// modules are defined as an array
// [ module function, map of requires ]
//
// map of requires is short require name -> numeric require
//
// anything defined in a previous bundle is accessed via the
// orig method which is the require for previous bundles

(function (modules, entry, mainEntry, parcelRequireName, globalName) {
  /* eslint-disable no-undef */
  var globalObject =
    typeof globalThis !== 'undefined'
      ? globalThis
      : typeof self !== 'undefined'
      ? self
      : typeof window !== 'undefined'
      ? window
      : typeof global !== 'undefined'
      ? global
      : {};
  /* eslint-enable no-undef */

  // Save the require from previous bundle to this closure if any
  var previousRequire =
    typeof globalObject[parcelRequireName] === 'function' &&
    globalObject[parcelRequireName];

  var cache = previousRequire.cache || {};
  // Do not use `require` to prevent Webpack from trying to bundle this call
  var nodeRequire =
    typeof module !== 'undefined' &&
    typeof module.require === 'function' &&
    module.require.bind(module);

  function newRequire(name, jumped) {
    if (!cache[name]) {
      if (!modules[name]) {
        // if we cannot find the module within our internal map or
        // cache jump to the current global require ie. the last bundle
        // that was added to the page.
        var currentRequire =
          typeof globalObject[parcelRequireName] === 'function' &&
          globalObject[parcelRequireName];
        if (!jumped && currentRequire) {
          return currentRequire(name, true);
        }

        // If there are other bundles on this page the require from the
        // previous one is saved to 'previousRequire'. Repeat this as
        // many times as there are bundles until the module is found or
        // we exhaust the require chain.
        if (previousRequire) {
          return previousRequire(name, true);
        }

        // Try the node require function if it exists.
        if (nodeRequire && typeof name === 'string') {
          return nodeRequire(name);
        }

        var err = new Error("Cannot find module '" + name + "'");
        err.code = 'MODULE_NOT_FOUND';
        throw err;
      }

      localRequire.resolve = resolve;
      localRequire.cache = {};

      var module = (cache[name] = new newRequire.Module(name));

      modules[name][0].call(
        module.exports,
        localRequire,
        module,
        module.exports,
        this
      );
    }

    return cache[name].exports;

    function localRequire(x) {
      var res = localRequire.resolve(x);
      return res === false ? {} : newRequire(res);
    }

    function resolve(x) {
      var id = modules[name][1][x];
      return id != null ? id : x;
    }
  }

  function Module(moduleName) {
    this.id = moduleName;
    this.bundle = newRequire;
    this.exports = {};
  }

  newRequire.isParcelRequire = true;
  newRequire.Module = Module;
  newRequire.modules = modules;
  newRequire.cache = cache;
  newRequire.parent = previousRequire;
  newRequire.register = function (id, exports) {
    modules[id] = [
      function (require, module) {
        module.exports = exports;
      },
      {},
    ];
  };

  Object.defineProperty(newRequire, 'root', {
    get: function () {
      return globalObject[parcelRequireName];
    },
  });

  globalObject[parcelRequireName] = newRequire;

  for (var i = 0; i < entry.length; i++) {
    newRequire(entry[i]);
  }

  if (mainEntry) {
    // Expose entry point to Node, AMD or browser globals
    // Based on https://github.com/ForbesLindesay/umd/blob/master/template.js
    var mainExports = newRequire(mainEntry);

    // CommonJS
    if (typeof exports === 'object' && typeof module !== 'undefined') {
      module.exports = mainExports;

      // RequireJS
    } else if (typeof define === 'function' && define.amd) {
      define(function () {
        return mainExports;
      });

      // <script>
    } else if (globalName) {
      this[globalName] = mainExports;
    }
  }
})({"5Tqlz":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactDom = require("react-dom");
var _reactDomDefault = parcelHelpers.interopDefault(_reactDom);
var _client = require("react-dom/client");
var _reactRouterDom = require("react-router-dom");
var _homepage = require("./components/HomepageComponent/Homepage");
var _homepageDefault = parcelHelpers.interopDefault(_homepage);
var _index = require("./components/Artpocalypse/Index");
var _indexDefault = parcelHelpers.interopDefault(_index);
const root = (0, _client.createRoot)(document.getElementById("app"));
root.render(/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.BrowserRouter), {
    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactRouterDom.Switch), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                exact: true,
                path: "/",
                component: (0, _homepageDefault.default)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                path: "/Artpocalypse",
                component: (0, _indexDefault.default)
            })
        ]
    })
}));

},{"react/jsx-runtime":"gaGEj","react":"6uln9","react-dom":"b8T3j","react-dom/client":"5ccwt","react-router-dom":"5fzqq","./components/HomepageComponent/Homepage":"eonG5","./components/Artpocalypse/Index":"7C0JV","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"gaGEj":[function(require,module,exports) {
"use strict";
module.exports = require("e5e9711c2edf1a4e");

},{"e5e9711c2edf1a4e":"kbpKW"}],"kbpKW":[function(require,module,exports) {
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var f = require("3fd2a064dc1f3641"), k = Symbol.for("react.element"), l = Symbol.for("react.fragment"), m = Object.prototype.hasOwnProperty, n = f.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for(b in a)m.call(a, b) && !p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: k,
        type: c,
        key: e,
        ref: h,
        props: d,
        _owner: n.current
    };
}
exports.Fragment = l;
exports.jsx = q;
exports.jsxs = q;

},{"3fd2a064dc1f3641":"6uln9"}],"6uln9":[function(require,module,exports) {
"use strict";
module.exports = require("956f36295e4e0134");

},{"956f36295e4e0134":"8n7Eb"}],"8n7Eb":[function(require,module,exports) {
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var l = Symbol.for("react.element"), n = Symbol.for("react.portal"), p = Symbol.for("react.fragment"), q = Symbol.for("react.strict_mode"), r = Symbol.for("react.profiler"), t = Symbol.for("react.provider"), u = Symbol.for("react.context"), v = Symbol.for("react.forward_ref"), w = Symbol.for("react.suspense"), x = Symbol.for("react.memo"), y = Symbol.for("react.lazy"), z = Symbol.iterator;
function A(a) {
    if (null === a || "object" !== typeof a) return null;
    a = z && a[z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var B = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, C = Object.assign, D = {};
function E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = D;
    this.updater = e || B;
}
E.prototype.isReactComponent = {};
E.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function F() {}
F.prototype = E.prototype;
function G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = D;
    this.updater = e || B;
}
var H = G.prototype = new F;
H.constructor = G;
C(H, E.prototype);
H.isPureReactComponent = !0;
var I = Array.isArray, J = Object.prototype.hasOwnProperty, K = {
    current: null
}, L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)J.call(b, d) && !L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: K.current
    };
}
function N(a, b) {
    return {
        $$typeof: l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === l;
}
function escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var P = /\/+/g;
function Q(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? escape("" + a.key) : b.toString(36);
}
function R(a, b, e, d, c) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case l:
                case n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + Q(h, 0) : d, I(c) ? (e = "", null != a && (e = a.replace(P, "$&/") + "/"), R(c, b, e, "", function(a) {
        return a;
    })) : null != c && (O(c) && (c = N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace(P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if (I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + Q(k, g);
        h += R(k, b, e, f, c);
    }
    else if (f = A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + Q(k, g++), h += R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result.default;
    throw a._result;
}
var U = {
    current: null
}, V = {
    transition: null
}, W = {
    ReactCurrentDispatcher: U,
    ReactCurrentBatchConfig: V,
    ReactCurrentOwner: K
};
function X() {
    throw Error("act(...) is not supported in production builds of React.");
}
exports.Children = {
    map: S,
    forEach: function(a, b, e) {
        S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function(a) {
        var b = 0;
        S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return S(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
exports.Component = E;
exports.Fragment = p;
exports.Profiler = r;
exports.PureComponent = G;
exports.StrictMode = q;
exports.Suspense = w;
exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = W;
exports.act = X;
exports.cloneElement = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)J.call(b, f) && !L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
exports.createContext = function(a) {
    a = {
        $$typeof: u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: t,
        _context: a
    };
    return a.Consumer = a;
};
exports.createElement = M;
exports.createFactory = function(a) {
    var b = M.bind(null, a);
    b.type = a;
    return b;
};
exports.createRef = function() {
    return {
        current: null
    };
};
exports.forwardRef = function(a) {
    return {
        $$typeof: v,
        render: a
    };
};
exports.isValidElement = O;
exports.lazy = function(a) {
    return {
        $$typeof: y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: T
    };
};
exports.memo = function(a, b) {
    return {
        $$typeof: x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
exports.startTransition = function(a) {
    var b = V.transition;
    V.transition = {};
    try {
        a();
    } finally{
        V.transition = b;
    }
};
exports.unstable_act = X;
exports.useCallback = function(a, b) {
    return U.current.useCallback(a, b);
};
exports.useContext = function(a) {
    return U.current.useContext(a);
};
exports.useDebugValue = function() {};
exports.useDeferredValue = function(a) {
    return U.current.useDeferredValue(a);
};
exports.useEffect = function(a, b) {
    return U.current.useEffect(a, b);
};
exports.useId = function() {
    return U.current.useId();
};
exports.useImperativeHandle = function(a, b, e) {
    return U.current.useImperativeHandle(a, b, e);
};
exports.useInsertionEffect = function(a, b) {
    return U.current.useInsertionEffect(a, b);
};
exports.useLayoutEffect = function(a, b) {
    return U.current.useLayoutEffect(a, b);
};
exports.useMemo = function(a, b) {
    return U.current.useMemo(a, b);
};
exports.useReducer = function(a, b, e) {
    return U.current.useReducer(a, b, e);
};
exports.useRef = function(a) {
    return U.current.useRef(a);
};
exports.useState = function(a) {
    return U.current.useState(a);
};
exports.useSyncExternalStore = function(a, b, e) {
    return U.current.useSyncExternalStore(a, b, e);
};
exports.useTransition = function() {
    return U.current.useTransition();
};
exports.version = "18.3.1";

},{}],"b8T3j":[function(require,module,exports) {
"use strict";
function checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === "undefined" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== "function") return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
checkDCE();
module.exports = require("9223fb8c5161e54b");

},{"9223fb8c5161e54b":"bO0Ia"}],"bO0Ia":[function(require,module,exports) {
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ "use strict";
var aa = require("5393afc8c463ef07"), ca = require("ece50e903283a22f");
function p(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var da = new Set, ea = {};
function fa(a, b) {
    ha(a, b);
    ha(a + "Capture", b);
}
function ha(a, b) {
    ea[a] = b;
    for(a = 0; a < b.length; a++)da.add(b[a]);
}
var ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), ja = Object.prototype.hasOwnProperty, ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, la = {}, ma = {};
function oa(a) {
    if (ja.call(ma, a)) return !0;
    if (ja.call(la, a)) return !1;
    if (ka.test(a)) return ma[a] = !0;
    la[a] = !0;
    return !1;
}
function pa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function qa(a, b, c, d) {
    if (null === b || "undefined" === typeof b || pa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function v(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    z[a] = new v(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    z[b] = new v(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    z[a] = new v(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    z[a] = new v(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    z[a] = new v(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    z[a] = new v(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    z[a] = new v(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    z[a] = new v(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    z[a] = new v(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var ra = /[\-:]([a-z])/g;
function sa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace(ra, sa);
    z[b] = new v(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace(ra, sa);
    z[b] = new v(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace(ra, sa);
    z[b] = new v(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    z[a] = new v(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
z.xlinkHref = new v("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    z[a] = new v(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function ta(a, b, c, d) {
    var e = z.hasOwnProperty(b) ? z[b] : null;
    if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) qa(b, c, e, d) && (c = null), d || null === e ? oa(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
}
var ua = aa.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, va = Symbol.for("react.element"), wa = Symbol.for("react.portal"), ya = Symbol.for("react.fragment"), za = Symbol.for("react.strict_mode"), Aa = Symbol.for("react.profiler"), Ba = Symbol.for("react.provider"), Ca = Symbol.for("react.context"), Da = Symbol.for("react.forward_ref"), Ea = Symbol.for("react.suspense"), Fa = Symbol.for("react.suspense_list"), Ga = Symbol.for("react.memo"), Ha = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var Ia = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.cache");
Symbol.for("react.tracing_marker");
var Ja = Symbol.iterator;
function Ka(a) {
    if (null === a || "object" !== typeof a) return null;
    a = Ja && a[Ja] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var A = Object.assign, La;
function Ma(a) {
    if (void 0 === La) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        La = b && b[1] || "";
    }
    return "\n" + La + a;
}
var Na = !1;
function Oa(a, b) {
    if (!a || Na) return "";
    Na = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (l) {
                    var d = l;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (l) {
                    d = l;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (l) {
                d = l;
            }
            a();
        }
    } catch (l) {
        if (l && d && "string" === typeof l.stack) {
            for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) {
                        var k = "\n" + e[g].replace(" at new ", " at ");
                        a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                        return k;
                    }
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        Na = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? Ma(a) : "";
}
function Pa(a) {
    switch(a.tag){
        case 5:
            return Ma(a.type);
        case 16:
            return Ma("Lazy");
        case 13:
            return Ma("Suspense");
        case 19:
            return Ma("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = Oa(a.type, !1), a;
        case 11:
            return a = Oa(a.type.render, !1), a;
        case 1:
            return a = Oa(a.type, !0), a;
        default:
            return "";
    }
}
function Qa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case ya:
            return "Fragment";
        case wa:
            return "Portal";
        case Aa:
            return "Profiler";
        case za:
            return "StrictMode";
        case Ea:
            return "Suspense";
        case Fa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case Ca:
            return (a.displayName || "Context") + ".Consumer";
        case Ba:
            return (a._context.displayName || "Context") + ".Provider";
        case Da:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case Ga:
            return b = a.displayName || null, null !== b ? b : Qa(a.type) || "Memo";
        case Ha:
            b = a._payload;
            a = a._init;
            try {
                return Qa(a(b));
            } catch (c) {}
    }
    return null;
}
function Ra(a) {
    var b = a.type;
    switch(a.tag){
        case 24:
            return "Cache";
        case 9:
            return (b.displayName || "Context") + ".Consumer";
        case 10:
            return (b._context.displayName || "Context") + ".Provider";
        case 18:
            return "DehydratedFragment";
        case 11:
            return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
        case 7:
            return "Fragment";
        case 5:
            return b;
        case 4:
            return "Portal";
        case 3:
            return "Root";
        case 6:
            return "Text";
        case 16:
            return Qa(b);
        case 8:
            return b === za ? "StrictMode" : "Mode";
        case 22:
            return "Offscreen";
        case 12:
            return "Profiler";
        case 21:
            return "Scope";
        case 13:
            return "Suspense";
        case 19:
            return "SuspenseList";
        case 25:
            return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
            if ("function" === typeof b) return b.displayName || b.name || null;
            if ("string" === typeof b) return b;
    }
    return null;
}
function Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return a;
        case "object":
            return a;
        default:
            return "";
    }
}
function Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function Ua(a) {
    var b = Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function Va(a) {
    a._valueTracker || (a._valueTracker = Ua(a));
}
function Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function Ya(a, b) {
    var c = b.checked;
    return A({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function ab(a, b) {
    b = b.checked;
    null != b && ta(a, "checked", b, !1);
}
function bb(a, b) {
    ab(a, b);
    var c = Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? cb(a, b.type, c) : b.hasOwnProperty("defaultValue") && cb(a, b.type, Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function db(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function cb(a, b, c) {
    if ("number" !== b || Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var eb = Array.isArray;
function fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error(p(91));
    return A({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error(p(92));
            if (eb(c)) {
                if (1 < c.length) throw Error(p(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: Sa(c)
    };
}
function ib(a, b) {
    var c = Sa(b.value), d = Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
function kb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function lb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? kb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var mb, nb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;
    else {
        mb = mb || document.createElement("div");
        mb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = mb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function ob(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var pb = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, qb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys(pb).forEach(function(a) {
    qb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        pb[b] = pb[a];
    });
});
function rb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || pb.hasOwnProperty(a) && pb[a] ? ("" + b).trim() : b + "px";
}
function sb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = rb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var tb = A({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function ub(a, b) {
    if (b) {
        if (tb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error(p(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error(p(60));
            if ("object" !== typeof b.dangerouslySetInnerHTML || !("__html" in b.dangerouslySetInnerHTML)) throw Error(p(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error(p(62));
    }
}
function vb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var wb = null;
function xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var yb = null, zb = null, Ab = null;
function Bb(a) {
    if (a = Cb(a)) {
        if ("function" !== typeof yb) throw Error(p(280));
        var b = a.stateNode;
        b && (b = Db(b), yb(a.stateNode, a.type, b));
    }
}
function Eb(a) {
    zb ? Ab ? Ab.push(a) : Ab = [
        a
    ] : zb = a;
}
function Fb() {
    if (zb) {
        var a = zb, b = Ab;
        Ab = zb = null;
        Bb(a);
        if (b) for(a = 0; a < b.length; a++)Bb(b[a]);
    }
}
function Gb(a, b) {
    return a(b);
}
function Hb() {}
var Ib = !1;
function Jb(a, b, c) {
    if (Ib) return a(b, c);
    Ib = !0;
    try {
        return Gb(a, b, c);
    } finally{
        if (Ib = !1, null !== zb || null !== Ab) Hb(), Fb();
    }
}
function Kb(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error(p(231, b, typeof c));
    return c;
}
var Lb = !1;
if (ia) try {
    var Mb = {};
    Object.defineProperty(Mb, "passive", {
        get: function() {
            Lb = !0;
        }
    });
    window.addEventListener("test", Mb, Mb);
    window.removeEventListener("test", Mb, Mb);
} catch (a) {
    Lb = !1;
}
function Nb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (m) {
        this.onError(m);
    }
}
var Ob = !1, Pb = null, Qb = !1, Rb = null, Sb = {
    onError: function(a) {
        Ob = !0;
        Pb = a;
    }
};
function Tb(a, b, c, d, e, f, g, h, k) {
    Ob = !1;
    Pb = null;
    Nb.apply(Sb, arguments);
}
function Ub(a, b, c, d, e, f, g, h, k) {
    Tb.apply(this, arguments);
    if (Ob) {
        if (Ob) {
            var l = Pb;
            Ob = !1;
            Pb = null;
        } else throw Error(p(198));
        Qb || (Qb = !0, Rb = l);
    }
}
function Vb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function Wb(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function Xb(a) {
    if (Vb(a) !== a) throw Error(p(188));
}
function Yb(a) {
    var b = a.alternate;
    if (!b) {
        b = Vb(a);
        if (null === b) throw Error(p(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return Xb(e), a;
                if (f === d) return Xb(e), b;
                f = f.sibling;
            }
            throw Error(p(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error(p(189));
            }
        }
        if (c.alternate !== d) throw Error(p(190));
    }
    if (3 !== c.tag) throw Error(p(188));
    return c.stateNode.current === c ? a : b;
}
function Zb(a) {
    a = Yb(a);
    return null !== a ? $b(a) : null;
}
function $b(a) {
    if (5 === a.tag || 6 === a.tag) return a;
    for(a = a.child; null !== a;){
        var b = $b(a);
        if (null !== b) return b;
        a = a.sibling;
    }
    return null;
}
var ac = ca.unstable_scheduleCallback, bc = ca.unstable_cancelCallback, cc = ca.unstable_shouldYield, dc = ca.unstable_requestPaint, B = ca.unstable_now, ec = ca.unstable_getCurrentPriorityLevel, fc = ca.unstable_ImmediatePriority, gc = ca.unstable_UserBlockingPriority, hc = ca.unstable_NormalPriority, ic = ca.unstable_LowPriority, jc = ca.unstable_IdlePriority, kc = null, lc = null;
function mc(a) {
    if (lc && "function" === typeof lc.onCommitFiberRoot) try {
        lc.onCommitFiberRoot(kc, a, void 0, 128 === (a.current.flags & 128));
    } catch (b) {}
}
var oc = Math.clz32 ? Math.clz32 : nc, pc = Math.log, qc = Math.LN2;
function nc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - (pc(a) / qc | 0) | 0;
}
var rc = 64, sc = 4194304;
function tc(a) {
    switch(a & -a){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return a & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return a & 130023424;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 1073741824;
        default:
            return a;
    }
}
function uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return 0;
    var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
    if (0 !== g) {
        var h = g & ~e;
        0 !== h ? d = tc(h) : (f &= g, 0 !== f && (d = tc(f)));
    } else g = c & ~e, 0 !== g ? d = tc(g) : 0 !== f && (d = tc(f));
    if (0 === d) return 0;
    if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
    0 !== (d & 4) && (d |= c & 16);
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - oc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function vc(a, b) {
    switch(a){
        case 1:
        case 2:
        case 4:
            return b + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return b + 5E3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function wc(a, b) {
    for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
        var g = 31 - oc(f), h = 1 << g, k = e[g];
        if (-1 === k) {
            if (0 === (h & c) || 0 !== (h & d)) e[g] = vc(h, b);
        } else k <= b && (a.expiredLanes |= h);
        f &= ~h;
    }
}
function xc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function yc() {
    var a = rc;
    rc <<= 1;
    0 === (rc & 4194240) && (rc = 64);
    return a;
}
function zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function Ac(a, b, c) {
    a.pendingLanes |= b;
    536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
    a = a.eventTimes;
    b = 31 - oc(b);
    a[b] = c;
}
function Bc(a, b) {
    var c = a.pendingLanes & ~b;
    a.pendingLanes = b;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= b;
    a.mutableReadLanes &= b;
    a.entangledLanes &= b;
    b = a.entanglements;
    var d = a.eventTimes;
    for(a = a.expirationTimes; 0 < c;){
        var e = 31 - oc(c), f = 1 << e;
        b[e] = 0;
        d[e] = -1;
        a[e] = -1;
        c &= ~f;
    }
}
function Cc(a, b) {
    var c = a.entangledLanes |= b;
    for(a = a.entanglements; c;){
        var d = 31 - oc(c), e = 1 << d;
        e & b | a[d] & b && (a[d] |= b);
        c &= ~e;
    }
}
var C = 0;
function Dc(a) {
    a &= -a;
    return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
}
var Ec, Fc, Gc, Hc, Ic, Jc = !1, Kc = [], Lc = null, Mc = null, Nc = null, Oc = new Map, Pc = new Map, Qc = [], Rc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function Sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            Lc = null;
            break;
        case "dragenter":
        case "dragleave":
            Mc = null;
            break;
        case "mouseover":
        case "mouseout":
            Nc = null;
            break;
        case "pointerover":
        case "pointerout":
            Oc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            Pc.delete(b.pointerId);
    }
}
function Tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = {
        blockedOn: b,
        domEventName: c,
        eventSystemFlags: d,
        nativeEvent: f,
        targetContainers: [
            e
        ]
    }, null !== b && (b = Cb(b), null !== b && Fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function Uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return Lc = Tc(Lc, a, b, c, d, e), !0;
        case "dragenter":
            return Mc = Tc(Mc, a, b, c, d, e), !0;
        case "mouseover":
            return Nc = Tc(Nc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            Oc.set(f, Tc(Oc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, Pc.set(f, Tc(Pc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function Vc(a) {
    var b = Wc(a.target);
    if (null !== b) {
        var c = Vb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = Wb(c), null !== b) {
                    a.blockedOn = b;
                    Ic(a.priority, function() {
                        Gc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function Xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = Yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null === c) {
            c = a.nativeEvent;
            var d = new c.constructor(c.type, c);
            wb = d;
            c.target.dispatchEvent(d);
            wb = null;
        } else return b = Cb(c), null !== b && Fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function Zc(a, b, c) {
    Xc(a) && c.delete(b);
}
function $c() {
    Jc = !1;
    null !== Lc && Xc(Lc) && (Lc = null);
    null !== Mc && Xc(Mc) && (Mc = null);
    null !== Nc && Xc(Nc) && (Nc = null);
    Oc.forEach(Zc);
    Pc.forEach(Zc);
}
function ad(a, b) {
    a.blockedOn === b && (a.blockedOn = null, Jc || (Jc = !0, ca.unstable_scheduleCallback(ca.unstable_NormalPriority, $c)));
}
function bd(a) {
    function b(b) {
        return ad(b, a);
    }
    if (0 < Kc.length) {
        ad(Kc[0], a);
        for(var c = 1; c < Kc.length; c++){
            var d = Kc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== Lc && ad(Lc, a);
    null !== Mc && ad(Mc, a);
    null !== Nc && ad(Nc, a);
    Oc.forEach(b);
    Pc.forEach(b);
    for(c = 0; c < Qc.length; c++)d = Qc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < Qc.length && (c = Qc[0], null === c.blockedOn);)Vc(c), null === c.blockedOn && Qc.shift();
}
var cd = ua.ReactCurrentBatchConfig, dd = !0;
function ed(a, b, c, d) {
    var e = C, f = cd.transition;
    cd.transition = null;
    try {
        C = 1, fd(a, b, c, d);
    } finally{
        C = e, cd.transition = f;
    }
}
function gd(a, b, c, d) {
    var e = C, f = cd.transition;
    cd.transition = null;
    try {
        C = 4, fd(a, b, c, d);
    } finally{
        C = e, cd.transition = f;
    }
}
function fd(a, b, c, d) {
    if (dd) {
        var e = Yc(a, b, c, d);
        if (null === e) hd(a, b, d, id, c), Sc(a, d);
        else if (Uc(e, a, b, c, d)) d.stopPropagation();
        else if (Sc(a, d), b & 4 && -1 < Rc.indexOf(a)) {
            for(; null !== e;){
                var f = Cb(e);
                null !== f && Ec(f);
                f = Yc(a, b, c, d);
                null === f && hd(a, b, d, id, c);
                if (f === e) break;
                e = f;
            }
            null !== e && d.stopPropagation();
        } else hd(a, b, d, null, c);
    }
}
var id = null;
function Yc(a, b, c, d) {
    id = null;
    a = xb(d);
    a = Wc(a);
    if (null !== a) {
        if (b = Vb(a), null === b) a = null;
        else if (c = b.tag, 13 === c) {
            a = Wb(b);
            if (null !== a) return a;
            a = null;
        } else if (3 === c) {
            if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
            a = null;
        } else b !== a && (a = null);
    }
    id = a;
    return null;
}
function jd(a) {
    switch(a){
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 1;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 4;
        case "message":
            switch(ec()){
                case fc:
                    return 1;
                case gc:
                    return 4;
                case hc:
                case ic:
                    return 16;
                case jc:
                    return 536870912;
                default:
                    return 16;
            }
        default:
            return 16;
    }
}
var kd = null, ld = null, md = null;
function nd() {
    if (md) return md;
    var a, b = ld, c = b.length, d, e = "value" in kd ? kd.value : kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function pd() {
    return !0;
}
function qd() {
    return !1;
}
function rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? pd : qd;
        this.isPropagationStopped = qd;
        return this;
    }
    A(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = pd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = pd);
        },
        persist: function() {},
        isPersistent: pd
    });
    return b;
}
var sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, td = rd(sd), ud = A({}, sd, {
    view: 0,
    detail: 0
}), vd = rd(ud), wd, xd, yd, Ad = A({}, ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: zd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== yd && (yd && "mousemove" === a.type ? (wd = a.screenX - yd.screenX, xd = a.screenY - yd.screenY) : xd = wd = 0, yd = a);
        return wd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : xd;
    }
}), Bd = rd(Ad), Cd = A({}, Ad, {
    dataTransfer: 0
}), Dd = rd(Cd), Ed = A({}, ud, {
    relatedTarget: 0
}), Fd = rd(Ed), Gd = A({}, sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), Hd = rd(Gd), Id = A({}, sd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), Jd = rd(Id), Kd = A({}, sd, {
    data: 0
}), Ld = rd(Kd), Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = Od[a]) ? !!b[a] : !1;
}
function zd() {
    return Pd;
}
var Qd = A({}, ud, {
    key: function(a) {
        if (a.key) {
            var b = Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: zd,
    charCode: function(a) {
        return "keypress" === a.type ? od(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), Rd = rd(Qd), Sd = A({}, Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), Td = rd(Sd), Ud = A({}, ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: zd
}), Vd = rd(Ud), Wd = A({}, sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), Xd = rd(Wd), Yd = A({}, Ad, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), Zd = rd(Yd), $d = [
    9,
    13,
    27,
    32
], ae = ia && "CompositionEvent" in window, be = null;
ia && "documentMode" in document && (be = document.documentMode);
var ce = ia && "TextEvent" in window && !be, de = ia && (!ae || be && 8 < be && 11 >= be), ee = String.fromCharCode(32), fe = !1;
function ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var ie = !1;
function je(a, b) {
    switch(a){
        case "compositionend":
            return he(b);
        case "keypress":
            if (32 !== b.which) return null;
            fe = !0;
            return ee;
        case "textInput":
            return a = b.data, a === ee && fe ? null : a;
        default:
            return null;
    }
}
function ke(a, b) {
    if (ie) return "compositionend" === a || !ae && ge(a, b) ? (a = nd(), md = ld = kd = null, ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!le[a.type] : "textarea" === b ? !0 : !1;
}
function ne(a, b, c, d) {
    Eb(d);
    b = oe(b, "onChange");
    0 < b.length && (c = new td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var pe = null, qe = null;
function re(a) {
    se(a, 0);
}
function te(a) {
    var b = ue(a);
    if (Wa(b)) return a;
}
function ve(a, b) {
    if ("change" === a) return b;
}
var we = !1;
if (ia) {
    var xe;
    if (ia) {
        var ye = "oninput" in document;
        if (!ye) {
            var ze = document.createElement("div");
            ze.setAttribute("oninput", "return;");
            ye = "function" === typeof ze.oninput;
        }
        xe = ye;
    } else xe = !1;
    we = xe && (!document.documentMode || 9 < document.documentMode);
}
function Ae() {
    pe && (pe.detachEvent("onpropertychange", Be), qe = pe = null);
}
function Be(a) {
    if ("value" === a.propertyName && te(qe)) {
        var b = [];
        ne(b, qe, a, xb(a));
        Jb(re, b);
    }
}
function Ce(a, b, c) {
    "focusin" === a ? (Ae(), pe = b, qe = c, pe.attachEvent("onpropertychange", Be)) : "focusout" === a && Ae();
}
function De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return te(qe);
}
function Ee(a, b) {
    if ("click" === a) return te(b);
}
function Fe(a, b) {
    if ("input" === a || "change" === a) return te(b);
}
function Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var He = "function" === typeof Object.is ? Object.is : Ge;
function Ie(a, b) {
    if (He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++){
        var e = c[d];
        if (!ja.call(b, e) || !He(a[e], b[e])) return !1;
    }
    return !0;
}
function Je(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function Ke(a, b) {
    var c = Je(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = Je(c);
    }
}
function Le(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? Le(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function Me() {
    for(var a = window, b = Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = Xa(a.document);
    }
    return b;
}
function Ne(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
function Oe(a) {
    var b = Me(), c = a.focusedElem, d = a.selectionRange;
    if (b !== c && c && c.ownerDocument && Le(c.ownerDocument.documentElement, c)) {
        if (null !== d && Ne(c)) {
            if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
            else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
                a = a.getSelection();
                var e = c.textContent.length, f = Math.min(d.start, e);
                d = void 0 === d.end ? f : Math.min(d.end, e);
                !a.extend && f > d && (e = d, d = f, f = e);
                e = Ke(c, f);
                var g = Ke(c, d);
                e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
            }
        }
        b = [];
        for(a = c; a = a.parentNode;)1 === a.nodeType && b.push({
            element: a,
            left: a.scrollLeft,
            top: a.scrollTop
        });
        "function" === typeof c.focus && c.focus();
        for(c = 0; c < b.length; c++)a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
}
var Pe = ia && "documentMode" in document && 11 >= document.documentMode, Qe = null, Re = null, Se = null, Te = !1;
function Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    Te || null == Qe || Qe !== Xa(d) || (d = Qe, "selectionStart" in d && Ne(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), Se && Ie(Se, d) || (Se = d, d = oe(Re, "onSelect"), 0 < d.length && (b = new td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = Qe)));
}
function Ve(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var We = {
    animationend: Ve("Animation", "AnimationEnd"),
    animationiteration: Ve("Animation", "AnimationIteration"),
    animationstart: Ve("Animation", "AnimationStart"),
    transitionend: Ve("Transition", "TransitionEnd")
}, Xe = {}, Ye = {};
ia && (Ye = document.createElement("div").style, "AnimationEvent" in window || (delete We.animationend.animation, delete We.animationiteration.animation, delete We.animationstart.animation), "TransitionEvent" in window || delete We.transitionend.transition);
function Ze(a) {
    if (Xe[a]) return Xe[a];
    if (!We[a]) return a;
    var b = We[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in Ye) return Xe[a] = b[c];
    return a;
}
var $e = Ze("animationend"), af = Ze("animationiteration"), bf = Ze("animationstart"), cf = Ze("transitionend"), df = new Map, ef = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function ff(a, b) {
    df.set(a, b);
    fa(b, [
        a
    ]);
}
for(var gf = 0; gf < ef.length; gf++){
    var hf = ef[gf], jf = hf.toLowerCase(), kf = hf[0].toUpperCase() + hf.slice(1);
    ff(jf, "on" + kf);
}
ff($e, "onAnimationEnd");
ff(af, "onAnimationIteration");
ff(bf, "onAnimationStart");
ff("dblclick", "onDoubleClick");
ff("focusin", "onFocus");
ff("focusout", "onBlur");
ff(cf, "onTransitionEnd");
ha("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
ha("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
ha("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
ha("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
fa("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var lf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), mf = new Set("cancel close invalid load scroll toggle".split(" ").concat(lf));
function nf(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    Ub(d, b, void 0, a);
    a.currentTarget = null;
}
function se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                nf(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                nf(e, h, l);
                f = k;
            }
        }
    }
    if (Qb) throw a = Rb, Qb = !1, Rb = null, a;
}
function D(a, b) {
    var c = b[of];
    void 0 === c && (c = b[of] = new Set);
    var d = a + "__bubble";
    c.has(d) || (pf(b, a, 2, !1), c.add(d));
}
function qf(a, b, c) {
    var d = 0;
    b && (d |= 4);
    pf(c, a, d, b);
}
var rf = "_reactListening" + Math.random().toString(36).slice(2);
function sf(a) {
    if (!a[rf]) {
        a[rf] = !0;
        da.forEach(function(b) {
            "selectionchange" !== b && (mf.has(b) || qf(b, !1, a), qf(b, !0, a));
        });
        var b = 9 === a.nodeType ? a : a.ownerDocument;
        null === b || b[rf] || (b[rf] = !0, qf("selectionchange", !1, b));
    }
}
function pf(a, b, c, d) {
    switch(jd(b)){
        case 1:
            var e = ed;
            break;
        case 4:
            e = gd;
            break;
        default:
            e = fd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !Lb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function hd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = Wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    Jb(function() {
        var d = f, e = xb(c), g = [];
        a: {
            var h = df.get(a);
            if (void 0 !== h) {
                var k = td, n = a;
                switch(a){
                    case "keypress":
                        if (0 === od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = Rd;
                        break;
                    case "focusin":
                        n = "focus";
                        k = Fd;
                        break;
                    case "focusout":
                        n = "blur";
                        k = Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = Vd;
                        break;
                    case $e:
                    case af:
                    case bf:
                        k = Hd;
                        break;
                    case cf:
                        k = Xd;
                        break;
                    case "scroll":
                        k = vd;
                        break;
                    case "wheel":
                        k = Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = Td;
                }
                var t = 0 !== (b & 4), J = !t && "scroll" === a, x = t ? null !== h ? h + "Capture" : null : h;
                t = [];
                for(var w = d, u; null !== w;){
                    u = w;
                    var F = u.stateNode;
                    5 === u.tag && null !== F && (u = F, null !== x && (F = Kb(w, x), null != F && t.push(tf(w, F, u))));
                    if (J) break;
                    w = w.return;
                }
                0 < t.length && (h = new k(h, n, null, c, e), g.push({
                    event: h,
                    listeners: t
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && c !== wb && (n = c.relatedTarget || c.fromElement) && (Wc(n) || n[uf])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (n = c.relatedTarget || c.toElement, k = d, n = n ? Wc(n) : null, null !== n && (J = Vb(n), n !== J || 5 !== n.tag && 6 !== n.tag)) n = null;
                    } else k = null, n = d;
                    if (k !== n) {
                        t = Bd;
                        F = "onMouseLeave";
                        x = "onMouseEnter";
                        w = "mouse";
                        if ("pointerout" === a || "pointerover" === a) t = Td, F = "onPointerLeave", x = "onPointerEnter", w = "pointer";
                        J = null == k ? h : ue(k);
                        u = null == n ? h : ue(n);
                        h = new t(F, w + "leave", k, c, e);
                        h.target = J;
                        h.relatedTarget = u;
                        F = null;
                        Wc(e) === d && (t = new t(x, w + "enter", n, c, e), t.target = u, t.relatedTarget = J, F = t);
                        J = F;
                        if (k && n) b: {
                            t = k;
                            x = n;
                            w = 0;
                            for(u = t; u; u = vf(u))w++;
                            u = 0;
                            for(F = x; F; F = vf(F))u++;
                            for(; 0 < w - u;)t = vf(t), w--;
                            for(; 0 < u - w;)x = vf(x), u--;
                            for(; w--;){
                                if (t === x || null !== x && t === x.alternate) break b;
                                t = vf(t);
                                x = vf(x);
                            }
                            t = null;
                        }
                        else t = null;
                        null !== k && wf(g, h, k, t, !1);
                        null !== n && null !== J && wf(g, J, n, t, !0);
                    }
                }
            }
            a: {
                h = d ? ue(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var na = ve;
                else if (me(h)) {
                    if (we) na = Fe;
                    else {
                        na = De;
                        var xa = Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (na = Ee);
                if (na && (na = na(a, d))) {
                    ne(g, na, c, e);
                    break a;
                }
                xa && xa(a, h, d);
                "focusout" === a && (xa = h._wrapperState) && xa.controlled && "number" === h.type && cb(h, "number", h.value);
            }
            xa = d ? ue(d) : window;
            switch(a){
                case "focusin":
                    if (me(xa) || "true" === xa.contentEditable) Qe = xa, Re = d, Se = null;
                    break;
                case "focusout":
                    Se = Re = Qe = null;
                    break;
                case "mousedown":
                    Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    Te = !1;
                    Ue(g, c, e);
                    break;
                case "selectionchange":
                    if (Pe) break;
                case "keydown":
                case "keyup":
                    Ue(g, c, e);
            }
            var $a;
            if (ae) b: {
                switch(a){
                    case "compositionstart":
                        var ba = "onCompositionStart";
                        break b;
                    case "compositionend":
                        ba = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        ba = "onCompositionUpdate";
                        break b;
                }
                ba = void 0;
            }
            else ie ? ge(a, c) && (ba = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (ba = "onCompositionStart");
            ba && (de && "ko" !== c.locale && (ie || "onCompositionStart" !== ba ? "onCompositionEnd" === ba && ie && ($a = nd()) : (kd = e, ld = "value" in kd ? kd.value : kd.textContent, ie = !0)), xa = oe(d, ba), 0 < xa.length && (ba = new Ld(ba, a, null, c, e), g.push({
                event: ba,
                listeners: xa
            }), $a ? ba.data = $a : ($a = he(c), null !== $a && (ba.data = $a))));
            if ($a = ce ? je(a, c) : ke(a, c)) d = oe(d, "onBeforeInput"), 0 < d.length && (e = new Ld("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = $a);
        }
        se(g, b);
    });
}
function tf(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = Kb(a, c), null != f && d.unshift(tf(a, f, e)), f = Kb(a, b), null != f && d.push(tf(a, f, e)));
        a = a.return;
    }
    return d;
}
function vf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function wf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = Kb(c, f), null != k && g.unshift(tf(c, k, h))) : e || (k = Kb(c, f), null != k && g.push(tf(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
var xf = /\r\n?/g, yf = /\u0000|\uFFFD/g;
function zf(a) {
    return ("string" === typeof a ? a : "" + a).replace(xf, "\n").replace(yf, "");
}
function Af(a, b, c) {
    b = zf(b);
    if (zf(a) !== b && c) throw Error(p(425));
}
function Bf() {}
var Cf = null, Df = null;
function Ef(a, b) {
    return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var Ff = "function" === typeof setTimeout ? setTimeout : void 0, Gf = "function" === typeof clearTimeout ? clearTimeout : void 0, Hf = "function" === typeof Promise ? Promise : void 0, Jf = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof Hf ? function(a) {
    return Hf.resolve(null).then(a).catch(If);
} : Ff;
function If(a) {
    setTimeout(function() {
        throw a;
    });
}
function Kf(a, b) {
    var c = b, d = 0;
    do {
        var e = c.nextSibling;
        a.removeChild(c);
        if (e && 8 === e.nodeType) {
            if (c = e.data, "/$" === c) {
                if (0 === d) {
                    a.removeChild(e);
                    bd(b);
                    return;
                }
                d--;
            } else "$" !== c && "$?" !== c && "$!" !== c || d++;
        }
        c = e;
    }while (c);
    bd(b);
}
function Lf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
        if (8 === b) {
            b = a.data;
            if ("$" === b || "$!" === b || "$?" === b) break;
            if ("/$" === b) return null;
        }
    }
    return a;
}
function Mf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var Nf = Math.random().toString(36).slice(2), Of = "__reactFiber$" + Nf, Pf = "__reactProps$" + Nf, uf = "__reactContainer$" + Nf, of = "__reactEvents$" + Nf, Qf = "__reactListeners$" + Nf, Rf = "__reactHandles$" + Nf;
function Wc(a) {
    var b = a[Of];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[uf] || c[Of]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = Mf(a); null !== a;){
                if (c = a[Of]) return c;
                a = Mf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function Cb(a) {
    a = a[Of] || a[uf];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error(p(33));
}
function Db(a) {
    return a[Pf] || null;
}
var Sf = [], Tf = -1;
function Uf(a) {
    return {
        current: a
    };
}
function E(a) {
    0 > Tf || (a.current = Sf[Tf], Sf[Tf] = null, Tf--);
}
function G(a, b) {
    Tf++;
    Sf[Tf] = a.current;
    a.current = b;
}
var Vf = {}, H = Uf(Vf), Wf = Uf(!1), Xf = Vf;
function Yf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return Vf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function Zf(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $f() {
    E(Wf);
    E(H);
}
function ag(a, b, c) {
    if (H.current !== Vf) throw Error(p(168));
    G(H, b);
    G(Wf, c);
}
function bg(a, b, c) {
    var d = a.stateNode;
    b = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in b)) throw Error(p(108, Ra(a) || "Unknown", e));
    return A({}, c, d);
}
function cg(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || Vf;
    Xf = H.current;
    G(H, a);
    G(Wf, Wf.current);
    return !0;
}
function dg(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error(p(169));
    c ? (a = bg(a, b, Xf), d.__reactInternalMemoizedMergedChildContext = a, E(Wf), E(H), G(H, a)) : E(Wf);
    G(Wf, c);
}
var eg = null, fg = !1, gg = !1;
function hg(a) {
    null === eg ? eg = [
        a
    ] : eg.push(a);
}
function ig(a) {
    fg = !0;
    hg(a);
}
function jg() {
    if (!gg && null !== eg) {
        gg = !0;
        var a = 0, b = C;
        try {
            var c = eg;
            for(C = 1; a < c.length; a++){
                var d = c[a];
                do d = d(!0);
                while (null !== d);
            }
            eg = null;
            fg = !1;
        } catch (e) {
            throw null !== eg && (eg = eg.slice(a + 1)), ac(fc, jg), e;
        } finally{
            C = b, gg = !1;
        }
    }
    return null;
}
var kg = [], lg = 0, mg = null, ng = 0, og = [], pg = 0, qg = null, rg = 1, sg = "";
function tg(a, b) {
    kg[lg++] = ng;
    kg[lg++] = mg;
    mg = a;
    ng = b;
}
function ug(a, b, c) {
    og[pg++] = rg;
    og[pg++] = sg;
    og[pg++] = qg;
    qg = a;
    var d = rg;
    a = sg;
    var e = 32 - oc(d) - 1;
    d &= ~(1 << e);
    c += 1;
    var f = 32 - oc(b) + e;
    if (30 < f) {
        var g = e - e % 5;
        f = (d & (1 << g) - 1).toString(32);
        d >>= g;
        e -= g;
        rg = 1 << 32 - oc(b) + e | c << e | d;
        sg = f + a;
    } else rg = 1 << f | c << e | d, sg = a;
}
function vg(a) {
    null !== a.return && (tg(a, 1), ug(a, 1, 0));
}
function wg(a) {
    for(; a === mg;)mg = kg[--lg], kg[lg] = null, ng = kg[--lg], kg[lg] = null;
    for(; a === qg;)qg = og[--pg], og[pg] = null, sg = og[--pg], og[pg] = null, rg = og[--pg], og[pg] = null;
}
var xg = null, yg = null, I = !1, zg = null;
function Ag(a, b) {
    var c = Bg(5, null, null, 0);
    c.elementType = "DELETED";
    c.stateNode = b;
    c.return = a;
    b = a.deletions;
    null === b ? (a.deletions = [
        c
    ], a.flags |= 16) : b.push(c);
}
function Cg(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, xg = a, yg = Lf(b.firstChild), !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, xg = a, yg = null, !0) : !1;
        case 13:
            return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== qg ? {
                id: rg,
                overflow: sg
            } : null, a.memoizedState = {
                dehydrated: b,
                treeContext: c,
                retryLane: 1073741824
            }, c = Bg(18, null, null, 0), c.stateNode = b, c.return = a, a.child = c, xg = a, yg = null, !0) : !1;
        default:
            return !1;
    }
}
function Dg(a) {
    return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
}
function Eg(a) {
    if (I) {
        var b = yg;
        if (b) {
            var c = b;
            if (!Cg(a, b)) {
                if (Dg(a)) throw Error(p(418));
                b = Lf(c.nextSibling);
                var d = xg;
                b && Cg(a, b) ? Ag(d, c) : (a.flags = a.flags & -4097 | 2, I = !1, xg = a);
            }
        } else {
            if (Dg(a)) throw Error(p(418));
            a.flags = a.flags & -4097 | 2;
            I = !1;
            xg = a;
        }
    }
}
function Fg(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    xg = a;
}
function Gg(a) {
    if (a !== xg) return !1;
    if (!I) return Fg(a), I = !0, !1;
    var b;
    (b = 3 !== a.tag) && !(b = 5 !== a.tag) && (b = a.type, b = "head" !== b && "body" !== b && !Ef(a.type, a.memoizedProps));
    if (b && (b = yg)) {
        if (Dg(a)) throw Hg(), Error(p(418));
        for(; b;)Ag(a, b), b = Lf(b.nextSibling);
    }
    Fg(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error(p(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            yg = Lf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            yg = null;
        }
    } else yg = xg ? Lf(a.stateNode.nextSibling) : null;
    return !0;
}
function Hg() {
    for(var a = yg; a;)a = Lf(a.nextSibling);
}
function Ig() {
    yg = xg = null;
    I = !1;
}
function Jg(a) {
    null === zg ? zg = [
        a
    ] : zg.push(a);
}
var Kg = ua.ReactCurrentBatchConfig;
function Lg(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error(p(309));
                var d = c.stateNode;
            }
            if (!d) throw Error(p(147, a));
            var e = d, f = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
            b = function(a) {
                var b = e.refs;
                null === a ? delete b[f] : b[f] = a;
            };
            b._stringRef = f;
            return b;
        }
        if ("string" !== typeof a) throw Error(p(284));
        if (!c._owner) throw Error(p(290, a));
    }
    return a;
}
function Mg(a, b) {
    a = Object.prototype.toString.call(b);
    throw Error(p(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
}
function Ng(a) {
    var b = a._init;
    return b(a._payload);
}
function Og(a) {
    function b(b, c) {
        if (a) {
            var d = b.deletions;
            null === d ? (b.deletions = [
                c
            ], b.flags |= 16) : d.push(c);
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = Pg(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return b.flags |= 1048576, c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
        b.flags |= 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags |= 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = Qg(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        var f = c.type;
        if (f === ya) return m(a, b, c.props.children, d, c.key);
        if (null !== b && (b.elementType === f || "object" === typeof f && null !== f && f.$$typeof === Ha && Ng(f) === b.type)) return d = e(b, c.props), d.ref = Lg(a, b, c), d.return = a, d;
        d = Rg(c.type, c.key, c.props, null, a.mode, d);
        d.ref = Lg(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = Sg(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = Tg(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function q(a, b, c) {
        if ("string" === typeof b && "" !== b || "number" === typeof b) return b = Qg("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case va:
                    return c = Rg(b.type, b.key, b.props, null, a.mode, c), c.ref = Lg(a, null, b), c.return = a, c;
                case wa:
                    return b = Sg(b, a.mode, c), b.return = a, b;
                case Ha:
                    var d = b._init;
                    return q(a, d(b._payload), c);
            }
            if (eb(b) || Ka(b)) return b = Tg(b, a.mode, c, null), b.return = a, b;
            Mg(a, b);
        }
        return null;
    }
    function r(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case va:
                    return c.key === e ? k(a, b, c, d) : null;
                case wa:
                    return c.key === e ? l(a, b, c, d) : null;
                case Ha:
                    return e = c._init, r(a, b, e(c._payload), d);
            }
            if (eb(c) || Ka(c)) return null !== e ? null : m(a, b, c, d, null);
            Mg(a, c);
        }
        return null;
    }
    function y(a, b, c, d, e) {
        if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case va:
                    return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                case wa:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                case Ha:
                    var f = d._init;
                    return y(a, b, c, f(d._payload), e);
            }
            if (eb(d) || Ka(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            Mg(b, d);
        }
        return null;
    }
    function n(e, g, h, k) {
        for(var l = null, m = null, u = g, w = g = 0, x = null; null !== u && w < h.length; w++){
            u.index > w ? (x = u, u = null) : x = u.sibling;
            var n = r(e, u, h[w], k);
            if (null === n) {
                null === u && (u = x);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, w);
            null === m ? l = n : m.sibling = n;
            m = n;
            u = x;
        }
        if (w === h.length) return c(e, u), I && tg(e, w), l;
        if (null === u) {
            for(; w < h.length; w++)u = q(e, h[w], k), null !== u && (g = f(u, g, w), null === m ? l = u : m.sibling = u, m = u);
            I && tg(e, w);
            return l;
        }
        for(u = d(e, u); w < h.length; w++)x = y(u, e, w, h[w], k), null !== x && (a && null !== x.alternate && u.delete(null === x.key ? w : x.key), g = f(x, g, w), null === m ? l = x : m.sibling = x, m = x);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        I && tg(e, w);
        return l;
    }
    function t(e, g, h, k) {
        var l = Ka(h);
        if ("function" !== typeof l) throw Error(p(150));
        h = l.call(h);
        if (null == h) throw Error(p(151));
        for(var u = l = null, m = g, w = g = 0, x = null, n = h.next(); null !== m && !n.done; w++, n = h.next()){
            m.index > w ? (x = m, m = null) : x = m.sibling;
            var t = r(e, m, n.value, k);
            if (null === t) {
                null === m && (m = x);
                break;
            }
            a && m && null === t.alternate && b(e, m);
            g = f(t, g, w);
            null === u ? l = t : u.sibling = t;
            u = t;
            m = x;
        }
        if (n.done) return c(e, m), I && tg(e, w), l;
        if (null === m) {
            for(; !n.done; w++, n = h.next())n = q(e, n.value, k), null !== n && (g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
            I && tg(e, w);
            return l;
        }
        for(m = d(e, m); !n.done; w++, n = h.next())n = y(m, e, w, n.value, k), null !== n && (a && null !== n.alternate && m.delete(null === n.key ? w : n.key), g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        I && tg(e, w);
        return l;
    }
    function J(a, d, f, h) {
        "object" === typeof f && null !== f && f.type === ya && null === f.key && (f = f.props.children);
        if ("object" === typeof f && null !== f) {
            switch(f.$$typeof){
                case va:
                    a: {
                        for(var k = f.key, l = d; null !== l;){
                            if (l.key === k) {
                                k = f.type;
                                if (k === ya) {
                                    if (7 === l.tag) {
                                        c(a, l.sibling);
                                        d = e(l, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                } else if (l.elementType === k || "object" === typeof k && null !== k && k.$$typeof === Ha && Ng(k) === l.type) {
                                    c(a, l.sibling);
                                    d = e(l, f.props);
                                    d.ref = Lg(a, l, f);
                                    d.return = a;
                                    a = d;
                                    break a;
                                }
                                c(a, l);
                                break;
                            } else b(a, l);
                            l = l.sibling;
                        }
                        f.type === ya ? (d = Tg(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = Rg(f.type, f.key, f.props, null, a.mode, h), h.ref = Lg(a, d, f), h.return = a, a = h);
                    }
                    return g(a);
                case wa:
                    a: {
                        for(l = f.key; null !== d;){
                            if (d.key === l) {
                                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                    c(a, d.sibling);
                                    d = e(d, f.children || []);
                                    d.return = a;
                                    a = d;
                                    break a;
                                } else {
                                    c(a, d);
                                    break;
                                }
                            } else b(a, d);
                            d = d.sibling;
                        }
                        d = Sg(f, a.mode, h);
                        d.return = a;
                        a = d;
                    }
                    return g(a);
                case Ha:
                    return l = f._init, J(a, d, l(f._payload), h);
            }
            if (eb(f)) return n(a, d, f, h);
            if (Ka(f)) return t(a, d, f, h);
            Mg(a, f);
        }
        return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = Qg(f, a.mode, h), d.return = a, a = d), g(a)) : c(a, d);
    }
    return J;
}
var Ug = Og(!0), Vg = Og(!1), Wg = Uf(null), Xg = null, Yg = null, Zg = null;
function $g() {
    Zg = Yg = Xg = null;
}
function ah(a) {
    var b = Wg.current;
    E(Wg);
    a._currentValue = b;
}
function bh(a, b, c) {
    for(; null !== a;){
        var d = a.alternate;
        (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
        if (a === c) break;
        a = a.return;
    }
}
function ch(a, b) {
    Xg = a;
    Zg = Yg = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && (dh = !0), a.firstContext = null);
}
function eh(a) {
    var b = a._currentValue;
    if (Zg !== a) {
        if (a = {
            context: a,
            memoizedValue: b,
            next: null
        }, null === Yg) {
            if (null === Xg) throw Error(p(308));
            Yg = a;
            Xg.dependencies = {
                lanes: 0,
                firstContext: a
            };
        } else Yg = Yg.next = a;
    }
    return b;
}
var fh = null;
function gh(a) {
    null === fh ? fh = [
        a
    ] : fh.push(a);
}
function hh(a, b, c, d) {
    var e = b.interleaved;
    null === e ? (c.next = c, gh(b)) : (c.next = e.next, e.next = c);
    b.interleaved = c;
    return ih(a, d);
}
function ih(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
var jh = !1;
function kh(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            interleaved: null,
            lanes: 0
        },
        effects: null
    };
}
function lh(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function mh(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function nh(a, b, c) {
    var d = a.updateQueue;
    if (null === d) return null;
    d = d.shared;
    if (0 !== (K & 2)) {
        var e = d.pending;
        null === e ? b.next = b : (b.next = e.next, e.next = b);
        d.pending = b;
        return ih(a, c);
    }
    e = d.interleaved;
    null === e ? (b.next = b, gh(d)) : (b.next = e.next, e.next = b);
    d.interleaved = b;
    return ih(a, c);
}
function oh(a, b, c) {
    b = b.updateQueue;
    if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        Cc(a, c);
    }
}
function ph(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function qh(a, b, c, d) {
    var e = a.updateQueue;
    jh = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var m = a.alternate;
        null !== m && (m = m.updateQueue, h = m.lastBaseUpdate, h !== g && (null === h ? m.firstBaseUpdate = l : h.next = l, m.lastBaseUpdate = k));
    }
    if (null !== f) {
        var q = e.baseState;
        g = 0;
        m = l = k = null;
        h = f;
        do {
            var r = h.lane, y = h.eventTime;
            if ((d & r) === r) {
                null !== m && (m = m.next = {
                    eventTime: y,
                    lane: 0,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                });
                a: {
                    var n = a, t = h;
                    r = b;
                    y = c;
                    switch(t.tag){
                        case 1:
                            n = t.payload;
                            if ("function" === typeof n) {
                                q = n.call(y, q, r);
                                break a;
                            }
                            q = n;
                            break a;
                        case 3:
                            n.flags = n.flags & -65537 | 128;
                        case 0:
                            n = t.payload;
                            r = "function" === typeof n ? n.call(y, q, r) : n;
                            if (null === r || void 0 === r) break a;
                            q = A({}, q, r);
                            break a;
                        case 2:
                            jh = !0;
                    }
                }
                null !== h.callback && 0 !== h.lane && (a.flags |= 64, r = e.effects, null === r ? e.effects = [
                    h
                ] : r.push(h));
            } else y = {
                eventTime: y,
                lane: r,
                tag: h.tag,
                payload: h.payload,
                callback: h.callback,
                next: null
            }, null === m ? (l = m = y, k = q) : m = m.next = y, g |= r;
            h = h.next;
            if (null === h) {
                if (h = e.shared.pending, null === h) break;
                else r = h, h = r.next, r.next = null, e.lastBaseUpdate = r, e.shared.pending = null;
            }
        }while (1);
        null === m && (k = q);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = m;
        b = e.shared.interleaved;
        if (null !== b) {
            e = b;
            do g |= e.lane, e = e.next;
            while (e !== b);
        } else null === f && (e.shared.lanes = 0);
        rh |= g;
        a.lanes = g;
        a.memoizedState = q;
    }
}
function sh(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error(p(191, e));
            e.call(d);
        }
    }
}
var th = {}, uh = Uf(th), vh = Uf(th), wh = Uf(th);
function xh(a) {
    if (a === th) throw Error(p(174));
    return a;
}
function yh(a, b) {
    G(wh, b);
    G(vh, a);
    G(uh, th);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : lb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = lb(b, a);
    }
    E(uh);
    G(uh, b);
}
function zh() {
    E(uh);
    E(vh);
    E(wh);
}
function Ah(a) {
    xh(wh.current);
    var b = xh(uh.current);
    var c = lb(b, a.type);
    b !== c && (G(vh, a), G(uh, c));
}
function Bh(a) {
    vh.current === a && (E(uh), E(vh));
}
var L = Uf(0);
function Ch(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 128)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var Dh = [];
function Eh() {
    for(var a = 0; a < Dh.length; a++)Dh[a]._workInProgressVersionPrimary = null;
    Dh.length = 0;
}
var Fh = ua.ReactCurrentDispatcher, Gh = ua.ReactCurrentBatchConfig, Hh = 0, M = null, N = null, O = null, Ih = !1, Jh = !1, Kh = 0, Lh = 0;
function P() {
    throw Error(p(321));
}
function Mh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!He(a[c], b[c])) return !1;
    return !0;
}
function Nh(a, b, c, d, e, f) {
    Hh = f;
    M = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    Fh.current = null === a || null === a.memoizedState ? Oh : Ph;
    a = c(d, e);
    if (Jh) {
        f = 0;
        do {
            Jh = !1;
            Kh = 0;
            if (25 <= f) throw Error(p(301));
            f += 1;
            O = N = null;
            b.updateQueue = null;
            Fh.current = Qh;
            a = c(d, e);
        }while (Jh);
    }
    Fh.current = Rh;
    b = null !== N && null !== N.next;
    Hh = 0;
    O = N = M = null;
    Ih = !1;
    if (b) throw Error(p(300));
    return a;
}
function Sh() {
    var a = 0 !== Kh;
    Kh = 0;
    return a;
}
function Th() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === O ? M.memoizedState = O = a : O = O.next = a;
    return O;
}
function Uh() {
    if (null === N) {
        var a = M.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = N.next;
    var b = null === O ? M.memoizedState : O.next;
    if (null !== b) O = b, N = a;
    else {
        if (null === a) throw Error(p(310));
        N = a;
        a = {
            memoizedState: N.memoizedState,
            baseState: N.baseState,
            baseQueue: N.baseQueue,
            queue: N.queue,
            next: null
        };
        null === O ? M.memoizedState = O = a : O = O.next = a;
    }
    return O;
}
function Vh(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function Wh(a) {
    var b = Uh(), c = b.queue;
    if (null === c) throw Error(p(311));
    c.lastRenderedReducer = a;
    var d = N, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        f = e.next;
        d = d.baseState;
        var h = g = null, k = null, l = f;
        do {
            var m = l.lane;
            if ((Hh & m) === m) null !== k && (k = k.next = {
                lane: 0,
                action: l.action,
                hasEagerState: l.hasEagerState,
                eagerState: l.eagerState,
                next: null
            }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
            else {
                var q = {
                    lane: m,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                };
                null === k ? (h = k = q, g = d) : k = k.next = q;
                M.lanes |= m;
                rh |= m;
            }
            l = l.next;
        }while (null !== l && l !== f);
        null === k ? g = d : k.next = h;
        He(d, b.memoizedState) || (dh = !0);
        b.memoizedState = d;
        b.baseState = g;
        b.baseQueue = k;
        c.lastRenderedState = d;
    }
    a = c.interleaved;
    if (null !== a) {
        e = a;
        do f = e.lane, M.lanes |= f, rh |= f, e = e.next;
        while (e !== a);
    } else null === e && (c.lanes = 0);
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function Xh(a) {
    var b = Uh(), c = b.queue;
    if (null === c) throw Error(p(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        He(f, b.memoizedState) || (dh = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function Yh() {}
function Zh(a, b) {
    var c = M, d = Uh(), e = b(), f = !He(d.memoizedState, e);
    f && (d.memoizedState = e, dh = !0);
    d = d.queue;
    $h(ai.bind(null, c, d, a), [
        a
    ]);
    if (d.getSnapshot !== b || f || null !== O && O.memoizedState.tag & 1) {
        c.flags |= 2048;
        bi(9, ci.bind(null, c, d, e, b), void 0, null);
        if (null === Q) throw Error(p(349));
        0 !== (Hh & 30) || di(c, b, e);
    }
    return e;
}
function di(a, b, c) {
    a.flags |= 16384;
    a = {
        getSnapshot: b,
        value: c
    };
    b = M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, M.updateQueue = b, b.stores = [
        a
    ]) : (c = b.stores, null === c ? b.stores = [
        a
    ] : c.push(a));
}
function ci(a, b, c, d) {
    b.value = c;
    b.getSnapshot = d;
    ei(b) && fi(a);
}
function ai(a, b, c) {
    return c(function() {
        ei(b) && fi(a);
    });
}
function ei(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var c = b();
        return !He(a, c);
    } catch (d) {
        return !0;
    }
}
function fi(a) {
    var b = ih(a, 1);
    null !== b && gi(b, a, 1, -1);
}
function hi(a) {
    var b = Th();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = {
        pending: null,
        interleaved: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: Vh,
        lastRenderedState: a
    };
    b.queue = a;
    a = a.dispatch = ii.bind(null, M, a);
    return [
        b.memoizedState,
        a
    ];
}
function bi(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, M.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function ji() {
    return Uh().memoizedState;
}
function ki(a, b, c, d) {
    var e = Th();
    M.flags |= a;
    e.memoizedState = bi(1 | b, c, void 0, void 0 === d ? null : d);
}
function li(a, b, c, d) {
    var e = Uh();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== N) {
        var g = N.memoizedState;
        f = g.destroy;
        if (null !== d && Mh(d, g.deps)) {
            e.memoizedState = bi(b, c, f, d);
            return;
        }
    }
    M.flags |= a;
    e.memoizedState = bi(1 | b, c, f, d);
}
function mi(a, b) {
    return ki(8390656, 8, a, b);
}
function $h(a, b) {
    return li(2048, 8, a, b);
}
function ni(a, b) {
    return li(4, 2, a, b);
}
function oi(a, b) {
    return li(4, 4, a, b);
}
function pi(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function qi(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return li(4, 4, pi.bind(null, b, a), c);
}
function ri() {}
function si(a, b) {
    var c = Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && Mh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function ti(a, b) {
    var c = Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && Mh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function ui(a, b, c) {
    if (0 === (Hh & 21)) return a.baseState && (a.baseState = !1, dh = !0), a.memoizedState = c;
    He(c, b) || (c = yc(), M.lanes |= c, rh |= c, a.baseState = !0);
    return b;
}
function vi(a, b) {
    var c = C;
    C = 0 !== c && 4 > c ? c : 4;
    a(!0);
    var d = Gh.transition;
    Gh.transition = {};
    try {
        a(!1), b();
    } finally{
        C = c, Gh.transition = d;
    }
}
function wi() {
    return Uh().memoizedState;
}
function xi(a, b, c) {
    var d = yi(a);
    c = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if (zi(a)) Ai(b, c);
    else if (c = hh(a, b, c, d), null !== c) {
        var e = R();
        gi(c, a, d, e);
        Bi(c, b, d);
    }
}
function ii(a, b, c) {
    var d = yi(a), e = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if (zi(a)) Ai(b, e);
    else {
        var f = a.alternate;
        if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.hasEagerState = !0;
            e.eagerState = h;
            if (He(h, g)) {
                var k = b.interleaved;
                null === k ? (e.next = e, gh(b)) : (e.next = k.next, k.next = e);
                b.interleaved = e;
                return;
            }
        } catch (l) {} finally{}
        c = hh(a, b, e, d);
        null !== c && (e = R(), gi(c, a, d, e), Bi(c, b, d));
    }
}
function zi(a) {
    var b = a.alternate;
    return a === M || null !== b && b === M;
}
function Ai(a, b) {
    Jh = Ih = !0;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
}
function Bi(a, b, c) {
    if (0 !== (c & 4194240)) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        Cc(a, c);
    }
}
var Rh = {
    readContext: eh,
    useCallback: P,
    useContext: P,
    useEffect: P,
    useImperativeHandle: P,
    useInsertionEffect: P,
    useLayoutEffect: P,
    useMemo: P,
    useReducer: P,
    useRef: P,
    useState: P,
    useDebugValue: P,
    useDeferredValue: P,
    useTransition: P,
    useMutableSource: P,
    useSyncExternalStore: P,
    useId: P,
    unstable_isNewReconciler: !1
}, Oh = {
    readContext: eh,
    useCallback: function(a, b) {
        Th().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: eh,
    useEffect: mi,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return ki(4194308, 4, pi.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return ki(4194308, 4, a, b);
    },
    useInsertionEffect: function(a, b) {
        return ki(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = Th();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = Th();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        d.queue = a;
        a = a.dispatch = xi.bind(null, M, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function(a) {
        var b = Th();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: hi,
    useDebugValue: ri,
    useDeferredValue: function(a) {
        return Th().memoizedState = a;
    },
    useTransition: function() {
        var a = hi(!1), b = a[0];
        a = vi.bind(null, a[1]);
        Th().memoizedState = a;
        return [
            b,
            a
        ];
    },
    useMutableSource: function() {},
    useSyncExternalStore: function(a, b, c) {
        var d = M, e = Th();
        if (I) {
            if (void 0 === c) throw Error(p(407));
            c = c();
        } else {
            c = b();
            if (null === Q) throw Error(p(349));
            0 !== (Hh & 30) || di(d, b, c);
        }
        e.memoizedState = c;
        var f = {
            value: c,
            getSnapshot: b
        };
        e.queue = f;
        mi(ai.bind(null, d, f, a), [
            a
        ]);
        d.flags |= 2048;
        bi(9, ci.bind(null, d, f, c, b), void 0, null);
        return c;
    },
    useId: function() {
        var a = Th(), b = Q.identifierPrefix;
        if (I) {
            var c = sg;
            var d = rg;
            c = (d & ~(1 << 32 - oc(d) - 1)).toString(32) + c;
            b = ":" + b + "R" + c;
            c = Kh++;
            0 < c && (b += "H" + c.toString(32));
            b += ":";
        } else c = Lh++, b = ":" + b + "r" + c.toString(32) + ":";
        return a.memoizedState = b;
    },
    unstable_isNewReconciler: !1
}, Ph = {
    readContext: eh,
    useCallback: si,
    useContext: eh,
    useEffect: $h,
    useImperativeHandle: qi,
    useInsertionEffect: ni,
    useLayoutEffect: oi,
    useMemo: ti,
    useReducer: Wh,
    useRef: ji,
    useState: function() {
        return Wh(Vh);
    },
    useDebugValue: ri,
    useDeferredValue: function(a) {
        var b = Uh();
        return ui(b, N.memoizedState, a);
    },
    useTransition: function() {
        var a = Wh(Vh)[0], b = Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: Yh,
    useSyncExternalStore: Zh,
    useId: wi,
    unstable_isNewReconciler: !1
}, Qh = {
    readContext: eh,
    useCallback: si,
    useContext: eh,
    useEffect: $h,
    useImperativeHandle: qi,
    useInsertionEffect: ni,
    useLayoutEffect: oi,
    useMemo: ti,
    useReducer: Xh,
    useRef: ji,
    useState: function() {
        return Xh(Vh);
    },
    useDebugValue: ri,
    useDeferredValue: function(a) {
        var b = Uh();
        return null === N ? b.memoizedState = a : ui(b, N.memoizedState, a);
    },
    useTransition: function() {
        var a = Xh(Vh)[0], b = Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: Yh,
    useSyncExternalStore: Zh,
    useId: wi,
    unstable_isNewReconciler: !1
};
function Ci(a, b) {
    if (a && a.defaultProps) {
        b = A({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
function Di(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : A({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var Ei = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? Vb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = R(), e = yi(a), f = mh(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = nh(a, f, e);
        null !== b && (gi(b, a, e, d), oh(b, a, e));
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = R(), e = yi(a), f = mh(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = nh(a, f, e);
        null !== b && (gi(b, a, e, d), oh(b, a, e));
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = R(), d = yi(a), e = mh(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        b = nh(a, e, d);
        null !== b && (gi(b, a, d, c), oh(b, a, d));
    }
};
function Fi(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !Ie(c, d) || !Ie(e, f) : !0;
}
function Gi(a, b, c) {
    var d = !1, e = Vf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = eh(f) : (e = Zf(b) ? Xf : H.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? Yf(a, e) : Vf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = Ei;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function Hi(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && Ei.enqueueReplaceState(b, b.state, null);
}
function Ii(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = {};
    kh(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = eh(f) : (f = Zf(b) ? Xf : H.current, e.context = Yf(a, f));
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && (Di(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && Ei.enqueueReplaceState(e, e.state, null), qh(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4194308);
}
function Ji(a, b) {
    try {
        var c = "", d = b;
        do c += Pa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e,
        digest: null
    };
}
function Ki(a, b, c) {
    return {
        value: a,
        source: null,
        stack: null != c ? c : null,
        digest: null != b ? b : null
    };
}
function Li(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var Mi = "function" === typeof WeakMap ? WeakMap : Map;
function Ni(a, b, c) {
    c = mh(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        Oi || (Oi = !0, Pi = d);
        Li(a, b);
    };
    return c;
}
function Qi(a, b, c) {
    c = mh(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            return d(e);
        };
        c.callback = function() {
            Li(a, b);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        Li(a, b);
        "function" !== typeof d && (null === Ri ? Ri = new Set([
            this
        ]) : Ri.add(this));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
function Si(a, b, c) {
    var d = a.pingCache;
    if (null === d) {
        d = a.pingCache = new Mi;
        var e = new Set;
        d.set(b, e);
    } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
    e.has(c) || (e.add(c), a = Ti.bind(null, a, b, c), b.then(a, a));
}
function Ui(a) {
    do {
        var b;
        if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
        if (b) return a;
        a = a.return;
    }while (null !== a);
    return null;
}
function Vi(a, b, c, d, e) {
    if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = mh(-1, 1), b.tag = 2, nh(c, b, 1))), c.lanes |= 1), a;
    a.flags |= 65536;
    a.lanes = e;
    return a;
}
var Wi = ua.ReactCurrentOwner, dh = !1;
function Xi(a, b, c, d) {
    b.child = null === a ? Vg(b, null, c, d) : Ug(b, a.child, c, d);
}
function Yi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    ch(b, e);
    d = Nh(a, b, c, d, f, e);
    c = Sh();
    if (null !== a && !dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, Zi(a, b, e);
    I && c && vg(b);
    b.flags |= 1;
    Xi(a, b, d, e);
    return b.child;
}
function $i(a, b, c, d, e) {
    if (null === a) {
        var f = c.type;
        if ("function" === typeof f && !aj(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, bj(a, b, f, d, e);
        a = Rg(c.type, null, d, b, b.mode, e);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    f = a.child;
    if (0 === (a.lanes & e)) {
        var g = f.memoizedProps;
        c = c.compare;
        c = null !== c ? c : Ie;
        if (c(g, d) && a.ref === b.ref) return Zi(a, b, e);
    }
    b.flags |= 1;
    a = Pg(f, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function bj(a, b, c, d, e) {
    if (null !== a) {
        var f = a.memoizedProps;
        if (Ie(f, d) && a.ref === b.ref) {
            if (dh = !1, b.pendingProps = d = f, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && (dh = !0);
            else return b.lanes = a.lanes, Zi(a, b, e);
        }
    }
    return cj(a, b, c, d, e);
}
function dj(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode) {
        if (0 === (b.mode & 1)) b.memoizedState = {
            baseLanes: 0,
            cachePool: null,
            transitions: null
        }, G(ej, fj), fj |= c;
        else {
            if (0 === (c & 1073741824)) return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
                baseLanes: a,
                cachePool: null,
                transitions: null
            }, b.updateQueue = null, G(ej, fj), fj |= a, null;
            b.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null
            };
            d = null !== f ? f.baseLanes : c;
            G(ej, fj);
            fj |= d;
        }
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, G(ej, fj), fj |= d;
    Xi(a, b, e, c);
    return b.child;
}
function gj(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
}
function cj(a, b, c, d, e) {
    var f = Zf(c) ? Xf : H.current;
    f = Yf(b, f);
    ch(b, e);
    c = Nh(a, b, c, d, f, e);
    d = Sh();
    if (null !== a && !dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, Zi(a, b, e);
    I && d && vg(b);
    b.flags |= 1;
    Xi(a, b, c, e);
    return b.child;
}
function hj(a, b, c, d, e) {
    if (Zf(c)) {
        var f = !0;
        cg(b);
    } else f = !1;
    ch(b, e);
    if (null === b.stateNode) ij(a, b), Gi(b, c, d), Ii(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = eh(l) : (l = Zf(c) ? Xf : H.current, l = Yf(b, l));
        var m = c.getDerivedStateFromProps, q = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        q || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && Hi(b, g, d, l);
        jh = !1;
        var r = b.memoizedState;
        g.state = r;
        qh(b, d, g, e);
        k = b.memoizedState;
        h !== d || r !== k || Wf.current || jh ? ("function" === typeof m && (Di(b, c, m, d), k = b.memoizedState), (h = jh || Fi(b, c, h, d, r, k, l)) ? (q || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
    } else {
        g = b.stateNode;
        lh(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : Ci(b.type, h);
        g.props = l;
        q = b.pendingProps;
        r = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = eh(k) : (k = Zf(c) ? Xf : H.current, k = Yf(b, k));
        var y = c.getDerivedStateFromProps;
        (m = "function" === typeof y || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== q || r !== k) && Hi(b, g, d, k);
        jh = !1;
        r = b.memoizedState;
        g.state = r;
        qh(b, d, g, e);
        var n = b.memoizedState;
        h !== q || r !== n || Wf.current || jh ? ("function" === typeof y && (Di(b, c, y, d), n = b.memoizedState), (l = jh || Fi(b, c, l, d, r, n, k) || !1) ? (m || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, n, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, n, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = n), g.props = d, g.state = n, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), d = !1);
    }
    return jj(a, b, c, d, f, e);
}
function jj(a, b, c, d, e, f) {
    gj(a, b);
    var g = 0 !== (b.flags & 128);
    if (!d && !g) return e && dg(b, c, !1), Zi(a, b, f);
    d = b.stateNode;
    Wi.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = Ug(b, a.child, null, f), b.child = Ug(b, null, h, f)) : Xi(a, b, h, f);
    b.memoizedState = d.state;
    e && dg(b, c, !0);
    return b.child;
}
function kj(a) {
    var b = a.stateNode;
    b.pendingContext ? ag(a, b.pendingContext, b.pendingContext !== b.context) : b.context && ag(a, b.context, !1);
    yh(a, b.containerInfo);
}
function lj(a, b, c, d, e) {
    Ig();
    Jg(e);
    b.flags |= 256;
    Xi(a, b, c, d);
    return b.child;
}
var mj = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function nj(a) {
    return {
        baseLanes: a,
        cachePool: null,
        transitions: null
    };
}
function oj(a, b, c) {
    var d = b.pendingProps, e = L.current, f = !1, g = 0 !== (b.flags & 128), h;
    (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    if (h) f = !0, b.flags &= -129;
    else if (null === a || null !== a.memoizedState) e |= 1;
    G(L, e & 1);
    if (null === a) {
        Eg(b);
        a = b.memoizedState;
        if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a.data ? b.lanes = 8 : b.lanes = 1073741824, null;
        g = d.children;
        a = d.fallback;
        return f ? (d = b.mode, f = b.child, g = {
            mode: "hidden",
            children: g
        }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = g) : f = pj(g, d, 0, null), a = Tg(a, d, c, null), f.return = b, a.return = b, f.sibling = a, b.child = f, b.child.memoizedState = nj(c), b.memoizedState = mj, a) : qj(b, g);
    }
    e = a.memoizedState;
    if (null !== e && (h = e.dehydrated, null !== h)) return rj(a, b, g, d, h, e, c);
    if (f) {
        f = d.fallback;
        g = b.mode;
        e = a.child;
        h = e.sibling;
        var k = {
            mode: "hidden",
            children: d.children
        };
        0 === (g & 1) && b.child !== e ? (d = b.child, d.childLanes = 0, d.pendingProps = k, b.deletions = null) : (d = Pg(e, k), d.subtreeFlags = e.subtreeFlags & 14680064);
        null !== h ? f = Pg(h, f) : (f = Tg(f, g, c, null), f.flags |= 2);
        f.return = b;
        d.return = b;
        d.sibling = f;
        b.child = d;
        d = f;
        f = b.child;
        g = a.child.memoizedState;
        g = null === g ? nj(c) : {
            baseLanes: g.baseLanes | c,
            cachePool: null,
            transitions: g.transitions
        };
        f.memoizedState = g;
        f.childLanes = a.childLanes & ~c;
        b.memoizedState = mj;
        return d;
    }
    f = a.child;
    a = f.sibling;
    d = Pg(f, {
        mode: "visible",
        children: d.children
    });
    0 === (b.mode & 1) && (d.lanes = c);
    d.return = b;
    d.sibling = null;
    null !== a && (c = b.deletions, null === c ? (b.deletions = [
        a
    ], b.flags |= 16) : c.push(a));
    b.child = d;
    b.memoizedState = null;
    return d;
}
function qj(a, b) {
    b = pj({
        mode: "visible",
        children: b
    }, a.mode, 0, null);
    b.return = a;
    return a.child = b;
}
function sj(a, b, c, d) {
    null !== d && Jg(d);
    Ug(b, a.child, null, c);
    a = qj(b, b.pendingProps.children);
    a.flags |= 2;
    b.memoizedState = null;
    return a;
}
function rj(a, b, c, d, e, f, g) {
    if (c) {
        if (b.flags & 256) return b.flags &= -257, d = Ki(Error(p(422))), sj(a, b, g, d);
        if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
        f = d.fallback;
        e = b.mode;
        d = pj({
            mode: "visible",
            children: d.children
        }, e, 0, null);
        f = Tg(f, e, g, null);
        f.flags |= 2;
        d.return = b;
        f.return = b;
        d.sibling = f;
        b.child = d;
        0 !== (b.mode & 1) && Ug(b, a.child, null, g);
        b.child.memoizedState = nj(g);
        b.memoizedState = mj;
        return f;
    }
    if (0 === (b.mode & 1)) return sj(a, b, g, null);
    if ("$!" === e.data) {
        d = e.nextSibling && e.nextSibling.dataset;
        if (d) var h = d.dgst;
        d = h;
        f = Error(p(419));
        d = Ki(f, d, void 0);
        return sj(a, b, g, d);
    }
    h = 0 !== (g & a.childLanes);
    if (dh || h) {
        d = Q;
        if (null !== d) {
            switch(g & -g){
                case 4:
                    e = 2;
                    break;
                case 16:
                    e = 8;
                    break;
                case 64:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                case 67108864:
                    e = 32;
                    break;
                case 536870912:
                    e = 268435456;
                    break;
                default:
                    e = 0;
            }
            e = 0 !== (e & (d.suspendedLanes | g)) ? 0 : e;
            0 !== e && e !== f.retryLane && (f.retryLane = e, ih(a, e), gi(d, a, e, -1));
        }
        tj();
        d = Ki(Error(p(421)));
        return sj(a, b, g, d);
    }
    if ("$?" === e.data) return b.flags |= 128, b.child = a.child, b = uj.bind(null, a), e._reactRetry = b, null;
    a = f.treeContext;
    yg = Lf(e.nextSibling);
    xg = b;
    I = !0;
    zg = null;
    null !== a && (og[pg++] = rg, og[pg++] = sg, og[pg++] = qg, rg = a.id, sg = a.overflow, qg = b);
    b = qj(b, d.children);
    b.flags |= 4096;
    return b;
}
function vj(a, b, c) {
    a.lanes |= b;
    var d = a.alternate;
    null !== d && (d.lanes |= b);
    bh(a.return, b, c);
}
function wj(a, b, c, d, e) {
    var f = a.memoizedState;
    null === f ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e
    } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
}
function xj(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    Xi(a, b, d.children, c);
    d = L.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
    else {
        if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && vj(a, c, b);
            else if (19 === a.tag) vj(a, c, b);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    G(L, d);
    if (0 === (b.mode & 1)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === Ch(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            wj(b, !1, e, c, f);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === Ch(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            wj(b, !0, c, null, f);
            break;
        case "together":
            wj(b, !1, null, null, void 0);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function ij(a, b) {
    0 === (b.mode & 1) && null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
}
function Zi(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    rh |= b.lanes;
    if (0 === (c & b.childLanes)) return null;
    if (null !== a && b.child !== a.child) throw Error(p(153));
    if (null !== b.child) {
        a = b.child;
        c = Pg(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = Pg(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
function yj(a, b, c) {
    switch(b.tag){
        case 3:
            kj(b);
            Ig();
            break;
        case 5:
            Ah(b);
            break;
        case 1:
            Zf(b.type) && cg(b);
            break;
        case 4:
            yh(b, b.stateNode.containerInfo);
            break;
        case 10:
            var d = b.type._context, e = b.memoizedProps.value;
            G(Wg, d._currentValue);
            d._currentValue = e;
            break;
        case 13:
            d = b.memoizedState;
            if (null !== d) {
                if (null !== d.dehydrated) return G(L, L.current & 1), b.flags |= 128, null;
                if (0 !== (c & b.child.childLanes)) return oj(a, b, c);
                G(L, L.current & 1);
                a = Zi(a, b, c);
                return null !== a ? a.sibling : null;
            }
            G(L, L.current & 1);
            break;
        case 19:
            d = 0 !== (c & b.childLanes);
            if (0 !== (a.flags & 128)) {
                if (d) return xj(a, b, c);
                b.flags |= 128;
            }
            e = b.memoizedState;
            null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
            G(L, L.current);
            if (d) break;
            else return null;
        case 22:
        case 23:
            return b.lanes = 0, dj(a, b, c);
    }
    return Zi(a, b, c);
}
var zj, Aj, Bj, Cj;
zj = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
Aj = function() {};
Bj = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        xh(uh.current);
        var f = null;
        switch(c){
            case "input":
                e = Ya(a, e);
                d = Ya(a, d);
                f = [];
                break;
            case "select":
                e = A({}, e, {
                    value: void 0
                });
                d = A({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = gb(a, e);
                d = gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = Bf);
        }
        ub(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && (ea.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && (ea.hasOwnProperty(l) ? (null != k && "onScroll" === l && D("scroll", a), f || h === k || (f = [])) : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
Cj = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function Dj(a, b) {
    if (!I) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function S(a) {
    var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
    if (b) for(var e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
    else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
    a.subtreeFlags |= d;
    a.childLanes = c;
    return b;
}
function Ej(a, b, c) {
    var d = b.pendingProps;
    wg(b);
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return S(b), null;
        case 1:
            return Zf(b.type) && $f(), S(b), null;
        case 3:
            d = b.stateNode;
            zh();
            E(Wf);
            E(H);
            Eh();
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) Gg(b) ? b.flags |= 4 : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== zg && (Fj(zg), zg = null));
            Aj(a, b);
            S(b);
            return null;
        case 5:
            Bh(b);
            var e = xh(wh.current);
            c = b.type;
            if (null !== a && null != b.stateNode) Bj(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error(p(166));
                    S(b);
                    return null;
                }
                a = xh(uh.current);
                if (Gg(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[Of] = b;
                    d[Pf] = f;
                    a = 0 !== (b.mode & 1);
                    switch(c){
                        case "dialog":
                            D("cancel", d);
                            D("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            D("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < lf.length; e++)D(lf[e], d);
                            break;
                        case "source":
                            D("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            D("error", d);
                            D("load", d);
                            break;
                        case "details":
                            D("toggle", d);
                            break;
                        case "input":
                            Za(d, f);
                            D("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            D("invalid", d);
                            break;
                        case "textarea":
                            hb(d, f), D("invalid", d);
                    }
                    ub(c, f);
                    e = null;
                    for(var g in f)if (f.hasOwnProperty(g)) {
                        var h = f[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (!0 !== f.suppressHydrationWarning && Af(d.textContent, h, a), e = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (!0 !== f.suppressHydrationWarning && Af(d.textContent, h, a), e = [
                            "children",
                            "" + h
                        ]) : ea.hasOwnProperty(g) && null != h && "onScroll" === g && D("scroll", d);
                    }
                    switch(c){
                        case "input":
                            Va(d);
                            db(d, f, !0);
                            break;
                        case "textarea":
                            Va(d);
                            jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = Bf);
                    }
                    d = e;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    "http://www.w3.org/1999/xhtml" === a && (a = kb(c));
                    "http://www.w3.org/1999/xhtml" === a ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script></script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[Of] = b;
                    a[Pf] = d;
                    zj(a, b, !1, !1);
                    b.stateNode = a;
                    a: {
                        g = vb(c, d);
                        switch(c){
                            case "dialog":
                                D("cancel", a);
                                D("close", a);
                                e = d;
                                break;
                            case "iframe":
                            case "object":
                            case "embed":
                                D("load", a);
                                e = d;
                                break;
                            case "video":
                            case "audio":
                                for(e = 0; e < lf.length; e++)D(lf[e], a);
                                e = d;
                                break;
                            case "source":
                                D("error", a);
                                e = d;
                                break;
                            case "img":
                            case "image":
                            case "link":
                                D("error", a);
                                D("load", a);
                                e = d;
                                break;
                            case "details":
                                D("toggle", a);
                                e = d;
                                break;
                            case "input":
                                Za(a, d);
                                e = Ya(a, d);
                                D("invalid", a);
                                break;
                            case "option":
                                e = d;
                                break;
                            case "select":
                                a._wrapperState = {
                                    wasMultiple: !!d.multiple
                                };
                                e = A({}, d, {
                                    value: void 0
                                });
                                D("invalid", a);
                                break;
                            case "textarea":
                                hb(a, d);
                                e = gb(a, d);
                                D("invalid", a);
                                break;
                            default:
                                e = d;
                        }
                        ub(c, e);
                        h = e;
                        for(f in h)if (h.hasOwnProperty(f)) {
                            var k = h[f];
                            "style" === f ? sb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && nb(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && ob(a, k) : "number" === typeof k && ob(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && (ea.hasOwnProperty(f) ? null != k && "onScroll" === f && D("scroll", a) : null != k && ta(a, f, k, g));
                        }
                        switch(c){
                            case "input":
                                Va(a);
                                db(a, d, !1);
                                break;
                            case "textarea":
                                Va(a);
                                jb(a);
                                break;
                            case "option":
                                null != d.value && a.setAttribute("value", "" + Sa(d.value));
                                break;
                            case "select":
                                a.multiple = !!d.multiple;
                                f = d.value;
                                null != f ? fb(a, !!d.multiple, f, !1) : null != d.defaultValue && fb(a, !!d.multiple, d.defaultValue, !0);
                                break;
                            default:
                                "function" === typeof e.onClick && (a.onclick = Bf);
                        }
                        switch(c){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                d = !!d.autoFocus;
                                break a;
                            case "img":
                                d = !0;
                                break a;
                            default:
                                d = !1;
                        }
                    }
                    d && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            }
            S(b);
            return null;
        case 6:
            if (a && null != b.stateNode) Cj(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error(p(166));
                c = xh(wh.current);
                xh(uh.current);
                if (Gg(b)) {
                    d = b.stateNode;
                    c = b.memoizedProps;
                    d[Of] = b;
                    if (f = d.nodeValue !== c) {
                        if (a = xg, null !== a) switch(a.tag){
                            case 3:
                                Af(d.nodeValue, c, 0 !== (a.mode & 1));
                                break;
                            case 5:
                                !0 !== a.memoizedProps.suppressHydrationWarning && Af(d.nodeValue, c, 0 !== (a.mode & 1));
                        }
                    }
                    f && (b.flags |= 4);
                } else d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[Of] = b, b.stateNode = d;
            }
            S(b);
            return null;
        case 13:
            E(L);
            d = b.memoizedState;
            if (null === a || null !== a.memoizedState && null !== a.memoizedState.dehydrated) {
                if (I && null !== yg && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) Hg(), Ig(), b.flags |= 98560, f = !1;
                else if (f = Gg(b), null !== d && null !== d.dehydrated) {
                    if (null === a) {
                        if (!f) throw Error(p(318));
                        f = b.memoizedState;
                        f = null !== f ? f.dehydrated : null;
                        if (!f) throw Error(p(317));
                        f[Of] = b;
                    } else Ig(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4;
                    S(b);
                    f = !1;
                } else null !== zg && (Fj(zg), zg = null), f = !0;
                if (!f) return b.flags & 65536 ? b : null;
            }
            if (0 !== (b.flags & 128)) return b.lanes = c, b;
            d = null !== d;
            d !== (null !== a && null !== a.memoizedState) && d && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== (L.current & 1) ? 0 === T && (T = 3) : tj()));
            null !== b.updateQueue && (b.flags |= 4);
            S(b);
            return null;
        case 4:
            return zh(), Aj(a, b), null === a && sf(b.stateNode.containerInfo), S(b), null;
        case 10:
            return ah(b.type._context), S(b), null;
        case 17:
            return Zf(b.type) && $f(), S(b), null;
        case 19:
            E(L);
            f = b.memoizedState;
            if (null === f) return S(b), null;
            d = 0 !== (b.flags & 128);
            g = f.rendering;
            if (null === g) {
                if (d) Dj(f, !1);
                else {
                    if (0 !== T || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                        g = Ch(a);
                        if (null !== g) {
                            b.flags |= 128;
                            Dj(f, !1);
                            d = g.updateQueue;
                            null !== d && (b.updateQueue = d, b.flags |= 4);
                            b.subtreeFlags = 0;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 14680066, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.subtreeFlags = 0, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.subtreeFlags = 0, f.deletions = null, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            G(L, L.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== f.tail && B() > Gj && (b.flags |= 128, d = !0, Dj(f, !1), b.lanes = 4194304);
                }
            } else {
                if (!d) {
                    if (a = Ch(g), null !== a) {
                        if (b.flags |= 128, d = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), Dj(f, !0), null === f.tail && "hidden" === f.tailMode && !g.alternate && !I) return S(b), null;
                    } else 2 * B() - f.renderingStartTime > Gj && 1073741824 !== c && (b.flags |= 128, d = !0, Dj(f, !1), b.lanes = 4194304);
                }
                f.isBackwards ? (g.sibling = b.child, b.child = g) : (c = f.last, null !== c ? c.sibling = g : b.child = g, f.last = g);
            }
            if (null !== f.tail) return b = f.tail, f.rendering = b, f.tail = b.sibling, f.renderingStartTime = B(), b.sibling = null, c = L.current, G(L, d ? c & 1 | 2 : c & 1), b;
            S(b);
            return null;
        case 22:
        case 23:
            return Hj(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== (fj & 1073741824) && (S(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : S(b), null;
        case 24:
            return null;
        case 25:
            return null;
    }
    throw Error(p(156, b.tag));
}
function Ij(a, b) {
    wg(b);
    switch(b.tag){
        case 1:
            return Zf(b.type) && $f(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 3:
            return zh(), E(Wf), E(H), Eh(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
        case 5:
            return Bh(b), null;
        case 13:
            E(L);
            a = b.memoizedState;
            if (null !== a && null !== a.dehydrated) {
                if (null === b.alternate) throw Error(p(340));
                Ig();
            }
            a = b.flags;
            return a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 19:
            return E(L), null;
        case 4:
            return zh(), null;
        case 10:
            return ah(b.type._context), null;
        case 22:
        case 23:
            return Hj(), null;
        case 24:
            return null;
        default:
            return null;
    }
}
var Jj = !1, U = !1, Kj = "function" === typeof WeakSet ? WeakSet : Set, V = null;
function Lj(a, b) {
    var c = a.ref;
    if (null !== c) {
        if ("function" === typeof c) try {
            c(null);
        } catch (d) {
            W(a, b, d);
        }
        else c.current = null;
    }
}
function Mj(a, b, c) {
    try {
        c();
    } catch (d) {
        W(a, b, d);
    }
}
var Nj = !1;
function Oj(a, b) {
    Cf = dd;
    a = Me();
    if (Ne(a)) {
        if ("selectionStart" in a) var c = {
            start: a.selectionStart,
            end: a.selectionEnd
        };
        else a: {
            c = (c = a.ownerDocument) && c.defaultView || window;
            var d = c.getSelection && c.getSelection();
            if (d && 0 !== d.rangeCount) {
                c = d.anchorNode;
                var e = d.anchorOffset, f = d.focusNode;
                d = d.focusOffset;
                try {
                    c.nodeType, f.nodeType;
                } catch (F) {
                    c = null;
                    break a;
                }
                var g = 0, h = -1, k = -1, l = 0, m = 0, q = a, r = null;
                b: for(;;){
                    for(var y;;){
                        q !== c || 0 !== e && 3 !== q.nodeType || (h = g + e);
                        q !== f || 0 !== d && 3 !== q.nodeType || (k = g + d);
                        3 === q.nodeType && (g += q.nodeValue.length);
                        if (null === (y = q.firstChild)) break;
                        r = q;
                        q = y;
                    }
                    for(;;){
                        if (q === a) break b;
                        r === c && ++l === e && (h = g);
                        r === f && ++m === d && (k = g);
                        if (null !== (y = q.nextSibling)) break;
                        q = r;
                        r = q.parentNode;
                    }
                    q = y;
                }
                c = -1 === h || -1 === k ? null : {
                    start: h,
                    end: k
                };
            } else c = null;
        }
        c = c || {
            start: 0,
            end: 0
        };
    } else c = null;
    Df = {
        focusedElem: a,
        selectionRange: c
    };
    dd = !1;
    for(V = b; null !== V;)if (b = V, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a.return = b, V = a;
    else for(; null !== V;){
        b = V;
        try {
            var n = b.alternate;
            if (0 !== (b.flags & 1024)) switch(b.tag){
                case 0:
                case 11:
                case 15:
                    break;
                case 1:
                    if (null !== n) {
                        var t = n.memoizedProps, J = n.memoizedState, x = b.stateNode, w = x.getSnapshotBeforeUpdate(b.elementType === b.type ? t : Ci(b.type, t), J);
                        x.__reactInternalSnapshotBeforeUpdate = w;
                    }
                    break;
                case 3:
                    var u = b.stateNode.containerInfo;
                    1 === u.nodeType ? u.textContent = "" : 9 === u.nodeType && u.documentElement && u.removeChild(u.documentElement);
                    break;
                case 5:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    throw Error(p(163));
            }
        } catch (F) {
            W(b, b.return, F);
        }
        a = b.sibling;
        if (null !== a) {
            a.return = b.return;
            V = a;
            break;
        }
        V = b.return;
    }
    n = Nj;
    Nj = !1;
    return n;
}
function Pj(a, b, c) {
    var d = b.updateQueue;
    d = null !== d ? d.lastEffect : null;
    if (null !== d) {
        var e = d = d.next;
        do {
            if ((e.tag & a) === a) {
                var f = e.destroy;
                e.destroy = void 0;
                void 0 !== f && Mj(b, c, f);
            }
            e = e.next;
        }while (e !== d);
    }
}
function Qj(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function Rj(a) {
    var b = a.ref;
    if (null !== b) {
        var c = a.stateNode;
        switch(a.tag){
            case 5:
                a = c;
                break;
            default:
                a = c;
        }
        "function" === typeof b ? b(a) : b.current = a;
    }
}
function Sj(a) {
    var b = a.alternate;
    null !== b && (a.alternate = null, Sj(b));
    a.child = null;
    a.deletions = null;
    a.sibling = null;
    5 === a.tag && (b = a.stateNode, null !== b && (delete b[Of], delete b[Pf], delete b[of], delete b[Qf], delete b[Rf]));
    a.stateNode = null;
    a.return = null;
    a.dependencies = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.stateNode = null;
    a.updateQueue = null;
}
function Tj(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function Uj(a) {
    a: for(;;){
        for(; null === a.sibling;){
            if (null === a.return || Tj(a.return)) return null;
            a = a.return;
        }
        a.sibling.return = a.return;
        for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
            if (a.flags & 2) continue a;
            if (null === a.child || 4 === a.tag) continue a;
            else a.child.return = a, a = a.child;
        }
        if (!(a.flags & 2)) return a.stateNode;
    }
}
function Vj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = Bf));
    else if (4 !== d && (a = a.child, null !== a)) for(Vj(a, b, c), a = a.sibling; null !== a;)Vj(a, b, c), a = a.sibling;
}
function Wj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for(Wj(a, b, c), a = a.sibling; null !== a;)Wj(a, b, c), a = a.sibling;
}
var X = null, Xj = !1;
function Yj(a, b, c) {
    for(c = c.child; null !== c;)Zj(a, b, c), c = c.sibling;
}
function Zj(a, b, c) {
    if (lc && "function" === typeof lc.onCommitFiberUnmount) try {
        lc.onCommitFiberUnmount(kc, c);
    } catch (h) {}
    switch(c.tag){
        case 5:
            U || Lj(c, b);
        case 6:
            var d = X, e = Xj;
            X = null;
            Yj(a, b, c);
            X = d;
            Xj = e;
            null !== X && (Xj ? (a = X, c = c.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c)) : X.removeChild(c.stateNode));
            break;
        case 18:
            null !== X && (Xj ? (a = X, c = c.stateNode, 8 === a.nodeType ? Kf(a.parentNode, c) : 1 === a.nodeType && Kf(a, c), bd(a)) : Kf(X, c.stateNode));
            break;
        case 4:
            d = X;
            e = Xj;
            X = c.stateNode.containerInfo;
            Xj = !0;
            Yj(a, b, c);
            X = d;
            Xj = e;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            if (!U && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
                e = d = d.next;
                do {
                    var f = e, g = f.destroy;
                    f = f.tag;
                    void 0 !== g && (0 !== (f & 2) ? Mj(c, b, g) : 0 !== (f & 4) && Mj(c, b, g));
                    e = e.next;
                }while (e !== d);
            }
            Yj(a, b, c);
            break;
        case 1:
            if (!U && (Lj(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
                d.props = c.memoizedProps, d.state = c.memoizedState, d.componentWillUnmount();
            } catch (h) {
                W(c, b, h);
            }
            Yj(a, b, c);
            break;
        case 21:
            Yj(a, b, c);
            break;
        case 22:
            c.mode & 1 ? (U = (d = U) || null !== c.memoizedState, Yj(a, b, c), U = d) : Yj(a, b, c);
            break;
        default:
            Yj(a, b, c);
    }
}
function ak(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new Kj);
        b.forEach(function(b) {
            var d = bk.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function ck(a, b) {
    var c = b.deletions;
    if (null !== c) for(var d = 0; d < c.length; d++){
        var e = c[d];
        try {
            var f = a, g = b, h = g;
            a: for(; null !== h;){
                switch(h.tag){
                    case 5:
                        X = h.stateNode;
                        Xj = !1;
                        break a;
                    case 3:
                        X = h.stateNode.containerInfo;
                        Xj = !0;
                        break a;
                    case 4:
                        X = h.stateNode.containerInfo;
                        Xj = !0;
                        break a;
                }
                h = h.return;
            }
            if (null === X) throw Error(p(160));
            Zj(f, g, e);
            X = null;
            Xj = !1;
            var k = e.alternate;
            null !== k && (k.return = null);
            e.return = null;
        } catch (l) {
            W(e, b, l);
        }
    }
    if (b.subtreeFlags & 12854) for(b = b.child; null !== b;)dk(b, a), b = b.sibling;
}
function dk(a, b) {
    var c = a.alternate, d = a.flags;
    switch(a.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            ck(b, a);
            ek(a);
            if (d & 4) {
                try {
                    Pj(3, a, a.return), Qj(3, a);
                } catch (t) {
                    W(a, a.return, t);
                }
                try {
                    Pj(5, a, a.return);
                } catch (t) {
                    W(a, a.return, t);
                }
            }
            break;
        case 1:
            ck(b, a);
            ek(a);
            d & 512 && null !== c && Lj(c, c.return);
            break;
        case 5:
            ck(b, a);
            ek(a);
            d & 512 && null !== c && Lj(c, c.return);
            if (a.flags & 32) {
                var e = a.stateNode;
                try {
                    ob(e, "");
                } catch (t) {
                    W(a, a.return, t);
                }
            }
            if (d & 4 && (e = a.stateNode, null != e)) {
                var f = a.memoizedProps, g = null !== c ? c.memoizedProps : f, h = a.type, k = a.updateQueue;
                a.updateQueue = null;
                if (null !== k) try {
                    "input" === h && "radio" === f.type && null != f.name && ab(e, f);
                    vb(h, g);
                    var l = vb(h, f);
                    for(g = 0; g < k.length; g += 2){
                        var m = k[g], q = k[g + 1];
                        "style" === m ? sb(e, q) : "dangerouslySetInnerHTML" === m ? nb(e, q) : "children" === m ? ob(e, q) : ta(e, m, q, l);
                    }
                    switch(h){
                        case "input":
                            bb(e, f);
                            break;
                        case "textarea":
                            ib(e, f);
                            break;
                        case "select":
                            var r = e._wrapperState.wasMultiple;
                            e._wrapperState.wasMultiple = !!f.multiple;
                            var y = f.value;
                            null != y ? fb(e, !!f.multiple, y, !1) : r !== !!f.multiple && (null != f.defaultValue ? fb(e, !!f.multiple, f.defaultValue, !0) : fb(e, !!f.multiple, f.multiple ? [] : "", !1));
                    }
                    e[Pf] = f;
                } catch (t) {
                    W(a, a.return, t);
                }
            }
            break;
        case 6:
            ck(b, a);
            ek(a);
            if (d & 4) {
                if (null === a.stateNode) throw Error(p(162));
                e = a.stateNode;
                f = a.memoizedProps;
                try {
                    e.nodeValue = f;
                } catch (t) {
                    W(a, a.return, t);
                }
            }
            break;
        case 3:
            ck(b, a);
            ek(a);
            if (d & 4 && null !== c && c.memoizedState.isDehydrated) try {
                bd(b.containerInfo);
            } catch (t) {
                W(a, a.return, t);
            }
            break;
        case 4:
            ck(b, a);
            ek(a);
            break;
        case 13:
            ck(b, a);
            ek(a);
            e = a.child;
            e.flags & 8192 && (f = null !== e.memoizedState, e.stateNode.isHidden = f, !f || null !== e.alternate && null !== e.alternate.memoizedState || (fk = B()));
            d & 4 && ak(a);
            break;
        case 22:
            m = null !== c && null !== c.memoizedState;
            a.mode & 1 ? (U = (l = U) || m, ck(b, a), U = l) : ck(b, a);
            ek(a);
            if (d & 8192) {
                l = null !== a.memoizedState;
                if ((a.stateNode.isHidden = l) && !m && 0 !== (a.mode & 1)) for(V = a, m = a.child; null !== m;){
                    for(q = V = m; null !== V;){
                        r = V;
                        y = r.child;
                        switch(r.tag){
                            case 0:
                            case 11:
                            case 14:
                            case 15:
                                Pj(4, r, r.return);
                                break;
                            case 1:
                                Lj(r, r.return);
                                var n = r.stateNode;
                                if ("function" === typeof n.componentWillUnmount) {
                                    d = r;
                                    c = r.return;
                                    try {
                                        b = d, n.props = b.memoizedProps, n.state = b.memoizedState, n.componentWillUnmount();
                                    } catch (t) {
                                        W(d, c, t);
                                    }
                                }
                                break;
                            case 5:
                                Lj(r, r.return);
                                break;
                            case 22:
                                if (null !== r.memoizedState) {
                                    gk(q);
                                    continue;
                                }
                        }
                        null !== y ? (y.return = r, V = y) : gk(q);
                    }
                    m = m.sibling;
                }
                a: for(m = null, q = a;;){
                    if (5 === q.tag) {
                        if (null === m) {
                            m = q;
                            try {
                                e = q.stateNode, l ? (f = e.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (h = q.stateNode, k = q.memoizedProps.style, g = void 0 !== k && null !== k && k.hasOwnProperty("display") ? k.display : null, h.style.display = rb("display", g));
                            } catch (t) {
                                W(a, a.return, t);
                            }
                        }
                    } else if (6 === q.tag) {
                        if (null === m) try {
                            q.stateNode.nodeValue = l ? "" : q.memoizedProps;
                        } catch (t) {
                            W(a, a.return, t);
                        }
                    } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === a) && null !== q.child) {
                        q.child.return = q;
                        q = q.child;
                        continue;
                    }
                    if (q === a) break a;
                    for(; null === q.sibling;){
                        if (null === q.return || q.return === a) break a;
                        m === q && (m = null);
                        q = q.return;
                    }
                    m === q && (m = null);
                    q.sibling.return = q.return;
                    q = q.sibling;
                }
            }
            break;
        case 19:
            ck(b, a);
            ek(a);
            d & 4 && ak(a);
            break;
        case 21:
            break;
        default:
            ck(b, a), ek(a);
    }
}
function ek(a) {
    var b = a.flags;
    if (b & 2) {
        try {
            a: {
                for(var c = a.return; null !== c;){
                    if (Tj(c)) {
                        var d = c;
                        break a;
                    }
                    c = c.return;
                }
                throw Error(p(160));
            }
            switch(d.tag){
                case 5:
                    var e = d.stateNode;
                    d.flags & 32 && (ob(e, ""), d.flags &= -33);
                    var f = Uj(a);
                    Wj(a, f, e);
                    break;
                case 3:
                case 4:
                    var g = d.stateNode.containerInfo, h = Uj(a);
                    Vj(a, h, g);
                    break;
                default:
                    throw Error(p(161));
            }
        } catch (k) {
            W(a, a.return, k);
        }
        a.flags &= -3;
    }
    b & 4096 && (a.flags &= -4097);
}
function hk(a, b, c) {
    V = a;
    ik(a, b, c);
}
function ik(a, b, c) {
    for(var d = 0 !== (a.mode & 1); null !== V;){
        var e = V, f = e.child;
        if (22 === e.tag && d) {
            var g = null !== e.memoizedState || Jj;
            if (!g) {
                var h = e.alternate, k = null !== h && null !== h.memoizedState || U;
                h = Jj;
                var l = U;
                Jj = g;
                if ((U = k) && !l) for(V = e; null !== V;)g = V, k = g.child, 22 === g.tag && null !== g.memoizedState ? jk(e) : null !== k ? (k.return = g, V = k) : jk(e);
                for(; null !== f;)V = f, ik(f, b, c), f = f.sibling;
                V = e;
                Jj = h;
                U = l;
            }
            kk(a, b, c);
        } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f.return = e, V = f) : kk(a, b, c);
    }
}
function kk(a) {
    for(; null !== V;){
        var b = V;
        if (0 !== (b.flags & 8772)) {
            var c = b.alternate;
            try {
                if (0 !== (b.flags & 8772)) switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        U || Qj(5, b);
                        break;
                    case 1:
                        var d = b.stateNode;
                        if (b.flags & 4 && !U) {
                            if (null === c) d.componentDidMount();
                            else {
                                var e = b.elementType === b.type ? c.memoizedProps : Ci(b.type, c.memoizedProps);
                                d.componentDidUpdate(e, c.memoizedState, d.__reactInternalSnapshotBeforeUpdate);
                            }
                        }
                        var f = b.updateQueue;
                        null !== f && sh(b, f, d);
                        break;
                    case 3:
                        var g = b.updateQueue;
                        if (null !== g) {
                            c = null;
                            if (null !== b.child) switch(b.child.tag){
                                case 5:
                                    c = b.child.stateNode;
                                    break;
                                case 1:
                                    c = b.child.stateNode;
                            }
                            sh(b, g, c);
                        }
                        break;
                    case 5:
                        var h = b.stateNode;
                        if (null === c && b.flags & 4) {
                            c = h;
                            var k = b.memoizedProps;
                            switch(b.type){
                                case "button":
                                case "input":
                                case "select":
                                case "textarea":
                                    k.autoFocus && c.focus();
                                    break;
                                case "img":
                                    k.src && (c.src = k.src);
                            }
                        }
                        break;
                    case 6:
                        break;
                    case 4:
                        break;
                    case 12:
                        break;
                    case 13:
                        if (null === b.memoizedState) {
                            var l = b.alternate;
                            if (null !== l) {
                                var m = l.memoizedState;
                                if (null !== m) {
                                    var q = m.dehydrated;
                                    null !== q && bd(q);
                                }
                            }
                        }
                        break;
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                    case 25:
                        break;
                    default:
                        throw Error(p(163));
                }
                U || b.flags & 512 && Rj(b);
            } catch (r) {
                W(b, b.return, r);
            }
        }
        if (b === a) {
            V = null;
            break;
        }
        c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            V = c;
            break;
        }
        V = b.return;
    }
}
function gk(a) {
    for(; null !== V;){
        var b = V;
        if (b === a) {
            V = null;
            break;
        }
        var c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            V = c;
            break;
        }
        V = b.return;
    }
}
function jk(a) {
    for(; null !== V;){
        var b = V;
        try {
            switch(b.tag){
                case 0:
                case 11:
                case 15:
                    var c = b.return;
                    try {
                        Qj(4, b);
                    } catch (k) {
                        W(b, c, k);
                    }
                    break;
                case 1:
                    var d = b.stateNode;
                    if ("function" === typeof d.componentDidMount) {
                        var e = b.return;
                        try {
                            d.componentDidMount();
                        } catch (k) {
                            W(b, e, k);
                        }
                    }
                    var f = b.return;
                    try {
                        Rj(b);
                    } catch (k) {
                        W(b, f, k);
                    }
                    break;
                case 5:
                    var g = b.return;
                    try {
                        Rj(b);
                    } catch (k) {
                        W(b, g, k);
                    }
            }
        } catch (k) {
            W(b, b.return, k);
        }
        if (b === a) {
            V = null;
            break;
        }
        var h = b.sibling;
        if (null !== h) {
            h.return = b.return;
            V = h;
            break;
        }
        V = b.return;
    }
}
var lk = Math.ceil, mk = ua.ReactCurrentDispatcher, nk = ua.ReactCurrentOwner, ok = ua.ReactCurrentBatchConfig, K = 0, Q = null, Y = null, Z = 0, fj = 0, ej = Uf(0), T = 0, pk = null, rh = 0, qk = 0, rk = 0, sk = null, tk = null, fk = 0, Gj = Infinity, uk = null, Oi = !1, Pi = null, Ri = null, vk = !1, wk = null, xk = 0, yk = 0, zk = null, Ak = -1, Bk = 0;
function R() {
    return 0 !== (K & 6) ? B() : -1 !== Ak ? Ak : Ak = B();
}
function yi(a) {
    if (0 === (a.mode & 1)) return 1;
    if (0 !== (K & 2) && 0 !== Z) return Z & -Z;
    if (null !== Kg.transition) return 0 === Bk && (Bk = yc()), Bk;
    a = C;
    if (0 !== a) return a;
    a = window.event;
    a = void 0 === a ? 16 : jd(a.type);
    return a;
}
function gi(a, b, c, d) {
    if (50 < yk) throw yk = 0, zk = null, Error(p(185));
    Ac(a, c, d);
    if (0 === (K & 2) || a !== Q) a === Q && (0 === (K & 2) && (qk |= c), 4 === T && Ck(a, Z)), Dk(a, d), 1 === c && 0 === K && 0 === (b.mode & 1) && (Gj = B() + 500, fg && jg());
}
function Dk(a, b) {
    var c = a.callbackNode;
    wc(a, b);
    var d = uc(a, a === Q ? Z : 0);
    if (0 === d) null !== c && bc(c), a.callbackNode = null, a.callbackPriority = 0;
    else if (b = d & -d, a.callbackPriority !== b) {
        null != c && bc(c);
        if (1 === b) 0 === a.tag ? ig(Ek.bind(null, a)) : hg(Ek.bind(null, a)), Jf(function() {
            0 === (K & 6) && jg();
        }), c = null;
        else {
            switch(Dc(d)){
                case 1:
                    c = fc;
                    break;
                case 4:
                    c = gc;
                    break;
                case 16:
                    c = hc;
                    break;
                case 536870912:
                    c = jc;
                    break;
                default:
                    c = hc;
            }
            c = Fk(c, Gk.bind(null, a));
        }
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function Gk(a, b) {
    Ak = -1;
    Bk = 0;
    if (0 !== (K & 6)) throw Error(p(327));
    var c = a.callbackNode;
    if (Hk() && a.callbackNode !== c) return null;
    var d = uc(a, a === Q ? Z : 0);
    if (0 === d) return null;
    if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = Ik(a, d);
    else {
        b = d;
        var e = K;
        K |= 2;
        var f = Jk();
        if (Q !== a || Z !== b) uk = null, Gj = B() + 500, Kk(a, b);
        for(;;)try {
            Lk();
            break;
        } catch (h) {
            Mk(a, h);
        }
        $g();
        mk.current = f;
        K = e;
        null !== Y ? b = 0 : (Q = null, Z = 0, b = T);
    }
    if (0 !== b) {
        2 === b && (e = xc(a), 0 !== e && (d = e, b = Nk(a, e)));
        if (1 === b) throw c = pk, Kk(a, 0), Ck(a, d), Dk(a, B()), c;
        if (6 === b) Ck(a, d);
        else {
            e = a.current.alternate;
            if (0 === (d & 30) && !Ok(e) && (b = Ik(a, d), 2 === b && (f = xc(a), 0 !== f && (d = f, b = Nk(a, f))), 1 === b)) throw c = pk, Kk(a, 0), Ck(a, d), Dk(a, B()), c;
            a.finishedWork = e;
            a.finishedLanes = d;
            switch(b){
                case 0:
                case 1:
                    throw Error(p(345));
                case 2:
                    Pk(a, tk, uk);
                    break;
                case 3:
                    Ck(a, d);
                    if ((d & 130023424) === d && (b = fk + 500 - B(), 10 < b)) {
                        if (0 !== uc(a, 0)) break;
                        e = a.suspendedLanes;
                        if ((e & d) !== d) {
                            R();
                            a.pingedLanes |= a.suspendedLanes & e;
                            break;
                        }
                        a.timeoutHandle = Ff(Pk.bind(null, a, tk, uk), b);
                        break;
                    }
                    Pk(a, tk, uk);
                    break;
                case 4:
                    Ck(a, d);
                    if ((d & 4194240) === d) break;
                    b = a.eventTimes;
                    for(e = -1; 0 < d;){
                        var g = 31 - oc(d);
                        f = 1 << g;
                        g = b[g];
                        g > e && (e = g);
                        d &= ~f;
                    }
                    d = e;
                    d = B() - d;
                    d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * lk(d / 1960)) - d;
                    if (10 < d) {
                        a.timeoutHandle = Ff(Pk.bind(null, a, tk, uk), d);
                        break;
                    }
                    Pk(a, tk, uk);
                    break;
                case 5:
                    Pk(a, tk, uk);
                    break;
                default:
                    throw Error(p(329));
            }
        }
    }
    Dk(a, B());
    return a.callbackNode === c ? Gk.bind(null, a) : null;
}
function Nk(a, b) {
    var c = sk;
    a.current.memoizedState.isDehydrated && (Kk(a, b).flags |= 256);
    a = Ik(a, b);
    2 !== a && (b = tk, tk = c, null !== b && Fj(b));
    return a;
}
function Fj(a) {
    null === tk ? tk = a : tk.push.apply(tk, a);
}
function Ok(a) {
    for(var b = a;;){
        if (b.flags & 16384) {
            var c = b.updateQueue;
            if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                var e = c[d], f = e.getSnapshot;
                e = e.value;
                try {
                    if (!He(f(), e)) return !1;
                } catch (g) {
                    return !1;
                }
            }
        }
        c = b.child;
        if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
        else {
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return !0;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return !0;
}
function Ck(a, b) {
    b &= ~rk;
    b &= ~qk;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - oc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function Ek(a) {
    if (0 !== (K & 6)) throw Error(p(327));
    Hk();
    var b = uc(a, 0);
    if (0 === (b & 1)) return Dk(a, B()), null;
    var c = Ik(a, b);
    if (0 !== a.tag && 2 === c) {
        var d = xc(a);
        0 !== d && (b = d, c = Nk(a, d));
    }
    if (1 === c) throw c = pk, Kk(a, 0), Ck(a, b), Dk(a, B()), c;
    if (6 === c) throw Error(p(345));
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    Pk(a, tk, uk);
    Dk(a, B());
    return null;
}
function Qk(a, b) {
    var c = K;
    K |= 1;
    try {
        return a(b);
    } finally{
        K = c, 0 === K && (Gj = B() + 500, fg && jg());
    }
}
function Rk(a) {
    null !== wk && 0 === wk.tag && 0 === (K & 6) && Hk();
    var b = K;
    K |= 1;
    var c = ok.transition, d = C;
    try {
        if (ok.transition = null, C = 1, a) return a();
    } finally{
        C = d, ok.transition = c, K = b, 0 === (K & 6) && jg();
    }
}
function Hj() {
    fj = ej.current;
    E(ej);
}
function Kk(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, Gf(c));
    if (null !== Y) for(c = Y.return; null !== c;){
        var d = c;
        wg(d);
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $f();
                break;
            case 3:
                zh();
                E(Wf);
                E(H);
                Eh();
                break;
            case 5:
                Bh(d);
                break;
            case 4:
                zh();
                break;
            case 13:
                E(L);
                break;
            case 19:
                E(L);
                break;
            case 10:
                ah(d.type._context);
                break;
            case 22:
            case 23:
                Hj();
        }
        c = c.return;
    }
    Q = a;
    Y = a = Pg(a.current, null);
    Z = fj = b;
    T = 0;
    pk = null;
    rk = qk = rh = 0;
    tk = sk = null;
    if (null !== fh) {
        for(b = 0; b < fh.length; b++)if (c = fh[b], d = c.interleaved, null !== d) {
            c.interleaved = null;
            var e = d.next, f = c.pending;
            if (null !== f) {
                var g = f.next;
                f.next = e;
                d.next = g;
            }
            c.pending = d;
        }
        fh = null;
    }
    return a;
}
function Mk(a, b) {
    do {
        var c = Y;
        try {
            $g();
            Fh.current = Rh;
            if (Ih) {
                for(var d = M.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                Ih = !1;
            }
            Hh = 0;
            O = N = M = null;
            Jh = !1;
            Kh = 0;
            nk.current = null;
            if (null === c || null === c.return) {
                T = 1;
                pk = b;
                Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = Z;
                h.flags |= 32768;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k, m = h, q = m.tag;
                    if (0 === (m.mode & 1) && (0 === q || 11 === q || 15 === q)) {
                        var r = m.alternate;
                        r ? (m.updateQueue = r.updateQueue, m.memoizedState = r.memoizedState, m.lanes = r.lanes) : (m.updateQueue = null, m.memoizedState = null);
                    }
                    var y = Ui(g);
                    if (null !== y) {
                        y.flags &= -257;
                        Vi(y, g, h, f, b);
                        y.mode & 1 && Si(f, l, b);
                        b = y;
                        k = l;
                        var n = b.updateQueue;
                        if (null === n) {
                            var t = new Set;
                            t.add(k);
                            b.updateQueue = t;
                        } else n.add(k);
                        break a;
                    } else {
                        if (0 === (b & 1)) {
                            Si(f, l, b);
                            tj();
                            break a;
                        }
                        k = Error(p(426));
                    }
                } else if (I && h.mode & 1) {
                    var J = Ui(g);
                    if (null !== J) {
                        0 === (J.flags & 65536) && (J.flags |= 256);
                        Vi(J, g, h, f, b);
                        Jg(Ji(k, h));
                        break a;
                    }
                }
                f = k = Ji(k, h);
                4 !== T && (T = 2);
                null === sk ? sk = [
                    f
                ] : sk.push(f);
                f = g;
                do {
                    switch(f.tag){
                        case 3:
                            f.flags |= 65536;
                            b &= -b;
                            f.lanes |= b;
                            var x = Ni(f, k, b);
                            ph(f, x);
                            break a;
                        case 1:
                            h = k;
                            var w = f.type, u = f.stateNode;
                            if (0 === (f.flags & 128) && ("function" === typeof w.getDerivedStateFromError || null !== u && "function" === typeof u.componentDidCatch && (null === Ri || !Ri.has(u)))) {
                                f.flags |= 65536;
                                b &= -b;
                                f.lanes |= b;
                                var F = Qi(f, h, b);
                                ph(f, F);
                                break a;
                            }
                    }
                    f = f.return;
                }while (null !== f);
            }
            Sk(c);
        } catch (na) {
            b = na;
            Y === c && null !== c && (Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function Jk() {
    var a = mk.current;
    mk.current = Rh;
    return null === a ? Rh : a;
}
function tj() {
    if (0 === T || 3 === T || 2 === T) T = 4;
    null === Q || 0 === (rh & 268435455) && 0 === (qk & 268435455) || Ck(Q, Z);
}
function Ik(a, b) {
    var c = K;
    K |= 2;
    var d = Jk();
    if (Q !== a || Z !== b) uk = null, Kk(a, b);
    for(;;)try {
        Tk();
        break;
    } catch (e) {
        Mk(a, e);
    }
    $g();
    K = c;
    mk.current = d;
    if (null !== Y) throw Error(p(261));
    Q = null;
    Z = 0;
    return T;
}
function Tk() {
    for(; null !== Y;)Uk(Y);
}
function Lk() {
    for(; null !== Y && !cc();)Uk(Y);
}
function Uk(a) {
    var b = Vk(a.alternate, a, fj);
    a.memoizedProps = a.pendingProps;
    null === b ? Sk(a) : Y = b;
    nk.current = null;
}
function Sk(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 32768)) {
            if (c = Ej(c, b, fj), null !== c) {
                Y = c;
                return;
            }
        } else {
            c = Ij(c, b);
            if (null !== c) {
                c.flags &= 32767;
                Y = c;
                return;
            }
            if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
            else {
                T = 6;
                Y = null;
                return;
            }
        }
        b = b.sibling;
        if (null !== b) {
            Y = b;
            return;
        }
        Y = b = a;
    }while (null !== b);
    0 === T && (T = 5);
}
function Pk(a, b, c) {
    var d = C, e = ok.transition;
    try {
        ok.transition = null, C = 1, Wk(a, b, c, d);
    } finally{
        ok.transition = e, C = d;
    }
    return null;
}
function Wk(a, b, c, d) {
    do Hk();
    while (null !== wk);
    if (0 !== (K & 6)) throw Error(p(327));
    c = a.finishedWork;
    var e = a.finishedLanes;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error(p(177));
    a.callbackNode = null;
    a.callbackPriority = 0;
    var f = c.lanes | c.childLanes;
    Bc(a, f);
    a === Q && (Y = Q = null, Z = 0);
    0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || vk || (vk = !0, Fk(hc, function() {
        Hk();
        return null;
    }));
    f = 0 !== (c.flags & 15990);
    if (0 !== (c.subtreeFlags & 15990) || f) {
        f = ok.transition;
        ok.transition = null;
        var g = C;
        C = 1;
        var h = K;
        K |= 4;
        nk.current = null;
        Oj(a, c);
        dk(c, a);
        Oe(Df);
        dd = !!Cf;
        Df = Cf = null;
        a.current = c;
        hk(c, a, e);
        dc();
        K = h;
        C = g;
        ok.transition = f;
    } else a.current = c;
    vk && (vk = !1, wk = a, xk = e);
    f = a.pendingLanes;
    0 === f && (Ri = null);
    mc(c.stateNode, d);
    Dk(a, B());
    if (null !== b) for(d = a.onRecoverableError, c = 0; c < b.length; c++)e = b[c], d(e.value, {
        componentStack: e.stack,
        digest: e.digest
    });
    if (Oi) throw Oi = !1, a = Pi, Pi = null, a;
    0 !== (xk & 1) && 0 !== a.tag && Hk();
    f = a.pendingLanes;
    0 !== (f & 1) ? a === zk ? yk++ : (yk = 0, zk = a) : yk = 0;
    jg();
    return null;
}
function Hk() {
    if (null !== wk) {
        var a = Dc(xk), b = ok.transition, c = C;
        try {
            ok.transition = null;
            C = 16 > a ? 16 : a;
            if (null === wk) var d = !1;
            else {
                a = wk;
                wk = null;
                xk = 0;
                if (0 !== (K & 6)) throw Error(p(331));
                var e = K;
                K |= 4;
                for(V = a.current; null !== V;){
                    var f = V, g = f.child;
                    if (0 !== (V.flags & 16)) {
                        var h = f.deletions;
                        if (null !== h) {
                            for(var k = 0; k < h.length; k++){
                                var l = h[k];
                                for(V = l; null !== V;){
                                    var m = V;
                                    switch(m.tag){
                                        case 0:
                                        case 11:
                                        case 15:
                                            Pj(8, m, f);
                                    }
                                    var q = m.child;
                                    if (null !== q) q.return = m, V = q;
                                    else for(; null !== V;){
                                        m = V;
                                        var r = m.sibling, y = m.return;
                                        Sj(m);
                                        if (m === l) {
                                            V = null;
                                            break;
                                        }
                                        if (null !== r) {
                                            r.return = y;
                                            V = r;
                                            break;
                                        }
                                        V = y;
                                    }
                                }
                            }
                            var n = f.alternate;
                            if (null !== n) {
                                var t = n.child;
                                if (null !== t) {
                                    n.child = null;
                                    do {
                                        var J = t.sibling;
                                        t.sibling = null;
                                        t = J;
                                    }while (null !== t);
                                }
                            }
                            V = f;
                        }
                    }
                    if (0 !== (f.subtreeFlags & 2064) && null !== g) g.return = f, V = g;
                    else b: for(; null !== V;){
                        f = V;
                        if (0 !== (f.flags & 2048)) switch(f.tag){
                            case 0:
                            case 11:
                            case 15:
                                Pj(9, f, f.return);
                        }
                        var x = f.sibling;
                        if (null !== x) {
                            x.return = f.return;
                            V = x;
                            break b;
                        }
                        V = f.return;
                    }
                }
                var w = a.current;
                for(V = w; null !== V;){
                    g = V;
                    var u = g.child;
                    if (0 !== (g.subtreeFlags & 2064) && null !== u) u.return = g, V = u;
                    else b: for(g = w; null !== V;){
                        h = V;
                        if (0 !== (h.flags & 2048)) try {
                            switch(h.tag){
                                case 0:
                                case 11:
                                case 15:
                                    Qj(9, h);
                            }
                        } catch (na) {
                            W(h, h.return, na);
                        }
                        if (h === g) {
                            V = null;
                            break b;
                        }
                        var F = h.sibling;
                        if (null !== F) {
                            F.return = h.return;
                            V = F;
                            break b;
                        }
                        V = h.return;
                    }
                }
                K = e;
                jg();
                if (lc && "function" === typeof lc.onPostCommitFiberRoot) try {
                    lc.onPostCommitFiberRoot(kc, a);
                } catch (na) {}
                d = !0;
            }
            return d;
        } finally{
            C = c, ok.transition = b;
        }
    }
    return !1;
}
function Xk(a, b, c) {
    b = Ji(c, b);
    b = Ni(a, b, 1);
    a = nh(a, b, 1);
    b = R();
    null !== a && (Ac(a, 1, b), Dk(a, b));
}
function W(a, b, c) {
    if (3 === a.tag) Xk(a, a, c);
    else for(; null !== b;){
        if (3 === b.tag) {
            Xk(b, a, c);
            break;
        } else if (1 === b.tag) {
            var d = b.stateNode;
            if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === Ri || !Ri.has(d))) {
                a = Ji(c, a);
                a = Qi(b, a, 1);
                b = nh(b, a, 1);
                a = R();
                null !== b && (Ac(b, 1, a), Dk(b, a));
                break;
            }
        }
        b = b.return;
    }
}
function Ti(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = R();
    a.pingedLanes |= a.suspendedLanes & c;
    Q === a && (Z & c) === c && (4 === T || 3 === T && (Z & 130023424) === Z && 500 > B() - fk ? Kk(a, 0) : rk |= c);
    Dk(a, b);
}
function Yk(a, b) {
    0 === b && (0 === (a.mode & 1) ? b = 1 : (b = sc, sc <<= 1, 0 === (sc & 130023424) && (sc = 4194304)));
    var c = R();
    a = ih(a, b);
    null !== a && (Ac(a, b, c), Dk(a, c));
}
function uj(a) {
    var b = a.memoizedState, c = 0;
    null !== b && (c = b.retryLane);
    Yk(a, c);
}
function bk(a, b) {
    var c = 0;
    switch(a.tag){
        case 13:
            var d = a.stateNode;
            var e = a.memoizedState;
            null !== e && (c = e.retryLane);
            break;
        case 19:
            d = a.stateNode;
            break;
        default:
            throw Error(p(314));
    }
    null !== d && d.delete(b);
    Yk(a, c);
}
var Vk;
Vk = function(a, b, c) {
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || Wf.current) dh = !0;
        else {
            if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return dh = !1, yj(a, b, c);
            dh = 0 !== (a.flags & 131072) ? !0 : !1;
        }
    } else dh = !1, I && 0 !== (b.flags & 1048576) && ug(b, ng, b.index);
    b.lanes = 0;
    switch(b.tag){
        case 2:
            var d = b.type;
            ij(a, b);
            a = b.pendingProps;
            var e = Yf(b, H.current);
            ch(b, c);
            e = Nh(null, b, d, a, e, c);
            var f = Sh();
            b.flags |= 1;
            "object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, Zf(d) ? (f = !0, cg(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, kh(b), e.updater = Ei, b.stateNode = e, e._reactInternals = b, Ii(b, d, a, c), b = jj(null, b, d, !0, f, c)) : (b.tag = 0, I && f && vg(b), Xi(null, b, e, c), b = b.child);
            return b;
        case 16:
            d = b.elementType;
            a: {
                ij(a, b);
                a = b.pendingProps;
                e = d._init;
                d = e(d._payload);
                b.type = d;
                e = b.tag = Zk(d);
                a = Ci(d, a);
                switch(e){
                    case 0:
                        b = cj(null, b, d, a, c);
                        break a;
                    case 1:
                        b = hj(null, b, d, a, c);
                        break a;
                    case 11:
                        b = Yi(null, b, d, a, c);
                        break a;
                    case 14:
                        b = $i(null, b, d, Ci(d.type, a), c);
                        break a;
                }
                throw Error(p(306, d, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : Ci(d, e), cj(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : Ci(d, e), hj(a, b, d, e, c);
        case 3:
            a: {
                kj(b);
                if (null === a) throw Error(p(387));
                d = b.pendingProps;
                f = b.memoizedState;
                e = f.element;
                lh(a, b);
                qh(b, d, null, c);
                var g = b.memoizedState;
                d = g.element;
                if (f.isDehydrated) {
                    if (f = {
                        element: d,
                        isDehydrated: !1,
                        cache: g.cache,
                        pendingSuspenseBoundaries: g.pendingSuspenseBoundaries,
                        transitions: g.transitions
                    }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                        e = Ji(Error(p(423)), b);
                        b = lj(a, b, d, c, e);
                        break a;
                    } else if (d !== e) {
                        e = Ji(Error(p(424)), b);
                        b = lj(a, b, d, c, e);
                        break a;
                    } else for(yg = Lf(b.stateNode.containerInfo.firstChild), xg = b, I = !0, zg = null, c = Vg(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                } else {
                    Ig();
                    if (d === e) {
                        b = Zi(a, b, c);
                        break a;
                    }
                    Xi(a, b, d, c);
                }
                b = b.child;
            }
            return b;
        case 5:
            return Ah(b), null === a && Eg(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, Ef(d, e) ? g = null : null !== f && Ef(d, f) && (b.flags |= 32), gj(a, b), Xi(a, b, g, c), b.child;
        case 6:
            return null === a && Eg(b), null;
        case 13:
            return oj(a, b, c);
        case 4:
            return yh(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = Ug(b, null, d, c) : Xi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : Ci(d, e), Yi(a, b, d, e, c);
        case 7:
            return Xi(a, b, b.pendingProps, c), b.child;
        case 8:
            return Xi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return Xi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                f = b.memoizedProps;
                g = e.value;
                G(Wg, d._currentValue);
                d._currentValue = g;
                if (null !== f) {
                    if (He(f.value, g)) {
                        if (f.children === e.children && !Wf.current) {
                            b = Zi(a, b, c);
                            break a;
                        }
                    } else for(f = b.child, null !== f && (f.return = b); null !== f;){
                        var h = f.dependencies;
                        if (null !== h) {
                            g = f.child;
                            for(var k = h.firstContext; null !== k;){
                                if (k.context === d) {
                                    if (1 === f.tag) {
                                        k = mh(-1, c & -c);
                                        k.tag = 2;
                                        var l = f.updateQueue;
                                        if (null !== l) {
                                            l = l.shared;
                                            var m = l.pending;
                                            null === m ? k.next = k : (k.next = m.next, m.next = k);
                                            l.pending = k;
                                        }
                                    }
                                    f.lanes |= c;
                                    k = f.alternate;
                                    null !== k && (k.lanes |= c);
                                    bh(f.return, c, b);
                                    h.lanes |= c;
                                    break;
                                }
                                k = k.next;
                            }
                        } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                        else if (18 === f.tag) {
                            g = f.return;
                            if (null === g) throw Error(p(341));
                            g.lanes |= c;
                            h = g.alternate;
                            null !== h && (h.lanes |= c);
                            bh(g, c, b);
                            g = f.sibling;
                        } else g = f.child;
                        if (null !== g) g.return = f;
                        else for(g = f; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            f = g.sibling;
                            if (null !== f) {
                                f.return = g.return;
                                g = f;
                                break;
                            }
                            g = g.return;
                        }
                        f = g;
                    }
                }
                Xi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, d = b.pendingProps.children, ch(b, c), e = eh(e), d = d(e), b.flags |= 1, Xi(a, b, d, c), b.child;
        case 14:
            return d = b.type, e = Ci(d, b.pendingProps), e = Ci(d.type, e), $i(a, b, d, e, c);
        case 15:
            return bj(a, b, b.type, b.pendingProps, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : Ci(d, e), ij(a, b), b.tag = 1, Zf(d) ? (a = !0, cg(b)) : a = !1, ch(b, c), Gi(b, d, e), Ii(b, d, e, c), jj(null, b, d, !0, a, c);
        case 19:
            return xj(a, b, c);
        case 22:
            return dj(a, b, c);
    }
    throw Error(p(156, b.tag));
};
function Fk(a, b) {
    return ac(a, b);
}
function $k(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function Bg(a, b, c, d) {
    return new $k(a, b, c, d);
}
function aj(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function Zk(a) {
    if ("function" === typeof a) return aj(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === Da) return 11;
        if (a === Ga) return 14;
    }
    return 2;
}
function Pg(a, b) {
    var c = a.alternate;
    null === c ? (c = Bg(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null);
    c.flags = a.flags & 14680064;
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function Rg(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) aj(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case ya:
            return Tg(c.children, e, f, b);
        case za:
            g = 8;
            e |= 8;
            break;
        case Aa:
            return a = Bg(12, c, b, e | 2), a.elementType = Aa, a.lanes = f, a;
        case Ea:
            return a = Bg(13, c, b, e), a.elementType = Ea, a.lanes = f, a;
        case Fa:
            return a = Bg(19, c, b, e), a.elementType = Fa, a.lanes = f, a;
        case Ia:
            return pj(c, e, f, b);
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case Ba:
                    g = 10;
                    break a;
                case Ca:
                    g = 9;
                    break a;
                case Da:
                    g = 11;
                    break a;
                case Ga:
                    g = 14;
                    break a;
                case Ha:
                    g = 16;
                    d = null;
                    break a;
            }
            throw Error(p(130, null == a ? a : typeof a, ""));
    }
    b = Bg(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function Tg(a, b, c, d) {
    a = Bg(7, a, d, b);
    a.lanes = c;
    return a;
}
function pj(a, b, c, d) {
    a = Bg(22, a, d, b);
    a.elementType = Ia;
    a.lanes = c;
    a.stateNode = {
        isHidden: !1
    };
    return a;
}
function Qg(a, b, c) {
    a = Bg(6, a, null, b);
    a.lanes = c;
    return a;
}
function Sg(a, b, c) {
    b = Bg(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function al(a, b, c, d, e) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.pendingContext = this.context = null;
    this.callbackPriority = 0;
    this.eventTimes = zc(0);
    this.expirationTimes = zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = zc(0);
    this.identifierPrefix = d;
    this.onRecoverableError = e;
    this.mutableSourceEagerHydrationData = null;
}
function bl(a, b, c, d, e, f, g, h, k) {
    a = new al(a, b, c, h, k);
    1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
    f = Bg(3, null, null, b);
    a.current = f;
    f.stateNode = a;
    f.memoizedState = {
        element: d,
        isDehydrated: c,
        cache: null,
        transitions: null,
        pendingSuspenseBoundaries: null
    };
    kh(f);
    return a;
}
function cl(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: wa,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function dl(a) {
    if (!a) return Vf;
    a = a._reactInternals;
    a: {
        if (Vb(a) !== a || 1 !== a.tag) throw Error(p(170));
        var b = a;
        do {
            switch(b.tag){
                case 3:
                    b = b.stateNode.context;
                    break a;
                case 1:
                    if (Zf(b.type)) {
                        b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                        break a;
                    }
            }
            b = b.return;
        }while (null !== b);
        throw Error(p(171));
    }
    if (1 === a.tag) {
        var c = a.type;
        if (Zf(c)) return bg(a, c, b);
    }
    return b;
}
function el(a, b, c, d, e, f, g, h, k) {
    a = bl(c, d, !0, a, e, f, g, h, k);
    a.context = dl(null);
    c = a.current;
    d = R();
    e = yi(c);
    f = mh(d, e);
    f.callback = void 0 !== b && null !== b ? b : null;
    nh(c, f, e);
    a.current.lanes = e;
    Ac(a, e, d);
    Dk(a, d);
    return a;
}
function fl(a, b, c, d) {
    var e = b.current, f = R(), g = yi(e);
    c = dl(c);
    null === b.context ? b.context = c : b.pendingContext = c;
    b = mh(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    a = nh(e, b, g);
    null !== a && (gi(a, e, g, f), oh(a, e, g));
    return g;
}
function gl(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function hl(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function il(a, b) {
    hl(a, b);
    (a = a.alternate) && hl(a, b);
}
function jl() {
    return null;
}
var kl = "function" === typeof reportError ? reportError : function(a) {
    console.error(a);
};
function ll(a) {
    this._internalRoot = a;
}
ml.prototype.render = ll.prototype.render = function(a) {
    var b = this._internalRoot;
    if (null === b) throw Error(p(409));
    fl(a, b, null, null);
};
ml.prototype.unmount = ll.prototype.unmount = function() {
    var a = this._internalRoot;
    if (null !== a) {
        this._internalRoot = null;
        var b = a.containerInfo;
        Rk(function() {
            fl(null, a, null, null);
        });
        b[uf] = null;
    }
};
function ml(a) {
    this._internalRoot = a;
}
ml.prototype.unstable_scheduleHydration = function(a) {
    if (a) {
        var b = Hc();
        a = {
            blockedOn: null,
            target: a,
            priority: b
        };
        for(var c = 0; c < Qc.length && 0 !== b && b < Qc[c].priority; c++);
        Qc.splice(c, 0, a);
        0 === c && Vc(a);
    }
};
function nl(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
}
function ol(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function pl() {}
function ql(a, b, c, d, e) {
    if (e) {
        if ("function" === typeof d) {
            var f = d;
            d = function() {
                var a = gl(g);
                f.call(a);
            };
        }
        var g = el(b, d, a, 0, null, !1, !1, "", pl);
        a._reactRootContainer = g;
        a[uf] = g.current;
        sf(8 === a.nodeType ? a.parentNode : a);
        Rk();
        return g;
    }
    for(; e = a.lastChild;)a.removeChild(e);
    if ("function" === typeof d) {
        var h = d;
        d = function() {
            var a = gl(k);
            h.call(a);
        };
    }
    var k = bl(a, 0, !1, null, null, !1, !1, "", pl);
    a._reactRootContainer = k;
    a[uf] = k.current;
    sf(8 === a.nodeType ? a.parentNode : a);
    Rk(function() {
        fl(b, k, c, d);
    });
    return k;
}
function rl(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = gl(g);
                h.call(a);
            };
        }
        fl(b, g, a, e);
    } else g = ql(c, b, a, e, d);
    return gl(g);
}
Ec = function(a) {
    switch(a.tag){
        case 3:
            var b = a.stateNode;
            if (b.current.memoizedState.isDehydrated) {
                var c = tc(b.pendingLanes);
                0 !== c && (Cc(b, c | 1), Dk(b, B()), 0 === (K & 6) && (Gj = B() + 500, jg()));
            }
            break;
        case 13:
            Rk(function() {
                var b = ih(a, 1);
                if (null !== b) {
                    var c = R();
                    gi(b, a, 1, c);
                }
            }), il(a, 1);
    }
};
Fc = function(a) {
    if (13 === a.tag) {
        var b = ih(a, 134217728);
        if (null !== b) {
            var c = R();
            gi(b, a, 134217728, c);
        }
        il(a, 134217728);
    }
};
Gc = function(a) {
    if (13 === a.tag) {
        var b = yi(a), c = ih(a, b);
        if (null !== c) {
            var d = R();
            gi(c, a, b, d);
        }
        il(a, b);
    }
};
Hc = function() {
    return C;
};
Ic = function(a, b) {
    var c = C;
    try {
        return C = a, b();
    } finally{
        C = c;
    }
};
yb = function(a, b, c) {
    switch(b){
        case "input":
            bb(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = Db(d);
                        if (!e) throw Error(p(90));
                        Wa(d);
                        bb(d, e);
                    }
                }
            }
            break;
        case "textarea":
            ib(a, c);
            break;
        case "select":
            b = c.value, null != b && fb(a, !!c.multiple, b, !1);
    }
};
Gb = Qk;
Hb = Rk;
var sl = {
    usingClientEntryPoint: !1,
    Events: [
        Cb,
        ue,
        Db,
        Eb,
        Fb,
        Qk
    ]
}, tl = {
    findFiberByHostInstance: Wc,
    bundleType: 0,
    version: "18.3.1",
    rendererPackageName: "react-dom"
};
var ul = {
    bundleType: tl.bundleType,
    version: tl.version,
    rendererPackageName: tl.rendererPackageName,
    rendererConfig: tl.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: ua.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = Zb(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: tl.findFiberByHostInstance || jl,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: "18.3.1-next-f1338f8080-20240426"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var vl = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!vl.isDisabled && vl.supportsFiber) try {
        kc = vl.inject(ul), lc = vl;
    } catch (a) {}
}
exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = sl;
exports.createPortal = function(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!nl(b)) throw Error(p(200));
    return cl(a, b, null, c);
};
exports.createRoot = function(a, b) {
    if (!nl(a)) throw Error(p(299));
    var c = !1, d = "", e = kl;
    null !== b && void 0 !== b && (!0 === b.unstable_strictMode && (c = !0), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
    b = bl(a, 1, !1, null, null, c, !1, d, e);
    a[uf] = b.current;
    sf(8 === a.nodeType ? a.parentNode : a);
    return new ll(b);
};
exports.findDOMNode = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error(p(188));
        a = Object.keys(a).join(",");
        throw Error(p(268, a));
    }
    a = Zb(b);
    a = null === a ? null : a.stateNode;
    return a;
};
exports.flushSync = function(a) {
    return Rk(a);
};
exports.hydrate = function(a, b, c) {
    if (!ol(b)) throw Error(p(200));
    return rl(null, a, b, !0, c);
};
exports.hydrateRoot = function(a, b, c) {
    if (!nl(a)) throw Error(p(405));
    var d = null != c && c.hydratedSources || null, e = !1, f = "", g = kl;
    null !== c && void 0 !== c && (!0 === c.unstable_strictMode && (e = !0), void 0 !== c.identifierPrefix && (f = c.identifierPrefix), void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
    b = el(b, null, a, 1, null != c ? c : null, e, !1, f, g);
    a[uf] = b.current;
    sf(a);
    if (d) for(a = 0; a < d.length; a++)c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [
        c,
        e
    ] : b.mutableSourceEagerHydrationData.push(c, e);
    return new ml(b);
};
exports.render = function(a, b, c) {
    if (!ol(b)) throw Error(p(200));
    return rl(null, a, b, !1, c);
};
exports.unmountComponentAtNode = function(a) {
    if (!ol(a)) throw Error(p(40));
    return a._reactRootContainer ? (Rk(function() {
        rl(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[uf] = null;
        });
    }), !0) : !1;
};
exports.unstable_batchedUpdates = Qk;
exports.unstable_renderSubtreeIntoContainer = function(a, b, c, d) {
    if (!ol(c)) throw Error(p(200));
    if (null == a || void 0 === a._reactInternals) throw Error(p(38));
    return rl(a, b, c, !1, d);
};
exports.version = "18.3.1-next-f1338f8080-20240426";

},{"5393afc8c463ef07":"6uln9","ece50e903283a22f":"jNZm8"}],"jNZm8":[function(require,module,exports) {
"use strict";
module.exports = require("15840f0beed8ff36");

},{"15840f0beed8ff36":"izQ2Z"}],"izQ2Z":[function(require,module,exports) {
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
function f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function h(a) {
    return 0 === a.length ? null : a[0];
}
function k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, w = e >>> 1; d < w;){
            var m = 2 * (d + 1) - 1, C = a[m], n = m + 1, x = a[n];
            if (0 > g(C, c)) n < e && 0 > g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);
            else if (n < e && 0 > g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
if ("object" === typeof performance && "function" === typeof performance.now) {
    var l = performance;
    exports.unstable_now = function() {
        return l.now();
    };
} else {
    var p = Date, q = p.now();
    exports.unstable_now = function() {
        return p.now() - q;
    };
}
var r = [], t = [], u = 1, v = null, y = 3, z = !1, A = !1, B = !1, D = "function" === typeof setTimeout ? setTimeout : null, E = "function" === typeof clearTimeout ? clearTimeout : null, F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function G(a) {
    for(var b = h(t); null !== b;){
        if (null === b.callback) k(t);
        else if (b.startTime <= a) k(t), b.sortIndex = b.expirationTime, f(r, b);
        else break;
        b = h(t);
    }
}
function H(a) {
    B = !1;
    G(a);
    if (!A) {
        if (null !== h(r)) A = !0, I(J);
        else {
            var b = h(t);
            null !== b && K(H, b.startTime - a);
        }
    }
}
function J(a, b) {
    A = !1;
    B && (B = !1, E(L), L = -1);
    z = !0;
    var c = y;
    try {
        G(b);
        for(v = h(r); null !== v && (!(v.expirationTime > b) || a && !M());){
            var d = v.callback;
            if ("function" === typeof d) {
                v.callback = null;
                y = v.priorityLevel;
                var e = d(v.expirationTime <= b);
                b = exports.unstable_now();
                "function" === typeof e ? v.callback = e : v === h(r) && k(r);
                G(b);
            } else k(r);
            v = h(r);
        }
        if (null !== v) var w = !0;
        else {
            var m = h(t);
            null !== m && K(H, m.startTime - b);
            w = !1;
        }
        return w;
    } finally{
        v = null, y = c, z = !1;
    }
}
var N = !1, O = null, L = -1, P = 5, Q = -1;
function M() {
    return exports.unstable_now() - Q < P ? !1 : !0;
}
function R() {
    if (null !== O) {
        var a = exports.unstable_now();
        Q = a;
        var b = !0;
        try {
            b = O(!0, a);
        } finally{
            b ? S() : (N = !1, O = null);
        }
    } else N = !1;
}
var S;
if ("function" === typeof F) S = function() {
    F(R);
};
else if ("undefined" !== typeof MessageChannel) {
    var T = new MessageChannel, U = T.port2;
    T.port1.onmessage = R;
    S = function() {
        U.postMessage(null);
    };
} else S = function() {
    D(R, 0);
};
function I(a) {
    O = a;
    N || (N = !0, S());
}
function K(a, b) {
    L = D(function() {
        a(exports.unstable_now());
    }, b);
}
exports.unstable_IdlePriority = 5;
exports.unstable_ImmediatePriority = 1;
exports.unstable_LowPriority = 4;
exports.unstable_NormalPriority = 3;
exports.unstable_Profiling = null;
exports.unstable_UserBlockingPriority = 2;
exports.unstable_cancelCallback = function(a) {
    a.callback = null;
};
exports.unstable_continueExecution = function() {
    A || z || (A = !0, I(J));
};
exports.unstable_forceFrameRate = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : P = 0 < a ? Math.floor(1E3 / a) : 5;
};
exports.unstable_getCurrentPriorityLevel = function() {
    return y;
};
exports.unstable_getFirstCallbackNode = function() {
    return h(r);
};
exports.unstable_next = function(a) {
    switch(y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = y;
    }
    var c = y;
    y = b;
    try {
        return a();
    } finally{
        y = c;
    }
};
exports.unstable_pauseExecution = function() {};
exports.unstable_requestPaint = function() {};
exports.unstable_runWithPriority = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = y;
    y = a;
    try {
        return b();
    } finally{
        y = c;
    }
};
exports.unstable_scheduleCallback = function(a, b, c) {
    var d = exports.unstable_now();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: u++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, f(t, a), null === h(r) && a === h(t) && (B ? (E(L), L = -1) : B = !0, K(H, c - d))) : (a.sortIndex = e, f(r, a), A || z || (A = !0, I(J)));
    return a;
};
exports.unstable_shouldYield = M;
exports.unstable_wrapCallback = function(a) {
    var b = y;
    return function() {
        var c = y;
        y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            y = c;
        }
    };
};

},{}],"5ccwt":[function(require,module,exports) {
"use strict";
var m = require("aaccff5d309d9239");
var i;
exports.createRoot = m.createRoot;
exports.hydrateRoot = m.hydrateRoot;

},{"aaccff5d309d9239":"b8T3j"}],"5fzqq":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MemoryRouter", ()=>(0, _reactRouter.MemoryRouter));
parcelHelpers.export(exports, "Prompt", ()=>(0, _reactRouter.Prompt));
parcelHelpers.export(exports, "Redirect", ()=>(0, _reactRouter.Redirect));
parcelHelpers.export(exports, "Route", ()=>(0, _reactRouter.Route));
parcelHelpers.export(exports, "Router", ()=>(0, _reactRouter.Router));
parcelHelpers.export(exports, "StaticRouter", ()=>(0, _reactRouter.StaticRouter));
parcelHelpers.export(exports, "Switch", ()=>(0, _reactRouter.Switch));
parcelHelpers.export(exports, "generatePath", ()=>(0, _reactRouter.generatePath));
parcelHelpers.export(exports, "matchPath", ()=>(0, _reactRouter.matchPath));
parcelHelpers.export(exports, "useHistory", ()=>(0, _reactRouter.useHistory));
parcelHelpers.export(exports, "useLocation", ()=>(0, _reactRouter.useLocation));
parcelHelpers.export(exports, "useParams", ()=>(0, _reactRouter.useParams));
parcelHelpers.export(exports, "useRouteMatch", ()=>(0, _reactRouter.useRouteMatch));
parcelHelpers.export(exports, "withRouter", ()=>(0, _reactRouter.withRouter));
parcelHelpers.export(exports, "BrowserRouter", ()=>BrowserRouter);
parcelHelpers.export(exports, "HashRouter", ()=>HashRouter);
parcelHelpers.export(exports, "Link", ()=>Link);
parcelHelpers.export(exports, "NavLink", ()=>NavLink);
var _reactRouter = require("react-router");
var _inheritsLoose = require("@babel/runtime/helpers/esm/inheritsLoose");
var _inheritsLooseDefault = parcelHelpers.interopDefault(_inheritsLoose);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _history = require("history");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _tinyWarning = require("tiny-warning");
var _tinyWarningDefault = parcelHelpers.interopDefault(_tinyWarning);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _tinyInvariant = require("tiny-invariant");
var _tinyInvariantDefault = parcelHelpers.interopDefault(_tinyInvariant);
/**
 * The public API for a <Router> that uses HTML5 history.
 */ var BrowserRouter = /*#__PURE__*/ function(_React$Component) {
    (0, _inheritsLooseDefault.default)(BrowserRouter, _React$Component);
    function BrowserRouter() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.history = (0, _history.createBrowserHistory)(_this.props);
        return _this;
    }
    var _proto = BrowserRouter.prototype;
    _proto.render = function render() {
        return (0, _reactDefault.default).createElement((0, _reactRouter.Router), {
            history: this.history,
            children: this.props.children
        });
    };
    return BrowserRouter;
}((0, _reactDefault.default).Component);
/**
 * The public API for a <Router> that uses window.location.hash.
 */ var HashRouter = /*#__PURE__*/ function(_React$Component) {
    (0, _inheritsLooseDefault.default)(HashRouter, _React$Component);
    function HashRouter() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.history = (0, _history.createHashHistory)(_this.props);
        return _this;
    }
    var _proto = HashRouter.prototype;
    _proto.render = function render() {
        return (0, _reactDefault.default).createElement((0, _reactRouter.Router), {
            history: this.history,
            children: this.props.children
        });
    };
    return HashRouter;
}((0, _reactDefault.default).Component);
var resolveToLocation = function resolveToLocation(to, currentLocation) {
    return typeof to === "function" ? to(currentLocation) : to;
};
var normalizeToLocation = function normalizeToLocation(to, currentLocation) {
    return typeof to === "string" ? (0, _history.createLocation)(to, null, null, currentLocation) : to;
};
var forwardRefShim = function forwardRefShim(C) {
    return C;
};
var forwardRef = (0, _reactDefault.default).forwardRef;
if (typeof forwardRef === "undefined") forwardRef = forwardRefShim;
function isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
var LinkAnchor = forwardRef(function(_ref, forwardedRef) {
    var innerRef = _ref.innerRef, navigate = _ref.navigate, _onClick = _ref.onClick, rest = (0, _objectWithoutPropertiesLooseDefault.default)(_ref, [
        "innerRef",
        "navigate",
        "onClick"
    ]);
    var target = rest.target;
    var props = (0, _extendsDefault.default)({}, rest, {
        onClick: function onClick(event) {
            try {
                if (_onClick) _onClick(event);
            } catch (ex) {
                event.preventDefault();
                throw ex;
            }
            if (!event.defaultPrevented && // onClick prevented default
            event.button === 0 && (!target || target === "_self") && // let browser handle "target=_blank" etc.
            !isModifiedEvent(event) // ignore clicks with modifier keys
            ) {
                event.preventDefault();
                navigate();
            }
        }
    }); // React 15 compat
    if (forwardRefShim !== forwardRef) props.ref = forwardedRef || innerRef;
    else props.ref = innerRef;
    /* eslint-disable-next-line jsx-a11y/anchor-has-content */ return (0, _reactDefault.default).createElement("a", props);
});
/**
 * The public API for rendering a history-aware <a>.
 */ var Link = forwardRef(function(_ref2, forwardedRef) {
    var _ref2$component = _ref2.component, component = _ref2$component === void 0 ? LinkAnchor : _ref2$component, replace = _ref2.replace, to = _ref2.to, innerRef = _ref2.innerRef, rest = (0, _objectWithoutPropertiesLooseDefault.default)(_ref2, [
        "component",
        "replace",
        "to",
        "innerRef"
    ]);
    return (0, _reactDefault.default).createElement((0, _reactRouter.__RouterContext).Consumer, null, function(context) {
        !context && (0, _tinyInvariantDefault.default)(false);
        var history = context.history;
        var location = normalizeToLocation(resolveToLocation(to, context.location), context.location);
        var href = location ? history.createHref(location) : "";
        var props = (0, _extendsDefault.default)({}, rest, {
            href: href,
            navigate: function navigate() {
                var location = resolveToLocation(to, context.location);
                var method = replace ? history.replace : history.push;
                method(location);
            }
        }); // React 15 compat
        if (forwardRefShim !== forwardRef) props.ref = forwardedRef || innerRef;
        else props.innerRef = innerRef;
        return (0, _reactDefault.default).createElement(component, props);
    });
});
var toType, refType;
var forwardRefShim$1 = function forwardRefShim(C) {
    return C;
};
var forwardRef$1 = (0, _reactDefault.default).forwardRef;
if (typeof forwardRef$1 === "undefined") forwardRef$1 = forwardRefShim$1;
function joinClassnames() {
    for(var _len = arguments.length, classnames = new Array(_len), _key = 0; _key < _len; _key++)classnames[_key] = arguments[_key];
    return classnames.filter(function(i) {
        return i;
    }).join(" ");
}
/**
 * A <Link> wrapper that knows if it's "active" or not.
 */ var NavLink = forwardRef$1(function(_ref, forwardedRef) {
    var _ref$ariaCurrent = _ref["aria-current"], ariaCurrent = _ref$ariaCurrent === void 0 ? "page" : _ref$ariaCurrent, _ref$activeClassName = _ref.activeClassName, activeClassName = _ref$activeClassName === void 0 ? "active" : _ref$activeClassName, activeStyle = _ref.activeStyle, classNameProp = _ref.className, exact = _ref.exact, isActiveProp = _ref.isActive, locationProp = _ref.location, sensitive = _ref.sensitive, strict = _ref.strict, styleProp = _ref.style, to = _ref.to, innerRef = _ref.innerRef, rest = (0, _objectWithoutPropertiesLooseDefault.default)(_ref, [
        "aria-current",
        "activeClassName",
        "activeStyle",
        "className",
        "exact",
        "isActive",
        "location",
        "sensitive",
        "strict",
        "style",
        "to",
        "innerRef"
    ]);
    return (0, _reactDefault.default).createElement((0, _reactRouter.__RouterContext).Consumer, null, function(context) {
        !context && (0, _tinyInvariantDefault.default)(false);
        var currentLocation = locationProp || context.location;
        var toLocation = normalizeToLocation(resolveToLocation(to, currentLocation), currentLocation);
        var path = toLocation.pathname; // Regex taken from: https://github.com/pillarjs/path-to-regexp/blob/master/index.js#L202
        var escapedPath = path && path.replace(/([.+*?=^!:${}()[\]|/\\])/g, "\\$1");
        var match = escapedPath ? (0, _reactRouter.matchPath)(currentLocation.pathname, {
            path: escapedPath,
            exact: exact,
            sensitive: sensitive,
            strict: strict
        }) : null;
        var isActive = !!(isActiveProp ? isActiveProp(match, currentLocation) : match);
        var className = isActive ? joinClassnames(classNameProp, activeClassName) : classNameProp;
        var style = isActive ? (0, _extendsDefault.default)({}, styleProp, {}, activeStyle) : styleProp;
        var props = (0, _extendsDefault.default)({
            "aria-current": isActive && ariaCurrent || null,
            className: className,
            style: style,
            to: toLocation
        }, rest); // React 15 compat
        if (forwardRefShim$1 !== forwardRef$1) props.ref = forwardedRef || innerRef;
        else props.innerRef = innerRef;
        return (0, _reactDefault.default).createElement(Link, props);
    });
});
var ariaCurrentType;

},{"react-router":"i3TiW","@babel/runtime/helpers/esm/inheritsLoose":"9IZpV","react":"6uln9","history":"grwqf","prop-types":"6FKs7","tiny-warning":"328jC","@babel/runtime/helpers/esm/extends":"fW5l8","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"5R6Zx","tiny-invariant":"dPEnp","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"i3TiW":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MemoryRouter", ()=>MemoryRouter);
parcelHelpers.export(exports, "Prompt", ()=>Prompt);
parcelHelpers.export(exports, "Redirect", ()=>Redirect);
parcelHelpers.export(exports, "Route", ()=>Route);
parcelHelpers.export(exports, "Router", ()=>Router);
parcelHelpers.export(exports, "StaticRouter", ()=>StaticRouter);
parcelHelpers.export(exports, "Switch", ()=>Switch);
parcelHelpers.export(exports, "__HistoryContext", ()=>historyContext);
parcelHelpers.export(exports, "__RouterContext", ()=>context);
parcelHelpers.export(exports, "generatePath", ()=>generatePath);
parcelHelpers.export(exports, "matchPath", ()=>matchPath);
parcelHelpers.export(exports, "useHistory", ()=>useHistory);
parcelHelpers.export(exports, "useLocation", ()=>useLocation);
parcelHelpers.export(exports, "useParams", ()=>useParams);
parcelHelpers.export(exports, "useRouteMatch", ()=>useRouteMatch);
parcelHelpers.export(exports, "withRouter", ()=>withRouter);
var _inheritsLoose = require("@babel/runtime/helpers/esm/inheritsLoose");
var _inheritsLooseDefault = parcelHelpers.interopDefault(_inheritsLoose);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _history = require("history");
var _tinyWarning = require("tiny-warning");
var _tinyWarningDefault = parcelHelpers.interopDefault(_tinyWarning);
var _miniCreateReactContext = require("mini-create-react-context");
var _miniCreateReactContextDefault = parcelHelpers.interopDefault(_miniCreateReactContext);
var _tinyInvariant = require("tiny-invariant");
var _tinyInvariantDefault = parcelHelpers.interopDefault(_tinyInvariant);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _pathToRegexp = require("path-to-regexp");
var _pathToRegexpDefault = parcelHelpers.interopDefault(_pathToRegexp);
var _reactIs = require("react-is");
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _hoistNonReactStatics = require("hoist-non-react-statics");
var _hoistNonReactStaticsDefault = parcelHelpers.interopDefault(_hoistNonReactStatics);
// TODO: Replace with React.createContext once we can assume React 16+
var createNamedContext = function createNamedContext(name) {
    var context = (0, _miniCreateReactContextDefault.default)();
    context.displayName = name;
    return context;
};
var historyContext = /*#__PURE__*/ createNamedContext("Router-History");
// TODO: Replace with React.createContext once we can assume React 16+
var createNamedContext$1 = function createNamedContext(name) {
    var context = (0, _miniCreateReactContextDefault.default)();
    context.displayName = name;
    return context;
};
var context = /*#__PURE__*/ createNamedContext$1("Router");
/**
 * The public API for putting history on context.
 */ var Router = /*#__PURE__*/ function(_React$Component) {
    (0, _inheritsLooseDefault.default)(Router, _React$Component);
    Router.computeRootMatch = function computeRootMatch(pathname) {
        return {
            path: "/",
            url: "/",
            params: {},
            isExact: pathname === "/"
        };
    };
    function Router(props) {
        var _this;
        _this = _React$Component.call(this, props) || this;
        _this.state = {
            location: props.history.location
        }; // This is a bit of a hack. We have to start listening for location
        // changes here in the constructor in case there are any <Redirect>s
        // on the initial render. If there are, they will replace/push when
        // they mount and since cDM fires in children before parents, we may
        // get a new location before the <Router> is mounted.
        _this._isMounted = false;
        _this._pendingLocation = null;
        if (!props.staticContext) _this.unlisten = props.history.listen(function(location) {
            if (_this._isMounted) _this.setState({
                location: location
            });
            else _this._pendingLocation = location;
        });
        return _this;
    }
    var _proto = Router.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this._isMounted = true;
        if (this._pendingLocation) this.setState({
            location: this._pendingLocation
        });
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        if (this.unlisten) this.unlisten();
    };
    _proto.render = function render() {
        return (0, _reactDefault.default).createElement(context.Provider, {
            value: {
                history: this.props.history,
                location: this.state.location,
                match: Router.computeRootMatch(this.state.location.pathname),
                staticContext: this.props.staticContext
            }
        }, (0, _reactDefault.default).createElement(historyContext.Provider, {
            children: this.props.children || null,
            value: this.props.history
        }));
    };
    return Router;
}((0, _reactDefault.default).Component);
/**
 * The public API for a <Router> that stores location in memory.
 */ var MemoryRouter = /*#__PURE__*/ function(_React$Component) {
    (0, _inheritsLooseDefault.default)(MemoryRouter, _React$Component);
    function MemoryRouter() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.history = (0, _history.createMemoryHistory)(_this.props);
        return _this;
    }
    var _proto = MemoryRouter.prototype;
    _proto.render = function render() {
        return (0, _reactDefault.default).createElement(Router, {
            history: this.history,
            children: this.props.children
        });
    };
    return MemoryRouter;
}((0, _reactDefault.default).Component);
var Lifecycle = /*#__PURE__*/ function(_React$Component) {
    (0, _inheritsLooseDefault.default)(Lifecycle, _React$Component);
    function Lifecycle() {
        return _React$Component.apply(this, arguments) || this;
    }
    var _proto = Lifecycle.prototype;
    _proto.componentDidMount = function componentDidMount() {
        if (this.props.onMount) this.props.onMount.call(this, this);
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        if (this.props.onUpdate) this.props.onUpdate.call(this, this, prevProps);
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        if (this.props.onUnmount) this.props.onUnmount.call(this, this);
    };
    _proto.render = function render() {
        return null;
    };
    return Lifecycle;
}((0, _reactDefault.default).Component);
/**
 * The public API for prompting the user before navigating away from a screen.
 */ function Prompt(_ref) {
    var message = _ref.message, _ref$when = _ref.when, when = _ref$when === void 0 ? true : _ref$when;
    return (0, _reactDefault.default).createElement(context.Consumer, null, function(context) {
        !context && (0, _tinyInvariantDefault.default)(false);
        if (!when || context.staticContext) return null;
        var method = context.history.block;
        return (0, _reactDefault.default).createElement(Lifecycle, {
            onMount: function onMount(self) {
                self.release = method(message);
            },
            onUpdate: function onUpdate(self, prevProps) {
                if (prevProps.message !== message) {
                    self.release();
                    self.release = method(message);
                }
            },
            onUnmount: function onUnmount(self) {
                self.release();
            },
            message: message
        });
    });
}
var messageType;
var cache = {};
var cacheLimit = 10000;
var cacheCount = 0;
function compilePath(path) {
    if (cache[path]) return cache[path];
    var generator = (0, _pathToRegexpDefault.default).compile(path);
    if (cacheCount < cacheLimit) {
        cache[path] = generator;
        cacheCount++;
    }
    return generator;
}
/**
 * Public API for generating a URL pathname from a path and parameters.
 */ function generatePath(path, params) {
    if (path === void 0) path = "/";
    if (params === void 0) params = {};
    return path === "/" ? path : compilePath(path)(params, {
        pretty: true
    });
}
/**
 * The public API for navigating programmatically with a component.
 */ function Redirect(_ref) {
    var computedMatch = _ref.computedMatch, to = _ref.to, _ref$push = _ref.push, push = _ref$push === void 0 ? false : _ref$push;
    return (0, _reactDefault.default).createElement(context.Consumer, null, function(context) {
        !context && (0, _tinyInvariantDefault.default)(false);
        var history = context.history, staticContext = context.staticContext;
        var method = push ? history.push : history.replace;
        var location = (0, _history.createLocation)(computedMatch ? typeof to === "string" ? generatePath(to, computedMatch.params) : (0, _extendsDefault.default)({}, to, {
            pathname: generatePath(to.pathname, computedMatch.params)
        }) : to); // When rendering in a static context,
        // set the new location immediately.
        if (staticContext) {
            method(location);
            return null;
        }
        return (0, _reactDefault.default).createElement(Lifecycle, {
            onMount: function onMount() {
                method(location);
            },
            onUpdate: function onUpdate(self, prevProps) {
                var prevLocation = (0, _history.createLocation)(prevProps.to);
                if (!(0, _history.locationsAreEqual)(prevLocation, (0, _extendsDefault.default)({}, location, {
                    key: prevLocation.key
                }))) method(location);
            },
            to: to
        });
    });
}
var cache$1 = {};
var cacheLimit$1 = 10000;
var cacheCount$1 = 0;
function compilePath$1(path, options) {
    var cacheKey = "" + options.end + options.strict + options.sensitive;
    var pathCache = cache$1[cacheKey] || (cache$1[cacheKey] = {});
    if (pathCache[path]) return pathCache[path];
    var keys = [];
    var regexp = (0, _pathToRegexpDefault.default)(path, keys, options);
    var result = {
        regexp: regexp,
        keys: keys
    };
    if (cacheCount$1 < cacheLimit$1) {
        pathCache[path] = result;
        cacheCount$1++;
    }
    return result;
}
/**
 * Public API for matching a URL pathname to a path.
 */ function matchPath(pathname, options) {
    if (options === void 0) options = {};
    if (typeof options === "string" || Array.isArray(options)) options = {
        path: options
    };
    var _options = options, path = _options.path, _options$exact = _options.exact, exact = _options$exact === void 0 ? false : _options$exact, _options$strict = _options.strict, strict = _options$strict === void 0 ? false : _options$strict, _options$sensitive = _options.sensitive, sensitive = _options$sensitive === void 0 ? false : _options$sensitive;
    var paths = [].concat(path);
    return paths.reduce(function(matched, path) {
        if (!path && path !== "") return null;
        if (matched) return matched;
        var _compilePath = compilePath$1(path, {
            end: exact,
            strict: strict,
            sensitive: sensitive
        }), regexp = _compilePath.regexp, keys = _compilePath.keys;
        var match = regexp.exec(pathname);
        if (!match) return null;
        var url = match[0], values = match.slice(1);
        var isExact = pathname === url;
        if (exact && !isExact) return null;
        return {
            path: path,
            // the path used to match
            url: path === "/" && url === "" ? "/" : url,
            // the matched portion of the URL
            isExact: isExact,
            // whether or not we matched exactly
            params: keys.reduce(function(memo, key, index) {
                memo[key.name] = values[index];
                return memo;
            }, {})
        };
    }, null);
}
function isEmptyChildren(children) {
    return (0, _reactDefault.default).Children.count(children) === 0;
}
function evalChildrenDev(children, props, path) {
    var value = children(props);
    return value || null;
}
/**
 * The public API for matching a single path and rendering.
 */ var Route = /*#__PURE__*/ function(_React$Component) {
    (0, _inheritsLooseDefault.default)(Route, _React$Component);
    function Route() {
        return _React$Component.apply(this, arguments) || this;
    }
    var _proto = Route.prototype;
    _proto.render = function render() {
        var _this = this;
        return (0, _reactDefault.default).createElement(context.Consumer, null, function(context$1) {
            !context$1 && (0, _tinyInvariantDefault.default)(false);
            var location = _this.props.location || context$1.location;
            var match = _this.props.computedMatch ? _this.props.computedMatch // <Switch> already computed the match for us
             : _this.props.path ? matchPath(location.pathname, _this.props) : context$1.match;
            var props = (0, _extendsDefault.default)({}, context$1, {
                location: location,
                match: match
            });
            var _this$props = _this.props, children = _this$props.children, component = _this$props.component, render = _this$props.render; // Preact uses an empty array as children by
            // default, so use null if that's the case.
            if (Array.isArray(children) && children.length === 0) children = null;
            return (0, _reactDefault.default).createElement(context.Provider, {
                value: props
            }, props.match ? children ? typeof children === "function" ? children(props) : children : component ? (0, _reactDefault.default).createElement(component, props) : render ? render(props) : null : typeof children === "function" ? children(props) : null);
        });
    };
    return Route;
}((0, _reactDefault.default).Component);
function addLeadingSlash(path) {
    return path.charAt(0) === "/" ? path : "/" + path;
}
function addBasename(basename, location) {
    if (!basename) return location;
    return (0, _extendsDefault.default)({}, location, {
        pathname: addLeadingSlash(basename) + location.pathname
    });
}
function stripBasename(basename, location) {
    if (!basename) return location;
    var base = addLeadingSlash(basename);
    if (location.pathname.indexOf(base) !== 0) return location;
    return (0, _extendsDefault.default)({}, location, {
        pathname: location.pathname.substr(base.length)
    });
}
function createURL(location) {
    return typeof location === "string" ? location : (0, _history.createPath)(location);
}
function staticHandler(methodName) {
    return function() {
        (0, _tinyInvariantDefault.default)(false);
    };
}
function noop() {}
/**
 * The public top-level API for a "static" <Router>, so-called because it
 * can't actually change the current location. Instead, it just records
 * location changes in a context object. Useful mainly in testing and
 * server-rendering scenarios.
 */ var StaticRouter = /*#__PURE__*/ function(_React$Component) {
    (0, _inheritsLooseDefault.default)(StaticRouter, _React$Component);
    function StaticRouter() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.handlePush = function(location) {
            return _this.navigateTo(location, "PUSH");
        };
        _this.handleReplace = function(location) {
            return _this.navigateTo(location, "REPLACE");
        };
        _this.handleListen = function() {
            return noop;
        };
        _this.handleBlock = function() {
            return noop;
        };
        return _this;
    }
    var _proto = StaticRouter.prototype;
    _proto.navigateTo = function navigateTo(location, action) {
        var _this$props = this.props, _this$props$basename = _this$props.basename, basename = _this$props$basename === void 0 ? "" : _this$props$basename, _this$props$context = _this$props.context, context = _this$props$context === void 0 ? {} : _this$props$context;
        context.action = action;
        context.location = addBasename(basename, (0, _history.createLocation)(location));
        context.url = createURL(context.location);
    };
    _proto.render = function render() {
        var _this$props2 = this.props, _this$props2$basename = _this$props2.basename, basename = _this$props2$basename === void 0 ? "" : _this$props2$basename, _this$props2$context = _this$props2.context, context = _this$props2$context === void 0 ? {} : _this$props2$context, _this$props2$location = _this$props2.location, location = _this$props2$location === void 0 ? "/" : _this$props2$location, rest = (0, _objectWithoutPropertiesLooseDefault.default)(_this$props2, [
            "basename",
            "context",
            "location"
        ]);
        var history = {
            createHref: function createHref(path) {
                return addLeadingSlash(basename + createURL(path));
            },
            action: "POP",
            location: stripBasename(basename, (0, _history.createLocation)(location)),
            push: this.handlePush,
            replace: this.handleReplace,
            go: staticHandler("go"),
            goBack: staticHandler("goBack"),
            goForward: staticHandler("goForward"),
            listen: this.handleListen,
            block: this.handleBlock
        };
        return (0, _reactDefault.default).createElement(Router, (0, _extendsDefault.default)({}, rest, {
            history: history,
            staticContext: context
        }));
    };
    return StaticRouter;
}((0, _reactDefault.default).Component);
/**
 * The public API for rendering the first <Route> that matches.
 */ var Switch = /*#__PURE__*/ function(_React$Component) {
    (0, _inheritsLooseDefault.default)(Switch, _React$Component);
    function Switch() {
        return _React$Component.apply(this, arguments) || this;
    }
    var _proto = Switch.prototype;
    _proto.render = function render() {
        var _this = this;
        return (0, _reactDefault.default).createElement(context.Consumer, null, function(context) {
            !context && (0, _tinyInvariantDefault.default)(false);
            var location = _this.props.location || context.location;
            var element, match; // We use React.Children.forEach instead of React.Children.toArray().find()
            // here because toArray adds keys to all child elements and we do not want
            // to trigger an unmount/remount for two <Route>s that render the same
            // component at different URLs.
            (0, _reactDefault.default).Children.forEach(_this.props.children, function(child) {
                if (match == null && (0, _reactDefault.default).isValidElement(child)) {
                    element = child;
                    var path = child.props.path || child.props.from;
                    match = path ? matchPath(location.pathname, (0, _extendsDefault.default)({}, child.props, {
                        path: path
                    })) : context.match;
                }
            });
            return match ? (0, _reactDefault.default).cloneElement(element, {
                location: location,
                computedMatch: match
            }) : null;
        });
    };
    return Switch;
}((0, _reactDefault.default).Component);
/**
 * A public higher-order component to access the imperative API
 */ function withRouter(Component) {
    var displayName = "withRouter(" + (Component.displayName || Component.name) + ")";
    var C = function C(props) {
        var wrappedComponentRef = props.wrappedComponentRef, remainingProps = (0, _objectWithoutPropertiesLooseDefault.default)(props, [
            "wrappedComponentRef"
        ]);
        return (0, _reactDefault.default).createElement(context.Consumer, null, function(context) {
            !context && (0, _tinyInvariantDefault.default)(false);
            return (0, _reactDefault.default).createElement(Component, (0, _extendsDefault.default)({}, remainingProps, context, {
                ref: wrappedComponentRef
            }));
        });
    };
    C.displayName = displayName;
    C.WrappedComponent = Component;
    return (0, _hoistNonReactStaticsDefault.default)(C, Component);
}
var useContext = (0, _reactDefault.default).useContext;
function useHistory() {
    return useContext(historyContext);
}
function useLocation() {
    return useContext(context).location;
}
function useParams() {
    var match = useContext(context).match;
    return match ? match.params : {};
}
function useRouteMatch(path) {
    var location = useLocation();
    var match = useContext(context).match;
    return path ? matchPath(location.pathname, path) : match;
}
var global, key, buildNames, initialBuildName, secondaryBuildName;

},{"@babel/runtime/helpers/esm/inheritsLoose":"9IZpV","react":"6uln9","prop-types":"6FKs7","history":"grwqf","tiny-warning":"328jC","mini-create-react-context":"kYfip","tiny-invariant":"dPEnp","@babel/runtime/helpers/esm/extends":"fW5l8","path-to-regexp":"ejAzl","react-is":"4OYrG","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"5R6Zx","hoist-non-react-statics":"3bvdc","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9IZpV":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_inheritsLoose);
var _setPrototypeOfJs = require("./setPrototypeOf.js");
var _setPrototypeOfJsDefault = parcelHelpers.interopDefault(_setPrototypeOfJs);
function _inheritsLoose(t, o) {
    t.prototype = Object.create(o.prototype), t.prototype.constructor = t, (0, _setPrototypeOfJsDefault.default)(t, o);
}

},{"./setPrototypeOf.js":"hT6Yn","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"hT6Yn":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_setPrototypeOf);
function _setPrototypeOf(t, e) {
    return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, _setPrototypeOf(t, e);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"k3151":[function(require,module,exports) {
exports.interopDefault = function(a) {
    return a && a.__esModule ? a : {
        default: a
    };
};
exports.defineInteropFlag = function(a) {
    Object.defineProperty(a, "__esModule", {
        value: true
    });
};
exports.exportAll = function(source, dest) {
    Object.keys(source).forEach(function(key) {
        if (key === "default" || key === "__esModule" || Object.prototype.hasOwnProperty.call(dest, key)) return;
        Object.defineProperty(dest, key, {
            enumerable: true,
            get: function() {
                return source[key];
            }
        });
    });
    return dest;
};
exports.export = function(dest, destName, get) {
    Object.defineProperty(dest, destName, {
        enumerable: true,
        get: get
    });
};

},{}],"6FKs7":[function(require,module,exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var ReactIs, throwOnDirectAccess;
// By explicitly using `prop-types` you are opting into new production behavior.
// http://fb.me/prop-types-in-prod
module.exports = require("e98516c5bab4526")();

},{"e98516c5bab4526":"7ziwC"}],"7ziwC":[function(require,module,exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var ReactPropTypesSecret = require("bf7f43a19ae1b960");
function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;
module.exports = function() {
    function shim(props, propName, componentName, location, propFullName, secret) {
        if (secret === ReactPropTypesSecret) // It is still safe when called from React.
        return;
        var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        err.name = "Invariant Violation";
        throw err;
    }
    shim.isRequired = shim;
    function getShim() {
        return shim;
    }
    // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
    var ReactPropTypes = {
        array: shim,
        bigint: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: emptyFunctionWithReset,
        resetWarningCache: emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};

},{"bf7f43a19ae1b960":"4Cml4"}],"4Cml4":[function(require,module,exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var ReactPropTypesSecret = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
module.exports = ReactPropTypesSecret;

},{}],"grwqf":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createBrowserHistory", ()=>createBrowserHistory);
parcelHelpers.export(exports, "createHashHistory", ()=>createHashHistory);
parcelHelpers.export(exports, "createMemoryHistory", ()=>createMemoryHistory);
parcelHelpers.export(exports, "createLocation", ()=>createLocation);
parcelHelpers.export(exports, "locationsAreEqual", ()=>locationsAreEqual);
parcelHelpers.export(exports, "parsePath", ()=>parsePath);
parcelHelpers.export(exports, "createPath", ()=>createPath);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _resolvePathname = require("resolve-pathname");
var _resolvePathnameDefault = parcelHelpers.interopDefault(_resolvePathname);
var _valueEqual = require("value-equal");
var _valueEqualDefault = parcelHelpers.interopDefault(_valueEqual);
var _tinyWarning = require("tiny-warning");
var _tinyWarningDefault = parcelHelpers.interopDefault(_tinyWarning);
var _tinyInvariant = require("tiny-invariant");
var _tinyInvariantDefault = parcelHelpers.interopDefault(_tinyInvariant);
function addLeadingSlash(path) {
    return path.charAt(0) === "/" ? path : "/" + path;
}
function stripLeadingSlash(path) {
    return path.charAt(0) === "/" ? path.substr(1) : path;
}
function hasBasename(path, prefix) {
    return path.toLowerCase().indexOf(prefix.toLowerCase()) === 0 && "/?#".indexOf(path.charAt(prefix.length)) !== -1;
}
function stripBasename(path, prefix) {
    return hasBasename(path, prefix) ? path.substr(prefix.length) : path;
}
function stripTrailingSlash(path) {
    return path.charAt(path.length - 1) === "/" ? path.slice(0, -1) : path;
}
function parsePath(path) {
    var pathname = path || "/";
    var search = "";
    var hash = "";
    var hashIndex = pathname.indexOf("#");
    if (hashIndex !== -1) {
        hash = pathname.substr(hashIndex);
        pathname = pathname.substr(0, hashIndex);
    }
    var searchIndex = pathname.indexOf("?");
    if (searchIndex !== -1) {
        search = pathname.substr(searchIndex);
        pathname = pathname.substr(0, searchIndex);
    }
    return {
        pathname: pathname,
        search: search === "?" ? "" : search,
        hash: hash === "#" ? "" : hash
    };
}
function createPath(location) {
    var pathname = location.pathname, search = location.search, hash = location.hash;
    var path = pathname || "/";
    if (search && search !== "?") path += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") path += hash.charAt(0) === "#" ? hash : "#" + hash;
    return path;
}
function createLocation(path, state, key, currentLocation) {
    var location;
    if (typeof path === "string") {
        // Two-arg form: push(path, state)
        location = parsePath(path);
        location.state = state;
    } else {
        // One-arg form: push(location)
        location = (0, _extendsDefault.default)({}, path);
        if (location.pathname === undefined) location.pathname = "";
        if (location.search) {
            if (location.search.charAt(0) !== "?") location.search = "?" + location.search;
        } else location.search = "";
        if (location.hash) {
            if (location.hash.charAt(0) !== "#") location.hash = "#" + location.hash;
        } else location.hash = "";
        if (state !== undefined && location.state === undefined) location.state = state;
    }
    try {
        location.pathname = decodeURI(location.pathname);
    } catch (e) {
        if (e instanceof URIError) throw new URIError('Pathname "' + location.pathname + '" could not be decoded. ' + "This is likely caused by an invalid percent-encoding.");
        else throw e;
    }
    if (key) location.key = key;
    if (currentLocation) {
        // Resolve incomplete/relative pathname relative to current location.
        if (!location.pathname) location.pathname = currentLocation.pathname;
        else if (location.pathname.charAt(0) !== "/") location.pathname = (0, _resolvePathnameDefault.default)(location.pathname, currentLocation.pathname);
    } else // When there is no prior location and pathname is empty, set it to /
    if (!location.pathname) location.pathname = "/";
    return location;
}
function locationsAreEqual(a, b) {
    return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash && a.key === b.key && (0, _valueEqualDefault.default)(a.state, b.state);
}
function createTransitionManager() {
    var prompt = null;
    function setPrompt(nextPrompt) {
        prompt = nextPrompt;
        return function() {
            if (prompt === nextPrompt) prompt = null;
        };
    }
    function confirmTransitionTo(location, action, getUserConfirmation, callback) {
        // TODO: If another transition starts while we're still confirming
        // the previous one, we may end up in a weird state. Figure out the
        // best way to handle this.
        if (prompt != null) {
            var result = typeof prompt === "function" ? prompt(location, action) : prompt;
            if (typeof result === "string") {
                if (typeof getUserConfirmation === "function") getUserConfirmation(result, callback);
                else callback(true);
            } else // Return false from a transition hook to cancel the transition.
            callback(result !== false);
        } else callback(true);
    }
    var listeners = [];
    function appendListener(fn) {
        var isActive = true;
        function listener() {
            if (isActive) fn.apply(void 0, arguments);
        }
        listeners.push(listener);
        return function() {
            isActive = false;
            listeners = listeners.filter(function(item) {
                return item !== listener;
            });
        };
    }
    function notifyListeners() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        listeners.forEach(function(listener) {
            return listener.apply(void 0, args);
        });
    }
    return {
        setPrompt: setPrompt,
        confirmTransitionTo: confirmTransitionTo,
        appendListener: appendListener,
        notifyListeners: notifyListeners
    };
}
var canUseDOM = !!(typeof window !== "undefined" && window.document && window.document.createElement);
function getConfirmation(message, callback) {
    callback(window.confirm(message)); // eslint-disable-line no-alert
}
/**
 * Returns true if the HTML5 history API is supported. Taken from Modernizr.
 *
 * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
 * changed to avoid false negatives for Windows Phones: https://github.com/reactjs/react-router/issues/586
 */ function supportsHistory() {
    var ua = window.navigator.userAgent;
    if ((ua.indexOf("Android 2.") !== -1 || ua.indexOf("Android 4.0") !== -1) && ua.indexOf("Mobile Safari") !== -1 && ua.indexOf("Chrome") === -1 && ua.indexOf("Windows Phone") === -1) return false;
    return window.history && "pushState" in window.history;
}
/**
 * Returns true if browser fires popstate on hash change.
 * IE10 and IE11 do not.
 */ function supportsPopStateOnHashChange() {
    return window.navigator.userAgent.indexOf("Trident") === -1;
}
/**
 * Returns false if using go(n) with hash history causes a full page reload.
 */ function supportsGoWithoutReloadUsingHash() {
    return window.navigator.userAgent.indexOf("Firefox") === -1;
}
/**
 * Returns true if a given popstate event is an extraneous WebKit event.
 * Accounts for the fact that Chrome on iOS fires real popstate events
 * containing undefined state when pressing the back button.
 */ function isExtraneousPopstateEvent(event) {
    return event.state === undefined && navigator.userAgent.indexOf("CriOS") === -1;
}
var PopStateEvent = "popstate";
var HashChangeEvent = "hashchange";
function getHistoryState() {
    try {
        return window.history.state || {};
    } catch (e) {
        // IE 11 sometimes throws when accessing window.history.state
        // See https://github.com/ReactTraining/history/pull/289
        return {};
    }
}
/**
 * Creates a history object that uses the HTML5 history API including
 * pushState, replaceState, and the popstate event.
 */ function createBrowserHistory(props) {
    if (props === void 0) props = {};
    !canUseDOM && (0, _tinyInvariantDefault.default)(false);
    var globalHistory = window.history;
    var canUseHistory = supportsHistory();
    var needsHashChangeListener = !supportsPopStateOnHashChange();
    var _props = props, _props$forceRefresh = _props.forceRefresh, forceRefresh = _props$forceRefresh === void 0 ? false : _props$forceRefresh, _props$getUserConfirm = _props.getUserConfirmation, getUserConfirmation = _props$getUserConfirm === void 0 ? getConfirmation : _props$getUserConfirm, _props$keyLength = _props.keyLength, keyLength = _props$keyLength === void 0 ? 6 : _props$keyLength;
    var basename = props.basename ? stripTrailingSlash(addLeadingSlash(props.basename)) : "";
    function getDOMLocation(historyState) {
        var _ref = historyState || {}, key = _ref.key, state = _ref.state;
        var _window$location = window.location, pathname = _window$location.pathname, search = _window$location.search, hash = _window$location.hash;
        var path = pathname + search + hash;
        if (basename) path = stripBasename(path, basename);
        return createLocation(path, state, key);
    }
    function createKey() {
        return Math.random().toString(36).substr(2, keyLength);
    }
    var transitionManager = createTransitionManager();
    function setState(nextState) {
        (0, _extendsDefault.default)(history, nextState);
        history.length = globalHistory.length;
        transitionManager.notifyListeners(history.location, history.action);
    }
    function handlePopState(event) {
        // Ignore extraneous popstate events in WebKit.
        if (isExtraneousPopstateEvent(event)) return;
        handlePop(getDOMLocation(event.state));
    }
    function handleHashChange() {
        handlePop(getDOMLocation(getHistoryState()));
    }
    var forceNextPop = false;
    function handlePop(location) {
        if (forceNextPop) {
            forceNextPop = false;
            setState();
        } else {
            var action = "POP";
            transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
                if (ok) setState({
                    action: action,
                    location: location
                });
                else revertPop(location);
            });
        }
    }
    function revertPop(fromLocation) {
        var toLocation = history.location; // TODO: We could probably make this more reliable by
        // keeping a list of keys we've seen in sessionStorage.
        // Instead, we just default to 0 for keys we don't know.
        var toIndex = allKeys.indexOf(toLocation.key);
        if (toIndex === -1) toIndex = 0;
        var fromIndex = allKeys.indexOf(fromLocation.key);
        if (fromIndex === -1) fromIndex = 0;
        var delta = toIndex - fromIndex;
        if (delta) {
            forceNextPop = true;
            go(delta);
        }
    }
    var initialLocation = getDOMLocation(getHistoryState());
    var allKeys = [
        initialLocation.key
    ]; // Public interface
    function createHref(location) {
        return basename + createPath(location);
    }
    function push(path, state) {
        var action = "PUSH";
        var location = createLocation(path, state, createKey(), history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var href = createHref(location);
            var key = location.key, state = location.state;
            if (canUseHistory) {
                globalHistory.pushState({
                    key: key,
                    state: state
                }, null, href);
                if (forceRefresh) window.location.href = href;
                else {
                    var prevIndex = allKeys.indexOf(history.location.key);
                    var nextKeys = allKeys.slice(0, prevIndex + 1);
                    nextKeys.push(location.key);
                    allKeys = nextKeys;
                    setState({
                        action: action,
                        location: location
                    });
                }
            } else window.location.href = href;
        });
    }
    function replace(path, state) {
        var action = "REPLACE";
        var location = createLocation(path, state, createKey(), history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var href = createHref(location);
            var key = location.key, state = location.state;
            if (canUseHistory) {
                globalHistory.replaceState({
                    key: key,
                    state: state
                }, null, href);
                if (forceRefresh) window.location.replace(href);
                else {
                    var prevIndex = allKeys.indexOf(history.location.key);
                    if (prevIndex !== -1) allKeys[prevIndex] = location.key;
                    setState({
                        action: action,
                        location: location
                    });
                }
            } else window.location.replace(href);
        });
    }
    function go(n) {
        globalHistory.go(n);
    }
    function goBack() {
        go(-1);
    }
    function goForward() {
        go(1);
    }
    var listenerCount = 0;
    function checkDOMListeners(delta) {
        listenerCount += delta;
        if (listenerCount === 1 && delta === 1) {
            window.addEventListener(PopStateEvent, handlePopState);
            if (needsHashChangeListener) window.addEventListener(HashChangeEvent, handleHashChange);
        } else if (listenerCount === 0) {
            window.removeEventListener(PopStateEvent, handlePopState);
            if (needsHashChangeListener) window.removeEventListener(HashChangeEvent, handleHashChange);
        }
    }
    var isBlocked = false;
    function block(prompt) {
        if (prompt === void 0) prompt = false;
        var unblock = transitionManager.setPrompt(prompt);
        if (!isBlocked) {
            checkDOMListeners(1);
            isBlocked = true;
        }
        return function() {
            if (isBlocked) {
                isBlocked = false;
                checkDOMListeners(-1);
            }
            return unblock();
        };
    }
    function listen(listener) {
        var unlisten = transitionManager.appendListener(listener);
        checkDOMListeners(1);
        return function() {
            checkDOMListeners(-1);
            unlisten();
        };
    }
    var history = {
        length: globalHistory.length,
        action: "POP",
        location: initialLocation,
        createHref: createHref,
        push: push,
        replace: replace,
        go: go,
        goBack: goBack,
        goForward: goForward,
        block: block,
        listen: listen
    };
    return history;
}
var HashChangeEvent$1 = "hashchange";
var HashPathCoders = {
    hashbang: {
        encodePath: function encodePath(path) {
            return path.charAt(0) === "!" ? path : "!/" + stripLeadingSlash(path);
        },
        decodePath: function decodePath(path) {
            return path.charAt(0) === "!" ? path.substr(1) : path;
        }
    },
    noslash: {
        encodePath: stripLeadingSlash,
        decodePath: addLeadingSlash
    },
    slash: {
        encodePath: addLeadingSlash,
        decodePath: addLeadingSlash
    }
};
function stripHash(url) {
    var hashIndex = url.indexOf("#");
    return hashIndex === -1 ? url : url.slice(0, hashIndex);
}
function getHashPath() {
    // We can't use window.location.hash here because it's not
    // consistent across browsers - Firefox will pre-decode it!
    var href = window.location.href;
    var hashIndex = href.indexOf("#");
    return hashIndex === -1 ? "" : href.substring(hashIndex + 1);
}
function pushHashPath(path) {
    window.location.hash = path;
}
function replaceHashPath(path) {
    window.location.replace(stripHash(window.location.href) + "#" + path);
}
function createHashHistory(props) {
    if (props === void 0) props = {};
    !canUseDOM && (0, _tinyInvariantDefault.default)(false);
    var globalHistory = window.history;
    var canGoWithoutReload = supportsGoWithoutReloadUsingHash();
    var _props = props, _props$getUserConfirm = _props.getUserConfirmation, getUserConfirmation = _props$getUserConfirm === void 0 ? getConfirmation : _props$getUserConfirm, _props$hashType = _props.hashType, hashType = _props$hashType === void 0 ? "slash" : _props$hashType;
    var basename = props.basename ? stripTrailingSlash(addLeadingSlash(props.basename)) : "";
    var _HashPathCoders$hashT = HashPathCoders[hashType], encodePath = _HashPathCoders$hashT.encodePath, decodePath = _HashPathCoders$hashT.decodePath;
    function getDOMLocation() {
        var path = decodePath(getHashPath());
        if (basename) path = stripBasename(path, basename);
        return createLocation(path);
    }
    var transitionManager = createTransitionManager();
    function setState(nextState) {
        (0, _extendsDefault.default)(history, nextState);
        history.length = globalHistory.length;
        transitionManager.notifyListeners(history.location, history.action);
    }
    var forceNextPop = false;
    var ignorePath = null;
    function locationsAreEqual$$1(a, b) {
        return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash;
    }
    function handleHashChange() {
        var path = getHashPath();
        var encodedPath = encodePath(path);
        if (path !== encodedPath) // Ensure we always have a properly-encoded hash.
        replaceHashPath(encodedPath);
        else {
            var location = getDOMLocation();
            var prevLocation = history.location;
            if (!forceNextPop && locationsAreEqual$$1(prevLocation, location)) return; // A hashchange doesn't always == location change.
            if (ignorePath === createPath(location)) return; // Ignore this change; we already setState in push/replace.
            ignorePath = null;
            handlePop(location);
        }
    }
    function handlePop(location) {
        if (forceNextPop) {
            forceNextPop = false;
            setState();
        } else {
            var action = "POP";
            transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
                if (ok) setState({
                    action: action,
                    location: location
                });
                else revertPop(location);
            });
        }
    }
    function revertPop(fromLocation) {
        var toLocation = history.location; // TODO: We could probably make this more reliable by
        // keeping a list of paths we've seen in sessionStorage.
        // Instead, we just default to 0 for paths we don't know.
        var toIndex = allPaths.lastIndexOf(createPath(toLocation));
        if (toIndex === -1) toIndex = 0;
        var fromIndex = allPaths.lastIndexOf(createPath(fromLocation));
        if (fromIndex === -1) fromIndex = 0;
        var delta = toIndex - fromIndex;
        if (delta) {
            forceNextPop = true;
            go(delta);
        }
    } // Ensure the hash is encoded properly before doing anything else.
    var path = getHashPath();
    var encodedPath = encodePath(path);
    if (path !== encodedPath) replaceHashPath(encodedPath);
    var initialLocation = getDOMLocation();
    var allPaths = [
        createPath(initialLocation)
    ]; // Public interface
    function createHref(location) {
        var baseTag = document.querySelector("base");
        var href = "";
        if (baseTag && baseTag.getAttribute("href")) href = stripHash(window.location.href);
        return href + "#" + encodePath(basename + createPath(location));
    }
    function push(path, state) {
        var action = "PUSH";
        var location = createLocation(path, undefined, undefined, history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var path = createPath(location);
            var encodedPath = encodePath(basename + path);
            var hashChanged = getHashPath() !== encodedPath;
            if (hashChanged) {
                // We cannot tell if a hashchange was caused by a PUSH, so we'd
                // rather setState here and ignore the hashchange. The caveat here
                // is that other hash histories in the page will consider it a POP.
                ignorePath = path;
                pushHashPath(encodedPath);
                var prevIndex = allPaths.lastIndexOf(createPath(history.location));
                var nextPaths = allPaths.slice(0, prevIndex + 1);
                nextPaths.push(path);
                allPaths = nextPaths;
                setState({
                    action: action,
                    location: location
                });
            } else setState();
        });
    }
    function replace(path, state) {
        var action = "REPLACE";
        var location = createLocation(path, undefined, undefined, history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var path = createPath(location);
            var encodedPath = encodePath(basename + path);
            var hashChanged = getHashPath() !== encodedPath;
            if (hashChanged) {
                // We cannot tell if a hashchange was caused by a REPLACE, so we'd
                // rather setState here and ignore the hashchange. The caveat here
                // is that other hash histories in the page will consider it a POP.
                ignorePath = path;
                replaceHashPath(encodedPath);
            }
            var prevIndex = allPaths.indexOf(createPath(history.location));
            if (prevIndex !== -1) allPaths[prevIndex] = path;
            setState({
                action: action,
                location: location
            });
        });
    }
    function go(n) {
        globalHistory.go(n);
    }
    function goBack() {
        go(-1);
    }
    function goForward() {
        go(1);
    }
    var listenerCount = 0;
    function checkDOMListeners(delta) {
        listenerCount += delta;
        if (listenerCount === 1 && delta === 1) window.addEventListener(HashChangeEvent$1, handleHashChange);
        else if (listenerCount === 0) window.removeEventListener(HashChangeEvent$1, handleHashChange);
    }
    var isBlocked = false;
    function block(prompt) {
        if (prompt === void 0) prompt = false;
        var unblock = transitionManager.setPrompt(prompt);
        if (!isBlocked) {
            checkDOMListeners(1);
            isBlocked = true;
        }
        return function() {
            if (isBlocked) {
                isBlocked = false;
                checkDOMListeners(-1);
            }
            return unblock();
        };
    }
    function listen(listener) {
        var unlisten = transitionManager.appendListener(listener);
        checkDOMListeners(1);
        return function() {
            checkDOMListeners(-1);
            unlisten();
        };
    }
    var history = {
        length: globalHistory.length,
        action: "POP",
        location: initialLocation,
        createHref: createHref,
        push: push,
        replace: replace,
        go: go,
        goBack: goBack,
        goForward: goForward,
        block: block,
        listen: listen
    };
    return history;
}
function clamp(n, lowerBound, upperBound) {
    return Math.min(Math.max(n, lowerBound), upperBound);
}
/**
 * Creates a history object that stores locations in memory.
 */ function createMemoryHistory(props) {
    if (props === void 0) props = {};
    var _props = props, getUserConfirmation = _props.getUserConfirmation, _props$initialEntries = _props.initialEntries, initialEntries = _props$initialEntries === void 0 ? [
        "/"
    ] : _props$initialEntries, _props$initialIndex = _props.initialIndex, initialIndex = _props$initialIndex === void 0 ? 0 : _props$initialIndex, _props$keyLength = _props.keyLength, keyLength = _props$keyLength === void 0 ? 6 : _props$keyLength;
    var transitionManager = createTransitionManager();
    function setState(nextState) {
        (0, _extendsDefault.default)(history, nextState);
        history.length = history.entries.length;
        transitionManager.notifyListeners(history.location, history.action);
    }
    function createKey() {
        return Math.random().toString(36).substr(2, keyLength);
    }
    var index = clamp(initialIndex, 0, initialEntries.length - 1);
    var entries = initialEntries.map(function(entry) {
        return typeof entry === "string" ? createLocation(entry, undefined, createKey()) : createLocation(entry, undefined, entry.key || createKey());
    }); // Public interface
    var createHref = createPath;
    function push(path, state) {
        var action = "PUSH";
        var location = createLocation(path, state, createKey(), history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var prevIndex = history.index;
            var nextIndex = prevIndex + 1;
            var nextEntries = history.entries.slice(0);
            if (nextEntries.length > nextIndex) nextEntries.splice(nextIndex, nextEntries.length - nextIndex, location);
            else nextEntries.push(location);
            setState({
                action: action,
                location: location,
                index: nextIndex,
                entries: nextEntries
            });
        });
    }
    function replace(path, state) {
        var action = "REPLACE";
        var location = createLocation(path, state, createKey(), history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            history.entries[history.index] = location;
            setState({
                action: action,
                location: location
            });
        });
    }
    function go(n) {
        var nextIndex = clamp(history.index + n, 0, history.entries.length - 1);
        var action = "POP";
        var location = history.entries[nextIndex];
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (ok) setState({
                action: action,
                location: location,
                index: nextIndex
            });
            else // Mimic the behavior of DOM histories by
            // causing a render after a cancelled POP.
            setState();
        });
    }
    function goBack() {
        go(-1);
    }
    function goForward() {
        go(1);
    }
    function canGo(n) {
        var nextIndex = history.index + n;
        return nextIndex >= 0 && nextIndex < history.entries.length;
    }
    function block(prompt) {
        if (prompt === void 0) prompt = false;
        return transitionManager.setPrompt(prompt);
    }
    function listen(listener) {
        return transitionManager.appendListener(listener);
    }
    var history = {
        length: entries.length,
        action: "POP",
        location: entries[index],
        index: index,
        entries: entries,
        createHref: createHref,
        push: push,
        replace: replace,
        go: go,
        goBack: goBack,
        goForward: goForward,
        canGo: canGo,
        block: block,
        listen: listen
    };
    return history;
}

},{"@babel/runtime/helpers/esm/extends":"fW5l8","resolve-pathname":"0395z","value-equal":"1MFfb","tiny-warning":"328jC","tiny-invariant":"dPEnp","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"fW5l8":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_extends);
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"0395z":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function isAbsolute(pathname) {
    return pathname.charAt(0) === "/";
}
// About 1.5x faster than the two-arg version of Array#splice()
function spliceOne(list, index) {
    for(var i = index, k = i + 1, n = list.length; k < n; i += 1, k += 1)list[i] = list[k];
    list.pop();
}
// This implementation is based heavily on node's url.parse
function resolvePathname(to, from) {
    if (from === undefined) from = "";
    var toParts = to && to.split("/") || [];
    var fromParts = from && from.split("/") || [];
    var isToAbs = to && isAbsolute(to);
    var isFromAbs = from && isAbsolute(from);
    var mustEndAbs = isToAbs || isFromAbs;
    if (to && isAbsolute(to)) // to is absolute
    fromParts = toParts;
    else if (toParts.length) {
        // to is relative, drop the filename
        fromParts.pop();
        fromParts = fromParts.concat(toParts);
    }
    if (!fromParts.length) return "/";
    var hasTrailingSlash;
    if (fromParts.length) {
        var last = fromParts[fromParts.length - 1];
        hasTrailingSlash = last === "." || last === ".." || last === "";
    } else hasTrailingSlash = false;
    var up = 0;
    for(var i = fromParts.length; i >= 0; i--){
        var part = fromParts[i];
        if (part === ".") spliceOne(fromParts, i);
        else if (part === "..") {
            spliceOne(fromParts, i);
            up++;
        } else if (up) {
            spliceOne(fromParts, i);
            up--;
        }
    }
    if (!mustEndAbs) for(; up--; up)fromParts.unshift("..");
    if (mustEndAbs && fromParts[0] !== "" && (!fromParts[0] || !isAbsolute(fromParts[0]))) fromParts.unshift("");
    var result = fromParts.join("/");
    if (hasTrailingSlash && result.substr(-1) !== "/") result += "/";
    return result;
}
exports.default = resolvePathname;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"1MFfb":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function valueOf(obj) {
    return obj.valueOf ? obj.valueOf() : Object.prototype.valueOf.call(obj);
}
function valueEqual(a, b) {
    // Test for strict equality first.
    if (a === b) return true;
    // Otherwise, if either of them == null they are not equal.
    if (a == null || b == null) return false;
    if (Array.isArray(a)) return Array.isArray(b) && a.length === b.length && a.every(function(item, index) {
        return valueEqual(item, b[index]);
    });
    if (typeof a === "object" || typeof b === "object") {
        var aValue = valueOf(a);
        var bValue = valueOf(b);
        if (aValue !== a || bValue !== b) return valueEqual(aValue, bValue);
        return Object.keys(Object.assign({}, a, b)).every(function(key) {
            return valueEqual(a[key], b[key]);
        });
    }
    return false;
}
exports.default = valueEqual;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"328jC":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var isProduction = true;
function warning(condition, message) {
    if (!isProduction) {
        if (condition) return;
        var text = "Warning: " + message;
        if (typeof console !== "undefined") console.warn(text);
        try {
            throw Error(text);
        } catch (x) {}
    }
}
exports.default = warning;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"dPEnp":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>invariant);
var isProduction = true;
var prefix = "Invariant failed";
function invariant(condition, message) {
    if (condition) return;
    if (isProduction) throw new Error(prefix);
    var provided = typeof message === "function" ? message() : message;
    var value = provided ? "".concat(prefix, ": ").concat(provided) : prefix;
    throw new Error(value);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"kYfip":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _inheritsLoose = require("@babel/runtime/helpers/esm/inheritsLoose");
var _inheritsLooseDefault = parcelHelpers.interopDefault(_inheritsLoose);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _tinyWarning = require("tiny-warning");
var _tinyWarningDefault = parcelHelpers.interopDefault(_tinyWarning);
var global = arguments[3];
var MAX_SIGNED_31_BIT_INT = 1073741823;
var commonjsGlobal = typeof globalThis !== "undefined" ? globalThis : typeof window !== "undefined" ? window : typeof global !== "undefined" ? global : {};
function getUniqueId() {
    var key = "__global_unique_id__";
    return commonjsGlobal[key] = (commonjsGlobal[key] || 0) + 1;
}
function objectIs(x, y) {
    if (x === y) return x !== 0 || 1 / x === 1 / y;
    else return x !== x && y !== y;
}
function createEventEmitter(value) {
    var handlers = [];
    return {
        on: function on(handler) {
            handlers.push(handler);
        },
        off: function off(handler) {
            handlers = handlers.filter(function(h) {
                return h !== handler;
            });
        },
        get: function get() {
            return value;
        },
        set: function set(newValue, changedBits) {
            value = newValue;
            handlers.forEach(function(handler) {
                return handler(value, changedBits);
            });
        }
    };
}
function onlyChild(children) {
    return Array.isArray(children) ? children[0] : children;
}
function createReactContext(defaultValue, calculateChangedBits) {
    var _Provider$childContex, _Consumer$contextType;
    var contextProp = "__create-react-context-" + getUniqueId() + "__";
    var Provider = /*#__PURE__*/ function(_Component) {
        (0, _inheritsLooseDefault.default)(Provider, _Component);
        function Provider() {
            var _this;
            _this = _Component.apply(this, arguments) || this;
            _this.emitter = createEventEmitter(_this.props.value);
            return _this;
        }
        var _proto = Provider.prototype;
        _proto.getChildContext = function getChildContext() {
            var _ref;
            return _ref = {}, _ref[contextProp] = this.emitter, _ref;
        };
        _proto.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
            if (this.props.value !== nextProps.value) {
                var oldValue = this.props.value;
                var newValue = nextProps.value;
                var changedBits;
                if (objectIs(oldValue, newValue)) changedBits = 0;
                else {
                    changedBits = typeof calculateChangedBits === "function" ? calculateChangedBits(oldValue, newValue) : MAX_SIGNED_31_BIT_INT;
                    changedBits |= 0;
                    if (changedBits !== 0) this.emitter.set(nextProps.value, changedBits);
                }
            }
        };
        _proto.render = function render() {
            return this.props.children;
        };
        return Provider;
    }((0, _react.Component));
    Provider.childContextTypes = (_Provider$childContex = {}, _Provider$childContex[contextProp] = (0, _propTypesDefault.default).object.isRequired, _Provider$childContex);
    var Consumer = /*#__PURE__*/ function(_Component2) {
        (0, _inheritsLooseDefault.default)(Consumer, _Component2);
        function Consumer() {
            var _this2;
            _this2 = _Component2.apply(this, arguments) || this;
            _this2.state = {
                value: _this2.getValue()
            };
            _this2.onUpdate = function(newValue, changedBits) {
                var observedBits = _this2.observedBits | 0;
                if ((observedBits & changedBits) !== 0) _this2.setState({
                    value: _this2.getValue()
                });
            };
            return _this2;
        }
        var _proto2 = Consumer.prototype;
        _proto2.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
            var observedBits = nextProps.observedBits;
            this.observedBits = observedBits === undefined || observedBits === null ? MAX_SIGNED_31_BIT_INT : observedBits;
        };
        _proto2.componentDidMount = function componentDidMount() {
            if (this.context[contextProp]) this.context[contextProp].on(this.onUpdate);
            var observedBits = this.props.observedBits;
            this.observedBits = observedBits === undefined || observedBits === null ? MAX_SIGNED_31_BIT_INT : observedBits;
        };
        _proto2.componentWillUnmount = function componentWillUnmount() {
            if (this.context[contextProp]) this.context[contextProp].off(this.onUpdate);
        };
        _proto2.getValue = function getValue() {
            if (this.context[contextProp]) return this.context[contextProp].get();
            else return defaultValue;
        };
        _proto2.render = function render() {
            return onlyChild(this.props.children)(this.state.value);
        };
        return Consumer;
    }((0, _react.Component));
    Consumer.contextTypes = (_Consumer$contextType = {}, _Consumer$contextType[contextProp] = (0, _propTypesDefault.default).object, _Consumer$contextType);
    return {
        Provider: Provider,
        Consumer: Consumer
    };
}
var index = (0, _reactDefault.default).createContext || createReactContext;
exports.default = index;

},{"react":"6uln9","@babel/runtime/helpers/esm/inheritsLoose":"9IZpV","prop-types":"6FKs7","tiny-warning":"328jC","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"ejAzl":[function(require,module,exports) {
var isarray = require("828472a1e168de2b");
/**
 * Expose `pathToRegexp`.
 */ module.exports = pathToRegexp;
module.exports.parse = parse;
module.exports.compile = compile;
module.exports.tokensToFunction = tokensToFunction;
module.exports.tokensToRegExp = tokensToRegExp;
/**
 * The main path matching regexp utility.
 *
 * @type {RegExp}
 */ var PATH_REGEXP = new RegExp([
    // Match escaped characters that would otherwise appear in future matches.
    // This allows the user to escape special characters that won't transform.
    "(\\\\.)",
    // Match Express-style parameters and un-named parameters with a prefix
    // and optional suffixes. Matches appear as:
    //
    // "/:test(\\d+)?" => ["/", "test", "\d+", undefined, "?", undefined]
    // "/route(\\d+)"  => [undefined, undefined, undefined, "\d+", undefined, undefined]
    // "/*"            => ["/", undefined, undefined, undefined, undefined, "*"]
    "([\\/.])?(?:(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?|(\\*))"
].join("|"), "g");
/**
 * Parse a string for the raw tokens.
 *
 * @param  {string}  str
 * @param  {Object=} options
 * @return {!Array}
 */ function parse(str, options) {
    var tokens = [];
    var key = 0;
    var index = 0;
    var path = "";
    var defaultDelimiter = options && options.delimiter || "/";
    var res;
    while((res = PATH_REGEXP.exec(str)) != null){
        var m = res[0];
        var escaped = res[1];
        var offset = res.index;
        path += str.slice(index, offset);
        index = offset + m.length;
        // Ignore already escaped sequences.
        if (escaped) {
            path += escaped[1];
            continue;
        }
        var next = str[index];
        var prefix = res[2];
        var name = res[3];
        var capture = res[4];
        var group = res[5];
        var modifier = res[6];
        var asterisk = res[7];
        // Push the current path onto the tokens.
        if (path) {
            tokens.push(path);
            path = "";
        }
        var partial = prefix != null && next != null && next !== prefix;
        var repeat = modifier === "+" || modifier === "*";
        var optional = modifier === "?" || modifier === "*";
        var delimiter = res[2] || defaultDelimiter;
        var pattern = capture || group;
        tokens.push({
            name: name || key++,
            prefix: prefix || "",
            delimiter: delimiter,
            optional: optional,
            repeat: repeat,
            partial: partial,
            asterisk: !!asterisk,
            pattern: pattern ? escapeGroup(pattern) : asterisk ? ".*" : "[^" + escapeString(delimiter) + "]+?"
        });
    }
    // Match any characters still remaining.
    if (index < str.length) path += str.substr(index);
    // If the path exists, push it onto the end.
    if (path) tokens.push(path);
    return tokens;
}
/**
 * Compile a string to a template function for the path.
 *
 * @param  {string}             str
 * @param  {Object=}            options
 * @return {!function(Object=, Object=)}
 */ function compile(str, options) {
    return tokensToFunction(parse(str, options), options);
}
/**
 * Prettier encoding of URI path segments.
 *
 * @param  {string}
 * @return {string}
 */ function encodeURIComponentPretty(str) {
    return encodeURI(str).replace(/[\/?#]/g, function(c) {
        return "%" + c.charCodeAt(0).toString(16).toUpperCase();
    });
}
/**
 * Encode the asterisk parameter. Similar to `pretty`, but allows slashes.
 *
 * @param  {string}
 * @return {string}
 */ function encodeAsterisk(str) {
    return encodeURI(str).replace(/[?#]/g, function(c) {
        return "%" + c.charCodeAt(0).toString(16).toUpperCase();
    });
}
/**
 * Expose a method for transforming tokens into the path function.
 */ function tokensToFunction(tokens, options) {
    // Compile all the tokens into regexps.
    var matches = new Array(tokens.length);
    // Compile all the patterns before compilation.
    for(var i = 0; i < tokens.length; i++)if (typeof tokens[i] === "object") matches[i] = new RegExp("^(?:" + tokens[i].pattern + ")$", flags(options));
    return function(obj, opts) {
        var path = "";
        var data = obj || {};
        var options = opts || {};
        var encode = options.pretty ? encodeURIComponentPretty : encodeURIComponent;
        for(var i = 0; i < tokens.length; i++){
            var token = tokens[i];
            if (typeof token === "string") {
                path += token;
                continue;
            }
            var value = data[token.name];
            var segment;
            if (value == null) {
                if (token.optional) {
                    // Prepend partial segment prefixes.
                    if (token.partial) path += token.prefix;
                    continue;
                } else throw new TypeError('Expected "' + token.name + '" to be defined');
            }
            if (isarray(value)) {
                if (!token.repeat) throw new TypeError('Expected "' + token.name + '" to not repeat, but received `' + JSON.stringify(value) + "`");
                if (value.length === 0) {
                    if (token.optional) continue;
                    else throw new TypeError('Expected "' + token.name + '" to not be empty');
                }
                for(var j = 0; j < value.length; j++){
                    segment = encode(value[j]);
                    if (!matches[i].test(segment)) throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '", but received `' + JSON.stringify(segment) + "`");
                    path += (j === 0 ? token.prefix : token.delimiter) + segment;
                }
                continue;
            }
            segment = token.asterisk ? encodeAsterisk(value) : encode(value);
            if (!matches[i].test(segment)) throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but received "' + segment + '"');
            path += token.prefix + segment;
        }
        return path;
    };
}
/**
 * Escape a regular expression string.
 *
 * @param  {string} str
 * @return {string}
 */ function escapeString(str) {
    return str.replace(/([.+*?=^!:${}()[\]|\/\\])/g, "\\$1");
}
/**
 * Escape the capturing group by escaping special characters and meaning.
 *
 * @param  {string} group
 * @return {string}
 */ function escapeGroup(group) {
    return group.replace(/([=!:$\/()])/g, "\\$1");
}
/**
 * Attach the keys as a property of the regexp.
 *
 * @param  {!RegExp} re
 * @param  {Array}   keys
 * @return {!RegExp}
 */ function attachKeys(re, keys) {
    re.keys = keys;
    return re;
}
/**
 * Get the flags for a regexp from the options.
 *
 * @param  {Object} options
 * @return {string}
 */ function flags(options) {
    return options && options.sensitive ? "" : "i";
}
/**
 * Pull out keys from a regexp.
 *
 * @param  {!RegExp} path
 * @param  {!Array}  keys
 * @return {!RegExp}
 */ function regexpToRegexp(path, keys) {
    // Use a negative lookahead to match only capturing groups.
    var groups = path.source.match(/\((?!\?)/g);
    if (groups) for(var i = 0; i < groups.length; i++)keys.push({
        name: i,
        prefix: null,
        delimiter: null,
        optional: false,
        repeat: false,
        partial: false,
        asterisk: false,
        pattern: null
    });
    return attachKeys(path, keys);
}
/**
 * Transform an array into a regexp.
 *
 * @param  {!Array}  path
 * @param  {Array}   keys
 * @param  {!Object} options
 * @return {!RegExp}
 */ function arrayToRegexp(path, keys, options) {
    var parts = [];
    for(var i = 0; i < path.length; i++)parts.push(pathToRegexp(path[i], keys, options).source);
    var regexp = new RegExp("(?:" + parts.join("|") + ")", flags(options));
    return attachKeys(regexp, keys);
}
/**
 * Create a path regexp from string input.
 *
 * @param  {string}  path
 * @param  {!Array}  keys
 * @param  {!Object} options
 * @return {!RegExp}
 */ function stringToRegexp(path, keys, options) {
    return tokensToRegExp(parse(path, options), keys, options);
}
/**
 * Expose a function for taking tokens and returning a RegExp.
 *
 * @param  {!Array}          tokens
 * @param  {(Array|Object)=} keys
 * @param  {Object=}         options
 * @return {!RegExp}
 */ function tokensToRegExp(tokens, keys, options) {
    if (!isarray(keys)) {
        options = /** @type {!Object} */ keys || options;
        keys = [];
    }
    options = options || {};
    var strict = options.strict;
    var end = options.end !== false;
    var route = "";
    // Iterate over the tokens and create our regexp string.
    for(var i = 0; i < tokens.length; i++){
        var token = tokens[i];
        if (typeof token === "string") route += escapeString(token);
        else {
            var prefix = escapeString(token.prefix);
            var capture = "(?:" + token.pattern + ")";
            keys.push(token);
            if (token.repeat) capture += "(?:" + prefix + capture + ")*";
            if (token.optional) {
                if (!token.partial) capture = "(?:" + prefix + "(" + capture + "))?";
                else capture = prefix + "(" + capture + ")?";
            } else capture = prefix + "(" + capture + ")";
            route += capture;
        }
    }
    var delimiter = escapeString(options.delimiter || "/");
    var endsWithDelimiter = route.slice(-delimiter.length) === delimiter;
    // In non-strict mode we allow a slash at the end of match. If the path to
    // match already ends with a slash, we remove it for consistency. The slash
    // is valid at the end of a path match, not in the middle. This is important
    // in non-ending mode, where "/test/" shouldn't match "/test//route".
    if (!strict) route = (endsWithDelimiter ? route.slice(0, -delimiter.length) : route) + "(?:" + delimiter + "(?=$))?";
    if (end) route += "$";
    else // In non-ending mode, we need the capturing groups to match as much as
    // possible by using a positive lookahead to the end or next path segment.
    route += strict && endsWithDelimiter ? "" : "(?=" + delimiter + "|$)";
    return attachKeys(new RegExp("^" + route, flags(options)), keys);
}
/**
 * Normalize the given path string, returning a regular expression.
 *
 * An empty array can be passed in for the keys, which will hold the
 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
 *
 * @param  {(string|RegExp|Array)} path
 * @param  {(Array|Object)=}       keys
 * @param  {Object=}               options
 * @return {!RegExp}
 */ function pathToRegexp(path, keys, options) {
    if (!isarray(keys)) {
        options = /** @type {!Object} */ keys || options;
        keys = [];
    }
    options = options || {};
    if (path instanceof RegExp) return regexpToRegexp(path, /** @type {!Array} */ keys);
    if (isarray(path)) return arrayToRegexp(/** @type {!Array} */ path, /** @type {!Array} */ keys, options);
    return stringToRegexp(/** @type {string} */ path, /** @type {!Array} */ keys, options);
}

},{"828472a1e168de2b":"2aeCJ"}],"2aeCJ":[function(require,module,exports) {
module.exports = Array.isArray || function(arr) {
    return Object.prototype.toString.call(arr) == "[object Array]";
};

},{}],"4OYrG":[function(require,module,exports) {
"use strict";
module.exports = require("3e96cece4daa9961");

},{"3e96cece4daa9961":"4i16j"}],"4i16j":[function(require,module,exports) {
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var b = "function" === typeof Symbol && Symbol.for, c = b ? Symbol.for("react.element") : 60103, d = b ? Symbol.for("react.portal") : 60106, e = b ? Symbol.for("react.fragment") : 60107, f = b ? Symbol.for("react.strict_mode") : 60108, g = b ? Symbol.for("react.profiler") : 60114, h = b ? Symbol.for("react.provider") : 60109, k = b ? Symbol.for("react.context") : 60110, l = b ? Symbol.for("react.async_mode") : 60111, m = b ? Symbol.for("react.concurrent_mode") : 60111, n = b ? Symbol.for("react.forward_ref") : 60112, p = b ? Symbol.for("react.suspense") : 60113, q = b ? Symbol.for("react.suspense_list") : 60120, r = b ? Symbol.for("react.memo") : 60115, t = b ? Symbol.for("react.lazy") : 60116, v = b ? Symbol.for("react.block") : 60121, w = b ? Symbol.for("react.fundamental") : 60117, x = b ? Symbol.for("react.responder") : 60118, y = b ? Symbol.for("react.scope") : 60119;
function z(a) {
    if ("object" === typeof a && null !== a) {
        var u = a.$$typeof;
        switch(u){
            case c:
                switch(a = a.type, a){
                    case l:
                    case m:
                    case e:
                    case g:
                    case f:
                    case p:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case k:
                            case n:
                            case t:
                            case r:
                            case h:
                                return a;
                            default:
                                return u;
                        }
                }
            case d:
                return u;
        }
    }
}
function A(a) {
    return z(a) === m;
}
exports.AsyncMode = l;
exports.ConcurrentMode = m;
exports.ContextConsumer = k;
exports.ContextProvider = h;
exports.Element = c;
exports.ForwardRef = n;
exports.Fragment = e;
exports.Lazy = t;
exports.Memo = r;
exports.Portal = d;
exports.Profiler = g;
exports.StrictMode = f;
exports.Suspense = p;
exports.isAsyncMode = function(a) {
    return A(a) || z(a) === l;
};
exports.isConcurrentMode = A;
exports.isContextConsumer = function(a) {
    return z(a) === k;
};
exports.isContextProvider = function(a) {
    return z(a) === h;
};
exports.isElement = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === c;
};
exports.isForwardRef = function(a) {
    return z(a) === n;
};
exports.isFragment = function(a) {
    return z(a) === e;
};
exports.isLazy = function(a) {
    return z(a) === t;
};
exports.isMemo = function(a) {
    return z(a) === r;
};
exports.isPortal = function(a) {
    return z(a) === d;
};
exports.isProfiler = function(a) {
    return z(a) === g;
};
exports.isStrictMode = function(a) {
    return z(a) === f;
};
exports.isSuspense = function(a) {
    return z(a) === p;
};
exports.isValidElementType = function(a) {
    return "string" === typeof a || "function" === typeof a || a === e || a === m || a === g || a === f || a === p || a === q || "object" === typeof a && null !== a && (a.$$typeof === t || a.$$typeof === r || a.$$typeof === h || a.$$typeof === k || a.$$typeof === n || a.$$typeof === w || a.$$typeof === x || a.$$typeof === y || a.$$typeof === v);
};
exports.typeOf = z;

},{}],"5R6Zx":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_objectWithoutPropertiesLoose);
function _objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.includes(n)) continue;
        t[n] = r[n];
    }
    return t;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"3bvdc":[function(require,module,exports) {
"use strict";
var reactIs = require("c03b486d83967636");
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */ var REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var FORWARD_REF_STATICS = {
    "$$typeof": true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};
var MEMO_STATICS = {
    "$$typeof": true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};
var TYPE_STATICS = {};
TYPE_STATICS[reactIs.ForwardRef] = FORWARD_REF_STATICS;
TYPE_STATICS[reactIs.Memo] = MEMO_STATICS;
function getStatics(component) {
    // React v16.11 and below
    if (reactIs.isMemo(component)) return MEMO_STATICS;
     // React v16.12 and above
    return TYPE_STATICS[component["$$typeof"]] || REACT_STATICS;
}
var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = Object.prototype;
function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== "string") {
        // don't hoist over string (html) components
        if (objectPrototype) {
            var inheritedComponent = getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== objectPrototype) hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
        }
        var keys = getOwnPropertyNames(sourceComponent);
        if (getOwnPropertySymbols) keys = keys.concat(getOwnPropertySymbols(sourceComponent));
        var targetStatics = getStatics(targetComponent);
        var sourceStatics = getStatics(sourceComponent);
        for(var i = 0; i < keys.length; ++i){
            var key = keys[i];
            if (!KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    // Avoid failures from read-only properties
                    defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
    }
    return targetComponent;
}
module.exports = hoistNonReactStatics;

},{"c03b486d83967636":"69RSM"}],"69RSM":[function(require,module,exports) {
"use strict";
module.exports = require("569f914be4368a39");

},{"569f914be4368a39":"2UEgQ"}],"2UEgQ":[function(require,module,exports) {
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var b = "function" === typeof Symbol && Symbol.for, c = b ? Symbol.for("react.element") : 60103, d = b ? Symbol.for("react.portal") : 60106, e = b ? Symbol.for("react.fragment") : 60107, f = b ? Symbol.for("react.strict_mode") : 60108, g = b ? Symbol.for("react.profiler") : 60114, h = b ? Symbol.for("react.provider") : 60109, k = b ? Symbol.for("react.context") : 60110, l = b ? Symbol.for("react.async_mode") : 60111, m = b ? Symbol.for("react.concurrent_mode") : 60111, n = b ? Symbol.for("react.forward_ref") : 60112, p = b ? Symbol.for("react.suspense") : 60113, q = b ? Symbol.for("react.suspense_list") : 60120, r = b ? Symbol.for("react.memo") : 60115, t = b ? Symbol.for("react.lazy") : 60116, v = b ? Symbol.for("react.block") : 60121, w = b ? Symbol.for("react.fundamental") : 60117, x = b ? Symbol.for("react.responder") : 60118, y = b ? Symbol.for("react.scope") : 60119;
function z(a) {
    if ("object" === typeof a && null !== a) {
        var u = a.$$typeof;
        switch(u){
            case c:
                switch(a = a.type, a){
                    case l:
                    case m:
                    case e:
                    case g:
                    case f:
                    case p:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case k:
                            case n:
                            case t:
                            case r:
                            case h:
                                return a;
                            default:
                                return u;
                        }
                }
            case d:
                return u;
        }
    }
}
function A(a) {
    return z(a) === m;
}
exports.AsyncMode = l;
exports.ConcurrentMode = m;
exports.ContextConsumer = k;
exports.ContextProvider = h;
exports.Element = c;
exports.ForwardRef = n;
exports.Fragment = e;
exports.Lazy = t;
exports.Memo = r;
exports.Portal = d;
exports.Profiler = g;
exports.StrictMode = f;
exports.Suspense = p;
exports.isAsyncMode = function(a) {
    return A(a) || z(a) === l;
};
exports.isConcurrentMode = A;
exports.isContextConsumer = function(a) {
    return z(a) === k;
};
exports.isContextProvider = function(a) {
    return z(a) === h;
};
exports.isElement = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === c;
};
exports.isForwardRef = function(a) {
    return z(a) === n;
};
exports.isFragment = function(a) {
    return z(a) === e;
};
exports.isLazy = function(a) {
    return z(a) === t;
};
exports.isMemo = function(a) {
    return z(a) === r;
};
exports.isPortal = function(a) {
    return z(a) === d;
};
exports.isProfiler = function(a) {
    return z(a) === g;
};
exports.isStrictMode = function(a) {
    return z(a) === f;
};
exports.isSuspense = function(a) {
    return z(a) === p;
};
exports.isValidElementType = function(a) {
    return "string" === typeof a || "function" === typeof a || a === e || a === m || a === g || a === f || a === p || a === q || "object" === typeof a && null !== a && (a.$$typeof === t || a.$$typeof === r || a.$$typeof === h || a.$$typeof === k || a.$$typeof === n || a.$$typeof === w || a.$$typeof === x || a.$$typeof === y || a.$$typeof === v);
};
exports.typeOf = z;

},{}],"eonG5":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _homepageCss = require("./Homepage.css");
// Page Imports 
// import Mint from '../Mint/Mint.jsx'
// Image Imports
var _headerLogoPng = require("../../assets/images/HeaderLogo.png");
var _headerLogoPngDefault = parcelHelpers.interopDefault(_headerLogoPng);
var _titleRoadMapPng = require("../../assets/images/Title_RoadMap.png");
var _titleRoadMapPngDefault = parcelHelpers.interopDefault(_titleRoadMapPng);
var _marioPng = require("../../assets/images/Mario.png");
var _marioPngDefault = parcelHelpers.interopDefault(_marioPng);
var _titleAboutPng = require("../../assets/images/Title_About.png");
var _titleAboutPngDefault = parcelHelpers.interopDefault(_titleAboutPng);
var _whatAreMFPng = require("../../assets/images/WhatAreMF.png");
var _whatAreMFPngDefault = parcelHelpers.interopDefault(_whatAreMFPng);
var _twitterPng = require("../../assets/images/Twitter.png");
var _twitterPngDefault = parcelHelpers.interopDefault(_twitterPng);
// import Etherscan from '../../assets/images/etherscan.png'
var _metalogoPng = require("../../assets/images/Metalogo.png");
var _metalogoPngDefault = parcelHelpers.interopDefault(_metalogoPng);
// Slider Imports 
var _collectionSlider = require("../Sliders/CollectionSlider");
var _collectionSliderDefault = parcelHelpers.interopDefault(_collectionSlider);
var _bioSlider = require("../Sliders/BioSlider");
var _bioSliderDefault = parcelHelpers.interopDefault(_bioSlider);
var _mint = require("../Mint/Mint");
var _mintDefault = parcelHelpers.interopDefault(_mint);
var _enter = require("./Enter");
var _enterDefault = parcelHelpers.interopDefault(_enter);
function Homepage() {
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "App",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _enterDefault.default), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                src: (0, _headerLogoPngDefault.default),
                alt: "Logo",
                className: "HeaderLogo"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "socialLinks",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("a", {
                    href: "https://twitter.com/FineartMfers",
                    target: "_blank",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                        src: (0, _twitterPngDefault.default),
                        alt: "twitter",
                        className: "TwitterLogo"
                    })
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _mintDefault.default), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _collectionSliderDefault.default), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "gap",
                children: " "
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "gap",
                children: " "
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                src: (0, _whatAreMFPngDefault.default),
                alt: "WhatAreFineArtMFers",
                className: "WhatAreLogo"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "Desc ",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("h1", {
                    children: '"fine art mfers" is a collection of 4200 hand-drawn degens by renowned artist Marlon Pruz. A tribute to the OG mfers NFT, every trait was painstakingly drawn by him over the past 5 months. No matter the rarity, each piece was designed to be a 1 of 1 masterpiece filled with Easter eggs, cultural references, and a mind-blowing amount of detail. Marlon flips the simplicity of mfers by using them as a template for these high-quality illustrations, preserving the perspective drawn by the now-departed Sartoshi. Join the curation and behold the future of mfers.'
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "gap",
                children: " "
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "gap",
                children: " "
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                src: (0, _titleRoadMapPngDefault.default),
                alt: "RoadMap",
                className: "RoadMapLogo"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "Desc ",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("h1", {
                    children: "Proceeds of fine art mfers will be used to fund public murals and community art days for the neighborhoods that need it most. Proceeds will also be used to spread the love to other independent artists in the space by purchasing their unsold pieces and adding them to our curated collection. With these initiatives, we can introduce art and educate the public about web3, not to mention, having mfers painted on murals all over the world! Many more things are yet to come, such as companions and airdrops. I guess we just gonna have to wait and see..."
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "gap",
                children: " "
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "gap",
                children: " "
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "video",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("iframe", {
                    style: {
                        border: 0
                    },
                    id: "ytplayer",
                    type: "text/html",
                    width: "100%",
                    height: "100%",
                    src: "https://www.youtube.com/embed/zzyNAM9z1cE",
                    frameBorder: "0",
                    allowFullScreen: "allowfullscreen",
                    mozallowfullscreen: "mozallowfullscreen",
                    msallowfullscreen: "msallowfullscreen",
                    oallowfullscreen: "oallowfullscreen",
                    webkitallowfullscreen: "webkitallowfullscreen"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "DescMint4",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("h3", {
                    children: [
                        "MFERS JUST ",
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
                        " GETTING STARTED"
                    ]
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "Desc"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _bioSliderDefault.default), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "gap",
                children: " "
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "gap",
                children: " "
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                src: (0, _titleAboutPngDefault.default),
                alt: "About",
                className: "AboutLogo"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "Desc",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("h1", {
                    children: "Marlon Pruz is a full time illustrator and muralist from Miami Beach, Florida. His art derives from the constant influx of images and ideas that he conjures. expressing them through his primal need to manifest them into the world. It is a universal language that he uses to tap into communities and connect with people from all walks of life. Each piece is created using an explosion of detail, line, and depth, formulating a controlled chaos that grabs the viewer and pulls them into the work. Marlon Pruz has collaborated with huge brands such as Vans, Off-White, and Mercedes-Benz. As well as, public murals and art showcased all over the world."
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "gap",
                children: " "
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "video",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("iframe", {
                    style: {
                        border: 0
                    },
                    id: "ytplayer",
                    type: "text/html",
                    width: "100%",
                    height: "100%",
                    src: "https://www.youtube.com/embed/qiE25K_VvPk",
                    frameBorder: "0",
                    allowFullScreen: "allowfullscreen",
                    mozallowfullscreen: "mozallowfullscreen",
                    msallowfullscreen: "msallowfullscreen",
                    oallowfullscreen: "oallowfullscreen",
                    webkitallowfullscreen: "webkitallowfullscreen"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "Desc"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "gap",
                children: " "
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "footer",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                        className: "metavate-p",
                        children: "Powered by"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("a", {
                        href: "https://metavate.io",
                        target: "_blank",
                        rel: "noopener",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                            src: (0, _metalogoPngDefault.default),
                            alt: "Metavate",
                            className: "MetavateLogo"
                        })
                    })
                ]
            })
        ]
    });
}
exports.default = Homepage;

},{"react/jsx-runtime":"gaGEj","./Homepage.css":"8zppS","../../assets/images/HeaderLogo.png":"cKK3I","../../assets/images/Title_RoadMap.png":"cBGsF","../../assets/images/Mario.png":"9D2dT","../../assets/images/Title_About.png":"jueKj","../../assets/images/WhatAreMF.png":"26pTU","../../assets/images/Twitter.png":"l9W3p","../../assets/images/Metalogo.png":"9T8p8","../Sliders/CollectionSlider":"75PXk","../Sliders/BioSlider":"iusoq","../Mint/Mint":"L3nU8","./Enter":"eQaWH","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8zppS":[function() {},{}],"cKK3I":[function(require,module,exports) {
module.exports = require("6e6ae45f1c43629c").getBundleURL("8aiQJ") + "HeaderLogo.9000a0b8.png";

},{"6e6ae45f1c43629c":"c7Tr5"}],"cBGsF":[function(require,module,exports) {
module.exports = require("9e1552fc18b3f3ae").getBundleURL("8aiQJ") + "Title_RoadMap.0b68b786.png";

},{"9e1552fc18b3f3ae":"c7Tr5"}],"9D2dT":[function(require,module,exports) {
module.exports = require("6537f4698b21417e").getBundleURL("8aiQJ") + "Mario.7a73307c.png";

},{"6537f4698b21417e":"c7Tr5"}],"jueKj":[function(require,module,exports) {
module.exports = require("fcbaf097344c765b").getBundleURL("8aiQJ") + "Title_About.46dc26aa.png";

},{"fcbaf097344c765b":"c7Tr5"}],"26pTU":[function(require,module,exports) {
module.exports = require("51c99a6268ed3b76").getBundleURL("8aiQJ") + "WhatAreMF.70f66656.png";

},{"51c99a6268ed3b76":"c7Tr5"}],"l9W3p":[function(require,module,exports) {
module.exports = require("92fa9205a44e430c").getBundleURL("8aiQJ") + "Twitter.86dd2f59.png";

},{"92fa9205a44e430c":"c7Tr5"}],"9T8p8":[function(require,module,exports) {
module.exports = require("a55510868ec3603c").getBundleURL("8aiQJ") + "Metalogo.78e2691b.png";

},{"a55510868ec3603c":"c7Tr5"}],"75PXk":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _collectionSliderScss = require("./CollectionSlider.scss");
const CollectionSlider = ()=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "collectionSlider",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            className: "collectionSlider-row"
        })
    });
};
exports.default = CollectionSlider;

},{"react/jsx-runtime":"gaGEj","react":"6uln9","./CollectionSlider.scss":"as29F","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"as29F":[function() {},{}],"iusoq":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _bioSliderScss = require("./BioSlider.scss");
const BioSlider = ()=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "bioSlider",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            className: "bioSlider-row"
        })
    });
};
exports.default = BioSlider;

},{"react/jsx-runtime":"gaGEj","react":"6uln9","./BioSlider.scss":"98Kze","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"98Kze":[function() {},{}],"L3nU8":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _mintCss = require("./Mint.css");
var _connect3 = require("../Smart/Connect3");
var _connect3Default = parcelHelpers.interopDefault(_connect3);
const Mint = ()=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "MintContainter",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _connect3Default.default), {})
    });
};
exports.default = Mint;

},{"react/jsx-runtime":"gaGEj","react":"6uln9","./Mint.css":"i1uw8","../Smart/Connect3":"bY7TA","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"i1uw8":[function() {},{}],"bY7TA":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _web3 = require("web3");
var _web3Default = parcelHelpers.interopDefault(_web3);
var _homepageCss = require("../HomepageComponent/Homepage.css");
var _alchemyWeb3 = require("@alch/alchemy-web3");
var _merkletreejs = require("merkletreejs");
var _keccak256 = require("keccak256");
var _keccak256Default = parcelHelpers.interopDefault(_keccak256);
// import { convertUtf8ToHex } from "@walletconnect/utils";
// @ts-ignore
var _web3Modal = require("web3modal");
var _web3ModalDefault = parcelHelpers.interopDefault(_web3Modal);
// @ts-ignore
var _web3Provider = require("@walletconnect/web3-provider");
var _web3ProviderDefault = parcelHelpers.interopDefault(_web3Provider);
// @ts-ignore
// import Torus from "@toruslabs/torus-embed";
// @ts-ignore
var _walletlink = require("walletlink");
var _walletlinkDefault = parcelHelpers.interopDefault(_walletlink);
var _button = require("./Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _column = require("./Column");
var _columnDefault = parcelHelpers.interopDefault(_column);
var _wrapper = require("./Wrapper");
var _wrapperDefault = parcelHelpers.interopDefault(_wrapper);
var _modal = require("./Modal");
var _modalDefault = parcelHelpers.interopDefault(_modal);
var _loader = require("./Loader");
var _loaderDefault = parcelHelpers.interopDefault(_loader);
var _utilities = require("./helpers/utilities");
var _styles = require("./styles");
var _web31 = require("./helpers/web3");
var _mintCount = require("./helpers/mintCount");
var _appCss = require("./App.css");
var _whitelist = require("./whitelist");
var _whitelistDefault = parcelHelpers.interopDefault(_whitelist);
const SLayout = (0, _styledComponentsDefault.default).div`
  position: relative;
  width: 100%;
  min-height: 650px; //vh100
  text-align: center;
`;
const SContent = (0, _styledComponentsDefault.default)((0, _wrapperDefault.default))`
  width: 100%;
  height: 100%;
  padding: 0 16px;
`;
const SContainer = (0, _styledComponentsDefault.default).div`
  height: 100%;
  min-height: 200px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  word-break: break-word;
`;
const SLanding = (0, _styledComponentsDefault.default)((0, _columnDefault.default))`
  height: 150px;
  //   padding-top: 60px;
`;
const SModalContainer = (0, _styledComponentsDefault.default).div`
  width: 100%;
  position: relative;
  word-wrap: break-word;
  color: #050a17 !important;
`;
const SModalTitle = (0, _styledComponentsDefault.default).div`
  margin: 1em 0;
  font-size: 20px;
  font-weight: 700;
`;
const SModalParagraph = (0, _styledComponentsDefault.default).p`
  margin-top: 30px;
`;
// @ts-ignore
const SBalances = (0, _styledComponentsDefault.default)(SLanding)`
  height: 100%;
  & h3 {
    // padding-top: 30px;
  }
`;
const STestButtonContainer = (0, _styledComponentsDefault.default).div`
  width: 100%;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
`;
const STestButton = (0, _styledComponentsDefault.default)((0, _buttonDefault.default))`
  //   border-radius: 8px;
  //   font-size: ${(0, _styles.fonts).size.medium};
  height: 150px;
  width: 100%;
  max-width: 175px;
  background-color: rgba(0, 0, 0, 0);

  //   background-image: url('/assets/images/Mint Button.png');
  background-size: 100% 100%;
  box-shadow: none !important;
`;
const presaleList = (0, _whitelistDefault.default);
const ALCHEMY_ID = "06TjEVJYYTgNryGP7Awp9F9HqnccVp0z";
function sliderValueText(value) {
    return `${value}`;
}
function getMerkleTree() {
    const leafNodes = presaleList.map((addr)=>(0, _keccak256Default.default)(addr));
    const merkleTree = new (0, _merkletreejs.MerkleTree)(leafNodes, (0, _keccak256Default.default), {
        sortPairs: true
    });
    console.log("root: 0x" + merkleTree.getRoot().toString("hex"));
    return merkleTree;
}
const nftContractAddress = "0xF0031782d37819F8E209C4421C774eD1f6163052";
const alchemyWeb3 = (0, _alchemyWeb3.createAlchemyWeb3)(`https://eth-mainnet.g.alchemy.com/v2/${ALCHEMY_ID}`); //https://eth-mainnet.alchemyapi.io/v2/${ALCHEMY_ID}`);
const ABI = [
    {
        inputs: [
            {
                internalType: "string",
                name: "_name",
                type: "string"
            },
            {
                internalType: "string",
                name: "_symbol",
                type: "string"
            }
        ],
        stateMutability: "nonpayable",
        type: "constructor"
    },
    {
        inputs: [],
        name: "AccessDenied",
        type: "error"
    },
    {
        inputs: [],
        name: "ApprovalCallerNotOwnerNorApproved",
        type: "error"
    },
    {
        inputs: [],
        name: "ApprovalQueryForNonexistentToken",
        type: "error"
    },
    {
        inputs: [],
        name: "BadInput",
        type: "error"
    },
    {
        inputs: [],
        name: "BalanceQueryForZeroAddress",
        type: "error"
    },
    {
        inputs: [],
        name: "EthValue",
        type: "error"
    },
    {
        inputs: [],
        name: "MaxSupply",
        type: "error"
    },
    {
        inputs: [],
        name: "MintERC2309QuantityExceedsLimit",
        type: "error"
    },
    {
        inputs: [],
        name: "MintLimit",
        type: "error"
    },
    {
        inputs: [],
        name: "MintToZeroAddress",
        type: "error"
    },
    {
        inputs: [],
        name: "MintZeroQuantity",
        type: "error"
    },
    {
        inputs: [],
        name: "OwnerQueryForNonexistentToken",
        type: "error"
    },
    {
        inputs: [],
        name: "OwnershipNotInitializedForExtraData",
        type: "error"
    },
    {
        inputs: [],
        name: "Paused",
        type: "error"
    },
    {
        inputs: [],
        name: "TransferCallerNotOwnerNorApproved",
        type: "error"
    },
    {
        inputs: [],
        name: "TransferFromIncorrectOwner",
        type: "error"
    },
    {
        inputs: [],
        name: "TransferToNonERC721ReceiverImplementer",
        type: "error"
    },
    {
        inputs: [],
        name: "TransferToZeroAddress",
        type: "error"
    },
    {
        inputs: [],
        name: "URIQueryForNonexistentToken",
        type: "error"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "owner",
                type: "address"
            },
            {
                indexed: true,
                internalType: "address",
                name: "approved",
                type: "address"
            },
            {
                indexed: true,
                internalType: "uint256",
                name: "tokenId",
                type: "uint256"
            }
        ],
        name: "Approval",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "owner",
                type: "address"
            },
            {
                indexed: true,
                internalType: "address",
                name: "operator",
                type: "address"
            },
            {
                indexed: false,
                internalType: "bool",
                name: "approved",
                type: "bool"
            }
        ],
        name: "ApprovalForAll",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "uint256",
                name: "fromTokenId",
                type: "uint256"
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "toTokenId",
                type: "uint256"
            },
            {
                indexed: true,
                internalType: "address",
                name: "from",
                type: "address"
            },
            {
                indexed: true,
                internalType: "address",
                name: "to",
                type: "address"
            }
        ],
        name: "ConsecutiveTransfer",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "from",
                type: "address"
            },
            {
                indexed: true,
                internalType: "address",
                name: "to",
                type: "address"
            },
            {
                indexed: true,
                internalType: "uint256",
                name: "tokenId",
                type: "uint256"
            }
        ],
        name: "Transfer",
        type: "event"
    },
    {
        stateMutability: "payable",
        type: "fallback"
    },
    {
        inputs: [],
        name: "admin",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "adminAccess",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "to",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256"
            }
        ],
        name: "approve",
        outputs: [],
        stateMutability: "payable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "owner",
                type: "address"
            }
        ],
        name: "balanceOf",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "baseURI",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "cost",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "mintQty",
                type: "uint256"
            },
            {
                internalType: "address",
                name: "recipient",
                type: "address"
            }
        ],
        name: "devMint",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "uint256[]",
                name: "quantity",
                type: "uint256[]"
            },
            {
                internalType: "address[]",
                name: "recipient",
                type: "address[]"
            }
        ],
        name: "devMint",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [],
        name: "freezeMetadata",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [],
        name: "frozen",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256"
            }
        ],
        name: "getApproved",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address"
            }
        ],
        name: "giftClaimed",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "owner",
                type: "address"
            },
            {
                internalType: "address",
                name: "operator",
                type: "address"
            }
        ],
        name: "isApprovedForAll",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "maxSupply",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "mintQty",
                type: "uint256"
            },
            {
                internalType: "bytes32[]",
                name: "_merkleProof",
                type: "bytes32[]"
            }
        ],
        name: "mferEarlyMint",
        outputs: [],
        stateMutability: "payable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "mintQty",
                type: "uint256"
            },
            {
                internalType: "bytes32[]",
                name: "_merkleProof",
                type: "bytes32[]"
            }
        ],
        name: "mferEarlyMintGift",
        outputs: [],
        stateMutability: "payable",
        type: "function"
    },
    {
        inputs: [],
        name: "mferMerkleRoot",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "mintQty",
                type: "uint256"
            }
        ],
        name: "mint",
        outputs: [],
        stateMutability: "payable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "mintQty",
                type: "uint256"
            },
            {
                internalType: "bytes32[]",
                name: "_merkleProof",
                type: "bytes32[]"
            }
        ],
        name: "mintMferGift",
        outputs: [],
        stateMutability: "payable",
        type: "function"
    },
    {
        inputs: [],
        name: "name",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "owner",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256"
            }
        ],
        name: "ownerOf",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "presale",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "newSupply",
                type: "uint256"
            }
        ],
        name: "reduceMaxSupply",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "from",
                type: "address"
            },
            {
                internalType: "address",
                name: "to",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256"
            }
        ],
        name: "safeTransferFrom",
        outputs: [],
        stateMutability: "payable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "from",
                type: "address"
            },
            {
                internalType: "address",
                name: "to",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256"
            },
            {
                internalType: "bytes",
                name: "_data",
                type: "bytes"
            }
        ],
        name: "safeTransferFrom",
        outputs: [],
        stateMutability: "payable",
        type: "function"
    },
    {
        inputs: [],
        name: "sale",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "operator",
                type: "address"
            },
            {
                internalType: "bool",
                name: "approved",
                type: "bool"
            }
        ],
        name: "setApprovalForAll",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "string",
                name: "_newBaseURI",
                type: "string"
            }
        ],
        name: "setBaseURI",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_cost",
                type: "uint256"
            }
        ],
        name: "setCost",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "root",
                type: "bytes32"
            }
        ],
        name: "setMerkleRoot",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "bytes4",
                name: "interfaceId",
                type: "bytes4"
            }
        ],
        name: "supportsInterface",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "symbol",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "toggleAdminAccess",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [],
        name: "togglePresale",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [],
        name: "toggleSale",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256"
            }
        ],
        name: "tokenURI",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "totalSupply",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "from",
                type: "address"
            },
            {
                internalType: "address",
                name: "to",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256"
            }
        ],
        name: "transferFrom",
        outputs: [],
        stateMutability: "payable",
        type: "function"
    },
    {
        inputs: [],
        name: "withdraw",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        stateMutability: "payable",
        type: "receive"
    }
];
function MintCount({ totalMinted }) {
    // const [totalMinted, setTotalMinted] = React.useState(null);
    // React.useEffect(() => {
    //   async function fetchMintCount() {
    //     const mintCount = await getMintCount();
    //     setTotalMinted(mintCount);
    //   }
    //   fetchMintCount();
    // }, []);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "text-center w-full",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
            className: "font text-3xl font-semibold w-full",
            children: [
                "Minted NFTs: ",
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
                " ",
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                    className: "5xl bg-[#510c0c] py-4 px-8 text-white rounded-full",
                    children: [
                        totalMinted !== null ? totalMinted : "Loading...",
                        " / 4200"
                    ]
                })
            ]
        })
    });
}
const nftContract = new alchemyWeb3.eth.Contract(ABI, nftContractAddress);
const sliderMarks = [
    {
        value: 1,
        label: "1"
    },
    {
        value: 5,
        label: "5+\uD83C\uDF81"
    },
    {
        value: 10,
        label: "10+\uD83C\uDF81\uD83C\uDF81"
    }
];
const INITIAL_STATE = {
    fetching: false,
    address: "",
    web3: null,
    provider: null,
    connected: false,
    chainId: 1,
    networkId: 1,
    assets: [],
    showModal: false,
    pendingRequest: false,
    result: null,
    mintQty: 1,
    buttonText: "CONNECT",
    presalePartner: null,
    cost: 0.022,
    // checkingWallet: true
    discountMints: 5,
    mintMax: 5,
    merkleTree: getMerkleTree(),
    presaleData: null,
    extraMint: false,
    soonMessage: false,
    showMessageModal: false,
    showSoldoutModal: false,
    showPresaleErrorModal: false,
    showGiftModal: false
};
function initWeb3(provider) {
    const web3 = new (0, _web3Default.default)(provider);
    web3.eth.extend({
        methods: [
            {
                name: "chainId",
                call: "eth_chainId",
                outputFormatter: web3.utils.hexToNumber
            }
        ]
    });
    return web3;
}
class App extends _react.Component {
    constructor(props){
        super(props);
        this.fetchMintCount = async ()=>{
            const mintCount = await (0, _mintCount.getMintCount)();
            this.setState({
                totalMinted: mintCount
            });
        };
        this.handlePresaleSetup = async (address)=>{
            var presaleData;
            address = alchemyWeb3.utils.toChecksumAddress(address);
            if (presaleList.includes(address)) {
                presaleData = this.getPresaleData(address);
                console.log("merkle data: ", presaleData);
                const claimed = await nftContract.methods.giftClaimed(address).call();
                console.log("gift claimed: ", claimed);
                this.setState({
                    presaleData,
                    extraMint: !claimed
                });
                if (claimed == false) this.toggleGiftModal();
            } else this.setState({
                presaleData: null,
                extraMint: false
            });
        };
        this.onConnect = async ()=>{
            try {
                this.setState({
                    checkingWallet: true
                });
                const provider = await this.web3Modal.connect();
                await this.subscribeProvider(provider);
                await provider.enable();
                const web3 = initWeb3(provider);
                const accounts = await web3.eth.getAccounts();
                const address = alchemyWeb3.utils.toChecksumAddress(accounts[0]);
                const networkId = await web3.eth.net.getId();
                const chainId = await web3.eth.chainId();
                this.handlePresaleSetup(address);
                await this.setState({
                    web3,
                    provider,
                    connected: true,
                    address,
                    chainId,
                    networkId,
                    // presaleData
                    checkingWallet: false
                });
                const btnText = document.getElementById("connect-btn-text");
                const btn = document.getElementById("connect-btn");
                this.setState({
                    buttonText: (0, _utilities.ellipseAddress)(accounts[0])
                });
                if (btn) btn.innerText = (0, _utilities.ellipseAddress)(accounts[0]);
                if (btn) btn.style.backgroundColor = "rgba(0,0,0,0)"; //"#b74848"//"red"
            // setTimeout(() => this.setState({checkingWallet: false}),500)
            // GET WHITELIST STATUS OR PARTNER NFTS
            } catch (error) {
                console.log("123");
                console.log(error);
                this.resetApp();
            }
        };
        this.onSliderUpdate = (event, value)=>{
            this.setState({
                mintQty: value
            });
        };
        this.subscribeProvider = async (provider)=>{
            if (!provider.on) return;
            provider.on("close", ()=>{
                console.log("disconnect");
                this.resetApp();
            });
            provider.on("disconnect", ()=>{
                console.log("disconnect");
                this.resetApp();
            });
            provider.on("accountsChanged", async (accounts)=>{
                console.log("account changed - accounts ", accounts);
                const address = accounts[0];
                this.handlePresaleSetup(address);
                this.setState({
                    buttonText: (0, _utilities.ellipseAddress)(address),
                    address: address
                });
                const btn = document.getElementById("connect-btn");
                if (btn) btn.innerText = (0, _utilities.ellipseAddress)(address);
            });
            provider.on("chainChanged", async (chainId)=>{
                console.log("chain changed");
                const { web3 } = this.state;
                const networkId = await web3.eth.net.getId();
                await this.setState({
                    chainId,
                    networkId
                });
            });
            provider.on("networkChanged", async (networkId)=>{
                console.log("network changed");
                const { web3 } = this.state;
                const chainId = await web3.eth.chainId();
                await this.setState({
                    chainId,
                    networkId
                });
            });
        };
        this.getNetwork = ()=>(0, _utilities.getChainData)(this.state.chainId).network;
        this.getProviderOptions = ()=>{
            const providerOptions = {
                walletconnect: {
                    package: (0, _web3ProviderDefault.default),
                    options: {
                        rpc: {
                            1: `https://eth-mainnet.g.alchemy.com/v2/${ALCHEMY_ID}`,
                            5: `https://eth-mainnet.g.alchemy.com/v2/${ALCHEMY_ID}`
                        }
                    }
                },
                "custom-walletlink": {
                    display: {
                        logo: "https://play-lh.googleusercontent.com/PjoJoG27miSglVBXoXrxBSLveV6e3EeBPpNY55aiUUBM9Q1RCETKCOqdOkX2ZydqVf0",
                        name: "Coinbase",
                        description: "Connect to Coinbase Wallet (not Coinbase App)"
                    },
                    options: {
                        jsonRpcUrl: `https://eth-mainnet.g.alchemy.com/v2/${ALCHEMY_ID}`,
                        appName: "fine art mfers",
                        networkUrl: `https://eth-mainnet.g.alchemy.com/v2/${ALCHEMY_ID}`,
                        rpc: {
                            1: `https://eth-mainnet.g.alchemy.com/v2/${ALCHEMY_ID}`,
                            5: `https://eth-mainnet.g.alchemy.com/v2/${ALCHEMY_ID}`
                        },
                        chainId: 1
                    },
                    package: (0, _walletlinkDefault.default),
                    connector: async (_, options)=>{
                        const { appName, networkUrl, chainId } = options;
                        const walletLink = new (0, _walletlinkDefault.default)({
                            appName
                        });
                        const provider = walletLink.makeWeb3Provider(networkUrl, chainId);
                        await provider.enable();
                        return provider;
                    }
                }
            };
            return providerOptions;
        };
        this.toggleModal = ()=>{
            this.setState({
                showModal: !this.state.showModal
            });
        };
        this.toggleMessageModal = ()=>{
            this.setState({
                showMessageModal: !this.state.showMessageModal
            });
        };
        this.toggleSoldoutModal = ()=>{
            this.setState({
                showSoldoutModal: !this.state.showSoldoutModal
            });
        };
        this.togglePresaleErrorModal = ()=>{
            this.setState({
                showPresaleErrorModal: !this.state.showPresaleErrorModal
            });
        };
        this.toggleGiftModal = ()=>{
            this.setState({
                showGiftModal: !this.state.showGiftModal
            });
        };
        this.startMint = async (functionSig)=>{
            const saleStarted = await nftContract.methods.sale().call();
            const presaleStarted = await nftContract.methods.presale().call();
            // console.log("PAUSED = ", paused)
            if (!saleStarted && !presaleStarted) {
                this.toggleMessageModal();
                return;
            }
            const totalSupply = await nftContract.methods.totalSupply().call();
            // console.log("total minted = ", totalSupply)
            if (totalSupply >= 4200) {
                this.toggleSoldoutModal();
                return;
            }
            const { web3, address, chainId, mintQty, cost, extraMint, presaleData } = this.state;
            try {
                // send transaction
                var result;
                if (presaleStarted && !saleStarted) {
                    console.log("starting presale mint");
                    // make this a modal popup
                    if (!presaleData) {
                        this.setState({
                            pendingRequest: false
                        });
                        this.togglePresaleErrorModal();
                        return;
                    }
                    // open modal
                    this.toggleModal();
                    // toggle pending request indicator
                    this.setState({
                        pendingRequest: true
                    });
                    result = await (0, _web31.callPresaleMint)(address, chainId, web3, mintQty, cost, nftContract, extraMint, presaleData);
                } else {
                    // open modal
                    this.toggleModal();
                    // toggle pending request indicator
                    this.setState({
                        pendingRequest: true
                    });
                    console.log("starting  mint");
                    result = await (0, _web31.callMint)(address, chainId, web3, mintQty, cost, nftContract, extraMint, presaleData);
                }
                const formattedResult = {
                    action: functionSig,
                    result
                };
                // display result
                this.setState({
                    web3,
                    pendingRequest: false,
                    result: formattedResult || null,
                    extraMint: false
                });
            } catch (error) {
                console.error(error); // tslint:disable-line
                this.setState({
                    web3,
                    pendingRequest: false,
                    result: null
                });
            }
        };
        this.resetApp = async ()=>{
            console.log("resetApp");
            await this.web3Modal.clearCachedProvider();
            if (this.state.provider?.disconnect && typeof this.state.provider.disconnect === "function") await this.state.provider.disconnect();
            this.setState({
                ...INITIAL_STATE
            });
            const btn = document.getElementById("connect-btn");
            if (btn) btn.style.backgroundColor = "rgba(64,153,255,0)";
            this.setState({
                buttonText: "CONNECT"
            });
            if (btn) btn.innerText = "CONNECT";
            // else {
            // }
            const { web3 } = this.state;
            if (web3 && web3.currentProvider && web3.currentProvider.close) await web3.currentProvider.close();
        };
        this.render = ()=>{
            const { //   assets,
            //   address,
            //   connected,
            //   chainId,
            //   fetching,
            showModal, pendingRequest, result, showMessageModal, showSoldoutModal, showPresaleErrorModal, showGiftModal, totalMinted } = this.state;
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)(SLayout, {
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _columnDefault.default), {
                            maxWidth: 1000,
                            spanHeight: true,
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)(SContent, {
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "Desc",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("h1", {
                                                children: "Congratulations all you fine mfers, we did it, we're all sold out!"
                                            })
                                        }),
                                        this.state.extraMint ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "DescMint6",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                id: "free-gift-message",
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("h1", {
                                                    children: "collector wallet detected! we recognize you as a real collector of fine NFTs and you will receive one free fine art mfer with your first mint, in addition to any other bonus NFTs you receive. This free NFT can only be claimed on your first purchase, but your bonus gift for buying multiples of 5 can be claimed on every mint."
                                                })
                                            })
                                        }) : "",
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {})
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "DescMint2",
                                    children: [
                                        this.state.chainId && this.state.chainId === 1 ? "" : /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            style: {
                                                color: "red"
                                            },
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("h1", {
                                                children: `YOU ARE ON THE WRONG NETWORK! CHANGE TO ETHEREUM MAINNET BEFORE MINTING`
                                            })
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {})
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _modalDefault.default), {
                            show: showModal,
                            toggleModal: this.toggleModal,
                            children: pendingRequest ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)(SModalContainer, {
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(SModalTitle, {
                                        children: "Pending Transaction"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(SContainer, {
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _loaderDefault.default), {}),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(SModalParagraph, {
                                                children: "Approve or reject transaction using your wallet"
                                            })
                                        ]
                                    })
                                ]
                            }) : result ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(SModalContainer, {
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(SModalTitle, {
                                    children: "Transaction Approved"
                                })
                            }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)(SModalContainer, {
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(SModalTitle, {
                                    children: "You did not confirm the transaction. Please try again."
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _modalDefault.default), {
                            show: showMessageModal,
                            toggleModal: this.toggleMessageModal,
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(SModalContainer, {
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(SModalTitle, {
                                    children: "coming soon mfer!"
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _modalDefault.default), {
                            show: showSoldoutModal,
                            toggleModal: this.toggleSoldoutModal,
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(SModalContainer, {
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(SModalTitle, {
                                    children: "sold out mfer!"
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _modalDefault.default), {
                            show: showPresaleErrorModal,
                            toggleModal: this.togglePresaleErrorModal,
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(SModalContainer, {
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(SModalTitle, {
                                    children: "Sorry you aren't on the presale list. Check back soon for open sale!"
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _modalDefault.default), {
                            show: showGiftModal,
                            toggleModal: this.toggleGiftModal,
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)(SModalContainer, {
                                className: "ModalContainer",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(SModalTitle, {
                                        className: "DescMint5",
                                        children: "a gift for you, mfer!"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(SModalTitle, {
                                        children: " as a recognized collector, you will receive 1 free fine art mfer with your first mint\u2026 in addition to the bonus NFTs for minting at least 5. this free nft will be claimed on your first purchase, but the bonus for buying multiples of 5 can be claimed on every purchase."
                                    })
                                ]
                            })
                        })
                    ]
                })
            });
        };
        this.mintQty = 1;
        this.state = {
            ...INITIAL_STATE,
            totalMinted: null
        };
        this.web3Modal = new (0, _web3ModalDefault.default)({
            network: this.getNetwork(),
            cacheProvider: true,
            providerOptions: this.getProviderOptions(),
            // theme: "dark"
            theme: {
                background: "rgb(39, 49, 56)",
                main: "rgb(240, 240, 240)",
                secondary: "rgb(185, 185, 185)",
                border: "rgba(195, 195, 195, 0.14)",
                hover: "rgb(16, 26, 32)"
            }
        });
    }
    componentDidMount() {
        // console.log("componentDidMount: ", this.state);
        if (this.web3Modal.cachedProvider) // console.log("componentDidMount -> onConnect")
        this.onConnect();
        this.fetchMintCount();
    }
    getPresaleData(address) {
        const merkleProof = this.state.merkleTree.getHexProof((0, _keccak256Default.default)(address));
        return merkleProof;
    }
    async getDiscountMints(address) {
        const discountMints = await nftContract.methods.discountMints(address).call();
        console.log("discountMints: ", discountMints);
        return discountMints;
    }
}
exports.default = App;

},{"react/jsx-runtime":"gaGEj","react":"6uln9","styled-components":"byVI1","web3":"hK09n","../HomepageComponent/Homepage.css":"8zppS","@alch/alchemy-web3":"be8H8","merkletreejs":"2GqqW","keccak256":"6266D","web3modal":"btbjS","@walletconnect/web3-provider":"fzWh4","walletlink":"lIFqn","./Button":"7DBr2","./Column":"cDB44","./Wrapper":"2ZHss","./Modal":"ijSqB","./Loader":"iL7xa","./helpers/utilities":"4UgH2","./styles":"iCPVY","./helpers/web3":"5mho7","./helpers/mintCount":"bQ7Gx","./App.css":"24iJU","./whitelist":"hr2w2","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"byVI1":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createGlobalStyle", ()=>createGlobalStyle);
parcelHelpers.export(exports, "css", ()=>css);
parcelHelpers.export(exports, "isStyledComponent", ()=>isStyledComponent);
parcelHelpers.export(exports, "keyframes", ()=>keyframes);
parcelHelpers.export(exports, "ServerStyleSheet", ()=>ServerStyleSheet);
parcelHelpers.export(exports, "StyleSheetConsumer", ()=>StyleSheetConsumer);
parcelHelpers.export(exports, "StyleSheetContext", ()=>StyleSheetContext);
parcelHelpers.export(exports, "StyleSheetManager", ()=>StyleSheetManager);
parcelHelpers.export(exports, "ThemeConsumer", ()=>ThemeConsumer);
parcelHelpers.export(exports, "ThemeContext", ()=>ThemeContext);
parcelHelpers.export(exports, "ThemeProvider", ()=>ThemeProvider);
parcelHelpers.export(exports, "withTheme", ()=>withTheme);
parcelHelpers.export(exports, "__DO_NOT_USE_OR_YOU_WILL_BE_HAUNTED_BY_SPOOKY_GHOSTS", ()=>__DO_NOT_USE_OR_YOU_WILL_BE_HAUNTED_BY_SPOOKY_GHOSTS);
var _stylisMin = require("stylis/stylis.min");
var _stylisMinDefault = parcelHelpers.interopDefault(_stylisMin);
var _stylisRuleSheet = require("stylis-rule-sheet");
var _stylisRuleSheetDefault = parcelHelpers.interopDefault(_stylisRuleSheet);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _unitless = require("@emotion/unitless");
var _unitlessDefault = parcelHelpers.interopDefault(_unitless);
var _reactIs = require("react-is");
var _memoizeOne = require("memoize-one");
var _memoizeOneDefault = parcelHelpers.interopDefault(_memoizeOne);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _isPropValid = require("@emotion/is-prop-valid");
var _isPropValidDefault = parcelHelpers.interopDefault(_isPropValid);
var _mergeAnything = require("merge-anything");
var _mergeAnythingDefault = parcelHelpers.interopDefault(_mergeAnything);
var process = require("50571207bc3cae02");
// 
var interleave = function(strings, interpolations) {
    var result = [
        strings[0]
    ];
    for(var i = 0, len = interpolations.length; i < len; i += 1)result.push(interpolations[i], strings[i + 1]);
    return result;
};
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
    return typeof obj;
} : function(obj) {
    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};
var classCallCheck = function(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
};
var createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
var _extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var inherits = function(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};
var objectWithoutProperties = function(obj, keys) {
    var target = {};
    for(var i in obj){
        if (keys.indexOf(i) >= 0) continue;
        if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
        target[i] = obj[i];
    }
    return target;
};
var possibleConstructorReturn = function(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
};
// 
var isPlainObject = function(x) {
    return (typeof x === "undefined" ? "undefined" : _typeof(x)) === "object" && x.constructor === Object;
};
// 
var EMPTY_ARRAY = Object.freeze([]);
var EMPTY_OBJECT = Object.freeze({});
// 
function isFunction(test) {
    return typeof test === "function";
}
// 
function getComponentName(target) {
    return (0, target.displayName) || target.name || "Component";
}
// 
function isStatelessFunction(test) {
    return typeof test === "function" && !(test.prototype && test.prototype.isReactComponent);
}
// 
function isStyledComponent(target) {
    return target && typeof target.styledComponentId === "string";
}
// 
var SC_ATTR = (typeof process !== "undefined" && undefined, "data-styled");
var SC_VERSION_ATTR = "data-styled-version";
var SC_STREAM_ATTR = "data-styled-streamed";
var IS_BROWSER = typeof window !== "undefined" && "HTMLElement" in window;
var DISABLE_SPEEDY = typeof SC_DISABLE_SPEEDY === "boolean" && SC_DISABLE_SPEEDY || typeof process !== "undefined" && undefined || false;
// Shared empty execution context when generating static styles
var STATIC_EXECUTION_CONTEXT = {};
// 
/**
 * Parse errors.md and turn it into a simple hash of code: message
 */ var ERRORS = {};
/**
 * super basic version of sprintf
 */ function format() {
    var a = arguments.length <= 0 ? undefined : arguments[0];
    var b = [];
    for(var c = 1, len = arguments.length; c < len; c += 1)b.push(arguments.length <= c ? undefined : arguments[c]);
    b.forEach(function(d) {
        a = a.replace(/%[a-z]/, d);
    });
    return a;
}
/**
 * Create an error file out of errors.md for development and a simple web link to the full errors
 * in production mode.
 */ var StyledComponentsError = function(_Error) {
    inherits(StyledComponentsError, _Error);
    function StyledComponentsError(code) {
        classCallCheck(this, StyledComponentsError);
        for(var _len = arguments.length, interpolations = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)interpolations[_key - 1] = arguments[_key];
        var _this;
        var _this = possibleConstructorReturn(this, _Error.call(this, "An error occurred. See https://github.com/styled-components/styled-components/blob/master/packages/styled-components/src/utils/errors.md#" + code + " for more information." + (interpolations.length > 0 ? " Additional arguments: " + interpolations.join(", ") : "")));
        return possibleConstructorReturn(_this);
    }
    return StyledComponentsError;
}(Error);
// 
var SC_COMPONENT_ID = /^[^\S\n]*?\/\* sc-component-id:\s*(\S+)\s+\*\//gm;
var extractComps = function(maybeCSS) {
    var css = "" + (maybeCSS || ""); // Definitely a string, and a clone
    var existingComponents = [];
    css.replace(SC_COMPONENT_ID, function(match, componentId, matchIndex) {
        existingComponents.push({
            componentId: componentId,
            matchIndex: matchIndex
        });
        return match;
    });
    return existingComponents.map(function(_ref, i) {
        var componentId = _ref.componentId, matchIndex = _ref.matchIndex;
        var nextComp = existingComponents[i + 1];
        var cssFromDOM = nextComp ? css.slice(matchIndex, nextComp.matchIndex) : css.slice(matchIndex);
        return {
            componentId: componentId,
            cssFromDOM: cssFromDOM
        };
    });
};
// 
var COMMENT_REGEX = /^\s*\/\/.*$/gm;
// NOTE: This stylis instance is only used to split rules from SSR'd style tags
var stylisSplitter = new (0, _stylisMinDefault.default)({
    global: false,
    cascade: true,
    keyframe: false,
    prefix: false,
    compress: false,
    semicolon: true
});
var stylis = new (0, _stylisMinDefault.default)({
    global: false,
    cascade: true,
    keyframe: false,
    prefix: true,
    compress: false,
    semicolon: false // NOTE: This means "autocomplete missing semicolons"
});
// Wrap `insertRulePlugin to build a list of rules,
// and then make our own plugin to return the rules. This
// makes it easier to hook into the existing SSR architecture
var parsingRules = [];
// eslint-disable-next-line consistent-return
var returnRulesPlugin = function returnRulesPlugin(context) {
    if (context === -2) {
        var parsedRules = parsingRules;
        parsingRules = [];
        return parsedRules;
    }
};
var parseRulesPlugin = (0, _stylisRuleSheetDefault.default)(function(rule) {
    parsingRules.push(rule);
});
var _componentId = void 0;
var _selector = void 0;
var _selectorRegexp = void 0;
var selfReferenceReplacer = function selfReferenceReplacer(match, offset, string) {
    if (// the first self-ref is always untouched
    offset > 0 && // there should be at least two self-refs to do a replacement (.b > .b)
    string.slice(0, offset).indexOf(_selector) !== -1 && // no consecutive self refs (.b.b); that is a precedence boost and treated differently
    string.slice(offset - _selector.length, offset) !== _selector) return "." + _componentId;
    return match;
};
/**
 * When writing a style like
 *
 * & + & {
 *   color: red;
 * }
 *
 * The second ampersand should be a reference to the static component class. stylis
 * has no knowledge of static class so we have to intelligently replace the base selector.
 */ var selfReferenceReplacementPlugin = function selfReferenceReplacementPlugin(context, _, selectors) {
    if (context === 2 && selectors.length && selectors[0].lastIndexOf(_selector) > 0) // eslint-disable-next-line no-param-reassign
    selectors[0] = selectors[0].replace(_selectorRegexp, selfReferenceReplacer);
};
stylis.use([
    selfReferenceReplacementPlugin,
    parseRulesPlugin,
    returnRulesPlugin
]);
stylisSplitter.use([
    parseRulesPlugin,
    returnRulesPlugin
]);
var splitByRules = function splitByRules(css) {
    return stylisSplitter("", css);
};
function stringifyRules(rules, selector, prefix) {
    var componentId = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : "&";
    var flatCSS = rules.join("").replace(COMMENT_REGEX, ""); // replace JS comments
    var cssStr = selector && prefix ? prefix + " " + selector + " { " + flatCSS + " }" : flatCSS;
    // stylis has no concept of state to be passed to plugins
    // but since JS is single=threaded, we can rely on that to ensure
    // these properties stay in sync with the current stylis run
    _componentId = componentId;
    _selector = selector;
    _selectorRegexp = new RegExp("\\" + _selector + "\\b", "g");
    return stylis(prefix || !selector ? "" : selector, cssStr);
}
// 
/* eslint-disable camelcase, no-undef */ var getNonce = function() {
    return typeof __webpack_nonce__ !== "undefined" ? __webpack_nonce__ : null;
};
// 
/* These are helpers for the StyleTags to keep track of the injected
 * rule names for each (component) ID that they're keeping track of.
 * They're crucial for detecting whether a name has already been
 * injected.
 * (This excludes rehydrated names) */ /* adds a new ID:name pairing to a names dictionary */ var addNameForId = function addNameForId(names, id, name) {
    if (name) {
        // eslint-disable-next-line no-param-reassign
        var namesForId = names[id] || (names[id] = Object.create(null));
        namesForId[name] = true;
    }
};
/* resets an ID entirely by overwriting it in the dictionary */ var resetIdNames = function resetIdNames(names, id) {
    // eslint-disable-next-line no-param-reassign
    names[id] = Object.create(null);
};
/* factory for a names dictionary checking the existance of an ID:name pairing */ var hasNameForId = function hasNameForId(names) {
    return function(id, name) {
        return names[id] !== undefined && names[id][name];
    };
};
/* stringifies names for the html/element output */ var stringifyNames = function stringifyNames(names) {
    var str = "";
    // eslint-disable-next-line guard-for-in
    for(var id in names)str += Object.keys(names[id]).join(" ") + " ";
    return str.trim();
};
/* clones the nested names dictionary */ var cloneNames = function cloneNames(names) {
    var clone = Object.create(null);
    // eslint-disable-next-line guard-for-in
    for(var id in names)clone[id] = _extends({}, names[id]);
    return clone;
};
// 
/* These are helpers that deal with the insertRule (aka speedy) API
 * They are used in the StyleTags and specifically the speedy tag
 */ /* retrieve a sheet for a given style tag */ var sheetForTag = function sheetForTag(tag) {
    // $FlowFixMe
    if (tag.sheet) return tag.sheet;
    /* Firefox quirk requires us to step through all stylesheets to find one owned by the given tag */ var size = tag.ownerDocument.styleSheets.length;
    for(var i = 0; i < size; i += 1){
        var sheet = tag.ownerDocument.styleSheets[i];
        // $FlowFixMe
        if (sheet.ownerNode === tag) return sheet;
    }
    /* we should always be able to find a tag */ throw new StyledComponentsError(10);
};
/* insert a rule safely and return whether it was actually injected */ var safeInsertRule = function safeInsertRule(sheet, cssRule, index) {
    /* abort early if cssRule string is falsy */ if (!cssRule) return false;
    var maxIndex = sheet.cssRules.length;
    try {
        /* use insertRule and cap passed index with maxIndex (no of cssRules) */ sheet.insertRule(cssRule, index <= maxIndex ? index : maxIndex);
    } catch (err) {
        /* any error indicates an invalid rule */ return false;
    }
    return true;
};
/* deletes `size` rules starting from `removalIndex` */ var deleteRules = function deleteRules(sheet, removalIndex, size) {
    var lowerBound = removalIndex - size;
    for(var i = removalIndex; i > lowerBound; i -= 1)sheet.deleteRule(i);
};
// 
/* this marker separates component styles and is important for rehydration */ var makeTextMarker = function makeTextMarker(id) {
    return "\n/* sc-component-id: " + id + " */\n";
};
/* add up all numbers in array up until and including the index */ var addUpUntilIndex = function addUpUntilIndex(sizes, index) {
    var totalUpToIndex = 0;
    for(var i = 0; i <= index; i += 1)totalUpToIndex += sizes[i];
    return totalUpToIndex;
};
/* create a new style tag after lastEl */ var makeStyleTag = function makeStyleTag(target, tagEl, insertBefore) {
    var targetDocument = document;
    if (target) targetDocument = target.ownerDocument;
    else if (tagEl) targetDocument = tagEl.ownerDocument;
    var el = targetDocument.createElement("style");
    el.setAttribute(SC_ATTR, "");
    el.setAttribute(SC_VERSION_ATTR, "4.4.1");
    var nonce = getNonce();
    if (nonce) el.setAttribute("nonce", nonce);
    /* Work around insertRule quirk in EdgeHTML */ el.appendChild(targetDocument.createTextNode(""));
    if (target && !tagEl) /* Append to target when no previous element was passed */ target.appendChild(el);
    else {
        if (!tagEl || !target || !tagEl.parentNode) throw new StyledComponentsError(6);
        /* Insert new style tag after the previous one */ tagEl.parentNode.insertBefore(el, insertBefore ? tagEl : tagEl.nextSibling);
    }
    return el;
};
/* takes a css factory function and outputs an html styled tag factory */ var wrapAsHtmlTag = function wrapAsHtmlTag(css, names) {
    return function(additionalAttrs) {
        var nonce = getNonce();
        var attrs = [
            nonce && 'nonce="' + nonce + '"',
            SC_ATTR + '="' + stringifyNames(names) + '"',
            SC_VERSION_ATTR + '="' + "4.4.1" + '"',
            additionalAttrs
        ];
        var htmlAttr = attrs.filter(Boolean).join(" ");
        return "<style " + htmlAttr + ">" + css() + "</style>";
    };
};
/* takes a css factory function and outputs an element factory */ var wrapAsElement = function wrapAsElement(css, names) {
    return function() {
        var _props;
        var props = (_props = {}, _props[SC_ATTR] = stringifyNames(names), _props[SC_VERSION_ATTR] = "4.4.1", _props);
        var nonce = getNonce();
        if (nonce) // $FlowFixMe
        props.nonce = nonce;
        // eslint-disable-next-line react/no-danger
        return (0, _reactDefault.default).createElement("style", _extends({}, props, {
            dangerouslySetInnerHTML: {
                __html: css()
            }
        }));
    };
};
var getIdsFromMarkersFactory = function getIdsFromMarkersFactory(markers) {
    return function() {
        return Object.keys(markers);
    };
};
/* speedy tags utilise insertRule */ var makeSpeedyTag = function makeSpeedyTag(el, getImportRuleTag) {
    var names = Object.create(null);
    var markers = Object.create(null);
    var sizes = [];
    var extractImport = getImportRuleTag !== undefined;
    /* indicates whether getImportRuleTag was called */ var usedImportRuleTag = false;
    var insertMarker = function insertMarker(id) {
        var prev = markers[id];
        if (prev !== undefined) return prev;
        markers[id] = sizes.length;
        sizes.push(0);
        resetIdNames(names, id);
        return markers[id];
    };
    var insertRules = function insertRules(id, cssRules, name) {
        var marker = insertMarker(id);
        var sheet = sheetForTag(el);
        var insertIndex = addUpUntilIndex(sizes, marker);
        var injectedRules = 0;
        var importRules = [];
        var cssRulesSize = cssRules.length;
        for(var i = 0; i < cssRulesSize; i += 1){
            var cssRule = cssRules[i];
            var mayHaveImport = extractImport; /* @import rules are reordered to appear first */ 
            if (mayHaveImport && cssRule.indexOf("@import") !== -1) importRules.push(cssRule);
            else if (safeInsertRule(sheet, cssRule, insertIndex + injectedRules)) {
                mayHaveImport = false;
                injectedRules += 1;
            }
        }
        if (extractImport && importRules.length > 0) {
            usedImportRuleTag = true;
            // $FlowFixMe
            getImportRuleTag().insertRules(id + "-import", importRules);
        }
        sizes[marker] += injectedRules; /* add up no of injected rules */ 
        addNameForId(names, id, name);
    };
    var removeRules = function removeRules(id) {
        var marker = markers[id];
        if (marker === undefined) return;
        // $FlowFixMe
        if (el.isConnected === false) return;
        var size = sizes[marker];
        var sheet = sheetForTag(el);
        var removalIndex = addUpUntilIndex(sizes, marker) - 1;
        deleteRules(sheet, removalIndex, size);
        sizes[marker] = 0;
        resetIdNames(names, id);
        if (extractImport && usedImportRuleTag) // $FlowFixMe
        getImportRuleTag().removeRules(id + "-import");
    };
    var css = function css() {
        var _sheetForTag = sheetForTag(el), cssRules = _sheetForTag.cssRules;
        var str = "";
        // eslint-disable-next-line guard-for-in
        for(var id in markers){
            str += makeTextMarker(id);
            var marker = markers[id];
            var end = addUpUntilIndex(sizes, marker);
            var size = sizes[marker];
            for(var i = end - size; i < end; i += 1){
                var rule = cssRules[i];
                if (rule !== undefined) str += rule.cssText;
            }
        }
        return str;
    };
    return {
        clone: function clone() {
            throw new StyledComponentsError(5);
        },
        css: css,
        getIds: getIdsFromMarkersFactory(markers),
        hasNameForId: hasNameForId(names),
        insertMarker: insertMarker,
        insertRules: insertRules,
        removeRules: removeRules,
        sealed: false,
        styleTag: el,
        toElement: wrapAsElement(css, names),
        toHTML: wrapAsHtmlTag(css, names)
    };
};
var makeTextNode = function makeTextNode(targetDocument, id) {
    return targetDocument.createTextNode(makeTextMarker(id));
};
var makeBrowserTag = function makeBrowserTag(el, getImportRuleTag) {
    var names = Object.create(null);
    var markers = Object.create(null);
    var extractImport = getImportRuleTag !== undefined;
    /* indicates whether getImportRuleTag was called */ var usedImportRuleTag = false;
    var insertMarker = function insertMarker(id) {
        var prev = markers[id];
        if (prev !== undefined) return prev;
        markers[id] = makeTextNode(el.ownerDocument, id);
        el.appendChild(markers[id]);
        names[id] = Object.create(null);
        return markers[id];
    };
    var insertRules = function insertRules(id, cssRules, name) {
        var marker = insertMarker(id);
        var importRules = [];
        var cssRulesSize = cssRules.length;
        for(var i = 0; i < cssRulesSize; i += 1){
            var rule = cssRules[i];
            var mayHaveImport = extractImport;
            if (mayHaveImport && rule.indexOf("@import") !== -1) importRules.push(rule);
            else {
                mayHaveImport = false;
                var separator = i === cssRulesSize - 1 ? "" : " ";
                marker.appendData("" + rule + separator);
            }
        }
        addNameForId(names, id, name);
        if (extractImport && importRules.length > 0) {
            usedImportRuleTag = true;
            // $FlowFixMe
            getImportRuleTag().insertRules(id + "-import", importRules);
        }
    };
    var removeRules = function removeRules(id) {
        var marker = markers[id];
        if (marker === undefined) return;
        /* create new empty text node and replace the current one */ var newMarker = makeTextNode(el.ownerDocument, id);
        el.replaceChild(newMarker, marker);
        markers[id] = newMarker;
        resetIdNames(names, id);
        if (extractImport && usedImportRuleTag) // $FlowFixMe
        getImportRuleTag().removeRules(id + "-import");
    };
    var css = function css() {
        var str = "";
        // eslint-disable-next-line guard-for-in
        for(var id in markers)str += markers[id].data;
        return str;
    };
    return {
        clone: function clone() {
            throw new StyledComponentsError(5);
        },
        css: css,
        getIds: getIdsFromMarkersFactory(markers),
        hasNameForId: hasNameForId(names),
        insertMarker: insertMarker,
        insertRules: insertRules,
        removeRules: removeRules,
        sealed: false,
        styleTag: el,
        toElement: wrapAsElement(css, names),
        toHTML: wrapAsHtmlTag(css, names)
    };
};
var makeServerTag = function makeServerTag(namesArg, markersArg) {
    var names = namesArg === undefined ? Object.create(null) : namesArg;
    var markers = markersArg === undefined ? Object.create(null) : markersArg;
    var insertMarker = function insertMarker(id) {
        var prev = markers[id];
        if (prev !== undefined) return prev;
        return markers[id] = [
            ""
        ];
    };
    var insertRules = function insertRules(id, cssRules, name) {
        var marker = insertMarker(id);
        marker[0] += cssRules.join(" ");
        addNameForId(names, id, name);
    };
    var removeRules = function removeRules(id) {
        var marker = markers[id];
        if (marker === undefined) return;
        marker[0] = "";
        resetIdNames(names, id);
    };
    var css = function css() {
        var str = "";
        // eslint-disable-next-line guard-for-in
        for(var id in markers){
            var cssForId = markers[id][0];
            if (cssForId) str += makeTextMarker(id) + cssForId;
        }
        return str;
    };
    var clone = function clone() {
        var namesClone = cloneNames(names);
        var markersClone = Object.create(null);
        // eslint-disable-next-line guard-for-in
        for(var id in markers)markersClone[id] = [
            markers[id][0]
        ];
        return makeServerTag(namesClone, markersClone);
    };
    var tag = {
        clone: clone,
        css: css,
        getIds: getIdsFromMarkersFactory(markers),
        hasNameForId: hasNameForId(names),
        insertMarker: insertMarker,
        insertRules: insertRules,
        removeRules: removeRules,
        sealed: false,
        styleTag: null,
        toElement: wrapAsElement(css, names),
        toHTML: wrapAsHtmlTag(css, names)
    };
    return tag;
};
var makeTag = function makeTag(target, tagEl, forceServer, insertBefore, getImportRuleTag) {
    if (IS_BROWSER && !forceServer) {
        var el = makeStyleTag(target, tagEl, insertBefore);
        if (DISABLE_SPEEDY) return makeBrowserTag(el, getImportRuleTag);
        else return makeSpeedyTag(el, getImportRuleTag);
    }
    return makeServerTag();
};
var rehydrate = function rehydrate(tag, els, extracted) {
    /* add all extracted components to the new tag */ for(var i = 0, len = extracted.length; i < len; i += 1){
        var _extracted$i = extracted[i], componentId = _extracted$i.componentId, cssFromDOM = _extracted$i.cssFromDOM;
        var cssRules = splitByRules(cssFromDOM);
        tag.insertRules(componentId, cssRules);
    }
    /* remove old HTMLStyleElements, since they have been rehydrated */ for(var _i = 0, _len = els.length; _i < _len; _i += 1){
        var el = els[_i];
        if (el.parentNode) el.parentNode.removeChild(el);
    }
};
// 
var SPLIT_REGEX = /\s+/;
/* determine the maximum number of components before tags are sharded */ var MAX_SIZE = void 0;
if (IS_BROWSER) /* in speedy mode we can keep a lot more rules in a sheet before a slowdown can be expected */ MAX_SIZE = DISABLE_SPEEDY ? 40 : 1000;
else /* for servers we do not need to shard at all */ MAX_SIZE = -1;
var sheetRunningId = 0;
var master = void 0;
var StyleSheet = function() {
    /* a map from ids to tags */ /* deferred rules for a given id */ /* this is used for not reinjecting rules via hasNameForId() */ /* when rules for an id are removed using remove() we have to ignore rehydratedNames for it */ /* a list of tags belonging to this StyleSheet */ /* a tag for import rules */ /* current capacity until a new tag must be created */ /* children (aka clones) of this StyleSheet inheriting all and future injections */ function StyleSheet() {
        var _this = this;
        var target = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : IS_BROWSER ? document.head : null;
        var forceServer = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        classCallCheck(this, StyleSheet);
        this.getImportRuleTag = function() {
            var importRuleTag = _this.importRuleTag;
            if (importRuleTag !== undefined) return importRuleTag;
            var firstTag = _this.tags[0];
            var insertBefore = true;
            return _this.importRuleTag = makeTag(_this.target, firstTag ? firstTag.styleTag : null, _this.forceServer, insertBefore);
        };
        sheetRunningId += 1;
        this.id = sheetRunningId;
        this.forceServer = forceServer;
        this.target = forceServer ? null : target;
        this.tagMap = {};
        this.deferred = {};
        this.rehydratedNames = {};
        this.ignoreRehydratedNames = {};
        this.tags = [];
        this.capacity = 1;
        this.clones = [];
    }
    /* rehydrate all SSR'd style tags */ StyleSheet.prototype.rehydrate = function rehydrate$$1() {
        if (!IS_BROWSER || this.forceServer) return this;
        var els = [];
        var extracted = [];
        var isStreamed = false;
        /* retrieve all of our SSR style elements from the DOM */ var nodes = document.querySelectorAll("style[" + SC_ATTR + "][" + SC_VERSION_ATTR + '="' + "4.4.1" + '"]');
        var nodesSize = nodes.length;
        /* abort rehydration if no previous style tags were found */ if (!nodesSize) return this;
        for(var i = 0; i < nodesSize; i += 1){
            var el = nodes[i];
            /* check if style tag is a streamed tag */ if (!isStreamed) isStreamed = !!el.getAttribute(SC_STREAM_ATTR);
            /* retrieve all component names */ var elNames = (el.getAttribute(SC_ATTR) || "").trim().split(SPLIT_REGEX);
            var elNamesSize = elNames.length;
            for(var j = 0, name; j < elNamesSize; j += 1){
                name = elNames[j];
                /* add rehydrated name to sheet to avoid re-adding styles */ this.rehydratedNames[name] = true;
            }
            /* extract all components and their CSS */ extracted.push.apply(extracted, extractComps(el.textContent));
            /* store original HTMLStyleElement */ els.push(el);
        }
        /* abort rehydration if nothing was extracted */ var extractedSize = extracted.length;
        if (!extractedSize) return this;
        /* create a tag to be used for rehydration */ var tag = this.makeTag(null);
        rehydrate(tag, els, extracted);
        /* reset capacity and adjust MAX_SIZE by the initial size of the rehydration */ this.capacity = Math.max(1, MAX_SIZE - extractedSize);
        this.tags.push(tag);
        /* retrieve all component ids */ for(var _j = 0; _j < extractedSize; _j += 1)this.tagMap[extracted[_j].componentId] = tag;
        return this;
    };
    /* retrieve a "master" instance of StyleSheet which is typically used when no other is available
   * The master StyleSheet is targeted by createGlobalStyle, keyframes, and components outside of any
    * StyleSheetManager's context */ /* reset the internal "master" instance */ StyleSheet.reset = function reset() {
        var forceServer = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
        master = new StyleSheet(undefined, forceServer).rehydrate();
    };
    /* adds "children" to the StyleSheet that inherit all of the parents' rules
   * while their own rules do not affect the parent */ StyleSheet.prototype.clone = function clone() {
        var sheet = new StyleSheet(this.target, this.forceServer);
        /* add to clone array */ this.clones.push(sheet);
        /* clone all tags */ sheet.tags = this.tags.map(function(tag) {
            var ids = tag.getIds();
            var newTag = tag.clone();
            /* reconstruct tagMap */ for(var i = 0; i < ids.length; i += 1)sheet.tagMap[ids[i]] = newTag;
            return newTag;
        });
        /* clone other maps */ sheet.rehydratedNames = _extends({}, this.rehydratedNames);
        sheet.deferred = _extends({}, this.deferred);
        return sheet;
    };
    /* force StyleSheet to create a new tag on the next injection */ StyleSheet.prototype.sealAllTags = function sealAllTags() {
        this.capacity = 1;
        this.tags.forEach(function(tag) {
            // eslint-disable-next-line no-param-reassign
            tag.sealed = true;
        });
    };
    StyleSheet.prototype.makeTag = function makeTag$$1(tag) {
        var lastEl = tag ? tag.styleTag : null;
        var insertBefore = false;
        return makeTag(this.target, lastEl, this.forceServer, insertBefore, this.getImportRuleTag);
    };
    /* get a tag for a given componentId, assign the componentId to one, or shard */ StyleSheet.prototype.getTagForId = function getTagForId(id) {
        /* simply return a tag, when the componentId was already assigned one */ var prev = this.tagMap[id];
        if (prev !== undefined && !prev.sealed) return prev;
        var tag = this.tags[this.tags.length - 1];
        /* shard (create a new tag) if the tag is exhausted (See MAX_SIZE) */ this.capacity -= 1;
        if (this.capacity === 0) {
            this.capacity = MAX_SIZE;
            tag = this.makeTag(tag);
            this.tags.push(tag);
        }
        return this.tagMap[id] = tag;
    };
    /* mainly for createGlobalStyle to check for its id */ StyleSheet.prototype.hasId = function hasId(id) {
        return this.tagMap[id] !== undefined;
    };
    /* caching layer checking id+name to already have a corresponding tag and injected rules */ StyleSheet.prototype.hasNameForId = function hasNameForId(id, name) {
        /* exception for rehydrated names which are checked separately */ if (this.ignoreRehydratedNames[id] === undefined && this.rehydratedNames[name]) return true;
        var tag = this.tagMap[id];
        return tag !== undefined && tag.hasNameForId(id, name);
    };
    /* registers a componentId and registers it on its tag */ StyleSheet.prototype.deferredInject = function deferredInject(id, cssRules) {
        /* don't inject when the id is already registered */ if (this.tagMap[id] !== undefined) return;
        var clones = this.clones;
        for(var i = 0; i < clones.length; i += 1)clones[i].deferredInject(id, cssRules);
        this.getTagForId(id).insertMarker(id);
        this.deferred[id] = cssRules;
    };
    /* injects rules for a given id with a name that will need to be cached */ StyleSheet.prototype.inject = function inject(id, cssRules, name) {
        var clones = this.clones;
        for(var i = 0; i < clones.length; i += 1)clones[i].inject(id, cssRules, name);
        var tag = this.getTagForId(id);
        /* add deferred rules for component */ if (this.deferred[id] !== undefined) {
            // Combine passed cssRules with previously deferred CSS rules
            // NOTE: We cannot mutate the deferred array itself as all clones
            // do the same (see clones[i].inject)
            var rules = this.deferred[id].concat(cssRules);
            tag.insertRules(id, rules, name);
            this.deferred[id] = undefined;
        } else tag.insertRules(id, cssRules, name);
    };
    /* removes all rules for a given id, which doesn't remove its marker but resets it */ StyleSheet.prototype.remove = function remove(id) {
        var tag = this.tagMap[id];
        if (tag === undefined) return;
        var clones = this.clones;
        for(var i = 0; i < clones.length; i += 1)clones[i].remove(id);
        /* remove all rules from the tag */ tag.removeRules(id);
        /* ignore possible rehydrated names */ this.ignoreRehydratedNames[id] = true;
        /* delete possible deferred rules */ this.deferred[id] = undefined;
    };
    StyleSheet.prototype.toHTML = function toHTML() {
        return this.tags.map(function(tag) {
            return tag.toHTML();
        }).join("");
    };
    StyleSheet.prototype.toReactElements = function toReactElements() {
        var id = this.id;
        return this.tags.map(function(tag, i) {
            var key = "sc-" + id + "-" + i;
            return (0, _react.cloneElement)(tag.toElement(), {
                key: key
            });
        });
    };
    createClass(StyleSheet, null, [
        {
            key: "master",
            get: function get$$1() {
                return master || (master = new StyleSheet().rehydrate());
            }
        },
        {
            key: "instance",
            get: function get$$1() {
                return StyleSheet.master;
            }
        }
    ]);
    return StyleSheet;
}();
// 
var Keyframes = function() {
    function Keyframes(name, rules) {
        var _this = this;
        classCallCheck(this, Keyframes);
        this.inject = function(styleSheet) {
            if (!styleSheet.hasNameForId(_this.id, _this.name)) styleSheet.inject(_this.id, _this.rules, _this.name);
        };
        this.toString = function() {
            throw new StyledComponentsError(12, String(_this.name));
        };
        this.name = name;
        this.rules = rules;
        this.id = "sc-keyframes-" + name;
    }
    Keyframes.prototype.getName = function getName() {
        return this.name;
    };
    return Keyframes;
}();
// 
/**
 * inlined version of
 * https://github.com/facebook/fbjs/blob/master/packages/fbjs/src/core/hyphenateStyleName.js
 */ var uppercasePattern = /([A-Z])/g;
var msPattern = /^ms-/;
/**
 * Hyphenates a camelcased CSS property name, for example:
 *
 *   > hyphenateStyleName('backgroundColor')
 *   < "background-color"
 *   > hyphenateStyleName('MozTransition')
 *   < "-moz-transition"
 *   > hyphenateStyleName('msTransition')
 *   < "-ms-transition"
 *
 * As Modernizr suggests (http://modernizr.com/docs/#prefixed), an `ms` prefix
 * is converted to `-ms-`.
 *
 * @param {string} string
 * @return {string}
 */ function hyphenateStyleName(string) {
    return string.replace(uppercasePattern, "-$1").toLowerCase().replace(msPattern, "-ms-");
}
// 
// Taken from https://github.com/facebook/react/blob/b87aabdfe1b7461e7331abb3601d9e6bb27544bc/packages/react-dom/src/shared/dangerousStyleValue.js
function addUnitIfNeeded(name, value) {
    // https://github.com/amilajack/eslint-plugin-flowtype-errors/issues/133
    // $FlowFixMe
    if (value == null || typeof value === "boolean" || value === "") return "";
    if (typeof value === "number" && value !== 0 && !(name in (0, _unitlessDefault.default))) return value + "px"; // Presumes implicit 'px' suffix for unitless numbers
    return String(value).trim();
}
// 
/**
 * It's falsish not falsy because 0 is allowed.
 */ var isFalsish = function isFalsish(chunk) {
    return chunk === undefined || chunk === null || chunk === false || chunk === "";
};
var objToCssArray = function objToCssArray(obj, prevKey) {
    var rules = [];
    var keys = Object.keys(obj);
    keys.forEach(function(key) {
        if (!isFalsish(obj[key])) {
            if (isPlainObject(obj[key])) {
                rules.push.apply(rules, objToCssArray(obj[key], key));
                return rules;
            } else if (isFunction(obj[key])) {
                rules.push(hyphenateStyleName(key) + ":", obj[key], ";");
                return rules;
            }
            rules.push(hyphenateStyleName(key) + ": " + addUnitIfNeeded(key, obj[key]) + ";");
        }
        return rules;
    });
    return prevKey ? [
        prevKey + " {"
    ].concat(rules, [
        "}"
    ]) : rules;
};
function flatten(chunk, executionContext, styleSheet) {
    if (Array.isArray(chunk)) {
        var ruleSet = [];
        for(var i = 0, len = chunk.length, result; i < len; i += 1){
            result = flatten(chunk[i], executionContext, styleSheet);
            if (result === null) continue;
            else if (Array.isArray(result)) ruleSet.push.apply(ruleSet, result);
            else ruleSet.push(result);
        }
        return ruleSet;
    }
    if (isFalsish(chunk)) return null;
    /* Handle other components */ if (isStyledComponent(chunk)) return "." + chunk.styledComponentId;
    /* Either execute or defer the function */ if (isFunction(chunk)) {
        if (isStatelessFunction(chunk) && executionContext) {
            var _result = chunk(executionContext);
            return flatten(_result, executionContext, styleSheet);
        } else return chunk;
    }
    if (chunk instanceof Keyframes) {
        if (styleSheet) {
            chunk.inject(styleSheet);
            return chunk.getName();
        } else return chunk;
    }
    /* Handle objects */ return isPlainObject(chunk) ? objToCssArray(chunk) : chunk.toString();
}
// 
function css(styles) {
    for(var _len = arguments.length, interpolations = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)interpolations[_key - 1] = arguments[_key];
    if (isFunction(styles) || isPlainObject(styles)) // $FlowFixMe
    return flatten(interleave(EMPTY_ARRAY, [
        styles
    ].concat(interpolations)));
    // $FlowFixMe
    return flatten(interleave(styles, interpolations));
}
// 
function constructWithOptions(componentConstructor, tag) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : EMPTY_OBJECT;
    if (!(0, _reactIs.isValidElementType)(tag)) throw new StyledComponentsError(1, String(tag));
    /* This is callable directly as a template function */ // $FlowFixMe: Not typed to avoid destructuring arguments
    var templateFunction = function templateFunction() {
        return componentConstructor(tag, options, css.apply(undefined, arguments));
    };
    /* If config methods are called, wrap up a new template function and merge options */ templateFunction.withConfig = function(config) {
        return constructWithOptions(componentConstructor, tag, _extends({}, options, config));
    };
    /* Modify/inject new props at runtime */ templateFunction.attrs = function(attrs) {
        return constructWithOptions(componentConstructor, tag, _extends({}, options, {
            attrs: Array.prototype.concat(options.attrs, attrs).filter(Boolean)
        }));
    };
    return templateFunction;
}
// 
// Source: https://github.com/garycourt/murmurhash-js/blob/master/murmurhash2_gc.js
function murmurhash(c) {
    for(var e = c.length | 0, a = e | 0, d = 0, b; e >= 4;)b = c.charCodeAt(d) & 255 | (c.charCodeAt(++d) & 255) << 8 | (c.charCodeAt(++d) & 255) << 16 | (c.charCodeAt(++d) & 255) << 24, b = 1540483477 * (b & 65535) + ((1540483477 * (b >>> 16) & 65535) << 16), b ^= b >>> 24, b = 1540483477 * (b & 65535) + ((1540483477 * (b >>> 16) & 65535) << 16), a = 1540483477 * (a & 65535) + ((1540483477 * (a >>> 16) & 65535) << 16) ^ b, e -= 4, ++d;
    switch(e){
        case 3:
            a ^= (c.charCodeAt(d + 2) & 255) << 16;
        case 2:
            a ^= (c.charCodeAt(d + 1) & 255) << 8;
        case 1:
            a ^= c.charCodeAt(d) & 255, a = 1540483477 * (a & 65535) + ((1540483477 * (a >>> 16) & 65535) << 16);
    }
    a ^= a >>> 13;
    a = 1540483477 * (a & 65535) + ((1540483477 * (a >>> 16) & 65535) << 16);
    return (a ^ a >>> 15) >>> 0;
}
// 
/* eslint-disable no-bitwise */ /* This is the "capacity" of our alphabet i.e. 2x26 for all letters plus their capitalised
 * counterparts */ var charsLength = 52;
/* start at 75 for 'a' until 'z' (25) and then start at 65 for capitalised letters */ var getAlphabeticChar = function getAlphabeticChar(code) {
    return String.fromCharCode(code + (code > 25 ? 39 : 97));
};
/* input a number, usually a hash and convert it to base-52 */ function generateAlphabeticName(code) {
    var name = "";
    var x = void 0;
    /* get a char and divide by alphabet-length */ for(x = code; x > charsLength; x = Math.floor(x / charsLength))name = getAlphabeticChar(x % charsLength) + name;
    return getAlphabeticChar(x % charsLength) + name;
}
// 
function hasFunctionObjectKey(obj) {
    // eslint-disable-next-line guard-for-in, no-restricted-syntax
    for(var key in obj){
        if (isFunction(obj[key])) return true;
    }
    return false;
}
function isStaticRules(rules, attrs) {
    for(var i = 0; i < rules.length; i += 1){
        var rule = rules[i];
        // recursive case
        if (Array.isArray(rule) && !isStaticRules(rule, attrs)) return false;
        else if (isFunction(rule) && !isStyledComponent(rule)) // functions are allowed to be static if they're just being
        // used to get the classname of a nested styled component
        return false;
    }
    if (attrs.some(function(x) {
        return isFunction(x) || hasFunctionObjectKey(x);
    })) return false;
    return true;
}
// 
/* combines hashStr (murmurhash) and nameGenerator for convenience */ var hasher = function hasher(str) {
    return generateAlphabeticName(murmurhash(str));
};
/*
 ComponentStyle is all the CSS-specific stuff, not
 the React-specific stuff.
 */ var ComponentStyle = function() {
    function ComponentStyle(rules, attrs, componentId) {
        classCallCheck(this, ComponentStyle);
        this.rules = rules;
        this.isStatic = isStaticRules(rules, attrs);
        this.componentId = componentId;
        if (!StyleSheet.master.hasId(componentId)) StyleSheet.master.deferredInject(componentId, []);
    }
    /*
   * Flattens a rule set into valid CSS
   * Hashes it, wraps the whole chunk in a .hash1234 {}
   * Returns the hash to be injected on render()
   * */ ComponentStyle.prototype.generateAndInjectStyles = function generateAndInjectStyles(executionContext, styleSheet) {
        var isStatic = this.isStatic, componentId = this.componentId, lastClassName = this.lastClassName;
        if (IS_BROWSER && isStatic && typeof lastClassName === "string" && styleSheet.hasNameForId(componentId, lastClassName)) return lastClassName;
        var flatCSS = flatten(this.rules, executionContext, styleSheet);
        var name = hasher(this.componentId + flatCSS.join(""));
        if (!styleSheet.hasNameForId(componentId, name)) styleSheet.inject(this.componentId, stringifyRules(flatCSS, "." + name, undefined, componentId), name);
        this.lastClassName = name;
        return name;
    };
    ComponentStyle.generateName = function generateName(str) {
        return hasher(str);
    };
    return ComponentStyle;
}();
// 
var LIMIT = 200;
var createWarnTooManyClasses = function(displayName) {
    var generatedClasses = {};
    var warningSeen = false;
    return function(className) {
        if (!warningSeen) {
            generatedClasses[className] = true;
            if (Object.keys(generatedClasses).length >= LIMIT) {
                // Unable to find latestRule in test environment.
                /* eslint-disable no-console, prefer-template */ console.warn("Over " + LIMIT + " classes were generated for component " + displayName + ". \n" + "Consider using the attrs method, together with a style object for frequently changed styles.\n" + "Example:\n" + "  const Component = styled.div.attrs(props => ({\n" + "    style: {\n" + "      background: props.background,\n" + "    },\n" + "  }))`width: 100%;`\n\n" + "  <Component />");
                warningSeen = true;
                generatedClasses = {};
            }
        }
    };
};
// 
var determineTheme = function(props, fallbackTheme) {
    var defaultProps = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : EMPTY_OBJECT;
    // Props should take precedence over ThemeProvider, which should take precedence over
    // defaultProps, but React automatically puts defaultProps on props.
    /* eslint-disable react/prop-types, flowtype-errors/show-errors */ var isDefaultTheme = defaultProps ? props.theme === defaultProps.theme : false;
    var theme = props.theme && !isDefaultTheme ? props.theme : fallbackTheme || defaultProps.theme;
    /* eslint-enable */ return theme;
};
// 
var escapeRegex = /[[\].#*$><+~=|^:(),"'`-]+/g;
var dashesAtEnds = /(^-|-$)/g;
/**
 * TODO: Explore using CSS.escape when it becomes more available
 * in evergreen browsers.
 */ function escape(str) {
    return str// Replace all possible CSS selectors
    .replace(escapeRegex, "-")// Remove extraneous hyphens at the start and end
    .replace(dashesAtEnds, "");
}
// 
function isTag(target) {
    return typeof target === "string" && true;
}
// 
function generateDisplayName(target) {
    // $FlowFixMe
    return isTag(target) ? "styled." + target : "Styled(" + getComponentName(target) + ")";
}
var _TYPE_STATICS;
var REACT_STATICS = {
    childContextTypes: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDerivedStateFromProps: true,
    propTypes: true,
    type: true
};
var KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var TYPE_STATICS = (_TYPE_STATICS = {}, _TYPE_STATICS[0, _reactIs.ForwardRef] = {
    $$typeof: true,
    render: true
}, _TYPE_STATICS);
var defineProperty$1 = Object.defineProperty, getOwnPropertyNames = Object.getOwnPropertyNames, _Object$getOwnPropert = Object.getOwnPropertySymbols, getOwnPropertySymbols = _Object$getOwnPropert === undefined ? function() {
    return [];
} : _Object$getOwnPropert, getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor, getPrototypeOf = Object.getPrototypeOf, objectPrototype = Object.prototype;
var arrayPrototype = Array.prototype;
function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== "string") {
        // don't hoist over string (html) components
        var inheritedComponent = getPrototypeOf(sourceComponent);
        if (inheritedComponent && inheritedComponent !== objectPrototype) hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
        var keys = arrayPrototype.concat(getOwnPropertyNames(sourceComponent), // $FlowFixMe
        getOwnPropertySymbols(sourceComponent));
        var targetStatics = TYPE_STATICS[targetComponent.$$typeof] || REACT_STATICS;
        var sourceStatics = TYPE_STATICS[sourceComponent.$$typeof] || REACT_STATICS;
        var i = keys.length;
        var descriptor = void 0;
        var key = void 0;
        // eslint-disable-next-line no-plusplus
        while(i--){
            key = keys[i];
            if (// $FlowFixMe
            !KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && // $FlowFixMe
            !(targetStatics && targetStatics[key])) {
                descriptor = getOwnPropertyDescriptor(sourceComponent, key);
                if (descriptor) try {
                    // Avoid failures from read-only properties
                    defineProperty$1(targetComponent, key, descriptor);
                } catch (e) {
                /* fail silently */ }
            }
        }
        return targetComponent;
    }
    return targetComponent;
}
// 
function isDerivedReactComponent(fn) {
    return !!(fn && fn.prototype && fn.prototype.isReactComponent);
}
// 
// Helper to call a given function, only once
var once = function(cb) {
    var called = false;
    return function() {
        if (!called) {
            called = true;
            cb.apply(undefined, arguments);
        }
    };
};
// 
var ThemeContext = (0, _react.createContext)();
var ThemeConsumer = ThemeContext.Consumer;
/**
 * Provide a theme to an entire react component tree via context
 */ var ThemeProvider = function(_Component) {
    inherits(ThemeProvider, _Component);
    function ThemeProvider(props) {
        classCallCheck(this, ThemeProvider);
        var _this = possibleConstructorReturn(this, _Component.call(this, props));
        _this.getContext = (0, _memoizeOneDefault.default)(_this.getContext.bind(_this));
        _this.renderInner = _this.renderInner.bind(_this);
        return _this;
    }
    ThemeProvider.prototype.render = function render() {
        if (!this.props.children) return null;
        return (0, _reactDefault.default).createElement(ThemeContext.Consumer, null, this.renderInner);
    };
    ThemeProvider.prototype.renderInner = function renderInner(outerTheme) {
        var context = this.getContext(this.props.theme, outerTheme);
        return (0, _reactDefault.default).createElement(ThemeContext.Provider, {
            value: context
        }, this.props.children);
    };
    /**
   * Get the theme from the props, supporting both (outerTheme) => {}
   * as well as object notation
   */ ThemeProvider.prototype.getTheme = function getTheme(theme, outerTheme) {
        if (isFunction(theme)) {
            var mergedTheme = theme(outerTheme);
            return mergedTheme;
        }
        if (theme === null || Array.isArray(theme) || (typeof theme === "undefined" ? "undefined" : _typeof(theme)) !== "object") throw new StyledComponentsError(8);
        return _extends({}, outerTheme, theme);
    };
    ThemeProvider.prototype.getContext = function getContext(theme, outerTheme) {
        return this.getTheme(theme, outerTheme);
    };
    return ThemeProvider;
}((0, _react.Component));
// 
var CLOSING_TAG_R = /^\s*<\/[a-z]/i;
var ServerStyleSheet = function() {
    function ServerStyleSheet() {
        classCallCheck(this, ServerStyleSheet);
        /* The master sheet might be reset, so keep a reference here */ this.masterSheet = StyleSheet.master;
        this.instance = this.masterSheet.clone();
        this.sealed = false;
    }
    /**
   * Mark the ServerStyleSheet as being fully emitted and manually GC it from the
   * StyleSheet singleton.
   */ ServerStyleSheet.prototype.seal = function seal() {
        if (!this.sealed) {
            /* Remove sealed StyleSheets from the master sheet */ var index = this.masterSheet.clones.indexOf(this.instance);
            this.masterSheet.clones.splice(index, 1);
            this.sealed = true;
        }
    };
    ServerStyleSheet.prototype.collectStyles = function collectStyles(children) {
        if (this.sealed) throw new StyledComponentsError(2);
        return (0, _reactDefault.default).createElement(StyleSheetManager, {
            sheet: this.instance
        }, children);
    };
    ServerStyleSheet.prototype.getStyleTags = function getStyleTags() {
        this.seal();
        return this.instance.toHTML();
    };
    ServerStyleSheet.prototype.getStyleElement = function getStyleElement() {
        this.seal();
        return this.instance.toReactElements();
    };
    ServerStyleSheet.prototype.interleaveWithNodeStream = function interleaveWithNodeStream(readableStream) {
        var _this = this;
        var instance, instanceTagIndex, streamAttr, transformer;
        throw new StyledComponentsError(3);
    };
    return ServerStyleSheet;
}();
// 
var StyleSheetContext = (0, _react.createContext)();
var StyleSheetConsumer = StyleSheetContext.Consumer;
var StyleSheetManager = function(_Component) {
    inherits(StyleSheetManager, _Component);
    function StyleSheetManager(props) {
        classCallCheck(this, StyleSheetManager);
        var _this = possibleConstructorReturn(this, _Component.call(this, props));
        _this.getContext = (0, _memoizeOneDefault.default)(_this.getContext);
        return _this;
    }
    StyleSheetManager.prototype.getContext = function getContext(sheet, target) {
        if (sheet) return sheet;
        else if (target) return new StyleSheet(target);
        else throw new StyledComponentsError(4);
    };
    StyleSheetManager.prototype.render = function render() {
        var _props = this.props, children = _props.children, sheet = _props.sheet, target = _props.target;
        return (0, _reactDefault.default).createElement(StyleSheetContext.Provider, {
            value: this.getContext(sheet, target)
        }, children);
    };
    return StyleSheetManager;
}((0, _react.Component));
// 
var identifiers = {};
/* We depend on components having unique IDs */ function generateId(_ComponentStyle, _displayName, parentComponentId) {
    var displayName = typeof _displayName !== "string" ? "sc" : escape(_displayName);
    /**
   * This ensures uniqueness if two components happen to share
   * the same displayName.
   */ var nr = (identifiers[displayName] || 0) + 1;
    identifiers[displayName] = nr;
    var componentId = displayName + "-" + _ComponentStyle.generateName(displayName + nr);
    return parentComponentId ? parentComponentId + "-" + componentId : componentId;
}
// $FlowFixMe
var StyledComponent = function(_Component) {
    inherits(StyledComponent, _Component);
    function StyledComponent() {
        classCallCheck(this, StyledComponent);
        var _this = possibleConstructorReturn(this, _Component.call(this));
        _this.attrs = {};
        _this.renderOuter = _this.renderOuter.bind(_this);
        _this.renderInner = _this.renderInner.bind(_this);
        return _this;
    }
    StyledComponent.prototype.render = function render() {
        return (0, _reactDefault.default).createElement(StyleSheetConsumer, null, this.renderOuter);
    };
    StyledComponent.prototype.renderOuter = function renderOuter() {
        var styleSheet = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : StyleSheet.master;
        this.styleSheet = styleSheet;
        // No need to subscribe a static component to theme changes, it won't change anything
        if (this.props.forwardedComponent.componentStyle.isStatic) return this.renderInner();
        return (0, _reactDefault.default).createElement(ThemeConsumer, null, this.renderInner);
    };
    StyledComponent.prototype.renderInner = function renderInner(theme) {
        var _props$forwardedCompo = this.props.forwardedComponent, componentStyle = _props$forwardedCompo.componentStyle, defaultProps = _props$forwardedCompo.defaultProps, displayName = _props$forwardedCompo.displayName, foldedComponentIds = _props$forwardedCompo.foldedComponentIds, styledComponentId = _props$forwardedCompo.styledComponentId, target = _props$forwardedCompo.target;
        var generatedClassName = void 0;
        if (componentStyle.isStatic) generatedClassName = this.generateAndInjectStyles(EMPTY_OBJECT, this.props);
        else generatedClassName = this.generateAndInjectStyles(determineTheme(this.props, theme, defaultProps) || EMPTY_OBJECT, this.props);
        var elementToBeCreated = this.props.as || this.attrs.as || target;
        var isTargetTag = isTag(elementToBeCreated);
        var propsForElement = {};
        var computedProps = _extends({}, this.props, this.attrs);
        var key = void 0;
        // eslint-disable-next-line guard-for-in
        for(key in computedProps){
            if (key === "forwardedComponent" || key === "as") continue;
            else if (key === "forwardedRef") propsForElement.ref = computedProps[key];
            else if (key === "forwardedAs") propsForElement.as = computedProps[key];
            else if (!isTargetTag || (0, _isPropValidDefault.default)(key)) // Don't pass through non HTML tags through to HTML elements
            propsForElement[key] = computedProps[key];
        }
        if (this.props.style && this.attrs.style) propsForElement.style = _extends({}, this.attrs.style, this.props.style);
        propsForElement.className = Array.prototype.concat(foldedComponentIds, styledComponentId, generatedClassName !== styledComponentId ? generatedClassName : null, this.props.className, this.attrs.className).filter(Boolean).join(" ");
        return (0, _react.createElement)(elementToBeCreated, propsForElement);
    };
    StyledComponent.prototype.buildExecutionContext = function buildExecutionContext(theme, props, attrs) {
        var _this2 = this;
        var context = _extends({}, props, {
            theme: theme
        });
        if (!attrs.length) return context;
        this.attrs = {};
        attrs.forEach(function(attrDef) {
            var resolvedAttrDef = attrDef;
            var attrDefWasFn = false;
            var attr = void 0;
            var key = void 0;
            if (isFunction(resolvedAttrDef)) {
                // $FlowFixMe
                resolvedAttrDef = resolvedAttrDef(context);
                attrDefWasFn = true;
            }
            /* eslint-disable guard-for-in */ // $FlowFixMe
            for(key in resolvedAttrDef){
                attr = resolvedAttrDef[key];
                if (!attrDefWasFn) {
                    if (isFunction(attr) && !isDerivedReactComponent(attr) && !isStyledComponent(attr)) attr = attr(context);
                }
                _this2.attrs[key] = attr;
                context[key] = attr;
            }
        /* eslint-enable */ });
        return context;
    };
    StyledComponent.prototype.generateAndInjectStyles = function generateAndInjectStyles(theme, props) {
        var _props$forwardedCompo2 = props.forwardedComponent, attrs = _props$forwardedCompo2.attrs, componentStyle = _props$forwardedCompo2.componentStyle, warnTooManyClasses = _props$forwardedCompo2.warnTooManyClasses;
        // statically styled-components don't need to build an execution context object,
        // and shouldn't be increasing the number of class names
        if (componentStyle.isStatic && !attrs.length) return componentStyle.generateAndInjectStyles(EMPTY_OBJECT, this.styleSheet);
        var className = componentStyle.generateAndInjectStyles(this.buildExecutionContext(theme, props, attrs), this.styleSheet);
        return className;
    };
    return StyledComponent;
}((0, _react.Component));
function createStyledComponent(target, options, rules) {
    var isTargetStyledComp = isStyledComponent(target);
    var isClass = !isTag(target);
    var _options$displayName = options.displayName, displayName = _options$displayName === undefined ? generateDisplayName(target) : _options$displayName, _options$componentId = options.componentId, componentId = _options$componentId === undefined ? generateId(ComponentStyle, options.displayName, options.parentComponentId) : _options$componentId, _options$ParentCompon = options.ParentComponent, ParentComponent = _options$ParentCompon === undefined ? StyledComponent : _options$ParentCompon, _options$attrs = options.attrs, attrs = _options$attrs === undefined ? EMPTY_ARRAY : _options$attrs;
    var styledComponentId = options.displayName && options.componentId ? escape(options.displayName) + "-" + options.componentId : options.componentId || componentId;
    // fold the underlying StyledComponent attrs up (implicit extend)
    var finalAttrs = // $FlowFixMe
    isTargetStyledComp && target.attrs ? Array.prototype.concat(target.attrs, attrs).filter(Boolean) : attrs;
    var componentStyle = new ComponentStyle(isTargetStyledComp ? // $FlowFixMe
    target.componentStyle.rules.concat(rules) : rules, finalAttrs, styledComponentId);
    /**
   * forwardRef creates a new interim component, which we'll take advantage of
   * instead of extending ParentComponent to create _another_ interim class
   */ var WrappedStyledComponent = void 0;
    var forwardRef = function forwardRef(props, ref) {
        return (0, _reactDefault.default).createElement(ParentComponent, _extends({}, props, {
            forwardedComponent: WrappedStyledComponent,
            forwardedRef: ref
        }));
    };
    forwardRef.displayName = displayName;
    WrappedStyledComponent = (0, _reactDefault.default).forwardRef(forwardRef);
    WrappedStyledComponent.displayName = displayName;
    // $FlowFixMe
    WrappedStyledComponent.attrs = finalAttrs;
    // $FlowFixMe
    WrappedStyledComponent.componentStyle = componentStyle;
    // $FlowFixMe
    WrappedStyledComponent.foldedComponentIds = isTargetStyledComp ? Array.prototype.concat(target.foldedComponentIds, target.styledComponentId) : EMPTY_ARRAY;
    // $FlowFixMe
    WrappedStyledComponent.styledComponentId = styledComponentId;
    // fold the underlying StyledComponent target up since we folded the styles
    // $FlowFixMe
    WrappedStyledComponent.target = isTargetStyledComp ? target.target : target;
    // $FlowFixMe
    WrappedStyledComponent.withComponent = function withComponent(tag) {
        var previousComponentId = options.componentId, optionsToCopy = objectWithoutProperties(options, [
            "componentId"
        ]);
        var newComponentId = previousComponentId && previousComponentId + "-" + (isTag(tag) ? tag : escape(getComponentName(tag)));
        var newOptions = _extends({}, optionsToCopy, {
            attrs: finalAttrs,
            componentId: newComponentId,
            ParentComponent: ParentComponent
        });
        return createStyledComponent(tag, newOptions, rules);
    };
    // $FlowFixMe
    Object.defineProperty(WrappedStyledComponent, "defaultProps", {
        get: function get$$1() {
            return this._foldedDefaultProps;
        },
        set: function set$$1(obj) {
            // $FlowFixMe
            this._foldedDefaultProps = isTargetStyledComp ? (0, _mergeAnythingDefault.default)(target.defaultProps, obj) : obj;
        }
    });
    // $FlowFixMe
    WrappedStyledComponent.toString = function() {
        return "." + WrappedStyledComponent.styledComponentId;
    };
    if (isClass) hoistNonReactStatics(WrappedStyledComponent, target, {
        // all SC-specific things should not be hoisted
        attrs: true,
        componentStyle: true,
        displayName: true,
        foldedComponentIds: true,
        styledComponentId: true,
        target: true,
        withComponent: true
    });
    return WrappedStyledComponent;
}
// 
// Thanks to ReactDOMFactories for this handy list!
var domElements = [
    "a",
    "abbr",
    "address",
    "area",
    "article",
    "aside",
    "audio",
    "b",
    "base",
    "bdi",
    "bdo",
    "big",
    "blockquote",
    "body",
    "br",
    "button",
    "canvas",
    "caption",
    "cite",
    "code",
    "col",
    "colgroup",
    "data",
    "datalist",
    "dd",
    "del",
    "details",
    "dfn",
    "dialog",
    "div",
    "dl",
    "dt",
    "em",
    "embed",
    "fieldset",
    "figcaption",
    "figure",
    "footer",
    "form",
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6",
    "head",
    "header",
    "hgroup",
    "hr",
    "html",
    "i",
    "iframe",
    "img",
    "input",
    "ins",
    "kbd",
    "keygen",
    "label",
    "legend",
    "li",
    "link",
    "main",
    "map",
    "mark",
    "marquee",
    "menu",
    "menuitem",
    "meta",
    "meter",
    "nav",
    "noscript",
    "object",
    "ol",
    "optgroup",
    "option",
    "output",
    "p",
    "param",
    "picture",
    "pre",
    "progress",
    "q",
    "rp",
    "rt",
    "ruby",
    "s",
    "samp",
    "script",
    "section",
    "select",
    "small",
    "source",
    "span",
    "strong",
    "style",
    "sub",
    "summary",
    "sup",
    "table",
    "tbody",
    "td",
    "textarea",
    "tfoot",
    "th",
    "thead",
    "time",
    "title",
    "tr",
    "track",
    "u",
    "ul",
    "var",
    "video",
    "wbr",
    // SVG
    "circle",
    "clipPath",
    "defs",
    "ellipse",
    "foreignObject",
    "g",
    "image",
    "line",
    "linearGradient",
    "marker",
    "mask",
    "path",
    "pattern",
    "polygon",
    "polyline",
    "radialGradient",
    "rect",
    "stop",
    "svg",
    "text",
    "tspan"
];
// 
var styled = function styled(tag) {
    return constructWithOptions(createStyledComponent, tag);
};
// Shorthands for all valid HTML Elements
domElements.forEach(function(domElement) {
    styled[domElement] = styled(domElement);
});
// 
var GlobalStyle = function() {
    function GlobalStyle(rules, componentId) {
        classCallCheck(this, GlobalStyle);
        this.rules = rules;
        this.componentId = componentId;
        this.isStatic = isStaticRules(rules, EMPTY_ARRAY);
        if (!StyleSheet.master.hasId(componentId)) StyleSheet.master.deferredInject(componentId, []);
    }
    GlobalStyle.prototype.createStyles = function createStyles(executionContext, styleSheet) {
        var flatCSS = flatten(this.rules, executionContext, styleSheet);
        var css = stringifyRules(flatCSS, "");
        styleSheet.inject(this.componentId, css);
    };
    GlobalStyle.prototype.removeStyles = function removeStyles(styleSheet) {
        var componentId = this.componentId;
        if (styleSheet.hasId(componentId)) styleSheet.remove(componentId);
    };
    // TODO: overwrite in-place instead of remove+create?
    GlobalStyle.prototype.renderStyles = function renderStyles(executionContext, styleSheet) {
        this.removeStyles(styleSheet);
        this.createStyles(executionContext, styleSheet);
    };
    return GlobalStyle;
}();
// 
// place our cache into shared context so it'll persist between HMRs
if (IS_BROWSER) window.scCGSHMRCache = {};
function createGlobalStyle(strings) {
    for(var _len = arguments.length, interpolations = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)interpolations[_key - 1] = arguments[_key];
    var rules = css.apply(undefined, [
        strings
    ].concat(interpolations));
    var id = "sc-global-" + murmurhash(JSON.stringify(rules));
    var style = new GlobalStyle(rules, id);
    var GlobalStyleComponent = function(_React$Component) {
        inherits(GlobalStyleComponent, _React$Component);
        function GlobalStyleComponent(props) {
            classCallCheck(this, GlobalStyleComponent);
            var _this = possibleConstructorReturn(this, _React$Component.call(this, props));
            var _this$constructor = _this.constructor, globalStyle = _this$constructor.globalStyle, styledComponentId = _this$constructor.styledComponentId;
            if (IS_BROWSER) window.scCGSHMRCache[styledComponentId] = (window.scCGSHMRCache[styledComponentId] || 0) + 1;
            /**
       * This fixes HMR compatibility. Don't ask me why, but this combination of
       * caching the closure variables via statics and then persisting the statics in
       * state works across HMR where no other combination did. ¯\_(ツ)_/¯
       */ _this.state = {
                globalStyle: globalStyle,
                styledComponentId: styledComponentId
            };
            return _this;
        }
        GlobalStyleComponent.prototype.componentWillUnmount = function componentWillUnmount() {
            if (window.scCGSHMRCache[this.state.styledComponentId]) window.scCGSHMRCache[this.state.styledComponentId] -= 1;
            /**
       * Depending on the order "render" is called this can cause the styles to be lost
       * until the next render pass of the remaining instance, which may
       * not be immediate.
       */ if (window.scCGSHMRCache[this.state.styledComponentId] === 0) this.state.globalStyle.removeStyles(this.styleSheet);
        };
        GlobalStyleComponent.prototype.render = function render() {
            var _this2 = this;
            return (0, _reactDefault.default).createElement(StyleSheetConsumer, null, function(styleSheet) {
                _this2.styleSheet = styleSheet || StyleSheet.master;
                var globalStyle = _this2.state.globalStyle;
                if (globalStyle.isStatic) {
                    globalStyle.renderStyles(STATIC_EXECUTION_CONTEXT, _this2.styleSheet);
                    return null;
                } else return (0, _reactDefault.default).createElement(ThemeConsumer, null, function(theme) {
                    // $FlowFixMe
                    var defaultProps = _this2.constructor.defaultProps;
                    var context = _extends({}, _this2.props);
                    if (typeof theme !== "undefined") context.theme = determineTheme(_this2.props, theme, defaultProps);
                    globalStyle.renderStyles(context, _this2.styleSheet);
                    return null;
                });
            });
        };
        return GlobalStyleComponent;
    }((0, _reactDefault.default).Component);
    GlobalStyleComponent.globalStyle = style;
    GlobalStyleComponent.styledComponentId = id;
    return GlobalStyleComponent;
}
// 
var replaceWhitespace = function replaceWhitespace(str) {
    return str.replace(/\s|\\n/g, "");
};
function keyframes(strings) {
    for(var _len = arguments.length, interpolations = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)interpolations[_key - 1] = arguments[_key];
    var rules = css.apply(undefined, [
        strings
    ].concat(interpolations));
    var name = generateAlphabeticName(murmurhash(replaceWhitespace(JSON.stringify(rules))));
    return new Keyframes(name, stringifyRules(rules, name, "@keyframes"));
}
// 
var withTheme = function(Component$$1) {
    var WithTheme = (0, _reactDefault.default).forwardRef(function(props, ref) {
        return (0, _reactDefault.default).createElement(ThemeConsumer, null, function(theme) {
            // $FlowFixMe
            var defaultProps = Component$$1.defaultProps;
            var themeProp = determineTheme(props, theme, defaultProps);
            return (0, _reactDefault.default).createElement(Component$$1, _extends({}, props, {
                theme: themeProp,
                ref: ref
            }));
        });
    });
    hoistNonReactStatics(WithTheme, Component$$1);
    WithTheme.displayName = "WithTheme(" + getComponentName(Component$$1) + ")";
    return WithTheme;
};
// 
/* eslint-disable */ var __DO_NOT_USE_OR_YOU_WILL_BE_HAUNTED_BY_SPOOKY_GHOSTS = {
    StyleSheet: StyleSheet
};
//
exports.default = styled;

},{"50571207bc3cae02":"5QIF0","stylis/stylis.min":"9kcw3","stylis-rule-sheet":"6dE67","react":"6uln9","@emotion/unitless":"koKW5","react-is":"b8HlJ","memoize-one":"9ZyRf","prop-types":"6FKs7","@emotion/is-prop-valid":"jNzT2","merge-anything":"jOpK9","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"5QIF0":[function(require,module,exports) {
// shim for using process in browser
var process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var cachedSetTimeout;
var cachedClearTimeout;
function defaultSetTimout() {
    throw new Error("setTimeout has not been defined");
}
function defaultClearTimeout() {
    throw new Error("clearTimeout has not been defined");
}
(function() {
    try {
        if (typeof setTimeout === "function") cachedSetTimeout = setTimeout;
        else cachedSetTimeout = defaultSetTimout;
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === "function") cachedClearTimeout = clearTimeout;
        else cachedClearTimeout = defaultClearTimeout;
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
})();
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }
}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;
function cleanUpNextTick() {
    if (!draining || !currentQueue) return;
    draining = false;
    if (currentQueue.length) queue = currentQueue.concat(queue);
    else queueIndex = -1;
    if (queue.length) drainQueue();
}
function drainQueue() {
    if (draining) return;
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;
    var len = queue.length;
    while(len){
        currentQueue = queue;
        queue = [];
        while(++queueIndex < len)if (currentQueue) currentQueue[queueIndex].run();
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}
process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) runTimeout(drainQueue);
};
// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
process.title = "browser";
process.browser = true;
process.env = {};
process.argv = [];
process.version = ""; // empty string to avoid regexp issues
process.versions = {};
function noop() {}
process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;
process.listeners = function(name) {
    return [];
};
process.binding = function(name) {
    throw new Error("process.binding is not supported");
};
process.cwd = function() {
    return "/";
};
process.chdir = function(dir) {
    throw new Error("process.chdir is not supported");
};
process.umask = function() {
    return 0;
};

},{}],"9kcw3":[function(require,module,exports) {
!function(e) {
    module.exports = e(null);
}(function e(a) {
    "use strict";
    var r = /^\0+/g, c = /[\0\r\f]/g, s = /: */g, t = /zoo|gra/, i = /([,: ])(transform)/g, f = /,+\s*(?![^(]*[)])/g, n = / +\s*(?![^(]*[)])/g, l = / *[\0] */g, o = /,\r+?/g, h = /([\t\r\n ])*\f?&/g, u = /:global\(((?:[^\(\)\[\]]*|\[.*\]|\([^\(\)]*\))*)\)/g, d = /\W+/g, b = /@(k\w+)\s*(\S*)\s*/, p = /::(place)/g, k = /:(read-only)/g, g = /\s+(?=[{\];=:>])/g, A = /([[}=:>])\s+/g, C = /(\{[^{]+?);(?=\})/g, w = /\s{2,}/g, v = /([^\(])(:+) */g, m = /[svh]\w+-[tblr]{2}/, x = /\(\s*(.*)\s*\)/g, $ = /([\s\S]*?);/g, y = /-self|flex-/g, O = /[^]*?(:[rp][el]a[\w-]+)[^]*/, j = /stretch|:\s*\w+\-(?:conte|avail)/, z = /([^-])(image-set\()/, N = "-webkit-", S = "-moz-", F = "-ms-", W = 59, q = 125, B = 123, D = 40, E = 41, G = 91, H = 93, I = 10, J = 13, K = 9, L = 64, M = 32, P = 38, Q = 45, R = 95, T = 42, U = 44, V = 58, X = 39, Y = 34, Z = 47, _ = 62, ee = 43, ae = 126, re = 0, ce = 12, se = 11, te = 107, ie = 109, fe = 115, ne = 112, le = 111, oe = 105, he = 99, ue = 100, de = 112, be = 1, pe = 1, ke = 0, ge = 1, Ae = 1, Ce = 1, we = 0, ve = 0, me = 0, xe = [], $e = [], ye = 0, Oe = null, je = -2, ze = -1, Ne = 0, Se = 1, Fe = 2, We = 3, qe = 0, Be = 1, De = "", Ee = "", Ge = "";
    function He(e, a, s, t, i) {
        for(var f, n, o = 0, h = 0, u = 0, d = 0, g = 0, A = 0, C = 0, w = 0, m = 0, $ = 0, y = 0, O = 0, j = 0, z = 0, R = 0, we = 0, $e = 0, Oe = 0, je = 0, ze = s.length, Je = ze - 1, Re = "", Te = "", Ue = "", Ve = "", Xe = "", Ye = ""; R < ze;){
            if (C = s.charCodeAt(R), R === Je) {
                if (h + d + u + o !== 0) {
                    if (0 !== h) C = h === Z ? I : Z;
                    d = u = o = 0, ze++, Je++;
                }
            }
            if (h + d + u + o === 0) {
                if (R === Je) {
                    if (we > 0) Te = Te.replace(c, "");
                    if (Te.trim().length > 0) {
                        switch(C){
                            case M:
                            case K:
                            case W:
                            case J:
                            case I:
                                break;
                            default:
                                Te += s.charAt(R);
                        }
                        C = W;
                    }
                }
                if (1 === $e) switch(C){
                    case B:
                    case q:
                    case W:
                    case Y:
                    case X:
                    case D:
                    case E:
                    case U:
                        $e = 0;
                    case K:
                    case J:
                    case I:
                    case M:
                        break;
                    default:
                        for($e = 0, je = R, g = C, R--, C = W; je < ze;)switch(s.charCodeAt(je++)){
                            case I:
                            case J:
                            case W:
                                ++R, C = g, je = ze;
                                break;
                            case V:
                                if (we > 0) ++R, C = g;
                            case B:
                                je = ze;
                        }
                }
                switch(C){
                    case B:
                        for(g = (Te = Te.trim()).charCodeAt(0), y = 1, je = ++R; R < ze;){
                            switch(C = s.charCodeAt(R)){
                                case B:
                                    y++;
                                    break;
                                case q:
                                    y--;
                                    break;
                                case Z:
                                    switch(A = s.charCodeAt(R + 1)){
                                        case T:
                                        case Z:
                                            R = Qe(A, R, Je, s);
                                    }
                                    break;
                                case G:
                                    C++;
                                case D:
                                    C++;
                                case Y:
                                case X:
                                    for(; R++ < Je && s.charCodeAt(R) !== C;);
                            }
                            if (0 === y) break;
                            R++;
                        }
                        if (Ue = s.substring(je, R), g === re) g = (Te = Te.replace(r, "").trim()).charCodeAt(0);
                        switch(g){
                            case L:
                                if (we > 0) Te = Te.replace(c, "");
                                switch(A = Te.charCodeAt(1)){
                                    case ue:
                                    case ie:
                                    case fe:
                                    case Q:
                                        f = a;
                                        break;
                                    default:
                                        f = xe;
                                }
                                if (je = (Ue = He(a, f, Ue, A, i + 1)).length, me > 0 && 0 === je) je = Te.length;
                                if (ye > 0) {
                                    if (f = Ie(xe, Te, Oe), n = Pe(We, Ue, f, a, pe, be, je, A, i, t), Te = f.join(""), void 0 !== n) {
                                        if (0 === (je = (Ue = n.trim()).length)) A = 0, Ue = "";
                                    }
                                }
                                if (je > 0) switch(A){
                                    case fe:
                                        Te = Te.replace(x, Me);
                                    case ue:
                                    case ie:
                                    case Q:
                                        Ue = Te + "{" + Ue + "}";
                                        break;
                                    case te:
                                        if (Ue = (Te = Te.replace(b, "$1 $2" + (Be > 0 ? De : ""))) + "{" + Ue + "}", 1 === Ae || 2 === Ae && Le("@" + Ue, 3)) Ue = "@" + N + Ue + "@" + Ue;
                                        else Ue = "@" + Ue;
                                        break;
                                    default:
                                        if (Ue = Te + Ue, t === de) Ve += Ue, Ue = "";
                                }
                                else Ue = "";
                                break;
                            default:
                                Ue = He(a, Ie(a, Te, Oe), Ue, t, i + 1);
                        }
                        Xe += Ue, O = 0, $e = 0, z = 0, we = 0, Oe = 0, j = 0, Te = "", Ue = "", C = s.charCodeAt(++R);
                        break;
                    case q:
                    case W:
                        if ((je = (Te = (we > 0 ? Te.replace(c, "") : Te).trim()).length) > 1) {
                            if (0 === z) {
                                if ((g = Te.charCodeAt(0)) === Q || g > 96 && g < 123) je = (Te = Te.replace(" ", ":")).length;
                            }
                            if (ye > 0) {
                                if (void 0 !== (n = Pe(Se, Te, a, e, pe, be, Ve.length, t, i, t))) {
                                    if (0 === (je = (Te = n.trim()).length)) Te = "\0\0";
                                }
                            }
                            switch(g = Te.charCodeAt(0), A = Te.charCodeAt(1), g){
                                case re:
                                    break;
                                case L:
                                    if (A === oe || A === he) {
                                        Ye += Te + s.charAt(R);
                                        break;
                                    }
                                default:
                                    if (Te.charCodeAt(je - 1) === V) break;
                                    Ve += Ke(Te, g, A, Te.charCodeAt(2));
                            }
                        }
                        O = 0, $e = 0, z = 0, we = 0, Oe = 0, Te = "", C = s.charCodeAt(++R);
                }
            }
            switch(C){
                case J:
                case I:
                    if (h + d + u + o + ve === 0) switch($){
                        case E:
                        case X:
                        case Y:
                        case L:
                        case ae:
                        case _:
                        case T:
                        case ee:
                        case Z:
                        case Q:
                        case V:
                        case U:
                        case W:
                        case B:
                        case q:
                            break;
                        default:
                            if (z > 0) $e = 1;
                    }
                    if (h === Z) h = 0;
                    else if (ge + O === 0 && t !== te && Te.length > 0) we = 1, Te += "\0";
                    if (ye * qe > 0) Pe(Ne, Te, a, e, pe, be, Ve.length, t, i, t);
                    be = 1, pe++;
                    break;
                case W:
                case q:
                    if (h + d + u + o === 0) {
                        be++;
                        break;
                    }
                default:
                    switch(be++, Re = s.charAt(R), C){
                        case K:
                        case M:
                            if (d + o + h === 0) switch(w){
                                case U:
                                case V:
                                case K:
                                case M:
                                    Re = "";
                                    break;
                                default:
                                    if (C !== M) Re = " ";
                            }
                            break;
                        case re:
                            Re = "\\0";
                            break;
                        case ce:
                            Re = "\\f";
                            break;
                        case se:
                            Re = "\\v";
                            break;
                        case P:
                            if (d + h + o === 0 && ge > 0) Oe = 1, we = 1, Re = "\f" + Re;
                            break;
                        case 108:
                            if (d + h + o + ke === 0 && z > 0) switch(R - z){
                                case 2:
                                    if (w === ne && s.charCodeAt(R - 3) === V) ke = w;
                                case 8:
                                    if (m === le) ke = m;
                            }
                            break;
                        case V:
                            if (d + h + o === 0) z = R;
                            break;
                        case U:
                            if (h + u + d + o === 0) we = 1, Re += "\r";
                            break;
                        case Y:
                        case X:
                            if (0 === h) d = d === C ? 0 : 0 === d ? C : d;
                            break;
                        case G:
                            if (d + h + u === 0) o++;
                            break;
                        case H:
                            if (d + h + u === 0) o--;
                            break;
                        case E:
                            if (d + h + o === 0) u--;
                            break;
                        case D:
                            if (d + h + o === 0) {
                                if (0 === O) switch(2 * w + 3 * m){
                                    case 533:
                                        break;
                                    default:
                                        y = 0, O = 1;
                                }
                                u++;
                            }
                            break;
                        case L:
                            if (h + u + d + o + z + j === 0) j = 1;
                            break;
                        case T:
                        case Z:
                            if (d + o + u > 0) break;
                            switch(h){
                                case 0:
                                    switch(2 * C + 3 * s.charCodeAt(R + 1)){
                                        case 235:
                                            h = Z;
                                            break;
                                        case 220:
                                            je = R, h = T;
                                    }
                                    break;
                                case T:
                                    if (C === Z && w === T && je + 2 !== R) {
                                        if (33 === s.charCodeAt(je + 2)) Ve += s.substring(je, R + 1);
                                        Re = "", h = 0;
                                    }
                            }
                    }
                    if (0 === h) {
                        if (ge + d + o + j === 0 && t !== te && C !== W) switch(C){
                            case U:
                            case ae:
                            case _:
                            case ee:
                            case E:
                            case D:
                                if (0 === O) {
                                    switch(w){
                                        case K:
                                        case M:
                                        case I:
                                        case J:
                                            Re += "\0";
                                            break;
                                        default:
                                            Re = "\0" + Re + (C === U ? "" : "\0");
                                    }
                                    we = 1;
                                } else switch(C){
                                    case D:
                                        if (z + 7 === R && 108 === w) z = 0;
                                        O = ++y;
                                        break;
                                    case E:
                                        if (0 == (O = --y)) we = 1, Re += "\0";
                                }
                                break;
                            case K:
                            case M:
                                switch(w){
                                    case re:
                                    case B:
                                    case q:
                                    case W:
                                    case U:
                                    case ce:
                                    case K:
                                    case M:
                                    case I:
                                    case J:
                                        break;
                                    default:
                                        if (0 === O) we = 1, Re += "\0";
                                }
                        }
                        if (Te += Re, C !== M && C !== K) $ = C;
                    }
            }
            m = w, w = C, R++;
        }
        if (je = Ve.length, me > 0) {
            if (0 === je && 0 === Xe.length && 0 === a[0].length == false) {
                if (t !== ie || 1 === a.length && (ge > 0 ? Ee : Ge) === a[0]) je = a.join(",").length + 2;
            }
        }
        if (je > 0) {
            if (f = 0 === ge && t !== te ? function(e) {
                for(var a, r, s = 0, t = e.length, i = Array(t); s < t; ++s){
                    for(var f = e[s].split(l), n = "", o = 0, h = 0, u = 0, d = 0, b = f.length; o < b; ++o){
                        if (0 === (h = (r = f[o]).length) && b > 1) continue;
                        if (u = n.charCodeAt(n.length - 1), d = r.charCodeAt(0), a = "", 0 !== o) switch(u){
                            case T:
                            case ae:
                            case _:
                            case ee:
                            case M:
                            case D:
                                break;
                            default:
                                a = " ";
                        }
                        switch(d){
                            case P:
                                r = a + Ee;
                            case ae:
                            case _:
                            case ee:
                            case M:
                            case E:
                            case D:
                                break;
                            case G:
                                r = a + r + Ee;
                                break;
                            case V:
                                switch(2 * r.charCodeAt(1) + 3 * r.charCodeAt(2)){
                                    case 530:
                                        if (Ce > 0) {
                                            r = a + r.substring(8, h - 1);
                                            break;
                                        }
                                    default:
                                        if (o < 1 || f[o - 1].length < 1) r = a + Ee + r;
                                }
                                break;
                            case U:
                                a = "";
                            default:
                                if (h > 1 && r.indexOf(":") > 0) r = a + r.replace(v, "$1" + Ee + "$2");
                                else r = a + r + Ee;
                        }
                        n += r;
                    }
                    i[s] = n.replace(c, "").trim();
                }
                return i;
            }(a) : a, ye > 0) {
                if (void 0 !== (n = Pe(Fe, Ve, f, e, pe, be, je, t, i, t)) && 0 === (Ve = n).length) return Ye + Ve + Xe;
            }
            if (Ve = f.join(",") + "{" + Ve + "}", Ae * ke != 0) {
                if (2 === Ae && !Le(Ve, 2)) ke = 0;
                switch(ke){
                    case le:
                        Ve = Ve.replace(k, ":" + S + "$1") + Ve;
                        break;
                    case ne:
                        Ve = Ve.replace(p, "::" + N + "input-$1") + Ve.replace(p, "::" + S + "$1") + Ve.replace(p, ":" + F + "input-$1") + Ve;
                }
                ke = 0;
            }
        }
        return Ye + Ve + Xe;
    }
    function Ie(e, a, r) {
        var c = a.trim().split(o), s = c, t = c.length, i = e.length;
        switch(i){
            case 0:
            case 1:
                for(var f = 0, n = 0 === i ? "" : e[0] + " "; f < t; ++f)s[f] = Je(n, s[f], r, i).trim();
                break;
            default:
                f = 0;
                var l = 0;
                for(s = []; f < t; ++f)for(var h = 0; h < i; ++h)s[l++] = Je(e[h] + " ", c[f], r, i).trim();
        }
        return s;
    }
    function Je(e, a, r, c) {
        var s = a, t = s.charCodeAt(0);
        if (t < 33) t = (s = s.trim()).charCodeAt(0);
        switch(t){
            case P:
                switch(ge + c){
                    case 0:
                    case 1:
                        if (0 === e.trim().length) break;
                    default:
                        return s.replace(h, "$1" + e.trim());
                }
                break;
            case V:
                switch(s.charCodeAt(1)){
                    case 103:
                        if (Ce > 0 && ge > 0) return s.replace(u, "$1").replace(h, "$1" + Ge);
                        break;
                    default:
                        return e.trim() + s.replace(h, "$1" + e.trim());
                }
            default:
                if (r * ge > 0 && s.indexOf("\f") > 0) return s.replace(h, (e.charCodeAt(0) === V ? "" : "$1") + e.trim());
        }
        return e + s;
    }
    function Ke(e, a, r, c) {
        var l, o = 0, h = e + ";", u = 2 * a + 3 * r + 4 * c;
        if (944 === u) return function(e) {
            var a = e.length, r = e.indexOf(":", 9) + 1, c = e.substring(0, r).trim(), s = e.substring(r, a - 1).trim();
            switch(e.charCodeAt(9) * Be){
                case 0:
                    break;
                case Q:
                    if (110 !== e.charCodeAt(10)) break;
                default:
                    for(var t = s.split((s = "", f)), i = 0, r = 0, a = t.length; i < a; r = 0, ++i){
                        for(var l = t[i], o = l.split(n); l = o[r];){
                            var h = l.charCodeAt(0);
                            if (1 === Be && (h > L && h < 90 || h > 96 && h < 123 || h === R || h === Q && l.charCodeAt(1) !== Q)) switch(isNaN(parseFloat(l)) + (-1 !== l.indexOf("("))){
                                case 1:
                                    switch(l){
                                        case "infinite":
                                        case "alternate":
                                        case "backwards":
                                        case "running":
                                        case "normal":
                                        case "forwards":
                                        case "both":
                                        case "none":
                                        case "linear":
                                        case "ease":
                                        case "ease-in":
                                        case "ease-out":
                                        case "ease-in-out":
                                        case "paused":
                                        case "reverse":
                                        case "alternate-reverse":
                                        case "inherit":
                                        case "initial":
                                        case "unset":
                                        case "step-start":
                                        case "step-end":
                                            break;
                                        default:
                                            l += De;
                                    }
                            }
                            o[r++] = l;
                        }
                        s += (0 === i ? "" : ",") + o.join(" ");
                    }
            }
            if (s = c + s + ";", 1 === Ae || 2 === Ae && Le(s, 1)) return N + s + s;
            return s;
        }(h);
        else if (0 === Ae || 2 === Ae && !Le(h, 1)) return h;
        switch(u){
            case 1015:
                return 97 === h.charCodeAt(10) ? N + h + h : h;
            case 951:
                return 116 === h.charCodeAt(3) ? N + h + h : h;
            case 963:
                return 110 === h.charCodeAt(5) ? N + h + h : h;
            case 1009:
                if (100 !== h.charCodeAt(4)) break;
            case 969:
            case 942:
                return N + h + h;
            case 978:
                return N + h + S + h + h;
            case 1019:
            case 983:
                return N + h + S + h + F + h + h;
            case 883:
                if (h.charCodeAt(8) === Q) return N + h + h;
                if (h.indexOf("image-set(", 11) > 0) return h.replace(z, "$1" + N + "$2") + h;
                return h;
            case 932:
                if (h.charCodeAt(4) === Q) switch(h.charCodeAt(5)){
                    case 103:
                        return N + "box-" + h.replace("-grow", "") + N + h + F + h.replace("grow", "positive") + h;
                    case 115:
                        return N + h + F + h.replace("shrink", "negative") + h;
                    case 98:
                        return N + h + F + h.replace("basis", "preferred-size") + h;
                }
                return N + h + F + h + h;
            case 964:
                return N + h + F + "flex-" + h + h;
            case 1023:
                if (99 !== h.charCodeAt(8)) break;
                return l = h.substring(h.indexOf(":", 15)).replace("flex-", "").replace("space-between", "justify"), N + "box-pack" + l + N + h + F + "flex-pack" + l + h;
            case 1005:
                return t.test(h) ? h.replace(s, ":" + N) + h.replace(s, ":" + S) + h : h;
            case 1e3:
                switch(o = (l = h.substring(13).trim()).indexOf("-") + 1, l.charCodeAt(0) + l.charCodeAt(o)){
                    case 226:
                        l = h.replace(m, "tb");
                        break;
                    case 232:
                        l = h.replace(m, "tb-rl");
                        break;
                    case 220:
                        l = h.replace(m, "lr");
                        break;
                    default:
                        return h;
                }
                return N + h + F + l + h;
            case 1017:
                if (-1 === h.indexOf("sticky", 9)) return h;
            case 975:
                switch(o = (h = e).length - 10, u = (l = (33 === h.charCodeAt(o) ? h.substring(0, o) : h).substring(e.indexOf(":", 7) + 1).trim()).charCodeAt(0) + (0 | l.charCodeAt(7))){
                    case 203:
                        if (l.charCodeAt(8) < 111) break;
                    case 115:
                        h = h.replace(l, N + l) + ";" + h;
                        break;
                    case 207:
                    case 102:
                        h = h.replace(l, N + (u > 102 ? "inline-" : "") + "box") + ";" + h.replace(l, N + l) + ";" + h.replace(l, F + l + "box") + ";" + h;
                }
                return h + ";";
            case 938:
                if (h.charCodeAt(5) === Q) switch(h.charCodeAt(6)){
                    case 105:
                        return l = h.replace("-items", ""), N + h + N + "box-" + l + F + "flex-" + l + h;
                    case 115:
                        return N + h + F + "flex-item-" + h.replace(y, "") + h;
                    default:
                        return N + h + F + "flex-line-pack" + h.replace("align-content", "").replace(y, "") + h;
                }
                break;
            case 973:
            case 989:
                if (h.charCodeAt(3) !== Q || 122 === h.charCodeAt(4)) break;
            case 931:
            case 953:
                if (true === j.test(e)) {
                    if (115 === (l = e.substring(e.indexOf(":") + 1)).charCodeAt(0)) return Ke(e.replace("stretch", "fill-available"), a, r, c).replace(":fill-available", ":stretch");
                    else return h.replace(l, N + l) + h.replace(l, S + l.replace("fill-", "")) + h;
                }
                break;
            case 962:
                if (h = N + h + (102 === h.charCodeAt(5) ? F + h : "") + h, r + c === 211 && 105 === h.charCodeAt(13) && h.indexOf("transform", 10) > 0) return h.substring(0, h.indexOf(";", 27) + 1).replace(i, "$1" + N + "$2") + h;
        }
        return h;
    }
    function Le(e, a) {
        var r = e.indexOf(1 === a ? ":" : "{"), c = e.substring(0, 3 !== a ? r : 10), s = e.substring(r + 1, e.length - 1);
        return Oe(2 !== a ? c : c.replace(O, "$1"), s, a);
    }
    function Me(e, a) {
        var r = Ke(a, a.charCodeAt(0), a.charCodeAt(1), a.charCodeAt(2));
        return r !== a + ";" ? r.replace($, " or ($1)").substring(4) : "(" + a + ")";
    }
    function Pe(e, a, r, c, s, t, i, f, n, l) {
        for(var o, h = 0, u = a; h < ye; ++h)switch(o = $e[h].call(Te, e, u, r, c, s, t, i, f, n, l)){
            case void 0:
            case false:
            case true:
            case null:
                break;
            default:
                u = o;
        }
        if (u !== a) return u;
    }
    function Qe(e, a, r, c) {
        for(var s = a + 1; s < r; ++s)switch(c.charCodeAt(s)){
            case Z:
                if (e === T) {
                    if (c.charCodeAt(s - 1) === T && a + 2 !== s) return s + 1;
                }
                break;
            case I:
                if (e === Z) return s + 1;
        }
        return s;
    }
    function Re(e) {
        for(var a in e){
            var r = e[a];
            switch(a){
                case "keyframe":
                    Be = 0 | r;
                    break;
                case "global":
                    Ce = 0 | r;
                    break;
                case "cascade":
                    ge = 0 | r;
                    break;
                case "compress":
                    we = 0 | r;
                    break;
                case "semicolon":
                    ve = 0 | r;
                    break;
                case "preserve":
                    me = 0 | r;
                    break;
                case "prefix":
                    if (Oe = null, !r) Ae = 0;
                    else if ("function" != typeof r) Ae = 1;
                    else Ae = 2, Oe = r;
            }
        }
        return Re;
    }
    function Te(a, r) {
        if (void 0 !== this && this.constructor === Te) return e(a);
        var s = a, t = s.charCodeAt(0);
        if (t < 33) t = (s = s.trim()).charCodeAt(0);
        if (Be > 0) De = s.replace(d, t === G ? "" : "-");
        if (t = 1, 1 === ge) Ge = s;
        else Ee = s;
        var i, f = [
            Ge
        ];
        if (ye > 0) {
            if (void 0 !== (i = Pe(ze, r, f, f, pe, be, 0, 0, 0, 0)) && "string" == typeof i) r = i;
        }
        var n = He(xe, f, r, 0, 0);
        if (ye > 0) {
            if (void 0 !== (i = Pe(je, n, f, f, pe, be, n.length, 0, 0, 0)) && "string" != typeof (n = i)) t = 0;
        }
        return De = "", Ge = "", Ee = "", ke = 0, pe = 1, be = 1, we * t == 0 ? n : n.replace(c, "").replace(g, "").replace(A, "$1").replace(C, "$1").replace(w, " ");
    }
    if (Te.use = function e(a) {
        switch(a){
            case void 0:
            case null:
                ye = $e.length = 0;
                break;
            default:
                if ("function" == typeof a) $e[ye++] = a;
                else if ("object" == typeof a) for(var r = 0, c = a.length; r < c; ++r)e(a[r]);
                else qe = 0 | !!a;
        }
        return e;
    }, Te.set = Re, void 0 !== a) Re(a);
    return Te;
});

},{}],"6dE67":[function(require,module,exports) {
(function(factory) {
    module["exports"] = factory();
})(function() {
    "use strict";
    return function(insertRule) {
        var delimiter = "/*|*/";
        var needle = delimiter + "}";
        function toSheet(block) {
            if (block) try {
                insertRule(block + "}");
            } catch (e) {}
        }
        return function ruleSheet(context, content, selectors, parents, line, column, length, ns, depth, at) {
            switch(context){
                // property
                case 1:
                    // @import
                    if (depth === 0 && content.charCodeAt(0) === 64) return insertRule(content + ";"), "";
                    break;
                // selector
                case 2:
                    if (ns === 0) return content + delimiter;
                    break;
                // at-rule
                case 3:
                    switch(ns){
                        // @font-face, @page
                        case 102:
                        case 112:
                            return insertRule(selectors[0] + content), "";
                        default:
                            return content + (at === 0 ? delimiter : "");
                    }
                case -2:
                    content.split(needle).forEach(toSheet);
            }
        };
    };
});

},{}],"koKW5":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var unitlessKeys = {
    animationIterationCount: 1,
    borderImageOutset: 1,
    borderImageSlice: 1,
    borderImageWidth: 1,
    boxFlex: 1,
    boxFlexGroup: 1,
    boxOrdinalGroup: 1,
    columnCount: 1,
    columns: 1,
    flex: 1,
    flexGrow: 1,
    flexPositive: 1,
    flexShrink: 1,
    flexNegative: 1,
    flexOrder: 1,
    gridRow: 1,
    gridRowEnd: 1,
    gridRowSpan: 1,
    gridRowStart: 1,
    gridColumn: 1,
    gridColumnEnd: 1,
    gridColumnSpan: 1,
    gridColumnStart: 1,
    msGridRow: 1,
    msGridRowSpan: 1,
    msGridColumn: 1,
    msGridColumnSpan: 1,
    fontWeight: 1,
    lineHeight: 1,
    opacity: 1,
    order: 1,
    orphans: 1,
    tabSize: 1,
    widows: 1,
    zIndex: 1,
    zoom: 1,
    WebkitLineClamp: 1,
    // SVG-related properties
    fillOpacity: 1,
    floodOpacity: 1,
    stopOpacity: 1,
    strokeDasharray: 1,
    strokeDashoffset: 1,
    strokeMiterlimit: 1,
    strokeOpacity: 1,
    strokeWidth: 1
};
exports.default = unitlessKeys;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"b8HlJ":[function(require,module,exports) {
"use strict";
module.exports = require("6622c69b983abbb0");

},{"6622c69b983abbb0":"M1cEA"}],"M1cEA":[function(require,module,exports) {
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var b = "function" === typeof Symbol && Symbol.for, c = b ? Symbol.for("react.element") : 60103, d = b ? Symbol.for("react.portal") : 60106, e = b ? Symbol.for("react.fragment") : 60107, f = b ? Symbol.for("react.strict_mode") : 60108, g = b ? Symbol.for("react.profiler") : 60114, h = b ? Symbol.for("react.provider") : 60109, k = b ? Symbol.for("react.context") : 60110, l = b ? Symbol.for("react.async_mode") : 60111, m = b ? Symbol.for("react.concurrent_mode") : 60111, n = b ? Symbol.for("react.forward_ref") : 60112, p = b ? Symbol.for("react.suspense") : 60113, q = b ? Symbol.for("react.suspense_list") : 60120, r = b ? Symbol.for("react.memo") : 60115, t = b ? Symbol.for("react.lazy") : 60116, v = b ? Symbol.for("react.block") : 60121, w = b ? Symbol.for("react.fundamental") : 60117, x = b ? Symbol.for("react.responder") : 60118, y = b ? Symbol.for("react.scope") : 60119;
function z(a) {
    if ("object" === typeof a && null !== a) {
        var u = a.$$typeof;
        switch(u){
            case c:
                switch(a = a.type, a){
                    case l:
                    case m:
                    case e:
                    case g:
                    case f:
                    case p:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case k:
                            case n:
                            case t:
                            case r:
                            case h:
                                return a;
                            default:
                                return u;
                        }
                }
            case d:
                return u;
        }
    }
}
function A(a) {
    return z(a) === m;
}
exports.AsyncMode = l;
exports.ConcurrentMode = m;
exports.ContextConsumer = k;
exports.ContextProvider = h;
exports.Element = c;
exports.ForwardRef = n;
exports.Fragment = e;
exports.Lazy = t;
exports.Memo = r;
exports.Portal = d;
exports.Profiler = g;
exports.StrictMode = f;
exports.Suspense = p;
exports.isAsyncMode = function(a) {
    return A(a) || z(a) === l;
};
exports.isConcurrentMode = A;
exports.isContextConsumer = function(a) {
    return z(a) === k;
};
exports.isContextProvider = function(a) {
    return z(a) === h;
};
exports.isElement = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === c;
};
exports.isForwardRef = function(a) {
    return z(a) === n;
};
exports.isFragment = function(a) {
    return z(a) === e;
};
exports.isLazy = function(a) {
    return z(a) === t;
};
exports.isMemo = function(a) {
    return z(a) === r;
};
exports.isPortal = function(a) {
    return z(a) === d;
};
exports.isProfiler = function(a) {
    return z(a) === g;
};
exports.isStrictMode = function(a) {
    return z(a) === f;
};
exports.isSuspense = function(a) {
    return z(a) === p;
};
exports.isValidElementType = function(a) {
    return "string" === typeof a || "function" === typeof a || a === e || a === m || a === g || a === f || a === p || a === q || "object" === typeof a && null !== a && (a.$$typeof === t || a.$$typeof === r || a.$$typeof === h || a.$$typeof === k || a.$$typeof === n || a.$$typeof === w || a.$$typeof === x || a.$$typeof === y || a.$$typeof === v);
};
exports.typeOf = z;

},{}],"9ZyRf":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var safeIsNaN = Number.isNaN || function ponyfill(value) {
    return typeof value === "number" && value !== value;
};
function isEqual(first, second) {
    if (first === second) return true;
    if (safeIsNaN(first) && safeIsNaN(second)) return true;
    return false;
}
function areInputsEqual(newInputs, lastInputs) {
    if (newInputs.length !== lastInputs.length) return false;
    for(var i = 0; i < newInputs.length; i++){
        if (!isEqual(newInputs[i], lastInputs[i])) return false;
    }
    return true;
}
function memoizeOne(resultFn, isEqual) {
    if (isEqual === void 0) isEqual = areInputsEqual;
    var lastThis;
    var lastArgs = [];
    var lastResult;
    var calledOnce = false;
    function memoized() {
        var newArgs = [];
        for(var _i = 0; _i < arguments.length; _i++)newArgs[_i] = arguments[_i];
        if (calledOnce && lastThis === this && isEqual(newArgs, lastArgs)) return lastResult;
        lastResult = resultFn.apply(this, newArgs);
        calledOnce = true;
        lastThis = this;
        lastArgs = newArgs;
        return lastResult;
    }
    return memoized;
}
exports.default = memoizeOne;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"jNzT2":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _memoize = require("@emotion/memoize");
var _memoizeDefault = parcelHelpers.interopDefault(_memoize);
var reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|download|draggable|encType|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|inert|itemProp|itemScope|itemType|itemID|itemRef|on|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23
var index = (0, _memoizeDefault.default)(function(prop) {
    return reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111 && prop.charCodeAt(1) === 110 && prop.charCodeAt(2) < 91;
});
exports.default = index;

},{"@emotion/memoize":"3jtB6","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"3jtB6":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function memoize(fn) {
    var cache = {};
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}
exports.default = memoize;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"jOpK9":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "concatArrays", ()=>concatArrays);
parcelHelpers.export(exports, "merge", ()=>merge);
var _isWhat = require("is-what");
/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */ function __spreadArrays() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function assignProp(carry, key, newVal, originalObject) {
    var propType = originalObject.propertyIsEnumerable(key) ? "enumerable" : "nonenumerable";
    if (propType === "enumerable") carry[key] = newVal;
    if (propType === "nonenumerable") Object.defineProperty(carry, key, {
        value: newVal,
        enumerable: false,
        writable: true,
        configurable: true
    });
}
function mergeRecursively(origin, newComer, extensions) {
    // work directly on newComer if its not an object
    if (!(0, _isWhat.isPlainObject)(newComer)) {
        // extend merge rules
        if (extensions && (0, _isWhat.isArray)(extensions)) extensions.forEach(function(extend) {
            newComer = extend(origin, newComer);
        });
        return newComer;
    }
    // define newObject to merge all values upon
    var newObject = {};
    if ((0, _isWhat.isPlainObject)(origin)) {
        var props_1 = Object.getOwnPropertyNames(origin);
        var symbols_1 = Object.getOwnPropertySymbols(origin);
        newObject = __spreadArrays(props_1, symbols_1).reduce(function(carry, key) {
            // @ts-ignore
            var targetVal = origin[key];
            if (!(0, _isWhat.isSymbol)(key) && !Object.getOwnPropertyNames(newComer).includes(key) || (0, _isWhat.isSymbol)(key) && !Object.getOwnPropertySymbols(newComer).includes(key)) assignProp(carry, key, targetVal, origin);
            return carry;
        }, {});
    }
    var props = Object.getOwnPropertyNames(newComer);
    var symbols = Object.getOwnPropertySymbols(newComer);
    var result = __spreadArrays(props, symbols).reduce(function(carry, key) {
        // re-define the origin and newComer as targetVal and newVal
        var newVal = newComer[key];
        var targetVal = (0, _isWhat.isPlainObject)(origin) ? origin[key] : undefined;
        // extend merge rules
        if (extensions && (0, _isWhat.isArray)(extensions)) extensions.forEach(function(extend) {
            newVal = extend(targetVal, newVal);
        });
        // When newVal is an object do the merge recursively
        if (targetVal !== undefined && (0, _isWhat.isPlainObject)(newVal)) newVal = mergeRecursively(targetVal, newVal, extensions);
        assignProp(carry, key, newVal, newComer);
        return carry;
    }, newObject);
    return result;
}
/**
 * Merge anything recursively.
 * Objects get merged, special objects (classes etc.) are re-assigned "as is".
 * Basic types overwrite objects or other basic types.
 *
 * @param {(IConfig | any)} origin
 * @param {...any[]} newComers
 * @returns the result
 */ function merge(origin) {
    var newComers = [];
    for(var _i = 1; _i < arguments.length; _i++)newComers[_i - 1] = arguments[_i];
    var extensions = null;
    var base = origin;
    if ((0, _isWhat.isPlainObject)(origin) && origin.extensions && Object.keys(origin).length === 1) {
        base = {};
        extensions = origin.extensions;
    }
    return newComers.reduce(function(result, newComer) {
        return mergeRecursively(result, newComer, extensions);
    }, base);
}
function concatArrays(originVal, newVal) {
    if ((0, _isWhat.isArray)(originVal) && (0, _isWhat.isArray)(newVal)) // concat logic
    return originVal.concat(newVal);
    return newVal; // always return newVal as fallback!!
}
exports.default = merge;

},{"is-what":"2uVyU","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2uVyU":[function(require,module,exports) {
/**
 * Returns the object type of the given payload
 *
 * @param {*} payload
 * @returns {string}
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getType", ()=>getType);
parcelHelpers.export(exports, "isAnyObject", ()=>isAnyObject);
parcelHelpers.export(exports, "isArray", ()=>isArray);
parcelHelpers.export(exports, "isBlob", ()=>isBlob);
parcelHelpers.export(exports, "isBoolean", ()=>isBoolean);
parcelHelpers.export(exports, "isDate", ()=>isDate);
parcelHelpers.export(exports, "isEmptyArray", ()=>isEmptyArray);
parcelHelpers.export(exports, "isEmptyObject", ()=>isEmptyObject);
parcelHelpers.export(exports, "isEmptyString", ()=>isEmptyString);
parcelHelpers.export(exports, "isError", ()=>isError);
parcelHelpers.export(exports, "isFile", ()=>isFile);
parcelHelpers.export(exports, "isFullArray", ()=>isFullArray);
parcelHelpers.export(exports, "isFullObject", ()=>isFullObject);
parcelHelpers.export(exports, "isFullString", ()=>isFullString);
parcelHelpers.export(exports, "isFunction", ()=>isFunction);
parcelHelpers.export(exports, "isMap", ()=>isMap);
parcelHelpers.export(exports, "isNaNValue", ()=>isNaNValue);
parcelHelpers.export(exports, "isNull", ()=>isNull);
parcelHelpers.export(exports, "isNullOrUndefined", ()=>isNullOrUndefined);
parcelHelpers.export(exports, "isNumber", ()=>isNumber);
parcelHelpers.export(exports, "isObject", ()=>isObject);
parcelHelpers.export(exports, "isObjectLike", ()=>isObjectLike);
parcelHelpers.export(exports, "isOneOf", ()=>isOneOf);
parcelHelpers.export(exports, "isPlainObject", ()=>isPlainObject);
parcelHelpers.export(exports, "isPrimitive", ()=>isPrimitive);
parcelHelpers.export(exports, "isPromise", ()=>isPromise);
parcelHelpers.export(exports, "isRegExp", ()=>isRegExp);
parcelHelpers.export(exports, "isSet", ()=>isSet);
parcelHelpers.export(exports, "isString", ()=>isString);
parcelHelpers.export(exports, "isSymbol", ()=>isSymbol);
parcelHelpers.export(exports, "isType", ()=>isType);
parcelHelpers.export(exports, "isUndefined", ()=>isUndefined);
parcelHelpers.export(exports, "isWeakMap", ()=>isWeakMap);
parcelHelpers.export(exports, "isWeakSet", ()=>isWeakSet);
function getType(payload) {
    return Object.prototype.toString.call(payload).slice(8, -1);
}
/**
 * Returns whether the payload is undefined
 *
 * @param {*} payload
 * @returns {payload is undefined}
 */ function isUndefined(payload) {
    return getType(payload) === "Undefined";
}
/**
 * Returns whether the payload is null
 *
 * @param {*} payload
 * @returns {payload is null}
 */ function isNull(payload) {
    return getType(payload) === "Null";
}
/**
 * Returns whether the payload is a plain JavaScript object (excluding special classes or objects with other prototypes)
 *
 * @param {*} payload
 * @returns {payload is PlainObject}
 */ function isPlainObject(payload) {
    if (getType(payload) !== "Object") return false;
    return payload.constructor === Object && Object.getPrototypeOf(payload) === Object.prototype;
}
/**
 * Returns whether the payload is a plain JavaScript object (excluding special classes or objects with other prototypes)
 *
 * @param {*} payload
 * @returns {payload is PlainObject}
 */ function isObject(payload) {
    return isPlainObject(payload);
}
/**
 * Returns whether the payload is a an empty object (excluding special classes or objects with other prototypes)
 *
 * @param {*} payload
 * @returns {payload is { [K in any]: never }}
 */ function isEmptyObject(payload) {
    return isPlainObject(payload) && Object.keys(payload).length === 0;
}
/**
 * Returns whether the payload is a an empty object (excluding special classes or objects with other prototypes)
 *
 * @param {*} payload
 * @returns {payload is PlainObject}
 */ function isFullObject(payload) {
    return isPlainObject(payload) && Object.keys(payload).length > 0;
}
/**
 * Returns whether the payload is an any kind of object (including special classes or objects with different prototypes)
 *
 * @param {*} payload
 * @returns {payload is PlainObject}
 */ function isAnyObject(payload) {
    return getType(payload) === "Object";
}
/**
 * Returns whether the payload is an object like a type passed in < >
 *
 * Usage: isObjectLike<{id: any}>(payload) // will make sure it's an object and has an `id` prop.
 *
 * @template T this must be passed in < >
 * @param {*} payload
 * @returns {payload is T}
 */ function isObjectLike(payload) {
    return isAnyObject(payload);
}
/**
 * Returns whether the payload is a function (regular or async)
 *
 * @param {*} payload
 * @returns {payload is AnyFunction}
 */ function isFunction(payload) {
    return typeof payload === "function";
}
/**
 * Returns whether the payload is an array
 *
 * @param {any} payload
 * @returns {payload is any[]}
 */ function isArray(payload) {
    return getType(payload) === "Array";
}
/**
 * Returns whether the payload is a an array with at least 1 item
 *
 * @param {*} payload
 * @returns {payload is any[]}
 */ function isFullArray(payload) {
    return isArray(payload) && payload.length > 0;
}
/**
 * Returns whether the payload is a an empty array
 *
 * @param {*} payload
 * @returns {payload is []}
 */ function isEmptyArray(payload) {
    return isArray(payload) && payload.length === 0;
}
/**
 * Returns whether the payload is a string
 *
 * @param {*} payload
 * @returns {payload is string}
 */ function isString(payload) {
    return getType(payload) === "String";
}
/**
 * Returns whether the payload is a string, BUT returns false for ''
 *
 * @param {*} payload
 * @returns {payload is string}
 */ function isFullString(payload) {
    return isString(payload) && payload !== "";
}
/**
 * Returns whether the payload is ''
 *
 * @param {*} payload
 * @returns {payload is string}
 */ function isEmptyString(payload) {
    return payload === "";
}
/**
 * Returns whether the payload is a number (but not NaN)
 *
 * This will return `false` for `NaN`!!
 *
 * @param {*} payload
 * @returns {payload is number}
 */ function isNumber(payload) {
    return getType(payload) === "Number" && !isNaN(payload);
}
/**
 * Returns whether the payload is a boolean
 *
 * @param {*} payload
 * @returns {payload is boolean}
 */ function isBoolean(payload) {
    return getType(payload) === "Boolean";
}
/**
 * Returns whether the payload is a regular expression (RegExp)
 *
 * @param {*} payload
 * @returns {payload is RegExp}
 */ function isRegExp(payload) {
    return getType(payload) === "RegExp";
}
/**
 * Returns whether the payload is a Map
 *
 * @param {*} payload
 * @returns {payload is Map<any, any>}
 */ function isMap(payload) {
    return getType(payload) === "Map";
}
/**
 * Returns whether the payload is a WeakMap
 *
 * @param {*} payload
 * @returns {payload is WeakMap<any, any>}
 */ function isWeakMap(payload) {
    return getType(payload) === "WeakMap";
}
/**
 * Returns whether the payload is a Set
 *
 * @param {*} payload
 * @returns {payload is Set<any>}
 */ function isSet(payload) {
    return getType(payload) === "Set";
}
/**
 * Returns whether the payload is a WeakSet
 *
 * @param {*} payload
 * @returns {payload is WeakSet<any>}
 */ function isWeakSet(payload) {
    return getType(payload) === "WeakSet";
}
/**
 * Returns whether the payload is a Symbol
 *
 * @param {*} payload
 * @returns {payload is symbol}
 */ function isSymbol(payload) {
    return getType(payload) === "Symbol";
}
/**
 * Returns whether the payload is a Date, and that the date is valid
 *
 * @param {*} payload
 * @returns {payload is Date}
 */ function isDate(payload) {
    return getType(payload) === "Date" && !isNaN(payload);
}
/**
 * Returns whether the payload is a Blob
 *
 * @param {*} payload
 * @returns {payload is Blob}
 */ function isBlob(payload) {
    return getType(payload) === "Blob";
}
/**
 * Returns whether the payload is a File
 *
 * @param {*} payload
 * @returns {payload is File}
 */ function isFile(payload) {
    return getType(payload) === "File";
}
/**
 * Returns whether the payload is a Promise
 *
 * @param {*} payload
 * @returns {payload is Promise<any>}
 */ function isPromise(payload) {
    return getType(payload) === "Promise";
}
/**
 * Returns whether the payload is an Error
 *
 * @param {*} payload
 * @returns {payload is Error}
 */ function isError(payload) {
    return getType(payload) === "Error";
}
/**
 * Returns whether the payload is literally the value `NaN` (it's `NaN` and also a `number`)
 *
 * @param {*} payload
 * @returns {payload is typeof NaN}
 */ function isNaNValue(payload) {
    return getType(payload) === "Number" && isNaN(payload);
}
/**
 * Returns whether the payload is a primitive type (eg. Boolean | Null | Undefined | Number | String | Symbol)
 *
 * @param {*} payload
 * @returns {(payload is boolean | null | undefined | number | string | symbol)}
 */ function isPrimitive(payload) {
    return isBoolean(payload) || isNull(payload) || isUndefined(payload) || isNumber(payload) || isString(payload) || isSymbol(payload);
}
/**
 * Returns true whether the payload is null or undefined
 *
 * @param {*} payload
 * @returns {(payload is null | undefined)}
 */ var isNullOrUndefined = isOneOf(isNull, isUndefined);
function isOneOf(a, b, c, d, e) {
    return function(value) {
        return a(value) || b(value) || !!c && c(value) || !!d && d(value) || !!e && e(value);
    };
}
/**
 * Does a generic check to check that the given payload is of a given type.
 * In cases like Number, it will return true for NaN as NaN is a Number (thanks javascript!);
 * It will, however, differentiate between object and null
 *
 * @template T
 * @param {*} payload
 * @param {T} type
 * @throws {TypeError} Will throw type error if type is an invalid type
 * @returns {payload is T}
 */ function isType(payload, type) {
    if (!(type instanceof Function)) throw new TypeError("Type must be a function");
    if (!Object.prototype.hasOwnProperty.call(type, "prototype")) throw new TypeError("Type is not a class");
    // Classes usually have names (as functions usually have names)
    var name = type.name;
    return getType(payload) === name || Boolean(payload && payload.constructor === type);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"hK09n":[function(require,module,exports) {
/*! For license information please see web3.min.js.LICENSE.txt */ !function(e, t) {
    module.exports = t();
}(self, ()=>(()=>{
        var e = {
            81645: (e, t, r)=>{
                "use strict";
                var n = function(e) {
                    var t = "function" == typeof Symbol && Symbol.iterator, r = t && e[t], n = 0;
                    if (r) return r.call(e);
                    if (e && "number" == typeof e.length) return {
                        next: function() {
                            return e && n >= e.length && (e = void 0), {
                                value: e && e[n++],
                                done: !e
                            };
                        }
                    };
                    throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
                }, i = function(e) {
                    return e && e.__esModule ? e : {
                        default: e
                    };
                };
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.chains = t._getInitializedChains = void 0;
                var o = i(r(87295)), a = i(r(31227)), s = i(r(40439)), u = i(r(37098)), c = i(r(17687)), f = i(r(49422));
                function d(e) {
                    var t, r, i = {
                        1: "mainnet",
                        3: "ropsten",
                        4: "rinkeby",
                        42: "kovan",
                        5: "goerli",
                        11155111: "sepolia"
                    }, d = {
                        mainnet: o.default,
                        ropsten: a.default,
                        rinkeby: s.default,
                        kovan: u.default,
                        goerli: c.default,
                        sepolia: f.default
                    };
                    if (e) try {
                        for(var l = n(e), h = l.next(); !h.done; h = l.next()){
                            var p = h.value, b = p.name;
                            i[p.chainId.toString()] = b, d[b] = p;
                        }
                    } catch (e) {
                        t = {
                            error: e
                        };
                    } finally{
                        try {
                            h && !h.done && (r = l.return) && r.call(l);
                        } finally{
                            if (t) throw t.error;
                        }
                    }
                    return d.names = i, d;
                }
                t._getInitializedChains = d, t.chains = d();
            },
            425: (e, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.EIPs = void 0, t.EIPs = {
                    1153: r(96561),
                    1559: r(77523),
                    2315: r(83339),
                    2537: r(26769),
                    2565: r(17897),
                    2718: r(62170),
                    2929: r(88436),
                    2930: r(96213),
                    3198: r(25491),
                    3529: r(20070),
                    3540: r(52256),
                    3541: r(21871),
                    3554: r(47225),
                    3607: r(3968),
                    3651: r(29496),
                    3670: r(74290),
                    3675: r(98571),
                    3855: r(64551),
                    3860: r(94300),
                    4345: r(74818),
                    4399: r(68372),
                    5133: r(4759)
                };
            },
            7002: (e, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.hardforks = void 0, t.hardforks = [
                    [
                        "chainstart",
                        r(60114)
                    ],
                    [
                        "homestead",
                        r(62800)
                    ],
                    [
                        "dao",
                        r(7197)
                    ],
                    [
                        "tangerineWhistle",
                        r(22302)
                    ],
                    [
                        "spuriousDragon",
                        r(90716)
                    ],
                    [
                        "byzantium",
                        r(26985)
                    ],
                    [
                        "constantinople",
                        r(35993)
                    ],
                    [
                        "petersburg",
                        r(4064)
                    ],
                    [
                        "istanbul",
                        r(83166)
                    ],
                    [
                        "muirGlacier",
                        r(42946)
                    ],
                    [
                        "berlin",
                        r(20015)
                    ],
                    [
                        "london",
                        r(61250)
                    ],
                    [
                        "shanghai",
                        r(5553)
                    ],
                    [
                        "arrowGlacier",
                        r(51971)
                    ],
                    [
                        "grayGlacier",
                        r(31088)
                    ],
                    [
                        "mergeForkIdTransition",
                        r(49347)
                    ],
                    [
                        "merge",
                        r(88648)
                    ]
                ];
            },
            3863: (e, t, r)=>{
                "use strict";
                var n, i = r(29033).Buffer, o = r(28847)(r(3355)), a = (n = function(e, t) {
                    return n = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(e, t) {
                        e.__proto__ = t;
                    } || function(e, t) {
                        for(var r in t)Object.prototype.hasOwnProperty.call(t, r) && (e[r] = t[r]);
                    }, n(e, t);
                }, function(e, t) {
                    if ("function" != typeof t && null !== t) throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");
                    function r() {
                        this.constructor = e;
                    }
                    n(e, t), e.prototype = null === t ? Object.create(t) : (r.prototype = t.prototype, new r);
                }), s = function() {
                    return s = Object.assign || function(e) {
                        for(var t, r = 1, n = arguments.length; r < n; r++)for(var i in t = arguments[r])Object.prototype.hasOwnProperty.call(t, i) && (e[i] = t[i]);
                        return e;
                    }, s.apply(this, arguments);
                }, u = function(e) {
                    var t = "function" == typeof Symbol && Symbol.iterator, r = t && e[t], n = 0;
                    if (r) return r.call(e);
                    if (e && "number" == typeof e.length) return {
                        next: function() {
                            return e && n >= e.length && (e = void 0), {
                                value: e && e[n++],
                                done: !e
                            };
                        }
                    };
                    throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
                };
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.ConsensusAlgorithm = t.ConsensusType = t.Hardfork = t.Chain = t.CustomChain = void 0;
                var c, f, d, l, h, p = r(38291), b = r(64628), y = r(33062), v = r(81645), m = r(7002), g = r(425);
                !function(e) {
                    e.PolygonMainnet = "polygon-mainnet", e.PolygonMumbai = "polygon-mumbai", e.ArbitrumRinkebyTestnet = "arbitrum-rinkeby-testnet", e.xDaiChain = "x-dai-chain", e.OptimisticKovan = "optimistic-kovan", e.OptimisticEthereum = "optimistic-ethereum";
                }(c = t.CustomChain || (t.CustomChain = {})), (h = t.Chain || (t.Chain = {}))[h.Mainnet = 1] = "Mainnet", h[h.Ropsten = 3] = "Ropsten", h[h.Rinkeby = 4] = "Rinkeby", h[h.Kovan = 42] = "Kovan", h[h.Goerli = 5] = "Goerli", h[h.Sepolia = 11155111] = "Sepolia", function(e) {
                    e.Chainstart = "chainstart", e.Homestead = "homestead", e.Dao = "dao", e.TangerineWhistle = "tangerineWhistle", e.SpuriousDragon = "spuriousDragon", e.Byzantium = "byzantium", e.Constantinople = "constantinople", e.Petersburg = "petersburg", e.Istanbul = "istanbul", e.MuirGlacier = "muirGlacier", e.Berlin = "berlin", e.London = "london", e.ArrowGlacier = "arrowGlacier", e.GrayGlacier = "grayGlacier", e.MergeForkIdTransition = "mergeForkIdTransition", e.Merge = "merge", e.Shanghai = "shanghai";
                }(f = t.Hardfork || (t.Hardfork = {})), (l = t.ConsensusType || (t.ConsensusType = {})).ProofOfStake = "pos", l.ProofOfWork = "pow", l.ProofOfAuthority = "poa", (d = t.ConsensusAlgorithm || (t.ConsensusAlgorithm = {})).Ethash = "ethash", d.Clique = "clique", d.Casper = "casper";
                var w = function(e) {
                    function t(t) {
                        var r, n, i, o, a = this;
                        (a = e.call(this) || this)._supportedHardforks = [], a._eips = [], a._customChains = null !== (i = t.customChains) && void 0 !== i ? i : [], a._chainParams = a.setChain(t.chain), a.DEFAULT_HARDFORK = null !== (o = a._chainParams.defaultHardfork) && void 0 !== o ? o : f.Istanbul;
                        try {
                            for(var s = u(a._chainParams.hardforks), c = s.next(); !c.done; c = s.next()){
                                var d = c.value;
                                d.forkHash || (d.forkHash = a._calcForkHash(d.name));
                            }
                        } catch (e) {
                            r = {
                                error: e
                            };
                        } finally{
                            try {
                                c && !c.done && (n = s.return) && n.call(s);
                            } finally{
                                if (r) throw r.error;
                            }
                        }
                        return a._hardfork = a.DEFAULT_HARDFORK, t.supportedHardforks && (a._supportedHardforks = t.supportedHardforks), t.hardfork && a.setHardfork(t.hardfork), t.eips && a.setEIPs(t.eips), a;
                    }
                    return a(t, e), t.custom = function(e, r) {
                        var n;
                        void 0 === r && (r = {});
                        var i = null !== (n = r.baseChain) && void 0 !== n ? n : "mainnet", o = s({}, t._getChainParams(i));
                        if (o.name = "custom-chain", "string" != typeof e) return new t(s({
                            chain: s(s({}, o), e)
                        }, r));
                        if (e === c.PolygonMainnet) return t.custom({
                            name: c.PolygonMainnet,
                            chainId: 137,
                            networkId: 137
                        }, r);
                        if (e === c.PolygonMumbai) return t.custom({
                            name: c.PolygonMumbai,
                            chainId: 80001,
                            networkId: 80001
                        }, r);
                        if (e === c.ArbitrumRinkebyTestnet) return t.custom({
                            name: c.ArbitrumRinkebyTestnet,
                            chainId: 421611,
                            networkId: 421611
                        }, r);
                        if (e === c.xDaiChain) return t.custom({
                            name: c.xDaiChain,
                            chainId: 100,
                            networkId: 100
                        }, r);
                        if (e === c.OptimisticKovan) return t.custom({
                            name: c.OptimisticKovan,
                            chainId: 69,
                            networkId: 69
                        }, s({
                            hardfork: f.Berlin
                        }, r));
                        if (e === c.OptimisticEthereum) return t.custom({
                            name: c.OptimisticEthereum,
                            chainId: 10,
                            networkId: 10
                        }, s({
                            hardfork: f.Berlin
                        }, r));
                        throw new Error("Custom chain ".concat(e, " not supported"));
                    }, t.forCustomChain = function(e, r, n, i) {
                        var o = t._getChainParams(e);
                        return new t({
                            chain: s(s({}, o), r),
                            hardfork: n,
                            supportedHardforks: i
                        });
                    }, t.isSupportedChainId = function(e) {
                        var t = (0, v._getInitializedChains)();
                        return Boolean(t.names[e.toString()]);
                    }, t._getChainParams = function(e, t) {
                        var r = (0, v._getInitializedChains)(t);
                        if ("number" == typeof e || y.BN.isBN(e)) {
                            if (e = e.toString(), r.names[e]) return r[r.names[e]];
                            throw new Error("Chain with ID ".concat(e, " not supported"));
                        }
                        if (r[e]) return r[e];
                        throw new Error("Chain with name ".concat(e, " not supported"));
                    }, t.prototype.setChain = function(e) {
                        var r, n;
                        if ("number" == typeof e || "string" == typeof e || y.BN.isBN(e)) {
                            var i;
                            i = this._customChains && this._customChains.length > 0 && Array.isArray(this._customChains[0]) ? this._customChains.map(function(e) {
                                return e[0];
                            }) : this._customChains, this._chainParams = t._getChainParams(e, i);
                        } else {
                            if ("object" !== (0, o.default)(e)) throw new Error("Wrong input format");
                            if (this._customChains.length > 0) throw new Error("Chain must be a string, number, or BN when initialized with customChains passed in");
                            try {
                                for(var a = u([
                                    "networkId",
                                    "genesis",
                                    "hardforks",
                                    "bootstrapNodes"
                                ]), s = a.next(); !s.done; s = a.next()){
                                    var c = s.value;
                                    if (void 0 === e[c]) throw new Error("Missing required chain parameter: ".concat(c));
                                }
                            } catch (e) {
                                r = {
                                    error: e
                                };
                            } finally{
                                try {
                                    s && !s.done && (n = a.return) && n.call(a);
                                } finally{
                                    if (r) throw r.error;
                                }
                            }
                            this._chainParams = e;
                        }
                        return this._chainParams;
                    }, t.prototype.setHardfork = function(e) {
                        var t, r;
                        if (!this._isSupportedHardfork(e)) throw new Error("Hardfork ".concat(e, " not set as supported in supportedHardforks"));
                        var n = !1;
                        try {
                            for(var i = u(m.hardforks), o = i.next(); !o.done; o = i.next())o.value[0] === e && (this._hardfork !== e && (this._hardfork = e, this.emit("hardforkChanged", e)), n = !0);
                        } catch (e) {
                            t = {
                                error: e
                            };
                        } finally{
                            try {
                                o && !o.done && (r = i.return) && r.call(i);
                            } finally{
                                if (t) throw t.error;
                            }
                        }
                        if (!n) throw new Error("Hardfork with name ".concat(e, " not supported"));
                    }, t.prototype.getHardforkByBlockNumber = function(e, t) {
                        var r, n;
                        e = (0, y.toType)(e, y.TypeOutput.BN), t = (0, y.toType)(t, y.TypeOutput.BN);
                        var i, o, a, s = f.Chainstart;
                        try {
                            for(var c = u(this.hardforks()), d = c.next(); !d.done; d = c.next()){
                                var l = d.value;
                                if (null !== l.block) e.gte(new y.BN(l.block)) && (s = l.name), t && l.td && (t.gte(new y.BN(l.td)) ? i = l.name : o = a), a = l.name;
                                else if (null != t && void 0 !== l.td && null !== l.td && t.gte(new y.BN(l.td))) return l.name;
                            }
                        } catch (e) {
                            r = {
                                error: e
                            };
                        } finally{
                            try {
                                d && !d.done && (n = c.return) && n.call(c);
                            } finally{
                                if (r) throw r.error;
                            }
                        }
                        if (t) {
                            var h = "block number: ".concat(e, " (-> ").concat(s, "), ");
                            if (i && !this.hardforkGteHardfork(s, i)) {
                                var p = "HF determined by block number is lower than the minimum total difficulty HF";
                                throw h += "total difficulty: ".concat(t, " (-> ").concat(i, ")"), new Error("".concat(p, ": ").concat(h));
                            }
                            if (o && !this.hardforkGteHardfork(o, s)) throw p = "Maximum HF determined by total difficulty is lower than the block number HF", h += "total difficulty: ".concat(t, " (-> ").concat(o, ")"), new Error("".concat(p, ": ").concat(h));
                        }
                        return s;
                    }, t.prototype.setHardforkByBlockNumber = function(e, t) {
                        var r = this.getHardforkByBlockNumber(e, t);
                        return this.setHardfork(r), r;
                    }, t.prototype._chooseHardfork = function(e, t) {
                        if (void 0 === t && (t = !0), e) {
                            if (t && !this._isSupportedHardfork(e)) throw new Error("Hardfork ".concat(e, " not set as supported in supportedHardforks"));
                        } else e = this._hardfork;
                        return e;
                    }, t.prototype._getHardfork = function(e) {
                        var t, r, n = this.hardforks();
                        try {
                            for(var i = u(n), o = i.next(); !o.done; o = i.next()){
                                var a = o.value;
                                if (a.name === e) return a;
                            }
                        } catch (e) {
                            t = {
                                error: e
                            };
                        } finally{
                            try {
                                o && !o.done && (r = i.return) && r.call(i);
                            } finally{
                                if (t) throw t.error;
                            }
                        }
                        throw new Error("Hardfork ".concat(e, " not defined for chain ").concat(this.chainName()));
                    }, t.prototype._isSupportedHardfork = function(e) {
                        var t, r;
                        if (!(this._supportedHardforks.length > 0)) return !0;
                        try {
                            for(var n = u(this._supportedHardforks), i = n.next(); !i.done; i = n.next())if (e === i.value) return !0;
                        } catch (e) {
                            t = {
                                error: e
                            };
                        } finally{
                            try {
                                i && !i.done && (r = n.return) && r.call(n);
                            } finally{
                                if (t) throw t.error;
                            }
                        }
                        return !1;
                    }, t.prototype.setEIPs = function(e) {
                        var t, r, n = this;
                        void 0 === e && (e = []);
                        var i = function(t) {
                            if (!(t in g.EIPs)) throw new Error("".concat(t, " not supported"));
                            var r = o.gteHardfork(g.EIPs[t].minimumHardfork);
                            if (!r) throw new Error("".concat(t, " cannot be activated on hardfork ").concat(o.hardfork(), ", minimumHardfork: ").concat(r));
                            g.EIPs[t].requiredEIPs && g.EIPs[t].requiredEIPs.forEach(function(r) {
                                if (!e.includes(r) && !n.isActivatedEIP(r)) throw new Error("".concat(t, " requires EIP ").concat(r, ", but is not included in the EIP list"));
                            });
                        }, o = this;
                        try {
                            for(var a = u(e), s = a.next(); !s.done; s = a.next())i(s.value);
                        } catch (e) {
                            t = {
                                error: e
                            };
                        } finally{
                            try {
                                s && !s.done && (r = a.return) && r.call(a);
                            } finally{
                                if (t) throw t.error;
                            }
                        }
                        this._eips = e;
                    }, t.prototype.param = function(e, t) {
                        var r, n, i = null;
                        try {
                            for(var o = u(this._eips), a = o.next(); !a.done; a = o.next()){
                                var s = a.value;
                                if (null !== (i = this.paramByEIP(e, t, s))) return i;
                            }
                        } catch (e) {
                            r = {
                                error: e
                            };
                        } finally{
                            try {
                                a && !a.done && (n = o.return) && n.call(o);
                            } finally{
                                if (r) throw r.error;
                            }
                        }
                        return this.paramByHardfork(e, t, this._hardfork);
                    }, t.prototype.paramByHardfork = function(e, t, r) {
                        var n, i, o, a;
                        r = this._chooseHardfork(r);
                        var s = null;
                        try {
                            for(var c = u(m.hardforks), f = c.next(); !f.done; f = c.next()){
                                var d = f.value;
                                if ("eips" in d[1]) {
                                    var l = d[1].eips;
                                    try {
                                        for(var h = (o = void 0, u(l)), p = h.next(); !p.done; p = h.next()){
                                            var b = p.value, y = this.paramByEIP(e, t, b);
                                            s = null !== y ? y : s;
                                        }
                                    } catch (e) {
                                        o = {
                                            error: e
                                        };
                                    } finally{
                                        try {
                                            p && !p.done && (a = h.return) && a.call(h);
                                        } finally{
                                            if (o) throw o.error;
                                        }
                                    }
                                } else {
                                    if (!d[1][e]) throw new Error("Topic ".concat(e, " not defined"));
                                    void 0 !== d[1][e][t] && (s = d[1][e][t].v);
                                }
                                if (d[0] === r) break;
                            }
                        } catch (e) {
                            n = {
                                error: e
                            };
                        } finally{
                            try {
                                f && !f.done && (i = c.return) && i.call(c);
                            } finally{
                                if (n) throw n.error;
                            }
                        }
                        return s;
                    }, t.prototype.paramByEIP = function(e, t, r) {
                        if (!(r in g.EIPs)) throw new Error("".concat(r, " not supported"));
                        var n = g.EIPs[r];
                        if (!(e in n)) throw new Error("Topic ".concat(e, " not defined"));
                        return void 0 === n[e][t] ? null : n[e][t].v;
                    }, t.prototype.paramByBlock = function(e, t, r) {
                        var n = this.activeHardforks(r), i = n[n.length - 1].name;
                        return this.paramByHardfork(e, t, i);
                    }, t.prototype.isActivatedEIP = function(e) {
                        var t, r;
                        if (this.eips().includes(e)) return !0;
                        try {
                            for(var n = u(m.hardforks), i = n.next(); !i.done; i = n.next()){
                                var o = i.value[1];
                                if (this.gteHardfork(o.name) && "eips" in o && o.eips.includes(e)) return !0;
                            }
                        } catch (e) {
                            t = {
                                error: e
                            };
                        } finally{
                            try {
                                i && !i.done && (r = n.return) && r.call(n);
                            } finally{
                                if (t) throw t.error;
                            }
                        }
                        return !1;
                    }, t.prototype.hardforkIsActiveOnBlock = function(e, t, r) {
                        var n;
                        void 0 === r && (r = {}), t = (0, y.toType)(t, y.TypeOutput.BN);
                        var i = null !== (n = r.onlySupported) && void 0 !== n && n;
                        e = this._chooseHardfork(e, i);
                        var o = this.hardforkBlockBN(e);
                        return !(!o || !t.gte(o));
                    }, t.prototype.activeOnBlock = function(e, t) {
                        return this.hardforkIsActiveOnBlock(null, e, t);
                    }, t.prototype.hardforkGteHardfork = function(e, t, r) {
                        var n, i;
                        void 0 === r && (r = {});
                        var o, a = void 0 !== r.onlyActive && r.onlyActive;
                        e = this._chooseHardfork(e, r.onlySupported), o = a ? this.activeHardforks(null, r) : this.hardforks();
                        var s = -1, c = -1, f = 0;
                        try {
                            for(var d = u(o), l = d.next(); !l.done; l = d.next()){
                                var h = l.value;
                                h.name === e && (s = f), h.name === t && (c = f), f += 1;
                            }
                        } catch (e) {
                            n = {
                                error: e
                            };
                        } finally{
                            try {
                                l && !l.done && (i = d.return) && i.call(d);
                            } finally{
                                if (n) throw n.error;
                            }
                        }
                        return s >= c && -1 !== c;
                    }, t.prototype.gteHardfork = function(e, t) {
                        return this.hardforkGteHardfork(null, e, t);
                    }, t.prototype.hardforkIsActiveOnChain = function(e, t) {
                        var r, n, i;
                        void 0 === t && (t = {});
                        var o = null !== (i = t.onlySupported) && void 0 !== i && i;
                        e = this._chooseHardfork(e, o);
                        try {
                            for(var a = u(this.hardforks()), s = a.next(); !s.done; s = a.next()){
                                var c = s.value;
                                if (c.name === e && null !== c.block) return !0;
                            }
                        } catch (e) {
                            r = {
                                error: e
                            };
                        } finally{
                            try {
                                s && !s.done && (n = a.return) && n.call(a);
                            } finally{
                                if (r) throw r.error;
                            }
                        }
                        return !1;
                    }, t.prototype.activeHardforks = function(e, t) {
                        var r, n;
                        void 0 === t && (t = {});
                        var i = [], o = this.hardforks();
                        try {
                            for(var a = u(o), s = a.next(); !s.done; s = a.next()){
                                var c = s.value;
                                if (null !== c.block) {
                                    if (null != e && e < c.block) break;
                                    t.onlySupported && !this._isSupportedHardfork(c.name) || i.push(c);
                                }
                            }
                        } catch (e) {
                            r = {
                                error: e
                            };
                        } finally{
                            try {
                                s && !s.done && (n = a.return) && n.call(a);
                            } finally{
                                if (r) throw r.error;
                            }
                        }
                        return i;
                    }, t.prototype.activeHardfork = function(e, t) {
                        void 0 === t && (t = {});
                        var r = this.activeHardforks(e, t);
                        if (r.length > 0) return r[r.length - 1].name;
                        throw new Error("No (supported) active hardfork found");
                    }, t.prototype.hardforkBlock = function(e) {
                        var t = this.hardforkBlockBN(e);
                        return (0, y.toType)(t, y.TypeOutput.Number);
                    }, t.prototype.hardforkBlockBN = function(e) {
                        e = this._chooseHardfork(e, !1);
                        var t = this._getHardfork(e).block;
                        return null == t ? null : new y.BN(t);
                    }, t.prototype.hardforkTD = function(e) {
                        e = this._chooseHardfork(e, !1);
                        var t = this._getHardfork(e).td;
                        return null == t ? null : new y.BN(t);
                    }, t.prototype.isHardforkBlock = function(e, t) {
                        e = (0, y.toType)(e, y.TypeOutput.BN), t = this._chooseHardfork(t, !1);
                        var r = this.hardforkBlockBN(t);
                        return !!r && r.eq(e);
                    }, t.prototype.nextHardforkBlock = function(e) {
                        var t = this.nextHardforkBlockBN(e);
                        return (0, y.toType)(t, y.TypeOutput.Number);
                    }, t.prototype.nextHardforkBlockBN = function(e) {
                        e = this._chooseHardfork(e, !1);
                        var t = this.hardforkBlockBN(e);
                        return null === t ? null : this.hardforks().reduce(function(e, r) {
                            var n = new y.BN(r.block);
                            return n.gt(t) && null === e ? n : e;
                        }, null);
                    }, t.prototype.isNextHardforkBlock = function(e, t) {
                        e = (0, y.toType)(e, y.TypeOutput.BN), t = this._chooseHardfork(t, !1);
                        var r = this.nextHardforkBlockBN(t);
                        return null !== r && r.eq(e);
                    }, t.prototype._calcForkHash = function(e) {
                        var t, r, n = i.from(this.genesis().hash.substr(2), "hex"), o = i.alloc(0), a = 0;
                        try {
                            for(var s = u(this.hardforks()), c = s.next(); !c.done; c = s.next()){
                                var f = c.value, d = f.block;
                                if (0 !== d && null !== d && d !== a) {
                                    var l = i.from(d.toString(16).padStart(16, "0"), "hex");
                                    o = i.concat([
                                        o,
                                        l
                                    ]);
                                }
                                if (f.name === e) break;
                                null !== d && (a = d);
                            }
                        } catch (e) {
                            t = {
                                error: e
                            };
                        } finally{
                            try {
                                c && !c.done && (r = s.return) && r.call(s);
                            } finally{
                                if (t) throw t.error;
                            }
                        }
                        var h = i.concat([
                            n,
                            o
                        ]), p = (0, y.intToBuffer)((0, b.buf)(h) >>> 0).toString("hex");
                        return "0x".concat(p);
                    }, t.prototype.forkHash = function(e) {
                        e = this._chooseHardfork(e, !1);
                        var t = this._getHardfork(e);
                        if (null === t.block && void 0 === t.td) throw new Error("No fork hash calculation possible for future hardfork");
                        return void 0 !== t.forkHash ? t.forkHash : this._calcForkHash(e);
                    }, t.prototype.hardforkForForkHash = function(e) {
                        var t = this.hardforks().filter(function(t) {
                            return t.forkHash === e;
                        });
                        return t.length >= 1 ? t[t.length - 1] : null;
                    }, t.prototype.genesis = function() {
                        return this._chainParams.genesis;
                    }, t.prototype.genesisState = function() {
                        var e, t;
                        switch(this.chainName()){
                            case "mainnet":
                                return r(Object(function() {
                                    var e = new Error("Cannot find module './genesisStates/mainnet.json'");
                                    throw e.code = "MODULE_NOT_FOUND", e;
                                }()));
                            case "ropsten":
                                return r(Object(function() {
                                    var e = new Error("Cannot find module './genesisStates/ropsten.json'");
                                    throw e.code = "MODULE_NOT_FOUND", e;
                                }()));
                            case "rinkeby":
                                return r(Object(function() {
                                    var e = new Error("Cannot find module './genesisStates/rinkeby.json'");
                                    throw e.code = "MODULE_NOT_FOUND", e;
                                }()));
                            case "kovan":
                                return r(Object(function() {
                                    var e = new Error("Cannot find module './genesisStates/kovan.json'");
                                    throw e.code = "MODULE_NOT_FOUND", e;
                                }()));
                            case "goerli":
                                return r(Object(function() {
                                    var e = new Error("Cannot find module './genesisStates/goerli.json'");
                                    throw e.code = "MODULE_NOT_FOUND", e;
                                }()));
                            case "sepolia":
                                return r(Object(function() {
                                    var e = new Error("Cannot find module './genesisStates/sepolia.json'");
                                    throw e.code = "MODULE_NOT_FOUND", e;
                                }()));
                        }
                        if (this._customChains && this._customChains.length > 0 && Array.isArray(this._customChains[0])) try {
                            for(var n = u(this._customChains), i = n.next(); !i.done; i = n.next()){
                                var o = i.value;
                                if (o[0].name === this.chainName()) return o[1];
                            }
                        } catch (t) {
                            e = {
                                error: t
                            };
                        } finally{
                            try {
                                i && !i.done && (t = n.return) && t.call(n);
                            } finally{
                                if (e) throw e.error;
                            }
                        }
                        return {};
                    }, t.prototype.hardforks = function() {
                        return this._chainParams.hardforks;
                    }, t.prototype.bootstrapNodes = function() {
                        return this._chainParams.bootstrapNodes;
                    }, t.prototype.dnsNetworks = function() {
                        return this._chainParams.dnsNetworks;
                    }, t.prototype.hardfork = function() {
                        return this._hardfork;
                    }, t.prototype.chainId = function() {
                        return (0, y.toType)(this.chainIdBN(), y.TypeOutput.Number);
                    }, t.prototype.chainIdBN = function() {
                        return new y.BN(this._chainParams.chainId);
                    }, t.prototype.chainName = function() {
                        return this._chainParams.name;
                    }, t.prototype.networkId = function() {
                        return (0, y.toType)(this.networkIdBN(), y.TypeOutput.Number);
                    }, t.prototype.networkIdBN = function() {
                        return new y.BN(this._chainParams.networkId);
                    }, t.prototype.eips = function() {
                        return this._eips;
                    }, t.prototype.consensusType = function() {
                        var e, t, r, n = this.hardfork();
                        try {
                            for(var i = u(m.hardforks), o = i.next(); !o.done; o = i.next()){
                                var a = o.value;
                                if ("consensus" in a[1] && (r = a[1].consensus.type), a[0] === n) break;
                            }
                        } catch (t) {
                            e = {
                                error: t
                            };
                        } finally{
                            try {
                                o && !o.done && (t = i.return) && t.call(i);
                            } finally{
                                if (e) throw e.error;
                            }
                        }
                        return r || this._chainParams.consensus.type;
                    }, t.prototype.consensusAlgorithm = function() {
                        var e, t, r, n = this.hardfork();
                        try {
                            for(var i = u(m.hardforks), o = i.next(); !o.done; o = i.next()){
                                var a = o.value;
                                if ("consensus" in a[1] && (r = a[1].consensus.algorithm), a[0] === n) break;
                            }
                        } catch (t) {
                            e = {
                                error: t
                            };
                        } finally{
                            try {
                                o && !o.done && (t = i.return) && t.call(i);
                            } finally{
                                if (e) throw e.error;
                            }
                        }
                        return r || this._chainParams.consensus.algorithm;
                    }, t.prototype.consensusConfig = function() {
                        var e, t, r, n = this.hardfork();
                        try {
                            for(var i = u(m.hardforks), o = i.next(); !o.done; o = i.next()){
                                var a = o.value;
                                if ("consensus" in a[1] && (r = a[1].consensus[a[1].consensus.algorithm]), a[0] === n) break;
                            }
                        } catch (t) {
                            e = {
                                error: t
                            };
                        } finally{
                            try {
                                o && !o.done && (t = i.return) && t.call(i);
                            } finally{
                                if (e) throw e.error;
                            }
                        }
                        if (r) return r;
                        var s = this.consensusAlgorithm();
                        return this._chainParams.consensus[s];
                    }, t.prototype.copy = function() {
                        var e = Object.assign(Object.create(Object.getPrototypeOf(this)), this);
                        return e.removeAllListeners(), e;
                    }, t;
                }(p.EventEmitter);
                t.default = w;
            },
            89658: (e, t, r)=>{
                "use strict";
                var n = r(28847)(r(3355));
                function i(e) {
                    if (Array.isArray(e)) {
                        for(var t = [], r = 0, n = 0; n < e.length; n++){
                            var o = i(e[n]);
                            t.push(o), r += o.length;
                        }
                        return p.apply(void 0, [
                            s(r, 192)
                        ].concat(t));
                    }
                    var a = m(e);
                    return 1 === a.length && a[0] < 128 ? a : p(s(a.length, 128), a);
                }
                function o(e, t, r) {
                    if (r > e.length) throw new Error("invalid RLP (safeSlice): end slice of Uint8Array out-of-bounds");
                    return e.slice(t, r);
                }
                function a(e) {
                    if (0 === e[0]) throw new Error("invalid RLP: extra zeros");
                    return l(d(e));
                }
                function s(e, t) {
                    if (e < 56) return Uint8Array.from([
                        e + t
                    ]);
                    var r = y(e), n = y(t + 55 + r.length / 2);
                    return Uint8Array.from(h(n + r));
                }
                function u(e) {
                    var t = arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
                    if (null == e || 0 === e.length) return Uint8Array.from([]);
                    var r = c(m(e));
                    if (t) return r;
                    if (0 !== r.remainder.length) throw new Error("invalid RLP: remainder must be zero");
                    return r.data;
                }
                function c(e) {
                    var t, r, n, i, s, u = [], f = e[0];
                    if (f <= 127) return {
                        data: e.slice(0, 1),
                        remainder: e.slice(1)
                    };
                    if (f <= 183) {
                        if (t = f - 127, n = 128 === f ? Uint8Array.from([]) : o(e, 1, t), 2 === t && n[0] < 128) throw new Error("invalid RLP encoding: invalid prefix, single byte < 0x80 are not prefixed");
                        return {
                            data: n,
                            remainder: e.slice(t)
                        };
                    }
                    if (f <= 191) {
                        if (r = f - 182, e.length - 1 < r) throw new Error("invalid RLP: not enough bytes for string length");
                        if ((t = a(o(e, 1, r))) <= 55) throw new Error("invalid RLP: expected string length to be greater than 55");
                        return {
                            data: n = o(e, r, t + r),
                            remainder: e.slice(t + r)
                        };
                    }
                    if (f <= 247) {
                        for(i = o(e, 1, t = f - 191); i.length;)s = c(i), u.push(s.data), i = s.remainder;
                        return {
                            data: u,
                            remainder: e.slice(t)
                        };
                    }
                    if ((t = a(o(e, 1, r = f - 246))) < 56) throw new Error("invalid RLP: encoded list too short");
                    var d = r + t;
                    if (d > e.length) throw new Error("invalid RLP: total length is larger than the data");
                    for(i = o(e, r, d); i.length;)s = c(i), u.push(s.data), i = s.remainder;
                    return {
                        data: u,
                        remainder: e.slice(d)
                    };
                }
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.RLP = t.utils = t.decode = t.encode = void 0, t.encode = i, t.decode = u;
                var f = Array.from({
                    length: 256
                }, function(e, t) {
                    return t.toString(16).padStart(2, "0");
                });
                function d(e) {
                    for(var t = "", r = 0; r < e.length; r++)t += f[e[r]];
                    return t;
                }
                function l(e) {
                    var t = Number.parseInt(e, 16);
                    if (Number.isNaN(t)) throw new Error("Invalid byte sequence");
                    return t;
                }
                function h(e) {
                    if ("string" != typeof e) throw new TypeError("hexToBytes: expected string, got " + (0, n.default)(e));
                    if (e.length % 2) throw new Error("hexToBytes: received invalid unpadded hex");
                    for(var t = new Uint8Array(e.length / 2), r = 0; r < t.length; r++){
                        var i = 2 * r;
                        t[r] = l(e.slice(i, i + 2));
                    }
                    return t;
                }
                function p() {
                    for(var e = arguments.length, t = new Array(e), r = 0; r < e; r++)t[r] = arguments[r];
                    if (1 === t.length) return t[0];
                    for(var n = t.reduce(function(e, t) {
                        return e + t.length;
                    }, 0), i = new Uint8Array(n), o = 0, a = 0; o < t.length; o++){
                        var s = t[o];
                        i.set(s, a), a += s.length;
                    }
                    return i;
                }
                function b(e) {
                    return (new TextEncoder).encode(e);
                }
                function y(e) {
                    if (e < 0) throw new Error("Invalid integer as argument, must be unsigned!");
                    var t = e.toString(16);
                    return t.length % 2 ? "0".concat(t) : t;
                }
                function v(e) {
                    return e.length >= 2 && "0" === e[0] && "x" === e[1];
                }
                function m(e) {
                    if (e instanceof Uint8Array) return e;
                    if ("string" == typeof e) return v(e) ? h((t = "string" != typeof (r = e) ? r : v(r) ? r.slice(2) : r).length % 2 ? "0".concat(t) : t) : b(e);
                    var t, r;
                    if ("number" == typeof e || "bigint" == typeof e) return e ? h(y(e)) : Uint8Array.from([]);
                    if (null == e) return Uint8Array.from([]);
                    throw new Error("toBytes: received unsupported type " + (0, n.default)(e));
                }
                t.utils = {
                    bytesToHex: d,
                    concatBytes: p,
                    hexToBytes: h,
                    utf8ToBytes: b
                }, t.RLP = {
                    encode: i,
                    decode: u
                };
            },
            75058: (e, t, r)=>{
                "use strict";
                var n = Object.create ? function(e, t, r, n) {
                    void 0 === n && (n = r);
                    var i = Object.getOwnPropertyDescriptor(t, r);
                    i && !("get" in i ? !t.__esModule : i.writable || i.configurable) || (i = {
                        enumerable: !0,
                        get: function() {
                            return t[r];
                        }
                    }), Object.defineProperty(e, n, i);
                } : function(e, t, r, n) {
                    void 0 === n && (n = r), e[n] = t[r];
                }, i = Object.create ? function(e, t) {
                    Object.defineProperty(e, "default", {
                        enumerable: !0,
                        value: t
                    });
                } : function(e, t) {
                    e.default = t;
                }, o = function(e, t) {
                    var r = "function" == typeof Symbol && e[Symbol.iterator];
                    if (!r) return e;
                    var n, i, o = r.call(e), a = [];
                    try {
                        for(; (void 0 === t || t-- > 0) && !(n = o.next()).done;)a.push(n.value);
                    } catch (e) {
                        i = {
                            error: e
                        };
                    } finally{
                        try {
                            n && !n.done && (r = o.return) && r.call(o);
                        } finally{
                            if (i) throw i.error;
                        }
                    }
                    return a;
                };
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.BaseTransaction = void 0;
                var a = function(e) {
                    if (e && e.__esModule) return e;
                    var t = {};
                    if (null != e) for(var r in e)"default" !== r && Object.prototype.hasOwnProperty.call(e, r) && n(t, e, r);
                    return i(t, e), t;
                }(r(3863)), s = r(33062), u = r(87325), c = function() {
                    function e(e, t) {
                        this.cache = {
                            hash: void 0,
                            dataFee: void 0
                        }, this.activeCapabilities = [], this.DEFAULT_CHAIN = a.Chain.Mainnet, this.DEFAULT_HARDFORK = a.Hardfork.Istanbul;
                        var r = e.nonce, n = e.gasLimit, i = e.to, o = e.value, u = e.data, c = e.v, f = e.r, d = e.s, l = e.type;
                        this._type = new s.BN((0, s.toBuffer)(l)).toNumber(), this.txOptions = t;
                        var h = (0, s.toBuffer)("" === i ? "0x" : i), p = (0, s.toBuffer)("" === c ? "0x" : c), b = (0, s.toBuffer)("" === f ? "0x" : f), y = (0, s.toBuffer)("" === d ? "0x" : d);
                        this.nonce = new s.BN((0, s.toBuffer)("" === r ? "0x" : r)), this.gasLimit = new s.BN((0, s.toBuffer)("" === n ? "0x" : n)), this.to = h.length > 0 ? new s.Address(h) : void 0, this.value = new s.BN((0, s.toBuffer)("" === o ? "0x" : o)), this.data = (0, s.toBuffer)("" === u ? "0x" : u), this.v = p.length > 0 ? new s.BN(p) : void 0, this.r = b.length > 0 ? new s.BN(b) : void 0, this.s = y.length > 0 ? new s.BN(y) : void 0, this._validateCannotExceedMaxInteger({
                            value: this.value,
                            r: this.r,
                            s: this.s
                        }), this._validateCannotExceedMaxInteger({
                            gasLimit: this.gasLimit
                        }, 64), this._validateCannotExceedMaxInteger({
                            nonce: this.nonce
                        }, 64, !0);
                    }
                    return Object.defineProperty(e.prototype, "transactionType", {
                        get: function() {
                            return this.type;
                        },
                        enumerable: !1,
                        configurable: !0
                    }), Object.defineProperty(e.prototype, "type", {
                        get: function() {
                            return this._type;
                        },
                        enumerable: !1,
                        configurable: !0
                    }), e.prototype.supports = function(e) {
                        return this.activeCapabilities.includes(e);
                    }, e.prototype.validate = function(e) {
                        void 0 === e && (e = !1);
                        var t = [];
                        return this.getBaseFee().gt(this.gasLimit) && t.push("gasLimit is too low. given ".concat(this.gasLimit, ", need at least ").concat(this.getBaseFee())), this.isSigned() && !this.verifySignature() && t.push("Invalid Signature"), e ? t : 0 === t.length;
                    }, e.prototype.getBaseFee = function() {
                        var e = this.getDataFee().addn(this.common.param("gasPrices", "tx"));
                        return this.common.gteHardfork("homestead") && this.toCreationAddress() && e.iaddn(this.common.param("gasPrices", "txCreation")), e;
                    }, e.prototype.getDataFee = function() {
                        for(var e = this.common.param("gasPrices", "txDataZero"), t = this.common.param("gasPrices", "txDataNonZero"), r = 0, n = 0; n < this.data.length; n++)0 === this.data[n] ? r += e : r += t;
                        if (r = new s.BN(r), (void 0 === this.to || null === this.to) && this.common.isActivatedEIP(3860)) {
                            var i = Math.ceil(this.data.length / 32), o = new s.BN(this.common.param("gasPrices", "initCodeWordCost")).imuln(i);
                            r.iadd(o);
                        }
                        return r;
                    }, e.prototype.toCreationAddress = function() {
                        return void 0 === this.to || 0 === this.to.buf.length;
                    }, e.prototype.isSigned = function() {
                        var e = this, t = e.v, r = e.r, n = e.s;
                        return 0 === this.type ? !!(t && r && n) : !(void 0 === t || !r || !n);
                    }, e.prototype.verifySignature = function() {
                        try {
                            var e = this.getSenderPublicKey();
                            return 0 !== (0, s.unpadBuffer)(e).length;
                        } catch (e) {
                            return !1;
                        }
                    }, e.prototype.getSenderAddress = function() {
                        return new s.Address((0, s.publicToAddress)(this.getSenderPublicKey()));
                    }, e.prototype.sign = function(e) {
                        if (32 !== e.length) {
                            var t = this._errorMsg("Private key must be 32 bytes in length.");
                            throw new Error(t);
                        }
                        var r = !1;
                        0 === this.type && this.common.gteHardfork("spuriousDragon") && !this.supports(u.Capability.EIP155ReplayProtection) && (this.activeCapabilities.push(u.Capability.EIP155ReplayProtection), r = !0);
                        var n = this.getMessageToSign(!0), i = (0, s.ecsign)(n, e), o = i.v, a = i.r, c = i.s, f = this._processSignature(o, a, c);
                        if (r) {
                            var d = this.activeCapabilities.indexOf(u.Capability.EIP155ReplayProtection);
                            d > -1 && this.activeCapabilities.splice(d, 1);
                        }
                        return f;
                    }, e.prototype._getCommon = function(e, t) {
                        var r;
                        if (t) {
                            var n = new s.BN((0, s.toBuffer)(t));
                            if (e) {
                                if (!e.chainIdBN().eq(n)) {
                                    var i = this._errorMsg("The chain ID does not match the chain ID of Common");
                                    throw new Error(i);
                                }
                                return e.copy();
                            }
                            return a.default.isSupportedChainId(n) ? new a.default({
                                chain: n,
                                hardfork: this.DEFAULT_HARDFORK
                            }) : a.default.forCustomChain(this.DEFAULT_CHAIN, {
                                name: "custom-chain",
                                networkId: n,
                                chainId: n
                            }, this.DEFAULT_HARDFORK);
                        }
                        return null !== (r = null == e ? void 0 : e.copy()) && void 0 !== r ? r : new a.default({
                            chain: this.DEFAULT_CHAIN,
                            hardfork: this.DEFAULT_HARDFORK
                        });
                    }, e.prototype._validateCannotExceedMaxInteger = function(e, t, r) {
                        var n, i;
                        void 0 === t && (t = 256), void 0 === r && (r = !1);
                        try {
                            for(var a = function(e) {
                                var t = "function" == typeof Symbol && Symbol.iterator, r = t && e[t], n = 0;
                                if (r) return r.call(e);
                                if (e && "number" == typeof e.length) return {
                                    next: function() {
                                        return e && n >= e.length && (e = void 0), {
                                            value: e && e[n++],
                                            done: !e
                                        };
                                    }
                                };
                                throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
                            }(Object.entries(e)), u = a.next(); !u.done; u = a.next()){
                                var c = o(u.value, 2), f = c[0], d = c[1];
                                switch(t){
                                    case 64:
                                        if (r) {
                                            if (null == d ? void 0 : d.gte(s.MAX_UINT64)) {
                                                var l = this._errorMsg("".concat(f, " cannot equal or exceed MAX_UINT64 (2^64-1), given ").concat(d));
                                                throw new Error(l);
                                            }
                                        } else if (null == d ? void 0 : d.gt(s.MAX_UINT64)) throw l = this._errorMsg("".concat(f, " cannot exceed MAX_UINT64 (2^64-1), given ").concat(d)), new Error(l);
                                        break;
                                    case 256:
                                        if (r) {
                                            if (null == d ? void 0 : d.gte(s.MAX_INTEGER)) throw l = this._errorMsg("".concat(f, " cannot equal or exceed MAX_INTEGER (2^256-1), given ").concat(d)), new Error(l);
                                        } else if (null == d ? void 0 : d.gt(s.MAX_INTEGER)) throw l = this._errorMsg("".concat(f, " cannot exceed MAX_INTEGER (2^256-1), given ").concat(d)), new Error(l);
                                        break;
                                    default:
                                        throw l = this._errorMsg("unimplemented bits value"), new Error(l);
                                }
                            }
                        } catch (e) {
                            n = {
                                error: e
                            };
                        } finally{
                            try {
                                u && !u.done && (i = a.return) && i.call(a);
                            } finally{
                                if (n) throw n.error;
                            }
                        }
                    }, e.prototype._getSharedErrorPostfix = function() {
                        var e = "";
                        try {
                            e = this.isSigned() ? (0, s.bufferToHex)(this.hash()) : "not available (unsigned)";
                        } catch (t) {
                            e = "error";
                        }
                        var t = "";
                        try {
                            t = this.isSigned().toString();
                        } catch (t) {
                            e = "error";
                        }
                        var r = "";
                        try {
                            r = this.common.hardfork();
                        } catch (e) {
                            r = "error";
                        }
                        return "tx type=".concat(this.type, " hash=").concat(e, " nonce=").concat(this.nonce, " value=").concat(this.value, " ") + "signed=".concat(t, " hf=").concat(r);
                    }, e;
                }();
                t.BaseTransaction = c;
            },
            660: (e, t, r)=>{
                "use strict";
                var n, i = r(29033).Buffer, o = (n = function(e, t) {
                    return n = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(e, t) {
                        e.__proto__ = t;
                    } || function(e, t) {
                        for(var r in t)Object.prototype.hasOwnProperty.call(t, r) && (e[r] = t[r]);
                    }, n(e, t);
                }, function(e, t) {
                    if ("function" != typeof t && null !== t) throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");
                    function r() {
                        this.constructor = e;
                    }
                    n(e, t), e.prototype = null === t ? Object.create(t) : (r.prototype = t.prototype, new r);
                }), a = function() {
                    return a = Object.assign || function(e) {
                        for(var t, r = 1, n = arguments.length; r < n; r++)for(var i in t = arguments[r])Object.prototype.hasOwnProperty.call(t, i) && (e[i] = t[i]);
                        return e;
                    }, a.apply(this, arguments);
                };
                Object.defineProperty(t, "__esModule", {
                    value: !0
                });
                var s = r(33062), u = r(75058), c = r(87325), f = r(53789), d = i.from(2..toString(16).padStart(2, "0"), "hex"), l = function(e) {
                    function t(t, r) {
                        void 0 === r && (r = {});
                        var n, i, o = this;
                        (o = e.call(this, a(a({}, t), {
                            type: 2
                        }), r) || this).DEFAULT_HARDFORK = "london";
                        var u = t.chainId, d = t.accessList, l = t.maxFeePerGas, h = t.maxPriorityFeePerGas;
                        if (o.common = o._getCommon(r.common, u), o.chainId = o.common.chainIdBN(), !o.common.isActivatedEIP(1559)) throw new Error("EIP-1559 not enabled on Common");
                        o.activeCapabilities = o.activeCapabilities.concat([
                            1559,
                            2718,
                            2930
                        ]);
                        var p = f.AccessLists.getAccessListData(null != d ? d : []);
                        if (o.accessList = p.accessList, o.AccessListJSON = p.AccessListJSON, f.AccessLists.verifyAccessList(o.accessList), o.maxFeePerGas = new s.BN((0, s.toBuffer)("" === l ? "0x" : l)), o.maxPriorityFeePerGas = new s.BN((0, s.toBuffer)("" === h ? "0x" : h)), o._validateCannotExceedMaxInteger({
                            maxFeePerGas: o.maxFeePerGas,
                            maxPriorityFeePerGas: o.maxPriorityFeePerGas
                        }), o.gasLimit.mul(o.maxFeePerGas).gt(s.MAX_INTEGER)) {
                            var b = o._errorMsg("gasLimit * maxFeePerGas cannot exceed MAX_INTEGER (2^256-1)");
                            throw new Error(b);
                        }
                        if (o.maxFeePerGas.lt(o.maxPriorityFeePerGas)) throw b = o._errorMsg("maxFeePerGas cannot be less than maxPriorityFeePerGas (The total must be the larger of the two)"), new Error(b);
                        if (o.v && !o.v.eqn(0) && !o.v.eqn(1)) throw b = o._errorMsg("The y-parity of the transaction should either be 0 or 1"), new Error(b);
                        if (o.common.gteHardfork("homestead") && (null === (n = o.s) || void 0 === n ? void 0 : n.gt(c.N_DIV_2))) throw b = o._errorMsg("Invalid Signature: s-values greater than secp256k1n/2 are considered invalid"), new Error(b);
                        return o.common.isActivatedEIP(3860) && (0, f.checkMaxInitCodeSize)(o.common, o.data.length), (null === (i = null == r ? void 0 : r.freeze) || void 0 === i || i) && Object.freeze(o), o;
                    }
                    return o(t, e), Object.defineProperty(t.prototype, "senderR", {
                        get: function() {
                            return this.r;
                        },
                        enumerable: !1,
                        configurable: !0
                    }), Object.defineProperty(t.prototype, "senderS", {
                        get: function() {
                            return this.s;
                        },
                        enumerable: !1,
                        configurable: !0
                    }), Object.defineProperty(t.prototype, "yParity", {
                        get: function() {
                            return this.v;
                        },
                        enumerable: !1,
                        configurable: !0
                    }), t.fromTxData = function(e, r) {
                        return void 0 === r && (r = {}), new t(e, r);
                    }, t.fromSerializedTx = function(e, r) {
                        if (void 0 === r && (r = {}), !e.slice(0, 1).equals(d)) throw new Error("Invalid serialized tx input: not an EIP-1559 transaction (wrong tx type, expected: ".concat(2, ", received: ").concat(e.slice(0, 1).toString("hex")));
                        var n = s.rlp.decode(e.slice(1));
                        if (!Array.isArray(n)) throw new Error("Invalid serialized tx input: must be array");
                        return t.fromValuesArray(n, r);
                    }, t.fromRlpSerializedTx = function(e, r) {
                        return void 0 === r && (r = {}), t.fromSerializedTx(e, r);
                    }, t.fromValuesArray = function(e, r) {
                        if (void 0 === r && (r = {}), 9 !== e.length && 12 !== e.length) throw new Error("Invalid EIP-1559 transaction. Only expecting 9 values (for unsigned tx) or 12 values (for signed tx).");
                        var n = function(e, t) {
                            var r = "function" == typeof Symbol && e[Symbol.iterator];
                            if (!r) return e;
                            var n, i, o = r.call(e), a = [];
                            try {
                                for(; (void 0 === t || t-- > 0) && !(n = o.next()).done;)a.push(n.value);
                            } catch (e) {
                                i = {
                                    error: e
                                };
                            } finally{
                                try {
                                    n && !n.done && (r = o.return) && r.call(o);
                                } finally{
                                    if (i) throw i.error;
                                }
                            }
                            return a;
                        }(e, 12), i = n[0], o = n[1], a = n[2], u = n[3], c = n[4], f = n[5], d = n[6], l = n[7], h = n[8], p = n[9], b = n[10], y = n[11];
                        return (0, s.validateNoLeadingZeroes)({
                            nonce: o,
                            maxPriorityFeePerGas: a,
                            maxFeePerGas: u,
                            gasLimit: c,
                            value: d,
                            v: p,
                            r: b,
                            s: y
                        }), new t({
                            chainId: new s.BN(i),
                            nonce: o,
                            maxPriorityFeePerGas: a,
                            maxFeePerGas: u,
                            gasLimit: c,
                            to: f,
                            value: d,
                            data: l,
                            accessList: null != h ? h : [],
                            v: void 0 !== p ? new s.BN(p) : void 0,
                            r: b,
                            s: y
                        }, r);
                    }, t.prototype.getDataFee = function() {
                        if (this.cache.dataFee && this.cache.dataFee.hardfork === this.common.hardfork()) return this.cache.dataFee.value;
                        var t = e.prototype.getDataFee.call(this);
                        return t.iaddn(f.AccessLists.getDataFeeEIP2930(this.accessList, this.common)), Object.isFrozen(this) && (this.cache.dataFee = {
                            value: t,
                            hardfork: this.common.hardfork()
                        }), t;
                    }, t.prototype.getUpfrontCost = function(e) {
                        void 0 === e && (e = new s.BN(0));
                        var t = s.BN.min(this.maxPriorityFeePerGas, this.maxFeePerGas.sub(e)).add(e);
                        return this.gasLimit.mul(t).add(this.value);
                    }, t.prototype.raw = function() {
                        return [
                            (0, s.bnToUnpaddedBuffer)(this.chainId),
                            (0, s.bnToUnpaddedBuffer)(this.nonce),
                            (0, s.bnToUnpaddedBuffer)(this.maxPriorityFeePerGas),
                            (0, s.bnToUnpaddedBuffer)(this.maxFeePerGas),
                            (0, s.bnToUnpaddedBuffer)(this.gasLimit),
                            void 0 !== this.to ? this.to.buf : i.from([]),
                            (0, s.bnToUnpaddedBuffer)(this.value),
                            this.data,
                            this.accessList,
                            void 0 !== this.v ? (0, s.bnToUnpaddedBuffer)(this.v) : i.from([]),
                            void 0 !== this.r ? (0, s.bnToUnpaddedBuffer)(this.r) : i.from([]),
                            void 0 !== this.s ? (0, s.bnToUnpaddedBuffer)(this.s) : i.from([])
                        ];
                    }, t.prototype.serialize = function() {
                        var e = this.raw();
                        return i.concat([
                            d,
                            s.rlp.encode(e)
                        ]);
                    }, t.prototype.getMessageToSign = function(e) {
                        void 0 === e && (e = !0);
                        var t = this.raw().slice(0, 9), r = i.concat([
                            d,
                            s.rlp.encode(t)
                        ]);
                        return e ? (0, s.keccak256)(r) : r;
                    }, t.prototype.hash = function() {
                        if (!this.isSigned()) {
                            var e = this._errorMsg("Cannot call hash method if transaction is not signed");
                            throw new Error(e);
                        }
                        return Object.isFrozen(this) ? (this.cache.hash || (this.cache.hash = (0, s.keccak256)(this.serialize())), this.cache.hash) : (0, s.keccak256)(this.serialize());
                    }, t.prototype.getMessageToVerifySignature = function() {
                        return this.getMessageToSign();
                    }, t.prototype.getSenderPublicKey = function() {
                        var e;
                        if (!this.isSigned()) {
                            var t = this._errorMsg("Cannot call this method if transaction is not signed");
                            throw new Error(t);
                        }
                        var r = this.getMessageToVerifySignature();
                        if (this.common.gteHardfork("homestead") && (null === (e = this.s) || void 0 === e ? void 0 : e.gt(c.N_DIV_2))) throw t = this._errorMsg("Invalid Signature: s-values greater than secp256k1n/2 are considered invalid"), new Error(t);
                        var n = this, i = n.v, o = n.r, a = n.s;
                        try {
                            return (0, s.ecrecover)(r, i.addn(27), (0, s.bnToUnpaddedBuffer)(o), (0, s.bnToUnpaddedBuffer)(a));
                        } catch (e) {
                            throw t = this._errorMsg("Invalid Signature"), new Error(t);
                        }
                    }, t.prototype._processSignature = function(e, r, n) {
                        var i = a(a({}, this.txOptions), {
                            common: this.common
                        });
                        return t.fromTxData({
                            chainId: this.chainId,
                            nonce: this.nonce,
                            maxPriorityFeePerGas: this.maxPriorityFeePerGas,
                            maxFeePerGas: this.maxFeePerGas,
                            gasLimit: this.gasLimit,
                            to: this.to,
                            value: this.value,
                            data: this.data,
                            accessList: this.accessList,
                            v: new s.BN(e - 27),
                            r: new s.BN(r),
                            s: new s.BN(n)
                        }, i);
                    }, t.prototype.toJSON = function() {
                        var e = f.AccessLists.getAccessListJSON(this.accessList);
                        return {
                            chainId: (0, s.bnToHex)(this.chainId),
                            nonce: (0, s.bnToHex)(this.nonce),
                            maxPriorityFeePerGas: (0, s.bnToHex)(this.maxPriorityFeePerGas),
                            maxFeePerGas: (0, s.bnToHex)(this.maxFeePerGas),
                            gasLimit: (0, s.bnToHex)(this.gasLimit),
                            to: void 0 !== this.to ? this.to.toString() : void 0,
                            value: (0, s.bnToHex)(this.value),
                            data: "0x" + this.data.toString("hex"),
                            accessList: e,
                            v: void 0 !== this.v ? (0, s.bnToHex)(this.v) : void 0,
                            r: void 0 !== this.r ? (0, s.bnToHex)(this.r) : void 0,
                            s: void 0 !== this.s ? (0, s.bnToHex)(this.s) : void 0
                        };
                    }, t.prototype.errorStr = function() {
                        return this._getSharedErrorPostfix() + " maxFeePerGas=".concat(this.maxFeePerGas, " maxPriorityFeePerGas=").concat(this.maxPriorityFeePerGas);
                    }, t.prototype._errorMsg = function(e) {
                        return "".concat(e, " (").concat(this.errorStr(), ")");
                    }, t;
                }(u.BaseTransaction);
                t.default = l;
            },
            97613: (e, t, r)=>{
                "use strict";
                var n, i = r(29033).Buffer, o = (n = function(e, t) {
                    return n = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(e, t) {
                        e.__proto__ = t;
                    } || function(e, t) {
                        for(var r in t)Object.prototype.hasOwnProperty.call(t, r) && (e[r] = t[r]);
                    }, n(e, t);
                }, function(e, t) {
                    if ("function" != typeof t && null !== t) throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");
                    function r() {
                        this.constructor = e;
                    }
                    n(e, t), e.prototype = null === t ? Object.create(t) : (r.prototype = t.prototype, new r);
                }), a = function() {
                    return a = Object.assign || function(e) {
                        for(var t, r = 1, n = arguments.length; r < n; r++)for(var i in t = arguments[r])Object.prototype.hasOwnProperty.call(t, i) && (e[i] = t[i]);
                        return e;
                    }, a.apply(this, arguments);
                };
                Object.defineProperty(t, "__esModule", {
                    value: !0
                });
                var s = r(33062), u = r(75058), c = r(87325), f = r(53789), d = i.from(1..toString(16).padStart(2, "0"), "hex"), l = function(e) {
                    function t(t, r) {
                        void 0 === r && (r = {});
                        var n, i, o = this;
                        (o = e.call(this, a(a({}, t), {
                            type: 1
                        }), r) || this).DEFAULT_HARDFORK = "berlin";
                        var u = t.chainId, d = t.accessList, l = t.gasPrice;
                        if (o.common = o._getCommon(r.common, u), o.chainId = o.common.chainIdBN(), !o.common.isActivatedEIP(2930)) throw new Error("EIP-2930 not enabled on Common");
                        o.activeCapabilities = o.activeCapabilities.concat([
                            2718,
                            2930
                        ]);
                        var h = f.AccessLists.getAccessListData(null != d ? d : []);
                        if (o.accessList = h.accessList, o.AccessListJSON = h.AccessListJSON, f.AccessLists.verifyAccessList(o.accessList), o.gasPrice = new s.BN((0, s.toBuffer)("" === l ? "0x" : l)), o._validateCannotExceedMaxInteger({
                            gasPrice: o.gasPrice
                        }), o.gasPrice.mul(o.gasLimit).gt(s.MAX_INTEGER)) {
                            var p = o._errorMsg("gasLimit * gasPrice cannot exceed MAX_INTEGER");
                            throw new Error(p);
                        }
                        if (o.v && !o.v.eqn(0) && !o.v.eqn(1)) throw p = o._errorMsg("The y-parity of the transaction should either be 0 or 1"), new Error(p);
                        if (o.common.gteHardfork("homestead") && (null === (n = o.s) || void 0 === n ? void 0 : n.gt(c.N_DIV_2))) throw p = o._errorMsg("Invalid Signature: s-values greater than secp256k1n/2 are considered invalid"), new Error(p);
                        return o.common.isActivatedEIP(3860) && (0, f.checkMaxInitCodeSize)(o.common, o.data.length), (null === (i = null == r ? void 0 : r.freeze) || void 0 === i || i) && Object.freeze(o), o;
                    }
                    return o(t, e), Object.defineProperty(t.prototype, "senderR", {
                        get: function() {
                            return this.r;
                        },
                        enumerable: !1,
                        configurable: !0
                    }), Object.defineProperty(t.prototype, "senderS", {
                        get: function() {
                            return this.s;
                        },
                        enumerable: !1,
                        configurable: !0
                    }), Object.defineProperty(t.prototype, "yParity", {
                        get: function() {
                            return this.v;
                        },
                        enumerable: !1,
                        configurable: !0
                    }), t.fromTxData = function(e, r) {
                        return void 0 === r && (r = {}), new t(e, r);
                    }, t.fromSerializedTx = function(e, r) {
                        if (void 0 === r && (r = {}), !e.slice(0, 1).equals(d)) throw new Error("Invalid serialized tx input: not an EIP-2930 transaction (wrong tx type, expected: ".concat(1, ", received: ").concat(e.slice(0, 1).toString("hex")));
                        var n = s.rlp.decode(e.slice(1));
                        if (!Array.isArray(n)) throw new Error("Invalid serialized tx input: must be array");
                        return t.fromValuesArray(n, r);
                    }, t.fromRlpSerializedTx = function(e, r) {
                        return void 0 === r && (r = {}), t.fromSerializedTx(e, r);
                    }, t.fromValuesArray = function(e, r) {
                        if (void 0 === r && (r = {}), 8 !== e.length && 11 !== e.length) throw new Error("Invalid EIP-2930 transaction. Only expecting 8 values (for unsigned tx) or 11 values (for signed tx).");
                        var n = function(e, t) {
                            var r = "function" == typeof Symbol && e[Symbol.iterator];
                            if (!r) return e;
                            var n, i, o = r.call(e), a = [];
                            try {
                                for(; (void 0 === t || t-- > 0) && !(n = o.next()).done;)a.push(n.value);
                            } catch (e) {
                                i = {
                                    error: e
                                };
                            } finally{
                                try {
                                    n && !n.done && (r = o.return) && r.call(o);
                                } finally{
                                    if (i) throw i.error;
                                }
                            }
                            return a;
                        }(e, 11), i = n[0], o = n[1], a = n[2], u = n[3], c = n[4], f = n[5], d = n[6], l = n[7], h = n[8], p = n[9], b = n[10];
                        return (0, s.validateNoLeadingZeroes)({
                            nonce: o,
                            gasPrice: a,
                            gasLimit: u,
                            value: f,
                            v: h,
                            r: p,
                            s: b
                        }), new t({
                            chainId: new s.BN(i),
                            nonce: o,
                            gasPrice: a,
                            gasLimit: u,
                            to: c,
                            value: f,
                            data: d,
                            accessList: null != l ? l : [],
                            v: void 0 !== h ? new s.BN(h) : void 0,
                            r: p,
                            s: b
                        }, r);
                    }, t.prototype.getDataFee = function() {
                        if (this.cache.dataFee && this.cache.dataFee.hardfork === this.common.hardfork()) return this.cache.dataFee.value;
                        var t = e.prototype.getDataFee.call(this);
                        return t.iaddn(f.AccessLists.getDataFeeEIP2930(this.accessList, this.common)), Object.isFrozen(this) && (this.cache.dataFee = {
                            value: t,
                            hardfork: this.common.hardfork()
                        }), t;
                    }, t.prototype.getUpfrontCost = function() {
                        return this.gasLimit.mul(this.gasPrice).add(this.value);
                    }, t.prototype.raw = function() {
                        return [
                            (0, s.bnToUnpaddedBuffer)(this.chainId),
                            (0, s.bnToUnpaddedBuffer)(this.nonce),
                            (0, s.bnToUnpaddedBuffer)(this.gasPrice),
                            (0, s.bnToUnpaddedBuffer)(this.gasLimit),
                            void 0 !== this.to ? this.to.buf : i.from([]),
                            (0, s.bnToUnpaddedBuffer)(this.value),
                            this.data,
                            this.accessList,
                            void 0 !== this.v ? (0, s.bnToUnpaddedBuffer)(this.v) : i.from([]),
                            void 0 !== this.r ? (0, s.bnToUnpaddedBuffer)(this.r) : i.from([]),
                            void 0 !== this.s ? (0, s.bnToUnpaddedBuffer)(this.s) : i.from([])
                        ];
                    }, t.prototype.serialize = function() {
                        var e = this.raw();
                        return i.concat([
                            d,
                            s.rlp.encode(e)
                        ]);
                    }, t.prototype.getMessageToSign = function(e) {
                        void 0 === e && (e = !0);
                        var t = this.raw().slice(0, 8), r = i.concat([
                            d,
                            s.rlp.encode(t)
                        ]);
                        return e ? (0, s.keccak256)(r) : r;
                    }, t.prototype.hash = function() {
                        if (!this.isSigned()) {
                            var e = this._errorMsg("Cannot call hash method if transaction is not signed");
                            throw new Error(e);
                        }
                        return Object.isFrozen(this) ? (this.cache.hash || (this.cache.hash = (0, s.keccak256)(this.serialize())), this.cache.hash) : (0, s.keccak256)(this.serialize());
                    }, t.prototype.getMessageToVerifySignature = function() {
                        return this.getMessageToSign();
                    }, t.prototype.getSenderPublicKey = function() {
                        var e;
                        if (!this.isSigned()) {
                            var t = this._errorMsg("Cannot call this method if transaction is not signed");
                            throw new Error(t);
                        }
                        var r = this.getMessageToVerifySignature();
                        if (this.common.gteHardfork("homestead") && (null === (e = this.s) || void 0 === e ? void 0 : e.gt(c.N_DIV_2))) throw t = this._errorMsg("Invalid Signature: s-values greater than secp256k1n/2 are considered invalid"), new Error(t);
                        var n = this, i = n.yParity, o = n.r, a = n.s;
                        try {
                            return (0, s.ecrecover)(r, i.addn(27), (0, s.bnToUnpaddedBuffer)(o), (0, s.bnToUnpaddedBuffer)(a));
                        } catch (e) {
                            throw t = this._errorMsg("Invalid Signature"), new Error(t);
                        }
                    }, t.prototype._processSignature = function(e, r, n) {
                        var i = a(a({}, this.txOptions), {
                            common: this.common
                        });
                        return t.fromTxData({
                            chainId: this.chainId,
                            nonce: this.nonce,
                            gasPrice: this.gasPrice,
                            gasLimit: this.gasLimit,
                            to: this.to,
                            value: this.value,
                            data: this.data,
                            accessList: this.accessList,
                            v: new s.BN(e - 27),
                            r: new s.BN(r),
                            s: new s.BN(n)
                        }, i);
                    }, t.prototype.toJSON = function() {
                        var e = f.AccessLists.getAccessListJSON(this.accessList);
                        return {
                            chainId: (0, s.bnToHex)(this.chainId),
                            nonce: (0, s.bnToHex)(this.nonce),
                            gasPrice: (0, s.bnToHex)(this.gasPrice),
                            gasLimit: (0, s.bnToHex)(this.gasLimit),
                            to: void 0 !== this.to ? this.to.toString() : void 0,
                            value: (0, s.bnToHex)(this.value),
                            data: "0x" + this.data.toString("hex"),
                            accessList: e,
                            v: void 0 !== this.v ? (0, s.bnToHex)(this.v) : void 0,
                            r: void 0 !== this.r ? (0, s.bnToHex)(this.r) : void 0,
                            s: void 0 !== this.s ? (0, s.bnToHex)(this.s) : void 0
                        };
                    }, t.prototype.errorStr = function() {
                        var e, t;
                        return this._getSharedErrorPostfix() + " gasPrice=".concat(this.gasPrice, " accessListCount=").concat(null !== (t = null === (e = this.accessList) || void 0 === e ? void 0 : e.length) && void 0 !== t ? t : 0);
                    }, t.prototype._errorMsg = function(e) {
                        return "".concat(e, " (").concat(this.errorStr(), ")");
                    }, t;
                }(u.BaseTransaction);
                t.default = l;
            },
            42339: (e, t, r)=>{
                "use strict";
                var n = Object.create ? function(e, t, r, n) {
                    void 0 === n && (n = r);
                    var i = Object.getOwnPropertyDescriptor(t, r);
                    i && !("get" in i ? !t.__esModule : i.writable || i.configurable) || (i = {
                        enumerable: !0,
                        get: function() {
                            return t[r];
                        }
                    }), Object.defineProperty(e, n, i);
                } : function(e, t, r, n) {
                    void 0 === n && (n = r), e[n] = t[r];
                }, i = function(e) {
                    return e && e.__esModule ? e : {
                        default: e
                    };
                };
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.FeeMarketEIP1559Transaction = t.TransactionFactory = t.AccessListEIP2930Transaction = t.Transaction = void 0;
                var o = r(53088);
                Object.defineProperty(t, "Transaction", {
                    enumerable: !0,
                    get: function() {
                        return i(o).default;
                    }
                });
                var a = r(97613);
                Object.defineProperty(t, "AccessListEIP2930Transaction", {
                    enumerable: !0,
                    get: function() {
                        return i(a).default;
                    }
                });
                var s = r(89562);
                Object.defineProperty(t, "TransactionFactory", {
                    enumerable: !0,
                    get: function() {
                        return i(s).default;
                    }
                });
                var u = r(660);
                Object.defineProperty(t, "FeeMarketEIP1559Transaction", {
                    enumerable: !0,
                    get: function() {
                        return i(u).default;
                    }
                }), function(e, t) {
                    for(var r in e)"default" === r || Object.prototype.hasOwnProperty.call(t, r) || n(t, e, r);
                }(r(87325), t);
            },
            53088: (e, t, r)=>{
                "use strict";
                var n, i = r(29033).Buffer, o = (n = function(e, t) {
                    return n = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(e, t) {
                        e.__proto__ = t;
                    } || function(e, t) {
                        for(var r in t)Object.prototype.hasOwnProperty.call(t, r) && (e[r] = t[r]);
                    }, n(e, t);
                }, function(e, t) {
                    if ("function" != typeof t && null !== t) throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");
                    function r() {
                        this.constructor = e;
                    }
                    n(e, t), e.prototype = null === t ? Object.create(t) : (r.prototype = t.prototype, new r);
                }), a = function() {
                    return a = Object.assign || function(e) {
                        for(var t, r = 1, n = arguments.length; r < n; r++)for(var i in t = arguments[r])Object.prototype.hasOwnProperty.call(t, i) && (e[i] = t[i]);
                        return e;
                    }, a.apply(this, arguments);
                };
                Object.defineProperty(t, "__esModule", {
                    value: !0
                });
                var s = r(33062), u = r(87325), c = r(75058), f = r(53789), d = function(e) {
                    function t(t, r) {
                        void 0 === r && (r = {});
                        var n, i = this;
                        if ((i = e.call(this, a(a({}, t), {
                            type: 0
                        }), r) || this).common = i._validateTxV(i.v, r.common), i.gasPrice = new s.BN((0, s.toBuffer)("" === t.gasPrice ? "0x" : t.gasPrice)), i.gasPrice.mul(i.gasLimit).gt(s.MAX_INTEGER)) {
                            var o = i._errorMsg("gas limit * gasPrice cannot exceed MAX_INTEGER (2^256-1)");
                            throw new Error(o);
                        }
                        if (i._validateCannotExceedMaxInteger({
                            gasPrice: i.gasPrice
                        }), i.common.gteHardfork("spuriousDragon")) {
                            if (i.isSigned()) {
                                var c = i.v, d = i.common.chainIdBN().muln(2);
                                (c.eq(d.addn(35)) || c.eq(d.addn(36))) && i.activeCapabilities.push(u.Capability.EIP155ReplayProtection);
                            } else i.activeCapabilities.push(u.Capability.EIP155ReplayProtection);
                        }
                        return i.common.isActivatedEIP(3860) && (0, f.checkMaxInitCodeSize)(i.common, i.data.length), (null === (n = null == r ? void 0 : r.freeze) || void 0 === n || n) && Object.freeze(i), i;
                    }
                    return o(t, e), t.fromTxData = function(e, r) {
                        return void 0 === r && (r = {}), new t(e, r);
                    }, t.fromSerializedTx = function(e, t) {
                        void 0 === t && (t = {});
                        var r = s.rlp.decode(e);
                        if (!Array.isArray(r)) throw new Error("Invalid serialized tx input. Must be array");
                        return this.fromValuesArray(r, t);
                    }, t.fromRlpSerializedTx = function(e, r) {
                        return void 0 === r && (r = {}), t.fromSerializedTx(e, r);
                    }, t.fromValuesArray = function(e, r) {
                        if (void 0 === r && (r = {}), 6 !== e.length && 9 !== e.length) throw new Error("Invalid transaction. Only expecting 6 values (for unsigned tx) or 9 values (for signed tx).");
                        var n = function(e, t) {
                            var r = "function" == typeof Symbol && e[Symbol.iterator];
                            if (!r) return e;
                            var n, i, o = r.call(e), a = [];
                            try {
                                for(; (void 0 === t || t-- > 0) && !(n = o.next()).done;)a.push(n.value);
                            } catch (e) {
                                i = {
                                    error: e
                                };
                            } finally{
                                try {
                                    n && !n.done && (r = o.return) && r.call(o);
                                } finally{
                                    if (i) throw i.error;
                                }
                            }
                            return a;
                        }(e, 9), i = n[0], o = n[1], a = n[2], u = n[3], c = n[4], f = n[5], d = n[6], l = n[7], h = n[8];
                        return (0, s.validateNoLeadingZeroes)({
                            nonce: i,
                            gasPrice: o,
                            gasLimit: a,
                            value: c,
                            v: d,
                            r: l,
                            s: h
                        }), new t({
                            nonce: i,
                            gasPrice: o,
                            gasLimit: a,
                            to: u,
                            value: c,
                            data: f,
                            v: d,
                            r: l,
                            s: h
                        }, r);
                    }, t.prototype.raw = function() {
                        return [
                            (0, s.bnToUnpaddedBuffer)(this.nonce),
                            (0, s.bnToUnpaddedBuffer)(this.gasPrice),
                            (0, s.bnToUnpaddedBuffer)(this.gasLimit),
                            void 0 !== this.to ? this.to.buf : i.from([]),
                            (0, s.bnToUnpaddedBuffer)(this.value),
                            this.data,
                            void 0 !== this.v ? (0, s.bnToUnpaddedBuffer)(this.v) : i.from([]),
                            void 0 !== this.r ? (0, s.bnToUnpaddedBuffer)(this.r) : i.from([]),
                            void 0 !== this.s ? (0, s.bnToUnpaddedBuffer)(this.s) : i.from([])
                        ];
                    }, t.prototype.serialize = function() {
                        return s.rlp.encode(this.raw());
                    }, t.prototype._getMessageToSign = function() {
                        var e = [
                            (0, s.bnToUnpaddedBuffer)(this.nonce),
                            (0, s.bnToUnpaddedBuffer)(this.gasPrice),
                            (0, s.bnToUnpaddedBuffer)(this.gasLimit),
                            void 0 !== this.to ? this.to.buf : i.from([]),
                            (0, s.bnToUnpaddedBuffer)(this.value),
                            this.data
                        ];
                        return this.supports(u.Capability.EIP155ReplayProtection) && (e.push((0, s.toBuffer)(this.common.chainIdBN())), e.push((0, s.unpadBuffer)((0, s.toBuffer)(0))), e.push((0, s.unpadBuffer)((0, s.toBuffer)(0)))), e;
                    }, t.prototype.getMessageToSign = function(e) {
                        void 0 === e && (e = !0);
                        var t = this._getMessageToSign();
                        return e ? (0, s.rlphash)(t) : t;
                    }, t.prototype.getDataFee = function() {
                        return this.cache.dataFee && this.cache.dataFee.hardfork === this.common.hardfork() ? this.cache.dataFee.value : (Object.isFrozen(this) && (this.cache.dataFee = {
                            value: e.prototype.getDataFee.call(this),
                            hardfork: this.common.hardfork()
                        }), e.prototype.getDataFee.call(this));
                    }, t.prototype.getUpfrontCost = function() {
                        return this.gasLimit.mul(this.gasPrice).add(this.value);
                    }, t.prototype.hash = function() {
                        return Object.isFrozen(this) ? (this.cache.hash || (this.cache.hash = (0, s.rlphash)(this.raw())), this.cache.hash) : (0, s.rlphash)(this.raw());
                    }, t.prototype.getMessageToVerifySignature = function() {
                        if (!this.isSigned()) {
                            var e = this._errorMsg("This transaction is not signed");
                            throw new Error(e);
                        }
                        var t = this._getMessageToSign();
                        return (0, s.rlphash)(t);
                    }, t.prototype.getSenderPublicKey = function() {
                        var e, t = this.getMessageToVerifySignature();
                        if (this.common.gteHardfork("homestead") && (null === (e = this.s) || void 0 === e ? void 0 : e.gt(u.N_DIV_2))) {
                            var r = this._errorMsg("Invalid Signature: s-values greater than secp256k1n/2 are considered invalid");
                            throw new Error(r);
                        }
                        var n = this, i = n.v, o = n.r, a = n.s;
                        try {
                            return (0, s.ecrecover)(t, i, (0, s.bnToUnpaddedBuffer)(o), (0, s.bnToUnpaddedBuffer)(a), this.supports(u.Capability.EIP155ReplayProtection) ? this.common.chainIdBN() : void 0);
                        } catch (e) {
                            throw r = this._errorMsg("Invalid Signature"), new Error(r);
                        }
                    }, t.prototype._processSignature = function(e, r, n) {
                        var i = new s.BN(e);
                        this.supports(u.Capability.EIP155ReplayProtection) && i.iadd(this.common.chainIdBN().muln(2).addn(8));
                        var o = a(a({}, this.txOptions), {
                            common: this.common
                        });
                        return t.fromTxData({
                            nonce: this.nonce,
                            gasPrice: this.gasPrice,
                            gasLimit: this.gasLimit,
                            to: this.to,
                            value: this.value,
                            data: this.data,
                            v: i,
                            r: new s.BN(r),
                            s: new s.BN(n)
                        }, o);
                    }, t.prototype.toJSON = function() {
                        return {
                            nonce: (0, s.bnToHex)(this.nonce),
                            gasPrice: (0, s.bnToHex)(this.gasPrice),
                            gasLimit: (0, s.bnToHex)(this.gasLimit),
                            to: void 0 !== this.to ? this.to.toString() : void 0,
                            value: (0, s.bnToHex)(this.value),
                            data: "0x" + this.data.toString("hex"),
                            v: void 0 !== this.v ? (0, s.bnToHex)(this.v) : void 0,
                            r: void 0 !== this.r ? (0, s.bnToHex)(this.r) : void 0,
                            s: void 0 !== this.s ? (0, s.bnToHex)(this.s) : void 0
                        };
                    }, t.prototype._validateTxV = function(e, t) {
                        if (void 0 !== e && e.ltn(37) && !e.eqn(27) && !e.eqn(28)) throw new Error("Legacy txs need either v = 27/28 or v >= 37 (EIP-155 replay protection), got v = ".concat(e));
                        var r;
                        if (void 0 !== e && (!t || t.gteHardfork("spuriousDragon")) && !e.eqn(27) && !e.eqn(28)) {
                            if (t) {
                                var n = t.chainIdBN().muln(2);
                                if (!e.eq(n.addn(35)) && !e.eq(n.addn(36))) throw new Error("Incompatible EIP155-based V ".concat(e, " and chain id ").concat(t.chainIdBN(), ". See the Common parameter of the Transaction constructor to set the chain id."));
                            } else {
                                var i;
                                i = e.subn(35).isEven() ? 35 : 36, r = e.subn(i).divn(2);
                            }
                        }
                        return this._getCommon(t, r);
                    }, t.prototype._unsignedTxImplementsEIP155 = function() {
                        return this.common.gteHardfork("spuriousDragon");
                    }, t.prototype._signedTxImplementsEIP155 = function() {
                        if (!this.isSigned()) {
                            var e = this._errorMsg("This transaction is not signed");
                            throw new Error(e);
                        }
                        var t = this.common.gteHardfork("spuriousDragon"), r = this.v, n = this.common.chainIdBN().muln(2);
                        return (r.eq(n.addn(35)) || r.eq(n.addn(36))) && t;
                    }, t.prototype.errorStr = function() {
                        return this._getSharedErrorPostfix() + " gasPrice=".concat(this.gasPrice);
                    }, t.prototype._errorMsg = function(e) {
                        return "".concat(e, " (").concat(this.errorStr(), ")");
                    }, t;
                }(c.BaseTransaction);
                t.default = d;
            },
            89562: (e, t, r)=>{
                "use strict";
                var n = r(29033).Buffer;
                Object.defineProperty(t, "__esModule", {
                    value: !0
                });
                var i = r(33062), o = r(42339), a = function() {
                    function e() {}
                    return e.fromTxData = function(e, t) {
                        if (void 0 === t && (t = {}), "type" in e && void 0 !== e.type) {
                            var r = new i.BN((0, i.toBuffer)(e.type)).toNumber();
                            if (0 === r) return o.Transaction.fromTxData(e, t);
                            if (1 === r) return o.AccessListEIP2930Transaction.fromTxData(e, t);
                            if (2 === r) return o.FeeMarketEIP1559Transaction.fromTxData(e, t);
                            throw new Error("Tx instantiation with type ".concat(r, " not supported"));
                        }
                        return o.Transaction.fromTxData(e, t);
                    }, e.fromSerializedData = function(e, t) {
                        if (void 0 === t && (t = {}), e[0] <= 127) {
                            var r = void 0;
                            switch(e[0]){
                                case 1:
                                    r = 2930;
                                    break;
                                case 2:
                                    r = 1559;
                                    break;
                                default:
                                    throw new Error("TypedTransaction with ID ".concat(e[0], " unknown"));
                            }
                            return 1559 === r ? o.FeeMarketEIP1559Transaction.fromSerializedTx(e, t) : o.AccessListEIP2930Transaction.fromSerializedTx(e, t);
                        }
                        return o.Transaction.fromSerializedTx(e, t);
                    }, e.fromBlockBodyData = function(e, t) {
                        if (void 0 === t && (t = {}), n.isBuffer(e)) return this.fromSerializedData(e, t);
                        if (Array.isArray(e)) return o.Transaction.fromValuesArray(e, t);
                        throw new Error("Cannot decode transaction: unknown type input");
                    }, e.getTransactionClass = function(e, t) {
                        if (void 0 === e && (e = 0), 0 == e || e >= 128 && e <= 255) return o.Transaction;
                        switch(e){
                            case 1:
                                return o.AccessListEIP2930Transaction;
                            case 2:
                                return o.FeeMarketEIP1559Transaction;
                            default:
                                throw new Error("TypedTransaction with ID ".concat(e, " unknown"));
                        }
                    }, e;
                }();
                t.default = a;
            },
            87325: (e, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.N_DIV_2 = t.isAccessList = t.isAccessListBuffer = t.Capability = void 0;
                var n, i = r(33062);
                function o(e) {
                    if (0 === e.length) return !0;
                    var t = e[0];
                    return !!Array.isArray(t);
                }
                (n = t.Capability || (t.Capability = {}))[n.EIP155ReplayProtection = 155] = "EIP155ReplayProtection", n[n.EIP1559FeeMarket = 1559] = "EIP1559FeeMarket", n[n.EIP2718TypedTransaction = 2718] = "EIP2718TypedTransaction", n[n.EIP2930AccessLists = 2930] = "EIP2930AccessLists", t.isAccessListBuffer = o, t.isAccessList = function(e) {
                    return !o(e);
                }, t.N_DIV_2 = new i.BN("7fffffffffffffffffffffffffffffff5d576e7357a4501ddfe92f46681b20a0", 16);
            },
            53789: (e, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.AccessLists = t.checkMaxInitCodeSize = void 0;
                var n = r(33062), i = r(87325);
                t.checkMaxInitCodeSize = function(e, t) {
                    if (t > e.param("vm", "maxInitCodeSize")) throw new Error("the initcode size of this transaction is too large: it is ".concat(t, " while the max is ").concat(e.param("vm", "maxInitCodeSize")));
                };
                var o = function() {
                    function e() {}
                    return e.getAccessListData = function(e) {
                        var t, r;
                        if (e && (0, i.isAccessList)(e)) {
                            t = e;
                            for(var o = [], a = 0; a < e.length; a++){
                                for(var s = e[a], u = (0, n.toBuffer)(s.address), c = [], f = 0; f < s.storageKeys.length; f++)c.push((0, n.toBuffer)(s.storageKeys[f]));
                                o.push([
                                    u,
                                    c
                                ]);
                            }
                            r = o;
                        } else {
                            r = null != e ? e : [];
                            var d = [];
                            for(a = 0; a < r.length; a++){
                                var l = r[a], h = (0, n.bufferToHex)(l[0]), p = [];
                                for(s = 0; s < l[1].length; s++)p.push((0, n.bufferToHex)(l[1][s]));
                                var b = {
                                    address: h,
                                    storageKeys: p
                                };
                                d.push(b);
                            }
                            t = d;
                        }
                        return {
                            AccessListJSON: t,
                            accessList: r
                        };
                    }, e.verifyAccessList = function(e) {
                        for(var t = 0; t < e.length; t++){
                            var r = e[t], n = r[0], i = r[1];
                            if (void 0 !== r[2]) throw new Error("Access list item cannot have 3 elements. It can only have an address, and an array of storage slots.");
                            if (20 != n.length) throw new Error("Invalid EIP-2930 transaction: address length should be 20 bytes");
                            for(var o = 0; o < i.length; o++)if (32 != i[o].length) throw new Error("Invalid EIP-2930 transaction: storage slot length should be 32 bytes");
                        }
                    }, e.getAccessListJSON = function(e) {
                        for(var t = [], r = 0; r < e.length; r++){
                            for(var i = e[r], o = {
                                address: "0x" + (0, n.setLengthLeft)(i[0], 20).toString("hex"),
                                storageKeys: []
                            }, a = i[1], s = 0; s < a.length; s++){
                                var u = a[s];
                                o.storageKeys.push("0x" + (0, n.setLengthLeft)(u, 32).toString("hex"));
                            }
                            t.push(o);
                        }
                        return t;
                    }, e.getDataFeeEIP2930 = function(e, t) {
                        for(var r = t.param("gasPrices", "accessListStorageKeyCost"), n = t.param("gasPrices", "accessListAddressCost"), i = 0, o = 0; o < e.length; o++)i += e[o][1].length;
                        return e.length * n + i * r;
                    }, e;
                }();
                t.AccessLists = o;
            },
            59786: (e, t, r)=>{
                "use strict";
                var n = r(29033).Buffer, i = r(28847), o = i(r(74519)), a = i(r(69721)), s = i(r(58985));
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.accountBodyToRLP = t.accountBodyToSlim = t.accountBodyFromSlim = t.isZeroAddress = t.zeroAddress = t.importPublic = t.privateToAddress = t.privateToPublic = t.publicToAddress = t.pubToAddress = t.isValidPublic = t.isValidPrivate = t.generateAddress2 = t.generateAddress = t.isValidChecksumAddress = t.toChecksumAddress = t.isValidAddress = t.Account = void 0;
                var u = r(89658), c = r(1243), f = r(86992), d = r(40890), l = r(55803), h = r(21449), p = r(99047), b = r(72560), y = BigInt(0), v = function() {
                    function e() {
                        var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : y, r = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : y, n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : h.KECCAK256_RLP, i = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : h.KECCAK256_NULL;
                        (0, a.default)(this, e), this.nonce = t, this.balance = r, this.storageRoot = n, this.codeHash = i, this._validate();
                    }
                    return (0, s.default)(e, [
                        {
                            key: "_validate",
                            value: function() {
                                if (this.nonce < y) throw new Error("nonce must be greater than zero");
                                if (this.balance < y) throw new Error("balance must be greater than zero");
                                if (32 !== this.storageRoot.length) throw new Error("storageRoot must have a length of 32");
                                if (32 !== this.codeHash.length) throw new Error("codeHash must have a length of 32");
                            }
                        },
                        {
                            key: "raw",
                            value: function() {
                                return [
                                    (0, l.bigIntToUnpaddedBuffer)(this.nonce),
                                    (0, l.bigIntToUnpaddedBuffer)(this.balance),
                                    this.storageRoot,
                                    this.codeHash
                                ];
                            }
                        },
                        {
                            key: "serialize",
                            value: function() {
                                return n.from(u.RLP.encode((0, l.bufArrToArr)(this.raw())));
                            }
                        },
                        {
                            key: "isContract",
                            value: function() {
                                return !this.codeHash.equals(h.KECCAK256_NULL);
                            }
                        },
                        {
                            key: "isEmpty",
                            value: function() {
                                return this.balance === y && this.nonce === y && this.codeHash.equals(h.KECCAK256_NULL);
                            }
                        }
                    ], [
                        {
                            key: "fromAccountData",
                            value: function(t) {
                                var r = t.nonce, n = t.balance, i = t.storageRoot, o = t.codeHash;
                                return new e(void 0 !== r ? (0, l.bufferToBigInt)((0, l.toBuffer)(r)) : void 0, void 0 !== n ? (0, l.bufferToBigInt)((0, l.toBuffer)(n)) : void 0, void 0 !== i ? (0, l.toBuffer)(i) : void 0, void 0 !== o ? (0, l.toBuffer)(o) : void 0);
                            }
                        },
                        {
                            key: "fromRlpSerializedAccount",
                            value: function(e) {
                                var t = (0, l.arrToBufArr)(u.RLP.decode(Uint8Array.from(e)));
                                if (!Array.isArray(t)) throw new Error("Invalid serialized account input. Must be array");
                                return this.fromValuesArray(t);
                            }
                        },
                        {
                            key: "fromValuesArray",
                            value: function(t) {
                                var r = (0, o.default)(t, 4), n = r[0], i = r[1], a = r[2], s = r[3];
                                return new e((0, l.bufferToBigInt)(n), (0, l.bufferToBigInt)(i), a, s);
                            }
                        }
                    ]), e;
                }();
                function m(e) {
                    var t = (0, o.default)(e, 4), r = t[0], n = t[1], i = t[2], a = t[3];
                    return [
                        r,
                        n,
                        0 === (0, l.arrToBufArr)(i).length ? h.KECCAK256_RLP : i,
                        0 === (0, l.arrToBufArr)(a).length ? h.KECCAK256_NULL : a
                    ];
                }
                t.Account = v, t.isValidAddress = function(e) {
                    try {
                        (0, p.assertIsString)(e);
                    } catch (e) {
                        return !1;
                    }
                    return /^0x[0-9a-fA-F]{40}$/.test(e);
                }, t.toChecksumAddress = function(e, t) {
                    (0, p.assertIsHexString)(e);
                    var r = (0, b.stripHexPrefix)(e).toLowerCase(), i = "";
                    void 0 !== t && (i = (0, l.bufferToBigInt)((0, l.toBuffer)(t)).toString() + "0x");
                    for(var o = n.from(i + r, "utf8"), a = (0, d.bytesToHex)((0, c.keccak256)(o)), s = "0x", u = 0; u < r.length; u++)parseInt(a[u], 16) >= 8 ? s += r[u].toUpperCase() : s += r[u];
                    return s;
                }, t.isValidChecksumAddress = function(e, r) {
                    return (0, t.isValidAddress)(e) && (0, t.toChecksumAddress)(e, r) === e;
                }, t.generateAddress = function(e, t) {
                    return (0, p.assertIsBuffer)(e), (0, p.assertIsBuffer)(t), (0, l.bufferToBigInt)(t) === BigInt(0) ? n.from((0, c.keccak256)(u.RLP.encode((0, l.bufArrToArr)([
                        e,
                        null
                    ])))).slice(-20) : n.from((0, c.keccak256)(u.RLP.encode((0, l.bufArrToArr)([
                        e,
                        t
                    ])))).slice(-20);
                }, t.generateAddress2 = function(e, t, r) {
                    if ((0, p.assertIsBuffer)(e), (0, p.assertIsBuffer)(t), (0, p.assertIsBuffer)(r), 20 !== e.length) throw new Error("Expected from to be of length 20");
                    if (32 !== t.length) throw new Error("Expected salt to be of length 32");
                    var i = (0, c.keccak256)(n.concat([
                        n.from("ff", "hex"),
                        e,
                        t,
                        (0, c.keccak256)(r)
                    ]));
                    return (0, l.toBuffer)(i).slice(-20);
                }, t.isValidPrivate = function(e) {
                    return f.secp256k1.utils.isValidPrivateKey(e);
                }, t.isValidPublic = function(e) {
                    var t = arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
                    if ((0, p.assertIsBuffer)(e), 64 === e.length) try {
                        return f.secp256k1.ProjectivePoint.fromHex(n.concat([
                            n.from([
                                4
                            ]),
                            e
                        ])), !0;
                    } catch (e) {
                        return !1;
                    }
                    if (!t) return !1;
                    try {
                        return f.secp256k1.ProjectivePoint.fromHex(e), !0;
                    } catch (e) {
                        return !1;
                    }
                }, t.pubToAddress = function(e) {
                    var t = arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
                    if ((0, p.assertIsBuffer)(e), t && 64 !== e.length && (e = n.from(f.secp256k1.ProjectivePoint.fromHex(e).toRawBytes(!1).slice(1))), 64 !== e.length) throw new Error("Expected pubKey to be of length 64");
                    return n.from((0, c.keccak256)(e)).slice(-20);
                }, t.publicToAddress = t.pubToAddress, t.privateToPublic = function(e) {
                    return (0, p.assertIsBuffer)(e), n.from(f.secp256k1.ProjectivePoint.fromPrivateKey(e).toRawBytes(!1).slice(1));
                }, t.privateToAddress = function(e) {
                    return (0, t.publicToAddress)((0, t.privateToPublic)(e));
                }, t.importPublic = function(e) {
                    return (0, p.assertIsBuffer)(e), 64 !== e.length && (e = n.from(f.secp256k1.ProjectivePoint.fromHex(e).toRawBytes(!1).slice(1))), e;
                }, t.zeroAddress = function() {
                    var e = (0, l.zeros)(20);
                    return (0, l.bufferToHex)(e);
                }, t.isZeroAddress = function(e) {
                    try {
                        (0, p.assertIsString)(e);
                    } catch (e) {
                        return !1;
                    }
                    return (0, t.zeroAddress)() === e;
                }, t.accountBodyFromSlim = m;
                var g = new Uint8Array(0);
                t.accountBodyToSlim = function(e) {
                    var t = (0, o.default)(e, 4), r = t[0], n = t[1], i = t[2], a = t[3];
                    return [
                        r,
                        n,
                        (0, l.arrToBufArr)(i).equals(h.KECCAK256_RLP) ? g : i,
                        (0, l.arrToBufArr)(a).equals(h.KECCAK256_NULL) ? g : a
                    ];
                }, t.accountBodyToRLP = function(e) {
                    var t = arguments.length > 1 && void 0 !== arguments[1] && !arguments[1] ? e : m(e);
                    return (0, l.arrToBufArr)(u.RLP.encode(t));
                };
            },
            78718: (e, t, r)=>{
                "use strict";
                var n = r(29033).Buffer, i = r(28847), o = i(r(69721)), a = i(r(58985));
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.Address = void 0;
                var s = r(59786), u = r(55803), c = function() {
                    function e(t) {
                        if ((0, o.default)(this, e), 20 !== t.length) throw new Error("Invalid address length");
                        this.buf = t;
                    }
                    return (0, a.default)(e, [
                        {
                            key: "equals",
                            value: function(e) {
                                return this.buf.equals(e.buf);
                            }
                        },
                        {
                            key: "isZero",
                            value: function() {
                                return this.equals(e.zero());
                            }
                        },
                        {
                            key: "isPrecompileOrSystemAddress",
                            value: function() {
                                var e = (0, u.bufferToBigInt)(this.buf), t = BigInt(0), r = BigInt("0xffff");
                                return e >= t && e <= r;
                            }
                        },
                        {
                            key: "toString",
                            value: function() {
                                return "0x" + this.buf.toString("hex");
                            }
                        },
                        {
                            key: "toBuffer",
                            value: function() {
                                return n.from(this.buf);
                            }
                        }
                    ], [
                        {
                            key: "zero",
                            value: function() {
                                return new e((0, u.zeros)(20));
                            }
                        },
                        {
                            key: "fromString",
                            value: function(t) {
                                if (!(0, s.isValidAddress)(t)) throw new Error("Invalid address");
                                return new e((0, u.toBuffer)(t));
                            }
                        },
                        {
                            key: "fromPublicKey",
                            value: function(t) {
                                if (!n.isBuffer(t)) throw new Error("Public key should be Buffer");
                                return new e((0, s.pubToAddress)(t));
                            }
                        },
                        {
                            key: "fromPrivateKey",
                            value: function(t) {
                                if (!n.isBuffer(t)) throw new Error("Private key should be Buffer");
                                return new e((0, s.privateToAddress)(t));
                            }
                        },
                        {
                            key: "generate",
                            value: function(t, r) {
                                if ("bigint" != typeof r) throw new Error("Expected nonce to be a bigint");
                                return new e((0, s.generateAddress)(t.buf, (0, u.bigIntToBuffer)(r)));
                            }
                        },
                        {
                            key: "generate2",
                            value: function(t, r, i) {
                                if (!n.isBuffer(r)) throw new Error("Expected salt to be a Buffer");
                                if (!n.isBuffer(i)) throw new Error("Expected initCode to be a Buffer");
                                return new e((0, s.generateAddress2)(t.buf, r, i));
                            }
                        }
                    ]), e;
                }();
                t.Address = c;
            },
            77692: (e, t, r)=>{
                "use strict";
                var n = r(28847), i = n(r(82247)), o = n(r(69721)), a = n(r(58985)), s = n(r(119)), u = n(r(15163)), c = n(r(34650)), f = n(r(21949)), d = n(r(94571));
                function l(e) {
                    var t, r, n, i = 2;
                    for("undefined" != typeof Symbol && (r = Symbol.asyncIterator, n = Symbol.iterator); i--;){
                        if (r && null != (t = e[r])) return t.call(e);
                        if (n && null != (t = e[n])) return new h(t.call(e));
                        r = "@@asyncIterator", n = "@@iterator";
                    }
                    throw new TypeError("Object is not async iterable");
                }
                function h(e) {
                    function t(e) {
                        if (Object(e) !== e) return Promise.reject(new TypeError(e + " is not an object."));
                        var t = e.done;
                        return Promise.resolve(e.value).then(function(e) {
                            return {
                                value: e,
                                done: t
                            };
                        });
                    }
                    return h = function(e) {
                        this.s = e, this.n = e.next;
                    }, h.prototype = {
                        s: null,
                        n: null,
                        next: function() {
                            return t(this.n.apply(this.s, arguments));
                        },
                        return: function(e) {
                            var r = this.s.return;
                            return void 0 === r ? Promise.resolve({
                                value: e,
                                done: !0
                            }) : t(r.apply(this.s, arguments));
                        },
                        throw: function(e) {
                            var r = this.s.return;
                            return void 0 === r ? Promise.reject(e) : t(r.apply(this.s, arguments));
                        }
                    }, new h(e);
                }
                function p() {
                    return (p = (0, d.default)(i.default.mark(function e(t, r, n) {
                        var o, a, s, u, c, f, d;
                        return i.default.wrap(function(e) {
                            for(;;)switch(e.prev = e.next){
                                case 0:
                                    a = !1, s = !1, e.prev = 2, c = i.default.mark(function e() {
                                        var r;
                                        return i.default.wrap(function(e) {
                                            for(;;)switch(e.prev = e.next){
                                                case 0:
                                                    if (r = d.value, e.prev = 1, !(r.length < 2)) {
                                                        e.next = 6;
                                                        break;
                                                    }
                                                    r.call(t, n), e.next = 8;
                                                    break;
                                                case 6:
                                                    return e.next = 8, new Promise(function(e, i) {
                                                        r.call(t, n, function(t) {
                                                            t ? i(t) : e();
                                                        });
                                                    });
                                                case 8:
                                                    e.next = 13;
                                                    break;
                                                case 10:
                                                    e.prev = 10, e.t0 = e.catch(1), o = e.t0;
                                                case 13:
                                                case "end":
                                                    return e.stop();
                                            }
                                        }, e, null, [
                                            [
                                                1,
                                                10
                                            ]
                                        ]);
                                    }), f = l(r);
                                case 5:
                                    return e.next = 7, f.next();
                                case 7:
                                    if (!(a = !(d = e.sent).done)) {
                                        e.next = 12;
                                        break;
                                    }
                                    return e.delegateYield(c(), "t0", 9);
                                case 9:
                                    a = !1, e.next = 5;
                                    break;
                                case 12:
                                    e.next = 18;
                                    break;
                                case 14:
                                    e.prev = 14, e.t1 = e.catch(2), s = !0, u = e.t1;
                                case 18:
                                    if (e.prev = 18, e.prev = 19, !a || null == f.return) {
                                        e.next = 23;
                                        break;
                                    }
                                    return e.next = 23, f.return();
                                case 23:
                                    if (e.prev = 23, !s) {
                                        e.next = 26;
                                        break;
                                    }
                                    throw u;
                                case 26:
                                    return e.finish(23);
                                case 27:
                                    return e.finish(18);
                                case 28:
                                    if (!o) {
                                        e.next = 30;
                                        break;
                                    }
                                    throw o;
                                case 30:
                                case "end":
                                    return e.stop();
                            }
                        }, e, null, [
                            [
                                2,
                                14,
                                18,
                                28
                            ],
                            [
                                19,
                                ,
                                23,
                                27
                            ]
                        ]);
                    }))).apply(this, arguments);
                }
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.AsyncEventEmitter = void 0;
                var b = function(e) {
                    (0, u.default)(i, e);
                    var t, r, n = (t = i, r = function() {
                        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                        if (Reflect.construct.sham) return !1;
                        if ("function" == typeof Proxy) return !0;
                        try {
                            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                        } catch (e) {
                            return !1;
                        }
                    }(), function() {
                        var e, n = (0, f.default)(t);
                        if (r) {
                            var i = (0, f.default)(this).constructor;
                            e = Reflect.construct(n, arguments, i);
                        } else e = n.apply(this, arguments);
                        return (0, c.default)(this, e);
                    });
                    function i() {
                        return (0, o.default)(this, i), n.apply(this, arguments);
                    }
                    return (0, a.default)(i, [
                        {
                            key: "emit",
                            value: function(e) {
                                for(var t, r = arguments.length, n = new Array(r > 1 ? r - 1 : 0), i = 1; i < r; i++)n[i - 1] = arguments[i];
                                var o = n[0], a = n[1], s = this, u = null !== (t = s._events[e]) && void 0 !== t ? t : [];
                                return void 0 === a && "function" == typeof o && (a = o, o = void 0), "newListener" !== e && "removeListener" !== e || (o = {
                                    event: o,
                                    fn: a
                                }, a = void 0), (function(e, t, r) {
                                    return p.apply(this, arguments);
                                })(s, (u = Array.isArray(u) ? u : [
                                    u
                                ]).slice(), o).then(a).catch(a), s.listenerCount(e) > 0;
                            }
                        },
                        {
                            key: "once",
                            value: function(e, t) {
                                var r, n = this;
                                if ("function" != typeof t) throw new TypeError("listener must be a function");
                                return r = t.length >= 2 ? function(i, o) {
                                    n.removeListener(e, r), t(i, o);
                                } : function(i) {
                                    n.removeListener(e, r), t(i, r);
                                }, n.on(e, r), n;
                            }
                        },
                        {
                            key: "first",
                            value: function(e, t) {
                                var r, n = null !== (r = this._events[e]) && void 0 !== r ? r : [];
                                if ("function" != typeof t) throw new TypeError("listener must be a function");
                                return Array.isArray(n) || (this._events[e] = n = [
                                    n
                                ]), n.unshift(t), this;
                            }
                        },
                        {
                            key: "before",
                            value: function(e, t, r) {
                                return this.beforeOrAfter(e, t, r);
                            }
                        },
                        {
                            key: "after",
                            value: function(e, t, r) {
                                return this.beforeOrAfter(e, t, r, "after");
                            }
                        },
                        {
                            key: "beforeOrAfter",
                            value: function(e, t, r, n) {
                                var i, o, a, s = null !== (i = this._events[e]) && void 0 !== i ? i : [], u = "after" === n ? 1 : 0;
                                if ("function" != typeof r) throw new TypeError("listener must be a function");
                                if ("function" != typeof t) throw new TypeError("target must be a function");
                                for(Array.isArray(s) || (this._events[e] = s = [
                                    s
                                ]), a = s.length, o = s.length; o--;)if (s[o] === t) {
                                    a = o + u;
                                    break;
                                }
                                return s.splice(a, 0, r), this;
                            }
                        },
                        {
                            key: "on",
                            value: function(e, t) {
                                return (0, s.default)((0, f.default)(i.prototype), "on", this).call(this, e, t);
                            }
                        },
                        {
                            key: "addListener",
                            value: function(e, t) {
                                return (0, s.default)((0, f.default)(i.prototype), "addListener", this).call(this, e, t);
                            }
                        },
                        {
                            key: "prependListener",
                            value: function(e, t) {
                                return (0, s.default)((0, f.default)(i.prototype), "prependListener", this).call(this, e, t);
                            }
                        },
                        {
                            key: "prependOnceListener",
                            value: function(e, t) {
                                return (0, s.default)((0, f.default)(i.prototype), "prependOnceListener", this).call(this, e, t);
                            }
                        },
                        {
                            key: "removeAllListeners",
                            value: function(e) {
                                return (0, s.default)((0, f.default)(i.prototype), "removeAllListeners", this).call(this, e);
                            }
                        },
                        {
                            key: "removeListener",
                            value: function(e, t) {
                                return (0, s.default)((0, f.default)(i.prototype), "removeListener", this).call(this, e, t);
                            }
                        },
                        {
                            key: "eventNames",
                            value: function() {
                                return (0, s.default)((0, f.default)(i.prototype), "eventNames", this).call(this);
                            }
                        },
                        {
                            key: "listeners",
                            value: function(e) {
                                return (0, s.default)((0, f.default)(i.prototype), "listeners", this).call(this, e);
                            }
                        },
                        {
                            key: "listenerCount",
                            value: function(e) {
                                return (0, s.default)((0, f.default)(i.prototype), "listenerCount", this).call(this, e);
                            }
                        },
                        {
                            key: "getMaxListeners",
                            value: function() {
                                return (0, s.default)((0, f.default)(i.prototype), "getMaxListeners", this).call(this);
                            }
                        },
                        {
                            key: "setMaxListeners",
                            value: function(e) {
                                return (0, s.default)((0, f.default)(i.prototype), "setMaxListeners", this).call(this, e);
                            }
                        }
                    ]), i;
                }(r(38291).EventEmitter);
                t.AsyncEventEmitter = b;
            },
            55803: (e, t, r)=>{
                "use strict";
                var n = r(29033).Buffer, i = r(28847)(r(74519));
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.intToUnpaddedBuffer = t.bigIntToUnpaddedBuffer = t.bigIntToHex = t.bufArrToArr = t.arrToBufArr = t.validateNoLeadingZeroes = t.baToJSON = t.toUtf8 = t.short = t.addHexPrefix = t.toUnsigned = t.fromSigned = t.bufferToInt = t.bigIntToBuffer = t.bufferToBigInt = t.bufferToHex = t.toBuffer = t.unpadHexString = t.unpadArray = t.unpadBuffer = t.setLengthRight = t.setLengthLeft = t.zeros = t.intToBuffer = t.intToHex = void 0;
                var o = r(99047), a = r(72560);
                t.intToHex = function(e) {
                    if (!Number.isSafeInteger(e) || e < 0) throw new Error("Received an invalid integer type: ".concat(e));
                    return "0x".concat(e.toString(16));
                }, t.intToBuffer = function(e) {
                    var r = (0, t.intToHex)(e);
                    return n.from((0, a.padToEven)(r.slice(2)), "hex");
                }, t.zeros = function(e) {
                    return n.allocUnsafe(e).fill(0);
                };
                var s = function(e, r, n) {
                    var i = (0, t.zeros)(r);
                    return n ? e.length < r ? (e.copy(i), i) : e.slice(0, r) : e.length < r ? (e.copy(i, r - e.length), i) : e.slice(-r);
                };
                t.setLengthLeft = function(e, t) {
                    return (0, o.assertIsBuffer)(e), s(e, t, !1);
                }, t.setLengthRight = function(e, t) {
                    return (0, o.assertIsBuffer)(e), s(e, t, !0);
                };
                var u = function(e) {
                    for(var t = e[0]; e.length > 0 && "0" === t.toString();)t = (e = e.slice(1))[0];
                    return e;
                };
                function c(e) {
                    var r = (0, t.bufferToHex)(e);
                    return "0x" === r ? BigInt(0) : BigInt(r);
                }
                function f(e) {
                    return (0, t.toBuffer)("0x" + e.toString(16));
                }
                t.unpadBuffer = function(e) {
                    return (0, o.assertIsBuffer)(e), u(e);
                }, t.unpadArray = function(e) {
                    return (0, o.assertIsArray)(e), u(e);
                }, t.unpadHexString = function(e) {
                    return (0, o.assertIsHexString)(e), e = (0, a.stripHexPrefix)(e), "0x" + u(e);
                }, t.toBuffer = function(e) {
                    if (null == e) return n.allocUnsafe(0);
                    if (n.isBuffer(e)) return n.from(e);
                    if (Array.isArray(e) || e instanceof Uint8Array) return n.from(e);
                    if ("string" == typeof e) {
                        if (!(0, a.isHexString)(e)) throw new Error("Cannot convert string to buffer. toBuffer only supports 0x-prefixed hex strings and this string was given: ".concat(e));
                        return n.from((0, a.padToEven)((0, a.stripHexPrefix)(e)), "hex");
                    }
                    if ("number" == typeof e) return (0, t.intToBuffer)(e);
                    if ("bigint" == typeof e) {
                        if (e < BigInt(0)) throw new Error("Cannot convert negative bigint to buffer. Given: ".concat(e));
                        var r = e.toString(16);
                        return r.length % 2 && (r = "0" + r), n.from(r, "hex");
                    }
                    if (e.toArray) return n.from(e.toArray());
                    if (e.toBuffer) return n.from(e.toBuffer());
                    throw new Error("invalid type");
                }, t.bufferToHex = function(e) {
                    return "0x" + (e = (0, t.toBuffer)(e)).toString("hex");
                }, t.bufferToBigInt = c, t.bigIntToBuffer = f, t.bufferToInt = function(e) {
                    var t = Number(c(e));
                    if (!Number.isSafeInteger(t)) throw new Error("Number exceeds 53 bits");
                    return t;
                }, t.fromSigned = function(e) {
                    return BigInt.asIntN(256, c(e));
                }, t.toUnsigned = function(e) {
                    return f(BigInt.asUintN(256, e));
                }, t.addHexPrefix = function(e) {
                    return "string" != typeof e || (0, a.isHexPrefixed)(e) ? e : "0x" + e;
                }, t.short = function(e) {
                    var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 50, r = n.isBuffer(e) ? e.toString("hex") : e;
                    return r.length <= t ? r : r.slice(0, t) + "\u2026";
                }, t.toUtf8 = function(e) {
                    if ((e = (0, a.stripHexPrefix)(e)).length % 2 != 0) throw new Error("Invalid non-even hex string input for toUtf8() provided");
                    return n.from(e.replace(/^(00)+|(00)+$/g, ""), "hex").toString("utf8");
                }, t.baToJSON = function(e) {
                    if (n.isBuffer(e)) return "0x".concat(e.toString("hex"));
                    if (e instanceof Array) {
                        for(var r = [], i = 0; i < e.length; i++)r.push((0, t.baToJSON)(e[i]));
                        return r;
                    }
                }, t.validateNoLeadingZeroes = function(e) {
                    for(var t = 0, r = Object.entries(e); t < r.length; t++){
                        var n = (0, i.default)(r[t], 2), o = n[0], a = n[1];
                        if (void 0 !== a && a.length > 0 && 0 === a[0]) throw new Error("".concat(o, " cannot have leading zeroes, received: ").concat(a.toString("hex")));
                    }
                }, t.arrToBufArr = function e(t) {
                    return Array.isArray(t) ? t.map(function(t) {
                        return e(t);
                    }) : n.from(t);
                }, t.bufArrToArr = function e(t) {
                    return Array.isArray(t) ? t.map(function(t) {
                        return e(t);
                    }) : Uint8Array.from(null != t ? t : []);
                }, t.bigIntToHex = function(e) {
                    return "0x" + e.toString(16);
                }, t.bigIntToUnpaddedBuffer = function(e) {
                    return (0, t.unpadBuffer)(f(e));
                }, t.intToUnpaddedBuffer = function(e) {
                    return (0, t.unpadBuffer)((0, t.intToBuffer)(e));
                };
            },
            21449: (e, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.MAX_WITHDRAWALS_PER_PAYLOAD = t.RLP_EMPTY_STRING = t.KECCAK256_RLP = t.KECCAK256_RLP_S = t.KECCAK256_RLP_ARRAY = t.KECCAK256_RLP_ARRAY_S = t.KECCAK256_NULL = t.KECCAK256_NULL_S = t.TWO_POW256 = t.SECP256K1_ORDER_DIV_2 = t.SECP256K1_ORDER = t.MAX_INTEGER_BIGINT = t.MAX_INTEGER = t.MAX_UINT64 = void 0;
                var n = r(29033), i = r(86992);
                t.MAX_UINT64 = BigInt("0xffffffffffffffff"), t.MAX_INTEGER = BigInt("0xffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff"), t.MAX_INTEGER_BIGINT = BigInt("115792089237316195423570985008687907853269984665640564039457584007913129639935"), t.SECP256K1_ORDER = i.secp256k1.CURVE.n, t.SECP256K1_ORDER_DIV_2 = i.secp256k1.CURVE.n / BigInt(2), t.TWO_POW256 = BigInt("0x10000000000000000000000000000000000000000000000000000000000000000"), t.KECCAK256_NULL_S = "c5d2460186f7233c927e7db2dcc703c0e500b653ca82273b7bfad8045d85a470", t.KECCAK256_NULL = n.Buffer.from(t.KECCAK256_NULL_S, "hex"), t.KECCAK256_RLP_ARRAY_S = "1dcc4de8dec75d7aab85b567b6ccd41ad312451b948a7413f0a142fd40d49347", t.KECCAK256_RLP_ARRAY = n.Buffer.from(t.KECCAK256_RLP_ARRAY_S, "hex"), t.KECCAK256_RLP_S = "56e81f171bcc55a6ff8345e692c0f86e5b48e01b996cadc001622fb5e363b421", t.KECCAK256_RLP = n.Buffer.from(t.KECCAK256_RLP_S, "hex"), t.RLP_EMPTY_STRING = n.Buffer.from([
                    128
                ]), t.MAX_WITHDRAWALS_PER_PAYLOAD = 16;
            },
            89890: (e, t)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.compactBytesToNibbles = t.bytesToNibbles = t.nibblesToCompactBytes = t.nibblesToBytes = t.hasTerminator = void 0, t.hasTerminator = function(e) {
                    return e.length > 0 && 16 === e[e.length - 1];
                }, t.nibblesToBytes = function(e, t) {
                    for(var r = 0, n = 0; n < e.length; r += 1, n += 2)t[r] = e[n] << 4 | e[n + 1];
                }, t.nibblesToCompactBytes = function(e) {
                    var r = 0;
                    (0, t.hasTerminator)(e) && (r = 1, e = e.subarray(0, e.length - 1));
                    var n = new Uint8Array(e.length / 2 + 1);
                    return n[0] = r << 5, 1 == (1 & e.length) && (n[0] |= 16, n[0] |= e[0], e = e.subarray(1)), (0, t.nibblesToBytes)(e, n.subarray(1)), n;
                }, t.bytesToNibbles = function(e) {
                    for(var t = 2 * e.length + 1, r = new Uint8Array(t), n = 0; n < e.length; n++){
                        var i = e[n];
                        r[2 * n] = i / 16, r[2 * n + 1] = i % 16;
                    }
                    return r[t - 1] = 16, r;
                }, t.compactBytesToNibbles = function(e) {
                    if (0 === e.length) return e;
                    var r = (0, t.bytesToNibbles)(e);
                    r[0] < 2 && (r = r.subarray(0, r.length - 1));
                    var n = 2 - (1 & r[0]);
                    return r.subarray(n);
                };
            },
            99047: (e, t, r)=>{
                "use strict";
                var n = r(29033).Buffer;
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.assertIsString = t.assertIsArray = t.assertIsBuffer = t.assertIsHexString = void 0;
                var i = r(72560);
                t.assertIsHexString = function(e) {
                    if (!(0, i.isHexString)(e)) {
                        var t = "This method only supports 0x-prefixed hex strings but input was: ".concat(e);
                        throw new Error(t);
                    }
                }, t.assertIsBuffer = function(e) {
                    if (!n.isBuffer(e)) {
                        var t = "This method only supports Buffer but input was: ".concat(e);
                        throw new Error(t);
                    }
                }, t.assertIsArray = function(e) {
                    if (!Array.isArray(e)) {
                        var t = "This method only supports number arrays but input was: ".concat(e);
                        throw new Error(t);
                    }
                }, t.assertIsString = function(e) {
                    if ("string" != typeof e) {
                        var t = "This method only supports strings but input was: ".concat(e);
                        throw new Error(t);
                    }
                };
            },
            65907: (e, t, r)=>{
                "use strict";
                var n = Object.create ? function(e, t, r, n) {
                    void 0 === n && (n = r);
                    var i = Object.getOwnPropertyDescriptor(t, r);
                    i && !("get" in i ? !t.__esModule : i.writable || i.configurable) || (i = {
                        enumerable: !0,
                        get: function() {
                            return t[r];
                        }
                    }), Object.defineProperty(e, n, i);
                } : function(e, t, r, n) {
                    void 0 === n && (n = r), e[n] = t[r];
                }, i = function(e, t) {
                    for(var r in e)"default" === r || Object.prototype.hasOwnProperty.call(t, r) || n(t, e, r);
                };
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.toAscii = t.stripHexPrefix = t.padToEven = t.isHexString = t.isHexPrefixed = t.getKeys = t.getBinarySize = t.fromUtf8 = t.fromAscii = t.arrayContainsArray = void 0, i(r(21449), t), i(r(44205), t), i(r(59786), t), i(r(78718), t), i(r(1313), t), i(r(65404), t), i(r(55803), t), i(r(62198), t), i(r(89890), t), i(r(77692), t);
                var o = r(72560);
                Object.defineProperty(t, "arrayContainsArray", {
                    enumerable: !0,
                    get: function() {
                        return o.arrayContainsArray;
                    }
                }), Object.defineProperty(t, "fromAscii", {
                    enumerable: !0,
                    get: function() {
                        return o.fromAscii;
                    }
                }), Object.defineProperty(t, "fromUtf8", {
                    enumerable: !0,
                    get: function() {
                        return o.fromUtf8;
                    }
                }), Object.defineProperty(t, "getBinarySize", {
                    enumerable: !0,
                    get: function() {
                        return o.getBinarySize;
                    }
                }), Object.defineProperty(t, "getKeys", {
                    enumerable: !0,
                    get: function() {
                        return o.getKeys;
                    }
                }), Object.defineProperty(t, "isHexPrefixed", {
                    enumerable: !0,
                    get: function() {
                        return o.isHexPrefixed;
                    }
                }), Object.defineProperty(t, "isHexString", {
                    enumerable: !0,
                    get: function() {
                        return o.isHexString;
                    }
                }), Object.defineProperty(t, "padToEven", {
                    enumerable: !0,
                    get: function() {
                        return o.padToEven;
                    }
                }), Object.defineProperty(t, "stripHexPrefix", {
                    enumerable: !0,
                    get: function() {
                        return o.stripHexPrefix;
                    }
                }), Object.defineProperty(t, "toAscii", {
                    enumerable: !0,
                    get: function() {
                        return o.toAscii;
                    }
                }), i(r(35651), t), i(r(6449), t);
            },
            72560: (e, t, r)=>{
                "use strict";
                var n = r(29033).Buffer, i = r(28847)(r(3355));
                function o(e) {
                    if ("string" != typeof e) throw new Error("[isHexPrefixed] input must be type 'string', received type ".concat((0, i.default)(e)));
                    return "0" === e[0] && "x" === e[1];
                }
                function a(e) {
                    var t = e;
                    if ("string" != typeof t) throw new Error("[padToEven] value must be type 'string', received ".concat((0, i.default)(t)));
                    return t.length % 2 && (t = "0".concat(t)), t;
                }
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.isHexString = t.getKeys = t.fromAscii = t.fromUtf8 = t.toAscii = t.arrayContainsArray = t.getBinarySize = t.padToEven = t.stripHexPrefix = t.isHexPrefixed = void 0, t.isHexPrefixed = o, t.stripHexPrefix = function(e) {
                    if ("string" != typeof e) throw new Error("[stripHexPrefix] input must be type 'string', received ".concat((0, i.default)(e)));
                    return o(e) ? e.slice(2) : e;
                }, t.padToEven = a, t.getBinarySize = function(e) {
                    if ("string" != typeof e) throw new Error("[getBinarySize] method requires input type 'string', received ".concat((0, i.default)(e)));
                    return n.byteLength(e, "utf8");
                }, t.arrayContainsArray = function(e, t, r) {
                    if (!0 !== Array.isArray(e)) throw new Error("[arrayContainsArray] method requires input 'superset' to be an array, got type '".concat((0, i.default)(e), "'"));
                    if (!0 !== Array.isArray(t)) throw new Error("[arrayContainsArray] method requires input 'subset' to be an array, got type '".concat((0, i.default)(t), "'"));
                    return t[!0 === r ? "some" : "every"](function(t) {
                        return e.indexOf(t) >= 0;
                    });
                }, t.toAscii = function(e) {
                    var t = "", r = 0, n = e.length;
                    for("0x" === e.substring(0, 2) && (r = 2); r < n; r += 2){
                        var i = parseInt(e.substr(r, 2), 16);
                        t += String.fromCharCode(i);
                    }
                    return t;
                }, t.fromUtf8 = function(e) {
                    var t = n.from(e, "utf8");
                    return "0x".concat(a(t.toString("hex")).replace(/^0+|0+$/g, ""));
                }, t.fromAscii = function(e) {
                    for(var t = "", r = 0; r < e.length; r++){
                        var n = e.charCodeAt(r).toString(16);
                        t += n.length < 2 ? "0".concat(n) : n;
                    }
                    return "0x".concat(t);
                }, t.getKeys = function(e, t, r) {
                    if (!Array.isArray(e)) throw new Error("[getKeys] method expects input 'params' to be an array, got ".concat((0, i.default)(e)));
                    if ("string" != typeof t) throw new Error("[getKeys] method expects input 'key' to be type 'string', got ".concat((0, i.default)(e)));
                    for(var n = [], o = 0; o < e.length; o++){
                        var a = e[o][t];
                        if (!0 !== r || a) {
                            if ("string" != typeof a) throw new Error("invalid abi - expected type 'string', received ".concat((0, i.default)(a)));
                        } else a = "";
                        n.push(a);
                    }
                    return n;
                }, t.isHexString = function(e, t) {
                    return !("string" != typeof e || !e.match(/^0x[0-9A-Fa-f]*$/) || void 0 !== t && t > 0 && e.length !== 2 + 2 * t);
                };
            },
            35651: (e, t, r)=>{
                "use strict";
                var n = r(28847), i = n(r(82247)), o = n(r(94571)), a = n(r(69721)), s = n(r(58985));
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.Lock = void 0;
                var u = function() {
                    function e() {
                        (0, a.default)(this, e), this.permits = 1, this.promiseResolverQueue = [];
                    }
                    var t;
                    return (0, s.default)(e, [
                        {
                            key: "acquire",
                            value: (t = (0, o.default)(i.default.mark(function e() {
                                var t = this;
                                return i.default.wrap(function(e) {
                                    for(;;)switch(e.prev = e.next){
                                        case 0:
                                            if (!(this.permits > 0)) {
                                                e.next = 3;
                                                break;
                                            }
                                            return this.permits -= 1, e.abrupt("return", Promise.resolve(!0));
                                        case 3:
                                            return e.abrupt("return", new Promise(function(e) {
                                                return t.promiseResolverQueue.push(e);
                                            }));
                                        case 4:
                                        case "end":
                                            return e.stop();
                                    }
                                }, e, this);
                            })), function() {
                                return t.apply(this, arguments);
                            })
                        },
                        {
                            key: "release",
                            value: function() {
                                if (this.permits += 1, this.permits > 1 && this.promiseResolverQueue.length > 0) console.warn("Lock.permits should never be > 0 when there is someone waiting.");
                                else if (1 === this.permits && this.promiseResolverQueue.length > 0) {
                                    this.permits -= 1;
                                    var e = this.promiseResolverQueue.shift();
                                    e && e(!0);
                                }
                            }
                        }
                    ]), e;
                }();
                t.Lock = u;
            },
            6449: (e, t, r)=>{
                "use strict";
                var n = r(28847), i = n(r(82247)), o = n(r(94571));
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.getProvider = t.fetchFromProvider = void 0;
                var a = r(37441), s = function() {
                    var e = (0, o.default)(i.default.mark(function e(t, r) {
                        var n;
                        return i.default.wrap(function(e) {
                            for(;;)switch(e.prev = e.next){
                                case 0:
                                    return e.next = 2, (0, a.default)(t, {
                                        headers: {
                                            "content-type": "application/json"
                                        },
                                        type: "json",
                                        data: {
                                            method: r.method,
                                            params: r.params,
                                            jsonrpc: "2.0",
                                            id: 1
                                        }
                                    });
                                case 2:
                                    return n = e.sent, e.abrupt("return", n.result);
                                case 4:
                                case "end":
                                    return e.stop();
                            }
                        }, e);
                    }));
                    return function(t, r) {
                        return e.apply(this, arguments);
                    };
                }();
                t.fetchFromProvider = s, t.getProvider = function(e) {
                    var t;
                    if ("string" == typeof e) return e;
                    if (void 0 !== (null == e || null === (t = e.connection) || void 0 === t ? void 0 : t.url)) return e.connection.url;
                    throw new Error("Must provide valid provider URL or Web3Provider");
                };
            },
            65404: (e, t, r)=>{
                "use strict";
                var n = r(29033).Buffer;
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.hashPersonalMessage = t.isValidSignature = t.fromRpcSig = t.toCompactSig = t.toRpcSig = t.ecrecover = t.ecsign = void 0;
                var i = r(1243), o = r(86992), a = r(55803), s = r(21449), u = r(99047);
                function c(e, t) {
                    return e === BigInt(0) || e === BigInt(1) ? e : void 0 === t ? e - BigInt(27) : e - (t * BigInt(2) + BigInt(35));
                }
                function f(e) {
                    return e === BigInt(0) || e === BigInt(1);
                }
                t.ecsign = function(e, t, r) {
                    var i = o.secp256k1.sign(e, t), a = i.toCompactRawBytes();
                    return {
                        r: n.from(a.slice(0, 32)),
                        s: n.from(a.slice(32, 64)),
                        v: void 0 === r ? BigInt(i.recovery + 27) : BigInt(i.recovery + 35) + BigInt(r) * BigInt(2)
                    };
                }, t.ecrecover = function(e, t, r, i, s) {
                    var u = n.concat([
                        (0, a.setLengthLeft)(r, 32),
                        (0, a.setLengthLeft)(i, 32)
                    ], 64), d = c(t, s);
                    if (!f(d)) throw new Error("Invalid signature v value");
                    var l = o.secp256k1.Signature.fromCompact(u).addRecoveryBit(Number(d)).recoverPublicKey(e);
                    return n.from(l.toRawBytes(!1).slice(1));
                }, t.toRpcSig = function(e, t, r, i) {
                    if (!f(c(e, i))) throw new Error("Invalid signature v value");
                    return (0, a.bufferToHex)(n.concat([
                        (0, a.setLengthLeft)(t, 32),
                        (0, a.setLengthLeft)(r, 32),
                        (0, a.toBuffer)(e)
                    ]));
                }, t.toCompactSig = function(e, t, r, i) {
                    if (!f(c(e, i))) throw new Error("Invalid signature v value");
                    var o = r;
                    return (e > BigInt(28) && e % BigInt(2) === BigInt(1) || e === BigInt(1) || e === BigInt(28)) && ((o = n.from(r))[0] |= 128), (0, a.bufferToHex)(n.concat([
                        (0, a.setLengthLeft)(t, 32),
                        (0, a.setLengthLeft)(o, 32)
                    ]));
                }, t.fromRpcSig = function(e) {
                    var t, r, n, i = (0, a.toBuffer)(e);
                    if (i.length >= 65) t = i.slice(0, 32), r = i.slice(32, 64), n = (0, a.bufferToBigInt)(i.slice(64));
                    else {
                        if (64 !== i.length) throw new Error("Invalid signature length");
                        t = i.slice(0, 32), r = i.slice(32, 64), n = BigInt((0, a.bufferToInt)(i.slice(32, 33)) >> 7), r[0] &= 127;
                    }
                    return n < 27 && (n += BigInt(27)), {
                        v: n,
                        r: t,
                        s: r
                    };
                }, t.isValidSignature = function(e, t, r) {
                    var n = !(arguments.length > 3 && void 0 !== arguments[3]) || arguments[3], i = arguments.length > 4 ? arguments[4] : void 0;
                    if (32 !== t.length || 32 !== r.length) return !1;
                    if (!f(c(e, i))) return !1;
                    var o = (0, a.bufferToBigInt)(t), u = (0, a.bufferToBigInt)(r);
                    return !(o === BigInt(0) || o >= s.SECP256K1_ORDER || u === BigInt(0) || u >= s.SECP256K1_ORDER || n && u >= s.SECP256K1_ORDER_DIV_2);
                }, t.hashPersonalMessage = function(e) {
                    (0, u.assertIsBuffer)(e);
                    var t = n.from("\x19Ethereum Signed Message:\n".concat(e.length), "utf-8");
                    return n.from((0, i.keccak256)(n.concat([
                        t,
                        e
                    ])));
                };
            },
            62198: (e, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.toType = t.TypeOutput = void 0;
                var n, i = r(55803), o = r(72560);
                !function(e) {
                    e[e.Number = 0] = "Number", e[e.BigInt = 1] = "BigInt", e[e.Buffer = 2] = "Buffer", e[e.PrefixedHexString = 3] = "PrefixedHexString";
                }(n = t.TypeOutput || (t.TypeOutput = {})), t.toType = function(e, t) {
                    if (null === e) return null;
                    if (void 0 !== e) {
                        if ("string" == typeof e && !(0, o.isHexString)(e)) throw new Error("A string must be provided with a 0x-prefix, given: ".concat(e));
                        if ("number" == typeof e && !Number.isSafeInteger(e)) throw new Error("The provided number is greater than MAX_SAFE_INTEGER (please use an alternative input type)");
                        var r = (0, i.toBuffer)(e);
                        switch(t){
                            case n.Buffer:
                                return r;
                            case n.BigInt:
                                return (0, i.bufferToBigInt)(r);
                            case n.Number:
                                var a = (0, i.bufferToBigInt)(r);
                                if (a > BigInt(Number.MAX_SAFE_INTEGER)) throw new Error("The provided number is greater than MAX_SAFE_INTEGER (please use an alternative output type)");
                                return Number(a);
                            case n.PrefixedHexString:
                                return (0, i.bufferToHex)(r);
                            default:
                                throw new Error("unknown outputType");
                        }
                    }
                };
            },
            44205: (e, t)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.GWEI_TO_WEI = void 0, t.GWEI_TO_WEI = BigInt(1e9);
            },
            1313: (e, t, r)=>{
                "use strict";
                var n = r(29033).Buffer, i = r(28847), o = i(r(74519)), a = i(r(69721)), s = i(r(58985));
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.Withdrawal = void 0;
                var u = r(78718), c = r(55803), f = r(62198), d = function() {
                    function e(t, r, n, i) {
                        (0, a.default)(this, e), this.index = t, this.validatorIndex = r, this.address = n, this.amount = i;
                    }
                    return (0, s.default)(e, [
                        {
                            key: "raw",
                            value: function() {
                                return e.toBufferArray(this);
                            }
                        },
                        {
                            key: "toValue",
                            value: function() {
                                return {
                                    index: this.index,
                                    validatorIndex: this.validatorIndex,
                                    address: this.address.buf,
                                    amount: this.amount
                                };
                            }
                        },
                        {
                            key: "toJSON",
                            value: function() {
                                return {
                                    index: (0, c.bigIntToHex)(this.index),
                                    validatorIndex: (0, c.bigIntToHex)(this.validatorIndex),
                                    address: "0x" + this.address.buf.toString("hex"),
                                    amount: (0, c.bigIntToHex)(this.amount)
                                };
                            }
                        }
                    ], [
                        {
                            key: "fromWithdrawalData",
                            value: function(t) {
                                var r = t.index, n = t.validatorIndex, i = t.address, o = t.amount;
                                return new e((0, f.toType)(r, f.TypeOutput.BigInt), (0, f.toType)(n, f.TypeOutput.BigInt), new u.Address((0, f.toType)(i, f.TypeOutput.Buffer)), (0, f.toType)(o, f.TypeOutput.BigInt));
                            }
                        },
                        {
                            key: "fromValuesArray",
                            value: function(t) {
                                if (4 !== t.length) throw Error("Invalid withdrawalArray length expected=4 actual=".concat(t.length));
                                var r = (0, o.default)(t, 4), n = r[0], i = r[1], a = r[2], s = r[3];
                                return e.fromWithdrawalData({
                                    index: n,
                                    validatorIndex: i,
                                    address: a,
                                    amount: s
                                });
                            }
                        },
                        {
                            key: "toBufferArray",
                            value: function(e) {
                                var t = e.index, r = e.validatorIndex, i = e.address, o = e.amount;
                                return [
                                    (0, f.toType)(t, f.TypeOutput.BigInt) === BigInt(0) ? n.alloc(0) : (0, f.toType)(t, f.TypeOutput.Buffer),
                                    (0, f.toType)(r, f.TypeOutput.BigInt) === BigInt(0) ? n.alloc(0) : (0, f.toType)(r, f.TypeOutput.Buffer),
                                    i instanceof u.Address ? i.buf : (0, f.toType)(i, f.TypeOutput.Buffer),
                                    (0, f.toType)(o, f.TypeOutput.BigInt) === BigInt(0) ? n.alloc(0) : (0, f.toType)(o, f.TypeOutput.Buffer)
                                ];
                            }
                        }
                    ]), e;
                }();
                t.Withdrawal = d;
            },
            98067: (e, t)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.version = void 0, t.version = "abi/5.7.0";
            },
            44937: (e, t, r)=>{
                "use strict";
                var n = r(28847);
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.defaultAbiCoder = t.AbiCoder = void 0;
                var i = n(r(69721)), o = n(r(58985)), a = r(908), s = r(23694), u = r(64327), c = r(98067), f = r(17316), d = r(49146), l = r(4341), h = r(30024), p = r(53861), b = r(90028), y = r(4522), v = r(88287), m = r(48040), g = r(52010), w = r(60800), k = new u.Logger(c.version), _ = new RegExp(/^bytes([0-9]*)$/), A = new RegExp(/^(u?int)([0-9]*)$/), E = function() {
                    function e(t) {
                        (0, i.default)(this, e), (0, s.defineReadOnly)(this, "coerceFunc", t || null);
                    }
                    return (0, o.default)(e, [
                        {
                            key: "_getCoder",
                            value: function(e) {
                                var t = this;
                                switch(e.baseType){
                                    case "address":
                                        return new d.AddressCoder(e.name);
                                    case "bool":
                                        return new h.BooleanCoder(e.name);
                                    case "string":
                                        return new m.StringCoder(e.name);
                                    case "bytes":
                                        return new p.BytesCoder(e.name);
                                    case "array":
                                        return new l.ArrayCoder(this._getCoder(e.arrayChildren), e.arrayLength, e.name);
                                    case "tuple":
                                        return new g.TupleCoder((e.components || []).map(function(e) {
                                            return t._getCoder(e);
                                        }), e.name);
                                    case "":
                                        return new y.NullCoder(e.name);
                                }
                                var r = e.type.match(A);
                                if (r) {
                                    var n = parseInt(r[2] || "256");
                                    return (0 === n || n > 256 || n % 8 != 0) && k.throwArgumentError("invalid " + r[1] + " bit length", "param", e), new v.NumberCoder(n / 8, "int" === r[1], e.name);
                                }
                                if (r = e.type.match(_)) {
                                    var i = parseInt(r[1]);
                                    return (0 === i || i > 32) && k.throwArgumentError("invalid bytes length", "param", e), new b.FixedBytesCoder(i, e.name);
                                }
                                return k.throwArgumentError("invalid type", "type", e.type);
                            }
                        },
                        {
                            key: "_getWordSize",
                            value: function() {
                                return 32;
                            }
                        },
                        {
                            key: "_getReader",
                            value: function(e, t) {
                                return new f.Reader(e, this._getWordSize(), this.coerceFunc, t);
                            }
                        },
                        {
                            key: "_getWriter",
                            value: function() {
                                return new f.Writer(this._getWordSize());
                            }
                        },
                        {
                            key: "getDefaultValue",
                            value: function(e) {
                                var t = this, r = e.map(function(e) {
                                    return t._getCoder(w.ParamType.from(e));
                                });
                                return new g.TupleCoder(r, "_").defaultValue();
                            }
                        },
                        {
                            key: "encode",
                            value: function(e, t) {
                                var r = this;
                                e.length !== t.length && k.throwError("types/values length mismatch", u.Logger.errors.INVALID_ARGUMENT, {
                                    count: {
                                        types: e.length,
                                        values: t.length
                                    },
                                    value: {
                                        types: e,
                                        values: t
                                    }
                                });
                                var n = e.map(function(e) {
                                    return r._getCoder(w.ParamType.from(e));
                                }), i = new g.TupleCoder(n, "_"), o = this._getWriter();
                                return i.encode(o, t), o.data;
                            }
                        },
                        {
                            key: "decode",
                            value: function(e, t, r) {
                                var n = this, i = e.map(function(e) {
                                    return n._getCoder(w.ParamType.from(e));
                                });
                                return new g.TupleCoder(i, "_").decode(this._getReader((0, a.arrayify)(t), r));
                            }
                        }
                    ]), e;
                }();
                t.AbiCoder = E;
                var S = new E;
                t.defaultAbiCoder = S;
            },
            17316: (e, t, r)=>{
                "use strict";
                var n = r(28847);
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.Writer = t.Reader = t.Coder = void 0, t.checkResultErrors = function(e) {
                    var t = [];
                    return function e(r, n) {
                        if (Array.isArray(n)) for(var i in n){
                            var o = r.slice();
                            o.push(i);
                            try {
                                e(o, n[i]);
                            } catch (e) {
                                t.push({
                                    path: o,
                                    error: e
                                });
                            }
                        }
                    }([], e), t;
                };
                var i = n(r(69721)), o = n(r(58985)), a = r(908), s = r(34952), u = r(23694), c = r(64327), f = r(98067), d = new c.Logger(f.version), l = function() {
                    function e(t, r, n, o) {
                        (0, i.default)(this, e), this.name = t, this.type = r, this.localName = n, this.dynamic = o;
                    }
                    return (0, o.default)(e, [
                        {
                            key: "_throwError",
                            value: function(e, t) {
                                d.throwArgumentError(e, this.localName, t);
                            }
                        }
                    ]), e;
                }();
                t.Coder = l;
                var h = function() {
                    function e(t) {
                        (0, i.default)(this, e), (0, u.defineReadOnly)(this, "wordSize", t || 32), this._data = [], this._dataLength = 0, this._padding = new Uint8Array(t);
                    }
                    return (0, o.default)(e, [
                        {
                            key: "data",
                            get: function() {
                                return (0, a.hexConcat)(this._data);
                            }
                        },
                        {
                            key: "length",
                            get: function() {
                                return this._dataLength;
                            }
                        },
                        {
                            key: "_writeData",
                            value: function(e) {
                                return this._data.push(e), this._dataLength += e.length, e.length;
                            }
                        },
                        {
                            key: "appendWriter",
                            value: function(e) {
                                return this._writeData((0, a.concat)(e._data));
                            }
                        },
                        {
                            key: "writeBytes",
                            value: function(e) {
                                var t = (0, a.arrayify)(e), r = t.length % this.wordSize;
                                return r && (t = (0, a.concat)([
                                    t,
                                    this._padding.slice(r)
                                ])), this._writeData(t);
                            }
                        },
                        {
                            key: "_getValue",
                            value: function(e) {
                                var t = (0, a.arrayify)(s.BigNumber.from(e));
                                return t.length > this.wordSize && d.throwError("value out-of-bounds", c.Logger.errors.BUFFER_OVERRUN, {
                                    length: this.wordSize,
                                    offset: t.length
                                }), t.length % this.wordSize && (t = (0, a.concat)([
                                    this._padding.slice(t.length % this.wordSize),
                                    t
                                ])), t;
                            }
                        },
                        {
                            key: "writeValue",
                            value: function(e) {
                                return this._writeData(this._getValue(e));
                            }
                        },
                        {
                            key: "writeUpdatableValue",
                            value: function() {
                                var e = this, t = this._data.length;
                                return this._data.push(this._padding), this._dataLength += this.wordSize, function(r) {
                                    e._data[t] = e._getValue(r);
                                };
                            }
                        }
                    ]), e;
                }();
                t.Writer = h;
                var p = function() {
                    function e(t, r, n, o) {
                        (0, i.default)(this, e), (0, u.defineReadOnly)(this, "_data", (0, a.arrayify)(t)), (0, u.defineReadOnly)(this, "wordSize", r || 32), (0, u.defineReadOnly)(this, "_coerceFunc", n), (0, u.defineReadOnly)(this, "allowLoose", o), this._offset = 0;
                    }
                    return (0, o.default)(e, [
                        {
                            key: "data",
                            get: function() {
                                return (0, a.hexlify)(this._data);
                            }
                        },
                        {
                            key: "consumed",
                            get: function() {
                                return this._offset;
                            }
                        },
                        {
                            key: "coerce",
                            value: function(t, r) {
                                return this._coerceFunc ? this._coerceFunc(t, r) : e.coerce(t, r);
                            }
                        },
                        {
                            key: "_peekBytes",
                            value: function(e, t, r) {
                                var n = Math.ceil(t / this.wordSize) * this.wordSize;
                                return this._offset + n > this._data.length && (this.allowLoose && r && this._offset + t <= this._data.length ? n = t : d.throwError("data out-of-bounds", c.Logger.errors.BUFFER_OVERRUN, {
                                    length: this._data.length,
                                    offset: this._offset + n
                                })), this._data.slice(this._offset, this._offset + n);
                            }
                        },
                        {
                            key: "subReader",
                            value: function(t) {
                                return new e(this._data.slice(this._offset + t), this.wordSize, this._coerceFunc, this.allowLoose);
                            }
                        },
                        {
                            key: "readBytes",
                            value: function(e, t) {
                                var r = this._peekBytes(0, e, !!t);
                                return this._offset += r.length, r.slice(0, e);
                            }
                        },
                        {
                            key: "readValue",
                            value: function() {
                                return s.BigNumber.from(this.readBytes(this.wordSize));
                            }
                        }
                    ], [
                        {
                            key: "coerce",
                            value: function(e, t) {
                                var r = e.match("^u?int([0-9]+)$");
                                return r && parseInt(r[1]) <= 48 && (t = t.toNumber()), t;
                            }
                        }
                    ]), e;
                }();
                t.Reader = p;
            },
            49146: (e, t, r)=>{
                "use strict";
                var n = r(28847);
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.AddressCoder = void 0;
                var i = n(r(69721)), o = n(r(58985)), a = n(r(15163)), s = n(r(34650)), u = n(r(21949)), c = r(77921), f = r(908);
                var d = function(e) {
                    (0, a.default)(d, e);
                    var t, r, n = (t = d, r = function() {
                        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                        if (Reflect.construct.sham) return !1;
                        if ("function" == typeof Proxy) return !0;
                        try {
                            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                        } catch (e) {
                            return !1;
                        }
                    }(), function() {
                        var e, n = (0, u.default)(t);
                        if (r) {
                            var i = (0, u.default)(this).constructor;
                            e = Reflect.construct(n, arguments, i);
                        } else e = n.apply(this, arguments);
                        return (0, s.default)(this, e);
                    });
                    function d(e) {
                        return (0, i.default)(this, d), n.call(this, "address", "address", e, !1);
                    }
                    return (0, o.default)(d, [
                        {
                            key: "defaultValue",
                            value: function() {
                                return "0x0000000000000000000000000000000000000000";
                            }
                        },
                        {
                            key: "encode",
                            value: function(e, t) {
                                try {
                                    t = (0, c.getAddress)(t);
                                } catch (e) {
                                    this._throwError(e.message, t);
                                }
                                return e.writeValue(t);
                            }
                        },
                        {
                            key: "decode",
                            value: function(e) {
                                return (0, c.getAddress)((0, f.hexZeroPad)(e.readValue().toHexString(), 20));
                            }
                        }
                    ]), d;
                }(r(17316).Coder);
                t.AddressCoder = d;
            },
            58090: (e, t, r)=>{
                "use strict";
                var n = r(28847);
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.AnonymousCoder = void 0;
                var i = n(r(69721)), o = n(r(58985)), a = n(r(15163)), s = n(r(34650)), u = n(r(21949));
                var c = function(e) {
                    (0, a.default)(c, e);
                    var t, r, n = (t = c, r = function() {
                        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                        if (Reflect.construct.sham) return !1;
                        if ("function" == typeof Proxy) return !0;
                        try {
                            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                        } catch (e) {
                            return !1;
                        }
                    }(), function() {
                        var e, n = (0, u.default)(t);
                        if (r) {
                            var i = (0, u.default)(this).constructor;
                            e = Reflect.construct(n, arguments, i);
                        } else e = n.apply(this, arguments);
                        return (0, s.default)(this, e);
                    });
                    function c(e) {
                        var t;
                        return (0, i.default)(this, c), (t = n.call(this, e.name, e.type, void 0, e.dynamic)).coder = e, t;
                    }
                    return (0, o.default)(c, [
                        {
                            key: "defaultValue",
                            value: function() {
                                return this.coder.defaultValue();
                            }
                        },
                        {
                            key: "encode",
                            value: function(e, t) {
                                return this.coder.encode(e, t);
                            }
                        },
                        {
                            key: "decode",
                            value: function(e) {
                                return this.coder.decode(e);
                            }
                        }
                    ]), c;
                }(r(17316).Coder);
                t.AnonymousCoder = c;
            },
            4341: (e, t, r)=>{
                "use strict";
                var n = r(28847);
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.ArrayCoder = void 0, t.pack = b, t.unpack = y;
                var i = n(r(69721)), o = n(r(58985)), a = n(r(15163)), s = n(r(34650)), u = n(r(21949)), c = n(r(3355)), f = r(64327), d = r(98067), l = r(17316), h = r(58090);
                var p = new f.Logger(d.version);
                function b(e, t, r) {
                    var n = null;
                    if (Array.isArray(r)) n = r;
                    else if (r && "object" === (0, c.default)(r)) {
                        var i = {};
                        n = t.map(function(e) {
                            var t = e.localName;
                            return t || p.throwError("cannot encode object for signature with missing names", f.Logger.errors.INVALID_ARGUMENT, {
                                argument: "values",
                                coder: e,
                                value: r
                            }), i[t] && p.throwError("cannot encode object for signature with duplicate names", f.Logger.errors.INVALID_ARGUMENT, {
                                argument: "values",
                                coder: e,
                                value: r
                            }), i[t] = !0, r[t];
                        });
                    } else p.throwArgumentError("invalid tuple value", "tuple", r);
                    t.length !== n.length && p.throwArgumentError("types/value length mismatch", "tuple", r);
                    var o = new l.Writer(e.wordSize), a = new l.Writer(e.wordSize), s = [];
                    return t.forEach(function(e, t) {
                        var r = n[t];
                        if (e.dynamic) {
                            var i = a.length;
                            e.encode(a, r);
                            var u = o.writeUpdatableValue();
                            s.push(function(e) {
                                u(e + i);
                            });
                        } else e.encode(o, r);
                    }), s.forEach(function(e) {
                        e(o.length);
                    }), e.appendWriter(o) + e.appendWriter(a);
                }
                function y(e, t) {
                    var r = [], n = e.subReader(0);
                    t.forEach(function(t) {
                        var i = null;
                        if (t.dynamic) {
                            var o = e.readValue(), a = n.subReader(o.toNumber());
                            try {
                                i = t.decode(a);
                            } catch (e) {
                                if (e.code === f.Logger.errors.BUFFER_OVERRUN) throw e;
                                (i = e).baseType = t.name, i.name = t.localName, i.type = t.type;
                            }
                        } else try {
                            i = t.decode(e);
                        } catch (e) {
                            if (e.code === f.Logger.errors.BUFFER_OVERRUN) throw e;
                            (i = e).baseType = t.name, i.name = t.localName, i.type = t.type;
                        }
                        null != i && r.push(i);
                    });
                    var i = t.reduce(function(e, t) {
                        var r = t.localName;
                        return r && (e[r] || (e[r] = 0), e[r]++), e;
                    }, {});
                    t.forEach(function(e, t) {
                        var n = e.localName;
                        if (n && 1 === i[n] && ("length" === n && (n = "_length"), null == r[n])) {
                            var o = r[t];
                            o instanceof Error ? Object.defineProperty(r, n, {
                                enumerable: !0,
                                get: function() {
                                    throw o;
                                }
                            }) : r[n] = o;
                        }
                    });
                    for(var o = function(e) {
                        var t = r[e];
                        t instanceof Error && Object.defineProperty(r, e, {
                            enumerable: !0,
                            get: function() {
                                throw t;
                            }
                        });
                    }, a = 0; a < r.length; a++)o(a);
                    return Object.freeze(r);
                }
                var v = function(e) {
                    (0, a.default)(c, e);
                    var t, r, n = (t = c, r = function() {
                        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                        if (Reflect.construct.sham) return !1;
                        if ("function" == typeof Proxy) return !0;
                        try {
                            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                        } catch (e) {
                            return !1;
                        }
                    }(), function() {
                        var e, n = (0, u.default)(t);
                        if (r) {
                            var i = (0, u.default)(this).constructor;
                            e = Reflect.construct(n, arguments, i);
                        } else e = n.apply(this, arguments);
                        return (0, s.default)(this, e);
                    });
                    function c(e, t, r) {
                        var o;
                        (0, i.default)(this, c);
                        var a = e.type + "[" + (t >= 0 ? t : "") + "]", s = -1 === t || e.dynamic;
                        return (o = n.call(this, "array", a, r, s)).coder = e, o.length = t, o;
                    }
                    return (0, o.default)(c, [
                        {
                            key: "defaultValue",
                            value: function() {
                                for(var e = this.coder.defaultValue(), t = [], r = 0; r < this.length; r++)t.push(e);
                                return t;
                            }
                        },
                        {
                            key: "encode",
                            value: function(e, t) {
                                Array.isArray(t) || this._throwError("expected array value", t);
                                var r = this.length;
                                -1 === r && (r = t.length, e.writeValue(t.length)), p.checkArgumentCount(t.length, r, "coder array" + (this.localName ? " " + this.localName : ""));
                                for(var n = [], i = 0; i < t.length; i++)n.push(this.coder);
                                return b(e, n, t);
                            }
                        },
                        {
                            key: "decode",
                            value: function(e) {
                                var t = this.length;
                                -1 === t && 32 * (t = e.readValue().toNumber()) > e._data.length && p.throwError("insufficient data length", f.Logger.errors.BUFFER_OVERRUN, {
                                    length: e._data.length,
                                    count: t
                                });
                                for(var r = [], n = 0; n < t; n++)r.push(new h.AnonymousCoder(this.coder));
                                return e.coerce(this.name, y(e, r));
                            }
                        }
                    ]), c;
                }(l.Coder);
                t.ArrayCoder = v;
            },
            30024: (e, t, r)=>{
                "use strict";
                var n = r(28847);
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.BooleanCoder = void 0;
                var i = n(r(69721)), o = n(r(58985)), a = n(r(15163)), s = n(r(34650)), u = n(r(21949));
                var c = function(e) {
                    (0, a.default)(c, e);
                    var t, r, n = (t = c, r = function() {
                        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                        if (Reflect.construct.sham) return !1;
                        if ("function" == typeof Proxy) return !0;
                        try {
                            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                        } catch (e) {
                            return !1;
                        }
                    }(), function() {
                        var e, n = (0, u.default)(t);
                        if (r) {
                            var i = (0, u.default)(this).constructor;
                            e = Reflect.construct(n, arguments, i);
                        } else e = n.apply(this, arguments);
                        return (0, s.default)(this, e);
                    });
                    function c(e) {
                        return (0, i.default)(this, c), n.call(this, "bool", "bool", e, !1);
                    }
                    return (0, o.default)(c, [
                        {
                            key: "defaultValue",
                            value: function() {
                                return !1;
                            }
                        },
                        {
                            key: "encode",
                            value: function(e, t) {
                                return e.writeValue(t ? 1 : 0);
                            }
                        },
                        {
                            key: "decode",
                            value: function(e) {
                                return e.coerce(this.type, !e.readValue().isZero());
                            }
                        }
                    ]), c;
                }(r(17316).Coder);
                t.BooleanCoder = c;
            },
            53861: (e, t, r)=>{
                "use strict";
                var n = r(28847);
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.DynamicBytesCoder = t.BytesCoder = void 0;
                var i = n(r(119)), o = n(r(69721)), a = n(r(58985)), s = n(r(15163)), u = n(r(34650)), c = n(r(21949)), f = r(908);
                function d(e) {
                    var t = function() {
                        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                        if (Reflect.construct.sham) return !1;
                        if ("function" == typeof Proxy) return !0;
                        try {
                            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                        } catch (e) {
                            return !1;
                        }
                    }();
                    return function() {
                        var r, n = (0, c.default)(e);
                        if (t) {
                            var i = (0, c.default)(this).constructor;
                            r = Reflect.construct(n, arguments, i);
                        } else r = n.apply(this, arguments);
                        return (0, u.default)(this, r);
                    };
                }
                var l = function(e) {
                    (0, s.default)(r, e);
                    var t = d(r);
                    function r(e, n) {
                        return (0, o.default)(this, r), t.call(this, e, e, n, !0);
                    }
                    return (0, a.default)(r, [
                        {
                            key: "defaultValue",
                            value: function() {
                                return "0x";
                            }
                        },
                        {
                            key: "encode",
                            value: function(e, t) {
                                return t = (0, f.arrayify)(t), e.writeValue(t.length) + e.writeBytes(t);
                            }
                        },
                        {
                            key: "decode",
                            value: function(e) {
                                return e.readBytes(e.readValue().toNumber(), !0);
                            }
                        }
                    ]), r;
                }(r(17316).Coder);
                t.DynamicBytesCoder = l;
                var h = function(e) {
                    (0, s.default)(r, e);
                    var t = d(r);
                    function r(e) {
                        return (0, o.default)(this, r), t.call(this, "bytes", e);
                    }
                    return (0, a.default)(r, [
                        {
                            key: "decode",
                            value: function(e) {
                                return e.coerce(this.name, (0, f.hexlify)((0, i.default)((0, c.default)(r.prototype), "decode", this).call(this, e)));
                            }
                        }
                    ]), r;
                }(l);
                t.BytesCoder = h;
            },
            90028: (e, t, r)=>{
                "use strict";
                var n = r(28847);
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.FixedBytesCoder = void 0;
                var i = n(r(69721)), o = n(r(58985)), a = n(r(15163)), s = n(r(34650)), u = n(r(21949)), c = r(908);
                var f = function(e) {
                    (0, a.default)(f, e);
                    var t, r, n = (t = f, r = function() {
                        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                        if (Reflect.construct.sham) return !1;
                        if ("function" == typeof Proxy) return !0;
                        try {
                            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                        } catch (e) {
                            return !1;
                        }
                    }(), function() {
                        var e, n = (0, u.default)(t);
                        if (r) {
                            var i = (0, u.default)(this).constructor;
                            e = Reflect.construct(n, arguments, i);
                        } else e = n.apply(this, arguments);
                        return (0, s.default)(this, e);
                    });
                    function f(e, t) {
                        var r;
                        (0, i.default)(this, f);
                        var o = "bytes" + String(e);
                        return (r = n.call(this, o, o, t, !1)).size = e, r;
                    }
                    return (0, o.default)(f, [
                        {
                            key: "defaultValue",
                            value: function() {
                                return "0x0000000000000000000000000000000000000000000000000000000000000000".substring(0, 2 + 2 * this.size);
                            }
                        },
                        {
                            key: "encode",
                            value: function(e, t) {
                                var r = (0, c.arrayify)(t);
                                return r.length !== this.size && this._throwError("incorrect data length", t), e.writeBytes(r);
                            }
                        },
                        {
                            key: "decode",
                            value: function(e) {
                                return e.coerce(this.name, (0, c.hexlify)(e.readBytes(this.size)));
                            }
                        }
                    ]), f;
                }(r(17316).Coder);
                t.FixedBytesCoder = f;
            },
            4522: (e, t, r)=>{
                "use strict";
                var n = r(28847);
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.NullCoder = void 0;
                var i = n(r(69721)), o = n(r(58985)), a = n(r(15163)), s = n(r(34650)), u = n(r(21949));
                var c = function(e) {
                    (0, a.default)(c, e);
                    var t, r, n = (t = c, r = function() {
                        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                        if (Reflect.construct.sham) return !1;
                        if ("function" == typeof Proxy) return !0;
                        try {
                            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                        } catch (e) {
                            return !1;
                        }
                    }(), function() {
                        var e, n = (0, u.default)(t);
                        if (r) {
                            var i = (0, u.default)(this).constructor;
                            e = Reflect.construct(n, arguments, i);
                        } else e = n.apply(this, arguments);
                        return (0, s.default)(this, e);
                    });
                    function c(e) {
                        return (0, i.default)(this, c), n.call(this, "null", "", e, !1);
                    }
                    return (0, o.default)(c, [
                        {
                            key: "defaultValue",
                            value: function() {
                                return null;
                            }
                        },
                        {
                            key: "encode",
                            value: function(e, t) {
                                return null != t && this._throwError("not null", t), e.writeBytes([]);
                            }
                        },
                        {
                            key: "decode",
                            value: function(e) {
                                return e.readBytes(0), e.coerce(this.name, null);
                            }
                        }
                    ]), c;
                }(r(17316).Coder);
                t.NullCoder = c;
            },
            88287: (e, t, r)=>{
                "use strict";
                var n = r(28847);
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.NumberCoder = void 0;
                var i = n(r(69721)), o = n(r(58985)), a = n(r(15163)), s = n(r(34650)), u = n(r(21949)), c = r(34952), f = r(5465);
                var d = function(e) {
                    (0, a.default)(d, e);
                    var t, r, n = (t = d, r = function() {
                        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                        if (Reflect.construct.sham) return !1;
                        if ("function" == typeof Proxy) return !0;
                        try {
                            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                        } catch (e) {
                            return !1;
                        }
                    }(), function() {
                        var e, n = (0, u.default)(t);
                        if (r) {
                            var i = (0, u.default)(this).constructor;
                            e = Reflect.construct(n, arguments, i);
                        } else e = n.apply(this, arguments);
                        return (0, s.default)(this, e);
                    });
                    function d(e, t, r) {
                        var o;
                        (0, i.default)(this, d);
                        var a = (t ? "int" : "uint") + 8 * e;
                        return (o = n.call(this, a, a, r, !1)).size = e, o.signed = t, o;
                    }
                    return (0, o.default)(d, [
                        {
                            key: "defaultValue",
                            value: function() {
                                return 0;
                            }
                        },
                        {
                            key: "encode",
                            value: function(e, t) {
                                var r = c.BigNumber.from(t), n = f.MaxUint256.mask(8 * e.wordSize);
                                if (this.signed) {
                                    var i = n.mask(8 * this.size - 1);
                                    (r.gt(i) || r.lt(i.add(f.One).mul(f.NegativeOne))) && this._throwError("value out-of-bounds", t);
                                } else (r.lt(f.Zero) || r.gt(n.mask(8 * this.size))) && this._throwError("value out-of-bounds", t);
                                return r = r.toTwos(8 * this.size).mask(8 * this.size), this.signed && (r = r.fromTwos(8 * this.size).toTwos(8 * e.wordSize)), e.writeValue(r);
                            }
                        },
                        {
                            key: "decode",
                            value: function(e) {
                                var t = e.readValue().mask(8 * this.size);
                                return this.signed && (t = t.fromTwos(8 * this.size)), e.coerce(this.name, t);
                            }
                        }
                    ]), d;
                }(r(17316).Coder);
                t.NumberCoder = d;
            },
            48040: (e, t, r)=>{
                "use strict";
                var n = r(28847);
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.StringCoder = void 0;
                var i = n(r(69721)), o = n(r(58985)), a = n(r(119)), s = n(r(15163)), u = n(r(34650)), c = n(r(21949)), f = r(78627);
                var d = function(e) {
                    (0, s.default)(d, e);
                    var t, r, n = (t = d, r = function() {
                        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                        if (Reflect.construct.sham) return !1;
                        if ("function" == typeof Proxy) return !0;
                        try {
                            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                        } catch (e) {
                            return !1;
                        }
                    }(), function() {
                        var e, n = (0, c.default)(t);
                        if (r) {
                            var i = (0, c.default)(this).constructor;
                            e = Reflect.construct(n, arguments, i);
                        } else e = n.apply(this, arguments);
                        return (0, u.default)(this, e);
                    });
                    function d(e) {
                        return (0, i.default)(this, d), n.call(this, "string", e);
                    }
                    return (0, o.default)(d, [
                        {
                            key: "defaultValue",
                            value: function() {
                                return "";
                            }
                        },
                        {
                            key: "encode",
                            value: function(e, t) {
                                return (0, a.default)((0, c.default)(d.prototype), "encode", this).call(this, e, (0, f.toUtf8Bytes)(t));
                            }
                        },
                        {
                            key: "decode",
                            value: function(e) {
                                return (0, f.toUtf8String)((0, a.default)((0, c.default)(d.prototype), "decode", this).call(this, e));
                            }
                        }
                    ]), d;
                }(r(53861).DynamicBytesCoder);
                t.StringCoder = d;
            },
            52010: (e, t, r)=>{
                "use strict";
                var n = r(28847);
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.TupleCoder = void 0;
                var i = n(r(69721)), o = n(r(58985)), a = n(r(15163)), s = n(r(34650)), u = n(r(21949)), c = r(17316), f = r(4341);
                var d = function(e) {
                    (0, a.default)(c, e);
                    var t, r, n = (t = c, r = function() {
                        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                        if (Reflect.construct.sham) return !1;
                        if ("function" == typeof Proxy) return !0;
                        try {
                            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                        } catch (e) {
                            return !1;
                        }
                    }(), function() {
                        var e, n = (0, u.default)(t);
                        if (r) {
                            var i = (0, u.default)(this).constructor;
                            e = Reflect.construct(n, arguments, i);
                        } else e = n.apply(this, arguments);
                        return (0, s.default)(this, e);
                    });
                    function c(e, t) {
                        var r;
                        (0, i.default)(this, c);
                        var o = !1, a = [];
                        e.forEach(function(e) {
                            e.dynamic && (o = !0), a.push(e.type);
                        });
                        var s = "tuple(" + a.join(",") + ")";
                        return (r = n.call(this, "tuple", s, t, o)).coders = e, r;
                    }
                    return (0, o.default)(c, [
                        {
                            key: "defaultValue",
                            value: function() {
                                var e = [];
                                this.coders.forEach(function(t) {
                                    e.push(t.defaultValue());
                                });
                                var t = this.coders.reduce(function(e, t) {
                                    var r = t.localName;
                                    return r && (e[r] || (e[r] = 0), e[r]++), e;
                                }, {});
                                return this.coders.forEach(function(r, n) {
                                    var i = r.localName;
                                    i && 1 === t[i] && ("length" === i && (i = "_length"), null == e[i] && (e[i] = e[n]));
                                }), Object.freeze(e);
                            }
                        },
                        {
                            key: "encode",
                            value: function(e, t) {
                                return (0, f.pack)(e, this.coders, t);
                            }
                        },
                        {
                            key: "decode",
                            value: function(e) {
                                return e.coerce(this.name, (0, f.unpack)(e, this.coders));
                            }
                        }
                    ]), c;
                }(c.Coder);
                t.TupleCoder = d;
            },
            60800: (e, t, r)=>{
                "use strict";
                var n = r(28847);
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.ParamType = t.FunctionFragment = t.Fragment = t.FormatTypes = t.EventFragment = t.ErrorFragment = t.ConstructorFragment = void 0;
                var i = n(r(15163)), o = n(r(34650)), a = n(r(21949)), s = n(r(69721)), u = n(r(58985)), c = r(34952), f = r(23694), d = r(64327), l = r(98067);
                function h(e) {
                    var t = function() {
                        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                        if (Reflect.construct.sham) return !1;
                        if ("function" == typeof Proxy) return !0;
                        try {
                            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                        } catch (e) {
                            return !1;
                        }
                    }();
                    return function() {
                        var r, n = (0, a.default)(e);
                        if (t) {
                            var i = (0, a.default)(this).constructor;
                            r = Reflect.construct(n, arguments, i);
                        } else r = n.apply(this, arguments);
                        return (0, o.default)(this, r);
                    };
                }
                var p = new d.Logger(l.version), b = {}, y = {
                    calldata: !0,
                    memory: !0,
                    storage: !0
                }, v = {
                    calldata: !0,
                    memory: !0
                };
                function m(e, t) {
                    if ("bytes" === e || "string" === e) {
                        if (y[t]) return !0;
                    } else if ("address" === e) {
                        if ("payable" === t) return !0;
                    } else if ((e.indexOf("[") >= 0 || "tuple" === e) && v[t]) return !0;
                    return (y[t] || "payable" === t) && p.throwArgumentError("invalid modifier", "name", t), !1;
                }
                function g(e, t) {
                    for(var r in t)(0, f.defineReadOnly)(e, r, t[r]);
                }
                var w = Object.freeze({
                    sighash: "sighash",
                    minimal: "minimal",
                    full: "full",
                    json: "json"
                });
                t.FormatTypes = w;
                var k = new RegExp(/^(.*)\[([0-9]*)\]$/), _ = function() {
                    function e(t, r) {
                        (0, s.default)(this, e), t !== b && p.throwError("use fromString", d.Logger.errors.UNSUPPORTED_OPERATION, {
                            operation: "new ParamType()"
                        }), g(this, r);
                        var n = this.type.match(k);
                        g(this, n ? {
                            arrayLength: parseInt(n[2] || "-1"),
                            arrayChildren: e.fromObject({
                                type: n[1],
                                components: this.components
                            }),
                            baseType: "array"
                        } : {
                            arrayLength: null,
                            arrayChildren: null,
                            baseType: null != this.components ? "tuple" : this.type
                        }), this._isParamType = !0, Object.freeze(this);
                    }
                    return (0, u.default)(e, [
                        {
                            key: "format",
                            value: function(e) {
                                if (e || (e = w.sighash), w[e] || p.throwArgumentError("invalid format type", "format", e), e === w.json) {
                                    var t = {
                                        type: "tuple" === this.baseType ? "tuple" : this.type,
                                        name: this.name || void 0
                                    };
                                    return "boolean" == typeof this.indexed && (t.indexed = this.indexed), this.components && (t.components = this.components.map(function(t) {
                                        return JSON.parse(t.format(e));
                                    })), JSON.stringify(t);
                                }
                                var r = "";
                                return "array" === this.baseType ? (r += this.arrayChildren.format(e), r += "[" + (this.arrayLength < 0 ? "" : String(this.arrayLength)) + "]") : "tuple" === this.baseType ? (e !== w.sighash && (r += this.type), r += "(" + this.components.map(function(t) {
                                    return t.format(e);
                                }).join(e === w.full ? ", " : ",") + ")") : r += this.type, e !== w.sighash && (!0 === this.indexed && (r += " indexed"), e === w.full && this.name && (r += " " + this.name)), r;
                            }
                        }
                    ], [
                        {
                            key: "from",
                            value: function(t, r) {
                                return "string" == typeof t ? e.fromString(t, r) : e.fromObject(t);
                            }
                        },
                        {
                            key: "fromObject",
                            value: function(t) {
                                return e.isParamType(t) ? t : new e(b, {
                                    name: t.name || null,
                                    type: M(t.type),
                                    indexed: null == t.indexed ? null : !!t.indexed,
                                    components: t.components ? t.components.map(e.fromObject) : null
                                });
                            }
                        },
                        {
                            key: "fromString",
                            value: function(t, r) {
                                var n;
                                return n = function(e, t) {
                                    var r = e;
                                    function n(t) {
                                        p.throwArgumentError("unexpected character at position ".concat(t), "param", e);
                                    }
                                    function i(e) {
                                        var r = {
                                            type: "",
                                            name: "",
                                            parent: e,
                                            state: {
                                                allowType: !0
                                            }
                                        };
                                        return t && (r.indexed = !1), r;
                                    }
                                    e = e.replace(/\s/g, " ");
                                    for(var o = {
                                        type: "",
                                        name: "",
                                        state: {
                                            allowType: !0
                                        }
                                    }, a = o, s = 0; s < e.length; s++){
                                        var u = e[s];
                                        switch(u){
                                            case "(":
                                                a.state.allowType && "" === a.type ? a.type = "tuple" : a.state.allowParams || n(s), a.state.allowType = !1, a.type = M(a.type), a.components = [
                                                    i(a)
                                                ], a = a.components[0];
                                                break;
                                            case ")":
                                                delete a.state, "indexed" === a.name && (t || n(s), a.indexed = !0, a.name = ""), m(a.type, a.name) && (a.name = ""), a.type = M(a.type);
                                                var c = a;
                                                (a = a.parent) || n(s), delete c.parent, a.state.allowParams = !1, a.state.allowName = !0, a.state.allowArray = !0;
                                                break;
                                            case ",":
                                                delete a.state, "indexed" === a.name && (t || n(s), a.indexed = !0, a.name = ""), m(a.type, a.name) && (a.name = ""), a.type = M(a.type);
                                                var f = i(a.parent);
                                                a.parent.components.push(f), delete a.parent, a = f;
                                                break;
                                            case " ":
                                                a.state.allowType && "" !== a.type && (a.type = M(a.type), delete a.state.allowType, a.state.allowName = !0, a.state.allowParams = !0), a.state.allowName && "" !== a.name && ("indexed" === a.name ? (t || n(s), a.indexed && n(s), a.indexed = !0, a.name = "") : m(a.type, a.name) ? a.name = "" : a.state.allowName = !1);
                                                break;
                                            case "[":
                                                a.state.allowArray || n(s), a.type += u, a.state.allowArray = !1, a.state.allowName = !1, a.state.readArray = !0;
                                                break;
                                            case "]":
                                                a.state.readArray || n(s), a.type += u, a.state.readArray = !1, a.state.allowArray = !0, a.state.allowName = !0;
                                                break;
                                            default:
                                                a.state.allowType ? (a.type += u, a.state.allowParams = !0, a.state.allowArray = !0) : a.state.allowName ? (a.name += u, delete a.state.allowArray) : a.state.readArray ? a.type += u : n(s);
                                        }
                                    }
                                    return a.parent && p.throwArgumentError("unexpected eof", "param", e), delete o.state, "indexed" === a.name ? (t || n(r.length - 7), a.indexed && n(r.length - 7), a.indexed = !0, a.name = "") : m(a.type, a.name) && (a.name = ""), o.type = M(o.type), o;
                                }(t, !!r), e.fromObject({
                                    name: n.name,
                                    type: n.type,
                                    indexed: n.indexed,
                                    components: n.components
                                });
                            }
                        },
                        {
                            key: "isParamType",
                            value: function(e) {
                                return !(null == e || !e._isParamType);
                            }
                        }
                    ]), e;
                }();
                function A(e, t) {
                    return (function(e) {
                        e = e.trim();
                        for(var t = [], r = "", n = 0, i = 0; i < e.length; i++){
                            var o = e[i];
                            "," === o && 0 === n ? (t.push(r), r = "") : (r += o, "(" === o ? n++ : ")" === o && -1 == --n && p.throwArgumentError("unbalanced parenthesis", "value", e));
                        }
                        return r && t.push(r), t;
                    })(e).map(function(e) {
                        return _.fromString(e, t);
                    });
                }
                t.ParamType = _;
                var E = function() {
                    function e(t, r) {
                        (0, s.default)(this, e), t !== b && p.throwError("use a static from method", d.Logger.errors.UNSUPPORTED_OPERATION, {
                            operation: "new Fragment()"
                        }), g(this, r), this._isFragment = !0, Object.freeze(this);
                    }
                    return (0, u.default)(e, null, [
                        {
                            key: "from",
                            value: function(t) {
                                return e.isFragment(t) ? t : "string" == typeof t ? e.fromString(t) : e.fromObject(t);
                            }
                        },
                        {
                            key: "fromObject",
                            value: function(t) {
                                if (e.isFragment(t)) return t;
                                switch(t.type){
                                    case "function":
                                        return I.fromObject(t);
                                    case "event":
                                        return S.fromObject(t);
                                    case "constructor":
                                        return P.fromObject(t);
                                    case "error":
                                        return C.fromObject(t);
                                    case "fallback":
                                    case "receive":
                                        return null;
                                }
                                return p.throwArgumentError("invalid fragment object", "value", t);
                            }
                        },
                        {
                            key: "fromString",
                            value: function(e) {
                                return "event" === (e = (e = (e = e.replace(/\s/g, " ")).replace(/\(/g, " (").replace(/\)/g, ") ").replace(/\s+/g, " ")).trim()).split(" ")[0] ? S.fromString(e.substring(5).trim()) : "function" === e.split(" ")[0] ? I.fromString(e.substring(8).trim()) : "constructor" === e.split("(")[0].trim() ? P.fromString(e.trim()) : "error" === e.split(" ")[0] ? C.fromString(e.substring(5).trim()) : p.throwArgumentError("unsupported fragment", "value", e);
                            }
                        },
                        {
                            key: "isFragment",
                            value: function(e) {
                                return !(!e || !e._isFragment);
                            }
                        }
                    ]), e;
                }();
                t.Fragment = E;
                var S = function(e) {
                    (0, i.default)(r, e);
                    var t = h(r);
                    function r() {
                        return (0, s.default)(this, r), t.apply(this, arguments);
                    }
                    return (0, u.default)(r, [
                        {
                            key: "format",
                            value: function(e) {
                                if (e || (e = w.sighash), w[e] || p.throwArgumentError("invalid format type", "format", e), e === w.json) return JSON.stringify({
                                    type: "event",
                                    anonymous: this.anonymous,
                                    name: this.name,
                                    inputs: this.inputs.map(function(t) {
                                        return JSON.parse(t.format(e));
                                    })
                                });
                                var t = "";
                                return e !== w.sighash && (t += "event "), t += this.name + "(" + this.inputs.map(function(t) {
                                    return t.format(e);
                                }).join(e === w.full ? ", " : ",") + ") ", e !== w.sighash && this.anonymous && (t += "anonymous "), t.trim();
                            }
                        }
                    ], [
                        {
                            key: "from",
                            value: function(e) {
                                return "string" == typeof e ? r.fromString(e) : r.fromObject(e);
                            }
                        },
                        {
                            key: "fromObject",
                            value: function(e) {
                                if (r.isEventFragment(e)) return e;
                                "event" !== e.type && p.throwArgumentError("invalid event object", "value", e);
                                var t = {
                                    name: U(e.name),
                                    anonymous: e.anonymous,
                                    inputs: e.inputs ? e.inputs.map(_.fromObject) : [],
                                    type: "event"
                                };
                                return new r(b, t);
                            }
                        },
                        {
                            key: "fromString",
                            value: function(e) {
                                var t = e.match(N);
                                t || p.throwArgumentError("invalid event string", "value", e);
                                var n = !1;
                                return t[3].split(" ").forEach(function(e) {
                                    switch(e.trim()){
                                        case "anonymous":
                                            n = !0;
                                            break;
                                        case "":
                                            break;
                                        default:
                                            p.warn("unknown modifier: " + e);
                                    }
                                }), r.fromObject({
                                    name: t[1].trim(),
                                    anonymous: n,
                                    inputs: A(t[2], !0),
                                    type: "event"
                                });
                            }
                        },
                        {
                            key: "isEventFragment",
                            value: function(e) {
                                return e && e._isFragment && "event" === e.type;
                            }
                        }
                    ]), r;
                }(E);
                function x(e, t) {
                    t.gas = null;
                    var r = e.split("@");
                    return 1 !== r.length ? (r.length > 2 && p.throwArgumentError("invalid human-readable ABI signature", "value", e), r[1].match(/^[0-9]+$/) || p.throwArgumentError("invalid human-readable ABI signature gas", "value", e), t.gas = c.BigNumber.from(r[1]), r[0]) : e;
                }
                function B(e, t) {
                    t.constant = !1, t.payable = !1, t.stateMutability = "nonpayable", e.split(" ").forEach(function(e) {
                        switch(e.trim()){
                            case "constant":
                                t.constant = !0;
                                break;
                            case "payable":
                                t.payable = !0, t.stateMutability = "payable";
                                break;
                            case "nonpayable":
                                t.payable = !1, t.stateMutability = "nonpayable";
                                break;
                            case "pure":
                                t.constant = !0, t.stateMutability = "pure";
                                break;
                            case "view":
                                t.constant = !0, t.stateMutability = "view";
                                break;
                            case "external":
                            case "public":
                            case "":
                                break;
                            default:
                                console.log("unknown modifier: " + e);
                        }
                    });
                }
                function O(e) {
                    var t = {
                        constant: !1,
                        payable: !0,
                        stateMutability: "payable"
                    };
                    return null != e.stateMutability ? (t.stateMutability = e.stateMutability, t.constant = "view" === t.stateMutability || "pure" === t.stateMutability, null != e.constant && !!e.constant !== t.constant && p.throwArgumentError("cannot have constant function with mutability " + t.stateMutability, "value", e), t.payable = "payable" === t.stateMutability, null != e.payable && !!e.payable !== t.payable && p.throwArgumentError("cannot have payable function with mutability " + t.stateMutability, "value", e)) : null != e.payable ? (t.payable = !!e.payable, null != e.constant || t.payable || "constructor" === e.type || p.throwArgumentError("unable to determine stateMutability", "value", e), t.constant = !!e.constant, t.constant ? t.stateMutability = "view" : t.stateMutability = t.payable ? "payable" : "nonpayable", t.payable && t.constant && p.throwArgumentError("cannot have constant payable function", "value", e)) : null != e.constant ? (t.constant = !!e.constant, t.payable = !t.constant, t.stateMutability = t.constant ? "view" : "payable") : "constructor" !== e.type && p.throwArgumentError("unable to determine stateMutability", "value", e), t;
                }
                t.EventFragment = S;
                var P = function(e) {
                    (0, i.default)(r, e);
                    var t = h(r);
                    function r() {
                        return (0, s.default)(this, r), t.apply(this, arguments);
                    }
                    return (0, u.default)(r, [
                        {
                            key: "format",
                            value: function(e) {
                                if (e || (e = w.sighash), w[e] || p.throwArgumentError("invalid format type", "format", e), e === w.json) return JSON.stringify({
                                    type: "constructor",
                                    stateMutability: "nonpayable" !== this.stateMutability ? this.stateMutability : void 0,
                                    payable: this.payable,
                                    gas: this.gas ? this.gas.toNumber() : void 0,
                                    inputs: this.inputs.map(function(t) {
                                        return JSON.parse(t.format(e));
                                    })
                                });
                                e === w.sighash && p.throwError("cannot format a constructor for sighash", d.Logger.errors.UNSUPPORTED_OPERATION, {
                                    operation: "format(sighash)"
                                });
                                var t = "constructor(" + this.inputs.map(function(t) {
                                    return t.format(e);
                                }).join(e === w.full ? ", " : ",") + ") ";
                                return this.stateMutability && "nonpayable" !== this.stateMutability && (t += this.stateMutability + " "), t.trim();
                            }
                        }
                    ], [
                        {
                            key: "from",
                            value: function(e) {
                                return "string" == typeof e ? r.fromString(e) : r.fromObject(e);
                            }
                        },
                        {
                            key: "fromObject",
                            value: function(e) {
                                if (r.isConstructorFragment(e)) return e;
                                "constructor" !== e.type && p.throwArgumentError("invalid constructor object", "value", e);
                                var t = O(e);
                                t.constant && p.throwArgumentError("constructor cannot be constant", "value", e);
                                var n = {
                                    name: null,
                                    type: e.type,
                                    inputs: e.inputs ? e.inputs.map(_.fromObject) : [],
                                    payable: t.payable,
                                    stateMutability: t.stateMutability,
                                    gas: e.gas ? c.BigNumber.from(e.gas) : null
                                };
                                return new r(b, n);
                            }
                        },
                        {
                            key: "fromString",
                            value: function(e) {
                                var t = {
                                    type: "constructor"
                                }, n = (e = x(e, t)).match(N);
                                return n && "constructor" === n[1].trim() || p.throwArgumentError("invalid constructor string", "value", e), t.inputs = A(n[2].trim(), !1), B(n[3].trim(), t), r.fromObject(t);
                            }
                        },
                        {
                            key: "isConstructorFragment",
                            value: function(e) {
                                return e && e._isFragment && "constructor" === e.type;
                            }
                        }
                    ]), r;
                }(E);
                t.ConstructorFragment = P;
                var I = function(e) {
                    (0, i.default)(r, e);
                    var t = h(r);
                    function r() {
                        return (0, s.default)(this, r), t.apply(this, arguments);
                    }
                    return (0, u.default)(r, [
                        {
                            key: "format",
                            value: function(e) {
                                if (e || (e = w.sighash), w[e] || p.throwArgumentError("invalid format type", "format", e), e === w.json) return JSON.stringify({
                                    type: "function",
                                    name: this.name,
                                    constant: this.constant,
                                    stateMutability: "nonpayable" !== this.stateMutability ? this.stateMutability : void 0,
                                    payable: this.payable,
                                    gas: this.gas ? this.gas.toNumber() : void 0,
                                    inputs: this.inputs.map(function(t) {
                                        return JSON.parse(t.format(e));
                                    }),
                                    outputs: this.outputs.map(function(t) {
                                        return JSON.parse(t.format(e));
                                    })
                                });
                                var t = "";
                                return e !== w.sighash && (t += "function "), t += this.name + "(" + this.inputs.map(function(t) {
                                    return t.format(e);
                                }).join(e === w.full ? ", " : ",") + ") ", e !== w.sighash && (this.stateMutability ? "nonpayable" !== this.stateMutability && (t += this.stateMutability + " ") : this.constant && (t += "view "), this.outputs && this.outputs.length && (t += "returns (" + this.outputs.map(function(t) {
                                    return t.format(e);
                                }).join(", ") + ") "), null != this.gas && (t += "@" + this.gas.toString() + " ")), t.trim();
                            }
                        }
                    ], [
                        {
                            key: "from",
                            value: function(e) {
                                return "string" == typeof e ? r.fromString(e) : r.fromObject(e);
                            }
                        },
                        {
                            key: "fromObject",
                            value: function(e) {
                                if (r.isFunctionFragment(e)) return e;
                                "function" !== e.type && p.throwArgumentError("invalid function object", "value", e);
                                var t = O(e), n = {
                                    type: e.type,
                                    name: U(e.name),
                                    constant: t.constant,
                                    inputs: e.inputs ? e.inputs.map(_.fromObject) : [],
                                    outputs: e.outputs ? e.outputs.map(_.fromObject) : [],
                                    payable: t.payable,
                                    stateMutability: t.stateMutability,
                                    gas: e.gas ? c.BigNumber.from(e.gas) : null
                                };
                                return new r(b, n);
                            }
                        },
                        {
                            key: "fromString",
                            value: function(e) {
                                var t = {
                                    type: "function"
                                }, n = (e = x(e, t)).split(" returns ");
                                n.length > 2 && p.throwArgumentError("invalid function string", "value", e);
                                var i = n[0].match(N);
                                if (i || p.throwArgumentError("invalid function signature", "value", e), t.name = i[1].trim(), t.name && U(t.name), t.inputs = A(i[2], !1), B(i[3].trim(), t), n.length > 1) {
                                    var o = n[1].match(N);
                                    "" == o[1].trim() && "" == o[3].trim() || p.throwArgumentError("unexpected tokens", "value", e), t.outputs = A(o[2], !1);
                                } else t.outputs = [];
                                return r.fromObject(t);
                            }
                        },
                        {
                            key: "isFunctionFragment",
                            value: function(e) {
                                return e && e._isFragment && "function" === e.type;
                            }
                        }
                    ]), r;
                }(P);
                function T(e) {
                    var t = e.format();
                    return "Error(string)" !== t && "Panic(uint256)" !== t || p.throwArgumentError("cannot specify user defined ".concat(t, " error"), "fragment", e), e;
                }
                t.FunctionFragment = I;
                var C = function(e) {
                    (0, i.default)(r, e);
                    var t = h(r);
                    function r() {
                        return (0, s.default)(this, r), t.apply(this, arguments);
                    }
                    return (0, u.default)(r, [
                        {
                            key: "format",
                            value: function(e) {
                                if (e || (e = w.sighash), w[e] || p.throwArgumentError("invalid format type", "format", e), e === w.json) return JSON.stringify({
                                    type: "error",
                                    name: this.name,
                                    inputs: this.inputs.map(function(t) {
                                        return JSON.parse(t.format(e));
                                    })
                                });
                                var t = "";
                                return e !== w.sighash && (t += "error "), (t += this.name + "(" + this.inputs.map(function(t) {
                                    return t.format(e);
                                }).join(e === w.full ? ", " : ",") + ") ").trim();
                            }
                        }
                    ], [
                        {
                            key: "from",
                            value: function(e) {
                                return "string" == typeof e ? r.fromString(e) : r.fromObject(e);
                            }
                        },
                        {
                            key: "fromObject",
                            value: function(e) {
                                if (r.isErrorFragment(e)) return e;
                                "error" !== e.type && p.throwArgumentError("invalid error object", "value", e);
                                var t = {
                                    type: e.type,
                                    name: U(e.name),
                                    inputs: e.inputs ? e.inputs.map(_.fromObject) : []
                                };
                                return T(new r(b, t));
                            }
                        },
                        {
                            key: "fromString",
                            value: function(e) {
                                var t = {
                                    type: "error"
                                }, n = e.match(N);
                                return n || p.throwArgumentError("invalid error signature", "value", e), t.name = n[1].trim(), t.name && U(t.name), t.inputs = A(n[2], !1), T(r.fromObject(t));
                            }
                        },
                        {
                            key: "isErrorFragment",
                            value: function(e) {
                                return e && e._isFragment && "error" === e.type;
                            }
                        }
                    ]), r;
                }(E);
                function M(e) {
                    return e.match(/^uint($|[^1-9])/) ? e = "uint256" + e.substring(4) : e.match(/^int($|[^1-9])/) && (e = "int256" + e.substring(3)), e;
                }
                t.ErrorFragment = C;
                var R = new RegExp("^[a-zA-Z$_][a-zA-Z0-9$_]*$");
                function U(e) {
                    return e && e.match(R) || p.throwArgumentError('invalid identifier "'.concat(e, '"'), "value", e), e;
                }
                var N = new RegExp("^([^)(]*)\\((.*)\\)([^)(]*)$");
            },
            62914: (e, t, r)=>{
                "use strict";
                Object.defineProperty(t, "RQ", {
                    enumerable: !0,
                    get: function() {
                        return i.AbiCoder;
                    }
                }), Object.defineProperty(t, "_R", {
                    enumerable: !0,
                    get: function() {
                        return n.ParamType;
                    }
                });
                var n = r(60800), i = r(44937);
                r(69044);
            },
            69044: (e, t, r)=>{
                "use strict";
                var n = r(28847);
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.TransactionDescription = t.LogDescription = t.Interface = t.Indexed = t.ErrorDescription = void 0, Object.defineProperty(t, "checkResultErrors", {
                    enumerable: !0,
                    get: function() {
                        return y.checkResultErrors;
                    }
                });
                var i = n(r(58985)), o = n(r(69721)), a = n(r(15163)), s = n(r(34650)), u = n(r(21949)), c = r(77921), f = r(34952), d = r(908), l = r(37515), h = r(64642), p = r(23694), b = r(44937), y = r(17316), v = r(60800), m = r(64327), g = r(98067);
                function w(e) {
                    var t = function() {
                        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                        if (Reflect.construct.sham) return !1;
                        if ("function" == typeof Proxy) return !0;
                        try {
                            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                        } catch (e) {
                            return !1;
                        }
                    }();
                    return function() {
                        var r, n = (0, u.default)(e);
                        if (t) {
                            var i = (0, u.default)(this).constructor;
                            r = Reflect.construct(n, arguments, i);
                        } else r = n.apply(this, arguments);
                        return (0, s.default)(this, r);
                    };
                }
                var k = new m.Logger(g.version), _ = function(e) {
                    (0, a.default)(r, e);
                    var t = w(r);
                    function r() {
                        return (0, o.default)(this, r), t.apply(this, arguments);
                    }
                    return (0, i.default)(r);
                }(p.Description);
                t.LogDescription = _;
                var A = function(e) {
                    (0, a.default)(r, e);
                    var t = w(r);
                    function r() {
                        return (0, o.default)(this, r), t.apply(this, arguments);
                    }
                    return (0, i.default)(r);
                }(p.Description);
                t.TransactionDescription = A;
                var E = function(e) {
                    (0, a.default)(r, e);
                    var t = w(r);
                    function r() {
                        return (0, o.default)(this, r), t.apply(this, arguments);
                    }
                    return (0, i.default)(r);
                }(p.Description);
                t.ErrorDescription = E;
                var S = function(e) {
                    (0, a.default)(r, e);
                    var t = w(r);
                    function r() {
                        return (0, o.default)(this, r), t.apply(this, arguments);
                    }
                    return (0, i.default)(r, null, [
                        {
                            key: "isIndexed",
                            value: function(e) {
                                return !(!e || !e._isIndexed);
                            }
                        }
                    ]), r;
                }(p.Description);
                t.Indexed = S;
                var x = {
                    "0x08c379a0": {
                        signature: "Error(string)",
                        name: "Error",
                        inputs: [
                            "string"
                        ],
                        reason: !0
                    },
                    "0x4e487b71": {
                        signature: "Panic(uint256)",
                        name: "Panic",
                        inputs: [
                            "uint256"
                        ]
                    }
                };
                function B(e, t) {
                    var r = new Error("deferred error during ABI decoding triggered accessing ".concat(e));
                    return r.error = t, r;
                }
                var O = function() {
                    function e(t) {
                        var r = this;
                        (0, o.default)(this, e);
                        var n = [];
                        n = "string" == typeof t ? JSON.parse(t) : t, (0, p.defineReadOnly)(this, "fragments", n.map(function(e) {
                            return v.Fragment.from(e);
                        }).filter(function(e) {
                            return null != e;
                        })), (0, p.defineReadOnly)(this, "_abiCoder", (0, p.getStatic)(this instanceof e ? this.constructor : void 0, "getAbiCoder")()), (0, p.defineReadOnly)(this, "functions", {}), (0, p.defineReadOnly)(this, "errors", {}), (0, p.defineReadOnly)(this, "events", {}), (0, p.defineReadOnly)(this, "structs", {}), this.fragments.forEach(function(e) {
                            var t = null;
                            switch(e.type){
                                case "constructor":
                                    return r.deploy ? void k.warn("duplicate definition - constructor") : void (0, p.defineReadOnly)(r, "deploy", e);
                                case "function":
                                    t = r.functions;
                                    break;
                                case "event":
                                    t = r.events;
                                    break;
                                case "error":
                                    t = r.errors;
                                    break;
                                default:
                                    return;
                            }
                            var n = e.format();
                            t[n] ? k.warn("duplicate definition - " + n) : t[n] = e;
                        }), this.deploy || (0, p.defineReadOnly)(this, "deploy", v.ConstructorFragment.from({
                            payable: !1,
                            type: "constructor"
                        })), (0, p.defineReadOnly)(this, "_isInterface", !0);
                    }
                    return (0, i.default)(e, [
                        {
                            key: "format",
                            value: function(e) {
                                e || (e = v.FormatTypes.full), e === v.FormatTypes.sighash && k.throwArgumentError("interface does not support formatting sighash", "format", e);
                                var t = this.fragments.map(function(t) {
                                    return t.format(e);
                                });
                                return e === v.FormatTypes.json ? JSON.stringify(t.map(function(e) {
                                    return JSON.parse(e);
                                })) : t;
                            }
                        },
                        {
                            key: "getFunction",
                            value: function(e) {
                                if ((0, d.isHexString)(e)) {
                                    for(var t in this.functions)if (e === this.getSighash(t)) return this.functions[t];
                                    k.throwArgumentError("no matching function", "sighash", e);
                                }
                                if (-1 === e.indexOf("(")) {
                                    var r = e.trim(), n = Object.keys(this.functions).filter(function(e) {
                                        return e.split("(")[0] === r;
                                    });
                                    return 0 === n.length ? k.throwArgumentError("no matching function", "name", r) : n.length > 1 && k.throwArgumentError("multiple matching functions", "name", r), this.functions[n[0]];
                                }
                                var i = this.functions[v.FunctionFragment.fromString(e).format()];
                                return i || k.throwArgumentError("no matching function", "signature", e), i;
                            }
                        },
                        {
                            key: "getEvent",
                            value: function(e) {
                                if ((0, d.isHexString)(e)) {
                                    var t = e.toLowerCase();
                                    for(var r in this.events)if (t === this.getEventTopic(r)) return this.events[r];
                                    k.throwArgumentError("no matching event", "topichash", t);
                                }
                                if (-1 === e.indexOf("(")) {
                                    var n = e.trim(), i = Object.keys(this.events).filter(function(e) {
                                        return e.split("(")[0] === n;
                                    });
                                    return 0 === i.length ? k.throwArgumentError("no matching event", "name", n) : i.length > 1 && k.throwArgumentError("multiple matching events", "name", n), this.events[i[0]];
                                }
                                var o = this.events[v.EventFragment.fromString(e).format()];
                                return o || k.throwArgumentError("no matching event", "signature", e), o;
                            }
                        },
                        {
                            key: "getError",
                            value: function(e) {
                                if ((0, d.isHexString)(e)) {
                                    var t = (0, p.getStatic)(this.constructor, "getSighash");
                                    for(var r in this.errors)if (e === t(this.errors[r])) return this.errors[r];
                                    k.throwArgumentError("no matching error", "sighash", e);
                                }
                                if (-1 === e.indexOf("(")) {
                                    var n = e.trim(), i = Object.keys(this.errors).filter(function(e) {
                                        return e.split("(")[0] === n;
                                    });
                                    return 0 === i.length ? k.throwArgumentError("no matching error", "name", n) : i.length > 1 && k.throwArgumentError("multiple matching errors", "name", n), this.errors[i[0]];
                                }
                                var o = this.errors[v.FunctionFragment.fromString(e).format()];
                                return o || k.throwArgumentError("no matching error", "signature", e), o;
                            }
                        },
                        {
                            key: "getSighash",
                            value: function(e) {
                                if ("string" == typeof e) try {
                                    e = this.getFunction(e);
                                } catch (t) {
                                    try {
                                        e = this.getError(e);
                                    } catch (e) {
                                        throw t;
                                    }
                                }
                                return (0, p.getStatic)(this.constructor, "getSighash")(e);
                            }
                        },
                        {
                            key: "getEventTopic",
                            value: function(e) {
                                return "string" == typeof e && (e = this.getEvent(e)), (0, p.getStatic)(this.constructor, "getEventTopic")(e);
                            }
                        },
                        {
                            key: "_decodeParams",
                            value: function(e, t) {
                                return this._abiCoder.decode(e, t);
                            }
                        },
                        {
                            key: "_encodeParams",
                            value: function(e, t) {
                                return this._abiCoder.encode(e, t);
                            }
                        },
                        {
                            key: "encodeDeploy",
                            value: function(e) {
                                return this._encodeParams(this.deploy.inputs, e || []);
                            }
                        },
                        {
                            key: "decodeErrorResult",
                            value: function(e, t) {
                                "string" == typeof e && (e = this.getError(e));
                                var r = (0, d.arrayify)(t);
                                return (0, d.hexlify)(r.slice(0, 4)) !== this.getSighash(e) && k.throwArgumentError("data signature does not match error ".concat(e.name, "."), "data", (0, d.hexlify)(r)), this._decodeParams(e.inputs, r.slice(4));
                            }
                        },
                        {
                            key: "encodeErrorResult",
                            value: function(e, t) {
                                return "string" == typeof e && (e = this.getError(e)), (0, d.hexlify)((0, d.concat)([
                                    this.getSighash(e),
                                    this._encodeParams(e.inputs, t || [])
                                ]));
                            }
                        },
                        {
                            key: "decodeFunctionData",
                            value: function(e, t) {
                                "string" == typeof e && (e = this.getFunction(e));
                                var r = (0, d.arrayify)(t);
                                return (0, d.hexlify)(r.slice(0, 4)) !== this.getSighash(e) && k.throwArgumentError("data signature does not match function ".concat(e.name, "."), "data", (0, d.hexlify)(r)), this._decodeParams(e.inputs, r.slice(4));
                            }
                        },
                        {
                            key: "encodeFunctionData",
                            value: function(e, t) {
                                return "string" == typeof e && (e = this.getFunction(e)), (0, d.hexlify)((0, d.concat)([
                                    this.getSighash(e),
                                    this._encodeParams(e.inputs, t || [])
                                ]));
                            }
                        },
                        {
                            key: "decodeFunctionResult",
                            value: function(e, t) {
                                "string" == typeof e && (e = this.getFunction(e));
                                var r = (0, d.arrayify)(t), n = null, i = "", o = null, a = null, s = null;
                                switch(r.length % this._abiCoder._getWordSize()){
                                    case 0:
                                        try {
                                            return this._abiCoder.decode(e.outputs, r);
                                        } catch (f) {}
                                        break;
                                    case 4:
                                        var u = (0, d.hexlify)(r.slice(0, 4)), c = x[u];
                                        if (c) o = this._abiCoder.decode(c.inputs, r.slice(4)), a = c.name, s = c.signature, c.reason && (n = o[0]), "Error" === a ? i = "; VM Exception while processing transaction: reverted with reason string ".concat(JSON.stringify(o[0])) : "Panic" === a && (i = "; VM Exception while processing transaction: reverted with panic code ".concat(o[0]));
                                        else try {
                                            var f = this.getError(u);
                                            o = this._abiCoder.decode(f.inputs, r.slice(4)), a = f.name, s = f.format();
                                        } catch (f) {}
                                }
                                return k.throwError("call revert exception" + i, m.Logger.errors.CALL_EXCEPTION, {
                                    method: e.format(),
                                    data: (0, d.hexlify)(t),
                                    errorArgs: o,
                                    errorName: a,
                                    errorSignature: s,
                                    reason: n
                                });
                            }
                        },
                        {
                            key: "encodeFunctionResult",
                            value: function(e, t) {
                                return "string" == typeof e && (e = this.getFunction(e)), (0, d.hexlify)(this._abiCoder.encode(e.outputs, t || []));
                            }
                        },
                        {
                            key: "encodeFilterTopics",
                            value: function(e, t) {
                                var r = this;
                                "string" == typeof e && (e = this.getEvent(e)), t.length > e.inputs.length && k.throwError("too many arguments for " + e.format(), m.Logger.errors.UNEXPECTED_ARGUMENT, {
                                    argument: "values",
                                    value: t
                                });
                                var n = [];
                                e.anonymous || n.push(this.getEventTopic(e));
                                var i = function(e, t) {
                                    return "string" === e.type ? (0, l.id)(t) : "bytes" === e.type ? (0, h.keccak256)((0, d.hexlify)(t)) : ("bool" === e.type && "boolean" == typeof t && (t = t ? "0x01" : "0x00"), e.type.match(/^u?int/) && (t = f.BigNumber.from(t).toHexString()), "address" === e.type && r._abiCoder.encode([
                                        "address"
                                    ], [
                                        t
                                    ]), (0, d.hexZeroPad)((0, d.hexlify)(t), 32));
                                };
                                for(t.forEach(function(t, r) {
                                    var o = e.inputs[r];
                                    o.indexed ? null == t ? n.push(null) : "array" === o.baseType || "tuple" === o.baseType ? k.throwArgumentError("filtering with tuples or arrays not supported", "contract." + o.name, t) : Array.isArray(t) ? n.push(t.map(function(e) {
                                        return i(o, e);
                                    })) : n.push(i(o, t)) : null != t && k.throwArgumentError("cannot filter non-indexed parameters; must be null", "contract." + o.name, t);
                                }); n.length && null === n[n.length - 1];)n.pop();
                                return n;
                            }
                        },
                        {
                            key: "encodeEventLog",
                            value: function(e, t) {
                                var r = this;
                                "string" == typeof e && (e = this.getEvent(e));
                                var n = [], i = [], o = [];
                                return e.anonymous || n.push(this.getEventTopic(e)), t.length !== e.inputs.length && k.throwArgumentError("event arguments/values mismatch", "values", t), e.inputs.forEach(function(e, a) {
                                    var s = t[a];
                                    if (e.indexed) {
                                        if ("string" === e.type) n.push((0, l.id)(s));
                                        else if ("bytes" === e.type) n.push((0, h.keccak256)(s));
                                        else {
                                            if ("tuple" === e.baseType || "array" === e.baseType) throw new Error("not implemented");
                                            n.push(r._abiCoder.encode([
                                                e.type
                                            ], [
                                                s
                                            ]));
                                        }
                                    } else i.push(e), o.push(s);
                                }), {
                                    data: this._abiCoder.encode(i, o),
                                    topics: n
                                };
                            }
                        },
                        {
                            key: "decodeEventLog",
                            value: function(e, t, r) {
                                if ("string" == typeof e && (e = this.getEvent(e)), null != r && !e.anonymous) {
                                    var n = this.getEventTopic(e);
                                    (0, d.isHexString)(r[0], 32) && r[0].toLowerCase() === n || k.throwError("fragment/topic mismatch", m.Logger.errors.INVALID_ARGUMENT, {
                                        argument: "topics[0]",
                                        expected: n,
                                        value: r[0]
                                    }), r = r.slice(1);
                                }
                                var i = [], o = [], a = [];
                                e.inputs.forEach(function(e, t) {
                                    e.indexed ? "string" === e.type || "bytes" === e.type || "tuple" === e.baseType || "array" === e.baseType ? (i.push(v.ParamType.fromObject({
                                        type: "bytes32",
                                        name: e.name
                                    })), a.push(!0)) : (i.push(e), a.push(!1)) : (o.push(e), a.push(!1));
                                });
                                var s = null != r ? this._abiCoder.decode(i, (0, d.concat)(r)) : null, u = this._abiCoder.decode(o, t, !0), c = [], f = 0, l = 0;
                                e.inputs.forEach(function(e, t) {
                                    if (e.indexed) {
                                        if (null == s) c[t] = new S({
                                            _isIndexed: !0,
                                            hash: null
                                        });
                                        else if (a[t]) c[t] = new S({
                                            _isIndexed: !0,
                                            hash: s[l++]
                                        });
                                        else try {
                                            c[t] = s[l++];
                                        } catch (e) {
                                            c[t] = e;
                                        }
                                    } else try {
                                        c[t] = u[f++];
                                    } catch (e) {
                                        c[t] = e;
                                    }
                                    if (e.name && null == c[e.name]) {
                                        var r = c[t];
                                        r instanceof Error ? Object.defineProperty(c, e.name, {
                                            enumerable: !0,
                                            get: function() {
                                                throw B("property ".concat(JSON.stringify(e.name)), r);
                                            }
                                        }) : c[e.name] = r;
                                    }
                                });
                                for(var h = function(e) {
                                    var t = c[e];
                                    t instanceof Error && Object.defineProperty(c, e, {
                                        enumerable: !0,
                                        get: function() {
                                            throw B("index ".concat(e), t);
                                        }
                                    });
                                }, p = 0; p < c.length; p++)h(p);
                                return Object.freeze(c);
                            }
                        },
                        {
                            key: "parseTransaction",
                            value: function(e) {
                                var t = this.getFunction(e.data.substring(0, 10).toLowerCase());
                                return t ? new A({
                                    args: this._abiCoder.decode(t.inputs, "0x" + e.data.substring(10)),
                                    functionFragment: t,
                                    name: t.name,
                                    signature: t.format(),
                                    sighash: this.getSighash(t),
                                    value: f.BigNumber.from(e.value || "0")
                                }) : null;
                            }
                        },
                        {
                            key: "parseLog",
                            value: function(e) {
                                var t = this.getEvent(e.topics[0]);
                                return !t || t.anonymous ? null : new _({
                                    eventFragment: t,
                                    name: t.name,
                                    signature: t.format(),
                                    topic: this.getEventTopic(t),
                                    args: this.decodeEventLog(t, e.data, e.topics)
                                });
                            }
                        },
                        {
                            key: "parseError",
                            value: function(e) {
                                var t = (0, d.hexlify)(e), r = this.getError(t.substring(0, 10).toLowerCase());
                                return r ? new E({
                                    args: this._abiCoder.decode(r.inputs, "0x" + t.substring(10)),
                                    errorFragment: r,
                                    name: r.name,
                                    signature: r.format(),
                                    sighash: this.getSighash(r)
                                }) : null;
                            }
                        }
                    ], [
                        {
                            key: "getAbiCoder",
                            value: function() {
                                return b.defaultAbiCoder;
                            }
                        },
                        {
                            key: "getAddress",
                            value: function(e) {
                                return (0, c.getAddress)(e);
                            }
                        },
                        {
                            key: "getSighash",
                            value: function(e) {
                                return (0, d.hexDataSlice)((0, l.id)(e.format()), 0, 4);
                            }
                        },
                        {
                            key: "getEventTopic",
                            value: function(e) {
                                return (0, l.id)(e.format());
                            }
                        },
                        {
                            key: "isInterface",
                            value: function(e) {
                                return !(!e || !e._isInterface);
                            }
                        }
                    ]), e;
                }();
                t.Interface = O;
            },
            88222: (e, t)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.version = void 0, t.version = "address/5.7.0";
            },
            77921: (e, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.getAddress = v, t.getContractAddress = function(e) {
                    var t = null;
                    try {
                        t = v(e.from);
                    } catch (t) {
                        c.throwArgumentError("missing from address", "transaction", e);
                    }
                    var r = (0, n.stripZeros)((0, n.arrayify)(i.BigNumber.from(e.nonce).toHexString()));
                    return v((0, n.hexDataSlice)((0, o.keccak256)((0, a.encode)([
                        t,
                        r
                    ])), 12));
                }, t.getCreate2Address = function(e, t, r) {
                    return 32 !== (0, n.hexDataLength)(t) && c.throwArgumentError("salt must be 32 bytes", "salt", t), 32 !== (0, n.hexDataLength)(r) && c.throwArgumentError("initCodeHash must be 32 bytes", "initCodeHash", r), v((0, n.hexDataSlice)((0, o.keccak256)((0, n.concat)([
                        "0xff",
                        v(e),
                        t,
                        r
                    ])), 12));
                }, t.getIcapAddress = function(e) {
                    for(var t = (0, i._base16To36)(v(e).substring(2)).toUpperCase(); t.length < 30;)t = "0" + t;
                    return "XE" + y("XE00" + t) + t;
                }, t.isAddress = function(e) {
                    try {
                        return v(e), !0;
                    } catch (e) {}
                    return !1;
                };
                var n = r(908), i = r(34952), o = r(64642), a = r(55265), s = r(64327), u = r(88222), c = new s.Logger(u.version);
                function f(e) {
                    (0, n.isHexString)(e, 20) || c.throwArgumentError("invalid address", "address", e);
                    for(var t = (e = e.toLowerCase()).substring(2).split(""), r = new Uint8Array(40), i = 0; i < 40; i++)r[i] = t[i].charCodeAt(0);
                    for(var a = (0, n.arrayify)((0, o.keccak256)(r)), s = 0; s < 40; s += 2)a[s >> 1] >> 4 >= 8 && (t[s] = t[s].toUpperCase()), (15 & a[s >> 1]) >= 8 && (t[s + 1] = t[s + 1].toUpperCase());
                    return "0x" + t.join("");
                }
                for(var d = {}, l = 0; l < 10; l++)d[String(l)] = String(l);
                for(var h = 0; h < 26; h++)d[String.fromCharCode(65 + h)] = String(10 + h);
                var p, b = Math.floor((p = 9007199254740991, Math.log10 ? Math.log10(p) : Math.log(p) / Math.LN10));
                function y(e) {
                    for(var t = (e = (e = e.toUpperCase()).substring(4) + e.substring(0, 2) + "00").split("").map(function(e) {
                        return d[e];
                    }).join(""); t.length >= b;){
                        var r = t.substring(0, b);
                        t = parseInt(r, 10) % 97 + t.substring(r.length);
                    }
                    for(var n = String(98 - parseInt(t, 10) % 97); n.length < 2;)n = "0" + n;
                    return n;
                }
                function v(e) {
                    var t = null;
                    if ("string" != typeof e && c.throwArgumentError("invalid address", "address", e), e.match(/^(0x)?[0-9a-fA-F]{40}$/)) "0x" !== e.substring(0, 2) && (e = "0x" + e), t = f(e), e.match(/([A-F].*[a-f])|([a-f].*[A-F])/) && t !== e && c.throwArgumentError("bad address checksum", "address", e);
                    else if (e.match(/^XE[0-9]{2}[0-9A-Za-z]{30,31}$/)) {
                        for(e.substring(2, 4) !== y(e) && c.throwArgumentError("bad icap checksum", "address", e), t = (0, i._base36To16)(e.substring(4)); t.length < 40;)t = "0" + t;
                        t = f("0x" + t);
                    } else c.throwArgumentError("invalid address", "address", e);
                    return t;
                }
            },
            75798: (e, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.decode = function(e) {
                    e = atob(e);
                    for(var t = [], r = 0; r < e.length; r++)t.push(e.charCodeAt(r));
                    return (0, n.arrayify)(t);
                }, t.encode = function(e) {
                    e = (0, n.arrayify)(e);
                    for(var t = "", r = 0; r < e.length; r++)t += String.fromCharCode(e[r]);
                    return btoa(t);
                };
                var n = r(908);
            },
            80997: (e, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), Object.defineProperty(t, "decode", {
                    enumerable: !0,
                    get: function() {
                        return n.decode;
                    }
                }), Object.defineProperty(t, "encode", {
                    enumerable: !0,
                    get: function() {
                        return n.encode;
                    }
                });
                var n = r(75798);
            },
            3042: (e, t)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.version = void 0, t.version = "bignumber/5.7.0";
            },
            1872: (e, t, r)=>{
                "use strict";
                var n = r(28847);
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.BigNumber = void 0, t._base16To36 = function(e) {
                    return new f(e, 16).toString(36);
                }, t._base36To16 = function(e) {
                    return new f(e, 36).toString(16);
                }, t.isBigNumberish = function(e) {
                    return null != e && (b.isBigNumber(e) || "number" == typeof e && e % 1 == 0 || "string" == typeof e && !!e.match(/^-?[0-9]+$/) || (0, s.isHexString)(e) || "bigint" == typeof e || (0, s.isBytes)(e));
                };
                var i = n(r(69721)), o = n(r(58985)), a = n(r(31734)), s = r(908), u = r(64327), c = r(3042), f = a.default.BN, d = new u.Logger(c.version), l = {}, h = 9007199254740991, p = !1, b = function() {
                    function e(t, r) {
                        (0, i.default)(this, e), t !== l && d.throwError("cannot call constructor directly; use BigNumber.from", u.Logger.errors.UNSUPPORTED_OPERATION, {
                            operation: "new (BigNumber)"
                        }), this._hex = r, this._isBigNumber = !0, Object.freeze(this);
                    }
                    return (0, o.default)(e, [
                        {
                            key: "fromTwos",
                            value: function(e) {
                                return v(m(this).fromTwos(e));
                            }
                        },
                        {
                            key: "toTwos",
                            value: function(e) {
                                return v(m(this).toTwos(e));
                            }
                        },
                        {
                            key: "abs",
                            value: function() {
                                return "-" === this._hex[0] ? e.from(this._hex.substring(1)) : this;
                            }
                        },
                        {
                            key: "add",
                            value: function(e) {
                                return v(m(this).add(m(e)));
                            }
                        },
                        {
                            key: "sub",
                            value: function(e) {
                                return v(m(this).sub(m(e)));
                            }
                        },
                        {
                            key: "div",
                            value: function(t) {
                                return e.from(t).isZero() && g("division-by-zero", "div"), v(m(this).div(m(t)));
                            }
                        },
                        {
                            key: "mul",
                            value: function(e) {
                                return v(m(this).mul(m(e)));
                            }
                        },
                        {
                            key: "mod",
                            value: function(e) {
                                var t = m(e);
                                return t.isNeg() && g("division-by-zero", "mod"), v(m(this).umod(t));
                            }
                        },
                        {
                            key: "pow",
                            value: function(e) {
                                var t = m(e);
                                return t.isNeg() && g("negative-power", "pow"), v(m(this).pow(t));
                            }
                        },
                        {
                            key: "and",
                            value: function(e) {
                                var t = m(e);
                                return (this.isNegative() || t.isNeg()) && g("unbound-bitwise-result", "and"), v(m(this).and(t));
                            }
                        },
                        {
                            key: "or",
                            value: function(e) {
                                var t = m(e);
                                return (this.isNegative() || t.isNeg()) && g("unbound-bitwise-result", "or"), v(m(this).or(t));
                            }
                        },
                        {
                            key: "xor",
                            value: function(e) {
                                var t = m(e);
                                return (this.isNegative() || t.isNeg()) && g("unbound-bitwise-result", "xor"), v(m(this).xor(t));
                            }
                        },
                        {
                            key: "mask",
                            value: function(e) {
                                return (this.isNegative() || e < 0) && g("negative-width", "mask"), v(m(this).maskn(e));
                            }
                        },
                        {
                            key: "shl",
                            value: function(e) {
                                return (this.isNegative() || e < 0) && g("negative-width", "shl"), v(m(this).shln(e));
                            }
                        },
                        {
                            key: "shr",
                            value: function(e) {
                                return (this.isNegative() || e < 0) && g("negative-width", "shr"), v(m(this).shrn(e));
                            }
                        },
                        {
                            key: "eq",
                            value: function(e) {
                                return m(this).eq(m(e));
                            }
                        },
                        {
                            key: "lt",
                            value: function(e) {
                                return m(this).lt(m(e));
                            }
                        },
                        {
                            key: "lte",
                            value: function(e) {
                                return m(this).lte(m(e));
                            }
                        },
                        {
                            key: "gt",
                            value: function(e) {
                                return m(this).gt(m(e));
                            }
                        },
                        {
                            key: "gte",
                            value: function(e) {
                                return m(this).gte(m(e));
                            }
                        },
                        {
                            key: "isNegative",
                            value: function() {
                                return "-" === this._hex[0];
                            }
                        },
                        {
                            key: "isZero",
                            value: function() {
                                return m(this).isZero();
                            }
                        },
                        {
                            key: "toNumber",
                            value: function() {
                                try {
                                    return m(this).toNumber();
                                } catch (e) {
                                    g("overflow", "toNumber", this.toString());
                                }
                                return null;
                            }
                        },
                        {
                            key: "toBigInt",
                            value: function() {
                                try {
                                    return BigInt(this.toString());
                                } catch (e) {}
                                return d.throwError("this platform does not support BigInt", u.Logger.errors.UNSUPPORTED_OPERATION, {
                                    value: this.toString()
                                });
                            }
                        },
                        {
                            key: "toString",
                            value: function() {
                                return arguments.length > 0 && (10 === arguments[0] ? p || (p = !0, d.warn("BigNumber.toString does not accept any parameters; base-10 is assumed")) : 16 === arguments[0] ? d.throwError("BigNumber.toString does not accept any parameters; use bigNumber.toHexString()", u.Logger.errors.UNEXPECTED_ARGUMENT, {}) : d.throwError("BigNumber.toString does not accept parameters", u.Logger.errors.UNEXPECTED_ARGUMENT, {})), m(this).toString(10);
                            }
                        },
                        {
                            key: "toHexString",
                            value: function() {
                                return this._hex;
                            }
                        },
                        {
                            key: "toJSON",
                            value: function(e) {
                                return {
                                    type: "BigNumber",
                                    hex: this.toHexString()
                                };
                            }
                        }
                    ], [
                        {
                            key: "from",
                            value: function(t) {
                                if (t instanceof e) return t;
                                if ("string" == typeof t) return t.match(/^-?0x[0-9a-f]+$/i) ? new e(l, y(t)) : t.match(/^-?[0-9]+$/) ? new e(l, y(new f(t))) : d.throwArgumentError("invalid BigNumber string", "value", t);
                                if ("number" == typeof t) return t % 1 && g("underflow", "BigNumber.from", t), (t >= h || t <= -h) && g("overflow", "BigNumber.from", t), e.from(String(t));
                                var r = t;
                                if ("bigint" == typeof r) return e.from(r.toString());
                                if ((0, s.isBytes)(r)) return e.from((0, s.hexlify)(r));
                                if (r) {
                                    if (r.toHexString) {
                                        var n = r.toHexString();
                                        if ("string" == typeof n) return e.from(n);
                                    } else {
                                        var i = r._hex;
                                        if (null == i && "BigNumber" === r.type && (i = r.hex), "string" == typeof i && ((0, s.isHexString)(i) || "-" === i[0] && (0, s.isHexString)(i.substring(1)))) return e.from(i);
                                    }
                                }
                                return d.throwArgumentError("invalid BigNumber value", "value", t);
                            }
                        },
                        {
                            key: "isBigNumber",
                            value: function(e) {
                                return !(!e || !e._isBigNumber);
                            }
                        }
                    ]), e;
                }();
                function y(e) {
                    if ("string" != typeof e) return y(e.toString(16));
                    if ("-" === e[0]) return "-" === (e = e.substring(1))[0] && d.throwArgumentError("invalid hex", "value", e), "0x00" === (e = y(e)) ? e : "-" + e;
                    if ("0x" !== e.substring(0, 2) && (e = "0x" + e), "0x" === e) return "0x00";
                    for(e.length % 2 && (e = "0x0" + e.substring(2)); e.length > 4 && "0x00" === e.substring(0, 4);)e = "0x" + e.substring(4);
                    return e;
                }
                function v(e) {
                    return b.from(y(e));
                }
                function m(e) {
                    var t = b.from(e).toHexString();
                    return "-" === t[0] ? new f("-" + t.substring(3), 16) : new f(t.substring(2), 16);
                }
                function g(e, t, r) {
                    var n = {
                        fault: e,
                        operation: t
                    };
                    return null != r && (n.value = r), d.throwError(e, u.Logger.errors.NUMERIC_FAULT, n);
                }
                t.BigNumber = b;
            },
            68390: (e, t, r)=>{
                "use strict";
                var n = r(28847);
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.FixedNumber = t.FixedFormat = void 0, t.formatFixed = m, t.parseFixed = g;
                var i = n(r(3355)), o = n(r(69721)), a = n(r(58985)), s = r(908), u = r(64327), c = r(3042), f = r(1872), d = new u.Logger(c.version), l = {}, h = f.BigNumber.from(0), p = f.BigNumber.from(-1);
                function b(e, t, r, n) {
                    var i = {
                        fault: t,
                        operation: r
                    };
                    return void 0 !== n && (i.value = n), d.throwError(e, u.Logger.errors.NUMERIC_FAULT, i);
                }
                for(var y = "0"; y.length < 256;)y += y;
                function v(e) {
                    if ("number" != typeof e) try {
                        e = f.BigNumber.from(e).toNumber();
                    } catch (e) {}
                    return "number" == typeof e && e >= 0 && e <= 256 && !(e % 1) ? "1" + y.substring(0, e) : d.throwArgumentError("invalid decimal size", "decimals", e);
                }
                function m(e, t) {
                    null == t && (t = 0);
                    var r = v(t), n = (e = f.BigNumber.from(e)).lt(h);
                    n && (e = e.mul(p));
                    for(var i = e.mod(r).toString(); i.length < r.length - 1;)i = "0" + i;
                    i = i.match(/^([0-9]*[1-9]|0)(0*)/)[1];
                    var o = e.div(r).toString();
                    return e = 1 === r.length ? o : o + "." + i, n && (e = "-" + e), e;
                }
                function g(e, t) {
                    null == t && (t = 0);
                    var r = v(t);
                    "string" == typeof e && e.match(/^-?[0-9.]+$/) || d.throwArgumentError("invalid decimal value", "value", e);
                    var n = "-" === e.substring(0, 1);
                    n && (e = e.substring(1)), "." === e && d.throwArgumentError("missing value", "value", e);
                    var i = e.split(".");
                    i.length > 2 && d.throwArgumentError("too many decimal points", "value", e);
                    var o = i[0], a = i[1];
                    for(o || (o = "0"), a || (a = "0"); "0" === a[a.length - 1];)a = a.substring(0, a.length - 1);
                    for(a.length > r.length - 1 && b("fractional component exceeds decimals", "underflow", "parseFixed"), "" === a && (a = "0"); a.length < r.length - 1;)a += "0";
                    var s = f.BigNumber.from(o), u = f.BigNumber.from(a), c = s.mul(r).add(u);
                    return n && (c = c.mul(p)), c;
                }
                var w = function() {
                    function e(t, r, n, i) {
                        (0, o.default)(this, e), t !== l && d.throwError("cannot use FixedFormat constructor; use FixedFormat.from", u.Logger.errors.UNSUPPORTED_OPERATION, {
                            operation: "new FixedFormat"
                        }), this.signed = r, this.width = n, this.decimals = i, this.name = (r ? "" : "u") + "fixed" + String(n) + "x" + String(i), this._multiplier = v(i), Object.freeze(this);
                    }
                    return (0, a.default)(e, null, [
                        {
                            key: "from",
                            value: function(t) {
                                if (t instanceof e) return t;
                                "number" == typeof t && (t = "fixed128x".concat(t));
                                var r = !0, n = 128, o = 18;
                                if ("string" == typeof t) {
                                    if ("fixed" === t) ;
                                    else if ("ufixed" === t) r = !1;
                                    else {
                                        var a = t.match(/^(u?)fixed([0-9]+)x([0-9]+)$/);
                                        a || d.throwArgumentError("invalid fixed format", "format", t), r = "u" !== a[1], n = parseInt(a[2]), o = parseInt(a[3]);
                                    }
                                } else if (t) {
                                    var s = function(e, r, n) {
                                        return null == t[e] ? n : ((0, i.default)(t[e]) !== r && d.throwArgumentError("invalid fixed format (" + e + " not " + r + ")", "format." + e, t[e]), t[e]);
                                    };
                                    r = s("signed", "boolean", r), n = s("width", "number", n), o = s("decimals", "number", o);
                                }
                                return n % 8 && d.throwArgumentError("invalid fixed format width (not byte aligned)", "format.width", n), o > 80 && d.throwArgumentError("invalid fixed format (decimals too large)", "format.decimals", o), new e(l, r, n, o);
                            }
                        }
                    ]), e;
                }();
                t.FixedFormat = w;
                var k = function() {
                    function e(t, r, n, i) {
                        (0, o.default)(this, e), t !== l && d.throwError("cannot use FixedNumber constructor; use FixedNumber.from", u.Logger.errors.UNSUPPORTED_OPERATION, {
                            operation: "new FixedFormat"
                        }), this.format = i, this._hex = r, this._value = n, this._isFixedNumber = !0, Object.freeze(this);
                    }
                    return (0, a.default)(e, [
                        {
                            key: "_checkFormat",
                            value: function(e) {
                                this.format.name !== e.format.name && d.throwArgumentError("incompatible format; use fixedNumber.toFormat", "other", e);
                            }
                        },
                        {
                            key: "addUnsafe",
                            value: function(t) {
                                this._checkFormat(t);
                                var r = g(this._value, this.format.decimals), n = g(t._value, t.format.decimals);
                                return e.fromValue(r.add(n), this.format.decimals, this.format);
                            }
                        },
                        {
                            key: "subUnsafe",
                            value: function(t) {
                                this._checkFormat(t);
                                var r = g(this._value, this.format.decimals), n = g(t._value, t.format.decimals);
                                return e.fromValue(r.sub(n), this.format.decimals, this.format);
                            }
                        },
                        {
                            key: "mulUnsafe",
                            value: function(t) {
                                this._checkFormat(t);
                                var r = g(this._value, this.format.decimals), n = g(t._value, t.format.decimals);
                                return e.fromValue(r.mul(n).div(this.format._multiplier), this.format.decimals, this.format);
                            }
                        },
                        {
                            key: "divUnsafe",
                            value: function(t) {
                                this._checkFormat(t);
                                var r = g(this._value, this.format.decimals), n = g(t._value, t.format.decimals);
                                return e.fromValue(r.mul(this.format._multiplier).div(n), this.format.decimals, this.format);
                            }
                        },
                        {
                            key: "floor",
                            value: function() {
                                var t = this.toString().split(".");
                                1 === t.length && t.push("0");
                                var r = e.from(t[0], this.format), n = !t[1].match(/^(0*)$/);
                                return this.isNegative() && n && (r = r.subUnsafe(_.toFormat(r.format))), r;
                            }
                        },
                        {
                            key: "ceiling",
                            value: function() {
                                var t = this.toString().split(".");
                                1 === t.length && t.push("0");
                                var r = e.from(t[0], this.format), n = !t[1].match(/^(0*)$/);
                                return !this.isNegative() && n && (r = r.addUnsafe(_.toFormat(r.format))), r;
                            }
                        },
                        {
                            key: "round",
                            value: function(t) {
                                null == t && (t = 0);
                                var r = this.toString().split(".");
                                if (1 === r.length && r.push("0"), (t < 0 || t > 80 || t % 1) && d.throwArgumentError("invalid decimal count", "decimals", t), r[1].length <= t) return this;
                                var n = e.from("1" + y.substring(0, t), this.format), i = A.toFormat(this.format);
                                return this.mulUnsafe(n).addUnsafe(i).floor().divUnsafe(n);
                            }
                        },
                        {
                            key: "isZero",
                            value: function() {
                                return "0.0" === this._value || "0" === this._value;
                            }
                        },
                        {
                            key: "isNegative",
                            value: function() {
                                return "-" === this._value[0];
                            }
                        },
                        {
                            key: "toString",
                            value: function() {
                                return this._value;
                            }
                        },
                        {
                            key: "toHexString",
                            value: function(e) {
                                if (null == e) return this._hex;
                                e % 8 && d.throwArgumentError("invalid byte width", "width", e);
                                var t = f.BigNumber.from(this._hex).fromTwos(this.format.width).toTwos(e).toHexString();
                                return (0, s.hexZeroPad)(t, e / 8);
                            }
                        },
                        {
                            key: "toUnsafeFloat",
                            value: function() {
                                return parseFloat(this.toString());
                            }
                        },
                        {
                            key: "toFormat",
                            value: function(t) {
                                return e.fromString(this._value, t);
                            }
                        }
                    ], [
                        {
                            key: "fromValue",
                            value: function(t, r, n) {
                                return null != n || null == r || (0, f.isBigNumberish)(r) || (n = r, r = null), null == r && (r = 0), null == n && (n = "fixed"), e.fromString(m(t, r), w.from(n));
                            }
                        },
                        {
                            key: "fromString",
                            value: function(t, r) {
                                null == r && (r = "fixed");
                                var n = w.from(r), i = g(t, n.decimals);
                                !n.signed && i.lt(h) && b("unsigned value cannot be negative", "overflow", "value", t);
                                var o = null;
                                n.signed ? o = i.toTwos(n.width).toHexString() : (o = i.toHexString(), o = (0, s.hexZeroPad)(o, n.width / 8));
                                var a = m(i, n.decimals);
                                return new e(l, o, a, n);
                            }
                        },
                        {
                            key: "fromBytes",
                            value: function(t, r) {
                                null == r && (r = "fixed");
                                var n = w.from(r);
                                if ((0, s.arrayify)(t).length > n.width / 8) throw new Error("overflow");
                                var i = f.BigNumber.from(t);
                                n.signed && (i = i.fromTwos(n.width));
                                var o = i.toTwos((n.signed ? 0 : 1) + n.width).toHexString(), a = m(i, n.decimals);
                                return new e(l, o, a, n);
                            }
                        },
                        {
                            key: "from",
                            value: function(t, r) {
                                if ("string" == typeof t) return e.fromString(t, r);
                                if ((0, s.isBytes)(t)) return e.fromBytes(t, r);
                                try {
                                    return e.fromValue(t, 0, r);
                                } catch (e) {
                                    if (e.code !== u.Logger.errors.INVALID_ARGUMENT) throw e;
                                }
                                return d.throwArgumentError("invalid FixedNumber value", "value", t);
                            }
                        },
                        {
                            key: "isFixedNumber",
                            value: function(e) {
                                return !(!e || !e._isFixedNumber);
                            }
                        }
                    ]), e;
                }();
                t.FixedNumber = k;
                var _ = k.from(1), A = k.from("0.5");
            },
            34952: (e, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), Object.defineProperty(t, "BigNumber", {
                    enumerable: !0,
                    get: function() {
                        return n.BigNumber;
                    }
                }), Object.defineProperty(t, "FixedFormat", {
                    enumerable: !0,
                    get: function() {
                        return i.FixedFormat;
                    }
                }), Object.defineProperty(t, "FixedNumber", {
                    enumerable: !0,
                    get: function() {
                        return i.FixedNumber;
                    }
                }), Object.defineProperty(t, "_base16To36", {
                    enumerable: !0,
                    get: function() {
                        return n._base16To36;
                    }
                }), Object.defineProperty(t, "_base36To16", {
                    enumerable: !0,
                    get: function() {
                        return n._base36To16;
                    }
                }), Object.defineProperty(t, "formatFixed", {
                    enumerable: !0,
                    get: function() {
                        return i.formatFixed;
                    }
                }), Object.defineProperty(t, "parseFixed", {
                    enumerable: !0,
                    get: function() {
                        return i.parseFixed;
                    }
                });
                var n = r(1872), i = r(68390);
            },
            8729: (e, t)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.version = void 0, t.version = "bytes/5.7.0";
            },
            908: (e, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.arrayify = d, t.concat = l, t.hexConcat = function(e) {
                    var t = "0x";
                    return e.forEach(function(e) {
                        t += y(e).substring(2);
                    }), t;
                }, t.hexDataLength = function(e) {
                    if ("string" != typeof e) e = y(e);
                    else if (!p(e) || e.length % 2) return null;
                    return (e.length - 2) / 2;
                }, t.hexDataSlice = function(e, t, r) {
                    return "string" != typeof e ? e = y(e) : (!p(e) || e.length % 2) && o.throwArgumentError("invalid hexData", "value", e), t = 2 + 2 * t, null != r ? "0x" + e.substring(t, 2 + 2 * r) : "0x" + e.substring(t);
                }, t.hexStripZeros = v, t.hexValue = function(e) {
                    var t = v(y(e, {
                        hexPad: "left"
                    }));
                    return "0x" === t ? "0x0" : t;
                }, t.hexZeroPad = m, t.hexlify = y, t.isBytes = f, t.isBytesLike = u, t.isHexString = p, t.joinSignature = function(e) {
                    return y(l([
                        (e = g(e)).r,
                        e.s,
                        e.recoveryParam ? "0x1c" : "0x1b"
                    ]));
                }, t.splitSignature = g, t.stripZeros = function(e) {
                    var t = d(e);
                    if (0 === t.length) return t;
                    for(var r = 0; r < t.length && 0 === t[r];)r++;
                    return r && (t = t.slice(r)), t;
                }, t.zeroPad = h;
                var n = r(64327), i = r(8729), o = new n.Logger(i.version);
                function a(e) {
                    return !!e.toHexString;
                }
                function s(e) {
                    return e.slice || (e.slice = function() {
                        var t = Array.prototype.slice.call(arguments);
                        return s(new Uint8Array(Array.prototype.slice.apply(e, t)));
                    }), e;
                }
                function u(e) {
                    return p(e) && !(e.length % 2) || f(e);
                }
                function c(e) {
                    return "number" == typeof e && e == e && e % 1 == 0;
                }
                function f(e) {
                    if (null == e) return !1;
                    if (e.constructor === Uint8Array) return !0;
                    if ("string" == typeof e) return !1;
                    if (!c(e.length) || e.length < 0) return !1;
                    for(var t = 0; t < e.length; t++){
                        var r = e[t];
                        if (!c(r) || r < 0 || r >= 256) return !1;
                    }
                    return !0;
                }
                function d(e, t) {
                    if (t || (t = {}), "number" == typeof e) {
                        o.checkSafeUint53(e, "invalid arrayify value");
                        for(var r = []; e;)r.unshift(255 & e), e = parseInt(String(e / 256));
                        return 0 === r.length && r.push(0), s(new Uint8Array(r));
                    }
                    if (t.allowMissingPrefix && "string" == typeof e && "0x" !== e.substring(0, 2) && (e = "0x" + e), a(e) && (e = e.toHexString()), p(e)) {
                        var n = e.substring(2);
                        n.length % 2 && ("left" === t.hexPad ? n = "0" + n : "right" === t.hexPad ? n += "0" : o.throwArgumentError("hex data is odd-length", "value", e));
                        for(var i = [], u = 0; u < n.length; u += 2)i.push(parseInt(n.substring(u, u + 2), 16));
                        return s(new Uint8Array(i));
                    }
                    return f(e) ? s(new Uint8Array(e)) : o.throwArgumentError("invalid arrayify value", "value", e);
                }
                function l(e) {
                    var t = e.map(function(e) {
                        return d(e);
                    }), r = t.reduce(function(e, t) {
                        return e + t.length;
                    }, 0), n = new Uint8Array(r);
                    return t.reduce(function(e, t) {
                        return n.set(t, e), e + t.length;
                    }, 0), s(n);
                }
                function h(e, t) {
                    (e = d(e)).length > t && o.throwArgumentError("value out of range", "value", arguments[0]);
                    var r = new Uint8Array(t);
                    return r.set(e, t - e.length), s(r);
                }
                function p(e, t) {
                    return !("string" != typeof e || !e.match(/^0x[0-9A-Fa-f]*$/) || t && e.length !== 2 + 2 * t);
                }
                var b = "0123456789abcdef";
                function y(e, t) {
                    if (t || (t = {}), "number" == typeof e) {
                        o.checkSafeUint53(e, "invalid hexlify value");
                        for(var r = ""; e;)r = b[15 & e] + r, e = Math.floor(e / 16);
                        return r.length ? (r.length % 2 && (r = "0" + r), "0x" + r) : "0x00";
                    }
                    if ("bigint" == typeof e) return (e = e.toString(16)).length % 2 ? "0x0" + e : "0x" + e;
                    if (t.allowMissingPrefix && "string" == typeof e && "0x" !== e.substring(0, 2) && (e = "0x" + e), a(e)) return e.toHexString();
                    if (p(e)) return e.length % 2 && ("left" === t.hexPad ? e = "0x0" + e.substring(2) : "right" === t.hexPad ? e += "0" : o.throwArgumentError("hex data is odd-length", "value", e)), e.toLowerCase();
                    if (f(e)) {
                        for(var n = "0x", i = 0; i < e.length; i++){
                            var s = e[i];
                            n += b[(240 & s) >> 4] + b[15 & s];
                        }
                        return n;
                    }
                    return o.throwArgumentError("invalid hexlify value", "value", e);
                }
                function v(e) {
                    "string" != typeof e && (e = y(e)), p(e) || o.throwArgumentError("invalid hex string", "value", e), e = e.substring(2);
                    for(var t = 0; t < e.length && "0" === e[t];)t++;
                    return "0x" + e.substring(t);
                }
                function m(e, t) {
                    for("string" != typeof e ? e = y(e) : p(e) || o.throwArgumentError("invalid hex string", "value", e), e.length > 2 * t + 2 && o.throwArgumentError("value out of range", "value", arguments[1]); e.length < 2 * t + 2;)e = "0x0" + e.substring(2);
                    return e;
                }
                function g(e) {
                    var t = {
                        r: "0x",
                        s: "0x",
                        _vs: "0x",
                        recoveryParam: 0,
                        v: 0,
                        yParityAndS: "0x",
                        compact: "0x"
                    };
                    if (u(e)) {
                        var r = d(e);
                        64 === r.length ? (t.v = 27 + (r[32] >> 7), r[32] &= 127, t.r = y(r.slice(0, 32)), t.s = y(r.slice(32, 64))) : 65 === r.length ? (t.r = y(r.slice(0, 32)), t.s = y(r.slice(32, 64)), t.v = r[64]) : o.throwArgumentError("invalid signature string", "signature", e), t.v < 27 && (0 === t.v || 1 === t.v ? t.v += 27 : o.throwArgumentError("signature invalid v byte", "signature", e)), t.recoveryParam = 1 - t.v % 2, t.recoveryParam && (r[32] |= 128), t._vs = y(r.slice(32, 64));
                    } else {
                        if (t.r = e.r, t.s = e.s, t.v = e.v, t.recoveryParam = e.recoveryParam, t._vs = e._vs, null != t._vs) {
                            var n = h(d(t._vs), 32);
                            t._vs = y(n);
                            var i = n[0] >= 128 ? 1 : 0;
                            null == t.recoveryParam ? t.recoveryParam = i : t.recoveryParam !== i && o.throwArgumentError("signature recoveryParam mismatch _vs", "signature", e), n[0] &= 127;
                            var a = y(n);
                            null == t.s ? t.s = a : t.s !== a && o.throwArgumentError("signature v mismatch _vs", "signature", e);
                        }
                        if (null == t.recoveryParam) null == t.v ? o.throwArgumentError("signature missing v and recoveryParam", "signature", e) : 0 === t.v || 1 === t.v ? t.recoveryParam = t.v : t.recoveryParam = 1 - t.v % 2;
                        else if (null == t.v) t.v = 27 + t.recoveryParam;
                        else {
                            var s = 0 === t.v || 1 === t.v ? t.v : 1 - t.v % 2;
                            t.recoveryParam !== s && o.throwArgumentError("signature recoveryParam mismatch v", "signature", e);
                        }
                        null != t.r && p(t.r) ? t.r = m(t.r, 32) : o.throwArgumentError("signature missing or invalid r", "signature", e), null != t.s && p(t.s) ? t.s = m(t.s, 32) : o.throwArgumentError("signature missing or invalid s", "signature", e);
                        var c = d(t.s);
                        c[0] >= 128 && o.throwArgumentError("signature s out of range", "signature", e), t.recoveryParam && (c[0] |= 128);
                        var f = y(c);
                        t._vs && (p(t._vs) || o.throwArgumentError("signature invalid _vs", "signature", e), t._vs = m(t._vs, 32)), null == t._vs ? t._vs = f : t._vs !== f && o.throwArgumentError("signature _vs mismatch v and s", "signature", e);
                    }
                    return t.yParityAndS = t._vs, t.compact = t.r + t.yParityAndS.substring(2), t;
                }
            },
            48721: (e, t)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.AddressZero = void 0, t.AddressZero = "0x0000000000000000000000000000000000000000";
            },
            22997: (e, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.Zero = t.WeiPerEther = t.Two = t.One = t.NegativeOne = t.MinInt256 = t.MaxUint256 = t.MaxInt256 = void 0;
                var n = r(34952), i = n.BigNumber.from(-1);
                t.NegativeOne = i;
                var o = n.BigNumber.from(0);
                t.Zero = o;
                var a = n.BigNumber.from(1);
                t.One = a;
                var s = n.BigNumber.from(2);
                t.Two = s;
                var u = n.BigNumber.from("1000000000000000000");
                t.WeiPerEther = u;
                var c = n.BigNumber.from("0xffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff");
                t.MaxUint256 = c;
                var f = n.BigNumber.from("-0x8000000000000000000000000000000000000000000000000000000000000000");
                t.MinInt256 = f;
                var d = n.BigNumber.from("0x7fffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff");
                t.MaxInt256 = d;
            },
            90396: (e, t)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.HashZero = void 0, t.HashZero = "0x0000000000000000000000000000000000000000000000000000000000000000";
            },
            5465: (e, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), Object.defineProperty(t, "AddressZero", {
                    enumerable: !0,
                    get: function() {
                        return n.AddressZero;
                    }
                }), Object.defineProperty(t, "EtherSymbol", {
                    enumerable: !0,
                    get: function() {
                        return a.EtherSymbol;
                    }
                }), Object.defineProperty(t, "HashZero", {
                    enumerable: !0,
                    get: function() {
                        return o.HashZero;
                    }
                }), Object.defineProperty(t, "MaxInt256", {
                    enumerable: !0,
                    get: function() {
                        return i.MaxInt256;
                    }
                }), Object.defineProperty(t, "MaxUint256", {
                    enumerable: !0,
                    get: function() {
                        return i.MaxUint256;
                    }
                }), Object.defineProperty(t, "MinInt256", {
                    enumerable: !0,
                    get: function() {
                        return i.MinInt256;
                    }
                }), Object.defineProperty(t, "NegativeOne", {
                    enumerable: !0,
                    get: function() {
                        return i.NegativeOne;
                    }
                }), Object.defineProperty(t, "One", {
                    enumerable: !0,
                    get: function() {
                        return i.One;
                    }
                }), Object.defineProperty(t, "Two", {
                    enumerable: !0,
                    get: function() {
                        return i.Two;
                    }
                }), Object.defineProperty(t, "WeiPerEther", {
                    enumerable: !0,
                    get: function() {
                        return i.WeiPerEther;
                    }
                }), Object.defineProperty(t, "Zero", {
                    enumerable: !0,
                    get: function() {
                        return i.Zero;
                    }
                });
                var n = r(48721), i = r(22997), o = r(90396), a = r(68347);
            },
            68347: (e, t)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.EtherSymbol = void 0, t.EtherSymbol = "\u039E";
            },
            33989: (e, t)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.version = void 0, t.version = "hash/5.7.0";
            },
            33731: (e, t)=>{
                "use strict";
                function r(e, t) {
                    null == t && (t = 1);
                    var r = [], n = r.forEach;
                    return function e(t, i) {
                        n.call(t, function(t) {
                            i > 0 && Array.isArray(t) ? e(t, i - 1) : r.push(t);
                        });
                    }(e, t), r;
                }
                function n(e) {
                    var t = 0;
                    function r() {
                        return e[t++] << 8 | e[t++];
                    }
                    for(var n = r(), i = 1, o = [
                        0,
                        1
                    ], a = 1; a < n; a++)o.push(i += r());
                    var s = r(), u = t;
                    t += s;
                    var c = 0, f = 0;
                    function d() {
                        return 0 == c && (f = f << 8 | e[t++], c = 8), f >> --c & 1;
                    }
                    for(var l = Math.pow(2, 31), h = l >>> 1, p = h >> 1, b = l - 1, y = 0, v = 0; v < 31; v++)y = y << 1 | d();
                    for(var m = [], g = 0, w = l;;){
                        for(var k = Math.floor(((y - g + 1) * i - 1) / w), _ = 0, A = n; A - _ > 1;){
                            var E = _ + A >>> 1;
                            k < o[E] ? A = E : _ = E;
                        }
                        if (0 == _) break;
                        m.push(_);
                        for(var S = g + Math.floor(w * o[_] / i), x = g + Math.floor(w * o[_ + 1] / i) - 1; 0 == ((S ^ x) & h);)y = y << 1 & b | d(), S = S << 1 & b, x = x << 1 & b | 1;
                        for(; S & ~x & p;)y = y & h | y << 1 & b >>> 1 | d(), S = S << 1 ^ h, x = (x ^ h) << 1 | h | 1;
                        g = S, w = 1 + x - S;
                    }
                    var B = n - 4;
                    return m.map(function(t) {
                        switch(t - B){
                            case 3:
                                return B + 65792 + (e[u++] << 16 | e[u++] << 8 | e[u++]);
                            case 2:
                                return B + 256 + (e[u++] << 8 | e[u++]);
                            case 1:
                                return B + e[u++];
                            default:
                                return t - 1;
                        }
                    });
                }
                function i(e) {
                    var t = 0;
                    return function() {
                        return e[t++];
                    };
                }
                function o(e) {
                    return 1 & e ? ~e >> 1 : e >> 1;
                }
                function a(e, t) {
                    for(var r = Array(e), n = 0, i = -1; n < e; n++)r[n] = i += 1 + t();
                    return r;
                }
                function s(e, t) {
                    for(var r = Array(e), n = 0, i = 0; n < e; n++)r[n] = i += o(t());
                    return r;
                }
                function u(e, t) {
                    for(var r = a(e(), e), n = e(), i = a(n, e), o = function(e, t) {
                        for(var r = Array(e), n = 0; n < e; n++)r[n] = 1 + t();
                        return r;
                    }(n, e), s = 0; s < n; s++)for(var u = 0; u < o[s]; u++)r.push(i[s] + u);
                    return t ? r.map(function(e) {
                        return t[e];
                    }) : r;
                }
                function c(e) {
                    for(var t = [];;){
                        var r = e();
                        if (0 == r) break;
                        t.push(r);
                    }
                    return t;
                }
                function f(e, t, r) {
                    for(var n = Array(e).fill(void 0).map(function() {
                        return [];
                    }), i = 0; i < t; i++)s(e, r).forEach(function(e, t) {
                        return n[t].push(e);
                    });
                    return n;
                }
                function d(e, t) {
                    var n = 1 + t(), i = t(), o = c(t);
                    return r(f(o.length, 1 + e, t).map(function(e, t) {
                        var r = e[0], a = e.slice(1);
                        return Array(o[t]).fill(void 0).map(function(e, t) {
                            var o = t * i;
                            return [
                                r + t * n,
                                a.map(function(e) {
                                    return e + o;
                                })
                            ];
                        });
                    }));
                }
                function l(e, t) {
                    return f(1 + t(), 1 + e, t).map(function(e) {
                        return [
                            e[0],
                            e.slice(1)
                        ];
                    });
                }
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.decode_arithmetic = n, t.read_compressed_payload = function(e) {
                    return i(n(e));
                }, t.read_emoji_trie = function(e) {
                    var t = u(e).sort(function(e, t) {
                        return e - t;
                    });
                    return function r() {
                        for(var n = [];;){
                            var i = u(e, t);
                            if (0 == i.length) break;
                            n.push({
                                set: new Set(i),
                                node: r()
                            });
                        }
                        n.sort(function(e, t) {
                            return t.set.size - e.set.size;
                        });
                        var o = e();
                        return {
                            branches: n,
                            valid: o % 3,
                            fe0f: !!(1 & (o = o / 3 | 0)),
                            save: 1 == (o >>= 1),
                            check: 2 == o
                        };
                    }();
                }, t.read_mapped_map = function(e) {
                    for(var t = [];;){
                        var n = e();
                        if (0 == n) break;
                        t.push(d(n, e));
                    }
                    for(;;){
                        var i = e() - 1;
                        if (i < 0) break;
                        t.push(l(i, e));
                    }
                    return function(e) {
                        for(var t = {}, r = 0; r < e.length; r++){
                            var n = e[r];
                            t[n[0]] = n[1];
                        }
                        return t;
                    }(r(t));
                }, t.read_member_array = u, t.read_payload = i, t.read_zero_terminated_array = c, t.signed = o;
            },
            63961: (e, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.getData = function() {
                    return (0, i.read_compressed_payload)((0, n.decode)("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"));
                };
                var n = r(80997), i = r(33731);
            },
            17032: (e, t, r)=>{
                "use strict";
                var n = r(28847);
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.ens_normalize = function(e) {
                    return m(function(e, t) {
                        for(var r = y(e).reverse(), n = []; r.length;){
                            var o = g(r);
                            if (o) n.push.apply(n, (0, i.default)(t(o)));
                            else {
                                var a = r.pop();
                                if (f.has(a)) n.push(a);
                                else if (!d.has(a)) {
                                    var s = l[a];
                                    if (!s) throw new Error("Disallowed codepoint: 0x".concat(a.toString(16).toUpperCase()));
                                    n.push.apply(n, (0, i.default)(s));
                                }
                            }
                        }
                        return m(String.fromCodePoint.apply(String, n).normalize("NFC"));
                    }(e, v));
                }, t.ens_normalize_post_check = m;
                var i = n(r(93106)), o = r(78627), a = r(63961), s = r(33731);
                function u(e, t) {
                    (null == t || t > e.length) && (t = e.length);
                    for(var r = 0, n = new Array(t); r < t; r++)n[r] = e[r];
                    return n;
                }
                var c = (0, a.getData)(), f = new Set((0, s.read_member_array)(c)), d = new Set((0, s.read_member_array)(c)), l = (0, s.read_mapped_map)(c), h = (0, s.read_emoji_trie)(c), p = 45, b = 95;
                function y(e) {
                    return (0, o.toUtf8CodePoints)(e);
                }
                function v(e) {
                    return e.filter(function(e) {
                        return 65039 != e;
                    });
                }
                function m(e) {
                    var t, r = function(e, t) {
                        var r = "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
                        if (!r) {
                            if (Array.isArray(e) || (r = function(e, t) {
                                if (e) {
                                    if ("string" == typeof e) return u(e, t);
                                    var r = Object.prototype.toString.call(e).slice(8, -1);
                                    return "Object" === r && e.constructor && (r = e.constructor.name), "Map" === r || "Set" === r ? Array.from(e) : "Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? u(e, t) : void 0;
                                }
                            }(e)) || t && e && "number" == typeof e.length) {
                                r && (e = r);
                                var n = 0, i = function() {};
                                return {
                                    s: i,
                                    n: function() {
                                        return n >= e.length ? {
                                            done: !0
                                        } : {
                                            done: !1,
                                            value: e[n++]
                                        };
                                    },
                                    e: function(e) {
                                        throw e;
                                    },
                                    f: i
                                };
                            }
                            throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                        }
                        var o, a = !0, s = !1;
                        return {
                            s: function() {
                                r = r.call(e);
                            },
                            n: function() {
                                var e = r.next();
                                return a = e.done, e;
                            },
                            e: function(e) {
                                s = !0, o = e;
                            },
                            f: function() {
                                try {
                                    a || null == r.return || r.return();
                                } finally{
                                    if (s) throw o;
                                }
                            }
                        };
                    }(e.split("."));
                    try {
                        for(r.s(); !(t = r.n()).done;){
                            var n = t.value, i = y(n);
                            try {
                                for(var o = i.lastIndexOf(b) - 1; o >= 0; o--)if (i[o] !== b) throw new Error("underscore only allowed at start");
                                if (i.length >= 4 && i.every(function(e) {
                                    return e < 128;
                                }) && i[2] === p && i[3] === p) throw new Error("invalid label extension");
                            } catch (e) {
                                throw new Error('Invalid label "'.concat(n, '": ').concat(e.message));
                            }
                        }
                    } catch (e) {
                        r.e(e);
                    } finally{
                        r.f();
                    }
                    return e;
                }
                function g(e, t) {
                    var r, n, o, a = h, s = [], u = e.length;
                    t && (t.length = 0);
                    for(var c = function() {
                        var c = e[--u];
                        if (!(a = null === (r = a.branches.find(function(e) {
                            return e.set.has(c);
                        })) || void 0 === r ? void 0 : r.node)) return "break";
                        if (a.save) o = c;
                        else if (a.check && c === o) return "break";
                        s.push(c), a.fe0f && (s.push(65039), u > 0 && 65039 == e[u - 1] && u--), a.valid && (n = s.slice(), 2 == a.valid && n.splice(1, 1), t && t.push.apply(t, (0, i.default)(e.slice(u).reverse())), e.length = u);
                    }; u && "break" !== c(););
                    return n;
                }
            },
            57901: (e, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.id = function(e) {
                    return (0, n.keccak256)((0, i.toUtf8Bytes)(e));
                };
                var n = r(64642), i = r(78627);
            },
            37515: (e, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), Object.defineProperty(t, "_TypedDataEncoder", {
                    enumerable: !0,
                    get: function() {
                        return a.TypedDataEncoder;
                    }
                }), Object.defineProperty(t, "dnsEncode", {
                    enumerable: !0,
                    get: function() {
                        return i.dnsEncode;
                    }
                }), Object.defineProperty(t, "ensNormalize", {
                    enumerable: !0,
                    get: function() {
                        return i.ensNormalize;
                    }
                }), Object.defineProperty(t, "hashMessage", {
                    enumerable: !0,
                    get: function() {
                        return o.hashMessage;
                    }
                }), Object.defineProperty(t, "id", {
                    enumerable: !0,
                    get: function() {
                        return n.id;
                    }
                }), Object.defineProperty(t, "isValidName", {
                    enumerable: !0,
                    get: function() {
                        return i.isValidName;
                    }
                }), Object.defineProperty(t, "messagePrefix", {
                    enumerable: !0,
                    get: function() {
                        return o.messagePrefix;
                    }
                }), Object.defineProperty(t, "namehash", {
                    enumerable: !0,
                    get: function() {
                        return i.namehash;
                    }
                });
                var n = r(57901), i = r(84898), o = r(34443), a = r(12171);
            },
            34443: (e, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.hashMessage = function(e) {
                    return "string" == typeof e && (e = (0, o.toUtf8Bytes)(e)), (0, i.keccak256)((0, n.concat)([
                        (0, o.toUtf8Bytes)(a),
                        (0, o.toUtf8Bytes)(String(e.length)),
                        e
                    ]));
                }, t.messagePrefix = void 0;
                var n = r(908), i = r(64642), o = r(78627), a = "\x19Ethereum Signed Message:\n";
                t.messagePrefix = a;
            },
            84898: (e, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.dnsEncode = function(e) {
                    return (0, n.hexlify)((0, n.concat)(l(e).map(function(e) {
                        if (e.length > 63) throw new Error("invalid DNS encoded entry; length exceeds 63 bytes");
                        var t = new Uint8Array(e.length + 1);
                        return t.set(e, 1), t[0] = t.length - 1, t;
                    }))) + "00";
                }, t.ensNormalize = function(e) {
                    return l(e).map(function(e) {
                        return (0, i.toUtf8String)(e);
                    }).join(".");
                }, t.isValidName = function(e) {
                    try {
                        return 0 !== l(e).length;
                    } catch (e) {}
                    return !1;
                }, t.namehash = function(e) {
                    "string" != typeof e && c.throwArgumentError("invalid ENS name; not a string", "name", e);
                    for(var t = f, r = l(e); r.length;)t = (0, o.keccak256)((0, n.concat)([
                        t,
                        (0, o.keccak256)(r.pop())
                    ]));
                    return (0, n.hexlify)(t);
                };
                var n = r(908), i = r(78627), o = r(64642), a = r(64327), s = r(33989), u = r(17032), c = new a.Logger(s.version), f = new Uint8Array(32);
                function d(e) {
                    if (0 === e.length) throw new Error("invalid ENS name; empty component");
                    return e;
                }
                function l(e) {
                    var t = (0, i.toUtf8Bytes)((0, u.ens_normalize)(e)), r = [];
                    if (0 === e.length) return r;
                    for(var n = 0, o = 0; o < t.length; o++)46 === t[o] && (r.push(d(t.slice(n, o))), n = o + 1);
                    if (n >= t.length) throw new Error("invalid ENS name; empty component");
                    return r.push(d(t.slice(n))), r;
                }
                f.fill(0);
            },
            12171: (e, t, r)=>{
                "use strict";
                var n = r(28847);
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.TypedDataEncoder = void 0;
                var i = n(r(82247)), o = n(r(69721)), a = n(r(58985)), s = r(77921), u = r(34952), c = r(908), f = r(64642), d = r(23694), l = r(64327), h = r(33989), p = r(57901), b = new l.Logger(h.version), y = new Uint8Array(32);
                y.fill(0);
                var v = u.BigNumber.from(-1), m = u.BigNumber.from(0), g = u.BigNumber.from(1), w = u.BigNumber.from("0xffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff"), k = (0, c.hexZeroPad)(g.toHexString(), 32), _ = (0, c.hexZeroPad)(m.toHexString(), 32), A = {
                    name: "string",
                    version: "string",
                    chainId: "uint256",
                    verifyingContract: "address",
                    salt: "bytes32"
                }, E = [
                    "name",
                    "version",
                    "chainId",
                    "verifyingContract",
                    "salt"
                ];
                function S(e) {
                    return function(t) {
                        return "string" != typeof t && b.throwArgumentError("invalid domain value for ".concat(JSON.stringify(e)), "domain.".concat(e), t), t;
                    };
                }
                var x = {
                    name: S("name"),
                    version: S("version"),
                    chainId: function(e) {
                        try {
                            return u.BigNumber.from(e).toString();
                        } catch (e) {}
                        return b.throwArgumentError('invalid domain value for "chainId"', "domain.chainId", e);
                    },
                    verifyingContract: function(e) {
                        try {
                            return (0, s.getAddress)(e).toLowerCase();
                        } catch (e) {}
                        return b.throwArgumentError('invalid domain value "verifyingContract"', "domain.verifyingContract", e);
                    },
                    salt: function(e) {
                        try {
                            var t = (0, c.arrayify)(e);
                            if (32 !== t.length) throw new Error("bad length");
                            return (0, c.hexlify)(t);
                        } catch (e) {}
                        return b.throwArgumentError('invalid domain value "salt"', "domain.salt", e);
                    }
                };
                function B(e) {
                    var t = e.match(/^(u?)int(\d*)$/);
                    if (t) {
                        var r = "" === t[1], n = parseInt(t[2] || "256");
                        (n % 8 != 0 || n > 256 || t[2] && t[2] !== String(n)) && b.throwArgumentError("invalid numeric width", "type", e);
                        var i = w.mask(r ? n - 1 : n), o = r ? i.add(g).mul(v) : m;
                        return function(t) {
                            var r = u.BigNumber.from(t);
                            return (r.lt(o) || r.gt(i)) && b.throwArgumentError("value out-of-bounds for ".concat(e), "value", t), (0, c.hexZeroPad)(r.toTwos(256).toHexString(), 32);
                        };
                    }
                    var a = e.match(/^bytes(\d+)$/);
                    if (a) {
                        var d = parseInt(a[1]);
                        return (0 === d || d > 32 || a[1] !== String(d)) && b.throwArgumentError("invalid bytes width", "type", e), function(t) {
                            return (0, c.arrayify)(t).length !== d && b.throwArgumentError("invalid length for ".concat(e), "value", t), function(e) {
                                var t = (0, c.arrayify)(e), r = t.length % 32;
                                return r ? (0, c.hexConcat)([
                                    t,
                                    y.slice(r)
                                ]) : (0, c.hexlify)(t);
                            }(t);
                        };
                    }
                    switch(e){
                        case "address":
                            return function(e) {
                                return (0, c.hexZeroPad)((0, s.getAddress)(e), 32);
                            };
                        case "bool":
                            return function(e) {
                                return e ? k : _;
                            };
                        case "bytes":
                            return function(e) {
                                return (0, f.keccak256)(e);
                            };
                        case "string":
                            return function(e) {
                                return (0, p.id)(e);
                            };
                    }
                    return null;
                }
                function O(e, t) {
                    return "".concat(e, "(").concat(t.map(function(e) {
                        var t = e.name;
                        return e.type + " " + t;
                    }).join(","), ")");
                }
                var P = function() {
                    function e(t) {
                        (0, o.default)(this, e), (0, d.defineReadOnly)(this, "types", Object.freeze((0, d.deepCopy)(t))), (0, d.defineReadOnly)(this, "_encoderCache", {}), (0, d.defineReadOnly)(this, "_types", {});
                        var r = {}, n = {}, i = {};
                        Object.keys(t).forEach(function(e) {
                            r[e] = {}, n[e] = [], i[e] = {};
                        });
                        var a = function(e) {
                            var i = {};
                            t[e].forEach(function(o) {
                                i[o.name] && b.throwArgumentError("duplicate variable name ".concat(JSON.stringify(o.name), " in ").concat(JSON.stringify(e)), "types", t), i[o.name] = !0;
                                var a = o.type.match(/^([^\x5b]*)(\x5b|$)/)[1];
                                a === e && b.throwArgumentError("circular type reference to ".concat(JSON.stringify(a)), "types", t), B(a) || (n[a] || b.throwArgumentError("unknown type ".concat(JSON.stringify(a)), "types", t), n[a].push(e), r[e][a] = !0);
                            });
                        };
                        for(var s in t)a(s);
                        var u = Object.keys(n).filter(function(e) {
                            return 0 === n[e].length;
                        });
                        for(var c in 0 === u.length ? b.throwArgumentError("missing primary type", "types", t) : u.length > 1 && b.throwArgumentError("ambiguous primary types or unused types: ".concat(u.map(function(e) {
                            return JSON.stringify(e);
                        }).join(", ")), "types", t), (0, d.defineReadOnly)(this, "primaryType", u[0]), function e(o, a) {
                            a[o] && b.throwArgumentError("circular type reference to ".concat(JSON.stringify(o)), "types", t), a[o] = !0, Object.keys(r[o]).forEach(function(t) {
                                n[t] && (e(t, a), Object.keys(a).forEach(function(e) {
                                    i[e][t] = !0;
                                }));
                            }), delete a[o];
                        }(this.primaryType, {}), i){
                            var f = Object.keys(i[c]);
                            f.sort(), this._types[c] = O(c, t[c]) + f.map(function(e) {
                                return O(e, t[e]);
                            }).join("");
                        }
                    }
                    return (0, a.default)(e, [
                        {
                            key: "getEncoder",
                            value: function(e) {
                                var t = this._encoderCache[e];
                                return t || (t = this._encoderCache[e] = this._getEncoder(e)), t;
                            }
                        },
                        {
                            key: "_getEncoder",
                            value: function(e) {
                                var t = this, r = B(e);
                                if (r) return r;
                                var n = e.match(/^(.*)(\x5b(\d*)\x5d)$/);
                                if (n) {
                                    var i = n[1], o = this.getEncoder(i), a = parseInt(n[3]);
                                    return function(e) {
                                        a >= 0 && e.length !== a && b.throwArgumentError("array length mismatch; expected length ${ arrayLength }", "value", e);
                                        var r = e.map(o);
                                        return t._types[i] && (r = r.map(f.keccak256)), (0, f.keccak256)((0, c.hexConcat)(r));
                                    };
                                }
                                var s = this.types[e];
                                if (s) {
                                    var u = (0, p.id)(this._types[e]);
                                    return function(e) {
                                        var r = s.map(function(r) {
                                            var n = r.name, i = r.type, o = t.getEncoder(i)(e[n]);
                                            return t._types[i] ? (0, f.keccak256)(o) : o;
                                        });
                                        return r.unshift(u), (0, c.hexConcat)(r);
                                    };
                                }
                                return b.throwArgumentError("unknown type: ".concat(e), "type", e);
                            }
                        },
                        {
                            key: "encodeType",
                            value: function(e) {
                                var t = this._types[e];
                                return t || b.throwArgumentError("unknown type: ".concat(JSON.stringify(e)), "name", e), t;
                            }
                        },
                        {
                            key: "encodeData",
                            value: function(e, t) {
                                return this.getEncoder(e)(t);
                            }
                        },
                        {
                            key: "hashStruct",
                            value: function(e, t) {
                                return (0, f.keccak256)(this.encodeData(e, t));
                            }
                        },
                        {
                            key: "encode",
                            value: function(e) {
                                return this.encodeData(this.primaryType, e);
                            }
                        },
                        {
                            key: "hash",
                            value: function(e) {
                                return this.hashStruct(this.primaryType, e);
                            }
                        },
                        {
                            key: "_visit",
                            value: function(e, t, r) {
                                var n = this;
                                if (B(e)) return r(e, t);
                                var i = e.match(/^(.*)(\x5b(\d*)\x5d)$/);
                                if (i) {
                                    var o = i[1], a = parseInt(i[3]);
                                    return a >= 0 && t.length !== a && b.throwArgumentError("array length mismatch; expected length ${ arrayLength }", "value", t), t.map(function(e) {
                                        return n._visit(o, e, r);
                                    });
                                }
                                var s = this.types[e];
                                return s ? s.reduce(function(e, i) {
                                    var o = i.name, a = i.type;
                                    return e[o] = n._visit(a, t[o], r), e;
                                }, {}) : b.throwArgumentError("unknown type: ".concat(e), "type", e);
                            }
                        },
                        {
                            key: "visit",
                            value: function(e, t) {
                                return this._visit(this.primaryType, e, t);
                            }
                        }
                    ], [
                        {
                            key: "from",
                            value: function(t) {
                                return new e(t);
                            }
                        },
                        {
                            key: "getPrimaryType",
                            value: function(t) {
                                return e.from(t).primaryType;
                            }
                        },
                        {
                            key: "hashStruct",
                            value: function(t, r, n) {
                                return e.from(r).hashStruct(t, n);
                            }
                        },
                        {
                            key: "hashDomain",
                            value: function(t) {
                                var r = [];
                                for(var n in t){
                                    var i = A[n];
                                    i || b.throwArgumentError("invalid typed-data domain key: ".concat(JSON.stringify(n)), "domain", t), r.push({
                                        name: n,
                                        type: i
                                    });
                                }
                                return r.sort(function(e, t) {
                                    return E.indexOf(e.name) - E.indexOf(t.name);
                                }), e.hashStruct("EIP712Domain", {
                                    EIP712Domain: r
                                }, t);
                            }
                        },
                        {
                            key: "encode",
                            value: function(t, r, n) {
                                return (0, c.hexConcat)([
                                    "0x1901",
                                    e.hashDomain(t),
                                    e.from(r).hash(n)
                                ]);
                            }
                        },
                        {
                            key: "hash",
                            value: function(t, r, n) {
                                return (0, f.keccak256)(e.encode(t, r, n));
                            }
                        },
                        {
                            key: "resolveNames",
                            value: function(t, r, n, o) {
                                var a, s, u, f;
                                return a = this, s = void 0, u = void 0, f = i.default.mark(function a() {
                                    var s, u, f;
                                    return i.default.wrap(function(a) {
                                        for(;;)switch(a.prev = a.next){
                                            case 0:
                                                t = (0, d.shallowCopy)(t), s = {}, t.verifyingContract && !(0, c.isHexString)(t.verifyingContract, 20) && (s[t.verifyingContract] = "0x"), (u = e.from(r)).visit(n, function(e, t) {
                                                    return "address" !== e || (0, c.isHexString)(t, 20) || (s[t] = "0x"), t;
                                                }), a.t0 = i.default.keys(s);
                                            case 6:
                                                if ((a.t1 = a.t0()).done) {
                                                    a.next = 13;
                                                    break;
                                                }
                                                return f = a.t1.value, a.next = 10, o(f);
                                            case 10:
                                                s[f] = a.sent, a.next = 6;
                                                break;
                                            case 13:
                                                return t.verifyingContract && s[t.verifyingContract] && (t.verifyingContract = s[t.verifyingContract]), n = u.visit(n, function(e, t) {
                                                    return "address" === e && s[t] ? s[t] : t;
                                                }), a.abrupt("return", {
                                                    domain: t,
                                                    value: n
                                                });
                                            case 16:
                                            case "end":
                                                return a.stop();
                                        }
                                    }, a);
                                }), new (u || (u = Promise))(function(e, t) {
                                    function r(e) {
                                        try {
                                            i(f.next(e));
                                        } catch (e) {
                                            t(e);
                                        }
                                    }
                                    function n(e) {
                                        try {
                                            i(f.throw(e));
                                        } catch (e) {
                                            t(e);
                                        }
                                    }
                                    function i(t) {
                                        var i;
                                        t.done ? e(t.value) : (i = t.value, i instanceof u ? i : new u(function(e) {
                                            e(i);
                                        })).then(r, n);
                                    }
                                    i((f = f.apply(a, s || [])).next());
                                });
                            }
                        },
                        {
                            key: "getPayload",
                            value: function(t, r, n) {
                                e.hashDomain(t);
                                var i = {}, o = [];
                                E.forEach(function(e) {
                                    var r = t[e];
                                    null != r && (i[e] = x[e](r), o.push({
                                        name: e,
                                        type: A[e]
                                    }));
                                });
                                var a = e.from(r), s = (0, d.shallowCopy)(r);
                                return s.EIP712Domain ? b.throwArgumentError("types must not contain EIP712Domain type", "types.EIP712Domain", r) : s.EIP712Domain = o, a.encode(n), {
                                    types: s,
                                    domain: i,
                                    primaryType: a.primaryType,
                                    message: a.visit(n, function(e, t) {
                                        if (e.match(/^bytes(\d*)/)) return (0, c.hexlify)((0, c.arrayify)(t));
                                        if (e.match(/^u?int/)) return u.BigNumber.from(t).toString();
                                        switch(e){
                                            case "address":
                                                return t.toLowerCase();
                                            case "bool":
                                                return !!t;
                                            case "string":
                                                return "string" != typeof t && b.throwArgumentError("invalid string", "value", t), t;
                                        }
                                        return b.throwArgumentError("unsupported type", "type", e);
                                    })
                                };
                            }
                        }
                    ]), e;
                }();
                t.TypedDataEncoder = P;
            },
            64642: (e, t, r)=>{
                "use strict";
                var n = r(28847);
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.keccak256 = function(e) {
                    return "0x" + i.default.keccak_256((0, o.arrayify)(e));
                };
                var i = n(r(95975)), o = r(908);
            },
            95975: (e, t, r)=>{
                "use strict";
                e = r.nmd(e);
                var n, i = r(19142), o = r(28847)(r(3355));
                !function() {
                    var a = "input is invalid type", s = "object" === ("undefined" == typeof window ? "undefined" : (0, o.default)(window)), u = s ? window : {};
                    u.JS_SHA3_NO_WINDOW && (s = !1);
                    var c = !s && "object" === ("undefined" == typeof self ? "undefined" : (0, o.default)(self));
                    !u.JS_SHA3_NO_NODE_JS && "object" === (void 0 === i ? "undefined" : (0, o.default)(i)) && i.versions && i.versions.node ? u = r.g : c && (u = self);
                    var f = !u.JS_SHA3_NO_COMMON_JS && "object" === (0, o.default)(e) && e.exports, d = r.amdO, l = !u.JS_SHA3_NO_ARRAY_BUFFER && "undefined" != typeof ArrayBuffer, h = "0123456789abcdef".split(""), p = [
                        4,
                        1024,
                        262144,
                        67108864
                    ], b = [
                        0,
                        8,
                        16,
                        24
                    ], y = [
                        1,
                        0,
                        32898,
                        0,
                        32906,
                        2147483648,
                        2147516416,
                        2147483648,
                        32907,
                        0,
                        2147483649,
                        0,
                        2147516545,
                        2147483648,
                        32777,
                        2147483648,
                        138,
                        0,
                        136,
                        0,
                        2147516425,
                        0,
                        2147483658,
                        0,
                        2147516555,
                        0,
                        139,
                        2147483648,
                        32905,
                        2147483648,
                        32771,
                        2147483648,
                        32770,
                        2147483648,
                        128,
                        2147483648,
                        32778,
                        0,
                        2147483658,
                        2147483648,
                        2147516545,
                        2147483648,
                        32896,
                        2147483648,
                        2147483649,
                        0,
                        2147516424,
                        2147483648
                    ], v = [
                        224,
                        256,
                        384,
                        512
                    ], m = [
                        128,
                        256
                    ], g = [
                        "hex",
                        "buffer",
                        "arrayBuffer",
                        "array",
                        "digest"
                    ], w = {
                        128: 168,
                        256: 136
                    };
                    !u.JS_SHA3_NO_NODE_JS && Array.isArray || (Array.isArray = function(e) {
                        return "[object Array]" === Object.prototype.toString.call(e);
                    }), !l || !u.JS_SHA3_NO_ARRAY_BUFFER_IS_VIEW && ArrayBuffer.isView || (ArrayBuffer.isView = function(e) {
                        return "object" === (0, o.default)(e) && e.buffer && e.buffer.constructor === ArrayBuffer;
                    });
                    for(var k = function(e, t, r) {
                        return function(n) {
                            return new N(e, t, e).update(n)[r]();
                        };
                    }, _ = function(e, t, r) {
                        return function(n, i) {
                            return new N(e, t, i).update(n)[r]();
                        };
                    }, A = function(e, t, r) {
                        return function(t, n, i, o) {
                            return O["cshake" + e].update(t, n, i, o)[r]();
                        };
                    }, E = function(e, t, r) {
                        return function(t, n, i, o) {
                            return O["kmac" + e].update(t, n, i, o)[r]();
                        };
                    }, S = function(e, t, r, n) {
                        for(var i = 0; i < g.length; ++i){
                            var o = g[i];
                            e[o] = t(r, n, o);
                        }
                        return e;
                    }, x = function(e, t) {
                        var r = k(e, t, "hex");
                        return r.create = function() {
                            return new N(e, t, e);
                        }, r.update = function(e) {
                            return r.create().update(e);
                        }, S(r, k, e, t);
                    }, B = [
                        {
                            name: "keccak",
                            padding: [
                                1,
                                256,
                                65536,
                                16777216
                            ],
                            bits: v,
                            createMethod: x
                        },
                        {
                            name: "sha3",
                            padding: [
                                6,
                                1536,
                                393216,
                                100663296
                            ],
                            bits: v,
                            createMethod: x
                        },
                        {
                            name: "shake",
                            padding: [
                                31,
                                7936,
                                2031616,
                                520093696
                            ],
                            bits: m,
                            createMethod: function(e, t) {
                                var r = _(e, t, "hex");
                                return r.create = function(r) {
                                    return new N(e, t, r);
                                }, r.update = function(e, t) {
                                    return r.create(t).update(e);
                                }, S(r, _, e, t);
                            }
                        },
                        {
                            name: "cshake",
                            padding: p,
                            bits: m,
                            createMethod: function(e, t) {
                                var r = w[e], n = A(e, 0, "hex");
                                return n.create = function(n, i, o) {
                                    return i || o ? new N(e, t, n).bytepad([
                                        i,
                                        o
                                    ], r) : O["shake" + e].create(n);
                                }, n.update = function(e, t, r, i) {
                                    return n.create(t, r, i).update(e);
                                }, S(n, A, e, t);
                            }
                        },
                        {
                            name: "kmac",
                            padding: p,
                            bits: m,
                            createMethod: function(e, t) {
                                var r = w[e], n = E(e, 0, "hex");
                                return n.create = function(n, i, o) {
                                    return new j(e, t, i).bytepad([
                                        "KMAC",
                                        o
                                    ], r).bytepad([
                                        n
                                    ], r);
                                }, n.update = function(e, t, r, i) {
                                    return n.create(e, r, i).update(t);
                                }, S(n, E, e, t);
                            }
                        }
                    ], O = {}, P = [], I = 0; I < B.length; ++I)for(var T = B[I], C = T.bits, M = 0; M < C.length; ++M){
                        var R = T.name + "_" + C[M];
                        if (P.push(R), O[R] = T.createMethod(C[M], T.padding), "sha3" !== T.name) {
                            var U = T.name + C[M];
                            P.push(U), O[U] = O[R];
                        }
                    }
                    function N(e, t, r) {
                        this.blocks = [], this.s = [], this.padding = t, this.outputBits = r, this.reset = !0, this.finalized = !1, this.block = 0, this.start = 0, this.blockCount = 1600 - (e << 1) >> 5, this.byteCount = this.blockCount << 2, this.outputBlocks = r >> 5, this.extraBytes = (31 & r) >> 3;
                        for(var n = 0; n < 50; ++n)this.s[n] = 0;
                    }
                    function j(e, t, r) {
                        N.call(this, e, t, r);
                    }
                    N.prototype.update = function(e) {
                        if (this.finalized) throw new Error("finalize already called");
                        var t, r = (0, o.default)(e);
                        if ("string" !== r) {
                            if ("object" !== r) throw new Error(a);
                            if (null === e) throw new Error(a);
                            if (l && e.constructor === ArrayBuffer) e = new Uint8Array(e);
                            else if (!(Array.isArray(e) || l && ArrayBuffer.isView(e))) throw new Error(a);
                            t = !0;
                        }
                        for(var n, i, s = this.blocks, u = this.byteCount, c = e.length, f = this.blockCount, d = 0, h = this.s; d < c;){
                            if (this.reset) for(this.reset = !1, s[0] = this.block, n = 1; n < f + 1; ++n)s[n] = 0;
                            if (t) for(n = this.start; d < c && n < u; ++d)s[n >> 2] |= e[d] << b[3 & n++];
                            else for(n = this.start; d < c && n < u; ++d)(i = e.charCodeAt(d)) < 128 ? s[n >> 2] |= i << b[3 & n++] : i < 2048 ? (s[n >> 2] |= (192 | i >> 6) << b[3 & n++], s[n >> 2] |= (128 | 63 & i) << b[3 & n++]) : i < 55296 || i >= 57344 ? (s[n >> 2] |= (224 | i >> 12) << b[3 & n++], s[n >> 2] |= (128 | i >> 6 & 63) << b[3 & n++], s[n >> 2] |= (128 | 63 & i) << b[3 & n++]) : (i = 65536 + ((1023 & i) << 10 | 1023 & e.charCodeAt(++d)), s[n >> 2] |= (240 | i >> 18) << b[3 & n++], s[n >> 2] |= (128 | i >> 12 & 63) << b[3 & n++], s[n >> 2] |= (128 | i >> 6 & 63) << b[3 & n++], s[n >> 2] |= (128 | 63 & i) << b[3 & n++]);
                            if (this.lastByteIndex = n, n >= u) {
                                for(this.start = n - u, this.block = s[f], n = 0; n < f; ++n)h[n] ^= s[n];
                                L(h), this.reset = !0;
                            } else this.start = n;
                        }
                        return this;
                    }, N.prototype.encode = function(e, t) {
                        var r = 255 & e, n = 1, i = [
                            r
                        ];
                        for(r = 255 & (e >>= 8); r > 0;)i.unshift(r), r = 255 & (e >>= 8), ++n;
                        return t ? i.push(n) : i.unshift(n), this.update(i), i.length;
                    }, N.prototype.encodeString = function(e) {
                        var t, r = (0, o.default)(e);
                        if ("string" !== r) {
                            if ("object" !== r) throw new Error(a);
                            if (null === e) throw new Error(a);
                            if (l && e.constructor === ArrayBuffer) e = new Uint8Array(e);
                            else if (!(Array.isArray(e) || l && ArrayBuffer.isView(e))) throw new Error(a);
                            t = !0;
                        }
                        var n = 0, i = e.length;
                        if (t) n = i;
                        else for(var s = 0; s < e.length; ++s){
                            var u = e.charCodeAt(s);
                            u < 128 ? n += 1 : u < 2048 ? n += 2 : u < 55296 || u >= 57344 ? n += 3 : (u = 65536 + ((1023 & u) << 10 | 1023 & e.charCodeAt(++s)), n += 4);
                        }
                        return n += this.encode(8 * n), this.update(e), n;
                    }, N.prototype.bytepad = function(e, t) {
                        for(var r = this.encode(t), n = 0; n < e.length; ++n)r += this.encodeString(e[n]);
                        var i = t - r % t, o = [];
                        return o.length = i, this.update(o), this;
                    }, N.prototype.finalize = function() {
                        if (!this.finalized) {
                            this.finalized = !0;
                            var e = this.blocks, t = this.lastByteIndex, r = this.blockCount, n = this.s;
                            if (e[t >> 2] |= this.padding[3 & t], this.lastByteIndex === this.byteCount) for(e[0] = e[r], t = 1; t < r + 1; ++t)e[t] = 0;
                            for(e[r - 1] |= 2147483648, t = 0; t < r; ++t)n[t] ^= e[t];
                            L(n);
                        }
                    }, N.prototype.toString = N.prototype.hex = function() {
                        this.finalize();
                        for(var e, t = this.blockCount, r = this.s, n = this.outputBlocks, i = this.extraBytes, o = 0, a = 0, s = ""; a < n;){
                            for(o = 0; o < t && a < n; ++o, ++a)e = r[o], s += h[e >> 4 & 15] + h[15 & e] + h[e >> 12 & 15] + h[e >> 8 & 15] + h[e >> 20 & 15] + h[e >> 16 & 15] + h[e >> 28 & 15] + h[e >> 24 & 15];
                            a % t == 0 && (L(r), o = 0);
                        }
                        return i && (e = r[o], s += h[e >> 4 & 15] + h[15 & e], i > 1 && (s += h[e >> 12 & 15] + h[e >> 8 & 15]), i > 2 && (s += h[e >> 20 & 15] + h[e >> 16 & 15])), s;
                    }, N.prototype.arrayBuffer = function() {
                        this.finalize();
                        var e, t = this.blockCount, r = this.s, n = this.outputBlocks, i = this.extraBytes, o = 0, a = 0, s = this.outputBits >> 3;
                        e = i ? new ArrayBuffer(n + 1 << 2) : new ArrayBuffer(s);
                        for(var u = new Uint32Array(e); a < n;){
                            for(o = 0; o < t && a < n; ++o, ++a)u[a] = r[o];
                            a % t == 0 && L(r);
                        }
                        return i && (u[o] = r[o], e = e.slice(0, s)), e;
                    }, N.prototype.buffer = N.prototype.arrayBuffer, N.prototype.digest = N.prototype.array = function() {
                        this.finalize();
                        for(var e, t, r = this.blockCount, n = this.s, i = this.outputBlocks, o = this.extraBytes, a = 0, s = 0, u = []; s < i;){
                            for(a = 0; a < r && s < i; ++a, ++s)e = s << 2, t = n[a], u[e] = 255 & t, u[e + 1] = t >> 8 & 255, u[e + 2] = t >> 16 & 255, u[e + 3] = t >> 24 & 255;
                            s % r == 0 && L(n);
                        }
                        return o && (e = s << 2, t = n[a], u[e] = 255 & t, o > 1 && (u[e + 1] = t >> 8 & 255), o > 2 && (u[e + 2] = t >> 16 & 255)), u;
                    }, j.prototype = new N, j.prototype.finalize = function() {
                        return this.encode(this.outputBits, !0), N.prototype.finalize.call(this);
                    };
                    var L = function(e) {
                        var t, r, n, i, o, a, s, u, c, f, d, l, h, p, b, v, m, g, w, k, _, A, E, S, x, B, O, P, I, T, C, M, R, U, N, j, L, F, D, H, z, q, K, G, V, Z, W, J, Y, X, Q, $, ee, te, re, ne, ie, oe, ae, se, ue, ce, fe;
                        for(n = 0; n < 48; n += 2)i = e[0] ^ e[10] ^ e[20] ^ e[30] ^ e[40], o = e[1] ^ e[11] ^ e[21] ^ e[31] ^ e[41], a = e[2] ^ e[12] ^ e[22] ^ e[32] ^ e[42], s = e[3] ^ e[13] ^ e[23] ^ e[33] ^ e[43], u = e[4] ^ e[14] ^ e[24] ^ e[34] ^ e[44], c = e[5] ^ e[15] ^ e[25] ^ e[35] ^ e[45], f = e[6] ^ e[16] ^ e[26] ^ e[36] ^ e[46], d = e[7] ^ e[17] ^ e[27] ^ e[37] ^ e[47], t = (l = e[8] ^ e[18] ^ e[28] ^ e[38] ^ e[48]) ^ (a << 1 | s >>> 31), r = (h = e[9] ^ e[19] ^ e[29] ^ e[39] ^ e[49]) ^ (s << 1 | a >>> 31), e[0] ^= t, e[1] ^= r, e[10] ^= t, e[11] ^= r, e[20] ^= t, e[21] ^= r, e[30] ^= t, e[31] ^= r, e[40] ^= t, e[41] ^= r, t = i ^ (u << 1 | c >>> 31), r = o ^ (c << 1 | u >>> 31), e[2] ^= t, e[3] ^= r, e[12] ^= t, e[13] ^= r, e[22] ^= t, e[23] ^= r, e[32] ^= t, e[33] ^= r, e[42] ^= t, e[43] ^= r, t = a ^ (f << 1 | d >>> 31), r = s ^ (d << 1 | f >>> 31), e[4] ^= t, e[5] ^= r, e[14] ^= t, e[15] ^= r, e[24] ^= t, e[25] ^= r, e[34] ^= t, e[35] ^= r, e[44] ^= t, e[45] ^= r, t = u ^ (l << 1 | h >>> 31), r = c ^ (h << 1 | l >>> 31), e[6] ^= t, e[7] ^= r, e[16] ^= t, e[17] ^= r, e[26] ^= t, e[27] ^= r, e[36] ^= t, e[37] ^= r, e[46] ^= t, e[47] ^= r, t = f ^ (i << 1 | o >>> 31), r = d ^ (o << 1 | i >>> 31), e[8] ^= t, e[9] ^= r, e[18] ^= t, e[19] ^= r, e[28] ^= t, e[29] ^= r, e[38] ^= t, e[39] ^= r, e[48] ^= t, e[49] ^= r, p = e[0], b = e[1], Z = e[11] << 4 | e[10] >>> 28, W = e[10] << 4 | e[11] >>> 28, P = e[20] << 3 | e[21] >>> 29, I = e[21] << 3 | e[20] >>> 29, se = e[31] << 9 | e[30] >>> 23, ue = e[30] << 9 | e[31] >>> 23, q = e[40] << 18 | e[41] >>> 14, K = e[41] << 18 | e[40] >>> 14, U = e[2] << 1 | e[3] >>> 31, N = e[3] << 1 | e[2] >>> 31, v = e[13] << 12 | e[12] >>> 20, m = e[12] << 12 | e[13] >>> 20, J = e[22] << 10 | e[23] >>> 22, Y = e[23] << 10 | e[22] >>> 22, T = e[33] << 13 | e[32] >>> 19, C = e[32] << 13 | e[33] >>> 19, ce = e[42] << 2 | e[43] >>> 30, fe = e[43] << 2 | e[42] >>> 30, te = e[5] << 30 | e[4] >>> 2, re = e[4] << 30 | e[5] >>> 2, j = e[14] << 6 | e[15] >>> 26, L = e[15] << 6 | e[14] >>> 26, g = e[25] << 11 | e[24] >>> 21, w = e[24] << 11 | e[25] >>> 21, X = e[34] << 15 | e[35] >>> 17, Q = e[35] << 15 | e[34] >>> 17, M = e[45] << 29 | e[44] >>> 3, R = e[44] << 29 | e[45] >>> 3, S = e[6] << 28 | e[7] >>> 4, x = e[7] << 28 | e[6] >>> 4, ne = e[17] << 23 | e[16] >>> 9, ie = e[16] << 23 | e[17] >>> 9, F = e[26] << 25 | e[27] >>> 7, D = e[27] << 25 | e[26] >>> 7, k = e[36] << 21 | e[37] >>> 11, _ = e[37] << 21 | e[36] >>> 11, $ = e[47] << 24 | e[46] >>> 8, ee = e[46] << 24 | e[47] >>> 8, G = e[8] << 27 | e[9] >>> 5, V = e[9] << 27 | e[8] >>> 5, B = e[18] << 20 | e[19] >>> 12, O = e[19] << 20 | e[18] >>> 12, oe = e[29] << 7 | e[28] >>> 25, ae = e[28] << 7 | e[29] >>> 25, H = e[38] << 8 | e[39] >>> 24, z = e[39] << 8 | e[38] >>> 24, A = e[48] << 14 | e[49] >>> 18, E = e[49] << 14 | e[48] >>> 18, e[0] = p ^ ~v & g, e[1] = b ^ ~m & w, e[10] = S ^ ~B & P, e[11] = x ^ ~O & I, e[20] = U ^ ~j & F, e[21] = N ^ ~L & D, e[30] = G ^ ~Z & J, e[31] = V ^ ~W & Y, e[40] = te ^ ~ne & oe, e[41] = re ^ ~ie & ae, e[2] = v ^ ~g & k, e[3] = m ^ ~w & _, e[12] = B ^ ~P & T, e[13] = O ^ ~I & C, e[22] = j ^ ~F & H, e[23] = L ^ ~D & z, e[32] = Z ^ ~J & X, e[33] = W ^ ~Y & Q, e[42] = ne ^ ~oe & se, e[43] = ie ^ ~ae & ue, e[4] = g ^ ~k & A, e[5] = w ^ ~_ & E, e[14] = P ^ ~T & M, e[15] = I ^ ~C & R, e[24] = F ^ ~H & q, e[25] = D ^ ~z & K, e[34] = J ^ ~X & $, e[35] = Y ^ ~Q & ee, e[44] = oe ^ ~se & ce, e[45] = ae ^ ~ue & fe, e[6] = k ^ ~A & p, e[7] = _ ^ ~E & b, e[16] = T ^ ~M & S, e[17] = C ^ ~R & x, e[26] = H ^ ~q & U, e[27] = z ^ ~K & N, e[36] = X ^ ~$ & G, e[37] = Q ^ ~ee & V, e[46] = se ^ ~ce & te, e[47] = ue ^ ~fe & re, e[8] = A ^ ~p & v, e[9] = E ^ ~b & m, e[18] = M ^ ~S & B, e[19] = R ^ ~x & O, e[28] = q ^ ~U & j, e[29] = K ^ ~N & L, e[38] = $ ^ ~G & Z, e[39] = ee ^ ~V & W, e[48] = ce ^ ~te & ne, e[49] = fe ^ ~re & ie, e[0] ^= y[n], e[1] ^= y[n + 1];
                    };
                    if (f) e.exports = O;
                    else {
                        for(I = 0; I < P.length; ++I)u[P[I]] = O[P[I]];
                        d && (void 0 === (n = (function() {
                            return O;
                        }).call(t, r, t, e)) || (e.exports = n));
                    }
                }();
            },
            37252: (e, t)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.version = void 0, t.version = "logger/5.7.0";
            },
            64327: (e, t, r)=>{
                "use strict";
                var n = r(28847);
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.Logger = t.LogLevel = t.ErrorCode = void 0;
                var i, o, a = n(r(69721)), s = n(r(58985)), u = r(37252), c = !1, f = !1, d = {
                    debug: 1,
                    default: 2,
                    info: 2,
                    warning: 3,
                    error: 4,
                    off: 5
                }, l = d.default, h = null, p = function() {
                    try {
                        var e = [];
                        if ([
                            "NFD",
                            "NFC",
                            "NFKD",
                            "NFKC"
                        ].forEach(function(t) {
                            try {
                                if ("test" !== "test".normalize(t)) throw new Error("bad normalize");
                            } catch (r) {
                                e.push(t);
                            }
                        }), e.length) throw new Error("missing " + e.join(", "));
                        if (String.fromCharCode(233).normalize("NFD") !== String.fromCharCode(101, 769)) throw new Error("broken implementation");
                    } catch (e) {
                        return e.message;
                    }
                    return null;
                }();
                t.LogLevel = i, function(e) {
                    e.DEBUG = "DEBUG", e.INFO = "INFO", e.WARNING = "WARNING", e.ERROR = "ERROR", e.OFF = "OFF";
                }(i || (t.LogLevel = i = {})), t.ErrorCode = o, function(e) {
                    e.UNKNOWN_ERROR = "UNKNOWN_ERROR", e.NOT_IMPLEMENTED = "NOT_IMPLEMENTED", e.UNSUPPORTED_OPERATION = "UNSUPPORTED_OPERATION", e.NETWORK_ERROR = "NETWORK_ERROR", e.SERVER_ERROR = "SERVER_ERROR", e.TIMEOUT = "TIMEOUT", e.BUFFER_OVERRUN = "BUFFER_OVERRUN", e.NUMERIC_FAULT = "NUMERIC_FAULT", e.MISSING_NEW = "MISSING_NEW", e.INVALID_ARGUMENT = "INVALID_ARGUMENT", e.MISSING_ARGUMENT = "MISSING_ARGUMENT", e.UNEXPECTED_ARGUMENT = "UNEXPECTED_ARGUMENT", e.CALL_EXCEPTION = "CALL_EXCEPTION", e.INSUFFICIENT_FUNDS = "INSUFFICIENT_FUNDS", e.NONCE_EXPIRED = "NONCE_EXPIRED", e.REPLACEMENT_UNDERPRICED = "REPLACEMENT_UNDERPRICED", e.UNPREDICTABLE_GAS_LIMIT = "UNPREDICTABLE_GAS_LIMIT", e.TRANSACTION_REPLACED = "TRANSACTION_REPLACED", e.ACTION_REJECTED = "ACTION_REJECTED";
                }(o || (t.ErrorCode = o = {}));
                var b = "0123456789abcdef", y = function() {
                    function e(t) {
                        (0, a.default)(this, e), Object.defineProperty(this, "version", {
                            enumerable: !0,
                            value: t,
                            writable: !1
                        });
                    }
                    return (0, s.default)(e, [
                        {
                            key: "_log",
                            value: function(e, t) {
                                var r = e.toLowerCase();
                                null == d[r] && this.throwArgumentError("invalid log level name", "logLevel", e), l > d[r] || console.log.apply(console, t);
                            }
                        },
                        {
                            key: "debug",
                            value: function() {
                                for(var t = arguments.length, r = new Array(t), n = 0; n < t; n++)r[n] = arguments[n];
                                this._log(e.levels.DEBUG, r);
                            }
                        },
                        {
                            key: "info",
                            value: function() {
                                for(var t = arguments.length, r = new Array(t), n = 0; n < t; n++)r[n] = arguments[n];
                                this._log(e.levels.INFO, r);
                            }
                        },
                        {
                            key: "warn",
                            value: function() {
                                for(var t = arguments.length, r = new Array(t), n = 0; n < t; n++)r[n] = arguments[n];
                                this._log(e.levels.WARNING, r);
                            }
                        },
                        {
                            key: "makeError",
                            value: function(t, r, n) {
                                if (f) return this.makeError("censored error", r, {});
                                r || (r = e.errors.UNKNOWN_ERROR), n || (n = {});
                                var i = [];
                                Object.keys(n).forEach(function(e) {
                                    var t = n[e];
                                    try {
                                        if (t instanceof Uint8Array) {
                                            for(var r = "", o = 0; o < t.length; o++)r += b[t[o] >> 4], r += b[15 & t[o]];
                                            i.push(e + "=Uint8Array(0x" + r + ")");
                                        } else i.push(e + "=" + JSON.stringify(t));
                                    } catch (t) {
                                        i.push(e + "=" + JSON.stringify(n[e].toString()));
                                    }
                                }), i.push("code=".concat(r)), i.push("version=".concat(this.version));
                                var a = t, s = "";
                                switch(r){
                                    case o.NUMERIC_FAULT:
                                        s = "NUMERIC_FAULT";
                                        var u = t;
                                        switch(u){
                                            case "overflow":
                                            case "underflow":
                                            case "division-by-zero":
                                                s += "-" + u;
                                                break;
                                            case "negative-power":
                                            case "negative-width":
                                                s += "-unsupported";
                                                break;
                                            case "unbound-bitwise-result":
                                                s += "-unbound-result";
                                        }
                                        break;
                                    case o.CALL_EXCEPTION:
                                    case o.INSUFFICIENT_FUNDS:
                                    case o.MISSING_NEW:
                                    case o.NONCE_EXPIRED:
                                    case o.REPLACEMENT_UNDERPRICED:
                                    case o.TRANSACTION_REPLACED:
                                    case o.UNPREDICTABLE_GAS_LIMIT:
                                        s = r;
                                }
                                s && (t += " [ See: https://links.ethers.org/v5-errors-" + s + " ]"), i.length && (t += " (" + i.join(", ") + ")");
                                var c = new Error(t);
                                return c.reason = a, c.code = r, Object.keys(n).forEach(function(e) {
                                    c[e] = n[e];
                                }), c;
                            }
                        },
                        {
                            key: "throwError",
                            value: function(e, t, r) {
                                throw this.makeError(e, t, r);
                            }
                        },
                        {
                            key: "throwArgumentError",
                            value: function(t, r, n) {
                                return this.throwError(t, e.errors.INVALID_ARGUMENT, {
                                    argument: r,
                                    value: n
                                });
                            }
                        },
                        {
                            key: "assert",
                            value: function(e, t, r, n) {
                                e || this.throwError(t, r, n);
                            }
                        },
                        {
                            key: "assertArgument",
                            value: function(e, t, r, n) {
                                e || this.throwArgumentError(t, r, n);
                            }
                        },
                        {
                            key: "checkNormalize",
                            value: function(t) {
                                null == t && (t = "platform missing String.prototype.normalize"), p && this.throwError("platform missing String.prototype.normalize", e.errors.UNSUPPORTED_OPERATION, {
                                    operation: "String.prototype.normalize",
                                    form: p
                                });
                            }
                        },
                        {
                            key: "checkSafeUint53",
                            value: function(t, r) {
                                "number" == typeof t && (null == r && (r = "value not safe"), (t < 0 || t >= 9007199254740991) && this.throwError(r, e.errors.NUMERIC_FAULT, {
                                    operation: "checkSafeInteger",
                                    fault: "out-of-safe-range",
                                    value: t
                                }), t % 1 && this.throwError(r, e.errors.NUMERIC_FAULT, {
                                    operation: "checkSafeInteger",
                                    fault: "non-integer",
                                    value: t
                                }));
                            }
                        },
                        {
                            key: "checkArgumentCount",
                            value: function(t, r, n) {
                                n = n ? ": " + n : "", t < r && this.throwError("missing argument" + n, e.errors.MISSING_ARGUMENT, {
                                    count: t,
                                    expectedCount: r
                                }), t > r && this.throwError("too many arguments" + n, e.errors.UNEXPECTED_ARGUMENT, {
                                    count: t,
                                    expectedCount: r
                                });
                            }
                        },
                        {
                            key: "checkNew",
                            value: function(t, r) {
                                t !== Object && null != t || this.throwError("missing new", e.errors.MISSING_NEW, {
                                    name: r.name
                                });
                            }
                        },
                        {
                            key: "checkAbstract",
                            value: function(t, r) {
                                t === r ? this.throwError("cannot instantiate abstract class " + JSON.stringify(r.name) + " directly; use a sub-class", e.errors.UNSUPPORTED_OPERATION, {
                                    name: t.name,
                                    operation: "new"
                                }) : t !== Object && null != t || this.throwError("missing new", e.errors.MISSING_NEW, {
                                    name: r.name
                                });
                            }
                        }
                    ], [
                        {
                            key: "globalLogger",
                            value: function() {
                                return h || (h = new e(u.version)), h;
                            }
                        },
                        {
                            key: "setCensorship",
                            value: function(t, r) {
                                if (!t && r && this.globalLogger().throwError("cannot permanently disable censorship", e.errors.UNSUPPORTED_OPERATION, {
                                    operation: "setCensorship"
                                }), c) {
                                    if (!t) return;
                                    this.globalLogger().throwError("error censorship permanent", e.errors.UNSUPPORTED_OPERATION, {
                                        operation: "setCensorship"
                                    });
                                }
                                f = !!t, c = !!r;
                            }
                        },
                        {
                            key: "setLogLevel",
                            value: function(t) {
                                var r = d[t.toLowerCase()];
                                null != r ? l = r : e.globalLogger().warn("invalid log level - " + t);
                            }
                        },
                        {
                            key: "from",
                            value: function(t) {
                                return new e(t);
                            }
                        }
                    ]), e;
                }();
                t.Logger = y, y.errors = o, y.levels = i;
            },
            64071: (e, t)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.version = void 0, t.version = "properties/5.7.0";
            },
            23694: (e, t, r)=>{
                "use strict";
                var n = r(28847);
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.Description = void 0, t.checkProperties = function(e, t) {
                    e && "object" === (0, s.default)(e) || d.throwArgumentError("invalid object", "object", e), Object.keys(e).forEach(function(r) {
                        t[r] || d.throwArgumentError("invalid object key - " + r, "transaction:" + r, e);
                    });
                }, t.deepCopy = y, t.defineReadOnly = l, t.getStatic = function(e, t) {
                    for(var r = 0; r < 32; r++){
                        if (e[t]) return e[t];
                        if (!e.prototype || "object" !== (0, s.default)(e.prototype)) break;
                        e = Object.getPrototypeOf(e.prototype).constructor;
                    }
                    return null;
                }, t.resolveProperties = function(e) {
                    return f(this, void 0, void 0, i.default.mark(function t() {
                        var r, n;
                        return i.default.wrap(function(t) {
                            for(;;)switch(t.prev = t.next){
                                case 0:
                                    return r = Object.keys(e).map(function(t) {
                                        var r = e[t];
                                        return Promise.resolve(r).then(function(e) {
                                            return {
                                                key: t,
                                                value: e
                                            };
                                        });
                                    }), t.next = 3, Promise.all(r);
                                case 3:
                                    return n = t.sent, t.abrupt("return", n.reduce(function(e, t) {
                                        return e[t.key] = t.value, e;
                                    }, {}));
                                case 5:
                                case "end":
                                    return t.stop();
                            }
                        }, t);
                    }));
                }, t.shallowCopy = function(e) {
                    var t = {};
                    for(var r in e)t[r] = e[r];
                    return t;
                };
                var i = n(r(82247)), o = n(r(58985)), a = n(r(69721)), s = n(r(3355)), u = r(64327), c = r(64071), f = function(e, t, r, n) {
                    return new (r || (r = Promise))(function(i, o) {
                        function a(e) {
                            try {
                                u(n.next(e));
                            } catch (e) {
                                o(e);
                            }
                        }
                        function s(e) {
                            try {
                                u(n.throw(e));
                            } catch (e) {
                                o(e);
                            }
                        }
                        function u(e) {
                            var t;
                            e.done ? i(e.value) : (t = e.value, t instanceof r ? t : new r(function(e) {
                                e(t);
                            })).then(a, s);
                        }
                        u((n = n.apply(e, t || [])).next());
                    });
                }, d = new u.Logger(c.version);
                function l(e, t, r) {
                    Object.defineProperty(e, t, {
                        enumerable: !0,
                        value: r,
                        writable: !1
                    });
                }
                var h = {
                    bigint: !0,
                    boolean: !0,
                    function: !0,
                    number: !0,
                    string: !0
                };
                function p(e) {
                    if (null == e || h[(0, s.default)(e)]) return !0;
                    if (Array.isArray(e) || "object" === (0, s.default)(e)) {
                        if (!Object.isFrozen(e)) return !1;
                        for(var t = Object.keys(e), r = 0; r < t.length; r++){
                            var n = null;
                            try {
                                n = e[t[r]];
                            } catch (e) {
                                continue;
                            }
                            if (!p(n)) return !1;
                        }
                        return !0;
                    }
                    return d.throwArgumentError("Cannot deepCopy ".concat((0, s.default)(e)), "object", e);
                }
                function b(e) {
                    if (p(e)) return e;
                    if (Array.isArray(e)) return Object.freeze(e.map(function(e) {
                        return y(e);
                    }));
                    if ("object" === (0, s.default)(e)) {
                        var t = {};
                        for(var r in e){
                            var n = e[r];
                            void 0 !== n && l(t, r, y(n));
                        }
                        return t;
                    }
                    return d.throwArgumentError("Cannot deepCopy ".concat((0, s.default)(e)), "object", e);
                }
                function y(e) {
                    return b(e);
                }
                var v = (0, o.default)(function e(t) {
                    for(var r in (0, a.default)(this, e), t)this[r] = y(t[r]);
                });
                t.Description = v;
            },
            61466: (e, t)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.version = void 0, t.version = "rlp/5.7.0";
            },
            55265: (e, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.decode = function(e) {
                    var t = (0, n.arrayify)(e), r = d(t, 0);
                    return r.consumed !== t.length && a.throwArgumentError("invalid rlp data", "data", e), r.result;
                }, t.encode = function(e) {
                    return (0, n.hexlify)(c(e));
                };
                var n = r(908), i = r(64327), o = r(61466), a = new i.Logger(o.version);
                function s(e) {
                    for(var t = []; e;)t.unshift(255 & e), e >>= 8;
                    return t;
                }
                function u(e, t, r) {
                    for(var n = 0, i = 0; i < r; i++)n = 256 * n + e[t + i];
                    return n;
                }
                function c(e) {
                    if (Array.isArray(e)) {
                        var t = [];
                        if (e.forEach(function(e) {
                            t = t.concat(c(e));
                        }), t.length <= 55) return t.unshift(192 + t.length), t;
                        var r = s(t.length);
                        return r.unshift(247 + r.length), r.concat(t);
                    }
                    (0, n.isBytesLike)(e) || a.throwArgumentError("RLP object must be BytesLike", "object", e);
                    var i = Array.prototype.slice.call((0, n.arrayify)(e));
                    if (1 === i.length && i[0] <= 127) return i;
                    if (i.length <= 55) return i.unshift(128 + i.length), i;
                    var o = s(i.length);
                    return o.unshift(183 + o.length), o.concat(i);
                }
                function f(e, t, r, n) {
                    for(var o = []; r < t + 1 + n;){
                        var s = d(e, r);
                        o.push(s.result), (r += s.consumed) > t + 1 + n && a.throwError("child data too short", i.Logger.errors.BUFFER_OVERRUN, {});
                    }
                    return {
                        consumed: 1 + n,
                        result: o
                    };
                }
                function d(e, t) {
                    if (0 === e.length && a.throwError("data too short", i.Logger.errors.BUFFER_OVERRUN, {}), e[t] >= 248) {
                        var r = e[t] - 247;
                        t + 1 + r > e.length && a.throwError("data short segment too short", i.Logger.errors.BUFFER_OVERRUN, {});
                        var o = u(e, t + 1, r);
                        return t + 1 + r + o > e.length && a.throwError("data long segment too short", i.Logger.errors.BUFFER_OVERRUN, {}), f(e, t, t + 1 + r, r + o);
                    }
                    if (e[t] >= 192) {
                        var s = e[t] - 192;
                        return t + 1 + s > e.length && a.throwError("data array too short", i.Logger.errors.BUFFER_OVERRUN, {}), f(e, t, t + 1, s);
                    }
                    if (e[t] >= 184) {
                        var c = e[t] - 183;
                        t + 1 + c > e.length && a.throwError("data array too short", i.Logger.errors.BUFFER_OVERRUN, {});
                        var d = u(e, t + 1, c);
                        return t + 1 + c + d > e.length && a.throwError("data array too short", i.Logger.errors.BUFFER_OVERRUN, {}), {
                            consumed: 1 + c + d,
                            result: (0, n.hexlify)(e.slice(t + 1 + c, t + 1 + c + d))
                        };
                    }
                    if (e[t] >= 128) {
                        var l = e[t] - 128;
                        return t + 1 + l > e.length && a.throwError("data too short", i.Logger.errors.BUFFER_OVERRUN, {}), {
                            consumed: 1 + l,
                            result: (0, n.hexlify)(e.slice(t + 1, t + 1 + l))
                        };
                    }
                    return {
                        consumed: 1,
                        result: (0, n.hexlify)(e[t])
                    };
                }
            },
            48100: (e, t)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.version = void 0, t.version = "signing-key/5.7.0";
            },
            36918: (e, t, r)=>{
                "use strict";
                var n = r(28847);
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.EC = void 0;
                var i = n(r(3355)), o = n(r(31734)), a = n(r(37198));
                function s(e, t, r) {
                    return r = {
                        path: t,
                        exports: {},
                        require: function(e, t) {
                            return function() {
                                throw new Error("Dynamic requires are not currently supported by @rollup/plugin-commonjs");
                            }(null == t && r.path);
                        }
                    }, e(r, r.exports), r.exports;
                }
                "undefined" != typeof globalThis ? globalThis : "undefined" != typeof window ? window : void 0 !== r.g ? r.g : "undefined" != typeof self && self;
                var u = c;
                function c(e, t) {
                    if (!e) throw new Error(t || "Assertion failed");
                }
                c.equal = function(e, t, r) {
                    if (e != t) throw new Error(r || "Assertion failed: " + e + " != " + t);
                };
                var f = s(function(e, t) {
                    var r = t;
                    function n(e) {
                        return 1 === e.length ? "0" + e : e;
                    }
                    function i(e) {
                        for(var t = "", r = 0; r < e.length; r++)t += n(e[r].toString(16));
                        return t;
                    }
                    r.toArray = function(e, t) {
                        if (Array.isArray(e)) return e.slice();
                        if (!e) return [];
                        var r = [];
                        if ("string" != typeof e) {
                            for(var n = 0; n < e.length; n++)r[n] = 0 | e[n];
                            return r;
                        }
                        if ("hex" === t) for((e = e.replace(/[^a-z0-9]+/gi, "")).length % 2 != 0 && (e = "0" + e), n = 0; n < e.length; n += 2)r.push(parseInt(e[n] + e[n + 1], 16));
                        else for(n = 0; n < e.length; n++){
                            var i = e.charCodeAt(n), o = i >> 8, a = 255 & i;
                            o ? r.push(o, a) : r.push(a);
                        }
                        return r;
                    }, r.zero2 = n, r.toHex = i, r.encode = function(e, t) {
                        return "hex" === t ? i(e) : e;
                    };
                }), d = s(function(e, t) {
                    var r = t;
                    r.assert = u, r.toArray = f.toArray, r.zero2 = f.zero2, r.toHex = f.toHex, r.encode = f.encode, r.getNAF = function(e, t, r) {
                        var n = new Array(Math.max(e.bitLength(), r) + 1);
                        n.fill(0);
                        for(var i = 1 << t + 1, o = e.clone(), a = 0; a < n.length; a++){
                            var s, u = o.andln(i - 1);
                            o.isOdd() ? (s = u > (i >> 1) - 1 ? (i >> 1) - u : u, o.isubn(s)) : s = 0, n[a] = s, o.iushrn(1);
                        }
                        return n;
                    }, r.getJSF = function(e, t) {
                        var r = [
                            [],
                            []
                        ];
                        e = e.clone(), t = t.clone();
                        for(var n, i = 0, o = 0; e.cmpn(-i) > 0 || t.cmpn(-o) > 0;){
                            var a, s, u = e.andln(3) + i & 3, c = t.andln(3) + o & 3;
                            3 === u && (u = -1), 3 === c && (c = -1), a = 0 == (1 & u) ? 0 : 3 != (n = e.andln(7) + i & 7) && 5 !== n || 2 !== c ? u : -u, r[0].push(a), s = 0 == (1 & c) ? 0 : 3 != (n = t.andln(7) + o & 7) && 5 !== n || 2 !== u ? c : -c, r[1].push(s), 2 * i === a + 1 && (i = 1 - i), 2 * o === s + 1 && (o = 1 - o), e.iushrn(1), t.iushrn(1);
                        }
                        return r;
                    }, r.cachedProperty = function(e, t, r) {
                        var n = "_" + t;
                        e.prototype[t] = function() {
                            return void 0 !== this[n] ? this[n] : this[n] = r.call(this);
                        };
                    }, r.parseBytes = function(e) {
                        return "string" == typeof e ? r.toArray(e, "hex") : e;
                    }, r.intFromLE = function(e) {
                        return new o.default(e, "hex", "le");
                    };
                }), l = d.getNAF, h = d.getJSF, p = d.assert;
                function b(e, t) {
                    this.type = e, this.p = new o.default(t.p, 16), this.red = t.prime ? o.default.red(t.prime) : o.default.mont(this.p), this.zero = new o.default(0).toRed(this.red), this.one = new o.default(1).toRed(this.red), this.two = new o.default(2).toRed(this.red), this.n = t.n && new o.default(t.n, 16), this.g = t.g && this.pointFromJSON(t.g, t.gRed), this._wnafT1 = new Array(4), this._wnafT2 = new Array(4), this._wnafT3 = new Array(4), this._wnafT4 = new Array(4), this._bitLength = this.n ? this.n.bitLength() : 0;
                    var r = this.n && this.p.div(this.n);
                    !r || r.cmpn(100) > 0 ? this.redN = null : (this._maxwellTrick = !0, this.redN = this.n.toRed(this.red));
                }
                var y = b;
                function v(e, t) {
                    this.curve = e, this.type = t, this.precomputed = null;
                }
                b.prototype.point = function() {
                    throw new Error("Not implemented");
                }, b.prototype.validate = function() {
                    throw new Error("Not implemented");
                }, b.prototype._fixedNafMul = function(e, t) {
                    p(e.precomputed);
                    var r = e._getDoubles(), n = l(t, 1, this._bitLength), i = (1 << r.step + 1) - (r.step % 2 == 0 ? 2 : 1);
                    i /= 3;
                    var o, a, s = [];
                    for(o = 0; o < n.length; o += r.step){
                        a = 0;
                        for(var u = o + r.step - 1; u >= o; u--)a = (a << 1) + n[u];
                        s.push(a);
                    }
                    for(var c = this.jpoint(null, null, null), f = this.jpoint(null, null, null), d = i; d > 0; d--){
                        for(o = 0; o < s.length; o++)(a = s[o]) === d ? f = f.mixedAdd(r.points[o]) : a === -d && (f = f.mixedAdd(r.points[o].neg()));
                        c = c.add(f);
                    }
                    return c.toP();
                }, b.prototype._wnafMul = function(e, t) {
                    var r = 4, n = e._getNAFPoints(r);
                    r = n.wnd;
                    for(var i = n.points, o = l(t, r, this._bitLength), a = this.jpoint(null, null, null), s = o.length - 1; s >= 0; s--){
                        for(var u = 0; s >= 0 && 0 === o[s]; s--)u++;
                        if (s >= 0 && u++, a = a.dblp(u), s < 0) break;
                        var c = o[s];
                        p(0 !== c), a = "affine" === e.type ? c > 0 ? a.mixedAdd(i[c - 1 >> 1]) : a.mixedAdd(i[-c - 1 >> 1].neg()) : c > 0 ? a.add(i[c - 1 >> 1]) : a.add(i[-c - 1 >> 1].neg());
                    }
                    return "affine" === e.type ? a.toP() : a;
                }, b.prototype._wnafMulAdd = function(e, t, r, n, i) {
                    var o, a, s, u = this._wnafT1, c = this._wnafT2, f = this._wnafT3, d = 0;
                    for(o = 0; o < n; o++){
                        var p = (s = t[o])._getNAFPoints(e);
                        u[o] = p.wnd, c[o] = p.points;
                    }
                    for(o = n - 1; o >= 1; o -= 2){
                        var b = o - 1, y = o;
                        if (1 === u[b] && 1 === u[y]) {
                            var v = [
                                t[b],
                                null,
                                null,
                                t[y]
                            ];
                            0 === t[b].y.cmp(t[y].y) ? (v[1] = t[b].add(t[y]), v[2] = t[b].toJ().mixedAdd(t[y].neg())) : 0 === t[b].y.cmp(t[y].y.redNeg()) ? (v[1] = t[b].toJ().mixedAdd(t[y]), v[2] = t[b].add(t[y].neg())) : (v[1] = t[b].toJ().mixedAdd(t[y]), v[2] = t[b].toJ().mixedAdd(t[y].neg()));
                            var m = [
                                -3,
                                -1,
                                -5,
                                -7,
                                0,
                                7,
                                5,
                                1,
                                3
                            ], g = h(r[b], r[y]);
                            for(d = Math.max(g[0].length, d), f[b] = new Array(d), f[y] = new Array(d), a = 0; a < d; a++){
                                var w = 0 | g[0][a], k = 0 | g[1][a];
                                f[b][a] = m[3 * (w + 1) + (k + 1)], f[y][a] = 0, c[b] = v;
                            }
                        } else f[b] = l(r[b], u[b], this._bitLength), f[y] = l(r[y], u[y], this._bitLength), d = Math.max(f[b].length, d), d = Math.max(f[y].length, d);
                    }
                    var _ = this.jpoint(null, null, null), A = this._wnafT4;
                    for(o = d; o >= 0; o--){
                        for(var E = 0; o >= 0;){
                            var S = !0;
                            for(a = 0; a < n; a++)A[a] = 0 | f[a][o], 0 !== A[a] && (S = !1);
                            if (!S) break;
                            E++, o--;
                        }
                        if (o >= 0 && E++, _ = _.dblp(E), o < 0) break;
                        for(a = 0; a < n; a++){
                            var x = A[a];
                            0 !== x && (x > 0 ? s = c[a][x - 1 >> 1] : x < 0 && (s = c[a][-x - 1 >> 1].neg()), _ = "affine" === s.type ? _.mixedAdd(s) : _.add(s));
                        }
                    }
                    for(o = 0; o < n; o++)c[o] = null;
                    return i ? _ : _.toP();
                }, b.BasePoint = v, v.prototype.eq = function() {
                    throw new Error("Not implemented");
                }, v.prototype.validate = function() {
                    return this.curve.validate(this);
                }, b.prototype.decodePoint = function(e, t) {
                    e = d.toArray(e, t);
                    var r = this.p.byteLength();
                    if ((4 === e[0] || 6 === e[0] || 7 === e[0]) && e.length - 1 == 2 * r) return 6 === e[0] ? p(e[e.length - 1] % 2 == 0) : 7 === e[0] && p(e[e.length - 1] % 2 == 1), this.point(e.slice(1, 1 + r), e.slice(1 + r, 1 + 2 * r));
                    if ((2 === e[0] || 3 === e[0]) && e.length - 1 === r) return this.pointFromX(e.slice(1, 1 + r), 3 === e[0]);
                    throw new Error("Unknown point format");
                }, v.prototype.encodeCompressed = function(e) {
                    return this.encode(e, !0);
                }, v.prototype._encode = function(e) {
                    var t = this.curve.p.byteLength(), r = this.getX().toArray("be", t);
                    return e ? [
                        this.getY().isEven() ? 2 : 3
                    ].concat(r) : [
                        4
                    ].concat(r, this.getY().toArray("be", t));
                }, v.prototype.encode = function(e, t) {
                    return d.encode(this._encode(t), e);
                }, v.prototype.precompute = function(e) {
                    if (this.precomputed) return this;
                    var t = {
                        doubles: null,
                        naf: null,
                        beta: null
                    };
                    return t.naf = this._getNAFPoints(8), t.doubles = this._getDoubles(4, e), t.beta = this._getBeta(), this.precomputed = t, this;
                }, v.prototype._hasDoubles = function(e) {
                    if (!this.precomputed) return !1;
                    var t = this.precomputed.doubles;
                    return !!t && t.points.length >= Math.ceil((e.bitLength() + 1) / t.step);
                }, v.prototype._getDoubles = function(e, t) {
                    if (this.precomputed && this.precomputed.doubles) return this.precomputed.doubles;
                    for(var r = [
                        this
                    ], n = this, i = 0; i < t; i += e){
                        for(var o = 0; o < e; o++)n = n.dbl();
                        r.push(n);
                    }
                    return {
                        step: e,
                        points: r
                    };
                }, v.prototype._getNAFPoints = function(e) {
                    if (this.precomputed && this.precomputed.naf) return this.precomputed.naf;
                    for(var t = [
                        this
                    ], r = (1 << e) - 1, n = 1 === r ? null : this.dbl(), i = 1; i < r; i++)t[i] = t[i - 1].add(n);
                    return {
                        wnd: e,
                        points: t
                    };
                }, v.prototype._getBeta = function() {
                    return null;
                }, v.prototype.dblp = function(e) {
                    for(var t = this, r = 0; r < e; r++)t = t.dbl();
                    return t;
                };
                var m = s(function(e) {
                    "function" == typeof Object.create ? e.exports = function(e, t) {
                        t && (e.super_ = t, e.prototype = Object.create(t.prototype, {
                            constructor: {
                                value: e,
                                enumerable: !1,
                                writable: !0,
                                configurable: !0
                            }
                        }));
                    } : e.exports = function(e, t) {
                        if (t) {
                            e.super_ = t;
                            var r = function() {};
                            r.prototype = t.prototype, e.prototype = new r, e.prototype.constructor = e;
                        }
                    };
                }), g = d.assert;
                function w(e) {
                    y.call(this, "short", e), this.a = new o.default(e.a, 16).toRed(this.red), this.b = new o.default(e.b, 16).toRed(this.red), this.tinv = this.two.redInvm(), this.zeroA = 0 === this.a.fromRed().cmpn(0), this.threeA = 0 === this.a.fromRed().sub(this.p).cmpn(-3), this.endo = this._getEndomorphism(e), this._endoWnafT1 = new Array(4), this._endoWnafT2 = new Array(4);
                }
                m(w, y);
                var k = w;
                function _(e, t, r, n) {
                    y.BasePoint.call(this, e, "affine"), null === t && null === r ? (this.x = null, this.y = null, this.inf = !0) : (this.x = new o.default(t, 16), this.y = new o.default(r, 16), n && (this.x.forceRed(this.curve.red), this.y.forceRed(this.curve.red)), this.x.red || (this.x = this.x.toRed(this.curve.red)), this.y.red || (this.y = this.y.toRed(this.curve.red)), this.inf = !1);
                }
                function A(e, t, r, n) {
                    y.BasePoint.call(this, e, "jacobian"), null === t && null === r && null === n ? (this.x = this.curve.one, this.y = this.curve.one, this.z = new o.default(0)) : (this.x = new o.default(t, 16), this.y = new o.default(r, 16), this.z = new o.default(n, 16)), this.x.red || (this.x = this.x.toRed(this.curve.red)), this.y.red || (this.y = this.y.toRed(this.curve.red)), this.z.red || (this.z = this.z.toRed(this.curve.red)), this.zOne = this.z === this.curve.one;
                }
                w.prototype._getEndomorphism = function(e) {
                    if (this.zeroA && this.g && this.n && 1 === this.p.modn(3)) {
                        var t, r;
                        if (e.beta) t = new o.default(e.beta, 16).toRed(this.red);
                        else {
                            var n = this._getEndoRoots(this.p);
                            t = (t = n[0].cmp(n[1]) < 0 ? n[0] : n[1]).toRed(this.red);
                        }
                        if (e.lambda) r = new o.default(e.lambda, 16);
                        else {
                            var i = this._getEndoRoots(this.n);
                            0 === this.g.mul(i[0]).x.cmp(this.g.x.redMul(t)) ? r = i[0] : (r = i[1], g(0 === this.g.mul(r).x.cmp(this.g.x.redMul(t))));
                        }
                        return {
                            beta: t,
                            lambda: r,
                            basis: e.basis ? e.basis.map(function(e) {
                                return {
                                    a: new o.default(e.a, 16),
                                    b: new o.default(e.b, 16)
                                };
                            }) : this._getEndoBasis(r)
                        };
                    }
                }, w.prototype._getEndoRoots = function(e) {
                    var t = e === this.p ? this.red : o.default.mont(e), r = new o.default(2).toRed(t).redInvm(), n = r.redNeg(), i = new o.default(3).toRed(t).redNeg().redSqrt().redMul(r);
                    return [
                        n.redAdd(i).fromRed(),
                        n.redSub(i).fromRed()
                    ];
                }, w.prototype._getEndoBasis = function(e) {
                    for(var t, r, n, i, a, s, u, c, f, d = this.n.ushrn(Math.floor(this.n.bitLength() / 2)), l = e, h = this.n.clone(), p = new o.default(1), b = new o.default(0), y = new o.default(0), v = new o.default(1), m = 0; 0 !== l.cmpn(0);){
                        var g = h.div(l);
                        c = h.sub(g.mul(l)), f = y.sub(g.mul(p));
                        var w = v.sub(g.mul(b));
                        if (!n && c.cmp(d) < 0) t = u.neg(), r = p, n = c.neg(), i = f;
                        else if (n && 2 == ++m) break;
                        u = c, h = l, l = c, y = p, p = f, v = b, b = w;
                    }
                    a = c.neg(), s = f;
                    var k = n.sqr().add(i.sqr());
                    return a.sqr().add(s.sqr()).cmp(k) >= 0 && (a = t, s = r), n.negative && (n = n.neg(), i = i.neg()), a.negative && (a = a.neg(), s = s.neg()), [
                        {
                            a: n,
                            b: i
                        },
                        {
                            a,
                            b: s
                        }
                    ];
                }, w.prototype._endoSplit = function(e) {
                    var t = this.endo.basis, r = t[0], n = t[1], i = n.b.mul(e).divRound(this.n), o = r.b.neg().mul(e).divRound(this.n), a = i.mul(r.a), s = o.mul(n.a), u = i.mul(r.b), c = o.mul(n.b);
                    return {
                        k1: e.sub(a).sub(s),
                        k2: u.add(c).neg()
                    };
                }, w.prototype.pointFromX = function(e, t) {
                    (e = new o.default(e, 16)).red || (e = e.toRed(this.red));
                    var r = e.redSqr().redMul(e).redIAdd(e.redMul(this.a)).redIAdd(this.b), n = r.redSqrt();
                    if (0 !== n.redSqr().redSub(r).cmp(this.zero)) throw new Error("invalid point");
                    var i = n.fromRed().isOdd();
                    return (t && !i || !t && i) && (n = n.redNeg()), this.point(e, n);
                }, w.prototype.validate = function(e) {
                    if (e.inf) return !0;
                    var t = e.x, r = e.y, n = this.a.redMul(t), i = t.redSqr().redMul(t).redIAdd(n).redIAdd(this.b);
                    return 0 === r.redSqr().redISub(i).cmpn(0);
                }, w.prototype._endoWnafMulAdd = function(e, t, r) {
                    for(var n = this._endoWnafT1, i = this._endoWnafT2, o = 0; o < e.length; o++){
                        var a = this._endoSplit(t[o]), s = e[o], u = s._getBeta();
                        a.k1.negative && (a.k1.ineg(), s = s.neg(!0)), a.k2.negative && (a.k2.ineg(), u = u.neg(!0)), n[2 * o] = s, n[2 * o + 1] = u, i[2 * o] = a.k1, i[2 * o + 1] = a.k2;
                    }
                    for(var c = this._wnafMulAdd(1, n, i, 2 * o, r), f = 0; f < 2 * o; f++)n[f] = null, i[f] = null;
                    return c;
                }, m(_, y.BasePoint), w.prototype.point = function(e, t, r) {
                    return new _(this, e, t, r);
                }, w.prototype.pointFromJSON = function(e, t) {
                    return _.fromJSON(this, e, t);
                }, _.prototype._getBeta = function() {
                    if (this.curve.endo) {
                        var e = this.precomputed;
                        if (e && e.beta) return e.beta;
                        var t = this.curve.point(this.x.redMul(this.curve.endo.beta), this.y);
                        if (e) {
                            var r = this.curve, n = function(e) {
                                return r.point(e.x.redMul(r.endo.beta), e.y);
                            };
                            e.beta = t, t.precomputed = {
                                beta: null,
                                naf: e.naf && {
                                    wnd: e.naf.wnd,
                                    points: e.naf.points.map(n)
                                },
                                doubles: e.doubles && {
                                    step: e.doubles.step,
                                    points: e.doubles.points.map(n)
                                }
                            };
                        }
                        return t;
                    }
                }, _.prototype.toJSON = function() {
                    return this.precomputed ? [
                        this.x,
                        this.y,
                        this.precomputed && {
                            doubles: this.precomputed.doubles && {
                                step: this.precomputed.doubles.step,
                                points: this.precomputed.doubles.points.slice(1)
                            },
                            naf: this.precomputed.naf && {
                                wnd: this.precomputed.naf.wnd,
                                points: this.precomputed.naf.points.slice(1)
                            }
                        }
                    ] : [
                        this.x,
                        this.y
                    ];
                }, _.fromJSON = function(e, t, r) {
                    "string" == typeof t && (t = JSON.parse(t));
                    var n = e.point(t[0], t[1], r);
                    if (!t[2]) return n;
                    function i(t) {
                        return e.point(t[0], t[1], r);
                    }
                    var o = t[2];
                    return n.precomputed = {
                        beta: null,
                        doubles: o.doubles && {
                            step: o.doubles.step,
                            points: [
                                n
                            ].concat(o.doubles.points.map(i))
                        },
                        naf: o.naf && {
                            wnd: o.naf.wnd,
                            points: [
                                n
                            ].concat(o.naf.points.map(i))
                        }
                    }, n;
                }, _.prototype.inspect = function() {
                    return this.isInfinity() ? "<EC Point Infinity>" : "<EC Point x: " + this.x.fromRed().toString(16, 2) + " y: " + this.y.fromRed().toString(16, 2) + ">";
                }, _.prototype.isInfinity = function() {
                    return this.inf;
                }, _.prototype.add = function(e) {
                    if (this.inf) return e;
                    if (e.inf) return this;
                    if (this.eq(e)) return this.dbl();
                    if (this.neg().eq(e)) return this.curve.point(null, null);
                    if (0 === this.x.cmp(e.x)) return this.curve.point(null, null);
                    var t = this.y.redSub(e.y);
                    0 !== t.cmpn(0) && (t = t.redMul(this.x.redSub(e.x).redInvm()));
                    var r = t.redSqr().redISub(this.x).redISub(e.x), n = t.redMul(this.x.redSub(r)).redISub(this.y);
                    return this.curve.point(r, n);
                }, _.prototype.dbl = function() {
                    if (this.inf) return this;
                    var e = this.y.redAdd(this.y);
                    if (0 === e.cmpn(0)) return this.curve.point(null, null);
                    var t = this.curve.a, r = this.x.redSqr(), n = e.redInvm(), i = r.redAdd(r).redIAdd(r).redIAdd(t).redMul(n), o = i.redSqr().redISub(this.x.redAdd(this.x)), a = i.redMul(this.x.redSub(o)).redISub(this.y);
                    return this.curve.point(o, a);
                }, _.prototype.getX = function() {
                    return this.x.fromRed();
                }, _.prototype.getY = function() {
                    return this.y.fromRed();
                }, _.prototype.mul = function(e) {
                    return e = new o.default(e, 16), this.isInfinity() ? this : this._hasDoubles(e) ? this.curve._fixedNafMul(this, e) : this.curve.endo ? this.curve._endoWnafMulAdd([
                        this
                    ], [
                        e
                    ]) : this.curve._wnafMul(this, e);
                }, _.prototype.mulAdd = function(e, t, r) {
                    var n = [
                        this,
                        t
                    ], i = [
                        e,
                        r
                    ];
                    return this.curve.endo ? this.curve._endoWnafMulAdd(n, i) : this.curve._wnafMulAdd(1, n, i, 2);
                }, _.prototype.jmulAdd = function(e, t, r) {
                    var n = [
                        this,
                        t
                    ], i = [
                        e,
                        r
                    ];
                    return this.curve.endo ? this.curve._endoWnafMulAdd(n, i, !0) : this.curve._wnafMulAdd(1, n, i, 2, !0);
                }, _.prototype.eq = function(e) {
                    return this === e || this.inf === e.inf && (this.inf || 0 === this.x.cmp(e.x) && 0 === this.y.cmp(e.y));
                }, _.prototype.neg = function(e) {
                    if (this.inf) return this;
                    var t = this.curve.point(this.x, this.y.redNeg());
                    if (e && this.precomputed) {
                        var r = this.precomputed, n = function(e) {
                            return e.neg();
                        };
                        t.precomputed = {
                            naf: r.naf && {
                                wnd: r.naf.wnd,
                                points: r.naf.points.map(n)
                            },
                            doubles: r.doubles && {
                                step: r.doubles.step,
                                points: r.doubles.points.map(n)
                            }
                        };
                    }
                    return t;
                }, _.prototype.toJ = function() {
                    return this.inf ? this.curve.jpoint(null, null, null) : this.curve.jpoint(this.x, this.y, this.curve.one);
                }, m(A, y.BasePoint), w.prototype.jpoint = function(e, t, r) {
                    return new A(this, e, t, r);
                }, A.prototype.toP = function() {
                    if (this.isInfinity()) return this.curve.point(null, null);
                    var e = this.z.redInvm(), t = e.redSqr(), r = this.x.redMul(t), n = this.y.redMul(t).redMul(e);
                    return this.curve.point(r, n);
                }, A.prototype.neg = function() {
                    return this.curve.jpoint(this.x, this.y.redNeg(), this.z);
                }, A.prototype.add = function(e) {
                    if (this.isInfinity()) return e;
                    if (e.isInfinity()) return this;
                    var t = e.z.redSqr(), r = this.z.redSqr(), n = this.x.redMul(t), i = e.x.redMul(r), o = this.y.redMul(t.redMul(e.z)), a = e.y.redMul(r.redMul(this.z)), s = n.redSub(i), u = o.redSub(a);
                    if (0 === s.cmpn(0)) return 0 !== u.cmpn(0) ? this.curve.jpoint(null, null, null) : this.dbl();
                    var c = s.redSqr(), f = c.redMul(s), d = n.redMul(c), l = u.redSqr().redIAdd(f).redISub(d).redISub(d), h = u.redMul(d.redISub(l)).redISub(o.redMul(f)), p = this.z.redMul(e.z).redMul(s);
                    return this.curve.jpoint(l, h, p);
                }, A.prototype.mixedAdd = function(e) {
                    if (this.isInfinity()) return e.toJ();
                    if (e.isInfinity()) return this;
                    var t = this.z.redSqr(), r = this.x, n = e.x.redMul(t), i = this.y, o = e.y.redMul(t).redMul(this.z), a = r.redSub(n), s = i.redSub(o);
                    if (0 === a.cmpn(0)) return 0 !== s.cmpn(0) ? this.curve.jpoint(null, null, null) : this.dbl();
                    var u = a.redSqr(), c = u.redMul(a), f = r.redMul(u), d = s.redSqr().redIAdd(c).redISub(f).redISub(f), l = s.redMul(f.redISub(d)).redISub(i.redMul(c)), h = this.z.redMul(a);
                    return this.curve.jpoint(d, l, h);
                }, A.prototype.dblp = function(e) {
                    if (0 === e) return this;
                    if (this.isInfinity()) return this;
                    if (!e) return this.dbl();
                    var t;
                    if (this.curve.zeroA || this.curve.threeA) {
                        var r = this;
                        for(t = 0; t < e; t++)r = r.dbl();
                        return r;
                    }
                    var n = this.curve.a, i = this.curve.tinv, o = this.x, a = this.y, s = this.z, u = s.redSqr().redSqr(), c = a.redAdd(a);
                    for(t = 0; t < e; t++){
                        var f = o.redSqr(), d = c.redSqr(), l = d.redSqr(), h = f.redAdd(f).redIAdd(f).redIAdd(n.redMul(u)), p = o.redMul(d), b = h.redSqr().redISub(p.redAdd(p)), y = p.redISub(b), v = h.redMul(y);
                        v = v.redIAdd(v).redISub(l);
                        var m = c.redMul(s);
                        t + 1 < e && (u = u.redMul(l)), o = b, s = m, c = v;
                    }
                    return this.curve.jpoint(o, c.redMul(i), s);
                }, A.prototype.dbl = function() {
                    return this.isInfinity() ? this : this.curve.zeroA ? this._zeroDbl() : this.curve.threeA ? this._threeDbl() : this._dbl();
                }, A.prototype._zeroDbl = function() {
                    var e, t, r;
                    if (this.zOne) {
                        var n = this.x.redSqr(), i = this.y.redSqr(), o = i.redSqr(), a = this.x.redAdd(i).redSqr().redISub(n).redISub(o);
                        a = a.redIAdd(a);
                        var s = n.redAdd(n).redIAdd(n), u = s.redSqr().redISub(a).redISub(a), c = o.redIAdd(o);
                        c = (c = c.redIAdd(c)).redIAdd(c), e = u, t = s.redMul(a.redISub(u)).redISub(c), r = this.y.redAdd(this.y);
                    } else {
                        var f = this.x.redSqr(), d = this.y.redSqr(), l = d.redSqr(), h = this.x.redAdd(d).redSqr().redISub(f).redISub(l);
                        h = h.redIAdd(h);
                        var p = f.redAdd(f).redIAdd(f), b = p.redSqr(), y = l.redIAdd(l);
                        y = (y = y.redIAdd(y)).redIAdd(y), e = b.redISub(h).redISub(h), t = p.redMul(h.redISub(e)).redISub(y), r = (r = this.y.redMul(this.z)).redIAdd(r);
                    }
                    return this.curve.jpoint(e, t, r);
                }, A.prototype._threeDbl = function() {
                    var e, t, r;
                    if (this.zOne) {
                        var n = this.x.redSqr(), i = this.y.redSqr(), o = i.redSqr(), a = this.x.redAdd(i).redSqr().redISub(n).redISub(o);
                        a = a.redIAdd(a);
                        var s = n.redAdd(n).redIAdd(n).redIAdd(this.curve.a), u = s.redSqr().redISub(a).redISub(a);
                        e = u;
                        var c = o.redIAdd(o);
                        c = (c = c.redIAdd(c)).redIAdd(c), t = s.redMul(a.redISub(u)).redISub(c), r = this.y.redAdd(this.y);
                    } else {
                        var f = this.z.redSqr(), d = this.y.redSqr(), l = this.x.redMul(d), h = this.x.redSub(f).redMul(this.x.redAdd(f));
                        h = h.redAdd(h).redIAdd(h);
                        var p = l.redIAdd(l), b = (p = p.redIAdd(p)).redAdd(p);
                        e = h.redSqr().redISub(b), r = this.y.redAdd(this.z).redSqr().redISub(d).redISub(f);
                        var y = d.redSqr();
                        y = (y = (y = y.redIAdd(y)).redIAdd(y)).redIAdd(y), t = h.redMul(p.redISub(e)).redISub(y);
                    }
                    return this.curve.jpoint(e, t, r);
                }, A.prototype._dbl = function() {
                    var e = this.curve.a, t = this.x, r = this.y, n = this.z, i = n.redSqr().redSqr(), o = t.redSqr(), a = r.redSqr(), s = o.redAdd(o).redIAdd(o).redIAdd(e.redMul(i)), u = t.redAdd(t), c = (u = u.redIAdd(u)).redMul(a), f = s.redSqr().redISub(c.redAdd(c)), d = c.redISub(f), l = a.redSqr();
                    l = (l = (l = l.redIAdd(l)).redIAdd(l)).redIAdd(l);
                    var h = s.redMul(d).redISub(l), p = r.redAdd(r).redMul(n);
                    return this.curve.jpoint(f, h, p);
                }, A.prototype.trpl = function() {
                    if (!this.curve.zeroA) return this.dbl().add(this);
                    var e = this.x.redSqr(), t = this.y.redSqr(), r = this.z.redSqr(), n = t.redSqr(), i = e.redAdd(e).redIAdd(e), o = i.redSqr(), a = this.x.redAdd(t).redSqr().redISub(e).redISub(n), s = (a = (a = (a = a.redIAdd(a)).redAdd(a).redIAdd(a)).redISub(o)).redSqr(), u = n.redIAdd(n);
                    u = (u = (u = u.redIAdd(u)).redIAdd(u)).redIAdd(u);
                    var c = i.redIAdd(a).redSqr().redISub(o).redISub(s).redISub(u), f = t.redMul(c);
                    f = (f = f.redIAdd(f)).redIAdd(f);
                    var d = this.x.redMul(s).redISub(f);
                    d = (d = d.redIAdd(d)).redIAdd(d);
                    var l = this.y.redMul(c.redMul(u.redISub(c)).redISub(a.redMul(s)));
                    l = (l = (l = l.redIAdd(l)).redIAdd(l)).redIAdd(l);
                    var h = this.z.redAdd(a).redSqr().redISub(r).redISub(s);
                    return this.curve.jpoint(d, l, h);
                }, A.prototype.mul = function(e, t) {
                    return e = new o.default(e, t), this.curve._wnafMul(this, e);
                }, A.prototype.eq = function(e) {
                    if ("affine" === e.type) return this.eq(e.toJ());
                    if (this === e) return !0;
                    var t = this.z.redSqr(), r = e.z.redSqr();
                    if (0 !== this.x.redMul(r).redISub(e.x.redMul(t)).cmpn(0)) return !1;
                    var n = t.redMul(this.z), i = r.redMul(e.z);
                    return 0 === this.y.redMul(i).redISub(e.y.redMul(n)).cmpn(0);
                }, A.prototype.eqXToP = function(e) {
                    var t = this.z.redSqr(), r = e.toRed(this.curve.red).redMul(t);
                    if (0 === this.x.cmp(r)) return !0;
                    for(var n = e.clone(), i = this.curve.redN.redMul(t);;){
                        if (n.iadd(this.curve.n), n.cmp(this.curve.p) >= 0) return !1;
                        if (r.redIAdd(i), 0 === this.x.cmp(r)) return !0;
                    }
                }, A.prototype.inspect = function() {
                    return this.isInfinity() ? "<EC JPoint Infinity>" : "<EC JPoint x: " + this.x.toString(16, 2) + " y: " + this.y.toString(16, 2) + " z: " + this.z.toString(16, 2) + ">";
                }, A.prototype.isInfinity = function() {
                    return 0 === this.z.cmpn(0);
                };
                var E = s(function(e, t) {
                    var r = t;
                    r.base = y, r.short = k, r.mont = null, r.edwards = null;
                }), S = s(function(e, t) {
                    var r, n = t, i = d.assert;
                    function o(e) {
                        "short" === e.type ? this.curve = new E.short(e) : "edwards" === e.type ? this.curve = new E.edwards(e) : this.curve = new E.mont(e), this.g = this.curve.g, this.n = this.curve.n, this.hash = e.hash, i(this.g.validate(), "Invalid curve"), i(this.g.mul(this.n).isInfinity(), "Invalid curve, G*N != O");
                    }
                    function s(e, t) {
                        Object.defineProperty(n, e, {
                            configurable: !0,
                            enumerable: !0,
                            get: function() {
                                var r = new o(t);
                                return Object.defineProperty(n, e, {
                                    configurable: !0,
                                    enumerable: !0,
                                    value: r
                                }), r;
                            }
                        });
                    }
                    n.PresetCurve = o, s("p192", {
                        type: "short",
                        prime: "p192",
                        p: "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff",
                        a: "ffffffff ffffffff ffffffff fffffffe ffffffff fffffffc",
                        b: "64210519 e59c80e7 0fa7e9ab 72243049 feb8deec c146b9b1",
                        n: "ffffffff ffffffff ffffffff 99def836 146bc9b1 b4d22831",
                        hash: a.default.sha256,
                        gRed: !1,
                        g: [
                            "188da80e b03090f6 7cbf20eb 43a18800 f4ff0afd 82ff1012",
                            "07192b95 ffc8da78 631011ed 6b24cdd5 73f977a1 1e794811"
                        ]
                    }), s("p224", {
                        type: "short",
                        prime: "p224",
                        p: "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001",
                        a: "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff fffffffe",
                        b: "b4050a85 0c04b3ab f5413256 5044b0b7 d7bfd8ba 270b3943 2355ffb4",
                        n: "ffffffff ffffffff ffffffff ffff16a2 e0b8f03e 13dd2945 5c5c2a3d",
                        hash: a.default.sha256,
                        gRed: !1,
                        g: [
                            "b70e0cbd 6bb4bf7f 321390b9 4a03c1d3 56c21122 343280d6 115c1d21",
                            "bd376388 b5f723fb 4c22dfe6 cd4375a0 5a074764 44d58199 85007e34"
                        ]
                    }), s("p256", {
                        type: "short",
                        prime: null,
                        p: "ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff ffffffff",
                        a: "ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff fffffffc",
                        b: "5ac635d8 aa3a93e7 b3ebbd55 769886bc 651d06b0 cc53b0f6 3bce3c3e 27d2604b",
                        n: "ffffffff 00000000 ffffffff ffffffff bce6faad a7179e84 f3b9cac2 fc632551",
                        hash: a.default.sha256,
                        gRed: !1,
                        g: [
                            "6b17d1f2 e12c4247 f8bce6e5 63a440f2 77037d81 2deb33a0 f4a13945 d898c296",
                            "4fe342e2 fe1a7f9b 8ee7eb4a 7c0f9e16 2bce3357 6b315ece cbb64068 37bf51f5"
                        ]
                    }), s("p384", {
                        type: "short",
                        prime: null,
                        p: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe ffffffff 00000000 00000000 ffffffff",
                        a: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe ffffffff 00000000 00000000 fffffffc",
                        b: "b3312fa7 e23ee7e4 988e056b e3f82d19 181d9c6e fe814112 0314088f 5013875a c656398d 8a2ed19d 2a85c8ed d3ec2aef",
                        n: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff c7634d81 f4372ddf 581a0db2 48b0a77a ecec196a ccc52973",
                        hash: a.default.sha384,
                        gRed: !1,
                        g: [
                            "aa87ca22 be8b0537 8eb1c71e f320ad74 6e1d3b62 8ba79b98 59f741e0 82542a38 5502f25d bf55296c 3a545e38 72760ab7",
                            "3617de4a 96262c6f 5d9e98bf 9292dc29 f8f41dbd 289a147c e9da3113 b5f0b8c0 0a60b1ce 1d7e819d 7a431d7c 90ea0e5f"
                        ]
                    }), s("p521", {
                        type: "short",
                        prime: null,
                        p: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff",
                        a: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffc",
                        b: "00000051 953eb961 8e1c9a1f 929a21a0 b68540ee a2da725b 99b315f3 b8b48991 8ef109e1 56193951 ec7e937b 1652c0bd 3bb1bf07 3573df88 3d2c34f1 ef451fd4 6b503f00",
                        n: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffa 51868783 bf2f966b 7fcc0148 f709a5d0 3bb5c9b8 899c47ae bb6fb71e 91386409",
                        hash: a.default.sha512,
                        gRed: !1,
                        g: [
                            "000000c6 858e06b7 0404e9cd 9e3ecb66 2395b442 9c648139 053fb521 f828af60 6b4d3dba a14b5e77 efe75928 fe1dc127 a2ffa8de 3348b3c1 856a429b f97e7e31 c2e5bd66",
                            "00000118 39296a78 9a3bc004 5c8a5fb4 2c7d1bd9 98f54449 579b4468 17afbd17 273e662c 97ee7299 5ef42640 c550b901 3fad0761 353c7086 a272c240 88be9476 9fd16650"
                        ]
                    }), s("curve25519", {
                        type: "mont",
                        prime: "p25519",
                        p: "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed",
                        a: "76d06",
                        b: "1",
                        n: "1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed",
                        hash: a.default.sha256,
                        gRed: !1,
                        g: [
                            "9"
                        ]
                    }), s("ed25519", {
                        type: "edwards",
                        prime: "p25519",
                        p: "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed",
                        a: "-1",
                        c: "1",
                        d: "52036cee2b6ffe73 8cc740797779e898 00700a4d4141d8ab 75eb4dca135978a3",
                        n: "1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed",
                        hash: a.default.sha256,
                        gRed: !1,
                        g: [
                            "216936d3cd6e53fec0a4e231fdd6dc5c692cc7609525a7b2c9562d608f25d51a",
                            "6666666666666666666666666666666666666666666666666666666666666658"
                        ]
                    });
                    try {
                        r = null.crash();
                    } catch (e) {
                        r = void 0;
                    }
                    s("secp256k1", {
                        type: "short",
                        prime: "k256",
                        p: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f",
                        a: "0",
                        b: "7",
                        n: "ffffffff ffffffff ffffffff fffffffe baaedce6 af48a03b bfd25e8c d0364141",
                        h: "1",
                        hash: a.default.sha256,
                        beta: "7ae96a2b657c07106e64479eac3434e99cf0497512f58995c1396c28719501ee",
                        lambda: "5363ad4cc05c30e0a5261c028812645a122e22ea20816678df02967c1b23bd72",
                        basis: [
                            {
                                a: "3086d221a7d46bcde86c90e49284eb15",
                                b: "-e4437ed6010e88286f547fa90abfe4c3"
                            },
                            {
                                a: "114ca50f7a8e2f3f657c1108d9d44cfd8",
                                b: "3086d221a7d46bcde86c90e49284eb15"
                            }
                        ],
                        gRed: !1,
                        g: [
                            "79be667ef9dcbbac55a06295ce870b07029bfcdb2dce28d959f2815b16f81798",
                            "483ada7726a3c4655da4fbfc0e1108a8fd17b448a68554199c47d08ffb10d4b8",
                            r
                        ]
                    });
                });
                function x(e) {
                    if (!(this instanceof x)) return new x(e);
                    this.hash = e.hash, this.predResist = !!e.predResist, this.outLen = this.hash.outSize, this.minEntropy = e.minEntropy || this.hash.hmacStrength, this._reseed = null, this.reseedInterval = null, this.K = null, this.V = null;
                    var t = f.toArray(e.entropy, e.entropyEnc || "hex"), r = f.toArray(e.nonce, e.nonceEnc || "hex"), n = f.toArray(e.pers, e.persEnc || "hex");
                    u(t.length >= this.minEntropy / 8, "Not enough entropy. Minimum is: " + this.minEntropy + " bits"), this._init(t, r, n);
                }
                var B = x;
                x.prototype._init = function(e, t, r) {
                    var n = e.concat(t).concat(r);
                    this.K = new Array(this.outLen / 8), this.V = new Array(this.outLen / 8);
                    for(var i = 0; i < this.V.length; i++)this.K[i] = 0, this.V[i] = 1;
                    this._update(n), this._reseed = 1, this.reseedInterval = 281474976710656;
                }, x.prototype._hmac = function() {
                    return new a.default.hmac(this.hash, this.K);
                }, x.prototype._update = function(e) {
                    var t = this._hmac().update(this.V).update([
                        0
                    ]);
                    e && (t = t.update(e)), this.K = t.digest(), this.V = this._hmac().update(this.V).digest(), e && (this.K = this._hmac().update(this.V).update([
                        1
                    ]).update(e).digest(), this.V = this._hmac().update(this.V).digest());
                }, x.prototype.reseed = function(e, t, r, n) {
                    "string" != typeof t && (n = r, r = t, t = null), e = f.toArray(e, t), r = f.toArray(r, n), u(e.length >= this.minEntropy / 8, "Not enough entropy. Minimum is: " + this.minEntropy + " bits"), this._update(e.concat(r || [])), this._reseed = 1;
                }, x.prototype.generate = function(e, t, r, n) {
                    if (this._reseed > this.reseedInterval) throw new Error("Reseed is required");
                    "string" != typeof t && (n = r, r = t, t = null), r && (r = f.toArray(r, n || "hex"), this._update(r));
                    for(var i = []; i.length < e;)this.V = this._hmac().update(this.V).digest(), i = i.concat(this.V);
                    var o = i.slice(0, e);
                    return this._update(r), this._reseed++, f.encode(o, t);
                };
                var O = d.assert;
                function P(e, t) {
                    this.ec = e, this.priv = null, this.pub = null, t.priv && this._importPrivate(t.priv, t.privEnc), t.pub && this._importPublic(t.pub, t.pubEnc);
                }
                var I = P;
                P.fromPublic = function(e, t, r) {
                    return t instanceof P ? t : new P(e, {
                        pub: t,
                        pubEnc: r
                    });
                }, P.fromPrivate = function(e, t, r) {
                    return t instanceof P ? t : new P(e, {
                        priv: t,
                        privEnc: r
                    });
                }, P.prototype.validate = function() {
                    var e = this.getPublic();
                    return e.isInfinity() ? {
                        result: !1,
                        reason: "Invalid public key"
                    } : e.validate() ? e.mul(this.ec.curve.n).isInfinity() ? {
                        result: !0,
                        reason: null
                    } : {
                        result: !1,
                        reason: "Public key * N != O"
                    } : {
                        result: !1,
                        reason: "Public key is not a point"
                    };
                }, P.prototype.getPublic = function(e, t) {
                    return "string" == typeof e && (t = e, e = null), this.pub || (this.pub = this.ec.g.mul(this.priv)), t ? this.pub.encode(t, e) : this.pub;
                }, P.prototype.getPrivate = function(e) {
                    return "hex" === e ? this.priv.toString(16, 2) : this.priv;
                }, P.prototype._importPrivate = function(e, t) {
                    this.priv = new o.default(e, t || 16), this.priv = this.priv.umod(this.ec.curve.n);
                }, P.prototype._importPublic = function(e, t) {
                    if (e.x || e.y) return "mont" === this.ec.curve.type ? O(e.x, "Need x coordinate") : "short" !== this.ec.curve.type && "edwards" !== this.ec.curve.type || O(e.x && e.y, "Need both x and y coordinate"), void (this.pub = this.ec.curve.point(e.x, e.y));
                    this.pub = this.ec.curve.decodePoint(e, t);
                }, P.prototype.derive = function(e) {
                    return e.validate() || O(e.validate(), "public point not validated"), e.mul(this.priv).getX();
                }, P.prototype.sign = function(e, t, r) {
                    return this.ec.sign(e, this, t, r);
                }, P.prototype.verify = function(e, t) {
                    return this.ec.verify(e, t, this);
                }, P.prototype.inspect = function() {
                    return "<Key priv: " + (this.priv && this.priv.toString(16, 2)) + " pub: " + (this.pub && this.pub.inspect()) + " >";
                };
                var T = d.assert;
                function C(e, t) {
                    if (e instanceof C) return e;
                    this._importDER(e, t) || (T(e.r && e.s, "Signature without r or s"), this.r = new o.default(e.r, 16), this.s = new o.default(e.s, 16), void 0 === e.recoveryParam ? this.recoveryParam = null : this.recoveryParam = e.recoveryParam);
                }
                var M = C;
                function R() {
                    this.place = 0;
                }
                function U(e, t) {
                    var r = e[t.place++];
                    if (!(128 & r)) return r;
                    var n = 15 & r;
                    if (0 === n || n > 4) return !1;
                    for(var i = 0, o = 0, a = t.place; o < n; o++, a++)i <<= 8, i |= e[a], i >>>= 0;
                    return !(i <= 127) && (t.place = a, i);
                }
                function N(e) {
                    for(var t = 0, r = e.length - 1; !e[t] && !(128 & e[t + 1]) && t < r;)t++;
                    return 0 === t ? e : e.slice(t);
                }
                function j(e, t) {
                    if (t < 128) e.push(t);
                    else {
                        var r = 1 + (Math.log(t) / Math.LN2 >>> 3);
                        for(e.push(128 | r); --r;)e.push(t >>> (r << 3) & 255);
                        e.push(t);
                    }
                }
                C.prototype._importDER = function(e, t) {
                    e = d.toArray(e, t);
                    var r = new R;
                    if (48 !== e[r.place++]) return !1;
                    var n = U(e, r);
                    if (!1 === n) return !1;
                    if (n + r.place !== e.length) return !1;
                    if (2 !== e[r.place++]) return !1;
                    var i = U(e, r);
                    if (!1 === i) return !1;
                    var a = e.slice(r.place, i + r.place);
                    if (r.place += i, 2 !== e[r.place++]) return !1;
                    var s = U(e, r);
                    if (!1 === s) return !1;
                    if (e.length !== s + r.place) return !1;
                    var u = e.slice(r.place, s + r.place);
                    if (0 === a[0]) {
                        if (!(128 & a[1])) return !1;
                        a = a.slice(1);
                    }
                    if (0 === u[0]) {
                        if (!(128 & u[1])) return !1;
                        u = u.slice(1);
                    }
                    return this.r = new o.default(a), this.s = new o.default(u), this.recoveryParam = null, !0;
                }, C.prototype.toDER = function(e) {
                    var t = this.r.toArray(), r = this.s.toArray();
                    for(128 & t[0] && (t = [
                        0
                    ].concat(t)), 128 & r[0] && (r = [
                        0
                    ].concat(r)), t = N(t), r = N(r); !(r[0] || 128 & r[1]);)r = r.slice(1);
                    var n = [
                        2
                    ];
                    j(n, t.length), (n = n.concat(t)).push(2), j(n, r.length);
                    var i = n.concat(r), o = [
                        48
                    ];
                    return j(o, i.length), o = o.concat(i), d.encode(o, e);
                };
                var L = function() {
                    throw new Error("unsupported");
                }, F = d.assert;
                function D(e) {
                    if (!(this instanceof D)) return new D(e);
                    "string" == typeof e && (F(Object.prototype.hasOwnProperty.call(S, e), "Unknown curve " + e), e = S[e]), e instanceof S.PresetCurve && (e = {
                        curve: e
                    }), this.curve = e.curve.curve, this.n = this.curve.n, this.nh = this.n.ushrn(1), this.g = this.curve.g, this.g = e.curve.g, this.g.precompute(e.curve.n.bitLength() + 1), this.hash = e.hash || e.curve.hash;
                }
                var H = D;
                D.prototype.keyPair = function(e) {
                    return new I(this, e);
                }, D.prototype.keyFromPrivate = function(e, t) {
                    return I.fromPrivate(this, e, t);
                }, D.prototype.keyFromPublic = function(e, t) {
                    return I.fromPublic(this, e, t);
                }, D.prototype.genKeyPair = function(e) {
                    e || (e = {});
                    for(var t = new B({
                        hash: this.hash,
                        pers: e.pers,
                        persEnc: e.persEnc || "utf8",
                        entropy: e.entropy || L(this.hash.hmacStrength),
                        entropyEnc: e.entropy && e.entropyEnc || "utf8",
                        nonce: this.n.toArray()
                    }), r = this.n.byteLength(), n = this.n.sub(new o.default(2));;){
                        var i = new o.default(t.generate(r));
                        if (!(i.cmp(n) > 0)) return i.iaddn(1), this.keyFromPrivate(i);
                    }
                }, D.prototype._truncateToN = function(e, t) {
                    var r = 8 * e.byteLength() - this.n.bitLength();
                    return r > 0 && (e = e.ushrn(r)), !t && e.cmp(this.n) >= 0 ? e.sub(this.n) : e;
                }, D.prototype.sign = function(e, t, r, n) {
                    "object" === (0, i.default)(r) && (n = r, r = null), n || (n = {}), t = this.keyFromPrivate(t, r), e = this._truncateToN(new o.default(e, 16));
                    for(var a = this.n.byteLength(), s = t.getPrivate().toArray("be", a), u = e.toArray("be", a), c = new B({
                        hash: this.hash,
                        entropy: s,
                        nonce: u,
                        pers: n.pers,
                        persEnc: n.persEnc || "utf8"
                    }), f = this.n.sub(new o.default(1)), d = 0;; d++){
                        var l = n.k ? n.k(d) : new o.default(c.generate(this.n.byteLength()));
                        if (!((l = this._truncateToN(l, !0)).cmpn(1) <= 0 || l.cmp(f) >= 0)) {
                            var h = this.g.mul(l);
                            if (!h.isInfinity()) {
                                var p = h.getX(), b = p.umod(this.n);
                                if (0 !== b.cmpn(0)) {
                                    var y = l.invm(this.n).mul(b.mul(t.getPrivate()).iadd(e));
                                    if (0 !== (y = y.umod(this.n)).cmpn(0)) {
                                        var v = (h.getY().isOdd() ? 1 : 0) | (0 !== p.cmp(b) ? 2 : 0);
                                        return n.canonical && y.cmp(this.nh) > 0 && (y = this.n.sub(y), v ^= 1), new M({
                                            r: b,
                                            s: y,
                                            recoveryParam: v
                                        });
                                    }
                                }
                            }
                        }
                    }
                }, D.prototype.verify = function(e, t, r, n) {
                    e = this._truncateToN(new o.default(e, 16)), r = this.keyFromPublic(r, n);
                    var i = (t = new M(t, "hex")).r, a = t.s;
                    if (i.cmpn(1) < 0 || i.cmp(this.n) >= 0) return !1;
                    if (a.cmpn(1) < 0 || a.cmp(this.n) >= 0) return !1;
                    var s, u = a.invm(this.n), c = u.mul(e).umod(this.n), f = u.mul(i).umod(this.n);
                    return this.curve._maxwellTrick ? !(s = this.g.jmulAdd(c, r.getPublic(), f)).isInfinity() && s.eqXToP(i) : !(s = this.g.mulAdd(c, r.getPublic(), f)).isInfinity() && 0 === s.getX().umod(this.n).cmp(i);
                }, D.prototype.recoverPubKey = function(e, t, r, n) {
                    F((3 & r) === r, "The recovery param is more than two bits"), t = new M(t, n);
                    var i = this.n, a = new o.default(e), s = t.r, u = t.s, c = 1 & r, f = r >> 1;
                    if (s.cmp(this.curve.p.umod(this.curve.n)) >= 0 && f) throw new Error("Unable to find sencond key candinate");
                    s = f ? this.curve.pointFromX(s.add(this.curve.n), c) : this.curve.pointFromX(s, c);
                    var d = t.r.invm(i), l = i.sub(a).mul(d).umod(i), h = u.mul(d).umod(i);
                    return this.g.mulAdd(l, s, h);
                }, D.prototype.getKeyRecoveryParam = function(e, t, r, n) {
                    if (null !== (t = new M(t, n)).recoveryParam) return t.recoveryParam;
                    for(var i = 0; i < 4; i++){
                        var o;
                        try {
                            o = this.recoverPubKey(e, t, i);
                        } catch (e) {
                            continue;
                        }
                        if (o.eq(r)) return i;
                    }
                    throw new Error("Unable to find valid recovery factor");
                };
                var z = s(function(e, t) {
                    var r = t;
                    r.version = "6.5.4", r.utils = d, r.rand = function() {
                        throw new Error("unsupported");
                    }, r.curve = E, r.curves = S, r.ec = H, r.eddsa = null;
                }), q = z.ec;
                t.EC = q;
            },
            17612: (e, t, r)=>{
                "use strict";
                var n = r(28847);
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.SigningKey = void 0, t.computePublicKey = b, t.recoverPublicKey = function(e, t) {
                    var r = (0, s.splitSignature)(t), n = {
                        r: (0, s.arrayify)(r.r),
                        s: (0, s.arrayify)(r.s)
                    };
                    return "0x" + h().recoverPubKey((0, s.arrayify)(e), n, r.recoveryParam).encode("hex", !1);
                };
                var i = n(r(69721)), o = n(r(58985)), a = r(36918), s = r(908), u = r(23694), c = r(64327), f = r(48100), d = new c.Logger(f.version), l = null;
                function h() {
                    return l || (l = new a.EC("secp256k1")), l;
                }
                var p = function() {
                    function e(t) {
                        (0, i.default)(this, e), (0, u.defineReadOnly)(this, "curve", "secp256k1"), (0, u.defineReadOnly)(this, "privateKey", (0, s.hexlify)(t)), 32 !== (0, s.hexDataLength)(this.privateKey) && d.throwArgumentError("invalid private key", "privateKey", "[[ REDACTED ]]");
                        var r = h().keyFromPrivate((0, s.arrayify)(this.privateKey));
                        (0, u.defineReadOnly)(this, "publicKey", "0x" + r.getPublic(!1, "hex")), (0, u.defineReadOnly)(this, "compressedPublicKey", "0x" + r.getPublic(!0, "hex")), (0, u.defineReadOnly)(this, "_isSigningKey", !0);
                    }
                    return (0, o.default)(e, [
                        {
                            key: "_addPoint",
                            value: function(e) {
                                var t = h().keyFromPublic((0, s.arrayify)(this.publicKey)), r = h().keyFromPublic((0, s.arrayify)(e));
                                return "0x" + t.pub.add(r.pub).encodeCompressed("hex");
                            }
                        },
                        {
                            key: "signDigest",
                            value: function(e) {
                                var t = h().keyFromPrivate((0, s.arrayify)(this.privateKey)), r = (0, s.arrayify)(e);
                                32 !== r.length && d.throwArgumentError("bad digest length", "digest", e);
                                var n = t.sign(r, {
                                    canonical: !0
                                });
                                return (0, s.splitSignature)({
                                    recoveryParam: n.recoveryParam,
                                    r: (0, s.hexZeroPad)("0x" + n.r.toString(16), 32),
                                    s: (0, s.hexZeroPad)("0x" + n.s.toString(16), 32)
                                });
                            }
                        },
                        {
                            key: "computeSharedSecret",
                            value: function(e) {
                                var t = h().keyFromPrivate((0, s.arrayify)(this.privateKey)), r = h().keyFromPublic((0, s.arrayify)(b(e)));
                                return (0, s.hexZeroPad)("0x" + t.derive(r.getPublic()).toString(16), 32);
                            }
                        }
                    ], [
                        {
                            key: "isSigningKey",
                            value: function(e) {
                                return !(!e || !e._isSigningKey);
                            }
                        }
                    ]), e;
                }();
                function b(e, t) {
                    var r = (0, s.arrayify)(e);
                    if (32 === r.length) {
                        var n = new p(r);
                        return t ? "0x" + h().keyFromPrivate(r).getPublic(!0, "hex") : n.publicKey;
                    }
                    return 33 === r.length ? t ? (0, s.hexlify)(r) : "0x" + h().keyFromPublic(r).getPublic(!1, "hex") : 65 === r.length ? t ? "0x" + h().keyFromPublic(r).getPublic(!0, "hex") : (0, s.hexlify)(r) : d.throwArgumentError("invalid public or private key", "key", "[REDACTED]");
                }
                t.SigningKey = p;
            },
            56518: (e, t)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.version = void 0, t.version = "strings/5.7.0";
            },
            95856: (e, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.formatBytes32String = function(e) {
                    var t = (0, o.toUtf8Bytes)(e);
                    if (t.length > 31) throw new Error("bytes32 string must be less than 32 bytes");
                    return (0, i.hexlify)((0, i.concat)([
                        t,
                        n.HashZero
                    ]).slice(0, 32));
                }, t.parseBytes32String = function(e) {
                    var t = (0, i.arrayify)(e);
                    if (32 !== t.length) throw new Error("invalid bytes32 - not 32 bytes long");
                    if (0 !== t[31]) throw new Error("invalid bytes32 string - no null terminator");
                    for(var r = 31; 0 === t[r - 1];)r--;
                    return (0, o.toUtf8String)(t.slice(0, r));
                };
                var n = r(5465), i = r(908), o = r(34997);
            },
            68645: (e, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t._nameprepTableA1 = p, t._nameprepTableB2 = b, t._nameprepTableC = y, t.nameprep = function(e) {
                    if (e.match(/^[a-z0-9-]*$/i) && e.length <= 59) return e.toLowerCase();
                    var t, r = (0, n.toUtf8CodePoints)(e);
                    t = r.map(function(e) {
                        return u.indexOf(e) >= 0 || e >= 65024 && e <= 65039 ? [] : b(e) || [
                            e
                        ];
                    }), r = t.reduce(function(e, t) {
                        return t.forEach(function(t) {
                            e.push(t);
                        }), e;
                    }, []), (r = (0, n.toUtf8CodePoints)((0, n._toUtf8String)(r), n.UnicodeNormalizationForm.NFKC)).forEach(function(e) {
                        if (y(e)) throw new Error("STRINGPREP_CONTAINS_PROHIBITED");
                    }), r.forEach(function(e) {
                        if (p(e)) throw new Error("STRINGPREP_CONTAINS_UNASSIGNED");
                    });
                    var i = (0, n._toUtf8String)(r);
                    if ("-" === i.substring(0, 1) || "--" === i.substring(2, 4) || "-" === i.substring(i.length - 1)) throw new Error("invalid hyphen");
                    return i;
                };
                var n = r(34997);
                function i(e, t) {
                    t || (t = function(e) {
                        return [
                            parseInt(e, 16)
                        ];
                    });
                    var r = 0, n = {};
                    return e.split(",").forEach(function(e) {
                        var i = e.split(":");
                        r += parseInt(i[0], 16), n[r] = t(i[1]);
                    }), n;
                }
                function o(e) {
                    var t = 0;
                    return e.split(",").map(function(e) {
                        var r = e.split("-");
                        return 1 === r.length ? r[1] = "0" : "" === r[1] && (r[1] = "1"), {
                            l: t + parseInt(r[0], 16),
                            h: t = parseInt(r[1], 16)
                        };
                    });
                }
                function a(e, t) {
                    for(var r = 0, n = 0; n < t.length; n++){
                        var i = t[n];
                        if (e >= (r += i.l) && e <= r + i.h && (e - r) % (i.d || 1) == 0) {
                            if (i.e && -1 !== i.e.indexOf(e - r)) continue;
                            return i;
                        }
                    }
                    return null;
                }
                var s = o("221,13-1b,5f-,40-10,51-f,11-3,3-3,2-2,2-4,8,2,15,2d,28-8,88,48,27-,3-5,11-20,27-,8,28,3-5,12,18,b-a,1c-4,6-16,2-d,2-2,2,1b-4,17-9,8f-,10,f,1f-2,1c-34,33-14e,4,36-,13-,6-2,1a-f,4,9-,3-,17,8,2-2,5-,2,8-,3-,4-8,2-3,3,6-,16-6,2-,7-3,3-,17,8,3,3,3-,2,6-3,3-,4-a,5,2-6,10-b,4,8,2,4,17,8,3,6-,b,4,4-,2-e,2-4,b-10,4,9-,3-,17,8,3-,5-,9-2,3-,4-7,3-3,3,4-3,c-10,3,7-2,4,5-2,3,2,3-2,3-2,4-2,9,4-3,6-2,4,5-8,2-e,d-d,4,9,4,18,b,6-3,8,4,5-6,3-8,3-3,b-11,3,9,4,18,b,6-3,8,4,5-6,3-6,2,3-3,b-11,3,9,4,18,11-3,7-,4,5-8,2-7,3-3,b-11,3,13-2,19,a,2-,8-2,2-3,7,2,9-11,4-b,3b-3,1e-24,3,2-,3,2-,2-5,5,8,4,2,2-,3,e,4-,6,2,7-,b-,3-21,49,23-5,1c-3,9,25,10-,2-2f,23,6,3,8-2,5-5,1b-45,27-9,2a-,2-3,5b-4,45-4,53-5,8,40,2,5-,8,2,5-,28,2,5-,20,2,5-,8,2,5-,8,8,18,20,2,5-,8,28,14-5,1d-22,56-b,277-8,1e-2,52-e,e,8-a,18-8,15-b,e,4,3-b,5e-2,b-15,10,b-5,59-7,2b-555,9d-3,5b-5,17-,7-,27-,7-,9,2,2,2,20-,36,10,f-,7,14-,4,a,54-3,2-6,6-5,9-,1c-10,13-1d,1c-14,3c-,10-6,32-b,240-30,28-18,c-14,a0,115-,3,66-,b-76,5,5-,1d,24,2,5-2,2,8-,35-2,19,f-10,1d-3,311-37f,1b,5a-b,d7-19,d-3,41,57-,68-4,29-3,5f,29-37,2e-2,25-c,2c-2,4e-3,30,78-3,64-,20,19b7-49,51a7-59,48e-2,38-738,2ba5-5b,222f-,3c-94,8-b,6-4,1b,6,2,3,3,6d-20,16e-f,41-,37-7,2e-2,11-f,5-b,18-,b,14,5-3,6,88-,2,bf-2,7-,7-,7-,4-2,8,8-9,8-2ff,20,5-b,1c-b4,27-,27-cbb1,f7-9,28-2,b5-221,56,48,3-,2-,3-,5,d,2,5,3,42,5-,9,8,1d,5,6,2-2,8,153-3,123-3,33-27fd,a6da-5128,21f-5df,3-fffd,3-fffd,3-fffd,3-fffd,3-fffd,3-fffd,3-fffd,3-fffd,3-fffd,3-fffd,3-fffd,3,2-1d,61-ff7d"), u = "ad,34f,1806,180b,180c,180d,200b,200c,200d,2060,feff".split(",").map(function(e) {
                    return parseInt(e, 16);
                }), c = [
                    {
                        h: 25,
                        s: 32,
                        l: 65
                    },
                    {
                        h: 30,
                        s: 32,
                        e: [
                            23
                        ],
                        l: 127
                    },
                    {
                        h: 54,
                        s: 1,
                        e: [
                            48
                        ],
                        l: 64,
                        d: 2
                    },
                    {
                        h: 14,
                        s: 1,
                        l: 57,
                        d: 2
                    },
                    {
                        h: 44,
                        s: 1,
                        l: 17,
                        d: 2
                    },
                    {
                        h: 10,
                        s: 1,
                        e: [
                            2,
                            6,
                            8
                        ],
                        l: 61,
                        d: 2
                    },
                    {
                        h: 16,
                        s: 1,
                        l: 68,
                        d: 2
                    },
                    {
                        h: 84,
                        s: 1,
                        e: [
                            18,
                            24,
                            66
                        ],
                        l: 19,
                        d: 2
                    },
                    {
                        h: 26,
                        s: 32,
                        e: [
                            17
                        ],
                        l: 435
                    },
                    {
                        h: 22,
                        s: 1,
                        l: 71,
                        d: 2
                    },
                    {
                        h: 15,
                        s: 80,
                        l: 40
                    },
                    {
                        h: 31,
                        s: 32,
                        l: 16
                    },
                    {
                        h: 32,
                        s: 1,
                        l: 80,
                        d: 2
                    },
                    {
                        h: 52,
                        s: 1,
                        l: 42,
                        d: 2
                    },
                    {
                        h: 12,
                        s: 1,
                        l: 55,
                        d: 2
                    },
                    {
                        h: 40,
                        s: 1,
                        e: [
                            38
                        ],
                        l: 15,
                        d: 2
                    },
                    {
                        h: 14,
                        s: 1,
                        l: 48,
                        d: 2
                    },
                    {
                        h: 37,
                        s: 48,
                        l: 49
                    },
                    {
                        h: 148,
                        s: 1,
                        l: 6351,
                        d: 2
                    },
                    {
                        h: 88,
                        s: 1,
                        l: 160,
                        d: 2
                    },
                    {
                        h: 15,
                        s: 16,
                        l: 704
                    },
                    {
                        h: 25,
                        s: 26,
                        l: 854
                    },
                    {
                        h: 25,
                        s: 32,
                        l: 55915
                    },
                    {
                        h: 37,
                        s: 40,
                        l: 1247
                    },
                    {
                        h: 25,
                        s: -119711,
                        l: 53248
                    },
                    {
                        h: 25,
                        s: -119763,
                        l: 52
                    },
                    {
                        h: 25,
                        s: -119815,
                        l: 52
                    },
                    {
                        h: 25,
                        s: -119867,
                        e: [
                            1,
                            4,
                            5,
                            7,
                            8,
                            11,
                            12,
                            17
                        ],
                        l: 52
                    },
                    {
                        h: 25,
                        s: -119919,
                        l: 52
                    },
                    {
                        h: 24,
                        s: -119971,
                        e: [
                            2,
                            7,
                            8,
                            17
                        ],
                        l: 52
                    },
                    {
                        h: 24,
                        s: -120023,
                        e: [
                            2,
                            7,
                            13,
                            15,
                            16,
                            17
                        ],
                        l: 52
                    },
                    {
                        h: 25,
                        s: -120075,
                        l: 52
                    },
                    {
                        h: 25,
                        s: -120127,
                        l: 52
                    },
                    {
                        h: 25,
                        s: -120179,
                        l: 52
                    },
                    {
                        h: 25,
                        s: -120231,
                        l: 52
                    },
                    {
                        h: 25,
                        s: -120283,
                        l: 52
                    },
                    {
                        h: 25,
                        s: -120335,
                        l: 52
                    },
                    {
                        h: 24,
                        s: -119543,
                        e: [
                            17
                        ],
                        l: 56
                    },
                    {
                        h: 24,
                        s: -119601,
                        e: [
                            17
                        ],
                        l: 58
                    },
                    {
                        h: 24,
                        s: -119659,
                        e: [
                            17
                        ],
                        l: 58
                    },
                    {
                        h: 24,
                        s: -119717,
                        e: [
                            17
                        ],
                        l: 58
                    },
                    {
                        h: 24,
                        s: -119775,
                        e: [
                            17
                        ],
                        l: 58
                    }
                ], f = i("b5:3bc,c3:ff,7:73,2:253,5:254,3:256,1:257,5:259,1:25b,3:260,1:263,2:269,1:268,5:26f,1:272,2:275,7:280,3:283,5:288,3:28a,1:28b,5:292,3f:195,1:1bf,29:19e,125:3b9,8b:3b2,1:3b8,1:3c5,3:3c6,1:3c0,1a:3ba,1:3c1,1:3c3,2:3b8,1:3b5,1bc9:3b9,1c:1f76,1:1f77,f:1f7a,1:1f7b,d:1f78,1:1f79,1:1f7c,1:1f7d,107:63,5:25b,4:68,1:68,1:68,3:69,1:69,1:6c,3:6e,4:70,1:71,1:72,1:72,1:72,7:7a,2:3c9,2:7a,2:6b,1:e5,1:62,1:63,3:65,1:66,2:6d,b:3b3,1:3c0,6:64,1b574:3b8,1a:3c3,20:3b8,1a:3c3,20:3b8,1a:3c3,20:3b8,1a:3c3,20:3b8,1a:3c3"), d = i("179:1,2:1,2:1,5:1,2:1,a:4f,a:1,8:1,2:1,2:1,3:1,5:1,3:1,4:1,2:1,3:1,4:1,8:2,1:1,2:2,1:1,2:2,27:2,195:26,2:25,1:25,1:25,2:40,2:3f,1:3f,33:1,11:-6,1:-9,1ac7:-3a,6d:-8,1:-8,1:-8,1:-8,1:-8,1:-8,1:-8,1:-8,9:-8,1:-8,1:-8,1:-8,1:-8,1:-8,b:-8,1:-8,1:-8,1:-8,1:-8,1:-8,1:-8,1:-8,9:-8,1:-8,1:-8,1:-8,1:-8,1:-8,1:-8,1:-8,9:-8,1:-8,1:-8,1:-8,1:-8,1:-8,c:-8,2:-8,2:-8,2:-8,9:-8,1:-8,1:-8,1:-8,1:-8,1:-8,1:-8,1:-8,49:-8,1:-8,1:-4a,1:-4a,d:-56,1:-56,1:-56,1:-56,d:-8,1:-8,f:-8,1:-8,3:-7"), l = i("df:00730073,51:00690307,19:02BC006E,a7:006A030C,18a:002003B9,16:03B903080301,20:03C503080301,1d7:05650582,190f:00680331,1:00740308,1:0077030A,1:0079030A,1:006102BE,b6:03C50313,2:03C503130300,2:03C503130301,2:03C503130342,2a:1F0003B9,1:1F0103B9,1:1F0203B9,1:1F0303B9,1:1F0403B9,1:1F0503B9,1:1F0603B9,1:1F0703B9,1:1F0003B9,1:1F0103B9,1:1F0203B9,1:1F0303B9,1:1F0403B9,1:1F0503B9,1:1F0603B9,1:1F0703B9,1:1F2003B9,1:1F2103B9,1:1F2203B9,1:1F2303B9,1:1F2403B9,1:1F2503B9,1:1F2603B9,1:1F2703B9,1:1F2003B9,1:1F2103B9,1:1F2203B9,1:1F2303B9,1:1F2403B9,1:1F2503B9,1:1F2603B9,1:1F2703B9,1:1F6003B9,1:1F6103B9,1:1F6203B9,1:1F6303B9,1:1F6403B9,1:1F6503B9,1:1F6603B9,1:1F6703B9,1:1F6003B9,1:1F6103B9,1:1F6203B9,1:1F6303B9,1:1F6403B9,1:1F6503B9,1:1F6603B9,1:1F6703B9,3:1F7003B9,1:03B103B9,1:03AC03B9,2:03B10342,1:03B1034203B9,5:03B103B9,6:1F7403B9,1:03B703B9,1:03AE03B9,2:03B70342,1:03B7034203B9,5:03B703B9,6:03B903080300,1:03B903080301,3:03B90342,1:03B903080342,b:03C503080300,1:03C503080301,1:03C10313,2:03C50342,1:03C503080342,b:1F7C03B9,1:03C903B9,1:03CE03B9,2:03C90342,1:03C9034203B9,5:03C903B9,ac:00720073,5b:00B00063,6:00B00066,d:006E006F,a:0073006D,1:00740065006C,1:0074006D,124f:006800700061,2:00610075,2:006F0076,b:00700061,1:006E0061,1:03BC0061,1:006D0061,1:006B0061,1:006B0062,1:006D0062,1:00670062,3:00700066,1:006E0066,1:03BC0066,4:0068007A,1:006B0068007A,1:006D0068007A,1:00670068007A,1:00740068007A,15:00700061,1:006B00700061,1:006D00700061,1:006700700061,8:00700076,1:006E0076,1:03BC0076,1:006D0076,1:006B0076,1:006D0076,1:00700077,1:006E0077,1:03BC0077,1:006D0077,1:006B0077,1:006D0077,1:006B03C9,1:006D03C9,2:00620071,3:00632215006B0067,1:0063006F002E,1:00640062,1:00670079,2:00680070,2:006B006B,1:006B006D,9:00700068,2:00700070006D,1:00700072,2:00730076,1:00770062,c723:00660066,1:00660069,1:0066006C,1:006600660069,1:00660066006C,1:00730074,1:00730074,d:05740576,1:05740565,1:0574056B,1:057E0576,1:0574056D", function(e) {
                    if (e.length % 4 != 0) throw new Error("bad data");
                    for(var t = [], r = 0; r < e.length; r += 4)t.push(parseInt(e.substring(r, r + 4), 16));
                    return t;
                }), h = o("80-20,2a0-,39c,32,f71,18e,7f2-f,19-7,30-4,7-5,f81-b,5,a800-20ff,4d1-1f,110,fa-6,d174-7,2e84-,ffff-,ffff-,ffff-,ffff-,ffff-,ffff-,ffff-,ffff-,ffff-,ffff-,ffff-,ffff-,2,1f-5f,ff7f-20001");
                function p(e) {
                    return !!a(e, s);
                }
                function b(e) {
                    var t = a(e, c);
                    if (t) return [
                        e + t.s
                    ];
                    var r = f[e];
                    if (r) return r;
                    var n = d[e];
                    return n ? [
                        e + n[0]
                    ] : l[e] || null;
                }
                function y(e) {
                    return !!a(e, h);
                }
            },
            78627: (e, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), Object.defineProperty(t, "UnicodeNormalizationForm", {
                    enumerable: !0,
                    get: function() {
                        return o.UnicodeNormalizationForm;
                    }
                }), Object.defineProperty(t, "Utf8ErrorFuncs", {
                    enumerable: !0,
                    get: function() {
                        return o.Utf8ErrorFuncs;
                    }
                }), Object.defineProperty(t, "Utf8ErrorReason", {
                    enumerable: !0,
                    get: function() {
                        return o.Utf8ErrorReason;
                    }
                }), Object.defineProperty(t, "_toEscapedUtf8String", {
                    enumerable: !0,
                    get: function() {
                        return o._toEscapedUtf8String;
                    }
                }), Object.defineProperty(t, "formatBytes32String", {
                    enumerable: !0,
                    get: function() {
                        return n.formatBytes32String;
                    }
                }), Object.defineProperty(t, "nameprep", {
                    enumerable: !0,
                    get: function() {
                        return i.nameprep;
                    }
                }), Object.defineProperty(t, "parseBytes32String", {
                    enumerable: !0,
                    get: function() {
                        return n.parseBytes32String;
                    }
                }), Object.defineProperty(t, "toUtf8Bytes", {
                    enumerable: !0,
                    get: function() {
                        return o.toUtf8Bytes;
                    }
                }), Object.defineProperty(t, "toUtf8CodePoints", {
                    enumerable: !0,
                    get: function() {
                        return o.toUtf8CodePoints;
                    }
                }), Object.defineProperty(t, "toUtf8String", {
                    enumerable: !0,
                    get: function() {
                        return o.toUtf8String;
                    }
                });
                var n = r(95856), i = r(68645), o = r(34997);
            },
            34997: (e, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.Utf8ErrorReason = t.Utf8ErrorFuncs = t.UnicodeNormalizationForm = void 0, t._toEscapedUtf8String = function(e, t) {
                    return '"' + d(e, t).map(function(e) {
                        if (e < 256) {
                            switch(e){
                                case 8:
                                    return "\\b";
                                case 9:
                                    return "\\t";
                                case 10:
                                    return "\\n";
                                case 13:
                                    return "\\r";
                                case 34:
                                    return '\\"';
                                case 92:
                                    return "\\\\";
                            }
                            if (e >= 32 && e < 127) return String.fromCharCode(e);
                        }
                        return e <= 65535 ? h(e) : h(55296 + ((e -= 65536) >> 10 & 1023)) + h(56320 + (1023 & e));
                    }).join("") + '"';
                }, t._toUtf8String = p, t.toUtf8Bytes = l, t.toUtf8CodePoints = function(e) {
                    return d(l(e, arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : n.current));
                }, t.toUtf8String = function(e, t) {
                    return p(d(e, t));
                };
                var n, i, o = r(908), a = r(64327), s = r(56518), u = new a.Logger(s.version);
                function c(e, t, r, n, o) {
                    if (e === i.BAD_PREFIX || e === i.UNEXPECTED_CONTINUE) {
                        for(var a = 0, s = t + 1; s < r.length && r[s] >> 6 == 2; s++)a++;
                        return a;
                    }
                    return e === i.OVERRUN ? r.length - t - 1 : 0;
                }
                t.UnicodeNormalizationForm = n, function(e) {
                    e.current = "", e.NFC = "NFC", e.NFD = "NFD", e.NFKC = "NFKC", e.NFKD = "NFKD";
                }(n || (t.UnicodeNormalizationForm = n = {})), t.Utf8ErrorReason = i, function(e) {
                    e.UNEXPECTED_CONTINUE = "unexpected continuation byte", e.BAD_PREFIX = "bad codepoint prefix", e.OVERRUN = "string overrun", e.MISSING_CONTINUE = "missing continuation byte", e.OUT_OF_RANGE = "out of UTF-8 range", e.UTF16_SURROGATE = "UTF-16 surrogate", e.OVERLONG = "overlong representation";
                }(i || (t.Utf8ErrorReason = i = {}));
                var f = Object.freeze({
                    error: function(e, t, r, n, i) {
                        return u.throwArgumentError("invalid codepoint at offset ".concat(t, "; ").concat(e), "bytes", r);
                    },
                    ignore: c,
                    replace: function(e, t, r, n, o) {
                        return e === i.OVERLONG ? (n.push(o), 0) : (n.push(65533), c(e, t, r));
                    }
                });
                function d(e, t) {
                    null == t && (t = f.error), e = (0, o.arrayify)(e);
                    for(var r = [], n = 0; n < e.length;){
                        var a = e[n++];
                        if (a >> 7 != 0) {
                            var s = null, u = null;
                            if (192 == (224 & a)) s = 1, u = 127;
                            else if (224 == (240 & a)) s = 2, u = 2047;
                            else {
                                if (240 != (248 & a)) {
                                    n += t(128 == (192 & a) ? i.UNEXPECTED_CONTINUE : i.BAD_PREFIX, n - 1, e, r);
                                    continue;
                                }
                                s = 3, u = 65535;
                            }
                            if (n - 1 + s >= e.length) n += t(i.OVERRUN, n - 1, e, r);
                            else {
                                for(var c = a & (1 << 8 - s - 1) - 1, d = 0; d < s; d++){
                                    var l = e[n];
                                    if (128 != (192 & l)) {
                                        n += t(i.MISSING_CONTINUE, n, e, r), c = null;
                                        break;
                                    }
                                    c = c << 6 | 63 & l, n++;
                                }
                                null !== c && (c > 1114111 ? n += t(i.OUT_OF_RANGE, n - 1 - s, e, r, c) : c >= 55296 && c <= 57343 ? n += t(i.UTF16_SURROGATE, n - 1 - s, e, r, c) : c <= u ? n += t(i.OVERLONG, n - 1 - s, e, r, c) : r.push(c));
                            }
                        } else r.push(a);
                    }
                    return r;
                }
                function l(e) {
                    var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : n.current;
                    t != n.current && (u.checkNormalize(), e = e.normalize(t));
                    for(var r = [], i = 0; i < e.length; i++){
                        var a = e.charCodeAt(i);
                        if (a < 128) r.push(a);
                        else if (a < 2048) r.push(a >> 6 | 192), r.push(63 & a | 128);
                        else if (55296 == (64512 & a)) {
                            i++;
                            var s = e.charCodeAt(i);
                            if (i >= e.length || 56320 != (64512 & s)) throw new Error("invalid utf-8 string");
                            var c = 65536 + ((1023 & a) << 10) + (1023 & s);
                            r.push(c >> 18 | 240), r.push(c >> 12 & 63 | 128), r.push(c >> 6 & 63 | 128), r.push(63 & c | 128);
                        } else r.push(a >> 12 | 224), r.push(a >> 6 & 63 | 128), r.push(63 & a | 128);
                    }
                    return (0, o.arrayify)(r);
                }
                function h(e) {
                    var t = "0000" + e.toString(16);
                    return "\\u" + t.substring(t.length - 4);
                }
                function p(e) {
                    return e.map(function(e) {
                        return e <= 65535 ? String.fromCharCode(e) : (e -= 65536, String.fromCharCode(55296 + (e >> 10 & 1023), 56320 + (1023 & e)));
                    }).join("");
                }
                t.Utf8ErrorFuncs = f;
            },
            96783: (e, t)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.version = void 0, t.version = "transactions/5.7.0";
            },
            21936: (e, t, r)=>{
                "use strict";
                var n = r(3355);
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.TransactionTypes = void 0, t.accessListify = S, t.computeAddress = k, t.parse = function(e) {
                    var t = (0, a.arrayify)(e);
                    if (t[0] > 127) return function(e) {
                        var t = f.decode(e);
                        9 !== t.length && 6 !== t.length && y.throwArgumentError("invalid raw transaction", "rawTransaction", e);
                        var r = {
                            nonce: m(t[0]).toNumber(),
                            gasPrice: m(t[1]),
                            gasLimit: m(t[2]),
                            to: v(t[3]),
                            value: m(t[4]),
                            data: t[5],
                            chainId: 0
                        };
                        if (6 === t.length) return r;
                        try {
                            r.v = o.BigNumber.from(t[6]).toNumber();
                        } catch (e) {
                            return r;
                        }
                        if (r.r = (0, a.hexZeroPad)(t[7], 32), r.s = (0, a.hexZeroPad)(t[8], 32), o.BigNumber.from(r.r).isZero() && o.BigNumber.from(r.s).isZero()) r.chainId = r.v, r.v = 0;
                        else {
                            r.chainId = Math.floor((r.v - 35) / 2), r.chainId < 0 && (r.chainId = 0);
                            var n = r.v - 27, i = t.slice(0, 6);
                            0 !== r.chainId && (i.push((0, a.hexlify)(r.chainId)), i.push("0x"), i.push("0x"), n -= 2 * r.chainId + 8);
                            var s = (0, u.keccak256)(f.encode(i));
                            try {
                                r.from = _(s, {
                                    r: (0, a.hexlify)(r.r),
                                    s: (0, a.hexlify)(r.s),
                                    recoveryParam: n
                                });
                            } catch (e) {}
                            r.hash = (0, u.keccak256)(e);
                        }
                        return r.type = null, r;
                    }(t);
                    switch(t[0]){
                        case 1:
                            return function(e) {
                                var t = f.decode(e.slice(1));
                                8 !== t.length && 11 !== t.length && y.throwArgumentError("invalid component count for transaction type: 1", "payload", (0, a.hexlify)(e));
                                var r = {
                                    type: 1,
                                    chainId: m(t[0]).toNumber(),
                                    nonce: m(t[1]).toNumber(),
                                    gasPrice: m(t[2]),
                                    gasLimit: m(t[3]),
                                    to: v(t[4]),
                                    value: m(t[5]),
                                    data: t[6],
                                    accessList: S(t[7])
                                };
                                return 8 === t.length || (r.hash = (0, u.keccak256)(e), P(r, t.slice(8), O)), r;
                            }(t);
                        case 2:
                            return function(e) {
                                var t = f.decode(e.slice(1));
                                9 !== t.length && 12 !== t.length && y.throwArgumentError("invalid component count for transaction type: 2", "payload", (0, a.hexlify)(e));
                                var r = m(t[2]), n = m(t[3]), i = {
                                    type: 2,
                                    chainId: m(t[0]).toNumber(),
                                    nonce: m(t[1]).toNumber(),
                                    maxPriorityFeePerGas: r,
                                    maxFeePerGas: n,
                                    gasPrice: null,
                                    gasLimit: m(t[4]),
                                    to: v(t[5]),
                                    value: m(t[6]),
                                    data: t[7],
                                    accessList: S(t[8])
                                };
                                return 9 === t.length || (i.hash = (0, u.keccak256)(e), P(i, t.slice(9), B)), i;
                            }(t);
                    }
                    return y.throwError("unsupported transaction type: ".concat(t[0]), l.Logger.errors.UNSUPPORTED_OPERATION, {
                        operation: "parseTransaction",
                        transactionType: t[0]
                    });
                }, t.recoverAddress = _, t.serialize = function(e, t) {
                    if (null == e.type || 0 === e.type) return null != e.accessList && y.throwArgumentError("untyped transactions do not support accessList; include type: 1", "transaction", e), function(e, t) {
                        (0, c.checkProperties)(e, w);
                        var r = [];
                        g.forEach(function(t) {
                            var n = e[t.name] || [], i = {};
                            t.numeric && (i.hexPad = "left"), n = (0, a.arrayify)((0, a.hexlify)(n, i)), t.length && n.length !== t.length && n.length > 0 && y.throwArgumentError("invalid length for " + t.name, "transaction:" + t.name, n), t.maxLength && (n = (0, a.stripZeros)(n)).length > t.maxLength && y.throwArgumentError("invalid length for " + t.name, "transaction:" + t.name, n), r.push((0, a.hexlify)(n));
                        });
                        var n = 0;
                        if (null != e.chainId ? "number" != typeof (n = e.chainId) && y.throwArgumentError("invalid transaction.chainId", "transaction", e) : t && !(0, a.isBytesLike)(t) && t.v > 28 && (n = Math.floor((t.v - 35) / 2)), 0 !== n && (r.push((0, a.hexlify)(n)), r.push("0x"), r.push("0x")), !t) return f.encode(r);
                        var i = (0, a.splitSignature)(t), o = 27 + i.recoveryParam;
                        return 0 !== n ? (r.pop(), r.pop(), r.pop(), o += 2 * n + 8, i.v > 28 && i.v !== o && y.throwArgumentError("transaction.chainId/signature.v mismatch", "signature", t)) : i.v !== o && y.throwArgumentError("transaction.chainId/signature.v mismatch", "signature", t), r.push((0, a.hexlify)(o)), r.push((0, a.stripZeros)((0, a.arrayify)(i.r))), r.push((0, a.stripZeros)((0, a.arrayify)(i.s))), f.encode(r);
                    }(e, t);
                    switch(e.type){
                        case 1:
                            return O(e, t);
                        case 2:
                            return B(e, t);
                    }
                    return y.throwError("unsupported transaction type: ".concat(e.type), l.Logger.errors.UNSUPPORTED_OPERATION, {
                        operation: "serializeTransaction",
                        transactionType: e.type
                    });
                };
                var i = r(77921), o = r(34952), a = r(908), s = r(5465), u = r(64642), c = r(23694), f = function(e, t) {
                    if (e && e.__esModule) return e;
                    if (null === e || "object" !== n(e) && "function" != typeof e) return {
                        default: e
                    };
                    var r = p(t);
                    if (r && r.has(e)) return r.get(e);
                    var i = {}, o = Object.defineProperty && Object.getOwnPropertyDescriptor;
                    for(var a in e)if ("default" !== a && Object.prototype.hasOwnProperty.call(e, a)) {
                        var s = o ? Object.getOwnPropertyDescriptor(e, a) : null;
                        s && (s.get || s.set) ? Object.defineProperty(i, a, s) : i[a] = e[a];
                    }
                    return i.default = e, r && r.set(e, i), i;
                }(r(55265)), d = r(17612), l = r(64327), h = r(96783);
                function p(e) {
                    if ("function" != typeof WeakMap) return null;
                    var t = new WeakMap, r = new WeakMap;
                    return (p = function(e) {
                        return e ? r : t;
                    })(e);
                }
                var b, y = new l.Logger(h.version);
                function v(e) {
                    return "0x" === e ? null : (0, i.getAddress)(e);
                }
                function m(e) {
                    return "0x" === e ? s.Zero : o.BigNumber.from(e);
                }
                t.TransactionTypes = b, function(e) {
                    e[e.legacy = 0] = "legacy", e[e.eip2930 = 1] = "eip2930", e[e.eip1559 = 2] = "eip1559";
                }(b || (t.TransactionTypes = b = {}));
                var g = [
                    {
                        name: "nonce",
                        maxLength: 32,
                        numeric: !0
                    },
                    {
                        name: "gasPrice",
                        maxLength: 32,
                        numeric: !0
                    },
                    {
                        name: "gasLimit",
                        maxLength: 32,
                        numeric: !0
                    },
                    {
                        name: "to",
                        length: 20
                    },
                    {
                        name: "value",
                        maxLength: 32,
                        numeric: !0
                    },
                    {
                        name: "data"
                    }
                ], w = {
                    chainId: !0,
                    data: !0,
                    gasLimit: !0,
                    gasPrice: !0,
                    nonce: !0,
                    to: !0,
                    type: !0,
                    value: !0
                };
                function k(e) {
                    var t = (0, d.computePublicKey)(e);
                    return (0, i.getAddress)((0, a.hexDataSlice)((0, u.keccak256)((0, a.hexDataSlice)(t, 1)), 12));
                }
                function _(e, t) {
                    return k((0, d.recoverPublicKey)((0, a.arrayify)(e), t));
                }
                function A(e, t) {
                    var r = (0, a.stripZeros)(o.BigNumber.from(e).toHexString());
                    return r.length > 32 && y.throwArgumentError("invalid length for " + t, "transaction:" + t, e), r;
                }
                function E(e, t) {
                    return {
                        address: (0, i.getAddress)(e),
                        storageKeys: (t || []).map(function(t, r) {
                            return 32 !== (0, a.hexDataLength)(t) && y.throwArgumentError("invalid access list storageKey", "accessList[".concat(e, ":").concat(r, "]"), t), t.toLowerCase();
                        })
                    };
                }
                function S(e) {
                    if (Array.isArray(e)) return e.map(function(e, t) {
                        return Array.isArray(e) ? (e.length > 2 && y.throwArgumentError("access list expected to be [ address, storageKeys[] ]", "value[".concat(t, "]"), e), E(e[0], e[1])) : E(e.address, e.storageKeys);
                    });
                    var t = Object.keys(e).map(function(t) {
                        var r = e[t].reduce(function(e, t) {
                            return e[t] = !0, e;
                        }, {});
                        return E(t, Object.keys(r).sort());
                    });
                    return t.sort(function(e, t) {
                        return e.address.localeCompare(t.address);
                    }), t;
                }
                function x(e) {
                    return S(e).map(function(e) {
                        return [
                            e.address,
                            e.storageKeys
                        ];
                    });
                }
                function B(e, t) {
                    if (null != e.gasPrice) {
                        var r = o.BigNumber.from(e.gasPrice), n = o.BigNumber.from(e.maxFeePerGas || 0);
                        r.eq(n) || y.throwArgumentError("mismatch EIP-1559 gasPrice != maxFeePerGas", "tx", {
                            gasPrice: r,
                            maxFeePerGas: n
                        });
                    }
                    var s = [
                        A(e.chainId || 0, "chainId"),
                        A(e.nonce || 0, "nonce"),
                        A(e.maxPriorityFeePerGas || 0, "maxPriorityFeePerGas"),
                        A(e.maxFeePerGas || 0, "maxFeePerGas"),
                        A(e.gasLimit || 0, "gasLimit"),
                        null != e.to ? (0, i.getAddress)(e.to) : "0x",
                        A(e.value || 0, "value"),
                        e.data || "0x",
                        x(e.accessList || [])
                    ];
                    if (t) {
                        var u = (0, a.splitSignature)(t);
                        s.push(A(u.recoveryParam, "recoveryParam")), s.push((0, a.stripZeros)(u.r)), s.push((0, a.stripZeros)(u.s));
                    }
                    return (0, a.hexConcat)([
                        "0x02",
                        f.encode(s)
                    ]);
                }
                function O(e, t) {
                    var r = [
                        A(e.chainId || 0, "chainId"),
                        A(e.nonce || 0, "nonce"),
                        A(e.gasPrice || 0, "gasPrice"),
                        A(e.gasLimit || 0, "gasLimit"),
                        null != e.to ? (0, i.getAddress)(e.to) : "0x",
                        A(e.value || 0, "value"),
                        e.data || "0x",
                        x(e.accessList || [])
                    ];
                    if (t) {
                        var n = (0, a.splitSignature)(t);
                        r.push(A(n.recoveryParam, "recoveryParam")), r.push((0, a.stripZeros)(n.r)), r.push((0, a.stripZeros)(n.s));
                    }
                    return (0, a.hexConcat)([
                        "0x01",
                        f.encode(r)
                    ]);
                }
                function P(e, t, r) {
                    try {
                        var n = m(t[0]).toNumber();
                        if (0 !== n && 1 !== n) throw new Error("bad recid");
                        e.v = n;
                    } catch (e) {
                        y.throwArgumentError("invalid v for transaction type: 1", "v", t[0]);
                    }
                    e.r = (0, a.hexZeroPad)(t[1], 32), e.s = (0, a.hexZeroPad)(t[2], 32);
                    try {
                        var i = (0, u.keccak256)(r(e));
                        e.from = _(i, {
                            r: e.r,
                            s: e.s,
                            recoveryParam: e.v
                        });
                    } catch (e) {}
                }
            },
            96546: (e, t, r)=>{
                "use strict";
                var n = r(28847)(r(90775));
                function i(e, t) {
                    var r = Object.keys(e);
                    if (Object.getOwnPropertySymbols) {
                        var n = Object.getOwnPropertySymbols(e);
                        t && (n = n.filter(function(t) {
                            return Object.getOwnPropertyDescriptor(e, t).enumerable;
                        })), r.push.apply(r, n);
                    }
                    return r;
                }
                function o(e) {
                    for(var t = 1; t < arguments.length; t++){
                        var r = null != arguments[t] ? arguments[t] : {};
                        t % 2 ? i(Object(r), !0).forEach(function(t) {
                            (0, n.default)(e, t, r[t]);
                        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : i(Object(r)).forEach(function(t) {
                            Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
                        });
                    }
                    return e;
                }
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.createCurve = t.getHash = void 0;
                var a = r(45896), s = r(72434), u = r(16573);
                function c(e) {
                    return {
                        hash: e,
                        hmac: function(t) {
                            for(var r = arguments.length, n = new Array(r > 1 ? r - 1 : 0), i = 1; i < r; i++)n[i - 1] = arguments[i];
                            return (0, a.hmac)(e, t, s.concatBytes.apply(void 0, n));
                        },
                        randomBytes: s.randomBytes
                    };
                }
                t.getHash = c, t.createCurve = function(e, t) {
                    var r = function(t) {
                        return (0, u.weierstrass)(o(o({}, e), c(t)));
                    };
                    return Object.freeze(o(o({}, r(t)), {}, {
                        create: r
                    }));
                };
            },
            91813: (e, t, r)=>{
                "use strict";
                var n = r(28847)(r(90775));
                function i(e, t) {
                    var r = Object.keys(e);
                    if (Object.getOwnPropertySymbols) {
                        var n = Object.getOwnPropertySymbols(e);
                        t && (n = n.filter(function(t) {
                            return Object.getOwnPropertyDescriptor(e, t).enumerable;
                        })), r.push.apply(r, n);
                    }
                    return r;
                }
                function o(e) {
                    for(var t = 1; t < arguments.length; t++){
                        var r = null != arguments[t] ? arguments[t] : {};
                        t % 2 ? i(Object(r), !0).forEach(function(t) {
                            (0, n.default)(e, t, r[t]);
                        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : i(Object(r)).forEach(function(t) {
                            Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
                        });
                    }
                    return e;
                }
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.validateBasic = t.wNAF = void 0;
                var a = r(3970), s = r(46928), u = BigInt(0), c = BigInt(1);
                t.wNAF = function(e, t) {
                    var r = function(e, t) {
                        var r = t.negate();
                        return e ? r : t;
                    }, n = function(e) {
                        return {
                            windows: Math.ceil(t / e) + 1,
                            windowSize: Math.pow(2, e - 1)
                        };
                    };
                    return {
                        constTimeNegate: r,
                        unsafeLadder: function(t, r) {
                            for(var n = e.ZERO, i = t; r > u;)r & c && (n = n.add(i)), i = i.double(), r >>= c;
                            return n;
                        },
                        precomputeWindow: function(e, t) {
                            for(var r = n(t), i = r.windows, o = r.windowSize, a = [], s = e, u = s, c = 0; c < i; c++){
                                u = s, a.push(u);
                                for(var f = 1; f < o; f++)u = u.add(s), a.push(u);
                                s = u.double();
                            }
                            return a;
                        },
                        wNAF: function(t, i, o) {
                            for(var a = n(t), s = a.windows, u = a.windowSize, f = e.ZERO, d = e.BASE, l = BigInt(Math.pow(2, t) - 1), h = Math.pow(2, t), p = BigInt(t), b = 0; b < s; b++){
                                var y = b * u, v = Number(o & l);
                                o >>= p, v > u && (v -= h, o += c);
                                var m = y, g = y + Math.abs(v) - 1, w = b % 2 != 0, k = v < 0;
                                0 === v ? d = d.add(r(w, i[m])) : f = f.add(r(k, i[g]));
                            }
                            return {
                                p: f,
                                f: d
                            };
                        },
                        wNAFCached: function(e, t, r, n) {
                            var i = e._WINDOW_SIZE || 1, o = t.get(e);
                            return o || (o = this.precomputeWindow(e, i), 1 !== i && t.set(e, n(o))), this.wNAF(i, o, r);
                        }
                    };
                }, t.validateBasic = function(e) {
                    return (0, a.validateField)(e.Fp), (0, s.validateObject)(e, {
                        n: "bigint",
                        h: "bigint",
                        Gx: "field",
                        Gy: "field"
                    }, {
                        nBitLength: "isSafeInteger",
                        nByteLength: "isSafeInteger"
                    }), Object.freeze(o(o(o({}, (0, a.nLength)(e.n, e.nBitLength)), e), {
                        p: e.Fp.ORDER
                    }));
                };
            },
            19751: (e, t, r)=>{
                "use strict";
                var n = r(28847), i = n(r(90775)), o = n(r(74519));
                function a(e, t) {
                    var r = Object.keys(e);
                    if (Object.getOwnPropertySymbols) {
                        var n = Object.getOwnPropertySymbols(e);
                        t && (n = n.filter(function(t) {
                            return Object.getOwnPropertyDescriptor(e, t).enumerable;
                        })), r.push.apply(r, n);
                    }
                    return r;
                }
                function s(e) {
                    for(var t = 1; t < arguments.length; t++){
                        var r = null != arguments[t] ? arguments[t] : {};
                        t % 2 ? a(Object(r), !0).forEach(function(t) {
                            (0, i.default)(e, t, r[t]);
                        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : a(Object(r)).forEach(function(t) {
                            Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
                        });
                    }
                    return e;
                }
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.createHasher = t.isogenyMap = t.hash_to_field = t.expand_message_xof = t.expand_message_xmd = void 0;
                var u = r(3970), c = r(46928), f = c.bytesToNumberBE;
                function d(e, t) {
                    if (e < 0 || e >= 1 << 8 * t) throw new Error("bad I2OSP call: value=".concat(e, " length=").concat(t));
                    for(var r = Array.from({
                        length: t
                    }).fill(0), n = t - 1; n >= 0; n--)r[n] = 255 & e, e >>>= 8;
                    return new Uint8Array(r);
                }
                function l(e, t) {
                    for(var r = new Uint8Array(e.length), n = 0; n < e.length; n++)r[n] = e[n] ^ t[n];
                    return r;
                }
                function h(e) {
                    if (!(e instanceof Uint8Array)) throw new Error("Uint8Array expected");
                }
                function p(e) {
                    if (!Number.isSafeInteger(e)) throw new Error("number expected");
                }
                function b(e, t, r, n) {
                    h(e), h(t), p(r), t.length > 255 && (t = n((0, c.concatBytes)((0, c.utf8ToBytes)("H2C-OVERSIZE-DST-"), t)));
                    var i = n.outputLen, o = n.blockLen, a = Math.ceil(r / i);
                    if (a > 255) throw new Error("Invalid xmd length");
                    var s = (0, c.concatBytes)(t, d(t.length, 1)), u = d(0, o), f = d(r, 2), b = new Array(a), y = n((0, c.concatBytes)(u, e, f, d(0, 1), s));
                    b[0] = n((0, c.concatBytes)(y, d(1, 1), s));
                    for(var v = 1; v <= a; v++){
                        var m = [
                            l(y, b[v - 1]),
                            d(v + 1, 1),
                            s
                        ];
                        b[v] = n(c.concatBytes.apply(void 0, m));
                    }
                    return c.concatBytes.apply(void 0, b).slice(0, r);
                }
                function y(e, t, r, n, i) {
                    if (h(e), h(t), p(r), t.length > 255) {
                        var o = Math.ceil(2 * n / 8);
                        t = i.create({
                            dkLen: o
                        }).update((0, c.utf8ToBytes)("H2C-OVERSIZE-DST-")).update(t).digest();
                    }
                    if (r > 65535 || t.length > 255) throw new Error("expand_message_xof: invalid lenInBytes");
                    return i.create({
                        dkLen: r
                    }).update(e).update(d(r, 2)).update(t).update(d(t.length, 1)).digest();
                }
                function v(e, t, r) {
                    (0, c.validateObject)(r, {
                        DST: "string",
                        p: "bigint",
                        m: "isSafeInteger",
                        k: "isSafeInteger",
                        hash: "hash"
                    });
                    var n = r.p, i = r.k, o = r.m, a = r.hash, s = r.expand, d = r.DST;
                    h(e), p(t);
                    var l, v = function(e) {
                        if (e instanceof Uint8Array) return e;
                        if ("string" == typeof e) return (0, c.utf8ToBytes)(e);
                        throw new Error("DST must be Uint8Array or string");
                    }(d), m = n.toString(2).length, g = Math.ceil((m + i) / 8), w = t * o * g;
                    if ("xmd" === s) l = b(e, v, w, a);
                    else if ("xof" === s) l = y(e, v, w, i, a);
                    else {
                        if ("_internal_pass" !== s) throw new Error('expand must be "xmd" or "xof"');
                        l = e;
                    }
                    for(var k = new Array(t), _ = 0; _ < t; _++){
                        for(var A = new Array(o), E = 0; E < o; E++){
                            var S = g * (E + _ * o), x = l.subarray(S, S + g);
                            A[E] = (0, u.mod)(f(x), n);
                        }
                        k[_] = A;
                    }
                    return k;
                }
                t.expand_message_xmd = b, t.expand_message_xof = y, t.hash_to_field = v, t.isogenyMap = function(e, t) {
                    var r = t.map(function(e) {
                        return Array.from(e).reverse();
                    });
                    return function(t, n) {
                        var i = r.map(function(r) {
                            return r.reduce(function(r, n) {
                                return e.add(e.mul(r, t), n);
                            });
                        }), a = (0, o.default)(i, 4), s = a[0], u = a[1], c = a[2], f = a[3];
                        return t = e.div(s, u), n = e.mul(n, e.div(c, f)), {
                            x: t,
                            y: n
                        };
                    };
                }, t.createHasher = function(e, t, r) {
                    if ("function" != typeof t) throw new Error("mapToCurve() must be defined");
                    return {
                        hashToCurve: function(n, i) {
                            var o = v(n, 2, s(s({}, r), {}, {
                                DST: r.DST
                            }, i)), a = e.fromAffine(t(o[0])), u = e.fromAffine(t(o[1])), c = a.add(u).clearCofactor();
                            return c.assertValidity(), c;
                        },
                        encodeToCurve: function(n, i) {
                            var o = v(n, 1, s(s({}, r), {}, {
                                DST: r.encodeDST
                            }, i)), a = e.fromAffine(t(o[0])).clearCofactor();
                            return a.assertValidity(), a;
                        }
                    };
                };
            },
            3970: (e, t, r)=>{
                "use strict";
                var n = r(28847)(r(3355));
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.hashToPrivateScalar = t.FpSqrtEven = t.FpSqrtOdd = t.Field = t.nLength = t.FpIsSquare = t.FpDiv = t.FpInvertBatch = t.FpPow = t.validateField = t.isNegativeLE = t.FpSqrt = t.tonelliShanks = t.invert = t.pow2 = t.pow = t.mod = void 0;
                var i = r(46928), o = BigInt(0), a = BigInt(1), s = BigInt(2), u = BigInt(3), c = BigInt(4), f = BigInt(5), d = BigInt(8);
                function l(e, t) {
                    var r = e % t;
                    return r >= o ? r : t + r;
                }
                function h(e, t, r) {
                    if (r <= o || t < o) throw new Error("Expected power/modulo > 0");
                    if (r === a) return o;
                    for(var n = a; t > o;)t & a && (n = n * e % r), e = e * e % r, t >>= a;
                    return n;
                }
                function p(e, t) {
                    if (e === o || t <= o) throw new Error("invert: expected positive integers, got n=".concat(e, " mod=").concat(t));
                    for(var r = l(e, t), n = t, i = o, s = a, u = a, c = o; r !== o;){
                        var f = n / r, d = n % r, h = i - u * f, p = s - c * f;
                        n = r, r = d, i = u, s = c, u = h, c = p;
                    }
                    if (n !== a) throw new Error("invert: does not exist");
                    return l(i, t);
                }
                function b(e) {
                    var t, r, n, i = (e - a) / s;
                    for(t = e - a, r = 0; t % s === o; t /= s, r++);
                    for(n = s; n < e && h(n, i, e) !== e - a; n++);
                    if (1 === r) {
                        var u = (e + a) / c;
                        return function(e, t) {
                            var r = e.pow(t, u);
                            if (!e.eql(e.sqr(r), t)) throw new Error("Cannot find square root");
                            return r;
                        };
                    }
                    var f = (t + a) / s;
                    return function(e, o) {
                        if (e.pow(o, i) === e.neg(e.ONE)) throw new Error("Cannot find square root");
                        for(var s = r, u = e.pow(e.mul(e.ONE, n), t), c = e.pow(o, f), d = e.pow(o, t); !e.eql(d, e.ONE);){
                            if (e.eql(d, e.ZERO)) return e.ZERO;
                            for(var l = 1, h = e.sqr(d); l < s && !e.eql(h, e.ONE); l++)h = e.sqr(h);
                            var p = e.pow(u, a << BigInt(s - l - 1));
                            u = e.sqr(p), c = e.mul(c, p), d = e.mul(d, u), s = l;
                        }
                        return c;
                    };
                }
                function y(e) {
                    if (e % c === u) {
                        var t = (e + a) / c;
                        return function(e, r) {
                            var n = e.pow(r, t);
                            if (!e.eql(e.sqr(n), r)) throw new Error("Cannot find square root");
                            return n;
                        };
                    }
                    if (e % d === f) {
                        var r = (e - f) / d;
                        return function(e, t) {
                            var n = e.mul(t, s), i = e.pow(n, r), o = e.mul(t, i), a = e.mul(e.mul(o, s), i), u = e.mul(o, e.sub(a, e.ONE));
                            if (!e.eql(e.sqr(u), t)) throw new Error("Cannot find square root");
                            return u;
                        };
                    }
                    return b(e);
                }
                BigInt(9), BigInt(16), t.mod = l, t.pow = h, t.pow2 = function(e, t, r) {
                    for(var n = e; t-- > o;)n *= n, n %= r;
                    return n;
                }, t.invert = p, t.tonelliShanks = b, t.FpSqrt = y, t.isNegativeLE = function(e, t) {
                    return (l(e, t) & a) === a;
                };
                var v = [
                    "create",
                    "isValid",
                    "is0",
                    "neg",
                    "inv",
                    "sqrt",
                    "sqr",
                    "eql",
                    "add",
                    "sub",
                    "mul",
                    "pow",
                    "div",
                    "addN",
                    "subN",
                    "mulN",
                    "sqrN"
                ];
                function m(e, t, r) {
                    if (r < o) throw new Error("Expected power > 0");
                    if (r === o) return e.ONE;
                    if (r === a) return t;
                    for(var n = e.ONE, i = t; r > o;)r & a && (n = e.mul(n, i)), i = e.sqr(i), r >>= a;
                    return n;
                }
                function g(e, t) {
                    var r = new Array(t.length), n = t.reduce(function(t, n, i) {
                        return e.is0(n) ? t : (r[i] = t, e.mul(t, n));
                    }, e.ONE), i = e.inv(n);
                    return t.reduceRight(function(t, n, i) {
                        return e.is0(n) ? t : (r[i] = e.mul(t, r[i]), e.mul(t, n));
                    }, i), r;
                }
                function w(e, t) {
                    var r = void 0 !== t ? t : e.toString(2).length;
                    return {
                        nBitLength: r,
                        nByteLength: Math.ceil(r / 8)
                    };
                }
                t.validateField = function(e) {
                    var t = v.reduce(function(e, t) {
                        return e[t] = "function", e;
                    }, {
                        ORDER: "bigint",
                        MASK: "bigint",
                        BYTES: "isSafeInteger",
                        BITS: "isSafeInteger"
                    });
                    return (0, i.validateObject)(e, t);
                }, t.FpPow = m, t.FpInvertBatch = g, t.FpDiv = function(e, t, r) {
                    return e.mul(t, "bigint" == typeof r ? p(r, e.ORDER) : e.inv(r));
                }, t.FpIsSquare = function(e) {
                    var t = (e.ORDER - a) / s;
                    return function(r) {
                        var n = e.pow(r, t);
                        return e.eql(n, e.ZERO) || e.eql(n, e.ONE);
                    };
                }, t.nLength = w, t.Field = function(e, t) {
                    var r = arguments.length > 2 && void 0 !== arguments[2] && arguments[2], s = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : {};
                    if (e <= o) throw new Error("Expected Fp ORDER > 0, got ".concat(e));
                    var u = w(e, t), c = u.nBitLength, f = u.nByteLength;
                    if (f > 2048) throw new Error("Field lengths over 2048 bytes are not supported");
                    var d = y(e), h = Object.freeze({
                        ORDER: e,
                        BITS: c,
                        BYTES: f,
                        MASK: (0, i.bitMask)(c),
                        ZERO: o,
                        ONE: a,
                        create: function(t) {
                            return l(t, e);
                        },
                        isValid: function(t) {
                            if ("bigint" != typeof t) throw new Error("Invalid field element: expected bigint, got ".concat((0, n.default)(t)));
                            return o <= t && t < e;
                        },
                        is0: function(e) {
                            return e === o;
                        },
                        isOdd: function(e) {
                            return (e & a) === a;
                        },
                        neg: function(t) {
                            return l(-t, e);
                        },
                        eql: function(e, t) {
                            return e === t;
                        },
                        sqr: function(t) {
                            return l(t * t, e);
                        },
                        add: function(t, r) {
                            return l(t + r, e);
                        },
                        sub: function(t, r) {
                            return l(t - r, e);
                        },
                        mul: function(t, r) {
                            return l(t * r, e);
                        },
                        pow: function(e, t) {
                            return m(h, e, t);
                        },
                        div: function(t, r) {
                            return l(t * p(r, e), e);
                        },
                        sqrN: function(e) {
                            return e * e;
                        },
                        addN: function(e, t) {
                            return e + t;
                        },
                        subN: function(e, t) {
                            return e - t;
                        },
                        mulN: function(e, t) {
                            return e * t;
                        },
                        inv: function(t) {
                            return p(t, e);
                        },
                        sqrt: s.sqrt || function(e) {
                            return d(h, e);
                        },
                        invertBatch: function(e) {
                            return g(h, e);
                        },
                        cmov: function(e, t, r) {
                            return r ? t : e;
                        },
                        toBytes: function(e) {
                            return r ? (0, i.numberToBytesLE)(e, f) : (0, i.numberToBytesBE)(e, f);
                        },
                        fromBytes: function(e) {
                            if (e.length !== f) throw new Error("Fp.fromBytes: expected ".concat(f, ", got ").concat(e.length));
                            return r ? (0, i.bytesToNumberLE)(e) : (0, i.bytesToNumberBE)(e);
                        }
                    });
                    return Object.freeze(h);
                }, t.FpSqrtOdd = function(e, t) {
                    if (!e.isOdd) throw new Error("Field doesn't have isOdd");
                    var r = e.sqrt(t);
                    return e.isOdd(r) ? r : e.neg(r);
                }, t.FpSqrtEven = function(e, t) {
                    if (!e.isOdd) throw new Error("Field doesn't have isOdd");
                    var r = e.sqrt(t);
                    return e.isOdd(r) ? e.neg(r) : r;
                }, t.hashToPrivateScalar = function(e, t) {
                    var r = arguments.length > 2 && void 0 !== arguments[2] && arguments[2], n = (e = (0, i.ensureBytes)("privateHash", e)).length, o = w(t).nByteLength + 8;
                    if (o < 24 || n < o || n > 1024) throw new Error("hashToPrivateScalar: expected ".concat(o, "-1024 bytes of input, got ").concat(n));
                    return l(r ? (0, i.bytesToNumberLE)(e) : (0, i.bytesToNumberBE)(e), t - a) + a;
                };
            },
            46928: (e, t, r)=>{
                "use strict";
                var n = r(28847), i = n(r(74519)), o = n(r(3355));
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.validateObject = t.createHmacDrbg = t.bitMask = t.bitSet = t.bitGet = t.bitLen = t.utf8ToBytes = t.equalBytes = t.concatBytes = t.ensureBytes = t.numberToVarBytesBE = t.numberToBytesLE = t.numberToBytesBE = t.bytesToNumberLE = t.bytesToNumberBE = t.hexToBytes = t.hexToNumber = t.numberToHexUnpadded = t.bytesToHex = void 0;
                var a = BigInt(0), s = BigInt(1), u = BigInt(2), c = function(e) {
                    return e instanceof Uint8Array;
                }, f = Array.from({
                    length: 256
                }, function(e, t) {
                    return t.toString(16).padStart(2, "0");
                });
                function d(e) {
                    if (!c(e)) throw new Error("Uint8Array expected");
                    for(var t = "", r = 0; r < e.length; r++)t += f[e[r]];
                    return t;
                }
                function l(e) {
                    var t = e.toString(16);
                    return 1 & t.length ? "0".concat(t) : t;
                }
                function h(e) {
                    if ("string" != typeof e) throw new Error("hex string expected, got " + (0, o.default)(e));
                    return BigInt("" === e ? "0" : "0x".concat(e));
                }
                function p(e) {
                    if ("string" != typeof e) throw new Error("hex string expected, got " + (0, o.default)(e));
                    var t = e.length;
                    if (t % 2) throw new Error("padded hex string expected, got unpadded hex of length " + t);
                    for(var r = new Uint8Array(t / 2), n = 0; n < r.length; n++){
                        var i = 2 * n, a = e.slice(i, i + 2), s = Number.parseInt(a, 16);
                        if (Number.isNaN(s) || s < 0) throw new Error("Invalid byte sequence");
                        r[n] = s;
                    }
                    return r;
                }
                function b(e, t) {
                    return p(e.toString(16).padStart(2 * t, "0"));
                }
                function y() {
                    for(var e = arguments.length, t = new Array(e), r = 0; r < e; r++)t[r] = arguments[r];
                    var n = new Uint8Array(t.reduce(function(e, t) {
                        return e + t.length;
                    }, 0)), i = 0;
                    return t.forEach(function(e) {
                        if (!c(e)) throw new Error("Uint8Array expected");
                        n.set(e, i), i += e.length;
                    }), n;
                }
                t.bytesToHex = d, t.numberToHexUnpadded = l, t.hexToNumber = h, t.hexToBytes = p, t.bytesToNumberBE = function(e) {
                    return h(d(e));
                }, t.bytesToNumberLE = function(e) {
                    if (!c(e)) throw new Error("Uint8Array expected");
                    return h(d(Uint8Array.from(e).reverse()));
                }, t.numberToBytesBE = b, t.numberToBytesLE = function(e, t) {
                    return b(e, t).reverse();
                }, t.numberToVarBytesBE = function(e) {
                    return p(l(e));
                }, t.ensureBytes = function(e, t, r) {
                    var n;
                    if ("string" == typeof t) try {
                        n = p(t);
                    } catch (r) {
                        throw new Error("".concat(e, ' must be valid hex string, got "').concat(t, '". Cause: ').concat(r));
                    }
                    else {
                        if (!c(t)) throw new Error("".concat(e, " must be hex string or Uint8Array"));
                        n = Uint8Array.from(t);
                    }
                    var i = n.length;
                    if ("number" == typeof r && i !== r) throw new Error("".concat(e, " expected ").concat(r, " bytes, got ").concat(i));
                    return n;
                }, t.concatBytes = y, t.equalBytes = function(e, t) {
                    if (e.length !== t.length) return !1;
                    for(var r = 0; r < e.length; r++)if (e[r] !== t[r]) return !1;
                    return !0;
                }, t.utf8ToBytes = function(e) {
                    if ("string" != typeof e) throw new Error("utf8ToBytes expected string, got ".concat((0, o.default)(e)));
                    return new Uint8Array((new TextEncoder).encode(e));
                }, t.bitLen = function(e) {
                    var t;
                    for(t = 0; e > a; e >>= s, t += 1);
                    return t;
                }, t.bitGet = function(e, t) {
                    return e >> BigInt(t) & s;
                }, t.bitSet = function(e, t, r) {
                    return e | (r ? s : a) << BigInt(t);
                }, t.bitMask = function(e) {
                    return (u << BigInt(e - 1)) - s;
                };
                var v = function(e) {
                    return new Uint8Array(e);
                }, m = function(e) {
                    return Uint8Array.from(e);
                };
                t.createHmacDrbg = function(e, t, r) {
                    if ("number" != typeof e || e < 2) throw new Error("hashLen must be a number");
                    if ("number" != typeof t || t < 2) throw new Error("qByteLen must be a number");
                    if ("function" != typeof r) throw new Error("hmacFn must be a function");
                    var n = v(e), i = v(e), o = 0, a = function() {
                        n.fill(1), i.fill(0), o = 0;
                    }, s = function() {
                        for(var e = arguments.length, t = new Array(e), o = 0; o < e; o++)t[o] = arguments[o];
                        return r.apply(void 0, [
                            i,
                            n
                        ].concat(t));
                    }, u = function() {
                        var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : v();
                        i = s(m([
                            0
                        ]), e), n = s(), 0 !== e.length && (i = s(m([
                            1
                        ]), e), n = s());
                    }, c = function() {
                        if (o++ >= 1e3) throw new Error("drbg: tried 1000 values");
                        for(var e = 0, r = []; e < t;){
                            var i = (n = s()).slice();
                            r.push(i), e += n.length;
                        }
                        return y.apply(void 0, r);
                    };
                    return function(e, t) {
                        a(), u(e);
                        for(var r = void 0; !(r = t(c()));)u();
                        return a(), r;
                    };
                };
                var g = {
                    bigint: function(e) {
                        return "bigint" == typeof e;
                    },
                    function: function(e) {
                        return "function" == typeof e;
                    },
                    boolean: function(e) {
                        return "boolean" == typeof e;
                    },
                    string: function(e) {
                        return "string" == typeof e;
                    },
                    isSafeInteger: function(e) {
                        return Number.isSafeInteger(e);
                    },
                    array: function(e) {
                        return Array.isArray(e);
                    },
                    field: function(e, t) {
                        return t.Fp.isValid(e);
                    },
                    hash: function(e) {
                        return "function" == typeof e && Number.isSafeInteger(e.outputLen);
                    }
                };
                t.validateObject = function(e, t) {
                    for(var r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {}, n = function(t, r, n) {
                        var i = g[r];
                        if ("function" != typeof i) throw new Error('Invalid validator "'.concat(r, '", expected function'));
                        var a = e[t];
                        if (!(n && void 0 === a || i(a, e))) throw new Error("Invalid param ".concat(String(t), "=").concat(a, " (").concat((0, o.default)(a), "), expected ").concat(r));
                    }, a = 0, s = Object.entries(t); a < s.length; a++){
                        var u = (0, i.default)(s[a], 2);
                        n(u[0], u[1], !1);
                    }
                    for(var c = 0, f = Object.entries(r); c < f.length; c++){
                        var d = (0, i.default)(f[c], 2);
                        n(d[0], d[1], !0);
                    }
                    return e;
                };
            },
            16573: (e, t, r)=>{
                "use strict";
                var n = r(28847), i = n(r(58985)), o = n(r(69721)), a = n(r(15163)), s = n(r(34650)), u = n(r(21949)), c = n(r(22940)), f = n(r(90775)), d = n(r(3355));
                function l(e, t) {
                    var r = Object.keys(e);
                    if (Object.getOwnPropertySymbols) {
                        var n = Object.getOwnPropertySymbols(e);
                        t && (n = n.filter(function(t) {
                            return Object.getOwnPropertyDescriptor(e, t).enumerable;
                        })), r.push.apply(r, n);
                    }
                    return r;
                }
                function h(e) {
                    for(var t = 1; t < arguments.length; t++){
                        var r = null != arguments[t] ? arguments[t] : {};
                        t % 2 ? l(Object(r), !0).forEach(function(t) {
                            (0, f.default)(e, t, r[t]);
                        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : l(Object(r)).forEach(function(t) {
                            Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
                        });
                    }
                    return e;
                }
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.mapToCurveSimpleSWU = t.SWUFpSqrtRatio = t.weierstrass = t.weierstrassPoints = t.DER = void 0;
                var p = r(3970), b = r(46928), y = r(46928), v = r(91813), m = b.bytesToNumberBE, g = b.hexToBytes;
                t.DER = {
                    Err: function(e) {
                        (0, a.default)(c, e);
                        var t, r, n = (t = c, r = function() {
                            if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                            if (Reflect.construct.sham) return !1;
                            if ("function" == typeof Proxy) return !0;
                            try {
                                return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                            } catch (e) {
                                return !1;
                            }
                        }(), function() {
                            var e, n = (0, u.default)(t);
                            if (r) {
                                var i = (0, u.default)(this).constructor;
                                e = Reflect.construct(n, arguments, i);
                            } else e = n.apply(this, arguments);
                            return (0, s.default)(this, e);
                        });
                        function c() {
                            var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "";
                            return (0, o.default)(this, c), n.call(this, e);
                        }
                        return (0, i.default)(c);
                    }((0, c.default)(Error)),
                    _parseInt: function(e) {
                        var r = t.DER.Err;
                        if (e.length < 2 || 2 !== e[0]) throw new r("Invalid signature integer tag");
                        var n = e[1], i = e.subarray(2, n + 2);
                        if (!n || i.length !== n) throw new r("Invalid signature integer: wrong length");
                        if (128 & i[0]) throw new r("Invalid signature integer: negative");
                        if (0 === i[0] && !(128 & i[1])) throw new r("Invalid signature integer: unnecessary leading zero");
                        return {
                            d: m(i),
                            l: e.subarray(n + 2)
                        };
                    },
                    toSig: function(e) {
                        var r = t.DER.Err, n = "string" == typeof e ? g(e) : e;
                        if (!(n instanceof Uint8Array)) throw new Error("ui8a expected");
                        var i = n.length;
                        if (i < 2 || 48 != n[0]) throw new r("Invalid signature tag");
                        if (n[1] !== i - 2) throw new r("Invalid signature: incorrect length");
                        var o = t.DER._parseInt(n.subarray(2)), a = o.d, s = o.l, u = t.DER._parseInt(s), c = u.d;
                        if (u.l.length) throw new r("Invalid signature: left bytes after parsing");
                        return {
                            r: a,
                            s: c
                        };
                    },
                    hexFromSig: function(e) {
                        var t = function(e) {
                            return 8 & Number.parseInt(e[0], 16) ? "00" + e : e;
                        }, r = function(e) {
                            var t = e.toString(16);
                            return 1 & t.length ? "0".concat(t) : t;
                        }, n = t(r(e.s)), i = t(r(e.r)), o = n.length / 2, a = i.length / 2, s = r(o), u = r(a);
                        return "30".concat(r(a + o + 4), "02").concat(u).concat(i, "02").concat(s).concat(n);
                    }
                };
                var w = BigInt(0), k = BigInt(1), _ = BigInt(2), A = BigInt(3), E = BigInt(4);
                function S(e) {
                    var t = function(e) {
                        var t = (0, v.validateBasic)(e);
                        b.validateObject(t, {
                            a: "field",
                            b: "field"
                        }, {
                            allowedPrivateKeyLengths: "array",
                            wrapPrivateKey: "boolean",
                            isTorsionFree: "function",
                            clearCofactor: "function",
                            allowInfinityPoint: "boolean",
                            fromBytes: "function",
                            toBytes: "function"
                        });
                        var r = t.endo, n = t.Fp, i = t.a;
                        if (r) {
                            if (!n.eql(i, n.ZERO)) throw new Error("Endomorphism can only be defined for Koblitz curves that have a=0");
                            if ("object" !== (0, d.default)(r) || "bigint" != typeof r.beta || "function" != typeof r.splitScalar) throw new Error("Expected endomorphism with beta: bigint and splitScalar: function");
                        }
                        return Object.freeze(h({}, t));
                    }(e), r = t.Fp, n = t.toBytes || function(e, t, n) {
                        var i = t.toAffine();
                        return b.concatBytes(Uint8Array.from([
                            4
                        ]), r.toBytes(i.x), r.toBytes(i.y));
                    }, a = t.fromBytes || function(e) {
                        var t = e.subarray(1);
                        return {
                            x: r.fromBytes(t.subarray(0, r.BYTES)),
                            y: r.fromBytes(t.subarray(r.BYTES, 2 * r.BYTES))
                        };
                    };
                    function s(e) {
                        var n = t.a, i = t.b, o = r.sqr(e), a = r.mul(o, e);
                        return r.add(r.add(a, r.mul(e, n)), i);
                    }
                    if (!r.eql(r.sqr(t.Gy), s(t.Gx))) throw new Error("bad generator point: equation left != right");
                    function u(e) {
                        return "bigint" == typeof e && w < e && e < t.n;
                    }
                    function c(e) {
                        if (!u(e)) throw new Error("Expected valid bigint: 0 < bigint < curve.n");
                    }
                    function f(e) {
                        var r, n = t.allowedPrivateKeyLengths, i = t.nByteLength, o = t.wrapPrivateKey, a = t.n;
                        if (n && "bigint" != typeof e) {
                            if (e instanceof Uint8Array && (e = b.bytesToHex(e)), "string" != typeof e || !n.includes(e.length)) throw new Error("Invalid key");
                            e = e.padStart(2 * i, "0");
                        }
                        try {
                            r = "bigint" == typeof e ? e : b.bytesToNumberBE((0, y.ensureBytes)("private key", e, i));
                        } catch (t) {
                            throw new Error("private key must be ".concat(i, " bytes, hex or bigint, not ").concat((0, d.default)(e)));
                        }
                        return o && (r = p.mod(r, a)), c(r), r;
                    }
                    var l = new Map;
                    function m(e) {
                        if (!(e instanceof g)) throw new Error("ProjectivePoint expected");
                    }
                    var g = function() {
                        function e(t, n, i) {
                            if ((0, o.default)(this, e), this.px = t, this.py = n, this.pz = i, null == t || !r.isValid(t)) throw new Error("x required");
                            if (null == n || !r.isValid(n)) throw new Error("y required");
                            if (null == i || !r.isValid(i)) throw new Error("z required");
                        }
                        return (0, i.default)(e, [
                            {
                                key: "x",
                                get: function() {
                                    return this.toAffine().x;
                                }
                            },
                            {
                                key: "y",
                                get: function() {
                                    return this.toAffine().y;
                                }
                            },
                            {
                                key: "_setWindowSize",
                                value: function(e) {
                                    this._WINDOW_SIZE = e, l.delete(this);
                                }
                            },
                            {
                                key: "assertValidity",
                                value: function() {
                                    if (this.is0()) {
                                        if (t.allowInfinityPoint) return;
                                        throw new Error("bad point: ZERO");
                                    }
                                    var e = this.toAffine(), n = e.x, i = e.y;
                                    if (!r.isValid(n) || !r.isValid(i)) throw new Error("bad point: x or y not FE");
                                    var o = r.sqr(i), a = s(n);
                                    if (!r.eql(o, a)) throw new Error("bad point: equation left != right");
                                    if (!this.isTorsionFree()) throw new Error("bad point: not in prime-order subgroup");
                                }
                            },
                            {
                                key: "hasEvenY",
                                value: function() {
                                    var e = this.toAffine().y;
                                    if (r.isOdd) return !r.isOdd(e);
                                    throw new Error("Field doesn't support isOdd");
                                }
                            },
                            {
                                key: "equals",
                                value: function(e) {
                                    m(e);
                                    var t = this.px, n = this.py, i = this.pz, o = e.px, a = e.py, s = e.pz, u = r.eql(r.mul(t, s), r.mul(o, i)), c = r.eql(r.mul(n, s), r.mul(a, i));
                                    return u && c;
                                }
                            },
                            {
                                key: "negate",
                                value: function() {
                                    return new e(this.px, r.neg(this.py), this.pz);
                                }
                            },
                            {
                                key: "double",
                                value: function() {
                                    var n = t.a, i = t.b, o = r.mul(i, A), a = this.px, s = this.py, u = this.pz, c = r.ZERO, f = r.ZERO, d = r.ZERO, l = r.mul(a, a), h = r.mul(s, s), p = r.mul(u, u), b = r.mul(a, s);
                                    return b = r.add(b, b), d = r.mul(a, u), d = r.add(d, d), c = r.mul(n, d), f = r.mul(o, p), f = r.add(c, f), c = r.sub(h, f), f = r.add(h, f), f = r.mul(c, f), c = r.mul(b, c), d = r.mul(o, d), p = r.mul(n, p), b = r.sub(l, p), b = r.mul(n, b), b = r.add(b, d), d = r.add(l, l), l = r.add(d, l), l = r.add(l, p), l = r.mul(l, b), f = r.add(f, l), p = r.mul(s, u), p = r.add(p, p), l = r.mul(p, b), c = r.sub(c, l), d = r.mul(p, h), d = r.add(d, d), new e(c, f, d = r.add(d, d));
                                }
                            },
                            {
                                key: "add",
                                value: function(n) {
                                    m(n);
                                    var i = this.px, o = this.py, a = this.pz, s = n.px, u = n.py, c = n.pz, f = r.ZERO, d = r.ZERO, l = r.ZERO, h = t.a, p = r.mul(t.b, A), b = r.mul(i, s), y = r.mul(o, u), v = r.mul(a, c), g = r.add(i, o), w = r.add(s, u);
                                    g = r.mul(g, w), w = r.add(b, y), g = r.sub(g, w), w = r.add(i, a);
                                    var k = r.add(s, c);
                                    return w = r.mul(w, k), k = r.add(b, v), w = r.sub(w, k), k = r.add(o, a), f = r.add(u, c), k = r.mul(k, f), f = r.add(y, v), k = r.sub(k, f), l = r.mul(h, w), f = r.mul(p, v), l = r.add(f, l), f = r.sub(y, l), l = r.add(y, l), d = r.mul(f, l), y = r.add(b, b), y = r.add(y, b), v = r.mul(h, v), w = r.mul(p, w), y = r.add(y, v), v = r.sub(b, v), v = r.mul(h, v), w = r.add(w, v), b = r.mul(y, w), d = r.add(d, b), b = r.mul(k, w), f = r.mul(g, f), f = r.sub(f, b), b = r.mul(g, y), l = r.mul(k, l), new e(f, d, l = r.add(l, b));
                                }
                            },
                            {
                                key: "subtract",
                                value: function(e) {
                                    return this.add(e.negate());
                                }
                            },
                            {
                                key: "is0",
                                value: function() {
                                    return this.equals(e.ZERO);
                                }
                            },
                            {
                                key: "wNAF",
                                value: function(t) {
                                    return E.wNAFCached(this, l, t, function(t) {
                                        var n = r.invertBatch(t.map(function(e) {
                                            return e.pz;
                                        }));
                                        return t.map(function(e, t) {
                                            return e.toAffine(n[t]);
                                        }).map(e.fromAffine);
                                    });
                                }
                            },
                            {
                                key: "multiplyUnsafe",
                                value: function(n) {
                                    var i = e.ZERO;
                                    if (n === w) return i;
                                    if (c(n), n === k) return this;
                                    var o = t.endo;
                                    if (!o) return E.unsafeLadder(this, n);
                                    for(var a = o.splitScalar(n), s = a.k1neg, u = a.k1, f = a.k2neg, d = a.k2, l = i, h = i, p = this; u > w || d > w;)u & k && (l = l.add(p)), d & k && (h = h.add(p)), p = p.double(), u >>= k, d >>= k;
                                    return s && (l = l.negate()), f && (h = h.negate()), h = new e(r.mul(h.px, o.beta), h.py, h.pz), l.add(h);
                                }
                            },
                            {
                                key: "multiply",
                                value: function(n) {
                                    c(n);
                                    var i, o, a = n, s = t.endo;
                                    if (s) {
                                        var u = s.splitScalar(a), f = u.k1neg, d = u.k1, l = u.k2neg, h = u.k2, p = this.wNAF(d), b = p.p, y = p.f, v = this.wNAF(h), m = v.p, g = v.f;
                                        b = E.constTimeNegate(f, b), m = E.constTimeNegate(l, m), m = new e(r.mul(m.px, s.beta), m.py, m.pz), i = b.add(m), o = y.add(g);
                                    } else {
                                        var w = this.wNAF(a);
                                        i = w.p, o = w.f;
                                    }
                                    return e.normalizeZ([
                                        i,
                                        o
                                    ])[0];
                                }
                            },
                            {
                                key: "multiplyAndAddUnsafe",
                                value: function(t, r, n) {
                                    var i = e.BASE, o = function(e, t) {
                                        return t !== w && t !== k && e.equals(i) ? e.multiply(t) : e.multiplyUnsafe(t);
                                    }, a = o(this, r).add(o(t, n));
                                    return a.is0() ? void 0 : a;
                                }
                            },
                            {
                                key: "toAffine",
                                value: function(e) {
                                    var t = this.px, n = this.py, i = this.pz, o = this.is0();
                                    null == e && (e = o ? r.ONE : r.inv(i));
                                    var a = r.mul(t, e), s = r.mul(n, e), u = r.mul(i, e);
                                    if (o) return {
                                        x: r.ZERO,
                                        y: r.ZERO
                                    };
                                    if (!r.eql(u, r.ONE)) throw new Error("invZ was invalid");
                                    return {
                                        x: a,
                                        y: s
                                    };
                                }
                            },
                            {
                                key: "isTorsionFree",
                                value: function() {
                                    var r = t.h, n = t.isTorsionFree;
                                    if (r === k) return !0;
                                    if (n) return n(e, this);
                                    throw new Error("isTorsionFree() has not been declared for the elliptic curve");
                                }
                            },
                            {
                                key: "clearCofactor",
                                value: function() {
                                    var r = t.h, n = t.clearCofactor;
                                    return r === k ? this : n ? n(e, this) : this.multiplyUnsafe(t.h);
                                }
                            },
                            {
                                key: "toRawBytes",
                                value: function() {
                                    var t = !(arguments.length > 0 && void 0 !== arguments[0]) || arguments[0];
                                    return this.assertValidity(), n(e, this, t);
                                }
                            },
                            {
                                key: "toHex",
                                value: function() {
                                    var e = !(arguments.length > 0 && void 0 !== arguments[0]) || arguments[0];
                                    return b.bytesToHex(this.toRawBytes(e));
                                }
                            }
                        ], [
                            {
                                key: "fromAffine",
                                value: function(t) {
                                    var n = t || {}, i = n.x, o = n.y;
                                    if (!t || !r.isValid(i) || !r.isValid(o)) throw new Error("invalid affine point");
                                    if (t instanceof e) throw new Error("projective point not allowed");
                                    var a = function(e) {
                                        return r.eql(e, r.ZERO);
                                    };
                                    return a(i) && a(o) ? e.ZERO : new e(i, o, r.ONE);
                                }
                            },
                            {
                                key: "normalizeZ",
                                value: function(t) {
                                    var n = r.invertBatch(t.map(function(e) {
                                        return e.pz;
                                    }));
                                    return t.map(function(e, t) {
                                        return e.toAffine(n[t]);
                                    }).map(e.fromAffine);
                                }
                            },
                            {
                                key: "fromHex",
                                value: function(t) {
                                    var r = e.fromAffine(a((0, y.ensureBytes)("pointHex", t)));
                                    return r.assertValidity(), r;
                                }
                            },
                            {
                                key: "fromPrivateKey",
                                value: function(t) {
                                    return e.BASE.multiply(f(t));
                                }
                            }
                        ]), e;
                    }();
                    g.BASE = new g(t.Gx, t.Gy, r.ONE), g.ZERO = new g(r.ZERO, r.ONE, r.ZERO);
                    var _ = t.nBitLength, E = (0, v.wNAF)(g, t.endo ? Math.ceil(_ / 2) : _);
                    return {
                        CURVE: t,
                        ProjectivePoint: g,
                        normPrivateKeyToScalar: f,
                        weierstrassEquation: s,
                        isWithinCurveOrder: u
                    };
                }
                function x(e, t) {
                    for(var r = e.ORDER, n = w, i = r - k; i % _ === w; i /= _)n += k;
                    var o = n, a = _ << o - k - k, s = a * _, u = (r - k) / s, c = (u - k) / _, f = s - k, d = a, l = e.pow(t, u), h = e.pow(t, (u + k) / _), p = function(t, r) {
                        var n = l, i = e.pow(r, f), a = e.sqr(i);
                        a = e.mul(a, r);
                        var s = e.mul(t, a);
                        s = e.pow(s, c), s = e.mul(s, i), i = e.mul(s, r), a = e.mul(s, t);
                        var u = e.mul(a, i);
                        s = e.pow(u, d);
                        var p = e.eql(s, e.ONE);
                        i = e.mul(a, h), s = e.mul(u, n), a = e.cmov(i, a, p), u = e.cmov(s, u, p);
                        for(var b = o; b > k; b--){
                            var y = b - _;
                            y = _ << y - k;
                            var v = e.pow(u, y), m = e.eql(v, e.ONE);
                            i = e.mul(a, n), n = e.mul(n, n), v = e.mul(u, n), a = e.cmov(i, a, m), u = e.cmov(v, u, m);
                        }
                        return {
                            isValid: p,
                            value: a
                        };
                    };
                    if (e.ORDER % E === A) {
                        var b = (e.ORDER - A) / E, y = e.sqrt(e.neg(t));
                        p = function(t, r) {
                            var n = e.sqr(r), i = e.mul(t, r);
                            n = e.mul(n, i);
                            var o = e.pow(n, b);
                            o = e.mul(o, i);
                            var a = e.mul(o, y), s = e.mul(e.sqr(o), r), u = e.eql(s, t);
                            return {
                                isValid: u,
                                value: e.cmov(a, o, u)
                            };
                        };
                    }
                    return p;
                }
                t.weierstrassPoints = S, t.weierstrass = function(e) {
                    var r, n, a = (r = e, n = (0, v.validateBasic)(r), b.validateObject(n, {
                        hash: "hash",
                        hmac: "function",
                        randomBytes: "function"
                    }, {
                        bits2int: "function",
                        bits2int_modN: "function",
                        lowS: "boolean"
                    }), Object.freeze(h({
                        lowS: !0
                    }, n))), s = a.Fp, u = a.n, c = s.BYTES + 1, f = 2 * s.BYTES + 1;
                    function l(e) {
                        return p.mod(e, u);
                    }
                    function m(e) {
                        return p.invert(e, u);
                    }
                    var g = S(h(h({}, a), {}, {
                        toBytes: function(e, t, r) {
                            var n = t.toAffine(), i = s.toBytes(n.x), o = b.concatBytes;
                            return r ? o(Uint8Array.from([
                                t.hasEvenY() ? 2 : 3
                            ]), i) : o(Uint8Array.from([
                                4
                            ]), i, s.toBytes(n.y));
                        },
                        fromBytes: function(e) {
                            var t = e.length, r = e[0], n = e.subarray(1);
                            if (t !== c || 2 !== r && 3 !== r) {
                                if (t === f && 4 === r) return {
                                    x: s.fromBytes(n.subarray(0, s.BYTES)),
                                    y: s.fromBytes(n.subarray(s.BYTES, 2 * s.BYTES))
                                };
                                throw new Error("Point of length ".concat(t, " was invalid. Expected ").concat(c, " compressed bytes or ").concat(f, " uncompressed bytes"));
                            }
                            var i = b.bytesToNumberBE(n);
                            if (!(w < (o = i) && o < s.ORDER)) throw new Error("Point is not on curve");
                            var o, a = E(i), u = s.sqrt(a);
                            return 1 == (1 & r) != ((u & k) === k) && (u = s.neg(u)), {
                                x: i,
                                y: u
                            };
                        }
                    })), _ = g.ProjectivePoint, A = g.normPrivateKeyToScalar, E = g.weierstrassEquation, x = g.isWithinCurveOrder, B = function(e) {
                        return b.bytesToHex(b.numberToBytesBE(e, a.nByteLength));
                    };
                    function O(e) {
                        return e > u >> k;
                    }
                    var P = function(e, t, r) {
                        return b.bytesToNumberBE(e.slice(t, r));
                    }, I = function() {
                        function e(t, r, n) {
                            (0, o.default)(this, e), this.r = t, this.s = r, this.recovery = n, this.assertValidity();
                        }
                        return (0, i.default)(e, [
                            {
                                key: "assertValidity",
                                value: function() {
                                    if (!x(this.r)) throw new Error("r must be 0 < r < CURVE.n");
                                    if (!x(this.s)) throw new Error("s must be 0 < s < CURVE.n");
                                }
                            },
                            {
                                key: "addRecoveryBit",
                                value: function(t) {
                                    return new e(this.r, this.s, t);
                                }
                            },
                            {
                                key: "recoverPublicKey",
                                value: function(e) {
                                    var t = this.r, r = this.s, n = this.recovery, i = R((0, y.ensureBytes)("msgHash", e));
                                    if (null == n || ![
                                        0,
                                        1,
                                        2,
                                        3
                                    ].includes(n)) throw new Error("recovery id invalid");
                                    var o = 2 === n || 3 === n ? t + a.n : t;
                                    if (o >= s.ORDER) throw new Error("recovery id 2 or 3 invalid");
                                    var u = 0 == (1 & n) ? "02" : "03", c = _.fromHex(u + B(o)), f = m(o), d = l(-i * f), h = l(r * f), p = _.BASE.multiplyAndAddUnsafe(c, d, h);
                                    if (!p) throw new Error("point at infinify");
                                    return p.assertValidity(), p;
                                }
                            },
                            {
                                key: "hasHighS",
                                value: function() {
                                    return O(this.s);
                                }
                            },
                            {
                                key: "normalizeS",
                                value: function() {
                                    return this.hasHighS() ? new e(this.r, l(-this.s), this.recovery) : this;
                                }
                            },
                            {
                                key: "toDERRawBytes",
                                value: function() {
                                    return b.hexToBytes(this.toDERHex());
                                }
                            },
                            {
                                key: "toDERHex",
                                value: function() {
                                    return t.DER.hexFromSig({
                                        r: this.r,
                                        s: this.s
                                    });
                                }
                            },
                            {
                                key: "toCompactRawBytes",
                                value: function() {
                                    return b.hexToBytes(this.toCompactHex());
                                }
                            },
                            {
                                key: "toCompactHex",
                                value: function() {
                                    return B(this.r) + B(this.s);
                                }
                            }
                        ], [
                            {
                                key: "fromCompact",
                                value: function(t) {
                                    var r = a.nByteLength;
                                    return t = (0, y.ensureBytes)("compactSignature", t, 2 * r), new e(P(t, 0, r), P(t, r, 2 * r));
                                }
                            },
                            {
                                key: "fromDER",
                                value: function(r) {
                                    var n = t.DER.toSig((0, y.ensureBytes)("DER", r));
                                    return new e(n.r, n.s);
                                }
                            }
                        ]), e;
                    }(), T = {
                        isValidPrivateKey: function(e) {
                            try {
                                return A(e), !0;
                            } catch (e) {
                                return !1;
                            }
                        },
                        normPrivateKeyToScalar: A,
                        randomPrivateKey: function() {
                            var e = a.randomBytes(s.BYTES + 8), t = p.hashToPrivateScalar(e, u);
                            return b.numberToBytesBE(t, a.nByteLength);
                        },
                        precompute: function() {
                            var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 8, t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : _.BASE;
                            return t._setWindowSize(e), t.multiply(BigInt(3)), t;
                        }
                    };
                    function C(e) {
                        var t = e instanceof Uint8Array, r = "string" == typeof e, n = (t || r) && e.length;
                        return t ? n === c || n === f : r ? n === 2 * c || n === 2 * f : e instanceof _;
                    }
                    var M = a.bits2int || function(e) {
                        var t = b.bytesToNumberBE(e), r = 8 * e.length - a.nBitLength;
                        return r > 0 ? t >> BigInt(r) : t;
                    }, R = a.bits2int_modN || function(e) {
                        return l(M(e));
                    }, U = b.bitMask(a.nBitLength);
                    function N(e) {
                        if ("bigint" != typeof e) throw new Error("bigint expected");
                        if (!(w <= e && e < U)) throw new Error("bigint expected < 2^".concat(a.nBitLength));
                        return b.numberToBytesBE(e, a.nByteLength);
                    }
                    var j = {
                        lowS: a.lowS,
                        prehash: !1
                    }, L = {
                        lowS: a.lowS,
                        prehash: !1
                    };
                    return _.BASE._setWindowSize(8), {
                        CURVE: a,
                        getPublicKey: function(e) {
                            var t = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1];
                            return _.fromPrivateKey(e).toRawBytes(t);
                        },
                        getSharedSecret: function(e, t) {
                            var r = !(arguments.length > 2 && void 0 !== arguments[2]) || arguments[2];
                            if (C(e)) throw new Error("first arg must be private key");
                            if (!C(t)) throw new Error("second arg must be public key");
                            return _.fromHex(t).multiply(A(e)).toRawBytes(r);
                        },
                        sign: function(e, t) {
                            var r = function(e, t) {
                                var r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : j;
                                if ([
                                    "recovered",
                                    "canonical"
                                ].some(function(e) {
                                    return e in r;
                                })) throw new Error("sign() legacy options not supported");
                                var n = a.hash, i = a.randomBytes, o = r.lowS, u = r.prehash, c = r.extraEntropy;
                                null == o && (o = !0), e = (0, y.ensureBytes)("msgHash", e), u && (e = (0, y.ensureBytes)("prehashed msgHash", n(e)));
                                var f = R(e), d = A(t), h = [
                                    N(d),
                                    N(f)
                                ];
                                if (null != c) {
                                    var p = !0 === c ? i(s.BYTES) : c;
                                    h.push((0, y.ensureBytes)("extraEntropy", p, s.BYTES));
                                }
                                var v = b.concatBytes.apply(b, h), g = f;
                                return {
                                    seed: v,
                                    k2sig: function(e) {
                                        var t = M(e);
                                        if (x(t)) {
                                            var r = m(t), n = _.BASE.multiply(t).toAffine(), i = l(n.x);
                                            if (i !== w) {
                                                var a = l(r * l(g + i * d));
                                                if (a !== w) {
                                                    var s = (n.x === i ? 0 : 2) | Number(n.y & k), u = a;
                                                    return o && O(a) && (u = function(e) {
                                                        return O(e) ? l(-e) : e;
                                                    }(a), s ^= 1), new I(i, u, s);
                                                }
                                            }
                                        }
                                    }
                                };
                            }(e, t, arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : j), n = r.seed, i = r.k2sig, o = a;
                            return b.createHmacDrbg(o.hash.outputLen, o.nByteLength, o.hmac)(n, i);
                        },
                        verify: function(e, r, n) {
                            var i, o = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : L, s = e;
                            if (r = (0, y.ensureBytes)("msgHash", r), n = (0, y.ensureBytes)("publicKey", n), "strict" in o) throw new Error("options.strict was renamed to lowS");
                            var u, c = o.lowS, f = o.prehash, h = void 0;
                            try {
                                if ("string" == typeof s || s instanceof Uint8Array) try {
                                    h = I.fromDER(s);
                                } catch (e) {
                                    if (!(e instanceof t.DER.Err)) throw e;
                                    h = I.fromCompact(s);
                                }
                                else {
                                    if ("object" !== (0, d.default)(s) || "bigint" != typeof s.r || "bigint" != typeof s.s) throw new Error("PARSE");
                                    var p = s.r, b = s.s;
                                    h = new I(p, b);
                                }
                                u = _.fromHex(n);
                            } catch (e) {
                                if ("PARSE" === e.message) throw new Error("signature must be Signature instance, Uint8Array or hex string");
                                return !1;
                            }
                            if (c && h.hasHighS()) return !1;
                            f && (r = a.hash(r));
                            var v = h, g = v.r, w = v.s, k = R(r), A = m(w), E = l(k * A), S = l(g * A), x = null === (i = _.BASE.multiplyAndAddUnsafe(u, E, S)) || void 0 === i ? void 0 : i.toAffine();
                            return !!x && l(x.x) === g;
                        },
                        ProjectivePoint: _,
                        Signature: I,
                        utils: T
                    };
                }, t.SWUFpSqrtRatio = x, t.mapToCurveSimpleSWU = function(e, t) {
                    if (p.validateField(e), !e.isValid(t.A) || !e.isValid(t.B) || !e.isValid(t.Z)) throw new Error("mapToCurveSimpleSWU: invalid opts");
                    var r = x(e, t.Z);
                    if (!e.isOdd) throw new Error("Fp.isOdd is not implemented!");
                    return function(n) {
                        var i, o, a, s, u, c, f, d;
                        i = e.sqr(n), i = e.mul(i, t.Z), o = e.sqr(i), o = e.add(o, i), a = e.add(o, e.ONE), a = e.mul(a, t.B), s = e.cmov(t.Z, e.neg(o), !e.eql(o, e.ZERO)), s = e.mul(s, t.A), o = e.sqr(a), c = e.sqr(s), u = e.mul(c, t.A), o = e.add(o, u), o = e.mul(o, a), c = e.mul(c, s), u = e.mul(c, t.B), o = e.add(o, u), f = e.mul(i, a);
                        var l = r(o, c), h = l.isValid, p = l.value;
                        d = e.mul(i, n), d = e.mul(d, p), f = e.cmov(f, a, h), d = e.cmov(d, p, h);
                        var b = e.isOdd(n) === e.isOdd(d);
                        return d = e.cmov(e.neg(d), d, b), {
                            x: f = e.div(f, s),
                            y: d
                        };
                    };
                };
            },
            4158: (e, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.encodeToCurve = t.hashToCurve = t.schnorr = t.secp256k1 = void 0;
                var n = r(61241), i = r(72434), o = r(3970), a = r(16573), s = r(46928), u = r(19751), c = r(96546), f = BigInt("0xfffffffffffffffffffffffffffffffffffffffffffffffffffffffefffffc2f"), d = BigInt("0xfffffffffffffffffffffffffffffffebaaedce6af48a03bbfd25e8cd0364141"), l = BigInt(1), h = BigInt(2), p = function(e, t) {
                    return (e + t / h) / t;
                };
                function b(e) {
                    var t = f, r = BigInt(3), n = BigInt(6), i = BigInt(11), a = BigInt(22), s = BigInt(23), u = BigInt(44), c = BigInt(88), d = e * e * e % t, l = d * d * e % t, p = (0, o.pow2)(l, r, t) * l % t, b = (0, o.pow2)(p, r, t) * l % t, v = (0, o.pow2)(b, h, t) * d % t, m = (0, o.pow2)(v, i, t) * v % t, g = (0, o.pow2)(m, a, t) * m % t, w = (0, o.pow2)(g, u, t) * g % t, k = (0, o.pow2)(w, c, t) * w % t, _ = (0, o.pow2)(k, u, t) * g % t, A = (0, o.pow2)(_, r, t) * l % t, E = (0, o.pow2)(A, s, t) * m % t, S = (0, o.pow2)(E, n, t) * d % t, x = (0, o.pow2)(S, h, t);
                    if (!y.eql(y.sqr(x), e)) throw new Error("Cannot find square root");
                    return x;
                }
                var y = (0, o.Field)(f, void 0, void 0, {
                    sqrt: b
                });
                t.secp256k1 = (0, c.createCurve)({
                    a: BigInt(0),
                    b: BigInt(7),
                    Fp: y,
                    n: d,
                    Gx: BigInt("55066263022277343669578718895168534326250603453777594175500187360389116729240"),
                    Gy: BigInt("32670510020758816978083085130507043184471273380659243275938904335757337482424"),
                    h: BigInt(1),
                    lowS: !0,
                    endo: {
                        beta: BigInt("0x7ae96a2b657c07106e64479eac3434e99cf0497512f58995c1396c28719501ee"),
                        splitScalar: function(e) {
                            var t = d, r = BigInt("0x3086d221a7d46bcde86c90e49284eb15"), n = -l * BigInt("0xe4437ed6010e88286f547fa90abfe4c3"), i = BigInt("0x114ca50f7a8e2f3f657c1108d9d44cfd8"), a = r, s = BigInt("0x100000000000000000000000000000000"), u = p(a * e, t), c = p(-n * e, t), f = (0, o.mod)(e - u * r - c * i, t), h = (0, o.mod)(-u * n - c * a, t), b = f > s, y = h > s;
                            if (b && (f = t - f), y && (h = t - h), f > s || h > s) throw new Error("splitScalar: Endomorphism failed, k=" + e);
                            return {
                                k1neg: b,
                                k1: f,
                                k2neg: y,
                                k2: h
                            };
                        }
                    }
                }, n.sha256);
                var v = BigInt(0), m = function(e) {
                    return "bigint" == typeof e && v < e && e < f;
                }, g = function(e) {
                    return "bigint" == typeof e && v < e && e < d;
                }, w = {};
                function k(e) {
                    var t = w[e];
                    if (void 0 === t) {
                        var r = (0, n.sha256)(Uint8Array.from(e, function(e) {
                            return e.charCodeAt(0);
                        }));
                        t = (0, s.concatBytes)(r, r), w[e] = t;
                    }
                    for(var i = arguments.length, o = new Array(i > 1 ? i - 1 : 0), a = 1; a < i; a++)o[a - 1] = arguments[a];
                    return (0, n.sha256)(s.concatBytes.apply(void 0, [
                        t
                    ].concat(o)));
                }
                var _ = function(e) {
                    return e.toRawBytes(!0).slice(1);
                }, A = function(e) {
                    return (0, s.numberToBytesBE)(e, 32);
                }, E = function(e) {
                    return (0, o.mod)(e, f);
                }, S = function(e) {
                    return (0, o.mod)(e, d);
                }, x = t.secp256k1.ProjectivePoint, B = function(e, t, r) {
                    return x.BASE.multiplyAndAddUnsafe(e, t, r);
                };
                function O(e) {
                    var r = t.secp256k1.utils.normPrivateKeyToScalar(e), n = x.fromPrivateKey(r);
                    return {
                        scalar: n.hasEvenY() ? r : S(-r),
                        bytes: _(n)
                    };
                }
                function P(e) {
                    if (!m(e)) throw new Error("bad x: need 0 < x < p");
                    var t = E(e * e), r = b(E(t * e + BigInt(7)));
                    r % h !== v && (r = E(-r));
                    var n = new x(e, r, l);
                    return n.assertValidity(), n;
                }
                function I() {
                    for(var e = arguments.length, t = new Array(e), r = 0; r < e; r++)t[r] = arguments[r];
                    return S((0, s.bytesToNumberBE)(k.apply(void 0, [
                        "BIP0340/challenge"
                    ].concat(t))));
                }
                function T(e, t, r) {
                    var n = (0, s.ensureBytes)("signature", e, 64), i = (0, s.ensureBytes)("message", t), o = (0, s.ensureBytes)("publicKey", r, 32);
                    try {
                        var a = P((0, s.bytesToNumberBE)(o)), u = (0, s.bytesToNumberBE)(n.subarray(0, 32));
                        if (!m(u)) return !1;
                        var c = (0, s.bytesToNumberBE)(n.subarray(32, 64));
                        if (!g(c)) return !1;
                        var f = I(A(u), _(a), i), d = B(a, c, S(-f));
                        return !(!d || !d.hasEvenY() || d.toAffine().x !== u);
                    } catch (e) {
                        return !1;
                    }
                }
                t.schnorr = {
                    getPublicKey: function(e) {
                        return O(e).bytes;
                    },
                    sign: function(e, t) {
                        var r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : (0, i.randomBytes)(32), n = (0, s.ensureBytes)("message", e), o = O(t), a = o.bytes, u = o.scalar, c = (0, s.ensureBytes)("auxRand", r, 32), f = A(u ^ (0, s.bytesToNumberBE)(k("BIP0340/aux", c))), d = k("BIP0340/nonce", f, a, n), l = S((0, s.bytesToNumberBE)(d));
                        if (l === v) throw new Error("sign failed: k is zero");
                        var h = O(l), p = h.bytes, b = h.scalar, y = I(p, a, n), m = new Uint8Array(64);
                        if (m.set(p, 0), m.set(A(S(b + y * u)), 32), !T(m, n, a)) throw new Error("sign: Invalid signature produced");
                        return m;
                    },
                    verify: T,
                    utils: {
                        randomPrivateKey: t.secp256k1.utils.randomPrivateKey,
                        lift_x: P,
                        pointToBytes: _,
                        numberToBytesBE: s.numberToBytesBE,
                        bytesToNumberBE: s.bytesToNumberBE,
                        taggedHash: k,
                        mod: o.mod
                    }
                };
                var C = function() {
                    return (0, u.isogenyMap)(y, [
                        [
                            "0x8e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38daaaaa8c7",
                            "0x7d3d4c80bc321d5b9f315cea7fd44c5d595d2fc0bf63b92dfff1044f17c6581",
                            "0x534c328d23f234e6e2a413deca25caece4506144037c40314ecbd0b53d9dd262",
                            "0x8e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38daaaaa88c"
                        ],
                        [
                            "0xd35771193d94918a9ca34ccbb7b640dd86cd409542f8487d9fe6b745781eb49b",
                            "0xedadc6f64383dc1df7c4b2d51b54225406d36b641f5e41bbc52a56612a8c6d14",
                            "0x0000000000000000000000000000000000000000000000000000000000000001"
                        ],
                        [
                            "0x4bda12f684bda12f684bda12f684bda12f684bda12f684bda12f684b8e38e23c",
                            "0xc75e0c32d5cb7c0fa9d0a54b12a0a6d5647ab046d686da6fdffc90fc201d71a3",
                            "0x29a6194691f91a73715209ef6512e576722830a201be2018a765e85a9ecee931",
                            "0x2f684bda12f684bda12f684bda12f684bda12f684bda12f684bda12f38e38d84"
                        ],
                        [
                            "0xfffffffffffffffffffffffffffffffffffffffffffffffffffffffefffff93b",
                            "0x7a06534bb8bdb49fd5e9e6632722c2989467c1bfc8e8d978dfb425d2685c2573",
                            "0x6484aa716545ca2cf3a70c3fa8fe337e0a3d21162f0d6299a7bf8192bfd2a76f",
                            "0x0000000000000000000000000000000000000000000000000000000000000001"
                        ]
                    ].map(function(e) {
                        return e.map(function(e) {
                            return BigInt(e);
                        });
                    }));
                }(), M = function() {
                    return (0, a.mapToCurveSimpleSWU)(y, {
                        A: BigInt("0x3f8731abdd661adca08a5558f0f5d272e953d363cb6f0e5d405447c01a444533"),
                        B: BigInt("1771"),
                        Z: y.create(BigInt("-11"))
                    });
                }(), R = function() {
                    return (0, u.createHasher)(t.secp256k1.ProjectivePoint, function(e) {
                        var t = M(y.create(e[0])), r = t.x, n = t.y;
                        return C(r, n);
                    }, {
                        DST: "secp256k1_XMD:SHA-256_SSWU_RO_",
                        encodeDST: "secp256k1_XMD:SHA-256_SSWU_NU_",
                        p: y.ORDER,
                        m: 1,
                        k: 128,
                        expand: "xmd",
                        hash: n.sha256
                    });
                }();
                t.hashToCurve = R.hashToCurve, t.encodeToCurve = R.encodeToCurve;
            },
            96822: (e, t)=>{
                "use strict";
                function r(e) {
                    if (!Number.isSafeInteger(e) || e < 0) throw new Error("Wrong positive integer: ".concat(e));
                }
                function n(e) {
                    if ("boolean" != typeof e) throw new Error("Expected boolean, not ".concat(e));
                }
                function i(e) {
                    if (!(e instanceof Uint8Array)) throw new Error("Expected Uint8Array");
                    for(var t = arguments.length, r = new Array(t > 1 ? t - 1 : 0), n = 1; n < t; n++)r[n - 1] = arguments[n];
                    if (r.length > 0 && !r.includes(e.length)) throw new Error("Expected Uint8Array of length ".concat(r, ", not of length=").concat(e.length));
                }
                function o(e) {
                    if ("function" != typeof e || "function" != typeof e.create) throw new Error("Hash should be wrapped by utils.wrapConstructor");
                    r(e.outputLen), r(e.blockLen);
                }
                function a(e) {
                    var t = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1];
                    if (e.destroyed) throw new Error("Hash instance has been destroyed");
                    if (t && e.finished) throw new Error("Hash#digest() has already been called");
                }
                function s(e, t) {
                    i(e);
                    var r = t.outputLen;
                    if (e.length < r) throw new Error("digestInto() expects output buffer of length at least ".concat(r));
                }
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.output = t.exists = t.hash = t.bytes = t.bool = t.number = void 0, t.number = r, t.bool = n, t.bytes = i, t.hash = o, t.exists = a, t.output = s;
                var u = {
                    number: r,
                    bool: n,
                    bytes: i,
                    hash: o,
                    exists: a,
                    output: s
                };
                t.default = u;
            },
            20330: (e, t, r)=>{
                "use strict";
                var n = r(28847), i = n(r(93106)), o = n(r(69721)), a = n(r(58985)), s = n(r(15163)), u = n(r(34650)), c = n(r(21949));
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.SHA2 = void 0;
                var f = r(96822), d = r(72434), l = function(e) {
                    (0, s.default)(l, e);
                    var t, r, n = (t = l, r = function() {
                        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                        if (Reflect.construct.sham) return !1;
                        if ("function" == typeof Proxy) return !0;
                        try {
                            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                        } catch (e) {
                            return !1;
                        }
                    }(), function() {
                        var e, n = (0, c.default)(t);
                        if (r) {
                            var i = (0, c.default)(this).constructor;
                            e = Reflect.construct(n, arguments, i);
                        } else e = n.apply(this, arguments);
                        return (0, u.default)(this, e);
                    });
                    function l(e, t, r, i) {
                        var a;
                        return (0, o.default)(this, l), (a = n.call(this)).blockLen = e, a.outputLen = t, a.padOffset = r, a.isLE = i, a.finished = !1, a.length = 0, a.pos = 0, a.destroyed = !1, a.buffer = new Uint8Array(e), a.view = (0, d.createView)(a.buffer), a;
                    }
                    return (0, a.default)(l, [
                        {
                            key: "update",
                            value: function(e) {
                                f.default.exists(this);
                                for(var t = this.view, r = this.buffer, n = this.blockLen, i = (e = (0, d.toBytes)(e)).length, o = 0; o < i;){
                                    var a = Math.min(n - this.pos, i - o);
                                    if (a !== n) r.set(e.subarray(o, o + a), this.pos), this.pos += a, o += a, this.pos === n && (this.process(t, 0), this.pos = 0);
                                    else for(var s = (0, d.createView)(e); n <= i - o; o += n)this.process(s, o);
                                }
                                return this.length += e.length, this.roundClean(), this;
                            }
                        },
                        {
                            key: "digestInto",
                            value: function(e) {
                                f.default.exists(this), f.default.output(e, this), this.finished = !0;
                                var t = this.buffer, r = this.view, n = this.blockLen, i = this.isLE, o = this.pos;
                                t[o++] = 128, this.buffer.subarray(o).fill(0), this.padOffset > n - o && (this.process(r, 0), o = 0);
                                for(var a = o; a < n; a++)t[a] = 0;
                                !function(e, t, r, n) {
                                    if ("function" == typeof e.setBigUint64) return e.setBigUint64(t, r, n);
                                    var i = BigInt(32), o = BigInt(4294967295), a = Number(r >> i & o), s = Number(r & o), u = n ? 4 : 0, c = n ? 0 : 4;
                                    e.setUint32(t + u, a, n), e.setUint32(t + c, s, n);
                                }(r, n - 8, BigInt(8 * this.length), i), this.process(r, 0);
                                var s = (0, d.createView)(e), u = this.outputLen;
                                if (u % 4) throw new Error("_sha2: outputLen should be aligned to 32bit");
                                var c = u / 4, l = this.get();
                                if (c > l.length) throw new Error("_sha2: outputLen bigger than state");
                                for(var h = 0; h < c; h++)s.setUint32(4 * h, l[h], i);
                            }
                        },
                        {
                            key: "digest",
                            value: function() {
                                var e = this.buffer, t = this.outputLen;
                                this.digestInto(e);
                                var r = e.slice(0, t);
                                return this.destroy(), r;
                            }
                        },
                        {
                            key: "_cloneInto",
                            value: function(e) {
                                var t;
                                e || (e = new this.constructor), (t = e).set.apply(t, (0, i.default)(this.get()));
                                var r = this.blockLen, n = this.buffer, o = this.length, a = this.finished, s = this.destroyed, u = this.pos;
                                return e.length = o, e.pos = u, e.finished = a, e.destroyed = s, o % r && e.buffer.set(n), e;
                            }
                        }
                    ]), l;
                }(d.Hash);
                t.SHA2 = l;
            },
            64356: (e, t)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.add = t.toBig = t.split = t.fromBig = void 0;
                var r = BigInt(Math.pow(2, 32) - 1), n = BigInt(32);
                function i(e) {
                    return arguments.length > 1 && void 0 !== arguments[1] && arguments[1] ? {
                        h: Number(e & r),
                        l: Number(e >> n & r)
                    } : {
                        h: 0 | Number(e >> n & r),
                        l: 0 | Number(e & r)
                    };
                }
                function o(e) {
                    for(var t = arguments.length > 1 && void 0 !== arguments[1] && arguments[1], r = new Uint32Array(e.length), n = new Uint32Array(e.length), o = 0; o < e.length; o++){
                        var a = i(e[o], t), s = [
                            a.h,
                            a.l
                        ];
                        r[o] = s[0], n[o] = s[1];
                    }
                    return [
                        r,
                        n
                    ];
                }
                function a(e, t, r, n) {
                    var i = (t >>> 0) + (n >>> 0);
                    return {
                        h: e + r + (i / Math.pow(2, 32) | 0) | 0,
                        l: 0 | i
                    };
                }
                t.fromBig = i, t.split = o, t.toBig = function(e, t) {
                    return BigInt(e >>> 0) << n | BigInt(t >>> 0);
                }, t.add = a;
                var s = {
                    fromBig: i,
                    split: o,
                    toBig: t.toBig,
                    shrSH: function(e, t, r) {
                        return e >>> r;
                    },
                    shrSL: function(e, t, r) {
                        return e << 32 - r | t >>> r;
                    },
                    rotrSH: function(e, t, r) {
                        return e >>> r | t << 32 - r;
                    },
                    rotrSL: function(e, t, r) {
                        return e << 32 - r | t >>> r;
                    },
                    rotrBH: function(e, t, r) {
                        return e << 64 - r | t >>> r - 32;
                    },
                    rotrBL: function(e, t, r) {
                        return e >>> r - 32 | t << 64 - r;
                    },
                    rotr32H: function(e, t) {
                        return t;
                    },
                    rotr32L: function(e, t) {
                        return e;
                    },
                    rotlSH: function(e, t, r) {
                        return e << r | t >>> 32 - r;
                    },
                    rotlSL: function(e, t, r) {
                        return t << r | e >>> 32 - r;
                    },
                    rotlBH: function(e, t, r) {
                        return t << r - 32 | e >>> 64 - r;
                    },
                    rotlBL: function(e, t, r) {
                        return e << r - 32 | t >>> 64 - r;
                    },
                    add: a,
                    add3L: function(e, t, r) {
                        return (e >>> 0) + (t >>> 0) + (r >>> 0);
                    },
                    add3H: function(e, t, r, n) {
                        return t + r + n + (e / Math.pow(2, 32) | 0) | 0;
                    },
                    add4L: function(e, t, r, n) {
                        return (e >>> 0) + (t >>> 0) + (r >>> 0) + (n >>> 0);
                    },
                    add4H: function(e, t, r, n, i) {
                        return t + r + n + i + (e / Math.pow(2, 32) | 0) | 0;
                    },
                    add5H: function(e, t, r, n, i, o) {
                        return t + r + n + i + o + (e / Math.pow(2, 32) | 0) | 0;
                    },
                    add5L: function(e, t, r, n, i) {
                        return (e >>> 0) + (t >>> 0) + (r >>> 0) + (n >>> 0) + (i >>> 0);
                    }
                };
                t.default = s;
            },
            39712: (e, t, r)=>{
                "use strict";
                var n = r(28847)(r(3355));
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.crypto = void 0, t.crypto = "object" === ("undefined" == typeof globalThis ? "undefined" : (0, n.default)(globalThis)) && "crypto" in globalThis ? globalThis.crypto : void 0;
            },
            45896: (e, t, r)=>{
                "use strict";
                var n = r(28847), i = n(r(69721)), o = n(r(58985)), a = n(r(15163)), s = n(r(34650)), u = n(r(21949));
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.hmac = t.HMAC = void 0;
                var c = r(96822), f = r(72434), d = function(e) {
                    (0, a.default)(d, e);
                    var t, r, n = (t = d, r = function() {
                        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                        if (Reflect.construct.sham) return !1;
                        if ("function" == typeof Proxy) return !0;
                        try {
                            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                        } catch (e) {
                            return !1;
                        }
                    }(), function() {
                        var e, n = (0, u.default)(t);
                        if (r) {
                            var i = (0, u.default)(this).constructor;
                            e = Reflect.construct(n, arguments, i);
                        } else e = n.apply(this, arguments);
                        return (0, s.default)(this, e);
                    });
                    function d(e, t) {
                        var r;
                        (0, i.default)(this, d), (r = n.call(this)).finished = !1, r.destroyed = !1, c.default.hash(e);
                        var o = (0, f.toBytes)(t);
                        if (r.iHash = e.create(), "function" != typeof r.iHash.update) throw new Error("Expected instance of class which extends utils.Hash");
                        r.blockLen = r.iHash.blockLen, r.outputLen = r.iHash.outputLen;
                        var a = r.blockLen, s = new Uint8Array(a);
                        s.set(o.length > a ? e.create().update(o).digest() : o);
                        for(var u = 0; u < s.length; u++)s[u] ^= 54;
                        r.iHash.update(s), r.oHash = e.create();
                        for(var l = 0; l < s.length; l++)s[l] ^= 106;
                        return r.oHash.update(s), s.fill(0), r;
                    }
                    return (0, o.default)(d, [
                        {
                            key: "update",
                            value: function(e) {
                                return c.default.exists(this), this.iHash.update(e), this;
                            }
                        },
                        {
                            key: "digestInto",
                            value: function(e) {
                                c.default.exists(this), c.default.bytes(e, this.outputLen), this.finished = !0, this.iHash.digestInto(e), this.oHash.update(e), this.oHash.digestInto(e), this.destroy();
                            }
                        },
                        {
                            key: "digest",
                            value: function() {
                                var e = new Uint8Array(this.oHash.outputLen);
                                return this.digestInto(e), e;
                            }
                        },
                        {
                            key: "_cloneInto",
                            value: function(e) {
                                e || (e = Object.create(Object.getPrototypeOf(this), {}));
                                var t = this.oHash, r = this.iHash, n = this.finished, i = this.destroyed, o = this.blockLen, a = this.outputLen;
                                return e.finished = n, e.destroyed = i, e.blockLen = o, e.outputLen = a, e.oHash = t._cloneInto(e.oHash), e.iHash = r._cloneInto(e.iHash), e;
                            }
                        },
                        {
                            key: "destroy",
                            value: function() {
                                this.destroyed = !0, this.oHash.destroy(), this.iHash.destroy();
                            }
                        }
                    ]), d;
                }(f.Hash);
                t.HMAC = d, t.hmac = function(e, t, r) {
                    return new d(e, t).update(r).digest();
                }, t.hmac.create = function(e, t) {
                    return new d(e, t);
                };
            },
            61241: (e, t, r)=>{
                "use strict";
                var n = r(28847), i = n(r(69721)), o = n(r(58985)), a = n(r(15163)), s = n(r(34650)), u = n(r(21949));
                function c(e) {
                    var t = function() {
                        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                        if (Reflect.construct.sham) return !1;
                        if ("function" == typeof Proxy) return !0;
                        try {
                            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                        } catch (e) {
                            return !1;
                        }
                    }();
                    return function() {
                        var r, n = (0, u.default)(e);
                        if (t) {
                            var i = (0, u.default)(this).constructor;
                            r = Reflect.construct(n, arguments, i);
                        } else r = n.apply(this, arguments);
                        return (0, s.default)(this, r);
                    };
                }
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.sha224 = t.sha256 = void 0;
                var f = r(20330), d = r(72434), l = function(e, t, r) {
                    return e & t ^ e & r ^ t & r;
                }, h = new Uint32Array([
                    1116352408,
                    1899447441,
                    3049323471,
                    3921009573,
                    961987163,
                    1508970993,
                    2453635748,
                    2870763221,
                    3624381080,
                    310598401,
                    607225278,
                    1426881987,
                    1925078388,
                    2162078206,
                    2614888103,
                    3248222580,
                    3835390401,
                    4022224774,
                    264347078,
                    604807628,
                    770255983,
                    1249150122,
                    1555081692,
                    1996064986,
                    2554220882,
                    2821834349,
                    2952996808,
                    3210313671,
                    3336571891,
                    3584528711,
                    113926993,
                    338241895,
                    666307205,
                    773529912,
                    1294757372,
                    1396182291,
                    1695183700,
                    1986661051,
                    2177026350,
                    2456956037,
                    2730485921,
                    2820302411,
                    3259730800,
                    3345764771,
                    3516065817,
                    3600352804,
                    4094571909,
                    275423344,
                    430227734,
                    506948616,
                    659060556,
                    883997877,
                    958139571,
                    1322822218,
                    1537002063,
                    1747873779,
                    1955562222,
                    2024104815,
                    2227730452,
                    2361852424,
                    2428436474,
                    2756734187,
                    3204031479,
                    3329325298
                ]), p = new Uint32Array([
                    1779033703,
                    3144134277,
                    1013904242,
                    2773480762,
                    1359893119,
                    2600822924,
                    528734635,
                    1541459225
                ]), b = new Uint32Array(64), y = function(e) {
                    (0, a.default)(r, e);
                    var t = c(r);
                    function r() {
                        var e;
                        return (0, i.default)(this, r), (e = t.call(this, 64, 32, 8, !1)).A = 0 | p[0], e.B = 0 | p[1], e.C = 0 | p[2], e.D = 0 | p[3], e.E = 0 | p[4], e.F = 0 | p[5], e.G = 0 | p[6], e.H = 0 | p[7], e;
                    }
                    return (0, o.default)(r, [
                        {
                            key: "get",
                            value: function() {
                                return [
                                    this.A,
                                    this.B,
                                    this.C,
                                    this.D,
                                    this.E,
                                    this.F,
                                    this.G,
                                    this.H
                                ];
                            }
                        },
                        {
                            key: "set",
                            value: function(e, t, r, n, i, o, a, s) {
                                this.A = 0 | e, this.B = 0 | t, this.C = 0 | r, this.D = 0 | n, this.E = 0 | i, this.F = 0 | o, this.G = 0 | a, this.H = 0 | s;
                            }
                        },
                        {
                            key: "process",
                            value: function(e, t) {
                                for(var r = 0; r < 16; r++, t += 4)b[r] = e.getUint32(t, !1);
                                for(var n = 16; n < 64; n++){
                                    var i = b[n - 15], o = b[n - 2], a = (0, d.rotr)(i, 7) ^ (0, d.rotr)(i, 18) ^ i >>> 3, s = (0, d.rotr)(o, 17) ^ (0, d.rotr)(o, 19) ^ o >>> 10;
                                    b[n] = s + b[n - 7] + a + b[n - 16] | 0;
                                }
                                var u, c = this.A, f = this.B, p = this.C, y = this.D, v = this.E, m = this.F, g = this.G, w = this.H;
                                for(r = 0; r < 64; r++){
                                    var k = w + ((0, d.rotr)(v, 6) ^ (0, d.rotr)(v, 11) ^ (0, d.rotr)(v, 25)) + ((u = v) & m ^ ~u & g) + h[r] + b[r] | 0, _ = ((0, d.rotr)(c, 2) ^ (0, d.rotr)(c, 13) ^ (0, d.rotr)(c, 22)) + l(c, f, p) | 0;
                                    w = g, g = m, m = v, v = y + k | 0, y = p, p = f, f = c, c = k + _ | 0;
                                }
                                c = c + this.A | 0, f = f + this.B | 0, p = p + this.C | 0, y = y + this.D | 0, v = v + this.E | 0, m = m + this.F | 0, g = g + this.G | 0, w = w + this.H | 0, this.set(c, f, p, y, v, m, g, w);
                            }
                        },
                        {
                            key: "roundClean",
                            value: function() {
                                b.fill(0);
                            }
                        },
                        {
                            key: "destroy",
                            value: function() {
                                this.set(0, 0, 0, 0, 0, 0, 0, 0), this.buffer.fill(0);
                            }
                        }
                    ]), r;
                }(f.SHA2), v = function(e) {
                    (0, a.default)(r, e);
                    var t = c(r);
                    function r() {
                        var e;
                        return (0, i.default)(this, r), (e = t.call(this)).A = -1056596264, e.B = 914150663, e.C = 812702999, e.D = -150054599, e.E = -4191439, e.F = 1750603025, e.G = 1694076839, e.H = -1090891868, e.outputLen = 28, e;
                    }
                    return (0, o.default)(r);
                }(y);
                t.sha256 = (0, d.wrapConstructor)(function() {
                    return new y;
                }), t.sha224 = (0, d.wrapConstructor)(function() {
                    return new v;
                });
            },
            64376: (e, t, r)=>{
                "use strict";
                var n = r(28847), i = n(r(69721)), o = n(r(58985)), a = n(r(15163)), s = n(r(34650)), u = n(r(21949)), c = n(r(74519));
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.shake256 = t.shake128 = t.keccak_512 = t.keccak_384 = t.keccak_256 = t.keccak_224 = t.sha3_512 = t.sha3_384 = t.sha3_256 = t.sha3_224 = t.Keccak = t.keccakP = void 0;
                for(var f = r(96822), d = r(64356), l = r(72434), h = [], p = [], b = [], y = BigInt(0), v = BigInt(1), m = BigInt(2), g = BigInt(7), w = BigInt(256), k = BigInt(113), _ = 0, A = v, E = 1, S = 0; _ < 24; _++){
                    var x = [
                        S,
                        (2 * E + 3 * S) % 5
                    ];
                    E = x[0], S = x[1], h.push(2 * (5 * S + E)), p.push((_ + 1) * (_ + 2) / 2 % 64);
                    for(var B = y, O = 0; O < 7; O++)(A = (A << v ^ (A >> g) * k) % w) & m && (B ^= v << (v << BigInt(O)) - v);
                    b.push(B);
                }
                var P = d.default.split(b, !0), I = (0, c.default)(P, 2), T = I[0], C = I[1], M = function(e, t, r) {
                    return r > 32 ? d.default.rotlBH(e, t, r) : d.default.rotlSH(e, t, r);
                }, R = function(e, t, r) {
                    return r > 32 ? d.default.rotlBL(e, t, r) : d.default.rotlSL(e, t, r);
                };
                function U(e) {
                    for(var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 24, r = new Uint32Array(10), n = 24 - t; n < 24; n++){
                        for(var i = 0; i < 10; i++)r[i] = e[i] ^ e[i + 10] ^ e[i + 20] ^ e[i + 30] ^ e[i + 40];
                        for(var o = 0; o < 10; o += 2)for(var a = (o + 8) % 10, s = (o + 2) % 10, u = r[s], c = r[s + 1], f = M(u, c, 1) ^ r[a], d = R(u, c, 1) ^ r[a + 1], l = 0; l < 50; l += 10)e[o + l] ^= f, e[o + l + 1] ^= d;
                        for(var b = e[2], y = e[3], v = 0; v < 24; v++){
                            var m = p[v], g = M(b, y, m), w = R(b, y, m), k = h[v];
                            b = e[k], y = e[k + 1], e[k] = g, e[k + 1] = w;
                        }
                        for(var _ = 0; _ < 50; _ += 10){
                            for(var A = 0; A < 10; A++)r[A] = e[_ + A];
                            for(var E = 0; E < 10; E++)e[_ + E] ^= ~r[(E + 2) % 10] & r[(E + 4) % 10];
                        }
                        e[0] ^= T[n], e[1] ^= C[n];
                    }
                    r.fill(0);
                }
                t.keccakP = U;
                var N = function(e) {
                    (0, a.default)(c, e);
                    var t, r, n = (t = c, r = function() {
                        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                        if (Reflect.construct.sham) return !1;
                        if ("function" == typeof Proxy) return !0;
                        try {
                            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                        } catch (e) {
                            return !1;
                        }
                    }(), function() {
                        var e, n = (0, u.default)(t);
                        if (r) {
                            var i = (0, u.default)(this).constructor;
                            e = Reflect.construct(n, arguments, i);
                        } else e = n.apply(this, arguments);
                        return (0, s.default)(this, e);
                    });
                    function c(e, t, r) {
                        var o, a = arguments.length > 3 && void 0 !== arguments[3] && arguments[3], s = arguments.length > 4 && void 0 !== arguments[4] ? arguments[4] : 24;
                        if ((0, i.default)(this, c), (o = n.call(this)).blockLen = e, o.suffix = t, o.outputLen = r, o.enableXOF = a, o.rounds = s, o.pos = 0, o.posOut = 0, o.finished = !1, o.destroyed = !1, f.default.number(r), 0 >= o.blockLen || o.blockLen >= 200) throw new Error("Sha3 supports only keccak-f1600 function");
                        return o.state = new Uint8Array(200), o.state32 = (0, l.u32)(o.state), o;
                    }
                    return (0, o.default)(c, [
                        {
                            key: "keccak",
                            value: function() {
                                U(this.state32, this.rounds), this.posOut = 0, this.pos = 0;
                            }
                        },
                        {
                            key: "update",
                            value: function(e) {
                                f.default.exists(this);
                                for(var t = this.blockLen, r = this.state, n = (e = (0, l.toBytes)(e)).length, i = 0; i < n;){
                                    for(var o = Math.min(t - this.pos, n - i), a = 0; a < o; a++)r[this.pos++] ^= e[i++];
                                    this.pos === t && this.keccak();
                                }
                                return this;
                            }
                        },
                        {
                            key: "finish",
                            value: function() {
                                if (!this.finished) {
                                    this.finished = !0;
                                    var e = this.state, t = this.suffix, r = this.pos, n = this.blockLen;
                                    e[r] ^= t, 0 != (128 & t) && r === n - 1 && this.keccak(), e[n - 1] ^= 128, this.keccak();
                                }
                            }
                        },
                        {
                            key: "writeInto",
                            value: function(e) {
                                f.default.exists(this, !1), f.default.bytes(e), this.finish();
                                for(var t = this.state, r = this.blockLen, n = 0, i = e.length; n < i;){
                                    this.posOut >= r && this.keccak();
                                    var o = Math.min(r - this.posOut, i - n);
                                    e.set(t.subarray(this.posOut, this.posOut + o), n), this.posOut += o, n += o;
                                }
                                return e;
                            }
                        },
                        {
                            key: "xofInto",
                            value: function(e) {
                                if (!this.enableXOF) throw new Error("XOF is not possible for this instance");
                                return this.writeInto(e);
                            }
                        },
                        {
                            key: "xof",
                            value: function(e) {
                                return f.default.number(e), this.xofInto(new Uint8Array(e));
                            }
                        },
                        {
                            key: "digestInto",
                            value: function(e) {
                                if (f.default.output(e, this), this.finished) throw new Error("digest() was already called");
                                return this.writeInto(e), this.destroy(), e;
                            }
                        },
                        {
                            key: "digest",
                            value: function() {
                                return this.digestInto(new Uint8Array(this.outputLen));
                            }
                        },
                        {
                            key: "destroy",
                            value: function() {
                                this.destroyed = !0, this.state.fill(0);
                            }
                        },
                        {
                            key: "_cloneInto",
                            value: function(e) {
                                var t = this.blockLen, r = this.suffix, n = this.outputLen, i = this.rounds, o = this.enableXOF;
                                return e || (e = new c(t, r, n, o, i)), e.state32.set(this.state32), e.pos = this.pos, e.posOut = this.posOut, e.finished = this.finished, e.rounds = i, e.suffix = r, e.outputLen = n, e.enableXOF = o, e.destroyed = this.destroyed, e;
                            }
                        }
                    ]), c;
                }(l.Hash);
                t.Keccak = N;
                var j = function(e, t, r) {
                    return (0, l.wrapConstructor)(function() {
                        return new N(t, e, r);
                    });
                };
                t.sha3_224 = j(6, 144, 28), t.sha3_256 = j(6, 136, 32), t.sha3_384 = j(6, 104, 48), t.sha3_512 = j(6, 72, 64), t.keccak_224 = j(1, 144, 28), t.keccak_256 = j(1, 136, 32), t.keccak_384 = j(1, 104, 48), t.keccak_512 = j(1, 72, 64);
                var L = function(e, t, r) {
                    return (0, l.wrapXOFConstructorWithOpts)(function() {
                        var n = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
                        return new N(t, e, void 0 === n.dkLen ? r : n.dkLen, !0);
                    });
                };
                t.shake128 = L(31, 168, 16), t.shake256 = L(31, 136, 32);
            },
            72434: (e, t, r)=>{
                "use strict";
                var n = r(28847), i = n(r(82247)), o = n(r(69721)), a = n(r(58985)), s = n(r(94571)), u = n(r(3355));
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.randomBytes = t.wrapXOFConstructorWithOpts = t.wrapConstructorWithOpts = t.wrapConstructor = t.checkOpts = t.Hash = t.concatBytes = t.toBytes = t.utf8ToBytes = t.asyncLoop = t.nextTick = t.hexToBytes = t.bytesToHex = t.isLE = t.rotr = t.createView = t.u32 = t.u8 = void 0;
                var c = r(39712), f = function(e) {
                    return e instanceof Uint8Array;
                };
                if (t.u8 = function(e) {
                    return new Uint8Array(e.buffer, e.byteOffset, e.byteLength);
                }, t.u32 = function(e) {
                    return new Uint32Array(e.buffer, e.byteOffset, Math.floor(e.byteLength / 4));
                }, t.createView = function(e) {
                    return new DataView(e.buffer, e.byteOffset, e.byteLength);
                }, t.rotr = function(e, t) {
                    return e << 32 - t | e >>> t;
                }, t.isLE = 68 === new Uint8Array(new Uint32Array([
                    287454020
                ]).buffer)[0], !t.isLE) throw new Error("Non little-endian hardware is not supported");
                var d = Array.from({
                    length: 256
                }, function(e, t) {
                    return t.toString(16).padStart(2, "0");
                });
                t.bytesToHex = function(e) {
                    if (!f(e)) throw new Error("Uint8Array expected");
                    for(var t = "", r = 0; r < e.length; r++)t += d[e[r]];
                    return t;
                }, t.hexToBytes = function(e) {
                    if ("string" != typeof e) throw new Error("hex string expected, got " + (0, u.default)(e));
                    var t = e.length;
                    if (t % 2) throw new Error("padded hex string expected, got unpadded hex of length " + t);
                    for(var r = new Uint8Array(t / 2), n = 0; n < r.length; n++){
                        var i = 2 * n, o = e.slice(i, i + 2), a = Number.parseInt(o, 16);
                        if (Number.isNaN(a) || a < 0) throw new Error("Invalid byte sequence");
                        r[n] = a;
                    }
                    return r;
                };
                var l = function() {
                    var e = (0, s.default)(i.default.mark(function e() {
                        return i.default.wrap(function(e) {
                            for(;;)switch(e.prev = e.next){
                                case 0:
                                case "end":
                                    return e.stop();
                            }
                        }, e);
                    }));
                    return function() {
                        return e.apply(this, arguments);
                    };
                }();
                function h() {
                    return (h = (0, s.default)(i.default.mark(function e(r, n, o) {
                        var a, s, u;
                        return i.default.wrap(function(e) {
                            for(;;)switch(e.prev = e.next){
                                case 0:
                                    a = Date.now(), s = 0;
                                case 2:
                                    if (!(s < r)) {
                                        e.next = 13;
                                        break;
                                    }
                                    if (o(s), !((u = Date.now() - a) >= 0 && u < n)) {
                                        e.next = 7;
                                        break;
                                    }
                                    return e.abrupt("continue", 10);
                                case 7:
                                    return e.next = 9, (0, t.nextTick)();
                                case 9:
                                    a += u;
                                case 10:
                                    s++, e.next = 2;
                                    break;
                                case 13:
                                case "end":
                                    return e.stop();
                            }
                        }, e);
                    }))).apply(this, arguments);
                }
                function p(e) {
                    if ("string" != typeof e) throw new Error("utf8ToBytes expected string, got ".concat((0, u.default)(e)));
                    return new Uint8Array((new TextEncoder).encode(e));
                }
                function b(e) {
                    if ("string" == typeof e && (e = p(e)), !f(e)) throw new Error("expected Uint8Array, got ".concat((0, u.default)(e)));
                    return e;
                }
                t.nextTick = l, t.asyncLoop = function(e, t, r) {
                    return h.apply(this, arguments);
                }, t.utf8ToBytes = p, t.toBytes = b, t.concatBytes = function() {
                    for(var e = arguments.length, t = new Array(e), r = 0; r < e; r++)t[r] = arguments[r];
                    var n = new Uint8Array(t.reduce(function(e, t) {
                        return e + t.length;
                    }, 0)), i = 0;
                    return t.forEach(function(e) {
                        if (!f(e)) throw new Error("Uint8Array expected");
                        n.set(e, i), i += e.length;
                    }), n;
                };
                var y = function() {
                    function e() {
                        (0, o.default)(this, e);
                    }
                    return (0, a.default)(e, [
                        {
                            key: "clone",
                            value: function() {
                                return this._cloneInto();
                            }
                        }
                    ]), e;
                }();
                t.Hash = y;
                t.checkOpts = function(e, t) {
                    if (void 0 !== t && ("object" !== (0, u.default)(t) || (r = t, "[object Object]" !== Object.prototype.toString.call(r) || r.constructor !== Object))) throw new Error("Options should be object or undefined");
                    var r;
                    return Object.assign(e, t);
                }, t.wrapConstructor = function(e) {
                    var t = function(t) {
                        return e().update(b(t)).digest();
                    }, r = e();
                    return t.outputLen = r.outputLen, t.blockLen = r.blockLen, t.create = function() {
                        return e();
                    }, t;
                }, t.wrapConstructorWithOpts = function(e) {
                    var t = function(t, r) {
                        return e(r).update(b(t)).digest();
                    }, r = e({});
                    return t.outputLen = r.outputLen, t.blockLen = r.blockLen, t.create = function(t) {
                        return e(t);
                    }, t;
                }, t.wrapXOFConstructorWithOpts = function(e) {
                    var t = function(t, r) {
                        return e(r).update(b(t)).digest();
                    }, r = e({});
                    return t.outputLen = r.outputLen, t.blockLen = r.blockLen, t.create = function(t) {
                        return e(t);
                    }, t;
                }, t.randomBytes = function() {
                    var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 32;
                    if (c.crypto && "function" == typeof c.crypto.getRandomValues) return c.crypto.getRandomValues(new Uint8Array(e));
                    throw new Error("crypto.getRandomValues must be defined");
                };
            },
            53368: (e, t, r)=>{
                "use strict";
                var n, i, o = r(28847)(r(3355));
                void 0 === (i = "function" == typeof (n = function() {
                    function e(e, t) {
                        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                    }
                    function t(e, t) {
                        for(var r = 0; r < t.length; r++){
                            var n = t[r];
                            n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
                        }
                    }
                    function n(e, r, n) {
                        return r && t(e.prototype, r), n && t(e, n), Object.defineProperty(e, "prototype", {
                            writable: !1
                        }), e;
                    }
                    function i(e) {
                        return i = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(e) {
                            return e.__proto__ || Object.getPrototypeOf(e);
                        }, i(e);
                    }
                    function a(e, t) {
                        return a = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(e, t) {
                            return e.__proto__ = t, e;
                        }, a(e, t);
                    }
                    function s(e) {
                        if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                        return e;
                    }
                    function u(e) {
                        var t = function() {
                            if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                            if (Reflect.construct.sham) return !1;
                            if ("function" == typeof Proxy) return !0;
                            try {
                                return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                            } catch (e) {
                                return !1;
                            }
                        }();
                        return function() {
                            var r, n = i(e);
                            if (t) {
                                var a = i(this).constructor;
                                r = Reflect.construct(n, arguments, a);
                            } else r = n.apply(this, arguments);
                            return function(e, t) {
                                if (t && ("object" === (0, o.default)(t) || "function" == typeof t)) return t;
                                if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
                                return s(e);
                            }(this, r);
                        };
                    }
                    function c() {
                        return c = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function(e, t, r) {
                            var n = function(e, t) {
                                for(; !Object.prototype.hasOwnProperty.call(e, t) && null !== (e = i(e)););
                                return e;
                            }(e, t);
                            if (n) {
                                var o = Object.getOwnPropertyDescriptor(n, t);
                                return o.get ? o.get.call(arguments.length < 3 ? e : r) : o.value;
                            }
                        }, c.apply(this, arguments);
                    }
                    var f = function() {
                        function t() {
                            e(this, t), Object.defineProperty(this, "listeners", {
                                value: {},
                                writable: !0,
                                configurable: !0
                            });
                        }
                        return n(t, [
                            {
                                key: "addEventListener",
                                value: function(e, t, r) {
                                    e in this.listeners || (this.listeners[e] = []), this.listeners[e].push({
                                        callback: t,
                                        options: r
                                    });
                                }
                            },
                            {
                                key: "removeEventListener",
                                value: function(e, t) {
                                    if (e in this.listeners) {
                                        for(var r = this.listeners[e], n = 0, i = r.length; n < i; n++)if (r[n].callback === t) return void r.splice(n, 1);
                                    }
                                }
                            },
                            {
                                key: "dispatchEvent",
                                value: function(e) {
                                    if (e.type in this.listeners) {
                                        for(var t = this.listeners[e.type].slice(), r = 0, n = t.length; r < n; r++){
                                            var i = t[r];
                                            try {
                                                i.callback.call(this, e);
                                            } catch (e) {
                                                Promise.resolve().then(function() {
                                                    throw e;
                                                });
                                            }
                                            i.options && i.options.once && this.removeEventListener(e.type, i.callback);
                                        }
                                        return !e.defaultPrevented;
                                    }
                                }
                            }
                        ]), t;
                    }(), d = function(t) {
                        !function(e, t) {
                            if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
                            e.prototype = Object.create(t && t.prototype, {
                                constructor: {
                                    value: e,
                                    writable: !0,
                                    configurable: !0
                                }
                            }), Object.defineProperty(e, "prototype", {
                                writable: !1
                            }), t && a(e, t);
                        }(o, t);
                        var r = u(o);
                        function o() {
                            var t;
                            return e(this, o), (t = r.call(this)).listeners || f.call(s(t)), Object.defineProperty(s(t), "aborted", {
                                value: !1,
                                writable: !0,
                                configurable: !0
                            }), Object.defineProperty(s(t), "onabort", {
                                value: null,
                                writable: !0,
                                configurable: !0
                            }), Object.defineProperty(s(t), "reason", {
                                value: void 0,
                                writable: !0,
                                configurable: !0
                            }), t;
                        }
                        return n(o, [
                            {
                                key: "toString",
                                value: function() {
                                    return "[object AbortSignal]";
                                }
                            },
                            {
                                key: "dispatchEvent",
                                value: function(e) {
                                    "abort" === e.type && (this.aborted = !0, "function" == typeof this.onabort && this.onabort.call(this, e)), c(i(o.prototype), "dispatchEvent", this).call(this, e);
                                }
                            }
                        ]), o;
                    }(f), l = function() {
                        function t() {
                            e(this, t), Object.defineProperty(this, "signal", {
                                value: new d,
                                writable: !0,
                                configurable: !0
                            });
                        }
                        return n(t, [
                            {
                                key: "abort",
                                value: function(e) {
                                    var t;
                                    try {
                                        t = new Event("abort");
                                    } catch (e) {
                                        "undefined" != typeof document ? document.createEvent ? (t = document.createEvent("Event")).initEvent("abort", !1, !1) : (t = document.createEventObject()).type = "abort" : t = {
                                            type: "abort",
                                            bubbles: !1,
                                            cancelable: !1
                                        };
                                    }
                                    var r = e;
                                    if (void 0 === r) {
                                        if ("undefined" == typeof document) (r = new Error("This operation was aborted")).name = "AbortError";
                                        else try {
                                            r = new DOMException("signal is aborted without reason");
                                        } catch (e) {
                                            (r = new Error("This operation was aborted")).name = "AbortError";
                                        }
                                    }
                                    this.signal.reason = r, this.signal.dispatchEvent(t);
                                }
                            },
                            {
                                key: "toString",
                                value: function() {
                                    return "[object AbortController]";
                                }
                            }
                        ]), t;
                    }();
                    function h(e) {
                        return e.__FORCE_INSTALL_ABORTCONTROLLER_POLYFILL ? (console.log("__FORCE_INSTALL_ABORTCONTROLLER_POLYFILL=true is set, will force install polyfill"), !0) : "function" == typeof e.Request && !e.Request.prototype.hasOwnProperty("signal") || !e.AbortController;
                    }
                    "undefined" != typeof Symbol && Symbol.toStringTag && (l.prototype[Symbol.toStringTag] = "AbortController", d.prototype[Symbol.toStringTag] = "AbortSignal"), function(e) {
                        if (h(e)) {
                            if (e.fetch) {
                                var t = function(e) {
                                    "function" == typeof e && (e = {
                                        fetch: e
                                    });
                                    var t = e, r = t.fetch, n = t.Request, i = void 0 === n ? r.Request : n, o = t.AbortController, a = t.__FORCE_INSTALL_ABORTCONTROLLER_POLYFILL, s = void 0 !== a && a;
                                    if (!h({
                                        fetch: r,
                                        Request: i,
                                        AbortController: o,
                                        __FORCE_INSTALL_ABORTCONTROLLER_POLYFILL: s
                                    })) return {
                                        fetch: r,
                                        Request: u
                                    };
                                    var u = i;
                                    (u && !u.prototype.hasOwnProperty("signal") || s) && ((u = function(e, t) {
                                        var r;
                                        t && t.signal && (r = t.signal, delete t.signal);
                                        var n = new i(e, t);
                                        return r && Object.defineProperty(n, "signal", {
                                            writable: !1,
                                            enumerable: !1,
                                            configurable: !0,
                                            value: r
                                        }), n;
                                    }).prototype = i.prototype);
                                    var c = r;
                                    return {
                                        fetch: function(e, t) {
                                            var r = u && u.prototype.isPrototypeOf(e) ? e.signal : t ? t.signal : void 0;
                                            if (r) {
                                                var n;
                                                try {
                                                    n = new DOMException("Aborted", "AbortError");
                                                } catch (e) {
                                                    (n = new Error("Aborted")).name = "AbortError";
                                                }
                                                if (r.aborted) return Promise.reject(n);
                                                var i = new Promise(function(e, t) {
                                                    r.addEventListener("abort", function() {
                                                        return t(n);
                                                    }, {
                                                        once: !0
                                                    });
                                                });
                                                return t && t.signal && delete t.signal, Promise.race([
                                                    i,
                                                    c(e, t)
                                                ]);
                                            }
                                            return c(e, t);
                                        },
                                        Request: u
                                    };
                                }(e), r = t.fetch, n = t.Request;
                                e.fetch = r, e.Request = n, Object.defineProperty(e, "AbortController", {
                                    writable: !0,
                                    enumerable: !1,
                                    configurable: !0,
                                    value: l
                                }), Object.defineProperty(e, "AbortSignal", {
                                    writable: !0,
                                    enumerable: !1,
                                    configurable: !0,
                                    value: d
                                });
                            } else console.warn("fetch() is not available, cannot install abortcontroller-polyfill");
                        }
                    }("undefined" != typeof self ? self : r.g);
                }) ? n.call(t, r, t, e) : n) || (e.exports = i);
            },
            68357: (e, t, r)=>{
                "use strict";
                var n = t;
                n.bignum = r(31734), n.define = r(41568).define, n.base = r(12412), n.constants = r(79387), n.decoders = r(61500), n.encoders = r(47506);
            },
            41568: (e, t, r)=>{
                "use strict";
                var n = r(47506), i = r(61500), o = r(41736);
                function a(e, t) {
                    this.name = e, this.body = t, this.decoders = {}, this.encoders = {};
                }
                t.define = function(e, t) {
                    return new a(e, t);
                }, a.prototype._createNamed = function(e) {
                    var t = this.name;
                    function r(e) {
                        this._initNamed(e, t);
                    }
                    return o(r, e), r.prototype._initNamed = function(t, r) {
                        e.call(this, t, r);
                    }, new r(this);
                }, a.prototype._getDecoder = function(e) {
                    return e = e || "der", this.decoders.hasOwnProperty(e) || (this.decoders[e] = this._createNamed(i[e])), this.decoders[e];
                }, a.prototype.decode = function(e, t, r) {
                    return this._getDecoder(t).decode(e, r);
                }, a.prototype._getEncoder = function(e) {
                    return e = e || "der", this.encoders.hasOwnProperty(e) || (this.encoders[e] = this._createNamed(n[e])), this.encoders[e];
                }, a.prototype.encode = function(e, t, r) {
                    return this._getEncoder(t).encode(e, r);
                };
            },
            90585: (e, t, r)=>{
                "use strict";
                var n = r(28847)(r(3355)), i = r(41736), o = r(32719).b, a = r(11755).Buffer;
                function s(e, t) {
                    o.call(this, t), a.isBuffer(e) ? (this.base = e, this.offset = 0, this.length = e.length) : this.error("Input not Buffer");
                }
                function u(e, t) {
                    if (Array.isArray(e)) this.length = 0, this.value = e.map(function(e) {
                        return u.isEncoderBuffer(e) || (e = new u(e, t)), this.length += e.length, e;
                    }, this);
                    else if ("number" == typeof e) {
                        if (!(0 <= e && e <= 255)) return t.error("non-byte EncoderBuffer value");
                        this.value = e, this.length = 1;
                    } else if ("string" == typeof e) this.value = e, this.length = a.byteLength(e);
                    else {
                        if (!a.isBuffer(e)) return t.error("Unsupported type: " + (0, n.default)(e));
                        this.value = e, this.length = e.length;
                    }
                }
                i(s, o), t.C = s, s.isDecoderBuffer = function(e) {
                    return e instanceof s || "object" === (0, n.default)(e) && a.isBuffer(e.base) && "DecoderBuffer" === e.constructor.name && "number" == typeof e.offset && "number" == typeof e.length && "function" == typeof e.save && "function" == typeof e.restore && "function" == typeof e.isEmpty && "function" == typeof e.readUInt8 && "function" == typeof e.skip && "function" == typeof e.raw;
                }, s.prototype.save = function() {
                    return {
                        offset: this.offset,
                        reporter: o.prototype.save.call(this)
                    };
                }, s.prototype.restore = function(e) {
                    var t = new s(this.base);
                    return t.offset = e.offset, t.length = this.offset, this.offset = e.offset, o.prototype.restore.call(this, e.reporter), t;
                }, s.prototype.isEmpty = function() {
                    return this.offset === this.length;
                }, s.prototype.readUInt8 = function(e) {
                    return this.offset + 1 <= this.length ? this.base.readUInt8(this.offset++, !0) : this.error(e || "DecoderBuffer overrun");
                }, s.prototype.skip = function(e, t) {
                    if (!(this.offset + e <= this.length)) return this.error(t || "DecoderBuffer overrun");
                    var r = new s(this.base);
                    return r._reporterState = this._reporterState, r.offset = this.offset, r.length = this.offset + e, this.offset += e, r;
                }, s.prototype.raw = function(e) {
                    return this.base.slice(e ? e.offset : this.offset, this.length);
                }, t.R = u, u.isEncoderBuffer = function(e) {
                    return e instanceof u || "object" === (0, n.default)(e) && "EncoderBuffer" === e.constructor.name && "number" == typeof e.length && "function" == typeof e.join;
                }, u.prototype.join = function(e, t) {
                    return e || (e = a.alloc(this.length)), t || (t = 0), 0 === this.length || (Array.isArray(this.value) ? this.value.forEach(function(r) {
                        r.join(e, t), t += r.length;
                    }) : ("number" == typeof this.value ? e[t] = this.value : "string" == typeof this.value ? e.write(this.value, t) : a.isBuffer(this.value) && this.value.copy(e, t), t += this.length)), e;
                };
            },
            12412: (e, t, r)=>{
                "use strict";
                var n = t;
                n.Reporter = r(32719).b, n.DecoderBuffer = r(90585).C, n.EncoderBuffer = r(90585).R, n.Node = r(51371);
            },
            51371: (e, t, r)=>{
                "use strict";
                var n = r(28847)(r(3355)), i = r(32719).b, o = r(90585).R, a = r(90585).C, s = r(94504), u = [
                    "seq",
                    "seqof",
                    "set",
                    "setof",
                    "objid",
                    "bool",
                    "gentime",
                    "utctime",
                    "null_",
                    "enum",
                    "int",
                    "objDesc",
                    "bitstr",
                    "bmpstr",
                    "charstr",
                    "genstr",
                    "graphstr",
                    "ia5str",
                    "iso646str",
                    "numstr",
                    "octstr",
                    "printstr",
                    "t61str",
                    "unistr",
                    "utf8str",
                    "videostr"
                ], c = [
                    "key",
                    "obj",
                    "use",
                    "optional",
                    "explicit",
                    "implicit",
                    "def",
                    "choice",
                    "any",
                    "contains"
                ].concat(u);
                function f(e, t, r) {
                    var n = {};
                    this._baseState = n, n.name = r, n.enc = e, n.parent = t || null, n.children = null, n.tag = null, n.args = null, n.reverseArgs = null, n.choice = null, n.optional = !1, n.any = !1, n.obj = !1, n.use = null, n.useDecoder = null, n.key = null, n.default = null, n.explicit = null, n.implicit = null, n.contains = null, n.parent || (n.children = [], this._wrap());
                }
                e.exports = f;
                var d = [
                    "enc",
                    "parent",
                    "children",
                    "tag",
                    "args",
                    "reverseArgs",
                    "choice",
                    "optional",
                    "any",
                    "obj",
                    "use",
                    "alteredUse",
                    "key",
                    "default",
                    "explicit",
                    "implicit",
                    "contains"
                ];
                f.prototype.clone = function() {
                    var e = this._baseState, t = {};
                    d.forEach(function(r) {
                        t[r] = e[r];
                    });
                    var r = new this.constructor(t.parent);
                    return r._baseState = t, r;
                }, f.prototype._wrap = function() {
                    var e = this._baseState;
                    c.forEach(function(t) {
                        this[t] = function() {
                            var r = new this.constructor(this);
                            return e.children.push(r), r[t].apply(r, arguments);
                        };
                    }, this);
                }, f.prototype._init = function(e) {
                    var t = this._baseState;
                    s(null === t.parent), e.call(this), t.children = t.children.filter(function(e) {
                        return e._baseState.parent === this;
                    }, this), s.equal(t.children.length, 1, "Root node can have only one child");
                }, f.prototype._useArgs = function(e) {
                    var t = this._baseState, r = e.filter(function(e) {
                        return e instanceof this.constructor;
                    }, this);
                    e = e.filter(function(e) {
                        return !(e instanceof this.constructor);
                    }, this), 0 !== r.length && (s(null === t.children), t.children = r, r.forEach(function(e) {
                        e._baseState.parent = this;
                    }, this)), 0 !== e.length && (s(null === t.args), t.args = e, t.reverseArgs = e.map(function(e) {
                        if ("object" !== (0, n.default)(e) || e.constructor !== Object) return e;
                        var t = {};
                        return Object.keys(e).forEach(function(r) {
                            r == (0 | r) && (r |= 0);
                            var n = e[r];
                            t[n] = r;
                        }), t;
                    }));
                }, [
                    "_peekTag",
                    "_decodeTag",
                    "_use",
                    "_decodeStr",
                    "_decodeObjid",
                    "_decodeTime",
                    "_decodeNull",
                    "_decodeInt",
                    "_decodeBool",
                    "_decodeList",
                    "_encodeComposite",
                    "_encodeStr",
                    "_encodeObjid",
                    "_encodeTime",
                    "_encodeNull",
                    "_encodeInt",
                    "_encodeBool"
                ].forEach(function(e) {
                    f.prototype[e] = function() {
                        var t = this._baseState;
                        throw new Error(e + " not implemented for encoding: " + t.enc);
                    };
                }), u.forEach(function(e) {
                    f.prototype[e] = function() {
                        var t = this._baseState, r = Array.prototype.slice.call(arguments);
                        return s(null === t.tag), t.tag = e, this._useArgs(r), this;
                    };
                }), f.prototype.use = function(e) {
                    s(e);
                    var t = this._baseState;
                    return s(null === t.use), t.use = e, this;
                }, f.prototype.optional = function() {
                    return this._baseState.optional = !0, this;
                }, f.prototype.def = function(e) {
                    var t = this._baseState;
                    return s(null === t.default), t.default = e, t.optional = !0, this;
                }, f.prototype.explicit = function(e) {
                    var t = this._baseState;
                    return s(null === t.explicit && null === t.implicit), t.explicit = e, this;
                }, f.prototype.implicit = function(e) {
                    var t = this._baseState;
                    return s(null === t.explicit && null === t.implicit), t.implicit = e, this;
                }, f.prototype.obj = function() {
                    var e = this._baseState, t = Array.prototype.slice.call(arguments);
                    return e.obj = !0, 0 !== t.length && this._useArgs(t), this;
                }, f.prototype.key = function(e) {
                    var t = this._baseState;
                    return s(null === t.key), t.key = e, this;
                }, f.prototype.any = function() {
                    return this._baseState.any = !0, this;
                }, f.prototype.choice = function(e) {
                    var t = this._baseState;
                    return s(null === t.choice), t.choice = e, this._useArgs(Object.keys(e).map(function(t) {
                        return e[t];
                    })), this;
                }, f.prototype.contains = function(e) {
                    var t = this._baseState;
                    return s(null === t.use), t.contains = e, this;
                }, f.prototype._decode = function(e, t) {
                    var r = this._baseState;
                    if (null === r.parent) return e.wrapResult(r.children[0]._decode(e, t));
                    var n, i = r.default, o = !0, s = null;
                    if (null !== r.key && (s = e.enterKey(r.key)), r.optional) {
                        var u = null;
                        if (null !== r.explicit ? u = r.explicit : null !== r.implicit ? u = r.implicit : null !== r.tag && (u = r.tag), null !== u || r.any) {
                            if (o = this._peekTag(e, u, r.any), e.isError(o)) return o;
                        } else {
                            var c = e.save();
                            try {
                                null === r.choice ? this._decodeGeneric(r.tag, e, t) : this._decodeChoice(e, t), o = !0;
                            } catch (e) {
                                o = !1;
                            }
                            e.restore(c);
                        }
                    }
                    if (r.obj && o && (n = e.enterObject()), o) {
                        if (null !== r.explicit) {
                            var f = this._decodeTag(e, r.explicit);
                            if (e.isError(f)) return f;
                            e = f;
                        }
                        var d = e.offset;
                        if (null === r.use && null === r.choice) {
                            var l;
                            r.any && (l = e.save());
                            var h = this._decodeTag(e, null !== r.implicit ? r.implicit : r.tag, r.any);
                            if (e.isError(h)) return h;
                            r.any ? i = e.raw(l) : e = h;
                        }
                        if (t && t.track && null !== r.tag && t.track(e.path(), d, e.length, "tagged"), t && t.track && null !== r.tag && t.track(e.path(), e.offset, e.length, "content"), r.any || (i = null === r.choice ? this._decodeGeneric(r.tag, e, t) : this._decodeChoice(e, t)), e.isError(i)) return i;
                        if (r.any || null !== r.choice || null === r.children || r.children.forEach(function(r) {
                            r._decode(e, t);
                        }), r.contains && ("octstr" === r.tag || "bitstr" === r.tag)) {
                            var p = new a(i);
                            i = this._getUse(r.contains, e._reporterState.obj)._decode(p, t);
                        }
                    }
                    return r.obj && o && (i = e.leaveObject(n)), null === r.key || null === i && !0 !== o ? null !== s && e.exitKey(s) : e.leaveKey(s, r.key, i), i;
                }, f.prototype._decodeGeneric = function(e, t, r) {
                    var n = this._baseState;
                    return "seq" === e || "set" === e ? null : "seqof" === e || "setof" === e ? this._decodeList(t, e, n.args[0], r) : /str$/.test(e) ? this._decodeStr(t, e, r) : "objid" === e && n.args ? this._decodeObjid(t, n.args[0], n.args[1], r) : "objid" === e ? this._decodeObjid(t, null, null, r) : "gentime" === e || "utctime" === e ? this._decodeTime(t, e, r) : "null_" === e ? this._decodeNull(t, r) : "bool" === e ? this._decodeBool(t, r) : "objDesc" === e ? this._decodeStr(t, e, r) : "int" === e || "enum" === e ? this._decodeInt(t, n.args && n.args[0], r) : null !== n.use ? this._getUse(n.use, t._reporterState.obj)._decode(t, r) : t.error("unknown tag: " + e);
                }, f.prototype._getUse = function(e, t) {
                    var r = this._baseState;
                    return r.useDecoder = this._use(e, t), s(null === r.useDecoder._baseState.parent), r.useDecoder = r.useDecoder._baseState.children[0], r.implicit !== r.useDecoder._baseState.implicit && (r.useDecoder = r.useDecoder.clone(), r.useDecoder._baseState.implicit = r.implicit), r.useDecoder;
                }, f.prototype._decodeChoice = function(e, t) {
                    var r = this._baseState, n = null, i = !1;
                    return Object.keys(r.choice).some(function(o) {
                        var a = e.save(), s = r.choice[o];
                        try {
                            var u = s._decode(e, t);
                            if (e.isError(u)) return !1;
                            n = {
                                type: o,
                                value: u
                            }, i = !0;
                        } catch (t) {
                            return e.restore(a), !1;
                        }
                        return !0;
                    }, this), i ? n : e.error("Choice not matched");
                }, f.prototype._createEncoderBuffer = function(e) {
                    return new o(e, this.reporter);
                }, f.prototype._encode = function(e, t, r) {
                    var n = this._baseState;
                    if (null === n.default || n.default !== e) {
                        var i = this._encodeValue(e, t, r);
                        if (void 0 !== i && !this._skipDefault(i, t, r)) return i;
                    }
                }, f.prototype._encodeValue = function(e, t, r) {
                    var o = this._baseState;
                    if (null === o.parent) return o.children[0]._encode(e, t || new i);
                    var a = null;
                    if (this.reporter = t, o.optional && void 0 === e) {
                        if (null === o.default) return;
                        e = o.default;
                    }
                    var s = null, u = !1;
                    if (o.any) a = this._createEncoderBuffer(e);
                    else if (o.choice) a = this._encodeChoice(e, t);
                    else if (o.contains) s = this._getUse(o.contains, r)._encode(e, t), u = !0;
                    else if (o.children) s = o.children.map(function(r) {
                        if ("null_" === r._baseState.tag) return r._encode(null, t, e);
                        if (null === r._baseState.key) return t.error("Child should have a key");
                        var i = t.enterKey(r._baseState.key);
                        if ("object" !== (0, n.default)(e)) return t.error("Child expected, but input is not object");
                        var o = r._encode(e[r._baseState.key], t, e);
                        return t.leaveKey(i), o;
                    }, this).filter(function(e) {
                        return e;
                    }), s = this._createEncoderBuffer(s);
                    else if ("seqof" === o.tag || "setof" === o.tag) {
                        if (!o.args || 1 !== o.args.length) return t.error("Too many args for : " + o.tag);
                        if (!Array.isArray(e)) return t.error("seqof/setof, but data is not Array");
                        var c = this.clone();
                        c._baseState.implicit = null, s = this._createEncoderBuffer(e.map(function(r) {
                            var n = this._baseState;
                            return this._getUse(n.args[0], e)._encode(r, t);
                        }, c));
                    } else null !== o.use ? a = this._getUse(o.use, r)._encode(e, t) : (s = this._encodePrimitive(o.tag, e), u = !0);
                    if (!o.any && null === o.choice) {
                        var f = null !== o.implicit ? o.implicit : o.tag, d = null === o.implicit ? "universal" : "context";
                        null === f ? null === o.use && t.error("Tag could be omitted only for .use()") : null === o.use && (a = this._encodeComposite(f, u, d, s));
                    }
                    return null !== o.explicit && (a = this._encodeComposite(o.explicit, !1, "context", a)), a;
                }, f.prototype._encodeChoice = function(e, t) {
                    var r = this._baseState, n = r.choice[e.type];
                    return n || s(!1, e.type + " not found in " + JSON.stringify(Object.keys(r.choice))), n._encode(e.value, t);
                }, f.prototype._encodePrimitive = function(e, t) {
                    var r = this._baseState;
                    if (/str$/.test(e)) return this._encodeStr(t, e);
                    if ("objid" === e && r.args) return this._encodeObjid(t, r.reverseArgs[0], r.args[1]);
                    if ("objid" === e) return this._encodeObjid(t, null, null);
                    if ("gentime" === e || "utctime" === e) return this._encodeTime(t, e);
                    if ("null_" === e) return this._encodeNull();
                    if ("int" === e || "enum" === e) return this._encodeInt(t, r.args && r.reverseArgs[0]);
                    if ("bool" === e) return this._encodeBool(t);
                    if ("objDesc" === e) return this._encodeStr(t, e);
                    throw new Error("Unsupported tag: " + e);
                }, f.prototype._isNumstr = function(e) {
                    return /^[0-9 ]*$/.test(e);
                }, f.prototype._isPrintstr = function(e) {
                    return /^[A-Za-z0-9 '()+,-./:=?]*$/.test(e);
                };
            },
            32719: (e, t, r)=>{
                "use strict";
                var n = r(41736);
                function i(e) {
                    this._reporterState = {
                        obj: null,
                        path: [],
                        options: e || {},
                        errors: []
                    };
                }
                function o(e, t) {
                    this.path = e, this.rethrow(t);
                }
                t.b = i, i.prototype.isError = function(e) {
                    return e instanceof o;
                }, i.prototype.save = function() {
                    var e = this._reporterState;
                    return {
                        obj: e.obj,
                        pathLen: e.path.length
                    };
                }, i.prototype.restore = function(e) {
                    var t = this._reporterState;
                    t.obj = e.obj, t.path = t.path.slice(0, e.pathLen);
                }, i.prototype.enterKey = function(e) {
                    return this._reporterState.path.push(e);
                }, i.prototype.exitKey = function(e) {
                    var t = this._reporterState;
                    t.path = t.path.slice(0, e - 1);
                }, i.prototype.leaveKey = function(e, t, r) {
                    var n = this._reporterState;
                    this.exitKey(e), null !== n.obj && (n.obj[t] = r);
                }, i.prototype.path = function() {
                    return this._reporterState.path.join("/");
                }, i.prototype.enterObject = function() {
                    var e = this._reporterState, t = e.obj;
                    return e.obj = {}, t;
                }, i.prototype.leaveObject = function(e) {
                    var t = this._reporterState, r = t.obj;
                    return t.obj = e, r;
                }, i.prototype.error = function(e) {
                    var t, r = this._reporterState, n = e instanceof o;
                    if (t = n ? e : new o(r.path.map(function(e) {
                        return "[" + JSON.stringify(e) + "]";
                    }).join(""), e.message || e, e.stack), !r.options.partial) throw t;
                    return n || r.errors.push(t), t;
                }, i.prototype.wrapResult = function(e) {
                    var t = this._reporterState;
                    return t.options.partial ? {
                        result: this.isError(e) ? null : e,
                        errors: t.errors
                    } : e;
                }, n(o, Error), o.prototype.rethrow = function(e) {
                    if (this.message = e + " at: " + (this.path || "(shallow)"), Error.captureStackTrace && Error.captureStackTrace(this, o), !this.stack) try {
                        throw new Error(this.message);
                    } catch (e) {
                        this.stack = e.stack;
                    }
                    return this;
                };
            },
            6520: (e, t)=>{
                "use strict";
                function r(e) {
                    var t = {};
                    return Object.keys(e).forEach(function(r) {
                        (0 | r) == r && (r |= 0);
                        var n = e[r];
                        t[n] = r;
                    }), t;
                }
                t.tagClass = {
                    0: "universal",
                    1: "application",
                    2: "context",
                    3: "private"
                }, t.tagClassByName = r(t.tagClass), t.tag = {
                    0: "end",
                    1: "bool",
                    2: "int",
                    3: "bitstr",
                    4: "octstr",
                    5: "null_",
                    6: "objid",
                    7: "objDesc",
                    8: "external",
                    9: "real",
                    10: "enum",
                    11: "embed",
                    12: "utf8str",
                    13: "relativeOid",
                    16: "seq",
                    17: "set",
                    18: "numstr",
                    19: "printstr",
                    20: "t61str",
                    21: "videostr",
                    22: "ia5str",
                    23: "utctime",
                    24: "gentime",
                    25: "graphstr",
                    26: "iso646str",
                    27: "genstr",
                    28: "unistr",
                    29: "charstr",
                    30: "bmpstr"
                }, t.tagByName = r(t.tag);
            },
            79387: (e, t, r)=>{
                "use strict";
                var n = t;
                n._reverse = function(e) {
                    var t = {};
                    return Object.keys(e).forEach(function(r) {
                        (0 | r) == r && (r |= 0);
                        var n = e[r];
                        t[n] = r;
                    }), t;
                }, n.der = r(6520);
            },
            92387: (e, t, r)=>{
                "use strict";
                var n = r(41736), i = r(31734), o = r(90585).C, a = r(51371), s = r(6520);
                function u(e) {
                    this.enc = "der", this.name = e.name, this.entity = e, this.tree = new c, this.tree._init(e.body);
                }
                function c(e) {
                    a.call(this, "der", e);
                }
                function f(e, t) {
                    var r = e.readUInt8(t);
                    if (e.isError(r)) return r;
                    var n = s.tagClass[r >> 6], i = 0 == (32 & r);
                    if (31 == (31 & r)) {
                        var o = r;
                        for(r = 0; 128 == (128 & o);){
                            if (o = e.readUInt8(t), e.isError(o)) return o;
                            r <<= 7, r |= 127 & o;
                        }
                    } else r &= 31;
                    return {
                        cls: n,
                        primitive: i,
                        tag: r,
                        tagStr: s.tag[r]
                    };
                }
                function d(e, t, r) {
                    var n = e.readUInt8(r);
                    if (e.isError(n)) return n;
                    if (!t && 128 === n) return null;
                    if (0 == (128 & n)) return n;
                    var i = 127 & n;
                    if (i > 4) return e.error("length octect is too long");
                    n = 0;
                    for(var o = 0; o < i; o++){
                        n <<= 8;
                        var a = e.readUInt8(r);
                        if (e.isError(a)) return a;
                        n |= a;
                    }
                    return n;
                }
                e.exports = u, u.prototype.decode = function(e, t) {
                    return o.isDecoderBuffer(e) || (e = new o(e, t)), this.tree._decode(e, t);
                }, n(c, a), c.prototype._peekTag = function(e, t, r) {
                    if (e.isEmpty()) return !1;
                    var n = e.save(), i = f(e, 'Failed to peek tag: "' + t + '"');
                    return e.isError(i) ? i : (e.restore(n), i.tag === t || i.tagStr === t || i.tagStr + "of" === t || r);
                }, c.prototype._decodeTag = function(e, t, r) {
                    var n = f(e, 'Failed to decode tag of "' + t + '"');
                    if (e.isError(n)) return n;
                    var i = d(e, n.primitive, 'Failed to get length of "' + t + '"');
                    if (e.isError(i)) return i;
                    if (!r && n.tag !== t && n.tagStr !== t && n.tagStr + "of" !== t) return e.error('Failed to match tag: "' + t + '"');
                    if (n.primitive || null !== i) return e.skip(i, 'Failed to match body of: "' + t + '"');
                    var o = e.save(), a = this._skipUntilEnd(e, 'Failed to skip indefinite length body: "' + this.tag + '"');
                    return e.isError(a) ? a : (i = e.offset - o.offset, e.restore(o), e.skip(i, 'Failed to match body of: "' + t + '"'));
                }, c.prototype._skipUntilEnd = function(e, t) {
                    for(;;){
                        var r = f(e, t);
                        if (e.isError(r)) return r;
                        var n = d(e, r.primitive, t);
                        if (e.isError(n)) return n;
                        var i;
                        if (i = r.primitive || null !== n ? e.skip(n) : this._skipUntilEnd(e, t), e.isError(i)) return i;
                        if ("end" === r.tagStr) break;
                    }
                }, c.prototype._decodeList = function(e, t, r, n) {
                    for(var i = []; !e.isEmpty();){
                        var o = this._peekTag(e, "end");
                        if (e.isError(o)) return o;
                        var a = r.decode(e, "der", n);
                        if (e.isError(a) && o) break;
                        i.push(a);
                    }
                    return i;
                }, c.prototype._decodeStr = function(e, t) {
                    if ("bitstr" === t) {
                        var r = e.readUInt8();
                        return e.isError(r) ? r : {
                            unused: r,
                            data: e.raw()
                        };
                    }
                    if ("bmpstr" === t) {
                        var n = e.raw();
                        if (n.length % 2 == 1) return e.error("Decoding of string type: bmpstr length mismatch");
                        for(var i = "", o = 0; o < n.length / 2; o++)i += String.fromCharCode(n.readUInt16BE(2 * o));
                        return i;
                    }
                    if ("numstr" === t) {
                        var a = e.raw().toString("ascii");
                        return this._isNumstr(a) ? a : e.error("Decoding of string type: numstr unsupported characters");
                    }
                    if ("octstr" === t) return e.raw();
                    if ("objDesc" === t) return e.raw();
                    if ("printstr" === t) {
                        var s = e.raw().toString("ascii");
                        return this._isPrintstr(s) ? s : e.error("Decoding of string type: printstr unsupported characters");
                    }
                    return /str$/.test(t) ? e.raw().toString() : e.error("Decoding of string type: " + t + " unsupported");
                }, c.prototype._decodeObjid = function(e, t, r) {
                    for(var n, i = [], o = 0, a = 0; !e.isEmpty();)o <<= 7, o |= 127 & (a = e.readUInt8()), 0 == (128 & a) && (i.push(o), o = 0);
                    128 & a && i.push(o);
                    var s = i[0] / 40 | 0, u = i[0] % 40;
                    if (n = r ? i : [
                        s,
                        u
                    ].concat(i.slice(1)), t) {
                        var c = t[n.join(" ")];
                        void 0 === c && (c = t[n.join(".")]), void 0 !== c && (n = c);
                    }
                    return n;
                }, c.prototype._decodeTime = function(e, t) {
                    var r, n, i, o, a, s, u = e.raw().toString();
                    if ("gentime" === t) r = 0 | u.slice(0, 4), n = 0 | u.slice(4, 6), i = 0 | u.slice(6, 8), o = 0 | u.slice(8, 10), a = 0 | u.slice(10, 12), s = 0 | u.slice(12, 14);
                    else {
                        if ("utctime" !== t) return e.error("Decoding " + t + " time is not supported yet");
                        r = 0 | u.slice(0, 2), n = 0 | u.slice(2, 4), i = 0 | u.slice(4, 6), o = 0 | u.slice(6, 8), a = 0 | u.slice(8, 10), s = 0 | u.slice(10, 12), r = r < 70 ? 2e3 + r : 1900 + r;
                    }
                    return Date.UTC(r, n - 1, i, o, a, s, 0);
                }, c.prototype._decodeNull = function() {
                    return null;
                }, c.prototype._decodeBool = function(e) {
                    var t = e.readUInt8();
                    return e.isError(t) ? t : 0 !== t;
                }, c.prototype._decodeInt = function(e, t) {
                    var r = e.raw(), n = new i(r);
                    return t && (n = t[n.toString(10)] || n), n;
                }, c.prototype._use = function(e, t) {
                    return "function" == typeof e && (e = e(t)), e._getDecoder("der").tree;
                };
            },
            61500: (e, t, r)=>{
                "use strict";
                var n = t;
                n.der = r(92387), n.pem = r(50529);
            },
            50529: (e, t, r)=>{
                "use strict";
                var n = r(41736), i = r(11755).Buffer, o = r(92387);
                function a(e) {
                    o.call(this, e), this.enc = "pem";
                }
                n(a, o), e.exports = a, a.prototype.decode = function(e, t) {
                    for(var r = e.toString().split(/[\r\n]+/g), n = t.label.toUpperCase(), a = /^-----(BEGIN|END) ([^-]+)-----$/, s = -1, u = -1, c = 0; c < r.length; c++){
                        var f = r[c].match(a);
                        if (null !== f && f[2] === n) {
                            if (-1 !== s) {
                                if ("END" !== f[1]) break;
                                u = c;
                                break;
                            }
                            if ("BEGIN" !== f[1]) break;
                            s = c;
                        }
                    }
                    if (-1 === s || -1 === u) throw new Error("PEM section not found for: " + n);
                    var d = r.slice(s + 1, u).join("");
                    d.replace(/[^a-z0-9+/=]+/gi, "");
                    var l = i.from(d, "base64");
                    return o.prototype.decode.call(this, l, t);
                };
            },
            11068: (e, t, r)=>{
                "use strict";
                var n = r(41736), i = r(11755).Buffer, o = r(51371), a = r(6520);
                function s(e) {
                    this.enc = "der", this.name = e.name, this.entity = e, this.tree = new u, this.tree._init(e.body);
                }
                function u(e) {
                    o.call(this, "der", e);
                }
                function c(e) {
                    return e < 10 ? "0" + e : e;
                }
                e.exports = s, s.prototype.encode = function(e, t) {
                    return this.tree._encode(e, t).join();
                }, n(u, o), u.prototype._encodeComposite = function(e, t, r, n) {
                    var o = function(e, t, r, n) {
                        var i;
                        if ("seqof" === e ? e = "seq" : "setof" === e && (e = "set"), a.tagByName.hasOwnProperty(e)) i = a.tagByName[e];
                        else {
                            if ("number" != typeof e || (0 | e) !== e) return n.error("Unknown tag: " + e);
                            i = e;
                        }
                        return i >= 31 ? n.error("Multi-octet tag encoding unsupported") : (t || (i |= 32), i |= a.tagClassByName[r || "universal"] << 6);
                    }(e, t, r, this.reporter);
                    if (n.length < 128) {
                        var s = i.alloc(2);
                        return s[0] = o, s[1] = n.length, this._createEncoderBuffer([
                            s,
                            n
                        ]);
                    }
                    for(var u = 1, c = n.length; c >= 256; c >>= 8)u++;
                    var f = i.alloc(2 + u);
                    f[0] = o, f[1] = 128 | u;
                    for(var d = 1 + u, l = n.length; l > 0; d--, l >>= 8)f[d] = 255 & l;
                    return this._createEncoderBuffer([
                        f,
                        n
                    ]);
                }, u.prototype._encodeStr = function(e, t) {
                    if ("bitstr" === t) return this._createEncoderBuffer([
                        0 | e.unused,
                        e.data
                    ]);
                    if ("bmpstr" === t) {
                        for(var r = i.alloc(2 * e.length), n = 0; n < e.length; n++)r.writeUInt16BE(e.charCodeAt(n), 2 * n);
                        return this._createEncoderBuffer(r);
                    }
                    return "numstr" === t ? this._isNumstr(e) ? this._createEncoderBuffer(e) : this.reporter.error("Encoding of string type: numstr supports only digits and space") : "printstr" === t ? this._isPrintstr(e) ? this._createEncoderBuffer(e) : this.reporter.error("Encoding of string type: printstr supports only latin upper and lower case letters, digits, space, apostrophe, left and rigth parenthesis, plus sign, comma, hyphen, dot, slash, colon, equal sign, question mark") : /str$/.test(t) || "objDesc" === t ? this._createEncoderBuffer(e) : this.reporter.error("Encoding of string type: " + t + " unsupported");
                }, u.prototype._encodeObjid = function(e, t, r) {
                    if ("string" == typeof e) {
                        if (!t) return this.reporter.error("string objid given, but no values map found");
                        if (!t.hasOwnProperty(e)) return this.reporter.error("objid not found in values map");
                        e = t[e].split(/[\s.]+/g);
                        for(var n = 0; n < e.length; n++)e[n] |= 0;
                    } else if (Array.isArray(e)) {
                        e = e.slice();
                        for(var o = 0; o < e.length; o++)e[o] |= 0;
                    }
                    if (!Array.isArray(e)) return this.reporter.error("objid() should be either array or string, got: " + JSON.stringify(e));
                    if (!r) {
                        if (e[1] >= 40) return this.reporter.error("Second objid identifier OOB");
                        e.splice(0, 2, 40 * e[0] + e[1]);
                    }
                    for(var a = 0, s = 0; s < e.length; s++){
                        var u = e[s];
                        for(a++; u >= 128; u >>= 7)a++;
                    }
                    for(var c = i.alloc(a), f = c.length - 1, d = e.length - 1; d >= 0; d--){
                        var l = e[d];
                        for(c[f--] = 127 & l; (l >>= 7) > 0;)c[f--] = 128 | 127 & l;
                    }
                    return this._createEncoderBuffer(c);
                }, u.prototype._encodeTime = function(e, t) {
                    var r, n = new Date(e);
                    return "gentime" === t ? r = [
                        c(n.getUTCFullYear()),
                        c(n.getUTCMonth() + 1),
                        c(n.getUTCDate()),
                        c(n.getUTCHours()),
                        c(n.getUTCMinutes()),
                        c(n.getUTCSeconds()),
                        "Z"
                    ].join("") : "utctime" === t ? r = [
                        c(n.getUTCFullYear() % 100),
                        c(n.getUTCMonth() + 1),
                        c(n.getUTCDate()),
                        c(n.getUTCHours()),
                        c(n.getUTCMinutes()),
                        c(n.getUTCSeconds()),
                        "Z"
                    ].join("") : this.reporter.error("Encoding " + t + " time is not supported yet"), this._encodeStr(r, "octstr");
                }, u.prototype._encodeNull = function() {
                    return this._createEncoderBuffer("");
                }, u.prototype._encodeInt = function(e, t) {
                    if ("string" == typeof e) {
                        if (!t) return this.reporter.error("String int or enum given, but no values map");
                        if (!t.hasOwnProperty(e)) return this.reporter.error("Values map doesn't contain: " + JSON.stringify(e));
                        e = t[e];
                    }
                    if ("number" != typeof e && !i.isBuffer(e)) {
                        var r = e.toArray();
                        !e.sign && 128 & r[0] && r.unshift(0), e = i.from(r);
                    }
                    if (i.isBuffer(e)) {
                        var n = e.length;
                        0 === e.length && n++;
                        var o = i.alloc(n);
                        return e.copy(o), 0 === e.length && (o[0] = 0), this._createEncoderBuffer(o);
                    }
                    if (e < 128) return this._createEncoderBuffer(e);
                    if (e < 256) return this._createEncoderBuffer([
                        0,
                        e
                    ]);
                    for(var a = 1, s = e; s >= 256; s >>= 8)a++;
                    for(var u = new Array(a), c = u.length - 1; c >= 0; c--)u[c] = 255 & e, e >>= 8;
                    return 128 & u[0] && u.unshift(0), this._createEncoderBuffer(i.from(u));
                }, u.prototype._encodeBool = function(e) {
                    return this._createEncoderBuffer(e ? 255 : 0);
                }, u.prototype._use = function(e, t) {
                    return "function" == typeof e && (e = e(t)), e._getEncoder("der").tree;
                }, u.prototype._skipDefault = function(e, t, r) {
                    var n, i = this._baseState;
                    if (null === i.default) return !1;
                    var o = e.join();
                    if (void 0 === i.defaultBuffer && (i.defaultBuffer = this._encodeValue(i.default, t, r).join()), o.length !== i.defaultBuffer.length) return !1;
                    for(n = 0; n < o.length; n++)if (o[n] !== i.defaultBuffer[n]) return !1;
                    return !0;
                };
            },
            47506: (e, t, r)=>{
                "use strict";
                var n = t;
                n.der = r(11068), n.pem = r(38520);
            },
            38520: (e, t, r)=>{
                "use strict";
                var n = r(41736), i = r(11068);
                function o(e) {
                    i.call(this, e), this.enc = "pem";
                }
                n(o, i), e.exports = o, o.prototype.encode = function(e, t) {
                    for(var r = i.prototype.encode.call(this, e).toString("base64"), n = [
                        "-----BEGIN " + t.label + "-----"
                    ], o = 0; o < r.length; o += 64)n.push(r.slice(o, o + 64));
                    return n.push("-----END " + t.label + "-----"), n.join("\n");
                };
            },
            3894: (e, t, r)=>{
                "use strict";
                var n = r(28847)(r(3355)), i = r(33103);
                function o(e, t) {
                    if (e === t) return 0;
                    for(var r = e.length, n = t.length, i = 0, o = Math.min(r, n); i < o; ++i)if (e[i] !== t[i]) {
                        r = e[i], n = t[i];
                        break;
                    }
                    return r < n ? -1 : n < r ? 1 : 0;
                }
                function a(e) {
                    return r.g.Buffer && "function" == typeof r.g.Buffer.isBuffer ? r.g.Buffer.isBuffer(e) : !(null == e || !e._isBuffer);
                }
                var s = r(69954), u = Object.prototype.hasOwnProperty, c = Array.prototype.slice, f = "foo" === (function() {}).name;
                function d(e) {
                    return Object.prototype.toString.call(e);
                }
                function l(e) {
                    return !a(e) && "function" == typeof r.g.ArrayBuffer && ("function" == typeof ArrayBuffer.isView ? ArrayBuffer.isView(e) : !!e && (e instanceof DataView || !!(e.buffer && e.buffer instanceof ArrayBuffer)));
                }
                var h = e.exports = g, p = /\s*function\s+([^\(\s]*)\s*/;
                function b(e) {
                    if (s.isFunction(e)) {
                        if (f) return e.name;
                        var t = e.toString().match(p);
                        return t && t[1];
                    }
                }
                function y(e, t) {
                    return "string" == typeof e ? e.length < t ? e : e.slice(0, t) : e;
                }
                function v(e) {
                    if (f || !s.isFunction(e)) return s.inspect(e);
                    var t = b(e);
                    return "[Function" + (t ? ": " + t : "") + "]";
                }
                function m(e, t, r, n, i) {
                    throw new h.AssertionError({
                        message: r,
                        actual: e,
                        expected: t,
                        operator: n,
                        stackStartFunction: i
                    });
                }
                function g(e, t) {
                    e || m(e, !0, t, "==", h.ok);
                }
                function w(e, t, r, i) {
                    if (e === t) return !0;
                    if (a(e) && a(t)) return 0 === o(e, t);
                    if (s.isDate(e) && s.isDate(t)) return e.getTime() === t.getTime();
                    if (s.isRegExp(e) && s.isRegExp(t)) return e.source === t.source && e.global === t.global && e.multiline === t.multiline && e.lastIndex === t.lastIndex && e.ignoreCase === t.ignoreCase;
                    if (null !== e && "object" === (0, n.default)(e) || null !== t && "object" === (0, n.default)(t)) {
                        if (l(e) && l(t) && d(e) === d(t) && !(e instanceof Float32Array || e instanceof Float64Array)) return 0 === o(new Uint8Array(e.buffer), new Uint8Array(t.buffer));
                        if (a(e) !== a(t)) return !1;
                        var u = (i = i || {
                            actual: [],
                            expected: []
                        }).actual.indexOf(e);
                        return -1 !== u && u === i.expected.indexOf(t) || (i.actual.push(e), i.expected.push(t), function(e, t, r, n) {
                            if (null == e || null == t) return !1;
                            if (s.isPrimitive(e) || s.isPrimitive(t)) return e === t;
                            if (r && Object.getPrototypeOf(e) !== Object.getPrototypeOf(t)) return !1;
                            var i = k(e), o = k(t);
                            if (i && !o || !i && o) return !1;
                            if (i) return w(e = c.call(e), t = c.call(t), r);
                            var a, u, f = E(e), d = E(t);
                            if (f.length !== d.length) return !1;
                            for(f.sort(), d.sort(), u = f.length - 1; u >= 0; u--)if (f[u] !== d[u]) return !1;
                            for(u = f.length - 1; u >= 0; u--)if (!w(e[a = f[u]], t[a], r, n)) return !1;
                            return !0;
                        }(e, t, r, i));
                    }
                    return r ? e === t : e == t;
                }
                function k(e) {
                    return "[object Arguments]" == Object.prototype.toString.call(e);
                }
                function _(e, t) {
                    if (!e || !t) return !1;
                    if ("[object RegExp]" == Object.prototype.toString.call(t)) return t.test(e);
                    try {
                        if (e instanceof t) return !0;
                    } catch (e) {}
                    return !Error.isPrototypeOf(t) && !0 === t.call({}, e);
                }
                function A(e, t, r, n) {
                    var i;
                    if ("function" != typeof t) throw new TypeError('"block" argument must be a function');
                    "string" == typeof r && (n = r, r = null), i = function(e) {
                        var t;
                        try {
                            e();
                        } catch (e) {
                            t = e;
                        }
                        return t;
                    }(t), n = (r && r.name ? " (" + r.name + ")." : ".") + (n ? " " + n : "."), e && !i && m(i, r, "Missing expected exception" + n);
                    var o = "string" == typeof n, a = !e && i && !r;
                    if ((!e && s.isError(i) && o && _(i, r) || a) && m(i, r, "Got unwanted exception" + n), e && i && r && !_(i, r) || !e && i) throw i;
                }
                h.AssertionError = function(e) {
                    this.name = "AssertionError", this.actual = e.actual, this.expected = e.expected, this.operator = e.operator, e.message ? (this.message = e.message, this.generatedMessage = !1) : (this.message = function(e) {
                        return y(v(e.actual), 128) + " " + e.operator + " " + y(v(e.expected), 128);
                    }(this), this.generatedMessage = !0);
                    var t = e.stackStartFunction || m;
                    if (Error.captureStackTrace) Error.captureStackTrace(this, t);
                    else {
                        var r = new Error;
                        if (r.stack) {
                            var n = r.stack, i = b(t), o = n.indexOf("\n" + i);
                            if (o >= 0) {
                                var a = n.indexOf("\n", o + 1);
                                n = n.substring(a + 1);
                            }
                            this.stack = n;
                        }
                    }
                }, s.inherits(h.AssertionError, Error), h.fail = m, h.ok = g, h.equal = function(e, t, r) {
                    e != t && m(e, t, r, "==", h.equal);
                }, h.notEqual = function(e, t, r) {
                    e == t && m(e, t, r, "!=", h.notEqual);
                }, h.deepEqual = function(e, t, r) {
                    w(e, t, !1) || m(e, t, r, "deepEqual", h.deepEqual);
                }, h.deepStrictEqual = function(e, t, r) {
                    w(e, t, !0) || m(e, t, r, "deepStrictEqual", h.deepStrictEqual);
                }, h.notDeepEqual = function(e, t, r) {
                    w(e, t, !1) && m(e, t, r, "notDeepEqual", h.notDeepEqual);
                }, h.notDeepStrictEqual = function e(t, r, n) {
                    w(t, r, !0) && m(t, r, n, "notDeepStrictEqual", e);
                }, h.strictEqual = function(e, t, r) {
                    e !== t && m(e, t, r, "===", h.strictEqual);
                }, h.notStrictEqual = function(e, t, r) {
                    e === t && m(e, t, r, "!==", h.notStrictEqual);
                }, h.throws = function(e, t, r) {
                    A(!0, e, t, r);
                }, h.doesNotThrow = function(e, t, r) {
                    A(!1, e, t, r);
                }, h.ifError = function(e) {
                    if (e) throw e;
                }, h.strict = i(function e(t, r) {
                    t || m(t, !0, r, "==", e);
                }, h, {
                    equal: h.strictEqual,
                    deepEqual: h.deepStrictEqual,
                    notEqual: h.notStrictEqual,
                    notDeepEqual: h.notDeepStrictEqual
                }), h.strict.strict = h.strict;
                var E = Object.keys || function(e) {
                    var t = [];
                    for(var r in e)u.call(e, r) && t.push(r);
                    return t;
                };
            },
            94074: (e)=>{
                "use strict";
                "function" == typeof Object.create ? e.exports = function(e, t) {
                    e.super_ = t, e.prototype = Object.create(t.prototype, {
                        constructor: {
                            value: e,
                            enumerable: !1,
                            writable: !0,
                            configurable: !0
                        }
                    });
                } : e.exports = function(e, t) {
                    e.super_ = t;
                    var r = function() {};
                    r.prototype = t.prototype, e.prototype = new r, e.prototype.constructor = e;
                };
            },
            86732: (e, t, r)=>{
                "use strict";
                var n = r(28847)(r(3355));
                e.exports = function(e) {
                    return e && "object" === (0, n.default)(e) && "function" == typeof e.copy && "function" == typeof e.fill && "function" == typeof e.readUInt8;
                };
            },
            69954: (e, t, r)=>{
                "use strict";
                var n = r(19142), i = r(28847)(r(3355)), o = /%[sdj%]/g;
                t.format = function(e) {
                    if (!m(e)) {
                        for(var t = [], r = 0; r < arguments.length; r++)t.push(u(arguments[r]));
                        return t.join(" ");
                    }
                    r = 1;
                    for(var n = arguments, i = n.length, a = String(e).replace(o, function(e) {
                        if ("%%" === e) return "%";
                        if (r >= i) return e;
                        switch(e){
                            case "%s":
                                return String(n[r++]);
                            case "%d":
                                return Number(n[r++]);
                            case "%j":
                                try {
                                    return JSON.stringify(n[r++]);
                                } catch (e) {
                                    return "[Circular]";
                                }
                            default:
                                return e;
                        }
                    }), s = n[r]; r < i; s = n[++r])y(s) || !k(s) ? a += " " + s : a += " " + u(s);
                    return a;
                }, t.deprecate = function(e, i) {
                    if (g(r.g.process)) return function() {
                        return t.deprecate(e, i).apply(this, arguments);
                    };
                    if (!0 === n.noDeprecation) return e;
                    var o = !1;
                    return function() {
                        if (!o) {
                            if (n.throwDeprecation) throw new Error(i);
                            n.traceDeprecation ? console.trace(i) : console.error(i), o = !0;
                        }
                        return e.apply(this, arguments);
                    };
                };
                var a, s = {};
                function u(e, r) {
                    var n = {
                        seen: [],
                        stylize: f
                    };
                    return arguments.length >= 3 && (n.depth = arguments[2]), arguments.length >= 4 && (n.colors = arguments[3]), b(r) ? n.showHidden = r : r && t._extend(n, r), g(n.showHidden) && (n.showHidden = !1), g(n.depth) && (n.depth = 2), g(n.colors) && (n.colors = !1), g(n.customInspect) && (n.customInspect = !0), n.colors && (n.stylize = c), d(n, e, n.depth);
                }
                function c(e, t) {
                    var r = u.styles[t];
                    return r ? "\x1b[" + u.colors[r][0] + "m" + e + "\x1b[" + u.colors[r][1] + "m" : e;
                }
                function f(e, t) {
                    return e;
                }
                function d(e, r, n) {
                    if (e.customInspect && r && E(r.inspect) && r.inspect !== t.inspect && (!r.constructor || r.constructor.prototype !== r)) {
                        var i = r.inspect(n, e);
                        return m(i) || (i = d(e, i, n)), i;
                    }
                    var o = function(e, t) {
                        if (g(t)) return e.stylize("undefined", "undefined");
                        if (m(t)) {
                            var r = "'" + JSON.stringify(t).replace(/^"|"$/g, "").replace(/'/g, "\\'").replace(/\\"/g, '"') + "'";
                            return e.stylize(r, "string");
                        }
                        return v(t) ? e.stylize("" + t, "number") : b(t) ? e.stylize("" + t, "boolean") : y(t) ? e.stylize("null", "null") : void 0;
                    }(e, r);
                    if (o) return o;
                    var a = Object.keys(r), s = function(e) {
                        var t = {};
                        return e.forEach(function(e, r) {
                            t[e] = !0;
                        }), t;
                    }(a);
                    if (e.showHidden && (a = Object.getOwnPropertyNames(r)), A(r) && (a.indexOf("message") >= 0 || a.indexOf("description") >= 0)) return l(r);
                    if (0 === a.length) {
                        if (E(r)) {
                            var u = r.name ? ": " + r.name : "";
                            return e.stylize("[Function" + u + "]", "special");
                        }
                        if (w(r)) return e.stylize(RegExp.prototype.toString.call(r), "regexp");
                        if (_(r)) return e.stylize(Date.prototype.toString.call(r), "date");
                        if (A(r)) return l(r);
                    }
                    var c, f = "", k = !1, S = [
                        "{",
                        "}"
                    ];
                    return p(r) && (k = !0, S = [
                        "[",
                        "]"
                    ]), E(r) && (f = " [Function" + (r.name ? ": " + r.name : "") + "]"), w(r) && (f = " " + RegExp.prototype.toString.call(r)), _(r) && (f = " " + Date.prototype.toUTCString.call(r)), A(r) && (f = " " + l(r)), 0 !== a.length || k && 0 != r.length ? n < 0 ? w(r) ? e.stylize(RegExp.prototype.toString.call(r), "regexp") : e.stylize("[Object]", "special") : (e.seen.push(r), c = k ? function(e, t, r, n, i) {
                        for(var o = [], a = 0, s = t.length; a < s; ++a)O(t, String(a)) ? o.push(h(e, t, r, n, String(a), !0)) : o.push("");
                        return i.forEach(function(i) {
                            i.match(/^\d+$/) || o.push(h(e, t, r, n, i, !0));
                        }), o;
                    }(e, r, n, s, a) : a.map(function(t) {
                        return h(e, r, n, s, t, k);
                    }), e.seen.pop(), function(e, t, r) {
                        return e.reduce(function(e, t) {
                            return t.indexOf("\n"), e + t.replace(/\u001b\[\d\d?m/g, "").length + 1;
                        }, 0) > 60 ? r[0] + ("" === t ? "" : t + "\n ") + " " + e.join(",\n  ") + " " + r[1] : r[0] + t + " " + e.join(", ") + " " + r[1];
                    }(c, f, S)) : S[0] + f + S[1];
                }
                function l(e) {
                    return "[" + Error.prototype.toString.call(e) + "]";
                }
                function h(e, t, r, n, i, o) {
                    var a, s, u;
                    if ((u = Object.getOwnPropertyDescriptor(t, i) || {
                        value: t[i]
                    }).get ? s = u.set ? e.stylize("[Getter/Setter]", "special") : e.stylize("[Getter]", "special") : u.set && (s = e.stylize("[Setter]", "special")), O(n, i) || (a = "[" + i + "]"), s || (e.seen.indexOf(u.value) < 0 ? (s = y(r) ? d(e, u.value, null) : d(e, u.value, r - 1)).indexOf("\n") > -1 && (s = o ? s.split("\n").map(function(e) {
                        return "  " + e;
                    }).join("\n").substr(2) : "\n" + s.split("\n").map(function(e) {
                        return "   " + e;
                    }).join("\n")) : s = e.stylize("[Circular]", "special")), g(a)) {
                        if (o && i.match(/^\d+$/)) return s;
                        (a = JSON.stringify("" + i)).match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/) ? (a = a.substr(1, a.length - 2), a = e.stylize(a, "name")) : (a = a.replace(/'/g, "\\'").replace(/\\"/g, '"').replace(/(^"|"$)/g, "'"), a = e.stylize(a, "string"));
                    }
                    return a + ": " + s;
                }
                function p(e) {
                    return Array.isArray(e);
                }
                function b(e) {
                    return "boolean" == typeof e;
                }
                function y(e) {
                    return null === e;
                }
                function v(e) {
                    return "number" == typeof e;
                }
                function m(e) {
                    return "string" == typeof e;
                }
                function g(e) {
                    return void 0 === e;
                }
                function w(e) {
                    return k(e) && "[object RegExp]" === S(e);
                }
                function k(e) {
                    return "object" === (0, i.default)(e) && null !== e;
                }
                function _(e) {
                    return k(e) && "[object Date]" === S(e);
                }
                function A(e) {
                    return k(e) && ("[object Error]" === S(e) || e instanceof Error);
                }
                function E(e) {
                    return "function" == typeof e;
                }
                function S(e) {
                    return Object.prototype.toString.call(e);
                }
                function x(e) {
                    return e < 10 ? "0" + e.toString(10) : e.toString(10);
                }
                t.debuglog = function(e) {
                    if (g(a) && (a = n.env.NODE_DEBUG || ""), e = e.toUpperCase(), !s[e]) {
                        if (new RegExp("\\b" + e + "\\b", "i").test(a)) {
                            var r = n.pid;
                            s[e] = function() {
                                var n = t.format.apply(t, arguments);
                                console.error("%s %d: %s", e, r, n);
                            };
                        } else s[e] = function() {};
                    }
                    return s[e];
                }, t.inspect = u, u.colors = {
                    bold: [
                        1,
                        22
                    ],
                    italic: [
                        3,
                        23
                    ],
                    underline: [
                        4,
                        24
                    ],
                    inverse: [
                        7,
                        27
                    ],
                    white: [
                        37,
                        39
                    ],
                    grey: [
                        90,
                        39
                    ],
                    black: [
                        30,
                        39
                    ],
                    blue: [
                        34,
                        39
                    ],
                    cyan: [
                        36,
                        39
                    ],
                    green: [
                        32,
                        39
                    ],
                    magenta: [
                        35,
                        39
                    ],
                    red: [
                        31,
                        39
                    ],
                    yellow: [
                        33,
                        39
                    ]
                }, u.styles = {
                    special: "cyan",
                    number: "yellow",
                    boolean: "yellow",
                    undefined: "grey",
                    null: "bold",
                    string: "green",
                    date: "magenta",
                    regexp: "red"
                }, t.isArray = p, t.isBoolean = b, t.isNull = y, t.isNullOrUndefined = function(e) {
                    return null == e;
                }, t.isNumber = v, t.isString = m, t.isSymbol = function(e) {
                    return "symbol" === (0, i.default)(e);
                }, t.isUndefined = g, t.isRegExp = w, t.isObject = k, t.isDate = _, t.isError = A, t.isFunction = E, t.isPrimitive = function(e) {
                    return null === e || "boolean" == typeof e || "number" == typeof e || "string" == typeof e || "symbol" === (0, i.default)(e) || void 0 === e;
                }, t.isBuffer = r(86732);
                var B = [
                    "Jan",
                    "Feb",
                    "Mar",
                    "Apr",
                    "May",
                    "Jun",
                    "Jul",
                    "Aug",
                    "Sep",
                    "Oct",
                    "Nov",
                    "Dec"
                ];
                function O(e, t) {
                    return Object.prototype.hasOwnProperty.call(e, t);
                }
                t.log = function() {
                    var e, r;
                    console.log("%s - %s", (r = [
                        x((e = new Date).getHours()),
                        x(e.getMinutes()),
                        x(e.getSeconds())
                    ].join(":"), [
                        e.getDate(),
                        B[e.getMonth()],
                        r
                    ].join(" ")), t.format.apply(t, arguments));
                }, t.inherits = r(94074), t._extend = function(e, t) {
                    if (!t || !k(t)) return e;
                    for(var r = Object.keys(t), n = r.length; n--;)e[r[n]] = t[r[n]];
                    return e;
                };
            },
            27548: (e, t, r)=>{
                "use strict";
                var n = r(48850).Buffer;
                e.exports = function(e) {
                    if (e.length >= 255) throw new TypeError("Alphabet too long");
                    for(var t = new Uint8Array(256), r = 0; r < t.length; r++)t[r] = 255;
                    for(var i = 0; i < e.length; i++){
                        var o = e.charAt(i), a = o.charCodeAt(0);
                        if (255 !== t[a]) throw new TypeError(o + " is ambiguous");
                        t[a] = i;
                    }
                    var s = e.length, u = e.charAt(0), c = Math.log(s) / Math.log(256), f = Math.log(256) / Math.log(s);
                    function d(e) {
                        if ("string" != typeof e) throw new TypeError("Expected String");
                        if (0 === e.length) return n.alloc(0);
                        for(var r = 0, i = 0, o = 0; e[r] === u;)i++, r++;
                        for(var a = (e.length - r) * c + 1 >>> 0, f = new Uint8Array(a); e[r];){
                            var d = t[e.charCodeAt(r)];
                            if (255 === d) return;
                            for(var l = 0, h = a - 1; (0 !== d || l < o) && -1 !== h; h--, l++)d += s * f[h] >>> 0, f[h] = d % 256 >>> 0, d = d / 256 >>> 0;
                            if (0 !== d) throw new Error("Non-zero carry");
                            o = l, r++;
                        }
                        for(var p = a - o; p !== a && 0 === f[p];)p++;
                        var b = n.allocUnsafe(i + (a - p));
                        b.fill(0, 0, i);
                        for(var y = i; p !== a;)b[y++] = f[p++];
                        return b;
                    }
                    return {
                        encode: function(t) {
                            if ((Array.isArray(t) || t instanceof Uint8Array) && (t = n.from(t)), !n.isBuffer(t)) throw new TypeError("Expected Buffer");
                            if (0 === t.length) return "";
                            for(var r = 0, i = 0, o = 0, a = t.length; o !== a && 0 === t[o];)o++, r++;
                            for(var c = (a - o) * f + 1 >>> 0, d = new Uint8Array(c); o !== a;){
                                for(var l = t[o], h = 0, p = c - 1; (0 !== l || h < i) && -1 !== p; p--, h++)l += 256 * d[p] >>> 0, d[p] = l % s >>> 0, l = l / s >>> 0;
                                if (0 !== l) throw new Error("Non-zero carry");
                                i = h, o++;
                            }
                            for(var b = c - i; b !== c && 0 === d[b];)b++;
                            for(var y = u.repeat(r); b < c; ++b)y += e.charAt(d[b]);
                            return y;
                        },
                        decodeUnsafe: d,
                        decode: function(e) {
                            var t = d(e);
                            if (t) return t;
                            throw new Error("Non-base" + s + " character");
                        }
                    };
                };
            },
            34919: (e, t)=>{
                "use strict";
                t.byteLength = function(e) {
                    var t = u(e), r = t[0], n = t[1];
                    return 3 * (r + n) / 4 - n;
                }, t.toByteArray = function(e) {
                    var t, r, o = u(e), a = o[0], s = o[1], c = new i(function(e, t, r) {
                        return 3 * (t + r) / 4 - r;
                    }(0, a, s)), f = 0, d = s > 0 ? a - 4 : a;
                    for(r = 0; r < d; r += 4)t = n[e.charCodeAt(r)] << 18 | n[e.charCodeAt(r + 1)] << 12 | n[e.charCodeAt(r + 2)] << 6 | n[e.charCodeAt(r + 3)], c[f++] = t >> 16 & 255, c[f++] = t >> 8 & 255, c[f++] = 255 & t;
                    return 2 === s && (t = n[e.charCodeAt(r)] << 2 | n[e.charCodeAt(r + 1)] >> 4, c[f++] = 255 & t), 1 === s && (t = n[e.charCodeAt(r)] << 10 | n[e.charCodeAt(r + 1)] << 4 | n[e.charCodeAt(r + 2)] >> 2, c[f++] = t >> 8 & 255, c[f++] = 255 & t), c;
                }, t.fromByteArray = function(e) {
                    for(var t, n = e.length, i = n % 3, o = [], a = 16383, s = 0, u = n - i; s < u; s += a)o.push(c(e, s, s + a > u ? u : s + a));
                    return 1 === i ? (t = e[n - 1], o.push(r[t >> 2] + r[t << 4 & 63] + "==")) : 2 === i && (t = (e[n - 2] << 8) + e[n - 1], o.push(r[t >> 10] + r[t >> 4 & 63] + r[t << 2 & 63] + "=")), o.join("");
                };
                for(var r = [], n = [], i = "undefined" != typeof Uint8Array ? Uint8Array : Array, o = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", a = 0, s = o.length; a < s; ++a)r[a] = o[a], n[o.charCodeAt(a)] = a;
                function u(e) {
                    var t = e.length;
                    if (t % 4 > 0) throw new Error("Invalid string. Length must be a multiple of 4");
                    var r = e.indexOf("=");
                    return -1 === r && (r = t), [
                        r,
                        r === t ? 0 : 4 - r % 4
                    ];
                }
                function c(e, t, n) {
                    for(var i, o, a = [], s = t; s < n; s += 3)i = (e[s] << 16 & 16711680) + (e[s + 1] << 8 & 65280) + (255 & e[s + 2]), a.push(r[(o = i) >> 18 & 63] + r[o >> 12 & 63] + r[o >> 6 & 63] + r[63 & o]);
                    return a.join("");
                }
                n["-".charCodeAt(0)] = 62, n["_".charCodeAt(0)] = 63;
            },
            31734: (e, t, r)=>{
                "use strict";
                e = r.nmd(e);
                var n = r(28847)(r(3355));
                !function(e, t) {
                    function i(e, t) {
                        if (!e) throw new Error(t || "Assertion failed");
                    }
                    function o(e, t) {
                        e.super_ = t;
                        var r = function() {};
                        r.prototype = t.prototype, e.prototype = new r, e.prototype.constructor = e;
                    }
                    function a(e, t, r) {
                        if (a.isBN(e)) return e;
                        this.negative = 0, this.words = null, this.length = 0, this.red = null, null !== e && ("le" !== t && "be" !== t || (r = t, t = 10), this._init(e || 0, t || 10, r || "be"));
                    }
                    var s;
                    "object" === (0, n.default)(e) ? e.exports = a : (void 0).BN = a, a.BN = a, a.wordSize = 26;
                    try {
                        s = "undefined" != typeof window && void 0 !== window.Buffer ? window.Buffer : r(29033).Buffer;
                    } catch (e) {}
                    function u(e, t) {
                        var r = e.charCodeAt(t);
                        return r >= 48 && r <= 57 ? r - 48 : r >= 65 && r <= 70 ? r - 55 : r >= 97 && r <= 102 ? r - 87 : void i(!1, "Invalid character in " + e);
                    }
                    function c(e, t, r) {
                        var n = u(e, r);
                        return r - 1 >= t && (n |= u(e, r - 1) << 4), n;
                    }
                    function f(e, t, r, n) {
                        for(var o = 0, a = 0, s = Math.min(e.length, r), u = t; u < s; u++){
                            var c = e.charCodeAt(u) - 48;
                            o *= n, a = c >= 49 ? c - 49 + 10 : c >= 17 ? c - 17 + 10 : c, i(c >= 0 && a < n, "Invalid character"), o += a;
                        }
                        return o;
                    }
                    function d(e, t) {
                        e.words = t.words, e.length = t.length, e.negative = t.negative, e.red = t.red;
                    }
                    if (a.isBN = function(e) {
                        return e instanceof a || null !== e && "object" === (0, n.default)(e) && e.constructor.wordSize === a.wordSize && Array.isArray(e.words);
                    }, a.max = function(e, t) {
                        return e.cmp(t) > 0 ? e : t;
                    }, a.min = function(e, t) {
                        return e.cmp(t) < 0 ? e : t;
                    }, a.prototype._init = function(e, t, r) {
                        if ("number" == typeof e) return this._initNumber(e, t, r);
                        if ("object" === (0, n.default)(e)) return this._initArray(e, t, r);
                        "hex" === t && (t = 16), i(t === (0 | t) && t >= 2 && t <= 36);
                        var o = 0;
                        "-" === (e = e.toString().replace(/\s+/g, ""))[0] && (o++, this.negative = 1), o < e.length && (16 === t ? this._parseHex(e, o, r) : (this._parseBase(e, t, o), "le" === r && this._initArray(this.toArray(), t, r)));
                    }, a.prototype._initNumber = function(e, t, r) {
                        e < 0 && (this.negative = 1, e = -e), e < 67108864 ? (this.words = [
                            67108863 & e
                        ], this.length = 1) : e < 4503599627370496 ? (this.words = [
                            67108863 & e,
                            e / 67108864 & 67108863
                        ], this.length = 2) : (i(e < 9007199254740992), this.words = [
                            67108863 & e,
                            e / 67108864 & 67108863,
                            1
                        ], this.length = 3), "le" === r && this._initArray(this.toArray(), t, r);
                    }, a.prototype._initArray = function(e, t, r) {
                        if (i("number" == typeof e.length), e.length <= 0) return this.words = [
                            0
                        ], this.length = 1, this;
                        this.length = Math.ceil(e.length / 3), this.words = new Array(this.length);
                        for(var n = 0; n < this.length; n++)this.words[n] = 0;
                        var o, a, s = 0;
                        if ("be" === r) for(n = e.length - 1, o = 0; n >= 0; n -= 3)a = e[n] | e[n - 1] << 8 | e[n - 2] << 16, this.words[o] |= a << s & 67108863, this.words[o + 1] = a >>> 26 - s & 67108863, (s += 24) >= 26 && (s -= 26, o++);
                        else if ("le" === r) for(n = 0, o = 0; n < e.length; n += 3)a = e[n] | e[n + 1] << 8 | e[n + 2] << 16, this.words[o] |= a << s & 67108863, this.words[o + 1] = a >>> 26 - s & 67108863, (s += 24) >= 26 && (s -= 26, o++);
                        return this._strip();
                    }, a.prototype._parseHex = function(e, t, r) {
                        this.length = Math.ceil((e.length - t) / 6), this.words = new Array(this.length);
                        for(var n = 0; n < this.length; n++)this.words[n] = 0;
                        var i, o = 0, a = 0;
                        if ("be" === r) for(n = e.length - 1; n >= t; n -= 2)i = c(e, t, n) << o, this.words[a] |= 67108863 & i, o >= 18 ? (o -= 18, a += 1, this.words[a] |= i >>> 26) : o += 8;
                        else for(n = (e.length - t) % 2 == 0 ? t + 1 : t; n < e.length; n += 2)i = c(e, t, n) << o, this.words[a] |= 67108863 & i, o >= 18 ? (o -= 18, a += 1, this.words[a] |= i >>> 26) : o += 8;
                        this._strip();
                    }, a.prototype._parseBase = function(e, t, r) {
                        this.words = [
                            0
                        ], this.length = 1;
                        for(var n = 0, i = 1; i <= 67108863; i *= t)n++;
                        n--, i = i / t | 0;
                        for(var o = e.length - r, a = o % n, s = Math.min(o, o - a) + r, u = 0, c = r; c < s; c += n)u = f(e, c, c + n, t), this.imuln(i), this.words[0] + u < 67108864 ? this.words[0] += u : this._iaddn(u);
                        if (0 !== a) {
                            var d = 1;
                            for(u = f(e, c, e.length, t), c = 0; c < a; c++)d *= t;
                            this.imuln(d), this.words[0] + u < 67108864 ? this.words[0] += u : this._iaddn(u);
                        }
                        this._strip();
                    }, a.prototype.copy = function(e) {
                        e.words = new Array(this.length);
                        for(var t = 0; t < this.length; t++)e.words[t] = this.words[t];
                        e.length = this.length, e.negative = this.negative, e.red = this.red;
                    }, a.prototype._move = function(e) {
                        d(e, this);
                    }, a.prototype.clone = function() {
                        var e = new a(null);
                        return this.copy(e), e;
                    }, a.prototype._expand = function(e) {
                        for(; this.length < e;)this.words[this.length++] = 0;
                        return this;
                    }, a.prototype._strip = function() {
                        for(; this.length > 1 && 0 === this.words[this.length - 1];)this.length--;
                        return this._normSign();
                    }, a.prototype._normSign = function() {
                        return 1 === this.length && 0 === this.words[0] && (this.negative = 0), this;
                    }, "undefined" != typeof Symbol && "function" == typeof Symbol.for) try {
                        a.prototype[Symbol.for("nodejs.util.inspect.custom")] = l;
                    } catch (e) {
                        a.prototype.inspect = l;
                    }
                    else a.prototype.inspect = l;
                    function l() {
                        return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
                    }
                    var h = [
                        "",
                        "0",
                        "00",
                        "000",
                        "0000",
                        "00000",
                        "000000",
                        "0000000",
                        "00000000",
                        "000000000",
                        "0000000000",
                        "00000000000",
                        "000000000000",
                        "0000000000000",
                        "00000000000000",
                        "000000000000000",
                        "0000000000000000",
                        "00000000000000000",
                        "000000000000000000",
                        "0000000000000000000",
                        "00000000000000000000",
                        "000000000000000000000",
                        "0000000000000000000000",
                        "00000000000000000000000",
                        "000000000000000000000000",
                        "0000000000000000000000000"
                    ], p = [
                        0,
                        0,
                        25,
                        16,
                        12,
                        11,
                        10,
                        9,
                        8,
                        8,
                        7,
                        7,
                        7,
                        7,
                        6,
                        6,
                        6,
                        6,
                        6,
                        6,
                        6,
                        5,
                        5,
                        5,
                        5,
                        5,
                        5,
                        5,
                        5,
                        5,
                        5,
                        5,
                        5,
                        5,
                        5,
                        5,
                        5
                    ], b = [
                        0,
                        0,
                        33554432,
                        43046721,
                        16777216,
                        48828125,
                        60466176,
                        40353607,
                        16777216,
                        43046721,
                        1e7,
                        19487171,
                        35831808,
                        62748517,
                        7529536,
                        11390625,
                        16777216,
                        24137569,
                        34012224,
                        47045881,
                        64e6,
                        4084101,
                        5153632,
                        6436343,
                        7962624,
                        9765625,
                        11881376,
                        14348907,
                        17210368,
                        20511149,
                        243e5,
                        28629151,
                        33554432,
                        39135393,
                        45435424,
                        52521875,
                        60466176
                    ];
                    function y(e, t, r) {
                        r.negative = t.negative ^ e.negative;
                        var n = e.length + t.length | 0;
                        r.length = n, n = n - 1 | 0;
                        var i = 0 | e.words[0], o = 0 | t.words[0], a = i * o, s = 67108863 & a, u = a / 67108864 | 0;
                        r.words[0] = s;
                        for(var c = 1; c < n; c++){
                            for(var f = u >>> 26, d = 67108863 & u, l = Math.min(c, t.length - 1), h = Math.max(0, c - e.length + 1); h <= l; h++){
                                var p = c - h | 0;
                                f += (a = (i = 0 | e.words[p]) * (o = 0 | t.words[h]) + d) / 67108864 | 0, d = 67108863 & a;
                            }
                            r.words[c] = 0 | d, u = 0 | f;
                        }
                        return 0 !== u ? r.words[c] = 0 | u : r.length--, r._strip();
                    }
                    a.prototype.toString = function(e, t) {
                        var r;
                        if (t = 0 | t || 1, 16 === (e = e || 10) || "hex" === e) {
                            r = "";
                            for(var n = 0, o = 0, a = 0; a < this.length; a++){
                                var s = this.words[a], u = (16777215 & (s << n | o)).toString(16);
                                o = s >>> 24 - n & 16777215, (n += 2) >= 26 && (n -= 26, a--), r = 0 !== o || a !== this.length - 1 ? h[6 - u.length] + u + r : u + r;
                            }
                            for(0 !== o && (r = o.toString(16) + r); r.length % t != 0;)r = "0" + r;
                            return 0 !== this.negative && (r = "-" + r), r;
                        }
                        if (e === (0 | e) && e >= 2 && e <= 36) {
                            var c = p[e], f = b[e];
                            r = "";
                            var d = this.clone();
                            for(d.negative = 0; !d.isZero();){
                                var l = d.modrn(f).toString(e);
                                r = (d = d.idivn(f)).isZero() ? l + r : h[c - l.length] + l + r;
                            }
                            for(this.isZero() && (r = "0" + r); r.length % t != 0;)r = "0" + r;
                            return 0 !== this.negative && (r = "-" + r), r;
                        }
                        i(!1, "Base should be between 2 and 36");
                    }, a.prototype.toNumber = function() {
                        var e = this.words[0];
                        return 2 === this.length ? e += 67108864 * this.words[1] : 3 === this.length && 1 === this.words[2] ? e += 4503599627370496 + 67108864 * this.words[1] : this.length > 2 && i(!1, "Number can only safely store up to 53 bits"), 0 !== this.negative ? -e : e;
                    }, a.prototype.toJSON = function() {
                        return this.toString(16, 2);
                    }, s && (a.prototype.toBuffer = function(e, t) {
                        return this.toArrayLike(s, e, t);
                    }), a.prototype.toArray = function(e, t) {
                        return this.toArrayLike(Array, e, t);
                    }, a.prototype.toArrayLike = function(e, t, r) {
                        this._strip();
                        var n = this.byteLength(), o = r || Math.max(1, n);
                        i(n <= o, "byte array longer than desired length"), i(o > 0, "Requested array length <= 0");
                        var a = function(e, t) {
                            return e.allocUnsafe ? e.allocUnsafe(t) : new e(t);
                        }(e, o);
                        return this["_toArrayLike" + ("le" === t ? "LE" : "BE")](a, n), a;
                    }, a.prototype._toArrayLikeLE = function(e, t) {
                        for(var r = 0, n = 0, i = 0, o = 0; i < this.length; i++){
                            var a = this.words[i] << o | n;
                            e[r++] = 255 & a, r < e.length && (e[r++] = a >> 8 & 255), r < e.length && (e[r++] = a >> 16 & 255), 6 === o ? (r < e.length && (e[r++] = a >> 24 & 255), n = 0, o = 0) : (n = a >>> 24, o += 2);
                        }
                        if (r < e.length) for(e[r++] = n; r < e.length;)e[r++] = 0;
                    }, a.prototype._toArrayLikeBE = function(e, t) {
                        for(var r = e.length - 1, n = 0, i = 0, o = 0; i < this.length; i++){
                            var a = this.words[i] << o | n;
                            e[r--] = 255 & a, r >= 0 && (e[r--] = a >> 8 & 255), r >= 0 && (e[r--] = a >> 16 & 255), 6 === o ? (r >= 0 && (e[r--] = a >> 24 & 255), n = 0, o = 0) : (n = a >>> 24, o += 2);
                        }
                        if (r >= 0) for(e[r--] = n; r >= 0;)e[r--] = 0;
                    }, Math.clz32 ? a.prototype._countBits = function(e) {
                        return 32 - Math.clz32(e);
                    } : a.prototype._countBits = function(e) {
                        var t = e, r = 0;
                        return t >= 4096 && (r += 13, t >>>= 13), t >= 64 && (r += 7, t >>>= 7), t >= 8 && (r += 4, t >>>= 4), t >= 2 && (r += 2, t >>>= 2), r + t;
                    }, a.prototype._zeroBits = function(e) {
                        if (0 === e) return 26;
                        var t = e, r = 0;
                        return 0 == (8191 & t) && (r += 13, t >>>= 13), 0 == (127 & t) && (r += 7, t >>>= 7), 0 == (15 & t) && (r += 4, t >>>= 4), 0 == (3 & t) && (r += 2, t >>>= 2), 0 == (1 & t) && r++, r;
                    }, a.prototype.bitLength = function() {
                        var e = this.words[this.length - 1], t = this._countBits(e);
                        return 26 * (this.length - 1) + t;
                    }, a.prototype.zeroBits = function() {
                        if (this.isZero()) return 0;
                        for(var e = 0, t = 0; t < this.length; t++){
                            var r = this._zeroBits(this.words[t]);
                            if (e += r, 26 !== r) break;
                        }
                        return e;
                    }, a.prototype.byteLength = function() {
                        return Math.ceil(this.bitLength() / 8);
                    }, a.prototype.toTwos = function(e) {
                        return 0 !== this.negative ? this.abs().inotn(e).iaddn(1) : this.clone();
                    }, a.prototype.fromTwos = function(e) {
                        return this.testn(e - 1) ? this.notn(e).iaddn(1).ineg() : this.clone();
                    }, a.prototype.isNeg = function() {
                        return 0 !== this.negative;
                    }, a.prototype.neg = function() {
                        return this.clone().ineg();
                    }, a.prototype.ineg = function() {
                        return this.isZero() || (this.negative ^= 1), this;
                    }, a.prototype.iuor = function(e) {
                        for(; this.length < e.length;)this.words[this.length++] = 0;
                        for(var t = 0; t < e.length; t++)this.words[t] = this.words[t] | e.words[t];
                        return this._strip();
                    }, a.prototype.ior = function(e) {
                        return i(0 == (this.negative | e.negative)), this.iuor(e);
                    }, a.prototype.or = function(e) {
                        return this.length > e.length ? this.clone().ior(e) : e.clone().ior(this);
                    }, a.prototype.uor = function(e) {
                        return this.length > e.length ? this.clone().iuor(e) : e.clone().iuor(this);
                    }, a.prototype.iuand = function(e) {
                        var t;
                        t = this.length > e.length ? e : this;
                        for(var r = 0; r < t.length; r++)this.words[r] = this.words[r] & e.words[r];
                        return this.length = t.length, this._strip();
                    }, a.prototype.iand = function(e) {
                        return i(0 == (this.negative | e.negative)), this.iuand(e);
                    }, a.prototype.and = function(e) {
                        return this.length > e.length ? this.clone().iand(e) : e.clone().iand(this);
                    }, a.prototype.uand = function(e) {
                        return this.length > e.length ? this.clone().iuand(e) : e.clone().iuand(this);
                    }, a.prototype.iuxor = function(e) {
                        var t, r;
                        this.length > e.length ? (t = this, r = e) : (t = e, r = this);
                        for(var n = 0; n < r.length; n++)this.words[n] = t.words[n] ^ r.words[n];
                        if (this !== t) for(; n < t.length; n++)this.words[n] = t.words[n];
                        return this.length = t.length, this._strip();
                    }, a.prototype.ixor = function(e) {
                        return i(0 == (this.negative | e.negative)), this.iuxor(e);
                    }, a.prototype.xor = function(e) {
                        return this.length > e.length ? this.clone().ixor(e) : e.clone().ixor(this);
                    }, a.prototype.uxor = function(e) {
                        return this.length > e.length ? this.clone().iuxor(e) : e.clone().iuxor(this);
                    }, a.prototype.inotn = function(e) {
                        i("number" == typeof e && e >= 0);
                        var t = 0 | Math.ceil(e / 26), r = e % 26;
                        this._expand(t), r > 0 && t--;
                        for(var n = 0; n < t; n++)this.words[n] = 67108863 & ~this.words[n];
                        return r > 0 && (this.words[n] = ~this.words[n] & 67108863 >> 26 - r), this._strip();
                    }, a.prototype.notn = function(e) {
                        return this.clone().inotn(e);
                    }, a.prototype.setn = function(e, t) {
                        i("number" == typeof e && e >= 0);
                        var r = e / 26 | 0, n = e % 26;
                        return this._expand(r + 1), this.words[r] = t ? this.words[r] | 1 << n : this.words[r] & ~(1 << n), this._strip();
                    }, a.prototype.iadd = function(e) {
                        var t, r, n;
                        if (0 !== this.negative && 0 === e.negative) return this.negative = 0, t = this.isub(e), this.negative ^= 1, this._normSign();
                        if (0 === this.negative && 0 !== e.negative) return e.negative = 0, t = this.isub(e), e.negative = 1, t._normSign();
                        this.length > e.length ? (r = this, n = e) : (r = e, n = this);
                        for(var i = 0, o = 0; o < n.length; o++)t = (0 | r.words[o]) + (0 | n.words[o]) + i, this.words[o] = 67108863 & t, i = t >>> 26;
                        for(; 0 !== i && o < r.length; o++)t = (0 | r.words[o]) + i, this.words[o] = 67108863 & t, i = t >>> 26;
                        if (this.length = r.length, 0 !== i) this.words[this.length] = i, this.length++;
                        else if (r !== this) for(; o < r.length; o++)this.words[o] = r.words[o];
                        return this;
                    }, a.prototype.add = function(e) {
                        var t;
                        return 0 !== e.negative && 0 === this.negative ? (e.negative = 0, t = this.sub(e), e.negative ^= 1, t) : 0 === e.negative && 0 !== this.negative ? (this.negative = 0, t = e.sub(this), this.negative = 1, t) : this.length > e.length ? this.clone().iadd(e) : e.clone().iadd(this);
                    }, a.prototype.isub = function(e) {
                        if (0 !== e.negative) {
                            e.negative = 0;
                            var t = this.iadd(e);
                            return e.negative = 1, t._normSign();
                        }
                        if (0 !== this.negative) return this.negative = 0, this.iadd(e), this.negative = 1, this._normSign();
                        var r, n, i = this.cmp(e);
                        if (0 === i) return this.negative = 0, this.length = 1, this.words[0] = 0, this;
                        i > 0 ? (r = this, n = e) : (r = e, n = this);
                        for(var o = 0, a = 0; a < n.length; a++)o = (t = (0 | r.words[a]) - (0 | n.words[a]) + o) >> 26, this.words[a] = 67108863 & t;
                        for(; 0 !== o && a < r.length; a++)o = (t = (0 | r.words[a]) + o) >> 26, this.words[a] = 67108863 & t;
                        if (0 === o && a < r.length && r !== this) for(; a < r.length; a++)this.words[a] = r.words[a];
                        return this.length = Math.max(this.length, a), r !== this && (this.negative = 1), this._strip();
                    }, a.prototype.sub = function(e) {
                        return this.clone().isub(e);
                    };
                    var v = function(e, t, r) {
                        var n, i, o, a = e.words, s = t.words, u = r.words, c = 0, f = 0 | a[0], d = 8191 & f, l = f >>> 13, h = 0 | a[1], p = 8191 & h, b = h >>> 13, y = 0 | a[2], v = 8191 & y, m = y >>> 13, g = 0 | a[3], w = 8191 & g, k = g >>> 13, _ = 0 | a[4], A = 8191 & _, E = _ >>> 13, S = 0 | a[5], x = 8191 & S, B = S >>> 13, O = 0 | a[6], P = 8191 & O, I = O >>> 13, T = 0 | a[7], C = 8191 & T, M = T >>> 13, R = 0 | a[8], U = 8191 & R, N = R >>> 13, j = 0 | a[9], L = 8191 & j, F = j >>> 13, D = 0 | s[0], H = 8191 & D, z = D >>> 13, q = 0 | s[1], K = 8191 & q, G = q >>> 13, V = 0 | s[2], Z = 8191 & V, W = V >>> 13, J = 0 | s[3], Y = 8191 & J, X = J >>> 13, Q = 0 | s[4], $ = 8191 & Q, ee = Q >>> 13, te = 0 | s[5], re = 8191 & te, ne = te >>> 13, ie = 0 | s[6], oe = 8191 & ie, ae = ie >>> 13, se = 0 | s[7], ue = 8191 & se, ce = se >>> 13, fe = 0 | s[8], de = 8191 & fe, le = fe >>> 13, he = 0 | s[9], pe = 8191 & he, be = he >>> 13;
                        r.negative = e.negative ^ t.negative, r.length = 19;
                        var ye = (c + (n = Math.imul(d, H)) | 0) + ((8191 & (i = (i = Math.imul(d, z)) + Math.imul(l, H) | 0)) << 13) | 0;
                        c = ((o = Math.imul(l, z)) + (i >>> 13) | 0) + (ye >>> 26) | 0, ye &= 67108863, n = Math.imul(p, H), i = (i = Math.imul(p, z)) + Math.imul(b, H) | 0, o = Math.imul(b, z);
                        var ve = (c + (n = n + Math.imul(d, K) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(d, G) | 0) + Math.imul(l, K) | 0)) << 13) | 0;
                        c = ((o = o + Math.imul(l, G) | 0) + (i >>> 13) | 0) + (ve >>> 26) | 0, ve &= 67108863, n = Math.imul(v, H), i = (i = Math.imul(v, z)) + Math.imul(m, H) | 0, o = Math.imul(m, z), n = n + Math.imul(p, K) | 0, i = (i = i + Math.imul(p, G) | 0) + Math.imul(b, K) | 0, o = o + Math.imul(b, G) | 0;
                        var me = (c + (n = n + Math.imul(d, Z) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(d, W) | 0) + Math.imul(l, Z) | 0)) << 13) | 0;
                        c = ((o = o + Math.imul(l, W) | 0) + (i >>> 13) | 0) + (me >>> 26) | 0, me &= 67108863, n = Math.imul(w, H), i = (i = Math.imul(w, z)) + Math.imul(k, H) | 0, o = Math.imul(k, z), n = n + Math.imul(v, K) | 0, i = (i = i + Math.imul(v, G) | 0) + Math.imul(m, K) | 0, o = o + Math.imul(m, G) | 0, n = n + Math.imul(p, Z) | 0, i = (i = i + Math.imul(p, W) | 0) + Math.imul(b, Z) | 0, o = o + Math.imul(b, W) | 0;
                        var ge = (c + (n = n + Math.imul(d, Y) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(d, X) | 0) + Math.imul(l, Y) | 0)) << 13) | 0;
                        c = ((o = o + Math.imul(l, X) | 0) + (i >>> 13) | 0) + (ge >>> 26) | 0, ge &= 67108863, n = Math.imul(A, H), i = (i = Math.imul(A, z)) + Math.imul(E, H) | 0, o = Math.imul(E, z), n = n + Math.imul(w, K) | 0, i = (i = i + Math.imul(w, G) | 0) + Math.imul(k, K) | 0, o = o + Math.imul(k, G) | 0, n = n + Math.imul(v, Z) | 0, i = (i = i + Math.imul(v, W) | 0) + Math.imul(m, Z) | 0, o = o + Math.imul(m, W) | 0, n = n + Math.imul(p, Y) | 0, i = (i = i + Math.imul(p, X) | 0) + Math.imul(b, Y) | 0, o = o + Math.imul(b, X) | 0;
                        var we = (c + (n = n + Math.imul(d, $) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(d, ee) | 0) + Math.imul(l, $) | 0)) << 13) | 0;
                        c = ((o = o + Math.imul(l, ee) | 0) + (i >>> 13) | 0) + (we >>> 26) | 0, we &= 67108863, n = Math.imul(x, H), i = (i = Math.imul(x, z)) + Math.imul(B, H) | 0, o = Math.imul(B, z), n = n + Math.imul(A, K) | 0, i = (i = i + Math.imul(A, G) | 0) + Math.imul(E, K) | 0, o = o + Math.imul(E, G) | 0, n = n + Math.imul(w, Z) | 0, i = (i = i + Math.imul(w, W) | 0) + Math.imul(k, Z) | 0, o = o + Math.imul(k, W) | 0, n = n + Math.imul(v, Y) | 0, i = (i = i + Math.imul(v, X) | 0) + Math.imul(m, Y) | 0, o = o + Math.imul(m, X) | 0, n = n + Math.imul(p, $) | 0, i = (i = i + Math.imul(p, ee) | 0) + Math.imul(b, $) | 0, o = o + Math.imul(b, ee) | 0;
                        var ke = (c + (n = n + Math.imul(d, re) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(d, ne) | 0) + Math.imul(l, re) | 0)) << 13) | 0;
                        c = ((o = o + Math.imul(l, ne) | 0) + (i >>> 13) | 0) + (ke >>> 26) | 0, ke &= 67108863, n = Math.imul(P, H), i = (i = Math.imul(P, z)) + Math.imul(I, H) | 0, o = Math.imul(I, z), n = n + Math.imul(x, K) | 0, i = (i = i + Math.imul(x, G) | 0) + Math.imul(B, K) | 0, o = o + Math.imul(B, G) | 0, n = n + Math.imul(A, Z) | 0, i = (i = i + Math.imul(A, W) | 0) + Math.imul(E, Z) | 0, o = o + Math.imul(E, W) | 0, n = n + Math.imul(w, Y) | 0, i = (i = i + Math.imul(w, X) | 0) + Math.imul(k, Y) | 0, o = o + Math.imul(k, X) | 0, n = n + Math.imul(v, $) | 0, i = (i = i + Math.imul(v, ee) | 0) + Math.imul(m, $) | 0, o = o + Math.imul(m, ee) | 0, n = n + Math.imul(p, re) | 0, i = (i = i + Math.imul(p, ne) | 0) + Math.imul(b, re) | 0, o = o + Math.imul(b, ne) | 0;
                        var _e = (c + (n = n + Math.imul(d, oe) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(d, ae) | 0) + Math.imul(l, oe) | 0)) << 13) | 0;
                        c = ((o = o + Math.imul(l, ae) | 0) + (i >>> 13) | 0) + (_e >>> 26) | 0, _e &= 67108863, n = Math.imul(C, H), i = (i = Math.imul(C, z)) + Math.imul(M, H) | 0, o = Math.imul(M, z), n = n + Math.imul(P, K) | 0, i = (i = i + Math.imul(P, G) | 0) + Math.imul(I, K) | 0, o = o + Math.imul(I, G) | 0, n = n + Math.imul(x, Z) | 0, i = (i = i + Math.imul(x, W) | 0) + Math.imul(B, Z) | 0, o = o + Math.imul(B, W) | 0, n = n + Math.imul(A, Y) | 0, i = (i = i + Math.imul(A, X) | 0) + Math.imul(E, Y) | 0, o = o + Math.imul(E, X) | 0, n = n + Math.imul(w, $) | 0, i = (i = i + Math.imul(w, ee) | 0) + Math.imul(k, $) | 0, o = o + Math.imul(k, ee) | 0, n = n + Math.imul(v, re) | 0, i = (i = i + Math.imul(v, ne) | 0) + Math.imul(m, re) | 0, o = o + Math.imul(m, ne) | 0, n = n + Math.imul(p, oe) | 0, i = (i = i + Math.imul(p, ae) | 0) + Math.imul(b, oe) | 0, o = o + Math.imul(b, ae) | 0;
                        var Ae = (c + (n = n + Math.imul(d, ue) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(d, ce) | 0) + Math.imul(l, ue) | 0)) << 13) | 0;
                        c = ((o = o + Math.imul(l, ce) | 0) + (i >>> 13) | 0) + (Ae >>> 26) | 0, Ae &= 67108863, n = Math.imul(U, H), i = (i = Math.imul(U, z)) + Math.imul(N, H) | 0, o = Math.imul(N, z), n = n + Math.imul(C, K) | 0, i = (i = i + Math.imul(C, G) | 0) + Math.imul(M, K) | 0, o = o + Math.imul(M, G) | 0, n = n + Math.imul(P, Z) | 0, i = (i = i + Math.imul(P, W) | 0) + Math.imul(I, Z) | 0, o = o + Math.imul(I, W) | 0, n = n + Math.imul(x, Y) | 0, i = (i = i + Math.imul(x, X) | 0) + Math.imul(B, Y) | 0, o = o + Math.imul(B, X) | 0, n = n + Math.imul(A, $) | 0, i = (i = i + Math.imul(A, ee) | 0) + Math.imul(E, $) | 0, o = o + Math.imul(E, ee) | 0, n = n + Math.imul(w, re) | 0, i = (i = i + Math.imul(w, ne) | 0) + Math.imul(k, re) | 0, o = o + Math.imul(k, ne) | 0, n = n + Math.imul(v, oe) | 0, i = (i = i + Math.imul(v, ae) | 0) + Math.imul(m, oe) | 0, o = o + Math.imul(m, ae) | 0, n = n + Math.imul(p, ue) | 0, i = (i = i + Math.imul(p, ce) | 0) + Math.imul(b, ue) | 0, o = o + Math.imul(b, ce) | 0;
                        var Ee = (c + (n = n + Math.imul(d, de) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(d, le) | 0) + Math.imul(l, de) | 0)) << 13) | 0;
                        c = ((o = o + Math.imul(l, le) | 0) + (i >>> 13) | 0) + (Ee >>> 26) | 0, Ee &= 67108863, n = Math.imul(L, H), i = (i = Math.imul(L, z)) + Math.imul(F, H) | 0, o = Math.imul(F, z), n = n + Math.imul(U, K) | 0, i = (i = i + Math.imul(U, G) | 0) + Math.imul(N, K) | 0, o = o + Math.imul(N, G) | 0, n = n + Math.imul(C, Z) | 0, i = (i = i + Math.imul(C, W) | 0) + Math.imul(M, Z) | 0, o = o + Math.imul(M, W) | 0, n = n + Math.imul(P, Y) | 0, i = (i = i + Math.imul(P, X) | 0) + Math.imul(I, Y) | 0, o = o + Math.imul(I, X) | 0, n = n + Math.imul(x, $) | 0, i = (i = i + Math.imul(x, ee) | 0) + Math.imul(B, $) | 0, o = o + Math.imul(B, ee) | 0, n = n + Math.imul(A, re) | 0, i = (i = i + Math.imul(A, ne) | 0) + Math.imul(E, re) | 0, o = o + Math.imul(E, ne) | 0, n = n + Math.imul(w, oe) | 0, i = (i = i + Math.imul(w, ae) | 0) + Math.imul(k, oe) | 0, o = o + Math.imul(k, ae) | 0, n = n + Math.imul(v, ue) | 0, i = (i = i + Math.imul(v, ce) | 0) + Math.imul(m, ue) | 0, o = o + Math.imul(m, ce) | 0, n = n + Math.imul(p, de) | 0, i = (i = i + Math.imul(p, le) | 0) + Math.imul(b, de) | 0, o = o + Math.imul(b, le) | 0;
                        var Se = (c + (n = n + Math.imul(d, pe) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(d, be) | 0) + Math.imul(l, pe) | 0)) << 13) | 0;
                        c = ((o = o + Math.imul(l, be) | 0) + (i >>> 13) | 0) + (Se >>> 26) | 0, Se &= 67108863, n = Math.imul(L, K), i = (i = Math.imul(L, G)) + Math.imul(F, K) | 0, o = Math.imul(F, G), n = n + Math.imul(U, Z) | 0, i = (i = i + Math.imul(U, W) | 0) + Math.imul(N, Z) | 0, o = o + Math.imul(N, W) | 0, n = n + Math.imul(C, Y) | 0, i = (i = i + Math.imul(C, X) | 0) + Math.imul(M, Y) | 0, o = o + Math.imul(M, X) | 0, n = n + Math.imul(P, $) | 0, i = (i = i + Math.imul(P, ee) | 0) + Math.imul(I, $) | 0, o = o + Math.imul(I, ee) | 0, n = n + Math.imul(x, re) | 0, i = (i = i + Math.imul(x, ne) | 0) + Math.imul(B, re) | 0, o = o + Math.imul(B, ne) | 0, n = n + Math.imul(A, oe) | 0, i = (i = i + Math.imul(A, ae) | 0) + Math.imul(E, oe) | 0, o = o + Math.imul(E, ae) | 0, n = n + Math.imul(w, ue) | 0, i = (i = i + Math.imul(w, ce) | 0) + Math.imul(k, ue) | 0, o = o + Math.imul(k, ce) | 0, n = n + Math.imul(v, de) | 0, i = (i = i + Math.imul(v, le) | 0) + Math.imul(m, de) | 0, o = o + Math.imul(m, le) | 0;
                        var xe = (c + (n = n + Math.imul(p, pe) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(p, be) | 0) + Math.imul(b, pe) | 0)) << 13) | 0;
                        c = ((o = o + Math.imul(b, be) | 0) + (i >>> 13) | 0) + (xe >>> 26) | 0, xe &= 67108863, n = Math.imul(L, Z), i = (i = Math.imul(L, W)) + Math.imul(F, Z) | 0, o = Math.imul(F, W), n = n + Math.imul(U, Y) | 0, i = (i = i + Math.imul(U, X) | 0) + Math.imul(N, Y) | 0, o = o + Math.imul(N, X) | 0, n = n + Math.imul(C, $) | 0, i = (i = i + Math.imul(C, ee) | 0) + Math.imul(M, $) | 0, o = o + Math.imul(M, ee) | 0, n = n + Math.imul(P, re) | 0, i = (i = i + Math.imul(P, ne) | 0) + Math.imul(I, re) | 0, o = o + Math.imul(I, ne) | 0, n = n + Math.imul(x, oe) | 0, i = (i = i + Math.imul(x, ae) | 0) + Math.imul(B, oe) | 0, o = o + Math.imul(B, ae) | 0, n = n + Math.imul(A, ue) | 0, i = (i = i + Math.imul(A, ce) | 0) + Math.imul(E, ue) | 0, o = o + Math.imul(E, ce) | 0, n = n + Math.imul(w, de) | 0, i = (i = i + Math.imul(w, le) | 0) + Math.imul(k, de) | 0, o = o + Math.imul(k, le) | 0;
                        var Be = (c + (n = n + Math.imul(v, pe) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(v, be) | 0) + Math.imul(m, pe) | 0)) << 13) | 0;
                        c = ((o = o + Math.imul(m, be) | 0) + (i >>> 13) | 0) + (Be >>> 26) | 0, Be &= 67108863, n = Math.imul(L, Y), i = (i = Math.imul(L, X)) + Math.imul(F, Y) | 0, o = Math.imul(F, X), n = n + Math.imul(U, $) | 0, i = (i = i + Math.imul(U, ee) | 0) + Math.imul(N, $) | 0, o = o + Math.imul(N, ee) | 0, n = n + Math.imul(C, re) | 0, i = (i = i + Math.imul(C, ne) | 0) + Math.imul(M, re) | 0, o = o + Math.imul(M, ne) | 0, n = n + Math.imul(P, oe) | 0, i = (i = i + Math.imul(P, ae) | 0) + Math.imul(I, oe) | 0, o = o + Math.imul(I, ae) | 0, n = n + Math.imul(x, ue) | 0, i = (i = i + Math.imul(x, ce) | 0) + Math.imul(B, ue) | 0, o = o + Math.imul(B, ce) | 0, n = n + Math.imul(A, de) | 0, i = (i = i + Math.imul(A, le) | 0) + Math.imul(E, de) | 0, o = o + Math.imul(E, le) | 0;
                        var Oe = (c + (n = n + Math.imul(w, pe) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(w, be) | 0) + Math.imul(k, pe) | 0)) << 13) | 0;
                        c = ((o = o + Math.imul(k, be) | 0) + (i >>> 13) | 0) + (Oe >>> 26) | 0, Oe &= 67108863, n = Math.imul(L, $), i = (i = Math.imul(L, ee)) + Math.imul(F, $) | 0, o = Math.imul(F, ee), n = n + Math.imul(U, re) | 0, i = (i = i + Math.imul(U, ne) | 0) + Math.imul(N, re) | 0, o = o + Math.imul(N, ne) | 0, n = n + Math.imul(C, oe) | 0, i = (i = i + Math.imul(C, ae) | 0) + Math.imul(M, oe) | 0, o = o + Math.imul(M, ae) | 0, n = n + Math.imul(P, ue) | 0, i = (i = i + Math.imul(P, ce) | 0) + Math.imul(I, ue) | 0, o = o + Math.imul(I, ce) | 0, n = n + Math.imul(x, de) | 0, i = (i = i + Math.imul(x, le) | 0) + Math.imul(B, de) | 0, o = o + Math.imul(B, le) | 0;
                        var Pe = (c + (n = n + Math.imul(A, pe) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(A, be) | 0) + Math.imul(E, pe) | 0)) << 13) | 0;
                        c = ((o = o + Math.imul(E, be) | 0) + (i >>> 13) | 0) + (Pe >>> 26) | 0, Pe &= 67108863, n = Math.imul(L, re), i = (i = Math.imul(L, ne)) + Math.imul(F, re) | 0, o = Math.imul(F, ne), n = n + Math.imul(U, oe) | 0, i = (i = i + Math.imul(U, ae) | 0) + Math.imul(N, oe) | 0, o = o + Math.imul(N, ae) | 0, n = n + Math.imul(C, ue) | 0, i = (i = i + Math.imul(C, ce) | 0) + Math.imul(M, ue) | 0, o = o + Math.imul(M, ce) | 0, n = n + Math.imul(P, de) | 0, i = (i = i + Math.imul(P, le) | 0) + Math.imul(I, de) | 0, o = o + Math.imul(I, le) | 0;
                        var Ie = (c + (n = n + Math.imul(x, pe) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(x, be) | 0) + Math.imul(B, pe) | 0)) << 13) | 0;
                        c = ((o = o + Math.imul(B, be) | 0) + (i >>> 13) | 0) + (Ie >>> 26) | 0, Ie &= 67108863, n = Math.imul(L, oe), i = (i = Math.imul(L, ae)) + Math.imul(F, oe) | 0, o = Math.imul(F, ae), n = n + Math.imul(U, ue) | 0, i = (i = i + Math.imul(U, ce) | 0) + Math.imul(N, ue) | 0, o = o + Math.imul(N, ce) | 0, n = n + Math.imul(C, de) | 0, i = (i = i + Math.imul(C, le) | 0) + Math.imul(M, de) | 0, o = o + Math.imul(M, le) | 0;
                        var Te = (c + (n = n + Math.imul(P, pe) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(P, be) | 0) + Math.imul(I, pe) | 0)) << 13) | 0;
                        c = ((o = o + Math.imul(I, be) | 0) + (i >>> 13) | 0) + (Te >>> 26) | 0, Te &= 67108863, n = Math.imul(L, ue), i = (i = Math.imul(L, ce)) + Math.imul(F, ue) | 0, o = Math.imul(F, ce), n = n + Math.imul(U, de) | 0, i = (i = i + Math.imul(U, le) | 0) + Math.imul(N, de) | 0, o = o + Math.imul(N, le) | 0;
                        var Ce = (c + (n = n + Math.imul(C, pe) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(C, be) | 0) + Math.imul(M, pe) | 0)) << 13) | 0;
                        c = ((o = o + Math.imul(M, be) | 0) + (i >>> 13) | 0) + (Ce >>> 26) | 0, Ce &= 67108863, n = Math.imul(L, de), i = (i = Math.imul(L, le)) + Math.imul(F, de) | 0, o = Math.imul(F, le);
                        var Me = (c + (n = n + Math.imul(U, pe) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(U, be) | 0) + Math.imul(N, pe) | 0)) << 13) | 0;
                        c = ((o = o + Math.imul(N, be) | 0) + (i >>> 13) | 0) + (Me >>> 26) | 0, Me &= 67108863;
                        var Re = (c + (n = Math.imul(L, pe)) | 0) + ((8191 & (i = (i = Math.imul(L, be)) + Math.imul(F, pe) | 0)) << 13) | 0;
                        return c = ((o = Math.imul(F, be)) + (i >>> 13) | 0) + (Re >>> 26) | 0, Re &= 67108863, u[0] = ye, u[1] = ve, u[2] = me, u[3] = ge, u[4] = we, u[5] = ke, u[6] = _e, u[7] = Ae, u[8] = Ee, u[9] = Se, u[10] = xe, u[11] = Be, u[12] = Oe, u[13] = Pe, u[14] = Ie, u[15] = Te, u[16] = Ce, u[17] = Me, u[18] = Re, 0 !== c && (u[19] = c, r.length++), r;
                    };
                    function m(e, t, r) {
                        r.negative = t.negative ^ e.negative, r.length = e.length + t.length;
                        for(var n = 0, i = 0, o = 0; o < r.length - 1; o++){
                            var a = i;
                            i = 0;
                            for(var s = 67108863 & n, u = Math.min(o, t.length - 1), c = Math.max(0, o - e.length + 1); c <= u; c++){
                                var f = o - c, d = (0 | e.words[f]) * (0 | t.words[c]), l = 67108863 & d;
                                s = 67108863 & (l = l + s | 0), i += (a = (a = a + (d / 67108864 | 0) | 0) + (l >>> 26) | 0) >>> 26, a &= 67108863;
                            }
                            r.words[o] = s, n = a, a = i;
                        }
                        return 0 !== n ? r.words[o] = n : r.length--, r._strip();
                    }
                    function g(e, t, r) {
                        return m(e, t, r);
                    }
                    function w(e, t) {
                        this.x = e, this.y = t;
                    }
                    Math.imul || (v = y), a.prototype.mulTo = function(e, t) {
                        var r = this.length + e.length;
                        return 10 === this.length && 10 === e.length ? v(this, e, t) : r < 63 ? y(this, e, t) : r < 1024 ? m(this, e, t) : g(this, e, t);
                    }, w.prototype.makeRBT = function(e) {
                        for(var t = new Array(e), r = a.prototype._countBits(e) - 1, n = 0; n < e; n++)t[n] = this.revBin(n, r, e);
                        return t;
                    }, w.prototype.revBin = function(e, t, r) {
                        if (0 === e || e === r - 1) return e;
                        for(var n = 0, i = 0; i < t; i++)n |= (1 & e) << t - i - 1, e >>= 1;
                        return n;
                    }, w.prototype.permute = function(e, t, r, n, i, o) {
                        for(var a = 0; a < o; a++)n[a] = t[e[a]], i[a] = r[e[a]];
                    }, w.prototype.transform = function(e, t, r, n, i, o) {
                        this.permute(o, e, t, r, n, i);
                        for(var a = 1; a < i; a <<= 1)for(var s = a << 1, u = Math.cos(2 * Math.PI / s), c = Math.sin(2 * Math.PI / s), f = 0; f < i; f += s)for(var d = u, l = c, h = 0; h < a; h++){
                            var p = r[f + h], b = n[f + h], y = r[f + h + a], v = n[f + h + a], m = d * y - l * v;
                            v = d * v + l * y, y = m, r[f + h] = p + y, n[f + h] = b + v, r[f + h + a] = p - y, n[f + h + a] = b - v, h !== s && (m = u * d - c * l, l = u * l + c * d, d = m);
                        }
                    }, w.prototype.guessLen13b = function(e, t) {
                        var r = 1 | Math.max(t, e), n = 1 & r, i = 0;
                        for(r = r / 2 | 0; r; r >>>= 1)i++;
                        return 1 << i + 1 + n;
                    }, w.prototype.conjugate = function(e, t, r) {
                        if (!(r <= 1)) for(var n = 0; n < r / 2; n++){
                            var i = e[n];
                            e[n] = e[r - n - 1], e[r - n - 1] = i, i = t[n], t[n] = -t[r - n - 1], t[r - n - 1] = -i;
                        }
                    }, w.prototype.normalize13b = function(e, t) {
                        for(var r = 0, n = 0; n < t / 2; n++){
                            var i = 8192 * Math.round(e[2 * n + 1] / t) + Math.round(e[2 * n] / t) + r;
                            e[n] = 67108863 & i, r = i < 67108864 ? 0 : i / 67108864 | 0;
                        }
                        return e;
                    }, w.prototype.convert13b = function(e, t, r, n) {
                        for(var o = 0, a = 0; a < t; a++)o += 0 | e[a], r[2 * a] = 8191 & o, o >>>= 13, r[2 * a + 1] = 8191 & o, o >>>= 13;
                        for(a = 2 * t; a < n; ++a)r[a] = 0;
                        i(0 === o), i(0 == (-8192 & o));
                    }, w.prototype.stub = function(e) {
                        for(var t = new Array(e), r = 0; r < e; r++)t[r] = 0;
                        return t;
                    }, w.prototype.mulp = function(e, t, r) {
                        var n = 2 * this.guessLen13b(e.length, t.length), i = this.makeRBT(n), o = this.stub(n), a = new Array(n), s = new Array(n), u = new Array(n), c = new Array(n), f = new Array(n), d = new Array(n), l = r.words;
                        l.length = n, this.convert13b(e.words, e.length, a, n), this.convert13b(t.words, t.length, c, n), this.transform(a, o, s, u, n, i), this.transform(c, o, f, d, n, i);
                        for(var h = 0; h < n; h++){
                            var p = s[h] * f[h] - u[h] * d[h];
                            u[h] = s[h] * d[h] + u[h] * f[h], s[h] = p;
                        }
                        return this.conjugate(s, u, n), this.transform(s, u, l, o, n, i), this.conjugate(l, o, n), this.normalize13b(l, n), r.negative = e.negative ^ t.negative, r.length = e.length + t.length, r._strip();
                    }, a.prototype.mul = function(e) {
                        var t = new a(null);
                        return t.words = new Array(this.length + e.length), this.mulTo(e, t);
                    }, a.prototype.mulf = function(e) {
                        var t = new a(null);
                        return t.words = new Array(this.length + e.length), g(this, e, t);
                    }, a.prototype.imul = function(e) {
                        return this.clone().mulTo(e, this);
                    }, a.prototype.imuln = function(e) {
                        var t = e < 0;
                        t && (e = -e), i("number" == typeof e), i(e < 67108864);
                        for(var r = 0, n = 0; n < this.length; n++){
                            var o = (0 | this.words[n]) * e, a = (67108863 & o) + (67108863 & r);
                            r >>= 26, r += o / 67108864 | 0, r += a >>> 26, this.words[n] = 67108863 & a;
                        }
                        return 0 !== r && (this.words[n] = r, this.length++), t ? this.ineg() : this;
                    }, a.prototype.muln = function(e) {
                        return this.clone().imuln(e);
                    }, a.prototype.sqr = function() {
                        return this.mul(this);
                    }, a.prototype.isqr = function() {
                        return this.imul(this.clone());
                    }, a.prototype.pow = function(e) {
                        var t = function(e) {
                            for(var t = new Array(e.bitLength()), r = 0; r < t.length; r++){
                                var n = r / 26 | 0, i = r % 26;
                                t[r] = e.words[n] >>> i & 1;
                            }
                            return t;
                        }(e);
                        if (0 === t.length) return new a(1);
                        for(var r = this, n = 0; n < t.length && 0 === t[n]; n++, r = r.sqr());
                        if (++n < t.length) for(var i = r.sqr(); n < t.length; n++, i = i.sqr())0 !== t[n] && (r = r.mul(i));
                        return r;
                    }, a.prototype.iushln = function(e) {
                        i("number" == typeof e && e >= 0);
                        var t, r = e % 26, n = (e - r) / 26, o = 67108863 >>> 26 - r << 26 - r;
                        if (0 !== r) {
                            var a = 0;
                            for(t = 0; t < this.length; t++){
                                var s = this.words[t] & o, u = (0 | this.words[t]) - s << r;
                                this.words[t] = u | a, a = s >>> 26 - r;
                            }
                            a && (this.words[t] = a, this.length++);
                        }
                        if (0 !== n) {
                            for(t = this.length - 1; t >= 0; t--)this.words[t + n] = this.words[t];
                            for(t = 0; t < n; t++)this.words[t] = 0;
                            this.length += n;
                        }
                        return this._strip();
                    }, a.prototype.ishln = function(e) {
                        return i(0 === this.negative), this.iushln(e);
                    }, a.prototype.iushrn = function(e, t, r) {
                        var n;
                        i("number" == typeof e && e >= 0), n = t ? (t - t % 26) / 26 : 0;
                        var o = e % 26, a = Math.min((e - o) / 26, this.length), s = 67108863 ^ 67108863 >>> o << o, u = r;
                        if (n -= a, n = Math.max(0, n), u) {
                            for(var c = 0; c < a; c++)u.words[c] = this.words[c];
                            u.length = a;
                        }
                        if (0 === a) ;
                        else if (this.length > a) for(this.length -= a, c = 0; c < this.length; c++)this.words[c] = this.words[c + a];
                        else this.words[0] = 0, this.length = 1;
                        var f = 0;
                        for(c = this.length - 1; c >= 0 && (0 !== f || c >= n); c--){
                            var d = 0 | this.words[c];
                            this.words[c] = f << 26 - o | d >>> o, f = d & s;
                        }
                        return u && 0 !== f && (u.words[u.length++] = f), 0 === this.length && (this.words[0] = 0, this.length = 1), this._strip();
                    }, a.prototype.ishrn = function(e, t, r) {
                        return i(0 === this.negative), this.iushrn(e, t, r);
                    }, a.prototype.shln = function(e) {
                        return this.clone().ishln(e);
                    }, a.prototype.ushln = function(e) {
                        return this.clone().iushln(e);
                    }, a.prototype.shrn = function(e) {
                        return this.clone().ishrn(e);
                    }, a.prototype.ushrn = function(e) {
                        return this.clone().iushrn(e);
                    }, a.prototype.testn = function(e) {
                        i("number" == typeof e && e >= 0);
                        var t = e % 26, r = (e - t) / 26, n = 1 << t;
                        return !(this.length <= r || !(this.words[r] & n));
                    }, a.prototype.imaskn = function(e) {
                        i("number" == typeof e && e >= 0);
                        var t = e % 26, r = (e - t) / 26;
                        if (i(0 === this.negative, "imaskn works only with positive numbers"), this.length <= r) return this;
                        if (0 !== t && r++, this.length = Math.min(r, this.length), 0 !== t) {
                            var n = 67108863 ^ 67108863 >>> t << t;
                            this.words[this.length - 1] &= n;
                        }
                        return this._strip();
                    }, a.prototype.maskn = function(e) {
                        return this.clone().imaskn(e);
                    }, a.prototype.iaddn = function(e) {
                        return i("number" == typeof e), i(e < 67108864), e < 0 ? this.isubn(-e) : 0 !== this.negative ? 1 === this.length && (0 | this.words[0]) <= e ? (this.words[0] = e - (0 | this.words[0]), this.negative = 0, this) : (this.negative = 0, this.isubn(e), this.negative = 1, this) : this._iaddn(e);
                    }, a.prototype._iaddn = function(e) {
                        this.words[0] += e;
                        for(var t = 0; t < this.length && this.words[t] >= 67108864; t++)this.words[t] -= 67108864, t === this.length - 1 ? this.words[t + 1] = 1 : this.words[t + 1]++;
                        return this.length = Math.max(this.length, t + 1), this;
                    }, a.prototype.isubn = function(e) {
                        if (i("number" == typeof e), i(e < 67108864), e < 0) return this.iaddn(-e);
                        if (0 !== this.negative) return this.negative = 0, this.iaddn(e), this.negative = 1, this;
                        if (this.words[0] -= e, 1 === this.length && this.words[0] < 0) this.words[0] = -this.words[0], this.negative = 1;
                        else for(var t = 0; t < this.length && this.words[t] < 0; t++)this.words[t] += 67108864, this.words[t + 1] -= 1;
                        return this._strip();
                    }, a.prototype.addn = function(e) {
                        return this.clone().iaddn(e);
                    }, a.prototype.subn = function(e) {
                        return this.clone().isubn(e);
                    }, a.prototype.iabs = function() {
                        return this.negative = 0, this;
                    }, a.prototype.abs = function() {
                        return this.clone().iabs();
                    }, a.prototype._ishlnsubmul = function(e, t, r) {
                        var n, o, a = e.length + r;
                        this._expand(a);
                        var s = 0;
                        for(n = 0; n < e.length; n++){
                            o = (0 | this.words[n + r]) + s;
                            var u = (0 | e.words[n]) * t;
                            s = ((o -= 67108863 & u) >> 26) - (u / 67108864 | 0), this.words[n + r] = 67108863 & o;
                        }
                        for(; n < this.length - r; n++)s = (o = (0 | this.words[n + r]) + s) >> 26, this.words[n + r] = 67108863 & o;
                        if (0 === s) return this._strip();
                        for(i(-1 === s), s = 0, n = 0; n < this.length; n++)s = (o = -(0 | this.words[n]) + s) >> 26, this.words[n] = 67108863 & o;
                        return this.negative = 1, this._strip();
                    }, a.prototype._wordDiv = function(e, t) {
                        var r = (this.length, e.length), n = this.clone(), i = e, o = 0 | i.words[i.length - 1];
                        0 != (r = 26 - this._countBits(o)) && (i = i.ushln(r), n.iushln(r), o = 0 | i.words[i.length - 1]);
                        var s, u = n.length - i.length;
                        if ("mod" !== t) {
                            (s = new a(null)).length = u + 1, s.words = new Array(s.length);
                            for(var c = 0; c < s.length; c++)s.words[c] = 0;
                        }
                        var f = n.clone()._ishlnsubmul(i, 1, u);
                        0 === f.negative && (n = f, s && (s.words[u] = 1));
                        for(var d = u - 1; d >= 0; d--){
                            var l = 67108864 * (0 | n.words[i.length + d]) + (0 | n.words[i.length + d - 1]);
                            for(l = Math.min(l / o | 0, 67108863), n._ishlnsubmul(i, l, d); 0 !== n.negative;)l--, n.negative = 0, n._ishlnsubmul(i, 1, d), n.isZero() || (n.negative ^= 1);
                            s && (s.words[d] = l);
                        }
                        return s && s._strip(), n._strip(), "div" !== t && 0 !== r && n.iushrn(r), {
                            div: s || null,
                            mod: n
                        };
                    }, a.prototype.divmod = function(e, t, r) {
                        var n, o, s;
                        return i(!e.isZero()), this.isZero() ? {
                            div: new a(0),
                            mod: new a(0)
                        } : 0 !== this.negative && 0 === e.negative ? (s = this.neg().divmod(e, t), "mod" !== t && (n = s.div.neg()), "div" !== t && (o = s.mod.neg(), r && 0 !== o.negative && o.iadd(e)), {
                            div: n,
                            mod: o
                        }) : 0 === this.negative && 0 !== e.negative ? (s = this.divmod(e.neg(), t), "mod" !== t && (n = s.div.neg()), {
                            div: n,
                            mod: s.mod
                        }) : 0 != (this.negative & e.negative) ? (s = this.neg().divmod(e.neg(), t), "div" !== t && (o = s.mod.neg(), r && 0 !== o.negative && o.isub(e)), {
                            div: s.div,
                            mod: o
                        }) : e.length > this.length || this.cmp(e) < 0 ? {
                            div: new a(0),
                            mod: this
                        } : 1 === e.length ? "div" === t ? {
                            div: this.divn(e.words[0]),
                            mod: null
                        } : "mod" === t ? {
                            div: null,
                            mod: new a(this.modrn(e.words[0]))
                        } : {
                            div: this.divn(e.words[0]),
                            mod: new a(this.modrn(e.words[0]))
                        } : this._wordDiv(e, t);
                    }, a.prototype.div = function(e) {
                        return this.divmod(e, "div", !1).div;
                    }, a.prototype.mod = function(e) {
                        return this.divmod(e, "mod", !1).mod;
                    }, a.prototype.umod = function(e) {
                        return this.divmod(e, "mod", !0).mod;
                    }, a.prototype.divRound = function(e) {
                        var t = this.divmod(e);
                        if (t.mod.isZero()) return t.div;
                        var r = 0 !== t.div.negative ? t.mod.isub(e) : t.mod, n = e.ushrn(1), i = e.andln(1), o = r.cmp(n);
                        return o < 0 || 1 === i && 0 === o ? t.div : 0 !== t.div.negative ? t.div.isubn(1) : t.div.iaddn(1);
                    }, a.prototype.modrn = function(e) {
                        var t = e < 0;
                        t && (e = -e), i(e <= 67108863);
                        for(var r = 67108864 % e, n = 0, o = this.length - 1; o >= 0; o--)n = (r * n + (0 | this.words[o])) % e;
                        return t ? -n : n;
                    }, a.prototype.modn = function(e) {
                        return this.modrn(e);
                    }, a.prototype.idivn = function(e) {
                        var t = e < 0;
                        t && (e = -e), i(e <= 67108863);
                        for(var r = 0, n = this.length - 1; n >= 0; n--){
                            var o = (0 | this.words[n]) + 67108864 * r;
                            this.words[n] = o / e | 0, r = o % e;
                        }
                        return this._strip(), t ? this.ineg() : this;
                    }, a.prototype.divn = function(e) {
                        return this.clone().idivn(e);
                    }, a.prototype.egcd = function(e) {
                        i(0 === e.negative), i(!e.isZero());
                        var t = this, r = e.clone();
                        t = 0 !== t.negative ? t.umod(e) : t.clone();
                        for(var n = new a(1), o = new a(0), s = new a(0), u = new a(1), c = 0; t.isEven() && r.isEven();)t.iushrn(1), r.iushrn(1), ++c;
                        for(var f = r.clone(), d = t.clone(); !t.isZero();){
                            for(var l = 0, h = 1; 0 == (t.words[0] & h) && l < 26; ++l, h <<= 1);
                            if (l > 0) for(t.iushrn(l); l-- > 0;)(n.isOdd() || o.isOdd()) && (n.iadd(f), o.isub(d)), n.iushrn(1), o.iushrn(1);
                            for(var p = 0, b = 1; 0 == (r.words[0] & b) && p < 26; ++p, b <<= 1);
                            if (p > 0) for(r.iushrn(p); p-- > 0;)(s.isOdd() || u.isOdd()) && (s.iadd(f), u.isub(d)), s.iushrn(1), u.iushrn(1);
                            t.cmp(r) >= 0 ? (t.isub(r), n.isub(s), o.isub(u)) : (r.isub(t), s.isub(n), u.isub(o));
                        }
                        return {
                            a: s,
                            b: u,
                            gcd: r.iushln(c)
                        };
                    }, a.prototype._invmp = function(e) {
                        i(0 === e.negative), i(!e.isZero());
                        var t = this, r = e.clone();
                        t = 0 !== t.negative ? t.umod(e) : t.clone();
                        for(var n, o = new a(1), s = new a(0), u = r.clone(); t.cmpn(1) > 0 && r.cmpn(1) > 0;){
                            for(var c = 0, f = 1; 0 == (t.words[0] & f) && c < 26; ++c, f <<= 1);
                            if (c > 0) for(t.iushrn(c); c-- > 0;)o.isOdd() && o.iadd(u), o.iushrn(1);
                            for(var d = 0, l = 1; 0 == (r.words[0] & l) && d < 26; ++d, l <<= 1);
                            if (d > 0) for(r.iushrn(d); d-- > 0;)s.isOdd() && s.iadd(u), s.iushrn(1);
                            t.cmp(r) >= 0 ? (t.isub(r), o.isub(s)) : (r.isub(t), s.isub(o));
                        }
                        return (n = 0 === t.cmpn(1) ? o : s).cmpn(0) < 0 && n.iadd(e), n;
                    }, a.prototype.gcd = function(e) {
                        if (this.isZero()) return e.abs();
                        if (e.isZero()) return this.abs();
                        var t = this.clone(), r = e.clone();
                        t.negative = 0, r.negative = 0;
                        for(var n = 0; t.isEven() && r.isEven(); n++)t.iushrn(1), r.iushrn(1);
                        for(;;){
                            for(; t.isEven();)t.iushrn(1);
                            for(; r.isEven();)r.iushrn(1);
                            var i = t.cmp(r);
                            if (i < 0) {
                                var o = t;
                                t = r, r = o;
                            } else if (0 === i || 0 === r.cmpn(1)) break;
                            t.isub(r);
                        }
                        return r.iushln(n);
                    }, a.prototype.invm = function(e) {
                        return this.egcd(e).a.umod(e);
                    }, a.prototype.isEven = function() {
                        return 0 == (1 & this.words[0]);
                    }, a.prototype.isOdd = function() {
                        return 1 == (1 & this.words[0]);
                    }, a.prototype.andln = function(e) {
                        return this.words[0] & e;
                    }, a.prototype.bincn = function(e) {
                        i("number" == typeof e);
                        var t = e % 26, r = (e - t) / 26, n = 1 << t;
                        if (this.length <= r) return this._expand(r + 1), this.words[r] |= n, this;
                        for(var o = n, a = r; 0 !== o && a < this.length; a++){
                            var s = 0 | this.words[a];
                            o = (s += o) >>> 26, s &= 67108863, this.words[a] = s;
                        }
                        return 0 !== o && (this.words[a] = o, this.length++), this;
                    }, a.prototype.isZero = function() {
                        return 1 === this.length && 0 === this.words[0];
                    }, a.prototype.cmpn = function(e) {
                        var t, r = e < 0;
                        if (0 !== this.negative && !r) return -1;
                        if (0 === this.negative && r) return 1;
                        if (this._strip(), this.length > 1) t = 1;
                        else {
                            r && (e = -e), i(e <= 67108863, "Number is too big");
                            var n = 0 | this.words[0];
                            t = n === e ? 0 : n < e ? -1 : 1;
                        }
                        return 0 !== this.negative ? 0 | -t : t;
                    }, a.prototype.cmp = function(e) {
                        if (0 !== this.negative && 0 === e.negative) return -1;
                        if (0 === this.negative && 0 !== e.negative) return 1;
                        var t = this.ucmp(e);
                        return 0 !== this.negative ? 0 | -t : t;
                    }, a.prototype.ucmp = function(e) {
                        if (this.length > e.length) return 1;
                        if (this.length < e.length) return -1;
                        for(var t = 0, r = this.length - 1; r >= 0; r--){
                            var n = 0 | this.words[r], i = 0 | e.words[r];
                            if (n !== i) {
                                n < i ? t = -1 : n > i && (t = 1);
                                break;
                            }
                        }
                        return t;
                    }, a.prototype.gtn = function(e) {
                        return 1 === this.cmpn(e);
                    }, a.prototype.gt = function(e) {
                        return 1 === this.cmp(e);
                    }, a.prototype.gten = function(e) {
                        return this.cmpn(e) >= 0;
                    }, a.prototype.gte = function(e) {
                        return this.cmp(e) >= 0;
                    }, a.prototype.ltn = function(e) {
                        return -1 === this.cmpn(e);
                    }, a.prototype.lt = function(e) {
                        return -1 === this.cmp(e);
                    }, a.prototype.lten = function(e) {
                        return this.cmpn(e) <= 0;
                    }, a.prototype.lte = function(e) {
                        return this.cmp(e) <= 0;
                    }, a.prototype.eqn = function(e) {
                        return 0 === this.cmpn(e);
                    }, a.prototype.eq = function(e) {
                        return 0 === this.cmp(e);
                    }, a.red = function(e) {
                        return new B(e);
                    }, a.prototype.toRed = function(e) {
                        return i(!this.red, "Already a number in reduction context"), i(0 === this.negative, "red works only with positives"), e.convertTo(this)._forceRed(e);
                    }, a.prototype.fromRed = function() {
                        return i(this.red, "fromRed works only with numbers in reduction context"), this.red.convertFrom(this);
                    }, a.prototype._forceRed = function(e) {
                        return this.red = e, this;
                    }, a.prototype.forceRed = function(e) {
                        return i(!this.red, "Already a number in reduction context"), this._forceRed(e);
                    }, a.prototype.redAdd = function(e) {
                        return i(this.red, "redAdd works only with red numbers"), this.red.add(this, e);
                    }, a.prototype.redIAdd = function(e) {
                        return i(this.red, "redIAdd works only with red numbers"), this.red.iadd(this, e);
                    }, a.prototype.redSub = function(e) {
                        return i(this.red, "redSub works only with red numbers"), this.red.sub(this, e);
                    }, a.prototype.redISub = function(e) {
                        return i(this.red, "redISub works only with red numbers"), this.red.isub(this, e);
                    }, a.prototype.redShl = function(e) {
                        return i(this.red, "redShl works only with red numbers"), this.red.shl(this, e);
                    }, a.prototype.redMul = function(e) {
                        return i(this.red, "redMul works only with red numbers"), this.red._verify2(this, e), this.red.mul(this, e);
                    }, a.prototype.redIMul = function(e) {
                        return i(this.red, "redMul works only with red numbers"), this.red._verify2(this, e), this.red.imul(this, e);
                    }, a.prototype.redSqr = function() {
                        return i(this.red, "redSqr works only with red numbers"), this.red._verify1(this), this.red.sqr(this);
                    }, a.prototype.redISqr = function() {
                        return i(this.red, "redISqr works only with red numbers"), this.red._verify1(this), this.red.isqr(this);
                    }, a.prototype.redSqrt = function() {
                        return i(this.red, "redSqrt works only with red numbers"), this.red._verify1(this), this.red.sqrt(this);
                    }, a.prototype.redInvm = function() {
                        return i(this.red, "redInvm works only with red numbers"), this.red._verify1(this), this.red.invm(this);
                    }, a.prototype.redNeg = function() {
                        return i(this.red, "redNeg works only with red numbers"), this.red._verify1(this), this.red.neg(this);
                    }, a.prototype.redPow = function(e) {
                        return i(this.red && !e.red, "redPow(normalNum)"), this.red._verify1(this), this.red.pow(this, e);
                    };
                    var k = {
                        k256: null,
                        p224: null,
                        p192: null,
                        p25519: null
                    };
                    function _(e, t) {
                        this.name = e, this.p = new a(t, 16), this.n = this.p.bitLength(), this.k = new a(1).iushln(this.n).isub(this.p), this.tmp = this._tmp();
                    }
                    function A() {
                        _.call(this, "k256", "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f");
                    }
                    function E() {
                        _.call(this, "p224", "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001");
                    }
                    function S() {
                        _.call(this, "p192", "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff");
                    }
                    function x() {
                        _.call(this, "25519", "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed");
                    }
                    function B(e) {
                        if ("string" == typeof e) {
                            var t = a._prime(e);
                            this.m = t.p, this.prime = t;
                        } else i(e.gtn(1), "modulus must be greater than 1"), this.m = e, this.prime = null;
                    }
                    function O(e) {
                        B.call(this, e), this.shift = this.m.bitLength(), this.shift % 26 != 0 && (this.shift += 26 - this.shift % 26), this.r = new a(1).iushln(this.shift), this.r2 = this.imod(this.r.sqr()), this.rinv = this.r._invmp(this.m), this.minv = this.rinv.mul(this.r).isubn(1).div(this.m), this.minv = this.minv.umod(this.r), this.minv = this.r.sub(this.minv);
                    }
                    _.prototype._tmp = function() {
                        var e = new a(null);
                        return e.words = new Array(Math.ceil(this.n / 13)), e;
                    }, _.prototype.ireduce = function(e) {
                        var t, r = e;
                        do this.split(r, this.tmp), t = (r = (r = this.imulK(r)).iadd(this.tmp)).bitLength();
                        while (t > this.n);
                        var n = t < this.n ? -1 : r.ucmp(this.p);
                        return 0 === n ? (r.words[0] = 0, r.length = 1) : n > 0 ? r.isub(this.p) : void 0 !== r.strip ? r.strip() : r._strip(), r;
                    }, _.prototype.split = function(e, t) {
                        e.iushrn(this.n, 0, t);
                    }, _.prototype.imulK = function(e) {
                        return e.imul(this.k);
                    }, o(A, _), A.prototype.split = function(e, t) {
                        for(var r = 4194303, n = Math.min(e.length, 9), i = 0; i < n; i++)t.words[i] = e.words[i];
                        if (t.length = n, e.length <= 9) return e.words[0] = 0, void (e.length = 1);
                        var o = e.words[9];
                        for(t.words[t.length++] = o & r, i = 10; i < e.length; i++){
                            var a = 0 | e.words[i];
                            e.words[i - 10] = (a & r) << 4 | o >>> 22, o = a;
                        }
                        o >>>= 22, e.words[i - 10] = o, 0 === o && e.length > 10 ? e.length -= 10 : e.length -= 9;
                    }, A.prototype.imulK = function(e) {
                        e.words[e.length] = 0, e.words[e.length + 1] = 0, e.length += 2;
                        for(var t = 0, r = 0; r < e.length; r++){
                            var n = 0 | e.words[r];
                            t += 977 * n, e.words[r] = 67108863 & t, t = 64 * n + (t / 67108864 | 0);
                        }
                        return 0 === e.words[e.length - 1] && (e.length--, 0 === e.words[e.length - 1] && e.length--), e;
                    }, o(E, _), o(S, _), o(x, _), x.prototype.imulK = function(e) {
                        for(var t = 0, r = 0; r < e.length; r++){
                            var n = 19 * (0 | e.words[r]) + t, i = 67108863 & n;
                            n >>>= 26, e.words[r] = i, t = n;
                        }
                        return 0 !== t && (e.words[e.length++] = t), e;
                    }, a._prime = function(e) {
                        if (k[e]) return k[e];
                        var t;
                        if ("k256" === e) t = new A;
                        else if ("p224" === e) t = new E;
                        else if ("p192" === e) t = new S;
                        else {
                            if ("p25519" !== e) throw new Error("Unknown prime " + e);
                            t = new x;
                        }
                        return k[e] = t, t;
                    }, B.prototype._verify1 = function(e) {
                        i(0 === e.negative, "red works only with positives"), i(e.red, "red works only with red numbers");
                    }, B.prototype._verify2 = function(e, t) {
                        i(0 == (e.negative | t.negative), "red works only with positives"), i(e.red && e.red === t.red, "red works only with red numbers");
                    }, B.prototype.imod = function(e) {
                        return this.prime ? this.prime.ireduce(e)._forceRed(this) : (d(e, e.umod(this.m)._forceRed(this)), e);
                    }, B.prototype.neg = function(e) {
                        return e.isZero() ? e.clone() : this.m.sub(e)._forceRed(this);
                    }, B.prototype.add = function(e, t) {
                        this._verify2(e, t);
                        var r = e.add(t);
                        return r.cmp(this.m) >= 0 && r.isub(this.m), r._forceRed(this);
                    }, B.prototype.iadd = function(e, t) {
                        this._verify2(e, t);
                        var r = e.iadd(t);
                        return r.cmp(this.m) >= 0 && r.isub(this.m), r;
                    }, B.prototype.sub = function(e, t) {
                        this._verify2(e, t);
                        var r = e.sub(t);
                        return r.cmpn(0) < 0 && r.iadd(this.m), r._forceRed(this);
                    }, B.prototype.isub = function(e, t) {
                        this._verify2(e, t);
                        var r = e.isub(t);
                        return r.cmpn(0) < 0 && r.iadd(this.m), r;
                    }, B.prototype.shl = function(e, t) {
                        return this._verify1(e), this.imod(e.ushln(t));
                    }, B.prototype.imul = function(e, t) {
                        return this._verify2(e, t), this.imod(e.imul(t));
                    }, B.prototype.mul = function(e, t) {
                        return this._verify2(e, t), this.imod(e.mul(t));
                    }, B.prototype.isqr = function(e) {
                        return this.imul(e, e.clone());
                    }, B.prototype.sqr = function(e) {
                        return this.mul(e, e);
                    }, B.prototype.sqrt = function(e) {
                        if (e.isZero()) return e.clone();
                        var t = this.m.andln(3);
                        if (i(t % 2 == 1), 3 === t) {
                            var r = this.m.add(new a(1)).iushrn(2);
                            return this.pow(e, r);
                        }
                        for(var n = this.m.subn(1), o = 0; !n.isZero() && 0 === n.andln(1);)o++, n.iushrn(1);
                        i(!n.isZero());
                        var s = new a(1).toRed(this), u = s.redNeg(), c = this.m.subn(1).iushrn(1), f = this.m.bitLength();
                        for(f = new a(2 * f * f).toRed(this); 0 !== this.pow(f, c).cmp(u);)f.redIAdd(u);
                        for(var d = this.pow(f, n), l = this.pow(e, n.addn(1).iushrn(1)), h = this.pow(e, n), p = o; 0 !== h.cmp(s);){
                            for(var b = h, y = 0; 0 !== b.cmp(s); y++)b = b.redSqr();
                            i(y < p);
                            var v = this.pow(d, new a(1).iushln(p - y - 1));
                            l = l.redMul(v), d = v.redSqr(), h = h.redMul(d), p = y;
                        }
                        return l;
                    }, B.prototype.invm = function(e) {
                        var t = e._invmp(this.m);
                        return 0 !== t.negative ? (t.negative = 0, this.imod(t).redNeg()) : this.imod(t);
                    }, B.prototype.pow = function(e, t) {
                        if (t.isZero()) return new a(1).toRed(this);
                        if (0 === t.cmpn(1)) return e.clone();
                        var r = new Array(16);
                        r[0] = new a(1).toRed(this), r[1] = e;
                        for(var n = 2; n < r.length; n++)r[n] = this.mul(r[n - 1], e);
                        var i = r[0], o = 0, s = 0, u = t.bitLength() % 26;
                        for(0 === u && (u = 26), n = t.length - 1; n >= 0; n--){
                            for(var c = t.words[n], f = u - 1; f >= 0; f--){
                                var d = c >> f & 1;
                                i !== r[0] && (i = this.sqr(i)), 0 !== d || 0 !== o ? (o <<= 1, o |= d, (4 == ++s || 0 === n && 0 === f) && (i = this.mul(i, r[o]), s = 0, o = 0)) : s = 0;
                            }
                            u = 26;
                        }
                        return i;
                    }, B.prototype.convertTo = function(e) {
                        var t = e.umod(this.m);
                        return t === e ? t.clone() : t;
                    }, B.prototype.convertFrom = function(e) {
                        var t = e.clone();
                        return t.red = null, t;
                    }, a.mont = function(e) {
                        return new O(e);
                    }, o(O, B), O.prototype.convertTo = function(e) {
                        return this.imod(e.ushln(this.shift));
                    }, O.prototype.convertFrom = function(e) {
                        var t = this.imod(e.mul(this.rinv));
                        return t.red = null, t;
                    }, O.prototype.imul = function(e, t) {
                        if (e.isZero() || t.isZero()) return e.words[0] = 0, e.length = 1, e;
                        var r = e.imul(t), n = r.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m), i = r.isub(n).iushrn(this.shift), o = i;
                        return i.cmp(this.m) >= 0 ? o = i.isub(this.m) : i.cmpn(0) < 0 && (o = i.iadd(this.m)), o._forceRed(this);
                    }, O.prototype.mul = function(e, t) {
                        if (e.isZero() || t.isZero()) return new a(0)._forceRed(this);
                        var r = e.mul(t), n = r.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m), i = r.isub(n).iushrn(this.shift), o = i;
                        return i.cmp(this.m) >= 0 ? o = i.isub(this.m) : i.cmpn(0) < 0 && (o = i.iadd(this.m)), o._forceRed(this);
                    }, O.prototype.invm = function(e) {
                        return this.imod(e._invmp(this.m).mul(this.r2))._forceRed(this);
                    };
                }(e);
            },
            82202: (e, t, r)=>{
                "use strict";
                var n, i = r(28847)(r(3355));
                function o(e) {
                    this.rand = e;
                }
                if (e.exports = function(e) {
                    return n || (n = new o(null)), n.generate(e);
                }, e.exports.Rand = o, o.prototype.generate = function(e) {
                    return this._rand(e);
                }, o.prototype._rand = function(e) {
                    if (this.rand.getBytes) return this.rand.getBytes(e);
                    for(var t = new Uint8Array(e), r = 0; r < t.length; r++)t[r] = this.rand.getByte();
                    return t;
                }, "object" === ("undefined" == typeof self ? "undefined" : (0, i.default)(self))) self.crypto && self.crypto.getRandomValues ? o.prototype._rand = function(e) {
                    var t = new Uint8Array(e);
                    return self.crypto.getRandomValues(t), t;
                } : self.msCrypto && self.msCrypto.getRandomValues ? o.prototype._rand = function(e) {
                    var t = new Uint8Array(e);
                    return self.msCrypto.getRandomValues(t), t;
                } : "object" === ("undefined" == typeof window ? "undefined" : (0, i.default)(window)) && (o.prototype._rand = function() {
                    throw new Error("Not implemented yet");
                });
                else try {
                    var a = r(89214);
                    if ("function" != typeof a.randomBytes) throw new Error("Not supported");
                    o.prototype._rand = function(e) {
                        return a.randomBytes(e);
                    };
                } catch (e) {}
            },
            37494: (e, t, r)=>{
                "use strict";
                var n = r(48850).Buffer;
                function i(e) {
                    n.isBuffer(e) || (e = n.from(e));
                    for(var t = e.length / 4 | 0, r = new Array(t), i = 0; i < t; i++)r[i] = e.readUInt32BE(4 * i);
                    return r;
                }
                function o(e) {
                    for(; 0 < e.length; e++)e[0] = 0;
                }
                function a(e, t, r, n, i) {
                    for(var o, a, s, u, c = r[0], f = r[1], d = r[2], l = r[3], h = e[0] ^ t[0], p = e[1] ^ t[1], b = e[2] ^ t[2], y = e[3] ^ t[3], v = 4, m = 1; m < i; m++)o = c[h >>> 24] ^ f[p >>> 16 & 255] ^ d[b >>> 8 & 255] ^ l[255 & y] ^ t[v++], a = c[p >>> 24] ^ f[b >>> 16 & 255] ^ d[y >>> 8 & 255] ^ l[255 & h] ^ t[v++], s = c[b >>> 24] ^ f[y >>> 16 & 255] ^ d[h >>> 8 & 255] ^ l[255 & p] ^ t[v++], u = c[y >>> 24] ^ f[h >>> 16 & 255] ^ d[p >>> 8 & 255] ^ l[255 & b] ^ t[v++], h = o, p = a, b = s, y = u;
                    return o = (n[h >>> 24] << 24 | n[p >>> 16 & 255] << 16 | n[b >>> 8 & 255] << 8 | n[255 & y]) ^ t[v++], a = (n[p >>> 24] << 24 | n[b >>> 16 & 255] << 16 | n[y >>> 8 & 255] << 8 | n[255 & h]) ^ t[v++], s = (n[b >>> 24] << 24 | n[y >>> 16 & 255] << 16 | n[h >>> 8 & 255] << 8 | n[255 & p]) ^ t[v++], u = (n[y >>> 24] << 24 | n[h >>> 16 & 255] << 16 | n[p >>> 8 & 255] << 8 | n[255 & b]) ^ t[v++], [
                        o >>>= 0,
                        a >>>= 0,
                        s >>>= 0,
                        u >>>= 0
                    ];
                }
                var s = [
                    0,
                    1,
                    2,
                    4,
                    8,
                    16,
                    32,
                    64,
                    128,
                    27,
                    54
                ], u = function() {
                    for(var e = new Array(256), t = 0; t < 256; t++)e[t] = t < 128 ? t << 1 : t << 1 ^ 283;
                    for(var r = [], n = [], i = [
                        [],
                        [],
                        [],
                        []
                    ], o = [
                        [],
                        [],
                        [],
                        []
                    ], a = 0, s = 0, u = 0; u < 256; ++u){
                        var c = s ^ s << 1 ^ s << 2 ^ s << 3 ^ s << 4;
                        c = c >>> 8 ^ 255 & c ^ 99, r[a] = c, n[c] = a;
                        var f = e[a], d = e[f], l = e[d], h = 257 * e[c] ^ 16843008 * c;
                        i[0][a] = h << 24 | h >>> 8, i[1][a] = h << 16 | h >>> 16, i[2][a] = h << 8 | h >>> 24, i[3][a] = h, h = 16843009 * l ^ 65537 * d ^ 257 * f ^ 16843008 * a, o[0][c] = h << 24 | h >>> 8, o[1][c] = h << 16 | h >>> 16, o[2][c] = h << 8 | h >>> 24, o[3][c] = h, 0 === a ? a = s = 1 : (a = f ^ e[e[e[l ^ f]]], s ^= e[e[s]]);
                    }
                    return {
                        SBOX: r,
                        INV_SBOX: n,
                        SUB_MIX: i,
                        INV_SUB_MIX: o
                    };
                }();
                function c(e) {
                    this._key = i(e), this._reset();
                }
                c.blockSize = 16, c.keySize = 32, c.prototype.blockSize = c.blockSize, c.prototype.keySize = c.keySize, c.prototype._reset = function() {
                    for(var e = this._key, t = e.length, r = t + 6, n = 4 * (r + 1), i = [], o = 0; o < t; o++)i[o] = e[o];
                    for(o = t; o < n; o++){
                        var a = i[o - 1];
                        o % t == 0 ? (a = a << 8 | a >>> 24, a = u.SBOX[a >>> 24] << 24 | u.SBOX[a >>> 16 & 255] << 16 | u.SBOX[a >>> 8 & 255] << 8 | u.SBOX[255 & a], a ^= s[o / t | 0] << 24) : t > 6 && o % t == 4 && (a = u.SBOX[a >>> 24] << 24 | u.SBOX[a >>> 16 & 255] << 16 | u.SBOX[a >>> 8 & 255] << 8 | u.SBOX[255 & a]), i[o] = i[o - t] ^ a;
                    }
                    for(var c = [], f = 0; f < n; f++){
                        var d = n - f, l = i[d - (f % 4 ? 0 : 4)];
                        c[f] = f < 4 || d <= 4 ? l : u.INV_SUB_MIX[0][u.SBOX[l >>> 24]] ^ u.INV_SUB_MIX[1][u.SBOX[l >>> 16 & 255]] ^ u.INV_SUB_MIX[2][u.SBOX[l >>> 8 & 255]] ^ u.INV_SUB_MIX[3][u.SBOX[255 & l]];
                    }
                    this._nRounds = r, this._keySchedule = i, this._invKeySchedule = c;
                }, c.prototype.encryptBlockRaw = function(e) {
                    return a(e = i(e), this._keySchedule, u.SUB_MIX, u.SBOX, this._nRounds);
                }, c.prototype.encryptBlock = function(e) {
                    var t = this.encryptBlockRaw(e), r = n.allocUnsafe(16);
                    return r.writeUInt32BE(t[0], 0), r.writeUInt32BE(t[1], 4), r.writeUInt32BE(t[2], 8), r.writeUInt32BE(t[3], 12), r;
                }, c.prototype.decryptBlock = function(e) {
                    var t = (e = i(e))[1];
                    e[1] = e[3], e[3] = t;
                    var r = a(e, this._invKeySchedule, u.INV_SUB_MIX, u.INV_SBOX, this._nRounds), o = n.allocUnsafe(16);
                    return o.writeUInt32BE(r[0], 0), o.writeUInt32BE(r[3], 4), o.writeUInt32BE(r[2], 8), o.writeUInt32BE(r[1], 12), o;
                }, c.prototype.scrub = function() {
                    o(this._keySchedule), o(this._invKeySchedule), o(this._key);
                }, e.exports.AES = c;
            },
            10426: (e, t, r)=>{
                "use strict";
                var n = r(37494), i = r(48850).Buffer, o = r(93013), a = r(41736), s = r(26626), u = r(96316), c = r(67557);
                function f(e, t, r, a) {
                    o.call(this);
                    var u = i.alloc(4, 0);
                    this._cipher = new n.AES(t);
                    var f = this._cipher.encryptBlock(u);
                    this._ghash = new s(f), r = function(e, t, r) {
                        if (12 === t.length) return e._finID = i.concat([
                            t,
                            i.from([
                                0,
                                0,
                                0,
                                1
                            ])
                        ]), i.concat([
                            t,
                            i.from([
                                0,
                                0,
                                0,
                                2
                            ])
                        ]);
                        var n = new s(r), o = t.length, a = o % 16;
                        n.update(t), a && (a = 16 - a, n.update(i.alloc(a, 0))), n.update(i.alloc(8, 0));
                        var u = 8 * o, f = i.alloc(8);
                        f.writeUIntBE(u, 0, 8), n.update(f), e._finID = n.state;
                        var d = i.from(e._finID);
                        return c(d), d;
                    }(this, r, f), this._prev = i.from(r), this._cache = i.allocUnsafe(0), this._secCache = i.allocUnsafe(0), this._decrypt = a, this._alen = 0, this._len = 0, this._mode = e, this._authTag = null, this._called = !1;
                }
                a(f, o), f.prototype._update = function(e) {
                    if (!this._called && this._alen) {
                        var t = 16 - this._alen % 16;
                        t < 16 && (t = i.alloc(t, 0), this._ghash.update(t));
                    }
                    this._called = !0;
                    var r = this._mode.encrypt(this, e);
                    return this._decrypt ? this._ghash.update(e) : this._ghash.update(r), this._len += e.length, r;
                }, f.prototype._final = function() {
                    if (this._decrypt && !this._authTag) throw new Error("Unsupported state or unable to authenticate data");
                    var e = u(this._ghash.final(8 * this._alen, 8 * this._len), this._cipher.encryptBlock(this._finID));
                    if (this._decrypt && function(e, t) {
                        var r = 0;
                        e.length !== t.length && r++;
                        for(var n = Math.min(e.length, t.length), i = 0; i < n; ++i)r += e[i] ^ t[i];
                        return r;
                    }(e, this._authTag)) throw new Error("Unsupported state or unable to authenticate data");
                    this._authTag = e, this._cipher.scrub();
                }, f.prototype.getAuthTag = function() {
                    if (this._decrypt || !i.isBuffer(this._authTag)) throw new Error("Attempting to get auth tag in unsupported state");
                    return this._authTag;
                }, f.prototype.setAuthTag = function(e) {
                    if (!this._decrypt) throw new Error("Attempting to set auth tag in unsupported state");
                    this._authTag = e;
                }, f.prototype.setAAD = function(e) {
                    if (this._called) throw new Error("Attempting to set AAD in unsupported state");
                    this._ghash.update(e), this._alen += e.length;
                }, e.exports = f;
            },
            98073: (e, t, r)=>{
                "use strict";
                var n = r(85478), i = r(32184), o = r(44946);
                t.createCipher = t.Cipher = n.createCipher, t.createCipheriv = t.Cipheriv = n.createCipheriv, t.createDecipher = t.Decipher = i.createDecipher, t.createDecipheriv = t.Decipheriv = i.createDecipheriv, t.listCiphers = t.getCiphers = function() {
                    return Object.keys(o);
                };
            },
            32184: (e, t, r)=>{
                "use strict";
                var n = r(10426), i = r(48850).Buffer, o = r(58408), a = r(21408), s = r(93013), u = r(37494), c = r(27085);
                function f(e, t, r) {
                    s.call(this), this._cache = new d, this._last = void 0, this._cipher = new u.AES(t), this._prev = i.from(r), this._mode = e, this._autopadding = !0;
                }
                function d() {
                    this.cache = i.allocUnsafe(0);
                }
                function l(e, t, r) {
                    var s = o[e.toLowerCase()];
                    if (!s) throw new TypeError("invalid suite type");
                    if ("string" == typeof r && (r = i.from(r)), "GCM" !== s.mode && r.length !== s.iv) throw new TypeError("invalid iv length " + r.length);
                    if ("string" == typeof t && (t = i.from(t)), t.length !== s.key / 8) throw new TypeError("invalid key length " + t.length);
                    return "stream" === s.type ? new a(s.module, t, r, !0) : "auth" === s.type ? new n(s.module, t, r, !0) : new f(s.module, t, r);
                }
                r(41736)(f, s), f.prototype._update = function(e) {
                    var t, r;
                    this._cache.add(e);
                    for(var n = []; t = this._cache.get(this._autopadding);)r = this._mode.decrypt(this, t), n.push(r);
                    return i.concat(n);
                }, f.prototype._final = function() {
                    var e = this._cache.flush();
                    if (this._autopadding) return function(e) {
                        var t = e[15];
                        if (t < 1 || t > 16) throw new Error("unable to decrypt data");
                        for(var r = -1; ++r < t;)if (e[r + (16 - t)] !== t) throw new Error("unable to decrypt data");
                        if (16 !== t) return e.slice(0, 16 - t);
                    }(this._mode.decrypt(this, e));
                    if (e) throw new Error("data not multiple of block length");
                }, f.prototype.setAutoPadding = function(e) {
                    return this._autopadding = !!e, this;
                }, d.prototype.add = function(e) {
                    this.cache = i.concat([
                        this.cache,
                        e
                    ]);
                }, d.prototype.get = function(e) {
                    var t;
                    if (e) {
                        if (this.cache.length > 16) return t = this.cache.slice(0, 16), this.cache = this.cache.slice(16), t;
                    } else if (this.cache.length >= 16) return t = this.cache.slice(0, 16), this.cache = this.cache.slice(16), t;
                    return null;
                }, d.prototype.flush = function() {
                    if (this.cache.length) return this.cache;
                }, t.createDecipher = function(e, t) {
                    var r = o[e.toLowerCase()];
                    if (!r) throw new TypeError("invalid suite type");
                    var n = c(t, !1, r.key, r.iv);
                    return l(e, n.key, n.iv);
                }, t.createDecipheriv = l;
            },
            85478: (e, t, r)=>{
                "use strict";
                var n = r(58408), i = r(10426), o = r(48850).Buffer, a = r(21408), s = r(93013), u = r(37494), c = r(27085);
                function f(e, t, r) {
                    s.call(this), this._cache = new l, this._cipher = new u.AES(t), this._prev = o.from(r), this._mode = e, this._autopadding = !0;
                }
                r(41736)(f, s), f.prototype._update = function(e) {
                    var t, r;
                    this._cache.add(e);
                    for(var n = []; t = this._cache.get();)r = this._mode.encrypt(this, t), n.push(r);
                    return o.concat(n);
                };
                var d = o.alloc(16, 16);
                function l() {
                    this.cache = o.allocUnsafe(0);
                }
                function h(e, t, r) {
                    var s = n[e.toLowerCase()];
                    if (!s) throw new TypeError("invalid suite type");
                    if ("string" == typeof t && (t = o.from(t)), t.length !== s.key / 8) throw new TypeError("invalid key length " + t.length);
                    if ("string" == typeof r && (r = o.from(r)), "GCM" !== s.mode && r.length !== s.iv) throw new TypeError("invalid iv length " + r.length);
                    return "stream" === s.type ? new a(s.module, t, r) : "auth" === s.type ? new i(s.module, t, r) : new f(s.module, t, r);
                }
                f.prototype._final = function() {
                    var e = this._cache.flush();
                    if (this._autopadding) return e = this._mode.encrypt(this, e), this._cipher.scrub(), e;
                    if (!e.equals(d)) throw this._cipher.scrub(), new Error("data not multiple of block length");
                }, f.prototype.setAutoPadding = function(e) {
                    return this._autopadding = !!e, this;
                }, l.prototype.add = function(e) {
                    this.cache = o.concat([
                        this.cache,
                        e
                    ]);
                }, l.prototype.get = function() {
                    if (this.cache.length > 15) {
                        var e = this.cache.slice(0, 16);
                        return this.cache = this.cache.slice(16), e;
                    }
                    return null;
                }, l.prototype.flush = function() {
                    for(var e = 16 - this.cache.length, t = o.allocUnsafe(e), r = -1; ++r < e;)t.writeUInt8(e, r);
                    return o.concat([
                        this.cache,
                        t
                    ]);
                }, t.createCipheriv = h, t.createCipher = function(e, t) {
                    var r = n[e.toLowerCase()];
                    if (!r) throw new TypeError("invalid suite type");
                    var i = c(t, !1, r.key, r.iv);
                    return h(e, i.key, i.iv);
                };
            },
            26626: (e, t, r)=>{
                "use strict";
                var n = r(48850).Buffer, i = n.alloc(16, 0);
                function o(e) {
                    var t = n.allocUnsafe(16);
                    return t.writeUInt32BE(e[0] >>> 0, 0), t.writeUInt32BE(e[1] >>> 0, 4), t.writeUInt32BE(e[2] >>> 0, 8), t.writeUInt32BE(e[3] >>> 0, 12), t;
                }
                function a(e) {
                    this.h = e, this.state = n.alloc(16, 0), this.cache = n.allocUnsafe(0);
                }
                a.prototype.ghash = function(e) {
                    for(var t = -1; ++t < e.length;)this.state[t] ^= e[t];
                    this._multiply();
                }, a.prototype._multiply = function() {
                    for(var e, t, r, n = [
                        (e = this.h).readUInt32BE(0),
                        e.readUInt32BE(4),
                        e.readUInt32BE(8),
                        e.readUInt32BE(12)
                    ], i = [
                        0,
                        0,
                        0,
                        0
                    ], a = -1; ++a < 128;){
                        for(0 != (this.state[~~(a / 8)] & 1 << 7 - a % 8) && (i[0] ^= n[0], i[1] ^= n[1], i[2] ^= n[2], i[3] ^= n[3]), r = 0 != (1 & n[3]), t = 3; t > 0; t--)n[t] = n[t] >>> 1 | (1 & n[t - 1]) << 31;
                        n[0] = n[0] >>> 1, r && (n[0] = n[0] ^ -520093696);
                    }
                    this.state = o(i);
                }, a.prototype.update = function(e) {
                    var t;
                    for(this.cache = n.concat([
                        this.cache,
                        e
                    ]); this.cache.length >= 16;)t = this.cache.slice(0, 16), this.cache = this.cache.slice(16), this.ghash(t);
                }, a.prototype.final = function(e, t) {
                    return this.cache.length && this.ghash(n.concat([
                        this.cache,
                        i
                    ], 16)), this.ghash(o([
                        0,
                        e,
                        0,
                        t
                    ])), this.state;
                }, e.exports = a;
            },
            67557: (e)=>{
                "use strict";
                e.exports = function(e) {
                    for(var t, r = e.length; r--;){
                        if (255 !== (t = e.readUInt8(r))) {
                            t++, e.writeUInt8(t, r);
                            break;
                        }
                        e.writeUInt8(0, r);
                    }
                };
            },
            77427: (e, t, r)=>{
                "use strict";
                var n = r(96316);
                t.encrypt = function(e, t) {
                    var r = n(t, e._prev);
                    return e._prev = e._cipher.encryptBlock(r), e._prev;
                }, t.decrypt = function(e, t) {
                    var r = e._prev;
                    e._prev = t;
                    var i = e._cipher.decryptBlock(t);
                    return n(i, r);
                };
            },
            44030: (e, t, r)=>{
                "use strict";
                var n = r(48850).Buffer, i = r(96316);
                function o(e, t, r) {
                    var o = t.length, a = i(t, e._cache);
                    return e._cache = e._cache.slice(o), e._prev = n.concat([
                        e._prev,
                        r ? t : a
                    ]), a;
                }
                t.encrypt = function(e, t, r) {
                    for(var i, a = n.allocUnsafe(0); t.length;){
                        if (0 === e._cache.length && (e._cache = e._cipher.encryptBlock(e._prev), e._prev = n.allocUnsafe(0)), !(e._cache.length <= t.length)) {
                            a = n.concat([
                                a,
                                o(e, t, r)
                            ]);
                            break;
                        }
                        i = e._cache.length, a = n.concat([
                            a,
                            o(e, t.slice(0, i), r)
                        ]), t = t.slice(i);
                    }
                    return a;
                };
            },
            13206: (e, t, r)=>{
                "use strict";
                var n = r(48850).Buffer;
                function i(e, t, r) {
                    for(var n, i, a = -1, s = 0; ++a < 8;)n = t & 1 << 7 - a ? 128 : 0, s += (128 & (i = e._cipher.encryptBlock(e._prev)[0] ^ n)) >> a % 8, e._prev = o(e._prev, r ? n : i);
                    return s;
                }
                function o(e, t) {
                    var r = e.length, i = -1, o = n.allocUnsafe(e.length);
                    for(e = n.concat([
                        e,
                        n.from([
                            t
                        ])
                    ]); ++i < r;)o[i] = e[i] << 1 | e[i + 1] >> 7;
                    return o;
                }
                t.encrypt = function(e, t, r) {
                    for(var o = t.length, a = n.allocUnsafe(o), s = -1; ++s < o;)a[s] = i(e, t[s], r);
                    return a;
                };
            },
            14726: (e, t, r)=>{
                "use strict";
                var n = r(48850).Buffer;
                function i(e, t, r) {
                    var i = e._cipher.encryptBlock(e._prev)[0] ^ t;
                    return e._prev = n.concat([
                        e._prev.slice(1),
                        n.from([
                            r ? t : i
                        ])
                    ]), i;
                }
                t.encrypt = function(e, t, r) {
                    for(var o = t.length, a = n.allocUnsafe(o), s = -1; ++s < o;)a[s] = i(e, t[s], r);
                    return a;
                };
            },
            32802: (e, t, r)=>{
                "use strict";
                var n = r(96316), i = r(48850).Buffer, o = r(67557);
                function a(e) {
                    var t = e._cipher.encryptBlockRaw(e._prev);
                    return o(e._prev), t;
                }
                t.encrypt = function(e, t) {
                    var r = Math.ceil(t.length / 16), o = e._cache.length;
                    e._cache = i.concat([
                        e._cache,
                        i.allocUnsafe(16 * r)
                    ]);
                    for(var s = 0; s < r; s++){
                        var u = a(e), c = o + 16 * s;
                        e._cache.writeUInt32BE(u[0], c + 0), e._cache.writeUInt32BE(u[1], c + 4), e._cache.writeUInt32BE(u[2], c + 8), e._cache.writeUInt32BE(u[3], c + 12);
                    }
                    var f = e._cache.slice(0, t.length);
                    return e._cache = e._cache.slice(t.length), n(t, f);
                };
            },
            59297: (e, t)=>{
                "use strict";
                t.encrypt = function(e, t) {
                    return e._cipher.encryptBlock(t);
                }, t.decrypt = function(e, t) {
                    return e._cipher.decryptBlock(t);
                };
            },
            58408: (e, t, r)=>{
                "use strict";
                var n = {
                    ECB: r(59297),
                    CBC: r(77427),
                    CFB: r(44030),
                    CFB8: r(14726),
                    CFB1: r(13206),
                    OFB: r(91962),
                    CTR: r(32802),
                    GCM: r(32802)
                }, i = r(44946);
                for(var o in i)i[o].module = n[i[o].mode];
                e.exports = i;
            },
            91962: (e, t, r)=>{
                "use strict";
                var n = r(29033).Buffer, i = r(96316);
                function o(e) {
                    return e._prev = e._cipher.encryptBlock(e._prev), e._prev;
                }
                t.encrypt = function(e, t) {
                    for(; e._cache.length < t.length;)e._cache = n.concat([
                        e._cache,
                        o(e)
                    ]);
                    var r = e._cache.slice(0, t.length);
                    return e._cache = e._cache.slice(t.length), i(t, r);
                };
            },
            21408: (e, t, r)=>{
                "use strict";
                var n = r(37494), i = r(48850).Buffer, o = r(93013);
                function a(e, t, r, a) {
                    o.call(this), this._cipher = new n.AES(t), this._prev = i.from(r), this._cache = i.allocUnsafe(0), this._secCache = i.allocUnsafe(0), this._decrypt = a, this._mode = e;
                }
                r(41736)(a, o), a.prototype._update = function(e) {
                    return this._mode.encrypt(this, e, this._decrypt);
                }, a.prototype._final = function() {
                    this._cipher.scrub();
                }, e.exports = a;
            },
            56805: (e, t, r)=>{
                "use strict";
                var n = r(19120), i = r(98073), o = r(58408), a = r(30867), s = r(27085);
                function u(e, t, r) {
                    if (e = e.toLowerCase(), o[e]) return i.createCipheriv(e, t, r);
                    if (a[e]) return new n({
                        key: t,
                        iv: r,
                        mode: e
                    });
                    throw new TypeError("invalid suite type");
                }
                function c(e, t, r) {
                    if (e = e.toLowerCase(), o[e]) return i.createDecipheriv(e, t, r);
                    if (a[e]) return new n({
                        key: t,
                        iv: r,
                        mode: e,
                        decrypt: !0
                    });
                    throw new TypeError("invalid suite type");
                }
                t.createCipher = t.Cipher = function(e, t) {
                    var r, n;
                    if (e = e.toLowerCase(), o[e]) r = o[e].key, n = o[e].iv;
                    else {
                        if (!a[e]) throw new TypeError("invalid suite type");
                        r = 8 * a[e].key, n = a[e].iv;
                    }
                    var i = s(t, !1, r, n);
                    return u(e, i.key, i.iv);
                }, t.createCipheriv = t.Cipheriv = u, t.createDecipher = t.Decipher = function(e, t) {
                    var r, n;
                    if (e = e.toLowerCase(), o[e]) r = o[e].key, n = o[e].iv;
                    else {
                        if (!a[e]) throw new TypeError("invalid suite type");
                        r = 8 * a[e].key, n = a[e].iv;
                    }
                    var i = s(t, !1, r, n);
                    return c(e, i.key, i.iv);
                }, t.createDecipheriv = t.Decipheriv = c, t.listCiphers = t.getCiphers = function() {
                    return Object.keys(a).concat(i.getCiphers());
                };
            },
            19120: (e, t, r)=>{
                "use strict";
                var n = r(93013), i = r(75626), o = r(41736), a = r(48850).Buffer, s = {
                    "des-ede3-cbc": i.CBC.instantiate(i.EDE),
                    "des-ede3": i.EDE,
                    "des-ede-cbc": i.CBC.instantiate(i.EDE),
                    "des-ede": i.EDE,
                    "des-cbc": i.CBC.instantiate(i.DES),
                    "des-ecb": i.DES
                };
                function u(e) {
                    n.call(this);
                    var t, r = e.mode.toLowerCase(), i = s[r];
                    t = e.decrypt ? "decrypt" : "encrypt";
                    var o = e.key;
                    a.isBuffer(o) || (o = a.from(o)), "des-ede" !== r && "des-ede-cbc" !== r || (o = a.concat([
                        o,
                        o.slice(0, 8)
                    ]));
                    var u = e.iv;
                    a.isBuffer(u) || (u = a.from(u)), this._des = i.create({
                        key: o,
                        iv: u,
                        type: t
                    });
                }
                s.des = s["des-cbc"], s.des3 = s["des-ede3-cbc"], e.exports = u, o(u, n), u.prototype._update = function(e) {
                    return a.from(this._des.update(e));
                }, u.prototype._final = function() {
                    return a.from(this._des.final());
                };
            },
            30867: (e, t)=>{
                "use strict";
                t["des-ecb"] = {
                    key: 8,
                    iv: 0
                }, t["des-cbc"] = t.des = {
                    key: 8,
                    iv: 8
                }, t["des-ede3-cbc"] = t.des3 = {
                    key: 24,
                    iv: 8
                }, t["des-ede3"] = {
                    key: 24,
                    iv: 0
                }, t["des-ede-cbc"] = {
                    key: 16,
                    iv: 8
                }, t["des-ede"] = {
                    key: 16,
                    iv: 0
                };
            },
            99782: (e, t, r)=>{
                "use strict";
                var n = r(29033).Buffer, i = r(31734), o = r(75010);
                function a(e) {
                    var t, r = e.modulus.byteLength();
                    do t = new i(o(r));
                    while (t.cmp(e.modulus) >= 0 || !t.umod(e.prime1) || !t.umod(e.prime2));
                    return t;
                }
                function s(e, t) {
                    var r = function(e) {
                        var t = a(e);
                        return {
                            blinder: t.toRed(i.mont(e.modulus)).redPow(new i(e.publicExponent)).fromRed(),
                            unblinder: t.invm(e.modulus)
                        };
                    }(t), o = t.modulus.byteLength(), s = new i(e).mul(r.blinder).umod(t.modulus), u = s.toRed(i.mont(t.prime1)), c = s.toRed(i.mont(t.prime2)), f = t.coefficient, d = t.prime1, l = t.prime2, h = u.redPow(t.exponent1).fromRed(), p = c.redPow(t.exponent2).fromRed(), b = h.isub(p).imul(f).umod(d).imul(l);
                    return p.iadd(b).imul(r.unblinder).umod(t.modulus).toArrayLike(n, "be", o);
                }
                s.getr = a, e.exports = s;
            },
            26561: (e, t, r)=>{
                "use strict";
                e.exports = r(75207);
            },
            79527: (e, t, r)=>{
                "use strict";
                var n = r(48850).Buffer, i = r(35866), o = r(86505), a = r(41736), s = r(11628), u = r(15410), c = r(75207);
                function f(e) {
                    o.Writable.call(this);
                    var t = c[e];
                    if (!t) throw new Error("Unknown message digest");
                    this._hashType = t.hash, this._hash = i(t.hash), this._tag = t.id, this._signType = t.sign;
                }
                function d(e) {
                    o.Writable.call(this);
                    var t = c[e];
                    if (!t) throw new Error("Unknown message digest");
                    this._hash = i(t.hash), this._tag = t.id, this._signType = t.sign;
                }
                function l(e) {
                    return new f(e);
                }
                function h(e) {
                    return new d(e);
                }
                Object.keys(c).forEach(function(e) {
                    c[e].id = n.from(c[e].id, "hex"), c[e.toLowerCase()] = c[e];
                }), a(f, o.Writable), f.prototype._write = function(e, t, r) {
                    this._hash.update(e), r();
                }, f.prototype.update = function(e, t) {
                    return this._hash.update("string" == typeof e ? n.from(e, t) : e), this;
                }, f.prototype.sign = function(e, t) {
                    this.end();
                    var r = this._hash.digest(), n = s(r, e, this._hashType, this._signType, this._tag);
                    return t ? n.toString(t) : n;
                }, a(d, o.Writable), d.prototype._write = function(e, t, r) {
                    this._hash.update(e), r();
                }, d.prototype.update = function(e, t) {
                    return this._hash.update("string" == typeof e ? n.from(e, t) : e), this;
                }, d.prototype.verify = function(e, t, r) {
                    var i = "string" == typeof t ? n.from(t, r) : t;
                    this.end();
                    var o = this._hash.digest();
                    return u(i, o, e, this._signType, this._tag);
                }, e.exports = {
                    Sign: l,
                    Verify: h,
                    createSign: l,
                    createVerify: h
                };
            },
            11628: (e, t, r)=>{
                "use strict";
                var n = r(48850).Buffer, i = r(34424), o = r(99782), a = r(36597).ec, s = r(31734), u = r(27552), c = r(1308);
                function f(e, t, r, o) {
                    if ((e = n.from(e.toArray())).length < t.byteLength()) {
                        var a = n.alloc(t.byteLength() - e.length);
                        e = n.concat([
                            a,
                            e
                        ]);
                    }
                    var s = r.length, u = function(e, t) {
                        e = (e = d(e, t)).mod(t);
                        var r = n.from(e.toArray());
                        if (r.length < t.byteLength()) {
                            var i = n.alloc(t.byteLength() - r.length);
                            r = n.concat([
                                i,
                                r
                            ]);
                        }
                        return r;
                    }(r, t), c = n.alloc(s);
                    c.fill(1);
                    var f = n.alloc(s);
                    return f = i(o, f).update(c).update(n.from([
                        0
                    ])).update(e).update(u).digest(), c = i(o, f).update(c).digest(), {
                        k: f = i(o, f).update(c).update(n.from([
                            1
                        ])).update(e).update(u).digest(),
                        v: c = i(o, f).update(c).digest()
                    };
                }
                function d(e, t) {
                    var r = new s(e), n = (e.length << 3) - t.bitLength();
                    return n > 0 && r.ishrn(n), r;
                }
                function l(e, t, r) {
                    var o, a;
                    do {
                        for(o = n.alloc(0); 8 * o.length < e.bitLength();)t.v = i(r, t.k).update(t.v).digest(), o = n.concat([
                            o,
                            t.v
                        ]);
                        a = d(o, e), t.k = i(r, t.k).update(t.v).update(n.from([
                            0
                        ])).digest(), t.v = i(r, t.k).update(t.v).digest();
                    }while (-1 !== a.cmp(e));
                    return a;
                }
                function h(e, t, r, n) {
                    return e.toRed(s.mont(r)).redPow(t).fromRed().mod(n);
                }
                e.exports = function(e, t, r, i, p) {
                    var b = u(t);
                    if (b.curve) {
                        if ("ecdsa" !== i && "ecdsa/rsa" !== i) throw new Error("wrong private key type");
                        return function(e, t) {
                            var r = c[t.curve.join(".")];
                            if (!r) throw new Error("unknown curve " + t.curve.join("."));
                            var i = new a(r).keyFromPrivate(t.privateKey).sign(e);
                            return n.from(i.toDER());
                        }(e, b);
                    }
                    if ("dsa" === b.type) {
                        if ("dsa" !== i) throw new Error("wrong private key type");
                        return function(e, t, r) {
                            for(var i, o = t.params.priv_key, a = t.params.p, u = t.params.q, c = t.params.g, p = new s(0), b = d(e, u).mod(u), y = !1, v = f(o, u, e, r); !1 === y;)p = h(c, i = l(u, v, r), a, u), 0 === (y = i.invm(u).imul(b.add(o.mul(p))).mod(u)).cmpn(0) && (y = !1, p = new s(0));
                            return function(e, t) {
                                e = e.toArray(), t = t.toArray(), 128 & e[0] && (e = [
                                    0
                                ].concat(e)), 128 & t[0] && (t = [
                                    0
                                ].concat(t));
                                var r = [
                                    48,
                                    e.length + t.length + 4,
                                    2,
                                    e.length
                                ];
                                return r = r.concat(e, [
                                    2,
                                    t.length
                                ], t), n.from(r);
                            }(p, y);
                        }(e, b, r);
                    }
                    if ("rsa" !== i && "ecdsa/rsa" !== i) throw new Error("wrong private key type");
                    if (void 0 !== t.padding && 1 !== t.padding) throw new Error("illegal or unsupported padding mode");
                    e = n.concat([
                        p,
                        e
                    ]);
                    for(var y = b.modulus.byteLength(), v = [
                        0,
                        1
                    ]; e.length + v.length + 1 < y;)v.push(255);
                    v.push(0);
                    for(var m = -1; ++m < e.length;)v.push(e[m]);
                    return o(v, b);
                }, e.exports.getKey = f, e.exports.makeKey = l;
            },
            15410: (e, t, r)=>{
                "use strict";
                var n = r(48850).Buffer, i = r(31734), o = r(36597).ec, a = r(27552), s = r(1308);
                function u(e, t) {
                    if (e.cmpn(0) <= 0) throw new Error("invalid sig");
                    if (e.cmp(t) >= 0) throw new Error("invalid sig");
                }
                e.exports = function(e, t, r, c, f) {
                    var d = a(r);
                    if ("ec" === d.type) {
                        if ("ecdsa" !== c && "ecdsa/rsa" !== c) throw new Error("wrong public key type");
                        return function(e, t, r) {
                            var n = s[r.data.algorithm.curve.join(".")];
                            if (!n) throw new Error("unknown curve " + r.data.algorithm.curve.join("."));
                            var i = new o(n), a = r.data.subjectPrivateKey.data;
                            return i.verify(t, e, a);
                        }(e, t, d);
                    }
                    if ("dsa" === d.type) {
                        if ("dsa" !== c) throw new Error("wrong public key type");
                        return function(e, t, r) {
                            var n = r.data.p, o = r.data.q, s = r.data.g, c = r.data.pub_key, f = a.signature.decode(e, "der"), d = f.s, l = f.r;
                            u(d, o), u(l, o);
                            var h = i.mont(n), p = d.invm(o);
                            return 0 === s.toRed(h).redPow(new i(t).mul(p).mod(o)).fromRed().mul(c.toRed(h).redPow(l.mul(p).mod(o)).fromRed()).mod(n).mod(o).cmp(l);
                        }(e, t, d);
                    }
                    if ("rsa" !== c && "ecdsa/rsa" !== c) throw new Error("wrong public key type");
                    t = n.concat([
                        f,
                        t
                    ]);
                    for(var l = d.modulus.byteLength(), h = [
                        1
                    ], p = 0; t.length + h.length + 2 < l;)h.push(255), p += 1;
                    h.push(0);
                    for(var b = -1; ++b < t.length;)h.push(t[b]);
                    h = n.from(h);
                    var y = i.mont(d.modulus);
                    e = (e = new i(e).toRed(y)).redPow(new i(d.publicExponent)), e = n.from(e.fromRed().toArray());
                    var v = p < 8 ? 1 : 0;
                    for(l = Math.min(e.length, h.length), e.length !== h.length && (v = 1), b = -1; ++b < l;)v |= e[b] ^ h[b];
                    return 0 === v;
                };
            },
            19626: (e, t, r)=>{
                "use strict";
                var n = r(29033).Buffer, i = r(19142), o = r(3894), a = r(47563), s = r(54151), u = r(63534), c = r(29806);
                for(var f in c)t[f] = c[f];
                function d(e) {
                    if ("number" != typeof e || e < t.DEFLATE || e > t.UNZIP) throw new TypeError("Bad argument");
                    this.dictionary = null, this.err = 0, this.flush = 0, this.init_done = !1, this.level = 0, this.memLevel = 0, this.mode = e, this.strategy = 0, this.windowBits = 0, this.write_in_progress = !1, this.pending_close = !1, this.gzip_id_bytes_read = 0;
                }
                t.NONE = 0, t.DEFLATE = 1, t.INFLATE = 2, t.GZIP = 3, t.GUNZIP = 4, t.DEFLATERAW = 5, t.INFLATERAW = 6, t.UNZIP = 7, d.prototype.close = function() {
                    this.write_in_progress ? this.pending_close = !0 : (this.pending_close = !1, o(this.init_done, "close before init"), o(this.mode <= t.UNZIP), this.mode === t.DEFLATE || this.mode === t.GZIP || this.mode === t.DEFLATERAW ? s.deflateEnd(this.strm) : this.mode !== t.INFLATE && this.mode !== t.GUNZIP && this.mode !== t.INFLATERAW && this.mode !== t.UNZIP || u.inflateEnd(this.strm), this.mode = t.NONE, this.dictionary = null);
                }, d.prototype.write = function(e, t, r, n, i, o, a) {
                    return this._write(!0, e, t, r, n, i, o, a);
                }, d.prototype.writeSync = function(e, t, r, n, i, o, a) {
                    return this._write(!1, e, t, r, n, i, o, a);
                }, d.prototype._write = function(e, r, a, s, u, c, f, d) {
                    if (o.equal(arguments.length, 8), o(this.init_done, "write before init"), o(this.mode !== t.NONE, "already finalized"), o.equal(!1, this.write_in_progress, "write already in progress"), o.equal(!1, this.pending_close, "close is pending"), this.write_in_progress = !0, o.equal(!1, void 0 === r, "must provide flush value"), this.write_in_progress = !0, r !== t.Z_NO_FLUSH && r !== t.Z_PARTIAL_FLUSH && r !== t.Z_SYNC_FLUSH && r !== t.Z_FULL_FLUSH && r !== t.Z_FINISH && r !== t.Z_BLOCK) throw new Error("Invalid flush value");
                    if (null == a && (a = n.alloc(0), u = 0, s = 0), this.strm.avail_in = u, this.strm.input = a, this.strm.next_in = s, this.strm.avail_out = d, this.strm.output = c, this.strm.next_out = f, this.flush = r, !e) return this._process(), this._checkError() ? this._afterSync() : void 0;
                    var l = this;
                    return i.nextTick(function() {
                        l._process(), l._after();
                    }), this;
                }, d.prototype._afterSync = function() {
                    var e = this.strm.avail_out, t = this.strm.avail_in;
                    return this.write_in_progress = !1, [
                        t,
                        e
                    ];
                }, d.prototype._process = function() {
                    var e = null;
                    switch(this.mode){
                        case t.DEFLATE:
                        case t.GZIP:
                        case t.DEFLATERAW:
                            this.err = s.deflate(this.strm, this.flush);
                            break;
                        case t.UNZIP:
                            switch(this.strm.avail_in > 0 && (e = this.strm.next_in), this.gzip_id_bytes_read){
                                case 0:
                                    if (null === e) break;
                                    if (31 !== this.strm.input[e]) {
                                        this.mode = t.INFLATE;
                                        break;
                                    }
                                    if (this.gzip_id_bytes_read = 1, e++, 1 === this.strm.avail_in) break;
                                case 1:
                                    if (null === e) break;
                                    139 === this.strm.input[e] ? (this.gzip_id_bytes_read = 2, this.mode = t.GUNZIP) : this.mode = t.INFLATE;
                                    break;
                                default:
                                    throw new Error("invalid number of gzip magic number bytes read");
                            }
                        case t.INFLATE:
                        case t.GUNZIP:
                        case t.INFLATERAW:
                            for(this.err = u.inflate(this.strm, this.flush), this.err === t.Z_NEED_DICT && this.dictionary && (this.err = u.inflateSetDictionary(this.strm, this.dictionary), this.err === t.Z_OK ? this.err = u.inflate(this.strm, this.flush) : this.err === t.Z_DATA_ERROR && (this.err = t.Z_NEED_DICT)); this.strm.avail_in > 0 && this.mode === t.GUNZIP && this.err === t.Z_STREAM_END && 0 !== this.strm.next_in[0];)this.reset(), this.err = u.inflate(this.strm, this.flush);
                            break;
                        default:
                            throw new Error("Unknown mode " + this.mode);
                    }
                }, d.prototype._checkError = function() {
                    switch(this.err){
                        case t.Z_OK:
                        case t.Z_BUF_ERROR:
                            if (0 !== this.strm.avail_out && this.flush === t.Z_FINISH) return this._error("unexpected end of file"), !1;
                            break;
                        case t.Z_STREAM_END:
                            break;
                        case t.Z_NEED_DICT:
                            return null == this.dictionary ? this._error("Missing dictionary") : this._error("Bad dictionary"), !1;
                        default:
                            return this._error("Zlib error"), !1;
                    }
                    return !0;
                }, d.prototype._after = function() {
                    if (this._checkError()) {
                        var e = this.strm.avail_out, t = this.strm.avail_in;
                        this.write_in_progress = !1, this.callback(t, e), this.pending_close && this.close();
                    }
                }, d.prototype._error = function(e) {
                    this.strm.msg && (e = this.strm.msg), this.onerror(e, this.err), this.write_in_progress = !1, this.pending_close && this.close();
                }, d.prototype.init = function(e, r, n, i, a) {
                    o(4 === arguments.length || 5 === arguments.length, "init(windowBits, level, memLevel, strategy, [dictionary])"), o(e >= 8 && e <= 15, "invalid windowBits"), o(r >= -1 && r <= 9, "invalid compression level"), o(n >= 1 && n <= 9, "invalid memlevel"), o(i === t.Z_FILTERED || i === t.Z_HUFFMAN_ONLY || i === t.Z_RLE || i === t.Z_FIXED || i === t.Z_DEFAULT_STRATEGY, "invalid strategy"), this._init(r, e, n, i, a), this._setDictionary();
                }, d.prototype.params = function() {
                    throw new Error("deflateParams Not supported");
                }, d.prototype.reset = function() {
                    this._reset(), this._setDictionary();
                }, d.prototype._init = function(e, r, n, i, o) {
                    switch(this.level = e, this.windowBits = r, this.memLevel = n, this.strategy = i, this.flush = t.Z_NO_FLUSH, this.err = t.Z_OK, this.mode !== t.GZIP && this.mode !== t.GUNZIP || (this.windowBits += 16), this.mode === t.UNZIP && (this.windowBits += 32), this.mode !== t.DEFLATERAW && this.mode !== t.INFLATERAW || (this.windowBits = -1 * this.windowBits), this.strm = new a, this.mode){
                        case t.DEFLATE:
                        case t.GZIP:
                        case t.DEFLATERAW:
                            this.err = s.deflateInit2(this.strm, this.level, t.Z_DEFLATED, this.windowBits, this.memLevel, this.strategy);
                            break;
                        case t.INFLATE:
                        case t.GUNZIP:
                        case t.INFLATERAW:
                        case t.UNZIP:
                            this.err = u.inflateInit2(this.strm, this.windowBits);
                            break;
                        default:
                            throw new Error("Unknown mode " + this.mode);
                    }
                    this.err !== t.Z_OK && this._error("Init error"), this.dictionary = o, this.write_in_progress = !1, this.init_done = !0;
                }, d.prototype._setDictionary = function() {
                    if (null != this.dictionary) {
                        switch(this.err = t.Z_OK, this.mode){
                            case t.DEFLATE:
                            case t.DEFLATERAW:
                                this.err = s.deflateSetDictionary(this.strm, this.dictionary);
                        }
                        this.err !== t.Z_OK && this._error("Failed to set dictionary");
                    }
                }, d.prototype._reset = function() {
                    switch(this.err = t.Z_OK, this.mode){
                        case t.DEFLATE:
                        case t.DEFLATERAW:
                        case t.GZIP:
                            this.err = s.deflateReset(this.strm);
                            break;
                        case t.INFLATE:
                        case t.INFLATERAW:
                        case t.GUNZIP:
                            this.err = u.inflateReset(this.strm);
                    }
                    this.err !== t.Z_OK && this._error("Failed to reset stream");
                }, t.Zlib = d;
            },
            77611: (e, t, r)=>{
                "use strict";
                var n = r(19142), i = r(29033).Buffer, o = r(57245).Transform, a = r(19626), s = r(45058), u = r(3894).ok, c = r(29033).kMaxLength, f = "Cannot create final Buffer. It would be larger than 0x" + c.toString(16) + " bytes";
                a.Z_MIN_WINDOWBITS = 8, a.Z_MAX_WINDOWBITS = 15, a.Z_DEFAULT_WINDOWBITS = 15, a.Z_MIN_CHUNK = 64, a.Z_MAX_CHUNK = 1 / 0, a.Z_DEFAULT_CHUNK = 16384, a.Z_MIN_MEMLEVEL = 1, a.Z_MAX_MEMLEVEL = 9, a.Z_DEFAULT_MEMLEVEL = 8, a.Z_MIN_LEVEL = -1, a.Z_MAX_LEVEL = 9, a.Z_DEFAULT_LEVEL = a.Z_DEFAULT_COMPRESSION;
                for(var d = Object.keys(a), l = 0; l < d.length; l++){
                    var h = d[l];
                    h.match(/^Z/) && Object.defineProperty(t, h, {
                        enumerable: !0,
                        value: a[h],
                        writable: !1
                    });
                }
                for(var p = {
                    Z_OK: a.Z_OK,
                    Z_STREAM_END: a.Z_STREAM_END,
                    Z_NEED_DICT: a.Z_NEED_DICT,
                    Z_ERRNO: a.Z_ERRNO,
                    Z_STREAM_ERROR: a.Z_STREAM_ERROR,
                    Z_DATA_ERROR: a.Z_DATA_ERROR,
                    Z_MEM_ERROR: a.Z_MEM_ERROR,
                    Z_BUF_ERROR: a.Z_BUF_ERROR,
                    Z_VERSION_ERROR: a.Z_VERSION_ERROR
                }, b = Object.keys(p), y = 0; y < b.length; y++){
                    var v = b[y];
                    p[p[v]] = v;
                }
                function m(e, t, r) {
                    var n = [], o = 0;
                    function a() {
                        for(var t; null !== (t = e.read());)n.push(t), o += t.length;
                        e.once("readable", a);
                    }
                    function s() {
                        var t, a = null;
                        o >= c ? a = new RangeError(f) : t = i.concat(n, o), n = [], e.close(), r(a, t);
                    }
                    e.on("error", function(t) {
                        e.removeListener("end", s), e.removeListener("readable", a), r(t);
                    }), e.on("end", s), e.end(t), a();
                }
                function g(e, t) {
                    if ("string" == typeof t && (t = i.from(t)), !i.isBuffer(t)) throw new TypeError("Not a string or buffer");
                    var r = e._finishFlushFlag;
                    return e._processChunk(t, r);
                }
                function w(e) {
                    if (!(this instanceof w)) return new w(e);
                    O.call(this, e, a.DEFLATE);
                }
                function k(e) {
                    if (!(this instanceof k)) return new k(e);
                    O.call(this, e, a.INFLATE);
                }
                function _(e) {
                    if (!(this instanceof _)) return new _(e);
                    O.call(this, e, a.GZIP);
                }
                function A(e) {
                    if (!(this instanceof A)) return new A(e);
                    O.call(this, e, a.GUNZIP);
                }
                function E(e) {
                    if (!(this instanceof E)) return new E(e);
                    O.call(this, e, a.DEFLATERAW);
                }
                function S(e) {
                    if (!(this instanceof S)) return new S(e);
                    O.call(this, e, a.INFLATERAW);
                }
                function x(e) {
                    if (!(this instanceof x)) return new x(e);
                    O.call(this, e, a.UNZIP);
                }
                function B(e) {
                    return e === a.Z_NO_FLUSH || e === a.Z_PARTIAL_FLUSH || e === a.Z_SYNC_FLUSH || e === a.Z_FULL_FLUSH || e === a.Z_FINISH || e === a.Z_BLOCK;
                }
                function O(e, r) {
                    var n = this;
                    if (this._opts = e = e || {}, this._chunkSize = e.chunkSize || t.Z_DEFAULT_CHUNK, o.call(this, e), e.flush && !B(e.flush)) throw new Error("Invalid flush flag: " + e.flush);
                    if (e.finishFlush && !B(e.finishFlush)) throw new Error("Invalid flush flag: " + e.finishFlush);
                    if (this._flushFlag = e.flush || a.Z_NO_FLUSH, this._finishFlushFlag = void 0 !== e.finishFlush ? e.finishFlush : a.Z_FINISH, e.chunkSize && (e.chunkSize < t.Z_MIN_CHUNK || e.chunkSize > t.Z_MAX_CHUNK)) throw new Error("Invalid chunk size: " + e.chunkSize);
                    if (e.windowBits && (e.windowBits < t.Z_MIN_WINDOWBITS || e.windowBits > t.Z_MAX_WINDOWBITS)) throw new Error("Invalid windowBits: " + e.windowBits);
                    if (e.level && (e.level < t.Z_MIN_LEVEL || e.level > t.Z_MAX_LEVEL)) throw new Error("Invalid compression level: " + e.level);
                    if (e.memLevel && (e.memLevel < t.Z_MIN_MEMLEVEL || e.memLevel > t.Z_MAX_MEMLEVEL)) throw new Error("Invalid memLevel: " + e.memLevel);
                    if (e.strategy && e.strategy != t.Z_FILTERED && e.strategy != t.Z_HUFFMAN_ONLY && e.strategy != t.Z_RLE && e.strategy != t.Z_FIXED && e.strategy != t.Z_DEFAULT_STRATEGY) throw new Error("Invalid strategy: " + e.strategy);
                    if (e.dictionary && !i.isBuffer(e.dictionary)) throw new Error("Invalid dictionary: it should be a Buffer instance");
                    this._handle = new a.Zlib(r);
                    var s = this;
                    this._hadError = !1, this._handle.onerror = function(e, r) {
                        P(s), s._hadError = !0;
                        var n = new Error(e);
                        n.errno = r, n.code = t.codes[r], s.emit("error", n);
                    };
                    var u = t.Z_DEFAULT_COMPRESSION;
                    "number" == typeof e.level && (u = e.level);
                    var c = t.Z_DEFAULT_STRATEGY;
                    "number" == typeof e.strategy && (c = e.strategy), this._handle.init(e.windowBits || t.Z_DEFAULT_WINDOWBITS, u, e.memLevel || t.Z_DEFAULT_MEMLEVEL, c, e.dictionary), this._buffer = i.allocUnsafe(this._chunkSize), this._offset = 0, this._level = u, this._strategy = c, this.once("end", this.close), Object.defineProperty(this, "_closed", {
                        get: function() {
                            return !n._handle;
                        },
                        configurable: !0,
                        enumerable: !0
                    });
                }
                function P(e, t) {
                    t && n.nextTick(t), e._handle && (e._handle.close(), e._handle = null);
                }
                function I(e) {
                    e.emit("close");
                }
                Object.defineProperty(t, "codes", {
                    enumerable: !0,
                    value: Object.freeze(p),
                    writable: !1
                }), t.Deflate = w, t.Inflate = k, t.Gzip = _, t.Gunzip = A, t.DeflateRaw = E, t.InflateRaw = S, t.Unzip = x, t.createDeflate = function(e) {
                    return new w(e);
                }, t.createInflate = function(e) {
                    return new k(e);
                }, t.createDeflateRaw = function(e) {
                    return new E(e);
                }, t.createInflateRaw = function(e) {
                    return new S(e);
                }, t.createGzip = function(e) {
                    return new _(e);
                }, t.createGunzip = function(e) {
                    return new A(e);
                }, t.createUnzip = function(e) {
                    return new x(e);
                }, t.deflate = function(e, t, r) {
                    return "function" == typeof t && (r = t, t = {}), m(new w(t), e, r);
                }, t.deflateSync = function(e, t) {
                    return g(new w(t), e);
                }, t.gzip = function(e, t, r) {
                    return "function" == typeof t && (r = t, t = {}), m(new _(t), e, r);
                }, t.gzipSync = function(e, t) {
                    return g(new _(t), e);
                }, t.deflateRaw = function(e, t, r) {
                    return "function" == typeof t && (r = t, t = {}), m(new E(t), e, r);
                }, t.deflateRawSync = function(e, t) {
                    return g(new E(t), e);
                }, t.unzip = function(e, t, r) {
                    return "function" == typeof t && (r = t, t = {}), m(new x(t), e, r);
                }, t.unzipSync = function(e, t) {
                    return g(new x(t), e);
                }, t.inflate = function(e, t, r) {
                    return "function" == typeof t && (r = t, t = {}), m(new k(t), e, r);
                }, t.inflateSync = function(e, t) {
                    return g(new k(t), e);
                }, t.gunzip = function(e, t, r) {
                    return "function" == typeof t && (r = t, t = {}), m(new A(t), e, r);
                }, t.gunzipSync = function(e, t) {
                    return g(new A(t), e);
                }, t.inflateRaw = function(e, t, r) {
                    return "function" == typeof t && (r = t, t = {}), m(new S(t), e, r);
                }, t.inflateRawSync = function(e, t) {
                    return g(new S(t), e);
                }, s.inherits(O, o), O.prototype.params = function(e, r, i) {
                    if (e < t.Z_MIN_LEVEL || e > t.Z_MAX_LEVEL) throw new RangeError("Invalid compression level: " + e);
                    if (r != t.Z_FILTERED && r != t.Z_HUFFMAN_ONLY && r != t.Z_RLE && r != t.Z_FIXED && r != t.Z_DEFAULT_STRATEGY) throw new TypeError("Invalid strategy: " + r);
                    if (this._level !== e || this._strategy !== r) {
                        var o = this;
                        this.flush(a.Z_SYNC_FLUSH, function() {
                            u(o._handle, "zlib binding closed"), o._handle.params(e, r), o._hadError || (o._level = e, o._strategy = r, i && i());
                        });
                    } else n.nextTick(i);
                }, O.prototype.reset = function() {
                    return u(this._handle, "zlib binding closed"), this._handle.reset();
                }, O.prototype._flush = function(e) {
                    this._transform(i.alloc(0), "", e);
                }, O.prototype.flush = function(e, t) {
                    var r = this, o = this._writableState;
                    ("function" == typeof e || void 0 === e && !t) && (t = e, e = a.Z_FULL_FLUSH), o.ended ? t && n.nextTick(t) : o.ending ? t && this.once("end", t) : o.needDrain ? t && this.once("drain", function() {
                        return r.flush(e, t);
                    }) : (this._flushFlag = e, this.write(i.alloc(0), "", t));
                }, O.prototype.close = function(e) {
                    P(this, e), n.nextTick(I, this);
                }, O.prototype._transform = function(e, t, r) {
                    var n, o = this._writableState, s = (o.ending || o.ended) && (!e || o.length === e.length);
                    return null === e || i.isBuffer(e) ? this._handle ? (s ? n = this._finishFlushFlag : (n = this._flushFlag, e.length >= o.length && (this._flushFlag = this._opts.flush || a.Z_NO_FLUSH)), void this._processChunk(e, n, r)) : r(new Error("zlib binding closed")) : r(new Error("invalid input"));
                }, O.prototype._processChunk = function(e, t, r) {
                    var n = e && e.length, o = this._chunkSize - this._offset, a = 0, s = this, d = "function" == typeof r;
                    if (!d) {
                        var l, h = [], p = 0;
                        this.on("error", function(e) {
                            l = e;
                        }), u(this._handle, "zlib binding closed");
                        do var b = this._handle.writeSync(t, e, a, n, this._buffer, this._offset, o);
                        while (!this._hadError && m(b[0], b[1]));
                        if (this._hadError) throw l;
                        if (p >= c) throw P(this), new RangeError(f);
                        var y = i.concat(h, p);
                        return P(this), y;
                    }
                    u(this._handle, "zlib binding closed");
                    var v = this._handle.write(t, e, a, n, this._buffer, this._offset, o);
                    function m(c, f) {
                        if (this && (this.buffer = null, this.callback = null), !s._hadError) {
                            var l = o - f;
                            if (u(l >= 0, "have should not go down"), l > 0) {
                                var b = s._buffer.slice(s._offset, s._offset + l);
                                s._offset += l, d ? s.push(b) : (h.push(b), p += b.length);
                            }
                            if ((0 === f || s._offset >= s._chunkSize) && (o = s._chunkSize, s._offset = 0, s._buffer = i.allocUnsafe(s._chunkSize)), 0 === f) {
                                if (a += n - c, n = c, !d) return !0;
                                var y = s._handle.write(t, e, a, n, s._buffer, s._offset, s._chunkSize);
                                return y.callback = m, void (y.buffer = e);
                            }
                            if (!d) return !1;
                            r();
                        }
                    }
                    v.buffer = e, v.callback = m;
                }, s.inherits(w, O), s.inherits(k, O), s.inherits(_, O), s.inherits(A, O), s.inherits(E, O), s.inherits(S, O), s.inherits(x, O);
            },
            96316: (e, t, r)=>{
                "use strict";
                var n = r(29033).Buffer;
                e.exports = function(e, t) {
                    for(var r = Math.min(e.length, t.length), i = new n(r), o = 0; o < r; ++o)i[o] = e[o] ^ t[o];
                    return i;
                };
            },
            29033: (e, t, r)=>{
                "use strict";
                var n = r(34919), i = r(83226), o = r(39484);
                function a() {
                    return u.TYPED_ARRAY_SUPPORT ? 2147483647 : 1073741823;
                }
                function s(e, t) {
                    if (a() < t) throw new RangeError("Invalid typed array length");
                    return u.TYPED_ARRAY_SUPPORT ? (e = new Uint8Array(t)).__proto__ = u.prototype : (null === e && (e = new u(t)), e.length = t), e;
                }
                function u(e, t, r) {
                    if (!(u.TYPED_ARRAY_SUPPORT || this instanceof u)) return new u(e, t, r);
                    if ("number" == typeof e) {
                        if ("string" == typeof t) throw new Error("If encoding is specified then the first argument must be a string");
                        return d(this, e);
                    }
                    return c(this, e, t, r);
                }
                function c(e, t, r, n) {
                    if ("number" == typeof t) throw new TypeError('"value" argument must not be a number');
                    return "undefined" != typeof ArrayBuffer && t instanceof ArrayBuffer ? function(e, t, r, n) {
                        if (t.byteLength, r < 0 || t.byteLength < r) throw new RangeError("'offset' is out of bounds");
                        if (t.byteLength < r + (n || 0)) throw new RangeError("'length' is out of bounds");
                        return t = void 0 === r && void 0 === n ? new Uint8Array(t) : void 0 === n ? new Uint8Array(t, r) : new Uint8Array(t, r, n), u.TYPED_ARRAY_SUPPORT ? (e = t).__proto__ = u.prototype : e = l(e, t), e;
                    }(e, t, r, n) : "string" == typeof t ? function(e, t, r) {
                        if ("string" == typeof r && "" !== r || (r = "utf8"), !u.isEncoding(r)) throw new TypeError('"encoding" must be a valid string encoding');
                        var n = 0 | p(t, r), i = (e = s(e, n)).write(t, r);
                        return i !== n && (e = e.slice(0, i)), e;
                    }(e, t, r) : function(e, t) {
                        if (u.isBuffer(t)) {
                            var r = 0 | h(t.length);
                            return 0 === (e = s(e, r)).length || t.copy(e, 0, 0, r), e;
                        }
                        if (t) {
                            if ("undefined" != typeof ArrayBuffer && t.buffer instanceof ArrayBuffer || "length" in t) return "number" != typeof t.length || (n = t.length) != n ? s(e, 0) : l(e, t);
                            if ("Buffer" === t.type && o(t.data)) return l(e, t.data);
                        }
                        var n;
                        throw new TypeError("First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.");
                    }(e, t);
                }
                function f(e) {
                    if ("number" != typeof e) throw new TypeError('"size" argument must be a number');
                    if (e < 0) throw new RangeError('"size" argument must not be negative');
                }
                function d(e, t) {
                    if (f(t), e = s(e, t < 0 ? 0 : 0 | h(t)), !u.TYPED_ARRAY_SUPPORT) for(var r = 0; r < t; ++r)e[r] = 0;
                    return e;
                }
                function l(e, t) {
                    var r = t.length < 0 ? 0 : 0 | h(t.length);
                    e = s(e, r);
                    for(var n = 0; n < r; n += 1)e[n] = 255 & t[n];
                    return e;
                }
                function h(e) {
                    if (e >= a()) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + a().toString(16) + " bytes");
                    return 0 | e;
                }
                function p(e, t) {
                    if (u.isBuffer(e)) return e.length;
                    if ("undefined" != typeof ArrayBuffer && "function" == typeof ArrayBuffer.isView && (ArrayBuffer.isView(e) || e instanceof ArrayBuffer)) return e.byteLength;
                    "string" != typeof e && (e = "" + e);
                    var r = e.length;
                    if (0 === r) return 0;
                    for(var n = !1;;)switch(t){
                        case "ascii":
                        case "latin1":
                        case "binary":
                            return r;
                        case "utf8":
                        case "utf-8":
                        case void 0:
                            return D(e).length;
                        case "ucs2":
                        case "ucs-2":
                        case "utf16le":
                        case "utf-16le":
                            return 2 * r;
                        case "hex":
                            return r >>> 1;
                        case "base64":
                            return H(e).length;
                        default:
                            if (n) return D(e).length;
                            t = ("" + t).toLowerCase(), n = !0;
                    }
                }
                function b(e, t, r) {
                    var n = !1;
                    if ((void 0 === t || t < 0) && (t = 0), t > this.length) return "";
                    if ((void 0 === r || r > this.length) && (r = this.length), r <= 0) return "";
                    if ((r >>>= 0) <= (t >>>= 0)) return "";
                    for(e || (e = "utf8");;)switch(e){
                        case "hex":
                            return I(this, t, r);
                        case "utf8":
                        case "utf-8":
                            return x(this, t, r);
                        case "ascii":
                            return O(this, t, r);
                        case "latin1":
                        case "binary":
                            return P(this, t, r);
                        case "base64":
                            return S(this, t, r);
                        case "ucs2":
                        case "ucs-2":
                        case "utf16le":
                        case "utf-16le":
                            return T(this, t, r);
                        default:
                            if (n) throw new TypeError("Unknown encoding: " + e);
                            e = (e + "").toLowerCase(), n = !0;
                    }
                }
                function y(e, t, r) {
                    var n = e[t];
                    e[t] = e[r], e[r] = n;
                }
                function v(e, t, r, n, i) {
                    if (0 === e.length) return -1;
                    if ("string" == typeof r ? (n = r, r = 0) : r > 2147483647 ? r = 2147483647 : r < -2147483648 && (r = -2147483648), r = +r, isNaN(r) && (r = i ? 0 : e.length - 1), r < 0 && (r = e.length + r), r >= e.length) {
                        if (i) return -1;
                        r = e.length - 1;
                    } else if (r < 0) {
                        if (!i) return -1;
                        r = 0;
                    }
                    if ("string" == typeof t && (t = u.from(t, n)), u.isBuffer(t)) return 0 === t.length ? -1 : m(e, t, r, n, i);
                    if ("number" == typeof t) return t &= 255, u.TYPED_ARRAY_SUPPORT && "function" == typeof Uint8Array.prototype.indexOf ? i ? Uint8Array.prototype.indexOf.call(e, t, r) : Uint8Array.prototype.lastIndexOf.call(e, t, r) : m(e, [
                        t
                    ], r, n, i);
                    throw new TypeError("val must be string, number or Buffer");
                }
                function m(e, t, r, n, i) {
                    var o, a = 1, s = e.length, u = t.length;
                    if (void 0 !== n && ("ucs2" === (n = String(n).toLowerCase()) || "ucs-2" === n || "utf16le" === n || "utf-16le" === n)) {
                        if (e.length < 2 || t.length < 2) return -1;
                        a = 2, s /= 2, u /= 2, r /= 2;
                    }
                    function c(e, t) {
                        return 1 === a ? e[t] : e.readUInt16BE(t * a);
                    }
                    if (i) {
                        var f = -1;
                        for(o = r; o < s; o++)if (c(e, o) === c(t, -1 === f ? 0 : o - f)) {
                            if (-1 === f && (f = o), o - f + 1 === u) return f * a;
                        } else -1 !== f && (o -= o - f), f = -1;
                    } else for(r + u > s && (r = s - u), o = r; o >= 0; o--){
                        for(var d = !0, l = 0; l < u; l++)if (c(e, o + l) !== c(t, l)) {
                            d = !1;
                            break;
                        }
                        if (d) return o;
                    }
                    return -1;
                }
                function g(e, t, r, n) {
                    r = Number(r) || 0;
                    var i = e.length - r;
                    n ? (n = Number(n)) > i && (n = i) : n = i;
                    var o = t.length;
                    if (o % 2 != 0) throw new TypeError("Invalid hex string");
                    n > o / 2 && (n = o / 2);
                    for(var a = 0; a < n; ++a){
                        var s = parseInt(t.substr(2 * a, 2), 16);
                        if (isNaN(s)) return a;
                        e[r + a] = s;
                    }
                    return a;
                }
                function w(e, t, r, n) {
                    return z(D(t, e.length - r), e, r, n);
                }
                function k(e, t, r, n) {
                    return z(function(e) {
                        for(var t = [], r = 0; r < e.length; ++r)t.push(255 & e.charCodeAt(r));
                        return t;
                    }(t), e, r, n);
                }
                function _(e, t, r, n) {
                    return k(e, t, r, n);
                }
                function A(e, t, r, n) {
                    return z(H(t), e, r, n);
                }
                function E(e, t, r, n) {
                    return z(function(e, t) {
                        for(var r, n, i, o = [], a = 0; a < e.length && !((t -= 2) < 0); ++a)n = (r = e.charCodeAt(a)) >> 8, i = r % 256, o.push(i), o.push(n);
                        return o;
                    }(t, e.length - r), e, r, n);
                }
                function S(e, t, r) {
                    return 0 === t && r === e.length ? n.fromByteArray(e) : n.fromByteArray(e.slice(t, r));
                }
                function x(e, t, r) {
                    r = Math.min(e.length, r);
                    for(var n = [], i = t; i < r;){
                        var o, a, s, u, c = e[i], f = null, d = c > 239 ? 4 : c > 223 ? 3 : c > 191 ? 2 : 1;
                        if (i + d <= r) switch(d){
                            case 1:
                                c < 128 && (f = c);
                                break;
                            case 2:
                                128 == (192 & (o = e[i + 1])) && (u = (31 & c) << 6 | 63 & o) > 127 && (f = u);
                                break;
                            case 3:
                                o = e[i + 1], a = e[i + 2], 128 == (192 & o) && 128 == (192 & a) && (u = (15 & c) << 12 | (63 & o) << 6 | 63 & a) > 2047 && (u < 55296 || u > 57343) && (f = u);
                                break;
                            case 4:
                                o = e[i + 1], a = e[i + 2], s = e[i + 3], 128 == (192 & o) && 128 == (192 & a) && 128 == (192 & s) && (u = (15 & c) << 18 | (63 & o) << 12 | (63 & a) << 6 | 63 & s) > 65535 && u < 1114112 && (f = u);
                        }
                        null === f ? (f = 65533, d = 1) : f > 65535 && (f -= 65536, n.push(f >>> 10 & 1023 | 55296), f = 56320 | 1023 & f), n.push(f), i += d;
                    }
                    return function(e) {
                        var t = e.length;
                        if (t <= B) return String.fromCharCode.apply(String, e);
                        for(var r = "", n = 0; n < t;)r += String.fromCharCode.apply(String, e.slice(n, n += B));
                        return r;
                    }(n);
                }
                t.Buffer = u, t.SlowBuffer = function(e) {
                    return +e != e && (e = 0), u.alloc(+e);
                }, t.INSPECT_MAX_BYTES = 50, u.TYPED_ARRAY_SUPPORT = void 0 !== r.g.TYPED_ARRAY_SUPPORT ? r.g.TYPED_ARRAY_SUPPORT : function() {
                    try {
                        var e = new Uint8Array(1);
                        return e.__proto__ = {
                            __proto__: Uint8Array.prototype,
                            foo: function() {
                                return 42;
                            }
                        }, 42 === e.foo() && "function" == typeof e.subarray && 0 === e.subarray(1, 1).byteLength;
                    } catch (e) {
                        return !1;
                    }
                }(), t.kMaxLength = a(), u.poolSize = 8192, u._augment = function(e) {
                    return e.__proto__ = u.prototype, e;
                }, u.from = function(e, t, r) {
                    return c(null, e, t, r);
                }, u.TYPED_ARRAY_SUPPORT && (u.prototype.__proto__ = Uint8Array.prototype, u.__proto__ = Uint8Array, "undefined" != typeof Symbol && Symbol.species && u[Symbol.species] === u && Object.defineProperty(u, Symbol.species, {
                    value: null,
                    configurable: !0
                })), u.alloc = function(e, t, r) {
                    return function(e, t, r, n) {
                        return f(t), t <= 0 ? s(e, t) : void 0 !== r ? "string" == typeof n ? s(e, t).fill(r, n) : s(e, t).fill(r) : s(e, t);
                    }(null, e, t, r);
                }, u.allocUnsafe = function(e) {
                    return d(null, e);
                }, u.allocUnsafeSlow = function(e) {
                    return d(null, e);
                }, u.isBuffer = function(e) {
                    return !(null == e || !e._isBuffer);
                }, u.compare = function(e, t) {
                    if (!u.isBuffer(e) || !u.isBuffer(t)) throw new TypeError("Arguments must be Buffers");
                    if (e === t) return 0;
                    for(var r = e.length, n = t.length, i = 0, o = Math.min(r, n); i < o; ++i)if (e[i] !== t[i]) {
                        r = e[i], n = t[i];
                        break;
                    }
                    return r < n ? -1 : n < r ? 1 : 0;
                }, u.isEncoding = function(e) {
                    switch(String(e).toLowerCase()){
                        case "hex":
                        case "utf8":
                        case "utf-8":
                        case "ascii":
                        case "latin1":
                        case "binary":
                        case "base64":
                        case "ucs2":
                        case "ucs-2":
                        case "utf16le":
                        case "utf-16le":
                            return !0;
                        default:
                            return !1;
                    }
                }, u.concat = function(e, t) {
                    if (!o(e)) throw new TypeError('"list" argument must be an Array of Buffers');
                    if (0 === e.length) return u.alloc(0);
                    var r;
                    if (void 0 === t) for(t = 0, r = 0; r < e.length; ++r)t += e[r].length;
                    var n = u.allocUnsafe(t), i = 0;
                    for(r = 0; r < e.length; ++r){
                        var a = e[r];
                        if (!u.isBuffer(a)) throw new TypeError('"list" argument must be an Array of Buffers');
                        a.copy(n, i), i += a.length;
                    }
                    return n;
                }, u.byteLength = p, u.prototype._isBuffer = !0, u.prototype.swap16 = function() {
                    var e = this.length;
                    if (e % 2 != 0) throw new RangeError("Buffer size must be a multiple of 16-bits");
                    for(var t = 0; t < e; t += 2)y(this, t, t + 1);
                    return this;
                }, u.prototype.swap32 = function() {
                    var e = this.length;
                    if (e % 4 != 0) throw new RangeError("Buffer size must be a multiple of 32-bits");
                    for(var t = 0; t < e; t += 4)y(this, t, t + 3), y(this, t + 1, t + 2);
                    return this;
                }, u.prototype.swap64 = function() {
                    var e = this.length;
                    if (e % 8 != 0) throw new RangeError("Buffer size must be a multiple of 64-bits");
                    for(var t = 0; t < e; t += 8)y(this, t, t + 7), y(this, t + 1, t + 6), y(this, t + 2, t + 5), y(this, t + 3, t + 4);
                    return this;
                }, u.prototype.toString = function() {
                    var e = 0 | this.length;
                    return 0 === e ? "" : 0 === arguments.length ? x(this, 0, e) : b.apply(this, arguments);
                }, u.prototype.equals = function(e) {
                    if (!u.isBuffer(e)) throw new TypeError("Argument must be a Buffer");
                    return this === e || 0 === u.compare(this, e);
                }, u.prototype.inspect = function() {
                    var e = "", r = t.INSPECT_MAX_BYTES;
                    return this.length > 0 && (e = this.toString("hex", 0, r).match(/.{2}/g).join(" "), this.length > r && (e += " ... ")), "<Buffer " + e + ">";
                }, u.prototype.compare = function(e, t, r, n, i) {
                    if (!u.isBuffer(e)) throw new TypeError("Argument must be a Buffer");
                    if (void 0 === t && (t = 0), void 0 === r && (r = e ? e.length : 0), void 0 === n && (n = 0), void 0 === i && (i = this.length), t < 0 || r > e.length || n < 0 || i > this.length) throw new RangeError("out of range index");
                    if (n >= i && t >= r) return 0;
                    if (n >= i) return -1;
                    if (t >= r) return 1;
                    if (this === e) return 0;
                    for(var o = (i >>>= 0) - (n >>>= 0), a = (r >>>= 0) - (t >>>= 0), s = Math.min(o, a), c = this.slice(n, i), f = e.slice(t, r), d = 0; d < s; ++d)if (c[d] !== f[d]) {
                        o = c[d], a = f[d];
                        break;
                    }
                    return o < a ? -1 : a < o ? 1 : 0;
                }, u.prototype.includes = function(e, t, r) {
                    return -1 !== this.indexOf(e, t, r);
                }, u.prototype.indexOf = function(e, t, r) {
                    return v(this, e, t, r, !0);
                }, u.prototype.lastIndexOf = function(e, t, r) {
                    return v(this, e, t, r, !1);
                }, u.prototype.write = function(e, t, r, n) {
                    if (void 0 === t) n = "utf8", r = this.length, t = 0;
                    else if (void 0 === r && "string" == typeof t) n = t, r = this.length, t = 0;
                    else {
                        if (!isFinite(t)) throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
                        t |= 0, isFinite(r) ? (r |= 0, void 0 === n && (n = "utf8")) : (n = r, r = void 0);
                    }
                    var i = this.length - t;
                    if ((void 0 === r || r > i) && (r = i), e.length > 0 && (r < 0 || t < 0) || t > this.length) throw new RangeError("Attempt to write outside buffer bounds");
                    n || (n = "utf8");
                    for(var o = !1;;)switch(n){
                        case "hex":
                            return g(this, e, t, r);
                        case "utf8":
                        case "utf-8":
                            return w(this, e, t, r);
                        case "ascii":
                            return k(this, e, t, r);
                        case "latin1":
                        case "binary":
                            return _(this, e, t, r);
                        case "base64":
                            return A(this, e, t, r);
                        case "ucs2":
                        case "ucs-2":
                        case "utf16le":
                        case "utf-16le":
                            return E(this, e, t, r);
                        default:
                            if (o) throw new TypeError("Unknown encoding: " + n);
                            n = ("" + n).toLowerCase(), o = !0;
                    }
                }, u.prototype.toJSON = function() {
                    return {
                        type: "Buffer",
                        data: Array.prototype.slice.call(this._arr || this, 0)
                    };
                };
                var B = 4096;
                function O(e, t, r) {
                    var n = "";
                    r = Math.min(e.length, r);
                    for(var i = t; i < r; ++i)n += String.fromCharCode(127 & e[i]);
                    return n;
                }
                function P(e, t, r) {
                    var n = "";
                    r = Math.min(e.length, r);
                    for(var i = t; i < r; ++i)n += String.fromCharCode(e[i]);
                    return n;
                }
                function I(e, t, r) {
                    var n, i = e.length;
                    (!t || t < 0) && (t = 0), (!r || r < 0 || r > i) && (r = i);
                    for(var o = "", a = t; a < r; ++a)o += (n = e[a]) < 16 ? "0" + n.toString(16) : n.toString(16);
                    return o;
                }
                function T(e, t, r) {
                    for(var n = e.slice(t, r), i = "", o = 0; o < n.length; o += 2)i += String.fromCharCode(n[o] + 256 * n[o + 1]);
                    return i;
                }
                function C(e, t, r) {
                    if (e % 1 != 0 || e < 0) throw new RangeError("offset is not uint");
                    if (e + t > r) throw new RangeError("Trying to access beyond buffer length");
                }
                function M(e, t, r, n, i, o) {
                    if (!u.isBuffer(e)) throw new TypeError('"buffer" argument must be a Buffer instance');
                    if (t > i || t < o) throw new RangeError('"value" argument is out of bounds');
                    if (r + n > e.length) throw new RangeError("Index out of range");
                }
                function R(e, t, r, n) {
                    t < 0 && (t = 65535 + t + 1);
                    for(var i = 0, o = Math.min(e.length - r, 2); i < o; ++i)e[r + i] = (t & 255 << 8 * (n ? i : 1 - i)) >>> 8 * (n ? i : 1 - i);
                }
                function U(e, t, r, n) {
                    t < 0 && (t = 4294967295 + t + 1);
                    for(var i = 0, o = Math.min(e.length - r, 4); i < o; ++i)e[r + i] = t >>> 8 * (n ? i : 3 - i) & 255;
                }
                function N(e, t, r, n, i, o) {
                    if (r + n > e.length) throw new RangeError("Index out of range");
                    if (r < 0) throw new RangeError("Index out of range");
                }
                function j(e, t, r, n, o) {
                    return o || N(e, 0, r, 4), i.write(e, t, r, n, 23, 4), r + 4;
                }
                function L(e, t, r, n, o) {
                    return o || N(e, 0, r, 8), i.write(e, t, r, n, 52, 8), r + 8;
                }
                u.prototype.slice = function(e, t) {
                    var r, n = this.length;
                    if ((e = ~~e) < 0 ? (e += n) < 0 && (e = 0) : e > n && (e = n), (t = void 0 === t ? n : ~~t) < 0 ? (t += n) < 0 && (t = 0) : t > n && (t = n), t < e && (t = e), u.TYPED_ARRAY_SUPPORT) (r = this.subarray(e, t)).__proto__ = u.prototype;
                    else {
                        var i = t - e;
                        r = new u(i, void 0);
                        for(var o = 0; o < i; ++o)r[o] = this[o + e];
                    }
                    return r;
                }, u.prototype.readUIntLE = function(e, t, r) {
                    e |= 0, t |= 0, r || C(e, t, this.length);
                    for(var n = this[e], i = 1, o = 0; ++o < t && (i *= 256);)n += this[e + o] * i;
                    return n;
                }, u.prototype.readUIntBE = function(e, t, r) {
                    e |= 0, t |= 0, r || C(e, t, this.length);
                    for(var n = this[e + --t], i = 1; t > 0 && (i *= 256);)n += this[e + --t] * i;
                    return n;
                }, u.prototype.readUInt8 = function(e, t) {
                    return t || C(e, 1, this.length), this[e];
                }, u.prototype.readUInt16LE = function(e, t) {
                    return t || C(e, 2, this.length), this[e] | this[e + 1] << 8;
                }, u.prototype.readUInt16BE = function(e, t) {
                    return t || C(e, 2, this.length), this[e] << 8 | this[e + 1];
                }, u.prototype.readUInt32LE = function(e, t) {
                    return t || C(e, 4, this.length), (this[e] | this[e + 1] << 8 | this[e + 2] << 16) + 16777216 * this[e + 3];
                }, u.prototype.readUInt32BE = function(e, t) {
                    return t || C(e, 4, this.length), 16777216 * this[e] + (this[e + 1] << 16 | this[e + 2] << 8 | this[e + 3]);
                }, u.prototype.readIntLE = function(e, t, r) {
                    e |= 0, t |= 0, r || C(e, t, this.length);
                    for(var n = this[e], i = 1, o = 0; ++o < t && (i *= 256);)n += this[e + o] * i;
                    return n >= (i *= 128) && (n -= Math.pow(2, 8 * t)), n;
                }, u.prototype.readIntBE = function(e, t, r) {
                    e |= 0, t |= 0, r || C(e, t, this.length);
                    for(var n = t, i = 1, o = this[e + --n]; n > 0 && (i *= 256);)o += this[e + --n] * i;
                    return o >= (i *= 128) && (o -= Math.pow(2, 8 * t)), o;
                }, u.prototype.readInt8 = function(e, t) {
                    return t || C(e, 1, this.length), 128 & this[e] ? -1 * (255 - this[e] + 1) : this[e];
                }, u.prototype.readInt16LE = function(e, t) {
                    t || C(e, 2, this.length);
                    var r = this[e] | this[e + 1] << 8;
                    return 32768 & r ? 4294901760 | r : r;
                }, u.prototype.readInt16BE = function(e, t) {
                    t || C(e, 2, this.length);
                    var r = this[e + 1] | this[e] << 8;
                    return 32768 & r ? 4294901760 | r : r;
                }, u.prototype.readInt32LE = function(e, t) {
                    return t || C(e, 4, this.length), this[e] | this[e + 1] << 8 | this[e + 2] << 16 | this[e + 3] << 24;
                }, u.prototype.readInt32BE = function(e, t) {
                    return t || C(e, 4, this.length), this[e] << 24 | this[e + 1] << 16 | this[e + 2] << 8 | this[e + 3];
                }, u.prototype.readFloatLE = function(e, t) {
                    return t || C(e, 4, this.length), i.read(this, e, !0, 23, 4);
                }, u.prototype.readFloatBE = function(e, t) {
                    return t || C(e, 4, this.length), i.read(this, e, !1, 23, 4);
                }, u.prototype.readDoubleLE = function(e, t) {
                    return t || C(e, 8, this.length), i.read(this, e, !0, 52, 8);
                }, u.prototype.readDoubleBE = function(e, t) {
                    return t || C(e, 8, this.length), i.read(this, e, !1, 52, 8);
                }, u.prototype.writeUIntLE = function(e, t, r, n) {
                    e = +e, t |= 0, r |= 0, n || M(this, e, t, r, Math.pow(2, 8 * r) - 1, 0);
                    var i = 1, o = 0;
                    for(this[t] = 255 & e; ++o < r && (i *= 256);)this[t + o] = e / i & 255;
                    return t + r;
                }, u.prototype.writeUIntBE = function(e, t, r, n) {
                    e = +e, t |= 0, r |= 0, n || M(this, e, t, r, Math.pow(2, 8 * r) - 1, 0);
                    var i = r - 1, o = 1;
                    for(this[t + i] = 255 & e; --i >= 0 && (o *= 256);)this[t + i] = e / o & 255;
                    return t + r;
                }, u.prototype.writeUInt8 = function(e, t, r) {
                    return e = +e, t |= 0, r || M(this, e, t, 1, 255, 0), u.TYPED_ARRAY_SUPPORT || (e = Math.floor(e)), this[t] = 255 & e, t + 1;
                }, u.prototype.writeUInt16LE = function(e, t, r) {
                    return e = +e, t |= 0, r || M(this, e, t, 2, 65535, 0), u.TYPED_ARRAY_SUPPORT ? (this[t] = 255 & e, this[t + 1] = e >>> 8) : R(this, e, t, !0), t + 2;
                }, u.prototype.writeUInt16BE = function(e, t, r) {
                    return e = +e, t |= 0, r || M(this, e, t, 2, 65535, 0), u.TYPED_ARRAY_SUPPORT ? (this[t] = e >>> 8, this[t + 1] = 255 & e) : R(this, e, t, !1), t + 2;
                }, u.prototype.writeUInt32LE = function(e, t, r) {
                    return e = +e, t |= 0, r || M(this, e, t, 4, 4294967295, 0), u.TYPED_ARRAY_SUPPORT ? (this[t + 3] = e >>> 24, this[t + 2] = e >>> 16, this[t + 1] = e >>> 8, this[t] = 255 & e) : U(this, e, t, !0), t + 4;
                }, u.prototype.writeUInt32BE = function(e, t, r) {
                    return e = +e, t |= 0, r || M(this, e, t, 4, 4294967295, 0), u.TYPED_ARRAY_SUPPORT ? (this[t] = e >>> 24, this[t + 1] = e >>> 16, this[t + 2] = e >>> 8, this[t + 3] = 255 & e) : U(this, e, t, !1), t + 4;
                }, u.prototype.writeIntLE = function(e, t, r, n) {
                    if (e = +e, t |= 0, !n) {
                        var i = Math.pow(2, 8 * r - 1);
                        M(this, e, t, r, i - 1, -i);
                    }
                    var o = 0, a = 1, s = 0;
                    for(this[t] = 255 & e; ++o < r && (a *= 256);)e < 0 && 0 === s && 0 !== this[t + o - 1] && (s = 1), this[t + o] = (e / a >> 0) - s & 255;
                    return t + r;
                }, u.prototype.writeIntBE = function(e, t, r, n) {
                    if (e = +e, t |= 0, !n) {
                        var i = Math.pow(2, 8 * r - 1);
                        M(this, e, t, r, i - 1, -i);
                    }
                    var o = r - 1, a = 1, s = 0;
                    for(this[t + o] = 255 & e; --o >= 0 && (a *= 256);)e < 0 && 0 === s && 0 !== this[t + o + 1] && (s = 1), this[t + o] = (e / a >> 0) - s & 255;
                    return t + r;
                }, u.prototype.writeInt8 = function(e, t, r) {
                    return e = +e, t |= 0, r || M(this, e, t, 1, 127, -128), u.TYPED_ARRAY_SUPPORT || (e = Math.floor(e)), e < 0 && (e = 255 + e + 1), this[t] = 255 & e, t + 1;
                }, u.prototype.writeInt16LE = function(e, t, r) {
                    return e = +e, t |= 0, r || M(this, e, t, 2, 32767, -32768), u.TYPED_ARRAY_SUPPORT ? (this[t] = 255 & e, this[t + 1] = e >>> 8) : R(this, e, t, !0), t + 2;
                }, u.prototype.writeInt16BE = function(e, t, r) {
                    return e = +e, t |= 0, r || M(this, e, t, 2, 32767, -32768), u.TYPED_ARRAY_SUPPORT ? (this[t] = e >>> 8, this[t + 1] = 255 & e) : R(this, e, t, !1), t + 2;
                }, u.prototype.writeInt32LE = function(e, t, r) {
                    return e = +e, t |= 0, r || M(this, e, t, 4, 2147483647, -2147483648), u.TYPED_ARRAY_SUPPORT ? (this[t] = 255 & e, this[t + 1] = e >>> 8, this[t + 2] = e >>> 16, this[t + 3] = e >>> 24) : U(this, e, t, !0), t + 4;
                }, u.prototype.writeInt32BE = function(e, t, r) {
                    return e = +e, t |= 0, r || M(this, e, t, 4, 2147483647, -2147483648), e < 0 && (e = 4294967295 + e + 1), u.TYPED_ARRAY_SUPPORT ? (this[t] = e >>> 24, this[t + 1] = e >>> 16, this[t + 2] = e >>> 8, this[t + 3] = 255 & e) : U(this, e, t, !1), t + 4;
                }, u.prototype.writeFloatLE = function(e, t, r) {
                    return j(this, e, t, !0, r);
                }, u.prototype.writeFloatBE = function(e, t, r) {
                    return j(this, e, t, !1, r);
                }, u.prototype.writeDoubleLE = function(e, t, r) {
                    return L(this, e, t, !0, r);
                }, u.prototype.writeDoubleBE = function(e, t, r) {
                    return L(this, e, t, !1, r);
                }, u.prototype.copy = function(e, t, r, n) {
                    if (r || (r = 0), n || 0 === n || (n = this.length), t >= e.length && (t = e.length), t || (t = 0), n > 0 && n < r && (n = r), n === r) return 0;
                    if (0 === e.length || 0 === this.length) return 0;
                    if (t < 0) throw new RangeError("targetStart out of bounds");
                    if (r < 0 || r >= this.length) throw new RangeError("sourceStart out of bounds");
                    if (n < 0) throw new RangeError("sourceEnd out of bounds");
                    n > this.length && (n = this.length), e.length - t < n - r && (n = e.length - t + r);
                    var i, o = n - r;
                    if (this === e && r < t && t < n) for(i = o - 1; i >= 0; --i)e[i + t] = this[i + r];
                    else if (o < 1e3 || !u.TYPED_ARRAY_SUPPORT) for(i = 0; i < o; ++i)e[i + t] = this[i + r];
                    else Uint8Array.prototype.set.call(e, this.subarray(r, r + o), t);
                    return o;
                }, u.prototype.fill = function(e, t, r, n) {
                    if ("string" == typeof e) {
                        if ("string" == typeof t ? (n = t, t = 0, r = this.length) : "string" == typeof r && (n = r, r = this.length), 1 === e.length) {
                            var i = e.charCodeAt(0);
                            i < 256 && (e = i);
                        }
                        if (void 0 !== n && "string" != typeof n) throw new TypeError("encoding must be a string");
                        if ("string" == typeof n && !u.isEncoding(n)) throw new TypeError("Unknown encoding: " + n);
                    } else "number" == typeof e && (e &= 255);
                    if (t < 0 || this.length < t || this.length < r) throw new RangeError("Out of range index");
                    if (r <= t) return this;
                    var o;
                    if (t >>>= 0, r = void 0 === r ? this.length : r >>> 0, e || (e = 0), "number" == typeof e) for(o = t; o < r; ++o)this[o] = e;
                    else {
                        var a = u.isBuffer(e) ? e : D(new u(e, n).toString()), s = a.length;
                        for(o = 0; o < r - t; ++o)this[o + t] = a[o % s];
                    }
                    return this;
                };
                var F = /[^+\/0-9A-Za-z-_]/g;
                function D(e, t) {
                    var r;
                    t = t || 1 / 0;
                    for(var n = e.length, i = null, o = [], a = 0; a < n; ++a){
                        if ((r = e.charCodeAt(a)) > 55295 && r < 57344) {
                            if (!i) {
                                if (r > 56319) {
                                    (t -= 3) > -1 && o.push(239, 191, 189);
                                    continue;
                                }
                                if (a + 1 === n) {
                                    (t -= 3) > -1 && o.push(239, 191, 189);
                                    continue;
                                }
                                i = r;
                                continue;
                            }
                            if (r < 56320) {
                                (t -= 3) > -1 && o.push(239, 191, 189), i = r;
                                continue;
                            }
                            r = 65536 + (i - 55296 << 10 | r - 56320);
                        } else i && (t -= 3) > -1 && o.push(239, 191, 189);
                        if (i = null, r < 128) {
                            if ((t -= 1) < 0) break;
                            o.push(r);
                        } else if (r < 2048) {
                            if ((t -= 2) < 0) break;
                            o.push(r >> 6 | 192, 63 & r | 128);
                        } else if (r < 65536) {
                            if ((t -= 3) < 0) break;
                            o.push(r >> 12 | 224, r >> 6 & 63 | 128, 63 & r | 128);
                        } else {
                            if (!(r < 1114112)) throw new Error("Invalid code point");
                            if ((t -= 4) < 0) break;
                            o.push(r >> 18 | 240, r >> 12 & 63 | 128, r >> 6 & 63 | 128, 63 & r | 128);
                        }
                    }
                    return o;
                }
                function H(e) {
                    return n.toByteArray(function(e) {
                        if ((e = (function(e) {
                            return e.trim ? e.trim() : e.replace(/^\s+|\s+$/g, "");
                        })(e).replace(F, "")).length < 2) return "";
                        for(; e.length % 4 != 0;)e += "=";
                        return e;
                    }(e));
                }
                function z(e, t, r, n) {
                    for(var i = 0; i < n && !(i + r >= t.length || i >= e.length); ++i)t[i + r] = e[i];
                    return i;
                }
            },
            83675: (e)=>{
                "use strict";
                e.exports = {
                    100: "Continue",
                    101: "Switching Protocols",
                    102: "Processing",
                    200: "OK",
                    201: "Created",
                    202: "Accepted",
                    203: "Non-Authoritative Information",
                    204: "No Content",
                    205: "Reset Content",
                    206: "Partial Content",
                    207: "Multi-Status",
                    208: "Already Reported",
                    226: "IM Used",
                    300: "Multiple Choices",
                    301: "Moved Permanently",
                    302: "Found",
                    303: "See Other",
                    304: "Not Modified",
                    305: "Use Proxy",
                    307: "Temporary Redirect",
                    308: "Permanent Redirect",
                    400: "Bad Request",
                    401: "Unauthorized",
                    402: "Payment Required",
                    403: "Forbidden",
                    404: "Not Found",
                    405: "Method Not Allowed",
                    406: "Not Acceptable",
                    407: "Proxy Authentication Required",
                    408: "Request Timeout",
                    409: "Conflict",
                    410: "Gone",
                    411: "Length Required",
                    412: "Precondition Failed",
                    413: "Payload Too Large",
                    414: "URI Too Long",
                    415: "Unsupported Media Type",
                    416: "Range Not Satisfiable",
                    417: "Expectation Failed",
                    418: "I'm a teapot",
                    421: "Misdirected Request",
                    422: "Unprocessable Entity",
                    423: "Locked",
                    424: "Failed Dependency",
                    425: "Unordered Collection",
                    426: "Upgrade Required",
                    428: "Precondition Required",
                    429: "Too Many Requests",
                    431: "Request Header Fields Too Large",
                    451: "Unavailable For Legal Reasons",
                    500: "Internal Server Error",
                    501: "Not Implemented",
                    502: "Bad Gateway",
                    503: "Service Unavailable",
                    504: "Gateway Timeout",
                    505: "HTTP Version Not Supported",
                    506: "Variant Also Negotiates",
                    507: "Insufficient Storage",
                    508: "Loop Detected",
                    509: "Bandwidth Limit Exceeded",
                    510: "Not Extended",
                    511: "Network Authentication Required"
                };
            },
            80593: (e, t, r)=>{
                "use strict";
                var n = r(57701), i = r(24373), o = i(n("String.prototype.indexOf"));
                e.exports = function(e, t) {
                    var r = n(e, !!t);
                    return "function" == typeof r && o(e, ".prototype.") > -1 ? i(r) : r;
                };
            },
            24373: (e, t, r)=>{
                "use strict";
                var n = r(3767), i = r(57701), o = r(77990), a = i("%TypeError%"), s = i("%Function.prototype.apply%"), u = i("%Function.prototype.call%"), c = i("%Reflect.apply%", !0) || n.call(u, s), f = i("%Object.defineProperty%", !0), d = i("%Math.max%");
                if (f) try {
                    f({}, "a", {
                        value: 1
                    });
                } catch (e) {
                    f = null;
                }
                e.exports = function(e) {
                    if ("function" != typeof e) throw new a("a function is required");
                    var t = c(n, u, arguments);
                    return o(t, 1 + d(0, e.length - (arguments.length - 1)), !0);
                };
                var l = function() {
                    return c(n, s, arguments);
                };
                f ? f(e.exports, "apply", {
                    value: l
                }) : e.exports.apply = l;
            },
            47759: (e, t, r)=>{
                "use strict";
                for(var n = r(28847)(r(74519)), i = r(83630), o = {}, a = 0, s = Object.entries(i); a < s.length; a++){
                    var u = (0, n.default)(s[a], 2), c = u[0], f = u[1];
                    o[c.toUpperCase().replace(/-/g, "_")] = f;
                }
                e.exports = Object.freeze(o);
            },
            97223: (e, t, r)=>{
                "use strict";
                var n = r(29033).Buffer, i = r(26657), o = r(55262), a = r(71842), s = r(40779);
                (t = e.exports).addPrefix = function(e, t) {
                    var r;
                    if (n.isBuffer(e)) r = s.varintBufferEncode(e);
                    else {
                        if (!a[e]) throw new Error("multicodec not recognized");
                        r = a[e];
                    }
                    return n.concat([
                        r,
                        t
                    ]);
                }, t.rmPrefix = function(e) {
                    return i.decode(e), e.slice(i.decode.bytes);
                }, t.getCodec = function(e) {
                    var t = i.decode(e), r = o.get(t);
                    if (void 0 === r) throw new Error("Code ".concat(t, " not found"));
                    return r;
                }, t.getName = function(e) {
                    return o.get(e);
                }, t.getNumber = function(e) {
                    var t = a[e];
                    if (void 0 === t) throw new Error("Codec `" + e + "` not found");
                    return s.varintBufferDecode(t)[0];
                }, t.getCode = function(e) {
                    return i.decode(e);
                }, t.getCodeVarint = function(e) {
                    var t = a[e];
                    if (void 0 === t) throw new Error("Codec `" + e + "` not found");
                    return t;
                }, t.getVarint = function(e) {
                    return i.encode(e);
                };
                var u = r(47759);
                Object.assign(t, u), t.print = r(29268);
            },
            55262: (e, t, r)=>{
                "use strict";
                var n = r(83630), i = new Map;
                for(var o in n){
                    var a = n[o];
                    i.set(a, o);
                }
                e.exports = Object.freeze(i);
            },
            29268: (e, t, r)=>{
                "use strict";
                for(var n = r(28847)(r(74519)), i = r(83630), o = {}, a = 0, s = Object.entries(i); a < s.length; a++){
                    var u = (0, n.default)(s[a], 2), c = u[0], f = u[1];
                    void 0 === o[f] && (o[f] = c);
                }
                e.exports = Object.freeze(o);
            },
            40779: (e, t, r)=>{
                "use strict";
                var n = r(26657), i = r(29033).Buffer;
                function o(e) {
                    return parseInt(e.toString("hex"), 16);
                }
                function a(e) {
                    var t = e.toString(16);
                    return t.length % 2 == 1 && (t = "0" + t), i.from(t, "hex");
                }
                e.exports = {
                    numberToBuffer: a,
                    bufferToNumber: o,
                    varintBufferEncode: function(e) {
                        return i.from(n.encode(o(e)));
                    },
                    varintBufferDecode: function(e) {
                        return a(n.decode(e));
                    },
                    varintEncode: function(e) {
                        return i.from(n.encode(e));
                    }
                };
            },
            71842: (e, t, r)=>{
                "use strict";
                var n = r(83630), i = r(40779).varintEncode, o = {};
                for(var a in n){
                    var s = n[a];
                    o[a] = i(s);
                }
                e.exports = Object.freeze(o);
            },
            59976: (e, t, r)=>{
                "use strict";
                var n = r(77748), i = r(29033).Buffer, o = {
                    checkCIDComponents: function(e) {
                        if (null == e) return "null values are not valid CIDs";
                        if (0 !== e.version && 1 !== e.version) return "Invalid version, must be a number equal to 1 or 0";
                        if ("string" != typeof e.codec) return "codec must be string";
                        if (0 === e.version) {
                            if ("dag-pb" !== e.codec) return "codec must be 'dag-pb' for CIDv0";
                            if ("base58btc" !== e.multibaseName) return "multibaseName must be 'base58btc' for CIDv0";
                        }
                        if (!i.isBuffer(e.multihash)) return "multihash must be a Buffer";
                        try {
                            n.validate(e.multihash);
                        } catch (e) {
                            var t = e.message;
                            return t || (t = "Multihash validation failed"), t;
                        }
                    }
                };
                e.exports = o;
            },
            72753: (e, t, r)=>{
                "use strict";
                var n = r(28847), i = n(r(69721)), o = n(r(58985)), a = r(29033).Buffer, s = r(77748), u = r(6086), c = r(97223), f = r(83630), d = r(59976), l = r(83162)(function(e) {
                    function t(e, r, n, o) {
                        if ((0, i.default)(this, t), l.isCID(e)) {
                            var f = e;
                            return this.version = f.version, this.codec = f.codec, this.multihash = a.from(f.multihash), void (this.multibaseName = f.multibaseName || (0 === f.version ? "base58btc" : "base32"));
                        }
                        if ("string" == typeof e) {
                            var d = u.isEncoded(e);
                            if (d) {
                                var h = u.decode(e);
                                this.version = parseInt(h.slice(0, 1).toString("hex"), 16), this.codec = c.getCodec(h.slice(1)), this.multihash = c.rmPrefix(h.slice(1)), this.multibaseName = d;
                            } else this.version = 0, this.codec = "dag-pb", this.multihash = s.fromB58String(e), this.multibaseName = "base58btc";
                            return t.validateCID(this), void Object.defineProperty(this, "string", {
                                value: e
                            });
                        }
                        if (a.isBuffer(e)) {
                            var p = e.slice(0, 1), b = parseInt(p.toString("hex"), 16);
                            if (1 === b) {
                                var y = e;
                                this.version = b, this.codec = c.getCodec(y.slice(1)), this.multihash = c.rmPrefix(y.slice(1)), this.multibaseName = "base32";
                            } else this.version = 0, this.codec = "dag-pb", this.multihash = e, this.multibaseName = "base58btc";
                            t.validateCID(this);
                        } else this.version = e, this.codec = r, this.multihash = n, this.multibaseName = o || (0 === e ? "base58btc" : "base32"), t.validateCID(this);
                    }
                    return (0, o.default)(t, [
                        {
                            key: "buffer",
                            get: function() {
                                var e = this._buffer;
                                if (!e) {
                                    if (0 === this.version) e = this.multihash;
                                    else {
                                        if (1 !== this.version) throw new Error("unsupported version");
                                        e = a.concat([
                                            a.from("01", "hex"),
                                            c.getCodeVarint(this.codec),
                                            this.multihash
                                        ]);
                                    }
                                    Object.defineProperty(this, "_buffer", {
                                        value: e
                                    });
                                }
                                return e;
                            }
                        },
                        {
                            key: "prefix",
                            get: function() {
                                return a.concat([
                                    a.from("0".concat(this.version), "hex"),
                                    c.getCodeVarint(this.codec),
                                    s.prefix(this.multihash)
                                ]);
                            }
                        },
                        {
                            key: "toV0",
                            value: function() {
                                if ("dag-pb" !== this.codec) throw new Error("Cannot convert a non dag-pb CID to CIDv0");
                                var e = s.decode(this.multihash), t = e.name, r = e.length;
                                if ("sha2-256" !== t) throw new Error("Cannot convert non sha2-256 multihash CID to CIDv0");
                                if (32 !== r) throw new Error("Cannot convert non 32 byte multihash CID to CIDv0");
                                return new l(0, this.codec, this.multihash);
                            }
                        },
                        {
                            key: "toV1",
                            value: function() {
                                return new l(1, this.codec, this.multihash);
                            }
                        },
                        {
                            key: "toBaseEncodedString",
                            value: function() {
                                var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : this.multibaseName;
                                if (this.string && e === this.multibaseName) return this.string;
                                var t = null;
                                if (0 === this.version) {
                                    if ("base58btc" !== e) throw new Error("not supported with CIDv0, to support different bases, please migrate the instance do CIDv1, you can do that through cid.toV1()");
                                    t = s.toB58String(this.multihash);
                                } else {
                                    if (1 !== this.version) throw new Error("unsupported version");
                                    t = u.encode(e, this.buffer).toString();
                                }
                                return e === this.multibaseName && Object.defineProperty(this, "string", {
                                    value: t
                                }), t;
                            }
                        },
                        {
                            key: e,
                            value: function() {
                                return "CID(" + this.toString() + ")";
                            }
                        },
                        {
                            key: "toString",
                            value: function(e) {
                                return this.toBaseEncodedString(e);
                            }
                        },
                        {
                            key: "toJSON",
                            value: function() {
                                return {
                                    codec: this.codec,
                                    version: this.version,
                                    hash: this.multihash
                                };
                            }
                        },
                        {
                            key: "equals",
                            value: function(e) {
                                return this.codec === e.codec && this.version === e.version && this.multihash.equals(e.multihash);
                            }
                        }
                    ], [
                        {
                            key: "validateCID",
                            value: function(e) {
                                var t = d.checkCIDComponents(e);
                                if (t) throw new Error(t);
                            }
                        }
                    ]), t;
                }(Symbol.for("nodejs.util.inspect.custom")), {
                    className: "CID",
                    symbolName: "@ipld/js-cid/CID"
                });
                l.codecs = f, e.exports = l;
            },
            93013: (e, t, r)=>{
                "use strict";
                var n = r(48850).Buffer, i = r(57245).Transform, o = r(23462).s;
                function a(e) {
                    i.call(this), this.hashMode = "string" == typeof e, this.hashMode ? this[e] = this._finalOrDigest : this.final = this._finalOrDigest, this._final && (this.__final = this._final, this._final = null), this._decoder = null, this._encoding = null;
                }
                r(41736)(a, i), a.prototype.update = function(e, t, r) {
                    "string" == typeof e && (e = n.from(e, t));
                    var i = this._update(e);
                    return this.hashMode ? this : (r && (i = this._toString(i, r)), i);
                }, a.prototype.setAutoPadding = function() {}, a.prototype.getAuthTag = function() {
                    throw new Error("trying to get auth tag in unsupported state");
                }, a.prototype.setAuthTag = function() {
                    throw new Error("trying to set auth tag in unsupported state");
                }, a.prototype.setAAD = function() {
                    throw new Error("trying to set aad in unsupported state");
                }, a.prototype._transform = function(e, t, r) {
                    var n;
                    try {
                        this.hashMode ? this._update(e) : this.push(this._update(e));
                    } catch (e) {
                        n = e;
                    } finally{
                        r(n);
                    }
                }, a.prototype._flush = function(e) {
                    var t;
                    try {
                        this.push(this.__final());
                    } catch (e) {
                        t = e;
                    }
                    e(t);
                }, a.prototype._finalOrDigest = function(e) {
                    var t = this.__final() || n.alloc(0);
                    return e && (t = this._toString(t, e, !0)), t;
                }, a.prototype._toString = function(e, t, r) {
                    if (this._decoder || (this._decoder = new o(t), this._encoding = t), this._encoding !== t) throw new Error("can't switch encodings");
                    var n = this._decoder.write(e);
                    return r && (n += this._decoder.end()), n;
                }, e.exports = a;
            },
            83162: (e, t, r)=>{
                "use strict";
                var n = r(28847), i = n(r(14727)), o = n(r(90775)), a = n(r(69721)), s = n(r(58985)), u = n(r(58975)), c = n(r(15163)), f = n(r(34650)), d = n(r(21949));
                e.exports = function(e, t) {
                    var r = t.className, n = t.symbolName, i = Symbol.for(n), l = (0, o.default)({}, r, function(e, t) {
                        (0, c.default)(h, e);
                        var n, o, l = (n = h, o = function() {
                            if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                            if (Reflect.construct.sham) return !1;
                            if ("function" == typeof Proxy) return !0;
                            try {
                                return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                            } catch (e) {
                                return !1;
                            }
                        }(), function() {
                            var e, t = (0, d.default)(n);
                            if (o) {
                                var r = (0, d.default)(this).constructor;
                                e = Reflect.construct(t, arguments, r);
                            } else e = t.apply(this, arguments);
                            return (0, f.default)(this, e);
                        });
                        function h() {
                            var e;
                            (0, a.default)(this, h);
                            for(var t = arguments.length, r = new Array(t), n = 0; n < t; n++)r[n] = arguments[n];
                            return e = l.call.apply(l, [
                                this
                            ].concat(r)), Object.defineProperty((0, u.default)(e), i, {
                                value: !0
                            }), e;
                        }
                        return (0, s.default)(h, [
                            {
                                key: t,
                                get: function() {
                                    return r;
                                }
                            }
                        ]), h;
                    }(e, Symbol.toStringTag))[r];
                    return l["is".concat(r)] = function(e) {
                        return !(!e || !e[i]);
                    }, l;
                }, e.exports.proto = function(e, t) {
                    var r = t.className, n = t.symbolName, a = t.withoutNew, s = Symbol.for(n), u = (0, o.default)({}, r, function() {
                        for(var t = arguments.length, r = new Array(t), n = 0; n < t; n++)r[n] = arguments[n];
                        if (a && !(this instanceof u)) return (0, i.default)(u, r);
                        var o = e.call.apply(e, [
                            this
                        ].concat(r)) || this;
                        return o && !o[s] && Object.defineProperty(o, s, {
                            value: !0
                        }), o;
                    })[r];
                    return u.prototype = Object.create(e.prototype), u.prototype.constructor = u, Object.defineProperty(u.prototype, Symbol.toStringTag, {
                        get: function() {
                            return r;
                        }
                    }), u["is".concat(r)] = function(e) {
                        return !(!e || !e[s]);
                    }, u;
                };
            },
            36834: (e, t, r)=>{
                "use strict";
                var n = r(72753);
                t.cidV0ToV1Base32 = function(e) {
                    var t = new n(e);
                    return 0 === t.version && (t = t.toV1()), t.toString("base32");
                };
            },
            94308: (e, t, r)=>{
                "use strict";
                var n = r(69206), i = r(39512), o = i.hexStringToBuffer, a = i.profiles, s = r(36834).cidV0ToV1Base32;
                e.exports = {
                    helpers: {
                        cidV0ToV1Base32: s
                    },
                    decode: function(e) {
                        var t = o(e), r = n.getCodec(t), i = n.rmPrefix(t), s = a[r];
                        return s || (s = a.default), s.decode(i);
                    },
                    fromIpfs: function(e) {
                        return this.encode("ipfs-ns", e);
                    },
                    fromSwarm: function(e) {
                        return this.encode("swarm-ns", e);
                    },
                    encode: function(e, t) {
                        var r = a[e];
                        r || (r = a.default);
                        var i = r.encode(t);
                        return n.addPrefix(e, i).toString("hex");
                    },
                    getCodec: function(e) {
                        var t = o(e);
                        return n.getCodec(t);
                    }
                };
            },
            39512: (e, t, r)=>{
                "use strict";
                var n = r(29033).Buffer, i = r(72753), o = r(77748), a = function(e) {
                    var t, r = e.slice(0, 2), n = e.slice(2);
                    return t = "0x" === r ? n : e, o.fromHexString(t);
                }, s = {
                    swarm: function(e) {
                        var t = o.encode(a(e), "keccak-256");
                        return new i(1, "swarm-manifest", t).buffer;
                    },
                    ipfs: function(e) {
                        var t = o.fromB58String(e);
                        return new i(1, "dag-pb", t).buffer;
                    },
                    utf8: function(e) {
                        return n.from(e, "utf8");
                    }
                }, u = {
                    hexMultiHash: function(e) {
                        var t = new i(e);
                        return o.decode(t.multihash).digest.toString("hex");
                    },
                    b58MultiHash: function(e) {
                        var t = new i(e);
                        return o.toB58String(t.multihash);
                    },
                    utf8: function(e) {
                        return e.toString("utf8");
                    }
                }, c = {
                    "swarm-ns": {
                        encode: s.swarm,
                        decode: u.hexMultiHash
                    },
                    "ipfs-ns": {
                        encode: s.ipfs,
                        decode: u.b58MultiHash
                    },
                    "ipns-ns": {
                        encode: s.ipfs,
                        decode: u.b58MultiHash
                    },
                    default: {
                        encode: s.utf8,
                        decode: u.utf8
                    }
                };
                t.hexStringToBuffer = a, t.profiles = c;
            },
            64628: (e, t, r)=>{
                "use strict";
                var n, i, o = r(28847)(r(3355));
                i = function(e) {
                    e.version = "1.2.2";
                    var t = function() {
                        for(var e = 0, t = new Array(256), r = 0; 256 != r; ++r)e = 1 & (e = 1 & (e = 1 & (e = 1 & (e = 1 & (e = 1 & (e = 1 & (e = 1 & (e = r) ? -306674912 ^ e >>> 1 : e >>> 1) ? -306674912 ^ e >>> 1 : e >>> 1) ? -306674912 ^ e >>> 1 : e >>> 1) ? -306674912 ^ e >>> 1 : e >>> 1) ? -306674912 ^ e >>> 1 : e >>> 1) ? -306674912 ^ e >>> 1 : e >>> 1) ? -306674912 ^ e >>> 1 : e >>> 1) ? -306674912 ^ e >>> 1 : e >>> 1, t[r] = e;
                        return "undefined" != typeof Int32Array ? new Int32Array(t) : t;
                    }(), r = function(e) {
                        var t = 0, r = 0, n = 0, i = "undefined" != typeof Int32Array ? new Int32Array(4096) : new Array(4096);
                        for(n = 0; 256 != n; ++n)i[n] = e[n];
                        for(n = 0; 256 != n; ++n)for(r = e[n], t = 256 + n; t < 4096; t += 256)r = i[t] = r >>> 8 ^ e[255 & r];
                        var o = [];
                        for(n = 1; 16 != n; ++n)o[n - 1] = "undefined" != typeof Int32Array ? i.subarray(256 * n, 256 * n + 256) : i.slice(256 * n, 256 * n + 256);
                        return o;
                    }(t), n = r[0], i = r[1], o = r[2], a = r[3], s = r[4], u = r[5], c = r[6], f = r[7], d = r[8], l = r[9], h = r[10], p = r[11], b = r[12], y = r[13], v = r[14];
                    e.table = t, e.bstr = function(e, r) {
                        for(var n = -1 ^ r, i = 0, o = e.length; i < o;)n = n >>> 8 ^ t[255 & (n ^ e.charCodeAt(i++))];
                        return ~n;
                    }, e.buf = function(e, r) {
                        for(var m = -1 ^ r, g = e.length - 15, w = 0; w < g;)m = v[e[w++] ^ 255 & m] ^ y[e[w++] ^ m >> 8 & 255] ^ b[e[w++] ^ m >> 16 & 255] ^ p[e[w++] ^ m >>> 24] ^ h[e[w++]] ^ l[e[w++]] ^ d[e[w++]] ^ f[e[w++]] ^ c[e[w++]] ^ u[e[w++]] ^ s[e[w++]] ^ a[e[w++]] ^ o[e[w++]] ^ i[e[w++]] ^ n[e[w++]] ^ t[e[w++]];
                        for(g += 15; w < g;)m = m >>> 8 ^ t[255 & (m ^ e[w++])];
                        return ~m;
                    }, e.str = function(e, r) {
                        for(var n = -1 ^ r, i = 0, o = e.length, a = 0, s = 0; i < o;)(a = e.charCodeAt(i++)) < 128 ? n = n >>> 8 ^ t[255 & (n ^ a)] : a < 2048 ? n = (n = n >>> 8 ^ t[255 & (n ^ (192 | a >> 6 & 31))]) >>> 8 ^ t[255 & (n ^ (128 | 63 & a))] : a >= 55296 && a < 57344 ? (a = 64 + (1023 & a), s = 1023 & e.charCodeAt(i++), n = (n = (n = (n = n >>> 8 ^ t[255 & (n ^ (240 | a >> 8 & 7))]) >>> 8 ^ t[255 & (n ^ (128 | a >> 2 & 63))]) >>> 8 ^ t[255 & (n ^ (128 | s >> 6 & 15 | (3 & a) << 4))]) >>> 8 ^ t[255 & (n ^ (128 | 63 & s))]) : n = (n = (n = n >>> 8 ^ t[255 & (n ^ (224 | a >> 12 & 15))]) >>> 8 ^ t[255 & (n ^ (128 | a >> 6 & 63))]) >>> 8 ^ t[255 & (n ^ (128 | 63 & a))];
                        return ~n;
                    };
                }, "undefined" == typeof DO_NOT_EXPORT_CRC ? "object" === (0, o.default)(t) ? i(t) : (n = (function() {
                    var e = {};
                    return i(e), e;
                }).call(t, r, t, e), void 0 === n || (e.exports = n)) : i({});
            },
            75102: (e, t, r)=>{
                "use strict";
                var n = r(29033).Buffer, i = r(36597), o = r(31734);
                e.exports = function(e) {
                    return new s(e);
                };
                var a = {
                    secp256k1: {
                        name: "secp256k1",
                        byteLength: 32
                    },
                    secp224r1: {
                        name: "p224",
                        byteLength: 28
                    },
                    prime256v1: {
                        name: "p256",
                        byteLength: 32
                    },
                    prime192v1: {
                        name: "p192",
                        byteLength: 24
                    },
                    ed25519: {
                        name: "ed25519",
                        byteLength: 32
                    },
                    secp384r1: {
                        name: "p384",
                        byteLength: 48
                    },
                    secp521r1: {
                        name: "p521",
                        byteLength: 66
                    }
                };
                function s(e) {
                    this.curveType = a[e], this.curveType || (this.curveType = {
                        name: e
                    }), this.curve = new i.ec(this.curveType.name), this.keys = void 0;
                }
                function u(e, t, r) {
                    Array.isArray(e) || (e = e.toArray());
                    var i = new n(e);
                    if (r && i.length < r) {
                        var o = new n(r - i.length);
                        o.fill(0), i = n.concat([
                            o,
                            i
                        ]);
                    }
                    return t ? i.toString(t) : i;
                }
                a.p224 = a.secp224r1, a.p256 = a.secp256r1 = a.prime256v1, a.p192 = a.secp192r1 = a.prime192v1, a.p384 = a.secp384r1, a.p521 = a.secp521r1, s.prototype.generateKeys = function(e, t) {
                    return this.keys = this.curve.genKeyPair(), this.getPublicKey(e, t);
                }, s.prototype.computeSecret = function(e, t, r) {
                    return t = t || "utf8", n.isBuffer(e) || (e = new n(e, t)), u(this.curve.keyFromPublic(e).getPublic().mul(this.keys.getPrivate()).getX(), r, this.curveType.byteLength);
                }, s.prototype.getPublicKey = function(e, t) {
                    var r = this.keys.getPublic("compressed" === t, !0);
                    return "hybrid" === t && (r[r.length - 1] % 2 ? r[0] = 7 : r[0] = 6), u(r, e);
                }, s.prototype.getPrivateKey = function(e) {
                    return u(this.keys.getPrivate(), e);
                }, s.prototype.setPublicKey = function(e, t) {
                    return t = t || "utf8", n.isBuffer(e) || (e = new n(e, t)), this.keys._importPublic(e), this;
                }, s.prototype.setPrivateKey = function(e, t) {
                    t = t || "utf8", n.isBuffer(e) || (e = new n(e, t));
                    var r = new o(e);
                    return r = r.toString(16), this.keys = this.curve.genKeyPair(), this.keys._importPrivate(r), this;
                };
            },
            35866: (e, t, r)=>{
                "use strict";
                var n = r(41736), i = r(50807), o = r(26707), a = r(51708), s = r(93013);
                function u(e) {
                    s.call(this, "digest"), this._hash = e;
                }
                n(u, s), u.prototype._update = function(e) {
                    this._hash.update(e);
                }, u.prototype._final = function() {
                    return this._hash.digest();
                }, e.exports = function(e) {
                    return "md5" === (e = e.toLowerCase()) ? new i : "rmd160" === e || "ripemd160" === e ? new o : new u(a(e));
                };
            },
            55349: (e, t, r)=>{
                "use strict";
                var n = r(50807);
                e.exports = function(e) {
                    return (new n).update(e).digest();
                };
            },
            34424: (e, t, r)=>{
                "use strict";
                var n = r(41736), i = r(19956), o = r(93013), a = r(48850).Buffer, s = r(55349), u = r(26707), c = r(51708), f = a.alloc(128);
                function d(e, t) {
                    o.call(this, "digest"), "string" == typeof t && (t = a.from(t));
                    var r = "sha512" === e || "sha384" === e ? 128 : 64;
                    this._alg = e, this._key = t, t.length > r ? t = ("rmd160" === e ? new u : c(e)).update(t).digest() : t.length < r && (t = a.concat([
                        t,
                        f
                    ], r));
                    for(var n = this._ipad = a.allocUnsafe(r), i = this._opad = a.allocUnsafe(r), s = 0; s < r; s++)n[s] = 54 ^ t[s], i[s] = 92 ^ t[s];
                    this._hash = "rmd160" === e ? new u : c(e), this._hash.update(n);
                }
                n(d, o), d.prototype._update = function(e) {
                    this._hash.update(e);
                }, d.prototype._final = function() {
                    var e = this._hash.digest();
                    return ("rmd160" === this._alg ? new u : c(this._alg)).update(this._opad).update(e).digest();
                }, e.exports = function(e, t) {
                    return "rmd160" === (e = e.toLowerCase()) || "ripemd160" === e ? new d("rmd160", t) : "md5" === e ? new i(s, t) : new d(e, t);
                };
            },
            19956: (e, t, r)=>{
                "use strict";
                var n = r(41736), i = r(48850).Buffer, o = r(93013), a = i.alloc(128), s = 64;
                function u(e, t) {
                    o.call(this, "digest"), "string" == typeof t && (t = i.from(t)), this._alg = e, this._key = t, t.length > s ? t = e(t) : t.length < s && (t = i.concat([
                        t,
                        a
                    ], s));
                    for(var r = this._ipad = i.allocUnsafe(s), n = this._opad = i.allocUnsafe(s), u = 0; u < s; u++)r[u] = 54 ^ t[u], n[u] = 92 ^ t[u];
                    this._hash = [
                        r
                    ];
                }
                n(u, o), u.prototype._update = function(e) {
                    this._hash.push(e);
                }, u.prototype._final = function() {
                    var e = this._alg(i.concat(this._hash));
                    return this._alg(i.concat([
                        this._opad,
                        e
                    ]));
                }, e.exports = u;
            },
            33768: (e, t, r)=>{
                "use strict";
                var n = r(28847)(r(3355)), i = "undefined" != typeof globalThis && globalThis || "undefined" != typeof self && self || void 0 !== r.g && r.g, o = function() {
                    function e() {
                        this.fetch = !1, this.DOMException = i.DOMException;
                    }
                    return e.prototype = i, new e;
                }();
                !function(e) {
                    !function(t) {
                        var r = void 0 !== e && e || "undefined" != typeof self && self || void 0 !== r && r, i = {
                            searchParams: "URLSearchParams" in r,
                            iterable: "Symbol" in r && "iterator" in Symbol,
                            blob: "FileReader" in r && "Blob" in r && function() {
                                try {
                                    return new Blob, !0;
                                } catch (e) {
                                    return !1;
                                }
                            }(),
                            formData: "FormData" in r,
                            arrayBuffer: "ArrayBuffer" in r
                        };
                        if (i.arrayBuffer) var o = [
                            "[object Int8Array]",
                            "[object Uint8Array]",
                            "[object Uint8ClampedArray]",
                            "[object Int16Array]",
                            "[object Uint16Array]",
                            "[object Int32Array]",
                            "[object Uint32Array]",
                            "[object Float32Array]",
                            "[object Float64Array]"
                        ], a = ArrayBuffer.isView || function(e) {
                            return e && o.indexOf(Object.prototype.toString.call(e)) > -1;
                        };
                        function s(e) {
                            if ("string" != typeof e && (e = String(e)), /[^a-z0-9\-#$%&'*+.^_`|~!]/i.test(e) || "" === e) throw new TypeError('Invalid character in header field name: "' + e + '"');
                            return e.toLowerCase();
                        }
                        function u(e) {
                            return "string" != typeof e && (e = String(e)), e;
                        }
                        function c(e) {
                            var t = {
                                next: function() {
                                    var t = e.shift();
                                    return {
                                        done: void 0 === t,
                                        value: t
                                    };
                                }
                            };
                            return i.iterable && (t[Symbol.iterator] = function() {
                                return t;
                            }), t;
                        }
                        function f(e) {
                            this.map = {}, e instanceof f ? e.forEach(function(e, t) {
                                this.append(t, e);
                            }, this) : Array.isArray(e) ? e.forEach(function(e) {
                                this.append(e[0], e[1]);
                            }, this) : e && Object.getOwnPropertyNames(e).forEach(function(t) {
                                this.append(t, e[t]);
                            }, this);
                        }
                        function d(e) {
                            if (e.bodyUsed) return Promise.reject(new TypeError("Already read"));
                            e.bodyUsed = !0;
                        }
                        function l(e) {
                            return new Promise(function(t, r) {
                                e.onload = function() {
                                    t(e.result);
                                }, e.onerror = function() {
                                    r(e.error);
                                };
                            });
                        }
                        function h(e) {
                            var t = new FileReader, r = l(t);
                            return t.readAsArrayBuffer(e), r;
                        }
                        function p(e) {
                            if (e.slice) return e.slice(0);
                            var t = new Uint8Array(e.byteLength);
                            return t.set(new Uint8Array(e)), t.buffer;
                        }
                        function b() {
                            return this.bodyUsed = !1, this._initBody = function(e) {
                                var t;
                                this.bodyUsed = this.bodyUsed, this._bodyInit = e, e ? "string" == typeof e ? this._bodyText = e : i.blob && Blob.prototype.isPrototypeOf(e) ? this._bodyBlob = e : i.formData && FormData.prototype.isPrototypeOf(e) ? this._bodyFormData = e : i.searchParams && URLSearchParams.prototype.isPrototypeOf(e) ? this._bodyText = e.toString() : i.arrayBuffer && i.blob && (t = e) && DataView.prototype.isPrototypeOf(t) ? (this._bodyArrayBuffer = p(e.buffer), this._bodyInit = new Blob([
                                    this._bodyArrayBuffer
                                ])) : i.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(e) || a(e)) ? this._bodyArrayBuffer = p(e) : this._bodyText = e = Object.prototype.toString.call(e) : this._bodyText = "", this.headers.get("content-type") || ("string" == typeof e ? this.headers.set("content-type", "text/plain;charset=UTF-8") : this._bodyBlob && this._bodyBlob.type ? this.headers.set("content-type", this._bodyBlob.type) : i.searchParams && URLSearchParams.prototype.isPrototypeOf(e) && this.headers.set("content-type", "application/x-www-form-urlencoded;charset=UTF-8"));
                            }, i.blob && (this.blob = function() {
                                var e = d(this);
                                if (e) return e;
                                if (this._bodyBlob) return Promise.resolve(this._bodyBlob);
                                if (this._bodyArrayBuffer) return Promise.resolve(new Blob([
                                    this._bodyArrayBuffer
                                ]));
                                if (this._bodyFormData) throw new Error("could not read FormData body as blob");
                                return Promise.resolve(new Blob([
                                    this._bodyText
                                ]));
                            }, this.arrayBuffer = function() {
                                return this._bodyArrayBuffer ? d(this) || (ArrayBuffer.isView(this._bodyArrayBuffer) ? Promise.resolve(this._bodyArrayBuffer.buffer.slice(this._bodyArrayBuffer.byteOffset, this._bodyArrayBuffer.byteOffset + this._bodyArrayBuffer.byteLength)) : Promise.resolve(this._bodyArrayBuffer)) : this.blob().then(h);
                            }), this.text = function() {
                                var e, t, r, n = d(this);
                                if (n) return n;
                                if (this._bodyBlob) return e = this._bodyBlob, r = l(t = new FileReader), t.readAsText(e), r;
                                if (this._bodyArrayBuffer) return Promise.resolve(function(e) {
                                    for(var t = new Uint8Array(e), r = new Array(t.length), n = 0; n < t.length; n++)r[n] = String.fromCharCode(t[n]);
                                    return r.join("");
                                }(this._bodyArrayBuffer));
                                if (this._bodyFormData) throw new Error("could not read FormData body as text");
                                return Promise.resolve(this._bodyText);
                            }, i.formData && (this.formData = function() {
                                return this.text().then(m);
                            }), this.json = function() {
                                return this.text().then(JSON.parse);
                            }, this;
                        }
                        f.prototype.append = function(e, t) {
                            e = s(e), t = u(t);
                            var r = this.map[e];
                            this.map[e] = r ? r + ", " + t : t;
                        }, f.prototype.delete = function(e) {
                            delete this.map[s(e)];
                        }, f.prototype.get = function(e) {
                            return e = s(e), this.has(e) ? this.map[e] : null;
                        }, f.prototype.has = function(e) {
                            return this.map.hasOwnProperty(s(e));
                        }, f.prototype.set = function(e, t) {
                            this.map[s(e)] = u(t);
                        }, f.prototype.forEach = function(e, t) {
                            for(var r in this.map)this.map.hasOwnProperty(r) && e.call(t, this.map[r], r, this);
                        }, f.prototype.keys = function() {
                            var e = [];
                            return this.forEach(function(t, r) {
                                e.push(r);
                            }), c(e);
                        }, f.prototype.values = function() {
                            var e = [];
                            return this.forEach(function(t) {
                                e.push(t);
                            }), c(e);
                        }, f.prototype.entries = function() {
                            var e = [];
                            return this.forEach(function(t, r) {
                                e.push([
                                    r,
                                    t
                                ]);
                            }), c(e);
                        }, i.iterable && (f.prototype[Symbol.iterator] = f.prototype.entries);
                        var y = [
                            "DELETE",
                            "GET",
                            "HEAD",
                            "OPTIONS",
                            "POST",
                            "PUT"
                        ];
                        function v(e, t) {
                            if (!(this instanceof v)) throw new TypeError('Please use the "new" operator, this DOM object constructor cannot be called as a function.');
                            var r, n, i = (t = t || {}).body;
                            if (e instanceof v) {
                                if (e.bodyUsed) throw new TypeError("Already read");
                                this.url = e.url, this.credentials = e.credentials, t.headers || (this.headers = new f(e.headers)), this.method = e.method, this.mode = e.mode, this.signal = e.signal, i || null == e._bodyInit || (i = e._bodyInit, e.bodyUsed = !0);
                            } else this.url = String(e);
                            if (this.credentials = t.credentials || this.credentials || "same-origin", !t.headers && this.headers || (this.headers = new f(t.headers)), this.method = (n = (r = t.method || this.method || "GET").toUpperCase(), y.indexOf(n) > -1 ? n : r), this.mode = t.mode || this.mode || null, this.signal = t.signal || this.signal, this.referrer = null, ("GET" === this.method || "HEAD" === this.method) && i) throw new TypeError("Body not allowed for GET or HEAD requests");
                            if (this._initBody(i), !("GET" !== this.method && "HEAD" !== this.method || "no-store" !== t.cache && "no-cache" !== t.cache)) {
                                var o = /([?&])_=[^&]*/;
                                o.test(this.url) ? this.url = this.url.replace(o, "$1_=" + (new Date).getTime()) : this.url += (/\?/.test(this.url) ? "&" : "?") + "_=" + (new Date).getTime();
                            }
                        }
                        function m(e) {
                            var t = new FormData;
                            return e.trim().split("&").forEach(function(e) {
                                if (e) {
                                    var r = e.split("="), n = r.shift().replace(/\+/g, " "), i = r.join("=").replace(/\+/g, " ");
                                    t.append(decodeURIComponent(n), decodeURIComponent(i));
                                }
                            }), t;
                        }
                        function g(e, t) {
                            if (!(this instanceof g)) throw new TypeError('Please use the "new" operator, this DOM object constructor cannot be called as a function.');
                            t || (t = {}), this.type = "default", this.status = void 0 === t.status ? 200 : t.status, this.ok = this.status >= 200 && this.status < 300, this.statusText = void 0 === t.statusText ? "" : "" + t.statusText, this.headers = new f(t.headers), this.url = t.url || "", this._initBody(e);
                        }
                        v.prototype.clone = function() {
                            return new v(this, {
                                body: this._bodyInit
                            });
                        }, b.call(v.prototype), b.call(g.prototype), g.prototype.clone = function() {
                            return new g(this._bodyInit, {
                                status: this.status,
                                statusText: this.statusText,
                                headers: new f(this.headers),
                                url: this.url
                            });
                        }, g.error = function() {
                            var e = new g(null, {
                                status: 0,
                                statusText: ""
                            });
                            return e.type = "error", e;
                        };
                        var w = [
                            301,
                            302,
                            303,
                            307,
                            308
                        ];
                        g.redirect = function(e, t) {
                            if (-1 === w.indexOf(t)) throw new RangeError("Invalid status code");
                            return new g(null, {
                                status: t,
                                headers: {
                                    location: e
                                }
                            });
                        }, t.DOMException = r.DOMException;
                        try {
                            new t.DOMException;
                        } catch (e) {
                            t.DOMException = function(e, t) {
                                this.message = e, this.name = t;
                                var r = Error(e);
                                this.stack = r.stack;
                            }, t.DOMException.prototype = Object.create(Error.prototype), t.DOMException.prototype.constructor = t.DOMException;
                        }
                        function k(e, o) {
                            return new Promise(function(a, s) {
                                var c = new v(e, o);
                                if (c.signal && c.signal.aborted) return s(new t.DOMException("Aborted", "AbortError"));
                                var d = new XMLHttpRequest;
                                function l() {
                                    d.abort();
                                }
                                d.onload = function() {
                                    var e, t, r = {
                                        status: d.status,
                                        statusText: d.statusText,
                                        headers: (e = d.getAllResponseHeaders() || "", t = new f, e.replace(/\r?\n[\t ]+/g, " ").split("\r").map(function(e) {
                                            return 0 === e.indexOf("\n") ? e.substr(1, e.length) : e;
                                        }).forEach(function(e) {
                                            var r = e.split(":"), n = r.shift().trim();
                                            if (n) {
                                                var i = r.join(":").trim();
                                                t.append(n, i);
                                            }
                                        }), t)
                                    };
                                    r.url = "responseURL" in d ? d.responseURL : r.headers.get("X-Request-URL");
                                    var n = "response" in d ? d.response : d.responseText;
                                    setTimeout(function() {
                                        a(new g(n, r));
                                    }, 0);
                                }, d.onerror = function() {
                                    setTimeout(function() {
                                        s(new TypeError("Network request failed"));
                                    }, 0);
                                }, d.ontimeout = function() {
                                    setTimeout(function() {
                                        s(new TypeError("Network request failed"));
                                    }, 0);
                                }, d.onabort = function() {
                                    setTimeout(function() {
                                        s(new t.DOMException("Aborted", "AbortError"));
                                    }, 0);
                                }, d.open(c.method, function(e) {
                                    try {
                                        return "" === e && r.location.href ? r.location.href : e;
                                    } catch (t) {
                                        return e;
                                    }
                                }(c.url), !0), "include" === c.credentials ? d.withCredentials = !0 : "omit" === c.credentials && (d.withCredentials = !1), "responseType" in d && (i.blob ? d.responseType = "blob" : i.arrayBuffer && c.headers.get("Content-Type") && -1 !== c.headers.get("Content-Type").indexOf("application/octet-stream") && (d.responseType = "arraybuffer")), !o || "object" !== (0, n.default)(o.headers) || o.headers instanceof f ? c.headers.forEach(function(e, t) {
                                    d.setRequestHeader(t, e);
                                }) : Object.getOwnPropertyNames(o.headers).forEach(function(e) {
                                    d.setRequestHeader(e, u(o.headers[e]));
                                }), c.signal && (c.signal.addEventListener("abort", l), d.onreadystatechange = function() {
                                    4 === d.readyState && c.signal.removeEventListener("abort", l);
                                }), d.send(void 0 === c._bodyInit ? null : c._bodyInit);
                            });
                        }
                        k.polyfill = !0, r.fetch || (r.fetch = k, r.Headers = f, r.Request = v, r.Response = g), t.Headers = f, t.Request = v, t.Response = g, t.fetch = k;
                    }({});
                }(o), o.fetch.ponyfill = !0, delete o.fetch.polyfill;
                var a = i.fetch ? i : o;
                (t = a.fetch).default = a.fetch, t.fetch = a.fetch, t.Headers = a.Headers, t.Request = a.Request, t.Response = a.Response, e.exports = t;
            },
            24293: (e, t, r)=>{
                "use strict";
                t.randomBytes = t.rng = t.pseudoRandomBytes = t.prng = r(75010), t.createHash = t.Hash = r(35866), t.createHmac = t.Hmac = r(34424);
                var n = r(26561), i = Object.keys(n), o = [
                    "sha1",
                    "sha224",
                    "sha256",
                    "sha384",
                    "sha512",
                    "md5",
                    "rmd160"
                ].concat(i);
                t.getHashes = function() {
                    return o;
                };
                var a = r(54192);
                t.pbkdf2 = a.pbkdf2, t.pbkdf2Sync = a.pbkdf2Sync;
                var s = r(56805);
                t.Cipher = s.Cipher, t.createCipher = s.createCipher, t.Cipheriv = s.Cipheriv, t.createCipheriv = s.createCipheriv, t.Decipher = s.Decipher, t.createDecipher = s.createDecipher, t.Decipheriv = s.Decipheriv, t.createDecipheriv = s.createDecipheriv, t.getCiphers = s.getCiphers, t.listCiphers = s.listCiphers;
                var u = r(28333);
                t.DiffieHellmanGroup = u.DiffieHellmanGroup, t.createDiffieHellmanGroup = u.createDiffieHellmanGroup, t.getDiffieHellman = u.getDiffieHellman, t.createDiffieHellman = u.createDiffieHellman, t.DiffieHellman = u.DiffieHellman;
                var c = r(79527);
                t.createSign = c.createSign, t.Sign = c.Sign, t.createVerify = c.createVerify, t.Verify = c.Verify, t.createECDH = r(75102);
                var f = r(86991);
                t.publicEncrypt = f.publicEncrypt, t.privateEncrypt = f.privateEncrypt, t.publicDecrypt = f.publicDecrypt, t.privateDecrypt = f.privateDecrypt;
                var d = r(36509);
                t.randomFill = d.randomFill, t.randomFillSync = d.randomFillSync, t.createCredentials = function() {
                    throw new Error([
                        "sorry, createCredentials is not implemented yet",
                        "we accept pull requests",
                        "https://github.com/crypto-browserify/crypto-browserify"
                    ].join("\n"));
                }, t.constants = {
                    DH_CHECK_P_NOT_SAFE_PRIME: 2,
                    DH_CHECK_P_NOT_PRIME: 1,
                    DH_UNABLE_TO_CHECK_GENERATOR: 4,
                    DH_NOT_SUITABLE_GENERATOR: 8,
                    NPN_ENABLED: 1,
                    ALPN_ENABLED: 1,
                    RSA_PKCS1_PADDING: 1,
                    RSA_SSLV23_PADDING: 2,
                    RSA_NO_PADDING: 3,
                    RSA_PKCS1_OAEP_PADDING: 4,
                    RSA_X931_PADDING: 5,
                    RSA_PKCS1_PSS_PADDING: 6,
                    POINT_CONVERSION_COMPRESSED: 2,
                    POINT_CONVERSION_UNCOMPRESSED: 4,
                    POINT_CONVERSION_HYBRID: 6
                };
            },
            80034: (e, t, r)=>{
                "use strict";
                var n = r(28847)(r(3355)), i = "%[a-f0-9]{2}", o = new RegExp("(" + i + ")|([^%]+?)", "gi"), a = new RegExp("(" + i + ")+", "gi");
                function s(e, t) {
                    try {
                        return [
                            decodeURIComponent(e.join(""))
                        ];
                    } catch (e) {}
                    if (1 === e.length) return e;
                    t = t || 1;
                    var r = e.slice(0, t), n = e.slice(t);
                    return Array.prototype.concat.call([], s(r), s(n));
                }
                function u(e) {
                    try {
                        return decodeURIComponent(e);
                    } catch (n) {
                        for(var t = e.match(o) || [], r = 1; r < t.length; r++)t = (e = s(t, r).join("")).match(o) || [];
                        return e;
                    }
                }
                e.exports = function(e) {
                    if ("string" != typeof e) throw new TypeError("Expected `encodedURI` to be of type `string`, got `" + (0, n.default)(e) + "`");
                    try {
                        return e = e.replace(/\+/g, " "), decodeURIComponent(e);
                    } catch (t) {
                        return function(e) {
                            for(var t = {
                                "%FE%FF": "\uFFFD\uFFFD",
                                "%FF%FE": "\uFFFD\uFFFD"
                            }, r = a.exec(e); r;){
                                try {
                                    t[r[0]] = decodeURIComponent(r[0]);
                                } catch (e) {
                                    var n = u(r[0]);
                                    n !== r[0] && (t[r[0]] = n);
                                }
                                r = a.exec(e);
                            }
                            t["%C2"] = "\uFFFD";
                            for(var i = Object.keys(t), o = 0; o < i.length; o++){
                                var s = i[o];
                                e = e.replace(new RegExp(s, "g"), t[s]);
                            }
                            return e;
                        }(e);
                    }
                };
            },
            94919: (e, t, r)=>{
                "use strict";
                var n = r(28847)(r(3355)), i = r(1020)(), o = r(57701), a = i && o("%Object.defineProperty%", !0);
                if (a) try {
                    a({}, "a", {
                        value: 1
                    });
                } catch (e) {
                    a = !1;
                }
                var s = o("%SyntaxError%"), u = o("%TypeError%"), c = r(53820);
                e.exports = function(e, t, r) {
                    if (!e || "object" !== (0, n.default)(e) && "function" != typeof e) throw new u("`obj` must be an object or a function`");
                    if ("string" != typeof t && "symbol" !== (0, n.default)(t)) throw new u("`property` must be a string or a symbol`");
                    if (arguments.length > 3 && "boolean" != typeof arguments[3] && null !== arguments[3]) throw new u("`nonEnumerable`, if provided, must be a boolean or null");
                    if (arguments.length > 4 && "boolean" != typeof arguments[4] && null !== arguments[4]) throw new u("`nonWritable`, if provided, must be a boolean or null");
                    if (arguments.length > 5 && "boolean" != typeof arguments[5] && null !== arguments[5]) throw new u("`nonConfigurable`, if provided, must be a boolean or null");
                    if (arguments.length > 6 && "boolean" != typeof arguments[6]) throw new u("`loose`, if provided, must be a boolean");
                    var i = arguments.length > 3 ? arguments[3] : null, o = arguments.length > 4 ? arguments[4] : null, f = arguments.length > 5 ? arguments[5] : null, d = arguments.length > 6 && arguments[6], l = !!c && c(e, t);
                    if (a) a(e, t, {
                        configurable: null === f && l ? l.configurable : !f,
                        enumerable: null === i && l ? l.enumerable : !i,
                        value: r,
                        writable: null === o && l ? l.writable : !o
                    });
                    else {
                        if (!d && (i || o || f)) throw new s("This environment does not support defining a property as non-configurable, non-writable, or non-enumerable.");
                        e[t] = r;
                    }
                };
            },
            75626: (e, t, r)=>{
                "use strict";
                t.utils = r(43349), t.Cipher = r(19591), t.DES = r(63049), t.CBC = r(4375), t.EDE = r(9413);
            },
            4375: (e, t, r)=>{
                "use strict";
                var n = r(94504), i = r(41736), o = {};
                function a(e) {
                    n.equal(e.length, 8, "Invalid IV length"), this.iv = new Array(8);
                    for(var t = 0; t < this.iv.length; t++)this.iv[t] = e[t];
                }
                t.instantiate = function(e) {
                    function t(t) {
                        e.call(this, t), this._cbcInit();
                    }
                    i(t, e);
                    for(var r = Object.keys(o), n = 0; n < r.length; n++){
                        var a = r[n];
                        t.prototype[a] = o[a];
                    }
                    return t.create = function(e) {
                        return new t(e);
                    }, t;
                }, o._cbcInit = function() {
                    var e = new a(this.options.iv);
                    this._cbcState = e;
                }, o._update = function(e, t, r, n) {
                    var i = this._cbcState, o = this.constructor.super_.prototype, a = i.iv;
                    if ("encrypt" === this.type) {
                        for(var s = 0; s < this.blockSize; s++)a[s] ^= e[t + s];
                        for(o._update.call(this, a, 0, r, n), s = 0; s < this.blockSize; s++)a[s] = r[n + s];
                    } else {
                        for(o._update.call(this, e, t, r, n), s = 0; s < this.blockSize; s++)r[n + s] ^= a[s];
                        for(s = 0; s < this.blockSize; s++)a[s] = e[t + s];
                    }
                };
            },
            19591: (e, t, r)=>{
                "use strict";
                var n = r(94504);
                function i(e) {
                    this.options = e, this.type = this.options.type, this.blockSize = 8, this._init(), this.buffer = new Array(this.blockSize), this.bufferOff = 0;
                }
                e.exports = i, i.prototype._init = function() {}, i.prototype.update = function(e) {
                    return 0 === e.length ? [] : "decrypt" === this.type ? this._updateDecrypt(e) : this._updateEncrypt(e);
                }, i.prototype._buffer = function(e, t) {
                    for(var r = Math.min(this.buffer.length - this.bufferOff, e.length - t), n = 0; n < r; n++)this.buffer[this.bufferOff + n] = e[t + n];
                    return this.bufferOff += r, r;
                }, i.prototype._flushBuffer = function(e, t) {
                    return this._update(this.buffer, 0, e, t), this.bufferOff = 0, this.blockSize;
                }, i.prototype._updateEncrypt = function(e) {
                    var t = 0, r = 0, n = (this.bufferOff + e.length) / this.blockSize | 0, i = new Array(n * this.blockSize);
                    0 !== this.bufferOff && (t += this._buffer(e, t), this.bufferOff === this.buffer.length && (r += this._flushBuffer(i, r)));
                    for(var o = e.length - (e.length - t) % this.blockSize; t < o; t += this.blockSize)this._update(e, t, i, r), r += this.blockSize;
                    for(; t < e.length; t++, this.bufferOff++)this.buffer[this.bufferOff] = e[t];
                    return i;
                }, i.prototype._updateDecrypt = function(e) {
                    for(var t = 0, r = 0, n = Math.ceil((this.bufferOff + e.length) / this.blockSize) - 1, i = new Array(n * this.blockSize); n > 0; n--)t += this._buffer(e, t), r += this._flushBuffer(i, r);
                    return t += this._buffer(e, t), i;
                }, i.prototype.final = function(e) {
                    var t, r;
                    return e && (t = this.update(e)), r = "encrypt" === this.type ? this._finalEncrypt() : this._finalDecrypt(), t ? t.concat(r) : r;
                }, i.prototype._pad = function(e, t) {
                    if (0 === t) return !1;
                    for(; t < e.length;)e[t++] = 0;
                    return !0;
                }, i.prototype._finalEncrypt = function() {
                    if (!this._pad(this.buffer, this.bufferOff)) return [];
                    var e = new Array(this.blockSize);
                    return this._update(this.buffer, 0, e, 0), e;
                }, i.prototype._unpad = function(e) {
                    return e;
                }, i.prototype._finalDecrypt = function() {
                    n.equal(this.bufferOff, this.blockSize, "Not enough data to decrypt");
                    var e = new Array(this.blockSize);
                    return this._flushBuffer(e, 0), this._unpad(e);
                };
            },
            63049: (e, t, r)=>{
                "use strict";
                var n = r(94504), i = r(41736), o = r(43349), a = r(19591);
                function s() {
                    this.tmp = new Array(2), this.keys = null;
                }
                function u(e) {
                    a.call(this, e);
                    var t = new s;
                    this._desState = t, this.deriveKeys(t, e.key);
                }
                i(u, a), e.exports = u, u.create = function(e) {
                    return new u(e);
                };
                var c = [
                    1,
                    1,
                    2,
                    2,
                    2,
                    2,
                    2,
                    2,
                    1,
                    2,
                    2,
                    2,
                    2,
                    2,
                    2,
                    1
                ];
                u.prototype.deriveKeys = function(e, t) {
                    e.keys = new Array(32), n.equal(t.length, this.blockSize, "Invalid key length");
                    var r = o.readUInt32BE(t, 0), i = o.readUInt32BE(t, 4);
                    o.pc1(r, i, e.tmp, 0), r = e.tmp[0], i = e.tmp[1];
                    for(var a = 0; a < e.keys.length; a += 2){
                        var s = c[a >>> 1];
                        r = o.r28shl(r, s), i = o.r28shl(i, s), o.pc2(r, i, e.keys, a);
                    }
                }, u.prototype._update = function(e, t, r, n) {
                    var i = this._desState, a = o.readUInt32BE(e, t), s = o.readUInt32BE(e, t + 4);
                    o.ip(a, s, i.tmp, 0), a = i.tmp[0], s = i.tmp[1], "encrypt" === this.type ? this._encrypt(i, a, s, i.tmp, 0) : this._decrypt(i, a, s, i.tmp, 0), a = i.tmp[0], s = i.tmp[1], o.writeUInt32BE(r, a, n), o.writeUInt32BE(r, s, n + 4);
                }, u.prototype._pad = function(e, t) {
                    for(var r = e.length - t, n = t; n < e.length; n++)e[n] = r;
                    return !0;
                }, u.prototype._unpad = function(e) {
                    for(var t = e[e.length - 1], r = e.length - t; r < e.length; r++)n.equal(e[r], t);
                    return e.slice(0, e.length - t);
                }, u.prototype._encrypt = function(e, t, r, n, i) {
                    for(var a = t, s = r, u = 0; u < e.keys.length; u += 2){
                        var c = e.keys[u], f = e.keys[u + 1];
                        o.expand(s, e.tmp, 0), c ^= e.tmp[0], f ^= e.tmp[1];
                        var d = o.substitute(c, f), l = s;
                        s = (a ^ o.permute(d)) >>> 0, a = l;
                    }
                    o.rip(s, a, n, i);
                }, u.prototype._decrypt = function(e, t, r, n, i) {
                    for(var a = r, s = t, u = e.keys.length - 2; u >= 0; u -= 2){
                        var c = e.keys[u], f = e.keys[u + 1];
                        o.expand(a, e.tmp, 0), c ^= e.tmp[0], f ^= e.tmp[1];
                        var d = o.substitute(c, f), l = a;
                        a = (s ^ o.permute(d)) >>> 0, s = l;
                    }
                    o.rip(a, s, n, i);
                };
            },
            9413: (e, t, r)=>{
                "use strict";
                var n = r(94504), i = r(41736), o = r(19591), a = r(63049);
                function s(e, t) {
                    n.equal(t.length, 24, "Invalid key length");
                    var r = t.slice(0, 8), i = t.slice(8, 16), o = t.slice(16, 24);
                    this.ciphers = "encrypt" === e ? [
                        a.create({
                            type: "encrypt",
                            key: r
                        }),
                        a.create({
                            type: "decrypt",
                            key: i
                        }),
                        a.create({
                            type: "encrypt",
                            key: o
                        })
                    ] : [
                        a.create({
                            type: "decrypt",
                            key: o
                        }),
                        a.create({
                            type: "encrypt",
                            key: i
                        }),
                        a.create({
                            type: "decrypt",
                            key: r
                        })
                    ];
                }
                function u(e) {
                    o.call(this, e);
                    var t = new s(this.type, this.options.key);
                    this._edeState = t;
                }
                i(u, o), e.exports = u, u.create = function(e) {
                    return new u(e);
                }, u.prototype._update = function(e, t, r, n) {
                    var i = this._edeState;
                    i.ciphers[0]._update(e, t, r, n), i.ciphers[1]._update(r, n, r, n), i.ciphers[2]._update(r, n, r, n);
                }, u.prototype._pad = a.prototype._pad, u.prototype._unpad = a.prototype._unpad;
            },
            43349: (e, t)=>{
                "use strict";
                t.readUInt32BE = function(e, t) {
                    return (e[0 + t] << 24 | e[1 + t] << 16 | e[2 + t] << 8 | e[3 + t]) >>> 0;
                }, t.writeUInt32BE = function(e, t, r) {
                    e[0 + r] = t >>> 24, e[1 + r] = t >>> 16 & 255, e[2 + r] = t >>> 8 & 255, e[3 + r] = 255 & t;
                }, t.ip = function(e, t, r, n) {
                    for(var i = 0, o = 0, a = 6; a >= 0; a -= 2){
                        for(var s = 0; s <= 24; s += 8)i <<= 1, i |= t >>> s + a & 1;
                        for(s = 0; s <= 24; s += 8)i <<= 1, i |= e >>> s + a & 1;
                    }
                    for(a = 6; a >= 0; a -= 2){
                        for(s = 1; s <= 25; s += 8)o <<= 1, o |= t >>> s + a & 1;
                        for(s = 1; s <= 25; s += 8)o <<= 1, o |= e >>> s + a & 1;
                    }
                    r[n + 0] = i >>> 0, r[n + 1] = o >>> 0;
                }, t.rip = function(e, t, r, n) {
                    for(var i = 0, o = 0, a = 0; a < 4; a++)for(var s = 24; s >= 0; s -= 8)i <<= 1, i |= t >>> s + a & 1, i <<= 1, i |= e >>> s + a & 1;
                    for(a = 4; a < 8; a++)for(s = 24; s >= 0; s -= 8)o <<= 1, o |= t >>> s + a & 1, o <<= 1, o |= e >>> s + a & 1;
                    r[n + 0] = i >>> 0, r[n + 1] = o >>> 0;
                }, t.pc1 = function(e, t, r, n) {
                    for(var i = 0, o = 0, a = 7; a >= 5; a--){
                        for(var s = 0; s <= 24; s += 8)i <<= 1, i |= t >> s + a & 1;
                        for(s = 0; s <= 24; s += 8)i <<= 1, i |= e >> s + a & 1;
                    }
                    for(s = 0; s <= 24; s += 8)i <<= 1, i |= t >> s + a & 1;
                    for(a = 1; a <= 3; a++){
                        for(s = 0; s <= 24; s += 8)o <<= 1, o |= t >> s + a & 1;
                        for(s = 0; s <= 24; s += 8)o <<= 1, o |= e >> s + a & 1;
                    }
                    for(s = 0; s <= 24; s += 8)o <<= 1, o |= e >> s + a & 1;
                    r[n + 0] = i >>> 0, r[n + 1] = o >>> 0;
                }, t.r28shl = function(e, t) {
                    return e << t & 268435455 | e >>> 28 - t;
                };
                var r = [
                    14,
                    11,
                    17,
                    4,
                    27,
                    23,
                    25,
                    0,
                    13,
                    22,
                    7,
                    18,
                    5,
                    9,
                    16,
                    24,
                    2,
                    20,
                    12,
                    21,
                    1,
                    8,
                    15,
                    26,
                    15,
                    4,
                    25,
                    19,
                    9,
                    1,
                    26,
                    16,
                    5,
                    11,
                    23,
                    8,
                    12,
                    7,
                    17,
                    0,
                    22,
                    3,
                    10,
                    14,
                    6,
                    20,
                    27,
                    24
                ];
                t.pc2 = function(e, t, n, i) {
                    for(var o = 0, a = 0, s = r.length >>> 1, u = 0; u < s; u++)o <<= 1, o |= e >>> r[u] & 1;
                    for(u = s; u < r.length; u++)a <<= 1, a |= t >>> r[u] & 1;
                    n[i + 0] = o >>> 0, n[i + 1] = a >>> 0;
                }, t.expand = function(e, t, r) {
                    var n = 0, i = 0;
                    n = (1 & e) << 5 | e >>> 27;
                    for(var o = 23; o >= 15; o -= 4)n <<= 6, n |= e >>> o & 63;
                    for(o = 11; o >= 3; o -= 4)i |= e >>> o & 63, i <<= 6;
                    i |= (31 & e) << 1 | e >>> 31, t[r + 0] = n >>> 0, t[r + 1] = i >>> 0;
                };
                var n = [
                    14,
                    0,
                    4,
                    15,
                    13,
                    7,
                    1,
                    4,
                    2,
                    14,
                    15,
                    2,
                    11,
                    13,
                    8,
                    1,
                    3,
                    10,
                    10,
                    6,
                    6,
                    12,
                    12,
                    11,
                    5,
                    9,
                    9,
                    5,
                    0,
                    3,
                    7,
                    8,
                    4,
                    15,
                    1,
                    12,
                    14,
                    8,
                    8,
                    2,
                    13,
                    4,
                    6,
                    9,
                    2,
                    1,
                    11,
                    7,
                    15,
                    5,
                    12,
                    11,
                    9,
                    3,
                    7,
                    14,
                    3,
                    10,
                    10,
                    0,
                    5,
                    6,
                    0,
                    13,
                    15,
                    3,
                    1,
                    13,
                    8,
                    4,
                    14,
                    7,
                    6,
                    15,
                    11,
                    2,
                    3,
                    8,
                    4,
                    14,
                    9,
                    12,
                    7,
                    0,
                    2,
                    1,
                    13,
                    10,
                    12,
                    6,
                    0,
                    9,
                    5,
                    11,
                    10,
                    5,
                    0,
                    13,
                    14,
                    8,
                    7,
                    10,
                    11,
                    1,
                    10,
                    3,
                    4,
                    15,
                    13,
                    4,
                    1,
                    2,
                    5,
                    11,
                    8,
                    6,
                    12,
                    7,
                    6,
                    12,
                    9,
                    0,
                    3,
                    5,
                    2,
                    14,
                    15,
                    9,
                    10,
                    13,
                    0,
                    7,
                    9,
                    0,
                    14,
                    9,
                    6,
                    3,
                    3,
                    4,
                    15,
                    6,
                    5,
                    10,
                    1,
                    2,
                    13,
                    8,
                    12,
                    5,
                    7,
                    14,
                    11,
                    12,
                    4,
                    11,
                    2,
                    15,
                    8,
                    1,
                    13,
                    1,
                    6,
                    10,
                    4,
                    13,
                    9,
                    0,
                    8,
                    6,
                    15,
                    9,
                    3,
                    8,
                    0,
                    7,
                    11,
                    4,
                    1,
                    15,
                    2,
                    14,
                    12,
                    3,
                    5,
                    11,
                    10,
                    5,
                    14,
                    2,
                    7,
                    12,
                    7,
                    13,
                    13,
                    8,
                    14,
                    11,
                    3,
                    5,
                    0,
                    6,
                    6,
                    15,
                    9,
                    0,
                    10,
                    3,
                    1,
                    4,
                    2,
                    7,
                    8,
                    2,
                    5,
                    12,
                    11,
                    1,
                    12,
                    10,
                    4,
                    14,
                    15,
                    9,
                    10,
                    3,
                    6,
                    15,
                    9,
                    0,
                    0,
                    6,
                    12,
                    10,
                    11,
                    1,
                    7,
                    13,
                    13,
                    8,
                    15,
                    9,
                    1,
                    4,
                    3,
                    5,
                    14,
                    11,
                    5,
                    12,
                    2,
                    7,
                    8,
                    2,
                    4,
                    14,
                    2,
                    14,
                    12,
                    11,
                    4,
                    2,
                    1,
                    12,
                    7,
                    4,
                    10,
                    7,
                    11,
                    13,
                    6,
                    1,
                    8,
                    5,
                    5,
                    0,
                    3,
                    15,
                    15,
                    10,
                    13,
                    3,
                    0,
                    9,
                    14,
                    8,
                    9,
                    6,
                    4,
                    11,
                    2,
                    8,
                    1,
                    12,
                    11,
                    7,
                    10,
                    1,
                    13,
                    14,
                    7,
                    2,
                    8,
                    13,
                    15,
                    6,
                    9,
                    15,
                    12,
                    0,
                    5,
                    9,
                    6,
                    10,
                    3,
                    4,
                    0,
                    5,
                    14,
                    3,
                    12,
                    10,
                    1,
                    15,
                    10,
                    4,
                    15,
                    2,
                    9,
                    7,
                    2,
                    12,
                    6,
                    9,
                    8,
                    5,
                    0,
                    6,
                    13,
                    1,
                    3,
                    13,
                    4,
                    14,
                    14,
                    0,
                    7,
                    11,
                    5,
                    3,
                    11,
                    8,
                    9,
                    4,
                    14,
                    3,
                    15,
                    2,
                    5,
                    12,
                    2,
                    9,
                    8,
                    5,
                    12,
                    15,
                    3,
                    10,
                    7,
                    11,
                    0,
                    14,
                    4,
                    1,
                    10,
                    7,
                    1,
                    6,
                    13,
                    0,
                    11,
                    8,
                    6,
                    13,
                    4,
                    13,
                    11,
                    0,
                    2,
                    11,
                    14,
                    7,
                    15,
                    4,
                    0,
                    9,
                    8,
                    1,
                    13,
                    10,
                    3,
                    14,
                    12,
                    3,
                    9,
                    5,
                    7,
                    12,
                    5,
                    2,
                    10,
                    15,
                    6,
                    8,
                    1,
                    6,
                    1,
                    6,
                    4,
                    11,
                    11,
                    13,
                    13,
                    8,
                    12,
                    1,
                    3,
                    4,
                    7,
                    10,
                    14,
                    7,
                    10,
                    9,
                    15,
                    5,
                    6,
                    0,
                    8,
                    15,
                    0,
                    14,
                    5,
                    2,
                    9,
                    3,
                    2,
                    12,
                    13,
                    1,
                    2,
                    15,
                    8,
                    13,
                    4,
                    8,
                    6,
                    10,
                    15,
                    3,
                    11,
                    7,
                    1,
                    4,
                    10,
                    12,
                    9,
                    5,
                    3,
                    6,
                    14,
                    11,
                    5,
                    0,
                    0,
                    14,
                    12,
                    9,
                    7,
                    2,
                    7,
                    2,
                    11,
                    1,
                    4,
                    14,
                    1,
                    7,
                    9,
                    4,
                    12,
                    10,
                    14,
                    8,
                    2,
                    13,
                    0,
                    15,
                    6,
                    12,
                    10,
                    9,
                    13,
                    0,
                    15,
                    3,
                    3,
                    5,
                    5,
                    6,
                    8,
                    11
                ];
                t.substitute = function(e, t) {
                    for(var r = 0, i = 0; i < 4; i++)r <<= 4, r |= n[64 * i + (e >>> 18 - 6 * i & 63)];
                    for(i = 0; i < 4; i++)r <<= 4, r |= n[256 + 64 * i + (t >>> 18 - 6 * i & 63)];
                    return r >>> 0;
                };
                var i = [
                    16,
                    25,
                    12,
                    11,
                    3,
                    20,
                    4,
                    15,
                    31,
                    17,
                    9,
                    6,
                    27,
                    14,
                    1,
                    22,
                    30,
                    24,
                    8,
                    18,
                    0,
                    5,
                    29,
                    23,
                    13,
                    19,
                    2,
                    26,
                    10,
                    21,
                    28,
                    7
                ];
                t.permute = function(e) {
                    for(var t = 0, r = 0; r < i.length; r++)t <<= 1, t |= e >>> i[r] & 1;
                    return t >>> 0;
                }, t.padSplit = function(e, t, r) {
                    for(var n = e.toString(2); n.length < t;)n = "0" + n;
                    for(var i = [], o = 0; o < t; o += r)i.push(n.slice(o, o + r));
                    return i.join(" ");
                };
            },
            28333: (e, t, r)=>{
                "use strict";
                var n = r(29033).Buffer, i = r(78557), o = r(29799), a = r(51592), s = {
                    binary: !0,
                    hex: !0,
                    base64: !0
                };
                t.DiffieHellmanGroup = t.createDiffieHellmanGroup = t.getDiffieHellman = function(e) {
                    var t = new n(o[e].prime, "hex"), r = new n(o[e].gen, "hex");
                    return new a(t, r);
                }, t.createDiffieHellman = t.DiffieHellman = function e(t, r, o, u) {
                    return n.isBuffer(r) || void 0 === s[r] ? e(t, "binary", r, o) : (r = r || "binary", u = u || "binary", o = o || new n([
                        2
                    ]), n.isBuffer(o) || (o = new n(o, u)), "number" == typeof t ? new a(i(t, o), o, !0) : (n.isBuffer(t) || (t = new n(t, r)), new a(t, o, !0)));
                };
            },
            51592: (e, t, r)=>{
                "use strict";
                var n = r(29033).Buffer, i = r(31734), o = new (r(31962)), a = new i(24), s = new i(11), u = new i(10), c = new i(3), f = new i(7), d = r(78557), l = r(75010);
                function h(e, t) {
                    return t = t || "utf8", n.isBuffer(e) || (e = new n(e, t)), this._pub = new i(e), this;
                }
                function p(e, t) {
                    return t = t || "utf8", n.isBuffer(e) || (e = new n(e, t)), this._priv = new i(e), this;
                }
                e.exports = y;
                var b = {};
                function y(e, t, r) {
                    this.setGenerator(t), this.__prime = new i(e), this._prime = i.mont(this.__prime), this._primeLen = e.length, this._pub = void 0, this._priv = void 0, this._primeCode = void 0, r ? (this.setPublicKey = h, this.setPrivateKey = p) : this._primeCode = 8;
                }
                function v(e, t) {
                    var r = new n(e.toArray());
                    return t ? r.toString(t) : r;
                }
                Object.defineProperty(y.prototype, "verifyError", {
                    enumerable: !0,
                    get: function() {
                        return "number" != typeof this._primeCode && (this._primeCode = function(e, t) {
                            var r = t.toString("hex"), n = [
                                r,
                                e.toString(16)
                            ].join("_");
                            if (n in b) return b[n];
                            var i, l = 0;
                            if (e.isEven() || !d.simpleSieve || !d.fermatTest(e) || !o.test(e)) return l += 1, l += "02" === r || "05" === r ? 8 : 4, b[n] = l, l;
                            switch(o.test(e.shrn(1)) || (l += 2), r){
                                case "02":
                                    e.mod(a).cmp(s) && (l += 8);
                                    break;
                                case "05":
                                    (i = e.mod(u)).cmp(c) && i.cmp(f) && (l += 8);
                                    break;
                                default:
                                    l += 4;
                            }
                            return b[n] = l, l;
                        }(this.__prime, this.__gen)), this._primeCode;
                    }
                }), y.prototype.generateKeys = function() {
                    return this._priv || (this._priv = new i(l(this._primeLen))), this._pub = this._gen.toRed(this._prime).redPow(this._priv).fromRed(), this.getPublicKey();
                }, y.prototype.computeSecret = function(e) {
                    var t = (e = (e = new i(e)).toRed(this._prime)).redPow(this._priv).fromRed(), r = new n(t.toArray()), o = this.getPrime();
                    if (r.length < o.length) {
                        var a = new n(o.length - r.length);
                        a.fill(0), r = n.concat([
                            a,
                            r
                        ]);
                    }
                    return r;
                }, y.prototype.getPublicKey = function(e) {
                    return v(this._pub, e);
                }, y.prototype.getPrivateKey = function(e) {
                    return v(this._priv, e);
                }, y.prototype.getPrime = function(e) {
                    return v(this.__prime, e);
                }, y.prototype.getGenerator = function(e) {
                    return v(this._gen, e);
                }, y.prototype.setGenerator = function(e, t) {
                    return t = t || "utf8", n.isBuffer(e) || (e = new n(e, t)), this.__gen = e, this._gen = new i(e), this;
                };
            },
            78557: (e, t, r)=>{
                "use strict";
                var n = r(75010);
                e.exports = m, m.simpleSieve = y, m.fermatTest = v;
                var i = r(31734), o = new i(24), a = new (r(31962)), s = new i(1), u = new i(2), c = new i(5), f = (new i(16), new i(8), new i(10)), d = new i(3), l = (new i(7), new i(11)), h = new i(4), p = (new i(12), null);
                function b() {
                    if (null !== p) return p;
                    var e = [];
                    e[0] = 2;
                    for(var t = 1, r = 3; r < 1048576; r += 2){
                        for(var n = Math.ceil(Math.sqrt(r)), i = 0; i < t && e[i] <= n && r % e[i] != 0; i++);
                        t !== i && e[i] <= n || (e[t++] = r);
                    }
                    return p = e, e;
                }
                function y(e) {
                    for(var t = b(), r = 0; r < t.length; r++)if (0 === e.modn(t[r])) return 0 === e.cmpn(t[r]);
                    return !0;
                }
                function v(e) {
                    var t = i.mont(e);
                    return 0 === u.toRed(t).redPow(e.subn(1)).fromRed().cmpn(1);
                }
                function m(e, t) {
                    if (e < 16) return new i(2 === t || 5 === t ? [
                        140,
                        123
                    ] : [
                        140,
                        39
                    ]);
                    var r, p;
                    for(t = new i(t);;){
                        for(r = new i(n(Math.ceil(e / 8))); r.bitLength() > e;)r.ishrn(1);
                        if (r.isEven() && r.iadd(s), r.testn(1) || r.iadd(u), t.cmp(u)) {
                            if (!t.cmp(c)) for(; r.mod(f).cmp(d);)r.iadd(h);
                        } else for(; r.mod(o).cmp(l);)r.iadd(h);
                        if (y(p = r.shrn(1)) && y(r) && v(p) && v(r) && a.test(p) && a.test(r)) return r;
                    }
                }
            },
            36597: (e, t, r)=>{
                "use strict";
                var n = t;
                n.version = r(18597).i8, n.utils = r(7528), n.rand = r(82202), n.curve = r(76063), n.curves = r(40506), n.ec = r(28320), n.eddsa = r(68027);
            },
            11249: (e, t, r)=>{
                "use strict";
                var n = r(31734), i = r(7528), o = i.getNAF, a = i.getJSF, s = i.assert;
                function u(e, t) {
                    this.type = e, this.p = new n(t.p, 16), this.red = t.prime ? n.red(t.prime) : n.mont(this.p), this.zero = new n(0).toRed(this.red), this.one = new n(1).toRed(this.red), this.two = new n(2).toRed(this.red), this.n = t.n && new n(t.n, 16), this.g = t.g && this.pointFromJSON(t.g, t.gRed), this._wnafT1 = new Array(4), this._wnafT2 = new Array(4), this._wnafT3 = new Array(4), this._wnafT4 = new Array(4), this._bitLength = this.n ? this.n.bitLength() : 0;
                    var r = this.n && this.p.div(this.n);
                    !r || r.cmpn(100) > 0 ? this.redN = null : (this._maxwellTrick = !0, this.redN = this.n.toRed(this.red));
                }
                function c(e, t) {
                    this.curve = e, this.type = t, this.precomputed = null;
                }
                e.exports = u, u.prototype.point = function() {
                    throw new Error("Not implemented");
                }, u.prototype.validate = function() {
                    throw new Error("Not implemented");
                }, u.prototype._fixedNafMul = function(e, t) {
                    s(e.precomputed);
                    var r = e._getDoubles(), n = o(t, 1, this._bitLength), i = (1 << r.step + 1) - (r.step % 2 == 0 ? 2 : 1);
                    i /= 3;
                    var a, u, c = [];
                    for(a = 0; a < n.length; a += r.step){
                        u = 0;
                        for(var f = a + r.step - 1; f >= a; f--)u = (u << 1) + n[f];
                        c.push(u);
                    }
                    for(var d = this.jpoint(null, null, null), l = this.jpoint(null, null, null), h = i; h > 0; h--){
                        for(a = 0; a < c.length; a++)(u = c[a]) === h ? l = l.mixedAdd(r.points[a]) : u === -h && (l = l.mixedAdd(r.points[a].neg()));
                        d = d.add(l);
                    }
                    return d.toP();
                }, u.prototype._wnafMul = function(e, t) {
                    var r = 4, n = e._getNAFPoints(r);
                    r = n.wnd;
                    for(var i = n.points, a = o(t, r, this._bitLength), u = this.jpoint(null, null, null), c = a.length - 1; c >= 0; c--){
                        for(var f = 0; c >= 0 && 0 === a[c]; c--)f++;
                        if (c >= 0 && f++, u = u.dblp(f), c < 0) break;
                        var d = a[c];
                        s(0 !== d), u = "affine" === e.type ? d > 0 ? u.mixedAdd(i[d - 1 >> 1]) : u.mixedAdd(i[-d - 1 >> 1].neg()) : d > 0 ? u.add(i[d - 1 >> 1]) : u.add(i[-d - 1 >> 1].neg());
                    }
                    return "affine" === e.type ? u.toP() : u;
                }, u.prototype._wnafMulAdd = function(e, t, r, n, i) {
                    var s, u, c, f = this._wnafT1, d = this._wnafT2, l = this._wnafT3, h = 0;
                    for(s = 0; s < n; s++){
                        var p = (c = t[s])._getNAFPoints(e);
                        f[s] = p.wnd, d[s] = p.points;
                    }
                    for(s = n - 1; s >= 1; s -= 2){
                        var b = s - 1, y = s;
                        if (1 === f[b] && 1 === f[y]) {
                            var v = [
                                t[b],
                                null,
                                null,
                                t[y]
                            ];
                            0 === t[b].y.cmp(t[y].y) ? (v[1] = t[b].add(t[y]), v[2] = t[b].toJ().mixedAdd(t[y].neg())) : 0 === t[b].y.cmp(t[y].y.redNeg()) ? (v[1] = t[b].toJ().mixedAdd(t[y]), v[2] = t[b].add(t[y].neg())) : (v[1] = t[b].toJ().mixedAdd(t[y]), v[2] = t[b].toJ().mixedAdd(t[y].neg()));
                            var m = [
                                -3,
                                -1,
                                -5,
                                -7,
                                0,
                                7,
                                5,
                                1,
                                3
                            ], g = a(r[b], r[y]);
                            for(h = Math.max(g[0].length, h), l[b] = new Array(h), l[y] = new Array(h), u = 0; u < h; u++){
                                var w = 0 | g[0][u], k = 0 | g[1][u];
                                l[b][u] = m[3 * (w + 1) + (k + 1)], l[y][u] = 0, d[b] = v;
                            }
                        } else l[b] = o(r[b], f[b], this._bitLength), l[y] = o(r[y], f[y], this._bitLength), h = Math.max(l[b].length, h), h = Math.max(l[y].length, h);
                    }
                    var _ = this.jpoint(null, null, null), A = this._wnafT4;
                    for(s = h; s >= 0; s--){
                        for(var E = 0; s >= 0;){
                            var S = !0;
                            for(u = 0; u < n; u++)A[u] = 0 | l[u][s], 0 !== A[u] && (S = !1);
                            if (!S) break;
                            E++, s--;
                        }
                        if (s >= 0 && E++, _ = _.dblp(E), s < 0) break;
                        for(u = 0; u < n; u++){
                            var x = A[u];
                            0 !== x && (x > 0 ? c = d[u][x - 1 >> 1] : x < 0 && (c = d[u][-x - 1 >> 1].neg()), _ = "affine" === c.type ? _.mixedAdd(c) : _.add(c));
                        }
                    }
                    for(s = 0; s < n; s++)d[s] = null;
                    return i ? _ : _.toP();
                }, u.BasePoint = c, c.prototype.eq = function() {
                    throw new Error("Not implemented");
                }, c.prototype.validate = function() {
                    return this.curve.validate(this);
                }, u.prototype.decodePoint = function(e, t) {
                    e = i.toArray(e, t);
                    var r = this.p.byteLength();
                    if ((4 === e[0] || 6 === e[0] || 7 === e[0]) && e.length - 1 == 2 * r) return 6 === e[0] ? s(e[e.length - 1] % 2 == 0) : 7 === e[0] && s(e[e.length - 1] % 2 == 1), this.point(e.slice(1, 1 + r), e.slice(1 + r, 1 + 2 * r));
                    if ((2 === e[0] || 3 === e[0]) && e.length - 1 === r) return this.pointFromX(e.slice(1, 1 + r), 3 === e[0]);
                    throw new Error("Unknown point format");
                }, c.prototype.encodeCompressed = function(e) {
                    return this.encode(e, !0);
                }, c.prototype._encode = function(e) {
                    var t = this.curve.p.byteLength(), r = this.getX().toArray("be", t);
                    return e ? [
                        this.getY().isEven() ? 2 : 3
                    ].concat(r) : [
                        4
                    ].concat(r, this.getY().toArray("be", t));
                }, c.prototype.encode = function(e, t) {
                    return i.encode(this._encode(t), e);
                }, c.prototype.precompute = function(e) {
                    if (this.precomputed) return this;
                    var t = {
                        doubles: null,
                        naf: null,
                        beta: null
                    };
                    return t.naf = this._getNAFPoints(8), t.doubles = this._getDoubles(4, e), t.beta = this._getBeta(), this.precomputed = t, this;
                }, c.prototype._hasDoubles = function(e) {
                    if (!this.precomputed) return !1;
                    var t = this.precomputed.doubles;
                    return !!t && t.points.length >= Math.ceil((e.bitLength() + 1) / t.step);
                }, c.prototype._getDoubles = function(e, t) {
                    if (this.precomputed && this.precomputed.doubles) return this.precomputed.doubles;
                    for(var r = [
                        this
                    ], n = this, i = 0; i < t; i += e){
                        for(var o = 0; o < e; o++)n = n.dbl();
                        r.push(n);
                    }
                    return {
                        step: e,
                        points: r
                    };
                }, c.prototype._getNAFPoints = function(e) {
                    if (this.precomputed && this.precomputed.naf) return this.precomputed.naf;
                    for(var t = [
                        this
                    ], r = (1 << e) - 1, n = 1 === r ? null : this.dbl(), i = 1; i < r; i++)t[i] = t[i - 1].add(n);
                    return {
                        wnd: e,
                        points: t
                    };
                }, c.prototype._getBeta = function() {
                    return null;
                }, c.prototype.dblp = function(e) {
                    for(var t = this, r = 0; r < e; r++)t = t.dbl();
                    return t;
                };
            },
            81123: (e, t, r)=>{
                "use strict";
                var n = r(7528), i = r(31734), o = r(41736), a = r(11249), s = n.assert;
                function u(e) {
                    this.twisted = 1 != (0 | e.a), this.mOneA = this.twisted && -1 == (0 | e.a), this.extended = this.mOneA, a.call(this, "edwards", e), this.a = new i(e.a, 16).umod(this.red.m), this.a = this.a.toRed(this.red), this.c = new i(e.c, 16).toRed(this.red), this.c2 = this.c.redSqr(), this.d = new i(e.d, 16).toRed(this.red), this.dd = this.d.redAdd(this.d), s(!this.twisted || 0 === this.c.fromRed().cmpn(1)), this.oneC = 1 == (0 | e.c);
                }
                function c(e, t, r, n, o) {
                    a.BasePoint.call(this, e, "projective"), null === t && null === r && null === n ? (this.x = this.curve.zero, this.y = this.curve.one, this.z = this.curve.one, this.t = this.curve.zero, this.zOne = !0) : (this.x = new i(t, 16), this.y = new i(r, 16), this.z = n ? new i(n, 16) : this.curve.one, this.t = o && new i(o, 16), this.x.red || (this.x = this.x.toRed(this.curve.red)), this.y.red || (this.y = this.y.toRed(this.curve.red)), this.z.red || (this.z = this.z.toRed(this.curve.red)), this.t && !this.t.red && (this.t = this.t.toRed(this.curve.red)), this.zOne = this.z === this.curve.one, this.curve.extended && !this.t && (this.t = this.x.redMul(this.y), this.zOne || (this.t = this.t.redMul(this.z.redInvm()))));
                }
                o(u, a), e.exports = u, u.prototype._mulA = function(e) {
                    return this.mOneA ? e.redNeg() : this.a.redMul(e);
                }, u.prototype._mulC = function(e) {
                    return this.oneC ? e : this.c.redMul(e);
                }, u.prototype.jpoint = function(e, t, r, n) {
                    return this.point(e, t, r, n);
                }, u.prototype.pointFromX = function(e, t) {
                    (e = new i(e, 16)).red || (e = e.toRed(this.red));
                    var r = e.redSqr(), n = this.c2.redSub(this.a.redMul(r)), o = this.one.redSub(this.c2.redMul(this.d).redMul(r)), a = n.redMul(o.redInvm()), s = a.redSqrt();
                    if (0 !== s.redSqr().redSub(a).cmp(this.zero)) throw new Error("invalid point");
                    var u = s.fromRed().isOdd();
                    return (t && !u || !t && u) && (s = s.redNeg()), this.point(e, s);
                }, u.prototype.pointFromY = function(e, t) {
                    (e = new i(e, 16)).red || (e = e.toRed(this.red));
                    var r = e.redSqr(), n = r.redSub(this.c2), o = r.redMul(this.d).redMul(this.c2).redSub(this.a), a = n.redMul(o.redInvm());
                    if (0 === a.cmp(this.zero)) {
                        if (t) throw new Error("invalid point");
                        return this.point(this.zero, e);
                    }
                    var s = a.redSqrt();
                    if (0 !== s.redSqr().redSub(a).cmp(this.zero)) throw new Error("invalid point");
                    return s.fromRed().isOdd() !== t && (s = s.redNeg()), this.point(s, e);
                }, u.prototype.validate = function(e) {
                    if (e.isInfinity()) return !0;
                    e.normalize();
                    var t = e.x.redSqr(), r = e.y.redSqr(), n = t.redMul(this.a).redAdd(r), i = this.c2.redMul(this.one.redAdd(this.d.redMul(t).redMul(r)));
                    return 0 === n.cmp(i);
                }, o(c, a.BasePoint), u.prototype.pointFromJSON = function(e) {
                    return c.fromJSON(this, e);
                }, u.prototype.point = function(e, t, r, n) {
                    return new c(this, e, t, r, n);
                }, c.fromJSON = function(e, t) {
                    return new c(e, t[0], t[1], t[2]);
                }, c.prototype.inspect = function() {
                    return this.isInfinity() ? "<EC Point Infinity>" : "<EC Point x: " + this.x.fromRed().toString(16, 2) + " y: " + this.y.fromRed().toString(16, 2) + " z: " + this.z.fromRed().toString(16, 2) + ">";
                }, c.prototype.isInfinity = function() {
                    return 0 === this.x.cmpn(0) && (0 === this.y.cmp(this.z) || this.zOne && 0 === this.y.cmp(this.curve.c));
                }, c.prototype._extDbl = function() {
                    var e = this.x.redSqr(), t = this.y.redSqr(), r = this.z.redSqr();
                    r = r.redIAdd(r);
                    var n = this.curve._mulA(e), i = this.x.redAdd(this.y).redSqr().redISub(e).redISub(t), o = n.redAdd(t), a = o.redSub(r), s = n.redSub(t), u = i.redMul(a), c = o.redMul(s), f = i.redMul(s), d = a.redMul(o);
                    return this.curve.point(u, c, d, f);
                }, c.prototype._projDbl = function() {
                    var e, t, r, n, i, o, a = this.x.redAdd(this.y).redSqr(), s = this.x.redSqr(), u = this.y.redSqr();
                    if (this.curve.twisted) {
                        var c = (n = this.curve._mulA(s)).redAdd(u);
                        this.zOne ? (e = a.redSub(s).redSub(u).redMul(c.redSub(this.curve.two)), t = c.redMul(n.redSub(u)), r = c.redSqr().redSub(c).redSub(c)) : (i = this.z.redSqr(), o = c.redSub(i).redISub(i), e = a.redSub(s).redISub(u).redMul(o), t = c.redMul(n.redSub(u)), r = c.redMul(o));
                    } else n = s.redAdd(u), i = this.curve._mulC(this.z).redSqr(), o = n.redSub(i).redSub(i), e = this.curve._mulC(a.redISub(n)).redMul(o), t = this.curve._mulC(n).redMul(s.redISub(u)), r = n.redMul(o);
                    return this.curve.point(e, t, r);
                }, c.prototype.dbl = function() {
                    return this.isInfinity() ? this : this.curve.extended ? this._extDbl() : this._projDbl();
                }, c.prototype._extAdd = function(e) {
                    var t = this.y.redSub(this.x).redMul(e.y.redSub(e.x)), r = this.y.redAdd(this.x).redMul(e.y.redAdd(e.x)), n = this.t.redMul(this.curve.dd).redMul(e.t), i = this.z.redMul(e.z.redAdd(e.z)), o = r.redSub(t), a = i.redSub(n), s = i.redAdd(n), u = r.redAdd(t), c = o.redMul(a), f = s.redMul(u), d = o.redMul(u), l = a.redMul(s);
                    return this.curve.point(c, f, l, d);
                }, c.prototype._projAdd = function(e) {
                    var t, r, n = this.z.redMul(e.z), i = n.redSqr(), o = this.x.redMul(e.x), a = this.y.redMul(e.y), s = this.curve.d.redMul(o).redMul(a), u = i.redSub(s), c = i.redAdd(s), f = this.x.redAdd(this.y).redMul(e.x.redAdd(e.y)).redISub(o).redISub(a), d = n.redMul(u).redMul(f);
                    return this.curve.twisted ? (t = n.redMul(c).redMul(a.redSub(this.curve._mulA(o))), r = u.redMul(c)) : (t = n.redMul(c).redMul(a.redSub(o)), r = this.curve._mulC(u).redMul(c)), this.curve.point(d, t, r);
                }, c.prototype.add = function(e) {
                    return this.isInfinity() ? e : e.isInfinity() ? this : this.curve.extended ? this._extAdd(e) : this._projAdd(e);
                }, c.prototype.mul = function(e) {
                    return this._hasDoubles(e) ? this.curve._fixedNafMul(this, e) : this.curve._wnafMul(this, e);
                }, c.prototype.mulAdd = function(e, t, r) {
                    return this.curve._wnafMulAdd(1, [
                        this,
                        t
                    ], [
                        e,
                        r
                    ], 2, !1);
                }, c.prototype.jmulAdd = function(e, t, r) {
                    return this.curve._wnafMulAdd(1, [
                        this,
                        t
                    ], [
                        e,
                        r
                    ], 2, !0);
                }, c.prototype.normalize = function() {
                    if (this.zOne) return this;
                    var e = this.z.redInvm();
                    return this.x = this.x.redMul(e), this.y = this.y.redMul(e), this.t && (this.t = this.t.redMul(e)), this.z = this.curve.one, this.zOne = !0, this;
                }, c.prototype.neg = function() {
                    return this.curve.point(this.x.redNeg(), this.y, this.z, this.t && this.t.redNeg());
                }, c.prototype.getX = function() {
                    return this.normalize(), this.x.fromRed();
                }, c.prototype.getY = function() {
                    return this.normalize(), this.y.fromRed();
                }, c.prototype.eq = function(e) {
                    return this === e || 0 === this.getX().cmp(e.getX()) && 0 === this.getY().cmp(e.getY());
                }, c.prototype.eqXToP = function(e) {
                    var t = e.toRed(this.curve.red).redMul(this.z);
                    if (0 === this.x.cmp(t)) return !0;
                    for(var r = e.clone(), n = this.curve.redN.redMul(this.z);;){
                        if (r.iadd(this.curve.n), r.cmp(this.curve.p) >= 0) return !1;
                        if (t.redIAdd(n), 0 === this.x.cmp(t)) return !0;
                    }
                }, c.prototype.toP = c.prototype.normalize, c.prototype.mixedAdd = c.prototype.add;
            },
            76063: (e, t, r)=>{
                "use strict";
                var n = t;
                n.base = r(11249), n.short = r(53148), n.mont = r(51105), n.edwards = r(81123);
            },
            51105: (e, t, r)=>{
                "use strict";
                var n = r(31734), i = r(41736), o = r(11249), a = r(7528);
                function s(e) {
                    o.call(this, "mont", e), this.a = new n(e.a, 16).toRed(this.red), this.b = new n(e.b, 16).toRed(this.red), this.i4 = new n(4).toRed(this.red).redInvm(), this.two = new n(2).toRed(this.red), this.a24 = this.i4.redMul(this.a.redAdd(this.two));
                }
                function u(e, t, r) {
                    o.BasePoint.call(this, e, "projective"), null === t && null === r ? (this.x = this.curve.one, this.z = this.curve.zero) : (this.x = new n(t, 16), this.z = new n(r, 16), this.x.red || (this.x = this.x.toRed(this.curve.red)), this.z.red || (this.z = this.z.toRed(this.curve.red)));
                }
                i(s, o), e.exports = s, s.prototype.validate = function(e) {
                    var t = e.normalize().x, r = t.redSqr(), n = r.redMul(t).redAdd(r.redMul(this.a)).redAdd(t);
                    return 0 === n.redSqrt().redSqr().cmp(n);
                }, i(u, o.BasePoint), s.prototype.decodePoint = function(e, t) {
                    return this.point(a.toArray(e, t), 1);
                }, s.prototype.point = function(e, t) {
                    return new u(this, e, t);
                }, s.prototype.pointFromJSON = function(e) {
                    return u.fromJSON(this, e);
                }, u.prototype.precompute = function() {}, u.prototype._encode = function() {
                    return this.getX().toArray("be", this.curve.p.byteLength());
                }, u.fromJSON = function(e, t) {
                    return new u(e, t[0], t[1] || e.one);
                }, u.prototype.inspect = function() {
                    return this.isInfinity() ? "<EC Point Infinity>" : "<EC Point x: " + this.x.fromRed().toString(16, 2) + " z: " + this.z.fromRed().toString(16, 2) + ">";
                }, u.prototype.isInfinity = function() {
                    return 0 === this.z.cmpn(0);
                }, u.prototype.dbl = function() {
                    var e = this.x.redAdd(this.z).redSqr(), t = this.x.redSub(this.z).redSqr(), r = e.redSub(t), n = e.redMul(t), i = r.redMul(t.redAdd(this.curve.a24.redMul(r)));
                    return this.curve.point(n, i);
                }, u.prototype.add = function() {
                    throw new Error("Not supported on Montgomery curve");
                }, u.prototype.diffAdd = function(e, t) {
                    var r = this.x.redAdd(this.z), n = this.x.redSub(this.z), i = e.x.redAdd(e.z), o = e.x.redSub(e.z).redMul(r), a = i.redMul(n), s = t.z.redMul(o.redAdd(a).redSqr()), u = t.x.redMul(o.redISub(a).redSqr());
                    return this.curve.point(s, u);
                }, u.prototype.mul = function(e) {
                    for(var t = e.clone(), r = this, n = this.curve.point(null, null), i = []; 0 !== t.cmpn(0); t.iushrn(1))i.push(t.andln(1));
                    for(var o = i.length - 1; o >= 0; o--)0 === i[o] ? (r = r.diffAdd(n, this), n = n.dbl()) : (n = r.diffAdd(n, this), r = r.dbl());
                    return n;
                }, u.prototype.mulAdd = function() {
                    throw new Error("Not supported on Montgomery curve");
                }, u.prototype.jumlAdd = function() {
                    throw new Error("Not supported on Montgomery curve");
                }, u.prototype.eq = function(e) {
                    return 0 === this.getX().cmp(e.getX());
                }, u.prototype.normalize = function() {
                    return this.x = this.x.redMul(this.z.redInvm()), this.z = this.curve.one, this;
                }, u.prototype.getX = function() {
                    return this.normalize(), this.x.fromRed();
                };
            },
            53148: (e, t, r)=>{
                "use strict";
                var n = r(7528), i = r(31734), o = r(41736), a = r(11249), s = n.assert;
                function u(e) {
                    a.call(this, "short", e), this.a = new i(e.a, 16).toRed(this.red), this.b = new i(e.b, 16).toRed(this.red), this.tinv = this.two.redInvm(), this.zeroA = 0 === this.a.fromRed().cmpn(0), this.threeA = 0 === this.a.fromRed().sub(this.p).cmpn(-3), this.endo = this._getEndomorphism(e), this._endoWnafT1 = new Array(4), this._endoWnafT2 = new Array(4);
                }
                function c(e, t, r, n) {
                    a.BasePoint.call(this, e, "affine"), null === t && null === r ? (this.x = null, this.y = null, this.inf = !0) : (this.x = new i(t, 16), this.y = new i(r, 16), n && (this.x.forceRed(this.curve.red), this.y.forceRed(this.curve.red)), this.x.red || (this.x = this.x.toRed(this.curve.red)), this.y.red || (this.y = this.y.toRed(this.curve.red)), this.inf = !1);
                }
                function f(e, t, r, n) {
                    a.BasePoint.call(this, e, "jacobian"), null === t && null === r && null === n ? (this.x = this.curve.one, this.y = this.curve.one, this.z = new i(0)) : (this.x = new i(t, 16), this.y = new i(r, 16), this.z = new i(n, 16)), this.x.red || (this.x = this.x.toRed(this.curve.red)), this.y.red || (this.y = this.y.toRed(this.curve.red)), this.z.red || (this.z = this.z.toRed(this.curve.red)), this.zOne = this.z === this.curve.one;
                }
                o(u, a), e.exports = u, u.prototype._getEndomorphism = function(e) {
                    if (this.zeroA && this.g && this.n && 1 === this.p.modn(3)) {
                        var t, r;
                        if (e.beta) t = new i(e.beta, 16).toRed(this.red);
                        else {
                            var n = this._getEndoRoots(this.p);
                            t = (t = n[0].cmp(n[1]) < 0 ? n[0] : n[1]).toRed(this.red);
                        }
                        if (e.lambda) r = new i(e.lambda, 16);
                        else {
                            var o = this._getEndoRoots(this.n);
                            0 === this.g.mul(o[0]).x.cmp(this.g.x.redMul(t)) ? r = o[0] : (r = o[1], s(0 === this.g.mul(r).x.cmp(this.g.x.redMul(t))));
                        }
                        return {
                            beta: t,
                            lambda: r,
                            basis: e.basis ? e.basis.map(function(e) {
                                return {
                                    a: new i(e.a, 16),
                                    b: new i(e.b, 16)
                                };
                            }) : this._getEndoBasis(r)
                        };
                    }
                }, u.prototype._getEndoRoots = function(e) {
                    var t = e === this.p ? this.red : i.mont(e), r = new i(2).toRed(t).redInvm(), n = r.redNeg(), o = new i(3).toRed(t).redNeg().redSqrt().redMul(r);
                    return [
                        n.redAdd(o).fromRed(),
                        n.redSub(o).fromRed()
                    ];
                }, u.prototype._getEndoBasis = function(e) {
                    for(var t, r, n, o, a, s, u, c, f, d = this.n.ushrn(Math.floor(this.n.bitLength() / 2)), l = e, h = this.n.clone(), p = new i(1), b = new i(0), y = new i(0), v = new i(1), m = 0; 0 !== l.cmpn(0);){
                        var g = h.div(l);
                        c = h.sub(g.mul(l)), f = y.sub(g.mul(p));
                        var w = v.sub(g.mul(b));
                        if (!n && c.cmp(d) < 0) t = u.neg(), r = p, n = c.neg(), o = f;
                        else if (n && 2 == ++m) break;
                        u = c, h = l, l = c, y = p, p = f, v = b, b = w;
                    }
                    a = c.neg(), s = f;
                    var k = n.sqr().add(o.sqr());
                    return a.sqr().add(s.sqr()).cmp(k) >= 0 && (a = t, s = r), n.negative && (n = n.neg(), o = o.neg()), a.negative && (a = a.neg(), s = s.neg()), [
                        {
                            a: n,
                            b: o
                        },
                        {
                            a,
                            b: s
                        }
                    ];
                }, u.prototype._endoSplit = function(e) {
                    var t = this.endo.basis, r = t[0], n = t[1], i = n.b.mul(e).divRound(this.n), o = r.b.neg().mul(e).divRound(this.n), a = i.mul(r.a), s = o.mul(n.a), u = i.mul(r.b), c = o.mul(n.b);
                    return {
                        k1: e.sub(a).sub(s),
                        k2: u.add(c).neg()
                    };
                }, u.prototype.pointFromX = function(e, t) {
                    (e = new i(e, 16)).red || (e = e.toRed(this.red));
                    var r = e.redSqr().redMul(e).redIAdd(e.redMul(this.a)).redIAdd(this.b), n = r.redSqrt();
                    if (0 !== n.redSqr().redSub(r).cmp(this.zero)) throw new Error("invalid point");
                    var o = n.fromRed().isOdd();
                    return (t && !o || !t && o) && (n = n.redNeg()), this.point(e, n);
                }, u.prototype.validate = function(e) {
                    if (e.inf) return !0;
                    var t = e.x, r = e.y, n = this.a.redMul(t), i = t.redSqr().redMul(t).redIAdd(n).redIAdd(this.b);
                    return 0 === r.redSqr().redISub(i).cmpn(0);
                }, u.prototype._endoWnafMulAdd = function(e, t, r) {
                    for(var n = this._endoWnafT1, i = this._endoWnafT2, o = 0; o < e.length; o++){
                        var a = this._endoSplit(t[o]), s = e[o], u = s._getBeta();
                        a.k1.negative && (a.k1.ineg(), s = s.neg(!0)), a.k2.negative && (a.k2.ineg(), u = u.neg(!0)), n[2 * o] = s, n[2 * o + 1] = u, i[2 * o] = a.k1, i[2 * o + 1] = a.k2;
                    }
                    for(var c = this._wnafMulAdd(1, n, i, 2 * o, r), f = 0; f < 2 * o; f++)n[f] = null, i[f] = null;
                    return c;
                }, o(c, a.BasePoint), u.prototype.point = function(e, t, r) {
                    return new c(this, e, t, r);
                }, u.prototype.pointFromJSON = function(e, t) {
                    return c.fromJSON(this, e, t);
                }, c.prototype._getBeta = function() {
                    if (this.curve.endo) {
                        var e = this.precomputed;
                        if (e && e.beta) return e.beta;
                        var t = this.curve.point(this.x.redMul(this.curve.endo.beta), this.y);
                        if (e) {
                            var r = this.curve, n = function(e) {
                                return r.point(e.x.redMul(r.endo.beta), e.y);
                            };
                            e.beta = t, t.precomputed = {
                                beta: null,
                                naf: e.naf && {
                                    wnd: e.naf.wnd,
                                    points: e.naf.points.map(n)
                                },
                                doubles: e.doubles && {
                                    step: e.doubles.step,
                                    points: e.doubles.points.map(n)
                                }
                            };
                        }
                        return t;
                    }
                }, c.prototype.toJSON = function() {
                    return this.precomputed ? [
                        this.x,
                        this.y,
                        this.precomputed && {
                            doubles: this.precomputed.doubles && {
                                step: this.precomputed.doubles.step,
                                points: this.precomputed.doubles.points.slice(1)
                            },
                            naf: this.precomputed.naf && {
                                wnd: this.precomputed.naf.wnd,
                                points: this.precomputed.naf.points.slice(1)
                            }
                        }
                    ] : [
                        this.x,
                        this.y
                    ];
                }, c.fromJSON = function(e, t, r) {
                    "string" == typeof t && (t = JSON.parse(t));
                    var n = e.point(t[0], t[1], r);
                    if (!t[2]) return n;
                    function i(t) {
                        return e.point(t[0], t[1], r);
                    }
                    var o = t[2];
                    return n.precomputed = {
                        beta: null,
                        doubles: o.doubles && {
                            step: o.doubles.step,
                            points: [
                                n
                            ].concat(o.doubles.points.map(i))
                        },
                        naf: o.naf && {
                            wnd: o.naf.wnd,
                            points: [
                                n
                            ].concat(o.naf.points.map(i))
                        }
                    }, n;
                }, c.prototype.inspect = function() {
                    return this.isInfinity() ? "<EC Point Infinity>" : "<EC Point x: " + this.x.fromRed().toString(16, 2) + " y: " + this.y.fromRed().toString(16, 2) + ">";
                }, c.prototype.isInfinity = function() {
                    return this.inf;
                }, c.prototype.add = function(e) {
                    if (this.inf) return e;
                    if (e.inf) return this;
                    if (this.eq(e)) return this.dbl();
                    if (this.neg().eq(e)) return this.curve.point(null, null);
                    if (0 === this.x.cmp(e.x)) return this.curve.point(null, null);
                    var t = this.y.redSub(e.y);
                    0 !== t.cmpn(0) && (t = t.redMul(this.x.redSub(e.x).redInvm()));
                    var r = t.redSqr().redISub(this.x).redISub(e.x), n = t.redMul(this.x.redSub(r)).redISub(this.y);
                    return this.curve.point(r, n);
                }, c.prototype.dbl = function() {
                    if (this.inf) return this;
                    var e = this.y.redAdd(this.y);
                    if (0 === e.cmpn(0)) return this.curve.point(null, null);
                    var t = this.curve.a, r = this.x.redSqr(), n = e.redInvm(), i = r.redAdd(r).redIAdd(r).redIAdd(t).redMul(n), o = i.redSqr().redISub(this.x.redAdd(this.x)), a = i.redMul(this.x.redSub(o)).redISub(this.y);
                    return this.curve.point(o, a);
                }, c.prototype.getX = function() {
                    return this.x.fromRed();
                }, c.prototype.getY = function() {
                    return this.y.fromRed();
                }, c.prototype.mul = function(e) {
                    return e = new i(e, 16), this.isInfinity() ? this : this._hasDoubles(e) ? this.curve._fixedNafMul(this, e) : this.curve.endo ? this.curve._endoWnafMulAdd([
                        this
                    ], [
                        e
                    ]) : this.curve._wnafMul(this, e);
                }, c.prototype.mulAdd = function(e, t, r) {
                    var n = [
                        this,
                        t
                    ], i = [
                        e,
                        r
                    ];
                    return this.curve.endo ? this.curve._endoWnafMulAdd(n, i) : this.curve._wnafMulAdd(1, n, i, 2);
                }, c.prototype.jmulAdd = function(e, t, r) {
                    var n = [
                        this,
                        t
                    ], i = [
                        e,
                        r
                    ];
                    return this.curve.endo ? this.curve._endoWnafMulAdd(n, i, !0) : this.curve._wnafMulAdd(1, n, i, 2, !0);
                }, c.prototype.eq = function(e) {
                    return this === e || this.inf === e.inf && (this.inf || 0 === this.x.cmp(e.x) && 0 === this.y.cmp(e.y));
                }, c.prototype.neg = function(e) {
                    if (this.inf) return this;
                    var t = this.curve.point(this.x, this.y.redNeg());
                    if (e && this.precomputed) {
                        var r = this.precomputed, n = function(e) {
                            return e.neg();
                        };
                        t.precomputed = {
                            naf: r.naf && {
                                wnd: r.naf.wnd,
                                points: r.naf.points.map(n)
                            },
                            doubles: r.doubles && {
                                step: r.doubles.step,
                                points: r.doubles.points.map(n)
                            }
                        };
                    }
                    return t;
                }, c.prototype.toJ = function() {
                    return this.inf ? this.curve.jpoint(null, null, null) : this.curve.jpoint(this.x, this.y, this.curve.one);
                }, o(f, a.BasePoint), u.prototype.jpoint = function(e, t, r) {
                    return new f(this, e, t, r);
                }, f.prototype.toP = function() {
                    if (this.isInfinity()) return this.curve.point(null, null);
                    var e = this.z.redInvm(), t = e.redSqr(), r = this.x.redMul(t), n = this.y.redMul(t).redMul(e);
                    return this.curve.point(r, n);
                }, f.prototype.neg = function() {
                    return this.curve.jpoint(this.x, this.y.redNeg(), this.z);
                }, f.prototype.add = function(e) {
                    if (this.isInfinity()) return e;
                    if (e.isInfinity()) return this;
                    var t = e.z.redSqr(), r = this.z.redSqr(), n = this.x.redMul(t), i = e.x.redMul(r), o = this.y.redMul(t.redMul(e.z)), a = e.y.redMul(r.redMul(this.z)), s = n.redSub(i), u = o.redSub(a);
                    if (0 === s.cmpn(0)) return 0 !== u.cmpn(0) ? this.curve.jpoint(null, null, null) : this.dbl();
                    var c = s.redSqr(), f = c.redMul(s), d = n.redMul(c), l = u.redSqr().redIAdd(f).redISub(d).redISub(d), h = u.redMul(d.redISub(l)).redISub(o.redMul(f)), p = this.z.redMul(e.z).redMul(s);
                    return this.curve.jpoint(l, h, p);
                }, f.prototype.mixedAdd = function(e) {
                    if (this.isInfinity()) return e.toJ();
                    if (e.isInfinity()) return this;
                    var t = this.z.redSqr(), r = this.x, n = e.x.redMul(t), i = this.y, o = e.y.redMul(t).redMul(this.z), a = r.redSub(n), s = i.redSub(o);
                    if (0 === a.cmpn(0)) return 0 !== s.cmpn(0) ? this.curve.jpoint(null, null, null) : this.dbl();
                    var u = a.redSqr(), c = u.redMul(a), f = r.redMul(u), d = s.redSqr().redIAdd(c).redISub(f).redISub(f), l = s.redMul(f.redISub(d)).redISub(i.redMul(c)), h = this.z.redMul(a);
                    return this.curve.jpoint(d, l, h);
                }, f.prototype.dblp = function(e) {
                    if (0 === e) return this;
                    if (this.isInfinity()) return this;
                    if (!e) return this.dbl();
                    var t;
                    if (this.curve.zeroA || this.curve.threeA) {
                        var r = this;
                        for(t = 0; t < e; t++)r = r.dbl();
                        return r;
                    }
                    var n = this.curve.a, i = this.curve.tinv, o = this.x, a = this.y, s = this.z, u = s.redSqr().redSqr(), c = a.redAdd(a);
                    for(t = 0; t < e; t++){
                        var f = o.redSqr(), d = c.redSqr(), l = d.redSqr(), h = f.redAdd(f).redIAdd(f).redIAdd(n.redMul(u)), p = o.redMul(d), b = h.redSqr().redISub(p.redAdd(p)), y = p.redISub(b), v = h.redMul(y);
                        v = v.redIAdd(v).redISub(l);
                        var m = c.redMul(s);
                        t + 1 < e && (u = u.redMul(l)), o = b, s = m, c = v;
                    }
                    return this.curve.jpoint(o, c.redMul(i), s);
                }, f.prototype.dbl = function() {
                    return this.isInfinity() ? this : this.curve.zeroA ? this._zeroDbl() : this.curve.threeA ? this._threeDbl() : this._dbl();
                }, f.prototype._zeroDbl = function() {
                    var e, t, r;
                    if (this.zOne) {
                        var n = this.x.redSqr(), i = this.y.redSqr(), o = i.redSqr(), a = this.x.redAdd(i).redSqr().redISub(n).redISub(o);
                        a = a.redIAdd(a);
                        var s = n.redAdd(n).redIAdd(n), u = s.redSqr().redISub(a).redISub(a), c = o.redIAdd(o);
                        c = (c = c.redIAdd(c)).redIAdd(c), e = u, t = s.redMul(a.redISub(u)).redISub(c), r = this.y.redAdd(this.y);
                    } else {
                        var f = this.x.redSqr(), d = this.y.redSqr(), l = d.redSqr(), h = this.x.redAdd(d).redSqr().redISub(f).redISub(l);
                        h = h.redIAdd(h);
                        var p = f.redAdd(f).redIAdd(f), b = p.redSqr(), y = l.redIAdd(l);
                        y = (y = y.redIAdd(y)).redIAdd(y), e = b.redISub(h).redISub(h), t = p.redMul(h.redISub(e)).redISub(y), r = (r = this.y.redMul(this.z)).redIAdd(r);
                    }
                    return this.curve.jpoint(e, t, r);
                }, f.prototype._threeDbl = function() {
                    var e, t, r;
                    if (this.zOne) {
                        var n = this.x.redSqr(), i = this.y.redSqr(), o = i.redSqr(), a = this.x.redAdd(i).redSqr().redISub(n).redISub(o);
                        a = a.redIAdd(a);
                        var s = n.redAdd(n).redIAdd(n).redIAdd(this.curve.a), u = s.redSqr().redISub(a).redISub(a);
                        e = u;
                        var c = o.redIAdd(o);
                        c = (c = c.redIAdd(c)).redIAdd(c), t = s.redMul(a.redISub(u)).redISub(c), r = this.y.redAdd(this.y);
                    } else {
                        var f = this.z.redSqr(), d = this.y.redSqr(), l = this.x.redMul(d), h = this.x.redSub(f).redMul(this.x.redAdd(f));
                        h = h.redAdd(h).redIAdd(h);
                        var p = l.redIAdd(l), b = (p = p.redIAdd(p)).redAdd(p);
                        e = h.redSqr().redISub(b), r = this.y.redAdd(this.z).redSqr().redISub(d).redISub(f);
                        var y = d.redSqr();
                        y = (y = (y = y.redIAdd(y)).redIAdd(y)).redIAdd(y), t = h.redMul(p.redISub(e)).redISub(y);
                    }
                    return this.curve.jpoint(e, t, r);
                }, f.prototype._dbl = function() {
                    var e = this.curve.a, t = this.x, r = this.y, n = this.z, i = n.redSqr().redSqr(), o = t.redSqr(), a = r.redSqr(), s = o.redAdd(o).redIAdd(o).redIAdd(e.redMul(i)), u = t.redAdd(t), c = (u = u.redIAdd(u)).redMul(a), f = s.redSqr().redISub(c.redAdd(c)), d = c.redISub(f), l = a.redSqr();
                    l = (l = (l = l.redIAdd(l)).redIAdd(l)).redIAdd(l);
                    var h = s.redMul(d).redISub(l), p = r.redAdd(r).redMul(n);
                    return this.curve.jpoint(f, h, p);
                }, f.prototype.trpl = function() {
                    if (!this.curve.zeroA) return this.dbl().add(this);
                    var e = this.x.redSqr(), t = this.y.redSqr(), r = this.z.redSqr(), n = t.redSqr(), i = e.redAdd(e).redIAdd(e), o = i.redSqr(), a = this.x.redAdd(t).redSqr().redISub(e).redISub(n), s = (a = (a = (a = a.redIAdd(a)).redAdd(a).redIAdd(a)).redISub(o)).redSqr(), u = n.redIAdd(n);
                    u = (u = (u = u.redIAdd(u)).redIAdd(u)).redIAdd(u);
                    var c = i.redIAdd(a).redSqr().redISub(o).redISub(s).redISub(u), f = t.redMul(c);
                    f = (f = f.redIAdd(f)).redIAdd(f);
                    var d = this.x.redMul(s).redISub(f);
                    d = (d = d.redIAdd(d)).redIAdd(d);
                    var l = this.y.redMul(c.redMul(u.redISub(c)).redISub(a.redMul(s)));
                    l = (l = (l = l.redIAdd(l)).redIAdd(l)).redIAdd(l);
                    var h = this.z.redAdd(a).redSqr().redISub(r).redISub(s);
                    return this.curve.jpoint(d, l, h);
                }, f.prototype.mul = function(e, t) {
                    return e = new i(e, t), this.curve._wnafMul(this, e);
                }, f.prototype.eq = function(e) {
                    if ("affine" === e.type) return this.eq(e.toJ());
                    if (this === e) return !0;
                    var t = this.z.redSqr(), r = e.z.redSqr();
                    if (0 !== this.x.redMul(r).redISub(e.x.redMul(t)).cmpn(0)) return !1;
                    var n = t.redMul(this.z), i = r.redMul(e.z);
                    return 0 === this.y.redMul(i).redISub(e.y.redMul(n)).cmpn(0);
                }, f.prototype.eqXToP = function(e) {
                    var t = this.z.redSqr(), r = e.toRed(this.curve.red).redMul(t);
                    if (0 === this.x.cmp(r)) return !0;
                    for(var n = e.clone(), i = this.curve.redN.redMul(t);;){
                        if (n.iadd(this.curve.n), n.cmp(this.curve.p) >= 0) return !1;
                        if (r.redIAdd(i), 0 === this.x.cmp(r)) return !0;
                    }
                }, f.prototype.inspect = function() {
                    return this.isInfinity() ? "<EC JPoint Infinity>" : "<EC JPoint x: " + this.x.toString(16, 2) + " y: " + this.y.toString(16, 2) + " z: " + this.z.toString(16, 2) + ">";
                }, f.prototype.isInfinity = function() {
                    return 0 === this.z.cmpn(0);
                };
            },
            40506: (e, t, r)=>{
                "use strict";
                var n, i = t, o = r(37198), a = r(76063), s = r(7528).assert;
                function u(e) {
                    "short" === e.type ? this.curve = new a.short(e) : "edwards" === e.type ? this.curve = new a.edwards(e) : this.curve = new a.mont(e), this.g = this.curve.g, this.n = this.curve.n, this.hash = e.hash, s(this.g.validate(), "Invalid curve"), s(this.g.mul(this.n).isInfinity(), "Invalid curve, G*N != O");
                }
                function c(e, t) {
                    Object.defineProperty(i, e, {
                        configurable: !0,
                        enumerable: !0,
                        get: function() {
                            var r = new u(t);
                            return Object.defineProperty(i, e, {
                                configurable: !0,
                                enumerable: !0,
                                value: r
                            }), r;
                        }
                    });
                }
                i.PresetCurve = u, c("p192", {
                    type: "short",
                    prime: "p192",
                    p: "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff",
                    a: "ffffffff ffffffff ffffffff fffffffe ffffffff fffffffc",
                    b: "64210519 e59c80e7 0fa7e9ab 72243049 feb8deec c146b9b1",
                    n: "ffffffff ffffffff ffffffff 99def836 146bc9b1 b4d22831",
                    hash: o.sha256,
                    gRed: !1,
                    g: [
                        "188da80e b03090f6 7cbf20eb 43a18800 f4ff0afd 82ff1012",
                        "07192b95 ffc8da78 631011ed 6b24cdd5 73f977a1 1e794811"
                    ]
                }), c("p224", {
                    type: "short",
                    prime: "p224",
                    p: "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001",
                    a: "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff fffffffe",
                    b: "b4050a85 0c04b3ab f5413256 5044b0b7 d7bfd8ba 270b3943 2355ffb4",
                    n: "ffffffff ffffffff ffffffff ffff16a2 e0b8f03e 13dd2945 5c5c2a3d",
                    hash: o.sha256,
                    gRed: !1,
                    g: [
                        "b70e0cbd 6bb4bf7f 321390b9 4a03c1d3 56c21122 343280d6 115c1d21",
                        "bd376388 b5f723fb 4c22dfe6 cd4375a0 5a074764 44d58199 85007e34"
                    ]
                }), c("p256", {
                    type: "short",
                    prime: null,
                    p: "ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff ffffffff",
                    a: "ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff fffffffc",
                    b: "5ac635d8 aa3a93e7 b3ebbd55 769886bc 651d06b0 cc53b0f6 3bce3c3e 27d2604b",
                    n: "ffffffff 00000000 ffffffff ffffffff bce6faad a7179e84 f3b9cac2 fc632551",
                    hash: o.sha256,
                    gRed: !1,
                    g: [
                        "6b17d1f2 e12c4247 f8bce6e5 63a440f2 77037d81 2deb33a0 f4a13945 d898c296",
                        "4fe342e2 fe1a7f9b 8ee7eb4a 7c0f9e16 2bce3357 6b315ece cbb64068 37bf51f5"
                    ]
                }), c("p384", {
                    type: "short",
                    prime: null,
                    p: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe ffffffff 00000000 00000000 ffffffff",
                    a: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe ffffffff 00000000 00000000 fffffffc",
                    b: "b3312fa7 e23ee7e4 988e056b e3f82d19 181d9c6e fe814112 0314088f 5013875a c656398d 8a2ed19d 2a85c8ed d3ec2aef",
                    n: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff c7634d81 f4372ddf 581a0db2 48b0a77a ecec196a ccc52973",
                    hash: o.sha384,
                    gRed: !1,
                    g: [
                        "aa87ca22 be8b0537 8eb1c71e f320ad74 6e1d3b62 8ba79b98 59f741e0 82542a38 5502f25d bf55296c 3a545e38 72760ab7",
                        "3617de4a 96262c6f 5d9e98bf 9292dc29 f8f41dbd 289a147c e9da3113 b5f0b8c0 0a60b1ce 1d7e819d 7a431d7c 90ea0e5f"
                    ]
                }), c("p521", {
                    type: "short",
                    prime: null,
                    p: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff",
                    a: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffc",
                    b: "00000051 953eb961 8e1c9a1f 929a21a0 b68540ee a2da725b 99b315f3 b8b48991 8ef109e1 56193951 ec7e937b 1652c0bd 3bb1bf07 3573df88 3d2c34f1 ef451fd4 6b503f00",
                    n: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffa 51868783 bf2f966b 7fcc0148 f709a5d0 3bb5c9b8 899c47ae bb6fb71e 91386409",
                    hash: o.sha512,
                    gRed: !1,
                    g: [
                        "000000c6 858e06b7 0404e9cd 9e3ecb66 2395b442 9c648139 053fb521 f828af60 6b4d3dba a14b5e77 efe75928 fe1dc127 a2ffa8de 3348b3c1 856a429b f97e7e31 c2e5bd66",
                        "00000118 39296a78 9a3bc004 5c8a5fb4 2c7d1bd9 98f54449 579b4468 17afbd17 273e662c 97ee7299 5ef42640 c550b901 3fad0761 353c7086 a272c240 88be9476 9fd16650"
                    ]
                }), c("curve25519", {
                    type: "mont",
                    prime: "p25519",
                    p: "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed",
                    a: "76d06",
                    b: "1",
                    n: "1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed",
                    hash: o.sha256,
                    gRed: !1,
                    g: [
                        "9"
                    ]
                }), c("ed25519", {
                    type: "edwards",
                    prime: "p25519",
                    p: "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed",
                    a: "-1",
                    c: "1",
                    d: "52036cee2b6ffe73 8cc740797779e898 00700a4d4141d8ab 75eb4dca135978a3",
                    n: "1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed",
                    hash: o.sha256,
                    gRed: !1,
                    g: [
                        "216936d3cd6e53fec0a4e231fdd6dc5c692cc7609525a7b2c9562d608f25d51a",
                        "6666666666666666666666666666666666666666666666666666666666666658"
                    ]
                });
                try {
                    n = r(46401);
                } catch (e) {
                    n = void 0;
                }
                c("secp256k1", {
                    type: "short",
                    prime: "k256",
                    p: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f",
                    a: "0",
                    b: "7",
                    n: "ffffffff ffffffff ffffffff fffffffe baaedce6 af48a03b bfd25e8c d0364141",
                    h: "1",
                    hash: o.sha256,
                    beta: "7ae96a2b657c07106e64479eac3434e99cf0497512f58995c1396c28719501ee",
                    lambda: "5363ad4cc05c30e0a5261c028812645a122e22ea20816678df02967c1b23bd72",
                    basis: [
                        {
                            a: "3086d221a7d46bcde86c90e49284eb15",
                            b: "-e4437ed6010e88286f547fa90abfe4c3"
                        },
                        {
                            a: "114ca50f7a8e2f3f657c1108d9d44cfd8",
                            b: "3086d221a7d46bcde86c90e49284eb15"
                        }
                    ],
                    gRed: !1,
                    g: [
                        "79be667ef9dcbbac55a06295ce870b07029bfcdb2dce28d959f2815b16f81798",
                        "483ada7726a3c4655da4fbfc0e1108a8fd17b448a68554199c47d08ffb10d4b8",
                        n
                    ]
                });
            },
            28320: (e, t, r)=>{
                "use strict";
                var n = r(28847)(r(3355)), i = r(31734), o = r(29410), a = r(7528), s = r(40506), u = r(82202), c = a.assert, f = r(37791), d = r(30488);
                function l(e) {
                    if (!(this instanceof l)) return new l(e);
                    "string" == typeof e && (c(Object.prototype.hasOwnProperty.call(s, e), "Unknown curve " + e), e = s[e]), e instanceof s.PresetCurve && (e = {
                        curve: e
                    }), this.curve = e.curve.curve, this.n = this.curve.n, this.nh = this.n.ushrn(1), this.g = this.curve.g, this.g = e.curve.g, this.g.precompute(e.curve.n.bitLength() + 1), this.hash = e.hash || e.curve.hash;
                }
                e.exports = l, l.prototype.keyPair = function(e) {
                    return new f(this, e);
                }, l.prototype.keyFromPrivate = function(e, t) {
                    return f.fromPrivate(this, e, t);
                }, l.prototype.keyFromPublic = function(e, t) {
                    return f.fromPublic(this, e, t);
                }, l.prototype.genKeyPair = function(e) {
                    e || (e = {});
                    for(var t = new o({
                        hash: this.hash,
                        pers: e.pers,
                        persEnc: e.persEnc || "utf8",
                        entropy: e.entropy || u(this.hash.hmacStrength),
                        entropyEnc: e.entropy && e.entropyEnc || "utf8",
                        nonce: this.n.toArray()
                    }), r = this.n.byteLength(), n = this.n.sub(new i(2));;){
                        var a = new i(t.generate(r));
                        if (!(a.cmp(n) > 0)) return a.iaddn(1), this.keyFromPrivate(a);
                    }
                }, l.prototype._truncateToN = function(e, t) {
                    var r = 8 * e.byteLength() - this.n.bitLength();
                    return r > 0 && (e = e.ushrn(r)), !t && e.cmp(this.n) >= 0 ? e.sub(this.n) : e;
                }, l.prototype.sign = function(e, t, r, a) {
                    "object" === (0, n.default)(r) && (a = r, r = null), a || (a = {}), t = this.keyFromPrivate(t, r), e = this._truncateToN(new i(e, 16));
                    for(var s = this.n.byteLength(), u = t.getPrivate().toArray("be", s), c = e.toArray("be", s), f = new o({
                        hash: this.hash,
                        entropy: u,
                        nonce: c,
                        pers: a.pers,
                        persEnc: a.persEnc || "utf8"
                    }), l = this.n.sub(new i(1)), h = 0;; h++){
                        var p = a.k ? a.k(h) : new i(f.generate(this.n.byteLength()));
                        if (!((p = this._truncateToN(p, !0)).cmpn(1) <= 0 || p.cmp(l) >= 0)) {
                            var b = this.g.mul(p);
                            if (!b.isInfinity()) {
                                var y = b.getX(), v = y.umod(this.n);
                                if (0 !== v.cmpn(0)) {
                                    var m = p.invm(this.n).mul(v.mul(t.getPrivate()).iadd(e));
                                    if (0 !== (m = m.umod(this.n)).cmpn(0)) {
                                        var g = (b.getY().isOdd() ? 1 : 0) | (0 !== y.cmp(v) ? 2 : 0);
                                        return a.canonical && m.cmp(this.nh) > 0 && (m = this.n.sub(m), g ^= 1), new d({
                                            r: v,
                                            s: m,
                                            recoveryParam: g
                                        });
                                    }
                                }
                            }
                        }
                    }
                }, l.prototype.verify = function(e, t, r, n) {
                    e = this._truncateToN(new i(e, 16)), r = this.keyFromPublic(r, n);
                    var o = (t = new d(t, "hex")).r, a = t.s;
                    if (o.cmpn(1) < 0 || o.cmp(this.n) >= 0) return !1;
                    if (a.cmpn(1) < 0 || a.cmp(this.n) >= 0) return !1;
                    var s, u = a.invm(this.n), c = u.mul(e).umod(this.n), f = u.mul(o).umod(this.n);
                    return this.curve._maxwellTrick ? !(s = this.g.jmulAdd(c, r.getPublic(), f)).isInfinity() && s.eqXToP(o) : !(s = this.g.mulAdd(c, r.getPublic(), f)).isInfinity() && 0 === s.getX().umod(this.n).cmp(o);
                }, l.prototype.recoverPubKey = function(e, t, r, n) {
                    c((3 & r) === r, "The recovery param is more than two bits"), t = new d(t, n);
                    var o = this.n, a = new i(e), s = t.r, u = t.s, f = 1 & r, l = r >> 1;
                    if (s.cmp(this.curve.p.umod(this.curve.n)) >= 0 && l) throw new Error("Unable to find sencond key candinate");
                    s = l ? this.curve.pointFromX(s.add(this.curve.n), f) : this.curve.pointFromX(s, f);
                    var h = t.r.invm(o), p = o.sub(a).mul(h).umod(o), b = u.mul(h).umod(o);
                    return this.g.mulAdd(p, s, b);
                }, l.prototype.getKeyRecoveryParam = function(e, t, r, n) {
                    if (null !== (t = new d(t, n)).recoveryParam) return t.recoveryParam;
                    for(var i = 0; i < 4; i++){
                        var o;
                        try {
                            o = this.recoverPubKey(e, t, i);
                        } catch (e) {
                            continue;
                        }
                        if (o.eq(r)) return i;
                    }
                    throw new Error("Unable to find valid recovery factor");
                };
            },
            37791: (e, t, r)=>{
                "use strict";
                var n = r(31734), i = r(7528).assert;
                function o(e, t) {
                    this.ec = e, this.priv = null, this.pub = null, t.priv && this._importPrivate(t.priv, t.privEnc), t.pub && this._importPublic(t.pub, t.pubEnc);
                }
                e.exports = o, o.fromPublic = function(e, t, r) {
                    return t instanceof o ? t : new o(e, {
                        pub: t,
                        pubEnc: r
                    });
                }, o.fromPrivate = function(e, t, r) {
                    return t instanceof o ? t : new o(e, {
                        priv: t,
                        privEnc: r
                    });
                }, o.prototype.validate = function() {
                    var e = this.getPublic();
                    return e.isInfinity() ? {
                        result: !1,
                        reason: "Invalid public key"
                    } : e.validate() ? e.mul(this.ec.curve.n).isInfinity() ? {
                        result: !0,
                        reason: null
                    } : {
                        result: !1,
                        reason: "Public key * N != O"
                    } : {
                        result: !1,
                        reason: "Public key is not a point"
                    };
                }, o.prototype.getPublic = function(e, t) {
                    return "string" == typeof e && (t = e, e = null), this.pub || (this.pub = this.ec.g.mul(this.priv)), t ? this.pub.encode(t, e) : this.pub;
                }, o.prototype.getPrivate = function(e) {
                    return "hex" === e ? this.priv.toString(16, 2) : this.priv;
                }, o.prototype._importPrivate = function(e, t) {
                    this.priv = new n(e, t || 16), this.priv = this.priv.umod(this.ec.curve.n);
                }, o.prototype._importPublic = function(e, t) {
                    if (e.x || e.y) return "mont" === this.ec.curve.type ? i(e.x, "Need x coordinate") : "short" !== this.ec.curve.type && "edwards" !== this.ec.curve.type || i(e.x && e.y, "Need both x and y coordinate"), void (this.pub = this.ec.curve.point(e.x, e.y));
                    this.pub = this.ec.curve.decodePoint(e, t);
                }, o.prototype.derive = function(e) {
                    return e.validate() || i(e.validate(), "public point not validated"), e.mul(this.priv).getX();
                }, o.prototype.sign = function(e, t, r) {
                    return this.ec.sign(e, this, t, r);
                }, o.prototype.verify = function(e, t) {
                    return this.ec.verify(e, t, this);
                }, o.prototype.inspect = function() {
                    return "<Key priv: " + (this.priv && this.priv.toString(16, 2)) + " pub: " + (this.pub && this.pub.inspect()) + " >";
                };
            },
            30488: (e, t, r)=>{
                "use strict";
                var n = r(31734), i = r(7528), o = i.assert;
                function a(e, t) {
                    if (e instanceof a) return e;
                    this._importDER(e, t) || (o(e.r && e.s, "Signature without r or s"), this.r = new n(e.r, 16), this.s = new n(e.s, 16), void 0 === e.recoveryParam ? this.recoveryParam = null : this.recoveryParam = e.recoveryParam);
                }
                function s() {
                    this.place = 0;
                }
                function u(e, t) {
                    var r = e[t.place++];
                    if (!(128 & r)) return r;
                    var n = 15 & r;
                    if (0 === n || n > 4) return !1;
                    for(var i = 0, o = 0, a = t.place; o < n; o++, a++)i <<= 8, i |= e[a], i >>>= 0;
                    return !(i <= 127) && (t.place = a, i);
                }
                function c(e) {
                    for(var t = 0, r = e.length - 1; !e[t] && !(128 & e[t + 1]) && t < r;)t++;
                    return 0 === t ? e : e.slice(t);
                }
                function f(e, t) {
                    if (t < 128) e.push(t);
                    else {
                        var r = 1 + (Math.log(t) / Math.LN2 >>> 3);
                        for(e.push(128 | r); --r;)e.push(t >>> (r << 3) & 255);
                        e.push(t);
                    }
                }
                e.exports = a, a.prototype._importDER = function(e, t) {
                    e = i.toArray(e, t);
                    var r = new s;
                    if (48 !== e[r.place++]) return !1;
                    var o = u(e, r);
                    if (!1 === o) return !1;
                    if (o + r.place !== e.length) return !1;
                    if (2 !== e[r.place++]) return !1;
                    var a = u(e, r);
                    if (!1 === a) return !1;
                    var c = e.slice(r.place, a + r.place);
                    if (r.place += a, 2 !== e[r.place++]) return !1;
                    var f = u(e, r);
                    if (!1 === f) return !1;
                    if (e.length !== f + r.place) return !1;
                    var d = e.slice(r.place, f + r.place);
                    if (0 === c[0]) {
                        if (!(128 & c[1])) return !1;
                        c = c.slice(1);
                    }
                    if (0 === d[0]) {
                        if (!(128 & d[1])) return !1;
                        d = d.slice(1);
                    }
                    return this.r = new n(c), this.s = new n(d), this.recoveryParam = null, !0;
                }, a.prototype.toDER = function(e) {
                    var t = this.r.toArray(), r = this.s.toArray();
                    for(128 & t[0] && (t = [
                        0
                    ].concat(t)), 128 & r[0] && (r = [
                        0
                    ].concat(r)), t = c(t), r = c(r); !(r[0] || 128 & r[1]);)r = r.slice(1);
                    var n = [
                        2
                    ];
                    f(n, t.length), (n = n.concat(t)).push(2), f(n, r.length);
                    var o = n.concat(r), a = [
                        48
                    ];
                    return f(a, o.length), a = a.concat(o), i.encode(a, e);
                };
            },
            68027: (e, t, r)=>{
                "use strict";
                var n = r(37198), i = r(40506), o = r(7528), a = o.assert, s = o.parseBytes, u = r(27303), c = r(36646);
                function f(e) {
                    if (a("ed25519" === e, "only tested with ed25519 so far"), !(this instanceof f)) return new f(e);
                    e = i[e].curve, this.curve = e, this.g = e.g, this.g.precompute(e.n.bitLength() + 1), this.pointClass = e.point().constructor, this.encodingLength = Math.ceil(e.n.bitLength() / 8), this.hash = n.sha512;
                }
                e.exports = f, f.prototype.sign = function(e, t) {
                    e = s(e);
                    var r = this.keyFromSecret(t), n = this.hashInt(r.messagePrefix(), e), i = this.g.mul(n), o = this.encodePoint(i), a = this.hashInt(o, r.pubBytes(), e).mul(r.priv()), u = n.add(a).umod(this.curve.n);
                    return this.makeSignature({
                        R: i,
                        S: u,
                        Rencoded: o
                    });
                }, f.prototype.verify = function(e, t, r) {
                    e = s(e), t = this.makeSignature(t);
                    var n = this.keyFromPublic(r), i = this.hashInt(t.Rencoded(), n.pubBytes(), e), o = this.g.mul(t.S());
                    return t.R().add(n.pub().mul(i)).eq(o);
                }, f.prototype.hashInt = function() {
                    for(var e = this.hash(), t = 0; t < arguments.length; t++)e.update(arguments[t]);
                    return o.intFromLE(e.digest()).umod(this.curve.n);
                }, f.prototype.keyFromPublic = function(e) {
                    return u.fromPublic(this, e);
                }, f.prototype.keyFromSecret = function(e) {
                    return u.fromSecret(this, e);
                }, f.prototype.makeSignature = function(e) {
                    return e instanceof c ? e : new c(this, e);
                }, f.prototype.encodePoint = function(e) {
                    var t = e.getY().toArray("le", this.encodingLength);
                    return t[this.encodingLength - 1] |= e.getX().isOdd() ? 128 : 0, t;
                }, f.prototype.decodePoint = function(e) {
                    var t = (e = o.parseBytes(e)).length - 1, r = e.slice(0, t).concat(-129 & e[t]), n = 0 != (128 & e[t]), i = o.intFromLE(r);
                    return this.curve.pointFromY(i, n);
                }, f.prototype.encodeInt = function(e) {
                    return e.toArray("le", this.encodingLength);
                }, f.prototype.decodeInt = function(e) {
                    return o.intFromLE(e);
                }, f.prototype.isPoint = function(e) {
                    return e instanceof this.pointClass;
                };
            },
            27303: (e, t, r)=>{
                "use strict";
                var n = r(7528), i = n.assert, o = n.parseBytes, a = n.cachedProperty;
                function s(e, t) {
                    this.eddsa = e, this._secret = o(t.secret), e.isPoint(t.pub) ? this._pub = t.pub : this._pubBytes = o(t.pub);
                }
                s.fromPublic = function(e, t) {
                    return t instanceof s ? t : new s(e, {
                        pub: t
                    });
                }, s.fromSecret = function(e, t) {
                    return t instanceof s ? t : new s(e, {
                        secret: t
                    });
                }, s.prototype.secret = function() {
                    return this._secret;
                }, a(s, "pubBytes", function() {
                    return this.eddsa.encodePoint(this.pub());
                }), a(s, "pub", function() {
                    return this._pubBytes ? this.eddsa.decodePoint(this._pubBytes) : this.eddsa.g.mul(this.priv());
                }), a(s, "privBytes", function() {
                    var e = this.eddsa, t = this.hash(), r = e.encodingLength - 1, n = t.slice(0, e.encodingLength);
                    return n[0] &= 248, n[r] &= 127, n[r] |= 64, n;
                }), a(s, "priv", function() {
                    return this.eddsa.decodeInt(this.privBytes());
                }), a(s, "hash", function() {
                    return this.eddsa.hash().update(this.secret()).digest();
                }), a(s, "messagePrefix", function() {
                    return this.hash().slice(this.eddsa.encodingLength);
                }), s.prototype.sign = function(e) {
                    return i(this._secret, "KeyPair can only verify"), this.eddsa.sign(e, this);
                }, s.prototype.verify = function(e, t) {
                    return this.eddsa.verify(e, t, this);
                }, s.prototype.getSecret = function(e) {
                    return i(this._secret, "KeyPair is public only"), n.encode(this.secret(), e);
                }, s.prototype.getPublic = function(e) {
                    return n.encode(this.pubBytes(), e);
                }, e.exports = s;
            },
            36646: (e, t, r)=>{
                "use strict";
                var n = r(28847)(r(3355)), i = r(31734), o = r(7528), a = o.assert, s = o.cachedProperty, u = o.parseBytes;
                function c(e, t) {
                    this.eddsa = e, "object" !== (0, n.default)(t) && (t = u(t)), Array.isArray(t) && (t = {
                        R: t.slice(0, e.encodingLength),
                        S: t.slice(e.encodingLength)
                    }), a(t.R && t.S, "Signature without R or S"), e.isPoint(t.R) && (this._R = t.R), t.S instanceof i && (this._S = t.S), this._Rencoded = Array.isArray(t.R) ? t.R : t.Rencoded, this._Sencoded = Array.isArray(t.S) ? t.S : t.Sencoded;
                }
                s(c, "S", function() {
                    return this.eddsa.decodeInt(this.Sencoded());
                }), s(c, "R", function() {
                    return this.eddsa.decodePoint(this.Rencoded());
                }), s(c, "Rencoded", function() {
                    return this.eddsa.encodePoint(this.R());
                }), s(c, "Sencoded", function() {
                    return this.eddsa.encodeInt(this.S());
                }), c.prototype.toBytes = function() {
                    return this.Rencoded().concat(this.Sencoded());
                }, c.prototype.toHex = function() {
                    return o.encode(this.toBytes(), "hex").toUpperCase();
                }, e.exports = c;
            },
            46401: (e)=>{
                "use strict";
                e.exports = {
                    doubles: {
                        step: 4,
                        points: [
                            [
                                "e60fce93b59e9ec53011aabc21c23e97b2a31369b87a5ae9c44ee89e2a6dec0a",
                                "f7e3507399e595929db99f34f57937101296891e44d23f0be1f32cce69616821"
                            ],
                            [
                                "8282263212c609d9ea2a6e3e172de238d8c39cabd5ac1ca10646e23fd5f51508",
                                "11f8a8098557dfe45e8256e830b60ace62d613ac2f7b17bed31b6eaff6e26caf"
                            ],
                            [
                                "175e159f728b865a72f99cc6c6fc846de0b93833fd2222ed73fce5b551e5b739",
                                "d3506e0d9e3c79eba4ef97a51ff71f5eacb5955add24345c6efa6ffee9fed695"
                            ],
                            [
                                "363d90d447b00c9c99ceac05b6262ee053441c7e55552ffe526bad8f83ff4640",
                                "4e273adfc732221953b445397f3363145b9a89008199ecb62003c7f3bee9de9"
                            ],
                            [
                                "8b4b5f165df3c2be8c6244b5b745638843e4a781a15bcd1b69f79a55dffdf80c",
                                "4aad0a6f68d308b4b3fbd7813ab0da04f9e336546162ee56b3eff0c65fd4fd36"
                            ],
                            [
                                "723cbaa6e5db996d6bf771c00bd548c7b700dbffa6c0e77bcb6115925232fcda",
                                "96e867b5595cc498a921137488824d6e2660a0653779494801dc069d9eb39f5f"
                            ],
                            [
                                "eebfa4d493bebf98ba5feec812c2d3b50947961237a919839a533eca0e7dd7fa",
                                "5d9a8ca3970ef0f269ee7edaf178089d9ae4cdc3a711f712ddfd4fdae1de8999"
                            ],
                            [
                                "100f44da696e71672791d0a09b7bde459f1215a29b3c03bfefd7835b39a48db0",
                                "cdd9e13192a00b772ec8f3300c090666b7ff4a18ff5195ac0fbd5cd62bc65a09"
                            ],
                            [
                                "e1031be262c7ed1b1dc9227a4a04c017a77f8d4464f3b3852c8acde6e534fd2d",
                                "9d7061928940405e6bb6a4176597535af292dd419e1ced79a44f18f29456a00d"
                            ],
                            [
                                "feea6cae46d55b530ac2839f143bd7ec5cf8b266a41d6af52d5e688d9094696d",
                                "e57c6b6c97dce1bab06e4e12bf3ecd5c981c8957cc41442d3155debf18090088"
                            ],
                            [
                                "da67a91d91049cdcb367be4be6ffca3cfeed657d808583de33fa978bc1ec6cb1",
                                "9bacaa35481642bc41f463f7ec9780e5dec7adc508f740a17e9ea8e27a68be1d"
                            ],
                            [
                                "53904faa0b334cdda6e000935ef22151ec08d0f7bb11069f57545ccc1a37b7c0",
                                "5bc087d0bc80106d88c9eccac20d3c1c13999981e14434699dcb096b022771c8"
                            ],
                            [
                                "8e7bcd0bd35983a7719cca7764ca906779b53a043a9b8bcaeff959f43ad86047",
                                "10b7770b2a3da4b3940310420ca9514579e88e2e47fd68b3ea10047e8460372a"
                            ],
                            [
                                "385eed34c1cdff21e6d0818689b81bde71a7f4f18397e6690a841e1599c43862",
                                "283bebc3e8ea23f56701de19e9ebf4576b304eec2086dc8cc0458fe5542e5453"
                            ],
                            [
                                "6f9d9b803ecf191637c73a4413dfa180fddf84a5947fbc9c606ed86c3fac3a7",
                                "7c80c68e603059ba69b8e2a30e45c4d47ea4dd2f5c281002d86890603a842160"
                            ],
                            [
                                "3322d401243c4e2582a2147c104d6ecbf774d163db0f5e5313b7e0e742d0e6bd",
                                "56e70797e9664ef5bfb019bc4ddaf9b72805f63ea2873af624f3a2e96c28b2a0"
                            ],
                            [
                                "85672c7d2de0b7da2bd1770d89665868741b3f9af7643397721d74d28134ab83",
                                "7c481b9b5b43b2eb6374049bfa62c2e5e77f17fcc5298f44c8e3094f790313a6"
                            ],
                            [
                                "948bf809b1988a46b06c9f1919413b10f9226c60f668832ffd959af60c82a0a",
                                "53a562856dcb6646dc6b74c5d1c3418c6d4dff08c97cd2bed4cb7f88d8c8e589"
                            ],
                            [
                                "6260ce7f461801c34f067ce0f02873a8f1b0e44dfc69752accecd819f38fd8e8",
                                "bc2da82b6fa5b571a7f09049776a1ef7ecd292238051c198c1a84e95b2b4ae17"
                            ],
                            [
                                "e5037de0afc1d8d43d8348414bbf4103043ec8f575bfdc432953cc8d2037fa2d",
                                "4571534baa94d3b5f9f98d09fb990bddbd5f5b03ec481f10e0e5dc841d755bda"
                            ],
                            [
                                "e06372b0f4a207adf5ea905e8f1771b4e7e8dbd1c6a6c5b725866a0ae4fce725",
                                "7a908974bce18cfe12a27bb2ad5a488cd7484a7787104870b27034f94eee31dd"
                            ],
                            [
                                "213c7a715cd5d45358d0bbf9dc0ce02204b10bdde2a3f58540ad6908d0559754",
                                "4b6dad0b5ae462507013ad06245ba190bb4850f5f36a7eeddff2c27534b458f2"
                            ],
                            [
                                "4e7c272a7af4b34e8dbb9352a5419a87e2838c70adc62cddf0cc3a3b08fbd53c",
                                "17749c766c9d0b18e16fd09f6def681b530b9614bff7dd33e0b3941817dcaae6"
                            ],
                            [
                                "fea74e3dbe778b1b10f238ad61686aa5c76e3db2be43057632427e2840fb27b6",
                                "6e0568db9b0b13297cf674deccb6af93126b596b973f7b77701d3db7f23cb96f"
                            ],
                            [
                                "76e64113f677cf0e10a2570d599968d31544e179b760432952c02a4417bdde39",
                                "c90ddf8dee4e95cf577066d70681f0d35e2a33d2b56d2032b4b1752d1901ac01"
                            ],
                            [
                                "c738c56b03b2abe1e8281baa743f8f9a8f7cc643df26cbee3ab150242bcbb891",
                                "893fb578951ad2537f718f2eacbfbbbb82314eef7880cfe917e735d9699a84c3"
                            ],
                            [
                                "d895626548b65b81e264c7637c972877d1d72e5f3a925014372e9f6588f6c14b",
                                "febfaa38f2bc7eae728ec60818c340eb03428d632bb067e179363ed75d7d991f"
                            ],
                            [
                                "b8da94032a957518eb0f6433571e8761ceffc73693e84edd49150a564f676e03",
                                "2804dfa44805a1e4d7c99cc9762808b092cc584d95ff3b511488e4e74efdf6e7"
                            ],
                            [
                                "e80fea14441fb33a7d8adab9475d7fab2019effb5156a792f1a11778e3c0df5d",
                                "eed1de7f638e00771e89768ca3ca94472d155e80af322ea9fcb4291b6ac9ec78"
                            ],
                            [
                                "a301697bdfcd704313ba48e51d567543f2a182031efd6915ddc07bbcc4e16070",
                                "7370f91cfb67e4f5081809fa25d40f9b1735dbf7c0a11a130c0d1a041e177ea1"
                            ],
                            [
                                "90ad85b389d6b936463f9d0512678de208cc330b11307fffab7ac63e3fb04ed4",
                                "e507a3620a38261affdcbd9427222b839aefabe1582894d991d4d48cb6ef150"
                            ],
                            [
                                "8f68b9d2f63b5f339239c1ad981f162ee88c5678723ea3351b7b444c9ec4c0da",
                                "662a9f2dba063986de1d90c2b6be215dbbea2cfe95510bfdf23cbf79501fff82"
                            ],
                            [
                                "e4f3fb0176af85d65ff99ff9198c36091f48e86503681e3e6686fd5053231e11",
                                "1e63633ad0ef4f1c1661a6d0ea02b7286cc7e74ec951d1c9822c38576feb73bc"
                            ],
                            [
                                "8c00fa9b18ebf331eb961537a45a4266c7034f2f0d4e1d0716fb6eae20eae29e",
                                "efa47267fea521a1a9dc343a3736c974c2fadafa81e36c54e7d2a4c66702414b"
                            ],
                            [
                                "e7a26ce69dd4829f3e10cec0a9e98ed3143d084f308b92c0997fddfc60cb3e41",
                                "2a758e300fa7984b471b006a1aafbb18d0a6b2c0420e83e20e8a9421cf2cfd51"
                            ],
                            [
                                "b6459e0ee3662ec8d23540c223bcbdc571cbcb967d79424f3cf29eb3de6b80ef",
                                "67c876d06f3e06de1dadf16e5661db3c4b3ae6d48e35b2ff30bf0b61a71ba45"
                            ],
                            [
                                "d68a80c8280bb840793234aa118f06231d6f1fc67e73c5a5deda0f5b496943e8",
                                "db8ba9fff4b586d00c4b1f9177b0e28b5b0e7b8f7845295a294c84266b133120"
                            ],
                            [
                                "324aed7df65c804252dc0270907a30b09612aeb973449cea4095980fc28d3d5d",
                                "648a365774b61f2ff130c0c35aec1f4f19213b0c7e332843967224af96ab7c84"
                            ],
                            [
                                "4df9c14919cde61f6d51dfdbe5fee5dceec4143ba8d1ca888e8bd373fd054c96",
                                "35ec51092d8728050974c23a1d85d4b5d506cdc288490192ebac06cad10d5d"
                            ],
                            [
                                "9c3919a84a474870faed8a9c1cc66021523489054d7f0308cbfc99c8ac1f98cd",
                                "ddb84f0f4a4ddd57584f044bf260e641905326f76c64c8e6be7e5e03d4fc599d"
                            ],
                            [
                                "6057170b1dd12fdf8de05f281d8e06bb91e1493a8b91d4cc5a21382120a959e5",
                                "9a1af0b26a6a4807add9a2daf71df262465152bc3ee24c65e899be932385a2a8"
                            ],
                            [
                                "a576df8e23a08411421439a4518da31880cef0fba7d4df12b1a6973eecb94266",
                                "40a6bf20e76640b2c92b97afe58cd82c432e10a7f514d9f3ee8be11ae1b28ec8"
                            ],
                            [
                                "7778a78c28dec3e30a05fe9629de8c38bb30d1f5cf9a3a208f763889be58ad71",
                                "34626d9ab5a5b22ff7098e12f2ff580087b38411ff24ac563b513fc1fd9f43ac"
                            ],
                            [
                                "928955ee637a84463729fd30e7afd2ed5f96274e5ad7e5cb09eda9c06d903ac",
                                "c25621003d3f42a827b78a13093a95eeac3d26efa8a8d83fc5180e935bcd091f"
                            ],
                            [
                                "85d0fef3ec6db109399064f3a0e3b2855645b4a907ad354527aae75163d82751",
                                "1f03648413a38c0be29d496e582cf5663e8751e96877331582c237a24eb1f962"
                            ],
                            [
                                "ff2b0dce97eece97c1c9b6041798b85dfdfb6d8882da20308f5404824526087e",
                                "493d13fef524ba188af4c4dc54d07936c7b7ed6fb90e2ceb2c951e01f0c29907"
                            ],
                            [
                                "827fbbe4b1e880ea9ed2b2e6301b212b57f1ee148cd6dd28780e5e2cf856e241",
                                "c60f9c923c727b0b71bef2c67d1d12687ff7a63186903166d605b68baec293ec"
                            ],
                            [
                                "eaa649f21f51bdbae7be4ae34ce6e5217a58fdce7f47f9aa7f3b58fa2120e2b3",
                                "be3279ed5bbbb03ac69a80f89879aa5a01a6b965f13f7e59d47a5305ba5ad93d"
                            ],
                            [
                                "e4a42d43c5cf169d9391df6decf42ee541b6d8f0c9a137401e23632dda34d24f",
                                "4d9f92e716d1c73526fc99ccfb8ad34ce886eedfa8d8e4f13a7f7131deba9414"
                            ],
                            [
                                "1ec80fef360cbdd954160fadab352b6b92b53576a88fea4947173b9d4300bf19",
                                "aeefe93756b5340d2f3a4958a7abbf5e0146e77f6295a07b671cdc1cc107cefd"
                            ],
                            [
                                "146a778c04670c2f91b00af4680dfa8bce3490717d58ba889ddb5928366642be",
                                "b318e0ec3354028add669827f9d4b2870aaa971d2f7e5ed1d0b297483d83efd0"
                            ],
                            [
                                "fa50c0f61d22e5f07e3acebb1aa07b128d0012209a28b9776d76a8793180eef9",
                                "6b84c6922397eba9b72cd2872281a68a5e683293a57a213b38cd8d7d3f4f2811"
                            ],
                            [
                                "da1d61d0ca721a11b1a5bf6b7d88e8421a288ab5d5bba5220e53d32b5f067ec2",
                                "8157f55a7c99306c79c0766161c91e2966a73899d279b48a655fba0f1ad836f1"
                            ],
                            [
                                "a8e282ff0c9706907215ff98e8fd416615311de0446f1e062a73b0610d064e13",
                                "7f97355b8db81c09abfb7f3c5b2515888b679a3e50dd6bd6cef7c73111f4cc0c"
                            ],
                            [
                                "174a53b9c9a285872d39e56e6913cab15d59b1fa512508c022f382de8319497c",
                                "ccc9dc37abfc9c1657b4155f2c47f9e6646b3a1d8cb9854383da13ac079afa73"
                            ],
                            [
                                "959396981943785c3d3e57edf5018cdbe039e730e4918b3d884fdff09475b7ba",
                                "2e7e552888c331dd8ba0386a4b9cd6849c653f64c8709385e9b8abf87524f2fd"
                            ],
                            [
                                "d2a63a50ae401e56d645a1153b109a8fcca0a43d561fba2dbb51340c9d82b151",
                                "e82d86fb6443fcb7565aee58b2948220a70f750af484ca52d4142174dcf89405"
                            ],
                            [
                                "64587e2335471eb890ee7896d7cfdc866bacbdbd3839317b3436f9b45617e073",
                                "d99fcdd5bf6902e2ae96dd6447c299a185b90a39133aeab358299e5e9faf6589"
                            ],
                            [
                                "8481bde0e4e4d885b3a546d3e549de042f0aa6cea250e7fd358d6c86dd45e458",
                                "38ee7b8cba5404dd84a25bf39cecb2ca900a79c42b262e556d64b1b59779057e"
                            ],
                            [
                                "13464a57a78102aa62b6979ae817f4637ffcfed3c4b1ce30bcd6303f6caf666b",
                                "69be159004614580ef7e433453ccb0ca48f300a81d0942e13f495a907f6ecc27"
                            ],
                            [
                                "bc4a9df5b713fe2e9aef430bcc1dc97a0cd9ccede2f28588cada3a0d2d83f366",
                                "d3a81ca6e785c06383937adf4b798caa6e8a9fbfa547b16d758d666581f33c1"
                            ],
                            [
                                "8c28a97bf8298bc0d23d8c749452a32e694b65e30a9472a3954ab30fe5324caa",
                                "40a30463a3305193378fedf31f7cc0eb7ae784f0451cb9459e71dc73cbef9482"
                            ],
                            [
                                "8ea9666139527a8c1dd94ce4f071fd23c8b350c5a4bb33748c4ba111faccae0",
                                "620efabbc8ee2782e24e7c0cfb95c5d735b783be9cf0f8e955af34a30e62b945"
                            ],
                            [
                                "dd3625faef5ba06074669716bbd3788d89bdde815959968092f76cc4eb9a9787",
                                "7a188fa3520e30d461da2501045731ca941461982883395937f68d00c644a573"
                            ],
                            [
                                "f710d79d9eb962297e4f6232b40e8f7feb2bc63814614d692c12de752408221e",
                                "ea98e67232d3b3295d3b535532115ccac8612c721851617526ae47a9c77bfc82"
                            ]
                        ]
                    },
                    naf: {
                        wnd: 7,
                        points: [
                            [
                                "f9308a019258c31049344f85f89d5229b531c845836f99b08601f113bce036f9",
                                "388f7b0f632de8140fe337e62a37f3566500a99934c2231b6cb9fd7584b8e672"
                            ],
                            [
                                "2f8bde4d1a07209355b4a7250a5c5128e88b84bddc619ab7cba8d569b240efe4",
                                "d8ac222636e5e3d6d4dba9dda6c9c426f788271bab0d6840dca87d3aa6ac62d6"
                            ],
                            [
                                "5cbdf0646e5db4eaa398f365f2ea7a0e3d419b7e0330e39ce92bddedcac4f9bc",
                                "6aebca40ba255960a3178d6d861a54dba813d0b813fde7b5a5082628087264da"
                            ],
                            [
                                "acd484e2f0c7f65309ad178a9f559abde09796974c57e714c35f110dfc27ccbe",
                                "cc338921b0a7d9fd64380971763b61e9add888a4375f8e0f05cc262ac64f9c37"
                            ],
                            [
                                "774ae7f858a9411e5ef4246b70c65aac5649980be5c17891bbec17895da008cb",
                                "d984a032eb6b5e190243dd56d7b7b365372db1e2dff9d6a8301d74c9c953c61b"
                            ],
                            [
                                "f28773c2d975288bc7d1d205c3748651b075fbc6610e58cddeeddf8f19405aa8",
                                "ab0902e8d880a89758212eb65cdaf473a1a06da521fa91f29b5cb52db03ed81"
                            ],
                            [
                                "d7924d4f7d43ea965a465ae3095ff41131e5946f3c85f79e44adbcf8e27e080e",
                                "581e2872a86c72a683842ec228cc6defea40af2bd896d3a5c504dc9ff6a26b58"
                            ],
                            [
                                "defdea4cdb677750a420fee807eacf21eb9898ae79b9768766e4faa04a2d4a34",
                                "4211ab0694635168e997b0ead2a93daeced1f4a04a95c0f6cfb199f69e56eb77"
                            ],
                            [
                                "2b4ea0a797a443d293ef5cff444f4979f06acfebd7e86d277475656138385b6c",
                                "85e89bc037945d93b343083b5a1c86131a01f60c50269763b570c854e5c09b7a"
                            ],
                            [
                                "352bbf4a4cdd12564f93fa332ce333301d9ad40271f8107181340aef25be59d5",
                                "321eb4075348f534d59c18259dda3e1f4a1b3b2e71b1039c67bd3d8bcf81998c"
                            ],
                            [
                                "2fa2104d6b38d11b0230010559879124e42ab8dfeff5ff29dc9cdadd4ecacc3f",
                                "2de1068295dd865b64569335bd5dd80181d70ecfc882648423ba76b532b7d67"
                            ],
                            [
                                "9248279b09b4d68dab21a9b066edda83263c3d84e09572e269ca0cd7f5453714",
                                "73016f7bf234aade5d1aa71bdea2b1ff3fc0de2a887912ffe54a32ce97cb3402"
                            ],
                            [
                                "daed4f2be3a8bf278e70132fb0beb7522f570e144bf615c07e996d443dee8729",
                                "a69dce4a7d6c98e8d4a1aca87ef8d7003f83c230f3afa726ab40e52290be1c55"
                            ],
                            [
                                "c44d12c7065d812e8acf28d7cbb19f9011ecd9e9fdf281b0e6a3b5e87d22e7db",
                                "2119a460ce326cdc76c45926c982fdac0e106e861edf61c5a039063f0e0e6482"
                            ],
                            [
                                "6a245bf6dc698504c89a20cfded60853152b695336c28063b61c65cbd269e6b4",
                                "e022cf42c2bd4a708b3f5126f16a24ad8b33ba48d0423b6efd5e6348100d8a82"
                            ],
                            [
                                "1697ffa6fd9de627c077e3d2fe541084ce13300b0bec1146f95ae57f0d0bd6a5",
                                "b9c398f186806f5d27561506e4557433a2cf15009e498ae7adee9d63d01b2396"
                            ],
                            [
                                "605bdb019981718b986d0f07e834cb0d9deb8360ffb7f61df982345ef27a7479",
                                "2972d2de4f8d20681a78d93ec96fe23c26bfae84fb14db43b01e1e9056b8c49"
                            ],
                            [
                                "62d14dab4150bf497402fdc45a215e10dcb01c354959b10cfe31c7e9d87ff33d",
                                "80fc06bd8cc5b01098088a1950eed0db01aa132967ab472235f5642483b25eaf"
                            ],
                            [
                                "80c60ad0040f27dade5b4b06c408e56b2c50e9f56b9b8b425e555c2f86308b6f",
                                "1c38303f1cc5c30f26e66bad7fe72f70a65eed4cbe7024eb1aa01f56430bd57a"
                            ],
                            [
                                "7a9375ad6167ad54aa74c6348cc54d344cc5dc9487d847049d5eabb0fa03c8fb",
                                "d0e3fa9eca8726909559e0d79269046bdc59ea10c70ce2b02d499ec224dc7f7"
                            ],
                            [
                                "d528ecd9b696b54c907a9ed045447a79bb408ec39b68df504bb51f459bc3ffc9",
                                "eecf41253136e5f99966f21881fd656ebc4345405c520dbc063465b521409933"
                            ],
                            [
                                "49370a4b5f43412ea25f514e8ecdad05266115e4a7ecb1387231808f8b45963",
                                "758f3f41afd6ed428b3081b0512fd62a54c3f3afbb5b6764b653052a12949c9a"
                            ],
                            [
                                "77f230936ee88cbbd73df930d64702ef881d811e0e1498e2f1c13eb1fc345d74",
                                "958ef42a7886b6400a08266e9ba1b37896c95330d97077cbbe8eb3c7671c60d6"
                            ],
                            [
                                "f2dac991cc4ce4b9ea44887e5c7c0bce58c80074ab9d4dbaeb28531b7739f530",
                                "e0dedc9b3b2f8dad4da1f32dec2531df9eb5fbeb0598e4fd1a117dba703a3c37"
                            ],
                            [
                                "463b3d9f662621fb1b4be8fbbe2520125a216cdfc9dae3debcba4850c690d45b",
                                "5ed430d78c296c3543114306dd8622d7c622e27c970a1de31cb377b01af7307e"
                            ],
                            [
                                "f16f804244e46e2a09232d4aff3b59976b98fac14328a2d1a32496b49998f247",
                                "cedabd9b82203f7e13d206fcdf4e33d92a6c53c26e5cce26d6579962c4e31df6"
                            ],
                            [
                                "caf754272dc84563b0352b7a14311af55d245315ace27c65369e15f7151d41d1",
                                "cb474660ef35f5f2a41b643fa5e460575f4fa9b7962232a5c32f908318a04476"
                            ],
                            [
                                "2600ca4b282cb986f85d0f1709979d8b44a09c07cb86d7c124497bc86f082120",
                                "4119b88753c15bd6a693b03fcddbb45d5ac6be74ab5f0ef44b0be9475a7e4b40"
                            ],
                            [
                                "7635ca72d7e8432c338ec53cd12220bc01c48685e24f7dc8c602a7746998e435",
                                "91b649609489d613d1d5e590f78e6d74ecfc061d57048bad9e76f302c5b9c61"
                            ],
                            [
                                "754e3239f325570cdbbf4a87deee8a66b7f2b33479d468fbc1a50743bf56cc18",
                                "673fb86e5bda30fb3cd0ed304ea49a023ee33d0197a695d0c5d98093c536683"
                            ],
                            [
                                "e3e6bd1071a1e96aff57859c82d570f0330800661d1c952f9fe2694691d9b9e8",
                                "59c9e0bba394e76f40c0aa58379a3cb6a5a2283993e90c4167002af4920e37f5"
                            ],
                            [
                                "186b483d056a033826ae73d88f732985c4ccb1f32ba35f4b4cc47fdcf04aa6eb",
                                "3b952d32c67cf77e2e17446e204180ab21fb8090895138b4a4a797f86e80888b"
                            ],
                            [
                                "df9d70a6b9876ce544c98561f4be4f725442e6d2b737d9c91a8321724ce0963f",
                                "55eb2dafd84d6ccd5f862b785dc39d4ab157222720ef9da217b8c45cf2ba2417"
                            ],
                            [
                                "5edd5cc23c51e87a497ca815d5dce0f8ab52554f849ed8995de64c5f34ce7143",
                                "efae9c8dbc14130661e8cec030c89ad0c13c66c0d17a2905cdc706ab7399a868"
                            ],
                            [
                                "290798c2b6476830da12fe02287e9e777aa3fba1c355b17a722d362f84614fba",
                                "e38da76dcd440621988d00bcf79af25d5b29c094db2a23146d003afd41943e7a"
                            ],
                            [
                                "af3c423a95d9f5b3054754efa150ac39cd29552fe360257362dfdecef4053b45",
                                "f98a3fd831eb2b749a93b0e6f35cfb40c8cd5aa667a15581bc2feded498fd9c6"
                            ],
                            [
                                "766dbb24d134e745cccaa28c99bf274906bb66b26dcf98df8d2fed50d884249a",
                                "744b1152eacbe5e38dcc887980da38b897584a65fa06cedd2c924f97cbac5996"
                            ],
                            [
                                "59dbf46f8c94759ba21277c33784f41645f7b44f6c596a58ce92e666191abe3e",
                                "c534ad44175fbc300f4ea6ce648309a042ce739a7919798cd85e216c4a307f6e"
                            ],
                            [
                                "f13ada95103c4537305e691e74e9a4a8dd647e711a95e73cb62dc6018cfd87b8",
                                "e13817b44ee14de663bf4bc808341f326949e21a6a75c2570778419bdaf5733d"
                            ],
                            [
                                "7754b4fa0e8aced06d4167a2c59cca4cda1869c06ebadfb6488550015a88522c",
                                "30e93e864e669d82224b967c3020b8fa8d1e4e350b6cbcc537a48b57841163a2"
                            ],
                            [
                                "948dcadf5990e048aa3874d46abef9d701858f95de8041d2a6828c99e2262519",
                                "e491a42537f6e597d5d28a3224b1bc25df9154efbd2ef1d2cbba2cae5347d57e"
                            ],
                            [
                                "7962414450c76c1689c7b48f8202ec37fb224cf5ac0bfa1570328a8a3d7c77ab",
                                "100b610ec4ffb4760d5c1fc133ef6f6b12507a051f04ac5760afa5b29db83437"
                            ],
                            [
                                "3514087834964b54b15b160644d915485a16977225b8847bb0dd085137ec47ca",
                                "ef0afbb2056205448e1652c48e8127fc6039e77c15c2378b7e7d15a0de293311"
                            ],
                            [
                                "d3cc30ad6b483e4bc79ce2c9dd8bc54993e947eb8df787b442943d3f7b527eaf",
                                "8b378a22d827278d89c5e9be8f9508ae3c2ad46290358630afb34db04eede0a4"
                            ],
                            [
                                "1624d84780732860ce1c78fcbfefe08b2b29823db913f6493975ba0ff4847610",
                                "68651cf9b6da903e0914448c6cd9d4ca896878f5282be4c8cc06e2a404078575"
                            ],
                            [
                                "733ce80da955a8a26902c95633e62a985192474b5af207da6df7b4fd5fc61cd4",
                                "f5435a2bd2badf7d485a4d8b8db9fcce3e1ef8e0201e4578c54673bc1dc5ea1d"
                            ],
                            [
                                "15d9441254945064cf1a1c33bbd3b49f8966c5092171e699ef258dfab81c045c",
                                "d56eb30b69463e7234f5137b73b84177434800bacebfc685fc37bbe9efe4070d"
                            ],
                            [
                                "a1d0fcf2ec9de675b612136e5ce70d271c21417c9d2b8aaaac138599d0717940",
                                "edd77f50bcb5a3cab2e90737309667f2641462a54070f3d519212d39c197a629"
                            ],
                            [
                                "e22fbe15c0af8ccc5780c0735f84dbe9a790badee8245c06c7ca37331cb36980",
                                "a855babad5cd60c88b430a69f53a1a7a38289154964799be43d06d77d31da06"
                            ],
                            [
                                "311091dd9860e8e20ee13473c1155f5f69635e394704eaa74009452246cfa9b3",
                                "66db656f87d1f04fffd1f04788c06830871ec5a64feee685bd80f0b1286d8374"
                            ],
                            [
                                "34c1fd04d301be89b31c0442d3e6ac24883928b45a9340781867d4232ec2dbdf",
                                "9414685e97b1b5954bd46f730174136d57f1ceeb487443dc5321857ba73abee"
                            ],
                            [
                                "f219ea5d6b54701c1c14de5b557eb42a8d13f3abbcd08affcc2a5e6b049b8d63",
                                "4cb95957e83d40b0f73af4544cccf6b1f4b08d3c07b27fb8d8c2962a400766d1"
                            ],
                            [
                                "d7b8740f74a8fbaab1f683db8f45de26543a5490bca627087236912469a0b448",
                                "fa77968128d9c92ee1010f337ad4717eff15db5ed3c049b3411e0315eaa4593b"
                            ],
                            [
                                "32d31c222f8f6f0ef86f7c98d3a3335ead5bcd32abdd94289fe4d3091aa824bf",
                                "5f3032f5892156e39ccd3d7915b9e1da2e6dac9e6f26e961118d14b8462e1661"
                            ],
                            [
                                "7461f371914ab32671045a155d9831ea8793d77cd59592c4340f86cbc18347b5",
                                "8ec0ba238b96bec0cbdddcae0aa442542eee1ff50c986ea6b39847b3cc092ff6"
                            ],
                            [
                                "ee079adb1df1860074356a25aa38206a6d716b2c3e67453d287698bad7b2b2d6",
                                "8dc2412aafe3be5c4c5f37e0ecc5f9f6a446989af04c4e25ebaac479ec1c8c1e"
                            ],
                            [
                                "16ec93e447ec83f0467b18302ee620f7e65de331874c9dc72bfd8616ba9da6b5",
                                "5e4631150e62fb40d0e8c2a7ca5804a39d58186a50e497139626778e25b0674d"
                            ],
                            [
                                "eaa5f980c245f6f038978290afa70b6bd8855897f98b6aa485b96065d537bd99",
                                "f65f5d3e292c2e0819a528391c994624d784869d7e6ea67fb18041024edc07dc"
                            ],
                            [
                                "78c9407544ac132692ee1910a02439958ae04877151342ea96c4b6b35a49f51",
                                "f3e0319169eb9b85d5404795539a5e68fa1fbd583c064d2462b675f194a3ddb4"
                            ],
                            [
                                "494f4be219a1a77016dcd838431aea0001cdc8ae7a6fc688726578d9702857a5",
                                "42242a969283a5f339ba7f075e36ba2af925ce30d767ed6e55f4b031880d562c"
                            ],
                            [
                                "a598a8030da6d86c6bc7f2f5144ea549d28211ea58faa70ebf4c1e665c1fe9b5",
                                "204b5d6f84822c307e4b4a7140737aec23fc63b65b35f86a10026dbd2d864e6b"
                            ],
                            [
                                "c41916365abb2b5d09192f5f2dbeafec208f020f12570a184dbadc3e58595997",
                                "4f14351d0087efa49d245b328984989d5caf9450f34bfc0ed16e96b58fa9913"
                            ],
                            [
                                "841d6063a586fa475a724604da03bc5b92a2e0d2e0a36acfe4c73a5514742881",
                                "73867f59c0659e81904f9a1c7543698e62562d6744c169ce7a36de01a8d6154"
                            ],
                            [
                                "5e95bb399a6971d376026947f89bde2f282b33810928be4ded112ac4d70e20d5",
                                "39f23f366809085beebfc71181313775a99c9aed7d8ba38b161384c746012865"
                            ],
                            [
                                "36e4641a53948fd476c39f8a99fd974e5ec07564b5315d8bf99471bca0ef2f66",
                                "d2424b1b1abe4eb8164227b085c9aa9456ea13493fd563e06fd51cf5694c78fc"
                            ],
                            [
                                "336581ea7bfbbb290c191a2f507a41cf5643842170e914faeab27c2c579f726",
                                "ead12168595fe1be99252129b6e56b3391f7ab1410cd1e0ef3dcdcabd2fda224"
                            ],
                            [
                                "8ab89816dadfd6b6a1f2634fcf00ec8403781025ed6890c4849742706bd43ede",
                                "6fdcef09f2f6d0a044e654aef624136f503d459c3e89845858a47a9129cdd24e"
                            ],
                            [
                                "1e33f1a746c9c5778133344d9299fcaa20b0938e8acff2544bb40284b8c5fb94",
                                "60660257dd11b3aa9c8ed618d24edff2306d320f1d03010e33a7d2057f3b3b6"
                            ],
                            [
                                "85b7c1dcb3cec1b7ee7f30ded79dd20a0ed1f4cc18cbcfcfa410361fd8f08f31",
                                "3d98a9cdd026dd43f39048f25a8847f4fcafad1895d7a633c6fed3c35e999511"
                            ],
                            [
                                "29df9fbd8d9e46509275f4b125d6d45d7fbe9a3b878a7af872a2800661ac5f51",
                                "b4c4fe99c775a606e2d8862179139ffda61dc861c019e55cd2876eb2a27d84b"
                            ],
                            [
                                "a0b1cae06b0a847a3fea6e671aaf8adfdfe58ca2f768105c8082b2e449fce252",
                                "ae434102edde0958ec4b19d917a6a28e6b72da1834aff0e650f049503a296cf2"
                            ],
                            [
                                "4e8ceafb9b3e9a136dc7ff67e840295b499dfb3b2133e4ba113f2e4c0e121e5",
                                "cf2174118c8b6d7a4b48f6d534ce5c79422c086a63460502b827ce62a326683c"
                            ],
                            [
                                "d24a44e047e19b6f5afb81c7ca2f69080a5076689a010919f42725c2b789a33b",
                                "6fb8d5591b466f8fc63db50f1c0f1c69013f996887b8244d2cdec417afea8fa3"
                            ],
                            [
                                "ea01606a7a6c9cdd249fdfcfacb99584001edd28abbab77b5104e98e8e3b35d4",
                                "322af4908c7312b0cfbfe369f7a7b3cdb7d4494bc2823700cfd652188a3ea98d"
                            ],
                            [
                                "af8addbf2b661c8a6c6328655eb96651252007d8c5ea31be4ad196de8ce2131f",
                                "6749e67c029b85f52a034eafd096836b2520818680e26ac8f3dfbcdb71749700"
                            ],
                            [
                                "e3ae1974566ca06cc516d47e0fb165a674a3dabcfca15e722f0e3450f45889",
                                "2aeabe7e4531510116217f07bf4d07300de97e4874f81f533420a72eeb0bd6a4"
                            ],
                            [
                                "591ee355313d99721cf6993ffed1e3e301993ff3ed258802075ea8ced397e246",
                                "b0ea558a113c30bea60fc4775460c7901ff0b053d25ca2bdeee98f1a4be5d196"
                            ],
                            [
                                "11396d55fda54c49f19aa97318d8da61fa8584e47b084945077cf03255b52984",
                                "998c74a8cd45ac01289d5833a7beb4744ff536b01b257be4c5767bea93ea57a4"
                            ],
                            [
                                "3c5d2a1ba39c5a1790000738c9e0c40b8dcdfd5468754b6405540157e017aa7a",
                                "b2284279995a34e2f9d4de7396fc18b80f9b8b9fdd270f6661f79ca4c81bd257"
                            ],
                            [
                                "cc8704b8a60a0defa3a99a7299f2e9c3fbc395afb04ac078425ef8a1793cc030",
                                "bdd46039feed17881d1e0862db347f8cf395b74fc4bcdc4e940b74e3ac1f1b13"
                            ],
                            [
                                "c533e4f7ea8555aacd9777ac5cad29b97dd4defccc53ee7ea204119b2889b197",
                                "6f0a256bc5efdf429a2fb6242f1a43a2d9b925bb4a4b3a26bb8e0f45eb596096"
                            ],
                            [
                                "c14f8f2ccb27d6f109f6d08d03cc96a69ba8c34eec07bbcf566d48e33da6593",
                                "c359d6923bb398f7fd4473e16fe1c28475b740dd098075e6c0e8649113dc3a38"
                            ],
                            [
                                "a6cbc3046bc6a450bac24789fa17115a4c9739ed75f8f21ce441f72e0b90e6ef",
                                "21ae7f4680e889bb130619e2c0f95a360ceb573c70603139862afd617fa9b9f"
                            ],
                            [
                                "347d6d9a02c48927ebfb86c1359b1caf130a3c0267d11ce6344b39f99d43cc38",
                                "60ea7f61a353524d1c987f6ecec92f086d565ab687870cb12689ff1e31c74448"
                            ],
                            [
                                "da6545d2181db8d983f7dcb375ef5866d47c67b1bf31c8cf855ef7437b72656a",
                                "49b96715ab6878a79e78f07ce5680c5d6673051b4935bd897fea824b77dc208a"
                            ],
                            [
                                "c40747cc9d012cb1a13b8148309c6de7ec25d6945d657146b9d5994b8feb1111",
                                "5ca560753be2a12fc6de6caf2cb489565db936156b9514e1bb5e83037e0fa2d4"
                            ],
                            [
                                "4e42c8ec82c99798ccf3a610be870e78338c7f713348bd34c8203ef4037f3502",
                                "7571d74ee5e0fb92a7a8b33a07783341a5492144cc54bcc40a94473693606437"
                            ],
                            [
                                "3775ab7089bc6af823aba2e1af70b236d251cadb0c86743287522a1b3b0dedea",
                                "be52d107bcfa09d8bcb9736a828cfa7fac8db17bf7a76a2c42ad961409018cf7"
                            ],
                            [
                                "cee31cbf7e34ec379d94fb814d3d775ad954595d1314ba8846959e3e82f74e26",
                                "8fd64a14c06b589c26b947ae2bcf6bfa0149ef0be14ed4d80f448a01c43b1c6d"
                            ],
                            [
                                "b4f9eaea09b6917619f6ea6a4eb5464efddb58fd45b1ebefcdc1a01d08b47986",
                                "39e5c9925b5a54b07433a4f18c61726f8bb131c012ca542eb24a8ac07200682a"
                            ],
                            [
                                "d4263dfc3d2df923a0179a48966d30ce84e2515afc3dccc1b77907792ebcc60e",
                                "62dfaf07a0f78feb30e30d6295853ce189e127760ad6cf7fae164e122a208d54"
                            ],
                            [
                                "48457524820fa65a4f8d35eb6930857c0032acc0a4a2de422233eeda897612c4",
                                "25a748ab367979d98733c38a1fa1c2e7dc6cc07db2d60a9ae7a76aaa49bd0f77"
                            ],
                            [
                                "dfeeef1881101f2cb11644f3a2afdfc2045e19919152923f367a1767c11cceda",
                                "ecfb7056cf1de042f9420bab396793c0c390bde74b4bbdff16a83ae09a9a7517"
                            ],
                            [
                                "6d7ef6b17543f8373c573f44e1f389835d89bcbc6062ced36c82df83b8fae859",
                                "cd450ec335438986dfefa10c57fea9bcc521a0959b2d80bbf74b190dca712d10"
                            ],
                            [
                                "e75605d59102a5a2684500d3b991f2e3f3c88b93225547035af25af66e04541f",
                                "f5c54754a8f71ee540b9b48728473e314f729ac5308b06938360990e2bfad125"
                            ],
                            [
                                "eb98660f4c4dfaa06a2be453d5020bc99a0c2e60abe388457dd43fefb1ed620c",
                                "6cb9a8876d9cb8520609af3add26cd20a0a7cd8a9411131ce85f44100099223e"
                            ],
                            [
                                "13e87b027d8514d35939f2e6892b19922154596941888336dc3563e3b8dba942",
                                "fef5a3c68059a6dec5d624114bf1e91aac2b9da568d6abeb2570d55646b8adf1"
                            ],
                            [
                                "ee163026e9fd6fe017c38f06a5be6fc125424b371ce2708e7bf4491691e5764a",
                                "1acb250f255dd61c43d94ccc670d0f58f49ae3fa15b96623e5430da0ad6c62b2"
                            ],
                            [
                                "b268f5ef9ad51e4d78de3a750c2dc89b1e626d43505867999932e5db33af3d80",
                                "5f310d4b3c99b9ebb19f77d41c1dee018cf0d34fd4191614003e945a1216e423"
                            ],
                            [
                                "ff07f3118a9df035e9fad85eb6c7bfe42b02f01ca99ceea3bf7ffdba93c4750d",
                                "438136d603e858a3a5c440c38eccbaddc1d2942114e2eddd4740d098ced1f0d8"
                            ],
                            [
                                "8d8b9855c7c052a34146fd20ffb658bea4b9f69e0d825ebec16e8c3ce2b526a1",
                                "cdb559eedc2d79f926baf44fb84ea4d44bcf50fee51d7ceb30e2e7f463036758"
                            ],
                            [
                                "52db0b5384dfbf05bfa9d472d7ae26dfe4b851ceca91b1eba54263180da32b63",
                                "c3b997d050ee5d423ebaf66a6db9f57b3180c902875679de924b69d84a7b375"
                            ],
                            [
                                "e62f9490d3d51da6395efd24e80919cc7d0f29c3f3fa48c6fff543becbd43352",
                                "6d89ad7ba4876b0b22c2ca280c682862f342c8591f1daf5170e07bfd9ccafa7d"
                            ],
                            [
                                "7f30ea2476b399b4957509c88f77d0191afa2ff5cb7b14fd6d8e7d65aaab1193",
                                "ca5ef7d4b231c94c3b15389a5f6311e9daff7bb67b103e9880ef4bff637acaec"
                            ],
                            [
                                "5098ff1e1d9f14fb46a210fada6c903fef0fb7b4a1dd1d9ac60a0361800b7a00",
                                "9731141d81fc8f8084d37c6e7542006b3ee1b40d60dfe5362a5b132fd17ddc0"
                            ],
                            [
                                "32b78c7de9ee512a72895be6b9cbefa6e2f3c4ccce445c96b9f2c81e2778ad58",
                                "ee1849f513df71e32efc3896ee28260c73bb80547ae2275ba497237794c8753c"
                            ],
                            [
                                "e2cb74fddc8e9fbcd076eef2a7c72b0ce37d50f08269dfc074b581550547a4f7",
                                "d3aa2ed71c9dd2247a62df062736eb0baddea9e36122d2be8641abcb005cc4a4"
                            ],
                            [
                                "8438447566d4d7bedadc299496ab357426009a35f235cb141be0d99cd10ae3a8",
                                "c4e1020916980a4da5d01ac5e6ad330734ef0d7906631c4f2390426b2edd791f"
                            ],
                            [
                                "4162d488b89402039b584c6fc6c308870587d9c46f660b878ab65c82c711d67e",
                                "67163e903236289f776f22c25fb8a3afc1732f2b84b4e95dbda47ae5a0852649"
                            ],
                            [
                                "3fad3fa84caf0f34f0f89bfd2dcf54fc175d767aec3e50684f3ba4a4bf5f683d",
                                "cd1bc7cb6cc407bb2f0ca647c718a730cf71872e7d0d2a53fa20efcdfe61826"
                            ],
                            [
                                "674f2600a3007a00568c1a7ce05d0816c1fb84bf1370798f1c69532faeb1a86b",
                                "299d21f9413f33b3edf43b257004580b70db57da0b182259e09eecc69e0d38a5"
                            ],
                            [
                                "d32f4da54ade74abb81b815ad1fb3b263d82d6c692714bcff87d29bd5ee9f08f",
                                "f9429e738b8e53b968e99016c059707782e14f4535359d582fc416910b3eea87"
                            ],
                            [
                                "30e4e670435385556e593657135845d36fbb6931f72b08cb1ed954f1e3ce3ff6",
                                "462f9bce619898638499350113bbc9b10a878d35da70740dc695a559eb88db7b"
                            ],
                            [
                                "be2062003c51cc3004682904330e4dee7f3dcd10b01e580bf1971b04d4cad297",
                                "62188bc49d61e5428573d48a74e1c655b1c61090905682a0d5558ed72dccb9bc"
                            ],
                            [
                                "93144423ace3451ed29e0fb9ac2af211cb6e84a601df5993c419859fff5df04a",
                                "7c10dfb164c3425f5c71a3f9d7992038f1065224f72bb9d1d902a6d13037b47c"
                            ],
                            [
                                "b015f8044f5fcbdcf21ca26d6c34fb8197829205c7b7d2a7cb66418c157b112c",
                                "ab8c1e086d04e813744a655b2df8d5f83b3cdc6faa3088c1d3aea1454e3a1d5f"
                            ],
                            [
                                "d5e9e1da649d97d89e4868117a465a3a4f8a18de57a140d36b3f2af341a21b52",
                                "4cb04437f391ed73111a13cc1d4dd0db1693465c2240480d8955e8592f27447a"
                            ],
                            [
                                "d3ae41047dd7ca065dbf8ed77b992439983005cd72e16d6f996a5316d36966bb",
                                "bd1aeb21ad22ebb22a10f0303417c6d964f8cdd7df0aca614b10dc14d125ac46"
                            ],
                            [
                                "463e2763d885f958fc66cdd22800f0a487197d0a82e377b49f80af87c897b065",
                                "bfefacdb0e5d0fd7df3a311a94de062b26b80c61fbc97508b79992671ef7ca7f"
                            ],
                            [
                                "7985fdfd127c0567c6f53ec1bb63ec3158e597c40bfe747c83cddfc910641917",
                                "603c12daf3d9862ef2b25fe1de289aed24ed291e0ec6708703a5bd567f32ed03"
                            ],
                            [
                                "74a1ad6b5f76e39db2dd249410eac7f99e74c59cb83d2d0ed5ff1543da7703e9",
                                "cc6157ef18c9c63cd6193d83631bbea0093e0968942e8c33d5737fd790e0db08"
                            ],
                            [
                                "30682a50703375f602d416664ba19b7fc9bab42c72747463a71d0896b22f6da3",
                                "553e04f6b018b4fa6c8f39e7f311d3176290d0e0f19ca73f17714d9977a22ff8"
                            ],
                            [
                                "9e2158f0d7c0d5f26c3791efefa79597654e7a2b2464f52b1ee6c1347769ef57",
                                "712fcdd1b9053f09003a3481fa7762e9ffd7c8ef35a38509e2fbf2629008373"
                            ],
                            [
                                "176e26989a43c9cfeba4029c202538c28172e566e3c4fce7322857f3be327d66",
                                "ed8cc9d04b29eb877d270b4878dc43c19aefd31f4eee09ee7b47834c1fa4b1c3"
                            ],
                            [
                                "75d46efea3771e6e68abb89a13ad747ecf1892393dfc4f1b7004788c50374da8",
                                "9852390a99507679fd0b86fd2b39a868d7efc22151346e1a3ca4726586a6bed8"
                            ],
                            [
                                "809a20c67d64900ffb698c4c825f6d5f2310fb0451c869345b7319f645605721",
                                "9e994980d9917e22b76b061927fa04143d096ccc54963e6a5ebfa5f3f8e286c1"
                            ],
                            [
                                "1b38903a43f7f114ed4500b4eac7083fdefece1cf29c63528d563446f972c180",
                                "4036edc931a60ae889353f77fd53de4a2708b26b6f5da72ad3394119daf408f9"
                            ]
                        ]
                    }
                };
            },
            7528: (e, t, r)=>{
                "use strict";
                var n = t, i = r(31734), o = r(94504), a = r(96580);
                n.assert = o, n.toArray = a.toArray, n.zero2 = a.zero2, n.toHex = a.toHex, n.encode = a.encode, n.getNAF = function(e, t, r) {
                    var n = new Array(Math.max(e.bitLength(), r) + 1);
                    n.fill(0);
                    for(var i = 1 << t + 1, o = e.clone(), a = 0; a < n.length; a++){
                        var s, u = o.andln(i - 1);
                        o.isOdd() ? (s = u > (i >> 1) - 1 ? (i >> 1) - u : u, o.isubn(s)) : s = 0, n[a] = s, o.iushrn(1);
                    }
                    return n;
                }, n.getJSF = function(e, t) {
                    var r = [
                        [],
                        []
                    ];
                    e = e.clone(), t = t.clone();
                    for(var n, i = 0, o = 0; e.cmpn(-i) > 0 || t.cmpn(-o) > 0;){
                        var a, s, u = e.andln(3) + i & 3, c = t.andln(3) + o & 3;
                        3 === u && (u = -1), 3 === c && (c = -1), a = 0 == (1 & u) ? 0 : 3 != (n = e.andln(7) + i & 7) && 5 !== n || 2 !== c ? u : -u, r[0].push(a), s = 0 == (1 & c) ? 0 : 3 != (n = t.andln(7) + o & 7) && 5 !== n || 2 !== u ? c : -c, r[1].push(s), 2 * i === a + 1 && (i = 1 - i), 2 * o === s + 1 && (o = 1 - o), e.iushrn(1), t.iushrn(1);
                    }
                    return r;
                }, n.cachedProperty = function(e, t, r) {
                    var n = "_" + t;
                    e.prototype[t] = function() {
                        return void 0 !== this[n] ? this[n] : this[n] = r.call(this);
                    };
                }, n.parseBytes = function(e) {
                    return "string" == typeof e ? n.toArray(e, "hex") : e;
                }, n.intFromLE = function(e) {
                    return new i(e, "hex", "le");
                };
            },
            26464: (e, t, r)=>{
                "use strict";
                var n = r(28847)(r(3355)), i = function() {
                    if ("object" === ("undefined" == typeof self ? "undefined" : (0, n.default)(self)) && self) return self;
                    if ("object" === ("undefined" == typeof window ? "undefined" : (0, n.default)(window)) && window) return window;
                    throw new Error("Unable to resolve global `this`");
                };
                e.exports = function() {
                    if (this) return this;
                    if ("object" === ("undefined" == typeof globalThis ? "undefined" : (0, n.default)(globalThis)) && globalThis) return globalThis;
                    try {
                        Object.defineProperty(Object.prototype, "__global__", {
                            get: function() {
                                return this;
                            },
                            configurable: !0
                        });
                    } catch (e) {
                        return i();
                    }
                    try {
                        return __global__ || i();
                    } finally{
                        delete Object.prototype.__global__;
                    }
                }();
            },
            54258: (e, t, r)=>{
                "use strict";
                var n, i, o, a = r(19142), s = r(28847)(r(3355));
                o = function() {
                    function e(e) {
                        return "function" == typeof e;
                    }
                    var t = Array.isArray ? Array.isArray : function(e) {
                        return "[object Array]" === Object.prototype.toString.call(e);
                    }, n = 0, i = void 0, o = void 0, u = function(e, t) {
                        b[n] = e, b[n + 1] = t, 2 === (n += 2) && (o ? o(y) : k());
                    }, c = "undefined" != typeof window ? window : void 0, f = c || {}, d = f.MutationObserver || f.WebKitMutationObserver, l = "undefined" == typeof self && void 0 !== a && "[object process]" === ({}).toString.call(a), h = "undefined" != typeof Uint8ClampedArray && "undefined" != typeof importScripts && "undefined" != typeof MessageChannel;
                    function p() {
                        var e = setTimeout;
                        return function() {
                            return e(y, 1);
                        };
                    }
                    var b = new Array(1e3);
                    function y() {
                        for(var e = 0; e < n; e += 2)(0, b[e])(b[e + 1]), b[e] = void 0, b[e + 1] = void 0;
                        n = 0;
                    }
                    var v, m, g, w, k = void 0;
                    function _(e, t) {
                        var r = this, n = new this.constructor(S);
                        void 0 === n[E] && L(n);
                        var i = r._state;
                        if (i) {
                            var o = arguments[i - 1];
                            u(function() {
                                return N(i, n, o, r._result);
                            });
                        } else R(r, n, e, t);
                        return n;
                    }
                    function A(e) {
                        if (e && "object" === (0, s.default)(e) && e.constructor === this) return e;
                        var t = new this(S);
                        return I(t, e), t;
                    }
                    l ? k = function() {
                        return a.nextTick(y);
                    } : d ? (m = 0, g = new d(y), w = document.createTextNode(""), g.observe(w, {
                        characterData: !0
                    }), k = function() {
                        w.data = m = ++m % 2;
                    }) : h ? ((v = new MessageChannel).port1.onmessage = y, k = function() {
                        return v.port2.postMessage(0);
                    }) : k = void 0 === c ? function() {
                        try {
                            var e = Function("return this")().require("vertx");
                            return void 0 !== (i = e.runOnLoop || e.runOnContext) ? function() {
                                i(y);
                            } : p();
                        } catch (e) {
                            return p();
                        }
                    }() : p();
                    var E = Math.random().toString(36).substring(2);
                    function S() {}
                    var x = void 0, B = 1, O = 2;
                    function P(t, r, n) {
                        r.constructor === t.constructor && n === _ && r.constructor.resolve === A ? function(e, t) {
                            t._state === B ? C(e, t._result) : t._state === O ? M(e, t._result) : R(t, void 0, function(t) {
                                return I(e, t);
                            }, function(t) {
                                return M(e, t);
                            });
                        }(t, r) : void 0 === n ? C(t, r) : e(n) ? function(e, t, r) {
                            u(function(e) {
                                var n = !1, i = function(r, i, o, a) {
                                    try {
                                        r.call(i, function(r) {
                                            n || (n = !0, t !== r ? I(e, r) : C(e, r));
                                        }, function(t) {
                                            n || (n = !0, M(e, t));
                                        });
                                    } catch (e) {
                                        return e;
                                    }
                                }(r, t, 0, 0, e._label);
                                !n && i && (n = !0, M(e, i));
                            }, e);
                        }(t, r, n) : C(t, r);
                    }
                    function I(e, t) {
                        if (e === t) M(e, new TypeError("You cannot resolve a promise with itself"));
                        else if (n = t, i = (0, s.default)(n), null === n || "object" !== i && "function" !== i) C(e, t);
                        else {
                            var r = void 0;
                            try {
                                r = t.then;
                            } catch (t) {
                                return void M(e, t);
                            }
                            P(e, t, r);
                        }
                        var n, i;
                    }
                    function T(e) {
                        e._onerror && e._onerror(e._result), U(e);
                    }
                    function C(e, t) {
                        e._state === x && (e._result = t, e._state = B, 0 !== e._subscribers.length && u(U, e));
                    }
                    function M(e, t) {
                        e._state === x && (e._state = O, e._result = t, u(T, e));
                    }
                    function R(e, t, r, n) {
                        var i = e._subscribers, o = i.length;
                        e._onerror = null, i[o] = t, i[o + B] = r, i[o + O] = n, 0 === o && e._state && u(U, e);
                    }
                    function U(e) {
                        var t = e._subscribers, r = e._state;
                        if (0 !== t.length) {
                            for(var n = void 0, i = void 0, o = e._result, a = 0; a < t.length; a += 3)n = t[a], i = t[a + r], n ? N(r, n, i, o) : i(o);
                            e._subscribers.length = 0;
                        }
                    }
                    function N(t, r, n, i) {
                        var o = e(n), a = void 0, s = void 0, u = !0;
                        if (o) {
                            try {
                                a = n(i);
                            } catch (e) {
                                u = !1, s = e;
                            }
                            if (r === a) return void M(r, new TypeError("A promises callback cannot return that same promise."));
                        } else a = i;
                        r._state !== x || (o && u ? I(r, a) : !1 === u ? M(r, s) : t === B ? C(r, a) : t === O && M(r, a));
                    }
                    var j = 0;
                    function L(e) {
                        e[E] = j++, e._state = void 0, e._result = void 0, e._subscribers = [];
                    }
                    var F = function() {
                        function e(e, r) {
                            this._instanceConstructor = e, this.promise = new e(S), this.promise[E] || L(this.promise), t(r) ? (this.length = r.length, this._remaining = r.length, this._result = new Array(this.length), 0 === this.length ? C(this.promise, this._result) : (this.length = this.length || 0, this._enumerate(r), 0 === this._remaining && C(this.promise, this._result))) : M(this.promise, new Error("Array Methods must be provided an Array"));
                        }
                        return e.prototype._enumerate = function(e) {
                            for(var t = 0; this._state === x && t < e.length; t++)this._eachEntry(e[t], t);
                        }, e.prototype._eachEntry = function(e, t) {
                            var r = this._instanceConstructor, n = r.resolve;
                            if (n === A) {
                                var i = void 0, o = void 0, a = !1;
                                try {
                                    i = e.then;
                                } catch (e) {
                                    a = !0, o = e;
                                }
                                if (i === _ && e._state !== x) this._settledAt(e._state, t, e._result);
                                else if ("function" != typeof i) this._remaining--, this._result[t] = e;
                                else if (r === D) {
                                    var s = new r(S);
                                    a ? M(s, o) : P(s, e, i), this._willSettleAt(s, t);
                                } else this._willSettleAt(new r(function(t) {
                                    return t(e);
                                }), t);
                            } else this._willSettleAt(n(e), t);
                        }, e.prototype._settledAt = function(e, t, r) {
                            var n = this.promise;
                            n._state === x && (this._remaining--, e === O ? M(n, r) : this._result[t] = r), 0 === this._remaining && C(n, this._result);
                        }, e.prototype._willSettleAt = function(e, t) {
                            var r = this;
                            R(e, void 0, function(e) {
                                return r._settledAt(B, t, e);
                            }, function(e) {
                                return r._settledAt(O, t, e);
                            });
                        }, e;
                    }(), D = function() {
                        function t(e) {
                            this[E] = j++, this._result = this._state = void 0, this._subscribers = [], S !== e && ("function" != typeof e && function() {
                                throw new TypeError("You must pass a resolver function as the first argument to the promise constructor");
                            }(), this instanceof t ? function(e, t) {
                                try {
                                    t(function(t) {
                                        I(e, t);
                                    }, function(t) {
                                        M(e, t);
                                    });
                                } catch (t) {
                                    M(e, t);
                                }
                            }(this, e) : function() {
                                throw new TypeError("Failed to construct 'Promise': Please use the 'new' operator, this object constructor cannot be called as a function.");
                            }());
                        }
                        return t.prototype.catch = function(e) {
                            return this.then(null, e);
                        }, t.prototype.finally = function(t) {
                            var r = this, n = r.constructor;
                            return e(t) ? r.then(function(e) {
                                return n.resolve(t()).then(function() {
                                    return e;
                                });
                            }, function(e) {
                                return n.resolve(t()).then(function() {
                                    throw e;
                                });
                            }) : r.then(t, t);
                        }, t;
                    }();
                    return D.prototype.then = _, D.all = function(e) {
                        return new F(this, e).promise;
                    }, D.race = function(e) {
                        var r = this;
                        return t(e) ? new r(function(t, n) {
                            for(var i = e.length, o = 0; o < i; o++)r.resolve(e[o]).then(t, n);
                        }) : new r(function(e, t) {
                            return t(new TypeError("You must pass an array to race."));
                        });
                    }, D.resolve = A, D.reject = function(e) {
                        var t = new this(S);
                        return M(t, e), t;
                    }, D._setScheduler = function(e) {
                        o = e;
                    }, D._setAsap = function(e) {
                        u = e;
                    }, D._asap = u, D.polyfill = function() {
                        var e = void 0;
                        if (void 0 !== r.g) e = r.g;
                        else if ("undefined" != typeof self) e = self;
                        else try {
                            e = Function("return this")();
                        } catch (e) {
                            throw new Error("polyfill failed because global object is unavailable in this environment");
                        }
                        var t = e.Promise;
                        if (t) {
                            var n = null;
                            try {
                                n = Object.prototype.toString.call(t.resolve());
                            } catch (e) {}
                            if ("[object Promise]" === n && !t.cast) return;
                        }
                        e.Promise = D;
                    }, D.Promise = D, D;
                }, "object" === (0, s.default)(t) ? e.exports = o() : void 0 === (i = "function" == typeof (n = o) ? n.call(t, r, t, e) : n) || (e.exports = i);
            },
            21006: (e, t, r)=>{
                "use strict";
                var n = r(29033).Buffer, i = r(24858).keccak_256, o = r(3956);
                function a(e) {
                    return e ? o.toUnicode(e, {
                        useStd3ASCII: !0,
                        transitional: !1
                    }) : e;
                }
                t.hash = function(e) {
                    for(var t = "", r = 0; r < 32; r++)t += "00";
                    if (name = a(e), name) {
                        var o = name.split(".");
                        for(r = o.length - 1; r >= 0; r--){
                            var s = i(o[r]);
                            t = i(new n(t + s, "hex"));
                        }
                    }
                    return "0x" + t;
                }, t.normalize = a;
            },
            53058: (e, t, r)=>{
                "use strict";
                var n = r(29033).Buffer, i = r(28847)(r(74519)), o = r(58320), a = r(88645), s = r(36597), u = (r(46740), new s.ec("secp256k1")), c = r(22922), f = c.keccak256, d = c.keccak256s, l = function(e) {
                    for(var t = d(e.slice(2)), r = "0x", n = 0; n < 40; n++)r += parseInt(t[n + 2], 16) > 7 ? e[n + 2].toUpperCase() : e[n + 2];
                    return r;
                }, h = function(e) {
                    var t = new n(e.slice(2), "hex"), r = "0x" + u.keyFromPrivate(t).getPublic(!1, "hex").slice(2), i = f(r);
                    return {
                        address: l("0x" + i.slice(-40)),
                        privateKey: e
                    };
                }, p = function(e) {
                    var t = (0, i.default)(e, 3), r = t[0], n = t[1], a = t[2];
                    return o.flatten([
                        n,
                        a,
                        r
                    ]);
                }, b = function(e) {
                    return [
                        o.slice(64, o.length(e), e),
                        o.slice(0, 32, e),
                        o.slice(32, 64, e)
                    ];
                }, y = function(e) {
                    return function(t, r) {
                        var i = u.keyFromPrivate(new n(r.slice(2), "hex")).sign(new n(t.slice(2), "hex"), {
                            canonical: !0
                        });
                        return p([
                            a.fromString(o.fromNumber(e + i.recoveryParam)),
                            o.pad(32, o.fromNat("0x" + i.r.toString(16))),
                            o.pad(32, o.fromNat("0x" + i.s.toString(16)))
                        ]);
                    };
                }, v = y(27);
                e.exports = {
                    create: function(e) {
                        var t = f(o.concat(o.random(32), e || o.random(32))), r = o.concat(o.concat(o.random(32), t), o.random(32)), n = f(r);
                        return h(n);
                    },
                    toChecksum: l,
                    fromPrivate: h,
                    sign: v,
                    makeSigner: y,
                    recover: function(e, t) {
                        var r = b(t), i = {
                            v: o.toNumber(r[0]),
                            r: r[1].slice(2),
                            s: r[2].slice(2)
                        }, a = "0x" + u.recoverPubKey(new n(e.slice(2), "hex"), i, i.v < 2 ? i.v : 1 - i.v % 2).encode("hex", !1).slice(2), s = f(a);
                        return l("0x" + s.slice(-40));
                    },
                    encodeSignature: p,
                    decodeSignature: b
                };
            },
            51376: (e)=>{
                "use strict";
                var t = function(e, t) {
                    for(var r = [], n = 0; n < e; ++n)r.push(t(n));
                    return r;
                };
                e.exports = {
                    generate: t,
                    replicate: function(e, r) {
                        return t(e, function() {
                            return r;
                        });
                    },
                    concat: function(e, t) {
                        return e.concat(t);
                    },
                    flatten: function(e) {
                        for(var t = [], r = 0, n = e.length; r < n; ++r)for(var i = 0, o = e[r].length; i < o; ++i)t.push(e[r][i]);
                        return t;
                    },
                    chunksOf: function(e, t) {
                        for(var r = [], n = 0, i = t.length; n < i; n += e)r.push(t.slice(n, n + e));
                        return r;
                    }
                };
            },
            58320: (e, t, r)=>{
                "use strict";
                r(51376);
                var n = function(e, t) {
                    return parseInt(e.slice(2 * t + 2, 2 * t + 4), 16);
                }, i = function(e) {
                    return (e.length - 2) / 2;
                }, o = function(e) {
                    for(var t = [], r = 2, n = e.length; r < n; r += 2)t.push(parseInt(e.slice(r, r + 2), 16));
                    return t;
                }, a = function(e) {
                    for(var t = "0x", r = 0, n = e.length; r < n; ++r){
                        var i = e[r];
                        t += (i < 16 ? "0" : "") + i.toString(16);
                    }
                    return t;
                };
                e.exports = {
                    random: function(e) {
                        var t;
                        t = "undefined" != typeof window && window.crypto && window.crypto.getRandomValues ? window.crypto.getRandomValues(new Uint8Array(e)) : r(24293).randomBytes(e);
                        for(var n = "0x", i = 0; i < e; ++i)n += ("00" + t[i].toString(16)).slice(-2);
                        return n;
                    },
                    length: i,
                    concat: function(e, t) {
                        return e.concat(t.slice(2));
                    },
                    flatten: function(e) {
                        return "0x" + e.reduce(function(e, t) {
                            return e + t.slice(2);
                        }, "");
                    },
                    slice: function(e, t, r) {
                        return "0x" + r.slice(2 * e + 2, 2 * t + 2);
                    },
                    reverse: function(e) {
                        for(var t = "0x", r = 0, n = i(e); r < n; ++r)t += e.slice(2 * (n - r), 2 * (n - r + 1));
                        return t;
                    },
                    pad: function e(t, r) {
                        return r.length === 2 * t + 2 ? r : e(t, "0x0" + r.slice(2));
                    },
                    padRight: function e(t, r) {
                        return r.length === 2 * t + 2 ? r : e(t, r + "0");
                    },
                    fromAscii: function(e) {
                        for(var t = "0x", r = 0; r < e.length; ++r)t += ("00" + e.charCodeAt(r).toString(16)).slice(-2);
                        return t;
                    },
                    toAscii: function(e) {
                        for(var t = "", r = 2; r < e.length; r += 2)t += String.fromCharCode(parseInt(e.slice(r, r + 2), 16));
                        return t;
                    },
                    fromString: function(e) {
                        for(var t = function(e) {
                            var t = e.toString(16);
                            return t.length < 2 ? "0" + t : t;
                        }, r = "0x", n = 0; n != e.length; n++){
                            var i = e.charCodeAt(n);
                            if (i < 128) r += t(i);
                            else {
                                if (i < 2048) r += t(i >> 6 | 192);
                                else {
                                    if (i > 55295 && i < 56320) {
                                        if (++n == e.length) return null;
                                        var o = e.charCodeAt(n);
                                        if (o < 56320 || o > 57343) return null;
                                        r += t((i = 65536 + ((1023 & i) << 10) + (1023 & o)) >> 18 | 240), r += t(i >> 12 & 63 | 128);
                                    } else r += t(i >> 12 | 224);
                                    r += t(i >> 6 & 63 | 128);
                                }
                                r += t(63 & i | 128);
                            }
                        }
                        return r;
                    },
                    toString: function(e) {
                        for(var t = "", r = 0, o = i(e); r < o;){
                            var a = n(e, r++);
                            if (a > 127) {
                                if (a > 191 && a < 224) {
                                    if (r >= o) return null;
                                    a = (31 & a) << 6 | 63 & n(e, r);
                                } else if (a > 223 && a < 240) {
                                    if (r + 1 >= o) return null;
                                    a = (15 & a) << 12 | (63 & n(e, r)) << 6 | 63 & n(e, ++r);
                                } else {
                                    if (!(a > 239 && a < 248)) return null;
                                    if (r + 2 >= o) return null;
                                    a = (7 & a) << 18 | (63 & n(e, r)) << 12 | (63 & n(e, ++r)) << 6 | 63 & n(e, ++r);
                                }
                                ++r;
                            }
                            if (a <= 65535) t += String.fromCharCode(a);
                            else {
                                if (!(a <= 1114111)) return null;
                                a -= 65536, t += String.fromCharCode(a >> 10 | 55296), t += String.fromCharCode(1023 & a | 56320);
                            }
                        }
                        return t;
                    },
                    fromNumber: function(e) {
                        var t = e.toString(16);
                        return t.length % 2 == 0 ? "0x" + t : "0x0" + t;
                    },
                    toNumber: function(e) {
                        return parseInt(e.slice(2), 16);
                    },
                    fromNat: function(e) {
                        return "0x0" === e ? "0x" : e.length % 2 == 0 ? e : "0x0" + e.slice(2);
                    },
                    toNat: function(e) {
                        return "0" === e[2] ? "0x" + e.slice(3) : e;
                    },
                    fromArray: a,
                    toArray: o,
                    fromUint8Array: function(e) {
                        return a([].slice.call(e, 0));
                    },
                    toUint8Array: function(e) {
                        return new Uint8Array(o(e));
                    }
                };
            },
            22922: (e)=>{
                "use strict";
                var t = "0123456789abcdef".split(""), r = [
                    1,
                    256,
                    65536,
                    16777216
                ], n = [
                    0,
                    8,
                    16,
                    24
                ], i = [
                    1,
                    0,
                    32898,
                    0,
                    32906,
                    2147483648,
                    2147516416,
                    2147483648,
                    32907,
                    0,
                    2147483649,
                    0,
                    2147516545,
                    2147483648,
                    32777,
                    2147483648,
                    138,
                    0,
                    136,
                    0,
                    2147516425,
                    0,
                    2147483658,
                    0,
                    2147516555,
                    0,
                    139,
                    2147483648,
                    32905,
                    2147483648,
                    32771,
                    2147483648,
                    32770,
                    2147483648,
                    128,
                    2147483648,
                    32778,
                    0,
                    2147483658,
                    2147483648,
                    2147516545,
                    2147483648,
                    32896,
                    2147483648,
                    2147483649,
                    0,
                    2147516424,
                    2147483648
                ], o = function(e) {
                    var t, r, n, o, a, s, u, c, f, d, l, h, p, b, y, v, m, g, w, k, _, A, E, S, x, B, O, P, I, T, C, M, R, U, N, j, L, F, D, H, z, q, K, G, V, Z, W, J, Y, X, Q, $, ee, te, re, ne, ie, oe, ae, se, ue, ce, fe;
                    for(n = 0; n < 48; n += 2)o = e[0] ^ e[10] ^ e[20] ^ e[30] ^ e[40], a = e[1] ^ e[11] ^ e[21] ^ e[31] ^ e[41], s = e[2] ^ e[12] ^ e[22] ^ e[32] ^ e[42], u = e[3] ^ e[13] ^ e[23] ^ e[33] ^ e[43], c = e[4] ^ e[14] ^ e[24] ^ e[34] ^ e[44], f = e[5] ^ e[15] ^ e[25] ^ e[35] ^ e[45], d = e[6] ^ e[16] ^ e[26] ^ e[36] ^ e[46], l = e[7] ^ e[17] ^ e[27] ^ e[37] ^ e[47], t = (h = e[8] ^ e[18] ^ e[28] ^ e[38] ^ e[48]) ^ (s << 1 | u >>> 31), r = (p = e[9] ^ e[19] ^ e[29] ^ e[39] ^ e[49]) ^ (u << 1 | s >>> 31), e[0] ^= t, e[1] ^= r, e[10] ^= t, e[11] ^= r, e[20] ^= t, e[21] ^= r, e[30] ^= t, e[31] ^= r, e[40] ^= t, e[41] ^= r, t = o ^ (c << 1 | f >>> 31), r = a ^ (f << 1 | c >>> 31), e[2] ^= t, e[3] ^= r, e[12] ^= t, e[13] ^= r, e[22] ^= t, e[23] ^= r, e[32] ^= t, e[33] ^= r, e[42] ^= t, e[43] ^= r, t = s ^ (d << 1 | l >>> 31), r = u ^ (l << 1 | d >>> 31), e[4] ^= t, e[5] ^= r, e[14] ^= t, e[15] ^= r, e[24] ^= t, e[25] ^= r, e[34] ^= t, e[35] ^= r, e[44] ^= t, e[45] ^= r, t = c ^ (h << 1 | p >>> 31), r = f ^ (p << 1 | h >>> 31), e[6] ^= t, e[7] ^= r, e[16] ^= t, e[17] ^= r, e[26] ^= t, e[27] ^= r, e[36] ^= t, e[37] ^= r, e[46] ^= t, e[47] ^= r, t = d ^ (o << 1 | a >>> 31), r = l ^ (a << 1 | o >>> 31), e[8] ^= t, e[9] ^= r, e[18] ^= t, e[19] ^= r, e[28] ^= t, e[29] ^= r, e[38] ^= t, e[39] ^= r, e[48] ^= t, e[49] ^= r, b = e[0], y = e[1], Z = e[11] << 4 | e[10] >>> 28, W = e[10] << 4 | e[11] >>> 28, P = e[20] << 3 | e[21] >>> 29, I = e[21] << 3 | e[20] >>> 29, se = e[31] << 9 | e[30] >>> 23, ue = e[30] << 9 | e[31] >>> 23, q = e[40] << 18 | e[41] >>> 14, K = e[41] << 18 | e[40] >>> 14, U = e[2] << 1 | e[3] >>> 31, N = e[3] << 1 | e[2] >>> 31, v = e[13] << 12 | e[12] >>> 20, m = e[12] << 12 | e[13] >>> 20, J = e[22] << 10 | e[23] >>> 22, Y = e[23] << 10 | e[22] >>> 22, T = e[33] << 13 | e[32] >>> 19, C = e[32] << 13 | e[33] >>> 19, ce = e[42] << 2 | e[43] >>> 30, fe = e[43] << 2 | e[42] >>> 30, te = e[5] << 30 | e[4] >>> 2, re = e[4] << 30 | e[5] >>> 2, j = e[14] << 6 | e[15] >>> 26, L = e[15] << 6 | e[14] >>> 26, g = e[25] << 11 | e[24] >>> 21, w = e[24] << 11 | e[25] >>> 21, X = e[34] << 15 | e[35] >>> 17, Q = e[35] << 15 | e[34] >>> 17, M = e[45] << 29 | e[44] >>> 3, R = e[44] << 29 | e[45] >>> 3, S = e[6] << 28 | e[7] >>> 4, x = e[7] << 28 | e[6] >>> 4, ne = e[17] << 23 | e[16] >>> 9, ie = e[16] << 23 | e[17] >>> 9, F = e[26] << 25 | e[27] >>> 7, D = e[27] << 25 | e[26] >>> 7, k = e[36] << 21 | e[37] >>> 11, _ = e[37] << 21 | e[36] >>> 11, $ = e[47] << 24 | e[46] >>> 8, ee = e[46] << 24 | e[47] >>> 8, G = e[8] << 27 | e[9] >>> 5, V = e[9] << 27 | e[8] >>> 5, B = e[18] << 20 | e[19] >>> 12, O = e[19] << 20 | e[18] >>> 12, oe = e[29] << 7 | e[28] >>> 25, ae = e[28] << 7 | e[29] >>> 25, H = e[38] << 8 | e[39] >>> 24, z = e[39] << 8 | e[38] >>> 24, A = e[48] << 14 | e[49] >>> 18, E = e[49] << 14 | e[48] >>> 18, e[0] = b ^ ~v & g, e[1] = y ^ ~m & w, e[10] = S ^ ~B & P, e[11] = x ^ ~O & I, e[20] = U ^ ~j & F, e[21] = N ^ ~L & D, e[30] = G ^ ~Z & J, e[31] = V ^ ~W & Y, e[40] = te ^ ~ne & oe, e[41] = re ^ ~ie & ae, e[2] = v ^ ~g & k, e[3] = m ^ ~w & _, e[12] = B ^ ~P & T, e[13] = O ^ ~I & C, e[22] = j ^ ~F & H, e[23] = L ^ ~D & z, e[32] = Z ^ ~J & X, e[33] = W ^ ~Y & Q, e[42] = ne ^ ~oe & se, e[43] = ie ^ ~ae & ue, e[4] = g ^ ~k & A, e[5] = w ^ ~_ & E, e[14] = P ^ ~T & M, e[15] = I ^ ~C & R, e[24] = F ^ ~H & q, e[25] = D ^ ~z & K, e[34] = J ^ ~X & $, e[35] = Y ^ ~Q & ee, e[44] = oe ^ ~se & ce, e[45] = ae ^ ~ue & fe, e[6] = k ^ ~A & b, e[7] = _ ^ ~E & y, e[16] = T ^ ~M & S, e[17] = C ^ ~R & x, e[26] = H ^ ~q & U, e[27] = z ^ ~K & N, e[36] = X ^ ~$ & G, e[37] = Q ^ ~ee & V, e[46] = se ^ ~ce & te, e[47] = ue ^ ~fe & re, e[8] = A ^ ~b & v, e[9] = E ^ ~y & m, e[18] = M ^ ~S & B, e[19] = R ^ ~x & O, e[28] = q ^ ~U & j, e[29] = K ^ ~N & L, e[38] = $ ^ ~G & Z, e[39] = ee ^ ~V & W, e[48] = ce ^ ~te & ne, e[49] = fe ^ ~re & ie, e[0] ^= i[n], e[1] ^= i[n + 1];
                }, a = function(e) {
                    return function(i) {
                        var a;
                        if ("0x" === i.slice(0, 2)) {
                            a = [];
                            for(var s = 2, u = i.length; s < u; s += 2)a.push(parseInt(i.slice(s, s + 2), 16));
                        } else a = i;
                        return function(e, i) {
                            for(var a, s = i.length, u = e.blocks, c = e.blockCount << 2, f = e.blockCount, d = e.outputBlocks, l = e.s, h = 0; h < s;){
                                if (e.reset) for(e.reset = !1, u[0] = e.block, y = 1; y < f + 1; ++y)u[y] = 0;
                                if ("string" != typeof i) for(y = e.start; h < s && y < c; ++h)u[y >> 2] |= i[h] << n[3 & y++];
                                else for(y = e.start; h < s && y < c; ++h)(a = i.charCodeAt(h)) < 128 ? u[y >> 2] |= a << n[3 & y++] : a < 2048 ? (u[y >> 2] |= (192 | a >> 6) << n[3 & y++], u[y >> 2] |= (128 | 63 & a) << n[3 & y++]) : a < 55296 || a >= 57344 ? (u[y >> 2] |= (224 | a >> 12) << n[3 & y++], u[y >> 2] |= (128 | a >> 6 & 63) << n[3 & y++], u[y >> 2] |= (128 | 63 & a) << n[3 & y++]) : (a = 65536 + ((1023 & a) << 10 | 1023 & i.charCodeAt(++h)), u[y >> 2] |= (240 | a >> 18) << n[3 & y++], u[y >> 2] |= (128 | a >> 12 & 63) << n[3 & y++], u[y >> 2] |= (128 | a >> 6 & 63) << n[3 & y++], u[y >> 2] |= (128 | 63 & a) << n[3 & y++]);
                                if (e.lastByteIndex = y, y >= c) {
                                    for(e.start = y - c, e.block = u[f], y = 0; y < f; ++y)l[y] ^= u[y];
                                    o(l), e.reset = !0;
                                } else e.start = y;
                            }
                            if (u[(y = e.lastByteIndex) >> 2] |= r[3 & y], e.lastByteIndex === c) for(u[0] = u[f], y = 1; y < f + 1; ++y)u[y] = 0;
                            for(u[f - 1] |= 2147483648, y = 0; y < f; ++y)l[y] ^= u[y];
                            o(l);
                            for(var p, b = "", y = 0, v = 0; v < d;){
                                for(y = 0; y < f && v < d; ++y, ++v)p = l[y], b += t[p >> 4 & 15] + t[15 & p] + t[p >> 12 & 15] + t[p >> 8 & 15] + t[p >> 20 & 15] + t[p >> 16 & 15] + t[p >> 28 & 15] + t[p >> 24 & 15];
                                v % f == 0 && (o(l), y = 0);
                            }
                            return "0x" + b;
                        }(function(e) {
                            var t;
                            return {
                                blocks: [],
                                reset: !0,
                                block: 0,
                                start: 0,
                                blockCount: 1600 - (e << 1) >> 5,
                                outputBlocks: e >> 5,
                                s: (t = [
                                    0,
                                    0,
                                    0,
                                    0,
                                    0,
                                    0,
                                    0,
                                    0,
                                    0,
                                    0
                                ], [].concat(t, t, t, t, t))
                            };
                        }(e), a);
                    };
                };
                e.exports = {
                    keccak256: a(256),
                    keccak512: a(512),
                    keccak256s: a(256),
                    keccak512s: a(512)
                };
            },
            88645: (e, t, r)=>{
                "use strict";
                var n = r(31734), i = r(58320), o = function(e) {
                    return new n(e.slice(2), 16);
                }, a = function(e) {
                    var t = "0x" + ("0x" === e.slice(0, 2) ? new n(e.slice(2), 16) : new n(e, 10)).toString("hex");
                    return "0x0" === t ? "0x" : t;
                }, s = function(e) {
                    return "string" == typeof e ? /^0x/.test(e) ? e : "0x" + e : "0x" + new n(e).toString("hex");
                }, u = function(e) {
                    return o(e).toNumber();
                }, c = function(e) {
                    return function(t, r) {
                        return "0x" + o(t)[e](o(r)).toString("hex");
                    };
                }, f = c("add"), d = c("mul"), l = c("div"), h = c("sub");
                e.exports = {
                    toString: function(e) {
                        return o(e).toString(10);
                    },
                    fromString: a,
                    toNumber: u,
                    fromNumber: s,
                    toEther: function(e) {
                        return u(l(e, a("10000000000"))) / 1e8;
                    },
                    fromEther: function(e) {
                        return d(s(Math.floor(1e8 * e)), a("10000000000"));
                    },
                    toUint256: function(e) {
                        return i.pad(32, e);
                    },
                    add: f,
                    mul: d,
                    div: l,
                    sub: h
                };
            },
            46740: (e)=>{
                "use strict";
                e.exports = {
                    encode: function(e) {
                        var t = function(e) {
                            var t;
                            return (t = e.toString(16)).length % 2 == 0 ? t : "0" + t;
                        }, r = function(e, r) {
                            return e < 56 ? t(r + e) : t(r + t(e).length / 2 + 55) + t(e);
                        };
                        return "0x" + function e(t) {
                            if ("string" == typeof t) {
                                var n = t.slice(2);
                                return (2 != n.length || n >= "80" ? r(n.length / 2, 128) : "") + n;
                            }
                            var i = t.map(e).join("");
                            return r(i.length / 2, 192) + i;
                        }(e);
                    },
                    decode: function(e) {
                        var t = 2, r = function() {
                            if (t >= e.length) throw "";
                            var r = e.slice(t, t + 2);
                            return r < "80" ? (t += 2, "0x" + r) : r < "c0" ? i() : o();
                        }, n = function() {
                            var r = parseInt(e.slice(t, t += 2), 16) % 64;
                            return r < 56 ? r : parseInt(e.slice(t, t += 2 * (r - 55)), 16);
                        }, i = function() {
                            var r = n();
                            return "0x" + e.slice(t, t += 2 * r);
                        }, o = function() {
                            for(var e = 2 * n() + t, i = []; t < e;)i.push(r());
                            return i;
                        };
                        try {
                            return r();
                        } catch (e) {
                            return [];
                        }
                    }
                };
            },
            19313: (e, t, r)=>{
                "use strict";
                var n = r(28847)(r(3355));
                Object.defineProperty(t, "__esModule", {
                    value: !0
                });
                var i = r(78179);
                function o(e) {
                    return !("string" != typeof e || !/^(0x)?[0-9a-f]{512}$/i.test(e) || !/^(0x)?[0-9a-f]{512}$/.test(e) && !/^(0x)?[0-9A-F]{512}$/.test(e));
                }
                function a(e, t) {
                    "object" === (0, n.default)(t) && t.constructor === Uint8Array && (t = i.bytesToHex(t));
                    for(var r = i.keccak256(t).replace("0x", ""), o = 0; o < 12; o += 4){
                        var a = (parseInt(r.substr(o, 2), 16) << 8) + parseInt(r.substr(o + 2, 2), 16) & 2047, u = 1 << a % 4;
                        if ((s(e.charCodeAt(e.length - 1 - Math.floor(a / 4))) & u) !== u) return !1;
                    }
                    return !0;
                }
                function s(e) {
                    if (e >= 48 && e <= 57) return e - 48;
                    if (e >= 65 && e <= 70) return e - 55;
                    if (e >= 97 && e <= 102) return e - 87;
                    throw new Error("invalid bloom");
                }
                function u(e) {
                    return !("string" != typeof e || !/^(0x)?[0-9a-f]{64}$/i.test(e) || !/^(0x)?[0-9a-f]{64}$/.test(e) && !/^(0x)?[0-9A-F]{64}$/.test(e));
                }
                function c(e) {
                    return !("string" != typeof e || !e.match(/^(0x)?[0-9a-fA-F]{40}$/) && !e.match(/^XE[0-9]{2}[0-9A-Za-z]{30,31}$/));
                }
                t.isBloom = o, t.isInBloom = a, t.isUserEthereumAddressInBloom = function(e, t) {
                    if (!o(e)) throw new Error("Invalid bloom given");
                    if (!c(t)) throw new Error('Invalid ethereum address given: "'.concat(t, '"'));
                    return a(e, i.padLeft(t, 64));
                }, t.isContractAddressInBloom = function(e, t) {
                    if (!o(e)) throw new Error("Invalid bloom given");
                    if (!c(t)) throw new Error('Invalid contract address given: "'.concat(t, '"'));
                    return a(e, t);
                }, t.isTopicInBloom = function(e, t) {
                    if (!o(e)) throw new Error("Invalid bloom given");
                    if (!u(t)) throw new Error("Invalid topic");
                    return a(e, t);
                }, t.isTopic = u, t.isAddress = c;
            },
            78179: (e, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                });
                var n = r(34477);
                function i(e) {
                    if (null == e) throw new Error("cannot convert null value to array");
                    if ("string" == typeof e) {
                        var t = e.match(/^(0x)?[0-9a-fA-F]*$/);
                        if (!t) throw new Error("invalid hexidecimal string");
                        if ("0x" !== t[1]) throw new Error("hex string must have 0x prefix");
                        (e = e.substring(2)).length % 2 && (e = "0" + e);
                        for(var r = [], n = 0; n < e.length; n += 2)r.push(parseInt(e.substr(n, 2), 16));
                        return o(new Uint8Array(r));
                    }
                    if (function(e) {
                        if (!e || parseInt(String(e.length)) != e.length || "string" == typeof e) return !1;
                        for(var t = 0; t < e.length; t++){
                            var r = e[t];
                            if (r < 0 || r >= 256 || parseInt(String(r)) != r) return !1;
                        }
                        return !0;
                    }(e)) return o(new Uint8Array(e));
                    throw new Error("invalid arrayify value");
                }
                function o(e) {
                    var t = arguments;
                    return void 0 !== e.slice || (e.slice = function() {
                        var r = Array.prototype.slice.call(t);
                        return o(new Uint8Array(Array.prototype.slice.apply(e, r)));
                    }), e;
                }
                t.keccak256 = function(e) {
                    return "0x" + n.keccak_256(i(e));
                }, t.padLeft = function(e, t) {
                    var r = /^0x/i.test(e) || "number" == typeof e, n = t - (e = e.toString().replace(/^0x/i, "")).length + 1 >= 0 ? t - e.length + 1 : 0;
                    return (r ? "0x" : "") + new Array(n).join("0") + e;
                }, t.bytesToHex = function(e) {
                    for(var t = [], r = 0; r < e.length; r++)t.push((e[r] >>> 4).toString(16)), t.push((15 & e[r]).toString(16));
                    return "0x".concat(t.join("").replace(/^0+/, ""));
                }, t.toByteArray = i;
            },
            34477: (e, t, r)=>{
                "use strict";
                e = r.nmd(e);
                var n, i = r(19142), o = r(28847)(r(3355));
                !function() {
                    var a = "input is invalid type", s = "object" === ("undefined" == typeof window ? "undefined" : (0, o.default)(window)), u = s ? window : {};
                    u.JS_SHA3_NO_WINDOW && (s = !1);
                    var c = !s && "object" === ("undefined" == typeof self ? "undefined" : (0, o.default)(self));
                    !u.JS_SHA3_NO_NODE_JS && "object" === (void 0 === i ? "undefined" : (0, o.default)(i)) && i.versions && i.versions.node ? u = r.g : c && (u = self);
                    var f = !u.JS_SHA3_NO_COMMON_JS && "object" === (0, o.default)(e) && e.exports, d = r.amdO, l = !u.JS_SHA3_NO_ARRAY_BUFFER && "undefined" != typeof ArrayBuffer, h = "0123456789abcdef".split(""), p = [
                        4,
                        1024,
                        262144,
                        67108864
                    ], b = [
                        0,
                        8,
                        16,
                        24
                    ], y = [
                        1,
                        0,
                        32898,
                        0,
                        32906,
                        2147483648,
                        2147516416,
                        2147483648,
                        32907,
                        0,
                        2147483649,
                        0,
                        2147516545,
                        2147483648,
                        32777,
                        2147483648,
                        138,
                        0,
                        136,
                        0,
                        2147516425,
                        0,
                        2147483658,
                        0,
                        2147516555,
                        0,
                        139,
                        2147483648,
                        32905,
                        2147483648,
                        32771,
                        2147483648,
                        32770,
                        2147483648,
                        128,
                        2147483648,
                        32778,
                        0,
                        2147483658,
                        2147483648,
                        2147516545,
                        2147483648,
                        32896,
                        2147483648,
                        2147483649,
                        0,
                        2147516424,
                        2147483648
                    ], v = [
                        224,
                        256,
                        384,
                        512
                    ], m = [
                        128,
                        256
                    ], g = [
                        "hex",
                        "buffer",
                        "arrayBuffer",
                        "array",
                        "digest"
                    ], w = {
                        128: 168,
                        256: 136
                    };
                    !u.JS_SHA3_NO_NODE_JS && Array.isArray || (Array.isArray = function(e) {
                        return "[object Array]" === Object.prototype.toString.call(e);
                    }), !l || !u.JS_SHA3_NO_ARRAY_BUFFER_IS_VIEW && ArrayBuffer.isView || (ArrayBuffer.isView = function(e) {
                        return "object" === (0, o.default)(e) && e.buffer && e.buffer.constructor === ArrayBuffer;
                    });
                    for(var k = function(e, t, r) {
                        return function(n) {
                            return new N(e, t, e).update(n)[r]();
                        };
                    }, _ = function(e, t, r) {
                        return function(n, i) {
                            return new N(e, t, i).update(n)[r]();
                        };
                    }, A = function(e, t, r) {
                        return function(t, n, i, o) {
                            return O["cshake" + e].update(t, n, i, o)[r]();
                        };
                    }, E = function(e, t, r) {
                        return function(t, n, i, o) {
                            return O["kmac" + e].update(t, n, i, o)[r]();
                        };
                    }, S = function(e, t, r, n) {
                        for(var i = 0; i < g.length; ++i){
                            var o = g[i];
                            e[o] = t(r, n, o);
                        }
                        return e;
                    }, x = function(e, t) {
                        var r = k(e, t, "hex");
                        return r.create = function() {
                            return new N(e, t, e);
                        }, r.update = function(e) {
                            return r.create().update(e);
                        }, S(r, k, e, t);
                    }, B = [
                        {
                            name: "keccak",
                            padding: [
                                1,
                                256,
                                65536,
                                16777216
                            ],
                            bits: v,
                            createMethod: x
                        },
                        {
                            name: "sha3",
                            padding: [
                                6,
                                1536,
                                393216,
                                100663296
                            ],
                            bits: v,
                            createMethod: x
                        },
                        {
                            name: "shake",
                            padding: [
                                31,
                                7936,
                                2031616,
                                520093696
                            ],
                            bits: m,
                            createMethod: function(e, t) {
                                var r = _(e, t, "hex");
                                return r.create = function(r) {
                                    return new N(e, t, r);
                                }, r.update = function(e, t) {
                                    return r.create(t).update(e);
                                }, S(r, _, e, t);
                            }
                        },
                        {
                            name: "cshake",
                            padding: p,
                            bits: m,
                            createMethod: function(e, t) {
                                var r = w[e], n = A(e, 0, "hex");
                                return n.create = function(n, i, o) {
                                    return i || o ? new N(e, t, n).bytepad([
                                        i,
                                        o
                                    ], r) : O["shake" + e].create(n);
                                }, n.update = function(e, t, r, i) {
                                    return n.create(t, r, i).update(e);
                                }, S(n, A, e, t);
                            }
                        },
                        {
                            name: "kmac",
                            padding: p,
                            bits: m,
                            createMethod: function(e, t) {
                                var r = w[e], n = E(e, 0, "hex");
                                return n.create = function(n, i, o) {
                                    return new j(e, t, i).bytepad([
                                        "KMAC",
                                        o
                                    ], r).bytepad([
                                        n
                                    ], r);
                                }, n.update = function(e, t, r, i) {
                                    return n.create(e, r, i).update(t);
                                }, S(n, E, e, t);
                            }
                        }
                    ], O = {}, P = [], I = 0; I < B.length; ++I)for(var T = B[I], C = T.bits, M = 0; M < C.length; ++M){
                        var R = T.name + "_" + C[M];
                        if (P.push(R), O[R] = T.createMethod(C[M], T.padding), "sha3" !== T.name) {
                            var U = T.name + C[M];
                            P.push(U), O[U] = O[R];
                        }
                    }
                    function N(e, t, r) {
                        this.blocks = [], this.s = [], this.padding = t, this.outputBits = r, this.reset = !0, this.finalized = !1, this.block = 0, this.start = 0, this.blockCount = 1600 - (e << 1) >> 5, this.byteCount = this.blockCount << 2, this.outputBlocks = r >> 5, this.extraBytes = (31 & r) >> 3;
                        for(var n = 0; n < 50; ++n)this.s[n] = 0;
                    }
                    function j(e, t, r) {
                        N.call(this, e, t, r);
                    }
                    N.prototype.update = function(e) {
                        if (this.finalized) throw new Error("finalize already called");
                        var t, r = (0, o.default)(e);
                        if ("string" !== r) {
                            if ("object" !== r) throw new Error(a);
                            if (null === e) throw new Error(a);
                            if (l && e.constructor === ArrayBuffer) e = new Uint8Array(e);
                            else if (!(Array.isArray(e) || l && ArrayBuffer.isView(e))) throw new Error(a);
                            t = !0;
                        }
                        for(var n, i, s = this.blocks, u = this.byteCount, c = e.length, f = this.blockCount, d = 0, h = this.s; d < c;){
                            if (this.reset) for(this.reset = !1, s[0] = this.block, n = 1; n < f + 1; ++n)s[n] = 0;
                            if (t) for(n = this.start; d < c && n < u; ++d)s[n >> 2] |= e[d] << b[3 & n++];
                            else for(n = this.start; d < c && n < u; ++d)(i = e.charCodeAt(d)) < 128 ? s[n >> 2] |= i << b[3 & n++] : i < 2048 ? (s[n >> 2] |= (192 | i >> 6) << b[3 & n++], s[n >> 2] |= (128 | 63 & i) << b[3 & n++]) : i < 55296 || i >= 57344 ? (s[n >> 2] |= (224 | i >> 12) << b[3 & n++], s[n >> 2] |= (128 | i >> 6 & 63) << b[3 & n++], s[n >> 2] |= (128 | 63 & i) << b[3 & n++]) : (i = 65536 + ((1023 & i) << 10 | 1023 & e.charCodeAt(++d)), s[n >> 2] |= (240 | i >> 18) << b[3 & n++], s[n >> 2] |= (128 | i >> 12 & 63) << b[3 & n++], s[n >> 2] |= (128 | i >> 6 & 63) << b[3 & n++], s[n >> 2] |= (128 | 63 & i) << b[3 & n++]);
                            if (this.lastByteIndex = n, n >= u) {
                                for(this.start = n - u, this.block = s[f], n = 0; n < f; ++n)h[n] ^= s[n];
                                L(h), this.reset = !0;
                            } else this.start = n;
                        }
                        return this;
                    }, N.prototype.encode = function(e, t) {
                        var r = 255 & e, n = 1, i = [
                            r
                        ];
                        for(r = 255 & (e >>= 8); r > 0;)i.unshift(r), r = 255 & (e >>= 8), ++n;
                        return t ? i.push(n) : i.unshift(n), this.update(i), i.length;
                    }, N.prototype.encodeString = function(e) {
                        var t, r = (0, o.default)(e);
                        if ("string" !== r) {
                            if ("object" !== r) throw new Error(a);
                            if (null === e) throw new Error(a);
                            if (l && e.constructor === ArrayBuffer) e = new Uint8Array(e);
                            else if (!(Array.isArray(e) || l && ArrayBuffer.isView(e))) throw new Error(a);
                            t = !0;
                        }
                        var n = 0, i = e.length;
                        if (t) n = i;
                        else for(var s = 0; s < e.length; ++s){
                            var u = e.charCodeAt(s);
                            u < 128 ? n += 1 : u < 2048 ? n += 2 : u < 55296 || u >= 57344 ? n += 3 : (u = 65536 + ((1023 & u) << 10 | 1023 & e.charCodeAt(++s)), n += 4);
                        }
                        return n += this.encode(8 * n), this.update(e), n;
                    }, N.prototype.bytepad = function(e, t) {
                        for(var r = this.encode(t), n = 0; n < e.length; ++n)r += this.encodeString(e[n]);
                        var i = t - r % t, o = [];
                        return o.length = i, this.update(o), this;
                    }, N.prototype.finalize = function() {
                        if (!this.finalized) {
                            this.finalized = !0;
                            var e = this.blocks, t = this.lastByteIndex, r = this.blockCount, n = this.s;
                            if (e[t >> 2] |= this.padding[3 & t], this.lastByteIndex === this.byteCount) for(e[0] = e[r], t = 1; t < r + 1; ++t)e[t] = 0;
                            for(e[r - 1] |= 2147483648, t = 0; t < r; ++t)n[t] ^= e[t];
                            L(n);
                        }
                    }, N.prototype.toString = N.prototype.hex = function() {
                        this.finalize();
                        for(var e, t = this.blockCount, r = this.s, n = this.outputBlocks, i = this.extraBytes, o = 0, a = 0, s = ""; a < n;){
                            for(o = 0; o < t && a < n; ++o, ++a)e = r[o], s += h[e >> 4 & 15] + h[15 & e] + h[e >> 12 & 15] + h[e >> 8 & 15] + h[e >> 20 & 15] + h[e >> 16 & 15] + h[e >> 28 & 15] + h[e >> 24 & 15];
                            a % t == 0 && (L(r), o = 0);
                        }
                        return i && (e = r[o], s += h[e >> 4 & 15] + h[15 & e], i > 1 && (s += h[e >> 12 & 15] + h[e >> 8 & 15]), i > 2 && (s += h[e >> 20 & 15] + h[e >> 16 & 15])), s;
                    }, N.prototype.arrayBuffer = function() {
                        this.finalize();
                        var e, t = this.blockCount, r = this.s, n = this.outputBlocks, i = this.extraBytes, o = 0, a = 0, s = this.outputBits >> 3;
                        e = i ? new ArrayBuffer(n + 1 << 2) : new ArrayBuffer(s);
                        for(var u = new Uint32Array(e); a < n;){
                            for(o = 0; o < t && a < n; ++o, ++a)u[a] = r[o];
                            a % t == 0 && L(r);
                        }
                        return i && (u[o] = r[o], e = e.slice(0, s)), e;
                    }, N.prototype.buffer = N.prototype.arrayBuffer, N.prototype.digest = N.prototype.array = function() {
                        this.finalize();
                        for(var e, t, r = this.blockCount, n = this.s, i = this.outputBlocks, o = this.extraBytes, a = 0, s = 0, u = []; s < i;){
                            for(a = 0; a < r && s < i; ++a, ++s)e = s << 2, t = n[a], u[e] = 255 & t, u[e + 1] = t >> 8 & 255, u[e + 2] = t >> 16 & 255, u[e + 3] = t >> 24 & 255;
                            s % r == 0 && L(n);
                        }
                        return o && (e = s << 2, t = n[a], u[e] = 255 & t, o > 1 && (u[e + 1] = t >> 8 & 255), o > 2 && (u[e + 2] = t >> 16 & 255)), u;
                    }, j.prototype = new N, j.prototype.finalize = function() {
                        return this.encode(this.outputBits, !0), N.prototype.finalize.call(this);
                    };
                    var L = function(e) {
                        var t, r, n, i, o, a, s, u, c, f, d, l, h, p, b, v, m, g, w, k, _, A, E, S, x, B, O, P, I, T, C, M, R, U, N, j, L, F, D, H, z, q, K, G, V, Z, W, J, Y, X, Q, $, ee, te, re, ne, ie, oe, ae, se, ue, ce, fe;
                        for(n = 0; n < 48; n += 2)i = e[0] ^ e[10] ^ e[20] ^ e[30] ^ e[40], o = e[1] ^ e[11] ^ e[21] ^ e[31] ^ e[41], a = e[2] ^ e[12] ^ e[22] ^ e[32] ^ e[42], s = e[3] ^ e[13] ^ e[23] ^ e[33] ^ e[43], u = e[4] ^ e[14] ^ e[24] ^ e[34] ^ e[44], c = e[5] ^ e[15] ^ e[25] ^ e[35] ^ e[45], f = e[6] ^ e[16] ^ e[26] ^ e[36] ^ e[46], d = e[7] ^ e[17] ^ e[27] ^ e[37] ^ e[47], t = (l = e[8] ^ e[18] ^ e[28] ^ e[38] ^ e[48]) ^ (a << 1 | s >>> 31), r = (h = e[9] ^ e[19] ^ e[29] ^ e[39] ^ e[49]) ^ (s << 1 | a >>> 31), e[0] ^= t, e[1] ^= r, e[10] ^= t, e[11] ^= r, e[20] ^= t, e[21] ^= r, e[30] ^= t, e[31] ^= r, e[40] ^= t, e[41] ^= r, t = i ^ (u << 1 | c >>> 31), r = o ^ (c << 1 | u >>> 31), e[2] ^= t, e[3] ^= r, e[12] ^= t, e[13] ^= r, e[22] ^= t, e[23] ^= r, e[32] ^= t, e[33] ^= r, e[42] ^= t, e[43] ^= r, t = a ^ (f << 1 | d >>> 31), r = s ^ (d << 1 | f >>> 31), e[4] ^= t, e[5] ^= r, e[14] ^= t, e[15] ^= r, e[24] ^= t, e[25] ^= r, e[34] ^= t, e[35] ^= r, e[44] ^= t, e[45] ^= r, t = u ^ (l << 1 | h >>> 31), r = c ^ (h << 1 | l >>> 31), e[6] ^= t, e[7] ^= r, e[16] ^= t, e[17] ^= r, e[26] ^= t, e[27] ^= r, e[36] ^= t, e[37] ^= r, e[46] ^= t, e[47] ^= r, t = f ^ (i << 1 | o >>> 31), r = d ^ (o << 1 | i >>> 31), e[8] ^= t, e[9] ^= r, e[18] ^= t, e[19] ^= r, e[28] ^= t, e[29] ^= r, e[38] ^= t, e[39] ^= r, e[48] ^= t, e[49] ^= r, p = e[0], b = e[1], Z = e[11] << 4 | e[10] >>> 28, W = e[10] << 4 | e[11] >>> 28, P = e[20] << 3 | e[21] >>> 29, I = e[21] << 3 | e[20] >>> 29, se = e[31] << 9 | e[30] >>> 23, ue = e[30] << 9 | e[31] >>> 23, q = e[40] << 18 | e[41] >>> 14, K = e[41] << 18 | e[40] >>> 14, U = e[2] << 1 | e[3] >>> 31, N = e[3] << 1 | e[2] >>> 31, v = e[13] << 12 | e[12] >>> 20, m = e[12] << 12 | e[13] >>> 20, J = e[22] << 10 | e[23] >>> 22, Y = e[23] << 10 | e[22] >>> 22, T = e[33] << 13 | e[32] >>> 19, C = e[32] << 13 | e[33] >>> 19, ce = e[42] << 2 | e[43] >>> 30, fe = e[43] << 2 | e[42] >>> 30, te = e[5] << 30 | e[4] >>> 2, re = e[4] << 30 | e[5] >>> 2, j = e[14] << 6 | e[15] >>> 26, L = e[15] << 6 | e[14] >>> 26, g = e[25] << 11 | e[24] >>> 21, w = e[24] << 11 | e[25] >>> 21, X = e[34] << 15 | e[35] >>> 17, Q = e[35] << 15 | e[34] >>> 17, M = e[45] << 29 | e[44] >>> 3, R = e[44] << 29 | e[45] >>> 3, S = e[6] << 28 | e[7] >>> 4, x = e[7] << 28 | e[6] >>> 4, ne = e[17] << 23 | e[16] >>> 9, ie = e[16] << 23 | e[17] >>> 9, F = e[26] << 25 | e[27] >>> 7, D = e[27] << 25 | e[26] >>> 7, k = e[36] << 21 | e[37] >>> 11, _ = e[37] << 21 | e[36] >>> 11, $ = e[47] << 24 | e[46] >>> 8, ee = e[46] << 24 | e[47] >>> 8, G = e[8] << 27 | e[9] >>> 5, V = e[9] << 27 | e[8] >>> 5, B = e[18] << 20 | e[19] >>> 12, O = e[19] << 20 | e[18] >>> 12, oe = e[29] << 7 | e[28] >>> 25, ae = e[28] << 7 | e[29] >>> 25, H = e[38] << 8 | e[39] >>> 24, z = e[39] << 8 | e[38] >>> 24, A = e[48] << 14 | e[49] >>> 18, E = e[49] << 14 | e[48] >>> 18, e[0] = p ^ ~v & g, e[1] = b ^ ~m & w, e[10] = S ^ ~B & P, e[11] = x ^ ~O & I, e[20] = U ^ ~j & F, e[21] = N ^ ~L & D, e[30] = G ^ ~Z & J, e[31] = V ^ ~W & Y, e[40] = te ^ ~ne & oe, e[41] = re ^ ~ie & ae, e[2] = v ^ ~g & k, e[3] = m ^ ~w & _, e[12] = B ^ ~P & T, e[13] = O ^ ~I & C, e[22] = j ^ ~F & H, e[23] = L ^ ~D & z, e[32] = Z ^ ~J & X, e[33] = W ^ ~Y & Q, e[42] = ne ^ ~oe & se, e[43] = ie ^ ~ae & ue, e[4] = g ^ ~k & A, e[5] = w ^ ~_ & E, e[14] = P ^ ~T & M, e[15] = I ^ ~C & R, e[24] = F ^ ~H & q, e[25] = D ^ ~z & K, e[34] = J ^ ~X & $, e[35] = Y ^ ~Q & ee, e[44] = oe ^ ~se & ce, e[45] = ae ^ ~ue & fe, e[6] = k ^ ~A & p, e[7] = _ ^ ~E & b, e[16] = T ^ ~M & S, e[17] = C ^ ~R & x, e[26] = H ^ ~q & U, e[27] = z ^ ~K & N, e[36] = X ^ ~$ & G, e[37] = Q ^ ~ee & V, e[46] = se ^ ~ce & te, e[47] = ue ^ ~fe & re, e[8] = A ^ ~p & v, e[9] = E ^ ~b & m, e[18] = M ^ ~S & B, e[19] = R ^ ~x & O, e[28] = q ^ ~U & j, e[29] = K ^ ~N & L, e[38] = $ ^ ~G & Z, e[39] = ee ^ ~V & W, e[48] = ce ^ ~te & ne, e[49] = fe ^ ~re & ie, e[0] ^= y[n], e[1] ^= y[n + 1];
                    };
                    if (f) e.exports = O;
                    else {
                        for(I = 0; I < P.length; ++I)u[P[I]] = O[P[I]];
                        d && (void 0 === (n = (function() {
                            return O;
                        }).call(t, r, t, e)) || (e.exports = n));
                    }
                }();
            },
            1243: (e, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.keccak512 = t.keccak384 = t.keccak256 = t.keccak224 = void 0;
                var n, i = r(64376), o = r(40890);
                t.keccak224 = (0, o.wrapHash)(i.keccak_224), t.keccak256 = ((n = (0, o.wrapHash)(i.keccak_256)).create = i.keccak_256.create, n), t.keccak384 = (0, o.wrapHash)(i.keccak_384), t.keccak512 = (0, o.wrapHash)(i.keccak_512);
            },
            86992: (e, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.secp256k1 = void 0;
                var n = r(4158);
                Object.defineProperty(t, "secp256k1", {
                    enumerable: !0,
                    get: function() {
                        return n.secp256k1;
                    }
                });
            },
            40890: (e, t, r)=>{
                "use strict";
                e = r.nmd(e);
                var n = r(28847)(r(3355));
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.crypto = t.wrapHash = t.equalsBytes = t.hexToBytes = t.bytesToUtf8 = t.utf8ToBytes = t.createView = t.concatBytes = t.toHex = t.bytesToHex = t.assertBytes = t.assertBool = void 0;
                var i, o = (i = r(96822)) && i.__esModule ? i : {
                    default: i
                }, a = r(72434), s = o.default.bool;
                t.assertBool = s;
                var u = o.default.bytes;
                t.assertBytes = u;
                var c, f, d = r(72434);
                Object.defineProperty(t, "bytesToHex", {
                    enumerable: !0,
                    get: function() {
                        return d.bytesToHex;
                    }
                }), Object.defineProperty(t, "toHex", {
                    enumerable: !0,
                    get: function() {
                        return d.bytesToHex;
                    }
                }), Object.defineProperty(t, "concatBytes", {
                    enumerable: !0,
                    get: function() {
                        return d.concatBytes;
                    }
                }), Object.defineProperty(t, "createView", {
                    enumerable: !0,
                    get: function() {
                        return d.createView;
                    }
                }), Object.defineProperty(t, "utf8ToBytes", {
                    enumerable: !0,
                    get: function() {
                        return d.utf8ToBytes;
                    }
                }), t.bytesToUtf8 = function(e) {
                    if (!(e instanceof Uint8Array)) throw new TypeError("bytesToUtf8 expected Uint8Array, got ".concat((0, n.default)(e)));
                    return (new TextDecoder).decode(e);
                }, t.hexToBytes = function(e) {
                    var t = e.startsWith("0x") ? e.substring(2) : e;
                    return (0, a.hexToBytes)(t);
                }, t.equalsBytes = function(e, t) {
                    if (e.length !== t.length) return !1;
                    for(var r = 0; r < e.length; r++)if (e[r] !== t[r]) return !1;
                    return !0;
                }, t.wrapHash = function(e) {
                    return function(t) {
                        return o.default.bytes(t), e(t);
                    };
                }, t.crypto = (c = "object" === ("undefined" == typeof globalThis ? "undefined" : (0, n.default)(globalThis)) && "crypto" in globalThis ? globalThis.crypto : void 0, {
                    node: (f = "function" == typeof e.require && e.require.bind(e)) && !c ? f("crypto") : void 0,
                    web: c
                });
            },
            21968: (e, t, r)=>{
                "use strict";
                var n = r(29033).Buffer;
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.isZeroAddress = t.zeroAddress = t.importPublic = t.privateToAddress = t.privateToPublic = t.publicToAddress = t.pubToAddress = t.isValidPublic = t.isValidPrivate = t.generateAddress2 = t.generateAddress = t.isValidChecksumAddress = t.toChecksumAddress = t.isValidAddress = t.Account = void 0;
                var i, o = (i = r(3894)) && i.__esModule ? i : {
                    default: i
                }, a = r(49100), s = r(31439), u = r(23271), c = r(60986), f = r(13464), d = r(39808), l = r(5725), h = r(35513), p = function() {
                    function e(e, t, r, n) {
                        void 0 === e && (e = new a.BN(0)), void 0 === t && (t = new a.BN(0)), void 0 === r && (r = c.KECCAK256_RLP), void 0 === n && (n = c.KECCAK256_NULL), this.nonce = e, this.balance = t, this.stateRoot = r, this.codeHash = n, this._validate();
                    }
                    return e.fromAccountData = function(t) {
                        var r = t.nonce, n = t.balance, i = t.stateRoot, o = t.codeHash;
                        return new e(r ? new a.BN((0, f.toBuffer)(r)) : void 0, n ? new a.BN((0, f.toBuffer)(n)) : void 0, i ? (0, f.toBuffer)(i) : void 0, o ? (0, f.toBuffer)(o) : void 0);
                    }, e.fromRlpSerializedAccount = function(e) {
                        var t = a.rlp.decode(e);
                        if (!Array.isArray(t)) throw new Error("Invalid serialized account input. Must be array");
                        return this.fromValuesArray(t);
                    }, e.fromValuesArray = function(t) {
                        var r = function(e, t) {
                            var r = "function" == typeof Symbol && e[Symbol.iterator];
                            if (!r) return e;
                            var n, i, o = r.call(e), a = [];
                            try {
                                for(; (void 0 === t || t-- > 0) && !(n = o.next()).done;)a.push(n.value);
                            } catch (e) {
                                i = {
                                    error: e
                                };
                            } finally{
                                try {
                                    n && !n.done && (r = o.return) && r.call(o);
                                } finally{
                                    if (i) throw i.error;
                                }
                            }
                            return a;
                        }(t, 4), n = r[0], i = r[1], o = r[2], s = r[3];
                        return new e(new a.BN(n), new a.BN(i), o, s);
                    }, e.prototype._validate = function() {
                        if (this.nonce.lt(new a.BN(0))) throw new Error("nonce must be greater than zero");
                        if (this.balance.lt(new a.BN(0))) throw new Error("balance must be greater than zero");
                        if (32 !== this.stateRoot.length) throw new Error("stateRoot must have a length of 32");
                        if (32 !== this.codeHash.length) throw new Error("codeHash must have a length of 32");
                    }, e.prototype.raw = function() {
                        return [
                            (0, h.bnToUnpaddedBuffer)(this.nonce),
                            (0, h.bnToUnpaddedBuffer)(this.balance),
                            this.stateRoot,
                            this.codeHash
                        ];
                    }, e.prototype.serialize = function() {
                        return a.rlp.encode(this.raw());
                    }, e.prototype.isContract = function() {
                        return !this.codeHash.equals(c.KECCAK256_NULL);
                    }, e.prototype.isEmpty = function() {
                        return this.balance.isZero() && this.nonce.isZero() && this.codeHash.equals(c.KECCAK256_NULL);
                    }, e;
                }();
                t.Account = p, t.isValidAddress = function(e) {
                    try {
                        (0, l.assertIsString)(e);
                    } catch (e) {
                        return !1;
                    }
                    return /^0x[0-9a-fA-F]{40}$/.test(e);
                }, t.toChecksumAddress = function(e, t) {
                    (0, l.assertIsHexString)(e);
                    var r = (0, u.stripHexPrefix)(e).toLowerCase(), n = "";
                    t && (n = (0, h.toType)(t, h.TypeOutput.BN).toString() + "0x");
                    for(var i = (0, d.keccakFromString)(n + r).toString("hex"), o = "0x", a = 0; a < r.length; a++)parseInt(i[a], 16) >= 8 ? o += r[a].toUpperCase() : o += r[a];
                    return o;
                }, t.isValidChecksumAddress = function(e, r) {
                    return (0, t.isValidAddress)(e) && (0, t.toChecksumAddress)(e, r) === e;
                }, t.generateAddress = function(e, t) {
                    (0, l.assertIsBuffer)(e), (0, l.assertIsBuffer)(t);
                    var r = new a.BN(t);
                    return r.isZero() ? (0, d.rlphash)([
                        e,
                        null
                    ]).slice(-20) : (0, d.rlphash)([
                        e,
                        n.from(r.toArray())
                    ]).slice(-20);
                }, t.generateAddress2 = function(e, t, r) {
                    return (0, l.assertIsBuffer)(e), (0, l.assertIsBuffer)(t), (0, l.assertIsBuffer)(r), (0, o.default)(20 === e.length), (0, o.default)(32 === t.length), (0, d.keccak256)(n.concat([
                        n.from("ff", "hex"),
                        e,
                        t,
                        (0, d.keccak256)(r)
                    ])).slice(-20);
                }, t.isValidPrivate = function(e) {
                    return (0, s.privateKeyVerify)(e);
                }, t.isValidPublic = function(e, t) {
                    return void 0 === t && (t = !1), (0, l.assertIsBuffer)(e), 64 === e.length ? (0, s.publicKeyVerify)(n.concat([
                        n.from([
                            4
                        ]),
                        e
                    ])) : !!t && (0, s.publicKeyVerify)(e);
                }, t.pubToAddress = function(e, t) {
                    return void 0 === t && (t = !1), (0, l.assertIsBuffer)(e), t && 64 !== e.length && (e = n.from((0, s.publicKeyConvert)(e, !1).slice(1))), (0, o.default)(64 === e.length), (0, d.keccak)(e).slice(-20);
                }, t.publicToAddress = t.pubToAddress, t.privateToPublic = function(e) {
                    return (0, l.assertIsBuffer)(e), n.from((0, s.publicKeyCreate)(e, !1)).slice(1);
                }, t.privateToAddress = function(e) {
                    return (0, t.publicToAddress)((0, t.privateToPublic)(e));
                }, t.importPublic = function(e) {
                    return (0, l.assertIsBuffer)(e), 64 !== e.length && (e = n.from((0, s.publicKeyConvert)(e, !1).slice(1))), e;
                }, t.zeroAddress = function() {
                    var e = (0, f.zeros)(20);
                    return (0, f.bufferToHex)(e);
                }, t.isZeroAddress = function(e) {
                    try {
                        (0, l.assertIsString)(e);
                    } catch (e) {
                        return !1;
                    }
                    return (0, t.zeroAddress)() === e;
                };
            },
            41984: (e, t, r)=>{
                "use strict";
                var n = r(29033).Buffer;
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.Address = void 0;
                var i, o = (i = r(3894)) && i.__esModule ? i : {
                    default: i
                }, a = r(49100), s = r(13464), u = r(21968), c = function() {
                    function e(e) {
                        (0, o.default)(20 === e.length, "Invalid address length"), this.buf = e;
                    }
                    return e.zero = function() {
                        return new e((0, s.zeros)(20));
                    }, e.fromString = function(t) {
                        return (0, o.default)((0, u.isValidAddress)(t), "Invalid address"), new e((0, s.toBuffer)(t));
                    }, e.fromPublicKey = function(t) {
                        return (0, o.default)(n.isBuffer(t), "Public key should be Buffer"), new e((0, u.pubToAddress)(t));
                    }, e.fromPrivateKey = function(t) {
                        return (0, o.default)(n.isBuffer(t), "Private key should be Buffer"), new e((0, u.privateToAddress)(t));
                    }, e.generate = function(t, r) {
                        return (0, o.default)(a.BN.isBN(r)), new e((0, u.generateAddress)(t.buf, r.toArrayLike(n)));
                    }, e.generate2 = function(t, r, i) {
                        return (0, o.default)(n.isBuffer(r)), (0, o.default)(n.isBuffer(i)), new e((0, u.generateAddress2)(t.buf, r, i));
                    }, e.prototype.equals = function(e) {
                        return this.buf.equals(e.buf);
                    }, e.prototype.isZero = function() {
                        return this.equals(e.zero());
                    }, e.prototype.isPrecompileOrSystemAddress = function() {
                        var e = new a.BN(this.buf), t = new a.BN(0), r = new a.BN("ffff", "hex");
                        return e.gte(t) && e.lte(r);
                    }, e.prototype.toString = function() {
                        return "0x" + this.buf.toString("hex");
                    }, e.prototype.toBuffer = function() {
                        return n.from(this.buf);
                    }, e;
                }();
                t.Address = c;
            },
            13464: (e, t, r)=>{
                "use strict";
                var n = r(29033).Buffer, i = function(e, t) {
                    var r = "function" == typeof Symbol && e[Symbol.iterator];
                    if (!r) return e;
                    var n, i, o = r.call(e), a = [];
                    try {
                        for(; (void 0 === t || t-- > 0) && !(n = o.next()).done;)a.push(n.value);
                    } catch (e) {
                        i = {
                            error: e
                        };
                    } finally{
                        try {
                            n && !n.done && (r = o.return) && r.call(o);
                        } finally{
                            if (i) throw i.error;
                        }
                    }
                    return a;
                };
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.bufArrToArr = t.arrToBufArr = t.validateNoLeadingZeroes = t.baToJSON = t.toUtf8 = t.addHexPrefix = t.toUnsigned = t.fromSigned = t.bufferToHex = t.bufferToInt = t.toBuffer = t.unpadHexString = t.unpadArray = t.unpadBuffer = t.setLengthRight = t.setLengthLeft = t.zeros = t.intToBuffer = t.intToHex = void 0;
                var o = r(49100), a = r(23271), s = r(5725);
                t.intToHex = function(e) {
                    if (!Number.isSafeInteger(e) || e < 0) throw new Error("Received an invalid integer type: ".concat(e));
                    return "0x".concat(e.toString(16));
                }, t.intToBuffer = function(e) {
                    var r = (0, t.intToHex)(e);
                    return n.from((0, a.padToEven)(r.slice(2)), "hex");
                }, t.zeros = function(e) {
                    return n.allocUnsafe(e).fill(0);
                };
                var u = function(e, r, n) {
                    var i = (0, t.zeros)(r);
                    return n ? e.length < r ? (e.copy(i), i) : e.slice(0, r) : e.length < r ? (e.copy(i, r - e.length), i) : e.slice(-r);
                };
                t.setLengthLeft = function(e, t) {
                    return (0, s.assertIsBuffer)(e), u(e, t, !1);
                }, t.setLengthRight = function(e, t) {
                    return (0, s.assertIsBuffer)(e), u(e, t, !0);
                };
                var c = function(e) {
                    for(var t = e[0]; e.length > 0 && "0" === t.toString();)t = (e = e.slice(1))[0];
                    return e;
                };
                t.unpadBuffer = function(e) {
                    return (0, s.assertIsBuffer)(e), c(e);
                }, t.unpadArray = function(e) {
                    return (0, s.assertIsArray)(e), c(e);
                }, t.unpadHexString = function(e) {
                    return (0, s.assertIsHexString)(e), e = (0, a.stripHexPrefix)(e), c(e);
                }, t.toBuffer = function(e) {
                    if (null == e) return n.allocUnsafe(0);
                    if (n.isBuffer(e)) return n.from(e);
                    if (Array.isArray(e) || e instanceof Uint8Array) return n.from(e);
                    if ("string" == typeof e) {
                        if (!(0, a.isHexString)(e)) throw new Error("Cannot convert string to buffer. toBuffer only supports 0x-prefixed hex strings and this string was given: ".concat(e));
                        return n.from((0, a.padToEven)((0, a.stripHexPrefix)(e)), "hex");
                    }
                    if ("number" == typeof e) return (0, t.intToBuffer)(e);
                    if (o.BN.isBN(e)) {
                        if (e.isNeg()) throw new Error("Cannot convert negative BN to buffer. Given: ".concat(e));
                        return e.toArrayLike(n);
                    }
                    if (e.toArray) return n.from(e.toArray());
                    if (e.toBuffer) return n.from(e.toBuffer());
                    throw new Error("invalid type");
                }, t.bufferToInt = function(e) {
                    return new o.BN((0, t.toBuffer)(e)).toNumber();
                }, t.bufferToHex = function(e) {
                    return "0x" + (e = (0, t.toBuffer)(e)).toString("hex");
                }, t.fromSigned = function(e) {
                    return new o.BN(e).fromTwos(256);
                }, t.toUnsigned = function(e) {
                    return n.from(e.toTwos(256).toArray());
                }, t.addHexPrefix = function(e) {
                    return "string" != typeof e || (0, a.isHexPrefixed)(e) ? e : "0x" + e;
                }, t.toUtf8 = function(e) {
                    if ((e = (0, a.stripHexPrefix)(e)).length % 2 != 0) throw new Error("Invalid non-even hex string input for toUtf8() provided");
                    return n.from(e.replace(/^(00)+|(00)+$/g, ""), "hex").toString("utf8");
                }, t.baToJSON = function(e) {
                    if (n.isBuffer(e)) return "0x".concat(e.toString("hex"));
                    if (e instanceof Array) {
                        for(var r = [], i = 0; i < e.length; i++)r.push((0, t.baToJSON)(e[i]));
                        return r;
                    }
                }, t.validateNoLeadingZeroes = function(e) {
                    var t, r;
                    try {
                        for(var n = function(e) {
                            var t = "function" == typeof Symbol && Symbol.iterator, r = t && e[t], n = 0;
                            if (r) return r.call(e);
                            if (e && "number" == typeof e.length) return {
                                next: function() {
                                    return e && n >= e.length && (e = void 0), {
                                        value: e && e[n++],
                                        done: !e
                                    };
                                }
                            };
                            throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
                        }(Object.entries(e)), o = n.next(); !o.done; o = n.next()){
                            var a = i(o.value, 2), s = a[0], u = a[1];
                            if (void 0 !== u && u.length > 0 && 0 === u[0]) throw new Error("".concat(s, " cannot have leading zeroes, received: ").concat(u.toString("hex")));
                        }
                    } catch (e) {
                        t = {
                            error: e
                        };
                    } finally{
                        try {
                            o && !o.done && (r = n.return) && r.call(n);
                        } finally{
                            if (t) throw t.error;
                        }
                    }
                }, t.arrToBufArr = function e(t) {
                    return Array.isArray(t) ? t.map(function(t) {
                        return e(t);
                    }) : n.from(t);
                }, t.bufArrToArr = function e(t) {
                    return Array.isArray(t) ? t.map(function(t) {
                        return e(t);
                    }) : Uint8Array.from(null != t ? t : []);
                };
            },
            60986: (e, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.KECCAK256_RLP = t.KECCAK256_RLP_S = t.KECCAK256_RLP_ARRAY = t.KECCAK256_RLP_ARRAY_S = t.KECCAK256_NULL = t.KECCAK256_NULL_S = t.TWO_POW256 = t.MAX_INTEGER = t.MAX_UINT64 = void 0;
                var n = r(29033), i = r(49100);
                t.MAX_UINT64 = new i.BN("ffffffffffffffff", 16), t.MAX_INTEGER = new i.BN("ffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff", 16), t.TWO_POW256 = new i.BN("10000000000000000000000000000000000000000000000000000000000000000", 16), t.KECCAK256_NULL_S = "c5d2460186f7233c927e7db2dcc703c0e500b653ca82273b7bfad8045d85a470", t.KECCAK256_NULL = n.Buffer.from(t.KECCAK256_NULL_S, "hex"), t.KECCAK256_RLP_ARRAY_S = "1dcc4de8dec75d7aab85b567b6ccd41ad312451b948a7413f0a142fd40d49347", t.KECCAK256_RLP_ARRAY = n.Buffer.from(t.KECCAK256_RLP_ARRAY_S, "hex"), t.KECCAK256_RLP_S = "56e81f171bcc55a6ff8345e692c0f86e5b48e01b996cadc001622fb5e363b421", t.KECCAK256_RLP = n.Buffer.from(t.KECCAK256_RLP_S, "hex");
            },
            49100: (e, t, r)=>{
                "use strict";
                var n = Object.create ? function(e, t, r, n) {
                    void 0 === n && (n = r);
                    var i = Object.getOwnPropertyDescriptor(t, r);
                    i && !("get" in i ? !t.__esModule : i.writable || i.configurable) || (i = {
                        enumerable: !0,
                        get: function() {
                            return t[r];
                        }
                    }), Object.defineProperty(e, n, i);
                } : function(e, t, r, n) {
                    void 0 === n && (n = r), e[n] = t[r];
                }, i = Object.create ? function(e, t) {
                    Object.defineProperty(e, "default", {
                        enumerable: !0,
                        value: t
                    });
                } : function(e, t) {
                    e.default = t;
                };
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.rlp = t.BN = void 0;
                var o, a = (o = r(31734)) && o.__esModule ? o : {
                    default: o
                };
                t.BN = a.default;
                var s = function(e) {
                    if (e && e.__esModule) return e;
                    var t = {};
                    if (null != e) for(var r in e)"default" !== r && Object.prototype.hasOwnProperty.call(e, r) && n(t, e, r);
                    return i(t, e), t;
                }(r(6905));
                t.rlp = s;
            },
            39808: (e, t, r)=>{
                "use strict";
                var n = r(29033).Buffer;
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.rlphash = t.ripemd160FromArray = t.ripemd160FromString = t.ripemd160 = t.sha256FromArray = t.sha256FromString = t.sha256 = t.keccakFromArray = t.keccakFromHexString = t.keccakFromString = t.keccak256 = t.keccak = void 0;
                var i = r(8235), o = r(35866), a = r(49100), s = r(13464), u = r(5725);
                t.keccak = function(e, t) {
                    switch(void 0 === t && (t = 256), (0, u.assertIsBuffer)(e), t){
                        case 224:
                            return (0, i.keccak224)(e);
                        case 256:
                            return (0, i.keccak256)(e);
                        case 384:
                            return (0, i.keccak384)(e);
                        case 512:
                            return (0, i.keccak512)(e);
                        default:
                            throw new Error("Invald algorithm: keccak".concat(t));
                    }
                }, t.keccak256 = function(e) {
                    return (0, t.keccak)(e);
                }, t.keccakFromString = function(e, r) {
                    void 0 === r && (r = 256), (0, u.assertIsString)(e);
                    var i = n.from(e, "utf8");
                    return (0, t.keccak)(i, r);
                }, t.keccakFromHexString = function(e, r) {
                    return void 0 === r && (r = 256), (0, u.assertIsHexString)(e), (0, t.keccak)((0, s.toBuffer)(e), r);
                }, t.keccakFromArray = function(e, r) {
                    return void 0 === r && (r = 256), (0, u.assertIsArray)(e), (0, t.keccak)((0, s.toBuffer)(e), r);
                };
                var c = function(e) {
                    return e = (0, s.toBuffer)(e), o("sha256").update(e).digest();
                };
                t.sha256 = function(e) {
                    return (0, u.assertIsBuffer)(e), c(e);
                }, t.sha256FromString = function(e) {
                    return (0, u.assertIsString)(e), c(e);
                }, t.sha256FromArray = function(e) {
                    return (0, u.assertIsArray)(e), c(e);
                };
                var f = function(e, t) {
                    e = (0, s.toBuffer)(e);
                    var r = o("rmd160").update(e).digest();
                    return !0 === t ? (0, s.setLengthLeft)(r, 32) : r;
                };
                t.ripemd160 = function(e, t) {
                    return (0, u.assertIsBuffer)(e), f(e, t);
                }, t.ripemd160FromString = function(e, t) {
                    return (0, u.assertIsString)(e), f(e, t);
                }, t.ripemd160FromArray = function(e, t) {
                    return (0, u.assertIsArray)(e), f(e, t);
                }, t.rlphash = function(e) {
                    return (0, t.keccak)(a.rlp.encode(e));
                };
            },
            5725: (e, t, r)=>{
                "use strict";
                var n = r(29033).Buffer;
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.assertIsString = t.assertIsArray = t.assertIsBuffer = t.assertIsHexString = void 0;
                var i = r(23271);
                t.assertIsHexString = function(e) {
                    if (!(0, i.isHexString)(e)) {
                        var t = "This method only supports 0x-prefixed hex strings but input was: ".concat(e);
                        throw new Error(t);
                    }
                }, t.assertIsBuffer = function(e) {
                    if (!n.isBuffer(e)) {
                        var t = "This method only supports Buffer but input was: ".concat(e);
                        throw new Error(t);
                    }
                }, t.assertIsArray = function(e) {
                    if (!Array.isArray(e)) {
                        var t = "This method only supports number arrays but input was: ".concat(e);
                        throw new Error(t);
                    }
                }, t.assertIsString = function(e) {
                    if ("string" != typeof e) {
                        var t = "This method only supports strings but input was: ".concat(e);
                        throw new Error(t);
                    }
                };
            },
            33062: (e, t, r)=>{
                "use strict";
                var n = Object.create ? function(e, t, r, n) {
                    void 0 === n && (n = r);
                    var i = Object.getOwnPropertyDescriptor(t, r);
                    i && !("get" in i ? !t.__esModule : i.writable || i.configurable) || (i = {
                        enumerable: !0,
                        get: function() {
                            return t[r];
                        }
                    }), Object.defineProperty(e, n, i);
                } : function(e, t, r, n) {
                    void 0 === n && (n = r), e[n] = t[r];
                }, i = function(e, t) {
                    for(var r in e)"default" === r || Object.prototype.hasOwnProperty.call(t, r) || n(t, e, r);
                };
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.isHexString = t.getKeys = t.fromAscii = t.fromUtf8 = t.toAscii = t.arrayContainsArray = t.getBinarySize = t.padToEven = t.stripHexPrefix = t.isHexPrefixed = void 0, i(r(60986), t), i(r(21968), t), i(r(41984), t), i(r(39808), t), i(r(86081), t), i(r(13464), t), i(r(41677), t), i(r(49100), t), i(r(35513), t);
                var o = r(23271);
                Object.defineProperty(t, "isHexPrefixed", {
                    enumerable: !0,
                    get: function() {
                        return o.isHexPrefixed;
                    }
                }), Object.defineProperty(t, "stripHexPrefix", {
                    enumerable: !0,
                    get: function() {
                        return o.stripHexPrefix;
                    }
                }), Object.defineProperty(t, "padToEven", {
                    enumerable: !0,
                    get: function() {
                        return o.padToEven;
                    }
                }), Object.defineProperty(t, "getBinarySize", {
                    enumerable: !0,
                    get: function() {
                        return o.getBinarySize;
                    }
                }), Object.defineProperty(t, "arrayContainsArray", {
                    enumerable: !0,
                    get: function() {
                        return o.arrayContainsArray;
                    }
                }), Object.defineProperty(t, "toAscii", {
                    enumerable: !0,
                    get: function() {
                        return o.toAscii;
                    }
                }), Object.defineProperty(t, "fromUtf8", {
                    enumerable: !0,
                    get: function() {
                        return o.fromUtf8;
                    }
                }), Object.defineProperty(t, "fromAscii", {
                    enumerable: !0,
                    get: function() {
                        return o.fromAscii;
                    }
                }), Object.defineProperty(t, "getKeys", {
                    enumerable: !0,
                    get: function() {
                        return o.getKeys;
                    }
                }), Object.defineProperty(t, "isHexString", {
                    enumerable: !0,
                    get: function() {
                        return o.isHexString;
                    }
                });
            },
            23271: (e, t, r)=>{
                "use strict";
                var n = r(29033).Buffer, i = r(28847)(r(3355));
                function o(e) {
                    if ("string" != typeof e) throw new Error("[isHexPrefixed] input must be type 'string', received type ".concat((0, i.default)(e)));
                    return "0" === e[0] && "x" === e[1];
                }
                function a(e) {
                    var t = e;
                    if ("string" != typeof t) throw new Error("[padToEven] value must be type 'string', received ".concat((0, i.default)(t)));
                    return t.length % 2 && (t = "0".concat(t)), t;
                }
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.isHexString = t.getKeys = t.fromAscii = t.fromUtf8 = t.toAscii = t.arrayContainsArray = t.getBinarySize = t.padToEven = t.stripHexPrefix = t.isHexPrefixed = void 0, t.isHexPrefixed = o, t.stripHexPrefix = function(e) {
                    if ("string" != typeof e) throw new Error("[stripHexPrefix] input must be type 'string', received ".concat((0, i.default)(e)));
                    return o(e) ? e.slice(2) : e;
                }, t.padToEven = a, t.getBinarySize = function(e) {
                    if ("string" != typeof e) throw new Error("[getBinarySize] method requires input type 'string', recieved ".concat((0, i.default)(e)));
                    return n.byteLength(e, "utf8");
                }, t.arrayContainsArray = function(e, t, r) {
                    if (!0 !== Array.isArray(e)) throw new Error("[arrayContainsArray] method requires input 'superset' to be an array, got type '".concat((0, i.default)(e), "'"));
                    if (!0 !== Array.isArray(t)) throw new Error("[arrayContainsArray] method requires input 'subset' to be an array, got type '".concat((0, i.default)(t), "'"));
                    return t[r ? "some" : "every"](function(t) {
                        return e.indexOf(t) >= 0;
                    });
                }, t.toAscii = function(e) {
                    var t = "", r = 0, n = e.length;
                    for("0x" === e.substring(0, 2) && (r = 2); r < n; r += 2){
                        var i = parseInt(e.substr(r, 2), 16);
                        t += String.fromCharCode(i);
                    }
                    return t;
                }, t.fromUtf8 = function(e) {
                    var t = n.from(e, "utf8");
                    return "0x".concat(a(t.toString("hex")).replace(/^0+|0+$/g, ""));
                }, t.fromAscii = function(e) {
                    for(var t = "", r = 0; r < e.length; r++){
                        var n = e.charCodeAt(r).toString(16);
                        t += n.length < 2 ? "0".concat(n) : n;
                    }
                    return "0x".concat(t);
                }, t.getKeys = function(e, t, r) {
                    if (!Array.isArray(e)) throw new Error("[getKeys] method expects input 'params' to be an array, got ".concat((0, i.default)(e)));
                    if ("string" != typeof t) throw new Error("[getKeys] method expects input 'key' to be type 'string', got ".concat((0, i.default)(e)));
                    for(var n = [], o = 0; o < e.length; o++){
                        var a = e[o][t];
                        if (r && !a) a = "";
                        else if ("string" != typeof a) throw new Error("invalid abi - expected type 'string', received ".concat((0, i.default)(a)));
                        n.push(a);
                    }
                    return n;
                }, t.isHexString = function(e, t) {
                    return !("string" != typeof e || !e.match(/^0x[0-9A-Fa-f]*$/) || t && e.length !== 2 + 2 * t);
                };
            },
            41677: (e, t, r)=>{
                "use strict";
                var n = r(29033).Buffer, i = r(28847)(r(3355));
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.defineProperties = void 0;
                var o, a = (o = r(3894)) && o.__esModule ? o : {
                    default: o
                }, s = r(23271), u = r(49100), c = r(13464);
                t.defineProperties = function(e, t, r) {
                    if (e.raw = [], e._fields = [], e.toJSON = function(t) {
                        if (void 0 === t && (t = !1), t) {
                            var r = {};
                            return e._fields.forEach(function(t) {
                                r[t] = "0x".concat(e[t].toString("hex"));
                            }), r;
                        }
                        return (0, c.baToJSON)(e.raw);
                    }, e.serialize = function() {
                        return u.rlp.encode(e.raw);
                    }, t.forEach(function(t, r) {
                        function i() {
                            return e.raw[r];
                        }
                        function o(i) {
                            "00" !== (i = (0, c.toBuffer)(i)).toString("hex") || t.allowZero || (i = n.allocUnsafe(0)), t.allowLess && t.length ? (i = (0, c.unpadBuffer)(i), (0, a.default)(t.length >= i.length, "The field ".concat(t.name, " must not have more ").concat(t.length, " bytes"))) : t.allowZero && 0 === i.length || !t.length || (0, a.default)(t.length === i.length, "The field ".concat(t.name, " must have byte length of ").concat(t.length)), e.raw[r] = i;
                        }
                        e._fields.push(t.name), Object.defineProperty(e, t.name, {
                            enumerable: !0,
                            configurable: !0,
                            get: i,
                            set: o
                        }), t.default && (e[t.name] = t.default), t.alias && Object.defineProperty(e, t.alias, {
                            enumerable: !1,
                            configurable: !0,
                            set: o,
                            get: i
                        });
                    }), r) {
                        if ("string" == typeof r && (r = n.from((0, s.stripHexPrefix)(r), "hex")), n.isBuffer(r) && (r = u.rlp.decode(r)), Array.isArray(r)) {
                            if (r.length > e._fields.length) throw new Error("wrong number of fields in data");
                            r.forEach(function(t, r) {
                                e[e._fields[r]] = (0, c.toBuffer)(t);
                            });
                        } else {
                            if ("object" !== (0, i.default)(r)) throw new Error("invalid data");
                            var o = Object.keys(r);
                            t.forEach(function(t) {
                                -1 !== o.indexOf(t.name) && (e[t.name] = r[t.name]), -1 !== o.indexOf(t.alias) && (e[t.alias] = r[t.alias]);
                            });
                        }
                    }
                };
            },
            86081: (e, t, r)=>{
                "use strict";
                var n = r(29033).Buffer;
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.hashPersonalMessage = t.isValidSignature = t.fromRpcSig = t.toCompactSig = t.toRpcSig = t.ecrecover = t.ecsign = void 0;
                var i = r(31439), o = r(49100), a = r(13464), s = r(39808), u = r(5725), c = r(35513);
                function f(e, t) {
                    var r = (0, c.toType)(e, c.TypeOutput.BN);
                    if (r.eqn(0) || r.eqn(1)) return (0, c.toType)(e, c.TypeOutput.BN);
                    if (!t) return r.subn(27);
                    var n = (0, c.toType)(t, c.TypeOutput.BN);
                    return r.sub(n.muln(2).addn(35));
                }
                function d(e) {
                    var t = new o.BN(e);
                    return t.eqn(0) || t.eqn(1);
                }
                t.ecsign = function(e, t, r) {
                    var o = (0, i.ecdsaSign)(e, t), a = o.signature, s = o.recid, u = n.from(a.slice(0, 32)), f = n.from(a.slice(32, 64));
                    if (!r || "number" == typeof r) {
                        if (r && !Number.isSafeInteger(r)) throw new Error("The provided number is greater than MAX_SAFE_INTEGER (please use an alternative input type)");
                        return {
                            r: u,
                            s: f,
                            v: r ? s + (2 * r + 35) : s + 27
                        };
                    }
                    return {
                        r: u,
                        s: f,
                        v: (0, c.toType)(r, c.TypeOutput.BN).muln(2).addn(35).addn(s).toArrayLike(n)
                    };
                }, t.ecrecover = function(e, t, r, o, s) {
                    var u = n.concat([
                        (0, a.setLengthLeft)(r, 32),
                        (0, a.setLengthLeft)(o, 32)
                    ], 64), c = f(t, s);
                    if (!d(c)) throw new Error("Invalid signature v value");
                    var l = (0, i.ecdsaRecover)(u, c.toNumber(), e);
                    return n.from((0, i.publicKeyConvert)(l, !1).slice(1));
                }, t.toRpcSig = function(e, t, r, i) {
                    if (!d(f(e, i))) throw new Error("Invalid signature v value");
                    return (0, a.bufferToHex)(n.concat([
                        (0, a.setLengthLeft)(t, 32),
                        (0, a.setLengthLeft)(r, 32),
                        (0, a.toBuffer)(e)
                    ]));
                }, t.toCompactSig = function(e, t, r, i) {
                    if (!d(f(e, i))) throw new Error("Invalid signature v value");
                    var o = (0, c.toType)(e, c.TypeOutput.Number), s = r;
                    return (o > 28 && o % 2 == 1 || 1 === o || 28 === o) && ((s = n.from(r))[0] |= 128), (0, a.bufferToHex)(n.concat([
                        (0, a.setLengthLeft)(t, 32),
                        (0, a.setLengthLeft)(s, 32)
                    ]));
                }, t.fromRpcSig = function(e) {
                    var t, r, n, i = (0, a.toBuffer)(e);
                    if (i.length >= 65) t = i.slice(0, 32), r = i.slice(32, 64), n = (0, a.bufferToInt)(i.slice(64));
                    else {
                        if (64 !== i.length) throw new Error("Invalid signature length");
                        t = i.slice(0, 32), r = i.slice(32, 64), n = (0, a.bufferToInt)(i.slice(32, 33)) >> 7, r[0] &= 127;
                    }
                    return n < 27 && (n += 27), {
                        v: n,
                        r: t,
                        s: r
                    };
                }, t.isValidSignature = function(e, t, r, n, i) {
                    void 0 === n && (n = !0);
                    var a = new o.BN("7fffffffffffffffffffffffffffffff5d576e7357a4501ddfe92f46681b20a0", 16), s = new o.BN("fffffffffffffffffffffffffffffffebaaedce6af48a03bbfd25e8cd0364141", 16);
                    if (32 !== t.length || 32 !== r.length) return !1;
                    if (!d(f(e, i))) return !1;
                    var u = new o.BN(t), c = new o.BN(r);
                    return !(u.isZero() || u.gt(s) || c.isZero() || c.gt(s) || n && 1 === c.cmp(a));
                }, t.hashPersonalMessage = function(e) {
                    (0, u.assertIsBuffer)(e);
                    var t = n.from("\x19Ethereum Signed Message:\n".concat(e.length), "utf-8");
                    return (0, s.keccak)(n.concat([
                        t,
                        e
                    ]));
                };
            },
            35513: (e, t, r)=>{
                "use strict";
                var n = r(29033).Buffer;
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.toType = t.TypeOutput = t.bnToRlp = t.bnToUnpaddedBuffer = t.bnToHex = void 0;
                var i, o = r(49100), a = r(23271), s = r(13464);
                function u(e) {
                    return (0, s.unpadBuffer)(e.toArrayLike(n));
                }
                t.bnToHex = function(e) {
                    return "0x".concat(e.toString(16));
                }, t.bnToUnpaddedBuffer = u, t.bnToRlp = function(e) {
                    return u(e);
                }, function(e) {
                    e[e.Number = 0] = "Number", e[e.BN = 1] = "BN", e[e.Buffer = 2] = "Buffer", e[e.PrefixedHexString = 3] = "PrefixedHexString";
                }(i = t.TypeOutput || (t.TypeOutput = {})), t.toType = function(e, t) {
                    if (null === e) return null;
                    if (void 0 !== e) {
                        if ("string" == typeof e && !(0, a.isHexString)(e)) throw new Error("A string must be provided with a 0x-prefix, given: ".concat(e));
                        if ("number" == typeof e && !Number.isSafeInteger(e)) throw new Error("The provided number is greater than MAX_SAFE_INTEGER (please use an alternative input type)");
                        var r = (0, s.toBuffer)(e);
                        if (t === i.Buffer) return r;
                        if (t === i.BN) return new o.BN(r);
                        if (t === i.Number) {
                            var n = new o.BN(r), u = new o.BN(Number.MAX_SAFE_INTEGER.toString());
                            if (n.gt(u)) throw new Error("The provided number is greater than MAX_SAFE_INTEGER (please use an alternative output type)");
                            return n.toNumber();
                        }
                        return "0x".concat(r.toString("hex"));
                    }
                };
            },
            73303: (e, t, r)=>{
                "use strict";
                var n = r(29033).Buffer;
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.createHashFunction = function(e) {
                    return function(t) {
                        var r = e();
                        return r.update(t), n.from(r.digest());
                    };
                };
            },
            8235: (e, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                });
                var n = r(73303), i = r(93135);
                t.keccak224 = n.createHashFunction(function() {
                    return i("keccak224");
                }), t.keccak256 = n.createHashFunction(function() {
                    return i("keccak256");
                }), t.keccak384 = n.createHashFunction(function() {
                    return i("keccak384");
                }), t.keccak512 = n.createHashFunction(function() {
                    return i("keccak512");
                });
            },
            40739: (e, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                });
                var n = r(75010);
                t.getRandomBytes = function(e) {
                    return new Promise(function(t, r) {
                        n(e, function(e, n) {
                            e ? r(e) : t(n);
                        });
                    });
                }, t.getRandomBytesSync = function(e) {
                    return n(e);
                };
            },
            31439: (e, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                });
                var n = r(57902), i = r(40739);
                t.createPrivateKey = function() {
                    var e, t, r, o;
                    return e = this, t = void 0, o = function() {
                        var e;
                        return function(e, t) {
                            var r, n, i, o, a = {
                                label: 0,
                                sent: function() {
                                    if (1 & i[0]) throw i[1];
                                    return i[1];
                                },
                                trys: [],
                                ops: []
                            };
                            return o = {
                                next: s(0),
                                throw: s(1),
                                return: s(2)
                            }, "function" == typeof Symbol && (o[Symbol.iterator] = function() {
                                return this;
                            }), o;
                            function s(o) {
                                return function(s) {
                                    return function(o) {
                                        if (r) throw new TypeError("Generator is already executing.");
                                        for(; a;)try {
                                            if (r = 1, n && (i = 2 & o[0] ? n.return : o[0] ? n.throw || ((i = n.return) && i.call(n), 0) : n.next) && !(i = i.call(n, o[1])).done) return i;
                                            switch(n = 0, i && (o = [
                                                2 & o[0],
                                                i.value
                                            ]), o[0]){
                                                case 0:
                                                case 1:
                                                    i = o;
                                                    break;
                                                case 4:
                                                    return a.label++, {
                                                        value: o[1],
                                                        done: !1
                                                    };
                                                case 5:
                                                    a.label++, n = o[1], o = [
                                                        0
                                                    ];
                                                    continue;
                                                case 7:
                                                    o = a.ops.pop(), a.trys.pop();
                                                    continue;
                                                default:
                                                    if (!((i = (i = a.trys).length > 0 && i[i.length - 1]) || 6 !== o[0] && 2 !== o[0])) {
                                                        a = 0;
                                                        continue;
                                                    }
                                                    if (3 === o[0] && (!i || o[1] > i[0] && o[1] < i[3])) {
                                                        a.label = o[1];
                                                        break;
                                                    }
                                                    if (6 === o[0] && a.label < i[1]) {
                                                        a.label = i[1], i = o;
                                                        break;
                                                    }
                                                    if (i && a.label < i[2]) {
                                                        a.label = i[2], a.ops.push(o);
                                                        break;
                                                    }
                                                    i[2] && a.ops.pop(), a.trys.pop();
                                                    continue;
                                            }
                                            o = t.call(e, a);
                                        } catch (e) {
                                            o = [
                                                6,
                                                e
                                            ], n = 0;
                                        } finally{
                                            r = i = 0;
                                        }
                                        if (5 & o[0]) throw o[1];
                                        return {
                                            value: o[0] ? o[1] : void 0,
                                            done: !0
                                        };
                                    }([
                                        o,
                                        s
                                    ]);
                                };
                            }
                        }(this, function(t) {
                            switch(t.label){
                                case 0:
                                    return [
                                        4,
                                        i.getRandomBytes(32)
                                    ];
                                case 1:
                                    return e = t.sent(), n.privateKeyVerify(e) ? [
                                        2,
                                        e
                                    ] : [
                                        3,
                                        0
                                    ];
                                case 2:
                                    return [
                                        2
                                    ];
                            }
                        });
                    }, new (r = void 0, r = Promise)(function(n, i) {
                        function a(e) {
                            try {
                                u(o.next(e));
                            } catch (e) {
                                i(e);
                            }
                        }
                        function s(e) {
                            try {
                                u(o.throw(e));
                            } catch (e) {
                                i(e);
                            }
                        }
                        function u(e) {
                            var t;
                            e.done ? n(e.value) : (t = e.value, t instanceof r ? t : new r(function(e) {
                                e(t);
                            })).then(a, s);
                        }
                        u((o = o.apply(e, t || [])).next());
                    });
                }, t.createPrivateKeySync = function() {
                    for(;;){
                        var e = i.getRandomBytesSync(32);
                        if (n.privateKeyVerify(e)) return e;
                    }
                }, function(e) {
                    for(var r in e)t.hasOwnProperty(r) || (t[r] = e[r]);
                }(r(57902));
            },
            17130: (e, t, r)=>{
                "use strict";
                var n = r(28847)(r(3355)), i = r(31734), o = r(77277), a = new i(0), s = new i(-1), u = {
                    noether: "0",
                    wei: "1",
                    kwei: "1000",
                    Kwei: "1000",
                    babbage: "1000",
                    femtoether: "1000",
                    mwei: "1000000",
                    Mwei: "1000000",
                    lovelace: "1000000",
                    picoether: "1000000",
                    gwei: "1000000000",
                    Gwei: "1000000000",
                    shannon: "1000000000",
                    nanoether: "1000000000",
                    nano: "1000000000",
                    szabo: "1000000000000",
                    microether: "1000000000000",
                    micro: "1000000000000",
                    finney: "1000000000000000",
                    milliether: "1000000000000000",
                    milli: "1000000000000000",
                    ether: "1000000000000000000",
                    kether: "1000000000000000000000",
                    grand: "1000000000000000000000",
                    mether: "1000000000000000000000000",
                    gether: "1000000000000000000000000000",
                    tether: "1000000000000000000000000000000"
                };
                function c(e) {
                    var t = e ? e.toLowerCase() : "ether", r = u[t];
                    if ("string" != typeof r) throw new Error("[ethjs-unit] the unit provided " + e + " doesn't exists, please use the one of the following units " + JSON.stringify(u, null, 2));
                    return new i(r, 10);
                }
                function f(e) {
                    if ("string" == typeof e) {
                        if (!e.match(/^-?[0-9.]+$/)) throw new Error("while converting number to string, invalid number value '" + e + "', should be a number matching (^-?[0-9.]+).");
                        return e;
                    }
                    if ("number" == typeof e) return String(e);
                    if ("object" === (0, n.default)(e) && e.toString && (e.toTwos || e.dividedToIntegerBy)) return e.toPrecision ? String(e.toPrecision()) : e.toString(10);
                    throw new Error("while converting number to string, invalid number value '" + e + "' type " + (0, n.default)(e) + ".");
                }
                e.exports = {
                    unitMap: u,
                    numberToString: f,
                    getValueOfUnit: c,
                    fromWei: function(e, t, r) {
                        var n = o(e), i = n.lt(a), f = c(t), d = u[t].length - 1 || 1, l = r || {};
                        i && (n = n.mul(s));
                        for(var h = n.mod(f).toString(10); h.length < d;)h = "0" + h;
                        l.pad || (h = h.match(/^([0-9]*[1-9]|0)(0*)/)[1]);
                        var p = n.div(f).toString(10);
                        l.commify && (p = p.replace(/\B(?=(\d{3})+(?!\d))/g, ","));
                        var b = p + ("0" == h ? "" : "." + h);
                        return i && (b = "-" + b), b;
                    },
                    toWei: function(e, t) {
                        var r = f(e), n = c(t), o = u[t].length - 1 || 1, a = "-" === r.substring(0, 1);
                        if (a && (r = r.substring(1)), "." === r) throw new Error("[ethjs-unit] while converting number " + e + " to wei, invalid value");
                        var d = r.split(".");
                        if (d.length > 2) throw new Error("[ethjs-unit] while converting number " + e + " to wei,  too many decimal points");
                        var l = d[0], h = d[1];
                        if (l || (l = "0"), h || (h = "0"), h.length > o) throw new Error("[ethjs-unit] while converting number " + e + " to wei, too many decimal places");
                        for(; h.length < o;)h += "0";
                        l = new i(l), h = new i(h);
                        var p = l.mul(n).add(h);
                        return a && (p = p.mul(s)), new i(p.toString(10), 10);
                    }
                };
            },
            98008: (e)=>{
                "use strict";
                var t = Object.prototype.hasOwnProperty, r = "~";
                function n() {}
                function i(e, t, r) {
                    this.fn = e, this.context = t, this.once = r || !1;
                }
                function o(e, t, n, o, a) {
                    if ("function" != typeof n) throw new TypeError("The listener must be a function");
                    var s = new i(n, o || e, a), u = r ? r + t : t;
                    return e._events[u] ? e._events[u].fn ? e._events[u] = [
                        e._events[u],
                        s
                    ] : e._events[u].push(s) : (e._events[u] = s, e._eventsCount++), e;
                }
                function a(e, t) {
                    0 == --e._eventsCount ? e._events = new n : delete e._events[t];
                }
                function s() {
                    this._events = new n, this._eventsCount = 0;
                }
                Object.create && (n.prototype = Object.create(null), (new n).__proto__ || (r = !1)), s.prototype.eventNames = function() {
                    var e, n, i = [];
                    if (0 === this._eventsCount) return i;
                    for(n in e = this._events)t.call(e, n) && i.push(r ? n.slice(1) : n);
                    return Object.getOwnPropertySymbols ? i.concat(Object.getOwnPropertySymbols(e)) : i;
                }, s.prototype.listeners = function(e) {
                    var t = r ? r + e : e, n = this._events[t];
                    if (!n) return [];
                    if (n.fn) return [
                        n.fn
                    ];
                    for(var i = 0, o = n.length, a = new Array(o); i < o; i++)a[i] = n[i].fn;
                    return a;
                }, s.prototype.listenerCount = function(e) {
                    var t = r ? r + e : e, n = this._events[t];
                    return n ? n.fn ? 1 : n.length : 0;
                }, s.prototype.emit = function(e, t, n, i, o, a) {
                    var s = r ? r + e : e;
                    if (!this._events[s]) return !1;
                    var u, c, f = this._events[s], d = arguments.length;
                    if (f.fn) {
                        switch(f.once && this.removeListener(e, f.fn, void 0, !0), d){
                            case 1:
                                return f.fn.call(f.context), !0;
                            case 2:
                                return f.fn.call(f.context, t), !0;
                            case 3:
                                return f.fn.call(f.context, t, n), !0;
                            case 4:
                                return f.fn.call(f.context, t, n, i), !0;
                            case 5:
                                return f.fn.call(f.context, t, n, i, o), !0;
                            case 6:
                                return f.fn.call(f.context, t, n, i, o, a), !0;
                        }
                        for(c = 1, u = new Array(d - 1); c < d; c++)u[c - 1] = arguments[c];
                        f.fn.apply(f.context, u);
                    } else {
                        var l, h = f.length;
                        for(c = 0; c < h; c++)switch(f[c].once && this.removeListener(e, f[c].fn, void 0, !0), d){
                            case 1:
                                f[c].fn.call(f[c].context);
                                break;
                            case 2:
                                f[c].fn.call(f[c].context, t);
                                break;
                            case 3:
                                f[c].fn.call(f[c].context, t, n);
                                break;
                            case 4:
                                f[c].fn.call(f[c].context, t, n, i);
                                break;
                            default:
                                if (!u) for(l = 1, u = new Array(d - 1); l < d; l++)u[l - 1] = arguments[l];
                                f[c].fn.apply(f[c].context, u);
                        }
                    }
                    return !0;
                }, s.prototype.on = function(e, t, r) {
                    return o(this, e, t, r, !1);
                }, s.prototype.once = function(e, t, r) {
                    return o(this, e, t, r, !0);
                }, s.prototype.removeListener = function(e, t, n, i) {
                    var o = r ? r + e : e;
                    if (!this._events[o]) return this;
                    if (!t) return a(this, o), this;
                    var s = this._events[o];
                    if (s.fn) s.fn !== t || i && !s.once || n && s.context !== n || a(this, o);
                    else {
                        for(var u = 0, c = [], f = s.length; u < f; u++)(s[u].fn !== t || i && !s[u].once || n && s[u].context !== n) && c.push(s[u]);
                        c.length ? this._events[o] = 1 === c.length ? c[0] : c : a(this, o);
                    }
                    return this;
                }, s.prototype.removeAllListeners = function(e) {
                    var t;
                    return e ? (t = r ? r + e : e, this._events[t] && a(this, t)) : (this._events = new n, this._eventsCount = 0), this;
                }, s.prototype.off = s.prototype.removeListener, s.prototype.addListener = s.prototype.on, s.prefixed = r, s.EventEmitter = s, e.exports = s;
            },
            38291: (e, t, r)=>{
                "use strict";
                var n = r(28847)(r(3355)), i = Object.create || function(e) {
                    var t = function() {};
                    return t.prototype = e, new t;
                }, o = Object.keys || function(e) {
                    var t = [];
                    for(var r in e)Object.prototype.hasOwnProperty.call(e, r) && t.push(r);
                    return r;
                }, a = Function.prototype.bind || function(e) {
                    var t = this;
                    return function() {
                        return t.apply(e, arguments);
                    };
                };
                function s() {
                    this._events && Object.prototype.hasOwnProperty.call(this, "_events") || (this._events = i(null), this._eventsCount = 0), this._maxListeners = this._maxListeners || void 0;
                }
                e.exports = s, s.EventEmitter = s, s.prototype._events = void 0, s.prototype._maxListeners = void 0;
                var u, c = 10;
                try {
                    var f = {};
                    Object.defineProperty && Object.defineProperty(f, "x", {
                        value: 0
                    }), u = 0 === f.x;
                } catch (e) {
                    u = !1;
                }
                function d(e) {
                    return void 0 === e._maxListeners ? s.defaultMaxListeners : e._maxListeners;
                }
                function l(e, t, r, o) {
                    var a, s, u;
                    if ("function" != typeof r) throw new TypeError('"listener" argument must be a function');
                    if ((s = e._events) ? (s.newListener && (e.emit("newListener", t, r.listener ? r.listener : r), s = e._events), u = s[t]) : (s = e._events = i(null), e._eventsCount = 0), u) {
                        if ("function" == typeof u ? u = s[t] = o ? [
                            r,
                            u
                        ] : [
                            u,
                            r
                        ] : o ? u.unshift(r) : u.push(r), !u.warned && (a = d(e)) && a > 0 && u.length > a) {
                            u.warned = !0;
                            var c = new Error("Possible EventEmitter memory leak detected. " + u.length + ' "' + String(t) + '" listeners added. Use emitter.setMaxListeners() to increase limit.');
                            c.name = "MaxListenersExceededWarning", c.emitter = e, c.type = t, c.count = u.length, "object" === ("undefined" == typeof console ? "undefined" : (0, n.default)(console)) && console.warn && console.warn("%s: %s", c.name, c.message);
                        }
                    } else u = s[t] = r, ++e._eventsCount;
                    return e;
                }
                function h() {
                    if (!this.fired) switch(this.target.removeListener(this.type, this.wrapFn), this.fired = !0, arguments.length){
                        case 0:
                            return this.listener.call(this.target);
                        case 1:
                            return this.listener.call(this.target, arguments[0]);
                        case 2:
                            return this.listener.call(this.target, arguments[0], arguments[1]);
                        case 3:
                            return this.listener.call(this.target, arguments[0], arguments[1], arguments[2]);
                        default:
                            for(var e = new Array(arguments.length), t = 0; t < e.length; ++t)e[t] = arguments[t];
                            this.listener.apply(this.target, e);
                    }
                }
                function p(e, t, r) {
                    var n = {
                        fired: !1,
                        wrapFn: void 0,
                        target: e,
                        type: t,
                        listener: r
                    }, i = a.call(h, n);
                    return i.listener = r, n.wrapFn = i, i;
                }
                function b(e, t, r) {
                    var n = e._events;
                    if (!n) return [];
                    var i = n[t];
                    return i ? "function" == typeof i ? r ? [
                        i.listener || i
                    ] : [
                        i
                    ] : r ? function(e) {
                        for(var t = new Array(e.length), r = 0; r < t.length; ++r)t[r] = e[r].listener || e[r];
                        return t;
                    }(i) : v(i, i.length) : [];
                }
                function y(e) {
                    var t = this._events;
                    if (t) {
                        var r = t[e];
                        if ("function" == typeof r) return 1;
                        if (r) return r.length;
                    }
                    return 0;
                }
                function v(e, t) {
                    for(var r = new Array(t), n = 0; n < t; ++n)r[n] = e[n];
                    return r;
                }
                u ? Object.defineProperty(s, "defaultMaxListeners", {
                    enumerable: !0,
                    get: function() {
                        return c;
                    },
                    set: function(e) {
                        if ("number" != typeof e || e < 0 || e != e) throw new TypeError('"defaultMaxListeners" must be a positive number');
                        c = e;
                    }
                }) : s.defaultMaxListeners = c, s.prototype.setMaxListeners = function(e) {
                    if ("number" != typeof e || e < 0 || isNaN(e)) throw new TypeError('"n" argument must be a positive number');
                    return this._maxListeners = e, this;
                }, s.prototype.getMaxListeners = function() {
                    return d(this);
                }, s.prototype.emit = function(e) {
                    var t, r, n, i, o, a, s = "error" === e;
                    if (a = this._events) s = s && null == a.error;
                    else if (!s) return !1;
                    if (s) {
                        if (arguments.length > 1 && (t = arguments[1]), t instanceof Error) throw t;
                        var u = new Error('Unhandled "error" event. (' + t + ")");
                        throw u.context = t, u;
                    }
                    if (!(r = a[e])) return !1;
                    var c = "function" == typeof r;
                    switch(n = arguments.length){
                        case 1:
                            !function(e, t, r) {
                                if (t) e.call(r);
                                else for(var n = e.length, i = v(e, n), o = 0; o < n; ++o)i[o].call(r);
                            }(r, c, this);
                            break;
                        case 2:
                            !function(e, t, r, n) {
                                if (t) e.call(r, n);
                                else for(var i = e.length, o = v(e, i), a = 0; a < i; ++a)o[a].call(r, n);
                            }(r, c, this, arguments[1]);
                            break;
                        case 3:
                            !function(e, t, r, n, i) {
                                if (t) e.call(r, n, i);
                                else for(var o = e.length, a = v(e, o), s = 0; s < o; ++s)a[s].call(r, n, i);
                            }(r, c, this, arguments[1], arguments[2]);
                            break;
                        case 4:
                            !function(e, t, r, n, i, o) {
                                if (t) e.call(r, n, i, o);
                                else for(var a = e.length, s = v(e, a), u = 0; u < a; ++u)s[u].call(r, n, i, o);
                            }(r, c, this, arguments[1], arguments[2], arguments[3]);
                            break;
                        default:
                            for(i = new Array(n - 1), o = 1; o < n; o++)i[o - 1] = arguments[o];
                            !function(e, t, r, n) {
                                if (t) e.apply(r, n);
                                else for(var i = e.length, o = v(e, i), a = 0; a < i; ++a)o[a].apply(r, n);
                            }(r, c, this, i);
                    }
                    return !0;
                }, s.prototype.addListener = function(e, t) {
                    return l(this, e, t, !1);
                }, s.prototype.on = s.prototype.addListener, s.prototype.prependListener = function(e, t) {
                    return l(this, e, t, !0);
                }, s.prototype.once = function(e, t) {
                    if ("function" != typeof t) throw new TypeError('"listener" argument must be a function');
                    return this.on(e, p(this, e, t)), this;
                }, s.prototype.prependOnceListener = function(e, t) {
                    if ("function" != typeof t) throw new TypeError('"listener" argument must be a function');
                    return this.prependListener(e, p(this, e, t)), this;
                }, s.prototype.removeListener = function(e, t) {
                    var r, n, o, a, s;
                    if ("function" != typeof t) throw new TypeError('"listener" argument must be a function');
                    if (!(n = this._events)) return this;
                    if (!(r = n[e])) return this;
                    if (r === t || r.listener === t) 0 == --this._eventsCount ? this._events = i(null) : (delete n[e], n.removeListener && this.emit("removeListener", e, r.listener || t));
                    else if ("function" != typeof r) {
                        for(o = -1, a = r.length - 1; a >= 0; a--)if (r[a] === t || r[a].listener === t) {
                            s = r[a].listener, o = a;
                            break;
                        }
                        if (o < 0) return this;
                        0 === o ? r.shift() : function(e, t) {
                            for(var r = t, n = r + 1, i = e.length; n < i; r += 1, n += 1)e[r] = e[n];
                            e.pop();
                        }(r, o), 1 === r.length && (n[e] = r[0]), n.removeListener && this.emit("removeListener", e, s || t);
                    }
                    return this;
                }, s.prototype.removeAllListeners = function(e) {
                    var t, r, n;
                    if (!(r = this._events)) return this;
                    if (!r.removeListener) return 0 === arguments.length ? (this._events = i(null), this._eventsCount = 0) : r[e] && (0 == --this._eventsCount ? this._events = i(null) : delete r[e]), this;
                    if (0 === arguments.length) {
                        var a, s = o(r);
                        for(n = 0; n < s.length; ++n)"removeListener" !== (a = s[n]) && this.removeAllListeners(a);
                        return this.removeAllListeners("removeListener"), this._events = i(null), this._eventsCount = 0, this;
                    }
                    if ("function" == typeof (t = r[e])) this.removeListener(e, t);
                    else if (t) for(n = t.length - 1; n >= 0; n--)this.removeListener(e, t[n]);
                    return this;
                }, s.prototype.listeners = function(e) {
                    return b(this, e, !0);
                }, s.prototype.rawListeners = function(e) {
                    return b(this, e, !1);
                }, s.listenerCount = function(e, t) {
                    return "function" == typeof e.listenerCount ? e.listenerCount(t) : y.call(e, t);
                }, s.prototype.listenerCount = y, s.prototype.eventNames = function() {
                    return this._eventsCount > 0 ? Reflect.ownKeys(this._events) : [];
                };
            },
            27085: (e, t, r)=>{
                "use strict";
                var n = r(48850).Buffer, i = r(50807);
                e.exports = function(e, t, r, o) {
                    if (n.isBuffer(e) || (e = n.from(e, "binary")), t && (n.isBuffer(t) || (t = n.from(t, "binary")), 8 !== t.length)) throw new RangeError("salt should be Buffer with 8 byte length");
                    for(var a = r / 8, s = n.alloc(a), u = n.alloc(o || 0), c = n.alloc(0); a > 0 || o > 0;){
                        var f = new i;
                        f.update(c), f.update(e), t && f.update(t), c = f.digest();
                        var d = 0;
                        if (a > 0) {
                            var l = s.length - a;
                            d = Math.min(a, c.length), c.copy(s, l, 0, d), a -= d;
                        }
                        if (d < c.length && o > 0) {
                            var h = u.length - o, p = Math.min(o, c.length - d);
                            c.copy(u, h, d, d + p), o -= p;
                        }
                    }
                    return c.fill(0), {
                        key: s,
                        iv: u
                    };
                };
            },
            48184: (e, t, r)=>{
                "use strict";
                var n = r(41493), i = Object.prototype.toString, o = Object.prototype.hasOwnProperty;
                e.exports = function(e, t, r) {
                    if (!n(t)) throw new TypeError("iterator must be a function");
                    var a;
                    arguments.length >= 3 && (a = r), "[object Array]" === i.call(e) ? function(e, t, r) {
                        for(var n = 0, i = e.length; n < i; n++)o.call(e, n) && (null == r ? t(e[n], n, e) : t.call(r, e[n], n, e));
                    }(e, t, a) : "string" == typeof e ? function(e, t, r) {
                        for(var n = 0, i = e.length; n < i; n++)null == r ? t(e.charAt(n), n, e) : t.call(r, e.charAt(n), n, e);
                    }(e, t, a) : function(e, t, r) {
                        for(var n in e)o.call(e, n) && (null == r ? t(e[n], n, e) : t.call(r, e[n], n, e));
                    }(e, t, a);
                };
            },
            83161: (e)=>{
                "use strict";
                var t = Object.prototype.toString, r = Math.max, n = function(e, t) {
                    for(var r = [], n = 0; n < e.length; n += 1)r[n] = e[n];
                    for(var i = 0; i < t.length; i += 1)r[i + e.length] = t[i];
                    return r;
                };
                e.exports = function(e) {
                    var i = this;
                    if ("function" != typeof i || "[object Function]" !== t.apply(i)) throw new TypeError("Function.prototype.bind called on incompatible " + i);
                    for(var o, a = function(e, t) {
                        for(var r = [], n = 1, i = 0; n < e.length; n += 1, i += 1)r[i] = e[n];
                        return r;
                    }(arguments), s = r(0, i.length - a.length), u = [], c = 0; c < s; c++)u[c] = "$" + c;
                    if (o = Function("binder", "return function (" + function(e, t) {
                        for(var r = "", n = 0; n < e.length; n += 1)r += e[n], n + 1 < e.length && (r += ",");
                        return r;
                    }(u) + "){ return binder.apply(this,arguments); }")(function() {
                        if (this instanceof o) {
                            var t = i.apply(this, n(a, arguments));
                            return Object(t) === t ? t : this;
                        }
                        return i.apply(e, n(a, arguments));
                    }), i.prototype) {
                        var f = function() {};
                        f.prototype = i.prototype, o.prototype = new f, f.prototype = null;
                    }
                    return o;
                };
            },
            3767: (e, t, r)=>{
                "use strict";
                var n = r(83161);
                e.exports = Function.prototype.bind || n;
            },
            57701: (e, t, r)=>{
                "use strict";
                var n, i = r(28847)(r(3355)), o = SyntaxError, a = Function, s = TypeError, u = function(e) {
                    try {
                        return a('"use strict"; return (' + e + ").constructor;")();
                    } catch (e) {}
                }, c = Object.getOwnPropertyDescriptor;
                if (c) try {
                    c({}, "");
                } catch (e) {
                    c = null;
                }
                var f = function() {
                    throw new s;
                }, d = c ? function() {
                    try {
                        return f;
                    } catch (e) {
                        try {
                            return c(arguments, "callee").get;
                        } catch (e) {
                            return f;
                        }
                    }
                }() : f, l = r(58489)(), h = r(61593)(), p = Object.getPrototypeOf || (h ? function(e) {
                    return e.__proto__;
                } : null), b = {}, y = "undefined" != typeof Uint8Array && p ? p(Uint8Array) : n, v = {
                    "%AggregateError%": "undefined" == typeof AggregateError ? n : AggregateError,
                    "%Array%": Array,
                    "%ArrayBuffer%": "undefined" == typeof ArrayBuffer ? n : ArrayBuffer,
                    "%ArrayIteratorPrototype%": l && p ? p([][Symbol.iterator]()) : n,
                    "%AsyncFromSyncIteratorPrototype%": n,
                    "%AsyncFunction%": b,
                    "%AsyncGenerator%": b,
                    "%AsyncGeneratorFunction%": b,
                    "%AsyncIteratorPrototype%": b,
                    "%Atomics%": "undefined" == typeof Atomics ? n : Atomics,
                    "%BigInt%": "undefined" == typeof BigInt ? n : BigInt,
                    "%BigInt64Array%": "undefined" == typeof BigInt64Array ? n : BigInt64Array,
                    "%BigUint64Array%": "undefined" == typeof BigUint64Array ? n : BigUint64Array,
                    "%Boolean%": Boolean,
                    "%DataView%": "undefined" == typeof DataView ? n : DataView,
                    "%Date%": Date,
                    "%decodeURI%": decodeURI,
                    "%decodeURIComponent%": decodeURIComponent,
                    "%encodeURI%": encodeURI,
                    "%encodeURIComponent%": encodeURIComponent,
                    "%Error%": Error,
                    "%eval%": eval,
                    "%EvalError%": EvalError,
                    "%Float32Array%": "undefined" == typeof Float32Array ? n : Float32Array,
                    "%Float64Array%": "undefined" == typeof Float64Array ? n : Float64Array,
                    "%FinalizationRegistry%": "undefined" == typeof FinalizationRegistry ? n : FinalizationRegistry,
                    "%Function%": a,
                    "%GeneratorFunction%": b,
                    "%Int8Array%": "undefined" == typeof Int8Array ? n : Int8Array,
                    "%Int16Array%": "undefined" == typeof Int16Array ? n : Int16Array,
                    "%Int32Array%": "undefined" == typeof Int32Array ? n : Int32Array,
                    "%isFinite%": isFinite,
                    "%isNaN%": isNaN,
                    "%IteratorPrototype%": l && p ? p(p([][Symbol.iterator]())) : n,
                    "%JSON%": "object" === ("undefined" == typeof JSON ? "undefined" : (0, i.default)(JSON)) ? JSON : n,
                    "%Map%": "undefined" == typeof Map ? n : Map,
                    "%MapIteratorPrototype%": "undefined" != typeof Map && l && p ? p((new Map)[Symbol.iterator]()) : n,
                    "%Math%": Math,
                    "%Number%": Number,
                    "%Object%": Object,
                    "%parseFloat%": parseFloat,
                    "%parseInt%": parseInt,
                    "%Promise%": "undefined" == typeof Promise ? n : Promise,
                    "%Proxy%": "undefined" == typeof Proxy ? n : Proxy,
                    "%RangeError%": RangeError,
                    "%ReferenceError%": ReferenceError,
                    "%Reflect%": "undefined" == typeof Reflect ? n : Reflect,
                    "%RegExp%": RegExp,
                    "%Set%": "undefined" == typeof Set ? n : Set,
                    "%SetIteratorPrototype%": "undefined" != typeof Set && l && p ? p((new Set)[Symbol.iterator]()) : n,
                    "%SharedArrayBuffer%": "undefined" == typeof SharedArrayBuffer ? n : SharedArrayBuffer,
                    "%String%": String,
                    "%StringIteratorPrototype%": l && p ? p(""[Symbol.iterator]()) : n,
                    "%Symbol%": l ? Symbol : n,
                    "%SyntaxError%": o,
                    "%ThrowTypeError%": d,
                    "%TypedArray%": y,
                    "%TypeError%": s,
                    "%Uint8Array%": "undefined" == typeof Uint8Array ? n : Uint8Array,
                    "%Uint8ClampedArray%": "undefined" == typeof Uint8ClampedArray ? n : Uint8ClampedArray,
                    "%Uint16Array%": "undefined" == typeof Uint16Array ? n : Uint16Array,
                    "%Uint32Array%": "undefined" == typeof Uint32Array ? n : Uint32Array,
                    "%URIError%": URIError,
                    "%WeakMap%": "undefined" == typeof WeakMap ? n : WeakMap,
                    "%WeakRef%": "undefined" == typeof WeakRef ? n : WeakRef,
                    "%WeakSet%": "undefined" == typeof WeakSet ? n : WeakSet
                };
                if (p) try {
                    null.error;
                } catch (e) {
                    var m = p(p(e));
                    v["%Error.prototype%"] = m;
                }
                var g = function e(t) {
                    var r;
                    if ("%AsyncFunction%" === t) r = u("async function () {}");
                    else if ("%GeneratorFunction%" === t) r = u("function* () {}");
                    else if ("%AsyncGeneratorFunction%" === t) r = u("async function* () {}");
                    else if ("%AsyncGenerator%" === t) {
                        var n = e("%AsyncGeneratorFunction%");
                        n && (r = n.prototype);
                    } else if ("%AsyncIteratorPrototype%" === t) {
                        var i = e("%AsyncGenerator%");
                        i && p && (r = p(i.prototype));
                    }
                    return v[t] = r, r;
                }, w = {
                    "%ArrayBufferPrototype%": [
                        "ArrayBuffer",
                        "prototype"
                    ],
                    "%ArrayPrototype%": [
                        "Array",
                        "prototype"
                    ],
                    "%ArrayProto_entries%": [
                        "Array",
                        "prototype",
                        "entries"
                    ],
                    "%ArrayProto_forEach%": [
                        "Array",
                        "prototype",
                        "forEach"
                    ],
                    "%ArrayProto_keys%": [
                        "Array",
                        "prototype",
                        "keys"
                    ],
                    "%ArrayProto_values%": [
                        "Array",
                        "prototype",
                        "values"
                    ],
                    "%AsyncFunctionPrototype%": [
                        "AsyncFunction",
                        "prototype"
                    ],
                    "%AsyncGenerator%": [
                        "AsyncGeneratorFunction",
                        "prototype"
                    ],
                    "%AsyncGeneratorPrototype%": [
                        "AsyncGeneratorFunction",
                        "prototype",
                        "prototype"
                    ],
                    "%BooleanPrototype%": [
                        "Boolean",
                        "prototype"
                    ],
                    "%DataViewPrototype%": [
                        "DataView",
                        "prototype"
                    ],
                    "%DatePrototype%": [
                        "Date",
                        "prototype"
                    ],
                    "%ErrorPrototype%": [
                        "Error",
                        "prototype"
                    ],
                    "%EvalErrorPrototype%": [
                        "EvalError",
                        "prototype"
                    ],
                    "%Float32ArrayPrototype%": [
                        "Float32Array",
                        "prototype"
                    ],
                    "%Float64ArrayPrototype%": [
                        "Float64Array",
                        "prototype"
                    ],
                    "%FunctionPrototype%": [
                        "Function",
                        "prototype"
                    ],
                    "%Generator%": [
                        "GeneratorFunction",
                        "prototype"
                    ],
                    "%GeneratorPrototype%": [
                        "GeneratorFunction",
                        "prototype",
                        "prototype"
                    ],
                    "%Int8ArrayPrototype%": [
                        "Int8Array",
                        "prototype"
                    ],
                    "%Int16ArrayPrototype%": [
                        "Int16Array",
                        "prototype"
                    ],
                    "%Int32ArrayPrototype%": [
                        "Int32Array",
                        "prototype"
                    ],
                    "%JSONParse%": [
                        "JSON",
                        "parse"
                    ],
                    "%JSONStringify%": [
                        "JSON",
                        "stringify"
                    ],
                    "%MapPrototype%": [
                        "Map",
                        "prototype"
                    ],
                    "%NumberPrototype%": [
                        "Number",
                        "prototype"
                    ],
                    "%ObjectPrototype%": [
                        "Object",
                        "prototype"
                    ],
                    "%ObjProto_toString%": [
                        "Object",
                        "prototype",
                        "toString"
                    ],
                    "%ObjProto_valueOf%": [
                        "Object",
                        "prototype",
                        "valueOf"
                    ],
                    "%PromisePrototype%": [
                        "Promise",
                        "prototype"
                    ],
                    "%PromiseProto_then%": [
                        "Promise",
                        "prototype",
                        "then"
                    ],
                    "%Promise_all%": [
                        "Promise",
                        "all"
                    ],
                    "%Promise_reject%": [
                        "Promise",
                        "reject"
                    ],
                    "%Promise_resolve%": [
                        "Promise",
                        "resolve"
                    ],
                    "%RangeErrorPrototype%": [
                        "RangeError",
                        "prototype"
                    ],
                    "%ReferenceErrorPrototype%": [
                        "ReferenceError",
                        "prototype"
                    ],
                    "%RegExpPrototype%": [
                        "RegExp",
                        "prototype"
                    ],
                    "%SetPrototype%": [
                        "Set",
                        "prototype"
                    ],
                    "%SharedArrayBufferPrototype%": [
                        "SharedArrayBuffer",
                        "prototype"
                    ],
                    "%StringPrototype%": [
                        "String",
                        "prototype"
                    ],
                    "%SymbolPrototype%": [
                        "Symbol",
                        "prototype"
                    ],
                    "%SyntaxErrorPrototype%": [
                        "SyntaxError",
                        "prototype"
                    ],
                    "%TypedArrayPrototype%": [
                        "TypedArray",
                        "prototype"
                    ],
                    "%TypeErrorPrototype%": [
                        "TypeError",
                        "prototype"
                    ],
                    "%Uint8ArrayPrototype%": [
                        "Uint8Array",
                        "prototype"
                    ],
                    "%Uint8ClampedArrayPrototype%": [
                        "Uint8ClampedArray",
                        "prototype"
                    ],
                    "%Uint16ArrayPrototype%": [
                        "Uint16Array",
                        "prototype"
                    ],
                    "%Uint32ArrayPrototype%": [
                        "Uint32Array",
                        "prototype"
                    ],
                    "%URIErrorPrototype%": [
                        "URIError",
                        "prototype"
                    ],
                    "%WeakMapPrototype%": [
                        "WeakMap",
                        "prototype"
                    ],
                    "%WeakSetPrototype%": [
                        "WeakSet",
                        "prototype"
                    ]
                }, k = r(3767), _ = r(2383), A = k.call(Function.call, Array.prototype.concat), E = k.call(Function.apply, Array.prototype.splice), S = k.call(Function.call, String.prototype.replace), x = k.call(Function.call, String.prototype.slice), B = k.call(Function.call, RegExp.prototype.exec), O = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g, P = /\\(\\)?/g, I = function(e, t) {
                    var r, n = e;
                    if (_(w, n) && (n = "%" + (r = w[n])[0] + "%"), _(v, n)) {
                        var i = v[n];
                        if (i === b && (i = g(n)), void 0 === i && !t) throw new s("intrinsic " + e + " exists, but is not available. Please file an issue!");
                        return {
                            alias: r,
                            name: n,
                            value: i
                        };
                    }
                    throw new o("intrinsic " + e + " does not exist!");
                };
                e.exports = function(e, t) {
                    if ("string" != typeof e || 0 === e.length) throw new s("intrinsic name must be a non-empty string");
                    if (arguments.length > 1 && "boolean" != typeof t) throw new s('"allowMissing" argument must be a boolean');
                    if (null === B(/^%?[^%]*%?$/, e)) throw new o("`%` may not be present anywhere but at the beginning and end of the intrinsic name");
                    var r = function(e) {
                        var t = x(e, 0, 1), r = x(e, -1);
                        if ("%" === t && "%" !== r) throw new o("invalid intrinsic syntax, expected closing `%`");
                        if ("%" === r && "%" !== t) throw new o("invalid intrinsic syntax, expected opening `%`");
                        var n = [];
                        return S(e, O, function(e, t, r, i) {
                            n[n.length] = r ? S(i, P, "$1") : t || e;
                        }), n;
                    }(e), n = r.length > 0 ? r[0] : "", i = I("%" + n + "%", t), a = i.name, u = i.value, f = !1, d = i.alias;
                    d && (n = d[0], E(r, A([
                        0,
                        1
                    ], d)));
                    for(var l = 1, h = !0; l < r.length; l += 1){
                        var p = r[l], b = x(p, 0, 1), y = x(p, -1);
                        if (('"' === b || "'" === b || "`" === b || '"' === y || "'" === y || "`" === y) && b !== y) throw new o("property names with quotes must have matching quotes");
                        if ("constructor" !== p && h || (f = !0), _(v, a = "%" + (n += "." + p) + "%")) u = v[a];
                        else if (null != u) {
                            if (!(p in u)) {
                                if (!t) throw new s("base intrinsic for " + e + " exists, but the property is not available.");
                                return;
                            }
                            if (c && l + 1 >= r.length) {
                                var m = c(u, p);
                                u = (h = !!m) && "get" in m && !("originalValue" in m.get) ? m.get : u[p];
                            } else h = _(u, p), u = u[p];
                            h && !f && (v[a] = u);
                        }
                    }
                    return u;
                };
            },
            92948: (e, t, r)=>{
                "use strict";
                var n;
                n = "undefined" != typeof window ? window : void 0 !== r.g ? r.g : "undefined" != typeof self ? self : {}, e.exports = n;
            },
            53820: (e, t, r)=>{
                "use strict";
                var n = r(57701)("%Object.getOwnPropertyDescriptor%", !0);
                if (n) try {
                    n([], "length");
                } catch (e) {
                    n = null;
                }
                e.exports = n;
            },
            1020: (e, t, r)=>{
                "use strict";
                var n = r(57701)("%Object.defineProperty%", !0), i = function() {
                    if (n) try {
                        return n({}, "a", {
                            value: 1
                        }), !0;
                    } catch (e) {
                        return !1;
                    }
                    return !1;
                };
                i.hasArrayLengthDefineBug = function() {
                    if (!i()) return null;
                    try {
                        return 1 !== n([], "length", {
                            value: 1
                        }).length;
                    } catch (e) {
                        return !0;
                    }
                }, e.exports = i;
            },
            61593: (e)=>{
                "use strict";
                var t = {
                    foo: {}
                }, r = Object;
                e.exports = function() {
                    return ({
                        __proto__: t
                    }).foo === t.foo && !(({
                        __proto__: null
                    }) instanceof r);
                };
            },
            58489: (e, t, r)=>{
                "use strict";
                var n = r(28847)(r(3355)), i = "undefined" != typeof Symbol && Symbol, o = r(47027);
                e.exports = function() {
                    return "function" == typeof i && "function" == typeof Symbol && "symbol" === (0, n.default)(i("foo")) && "symbol" === (0, n.default)(Symbol("bar")) && o();
                };
            },
            47027: (e, t, r)=>{
                "use strict";
                var n = r(28847)(r(3355));
                e.exports = function() {
                    if ("function" != typeof Symbol || "function" != typeof Object.getOwnPropertySymbols) return !1;
                    if ("symbol" === (0, n.default)(Symbol.iterator)) return !0;
                    var e = {}, t = Symbol("test"), r = Object(t);
                    if ("string" == typeof t) return !1;
                    if ("[object Symbol]" !== Object.prototype.toString.call(t)) return !1;
                    if ("[object Symbol]" !== Object.prototype.toString.call(r)) return !1;
                    for(t in e[t] = 42, e)return !1;
                    if ("function" == typeof Object.keys && 0 !== Object.keys(e).length) return !1;
                    if ("function" == typeof Object.getOwnPropertyNames && 0 !== Object.getOwnPropertyNames(e).length) return !1;
                    var i = Object.getOwnPropertySymbols(e);
                    if (1 !== i.length || i[0] !== t) return !1;
                    if (!Object.prototype.propertyIsEnumerable.call(e, t)) return !1;
                    if ("function" == typeof Object.getOwnPropertyDescriptor) {
                        var o = Object.getOwnPropertyDescriptor(e, t);
                        if (42 !== o.value || !0 !== o.enumerable) return !1;
                    }
                    return !0;
                };
            },
            11191: (e, t, r)=>{
                "use strict";
                var n = r(47027);
                e.exports = function() {
                    return n() && !!Symbol.toStringTag;
                };
            },
            22353: (e, t, r)=>{
                "use strict";
                var n = r(48850).Buffer, i = r(86505).Transform;
                function o(e) {
                    i.call(this), this._block = n.allocUnsafe(e), this._blockSize = e, this._blockOffset = 0, this._length = [
                        0,
                        0,
                        0,
                        0
                    ], this._finalized = !1;
                }
                r(41736)(o, i), o.prototype._transform = function(e, t, r) {
                    var n = null;
                    try {
                        this.update(e, t);
                    } catch (e) {
                        n = e;
                    }
                    r(n);
                }, o.prototype._flush = function(e) {
                    var t = null;
                    try {
                        this.push(this.digest());
                    } catch (e) {
                        t = e;
                    }
                    e(t);
                }, o.prototype.update = function(e, t) {
                    if (function(e, t) {
                        if (!n.isBuffer(e) && "string" != typeof e) throw new TypeError("Data must be a string or a buffer");
                    }(e), this._finalized) throw new Error("Digest already called");
                    n.isBuffer(e) || (e = n.from(e, t));
                    for(var r = this._block, i = 0; this._blockOffset + e.length - i >= this._blockSize;){
                        for(var o = this._blockOffset; o < this._blockSize;)r[o++] = e[i++];
                        this._update(), this._blockOffset = 0;
                    }
                    for(; i < e.length;)r[this._blockOffset++] = e[i++];
                    for(var a = 0, s = 8 * e.length; s > 0; ++a)this._length[a] += s, (s = this._length[a] / 4294967296 | 0) > 0 && (this._length[a] -= 4294967296 * s);
                    return this;
                }, o.prototype._update = function() {
                    throw new Error("_update is not implemented");
                }, o.prototype.digest = function(e) {
                    if (this._finalized) throw new Error("Digest already called");
                    this._finalized = !0;
                    var t = this._digest();
                    void 0 !== e && (t = t.toString(e)), this._block.fill(0), this._blockOffset = 0;
                    for(var r = 0; r < 4; ++r)this._length[r] = 0;
                    return t;
                }, o.prototype._digest = function() {
                    throw new Error("_digest is not implemented");
                }, e.exports = o;
            },
            37198: (e, t, r)=>{
                "use strict";
                var n = t;
                n.utils = r(84268), n.common = r(64696), n.sha = r(39310), n.ripemd = r(69294), n.hmac = r(53201), n.sha1 = n.sha.sha1, n.sha256 = n.sha.sha256, n.sha224 = n.sha.sha224, n.sha384 = n.sha.sha384, n.sha512 = n.sha.sha512, n.ripemd160 = n.ripemd.ripemd160;
            },
            64696: (e, t, r)=>{
                "use strict";
                var n = r(84268), i = r(94504);
                function o() {
                    this.pending = null, this.pendingTotal = 0, this.blockSize = this.constructor.blockSize, this.outSize = this.constructor.outSize, this.hmacStrength = this.constructor.hmacStrength, this.padLength = this.constructor.padLength / 8, this.endian = "big", this._delta8 = this.blockSize / 8, this._delta32 = this.blockSize / 32;
                }
                t.BlockHash = o, o.prototype.update = function(e, t) {
                    if (e = n.toArray(e, t), this.pending ? this.pending = this.pending.concat(e) : this.pending = e, this.pendingTotal += e.length, this.pending.length >= this._delta8) {
                        var r = (e = this.pending).length % this._delta8;
                        this.pending = e.slice(e.length - r, e.length), 0 === this.pending.length && (this.pending = null), e = n.join32(e, 0, e.length - r, this.endian);
                        for(var i = 0; i < e.length; i += this._delta32)this._update(e, i, i + this._delta32);
                    }
                    return this;
                }, o.prototype.digest = function(e) {
                    return this.update(this._pad()), i(null === this.pending), this._digest(e);
                }, o.prototype._pad = function() {
                    var e = this.pendingTotal, t = this._delta8, r = t - (e + this.padLength) % t, n = new Array(r + this.padLength);
                    n[0] = 128;
                    for(var i = 1; i < r; i++)n[i] = 0;
                    if (e <<= 3, "big" === this.endian) {
                        for(var o = 8; o < this.padLength; o++)n[i++] = 0;
                        n[i++] = 0, n[i++] = 0, n[i++] = 0, n[i++] = 0, n[i++] = e >>> 24 & 255, n[i++] = e >>> 16 & 255, n[i++] = e >>> 8 & 255, n[i++] = 255 & e;
                    } else for(n[i++] = 255 & e, n[i++] = e >>> 8 & 255, n[i++] = e >>> 16 & 255, n[i++] = e >>> 24 & 255, n[i++] = 0, n[i++] = 0, n[i++] = 0, n[i++] = 0, o = 8; o < this.padLength; o++)n[i++] = 0;
                    return n;
                };
            },
            53201: (e, t, r)=>{
                "use strict";
                var n = r(84268), i = r(94504);
                function o(e, t, r) {
                    if (!(this instanceof o)) return new o(e, t, r);
                    this.Hash = e, this.blockSize = e.blockSize / 8, this.outSize = e.outSize / 8, this.inner = null, this.outer = null, this._init(n.toArray(t, r));
                }
                e.exports = o, o.prototype._init = function(e) {
                    e.length > this.blockSize && (e = (new this.Hash).update(e).digest()), i(e.length <= this.blockSize);
                    for(var t = e.length; t < this.blockSize; t++)e.push(0);
                    for(t = 0; t < e.length; t++)e[t] ^= 54;
                    for(this.inner = (new this.Hash).update(e), t = 0; t < e.length; t++)e[t] ^= 106;
                    this.outer = (new this.Hash).update(e);
                }, o.prototype.update = function(e, t) {
                    return this.inner.update(e, t), this;
                }, o.prototype.digest = function(e) {
                    return this.outer.update(this.inner.digest()), this.outer.digest(e);
                };
            },
            69294: (e, t, r)=>{
                "use strict";
                var n = r(84268), i = r(64696), o = n.rotl32, a = n.sum32, s = n.sum32_3, u = n.sum32_4, c = i.BlockHash;
                function f() {
                    if (!(this instanceof f)) return new f;
                    c.call(this), this.h = [
                        1732584193,
                        4023233417,
                        2562383102,
                        271733878,
                        3285377520
                    ], this.endian = "little";
                }
                function d(e, t, r, n) {
                    return e <= 15 ? t ^ r ^ n : e <= 31 ? t & r | ~t & n : e <= 47 ? (t | ~r) ^ n : e <= 63 ? t & n | r & ~n : t ^ (r | ~n);
                }
                function l(e) {
                    return e <= 15 ? 0 : e <= 31 ? 1518500249 : e <= 47 ? 1859775393 : e <= 63 ? 2400959708 : 2840853838;
                }
                function h(e) {
                    return e <= 15 ? 1352829926 : e <= 31 ? 1548603684 : e <= 47 ? 1836072691 : e <= 63 ? 2053994217 : 0;
                }
                n.inherits(f, c), t.ripemd160 = f, f.blockSize = 512, f.outSize = 160, f.hmacStrength = 192, f.padLength = 64, f.prototype._update = function(e, t) {
                    for(var r = this.h[0], n = this.h[1], i = this.h[2], c = this.h[3], f = this.h[4], m = r, g = n, w = i, k = c, _ = f, A = 0; A < 80; A++){
                        var E = a(o(u(r, d(A, n, i, c), e[p[A] + t], l(A)), y[A]), f);
                        r = f, f = c, c = o(i, 10), i = n, n = E, E = a(o(u(m, d(79 - A, g, w, k), e[b[A] + t], h(A)), v[A]), _), m = _, _ = k, k = o(w, 10), w = g, g = E;
                    }
                    E = s(this.h[1], i, k), this.h[1] = s(this.h[2], c, _), this.h[2] = s(this.h[3], f, m), this.h[3] = s(this.h[4], r, g), this.h[4] = s(this.h[0], n, w), this.h[0] = E;
                }, f.prototype._digest = function(e) {
                    return "hex" === e ? n.toHex32(this.h, "little") : n.split32(this.h, "little");
                };
                var p = [
                    0,
                    1,
                    2,
                    3,
                    4,
                    5,
                    6,
                    7,
                    8,
                    9,
                    10,
                    11,
                    12,
                    13,
                    14,
                    15,
                    7,
                    4,
                    13,
                    1,
                    10,
                    6,
                    15,
                    3,
                    12,
                    0,
                    9,
                    5,
                    2,
                    14,
                    11,
                    8,
                    3,
                    10,
                    14,
                    4,
                    9,
                    15,
                    8,
                    1,
                    2,
                    7,
                    0,
                    6,
                    13,
                    11,
                    5,
                    12,
                    1,
                    9,
                    11,
                    10,
                    0,
                    8,
                    12,
                    4,
                    13,
                    3,
                    7,
                    15,
                    14,
                    5,
                    6,
                    2,
                    4,
                    0,
                    5,
                    9,
                    7,
                    12,
                    2,
                    10,
                    14,
                    1,
                    3,
                    8,
                    11,
                    6,
                    15,
                    13
                ], b = [
                    5,
                    14,
                    7,
                    0,
                    9,
                    2,
                    11,
                    4,
                    13,
                    6,
                    15,
                    8,
                    1,
                    10,
                    3,
                    12,
                    6,
                    11,
                    3,
                    7,
                    0,
                    13,
                    5,
                    10,
                    14,
                    15,
                    8,
                    12,
                    4,
                    9,
                    1,
                    2,
                    15,
                    5,
                    1,
                    3,
                    7,
                    14,
                    6,
                    9,
                    11,
                    8,
                    12,
                    2,
                    10,
                    0,
                    4,
                    13,
                    8,
                    6,
                    4,
                    1,
                    3,
                    11,
                    15,
                    0,
                    5,
                    12,
                    2,
                    13,
                    9,
                    7,
                    10,
                    14,
                    12,
                    15,
                    10,
                    4,
                    1,
                    5,
                    8,
                    7,
                    6,
                    2,
                    13,
                    14,
                    0,
                    3,
                    9,
                    11
                ], y = [
                    11,
                    14,
                    15,
                    12,
                    5,
                    8,
                    7,
                    9,
                    11,
                    13,
                    14,
                    15,
                    6,
                    7,
                    9,
                    8,
                    7,
                    6,
                    8,
                    13,
                    11,
                    9,
                    7,
                    15,
                    7,
                    12,
                    15,
                    9,
                    11,
                    7,
                    13,
                    12,
                    11,
                    13,
                    6,
                    7,
                    14,
                    9,
                    13,
                    15,
                    14,
                    8,
                    13,
                    6,
                    5,
                    12,
                    7,
                    5,
                    11,
                    12,
                    14,
                    15,
                    14,
                    15,
                    9,
                    8,
                    9,
                    14,
                    5,
                    6,
                    8,
                    6,
                    5,
                    12,
                    9,
                    15,
                    5,
                    11,
                    6,
                    8,
                    13,
                    12,
                    5,
                    12,
                    13,
                    14,
                    11,
                    8,
                    5,
                    6
                ], v = [
                    8,
                    9,
                    9,
                    11,
                    13,
                    15,
                    15,
                    5,
                    7,
                    7,
                    8,
                    11,
                    14,
                    14,
                    12,
                    6,
                    9,
                    13,
                    15,
                    7,
                    12,
                    8,
                    9,
                    11,
                    7,
                    7,
                    12,
                    7,
                    6,
                    15,
                    13,
                    11,
                    9,
                    7,
                    15,
                    11,
                    8,
                    6,
                    6,
                    14,
                    12,
                    13,
                    5,
                    14,
                    13,
                    13,
                    7,
                    5,
                    15,
                    5,
                    8,
                    11,
                    14,
                    14,
                    6,
                    14,
                    6,
                    9,
                    12,
                    9,
                    12,
                    5,
                    15,
                    8,
                    8,
                    5,
                    12,
                    9,
                    12,
                    5,
                    14,
                    6,
                    8,
                    13,
                    6,
                    5,
                    15,
                    13,
                    11,
                    11
                ];
            },
            39310: (e, t, r)=>{
                "use strict";
                t.sha1 = r(38142), t.sha224 = r(14909), t.sha256 = r(87682), t.sha384 = r(74532), t.sha512 = r(36515);
            },
            38142: (e, t, r)=>{
                "use strict";
                var n = r(84268), i = r(64696), o = r(90070), a = n.rotl32, s = n.sum32, u = n.sum32_5, c = o.ft_1, f = i.BlockHash, d = [
                    1518500249,
                    1859775393,
                    2400959708,
                    3395469782
                ];
                function l() {
                    if (!(this instanceof l)) return new l;
                    f.call(this), this.h = [
                        1732584193,
                        4023233417,
                        2562383102,
                        271733878,
                        3285377520
                    ], this.W = new Array(80);
                }
                n.inherits(l, f), e.exports = l, l.blockSize = 512, l.outSize = 160, l.hmacStrength = 80, l.padLength = 64, l.prototype._update = function(e, t) {
                    for(var r = this.W, n = 0; n < 16; n++)r[n] = e[t + n];
                    for(; n < r.length; n++)r[n] = a(r[n - 3] ^ r[n - 8] ^ r[n - 14] ^ r[n - 16], 1);
                    var i = this.h[0], o = this.h[1], f = this.h[2], l = this.h[3], h = this.h[4];
                    for(n = 0; n < r.length; n++){
                        var p = ~~(n / 20), b = u(a(i, 5), c(p, o, f, l), h, r[n], d[p]);
                        h = l, l = f, f = a(o, 30), o = i, i = b;
                    }
                    this.h[0] = s(this.h[0], i), this.h[1] = s(this.h[1], o), this.h[2] = s(this.h[2], f), this.h[3] = s(this.h[3], l), this.h[4] = s(this.h[4], h);
                }, l.prototype._digest = function(e) {
                    return "hex" === e ? n.toHex32(this.h, "big") : n.split32(this.h, "big");
                };
            },
            14909: (e, t, r)=>{
                "use strict";
                var n = r(84268), i = r(87682);
                function o() {
                    if (!(this instanceof o)) return new o;
                    i.call(this), this.h = [
                        3238371032,
                        914150663,
                        812702999,
                        4144912697,
                        4290775857,
                        1750603025,
                        1694076839,
                        3204075428
                    ];
                }
                n.inherits(o, i), e.exports = o, o.blockSize = 512, o.outSize = 224, o.hmacStrength = 192, o.padLength = 64, o.prototype._digest = function(e) {
                    return "hex" === e ? n.toHex32(this.h.slice(0, 7), "big") : n.split32(this.h.slice(0, 7), "big");
                };
            },
            87682: (e, t, r)=>{
                "use strict";
                var n = r(84268), i = r(64696), o = r(90070), a = r(94504), s = n.sum32, u = n.sum32_4, c = n.sum32_5, f = o.ch32, d = o.maj32, l = o.s0_256, h = o.s1_256, p = o.g0_256, b = o.g1_256, y = i.BlockHash, v = [
                    1116352408,
                    1899447441,
                    3049323471,
                    3921009573,
                    961987163,
                    1508970993,
                    2453635748,
                    2870763221,
                    3624381080,
                    310598401,
                    607225278,
                    1426881987,
                    1925078388,
                    2162078206,
                    2614888103,
                    3248222580,
                    3835390401,
                    4022224774,
                    264347078,
                    604807628,
                    770255983,
                    1249150122,
                    1555081692,
                    1996064986,
                    2554220882,
                    2821834349,
                    2952996808,
                    3210313671,
                    3336571891,
                    3584528711,
                    113926993,
                    338241895,
                    666307205,
                    773529912,
                    1294757372,
                    1396182291,
                    1695183700,
                    1986661051,
                    2177026350,
                    2456956037,
                    2730485921,
                    2820302411,
                    3259730800,
                    3345764771,
                    3516065817,
                    3600352804,
                    4094571909,
                    275423344,
                    430227734,
                    506948616,
                    659060556,
                    883997877,
                    958139571,
                    1322822218,
                    1537002063,
                    1747873779,
                    1955562222,
                    2024104815,
                    2227730452,
                    2361852424,
                    2428436474,
                    2756734187,
                    3204031479,
                    3329325298
                ];
                function m() {
                    if (!(this instanceof m)) return new m;
                    y.call(this), this.h = [
                        1779033703,
                        3144134277,
                        1013904242,
                        2773480762,
                        1359893119,
                        2600822924,
                        528734635,
                        1541459225
                    ], this.k = v, this.W = new Array(64);
                }
                n.inherits(m, y), e.exports = m, m.blockSize = 512, m.outSize = 256, m.hmacStrength = 192, m.padLength = 64, m.prototype._update = function(e, t) {
                    for(var r = this.W, n = 0; n < 16; n++)r[n] = e[t + n];
                    for(; n < r.length; n++)r[n] = u(b(r[n - 2]), r[n - 7], p(r[n - 15]), r[n - 16]);
                    var i = this.h[0], o = this.h[1], y = this.h[2], v = this.h[3], m = this.h[4], g = this.h[5], w = this.h[6], k = this.h[7];
                    for(a(this.k.length === r.length), n = 0; n < r.length; n++){
                        var _ = c(k, h(m), f(m, g, w), this.k[n], r[n]), A = s(l(i), d(i, o, y));
                        k = w, w = g, g = m, m = s(v, _), v = y, y = o, o = i, i = s(_, A);
                    }
                    this.h[0] = s(this.h[0], i), this.h[1] = s(this.h[1], o), this.h[2] = s(this.h[2], y), this.h[3] = s(this.h[3], v), this.h[4] = s(this.h[4], m), this.h[5] = s(this.h[5], g), this.h[6] = s(this.h[6], w), this.h[7] = s(this.h[7], k);
                }, m.prototype._digest = function(e) {
                    return "hex" === e ? n.toHex32(this.h, "big") : n.split32(this.h, "big");
                };
            },
            74532: (e, t, r)=>{
                "use strict";
                var n = r(84268), i = r(36515);
                function o() {
                    if (!(this instanceof o)) return new o;
                    i.call(this), this.h = [
                        3418070365,
                        3238371032,
                        1654270250,
                        914150663,
                        2438529370,
                        812702999,
                        355462360,
                        4144912697,
                        1731405415,
                        4290775857,
                        2394180231,
                        1750603025,
                        3675008525,
                        1694076839,
                        1203062813,
                        3204075428
                    ];
                }
                n.inherits(o, i), e.exports = o, o.blockSize = 1024, o.outSize = 384, o.hmacStrength = 192, o.padLength = 128, o.prototype._digest = function(e) {
                    return "hex" === e ? n.toHex32(this.h.slice(0, 12), "big") : n.split32(this.h.slice(0, 12), "big");
                };
            },
            36515: (e, t, r)=>{
                "use strict";
                var n = r(84268), i = r(64696), o = r(94504), a = n.rotr64_hi, s = n.rotr64_lo, u = n.shr64_hi, c = n.shr64_lo, f = n.sum64, d = n.sum64_hi, l = n.sum64_lo, h = n.sum64_4_hi, p = n.sum64_4_lo, b = n.sum64_5_hi, y = n.sum64_5_lo, v = i.BlockHash, m = [
                    1116352408,
                    3609767458,
                    1899447441,
                    602891725,
                    3049323471,
                    3964484399,
                    3921009573,
                    2173295548,
                    961987163,
                    4081628472,
                    1508970993,
                    3053834265,
                    2453635748,
                    2937671579,
                    2870763221,
                    3664609560,
                    3624381080,
                    2734883394,
                    310598401,
                    1164996542,
                    607225278,
                    1323610764,
                    1426881987,
                    3590304994,
                    1925078388,
                    4068182383,
                    2162078206,
                    991336113,
                    2614888103,
                    633803317,
                    3248222580,
                    3479774868,
                    3835390401,
                    2666613458,
                    4022224774,
                    944711139,
                    264347078,
                    2341262773,
                    604807628,
                    2007800933,
                    770255983,
                    1495990901,
                    1249150122,
                    1856431235,
                    1555081692,
                    3175218132,
                    1996064986,
                    2198950837,
                    2554220882,
                    3999719339,
                    2821834349,
                    766784016,
                    2952996808,
                    2566594879,
                    3210313671,
                    3203337956,
                    3336571891,
                    1034457026,
                    3584528711,
                    2466948901,
                    113926993,
                    3758326383,
                    338241895,
                    168717936,
                    666307205,
                    1188179964,
                    773529912,
                    1546045734,
                    1294757372,
                    1522805485,
                    1396182291,
                    2643833823,
                    1695183700,
                    2343527390,
                    1986661051,
                    1014477480,
                    2177026350,
                    1206759142,
                    2456956037,
                    344077627,
                    2730485921,
                    1290863460,
                    2820302411,
                    3158454273,
                    3259730800,
                    3505952657,
                    3345764771,
                    106217008,
                    3516065817,
                    3606008344,
                    3600352804,
                    1432725776,
                    4094571909,
                    1467031594,
                    275423344,
                    851169720,
                    430227734,
                    3100823752,
                    506948616,
                    1363258195,
                    659060556,
                    3750685593,
                    883997877,
                    3785050280,
                    958139571,
                    3318307427,
                    1322822218,
                    3812723403,
                    1537002063,
                    2003034995,
                    1747873779,
                    3602036899,
                    1955562222,
                    1575990012,
                    2024104815,
                    1125592928,
                    2227730452,
                    2716904306,
                    2361852424,
                    442776044,
                    2428436474,
                    593698344,
                    2756734187,
                    3733110249,
                    3204031479,
                    2999351573,
                    3329325298,
                    3815920427,
                    3391569614,
                    3928383900,
                    3515267271,
                    566280711,
                    3940187606,
                    3454069534,
                    4118630271,
                    4000239992,
                    116418474,
                    1914138554,
                    174292421,
                    2731055270,
                    289380356,
                    3203993006,
                    460393269,
                    320620315,
                    685471733,
                    587496836,
                    852142971,
                    1086792851,
                    1017036298,
                    365543100,
                    1126000580,
                    2618297676,
                    1288033470,
                    3409855158,
                    1501505948,
                    4234509866,
                    1607167915,
                    987167468,
                    1816402316,
                    1246189591
                ];
                function g() {
                    if (!(this instanceof g)) return new g;
                    v.call(this), this.h = [
                        1779033703,
                        4089235720,
                        3144134277,
                        2227873595,
                        1013904242,
                        4271175723,
                        2773480762,
                        1595750129,
                        1359893119,
                        2917565137,
                        2600822924,
                        725511199,
                        528734635,
                        4215389547,
                        1541459225,
                        327033209
                    ], this.k = m, this.W = new Array(160);
                }
                function w(e, t, r, n, i) {
                    var o = e & r ^ ~e & i;
                    return o < 0 && (o += 4294967296), o;
                }
                function k(e, t, r, n, i, o) {
                    var a = t & n ^ ~t & o;
                    return a < 0 && (a += 4294967296), a;
                }
                function _(e, t, r, n, i) {
                    var o = e & r ^ e & i ^ r & i;
                    return o < 0 && (o += 4294967296), o;
                }
                function A(e, t, r, n, i, o) {
                    var a = t & n ^ t & o ^ n & o;
                    return a < 0 && (a += 4294967296), a;
                }
                function E(e, t) {
                    var r = a(e, t, 28) ^ a(t, e, 2) ^ a(t, e, 7);
                    return r < 0 && (r += 4294967296), r;
                }
                function S(e, t) {
                    var r = s(e, t, 28) ^ s(t, e, 2) ^ s(t, e, 7);
                    return r < 0 && (r += 4294967296), r;
                }
                function x(e, t) {
                    var r = s(e, t, 14) ^ s(e, t, 18) ^ s(t, e, 9);
                    return r < 0 && (r += 4294967296), r;
                }
                function B(e, t) {
                    var r = a(e, t, 1) ^ a(e, t, 8) ^ u(e, t, 7);
                    return r < 0 && (r += 4294967296), r;
                }
                function O(e, t) {
                    var r = s(e, t, 1) ^ s(e, t, 8) ^ c(e, t, 7);
                    return r < 0 && (r += 4294967296), r;
                }
                function P(e, t) {
                    var r = s(e, t, 19) ^ s(t, e, 29) ^ c(e, t, 6);
                    return r < 0 && (r += 4294967296), r;
                }
                n.inherits(g, v), e.exports = g, g.blockSize = 1024, g.outSize = 512, g.hmacStrength = 192, g.padLength = 128, g.prototype._prepareBlock = function(e, t) {
                    for(var r = this.W, n = 0; n < 32; n++)r[n] = e[t + n];
                    for(; n < r.length; n += 2){
                        var i = (y = r[n - 4], v = r[n - 3], m = void 0, (m = a(y, v, 19) ^ a(v, y, 29) ^ u(y, v, 6)) < 0 && (m += 4294967296), m), o = P(r[n - 4], r[n - 3]), s = r[n - 14], c = r[n - 13], f = B(r[n - 30], r[n - 29]), d = O(r[n - 30], r[n - 29]), l = r[n - 32], b = r[n - 31];
                        r[n] = h(i, o, s, c, f, d, l, b), r[n + 1] = p(i, o, s, c, f, d, l, b);
                    }
                    var y, v, m;
                }, g.prototype._update = function(e, t) {
                    this._prepareBlock(e, t);
                    var r, n, i, s = this.W, u = this.h[0], c = this.h[1], h = this.h[2], p = this.h[3], v = this.h[4], m = this.h[5], g = this.h[6], B = this.h[7], O = this.h[8], P = this.h[9], I = this.h[10], T = this.h[11], C = this.h[12], M = this.h[13], R = this.h[14], U = this.h[15];
                    o(this.k.length === s.length);
                    for(var N = 0; N < s.length; N += 2){
                        var j = R, L = U, F = (i = void 0, (i = a(r = O, n = P, 14) ^ a(r, n, 18) ^ a(n, r, 9)) < 0 && (i += 4294967296), i), D = x(O, P), H = w(O, 0, I, 0, C), z = k(0, P, 0, T, 0, M), q = this.k[N], K = this.k[N + 1], G = s[N], V = s[N + 1], Z = b(j, L, F, D, H, z, q, K, G, V), W = y(j, L, F, D, H, z, q, K, G, V);
                        j = E(u, c), L = S(u, c), F = _(u, 0, h, 0, v), D = A(0, c, 0, p, 0, m);
                        var J = d(j, L, F, D), Y = l(j, L, F, D);
                        R = C, U = M, C = I, M = T, I = O, T = P, O = d(g, B, Z, W), P = l(B, B, Z, W), g = v, B = m, v = h, m = p, h = u, p = c, u = d(Z, W, J, Y), c = l(Z, W, J, Y);
                    }
                    f(this.h, 0, u, c), f(this.h, 2, h, p), f(this.h, 4, v, m), f(this.h, 6, g, B), f(this.h, 8, O, P), f(this.h, 10, I, T), f(this.h, 12, C, M), f(this.h, 14, R, U);
                }, g.prototype._digest = function(e) {
                    return "hex" === e ? n.toHex32(this.h, "big") : n.split32(this.h, "big");
                };
            },
            90070: (e, t, r)=>{
                "use strict";
                var n = r(84268).rotr32;
                function i(e, t, r) {
                    return e & t ^ ~e & r;
                }
                function o(e, t, r) {
                    return e & t ^ e & r ^ t & r;
                }
                function a(e, t, r) {
                    return e ^ t ^ r;
                }
                t.ft_1 = function(e, t, r, n) {
                    return 0 === e ? i(t, r, n) : 1 === e || 3 === e ? a(t, r, n) : 2 === e ? o(t, r, n) : void 0;
                }, t.ch32 = i, t.maj32 = o, t.p32 = a, t.s0_256 = function(e) {
                    return n(e, 2) ^ n(e, 13) ^ n(e, 22);
                }, t.s1_256 = function(e) {
                    return n(e, 6) ^ n(e, 11) ^ n(e, 25);
                }, t.g0_256 = function(e) {
                    return n(e, 7) ^ n(e, 18) ^ e >>> 3;
                }, t.g1_256 = function(e) {
                    return n(e, 17) ^ n(e, 19) ^ e >>> 10;
                };
            },
            84268: (e, t, r)=>{
                "use strict";
                var n = r(94504), i = r(41736);
                function o(e, t) {
                    return 55296 == (64512 & e.charCodeAt(t)) && !(t < 0 || t + 1 >= e.length) && 56320 == (64512 & e.charCodeAt(t + 1));
                }
                function a(e) {
                    return (e >>> 24 | e >>> 8 & 65280 | e << 8 & 16711680 | (255 & e) << 24) >>> 0;
                }
                function s(e) {
                    return 1 === e.length ? "0" + e : e;
                }
                function u(e) {
                    return 7 === e.length ? "0" + e : 6 === e.length ? "00" + e : 5 === e.length ? "000" + e : 4 === e.length ? "0000" + e : 3 === e.length ? "00000" + e : 2 === e.length ? "000000" + e : 1 === e.length ? "0000000" + e : e;
                }
                t.inherits = i, t.toArray = function(e, t) {
                    if (Array.isArray(e)) return e.slice();
                    if (!e) return [];
                    var r = [];
                    if ("string" == typeof e) {
                        if (t) {
                            if ("hex" === t) for((e = e.replace(/[^a-z0-9]+/gi, "")).length % 2 != 0 && (e = "0" + e), i = 0; i < e.length; i += 2)r.push(parseInt(e[i] + e[i + 1], 16));
                        } else for(var n = 0, i = 0; i < e.length; i++){
                            var a = e.charCodeAt(i);
                            a < 128 ? r[n++] = a : a < 2048 ? (r[n++] = a >> 6 | 192, r[n++] = 63 & a | 128) : o(e, i) ? (a = 65536 + ((1023 & a) << 10) + (1023 & e.charCodeAt(++i)), r[n++] = a >> 18 | 240, r[n++] = a >> 12 & 63 | 128, r[n++] = a >> 6 & 63 | 128, r[n++] = 63 & a | 128) : (r[n++] = a >> 12 | 224, r[n++] = a >> 6 & 63 | 128, r[n++] = 63 & a | 128);
                        }
                    } else for(i = 0; i < e.length; i++)r[i] = 0 | e[i];
                    return r;
                }, t.toHex = function(e) {
                    for(var t = "", r = 0; r < e.length; r++)t += s(e[r].toString(16));
                    return t;
                }, t.htonl = a, t.toHex32 = function(e, t) {
                    for(var r = "", n = 0; n < e.length; n++){
                        var i = e[n];
                        "little" === t && (i = a(i)), r += u(i.toString(16));
                    }
                    return r;
                }, t.zero2 = s, t.zero8 = u, t.join32 = function(e, t, r, i) {
                    var o = r - t;
                    n(o % 4 == 0);
                    for(var a = new Array(o / 4), s = 0, u = t; s < a.length; s++, u += 4){
                        var c;
                        c = "big" === i ? e[u] << 24 | e[u + 1] << 16 | e[u + 2] << 8 | e[u + 3] : e[u + 3] << 24 | e[u + 2] << 16 | e[u + 1] << 8 | e[u], a[s] = c >>> 0;
                    }
                    return a;
                }, t.split32 = function(e, t) {
                    for(var r = new Array(4 * e.length), n = 0, i = 0; n < e.length; n++, i += 4){
                        var o = e[n];
                        "big" === t ? (r[i] = o >>> 24, r[i + 1] = o >>> 16 & 255, r[i + 2] = o >>> 8 & 255, r[i + 3] = 255 & o) : (r[i + 3] = o >>> 24, r[i + 2] = o >>> 16 & 255, r[i + 1] = o >>> 8 & 255, r[i] = 255 & o);
                    }
                    return r;
                }, t.rotr32 = function(e, t) {
                    return e >>> t | e << 32 - t;
                }, t.rotl32 = function(e, t) {
                    return e << t | e >>> 32 - t;
                }, t.sum32 = function(e, t) {
                    return e + t >>> 0;
                }, t.sum32_3 = function(e, t, r) {
                    return e + t + r >>> 0;
                }, t.sum32_4 = function(e, t, r, n) {
                    return e + t + r + n >>> 0;
                }, t.sum32_5 = function(e, t, r, n, i) {
                    return e + t + r + n + i >>> 0;
                }, t.sum64 = function(e, t, r, n) {
                    var i = e[t], o = n + e[t + 1] >>> 0, a = (o < n ? 1 : 0) + r + i;
                    e[t] = a >>> 0, e[t + 1] = o;
                }, t.sum64_hi = function(e, t, r, n) {
                    return (t + n >>> 0 < t ? 1 : 0) + e + r >>> 0;
                }, t.sum64_lo = function(e, t, r, n) {
                    return t + n >>> 0;
                }, t.sum64_4_hi = function(e, t, r, n, i, o, a, s) {
                    var u = 0, c = t;
                    return u += (c = c + n >>> 0) < t ? 1 : 0, u += (c = c + o >>> 0) < o ? 1 : 0, e + r + i + a + (u += (c = c + s >>> 0) < s ? 1 : 0) >>> 0;
                }, t.sum64_4_lo = function(e, t, r, n, i, o, a, s) {
                    return t + n + o + s >>> 0;
                }, t.sum64_5_hi = function(e, t, r, n, i, o, a, s, u, c) {
                    var f = 0, d = t;
                    return f += (d = d + n >>> 0) < t ? 1 : 0, f += (d = d + o >>> 0) < o ? 1 : 0, f += (d = d + s >>> 0) < s ? 1 : 0, e + r + i + a + u + (f += (d = d + c >>> 0) < c ? 1 : 0) >>> 0;
                }, t.sum64_5_lo = function(e, t, r, n, i, o, a, s, u, c) {
                    return t + n + o + s + c >>> 0;
                }, t.rotr64_hi = function(e, t, r) {
                    return (t << 32 - r | e >>> r) >>> 0;
                }, t.rotr64_lo = function(e, t, r) {
                    return (e << 32 - r | t >>> r) >>> 0;
                }, t.shr64_hi = function(e, t, r) {
                    return e >>> r;
                }, t.shr64_lo = function(e, t, r) {
                    return (e << 32 - r | t >>> r) >>> 0;
                };
            },
            2383: (e, t, r)=>{
                "use strict";
                var n = Function.prototype.call, i = Object.prototype.hasOwnProperty, o = r(3767);
                e.exports = o.call(n, i);
            },
            29410: (e, t, r)=>{
                "use strict";
                var n = r(37198), i = r(96580), o = r(94504);
                function a(e) {
                    if (!(this instanceof a)) return new a(e);
                    this.hash = e.hash, this.predResist = !!e.predResist, this.outLen = this.hash.outSize, this.minEntropy = e.minEntropy || this.hash.hmacStrength, this._reseed = null, this.reseedInterval = null, this.K = null, this.V = null;
                    var t = i.toArray(e.entropy, e.entropyEnc || "hex"), r = i.toArray(e.nonce, e.nonceEnc || "hex"), n = i.toArray(e.pers, e.persEnc || "hex");
                    o(t.length >= this.minEntropy / 8, "Not enough entropy. Minimum is: " + this.minEntropy + " bits"), this._init(t, r, n);
                }
                e.exports = a, a.prototype._init = function(e, t, r) {
                    var n = e.concat(t).concat(r);
                    this.K = new Array(this.outLen / 8), this.V = new Array(this.outLen / 8);
                    for(var i = 0; i < this.V.length; i++)this.K[i] = 0, this.V[i] = 1;
                    this._update(n), this._reseed = 1, this.reseedInterval = 281474976710656;
                }, a.prototype._hmac = function() {
                    return new n.hmac(this.hash, this.K);
                }, a.prototype._update = function(e) {
                    var t = this._hmac().update(this.V).update([
                        0
                    ]);
                    e && (t = t.update(e)), this.K = t.digest(), this.V = this._hmac().update(this.V).digest(), e && (this.K = this._hmac().update(this.V).update([
                        1
                    ]).update(e).digest(), this.V = this._hmac().update(this.V).digest());
                }, a.prototype.reseed = function(e, t, r, n) {
                    "string" != typeof t && (n = r, r = t, t = null), e = i.toArray(e, t), r = i.toArray(r, n), o(e.length >= this.minEntropy / 8, "Not enough entropy. Minimum is: " + this.minEntropy + " bits"), this._update(e.concat(r || [])), this._reseed = 1;
                }, a.prototype.generate = function(e, t, r, n) {
                    if (this._reseed > this.reseedInterval) throw new Error("Reseed is required");
                    "string" != typeof t && (n = r, r = t, t = null), r && (r = i.toArray(r, n || "hex"), this._update(r));
                    for(var o = []; o.length < e;)this.V = this._hmac().update(this.V).digest(), o = o.concat(this.V);
                    var a = o.slice(0, e);
                    return this._update(r), this._reseed++, i.encode(a, t);
                };
            },
            90912: (e, t, r)=>{
                "use strict";
                var n = r(29519), i = r(51143), o = e.exports;
                for(var a in n)n.hasOwnProperty(a) && (o[a] = n[a]);
                function s(e) {
                    if ("string" == typeof e && (e = i.parse(e)), e.protocol || (e.protocol = "https:"), "https:" !== e.protocol) throw new Error('Protocol "' + e.protocol + '" not supported. Expected "https:"');
                    return e;
                }
                o.request = function(e, t) {
                    return e = s(e), n.request.call(this, e, t);
                }, o.get = function(e, t) {
                    return e = s(e), n.get.call(this, e, t);
                };
            },
            32996: (e, t, r)=>{
                "use strict";
                var n;
                r(28847)(r(3355)), void 0 === (n = (function() {
                    var e, t;
                    return e = [
                        new Uint32Array([
                            2157250,
                            2157314,
                            2157378,
                            2157442,
                            2157506,
                            2157570,
                            2157634,
                            0,
                            2157698,
                            2157762,
                            2157826,
                            2157890,
                            2157954,
                            0,
                            2158018,
                            0
                        ]),
                        new Uint32Array([
                            2179041,
                            6291456,
                            2179073,
                            6291456,
                            2179105,
                            6291456,
                            2179137,
                            6291456,
                            2179169,
                            6291456,
                            2179201,
                            6291456,
                            2179233,
                            6291456,
                            2179265,
                            6291456
                        ]),
                        new Uint32Array([
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            14680064,
                            14680064,
                            14680064,
                            14680064,
                            14680064
                        ]),
                        new Uint32Array([
                            0,
                            2113729,
                            2197345,
                            2197377,
                            2113825,
                            2197409,
                            2197441,
                            2113921,
                            2197473,
                            2114017,
                            2197505,
                            2197537,
                            2197569,
                            2197601,
                            2197633,
                            2197665
                        ]),
                        new Uint32Array([
                            6291456,
                            6291456,
                            6291456,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            6291456,
                            23068672,
                            23068672,
                            0,
                            0
                        ]),
                        new Uint32Array([
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            0,
                            0,
                            0,
                            0,
                            23068672,
                            23068672,
                            23068672,
                            0,
                            0,
                            0,
                            0,
                            23068672
                        ]),
                        new Uint32Array([
                            14680064,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            14680064,
                            14680064
                        ]),
                        new Uint32Array([
                            2196001,
                            2196033,
                            2196065,
                            2196097,
                            2196129,
                            2196161,
                            2196193,
                            2196225,
                            2196257,
                            2196289,
                            2196321,
                            2196353,
                            2196385,
                            2196417,
                            2196449,
                            2196481
                        ]),
                        new Uint32Array([
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            23068672,
                            6291456,
                            0,
                            0,
                            0,
                            0,
                            0
                        ]),
                        new Uint32Array([
                            2097281,
                            2105921,
                            2097729,
                            2106081,
                            0,
                            2097601,
                            2162337,
                            2106017,
                            2133281,
                            2097505,
                            2105889,
                            2097185,
                            2097697,
                            2135777,
                            2097633,
                            2097441
                        ]),
                        new Uint32Array([
                            2177025,
                            6291456,
                            2177057,
                            6291456,
                            2177089,
                            6291456,
                            2177121,
                            6291456,
                            2177153,
                            6291456,
                            2177185,
                            6291456,
                            2177217,
                            6291456,
                            2177249,
                            6291456
                        ]),
                        new Uint32Array([
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            0,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456
                        ]),
                        new Uint32Array([
                            6291456,
                            6291456,
                            6291456,
                            0,
                            6291456,
                            6291456,
                            0,
                            0,
                            0,
                            0,
                            0,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456
                        ]),
                        new Uint32Array([
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            0,
                            0,
                            0,
                            6291456
                        ]),
                        new Uint32Array([
                            0,
                            23068672,
                            23068672,
                            23068672,
                            0,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            0,
                            0,
                            0,
                            0,
                            6291456
                        ]),
                        new Uint32Array([
                            2134435,
                            2134531,
                            2134627,
                            2134723,
                            2134723,
                            2134819,
                            2134819,
                            2134915,
                            2134915,
                            2135011,
                            2105987,
                            2135107,
                            2135203,
                            2135299,
                            2131587,
                            2135395
                        ]),
                        new Uint32Array([
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            6291456,
                            2168673,
                            2169249,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456
                        ]),
                        new Uint32Array([
                            2147906,
                            2147970,
                            2148034,
                            2148098,
                            2148162,
                            2148226,
                            2148290,
                            2148354,
                            2147906,
                            2147970,
                            2148034,
                            2148098,
                            2148162,
                            2148226,
                            2148290,
                            2148354
                        ]),
                        new Uint32Array([
                            2125219,
                            2125315,
                            2152834,
                            2152898,
                            2125411,
                            2152962,
                            2153026,
                            2125506,
                            2125507,
                            2125603,
                            2153090,
                            2153154,
                            2153218,
                            2153282,
                            2153346,
                            2105348
                        ]),
                        new Uint32Array([
                            2203393,
                            6291456,
                            2203425,
                            6291456,
                            2203457,
                            6291456,
                            2203489,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            2203521,
                            6291456,
                            2181281,
                            6291456,
                            6291456
                        ]),
                        new Uint32Array([
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            23068672,
                            23068672,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456
                        ]),
                        new Uint32Array([
                            6291456,
                            23068672,
                            6291456,
                            2145538,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            0,
                            0,
                            0,
                            0,
                            6291456
                        ]),
                        new Uint32Array([
                            2139426,
                            2160834,
                            2160898,
                            2160962,
                            2134242,
                            2161026,
                            2161090,
                            2161154,
                            2161218,
                            2161282,
                            2161346,
                            2161410,
                            2138658,
                            2161474,
                            2161538,
                            2134722
                        ]),
                        new Uint32Array([
                            2119939,
                            2124930,
                            2125026,
                            2106658,
                            2125218,
                            2128962,
                            2129058,
                            2129154,
                            2129250,
                            2129346,
                            2129442,
                            2108866,
                            2108770,
                            2150466,
                            2150530,
                            2150594
                        ]),
                        new Uint32Array([
                            2201601,
                            6291456,
                            2201633,
                            6291456,
                            2201665,
                            6291456,
                            2201697,
                            6291456,
                            2201729,
                            6291456,
                            2201761,
                            6291456,
                            2201793,
                            6291456,
                            2201825,
                            6291456
                        ]),
                        new Uint32Array([
                            2193537,
                            2193569,
                            2193601,
                            2193633,
                            2193665,
                            2193697,
                            2193729,
                            2193761,
                            2193793,
                            2193825,
                            2193857,
                            2193889,
                            2193921,
                            2193953,
                            2193985,
                            2194017
                        ]),
                        new Uint32Array([
                            6291456,
                            23068672,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456
                        ]),
                        new Uint32Array([
                            0,
                            6291456,
                            6291456,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0
                        ]),
                        new Uint32Array([
                            2190561,
                            6291456,
                            2190593,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            2190625,
                            6291456,
                            2190657,
                            6291456,
                            23068672
                        ]),
                        new Uint32Array([
                            2215905,
                            2215937,
                            2215969,
                            2216001,
                            2216033,
                            2216065,
                            2216097,
                            2216129,
                            2216161,
                            2216193,
                            2216225,
                            2216257,
                            2105441,
                            2216289,
                            2216321,
                            2216353
                        ]),
                        new Uint32Array([
                            23068672,
                            18884130,
                            23068672,
                            23068672,
                            23068672,
                            6291456,
                            23068672,
                            23068672,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            23068672,
                            23068672,
                            23068672
                        ]),
                        new Uint32Array([
                            23068672,
                            23068672,
                            0,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672
                        ]),
                        new Uint32Array([
                            6291456,
                            6291456,
                            23068672,
                            23068672,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0
                        ]),
                        new Uint32Array([
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672
                        ]),
                        new Uint32Array([
                            2191233,
                            2191265,
                            2191297,
                            2191329,
                            2191361,
                            2191393,
                            2191425,
                            2117377,
                            2191457,
                            2191489,
                            2191521,
                            2191553,
                            2191585,
                            2191617,
                            2191649,
                            2117953
                        ]),
                        new Uint32Array([
                            2132227,
                            2132323,
                            2132419,
                            2132419,
                            2132515,
                            2132515,
                            2132611,
                            2132707,
                            2132707,
                            2132803,
                            2132899,
                            2132899,
                            2132995,
                            2132995,
                            2133091,
                            2133187
                        ]),
                        new Uint32Array([
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456
                        ]),
                        new Uint32Array([
                            23068672,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            23068672,
                            23068672,
                            23068672,
                            6291456,
                            0,
                            0
                        ]),
                        new Uint32Array([
                            2112481,
                            2112577,
                            2098177,
                            2098305,
                            2108321,
                            2108289,
                            2100865,
                            2113153,
                            2108481,
                            2113345,
                            2113441,
                            10609889,
                            10610785,
                            10609921,
                            10610817,
                            2222241
                        ]),
                        new Uint32Array([
                            6291456,
                            6291456,
                            6291456,
                            23068672,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            23068672,
                            23068672,
                            0,
                            0
                        ]),
                        new Uint32Array([
                            2219969,
                            2157121,
                            2157441,
                            2157505,
                            2157889,
                            2157953,
                            2220001,
                            2158465,
                            2158529,
                            10575617,
                            2156994,
                            2157058,
                            2129923,
                            2130019,
                            2157122,
                            2157186
                        ]),
                        new Uint32Array([
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            0,
                            0,
                            0,
                            0,
                            0
                        ]),
                        new Uint32Array([
                            2185249,
                            6291456,
                            2185281,
                            6291456,
                            2185313,
                            6291456,
                            2185345,
                            6291456,
                            2185377,
                            6291456,
                            2185409,
                            6291456,
                            2185441,
                            6291456,
                            2185473,
                            6291456
                        ]),
                        new Uint32Array([
                            0,
                            0,
                            0,
                            0,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            0,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456
                        ]),
                        new Uint32Array([
                            6291456,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672
                        ]),
                        new Uint32Array([
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            0,
                            0,
                            23068672,
                            23068672,
                            0,
                            0,
                            23068672,
                            23068672,
                            23068672,
                            6291456,
                            0
                        ]),
                        new Uint32Array([
                            2183361,
                            6291456,
                            2183393,
                            6291456,
                            2183425,
                            6291456,
                            2183457,
                            6291456,
                            2183489,
                            6291456,
                            2183521,
                            6291456,
                            2183553,
                            6291456,
                            2183585,
                            6291456
                        ]),
                        new Uint32Array([
                            2192161,
                            2192193,
                            2192225,
                            2192257,
                            2192289,
                            2192321,
                            2192353,
                            2192385,
                            2192417,
                            2192449,
                            2192481,
                            2192513,
                            2192545,
                            2192577,
                            2192609,
                            2192641
                        ]),
                        new Uint32Array([
                            2212001,
                            2212033,
                            2212065,
                            2212097,
                            2212129,
                            2212161,
                            2212193,
                            2212225,
                            2212257,
                            2212289,
                            2212321,
                            2212353,
                            2212385,
                            2212417,
                            2212449,
                            2207265
                        ]),
                        new Uint32Array([
                            2249825,
                            2249857,
                            2249889,
                            2249921,
                            2249954,
                            2250018,
                            2250082,
                            2250145,
                            2250177,
                            2250209,
                            2250241,
                            2250274,
                            2250337,
                            2250370,
                            2250433,
                            2250465
                        ]),
                        new Uint32Array([
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            2147905,
                            2147969,
                            2148033,
                            2148097,
                            2148161,
                            2148225,
                            2148289,
                            2148353
                        ]),
                        new Uint32Array([
                            10485857,
                            6291456,
                            2197217,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456
                        ]),
                        new Uint32Array([
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            0,
                            0,
                            0,
                            0,
                            23068672,
                            23068672
                        ]),
                        new Uint32Array([
                            0,
                            23068672,
                            23068672,
                            23068672,
                            0,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            0,
                            6291456,
                            6291456
                        ]),
                        new Uint32Array([
                            2180353,
                            2180385,
                            2144033,
                            2180417,
                            2180449,
                            2180481,
                            2180513,
                            0,
                            0,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456
                        ]),
                        new Uint32Array([
                            2112481,
                            2112577,
                            2098177,
                            2098305,
                            2108321,
                            2108289,
                            2100865,
                            2113153,
                            2108481,
                            2113345,
                            2113441,
                            10610209,
                            10610465,
                            10610241,
                            10610753,
                            10609857
                        ]),
                        new Uint32Array([
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            23068672,
                            0,
                            0
                        ]),
                        new Uint32Array([
                            2223842,
                            2223906,
                            2223970,
                            2224034,
                            2224098,
                            2224162,
                            2224226,
                            2224290,
                            2224354,
                            2224418,
                            2224482,
                            2224546,
                            2224610,
                            2224674,
                            2224738,
                            2224802
                        ]),
                        new Uint32Array([
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            6291456,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672
                        ]),
                        new Uint32Array([
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            0,
                            6291456
                        ]),
                        new Uint32Array([
                            23068672,
                            23068672,
                            23068672,
                            18923650,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            0,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            18923714,
                            23068672,
                            23068672
                        ]),
                        new Uint32Array([
                            2126179,
                            2125538,
                            2126275,
                            2126371,
                            2126467,
                            2125634,
                            2126563,
                            2105603,
                            2105604,
                            2125346,
                            2126659,
                            2126755,
                            2126851,
                            2098179,
                            2098181,
                            2098182
                        ]),
                        new Uint32Array([
                            2227426,
                            2227490,
                            2227554,
                            2227618,
                            0,
                            0,
                            0,
                            0,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456
                        ]),
                        new Uint32Array([
                            2192353,
                            2240642,
                            2240642,
                            2240705,
                            2240737,
                            2240737,
                            2240769,
                            2240802,
                            2240866,
                            2240929,
                            2240961,
                            2240993,
                            2241025,
                            2241057,
                            2241089,
                            2241121
                        ]),
                        new Uint32Array([
                            6291456,
                            2170881,
                            2170913,
                            2170945,
                            6291456,
                            2170977,
                            6291456,
                            2171009,
                            2171041,
                            6291456,
                            6291456,
                            6291456,
                            2171073,
                            6291456,
                            6291456,
                            6291456
                        ]),
                        new Uint32Array([
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672
                        ]),
                        new Uint32Array([
                            2132226,
                            2132514,
                            2163586,
                            2132610,
                            2160386,
                            2133090,
                            2133186,
                            2160450,
                            2160514,
                            2160578,
                            2133570,
                            2106178,
                            2160642,
                            2133858,
                            2160706,
                            2160770
                        ]),
                        new Uint32Array([
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            0,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456
                        ]),
                        new Uint32Array([
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            10532162,
                            10532226,
                            10532290,
                            10532354,
                            10532418,
                            10532482,
                            6291456,
                            6291456
                        ]),
                        new Uint32Array([
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            0,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456
                        ]),
                        new Uint32Array([
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            6291456,
                            23068672
                        ]),
                        new Uint32Array([
                            2098209,
                            2108353,
                            2108193,
                            2108481,
                            2170241,
                            2111713,
                            2105473,
                            2105569,
                            2105601,
                            2112289,
                            2112481,
                            2098305,
                            2108321,
                            0,
                            0,
                            0
                        ]),
                        new Uint32Array([
                            2209121,
                            2209153,
                            2209185,
                            2209217,
                            2209249,
                            2209281,
                            2209313,
                            2209345,
                            2209377,
                            2209409,
                            2209441,
                            2209473,
                            2207265,
                            2209505,
                            2209537,
                            2209569
                        ]),
                        new Uint32Array([
                            2189025,
                            6291456,
                            2189057,
                            6291456,
                            2189089,
                            6291456,
                            2189121,
                            6291456,
                            2189153,
                            6291456,
                            2189185,
                            6291456,
                            2189217,
                            6291456,
                            2189249,
                            6291456
                        ]),
                        new Uint32Array([
                            2173825,
                            2153473,
                            2173857,
                            2173889,
                            2173921,
                            2173953,
                            2173985,
                            2173761,
                            2174017,
                            2174049,
                            2174081,
                            2174113,
                            2174145,
                            2174177,
                            2149057,
                            2233057
                        ]),
                        new Uint32Array([
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            2165764,
                            2140004
                        ]),
                        new Uint32Array([
                            2215105,
                            6291456,
                            2215137,
                            6291456,
                            6291456,
                            2215169,
                            2215201,
                            6291456,
                            6291456,
                            6291456,
                            2215233,
                            2215265,
                            2215297,
                            2215329,
                            2215361,
                            2215393
                        ]),
                        new Uint32Array([
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            0,
                            0,
                            6291456,
                            0,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456
                        ]),
                        new Uint32Array([
                            23068672,
                            23068672,
                            6291456,
                            6291456,
                            6291456,
                            23068672,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0
                        ]),
                        new Uint32Array([
                            10505091,
                            10505187,
                            10505283,
                            10505379,
                            10505475,
                            10505571,
                            10505667,
                            10505763,
                            10505859,
                            10505955,
                            10506051,
                            10506147,
                            10506243,
                            10506339,
                            10506435,
                            10506531
                        ]),
                        new Uint32Array([
                            2229730,
                            2229794,
                            2229858,
                            2229922,
                            2229986,
                            2230050,
                            2230114,
                            2230178,
                            2230242,
                            2230306,
                            2230370,
                            2230434,
                            2230498,
                            2230562,
                            2230626,
                            2230690
                        ]),
                        new Uint32Array([
                            2105505,
                            2098241,
                            2108353,
                            2108417,
                            2105825,
                            0,
                            2100897,
                            2111905,
                            2105473,
                            2105569,
                            2105601,
                            2112289,
                            2108193,
                            2112481,
                            2112577,
                            2098177
                        ]),
                        new Uint32Array([
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            10502115,
                            10502178,
                            10502211,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456
                        ]),
                        new Uint32Array([
                            0,
                            23068672,
                            23068672,
                            23068672,
                            0,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            0,
                            0,
                            6291456
                        ]),
                        new Uint32Array([
                            2190305,
                            6291456,
                            2190337,
                            6291456,
                            2190369,
                            6291456,
                            2190401,
                            6291456,
                            2190433,
                            6291456,
                            2190465,
                            6291456,
                            2190497,
                            6291456,
                            2190529,
                            6291456
                        ]),
                        new Uint32Array([
                            2173793,
                            2173985,
                            2174017,
                            6291456,
                            2173761,
                            2173697,
                            6291456,
                            2174689,
                            6291456,
                            2174017,
                            2174721,
                            6291456,
                            6291456,
                            2174753,
                            2174785,
                            2174817
                        ]),
                        new Uint32Array([
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456
                        ]),
                        new Uint32Array([
                            2099521,
                            2099105,
                            2120705,
                            2098369,
                            2120801,
                            2103361,
                            2097985,
                            2098433,
                            2121377,
                            2121473,
                            2099169,
                            2099873,
                            2098401,
                            2099393,
                            2152609,
                            2100033
                        ]),
                        new Uint32Array([
                            2132898,
                            2163842,
                            2163906,
                            2133282,
                            2132034,
                            2131938,
                            2137410,
                            2132802,
                            2132706,
                            2164866,
                            2133282,
                            2160578,
                            2165186,
                            2165186,
                            6291456,
                            6291456
                        ]),
                        new Uint32Array([
                            10500003,
                            10500099,
                            10500195,
                            10500291,
                            10500387,
                            10500483,
                            10500579,
                            10500675,
                            10500771,
                            10500867,
                            10500963,
                            10501059,
                            10501155,
                            10501251,
                            10501347,
                            10501443
                        ]),
                        new Uint32Array([
                            2163458,
                            2130978,
                            2131074,
                            2131266,
                            2131362,
                            2163522,
                            2160130,
                            2132066,
                            2131010,
                            2131106,
                            2106018,
                            2131618,
                            2131298,
                            2132034,
                            2131938,
                            2137410
                        ]),
                        new Uint32Array([
                            2212961,
                            2116993,
                            2212993,
                            2213025,
                            2213057,
                            2213089,
                            2213121,
                            2213153,
                            2213185,
                            2213217,
                            2213249,
                            2209633,
                            2213281,
                            2213313,
                            2213345,
                            2213377
                        ]),
                        new Uint32Array([
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            23068672,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            0,
                            6291456,
                            6291456
                        ]),
                        new Uint32Array([
                            2113729,
                            2113825,
                            2113921,
                            2114017,
                            2114113,
                            2114209,
                            2114305,
                            2114401,
                            2114497,
                            2114593,
                            2114689,
                            2114785,
                            2114881,
                            2114977,
                            2115073,
                            2115169
                        ]),
                        new Uint32Array([
                            2238177,
                            2238209,
                            2238241,
                            2238273,
                            2238305,
                            2238337,
                            2238337,
                            2217537,
                            2238369,
                            2238401,
                            2238433,
                            2238465,
                            2215649,
                            2238497,
                            2238529,
                            2238561
                        ]),
                        new Uint32Array([
                            2108289,
                            2100865,
                            2113153,
                            2108481,
                            2113345,
                            2113441,
                            2098209,
                            2111137,
                            2105505,
                            2098241,
                            2108353,
                            2108417,
                            2105825,
                            2111713,
                            2100897,
                            2111905
                        ]),
                        new Uint32Array([
                            6291456,
                            6291456,
                            0,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            0,
                            6291456,
                            0,
                            0
                        ]),
                        new Uint32Array([
                            6291456,
                            0,
                            6291456,
                            2145026,
                            0,
                            6291456,
                            2145090,
                            0,
                            6291456,
                            6291456,
                            0,
                            0,
                            23068672,
                            0,
                            23068672,
                            23068672
                        ]),
                        new Uint32Array([
                            2099233,
                            2122017,
                            2200673,
                            2098113,
                            2121537,
                            2103201,
                            2200705,
                            2104033,
                            2121857,
                            2121953,
                            2122401,
                            2099649,
                            2099969,
                            2123009,
                            2100129,
                            2100289
                        ]),
                        new Uint32Array([
                            6291456,
                            23068672,
                            6291456,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0
                        ]),
                        new Uint32Array([
                            6291456,
                            6291456,
                            23068672,
                            23068672,
                            0,
                            0,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            0,
                            0,
                            0
                        ]),
                        new Uint32Array([
                            2187681,
                            2187713,
                            2187745,
                            2187777,
                            2187809,
                            2187841,
                            2187873,
                            2187905,
                            2187937,
                            2187969,
                            2188001,
                            2188033,
                            2188065,
                            2188097,
                            2188129,
                            2188161
                        ]),
                        new Uint32Array([
                            0,
                            10554498,
                            10554562,
                            10554626,
                            10554690,
                            10554754,
                            10554818,
                            10554882,
                            10554946,
                            10555010,
                            10555074,
                            6291456,
                            6291456,
                            0,
                            0,
                            0
                        ]),
                        new Uint32Array([
                            2235170,
                            2235234,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456
                        ]),
                        new Uint32Array([
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0
                        ]),
                        new Uint32Array([
                            2181153,
                            6291456,
                            2188897,
                            6291456,
                            6291456,
                            2188929,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            2111905,
                            2100865,
                            2188961,
                            2188993
                        ]),
                        new Uint32Array([
                            2100833,
                            2100897,
                            0,
                            0,
                            2101569,
                            2101697,
                            2101825,
                            2101953,
                            2102081,
                            2102209,
                            10575617,
                            2187041,
                            10502177,
                            10489601,
                            10489697,
                            2112289
                        ]),
                        new Uint32Array([
                            6291456,
                            2172833,
                            6291456,
                            2172865,
                            2172897,
                            2172929,
                            2172961,
                            6291456,
                            2172993,
                            6291456,
                            2173025,
                            6291456,
                            2173057,
                            6291456,
                            2173089,
                            6291456
                        ]),
                        new Uint32Array([
                            6291456,
                            0,
                            6291456,
                            6291456,
                            0,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            0,
                            0,
                            23068672,
                            6291456,
                            23068672,
                            23068672
                        ]),
                        new Uint32Array([
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            2190721
                        ]),
                        new Uint32Array([
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            23068672,
                            6291456,
                            6291456
                        ]),
                        new Uint32Array([
                            2184993,
                            6291456,
                            2185025,
                            6291456,
                            2185057,
                            6291456,
                            2185089,
                            6291456,
                            2185121,
                            6291456,
                            2185153,
                            6291456,
                            2185185,
                            6291456,
                            2185217,
                            6291456
                        ]),
                        new Uint32Array([
                            2115265,
                            2115361,
                            2115457,
                            2115553,
                            2115649,
                            2115745,
                            2115841,
                            2115937,
                            2116033,
                            2116129,
                            2116225,
                            2116321,
                            2150658,
                            2150722,
                            2200225,
                            6291456
                        ]),
                        new Uint32Array([
                            2168321,
                            6291456,
                            2168353,
                            6291456,
                            2168385,
                            6291456,
                            2168417,
                            6291456,
                            2168449,
                            6291456,
                            2168481,
                            6291456,
                            2168513,
                            6291456,
                            2168545,
                            6291456
                        ]),
                        new Uint32Array([
                            23068672,
                            23068672,
                            23068672,
                            6291456,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672
                        ]),
                        new Uint32Array([
                            6291456,
                            0,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            0,
                            0,
                            0,
                            6291456,
                            6291456,
                            0,
                            6291456,
                            0,
                            6291456,
                            6291456
                        ]),
                        new Uint32Array([
                            6291456,
                            6291456,
                            6291456,
                            2186625,
                            0,
                            0,
                            6291456,
                            6291456,
                            2186657,
                            2186689,
                            2186721,
                            2173505,
                            0,
                            10496067,
                            10496163,
                            10496259
                        ]),
                        new Uint32Array([
                            2178785,
                            6291456,
                            2178817,
                            6291456,
                            2178849,
                            6291456,
                            2178881,
                            6291456,
                            2178913,
                            6291456,
                            2178945,
                            6291456,
                            2178977,
                            6291456,
                            2179009,
                            6291456
                        ]),
                        new Uint32Array([
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            0,
                            0,
                            0,
                            0,
                            0
                        ]),
                        new Uint32Array([
                            2097152,
                            0,
                            0,
                            0,
                            2097152,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0
                        ]),
                        new Uint32Array([
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            6291456,
                            6291456
                        ]),
                        new Uint32Array([
                            6291456,
                            0,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456
                        ]),
                        new Uint32Array([
                            0,
                            0,
                            2197857,
                            2197889,
                            2197921,
                            2197953,
                            2197985,
                            2198017,
                            0,
                            0,
                            2198049,
                            2198081,
                            2198113,
                            2198145,
                            2198177,
                            2198209
                        ]),
                        new Uint32Array([
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            2098209,
                            2167297,
                            2111137,
                            6291456
                        ]),
                        new Uint32Array([
                            2171393,
                            6291456,
                            2171425,
                            6291456,
                            2171457,
                            6291456,
                            2171489,
                            6291456,
                            2171521,
                            6291456,
                            2171553,
                            6291456,
                            2171585,
                            6291456,
                            2171617,
                            6291456
                        ]),
                        new Uint32Array([
                            2206753,
                            2206785,
                            2195457,
                            2206817,
                            2206849,
                            2206881,
                            2206913,
                            2197153,
                            2197153,
                            2206945,
                            2117857,
                            2206977,
                            2207009,
                            2207041,
                            2207073,
                            2207105
                        ]),
                        new Uint32Array([
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            23068672,
                            0,
                            0,
                            0,
                            0,
                            2144834,
                            2144898,
                            0,
                            2144962
                        ]),
                        new Uint32Array([
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            0,
                            0,
                            23068672
                        ]),
                        new Uint32Array([
                            2108193,
                            2112481,
                            2112577,
                            2098177,
                            2098305,
                            2108321,
                            2108289,
                            2100865,
                            2113153,
                            2108481,
                            2113345,
                            2113441,
                            2098209,
                            0,
                            2105505,
                            2098241
                        ]),
                        new Uint32Array([
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            0,
                            6291456,
                            6291456,
                            6291456,
                            0,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456
                        ]),
                        new Uint32Array([
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            0,
                            0,
                            0,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456
                        ]),
                        new Uint32Array([
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0
                        ]),
                        new Uint32Array([
                            6291456,
                            6291456,
                            2202049,
                            6291456,
                            2202081,
                            6291456,
                            2202113,
                            6291456,
                            2202145,
                            6291456,
                            2202177,
                            6291456,
                            2202209,
                            6291456,
                            2202241,
                            6291456
                        ]),
                        new Uint32Array([
                            10501155,
                            10501251,
                            10501347,
                            10501443,
                            10501539,
                            10501635,
                            10501731,
                            10501827,
                            10501923,
                            10502019,
                            2141731,
                            2105505,
                            2098177,
                            2155586,
                            2166530,
                            0
                        ]),
                        new Uint32Array([
                            2102081,
                            2102209,
                            2100833,
                            2100737,
                            2098337,
                            2101441,
                            2101569,
                            2101697,
                            2101825,
                            2101953,
                            2102081,
                            2102209,
                            2100833,
                            2100737,
                            2098337,
                            2101441
                        ]),
                        new Uint32Array([
                            2146882,
                            2146946,
                            2147010,
                            2147074,
                            2147138,
                            2147202,
                            2147266,
                            2147330,
                            2146882,
                            2146946,
                            2147010,
                            2147074,
                            2147138,
                            2147202,
                            2147266,
                            2147330
                        ]),
                        new Uint32Array([
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            0,
                            0
                        ]),
                        new Uint32Array([
                            10502307,
                            10502403,
                            10502499,
                            10502595,
                            10502691,
                            10502787,
                            10502883,
                            10502979,
                            10503075,
                            10503171,
                            10503267,
                            10503363,
                            10503459,
                            10503555,
                            10503651,
                            10503747
                        ]),
                        new Uint32Array([
                            2179937,
                            2179969,
                            2180001,
                            2180033,
                            2156545,
                            2180065,
                            2156577,
                            2180097,
                            2180129,
                            2180161,
                            2180193,
                            2180225,
                            2180257,
                            2180289,
                            2156737,
                            2180321
                        ]),
                        new Uint32Array([
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            0,
                            6291456,
                            6291456,
                            0,
                            0,
                            0,
                            6291456,
                            0,
                            0,
                            6291456
                        ]),
                        new Uint32Array([
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            0
                        ]),
                        new Uint32Array([
                            2227682,
                            2227746,
                            2227810,
                            2227874,
                            2227938,
                            2228002,
                            2228066,
                            2228130,
                            2228194,
                            2228258,
                            2228322,
                            2228386,
                            2228450,
                            2228514,
                            2228578,
                            2228642
                        ]),
                        new Uint32Array([
                            2105601,
                            2169121,
                            2108193,
                            2170049,
                            2181025,
                            2181057,
                            2112481,
                            2108321,
                            2108289,
                            2181089,
                            2170497,
                            2100865,
                            2181121,
                            2173601,
                            2173633,
                            2173665
                        ]),
                        new Uint32Array([
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            2180641,
                            6291456,
                            6291456,
                            6291456
                        ]),
                        new Uint32Array([
                            0,
                            6291456,
                            6291456,
                            6291456,
                            0,
                            6291456,
                            0,
                            6291456,
                            0,
                            0,
                            6291456,
                            6291456,
                            0,
                            6291456,
                            6291456,
                            6291456
                        ]),
                        new Uint32Array([
                            2178273,
                            6291456,
                            2178305,
                            6291456,
                            2178337,
                            6291456,
                            2178369,
                            6291456,
                            2178401,
                            6291456,
                            2178433,
                            6291456,
                            2178465,
                            6291456,
                            2178497,
                            6291456
                        ]),
                        new Uint32Array([
                            6291456,
                            6291456,
                            23068672,
                            23068672,
                            23068672,
                            6291456,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0
                        ]),
                        new Uint32Array([
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            14680064,
                            14680064,
                            14680064,
                            14680064,
                            14680064,
                            14680064
                        ]),
                        new Uint32Array([
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            6291456
                        ]),
                        new Uint32Array([
                            2237377,
                            2237409,
                            2236225,
                            2237441,
                            2237473,
                            2217441,
                            2215521,
                            2215553,
                            2217473,
                            2237505,
                            2237537,
                            2209697,
                            2237569,
                            2215585,
                            2237601,
                            2237633
                        ]),
                        new Uint32Array([
                            2221985,
                            2165601,
                            2165601,
                            2165665,
                            2165665,
                            2222017,
                            2222017,
                            2165729,
                            2165729,
                            2158913,
                            2158913,
                            2158913,
                            2158913,
                            2097281,
                            2097281,
                            2105921
                        ]),
                        new Uint32Array([
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            0,
                            23068672,
                            23068672,
                            23068672,
                            0,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            0,
                            0
                        ]),
                        new Uint32Array([
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            2149634,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456
                        ]),
                        new Uint32Array([
                            2176897,
                            6291456,
                            6291456,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            2176929,
                            6291456,
                            2176961,
                            6291456,
                            2176993,
                            6291456
                        ]),
                        new Uint32Array([
                            2172641,
                            6291456,
                            2172673,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            2172705,
                            2172737,
                            6291456,
                            2172769,
                            2172801,
                            6291456
                        ]),
                        new Uint32Array([
                            2099173,
                            2104196,
                            2121667,
                            2099395,
                            2121763,
                            2152258,
                            2152322,
                            2098946,
                            2152386,
                            2121859,
                            2121955,
                            2099333,
                            2122051,
                            2104324,
                            2099493,
                            2122147
                        ]),
                        new Uint32Array([
                            6291456,
                            6291456,
                            6291456,
                            2145794,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            0,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            2145858,
                            6291456,
                            6291456
                        ]),
                        new Uint32Array([
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            23068672,
                            23068672,
                            23068672,
                            0,
                            0,
                            6291456,
                            0
                        ]),
                        new Uint32Array([
                            0,
                            2105921,
                            2097729,
                            0,
                            2097377,
                            0,
                            0,
                            2106017,
                            0,
                            2097505,
                            2105889,
                            2097185,
                            2097697,
                            2135777,
                            2097633,
                            2097441
                        ]),
                        new Uint32Array([
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672
                        ]),
                        new Uint32Array([
                            2239074,
                            2239138,
                            2239201,
                            2239233,
                            2239265,
                            2239297,
                            2239329,
                            2239361,
                            0,
                            2239393,
                            2239425,
                            2239425,
                            2239458,
                            2239521,
                            2239553,
                            2209569
                        ]),
                        new Uint32Array([
                            14680064,
                            2098209,
                            2111137,
                            2105505,
                            2098241,
                            2108353,
                            2108417,
                            2105825,
                            2111713,
                            2100897,
                            2111905,
                            2105473,
                            2105569,
                            2105601,
                            2112289,
                            2108193
                        ]),
                        new Uint32Array([
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            0,
                            6291456,
                            23068672
                        ]),
                        new Uint32Array([
                            2108321,
                            2108289,
                            2113153,
                            2098209,
                            2180897,
                            2180929,
                            2180961,
                            2111137,
                            2098241,
                            2108353,
                            2170241,
                            2170273,
                            2180993,
                            2105825,
                            6291456,
                            2105473
                        ]),
                        new Uint32Array([
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            2146114,
                            6291456,
                            6291456,
                            6291456,
                            0,
                            0,
                            0
                        ]),
                        new Uint32Array([
                            2105921,
                            2105921,
                            2105921,
                            2222049,
                            2222049,
                            2130977,
                            2130977,
                            2130977,
                            2130977,
                            2160065,
                            2160065,
                            2160065,
                            2160065,
                            2097729,
                            2097729,
                            2097729
                        ]),
                        new Uint32Array([
                            2218145,
                            2214785,
                            2207937,
                            2218177,
                            2218209,
                            2192993,
                            2210113,
                            2212769,
                            2218241,
                            2218273,
                            2216129,
                            2218305,
                            2216161,
                            2218337,
                            2218369,
                            2218401
                        ]),
                        new Uint32Array([
                            0,
                            0,
                            0,
                            2156546,
                            2156610,
                            2156674,
                            2156738,
                            2156802,
                            0,
                            0,
                            0,
                            0,
                            0,
                            2156866,
                            23068672,
                            2156930
                        ]),
                        new Uint32Array([
                            23068672,
                            23068672,
                            23068672,
                            0,
                            0,
                            0,
                            0,
                            23068672,
                            23068672,
                            0,
                            0,
                            23068672,
                            23068672,
                            23068672,
                            0,
                            0
                        ]),
                        new Uint32Array([
                            2213409,
                            2213441,
                            2213473,
                            2213505,
                            2213537,
                            2213569,
                            2213601,
                            2213633,
                            2213665,
                            2195681,
                            2213697,
                            2213729,
                            2213761,
                            2213793,
                            2213825,
                            2213857
                        ]),
                        new Uint32Array([
                            2100033,
                            2099233,
                            2122017,
                            2200673,
                            2098113,
                            2121537,
                            2103201,
                            2200705,
                            2104033,
                            2121857,
                            2121953,
                            2122401,
                            2099649,
                            2099969,
                            2123009,
                            2100129
                        ]),
                        new Uint32Array([
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0
                        ]),
                        new Uint32Array([
                            2201857,
                            6291456,
                            2201889,
                            6291456,
                            2201921,
                            6291456,
                            2201953,
                            6291456,
                            2201985,
                            6291456,
                            2202017,
                            6291456,
                            2176193,
                            2176257,
                            23068672,
                            23068672
                        ]),
                        new Uint32Array([
                            6291456,
                            6291456,
                            23068672,
                            23068672,
                            0,
                            0,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456
                        ]),
                        new Uint32Array([
                            2188193,
                            2188225,
                            2188257,
                            2188289,
                            2188321,
                            2188353,
                            2188385,
                            2188417,
                            2188449,
                            2188481,
                            2188513,
                            2188545,
                            2188577,
                            2188609,
                            2188641,
                            0
                        ]),
                        new Uint32Array([
                            10554529,
                            2221089,
                            0,
                            10502113,
                            10562017,
                            10537921,
                            10538049,
                            2221121,
                            2221153,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0
                        ]),
                        new Uint32Array([
                            2213889,
                            2213921,
                            2213953,
                            2213985,
                            2214017,
                            2214049,
                            2214081,
                            2194177,
                            2214113,
                            2214145,
                            2214177,
                            2214209,
                            2214241,
                            2214273,
                            2214305,
                            2214337
                        ]),
                        new Uint32Array([
                            2166978,
                            2167042,
                            2099169,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0
                        ]),
                        new Uint32Array([
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            2180545,
                            6291456,
                            6291456,
                            6291456
                        ]),
                        new Uint32Array([
                            10518915,
                            10519011,
                            10519107,
                            10519203,
                            2162242,
                            2162306,
                            2159554,
                            2162370,
                            2159362,
                            2159618,
                            2105922,
                            2162434,
                            2159746,
                            2162498,
                            2159810,
                            2159874
                        ]),
                        new Uint32Array([
                            2161730,
                            2161794,
                            2135586,
                            2161858,
                            2161922,
                            2137186,
                            2131810,
                            2160290,
                            2135170,
                            2161986,
                            2137954,
                            2162050,
                            2162114,
                            2162178,
                            10518723,
                            10518819
                        ]),
                        new Uint32Array([
                            10506627,
                            10506723,
                            10506819,
                            10506915,
                            10507011,
                            10507107,
                            10507203,
                            10507299,
                            10507395,
                            10507491,
                            10507587,
                            10507683,
                            10507779,
                            10507875,
                            10507971,
                            10508067
                        ]),
                        new Uint32Array([
                            6291456,
                            23068672,
                            23068672,
                            23068672,
                            0,
                            23068672,
                            23068672,
                            0,
                            0,
                            0,
                            0,
                            0,
                            23068672,
                            23068672,
                            23068672,
                            23068672
                        ]),
                        new Uint32Array([
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            0,
                            0,
                            0,
                            0,
                            0
                        ]),
                        new Uint32Array([
                            2175873,
                            2175905,
                            2175937,
                            2175969,
                            2176001,
                            2176033,
                            2176065,
                            2176097,
                            2176129,
                            2176161,
                            2176193,
                            2176225,
                            2176257,
                            2176289,
                            2176321,
                            2176353
                        ]),
                        new Uint32Array([
                            2140006,
                            2140198,
                            2140390,
                            2140582,
                            2140774,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            6291456,
                            6291456,
                            6291456,
                            23068672,
                            23068672,
                            23068672
                        ]),
                        new Uint32Array([
                            2108193,
                            2112481,
                            2112577,
                            2098177,
                            2098305,
                            2108321,
                            2108289,
                            2100865,
                            2113153,
                            2108481,
                            2113345,
                            2113441,
                            2098209,
                            2111137,
                            2105505,
                            2098241
                        ]),
                        new Uint32Array([
                            0,
                            23068672,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            2145154,
                            2145218,
                            2145282,
                            6291456,
                            0,
                            2145346,
                            0
                        ]),
                        new Uint32Array([
                            0,
                            0,
                            0,
                            0,
                            10531458,
                            10495395,
                            2148545,
                            2143201,
                            2173473,
                            2148865,
                            2173505,
                            0,
                            2173537,
                            0,
                            2173569,
                            2149121
                        ]),
                        new Uint32Array([
                            10537282,
                            10495683,
                            2148738,
                            2148802,
                            2148866,
                            0,
                            6291456,
                            2148930,
                            2186593,
                            2173473,
                            2148737,
                            2148865,
                            2148802,
                            10495779,
                            10495875,
                            10495971
                        ]),
                        new Uint32Array([
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0
                        ]),
                        new Uint32Array([
                            2215425,
                            2215457,
                            2215489,
                            2215521,
                            2215553,
                            2215585,
                            2215617,
                            2215649,
                            2215681,
                            2215713,
                            2215745,
                            2215777,
                            2192033,
                            2215809,
                            2215841,
                            2215873
                        ]),
                        new Uint32Array([
                            2242049,
                            2242081,
                            2242113,
                            2242145,
                            2242177,
                            2242209,
                            2242241,
                            2242273,
                            2215937,
                            2242305,
                            2242338,
                            2242401,
                            2242433,
                            2242465,
                            2242497,
                            2216001
                        ]),
                        new Uint32Array([
                            10554529,
                            2221089,
                            0,
                            0,
                            10562017,
                            10502113,
                            10538049,
                            10537921,
                            2221185,
                            10489601,
                            10489697,
                            10609889,
                            10609921,
                            2141729,
                            2141793,
                            10610273
                        ]),
                        new Uint32Array([
                            2141923,
                            2142019,
                            2142115,
                            2142211,
                            2142307,
                            2142403,
                            2142499,
                            2142595,
                            2142691,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0
                        ]),
                        new Uint32Array([
                            0,
                            2221185,
                            2221217,
                            10609857,
                            10609857,
                            10489601,
                            10489697,
                            10609889,
                            10609921,
                            2141729,
                            2141793,
                            2221345,
                            2221377,
                            2221409,
                            2221441,
                            2187105
                        ]),
                        new Uint32Array([
                            6291456,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456
                        ]),
                        new Uint32Array([
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            0
                        ]),
                        new Uint32Array([
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            18923970,
                            23068672,
                            23068672,
                            23068672,
                            0,
                            6291456,
                            6291456
                        ]),
                        new Uint32Array([
                            2183105,
                            6291456,
                            2183137,
                            6291456,
                            2183169,
                            6291456,
                            2183201,
                            6291456,
                            2183233,
                            6291456,
                            2183265,
                            6291456,
                            2183297,
                            6291456,
                            2183329,
                            6291456
                        ]),
                        new Uint32Array([
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            0,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            0
                        ]),
                        new Uint32Array([
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            6291456,
                            6291456,
                            6291456,
                            6291456
                        ]),
                        new Uint32Array([
                            2134434,
                            2134818,
                            2097666,
                            2097186,
                            2097474,
                            2097698,
                            2105986,
                            2131586,
                            2132450,
                            2131874,
                            2131778,
                            2135970,
                            2135778,
                            2161602,
                            2136162,
                            2161666
                        ]),
                        new Uint32Array([
                            2236865,
                            2236897,
                            2236930,
                            2236993,
                            2237025,
                            2235681,
                            2237058,
                            2237121,
                            2237153,
                            2237185,
                            2237217,
                            2217281,
                            2237250,
                            2191233,
                            2237313,
                            2237345
                        ]),
                        new Uint32Array([
                            2190049,
                            6291456,
                            2190081,
                            6291456,
                            2190113,
                            6291456,
                            2190145,
                            6291456,
                            2190177,
                            6291456,
                            2190209,
                            6291456,
                            2190241,
                            6291456,
                            2190273,
                            6291456
                        ]),
                        new Uint32Array([
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            23068672,
                            23068672,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456
                        ]),
                        new Uint32Array([
                            2101922,
                            2102050,
                            2102178,
                            2102306,
                            10498755,
                            10498851,
                            10498947,
                            10499043,
                            10499139,
                            10499235,
                            10499331,
                            10499427,
                            10499523,
                            10489604,
                            10489732,
                            10489860
                        ]),
                        new Uint32Array([
                            2166914,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456
                        ]),
                        new Uint32Array([
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            0,
                            0,
                            0,
                            0,
                            0
                        ]),
                        new Uint32Array([
                            2181601,
                            2170561,
                            2181633,
                            2181665,
                            2170753,
                            2181697,
                            2172897,
                            2170881,
                            2181729,
                            2170913,
                            2172929,
                            2113441,
                            2181761,
                            2181793,
                            2171009,
                            2173761
                        ]),
                        new Uint32Array([
                            0,
                            2105921,
                            2097729,
                            2106081,
                            0,
                            2097601,
                            2162337,
                            2106017,
                            2133281,
                            2097505,
                            0,
                            2097185,
                            2097697,
                            2135777,
                            2097633,
                            2097441
                        ]),
                        new Uint32Array([
                            6291456,
                            6291456,
                            6291456,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            0,
                            0,
                            0,
                            0
                        ]),
                        new Uint32Array([
                            2248001,
                            2248033,
                            2248066,
                            2248130,
                            2248193,
                            2248226,
                            2248289,
                            2248322,
                            2248385,
                            2248417,
                            2216673,
                            2248450,
                            2248514,
                            2248577,
                            2248610,
                            2248673
                        ]),
                        new Uint32Array([
                            6291456,
                            6291456,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            0,
                            0,
                            0
                        ]),
                        new Uint32Array([
                            2169729,
                            6291456,
                            2169761,
                            6291456,
                            2169793,
                            6291456,
                            2169825,
                            6291456,
                            2169857,
                            2169889,
                            6291456,
                            2169921,
                            6291456,
                            2143329,
                            6291456,
                            2098305
                        ]),
                        new Uint32Array([
                            2162178,
                            2163202,
                            2163266,
                            2135170,
                            2136226,
                            2161986,
                            2137954,
                            2159426,
                            2159490,
                            2163330,
                            2159554,
                            2163394,
                            2159682,
                            2139522,
                            2136450,
                            2159746
                        ]),
                        new Uint32Array([
                            2173953,
                            2173985,
                            0,
                            2174017,
                            2174049,
                            2174081,
                            2174113,
                            2174145,
                            2174177,
                            2149057,
                            2174209,
                            2174241,
                            6291456,
                            6291456,
                            6291456,
                            6291456
                        ]),
                        new Uint32Array([
                            6291456,
                            6291456,
                            4271169,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            2174273
                        ]),
                        new Uint32Array([
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672
                        ]),
                        new Uint32Array([
                            6291456,
                            6291456,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            6291456,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0
                        ]),
                        new Uint32Array([
                            6291456,
                            6291456,
                            6291456,
                            2190785,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0
                        ]),
                        new Uint32Array([
                            2189793,
                            6291456,
                            2189825,
                            6291456,
                            2189857,
                            6291456,
                            2189889,
                            6291456,
                            2189921,
                            6291456,
                            2189953,
                            6291456,
                            2189985,
                            6291456,
                            2190017,
                            6291456
                        ]),
                        new Uint32Array([
                            2105601,
                            2112289,
                            2108193,
                            2112481,
                            2112577,
                            0,
                            2098305,
                            2108321,
                            2108289,
                            2100865,
                            2113153,
                            2108481,
                            2113345,
                            0,
                            2098209,
                            2111137
                        ]),
                        new Uint32Array([
                            2172129,
                            6291456,
                            2172161,
                            6291456,
                            2172193,
                            6291456,
                            2172225,
                            6291456,
                            2172257,
                            6291456,
                            2172289,
                            6291456,
                            2172321,
                            6291456,
                            2172353,
                            6291456
                        ]),
                        new Uint32Array([
                            2214753,
                            6291456,
                            2214785,
                            6291456,
                            6291456,
                            2214817,
                            2214849,
                            2214881,
                            2214913,
                            2214945,
                            2214977,
                            2215009,
                            2215041,
                            2215073,
                            2194401,
                            6291456
                        ]),
                        new Uint32Array([
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            6291456,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0
                        ]),
                        new Uint32Array([
                            0,
                            0,
                            0,
                            0,
                            6291456,
                            6291456,
                            6291456,
                            23068672,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456
                        ]),
                        new Uint32Array([
                            10610305,
                            10610337,
                            10575617,
                            2221761,
                            10610401,
                            10610433,
                            10502177,
                            0,
                            10610465,
                            10610497,
                            10610529,
                            10610561,
                            0,
                            0,
                            0,
                            0
                        ]),
                        new Uint32Array([
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            0,
                            0,
                            0,
                            23068672,
                            0,
                            0,
                            0,
                            0,
                            23068672
                        ]),
                        new Uint32Array([
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            2187105,
                            2187137,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456
                        ]),
                        new Uint32Array([
                            2199393,
                            2199425,
                            2199457,
                            2199489,
                            2199521,
                            2199553,
                            2199585,
                            2199617,
                            2199649,
                            2199681,
                            2199713,
                            2199745,
                            2199777,
                            2199809,
                            2199841,
                            0
                        ]),
                        new Uint32Array([
                            2217249,
                            2217281,
                            2217313,
                            2217345,
                            2217377,
                            2217409,
                            2217441,
                            2217473,
                            2215617,
                            2217505,
                            2217537,
                            2217569,
                            2214753,
                            2217601,
                            2217633,
                            2217665
                        ]),
                        new Uint32Array([
                            2170273,
                            2170305,
                            6291456,
                            2170337,
                            2170369,
                            6291456,
                            2170401,
                            2170433,
                            2170465,
                            6291456,
                            6291456,
                            6291456,
                            2170497,
                            2170529,
                            6291456,
                            2170561
                        ]),
                        new Uint32Array([
                            2188673,
                            6291456,
                            2188705,
                            2188737,
                            2188769,
                            6291456,
                            6291456,
                            2188801,
                            6291456,
                            2188833,
                            6291456,
                            2188865,
                            6291456,
                            2180929,
                            2181505,
                            2180897
                        ]),
                        new Uint32Array([
                            10489988,
                            10490116,
                            10490244,
                            10490372,
                            10490500,
                            10490628,
                            10490756,
                            10490884,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0
                        ]),
                        new Uint32Array([
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            2147393,
                            2147457,
                            2147521,
                            2147585,
                            2147649,
                            2147713,
                            2147777,
                            2147841
                        ]),
                        new Uint32Array([
                            23068672,
                            23068672,
                            0,
                            23068672,
                            23068672,
                            0,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            0,
                            0,
                            0,
                            0,
                            0
                        ]),
                        new Uint32Array([
                            2241153,
                            2241185,
                            2241217,
                            2215809,
                            2241250,
                            2241313,
                            2241345,
                            2241377,
                            2217921,
                            2241377,
                            2241409,
                            2215873,
                            2241441,
                            2241473,
                            2241505,
                            2241537
                        ]),
                        new Uint32Array([
                            23068672,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456
                        ]),
                        new Uint32Array([
                            2220417,
                            2220417,
                            2220449,
                            2220449,
                            2220481,
                            2220481,
                            2220513,
                            2220513,
                            2220545,
                            2220545,
                            2220577,
                            2220577,
                            2220609,
                            2220609,
                            2220641,
                            2220641
                        ]),
                        new Uint32Array([
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            2144002,
                            0,
                            6291456,
                            6291456,
                            0,
                            0,
                            6291456,
                            6291456,
                            6291456
                        ]),
                        new Uint32Array([
                            2167105,
                            2167137,
                            2167169,
                            2167201,
                            2167233,
                            2167265,
                            2167297,
                            2167329,
                            2167361,
                            2167393,
                            2167425,
                            2167457,
                            2167489,
                            2167521,
                            2167553,
                            2167585
                        ]),
                        new Uint32Array([
                            10575521,
                            2098209,
                            2111137,
                            2105505,
                            2098241,
                            2108353,
                            2108417,
                            2105825,
                            2111713,
                            2100897,
                            2111905,
                            2105473,
                            2105569,
                            2105601,
                            2112289,
                            2108193
                        ]),
                        new Uint32Array([
                            2234146,
                            2234210,
                            2234274,
                            2234338,
                            2234402,
                            2234466,
                            2234530,
                            2234594,
                            2234658,
                            2234722,
                            2234786,
                            2234850,
                            2234914,
                            2234978,
                            2235042,
                            2235106
                        ]),
                        new Uint32Array([
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            2180577,
                            0,
                            0,
                            0,
                            0,
                            0,
                            2180609,
                            0,
                            0
                        ]),
                        new Uint32Array([
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            0,
                            0,
                            6291456,
                            6291456
                        ]),
                        new Uint32Array([
                            2098209,
                            2111137,
                            2105505,
                            2098241,
                            2108353,
                            2108417,
                            2105825,
                            2111713,
                            2100897,
                            2111905,
                            2105473,
                            2105569,
                            2105601,
                            2112289,
                            2108193,
                            2112481
                        ]),
                        new Uint32Array([
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456
                        ]),
                        new Uint32Array([
                            2242529,
                            2242561,
                            2242593,
                            2242625,
                            2242657,
                            2242689,
                            2242721,
                            2242753,
                            2207937,
                            2218177,
                            2242785,
                            2242817,
                            2242849,
                            2242882,
                            2242945,
                            2242977
                        ]),
                        new Uint32Array([
                            2118049,
                            2105345,
                            2118241,
                            2105441,
                            2118433,
                            2118529,
                            2118625,
                            2118721,
                            2118817,
                            2200257,
                            2200289,
                            2191809,
                            2200321,
                            2200353,
                            2200385,
                            2200417
                        ]),
                        new Uint32Array([
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            23068672,
                            23068672,
                            23068672,
                            6291456,
                            6291456
                        ]),
                        new Uint32Array([
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            0,
                            0,
                            0,
                            0
                        ]),
                        new Uint32Array([
                            2185505,
                            6291456,
                            2185537,
                            6291456,
                            2185569,
                            6291456,
                            2185601,
                            6291456,
                            2185633,
                            6291456,
                            2185665,
                            6291456,
                            2185697,
                            6291456,
                            2185729,
                            6291456
                        ]),
                        new Uint32Array([
                            2231970,
                            2232034,
                            2232098,
                            2232162,
                            2232226,
                            2232290,
                            2232354,
                            2232418,
                            2232482,
                            2232546,
                            2232610,
                            2232674,
                            2232738,
                            2232802,
                            2232866,
                            2232930
                        ]),
                        new Uint32Array([
                            2218625,
                            2246402,
                            2246466,
                            2246530,
                            2246594,
                            2246657,
                            2246689,
                            2246689,
                            2218657,
                            2219681,
                            2246721,
                            2246753,
                            2246785,
                            2246818,
                            2246881,
                            2208481
                        ]),
                        new Uint32Array([
                            2197025,
                            2197057,
                            2197089,
                            2197121,
                            2197153,
                            2197185,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0
                        ]),
                        new Uint32Array([
                            2219137,
                            2216961,
                            2219169,
                            2219201,
                            2219233,
                            2219265,
                            2219297,
                            2217025,
                            2215041,
                            2219329,
                            2217057,
                            2219361,
                            2217089,
                            2219393,
                            2197153,
                            2219426
                        ]),
                        new Uint32Array([
                            23068672,
                            23068672,
                            23068672,
                            0,
                            0,
                            0,
                            23068672,
                            23068672,
                            23068672,
                            0,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            0,
                            0
                        ]),
                        new Uint32Array([
                            2098305,
                            2108321,
                            2108289,
                            2100865,
                            2113153,
                            2108481,
                            2113345,
                            2113441,
                            2098209,
                            2111137,
                            2105505,
                            2098241,
                            2108353,
                            2108417,
                            2105825,
                            2111713
                        ]),
                        new Uint32Array([
                            2243522,
                            2243585,
                            2243617,
                            2243649,
                            2243681,
                            2210113,
                            2243713,
                            2243746,
                            2243810,
                            2243874,
                            2243937,
                            2243970,
                            2244033,
                            2244065,
                            2244097,
                            2244129
                        ]),
                        new Uint32Array([
                            2178017,
                            6291456,
                            2178049,
                            6291456,
                            2178081,
                            6291456,
                            2178113,
                            6291456,
                            2178145,
                            6291456,
                            2178177,
                            6291456,
                            2178209,
                            6291456,
                            2178241,
                            6291456
                        ]),
                        new Uint32Array([
                            10553858,
                            2165314,
                            10518722,
                            6291456,
                            10518818,
                            0,
                            10518914,
                            2130690,
                            10519010,
                            2130786,
                            10519106,
                            2130882,
                            10519202,
                            2165378,
                            10554050,
                            2165506
                        ]),
                        new Uint32Array([
                            0,
                            0,
                            2135491,
                            2135587,
                            2135683,
                            2135779,
                            2135875,
                            2135971,
                            2135971,
                            2136067,
                            2136163,
                            2136259,
                            2136355,
                            2136355,
                            2136451,
                            2136547
                        ]),
                        new Uint32Array([
                            23068672,
                            23068672,
                            23068672,
                            6291456,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            6291456,
                            6291456
                        ]),
                        new Uint32Array([
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            6291456,
                            6291456,
                            6291456,
                            6291456
                        ]),
                        new Uint32Array([
                            23068672,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0
                        ]),
                        new Uint32Array([
                            2220033,
                            2220033,
                            2220065,
                            2220065,
                            2220065,
                            2220065,
                            2220097,
                            2220097,
                            2220097,
                            2220097,
                            2220129,
                            2220129,
                            2220129,
                            2220129,
                            2220161,
                            2220161
                        ]),
                        new Uint32Array([
                            6291456,
                            6291456,
                            6291456,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456
                        ]),
                        new Uint32Array([
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            0,
                            23068672,
                            0,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672
                        ]),
                        new Uint32Array([
                            2100897,
                            2100898,
                            2100899,
                            2150018,
                            2100865,
                            2100866,
                            2100867,
                            2100868,
                            2150082,
                            2108481,
                            2109858,
                            2109859,
                            2105569,
                            2105505,
                            2098241,
                            2105601
                        ]),
                        new Uint32Array([
                            2097217,
                            2097505,
                            2097505,
                            2097505,
                            2097505,
                            2165570,
                            2165570,
                            2165634,
                            2165634,
                            2165698,
                            2165698,
                            2097858,
                            2097858,
                            0,
                            0,
                            2097152
                        ]),
                        new Uint32Array([
                            23068672,
                            6291456,
                            23068672,
                            23068672,
                            23068672,
                            6291456,
                            6291456,
                            23068672,
                            23068672,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            23068672,
                            23068672
                        ]),
                        new Uint32Array([
                            23068672,
                            23068672,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            0,
                            0
                        ]),
                        new Uint32Array([
                            10503843,
                            10503939,
                            10504035,
                            10504131,
                            10504227,
                            10504323,
                            10504419,
                            10504515,
                            10504611,
                            10504707,
                            10504803,
                            10504899,
                            10504995,
                            10491140,
                            10491268,
                            0
                        ]),
                        new Uint32Array([
                            2173697,
                            2173729,
                            2148801,
                            2173761,
                            2143969,
                            2173793,
                            2173825,
                            2153473,
                            2173857,
                            2173889,
                            2173921,
                            2173953,
                            2173985,
                            2173761,
                            2174017,
                            2174049
                        ]),
                        new Uint32Array([
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            0,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672
                        ]),
                        new Uint32Array([
                            2134145,
                            2097153,
                            2134241,
                            2105953,
                            2132705,
                            2130977,
                            2160065,
                            2131297,
                            2162049,
                            2133089,
                            2160577,
                            2133857,
                            2235297,
                            2220769,
                            2235329,
                            2235361
                        ]),
                        new Uint32Array([
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672
                        ]),
                        new Uint32Array([
                            2222401,
                            2222433,
                            2222465,
                            10531394,
                            2222497,
                            2222529,
                            2222561,
                            0,
                            2222593,
                            2222625,
                            2222657,
                            2222689,
                            2222721,
                            2222753,
                            2222785,
                            0
                        ]),
                        new Uint32Array([
                            2184481,
                            6291456,
                            2184513,
                            6291456,
                            2184545,
                            6291456,
                            2184577,
                            6291456,
                            2184609,
                            6291456,
                            2184641,
                            6291456,
                            2184673,
                            6291456,
                            2184705,
                            6291456
                        ]),
                        new Uint32Array([
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            23068672,
                            23068672
                        ]),
                        new Uint32Array([
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            23068672,
                            23068672,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0
                        ]),
                        new Uint32Array([
                            2105570,
                            2156034,
                            2126947,
                            2156098,
                            2153666,
                            2127043,
                            2127139,
                            2156162,
                            0,
                            2127235,
                            2156226,
                            2156290,
                            2156354,
                            2156418,
                            2127331,
                            2127427
                        ]),
                        new Uint32Array([
                            2215905,
                            2207041,
                            2153185,
                            2241569,
                            2241601,
                            2241633,
                            2241665,
                            2241697,
                            2241730,
                            2241793,
                            2241825,
                            2241857,
                            2241889,
                            2241921,
                            2241954,
                            2242017
                        ]),
                        new Uint32Array([
                            2203777,
                            6291456,
                            2203809,
                            6291456,
                            2203841,
                            6291456,
                            2203873,
                            6291456,
                            2203905,
                            6291456,
                            2173121,
                            2180993,
                            2181249,
                            2203937,
                            2181313,
                            0
                        ]),
                        new Uint32Array([
                            2168577,
                            6291456,
                            2168609,
                            6291456,
                            2168641,
                            6291456,
                            2168673,
                            6291456,
                            2168705,
                            6291456,
                            2168737,
                            6291456,
                            2168769,
                            6291456,
                            2168801,
                            6291456
                        ]),
                        new Uint32Array([
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            0,
                            0,
                            6291456,
                            23068672,
                            23068672,
                            6291456
                        ]),
                        new Uint32Array([
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            0,
                            23068672,
                            23068672,
                            23068672,
                            0,
                            23068672,
                            23068672,
                            23068672,
                            0,
                            0
                        ]),
                        new Uint32Array([
                            2210113,
                            2195521,
                            2210145,
                            2210177,
                            2210209,
                            2210241,
                            2210273,
                            2210305,
                            2210337,
                            2210369,
                            2210401,
                            2210433,
                            2210465,
                            2210497,
                            2210529,
                            2210561
                        ]),
                        new Uint32Array([
                            6291456,
                            0,
                            0,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            0
                        ]),
                        new Uint32Array([
                            2228706,
                            2228770,
                            2228834,
                            2228898,
                            2228962,
                            2229026,
                            2229090,
                            2229154,
                            2229218,
                            2229282,
                            2229346,
                            2229410,
                            2229474,
                            2229538,
                            2229602,
                            2229666
                        ]),
                        new Uint32Array([
                            23068672,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0
                        ]),
                        new Uint32Array([
                            6291456,
                            6291456,
                            6291456,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            6291456
                        ]),
                        new Uint32Array([
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            0,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            18874368,
                            18874368,
                            18874368,
                            0,
                            0
                        ]),
                        new Uint32Array([
                            2133089,
                            2133281,
                            2133281,
                            2133281,
                            2133281,
                            2160577,
                            2160577,
                            2160577,
                            2160577,
                            2097441,
                            2097441,
                            2097441,
                            2097441,
                            2133857,
                            2133857,
                            2133857
                        ]),
                        new Uint32Array([
                            6291456,
                            0,
                            0,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456
                        ]),
                        new Uint32Array([
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            0,
                            0,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456
                        ]),
                        new Uint32Array([
                            2173825,
                            2153473,
                            2173857,
                            2173889,
                            2173921,
                            2173953,
                            2173985,
                            2174017,
                            2174017,
                            2174049,
                            2174081,
                            2174113,
                            2174145,
                            2174177,
                            2149057,
                            2233089
                        ]),
                        new Uint32Array([
                            2178529,
                            6291456,
                            2178561,
                            6291456,
                            2178593,
                            6291456,
                            2178625,
                            6291456,
                            2178657,
                            6291456,
                            2178689,
                            6291456,
                            2178721,
                            6291456,
                            2178753,
                            6291456
                        ]),
                        new Uint32Array([
                            2221025,
                            2221025,
                            2221057,
                            2221057,
                            2159329,
                            2159329,
                            2159329,
                            2159329,
                            2097217,
                            2097217,
                            2158914,
                            2158914,
                            2158978,
                            2158978,
                            2159042,
                            2159042
                        ]),
                        new Uint32Array([
                            2208161,
                            2208193,
                            2208225,
                            2208257,
                            2194433,
                            2208289,
                            2208321,
                            2208353,
                            2208385,
                            2208417,
                            2208449,
                            2208481,
                            2208513,
                            2208545,
                            2208577,
                            2208609
                        ]),
                        new Uint32Array([
                            2169217,
                            6291456,
                            2169249,
                            6291456,
                            2169281,
                            6291456,
                            2169313,
                            6291456,
                            2169345,
                            6291456,
                            2169377,
                            6291456,
                            2169409,
                            6291456,
                            2169441,
                            6291456
                        ]),
                        new Uint32Array([
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            0,
                            0,
                            6291456,
                            6291456,
                            6291456,
                            6291456
                        ]),
                        new Uint32Array([
                            2133187,
                            2133283,
                            2133283,
                            2133379,
                            2133475,
                            2133571,
                            2133667,
                            2133667,
                            2133763,
                            2133859,
                            2133955,
                            2134051,
                            2134147,
                            2134147,
                            2134243,
                            2134339
                        ]),
                        new Uint32Array([
                            2197697,
                            2114113,
                            2114209,
                            2197729,
                            2197761,
                            2114305,
                            2197793,
                            2114401,
                            2114497,
                            2197825,
                            2114593,
                            2114689,
                            2114785,
                            2114881,
                            2114977,
                            0
                        ]),
                        new Uint32Array([
                            2193089,
                            2193121,
                            2193153,
                            2193185,
                            2117665,
                            2117569,
                            2193217,
                            2193249,
                            2193281,
                            2193313,
                            2193345,
                            2193377,
                            2193409,
                            2193441,
                            2193473,
                            2193505
                        ]),
                        new Uint32Array([
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672
                        ]),
                        new Uint32Array([
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            0,
                            0,
                            0
                        ]),
                        new Uint32Array([
                            6291456,
                            6291456,
                            6291456,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0
                        ]),
                        new Uint32Array([
                            6291456,
                            6291456,
                            6291456,
                            0,
                            0,
                            0,
                            0,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456
                        ]),
                        new Uint32Array([
                            2184225,
                            6291456,
                            2184257,
                            6291456,
                            2184289,
                            6291456,
                            2184321,
                            6291456,
                            2184353,
                            6291456,
                            2184385,
                            6291456,
                            2184417,
                            6291456,
                            2184449,
                            6291456
                        ]),
                        new Uint32Array([
                            2112577,
                            2098177,
                            2098305,
                            2108321,
                            2108289,
                            2100865,
                            2113153,
                            2108481,
                            2113345,
                            2113441,
                            2100833,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456
                        ]),
                        new Uint32Array([
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672
                        ]),
                        new Uint32Array([
                            2098657,
                            2098049,
                            2200737,
                            2123489,
                            2123681,
                            2200769,
                            2098625,
                            2100321,
                            2098145,
                            2100449,
                            2098017,
                            2098753,
                            2200801,
                            2200833,
                            2200865,
                            0
                        ]),
                        new Uint32Array([
                            23068672,
                            23068672,
                            23068672,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672
                        ]),
                        new Uint32Array([
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            0,
                            0,
                            0,
                            0,
                            0
                        ]),
                        new Uint32Array([
                            2098305,
                            2108321,
                            2108289,
                            2100865,
                            2113153,
                            2108481,
                            2113345,
                            2113441,
                            2098209,
                            2111137,
                            0,
                            2098241,
                            2108353,
                            2108417,
                            2105825,
                            0
                        ]),
                        new Uint32Array([
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            2181153,
                            2105505,
                            2181185,
                            2167617,
                            2180993
                        ]),
                        new Uint32Array([
                            2160002,
                            2160066,
                            2160130,
                            2160194,
                            2160258,
                            2132066,
                            2131010,
                            2131106,
                            2106018,
                            2131618,
                            2160322,
                            2131298,
                            2132034,
                            2131938,
                            2137410,
                            2132226
                        ]),
                        new Uint32Array([
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            6291456
                        ]),
                        new Uint32Array([
                            2183617,
                            6291456,
                            2183649,
                            6291456,
                            2183681,
                            6291456,
                            2183713,
                            6291456,
                            2183745,
                            6291456,
                            2183777,
                            6291456,
                            2183809,
                            6291456,
                            2183841,
                            6291456
                        ]),
                        new Uint32Array([
                            0,
                            6291456,
                            6291456,
                            0,
                            6291456,
                            0,
                            0,
                            6291456,
                            6291456,
                            0,
                            6291456,
                            0,
                            0,
                            6291456,
                            0,
                            0
                        ]),
                        new Uint32Array([
                            2250977,
                            2251009,
                            2251041,
                            2251073,
                            2195009,
                            2251106,
                            2251169,
                            2251201,
                            2251233,
                            2251265,
                            2251297,
                            2251330,
                            2251394,
                            2251457,
                            2251489,
                            2251521
                        ]),
                        new Uint32Array([
                            2205729,
                            2205761,
                            2205793,
                            2205825,
                            2205857,
                            2205889,
                            2205921,
                            2205953,
                            2205985,
                            2206017,
                            2206049,
                            2206081,
                            2206113,
                            2206145,
                            2206177,
                            2206209
                        ]),
                        new Uint32Array([
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            0,
                            0,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456
                        ]),
                        new Uint32Array([
                            2143170,
                            2168993,
                            6291456,
                            2169025,
                            6291456,
                            2169057,
                            6291456,
                            2169089,
                            6291456,
                            2143234,
                            2169121,
                            6291456,
                            2169153,
                            6291456,
                            2169185,
                            6291456
                        ]),
                        new Uint32Array([
                            23068672,
                            23068672,
                            2190689,
                            6291456,
                            0,
                            0,
                            0,
                            0,
                            0,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456
                        ]),
                        new Uint32Array([
                            2248706,
                            2248769,
                            2248801,
                            2248833,
                            2248865,
                            2248897,
                            2248929,
                            2248962,
                            2249026,
                            2249090,
                            2249154,
                            2240705,
                            2249217,
                            2249249,
                            2249281,
                            2249313
                        ]),
                        new Uint32Array([
                            10485857,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            10495394,
                            6291456,
                            2098209,
                            6291456,
                            6291456,
                            2097152,
                            6291456,
                            10531394
                        ]),
                        new Uint32Array([
                            0,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            0,
                            0,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            0
                        ]),
                        new Uint32Array([
                            14680064,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456
                        ]),
                        new Uint32Array([
                            2173985,
                            2173953,
                            2148481,
                            2173601,
                            2173633,
                            2173665,
                            2173697,
                            2173729,
                            2148801,
                            2173761,
                            2143969,
                            2173793,
                            2173825,
                            2153473,
                            2173857,
                            2173889
                        ]),
                        new Uint32Array([
                            6291456,
                            2186977,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            10537858,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456
                        ]),
                        new Uint32Array([
                            2209601,
                            2209633,
                            2209665,
                            2209697,
                            2209729,
                            2209761,
                            2209793,
                            2209825,
                            2209857,
                            2209889,
                            2209921,
                            2209953,
                            2209985,
                            2210017,
                            2210049,
                            2210081
                        ]),
                        new Uint32Array([
                            10501539,
                            10501635,
                            10501731,
                            10501827,
                            10501923,
                            10502019,
                            2098209,
                            2111137,
                            2105505,
                            2098241,
                            2108353,
                            2108417,
                            2105825,
                            2111713,
                            2100897,
                            2111905
                        ]),
                        new Uint32Array([
                            2173697,
                            2173729,
                            2148801,
                            2173761,
                            2143969,
                            2173793,
                            2173825,
                            2153473,
                            2173857,
                            2173889,
                            2173921,
                            2173953,
                            2173985,
                            2174017,
                            2174017,
                            2174049
                        ]),
                        new Uint32Array([
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            0,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            0,
                            0
                        ]),
                        new Uint32Array([
                            6291456,
                            6291456,
                            23068672,
                            23068672,
                            23068672,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0
                        ]),
                        new Uint32Array([
                            2194561,
                            2194593,
                            2194625,
                            2119777,
                            2119873,
                            2194657,
                            2194689,
                            2194721,
                            2194753,
                            2194785,
                            2194817,
                            2194849,
                            2194881,
                            2194913,
                            2194945,
                            2194977
                        ]),
                        new Uint32Array([
                            2113153,
                            2108481,
                            2113345,
                            2113441,
                            2098209,
                            2111137,
                            2105505,
                            2098241,
                            2108353,
                            2108417,
                            2105825,
                            2111713,
                            2100897,
                            2111905,
                            2105473,
                            2105569
                        ]),
                        new Uint32Array([
                            2222818,
                            2222882,
                            2222946,
                            2223010,
                            2223074,
                            2223138,
                            2223202,
                            2223266,
                            2223330,
                            2223394,
                            2223458,
                            2223522,
                            2223586,
                            2223650,
                            2223714,
                            2223778
                        ]),
                        new Uint32Array([
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            23068672
                        ]),
                        new Uint32Array([
                            0,
                            2179553,
                            2179585,
                            2179617,
                            2179649,
                            2144001,
                            2179681,
                            2179713,
                            2179745,
                            2179777,
                            2179809,
                            2156705,
                            2179841,
                            2156833,
                            2179873,
                            2179905
                        ]),
                        new Uint32Array([
                            6291456,
                            23068672,
                            6291456,
                            2145602,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            0,
                            23068672,
                            23068672,
                            6291456,
                            0,
                            0
                        ]),
                        new Uint32Array([
                            2196513,
                            2196545,
                            2196577,
                            2196609,
                            2196641,
                            2196673,
                            2196705,
                            2196737,
                            2196769,
                            2196801,
                            2196833,
                            2196865,
                            2196897,
                            2196929,
                            2196961,
                            2196993
                        ]),
                        new Uint32Array([
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            0,
                            0,
                            0,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456
                        ]),
                        new Uint32Array([
                            2177281,
                            6291456,
                            2177313,
                            6291456,
                            2177345,
                            6291456,
                            2177377,
                            6291456,
                            2177409,
                            6291456,
                            2177441,
                            6291456,
                            2177473,
                            6291456,
                            2177505,
                            6291456
                        ]),
                        new Uint32Array([
                            2187137,
                            2221473,
                            2221505,
                            2221537,
                            2221569,
                            6291456,
                            6291456,
                            10610209,
                            10610241,
                            10537986,
                            10537986,
                            10537986,
                            10537986,
                            10609857,
                            10609857,
                            10609857
                        ]),
                        new Uint32Array([
                            2243009,
                            2243041,
                            2216033,
                            2243074,
                            2243137,
                            2243169,
                            2243201,
                            2219617,
                            2243233,
                            2243265,
                            2243297,
                            2243329,
                            2243362,
                            2243425,
                            2243457,
                            2243489
                        ]),
                        new Uint32Array([
                            10485857,
                            10485857,
                            10485857,
                            10485857,
                            10485857,
                            10485857,
                            10485857,
                            10485857,
                            10485857,
                            10485857,
                            10485857,
                            2097152,
                            4194304,
                            4194304,
                            0,
                            0
                        ]),
                        new Uint32Array([
                            2143042,
                            6291456,
                            2143106,
                            2143106,
                            2168833,
                            6291456,
                            2168865,
                            6291456,
                            6291456,
                            2168897,
                            6291456,
                            2168929,
                            6291456,
                            2168961,
                            6291456,
                            2143170
                        ]),
                        new Uint32Array([
                            6291456,
                            6291456,
                            23068672,
                            23068672,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456
                        ]),
                        new Uint32Array([
                            2204193,
                            2204225,
                            2204257,
                            2204289,
                            2204321,
                            2204353,
                            2204385,
                            2204417,
                            2204449,
                            2204481,
                            2204513,
                            2204545,
                            2204577,
                            2204609,
                            2204641,
                            2204673
                        ]),
                        new Uint32Array([
                            2202753,
                            6291456,
                            2202785,
                            6291456,
                            2202817,
                            6291456,
                            2202849,
                            6291456,
                            2202881,
                            6291456,
                            2202913,
                            6291456,
                            2202945,
                            6291456,
                            2202977,
                            6291456
                        ]),
                        new Uint32Array([
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            0,
                            0,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672
                        ]),
                        new Uint32Array([
                            2108353,
                            2108417,
                            2105825,
                            2111713,
                            2100897,
                            2111905,
                            2105473,
                            2105569,
                            2105601,
                            2112289,
                            2108193,
                            2112481,
                            2112577,
                            2098177,
                            2098305,
                            2108321
                        ]),
                        new Uint32Array([
                            2147394,
                            2147458,
                            2147522,
                            2147586,
                            2147650,
                            2147714,
                            2147778,
                            2147842,
                            2147394,
                            2147458,
                            2147522,
                            2147586,
                            2147650,
                            2147714,
                            2147778,
                            2147842
                        ]),
                        new Uint32Array([
                            2253313,
                            2253346,
                            2253409,
                            2253441,
                            2253473,
                            2253505,
                            2253537,
                            2253569,
                            2253601,
                            2253634,
                            2219393,
                            2253697,
                            2253729,
                            2253761,
                            2253793,
                            2253825
                        ]),
                        new Uint32Array([
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            6291456,
                            6291456
                        ]),
                        new Uint32Array([
                            2162562,
                            2162626,
                            2131362,
                            2162690,
                            2159938,
                            2160002,
                            2162754,
                            2162818,
                            2160130,
                            2162882,
                            2160194,
                            2160258,
                            2160834,
                            2160898,
                            2161026,
                            2161090
                        ]),
                        new Uint32Array([
                            2175361,
                            2175393,
                            2175425,
                            2175457,
                            2175489,
                            2175521,
                            2175553,
                            2175585,
                            2175617,
                            2175649,
                            2175681,
                            2175713,
                            2175745,
                            2175777,
                            2175809,
                            2175841
                        ]),
                        new Uint32Array([
                            2253858,
                            2253921,
                            2253954,
                            2254018,
                            2254082,
                            2196737,
                            2254145,
                            2196865,
                            2254177,
                            2254209,
                            2254241,
                            2254273,
                            2197025,
                            2254306,
                            0,
                            0
                        ]),
                        new Uint32Array([
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            2202113,
                            2204129,
                            2188705,
                            2204161
                        ]),
                        new Uint32Array([
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            0,
                            6291456,
                            0,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            0,
                            0
                        ]),
                        new Uint32Array([
                            2173985,
                            2174017,
                            2174017,
                            2174049,
                            2174081,
                            2174113,
                            2174145,
                            2174177,
                            2149057,
                            2233089,
                            2173697,
                            2173761,
                            2173793,
                            2174113,
                            2173985,
                            2173953
                        ]),
                        new Uint32Array([
                            2101569,
                            2101697,
                            2101825,
                            2101953,
                            2102081,
                            2102209,
                            2100833,
                            2100737,
                            2098337,
                            2101441,
                            2101569,
                            2101697,
                            2101825,
                            2101953,
                            2102081,
                            2102209
                        ]),
                        new Uint32Array([
                            2108289,
                            2100865,
                            2113153,
                            2108481,
                            2113345,
                            2113441,
                            2098209,
                            2111137,
                            2105505,
                            2098241,
                            0,
                            2108417,
                            0,
                            2111713,
                            2100897,
                            2111905
                        ]),
                        new Uint32Array([
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0
                        ]),
                        new Uint32Array([
                            2175425,
                            2175489,
                            2175809,
                            2175905,
                            2175937,
                            2175937,
                            2176193,
                            2176417,
                            2180865,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0
                        ]),
                        new Uint32Array([
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            2143298,
                            2143298,
                            2143298,
                            2143362,
                            2143362,
                            2143362,
                            2143426,
                            2143426,
                            2143426,
                            2171105,
                            6291456,
                            2171137
                        ]),
                        new Uint32Array([
                            2120162,
                            2120258,
                            2151618,
                            2151682,
                            2151746,
                            2151810,
                            2151874,
                            2151938,
                            2152002,
                            2120035,
                            2120131,
                            2120227,
                            2152066,
                            2120323,
                            2152130,
                            2120419
                        ]),
                        new Uint32Array([
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            0,
                            0,
                            0,
                            0,
                            0,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672
                        ]),
                        new Uint32Array([
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            0,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456
                        ]),
                        new Uint32Array([
                            2195361,
                            2142433,
                            2236065,
                            2236097,
                            2236129,
                            2236161,
                            2118241,
                            2117473,
                            2236193,
                            2236225,
                            2236257,
                            2236289,
                            0,
                            0,
                            0,
                            0
                        ]),
                        new Uint32Array([
                            2189281,
                            6291456,
                            2189313,
                            6291456,
                            2189345,
                            6291456,
                            2189377,
                            6291456,
                            2189409,
                            6291456,
                            2189441,
                            6291456,
                            2189473,
                            6291456,
                            2189505,
                            6291456
                        ]),
                        new Uint32Array([
                            6291456,
                            6291456,
                            2145922,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            2145986,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            2146050,
                            6291456,
                            6291456,
                            6291456
                        ]),
                        new Uint32Array([
                            2100833,
                            2100737,
                            2098337,
                            2101441,
                            2101569,
                            2101697,
                            2101825,
                            2101953,
                            2102081,
                            2102209,
                            10502113,
                            10562017,
                            10610401,
                            10502177,
                            10610433,
                            10538049
                        ]),
                        new Uint32Array([
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            0,
                            2186401,
                            0,
                            2186433,
                            0,
                            2186465,
                            0,
                            2186497
                        ]),
                        new Uint32Array([
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            0,
                            0,
                            0,
                            23068672,
                            23068672,
                            23068672
                        ]),
                        new Uint32Array([
                            0,
                            0,
                            2198241,
                            2198273,
                            2198305,
                            2198337,
                            2198369,
                            2198401,
                            0,
                            0,
                            2198433,
                            2198465,
                            2198497,
                            0,
                            0,
                            0
                        ]),
                        new Uint32Array([
                            6291456,
                            0,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            0,
                            0,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            0
                        ]),
                        new Uint32Array([
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            0,
                            6291456,
                            0,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            0,
                            0
                        ]),
                        new Uint32Array([
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            0,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            0,
                            0,
                            23068672,
                            6291456,
                            23068672,
                            23068672
                        ]),
                        new Uint32Array([
                            0,
                            2105921,
                            2097729,
                            0,
                            2097377,
                            0,
                            0,
                            2106017,
                            2133281,
                            2097505,
                            2105889,
                            0,
                            2097697,
                            2135777,
                            2097633,
                            2097441
                        ]),
                        new Uint32Array([
                            2197889,
                            2197921,
                            2197953,
                            2197985,
                            2198017,
                            2198049,
                            2198081,
                            2198113,
                            2198145,
                            2198177,
                            2198209,
                            2198241,
                            2198273,
                            2198305,
                            2198337,
                            2198369
                        ]),
                        new Uint32Array([
                            2132514,
                            2132610,
                            2160386,
                            2133090,
                            2133186,
                            2160450,
                            2160514,
                            2133282,
                            2160578,
                            2133570,
                            2106178,
                            2160642,
                            2133858,
                            2160706,
                            2160770,
                            2134146
                        ]),
                        new Uint32Array([
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            23068672,
                            23068672,
                            0,
                            0,
                            0,
                            0,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456
                        ]),
                        new Uint32Array([
                            6291456,
                            23068672,
                            23068672,
                            6291456,
                            23068672,
                            23068672,
                            6291456,
                            23068672,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0
                        ]),
                        new Uint32Array([
                            2184737,
                            6291456,
                            2184769,
                            6291456,
                            2184801,
                            6291456,
                            2184833,
                            6291456,
                            2184865,
                            6291456,
                            2184897,
                            6291456,
                            2184929,
                            6291456,
                            2184961,
                            6291456
                        ]),
                        new Uint32Array([
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            0,
                            6291456,
                            0,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            0,
                            6291456
                        ]),
                        new Uint32Array([
                            6291456,
                            6291456,
                            0,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456
                        ]),
                        new Uint32Array([
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            6291456,
                            23068672,
                            23068672,
                            23068672,
                            6291456,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            0,
                            0
                        ]),
                        new Uint32Array([
                            6291456,
                            6291456,
                            6291456,
                            2186753,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            2186785,
                            2186817,
                            2186849,
                            2173569,
                            2186881,
                            10496355,
                            10495395,
                            10575521
                        ]),
                        new Uint32Array([
                            0,
                            0,
                            2097729,
                            0,
                            0,
                            0,
                            0,
                            2106017,
                            0,
                            2097505,
                            0,
                            2097185,
                            0,
                            2135777,
                            2097633,
                            2097441
                        ]),
                        new Uint32Array([
                            2189537,
                            6291456,
                            2189569,
                            6291456,
                            2189601,
                            6291456,
                            2189633,
                            6291456,
                            2189665,
                            6291456,
                            2189697,
                            6291456,
                            2189729,
                            6291456,
                            2189761,
                            6291456
                        ]),
                        new Uint32Array([
                            2202497,
                            6291456,
                            2202529,
                            6291456,
                            2202561,
                            6291456,
                            2202593,
                            6291456,
                            2202625,
                            6291456,
                            2202657,
                            6291456,
                            2202689,
                            6291456,
                            2202721,
                            6291456
                        ]),
                        new Uint32Array([
                            2245217,
                            2218369,
                            2245249,
                            2245282,
                            2245345,
                            2245377,
                            2245410,
                            2245474,
                            2245537,
                            2245569,
                            2245601,
                            2245633,
                            2245665,
                            2245665,
                            2245697,
                            2245729
                        ]),
                        new Uint32Array([
                            6291456,
                            0,
                            23068672,
                            23068672,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0
                        ]),
                        new Uint32Array([
                            6291456,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            23068672,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0
                        ]),
                        new Uint32Array([
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            23068672,
                            6291456,
                            23068672,
                            6291456,
                            23068672,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            23068672,
                            23068672
                        ]),
                        new Uint32Array([
                            0,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0
                        ]),
                        new Uint32Array([
                            2097281,
                            2105921,
                            2097729,
                            2106081,
                            2097377,
                            2097601,
                            2162337,
                            2106017,
                            2133281,
                            2097505,
                            0,
                            2097185,
                            2097697,
                            2135777,
                            2097633,
                            2097441
                        ]),
                        new Uint32Array([
                            2176641,
                            6291456,
                            2176673,
                            6291456,
                            2176705,
                            6291456,
                            2176737,
                            6291456,
                            2176769,
                            6291456,
                            2176801,
                            6291456,
                            2176833,
                            6291456,
                            2176865,
                            6291456
                        ]),
                        new Uint32Array([
                            2174145,
                            2174177,
                            2149057,
                            2233089,
                            2173697,
                            2173761,
                            2173793,
                            2174113,
                            2173985,
                            2173953,
                            2174369,
                            2174369,
                            0,
                            0,
                            2100833,
                            2100737
                        ]),
                        new Uint32Array([
                            2116513,
                            2190817,
                            2190849,
                            2190881,
                            2190913,
                            2190945,
                            2116609,
                            2190977,
                            2191009,
                            2191041,
                            2191073,
                            2117185,
                            2191105,
                            2191137,
                            2191169,
                            2191201
                        ]),
                        new Uint32Array([
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            0,
                            0,
                            0,
                            0,
                            0,
                            6291456,
                            6291456,
                            6291456
                        ]),
                        new Uint32Array([
                            0,
                            0,
                            0,
                            0,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672
                        ]),
                        new Uint32Array([
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            6291456
                        ]),
                        new Uint32Array([
                            2167617,
                            2167649,
                            2167681,
                            2167713,
                            2167745,
                            2167777,
                            2167809,
                            6291456,
                            2167841,
                            2167873,
                            2167905,
                            2167937,
                            2167969,
                            2168001,
                            2168033,
                            4240130
                        ]),
                        new Uint32Array([
                            2165122,
                            2163970,
                            2164034,
                            2164098,
                            2164162,
                            2164226,
                            2164290,
                            2164354,
                            2164418,
                            2164482,
                            2164546,
                            2133122,
                            2134562,
                            2132162,
                            2132834,
                            2136866
                        ]),
                        new Uint32Array([
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            0,
                            0,
                            2186209,
                            2186241,
                            2186273,
                            2186305,
                            2186337,
                            2186369,
                            0,
                            0
                        ]),
                        new Uint32Array([
                            2112481,
                            2112577,
                            2098177,
                            2098305,
                            2108321,
                            2108289,
                            2100865,
                            2113153,
                            2108481,
                            2113345,
                            2113441,
                            14680064,
                            14680064,
                            14680064,
                            14680064,
                            14680064
                        ]),
                        new Uint32Array([
                            0,
                            0,
                            23068672,
                            6291456,
                            0,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            0,
                            0,
                            0,
                            6291456,
                            6291456
                        ]),
                        new Uint32Array([
                            0,
                            10537921,
                            10610689,
                            10610273,
                            10610497,
                            10610529,
                            10610305,
                            10610721,
                            10489601,
                            10489697,
                            10610337,
                            10575617,
                            10554529,
                            2221761,
                            2197217,
                            10496577
                        ]),
                        new Uint32Array([
                            2105473,
                            2105569,
                            2105601,
                            2112289,
                            0,
                            2112481,
                            2112577,
                            2098177,
                            2098305,
                            2108321,
                            2108289,
                            2100865,
                            2113153,
                            2108481,
                            2113345,
                            2113441
                        ]),
                        new Uint32Array([
                            2100897,
                            2111905,
                            2105473,
                            2105569,
                            2105601,
                            2112289,
                            2108193,
                            2112481,
                            2112577,
                            2098177,
                            2098305,
                            2108321,
                            2108289,
                            2100865,
                            2113153,
                            2108481
                        ]),
                        new Uint32Array([
                            2125346,
                            2153410,
                            2153474,
                            2127394,
                            2153538,
                            2153602,
                            2153666,
                            2153730,
                            2105507,
                            2105476,
                            2153794,
                            2153858,
                            2153922,
                            2153986,
                            2154050,
                            2105794
                        ]),
                        new Uint32Array([
                            2200449,
                            2119681,
                            2200481,
                            2153313,
                            2199873,
                            2199905,
                            2199937,
                            2200513,
                            2200545,
                            2200577,
                            2200609,
                            2119105,
                            2119201,
                            2119297,
                            2119393,
                            2119489
                        ]),
                        new Uint32Array([
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            2175777,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456
                        ]),
                        new Uint32Array([
                            2222273,
                            2197217,
                            2221473,
                            2221505,
                            2221089,
                            2222305,
                            2200865,
                            2099681,
                            2104481,
                            2222337,
                            2099905,
                            2120737,
                            2222369,
                            2103713,
                            2100225,
                            2098785
                        ]),
                        new Uint32Array([
                            2201377,
                            6291456,
                            2201409,
                            6291456,
                            2201441,
                            6291456,
                            2201473,
                            6291456,
                            2201505,
                            6291456,
                            2201537,
                            6291456,
                            2201569,
                            6291456,
                            6291456,
                            23068672
                        ]),
                        new Uint32Array([
                            2174081,
                            2174113,
                            2174145,
                            2174177,
                            2149057,
                            2233057,
                            2148481,
                            2173601,
                            2173633,
                            2173665,
                            2173697,
                            2173729,
                            2148801,
                            2173761,
                            2143969,
                            2173793
                        ]),
                        new Uint32Array([
                            2200897,
                            6291456,
                            2200929,
                            6291456,
                            2200961,
                            6291456,
                            2200993,
                            6291456,
                            2201025,
                            6291456,
                            2180865,
                            6291456,
                            2201057,
                            6291456,
                            2201089,
                            6291456
                        ]),
                        new Uint32Array([
                            0,
                            0,
                            0,
                            0,
                            0,
                            23068672,
                            23068672,
                            0,
                            6291456,
                            6291456,
                            6291456,
                            0,
                            0,
                            0,
                            0,
                            0
                        ]),
                        new Uint32Array([
                            2161154,
                            2161410,
                            2138658,
                            2161474,
                            2161538,
                            2097666,
                            2097186,
                            2097474,
                            2162946,
                            2132450,
                            2163010,
                            2163074,
                            2136162,
                            2163138,
                            2161666,
                            2161730
                        ]),
                        new Uint32Array([
                            2148481,
                            2173601,
                            2173633,
                            2173665,
                            2173697,
                            2173729,
                            2148801,
                            2173761,
                            2143969,
                            2173793,
                            2173825,
                            2153473,
                            2173857,
                            2173889,
                            2173921,
                            2173953
                        ]),
                        new Uint32Array([
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            23068672,
                            23068672,
                            0,
                            0,
                            0,
                            0,
                            2145410,
                            2145474,
                            0,
                            6291456
                        ]),
                        new Uint32Array([
                            2244161,
                            2216065,
                            2212769,
                            2244193,
                            2244225,
                            2244257,
                            2244290,
                            2244353,
                            2244385,
                            2244417,
                            2244449,
                            2218273,
                            2244481,
                            2244514,
                            2244577,
                            2244609
                        ]),
                        new Uint32Array([
                            2125730,
                            2125699,
                            2125795,
                            2125891,
                            2125987,
                            2154114,
                            2154178,
                            2154242,
                            2154306,
                            2154370,
                            2154434,
                            2154498,
                            2126082,
                            2126178,
                            2126274,
                            2126083
                        ]),
                        new Uint32Array([
                            2237665,
                            2237697,
                            2237697,
                            2237697,
                            2237730,
                            2237793,
                            2237825,
                            2237857,
                            2237890,
                            2237953,
                            2237985,
                            2238017,
                            2238049,
                            2238081,
                            2238113,
                            2238145
                        ]),
                        new Uint32Array([
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            2150146,
                            6291456,
                            6291456,
                            6291456
                        ]),
                        new Uint32Array([
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            0,
                            0,
                            23068672,
                            23068672,
                            0,
                            0,
                            23068672,
                            23068672,
                            23068672,
                            0,
                            0
                        ]),
                        new Uint32Array([
                            2214369,
                            2238593,
                            2238625,
                            2238657,
                            2238689,
                            2238721,
                            2238753,
                            2238785,
                            2238817,
                            2238850,
                            2238913,
                            2238945,
                            2238977,
                            2235457,
                            2239009,
                            2239041
                        ]),
                        new Uint32Array([
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            0,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            0,
                            0
                        ]),
                        new Uint32Array([
                            2252066,
                            2252130,
                            2252193,
                            2252225,
                            2252257,
                            2252290,
                            2252353,
                            2252385,
                            2252417,
                            2252449,
                            2252481,
                            2252513,
                            2252545,
                            2252578,
                            2252641,
                            2252673
                        ]),
                        new Uint32Array([
                            2197697,
                            2114113,
                            2114209,
                            2197729,
                            2197761,
                            2114305,
                            2197793,
                            2114401,
                            2114497,
                            2197825,
                            2114593,
                            2114689,
                            2114785,
                            2114881,
                            2114977,
                            2197857
                        ]),
                        new Uint32Array([
                            2224866,
                            2224930,
                            2224994,
                            2225058,
                            2225122,
                            2225186,
                            2225250,
                            2225314,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456
                        ]),
                        new Uint32Array([
                            2219490,
                            2219554,
                            2219617,
                            2219649,
                            2219681,
                            2219714,
                            2219778,
                            2219842,
                            2219905,
                            2219937,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0
                        ]),
                        new Uint32Array([
                            6291456,
                            23068672,
                            23068672,
                            23068672,
                            0,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            0,
                            0,
                            6291456
                        ]),
                        new Uint32Array([
                            2113345,
                            2113441,
                            2098209,
                            2111137,
                            2105505,
                            2098241,
                            2108353,
                            2108417,
                            2105825,
                            2111713,
                            2100897,
                            2111905,
                            2105473,
                            2105569,
                            2105601,
                            2112289
                        ]),
                        new Uint32Array([
                            2174081,
                            2174113,
                            2174145,
                            2174177,
                            2149057,
                            2233089,
                            2173697,
                            2173761,
                            2173793,
                            2174113,
                            2173985,
                            2173953,
                            2148481,
                            2173601,
                            2173633,
                            2173665
                        ]),
                        new Uint32Array([
                            2220161,
                            2220161,
                            2220193,
                            2220193,
                            2220193,
                            2220193,
                            2220225,
                            2220225,
                            2220225,
                            2220225,
                            2220257,
                            2220257,
                            2220257,
                            2220257,
                            2220289,
                            2220289
                        ]),
                        new Uint32Array([
                            2192673,
                            2192705,
                            2192737,
                            2192769,
                            2192801,
                            2192833,
                            2192865,
                            2118049,
                            2192897,
                            2117473,
                            2117761,
                            2192929,
                            2192961,
                            2192993,
                            2193025,
                            2193057
                        ]),
                        new Uint32Array([
                            2179297,
                            6291456,
                            2179329,
                            6291456,
                            2179361,
                            6291456,
                            2179393,
                            6291456,
                            2179425,
                            6291456,
                            2179457,
                            6291456,
                            2179489,
                            6291456,
                            2179521,
                            6291456
                        ]),
                        new Uint32Array([
                            6291456,
                            6291456,
                            6291456,
                            23068672,
                            6291456,
                            6291456,
                            6291456,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0
                        ]),
                        new Uint32Array([
                            2235745,
                            2235777,
                            2193633,
                            2235809,
                            2235841,
                            2235873,
                            2235905,
                            2235937,
                            2235969,
                            2116513,
                            2116705,
                            2236001,
                            2200513,
                            2199905,
                            2200545,
                            2236033
                        ]),
                        new Uint32Array([
                            2113153,
                            2108481,
                            2113345,
                            2113441,
                            2232993,
                            2233025,
                            0,
                            0,
                            2148481,
                            2173601,
                            2173633,
                            2173665,
                            2173697,
                            2173729,
                            2148801,
                            2173761
                        ]),
                        new Uint32Array([
                            2170593,
                            6291456,
                            2170625,
                            6291456,
                            2170657,
                            6291456,
                            2170689,
                            2170721,
                            6291456,
                            2170753,
                            6291456,
                            6291456,
                            2170785,
                            6291456,
                            2170817,
                            2170849
                        ]),
                        new Uint32Array([
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            2166786,
                            2166850,
                            0,
                            0,
                            0,
                            0
                        ]),
                        new Uint32Array([
                            23068672,
                            6291456,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0
                        ]),
                        new Uint32Array([
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            0,
                            6291456,
                            6291456
                        ]),
                        new Uint32Array([
                            2100833,
                            2100737,
                            2098337,
                            2101441,
                            2101569,
                            2101697,
                            2101825,
                            2101953,
                            2102081,
                            2102209,
                            10575617,
                            2187041,
                            10502177,
                            10489601,
                            10489697,
                            0
                        ]),
                        new Uint32Array([
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456
                        ]),
                        new Uint32Array([
                            2134562,
                            2132162,
                            2132834,
                            2136866,
                            2136482,
                            2164610,
                            2164674,
                            2164738,
                            2164802,
                            2132802,
                            2132706,
                            2164866,
                            2132898,
                            2164930,
                            2164994,
                            2165058
                        ]),
                        new Uint32Array([
                            6291456,
                            6291456,
                            2098337,
                            2101441,
                            10531458,
                            2153473,
                            6291456,
                            6291456,
                            10531522,
                            2100737,
                            2108193,
                            6291456,
                            2106499,
                            2106595,
                            2106691,
                            6291456
                        ]),
                        new Uint32Array([
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0
                        ]),
                        new Uint32Array([
                            2233122,
                            2233186,
                            2233250,
                            2233314,
                            2233378,
                            2233442,
                            2233506,
                            2233570,
                            2233634,
                            2233698,
                            2233762,
                            2233826,
                            2233890,
                            2233954,
                            2234018,
                            2234082
                        ]),
                        new Uint32Array([
                            23068672,
                            6291456,
                            23068672,
                            23068672,
                            23068672,
                            6291456,
                            6291456,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            6291456,
                            6291456
                        ]),
                        new Uint32Array([
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            0,
                            0
                        ]),
                        new Uint32Array([
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            0,
                            0,
                            0,
                            0,
                            6291456,
                            6291456
                        ]),
                        new Uint32Array([
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0
                        ]),
                        new Uint32Array([
                            2205217,
                            2205249,
                            2205281,
                            2205313,
                            2205345,
                            2205377,
                            2205409,
                            2205441,
                            2205473,
                            2205505,
                            2205537,
                            2205569,
                            2205601,
                            2205633,
                            2205665,
                            2205697
                        ]),
                        new Uint32Array([
                            6291456,
                            0,
                            6291456,
                            0,
                            0,
                            0,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            0,
                            0,
                            23068672,
                            6291456,
                            23068672,
                            23068672
                        ]),
                        new Uint32Array([
                            2173601,
                            2173761,
                            2174081,
                            2173569,
                            2174241,
                            2174113,
                            2173953,
                            6291456,
                            2174305,
                            6291456,
                            2174337,
                            6291456,
                            2174369,
                            6291456,
                            2174401,
                            6291456
                        ]),
                        new Uint32Array([
                            6291456,
                            23068672,
                            23068672,
                            23068672,
                            0,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            0,
                            6291456,
                            6291456
                        ]),
                        new Uint32Array([
                            2152450,
                            2152514,
                            2099653,
                            2104452,
                            2099813,
                            2122243,
                            2099973,
                            2152578,
                            2122339,
                            2122435,
                            2122531,
                            2122627,
                            2122723,
                            2104580,
                            2122819,
                            2152642
                        ]),
                        new Uint32Array([
                            2236385,
                            2236417,
                            2236449,
                            2236482,
                            2236545,
                            2215425,
                            2236577,
                            2236609,
                            2236641,
                            2236673,
                            2215457,
                            2236705,
                            2236737,
                            2236770,
                            2215489,
                            2236833
                        ]),
                        new Uint32Array([
                            2163394,
                            2159746,
                            2163458,
                            2131362,
                            2163522,
                            2160130,
                            2163778,
                            2132226,
                            2163842,
                            2132898,
                            2163906,
                            2161410,
                            2138658,
                            2097666,
                            2136162,
                            2163650
                        ]),
                        new Uint32Array([
                            2218721,
                            2246913,
                            2246946,
                            2216385,
                            2247010,
                            2247074,
                            2215009,
                            2247137,
                            2247169,
                            2216481,
                            2247201,
                            2247233,
                            2247266,
                            2247330,
                            2247330,
                            0
                        ]),
                        new Uint32Array([
                            2129730,
                            2129762,
                            2129858,
                            2129731,
                            2129827,
                            2156482,
                            2156482,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0
                        ]),
                        new Uint32Array([
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            0,
                            0,
                            0,
                            6291456,
                            6291456,
                            6291456
                        ]),
                        new Uint32Array([
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            0,
                            6291456,
                            0,
                            0,
                            0,
                            0,
                            0,
                            6291456,
                            0,
                            0
                        ]),
                        new Uint32Array([
                            2203969,
                            2204001,
                            2181377,
                            2204033,
                            2204065,
                            6291456,
                            2204097,
                            6291456,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0
                        ]),
                        new Uint32Array([
                            2169473,
                            6291456,
                            2169505,
                            6291456,
                            2169537,
                            6291456,
                            2169569,
                            6291456,
                            2169601,
                            6291456,
                            2169633,
                            6291456,
                            2169665,
                            6291456,
                            2169697,
                            6291456
                        ]),
                        new Uint32Array([
                            2141542,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456
                        ]),
                        new Uint32Array([
                            2220801,
                            2220801,
                            2220801,
                            2220801,
                            2220833,
                            2220833,
                            2220865,
                            2220865,
                            2220865,
                            2220865,
                            2220897,
                            2220897,
                            2220897,
                            2220897,
                            2139873,
                            2139873
                        ]),
                        new Uint32Array([
                            0,
                            0,
                            0,
                            0,
                            0,
                            23068672,
                            23068672,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            6291456,
                            0
                        ]),
                        new Uint32Array([
                            2214849,
                            2218433,
                            2218465,
                            2218497,
                            2218529,
                            2218561,
                            2214881,
                            2218593,
                            2218625,
                            2218657,
                            2218689,
                            2218721,
                            2218753,
                            2216545,
                            2218785,
                            2218817
                        ]),
                        new Uint32Array([
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            6291456
                        ]),
                        new Uint32Array([
                            2136482,
                            2164610,
                            2164674,
                            2164738,
                            2164802,
                            2132802,
                            2132706,
                            2164866,
                            2132898,
                            2164930,
                            2164994,
                            2165058,
                            2165122,
                            2132802,
                            2132706,
                            2164866
                        ]),
                        new Uint32Array([
                            2207649,
                            2207681,
                            2207713,
                            2207745,
                            2207777,
                            2207809,
                            2207841,
                            2207873,
                            2207905,
                            2207937,
                            2207969,
                            2208001,
                            2208033,
                            2208065,
                            2208097,
                            2208129
                        ]),
                        new Uint32Array([
                            2123683,
                            2105092,
                            2152706,
                            2123779,
                            2105220,
                            2152770,
                            2100453,
                            2098755,
                            2123906,
                            2124002,
                            2124098,
                            2124194,
                            2124290,
                            2124386,
                            2124482,
                            2124578
                        ]),
                        new Uint32Array([
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            0,
                            0,
                            0,
                            6291456,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            10485857
                        ]),
                        new Uint32Array([
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672
                        ]),
                        new Uint32Array([
                            10508163,
                            10508259,
                            10508355,
                            10508451,
                            2200129,
                            2200161,
                            2192737,
                            2200193,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456
                        ]),
                        new Uint32Array([
                            2203553,
                            6291456,
                            2203585,
                            6291456,
                            6291456,
                            6291456,
                            2203617,
                            6291456,
                            2203649,
                            6291456,
                            2203681,
                            6291456,
                            2203713,
                            6291456,
                            2203745,
                            6291456
                        ]),
                        new Uint32Array([
                            18884449,
                            18884065,
                            23068672,
                            18884417,
                            18884034,
                            18921185,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            18874368
                        ]),
                        new Uint32Array([
                            2247393,
                            2247426,
                            2247489,
                            2247521,
                            2247553,
                            2247586,
                            2247649,
                            2247681,
                            2247713,
                            2247745,
                            2247777,
                            2247810,
                            2247873,
                            2247905,
                            2247937,
                            2247969
                        ]),
                        new Uint32Array([
                            6291456,
                            6291456,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            6291456,
                            23068672
                        ]),
                        new Uint32Array([
                            2134145,
                            2097153,
                            2134241,
                            0,
                            2132705,
                            2130977,
                            2160065,
                            2131297,
                            0,
                            2133089,
                            2160577,
                            2133857,
                            2235297,
                            0,
                            2235329,
                            0
                        ]),
                        new Uint32Array([
                            2182593,
                            6291456,
                            2182625,
                            6291456,
                            2182657,
                            6291456,
                            2182689,
                            6291456,
                            2182721,
                            6291456,
                            2182753,
                            6291456,
                            2182785,
                            6291456,
                            2182817,
                            6291456
                        ]),
                        new Uint32Array([
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            2102402,
                            2102403,
                            6291456,
                            2110050
                        ]),
                        new Uint32Array([
                            2149890,
                            2108323,
                            2149954,
                            6291456,
                            2113441,
                            6291456,
                            2149057,
                            6291456,
                            2113441,
                            6291456,
                            2105473,
                            2167265,
                            2111137,
                            2105505,
                            6291456,
                            2108353
                        ]),
                        new Uint32Array([
                            2219105,
                            2219137,
                            2195233,
                            2251554,
                            2251617,
                            2251649,
                            2251681,
                            2251713,
                            2251746,
                            2251810,
                            2251873,
                            2251905,
                            2251937,
                            2251970,
                            2252033,
                            2219169
                        ]),
                        new Uint32Array([
                            2203009,
                            6291456,
                            2203041,
                            6291456,
                            2203073,
                            6291456,
                            2203105,
                            6291456,
                            2203137,
                            6291456,
                            2203169,
                            6291456,
                            2203201,
                            6291456,
                            2203233,
                            6291456
                        ]),
                        new Uint32Array([
                            2128195,
                            2128291,
                            2128387,
                            2128483,
                            2128579,
                            2128675,
                            2128771,
                            2128867,
                            2128963,
                            2129059,
                            2129155,
                            2129251,
                            2129347,
                            2129443,
                            2129539,
                            2129635
                        ]),
                        new Uint32Array([
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            2140964,
                            2141156,
                            2140966,
                            2141158,
                            2141350
                        ]),
                        new Uint32Array([
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672
                        ]),
                        new Uint32Array([
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672
                        ]),
                        new Uint32Array([
                            2225378,
                            2225442,
                            2225506,
                            2225570,
                            2225634,
                            2225698,
                            2225762,
                            2225826,
                            2225890,
                            2225954,
                            2226018,
                            2226082,
                            2226146,
                            2226210,
                            2226274,
                            2226338
                        ]),
                        new Uint32Array([
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456
                        ]),
                        new Uint32Array([
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            0,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            0,
                            6291456,
                            6291456
                        ]),
                        new Uint32Array([
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            0,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456
                        ]),
                        new Uint32Array([
                            2112577,
                            2098177,
                            2098305,
                            2108321,
                            2108289,
                            2100865,
                            2113153,
                            2108481,
                            2113345,
                            2113441,
                            2098209,
                            2111137,
                            2105505,
                            2098241,
                            2108353,
                            2108417
                        ]),
                        new Uint32Array([
                            2108353,
                            2108417,
                            0,
                            2105601,
                            2108193,
                            2157121,
                            2157313,
                            2157377,
                            2157441,
                            2100897,
                            6291456,
                            2108419,
                            2173953,
                            2173633,
                            2173633,
                            2173953
                        ]),
                        new Uint32Array([
                            2111713,
                            2173121,
                            2111905,
                            2098177,
                            2173153,
                            2173185,
                            2173217,
                            2113153,
                            2113345,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456
                        ]),
                        new Uint32Array([
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            0,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            2190753
                        ]),
                        new Uint32Array([
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            2197249,
                            6291456,
                            2117377,
                            2197281,
                            2197313,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456
                        ]),
                        new Uint32Array([
                            6291456,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            23068672,
                            0,
                            0,
                            0,
                            0,
                            0,
                            6291456,
                            6291456,
                            6291456
                        ]),
                        new Uint32Array([
                            2098337,
                            2101441,
                            2101569,
                            2101697,
                            2101825,
                            2101953,
                            2102081,
                            2102209,
                            2100833,
                            2100737,
                            2098337,
                            2101441,
                            2101569,
                            2101697,
                            2101825,
                            2101953
                        ]),
                        new Uint32Array([
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            0,
                            0,
                            0
                        ]),
                        new Uint32Array([
                            0,
                            0,
                            0,
                            0,
                            0,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456
                        ]),
                        new Uint32Array([
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            0,
                            0,
                            23068672,
                            23068672,
                            23068672
                        ]),
                        new Uint32Array([
                            2173281,
                            6291456,
                            2173313,
                            6291456,
                            2173345,
                            6291456,
                            2173377,
                            6291456,
                            0,
                            0,
                            10532546,
                            6291456,
                            6291456,
                            6291456,
                            10562017,
                            2173441
                        ]),
                        new Uint32Array([
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            23068672,
                            23068672,
                            0,
                            0
                        ]),
                        new Uint32Array([
                            23068672,
                            23068672,
                            23068672,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456
                        ]),
                        new Uint32Array([
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456
                        ]),
                        new Uint32Array([
                            2159426,
                            2159490,
                            2159554,
                            2159362,
                            2159618,
                            2159682,
                            2139522,
                            2136450,
                            2159746,
                            2159810,
                            2159874,
                            2130978,
                            2131074,
                            2131266,
                            2131362,
                            2159938
                        ]),
                        new Uint32Array([
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            0,
                            0,
                            0,
                            0,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456
                        ]),
                        new Uint32Array([
                            2203233,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            2203265,
                            6291456,
                            2203297,
                            6291456,
                            2203329,
                            2203361,
                            6291456
                        ]),
                        new Uint32Array([
                            6291456,
                            6291456,
                            2148418,
                            2148482,
                            2148546,
                            0,
                            6291456,
                            2148610,
                            2186529,
                            2186561,
                            2148417,
                            2148545,
                            2148482,
                            10495778,
                            2143969,
                            10495778
                        ]),
                        new Uint32Array([
                            2134146,
                            2139426,
                            2160962,
                            2134242,
                            2161218,
                            2161282,
                            2161346,
                            2161410,
                            2138658,
                            2134722,
                            2134434,
                            2134818,
                            2097666,
                            2097346,
                            2097698,
                            2105986
                        ]),
                        new Uint32Array([
                            2198881,
                            2198913,
                            2198945,
                            2198977,
                            2199009,
                            2199041,
                            2199073,
                            2199105,
                            2199137,
                            2199169,
                            2199201,
                            2199233,
                            2199265,
                            2199297,
                            2199329,
                            2199361
                        ]),
                        new Uint32Array([
                            0,
                            23068672,
                            23068672,
                            23068672,
                            0,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            0,
                            6291456
                        ]),
                        new Uint32Array([
                            10610561,
                            2098209,
                            2111137,
                            2105505,
                            2098241,
                            2108353,
                            2108417,
                            2105825,
                            2111713,
                            2100897,
                            2111905,
                            2105473,
                            2105569,
                            2105601,
                            2112289,
                            2108193
                        ]),
                        new Uint32Array([
                            2183873,
                            6291456,
                            2183905,
                            6291456,
                            2183937,
                            6291456,
                            2183969,
                            6291456,
                            2184001,
                            6291456,
                            2184033,
                            6291456,
                            2184065,
                            6291456,
                            2184097,
                            6291456
                        ]),
                        new Uint32Array([
                            2244642,
                            2244706,
                            2244769,
                            2244801,
                            2218305,
                            2244833,
                            2244865,
                            2244897,
                            2244929,
                            2244961,
                            2244993,
                            2245026,
                            2245089,
                            2245122,
                            2245185,
                            0
                        ]),
                        new Uint32Array([
                            6291456,
                            6291456,
                            2116513,
                            2116609,
                            2116705,
                            2116801,
                            2199873,
                            2199905,
                            2199937,
                            2199969,
                            2190913,
                            2200001,
                            2200033,
                            2200065,
                            2200097,
                            2191009
                        ]),
                        new Uint32Array([
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            0,
                            0,
                            2180673,
                            2180705,
                            2180737,
                            2180769,
                            2180801,
                            2180833,
                            0,
                            0
                        ]),
                        new Uint32Array([
                            2098081,
                            2099521,
                            2099105,
                            2120705,
                            2098369,
                            2120801,
                            2103361,
                            2097985,
                            2098433,
                            2121377,
                            2121473,
                            2099169,
                            2099873,
                            2098401,
                            2099393,
                            2152609
                        ]),
                        new Uint32Array([
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            2150402
                        ]),
                        new Uint32Array([
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            0,
                            0,
                            2145666,
                            2145730,
                            6291456,
                            6291456
                        ]),
                        new Uint32Array([
                            2173921,
                            2173953,
                            2173985,
                            2173761,
                            2174017,
                            2174049,
                            2174081,
                            2174113,
                            2174145,
                            2174177,
                            2149057,
                            2233057,
                            2148481,
                            2173601,
                            2173633,
                            2173665
                        ]),
                        new Uint32Array([
                            2187073,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            2098241,
                            2098241,
                            2108353,
                            2100897,
                            2111905,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456
                        ]),
                        new Uint32Array([
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            2102404,
                            6291456,
                            6291456,
                            6291456
                        ]),
                        new Uint32Array([
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            2100612,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            10485857
                        ]),
                        new Uint32Array([
                            2149057,
                            2233057,
                            2148481,
                            2173601,
                            2173633,
                            2173665,
                            2173697,
                            2173729,
                            2148801,
                            2173761,
                            2143969,
                            2173793,
                            2173825,
                            2153473,
                            2173857,
                            2173889
                        ]),
                        new Uint32Array([
                            2217697,
                            2217729,
                            2217761,
                            2217793,
                            2217825,
                            2217857,
                            2217889,
                            2217921,
                            2217953,
                            2215873,
                            2217985,
                            2215905,
                            2218017,
                            2218049,
                            2218081,
                            2218113
                        ]),
                        new Uint32Array([
                            2211233,
                            2218849,
                            2216673,
                            2218881,
                            2218913,
                            2218945,
                            2218977,
                            2219009,
                            2216833,
                            2219041,
                            2215137,
                            2219073,
                            2216865,
                            2209505,
                            2219105,
                            2216897
                        ]),
                        new Uint32Array([
                            2240097,
                            2240129,
                            2240161,
                            2240193,
                            2240225,
                            2240257,
                            2240289,
                            2240321,
                            2240353,
                            2240386,
                            2240449,
                            2240481,
                            2240513,
                            2240545,
                            2207905,
                            2240578
                        ]),
                        new Uint32Array([
                            6291456,
                            6291456,
                            2202273,
                            6291456,
                            2202305,
                            6291456,
                            2202337,
                            6291456,
                            2202369,
                            6291456,
                            2202401,
                            6291456,
                            2202433,
                            6291456,
                            2202465,
                            6291456
                        ]),
                        new Uint32Array([
                            0,
                            23068672,
                            23068672,
                            18923394,
                            23068672,
                            18923458,
                            18923522,
                            18884099,
                            18923586,
                            18884195,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672
                        ]),
                        new Uint32Array([
                            2201121,
                            6291456,
                            2201153,
                            6291456,
                            2201185,
                            6291456,
                            2201217,
                            6291456,
                            2201249,
                            6291456,
                            2201281,
                            6291456,
                            2201313,
                            6291456,
                            2201345,
                            6291456
                        ]),
                        new Uint32Array([
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            0,
                            0,
                            0,
                            6291456,
                            6291456
                        ]),
                        new Uint32Array([
                            2211041,
                            2211073,
                            2211105,
                            2211137,
                            2211169,
                            2211201,
                            2211233,
                            2211265,
                            2211297,
                            2211329,
                            2211361,
                            2211393,
                            2211425,
                            2211457,
                            2211489,
                            2211521
                        ]),
                        new Uint32Array([
                            2181825,
                            6291456,
                            2181857,
                            6291456,
                            2181889,
                            6291456,
                            2181921,
                            6291456,
                            2181953,
                            6291456,
                            2181985,
                            6291456,
                            2182017,
                            6291456,
                            2182049,
                            6291456
                        ]),
                        new Uint32Array([
                            2162337,
                            2097633,
                            2097633,
                            2097633,
                            2097633,
                            2132705,
                            2132705,
                            2132705,
                            2132705,
                            2097153,
                            2097153,
                            2097153,
                            2097153,
                            2133089,
                            2133089,
                            2133089
                        ]),
                        new Uint32Array([
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            0,
                            0,
                            0,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456
                        ]),
                        new Uint32Array([
                            6291456,
                            2148545,
                            6291456,
                            2173473,
                            6291456,
                            2148865,
                            6291456,
                            2173505,
                            6291456,
                            2173537,
                            6291456,
                            2173569,
                            6291456,
                            2149121,
                            0,
                            0
                        ]),
                        new Uint32Array([
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0
                        ]),
                        new Uint32Array([
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            6291456,
                            6291456,
                            0,
                            6291456,
                            6291456
                        ]),
                        new Uint32Array([
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            23068672,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            0,
                            0,
                            0,
                            0
                        ]),
                        new Uint32Array([
                            2148801,
                            2173761,
                            2143969,
                            2173793,
                            2173825,
                            2153473,
                            2173857,
                            2173889,
                            2173921,
                            2173953,
                            2173985,
                            2174017,
                            2174017,
                            2174049,
                            2174081,
                            2174113
                        ]),
                        new Uint32Array([
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            0,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672
                        ]),
                        new Uint32Array([
                            2207137,
                            2207169,
                            2207201,
                            2207233,
                            2207265,
                            2207297,
                            2207329,
                            2207361,
                            2207393,
                            2207425,
                            2207457,
                            2207489,
                            2207521,
                            2207553,
                            2207585,
                            2207617
                        ]),
                        new Uint32Array([
                            6291456,
                            6291456,
                            23068672,
                            23068672,
                            23068672,
                            6291456,
                            6291456,
                            0,
                            23068672,
                            23068672,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0
                        ]),
                        new Uint32Array([
                            2198401,
                            2198433,
                            2198465,
                            2198497,
                            0,
                            2198529,
                            2198561,
                            2198593,
                            2198625,
                            2198657,
                            2198689,
                            2198721,
                            2198753,
                            2198785,
                            2198817,
                            2198849
                        ]),
                        new Uint32Array([
                            2105505,
                            2098241,
                            2108353,
                            2108417,
                            2105825,
                            2111713,
                            2100897,
                            2111905,
                            2105473,
                            2105569,
                            2105601,
                            2112289,
                            2108193,
                            2112481,
                            2112577,
                            2098177
                        ]),
                        new Uint32Array([
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            23068672,
                            0,
                            0
                        ]),
                        new Uint32Array([
                            2216385,
                            2118721,
                            2216417,
                            2216449,
                            2216481,
                            2216513,
                            2216545,
                            2211233,
                            2216577,
                            2216609,
                            2216641,
                            2216673,
                            2216705,
                            2216737,
                            2216737,
                            2216769
                        ]),
                        new Uint32Array([
                            2216801,
                            2216833,
                            2216865,
                            2216897,
                            2216929,
                            2216961,
                            2216993,
                            2215169,
                            2217025,
                            2217057,
                            2217089,
                            2217121,
                            2217154,
                            2217217,
                            0,
                            0
                        ]),
                        new Uint32Array([
                            2210593,
                            2191809,
                            2210625,
                            2210657,
                            2210689,
                            2210721,
                            2210753,
                            2210785,
                            2210817,
                            2210849,
                            2191297,
                            2210881,
                            2210913,
                            2210945,
                            2210977,
                            2211009
                        ]),
                        new Uint32Array([
                            0,
                            0,
                            2105825,
                            0,
                            0,
                            2111905,
                            2105473,
                            0,
                            0,
                            2112289,
                            2108193,
                            2112481,
                            2112577,
                            0,
                            2098305,
                            2108321
                        ]),
                        new Uint32Array([
                            0,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456
                        ]),
                        new Uint32Array([
                            0,
                            2097153,
                            2134241,
                            0,
                            2132705,
                            0,
                            0,
                            2131297,
                            0,
                            2133089,
                            0,
                            2133857,
                            0,
                            2220769,
                            0,
                            2235361
                        ]),
                        new Uint32Array([
                            14680064,
                            14680064,
                            14680064,
                            14680064,
                            14680064,
                            14680064,
                            14680064,
                            14680064,
                            14680064,
                            14680064,
                            14680064,
                            14680064,
                            14680064,
                            6291456,
                            6291456,
                            14680064
                        ]),
                        new Uint32Array([
                            23068672,
                            23068672,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0
                        ]),
                        new Uint32Array([
                            2171873,
                            6291456,
                            2171905,
                            6291456,
                            2171937,
                            6291456,
                            2171969,
                            6291456,
                            2172001,
                            6291456,
                            2172033,
                            6291456,
                            2172065,
                            6291456,
                            2172097,
                            6291456
                        ]),
                        new Uint32Array([
                            2220929,
                            2220929,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456
                        ]),
                        new Uint32Array([
                            2133857,
                            2134145,
                            2134145,
                            2134145,
                            2134145,
                            2134241,
                            2134241,
                            2134241,
                            2134241,
                            2105889,
                            2105889,
                            2105889,
                            2105889,
                            2097185,
                            2097185,
                            2097185
                        ]),
                        new Uint32Array([
                            2173697,
                            2173761,
                            2173793,
                            2174113,
                            2173985,
                            2173953,
                            2148481,
                            2173601,
                            2173633,
                            2173665,
                            2173697,
                            2173729,
                            2148801,
                            2173761,
                            2143969,
                            2173793
                        ]),
                        new Uint32Array([
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            10499619,
                            10499715,
                            10499811,
                            10499907
                        ]),
                        new Uint32Array([
                            0,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672
                        ]),
                        new Uint32Array([
                            6291456,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            23068672
                        ]),
                        new Uint32Array([
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            0,
                            0,
                            0,
                            0,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456
                        ]),
                        new Uint32Array([
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            0,
                            0,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672
                        ]),
                        new Uint32Array([
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            0,
                            6291456,
                            6291456,
                            0,
                            6291456
                        ]),
                        new Uint32Array([
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            6291456,
                            6291456,
                            6291456
                        ]),
                        new Uint32Array([
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            0,
                            23068672,
                            23068672,
                            23068672,
                            0,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            6291456,
                            6291456
                        ]),
                        new Uint32Array([
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            0,
                            0,
                            0,
                            6291456,
                            23068672,
                            23068672
                        ]),
                        new Uint32Array([
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            0,
                            0,
                            0,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456
                        ]),
                        new Uint32Array([
                            6291456,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            2144322,
                            2144386,
                            2144450,
                            2144514,
                            2144578,
                            2144642,
                            2144706,
                            2144770
                        ]),
                        new Uint32Array([
                            23068672,
                            23068672,
                            23068672,
                            6291456,
                            6291456,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            6291456,
                            6291456,
                            6291456,
                            6291456
                        ]),
                        new Uint32Array([
                            2113153,
                            2108481,
                            2113345,
                            2113441,
                            2098209,
                            2111137,
                            0,
                            2098241,
                            2108353,
                            2108417,
                            2105825,
                            0,
                            0,
                            2111905,
                            2105473,
                            2105569
                        ]),
                        new Uint32Array([
                            2236321,
                            2236353,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0
                        ]),
                        new Uint32Array([
                            2152194,
                            2121283,
                            2103684,
                            2103812,
                            2097986,
                            2098533,
                            2097990,
                            2098693,
                            2098595,
                            2098853,
                            2099013,
                            2103940,
                            2121379,
                            2121475,
                            2121571,
                            2104068
                        ]),
                        new Uint32Array([
                            2206241,
                            2206273,
                            2206305,
                            2206337,
                            2206369,
                            2206401,
                            2206433,
                            2206465,
                            2206497,
                            2206529,
                            2206561,
                            2206593,
                            2206625,
                            2206657,
                            2206689,
                            2206721
                        ]),
                        new Uint32Array([
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            16777216,
                            16777216,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672
                        ]),
                        new Uint32Array([
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            0,
                            0,
                            23068672,
                            23068672,
                            10538818,
                            10538882,
                            6291456,
                            6291456,
                            2150338
                        ]),
                        new Uint32Array([
                            6291456,
                            6291456,
                            6291456,
                            0,
                            0,
                            0,
                            0,
                            0,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456
                        ]),
                        new Uint32Array([
                            2214369,
                            2214401,
                            2214433,
                            2214465,
                            2214497,
                            2214529,
                            2214561,
                            2214593,
                            2194977,
                            2214625,
                            2195073,
                            2214657,
                            2214689,
                            2214721,
                            6291456,
                            6291456
                        ]),
                        new Uint32Array([
                            2097152,
                            2097152,
                            2097152,
                            2097152,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0
                        ]),
                        new Uint32Array([
                            2182081,
                            6291456,
                            2182113,
                            6291456,
                            2182145,
                            6291456,
                            2182177,
                            6291456,
                            2182209,
                            6291456,
                            2182241,
                            6291456,
                            2182273,
                            6291456,
                            2182305,
                            6291456
                        ]),
                        new Uint32Array([
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            2146881,
                            2146945,
                            2147009,
                            2147073,
                            2147137,
                            2147201,
                            2147265,
                            2147329
                        ]),
                        new Uint32Array([
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            0,
                            0,
                            6291456,
                            23068672,
                            23068672
                        ]),
                        new Uint32Array([
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456
                        ]),
                        new Uint32Array([
                            2122915,
                            2123011,
                            2123107,
                            2104708,
                            2123203,
                            2123299,
                            2123395,
                            2100133,
                            2104836,
                            2100290,
                            2100293,
                            2104962,
                            2104964,
                            2098052,
                            2123491,
                            2123587
                        ]),
                        new Uint32Array([
                            23068672,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            0,
                            6291456
                        ]),
                        new Uint32Array([
                            6291456,
                            2171169,
                            6291456,
                            2171201,
                            6291456,
                            2171233,
                            6291456,
                            2171265,
                            6291456,
                            2171297,
                            6291456,
                            2171329,
                            6291456,
                            6291456,
                            2171361,
                            6291456
                        ]),
                        new Uint32Array([
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            0,
                            0,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456
                        ]),
                        new Uint32Array([
                            0,
                            0,
                            2148994,
                            2149058,
                            2149122,
                            0,
                            6291456,
                            2149186,
                            2186945,
                            2173537,
                            2148993,
                            2149121,
                            2149058,
                            10531458,
                            10496066,
                            0
                        ]),
                        new Uint32Array([
                            2195009,
                            2195041,
                            2195073,
                            2195105,
                            2195137,
                            2195169,
                            2195201,
                            2195233,
                            2195265,
                            2195297,
                            2195329,
                            2195361,
                            2195393,
                            2195425,
                            2195457,
                            2195489
                        ]),
                        new Uint32Array([
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            6291456,
                            0,
                            0,
                            6291456,
                            6291456
                        ]),
                        new Uint32Array([
                            2182849,
                            6291456,
                            2182881,
                            6291456,
                            2182913,
                            6291456,
                            2182945,
                            6291456,
                            2182977,
                            6291456,
                            2183009,
                            6291456,
                            2183041,
                            6291456,
                            2183073,
                            6291456
                        ]),
                        new Uint32Array([
                            2211553,
                            2210081,
                            2211585,
                            2211617,
                            2211649,
                            2211681,
                            2211713,
                            2211745,
                            2211777,
                            2211809,
                            2209569,
                            2211841,
                            2211873,
                            2211905,
                            2211937,
                            2211969
                        ]),
                        new Uint32Array([
                            2112577,
                            2098177,
                            2098305,
                            2108321,
                            2108289,
                            2100865,
                            2113153,
                            2108481,
                            2113345,
                            2113441,
                            2166594,
                            2127298,
                            2166658,
                            2142978,
                            2141827,
                            2166722
                        ]),
                        new Uint32Array([
                            2173985,
                            2173761,
                            2174017,
                            2174049,
                            2174081,
                            2174113,
                            2174145,
                            2174177,
                            2149057,
                            2233057,
                            2148481,
                            2173601,
                            2173633,
                            2173665,
                            2173697,
                            2173729
                        ]),
                        new Uint32Array([
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            0,
                            0,
                            2185761,
                            2185793,
                            2185825,
                            2185857,
                            2185889,
                            2185921,
                            0,
                            0
                        ]),
                        new Uint32Array([
                            6291456,
                            2148481,
                            2173601,
                            2173633,
                            2173665,
                            2173697,
                            2173729,
                            2148801,
                            2173761,
                            2143969,
                            2173793,
                            2173825,
                            2153473,
                            2173857,
                            2173889,
                            2173921
                        ]),
                        new Uint32Array([
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            0,
                            0,
                            0,
                            0,
                            0,
                            6291456
                        ]),
                        new Uint32Array([
                            0,
                            0,
                            0,
                            2220961,
                            2220961,
                            2220961,
                            2220961,
                            2144193,
                            2144193,
                            2159201,
                            2159201,
                            2159265,
                            2159265,
                            2144194,
                            2220993,
                            2220993
                        ]),
                        new Uint32Array([
                            2192641,
                            2235393,
                            2235425,
                            2152257,
                            2116609,
                            2235457,
                            2235489,
                            2200065,
                            2235521,
                            2235553,
                            2235585,
                            2212449,
                            2235617,
                            2235649,
                            2235681,
                            2235713
                        ]),
                        new Uint32Array([
                            2194049,
                            2194081,
                            2194113,
                            2194145,
                            2194177,
                            2194209,
                            2194241,
                            2194273,
                            2194305,
                            2194337,
                            2194369,
                            2194401,
                            2194433,
                            2194465,
                            2194497,
                            2194529
                        ]),
                        new Uint32Array([
                            2196673,
                            2208641,
                            2208673,
                            2208705,
                            2208737,
                            2208769,
                            2208801,
                            2208833,
                            2208865,
                            2208897,
                            2208929,
                            2208961,
                            2208993,
                            2209025,
                            2209057,
                            2209089
                        ]),
                        new Uint32Array([
                            2191681,
                            2191713,
                            2191745,
                            2191777,
                            2153281,
                            2191809,
                            2191841,
                            2191873,
                            2191905,
                            2191937,
                            2191969,
                            2192001,
                            2192033,
                            2192065,
                            2192097,
                            2192129
                        ]),
                        new Uint32Array([
                            2230946,
                            2231010,
                            2231074,
                            2231138,
                            2231202,
                            2231266,
                            2231330,
                            2231394,
                            2231458,
                            2231522,
                            2231586,
                            2231650,
                            2231714,
                            2231778,
                            2231842,
                            2231906
                        ]),
                        new Uint32Array([
                            14680064,
                            14680064,
                            14680064,
                            14680064,
                            14680064,
                            14680064,
                            14680064,
                            14680064,
                            14680064,
                            14680064,
                            14680064,
                            14680064,
                            14680064,
                            14680064,
                            14680064,
                            14680064
                        ]),
                        new Uint32Array([
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            2185953,
                            2185985,
                            2186017,
                            2186049,
                            2186081,
                            2186113,
                            2186145,
                            2186177
                        ]),
                        new Uint32Array([
                            2139811,
                            2139907,
                            2097284,
                            2105860,
                            2105988,
                            2106116,
                            2106244,
                            2097444,
                            2097604,
                            2097155,
                            10485778,
                            10486344,
                            2106372,
                            6291456,
                            0,
                            0
                        ]),
                        new Uint32Array([
                            2110051,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456
                        ]),
                        new Uint32Array([
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456
                        ]),
                        new Uint32Array([
                            2172385,
                            6291456,
                            2172417,
                            6291456,
                            2172449,
                            6291456,
                            2172481,
                            6291456,
                            2172513,
                            6291456,
                            2172545,
                            6291456,
                            2172577,
                            6291456,
                            2172609,
                            6291456
                        ]),
                        new Uint32Array([
                            0,
                            0,
                            23068672,
                            23068672,
                            6291456,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0
                        ]),
                        new Uint32Array([
                            2249345,
                            2249377,
                            2249409,
                            2249441,
                            2249473,
                            2249505,
                            2249537,
                            2249570,
                            2210209,
                            2249633,
                            2249665,
                            2249697,
                            2249729,
                            2249761,
                            2249793,
                            2216769
                        ]),
                        new Uint32Array([
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            23068672,
                            23068672,
                            23068672,
                            23068672
                        ]),
                        new Uint32Array([
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            0,
                            0,
                            0,
                            0,
                            6291456,
                            6291456,
                            6291456,
                            6291456
                        ]),
                        new Uint32Array([
                            2187169,
                            2187201,
                            2187233,
                            2187265,
                            2187297,
                            2187329,
                            2187361,
                            2187393,
                            2187425,
                            2187457,
                            2187489,
                            2187521,
                            2187553,
                            2187585,
                            2187617,
                            2187649
                        ]),
                        new Uint32Array([
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            23068672,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456
                        ]),
                        new Uint32Array([
                            0,
                            0,
                            0,
                            6291456,
                            6291456,
                            0,
                            0,
                            0,
                            6291456,
                            6291456,
                            6291456,
                            0,
                            0,
                            0,
                            6291456,
                            6291456
                        ]),
                        new Uint32Array([
                            2182337,
                            6291456,
                            2182369,
                            6291456,
                            2182401,
                            6291456,
                            2182433,
                            6291456,
                            2182465,
                            6291456,
                            2182497,
                            6291456,
                            2182529,
                            6291456,
                            2182561,
                            6291456
                        ]),
                        new Uint32Array([
                            2138179,
                            2138275,
                            2138371,
                            2138467,
                            2134243,
                            2134435,
                            2138563,
                            2138659,
                            2138755,
                            2138851,
                            2138947,
                            2139043,
                            2138947,
                            2138755,
                            2139139,
                            2139235
                        ]),
                        new Uint32Array([
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0
                        ]),
                        new Uint32Array([
                            0,
                            0,
                            23068672,
                            23068672,
                            0,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456
                        ]),
                        new Uint32Array([
                            2250498,
                            2250562,
                            2250625,
                            2250657,
                            2208321,
                            2250689,
                            2250721,
                            2250753,
                            2250785,
                            2250817,
                            2250849,
                            2218945,
                            2250881,
                            2250913,
                            2250945,
                            0
                        ]),
                        new Uint32Array([
                            2170369,
                            2105569,
                            2098305,
                            2108481,
                            2173249,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456
                        ]),
                        new Uint32Array([
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            0,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            0,
                            0,
                            6291456
                        ]),
                        new Uint32Array([
                            2100897,
                            2111905,
                            2105473,
                            2105569,
                            2105601,
                            0,
                            2108193,
                            0,
                            0,
                            0,
                            2098305,
                            2108321,
                            2108289,
                            2100865,
                            2113153,
                            2108481
                        ]),
                        new Uint32Array([
                            2100897,
                            2100897,
                            2105569,
                            2105569,
                            6291456,
                            2112289,
                            2149826,
                            6291456,
                            6291456,
                            2112481,
                            2112577,
                            2098177,
                            2098177,
                            2098177,
                            6291456,
                            6291456
                        ]),
                        new Uint32Array([
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            0,
                            0,
                            6291456,
                            6291456,
                            6291456
                        ]),
                        new Uint32Array([
                            6291456,
                            2169953,
                            2169985,
                            6291456,
                            2170017,
                            6291456,
                            2170049,
                            2170081,
                            6291456,
                            2170113,
                            2170145,
                            2170177,
                            6291456,
                            6291456,
                            2170209,
                            2170241
                        ]),
                        new Uint32Array([
                            6291456,
                            6291456,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0
                        ]),
                        new Uint32Array([
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456
                        ]),
                        new Uint32Array([
                            2220641,
                            2220641,
                            2220673,
                            2220673,
                            2220673,
                            2220673,
                            2220705,
                            2220705,
                            2220705,
                            2220705,
                            2220737,
                            2220737,
                            2220737,
                            2220737,
                            2220769,
                            2220769
                        ]),
                        new Uint32Array([
                            2127650,
                            2127746,
                            2127842,
                            2127938,
                            2128034,
                            2128130,
                            2128226,
                            2128322,
                            2128418,
                            2127523,
                            2127619,
                            2127715,
                            2127811,
                            2127907,
                            2128003,
                            2128099
                        ]),
                        new Uint32Array([
                            2143969,
                            2173793,
                            2173825,
                            2153473,
                            2173857,
                            2173889,
                            2173921,
                            2173953,
                            2173985,
                            2173761,
                            2174017,
                            2174049,
                            2174081,
                            2174113,
                            2174145,
                            2174177
                        ]),
                        new Uint32Array([
                            0,
                            0,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672
                        ]),
                        new Uint32Array([
                            2204705,
                            2204737,
                            2204769,
                            2204801,
                            2204833,
                            2204865,
                            2204897,
                            2204929,
                            2204961,
                            2204993,
                            2205025,
                            2205057,
                            2205089,
                            2205121,
                            2205153,
                            2205185
                        ]),
                        new Uint32Array([
                            2176385,
                            6291456,
                            2176417,
                            6291456,
                            2176449,
                            6291456,
                            2176481,
                            6291456,
                            2176513,
                            6291456,
                            2176545,
                            6291456,
                            2176577,
                            6291456,
                            2176609,
                            6291456
                        ]),
                        new Uint32Array([
                            2195521,
                            2195553,
                            2195585,
                            2195617,
                            2195649,
                            2195681,
                            2117857,
                            2195713,
                            2195745,
                            2195777,
                            2195809,
                            2195841,
                            2195873,
                            2195905,
                            2195937,
                            2195969
                        ]),
                        new Uint32Array([
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672
                        ]),
                        new Uint32Array([
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            0,
                            0,
                            0,
                            0
                        ]),
                        new Uint32Array([
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            0,
                            6291456,
                            6291456,
                            6291456
                        ]),
                        new Uint32Array([
                            2173921,
                            2173953,
                            2173985,
                            2174017,
                            2174017,
                            2174049,
                            2174081,
                            2174113,
                            2174145,
                            2174177,
                            2149057,
                            2233089,
                            2173697,
                            2173761,
                            2173793,
                            2174113
                        ]),
                        new Uint32Array([
                            2131586,
                            2132450,
                            2135970,
                            2135778,
                            2161602,
                            2136162,
                            2163650,
                            2161794,
                            2135586,
                            2163714,
                            2137186,
                            2131810,
                            2160290,
                            2135170,
                            2097506,
                            2159554
                        ]),
                        new Uint32Array([
                            2134145,
                            2097153,
                            2134241,
                            2105953,
                            2132705,
                            2130977,
                            2160065,
                            2131297,
                            2162049,
                            2133089,
                            2160577,
                            2133857,
                            0,
                            0,
                            0,
                            0
                        ]),
                        new Uint32Array([
                            2116513,
                            2116609,
                            2116705,
                            2116801,
                            2116897,
                            2116993,
                            2117089,
                            2117185,
                            2117281,
                            2117377,
                            2117473,
                            2117569,
                            2117665,
                            2117761,
                            2117857,
                            2117953
                        ]),
                        new Uint32Array([
                            2100737,
                            2098337,
                            2101441,
                            2101569,
                            2101697,
                            2101825,
                            2101953,
                            2102081,
                            2102209,
                            2100802,
                            2101154,
                            2101282,
                            2101410,
                            2101538,
                            2101666,
                            2101794
                        ]),
                        new Uint32Array([
                            2100289,
                            2098657,
                            2098049,
                            2200737,
                            2123489,
                            2123681,
                            2200769,
                            2098625,
                            2100321,
                            2098145,
                            2100449,
                            2098017,
                            2098753,
                            2098977,
                            2150241,
                            2150305
                        ]),
                        new Uint32Array([
                            6291456,
                            6291456,
                            6291456,
                            0,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            2109955,
                            6291456,
                            6291456,
                            0,
                            0,
                            0,
                            0
                        ]),
                        new Uint32Array([
                            18874368,
                            18874368,
                            18874368,
                            18874368,
                            18874368,
                            18874368,
                            18874368,
                            18874368,
                            18874368,
                            18874368,
                            18874368,
                            18874368,
                            18874368,
                            18874368,
                            18874368,
                            18874368
                        ]),
                        new Uint32Array([
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            0,
                            6291456,
                            0,
                            6291456,
                            0,
                            0
                        ]),
                        new Uint32Array([
                            2130979,
                            2131075,
                            2131075,
                            2131171,
                            2131267,
                            2131363,
                            2131459,
                            2131555,
                            2131651,
                            2131651,
                            2131747,
                            2131843,
                            2131939,
                            2132035,
                            2132131,
                            2132227
                        ]),
                        new Uint32Array([
                            0,
                            2177793,
                            6291456,
                            2177825,
                            6291456,
                            2177857,
                            6291456,
                            2177889,
                            6291456,
                            2177921,
                            6291456,
                            2177953,
                            6291456,
                            2177985,
                            6291456,
                            6291456
                        ]),
                        new Uint32Array([
                            6291456,
                            6291456,
                            6291456,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672
                        ]),
                        new Uint32Array([
                            6291456,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0
                        ]),
                        new Uint32Array([
                            2113345,
                            0,
                            2098209,
                            2111137,
                            2105505,
                            2098241,
                            2108353,
                            2108417,
                            2105825,
                            2111713,
                            2100897,
                            2111905,
                            2105473,
                            2105569,
                            2105601,
                            2112289
                        ]),
                        new Uint32Array([
                            2136643,
                            2136739,
                            2136835,
                            2136931,
                            2137027,
                            2137123,
                            2137219,
                            2137315,
                            2137411,
                            2137507,
                            2137603,
                            2137699,
                            2137795,
                            2137891,
                            2137987,
                            2138083
                        ]),
                        new Uint32Array([
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            0
                        ]),
                        new Uint32Array([
                            2174433,
                            6291456,
                            2174465,
                            6291456,
                            2174497,
                            6291456,
                            2174529,
                            6291456,
                            2174561,
                            6291456,
                            2174593,
                            6291456,
                            2174625,
                            6291456,
                            2174657,
                            6291456
                        ]),
                        new Uint32Array([
                            0,
                            0,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456
                        ]),
                        new Uint32Array([
                            2105473,
                            2105569,
                            2105601,
                            2112289,
                            2108193,
                            2112481,
                            2112577,
                            2098177,
                            2098305,
                            2108321,
                            2108289,
                            2100865,
                            2113153,
                            2108481,
                            2113345,
                            2113441
                        ]),
                        new Uint32Array([
                            10496547,
                            10496643,
                            2105505,
                            2149698,
                            6291456,
                            10496739,
                            10496835,
                            2170273,
                            6291456,
                            2149762,
                            2105825,
                            2111713,
                            2111713,
                            2111713,
                            2111713,
                            2168673
                        ]),
                        new Uint32Array([
                            6291456,
                            2143490,
                            2143490,
                            2143490,
                            2171649,
                            6291456,
                            2171681,
                            2171713,
                            2171745,
                            6291456,
                            2171777,
                            6291456,
                            2171809,
                            6291456,
                            2171841,
                            6291456
                        ]),
                        new Uint32Array([
                            2159106,
                            2159106,
                            2159170,
                            2159170,
                            2159234,
                            2159234,
                            2159298,
                            2159298,
                            2159298,
                            2159362,
                            2159362,
                            2159362,
                            2106401,
                            2106401,
                            2106401,
                            2106401
                        ]),
                        new Uint32Array([
                            2105601,
                            2112289,
                            2108193,
                            2112481,
                            2112577,
                            2098177,
                            2098305,
                            2108321,
                            2108289,
                            2100865,
                            2113153,
                            2108481,
                            2113345,
                            2113441,
                            2098209,
                            2111137
                        ]),
                        new Uint32Array([
                            2108417,
                            2181217,
                            2181249,
                            2181281,
                            2170433,
                            2170401,
                            2181313,
                            2181345,
                            2181377,
                            2181409,
                            2181441,
                            2181473,
                            2181505,
                            2181537,
                            2170529,
                            2181569
                        ]),
                        new Uint32Array([
                            2218433,
                            2245761,
                            2245793,
                            2245825,
                            2245857,
                            2245890,
                            2245953,
                            2245986,
                            2209665,
                            2246050,
                            2246113,
                            2246146,
                            2246210,
                            2246274,
                            2246337,
                            2246369
                        ]),
                        new Uint32Array([
                            2230754,
                            2230818,
                            2230882,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0
                        ]),
                        new Uint32Array([
                            6291456,
                            0,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            0,
                            0,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456
                        ]),
                        new Uint32Array([
                            6291456,
                            0,
                            0,
                            0,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456
                        ]),
                        new Uint32Array([
                            2184129,
                            6291456,
                            2184161,
                            6291456,
                            2184193,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            2146818,
                            2183361,
                            6291456,
                            6291456,
                            2142978,
                            6291456
                        ]),
                        new Uint32Array([
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            0,
                            0,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456
                        ]),
                        new Uint32Array([
                            2135170,
                            2097506,
                            2130691,
                            2130787,
                            2130883,
                            2163970,
                            2164034,
                            2164098,
                            2164162,
                            2164226,
                            2164290,
                            2164354,
                            2164418,
                            2164482,
                            2164546,
                            2133122
                        ]),
                        new Uint32Array([
                            2108515,
                            2108611,
                            2100740,
                            2108707,
                            2108803,
                            2108899,
                            2108995,
                            2109091,
                            2109187,
                            2109283,
                            2109379,
                            2109475,
                            2109571,
                            2109667,
                            2109763,
                            2100738
                        ]),
                        new Uint32Array([
                            2102788,
                            2102916,
                            2103044,
                            2120515,
                            2103172,
                            2120611,
                            2120707,
                            2098373,
                            2103300,
                            2120803,
                            2120899,
                            2120995,
                            2103428,
                            2103556,
                            2121091,
                            2121187
                        ]),
                        new Uint32Array([
                            2158082,
                            2158146,
                            0,
                            2158210,
                            2158274,
                            0,
                            2158338,
                            2158402,
                            2158466,
                            2129922,
                            2158530,
                            2158594,
                            2158658,
                            2158722,
                            2158786,
                            2158850
                        ]),
                        new Uint32Array([
                            10499619,
                            10499715,
                            10499811,
                            10499907,
                            10500003,
                            10500099,
                            10500195,
                            10500291,
                            10500387,
                            10500483,
                            10500579,
                            10500675,
                            10500771,
                            10500867,
                            10500963,
                            10501059
                        ]),
                        new Uint32Array([
                            2239585,
                            2239618,
                            2239681,
                            2239713,
                            0,
                            2191969,
                            2239745,
                            2239777,
                            2192033,
                            2239809,
                            2239841,
                            2239874,
                            2239937,
                            2239970,
                            2240033,
                            2240065
                        ]),
                        new Uint32Array([
                            2252705,
                            2252738,
                            2252801,
                            2252833,
                            2252865,
                            2252897,
                            2252930,
                            2252994,
                            2253057,
                            2253089,
                            2253121,
                            2253154,
                            2253217,
                            2253250,
                            2219361,
                            2219361
                        ]),
                        new Uint32Array([
                            2105825,
                            2111713,
                            2100897,
                            2111905,
                            2105473,
                            2105569,
                            2105601,
                            2112289,
                            2108193,
                            2112481,
                            2112577,
                            2098177,
                            2098305,
                            2108321,
                            2108289,
                            2100865
                        ]),
                        new Uint32Array([
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            10538050,
                            10538114,
                            10538178,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456
                        ]),
                        new Uint32Array([
                            2226402,
                            2226466,
                            2226530,
                            2226594,
                            2226658,
                            2226722,
                            2226786,
                            2226850,
                            2226914,
                            2226978,
                            2227042,
                            2227106,
                            2227170,
                            2227234,
                            2227298,
                            2227362
                        ]),
                        new Uint32Array([
                            23068672,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            2144066,
                            2144130,
                            2144194,
                            2144258,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456
                        ]),
                        new Uint32Array([
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            23068672,
                            23068672,
                            23068672,
                            6291456,
                            23068672,
                            23068672
                        ]),
                        new Uint32Array([
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0
                        ]),
                        new Uint32Array([
                            2124674,
                            2124770,
                            2123875,
                            2123971,
                            2124067,
                            2124163,
                            2124259,
                            2124355,
                            2124451,
                            2124547,
                            2124643,
                            2124739,
                            2124835,
                            2124931,
                            2125027,
                            2125123
                        ]),
                        new Uint32Array([
                            2168065,
                            6291456,
                            2168097,
                            6291456,
                            2168129,
                            6291456,
                            2168161,
                            6291456,
                            2168193,
                            6291456,
                            2168225,
                            6291456,
                            2168257,
                            6291456,
                            2168289,
                            6291456
                        ]),
                        new Uint32Array([
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            0,
                            0,
                            0,
                            0
                        ]),
                        new Uint32Array([
                            23068672,
                            23068672,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456
                        ]),
                        new Uint32Array([
                            6291456,
                            6291456,
                            6291456,
                            2100610,
                            2100611,
                            6291456,
                            2107842,
                            2107843,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            10537922,
                            6291456,
                            10537986,
                            6291456
                        ]),
                        new Uint32Array([
                            2174849,
                            2174881,
                            2174913,
                            2174945,
                            2174977,
                            2175009,
                            2175041,
                            2175073,
                            2175105,
                            2175137,
                            2175169,
                            2175201,
                            2175233,
                            2175265,
                            2175297,
                            2175329
                        ]),
                        new Uint32Array([
                            2154562,
                            2154626,
                            2154690,
                            2154754,
                            2141858,
                            2154818,
                            2154882,
                            2127298,
                            2154946,
                            2127298,
                            2155010,
                            2155074,
                            2155138,
                            2155202,
                            2155266,
                            2155202
                        ]),
                        new Uint32Array([
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            23068672,
                            0
                        ]),
                        new Uint32Array([
                            2200641,
                            2150786,
                            2150850,
                            2150914,
                            2150978,
                            2151042,
                            2106562,
                            2151106,
                            2150562,
                            2151170,
                            2151234,
                            2151298,
                            2151362,
                            2151426,
                            2151490,
                            2151554
                        ]),
                        new Uint32Array([
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            6291456,
                            6291456
                        ]),
                        new Uint32Array([
                            2220289,
                            2220289,
                            2220321,
                            2220321,
                            2220321,
                            2220321,
                            2220353,
                            2220353,
                            2220353,
                            2220353,
                            2220385,
                            2220385,
                            2220385,
                            2220385,
                            2220417,
                            2220417
                        ]),
                        new Uint32Array([
                            2155330,
                            2155394,
                            0,
                            2155458,
                            2155522,
                            2155586,
                            2105732,
                            0,
                            2155650,
                            2155714,
                            2155778,
                            2125314,
                            2155842,
                            2155906,
                            2126274,
                            2155970
                        ]),
                        new Uint32Array([
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            6291456,
                            6291456,
                            23068672,
                            23068672,
                            6291456,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            6291456,
                            6291456
                        ]),
                        new Uint32Array([
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0
                        ]),
                        new Uint32Array([
                            2097729,
                            2106017,
                            2106017,
                            2106017,
                            2106017,
                            2131297,
                            2131297,
                            2131297,
                            2131297,
                            2106081,
                            2106081,
                            2162049,
                            2162049,
                            2105953,
                            2105953,
                            2162337
                        ]),
                        new Uint32Array([
                            2097185,
                            2097697,
                            2097697,
                            2097697,
                            2097697,
                            2135777,
                            2135777,
                            2135777,
                            2135777,
                            2097377,
                            2097377,
                            2097377,
                            2097377,
                            2097601,
                            2097601,
                            2097217
                        ]),
                        new Uint32Array([
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            23068672
                        ]),
                        new Uint32Array([
                            2139331,
                            2139427,
                            2139523,
                            2139043,
                            2133571,
                            2132611,
                            2139619,
                            2139715,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0
                        ]),
                        new Uint32Array([
                            2174113,
                            2174145,
                            2100897,
                            2098177,
                            2108289,
                            2100865,
                            2173601,
                            2173633,
                            2173985,
                            2174113,
                            2174145,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            6291456
                        ]),
                        new Uint32Array([
                            6291456,
                            6291456,
                            23068672,
                            6291456,
                            6291456,
                            6291456,
                            23068672,
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            23068672,
                            6291456,
                            6291456,
                            6291456,
                            6291456
                        ]),
                        new Uint32Array([
                            23068672,
                            23068672,
                            18923778,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            18923842,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            18923906,
                            23068672,
                            23068672,
                            23068672
                        ]),
                        new Uint32Array([
                            2134145,
                            2097153,
                            2134241,
                            0,
                            2132705,
                            2130977,
                            2160065,
                            2131297,
                            0,
                            2133089,
                            0,
                            2133857,
                            0,
                            0,
                            0,
                            0
                        ]),
                        new Uint32Array([
                            6291456,
                            6291456,
                            6291456,
                            6291456,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0
                        ]),
                        new Uint32Array([
                            2177537,
                            6291456,
                            2177569,
                            6291456,
                            2177601,
                            6291456,
                            2177633,
                            6291456,
                            2177665,
                            6291456,
                            2177697,
                            6291456,
                            2177729,
                            6291456,
                            2177761,
                            6291456
                        ]),
                        new Uint32Array([
                            2212481,
                            2212513,
                            2212545,
                            2212577,
                            2197121,
                            2212609,
                            2212641,
                            2212673,
                            2212705,
                            2212737,
                            2212769,
                            2212801,
                            2212833,
                            2212865,
                            2212897,
                            2212929
                        ]),
                        new Uint32Array([
                            6291456,
                            6291456,
                            23068672,
                            23068672,
                            23068672,
                            6291456,
                            6291456,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0
                        ]),
                        new Uint32Array([
                            2098241,
                            2108353,
                            2170209,
                            2105825,
                            2111713,
                            2100897,
                            2111905,
                            2105473,
                            2105569,
                            2105601,
                            2112289,
                            6291456,
                            2108193,
                            2172417,
                            2112481,
                            2098177
                        ]),
                        new Uint32Array([
                            6291456,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            23068672,
                            6291456,
                            6291456
                        ])
                    ], t = new Uint16Array([
                        616,
                        616,
                        565,
                        147,
                        161,
                        411,
                        330,
                        2,
                        131,
                        131,
                        328,
                        454,
                        241,
                        408,
                        86,
                        86,
                        696,
                        113,
                        285,
                        350,
                        325,
                        301,
                        473,
                        214,
                        639,
                        232,
                        447,
                        64,
                        369,
                        598,
                        124,
                        672,
                        567,
                        223,
                        621,
                        154,
                        107,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        505,
                        86,
                        68,
                        634,
                        86,
                        218,
                        218,
                        218,
                        218,
                        486,
                        218,
                        218,
                        513,
                        188,
                        608,
                        216,
                        86,
                        217,
                        463,
                        668,
                        85,
                        700,
                        360,
                        184,
                        86,
                        86,
                        86,
                        647,
                        402,
                        153,
                        10,
                        346,
                        718,
                        662,
                        260,
                        145,
                        298,
                        117,
                        1,
                        443,
                        342,
                        138,
                        54,
                        563,
                        86,
                        240,
                        572,
                        218,
                        70,
                        387,
                        86,
                        118,
                        460,
                        641,
                        602,
                        86,
                        86,
                        306,
                        218,
                        86,
                        692,
                        86,
                        86,
                        86,
                        86,
                        86,
                        162,
                        707,
                        86,
                        458,
                        26,
                        86,
                        218,
                        638,
                        86,
                        86,
                        86,
                        86,
                        86,
                        65,
                        449,
                        86,
                        86,
                        306,
                        183,
                        86,
                        58,
                        391,
                        667,
                        86,
                        157,
                        131,
                        131,
                        131,
                        131,
                        86,
                        433,
                        131,
                        406,
                        31,
                        218,
                        247,
                        86,
                        86,
                        693,
                        218,
                        581,
                        351,
                        86,
                        438,
                        295,
                        69,
                        462,
                        45,
                        126,
                        173,
                        650,
                        14,
                        295,
                        69,
                        97,
                        168,
                        187,
                        641,
                        78,
                        523,
                        390,
                        69,
                        108,
                        287,
                        664,
                        173,
                        219,
                        83,
                        295,
                        69,
                        108,
                        431,
                        426,
                        173,
                        694,
                        412,
                        115,
                        628,
                        52,
                        257,
                        398,
                        641,
                        118,
                        501,
                        121,
                        69,
                        579,
                        151,
                        423,
                        173,
                        620,
                        464,
                        121,
                        69,
                        382,
                        151,
                        476,
                        173,
                        27,
                        53,
                        121,
                        86,
                        594,
                        578,
                        226,
                        173,
                        86,
                        632,
                        130,
                        86,
                        96,
                        228,
                        268,
                        641,
                        622,
                        563,
                        86,
                        86,
                        21,
                        148,
                        650,
                        131,
                        131,
                        321,
                        43,
                        144,
                        343,
                        381,
                        531,
                        131,
                        131,
                        178,
                        20,
                        86,
                        399,
                        156,
                        375,
                        164,
                        541,
                        30,
                        60,
                        715,
                        198,
                        92,
                        118,
                        131,
                        131,
                        86,
                        86,
                        306,
                        407,
                        86,
                        280,
                        457,
                        196,
                        488,
                        358,
                        131,
                        131,
                        244,
                        86,
                        86,
                        143,
                        86,
                        86,
                        86,
                        86,
                        86,
                        667,
                        563,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        336,
                        363,
                        86,
                        86,
                        336,
                        86,
                        86,
                        380,
                        678,
                        67,
                        86,
                        86,
                        86,
                        678,
                        86,
                        86,
                        86,
                        512,
                        86,
                        307,
                        86,
                        708,
                        86,
                        86,
                        86,
                        86,
                        86,
                        528,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        563,
                        307,
                        86,
                        86,
                        86,
                        86,
                        86,
                        104,
                        450,
                        337,
                        86,
                        720,
                        86,
                        32,
                        450,
                        397,
                        86,
                        86,
                        86,
                        587,
                        218,
                        558,
                        708,
                        708,
                        293,
                        708,
                        86,
                        86,
                        86,
                        86,
                        86,
                        694,
                        205,
                        86,
                        8,
                        86,
                        86,
                        86,
                        86,
                        549,
                        86,
                        667,
                        697,
                        697,
                        679,
                        86,
                        458,
                        460,
                        86,
                        86,
                        650,
                        86,
                        708,
                        543,
                        86,
                        86,
                        86,
                        245,
                        86,
                        86,
                        86,
                        140,
                        218,
                        127,
                        708,
                        708,
                        458,
                        197,
                        131,
                        131,
                        131,
                        131,
                        500,
                        86,
                        86,
                        483,
                        251,
                        86,
                        306,
                        510,
                        515,
                        86,
                        722,
                        86,
                        86,
                        86,
                        65,
                        201,
                        86,
                        86,
                        483,
                        580,
                        470,
                        86,
                        86,
                        86,
                        368,
                        131,
                        131,
                        131,
                        694,
                        114,
                        110,
                        555,
                        86,
                        86,
                        123,
                        721,
                        163,
                        142,
                        713,
                        418,
                        86,
                        317,
                        675,
                        209,
                        218,
                        218,
                        218,
                        371,
                        545,
                        592,
                        629,
                        490,
                        603,
                        199,
                        46,
                        320,
                        525,
                        680,
                        310,
                        279,
                        388,
                        111,
                        42,
                        252,
                        593,
                        607,
                        235,
                        617,
                        410,
                        377,
                        50,
                        548,
                        135,
                        356,
                        17,
                        520,
                        189,
                        116,
                        392,
                        600,
                        349,
                        332,
                        482,
                        699,
                        690,
                        535,
                        119,
                        106,
                        451,
                        71,
                        152,
                        667,
                        131,
                        218,
                        218,
                        265,
                        671,
                        637,
                        492,
                        504,
                        533,
                        683,
                        269,
                        269,
                        658,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        491,
                        619,
                        86,
                        86,
                        6,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        229,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        667,
                        86,
                        86,
                        171,
                        131,
                        118,
                        131,
                        656,
                        206,
                        234,
                        571,
                        89,
                        334,
                        670,
                        246,
                        311,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        534,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        82,
                        86,
                        86,
                        86,
                        86,
                        86,
                        430,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        599,
                        86,
                        324,
                        86,
                        470,
                        69,
                        640,
                        264,
                        131,
                        626,
                        101,
                        174,
                        86,
                        86,
                        667,
                        233,
                        105,
                        73,
                        374,
                        394,
                        221,
                        204,
                        84,
                        28,
                        326,
                        86,
                        86,
                        471,
                        86,
                        86,
                        86,
                        109,
                        573,
                        86,
                        171,
                        200,
                        200,
                        200,
                        200,
                        218,
                        218,
                        86,
                        86,
                        86,
                        86,
                        460,
                        131,
                        131,
                        131,
                        86,
                        506,
                        86,
                        86,
                        86,
                        86,
                        86,
                        220,
                        404,
                        34,
                        614,
                        47,
                        442,
                        305,
                        25,
                        612,
                        338,
                        601,
                        648,
                        7,
                        344,
                        255,
                        131,
                        131,
                        51,
                        86,
                        312,
                        507,
                        563,
                        86,
                        86,
                        86,
                        86,
                        588,
                        86,
                        86,
                        86,
                        86,
                        86,
                        530,
                        511,
                        86,
                        458,
                        3,
                        435,
                        384,
                        556,
                        522,
                        230,
                        527,
                        86,
                        118,
                        86,
                        86,
                        717,
                        86,
                        137,
                        273,
                        79,
                        181,
                        484,
                        23,
                        93,
                        112,
                        655,
                        249,
                        417,
                        703,
                        370,
                        87,
                        98,
                        313,
                        684,
                        585,
                        155,
                        465,
                        596,
                        481,
                        695,
                        18,
                        416,
                        428,
                        61,
                        701,
                        706,
                        282,
                        643,
                        495,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        549,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        549,
                        131,
                        131,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        307,
                        86,
                        86,
                        86,
                        171,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        650,
                        131,
                        422,
                        542,
                        420,
                        263,
                        24,
                        172,
                        86,
                        86,
                        86,
                        86,
                        86,
                        566,
                        86,
                        86,
                        132,
                        540,
                        395,
                        353,
                        494,
                        519,
                        19,
                        485,
                        284,
                        472,
                        131,
                        131,
                        131,
                        16,
                        714,
                        86,
                        211,
                        708,
                        86,
                        86,
                        86,
                        694,
                        698,
                        86,
                        86,
                        483,
                        704,
                        708,
                        218,
                        272,
                        86,
                        86,
                        120,
                        86,
                        159,
                        478,
                        86,
                        307,
                        247,
                        86,
                        86,
                        663,
                        597,
                        459,
                        627,
                        667,
                        86,
                        86,
                        277,
                        455,
                        39,
                        302,
                        86,
                        250,
                        86,
                        86,
                        86,
                        271,
                        99,
                        452,
                        306,
                        281,
                        329,
                        400,
                        200,
                        86,
                        86,
                        362,
                        549,
                        352,
                        646,
                        461,
                        323,
                        586,
                        86,
                        86,
                        4,
                        708,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        717,
                        86,
                        518,
                        86,
                        86,
                        650,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        125,
                        554,
                        480,
                        300,
                        613,
                        72,
                        333,
                        288,
                        561,
                        544,
                        604,
                        48,
                        719,
                        91,
                        169,
                        176,
                        590,
                        224,
                        76,
                        191,
                        29,
                        559,
                        560,
                        231,
                        537,
                        166,
                        477,
                        538,
                        256,
                        437,
                        131,
                        131,
                        469,
                        167,
                        40,
                        0,
                        685,
                        266,
                        441,
                        705,
                        239,
                        642,
                        475,
                        568,
                        640,
                        610,
                        299,
                        673,
                        517,
                        318,
                        385,
                        22,
                        202,
                        180,
                        179,
                        359,
                        424,
                        215,
                        90,
                        66,
                        521,
                        653,
                        467,
                        682,
                        453,
                        409,
                        479,
                        88,
                        131,
                        661,
                        35,
                        303,
                        15,
                        262,
                        666,
                        630,
                        712,
                        131,
                        131,
                        618,
                        659,
                        175,
                        218,
                        195,
                        347,
                        193,
                        227,
                        261,
                        150,
                        165,
                        709,
                        546,
                        294,
                        569,
                        710,
                        270,
                        413,
                        376,
                        524,
                        55,
                        242,
                        38,
                        419,
                        529,
                        170,
                        657,
                        3,
                        304,
                        122,
                        379,
                        278,
                        131,
                        651,
                        86,
                        67,
                        576,
                        458,
                        458,
                        131,
                        131,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        118,
                        309,
                        86,
                        86,
                        547,
                        86,
                        86,
                        86,
                        86,
                        667,
                        650,
                        664,
                        131,
                        131,
                        86,
                        86,
                        56,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        86,
                        307,
                        86,
                        86,
                        86,
                        664,
                        238,
                        650,
                        86,
                        86,
                        717,
                        86,
                        118,
                        86,
                        86,
                        315,
                        86,
                        59,
                        86,
                        86,
                        574,
                        549,
                        131,
                        131,
                        340,
                        57,
                        436,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        458,
                        708,
                        499,
                        691,
                        62,
                        86,
                        650,
                        86,
                        86,
                        694,
                        86,
                        86,
                        86,
                        319,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        171,
                        86,
                        549,
                        694,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        77,
                        86,
                        86,
                        139,
                        86,
                        502,
                        86,
                        86,
                        86,
                        667,
                        595,
                        131,
                        131,
                        131,
                        86,
                        12,
                        86,
                        13,
                        86,
                        609,
                        131,
                        131,
                        131,
                        131,
                        86,
                        86,
                        86,
                        625,
                        86,
                        669,
                        86,
                        86,
                        182,
                        129,
                        86,
                        5,
                        694,
                        104,
                        86,
                        86,
                        86,
                        86,
                        131,
                        131,
                        86,
                        86,
                        386,
                        171,
                        86,
                        86,
                        86,
                        345,
                        86,
                        324,
                        86,
                        589,
                        86,
                        213,
                        36,
                        131,
                        131,
                        131,
                        131,
                        131,
                        86,
                        86,
                        86,
                        86,
                        104,
                        131,
                        131,
                        131,
                        141,
                        290,
                        80,
                        677,
                        86,
                        86,
                        86,
                        267,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        86,
                        667,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        515,
                        86,
                        86,
                        33,
                        136,
                        669,
                        86,
                        711,
                        515,
                        86,
                        86,
                        550,
                        640,
                        86,
                        104,
                        708,
                        515,
                        86,
                        159,
                        372,
                        717,
                        86,
                        86,
                        444,
                        515,
                        86,
                        86,
                        663,
                        37,
                        86,
                        563,
                        460,
                        86,
                        390,
                        624,
                        702,
                        131,
                        131,
                        131,
                        131,
                        389,
                        59,
                        708,
                        86,
                        86,
                        341,
                        208,
                        708,
                        635,
                        295,
                        69,
                        108,
                        431,
                        508,
                        100,
                        190,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        86,
                        86,
                        86,
                        649,
                        516,
                        660,
                        131,
                        131,
                        86,
                        86,
                        86,
                        218,
                        631,
                        708,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        86,
                        86,
                        341,
                        575,
                        238,
                        514,
                        131,
                        131,
                        86,
                        86,
                        86,
                        218,
                        291,
                        708,
                        307,
                        131,
                        86,
                        86,
                        306,
                        367,
                        708,
                        131,
                        131,
                        131,
                        86,
                        378,
                        697,
                        86,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        615,
                        253,
                        86,
                        86,
                        86,
                        292,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        86,
                        86,
                        86,
                        104,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        69,
                        86,
                        341,
                        553,
                        549,
                        86,
                        307,
                        86,
                        86,
                        645,
                        275,
                        455,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        708,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        667,
                        460,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        717,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        667,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        171,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        104,
                        86,
                        667,
                        459,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        86,
                        458,
                        225,
                        86,
                        86,
                        86,
                        516,
                        549,
                        11,
                        390,
                        405,
                        86,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        86,
                        86,
                        86,
                        86,
                        460,
                        44,
                        218,
                        197,
                        711,
                        515,
                        131,
                        131,
                        131,
                        131,
                        664,
                        131,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        307,
                        131,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        308,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        640,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        118,
                        307,
                        104,
                        286,
                        591,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        549,
                        86,
                        86,
                        681,
                        86,
                        86,
                        75,
                        185,
                        314,
                        582,
                        86,
                        358,
                        496,
                        474,
                        86,
                        104,
                        131,
                        86,
                        86,
                        86,
                        86,
                        146,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        86,
                        86,
                        86,
                        86,
                        86,
                        171,
                        86,
                        640,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        246,
                        503,
                        689,
                        339,
                        674,
                        81,
                        258,
                        415,
                        439,
                        128,
                        562,
                        366,
                        414,
                        246,
                        503,
                        689,
                        583,
                        222,
                        557,
                        316,
                        636,
                        665,
                        186,
                        355,
                        95,
                        670,
                        246,
                        503,
                        689,
                        339,
                        674,
                        557,
                        258,
                        415,
                        439,
                        186,
                        355,
                        95,
                        670,
                        246,
                        503,
                        689,
                        446,
                        644,
                        536,
                        652,
                        331,
                        532,
                        335,
                        440,
                        274,
                        421,
                        297,
                        570,
                        74,
                        425,
                        364,
                        425,
                        606,
                        552,
                        403,
                        509,
                        134,
                        365,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        218,
                        218,
                        218,
                        498,
                        218,
                        218,
                        577,
                        627,
                        551,
                        497,
                        572,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        553,
                        354,
                        236,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        296,
                        455,
                        131,
                        131,
                        456,
                        243,
                        103,
                        86,
                        41,
                        459,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        9,
                        276,
                        158,
                        716,
                        393,
                        564,
                        383,
                        489,
                        401,
                        654,
                        210,
                        654,
                        131,
                        131,
                        131,
                        640,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        86,
                        86,
                        650,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        717,
                        667,
                        563,
                        563,
                        563,
                        86,
                        549,
                        102,
                        686,
                        133,
                        246,
                        605,
                        86,
                        448,
                        86,
                        86,
                        207,
                        307,
                        131,
                        131,
                        131,
                        641,
                        86,
                        177,
                        611,
                        445,
                        373,
                        194,
                        584,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        308,
                        307,
                        171,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        717,
                        86,
                        86,
                        86,
                        86,
                        86,
                        460,
                        131,
                        131,
                        650,
                        86,
                        86,
                        86,
                        694,
                        708,
                        86,
                        86,
                        694,
                        86,
                        458,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        667,
                        694,
                        289,
                        650,
                        667,
                        131,
                        131,
                        86,
                        640,
                        131,
                        131,
                        664,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        171,
                        131,
                        131,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        460,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        458,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        86,
                        640,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        466,
                        203,
                        149,
                        429,
                        94,
                        432,
                        160,
                        687,
                        539,
                        63,
                        237,
                        283,
                        192,
                        248,
                        348,
                        259,
                        427,
                        526,
                        396,
                        676,
                        254,
                        468,
                        487,
                        212,
                        327,
                        623,
                        49,
                        633,
                        322,
                        493,
                        434,
                        688,
                        357,
                        361,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131,
                        131
                    ]), {
                        mapStr: "\u0635\u0644\u0649 \u0627\u0644\u0644\u0647 \u0639\u0644\u064A\u0647 \u0648\u0633\u0644\u0645\u062C\u0644 \u062C\u0644\u0627\u0644\u0647\u30AD\u30ED\u30E1\u30FC\u30C8\u30EBrad\u2215s2\u30A8\u30B9\u30AF\u30FC\u30C9\u30AD\u30ED\u30B0\u30E9\u30E0\u30AD\u30ED\u30EF\u30C3\u30C8\u30B0\u30E9\u30E0\u30C8\u30F3\u30AF\u30EB\u30BC\u30A4\u30ED\u30B5\u30F3\u30C1\u30FC\u30E0\u30D1\u30FC\u30BB\u30F3\u30C8\u30D4\u30A2\u30B9\u30C8\u30EB\u30D5\u30A1\u30E9\u30C3\u30C9\u30D6\u30C3\u30B7\u30A7\u30EB\u30D8\u30AF\u30BF\u30FC\u30EB\u30DE\u30F3\u30B7\u30E7\u30F3\u30DF\u30EA\u30D0\u30FC\u30EB\u30EC\u30F3\u30C8\u30B2\u30F3\u2032\u2032\u2032\u20321\u204410viii(10)(11)(12)(13)(14)(15)(16)(17)(18)(19)(20)\u222B\u222B\u222B\u222B(\uC624\uC804)(\uC624\uD6C4)\u30A2\u30D1\u30FC\u30C8\u30A2\u30EB\u30D5\u30A1\u30A2\u30F3\u30DA\u30A2\u30A4\u30CB\u30F3\u30B0\u30A8\u30FC\u30AB\u30FC\u30AB\u30E9\u30C3\u30C8\u30AB\u30ED\u30EA\u30FC\u30AD\u30E5\u30EA\u30FC\u30AE\u30EB\u30C0\u30FC\u30AF\u30ED\u30FC\u30CD\u30B5\u30A4\u30AF\u30EB\u30B7\u30EA\u30F3\u30B0\u30D0\u30FC\u30EC\u30EB\u30D5\u30A3\u30FC\u30C8\u30DD\u30A4\u30F3\u30C8\u30DE\u30A4\u30AF\u30ED\u30DF\u30AF\u30ED\u30F3\u30E1\u30AC\u30C8\u30F3\u30EA\u30C3\u30C8\u30EB\u30EB\u30FC\u30D6\u30EB\u682A\u5F0F\u4F1A\u793Ekcalm\u2215s2c\u2215kg\u0627\u0643\u0628\u0631\u0645\u062D\u0645\u062F\u0635\u0644\u0639\u0645\u0631\u0633\u0648\u0644\u0631\u06CC\u0627\u06441\u204441\u204423\u20444 \u0308\u0301\u0FB2\u0F71\u0F80\u0FB3\u0F71\u0F80 \u0308\u0342 \u0313\u0300 \u0313\u0301 \u0313\u0342 \u0314\u0300 \u0314\u0301 \u0314\u0342 \u0308\u0300\u2035\u2035\u2035a/ca/sc/oc/utelfax1\u204471\u204491\u204432\u204431\u204452\u204453\u204454\u204451\u204465\u204461\u204483\u204485\u204487\u20448xii0\u20443\u222E\u222E\u222E(1)(2)(3)(4)(5)(6)(7)(8)(9)(a)(b)(c)(d)(e)(f)(g)(h)(i)(j)(k)(l)(m)(n)(o)(p)(q)(r)(s)(t)(u)(v)(w)(x)(y)(z)::====(\u1100)(\u1102)(\u1103)(\u1105)(\u1106)(\u1107)(\u1109)(\u110B)(\u110C)(\u110E)(\u110F)(\u1110)(\u1111)(\u1112)(\uAC00)(\uB098)(\uB2E4)(\uB77C)(\uB9C8)(\uBC14)(\uC0AC)(\uC544)(\uC790)(\uCC28)(\uCE74)(\uD0C0)(\uD30C)(\uD558)(\uC8FC)(\u4E00)(\u4E8C)(\u4E09)(\u56DB)(\u4E94)(\u516D)(\u4E03)(\u516B)(\u4E5D)(\u5341)(\u6708)(\u706B)(\u6C34)(\u6728)(\u91D1)(\u571F)(\u65E5)(\u682A)(\u6709)(\u793E)(\u540D)(\u7279)(\u8CA1)(\u795D)(\u52B4)(\u4EE3)(\u547C)(\u5B66)(\u76E3)(\u4F01)(\u8CC7)(\u5354)(\u796D)(\u4F11)(\u81EA)(\u81F3)pte10\u670811\u670812\u6708ergltd\u30A2\u30FC\u30EB\u30A4\u30F3\u30C1\u30A6\u30A9\u30F3\u30AA\u30F3\u30B9\u30AA\u30FC\u30E0\u30AB\u30A4\u30EA\u30AC\u30ED\u30F3\u30AC\u30F3\u30DE\u30AE\u30CB\u30FC\u30B1\u30FC\u30B9\u30B3\u30EB\u30CA\u30B3\u30FC\u30DD\u30BB\u30F3\u30C1\u30C0\u30FC\u30B9\u30CE\u30C3\u30C8\u30CF\u30A4\u30C4\u30D1\u30FC\u30C4\u30D4\u30AF\u30EB\u30D5\u30E9\u30F3\u30DA\u30CB\u30D2\u30D8\u30EB\u30C4\u30DA\u30F3\u30B9\u30DA\u30FC\u30B8\u30D9\u30FC\u30BF\u30DC\u30EB\u30C8\u30DD\u30F3\u30C9\u30DB\u30FC\u30EB\u30DB\u30FC\u30F3\u30DE\u30A4\u30EB\u30DE\u30C3\u30CF\u30DE\u30EB\u30AF\u30E4\u30FC\u30C9\u30E4\u30FC\u30EB\u30E6\u30A2\u30F3\u30EB\u30D4\u30FC10\u70B911\u70B912\u70B913\u70B914\u70B915\u70B916\u70B917\u70B918\u70B919\u70B920\u70B921\u70B922\u70B923\u70B924\u70B9hpabardm2dm3khzmhzghzthzmm2cm2km2mm3cm3km3kpampagpalogmilmolppmv\u2215ma\u2215m10\u65E511\u65E512\u65E513\u65E514\u65E515\u65E516\u65E517\u65E518\u65E519\u65E520\u65E521\u65E522\u65E523\u65E524\u65E525\u65E526\u65E527\u65E528\u65E529\u65E530\u65E531\u65E5galffiffl\u05E9\u05BC\u05C1\u05E9\u05BC\u05C2 \u064C\u0651 \u064D\u0651 \u064E\u0651 \u064F\u0651 \u0650\u0651 \u0651\u0670\u0640\u064E\u0651\u0640\u064F\u0651\u0640\u0650\u0651\u062A\u062C\u0645\u062A\u062D\u062C\u062A\u062D\u0645\u062A\u062E\u0645\u062A\u0645\u062C\u062A\u0645\u062D\u062A\u0645\u062E\u062C\u0645\u062D\u062D\u0645\u064A\u062D\u0645\u0649\u0633\u062D\u062C\u0633\u062C\u062D\u0633\u062C\u0649\u0633\u0645\u062D\u0633\u0645\u062C\u0633\u0645\u0645\u0635\u062D\u062D\u0635\u0645\u0645\u0634\u062D\u0645\u0634\u062C\u064A\u0634\u0645\u062E\u0634\u0645\u0645\u0636\u062D\u0649\u0636\u062E\u0645\u0637\u0645\u062D\u0637\u0645\u0645\u0637\u0645\u064A\u0639\u062C\u0645\u0639\u0645\u0645\u0639\u0645\u0649\u063A\u0645\u0645\u063A\u0645\u064A\u063A\u0645\u0649\u0641\u062E\u0645\u0642\u0645\u062D\u0642\u0645\u0645\u0644\u062D\u0645\u0644\u062D\u064A\u0644\u062D\u0649\u0644\u062C\u062C\u0644\u062E\u0645\u0644\u0645\u062D\u0645\u062D\u062C\u0645\u062D\u064A\u0645\u062C\u062D\u0645\u062C\u0645\u0645\u062E\u0645\u0645\u062C\u062E\u0647\u0645\u062C\u0647\u0645\u0645\u0646\u062D\u0645\u0646\u062D\u0649\u0646\u062C\u0645\u0646\u062C\u0649\u0646\u0645\u064A\u0646\u0645\u0649\u064A\u0645\u0645\u0628\u062E\u064A\u062A\u062C\u064A\u062A\u062C\u0649\u062A\u062E\u064A\u062A\u062E\u0649\u062A\u0645\u064A\u062A\u0645\u0649\u062C\u0645\u064A\u062C\u062D\u0649\u062C\u0645\u0649\u0633\u062E\u0649\u0635\u062D\u064A\u0634\u062D\u064A\u0636\u062D\u064A\u0644\u062C\u064A\u0644\u0645\u064A\u064A\u062D\u064A\u064A\u062C\u064A\u064A\u0645\u064A\u0645\u0645\u064A\u0642\u0645\u064A\u0646\u062D\u064A\u0639\u0645\u064A\u0643\u0645\u064A\u0646\u062C\u062D\u0645\u062E\u064A\u0644\u062C\u0645\u0643\u0645\u0645\u062C\u062D\u064A\u062D\u062C\u064A\u0645\u062C\u064A\u0641\u0645\u064A\u0628\u062D\u064A\u0633\u062E\u064A\u0646\u062C\u064A\u0635\u0644\u06D2\u0642\u0644\u06D2\uD834\uDD58\uD834\uDD65\uD834\uDD6E\uD834\uDD58\uD834\uDD65\uD834\uDD6F\uD834\uDD58\uD834\uDD65\uD834\uDD70\uD834\uDD58\uD834\uDD65\uD834\uDD71\uD834\uDD58\uD834\uDD65\uD834\uDD72\uD834\uDDB9\uD834\uDD65\uD834\uDD6E\uD834\uDDBA\uD834\uDD65\uD834\uDD6E\uD834\uDDB9\uD834\uDD65\uD834\uDD6F\uD834\uDDBA\uD834\uDD65\uD834\uDD6F\u3014s\u3015ppv\u3014\u672C\u3015\u3014\u4E09\u3015\u3014\u4E8C\u3015\u3014\u5B89\u3015\u3014\u70B9\u3015\u3014\u6253\u3015\u3014\u76D7\u3015\u3014\u52DD\u3015\u3014\u6557\u3015 \u0304 \u0301 \u0327ssi\u0307ijl\xb7\u02BCnd\u017Eljnjdz \u0306 \u0307 \u030A \u0328 \u0303 \u030B \u03B9\u0565\u0582\u0627\u0674\u0648\u0674\u06C7\u0674\u064A\u0674\u0915\u093C\u0916\u093C\u0917\u093C\u091C\u093C\u0921\u093C\u0922\u093C\u092B\u093C\u092F\u093C\u09A1\u09BC\u09A2\u09BC\u09AF\u09BC\u0A32\u0A3C\u0A38\u0A3C\u0A16\u0A3C\u0A17\u0A3C\u0A1C\u0A3C\u0A2B\u0A3C\u0B21\u0B3C\u0B22\u0B3C\u0E4D\u0E32\u0ECD\u0EB2\u0EAB\u0E99\u0EAB\u0EA1\u0F42\u0FB7\u0F4C\u0FB7\u0F51\u0FB7\u0F56\u0FB7\u0F5B\u0FB7\u0F40\u0FB5\u0F71\u0F72\u0F71\u0F74\u0FB2\u0F80\u0FB3\u0F80\u0F92\u0FB7\u0F9C\u0FB7\u0FA1\u0FB7\u0FA6\u0FB7\u0FAB\u0FB7\u0F90\u0FB5a\u02BE\u1F00\u03B9\u1F01\u03B9\u1F02\u03B9\u1F03\u03B9\u1F04\u03B9\u1F05\u03B9\u1F06\u03B9\u1F07\u03B9\u1F20\u03B9\u1F21\u03B9\u1F22\u03B9\u1F23\u03B9\u1F24\u03B9\u1F25\u03B9\u1F26\u03B9\u1F27\u03B9\u1F60\u03B9\u1F61\u03B9\u1F62\u03B9\u1F63\u03B9\u1F64\u03B9\u1F65\u03B9\u1F66\u03B9\u1F67\u03B9\u1F70\u03B9\u03B1\u03B9\u03AC\u03B9\u1FB6\u03B9 \u0342\u1F74\u03B9\u03B7\u03B9\u03AE\u03B9\u1FC6\u03B9\u1F7C\u03B9\u03C9\u03B9\u03CE\u03B9\u1FF6\u03B9 \u0333!! \u0305???!!?rs\xb0c\xb0fnosmtmivix\u2ADD\u0338 \u3099 \u309A\u3088\u308A\u30B3\u30C8333435\uCC38\uACE0\uC8FC\uC758363738394042444546474849503\u67084\u67085\u67086\u67087\u67088\u67089\u6708hgev\u30AE\u30AC\u30C7\u30B7\u30C9\u30EB\u30CA\u30CE\u30D4\u30B3\u30D3\u30EB\u30DA\u30BD\u30DB\u30F3\u30EA\u30E9\u30EC\u30E0daauovpciu\u5E73\u6210\u662D\u548C\u5927\u6B63\u660E\u6CBBna\u03BCakakbmbgbpfnf\u03BCf\u03BCgmg\u03BClmldlklfmnm\u03BCmpsns\u03BCsmsnv\u03BCvkvpwnw\u03BCwmwkwk\u03C9m\u03C9bqcccddbgyhainkkktlnlxphprsrsvwbst\u0574\u0576\u0574\u0565\u0574\u056B\u057E\u0576\u0574\u056D\u05D9\u05B4\u05F2\u05B7\u05E9\u05C1\u05E9\u05C2\u05D0\u05B7\u05D0\u05B8\u05D0\u05BC\u05D1\u05BC\u05D2\u05BC\u05D3\u05BC\u05D4\u05BC\u05D5\u05BC\u05D6\u05BC\u05D8\u05BC\u05D9\u05BC\u05DA\u05BC\u05DB\u05BC\u05DC\u05BC\u05DE\u05BC\u05E0\u05BC\u05E1\u05BC\u05E3\u05BC\u05E4\u05BC\u05E6\u05BC\u05E7\u05BC\u05E8\u05BC\u05EA\u05BC\u05D5\u05B9\u05D1\u05BF\u05DB\u05BF\u05E4\u05BF\u05D0\u05DC\u0626\u0627\u0626\u06D5\u0626\u0648\u0626\u06C7\u0626\u06C6\u0626\u06C8\u0626\u06D0\u0626\u0649\u0626\u062C\u0626\u062D\u0626\u0645\u0626\u064A\u0628\u062C\u0628\u0645\u0628\u0649\u0628\u064A\u062A\u0649\u062A\u064A\u062B\u062C\u062B\u0645\u062B\u0649\u062B\u064A\u062E\u062D\u0636\u062C\u0636\u0645\u0637\u062D\u0638\u0645\u063A\u062C\u0641\u062C\u0641\u062D\u0641\u0649\u0641\u064A\u0642\u062D\u0642\u0649\u0642\u064A\u0643\u0627\u0643\u062C\u0643\u062D\u0643\u062E\u0643\u0644\u0643\u0649\u0643\u064A\u0646\u062E\u0646\u0649\u0646\u064A\u0647\u062C\u0647\u0649\u0647\u064A\u064A\u0649\u0630\u0670\u0631\u0670\u0649\u0670\u0626\u0631\u0626\u0632\u0626\u0646\u0628\u0632\u0628\u0646\u062A\u0631\u062A\u0632\u062A\u0646\u062B\u0631\u062B\u0632\u062B\u0646\u0645\u0627\u0646\u0631\u0646\u0632\u0646\u0646\u064A\u0631\u064A\u0632\u0626\u062E\u0626\u0647\u0628\u0647\u062A\u0647\u0635\u062E\u0646\u0647\u0647\u0670\u062B\u0647\u0633\u0647\u0634\u0647\u0637\u0649\u0637\u064A\u0639\u0649\u0639\u064A\u063A\u0649\u063A\u064A\u0633\u0649\u0633\u064A\u0634\u0649\u0634\u064A\u0635\u0649\u0635\u064A\u0636\u0649\u0636\u064A\u0634\u062E\u0634\u0631\u0633\u0631\u0635\u0631\u0636\u0631\u0627\u064B \u064B\u0640\u064B\u0640\u0651 \u0652\u0640\u0652\u0644\u0622\u0644\u0623\u0644\u0625\uD834\uDD57\uD834\uDD650,1,2,3,4,5,6,7,8,9,wzhvsdwcmcmddj\u307B\u304B\u30B3\u30B3\xe0\xe1\xe2\xe3\xe4\xe5\xe6\xe7\xe8\xe9\xea\xeb\xec\xed\xee\xef\xf0\xf1\xf2\xf3\xf4\xf5\xf6\xf8\xf9\xfa\xfb\xfc\xfd\xfe\u0101\u0103\u0105\u0107\u0109\u010B\u010D\u010F\u0111\u0113\u0115\u0117\u0119\u011B\u011D\u011F\u0121\u0123\u0125\u0127\u0129\u012B\u012D\u012F\u0135\u0137\u013A\u013C\u013E\u0142\u0144\u0146\u0148\u014B\u014D\u014F\u0151\u0153\u0155\u0157\u0159\u015B\u015D\u015F\u0161\u0163\u0165\u0167\u0169\u016B\u016D\u016F\u0171\u0173\u0175\u0177\xff\u017A\u017C\u0253\u0183\u0185\u0254\u0188\u0256\u0257\u018C\u01DD\u0259\u025B\u0192\u0260\u0263\u0269\u0268\u0199\u026F\u0272\u0275\u01A1\u01A3\u01A5\u0280\u01A8\u0283\u01AD\u0288\u01B0\u028A\u028B\u01B4\u01B6\u0292\u01B9\u01BD\u01CE\u01D0\u01D2\u01D4\u01D6\u01D8\u01DA\u01DC\u01DF\u01E1\u01E3\u01E5\u01E7\u01E9\u01EB\u01ED\u01EF\u01F5\u0195\u01BF\u01F9\u01FB\u01FD\u01FF\u0201\u0203\u0205\u0207\u0209\u020B\u020D\u020F\u0211\u0213\u0215\u0217\u0219\u021B\u021D\u021F\u019E\u0223\u0225\u0227\u0229\u022B\u022D\u022F\u0231\u0233\u2C65\u023C\u019A\u2C66\u0242\u0180\u0289\u028C\u0247\u0249\u024B\u024D\u024F\u0266\u0279\u027B\u0281\u0295\u0371\u0373\u02B9\u0377;\u03F3\u03AD\u03AF\u03CC\u03CD\u03B2\u03B3\u03B4\u03B5\u03B6\u03B8\u03BA\u03BB\u03BD\u03BE\u03BF\u03C0\u03C1\u03C3\u03C4\u03C5\u03C6\u03C7\u03C8\u03CA\u03CB\u03D7\u03D9\u03DB\u03DD\u03DF\u03E1\u03E3\u03E5\u03E7\u03E9\u03EB\u03ED\u03EF\u03F8\u03FB\u037B\u037C\u037D\u0450\u0451\u0452\u0453\u0454\u0455\u0456\u0457\u0458\u0459\u045A\u045B\u045C\u045D\u045E\u045F\u0430\u0431\u0432\u0433\u0434\u0435\u0436\u0437\u0438\u0439\u043A\u043B\u043C\u043D\u043E\u043F\u0440\u0441\u0442\u0443\u0444\u0445\u0446\u0447\u0448\u0449\u044A\u044B\u044C\u044D\u044E\u044F\u0461\u0463\u0465\u0467\u0469\u046B\u046D\u046F\u0471\u0473\u0475\u0477\u0479\u047B\u047D\u047F\u0481\u048B\u048D\u048F\u0491\u0493\u0495\u0497\u0499\u049B\u049D\u049F\u04A1\u04A3\u04A5\u04A7\u04A9\u04AB\u04AD\u04AF\u04B1\u04B3\u04B5\u04B7\u04B9\u04BB\u04BD\u04BF\u04C2\u04C4\u04C6\u04C8\u04CA\u04CC\u04CE\u04D1\u04D3\u04D5\u04D7\u04D9\u04DB\u04DD\u04DF\u04E1\u04E3\u04E5\u04E7\u04E9\u04EB\u04ED\u04EF\u04F1\u04F3\u04F5\u04F7\u04F9\u04FB\u04FD\u04FF\u0501\u0503\u0505\u0507\u0509\u050B\u050D\u050F\u0511\u0513\u0515\u0517\u0519\u051B\u051D\u051F\u0521\u0523\u0525\u0527\u0529\u052B\u052D\u052F\u0561\u0562\u0563\u0564\u0566\u0567\u0568\u0569\u056A\u056C\u056E\u056F\u0570\u0571\u0572\u0573\u0575\u0577\u0578\u0579\u057A\u057B\u057C\u057D\u057F\u0580\u0581\u0583\u0584\u0585\u0586\u0F0B\u2D27\u2D2D\u10DC\u13F0\u13F1\u13F2\u13F3\u13F4\u13F5\uA64B\u0250\u0251\u1D02\u025C\u1D16\u1D17\u1D1D\u1D25\u0252\u0255\u025F\u0261\u0265\u026A\u1D7B\u029D\u026D\u1D85\u029F\u0271\u0270\u0273\u0274\u0278\u0282\u01AB\u1D1C\u0290\u0291\u1E01\u1E03\u1E05\u1E07\u1E09\u1E0B\u1E0D\u1E0F\u1E11\u1E13\u1E15\u1E17\u1E19\u1E1B\u1E1D\u1E1F\u1E21\u1E23\u1E25\u1E27\u1E29\u1E2B\u1E2D\u1E2F\u1E31\u1E33\u1E35\u1E37\u1E39\u1E3B\u1E3D\u1E3F\u1E41\u1E43\u1E45\u1E47\u1E49\u1E4B\u1E4D\u1E4F\u1E51\u1E53\u1E55\u1E57\u1E59\u1E5B\u1E5D\u1E5F\u1E61\u1E63\u1E65\u1E67\u1E69\u1E6B\u1E6D\u1E6F\u1E71\u1E73\u1E75\u1E77\u1E79\u1E7B\u1E7D\u1E7F\u1E81\u1E83\u1E85\u1E87\u1E89\u1E8B\u1E8D\u1E8F\u1E91\u1E93\u1E95\u1EA1\u1EA3\u1EA5\u1EA7\u1EA9\u1EAB\u1EAD\u1EAF\u1EB1\u1EB3\u1EB5\u1EB7\u1EB9\u1EBB\u1EBD\u1EBF\u1EC1\u1EC3\u1EC5\u1EC7\u1EC9\u1ECB\u1ECD\u1ECF\u1ED1\u1ED3\u1ED5\u1ED7\u1ED9\u1EDB\u1EDD\u1EDF\u1EE1\u1EE3\u1EE5\u1EE7\u1EE9\u1EEB\u1EED\u1EEF\u1EF1\u1EF3\u1EF5\u1EF7\u1EF9\u1EFB\u1EFD\u1EFF\u1F10\u1F11\u1F12\u1F13\u1F14\u1F15\u1F30\u1F31\u1F32\u1F33\u1F34\u1F35\u1F36\u1F37\u1F40\u1F41\u1F42\u1F43\u1F44\u1F45\u1F51\u1F53\u1F55\u1F57\u1FB0\u1FB1\u1F72\u0390\u1FD0\u1FD1\u1F76\u03B0\u1FE0\u1FE1\u1F7A\u1FE5`\u1F78\u2010+\u2212\u2211\u3008\u3009\u2C30\u2C31\u2C32\u2C33\u2C34\u2C35\u2C36\u2C37\u2C38\u2C39\u2C3A\u2C3B\u2C3C\u2C3D\u2C3E\u2C3F\u2C40\u2C41\u2C42\u2C43\u2C44\u2C45\u2C46\u2C47\u2C48\u2C49\u2C4A\u2C4B\u2C4C\u2C4D\u2C4E\u2C4F\u2C50\u2C51\u2C52\u2C53\u2C54\u2C55\u2C56\u2C57\u2C58\u2C59\u2C5A\u2C5B\u2C5C\u2C5D\u2C5E\u2C61\u026B\u1D7D\u027D\u2C68\u2C6A\u2C6C\u2C73\u2C76\u023F\u0240\u2C81\u2C83\u2C85\u2C87\u2C89\u2C8B\u2C8D\u2C8F\u2C91\u2C93\u2C95\u2C97\u2C99\u2C9B\u2C9D\u2C9F\u2CA1\u2CA3\u2CA5\u2CA7\u2CA9\u2CAB\u2CAD\u2CAF\u2CB1\u2CB3\u2CB5\u2CB7\u2CB9\u2CBB\u2CBD\u2CBF\u2CC1\u2CC3\u2CC5\u2CC7\u2CC9\u2CCB\u2CCD\u2CCF\u2CD1\u2CD3\u2CD5\u2CD7\u2CD9\u2CDB\u2CDD\u2CDF\u2CE1\u2CE3\u2CEC\u2CEE\u2CF3\u2D61\u6BCD\u9F9F\u4E28\u4E36\u4E3F\u4E59\u4E85\u4EA0\u4EBA\u513F\u5165\u5182\u5196\u51AB\u51E0\u51F5\u5200\u529B\u52F9\u5315\u531A\u5338\u535C\u5369\u5382\u53B6\u53C8\u53E3\u56D7\u58EB\u5902\u590A\u5915\u5973\u5B50\u5B80\u5BF8\u5C0F\u5C22\u5C38\u5C6E\u5C71\u5DDB\u5DE5\u5DF1\u5DFE\u5E72\u5E7A\u5E7F\u5EF4\u5EFE\u5F0B\u5F13\u5F50\u5F61\u5F73\u5FC3\u6208\u6236\u624B\u652F\u6534\u6587\u6597\u65A4\u65B9\u65E0\u66F0\u6B20\u6B62\u6B79\u6BB3\u6BCB\u6BD4\u6BDB\u6C0F\u6C14\u722A\u7236\u723B\u723F\u7247\u7259\u725B\u72AC\u7384\u7389\u74DC\u74E6\u7518\u751F\u7528\u7530\u758B\u7592\u7676\u767D\u76AE\u76BF\u76EE\u77DB\u77E2\u77F3\u793A\u79B8\u79BE\u7A74\u7ACB\u7AF9\u7C73\u7CF8\u7F36\u7F51\u7F8A\u7FBD\u8001\u800C\u8012\u8033\u807F\u8089\u81E3\u81FC\u820C\u821B\u821F\u826E\u8272\u8278\u864D\u866B\u8840\u884C\u8863\u897E\u898B\u89D2\u8A00\u8C37\u8C46\u8C55\u8C78\u8C9D\u8D64\u8D70\u8DB3\u8EAB\u8ECA\u8F9B\u8FB0\u8FB5\u9091\u9149\u91C6\u91CC\u9577\u9580\u961C\u96B6\u96B9\u96E8\u9751\u975E\u9762\u9769\u97CB\u97ED\u97F3\u9801\u98A8\u98DB\u98DF\u9996\u9999\u99AC\u9AA8\u9AD8\u9ADF\u9B25\u9B2F\u9B32\u9B3C\u9B5A\u9CE5\u9E75\u9E7F\u9EA5\u9EBB\u9EC3\u9ECD\u9ED1\u9EF9\u9EFD\u9F0E\u9F13\u9F20\u9F3B\u9F4A\u9F52\u9F8D\u9F9C\u9FA0.\u3012\u5344\u5345\u1101\u11AA\u11AC\u11AD\u1104\u11B0\u11B1\u11B2\u11B3\u11B4\u11B5\u111A\u1108\u1121\u110A\u110D\u1161\u1162\u1163\u1164\u1165\u1166\u1167\u1168\u1169\u116A\u116B\u116C\u116D\u116E\u116F\u1170\u1171\u1172\u1173\u1174\u1175\u1114\u1115\u11C7\u11C8\u11CC\u11CE\u11D3\u11D7\u11D9\u111C\u11DD\u11DF\u111D\u111E\u1120\u1122\u1123\u1127\u1129\u112B\u112C\u112D\u112E\u112F\u1132\u1136\u1140\u1147\u114C\u11F1\u11F2\u1157\u1158\u1159\u1184\u1185\u1188\u1191\u1192\u1194\u119E\u11A1\u4E0A\u4E2D\u4E0B\u7532\u4E19\u4E01\u5929\u5730\u554F\u5E7C\u7B8F\uC6B0\u79D8\u7537\u9069\u512A\u5370\u6CE8\u9805\u5199\u5DE6\u53F3\u533B\u5B97\u591C\u30C6\u30CC\u30E2\u30E8\u30F0\u30F1\u30F2\uA641\uA643\uA645\uA647\uA649\uA64D\uA64F\uA651\uA653\uA655\uA657\uA659\uA65B\uA65D\uA65F\uA661\uA663\uA665\uA667\uA669\uA66B\uA66D\uA681\uA683\uA685\uA687\uA689\uA68B\uA68D\uA68F\uA691\uA693\uA695\uA697\uA699\uA69B\uA723\uA725\uA727\uA729\uA72B\uA72D\uA72F\uA733\uA735\uA737\uA739\uA73B\uA73D\uA73F\uA741\uA743\uA745\uA747\uA749\uA74B\uA74D\uA74F\uA751\uA753\uA755\uA757\uA759\uA75B\uA75D\uA75F\uA761\uA763\uA765\uA767\uA769\uA76B\uA76D\uA76F\uA77A\uA77C\u1D79\uA77F\uA781\uA783\uA785\uA787\uA78C\uA791\uA793\uA797\uA799\uA79B\uA79D\uA79F\uA7A1\uA7A3\uA7A5\uA7A7\uA7A9\u026C\u029E\u0287\uAB53\uA7B5\uA7B7\uAB37\uAB52\u13A0\u13A1\u13A2\u13A3\u13A4\u13A5\u13A6\u13A7\u13A8\u13A9\u13AA\u13AB\u13AC\u13AD\u13AE\u13AF\u13B0\u13B1\u13B2\u13B3\u13B4\u13B5\u13B6\u13B7\u13B8\u13B9\u13BA\u13BB\u13BC\u13BD\u13BE\u13BF\u13C0\u13C1\u13C2\u13C3\u13C4\u13C5\u13C6\u13C7\u13C8\u13C9\u13CA\u13CB\u13CC\u13CD\u13CE\u13CF\u13D0\u13D1\u13D2\u13D3\u13D4\u13D5\u13D6\u13D7\u13D8\u13D9\u13DA\u13DB\u13DC\u13DD\u13DE\u13DF\u13E0\u13E1\u13E2\u13E3\u13E4\u13E5\u13E6\u13E7\u13E8\u13E9\u13EA\u13EB\u13EC\u13ED\u13EE\u13EF\u8C48\u66F4\u8CC8\u6ED1\u4E32\u53E5\u5951\u5587\u5948\u61F6\u7669\u7F85\u863F\u87BA\u88F8\u908F\u6A02\u6D1B\u70D9\u73DE\u843D\u916A\u99F1\u4E82\u5375\u6B04\u721B\u862D\u9E1E\u5D50\u6FEB\u85CD\u8964\u62C9\u81D8\u881F\u5ECA\u6717\u6D6A\u72FC\u90CE\u4F86\u51B7\u52DE\u64C4\u6AD3\u7210\u76E7\u8606\u865C\u8DEF\u9732\u9B6F\u9DFA\u788C\u797F\u7DA0\u83C9\u9304\u8AD6\u58DF\u5F04\u7C60\u807E\u7262\u78CA\u8CC2\u96F7\u58D8\u5C62\u6A13\u6DDA\u6F0F\u7D2F\u7E37\u964B\u52D2\u808B\u51DC\u51CC\u7A1C\u7DBE\u83F1\u9675\u8B80\u62CF\u8AFE\u4E39\u5BE7\u6012\u7387\u7570\u5317\u78FB\u4FBF\u5FA9\u4E0D\u6CCC\u6578\u7D22\u53C3\u585E\u7701\u8449\u8AAA\u6BBA\u6C88\u62FE\u82E5\u63A0\u7565\u4EAE\u5169\u51C9\u6881\u7CE7\u826F\u8AD2\u91CF\u52F5\u5442\u5EEC\u65C5\u6FFE\u792A\u95AD\u9A6A\u9E97\u9ECE\u66C6\u6B77\u8F62\u5E74\u6190\u6200\u649A\u6F23\u7149\u7489\u79CA\u7DF4\u806F\u8F26\u84EE\u9023\u934A\u5217\u52A3\u54BD\u70C8\u88C2\u5EC9\u5FF5\u637B\u6BAE\u7C3E\u7375\u4EE4\u56F9\u5DBA\u601C\u73B2\u7469\u7F9A\u8046\u9234\u96F6\u9748\u9818\u4F8B\u79AE\u91B4\u96B8\u60E1\u4E86\u50DA\u5BEE\u5C3F\u6599\u71CE\u7642\u84FC\u907C\u6688\u962E\u5289\u677B\u67F3\u6D41\u6E9C\u7409\u7559\u786B\u7D10\u985E\u622E\u9678\u502B\u5D19\u6DEA\u8F2A\u5F8B\u6144\u6817\u9686\u5229\u540F\u5C65\u6613\u674E\u68A8\u6CE5\u7406\u75E2\u7F79\u88CF\u88E1\u96E2\u533F\u6EBA\u541D\u71D0\u7498\u85FA\u96A3\u9C57\u9E9F\u6797\u6DCB\u81E8\u7B20\u7C92\u72C0\u7099\u8B58\u4EC0\u8336\u523A\u5207\u5EA6\u62D3\u7CD6\u5B85\u6D1E\u66B4\u8F3B\u964D\u5ED3\u5140\u55C0\u585A\u6674\u51DE\u732A\u76CA\u793C\u795E\u7965\u798F\u9756\u7CBE\u8612\u8AF8\u9038\u90FD\u98EF\u98FC\u9928\u9DB4\u90DE\u96B7\u4FAE\u50E7\u514D\u52C9\u52E4\u5351\u559D\u5606\u5668\u5840\u58A8\u5C64\u6094\u6168\u618E\u61F2\u654F\u65E2\u6691\u6885\u6D77\u6E1A\u6F22\u716E\u722B\u7422\u7891\u7949\u7948\u7950\u7956\u798D\u798E\u7A40\u7A81\u7BC0\u7E09\u7E41\u7F72\u8005\u81ED\u8279\u8457\u8910\u8996\u8B01\u8B39\u8CD3\u8D08\u8FB6\u96E3\u97FF\u983B\u6075\uD850\uDEEE\u8218\u4E26\u51B5\u5168\u4F80\u5145\u5180\u52C7\u52FA\u5555\u5599\u55E2\u58B3\u5944\u5954\u5A62\u5B28\u5ED2\u5ED9\u5F69\u5FAD\u60D8\u614E\u6108\u6160\u6234\u63C4\u641C\u6452\u6556\u671B\u6756\u6EDB\u6ECB\u701E\u77A7\u7235\u72AF\u7471\u7506\u753B\u761D\u761F\u76DB\u76F4\u774A\u7740\u78CC\u7AB1\u7C7B\u7D5B\u7F3E\u8352\u83EF\u8779\u8941\u8986\u8ABF\u8ACB\u8AED\u8B8A\u8F38\u9072\u9199\u9276\u967C\u97DB\u980B\u9B12\uD84A\uDC4A\uD84A\uDC44\uD84C\uDFD5\u3B9D\u4018\u4039\uD854\uDE49\uD857\uDCD0\uD85F\uDED3\u9F43\u9F8E\u05E2\u05DD\u0671\u067B\u067E\u0680\u067A\u067F\u0679\u06A4\u06A6\u0684\u0683\u0686\u0687\u068D\u068C\u068E\u0688\u0698\u0691\u06A9\u06AF\u06B3\u06B1\u06BA\u06BB\u06C0\u06C1\u06BE\u06D3\u06AD\u06CB\u06C5\u06C9\u3001\u3016\u3017\u2014\u2013_{}\u3010\u3011\u300A\u300B\u300C\u300D\u300E\u300F[]#&*-<>\\$%@\u0621\u0624\u0629\"'^|~\u2985\u2986\u30FB\u30A5\u30E3\xa2\xa3\xac\xa6\xa5\u20A9\u2502\u2190\u2191\u2192\u2193\u25A0\u25CB\uD801\uDC28\uD801\uDC29\uD801\uDC2A\uD801\uDC2B\uD801\uDC2C\uD801\uDC2D\uD801\uDC2E\uD801\uDC2F\uD801\uDC30\uD801\uDC31\uD801\uDC32\uD801\uDC33\uD801\uDC34\uD801\uDC35\uD801\uDC36\uD801\uDC37\uD801\uDC38\uD801\uDC39\uD801\uDC3A\uD801\uDC3B\uD801\uDC3C\uD801\uDC3D\uD801\uDC3E\uD801\uDC3F\uD801\uDC40\uD801\uDC41\uD801\uDC42\uD801\uDC43\uD801\uDC44\uD801\uDC45\uD801\uDC46\uD801\uDC47\uD801\uDC48\uD801\uDC49\uD801\uDC4A\uD801\uDC4B\uD801\uDC4C\uD801\uDC4D\uD801\uDC4E\uD801\uDC4F\uD801\uDCD8\uD801\uDCD9\uD801\uDCDA\uD801\uDCDB\uD801\uDCDC\uD801\uDCDD\uD801\uDCDE\uD801\uDCDF\uD801\uDCE0\uD801\uDCE1\uD801\uDCE2\uD801\uDCE3\uD801\uDCE4\uD801\uDCE5\uD801\uDCE6\uD801\uDCE7\uD801\uDCE8\uD801\uDCE9\uD801\uDCEA\uD801\uDCEB\uD801\uDCEC\uD801\uDCED\uD801\uDCEE\uD801\uDCEF\uD801\uDCF0\uD801\uDCF1\uD801\uDCF2\uD801\uDCF3\uD801\uDCF4\uD801\uDCF5\uD801\uDCF6\uD801\uDCF7\uD801\uDCF8\uD801\uDCF9\uD801\uDCFA\uD801\uDCFB\uD803\uDCC0\uD803\uDCC1\uD803\uDCC2\uD803\uDCC3\uD803\uDCC4\uD803\uDCC5\uD803\uDCC6\uD803\uDCC7\uD803\uDCC8\uD803\uDCC9\uD803\uDCCA\uD803\uDCCB\uD803\uDCCC\uD803\uDCCD\uD803\uDCCE\uD803\uDCCF\uD803\uDCD0\uD803\uDCD1\uD803\uDCD2\uD803\uDCD3\uD803\uDCD4\uD803\uDCD5\uD803\uDCD6\uD803\uDCD7\uD803\uDCD8\uD803\uDCD9\uD803\uDCDA\uD803\uDCDB\uD803\uDCDC\uD803\uDCDD\uD803\uDCDE\uD803\uDCDF\uD803\uDCE0\uD803\uDCE1\uD803\uDCE2\uD803\uDCE3\uD803\uDCE4\uD803\uDCE5\uD803\uDCE6\uD803\uDCE7\uD803\uDCE8\uD803\uDCE9\uD803\uDCEA\uD803\uDCEB\uD803\uDCEC\uD803\uDCED\uD803\uDCEE\uD803\uDCEF\uD803\uDCF0\uD803\uDCF1\uD803\uDCF2\uD806\uDCC0\uD806\uDCC1\uD806\uDCC2\uD806\uDCC3\uD806\uDCC4\uD806\uDCC5\uD806\uDCC6\uD806\uDCC7\uD806\uDCC8\uD806\uDCC9\uD806\uDCCA\uD806\uDCCB\uD806\uDCCC\uD806\uDCCD\uD806\uDCCE\uD806\uDCCF\uD806\uDCD0\uD806\uDCD1\uD806\uDCD2\uD806\uDCD3\uD806\uDCD4\uD806\uDCD5\uD806\uDCD6\uD806\uDCD7\uD806\uDCD8\uD806\uDCD9\uD806\uDCDA\uD806\uDCDB\uD806\uDCDC\uD806\uDCDD\uD806\uDCDE\uD806\uDCDF\u0131\u0237\u2207\u2202\uD83A\uDD22\uD83A\uDD23\uD83A\uDD24\uD83A\uDD25\uD83A\uDD26\uD83A\uDD27\uD83A\uDD28\uD83A\uDD29\uD83A\uDD2A\uD83A\uDD2B\uD83A\uDD2C\uD83A\uDD2D\uD83A\uDD2E\uD83A\uDD2F\uD83A\uDD30\uD83A\uDD31\uD83A\uDD32\uD83A\uDD33\uD83A\uDD34\uD83A\uDD35\uD83A\uDD36\uD83A\uDD37\uD83A\uDD38\uD83A\uDD39\uD83A\uDD3A\uD83A\uDD3B\uD83A\uDD3C\uD83A\uDD3D\uD83A\uDD3E\uD83A\uDD3F\uD83A\uDD40\uD83A\uDD41\uD83A\uDD42\uD83A\uDD43\u066E\u06A1\u066F\u5B57\u53CC\u591A\u89E3\u4EA4\u6620\u7121\u524D\u5F8C\u518D\u65B0\u521D\u7D42\u8CA9\u58F0\u5439\u6F14\u6295\u6355\u904A\u6307\u7981\u7A7A\u5408\u6E80\u7533\u5272\u55B6\u914D\u5F97\u53EF\u4E3D\u4E38\u4E41\uD840\uDD22\u4F60\u4FBB\u5002\u507A\u5099\u50CF\u349E\uD841\uDE3A\u5154\u5164\u5177\uD841\uDD1C\u34B9\u5167\uD841\uDD4B\u5197\u51A4\u4ECC\u51AC\uD864\uDDDF\u5203\u34DF\u523B\u5246\u5277\u3515\u5305\u5306\u5349\u535A\u5373\u537D\u537F\uD842\uDE2C\u7070\u53CA\u53DF\uD842\uDF63\u53EB\u53F1\u5406\u549E\u5438\u5448\u5468\u54A2\u54F6\u5510\u5553\u5563\u5584\u55AB\u55B3\u55C2\u5716\u5717\u5651\u5674\u58EE\u57CE\u57F4\u580D\u578B\u5832\u5831\u58AC\uD845\uDCE4\u58F2\u58F7\u5906\u5922\u5962\uD845\uDEA8\uD845\uDEEA\u59EC\u5A1B\u5A27\u59D8\u5A66\u36EE\u5B08\u5B3E\uD846\uDDC8\u5BC3\u5BD8\u5BF3\uD846\uDF18\u5BFF\u5C06\u3781\u5C60\u5CC0\u5C8D\uD847\uDDE4\u5D43\uD847\uDDE6\u5D6E\u5D6B\u5D7C\u5DE1\u5DE2\u382F\u5DFD\u5E28\u5E3D\u5E69\u3862\uD848\uDD83\u387C\u5EB0\u5EB3\u5EB6\uD868\uDF92\uD848\uDF31\u8201\u5F22\u38C7\uD84C\uDEB8\uD858\uDDDA\u5F62\u5F6B\u38E3\u5F9A\u5FCD\u5FD7\u5FF9\u6081\u393A\u391C\uD849\uDED4\u60C7\u6148\u614C\u617A\u61B2\u61A4\u61AF\u61DE\u621B\u625D\u62B1\u62D4\u6350\uD84A\uDF0C\u633D\u62FC\u6368\u6383\u63E4\uD84A\uDFF1\u6422\u63C5\u63A9\u3A2E\u6469\u647E\u649D\u6477\u3A6C\u656C\uD84C\uDC0A\u65E3\u66F8\u6649\u3B19\u3B08\u3AE4\u5192\u5195\u6700\u669C\u80AD\u43D9\u6721\u675E\u6753\uD84C\uDFC3\u3B49\u67FA\u6785\u6852\uD84D\uDC6D\u688E\u681F\u6914\u6942\u69A3\u69EA\u6AA8\uD84D\uDEA3\u6ADB\u3C18\u6B21\uD84E\uDCA7\u6B54\u3C4E\u6B72\u6B9F\u6BBB\uD84E\uDE8D\uD847\uDD0B\uD84E\uDEFA\u6C4E\uD84F\uDCBC\u6CBF\u6CCD\u6C67\u6D16\u6D3E\u6D69\u6D78\u6D85\uD84F\uDD1E\u6D34\u6E2F\u6E6E\u3D33\u6EC7\uD84F\uDED1\u6DF9\u6F6E\uD84F\uDF5E\uD84F\uDF8E\u6FC6\u7039\u701B\u3D96\u704A\u707D\u7077\u70AD\uD841\uDD25\u7145\uD850\uDE63\u719C\u7228\u7250\uD851\uDE08\u7280\u7295\uD851\uDF35\uD852\uDC14\u737A\u738B\u3EAC\u73A5\u3EB8\u7447\u745C\u7485\u74CA\u3F1B\u7524\uD853\uDC36\u753E\uD853\uDC92\uD848\uDD9F\u7610\uD853\uDFA1\uD853\uDFB8\uD854\uDC44\u3FFC\u4008\uD854\uDCF3\uD854\uDCF2\uD854\uDD19\uD854\uDD33\u771E\u771F\u778B\u4046\u4096\uD855\uDC1D\u784E\u40E3\uD855\uDE26\uD855\uDE9A\uD855\uDEC5\u79EB\u412F\u7A4A\u7A4F\uD856\uDD7C\uD856\uDEA7\u4202\uD856\uDFAB\u7BC6\u7BC9\u4227\uD857\uDC80\u7CD2\u42A0\u7CE8\u7CE3\u7D00\uD857\uDF86\u7D63\u4301\u7DC7\u7E02\u7E45\u4334\uD858\uDE28\uD858\uDE47\u4359\uD858\uDED9\u7F7A\uD858\uDF3E\u7F95\u7FFA\uD859\uDCDA\uD859\uDD23\u8060\uD859\uDDA8\u8070\uD84C\uDF5F\u43D5\u80B2\u8103\u440B\u813E\u5AB5\uD859\uDFA7\uD859\uDFB5\uD84C\uDF93\uD84C\uDF9C\u8204\u8F9E\u446B\u8291\u828B\u829D\u52B3\u82B1\u82B3\u82BD\u82E6\uD85A\uDF3C\u831D\u8363\u83AD\u8323\u83BD\u83E7\u8353\u83CA\u83CC\u83DC\uD85B\uDC36\uD85B\uDD6B\uD85B\uDCD5\u452B\u84F1\u84F3\u8516\uD85C\uDFCA\u8564\uD85B\uDF2C\u455D\u4561\uD85B\uDFB1\uD85C\uDCD2\u456B\u8650\u8667\u8669\u86A9\u8688\u870E\u86E2\u8728\u876B\u8786\u87E1\u8801\u45F9\u8860\uD85D\uDE67\u88D7\u88DE\u4635\u88FA\u34BB\uD85E\uDCAE\uD85E\uDD66\u46BE\u46C7\u8AA0\uD85F\uDCA8\u8CAB\u8CC1\u8D1B\u8D77\uD85F\uDF2F\uD842\uDC04\u8DCB\u8DBC\u8DF0\uD842\uDCDE\u8ED4\uD861\uDDD2\uD861\uDDED\u9094\u90F1\u9111\uD861\uDF2E\u911B\u9238\u92D7\u92D8\u927C\u93F9\u9415\uD862\uDFFA\u958B\u4995\u95B7\uD863\uDD77\u49E6\u96C3\u5DB2\u9723\uD864\uDD45\uD864\uDE1A\u4A6E\u4A76\u97E0\uD865\uDC0A\u4AB2\uD865\uDC96\u9829\uD865\uDDB6\u98E2\u4B33\u9929\u99A7\u99C2\u99FE\u4BCE\uD866\uDF30\u9C40\u9CFD\u4CCE\u4CED\u9D67\uD868\uDCCE\u4CF8\uD868\uDD05\uD868\uDE0E\uD868\uDE91\u4D56\u9EFE\u9F05\u9F0F\u9F16\uD869\uDE00",
                        mapChar: function(r) {
                            return r >= 196608 ? r >= 917760 && r <= 917999 ? 18874368 : 0 : e[t[r >> 4]][15 & r];
                        }
                    };
                }).apply(t, [])) || (e.exports = n);
            },
            94489: (e, t, r)=>{
                "use strict";
                var n = r(28847)(r(93106));
                function i(e, t) {
                    var r = "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
                    if (!r) {
                        if (Array.isArray(e) || (r = function(e, t) {
                            if (e) {
                                if ("string" == typeof e) return o(e, t);
                                var r = Object.prototype.toString.call(e).slice(8, -1);
                                return "Object" === r && e.constructor && (r = e.constructor.name), "Map" === r || "Set" === r ? Array.from(e) : "Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? o(e, t) : void 0;
                            }
                        }(e)) || t && e && "number" == typeof e.length) {
                            r && (e = r);
                            var n = 0, i = function() {};
                            return {
                                s: i,
                                n: function() {
                                    return n >= e.length ? {
                                        done: !0
                                    } : {
                                        done: !1,
                                        value: e[n++]
                                    };
                                },
                                e: function(e) {
                                    throw e;
                                },
                                f: i
                            };
                        }
                        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                    }
                    var a, s = !0, u = !1;
                    return {
                        s: function() {
                            r = r.call(e);
                        },
                        n: function() {
                            var e = r.next();
                            return s = e.done, e;
                        },
                        e: function(e) {
                            u = !0, a = e;
                        },
                        f: function() {
                            try {
                                s || null == r.return || r.return();
                            } finally{
                                if (u) throw a;
                            }
                        }
                    };
                }
                function o(e, t) {
                    (null == t || t > e.length) && (t = e.length);
                    for(var r = 0, n = new Array(t); r < t; r++)n[r] = e[r];
                    return n;
                }
                var a = 2147483647, s = 36, u = /^xn--/, c = /[^\0-\x7E]/, f = /[\x2E\u3002\uFF0E\uFF61]/g, d = {
                    overflow: "Overflow: input needs wider integers to process",
                    "not-basic": "Illegal input >= 0x80 (not a basic code point)",
                    "invalid-input": "Invalid input"
                }, l = Math.floor, h = String.fromCharCode;
                function p(e) {
                    throw new RangeError(d[e]);
                }
                function b(e, t) {
                    var r = e.split("@"), n = "";
                    r.length > 1 && (n = r[0] + "@", e = r[1]);
                    var i = (function(e, t) {
                        for(var r = [], n = e.length; n--;)r[n] = t(e[n]);
                        return r;
                    })((e = e.replace(f, ".")).split("."), t).join(".");
                    return n + i;
                }
                function y(e) {
                    for(var t = [], r = 0, n = e.length; r < n;){
                        var i = e.charCodeAt(r++);
                        if (i >= 55296 && i <= 56319 && r < n) {
                            var o = e.charCodeAt(r++);
                            56320 == (64512 & o) ? t.push(((1023 & i) << 10) + (1023 & o) + 65536) : (t.push(i), r--);
                        } else t.push(i);
                    }
                    return t;
                }
                var v = function(e, t) {
                    return e + 22 + 75 * (e < 26) - ((0 != t) << 5);
                }, m = function(e, t, r) {
                    var n = 0;
                    for(e = r ? l(e / 700) : e >> 1, e += l(e / t); e > 455; n += s)e = l(e / 35);
                    return l(n + 36 * e / (e + 38));
                }, g = function(e) {
                    var t, r = [], n = e.length, i = 0, o = 128, u = 72, c = e.lastIndexOf("-");
                    c < 0 && (c = 0);
                    for(var f = 0; f < c; ++f)e.charCodeAt(f) >= 128 && p("not-basic"), r.push(e.charCodeAt(f));
                    for(var d = c > 0 ? c + 1 : 0; d < n;){
                        for(var h = i, b = 1, y = s;; y += s){
                            d >= n && p("invalid-input");
                            var v = (t = e.charCodeAt(d++)) - 48 < 10 ? t - 22 : t - 65 < 26 ? t - 65 : t - 97 < 26 ? t - 97 : s;
                            (v >= s || v > l((a - i) / b)) && p("overflow"), i += v * b;
                            var g = y <= u ? 1 : y >= u + 26 ? 26 : y - u;
                            if (v < g) break;
                            var w = s - g;
                            b > l(a / w) && p("overflow"), b *= w;
                        }
                        var k = r.length + 1;
                        u = m(i - h, k, 0 == h), l(i / k) > a - o && p("overflow"), o += l(i / k), i %= k, r.splice(i++, 0, o);
                    }
                    return String.fromCodePoint.apply(String, r);
                }, w = function(e) {
                    var t, r = [], n = (e = y(e)).length, o = 128, u = 0, c = 72, f = i(e);
                    try {
                        for(f.s(); !(t = f.n()).done;){
                            var d = t.value;
                            d < 128 && r.push(h(d));
                        }
                    } catch (e) {
                        f.e(e);
                    } finally{
                        f.f();
                    }
                    var b = r.length, g = b;
                    for(b && r.push("-"); g < n;){
                        var w, k = a, _ = i(e);
                        try {
                            for(_.s(); !(w = _.n()).done;){
                                var A = w.value;
                                A >= o && A < k && (k = A);
                            }
                        } catch (e) {
                            _.e(e);
                        } finally{
                            _.f();
                        }
                        var E = g + 1;
                        k - o > l((a - u) / E) && p("overflow"), u += (k - o) * E, o = k;
                        var S, x = i(e);
                        try {
                            for(x.s(); !(S = x.n()).done;){
                                var B = S.value;
                                if (B < o && ++u > a && p("overflow"), B == o) {
                                    for(var O = u, P = s;; P += s){
                                        var I = P <= c ? 1 : P >= c + 26 ? 26 : P - c;
                                        if (O < I) break;
                                        var T = O - I, C = s - I;
                                        r.push(h(v(I + T % C, 0))), O = l(T / C);
                                    }
                                    r.push(h(v(O, 0))), c = m(u, E, g == b), u = 0, ++g;
                                }
                            }
                        } catch (e) {
                            x.e(e);
                        } finally{
                            x.f();
                        }
                        ++u, ++o;
                    }
                    return r.join("");
                }, k = {
                    version: "2.1.0",
                    ucs2: {
                        decode: y,
                        encode: function(e) {
                            return String.fromCodePoint.apply(String, (0, n.default)(e));
                        }
                    },
                    decode: g,
                    encode: w,
                    toASCII: function(e) {
                        return b(e, function(e) {
                            return c.test(e) ? "xn--" + w(e) : e;
                        });
                    },
                    toUnicode: function(e) {
                        return b(e, function(e) {
                            return u.test(e) ? g(e.slice(4).toLowerCase()) : e;
                        });
                    }
                };
                e.exports = k;
            },
            3956: (e, t, r)=>{
                "use strict";
                var n, i;
                r(28847)(r(3355)), n = [
                    r(94489),
                    r(32996)
                ], void 0 === (i = (function(e, t) {
                    return function(e, t) {
                        function r(r, n, i) {
                            for(var o = [], a = e.ucs2.decode(r), s = 0; s < a.length; s++){
                                var u = a[s], c = e.ucs2.encode([
                                    a[s]
                                ]), f = t.mapChar(u), d = f >> 23, l = f >> 21 & 3, h = f >> 5 & 65535, p = 31 & f, b = t.mapStr.substr(h, p);
                                if (0 === l || n && 1 & d) throw new Error("Illegal char " + c);
                                1 === l ? o.push(b) : 2 === l ? o.push(i ? b : c) : 3 === l && o.push(c);
                            }
                            return o.join("").normalize("NFC");
                        }
                        function n(t, n, o) {
                            void 0 === o && (o = !1);
                            var a = r(t, o, n).split(".");
                            return (a = a.map(function(t) {
                                return t.startsWith("xn--") ? i(t = e.decode(t.substring(4)), o, !1) : i(t, o, n), t;
                            })).join(".");
                        }
                        function i(e, n, i) {
                            if ("-" === e[2] && "-" === e[3]) throw new Error("Failed to validate " + e);
                            if (e.startsWith("-") || e.endsWith("-")) throw new Error("Failed to validate " + e);
                            if (e.includes(".")) throw new Error("Failed to validate " + e);
                            if (r(e, n, i) !== e) throw new Error("Failed to validate " + e);
                            var o = e.codePointAt(0);
                            if (t.mapChar(o) & 16777216) throw new Error("Label contains illegal character: " + o);
                        }
                        return {
                            toUnicode: function(e, t) {
                                return void 0 === t && (t = {}), n(e, !1, "useStd3ASCII" in t && t.useStd3ASCII);
                            },
                            toAscii: function(t, r) {
                                void 0 === r && (r = {});
                                var i, o = !("transitional" in r) || r.transitional, a = "useStd3ASCII" in r && r.useStd3ASCII, s = "verifyDnsLength" in r && r.verifyDnsLength, u = n(t, o, a).split(".").map(e.toASCII), c = u.join(".");
                                if (s) {
                                    if (c.length < 1 || c.length > 253) throw new Error("DNS name has wrong length: " + c);
                                    for(i = 0; i < u.length; i++){
                                        var f = u[i];
                                        if (f.length < 1 || f.length > 63) throw new Error("DNS label has wrong length: " + f);
                                    }
                                }
                                return c;
                            }
                        };
                    }(e, t);
                }).apply(t, n)) || (e.exports = i);
            },
            83226: (e, t)=>{
                "use strict";
                t.read = function(e, t, r, n, i) {
                    var o, a, s = 8 * i - n - 1, u = (1 << s) - 1, c = u >> 1, f = -7, d = r ? i - 1 : 0, l = r ? -1 : 1, h = e[t + d];
                    for(d += l, o = h & (1 << -f) - 1, h >>= -f, f += s; f > 0; o = 256 * o + e[t + d], d += l, f -= 8);
                    for(a = o & (1 << -f) - 1, o >>= -f, f += n; f > 0; a = 256 * a + e[t + d], d += l, f -= 8);
                    if (0 === o) o = 1 - c;
                    else {
                        if (o === u) return a ? NaN : 1 / 0 * (h ? -1 : 1);
                        a += Math.pow(2, n), o -= c;
                    }
                    return (h ? -1 : 1) * a * Math.pow(2, o - n);
                }, t.write = function(e, t, r, n, i, o) {
                    var a, s, u, c = 8 * o - i - 1, f = (1 << c) - 1, d = f >> 1, l = 23 === i ? Math.pow(2, -24) - Math.pow(2, -77) : 0, h = n ? 0 : o - 1, p = n ? 1 : -1, b = t < 0 || 0 === t && 1 / t < 0 ? 1 : 0;
                    for(t = Math.abs(t), isNaN(t) || t === 1 / 0 ? (s = isNaN(t) ? 1 : 0, a = f) : (a = Math.floor(Math.log(t) / Math.LN2), t * (u = Math.pow(2, -a)) < 1 && (a--, u *= 2), (t += a + d >= 1 ? l / u : l * Math.pow(2, 1 - d)) * u >= 2 && (a++, u /= 2), a + d >= f ? (s = 0, a = f) : a + d >= 1 ? (s = (t * u - 1) * Math.pow(2, i), a += d) : (s = t * Math.pow(2, d - 1) * Math.pow(2, i), a = 0)); i >= 8; e[r + h] = 255 & s, h += p, s /= 256, i -= 8);
                    for(a = a << i | s, c += i; c > 0; e[r + h] = 255 & a, h += p, a /= 256, c -= 8);
                    e[r + h - p] |= 128 * b;
                };
            },
            41736: (e)=>{
                "use strict";
                "function" == typeof Object.create ? e.exports = function(e, t) {
                    t && (e.super_ = t, e.prototype = Object.create(t.prototype, {
                        constructor: {
                            value: e,
                            enumerable: !1,
                            writable: !0,
                            configurable: !0
                        }
                    }));
                } : e.exports = function(e, t) {
                    if (t) {
                        e.super_ = t;
                        var r = function() {};
                        r.prototype = t.prototype, e.prototype = new r, e.prototype.constructor = e;
                    }
                };
            },
            69446: (e, t, r)=>{
                "use strict";
                var n = r(28847)(r(3355)), i = r(11191)(), o = r(80593)("Object.prototype.toString"), a = function(e) {
                    return !(i && e && "object" === (0, n.default)(e) && Symbol.toStringTag in e) && "[object Arguments]" === o(e);
                }, s = function(e) {
                    return !!a(e) || null !== e && "object" === (0, n.default)(e) && "number" == typeof e.length && e.length >= 0 && "[object Array]" !== o(e) && "[object Function]" === o(e.callee);
                }, u = function() {
                    return a(arguments);
                }();
                a.isLegacyArguments = s, e.exports = u ? a : s;
            },
            41493: (e, t, r)=>{
                "use strict";
                var n, i, o = r(28847)(r(3355)), a = Function.prototype.toString, s = "object" === ("undefined" == typeof Reflect ? "undefined" : (0, o.default)(Reflect)) && null !== Reflect && Reflect.apply;
                if ("function" == typeof s && "function" == typeof Object.defineProperty) try {
                    n = Object.defineProperty({}, "length", {
                        get: function() {
                            throw i;
                        }
                    }), i = {}, s(function() {
                        throw 42;
                    }, null, n);
                } catch (e) {
                    e !== i && (s = null);
                }
                else s = null;
                var u = /^\s*class\b/, c = function(e) {
                    try {
                        var t = a.call(e);
                        return u.test(t);
                    } catch (e) {
                        return !1;
                    }
                }, f = function(e) {
                    try {
                        return !c(e) && (a.call(e), !0);
                    } catch (e) {
                        return !1;
                    }
                }, d = Object.prototype.toString, l = "function" == typeof Symbol && !!Symbol.toStringTag, h = !(0 in [
                    , 
                ]), p = function() {
                    return !1;
                };
                if ("object" === ("undefined" == typeof document ? "undefined" : (0, o.default)(document))) {
                    var b = document.all;
                    d.call(b) === d.call(document.all) && (p = function(e) {
                        if ((h || !e) && (void 0 === e || "object" === (0, o.default)(e))) try {
                            var t = d.call(e);
                            return ("[object HTMLAllCollection]" === t || "[object HTML document.all class]" === t || "[object HTMLCollection]" === t || "[object Object]" === t) && null == e("");
                        } catch (e) {}
                        return !1;
                    });
                }
                e.exports = s ? function(e) {
                    if (p(e)) return !0;
                    if (!e) return !1;
                    if ("function" != typeof e && "object" !== (0, o.default)(e)) return !1;
                    try {
                        s(e, null, n);
                    } catch (e) {
                        if (e !== i) return !1;
                    }
                    return !c(e) && f(e);
                } : function(e) {
                    if (p(e)) return !0;
                    if (!e) return !1;
                    if ("function" != typeof e && "object" !== (0, o.default)(e)) return !1;
                    if (l) return f(e);
                    if (c(e)) return !1;
                    var t = d.call(e);
                    return !("[object Function]" !== t && "[object GeneratorFunction]" !== t && !/^\[object HTML/.test(t)) && f(e);
                };
            },
            27277: (e)=>{
                "use strict";
                e.exports = function(e) {
                    if (!e) return !1;
                    var r = t.call(e);
                    return "[object Function]" === r || "function" == typeof e && "[object RegExp]" !== r || "undefined" != typeof window && (e === window.setTimeout || e === window.alert || e === window.confirm || e === window.prompt);
                };
                var t = Object.prototype.toString;
            },
            14477: (e, t, r)=>{
                "use strict";
                var n, i = Object.prototype.toString, o = Function.prototype.toString, a = /^\s*(?:function)?\*/, s = r(11191)(), u = Object.getPrototypeOf;
                e.exports = function(e) {
                    if ("function" != typeof e) return !1;
                    if (a.test(o.call(e))) return !0;
                    if (!s) return "[object GeneratorFunction]" === i.call(e);
                    if (!u) return !1;
                    if (void 0 === n) {
                        var t = function() {
                            if (!s) return !1;
                            try {
                                return Function("return function*() {}")();
                            } catch (e) {}
                        }();
                        n = !!t && u(t);
                    }
                    return u(e) === n;
                };
            },
            8619: (e, t, r)=>{
                "use strict";
                var n = r(28847)(r(3355));
                e.exports = function(e) {
                    if ("string" != typeof e) throw new Error("[is-hex-prefixed] value must be type 'string', is currently type " + (0, n.default)(e) + ", while checking isHexPrefixed.");
                    return "0x" === e.slice(0, 2);
                };
            },
            28915: (e, t, r)=>{
                "use strict";
                var n = r(72337);
                e.exports = function(e) {
                    return !!n(e);
                };
            },
            39484: (e)=>{
                "use strict";
                var t = {}.toString;
                e.exports = Array.isArray || function(e) {
                    return "[object Array]" == t.call(e);
                };
            },
            24858: (e, t, r)=>{
                "use strict";
                e = r.nmd(e);
                var n = r(19142), i = r(28847)(r(3355));
                !function() {
                    var t = "object" === ("undefined" == typeof window ? "undefined" : (0, i.default)(window)) ? window : {};
                    !t.JS_SHA3_NO_NODE_JS && "object" === (void 0 === n ? "undefined" : (0, i.default)(n)) && n.versions && n.versions.node && (t = r.g);
                    for(var o = !t.JS_SHA3_NO_COMMON_JS && "object" === (0, i.default)(e) && e.exports, a = "0123456789abcdef".split(""), s = [
                        0,
                        8,
                        16,
                        24
                    ], u = [
                        1,
                        0,
                        32898,
                        0,
                        32906,
                        2147483648,
                        2147516416,
                        2147483648,
                        32907,
                        0,
                        2147483649,
                        0,
                        2147516545,
                        2147483648,
                        32777,
                        2147483648,
                        138,
                        0,
                        136,
                        0,
                        2147516425,
                        0,
                        2147483658,
                        0,
                        2147516555,
                        0,
                        139,
                        2147483648,
                        32905,
                        2147483648,
                        32771,
                        2147483648,
                        32770,
                        2147483648,
                        128,
                        2147483648,
                        32778,
                        0,
                        2147483658,
                        2147483648,
                        2147516545,
                        2147483648,
                        32896,
                        2147483648,
                        2147483649,
                        0,
                        2147516424,
                        2147483648
                    ], c = [
                        224,
                        256,
                        384,
                        512
                    ], f = [
                        "hex",
                        "buffer",
                        "arrayBuffer",
                        "array"
                    ], d = function(e, t, r) {
                        return function(n) {
                            return new _(e, t, e).update(n)[r]();
                        };
                    }, l = function(e, t, r) {
                        return function(n, i) {
                            return new _(e, t, i).update(n)[r]();
                        };
                    }, h = function(e, t) {
                        var r = d(e, t, "hex");
                        r.create = function() {
                            return new _(e, t, e);
                        }, r.update = function(e) {
                            return r.create().update(e);
                        };
                        for(var n = 0; n < f.length; ++n){
                            var i = f[n];
                            r[i] = d(e, t, i);
                        }
                        return r;
                    }, p = [
                        {
                            name: "keccak",
                            padding: [
                                1,
                                256,
                                65536,
                                16777216
                            ],
                            bits: c,
                            createMethod: h
                        },
                        {
                            name: "sha3",
                            padding: [
                                6,
                                1536,
                                393216,
                                100663296
                            ],
                            bits: c,
                            createMethod: h
                        },
                        {
                            name: "shake",
                            padding: [
                                31,
                                7936,
                                2031616,
                                520093696
                            ],
                            bits: [
                                128,
                                256
                            ],
                            createMethod: function(e, t) {
                                var r = l(e, t, "hex");
                                r.create = function(r) {
                                    return new _(e, t, r);
                                }, r.update = function(e, t) {
                                    return r.create(t).update(e);
                                };
                                for(var n = 0; n < f.length; ++n){
                                    var i = f[n];
                                    r[i] = l(e, t, i);
                                }
                                return r;
                            }
                        }
                    ], b = {}, y = [], v = 0; v < p.length; ++v)for(var m = p[v], g = m.bits, w = 0; w < g.length; ++w){
                        var k = m.name + "_" + g[w];
                        y.push(k), b[k] = m.createMethod(g[w], m.padding);
                    }
                    function _(e, t, r) {
                        this.blocks = [], this.s = [], this.padding = t, this.outputBits = r, this.reset = !0, this.block = 0, this.start = 0, this.blockCount = 1600 - (e << 1) >> 5, this.byteCount = this.blockCount << 2, this.outputBlocks = r >> 5, this.extraBytes = (31 & r) >> 3;
                        for(var n = 0; n < 50; ++n)this.s[n] = 0;
                    }
                    _.prototype.update = function(e) {
                        var t = "string" != typeof e;
                        t && e.constructor === ArrayBuffer && (e = new Uint8Array(e));
                        for(var r, n, i = e.length, o = this.blocks, a = this.byteCount, u = this.blockCount, c = 0, f = this.s; c < i;){
                            if (this.reset) for(this.reset = !1, o[0] = this.block, r = 1; r < u + 1; ++r)o[r] = 0;
                            if (t) for(r = this.start; c < i && r < a; ++c)o[r >> 2] |= e[c] << s[3 & r++];
                            else for(r = this.start; c < i && r < a; ++c)(n = e.charCodeAt(c)) < 128 ? o[r >> 2] |= n << s[3 & r++] : n < 2048 ? (o[r >> 2] |= (192 | n >> 6) << s[3 & r++], o[r >> 2] |= (128 | 63 & n) << s[3 & r++]) : n < 55296 || n >= 57344 ? (o[r >> 2] |= (224 | n >> 12) << s[3 & r++], o[r >> 2] |= (128 | n >> 6 & 63) << s[3 & r++], o[r >> 2] |= (128 | 63 & n) << s[3 & r++]) : (n = 65536 + ((1023 & n) << 10 | 1023 & e.charCodeAt(++c)), o[r >> 2] |= (240 | n >> 18) << s[3 & r++], o[r >> 2] |= (128 | n >> 12 & 63) << s[3 & r++], o[r >> 2] |= (128 | n >> 6 & 63) << s[3 & r++], o[r >> 2] |= (128 | 63 & n) << s[3 & r++]);
                            if (this.lastByteIndex = r, r >= a) {
                                for(this.start = r - a, this.block = o[u], r = 0; r < u; ++r)f[r] ^= o[r];
                                A(f), this.reset = !0;
                            } else this.start = r;
                        }
                        return this;
                    }, _.prototype.finalize = function() {
                        var e = this.blocks, t = this.lastByteIndex, r = this.blockCount, n = this.s;
                        if (e[t >> 2] |= this.padding[3 & t], this.lastByteIndex === this.byteCount) for(e[0] = e[r], t = 1; t < r + 1; ++t)e[t] = 0;
                        for(e[r - 1] |= 2147483648, t = 0; t < r; ++t)n[t] ^= e[t];
                        A(n);
                    }, _.prototype.toString = _.prototype.hex = function() {
                        this.finalize();
                        for(var e, t = this.blockCount, r = this.s, n = this.outputBlocks, i = this.extraBytes, o = 0, s = 0, u = ""; s < n;){
                            for(o = 0; o < t && s < n; ++o, ++s)e = r[o], u += a[e >> 4 & 15] + a[15 & e] + a[e >> 12 & 15] + a[e >> 8 & 15] + a[e >> 20 & 15] + a[e >> 16 & 15] + a[e >> 28 & 15] + a[e >> 24 & 15];
                            s % t == 0 && (A(r), o = 0);
                        }
                        return i && (e = r[o], i > 0 && (u += a[e >> 4 & 15] + a[15 & e]), i > 1 && (u += a[e >> 12 & 15] + a[e >> 8 & 15]), i > 2 && (u += a[e >> 20 & 15] + a[e >> 16 & 15])), u;
                    }, _.prototype.arrayBuffer = function() {
                        this.finalize();
                        var e, t = this.blockCount, r = this.s, n = this.outputBlocks, i = this.extraBytes, o = 0, a = 0, s = this.outputBits >> 3;
                        e = i ? new ArrayBuffer(n + 1 << 2) : new ArrayBuffer(s);
                        for(var u = new Uint32Array(e); a < n;){
                            for(o = 0; o < t && a < n; ++o, ++a)u[a] = r[o];
                            a % t == 0 && A(r);
                        }
                        return i && (u[o] = r[o], e = e.slice(0, s)), e;
                    }, _.prototype.buffer = _.prototype.arrayBuffer, _.prototype.digest = _.prototype.array = function() {
                        this.finalize();
                        for(var e, t, r = this.blockCount, n = this.s, i = this.outputBlocks, o = this.extraBytes, a = 0, s = 0, u = []; s < i;){
                            for(a = 0; a < r && s < i; ++a, ++s)e = s << 2, t = n[a], u[e] = 255 & t, u[e + 1] = t >> 8 & 255, u[e + 2] = t >> 16 & 255, u[e + 3] = t >> 24 & 255;
                            s % r == 0 && A(n);
                        }
                        return o && (e = s << 2, t = n[a], o > 0 && (u[e] = 255 & t), o > 1 && (u[e + 1] = t >> 8 & 255), o > 2 && (u[e + 2] = t >> 16 & 255)), u;
                    };
                    var A = function(e) {
                        var t, r, n, i, o, a, s, c, f, d, l, h, p, b, y, v, m, g, w, k, _, A, E, S, x, B, O, P, I, T, C, M, R, U, N, j, L, F, D, H, z, q, K, G, V, Z, W, J, Y, X, Q, $, ee, te, re, ne, ie, oe, ae, se, ue, ce, fe;
                        for(n = 0; n < 48; n += 2)i = e[0] ^ e[10] ^ e[20] ^ e[30] ^ e[40], o = e[1] ^ e[11] ^ e[21] ^ e[31] ^ e[41], a = e[2] ^ e[12] ^ e[22] ^ e[32] ^ e[42], s = e[3] ^ e[13] ^ e[23] ^ e[33] ^ e[43], c = e[4] ^ e[14] ^ e[24] ^ e[34] ^ e[44], f = e[5] ^ e[15] ^ e[25] ^ e[35] ^ e[45], d = e[6] ^ e[16] ^ e[26] ^ e[36] ^ e[46], l = e[7] ^ e[17] ^ e[27] ^ e[37] ^ e[47], t = (h = e[8] ^ e[18] ^ e[28] ^ e[38] ^ e[48]) ^ (a << 1 | s >>> 31), r = (p = e[9] ^ e[19] ^ e[29] ^ e[39] ^ e[49]) ^ (s << 1 | a >>> 31), e[0] ^= t, e[1] ^= r, e[10] ^= t, e[11] ^= r, e[20] ^= t, e[21] ^= r, e[30] ^= t, e[31] ^= r, e[40] ^= t, e[41] ^= r, t = i ^ (c << 1 | f >>> 31), r = o ^ (f << 1 | c >>> 31), e[2] ^= t, e[3] ^= r, e[12] ^= t, e[13] ^= r, e[22] ^= t, e[23] ^= r, e[32] ^= t, e[33] ^= r, e[42] ^= t, e[43] ^= r, t = a ^ (d << 1 | l >>> 31), r = s ^ (l << 1 | d >>> 31), e[4] ^= t, e[5] ^= r, e[14] ^= t, e[15] ^= r, e[24] ^= t, e[25] ^= r, e[34] ^= t, e[35] ^= r, e[44] ^= t, e[45] ^= r, t = c ^ (h << 1 | p >>> 31), r = f ^ (p << 1 | h >>> 31), e[6] ^= t, e[7] ^= r, e[16] ^= t, e[17] ^= r, e[26] ^= t, e[27] ^= r, e[36] ^= t, e[37] ^= r, e[46] ^= t, e[47] ^= r, t = d ^ (i << 1 | o >>> 31), r = l ^ (o << 1 | i >>> 31), e[8] ^= t, e[9] ^= r, e[18] ^= t, e[19] ^= r, e[28] ^= t, e[29] ^= r, e[38] ^= t, e[39] ^= r, e[48] ^= t, e[49] ^= r, b = e[0], y = e[1], Z = e[11] << 4 | e[10] >>> 28, W = e[10] << 4 | e[11] >>> 28, P = e[20] << 3 | e[21] >>> 29, I = e[21] << 3 | e[20] >>> 29, se = e[31] << 9 | e[30] >>> 23, ue = e[30] << 9 | e[31] >>> 23, q = e[40] << 18 | e[41] >>> 14, K = e[41] << 18 | e[40] >>> 14, U = e[2] << 1 | e[3] >>> 31, N = e[3] << 1 | e[2] >>> 31, v = e[13] << 12 | e[12] >>> 20, m = e[12] << 12 | e[13] >>> 20, J = e[22] << 10 | e[23] >>> 22, Y = e[23] << 10 | e[22] >>> 22, T = e[33] << 13 | e[32] >>> 19, C = e[32] << 13 | e[33] >>> 19, ce = e[42] << 2 | e[43] >>> 30, fe = e[43] << 2 | e[42] >>> 30, te = e[5] << 30 | e[4] >>> 2, re = e[4] << 30 | e[5] >>> 2, j = e[14] << 6 | e[15] >>> 26, L = e[15] << 6 | e[14] >>> 26, g = e[25] << 11 | e[24] >>> 21, w = e[24] << 11 | e[25] >>> 21, X = e[34] << 15 | e[35] >>> 17, Q = e[35] << 15 | e[34] >>> 17, M = e[45] << 29 | e[44] >>> 3, R = e[44] << 29 | e[45] >>> 3, S = e[6] << 28 | e[7] >>> 4, x = e[7] << 28 | e[6] >>> 4, ne = e[17] << 23 | e[16] >>> 9, ie = e[16] << 23 | e[17] >>> 9, F = e[26] << 25 | e[27] >>> 7, D = e[27] << 25 | e[26] >>> 7, k = e[36] << 21 | e[37] >>> 11, _ = e[37] << 21 | e[36] >>> 11, $ = e[47] << 24 | e[46] >>> 8, ee = e[46] << 24 | e[47] >>> 8, G = e[8] << 27 | e[9] >>> 5, V = e[9] << 27 | e[8] >>> 5, B = e[18] << 20 | e[19] >>> 12, O = e[19] << 20 | e[18] >>> 12, oe = e[29] << 7 | e[28] >>> 25, ae = e[28] << 7 | e[29] >>> 25, H = e[38] << 8 | e[39] >>> 24, z = e[39] << 8 | e[38] >>> 24, A = e[48] << 14 | e[49] >>> 18, E = e[49] << 14 | e[48] >>> 18, e[0] = b ^ ~v & g, e[1] = y ^ ~m & w, e[10] = S ^ ~B & P, e[11] = x ^ ~O & I, e[20] = U ^ ~j & F, e[21] = N ^ ~L & D, e[30] = G ^ ~Z & J, e[31] = V ^ ~W & Y, e[40] = te ^ ~ne & oe, e[41] = re ^ ~ie & ae, e[2] = v ^ ~g & k, e[3] = m ^ ~w & _, e[12] = B ^ ~P & T, e[13] = O ^ ~I & C, e[22] = j ^ ~F & H, e[23] = L ^ ~D & z, e[32] = Z ^ ~J & X, e[33] = W ^ ~Y & Q, e[42] = ne ^ ~oe & se, e[43] = ie ^ ~ae & ue, e[4] = g ^ ~k & A, e[5] = w ^ ~_ & E, e[14] = P ^ ~T & M, e[15] = I ^ ~C & R, e[24] = F ^ ~H & q, e[25] = D ^ ~z & K, e[34] = J ^ ~X & $, e[35] = Y ^ ~Q & ee, e[44] = oe ^ ~se & ce, e[45] = ae ^ ~ue & fe, e[6] = k ^ ~A & b, e[7] = _ ^ ~E & y, e[16] = T ^ ~M & S, e[17] = C ^ ~R & x, e[26] = H ^ ~q & U, e[27] = z ^ ~K & N, e[36] = X ^ ~$ & G, e[37] = Q ^ ~ee & V, e[46] = se ^ ~ce & te, e[47] = ue ^ ~fe & re, e[8] = A ^ ~b & v, e[9] = E ^ ~y & m, e[18] = M ^ ~S & B, e[19] = R ^ ~x & O, e[28] = q ^ ~U & j, e[29] = K ^ ~N & L, e[38] = $ ^ ~G & Z, e[39] = ee ^ ~V & W, e[48] = ce ^ ~te & ne, e[49] = fe ^ ~re & ie, e[0] ^= u[n], e[1] ^= u[n + 1];
                    };
                    if (o) e.exports = b;
                    else for(v = 0; v < y.length; ++v)t[y[v]] = b[y[v]];
                }();
            },
            93135: (e, t, r)=>{
                "use strict";
                e.exports = r(22109)(r(80801));
            },
            22109: (e, t, r)=>{
                "use strict";
                var n = r(46543), i = r(40274);
                e.exports = function(e) {
                    var t = n(e), r = i(e);
                    return function(e, n) {
                        switch("string" == typeof e ? e.toLowerCase() : e){
                            case "keccak224":
                                return new t(1152, 448, null, 224, n);
                            case "keccak256":
                                return new t(1088, 512, null, 256, n);
                            case "keccak384":
                                return new t(832, 768, null, 384, n);
                            case "keccak512":
                                return new t(576, 1024, null, 512, n);
                            case "sha3-224":
                                return new t(1152, 448, 6, 224, n);
                            case "sha3-256":
                                return new t(1088, 512, 6, 256, n);
                            case "sha3-384":
                                return new t(832, 768, 6, 384, n);
                            case "sha3-512":
                                return new t(576, 1024, 6, 512, n);
                            case "shake128":
                                return new r(1344, 256, 31, n);
                            case "shake256":
                                return new r(1088, 512, 31, n);
                            default:
                                throw new Error("Invald algorithm: " + e);
                        }
                    };
                };
            },
            46543: (e, t, r)=>{
                "use strict";
                var n = r(29033).Buffer, i = r(28847), o = i(r(69721)), a = i(r(58985)), s = i(r(15163)), u = i(r(34650)), c = i(r(21949));
                var f = r(86505).Transform;
                e.exports = function(e) {
                    return function(t) {
                        (0, s.default)(d, t);
                        var r, i, f = (r = d, i = function() {
                            if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                            if (Reflect.construct.sham) return !1;
                            if ("function" == typeof Proxy) return !0;
                            try {
                                return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                            } catch (e) {
                                return !1;
                            }
                        }(), function() {
                            var e, t = (0, c.default)(r);
                            if (i) {
                                var n = (0, c.default)(this).constructor;
                                e = Reflect.construct(t, arguments, n);
                            } else e = t.apply(this, arguments);
                            return (0, u.default)(this, e);
                        });
                        function d(t, r, n, i, a) {
                            var s;
                            return (0, o.default)(this, d), (s = f.call(this, a))._rate = t, s._capacity = r, s._delimitedSuffix = n, s._hashBitLength = i, s._options = a, s._state = new e, s._state.initialize(t, r), s._finalized = !1, s;
                        }
                        return (0, a.default)(d, [
                            {
                                key: "_transform",
                                value: function(e, t, r) {
                                    var n = null;
                                    try {
                                        this.update(e, t);
                                    } catch (e) {
                                        n = e;
                                    }
                                    r(n);
                                }
                            },
                            {
                                key: "_flush",
                                value: function(e) {
                                    var t = null;
                                    try {
                                        this.push(this.digest());
                                    } catch (e) {
                                        t = e;
                                    }
                                    e(t);
                                }
                            },
                            {
                                key: "update",
                                value: function(e, t) {
                                    if (!n.isBuffer(e) && "string" != typeof e) throw new TypeError("Data must be a string or a buffer");
                                    if (this._finalized) throw new Error("Digest already called");
                                    return n.isBuffer(e) || (e = n.from(e, t)), this._state.absorb(e), this;
                                }
                            },
                            {
                                key: "digest",
                                value: function(e) {
                                    if (this._finalized) throw new Error("Digest already called");
                                    this._finalized = !0, this._delimitedSuffix && this._state.absorbLastFewBits(this._delimitedSuffix);
                                    var t = this._state.squeeze(this._hashBitLength / 8);
                                    return void 0 !== e && (t = t.toString(e)), this._resetState(), t;
                                }
                            },
                            {
                                key: "_resetState",
                                value: function() {
                                    return this._state.initialize(this._rate, this._capacity), this;
                                }
                            },
                            {
                                key: "_clone",
                                value: function() {
                                    var e = new d(this._rate, this._capacity, this._delimitedSuffix, this._hashBitLength, this._options);
                                    return this._state.copy(e._state), e._finalized = this._finalized, e;
                                }
                            }
                        ]), d;
                    }(f);
                };
            },
            40274: (e, t, r)=>{
                "use strict";
                var n = r(29033).Buffer, i = r(28847), o = i(r(69721)), a = i(r(58985)), s = i(r(15163)), u = i(r(34650)), c = i(r(21949));
                var f = r(86505).Transform;
                e.exports = function(e) {
                    return function(t) {
                        (0, s.default)(d, t);
                        var r, i, f = (r = d, i = function() {
                            if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                            if (Reflect.construct.sham) return !1;
                            if ("function" == typeof Proxy) return !0;
                            try {
                                return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                            } catch (e) {
                                return !1;
                            }
                        }(), function() {
                            var e, t = (0, c.default)(r);
                            if (i) {
                                var n = (0, c.default)(this).constructor;
                                e = Reflect.construct(t, arguments, n);
                            } else e = t.apply(this, arguments);
                            return (0, u.default)(this, e);
                        });
                        function d(t, r, n, i) {
                            var a;
                            return (0, o.default)(this, d), (a = f.call(this, i))._rate = t, a._capacity = r, a._delimitedSuffix = n, a._options = i, a._state = new e, a._state.initialize(t, r), a._finalized = !1, a;
                        }
                        return (0, a.default)(d, [
                            {
                                key: "_transform",
                                value: function(e, t, r) {
                                    var n = null;
                                    try {
                                        this.update(e, t);
                                    } catch (e) {
                                        n = e;
                                    }
                                    r(n);
                                }
                            },
                            {
                                key: "_flush",
                                value: function() {}
                            },
                            {
                                key: "_read",
                                value: function(e) {
                                    this.push(this.squeeze(e));
                                }
                            },
                            {
                                key: "update",
                                value: function(e, t) {
                                    if (!n.isBuffer(e) && "string" != typeof e) throw new TypeError("Data must be a string or a buffer");
                                    if (this._finalized) throw new Error("Squeeze already called");
                                    return n.isBuffer(e) || (e = n.from(e, t)), this._state.absorb(e), this;
                                }
                            },
                            {
                                key: "squeeze",
                                value: function(e, t) {
                                    this._finalized || (this._finalized = !0, this._state.absorbLastFewBits(this._delimitedSuffix));
                                    var r = this._state.squeeze(e);
                                    return void 0 !== t && (r = r.toString(t)), r;
                                }
                            },
                            {
                                key: "_resetState",
                                value: function() {
                                    return this._state.initialize(this._rate, this._capacity), this;
                                }
                            },
                            {
                                key: "_clone",
                                value: function() {
                                    var e = new d(this._rate, this._capacity, this._delimitedSuffix, this._options);
                                    return this._state.copy(e._state), e._finalized = this._finalized, e;
                                }
                            }
                        ]), d;
                    }(f);
                };
            },
            25612: (e, t)=>{
                "use strict";
                var r = [
                    1,
                    0,
                    32898,
                    0,
                    32906,
                    2147483648,
                    2147516416,
                    2147483648,
                    32907,
                    0,
                    2147483649,
                    0,
                    2147516545,
                    2147483648,
                    32777,
                    2147483648,
                    138,
                    0,
                    136,
                    0,
                    2147516425,
                    0,
                    2147483658,
                    0,
                    2147516555,
                    0,
                    139,
                    2147483648,
                    32905,
                    2147483648,
                    32771,
                    2147483648,
                    32770,
                    2147483648,
                    128,
                    2147483648,
                    32778,
                    0,
                    2147483658,
                    2147483648,
                    2147516545,
                    2147483648,
                    32896,
                    2147483648,
                    2147483649,
                    0,
                    2147516424,
                    2147483648
                ];
                t.p1600 = function(e) {
                    for(var t = 0; t < 24; ++t){
                        var n = e[0] ^ e[10] ^ e[20] ^ e[30] ^ e[40], i = e[1] ^ e[11] ^ e[21] ^ e[31] ^ e[41], o = e[2] ^ e[12] ^ e[22] ^ e[32] ^ e[42], a = e[3] ^ e[13] ^ e[23] ^ e[33] ^ e[43], s = e[4] ^ e[14] ^ e[24] ^ e[34] ^ e[44], u = e[5] ^ e[15] ^ e[25] ^ e[35] ^ e[45], c = e[6] ^ e[16] ^ e[26] ^ e[36] ^ e[46], f = e[7] ^ e[17] ^ e[27] ^ e[37] ^ e[47], d = e[8] ^ e[18] ^ e[28] ^ e[38] ^ e[48], l = e[9] ^ e[19] ^ e[29] ^ e[39] ^ e[49], h = d ^ (o << 1 | a >>> 31), p = l ^ (a << 1 | o >>> 31), b = e[0] ^ h, y = e[1] ^ p, v = e[10] ^ h, m = e[11] ^ p, g = e[20] ^ h, w = e[21] ^ p, k = e[30] ^ h, _ = e[31] ^ p, A = e[40] ^ h, E = e[41] ^ p;
                        h = n ^ (s << 1 | u >>> 31), p = i ^ (u << 1 | s >>> 31);
                        var S = e[2] ^ h, x = e[3] ^ p, B = e[12] ^ h, O = e[13] ^ p, P = e[22] ^ h, I = e[23] ^ p, T = e[32] ^ h, C = e[33] ^ p, M = e[42] ^ h, R = e[43] ^ p;
                        h = o ^ (c << 1 | f >>> 31), p = a ^ (f << 1 | c >>> 31);
                        var U = e[4] ^ h, N = e[5] ^ p, j = e[14] ^ h, L = e[15] ^ p, F = e[24] ^ h, D = e[25] ^ p, H = e[34] ^ h, z = e[35] ^ p, q = e[44] ^ h, K = e[45] ^ p;
                        h = s ^ (d << 1 | l >>> 31), p = u ^ (l << 1 | d >>> 31);
                        var G = e[6] ^ h, V = e[7] ^ p, Z = e[16] ^ h, W = e[17] ^ p, J = e[26] ^ h, Y = e[27] ^ p, X = e[36] ^ h, Q = e[37] ^ p, $ = e[46] ^ h, ee = e[47] ^ p;
                        h = c ^ (n << 1 | i >>> 31), p = f ^ (i << 1 | n >>> 31);
                        var te = e[8] ^ h, re = e[9] ^ p, ne = e[18] ^ h, ie = e[19] ^ p, oe = e[28] ^ h, ae = e[29] ^ p, se = e[38] ^ h, ue = e[39] ^ p, ce = e[48] ^ h, fe = e[49] ^ p, de = b, le = y, he = m << 4 | v >>> 28, pe = v << 4 | m >>> 28, be = g << 3 | w >>> 29, ye = w << 3 | g >>> 29, ve = _ << 9 | k >>> 23, me = k << 9 | _ >>> 23, ge = A << 18 | E >>> 14, we = E << 18 | A >>> 14, ke = S << 1 | x >>> 31, _e = x << 1 | S >>> 31, Ae = O << 12 | B >>> 20, Ee = B << 12 | O >>> 20, Se = P << 10 | I >>> 22, xe = I << 10 | P >>> 22, Be = C << 13 | T >>> 19, Oe = T << 13 | C >>> 19, Pe = M << 2 | R >>> 30, Ie = R << 2 | M >>> 30, Te = N << 30 | U >>> 2, Ce = U << 30 | N >>> 2, Me = j << 6 | L >>> 26, Re = L << 6 | j >>> 26, Ue = D << 11 | F >>> 21, Ne = F << 11 | D >>> 21, je = H << 15 | z >>> 17, Le = z << 15 | H >>> 17, Fe = K << 29 | q >>> 3, De = q << 29 | K >>> 3, He = G << 28 | V >>> 4, ze = V << 28 | G >>> 4, qe = W << 23 | Z >>> 9, Ke = Z << 23 | W >>> 9, Ge = J << 25 | Y >>> 7, Ve = Y << 25 | J >>> 7, Ze = X << 21 | Q >>> 11, We = Q << 21 | X >>> 11, Je = ee << 24 | $ >>> 8, Ye = $ << 24 | ee >>> 8, Xe = te << 27 | re >>> 5, Qe = re << 27 | te >>> 5, $e = ne << 20 | ie >>> 12, et = ie << 20 | ne >>> 12, tt = ae << 7 | oe >>> 25, rt = oe << 7 | ae >>> 25, nt = se << 8 | ue >>> 24, it = ue << 8 | se >>> 24, ot = ce << 14 | fe >>> 18, at = fe << 14 | ce >>> 18;
                        e[0] = de ^ ~Ae & Ue, e[1] = le ^ ~Ee & Ne, e[10] = He ^ ~$e & be, e[11] = ze ^ ~et & ye, e[20] = ke ^ ~Me & Ge, e[21] = _e ^ ~Re & Ve, e[30] = Xe ^ ~he & Se, e[31] = Qe ^ ~pe & xe, e[40] = Te ^ ~qe & tt, e[41] = Ce ^ ~Ke & rt, e[2] = Ae ^ ~Ue & Ze, e[3] = Ee ^ ~Ne & We, e[12] = $e ^ ~be & Be, e[13] = et ^ ~ye & Oe, e[22] = Me ^ ~Ge & nt, e[23] = Re ^ ~Ve & it, e[32] = he ^ ~Se & je, e[33] = pe ^ ~xe & Le, e[42] = qe ^ ~tt & ve, e[43] = Ke ^ ~rt & me, e[4] = Ue ^ ~Ze & ot, e[5] = Ne ^ ~We & at, e[14] = be ^ ~Be & Fe, e[15] = ye ^ ~Oe & De, e[24] = Ge ^ ~nt & ge, e[25] = Ve ^ ~it & we, e[34] = Se ^ ~je & Je, e[35] = xe ^ ~Le & Ye, e[44] = tt ^ ~ve & Pe, e[45] = rt ^ ~me & Ie, e[6] = Ze ^ ~ot & de, e[7] = We ^ ~at & le, e[16] = Be ^ ~Fe & He, e[17] = Oe ^ ~De & ze, e[26] = nt ^ ~ge & ke, e[27] = it ^ ~we & _e, e[36] = je ^ ~Je & Xe, e[37] = Le ^ ~Ye & Qe, e[46] = ve ^ ~Pe & Te, e[47] = me ^ ~Ie & Ce, e[8] = ot ^ ~de & Ae, e[9] = at ^ ~le & Ee, e[18] = Fe ^ ~He & $e, e[19] = De ^ ~ze & et, e[28] = ge ^ ~ke & Me, e[29] = we ^ ~_e & Re, e[38] = Je ^ ~Xe & he, e[39] = Ye ^ ~Qe & pe, e[48] = Pe ^ ~Te & qe, e[49] = Ie ^ ~Ce & Ke, e[0] ^= r[2 * t], e[1] ^= r[2 * t + 1];
                    }
                };
            },
            80801: (e, t, r)=>{
                "use strict";
                var n = r(29033).Buffer, i = r(25612);
                function o() {
                    this.state = [
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ], this.blockSize = null, this.count = 0, this.squeezing = !1;
                }
                o.prototype.initialize = function(e, t) {
                    for(var r = 0; r < 50; ++r)this.state[r] = 0;
                    this.blockSize = e / 8, this.count = 0, this.squeezing = !1;
                }, o.prototype.absorb = function(e) {
                    for(var t = 0; t < e.length; ++t)this.state[~~(this.count / 4)] ^= e[t] << this.count % 4 * 8, this.count += 1, this.count === this.blockSize && (i.p1600(this.state), this.count = 0);
                }, o.prototype.absorbLastFewBits = function(e) {
                    this.state[~~(this.count / 4)] ^= e << this.count % 4 * 8, 0 != (128 & e) && this.count === this.blockSize - 1 && i.p1600(this.state), this.state[~~((this.blockSize - 1) / 4)] ^= 128 << (this.blockSize - 1) % 4 * 8, i.p1600(this.state), this.count = 0, this.squeezing = !0;
                }, o.prototype.squeeze = function(e) {
                    this.squeezing || this.absorbLastFewBits(1);
                    for(var t = n.alloc(e), r = 0; r < e; ++r)t[r] = this.state[~~(this.count / 4)] >>> this.count % 4 * 8 & 255, this.count += 1, this.count === this.blockSize && (i.p1600(this.state), this.count = 0);
                    return t;
                }, o.prototype.copy = function(e) {
                    for(var t = 0; t < 50; ++t)e.state[t] = this.state[t];
                    e.blockSize = this.blockSize, e.count = this.count, e.squeezing = this.squeezing;
                }, e.exports = o;
            },
            50807: (e, t, r)=>{
                "use strict";
                var n = r(41736), i = r(22353), o = r(48850).Buffer, a = new Array(16);
                function s() {
                    i.call(this, 64), this._a = 1732584193, this._b = 4023233417, this._c = 2562383102, this._d = 271733878;
                }
                function u(e, t) {
                    return e << t | e >>> 32 - t;
                }
                function c(e, t, r, n, i, o, a) {
                    return u(e + (t & r | ~t & n) + i + o | 0, a) + t | 0;
                }
                function f(e, t, r, n, i, o, a) {
                    return u(e + (t & n | r & ~n) + i + o | 0, a) + t | 0;
                }
                function d(e, t, r, n, i, o, a) {
                    return u(e + (t ^ r ^ n) + i + o | 0, a) + t | 0;
                }
                function l(e, t, r, n, i, o, a) {
                    return u(e + (r ^ (t | ~n)) + i + o | 0, a) + t | 0;
                }
                n(s, i), s.prototype._update = function() {
                    for(var e = a, t = 0; t < 16; ++t)e[t] = this._block.readInt32LE(4 * t);
                    var r = this._a, n = this._b, i = this._c, o = this._d;
                    r = c(r, n, i, o, e[0], 3614090360, 7), o = c(o, r, n, i, e[1], 3905402710, 12), i = c(i, o, r, n, e[2], 606105819, 17), n = c(n, i, o, r, e[3], 3250441966, 22), r = c(r, n, i, o, e[4], 4118548399, 7), o = c(o, r, n, i, e[5], 1200080426, 12), i = c(i, o, r, n, e[6], 2821735955, 17), n = c(n, i, o, r, e[7], 4249261313, 22), r = c(r, n, i, o, e[8], 1770035416, 7), o = c(o, r, n, i, e[9], 2336552879, 12), i = c(i, o, r, n, e[10], 4294925233, 17), n = c(n, i, o, r, e[11], 2304563134, 22), r = c(r, n, i, o, e[12], 1804603682, 7), o = c(o, r, n, i, e[13], 4254626195, 12), i = c(i, o, r, n, e[14], 2792965006, 17), r = f(r, n = c(n, i, o, r, e[15], 1236535329, 22), i, o, e[1], 4129170786, 5), o = f(o, r, n, i, e[6], 3225465664, 9), i = f(i, o, r, n, e[11], 643717713, 14), n = f(n, i, o, r, e[0], 3921069994, 20), r = f(r, n, i, o, e[5], 3593408605, 5), o = f(o, r, n, i, e[10], 38016083, 9), i = f(i, o, r, n, e[15], 3634488961, 14), n = f(n, i, o, r, e[4], 3889429448, 20), r = f(r, n, i, o, e[9], 568446438, 5), o = f(o, r, n, i, e[14], 3275163606, 9), i = f(i, o, r, n, e[3], 4107603335, 14), n = f(n, i, o, r, e[8], 1163531501, 20), r = f(r, n, i, o, e[13], 2850285829, 5), o = f(o, r, n, i, e[2], 4243563512, 9), i = f(i, o, r, n, e[7], 1735328473, 14), r = d(r, n = f(n, i, o, r, e[12], 2368359562, 20), i, o, e[5], 4294588738, 4), o = d(o, r, n, i, e[8], 2272392833, 11), i = d(i, o, r, n, e[11], 1839030562, 16), n = d(n, i, o, r, e[14], 4259657740, 23), r = d(r, n, i, o, e[1], 2763975236, 4), o = d(o, r, n, i, e[4], 1272893353, 11), i = d(i, o, r, n, e[7], 4139469664, 16), n = d(n, i, o, r, e[10], 3200236656, 23), r = d(r, n, i, o, e[13], 681279174, 4), o = d(o, r, n, i, e[0], 3936430074, 11), i = d(i, o, r, n, e[3], 3572445317, 16), n = d(n, i, o, r, e[6], 76029189, 23), r = d(r, n, i, o, e[9], 3654602809, 4), o = d(o, r, n, i, e[12], 3873151461, 11), i = d(i, o, r, n, e[15], 530742520, 16), r = l(r, n = d(n, i, o, r, e[2], 3299628645, 23), i, o, e[0], 4096336452, 6), o = l(o, r, n, i, e[7], 1126891415, 10), i = l(i, o, r, n, e[14], 2878612391, 15), n = l(n, i, o, r, e[5], 4237533241, 21), r = l(r, n, i, o, e[12], 1700485571, 6), o = l(o, r, n, i, e[3], 2399980690, 10), i = l(i, o, r, n, e[10], 4293915773, 15), n = l(n, i, o, r, e[1], 2240044497, 21), r = l(r, n, i, o, e[8], 1873313359, 6), o = l(o, r, n, i, e[15], 4264355552, 10), i = l(i, o, r, n, e[6], 2734768916, 15), n = l(n, i, o, r, e[13], 1309151649, 21), r = l(r, n, i, o, e[4], 4149444226, 6), o = l(o, r, n, i, e[11], 3174756917, 10), i = l(i, o, r, n, e[2], 718787259, 15), n = l(n, i, o, r, e[9], 3951481745, 21), this._a = this._a + r | 0, this._b = this._b + n | 0, this._c = this._c + i | 0, this._d = this._d + o | 0;
                }, s.prototype._digest = function() {
                    this._block[this._blockOffset++] = 128, this._blockOffset > 56 && (this._block.fill(0, this._blockOffset, 64), this._update(), this._blockOffset = 0), this._block.fill(0, this._blockOffset, 56), this._block.writeUInt32LE(this._length[0], 56), this._block.writeUInt32LE(this._length[1], 60), this._update();
                    var e = o.allocUnsafe(16);
                    return e.writeInt32LE(this._a, 0), e.writeInt32LE(this._b, 4), e.writeInt32LE(this._c, 8), e.writeInt32LE(this._d, 12), e;
                }, e.exports = s;
            },
            37441: (e, t, r)=>{
                "use strict";
                var n = r(29033).Buffer, i = r(19142), o = r(28847), a = o(r(82247)), s = o(r(3355)), u = o(r(94571)), c = o(r(90775)), f = o(r(58985)), d = o(r(69721)), l = o(r(15163)), h = o(r(34650)), p = o(r(21949)), b = o(r(22940));
                function y(e, t) {
                    var r = Object.keys(e);
                    if (Object.getOwnPropertySymbols) {
                        var n = Object.getOwnPropertySymbols(e);
                        t && (n = n.filter(function(t) {
                            return Object.getOwnPropertyDescriptor(e, t).enumerable;
                        })), r.push.apply(r, n);
                    }
                    return r;
                }
                function v(e) {
                    for(var t = 1; t < arguments.length; t++){
                        var r = null != arguments[t] ? arguments[t] : {};
                        t % 2 ? y(Object(r), !0).forEach(function(t) {
                            (0, c.default)(e, t, r[t]);
                        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : y(Object(r)).forEach(function(t) {
                            Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
                        });
                    }
                    return e;
                }
                function m(e) {
                    var t = function() {
                        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                        if (Reflect.construct.sham) return !1;
                        if ("function" == typeof Proxy) return !0;
                        try {
                            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                        } catch (e) {
                            return !1;
                        }
                    }();
                    return function() {
                        var r, n = (0, p.default)(e);
                        if (t) {
                            var i = (0, p.default)(this).constructor;
                            r = Reflect.construct(n, arguments, i);
                        } else r = n.apply(this, arguments);
                        return (0, h.default)(this, r);
                    };
                }
                function g(e) {
                    var t, r, n, i = 2;
                    for("undefined" != typeof Symbol && (r = Symbol.asyncIterator, n = Symbol.iterator); i--;){
                        if (r && null != (t = e[r])) return t.call(e);
                        if (n && null != (t = e[n])) return new w(t.call(e));
                        r = "@@asyncIterator", n = "@@iterator";
                    }
                    throw new TypeError("Object is not async iterable");
                }
                function w(e) {
                    function t(e) {
                        if (Object(e) !== e) return Promise.reject(new TypeError(e + " is not an object."));
                        var t = e.done;
                        return Promise.resolve(e.value).then(function(e) {
                            return {
                                value: e,
                                done: t
                            };
                        });
                    }
                    return w = function(e) {
                        this.s = e, this.n = e.next;
                    }, w.prototype = {
                        s: null,
                        n: null,
                        next: function() {
                            return t(this.n.apply(this.s, arguments));
                        },
                        return: function(e) {
                            var r = this.s.return;
                            return void 0 === r ? Promise.resolve({
                                value: e,
                                done: !0
                            }) : t(r.apply(this.s, arguments));
                        },
                        throw: function(e) {
                            var r = this.s.return;
                            return void 0 === r ? Promise.reject(e) : t(r.apply(this.s, arguments));
                        }
                    }, new w(e);
                }
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.InvalidStatusCodeError = t.InvalidCertError = void 0;
                var k = Object.freeze({
                    redirect: !0,
                    expectStatusCode: 200,
                    headers: {},
                    full: !1,
                    keepAlive: !0,
                    cors: !1,
                    referrer: !1,
                    sslAllowSelfSigned: !1,
                    _redirectCount: 0
                }), _ = function(e) {
                    (0, l.default)(r, e);
                    var t = m(r);
                    function r(e, n) {
                        var i;
                        return (0, d.default)(this, r), (i = t.call(this, e)).fingerprint256 = n, i;
                    }
                    return (0, f.default)(r);
                }((0, b.default)(Error));
                t.InvalidCertError = _;
                var A = function(e) {
                    (0, l.default)(r, e);
                    var t = m(r);
                    function r(e) {
                        var n;
                        return (0, d.default)(this, r), (n = t.call(this, "Request Failed. Status Code: ".concat(e))).statusCode = e, n;
                    }
                    return (0, f.default)(r);
                }((0, b.default)(Error));
                function E(e, t) {
                    if (!t || "text" === t || "json" === t) try {
                        var r = new TextDecoder("utf8", {
                            fatal: !0
                        }).decode(e);
                        if ("text" === t) return r;
                        try {
                            return JSON.parse(r);
                        } catch (e) {
                            if ("json" === t) throw e;
                            return r;
                        }
                    } catch (e) {
                        if ("text" === t || "json" === t) throw e;
                    }
                    return e;
                }
                t.InvalidStatusCodeError = A;
                var S = {};
                function x(e, t) {
                    var i = v(v({}, k), t), o = r(29519), s = r(90912), c = r(77611), f = r(45058).promisify, d = r(51143).resolve, l = !!/^https/.test(e), h = {
                        method: i.method || "GET",
                        headers: {
                            "Accept-Encoding": "gzip, deflate, br"
                        }
                    }, p = function(e) {
                        return e.replace(/:| /g, "").toLowerCase();
                    };
                    if (i.keepAlive) {
                        var b, y = [
                            l,
                            l && (null === (b = i.sslPinnedCertificates) || void 0 === b ? void 0 : b.map(function(e) {
                                return p(e);
                            }).sort())
                        ].join();
                        h.agent = S[y] || (S[y] = new (l ? s : o).Agent({
                            keepAlive: !0,
                            keepAliveMsecs: 3e4,
                            maxFreeSockets: 1024,
                            maxCachedSessions: 1024
                        }));
                    }
                    "json" === i.type && (h.headers["Content-Type"] = "application/json"), i.data && (i.method || (h.method = "POST"), h.body = "json" === i.type ? JSON.stringify(i.data) : i.data), h.headers = v(v({}, h.headers), i.headers), i.sslAllowSelfSigned && (h.rejectUnauthorized = !1);
                    var m = function() {
                        var t = (0, u.default)(a.default.mark(function t(r) {
                            var o, s, u, l, h, p, b, y, v, m, w;
                            return a.default.wrap(function(t) {
                                for(;;)switch(t.prev = t.next){
                                    case 0:
                                        if (o = r.statusCode, !(i.redirect && 300 <= o && o < 400 && r.headers.location)) {
                                            t.next = 8;
                                            break;
                                        }
                                        if (10 != i._redirectCount) {
                                            t.next = 4;
                                            break;
                                        }
                                        throw new Error("Request failed. Too much redirects.");
                                    case 4:
                                        return i._redirectCount += 1, t.next = 7, x(d(e, r.headers.location), i);
                                    case 7:
                                        return t.abrupt("return", t.sent);
                                    case 8:
                                        if (!i.expectStatusCode || o === i.expectStatusCode) {
                                            t.next = 11;
                                            break;
                                        }
                                        throw r.resume(), new A(o);
                                    case 11:
                                        s = [], u = !1, l = !1, t.prev = 14, p = g(r);
                                    case 16:
                                        return t.next = 18, p.next();
                                    case 18:
                                        if (!(u = !(b = t.sent).done)) {
                                            t.next = 24;
                                            break;
                                        }
                                        y = b.value, s.push(y);
                                    case 21:
                                        u = !1, t.next = 16;
                                        break;
                                    case 24:
                                        t.next = 30;
                                        break;
                                    case 26:
                                        t.prev = 26, t.t0 = t.catch(14), l = !0, h = t.t0;
                                    case 30:
                                        if (t.prev = 30, t.prev = 31, !u || null == p.return) {
                                            t.next = 35;
                                            break;
                                        }
                                        return t.next = 35, p.return();
                                    case 35:
                                        if (t.prev = 35, !l) {
                                            t.next = 38;
                                            break;
                                        }
                                        throw h;
                                    case 38:
                                        return t.finish(35);
                                    case 39:
                                        return t.finish(30);
                                    case 40:
                                        if (v = n.concat(s), "br" !== (m = r.headers["content-encoding"])) {
                                            t.next = 46;
                                            break;
                                        }
                                        return t.next = 45, f(c.brotliDecompress)(v);
                                    case 45:
                                        v = t.sent;
                                    case 46:
                                        if ("gzip" !== m && "deflate" !== m) {
                                            t.next = 50;
                                            break;
                                        }
                                        return t.next = 49, f(c.unzip)(v);
                                    case 49:
                                        v = t.sent;
                                    case 50:
                                        if (w = E(v, i.type), !i.full) {
                                            t.next = 53;
                                            break;
                                        }
                                        return t.abrupt("return", {
                                            headers: r.headers,
                                            status: o,
                                            body: w
                                        });
                                    case 53:
                                        return t.abrupt("return", w);
                                    case 54:
                                    case "end":
                                        return t.stop();
                                }
                            }, t, null, [
                                [
                                    14,
                                    26,
                                    30,
                                    40
                                ],
                                [
                                    31,
                                    ,
                                    35,
                                    39
                                ]
                            ]);
                        }));
                        return function(e) {
                            return t.apply(this, arguments);
                        };
                    }();
                    return new Promise(function(t, r) {
                        var n, c = function() {
                            var t = (0, u.default)(a.default.mark(function t(n) {
                                return a.default.wrap(function(t) {
                                    for(;;)switch(t.prev = t.next){
                                        case 0:
                                            if (!n || "DEPTH_ZERO_SELF_SIGNED_CERT" !== n.code) {
                                                t.next = 9;
                                                break;
                                            }
                                            return t.prev = 1, t.next = 4, x(e, v(v({}, i), {}, {
                                                sslAllowSelfSigned: !0,
                                                sslPinnedCertificates: []
                                            }));
                                        case 4:
                                            t.next = 9;
                                            break;
                                        case 6:
                                            t.prev = 6, t.t0 = t.catch(1), t.t0 && t.t0.fingerprint256 && (n = new _("Self-signed SSL certificate: ".concat(t.t0.fingerprint256), t.t0.fingerprint256));
                                        case 9:
                                            r(n);
                                        case 10:
                                        case "end":
                                            return t.stop();
                                    }
                                }, t, null, [
                                    [
                                        1,
                                        6
                                    ]
                                ]);
                            }));
                            return function(e) {
                                return t.apply(this, arguments);
                            };
                        }(), f = (l ? s : o).request(e, h, function(e) {
                            e.on("error", c), (0, u.default)(a.default.mark(function n() {
                                return a.default.wrap(function(n) {
                                    for(;;)switch(n.prev = n.next){
                                        case 0:
                                            return n.prev = 0, n.t0 = t, n.next = 4, m(e);
                                        case 4:
                                            n.t1 = n.sent, (0, n.t0)(n.t1), n.next = 11;
                                            break;
                                        case 8:
                                            n.prev = 8, n.t2 = n.catch(0), r(n.t2);
                                        case 11:
                                        case "end":
                                            return n.stop();
                                    }
                                }, n, null, [
                                    [
                                        0,
                                        8
                                    ]
                                ]);
                            }))();
                        });
                        f.on("error", c);
                        var d = null === (n = i.sslPinnedCertificates) || void 0 === n ? void 0 : n.map(function(e) {
                            return p(e);
                        }), b = function(e) {
                            var t, r = p((null === (t = e.getPeerCertificate()) || void 0 === t ? void 0 : t.fingerprint256) || "");
                            if ((r || !e.isSessionReused()) && !d.includes(r)) return f.emit("error", new _("Invalid SSL certificate: ".concat(r, " Expected: ").concat(d), r)), f.abort();
                        };
                        i.sslPinnedCertificates && f.on("socket", function(e) {
                            e.listeners("secureConnect").map(function(e) {
                                return (e.name || "").replace("bound ", "");
                            }).includes("mfetchSecureConnect") || e.on("secureConnect", b.bind(null, e));
                        }), i.keepAlive && f.setNoDelay(!0), h.body && f.write(h.body), f.end();
                    });
                }
                var B = new Set([
                    "Accept",
                    "Accept-Language",
                    "Content-Language",
                    "Content-Type"
                ].map(function(e) {
                    return e.toLowerCase();
                })), O = new Set([
                    "Accept-Charset",
                    "Accept-Encoding",
                    "Access-Control-Request-Headers",
                    "Access-Control-Request-Method",
                    "Connection",
                    "Content-Length",
                    "Cookie",
                    "Cookie2",
                    "Date",
                    "DNT",
                    "Expect",
                    "Host",
                    "Keep-Alive",
                    "Origin",
                    "Referer",
                    "TE",
                    "Trailer",
                    "Transfer-Encoding",
                    "Upgrade",
                    "Via"
                ].map(function(e) {
                    return e.toLowerCase();
                }));
                function P(e, t) {
                    return I.apply(this, arguments);
                }
                function I() {
                    return (I = (0, u.default)(a.default.mark(function e(t, r) {
                        var n, i, o, s, u, c, f, d, l;
                        return a.default.wrap(function(e) {
                            for(;;)switch(e.prev = e.next){
                                case 0:
                                    for(u in n = v(v({}, k), r), i = new Headers, "json" === n.type && i.set("Content-Type", "application/json"), (o = new URL(t)).username && (s = btoa("".concat(o.username, ":").concat(o.password)), i.set("Authorization", "Basic ".concat(s)), o.username = "", o.password = ""), t = "" + o, n.headers)c = u.toLowerCase(), (B.has(c) || n.cors && !O.has(c)) && i.set(u, n.headers[u]);
                                    return f = {
                                        headers: i,
                                        redirect: n.redirect ? "follow" : "manual"
                                    }, n.referrer || (f.referrerPolicy = "no-referrer"), n.cors && (f.mode = "cors"), n.data && (n.method || (f.method = "POST"), f.body = "json" === n.type ? JSON.stringify(n.data) : n.data), e.next = 13, fetch(t, f);
                                case 13:
                                    if (d = e.sent, !n.expectStatusCode || d.status === n.expectStatusCode) {
                                        e.next = 16;
                                        break;
                                    }
                                    throw new A(d.status);
                                case 16:
                                    return e.t0 = E, e.t1 = Uint8Array, e.next = 20, d.arrayBuffer();
                                case 20:
                                    if (e.t2 = e.sent, e.t3 = new e.t1(e.t2), e.t4 = n.type, l = (0, e.t0)(e.t3, e.t4), !n.full) {
                                        e.next = 26;
                                        break;
                                    }
                                    return e.abrupt("return", {
                                        headers: Object.fromEntries(d.headers.entries()),
                                        status: d.status,
                                        body: l
                                    });
                                case 26:
                                    return e.abrupt("return", l);
                                case 27:
                                case "end":
                                    return e.stop();
                            }
                        }, e);
                    }))).apply(this, arguments);
                }
                var T = !!("object" == (void 0 === i ? "undefined" : (0, s.default)(i)) && i.versions && i.versions.node && i.versions.v8);
                t.default = function(e, t) {
                    return (T ? x : P)(e, t);
                };
            },
            31962: (e, t, r)=>{
                "use strict";
                var n = r(31734), i = r(82202);
                function o(e) {
                    this.rand = e || new i.Rand;
                }
                e.exports = o, o.create = function(e) {
                    return new o(e);
                }, o.prototype._randbelow = function(e) {
                    var t = e.bitLength(), r = Math.ceil(t / 8);
                    do var i = new n(this.rand.generate(r));
                    while (i.cmp(e) >= 0);
                    return i;
                }, o.prototype._randrange = function(e, t) {
                    var r = t.sub(e);
                    return e.add(this._randbelow(r));
                }, o.prototype.test = function(e, t, r) {
                    var i = e.bitLength(), o = n.mont(e), a = new n(1).toRed(o);
                    t || (t = Math.max(1, i / 48 | 0));
                    for(var s = e.subn(1), u = 0; !s.testn(u); u++);
                    for(var c = e.shrn(u), f = s.toRed(o); t > 0; t--){
                        var d = this._randrange(new n(2), s);
                        r && r(d);
                        var l = d.toRed(o).redPow(c);
                        if (0 !== l.cmp(a) && 0 !== l.cmp(f)) {
                            for(var h = 1; h < u; h++){
                                if (0 === (l = l.redSqr()).cmp(a)) return !1;
                                if (0 === l.cmp(f)) break;
                            }
                            if (h === u) return !1;
                        }
                    }
                    return !0;
                }, o.prototype.getDivisor = function(e, t) {
                    var r = e.bitLength(), i = n.mont(e), o = new n(1).toRed(i);
                    t || (t = Math.max(1, r / 48 | 0));
                    for(var a = e.subn(1), s = 0; !a.testn(s); s++);
                    for(var u = e.shrn(s), c = a.toRed(i); t > 0; t--){
                        var f = this._randrange(new n(2), a), d = e.gcd(f);
                        if (0 !== d.cmpn(1)) return d;
                        var l = f.toRed(i).redPow(u);
                        if (0 !== l.cmp(o) && 0 !== l.cmp(c)) {
                            for(var h = 1; h < s; h++){
                                if (0 === (l = l.redSqr()).cmp(o)) return l.fromRed().subn(1).gcd(e);
                                if (0 === l.cmp(c)) break;
                            }
                            if (h === s) return (l = l.redSqr()).fromRed().subn(1).gcd(e);
                        }
                    }
                    return !1;
                };
            },
            94504: (e)=>{
                "use strict";
                function t(e, t) {
                    if (!e) throw new Error(t || "Assertion failed");
                }
                e.exports = t, t.equal = function(e, t, r) {
                    if (e != t) throw new Error(r || "Assertion failed: " + e + " != " + t);
                };
            },
            96580: (e, t)=>{
                "use strict";
                var r = t;
                function n(e) {
                    return 1 === e.length ? "0" + e : e;
                }
                function i(e) {
                    for(var t = "", r = 0; r < e.length; r++)t += n(e[r].toString(16));
                    return t;
                }
                r.toArray = function(e, t) {
                    if (Array.isArray(e)) return e.slice();
                    if (!e) return [];
                    var r = [];
                    if ("string" != typeof e) {
                        for(var n = 0; n < e.length; n++)r[n] = 0 | e[n];
                        return r;
                    }
                    if ("hex" === t) for((e = e.replace(/[^a-z0-9]+/gi, "")).length % 2 != 0 && (e = "0" + e), n = 0; n < e.length; n += 2)r.push(parseInt(e[n] + e[n + 1], 16));
                    else for(n = 0; n < e.length; n++){
                        var i = e.charCodeAt(n), o = i >> 8, a = 255 & i;
                        o ? r.push(o, a) : r.push(a);
                    }
                    return r;
                }, r.zero2 = n, r.toHex = i, r.encode = function(e, t) {
                    return "hex" === t ? i(e) : e;
                };
            },
            36565: (e, t, r)=>{
                "use strict";
                var n = r(28847), i = n(r(69721)), o = n(r(58985)), a = function() {
                    function e(t, r, n, o) {
                        (0, i.default)(this, e), this.name = t, this.code = r, this.alphabet = o, n && o && (this.engine = n(o));
                    }
                    return (0, o.default)(e, [
                        {
                            key: "encode",
                            value: function(e) {
                                return this.engine.encode(e);
                            }
                        },
                        {
                            key: "decode",
                            value: function(e) {
                                return this.engine.decode(e);
                            }
                        },
                        {
                            key: "isImplemented",
                            value: function() {
                                return this.engine;
                            }
                        }
                    ]), e;
                }();
                e.exports = a;
            },
            52642: (e, t, r)=>{
                "use strict";
                function n(e, t) {
                    (null == t || t > e.length) && (t = e.length);
                    for(var r = 0, n = new Array(t); r < t; r++)n[r] = e[r];
                    return n;
                }
                var i = r(29033).Buffer;
                e.exports = function(e) {
                    return {
                        encode: function(e) {
                            return "string" == typeof e ? i.from(e).toString("hex") : e.toString("hex");
                        },
                        decode: function(t) {
                            var r, o = function(e, t) {
                                var r = "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
                                if (!r) {
                                    if (Array.isArray(e) || (r = function(e, t) {
                                        if (e) {
                                            if ("string" == typeof e) return n(e, t);
                                            var r = Object.prototype.toString.call(e).slice(8, -1);
                                            return "Object" === r && e.constructor && (r = e.constructor.name), "Map" === r || "Set" === r ? Array.from(e) : "Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? n(e, t) : void 0;
                                        }
                                    }(e)) || t && e && "number" == typeof e.length) {
                                        r && (e = r);
                                        var i = 0, o = function() {};
                                        return {
                                            s: o,
                                            n: function() {
                                                return i >= e.length ? {
                                                    done: !0
                                                } : {
                                                    done: !1,
                                                    value: e[i++]
                                                };
                                            },
                                            e: function(e) {
                                                throw e;
                                            },
                                            f: o
                                        };
                                    }
                                    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                                }
                                var a, s = !0, u = !1;
                                return {
                                    s: function() {
                                        r = r.call(e);
                                    },
                                    n: function() {
                                        var e = r.next();
                                        return s = e.done, e;
                                    },
                                    e: function(e) {
                                        u = !0, a = e;
                                    },
                                    f: function() {
                                        try {
                                            s || null == r.return || r.return();
                                        } finally{
                                            if (u) throw a;
                                        }
                                    }
                                };
                            }(t);
                            try {
                                for(o.s(); !(r = o.n()).done;){
                                    var a = r.value;
                                    if (e.indexOf(a) < 0) throw new Error("invalid base16 character");
                                }
                            } catch (e) {
                                o.e(e);
                            } finally{
                                o.f();
                            }
                            return i.from(t, "hex");
                        }
                    };
                };
            },
            96494: (e)=>{
                "use strict";
                function t(e, t) {
                    (null == t || t > e.length) && (t = e.length);
                    for(var r = 0, n = new Array(t); r < t; r++)n[r] = e[r];
                    return n;
                }
                e.exports = function(e) {
                    return {
                        encode: function(t) {
                            return function(e, t) {
                                var r = e.byteLength, n = new Uint8Array(e), i = t.indexOf("=") === t.length - 1;
                                i && (t = t.substring(0, t.length - 1));
                                for(var o = 0, a = 0, s = "", u = 0; u < r; u++)for(a = a << 8 | n[u], o += 8; o >= 5;)s += t[a >>> o - 5 & 31], o -= 5;
                                if (o > 0 && (s += t[a << 5 - o & 31]), i) for(; s.length % 8 != 0;)s += "=";
                                return s;
                            }("string" == typeof t ? Uint8Array.from(t) : t, e);
                        },
                        decode: function(r) {
                            var n, i = function(e, r) {
                                var n = "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
                                if (!n) {
                                    if (Array.isArray(e) || (n = function(e, r) {
                                        if (e) {
                                            if ("string" == typeof e) return t(e, r);
                                            var n = Object.prototype.toString.call(e).slice(8, -1);
                                            return "Object" === n && e.constructor && (n = e.constructor.name), "Map" === n || "Set" === n ? Array.from(e) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? t(e, r) : void 0;
                                        }
                                    }(e)) || r && e && "number" == typeof e.length) {
                                        n && (e = n);
                                        var i = 0, o = function() {};
                                        return {
                                            s: o,
                                            n: function() {
                                                return i >= e.length ? {
                                                    done: !0
                                                } : {
                                                    done: !1,
                                                    value: e[i++]
                                                };
                                            },
                                            e: function(e) {
                                                throw e;
                                            },
                                            f: o
                                        };
                                    }
                                    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                                }
                                var a, s = !0, u = !1;
                                return {
                                    s: function() {
                                        n = n.call(e);
                                    },
                                    n: function() {
                                        var e = n.next();
                                        return s = e.done, e;
                                    },
                                    e: function(e) {
                                        u = !0, a = e;
                                    },
                                    f: function() {
                                        try {
                                            s || null == n.return || n.return();
                                        } finally{
                                            if (u) throw a;
                                        }
                                    }
                                };
                            }(r);
                            try {
                                for(i.s(); !(n = i.n()).done;){
                                    var o = n.value;
                                    if (e.indexOf(o) < 0) throw new Error("invalid base32 character");
                                }
                            } catch (e) {
                                i.e(e);
                            } finally{
                                i.f();
                            }
                            return function(e, t) {
                                for(var r = (e = e.replace(new RegExp("=", "g"), "")).length, n = 0, i = 0, o = 0, a = new Uint8Array(5 * r / 8 | 0), s = 0; s < r; s++)i = i << 5 | t.indexOf(e[s]), (n += 5) >= 8 && (a[o++] = i >>> n - 8 & 255, n -= 8);
                                return a.buffer;
                            }(r, e);
                        }
                    };
                };
            },
            76627: (e, t, r)=>{
                "use strict";
                function n(e, t) {
                    (null == t || t > e.length) && (t = e.length);
                    for(var r = 0, n = new Array(t); r < t; r++)n[r] = e[r];
                    return n;
                }
                var i = r(29033).Buffer;
                e.exports = function(e) {
                    var t = e.indexOf("=") > -1, r = e.indexOf("-") > -1 && e.indexOf("_") > -1;
                    return {
                        encode: function(e) {
                            var n = "";
                            n = "string" == typeof e ? i.from(e).toString("base64") : e.toString("base64"), r && (n = n.replace(/\+/g, "-").replace(/\//g, "_"));
                            var o = n.indexOf("=");
                            return o > 0 && !t && (n = n.substring(0, o)), n;
                        },
                        decode: function(t) {
                            var r, o = function(e, t) {
                                var r = "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
                                if (!r) {
                                    if (Array.isArray(e) || (r = function(e, t) {
                                        if (e) {
                                            if ("string" == typeof e) return n(e, t);
                                            var r = Object.prototype.toString.call(e).slice(8, -1);
                                            return "Object" === r && e.constructor && (r = e.constructor.name), "Map" === r || "Set" === r ? Array.from(e) : "Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? n(e, t) : void 0;
                                        }
                                    }(e)) || t && e && "number" == typeof e.length) {
                                        r && (e = r);
                                        var i = 0, o = function() {};
                                        return {
                                            s: o,
                                            n: function() {
                                                return i >= e.length ? {
                                                    done: !0
                                                } : {
                                                    done: !1,
                                                    value: e[i++]
                                                };
                                            },
                                            e: function(e) {
                                                throw e;
                                            },
                                            f: o
                                        };
                                    }
                                    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                                }
                                var a, s = !0, u = !1;
                                return {
                                    s: function() {
                                        r = r.call(e);
                                    },
                                    n: function() {
                                        var e = r.next();
                                        return s = e.done, e;
                                    },
                                    e: function(e) {
                                        u = !0, a = e;
                                    },
                                    f: function() {
                                        try {
                                            s || null == r.return || r.return();
                                        } finally{
                                            if (u) throw a;
                                        }
                                    }
                                };
                            }(t);
                            try {
                                for(o.s(); !(r = o.n()).done;){
                                    var a = r.value;
                                    if (e.indexOf(a) < 0) throw new Error("invalid base64 character");
                                }
                            } catch (e) {
                                o.e(e);
                            } finally{
                                o.f();
                            }
                            return i.from(t, "base64");
                        }
                    };
                };
            },
            7905: (e, t, r)=>{
                "use strict";
                var n = r(36565), i = r(27548), o = r(52642), a = r(96494), s = r(76627), u = [
                    [
                        "base1",
                        "1",
                        "",
                        "1"
                    ],
                    [
                        "base2",
                        "0",
                        i,
                        "01"
                    ],
                    [
                        "base8",
                        "7",
                        i,
                        "01234567"
                    ],
                    [
                        "base10",
                        "9",
                        i,
                        "0123456789"
                    ],
                    [
                        "base16",
                        "f",
                        o,
                        "0123456789abcdef"
                    ],
                    [
                        "base32",
                        "b",
                        a,
                        "abcdefghijklmnopqrstuvwxyz234567"
                    ],
                    [
                        "base32pad",
                        "c",
                        a,
                        "abcdefghijklmnopqrstuvwxyz234567="
                    ],
                    [
                        "base32hex",
                        "v",
                        a,
                        "0123456789abcdefghijklmnopqrstuv"
                    ],
                    [
                        "base32hexpad",
                        "t",
                        a,
                        "0123456789abcdefghijklmnopqrstuv="
                    ],
                    [
                        "base32z",
                        "h",
                        a,
                        "ybndrfg8ejkmcpqxot1uwisza345h769"
                    ],
                    [
                        "base58flickr",
                        "Z",
                        i,
                        "123456789abcdefghijkmnopqrstuvwxyzABCDEFGHJKLMNPQRSTUVWXYZ"
                    ],
                    [
                        "base58btc",
                        "z",
                        i,
                        "123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz"
                    ],
                    [
                        "base64",
                        "m",
                        s,
                        "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/"
                    ],
                    [
                        "base64pad",
                        "M",
                        s,
                        "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/="
                    ],
                    [
                        "base64url",
                        "u",
                        s,
                        "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_"
                    ],
                    [
                        "base64urlpad",
                        "U",
                        s,
                        "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_="
                    ]
                ], c = u.reduce(function(e, t) {
                    return e[t[0]] = new n(t[0], t[1], t[2], t[3]), e;
                }, {}), f = u.reduce(function(e, t) {
                    return e[t[1]] = c[t[0]], e;
                }, {});
                e.exports = {
                    names: c,
                    codes: f
                };
            },
            6086: (e, t, r)=>{
                "use strict";
                var n = r(29033).Buffer, i = r(7905);
                (t = e.exports = a).encode = function(e, t) {
                    var r = s(e);
                    return a(r.name, n.from(r.encode(t)));
                }, t.decode = function(e) {
                    n.isBuffer(e) && (e = e.toString());
                    var t = e.substring(0, 1);
                    "string" == typeof (e = e.substring(1, e.length)) && (e = n.from(e));
                    var r = s(t);
                    return n.from(r.decode(e.toString()));
                }, t.isEncoded = function(e) {
                    if (n.isBuffer(e) && (e = e.toString()), "[object String]" !== Object.prototype.toString.call(e)) return !1;
                    var t = e.substring(0, 1);
                    try {
                        return s(t).name;
                    } catch (e) {
                        return !1;
                    }
                }, t.names = Object.freeze(Object.keys(i.names)), t.codes = Object.freeze(Object.keys(i.codes));
                var o = new Error("Unsupported encoding");
                function a(e, t) {
                    if (!t) throw new Error("requires an encoded buffer");
                    var r = s(e), i = n.from(r.code);
                    return function(e, t) {
                        s(e).decode(t.toString());
                    }(r.name, t), n.concat([
                        i,
                        t
                    ]);
                }
                function s(e) {
                    var t;
                    if (i.names[e]) t = i.names[e];
                    else {
                        if (!i.codes[e]) throw o;
                        t = i.codes[e];
                    }
                    if (!t.isImplemented()) throw new Error("Base " + e + " is not implemented yet");
                    return t;
                }
            },
            54093: (e, t, r)=>{
                "use strict";
                for(var n = r(28847)(r(74519)), i = r(24070), o = {}, a = 0, s = Object.entries(i); a < s.length; a++){
                    var u = (0, n.default)(s[a], 2), c = u[0], f = u[1];
                    o[c.toUpperCase().replace(/-/g, "_")] = f;
                }
                e.exports = Object.freeze(o);
            },
            69206: (e, t, r)=>{
                "use strict";
                var n = r(29033).Buffer, i = r(26657), o = r(7054), a = r(86002), s = r(55576);
                (t = e.exports).addPrefix = function(e, t) {
                    var r;
                    if (n.isBuffer(e)) r = s.varintBufferEncode(e);
                    else {
                        if (!a[e]) throw new Error("multicodec not recognized");
                        r = a[e];
                    }
                    return n.concat([
                        r,
                        t
                    ]);
                }, t.rmPrefix = function(e) {
                    return i.decode(e), e.slice(i.decode.bytes);
                }, t.getCodec = function(e) {
                    var t = i.decode(e), r = o.get(t);
                    if (void 0 === r) throw new Error("Code ".concat(t, " not found"));
                    return r;
                }, t.getName = function(e) {
                    return o.get(e);
                }, t.getNumber = function(e) {
                    var t = a[e];
                    if (void 0 === t) throw new Error("Codec `" + e + "` not found");
                    return s.varintBufferDecode(t)[0];
                }, t.getCode = function(e) {
                    return i.decode(e);
                }, t.getCodeVarint = function(e) {
                    var t = a[e];
                    if (void 0 === t) throw new Error("Codec `" + e + "` not found");
                    return t;
                }, t.getVarint = function(e) {
                    return i.encode(e);
                };
                var u = r(54093);
                Object.assign(t, u), t.print = r(11032);
            },
            7054: (e, t, r)=>{
                "use strict";
                var n = r(24070), i = new Map;
                for(var o in n){
                    var a = n[o];
                    i.set(a, o);
                }
                e.exports = Object.freeze(i);
            },
            11032: (e, t, r)=>{
                "use strict";
                for(var n = r(28847)(r(74519)), i = r(24070), o = {}, a = 0, s = Object.entries(i); a < s.length; a++){
                    var u = (0, n.default)(s[a], 2), c = u[0], f = u[1];
                    void 0 === o[f] && (o[f] = c);
                }
                e.exports = Object.freeze(o);
            },
            55576: (e, t, r)=>{
                "use strict";
                var n = r(29033).Buffer, i = r(26657);
                function o(e) {
                    return parseInt(e.toString("hex"), 16);
                }
                function a(e) {
                    var t = e.toString(16);
                    return t.length % 2 == 1 && (t = "0" + t), n.from(t, "hex");
                }
                e.exports = {
                    numberToBuffer: a,
                    bufferToNumber: o,
                    varintBufferEncode: function(e) {
                        return n.from(i.encode(o(e)));
                    },
                    varintBufferDecode: function(e) {
                        return a(i.decode(e));
                    },
                    varintEncode: function(e) {
                        return n.from(i.encode(e));
                    }
                };
            },
            86002: (e, t, r)=>{
                "use strict";
                var n = r(24070), i = r(55576).varintEncode, o = {};
                for(var a in n){
                    var s = n[a];
                    o[a] = i(s);
                }
                e.exports = Object.freeze(o);
            },
            71786: (e, t, r)=>{
                "use strict";
                var n = r(28847), i = n(r(69721)), o = n(r(58985)), a = function() {
                    function e(t, r, n, o) {
                        (0, i.default)(this, e), this.name = t, this.code = r, this.alphabet = o, n && o && (this.engine = n(o));
                    }
                    return (0, o.default)(e, [
                        {
                            key: "encode",
                            value: function(e) {
                                return this.engine.encode(e);
                            }
                        },
                        {
                            key: "decode",
                            value: function(e) {
                                return this.engine.decode(e);
                            }
                        },
                        {
                            key: "isImplemented",
                            value: function() {
                                return this.engine;
                            }
                        }
                    ]), e;
                }();
                e.exports = a;
            },
            37739: (e, t, r)=>{
                "use strict";
                function n(e, t) {
                    (null == t || t > e.length) && (t = e.length);
                    for(var r = 0, n = new Array(t); r < t; r++)n[r] = e[r];
                    return n;
                }
                var i = r(29033).Buffer;
                e.exports = function(e) {
                    return {
                        encode: function(e) {
                            return "string" == typeof e ? i.from(e).toString("hex") : e.toString("hex");
                        },
                        decode: function(t) {
                            var r, o = function(e, t) {
                                var r = "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
                                if (!r) {
                                    if (Array.isArray(e) || (r = function(e, t) {
                                        if (e) {
                                            if ("string" == typeof e) return n(e, t);
                                            var r = Object.prototype.toString.call(e).slice(8, -1);
                                            return "Object" === r && e.constructor && (r = e.constructor.name), "Map" === r || "Set" === r ? Array.from(e) : "Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? n(e, t) : void 0;
                                        }
                                    }(e)) || t && e && "number" == typeof e.length) {
                                        r && (e = r);
                                        var i = 0, o = function() {};
                                        return {
                                            s: o,
                                            n: function() {
                                                return i >= e.length ? {
                                                    done: !0
                                                } : {
                                                    done: !1,
                                                    value: e[i++]
                                                };
                                            },
                                            e: function(e) {
                                                throw e;
                                            },
                                            f: o
                                        };
                                    }
                                    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                                }
                                var a, s = !0, u = !1;
                                return {
                                    s: function() {
                                        r = r.call(e);
                                    },
                                    n: function() {
                                        var e = r.next();
                                        return s = e.done, e;
                                    },
                                    e: function(e) {
                                        u = !0, a = e;
                                    },
                                    f: function() {
                                        try {
                                            s || null == r.return || r.return();
                                        } finally{
                                            if (u) throw a;
                                        }
                                    }
                                };
                            }(t);
                            try {
                                for(o.s(); !(r = o.n()).done;){
                                    var a = r.value;
                                    if (e.indexOf(a) < 0) throw new Error("invalid base16 character");
                                }
                            } catch (e) {
                                o.e(e);
                            } finally{
                                o.f();
                            }
                            return i.from(t, "hex");
                        }
                    };
                };
            },
            70976: (e)=>{
                "use strict";
                function t(e, t) {
                    (null == t || t > e.length) && (t = e.length);
                    for(var r = 0, n = new Array(t); r < t; r++)n[r] = e[r];
                    return n;
                }
                e.exports = function(e) {
                    return {
                        encode: function(t) {
                            return function(e, t) {
                                var r = e.byteLength, n = new Uint8Array(e), i = t.indexOf("=") === t.length - 1;
                                i && (t = t.substring(0, t.length - 1));
                                for(var o = 0, a = 0, s = "", u = 0; u < r; u++)for(a = a << 8 | n[u], o += 8; o >= 5;)s += t[a >>> o - 5 & 31], o -= 5;
                                if (o > 0 && (s += t[a << 5 - o & 31]), i) for(; s.length % 8 != 0;)s += "=";
                                return s;
                            }("string" == typeof t ? Uint8Array.from(t) : t, e);
                        },
                        decode: function(r) {
                            var n, i = function(e, r) {
                                var n = "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
                                if (!n) {
                                    if (Array.isArray(e) || (n = function(e, r) {
                                        if (e) {
                                            if ("string" == typeof e) return t(e, r);
                                            var n = Object.prototype.toString.call(e).slice(8, -1);
                                            return "Object" === n && e.constructor && (n = e.constructor.name), "Map" === n || "Set" === n ? Array.from(e) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? t(e, r) : void 0;
                                        }
                                    }(e)) || r && e && "number" == typeof e.length) {
                                        n && (e = n);
                                        var i = 0, o = function() {};
                                        return {
                                            s: o,
                                            n: function() {
                                                return i >= e.length ? {
                                                    done: !0
                                                } : {
                                                    done: !1,
                                                    value: e[i++]
                                                };
                                            },
                                            e: function(e) {
                                                throw e;
                                            },
                                            f: o
                                        };
                                    }
                                    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                                }
                                var a, s = !0, u = !1;
                                return {
                                    s: function() {
                                        n = n.call(e);
                                    },
                                    n: function() {
                                        var e = n.next();
                                        return s = e.done, e;
                                    },
                                    e: function(e) {
                                        u = !0, a = e;
                                    },
                                    f: function() {
                                        try {
                                            s || null == n.return || n.return();
                                        } finally{
                                            if (u) throw a;
                                        }
                                    }
                                };
                            }(r);
                            try {
                                for(i.s(); !(n = i.n()).done;){
                                    var o = n.value;
                                    if (e.indexOf(o) < 0) throw new Error("invalid base32 character");
                                }
                            } catch (e) {
                                i.e(e);
                            } finally{
                                i.f();
                            }
                            return function(e, t) {
                                for(var r = (e = e.replace(new RegExp("=", "g"), "")).length, n = 0, i = 0, o = 0, a = new Uint8Array(5 * r / 8 | 0), s = 0; s < r; s++)i = i << 5 | t.indexOf(e[s]), (n += 5) >= 8 && (a[o++] = i >>> n - 8 & 255, n -= 8);
                                return a.buffer;
                            }(r, e);
                        }
                    };
                };
            },
            88504: (e, t, r)=>{
                "use strict";
                function n(e, t) {
                    (null == t || t > e.length) && (t = e.length);
                    for(var r = 0, n = new Array(t); r < t; r++)n[r] = e[r];
                    return n;
                }
                var i = r(29033).Buffer;
                e.exports = function(e) {
                    var t = e.indexOf("=") > -1, r = e.indexOf("-") > -1 && e.indexOf("_") > -1;
                    return {
                        encode: function(e) {
                            var n = "";
                            n = "string" == typeof e ? i.from(e).toString("base64") : e.toString("base64"), r && (n = n.replace(/\+/g, "-").replace(/\//g, "_"));
                            var o = n.indexOf("=");
                            return o > 0 && !t && (n = n.substring(0, o)), n;
                        },
                        decode: function(t) {
                            var r, o = function(e, t) {
                                var r = "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
                                if (!r) {
                                    if (Array.isArray(e) || (r = function(e, t) {
                                        if (e) {
                                            if ("string" == typeof e) return n(e, t);
                                            var r = Object.prototype.toString.call(e).slice(8, -1);
                                            return "Object" === r && e.constructor && (r = e.constructor.name), "Map" === r || "Set" === r ? Array.from(e) : "Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? n(e, t) : void 0;
                                        }
                                    }(e)) || t && e && "number" == typeof e.length) {
                                        r && (e = r);
                                        var i = 0, o = function() {};
                                        return {
                                            s: o,
                                            n: function() {
                                                return i >= e.length ? {
                                                    done: !0
                                                } : {
                                                    done: !1,
                                                    value: e[i++]
                                                };
                                            },
                                            e: function(e) {
                                                throw e;
                                            },
                                            f: o
                                        };
                                    }
                                    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                                }
                                var a, s = !0, u = !1;
                                return {
                                    s: function() {
                                        r = r.call(e);
                                    },
                                    n: function() {
                                        var e = r.next();
                                        return s = e.done, e;
                                    },
                                    e: function(e) {
                                        u = !0, a = e;
                                    },
                                    f: function() {
                                        try {
                                            s || null == r.return || r.return();
                                        } finally{
                                            if (u) throw a;
                                        }
                                    }
                                };
                            }(t);
                            try {
                                for(o.s(); !(r = o.n()).done;){
                                    var a = r.value;
                                    if (e.indexOf(a) < 0) throw new Error("invalid base64 character");
                                }
                            } catch (e) {
                                o.e(e);
                            } finally{
                                o.f();
                            }
                            return i.from(t, "base64");
                        }
                    };
                };
            },
            12263: (e, t, r)=>{
                "use strict";
                var n = r(71786), i = r(27548), o = r(37739), a = r(70976), s = r(88504), u = [
                    [
                        "base1",
                        "1",
                        "",
                        "1"
                    ],
                    [
                        "base2",
                        "0",
                        i,
                        "01"
                    ],
                    [
                        "base8",
                        "7",
                        i,
                        "01234567"
                    ],
                    [
                        "base10",
                        "9",
                        i,
                        "0123456789"
                    ],
                    [
                        "base16",
                        "f",
                        o,
                        "0123456789abcdef"
                    ],
                    [
                        "base32",
                        "b",
                        a,
                        "abcdefghijklmnopqrstuvwxyz234567"
                    ],
                    [
                        "base32pad",
                        "c",
                        a,
                        "abcdefghijklmnopqrstuvwxyz234567="
                    ],
                    [
                        "base32hex",
                        "v",
                        a,
                        "0123456789abcdefghijklmnopqrstuv"
                    ],
                    [
                        "base32hexpad",
                        "t",
                        a,
                        "0123456789abcdefghijklmnopqrstuv="
                    ],
                    [
                        "base32z",
                        "h",
                        a,
                        "ybndrfg8ejkmcpqxot1uwisza345h769"
                    ],
                    [
                        "base58flickr",
                        "Z",
                        i,
                        "123456789abcdefghijkmnopqrstuvwxyzABCDEFGHJKLMNPQRSTUVWXYZ"
                    ],
                    [
                        "base58btc",
                        "z",
                        i,
                        "123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz"
                    ],
                    [
                        "base64",
                        "m",
                        s,
                        "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/"
                    ],
                    [
                        "base64pad",
                        "M",
                        s,
                        "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/="
                    ],
                    [
                        "base64url",
                        "u",
                        s,
                        "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_"
                    ],
                    [
                        "base64urlpad",
                        "U",
                        s,
                        "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_="
                    ]
                ], c = u.reduce(function(e, t) {
                    return e[t[0]] = new n(t[0], t[1], t[2], t[3]), e;
                }, {}), f = u.reduce(function(e, t) {
                    return e[t[1]] = c[t[0]], e;
                }, {});
                e.exports = {
                    names: c,
                    codes: f
                };
            },
            2592: (e, t, r)=>{
                "use strict";
                var n = r(29033).Buffer, i = r(12263);
                function o(e, t) {
                    if (!t) throw new Error("requires an encoded buffer");
                    var r = a(e), i = n.from(r.code);
                    return function(e, t) {
                        a(e).decode(t.toString());
                    }(r.name, t), n.concat([
                        i,
                        t
                    ]);
                }
                function a(e) {
                    var t;
                    if (i.names[e]) t = i.names[e];
                    else {
                        if (!i.codes[e]) throw new Error("Unsupported encoding");
                        t = i.codes[e];
                    }
                    if (!t.isImplemented()) throw new Error("Base " + e + " is not implemented yet");
                    return t;
                }
                (t = e.exports = o).encode = function(e, t) {
                    var r = a(e);
                    return o(r.name, n.from(r.encode(t)));
                }, t.decode = function(e) {
                    n.isBuffer(e) && (e = e.toString());
                    var t = e.substring(0, 1);
                    "string" == typeof (e = e.substring(1, e.length)) && (e = n.from(e));
                    var r = a(t);
                    return n.from(r.decode(e.toString()));
                }, t.isEncoded = function(e) {
                    if (n.isBuffer(e) && (e = e.toString()), "[object String]" !== Object.prototype.toString.call(e)) return !1;
                    var t = e.substring(0, 1);
                    try {
                        return a(t).name;
                    } catch (e) {
                        return !1;
                    }
                }, t.names = Object.freeze(Object.keys(i.names)), t.codes = Object.freeze(Object.keys(i.codes));
            },
            81269: (e, t)=>{
                "use strict";
                t.names = Object.freeze({
                    identity: 0,
                    sha1: 17,
                    "sha2-256": 18,
                    "sha2-512": 19,
                    "dbl-sha2-256": 86,
                    "sha3-224": 23,
                    "sha3-256": 22,
                    "sha3-384": 21,
                    "sha3-512": 20,
                    "shake-128": 24,
                    "shake-256": 25,
                    "keccak-224": 26,
                    "keccak-256": 27,
                    "keccak-384": 28,
                    "keccak-512": 29,
                    "murmur3-128": 34,
                    "murmur3-32": 35,
                    md4: 212,
                    md5: 213,
                    "blake2b-8": 45569,
                    "blake2b-16": 45570,
                    "blake2b-24": 45571,
                    "blake2b-32": 45572,
                    "blake2b-40": 45573,
                    "blake2b-48": 45574,
                    "blake2b-56": 45575,
                    "blake2b-64": 45576,
                    "blake2b-72": 45577,
                    "blake2b-80": 45578,
                    "blake2b-88": 45579,
                    "blake2b-96": 45580,
                    "blake2b-104": 45581,
                    "blake2b-112": 45582,
                    "blake2b-120": 45583,
                    "blake2b-128": 45584,
                    "blake2b-136": 45585,
                    "blake2b-144": 45586,
                    "blake2b-152": 45587,
                    "blake2b-160": 45588,
                    "blake2b-168": 45589,
                    "blake2b-176": 45590,
                    "blake2b-184": 45591,
                    "blake2b-192": 45592,
                    "blake2b-200": 45593,
                    "blake2b-208": 45594,
                    "blake2b-216": 45595,
                    "blake2b-224": 45596,
                    "blake2b-232": 45597,
                    "blake2b-240": 45598,
                    "blake2b-248": 45599,
                    "blake2b-256": 45600,
                    "blake2b-264": 45601,
                    "blake2b-272": 45602,
                    "blake2b-280": 45603,
                    "blake2b-288": 45604,
                    "blake2b-296": 45605,
                    "blake2b-304": 45606,
                    "blake2b-312": 45607,
                    "blake2b-320": 45608,
                    "blake2b-328": 45609,
                    "blake2b-336": 45610,
                    "blake2b-344": 45611,
                    "blake2b-352": 45612,
                    "blake2b-360": 45613,
                    "blake2b-368": 45614,
                    "blake2b-376": 45615,
                    "blake2b-384": 45616,
                    "blake2b-392": 45617,
                    "blake2b-400": 45618,
                    "blake2b-408": 45619,
                    "blake2b-416": 45620,
                    "blake2b-424": 45621,
                    "blake2b-432": 45622,
                    "blake2b-440": 45623,
                    "blake2b-448": 45624,
                    "blake2b-456": 45625,
                    "blake2b-464": 45626,
                    "blake2b-472": 45627,
                    "blake2b-480": 45628,
                    "blake2b-488": 45629,
                    "blake2b-496": 45630,
                    "blake2b-504": 45631,
                    "blake2b-512": 45632,
                    "blake2s-8": 45633,
                    "blake2s-16": 45634,
                    "blake2s-24": 45635,
                    "blake2s-32": 45636,
                    "blake2s-40": 45637,
                    "blake2s-48": 45638,
                    "blake2s-56": 45639,
                    "blake2s-64": 45640,
                    "blake2s-72": 45641,
                    "blake2s-80": 45642,
                    "blake2s-88": 45643,
                    "blake2s-96": 45644,
                    "blake2s-104": 45645,
                    "blake2s-112": 45646,
                    "blake2s-120": 45647,
                    "blake2s-128": 45648,
                    "blake2s-136": 45649,
                    "blake2s-144": 45650,
                    "blake2s-152": 45651,
                    "blake2s-160": 45652,
                    "blake2s-168": 45653,
                    "blake2s-176": 45654,
                    "blake2s-184": 45655,
                    "blake2s-192": 45656,
                    "blake2s-200": 45657,
                    "blake2s-208": 45658,
                    "blake2s-216": 45659,
                    "blake2s-224": 45660,
                    "blake2s-232": 45661,
                    "blake2s-240": 45662,
                    "blake2s-248": 45663,
                    "blake2s-256": 45664,
                    "Skein256-8": 45825,
                    "Skein256-16": 45826,
                    "Skein256-24": 45827,
                    "Skein256-32": 45828,
                    "Skein256-40": 45829,
                    "Skein256-48": 45830,
                    "Skein256-56": 45831,
                    "Skein256-64": 45832,
                    "Skein256-72": 45833,
                    "Skein256-80": 45834,
                    "Skein256-88": 45835,
                    "Skein256-96": 45836,
                    "Skein256-104": 45837,
                    "Skein256-112": 45838,
                    "Skein256-120": 45839,
                    "Skein256-128": 45840,
                    "Skein256-136": 45841,
                    "Skein256-144": 45842,
                    "Skein256-152": 45843,
                    "Skein256-160": 45844,
                    "Skein256-168": 45845,
                    "Skein256-176": 45846,
                    "Skein256-184": 45847,
                    "Skein256-192": 45848,
                    "Skein256-200": 45849,
                    "Skein256-208": 45850,
                    "Skein256-216": 45851,
                    "Skein256-224": 45852,
                    "Skein256-232": 45853,
                    "Skein256-240": 45854,
                    "Skein256-248": 45855,
                    "Skein256-256": 45856,
                    "Skein512-8": 45857,
                    "Skein512-16": 45858,
                    "Skein512-24": 45859,
                    "Skein512-32": 45860,
                    "Skein512-40": 45861,
                    "Skein512-48": 45862,
                    "Skein512-56": 45863,
                    "Skein512-64": 45864,
                    "Skein512-72": 45865,
                    "Skein512-80": 45866,
                    "Skein512-88": 45867,
                    "Skein512-96": 45868,
                    "Skein512-104": 45869,
                    "Skein512-112": 45870,
                    "Skein512-120": 45871,
                    "Skein512-128": 45872,
                    "Skein512-136": 45873,
                    "Skein512-144": 45874,
                    "Skein512-152": 45875,
                    "Skein512-160": 45876,
                    "Skein512-168": 45877,
                    "Skein512-176": 45878,
                    "Skein512-184": 45879,
                    "Skein512-192": 45880,
                    "Skein512-200": 45881,
                    "Skein512-208": 45882,
                    "Skein512-216": 45883,
                    "Skein512-224": 45884,
                    "Skein512-232": 45885,
                    "Skein512-240": 45886,
                    "Skein512-248": 45887,
                    "Skein512-256": 45888,
                    "Skein512-264": 45889,
                    "Skein512-272": 45890,
                    "Skein512-280": 45891,
                    "Skein512-288": 45892,
                    "Skein512-296": 45893,
                    "Skein512-304": 45894,
                    "Skein512-312": 45895,
                    "Skein512-320": 45896,
                    "Skein512-328": 45897,
                    "Skein512-336": 45898,
                    "Skein512-344": 45899,
                    "Skein512-352": 45900,
                    "Skein512-360": 45901,
                    "Skein512-368": 45902,
                    "Skein512-376": 45903,
                    "Skein512-384": 45904,
                    "Skein512-392": 45905,
                    "Skein512-400": 45906,
                    "Skein512-408": 45907,
                    "Skein512-416": 45908,
                    "Skein512-424": 45909,
                    "Skein512-432": 45910,
                    "Skein512-440": 45911,
                    "Skein512-448": 45912,
                    "Skein512-456": 45913,
                    "Skein512-464": 45914,
                    "Skein512-472": 45915,
                    "Skein512-480": 45916,
                    "Skein512-488": 45917,
                    "Skein512-496": 45918,
                    "Skein512-504": 45919,
                    "Skein512-512": 45920,
                    "Skein1024-8": 45921,
                    "Skein1024-16": 45922,
                    "Skein1024-24": 45923,
                    "Skein1024-32": 45924,
                    "Skein1024-40": 45925,
                    "Skein1024-48": 45926,
                    "Skein1024-56": 45927,
                    "Skein1024-64": 45928,
                    "Skein1024-72": 45929,
                    "Skein1024-80": 45930,
                    "Skein1024-88": 45931,
                    "Skein1024-96": 45932,
                    "Skein1024-104": 45933,
                    "Skein1024-112": 45934,
                    "Skein1024-120": 45935,
                    "Skein1024-128": 45936,
                    "Skein1024-136": 45937,
                    "Skein1024-144": 45938,
                    "Skein1024-152": 45939,
                    "Skein1024-160": 45940,
                    "Skein1024-168": 45941,
                    "Skein1024-176": 45942,
                    "Skein1024-184": 45943,
                    "Skein1024-192": 45944,
                    "Skein1024-200": 45945,
                    "Skein1024-208": 45946,
                    "Skein1024-216": 45947,
                    "Skein1024-224": 45948,
                    "Skein1024-232": 45949,
                    "Skein1024-240": 45950,
                    "Skein1024-248": 45951,
                    "Skein1024-256": 45952,
                    "Skein1024-264": 45953,
                    "Skein1024-272": 45954,
                    "Skein1024-280": 45955,
                    "Skein1024-288": 45956,
                    "Skein1024-296": 45957,
                    "Skein1024-304": 45958,
                    "Skein1024-312": 45959,
                    "Skein1024-320": 45960,
                    "Skein1024-328": 45961,
                    "Skein1024-336": 45962,
                    "Skein1024-344": 45963,
                    "Skein1024-352": 45964,
                    "Skein1024-360": 45965,
                    "Skein1024-368": 45966,
                    "Skein1024-376": 45967,
                    "Skein1024-384": 45968,
                    "Skein1024-392": 45969,
                    "Skein1024-400": 45970,
                    "Skein1024-408": 45971,
                    "Skein1024-416": 45972,
                    "Skein1024-424": 45973,
                    "Skein1024-432": 45974,
                    "Skein1024-440": 45975,
                    "Skein1024-448": 45976,
                    "Skein1024-456": 45977,
                    "Skein1024-464": 45978,
                    "Skein1024-472": 45979,
                    "Skein1024-480": 45980,
                    "Skein1024-488": 45981,
                    "Skein1024-496": 45982,
                    "Skein1024-504": 45983,
                    "Skein1024-512": 45984,
                    "Skein1024-520": 45985,
                    "Skein1024-528": 45986,
                    "Skein1024-536": 45987,
                    "Skein1024-544": 45988,
                    "Skein1024-552": 45989,
                    "Skein1024-560": 45990,
                    "Skein1024-568": 45991,
                    "Skein1024-576": 45992,
                    "Skein1024-584": 45993,
                    "Skein1024-592": 45994,
                    "Skein1024-600": 45995,
                    "Skein1024-608": 45996,
                    "Skein1024-616": 45997,
                    "Skein1024-624": 45998,
                    "Skein1024-632": 45999,
                    "Skein1024-640": 46e3,
                    "Skein1024-648": 46001,
                    "Skein1024-656": 46002,
                    "Skein1024-664": 46003,
                    "Skein1024-672": 46004,
                    "Skein1024-680": 46005,
                    "Skein1024-688": 46006,
                    "Skein1024-696": 46007,
                    "Skein1024-704": 46008,
                    "Skein1024-712": 46009,
                    "Skein1024-720": 46010,
                    "Skein1024-728": 46011,
                    "Skein1024-736": 46012,
                    "Skein1024-744": 46013,
                    "Skein1024-752": 46014,
                    "Skein1024-760": 46015,
                    "Skein1024-768": 46016,
                    "Skein1024-776": 46017,
                    "Skein1024-784": 46018,
                    "Skein1024-792": 46019,
                    "Skein1024-800": 46020,
                    "Skein1024-808": 46021,
                    "Skein1024-816": 46022,
                    "Skein1024-824": 46023,
                    "Skein1024-832": 46024,
                    "Skein1024-840": 46025,
                    "Skein1024-848": 46026,
                    "Skein1024-856": 46027,
                    "Skein1024-864": 46028,
                    "Skein1024-872": 46029,
                    "Skein1024-880": 46030,
                    "Skein1024-888": 46031,
                    "Skein1024-896": 46032,
                    "Skein1024-904": 46033,
                    "Skein1024-912": 46034,
                    "Skein1024-920": 46035,
                    "Skein1024-928": 46036,
                    "Skein1024-936": 46037,
                    "Skein1024-944": 46038,
                    "Skein1024-952": 46039,
                    "Skein1024-960": 46040,
                    "Skein1024-968": 46041,
                    "Skein1024-976": 46042,
                    "Skein1024-984": 46043,
                    "Skein1024-992": 46044,
                    "Skein1024-1000": 46045,
                    "Skein1024-1008": 46046,
                    "Skein1024-1016": 46047,
                    "Skein1024-1024": 46048
                }), t.codes = Object.freeze({
                    0: "identity",
                    17: "sha1",
                    18: "sha2-256",
                    19: "sha2-512",
                    86: "dbl-sha2-256",
                    23: "sha3-224",
                    22: "sha3-256",
                    21: "sha3-384",
                    20: "sha3-512",
                    24: "shake-128",
                    25: "shake-256",
                    26: "keccak-224",
                    27: "keccak-256",
                    28: "keccak-384",
                    29: "keccak-512",
                    34: "murmur3-128",
                    35: "murmur3-32",
                    212: "md4",
                    213: "md5",
                    45569: "blake2b-8",
                    45570: "blake2b-16",
                    45571: "blake2b-24",
                    45572: "blake2b-32",
                    45573: "blake2b-40",
                    45574: "blake2b-48",
                    45575: "blake2b-56",
                    45576: "blake2b-64",
                    45577: "blake2b-72",
                    45578: "blake2b-80",
                    45579: "blake2b-88",
                    45580: "blake2b-96",
                    45581: "blake2b-104",
                    45582: "blake2b-112",
                    45583: "blake2b-120",
                    45584: "blake2b-128",
                    45585: "blake2b-136",
                    45586: "blake2b-144",
                    45587: "blake2b-152",
                    45588: "blake2b-160",
                    45589: "blake2b-168",
                    45590: "blake2b-176",
                    45591: "blake2b-184",
                    45592: "blake2b-192",
                    45593: "blake2b-200",
                    45594: "blake2b-208",
                    45595: "blake2b-216",
                    45596: "blake2b-224",
                    45597: "blake2b-232",
                    45598: "blake2b-240",
                    45599: "blake2b-248",
                    45600: "blake2b-256",
                    45601: "blake2b-264",
                    45602: "blake2b-272",
                    45603: "blake2b-280",
                    45604: "blake2b-288",
                    45605: "blake2b-296",
                    45606: "blake2b-304",
                    45607: "blake2b-312",
                    45608: "blake2b-320",
                    45609: "blake2b-328",
                    45610: "blake2b-336",
                    45611: "blake2b-344",
                    45612: "blake2b-352",
                    45613: "blake2b-360",
                    45614: "blake2b-368",
                    45615: "blake2b-376",
                    45616: "blake2b-384",
                    45617: "blake2b-392",
                    45618: "blake2b-400",
                    45619: "blake2b-408",
                    45620: "blake2b-416",
                    45621: "blake2b-424",
                    45622: "blake2b-432",
                    45623: "blake2b-440",
                    45624: "blake2b-448",
                    45625: "blake2b-456",
                    45626: "blake2b-464",
                    45627: "blake2b-472",
                    45628: "blake2b-480",
                    45629: "blake2b-488",
                    45630: "blake2b-496",
                    45631: "blake2b-504",
                    45632: "blake2b-512",
                    45633: "blake2s-8",
                    45634: "blake2s-16",
                    45635: "blake2s-24",
                    45636: "blake2s-32",
                    45637: "blake2s-40",
                    45638: "blake2s-48",
                    45639: "blake2s-56",
                    45640: "blake2s-64",
                    45641: "blake2s-72",
                    45642: "blake2s-80",
                    45643: "blake2s-88",
                    45644: "blake2s-96",
                    45645: "blake2s-104",
                    45646: "blake2s-112",
                    45647: "blake2s-120",
                    45648: "blake2s-128",
                    45649: "blake2s-136",
                    45650: "blake2s-144",
                    45651: "blake2s-152",
                    45652: "blake2s-160",
                    45653: "blake2s-168",
                    45654: "blake2s-176",
                    45655: "blake2s-184",
                    45656: "blake2s-192",
                    45657: "blake2s-200",
                    45658: "blake2s-208",
                    45659: "blake2s-216",
                    45660: "blake2s-224",
                    45661: "blake2s-232",
                    45662: "blake2s-240",
                    45663: "blake2s-248",
                    45664: "blake2s-256",
                    45825: "Skein256-8",
                    45826: "Skein256-16",
                    45827: "Skein256-24",
                    45828: "Skein256-32",
                    45829: "Skein256-40",
                    45830: "Skein256-48",
                    45831: "Skein256-56",
                    45832: "Skein256-64",
                    45833: "Skein256-72",
                    45834: "Skein256-80",
                    45835: "Skein256-88",
                    45836: "Skein256-96",
                    45837: "Skein256-104",
                    45838: "Skein256-112",
                    45839: "Skein256-120",
                    45840: "Skein256-128",
                    45841: "Skein256-136",
                    45842: "Skein256-144",
                    45843: "Skein256-152",
                    45844: "Skein256-160",
                    45845: "Skein256-168",
                    45846: "Skein256-176",
                    45847: "Skein256-184",
                    45848: "Skein256-192",
                    45849: "Skein256-200",
                    45850: "Skein256-208",
                    45851: "Skein256-216",
                    45852: "Skein256-224",
                    45853: "Skein256-232",
                    45854: "Skein256-240",
                    45855: "Skein256-248",
                    45856: "Skein256-256",
                    45857: "Skein512-8",
                    45858: "Skein512-16",
                    45859: "Skein512-24",
                    45860: "Skein512-32",
                    45861: "Skein512-40",
                    45862: "Skein512-48",
                    45863: "Skein512-56",
                    45864: "Skein512-64",
                    45865: "Skein512-72",
                    45866: "Skein512-80",
                    45867: "Skein512-88",
                    45868: "Skein512-96",
                    45869: "Skein512-104",
                    45870: "Skein512-112",
                    45871: "Skein512-120",
                    45872: "Skein512-128",
                    45873: "Skein512-136",
                    45874: "Skein512-144",
                    45875: "Skein512-152",
                    45876: "Skein512-160",
                    45877: "Skein512-168",
                    45878: "Skein512-176",
                    45879: "Skein512-184",
                    45880: "Skein512-192",
                    45881: "Skein512-200",
                    45882: "Skein512-208",
                    45883: "Skein512-216",
                    45884: "Skein512-224",
                    45885: "Skein512-232",
                    45886: "Skein512-240",
                    45887: "Skein512-248",
                    45888: "Skein512-256",
                    45889: "Skein512-264",
                    45890: "Skein512-272",
                    45891: "Skein512-280",
                    45892: "Skein512-288",
                    45893: "Skein512-296",
                    45894: "Skein512-304",
                    45895: "Skein512-312",
                    45896: "Skein512-320",
                    45897: "Skein512-328",
                    45898: "Skein512-336",
                    45899: "Skein512-344",
                    45900: "Skein512-352",
                    45901: "Skein512-360",
                    45902: "Skein512-368",
                    45903: "Skein512-376",
                    45904: "Skein512-384",
                    45905: "Skein512-392",
                    45906: "Skein512-400",
                    45907: "Skein512-408",
                    45908: "Skein512-416",
                    45909: "Skein512-424",
                    45910: "Skein512-432",
                    45911: "Skein512-440",
                    45912: "Skein512-448",
                    45913: "Skein512-456",
                    45914: "Skein512-464",
                    45915: "Skein512-472",
                    45916: "Skein512-480",
                    45917: "Skein512-488",
                    45918: "Skein512-496",
                    45919: "Skein512-504",
                    45920: "Skein512-512",
                    45921: "Skein1024-8",
                    45922: "Skein1024-16",
                    45923: "Skein1024-24",
                    45924: "Skein1024-32",
                    45925: "Skein1024-40",
                    45926: "Skein1024-48",
                    45927: "Skein1024-56",
                    45928: "Skein1024-64",
                    45929: "Skein1024-72",
                    45930: "Skein1024-80",
                    45931: "Skein1024-88",
                    45932: "Skein1024-96",
                    45933: "Skein1024-104",
                    45934: "Skein1024-112",
                    45935: "Skein1024-120",
                    45936: "Skein1024-128",
                    45937: "Skein1024-136",
                    45938: "Skein1024-144",
                    45939: "Skein1024-152",
                    45940: "Skein1024-160",
                    45941: "Skein1024-168",
                    45942: "Skein1024-176",
                    45943: "Skein1024-184",
                    45944: "Skein1024-192",
                    45945: "Skein1024-200",
                    45946: "Skein1024-208",
                    45947: "Skein1024-216",
                    45948: "Skein1024-224",
                    45949: "Skein1024-232",
                    45950: "Skein1024-240",
                    45951: "Skein1024-248",
                    45952: "Skein1024-256",
                    45953: "Skein1024-264",
                    45954: "Skein1024-272",
                    45955: "Skein1024-280",
                    45956: "Skein1024-288",
                    45957: "Skein1024-296",
                    45958: "Skein1024-304",
                    45959: "Skein1024-312",
                    45960: "Skein1024-320",
                    45961: "Skein1024-328",
                    45962: "Skein1024-336",
                    45963: "Skein1024-344",
                    45964: "Skein1024-352",
                    45965: "Skein1024-360",
                    45966: "Skein1024-368",
                    45967: "Skein1024-376",
                    45968: "Skein1024-384",
                    45969: "Skein1024-392",
                    45970: "Skein1024-400",
                    45971: "Skein1024-408",
                    45972: "Skein1024-416",
                    45973: "Skein1024-424",
                    45974: "Skein1024-432",
                    45975: "Skein1024-440",
                    45976: "Skein1024-448",
                    45977: "Skein1024-456",
                    45978: "Skein1024-464",
                    45979: "Skein1024-472",
                    45980: "Skein1024-480",
                    45981: "Skein1024-488",
                    45982: "Skein1024-496",
                    45983: "Skein1024-504",
                    45984: "Skein1024-512",
                    45985: "Skein1024-520",
                    45986: "Skein1024-528",
                    45987: "Skein1024-536",
                    45988: "Skein1024-544",
                    45989: "Skein1024-552",
                    45990: "Skein1024-560",
                    45991: "Skein1024-568",
                    45992: "Skein1024-576",
                    45993: "Skein1024-584",
                    45994: "Skein1024-592",
                    45995: "Skein1024-600",
                    45996: "Skein1024-608",
                    45997: "Skein1024-616",
                    45998: "Skein1024-624",
                    45999: "Skein1024-632",
                    46e3: "Skein1024-640",
                    46001: "Skein1024-648",
                    46002: "Skein1024-656",
                    46003: "Skein1024-664",
                    46004: "Skein1024-672",
                    46005: "Skein1024-680",
                    46006: "Skein1024-688",
                    46007: "Skein1024-696",
                    46008: "Skein1024-704",
                    46009: "Skein1024-712",
                    46010: "Skein1024-720",
                    46011: "Skein1024-728",
                    46012: "Skein1024-736",
                    46013: "Skein1024-744",
                    46014: "Skein1024-752",
                    46015: "Skein1024-760",
                    46016: "Skein1024-768",
                    46017: "Skein1024-776",
                    46018: "Skein1024-784",
                    46019: "Skein1024-792",
                    46020: "Skein1024-800",
                    46021: "Skein1024-808",
                    46022: "Skein1024-816",
                    46023: "Skein1024-824",
                    46024: "Skein1024-832",
                    46025: "Skein1024-840",
                    46026: "Skein1024-848",
                    46027: "Skein1024-856",
                    46028: "Skein1024-864",
                    46029: "Skein1024-872",
                    46030: "Skein1024-880",
                    46031: "Skein1024-888",
                    46032: "Skein1024-896",
                    46033: "Skein1024-904",
                    46034: "Skein1024-912",
                    46035: "Skein1024-920",
                    46036: "Skein1024-928",
                    46037: "Skein1024-936",
                    46038: "Skein1024-944",
                    46039: "Skein1024-952",
                    46040: "Skein1024-960",
                    46041: "Skein1024-968",
                    46042: "Skein1024-976",
                    46043: "Skein1024-984",
                    46044: "Skein1024-992",
                    46045: "Skein1024-1000",
                    46046: "Skein1024-1008",
                    46047: "Skein1024-1016",
                    46048: "Skein1024-1024"
                }), t.defaultLengths = Object.freeze({
                    17: 20,
                    18: 32,
                    19: 64,
                    86: 32,
                    23: 28,
                    22: 32,
                    21: 48,
                    20: 64,
                    24: 32,
                    25: 64,
                    26: 28,
                    27: 32,
                    28: 48,
                    29: 64,
                    34: 32,
                    45569: 1,
                    45570: 2,
                    45571: 3,
                    45572: 4,
                    45573: 5,
                    45574: 6,
                    45575: 7,
                    45576: 8,
                    45577: 9,
                    45578: 10,
                    45579: 11,
                    45580: 12,
                    45581: 13,
                    45582: 14,
                    45583: 15,
                    45584: 16,
                    45585: 17,
                    45586: 18,
                    45587: 19,
                    45588: 20,
                    45589: 21,
                    45590: 22,
                    45591: 23,
                    45592: 24,
                    45593: 25,
                    45594: 26,
                    45595: 27,
                    45596: 28,
                    45597: 29,
                    45598: 30,
                    45599: 31,
                    45600: 32,
                    45601: 33,
                    45602: 34,
                    45603: 35,
                    45604: 36,
                    45605: 37,
                    45606: 38,
                    45607: 39,
                    45608: 40,
                    45609: 41,
                    45610: 42,
                    45611: 43,
                    45612: 44,
                    45613: 45,
                    45614: 46,
                    45615: 47,
                    45616: 48,
                    45617: 49,
                    45618: 50,
                    45619: 51,
                    45620: 52,
                    45621: 53,
                    45622: 54,
                    45623: 55,
                    45624: 56,
                    45625: 57,
                    45626: 58,
                    45627: 59,
                    45628: 60,
                    45629: 61,
                    45630: 62,
                    45631: 63,
                    45632: 64,
                    45633: 1,
                    45634: 2,
                    45635: 3,
                    45636: 4,
                    45637: 5,
                    45638: 6,
                    45639: 7,
                    45640: 8,
                    45641: 9,
                    45642: 10,
                    45643: 11,
                    45644: 12,
                    45645: 13,
                    45646: 14,
                    45647: 15,
                    45648: 16,
                    45649: 17,
                    45650: 18,
                    45651: 19,
                    45652: 20,
                    45653: 21,
                    45654: 22,
                    45655: 23,
                    45656: 24,
                    45657: 25,
                    45658: 26,
                    45659: 27,
                    45660: 28,
                    45661: 29,
                    45662: 30,
                    45663: 31,
                    45664: 32,
                    45825: 1,
                    45826: 2,
                    45827: 3,
                    45828: 4,
                    45829: 5,
                    45830: 6,
                    45831: 7,
                    45832: 8,
                    45833: 9,
                    45834: 10,
                    45835: 11,
                    45836: 12,
                    45837: 13,
                    45838: 14,
                    45839: 15,
                    45840: 16,
                    45841: 17,
                    45842: 18,
                    45843: 19,
                    45844: 20,
                    45845: 21,
                    45846: 22,
                    45847: 23,
                    45848: 24,
                    45849: 25,
                    45850: 26,
                    45851: 27,
                    45852: 28,
                    45853: 29,
                    45854: 30,
                    45855: 31,
                    45856: 32,
                    45857: 1,
                    45858: 2,
                    45859: 3,
                    45860: 4,
                    45861: 5,
                    45862: 6,
                    45863: 7,
                    45864: 8,
                    45865: 9,
                    45866: 10,
                    45867: 11,
                    45868: 12,
                    45869: 13,
                    45870: 14,
                    45871: 15,
                    45872: 16,
                    45873: 17,
                    45874: 18,
                    45875: 19,
                    45876: 20,
                    45877: 21,
                    45878: 22,
                    45879: 23,
                    45880: 24,
                    45881: 25,
                    45882: 26,
                    45883: 27,
                    45884: 28,
                    45885: 29,
                    45886: 30,
                    45887: 31,
                    45888: 32,
                    45889: 33,
                    45890: 34,
                    45891: 35,
                    45892: 36,
                    45893: 37,
                    45894: 38,
                    45895: 39,
                    45896: 40,
                    45897: 41,
                    45898: 42,
                    45899: 43,
                    45900: 44,
                    45901: 45,
                    45902: 46,
                    45903: 47,
                    45904: 48,
                    45905: 49,
                    45906: 50,
                    45907: 51,
                    45908: 52,
                    45909: 53,
                    45910: 54,
                    45911: 55,
                    45912: 56,
                    45913: 57,
                    45914: 58,
                    45915: 59,
                    45916: 60,
                    45917: 61,
                    45918: 62,
                    45919: 63,
                    45920: 64,
                    45921: 1,
                    45922: 2,
                    45923: 3,
                    45924: 4,
                    45925: 5,
                    45926: 6,
                    45927: 7,
                    45928: 8,
                    45929: 9,
                    45930: 10,
                    45931: 11,
                    45932: 12,
                    45933: 13,
                    45934: 14,
                    45935: 15,
                    45936: 16,
                    45937: 17,
                    45938: 18,
                    45939: 19,
                    45940: 20,
                    45941: 21,
                    45942: 22,
                    45943: 23,
                    45944: 24,
                    45945: 25,
                    45946: 26,
                    45947: 27,
                    45948: 28,
                    45949: 29,
                    45950: 30,
                    45951: 31,
                    45952: 32,
                    45953: 33,
                    45954: 34,
                    45955: 35,
                    45956: 36,
                    45957: 37,
                    45958: 38,
                    45959: 39,
                    45960: 40,
                    45961: 41,
                    45962: 42,
                    45963: 43,
                    45964: 44,
                    45965: 45,
                    45966: 46,
                    45967: 47,
                    45968: 48,
                    45969: 49,
                    45970: 50,
                    45971: 51,
                    45972: 52,
                    45973: 53,
                    45974: 54,
                    45975: 55,
                    45976: 56,
                    45977: 57,
                    45978: 58,
                    45979: 59,
                    45980: 60,
                    45981: 61,
                    45982: 62,
                    45983: 63,
                    45984: 64,
                    45985: 65,
                    45986: 66,
                    45987: 67,
                    45988: 68,
                    45989: 69,
                    45990: 70,
                    45991: 71,
                    45992: 72,
                    45993: 73,
                    45994: 74,
                    45995: 75,
                    45996: 76,
                    45997: 77,
                    45998: 78,
                    45999: 79,
                    46e3: 80,
                    46001: 81,
                    46002: 82,
                    46003: 83,
                    46004: 84,
                    46005: 85,
                    46006: 86,
                    46007: 87,
                    46008: 88,
                    46009: 89,
                    46010: 90,
                    46011: 91,
                    46012: 92,
                    46013: 93,
                    46014: 94,
                    46015: 95,
                    46016: 96,
                    46017: 97,
                    46018: 98,
                    46019: 99,
                    46020: 100,
                    46021: 101,
                    46022: 102,
                    46023: 103,
                    46024: 104,
                    46025: 105,
                    46026: 106,
                    46027: 107,
                    46028: 108,
                    46029: 109,
                    46030: 110,
                    46031: 111,
                    46032: 112,
                    46033: 113,
                    46034: 114,
                    46035: 115,
                    46036: 116,
                    46037: 117,
                    46038: 118,
                    46039: 119,
                    46040: 120,
                    46041: 121,
                    46042: 122,
                    46043: 123,
                    46044: 124,
                    46045: 125,
                    46046: 126,
                    46047: 127,
                    46048: 128
                });
            },
            77748: (e, t, r)=>{
                "use strict";
                var n = r(29033).Buffer, i = r(2592), o = r(26657), a = r(81269);
                function s(e) {
                    t.decode(e);
                }
                t.names = a.names, t.codes = a.codes, t.defaultLengths = a.defaultLengths, t.toHexString = function(e) {
                    if (!n.isBuffer(e)) throw new Error("must be passed a buffer");
                    return e.toString("hex");
                }, t.fromHexString = function(e) {
                    return n.from(e, "hex");
                }, t.toB58String = function(e) {
                    if (!n.isBuffer(e)) throw new Error("must be passed a buffer");
                    return i.encode("base58btc", e).toString().slice(1);
                }, t.fromB58String = function(e) {
                    var t = e;
                    return n.isBuffer(e) && (t = e.toString()), i.decode("z" + t);
                }, t.decode = function(e) {
                    if (!n.isBuffer(e)) throw new Error("multihash must be a Buffer");
                    if (e.length < 2) throw new Error("multihash too short. must be > 2 bytes.");
                    var r = o.decode(e);
                    if (!t.isValidCode(r)) throw new Error("multihash unknown function code: 0x".concat(r.toString(16)));
                    e = e.slice(o.decode.bytes);
                    var i = o.decode(e);
                    if (i < 0) throw new Error("multihash invalid length: ".concat(i));
                    if ((e = e.slice(o.decode.bytes)).length !== i) throw new Error("multihash length inconsistent: 0x".concat(e.toString("hex")));
                    return {
                        code: r,
                        name: a.codes[r],
                        length: i,
                        digest: e
                    };
                }, t.encode = function(e, r, i) {
                    if (!e || void 0 === r) throw new Error("multihash encode requires at least two args: digest, code");
                    var a = t.coerceCode(r);
                    if (!n.isBuffer(e)) throw new Error("digest should be a Buffer");
                    if (null == i && (i = e.length), i && e.length !== i) throw new Error("digest length should be equal to specified length.");
                    return n.concat([
                        n.from(o.encode(a)),
                        n.from(o.encode(i)),
                        e
                    ]);
                }, t.coerceCode = function(e) {
                    var r = e;
                    if ("string" == typeof e) {
                        if (void 0 === a.names[e]) throw new Error("Unrecognized hash function named: ".concat(e));
                        r = a.names[e];
                    }
                    if ("number" != typeof r) throw new Error("Hash function code should be a number. Got: ".concat(r));
                    if (void 0 === a.codes[r] && !t.isAppCode(r)) throw new Error("Unrecognized function code: ".concat(r));
                    return r;
                }, t.isAppCode = function(e) {
                    return e > 0 && e < 16;
                }, t.isValidCode = function(e) {
                    return !!t.isAppCode(e) || !!a.codes[e];
                }, t.validate = s, t.prefix = function(e) {
                    return s(e), e.slice(0, 2);
                };
            },
            77277: (e, t, r)=>{
                "use strict";
                var n = r(28847)(r(3355)), i = r(31734), o = r(36931);
                e.exports = function(e) {
                    if ("string" == typeof e || "number" == typeof e) {
                        var t = new i(1), r = String(e).toLowerCase().trim(), a = "0x" === r.substr(0, 2) || "-0x" === r.substr(0, 3), s = o(r);
                        if ("-" === s.substr(0, 1) && (s = o(s.slice(1)), t = new i(-1, 10)), !(s = "" === s ? "0" : s).match(/^-?[0-9]+$/) && s.match(/^[0-9A-Fa-f]+$/) || s.match(/^[a-fA-F]+$/) || !0 === a && s.match(/^[0-9A-Fa-f]+$/)) return new i(s, 16).mul(t);
                        if ((s.match(/^-?[0-9]+$/) || "" === s) && !1 === a) return new i(s, 10).mul(t);
                    } else if ("object" === (0, n.default)(e) && e.toString && !e.pop && !e.push && e.toString(10).match(/^-?[0-9]+$/) && (e.mul || e.dividedToIntegerBy)) return new i(e.toString(10), 10);
                    throw new Error("[number-to-bn] while converting number " + JSON.stringify(e) + " to BN.js instance, error: invalid number value. Value must be an integer, hex string, BN or BigNumber instance. Note, decimals are not supported.");
                };
            },
            33103: (e)=>{
                "use strict";
                var t = Object.getOwnPropertySymbols, r = Object.prototype.hasOwnProperty, n = Object.prototype.propertyIsEnumerable;
                e.exports = function() {
                    try {
                        if (!Object.assign) return !1;
                        var e = new String("abc");
                        if (e[5] = "de", "5" === Object.getOwnPropertyNames(e)[0]) return !1;
                        for(var t = {}, r = 0; r < 10; r++)t["_" + String.fromCharCode(r)] = r;
                        if ("0123456789" !== Object.getOwnPropertyNames(t).map(function(e) {
                            return t[e];
                        }).join("")) return !1;
                        var n = {};
                        return "abcdefghijklmnopqrst".split("").forEach(function(e) {
                            n[e] = e;
                        }), "abcdefghijklmnopqrst" === Object.keys(Object.assign({}, n)).join("");
                    } catch (e) {
                        return !1;
                    }
                }() ? Object.assign : function(e, i) {
                    for(var o, a, s = function(e) {
                        if (null == e) throw new TypeError("Object.assign cannot be called with null or undefined");
                        return Object(e);
                    }(e), u = 1; u < arguments.length; u++){
                        for(var c in o = Object(arguments[u]))r.call(o, c) && (s[c] = o[c]);
                        if (t) {
                            a = t(o);
                            for(var f = 0; f < a.length; f++)n.call(o, a[f]) && (s[a[f]] = o[a[f]]);
                        }
                    }
                    return s;
                };
            },
            83150: (e, t, r)=>{
                "use strict";
                var n, i, o;
                e = r.nmd(e);
                var a, s = r(28847)(r(3355));
                "undefined" != typeof self && self, a = function() {
                    return function(e) {
                        var t = {};
                        function r(n) {
                            if (t[n]) return t[n].exports;
                            var i = t[n] = {
                                i: n,
                                l: !1,
                                exports: {}
                            };
                            return e[n].call(i.exports, i, i.exports, r), i.l = !0, i.exports;
                        }
                        return r.m = e, r.c = t, r.d = function(e, t, n) {
                            r.o(e, t) || Object.defineProperty(e, t, {
                                configurable: !1,
                                enumerable: !0,
                                get: n
                            });
                        }, r.n = function(e) {
                            var t = e && e.__esModule ? function() {
                                return e.default;
                            } : function() {
                                return e;
                            };
                            return r.d(t, "a", t), t;
                        }, r.o = function(e, t) {
                            return Object.prototype.hasOwnProperty.call(e, t);
                        }, r.p = "", r(r.s = 7);
                    }([
                        function(e, t, r) {
                            r.d(t, "j", function() {
                                return i;
                            }), r.d(t, "d", function() {
                                return o;
                            }), r.d(t, "c", function() {
                                return a;
                            }), r.d(t, "h", function() {
                                return s;
                            }), r.d(t, "b", function() {
                                return u;
                            }), r.d(t, "k", function() {
                                return c;
                            }), r.d(t, "e", function() {
                                return f;
                            }), r.d(t, "g", function() {
                                return d;
                            }), r.d(t, "i", function() {
                                return l;
                            }), r.d(t, "a", function() {
                                return h;
                            }), r.d(t, "f", function() {
                                return p;
                            });
                            var n = r(1), i = c(function(e, t) {
                                var r = t.length;
                                return c(function(n) {
                                    for(var i = 0; i < n.length; i++)t[r + i] = n[i];
                                    return t.length = r + n.length, e.apply(this, t);
                                });
                            });
                            function o(e, t) {
                                return function() {
                                    return e.call(this, t.apply(this, arguments));
                                };
                            }
                            function a(e) {
                                return function(t) {
                                    return t[e];
                                };
                            }
                            c(function(e) {
                                var t = Object(n.c)(e);
                                function r(e, t) {
                                    return [
                                        u(e, t)
                                    ];
                                }
                                return c(function(e) {
                                    return Object(n.f)(r, e, t)[0];
                                });
                            });
                            var s = c(function(e) {
                                return c(function(t) {
                                    for(var r, n = 0; n < a("length")(e); n++)if (r = u(t, e[n])) return r;
                                });
                            });
                            function u(e, t) {
                                return t.apply(void 0, e);
                            }
                            function c(e) {
                                var t = e.length - 1, r = Array.prototype.slice;
                                if (0 === t) return function() {
                                    return e.call(this, r.call(arguments));
                                };
                                if (1 === t) return function() {
                                    return e.call(this, arguments[0], r.call(arguments, 1));
                                };
                                var n = Array(e.length);
                                return function() {
                                    for(var i = 0; i < t; i++)n[i] = arguments[i];
                                    return n[t] = r.call(arguments, t), e.apply(this, n);
                                };
                            }
                            function f(e) {
                                return function(t, r) {
                                    return e(r, t);
                                };
                            }
                            function d(e, t) {
                                return function(r) {
                                    return e(r) && t(r);
                                };
                            }
                            function l() {}
                            function h() {
                                return !0;
                            }
                            function p(e) {
                                return function() {
                                    return e;
                                };
                            }
                        },
                        function(e, t, r) {
                            r.d(t, "d", function() {
                                return i;
                            }), r.d(t, "g", function() {
                                return a;
                            }), r.d(t, "l", function() {
                                return s;
                            }), r.d(t, "c", function() {
                                return u;
                            }), r.d(t, "h", function() {
                                return c;
                            }), r.d(t, "i", function() {
                                return f;
                            }), r.d(t, "j", function() {
                                return d;
                            }), r.d(t, "f", function() {
                                return l;
                            }), r.d(t, "m", function() {
                                return h;
                            }), r.d(t, "a", function() {
                                return p;
                            }), r.d(t, "b", function() {
                                return b;
                            }), r.d(t, "k", function() {
                                return y;
                            }), r.d(t, "e", function() {
                                return v;
                            });
                            var n = r(0);
                            function i(e, t) {
                                return [
                                    e,
                                    t
                                ];
                            }
                            var o = null, a = Object(n.c)(0), s = Object(n.c)(1);
                            function u(e) {
                                return y(e.reduce(Object(n.e)(i), o));
                            }
                            var c = Object(n.k)(u);
                            function f(e) {
                                return l(function(e, t) {
                                    return e.unshift(t), e;
                                }, [], e);
                            }
                            function d(e, t) {
                                return t ? i(e(a(t)), d(e, s(t))) : o;
                            }
                            function l(e, t, r) {
                                return r ? e(l(e, t, s(r)), a(r)) : t;
                            }
                            function h(e, t, r) {
                                return function e(r, n) {
                                    return r ? t(a(r)) ? (n(a(r)), s(r)) : i(a(r), e(s(r), n)) : o;
                                }(e, r || n.i);
                            }
                            function p(e, t) {
                                return !t || e(a(t)) && p(e, s(t));
                            }
                            function b(e, t) {
                                e && (a(e).apply(null, t), b(s(e), t));
                            }
                            function y(e) {
                                return function e(t, r) {
                                    return t ? e(s(t), i(a(t), r)) : r;
                                }(e, o);
                            }
                            function v(e, t) {
                                return t && (e(a(t)) ? a(t) : v(e, s(t)));
                            }
                        },
                        function(e, t, r) {
                            r.d(t, "c", function() {
                                return o;
                            }), r.d(t, "e", function() {
                                return a;
                            }), r.d(t, "d", function() {
                                return s;
                            }), r.d(t, "a", function() {
                                return u;
                            }), r.d(t, "b", function() {
                                return c;
                            });
                            var n = r(1), i = r(0);
                            function o(e, t) {
                                return t && t.constructor === e;
                            }
                            var a = Object(i.c)("length"), s = Object(i.j)(o, String);
                            function u(e) {
                                return void 0 !== e;
                            }
                            function c(e, t) {
                                return t instanceof Object && Object(n.a)(function(e) {
                                    return e in t;
                                }, e);
                            }
                        },
                        function(e, t, r) {
                            r.d(t, "f", function() {
                                return i;
                            }), r.d(t, "d", function() {
                                return o;
                            }), r.d(t, "g", function() {
                                return a;
                            }), r.d(t, "e", function() {
                                return s;
                            }), r.d(t, "b", function() {
                                return u;
                            }), r.d(t, "h", function() {
                                return c;
                            }), r.d(t, "i", function() {
                                return f;
                            }), r.d(t, "c", function() {
                                return d;
                            }), r.d(t, "m", function() {
                                return l;
                            }), r.d(t, "n", function() {
                                return h;
                            }), r.d(t, "a", function() {
                                return p;
                            }), r.d(t, "j", function() {
                                return b;
                            }), r.d(t, "l", function() {
                                return y;
                            }), r.d(t, "k", function() {
                                return v;
                            }), r.d(t, "o", function() {
                                return m;
                            });
                            var n = 1, i = n++, o = n++, a = n++, s = n++, u = "fail", c = n++, f = n++, d = "start", l = "data", h = "end", p = n++, b = n++, y = n++, v = n++;
                            function m(e, t, r) {
                                try {
                                    var n = JSON.parse(t);
                                } catch (e) {}
                                return {
                                    statusCode: e,
                                    body: t,
                                    jsonBody: n,
                                    thrown: r
                                };
                            }
                        },
                        function(e, t, r) {
                            r.d(t, "b", function() {
                                return i;
                            }), r.d(t, "a", function() {
                                return o;
                            }), r.d(t, "c", function() {
                                return a;
                            });
                            var n = r(0);
                            function i(e, t) {
                                return {
                                    key: e,
                                    node: t
                                };
                            }
                            var o = Object(n.c)("key"), a = Object(n.c)("node");
                        },
                        function(e, t, r) {
                            r.d(t, "a", function() {
                                return u;
                            });
                            var n = r(1), i = r(0), o = r(2), a = r(8), s = r(9);
                            function u(e) {
                                var t = Object(n.h)("resume", "pause", "pipe"), r = Object(i.j)(o.b, t);
                                return e ? r(e) || Object(o.d)(e) ? Object(a.a)(s.a, e) : Object(a.a)(s.a, e.url, e.method, e.body, e.headers, e.withCredentials, e.cached) : Object(s.a)();
                            }
                            u.drop = function() {
                                return u.drop;
                            };
                        },
                        function(e, t, r) {
                            r.d(t, "b", function() {
                                return u;
                            }), r.d(t, "a", function() {
                                return s;
                            });
                            var n = r(3), i = r(4), o = r(2), a = r(1), s = {};
                            function u(e) {
                                var t = e(n.f).emit, r = e(n.d).emit, u = e(n.i).emit, c = e(n.h).emit;
                                function f(e, t, r) {
                                    Object(i.c)(Object(a.g)(e))[t] = r;
                                }
                                function d(e, r, n) {
                                    e && f(e, r, n);
                                    var o = Object(a.d)(Object(i.b)(r, n), e);
                                    return t(o), o;
                                }
                                var l = {};
                                return l[n.l] = function(e, t) {
                                    if (!e) return u(t), d(e, s, t);
                                    var r = function(e, t) {
                                        var r = Object(i.c)(Object(a.g)(e));
                                        return Object(o.c)(Array, r) ? d(e, Object(o.e)(r), t) : e;
                                    }(e, t), n = Object(a.l)(r), c = Object(i.a)(Object(a.g)(r));
                                    return f(n, c, t), Object(a.d)(Object(i.b)(c, t), n);
                                }, l[n.k] = function(e) {
                                    return r(e), Object(a.l)(e) || c(Object(i.c)(Object(a.g)(e)));
                                }, l[n.j] = d, l;
                            }
                        },
                        function(e, t, r) {
                            Object.defineProperty(t, "__esModule", {
                                value: !0
                            });
                            var n = r(5);
                            t.default = n.a;
                        },
                        function(e, t, r) {
                            r.d(t, "a", function() {
                                return i;
                            });
                            var n = r(2);
                            function i(e, t, r, i, o, a, s) {
                                return o = o ? JSON.parse(JSON.stringify(o)) : {}, i ? (Object(n.d)(i) || (i = JSON.stringify(i), o["Content-Type"] = o["Content-Type"] || "application/json"), o["Content-Length"] = o["Content-Length"] || i.length) : i = null, e(r || "GET", function(e, t) {
                                    return !1 === t && (-1 === e.indexOf("?") ? e += "?" : e += "&", e += "_=" + (new Date).getTime()), e;
                                }(t, s), i, o, a || !1);
                            }
                        },
                        function(e, t, r) {
                            r.d(t, "a", function() {
                                return d;
                            });
                            var n = r(10), i = r(12), o = r(6), a = r(13), s = r(14), u = r(16), c = r(17), f = r(18);
                            function d(e, t, r, d, l) {
                                var h = Object(n.a)();
                                return t && Object(f.b)(h, Object(f.a)(), e, t, r, d, l), Object(c.a)(h), Object(i.a)(h, Object(o.b)(h)), Object(a.a)(h, s.a), Object(u.a)(h, t);
                            }
                        },
                        function(e, t, r) {
                            r.d(t, "a", function() {
                                return o;
                            });
                            var n = r(11), i = r(0);
                            function o() {
                                var e = {}, t = o("newListener"), r = o("removeListener");
                                function o(i) {
                                    return e[i] = Object(n.a)(i, t, r), e[i];
                                }
                                function a(t) {
                                    return e[t] || o(t);
                                }
                                return [
                                    "emit",
                                    "on",
                                    "un"
                                ].forEach(function(e) {
                                    a[e] = Object(i.k)(function(t, r) {
                                        Object(i.b)(r, a(t)[e]);
                                    });
                                }), a;
                            }
                        },
                        function(e, t, r) {
                            r.d(t, "a", function() {
                                return a;
                            });
                            var n = r(1), i = r(2), o = r(0);
                            function a(e, t, r) {
                                var a, s;
                                function u(e) {
                                    return function(t) {
                                        return t.id === e;
                                    };
                                }
                                return {
                                    on: function(r, i) {
                                        var o = {
                                            listener: r,
                                            id: i || r
                                        };
                                        return t && t.emit(e, r, o.id), a = Object(n.d)(o, a), s = Object(n.d)(r, s), this;
                                    },
                                    emit: function() {
                                        Object(n.b)(s, arguments);
                                    },
                                    un: function(t) {
                                        var i;
                                        a = Object(n.m)(a, u(t), function(e) {
                                            i = e;
                                        }), i && (s = Object(n.m)(s, function(e) {
                                            return e === i.listener;
                                        }), r && r.emit(e, i.listener, i.id));
                                    },
                                    listeners: function() {
                                        return s;
                                    },
                                    hasListener: function(e) {
                                        var t = e ? u(e) : o.a;
                                        return Object(i.a)(Object(n.e)(t, a));
                                    }
                                };
                            }
                        },
                        function(e, t, r) {
                            r.d(t, "a", function() {
                                return a;
                            });
                            var n = r(4), i = r(3), o = r(1);
                            function a(e, t) {
                                var r, a = {};
                                function s(e) {
                                    return function(t) {
                                        r = e(r, t);
                                    };
                                }
                                for(var u in t)e(u).on(s(t[u]), a);
                                e(i.g).on(function(e) {
                                    var t = Object(o.g)(r), i = Object(n.a)(t), a = Object(o.l)(r);
                                    a && (Object(n.c)(Object(o.g)(a))[i] = e);
                                }), e(i.e).on(function() {
                                    var e = Object(o.g)(r), t = Object(n.a)(e), i = Object(o.l)(r);
                                    i && delete Object(n.c)(Object(o.g)(i))[t];
                                }), e(i.a).on(function() {
                                    for(var r in t)e(r).un(a);
                                });
                            }
                        },
                        function(e, t, r) {
                            r.d(t, "a", function() {
                                return a;
                            });
                            var n = r(3), i = r(1), o = r(4);
                            function a(e, t) {
                                var r = {
                                    node: e(n.d),
                                    path: e(n.f)
                                };
                                e("newListener").on(function(n) {
                                    var a = /(node|path):(.*)/.exec(n);
                                    if (a) {
                                        var s = r[a[1]];
                                        s.hasListener(n) || function(t, r, n) {
                                            var a = e(t).emit;
                                            r.on(function(e) {
                                                var t = n(e);
                                                !1 !== t && function(e, t, r) {
                                                    var n = Object(i.k)(r);
                                                    e(t, Object(i.i)(Object(i.l)(Object(i.j)(o.a, n))), Object(i.i)(Object(i.j)(o.c, n)));
                                                }(a, Object(o.c)(t), e);
                                            }, t), e("removeListener").on(function(n) {
                                                n === t && (e(n).listeners() || r.un(t));
                                            });
                                        }(n, s, t(a[2]));
                                    }
                                });
                            }
                        },
                        function(e, t, r) {
                            r.d(t, "a", function() {
                                return c;
                            });
                            var n = r(0), i = r(1), o = r(4), a = r(2), s = r(6), u = r(15), c = Object(u.a)(function(e, t, r, u, c) {
                                var f = 1, d = Object(n.d)(o.a, i.g), l = Object(n.d)(o.c, i.g);
                                function h(e, t) {
                                    return t[f] ? Object(n.g)(e, i.g) : e;
                                }
                                function p(e) {
                                    return e === n.a ? n.a : Object(n.g)(function(e) {
                                        return d(e) !== s.a;
                                    }, Object(n.d)(e, i.l));
                                }
                                function b() {
                                    return function(e) {
                                        return d(e) === s.a;
                                    };
                                }
                                function y(e, t, r, n, o) {
                                    var s = e(r);
                                    if (s) {
                                        var u = function(e, t, r) {
                                            return Object(i.f)(function(e, t) {
                                                return t(e, r);
                                            }, t, e);
                                        }(t, n, s);
                                        return o(r.substr(Object(a.e)(s[0])), u);
                                    }
                                }
                                function v(e, t) {
                                    return Object(n.j)(y, e, t);
                                }
                                var m = Object(n.h)(v(e, Object(i.h)(h, function(e, t) {
                                    var r = t[3];
                                    if (!r) return e;
                                    var o = Object(n.j)(a.b, Object(i.c)(r.split(/\W+/))), s = Object(n.d)(o, l);
                                    return Object(n.g)(s, e);
                                }, function(e, t) {
                                    var r = t[2], i = r && "*" !== r ? function(e) {
                                        return String(d(e)) === r;
                                    } : n.a;
                                    return Object(n.g)(i, e);
                                }, p)), v(t, Object(i.h)(function(e) {
                                    if (e === n.a) return n.a;
                                    var t = b(), r = e, i = p(function(e) {
                                        return o(e);
                                    }), o = Object(n.h)(t, r, i);
                                    return o;
                                })), v(r, Object(i.h)()), v(u, Object(i.h)(h, b)), v(c, Object(i.h)(function(e) {
                                    return function(t) {
                                        var r = e(t);
                                        return !0 === r ? Object(i.g)(t) : r;
                                    };
                                })), function(e) {
                                    throw Error('"' + e + '" could not be tokenised');
                                });
                                function g(e, t) {
                                    return t;
                                }
                                function w(e, t) {
                                    return m(e, t, e ? w : g);
                                }
                                return function(e) {
                                    try {
                                        return w(e, n.a);
                                    } catch (t) {
                                        throw Error('Could not compile "' + e + '" because ' + t.message);
                                    }
                                };
                            });
                        },
                        function(e, t, r) {
                            r.d(t, "a", function() {
                                return b;
                            });
                            var n, i, o, a, s, u, c, f, d, l, h, p = r(0), b = (n = Object(p.k)(function(e) {
                                var t;
                                return e.unshift(/^/), (t = RegExp(e.map(Object(p.c)("source")).join(""))).exec.bind(t);
                            }), a = n(i = /(\$?)/, /([\w-_]+|\*)/, o = /(?:{([\w ]*?)})?/), s = n(i, /\["([^"]+)"\]/, o), u = n(i, /\[(\d+|\*)\]/, o), c = n(i, /()/, /{([\w ]*?)}/), f = n(/\.\./), d = n(/\./), l = n(i, /!/), h = n(/$/), function(e) {
                                return e(Object(p.h)(a, s, u, c), f, d, l, h);
                            });
                        },
                        function(e, t, r) {
                            r.d(t, "a", function() {
                                return s;
                            });
                            var n = r(3), i = r(0), o = r(2), a = r(5);
                            function s(e, t) {
                                var r, s = /^(node|path):./, u = e(n.h), c = e(n.e).emit, f = e(n.g).emit, d = Object(i.k)(function(t, n) {
                                    if (r[t]) Object(i.b)(n, r[t]);
                                    else {
                                        var o = e(t), a = n[0];
                                        s.test(t) ? l(o, p(a)) : o.on(a);
                                    }
                                    return r;
                                });
                                function l(e, t, n) {
                                    n = n || t;
                                    var o = h(t);
                                    return e.on(function() {
                                        var t = !1;
                                        r.forget = function() {
                                            t = !0;
                                        }, Object(i.b)(arguments, o), delete r.forget, t && e.un(n);
                                    }, n), r;
                                }
                                function h(e) {
                                    return function() {
                                        try {
                                            return e.apply(r, arguments);
                                        } catch (e) {
                                            setTimeout(function() {
                                                throw new Error(e.message);
                                            });
                                        }
                                    };
                                }
                                function p(e) {
                                    return function() {
                                        var t = e.apply(this, arguments);
                                        Object(o.a)(t) && (t === a.a.drop ? c() : f(t));
                                    };
                                }
                                function b(t, r, n) {
                                    var i;
                                    i = "node" === t ? p(n) : n, l(function(t, r) {
                                        return e(t + ":" + r);
                                    }(t, r), i, n);
                                }
                                function y(e, t, n) {
                                    return Object(o.d)(t) ? b(e, t, n) : function(e, t) {
                                        for(var r in t)b(e, r, t[r]);
                                    }(e, t), r;
                                }
                                return e(n.i).on(function(e) {
                                    r.root = Object(i.f)(e);
                                }), e(n.c).on(function(e, t) {
                                    r.header = function(e) {
                                        return e ? t[e] : t;
                                    };
                                }), r = {
                                    on: d,
                                    addListener: d,
                                    removeListener: function(t, n, i) {
                                        if ("done" === t) u.un(n);
                                        else if ("node" === t || "path" === t) e.un(t + ":" + n, i);
                                        else {
                                            var o = n;
                                            e(t).un(o);
                                        }
                                        return r;
                                    },
                                    emit: e.emit,
                                    node: Object(i.j)(y, "node"),
                                    path: Object(i.j)(y, "path"),
                                    done: Object(i.j)(l, u),
                                    start: Object(i.j)(function(t, n) {
                                        return e(t).on(h(n), n), r;
                                    }, n.c),
                                    fail: e(n.b).on,
                                    abort: e(n.a).emit,
                                    header: i.i,
                                    root: i.i,
                                    source: t
                                };
                            }
                        },
                        function(e, t, r) {
                            r.d(t, "a", function() {
                                return i;
                            });
                            var n = r(3);
                            function i(e) {
                                var t, r, i, o, a = e(n.j).emit, s = e(n.l).emit, u = e(n.k).emit, c = e(n.b).emit, f = 65536, d = /[\\"\n]/g, l = 0, h = l++, p = l++, b = l++, y = l++, v = l++, m = l++, g = l++, w = l++, k = l++, _ = l++, A = l++, E = l++, S = l++, x = l++, B = l++, O = l++, P = l++, I = l++, T = l++, C = l++, M = f, R = "", U = !1, N = !1, j = h, L = [], F = null, D = 0, H = 0, z = 0, q = 0, K = 1;
                                function G(e) {
                                    void 0 !== o && (s(o), u(), o = void 0), t = Error(e + "\nLn: " + K + "\nCol: " + q + "\nChr: " + r), c(Object(n.o)(void 0, void 0, t));
                                }
                                function V(e) {
                                    return "\r" === e || "\n" === e || " " === e || "	" === e;
                                }
                                e(n.m).on(function(e) {
                                    if (!t) {
                                        if (N) return G("Cannot write after close");
                                        var n, c = 0;
                                        for(r = e[0]; r && (c > 0 && (i = r), r = e[c++]);)switch(z++, "\n" === r ? (K++, q = 0) : q++, j){
                                            case h:
                                                if ("{" === r) j = b;
                                                else if ("[" === r) j = v;
                                                else if (!V(r)) return G("Non-whitespace before {[.");
                                                continue;
                                            case w:
                                            case b:
                                                if (V(r)) continue;
                                                if (j === w) L.push(k);
                                                else {
                                                    if ("}" === r) {
                                                        s({}), u(), j = L.pop() || p;
                                                        continue;
                                                    }
                                                    L.push(y);
                                                }
                                                if ('"' !== r) return G('Malformed object key should start with " ');
                                                j = g;
                                                continue;
                                            case k:
                                            case y:
                                                if (V(r)) continue;
                                                if (":" === r) j === y ? (L.push(y), void 0 !== o && (s({}), a(o), o = void 0), H++) : void 0 !== o && (a(o), o = void 0), j = p;
                                                else if ("}" === r) void 0 !== o && (s(o), u(), o = void 0), u(), H--, j = L.pop() || p;
                                                else {
                                                    if ("," !== r) return G("Bad object");
                                                    j === y && L.push(y), void 0 !== o && (s(o), u(), o = void 0), j = w;
                                                }
                                                continue;
                                            case v:
                                            case p:
                                                if (V(r)) continue;
                                                if (j === v) {
                                                    if (s([]), H++, j = p, "]" === r) {
                                                        u(), H--, j = L.pop() || p;
                                                        continue;
                                                    }
                                                    L.push(m);
                                                }
                                                if ('"' === r) j = g;
                                                else if ("{" === r) j = b;
                                                else if ("[" === r) j = v;
                                                else if ("t" === r) j = _;
                                                else if ("f" === r) j = S;
                                                else if ("n" === r) j = P;
                                                else if ("-" === r) R += r;
                                                else if ("0" === r) R += r, j = 20;
                                                else {
                                                    if (-1 === "123456789".indexOf(r)) return G("Bad value");
                                                    R += r, j = 20;
                                                }
                                                continue;
                                            case m:
                                                if ("," === r) L.push(m), void 0 !== o && (s(o), u(), o = void 0), j = p;
                                                else {
                                                    if ("]" !== r) {
                                                        if (V(r)) continue;
                                                        return G("Bad array");
                                                    }
                                                    void 0 !== o && (s(o), u(), o = void 0), u(), H--, j = L.pop() || p;
                                                }
                                                continue;
                                            case g:
                                                void 0 === o && (o = "");
                                                var l = c - 1;
                                                e: for(;;){
                                                    for(; D > 0;)if (F += r, r = e.charAt(c++), 4 === D ? (o += String.fromCharCode(parseInt(F, 16)), D = 0, l = c - 1) : D++, !r) break e;
                                                    if ('"' === r && !U) {
                                                        j = L.pop() || p, o += e.substring(l, c - 1);
                                                        break;
                                                    }
                                                    if (!("\\" !== r || U || (U = !0, o += e.substring(l, c - 1), r = e.charAt(c++)))) break;
                                                    if (U) {
                                                        if (U = !1, "n" === r ? o += "\n" : "r" === r ? o += "\r" : "t" === r ? o += "	" : "f" === r ? o += "\f" : "b" === r ? o += "\b" : "u" === r ? (D = 1, F = "") : o += r, r = e.charAt(c++), l = c - 1, r) continue;
                                                        break;
                                                    }
                                                    d.lastIndex = c;
                                                    var Z = d.exec(e);
                                                    if (!Z) {
                                                        c = e.length + 1, o += e.substring(l, c - 1);
                                                        break;
                                                    }
                                                    if (c = Z.index + 1, !(r = e.charAt(Z.index))) {
                                                        o += e.substring(l, c - 1);
                                                        break;
                                                    }
                                                }
                                                continue;
                                            case _:
                                                if (!r) continue;
                                                if ("r" !== r) return G("Invalid true started with t" + r);
                                                j = A;
                                                continue;
                                            case A:
                                                if (!r) continue;
                                                if ("u" !== r) return G("Invalid true started with tr" + r);
                                                j = E;
                                                continue;
                                            case E:
                                                if (!r) continue;
                                                if ("e" !== r) return G("Invalid true started with tru" + r);
                                                s(!0), u(), j = L.pop() || p;
                                                continue;
                                            case S:
                                                if (!r) continue;
                                                if ("a" !== r) return G("Invalid false started with f" + r);
                                                j = x;
                                                continue;
                                            case x:
                                                if (!r) continue;
                                                if ("l" !== r) return G("Invalid false started with fa" + r);
                                                j = B;
                                                continue;
                                            case B:
                                                if (!r) continue;
                                                if ("s" !== r) return G("Invalid false started with fal" + r);
                                                j = O;
                                                continue;
                                            case O:
                                                if (!r) continue;
                                                if ("e" !== r) return G("Invalid false started with fals" + r);
                                                s(!1), u(), j = L.pop() || p;
                                                continue;
                                            case P:
                                                if (!r) continue;
                                                if ("u" !== r) return G("Invalid null started with n" + r);
                                                j = I;
                                                continue;
                                            case I:
                                                if (!r) continue;
                                                if ("l" !== r) return G("Invalid null started with nu" + r);
                                                j = T;
                                                continue;
                                            case T:
                                                if (!r) continue;
                                                if ("l" !== r) return G("Invalid null started with nul" + r);
                                                s(null), u(), j = L.pop() || p;
                                                continue;
                                            case C:
                                                if ("." !== r) return G("Leading zero not followed by .");
                                                R += r, j = 20;
                                                continue;
                                            case 20:
                                                if (-1 !== "0123456789".indexOf(r)) R += r;
                                                else if ("." === r) {
                                                    if (-1 !== R.indexOf(".")) return G("Invalid number has two dots");
                                                    R += r;
                                                } else if ("e" === r || "E" === r) {
                                                    if (-1 !== R.indexOf("e") || -1 !== R.indexOf("E")) return G("Invalid number has two exponential");
                                                    R += r;
                                                } else if ("+" === r || "-" === r) {
                                                    if ("e" !== i && "E" !== i) return G("Invalid symbol in number");
                                                    R += r;
                                                } else R && (s(parseFloat(R)), u(), R = ""), c--, j = L.pop() || p;
                                                continue;
                                            default:
                                                return G("Unknown state: " + j);
                                        }
                                        z >= M && (n = 0, void 0 !== o && o.length > f && (G("Max buffer length exceeded: textNode"), n = Math.max(n, o.length)), R.length > f && (G("Max buffer length exceeded: numberNode"), n = Math.max(n, R.length)), M = f - n + z);
                                    }
                                }), e(n.n).on(function() {
                                    if (j === h) return s({}), u(), void (N = !0);
                                    j === p && 0 === H || G("Unexpected end"), void 0 !== o && (s(o), u(), o = void 0), N = !0;
                                });
                            }
                        },
                        function(e, t, r) {
                            r.d(t, "a", function() {
                                return u;
                            }), r.d(t, "b", function() {
                                return c;
                            });
                            var n = r(19), i = r(3), o = r(2), a = r(20), s = r(0);
                            function u() {
                                return new XMLHttpRequest;
                            }
                            function c(e, t, r, u, c, f, d) {
                                var l = e(i.m).emit, h = e(i.b).emit, p = 0, b = !0;
                                function y() {
                                    if ("2" === String(t.status)[0]) {
                                        var e = t.responseText, r = (" " + e.substr(p)).substr(1);
                                        r && l(r), p = Object(o.e)(e);
                                    }
                                }
                                function v(t) {
                                    try {
                                        b && e(i.c).emit(t.status, Object(a.a)(t.getAllResponseHeaders())), b = !1;
                                    } catch (e) {}
                                }
                                e(i.a).on(function() {
                                    t.onreadystatechange = null, t.abort();
                                }), "onprogress" in t && (t.onprogress = y), t.onreadystatechange = function() {
                                    switch(t.readyState){
                                        case 2:
                                        case 3:
                                            return v(t);
                                        case 4:
                                            v(t), "2" === String(t.status)[0] ? (y(), e(i.n).emit()) : h(Object(i.o)(t.status, t.responseText));
                                    }
                                };
                                try {
                                    for(var m in t.open(r, u, !0), f)t.setRequestHeader(m, f[m]);
                                    Object(n.a)(window.location, Object(n.b)(u)) || t.setRequestHeader("X-Requested-With", "XMLHttpRequest"), t.withCredentials = d, t.send(c);
                                } catch (e) {
                                    window.setTimeout(Object(s.j)(h, Object(i.o)(void 0, void 0, e)), 0);
                                }
                            }
                        },
                        function(e, t, r) {
                            function n(e, t) {
                                function r(t) {
                                    return String(t.port || ({
                                        "http:": 80,
                                        "https:": 443
                                    })[t.protocol || e.protocol]);
                                }
                                return !!(t.protocol && t.protocol !== e.protocol || t.host && t.host !== e.host || t.host && r(t) !== r(e));
                            }
                            function i(e) {
                                var t = /(\w+:)?(?:\/\/)([\w.-]+)?(?::(\d+))?\/?/.exec(e) || [];
                                return {
                                    protocol: t[1] || "",
                                    host: t[2] || "",
                                    port: t[3] || ""
                                };
                            }
                            r.d(t, "a", function() {
                                return n;
                            }), r.d(t, "b", function() {
                                return i;
                            });
                        },
                        function(e, t, r) {
                            function n(e) {
                                var t = {};
                                return e && e.split("\r\n").forEach(function(e) {
                                    var r = e.indexOf(": ");
                                    t[e.substring(0, r)] = e.substring(r + 2);
                                }), t;
                            }
                            r.d(t, "a", function() {
                                return n;
                            });
                        }
                    ]).default;
                }, "object" === (0, s.default)(t) && "object" === (0, s.default)(e) ? e.exports = a() : (i = [], void 0 === (o = "function" == typeof (n = a) ? n.apply(t, i) : n) || (e.exports = o));
            },
            21307: (e, t, r)=>{
                "use strict";
                var n = r(28847)(r(3355)), i = "undefined" != typeof Uint8Array && "undefined" != typeof Uint16Array && "undefined" != typeof Int32Array;
                function o(e, t) {
                    return Object.prototype.hasOwnProperty.call(e, t);
                }
                t.assign = function(e) {
                    for(var t = Array.prototype.slice.call(arguments, 1); t.length;){
                        var r = t.shift();
                        if (r) {
                            if ("object" !== (0, n.default)(r)) throw new TypeError(r + "must be non-object");
                            for(var i in r)o(r, i) && (e[i] = r[i]);
                        }
                    }
                    return e;
                }, t.shrinkBuf = function(e, t) {
                    return e.length === t ? e : e.subarray ? e.subarray(0, t) : (e.length = t, e);
                };
                var a = {
                    arraySet: function(e, t, r, n, i) {
                        if (t.subarray && e.subarray) e.set(t.subarray(r, r + n), i);
                        else for(var o = 0; o < n; o++)e[i + o] = t[r + o];
                    },
                    flattenChunks: function(e) {
                        var t, r, n, i, o, a;
                        for(n = 0, t = 0, r = e.length; t < r; t++)n += e[t].length;
                        for(a = new Uint8Array(n), i = 0, t = 0, r = e.length; t < r; t++)o = e[t], a.set(o, i), i += o.length;
                        return a;
                    }
                }, s = {
                    arraySet: function(e, t, r, n, i) {
                        for(var o = 0; o < n; o++)e[i + o] = t[r + o];
                    },
                    flattenChunks: function(e) {
                        return [].concat.apply([], e);
                    }
                };
                t.setTyped = function(e) {
                    e ? (t.Buf8 = Uint8Array, t.Buf16 = Uint16Array, t.Buf32 = Int32Array, t.assign(t, a)) : (t.Buf8 = Array, t.Buf16 = Array, t.Buf32 = Array, t.assign(t, s));
                }, t.setTyped(i);
            },
            57506: (e)=>{
                "use strict";
                e.exports = function(e, t, r, n) {
                    for(var i = 65535 & e | 0, o = e >>> 16 & 65535 | 0, a = 0; 0 !== r;){
                        r -= a = r > 2e3 ? 2e3 : r;
                        do o = o + (i = i + t[n++] | 0) | 0;
                        while (--a);
                        i %= 65521, o %= 65521;
                    }
                    return i | o << 16 | 0;
                };
            },
            29806: (e)=>{
                "use strict";
                e.exports = {
                    Z_NO_FLUSH: 0,
                    Z_PARTIAL_FLUSH: 1,
                    Z_SYNC_FLUSH: 2,
                    Z_FULL_FLUSH: 3,
                    Z_FINISH: 4,
                    Z_BLOCK: 5,
                    Z_TREES: 6,
                    Z_OK: 0,
                    Z_STREAM_END: 1,
                    Z_NEED_DICT: 2,
                    Z_ERRNO: -1,
                    Z_STREAM_ERROR: -2,
                    Z_DATA_ERROR: -3,
                    Z_BUF_ERROR: -5,
                    Z_NO_COMPRESSION: 0,
                    Z_BEST_SPEED: 1,
                    Z_BEST_COMPRESSION: 9,
                    Z_DEFAULT_COMPRESSION: -1,
                    Z_FILTERED: 1,
                    Z_HUFFMAN_ONLY: 2,
                    Z_RLE: 3,
                    Z_FIXED: 4,
                    Z_DEFAULT_STRATEGY: 0,
                    Z_BINARY: 0,
                    Z_TEXT: 1,
                    Z_UNKNOWN: 2,
                    Z_DEFLATED: 8
                };
            },
            28548: (e)=>{
                "use strict";
                var t = function() {
                    for(var e, t = [], r = 0; r < 256; r++){
                        e = r;
                        for(var n = 0; n < 8; n++)e = 1 & e ? 3988292384 ^ e >>> 1 : e >>> 1;
                        t[r] = e;
                    }
                    return t;
                }();
                e.exports = function(e, r, n, i) {
                    var o = t, a = i + n;
                    e ^= -1;
                    for(var s = i; s < a; s++)e = e >>> 8 ^ o[255 & (e ^ r[s])];
                    return -1 ^ e;
                };
            },
            54151: (e, t, r)=>{
                "use strict";
                var n, i = r(21307), o = r(25280), a = r(57506), s = r(28548), u = r(78021), c = 0, f = 4, d = 0, l = -2, h = -1, p = 1, b = 4, y = 2, v = 8, m = 9, g = 286, w = 30, k = 19, _ = 2 * g + 1, A = 15, E = 3, S = 258, x = S + E + 1, B = 42, O = 103, P = 113, I = 666, T = 1, C = 2, M = 3, R = 4;
                function U(e, t) {
                    return e.msg = u[t], t;
                }
                function N(e) {
                    return (e << 1) - (e > 4 ? 9 : 0);
                }
                function j(e) {
                    for(var t = e.length; --t >= 0;)e[t] = 0;
                }
                function L(e) {
                    var t = e.state, r = t.pending;
                    r > e.avail_out && (r = e.avail_out), 0 !== r && (i.arraySet(e.output, t.pending_buf, t.pending_out, r, e.next_out), e.next_out += r, t.pending_out += r, e.total_out += r, e.avail_out -= r, t.pending -= r, 0 === t.pending && (t.pending_out = 0));
                }
                function F(e, t) {
                    o._tr_flush_block(e, e.block_start >= 0 ? e.block_start : -1, e.strstart - e.block_start, t), e.block_start = e.strstart, L(e.strm);
                }
                function D(e, t) {
                    e.pending_buf[e.pending++] = t;
                }
                function H(e, t) {
                    e.pending_buf[e.pending++] = t >>> 8 & 255, e.pending_buf[e.pending++] = 255 & t;
                }
                function z(e, t) {
                    var r, n, i = e.max_chain_length, o = e.strstart, a = e.prev_length, s = e.nice_match, u = e.strstart > e.w_size - x ? e.strstart - (e.w_size - x) : 0, c = e.window, f = e.w_mask, d = e.prev, l = e.strstart + S, h = c[o + a - 1], p = c[o + a];
                    e.prev_length >= e.good_match && (i >>= 2), s > e.lookahead && (s = e.lookahead);
                    do if (c[(r = t) + a] === p && c[r + a - 1] === h && c[r] === c[o] && c[++r] === c[o + 1]) {
                        o += 2, r++;
                        do ;
                        while (c[++o] === c[++r] && c[++o] === c[++r] && c[++o] === c[++r] && c[++o] === c[++r] && c[++o] === c[++r] && c[++o] === c[++r] && c[++o] === c[++r] && c[++o] === c[++r] && o < l);
                        if (n = S - (l - o), o = l - S, n > a) {
                            if (e.match_start = t, a = n, n >= s) break;
                            h = c[o + a - 1], p = c[o + a];
                        }
                    }
                    while ((t = d[t & f]) > u && 0 != --i);
                    return a <= e.lookahead ? a : e.lookahead;
                }
                function q(e) {
                    var t, r, n, o, u, c, f, d, l, h, p = e.w_size;
                    do {
                        if (o = e.window_size - e.lookahead - e.strstart, e.strstart >= p + (p - x)) {
                            i.arraySet(e.window, e.window, p, p, 0), e.match_start -= p, e.strstart -= p, e.block_start -= p, t = r = e.hash_size;
                            do n = e.head[--t], e.head[t] = n >= p ? n - p : 0;
                            while (--r);
                            t = r = p;
                            do n = e.prev[--t], e.prev[t] = n >= p ? n - p : 0;
                            while (--r);
                            o += p;
                        }
                        if (0 === e.strm.avail_in) break;
                        if (c = e.strm, f = e.window, d = e.strstart + e.lookahead, l = o, h = void 0, (h = c.avail_in) > l && (h = l), r = 0 === h ? 0 : (c.avail_in -= h, i.arraySet(f, c.input, c.next_in, h, d), 1 === c.state.wrap ? c.adler = a(c.adler, f, h, d) : 2 === c.state.wrap && (c.adler = s(c.adler, f, h, d)), c.next_in += h, c.total_in += h, h), e.lookahead += r, e.lookahead + e.insert >= E) for(u = e.strstart - e.insert, e.ins_h = e.window[u], e.ins_h = (e.ins_h << e.hash_shift ^ e.window[u + 1]) & e.hash_mask; e.insert && (e.ins_h = (e.ins_h << e.hash_shift ^ e.window[u + E - 1]) & e.hash_mask, e.prev[u & e.w_mask] = e.head[e.ins_h], e.head[e.ins_h] = u, u++, e.insert--, !(e.lookahead + e.insert < E)););
                    }while (e.lookahead < x && 0 !== e.strm.avail_in);
                }
                function K(e, t) {
                    for(var r, n;;){
                        if (e.lookahead < x) {
                            if (q(e), e.lookahead < x && t === c) return T;
                            if (0 === e.lookahead) break;
                        }
                        if (r = 0, e.lookahead >= E && (e.ins_h = (e.ins_h << e.hash_shift ^ e.window[e.strstart + E - 1]) & e.hash_mask, r = e.prev[e.strstart & e.w_mask] = e.head[e.ins_h], e.head[e.ins_h] = e.strstart), 0 !== r && e.strstart - r <= e.w_size - x && (e.match_length = z(e, r)), e.match_length >= E) {
                            if (n = o._tr_tally(e, e.strstart - e.match_start, e.match_length - E), e.lookahead -= e.match_length, e.match_length <= e.max_lazy_match && e.lookahead >= E) {
                                e.match_length--;
                                do e.strstart++, e.ins_h = (e.ins_h << e.hash_shift ^ e.window[e.strstart + E - 1]) & e.hash_mask, r = e.prev[e.strstart & e.w_mask] = e.head[e.ins_h], e.head[e.ins_h] = e.strstart;
                                while (0 != --e.match_length);
                                e.strstart++;
                            } else e.strstart += e.match_length, e.match_length = 0, e.ins_h = e.window[e.strstart], e.ins_h = (e.ins_h << e.hash_shift ^ e.window[e.strstart + 1]) & e.hash_mask;
                        } else n = o._tr_tally(e, 0, e.window[e.strstart]), e.lookahead--, e.strstart++;
                        if (n && (F(e, !1), 0 === e.strm.avail_out)) return T;
                    }
                    return e.insert = e.strstart < E - 1 ? e.strstart : E - 1, t === f ? (F(e, !0), 0 === e.strm.avail_out ? M : R) : e.last_lit && (F(e, !1), 0 === e.strm.avail_out) ? T : C;
                }
                function G(e, t) {
                    for(var r, n, i;;){
                        if (e.lookahead < x) {
                            if (q(e), e.lookahead < x && t === c) return T;
                            if (0 === e.lookahead) break;
                        }
                        if (r = 0, e.lookahead >= E && (e.ins_h = (e.ins_h << e.hash_shift ^ e.window[e.strstart + E - 1]) & e.hash_mask, r = e.prev[e.strstart & e.w_mask] = e.head[e.ins_h], e.head[e.ins_h] = e.strstart), e.prev_length = e.match_length, e.prev_match = e.match_start, e.match_length = E - 1, 0 !== r && e.prev_length < e.max_lazy_match && e.strstart - r <= e.w_size - x && (e.match_length = z(e, r), e.match_length <= 5 && (e.strategy === p || e.match_length === E && e.strstart - e.match_start > 4096) && (e.match_length = E - 1)), e.prev_length >= E && e.match_length <= e.prev_length) {
                            i = e.strstart + e.lookahead - E, n = o._tr_tally(e, e.strstart - 1 - e.prev_match, e.prev_length - E), e.lookahead -= e.prev_length - 1, e.prev_length -= 2;
                            do ++e.strstart <= i && (e.ins_h = (e.ins_h << e.hash_shift ^ e.window[e.strstart + E - 1]) & e.hash_mask, r = e.prev[e.strstart & e.w_mask] = e.head[e.ins_h], e.head[e.ins_h] = e.strstart);
                            while (0 != --e.prev_length);
                            if (e.match_available = 0, e.match_length = E - 1, e.strstart++, n && (F(e, !1), 0 === e.strm.avail_out)) return T;
                        } else if (e.match_available) {
                            if ((n = o._tr_tally(e, 0, e.window[e.strstart - 1])) && F(e, !1), e.strstart++, e.lookahead--, 0 === e.strm.avail_out) return T;
                        } else e.match_available = 1, e.strstart++, e.lookahead--;
                    }
                    return e.match_available && (n = o._tr_tally(e, 0, e.window[e.strstart - 1]), e.match_available = 0), e.insert = e.strstart < E - 1 ? e.strstart : E - 1, t === f ? (F(e, !0), 0 === e.strm.avail_out ? M : R) : e.last_lit && (F(e, !1), 0 === e.strm.avail_out) ? T : C;
                }
                function V(e, t, r, n, i) {
                    this.good_length = e, this.max_lazy = t, this.nice_length = r, this.max_chain = n, this.func = i;
                }
                function Z() {
                    this.strm = null, this.status = 0, this.pending_buf = null, this.pending_buf_size = 0, this.pending_out = 0, this.pending = 0, this.wrap = 0, this.gzhead = null, this.gzindex = 0, this.method = v, this.last_flush = -1, this.w_size = 0, this.w_bits = 0, this.w_mask = 0, this.window = null, this.window_size = 0, this.prev = null, this.head = null, this.ins_h = 0, this.hash_size = 0, this.hash_bits = 0, this.hash_mask = 0, this.hash_shift = 0, this.block_start = 0, this.match_length = 0, this.prev_match = 0, this.match_available = 0, this.strstart = 0, this.match_start = 0, this.lookahead = 0, this.prev_length = 0, this.max_chain_length = 0, this.max_lazy_match = 0, this.level = 0, this.strategy = 0, this.good_match = 0, this.nice_match = 0, this.dyn_ltree = new i.Buf16(2 * _), this.dyn_dtree = new i.Buf16(2 * (2 * w + 1)), this.bl_tree = new i.Buf16(2 * (2 * k + 1)), j(this.dyn_ltree), j(this.dyn_dtree), j(this.bl_tree), this.l_desc = null, this.d_desc = null, this.bl_desc = null, this.bl_count = new i.Buf16(A + 1), this.heap = new i.Buf16(2 * g + 1), j(this.heap), this.heap_len = 0, this.heap_max = 0, this.depth = new i.Buf16(2 * g + 1), j(this.depth), this.l_buf = 0, this.lit_bufsize = 0, this.last_lit = 0, this.d_buf = 0, this.opt_len = 0, this.static_len = 0, this.matches = 0, this.insert = 0, this.bi_buf = 0, this.bi_valid = 0;
                }
                function W(e) {
                    var t;
                    return e && e.state ? (e.total_in = e.total_out = 0, e.data_type = y, (t = e.state).pending = 0, t.pending_out = 0, t.wrap < 0 && (t.wrap = -t.wrap), t.status = t.wrap ? B : P, e.adler = 2 === t.wrap ? 0 : 1, t.last_flush = c, o._tr_init(t), d) : U(e, l);
                }
                function J(e) {
                    var t, r = W(e);
                    return r === d && ((t = e.state).window_size = 2 * t.w_size, j(t.head), t.max_lazy_match = n[t.level].max_lazy, t.good_match = n[t.level].good_length, t.nice_match = n[t.level].nice_length, t.max_chain_length = n[t.level].max_chain, t.strstart = 0, t.block_start = 0, t.lookahead = 0, t.insert = 0, t.match_length = t.prev_length = E - 1, t.match_available = 0, t.ins_h = 0), r;
                }
                function Y(e, t, r, n, o, a) {
                    if (!e) return l;
                    var s = 1;
                    if (t === h && (t = 6), n < 0 ? (s = 0, n = -n) : n > 15 && (s = 2, n -= 16), o < 1 || o > m || r !== v || n < 8 || n > 15 || t < 0 || t > 9 || a < 0 || a > b) return U(e, l);
                    8 === n && (n = 9);
                    var u = new Z;
                    return e.state = u, u.strm = e, u.wrap = s, u.gzhead = null, u.w_bits = n, u.w_size = 1 << u.w_bits, u.w_mask = u.w_size - 1, u.hash_bits = o + 7, u.hash_size = 1 << u.hash_bits, u.hash_mask = u.hash_size - 1, u.hash_shift = ~~((u.hash_bits + E - 1) / E), u.window = new i.Buf8(2 * u.w_size), u.head = new i.Buf16(u.hash_size), u.prev = new i.Buf16(u.w_size), u.lit_bufsize = 1 << o + 6, u.pending_buf_size = 4 * u.lit_bufsize, u.pending_buf = new i.Buf8(u.pending_buf_size), u.d_buf = 1 * u.lit_bufsize, u.l_buf = 3 * u.lit_bufsize, u.level = t, u.strategy = a, u.method = r, J(e);
                }
                n = [
                    new V(0, 0, 0, 0, function(e, t) {
                        var r = 65535;
                        for(r > e.pending_buf_size - 5 && (r = e.pending_buf_size - 5);;){
                            if (e.lookahead <= 1) {
                                if (q(e), 0 === e.lookahead && t === c) return T;
                                if (0 === e.lookahead) break;
                            }
                            e.strstart += e.lookahead, e.lookahead = 0;
                            var n = e.block_start + r;
                            if ((0 === e.strstart || e.strstart >= n) && (e.lookahead = e.strstart - n, e.strstart = n, F(e, !1), 0 === e.strm.avail_out)) return T;
                            if (e.strstart - e.block_start >= e.w_size - x && (F(e, !1), 0 === e.strm.avail_out)) return T;
                        }
                        return e.insert = 0, t === f ? (F(e, !0), 0 === e.strm.avail_out ? M : R) : (e.strstart > e.block_start && (F(e, !1), e.strm.avail_out), T);
                    }),
                    new V(4, 4, 8, 4, K),
                    new V(4, 5, 16, 8, K),
                    new V(4, 6, 32, 32, K),
                    new V(4, 4, 16, 16, G),
                    new V(8, 16, 32, 32, G),
                    new V(8, 16, 128, 128, G),
                    new V(8, 32, 128, 256, G),
                    new V(32, 128, 258, 1024, G),
                    new V(32, 258, 258, 4096, G)
                ], t.deflateInit = function(e, t) {
                    return Y(e, t, v, 15, 8, 0);
                }, t.deflateInit2 = Y, t.deflateReset = J, t.deflateResetKeep = W, t.deflateSetHeader = function(e, t) {
                    return e && e.state ? 2 !== e.state.wrap ? l : (e.state.gzhead = t, d) : l;
                }, t.deflate = function(e, t) {
                    var r, i, a, u;
                    if (!e || !e.state || t > 5 || t < 0) return e ? U(e, l) : l;
                    if (i = e.state, !e.output || !e.input && 0 !== e.avail_in || i.status === I && t !== f) return U(e, 0 === e.avail_out ? -5 : l);
                    if (i.strm = e, r = i.last_flush, i.last_flush = t, i.status === B) {
                        if (2 === i.wrap) e.adler = 0, D(i, 31), D(i, 139), D(i, 8), i.gzhead ? (D(i, (i.gzhead.text ? 1 : 0) + (i.gzhead.hcrc ? 2 : 0) + (i.gzhead.extra ? 4 : 0) + (i.gzhead.name ? 8 : 0) + (i.gzhead.comment ? 16 : 0)), D(i, 255 & i.gzhead.time), D(i, i.gzhead.time >> 8 & 255), D(i, i.gzhead.time >> 16 & 255), D(i, i.gzhead.time >> 24 & 255), D(i, 9 === i.level ? 2 : i.strategy >= 2 || i.level < 2 ? 4 : 0), D(i, 255 & i.gzhead.os), i.gzhead.extra && i.gzhead.extra.length && (D(i, 255 & i.gzhead.extra.length), D(i, i.gzhead.extra.length >> 8 & 255)), i.gzhead.hcrc && (e.adler = s(e.adler, i.pending_buf, i.pending, 0)), i.gzindex = 0, i.status = 69) : (D(i, 0), D(i, 0), D(i, 0), D(i, 0), D(i, 0), D(i, 9 === i.level ? 2 : i.strategy >= 2 || i.level < 2 ? 4 : 0), D(i, 3), i.status = P);
                        else {
                            var h = v + (i.w_bits - 8 << 4) << 8;
                            h |= (i.strategy >= 2 || i.level < 2 ? 0 : i.level < 6 ? 1 : 6 === i.level ? 2 : 3) << 6, 0 !== i.strstart && (h |= 32), h += 31 - h % 31, i.status = P, H(i, h), 0 !== i.strstart && (H(i, e.adler >>> 16), H(i, 65535 & e.adler)), e.adler = 1;
                        }
                    }
                    if (69 === i.status) {
                        if (i.gzhead.extra) {
                            for(a = i.pending; i.gzindex < (65535 & i.gzhead.extra.length) && (i.pending !== i.pending_buf_size || (i.gzhead.hcrc && i.pending > a && (e.adler = s(e.adler, i.pending_buf, i.pending - a, a)), L(e), a = i.pending, i.pending !== i.pending_buf_size));)D(i, 255 & i.gzhead.extra[i.gzindex]), i.gzindex++;
                            i.gzhead.hcrc && i.pending > a && (e.adler = s(e.adler, i.pending_buf, i.pending - a, a)), i.gzindex === i.gzhead.extra.length && (i.gzindex = 0, i.status = 73);
                        } else i.status = 73;
                    }
                    if (73 === i.status) {
                        if (i.gzhead.name) {
                            a = i.pending;
                            do {
                                if (i.pending === i.pending_buf_size && (i.gzhead.hcrc && i.pending > a && (e.adler = s(e.adler, i.pending_buf, i.pending - a, a)), L(e), a = i.pending, i.pending === i.pending_buf_size)) {
                                    u = 1;
                                    break;
                                }
                                u = i.gzindex < i.gzhead.name.length ? 255 & i.gzhead.name.charCodeAt(i.gzindex++) : 0, D(i, u);
                            }while (0 !== u);
                            i.gzhead.hcrc && i.pending > a && (e.adler = s(e.adler, i.pending_buf, i.pending - a, a)), 0 === u && (i.gzindex = 0, i.status = 91);
                        } else i.status = 91;
                    }
                    if (91 === i.status) {
                        if (i.gzhead.comment) {
                            a = i.pending;
                            do {
                                if (i.pending === i.pending_buf_size && (i.gzhead.hcrc && i.pending > a && (e.adler = s(e.adler, i.pending_buf, i.pending - a, a)), L(e), a = i.pending, i.pending === i.pending_buf_size)) {
                                    u = 1;
                                    break;
                                }
                                u = i.gzindex < i.gzhead.comment.length ? 255 & i.gzhead.comment.charCodeAt(i.gzindex++) : 0, D(i, u);
                            }while (0 !== u);
                            i.gzhead.hcrc && i.pending > a && (e.adler = s(e.adler, i.pending_buf, i.pending - a, a)), 0 === u && (i.status = O);
                        } else i.status = O;
                    }
                    if (i.status === O && (i.gzhead.hcrc ? (i.pending + 2 > i.pending_buf_size && L(e), i.pending + 2 <= i.pending_buf_size && (D(i, 255 & e.adler), D(i, e.adler >> 8 & 255), e.adler = 0, i.status = P)) : i.status = P), 0 !== i.pending) {
                        if (L(e), 0 === e.avail_out) return i.last_flush = -1, d;
                    } else if (0 === e.avail_in && N(t) <= N(r) && t !== f) return U(e, -5);
                    if (i.status === I && 0 !== e.avail_in) return U(e, -5);
                    if (0 !== e.avail_in || 0 !== i.lookahead || t !== c && i.status !== I) {
                        var p = 2 === i.strategy ? function(e, t) {
                            for(var r;;){
                                if (0 === e.lookahead && (q(e), 0 === e.lookahead)) {
                                    if (t === c) return T;
                                    break;
                                }
                                if (e.match_length = 0, r = o._tr_tally(e, 0, e.window[e.strstart]), e.lookahead--, e.strstart++, r && (F(e, !1), 0 === e.strm.avail_out)) return T;
                            }
                            return e.insert = 0, t === f ? (F(e, !0), 0 === e.strm.avail_out ? M : R) : e.last_lit && (F(e, !1), 0 === e.strm.avail_out) ? T : C;
                        }(i, t) : 3 === i.strategy ? function(e, t) {
                            for(var r, n, i, a, s = e.window;;){
                                if (e.lookahead <= S) {
                                    if (q(e), e.lookahead <= S && t === c) return T;
                                    if (0 === e.lookahead) break;
                                }
                                if (e.match_length = 0, e.lookahead >= E && e.strstart > 0 && (n = s[i = e.strstart - 1]) === s[++i] && n === s[++i] && n === s[++i]) {
                                    a = e.strstart + S;
                                    do ;
                                    while (n === s[++i] && n === s[++i] && n === s[++i] && n === s[++i] && n === s[++i] && n === s[++i] && n === s[++i] && n === s[++i] && i < a);
                                    e.match_length = S - (a - i), e.match_length > e.lookahead && (e.match_length = e.lookahead);
                                }
                                if (e.match_length >= E ? (r = o._tr_tally(e, 1, e.match_length - E), e.lookahead -= e.match_length, e.strstart += e.match_length, e.match_length = 0) : (r = o._tr_tally(e, 0, e.window[e.strstart]), e.lookahead--, e.strstart++), r && (F(e, !1), 0 === e.strm.avail_out)) return T;
                            }
                            return e.insert = 0, t === f ? (F(e, !0), 0 === e.strm.avail_out ? M : R) : e.last_lit && (F(e, !1), 0 === e.strm.avail_out) ? T : C;
                        }(i, t) : n[i.level].func(i, t);
                        if (p !== M && p !== R || (i.status = I), p === T || p === M) return 0 === e.avail_out && (i.last_flush = -1), d;
                        if (p === C && (1 === t ? o._tr_align(i) : 5 !== t && (o._tr_stored_block(i, 0, 0, !1), 3 === t && (j(i.head), 0 === i.lookahead && (i.strstart = 0, i.block_start = 0, i.insert = 0))), L(e), 0 === e.avail_out)) return i.last_flush = -1, d;
                    }
                    return t !== f ? d : i.wrap <= 0 ? 1 : (2 === i.wrap ? (D(i, 255 & e.adler), D(i, e.adler >> 8 & 255), D(i, e.adler >> 16 & 255), D(i, e.adler >> 24 & 255), D(i, 255 & e.total_in), D(i, e.total_in >> 8 & 255), D(i, e.total_in >> 16 & 255), D(i, e.total_in >> 24 & 255)) : (H(i, e.adler >>> 16), H(i, 65535 & e.adler)), L(e), i.wrap > 0 && (i.wrap = -i.wrap), 0 !== i.pending ? d : 1);
                }, t.deflateEnd = function(e) {
                    var t;
                    return e && e.state ? (t = e.state.status) !== B && 69 !== t && 73 !== t && 91 !== t && t !== O && t !== P && t !== I ? U(e, l) : (e.state = null, t === P ? U(e, -3) : d) : l;
                }, t.deflateSetDictionary = function(e, t) {
                    var r, n, o, s, u, c, f, h, p = t.length;
                    if (!e || !e.state) return l;
                    if (2 === (s = (r = e.state).wrap) || 1 === s && r.status !== B || r.lookahead) return l;
                    for(1 === s && (e.adler = a(e.adler, t, p, 0)), r.wrap = 0, p >= r.w_size && (0 === s && (j(r.head), r.strstart = 0, r.block_start = 0, r.insert = 0), h = new i.Buf8(r.w_size), i.arraySet(h, t, p - r.w_size, r.w_size, 0), t = h, p = r.w_size), u = e.avail_in, c = e.next_in, f = e.input, e.avail_in = p, e.next_in = 0, e.input = t, q(r); r.lookahead >= E;){
                        n = r.strstart, o = r.lookahead - (E - 1);
                        do r.ins_h = (r.ins_h << r.hash_shift ^ r.window[n + E - 1]) & r.hash_mask, r.prev[n & r.w_mask] = r.head[r.ins_h], r.head[r.ins_h] = n, n++;
                        while (--o);
                        r.strstart = n, r.lookahead = E - 1, q(r);
                    }
                    return r.strstart += r.lookahead, r.block_start = r.strstart, r.insert = r.lookahead, r.lookahead = 0, r.match_length = r.prev_length = E - 1, r.match_available = 0, e.next_in = c, e.input = f, e.avail_in = u, r.wrap = s, d;
                }, t.deflateInfo = "pako deflate (from Nodeca project)";
            },
            52399: (e)=>{
                "use strict";
                e.exports = function(e, t) {
                    var r, n, i, o, a, s, u, c, f, d, l, h, p, b, y, v, m, g, w, k, _, A, E, S, x;
                    r = e.state, n = e.next_in, S = e.input, i = n + (e.avail_in - 5), o = e.next_out, x = e.output, a = o - (t - e.avail_out), s = o + (e.avail_out - 257), u = r.dmax, c = r.wsize, f = r.whave, d = r.wnext, l = r.window, h = r.hold, p = r.bits, b = r.lencode, y = r.distcode, v = (1 << r.lenbits) - 1, m = (1 << r.distbits) - 1;
                    e: do {
                        p < 15 && (h += S[n++] << p, p += 8, h += S[n++] << p, p += 8), g = b[h & v];
                        t: for(;;){
                            if (h >>>= w = g >>> 24, p -= w, 0 == (w = g >>> 16 & 255)) x[o++] = 65535 & g;
                            else {
                                if (!(16 & w)) {
                                    if (0 == (64 & w)) {
                                        g = b[(65535 & g) + (h & (1 << w) - 1)];
                                        continue t;
                                    }
                                    if (32 & w) {
                                        r.mode = 12;
                                        break e;
                                    }
                                    e.msg = "invalid literal/length code", r.mode = 30;
                                    break e;
                                }
                                k = 65535 & g, (w &= 15) && (p < w && (h += S[n++] << p, p += 8), k += h & (1 << w) - 1, h >>>= w, p -= w), p < 15 && (h += S[n++] << p, p += 8, h += S[n++] << p, p += 8), g = y[h & m];
                                r: for(;;){
                                    if (h >>>= w = g >>> 24, p -= w, !(16 & (w = g >>> 16 & 255))) {
                                        if (0 == (64 & w)) {
                                            g = y[(65535 & g) + (h & (1 << w) - 1)];
                                            continue r;
                                        }
                                        e.msg = "invalid distance code", r.mode = 30;
                                        break e;
                                    }
                                    if (_ = 65535 & g, p < (w &= 15) && (h += S[n++] << p, (p += 8) < w && (h += S[n++] << p, p += 8)), (_ += h & (1 << w) - 1) > u) {
                                        e.msg = "invalid distance too far back", r.mode = 30;
                                        break e;
                                    }
                                    if (h >>>= w, p -= w, _ > (w = o - a)) {
                                        if ((w = _ - w) > f && r.sane) {
                                            e.msg = "invalid distance too far back", r.mode = 30;
                                            break e;
                                        }
                                        if (A = 0, E = l, 0 === d) {
                                            if (A += c - w, w < k) {
                                                k -= w;
                                                do x[o++] = l[A++];
                                                while (--w);
                                                A = o - _, E = x;
                                            }
                                        } else if (d < w) {
                                            if (A += c + d - w, (w -= d) < k) {
                                                k -= w;
                                                do x[o++] = l[A++];
                                                while (--w);
                                                if (A = 0, d < k) {
                                                    k -= w = d;
                                                    do x[o++] = l[A++];
                                                    while (--w);
                                                    A = o - _, E = x;
                                                }
                                            }
                                        } else if (A += d - w, w < k) {
                                            k -= w;
                                            do x[o++] = l[A++];
                                            while (--w);
                                            A = o - _, E = x;
                                        }
                                        for(; k > 2;)x[o++] = E[A++], x[o++] = E[A++], x[o++] = E[A++], k -= 3;
                                        k && (x[o++] = E[A++], k > 1 && (x[o++] = E[A++]));
                                    } else {
                                        A = o - _;
                                        do x[o++] = x[A++], x[o++] = x[A++], x[o++] = x[A++], k -= 3;
                                        while (k > 2);
                                        k && (x[o++] = x[A++], k > 1 && (x[o++] = x[A++]));
                                    }
                                    break;
                                }
                            }
                            break;
                        }
                    }while (n < i && o < s);
                    n -= k = p >> 3, h &= (1 << (p -= k << 3)) - 1, e.next_in = n, e.next_out = o, e.avail_in = n < i ? i - n + 5 : 5 - (n - i), e.avail_out = o < s ? s - o + 257 : 257 - (o - s), r.hold = h, r.bits = p;
                };
            },
            63534: (e, t, r)=>{
                "use strict";
                var n = r(21307), i = r(57506), o = r(28548), a = r(52399), s = r(51721), u = 1, c = 2, f = 0, d = -2, l = 1, h = 12, p = 30, b = 852, y = 592;
                function v(e) {
                    return (e >>> 24 & 255) + (e >>> 8 & 65280) + ((65280 & e) << 8) + ((255 & e) << 24);
                }
                function m() {
                    this.mode = 0, this.last = !1, this.wrap = 0, this.havedict = !1, this.flags = 0, this.dmax = 0, this.check = 0, this.total = 0, this.head = null, this.wbits = 0, this.wsize = 0, this.whave = 0, this.wnext = 0, this.window = null, this.hold = 0, this.bits = 0, this.length = 0, this.offset = 0, this.extra = 0, this.lencode = null, this.distcode = null, this.lenbits = 0, this.distbits = 0, this.ncode = 0, this.nlen = 0, this.ndist = 0, this.have = 0, this.next = null, this.lens = new n.Buf16(320), this.work = new n.Buf16(288), this.lendyn = null, this.distdyn = null, this.sane = 0, this.back = 0, this.was = 0;
                }
                function g(e) {
                    var t;
                    return e && e.state ? (t = e.state, e.total_in = e.total_out = t.total = 0, e.msg = "", t.wrap && (e.adler = 1 & t.wrap), t.mode = l, t.last = 0, t.havedict = 0, t.dmax = 32768, t.head = null, t.hold = 0, t.bits = 0, t.lencode = t.lendyn = new n.Buf32(b), t.distcode = t.distdyn = new n.Buf32(y), t.sane = 1, t.back = -1, f) : d;
                }
                function w(e) {
                    var t;
                    return e && e.state ? ((t = e.state).wsize = 0, t.whave = 0, t.wnext = 0, g(e)) : d;
                }
                function k(e, t) {
                    var r, n;
                    return e && e.state ? (n = e.state, t < 0 ? (r = 0, t = -t) : (r = 1 + (t >> 4), t < 48 && (t &= 15)), t && (t < 8 || t > 15) ? d : (null !== n.window && n.wbits !== t && (n.window = null), n.wrap = r, n.wbits = t, w(e))) : d;
                }
                function _(e, t) {
                    var r, n;
                    return e ? (n = new m, e.state = n, n.window = null, (r = k(e, t)) !== f && (e.state = null), r) : d;
                }
                var A, E, S = !0;
                function x(e) {
                    if (S) {
                        var t;
                        for(A = new n.Buf32(512), E = new n.Buf32(32), t = 0; t < 144;)e.lens[t++] = 8;
                        for(; t < 256;)e.lens[t++] = 9;
                        for(; t < 280;)e.lens[t++] = 7;
                        for(; t < 288;)e.lens[t++] = 8;
                        for(s(u, e.lens, 0, 288, A, 0, e.work, {
                            bits: 9
                        }), t = 0; t < 32;)e.lens[t++] = 5;
                        s(c, e.lens, 0, 32, E, 0, e.work, {
                            bits: 5
                        }), S = !1;
                    }
                    e.lencode = A, e.lenbits = 9, e.distcode = E, e.distbits = 5;
                }
                function B(e, t, r, i) {
                    var o, a = e.state;
                    return null === a.window && (a.wsize = 1 << a.wbits, a.wnext = 0, a.whave = 0, a.window = new n.Buf8(a.wsize)), i >= a.wsize ? (n.arraySet(a.window, t, r - a.wsize, a.wsize, 0), a.wnext = 0, a.whave = a.wsize) : ((o = a.wsize - a.wnext) > i && (o = i), n.arraySet(a.window, t, r - i, o, a.wnext), (i -= o) ? (n.arraySet(a.window, t, r - i, i, 0), a.wnext = i, a.whave = a.wsize) : (a.wnext += o, a.wnext === a.wsize && (a.wnext = 0), a.whave < a.wsize && (a.whave += o))), 0;
                }
                t.inflateReset = w, t.inflateReset2 = k, t.inflateResetKeep = g, t.inflateInit = function(e) {
                    return _(e, 15);
                }, t.inflateInit2 = _, t.inflate = function(e, t) {
                    var r, b, y, m, g, w, k, _, A, E, S, O, P, I, T, C, M, R, U, N, j, L, F, D, H = 0, z = new n.Buf8(4), q = [
                        16,
                        17,
                        18,
                        0,
                        8,
                        7,
                        9,
                        6,
                        10,
                        5,
                        11,
                        4,
                        12,
                        3,
                        13,
                        2,
                        14,
                        1,
                        15
                    ];
                    if (!e || !e.state || !e.output || !e.input && 0 !== e.avail_in) return d;
                    (r = e.state).mode === h && (r.mode = 13), g = e.next_out, y = e.output, k = e.avail_out, m = e.next_in, b = e.input, w = e.avail_in, _ = r.hold, A = r.bits, E = w, S = k, L = f;
                    e: for(;;)switch(r.mode){
                        case l:
                            if (0 === r.wrap) {
                                r.mode = 13;
                                break;
                            }
                            for(; A < 16;){
                                if (0 === w) break e;
                                w--, _ += b[m++] << A, A += 8;
                            }
                            if (2 & r.wrap && 35615 === _) {
                                r.check = 0, z[0] = 255 & _, z[1] = _ >>> 8 & 255, r.check = o(r.check, z, 2, 0), _ = 0, A = 0, r.mode = 2;
                                break;
                            }
                            if (r.flags = 0, r.head && (r.head.done = !1), !(1 & r.wrap) || (((255 & _) << 8) + (_ >> 8)) % 31) {
                                e.msg = "incorrect header check", r.mode = p;
                                break;
                            }
                            if (8 != (15 & _)) {
                                e.msg = "unknown compression method", r.mode = p;
                                break;
                            }
                            if (A -= 4, j = 8 + (15 & (_ >>>= 4)), 0 === r.wbits) r.wbits = j;
                            else if (j > r.wbits) {
                                e.msg = "invalid window size", r.mode = p;
                                break;
                            }
                            r.dmax = 1 << j, e.adler = r.check = 1, r.mode = 512 & _ ? 10 : h, _ = 0, A = 0;
                            break;
                        case 2:
                            for(; A < 16;){
                                if (0 === w) break e;
                                w--, _ += b[m++] << A, A += 8;
                            }
                            if (r.flags = _, 8 != (255 & r.flags)) {
                                e.msg = "unknown compression method", r.mode = p;
                                break;
                            }
                            if (57344 & r.flags) {
                                e.msg = "unknown header flags set", r.mode = p;
                                break;
                            }
                            r.head && (r.head.text = _ >> 8 & 1), 512 & r.flags && (z[0] = 255 & _, z[1] = _ >>> 8 & 255, r.check = o(r.check, z, 2, 0)), _ = 0, A = 0, r.mode = 3;
                        case 3:
                            for(; A < 32;){
                                if (0 === w) break e;
                                w--, _ += b[m++] << A, A += 8;
                            }
                            r.head && (r.head.time = _), 512 & r.flags && (z[0] = 255 & _, z[1] = _ >>> 8 & 255, z[2] = _ >>> 16 & 255, z[3] = _ >>> 24 & 255, r.check = o(r.check, z, 4, 0)), _ = 0, A = 0, r.mode = 4;
                        case 4:
                            for(; A < 16;){
                                if (0 === w) break e;
                                w--, _ += b[m++] << A, A += 8;
                            }
                            r.head && (r.head.xflags = 255 & _, r.head.os = _ >> 8), 512 & r.flags && (z[0] = 255 & _, z[1] = _ >>> 8 & 255, r.check = o(r.check, z, 2, 0)), _ = 0, A = 0, r.mode = 5;
                        case 5:
                            if (1024 & r.flags) {
                                for(; A < 16;){
                                    if (0 === w) break e;
                                    w--, _ += b[m++] << A, A += 8;
                                }
                                r.length = _, r.head && (r.head.extra_len = _), 512 & r.flags && (z[0] = 255 & _, z[1] = _ >>> 8 & 255, r.check = o(r.check, z, 2, 0)), _ = 0, A = 0;
                            } else r.head && (r.head.extra = null);
                            r.mode = 6;
                        case 6:
                            if (1024 & r.flags && ((O = r.length) > w && (O = w), O && (r.head && (j = r.head.extra_len - r.length, r.head.extra || (r.head.extra = new Array(r.head.extra_len)), n.arraySet(r.head.extra, b, m, O, j)), 512 & r.flags && (r.check = o(r.check, b, O, m)), w -= O, m += O, r.length -= O), r.length)) break e;
                            r.length = 0, r.mode = 7;
                        case 7:
                            if (2048 & r.flags) {
                                if (0 === w) break e;
                                O = 0;
                                do j = b[m + O++], r.head && j && r.length < 65536 && (r.head.name += String.fromCharCode(j));
                                while (j && O < w);
                                if (512 & r.flags && (r.check = o(r.check, b, O, m)), w -= O, m += O, j) break e;
                            } else r.head && (r.head.name = null);
                            r.length = 0, r.mode = 8;
                        case 8:
                            if (4096 & r.flags) {
                                if (0 === w) break e;
                                O = 0;
                                do j = b[m + O++], r.head && j && r.length < 65536 && (r.head.comment += String.fromCharCode(j));
                                while (j && O < w);
                                if (512 & r.flags && (r.check = o(r.check, b, O, m)), w -= O, m += O, j) break e;
                            } else r.head && (r.head.comment = null);
                            r.mode = 9;
                        case 9:
                            if (512 & r.flags) {
                                for(; A < 16;){
                                    if (0 === w) break e;
                                    w--, _ += b[m++] << A, A += 8;
                                }
                                if (_ !== (65535 & r.check)) {
                                    e.msg = "header crc mismatch", r.mode = p;
                                    break;
                                }
                                _ = 0, A = 0;
                            }
                            r.head && (r.head.hcrc = r.flags >> 9 & 1, r.head.done = !0), e.adler = r.check = 0, r.mode = h;
                            break;
                        case 10:
                            for(; A < 32;){
                                if (0 === w) break e;
                                w--, _ += b[m++] << A, A += 8;
                            }
                            e.adler = r.check = v(_), _ = 0, A = 0, r.mode = 11;
                        case 11:
                            if (0 === r.havedict) return e.next_out = g, e.avail_out = k, e.next_in = m, e.avail_in = w, r.hold = _, r.bits = A, 2;
                            e.adler = r.check = 1, r.mode = h;
                        case h:
                            if (5 === t || 6 === t) break e;
                        case 13:
                            if (r.last) {
                                _ >>>= 7 & A, A -= 7 & A, r.mode = 27;
                                break;
                            }
                            for(; A < 3;){
                                if (0 === w) break e;
                                w--, _ += b[m++] << A, A += 8;
                            }
                            switch(r.last = 1 & _, A -= 1, 3 & (_ >>>= 1)){
                                case 0:
                                    r.mode = 14;
                                    break;
                                case 1:
                                    if (x(r), r.mode = 20, 6 === t) {
                                        _ >>>= 2, A -= 2;
                                        break e;
                                    }
                                    break;
                                case 2:
                                    r.mode = 17;
                                    break;
                                case 3:
                                    e.msg = "invalid block type", r.mode = p;
                            }
                            _ >>>= 2, A -= 2;
                            break;
                        case 14:
                            for(_ >>>= 7 & A, A -= 7 & A; A < 32;){
                                if (0 === w) break e;
                                w--, _ += b[m++] << A, A += 8;
                            }
                            if ((65535 & _) != (_ >>> 16 ^ 65535)) {
                                e.msg = "invalid stored block lengths", r.mode = p;
                                break;
                            }
                            if (r.length = 65535 & _, _ = 0, A = 0, r.mode = 15, 6 === t) break e;
                        case 15:
                            r.mode = 16;
                        case 16:
                            if (O = r.length) {
                                if (O > w && (O = w), O > k && (O = k), 0 === O) break e;
                                n.arraySet(y, b, m, O, g), w -= O, m += O, k -= O, g += O, r.length -= O;
                                break;
                            }
                            r.mode = h;
                            break;
                        case 17:
                            for(; A < 14;){
                                if (0 === w) break e;
                                w--, _ += b[m++] << A, A += 8;
                            }
                            if (r.nlen = 257 + (31 & _), _ >>>= 5, A -= 5, r.ndist = 1 + (31 & _), _ >>>= 5, A -= 5, r.ncode = 4 + (15 & _), _ >>>= 4, A -= 4, r.nlen > 286 || r.ndist > 30) {
                                e.msg = "too many length or distance symbols", r.mode = p;
                                break;
                            }
                            r.have = 0, r.mode = 18;
                        case 18:
                            for(; r.have < r.ncode;){
                                for(; A < 3;){
                                    if (0 === w) break e;
                                    w--, _ += b[m++] << A, A += 8;
                                }
                                r.lens[q[r.have++]] = 7 & _, _ >>>= 3, A -= 3;
                            }
                            for(; r.have < 19;)r.lens[q[r.have++]] = 0;
                            if (r.lencode = r.lendyn, r.lenbits = 7, F = {
                                bits: r.lenbits
                            }, L = s(0, r.lens, 0, 19, r.lencode, 0, r.work, F), r.lenbits = F.bits, L) {
                                e.msg = "invalid code lengths set", r.mode = p;
                                break;
                            }
                            r.have = 0, r.mode = 19;
                        case 19:
                            for(; r.have < r.nlen + r.ndist;){
                                for(; C = (H = r.lencode[_ & (1 << r.lenbits) - 1]) >>> 16 & 255, M = 65535 & H, !((T = H >>> 24) <= A);){
                                    if (0 === w) break e;
                                    w--, _ += b[m++] << A, A += 8;
                                }
                                if (M < 16) _ >>>= T, A -= T, r.lens[r.have++] = M;
                                else {
                                    if (16 === M) {
                                        for(D = T + 2; A < D;){
                                            if (0 === w) break e;
                                            w--, _ += b[m++] << A, A += 8;
                                        }
                                        if (_ >>>= T, A -= T, 0 === r.have) {
                                            e.msg = "invalid bit length repeat", r.mode = p;
                                            break;
                                        }
                                        j = r.lens[r.have - 1], O = 3 + (3 & _), _ >>>= 2, A -= 2;
                                    } else if (17 === M) {
                                        for(D = T + 3; A < D;){
                                            if (0 === w) break e;
                                            w--, _ += b[m++] << A, A += 8;
                                        }
                                        A -= T, j = 0, O = 3 + (7 & (_ >>>= T)), _ >>>= 3, A -= 3;
                                    } else {
                                        for(D = T + 7; A < D;){
                                            if (0 === w) break e;
                                            w--, _ += b[m++] << A, A += 8;
                                        }
                                        A -= T, j = 0, O = 11 + (127 & (_ >>>= T)), _ >>>= 7, A -= 7;
                                    }
                                    if (r.have + O > r.nlen + r.ndist) {
                                        e.msg = "invalid bit length repeat", r.mode = p;
                                        break;
                                    }
                                    for(; O--;)r.lens[r.have++] = j;
                                }
                            }
                            if (r.mode === p) break;
                            if (0 === r.lens[256]) {
                                e.msg = "invalid code -- missing end-of-block", r.mode = p;
                                break;
                            }
                            if (r.lenbits = 9, F = {
                                bits: r.lenbits
                            }, L = s(u, r.lens, 0, r.nlen, r.lencode, 0, r.work, F), r.lenbits = F.bits, L) {
                                e.msg = "invalid literal/lengths set", r.mode = p;
                                break;
                            }
                            if (r.distbits = 6, r.distcode = r.distdyn, F = {
                                bits: r.distbits
                            }, L = s(c, r.lens, r.nlen, r.ndist, r.distcode, 0, r.work, F), r.distbits = F.bits, L) {
                                e.msg = "invalid distances set", r.mode = p;
                                break;
                            }
                            if (r.mode = 20, 6 === t) break e;
                        case 20:
                            r.mode = 21;
                        case 21:
                            if (w >= 6 && k >= 258) {
                                e.next_out = g, e.avail_out = k, e.next_in = m, e.avail_in = w, r.hold = _, r.bits = A, a(e, S), g = e.next_out, y = e.output, k = e.avail_out, m = e.next_in, b = e.input, w = e.avail_in, _ = r.hold, A = r.bits, r.mode === h && (r.back = -1);
                                break;
                            }
                            for(r.back = 0; C = (H = r.lencode[_ & (1 << r.lenbits) - 1]) >>> 16 & 255, M = 65535 & H, !((T = H >>> 24) <= A);){
                                if (0 === w) break e;
                                w--, _ += b[m++] << A, A += 8;
                            }
                            if (C && 0 == (240 & C)) {
                                for(R = T, U = C, N = M; C = (H = r.lencode[N + ((_ & (1 << R + U) - 1) >> R)]) >>> 16 & 255, M = 65535 & H, !(R + (T = H >>> 24) <= A);){
                                    if (0 === w) break e;
                                    w--, _ += b[m++] << A, A += 8;
                                }
                                _ >>>= R, A -= R, r.back += R;
                            }
                            if (_ >>>= T, A -= T, r.back += T, r.length = M, 0 === C) {
                                r.mode = 26;
                                break;
                            }
                            if (32 & C) {
                                r.back = -1, r.mode = h;
                                break;
                            }
                            if (64 & C) {
                                e.msg = "invalid literal/length code", r.mode = p;
                                break;
                            }
                            r.extra = 15 & C, r.mode = 22;
                        case 22:
                            if (r.extra) {
                                for(D = r.extra; A < D;){
                                    if (0 === w) break e;
                                    w--, _ += b[m++] << A, A += 8;
                                }
                                r.length += _ & (1 << r.extra) - 1, _ >>>= r.extra, A -= r.extra, r.back += r.extra;
                            }
                            r.was = r.length, r.mode = 23;
                        case 23:
                            for(; C = (H = r.distcode[_ & (1 << r.distbits) - 1]) >>> 16 & 255, M = 65535 & H, !((T = H >>> 24) <= A);){
                                if (0 === w) break e;
                                w--, _ += b[m++] << A, A += 8;
                            }
                            if (0 == (240 & C)) {
                                for(R = T, U = C, N = M; C = (H = r.distcode[N + ((_ & (1 << R + U) - 1) >> R)]) >>> 16 & 255, M = 65535 & H, !(R + (T = H >>> 24) <= A);){
                                    if (0 === w) break e;
                                    w--, _ += b[m++] << A, A += 8;
                                }
                                _ >>>= R, A -= R, r.back += R;
                            }
                            if (_ >>>= T, A -= T, r.back += T, 64 & C) {
                                e.msg = "invalid distance code", r.mode = p;
                                break;
                            }
                            r.offset = M, r.extra = 15 & C, r.mode = 24;
                        case 24:
                            if (r.extra) {
                                for(D = r.extra; A < D;){
                                    if (0 === w) break e;
                                    w--, _ += b[m++] << A, A += 8;
                                }
                                r.offset += _ & (1 << r.extra) - 1, _ >>>= r.extra, A -= r.extra, r.back += r.extra;
                            }
                            if (r.offset > r.dmax) {
                                e.msg = "invalid distance too far back", r.mode = p;
                                break;
                            }
                            r.mode = 25;
                        case 25:
                            if (0 === k) break e;
                            if (O = S - k, r.offset > O) {
                                if ((O = r.offset - O) > r.whave && r.sane) {
                                    e.msg = "invalid distance too far back", r.mode = p;
                                    break;
                                }
                                O > r.wnext ? (O -= r.wnext, P = r.wsize - O) : P = r.wnext - O, O > r.length && (O = r.length), I = r.window;
                            } else I = y, P = g - r.offset, O = r.length;
                            O > k && (O = k), k -= O, r.length -= O;
                            do y[g++] = I[P++];
                            while (--O);
                            0 === r.length && (r.mode = 21);
                            break;
                        case 26:
                            if (0 === k) break e;
                            y[g++] = r.length, k--, r.mode = 21;
                            break;
                        case 27:
                            if (r.wrap) {
                                for(; A < 32;){
                                    if (0 === w) break e;
                                    w--, _ |= b[m++] << A, A += 8;
                                }
                                if (S -= k, e.total_out += S, r.total += S, S && (e.adler = r.check = r.flags ? o(r.check, y, S, g - S) : i(r.check, y, S, g - S)), S = k, (r.flags ? _ : v(_)) !== r.check) {
                                    e.msg = "incorrect data check", r.mode = p;
                                    break;
                                }
                                _ = 0, A = 0;
                            }
                            r.mode = 28;
                        case 28:
                            if (r.wrap && r.flags) {
                                for(; A < 32;){
                                    if (0 === w) break e;
                                    w--, _ += b[m++] << A, A += 8;
                                }
                                if (_ !== (4294967295 & r.total)) {
                                    e.msg = "incorrect length check", r.mode = p;
                                    break;
                                }
                                _ = 0, A = 0;
                            }
                            r.mode = 29;
                        case 29:
                            L = 1;
                            break e;
                        case p:
                            L = -3;
                            break e;
                        case 31:
                            return -4;
                        default:
                            return d;
                    }
                    return e.next_out = g, e.avail_out = k, e.next_in = m, e.avail_in = w, r.hold = _, r.bits = A, (r.wsize || S !== e.avail_out && r.mode < p && (r.mode < 27 || 4 !== t)) && B(e, e.output, e.next_out, S - e.avail_out) ? (r.mode = 31, -4) : (E -= e.avail_in, S -= e.avail_out, e.total_in += E, e.total_out += S, r.total += S, r.wrap && S && (e.adler = r.check = r.flags ? o(r.check, y, S, e.next_out - S) : i(r.check, y, S, e.next_out - S)), e.data_type = r.bits + (r.last ? 64 : 0) + (r.mode === h ? 128 : 0) + (20 === r.mode || 15 === r.mode ? 256 : 0), (0 === E && 0 === S || 4 === t) && L === f && (L = -5), L);
                }, t.inflateEnd = function(e) {
                    if (!e || !e.state) return d;
                    var t = e.state;
                    return t.window && (t.window = null), e.state = null, f;
                }, t.inflateGetHeader = function(e, t) {
                    var r;
                    return e && e.state ? 0 == (2 & (r = e.state).wrap) ? d : (r.head = t, t.done = !1, f) : d;
                }, t.inflateSetDictionary = function(e, t) {
                    var r, n = t.length;
                    return e && e.state ? 0 !== (r = e.state).wrap && 11 !== r.mode ? d : 11 === r.mode && i(1, t, n, 0) !== r.check ? -3 : B(e, t, n, n) ? (r.mode = 31, -4) : (r.havedict = 1, f) : d;
                }, t.inflateInfo = "pako inflate (from Nodeca project)";
            },
            51721: (e, t, r)=>{
                "use strict";
                var n = r(21307), i = [
                    3,
                    4,
                    5,
                    6,
                    7,
                    8,
                    9,
                    10,
                    11,
                    13,
                    15,
                    17,
                    19,
                    23,
                    27,
                    31,
                    35,
                    43,
                    51,
                    59,
                    67,
                    83,
                    99,
                    115,
                    131,
                    163,
                    195,
                    227,
                    258,
                    0,
                    0
                ], o = [
                    16,
                    16,
                    16,
                    16,
                    16,
                    16,
                    16,
                    16,
                    17,
                    17,
                    17,
                    17,
                    18,
                    18,
                    18,
                    18,
                    19,
                    19,
                    19,
                    19,
                    20,
                    20,
                    20,
                    20,
                    21,
                    21,
                    21,
                    21,
                    16,
                    72,
                    78
                ], a = [
                    1,
                    2,
                    3,
                    4,
                    5,
                    7,
                    9,
                    13,
                    17,
                    25,
                    33,
                    49,
                    65,
                    97,
                    129,
                    193,
                    257,
                    385,
                    513,
                    769,
                    1025,
                    1537,
                    2049,
                    3073,
                    4097,
                    6145,
                    8193,
                    12289,
                    16385,
                    24577,
                    0,
                    0
                ], s = [
                    16,
                    16,
                    16,
                    16,
                    17,
                    17,
                    18,
                    18,
                    19,
                    19,
                    20,
                    20,
                    21,
                    21,
                    22,
                    22,
                    23,
                    23,
                    24,
                    24,
                    25,
                    25,
                    26,
                    26,
                    27,
                    27,
                    28,
                    28,
                    29,
                    29,
                    64,
                    64
                ];
                e.exports = function(e, t, r, u, c, f, d, l) {
                    var h, p, b, y, v, m, g, w, k, _ = l.bits, A = 0, E = 0, S = 0, x = 0, B = 0, O = 0, P = 0, I = 0, T = 0, C = 0, M = null, R = 0, U = new n.Buf16(16), N = new n.Buf16(16), j = null, L = 0;
                    for(A = 0; A <= 15; A++)U[A] = 0;
                    for(E = 0; E < u; E++)U[t[r + E]]++;
                    for(B = _, x = 15; x >= 1 && 0 === U[x]; x--);
                    if (B > x && (B = x), 0 === x) return c[f++] = 20971520, c[f++] = 20971520, l.bits = 1, 0;
                    for(S = 1; S < x && 0 === U[S]; S++);
                    for(B < S && (B = S), I = 1, A = 1; A <= 15; A++)if (I <<= 1, (I -= U[A]) < 0) return -1;
                    if (I > 0 && (0 === e || 1 !== x)) return -1;
                    for(N[1] = 0, A = 1; A < 15; A++)N[A + 1] = N[A] + U[A];
                    for(E = 0; E < u; E++)0 !== t[r + E] && (d[N[t[r + E]]++] = E);
                    if (0 === e ? (M = j = d, m = 19) : 1 === e ? (M = i, R -= 257, j = o, L -= 257, m = 256) : (M = a, j = s, m = -1), C = 0, E = 0, A = S, v = f, O = B, P = 0, b = -1, y = (T = 1 << B) - 1, 1 === e && T > 852 || 2 === e && T > 592) return 1;
                    for(;;){
                        g = A - P, d[E] < m ? (w = 0, k = d[E]) : d[E] > m ? (w = j[L + d[E]], k = M[R + d[E]]) : (w = 96, k = 0), h = 1 << A - P, S = p = 1 << O;
                        do c[v + (C >> P) + (p -= h)] = g << 24 | w << 16 | k | 0;
                        while (0 !== p);
                        for(h = 1 << A - 1; C & h;)h >>= 1;
                        if (0 !== h ? (C &= h - 1, C += h) : C = 0, E++, 0 == --U[A]) {
                            if (A === x) break;
                            A = t[r + d[E]];
                        }
                        if (A > B && (C & y) !== b) {
                            for(0 === P && (P = B), v += S, I = 1 << (O = A - P); O + P < x && !((I -= U[O + P]) <= 0);)O++, I <<= 1;
                            if (T += 1 << O, 1 === e && T > 852 || 2 === e && T > 592) return 1;
                            c[b = C & y] = B << 24 | O << 16 | v - f | 0;
                        }
                    }
                    return 0 !== C && (c[v + C] = A - P << 24 | 4194304), l.bits = B, 0;
                };
            },
            78021: (e)=>{
                "use strict";
                e.exports = {
                    2: "need dictionary",
                    1: "stream end",
                    0: "",
                    "-1": "file error",
                    "-2": "stream error",
                    "-3": "data error",
                    "-4": "insufficient memory",
                    "-5": "buffer error",
                    "-6": "incompatible version"
                };
            },
            25280: (e, t, r)=>{
                "use strict";
                var n = r(21307);
                function i(e) {
                    for(var t = e.length; --t >= 0;)e[t] = 0;
                }
                var o = 0, a = 256, s = a + 1 + 29, u = 30, c = 19, f = 2 * s + 1, d = 15, l = 16, h = 256, p = 16, b = 17, y = 18, v = [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    1,
                    1,
                    1,
                    1,
                    2,
                    2,
                    2,
                    2,
                    3,
                    3,
                    3,
                    3,
                    4,
                    4,
                    4,
                    4,
                    5,
                    5,
                    5,
                    5,
                    0
                ], m = [
                    0,
                    0,
                    0,
                    0,
                    1,
                    1,
                    2,
                    2,
                    3,
                    3,
                    4,
                    4,
                    5,
                    5,
                    6,
                    6,
                    7,
                    7,
                    8,
                    8,
                    9,
                    9,
                    10,
                    10,
                    11,
                    11,
                    12,
                    12,
                    13,
                    13
                ], g = [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    2,
                    3,
                    7
                ], w = [
                    16,
                    17,
                    18,
                    0,
                    8,
                    7,
                    9,
                    6,
                    10,
                    5,
                    11,
                    4,
                    12,
                    3,
                    13,
                    2,
                    14,
                    1,
                    15
                ], k = new Array(2 * (s + 2));
                i(k);
                var _ = new Array(2 * u);
                i(_);
                var A = new Array(512);
                i(A);
                var E = new Array(256);
                i(E);
                var S = new Array(29);
                i(S);
                var x, B, O, P = new Array(u);
                function I(e, t, r, n, i) {
                    this.static_tree = e, this.extra_bits = t, this.extra_base = r, this.elems = n, this.max_length = i, this.has_stree = e && e.length;
                }
                function T(e, t) {
                    this.dyn_tree = e, this.max_code = 0, this.stat_desc = t;
                }
                function C(e) {
                    return e < 256 ? A[e] : A[256 + (e >>> 7)];
                }
                function M(e, t) {
                    e.pending_buf[e.pending++] = 255 & t, e.pending_buf[e.pending++] = t >>> 8 & 255;
                }
                function R(e, t, r) {
                    e.bi_valid > l - r ? (e.bi_buf |= t << e.bi_valid & 65535, M(e, e.bi_buf), e.bi_buf = t >> l - e.bi_valid, e.bi_valid += r - l) : (e.bi_buf |= t << e.bi_valid & 65535, e.bi_valid += r);
                }
                function U(e, t, r) {
                    R(e, r[2 * t], r[2 * t + 1]);
                }
                function N(e, t) {
                    var r = 0;
                    do r |= 1 & e, e >>>= 1, r <<= 1;
                    while (--t > 0);
                    return r >>> 1;
                }
                function j(e, t, r) {
                    var n, i, o = new Array(d + 1), a = 0;
                    for(n = 1; n <= d; n++)o[n] = a = a + r[n - 1] << 1;
                    for(i = 0; i <= t; i++){
                        var s = e[2 * i + 1];
                        0 !== s && (e[2 * i] = N(o[s]++, s));
                    }
                }
                function L(e) {
                    var t;
                    for(t = 0; t < s; t++)e.dyn_ltree[2 * t] = 0;
                    for(t = 0; t < u; t++)e.dyn_dtree[2 * t] = 0;
                    for(t = 0; t < c; t++)e.bl_tree[2 * t] = 0;
                    e.dyn_ltree[2 * h] = 1, e.opt_len = e.static_len = 0, e.last_lit = e.matches = 0;
                }
                function F(e) {
                    e.bi_valid > 8 ? M(e, e.bi_buf) : e.bi_valid > 0 && (e.pending_buf[e.pending++] = e.bi_buf), e.bi_buf = 0, e.bi_valid = 0;
                }
                function D(e, t, r, n) {
                    var i = 2 * t, o = 2 * r;
                    return e[i] < e[o] || e[i] === e[o] && n[t] <= n[r];
                }
                function H(e, t, r) {
                    for(var n = e.heap[r], i = r << 1; i <= e.heap_len && (i < e.heap_len && D(t, e.heap[i + 1], e.heap[i], e.depth) && i++, !D(t, n, e.heap[i], e.depth));)e.heap[r] = e.heap[i], r = i, i <<= 1;
                    e.heap[r] = n;
                }
                function z(e, t, r) {
                    var n, i, o, s, u = 0;
                    if (0 !== e.last_lit) do n = e.pending_buf[e.d_buf + 2 * u] << 8 | e.pending_buf[e.d_buf + 2 * u + 1], i = e.pending_buf[e.l_buf + u], u++, 0 === n ? U(e, i, t) : (U(e, (o = E[i]) + a + 1, t), 0 !== (s = v[o]) && R(e, i -= S[o], s), U(e, o = C(--n), r), 0 !== (s = m[o]) && R(e, n -= P[o], s));
                    while (u < e.last_lit);
                    U(e, h, t);
                }
                function q(e, t) {
                    var r, n, i, o = t.dyn_tree, a = t.stat_desc.static_tree, s = t.stat_desc.has_stree, u = t.stat_desc.elems, c = -1;
                    for(e.heap_len = 0, e.heap_max = f, r = 0; r < u; r++)0 !== o[2 * r] ? (e.heap[++e.heap_len] = c = r, e.depth[r] = 0) : o[2 * r + 1] = 0;
                    for(; e.heap_len < 2;)o[2 * (i = e.heap[++e.heap_len] = c < 2 ? ++c : 0)] = 1, e.depth[i] = 0, e.opt_len--, s && (e.static_len -= a[2 * i + 1]);
                    for(t.max_code = c, r = e.heap_len >> 1; r >= 1; r--)H(e, o, r);
                    i = u;
                    do r = e.heap[1], e.heap[1] = e.heap[e.heap_len--], H(e, o, 1), n = e.heap[1], e.heap[--e.heap_max] = r, e.heap[--e.heap_max] = n, o[2 * i] = o[2 * r] + o[2 * n], e.depth[i] = (e.depth[r] >= e.depth[n] ? e.depth[r] : e.depth[n]) + 1, o[2 * r + 1] = o[2 * n + 1] = i, e.heap[1] = i++, H(e, o, 1);
                    while (e.heap_len >= 2);
                    e.heap[--e.heap_max] = e.heap[1], function(e, t) {
                        var r, n, i, o, a, s, u = t.dyn_tree, c = t.max_code, l = t.stat_desc.static_tree, h = t.stat_desc.has_stree, p = t.stat_desc.extra_bits, b = t.stat_desc.extra_base, y = t.stat_desc.max_length, v = 0;
                        for(o = 0; o <= d; o++)e.bl_count[o] = 0;
                        for(u[2 * e.heap[e.heap_max] + 1] = 0, r = e.heap_max + 1; r < f; r++)(o = u[2 * u[2 * (n = e.heap[r]) + 1] + 1] + 1) > y && (o = y, v++), u[2 * n + 1] = o, n > c || (e.bl_count[o]++, a = 0, n >= b && (a = p[n - b]), s = u[2 * n], e.opt_len += s * (o + a), h && (e.static_len += s * (l[2 * n + 1] + a)));
                        if (0 !== v) {
                            do {
                                for(o = y - 1; 0 === e.bl_count[o];)o--;
                                e.bl_count[o]--, e.bl_count[o + 1] += 2, e.bl_count[y]--, v -= 2;
                            }while (v > 0);
                            for(o = y; 0 !== o; o--)for(n = e.bl_count[o]; 0 !== n;)(i = e.heap[--r]) > c || (u[2 * i + 1] !== o && (e.opt_len += (o - u[2 * i + 1]) * u[2 * i], u[2 * i + 1] = o), n--);
                        }
                    }(e, t), j(o, c, e.bl_count);
                }
                function K(e, t, r) {
                    var n, i, o = -1, a = t[1], s = 0, u = 7, c = 4;
                    for(0 === a && (u = 138, c = 3), t[2 * (r + 1) + 1] = 65535, n = 0; n <= r; n++)i = a, a = t[2 * (n + 1) + 1], ++s < u && i === a || (s < c ? e.bl_tree[2 * i] += s : 0 !== i ? (i !== o && e.bl_tree[2 * i]++, e.bl_tree[2 * p]++) : s <= 10 ? e.bl_tree[2 * b]++ : e.bl_tree[2 * y]++, s = 0, o = i, 0 === a ? (u = 138, c = 3) : i === a ? (u = 6, c = 3) : (u = 7, c = 4));
                }
                function G(e, t, r) {
                    var n, i, o = -1, a = t[1], s = 0, u = 7, c = 4;
                    for(0 === a && (u = 138, c = 3), n = 0; n <= r; n++)if (i = a, a = t[2 * (n + 1) + 1], !(++s < u && i === a)) {
                        if (s < c) do U(e, i, e.bl_tree);
                        while (0 != --s);
                        else 0 !== i ? (i !== o && (U(e, i, e.bl_tree), s--), U(e, p, e.bl_tree), R(e, s - 3, 2)) : s <= 10 ? (U(e, b, e.bl_tree), R(e, s - 3, 3)) : (U(e, y, e.bl_tree), R(e, s - 11, 7));
                        s = 0, o = i, 0 === a ? (u = 138, c = 3) : i === a ? (u = 6, c = 3) : (u = 7, c = 4);
                    }
                }
                i(P);
                var V = !1;
                function Z(e, t, r, i) {
                    R(e, (o << 1) + (i ? 1 : 0), 3), function(e, t, r, i) {
                        F(e), M(e, r), M(e, ~r), n.arraySet(e.pending_buf, e.window, t, r, e.pending), e.pending += r;
                    }(e, t, r);
                }
                t._tr_init = function(e) {
                    V || (function() {
                        var e, t, r, n, i, o = new Array(d + 1);
                        for(r = 0, n = 0; n < 28; n++)for(S[n] = r, e = 0; e < 1 << v[n]; e++)E[r++] = n;
                        for(E[r - 1] = n, i = 0, n = 0; n < 16; n++)for(P[n] = i, e = 0; e < 1 << m[n]; e++)A[i++] = n;
                        for(i >>= 7; n < u; n++)for(P[n] = i << 7, e = 0; e < 1 << m[n] - 7; e++)A[256 + i++] = n;
                        for(t = 0; t <= d; t++)o[t] = 0;
                        for(e = 0; e <= 143;)k[2 * e + 1] = 8, e++, o[8]++;
                        for(; e <= 255;)k[2 * e + 1] = 9, e++, o[9]++;
                        for(; e <= 279;)k[2 * e + 1] = 7, e++, o[7]++;
                        for(; e <= 287;)k[2 * e + 1] = 8, e++, o[8]++;
                        for(j(k, s + 1, o), e = 0; e < u; e++)_[2 * e + 1] = 5, _[2 * e] = N(e, 5);
                        x = new I(k, v, a + 1, s, d), B = new I(_, m, 0, u, d), O = new I(new Array(0), g, 0, c, 7);
                    }(), V = !0), e.l_desc = new T(e.dyn_ltree, x), e.d_desc = new T(e.dyn_dtree, B), e.bl_desc = new T(e.bl_tree, O), e.bi_buf = 0, e.bi_valid = 0, L(e);
                }, t._tr_stored_block = Z, t._tr_flush_block = function(e, t, r, n) {
                    var i, o, s = 0;
                    e.level > 0 ? (2 === e.strm.data_type && (e.strm.data_type = function(e) {
                        var t, r = 4093624447;
                        for(t = 0; t <= 31; t++, r >>>= 1)if (1 & r && 0 !== e.dyn_ltree[2 * t]) return 0;
                        if (0 !== e.dyn_ltree[18] || 0 !== e.dyn_ltree[20] || 0 !== e.dyn_ltree[26]) return 1;
                        for(t = 32; t < a; t++)if (0 !== e.dyn_ltree[2 * t]) return 1;
                        return 0;
                    }(e)), q(e, e.l_desc), q(e, e.d_desc), s = function(e) {
                        var t;
                        for(K(e, e.dyn_ltree, e.l_desc.max_code), K(e, e.dyn_dtree, e.d_desc.max_code), q(e, e.bl_desc), t = c - 1; t >= 3 && 0 === e.bl_tree[2 * w[t] + 1]; t--);
                        return e.opt_len += 3 * (t + 1) + 5 + 5 + 4, t;
                    }(e), i = e.opt_len + 3 + 7 >>> 3, (o = e.static_len + 3 + 7 >>> 3) <= i && (i = o)) : i = o = r + 5, r + 4 <= i && -1 !== t ? Z(e, t, r, n) : 4 === e.strategy || o === i ? (R(e, 2 + (n ? 1 : 0), 3), z(e, k, _)) : (R(e, 4 + (n ? 1 : 0), 3), function(e, t, r, n) {
                        var i;
                        for(R(e, t - 257, 5), R(e, r - 1, 5), R(e, n - 4, 4), i = 0; i < n; i++)R(e, e.bl_tree[2 * w[i] + 1], 3);
                        G(e, e.dyn_ltree, t - 1), G(e, e.dyn_dtree, r - 1);
                    }(e, e.l_desc.max_code + 1, e.d_desc.max_code + 1, s + 1), z(e, e.dyn_ltree, e.dyn_dtree)), L(e), n && F(e);
                }, t._tr_tally = function(e, t, r) {
                    return e.pending_buf[e.d_buf + 2 * e.last_lit] = t >>> 8 & 255, e.pending_buf[e.d_buf + 2 * e.last_lit + 1] = 255 & t, e.pending_buf[e.l_buf + e.last_lit] = 255 & r, e.last_lit++, 0 === t ? e.dyn_ltree[2 * r]++ : (e.matches++, t--, e.dyn_ltree[2 * (E[r] + a + 1)]++, e.dyn_dtree[2 * C(t)]++), e.last_lit === e.lit_bufsize - 1;
                }, t._tr_align = function(e) {
                    R(e, 2, 3), U(e, h, k), function(e) {
                        16 === e.bi_valid ? (M(e, e.bi_buf), e.bi_buf = 0, e.bi_valid = 0) : e.bi_valid >= 8 && (e.pending_buf[e.pending++] = 255 & e.bi_buf, e.bi_buf >>= 8, e.bi_valid -= 8);
                    }(e);
                };
            },
            47563: (e)=>{
                "use strict";
                e.exports = function() {
                    this.input = null, this.next_in = 0, this.avail_in = 0, this.total_in = 0, this.output = null, this.next_out = 0, this.avail_out = 0, this.total_out = 0, this.msg = "", this.state = null, this.data_type = 2, this.adler = 0;
                };
            },
            81823: (e, t, r)=>{
                "use strict";
                var n = r(68357);
                t.certificate = r(41320);
                var i = n.define("RSAPrivateKey", function() {
                    this.seq().obj(this.key("version").int(), this.key("modulus").int(), this.key("publicExponent").int(), this.key("privateExponent").int(), this.key("prime1").int(), this.key("prime2").int(), this.key("exponent1").int(), this.key("exponent2").int(), this.key("coefficient").int());
                });
                t.RSAPrivateKey = i;
                var o = n.define("RSAPublicKey", function() {
                    this.seq().obj(this.key("modulus").int(), this.key("publicExponent").int());
                });
                t.RSAPublicKey = o;
                var a = n.define("SubjectPublicKeyInfo", function() {
                    this.seq().obj(this.key("algorithm").use(s), this.key("subjectPublicKey").bitstr());
                });
                t.PublicKey = a;
                var s = n.define("AlgorithmIdentifier", function() {
                    this.seq().obj(this.key("algorithm").objid(), this.key("none").null_().optional(), this.key("curve").objid().optional(), this.key("params").seq().obj(this.key("p").int(), this.key("q").int(), this.key("g").int()).optional());
                }), u = n.define("PrivateKeyInfo", function() {
                    this.seq().obj(this.key("version").int(), this.key("algorithm").use(s), this.key("subjectPrivateKey").octstr());
                });
                t.PrivateKey = u;
                var c = n.define("EncryptedPrivateKeyInfo", function() {
                    this.seq().obj(this.key("algorithm").seq().obj(this.key("id").objid(), this.key("decrypt").seq().obj(this.key("kde").seq().obj(this.key("id").objid(), this.key("kdeparams").seq().obj(this.key("salt").octstr(), this.key("iters").int())), this.key("cipher").seq().obj(this.key("algo").objid(), this.key("iv").octstr()))), this.key("subjectPrivateKey").octstr());
                });
                t.EncryptedPrivateKey = c;
                var f = n.define("DSAPrivateKey", function() {
                    this.seq().obj(this.key("version").int(), this.key("p").int(), this.key("q").int(), this.key("g").int(), this.key("pub_key").int(), this.key("priv_key").int());
                });
                t.DSAPrivateKey = f, t.DSAparam = n.define("DSAparam", function() {
                    this.int();
                });
                var d = n.define("ECPrivateKey", function() {
                    this.seq().obj(this.key("version").int(), this.key("privateKey").octstr(), this.key("parameters").optional().explicit(0).use(l), this.key("publicKey").optional().explicit(1).bitstr());
                });
                t.ECPrivateKey = d;
                var l = n.define("ECParameters", function() {
                    this.choice({
                        namedCurve: this.objid()
                    });
                });
                t.signature = n.define("signature", function() {
                    this.seq().obj(this.key("r").int(), this.key("s").int());
                });
            },
            41320: (e, t, r)=>{
                "use strict";
                var n = r(68357), i = n.define("Time", function() {
                    this.choice({
                        utcTime: this.utctime(),
                        generalTime: this.gentime()
                    });
                }), o = n.define("AttributeTypeValue", function() {
                    this.seq().obj(this.key("type").objid(), this.key("value").any());
                }), a = n.define("AlgorithmIdentifier", function() {
                    this.seq().obj(this.key("algorithm").objid(), this.key("parameters").optional(), this.key("curve").objid().optional());
                }), s = n.define("SubjectPublicKeyInfo", function() {
                    this.seq().obj(this.key("algorithm").use(a), this.key("subjectPublicKey").bitstr());
                }), u = n.define("RelativeDistinguishedName", function() {
                    this.setof(o);
                }), c = n.define("RDNSequence", function() {
                    this.seqof(u);
                }), f = n.define("Name", function() {
                    this.choice({
                        rdnSequence: this.use(c)
                    });
                }), d = n.define("Validity", function() {
                    this.seq().obj(this.key("notBefore").use(i), this.key("notAfter").use(i));
                }), l = n.define("Extension", function() {
                    this.seq().obj(this.key("extnID").objid(), this.key("critical").bool().def(!1), this.key("extnValue").octstr());
                }), h = n.define("TBSCertificate", function() {
                    this.seq().obj(this.key("version").explicit(0).int().optional(), this.key("serialNumber").int(), this.key("signature").use(a), this.key("issuer").use(f), this.key("validity").use(d), this.key("subject").use(f), this.key("subjectPublicKeyInfo").use(s), this.key("issuerUniqueID").implicit(1).bitstr().optional(), this.key("subjectUniqueID").implicit(2).bitstr().optional(), this.key("extensions").explicit(3).seqof(l).optional());
                }), p = n.define("X509Certificate", function() {
                    this.seq().obj(this.key("tbsCertificate").use(h), this.key("signatureAlgorithm").use(a), this.key("signatureValue").bitstr());
                });
                e.exports = p;
            },
            64988: (e, t, r)=>{
                "use strict";
                var n = /Proc-Type: 4,ENCRYPTED[\n\r]+DEK-Info: AES-((?:128)|(?:192)|(?:256))-CBC,([0-9A-H]+)[\n\r]+([0-9A-z\n\r+/=]+)[\n\r]+/m, i = /^-----BEGIN ((?:.*? KEY)|CERTIFICATE)-----/m, o = /^-----BEGIN ((?:.*? KEY)|CERTIFICATE)-----([0-9A-z\n\r+/=]+)-----END \1-----$/m, a = r(27085), s = r(98073), u = r(48850).Buffer;
                e.exports = function(e, t) {
                    var r, c = e.toString(), f = c.match(n);
                    if (f) {
                        var d = "aes" + f[1], l = u.from(f[2], "hex"), h = u.from(f[3].replace(/[\r\n]/g, ""), "base64"), p = a(t, l.slice(0, 8), parseInt(f[1], 10)).key, b = [], y = s.createDecipheriv(d, p, l);
                        b.push(y.update(h)), b.push(y.final()), r = u.concat(b);
                    } else {
                        var v = c.match(o);
                        r = u.from(v[2].replace(/[\r\n]/g, ""), "base64");
                    }
                    return {
                        tag: c.match(i)[1],
                        data: r
                    };
                };
            },
            27552: (e, t, r)=>{
                "use strict";
                var n = r(28847)(r(3355)), i = r(81823), o = r(22562), a = r(64988), s = r(98073), u = r(54192), c = r(48850).Buffer;
                function f(e) {
                    var t;
                    "object" !== (0, n.default)(e) || c.isBuffer(e) || (t = e.passphrase, e = e.key), "string" == typeof e && (e = c.from(e));
                    var r, f, d = a(e, t), l = d.tag, h = d.data;
                    switch(l){
                        case "CERTIFICATE":
                            f = i.certificate.decode(h, "der").tbsCertificate.subjectPublicKeyInfo;
                        case "PUBLIC KEY":
                            switch(f || (f = i.PublicKey.decode(h, "der")), r = f.algorithm.algorithm.join(".")){
                                case "1.2.840.113549.1.1.1":
                                    return i.RSAPublicKey.decode(f.subjectPublicKey.data, "der");
                                case "1.2.840.10045.2.1":
                                    return f.subjectPrivateKey = f.subjectPublicKey, {
                                        type: "ec",
                                        data: f
                                    };
                                case "1.2.840.10040.4.1":
                                    return f.algorithm.params.pub_key = i.DSAparam.decode(f.subjectPublicKey.data, "der"), {
                                        type: "dsa",
                                        data: f.algorithm.params
                                    };
                                default:
                                    throw new Error("unknown key id " + r);
                            }
                        case "ENCRYPTED PRIVATE KEY":
                            h = function(e, t) {
                                var r = e.algorithm.decrypt.kde.kdeparams.salt, n = parseInt(e.algorithm.decrypt.kde.kdeparams.iters.toString(), 10), i = o[e.algorithm.decrypt.cipher.algo.join(".")], a = e.algorithm.decrypt.cipher.iv, f = e.subjectPrivateKey, d = parseInt(i.split("-")[1], 10) / 8, l = u.pbkdf2Sync(t, r, n, d, "sha1"), h = s.createDecipheriv(i, l, a), p = [];
                                return p.push(h.update(f)), p.push(h.final()), c.concat(p);
                            }(h = i.EncryptedPrivateKey.decode(h, "der"), t);
                        case "PRIVATE KEY":
                            switch(r = (f = i.PrivateKey.decode(h, "der")).algorithm.algorithm.join(".")){
                                case "1.2.840.113549.1.1.1":
                                    return i.RSAPrivateKey.decode(f.subjectPrivateKey, "der");
                                case "1.2.840.10045.2.1":
                                    return {
                                        curve: f.algorithm.curve,
                                        privateKey: i.ECPrivateKey.decode(f.subjectPrivateKey, "der").privateKey
                                    };
                                case "1.2.840.10040.4.1":
                                    return f.algorithm.params.priv_key = i.DSAparam.decode(f.subjectPrivateKey, "der"), {
                                        type: "dsa",
                                        params: f.algorithm.params
                                    };
                                default:
                                    throw new Error("unknown key id " + r);
                            }
                        case "RSA PUBLIC KEY":
                            return i.RSAPublicKey.decode(h, "der");
                        case "RSA PRIVATE KEY":
                            return i.RSAPrivateKey.decode(h, "der");
                        case "DSA PRIVATE KEY":
                            return {
                                type: "dsa",
                                params: i.DSAPrivateKey.decode(h, "der")
                            };
                        case "EC PRIVATE KEY":
                            return {
                                curve: (h = i.ECPrivateKey.decode(h, "der")).parameters.value,
                                privateKey: h.privateKey
                            };
                        default:
                            throw new Error("unknown key type " + l);
                    }
                }
                e.exports = f, f.signature = i.signature;
            },
            48209: (e)=>{
                "use strict";
                var t = function(e) {
                    return e.replace(/^\s+|\s+$/g, "");
                };
                e.exports = function(e) {
                    if (!e) return {};
                    for(var r, n = {}, i = t(e).split("\n"), o = 0; o < i.length; o++){
                        var a = i[o], s = a.indexOf(":"), u = t(a.slice(0, s)).toLowerCase(), c = t(a.slice(s + 1));
                        void 0 === n[u] ? n[u] = c : (r = n[u], "[object Array]" === Object.prototype.toString.call(r) ? n[u].push(c) : n[u] = [
                            n[u],
                            c
                        ]);
                    }
                    return n;
                };
            },
            54192: (e, t, r)=>{
                "use strict";
                t.pbkdf2 = r(1882), t.pbkdf2Sync = r(1658);
            },
            1882: (e, t, r)=>{
                "use strict";
                var n, i, o = r(48850).Buffer, a = r(63127), s = r(77401), u = r(1658), c = r(98398), f = r.g.crypto && r.g.crypto.subtle, d = {
                    sha: "SHA-1",
                    "sha-1": "SHA-1",
                    sha1: "SHA-1",
                    sha256: "SHA-256",
                    "sha-256": "SHA-256",
                    sha384: "SHA-384",
                    "sha-384": "SHA-384",
                    "sha-512": "SHA-512",
                    sha512: "SHA-512"
                }, l = [];
                function h() {
                    return i || (i = r.g.process && r.g.process.nextTick ? r.g.process.nextTick : r.g.queueMicrotask ? r.g.queueMicrotask : r.g.setImmediate ? r.g.setImmediate : r.g.setTimeout);
                }
                function p(e, t, r, n, i) {
                    return f.importKey("raw", e, {
                        name: "PBKDF2"
                    }, !1, [
                        "deriveBits"
                    ]).then(function(e) {
                        return f.deriveBits({
                            name: "PBKDF2",
                            salt: t,
                            iterations: r,
                            hash: {
                                name: i
                            }
                        }, e, n << 3);
                    }).then(function(e) {
                        return o.from(e);
                    });
                }
                e.exports = function(e, t, i, b, y, v) {
                    "function" == typeof y && (v = y, y = void 0);
                    var m = d[(y = y || "sha1").toLowerCase()];
                    if (m && "function" == typeof r.g.Promise) {
                        if (a(i, b), e = c(e, s, "Password"), t = c(t, s, "Salt"), "function" != typeof v) throw new Error("No callback provided to pbkdf2");
                        !function(e, t) {
                            e.then(function(e) {
                                h()(function() {
                                    t(null, e);
                                });
                            }, function(e) {
                                h()(function() {
                                    t(e);
                                });
                            });
                        }((function(e) {
                            if (r.g.process && !r.g.process.browser) return Promise.resolve(!1);
                            if (!f || !f.importKey || !f.deriveBits) return Promise.resolve(!1);
                            if (void 0 !== l[e]) return l[e];
                            var t = p(n = n || o.alloc(8), n, 10, 128, e).then(function() {
                                return !0;
                            }).catch(function() {
                                return !1;
                            });
                            return l[e] = t, t;
                        })(m).then(function(r) {
                            return r ? p(e, t, i, b, m) : u(e, t, i, b, y);
                        }), v);
                    } else h()(function() {
                        var r;
                        try {
                            r = u(e, t, i, b, y);
                        } catch (e) {
                            return v(e);
                        }
                        v(null, r);
                    });
                };
            },
            77401: (e, t, r)=>{
                "use strict";
                var n, i = r(19142);
                n = r.g.process && r.g.process.browser ? "utf-8" : r.g.process && r.g.process.version ? parseInt(i.version.split(".")[0].slice(1), 10) >= 6 ? "utf-8" : "binary" : "utf-8", e.exports = n;
            },
            63127: (e)=>{
                "use strict";
                var t = Math.pow(2, 30) - 1;
                e.exports = function(e, r) {
                    if ("number" != typeof e) throw new TypeError("Iterations not a number");
                    if (e < 0) throw new TypeError("Bad iterations");
                    if ("number" != typeof r) throw new TypeError("Key length not a number");
                    if (r < 0 || r > t || r != r) throw new TypeError("Bad key length");
                };
            },
            1658: (e, t, r)=>{
                "use strict";
                var n = r(55349), i = r(26707), o = r(51708), a = r(48850).Buffer, s = r(63127), u = r(77401), c = r(98398), f = a.alloc(128), d = {
                    md5: 16,
                    sha1: 20,
                    sha224: 28,
                    sha256: 32,
                    sha384: 48,
                    sha512: 64,
                    rmd160: 20,
                    ripemd160: 20
                };
                function l(e, t, r) {
                    var s = function(e) {
                        return "rmd160" === e || "ripemd160" === e ? function(e) {
                            return (new i).update(e).digest();
                        } : "md5" === e ? n : function(t) {
                            return o(e).update(t).digest();
                        };
                    }(e), u = "sha512" === e || "sha384" === e ? 128 : 64;
                    t.length > u ? t = s(t) : t.length < u && (t = a.concat([
                        t,
                        f
                    ], u));
                    for(var c = a.allocUnsafe(u + d[e]), l = a.allocUnsafe(u + d[e]), h = 0; h < u; h++)c[h] = 54 ^ t[h], l[h] = 92 ^ t[h];
                    var p = a.allocUnsafe(u + r + 4);
                    c.copy(p, 0, 0, u), this.ipad1 = p, this.ipad2 = c, this.opad = l, this.alg = e, this.blocksize = u, this.hash = s, this.size = d[e];
                }
                l.prototype.run = function(e, t) {
                    return e.copy(t, this.blocksize), this.hash(t).copy(this.opad, this.blocksize), this.hash(this.opad);
                }, e.exports = function(e, t, r, n, i) {
                    s(r, n);
                    var o = new l(i = i || "sha1", e = c(e, u, "Password"), (t = c(t, u, "Salt")).length), f = a.allocUnsafe(n), h = a.allocUnsafe(t.length + 4);
                    t.copy(h, 0, 0, t.length);
                    for(var p = 0, b = d[i], y = Math.ceil(n / b), v = 1; v <= y; v++){
                        h.writeUInt32BE(v, t.length);
                        for(var m = o.run(h, o.ipad1), g = m, w = 1; w < r; w++){
                            g = o.run(g, o.ipad2);
                            for(var k = 0; k < b; k++)m[k] ^= g[k];
                        }
                        m.copy(f, p), p += b;
                    }
                    return f;
                };
            },
            98398: (e, t, r)=>{
                "use strict";
                var n = r(48850).Buffer;
                e.exports = function(e, t, r) {
                    if (n.isBuffer(e)) return e;
                    if ("string" == typeof e) return n.from(e, t);
                    if (ArrayBuffer.isView(e)) return n.from(e.buffer);
                    throw new TypeError(r + " must be a string, a Buffer, a typed array or a DataView");
                };
            },
            19142: (e)=>{
                "use strict";
                var t, r, n = e.exports = {};
                function i() {
                    throw new Error("setTimeout has not been defined");
                }
                function o() {
                    throw new Error("clearTimeout has not been defined");
                }
                function a(e) {
                    if (t === setTimeout) return setTimeout(e, 0);
                    if ((t === i || !t) && setTimeout) return t = setTimeout, setTimeout(e, 0);
                    try {
                        return t(e, 0);
                    } catch (r) {
                        try {
                            return t.call(null, e, 0);
                        } catch (r) {
                            return t.call(this, e, 0);
                        }
                    }
                }
                !function() {
                    try {
                        t = "function" == typeof setTimeout ? setTimeout : i;
                    } catch (e) {
                        t = i;
                    }
                    try {
                        r = "function" == typeof clearTimeout ? clearTimeout : o;
                    } catch (e) {
                        r = o;
                    }
                }();
                var s, u = [], c = !1, f = -1;
                function d() {
                    c && s && (c = !1, s.length ? u = s.concat(u) : f = -1, u.length && l());
                }
                function l() {
                    if (!c) {
                        var e = a(d);
                        c = !0;
                        for(var t = u.length; t;){
                            for(s = u, u = []; ++f < t;)s && s[f].run();
                            f = -1, t = u.length;
                        }
                        s = null, c = !1, function(e) {
                            if (r === clearTimeout) return clearTimeout(e);
                            if ((r === o || !r) && clearTimeout) return r = clearTimeout, clearTimeout(e);
                            try {
                                return r(e);
                            } catch (t) {
                                try {
                                    return r.call(null, e);
                                } catch (t) {
                                    return r.call(this, e);
                                }
                            }
                        }(e);
                    }
                }
                function h(e, t) {
                    this.fun = e, this.array = t;
                }
                function p() {}
                n.nextTick = function(e) {
                    var t = new Array(arguments.length - 1);
                    if (arguments.length > 1) for(var r = 1; r < arguments.length; r++)t[r - 1] = arguments[r];
                    u.push(new h(e, t)), 1 !== u.length || c || a(l);
                }, h.prototype.run = function() {
                    this.fun.apply(null, this.array);
                }, n.title = "browser", n.browser = !0, n.env = {}, n.argv = [], n.version = "", n.versions = {}, n.on = p, n.addListener = p, n.once = p, n.off = p, n.removeListener = p, n.removeAllListeners = p, n.emit = p, n.prependListener = p, n.prependOnceListener = p, n.listeners = function(e) {
                    return [];
                }, n.binding = function(e) {
                    throw new Error("process.binding is not supported");
                }, n.cwd = function() {
                    return "/";
                }, n.chdir = function(e) {
                    throw new Error("process.chdir is not supported");
                }, n.umask = function() {
                    return 0;
                };
            },
            86991: (e, t, r)=>{
                "use strict";
                t.publicEncrypt = r(82466), t.privateDecrypt = r(53144), t.privateEncrypt = function(e, r) {
                    return t.publicEncrypt(e, r, !0);
                }, t.publicDecrypt = function(e, r) {
                    return t.privateDecrypt(e, r, !0);
                };
            },
            26873: (e, t, r)=>{
                "use strict";
                var n = r(35866), i = r(48850).Buffer;
                function o(e) {
                    var t = i.allocUnsafe(4);
                    return t.writeUInt32BE(e, 0), t;
                }
                e.exports = function(e, t) {
                    for(var r, a = i.alloc(0), s = 0; a.length < t;)r = o(s++), a = i.concat([
                        a,
                        n("sha1").update(e).update(r).digest()
                    ]);
                    return a.slice(0, t);
                };
            },
            53144: (e, t, r)=>{
                "use strict";
                var n = r(27552), i = r(26873), o = r(27223), a = r(31734), s = r(99782), u = r(35866), c = r(2561), f = r(48850).Buffer;
                e.exports = function(e, t, r) {
                    var d;
                    d = e.padding ? e.padding : r ? 1 : 4;
                    var l, h = n(e), p = h.modulus.byteLength();
                    if (t.length > p || new a(t).cmp(h.modulus) >= 0) throw new Error("decryption error");
                    l = r ? c(new a(t), h) : s(t, h);
                    var b = f.alloc(p - l.length);
                    if (l = f.concat([
                        b,
                        l
                    ], p), 4 === d) return function(e, t) {
                        var r = e.modulus.byteLength(), n = u("sha1").update(f.alloc(0)).digest(), a = n.length;
                        if (0 !== t[0]) throw new Error("decryption error");
                        var s = t.slice(1, a + 1), c = t.slice(a + 1), d = o(s, i(c, a)), l = o(c, i(d, r - a - 1));
                        if (function(e, t) {
                            e = f.from(e), t = f.from(t);
                            var r = 0, n = e.length;
                            e.length !== t.length && (r++, n = Math.min(e.length, t.length));
                            for(var i = -1; ++i < n;)r += e[i] ^ t[i];
                            return r;
                        }(n, l.slice(0, a))) throw new Error("decryption error");
                        for(var h = a; 0 === l[h];)h++;
                        if (1 !== l[h++]) throw new Error("decryption error");
                        return l.slice(h);
                    }(h, l);
                    if (1 === d) return function(e, t, r) {
                        for(var n = t.slice(0, 2), i = 2, o = 0; 0 !== t[i++];)if (i >= t.length) {
                            o++;
                            break;
                        }
                        var a = t.slice(2, i - 1);
                        if (("0002" !== n.toString("hex") && !r || "0001" !== n.toString("hex") && r) && o++, a.length < 8 && o++, o) throw new Error("decryption error");
                        return t.slice(i);
                    }(0, l, r);
                    if (3 === d) return l;
                    throw new Error("unknown padding");
                };
            },
            82466: (e, t, r)=>{
                "use strict";
                var n = r(27552), i = r(75010), o = r(35866), a = r(26873), s = r(27223), u = r(31734), c = r(2561), f = r(99782), d = r(48850).Buffer;
                e.exports = function(e, t, r) {
                    var l;
                    l = e.padding ? e.padding : r ? 1 : 4;
                    var h, p = n(e);
                    if (4 === l) h = function(e, t) {
                        var r = e.modulus.byteLength(), n = t.length, c = o("sha1").update(d.alloc(0)).digest(), f = c.length, l = 2 * f;
                        if (n > r - l - 2) throw new Error("message too long");
                        var h = d.alloc(r - n - l - 2), p = r - f - 1, b = i(f), y = s(d.concat([
                            c,
                            h,
                            d.alloc(1, 1),
                            t
                        ], p), a(b, p)), v = s(b, a(y, f));
                        return new u(d.concat([
                            d.alloc(1),
                            v,
                            y
                        ], r));
                    }(p, t);
                    else if (1 === l) h = function(e, t, r) {
                        var n, o = t.length, a = e.modulus.byteLength();
                        if (o > a - 11) throw new Error("message too long");
                        return n = r ? d.alloc(a - o - 3, 255) : function(e) {
                            for(var t, r = d.allocUnsafe(e), n = 0, o = i(2 * e), a = 0; n < e;)a === o.length && (o = i(2 * e), a = 0), (t = o[a++]) && (r[n++] = t);
                            return r;
                        }(a - o - 3), new u(d.concat([
                            d.from([
                                0,
                                r ? 1 : 2
                            ]),
                            n,
                            d.alloc(1),
                            t
                        ], a));
                    }(p, t, r);
                    else {
                        if (3 !== l) throw new Error("unknown padding");
                        if ((h = new u(t)).cmp(p.modulus) >= 0) throw new Error("data too long for modulus");
                    }
                    return r ? f(h, p) : c(h, p);
                };
            },
            2561: (e, t, r)=>{
                "use strict";
                var n = r(31734), i = r(48850).Buffer;
                e.exports = function(e, t) {
                    return i.from(e.toRed(n.mont(t.modulus)).redPow(new n(t.publicExponent)).fromRed().toArray());
                };
            },
            27223: (e)=>{
                "use strict";
                e.exports = function(e, t) {
                    for(var r = e.length, n = -1; ++n < r;)e[n] ^= t[n];
                    return e;
                };
            },
            31296: (e, t, r)=>{
                "use strict";
                var n = r(28847)(r(3355)), i = r(22028), o = r(33103), a = r(80034);
                function s(e, t) {
                    return t.encode ? t.strict ? i(e) : encodeURIComponent(e) : e;
                }
                function u(e) {
                    return Array.isArray(e) ? e.sort() : "object" === (0, n.default)(e) ? u(Object.keys(e)).sort(function(e, t) {
                        return Number(e) - Number(t);
                    }).map(function(t) {
                        return e[t];
                    }) : e;
                }
                function c(e) {
                    var t = e.indexOf("?");
                    return -1 === t ? "" : e.slice(t + 1);
                }
                function f(e, t) {
                    var r = function(e) {
                        var t;
                        switch(e.arrayFormat){
                            case "index":
                                return function(e, r, n) {
                                    t = /\[(\d*)\]$/.exec(e), e = e.replace(/\[\d*\]$/, ""), t ? (void 0 === n[e] && (n[e] = {}), n[e][t[1]] = r) : n[e] = r;
                                };
                            case "bracket":
                                return function(e, r, n) {
                                    t = /(\[\])$/.exec(e), e = e.replace(/\[\]$/, ""), t ? void 0 !== n[e] ? n[e] = [].concat(n[e], r) : n[e] = [
                                        r
                                    ] : n[e] = r;
                                };
                            default:
                                return function(e, t, r) {
                                    void 0 !== r[e] ? r[e] = [].concat(r[e], t) : r[e] = t;
                                };
                        }
                    }(t = o({
                        arrayFormat: "none"
                    }, t)), i = Object.create(null);
                    return "string" != typeof e ? i : (e = e.trim().replace(/^[?#&]/, "")) ? (e.split("&").forEach(function(e) {
                        var t = e.replace(/\+/g, " ").split("="), n = t.shift(), o = t.length > 0 ? t.join("=") : void 0;
                        o = void 0 === o ? null : a(o), r(a(n), o, i);
                    }), Object.keys(i).sort().reduce(function(e, t) {
                        var r = i[t];
                        return Boolean(r) && "object" === (0, n.default)(r) && !Array.isArray(r) ? e[t] = u(r) : e[t] = r, e;
                    }, Object.create(null))) : i;
                }
                t.extract = c, t.parse = f, t.stringify = function(e, t) {
                    !1 === (t = o({
                        encode: !0,
                        strict: !0,
                        arrayFormat: "none"
                    }, t)).sort && (t.sort = function() {});
                    var r = function(e) {
                        switch(e.arrayFormat){
                            case "index":
                                return function(t, r, n) {
                                    return null === r ? [
                                        s(t, e),
                                        "[",
                                        n,
                                        "]"
                                    ].join("") : [
                                        s(t, e),
                                        "[",
                                        s(n, e),
                                        "]=",
                                        s(r, e)
                                    ].join("");
                                };
                            case "bracket":
                                return function(t, r) {
                                    return null === r ? s(t, e) : [
                                        s(t, e),
                                        "[]=",
                                        s(r, e)
                                    ].join("");
                                };
                            default:
                                return function(t, r) {
                                    return null === r ? s(t, e) : [
                                        s(t, e),
                                        "=",
                                        s(r, e)
                                    ].join("");
                                };
                        }
                    }(t);
                    return e ? Object.keys(e).sort(t.sort).map(function(n) {
                        var i = e[n];
                        if (void 0 === i) return "";
                        if (null === i) return s(n, t);
                        if (Array.isArray(i)) {
                            var o = [];
                            return i.slice().forEach(function(e) {
                                void 0 !== e && o.push(r(n, e, o.length));
                            }), o.join("&");
                        }
                        return s(n, t) + "=" + s(i, t);
                    }).filter(function(e) {
                        return e.length > 0;
                    }).join("&") : "";
                }, t.parseUrl = function(e, t) {
                    return {
                        url: e.split("?")[0] || "",
                        query: f(c(e), t)
                    };
                };
            },
            75010: (e, t, r)=>{
                "use strict";
                var n = r(19142), i = 65536, o = r(48850).Buffer, a = r.g.crypto || r.g.msCrypto;
                a && a.getRandomValues ? e.exports = function(e, t) {
                    if (e > 4294967295) throw new RangeError("requested too many random bytes");
                    var r = o.allocUnsafe(e);
                    if (e > 0) {
                        if (e > i) for(var s = 0; s < e; s += i)a.getRandomValues(r.slice(s, s + i));
                        else a.getRandomValues(r);
                    }
                    return "function" == typeof t ? n.nextTick(function() {
                        t(null, r);
                    }) : r;
                } : e.exports = function() {
                    throw new Error("Secure random number generation is not supported by this browser.\nUse Chrome, Firefox or Internet Explorer 11");
                };
            },
            36509: (e, t, r)=>{
                "use strict";
                var n = r(19142);
                function i() {
                    throw new Error("secure random number generation not supported by this browser\nuse chrome, FireFox or Internet Explorer 11");
                }
                var o = r(48850), a = r(75010), s = o.Buffer, u = o.kMaxLength, c = r.g.crypto || r.g.msCrypto, f = Math.pow(2, 32) - 1;
                function d(e, t) {
                    if ("number" != typeof e || e != e) throw new TypeError("offset must be a number");
                    if (e > f || e < 0) throw new TypeError("offset must be a uint32");
                    if (e > u || e > t) throw new RangeError("offset out of range");
                }
                function l(e, t, r) {
                    if ("number" != typeof e || e != e) throw new TypeError("size must be a number");
                    if (e > f || e < 0) throw new TypeError("size must be a uint32");
                    if (e + t > r || e > u) throw new RangeError("buffer too small");
                }
                function h(e, t, r, i) {
                    if (n.browser) {
                        var o = e.buffer, s = new Uint8Array(o, t, r);
                        return c.getRandomValues(s), i ? void n.nextTick(function() {
                            i(null, e);
                        }) : e;
                    }
                    if (!i) return a(r).copy(e, t), e;
                    a(r, function(r, n) {
                        if (r) return i(r);
                        n.copy(e, t), i(null, e);
                    });
                }
                c && c.getRandomValues || !n.browser ? (t.randomFill = function(e, t, n, i) {
                    if (!(s.isBuffer(e) || e instanceof r.g.Uint8Array)) throw new TypeError('"buf" argument must be a Buffer or Uint8Array');
                    if ("function" == typeof t) i = t, t = 0, n = e.length;
                    else if ("function" == typeof n) i = n, n = e.length - t;
                    else if ("function" != typeof i) throw new TypeError('"cb" argument must be a function');
                    return d(t, e.length), l(n, t, e.length), h(e, t, n, i);
                }, t.randomFillSync = function(e, t, n) {
                    if (void 0 === t && (t = 0), !(s.isBuffer(e) || e instanceof r.g.Uint8Array)) throw new TypeError('"buf" argument must be a Buffer or Uint8Array');
                    return d(t, e.length), void 0 === n && (n = e.length - t), l(n, t, e.length), h(e, t, n);
                }) : (t.randomFill = i, t.randomFillSync = i);
            },
            79024: (e, t, r)=>{
                "use strict";
                var n = r(28847)(r(3355)), i = {};
                function o(e, t, r) {
                    r || (r = Error);
                    var n = function(e) {
                        var r, n;
                        function i(r, n, i) {
                            return e.call(this, function(e, r, n) {
                                return "string" == typeof t ? t : t(e, r, n);
                            }(r, n, i)) || this;
                        }
                        return n = e, (r = i).prototype = Object.create(n.prototype), r.prototype.constructor = r, r.__proto__ = n, i;
                    }(r);
                    n.prototype.name = r.name, n.prototype.code = e, i[e] = n;
                }
                function a(e, t) {
                    if (Array.isArray(e)) {
                        var r = e.length;
                        return e = e.map(function(e) {
                            return String(e);
                        }), r > 2 ? "one of ".concat(t, " ").concat(e.slice(0, r - 1).join(", "), ", or ") + e[r - 1] : 2 === r ? "one of ".concat(t, " ").concat(e[0], " or ").concat(e[1]) : "of ".concat(t, " ").concat(e[0]);
                    }
                    return "of ".concat(t, " ").concat(String(e));
                }
                o("ERR_INVALID_OPT_VALUE", function(e, t) {
                    return 'The value "' + t + '" is invalid for option "' + e + '"';
                }, TypeError), o("ERR_INVALID_ARG_TYPE", function(e, t, r) {
                    var i, o, s, u, c;
                    if ("string" == typeof t && (o = "not ", t.substr(0, o.length) === o) ? (i = "must not be", t = t.replace(/^not /, "")) : i = "must be", function(e, t, r) {
                        return (void 0 === r || r > e.length) && (r = e.length), e.substring(r - t.length, r) === t;
                    }(e, " argument")) s = "The ".concat(e, " ").concat(i, " ").concat(a(t, "type"));
                    else {
                        var f = ("number" != typeof c && (c = 0), c + 1 > (u = e).length || -1 === u.indexOf(".", c) ? "argument" : "property");
                        s = 'The "'.concat(e, '" ').concat(f, " ").concat(i, " ").concat(a(t, "type"));
                    }
                    return s + ". Received type ".concat((0, n.default)(r));
                }, TypeError), o("ERR_STREAM_PUSH_AFTER_EOF", "stream.push() after EOF"), o("ERR_METHOD_NOT_IMPLEMENTED", function(e) {
                    return "The " + e + " method is not implemented";
                }), o("ERR_STREAM_PREMATURE_CLOSE", "Premature close"), o("ERR_STREAM_DESTROYED", function(e) {
                    return "Cannot call " + e + " after a stream was destroyed";
                }), o("ERR_MULTIPLE_CALLBACK", "Callback called multiple times"), o("ERR_STREAM_CANNOT_PIPE", "Cannot pipe, not readable"), o("ERR_STREAM_WRITE_AFTER_END", "write after end"), o("ERR_STREAM_NULL_VALUES", "May not write null values to stream", TypeError), o("ERR_UNKNOWN_ENCODING", function(e) {
                    return "Unknown encoding: " + e;
                }, TypeError), o("ERR_STREAM_UNSHIFT_AFTER_END_EVENT", "stream.unshift() after end event"), e.exports.q = i;
            },
            76884: (e, t, r)=>{
                "use strict";
                var n = r(19142), i = Object.keys || function(e) {
                    var t = [];
                    for(var r in e)t.push(r);
                    return t;
                };
                e.exports = f;
                var o = r(6297), a = r(71471);
                r(41736)(f, o);
                for(var s = i(a.prototype), u = 0; u < s.length; u++){
                    var c = s[u];
                    f.prototype[c] || (f.prototype[c] = a.prototype[c]);
                }
                function f(e) {
                    if (!(this instanceof f)) return new f(e);
                    o.call(this, e), a.call(this, e), this.allowHalfOpen = !0, e && (!1 === e.readable && (this.readable = !1), !1 === e.writable && (this.writable = !1), !1 === e.allowHalfOpen && (this.allowHalfOpen = !1, this.once("end", d)));
                }
                function d() {
                    this._writableState.ended || n.nextTick(l, this);
                }
                function l(e) {
                    e.end();
                }
                Object.defineProperty(f.prototype, "writableHighWaterMark", {
                    enumerable: !1,
                    get: function() {
                        return this._writableState.highWaterMark;
                    }
                }), Object.defineProperty(f.prototype, "writableBuffer", {
                    enumerable: !1,
                    get: function() {
                        return this._writableState && this._writableState.getBuffer();
                    }
                }), Object.defineProperty(f.prototype, "writableLength", {
                    enumerable: !1,
                    get: function() {
                        return this._writableState.length;
                    }
                }), Object.defineProperty(f.prototype, "destroyed", {
                    enumerable: !1,
                    get: function() {
                        return void 0 !== this._readableState && void 0 !== this._writableState && this._readableState.destroyed && this._writableState.destroyed;
                    },
                    set: function(e) {
                        void 0 !== this._readableState && void 0 !== this._writableState && (this._readableState.destroyed = e, this._writableState.destroyed = e);
                    }
                });
            },
            53582: (e, t, r)=>{
                "use strict";
                e.exports = i;
                var n = r(99154);
                function i(e) {
                    if (!(this instanceof i)) return new i(e);
                    n.call(this, e);
                }
                r(41736)(i, n), i.prototype._transform = function(e, t, r) {
                    r(null, e);
                };
            },
            6297: (e, t, r)=>{
                "use strict";
                var n, i = r(19142);
                e.exports = S, S.ReadableState = E, r(38291).EventEmitter;
                var o, a = function(e, t) {
                    return e.listeners(t).length;
                }, s = r(37144), u = r(29033).Buffer, c = (void 0 !== r.g ? r.g : "undefined" != typeof window ? window : "undefined" != typeof self ? self : {}).Uint8Array || function() {}, f = r(94616);
                o = f && f.debuglog ? f.debuglog("stream") : function() {};
                var d, l, h, p = r(25392), b = r(57572), y = r(6756).getHighWaterMark, v = r(79024).q, m = v.ERR_INVALID_ARG_TYPE, g = v.ERR_STREAM_PUSH_AFTER_EOF, w = v.ERR_METHOD_NOT_IMPLEMENTED, k = v.ERR_STREAM_UNSHIFT_AFTER_END_EVENT;
                r(41736)(S, s);
                var _ = b.errorOrDestroy, A = [
                    "error",
                    "close",
                    "destroy",
                    "pause",
                    "resume"
                ];
                function E(e, t, i) {
                    n = n || r(76884), e = e || {}, "boolean" != typeof i && (i = t instanceof n), this.objectMode = !!e.objectMode, i && (this.objectMode = this.objectMode || !!e.readableObjectMode), this.highWaterMark = y(this, e, "readableHighWaterMark", i), this.buffer = new p, this.length = 0, this.pipes = null, this.pipesCount = 0, this.flowing = null, this.ended = !1, this.endEmitted = !1, this.reading = !1, this.sync = !0, this.needReadable = !1, this.emittedReadable = !1, this.readableListening = !1, this.resumeScheduled = !1, this.paused = !0, this.emitClose = !1 !== e.emitClose, this.autoDestroy = !!e.autoDestroy, this.destroyed = !1, this.defaultEncoding = e.defaultEncoding || "utf8", this.awaitDrain = 0, this.readingMore = !1, this.decoder = null, this.encoding = null, e.encoding && (d || (d = r(23462).s), this.decoder = new d(e.encoding), this.encoding = e.encoding);
                }
                function S(e) {
                    if (n = n || r(76884), !(this instanceof S)) return new S(e);
                    var t = this instanceof n;
                    this._readableState = new E(e, this, t), this.readable = !0, e && ("function" == typeof e.read && (this._read = e.read), "function" == typeof e.destroy && (this._destroy = e.destroy)), s.call(this);
                }
                function x(e, t, r, n, i) {
                    o("readableAddChunk", t);
                    var a, s = e._readableState;
                    if (null === t) s.reading = !1, function(e, t) {
                        if (o("onEofChunk"), !t.ended) {
                            if (t.decoder) {
                                var r = t.decoder.end();
                                r && r.length && (t.buffer.push(r), t.length += t.objectMode ? 1 : r.length);
                            }
                            t.ended = !0, t.sync ? I(e) : (t.needReadable = !1, t.emittedReadable || (t.emittedReadable = !0, T(e)));
                        }
                    }(e, s);
                    else if (i || (a = function(e, t) {
                        var r, n;
                        return n = t, u.isBuffer(n) || n instanceof c || "string" == typeof t || void 0 === t || e.objectMode || (r = new m("chunk", [
                            "string",
                            "Buffer",
                            "Uint8Array"
                        ], t)), r;
                    }(s, t)), a) _(e, a);
                    else if (s.objectMode || t && t.length > 0) {
                        if ("string" == typeof t || s.objectMode || Object.getPrototypeOf(t) === u.prototype || (t = function(e) {
                            return u.from(e);
                        }(t)), n) s.endEmitted ? _(e, new k) : B(e, s, t, !0);
                        else if (s.ended) _(e, new g);
                        else {
                            if (s.destroyed) return !1;
                            s.reading = !1, s.decoder && !r ? (t = s.decoder.write(t), s.objectMode || 0 !== t.length ? B(e, s, t, !1) : C(e, s)) : B(e, s, t, !1);
                        }
                    } else n || (s.reading = !1, C(e, s));
                    return !s.ended && (s.length < s.highWaterMark || 0 === s.length);
                }
                function B(e, t, r, n) {
                    t.flowing && 0 === t.length && !t.sync ? (t.awaitDrain = 0, e.emit("data", r)) : (t.length += t.objectMode ? 1 : r.length, n ? t.buffer.unshift(r) : t.buffer.push(r), t.needReadable && I(e)), C(e, t);
                }
                Object.defineProperty(S.prototype, "destroyed", {
                    enumerable: !1,
                    get: function() {
                        return void 0 !== this._readableState && this._readableState.destroyed;
                    },
                    set: function(e) {
                        this._readableState && (this._readableState.destroyed = e);
                    }
                }), S.prototype.destroy = b.destroy, S.prototype._undestroy = b.undestroy, S.prototype._destroy = function(e, t) {
                    t(e);
                }, S.prototype.push = function(e, t) {
                    var r, n = this._readableState;
                    return n.objectMode ? r = !0 : "string" == typeof e && ((t = t || n.defaultEncoding) !== n.encoding && (e = u.from(e, t), t = ""), r = !0), x(this, e, t, !1, r);
                }, S.prototype.unshift = function(e) {
                    return x(this, e, null, !0, !1);
                }, S.prototype.isPaused = function() {
                    return !1 === this._readableState.flowing;
                }, S.prototype.setEncoding = function(e) {
                    d || (d = r(23462).s);
                    var t = new d(e);
                    this._readableState.decoder = t, this._readableState.encoding = this._readableState.decoder.encoding;
                    for(var n = this._readableState.buffer.head, i = ""; null !== n;)i += t.write(n.data), n = n.next;
                    return this._readableState.buffer.clear(), "" !== i && this._readableState.buffer.push(i), this._readableState.length = i.length, this;
                };
                var O = 1073741824;
                function P(e, t) {
                    return e <= 0 || 0 === t.length && t.ended ? 0 : t.objectMode ? 1 : e != e ? t.flowing && t.length ? t.buffer.head.data.length : t.length : (e > t.highWaterMark && (t.highWaterMark = function(e) {
                        return e >= O ? e = O : (e--, e |= e >>> 1, e |= e >>> 2, e |= e >>> 4, e |= e >>> 8, e |= e >>> 16, e++), e;
                    }(e)), e <= t.length ? e : t.ended ? t.length : (t.needReadable = !0, 0));
                }
                function I(e) {
                    var t = e._readableState;
                    o("emitReadable", t.needReadable, t.emittedReadable), t.needReadable = !1, t.emittedReadable || (o("emitReadable", t.flowing), t.emittedReadable = !0, i.nextTick(T, e));
                }
                function T(e) {
                    var t = e._readableState;
                    o("emitReadable_", t.destroyed, t.length, t.ended), t.destroyed || !t.length && !t.ended || (e.emit("readable"), t.emittedReadable = !1), t.needReadable = !t.flowing && !t.ended && t.length <= t.highWaterMark, j(e);
                }
                function C(e, t) {
                    t.readingMore || (t.readingMore = !0, i.nextTick(M, e, t));
                }
                function M(e, t) {
                    for(; !t.reading && !t.ended && (t.length < t.highWaterMark || t.flowing && 0 === t.length);){
                        var r = t.length;
                        if (o("maybeReadMore read 0"), e.read(0), r === t.length) break;
                    }
                    t.readingMore = !1;
                }
                function R(e) {
                    var t = e._readableState;
                    t.readableListening = e.listenerCount("readable") > 0, t.resumeScheduled && !t.paused ? t.flowing = !0 : e.listenerCount("data") > 0 && e.resume();
                }
                function U(e) {
                    o("readable nexttick read 0"), e.read(0);
                }
                function N(e, t) {
                    o("resume", t.reading), t.reading || e.read(0), t.resumeScheduled = !1, e.emit("resume"), j(e), t.flowing && !t.reading && e.read(0);
                }
                function j(e) {
                    var t = e._readableState;
                    for(o("flow", t.flowing); t.flowing && null !== e.read(););
                }
                function L(e, t) {
                    var r;
                    return 0 === t.length ? null : (t.objectMode ? r = t.buffer.shift() : !e || e >= t.length ? (r = t.decoder ? t.buffer.join("") : 1 === t.buffer.length ? t.buffer.first() : t.buffer.concat(t.length), t.buffer.clear()) : r = t.buffer.consume(e, t.decoder), r);
                }
                function F(e) {
                    var t = e._readableState;
                    o("endReadable", t.endEmitted), t.endEmitted || (t.ended = !0, i.nextTick(D, t, e));
                }
                function D(e, t) {
                    if (o("endReadableNT", e.endEmitted, e.length), !e.endEmitted && 0 === e.length && (e.endEmitted = !0, t.readable = !1, t.emit("end"), e.autoDestroy)) {
                        var r = t._writableState;
                        (!r || r.autoDestroy && r.finished) && t.destroy();
                    }
                }
                function H(e, t) {
                    for(var r = 0, n = e.length; r < n; r++)if (e[r] === t) return r;
                    return -1;
                }
                S.prototype.read = function(e) {
                    o("read", e), e = parseInt(e, 10);
                    var t = this._readableState, r = e;
                    if (0 !== e && (t.emittedReadable = !1), 0 === e && t.needReadable && ((0 !== t.highWaterMark ? t.length >= t.highWaterMark : t.length > 0) || t.ended)) return o("read: emitReadable", t.length, t.ended), 0 === t.length && t.ended ? F(this) : I(this), null;
                    if (0 === (e = P(e, t)) && t.ended) return 0 === t.length && F(this), null;
                    var n, i = t.needReadable;
                    return o("need readable", i), (0 === t.length || t.length - e < t.highWaterMark) && o("length less than watermark", i = !0), t.ended || t.reading ? o("reading or ended", i = !1) : i && (o("do read"), t.reading = !0, t.sync = !0, 0 === t.length && (t.needReadable = !0), this._read(t.highWaterMark), t.sync = !1, t.reading || (e = P(r, t))), null === (n = e > 0 ? L(e, t) : null) ? (t.needReadable = t.length <= t.highWaterMark, e = 0) : (t.length -= e, t.awaitDrain = 0), 0 === t.length && (t.ended || (t.needReadable = !0), r !== e && t.ended && F(this)), null !== n && this.emit("data", n), n;
                }, S.prototype._read = function(e) {
                    _(this, new w("_read()"));
                }, S.prototype.pipe = function(e, t) {
                    var r = this, n = this._readableState;
                    switch(n.pipesCount){
                        case 0:
                            n.pipes = e;
                            break;
                        case 1:
                            n.pipes = [
                                n.pipes,
                                e
                            ];
                            break;
                        default:
                            n.pipes.push(e);
                    }
                    n.pipesCount += 1, o("pipe count=%d opts=%j", n.pipesCount, t);
                    var s = t && !1 === t.end || e === i.stdout || e === i.stderr ? b : u;
                    function u() {
                        o("onend"), e.end();
                    }
                    n.endEmitted ? i.nextTick(s) : r.once("end", s), e.on("unpipe", function t(i, a) {
                        o("onunpipe"), i === r && a && !1 === a.hasUnpiped && (a.hasUnpiped = !0, o("cleanup"), e.removeListener("close", h), e.removeListener("finish", p), e.removeListener("drain", c), e.removeListener("error", l), e.removeListener("unpipe", t), r.removeListener("end", u), r.removeListener("end", b), r.removeListener("data", d), f = !0, !n.awaitDrain || e._writableState && !e._writableState.needDrain || c());
                    });
                    var c = function(e) {
                        return function() {
                            var t = e._readableState;
                            o("pipeOnDrain", t.awaitDrain), t.awaitDrain && t.awaitDrain--, 0 === t.awaitDrain && a(e, "data") && (t.flowing = !0, j(e));
                        };
                    }(r);
                    e.on("drain", c);
                    var f = !1;
                    function d(t) {
                        o("ondata");
                        var i = e.write(t);
                        o("dest.write", i), !1 === i && ((1 === n.pipesCount && n.pipes === e || n.pipesCount > 1 && -1 !== H(n.pipes, e)) && !f && (o("false write response, pause", n.awaitDrain), n.awaitDrain++), r.pause());
                    }
                    function l(t) {
                        o("onerror", t), b(), e.removeListener("error", l), 0 === a(e, "error") && _(e, t);
                    }
                    function h() {
                        e.removeListener("finish", p), b();
                    }
                    function p() {
                        o("onfinish"), e.removeListener("close", h), b();
                    }
                    function b() {
                        o("unpipe"), r.unpipe(e);
                    }
                    return r.on("data", d), function(e, t, r) {
                        if ("function" == typeof e.prependListener) return e.prependListener(t, r);
                        e._events && e._events[t] ? Array.isArray(e._events[t]) ? e._events[t].unshift(r) : e._events[t] = [
                            r,
                            e._events[t]
                        ] : e.on(t, r);
                    }(e, "error", l), e.once("close", h), e.once("finish", p), e.emit("pipe", r), n.flowing || (o("pipe resume"), r.resume()), e;
                }, S.prototype.unpipe = function(e) {
                    var t = this._readableState, r = {
                        hasUnpiped: !1
                    };
                    if (0 === t.pipesCount) return this;
                    if (1 === t.pipesCount) return e && e !== t.pipes || (e || (e = t.pipes), t.pipes = null, t.pipesCount = 0, t.flowing = !1, e && e.emit("unpipe", this, r)), this;
                    if (!e) {
                        var n = t.pipes, i = t.pipesCount;
                        t.pipes = null, t.pipesCount = 0, t.flowing = !1;
                        for(var o = 0; o < i; o++)n[o].emit("unpipe", this, {
                            hasUnpiped: !1
                        });
                        return this;
                    }
                    var a = H(t.pipes, e);
                    return -1 === a || (t.pipes.splice(a, 1), t.pipesCount -= 1, 1 === t.pipesCount && (t.pipes = t.pipes[0]), e.emit("unpipe", this, r)), this;
                }, S.prototype.on = function(e, t) {
                    var r = s.prototype.on.call(this, e, t), n = this._readableState;
                    return "data" === e ? (n.readableListening = this.listenerCount("readable") > 0, !1 !== n.flowing && this.resume()) : "readable" === e && (n.endEmitted || n.readableListening || (n.readableListening = n.needReadable = !0, n.flowing = !1, n.emittedReadable = !1, o("on readable", n.length, n.reading), n.length ? I(this) : n.reading || i.nextTick(U, this))), r;
                }, S.prototype.addListener = S.prototype.on, S.prototype.removeListener = function(e, t) {
                    var r = s.prototype.removeListener.call(this, e, t);
                    return "readable" === e && i.nextTick(R, this), r;
                }, S.prototype.removeAllListeners = function(e) {
                    var t = s.prototype.removeAllListeners.apply(this, arguments);
                    return "readable" !== e && void 0 !== e || i.nextTick(R, this), t;
                }, S.prototype.resume = function() {
                    var e = this._readableState;
                    return e.flowing || (o("resume"), e.flowing = !e.readableListening, function(e, t) {
                        t.resumeScheduled || (t.resumeScheduled = !0, i.nextTick(N, e, t));
                    }(this, e)), e.paused = !1, this;
                }, S.prototype.pause = function() {
                    return o("call pause flowing=%j", this._readableState.flowing), !1 !== this._readableState.flowing && (o("pause"), this._readableState.flowing = !1, this.emit("pause")), this._readableState.paused = !0, this;
                }, S.prototype.wrap = function(e) {
                    var t = this, r = this._readableState, n = !1;
                    for(var i in e.on("end", function() {
                        if (o("wrapped end"), r.decoder && !r.ended) {
                            var e = r.decoder.end();
                            e && e.length && t.push(e);
                        }
                        t.push(null);
                    }), e.on("data", function(i) {
                        o("wrapped data"), r.decoder && (i = r.decoder.write(i)), r.objectMode && null == i || (r.objectMode || i && i.length) && (t.push(i) || (n = !0, e.pause()));
                    }), e)void 0 === this[i] && "function" == typeof e[i] && (this[i] = function(t) {
                        return function() {
                            return e[t].apply(e, arguments);
                        };
                    }(i));
                    for(var a = 0; a < A.length; a++)e.on(A[a], this.emit.bind(this, A[a]));
                    return this._read = function(t) {
                        o("wrapped _read", t), n && (n = !1, e.resume());
                    }, this;
                }, "function" == typeof Symbol && (S.prototype[Symbol.asyncIterator] = function() {
                    return void 0 === l && (l = r(32317)), l(this);
                }), Object.defineProperty(S.prototype, "readableHighWaterMark", {
                    enumerable: !1,
                    get: function() {
                        return this._readableState.highWaterMark;
                    }
                }), Object.defineProperty(S.prototype, "readableBuffer", {
                    enumerable: !1,
                    get: function() {
                        return this._readableState && this._readableState.buffer;
                    }
                }), Object.defineProperty(S.prototype, "readableFlowing", {
                    enumerable: !1,
                    get: function() {
                        return this._readableState.flowing;
                    },
                    set: function(e) {
                        this._readableState && (this._readableState.flowing = e);
                    }
                }), S._fromList = L, Object.defineProperty(S.prototype, "readableLength", {
                    enumerable: !1,
                    get: function() {
                        return this._readableState.length;
                    }
                }), "function" == typeof Symbol && (S.from = function(e, t) {
                    return void 0 === h && (h = r(16218)), h(S, e, t);
                });
            },
            99154: (e, t, r)=>{
                "use strict";
                e.exports = f;
                var n = r(79024).q, i = n.ERR_METHOD_NOT_IMPLEMENTED, o = n.ERR_MULTIPLE_CALLBACK, a = n.ERR_TRANSFORM_ALREADY_TRANSFORMING, s = n.ERR_TRANSFORM_WITH_LENGTH_0, u = r(76884);
                function c(e, t) {
                    var r = this._transformState;
                    r.transforming = !1;
                    var n = r.writecb;
                    if (null === n) return this.emit("error", new o);
                    r.writechunk = null, r.writecb = null, null != t && this.push(t), n(e);
                    var i = this._readableState;
                    i.reading = !1, (i.needReadable || i.length < i.highWaterMark) && this._read(i.highWaterMark);
                }
                function f(e) {
                    if (!(this instanceof f)) return new f(e);
                    u.call(this, e), this._transformState = {
                        afterTransform: c.bind(this),
                        needTransform: !1,
                        transforming: !1,
                        writecb: null,
                        writechunk: null,
                        writeencoding: null
                    }, this._readableState.needReadable = !0, this._readableState.sync = !1, e && ("function" == typeof e.transform && (this._transform = e.transform), "function" == typeof e.flush && (this._flush = e.flush)), this.on("prefinish", d);
                }
                function d() {
                    var e = this;
                    "function" != typeof this._flush || this._readableState.destroyed ? l(this, null, null) : this._flush(function(t, r) {
                        l(e, t, r);
                    });
                }
                function l(e, t, r) {
                    if (t) return e.emit("error", t);
                    if (null != r && e.push(r), e._writableState.length) throw new s;
                    if (e._transformState.transforming) throw new a;
                    return e.push(null);
                }
                r(41736)(f, u), f.prototype.push = function(e, t) {
                    return this._transformState.needTransform = !1, u.prototype.push.call(this, e, t);
                }, f.prototype._transform = function(e, t, r) {
                    r(new i("_transform()"));
                }, f.prototype._write = function(e, t, r) {
                    var n = this._transformState;
                    if (n.writecb = r, n.writechunk = e, n.writeencoding = t, !n.transforming) {
                        var i = this._readableState;
                        (n.needTransform || i.needReadable || i.length < i.highWaterMark) && this._read(i.highWaterMark);
                    }
                }, f.prototype._read = function(e) {
                    var t = this._transformState;
                    null === t.writechunk || t.transforming ? t.needTransform = !0 : (t.transforming = !0, this._transform(t.writechunk, t.writeencoding, t.afterTransform));
                }, f.prototype._destroy = function(e, t) {
                    u.prototype._destroy.call(this, e, function(e) {
                        t(e);
                    });
                };
            },
            71471: (e, t, r)=>{
                "use strict";
                var n, i = r(19142);
                function o(e) {
                    var t = this;
                    this.next = null, this.entry = null, this.finish = function() {
                        !function(e, t, r) {
                            var n = e.entry;
                            for(e.entry = null; n;){
                                var i = n.callback;
                                t.pendingcb--, i(undefined), n = n.next;
                            }
                            t.corkedRequestsFree.next = e;
                        }(t, e);
                    };
                }
                e.exports = S, S.WritableState = E;
                var a, s = {
                    deprecate: r(96219)
                }, u = r(37144), c = r(29033).Buffer, f = (void 0 !== r.g ? r.g : "undefined" != typeof window ? window : "undefined" != typeof self ? self : {}).Uint8Array || function() {}, d = r(57572), l = r(6756).getHighWaterMark, h = r(79024).q, p = h.ERR_INVALID_ARG_TYPE, b = h.ERR_METHOD_NOT_IMPLEMENTED, y = h.ERR_MULTIPLE_CALLBACK, v = h.ERR_STREAM_CANNOT_PIPE, m = h.ERR_STREAM_DESTROYED, g = h.ERR_STREAM_NULL_VALUES, w = h.ERR_STREAM_WRITE_AFTER_END, k = h.ERR_UNKNOWN_ENCODING, _ = d.errorOrDestroy;
                function A() {}
                function E(e, t, a) {
                    n = n || r(76884), e = e || {}, "boolean" != typeof a && (a = t instanceof n), this.objectMode = !!e.objectMode, a && (this.objectMode = this.objectMode || !!e.writableObjectMode), this.highWaterMark = l(this, e, "writableHighWaterMark", a), this.finalCalled = !1, this.needDrain = !1, this.ending = !1, this.ended = !1, this.finished = !1, this.destroyed = !1;
                    var s = !1 === e.decodeStrings;
                    this.decodeStrings = !s, this.defaultEncoding = e.defaultEncoding || "utf8", this.length = 0, this.writing = !1, this.corked = 0, this.sync = !0, this.bufferProcessing = !1, this.onwrite = function(e) {
                        !function(e, t) {
                            var r = e._writableState, n = r.sync, o = r.writecb;
                            if ("function" != typeof o) throw new y;
                            if (function(e) {
                                e.writing = !1, e.writecb = null, e.length -= e.writelen, e.writelen = 0;
                            }(r), t) !function(e, t, r, n, o) {
                                --t.pendingcb, r ? (i.nextTick(o, n), i.nextTick(T, e, t), e._writableState.errorEmitted = !0, _(e, n)) : (o(n), e._writableState.errorEmitted = !0, _(e, n), T(e, t));
                            }(e, r, n, t, o);
                            else {
                                var a = P(r) || e.destroyed;
                                a || r.corked || r.bufferProcessing || !r.bufferedRequest || O(e, r), n ? i.nextTick(B, e, r, a, o) : B(e, r, a, o);
                            }
                        }(t, e);
                    }, this.writecb = null, this.writelen = 0, this.bufferedRequest = null, this.lastBufferedRequest = null, this.pendingcb = 0, this.prefinished = !1, this.errorEmitted = !1, this.emitClose = !1 !== e.emitClose, this.autoDestroy = !!e.autoDestroy, this.bufferedRequestCount = 0, this.corkedRequestsFree = new o(this);
                }
                function S(e) {
                    var t = this instanceof (n = n || r(76884));
                    if (!t && !a.call(S, this)) return new S(e);
                    this._writableState = new E(e, this, t), this.writable = !0, e && ("function" == typeof e.write && (this._write = e.write), "function" == typeof e.writev && (this._writev = e.writev), "function" == typeof e.destroy && (this._destroy = e.destroy), "function" == typeof e.final && (this._final = e.final)), u.call(this);
                }
                function x(e, t, r, n, i, o, a) {
                    t.writelen = n, t.writecb = a, t.writing = !0, t.sync = !0, t.destroyed ? t.onwrite(new m("write")) : r ? e._writev(i, t.onwrite) : e._write(i, o, t.onwrite), t.sync = !1;
                }
                function B(e, t, r, n) {
                    r || function(e, t) {
                        0 === t.length && t.needDrain && (t.needDrain = !1, e.emit("drain"));
                    }(e, t), t.pendingcb--, n(), T(e, t);
                }
                function O(e, t) {
                    t.bufferProcessing = !0;
                    var r = t.bufferedRequest;
                    if (e._writev && r && r.next) {
                        var n = t.bufferedRequestCount, i = new Array(n), a = t.corkedRequestsFree;
                        a.entry = r;
                        for(var s = 0, u = !0; r;)i[s] = r, r.isBuf || (u = !1), r = r.next, s += 1;
                        i.allBuffers = u, x(e, t, !0, t.length, i, "", a.finish), t.pendingcb++, t.lastBufferedRequest = null, a.next ? (t.corkedRequestsFree = a.next, a.next = null) : t.corkedRequestsFree = new o(t), t.bufferedRequestCount = 0;
                    } else {
                        for(; r;){
                            var c = r.chunk, f = r.encoding, d = r.callback;
                            if (x(e, t, !1, t.objectMode ? 1 : c.length, c, f, d), r = r.next, t.bufferedRequestCount--, t.writing) break;
                        }
                        null === r && (t.lastBufferedRequest = null);
                    }
                    t.bufferedRequest = r, t.bufferProcessing = !1;
                }
                function P(e) {
                    return e.ending && 0 === e.length && null === e.bufferedRequest && !e.finished && !e.writing;
                }
                function I(e, t) {
                    e._final(function(r) {
                        t.pendingcb--, r && _(e, r), t.prefinished = !0, e.emit("prefinish"), T(e, t);
                    });
                }
                function T(e, t) {
                    var r = P(t);
                    if (r && (function(e, t) {
                        t.prefinished || t.finalCalled || ("function" != typeof e._final || t.destroyed ? (t.prefinished = !0, e.emit("prefinish")) : (t.pendingcb++, t.finalCalled = !0, i.nextTick(I, e, t)));
                    }(e, t), 0 === t.pendingcb && (t.finished = !0, e.emit("finish"), t.autoDestroy))) {
                        var n = e._readableState;
                        (!n || n.autoDestroy && n.endEmitted) && e.destroy();
                    }
                    return r;
                }
                r(41736)(S, u), E.prototype.getBuffer = function() {
                    for(var e = this.bufferedRequest, t = []; e;)t.push(e), e = e.next;
                    return t;
                }, function() {
                    try {
                        Object.defineProperty(E.prototype, "buffer", {
                            get: s.deprecate(function() {
                                return this.getBuffer();
                            }, "_writableState.buffer is deprecated. Use _writableState.getBuffer instead.", "DEP0003")
                        });
                    } catch (e) {}
                }(), "function" == typeof Symbol && Symbol.hasInstance && "function" == typeof Function.prototype[Symbol.hasInstance] ? (a = Function.prototype[Symbol.hasInstance], Object.defineProperty(S, Symbol.hasInstance, {
                    value: function(e) {
                        return !!a.call(this, e) || this === S && e && e._writableState instanceof E;
                    }
                })) : a = function(e) {
                    return e instanceof this;
                }, S.prototype.pipe = function() {
                    _(this, new v);
                }, S.prototype.write = function(e, t, r) {
                    var n, o = this._writableState, a = !1, s = !o.objectMode && (n = e, c.isBuffer(n) || n instanceof f);
                    return s && !c.isBuffer(e) && (e = function(e) {
                        return c.from(e);
                    }(e)), "function" == typeof t && (r = t, t = null), s ? t = "buffer" : t || (t = o.defaultEncoding), "function" != typeof r && (r = A), o.ending ? function(e, t) {
                        var r = new w;
                        _(e, r), i.nextTick(t, r);
                    }(this, r) : (s || function(e, t, r, n) {
                        var o;
                        return null === r ? o = new g : "string" == typeof r || t.objectMode || (o = new p("chunk", [
                            "string",
                            "Buffer"
                        ], r)), !o || (_(e, o), i.nextTick(n, o), !1);
                    }(this, o, e, r)) && (o.pendingcb++, a = function(e, t, r, n, i, o) {
                        if (!r) {
                            var a = function(e, t, r) {
                                return e.objectMode || !1 === e.decodeStrings || "string" != typeof t || (t = c.from(t, r)), t;
                            }(t, n, i);
                            n !== a && (r = !0, i = "buffer", n = a);
                        }
                        var s = t.objectMode ? 1 : n.length;
                        t.length += s;
                        var u = t.length < t.highWaterMark;
                        if (u || (t.needDrain = !0), t.writing || t.corked) {
                            var f = t.lastBufferedRequest;
                            t.lastBufferedRequest = {
                                chunk: n,
                                encoding: i,
                                isBuf: r,
                                callback: o,
                                next: null
                            }, f ? f.next = t.lastBufferedRequest : t.bufferedRequest = t.lastBufferedRequest, t.bufferedRequestCount += 1;
                        } else x(e, t, !1, s, n, i, o);
                        return u;
                    }(this, o, s, e, t, r)), a;
                }, S.prototype.cork = function() {
                    this._writableState.corked++;
                }, S.prototype.uncork = function() {
                    var e = this._writableState;
                    e.corked && (e.corked--, e.writing || e.corked || e.bufferProcessing || !e.bufferedRequest || O(this, e));
                }, S.prototype.setDefaultEncoding = function(e) {
                    if ("string" == typeof e && (e = e.toLowerCase()), !([
                        "hex",
                        "utf8",
                        "utf-8",
                        "ascii",
                        "binary",
                        "base64",
                        "ucs2",
                        "ucs-2",
                        "utf16le",
                        "utf-16le",
                        "raw"
                    ].indexOf((e + "").toLowerCase()) > -1)) throw new k(e);
                    return this._writableState.defaultEncoding = e, this;
                }, Object.defineProperty(S.prototype, "writableBuffer", {
                    enumerable: !1,
                    get: function() {
                        return this._writableState && this._writableState.getBuffer();
                    }
                }), Object.defineProperty(S.prototype, "writableHighWaterMark", {
                    enumerable: !1,
                    get: function() {
                        return this._writableState.highWaterMark;
                    }
                }), S.prototype._write = function(e, t, r) {
                    r(new b("_write()"));
                }, S.prototype._writev = null, S.prototype.end = function(e, t, r) {
                    var n = this._writableState;
                    return "function" == typeof e ? (r = e, e = null, t = null) : "function" == typeof t && (r = t, t = null), null != e && this.write(e, t), n.corked && (n.corked = 1, this.uncork()), n.ending || function(e, t, r) {
                        t.ending = !0, T(e, t), r && (t.finished ? i.nextTick(r) : e.once("finish", r)), t.ended = !0, e.writable = !1;
                    }(this, n, r), this;
                }, Object.defineProperty(S.prototype, "writableLength", {
                    enumerable: !1,
                    get: function() {
                        return this._writableState.length;
                    }
                }), Object.defineProperty(S.prototype, "destroyed", {
                    enumerable: !1,
                    get: function() {
                        return void 0 !== this._writableState && this._writableState.destroyed;
                    },
                    set: function(e) {
                        this._writableState && (this._writableState.destroyed = e);
                    }
                }), S.prototype.destroy = d.destroy, S.prototype._undestroy = d.undestroy, S.prototype._destroy = function(e, t) {
                    t(e);
                };
            },
            32317: (e, t, r)=>{
                "use strict";
                var n, i = r(19142), o = r(28847)(r(3355));
                function a(e, t, r) {
                    return (t = function(e) {
                        var t = function(e, t) {
                            if ("object" !== (0, o.default)(e) || null === e) return e;
                            var r = e[Symbol.toPrimitive];
                            if (void 0 !== r) {
                                var n = r.call(e, "string");
                                if ("object" !== (0, o.default)(n)) return n;
                                throw new TypeError("@@toPrimitive must return a primitive value.");
                            }
                            return String(e);
                        }(e);
                        return "symbol" === (0, o.default)(t) ? t : String(t);
                    }(t)) in e ? Object.defineProperty(e, t, {
                        value: r,
                        enumerable: !0,
                        configurable: !0,
                        writable: !0
                    }) : e[t] = r, e;
                }
                var s = r(5831), u = Symbol("lastResolve"), c = Symbol("lastReject"), f = Symbol("error"), d = Symbol("ended"), l = Symbol("lastPromise"), h = Symbol("handlePromise"), p = Symbol("stream");
                function b(e, t) {
                    return {
                        value: e,
                        done: t
                    };
                }
                function y(e) {
                    var t = e[u];
                    if (null !== t) {
                        var r = e[p].read();
                        null !== r && (e[l] = null, e[u] = null, e[c] = null, t(b(r, !1)));
                    }
                }
                function v(e) {
                    i.nextTick(y, e);
                }
                var m = Object.getPrototypeOf(function() {}), g = Object.setPrototypeOf((a(n = {
                    get stream () {
                        return this[p];
                    },
                    next: function() {
                        var e = this, t = this[f];
                        if (null !== t) return Promise.reject(t);
                        if (this[d]) return Promise.resolve(b(void 0, !0));
                        if (this[p].destroyed) return new Promise(function(t, r) {
                            i.nextTick(function() {
                                e[f] ? r(e[f]) : t(b(void 0, !0));
                            });
                        });
                        var r, n = this[l];
                        if (n) r = new Promise(function(e, t) {
                            return function(r, n) {
                                e.then(function() {
                                    t[d] ? r(b(void 0, !0)) : t[h](r, n);
                                }, n);
                            };
                        }(n, this));
                        else {
                            var o = this[p].read();
                            if (null !== o) return Promise.resolve(b(o, !1));
                            r = new Promise(this[h]);
                        }
                        return this[l] = r, r;
                    }
                }, Symbol.asyncIterator, function() {
                    return this;
                }), a(n, "return", function() {
                    var e = this;
                    return new Promise(function(t, r) {
                        e[p].destroy(null, function(e) {
                            e ? r(e) : t(b(void 0, !0));
                        });
                    });
                }), n), m);
                e.exports = function(e) {
                    var t, r = Object.create(g, (a(t = {}, p, {
                        value: e,
                        writable: !0
                    }), a(t, u, {
                        value: null,
                        writable: !0
                    }), a(t, c, {
                        value: null,
                        writable: !0
                    }), a(t, f, {
                        value: null,
                        writable: !0
                    }), a(t, d, {
                        value: e._readableState.endEmitted,
                        writable: !0
                    }), a(t, h, {
                        value: function(e, t) {
                            var n = r[p].read();
                            n ? (r[l] = null, r[u] = null, r[c] = null, e(b(n, !1))) : (r[u] = e, r[c] = t);
                        },
                        writable: !0
                    }), t));
                    return r[l] = null, s(e, function(e) {
                        if (e && "ERR_STREAM_PREMATURE_CLOSE" !== e.code) {
                            var t = r[c];
                            return null !== t && (r[l] = null, r[u] = null, r[c] = null, t(e)), void (r[f] = e);
                        }
                        var n = r[u];
                        null !== n && (r[l] = null, r[u] = null, r[c] = null, n(b(void 0, !0))), r[d] = !0;
                    }), e.on("readable", v.bind(null, r)), r;
                };
            },
            25392: (e, t, r)=>{
                "use strict";
                var n = r(28847)(r(3355));
                function i(e, t) {
                    var r = Object.keys(e);
                    if (Object.getOwnPropertySymbols) {
                        var n = Object.getOwnPropertySymbols(e);
                        t && (n = n.filter(function(t) {
                            return Object.getOwnPropertyDescriptor(e, t).enumerable;
                        })), r.push.apply(r, n);
                    }
                    return r;
                }
                function o(e) {
                    for(var t = 1; t < arguments.length; t++){
                        var r = null != arguments[t] ? arguments[t] : {};
                        t % 2 ? i(Object(r), !0).forEach(function(t) {
                            a(e, t, r[t]);
                        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : i(Object(r)).forEach(function(t) {
                            Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
                        });
                    }
                    return e;
                }
                function a(e, t, r) {
                    return (t = u(t)) in e ? Object.defineProperty(e, t, {
                        value: r,
                        enumerable: !0,
                        configurable: !0,
                        writable: !0
                    }) : e[t] = r, e;
                }
                function s(e, t) {
                    for(var r = 0; r < t.length; r++){
                        var n = t[r];
                        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, u(n.key), n);
                    }
                }
                function u(e) {
                    var t = function(e, t) {
                        if ("object" !== (0, n.default)(e) || null === e) return e;
                        var r = e[Symbol.toPrimitive];
                        if (void 0 !== r) {
                            var i = r.call(e, "string");
                            if ("object" !== (0, n.default)(i)) return i;
                            throw new TypeError("@@toPrimitive must return a primitive value.");
                        }
                        return String(e);
                    }(e);
                    return "symbol" === (0, n.default)(t) ? t : String(t);
                }
                var c = r(29033).Buffer, f = r(52361).inspect, d = f && f.custom || "inspect";
                e.exports = function() {
                    function e() {
                        !function(e, t) {
                            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                        }(this, e), this.head = null, this.tail = null, this.length = 0;
                    }
                    var t, r;
                    return t = e, r = [
                        {
                            key: "push",
                            value: function(e) {
                                var t = {
                                    data: e,
                                    next: null
                                };
                                this.length > 0 ? this.tail.next = t : this.head = t, this.tail = t, ++this.length;
                            }
                        },
                        {
                            key: "unshift",
                            value: function(e) {
                                var t = {
                                    data: e,
                                    next: this.head
                                };
                                0 === this.length && (this.tail = t), this.head = t, ++this.length;
                            }
                        },
                        {
                            key: "shift",
                            value: function() {
                                if (0 !== this.length) {
                                    var e = this.head.data;
                                    return 1 === this.length ? this.head = this.tail = null : this.head = this.head.next, --this.length, e;
                                }
                            }
                        },
                        {
                            key: "clear",
                            value: function() {
                                this.head = this.tail = null, this.length = 0;
                            }
                        },
                        {
                            key: "join",
                            value: function(e) {
                                if (0 === this.length) return "";
                                for(var t = this.head, r = "" + t.data; t = t.next;)r += e + t.data;
                                return r;
                            }
                        },
                        {
                            key: "concat",
                            value: function(e) {
                                if (0 === this.length) return c.alloc(0);
                                for(var t, r, n, i = c.allocUnsafe(e >>> 0), o = this.head, a = 0; o;)t = o.data, r = i, n = a, c.prototype.copy.call(t, r, n), a += o.data.length, o = o.next;
                                return i;
                            }
                        },
                        {
                            key: "consume",
                            value: function(e, t) {
                                var r;
                                return e < this.head.data.length ? (r = this.head.data.slice(0, e), this.head.data = this.head.data.slice(e)) : r = e === this.head.data.length ? this.shift() : t ? this._getString(e) : this._getBuffer(e), r;
                            }
                        },
                        {
                            key: "first",
                            value: function() {
                                return this.head.data;
                            }
                        },
                        {
                            key: "_getString",
                            value: function(e) {
                                var t = this.head, r = 1, n = t.data;
                                for(e -= n.length; t = t.next;){
                                    var i = t.data, o = e > i.length ? i.length : e;
                                    if (o === i.length ? n += i : n += i.slice(0, e), 0 == (e -= o)) {
                                        o === i.length ? (++r, t.next ? this.head = t.next : this.head = this.tail = null) : (this.head = t, t.data = i.slice(o));
                                        break;
                                    }
                                    ++r;
                                }
                                return this.length -= r, n;
                            }
                        },
                        {
                            key: "_getBuffer",
                            value: function(e) {
                                var t = c.allocUnsafe(e), r = this.head, n = 1;
                                for(r.data.copy(t), e -= r.data.length; r = r.next;){
                                    var i = r.data, o = e > i.length ? i.length : e;
                                    if (i.copy(t, t.length - e, 0, o), 0 == (e -= o)) {
                                        o === i.length ? (++n, r.next ? this.head = r.next : this.head = this.tail = null) : (this.head = r, r.data = i.slice(o));
                                        break;
                                    }
                                    ++n;
                                }
                                return this.length -= n, t;
                            }
                        },
                        {
                            key: d,
                            value: function(e, t) {
                                return f(this, o(o({}, t), {}, {
                                    depth: 0,
                                    customInspect: !1
                                }));
                            }
                        }
                    ], s(t.prototype, r), Object.defineProperty(t, "prototype", {
                        writable: !1
                    }), e;
                }();
            },
            57572: (e, t, r)=>{
                "use strict";
                var n = r(19142);
                function i(e, t) {
                    a(e, t), o(e);
                }
                function o(e) {
                    e._writableState && !e._writableState.emitClose || e._readableState && !e._readableState.emitClose || e.emit("close");
                }
                function a(e, t) {
                    e.emit("error", t);
                }
                e.exports = {
                    destroy: function(e, t) {
                        var r = this, s = this._readableState && this._readableState.destroyed, u = this._writableState && this._writableState.destroyed;
                        return s || u ? (t ? t(e) : e && (this._writableState ? this._writableState.errorEmitted || (this._writableState.errorEmitted = !0, n.nextTick(a, this, e)) : n.nextTick(a, this, e)), this) : (this._readableState && (this._readableState.destroyed = !0), this._writableState && (this._writableState.destroyed = !0), this._destroy(e || null, function(e) {
                            !t && e ? r._writableState ? r._writableState.errorEmitted ? n.nextTick(o, r) : (r._writableState.errorEmitted = !0, n.nextTick(i, r, e)) : n.nextTick(i, r, e) : t ? (n.nextTick(o, r), t(e)) : n.nextTick(o, r);
                        }), this);
                    },
                    undestroy: function() {
                        this._readableState && (this._readableState.destroyed = !1, this._readableState.reading = !1, this._readableState.ended = !1, this._readableState.endEmitted = !1), this._writableState && (this._writableState.destroyed = !1, this._writableState.ended = !1, this._writableState.ending = !1, this._writableState.finalCalled = !1, this._writableState.prefinished = !1, this._writableState.finished = !1, this._writableState.errorEmitted = !1);
                    },
                    errorOrDestroy: function(e, t) {
                        var r = e._readableState, n = e._writableState;
                        r && r.autoDestroy || n && n.autoDestroy ? e.destroy(t) : e.emit("error", t);
                    }
                };
            },
            5831: (e, t, r)=>{
                "use strict";
                var n = r(79024).q.ERR_STREAM_PREMATURE_CLOSE;
                function i() {}
                e.exports = function e(t, r, o) {
                    if ("function" == typeof r) return e(t, null, r);
                    r || (r = {}), o = function(e) {
                        var t = !1;
                        return function() {
                            if (!t) {
                                t = !0;
                                for(var r = arguments.length, n = new Array(r), i = 0; i < r; i++)n[i] = arguments[i];
                                e.apply(this, n);
                            }
                        };
                    }(o || i);
                    var a = r.readable || !1 !== r.readable && t.readable, s = r.writable || !1 !== r.writable && t.writable, u = function() {
                        t.writable || f();
                    }, c = t._writableState && t._writableState.finished, f = function() {
                        s = !1, c = !0, a || o.call(t);
                    }, d = t._readableState && t._readableState.endEmitted, l = function() {
                        a = !1, d = !0, s || o.call(t);
                    }, h = function(e) {
                        o.call(t, e);
                    }, p = function() {
                        var e;
                        return a && !d ? (t._readableState && t._readableState.ended || (e = new n), o.call(t, e)) : s && !c ? (t._writableState && t._writableState.ended || (e = new n), o.call(t, e)) : void 0;
                    }, b = function() {
                        t.req.on("finish", f);
                    };
                    return function(e) {
                        return e.setHeader && "function" == typeof e.abort;
                    }(t) ? (t.on("complete", f), t.on("abort", p), t.req ? b() : t.on("request", b)) : s && !t._writableState && (t.on("end", u), t.on("close", u)), t.on("end", l), t.on("finish", f), !1 !== r.error && t.on("error", h), t.on("close", p), function() {
                        t.removeListener("complete", f), t.removeListener("abort", p), t.removeListener("request", b), t.req && t.req.removeListener("finish", f), t.removeListener("end", u), t.removeListener("close", u), t.removeListener("finish", f), t.removeListener("end", l), t.removeListener("error", h), t.removeListener("close", p);
                    };
                };
            },
            16218: (e)=>{
                "use strict";
                e.exports = function() {
                    throw new Error("Readable.from is not available in the browser");
                };
            },
            60384: (e, t, r)=>{
                "use strict";
                var n, i = r(79024).q, o = i.ERR_MISSING_ARGS, a = i.ERR_STREAM_DESTROYED;
                function s(e) {
                    if (e) throw e;
                }
                function u(e) {
                    e();
                }
                function c(e, t) {
                    return e.pipe(t);
                }
                e.exports = function() {
                    for(var e = arguments.length, t = new Array(e), i = 0; i < e; i++)t[i] = arguments[i];
                    var f, d = function(e) {
                        return e.length ? "function" != typeof e[e.length - 1] ? s : e.pop() : s;
                    }(t);
                    if (Array.isArray(t[0]) && (t = t[0]), t.length < 2) throw new o("streams");
                    var l = t.map(function(e, i) {
                        var o = i < t.length - 1;
                        return function(e, t, i, o) {
                            o = function(e) {
                                var t = !1;
                                return function() {
                                    t || (t = !0, e.apply(void 0, arguments));
                                };
                            }(o);
                            var s = !1;
                            e.on("close", function() {
                                s = !0;
                            }), void 0 === n && (n = r(5831)), n(e, {
                                readable: t,
                                writable: i
                            }, function(e) {
                                if (e) return o(e);
                                s = !0, o();
                            });
                            var u = !1;
                            return function(t) {
                                if (!s && !u) return u = !0, function(e) {
                                    return e.setHeader && "function" == typeof e.abort;
                                }(e) ? e.abort() : "function" == typeof e.destroy ? e.destroy() : void o(t || new a("pipe"));
                            };
                        }(e, o, i > 0, function(e) {
                            f || (f = e), e && l.forEach(u), o || (l.forEach(u), d(f));
                        });
                    });
                    return t.reduce(c);
                };
            },
            6756: (e, t, r)=>{
                "use strict";
                var n = r(79024).q.ERR_INVALID_OPT_VALUE;
                e.exports = {
                    getHighWaterMark: function(e, t, r, i) {
                        var o = function(e, t, r) {
                            return null != e.highWaterMark ? e.highWaterMark : t ? e[r] : null;
                        }(t, i, r);
                        if (null != o) {
                            if (!isFinite(o) || Math.floor(o) !== o || o < 0) throw new n(i ? r : "highWaterMark", o);
                            return Math.floor(o);
                        }
                        return e.objectMode ? 16 : 16384;
                    }
                };
            },
            37144: (e, t, r)=>{
                "use strict";
                e.exports = r(38291).EventEmitter;
            },
            86505: (e, t, r)=>{
                "use strict";
                (t = e.exports = r(6297)).Stream = t, t.Readable = t, t.Writable = r(71471), t.Duplex = r(76884), t.Transform = r(99154), t.PassThrough = r(53582), t.finished = r(5831), t.pipeline = r(60384);
            },
            26707: (e, t, r)=>{
                "use strict";
                var n = r(29033).Buffer, i = r(41736), o = r(22353), a = new Array(16), s = [
                    0,
                    1,
                    2,
                    3,
                    4,
                    5,
                    6,
                    7,
                    8,
                    9,
                    10,
                    11,
                    12,
                    13,
                    14,
                    15,
                    7,
                    4,
                    13,
                    1,
                    10,
                    6,
                    15,
                    3,
                    12,
                    0,
                    9,
                    5,
                    2,
                    14,
                    11,
                    8,
                    3,
                    10,
                    14,
                    4,
                    9,
                    15,
                    8,
                    1,
                    2,
                    7,
                    0,
                    6,
                    13,
                    11,
                    5,
                    12,
                    1,
                    9,
                    11,
                    10,
                    0,
                    8,
                    12,
                    4,
                    13,
                    3,
                    7,
                    15,
                    14,
                    5,
                    6,
                    2,
                    4,
                    0,
                    5,
                    9,
                    7,
                    12,
                    2,
                    10,
                    14,
                    1,
                    3,
                    8,
                    11,
                    6,
                    15,
                    13
                ], u = [
                    5,
                    14,
                    7,
                    0,
                    9,
                    2,
                    11,
                    4,
                    13,
                    6,
                    15,
                    8,
                    1,
                    10,
                    3,
                    12,
                    6,
                    11,
                    3,
                    7,
                    0,
                    13,
                    5,
                    10,
                    14,
                    15,
                    8,
                    12,
                    4,
                    9,
                    1,
                    2,
                    15,
                    5,
                    1,
                    3,
                    7,
                    14,
                    6,
                    9,
                    11,
                    8,
                    12,
                    2,
                    10,
                    0,
                    4,
                    13,
                    8,
                    6,
                    4,
                    1,
                    3,
                    11,
                    15,
                    0,
                    5,
                    12,
                    2,
                    13,
                    9,
                    7,
                    10,
                    14,
                    12,
                    15,
                    10,
                    4,
                    1,
                    5,
                    8,
                    7,
                    6,
                    2,
                    13,
                    14,
                    0,
                    3,
                    9,
                    11
                ], c = [
                    11,
                    14,
                    15,
                    12,
                    5,
                    8,
                    7,
                    9,
                    11,
                    13,
                    14,
                    15,
                    6,
                    7,
                    9,
                    8,
                    7,
                    6,
                    8,
                    13,
                    11,
                    9,
                    7,
                    15,
                    7,
                    12,
                    15,
                    9,
                    11,
                    7,
                    13,
                    12,
                    11,
                    13,
                    6,
                    7,
                    14,
                    9,
                    13,
                    15,
                    14,
                    8,
                    13,
                    6,
                    5,
                    12,
                    7,
                    5,
                    11,
                    12,
                    14,
                    15,
                    14,
                    15,
                    9,
                    8,
                    9,
                    14,
                    5,
                    6,
                    8,
                    6,
                    5,
                    12,
                    9,
                    15,
                    5,
                    11,
                    6,
                    8,
                    13,
                    12,
                    5,
                    12,
                    13,
                    14,
                    11,
                    8,
                    5,
                    6
                ], f = [
                    8,
                    9,
                    9,
                    11,
                    13,
                    15,
                    15,
                    5,
                    7,
                    7,
                    8,
                    11,
                    14,
                    14,
                    12,
                    6,
                    9,
                    13,
                    15,
                    7,
                    12,
                    8,
                    9,
                    11,
                    7,
                    7,
                    12,
                    7,
                    6,
                    15,
                    13,
                    11,
                    9,
                    7,
                    15,
                    11,
                    8,
                    6,
                    6,
                    14,
                    12,
                    13,
                    5,
                    14,
                    13,
                    13,
                    7,
                    5,
                    15,
                    5,
                    8,
                    11,
                    14,
                    14,
                    6,
                    14,
                    6,
                    9,
                    12,
                    9,
                    12,
                    5,
                    15,
                    8,
                    8,
                    5,
                    12,
                    9,
                    12,
                    5,
                    14,
                    6,
                    8,
                    13,
                    6,
                    5,
                    15,
                    13,
                    11,
                    11
                ], d = [
                    0,
                    1518500249,
                    1859775393,
                    2400959708,
                    2840853838
                ], l = [
                    1352829926,
                    1548603684,
                    1836072691,
                    2053994217,
                    0
                ];
                function h() {
                    o.call(this, 64), this._a = 1732584193, this._b = 4023233417, this._c = 2562383102, this._d = 271733878, this._e = 3285377520;
                }
                function p(e, t) {
                    return e << t | e >>> 32 - t;
                }
                function b(e, t, r, n, i, o, a, s) {
                    return p(e + (t ^ r ^ n) + o + a | 0, s) + i | 0;
                }
                function y(e, t, r, n, i, o, a, s) {
                    return p(e + (t & r | ~t & n) + o + a | 0, s) + i | 0;
                }
                function v(e, t, r, n, i, o, a, s) {
                    return p(e + ((t | ~r) ^ n) + o + a | 0, s) + i | 0;
                }
                function m(e, t, r, n, i, o, a, s) {
                    return p(e + (t & n | r & ~n) + o + a | 0, s) + i | 0;
                }
                function g(e, t, r, n, i, o, a, s) {
                    return p(e + (t ^ (r | ~n)) + o + a | 0, s) + i | 0;
                }
                i(h, o), h.prototype._update = function() {
                    for(var e = a, t = 0; t < 16; ++t)e[t] = this._block.readInt32LE(4 * t);
                    for(var r = 0 | this._a, n = 0 | this._b, i = 0 | this._c, o = 0 | this._d, h = 0 | this._e, w = 0 | this._a, k = 0 | this._b, _ = 0 | this._c, A = 0 | this._d, E = 0 | this._e, S = 0; S < 80; S += 1){
                        var x, B;
                        S < 16 ? (x = b(r, n, i, o, h, e[s[S]], d[0], c[S]), B = g(w, k, _, A, E, e[u[S]], l[0], f[S])) : S < 32 ? (x = y(r, n, i, o, h, e[s[S]], d[1], c[S]), B = m(w, k, _, A, E, e[u[S]], l[1], f[S])) : S < 48 ? (x = v(r, n, i, o, h, e[s[S]], d[2], c[S]), B = v(w, k, _, A, E, e[u[S]], l[2], f[S])) : S < 64 ? (x = m(r, n, i, o, h, e[s[S]], d[3], c[S]), B = y(w, k, _, A, E, e[u[S]], l[3], f[S])) : (x = g(r, n, i, o, h, e[s[S]], d[4], c[S]), B = b(w, k, _, A, E, e[u[S]], l[4], f[S])), r = h, h = o, o = p(i, 10), i = n, n = x, w = E, E = A, A = p(_, 10), _ = k, k = B;
                    }
                    var O = this._b + i + A | 0;
                    this._b = this._c + o + E | 0, this._c = this._d + h + w | 0, this._d = this._e + r + k | 0, this._e = this._a + n + _ | 0, this._a = O;
                }, h.prototype._digest = function() {
                    this._block[this._blockOffset++] = 128, this._blockOffset > 56 && (this._block.fill(0, this._blockOffset, 64), this._update(), this._blockOffset = 0), this._block.fill(0, this._blockOffset, 56), this._block.writeUInt32LE(this._length[0], 56), this._block.writeUInt32LE(this._length[1], 60), this._update();
                    var e = n.alloc ? n.alloc(20) : new n(20);
                    return e.writeInt32LE(this._a, 0), e.writeInt32LE(this._b, 4), e.writeInt32LE(this._c, 8), e.writeInt32LE(this._d, 12), e.writeInt32LE(this._e, 16), e;
                }, e.exports = h;
            },
            6905: (e, t, r)=>{
                "use strict";
                var n = r(29033).Buffer;
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.getLength = t.decode = t.encode = void 0;
                var i, o = (i = r(31734)) && i.__esModule ? i : {
                    default: i
                };
                function a(e, t) {
                    if ("0" === e[0] && "0" === e[1]) throw new Error("invalid RLP: extra zeros");
                    return parseInt(e, t);
                }
                function s(e, t) {
                    if (e < 56) return n.from([
                        e + t
                    ]);
                    var r = f(e), i = f(t + 55 + r.length / 2);
                    return n.from(i + r, "hex");
                }
                function u(e) {
                    var t, r, i, o, s, c = [], f = e[0];
                    if (f <= 127) return {
                        data: e.slice(0, 1),
                        remainder: e.slice(1)
                    };
                    if (f <= 183) {
                        if (t = f - 127, i = 128 === f ? n.from([]) : e.slice(1, t), 2 === t && i[0] < 128) throw new Error("invalid rlp encoding: byte must be less 0x80");
                        return {
                            data: i,
                            remainder: e.slice(t)
                        };
                    }
                    if (f <= 191) {
                        if (r = f - 182, e.length - 1 < r) throw new Error("invalid RLP: not enough bytes for string length");
                        if ((t = a(e.slice(1, r).toString("hex"), 16)) <= 55) throw new Error("invalid RLP: expected string length to be greater than 55");
                        if ((i = e.slice(r, t + r)).length < t) throw new Error("invalid RLP: not enough bytes for string");
                        return {
                            data: i,
                            remainder: e.slice(t + r)
                        };
                    }
                    if (f <= 247) {
                        for(t = f - 191, o = e.slice(1, t); o.length;)s = u(o), c.push(s.data), o = s.remainder;
                        return {
                            data: c,
                            remainder: e.slice(t)
                        };
                    }
                    var d = (r = f - 246) + (t = a(e.slice(1, r).toString("hex"), 16));
                    if (d > e.length) throw new Error("invalid rlp: total length is larger than the data");
                    if (0 === (o = e.slice(r, d)).length) throw new Error("invalid rlp, List has a invalid length");
                    for(; o.length;)s = u(o), c.push(s.data), o = s.remainder;
                    return {
                        data: c,
                        remainder: e.slice(d)
                    };
                }
                function c(e) {
                    return "0x" === e.slice(0, 2);
                }
                function f(e) {
                    if (e < 0) throw new Error("Invalid integer as argument, must be unsigned!");
                    var t = e.toString(16);
                    return t.length % 2 ? "0" + t : t;
                }
                function d(e) {
                    if (!n.isBuffer(e)) {
                        if ("string" == typeof e) return c(e) ? n.from((r = "string" != typeof (i = e) ? i : c(i) ? i.slice(2) : i).length % 2 ? "0" + r : r, "hex") : n.from(e);
                        if ("number" == typeof e || "bigint" == typeof e) return e ? (t = f(e), n.from(t, "hex")) : n.from([]);
                        if (null == e) return n.from([]);
                        if (e instanceof Uint8Array) return n.from(e);
                        if (o.default.isBN(e)) return n.from(e.toArray());
                        throw new Error("invalid type");
                    }
                    var t, r, i;
                    return e;
                }
                t.encode = function e(t) {
                    if (Array.isArray(t)) {
                        for(var r = [], i = 0; i < t.length; i++)r.push(e(t[i]));
                        var o = n.concat(r);
                        return n.concat([
                            s(o.length, 192),
                            o
                        ]);
                    }
                    var a = d(t);
                    return 1 === a.length && a[0] < 128 ? a : n.concat([
                        s(a.length, 128),
                        a
                    ]);
                }, t.decode = function(e, t) {
                    if (void 0 === t && (t = !1), !e || 0 === e.length) return n.from([]);
                    var r = u(d(e));
                    if (t) return r;
                    if (0 !== r.remainder.length) throw new Error("invalid remainder");
                    return r.data;
                }, t.getLength = function(e) {
                    if (!e || 0 === e.length) return n.from([]);
                    var t = d(e), r = t[0];
                    if (r <= 127) return t.length;
                    if (r <= 183) return r - 127;
                    if (r <= 191) return r - 182;
                    if (r <= 247) return r - 191;
                    var i = r - 246;
                    return i + a(t.slice(1, i).toString("hex"), 16);
                };
            },
            48850: (e, t, r)=>{
                "use strict";
                var n = r(29033), i = n.Buffer;
                function o(e, t) {
                    for(var r in e)t[r] = e[r];
                }
                function a(e, t, r) {
                    return i(e, t, r);
                }
                i.from && i.alloc && i.allocUnsafe && i.allocUnsafeSlow ? e.exports = n : (o(n, t), t.Buffer = a), a.prototype = Object.create(i.prototype), o(i, a), a.from = function(e, t, r) {
                    if ("number" == typeof e) throw new TypeError("Argument must not be a number");
                    return i(e, t, r);
                }, a.alloc = function(e, t, r) {
                    if ("number" != typeof e) throw new TypeError("Argument must be a number");
                    var n = i(e);
                    return void 0 !== t ? "string" == typeof r ? n.fill(t, r) : n.fill(t) : n.fill(0), n;
                }, a.allocUnsafe = function(e) {
                    if ("number" != typeof e) throw new TypeError("Argument must be a number");
                    return i(e);
                }, a.allocUnsafeSlow = function(e) {
                    if ("number" != typeof e) throw new TypeError("Argument must be a number");
                    return n.SlowBuffer(e);
                };
            },
            11755: (e, t, r)=>{
                "use strict";
                var n, i = r(19142), o = r(28847)(r(3355)), a = r(29033), s = a.Buffer, u = {};
                for(n in a)a.hasOwnProperty(n) && "SlowBuffer" !== n && "Buffer" !== n && (u[n] = a[n]);
                var c = u.Buffer = {};
                for(n in s)s.hasOwnProperty(n) && "allocUnsafe" !== n && "allocUnsafeSlow" !== n && (c[n] = s[n]);
                if (u.Buffer.prototype = s.prototype, c.from && c.from !== Uint8Array.from || (c.from = function(e, t, r) {
                    if ("number" == typeof e) throw new TypeError('The "value" argument must not be of type number. Received type ' + (0, o.default)(e));
                    if (e && void 0 === e.length) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + (0, o.default)(e));
                    return s(e, t, r);
                }), c.alloc || (c.alloc = function(e, t, r) {
                    if ("number" != typeof e) throw new TypeError('The "size" argument must be of type number. Received type ' + (0, o.default)(e));
                    if (e < 0 || e >= 2 * 1073741824) throw new RangeError('The value "' + e + '" is invalid for option "size"');
                    var n = s(e);
                    return t && 0 !== t.length ? "string" == typeof r ? n.fill(t, r) : n.fill(t) : n.fill(0), n;
                }), !u.kStringMaxLength) try {
                    u.kStringMaxLength = i.binding("buffer").kStringMaxLength;
                } catch (e) {}
                u.constants || (u.constants = {
                    MAX_LENGTH: u.kMaxLength
                }, u.kStringMaxLength && (u.constants.MAX_STRING_LENGTH = u.kStringMaxLength)), e.exports = u;
            },
            67799: (e)=>{
                "use strict";
                !function(t) {
                    var r = 2147483647;
                    function n(e) {
                        var t = new Uint32Array([
                            1116352408,
                            1899447441,
                            3049323471,
                            3921009573,
                            961987163,
                            1508970993,
                            2453635748,
                            2870763221,
                            3624381080,
                            310598401,
                            607225278,
                            1426881987,
                            1925078388,
                            2162078206,
                            2614888103,
                            3248222580,
                            3835390401,
                            4022224774,
                            264347078,
                            604807628,
                            770255983,
                            1249150122,
                            1555081692,
                            1996064986,
                            2554220882,
                            2821834349,
                            2952996808,
                            3210313671,
                            3336571891,
                            3584528711,
                            113926993,
                            338241895,
                            666307205,
                            773529912,
                            1294757372,
                            1396182291,
                            1695183700,
                            1986661051,
                            2177026350,
                            2456956037,
                            2730485921,
                            2820302411,
                            3259730800,
                            3345764771,
                            3516065817,
                            3600352804,
                            4094571909,
                            275423344,
                            430227734,
                            506948616,
                            659060556,
                            883997877,
                            958139571,
                            1322822218,
                            1537002063,
                            1747873779,
                            1955562222,
                            2024104815,
                            2227730452,
                            2361852424,
                            2428436474,
                            2756734187,
                            3204031479,
                            3329325298
                        ]), r = 1779033703, n = 3144134277, i = 1013904242, o = 2773480762, a = 1359893119, s = 2600822924, u = 528734635, c = 1541459225, f = new Uint32Array(64);
                        function d(e) {
                            for(var d = 0, l = e.length; l >= 64;){
                                var h = r, p = n, b = i, y = o, v = a, m = s, g = u, w = c, k = void 0, _ = void 0, A = void 0, E = void 0, S = void 0;
                                for(_ = 0; _ < 16; _++)A = d + 4 * _, f[_] = (255 & e[A]) << 24 | (255 & e[A + 1]) << 16 | (255 & e[A + 2]) << 8 | 255 & e[A + 3];
                                for(_ = 16; _ < 64; _++)E = ((k = f[_ - 2]) >>> 17 | k << 15) ^ (k >>> 19 | k << 13) ^ k >>> 10, S = ((k = f[_ - 15]) >>> 7 | k << 25) ^ (k >>> 18 | k << 14) ^ k >>> 3, f[_] = (E + f[_ - 7] | 0) + (S + f[_ - 16] | 0) | 0;
                                for(_ = 0; _ < 64; _++)E = (((v >>> 6 | v << 26) ^ (v >>> 11 | v << 21) ^ (v >>> 25 | v << 7)) + (v & m ^ ~v & g) | 0) + (w + (t[_] + f[_] | 0) | 0) | 0, S = ((h >>> 2 | h << 30) ^ (h >>> 13 | h << 19) ^ (h >>> 22 | h << 10)) + (h & p ^ h & b ^ p & b) | 0, w = g, g = m, m = v, v = y + E | 0, y = b, b = p, p = h, h = E + S | 0;
                                r = r + h | 0, n = n + p | 0, i = i + b | 0, o = o + y | 0, a = a + v | 0, s = s + m | 0, u = u + g | 0, c = c + w | 0, d += 64, l -= 64;
                            }
                        }
                        d(e);
                        var l, h = e.length % 64, p = e.length / 536870912 | 0, b = e.length << 3, y = h < 56 ? 56 : 120, v = e.slice(e.length - h, e.length);
                        for(v.push(128), l = h + 1; l < y; l++)v.push(0);
                        return v.push(p >>> 24 & 255), v.push(p >>> 16 & 255), v.push(p >>> 8 & 255), v.push(p >>> 0 & 255), v.push(b >>> 24 & 255), v.push(b >>> 16 & 255), v.push(b >>> 8 & 255), v.push(b >>> 0 & 255), d(v), [
                            r >>> 24 & 255,
                            r >>> 16 & 255,
                            r >>> 8 & 255,
                            r >>> 0 & 255,
                            n >>> 24 & 255,
                            n >>> 16 & 255,
                            n >>> 8 & 255,
                            n >>> 0 & 255,
                            i >>> 24 & 255,
                            i >>> 16 & 255,
                            i >>> 8 & 255,
                            i >>> 0 & 255,
                            o >>> 24 & 255,
                            o >>> 16 & 255,
                            o >>> 8 & 255,
                            o >>> 0 & 255,
                            a >>> 24 & 255,
                            a >>> 16 & 255,
                            a >>> 8 & 255,
                            a >>> 0 & 255,
                            s >>> 24 & 255,
                            s >>> 16 & 255,
                            s >>> 8 & 255,
                            s >>> 0 & 255,
                            u >>> 24 & 255,
                            u >>> 16 & 255,
                            u >>> 8 & 255,
                            u >>> 0 & 255,
                            c >>> 24 & 255,
                            c >>> 16 & 255,
                            c >>> 8 & 255,
                            c >>> 0 & 255
                        ];
                    }
                    function i(e, t, r) {
                        e = e.length <= 64 ? e : n(e);
                        var i, o = 64 + t.length + 4, a = new Array(o), s = new Array(64), u = [];
                        for(i = 0; i < 64; i++)a[i] = 54;
                        for(i = 0; i < e.length; i++)a[i] ^= e[i];
                        for(i = 0; i < t.length; i++)a[64 + i] = t[i];
                        for(i = o - 4; i < o; i++)a[i] = 0;
                        for(i = 0; i < 64; i++)s[i] = 92;
                        for(i = 0; i < e.length; i++)s[i] ^= e[i];
                        function c() {
                            for(var e = o - 1; e >= o - 4; e--){
                                if (a[e]++, a[e] <= 255) return;
                                a[e] = 0;
                            }
                        }
                        for(; r >= 32;)c(), u = u.concat(n(s.concat(n(a)))), r -= 32;
                        return r > 0 && (c(), u = u.concat(n(s.concat(n(a))).slice(0, r))), u;
                    }
                    function o(e, t, r, n, i) {
                        var o;
                        for(c(e, 16 * (2 * r - 1), i, 0, 16), o = 0; o < 2 * r; o++)u(e, 16 * o, i, 16), s(i, n), c(i, 0, e, t + 16 * o, 16);
                        for(o = 0; o < r; o++)c(e, t + 2 * o * 16, e, 16 * o, 16);
                        for(o = 0; o < r; o++)c(e, t + 16 * (2 * o + 1), e, 16 * (o + r), 16);
                    }
                    function a(e, t) {
                        return e << t | e >>> 32 - t;
                    }
                    function s(e, t) {
                        c(e, 0, t, 0, 16);
                        for(var r = 8; r > 0; r -= 2)t[4] ^= a(t[0] + t[12], 7), t[8] ^= a(t[4] + t[0], 9), t[12] ^= a(t[8] + t[4], 13), t[0] ^= a(t[12] + t[8], 18), t[9] ^= a(t[5] + t[1], 7), t[13] ^= a(t[9] + t[5], 9), t[1] ^= a(t[13] + t[9], 13), t[5] ^= a(t[1] + t[13], 18), t[14] ^= a(t[10] + t[6], 7), t[2] ^= a(t[14] + t[10], 9), t[6] ^= a(t[2] + t[14], 13), t[10] ^= a(t[6] + t[2], 18), t[3] ^= a(t[15] + t[11], 7), t[7] ^= a(t[3] + t[15], 9), t[11] ^= a(t[7] + t[3], 13), t[15] ^= a(t[11] + t[7], 18), t[1] ^= a(t[0] + t[3], 7), t[2] ^= a(t[1] + t[0], 9), t[3] ^= a(t[2] + t[1], 13), t[0] ^= a(t[3] + t[2], 18), t[6] ^= a(t[5] + t[4], 7), t[7] ^= a(t[6] + t[5], 9), t[4] ^= a(t[7] + t[6], 13), t[5] ^= a(t[4] + t[7], 18), t[11] ^= a(t[10] + t[9], 7), t[8] ^= a(t[11] + t[10], 9), t[9] ^= a(t[8] + t[11], 13), t[10] ^= a(t[9] + t[8], 18), t[12] ^= a(t[15] + t[14], 7), t[13] ^= a(t[12] + t[15], 9), t[14] ^= a(t[13] + t[12], 13), t[15] ^= a(t[14] + t[13], 18);
                        for(var n = 0; n < 16; ++n)e[n] += t[n];
                    }
                    function u(e, t, r, n) {
                        for(var i = 0; i < n; i++)r[i] ^= e[t + i];
                    }
                    function c(e, t, r, n, i) {
                        for(; i--;)r[n++] = e[t++];
                    }
                    function f(e) {
                        if (!e || "number" != typeof e.length) return !1;
                        for(var t = 0; t < e.length; t++){
                            var r = e[t];
                            if ("number" != typeof r || r % 1 || r < 0 || r >= 256) return !1;
                        }
                        return !0;
                    }
                    function d(e, t) {
                        if ("number" != typeof e || e % 1) throw new Error("invalid " + t);
                        return e;
                    }
                    function l(e, t, n, a, s, l, h) {
                        if (n = d(n, "N"), a = d(a, "r"), s = d(s, "p"), l = d(l, "dkLen"), 0 === n || 0 != (n & n - 1)) throw new Error("N must be power of 2");
                        if (n > r / 128 / a) throw new Error("N too large");
                        if (a > r / 128 / s) throw new Error("r too large");
                        if (!f(e)) throw new Error("password must be an array or buffer");
                        if (e = Array.prototype.slice.call(e), !f(t)) throw new Error("salt must be an array or buffer");
                        t = Array.prototype.slice.call(t);
                        for(var p = i(e, t, 128 * s * a), b = new Uint32Array(32 * s * a), y = 0; y < b.length; y++){
                            var v = 4 * y;
                            b[y] = (255 & p[v + 3]) << 24 | (255 & p[v + 2]) << 16 | (255 & p[v + 1]) << 8 | (255 & p[v + 0]) << 0;
                        }
                        var m, g, w = new Uint32Array(64 * a), k = new Uint32Array(32 * a * n), _ = 32 * a, A = new Uint32Array(16), E = new Uint32Array(16), S = s * n * 2, x = 0, B = null, O = !1, P = 0, I = 0, T = h ? parseInt(1e3 / a) : 4294967295, C = "undefined" != typeof setImmediate ? setImmediate : setTimeout, M = function t() {
                            if (O) return h(new Error("cancelled"), x / S);
                            var r;
                            switch(P){
                                case 0:
                                    c(b, g = 32 * I * a, w, 0, _), P = 1, m = 0;
                                case 1:
                                    (r = n - m) > T && (r = T);
                                    for(var f = 0; f < r; f++)c(w, 0, k, (m + f) * _, _), o(w, _, a, A, E);
                                    if (m += r, x += r, h) {
                                        var d = parseInt(1e3 * x / S);
                                        if (d !== B) {
                                            if (O = h(null, x / S)) break;
                                            B = d;
                                        }
                                    }
                                    if (m < n) break;
                                    m = 0, P = 2;
                                case 2:
                                    (r = n - m) > T && (r = T);
                                    for(var y = 0; y < r; y++){
                                        var v = w[16 * (2 * a - 1)] & n - 1;
                                        u(k, v * _, w, _), o(w, _, a, A, E);
                                    }
                                    if (m += r, x += r, h) {
                                        var M = parseInt(1e3 * x / S);
                                        if (M !== B) {
                                            if (O = h(null, x / S)) break;
                                            B = M;
                                        }
                                    }
                                    if (m < n) break;
                                    if (c(w, 0, b, g, _), ++I < s) {
                                        P = 0;
                                        break;
                                    }
                                    p = [];
                                    for(var R = 0; R < b.length; R++)p.push(b[R] >> 0 & 255), p.push(b[R] >> 8 & 255), p.push(b[R] >> 16 & 255), p.push(b[R] >> 24 & 255);
                                    var U = i(e, p, l);
                                    return h && h(null, 1, U), U;
                            }
                            h && C(t);
                        };
                        if (!h) for(;;){
                            var R = M();
                            if (null != R) return R;
                        }
                        M();
                    }
                    var h = {
                        scrypt: function(e, t, r, n, i, o, a) {
                            return new Promise(function(s, u) {
                                var c = 0;
                                a && a(0), l(e, t, r, n, i, o, function(e, t, r) {
                                    if (e) u(e);
                                    else if (r) a && 1 !== c && a(1), s(new Uint8Array(r));
                                    else if (a && t !== c) return c = t, a(t);
                                });
                            });
                        },
                        syncScrypt: function(e, t, r, n, i, o) {
                            return new Uint8Array(l(e, t, r, n, i, o));
                        }
                    };
                    e.exports = h;
                }();
            },
            57902: (e, t, r)=>{
                "use strict";
                e.exports = r(36922)(r(38123));
            },
            38123: (e, t, r)=>{
                "use strict";
                var n = new (r(36597)).ec("secp256k1"), i = n.curve, o = i.n.constructor;
                function a(e) {
                    var t = e[0];
                    switch(t){
                        case 2:
                        case 3:
                            return 33 !== e.length ? null : function(e, t) {
                                var r = new o(t);
                                if (r.cmp(i.p) >= 0) return null;
                                var a = (r = r.toRed(i.red)).redSqr().redIMul(r).redIAdd(i.b).redSqrt();
                                return 3 === e !== a.isOdd() && (a = a.redNeg()), n.keyPair({
                                    pub: {
                                        x: r,
                                        y: a
                                    }
                                });
                            }(t, e.subarray(1, 33));
                        case 4:
                        case 6:
                        case 7:
                            return 65 !== e.length ? null : function(e, t, r) {
                                var a = new o(t), s = new o(r);
                                if (a.cmp(i.p) >= 0 || s.cmp(i.p) >= 0) return null;
                                if (a = a.toRed(i.red), s = s.toRed(i.red), (6 === e || 7 === e) && s.isOdd() !== (7 === e)) return null;
                                var u = a.redSqr().redIMul(a);
                                return s.redSqr().redISub(u.redIAdd(i.b)).isZero() ? n.keyPair({
                                    pub: {
                                        x: a,
                                        y: s
                                    }
                                }) : null;
                            }(t, e.subarray(1, 33), e.subarray(33, 65));
                        default:
                            return null;
                    }
                }
                function s(e, t) {
                    for(var r = t.encode(null, 33 === e.length), n = 0; n < e.length; ++n)e[n] = r[n];
                }
                e.exports = {
                    contextRandomize: function() {
                        return 0;
                    },
                    privateKeyVerify: function(e) {
                        var t = new o(e);
                        return t.cmp(i.n) < 0 && !t.isZero() ? 0 : 1;
                    },
                    privateKeyNegate: function(e) {
                        var t = new o(e), r = i.n.sub(t).umod(i.n).toArrayLike(Uint8Array, "be", 32);
                        return e.set(r), 0;
                    },
                    privateKeyTweakAdd: function(e, t) {
                        var r = new o(t);
                        if (r.cmp(i.n) >= 0) return 1;
                        if (r.iadd(new o(e)), r.cmp(i.n) >= 0 && r.isub(i.n), r.isZero()) return 1;
                        var n = r.toArrayLike(Uint8Array, "be", 32);
                        return e.set(n), 0;
                    },
                    privateKeyTweakMul: function(e, t) {
                        var r = new o(t);
                        if (r.cmp(i.n) >= 0 || r.isZero()) return 1;
                        r.imul(new o(e)), r.cmp(i.n) >= 0 && (r = r.umod(i.n));
                        var n = r.toArrayLike(Uint8Array, "be", 32);
                        return e.set(n), 0;
                    },
                    publicKeyVerify: function(e) {
                        return null === a(e) ? 1 : 0;
                    },
                    publicKeyCreate: function(e, t) {
                        var r = new o(t);
                        return r.cmp(i.n) >= 0 || r.isZero() ? 1 : (s(e, n.keyFromPrivate(t).getPublic()), 0);
                    },
                    publicKeyConvert: function(e, t) {
                        var r = a(t);
                        return null === r ? 1 : (s(e, r.getPublic()), 0);
                    },
                    publicKeyNegate: function(e, t) {
                        var r = a(t);
                        if (null === r) return 1;
                        var n = r.getPublic();
                        return n.y = n.y.redNeg(), s(e, n), 0;
                    },
                    publicKeyCombine: function(e, t) {
                        for(var r = new Array(t.length), n = 0; n < t.length; ++n)if (r[n] = a(t[n]), null === r[n]) return 1;
                        for(var i = r[0].getPublic(), o = 1; o < r.length; ++o)i = i.add(r[o].pub);
                        return i.isInfinity() ? 2 : (s(e, i), 0);
                    },
                    publicKeyTweakAdd: function(e, t, r) {
                        var n = a(t);
                        if (null === n) return 1;
                        if ((r = new o(r)).cmp(i.n) >= 0) return 2;
                        var u = n.getPublic().add(i.g.mul(r));
                        return u.isInfinity() ? 2 : (s(e, u), 0);
                    },
                    publicKeyTweakMul: function(e, t, r) {
                        var n = a(t);
                        return null === n ? 1 : (r = new o(r)).cmp(i.n) >= 0 || r.isZero() ? 2 : (s(e, n.getPublic().mul(r)), 0);
                    },
                    signatureNormalize: function(e) {
                        var t = new o(e.subarray(0, 32)), r = new o(e.subarray(32, 64));
                        return t.cmp(i.n) >= 0 || r.cmp(i.n) >= 0 ? 1 : (1 === r.cmp(n.nh) && e.set(i.n.sub(r).toArrayLike(Uint8Array, "be", 32), 32), 0);
                    },
                    signatureExport: function(e, t) {
                        var r = t.subarray(0, 32), n = t.subarray(32, 64);
                        if (new o(r).cmp(i.n) >= 0) return 1;
                        if (new o(n).cmp(i.n) >= 0) return 1;
                        var a = e.output, s = a.subarray(4, 37);
                        s[0] = 0, s.set(r, 1);
                        for(var u = 33, c = 0; u > 1 && 0 === s[c] && !(128 & s[c + 1]); --u, ++c);
                        if (128 & (s = s.subarray(c))[0]) return 1;
                        if (u > 1 && 0 === s[0] && !(128 & s[1])) return 1;
                        var f = a.subarray(39, 72);
                        f[0] = 0, f.set(n, 1);
                        for(var d = 33, l = 0; d > 1 && 0 === f[l] && !(128 & f[l + 1]); --d, ++l);
                        return 128 & (f = f.subarray(l))[0] || d > 1 && 0 === f[0] && !(128 & f[1]) ? 1 : (e.outputlen = 6 + u + d, a[0] = 48, a[1] = e.outputlen - 2, a[2] = 2, a[3] = s.length, a.set(s, 4), a[4 + u] = 2, a[5 + u] = f.length, a.set(f, 6 + u), 0);
                    },
                    signatureImport: function(e, t) {
                        if (t.length < 8) return 1;
                        if (t.length > 72) return 1;
                        if (48 !== t[0]) return 1;
                        if (t[1] !== t.length - 2) return 1;
                        if (2 !== t[2]) return 1;
                        var r = t[3];
                        if (0 === r) return 1;
                        if (5 + r >= t.length) return 1;
                        if (2 !== t[4 + r]) return 1;
                        var n = t[5 + r];
                        if (0 === n) return 1;
                        if (6 + r + n !== t.length) return 1;
                        if (128 & t[4]) return 1;
                        if (r > 1 && 0 === t[4] && !(128 & t[5])) return 1;
                        if (128 & t[r + 6]) return 1;
                        if (n > 1 && 0 === t[r + 6] && !(128 & t[r + 7])) return 1;
                        var a = t.subarray(4, 4 + r);
                        if (33 === a.length && 0 === a[0] && (a = a.subarray(1)), a.length > 32) return 1;
                        var s = t.subarray(6 + r);
                        if (33 === s.length && 0 === s[0] && (s = s.slice(1)), s.length > 32) throw new Error("S length is too long");
                        var u = new o(a);
                        u.cmp(i.n) >= 0 && (u = new o(0));
                        var c = new o(t.subarray(6 + r));
                        return c.cmp(i.n) >= 0 && (c = new o(0)), e.set(u.toArrayLike(Uint8Array, "be", 32), 0), e.set(c.toArrayLike(Uint8Array, "be", 32), 32), 0;
                    },
                    ecdsaSign: function(e, t, r, a, s) {
                        if (s) {
                            var u = s;
                            s = function(e) {
                                var n = u(t, r, null, a, e);
                                if (!(n instanceof Uint8Array && 32 === n.length)) throw new Error("This is the way");
                                return new o(n);
                            };
                        }
                        var c, f = new o(r);
                        if (f.cmp(i.n) >= 0 || f.isZero()) return 1;
                        try {
                            c = n.sign(t, r, {
                                canonical: !0,
                                k: s,
                                pers: a
                            });
                        } catch (e) {
                            return 1;
                        }
                        return e.signature.set(c.r.toArrayLike(Uint8Array, "be", 32), 0), e.signature.set(c.s.toArrayLike(Uint8Array, "be", 32), 32), e.recid = c.recoveryParam, 0;
                    },
                    ecdsaVerify: function(e, t, r) {
                        var s = {
                            r: e.subarray(0, 32),
                            s: e.subarray(32, 64)
                        }, u = new o(s.r), c = new o(s.s);
                        if (u.cmp(i.n) >= 0 || c.cmp(i.n) >= 0) return 1;
                        if (1 === c.cmp(n.nh) || u.isZero() || c.isZero()) return 3;
                        var f = a(r);
                        if (null === f) return 2;
                        var d = f.getPublic();
                        return n.verify(t, s, d) ? 0 : 3;
                    },
                    ecdsaRecover: function(e, t, r, a) {
                        var u, c = {
                            r: t.slice(0, 32),
                            s: t.slice(32, 64)
                        }, f = new o(c.r), d = new o(c.s);
                        if (f.cmp(i.n) >= 0 || d.cmp(i.n) >= 0) return 1;
                        if (f.isZero() || d.isZero()) return 2;
                        try {
                            u = n.recoverPubKey(a, c, r);
                        } catch (e) {
                            return 2;
                        }
                        return s(e, u), 0;
                    },
                    ecdh: function(e, t, r, s, u, c, f) {
                        var d = a(t);
                        if (null === d) return 1;
                        var l = new o(r);
                        if (l.cmp(i.n) >= 0 || l.isZero()) return 2;
                        var h = d.getPublic().mul(l);
                        if (void 0 === u) for(var p = h.encode(null, !0), b = n.hash().update(p).digest(), y = 0; y < 32; ++y)e[y] = b[y];
                        else {
                            c || (c = new Uint8Array(32));
                            for(var v = h.getX().toArray("be", 32), m = 0; m < 32; ++m)c[m] = v[m];
                            f || (f = new Uint8Array(32));
                            for(var g = h.getY().toArray("be", 32), w = 0; w < 32; ++w)f[w] = g[w];
                            var k = u(c, f, s);
                            if (!(k instanceof Uint8Array && k.length === e.length)) return 2;
                            e.set(k);
                        }
                        return 0;
                    }
                };
            },
            36922: (e)=>{
                "use strict";
                function t(e, t) {
                    (null == t || t > e.length) && (t = e.length);
                    for(var r = 0, n = new Array(t); r < t; r++)n[r] = e[r];
                    return n;
                }
                var r = "Impossible case. Please create issue.", n = "The tweak was out of range or the resulted private key is invalid", i = "The tweak was out of range or equal to zero", o = "Public Key could not be parsed", a = "Public Key serialization error", s = "Signature could not be parsed";
                function u(e, t) {
                    if (!e) throw new Error(t);
                }
                function c(e, t, r) {
                    if (u(t instanceof Uint8Array, "Expected ".concat(e, " to be an Uint8Array")), void 0 !== r) {
                        if (Array.isArray(r)) {
                            var n = r.join(", "), i = "Expected ".concat(e, " to be an Uint8Array with length [").concat(n, "]");
                            u(r.includes(t.length), i);
                        } else {
                            var o = "Expected ".concat(e, " to be an Uint8Array with length ").concat(r);
                            u(t.length === r, o);
                        }
                    }
                }
                function f(e) {
                    u("Boolean" === l(e), "Expected compressed to be a Boolean");
                }
                function d() {
                    var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : function(e) {
                        return new Uint8Array(e);
                    }, t = arguments.length > 1 ? arguments[1] : void 0;
                    return "function" == typeof e && (e = e(t)), c("output", e, t), e;
                }
                function l(e) {
                    return Object.prototype.toString.call(e).slice(8, -1);
                }
                e.exports = function(e) {
                    return {
                        contextRandomize: function(t) {
                            if (u(null === t || t instanceof Uint8Array, "Expected seed to be an Uint8Array or null"), null !== t && c("seed", t, 32), 1 === e.contextRandomize(t)) throw new Error("Unknow error on context randomization");
                        },
                        privateKeyVerify: function(t) {
                            return c("private key", t, 32), 0 === e.privateKeyVerify(t);
                        },
                        privateKeyNegate: function(t) {
                            switch(c("private key", t, 32), e.privateKeyNegate(t)){
                                case 0:
                                    return t;
                                case 1:
                                    throw new Error(r);
                            }
                        },
                        privateKeyTweakAdd: function(t, r) {
                            switch(c("private key", t, 32), c("tweak", r, 32), e.privateKeyTweakAdd(t, r)){
                                case 0:
                                    return t;
                                case 1:
                                    throw new Error(n);
                            }
                        },
                        privateKeyTweakMul: function(t, r) {
                            switch(c("private key", t, 32), c("tweak", r, 32), e.privateKeyTweakMul(t, r)){
                                case 0:
                                    return t;
                                case 1:
                                    throw new Error(i);
                            }
                        },
                        publicKeyVerify: function(t) {
                            return c("public key", t, [
                                33,
                                65
                            ]), 0 === e.publicKeyVerify(t);
                        },
                        publicKeyCreate: function(t) {
                            var r = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1], n = arguments.length > 2 ? arguments[2] : void 0;
                            switch(c("private key", t, 32), f(r), n = d(n, r ? 33 : 65), e.publicKeyCreate(n, t)){
                                case 0:
                                    return n;
                                case 1:
                                    throw new Error("Private Key is invalid");
                                case 2:
                                    throw new Error(a);
                            }
                        },
                        publicKeyConvert: function(t) {
                            var r = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1], n = arguments.length > 2 ? arguments[2] : void 0;
                            switch(c("public key", t, [
                                33,
                                65
                            ]), f(r), n = d(n, r ? 33 : 65), e.publicKeyConvert(n, t)){
                                case 0:
                                    return n;
                                case 1:
                                    throw new Error(o);
                                case 2:
                                    throw new Error(a);
                            }
                        },
                        publicKeyNegate: function(t) {
                            var n = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1], i = arguments.length > 2 ? arguments[2] : void 0;
                            switch(c("public key", t, [
                                33,
                                65
                            ]), f(n), i = d(i, n ? 33 : 65), e.publicKeyNegate(i, t)){
                                case 0:
                                    return i;
                                case 1:
                                    throw new Error(o);
                                case 2:
                                    throw new Error(r);
                                case 3:
                                    throw new Error(a);
                            }
                        },
                        publicKeyCombine: function(r) {
                            var n = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1], i = arguments.length > 2 ? arguments[2] : void 0;
                            u(Array.isArray(r), "Expected public keys to be an Array"), u(r.length > 0, "Expected public keys array will have more than zero items");
                            var s, l = function(e, r) {
                                var n = "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
                                if (!n) {
                                    if (Array.isArray(e) || (n = function(e, r) {
                                        if (e) {
                                            if ("string" == typeof e) return t(e, r);
                                            var n = Object.prototype.toString.call(e).slice(8, -1);
                                            return "Object" === n && e.constructor && (n = e.constructor.name), "Map" === n || "Set" === n ? Array.from(e) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? t(e, r) : void 0;
                                        }
                                    }(e)) || r && e && "number" == typeof e.length) {
                                        n && (e = n);
                                        var i = 0, o = function() {};
                                        return {
                                            s: o,
                                            n: function() {
                                                return i >= e.length ? {
                                                    done: !0
                                                } : {
                                                    done: !1,
                                                    value: e[i++]
                                                };
                                            },
                                            e: function(e) {
                                                throw e;
                                            },
                                            f: o
                                        };
                                    }
                                    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                                }
                                var a, s = !0, u = !1;
                                return {
                                    s: function() {
                                        n = n.call(e);
                                    },
                                    n: function() {
                                        var e = n.next();
                                        return s = e.done, e;
                                    },
                                    e: function(e) {
                                        u = !0, a = e;
                                    },
                                    f: function() {
                                        try {
                                            s || null == n.return || n.return();
                                        } finally{
                                            if (u) throw a;
                                        }
                                    }
                                };
                            }(r);
                            try {
                                for(l.s(); !(s = l.n()).done;)c("public key", s.value, [
                                    33,
                                    65
                                ]);
                            } catch (e) {
                                l.e(e);
                            } finally{
                                l.f();
                            }
                            switch(f(n), i = d(i, n ? 33 : 65), e.publicKeyCombine(i, r)){
                                case 0:
                                    return i;
                                case 1:
                                    throw new Error(o);
                                case 2:
                                    throw new Error("The sum of the public keys is not valid");
                                case 3:
                                    throw new Error(a);
                            }
                        },
                        publicKeyTweakAdd: function(t, r) {
                            var i = !(arguments.length > 2 && void 0 !== arguments[2]) || arguments[2], a = arguments.length > 3 ? arguments[3] : void 0;
                            switch(c("public key", t, [
                                33,
                                65
                            ]), c("tweak", r, 32), f(i), a = d(a, i ? 33 : 65), e.publicKeyTweakAdd(a, t, r)){
                                case 0:
                                    return a;
                                case 1:
                                    throw new Error(o);
                                case 2:
                                    throw new Error(n);
                            }
                        },
                        publicKeyTweakMul: function(t, r) {
                            var n = !(arguments.length > 2 && void 0 !== arguments[2]) || arguments[2], a = arguments.length > 3 ? arguments[3] : void 0;
                            switch(c("public key", t, [
                                33,
                                65
                            ]), c("tweak", r, 32), f(n), a = d(a, n ? 33 : 65), e.publicKeyTweakMul(a, t, r)){
                                case 0:
                                    return a;
                                case 1:
                                    throw new Error(o);
                                case 2:
                                    throw new Error(i);
                            }
                        },
                        signatureNormalize: function(t) {
                            switch(c("signature", t, 64), e.signatureNormalize(t)){
                                case 0:
                                    return t;
                                case 1:
                                    throw new Error(s);
                            }
                        },
                        signatureExport: function(t, n) {
                            c("signature", t, 64);
                            var i = {
                                output: n = d(n, 72),
                                outputlen: 72
                            };
                            switch(e.signatureExport(i, t)){
                                case 0:
                                    return n.slice(0, i.outputlen);
                                case 1:
                                    throw new Error(s);
                                case 2:
                                    throw new Error(r);
                            }
                        },
                        signatureImport: function(t, n) {
                            switch(c("signature", t), n = d(n, 64), e.signatureImport(n, t)){
                                case 0:
                                    return n;
                                case 1:
                                    throw new Error(s);
                                case 2:
                                    throw new Error(r);
                            }
                        },
                        ecdsaSign: function(t, n) {
                            var i = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {}, o = arguments.length > 3 ? arguments[3] : void 0;
                            c("message", t, 32), c("private key", n, 32), u("Object" === l(i), "Expected options to be an Object"), void 0 !== i.data && c("options.data", i.data), void 0 !== i.noncefn && u("Function" === l(i.noncefn), "Expected options.noncefn to be a Function");
                            var a = {
                                signature: o = d(o, 64),
                                recid: null
                            };
                            switch(e.ecdsaSign(a, t, n, i.data, i.noncefn)){
                                case 0:
                                    return a;
                                case 1:
                                    throw new Error("The nonce generation function failed, or the private key was invalid");
                                case 2:
                                    throw new Error(r);
                            }
                        },
                        ecdsaVerify: function(t, r, n) {
                            switch(c("signature", t, 64), c("message", r, 32), c("public key", n, [
                                33,
                                65
                            ]), e.ecdsaVerify(t, r, n)){
                                case 0:
                                    return !0;
                                case 3:
                                    return !1;
                                case 1:
                                    throw new Error(s);
                                case 2:
                                    throw new Error(o);
                            }
                        },
                        ecdsaRecover: function(t, n, i) {
                            var o = !(arguments.length > 3 && void 0 !== arguments[3]) || arguments[3], a = arguments.length > 4 ? arguments[4] : void 0;
                            switch(c("signature", t, 64), u("Number" === l(n) && n >= 0 && n <= 3, "Expected recovery id to be a Number within interval [0, 3]"), c("message", i, 32), f(o), a = d(a, o ? 33 : 65), e.ecdsaRecover(a, t, n, i)){
                                case 0:
                                    return a;
                                case 1:
                                    throw new Error(s);
                                case 2:
                                    throw new Error("Public key could not be recover");
                                case 3:
                                    throw new Error(r);
                            }
                        },
                        ecdh: function(t, r) {
                            var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {}, i = arguments.length > 3 ? arguments[3] : void 0;
                            switch(c("public key", t, [
                                33,
                                65
                            ]), c("private key", r, 32), u("Object" === l(n), "Expected options to be an Object"), void 0 !== n.data && c("options.data", n.data), void 0 !== n.hashfn ? (u("Function" === l(n.hashfn), "Expected options.hashfn to be a Function"), void 0 !== n.xbuf && c("options.xbuf", n.xbuf, 32), void 0 !== n.ybuf && c("options.ybuf", n.ybuf, 32), c("output", i)) : i = d(i, 32), e.ecdh(i, t, r, n.data, n.hashfn, n.xbuf, n.ybuf)){
                                case 0:
                                    return i;
                                case 1:
                                    throw new Error(o);
                                case 2:
                                    throw new Error("Scalar was invalid (zero or overflow)");
                            }
                        }
                    };
                };
            },
            77990: (e, t, r)=>{
                "use strict";
                var n = r(57701), i = r(94919), o = r(1020)(), a = r(53820), s = n("%TypeError%"), u = n("%Math.floor%");
                e.exports = function(e, t) {
                    if ("function" != typeof e) throw new s("`fn` is not a function");
                    if ("number" != typeof t || t < 0 || t > 4294967295 || u(t) !== t) throw new s("`length` must be a positive 32-bit integer");
                    var r = arguments.length > 2 && !!arguments[2], n = !0, c = !0;
                    if ("length" in e && a) {
                        var f = a(e, "length");
                        f && !f.configurable && (n = !1), f && !f.writable && (c = !1);
                    }
                    return (n || c || !r) && (o ? i(e, "length", t, !0, !0) : i(e, "length", t)), e;
                };
            },
            76003: (e, t, r)=>{
                "use strict";
                var n = r(48850).Buffer;
                function i(e, t) {
                    this._block = n.alloc(e), this._finalSize = t, this._blockSize = e, this._len = 0;
                }
                i.prototype.update = function(e, t) {
                    "string" == typeof e && (t = t || "utf8", e = n.from(e, t));
                    for(var r = this._block, i = this._blockSize, o = e.length, a = this._len, s = 0; s < o;){
                        for(var u = a % i, c = Math.min(o - s, i - u), f = 0; f < c; f++)r[u + f] = e[s + f];
                        s += c, (a += c) % i == 0 && this._update(r);
                    }
                    return this._len += o, this;
                }, i.prototype.digest = function(e) {
                    var t = this._len % this._blockSize;
                    this._block[t] = 128, this._block.fill(0, t + 1), t >= this._finalSize && (this._update(this._block), this._block.fill(0));
                    var r = 8 * this._len;
                    if (r <= 4294967295) this._block.writeUInt32BE(r, this._blockSize - 4);
                    else {
                        var n = (4294967295 & r) >>> 0, i = (r - n) / 4294967296;
                        this._block.writeUInt32BE(i, this._blockSize - 8), this._block.writeUInt32BE(n, this._blockSize - 4);
                    }
                    this._update(this._block);
                    var o = this._hash();
                    return e ? o.toString(e) : o;
                }, i.prototype._update = function() {
                    throw new Error("_update must be implemented by subclass");
                }, e.exports = i;
            },
            51708: (e, t, r)=>{
                "use strict";
                var n = e.exports = function(e) {
                    e = e.toLowerCase();
                    var t = n[e];
                    if (!t) throw new Error(e + " is not supported (we accept pull requests)");
                    return new t;
                };
                n.sha = r(8210), n.sha1 = r(10544), n.sha224 = r(66288), n.sha256 = r(34571), n.sha384 = r(46959), n.sha512 = r(14515);
            },
            8210: (e, t, r)=>{
                "use strict";
                var n = r(41736), i = r(76003), o = r(48850).Buffer, a = [
                    1518500249,
                    1859775393,
                    -1894007588,
                    -899497514
                ], s = new Array(80);
                function u() {
                    this.init(), this._w = s, i.call(this, 64, 56);
                }
                function c(e) {
                    return e << 30 | e >>> 2;
                }
                function f(e, t, r, n) {
                    return 0 === e ? t & r | ~t & n : 2 === e ? t & r | t & n | r & n : t ^ r ^ n;
                }
                n(u, i), u.prototype.init = function() {
                    return this._a = 1732584193, this._b = 4023233417, this._c = 2562383102, this._d = 271733878, this._e = 3285377520, this;
                }, u.prototype._update = function(e) {
                    for(var t, r = this._w, n = 0 | this._a, i = 0 | this._b, o = 0 | this._c, s = 0 | this._d, u = 0 | this._e, d = 0; d < 16; ++d)r[d] = e.readInt32BE(4 * d);
                    for(; d < 80; ++d)r[d] = r[d - 3] ^ r[d - 8] ^ r[d - 14] ^ r[d - 16];
                    for(var l = 0; l < 80; ++l){
                        var h = ~~(l / 20), p = 0 | ((t = n) << 5 | t >>> 27) + f(h, i, o, s) + u + r[l] + a[h];
                        u = s, s = o, o = c(i), i = n, n = p;
                    }
                    this._a = n + this._a | 0, this._b = i + this._b | 0, this._c = o + this._c | 0, this._d = s + this._d | 0, this._e = u + this._e | 0;
                }, u.prototype._hash = function() {
                    var e = o.allocUnsafe(20);
                    return e.writeInt32BE(0 | this._a, 0), e.writeInt32BE(0 | this._b, 4), e.writeInt32BE(0 | this._c, 8), e.writeInt32BE(0 | this._d, 12), e.writeInt32BE(0 | this._e, 16), e;
                }, e.exports = u;
            },
            10544: (e, t, r)=>{
                "use strict";
                var n = r(41736), i = r(76003), o = r(48850).Buffer, a = [
                    1518500249,
                    1859775393,
                    -1894007588,
                    -899497514
                ], s = new Array(80);
                function u() {
                    this.init(), this._w = s, i.call(this, 64, 56);
                }
                function c(e) {
                    return e << 5 | e >>> 27;
                }
                function f(e) {
                    return e << 30 | e >>> 2;
                }
                function d(e, t, r, n) {
                    return 0 === e ? t & r | ~t & n : 2 === e ? t & r | t & n | r & n : t ^ r ^ n;
                }
                n(u, i), u.prototype.init = function() {
                    return this._a = 1732584193, this._b = 4023233417, this._c = 2562383102, this._d = 271733878, this._e = 3285377520, this;
                }, u.prototype._update = function(e) {
                    for(var t, r = this._w, n = 0 | this._a, i = 0 | this._b, o = 0 | this._c, s = 0 | this._d, u = 0 | this._e, l = 0; l < 16; ++l)r[l] = e.readInt32BE(4 * l);
                    for(; l < 80; ++l)r[l] = (t = r[l - 3] ^ r[l - 8] ^ r[l - 14] ^ r[l - 16]) << 1 | t >>> 31;
                    for(var h = 0; h < 80; ++h){
                        var p = ~~(h / 20), b = c(n) + d(p, i, o, s) + u + r[h] + a[p] | 0;
                        u = s, s = o, o = f(i), i = n, n = b;
                    }
                    this._a = n + this._a | 0, this._b = i + this._b | 0, this._c = o + this._c | 0, this._d = s + this._d | 0, this._e = u + this._e | 0;
                }, u.prototype._hash = function() {
                    var e = o.allocUnsafe(20);
                    return e.writeInt32BE(0 | this._a, 0), e.writeInt32BE(0 | this._b, 4), e.writeInt32BE(0 | this._c, 8), e.writeInt32BE(0 | this._d, 12), e.writeInt32BE(0 | this._e, 16), e;
                }, e.exports = u;
            },
            66288: (e, t, r)=>{
                "use strict";
                var n = r(41736), i = r(34571), o = r(76003), a = r(48850).Buffer, s = new Array(64);
                function u() {
                    this.init(), this._w = s, o.call(this, 64, 56);
                }
                n(u, i), u.prototype.init = function() {
                    return this._a = 3238371032, this._b = 914150663, this._c = 812702999, this._d = 4144912697, this._e = 4290775857, this._f = 1750603025, this._g = 1694076839, this._h = 3204075428, this;
                }, u.prototype._hash = function() {
                    var e = a.allocUnsafe(28);
                    return e.writeInt32BE(this._a, 0), e.writeInt32BE(this._b, 4), e.writeInt32BE(this._c, 8), e.writeInt32BE(this._d, 12), e.writeInt32BE(this._e, 16), e.writeInt32BE(this._f, 20), e.writeInt32BE(this._g, 24), e;
                }, e.exports = u;
            },
            34571: (e, t, r)=>{
                "use strict";
                var n = r(41736), i = r(76003), o = r(48850).Buffer, a = [
                    1116352408,
                    1899447441,
                    3049323471,
                    3921009573,
                    961987163,
                    1508970993,
                    2453635748,
                    2870763221,
                    3624381080,
                    310598401,
                    607225278,
                    1426881987,
                    1925078388,
                    2162078206,
                    2614888103,
                    3248222580,
                    3835390401,
                    4022224774,
                    264347078,
                    604807628,
                    770255983,
                    1249150122,
                    1555081692,
                    1996064986,
                    2554220882,
                    2821834349,
                    2952996808,
                    3210313671,
                    3336571891,
                    3584528711,
                    113926993,
                    338241895,
                    666307205,
                    773529912,
                    1294757372,
                    1396182291,
                    1695183700,
                    1986661051,
                    2177026350,
                    2456956037,
                    2730485921,
                    2820302411,
                    3259730800,
                    3345764771,
                    3516065817,
                    3600352804,
                    4094571909,
                    275423344,
                    430227734,
                    506948616,
                    659060556,
                    883997877,
                    958139571,
                    1322822218,
                    1537002063,
                    1747873779,
                    1955562222,
                    2024104815,
                    2227730452,
                    2361852424,
                    2428436474,
                    2756734187,
                    3204031479,
                    3329325298
                ], s = new Array(64);
                function u() {
                    this.init(), this._w = s, i.call(this, 64, 56);
                }
                function c(e, t, r) {
                    return r ^ e & (t ^ r);
                }
                function f(e, t, r) {
                    return e & t | r & (e | t);
                }
                function d(e) {
                    return (e >>> 2 | e << 30) ^ (e >>> 13 | e << 19) ^ (e >>> 22 | e << 10);
                }
                function l(e) {
                    return (e >>> 6 | e << 26) ^ (e >>> 11 | e << 21) ^ (e >>> 25 | e << 7);
                }
                function h(e) {
                    return (e >>> 7 | e << 25) ^ (e >>> 18 | e << 14) ^ e >>> 3;
                }
                n(u, i), u.prototype.init = function() {
                    return this._a = 1779033703, this._b = 3144134277, this._c = 1013904242, this._d = 2773480762, this._e = 1359893119, this._f = 2600822924, this._g = 528734635, this._h = 1541459225, this;
                }, u.prototype._update = function(e) {
                    for(var t, r = this._w, n = 0 | this._a, i = 0 | this._b, o = 0 | this._c, s = 0 | this._d, u = 0 | this._e, p = 0 | this._f, b = 0 | this._g, y = 0 | this._h, v = 0; v < 16; ++v)r[v] = e.readInt32BE(4 * v);
                    for(; v < 64; ++v)r[v] = 0 | (((t = r[v - 2]) >>> 17 | t << 15) ^ (t >>> 19 | t << 13) ^ t >>> 10) + r[v - 7] + h(r[v - 15]) + r[v - 16];
                    for(var m = 0; m < 64; ++m){
                        var g = y + l(u) + c(u, p, b) + a[m] + r[m] | 0, w = d(n) + f(n, i, o) | 0;
                        y = b, b = p, p = u, u = s + g | 0, s = o, o = i, i = n, n = g + w | 0;
                    }
                    this._a = n + this._a | 0, this._b = i + this._b | 0, this._c = o + this._c | 0, this._d = s + this._d | 0, this._e = u + this._e | 0, this._f = p + this._f | 0, this._g = b + this._g | 0, this._h = y + this._h | 0;
                }, u.prototype._hash = function() {
                    var e = o.allocUnsafe(32);
                    return e.writeInt32BE(this._a, 0), e.writeInt32BE(this._b, 4), e.writeInt32BE(this._c, 8), e.writeInt32BE(this._d, 12), e.writeInt32BE(this._e, 16), e.writeInt32BE(this._f, 20), e.writeInt32BE(this._g, 24), e.writeInt32BE(this._h, 28), e;
                }, e.exports = u;
            },
            46959: (e, t, r)=>{
                "use strict";
                var n = r(41736), i = r(14515), o = r(76003), a = r(48850).Buffer, s = new Array(160);
                function u() {
                    this.init(), this._w = s, o.call(this, 128, 112);
                }
                n(u, i), u.prototype.init = function() {
                    return this._ah = 3418070365, this._bh = 1654270250, this._ch = 2438529370, this._dh = 355462360, this._eh = 1731405415, this._fh = 2394180231, this._gh = 3675008525, this._hh = 1203062813, this._al = 3238371032, this._bl = 914150663, this._cl = 812702999, this._dl = 4144912697, this._el = 4290775857, this._fl = 1750603025, this._gl = 1694076839, this._hl = 3204075428, this;
                }, u.prototype._hash = function() {
                    var e = a.allocUnsafe(48);
                    function t(t, r, n) {
                        e.writeInt32BE(t, n), e.writeInt32BE(r, n + 4);
                    }
                    return t(this._ah, this._al, 0), t(this._bh, this._bl, 8), t(this._ch, this._cl, 16), t(this._dh, this._dl, 24), t(this._eh, this._el, 32), t(this._fh, this._fl, 40), e;
                }, e.exports = u;
            },
            14515: (e, t, r)=>{
                "use strict";
                var n = r(41736), i = r(76003), o = r(48850).Buffer, a = [
                    1116352408,
                    3609767458,
                    1899447441,
                    602891725,
                    3049323471,
                    3964484399,
                    3921009573,
                    2173295548,
                    961987163,
                    4081628472,
                    1508970993,
                    3053834265,
                    2453635748,
                    2937671579,
                    2870763221,
                    3664609560,
                    3624381080,
                    2734883394,
                    310598401,
                    1164996542,
                    607225278,
                    1323610764,
                    1426881987,
                    3590304994,
                    1925078388,
                    4068182383,
                    2162078206,
                    991336113,
                    2614888103,
                    633803317,
                    3248222580,
                    3479774868,
                    3835390401,
                    2666613458,
                    4022224774,
                    944711139,
                    264347078,
                    2341262773,
                    604807628,
                    2007800933,
                    770255983,
                    1495990901,
                    1249150122,
                    1856431235,
                    1555081692,
                    3175218132,
                    1996064986,
                    2198950837,
                    2554220882,
                    3999719339,
                    2821834349,
                    766784016,
                    2952996808,
                    2566594879,
                    3210313671,
                    3203337956,
                    3336571891,
                    1034457026,
                    3584528711,
                    2466948901,
                    113926993,
                    3758326383,
                    338241895,
                    168717936,
                    666307205,
                    1188179964,
                    773529912,
                    1546045734,
                    1294757372,
                    1522805485,
                    1396182291,
                    2643833823,
                    1695183700,
                    2343527390,
                    1986661051,
                    1014477480,
                    2177026350,
                    1206759142,
                    2456956037,
                    344077627,
                    2730485921,
                    1290863460,
                    2820302411,
                    3158454273,
                    3259730800,
                    3505952657,
                    3345764771,
                    106217008,
                    3516065817,
                    3606008344,
                    3600352804,
                    1432725776,
                    4094571909,
                    1467031594,
                    275423344,
                    851169720,
                    430227734,
                    3100823752,
                    506948616,
                    1363258195,
                    659060556,
                    3750685593,
                    883997877,
                    3785050280,
                    958139571,
                    3318307427,
                    1322822218,
                    3812723403,
                    1537002063,
                    2003034995,
                    1747873779,
                    3602036899,
                    1955562222,
                    1575990012,
                    2024104815,
                    1125592928,
                    2227730452,
                    2716904306,
                    2361852424,
                    442776044,
                    2428436474,
                    593698344,
                    2756734187,
                    3733110249,
                    3204031479,
                    2999351573,
                    3329325298,
                    3815920427,
                    3391569614,
                    3928383900,
                    3515267271,
                    566280711,
                    3940187606,
                    3454069534,
                    4118630271,
                    4000239992,
                    116418474,
                    1914138554,
                    174292421,
                    2731055270,
                    289380356,
                    3203993006,
                    460393269,
                    320620315,
                    685471733,
                    587496836,
                    852142971,
                    1086792851,
                    1017036298,
                    365543100,
                    1126000580,
                    2618297676,
                    1288033470,
                    3409855158,
                    1501505948,
                    4234509866,
                    1607167915,
                    987167468,
                    1816402316,
                    1246189591
                ], s = new Array(160);
                function u() {
                    this.init(), this._w = s, i.call(this, 128, 112);
                }
                function c(e, t, r) {
                    return r ^ e & (t ^ r);
                }
                function f(e, t, r) {
                    return e & t | r & (e | t);
                }
                function d(e, t) {
                    return (e >>> 28 | t << 4) ^ (t >>> 2 | e << 30) ^ (t >>> 7 | e << 25);
                }
                function l(e, t) {
                    return (e >>> 14 | t << 18) ^ (e >>> 18 | t << 14) ^ (t >>> 9 | e << 23);
                }
                function h(e, t) {
                    return (e >>> 1 | t << 31) ^ (e >>> 8 | t << 24) ^ e >>> 7;
                }
                function p(e, t) {
                    return (e >>> 1 | t << 31) ^ (e >>> 8 | t << 24) ^ (e >>> 7 | t << 25);
                }
                function b(e, t) {
                    return (e >>> 19 | t << 13) ^ (t >>> 29 | e << 3) ^ e >>> 6;
                }
                function y(e, t) {
                    return (e >>> 19 | t << 13) ^ (t >>> 29 | e << 3) ^ (e >>> 6 | t << 26);
                }
                function v(e, t) {
                    return e >>> 0 < t >>> 0 ? 1 : 0;
                }
                n(u, i), u.prototype.init = function() {
                    return this._ah = 1779033703, this._bh = 3144134277, this._ch = 1013904242, this._dh = 2773480762, this._eh = 1359893119, this._fh = 2600822924, this._gh = 528734635, this._hh = 1541459225, this._al = 4089235720, this._bl = 2227873595, this._cl = 4271175723, this._dl = 1595750129, this._el = 2917565137, this._fl = 725511199, this._gl = 4215389547, this._hl = 327033209, this;
                }, u.prototype._update = function(e) {
                    for(var t = this._w, r = 0 | this._ah, n = 0 | this._bh, i = 0 | this._ch, o = 0 | this._dh, s = 0 | this._eh, u = 0 | this._fh, m = 0 | this._gh, g = 0 | this._hh, w = 0 | this._al, k = 0 | this._bl, _ = 0 | this._cl, A = 0 | this._dl, E = 0 | this._el, S = 0 | this._fl, x = 0 | this._gl, B = 0 | this._hl, O = 0; O < 32; O += 2)t[O] = e.readInt32BE(4 * O), t[O + 1] = e.readInt32BE(4 * O + 4);
                    for(; O < 160; O += 2){
                        var P = t[O - 30], I = t[O - 30 + 1], T = h(P, I), C = p(I, P), M = b(P = t[O - 4], I = t[O - 4 + 1]), R = y(I, P), U = t[O - 14], N = t[O - 14 + 1], j = t[O - 32], L = t[O - 32 + 1], F = C + N | 0, D = T + U + v(F, C) | 0;
                        D = (D = D + M + v(F = F + R | 0, R) | 0) + j + v(F = F + L | 0, L) | 0, t[O] = D, t[O + 1] = F;
                    }
                    for(var H = 0; H < 160; H += 2){
                        D = t[H], F = t[H + 1];
                        var z = f(r, n, i), q = f(w, k, _), K = d(r, w), G = d(w, r), V = l(s, E), Z = l(E, s), W = a[H], J = a[H + 1], Y = c(s, u, m), X = c(E, S, x), Q = B + Z | 0, $ = g + V + v(Q, B) | 0;
                        $ = ($ = ($ = $ + Y + v(Q = Q + X | 0, X) | 0) + W + v(Q = Q + J | 0, J) | 0) + D + v(Q = Q + F | 0, F) | 0;
                        var ee = G + q | 0, te = K + z + v(ee, G) | 0;
                        g = m, B = x, m = u, x = S, u = s, S = E, s = o + $ + v(E = A + Q | 0, A) | 0, o = i, A = _, i = n, _ = k, n = r, k = w, r = $ + te + v(w = Q + ee | 0, Q) | 0;
                    }
                    this._al = this._al + w | 0, this._bl = this._bl + k | 0, this._cl = this._cl + _ | 0, this._dl = this._dl + A | 0, this._el = this._el + E | 0, this._fl = this._fl + S | 0, this._gl = this._gl + x | 0, this._hl = this._hl + B | 0, this._ah = this._ah + r + v(this._al, w) | 0, this._bh = this._bh + n + v(this._bl, k) | 0, this._ch = this._ch + i + v(this._cl, _) | 0, this._dh = this._dh + o + v(this._dl, A) | 0, this._eh = this._eh + s + v(this._el, E) | 0, this._fh = this._fh + u + v(this._fl, S) | 0, this._gh = this._gh + m + v(this._gl, x) | 0, this._hh = this._hh + g + v(this._hl, B) | 0;
                }, u.prototype._hash = function() {
                    var e = o.allocUnsafe(64);
                    function t(t, r, n) {
                        e.writeInt32BE(t, n), e.writeInt32BE(r, n + 4);
                    }
                    return t(this._ah, this._al, 0), t(this._bh, this._bl, 8), t(this._ch, this._cl, 16), t(this._dh, this._dl, 24), t(this._eh, this._el, 32), t(this._fh, this._fl, 40), t(this._gh, this._gl, 48), t(this._hh, this._hl, 56), e;
                }, e.exports = u;
            },
            57245: (e, t, r)=>{
                "use strict";
                e.exports = i;
                var n = r(38291).EventEmitter;
                function i() {
                    n.call(this);
                }
                r(41736)(i, n), i.Readable = r(6297), i.Writable = r(71471), i.Duplex = r(76884), i.Transform = r(99154), i.PassThrough = r(53582), i.finished = r(5831), i.pipeline = r(60384), i.Stream = i, i.prototype.pipe = function(e, t) {
                    var r = this;
                    function i(t) {
                        e.writable && !1 === e.write(t) && r.pause && r.pause();
                    }
                    function o() {
                        r.readable && r.resume && r.resume();
                    }
                    r.on("data", i), e.on("drain", o), e._isStdio || t && !1 === t.end || (r.on("end", s), r.on("close", u));
                    var a = !1;
                    function s() {
                        a || (a = !0, e.end());
                    }
                    function u() {
                        a || (a = !0, "function" == typeof e.destroy && e.destroy());
                    }
                    function c(e) {
                        if (f(), 0 === n.listenerCount(this, "error")) throw e;
                    }
                    function f() {
                        r.removeListener("data", i), e.removeListener("drain", o), r.removeListener("end", s), r.removeListener("close", u), r.removeListener("error", c), e.removeListener("error", c), r.removeListener("end", f), r.removeListener("close", f), e.removeListener("close", f);
                    }
                    return r.on("error", c), e.on("error", c), r.on("end", f), r.on("close", f), e.on("close", f), e.emit("pipe", r), e;
                };
            },
            29519: (e, t, r)=>{
                "use strict";
                var n = r(38844), i = r(53319), o = r(87705), a = r(83675), s = r(51143), u = t;
                u.request = function(e, t) {
                    e = "string" == typeof e ? s.parse(e) : o(e);
                    var i = -1 === r.g.location.protocol.search(/^https?:$/) ? "http:" : "", a = e.protocol || i, u = e.hostname || e.host, c = e.port, f = e.path || "/";
                    u && -1 !== u.indexOf(":") && (u = "[" + u + "]"), e.url = (u ? a + "//" + u : "") + (c ? ":" + c : "") + f, e.method = (e.method || "GET").toUpperCase(), e.headers = e.headers || {};
                    var d = new n(e);
                    return t && d.on("response", t), d;
                }, u.get = function(e, t) {
                    var r = u.request(e, t);
                    return r.end(), r;
                }, u.ClientRequest = n, u.IncomingMessage = i.IncomingMessage, u.Agent = function() {}, u.Agent.defaultMaxSockets = 4, u.globalAgent = new u.Agent, u.STATUS_CODES = a, u.METHODS = [
                    "CHECKOUT",
                    "CONNECT",
                    "COPY",
                    "DELETE",
                    "GET",
                    "HEAD",
                    "LOCK",
                    "M-SEARCH",
                    "MERGE",
                    "MKACTIVITY",
                    "MKCOL",
                    "MOVE",
                    "NOTIFY",
                    "OPTIONS",
                    "PATCH",
                    "POST",
                    "PROPFIND",
                    "PROPPATCH",
                    "PURGE",
                    "PUT",
                    "REPORT",
                    "SEARCH",
                    "SUBSCRIBE",
                    "TRACE",
                    "UNLOCK",
                    "UNSUBSCRIBE"
                ];
            },
            23928: (e, t, r)=>{
                "use strict";
                var n;
                function i() {
                    if (void 0 !== n) return n;
                    if (r.g.XMLHttpRequest) {
                        n = new r.g.XMLHttpRequest;
                        try {
                            n.open("GET", r.g.XDomainRequest ? "/" : "https://example.com");
                        } catch (e) {
                            n = null;
                        }
                    } else n = null;
                    return n;
                }
                function o(e) {
                    var t = i();
                    if (!t) return !1;
                    try {
                        return t.responseType = e, t.responseType === e;
                    } catch (e) {}
                    return !1;
                }
                function a(e) {
                    return "function" == typeof e;
                }
                t.fetch = a(r.g.fetch) && a(r.g.ReadableStream), t.writableStream = a(r.g.WritableStream), t.abortController = a(r.g.AbortController), t.arraybuffer = t.fetch || o("arraybuffer"), t.msstream = !t.fetch && o("ms-stream"), t.mozchunkedarraybuffer = !t.fetch && o("moz-chunked-arraybuffer"), t.overrideMimeType = t.fetch || !!i() && a(i().overrideMimeType), n = null;
            },
            38844: (e, t, r)=>{
                "use strict";
                var n = r(29033).Buffer, i = r(19142), o = r(23928), a = r(41736), s = r(53319), u = r(86505), c = s.IncomingMessage, f = s.readyStates, d = e.exports = function(e) {
                    var t, r = this;
                    u.Writable.call(r), r._opts = e, r._body = [], r._headers = {}, e.auth && r.setHeader("Authorization", "Basic " + n.from(e.auth).toString("base64")), Object.keys(e.headers).forEach(function(t) {
                        r.setHeader(t, e.headers[t]);
                    });
                    var i = !0;
                    if ("disable-fetch" === e.mode || "requestTimeout" in e && !o.abortController) i = !1, t = !0;
                    else if ("prefer-streaming" === e.mode) t = !1;
                    else if ("allow-wrong-content-type" === e.mode) t = !o.overrideMimeType;
                    else {
                        if (e.mode && "default" !== e.mode && "prefer-fast" !== e.mode) throw new Error("Invalid value for opts.mode");
                        t = !0;
                    }
                    r._mode = function(e, t) {
                        return o.fetch && t ? "fetch" : o.mozchunkedarraybuffer ? "moz-chunked-arraybuffer" : o.msstream ? "ms-stream" : o.arraybuffer && e ? "arraybuffer" : "text";
                    }(t, i), r._fetchTimer = null, r._socketTimeout = null, r._socketTimer = null, r.on("finish", function() {
                        r._onFinish();
                    });
                };
                a(d, u.Writable), d.prototype.setHeader = function(e, t) {
                    var r = e.toLowerCase();
                    -1 === l.indexOf(r) && (this._headers[r] = {
                        name: e,
                        value: t
                    });
                }, d.prototype.getHeader = function(e) {
                    var t = this._headers[e.toLowerCase()];
                    return t ? t.value : null;
                }, d.prototype.removeHeader = function(e) {
                    delete this._headers[e.toLowerCase()];
                }, d.prototype._onFinish = function() {
                    var e = this;
                    if (!e._destroyed) {
                        var t = e._opts;
                        "timeout" in t && 0 !== t.timeout && e.setTimeout(t.timeout);
                        var n = e._headers, a = null;
                        "GET" !== t.method && "HEAD" !== t.method && (a = new Blob(e._body, {
                            type: (n["content-type"] || {}).value || ""
                        }));
                        var s = [];
                        if (Object.keys(n).forEach(function(e) {
                            var t = n[e].name, r = n[e].value;
                            Array.isArray(r) ? r.forEach(function(e) {
                                s.push([
                                    t,
                                    e
                                ]);
                            }) : s.push([
                                t,
                                r
                            ]);
                        }), "fetch" === e._mode) {
                            var u = null;
                            if (o.abortController) {
                                var c = new AbortController;
                                u = c.signal, e._fetchAbortController = c, "requestTimeout" in t && 0 !== t.requestTimeout && (e._fetchTimer = r.g.setTimeout(function() {
                                    e.emit("requestTimeout"), e._fetchAbortController && e._fetchAbortController.abort();
                                }, t.requestTimeout));
                            }
                            r.g.fetch(e._opts.url, {
                                method: e._opts.method,
                                headers: s,
                                body: a || void 0,
                                mode: "cors",
                                credentials: t.withCredentials ? "include" : "same-origin",
                                signal: u
                            }).then(function(t) {
                                e._fetchResponse = t, e._resetTimers(!1), e._connect();
                            }, function(t) {
                                e._resetTimers(!0), e._destroyed || e.emit("error", t);
                            });
                        } else {
                            var d = e._xhr = new r.g.XMLHttpRequest;
                            try {
                                d.open(e._opts.method, e._opts.url, !0);
                            } catch (t) {
                                return void i.nextTick(function() {
                                    e.emit("error", t);
                                });
                            }
                            "responseType" in d && (d.responseType = e._mode), "withCredentials" in d && (d.withCredentials = !!t.withCredentials), "text" === e._mode && "overrideMimeType" in d && d.overrideMimeType("text/plain; charset=x-user-defined"), "requestTimeout" in t && (d.timeout = t.requestTimeout, d.ontimeout = function() {
                                e.emit("requestTimeout");
                            }), s.forEach(function(e) {
                                d.setRequestHeader(e[0], e[1]);
                            }), e._response = null, d.onreadystatechange = function() {
                                switch(d.readyState){
                                    case f.LOADING:
                                    case f.DONE:
                                        e._onXHRProgress();
                                }
                            }, "moz-chunked-arraybuffer" === e._mode && (d.onprogress = function() {
                                e._onXHRProgress();
                            }), d.onerror = function() {
                                e._destroyed || (e._resetTimers(!0), e.emit("error", new Error("XHR error")));
                            };
                            try {
                                d.send(a);
                            } catch (t) {
                                return void i.nextTick(function() {
                                    e.emit("error", t);
                                });
                            }
                        }
                    }
                }, d.prototype._onXHRProgress = function() {
                    var e = this;
                    e._resetTimers(!1), function(e) {
                        try {
                            var t = e.status;
                            return null !== t && 0 !== t;
                        } catch (e) {
                            return !1;
                        }
                    }(e._xhr) && !e._destroyed && (e._response || e._connect(), e._response._onXHRProgress(e._resetTimers.bind(e)));
                }, d.prototype._connect = function() {
                    var e = this;
                    e._destroyed || (e._response = new c(e._xhr, e._fetchResponse, e._mode, e._resetTimers.bind(e)), e._response.on("error", function(t) {
                        e.emit("error", t);
                    }), e.emit("response", e._response));
                }, d.prototype._write = function(e, t, r) {
                    this._body.push(e), r();
                }, d.prototype._resetTimers = function(e) {
                    var t = this;
                    r.g.clearTimeout(t._socketTimer), t._socketTimer = null, e ? (r.g.clearTimeout(t._fetchTimer), t._fetchTimer = null) : t._socketTimeout && (t._socketTimer = r.g.setTimeout(function() {
                        t.emit("timeout");
                    }, t._socketTimeout));
                }, d.prototype.abort = d.prototype.destroy = function(e) {
                    var t = this;
                    t._destroyed = !0, t._resetTimers(!0), t._response && (t._response._destroyed = !0), t._xhr ? t._xhr.abort() : t._fetchAbortController && t._fetchAbortController.abort(), e && t.emit("error", e);
                }, d.prototype.end = function(e, t, r) {
                    "function" == typeof e && (r = e, e = void 0), u.Writable.prototype.end.call(this, e, t, r);
                }, d.prototype.setTimeout = function(e, t) {
                    var r = this;
                    t && r.once("timeout", t), r._socketTimeout = e, r._resetTimers(!1);
                }, d.prototype.flushHeaders = function() {}, d.prototype.setNoDelay = function() {}, d.prototype.setSocketKeepAlive = function() {};
                var l = [
                    "accept-charset",
                    "accept-encoding",
                    "access-control-request-headers",
                    "access-control-request-method",
                    "connection",
                    "content-length",
                    "cookie",
                    "cookie2",
                    "date",
                    "dnt",
                    "expect",
                    "host",
                    "keep-alive",
                    "origin",
                    "referer",
                    "te",
                    "trailer",
                    "transfer-encoding",
                    "upgrade",
                    "via"
                ];
            },
            53319: (e, t, r)=>{
                "use strict";
                var n = r(19142), i = r(29033).Buffer, o = r(23928), a = r(41736), s = r(86505), u = t.readyStates = {
                    UNSENT: 0,
                    OPENED: 1,
                    HEADERS_RECEIVED: 2,
                    LOADING: 3,
                    DONE: 4
                }, c = t.IncomingMessage = function(e, t, r, a) {
                    var u = this;
                    if (s.Readable.call(u), u._mode = r, u.headers = {}, u.rawHeaders = [], u.trailers = {}, u.rawTrailers = [], u.on("end", function() {
                        n.nextTick(function() {
                            u.emit("close");
                        });
                    }), "fetch" === r) {
                        if (u._fetchResponse = t, u.url = t.url, u.statusCode = t.status, u.statusMessage = t.statusText, t.headers.forEach(function(e, t) {
                            u.headers[t.toLowerCase()] = e, u.rawHeaders.push(t, e);
                        }), o.writableStream) {
                            var c = new WritableStream({
                                write: function(e) {
                                    return a(!1), new Promise(function(t, r) {
                                        u._destroyed ? r() : u.push(i.from(e)) ? t() : u._resumeFetch = t;
                                    });
                                },
                                close: function() {
                                    a(!0), u._destroyed || u.push(null);
                                },
                                abort: function(e) {
                                    a(!0), u._destroyed || u.emit("error", e);
                                }
                            });
                            try {
                                return void t.body.pipeTo(c).catch(function(e) {
                                    a(!0), u._destroyed || u.emit("error", e);
                                });
                            } catch (e) {}
                        }
                        var f = t.body.getReader();
                        !function e() {
                            f.read().then(function(t) {
                                u._destroyed || (a(t.done), t.done ? u.push(null) : (u.push(i.from(t.value)), e()));
                            }).catch(function(e) {
                                a(!0), u._destroyed || u.emit("error", e);
                            });
                        }();
                    } else if (u._xhr = e, u._pos = 0, u.url = e.responseURL, u.statusCode = e.status, u.statusMessage = e.statusText, e.getAllResponseHeaders().split(/\r?\n/).forEach(function(e) {
                        var t = e.match(/^([^:]+):\s*(.*)/);
                        if (t) {
                            var r = t[1].toLowerCase();
                            "set-cookie" === r ? (void 0 === u.headers[r] && (u.headers[r] = []), u.headers[r].push(t[2])) : void 0 !== u.headers[r] ? u.headers[r] += ", " + t[2] : u.headers[r] = t[2], u.rawHeaders.push(t[1], t[2]);
                        }
                    }), u._charset = "x-user-defined", !o.overrideMimeType) {
                        var d = u.rawHeaders["mime-type"];
                        if (d) {
                            var l = d.match(/;\s*charset=([^;])(;|$)/);
                            l && (u._charset = l[1].toLowerCase());
                        }
                        u._charset || (u._charset = "utf-8");
                    }
                };
                a(c, s.Readable), c.prototype._read = function() {
                    var e = this._resumeFetch;
                    e && (this._resumeFetch = null, e());
                }, c.prototype._onXHRProgress = function(e) {
                    var t = this, n = t._xhr, o = null;
                    switch(t._mode){
                        case "text":
                            if ((o = n.responseText).length > t._pos) {
                                var a = o.substr(t._pos);
                                if ("x-user-defined" === t._charset) {
                                    for(var s = i.alloc(a.length), c = 0; c < a.length; c++)s[c] = 255 & a.charCodeAt(c);
                                    t.push(s);
                                } else t.push(a, t._charset);
                                t._pos = o.length;
                            }
                            break;
                        case "arraybuffer":
                            if (n.readyState !== u.DONE || !n.response) break;
                            o = n.response, t.push(i.from(new Uint8Array(o)));
                            break;
                        case "moz-chunked-arraybuffer":
                            if (o = n.response, n.readyState !== u.LOADING || !o) break;
                            t.push(i.from(new Uint8Array(o)));
                            break;
                        case "ms-stream":
                            if (o = n.response, n.readyState !== u.LOADING) break;
                            var f = new r.g.MSStreamReader;
                            f.onprogress = function() {
                                f.result.byteLength > t._pos && (t.push(i.from(new Uint8Array(f.result.slice(t._pos)))), t._pos = f.result.byteLength);
                            }, f.onload = function() {
                                e(!0), t.push(null);
                            }, f.readAsArrayBuffer(o);
                    }
                    t._xhr.readyState === u.DONE && "ms-stream" !== t._mode && (e(!0), t.push(null));
                };
            },
            22028: (e)=>{
                "use strict";
                e.exports = function(e) {
                    return encodeURIComponent(e).replace(/[!'()*]/g, function(e) {
                        return "%" + e.charCodeAt(0).toString(16).toUpperCase();
                    });
                };
            },
            23462: (e, t, r)=>{
                "use strict";
                var n = r(48850).Buffer, i = n.isEncoding || function(e) {
                    switch((e = "" + e) && e.toLowerCase()){
                        case "hex":
                        case "utf8":
                        case "utf-8":
                        case "ascii":
                        case "binary":
                        case "base64":
                        case "ucs2":
                        case "ucs-2":
                        case "utf16le":
                        case "utf-16le":
                        case "raw":
                            return !0;
                        default:
                            return !1;
                    }
                };
                function o(e) {
                    var t;
                    switch(this.encoding = function(e) {
                        var t = function(e) {
                            if (!e) return "utf8";
                            for(var t;;)switch(e){
                                case "utf8":
                                case "utf-8":
                                    return "utf8";
                                case "ucs2":
                                case "ucs-2":
                                case "utf16le":
                                case "utf-16le":
                                    return "utf16le";
                                case "latin1":
                                case "binary":
                                    return "latin1";
                                case "base64":
                                case "ascii":
                                case "hex":
                                    return e;
                                default:
                                    if (t) return;
                                    e = ("" + e).toLowerCase(), t = !0;
                            }
                        }(e);
                        if ("string" != typeof t && (n.isEncoding === i || !i(e))) throw new Error("Unknown encoding: " + e);
                        return t || e;
                    }(e), this.encoding){
                        case "utf16le":
                            this.text = u, this.end = c, t = 4;
                            break;
                        case "utf8":
                            this.fillLast = s, t = 4;
                            break;
                        case "base64":
                            this.text = f, this.end = d, t = 3;
                            break;
                        default:
                            return this.write = l, void (this.end = h);
                    }
                    this.lastNeed = 0, this.lastTotal = 0, this.lastChar = n.allocUnsafe(t);
                }
                function a(e) {
                    return e <= 127 ? 0 : e >> 5 == 6 ? 2 : e >> 4 == 14 ? 3 : e >> 3 == 30 ? 4 : e >> 6 == 2 ? -1 : -2;
                }
                function s(e) {
                    var t = this.lastTotal - this.lastNeed, r = function(e, t, r) {
                        if (128 != (192 & t[0])) return e.lastNeed = 0, "\uFFFD";
                        if (e.lastNeed > 1 && t.length > 1) {
                            if (128 != (192 & t[1])) return e.lastNeed = 1, "\uFFFD";
                            if (e.lastNeed > 2 && t.length > 2 && 128 != (192 & t[2])) return e.lastNeed = 2, "\uFFFD";
                        }
                    }(this, e);
                    return void 0 !== r ? r : this.lastNeed <= e.length ? (e.copy(this.lastChar, t, 0, this.lastNeed), this.lastChar.toString(this.encoding, 0, this.lastTotal)) : (e.copy(this.lastChar, t, 0, e.length), void (this.lastNeed -= e.length));
                }
                function u(e, t) {
                    if ((e.length - t) % 2 == 0) {
                        var r = e.toString("utf16le", t);
                        if (r) {
                            var n = r.charCodeAt(r.length - 1);
                            if (n >= 55296 && n <= 56319) return this.lastNeed = 2, this.lastTotal = 4, this.lastChar[0] = e[e.length - 2], this.lastChar[1] = e[e.length - 1], r.slice(0, -1);
                        }
                        return r;
                    }
                    return this.lastNeed = 1, this.lastTotal = 2, this.lastChar[0] = e[e.length - 1], e.toString("utf16le", t, e.length - 1);
                }
                function c(e) {
                    var t = e && e.length ? this.write(e) : "";
                    if (this.lastNeed) {
                        var r = this.lastTotal - this.lastNeed;
                        return t + this.lastChar.toString("utf16le", 0, r);
                    }
                    return t;
                }
                function f(e, t) {
                    var r = (e.length - t) % 3;
                    return 0 === r ? e.toString("base64", t) : (this.lastNeed = 3 - r, this.lastTotal = 3, 1 === r ? this.lastChar[0] = e[e.length - 1] : (this.lastChar[0] = e[e.length - 2], this.lastChar[1] = e[e.length - 1]), e.toString("base64", t, e.length - r));
                }
                function d(e) {
                    var t = e && e.length ? this.write(e) : "";
                    return this.lastNeed ? t + this.lastChar.toString("base64", 0, 3 - this.lastNeed) : t;
                }
                function l(e) {
                    return e.toString(this.encoding);
                }
                function h(e) {
                    return e && e.length ? this.write(e) : "";
                }
                t.s = o, o.prototype.write = function(e) {
                    if (0 === e.length) return "";
                    var t, r;
                    if (this.lastNeed) {
                        if (void 0 === (t = this.fillLast(e))) return "";
                        r = this.lastNeed, this.lastNeed = 0;
                    } else r = 0;
                    return r < e.length ? t ? t + this.text(e, r) : this.text(e, r) : t || "";
                }, o.prototype.end = function(e) {
                    var t = e && e.length ? this.write(e) : "";
                    return this.lastNeed ? t + "\uFFFD" : t;
                }, o.prototype.text = function(e, t) {
                    var r = function(e, t, r) {
                        var n = t.length - 1;
                        if (n < r) return 0;
                        var i = a(t[n]);
                        return i >= 0 ? (i > 0 && (e.lastNeed = i - 1), i) : --n < r || -2 === i ? 0 : (i = a(t[n])) >= 0 ? (i > 0 && (e.lastNeed = i - 2), i) : --n < r || -2 === i ? 0 : (i = a(t[n])) >= 0 ? (i > 0 && (2 === i ? i = 0 : e.lastNeed = i - 3), i) : 0;
                    }(this, e, t);
                    if (!this.lastNeed) return e.toString("utf8", t);
                    this.lastTotal = r;
                    var n = e.length - (r - this.lastNeed);
                    return e.copy(this.lastChar, 0, n), e.toString("utf8", t, n);
                }, o.prototype.fillLast = function(e) {
                    if (this.lastNeed <= e.length) return e.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, this.lastNeed), this.lastChar.toString(this.encoding, 0, this.lastTotal);
                    e.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, e.length), this.lastNeed -= e.length;
                };
            },
            36931: (e, t, r)=>{
                "use strict";
                var n = r(8619);
                e.exports = function(e) {
                    return "string" != typeof e ? e : n(e) ? e.slice(2) : e;
                };
            },
            26427: (e, t, r)=>{
                "use strict";
                var n = function() {
                    throw "This swarm.js function isn't available on the browser.";
                }, i = {
                    readFile: n
                }, o = {
                    download: n,
                    safeDownloadArchived: n,
                    directoryTree: n
                }, a = {
                    platform: n,
                    arch: n
                }, s = {
                    join: n,
                    slice: n
                }, u = {
                    spawn: n
                }, c = {
                    lookup: n
                }, f = r(31357), d = r(40631), l = r(42733), h = r(52510), p = r(13094);
                e.exports = p({
                    fs: i,
                    files: o,
                    os: a,
                    path: s,
                    child_process: u,
                    defaultArchives: {},
                    mimetype: c,
                    request: f,
                    downloadUrl: null,
                    bytes: d,
                    hash: l,
                    pick: h
                });
            },
            52510: (e)=>{
                "use strict";
                var t = function(e) {
                    return function() {
                        return new Promise(function(t, r) {
                            var n, i = function(r) {
                                var n = {}, i = r.target.files.length, o = 0;
                                [].map.call(r.target.files, function(r) {
                                    var a = new FileReader;
                                    a.onload = function(a) {
                                        var s = new Uint8Array(a.target.result);
                                        if ("directory" === e) {
                                            var u = r.webkitRelativePath;
                                            n[u.slice(u.indexOf("/") + 1)] = {
                                                type: "text/plain",
                                                data: s
                                            }, ++o === i && t(n);
                                        } else if ("file" === e) {
                                            var c = r.webkitRelativePath;
                                            t({
                                                type: mimetype.lookup(c),
                                                data: s
                                            });
                                        } else t(s);
                                    }, a.readAsArrayBuffer(r);
                                });
                            };
                            "directory" === e ? ((n = document.createElement("input")).addEventListener("change", i), n.type = "file", n.webkitdirectory = !0, n.mozdirectory = !0, n.msdirectory = !0, n.odirectory = !0, n.directory = !0) : ((n = document.createElement("input")).addEventListener("change", i), n.type = "file");
                            var o = document.createEvent("MouseEvents");
                            o.initEvent("click", !0, !1), n.dispatchEvent(o);
                        });
                    };
                };
                e.exports = {
                    data: t("data"),
                    file: t("file"),
                    directory: t("directory")
                };
            },
            42733: (e, t, r)=>{
                "use strict";
                var n = r(49574).keccak256, i = r(40631), o = function(e, t) {
                    var r = i.reverse(i.pad(6, i.fromNumber(e))), o = i.flatten([
                        r,
                        "0x0000",
                        t
                    ]);
                    return n(o).slice(2);
                };
                e.exports = function e(t) {
                    "string" == typeof t && "0x" !== t.slice(0, 2) ? t = i.fromString(t) : "string" != typeof t && void 0 !== t.length && (t = i.fromUint8Array(t));
                    var r = i.length(t);
                    if (r <= 4096) return o(r, t);
                    for(var n = 4096; 128 * n < r;)n *= 128;
                    for(var a = [], s = 0; s < r; s += n){
                        var u = n < r - s ? n : r - s;
                        a.push(e(i.slice(t, s, s + u)));
                    }
                    return o(r, i.flatten(a));
                };
            },
            13094: (e)=>{
                "use strict";
                e.exports = function(e) {
                    var t = e.fs, r = e.files, n = e.os, i = e.path, o = e.child_process, a = e.mimetype, s = e.defaultArchives, u = e.request, c = e.downloadUrl, f = e.bytes, d = e.hash, l = e.pick, h = function(e) {
                        return function(t) {
                            for(var r = {}, n = 0, i = e.length; n < i; ++n)r[e[n]] = t[n];
                            return r;
                        };
                    }, p = function(e) {
                        return function(t) {
                            return "".concat(e, "/bzz-raw:/").concat(t);
                        };
                    }, b = function(e) {
                        return function(t) {
                            return new Promise(function(r, n) {
                                u(p(e)(t), {
                                    responseType: "arraybuffer"
                                }, function(e, t, i) {
                                    return e ? n(e) : i.statusCode >= 400 ? n(new Error("Error ".concat(i.statusCode, "."))) : r(new Uint8Array(t));
                                });
                            });
                        };
                    }, y = function(e) {
                        return function(t) {
                            return (function t(r) {
                                return function(n) {
                                    return function(i) {
                                        var o = function(e) {
                                            var r;
                                            return void 0 === e.path ? Promise.resolve() : "application/bzz-manifest+json" === e.contentType ? t(e.hash)(n + e.path)(i) : Promise.resolve((r = n + e.path, function(e) {
                                                return function(t) {
                                                    return t[r] = e, t;
                                                };
                                            })(function(e) {
                                                return {
                                                    type: e.contentType,
                                                    hash: e.hash
                                                };
                                            }(e))(i));
                                        };
                                        return b(e)(r).then(function(e) {
                                            return JSON.parse(N(e)).entries;
                                        }).then(function(e) {
                                            return Promise.all(e.map(o));
                                        }).then(function() {
                                            return i;
                                        });
                                    };
                                };
                            })(t)("")({});
                        };
                    }, v = function(e) {
                        return function(t) {
                            return y(e)(t).then(function(e) {
                                return h(Object.keys(e))(Object.keys(e).map(function(t) {
                                    return e[t].hash;
                                }));
                            });
                        };
                    }, m = function(e) {
                        return function(t) {
                            return y(e)(t).then(function(t) {
                                var r = Object.keys(t), n = r.map(function(e) {
                                    return t[e].hash;
                                }), i = r.map(function(e) {
                                    return t[e].type;
                                }), o = n.map(b(e));
                                return Promise.all(o).then(function(e) {
                                    return h(r)(function(e) {
                                        return e.map(function(e, t) {
                                            return {
                                                type: i[t],
                                                data: e
                                            };
                                        });
                                    }(e));
                                });
                            });
                        };
                    }, g = function(e) {
                        return function(t) {
                            return function(n) {
                                return r.download(p(e)(t))(n);
                            };
                        };
                    }, w = function(e) {
                        return function(t) {
                            return function(r) {
                                return v(e)(t).then(function(t) {
                                    var n = [];
                                    for(var o in t)if (o.length > 0) {
                                        var a = i.join(r, o);
                                        n.push(g(e)(t[o])(a));
                                    }
                                    return Promise.all(n).then(function() {
                                        return r;
                                    });
                                });
                            };
                        };
                    }, k = function(e) {
                        return function(t) {
                            return new Promise(function(r, n) {
                                var i = {
                                    body: "string" == typeof t ? j(t) : t,
                                    method: "POST"
                                };
                                u("".concat(e, "/bzz-raw:/"), i, function(e, t) {
                                    return e ? n(e) : r(t);
                                });
                            });
                        };
                    }, _ = function(e) {
                        return function(t) {
                            return function(r) {
                                return function(n) {
                                    return function i(o) {
                                        var a = "/" === r[0] ? r : "/" + r, s = "".concat(e, "/bzz:/").concat(t).concat(a), c = {
                                            method: "PUT",
                                            headers: {
                                                "Content-Type": n.type
                                            },
                                            body: n.data
                                        };
                                        return new Promise(function(e, t) {
                                            u(s, c, function(r, n) {
                                                return r ? t(r) : -1 !== n.indexOf("error") ? t(n) : e(n);
                                            });
                                        }).catch(function(e) {
                                            return o > 0 && i(o - 1);
                                        });
                                    }(3);
                                };
                            };
                        };
                    }, A = function(e) {
                        return function(t) {
                            return S(e)({
                                "": t
                            });
                        };
                    }, E = function(e) {
                        return function(r) {
                            return t.readFile(r).then(function(t) {
                                return A(e)({
                                    type: a.lookup(r),
                                    data: t
                                });
                            });
                        };
                    }, S = function(e) {
                        return function(t) {
                            return k(e)("{}").then(function(r) {
                                return Object.keys(t).reduce(function(r, n) {
                                    return r.then(function(r) {
                                        return function(n) {
                                            return _(e)(n)(r)(t[r]);
                                        };
                                    }(n));
                                }, Promise.resolve(r));
                            });
                        };
                    }, x = function(e) {
                        return function(r) {
                            return t.readFile(r).then(k(e));
                        };
                    }, B = function(e) {
                        return function(n) {
                            return function(i) {
                                return r.directoryTree(i).then(function(e) {
                                    return Promise.all(e.map(function(e) {
                                        return t.readFile(e);
                                    })).then(function(t) {
                                        var r = e.map(function(e) {
                                            return e.slice(i.length);
                                        }), n = e.map(function(e) {
                                            return a.lookup(e) || "text/plain";
                                        });
                                        return h(r)(t.map(function(e, t) {
                                            return {
                                                type: n[t],
                                                data: e
                                            };
                                        }));
                                    });
                                }).then(function(e) {
                                    var t;
                                    return (t = n ? {
                                        "": e[n]
                                    } : {}, function(e) {
                                        var r = {};
                                        for(var n in t)r[n] = t[n];
                                        for(var i in e)r[i] = e[i];
                                        return r;
                                    })(e);
                                }).then(S(e));
                            };
                        };
                    }, O = function(e) {
                        return function(t) {
                            if ("data" === t.pick) return l.data().then(k(e));
                            if ("file" === t.pick) return l.file().then(A(e));
                            if ("directory" === t.pick) return l.directory().then(S(e));
                            if (t.path) switch(t.kind){
                                case "data":
                                    return x(e)(t.path);
                                case "file":
                                    return E(e)(t.path);
                                case "directory":
                                    return B(e)(t.defaultFile)(t.path);
                            }
                            else {
                                if (t.length || "string" == typeof t) return k(e)(t);
                                if (t instanceof Object) return S(e)(t);
                            }
                            return Promise.reject(new Error("Bad arguments"));
                        };
                    }, P = function(e) {
                        return function(t) {
                            return function(r) {
                                return R(e)(t).then(function(n) {
                                    return n ? r ? w(e)(t)(r) : m(e)(t) : r ? g(e)(t)(r) : b(e)(t);
                                });
                            };
                        };
                    }, I = function(e, t) {
                        var i = n.platform().replace("win32", "windows") + "-" + ("x64" === n.arch() ? "amd64" : "386"), o = (t || s)[i], a = c + o.archive + ".tar.gz", u = o.archiveMD5, f = o.binaryMD5;
                        return r.safeDownloadArchived(a)(u)(f)(e);
                    }, T = function(e) {
                        return new Promise(function(t, r) {
                            var n = o.spawn, i = function(e) {
                                return function(t) {
                                    return -1 !== ("" + t).indexOf(e);
                                };
                            }, a = e.account, s = e.password, u = e.dataDir, c = e.ensApi, f = e.privateKey, d = 0, l = n(e.binPath, [
                                "--bzzaccount",
                                a || f,
                                "--datadir",
                                u,
                                "--ens-api",
                                c
                            ]), h = function(e) {
                                0 === d && i("Passphrase")(e) ? setTimeout(function() {
                                    d = 1, l.stdin.write(s + "\n");
                                }, 500) : i("Swarm http proxy started")(e) && (d = 2, clearTimeout(p), t(l));
                            };
                            l.stdout.on("data", h), l.stderr.on("data", h);
                            var p = setTimeout(function() {
                                return r(new Error("Couldn't start swarm process."));
                            }, 2e4);
                        });
                    }, C = function(e) {
                        return new Promise(function(t, r) {
                            e.stderr.removeAllListeners("data"), e.stdout.removeAllListeners("data"), e.stdin.removeAllListeners("error"), e.removeAllListeners("error"), e.removeAllListeners("exit"), e.kill("SIGINT");
                            var n = setTimeout(function() {
                                return e.kill("SIGKILL");
                            }, 8e3);
                            e.once("close", function() {
                                clearTimeout(n), t();
                            });
                        });
                    }, M = function(e) {
                        return k(e)("test").then(function(e) {
                            return "c9a99c7d326dcc6316f32fe2625b311f6dc49a175e6877681ded93137d3569e7" === e;
                        }).catch(function() {
                            return !1;
                        });
                    }, R = function(e) {
                        return function(t) {
                            return b(e)(t).then(function(e) {
                                try {
                                    return !!JSON.parse(N(e)).entries;
                                } catch (e) {
                                    return !1;
                                }
                            });
                        };
                    }, U = function(e) {
                        return function(t, r, n, i, o) {
                            var a;
                            return void 0 !== t && (a = e(t)), void 0 !== r && (a = e(r)), void 0 !== n && (a = e(n)), void 0 !== i && (a = e(i)), void 0 !== o && (a = e(o)), a;
                        };
                    }, N = function(e) {
                        return f.toString(f.fromUint8Array(e));
                    }, j = function(e) {
                        return f.toUint8Array(f.fromString(e));
                    }, L = function(e) {
                        return {
                            download: function(t, r) {
                                return P(e)(t)(r);
                            },
                            downloadData: U(b(e)),
                            downloadDataToDisk: U(g(e)),
                            downloadDirectory: U(m(e)),
                            downloadDirectoryToDisk: U(w(e)),
                            downloadEntries: U(y(e)),
                            downloadRoutes: U(v(e)),
                            isAvailable: function() {
                                return M(e);
                            },
                            upload: function(t) {
                                return O(e)(t);
                            },
                            uploadData: U(k(e)),
                            uploadFile: U(A(e)),
                            uploadFileFromDisk: U(A(e)),
                            uploadDataFromDisk: U(x(e)),
                            uploadDirectory: U(S(e)),
                            uploadDirectoryFromDisk: U(B(e)),
                            uploadToManifest: U(_(e)),
                            pick: l,
                            hash: d,
                            fromString: j,
                            toString: N
                        };
                    };
                    return {
                        at: L,
                        local: function(e) {
                            return function(t) {
                                return M("http://localhost:8500").then(function(r) {
                                    return r ? t(L("http://localhost:8500")).then(function() {}) : I(e.binPath, e.archives).onData(function(t) {
                                        return (e.onProgress || function() {})(t.length);
                                    }).then(function() {
                                        return T(e);
                                    }).then(function(e) {
                                        return t(L("http://localhost:8500")).then(function() {
                                            return e;
                                        });
                                    }).then(C);
                                });
                            };
                        },
                        download: P,
                        downloadBinary: I,
                        downloadData: b,
                        downloadDataToDisk: g,
                        downloadDirectory: m,
                        downloadDirectoryToDisk: w,
                        downloadEntries: y,
                        downloadRoutes: v,
                        isAvailable: M,
                        startProcess: T,
                        stopProcess: C,
                        upload: O,
                        uploadData: k,
                        uploadDataFromDisk: x,
                        uploadFile: A,
                        uploadFileFromDisk: E,
                        uploadDirectory: S,
                        uploadDirectoryFromDisk: B,
                        uploadToManifest: _,
                        pick: l,
                        hash: d,
                        fromString: j,
                        toString: N
                    };
                };
            },
            16873: (e)=>{
                "use strict";
                var t = function(e, t) {
                    for(var r = [], n = 0; n < e; ++n)r.push(t(n));
                    return r;
                };
                e.exports = {
                    generate: t,
                    replicate: function(e, r) {
                        return t(e, function() {
                            return r;
                        });
                    },
                    concat: function(e, t) {
                        return e.concat(t);
                    },
                    flatten: function(e) {
                        for(var t = [], r = 0, n = e.length; r < n; ++r)for(var i = 0, o = e[r].length; i < o; ++i)t.push(e[r][i]);
                        return t;
                    },
                    chunksOf: function(e, t) {
                        for(var r = [], n = 0, i = t.length; n < i; n += e)r.push(t.slice(n, n + e));
                        return r;
                    }
                };
            },
            40631: (e, t, r)=>{
                "use strict";
                r(16873);
                var n = function(e, t) {
                    return parseInt(e.slice(2 * t + 2, 2 * t + 4), 16);
                }, i = function(e) {
                    return (e.length - 2) / 2;
                }, o = function(e) {
                    for(var t = [], r = 2, n = e.length; r < n; r += 2)t.push(parseInt(e.slice(r, r + 2), 16));
                    return t;
                }, a = function(e) {
                    for(var t = "0x", r = 0, n = e.length; r < n; ++r){
                        var i = e[r];
                        t += (i < 16 ? "0" : "") + i.toString(16);
                    }
                    return t;
                };
                e.exports = {
                    random: function(e) {
                        var t = void 0;
                        t = "undefined" != typeof window && window.crypto && window.crypto.getRandomValues ? window.crypto.getRandomValues(new Uint8Array(e)) : r(24293).randomBytes(e);
                        for(var n = "0x", i = 0; i < e; ++i)n += ("00" + t[i].toString(16)).slice(-2);
                        return n;
                    },
                    length: i,
                    concat: function(e, t) {
                        return e.concat(t.slice(2));
                    },
                    flatten: function(e) {
                        return "0x" + e.reduce(function(e, t) {
                            return e + t.slice(2);
                        }, "");
                    },
                    slice: function(e, t, r) {
                        return "0x" + r.slice(2 * e + 2, 2 * t + 2);
                    },
                    reverse: function(e) {
                        for(var t = "0x", r = 0, n = i(e); r < n; ++r)t += e.slice(2 * (n - r), 2 * (n - r + 1));
                        return t;
                    },
                    pad: function e(t, r) {
                        return r.length === 2 * t + 2 ? r : e(t, "0x0" + r.slice(2));
                    },
                    padRight: function e(t, r) {
                        return r.length === 2 * t + 2 ? r : e(t, r + "0");
                    },
                    fromAscii: function(e) {
                        for(var t = "0x", r = 0; r < e.length; ++r)t += ("00" + e.charCodeAt(r).toString(16)).slice(-2);
                        return t;
                    },
                    toAscii: function(e) {
                        for(var t = "", r = 2; r < e.length; r += 2)t += String.fromCharCode(parseInt(e.slice(r, r + 2), 16));
                        return t;
                    },
                    fromString: function(e) {
                        for(var t = function(e) {
                            var t = e.toString(16);
                            return t.length < 2 ? "0" + t : t;
                        }, r = "0x", n = 0; n != e.length; n++){
                            var i = e.charCodeAt(n);
                            if (i < 128) r += t(i);
                            else {
                                if (i < 2048) r += t(i >> 6 | 192);
                                else {
                                    if (i > 55295 && i < 56320) {
                                        if (++n == e.length) return null;
                                        var o = e.charCodeAt(n);
                                        if (o < 56320 || o > 57343) return null;
                                        r += t((i = 65536 + ((1023 & i) << 10) + (1023 & o)) >> 18 | 240), r += t(i >> 12 & 63 | 128);
                                    } else r += t(i >> 12 | 224);
                                    r += t(i >> 6 & 63 | 128);
                                }
                                r += t(63 & i | 128);
                            }
                        }
                        return r;
                    },
                    toString: function(e) {
                        for(var t = "", r = 0, o = i(e); r < o;){
                            var a = n(e, r++);
                            if (a > 127) {
                                if (a > 191 && a < 224) {
                                    if (r >= o) return null;
                                    a = (31 & a) << 6 | 63 & n(e, r);
                                } else if (a > 223 && a < 240) {
                                    if (r + 1 >= o) return null;
                                    a = (15 & a) << 12 | (63 & n(e, r)) << 6 | 63 & n(e, ++r);
                                } else {
                                    if (!(a > 239 && a < 248)) return null;
                                    if (r + 2 >= o) return null;
                                    a = (7 & a) << 18 | (63 & n(e, r)) << 12 | (63 & n(e, ++r)) << 6 | 63 & n(e, ++r);
                                }
                                ++r;
                            }
                            if (a <= 65535) t += String.fromCharCode(a);
                            else {
                                if (!(a <= 1114111)) return null;
                                a -= 65536, t += String.fromCharCode(a >> 10 | 55296), t += String.fromCharCode(1023 & a | 56320);
                            }
                        }
                        return t;
                    },
                    fromNumber: function(e) {
                        var t = e.toString(16);
                        return t.length % 2 == 0 ? "0x" + t : "0x0" + t;
                    },
                    toNumber: function(e) {
                        return parseInt(e.slice(2), 16);
                    },
                    fromNat: function(e) {
                        return "0x0" === e ? "0x" : e.length % 2 == 0 ? e : "0x0" + e.slice(2);
                    },
                    toNat: function(e) {
                        return "0" === e[2] ? "0x" + e.slice(3) : e;
                    },
                    fromArray: a,
                    toArray: o,
                    fromUint8Array: function(e) {
                        return a([].slice.call(e, 0));
                    },
                    toUint8Array: function(e) {
                        return new Uint8Array(o(e));
                    }
                };
            },
            49574: (e)=>{
                "use strict";
                var t = "0123456789abcdef".split(""), r = [
                    1,
                    256,
                    65536,
                    16777216
                ], n = [
                    0,
                    8,
                    16,
                    24
                ], i = [
                    1,
                    0,
                    32898,
                    0,
                    32906,
                    2147483648,
                    2147516416,
                    2147483648,
                    32907,
                    0,
                    2147483649,
                    0,
                    2147516545,
                    2147483648,
                    32777,
                    2147483648,
                    138,
                    0,
                    136,
                    0,
                    2147516425,
                    0,
                    2147483658,
                    0,
                    2147516555,
                    0,
                    139,
                    2147483648,
                    32905,
                    2147483648,
                    32771,
                    2147483648,
                    32770,
                    2147483648,
                    128,
                    2147483648,
                    32778,
                    0,
                    2147483658,
                    2147483648,
                    2147516545,
                    2147483648,
                    32896,
                    2147483648,
                    2147483649,
                    0,
                    2147516424,
                    2147483648
                ], o = function(e) {
                    var t, r, n, o, a, s, u, c, f, d, l, h, p, b, y, v, m, g, w, k, _, A, E, S, x, B, O, P, I, T, C, M, R, U, N, j, L, F, D, H, z, q, K, G, V, Z, W, J, Y, X, Q, $, ee, te, re, ne, ie, oe, ae, se, ue, ce, fe;
                    for(n = 0; n < 48; n += 2)o = e[0] ^ e[10] ^ e[20] ^ e[30] ^ e[40], a = e[1] ^ e[11] ^ e[21] ^ e[31] ^ e[41], s = e[2] ^ e[12] ^ e[22] ^ e[32] ^ e[42], u = e[3] ^ e[13] ^ e[23] ^ e[33] ^ e[43], c = e[4] ^ e[14] ^ e[24] ^ e[34] ^ e[44], f = e[5] ^ e[15] ^ e[25] ^ e[35] ^ e[45], d = e[6] ^ e[16] ^ e[26] ^ e[36] ^ e[46], l = e[7] ^ e[17] ^ e[27] ^ e[37] ^ e[47], t = (h = e[8] ^ e[18] ^ e[28] ^ e[38] ^ e[48]) ^ (s << 1 | u >>> 31), r = (p = e[9] ^ e[19] ^ e[29] ^ e[39] ^ e[49]) ^ (u << 1 | s >>> 31), e[0] ^= t, e[1] ^= r, e[10] ^= t, e[11] ^= r, e[20] ^= t, e[21] ^= r, e[30] ^= t, e[31] ^= r, e[40] ^= t, e[41] ^= r, t = o ^ (c << 1 | f >>> 31), r = a ^ (f << 1 | c >>> 31), e[2] ^= t, e[3] ^= r, e[12] ^= t, e[13] ^= r, e[22] ^= t, e[23] ^= r, e[32] ^= t, e[33] ^= r, e[42] ^= t, e[43] ^= r, t = s ^ (d << 1 | l >>> 31), r = u ^ (l << 1 | d >>> 31), e[4] ^= t, e[5] ^= r, e[14] ^= t, e[15] ^= r, e[24] ^= t, e[25] ^= r, e[34] ^= t, e[35] ^= r, e[44] ^= t, e[45] ^= r, t = c ^ (h << 1 | p >>> 31), r = f ^ (p << 1 | h >>> 31), e[6] ^= t, e[7] ^= r, e[16] ^= t, e[17] ^= r, e[26] ^= t, e[27] ^= r, e[36] ^= t, e[37] ^= r, e[46] ^= t, e[47] ^= r, t = d ^ (o << 1 | a >>> 31), r = l ^ (a << 1 | o >>> 31), e[8] ^= t, e[9] ^= r, e[18] ^= t, e[19] ^= r, e[28] ^= t, e[29] ^= r, e[38] ^= t, e[39] ^= r, e[48] ^= t, e[49] ^= r, b = e[0], y = e[1], Z = e[11] << 4 | e[10] >>> 28, W = e[10] << 4 | e[11] >>> 28, P = e[20] << 3 | e[21] >>> 29, I = e[21] << 3 | e[20] >>> 29, se = e[31] << 9 | e[30] >>> 23, ue = e[30] << 9 | e[31] >>> 23, q = e[40] << 18 | e[41] >>> 14, K = e[41] << 18 | e[40] >>> 14, U = e[2] << 1 | e[3] >>> 31, N = e[3] << 1 | e[2] >>> 31, v = e[13] << 12 | e[12] >>> 20, m = e[12] << 12 | e[13] >>> 20, J = e[22] << 10 | e[23] >>> 22, Y = e[23] << 10 | e[22] >>> 22, T = e[33] << 13 | e[32] >>> 19, C = e[32] << 13 | e[33] >>> 19, ce = e[42] << 2 | e[43] >>> 30, fe = e[43] << 2 | e[42] >>> 30, te = e[5] << 30 | e[4] >>> 2, re = e[4] << 30 | e[5] >>> 2, j = e[14] << 6 | e[15] >>> 26, L = e[15] << 6 | e[14] >>> 26, g = e[25] << 11 | e[24] >>> 21, w = e[24] << 11 | e[25] >>> 21, X = e[34] << 15 | e[35] >>> 17, Q = e[35] << 15 | e[34] >>> 17, M = e[45] << 29 | e[44] >>> 3, R = e[44] << 29 | e[45] >>> 3, S = e[6] << 28 | e[7] >>> 4, x = e[7] << 28 | e[6] >>> 4, ne = e[17] << 23 | e[16] >>> 9, ie = e[16] << 23 | e[17] >>> 9, F = e[26] << 25 | e[27] >>> 7, D = e[27] << 25 | e[26] >>> 7, k = e[36] << 21 | e[37] >>> 11, _ = e[37] << 21 | e[36] >>> 11, $ = e[47] << 24 | e[46] >>> 8, ee = e[46] << 24 | e[47] >>> 8, G = e[8] << 27 | e[9] >>> 5, V = e[9] << 27 | e[8] >>> 5, B = e[18] << 20 | e[19] >>> 12, O = e[19] << 20 | e[18] >>> 12, oe = e[29] << 7 | e[28] >>> 25, ae = e[28] << 7 | e[29] >>> 25, H = e[38] << 8 | e[39] >>> 24, z = e[39] << 8 | e[38] >>> 24, A = e[48] << 14 | e[49] >>> 18, E = e[49] << 14 | e[48] >>> 18, e[0] = b ^ ~v & g, e[1] = y ^ ~m & w, e[10] = S ^ ~B & P, e[11] = x ^ ~O & I, e[20] = U ^ ~j & F, e[21] = N ^ ~L & D, e[30] = G ^ ~Z & J, e[31] = V ^ ~W & Y, e[40] = te ^ ~ne & oe, e[41] = re ^ ~ie & ae, e[2] = v ^ ~g & k, e[3] = m ^ ~w & _, e[12] = B ^ ~P & T, e[13] = O ^ ~I & C, e[22] = j ^ ~F & H, e[23] = L ^ ~D & z, e[32] = Z ^ ~J & X, e[33] = W ^ ~Y & Q, e[42] = ne ^ ~oe & se, e[43] = ie ^ ~ae & ue, e[4] = g ^ ~k & A, e[5] = w ^ ~_ & E, e[14] = P ^ ~T & M, e[15] = I ^ ~C & R, e[24] = F ^ ~H & q, e[25] = D ^ ~z & K, e[34] = J ^ ~X & $, e[35] = Y ^ ~Q & ee, e[44] = oe ^ ~se & ce, e[45] = ae ^ ~ue & fe, e[6] = k ^ ~A & b, e[7] = _ ^ ~E & y, e[16] = T ^ ~M & S, e[17] = C ^ ~R & x, e[26] = H ^ ~q & U, e[27] = z ^ ~K & N, e[36] = X ^ ~$ & G, e[37] = Q ^ ~ee & V, e[46] = se ^ ~ce & te, e[47] = ue ^ ~fe & re, e[8] = A ^ ~b & v, e[9] = E ^ ~y & m, e[18] = M ^ ~S & B, e[19] = R ^ ~x & O, e[28] = q ^ ~U & j, e[29] = K ^ ~N & L, e[38] = $ ^ ~G & Z, e[39] = ee ^ ~V & W, e[48] = ce ^ ~te & ne, e[49] = fe ^ ~re & ie, e[0] ^= i[n], e[1] ^= i[n + 1];
                }, a = function(e) {
                    return function(i) {
                        var a;
                        if ("0x" === i.slice(0, 2)) {
                            a = [];
                            for(var s = 2, u = i.length; s < u; s += 2)a.push(parseInt(i.slice(s, s + 2), 16));
                        } else a = i;
                        return function(e, i) {
                            for(var a, s = i.length, u = e.blocks, c = e.blockCount << 2, f = e.blockCount, d = e.outputBlocks, l = e.s, h = 0; h < s;){
                                if (e.reset) for(e.reset = !1, u[0] = e.block, y = 1; y < f + 1; ++y)u[y] = 0;
                                if ("string" != typeof i) for(y = e.start; h < s && y < c; ++h)u[y >> 2] |= i[h] << n[3 & y++];
                                else for(y = e.start; h < s && y < c; ++h)(a = i.charCodeAt(h)) < 128 ? u[y >> 2] |= a << n[3 & y++] : a < 2048 ? (u[y >> 2] |= (192 | a >> 6) << n[3 & y++], u[y >> 2] |= (128 | 63 & a) << n[3 & y++]) : a < 55296 || a >= 57344 ? (u[y >> 2] |= (224 | a >> 12) << n[3 & y++], u[y >> 2] |= (128 | a >> 6 & 63) << n[3 & y++], u[y >> 2] |= (128 | 63 & a) << n[3 & y++]) : (a = 65536 + ((1023 & a) << 10 | 1023 & i.charCodeAt(++h)), u[y >> 2] |= (240 | a >> 18) << n[3 & y++], u[y >> 2] |= (128 | a >> 12 & 63) << n[3 & y++], u[y >> 2] |= (128 | a >> 6 & 63) << n[3 & y++], u[y >> 2] |= (128 | 63 & a) << n[3 & y++]);
                                if (e.lastByteIndex = y, y >= c) {
                                    for(e.start = y - c, e.block = u[f], y = 0; y < f; ++y)l[y] ^= u[y];
                                    o(l), e.reset = !0;
                                } else e.start = y;
                            }
                            if (u[(y = e.lastByteIndex) >> 2] |= r[3 & y], e.lastByteIndex === c) for(u[0] = u[f], y = 1; y < f + 1; ++y)u[y] = 0;
                            for(u[f - 1] |= 2147483648, y = 0; y < f; ++y)l[y] ^= u[y];
                            o(l);
                            for(var p, b = "", y = 0, v = 0; v < d;){
                                for(y = 0; y < f && v < d; ++y, ++v)p = l[y], b += t[p >> 4 & 15] + t[15 & p] + t[p >> 12 & 15] + t[p >> 8 & 15] + t[p >> 20 & 15] + t[p >> 16 & 15] + t[p >> 28 & 15] + t[p >> 24 & 15];
                                v % f == 0 && (o(l), y = 0);
                            }
                            return "0x" + b;
                        }(function(e) {
                            var t;
                            return {
                                blocks: [],
                                reset: !0,
                                block: 0,
                                start: 0,
                                blockCount: 1600 - (e << 1) >> 5,
                                outputBlocks: e >> 5,
                                s: (t = [
                                    0,
                                    0,
                                    0,
                                    0,
                                    0,
                                    0,
                                    0,
                                    0,
                                    0,
                                    0
                                ], [].concat(t, t, t, t, t))
                            };
                        }(e), a);
                    };
                };
                e.exports = {
                    keccak256: a(256),
                    keccak512: a(512),
                    keccak256s: a(256),
                    keccak512s: a(512)
                };
            },
            68419: (e)=>{
                "use strict";
                e.exports = function(e, t) {
                    if (t) {
                        t = (t = t.trim().replace(/^(\?|#|&)/, "")) ? "?" + t : t;
                        var r = e.split(/[\?\#]/)[0];
                        t && /\:\/\/[^\/]*$/.test(r) && (r += "/");
                        var n = e.match(/(\#.*)$/);
                        e = r + t, n && (e += n[0]);
                    }
                    return e;
                };
            },
            78677: (e, t, r)=>{
                "use strict";
                var n;
                e = r.nmd(e);
                var i = r(28847)(r(3355));
                !function(o) {
                    var a = "object" == (0, i.default)(t) && t && !t.nodeType && t, s = "object" == (0, i.default)(e) && e && !e.nodeType && e, u = "object" == (void 0 === r.g ? "undefined" : (0, i.default)(r.g)) && r.g;
                    u.global !== u && u.window !== u && u.self !== u || (o = u);
                    var c, f, d = 2147483647, l = 36, h = 1, p = 26, b = 38, y = 700, v = 72, m = 128, g = "-", w = /^xn--/, k = /[^\x20-\x7E]/, _ = /[\x2E\u3002\uFF0E\uFF61]/g, A = {
                        overflow: "Overflow: input needs wider integers to process",
                        "not-basic": "Illegal input >= 0x80 (not a basic code point)",
                        "invalid-input": "Invalid input"
                    }, E = l - h, S = Math.floor, x = String.fromCharCode;
                    function B(e) {
                        throw RangeError(A[e]);
                    }
                    function O(e, t) {
                        for(var r = e.length, n = []; r--;)n[r] = t(e[r]);
                        return n;
                    }
                    function P(e, t) {
                        var r = e.split("@"), n = "";
                        return r.length > 1 && (n = r[0] + "@", e = r[1]), n + O((e = e.replace(_, ".")).split("."), t).join(".");
                    }
                    function I(e) {
                        for(var t, r, n = [], i = 0, o = e.length; i < o;)(t = e.charCodeAt(i++)) >= 55296 && t <= 56319 && i < o ? 56320 == (64512 & (r = e.charCodeAt(i++))) ? n.push(((1023 & t) << 10) + (1023 & r) + 65536) : (n.push(t), i--) : n.push(t);
                        return n;
                    }
                    function T(e) {
                        return O(e, function(e) {
                            var t = "";
                            return e > 65535 && (t += x((e -= 65536) >>> 10 & 1023 | 55296), e = 56320 | 1023 & e), t + x(e);
                        }).join("");
                    }
                    function C(e, t) {
                        return e + 22 + 75 * (e < 26) - ((0 != t) << 5);
                    }
                    function M(e, t, r) {
                        var n = 0;
                        for(e = r ? S(e / y) : e >> 1, e += S(e / t); e > E * p >> 1; n += l)e = S(e / E);
                        return S(n + (E + 1) * e / (e + b));
                    }
                    function R(e) {
                        var t, r, n, i, o, a, s, u, c, f, b, y = [], w = e.length, k = 0, _ = m, A = v;
                        for((r = e.lastIndexOf(g)) < 0 && (r = 0), n = 0; n < r; ++n)e.charCodeAt(n) >= 128 && B("not-basic"), y.push(e.charCodeAt(n));
                        for(i = r > 0 ? r + 1 : 0; i < w;){
                            for(o = k, a = 1, s = l; i >= w && B("invalid-input"), ((u = (b = e.charCodeAt(i++)) - 48 < 10 ? b - 22 : b - 65 < 26 ? b - 65 : b - 97 < 26 ? b - 97 : l) >= l || u > S((d - k) / a)) && B("overflow"), k += u * a, !(u < (c = s <= A ? h : s >= A + p ? p : s - A)); s += l)a > S(d / (f = l - c)) && B("overflow"), a *= f;
                            A = M(k - o, t = y.length + 1, 0 == o), S(k / t) > d - _ && B("overflow"), _ += S(k / t), k %= t, y.splice(k++, 0, _);
                        }
                        return T(y);
                    }
                    function U(e) {
                        var t, r, n, i, o, a, s, u, c, f, b, y, w, k, _, A = [];
                        for(y = (e = I(e)).length, t = m, r = 0, o = v, a = 0; a < y; ++a)(b = e[a]) < 128 && A.push(x(b));
                        for(n = i = A.length, i && A.push(g); n < y;){
                            for(s = d, a = 0; a < y; ++a)(b = e[a]) >= t && b < s && (s = b);
                            for(s - t > S((d - r) / (w = n + 1)) && B("overflow"), r += (s - t) * w, t = s, a = 0; a < y; ++a)if ((b = e[a]) < t && ++r > d && B("overflow"), b == t) {
                                for(u = r, c = l; !(u < (f = c <= o ? h : c >= o + p ? p : c - o)); c += l)_ = u - f, k = l - f, A.push(x(C(f + _ % k, 0))), u = S(_ / k);
                                A.push(x(C(u, 0))), o = M(r, w, n == i), r = 0, ++n;
                            }
                            ++r, ++t;
                        }
                        return A.join("");
                    }
                    if (c = {
                        version: "1.3.2",
                        ucs2: {
                            decode: I,
                            encode: T
                        },
                        decode: R,
                        encode: U,
                        toASCII: function(e) {
                            return P(e, function(e) {
                                return k.test(e) ? "xn--" + U(e) : e;
                            });
                        },
                        toUnicode: function(e) {
                            return P(e, function(e) {
                                return w.test(e) ? R(e.slice(4).toLowerCase()) : e;
                            });
                        }
                    }, "object" == (0, i.default)(r.amdO) && r.amdO) void 0 === (n = (function() {
                        return c;
                    }).call(t, r, t, e)) || (e.exports = n);
                    else if (a && s) {
                        if (e.exports == a) s.exports = c;
                        else for(f in c)c.hasOwnProperty(f) && (a[f] = c[f]);
                    } else o.punycode = c;
                }(void 0);
            },
            98983: (e)=>{
                "use strict";
                function t(e, t) {
                    return Object.prototype.hasOwnProperty.call(e, t);
                }
                e.exports = function(e, r, n, i) {
                    r = r || "&", n = n || "=";
                    var o = {};
                    if ("string" != typeof e || 0 === e.length) return o;
                    var a = /\+/g;
                    e = e.split(r);
                    var s = 1e3;
                    i && "number" == typeof i.maxKeys && (s = i.maxKeys);
                    var u = e.length;
                    s > 0 && u > s && (u = s);
                    for(var c = 0; c < u; ++c){
                        var f, d, l, h, p = e[c].replace(a, "%20"), b = p.indexOf(n);
                        b >= 0 ? (f = p.substr(0, b), d = p.substr(b + 1)) : (f = p, d = ""), l = decodeURIComponent(f), h = decodeURIComponent(d), t(o, l) ? Array.isArray(o[l]) ? o[l].push(h) : o[l] = [
                            o[l],
                            h
                        ] : o[l] = h;
                    }
                    return o;
                };
            },
            84031: (e, t, r)=>{
                "use strict";
                var n = r(28847)(r(3355)), i = function(e) {
                    switch((0, n.default)(e)){
                        case "string":
                            return e;
                        case "boolean":
                            return e ? "true" : "false";
                        case "number":
                            return isFinite(e) ? e : "";
                        default:
                            return "";
                    }
                };
                e.exports = function(e, t, r, o) {
                    return t = t || "&", r = r || "=", null === e && (e = void 0), "object" === (0, n.default)(e) ? Object.keys(e).map(function(n) {
                        var o = encodeURIComponent(i(n)) + r;
                        return Array.isArray(e[n]) ? e[n].map(function(e) {
                            return o + encodeURIComponent(i(e));
                        }).join(t) : o + encodeURIComponent(i(e[n]));
                    }).join(t) : o ? encodeURIComponent(i(o)) + r + encodeURIComponent(i(e)) : "";
                };
            },
            845: (e, t, r)=>{
                "use strict";
                t.decode = t.parse = r(98983), t.encode = t.stringify = r(84031);
            },
            51143: (e, t, r)=>{
                "use strict";
                var n = r(28847)(r(3355)), i = r(78677), o = r(95751);
                function a() {
                    this.protocol = null, this.slashes = null, this.auth = null, this.host = null, this.port = null, this.hostname = null, this.hash = null, this.search = null, this.query = null, this.pathname = null, this.path = null, this.href = null;
                }
                t.parse = w, t.resolve = function(e, t) {
                    return w(e, !1, !0).resolve(t);
                }, t.resolveObject = function(e, t) {
                    return e ? w(e, !1, !0).resolveObject(t) : t;
                }, t.format = function(e) {
                    return o.isString(e) && (e = w(e)), e instanceof a ? e.format() : a.prototype.format.call(e);
                }, t.Url = a;
                var s = /^([a-z0-9.+-]+:)/i, u = /:[0-9]*$/, c = /^(\/\/?(?!\/)[^\?\s]*)(\?[^\s]*)?$/, f = [
                    "{",
                    "}",
                    "|",
                    "\\",
                    "^",
                    "`"
                ].concat([
                    "<",
                    ">",
                    '"',
                    "`",
                    " ",
                    "\r",
                    "\n",
                    "	"
                ]), d = [
                    "'"
                ].concat(f), l = [
                    "%",
                    "/",
                    "?",
                    ";",
                    "#"
                ].concat(d), h = [
                    "/",
                    "?",
                    "#"
                ], p = /^[+a-z0-9A-Z_-]{0,63}$/, b = /^([+a-z0-9A-Z_-]{0,63})(.*)$/, y = {
                    javascript: !0,
                    "javascript:": !0
                }, v = {
                    javascript: !0,
                    "javascript:": !0
                }, m = {
                    http: !0,
                    https: !0,
                    ftp: !0,
                    gopher: !0,
                    file: !0,
                    "http:": !0,
                    "https:": !0,
                    "ftp:": !0,
                    "gopher:": !0,
                    "file:": !0
                }, g = r(845);
                function w(e, t, r) {
                    if (e && o.isObject(e) && e instanceof a) return e;
                    var n = new a;
                    return n.parse(e, t, r), n;
                }
                a.prototype.parse = function(e, t, r) {
                    if (!o.isString(e)) throw new TypeError("Parameter 'url' must be a string, not " + (0, n.default)(e));
                    var a = e.indexOf("?"), u = -1 !== a && a < e.indexOf("#") ? "?" : "#", f = e.split(u);
                    f[0] = f[0].replace(/\\/g, "/");
                    var w = e = f.join(u);
                    if (w = w.trim(), !r && 1 === e.split("#").length) {
                        var k = c.exec(w);
                        if (k) return this.path = w, this.href = w, this.pathname = k[1], k[2] ? (this.search = k[2], this.query = t ? g.parse(this.search.substr(1)) : this.search.substr(1)) : t && (this.search = "", this.query = {}), this;
                    }
                    var _ = s.exec(w);
                    if (_) {
                        var A = (_ = _[0]).toLowerCase();
                        this.protocol = A, w = w.substr(_.length);
                    }
                    if (r || _ || w.match(/^\/\/[^@\/]+@[^@\/]+/)) {
                        var E = "//" === w.substr(0, 2);
                        !E || _ && v[_] || (w = w.substr(2), this.slashes = !0);
                    }
                    if (!v[_] && (E || _ && !m[_])) {
                        for(var S, x, B = -1, O = 0; O < h.length; O++)-1 !== (P = w.indexOf(h[O])) && (-1 === B || P < B) && (B = P);
                        for(-1 !== (x = -1 === B ? w.lastIndexOf("@") : w.lastIndexOf("@", B)) && (S = w.slice(0, x), w = w.slice(x + 1), this.auth = decodeURIComponent(S)), B = -1, O = 0; O < l.length; O++){
                            var P;
                            -1 !== (P = w.indexOf(l[O])) && (-1 === B || P < B) && (B = P);
                        }
                        -1 === B && (B = w.length), this.host = w.slice(0, B), w = w.slice(B), this.parseHost(), this.hostname = this.hostname || "";
                        var I = "[" === this.hostname[0] && "]" === this.hostname[this.hostname.length - 1];
                        if (!I) for(var T = this.hostname.split(/\./), C = (O = 0, T.length); O < C; O++){
                            var M = T[O];
                            if (M && !M.match(p)) {
                                for(var R = "", U = 0, N = M.length; U < N; U++)M.charCodeAt(U) > 127 ? R += "x" : R += M[U];
                                if (!R.match(p)) {
                                    var j = T.slice(0, O), L = T.slice(O + 1), F = M.match(b);
                                    F && (j.push(F[1]), L.unshift(F[2])), L.length && (w = "/" + L.join(".") + w), this.hostname = j.join(".");
                                    break;
                                }
                            }
                        }
                        this.hostname.length > 255 ? this.hostname = "" : this.hostname = this.hostname.toLowerCase(), I || (this.hostname = i.toASCII(this.hostname));
                        var D = this.port ? ":" + this.port : "", H = this.hostname || "";
                        this.host = H + D, this.href += this.host, I && (this.hostname = this.hostname.substr(1, this.hostname.length - 2), "/" !== w[0] && (w = "/" + w));
                    }
                    if (!y[A]) for(O = 0, C = d.length; O < C; O++){
                        var z = d[O];
                        if (-1 !== w.indexOf(z)) {
                            var q = encodeURIComponent(z);
                            q === z && (q = escape(z)), w = w.split(z).join(q);
                        }
                    }
                    var K = w.indexOf("#");
                    -1 !== K && (this.hash = w.substr(K), w = w.slice(0, K));
                    var G = w.indexOf("?");
                    if (-1 !== G ? (this.search = w.substr(G), this.query = w.substr(G + 1), t && (this.query = g.parse(this.query)), w = w.slice(0, G)) : t && (this.search = "", this.query = {}), w && (this.pathname = w), m[A] && this.hostname && !this.pathname && (this.pathname = "/"), this.pathname || this.search) {
                        D = this.pathname || "";
                        var V = this.search || "";
                        this.path = D + V;
                    }
                    return this.href = this.format(), this;
                }, a.prototype.format = function() {
                    var e = this.auth || "";
                    e && (e = (e = encodeURIComponent(e)).replace(/%3A/i, ":"), e += "@");
                    var t = this.protocol || "", r = this.pathname || "", n = this.hash || "", i = !1, a = "";
                    this.host ? i = e + this.host : this.hostname && (i = e + (-1 === this.hostname.indexOf(":") ? this.hostname : "[" + this.hostname + "]"), this.port && (i += ":" + this.port)), this.query && o.isObject(this.query) && Object.keys(this.query).length && (a = g.stringify(this.query));
                    var s = this.search || a && "?" + a || "";
                    return t && ":" !== t.substr(-1) && (t += ":"), this.slashes || (!t || m[t]) && !1 !== i ? (i = "//" + (i || ""), r && "/" !== r.charAt(0) && (r = "/" + r)) : i || (i = ""), n && "#" !== n.charAt(0) && (n = "#" + n), s && "?" !== s.charAt(0) && (s = "?" + s), t + i + (r = r.replace(/[?#]/g, function(e) {
                        return encodeURIComponent(e);
                    })) + (s = s.replace("#", "%23")) + n;
                }, a.prototype.resolve = function(e) {
                    return this.resolveObject(w(e, !1, !0)).format();
                }, a.prototype.resolveObject = function(e) {
                    if (o.isString(e)) {
                        var t = new a;
                        t.parse(e, !1, !0), e = t;
                    }
                    for(var r = new a, n = Object.keys(this), i = 0; i < n.length; i++){
                        var s = n[i];
                        r[s] = this[s];
                    }
                    if (r.hash = e.hash, "" === e.href) return r.href = r.format(), r;
                    if (e.slashes && !e.protocol) {
                        for(var u = Object.keys(e), c = 0; c < u.length; c++){
                            var f = u[c];
                            "protocol" !== f && (r[f] = e[f]);
                        }
                        return m[r.protocol] && r.hostname && !r.pathname && (r.path = r.pathname = "/"), r.href = r.format(), r;
                    }
                    if (e.protocol && e.protocol !== r.protocol) {
                        if (!m[e.protocol]) {
                            for(var d = Object.keys(e), l = 0; l < d.length; l++){
                                var h = d[l];
                                r[h] = e[h];
                            }
                            return r.href = r.format(), r;
                        }
                        if (r.protocol = e.protocol, e.host || v[e.protocol]) r.pathname = e.pathname;
                        else {
                            for(var p = (e.pathname || "").split("/"); p.length && !(e.host = p.shift()););
                            e.host || (e.host = ""), e.hostname || (e.hostname = ""), "" !== p[0] && p.unshift(""), p.length < 2 && p.unshift(""), r.pathname = p.join("/");
                        }
                        if (r.search = e.search, r.query = e.query, r.host = e.host || "", r.auth = e.auth, r.hostname = e.hostname || e.host, r.port = e.port, r.pathname || r.search) {
                            var b = r.pathname || "", y = r.search || "";
                            r.path = b + y;
                        }
                        return r.slashes = r.slashes || e.slashes, r.href = r.format(), r;
                    }
                    var g = r.pathname && "/" === r.pathname.charAt(0), w = e.host || e.pathname && "/" === e.pathname.charAt(0), k = w || g || r.host && e.pathname, _ = k, A = r.pathname && r.pathname.split("/") || [], E = (p = e.pathname && e.pathname.split("/") || [], r.protocol && !m[r.protocol]);
                    if (E && (r.hostname = "", r.port = null, r.host && ("" === A[0] ? A[0] = r.host : A.unshift(r.host)), r.host = "", e.protocol && (e.hostname = null, e.port = null, e.host && ("" === p[0] ? p[0] = e.host : p.unshift(e.host)), e.host = null), k = k && ("" === p[0] || "" === A[0])), w) r.host = e.host || "" === e.host ? e.host : r.host, r.hostname = e.hostname || "" === e.hostname ? e.hostname : r.hostname, r.search = e.search, r.query = e.query, A = p;
                    else if (p.length) A || (A = []), A.pop(), A = A.concat(p), r.search = e.search, r.query = e.query;
                    else if (!o.isNullOrUndefined(e.search)) return E && (r.hostname = r.host = A.shift(), (P = !!(r.host && r.host.indexOf("@") > 0) && r.host.split("@")) && (r.auth = P.shift(), r.host = r.hostname = P.shift())), r.search = e.search, r.query = e.query, o.isNull(r.pathname) && o.isNull(r.search) || (r.path = (r.pathname ? r.pathname : "") + (r.search ? r.search : "")), r.href = r.format(), r;
                    if (!A.length) return r.pathname = null, r.search ? r.path = "/" + r.search : r.path = null, r.href = r.format(), r;
                    for(var S = A.slice(-1)[0], x = (r.host || e.host || A.length > 1) && ("." === S || ".." === S) || "" === S, B = 0, O = A.length; O >= 0; O--)"." === (S = A[O]) ? A.splice(O, 1) : ".." === S ? (A.splice(O, 1), B++) : B && (A.splice(O, 1), B--);
                    if (!k && !_) for(; B--; B)A.unshift("..");
                    !k || "" === A[0] || A[0] && "/" === A[0].charAt(0) || A.unshift(""), x && "/" !== A.join("/").substr(-1) && A.push("");
                    var P, I = "" === A[0] || A[0] && "/" === A[0].charAt(0);
                    return E && (r.hostname = r.host = I ? "" : A.length ? A.shift() : "", (P = !!(r.host && r.host.indexOf("@") > 0) && r.host.split("@")) && (r.auth = P.shift(), r.host = r.hostname = P.shift())), (k = k || r.host && A.length) && !I && A.unshift(""), A.length ? r.pathname = A.join("/") : (r.pathname = null, r.path = null), o.isNull(r.pathname) && o.isNull(r.search) || (r.path = (r.pathname ? r.pathname : "") + (r.search ? r.search : "")), r.auth = e.auth || r.auth, r.slashes = r.slashes || e.slashes, r.href = r.format(), r;
                }, a.prototype.parseHost = function() {
                    var e = this.host, t = u.exec(e);
                    t && (":" !== (t = t[0]) && (this.port = t.substr(1)), e = e.substr(0, e.length - t.length)), e && (this.hostname = e);
                };
            },
            95751: (e, t, r)=>{
                "use strict";
                var n = r(28847)(r(3355));
                e.exports = {
                    isString: function(e) {
                        return "string" == typeof e;
                    },
                    isObject: function(e) {
                        return "object" === (0, n.default)(e) && null !== e;
                    },
                    isNull: function(e) {
                        return null === e;
                    },
                    isNullOrUndefined: function(e) {
                        return null == e;
                    }
                };
            },
            88632: (e, t)=>{
                "use strict";
                !function(e) {
                    var t, r, n, i = String.fromCharCode;
                    function o(e) {
                        for(var t, r, n = [], i = 0, o = e.length; i < o;)(t = e.charCodeAt(i++)) >= 55296 && t <= 56319 && i < o ? 56320 == (64512 & (r = e.charCodeAt(i++))) ? n.push(((1023 & t) << 10) + (1023 & r) + 65536) : (n.push(t), i--) : n.push(t);
                        return n;
                    }
                    function a(e) {
                        if (e >= 55296 && e <= 57343) throw Error("Lone surrogate U+" + e.toString(16).toUpperCase() + " is not a scalar value");
                    }
                    function s(e, t) {
                        return i(e >> t & 63 | 128);
                    }
                    function u(e) {
                        if (0 == (4294967168 & e)) return i(e);
                        var t = "";
                        return 0 == (4294965248 & e) ? t = i(e >> 6 & 31 | 192) : 0 == (4294901760 & e) ? (a(e), t = i(e >> 12 & 15 | 224), t += s(e, 6)) : 0 == (4292870144 & e) && (t = i(e >> 18 & 7 | 240), t += s(e, 12), t += s(e, 6)), t + i(63 & e | 128);
                    }
                    function c() {
                        if (n >= r) throw Error("Invalid byte index");
                        var e = 255 & t[n];
                        if (n++, 128 == (192 & e)) return 63 & e;
                        throw Error("Invalid continuation byte");
                    }
                    function f() {
                        var e, i;
                        if (n > r) throw Error("Invalid byte index");
                        if (n == r) return !1;
                        if (e = 255 & t[n], n++, 0 == (128 & e)) return e;
                        if (192 == (224 & e)) {
                            if ((i = (31 & e) << 6 | c()) >= 128) return i;
                            throw Error("Invalid continuation byte");
                        }
                        if (224 == (240 & e)) {
                            if ((i = (15 & e) << 12 | c() << 6 | c()) >= 2048) return a(i), i;
                            throw Error("Invalid continuation byte");
                        }
                        if (240 == (248 & e) && (i = (7 & e) << 18 | c() << 12 | c() << 6 | c()) >= 65536 && i <= 1114111) return i;
                        throw Error("Invalid UTF-8 detected");
                    }
                    e.version = "3.0.0", e.encode = function(e) {
                        for(var t = o(e), r = t.length, n = -1, i = ""; ++n < r;)i += u(t[n]);
                        return i;
                    }, e.decode = function(e) {
                        t = o(e), r = t.length, n = 0;
                        for(var a, s = []; !1 !== (a = f());)s.push(a);
                        return function(e) {
                            for(var t, r = e.length, n = -1, o = ""; ++n < r;)(t = e[n]) > 65535 && (o += i((t -= 65536) >>> 10 & 1023 | 55296), t = 56320 | 1023 & t), o += i(t);
                            return o;
                        }(s);
                    };
                }(t);
            },
            96219: (e, t, r)=>{
                "use strict";
                function n(e) {
                    try {
                        if (!r.g.localStorage) return !1;
                    } catch (e) {
                        return !1;
                    }
                    var t = r.g.localStorage[e];
                    return null != t && "true" === String(t).toLowerCase();
                }
                e.exports = function(e, t) {
                    if (n("noDeprecation")) return e;
                    var r = !1;
                    return function() {
                        if (!r) {
                            if (n("throwDeprecation")) throw new Error(t);
                            n("traceDeprecation") ? console.trace(t) : console.warn(t), r = !0;
                        }
                        return e.apply(this, arguments);
                    };
                };
            },
            16248: (e, t, r)=>{
                "use strict";
                var n = r(28847)(r(3355));
                e.exports = function(e) {
                    return e && "object" === (0, n.default)(e) && "function" == typeof e.copy && "function" == typeof e.fill && "function" == typeof e.readUInt8;
                };
            },
            17092: (e, t, r)=>{
                "use strict";
                var n = r(28847)(r(3355)), i = r(69446), o = r(14477), a = r(72337), s = r(28915);
                function u(e) {
                    return e.call.bind(e);
                }
                var c = "undefined" != typeof BigInt, f = "undefined" != typeof Symbol, d = u(Object.prototype.toString), l = u(Number.prototype.valueOf), h = u(String.prototype.valueOf), p = u(Boolean.prototype.valueOf);
                if (c) var b = u(BigInt.prototype.valueOf);
                if (f) var y = u(Symbol.prototype.valueOf);
                function v(e, t) {
                    if ("object" !== (0, n.default)(e)) return !1;
                    try {
                        return t(e), !0;
                    } catch (e) {
                        return !1;
                    }
                }
                function m(e) {
                    return "[object Map]" === d(e);
                }
                function g(e) {
                    return "[object Set]" === d(e);
                }
                function w(e) {
                    return "[object WeakMap]" === d(e);
                }
                function k(e) {
                    return "[object WeakSet]" === d(e);
                }
                function _(e) {
                    return "[object ArrayBuffer]" === d(e);
                }
                function A(e) {
                    return "undefined" != typeof ArrayBuffer && (_.working ? _(e) : e instanceof ArrayBuffer);
                }
                function E(e) {
                    return "[object DataView]" === d(e);
                }
                function S(e) {
                    return "undefined" != typeof DataView && (E.working ? E(e) : e instanceof DataView);
                }
                t.isArgumentsObject = i, t.isGeneratorFunction = o, t.isTypedArray = s, t.isPromise = function(e) {
                    return "undefined" != typeof Promise && e instanceof Promise || null !== e && "object" === (0, n.default)(e) && "function" == typeof e.then && "function" == typeof e.catch;
                }, t.isArrayBufferView = function(e) {
                    return "undefined" != typeof ArrayBuffer && ArrayBuffer.isView ? ArrayBuffer.isView(e) : s(e) || S(e);
                }, t.isUint8Array = function(e) {
                    return "Uint8Array" === a(e);
                }, t.isUint8ClampedArray = function(e) {
                    return "Uint8ClampedArray" === a(e);
                }, t.isUint16Array = function(e) {
                    return "Uint16Array" === a(e);
                }, t.isUint32Array = function(e) {
                    return "Uint32Array" === a(e);
                }, t.isInt8Array = function(e) {
                    return "Int8Array" === a(e);
                }, t.isInt16Array = function(e) {
                    return "Int16Array" === a(e);
                }, t.isInt32Array = function(e) {
                    return "Int32Array" === a(e);
                }, t.isFloat32Array = function(e) {
                    return "Float32Array" === a(e);
                }, t.isFloat64Array = function(e) {
                    return "Float64Array" === a(e);
                }, t.isBigInt64Array = function(e) {
                    return "BigInt64Array" === a(e);
                }, t.isBigUint64Array = function(e) {
                    return "BigUint64Array" === a(e);
                }, m.working = "undefined" != typeof Map && m(new Map), t.isMap = function(e) {
                    return "undefined" != typeof Map && (m.working ? m(e) : e instanceof Map);
                }, g.working = "undefined" != typeof Set && g(new Set), t.isSet = function(e) {
                    return "undefined" != typeof Set && (g.working ? g(e) : e instanceof Set);
                }, w.working = "undefined" != typeof WeakMap && w(new WeakMap), t.isWeakMap = function(e) {
                    return "undefined" != typeof WeakMap && (w.working ? w(e) : e instanceof WeakMap);
                }, k.working = "undefined" != typeof WeakSet && k(new WeakSet), t.isWeakSet = function(e) {
                    return k(e);
                }, _.working = "undefined" != typeof ArrayBuffer && _(new ArrayBuffer), t.isArrayBuffer = A, E.working = "undefined" != typeof ArrayBuffer && "undefined" != typeof DataView && E(new DataView(new ArrayBuffer(1), 0, 1)), t.isDataView = S;
                var x = "undefined" != typeof SharedArrayBuffer ? SharedArrayBuffer : void 0;
                function B(e) {
                    return "[object SharedArrayBuffer]" === d(e);
                }
                function O(e) {
                    return void 0 !== x && (void 0 === B.working && (B.working = B(new x)), B.working ? B(e) : e instanceof x);
                }
                function P(e) {
                    return v(e, l);
                }
                function I(e) {
                    return v(e, h);
                }
                function T(e) {
                    return v(e, p);
                }
                function C(e) {
                    return c && v(e, b);
                }
                function M(e) {
                    return f && v(e, y);
                }
                t.isSharedArrayBuffer = O, t.isAsyncFunction = function(e) {
                    return "[object AsyncFunction]" === d(e);
                }, t.isMapIterator = function(e) {
                    return "[object Map Iterator]" === d(e);
                }, t.isSetIterator = function(e) {
                    return "[object Set Iterator]" === d(e);
                }, t.isGeneratorObject = function(e) {
                    return "[object Generator]" === d(e);
                }, t.isWebAssemblyCompiledModule = function(e) {
                    return "[object WebAssembly.Module]" === d(e);
                }, t.isNumberObject = P, t.isStringObject = I, t.isBooleanObject = T, t.isBigIntObject = C, t.isSymbolObject = M, t.isBoxedPrimitive = function(e) {
                    return P(e) || I(e) || T(e) || C(e) || M(e);
                }, t.isAnyArrayBuffer = function(e) {
                    return "undefined" != typeof Uint8Array && (A(e) || O(e));
                }, [
                    "isProxy",
                    "isExternal",
                    "isModuleNamespaceObject"
                ].forEach(function(e) {
                    Object.defineProperty(t, e, {
                        enumerable: !1,
                        value: function() {
                            throw new Error(e + " is not supported in userland");
                        }
                    });
                });
            },
            45058: (e, t, r)=>{
                "use strict";
                var n = r(19142), i = r(28847)(r(3355)), o = Object.getOwnPropertyDescriptors || function(e) {
                    for(var t = Object.keys(e), r = {}, n = 0; n < t.length; n++)r[t[n]] = Object.getOwnPropertyDescriptor(e, t[n]);
                    return r;
                }, a = /%[sdj%]/g;
                t.format = function(e) {
                    if (!w(e)) {
                        for(var t = [], r = 0; r < arguments.length; r++)t.push(f(arguments[r]));
                        return t.join(" ");
                    }
                    r = 1;
                    for(var n = arguments, i = n.length, o = String(e).replace(a, function(e) {
                        if ("%%" === e) return "%";
                        if (r >= i) return e;
                        switch(e){
                            case "%s":
                                return String(n[r++]);
                            case "%d":
                                return Number(n[r++]);
                            case "%j":
                                try {
                                    return JSON.stringify(n[r++]);
                                } catch (e) {
                                    return "[Circular]";
                                }
                            default:
                                return e;
                        }
                    }), s = n[r]; r < i; s = n[++r])m(s) || !A(s) ? o += " " + s : o += " " + f(s);
                    return o;
                }, t.deprecate = function(e, r) {
                    if (void 0 !== n && !0 === n.noDeprecation) return e;
                    if (void 0 === n) return function() {
                        return t.deprecate(e, r).apply(this, arguments);
                    };
                    var i = !1;
                    return function() {
                        if (!i) {
                            if (n.throwDeprecation) throw new Error(r);
                            n.traceDeprecation ? console.trace(r) : console.error(r), i = !0;
                        }
                        return e.apply(this, arguments);
                    };
                };
                var s = {}, u = /^$/;
                if (n.env.NODE_DEBUG) {
                    var c = n.env.NODE_DEBUG;
                    c = c.replace(/[|\\{}()[\]^$+?.]/g, "\\$&").replace(/\*/g, ".*").replace(/,/g, "$|^").toUpperCase(), u = new RegExp("^" + c + "$", "i");
                }
                function f(e, r) {
                    var n = {
                        seen: [],
                        stylize: l
                    };
                    return arguments.length >= 3 && (n.depth = arguments[2]), arguments.length >= 4 && (n.colors = arguments[3]), v(r) ? n.showHidden = r : r && t._extend(n, r), k(n.showHidden) && (n.showHidden = !1), k(n.depth) && (n.depth = 2), k(n.colors) && (n.colors = !1), k(n.customInspect) && (n.customInspect = !0), n.colors && (n.stylize = d), h(n, e, n.depth);
                }
                function d(e, t) {
                    var r = f.styles[t];
                    return r ? "\x1b[" + f.colors[r][0] + "m" + e + "\x1b[" + f.colors[r][1] + "m" : e;
                }
                function l(e, t) {
                    return e;
                }
                function h(e, r, n) {
                    if (e.customInspect && r && x(r.inspect) && r.inspect !== t.inspect && (!r.constructor || r.constructor.prototype !== r)) {
                        var i = r.inspect(n, e);
                        return w(i) || (i = h(e, i, n)), i;
                    }
                    var o = function(e, t) {
                        if (k(t)) return e.stylize("undefined", "undefined");
                        if (w(t)) {
                            var r = "'" + JSON.stringify(t).replace(/^"|"$/g, "").replace(/'/g, "\\'").replace(/\\"/g, '"') + "'";
                            return e.stylize(r, "string");
                        }
                        return g(t) ? e.stylize("" + t, "number") : v(t) ? e.stylize("" + t, "boolean") : m(t) ? e.stylize("null", "null") : void 0;
                    }(e, r);
                    if (o) return o;
                    var a = Object.keys(r), s = function(e) {
                        var t = {};
                        return e.forEach(function(e, r) {
                            t[e] = !0;
                        }), t;
                    }(a);
                    if (e.showHidden && (a = Object.getOwnPropertyNames(r)), S(r) && (a.indexOf("message") >= 0 || a.indexOf("description") >= 0)) return p(r);
                    if (0 === a.length) {
                        if (x(r)) {
                            var u = r.name ? ": " + r.name : "";
                            return e.stylize("[Function" + u + "]", "special");
                        }
                        if (_(r)) return e.stylize(RegExp.prototype.toString.call(r), "regexp");
                        if (E(r)) return e.stylize(Date.prototype.toString.call(r), "date");
                        if (S(r)) return p(r);
                    }
                    var c, f = "", d = !1, l = [
                        "{",
                        "}"
                    ];
                    return y(r) && (d = !0, l = [
                        "[",
                        "]"
                    ]), x(r) && (f = " [Function" + (r.name ? ": " + r.name : "") + "]"), _(r) && (f = " " + RegExp.prototype.toString.call(r)), E(r) && (f = " " + Date.prototype.toUTCString.call(r)), S(r) && (f = " " + p(r)), 0 !== a.length || d && 0 != r.length ? n < 0 ? _(r) ? e.stylize(RegExp.prototype.toString.call(r), "regexp") : e.stylize("[Object]", "special") : (e.seen.push(r), c = d ? function(e, t, r, n, i) {
                        for(var o = [], a = 0, s = t.length; a < s; ++a)I(t, String(a)) ? o.push(b(e, t, r, n, String(a), !0)) : o.push("");
                        return i.forEach(function(i) {
                            i.match(/^\d+$/) || o.push(b(e, t, r, n, i, !0));
                        }), o;
                    }(e, r, n, s, a) : a.map(function(t) {
                        return b(e, r, n, s, t, d);
                    }), e.seen.pop(), function(e, t, r) {
                        return e.reduce(function(e, t) {
                            return t.indexOf("\n"), e + t.replace(/\u001b\[\d\d?m/g, "").length + 1;
                        }, 0) > 60 ? r[0] + ("" === t ? "" : t + "\n ") + " " + e.join(",\n  ") + " " + r[1] : r[0] + t + " " + e.join(", ") + " " + r[1];
                    }(c, f, l)) : l[0] + f + l[1];
                }
                function p(e) {
                    return "[" + Error.prototype.toString.call(e) + "]";
                }
                function b(e, t, r, n, i, o) {
                    var a, s, u;
                    if ((u = Object.getOwnPropertyDescriptor(t, i) || {
                        value: t[i]
                    }).get ? s = u.set ? e.stylize("[Getter/Setter]", "special") : e.stylize("[Getter]", "special") : u.set && (s = e.stylize("[Setter]", "special")), I(n, i) || (a = "[" + i + "]"), s || (e.seen.indexOf(u.value) < 0 ? (s = m(r) ? h(e, u.value, null) : h(e, u.value, r - 1)).indexOf("\n") > -1 && (s = o ? s.split("\n").map(function(e) {
                        return "  " + e;
                    }).join("\n").slice(2) : "\n" + s.split("\n").map(function(e) {
                        return "   " + e;
                    }).join("\n")) : s = e.stylize("[Circular]", "special")), k(a)) {
                        if (o && i.match(/^\d+$/)) return s;
                        (a = JSON.stringify("" + i)).match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/) ? (a = a.slice(1, -1), a = e.stylize(a, "name")) : (a = a.replace(/'/g, "\\'").replace(/\\"/g, '"').replace(/(^"|"$)/g, "'"), a = e.stylize(a, "string"));
                    }
                    return a + ": " + s;
                }
                function y(e) {
                    return Array.isArray(e);
                }
                function v(e) {
                    return "boolean" == typeof e;
                }
                function m(e) {
                    return null === e;
                }
                function g(e) {
                    return "number" == typeof e;
                }
                function w(e) {
                    return "string" == typeof e;
                }
                function k(e) {
                    return void 0 === e;
                }
                function _(e) {
                    return A(e) && "[object RegExp]" === B(e);
                }
                function A(e) {
                    return "object" === (0, i.default)(e) && null !== e;
                }
                function E(e) {
                    return A(e) && "[object Date]" === B(e);
                }
                function S(e) {
                    return A(e) && ("[object Error]" === B(e) || e instanceof Error);
                }
                function x(e) {
                    return "function" == typeof e;
                }
                function B(e) {
                    return Object.prototype.toString.call(e);
                }
                function O(e) {
                    return e < 10 ? "0" + e.toString(10) : e.toString(10);
                }
                t.debuglog = function(e) {
                    if (e = e.toUpperCase(), !s[e]) {
                        if (u.test(e)) {
                            var r = n.pid;
                            s[e] = function() {
                                var n = t.format.apply(t, arguments);
                                console.error("%s %d: %s", e, r, n);
                            };
                        } else s[e] = function() {};
                    }
                    return s[e];
                }, t.inspect = f, f.colors = {
                    bold: [
                        1,
                        22
                    ],
                    italic: [
                        3,
                        23
                    ],
                    underline: [
                        4,
                        24
                    ],
                    inverse: [
                        7,
                        27
                    ],
                    white: [
                        37,
                        39
                    ],
                    grey: [
                        90,
                        39
                    ],
                    black: [
                        30,
                        39
                    ],
                    blue: [
                        34,
                        39
                    ],
                    cyan: [
                        36,
                        39
                    ],
                    green: [
                        32,
                        39
                    ],
                    magenta: [
                        35,
                        39
                    ],
                    red: [
                        31,
                        39
                    ],
                    yellow: [
                        33,
                        39
                    ]
                }, f.styles = {
                    special: "cyan",
                    number: "yellow",
                    boolean: "yellow",
                    undefined: "grey",
                    null: "bold",
                    string: "green",
                    date: "magenta",
                    regexp: "red"
                }, t.types = r(17092), t.isArray = y, t.isBoolean = v, t.isNull = m, t.isNullOrUndefined = function(e) {
                    return null == e;
                }, t.isNumber = g, t.isString = w, t.isSymbol = function(e) {
                    return "symbol" === (0, i.default)(e);
                }, t.isUndefined = k, t.isRegExp = _, t.types.isRegExp = _, t.isObject = A, t.isDate = E, t.types.isDate = E, t.isError = S, t.types.isNativeError = S, t.isFunction = x, t.isPrimitive = function(e) {
                    return null === e || "boolean" == typeof e || "number" == typeof e || "string" == typeof e || "symbol" === (0, i.default)(e) || void 0 === e;
                }, t.isBuffer = r(16248);
                var P = [
                    "Jan",
                    "Feb",
                    "Mar",
                    "Apr",
                    "May",
                    "Jun",
                    "Jul",
                    "Aug",
                    "Sep",
                    "Oct",
                    "Nov",
                    "Dec"
                ];
                function I(e, t) {
                    return Object.prototype.hasOwnProperty.call(e, t);
                }
                t.log = function() {
                    var e, r;
                    console.log("%s - %s", (r = [
                        O((e = new Date).getHours()),
                        O(e.getMinutes()),
                        O(e.getSeconds())
                    ].join(":"), [
                        e.getDate(),
                        P[e.getMonth()],
                        r
                    ].join(" ")), t.format.apply(t, arguments));
                }, t.inherits = r(41736), t._extend = function(e, t) {
                    if (!t || !A(t)) return e;
                    for(var r = Object.keys(t), n = r.length; n--;)e[r[n]] = t[r[n]];
                    return e;
                };
                var T = "undefined" != typeof Symbol ? Symbol("util.promisify.custom") : void 0;
                function C(e, t) {
                    if (!e) {
                        var r = new Error("Promise was rejected with a falsy value");
                        r.reason = e, e = r;
                    }
                    return t(e);
                }
                t.promisify = function(e) {
                    if ("function" != typeof e) throw new TypeError('The "original" argument must be of type Function');
                    if (T && e[T]) {
                        var t;
                        if ("function" != typeof (t = e[T])) throw new TypeError('The "util.promisify.custom" argument must be of type Function');
                        return Object.defineProperty(t, T, {
                            value: t,
                            enumerable: !1,
                            writable: !1,
                            configurable: !0
                        }), t;
                    }
                    function t() {
                        for(var t, r, n = new Promise(function(e, n) {
                            t = e, r = n;
                        }), i = [], o = 0; o < arguments.length; o++)i.push(arguments[o]);
                        i.push(function(e, n) {
                            e ? r(e) : t(n);
                        });
                        try {
                            e.apply(this, i);
                        } catch (e) {
                            r(e);
                        }
                        return n;
                    }
                    return Object.setPrototypeOf(t, Object.getPrototypeOf(e)), T && Object.defineProperty(t, T, {
                        value: t,
                        enumerable: !1,
                        writable: !1,
                        configurable: !0
                    }), Object.defineProperties(t, o(e));
                }, t.promisify.custom = T, t.callbackify = function(e) {
                    if ("function" != typeof e) throw new TypeError('The "original" argument must be of type Function');
                    function t() {
                        for(var t = [], r = 0; r < arguments.length; r++)t.push(arguments[r]);
                        var i = t.pop();
                        if ("function" != typeof i) throw new TypeError("The last argument must be of type Function");
                        var o = this, a = function() {
                            return i.apply(o, arguments);
                        };
                        e.apply(this, t).then(function(e) {
                            n.nextTick(a.bind(null, null, e));
                        }, function(e) {
                            n.nextTick(C.bind(null, e, a));
                        });
                    }
                    return Object.setPrototypeOf(t, Object.getPrototypeOf(e)), Object.defineProperties(t, o(e)), t;
                };
            },
            22679: (e, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), Object.defineProperty(t, "NIL", {
                    enumerable: !0,
                    get: function() {
                        return s.default;
                    }
                }), Object.defineProperty(t, "parse", {
                    enumerable: !0,
                    get: function() {
                        return d.default;
                    }
                }), Object.defineProperty(t, "stringify", {
                    enumerable: !0,
                    get: function() {
                        return f.default;
                    }
                }), Object.defineProperty(t, "v1", {
                    enumerable: !0,
                    get: function() {
                        return n.default;
                    }
                }), Object.defineProperty(t, "v3", {
                    enumerable: !0,
                    get: function() {
                        return i.default;
                    }
                }), Object.defineProperty(t, "v4", {
                    enumerable: !0,
                    get: function() {
                        return o.default;
                    }
                }), Object.defineProperty(t, "v5", {
                    enumerable: !0,
                    get: function() {
                        return a.default;
                    }
                }), Object.defineProperty(t, "validate", {
                    enumerable: !0,
                    get: function() {
                        return c.default;
                    }
                }), Object.defineProperty(t, "version", {
                    enumerable: !0,
                    get: function() {
                        return u.default;
                    }
                });
                var n = l(r(55999)), i = l(r(28231)), o = l(r(78647)), a = l(r(65025)), s = l(r(55996)), u = l(r(8928)), c = l(r(76163)), f = l(r(22982)), d = l(r(91729));
                function l(e) {
                    return e && e.__esModule ? e : {
                        default: e
                    };
                }
            },
            86792: (e, t)=>{
                "use strict";
                function r(e) {
                    return 14 + (e + 64 >>> 9 << 4) + 1;
                }
                function n(e, t) {
                    var r = (65535 & e) + (65535 & t);
                    return (e >> 16) + (t >> 16) + (r >> 16) << 16 | 65535 & r;
                }
                function i(e, t, r, i, o, a) {
                    var s, u;
                    return n((s = n(n(t, e), n(i, a))) << (u = o) | s >>> 32 - u, r);
                }
                function o(e, t, r, n, o, a, s) {
                    return i(t & r | ~t & n, e, t, o, a, s);
                }
                function a(e, t, r, n, o, a, s) {
                    return i(t & n | r & ~n, e, t, o, a, s);
                }
                function s(e, t, r, n, o, a, s) {
                    return i(t ^ r ^ n, e, t, o, a, s);
                }
                function u(e, t, r, n, o, a, s) {
                    return i(r ^ (t | ~n), e, t, o, a, s);
                }
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.default = void 0;
                t.default = function(e) {
                    if ("string" == typeof e) {
                        var t = unescape(encodeURIComponent(e));
                        e = new Uint8Array(t.length);
                        for(var i = 0; i < t.length; ++i)e[i] = t.charCodeAt(i);
                    }
                    return function(e) {
                        for(var t = [], r = 32 * e.length, n = "0123456789abcdef", i = 0; i < r; i += 8){
                            var o = e[i >> 5] >>> i % 32 & 255, a = parseInt(n.charAt(o >>> 4 & 15) + n.charAt(15 & o), 16);
                            t.push(a);
                        }
                        return t;
                    }(function(e, t) {
                        e[t >> 5] |= 128 << t % 32, e[r(t) - 1] = t;
                        for(var i = 1732584193, c = -271733879, f = -1732584194, d = 271733878, l = 0; l < e.length; l += 16){
                            var h = i, p = c, b = f, y = d;
                            i = o(i, c, f, d, e[l], 7, -680876936), d = o(d, i, c, f, e[l + 1], 12, -389564586), f = o(f, d, i, c, e[l + 2], 17, 606105819), c = o(c, f, d, i, e[l + 3], 22, -1044525330), i = o(i, c, f, d, e[l + 4], 7, -176418897), d = o(d, i, c, f, e[l + 5], 12, 1200080426), f = o(f, d, i, c, e[l + 6], 17, -1473231341), c = o(c, f, d, i, e[l + 7], 22, -45705983), i = o(i, c, f, d, e[l + 8], 7, 1770035416), d = o(d, i, c, f, e[l + 9], 12, -1958414417), f = o(f, d, i, c, e[l + 10], 17, -42063), c = o(c, f, d, i, e[l + 11], 22, -1990404162), i = o(i, c, f, d, e[l + 12], 7, 1804603682), d = o(d, i, c, f, e[l + 13], 12, -40341101), f = o(f, d, i, c, e[l + 14], 17, -1502002290), i = a(i, c = o(c, f, d, i, e[l + 15], 22, 1236535329), f, d, e[l + 1], 5, -165796510), d = a(d, i, c, f, e[l + 6], 9, -1069501632), f = a(f, d, i, c, e[l + 11], 14, 643717713), c = a(c, f, d, i, e[l], 20, -373897302), i = a(i, c, f, d, e[l + 5], 5, -701558691), d = a(d, i, c, f, e[l + 10], 9, 38016083), f = a(f, d, i, c, e[l + 15], 14, -660478335), c = a(c, f, d, i, e[l + 4], 20, -405537848), i = a(i, c, f, d, e[l + 9], 5, 568446438), d = a(d, i, c, f, e[l + 14], 9, -1019803690), f = a(f, d, i, c, e[l + 3], 14, -187363961), c = a(c, f, d, i, e[l + 8], 20, 1163531501), i = a(i, c, f, d, e[l + 13], 5, -1444681467), d = a(d, i, c, f, e[l + 2], 9, -51403784), f = a(f, d, i, c, e[l + 7], 14, 1735328473), i = s(i, c = a(c, f, d, i, e[l + 12], 20, -1926607734), f, d, e[l + 5], 4, -378558), d = s(d, i, c, f, e[l + 8], 11, -2022574463), f = s(f, d, i, c, e[l + 11], 16, 1839030562), c = s(c, f, d, i, e[l + 14], 23, -35309556), i = s(i, c, f, d, e[l + 1], 4, -1530992060), d = s(d, i, c, f, e[l + 4], 11, 1272893353), f = s(f, d, i, c, e[l + 7], 16, -155497632), c = s(c, f, d, i, e[l + 10], 23, -1094730640), i = s(i, c, f, d, e[l + 13], 4, 681279174), d = s(d, i, c, f, e[l], 11, -358537222), f = s(f, d, i, c, e[l + 3], 16, -722521979), c = s(c, f, d, i, e[l + 6], 23, 76029189), i = s(i, c, f, d, e[l + 9], 4, -640364487), d = s(d, i, c, f, e[l + 12], 11, -421815835), f = s(f, d, i, c, e[l + 15], 16, 530742520), i = u(i, c = s(c, f, d, i, e[l + 2], 23, -995338651), f, d, e[l], 6, -198630844), d = u(d, i, c, f, e[l + 7], 10, 1126891415), f = u(f, d, i, c, e[l + 14], 15, -1416354905), c = u(c, f, d, i, e[l + 5], 21, -57434055), i = u(i, c, f, d, e[l + 12], 6, 1700485571), d = u(d, i, c, f, e[l + 3], 10, -1894986606), f = u(f, d, i, c, e[l + 10], 15, -1051523), c = u(c, f, d, i, e[l + 1], 21, -2054922799), i = u(i, c, f, d, e[l + 8], 6, 1873313359), d = u(d, i, c, f, e[l + 15], 10, -30611744), f = u(f, d, i, c, e[l + 6], 15, -1560198380), c = u(c, f, d, i, e[l + 13], 21, 1309151649), i = u(i, c, f, d, e[l + 4], 6, -145523070), d = u(d, i, c, f, e[l + 11], 10, -1120210379), f = u(f, d, i, c, e[l + 2], 15, 718787259), c = u(c, f, d, i, e[l + 9], 21, -343485551), i = n(i, h), c = n(c, p), f = n(f, b), d = n(d, y);
                        }
                        return [
                            i,
                            c,
                            f,
                            d
                        ];
                    }(function(e) {
                        if (0 === e.length) return [];
                        for(var t = 8 * e.length, n = new Uint32Array(r(t)), i = 0; i < t; i += 8)n[i >> 5] |= (255 & e[i / 8]) << i % 32;
                        return n;
                    }(e), 8 * e.length));
                };
            },
            11788: (e, t)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.default = void 0;
                var r = {
                    randomUUID: "undefined" != typeof crypto && crypto.randomUUID && crypto.randomUUID.bind(crypto)
                };
                t.default = r;
            },
            55996: (e, t)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.default = void 0, t.default = "00000000-0000-0000-0000-000000000000";
            },
            91729: (e, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.default = void 0;
                var n, i = (n = r(76163)) && n.__esModule ? n : {
                    default: n
                };
                t.default = function(e) {
                    if (!(0, i.default)(e)) throw TypeError("Invalid UUID");
                    var t, r = new Uint8Array(16);
                    return r[0] = (t = parseInt(e.slice(0, 8), 16)) >>> 24, r[1] = t >>> 16 & 255, r[2] = t >>> 8 & 255, r[3] = 255 & t, r[4] = (t = parseInt(e.slice(9, 13), 16)) >>> 8, r[5] = 255 & t, r[6] = (t = parseInt(e.slice(14, 18), 16)) >>> 8, r[7] = 255 & t, r[8] = (t = parseInt(e.slice(19, 23), 16)) >>> 8, r[9] = 255 & t, r[10] = (t = parseInt(e.slice(24, 36), 16)) / 1099511627776 & 255, r[11] = t / 4294967296 & 255, r[12] = t >>> 24 & 255, r[13] = t >>> 16 & 255, r[14] = t >>> 8 & 255, r[15] = 255 & t, r;
                };
            },
            77300: (e, t)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.default = void 0, t.default = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;
            },
            14402: (e, t)=>{
                "use strict";
                var r;
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.default = function() {
                    if (!r && !(r = "undefined" != typeof crypto && crypto.getRandomValues && crypto.getRandomValues.bind(crypto))) throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
                    return r(n);
                };
                var n = new Uint8Array(16);
            },
            42702: (e, t)=>{
                "use strict";
                function r(e, t, r, n) {
                    switch(e){
                        case 0:
                            return t & r ^ ~t & n;
                        case 1:
                        case 3:
                            return t ^ r ^ n;
                        case 2:
                            return t & r ^ t & n ^ r & n;
                    }
                }
                function n(e, t) {
                    return e << t | e >>> 32 - t;
                }
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.default = void 0;
                t.default = function(e) {
                    var t = [
                        1518500249,
                        1859775393,
                        2400959708,
                        3395469782
                    ], i = [
                        1732584193,
                        4023233417,
                        2562383102,
                        271733878,
                        3285377520
                    ];
                    if ("string" == typeof e) {
                        var o = unescape(encodeURIComponent(e));
                        e = [];
                        for(var a = 0; a < o.length; ++a)e.push(o.charCodeAt(a));
                    } else Array.isArray(e) || (e = Array.prototype.slice.call(e));
                    e.push(128);
                    for(var s = e.length / 4 + 2, u = Math.ceil(s / 16), c = new Array(u), f = 0; f < u; ++f){
                        for(var d = new Uint32Array(16), l = 0; l < 16; ++l)d[l] = e[64 * f + 4 * l] << 24 | e[64 * f + 4 * l + 1] << 16 | e[64 * f + 4 * l + 2] << 8 | e[64 * f + 4 * l + 3];
                        c[f] = d;
                    }
                    c[u - 1][14] = 8 * (e.length - 1) / Math.pow(2, 32), c[u - 1][14] = Math.floor(c[u - 1][14]), c[u - 1][15] = 8 * (e.length - 1) & 4294967295;
                    for(var h = 0; h < u; ++h){
                        for(var p = new Uint32Array(80), b = 0; b < 16; ++b)p[b] = c[h][b];
                        for(var y = 16; y < 80; ++y)p[y] = n(p[y - 3] ^ p[y - 8] ^ p[y - 14] ^ p[y - 16], 1);
                        for(var v = i[0], m = i[1], g = i[2], w = i[3], k = i[4], _ = 0; _ < 80; ++_){
                            var A = Math.floor(_ / 20), E = n(v, 5) + r(A, m, g, w) + k + t[A] + p[_] >>> 0;
                            k = w, w = g, g = n(m, 30) >>> 0, m = v, v = E;
                        }
                        i[0] = i[0] + v >>> 0, i[1] = i[1] + m >>> 0, i[2] = i[2] + g >>> 0, i[3] = i[3] + w >>> 0, i[4] = i[4] + k >>> 0;
                    }
                    return [
                        i[0] >> 24 & 255,
                        i[0] >> 16 & 255,
                        i[0] >> 8 & 255,
                        255 & i[0],
                        i[1] >> 24 & 255,
                        i[1] >> 16 & 255,
                        i[1] >> 8 & 255,
                        255 & i[1],
                        i[2] >> 24 & 255,
                        i[2] >> 16 & 255,
                        i[2] >> 8 & 255,
                        255 & i[2],
                        i[3] >> 24 & 255,
                        i[3] >> 16 & 255,
                        i[3] >> 8 & 255,
                        255 & i[3],
                        i[4] >> 24 & 255,
                        i[4] >> 16 & 255,
                        i[4] >> 8 & 255,
                        255 & i[4]
                    ];
                };
            },
            22982: (e, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.default = void 0, t.unsafeStringify = s;
                for(var n, i = (n = r(76163)) && n.__esModule ? n : {
                    default: n
                }, o = [], a = 0; a < 256; ++a)o.push((a + 256).toString(16).slice(1));
                function s(e) {
                    var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0;
                    return o[e[t + 0]] + o[e[t + 1]] + o[e[t + 2]] + o[e[t + 3]] + "-" + o[e[t + 4]] + o[e[t + 5]] + "-" + o[e[t + 6]] + o[e[t + 7]] + "-" + o[e[t + 8]] + o[e[t + 9]] + "-" + o[e[t + 10]] + o[e[t + 11]] + o[e[t + 12]] + o[e[t + 13]] + o[e[t + 14]] + o[e[t + 15]];
                }
                t.default = function(e) {
                    var t = s(e, arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0);
                    if (!(0, i.default)(t)) throw TypeError("Stringified UUID is invalid");
                    return t;
                };
            },
            55999: (e, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.default = void 0;
                var n, i, o, a = (n = r(14402)) && n.__esModule ? n : {
                    default: n
                }, s = r(22982), u = 0, c = 0;
                t.default = function(e, t, r) {
                    var n = t && r || 0, f = t || new Array(16), d = (e = e || {}).node || i, l = void 0 !== e.clockseq ? e.clockseq : o;
                    if (null == d || null == l) {
                        var h = e.random || (e.rng || a.default)();
                        null == d && (d = i = [
                            1 | h[0],
                            h[1],
                            h[2],
                            h[3],
                            h[4],
                            h[5]
                        ]), null == l && (l = o = 16383 & (h[6] << 8 | h[7]));
                    }
                    var p = void 0 !== e.msecs ? e.msecs : Date.now(), b = void 0 !== e.nsecs ? e.nsecs : c + 1, y = p - u + (b - c) / 1e4;
                    if (y < 0 && void 0 === e.clockseq && (l = l + 1 & 16383), (y < 0 || p > u) && void 0 === e.nsecs && (b = 0), b >= 1e4) throw new Error("uuid.v1(): Can't create more than 10M uuids/sec");
                    u = p, c = b, o = l;
                    var v = (1e4 * (268435455 & (p += 122192928e5)) + b) % 4294967296;
                    f[n++] = v >>> 24 & 255, f[n++] = v >>> 16 & 255, f[n++] = v >>> 8 & 255, f[n++] = 255 & v;
                    var m = p / 4294967296 * 1e4 & 268435455;
                    f[n++] = m >>> 8 & 255, f[n++] = 255 & m, f[n++] = m >>> 24 & 15 | 16, f[n++] = m >>> 16 & 255, f[n++] = l >>> 8 | 128, f[n++] = 255 & l;
                    for(var g = 0; g < 6; ++g)f[n + g] = d[g];
                    return t || (0, s.unsafeStringify)(f);
                };
            },
            28231: (e, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.default = void 0;
                var n = o(r(36125)), i = o(r(86792));
                function o(e) {
                    return e && e.__esModule ? e : {
                        default: e
                    };
                }
                var a = (0, n.default)("v3", 48, i.default);
                t.default = a;
            },
            36125: (e, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.URL = t.DNS = void 0, t.default = function(e, t, r) {
                    function n(e, n, a, s) {
                        var u;
                        if ("string" == typeof e && (e = function(e) {
                            e = unescape(encodeURIComponent(e));
                            for(var t = [], r = 0; r < e.length; ++r)t.push(e.charCodeAt(r));
                            return t;
                        }(e)), "string" == typeof n && (n = (0, o.default)(n)), 16 !== (null === (u = n) || void 0 === u ? void 0 : u.length)) throw TypeError("Namespace must be array-like (16 iterable integer values, 0-255)");
                        var c = new Uint8Array(16 + e.length);
                        if (c.set(n), c.set(e, n.length), (c = r(c))[6] = 15 & c[6] | t, c[8] = 63 & c[8] | 128, a) {
                            s = s || 0;
                            for(var f = 0; f < 16; ++f)a[s + f] = c[f];
                            return a;
                        }
                        return (0, i.unsafeStringify)(c);
                    }
                    try {
                        n.name = e;
                    } catch (e) {}
                    return n.DNS = a, n.URL = s, n;
                };
                var n, i = r(22982), o = (n = r(91729)) && n.__esModule ? n : {
                    default: n
                }, a = "6ba7b810-9dad-11d1-80b4-00c04fd430c8";
                t.DNS = a;
                var s = "6ba7b811-9dad-11d1-80b4-00c04fd430c8";
                t.URL = s;
            },
            78647: (e, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.default = void 0;
                var n = a(r(11788)), i = a(r(14402)), o = r(22982);
                function a(e) {
                    return e && e.__esModule ? e : {
                        default: e
                    };
                }
                t.default = function(e, t, r) {
                    if (n.default.randomUUID && !t && !e) return n.default.randomUUID();
                    var a = (e = e || {}).random || (e.rng || i.default)();
                    if (a[6] = 15 & a[6] | 64, a[8] = 63 & a[8] | 128, t) {
                        r = r || 0;
                        for(var s = 0; s < 16; ++s)t[r + s] = a[s];
                        return t;
                    }
                    return (0, o.unsafeStringify)(a);
                };
            },
            65025: (e, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.default = void 0;
                var n = o(r(36125)), i = o(r(42702));
                function o(e) {
                    return e && e.__esModule ? e : {
                        default: e
                    };
                }
                var a = (0, n.default)("v5", 80, i.default);
                t.default = a;
            },
            76163: (e, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.default = void 0;
                var n, i = (n = r(77300)) && n.__esModule ? n : {
                    default: n
                };
                t.default = function(e) {
                    return "string" == typeof e && i.default.test(e);
                };
            },
            8928: (e, t, r)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.default = void 0;
                var n, i = (n = r(76163)) && n.__esModule ? n : {
                    default: n
                };
                t.default = function(e) {
                    if (!(0, i.default)(e)) throw TypeError("Invalid UUID");
                    return parseInt(e.slice(14, 15), 16);
                };
            },
            38325: (e)=>{
                "use strict";
                e.exports = function e(n, i) {
                    var o, a = 0, s = 0, u = i = i || 0, c = n.length;
                    do {
                        if (u >= c) throw e.bytes = 0, new RangeError("Could not decode varint");
                        o = n[u++], a += s < 28 ? (o & r) << s : (o & r) * Math.pow(2, s), s += 7;
                    }while (o >= t);
                    return e.bytes = u - i, a;
                };
                var t = 128, r = 127;
            },
            92699: (e)=>{
                "use strict";
                e.exports = function e(i, o, a) {
                    o = o || [];
                    for(var s = a = a || 0; i >= n;)o[a++] = 255 & i | t, i /= 128;
                    for(; i & r;)o[a++] = 255 & i | t, i >>>= 7;
                    return o[a] = 0 | i, e.bytes = a - s + 1, o;
                };
                var t = 128, r = -128, n = Math.pow(2, 31);
            },
            26657: (e, t, r)=>{
                "use strict";
                e.exports = {
                    encode: r(92699),
                    decode: r(38325),
                    encodingLength: r(57490)
                };
            },
            57490: (e)=>{
                "use strict";
                var t = Math.pow(2, 7), r = Math.pow(2, 14), n = Math.pow(2, 21), i = Math.pow(2, 28), o = Math.pow(2, 35), a = Math.pow(2, 42), s = Math.pow(2, 49), u = Math.pow(2, 56), c = Math.pow(2, 63);
                e.exports = function(e) {
                    return e < t ? 1 : e < r ? 2 : e < n ? 3 : e < i ? 4 : e < o ? 5 : e < a ? 6 : e < s ? 7 : e < u ? 8 : e < c ? 9 : 10;
                };
            },
            1158: (e, t, r)=>{
                "use strict";
                var n, i = r(28847)(r(3355));
                if ("object" === ("undefined" == typeof globalThis ? "undefined" : (0, i.default)(globalThis))) n = globalThis;
                else try {
                    n = r(26464);
                } catch (e) {} finally{
                    if (n || "undefined" == typeof window || (n = window), !n) throw new Error("Could not determine global this");
                }
                var o = n.WebSocket || n.MozWebSocket, a = r(75735);
                function s(e, t) {
                    return t ? new o(e, t) : new o(e);
                }
                o && [
                    "CONNECTING",
                    "OPEN",
                    "CLOSING",
                    "CLOSED"
                ].forEach(function(e) {
                    Object.defineProperty(s, e, {
                        get: function() {
                            return o[e];
                        }
                    });
                }), e.exports = {
                    w3cwebsocket: o ? s : null,
                    version: a
                };
            },
            75735: (e, t, r)=>{
                "use strict";
                e.exports = r(19794).version;
            },
            72337: (e, t, r)=>{
                "use strict";
                var n = r(28847)(r(3355)), i = r(48184), o = r(43604), a = r(24373), s = r(80593), u = r(53820), c = s("Object.prototype.toString"), f = r(11191)(), d = "undefined" == typeof globalThis ? r.g : globalThis, l = o(), h = s("String.prototype.slice"), p = Object.getPrototypeOf, b = s("Array.prototype.indexOf", !0) || function(e, t) {
                    for(var r = 0; r < e.length; r += 1)if (e[r] === t) return r;
                    return -1;
                }, y = {
                    __proto__: null
                };
                i(l, f && u && p ? function(e) {
                    var t = new d[e];
                    if (Symbol.toStringTag in t) {
                        var r = p(t), n = u(r, Symbol.toStringTag);
                        if (!n) {
                            var i = p(r);
                            n = u(i, Symbol.toStringTag);
                        }
                        y["$" + e] = a(n.get);
                    }
                } : function(e) {
                    var t = new d[e], r = t.slice || t.set;
                    r && (y["$" + e] = a(r));
                }), e.exports = function(e) {
                    if (!e || "object" !== (0, n.default)(e)) return !1;
                    if (!f) {
                        var t = h(c(e), 8, -1);
                        return b(l, t) > -1 ? t : "Object" === t && function(e) {
                            var t = !1;
                            return i(y, function(r, n) {
                                if (!t) try {
                                    r(e), t = h(n, 1);
                                } catch (e) {}
                            }), t;
                        }(e);
                    }
                    return u ? function(e) {
                        var t = !1;
                        return i(y, function(r, n) {
                            if (!t) try {
                                "$" + r(e) === n && (t = h(n, 1));
                            } catch (e) {}
                        }), t;
                    }(e) : null;
                };
            },
            31357: (e, t, r)=>{
                "use strict";
                var n = r(31296), i = r(68419), o = r(33103), a = r(39122), s = r(17321), u = "application/json", c = function() {};
                e.exports = function(e, t, r) {
                    if (!e || "string" != typeof e) throw new TypeError("must specify a URL");
                    if ("function" == typeof t && (r = t, t = {}), r && "function" != typeof r) throw new TypeError("expected cb to be undefined or a function");
                    r = r || c;
                    var f = (t = t || {}).json ? "json" : "text", d = (t = o({
                        responseType: f
                    }, t)).headers || {}, l = (t.method || "GET").toUpperCase(), h = t.query;
                    return h && ("string" != typeof h && (h = n.stringify(h)), e = i(e, h)), "json" === t.responseType && a(d, "Accept", u), t.json && "GET" !== l && "HEAD" !== l && (a(d, "Content-Type", u), t.body = JSON.stringify(t.body)), t.method = l, t.url = e, t.headers = d, delete t.query, delete t.json, s(t, r);
                };
            },
            39122: (e)=>{
                "use strict";
                e.exports = function(e, t, r) {
                    var n = t.toLowerCase();
                    e[t] || e[n] || (e[t] = r);
                };
            },
            49800: (e)=>{
                "use strict";
                e.exports = function(e, t) {
                    return t ? {
                        statusCode: t.statusCode,
                        headers: t.headers,
                        method: e.method,
                        url: e.url,
                        rawRequest: t.rawRequest ? t.rawRequest : t
                    } : null;
                };
            },
            17321: (e, t, r)=>{
                "use strict";
                var n = r(30346), i = r(49800), o = function() {};
                e.exports = function(e, t) {
                    delete e.uri;
                    var r = !1;
                    "json" === e.responseType && (e.responseType = "text", r = !0);
                    var a = n(e, function(n, a, s) {
                        if (r && !n) try {
                            var u = a.rawRequest.responseText;
                            s = JSON.parse(u);
                        } catch (e) {
                            n = e;
                        }
                        a = i(e, a), t(n, n ? null : s, a), t = o;
                    }), s = a.onabort;
                    return a.onabort = function() {
                        var e = s.apply(a, Array.prototype.slice.call(arguments));
                        return t(new Error("XHR Aborted")), t = o, e;
                    }, a;
                };
            },
            30346: (e, t, r)=>{
                "use strict";
                var n = r(92948), i = r(27277), o = r(48209), a = r(87705);
                function s(e, t, r) {
                    var n = e;
                    return i(t) ? (r = t, "string" == typeof e && (n = {
                        uri: e
                    })) : n = a(t, {
                        uri: e
                    }), n.callback = r, n;
                }
                function u(e, t, r) {
                    return c(t = s(e, t, r));
                }
                function c(e) {
                    if (void 0 === e.callback) throw new Error("callback argument missing");
                    var t = !1, r = function(r, n, i) {
                        t || (t = !0, e.callback(r, n, i));
                    };
                    function n() {
                        var e = void 0;
                        if (e = f.response ? f.response : f.responseText || function(e) {
                            try {
                                if ("document" === e.responseType) return e.responseXML;
                                var t = e.responseXML && "parsererror" === e.responseXML.documentElement.nodeName;
                                if ("" === e.responseType && !t) return e.responseXML;
                            } catch (e) {}
                            return null;
                        }(f), v) try {
                            e = JSON.parse(e);
                        } catch (e) {}
                        return e;
                    }
                    function i(e) {
                        return clearTimeout(d), e instanceof Error || (e = new Error("" + (e || "Unknown XMLHttpRequest Error"))), e.statusCode = 0, r(e, m);
                    }
                    function a() {
                        if (!c) {
                            var t;
                            clearTimeout(d), t = e.useXDR && void 0 === f.status ? 200 : 1223 === f.status ? 204 : f.status;
                            var i = m, a = null;
                            return 0 !== t ? (i = {
                                body: n(),
                                statusCode: t,
                                method: h,
                                headers: {},
                                url: l,
                                rawRequest: f
                            }, f.getAllResponseHeaders && (i.headers = o(f.getAllResponseHeaders()))) : a = new Error("Internal XMLHttpRequest Error"), r(a, i, i.body);
                        }
                    }
                    var s, c, f = e.xhr || null;
                    f || (f = e.cors || e.useXDR ? new u.XDomainRequest : new u.XMLHttpRequest);
                    var d, l = f.url = e.uri || e.url, h = f.method = e.method || "GET", p = e.body || e.data, b = f.headers = e.headers || {}, y = !!e.sync, v = !1, m = {
                        body: void 0,
                        headers: {},
                        statusCode: 0,
                        method: h,
                        url: l,
                        rawRequest: f
                    };
                    if ("json" in e && !1 !== e.json && (v = !0, b.accept || b.Accept || (b.Accept = "application/json"), "GET" !== h && "HEAD" !== h && (b["content-type"] || b["Content-Type"] || (b["Content-Type"] = "application/json"), p = JSON.stringify(!0 === e.json ? p : e.json))), f.onreadystatechange = function() {
                        4 === f.readyState && setTimeout(a, 0);
                    }, f.onload = a, f.onerror = i, f.onprogress = function() {}, f.onabort = function() {
                        c = !0;
                    }, f.ontimeout = i, f.open(h, l, !y, e.username, e.password), y || (f.withCredentials = !!e.withCredentials), !y && e.timeout > 0 && (d = setTimeout(function() {
                        if (!c) {
                            c = !0, f.abort("timeout");
                            var e = new Error("XMLHttpRequest timeout");
                            e.code = "ETIMEDOUT", i(e);
                        }
                    }, e.timeout)), f.setRequestHeader) for(s in b)b.hasOwnProperty(s) && f.setRequestHeader(s, b[s]);
                    else if (e.headers && !function(e) {
                        for(var t in e)if (e.hasOwnProperty(t)) return !1;
                        return !0;
                    }(e.headers)) throw new Error("Headers cannot be set on an XDomainRequest object");
                    return "responseType" in e && (f.responseType = e.responseType), "beforeSend" in e && "function" == typeof e.beforeSend && e.beforeSend(f), f.send(p || null), f;
                }
                e.exports = u, e.exports.default = u, u.XMLHttpRequest = n.XMLHttpRequest || function() {}, u.XDomainRequest = "withCredentials" in new u.XMLHttpRequest ? u.XMLHttpRequest : n.XDomainRequest, function(e, t) {
                    for(var r = 0; r < e.length; r++)t(e[r]);
                }([
                    "get",
                    "put",
                    "post",
                    "patch",
                    "head",
                    "delete"
                ], function(e) {
                    u["delete" === e ? "del" : e] = function(t, r, n) {
                        return (r = s(t, r, n)).method = e.toUpperCase(), c(r);
                    };
                });
            },
            87705: (e)=>{
                "use strict";
                e.exports = function() {
                    for(var e = {}, r = 0; r < arguments.length; r++){
                        var n = arguments[r];
                        for(var i in n)t.call(n, i) && (e[i] = n[i]);
                    }
                    return e;
                };
                var t = Object.prototype.hasOwnProperty;
            },
            42463: (e, t, r)=>{
                "use strict";
                var n = r(28847)(r(3355)), i = r(26427), o = function e(t) {
                    this.givenProvider = e.givenProvider, t && t._requestManager && (t = t.currentProvider), "undefined" != typeof document && (this.pick = i.pick), this.setProvider(t);
                };
                o.givenProvider = null, "undefined" != typeof ethereum && ethereum.bzz && (o.givenProvider = ethereum.bzz), o.prototype.setProvider = function(e) {
                    if (e && "object" === (0, n.default)(e) && "string" == typeof e.bzz && (e = e.bzz), "string" != typeof e) {
                        this.currentProvider = null;
                        var t = new Error("No provider set, please set one using bzz.setProvider().");
                        return this.download = this.upload = this.isAvailable = function() {
                            throw t;
                        }, !1;
                    }
                    return this.currentProvider = e, this.download = i.at(e).download, this.upload = i.at(e).upload, this.isAvailable = i.at(e).isAvailable, !0;
                }, e.exports = o;
            },
            94246: (e, t, r)=>{
                "use strict";
                var n = r(28847)(r(3355));
                e.exports = {
                    ErrorResponse: function(e) {
                        var t = e && e.error && e.error.message ? e.error.message : JSON.stringify(e), r = e.error && e.error.data ? e.error.data : null, n = new Error("Returned error: " + t);
                        return n.data = r, n;
                    },
                    InvalidNumberOfParams: function(e, t, r) {
                        return new Error('Invalid number of parameters for "' + r + '". Got ' + e + " expected " + t + "!");
                    },
                    InvalidConnection: function(e, t) {
                        return this.ConnectionError("CONNECTION ERROR: Couldn't connect to node " + e + ".", t);
                    },
                    InvalidProvider: function() {
                        return new Error("Provider not set or invalid");
                    },
                    InvalidResponse: function(e) {
                        var t = e && e.error && e.error.message ? e.error.message : "Invalid JSON RPC response: " + JSON.stringify(e);
                        return new Error(t);
                    },
                    ConnectionTimeout: function(e) {
                        return new Error("CONNECTION TIMEOUT: timeout of " + e + " ms achived");
                    },
                    ConnectionNotOpenError: function(e) {
                        return this.ConnectionError("connection not open on send()", e);
                    },
                    ConnectionCloseError: function(e) {
                        return "object" === (0, n.default)(e) && e.code && e.reason ? this.ConnectionError("CONNECTION ERROR: The connection got closed with the close code `" + e.code + "` and the following reason string `" + e.reason + "`", e) : new Error("CONNECTION ERROR: The connection closed unexpectedly");
                    },
                    MaxAttemptsReachedOnReconnectingError: function() {
                        return new Error("Maximum number of reconnect attempts reached!");
                    },
                    PendingRequestsOnReconnectingError: function() {
                        return new Error("CONNECTION ERROR: Provider started to reconnect before the response got received!");
                    },
                    ConnectionError: function(e, t) {
                        var r = new Error(e);
                        return t && (r.code = t.code, r.reason = t.reason, t.description && (r.description = t.description)), r;
                    },
                    RevertInstructionError: function(e, t) {
                        var r = new Error("Your request got reverted with the following reason string: " + e);
                        return r.reason = e, r.signature = t, r;
                    },
                    TransactionRevertInstructionError: function(e, t, r) {
                        var n = new Error("Transaction has been reverted by the EVM:\n" + JSON.stringify(r, null, 2));
                        return n.reason = e, n.signature = t, n.receipt = r, n;
                    },
                    TransactionError: function(e, t) {
                        var r = new Error(e);
                        return r.receipt = t, r;
                    },
                    NoContractAddressFoundError: function(e) {
                        return this.TransactionError("The transaction receipt didn't contain a contract address.", e);
                    },
                    ContractCodeNotStoredError: function(e) {
                        return this.TransactionError("The contract code couldn't be stored, please check your gas limit.", e);
                    },
                    TransactionRevertedWithoutReasonError: function(e) {
                        return this.TransactionError("Transaction has been reverted by the EVM:\n" + JSON.stringify(e, null, 2), e);
                    },
                    TransactionOutOfGasError: function(e) {
                        return this.TransactionError("Transaction ran out of gas. Please provide more gas:\n" + JSON.stringify(e, null, 2), e);
                    },
                    ResolverMethodMissingError: function(e, t) {
                        return new Error("The resolver at " + e + 'does not implement requested method: "' + t + '".');
                    },
                    ContractMissingABIError: function() {
                        return new Error("You must provide the json interface of the contract when instantiating a contract object.");
                    },
                    ContractOnceRequiresCallbackError: function() {
                        return new Error("Once requires a callback as the second parameter.");
                    },
                    ContractEventDoesNotExistError: function(e) {
                        return new Error('Event "' + e + "\" doesn't exist in this contract.");
                    },
                    ContractReservedEventError: function(e) {
                        return new Error('The event "' + e + "\" is a reserved event name, you can't use it.");
                    },
                    ContractMissingDeployDataError: function() {
                        return new Error('No "data" specified in neither the given options, nor the default options.');
                    },
                    ContractNoAddressDefinedError: function() {
                        return new Error("This contract object doesn't have address set yet, please set an address first.");
                    },
                    ContractNoFromAddressDefinedError: function() {
                        return new Error('No "from" address specified in neither the given options, nor the default options.');
                    }
                };
            },
            32084: (e, t, r)=>{
                "use strict";
                var n = r(28847), i = n(r(90775)), o = n(r(3355));
                function a(e, t) {
                    var r = Object.keys(e);
                    if (Object.getOwnPropertySymbols) {
                        var n = Object.getOwnPropertySymbols(e);
                        t && (n = n.filter(function(t) {
                            return Object.getOwnPropertyDescriptor(e, t).enumerable;
                        })), r.push.apply(r, n);
                    }
                    return r;
                }
                function s(e) {
                    for(var t = 1; t < arguments.length; t++){
                        var r = null != arguments[t] ? arguments[t] : {};
                        t % 2 ? a(Object(r), !0).forEach(function(t) {
                            (0, i.default)(e, t, r[t]);
                        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : a(Object(r)).forEach(function(t) {
                            Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
                        });
                    }
                    return e;
                }
                var u = r(48161), c = r(30006), f = function(e) {
                    return u.toBN(e).toString(10);
                }, d = function(e) {
                    if (void 0 !== e) return function(e) {
                        return [
                            "latest",
                            "pending",
                            "earliest",
                            "finalized",
                            "safe"
                        ].includes(e);
                    }(e) ? e : "genesis" === e ? "0x0" : u.isHexStrict(e) ? "string" == typeof e ? e.toLowerCase() : e : u.numberToHex(e);
                }, l = function(e) {
                    if (e.to && (e.to = b(e.to)), e.data && e.input) throw new Error('You can\'t have "data" and "input" as properties of transactions at the same time, please use either "data" or "input" instead.');
                    if (!e.data && e.input && (e.data = e.input, delete e.input), e.data && !e.data.startsWith("0x") && (e.data = "0x" + e.data), e.data && !u.isHex(e.data)) throw new Error("The data field must be HEX encoded data.");
                    return (e.gas || e.gasLimit) && (e.gas = e.gas || e.gasLimit), (e.maxPriorityFeePerGas || e.maxFeePerGas) && delete e.gasPrice, [
                        "gasPrice",
                        "gas",
                        "value",
                        "maxPriorityFeePerGas",
                        "maxFeePerGas",
                        "nonce",
                        "type"
                    ].filter(function(t) {
                        return void 0 !== e[t];
                    }).forEach(function(t) {
                        e[t] = u.numberToHex(e[t]);
                    }), e;
                }, h = function(e, t) {
                    return t || (null !== e.blockNumber && (e.blockNumber = u.hexToNumber(e.blockNumber)), null !== e.transactionIndex && (e.transactionIndex = u.hexToNumber(e.transactionIndex)), e.nonce = u.hexToNumber(e.nonce), e.gas = u.hexToNumber(e.gas), e.type && (e.type = u.hexToNumber(e.type))), e.gasPrice && (e.gasPrice = f(e.gasPrice)), e.maxFeePerGas && (e.maxFeePerGas = f(e.maxFeePerGas)), e.maxPriorityFeePerGas && (e.maxPriorityFeePerGas = f(e.maxPriorityFeePerGas)), e.value = f(e.value), e.to && u.isAddress(e.to) ? e.to = u.toChecksumAddress(e.to) : e.to = null, e.from && (e.from = u.toChecksumAddress(e.from)), e;
                }, p = function(e) {
                    if ("string" == typeof e.blockHash && "string" == typeof e.transactionHash && "string" == typeof e.logIndex) {
                        var t = u.sha3(e.blockHash.replace("0x", "") + e.transactionHash.replace("0x", "") + e.logIndex.replace("0x", ""));
                        e.id = "log_" + t.replace("0x", "").slice(0, 8);
                    } else e.id || (e.id = null);
                    return null !== e.blockNumber && (e.blockNumber = u.hexToNumber(e.blockNumber)), null !== e.transactionIndex && (e.transactionIndex = u.hexToNumber(e.transactionIndex)), null !== e.logIndex && (e.logIndex = u.hexToNumber(e.logIndex)), e.address && (e.address = u.toChecksumAddress(e.address)), e;
                }, b = function(e) {
                    var t = new c(e);
                    if (t.isValid() && t.isDirect()) return t.toAddress().toLowerCase();
                    if (u.isAddress(e)) return "0x" + e.toLowerCase().replace("0x", "");
                    throw new Error("Provided address ".concat(e, " is invalid, the capitalization checksum test failed, or it's an indirect IBAN address which can't be converted."));
                };
                e.exports = {
                    inputDefaultBlockNumberFormatter: function(e) {
                        return d(this && null == e ? this.defaultBlock : e);
                    },
                    inputBlockNumberFormatter: d,
                    inputCallFormatter: function(e) {
                        var t = (e = l(e)).from || (this ? this.defaultAccount : null);
                        return t && (e.from = b(t)), e;
                    },
                    inputTransactionFormatter: function(e) {
                        if ("number" != typeof (e = l(e)).from && (!e.from || "object" !== (0, o.default)(e.from))) {
                            if (e.from = e.from || (this ? this.defaultAccount : null), !e.from && "number" != typeof e.from) throw new Error('The send transactions "from" field must be defined!');
                            e.from = b(e.from);
                        }
                        return e;
                    },
                    inputAddressFormatter: b,
                    inputPostFormatter: function(e) {
                        return e.ttl && (e.ttl = u.numberToHex(e.ttl)), e.workToProve && (e.workToProve = u.numberToHex(e.workToProve)), e.priority && (e.priority = u.numberToHex(e.priority)), Array.isArray(e.topics) || (e.topics = e.topics ? [
                            e.topics
                        ] : []), e.topics = e.topics.map(function(e) {
                            return 0 === e.indexOf("0x") ? e : u.fromUtf8(e);
                        }), e;
                    },
                    inputLogFormatter: function(e) {
                        var t = function(e) {
                            return null == e ? null : 0 === (e = String(e)).indexOf("0x") ? e : u.fromUtf8(e);
                        };
                        return void 0 === e && (e = {}), void 0 === e.fromBlock && (e = s(s({}, e), {}, {
                            fromBlock: "latest"
                        })), (e.fromBlock || 0 === e.fromBlock) && (e.fromBlock = d(e.fromBlock)), (e.toBlock || 0 === e.toBlock) && (e.toBlock = d(e.toBlock)), e.topics = e.topics || [], e.topics = e.topics.map(function(e) {
                            return Array.isArray(e) ? e.map(t) : t(e);
                        }), t = null, e.address && (e.address = Array.isArray(e.address) ? e.address.map(function(e) {
                            return b(e);
                        }) : b(e.address)), e;
                    },
                    inputSignFormatter: function(e) {
                        return u.isHexStrict(e) ? e : u.utf8ToHex(e);
                    },
                    inputStorageKeysFormatter: function(e) {
                        return e.map(u.numberToHex);
                    },
                    outputProofFormatter: function(e) {
                        return e.address = u.toChecksumAddress(e.address), e.nonce = u.hexToNumberString(e.nonce), e.balance = u.hexToNumberString(e.balance), e;
                    },
                    outputBigNumberFormatter: f,
                    outputTransactionFormatter: h,
                    outputTransactionReceiptFormatter: function(e) {
                        if ("object" !== (0, o.default)(e)) throw new Error("Received receipt is invalid: " + e);
                        return this.hexFormat || (null !== e.blockNumber && (e.blockNumber = u.hexToNumber(e.blockNumber)), null !== e.transactionIndex && (e.transactionIndex = u.hexToNumber(e.transactionIndex)), e.cumulativeGasUsed = u.hexToNumber(e.cumulativeGasUsed), e.gasUsed = u.hexToNumber(e.gasUsed), e.effectiveGasPrice && (e.effectiveGasPrice = u.hexToNumber(e.effectiveGasPrice))), Array.isArray(e.logs) && (e.logs = e.logs.map(p)), e.contractAddress && (e.contractAddress = u.toChecksumAddress(e.contractAddress)), void 0 !== e.status && null !== e.status && (e.status = Boolean(parseInt(e.status))), e;
                    },
                    outputBlockFormatter: function(e, t) {
                        return t || (e.gasLimit = u.hexToNumber(e.gasLimit), e.gasUsed = u.hexToNumber(e.gasUsed), e.size = u.hexToNumber(e.size), e.timestamp = u.hexToNumber(e.timestamp), null !== e.number && (e.number = u.hexToNumber(e.number))), e.difficulty && (e.difficulty = f(e.difficulty)), e.totalDifficulty && (e.totalDifficulty = f(e.totalDifficulty)), Array.isArray(e.transactions) && e.transactions.forEach(function(e) {
                            if ("string" != typeof e) return h(e, t);
                        }), e.miner && (e.miner = u.toChecksumAddress(e.miner)), e.baseFeePerGas && (e.baseFeePerGas = u.hexToNumber(e.baseFeePerGas)), e;
                    },
                    outputLogFormatter: p,
                    outputPostFormatter: function(e) {
                        return e.expiry = u.hexToNumber(e.expiry), e.sent = u.hexToNumber(e.sent), e.ttl = u.hexToNumber(e.ttl), e.workProved = u.hexToNumber(e.workProved), e.topics || (e.topics = []), e.topics = e.topics.map(function(e) {
                            return u.toUtf8(e);
                        }), e;
                    },
                    outputSyncingFormatter: function(e) {
                        return e.startingBlock = u.hexToNumber(e.startingBlock), e.currentBlock = u.hexToNumber(e.currentBlock), e.highestBlock = u.hexToNumber(e.highestBlock), e.knownStates && (e.knownStates = u.hexToNumber(e.knownStates), e.pulledStates = u.hexToNumber(e.pulledStates)), e;
                    }
                };
            },
            11314: (e, t, r)=>{
                "use strict";
                var n = r(94246), i = r(32084);
                e.exports = {
                    errors: n,
                    formatters: i
                };
            },
            53349: (e, t, r)=>{
                "use strict";
                var n = r(28847), i = n(r(82247)), o = n(r(74519)), a = n(r(90775)), s = n(r(94571)), u = n(r(3355));
                function c(e, t) {
                    var r = Object.keys(e);
                    if (Object.getOwnPropertySymbols) {
                        var n = Object.getOwnPropertySymbols(e);
                        t && (n = n.filter(function(t) {
                            return Object.getOwnPropertyDescriptor(e, t).enumerable;
                        })), r.push.apply(r, n);
                    }
                    return r;
                }
                function f(e) {
                    for(var t = 1; t < arguments.length; t++){
                        var r = null != arguments[t] ? arguments[t] : {};
                        t % 2 ? c(Object(r), !0).forEach(function(t) {
                            (0, a.default)(e, t, r[t]);
                        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : c(Object(r)).forEach(function(t) {
                            Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
                        });
                    }
                    return e;
                }
                var d = r(11314).errors, l = r(11314).formatters, h = r(48161), p = r(90282), b = r(34178).subscriptions, y = r(21936), v = function(e) {
                    if (!e.call || !e.name) throw new Error('When creating a method you need to provide at least the "name" and "call" property.');
                    this.name = e.name, this.call = e.call, this.params = e.params || 0, this.inputFormatter = e.inputFormatter, this.outputFormatter = e.outputFormatter, this.transformPayload = e.transformPayload, this.extraFormatters = e.extraFormatters, this.abiCoder = e.abiCoder, this.requestManager = e.requestManager, this.accounts = e.accounts, this.defaultBlock = e.defaultBlock || "latest", this.defaultAccount = e.defaultAccount || null, this.transactionBlockTimeout = e.transactionBlockTimeout || 50, this.transactionConfirmationBlocks = e.transactionConfirmationBlocks || 24, this.transactionPollingTimeout = e.transactionPollingTimeout || 750, this.transactionPollingInterval = e.transactionPollingInterval || 1e3, this.blockHeaderTimeout = e.blockHeaderTimeout || 10, this.defaultCommon = e.defaultCommon, this.defaultChain = e.defaultChain, this.defaultHardfork = e.defaultHardfork, this.handleRevert = e.handleRevert;
                };
                v.prototype.setRequestManager = function(e, t) {
                    this.requestManager = e, t && (this.accounts = t);
                }, v.prototype.createFunction = function(e, t) {
                    var r = this.buildCall();
                    return Object.defineProperty(r, "call", {
                        configurable: !0,
                        writable: !0,
                        value: this.call
                    }), this.setRequestManager(e || this.requestManager, t || this.accounts), r;
                }, v.prototype.attachToObject = function(e) {
                    var t = this.buildCall();
                    Object.defineProperty(t, "call", {
                        configurable: !0,
                        writable: !0,
                        value: this.call
                    });
                    var r = this.name.split(".");
                    r.length > 1 ? (e[r[0]] = e[r[0]] || {}, e[r[0]][r[1]] = t) : e[r[0]] = t;
                }, v.prototype.getCall = function(e) {
                    return "function" == typeof this.call ? this.call(e) : this.call;
                }, v.prototype.extractCallback = function(e) {
                    if ("function" == typeof e[e.length - 1]) return e.pop();
                }, v.prototype.validateArgs = function(e) {
                    if (e.length !== this.params) throw d.InvalidNumberOfParams(e.length, this.params, this.name);
                }, v.prototype.formatInput = function(e) {
                    var t = this;
                    return this.inputFormatter ? this.inputFormatter.map(function(r, n) {
                        return r ? r.call(t, e[n]) : e[n];
                    }) : e;
                }, v.prototype.formatOutput = function(e) {
                    var t = this;
                    return Array.isArray(e) ? e.map(function(e) {
                        return t.outputFormatter && e ? t.outputFormatter(e, null == this ? void 0 : this.hexFormat) : e;
                    }) : this.outputFormatter && e ? this.outputFormatter(e, null == this ? void 0 : this.hexFormat) : e;
                }, v.prototype.toPayload = function(e) {
                    var t = this.getCall(e), r = this.extractCallback(e), n = this.formatInput(e);
                    this.validateArgs(n);
                    var i = {
                        method: t,
                        params: n,
                        callback: r
                    };
                    return this.transformPayload && (i = this.transformPayload(i)), i;
                }, v.prototype._confirmTransaction = function(e, t, r) {
                    var n = this, o = !1, a = !0, c = 0, f = 0, m = null, g = null, w = null, k = r.params[0] && "object" === (0, u.default)(r.params[0]) && r.params[0].gas ? r.params[0].gas : null, _ = !!r.params[0] && "object" === (0, u.default)(r.params[0]) && r.params[0].data && r.params[0].from && !r.params[0].to, A = _ && r.params[0].data.length > 2, E = [
                        new v({
                            name: "getBlockByNumber",
                            call: "eth_getBlockByNumber",
                            params: 2,
                            inputFormatter: [
                                l.inputBlockNumberFormatter,
                                function(e) {
                                    return !!e;
                                }
                            ],
                            outputFormatter: l.outputBlockFormatter
                        }),
                        new v({
                            name: "getTransactionReceipt",
                            call: "eth_getTransactionReceipt",
                            params: 1,
                            inputFormatter: [
                                null
                            ],
                            outputFormatter: l.outputTransactionReceiptFormatter
                        }),
                        new v({
                            name: "getCode",
                            call: "eth_getCode",
                            params: 2,
                            inputFormatter: [
                                l.inputAddressFormatter,
                                l.inputDefaultBlockNumberFormatter
                            ]
                        }),
                        new v({
                            name: "getTransactionByHash",
                            call: "eth_getTransactionByHash",
                            params: 1,
                            inputFormatter: [
                                null
                            ],
                            outputFormatter: l.outputTransactionFormatter
                        }),
                        new b({
                            name: "subscribe",
                            type: "eth",
                            subscriptions: {
                                newBlockHeaders: {
                                    subscriptionName: "newHeads",
                                    params: 0,
                                    outputFormatter: l.outputBlockFormatter
                                }
                            }
                        })
                    ], S = {};
                    E.forEach(function(e) {
                        e.attachToObject(S), e.requestManager = n.requestManager;
                    });
                    var x = function(u, b, v, E, x) {
                        if (!v) return x || (x = {
                            unsubscribe: function() {
                                clearInterval(m), clearTimeout(g);
                            }
                        }), (u ? p.resolve(u) : S.getTransactionReceipt(t)).catch(function(t) {
                            x.unsubscribe(), o = !0, h._fireError({
                                message: "Failed to check for transaction receipt:",
                                data: t
                            }, e.eventEmitter, e.reject);
                        }).then(function() {
                            var t = (0, s.default)(i.default.mark(function t(r) {
                                var o, s, c;
                                return i.default.wrap(function(t) {
                                    for(;;)switch(t.prev = t.next){
                                        case 0:
                                            if (r && r.blockHash) {
                                                t.next = 2;
                                                break;
                                            }
                                            throw new Error("Receipt missing or blockHash null");
                                        case 2:
                                            if (n.extraFormatters && n.extraFormatters.receiptFormatter && (r = n.extraFormatters.receiptFormatter(r)), !(e.eventEmitter.listeners("confirmation").length > 0)) {
                                                t.next = 28;
                                                break;
                                            }
                                            if (void 0 !== u && 0 === f) {
                                                t.next = 25;
                                                break;
                                            }
                                            return t.next = 7, S.getBlockByNumber("latest");
                                        case 7:
                                            if (s = t.sent, c = s ? s.hash : null, !b) {
                                                t.next = 24;
                                                break;
                                            }
                                            if (!w) {
                                                t.next = 17;
                                                break;
                                            }
                                            return t.next = 13, S.getBlockByNumber(w.number + 1);
                                        case 13:
                                            (o = t.sent) && (w = o, e.eventEmitter.emit("confirmation", f, r, c)), t.next = 22;
                                            break;
                                        case 17:
                                            return t.next = 19, S.getBlockByNumber(r.blockNumber);
                                        case 19:
                                            o = t.sent, w = o, e.eventEmitter.emit("confirmation", f, r, c);
                                        case 22:
                                            t.next = 25;
                                            break;
                                        case 24:
                                            e.eventEmitter.emit("confirmation", f, r, c);
                                        case 25:
                                            (b && o || !b) && f++, a = !1, f === n.transactionConfirmationBlocks + 1 && (x.unsubscribe(), e.eventEmitter.removeAllListeners());
                                        case 28:
                                            return t.abrupt("return", r);
                                        case 29:
                                        case "end":
                                            return t.stop();
                                    }
                                }, t);
                            }));
                            return function(e) {
                                return t.apply(this, arguments);
                            };
                        }()).then(function() {
                            var t = (0, s.default)(i.default.mark(function t(r) {
                                var s;
                                return i.default.wrap(function(t) {
                                    for(;;)switch(t.prev = t.next){
                                        case 0:
                                            if (!_ || o) {
                                                t.next = 19;
                                                break;
                                            }
                                            if (r.contractAddress) {
                                                t.next = 5;
                                                break;
                                            }
                                            return a && (x.unsubscribe(), o = !0), h._fireError(d.NoContractAddressFoundError(r), e.eventEmitter, e.reject, null, r), t.abrupt("return");
                                        case 5:
                                            return t.prev = 5, t.next = 8, S.getCode(r.contractAddress);
                                        case 8:
                                            s = t.sent, t.next = 13;
                                            break;
                                        case 11:
                                            t.prev = 11, t.t0 = t.catch(5);
                                        case 13:
                                            if (s) {
                                                t.next = 15;
                                                break;
                                            }
                                            return t.abrupt("return");
                                        case 15:
                                            !0 === r.status && A || s.length > 2 ? (e.eventEmitter.emit("receipt", r), n.extraFormatters && n.extraFormatters.contractDeployFormatter ? e.resolve(n.extraFormatters.contractDeployFormatter(r)) : e.resolve(r), a && e.eventEmitter.removeAllListeners()) : h._fireError(d.ContractCodeNotStoredError(r), e.eventEmitter, e.reject, null, r), a && x.unsubscribe(), o = !0;
                                        case 19:
                                            return t.abrupt("return", r);
                                        case 20:
                                        case "end":
                                            return t.stop();
                                    }
                                }, t, null, [
                                    [
                                        5,
                                        11
                                    ]
                                ]);
                            }));
                            return function(e) {
                                return t.apply(this, arguments);
                            };
                        }()).then(function() {
                            var t = (0, s.default)(i.default.mark(function t(s) {
                                var u, c, f, p;
                                return i.default.wrap(function(t) {
                                    for(;;)switch(t.prev = t.next){
                                        case 0:
                                            if (_ || o) {
                                                t.next = 35;
                                                break;
                                            }
                                            if (s.outOfGas || k && k === s.gasUsed || !0 !== s.status && "0x1" !== s.status && void 0 !== s.status) {
                                                t.next = 7;
                                                break;
                                            }
                                            e.eventEmitter.emit("receipt", s), e.resolve(s), a && e.eventEmitter.removeAllListeners(), t.next = 33;
                                            break;
                                        case 7:
                                            if (JSON.stringify(s, null, 2), !1 !== s.status && "0x0" !== s.status) {
                                                t.next = 32;
                                                break;
                                            }
                                            if (t.prev = 9, u = null, !n.handleRevert || "eth_sendTransaction" !== n.call && "eth_sendRawTransaction" !== n.call) {
                                                t.next = 24;
                                                break;
                                            }
                                            return c = r.params[0], "eth_sendRawTransaction" === n.call && (f = r.params[0], p = y.parse(f), c = l.inputTransactionFormatter({
                                                data: p.data,
                                                to: p.to,
                                                from: p.from,
                                                gas: p.gasLimit.toHexString(),
                                                gasPrice: p.gasPrice ? p.gasPrice.toHexString() : void 0,
                                                value: p.value.toHexString()
                                            })), t.next = 16, n.getRevertReason(c, s.blockNumber);
                                        case 16:
                                            if (!(u = t.sent)) {
                                                t.next = 21;
                                                break;
                                            }
                                            h._fireError(d.TransactionRevertInstructionError(u.reason, u.signature, s), e.eventEmitter, e.reject, null, s), t.next = 22;
                                            break;
                                        case 21:
                                            throw !1;
                                        case 22:
                                            t.next = 25;
                                            break;
                                        case 24:
                                            throw !1;
                                        case 25:
                                            t.next = 30;
                                            break;
                                        case 27:
                                            t.prev = 27, t.t0 = t.catch(9), h._fireError(d.TransactionRevertedWithoutReasonError(s), e.eventEmitter, e.reject, null, s);
                                        case 30:
                                            t.next = 33;
                                            break;
                                        case 32:
                                            h._fireError(d.TransactionOutOfGasError(s), e.eventEmitter, e.reject, null, s);
                                        case 33:
                                            a && x.unsubscribe(), o = !0;
                                        case 35:
                                        case "end":
                                            return t.stop();
                                    }
                                }, t, null, [
                                    [
                                        9,
                                        27
                                    ]
                                ]);
                            }));
                            return function(e) {
                                return t.apply(this, arguments);
                            };
                        }()).catch(function() {
                            c++, b ? c - 1 >= n.transactionPollingTimeout && (x.unsubscribe(), o = !0, h._fireError(d.TransactionError("Transaction was not mined within " + n.transactionPollingTimeout + " seconds, please make sure your transaction was properly sent. Be aware that it might still be mined!"), e.eventEmitter, e.reject)) : c - 1 >= n.transactionBlockTimeout && (x.unsubscribe(), o = !0, h._fireError(d.TransactionError("Transaction was not mined within " + n.transactionBlockTimeout + " blocks, please make sure your transaction was properly sent. Be aware that it might still be mined!"), e.eventEmitter, e.reject));
                        });
                        x.unsubscribe(), o = !0, h._fireError({
                            message: "Failed to subscribe to new newBlockHeaders to confirm the transaction receipts.",
                            data: v
                        }, e.eventEmitter, e.reject);
                    }, B = (function(e) {
                        var t = !1, r = function() {
                            m = setInterval(x.bind(null, e, !0), n.transactionPollingInterval);
                        };
                        if (!this.requestManager.provider.on) return r();
                        S.subscribe("newBlockHeaders", function(n, i, o) {
                            if (t = !0, n || !i) return r();
                            x(e, !1, n, 0, o);
                        }), g = setTimeout(function() {
                            t || r();
                        }, 1e3 * this.blockHeaderTimeout);
                    }).bind(this);
                    S.getTransactionReceipt(t).then(function(t) {
                        t && t.blockHash ? (e.eventEmitter.listeners("confirmation").length > 0 && B(t), x(t, !1)) : o || B();
                    }).catch(function() {
                        o || B();
                    });
                };
                var m = function(e, t) {
                    return "number" == typeof e ? t.wallet[e] : e && "object" === (0, u.default)(e) && e.address && e.privateKey ? e : t.wallet[e.toLowerCase()];
                };
                v.prototype.buildCall = function() {
                    var e = this, t = "eth_sendTransaction" === e.call || "eth_sendRawTransaction" === e.call, r = "eth_call" === e.call, n = function() {
                        var n = Array.prototype.slice.call(arguments), i = p(!t), a = e.toPayload(n);
                        e.hexFormat = !1, "eth_getTransactionReceipt" !== e.call && "eth_getTransactionByHash" !== e.call && "getBlock" !== e.name || (e.hexFormat = a.params.length < n.length && "hex" === n[n.length - 1]);
                        var s = function(n, o) {
                            if (e.handleRevert && r && e.abiCoder) {
                                var s;
                                if (!n && e.isRevertReasonString(o)) s = o.substring(10);
                                else if (n && n.data) {
                                    var c;
                                    s = "object" === (0, u.default)(n.data) ? (null !== (c = n.data.originalError) && void 0 !== c ? c : n.data).data.substring(10) : n.data.substring(10);
                                }
                                if (s) {
                                    var f = e.abiCoder.decodeParameter("string", "0x" + s), l = "Error(String)";
                                    return void h._fireError(d.RevertInstructionError(f, l), i.eventEmitter, i.reject, a.callback, {
                                        reason: f,
                                        signature: l
                                    });
                                }
                            }
                            try {
                                o = e.formatOutput(o);
                            } catch (e) {
                                n = e;
                            }
                            if (o instanceof Error && (n = o), n) return n.error && (n = n.error), h._fireError(n, i.eventEmitter, i.reject, a.callback);
                            a.callback && a.callback(null, o), t ? (i.eventEmitter.emit("transactionHash", o), e._confirmTransaction(i, o, a)) : n || i.resolve(o);
                        }, c = function(t) {
                            var r = f(f({}, a), {}, {
                                method: "eth_sendRawTransaction",
                                params: [
                                    t.rawTransaction
                                ]
                            });
                            e.requestManager.send(r, s);
                        }, l = function(e, t) {
                            var r;
                            if (t && t.accounts && t.accounts.wallet && t.accounts.wallet.length) {
                                if ("eth_sendTransaction" === e.method) {
                                    var n = e.params[0];
                                    if ((r = m(n && "object" === (0, u.default)(n) ? n.from : null, t.accounts)) && r.privateKey) return delete (n = JSON.parse(JSON.stringify(n))).from, t.defaultChain && !n.chain && (n.chain = t.defaultChain), t.defaultHardfork && !n.hardfork && (n.hardfork = t.defaultHardfork), t.defaultCommon && !n.common && (n.common = t.defaultCommon), void t.accounts.signTransaction(n, r.privateKey).then(c).catch(function(e) {
                                        if ("function" == typeof i.eventEmitter.listeners && i.eventEmitter.listeners("error").length) {
                                            try {
                                                i.eventEmitter.emit("error", e);
                                            } catch (e) {}
                                            i.eventEmitter.removeAllListeners(), i.eventEmitter.catch(function() {});
                                        }
                                        i.reject(e);
                                    });
                                } else if ("eth_sign" === e.method) {
                                    var o = e.params[1];
                                    if ((r = m(e.params[0], t.accounts)) && r.privateKey) {
                                        var a = t.accounts.sign(o, r.privateKey);
                                        return e.callback && e.callback(null, a.signature), void i.resolve(a.signature);
                                    }
                                }
                            }
                            return t.requestManager.send(e, s);
                        }, b = t && !!a.params[0] && "object" === (0, u.default)(a.params[0]);
                        return b && "0x1" === a.params[0].type && void 0 === a.params[0].accessList && (a.params[0].accessList = []), !b || void 0 !== a.params[0].gasPrice || void 0 !== a.params[0].maxPriorityFeePerGas && void 0 !== a.params[0].maxFeePerGas ? (t && setTimeout(function() {
                            i.eventEmitter.emit("sending", a);
                        }, 0), l(a, e)) : (function(e, t) {
                            return new Promise(function(r, n) {
                                try {
                                    var i = new v({
                                        name: "getBlockByNumber",
                                        call: "eth_getBlockByNumber",
                                        params: 2,
                                        inputFormatter: [
                                            function(e) {
                                                return e ? h.toHex(e) : "latest";
                                            },
                                            function() {
                                                return !1;
                                            }
                                        ]
                                    }).createFunction(e.requestManager), a = new v({
                                        name: "getGasPrice",
                                        call: "eth_gasPrice",
                                        params: 0
                                    }).createFunction(e.requestManager);
                                    Promise.all([
                                        i(),
                                        a()
                                    ]).then(function(e) {
                                        var n = (0, o.default)(e, 2), i = n[0], a = n[1];
                                        if (("0x2" === t.type || void 0 === t.type) && i && i.baseFeePerGas) {
                                            var s, u;
                                            t.gasPrice ? (s = t.gasPrice, u = t.gasPrice, delete t.gasPrice) : (s = t.maxPriorityFeePerGas || "0x9502F900", u = t.maxFeePerGas || h.toHex(h.toBN(i.baseFeePerGas).mul(h.toBN(2)).add(h.toBN(s)))), r({
                                                maxFeePerGas: u,
                                                maxPriorityFeePerGas: s
                                            });
                                        } else {
                                            if (t.maxPriorityFeePerGas || t.maxFeePerGas) throw Error("Network doesn't support eip-1559");
                                            r({
                                                gasPrice: a
                                            });
                                        }
                                    });
                                } catch (e) {
                                    n(e);
                                }
                            });
                        })(e, a.params[0]).then(function(r) {
                            void 0 !== r.gasPrice ? a.params[0].gasPrice = r.gasPrice : void 0 !== r.maxPriorityFeePerGas && void 0 !== r.maxFeePerGas && (a.params[0].maxPriorityFeePerGas = r.maxPriorityFeePerGas, a.params[0].maxFeePerGas = r.maxFeePerGas), t && setTimeout(function() {
                                i.eventEmitter.emit("sending", a);
                            }, 0), l(a, e);
                        }), t && setTimeout(function() {
                            i.eventEmitter.emit("sent", a);
                        }, 0), i.eventEmitter;
                    };
                    return n.method = e, n.request = this.request.bind(this), n;
                }, v.prototype.getRevertReason = function(e, t) {
                    var r = this;
                    return new Promise(function(n, i) {
                        new v({
                            name: "call",
                            call: "eth_call",
                            params: 2,
                            abiCoder: r.abiCoder,
                            handleRevert: !0
                        }).createFunction(r.requestManager)(e, h.numberToHex(t)).then(function() {
                            n(!1);
                        }).catch(function(e) {
                            e.reason ? n({
                                reason: e.reason,
                                signature: e.signature
                            }) : i(e);
                        });
                    });
                }, v.prototype.isRevertReasonString = function(e) {
                    return "string" == typeof e && (e.length - 2) / 2 % 32 == 4 && "0x08c379a0" === e.substring(0, 10);
                }, v.prototype.request = function() {
                    var e = this.toPayload(Array.prototype.slice.call(arguments));
                    return e.format = this.formatOutput.bind(this), e;
                }, e.exports = v;
            },
            90282: (e, t, r)=>{
                "use strict";
                var n = r(98008), i = function(e) {
                    var t, r, i = new Promise(function() {
                        t = arguments[0], r = arguments[1];
                    });
                    if (e) return {
                        resolve: t,
                        reject: r,
                        eventEmitter: i
                    };
                    var o = new n;
                    return i._events = o._events, i.emit = o.emit, i.on = o.on, i.once = o.once, i.off = o.off, i.listeners = o.listeners, i.addListener = o.addListener, i.removeListener = o.removeListener, i.removeAllListeners = o.removeAllListeners, {
                        resolve: t,
                        reject: r,
                        eventEmitter: i
                    };
                };
                i.resolve = function(e) {
                    var t = i(!0);
                    return t.resolve(e), t.eventEmitter;
                }, e.exports = i;
            },
            35229: (e, t, r)=>{
                "use strict";
                var n = r(48155), i = r(11314).errors, o = function(e) {
                    this.requestManager = e, this.requests = [];
                };
                o.prototype.add = function(e) {
                    this.requests.push(e);
                }, o.prototype.execute = function() {
                    var e = this.requests, t = this._sortResponses.bind(this);
                    this.requestManager.sendBatch(e, function(r, o) {
                        o = t(o), e.map(function(e, t) {
                            return o[t] || {};
                        }).forEach(function(t, r) {
                            if (e[r].callback) {
                                if (t && t.error) return e[r].callback(i.ErrorResponse(t));
                                if (!n.isValidResponse(t)) return e[r].callback(i.InvalidResponse(t));
                                try {
                                    e[r].callback(null, e[r].format ? e[r].format(t.result) : t.result);
                                } catch (t) {
                                    e[r].callback(t);
                                }
                            }
                        });
                    });
                }, o.prototype._sortResponses = function(e) {
                    return (e || []).sort(function(e, t) {
                        return e.id - t.id;
                    });
                }, e.exports = o;
            },
            99764: (e, t, r)=>{
                "use strict";
                var n = r(28847)(r(3355)), i = null, o = "object" === ("undefined" == typeof globalThis ? "undefined" : (0, n.default)(globalThis)) ? globalThis : void 0;
                if (!o) try {
                    o = Function("return this")();
                } catch (e) {
                    o = self;
                }
                void 0 !== o.ethereum ? i = o.ethereum : void 0 !== o.web3 && o.web3.currentProvider && (o.web3.currentProvider.sendAsync && (o.web3.currentProvider.send = o.web3.currentProvider.sendAsync, delete o.web3.currentProvider.sendAsync), !o.web3.currentProvider.on && o.web3.currentProvider.connection && "ipcProviderWrapper" === o.web3.currentProvider.connection.constructor.name && (o.web3.currentProvider.on = function(e, t) {
                    if ("function" != typeof t) throw new Error("The second parameter callback must be a function.");
                    "data" === e ? this.connection.on("data", function(e) {
                        var r = "";
                        e = e.toString();
                        try {
                            r = JSON.parse(e);
                        } catch (r) {
                            return t(new Error("Couldn't parse response data" + e));
                        }
                        r.id || -1 === r.method.indexOf("_subscription") || t(null, r);
                    }) : this.connection.on(e, t);
                }), i = o.web3.currentProvider), e.exports = i;
            },
            92033: (e, t, r)=>{
                "use strict";
                var n = r(28847)(r(3355)), i = r(45058).callbackify, o = r(11314).errors, a = r(48155), s = r(35229), u = r(99764), c = function e(t, r) {
                    this.provider = null, this.providers = e.providers, this.setProvider(t, r), this.subscriptions = new Map;
                };
                c.givenProvider = u, c.providers = {
                    WebsocketProvider: r(77651),
                    HttpProvider: r(14565),
                    IpcProvider: r(52683)
                }, c.prototype.setProvider = function(e, t) {
                    var r = this;
                    if (e && "string" == typeof e && this.providers) {
                        if (/^http(s)?:\/\//i.test(e)) e = new this.providers.HttpProvider(e);
                        else if (/^ws(s)?:\/\//i.test(e)) e = new this.providers.WebsocketProvider(e);
                        else if (e && "object" === (0, n.default)(t) && "function" == typeof t.connect) e = new this.providers.IpcProvider(e, t);
                        else if (e) throw new Error("Can't autodetect provider for \"" + e + '"');
                    }
                    this.provider && this.provider.connected && this.clearSubscriptions(), this.provider = e || null, this.provider && this.provider.on && ("function" == typeof e.request ? this.provider.on("message", function(e) {
                        if (e && "eth_subscription" === e.type && e.data) {
                            var t = e.data;
                            t.subscription && r.subscriptions.has(t.subscription) && r.subscriptions.get(t.subscription).callback(null, t.result);
                        }
                    }) : this.provider.on("data", function(e, t) {
                        (e = e || t).method && e.params && e.params.subscription && r.subscriptions.has(e.params.subscription) && r.subscriptions.get(e.params.subscription).callback(null, e.params.result);
                    }), this.provider.on("connect", function() {
                        r.subscriptions.forEach(function(e) {
                            e.subscription.resubscribe();
                        });
                    }), this.provider.on("error", function(e) {
                        r.subscriptions.forEach(function(t) {
                            t.callback(e);
                        });
                    }), this.provider.on("disconnect", function(e) {
                        r._isCleanCloseEvent(e) && !r._isIpcCloseError(e) || (r.subscriptions.forEach(function(t) {
                            t.callback(o.ConnectionCloseError(e)), r.subscriptions.delete(t.subscription.id);
                        }), r.provider && r.provider.emit && r.provider.emit("error", o.ConnectionCloseError(e))), r.provider && r.provider.emit && r.provider.emit("end", e);
                    }));
                }, c.prototype.send = function(e, t) {
                    if (t = t || function() {}, !this.provider) return t(o.InvalidProvider());
                    var r = e.method, n = e.params, s = a.toPayload(r, n), u = this._jsonrpcResultCallback(t, s);
                    if (this.provider.request) i(this.provider.request.bind(this.provider))({
                        method: r,
                        params: n
                    }, t);
                    else if (this.provider.sendAsync) this.provider.sendAsync(s, u);
                    else {
                        if (!this.provider.send) throw new Error("Provider does not have a request or send method to use.");
                        this.provider.send(s, u);
                    }
                }, c.prototype.sendBatch = function(e, t) {
                    if (!this.provider) return t(o.InvalidProvider());
                    var r = a.toBatchPayload(e);
                    this.provider[this.provider.sendAsync ? "sendAsync" : "send"](r, function(e, r) {
                        return e ? t(e) : Array.isArray(r) ? void t(null, r) : t(o.InvalidResponse(r));
                    });
                }, c.prototype.addSubscription = function(e, t) {
                    if (!this.provider.on) throw new Error("The provider doesn't support subscriptions: " + this.provider.constructor.name);
                    this.subscriptions.set(e.id, {
                        callback: t,
                        subscription: e
                    });
                }, c.prototype.removeSubscription = function(e, t) {
                    if (this.subscriptions.has(e)) {
                        var r = this.subscriptions.get(e).subscription.options.type;
                        return this.subscriptions.delete(e), void this.send({
                            method: r + "_unsubscribe",
                            params: [
                                e
                            ]
                        }, t);
                    }
                    "function" == typeof t && t(null);
                }, c.prototype.clearSubscriptions = function(e) {
                    try {
                        var t = this;
                        return this.subscriptions.size > 0 && this.subscriptions.forEach(function(r, n) {
                            e && "syncing" === r.name || t.removeSubscription(n);
                        }), this.provider.reset && this.provider.reset(), !0;
                    } catch (e) {
                        throw new Error("Error while clearing subscriptions: ".concat(e));
                    }
                }, c.prototype._isCleanCloseEvent = function(e) {
                    return "object" === (0, n.default)(e) && ([
                        1e3
                    ].includes(e.code) || !0 === e.wasClean);
                }, c.prototype._isIpcCloseError = function(e) {
                    return "boolean" == typeof e && e;
                }, c.prototype._jsonrpcResultCallback = function(e, t) {
                    return function(r, n) {
                        return n && n.id && t.id !== n.id ? e(new Error("Wrong response id ".concat(n.id, " (expected: ").concat(t.id, ") in ").concat(JSON.stringify(t)))) : r ? e(r) : n && n.error ? e(o.ErrorResponse(n)) : a.isValidResponse(n) ? void e(null, n.result) : e(o.InvalidResponse(n));
                    };
                }, e.exports = {
                    Manager: c,
                    BatchManager: s
                };
            },
            48155: (e)=>{
                "use strict";
                var t = {
                    messageId: Math.floor(Math.random() * Number.MAX_SAFE_INTEGER),
                    toPayload: function(e, r) {
                        if (!e) throw new Error('JSONRPC method should be specified for params: "' + JSON.stringify(r) + '"!');
                        return t.messageId === Number.MAX_SAFE_INTEGER ? t.messageId = Math.floor(Math.random() * Number.MAX_SAFE_INTEGER) : t.messageId++, {
                            jsonrpc: "2.0",
                            id: t.messageId,
                            method: e,
                            params: r || []
                        };
                    },
                    isValidResponse: function(e) {
                        return Array.isArray(e) ? e.every(t) : t(e);
                        function t(e) {
                            return !(!e || e.error || "2.0" !== e.jsonrpc || "number" != typeof e.id && "string" != typeof e.id || void 0 === e.result);
                        }
                    },
                    toBatchPayload: function(e) {
                        return e.map(function(e) {
                            return t.toPayload(e.method, e.params);
                        });
                    }
                };
                e.exports = t;
            },
            34178: (e, t, r)=>{
                "use strict";
                var n = r(42929), i = function(e) {
                    this.name = e.name, this.type = e.type, this.subscriptions = e.subscriptions || {}, this.requestManager = null;
                };
                i.prototype.setRequestManager = function(e) {
                    this.requestManager = e;
                }, i.prototype.attachToObject = function(e) {
                    var t = this.buildCall(), r = this.name.split(".");
                    r.length > 1 ? (e[r[0]] = e[r[0]] || {}, e[r[0]][r[1]] = t) : e[r[0]] = t;
                }, i.prototype.buildCall = function() {
                    var e = this;
                    return function() {
                        e.subscriptions[arguments[0]] || console.warn("Subscription " + JSON.stringify(arguments[0]) + " doesn't exist. Subscribing anyway.");
                        var t = new n({
                            subscription: e.subscriptions[arguments[0]] || {},
                            requestManager: e.requestManager,
                            type: e.type
                        });
                        return t.subscribe.apply(t, arguments);
                    };
                }, e.exports = {
                    subscriptions: i,
                    subscription: n
                };
            },
            42929: (e, t, r)=>{
                "use strict";
                var n = r(28847)(r(3355)), i = r(11314).errors, o = r(98008), a = r(11314).formatters;
                function s(e) {
                    return e;
                }
                function u(e) {
                    o.call(this), this.id = null, this.callback = s, this.arguments = null, this.lastBlock = null, this.options = {
                        subscription: e.subscription,
                        type: e.type,
                        requestManager: e.requestManager
                    };
                }
                u.prototype = Object.create(o.prototype), u.prototype.constructor = u, u.prototype._extractCallback = function(e) {
                    if ("function" == typeof e[e.length - 1]) return e.pop();
                }, u.prototype._validateArgs = function(e) {
                    var t = this.options.subscription;
                    if (t || (t = {}), t.params || (t.params = 0), e.length !== t.params) throw i.InvalidNumberOfParams(e.length, t.params, t.subscriptionName);
                }, u.prototype._formatInput = function(e) {
                    var t = this.options.subscription;
                    return t && t.inputFormatter ? t.inputFormatter.map(function(t, r) {
                        return t ? t(e[r]) : e[r];
                    }) : e;
                }, u.prototype._formatOutput = function(e) {
                    var t = this.options.subscription;
                    return t && t.outputFormatter && e ? t.outputFormatter(e) : e;
                }, u.prototype._toPayload = function(e) {
                    var t = [];
                    if (this.callback = this._extractCallback(e) || s, this.subscriptionMethod || (this.subscriptionMethod = e.shift(), this.options.subscription.subscriptionName && (this.subscriptionMethod = this.options.subscription.subscriptionName)), this.arguments || (this.arguments = this._formatInput(e), this._validateArgs(this.arguments), e = []), t.push(this.subscriptionMethod), t = t.concat(this.arguments), e.length) throw new Error("Only a callback is allowed as parameter on an already instantiated subscription.");
                    return {
                        method: this.options.type + "_subscribe",
                        params: t
                    };
                }, u.prototype.unsubscribe = function(e) {
                    this.options.requestManager.removeSubscription(this.id, e), this.id = null, this.lastBlock = null, this.removeAllListeners();
                }, u.prototype.subscribe = function() {
                    var e = this, t = Array.prototype.slice.call(arguments), r = this._toPayload(t);
                    if (!r) return this;
                    if (!this.options.requestManager.provider) return setTimeout(function() {
                        var t = new Error("No provider set.");
                        e.callback(t, null, e), e.emit("error", t);
                    }, 0), this;
                    if (!this.options.requestManager.provider.on) return setTimeout(function() {
                        var t = new Error("The current provider doesn't support subscriptions: " + e.options.requestManager.provider.constructor.name);
                        e.callback(t, null, e), e.emit("error", t);
                    }, 0), this;
                    if (this.lastBlock && this.options.params && "object" === (0, n.default)(this.options.params) && (r.params[1] = this.options.params, r.params[1].fromBlock = a.inputBlockNumberFormatter(this.lastBlock + 1)), this.id && this.unsubscribe(), this.options.params = r.params[1], "logs" === r.params[0] && r.params[1] && "object" === (0, n.default)(r.params[1]) && r.params[1].hasOwnProperty("fromBlock") && isFinite(r.params[1].fromBlock)) {
                        var i = Object.assign({}, r.params[1]);
                        this.options.requestManager.send({
                            method: "eth_getLogs",
                            params: [
                                i
                            ]
                        }, function(t, r) {
                            t ? setTimeout(function() {
                                e.callback(t, null, e), e.emit("error", t);
                            }, 0) : r.forEach(function(t) {
                                var r = e._formatOutput(t);
                                e.callback(null, r, e), e.emit("data", r);
                            });
                        });
                    }
                    return "object" === (0, n.default)(r.params[1]) && delete r.params[1].fromBlock, this.options.requestManager.send(r, function(t, i) {
                        !t && i ? (e.id = i, e.method = r.params[0], e.options.requestManager.addSubscription(e, function(t, r) {
                            t ? (e.callback(t, !1, e), e.emit("error", t)) : (Array.isArray(r) || (r = [
                                r
                            ]), r.forEach(function(t) {
                                var r = e._formatOutput(t);
                                if (e.lastBlock = r && "object" === (0, n.default)(r) ? r.blockNumber : null, "function" == typeof e.options.subscription.subscriptionHandler) return e.options.subscription.subscriptionHandler.call(e, r);
                                e.emit("data", r), e.callback(null, r, e);
                            }));
                        }), e.emit("connected", i)) : setTimeout(function() {
                            e.callback(t, !1, e), e.emit("error", t);
                        }, 0);
                    }), this;
                }, u.prototype.resubscribe = function() {
                    this.options.requestManager.removeSubscription(this.id), this.id = null, this.subscribe(this.callback);
                }, e.exports = u;
            },
            1949: (e, t, r)=>{
                "use strict";
                var n = r(11314).formatters, i = r(53349), o = r(48161);
                e.exports = function(e) {
                    var t = function(t) {
                        var r;
                        return t.property ? (e[t.property] || (e[t.property] = {}), r = e[t.property]) : r = e, t.methods && t.methods.forEach(function(t) {
                            t instanceof i || (t = new i(t)), t.attachToObject(r), t.setRequestManager(e._requestManager);
                        }), e;
                    };
                    return t.formatters = n, t.utils = o, t.Method = i, t;
                };
            },
            80606: (e, t, r)=>{
                "use strict";
                var n = r(92033), i = r(1949);
                e.exports = {
                    packageInit: function(e, t) {
                        if (t = Array.prototype.slice.call(t), !e) throw new Error('You need to instantiate using the "new" keyword.');
                        Object.defineProperty(e, "currentProvider", {
                            get: function() {
                                return e._provider;
                            },
                            set: function(t) {
                                return e.setProvider(t);
                            },
                            enumerable: !0,
                            configurable: !0
                        }), t[0] && t[0]._requestManager ? e._requestManager = t[0]._requestManager : e._requestManager = new n.Manager(t[0], t[1]), e.givenProvider = n.Manager.givenProvider, e.providers = n.Manager.providers, e._provider = e._requestManager.provider, e.setProvider || (e.setProvider = function(t, r) {
                            return e._requestManager.setProvider(t, r), e._provider = e._requestManager.provider, !0;
                        }), e.setRequestManager = function(t) {
                            e._requestManager = t, e._provider = t.provider;
                        }, e.BatchRequest = n.BatchManager.bind(null, e._requestManager), e.extend = i(e);
                    },
                    addProviders: function(e) {
                        e.givenProvider = n.Manager.givenProvider, e.providers = n.Manager.providers;
                    }
                };
            },
            79901: (e, t, r)=>{
                "use strict";
                var n = r(28847)(r(3355)), i = r(29033).Buffer, o = r(48161), a = r(62914).RQ, s = r(62914)._R, u = new a(function(e, t) {
                    return !e.match(/^u?int/) || Array.isArray(t) || t && "object" === (0, n.default)(t) && "BN" === t.constructor.name ? t : t.toString();
                });
                function c() {}
                var f = function() {};
                f.prototype.encodeFunctionSignature = function(e) {
                    return ("function" == typeof e || "object" === (0, n.default)(e) && e) && (e = o._jsonInterfaceMethodToString(e)), o.sha3(e).slice(0, 10);
                }, f.prototype.encodeEventSignature = function(e) {
                    return ("function" == typeof e || "object" === (0, n.default)(e) && e) && (e = o._jsonInterfaceMethodToString(e)), o.sha3(e);
                }, f.prototype.encodeParameter = function(e, t) {
                    return this.encodeParameters([
                        e
                    ], [
                        t
                    ]);
                }, f.prototype.encodeParameters = function(e, t) {
                    var r = this;
                    return e = r.mapTypes(e), t = t.map(function(t, i) {
                        var o = e[i];
                        return "object" === (0, n.default)(o) && o.type && (o = o.type), t = r.formatParam(o, t), "string" == typeof o && o.includes("tuple") && function e(t, n) {
                            if ("array" === t.name) {
                                if (!t.type.match(/\[(\d+)\]/)) return n.map(function(r) {
                                    return e(u._getCoder(s.from(t.type.replace("[]", ""))), r);
                                });
                                var i = parseInt(t.type.match(/\[(\d+)\]/)[1]);
                                if (n.length !== i) throw new Error("Array length does not matches with the given input");
                                return n.map(function(r) {
                                    return e(u._getCoder(s.from(t.type.replace(/\[\d+\]/, ""))), r);
                                });
                            }
                            t.coders.forEach(function(t, i) {
                                "tuple" === t.name ? e(t, n[i]) : n[i] = r.formatParam(t.name, n[i]);
                            });
                        }(u._getCoder(s.from(o)), t), t;
                    }), u.encode(e, t);
                }, f.prototype.mapTypes = function(e) {
                    var t = this, r = [];
                    return e.forEach(function(e) {
                        if ("object" === (0, n.default)(e) && "function" === e.type && (e = Object.assign({}, e, {
                            type: "bytes24"
                        })), t.isSimplifiedStructFormat(e)) {
                            var i = Object.keys(e)[0];
                            r.push(Object.assign(t.mapStructNameAndType(i), {
                                components: t.mapStructToCoderFormat(e[i])
                            }));
                        } else r.push(e);
                    }), r;
                }, f.prototype.isSimplifiedStructFormat = function(e) {
                    return "object" === (0, n.default)(e) && void 0 === e.components && void 0 === e.name;
                }, f.prototype.mapStructNameAndType = function(e) {
                    var t = "tuple";
                    return e.indexOf("[]") > -1 && (t = "tuple[]", e = e.slice(0, -2)), {
                        type: t,
                        name: e
                    };
                }, f.prototype.mapStructToCoderFormat = function(e) {
                    var t = this, r = [];
                    return Object.keys(e).forEach(function(i) {
                        "object" !== (0, n.default)(e[i]) ? r.push({
                            name: i,
                            type: e[i]
                        }) : r.push(Object.assign(t.mapStructNameAndType(i), {
                            components: t.mapStructToCoderFormat(e[i])
                        }));
                    }), r;
                }, f.prototype.formatParam = function(e, t) {
                    var r = this, n = new RegExp(/^bytes([0-9]*)$/), a = new RegExp(/^bytes([0-9]*)\[\]$/), s = new RegExp(/^(u?int)([0-9]*)$/), u = new RegExp(/^(u?int)([0-9]*)\[\]$/);
                    if (o.isBN(t) || o.isBigNumber(t)) return t.toString(10);
                    if (e.match(a) || e.match(u)) return t.map(function(t) {
                        return r.formatParam(e.replace("[]", ""), t);
                    });
                    var c = e.match(s);
                    if (c) {
                        var f = parseInt(c[2] || "256");
                        f / 8 < t.length && (t = t.startsWith("-") ? "-".concat(o.leftPad(t.substring(1), f)) : o.leftPad(t, f));
                    }
                    if (c = e.match(n)) {
                        i.isBuffer(t) && (t = o.toHex(t));
                        var d = parseInt(c[1]);
                        if (d) {
                            var l = 2 * d;
                            "0x" === t.substring(0, 2) && (l += 2), t.length < l && (t = o.rightPad(t, 2 * d));
                        }
                        t.length % 2 == 1 && (t = "0x0" + t.substring(2));
                    }
                    return t;
                }, f.prototype.encodeFunctionCall = function(e, t) {
                    return this.encodeFunctionSignature(e) + this.encodeParameters(e.inputs, t).replace("0x", "");
                }, f.prototype.decodeParameter = function(e, t) {
                    return this.decodeParameters([
                        e
                    ], t)[0];
                }, f.prototype.decodeParameters = function(e, t) {
                    return this.decodeParametersWith(e, t, !1);
                }, f.prototype.decodeParametersWith = function(e, t, r) {
                    if (e.length > 0 && (!t || "0x" === t || "0X" === t)) throw new Error("Returned values aren't valid, did it run Out of Gas? You might also see this error if you are not using the correct ABI for the contract you are retrieving data from, requesting data from a block number that does not exist, or querying a node which is not fully synced.");
                    var i = u.decode(this.mapTypes(e), "0x" + t.replace(/0x/i, ""), r), o = new c;
                    return o.__length__ = 0, e.forEach(function(e, t) {
                        var r = i[o.__length__], a = "object" === (0, n.default)(e) && e.type && "string" === e.type;
                        r = "0x" !== r || a || "string" == typeof e && "string" === e ? r : null, o[t] = r, ("function" == typeof e || e && "object" === (0, n.default)(e)) && e.name && (o[e.name] = r), o.__length__++;
                    }), o;
                }, f.prototype.decodeLog = function(e, t, r) {
                    var n = this;
                    r = Array.isArray(r) ? r : [
                        r
                    ], t = t || "";
                    var i = [], o = [], a = 0;
                    e.forEach(function(e, t) {
                        e.indexed ? (o[t] = [
                            "bool",
                            "int",
                            "uint",
                            "address",
                            "fixed",
                            "ufixed"
                        ].find(function(t) {
                            return -1 !== e.type.indexOf(t);
                        }) ? n.decodeParameter(e.type, r[a]) : r[a], a++) : i[t] = e;
                    });
                    var s = t, u = s ? this.decodeParametersWith(i, s, !0) : [], f = new c;
                    return f.__length__ = 0, e.forEach(function(e, t) {
                        f[t] = "string" === e.type ? "" : null, void 0 !== u[t] && (f[t] = u[t]), void 0 !== o[t] && (f[t] = o[t]), e.name && (f[e.name] = f[t]), f.__length__++;
                    }), f;
                };
                var d = new f;
                e.exports = d;
            },
            99819: (e, t, r)=>{
                "use strict";
                var n = r(29033).Buffer, i = r(28847), o = i(r(93106)), a = i(r(3355)), s = i(r(90775)), u = i(r(74519));
                function c(e, t) {
                    var r = Object.keys(e);
                    if (Object.getOwnPropertySymbols) {
                        var n = Object.getOwnPropertySymbols(e);
                        t && (n = n.filter(function(t) {
                            return Object.getOwnPropertyDescriptor(e, t).enumerable;
                        })), r.push.apply(r, n);
                    }
                    return r;
                }
                function f(e) {
                    for(var t = 1; t < arguments.length; t++){
                        var r = null != arguments[t] ? arguments[t] : {};
                        t % 2 ? c(Object(r), !0).forEach(function(t) {
                            (0, s.default)(e, t, r[t]);
                        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : c(Object(r)).forEach(function(t) {
                            Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
                        });
                    }
                    return e;
                }
                function d(e, t) {
                    (null == t || t > e.length) && (t = e.length);
                    for(var r = 0, n = new Array(t); r < t; r++)n[r] = e[r];
                    return n;
                }
                var l = r(80606), h = r(53349), p = r(53058), b = r(24293), y = r(67799), v = r(22679), m = r(48161), g = r(11314), w = r(42339).TransactionFactory, k = r(3863).default, _ = r(3863).Hardfork, A = r(65907), E = function(e) {
                    return null == e;
                }, S = function(e) {
                    return null != e;
                }, x = function() {
                    var e = this;
                    l.packageInit(this, arguments), delete this.BatchRequest, delete this.extend;
                    var t = [
                        new h({
                            name: "getNetworkId",
                            call: "net_version",
                            params: 0,
                            outputFormatter: parseInt
                        }),
                        new h({
                            name: "getChainId",
                            call: "eth_chainId",
                            params: 0,
                            outputFormatter: m.hexToNumber
                        }),
                        new h({
                            name: "getGasPrice",
                            call: "eth_gasPrice",
                            params: 0
                        }),
                        new h({
                            name: "getTransactionCount",
                            call: "eth_getTransactionCount",
                            params: 2,
                            inputFormatter: [
                                function(e) {
                                    if (m.isAddress(e)) return e;
                                    throw new Error("Address " + e + ' is not a valid address to get the "transactionCount".');
                                },
                                function() {
                                    return "latest";
                                }
                            ]
                        }),
                        new h({
                            name: "getBlockByNumber",
                            call: "eth_getBlockByNumber",
                            params: 2,
                            inputFormatter: [
                                function(e) {
                                    return e ? m.toHex(e) : "latest";
                                },
                                function() {
                                    return !1;
                                }
                            ]
                        })
                    ];
                    this._ethereumCall = {}, t.forEach(function(t) {
                        t.attachToObject(e._ethereumCall), t.setRequestManager(e._requestManager);
                    }), this.wallet = new O(this);
                };
                function B(e, t) {
                    return new Promise(function(r, n) {
                        try {
                            (void 0 === t.type || t.type < "0x2") && void 0 !== t.gasPrice ? r({
                                gasPrice: t.gasPrice
                            }) : "0x2" === t.type && t.maxFeePerGas && t.maxPriorityFeePerGas ? r({
                                maxFeePerGas: t.maxFeePerGas,
                                maxPriorityFeePerGas: t.maxPriorityFeePerGas
                            }) : Promise.all([
                                e._ethereumCall.getBlockByNumber(),
                                e._ethereumCall.getGasPrice()
                            ]).then(function(e) {
                                var n = (0, u.default)(e, 2), i = n[0], o = n[1];
                                if ("0x2" === t.type && i && i.baseFeePerGas) {
                                    var a, s;
                                    t.gasPrice ? (a = t.gasPrice, s = t.gasPrice, delete t.gasPrice) : (a = t.maxPriorityFeePerGas || "0x9502F900", s = t.maxFeePerGas || m.toHex(m.toBN(i.baseFeePerGas).mul(m.toBN(2)).add(m.toBN(a)))), r({
                                        maxFeePerGas: s,
                                        maxPriorityFeePerGas: a
                                    });
                                } else {
                                    if (t.maxPriorityFeePerGas || t.maxFeePerGas) throw Error("Network doesn't support eip-1559");
                                    r({
                                        gasPrice: o
                                    });
                                }
                            }).catch(function(e) {
                                n(e);
                            });
                        } catch (e) {
                            n(e);
                        }
                    });
                }
                function O(e) {
                    this._accounts = e, this.length = 0, this.defaultKeyName = "web3js_wallet";
                }
                x.prototype._addAccountFunctions = function(e) {
                    var t = this;
                    return e.signTransaction = function(r, n) {
                        return t.signTransaction(r, e.privateKey, n);
                    }, e.sign = function(r) {
                        return t.sign(r, e.privateKey);
                    }, e.encrypt = function(r, n) {
                        return t.encrypt(e.privateKey, r, n);
                    }, e;
                }, x.prototype.create = function(e) {
                    return this._addAccountFunctions(p.create(e || m.randomHex(32)));
                }, x.prototype.privateKeyToAccount = function(e, t) {
                    if (e.startsWith("0x") || (e = "0x" + e), !t && 66 !== e.length) throw new Error("Private key must be 32 bytes long");
                    return this._addAccountFunctions(p.fromPrivate(e));
                }, x.prototype.signTransaction = function(e, t, r) {
                    var i = this, o = !1, a = {}, s = !(!e || !(e.chain && e.hardfork || e.common));
                    if (r = r || function() {}, !e) return o = new Error("No transaction object given!"), r(o), Promise.reject(o);
                    if (S(e.common) && E(e.common.customChain)) return o = new Error("If tx.common is provided it must have tx.common.customChain"), r(o), Promise.reject(o);
                    if (S(e.common) && E(e.common.customChain.chainId)) return o = new Error("If tx.common is provided it must have tx.common.customChain and tx.common.customChain.chainId"), r(o), Promise.reject(o);
                    if (S(e.common) && S(e.common.customChain.chainId) && S(e.chainId) && e.chainId !== e.common.customChain.chainId) return o = new Error("Chain Id doesnt match in tx.chainId tx.common.customChain.chainId"), r(o), Promise.reject(o);
                    function c(e) {
                        var i = function(e) {
                            if (e.common && e.chain && e.hardfork) return new Error("Please provide the @ethereumjs/common object or the chain and hardfork property but not all together.");
                            if (e.chain && !e.hardfork || e.hardfork && !e.chain) return new Error('When specifying chain and hardfork, both values must be defined. Received "chain": ' + e.chain + ', "hardfork": ' + e.hardfork);
                            if (!(e.gas || e.gasLimit || e.maxPriorityFeePerGas || e.maxFeePerGas)) return new Error('"gas" is missing');
                            if (e.gas && e.gasPrice) {
                                if (e.gas < 0 || e.gasPrice < 0) return new Error("Gas or gasPrice is lower than 0");
                            } else if (e.maxPriorityFeePerGas < 0 || e.maxFeePerGas < 0) return new Error("maxPriorityFeePerGas or maxFeePerGas is lower than 0");
                            return e.nonce < 0 || e.chainId < 0 ? new Error("Nonce or chainId is lower than 0") : void 0;
                        }(e);
                        if (i) return r(i), Promise.reject(i);
                        try {
                            var o = g.formatters.inputCallFormatter(Object.assign({}, e));
                            o.data = o.data || "0x", o.value = o.value || "0x", o.gasLimit = o.gasLimit || o.gas, "0x1" === o.type && void 0 === o.accessList && (o.accessList = []), s ? (o.common && (a.common = k.forCustomChain(o.common.baseChain || "mainnet", {
                                name: o.common.customChain.name || "custom-network",
                                networkId: o.common.customChain.networkId,
                                chainId: o.common.customChain.chainId
                            }, o.common.hardfork || _.London), delete o.common), o.chain && (a.chain = o.chain, delete o.chain), o.hardfork && (a.hardfork = o.hardfork, delete o.hardfork)) : (a.common = k.forCustomChain("mainnet", {
                                name: "custom-network",
                                networkId: o.networkId,
                                chainId: o.chainId
                            }, o.hardfork || _.London), delete o.networkId), t.startsWith("0x") && (t = t.substring(2));
                            var u = w.fromTxData(o, a).sign(n.from(t, "hex")), c = u.validate(!0);
                            if (c.length > 0) {
                                var f, l = "Signer Error: ", h = function(e, t) {
                                    var r = "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
                                    if (!r) {
                                        if (Array.isArray(e) || (r = function(e, t) {
                                            if (e) {
                                                if ("string" == typeof e) return d(e, t);
                                                var r = Object.prototype.toString.call(e).slice(8, -1);
                                                return "Object" === r && e.constructor && (r = e.constructor.name), "Map" === r || "Set" === r ? Array.from(e) : "Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? d(e, t) : void 0;
                                            }
                                        }(e)) || t && e && "number" == typeof e.length) {
                                            r && (e = r);
                                            var n = 0, i = function() {};
                                            return {
                                                s: i,
                                                n: function() {
                                                    return n >= e.length ? {
                                                        done: !0
                                                    } : {
                                                        done: !1,
                                                        value: e[n++]
                                                    };
                                                },
                                                e: function(e) {
                                                    throw e;
                                                },
                                                f: i
                                            };
                                        }
                                        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                                    }
                                    var o, a = !0, s = !1;
                                    return {
                                        s: function() {
                                            r = r.call(e);
                                        },
                                        n: function() {
                                            var e = r.next();
                                            return a = e.done, e;
                                        },
                                        e: function(e) {
                                            s = !0, o = e;
                                        },
                                        f: function() {
                                            try {
                                                a || null == r.return || r.return();
                                            } finally{
                                                if (s) throw o;
                                            }
                                        }
                                    };
                                }(c);
                                try {
                                    for(h.s(); !(f = h.n()).done;){
                                        var p = f.value;
                                        l += "".concat(l, " ").concat(p, ".");
                                    }
                                } catch (e) {
                                    h.e(e);
                                } finally{
                                    h.f();
                                }
                                throw new Error(l);
                            }
                            var b = "0x" + u.serialize().toString("hex"), y = m.keccak256(b), v = {
                                messageHash: "0x" + n.from(u.getMessageToSign(!0)).toString("hex"),
                                v: "0x" + u.v.toString("hex"),
                                r: "0x" + u.r.toString("hex"),
                                s: "0x" + u.s.toString("hex"),
                                rawTransaction: b,
                                transactionHash: y
                            };
                            return r(null, v), v;
                        } catch (e) {
                            return r(e), Promise.reject(e);
                        }
                    }
                    return e.type = function(e) {
                        var t, r = void 0 !== e.maxFeePerGas || void 0 !== e.maxPriorityFeePerGas;
                        if (void 0 !== e.type ? t = m.toHex(e.type) : void 0 === e.type && r && (t = "0x2"), void 0 !== e.gasPrice && ("0x2" === t || r)) throw Error("eip-1559 transactions don't support gasPrice");
                        if (("0x1" === t || "0x0" === t) && r) throw Error("pre-eip-1559 transaction don't support maxFeePerGas/maxPriorityFeePerGas");
                        return r || e.common && e.common.hardfork && e.common.hardfork.toLowerCase() === _.London || e.hardfork && e.hardfork.toLowerCase() === _.London ? t = "0x2" : (e.accessList || e.common && e.common.hardfork && e.common.hardfork.toLowerCase() === _.Berlin || e.hardfork && e.hardfork.toLowerCase() === _.Berlin) && (t = "0x1"), t;
                    }(e), void 0 !== e.nonce && void 0 !== e.chainId && (void 0 !== e.gasPrice || void 0 !== e.maxFeePerGas && void 0 !== e.maxPriorityFeePerGas) && s ? Promise.resolve(c(e)) : Promise.all([
                        E(e.common) || E(e.common.customChain.chainId) ? E(e.chainId) ? i._ethereumCall.getChainId() : e.chainId : void 0,
                        E(e.nonce) ? i._ethereumCall.getTransactionCount(i.privateKeyToAccount(t).address) : e.nonce,
                        E(s) ? i._ethereumCall.getNetworkId() : 1,
                        B(i, e)
                    ]).then(function(t) {
                        var r = (0, u.default)(t, 4), n = r[0], i = r[1], o = r[2], a = r[3];
                        if (E(n) && E(e.common) && E(e.common.customChain.chainId) || E(i) || E(o) || E(a)) throw new Error('One of the values "chainId", "networkId", "gasPrice", or "nonce" couldn\'t be fetched: ' + JSON.stringify(t));
                        return c(f(f(f({}, e), E(e.common) || E(e.common.customChain.chainId) ? {
                            chainId: n
                        } : {}), {}, {
                            nonce: i,
                            networkId: o
                        }, a));
                    });
                }, x.prototype.recoverTransaction = function(e) {
                    var t = n.from(e.slice(2), "hex"), r = w.fromSerializedData(t);
                    return m.toChecksumAddress(r.getSenderAddress().toString("hex"));
                }, x.prototype.hashMessage = function(e) {
                    var t = m.isHexStrict(e) ? e : m.utf8ToHex(e), r = m.hexToBytes(t), i = n.from(r), o = "\x19Ethereum Signed Message:\n" + r.length, a = n.from(o), s = n.concat([
                        a,
                        i
                    ]);
                    return A.bufferToHex(m.keccak256(s));
                }, x.prototype.sign = function(e, t) {
                    if (t.startsWith("0x") || (t = "0x" + t), 66 !== t.length) throw new Error("Private key must be 32 bytes long");
                    var r = this.hashMessage(e), n = p.sign(r, t), i = p.decodeSignature(n);
                    return {
                        message: e,
                        messageHash: r,
                        v: i[0],
                        r: i[1],
                        s: i[2],
                        signature: n
                    };
                }, x.prototype.recover = function(e, t, r) {
                    var n = [].slice.apply(arguments);
                    return e && "object" === (0, a.default)(e) ? this.recover(e.messageHash, p.encodeSignature([
                        e.v,
                        e.r,
                        e.s
                    ]), !0) : (r || (e = this.hashMessage(e)), n.length >= 4 ? (r = "boolean" == typeof (r = n.slice(-1)[0]) && !!r, this.recover(e, p.encodeSignature(n.slice(1, 4)), r)) : p.recover(e, t));
                }, x.prototype.decrypt = function(e, t, r) {
                    if ("string" != typeof t) throw new Error("No password given.");
                    var i, s, u = e && "object" === (0, a.default)(e) ? e : JSON.parse(r ? e.toLowerCase() : e);
                    if (3 !== u.version) throw new Error("Not a valid V3 wallet");
                    if ("scrypt" === u.crypto.kdf) s = u.crypto.kdfparams, i = y.syncScrypt(n.from(t), n.from(s.salt, "hex"), s.n, s.r, s.p, s.dklen);
                    else {
                        if ("pbkdf2" !== u.crypto.kdf) throw new Error("Unsupported key derivation scheme");
                        if ("hmac-sha256" !== (s = u.crypto.kdfparams).prf) throw new Error("Unsupported parameters to PBKDF2");
                        i = b.pbkdf2Sync(n.from(t), n.from(s.salt, "hex"), s.c, s.dklen, "sha256");
                    }
                    var c = n.from(u.crypto.ciphertext, "hex");
                    if (m.sha3(n.from([].concat((0, o.default)(i.slice(16, 32)), (0, o.default)(c)))).replace("0x", "") !== u.crypto.mac) throw new Error("Key derivation failed - possibly wrong password");
                    var f = b.createDecipheriv(u.crypto.cipher, i.slice(0, 16), n.from(u.crypto.cipherparams.iv, "hex")), d = "0x" + n.from([].concat((0, o.default)(f.update(c)), (0, o.default)(f.final()))).toString("hex");
                    return this.privateKeyToAccount(d, !0);
                }, x.prototype.encrypt = function(e, t, r) {
                    var i, a = this.privateKeyToAccount(e, !0), s = (r = r || {}).salt || b.randomBytes(32), u = r.iv || b.randomBytes(16), c = r.kdf || "scrypt", f = {
                        dklen: r.dklen || 32,
                        salt: s.toString("hex")
                    };
                    if ("pbkdf2" === c) f.c = r.c || 262144, f.prf = "hmac-sha256", i = b.pbkdf2Sync(n.from(t), n.from(f.salt, "hex"), f.c, f.dklen, "sha256");
                    else {
                        if ("scrypt" !== c) throw new Error("Unsupported kdf");
                        f.n = r.n || 8192, f.r = r.r || 8, f.p = r.p || 1, i = y.syncScrypt(n.from(t), n.from(f.salt, "hex"), f.n, f.r, f.p, f.dklen);
                    }
                    var d = b.createCipheriv(r.cipher || "aes-128-ctr", i.slice(0, 16), u);
                    if (!d) throw new Error("Unsupported cipher");
                    var l = n.from([].concat((0, o.default)(d.update(n.from(a.privateKey.replace("0x", ""), "hex"))), (0, o.default)(d.final()))), h = m.sha3(n.from([].concat((0, o.default)(i.slice(16, 32)), (0, o.default)(l)))).replace("0x", "");
                    return {
                        version: 3,
                        id: v.v4({
                            random: r.uuid || b.randomBytes(16)
                        }),
                        address: a.address.toLowerCase().replace("0x", ""),
                        crypto: {
                            ciphertext: l.toString("hex"),
                            cipherparams: {
                                iv: u.toString("hex")
                            },
                            cipher: r.cipher || "aes-128-ctr",
                            kdf: c,
                            kdfparams: f,
                            mac: h.toString("hex")
                        }
                    };
                }, O.prototype._findSafeIndex = function(e) {
                    return e = e || 0, this.hasOwnProperty(e) ? this._findSafeIndex(e + 1) : e;
                }, O.prototype._currentIndexes = function() {
                    return Object.keys(this).map(function(e) {
                        return parseInt(e);
                    }).filter(function(e) {
                        return e < 9e20;
                    });
                }, O.prototype.create = function(e, t) {
                    for(var r = 0; r < e; ++r)this.add(this._accounts.create(t).privateKey);
                    return this;
                }, O.prototype.add = function(e) {
                    return "string" == typeof e && (e = this._accounts.privateKeyToAccount(e)), this[e.address] ? this[e.address] : ((e = this._accounts.privateKeyToAccount(e.privateKey)).index = this._findSafeIndex(), this[e.index] = e, this[e.address] = e, this[e.address.toLowerCase()] = e, this.length++, e);
                }, O.prototype.remove = function(e) {
                    var t = this[e];
                    return !(!t || !t.address || (this[t.address].privateKey = null, delete this[t.address], this[t.address.toLowerCase()] && (this[t.address.toLowerCase()].privateKey = null, delete this[t.address.toLowerCase()]), this[t.index].privateKey = null, delete this[t.index], this.length--, 0));
                }, O.prototype.clear = function() {
                    var e = this;
                    return this._currentIndexes().forEach(function(t) {
                        e.remove(t);
                    }), this;
                }, O.prototype.encrypt = function(e, t) {
                    var r = this;
                    return this._currentIndexes().map(function(n) {
                        return r[n].encrypt(e, t);
                    });
                }, O.prototype.decrypt = function(e, t) {
                    var r = this;
                    return e.forEach(function(e) {
                        var n = r._accounts.decrypt(e, t);
                        if (!n) throw new Error("Couldn't decrypt accounts. Password wrong?");
                        r.add(n);
                    }), this;
                }, O.prototype.save = function(e, t) {
                    return localStorage.setItem(t || this.defaultKeyName, JSON.stringify(this.encrypt(e))), !0;
                }, O.prototype.load = function(e, t) {
                    var r = localStorage.getItem(t || this.defaultKeyName);
                    if (r) try {
                        r = JSON.parse(r);
                    } catch (e) {}
                    return this.decrypt(r || [], e);
                }, function(e) {
                    var t;
                    try {
                        t = self.localStorage;
                        var r = "__storage_test__";
                        return t.setItem(r, r), t.removeItem(r), !0;
                    } catch (e) {
                        return e && (22 === e.code || 1014 === e.code || "QuotaExceededError" === e.name || "NS_ERROR_DOM_QUOTA_REACHED" === e.name) && t && 0 !== t.length;
                    }
                }() || (delete O.prototype.save, delete O.prototype.load), e.exports = x;
            },
            58164: (e, t, r)=>{
                "use strict";
                var n = r(28847), i = n(r(93106)), o = n(r(90775)), a = n(r(3355));
                function s(e, t) {
                    (null == t || t > e.length) && (t = e.length);
                    for(var r = 0, n = new Array(t); r < t; r++)n[r] = e[r];
                    return n;
                }
                function u(e, t) {
                    var r = Object.keys(e);
                    if (Object.getOwnPropertySymbols) {
                        var n = Object.getOwnPropertySymbols(e);
                        t && (n = n.filter(function(t) {
                            return Object.getOwnPropertyDescriptor(e, t).enumerable;
                        })), r.push.apply(r, n);
                    }
                    return r;
                }
                function c(e) {
                    for(var t = 1; t < arguments.length; t++){
                        var r = null != arguments[t] ? arguments[t] : {};
                        t % 2 ? u(Object(r), !0).forEach(function(t) {
                            (0, o.default)(e, t, r[t]);
                        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : u(Object(r)).forEach(function(t) {
                            Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
                        });
                    }
                    return e;
                }
                var f = r(80606), d = r(53349), l = r(48161), h = r(34178).subscription, p = r(11314).formatters, b = r(11314).errors, y = r(90282), v = r(79901), m = function e(t, r, n) {
                    var i = this, o = Array.prototype.slice.call(arguments);
                    if (!(this instanceof e)) throw new Error('Please use the "new" keyword to instantiate a web3.eth.Contract() object!');
                    if (this.setProvider = function() {
                        f.packageInit(i, arguments), i.clearSubscriptions = i._requestManager.clearSubscriptions;
                    }, f.packageInit(this, [
                        this.constructor
                    ]), this.clearSubscriptions = this._requestManager.clearSubscriptions, !t || !Array.isArray(t)) throw b.ContractMissingABIError();
                    this.options = {};
                    var s = o[o.length - 1];
                    s && "object" === (0, a.default)(s) && !Array.isArray(s) && (n = s, this.options = c(c({}, this.options), this._getOrSetDefaultOptions(n)), r && "object" === (0, a.default)(r) && (r = null)), Object.defineProperty(this.options, "address", {
                        set: function(e) {
                            e && (i._address = l.toChecksumAddress(p.inputAddressFormatter(e)));
                        },
                        get: function() {
                            return i._address;
                        },
                        enumerable: !0
                    }), Object.defineProperty(this.options, "jsonInterface", {
                        set: function(e) {
                            return i.methods = {}, i.events = {}, i._jsonInterface = e.map(function(e) {
                                var t, r;
                                if (e.constant = "view" === e.stateMutability || "pure" === e.stateMutability || e.constant, e.payable = "payable" === e.stateMutability || e.payable, e.name && (r = l._jsonInterfaceMethodToString(e)), "function" === e.type) {
                                    if (e.signature = v.encodeFunctionSignature(r), t = i._createTxObject.bind({
                                        method: e,
                                        parent: i
                                    }), i.methods[e.name]) {
                                        var n = i._createTxObject.bind({
                                            method: e,
                                            parent: i,
                                            nextMethod: i.methods[e.name]
                                        });
                                        i.methods[e.name] = n;
                                    } else i.methods[e.name] = t;
                                    i.methods[e.signature] = t, i.methods[r] = t;
                                } else if ("event" === e.type) {
                                    e.signature = v.encodeEventSignature(r);
                                    var o = i._on.bind(i, e.signature);
                                    i.events[e.name] && "bound " !== i.events[e.name].name || (i.events[e.name] = o), i.events[e.signature] = o, i.events[r] = o;
                                }
                                return e;
                            }), i.events.allEvents = i._on.bind(i, "allevents"), i._jsonInterface;
                        },
                        get: function() {
                            return i._jsonInterface;
                        },
                        enumerable: !0
                    });
                    var u = this.constructor.defaultAccount, d = this.constructor.defaultBlock || "latest";
                    Object.defineProperty(this, "handleRevert", {
                        get: function() {
                            return !1 === i.options.handleRevert || !0 === i.options.handleRevert ? i.options.handleRevert : this.constructor.handleRevert;
                        },
                        set: function(e) {
                            i.options.handleRevert = e;
                        },
                        enumerable: !0
                    }), Object.defineProperty(this, "defaultCommon", {
                        get: function() {
                            return i.options.common || this.constructor.defaultCommon;
                        },
                        set: function(e) {
                            i.options.common = e;
                        },
                        enumerable: !0
                    }), Object.defineProperty(this, "defaultHardfork", {
                        get: function() {
                            return i.options.hardfork || this.constructor.defaultHardfork;
                        },
                        set: function(e) {
                            i.options.hardfork = e;
                        },
                        enumerable: !0
                    }), Object.defineProperty(this, "defaultChain", {
                        get: function() {
                            return i.options.chain || this.constructor.defaultChain;
                        },
                        set: function(e) {
                            i.options.chain = e;
                        },
                        enumerable: !0
                    }), Object.defineProperty(this, "transactionPollingTimeout", {
                        get: function() {
                            return 0 === i.options.transactionPollingTimeout ? i.options.transactionPollingTimeout : i.options.transactionPollingTimeout || this.constructor.transactionPollingTimeout;
                        },
                        set: function(e) {
                            i.options.transactionPollingTimeout = e;
                        },
                        enumerable: !0
                    }), Object.defineProperty(this, "transactionPollingInterval", {
                        get: function() {
                            return 0 === i.options.transactionPollingInterval ? i.options.transactionPollingInterval : i.options.transactionPollingInterval || this.constructor.transactionPollingInterval;
                        },
                        set: function(e) {
                            i.options.transactionPollingInterval = e;
                        },
                        enumerable: !0
                    }), Object.defineProperty(this, "transactionConfirmationBlocks", {
                        get: function() {
                            return 0 === i.options.transactionConfirmationBlocks ? i.options.transactionConfirmationBlocks : i.options.transactionConfirmationBlocks || this.constructor.transactionConfirmationBlocks;
                        },
                        set: function(e) {
                            i.options.transactionConfirmationBlocks = e;
                        },
                        enumerable: !0
                    }), Object.defineProperty(this, "transactionBlockTimeout", {
                        get: function() {
                            return 0 === i.options.transactionBlockTimeout ? i.options.transactionBlockTimeout : i.options.transactionBlockTimeout || this.constructor.transactionBlockTimeout;
                        },
                        set: function(e) {
                            i.options.transactionBlockTimeout = e;
                        },
                        enumerable: !0
                    }), Object.defineProperty(this, "blockHeaderTimeout", {
                        get: function() {
                            return 0 === i.options.blockHeaderTimeout ? i.options.blockHeaderTimeout : i.options.blockHeaderTimeout || this.constructor.blockHeaderTimeout;
                        },
                        set: function(e) {
                            i.options.blockHeaderTimeout = e;
                        },
                        enumerable: !0
                    }), Object.defineProperty(this, "defaultAccount", {
                        get: function() {
                            return u;
                        },
                        set: function(e) {
                            return e && (u = l.toChecksumAddress(p.inputAddressFormatter(e))), e;
                        },
                        enumerable: !0
                    }), Object.defineProperty(this, "defaultBlock", {
                        get: function() {
                            return d;
                        },
                        set: function(e) {
                            return d = e, e;
                        },
                        enumerable: !0
                    }), this.methods = {}, this.events = {}, this._address = null, this._jsonInterface = [], this.options.address = r, this.options.jsonInterface = t;
                };
                m.setProvider = function(e, t) {
                    f.packageInit(this, [
                        e
                    ]), this._ethAccounts = t;
                }, m.prototype._getCallback = function(e) {
                    if (e && e[e.length - 1] && "function" == typeof e[e.length - 1]) return e.pop();
                }, m.prototype._checkListener = function(e, t) {
                    if (t === e) throw b.ContractReservedEventError(e);
                }, m.prototype._getOrSetDefaultOptions = function(e) {
                    var t = c({}, e), r = t.gasPrice ? String(t.gasPrice) : null, n = t.from ? l.toChecksumAddress(p.inputAddressFormatter(t.from)) : null;
                    return t.data = t.data || this.options.data, t.from = n || this.options.from, t.gasPrice = r || this.options.gasPrice, t.gas = t.gas || t.gasLimit || this.options.gas, delete t.gasLimit, t;
                }, m.prototype._encodeEventABI = function(e, t) {
                    var r = (t = t || {}).filter || {}, n = {};
                    [
                        "fromBlock",
                        "toBlock"
                    ].filter(function(e) {
                        return void 0 !== t[e];
                    }).forEach(function(e) {
                        n[e] = p.inputBlockNumberFormatter(t[e]);
                    });
                    var o = [];
                    if (t.topics && Array.isArray(t.topics)) o = (0, i.default)(t.topics);
                    else if (o = [], e && !e.anonymous && "ALLEVENTS" !== e.name && o.push(e.signature || v.encodeEventSignature(l.jsonInterfaceMethodToString(e))), "ALLEVENTS" !== e.name && e.inputs) {
                        var a, u = function(e, t) {
                            var r = "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
                            if (!r) {
                                if (Array.isArray(e) || (r = function(e, t) {
                                    if (e) {
                                        if ("string" == typeof e) return s(e, t);
                                        var r = Object.prototype.toString.call(e).slice(8, -1);
                                        return "Object" === r && e.constructor && (r = e.constructor.name), "Map" === r || "Set" === r ? Array.from(e) : "Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? s(e, t) : void 0;
                                    }
                                }(e)) || t && e && "number" == typeof e.length) {
                                    r && (e = r);
                                    var n = 0, i = function() {};
                                    return {
                                        s: i,
                                        n: function() {
                                            return n >= e.length ? {
                                                done: !0
                                            } : {
                                                done: !1,
                                                value: e[n++]
                                            };
                                        },
                                        e: function(e) {
                                            throw e;
                                        },
                                        f: i
                                    };
                                }
                                throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                            }
                            var o, a = !0, u = !1;
                            return {
                                s: function() {
                                    r = r.call(e);
                                },
                                n: function() {
                                    var e = r.next();
                                    return a = e.done, e;
                                },
                                e: function(e) {
                                    u = !0, o = e;
                                },
                                f: function() {
                                    try {
                                        a || null == r.return || r.return();
                                    } finally{
                                        if (u) throw o;
                                    }
                                }
                            };
                        }(e.inputs);
                        try {
                            var c = function() {
                                var e = a.value;
                                if (!e.indexed) return "continue";
                                var t = r[e.name];
                                if (!t) return o.push(null), "continue";
                                Array.isArray(t) ? o.push(t.map(function(t) {
                                    return v.encodeParameter(e.type, t);
                                })) : o.push(v.encodeParameter(e.type, t));
                            };
                            for(u.s(); !(a = u.n()).done;)c();
                        } catch (e) {
                            u.e(e);
                        } finally{
                            u.f();
                        }
                    }
                    return o.length && (n.topics = o), this.options.address && (n.address = this.options.address.toLowerCase()), n;
                }, m.prototype._decodeEventABI = function(e) {
                    var t = this;
                    e.data = e.data || "", e.topics = e.topics || [];
                    var r = p.outputLogFormatter(e);
                    if ("ALLEVENTS" === t.name && (t = t.jsonInterface.find(function(t) {
                        return t.signature === e.topics[0];
                    }) || {
                        anonymous: !0
                    }), t.inputs = t.inputs || [], !t.anonymous) {
                        var n = 0;
                        t.inputs.forEach(function(e) {
                            return e.indexed ? n++ : null;
                        }), n > 0 && e.topics.length !== n + 1 && (t = {
                            anonymous: !0,
                            inputs: []
                        });
                    }
                    var i = t.anonymous ? e.topics : e.topics.slice(1);
                    return r.returnValues = v.decodeLog(t.inputs, e.data, i), delete r.returnValues.__length__, r.event = t.name, r.signature = t.anonymous || !e.topics[0] ? null : e.topics[0], r.raw = {
                        data: r.data,
                        topics: r.topics
                    }, delete r.data, delete r.topics, r;
                }, m.prototype._encodeMethodABI = function() {
                    var e = this._method.signature, t = this.arguments || [], r = !1, n = this._parent.options.jsonInterface.filter(function(t) {
                        return "constructor" === e && t.type === e || (t.signature === e || t.signature === e.replace("0x", "") || t.name === e) && "function" === t.type;
                    }).map(function(e) {
                        var n = Array.isArray(e.inputs) ? e.inputs.length : 0;
                        if (n !== t.length) throw new Error("The number of arguments is not matching the methods required number. You need to pass " + n + " arguments.");
                        return "function" === e.type && (r = e.signature), Array.isArray(e.inputs) ? e.inputs : [];
                    }).map(function(e) {
                        return v.encodeParameters(e, t).replace("0x", "");
                    })[0] || "";
                    if ("constructor" === e) {
                        if (!this._deployData) throw new Error("The contract has no contract data option set. This is necessary to append the constructor parameters.");
                        return this._deployData.startsWith("0x") || (this._deployData = "0x" + this._deployData), this._deployData + n;
                    }
                    var i = r ? r + n : n;
                    if (!i) throw new Error("Couldn't find a matching contract method named \"" + this._method.name + '".');
                    return i;
                }, m.prototype._decodeMethodReturn = function(e, t) {
                    if (!t) return null;
                    t = t.length >= 2 ? t.slice(2) : t;
                    var r = v.decodeParameters(e, t);
                    return 1 === r.__length__ ? r[0] : (delete r.__length__, r);
                }, m.prototype.deploy = function(e, t) {
                    if ((e = e || {}).arguments = e.arguments || [], !(e = this._getOrSetDefaultOptions(e)).data) {
                        if ("function" == typeof t) return t(b.ContractMissingDeployDataError());
                        throw b.ContractMissingDeployDataError();
                    }
                    var r = this.options.jsonInterface.find(function(e) {
                        return "constructor" === e.type;
                    }) || {};
                    return r.signature = "constructor", this._createTxObject.apply({
                        method: r,
                        parent: this,
                        deployData: e.data,
                        _ethAccounts: this.constructor._ethAccounts
                    }, e.arguments);
                }, m.prototype._generateEventOptions = function() {
                    var e = Array.prototype.slice.call(arguments), t = this._getCallback(e), r = "object" === (!!e[e.length - 1] && (0, a.default)(e[e.length - 1])) ? e.pop() : {}, n = "string" == typeof e[0] ? e[0] : "allevents", i = "allevents" === n.toLowerCase() ? {
                        name: "ALLEVENTS",
                        jsonInterface: this.options.jsonInterface
                    } : this.options.jsonInterface.find(function(e) {
                        return "event" === e.type && (e.name === n || e.signature === "0x" + n.replace("0x", ""));
                    });
                    if (!i) throw b.ContractEventDoesNotExistError(n);
                    if (!l.isAddress(this.options.address)) throw b.ContractNoAddressDefinedError();
                    return {
                        params: this._encodeEventABI(i, r),
                        event: i,
                        filter: r.filter || {},
                        callback: t
                    };
                }, m.prototype.clone = function() {
                    return new this.constructor(this.options.jsonInterface, this.options.address, this.options);
                }, m.prototype.once = function(e, t, r) {
                    var n = Array.prototype.slice.call(arguments);
                    if (!(r = this._getCallback(n))) throw b.ContractOnceRequiresCallbackError();
                    t && delete t.fromBlock, this._on(e, t, function(e, t, n) {
                        n.unsubscribe(), "function" == typeof r && r(e, t, n);
                    });
                }, m.prototype._on = function() {
                    var e = this._generateEventOptions.apply(this, arguments);
                    e.params && e.params.toBlock && (delete e.params.toBlock, console.warn("Invalid option: toBlock. Use getPastEvents for specific range.")), this._checkListener("newListener", e.event.name), this._checkListener("removeListener", e.event.name);
                    var t = new h({
                        subscription: {
                            params: 1,
                            inputFormatter: [
                                p.inputLogFormatter
                            ],
                            outputFormatter: this._decodeEventABI.bind(e.event),
                            subscriptionHandler: function(e) {
                                e.removed ? this.emit("changed", e) : this.emit("data", e), "function" == typeof this.callback && this.callback(null, e, this);
                            }
                        },
                        type: "eth",
                        requestManager: this._requestManager
                    });
                    return t.subscribe("logs", e.params, e.callback || function() {}), t;
                };
                var g = function(e, t) {
                    if (e.event && "ALLEVENTS" === e.event.name && Array.isArray(t)) {
                        var r = e.filter || {}, n = Object.keys(r);
                        return n.length > 0 ? t.filter(function(e) {
                            return "string" == typeof e || n.every(function(t) {
                                return Array.isArray(r[t]) ? r[t].some(function(r) {
                                    return String(e.returnValues[t]).toUpperCase() === String(r).toUpperCase();
                                }) : String(e.returnValues[t]).toUpperCase() === String(r[t]).toUpperCase();
                            });
                        }) : t;
                    }
                    return t;
                };
                m.prototype.getPastEvents = function() {
                    var e = this._generateEventOptions.apply(this, arguments), t = new d({
                        name: "getPastLogs",
                        call: "eth_getLogs",
                        params: 1,
                        inputFormatter: [
                            p.inputLogFormatter
                        ],
                        outputFormatter: this._decodeEventABI.bind(e.event)
                    });
                    t.setRequestManager(this._requestManager);
                    var r = t.buildCall();
                    return t = null, r(e.params, function(t, r) {
                        "function" == typeof e.callback && e.callback(t, g(e, r));
                    }).then(g.bind(this, e));
                }, m.prototype._createTxObject = function() {
                    var e = Array.prototype.slice.call(arguments), t = {};
                    if ("function" === this.method.type && (t.call = this.parent._executeMethod.bind(t, "call"), t.call.request = this.parent._executeMethod.bind(t, "call", !0)), t.send = this.parent._executeMethod.bind(t, "send"), t.send.request = this.parent._executeMethod.bind(t, "send", !0), t.encodeABI = this.parent._encodeMethodABI.bind(t), t.estimateGas = this.parent._executeMethod.bind(t, "estimate"), t.createAccessList = this.parent._executeMethod.bind(t, "createAccessList"), e && this.method.inputs && e.length !== this.method.inputs.length) {
                        if (this.nextMethod) return this.nextMethod.apply(null, e);
                        throw b.InvalidNumberOfParams(e.length, this.method.inputs.length, this.method.name);
                    }
                    return t.arguments = e || [], t._method = this.method, t._parent = this.parent, t._ethAccounts = this.parent.constructor._ethAccounts || this._ethAccounts, this.deployData && (t._deployData = this.deployData), t;
                }, m.prototype._processExecuteArguments = function(e, t) {
                    var r = {};
                    if (r.type = e.shift(), r.callback = this._parent._getCallback(e), "call" !== r.type || !0 === e[e.length - 1] || "string" != typeof e[e.length - 1] && !isFinite(e[e.length - 1]) || (r.defaultBlock = e.pop()), r.options = "object" === (!!e[e.length - 1] && (0, a.default)(e[e.length - 1])) ? e.pop() : {}, r.generateRequest = !0 === e[e.length - 1] && e.pop(), r.options = this._parent._getOrSetDefaultOptions(r.options), r.options.data = this.encodeABI(), !this._deployData && !l.isAddress(this._parent.options.address)) throw b.ContractNoAddressDefinedError();
                    return this._deployData || (r.options.to = this._parent.options.address), r.options.data ? r : l._fireError(new Error("Couldn't find a matching contract method, or the number of parameters is wrong."), t.eventEmitter, t.reject, r.callback);
                }, m.prototype._executeMethod = function() {
                    var e = this, t = this._parent._processExecuteArguments.call(this, Array.prototype.slice.call(arguments), r), r = y("send" !== t.type), n = e.constructor._ethAccounts || e._ethAccounts;
                    if (t.generateRequest) {
                        var i = {
                            params: [
                                p.inputCallFormatter.call(this._parent, t.options)
                            ],
                            callback: t.callback
                        };
                        return "call" === t.type ? (i.params.push(p.inputDefaultBlockNumberFormatter.call(this._parent, t.defaultBlock)), i.method = "eth_call", i.format = this._parent._decodeMethodReturn.bind(null, this._method.outputs)) : i.method = "eth_sendTransaction", i;
                    }
                    switch(t.type){
                        case "createAccessList":
                            return l.isAddress(t.options.from) ? new d({
                                name: "createAccessList",
                                call: "eth_createAccessList",
                                params: 2,
                                inputFormatter: [
                                    p.inputTransactionFormatter,
                                    p.inputDefaultBlockNumberFormatter
                                ],
                                requestManager: e._parent._requestManager,
                                accounts: n,
                                defaultAccount: e._parent.defaultAccount,
                                defaultBlock: e._parent.defaultBlock
                            }).createFunction()(t.options, t.callback) : l._fireError(b.ContractNoFromAddressDefinedError(), r.eventEmitter, r.reject, t.callback);
                        case "estimate":
                            return new d({
                                name: "estimateGas",
                                call: "eth_estimateGas",
                                params: 1,
                                inputFormatter: [
                                    p.inputCallFormatter
                                ],
                                outputFormatter: l.hexToNumber,
                                requestManager: e._parent._requestManager,
                                accounts: n,
                                defaultAccount: e._parent.defaultAccount,
                                defaultBlock: e._parent.defaultBlock
                            }).createFunction()(t.options, t.callback);
                        case "call":
                            return new d({
                                name: "call",
                                call: "eth_call",
                                params: 2,
                                inputFormatter: [
                                    p.inputCallFormatter,
                                    p.inputDefaultBlockNumberFormatter
                                ],
                                outputFormatter: function(t) {
                                    return e._parent._decodeMethodReturn(e._method.outputs, t);
                                },
                                requestManager: e._parent._requestManager,
                                accounts: n,
                                defaultAccount: e._parent.defaultAccount,
                                defaultBlock: e._parent.defaultBlock,
                                handleRevert: e._parent.handleRevert,
                                abiCoder: v
                            }).createFunction()(t.options, t.defaultBlock, t.callback);
                        case "send":
                            if (!l.isAddress(t.options.from)) return l._fireError(b.ContractNoFromAddressDefinedError(), r.eventEmitter, r.reject, t.callback);
                            if ("boolean" == typeof this._method.payable && !this._method.payable && t.options.value && t.options.value > 0) return l._fireError(new Error("Can not send value to non-payable contract method or constructor"), r.eventEmitter, r.reject, t.callback);
                            var o = {
                                receiptFormatter: function(t) {
                                    if (Array.isArray(t.logs)) {
                                        var r = t.logs.map(function(t) {
                                            return e._parent._decodeEventABI.call({
                                                name: "ALLEVENTS",
                                                jsonInterface: e._parent.options.jsonInterface
                                            }, t);
                                        });
                                        t.events = {};
                                        var n = 0;
                                        r.forEach(function(e) {
                                            e.event ? t.events[e.event] ? Array.isArray(t.events[e.event]) ? t.events[e.event].push(e) : t.events[e.event] = [
                                                t.events[e.event],
                                                e
                                            ] : t.events[e.event] = e : (t.events[n] = e, n++);
                                        }), delete t.logs;
                                    }
                                    return t;
                                },
                                contractDeployFormatter: function(t) {
                                    var r = e._parent.clone();
                                    return r.options.address = t.contractAddress, r;
                                }
                            };
                            return new d({
                                name: "sendTransaction",
                                call: "eth_sendTransaction",
                                params: 1,
                                inputFormatter: [
                                    p.inputTransactionFormatter
                                ],
                                requestManager: e._parent._requestManager,
                                accounts: e.constructor._ethAccounts || e._ethAccounts,
                                defaultAccount: e._parent.defaultAccount,
                                defaultBlock: e._parent.defaultBlock,
                                transactionBlockTimeout: e._parent.transactionBlockTimeout,
                                transactionConfirmationBlocks: e._parent.transactionConfirmationBlocks,
                                transactionPollingTimeout: e._parent.transactionPollingTimeout,
                                transactionPollingInterval: e._parent.transactionPollingInterval,
                                defaultCommon: e._parent.defaultCommon,
                                defaultChain: e._parent.defaultChain,
                                defaultHardfork: e._parent.defaultHardfork,
                                handleRevert: e._parent.handleRevert,
                                extraFormatters: o,
                                abiCoder: v
                            }).createFunction()(t.options, t.callback);
                        default:
                            throw new Error('Method "' + t.type + '" not implemented.');
                    }
                }, e.exports = m;
            },
            46764: (e, t, r)=>{
                "use strict";
                var n = r(28847), i = n(r(82247)), o = n(r(94571)), a = r(55160), s = r(11314).formatters, u = r(48161), c = r(11841), f = r(62867), d = r(22689);
                function l(e) {
                    this.eth = e;
                    var t = null;
                    this._detectedAddress = null, this._lastSyncCheck = null, Object.defineProperty(this, "registry", {
                        get: function() {
                            return new c(this);
                        },
                        enumerable: !0
                    }), Object.defineProperty(this, "resolverMethodHandler", {
                        get: function() {
                            return new f(this.registry);
                        },
                        enumerable: !0
                    }), Object.defineProperty(this, "registryAddress", {
                        get: function() {
                            return t;
                        },
                        set: function(e) {
                            t = null !== e ? s.inputAddressFormatter(e) : e;
                        },
                        enumerable: !0
                    });
                }
                l.prototype.supportsInterface = function(e, t, r) {
                    return this.getResolver(e).then(function(e) {
                        return u.isHexStrict(t) || (t = u.sha3(t).slice(0, 10)), e.methods.supportsInterface(t).call(r);
                    }).catch(function(e) {
                        if ("function" != typeof r) throw e;
                        r(e, null);
                    });
                }, l.prototype.resolver = function(e, t) {
                    return this.registry.resolver(e, t);
                }, l.prototype.getResolver = function(e, t) {
                    return this.registry.getResolver(e, t);
                }, l.prototype.setResolver = function(e, t, r, n) {
                    return this.registry.setResolver(e, t, r, n);
                }, l.prototype.setRecord = function(e, t, r, n, i, o) {
                    return this.registry.setRecord(e, t, r, n, i, o);
                }, l.prototype.setSubnodeRecord = function(e, t, r, n, i, o, a) {
                    return this.registry.setSubnodeRecord(e, t, r, n, i, o, a);
                }, l.prototype.setApprovalForAll = function(e, t, r, n) {
                    return this.registry.setApprovalForAll(e, t, r, n);
                }, l.prototype.isApprovedForAll = function(e, t, r) {
                    return this.registry.isApprovedForAll(e, t, r);
                }, l.prototype.recordExists = function(e, t) {
                    return this.registry.recordExists(e, t);
                }, l.prototype.setSubnodeOwner = function(e, t, r, n, i) {
                    return this.registry.setSubnodeOwner(e, t, r, n, i);
                }, l.prototype.getTTL = function(e, t) {
                    return this.registry.getTTL(e, t);
                }, l.prototype.setTTL = function(e, t, r, n) {
                    return this.registry.setTTL(e, t, r, n);
                }, l.prototype.getOwner = function(e, t) {
                    return this.registry.getOwner(e, t);
                }, l.prototype.setOwner = function(e, t, r, n) {
                    return this.registry.setOwner(e, t, r, n);
                }, l.prototype.getAddress = function(e, t) {
                    return this.resolverMethodHandler.method(e, "addr", []).call(t);
                }, l.prototype.setAddress = function(e, t, r, n) {
                    return this.resolverMethodHandler.method(e, "setAddr", [
                        t
                    ]).send(r, n);
                }, l.prototype.getPubkey = function(e, t) {
                    return this.resolverMethodHandler.method(e, "pubkey", [], null, t).call(t);
                }, l.prototype.setPubkey = function(e, t, r, n, i) {
                    return this.resolverMethodHandler.method(e, "setPubkey", [
                        t,
                        r
                    ]).send(n, i);
                }, l.prototype.getContent = function(e, t) {
                    return this.resolverMethodHandler.method(e, "content", []).call(t);
                }, l.prototype.setContent = function(e, t, r, n) {
                    return this.resolverMethodHandler.method(e, "setContent", [
                        t
                    ]).send(r, n);
                }, l.prototype.getContenthash = function(e, t) {
                    return this.resolverMethodHandler.method(e, "contenthash", [], d.decode).call(t);
                }, l.prototype.setContenthash = function(e, t, r, n) {
                    var i;
                    try {
                        i = d.encode(t);
                    } catch (e) {
                        var o = new Error("Could not encode " + t + ". See docs for supported hash protocols.");
                        if ("function" == typeof n) return void n(o, null);
                        throw o;
                    }
                    return this.resolverMethodHandler.method(e, "setContenthash", [
                        i
                    ]).send(r, n);
                }, l.prototype.getMultihash = function(e, t) {
                    return this.resolverMethodHandler.method(e, "multihash", []).call(t);
                }, l.prototype.setMultihash = function(e, t, r, n) {
                    return this.resolverMethodHandler.method(e, "multihash", [
                        t
                    ]).send(r, n);
                }, l.prototype.checkNetwork = (0, o.default)(i.default.mark(function e() {
                    var t, r, n, o, s;
                    return i.default.wrap(function(e) {
                        for(;;)switch(e.prev = e.next){
                            case 0:
                                if (t = new Date / 1e3, this._lastSyncCheck && !(t - this._lastSyncCheck > 3600)) {
                                    e.next = 9;
                                    break;
                                }
                                return e.next = 4, this.eth.getBlock("latest");
                            case 4:
                                if (r = e.sent, !((n = t - r.timestamp) > 3600)) {
                                    e.next = 8;
                                    break;
                                }
                                throw new Error("Network not synced; last block was " + n + " seconds ago");
                            case 8:
                                this._lastSyncCheck = t;
                            case 9:
                                if (!this.registryAddress) {
                                    e.next = 11;
                                    break;
                                }
                                return e.abrupt("return", this.registryAddress);
                            case 11:
                                if (this._detectedAddress) {
                                    e.next = 20;
                                    break;
                                }
                                return e.next = 14, this.eth.net.getNetworkType();
                            case 14:
                                if (o = e.sent, void 0 !== (s = a.addresses[o])) {
                                    e.next = 18;
                                    break;
                                }
                                throw new Error("ENS is not supported on network " + o);
                            case 18:
                                return this._detectedAddress = s, e.abrupt("return", this._detectedAddress);
                            case 20:
                                return e.abrupt("return", this._detectedAddress);
                            case 21:
                            case "end":
                                return e.stop();
                        }
                    }, e, this);
                })), e.exports = l;
            },
            55160: (e)=>{
                "use strict";
                e.exports = {
                    addresses: {
                        main: "0x00000000000C2E074eC69A0dFb2997BA6C7d2e1e",
                        ropsten: "0x00000000000C2E074eC69A0dFb2997BA6C7d2e1e",
                        rinkeby: "0x00000000000C2E074eC69A0dFb2997BA6C7d2e1e",
                        goerli: "0x00000000000C2E074eC69A0dFb2997BA6C7d2e1e"
                    },
                    interfaceIds: {
                        addr: "0x3b3b57de",
                        setAddr: "0x3b3b57de",
                        pubkey: "0xc8690233",
                        setPubkey: "0xc8690233",
                        contenthash: "0xbc1c58d1",
                        setContenthash: "0xbc1c58d1",
                        content: "0xd8389dc5",
                        setContent: "0xd8389dc5"
                    }
                };
            },
            11841: (e, t, r)=>{
                "use strict";
                var n = r(58164), i = r(21006), o = r(90282), a = r(11314).formatters, s = r(48161), u = r(43205), c = r(48384);
                function f(e) {
                    var t = this;
                    this.ens = e, this.contract = e.checkNetwork().then(function(e) {
                        var r = new n(u, e);
                        return r.setProvider(t.ens.eth.currentProvider), r;
                    });
                }
                f.prototype.owner = function(e, t) {
                    return console.warn('Deprecated: Please use the "getOwner" method instead of "owner".'), this.getOwner(e, t);
                }, f.prototype.getOwner = function(e, t) {
                    var r = new o(!0);
                    return this.contract.then(function(t) {
                        return t.methods.owner(i.hash(e)).call();
                    }).then(function(e) {
                        "function" != typeof t ? r.resolve(e) : t(e, e);
                    }).catch(function(e) {
                        "function" != typeof t ? r.reject(e) : t(e, null);
                    }), r.eventEmitter;
                }, f.prototype.setOwner = function(e, t, r, n) {
                    var s = new o(!0);
                    return this.contract.then(function(n) {
                        return n.methods.setOwner(i.hash(e), a.inputAddressFormatter(t)).send(r);
                    }).then(function(e) {
                        "function" != typeof n ? s.resolve(e) : n(e, e);
                    }).catch(function(e) {
                        "function" != typeof n ? s.reject(e) : n(e, null);
                    }), s.eventEmitter;
                }, f.prototype.getTTL = function(e, t) {
                    var r = new o(!0);
                    return this.contract.then(function(t) {
                        return t.methods.ttl(i.hash(e)).call();
                    }).then(function(e) {
                        "function" != typeof t ? r.resolve(e) : t(e, e);
                    }).catch(function(e) {
                        "function" != typeof t ? r.reject(e) : t(e, null);
                    }), r.eventEmitter;
                }, f.prototype.setTTL = function(e, t, r, n) {
                    var a = new o(!0);
                    return this.contract.then(function(n) {
                        return n.methods.setTTL(i.hash(e), t).send(r);
                    }).then(function(e) {
                        "function" != typeof n ? a.resolve(e) : n(e, e);
                    }).catch(function(e) {
                        "function" != typeof n ? a.reject(e) : n(e, null);
                    }), a.eventEmitter;
                }, f.prototype.setSubnodeOwner = function(e, t, r, n, u) {
                    var c = new o(!0);
                    return s.isHexStrict(t) || (t = s.sha3(t)), this.contract.then(function(o) {
                        return o.methods.setSubnodeOwner(i.hash(e), t, a.inputAddressFormatter(r)).send(n);
                    }).then(function(e) {
                        "function" != typeof u ? c.resolve(e) : u(e, e);
                    }).catch(function(e) {
                        "function" != typeof u ? c.reject(e) : u(e, null);
                    }), c.eventEmitter;
                }, f.prototype.setRecord = function(e, t, r, n, s, u) {
                    var c = new o(!0);
                    return this.contract.then(function(o) {
                        return o.methods.setRecord(i.hash(e), a.inputAddressFormatter(t), a.inputAddressFormatter(r), n).send(s);
                    }).then(function(e) {
                        "function" != typeof u ? c.resolve(e) : u(e, e);
                    }).catch(function(e) {
                        "function" != typeof u ? c.reject(e) : u(e, null);
                    }), c.eventEmitter;
                }, f.prototype.setSubnodeRecord = function(e, t, r, n, u, c, f) {
                    var d = new o(!0);
                    return s.isHexStrict(t) || (t = s.sha3(t)), this.contract.then(function(o) {
                        return o.methods.setSubnodeRecord(i.hash(e), t, a.inputAddressFormatter(r), a.inputAddressFormatter(n), u).send(c);
                    }).then(function(e) {
                        "function" != typeof f ? d.resolve(e) : f(e, e);
                    }).catch(function(e) {
                        "function" != typeof f ? d.reject(e) : f(e, null);
                    }), d.eventEmitter;
                }, f.prototype.setApprovalForAll = function(e, t, r, n) {
                    var i = new o(!0);
                    return this.contract.then(function(n) {
                        return n.methods.setApprovalForAll(a.inputAddressFormatter(e), t).send(r);
                    }).then(function(e) {
                        "function" != typeof n ? i.resolve(e) : n(e, e);
                    }).catch(function(e) {
                        "function" != typeof n ? i.reject(e) : n(e, null);
                    }), i.eventEmitter;
                }, f.prototype.isApprovedForAll = function(e, t, r) {
                    var n = new o(!0);
                    return this.contract.then(function(r) {
                        return r.methods.isApprovedForAll(a.inputAddressFormatter(e), a.inputAddressFormatter(t)).call();
                    }).then(function(e) {
                        "function" != typeof r ? n.resolve(e) : r(e, e);
                    }).catch(function(e) {
                        "function" != typeof r ? n.reject(e) : r(e, null);
                    }), n.eventEmitter;
                }, f.prototype.recordExists = function(e, t) {
                    var r = new o(!0);
                    return this.contract.then(function(t) {
                        return t.methods.recordExists(i.hash(e)).call();
                    }).then(function(e) {
                        "function" != typeof t ? r.resolve(e) : t(e, e);
                    }).catch(function(e) {
                        "function" != typeof t ? r.reject(e) : t(e, null);
                    }), r.eventEmitter;
                }, f.prototype.resolver = function(e, t) {
                    return console.warn('Deprecated: Please use the "getResolver" method instead of "resolver".'), this.getResolver(e, t);
                }, f.prototype.getResolver = function(e, t) {
                    var r = this;
                    return this.contract.then(function(t) {
                        return t.methods.resolver(i.hash(e)).call();
                    }).then(function(e) {
                        var i = new n(c, e);
                        if (i.setProvider(r.ens.eth.currentProvider), "function" != typeof t) return i;
                        t(i, i);
                    }).catch(function(e) {
                        if ("function" != typeof t) throw e;
                        t(e, null);
                    });
                }, f.prototype.setResolver = function(e, t, r, n) {
                    var s = new o(!0);
                    return this.contract.then(function(n) {
                        return n.methods.setResolver(i.hash(e), a.inputAddressFormatter(t)).send(r);
                    }).then(function(e) {
                        "function" != typeof n ? s.resolve(e) : n(e, e);
                    }).catch(function(e) {
                        "function" != typeof n ? s.reject(e) : n(e, null);
                    }), s.eventEmitter;
                }, e.exports = f;
            },
            30715: (e, t, r)=>{
                "use strict";
                var n = r(46764);
                e.exports = n;
            },
            62867: (e, t, r)=>{
                "use strict";
                var n = r(28847), i = n(r(82247)), o = n(r(94571)), a = r(90282), s = r(21006), u = r(11314).errors, c = r(55160).interfaceIds;
                function f(e) {
                    this.registry = e;
                }
                f.prototype.method = function(e, t, r, n, i) {
                    return {
                        call: this.call.bind({
                            ensName: e,
                            methodName: t,
                            methodArguments: r,
                            callback: i,
                            parent: this,
                            outputFormatter: n
                        }),
                        send: this.send.bind({
                            ensName: e,
                            methodName: t,
                            methodArguments: r,
                            callback: i,
                            parent: this
                        })
                    };
                }, f.prototype.call = function(e) {
                    var t = this, r = new a, n = this.parent.prepareArguments(this.ensName, this.methodArguments), s = this.outputFormatter || null;
                    return this.parent.registry.getResolver(this.ensName).then(function() {
                        var a = (0, o.default)(i.default.mark(function o(a) {
                            return i.default.wrap(function(i) {
                                for(;;)switch(i.prev = i.next){
                                    case 0:
                                        return i.next = 2, t.parent.checkInterfaceSupport(a, t.methodName);
                                    case 2:
                                        t.parent.handleCall(r, a.methods[t.methodName], n, s, e);
                                    case 3:
                                    case "end":
                                        return i.stop();
                                }
                            }, o);
                        }));
                        return function(e) {
                            return a.apply(this, arguments);
                        };
                    }()).catch(function(t) {
                        "function" != typeof e ? r.reject(t) : e(t, null);
                    }), r.eventEmitter;
                }, f.prototype.send = function(e, t) {
                    var r = this, n = new a, s = this.parent.prepareArguments(this.ensName, this.methodArguments);
                    return this.parent.registry.getResolver(this.ensName).then(function() {
                        var a = (0, o.default)(i.default.mark(function o(a) {
                            return i.default.wrap(function(i) {
                                for(;;)switch(i.prev = i.next){
                                    case 0:
                                        return i.next = 2, r.parent.checkInterfaceSupport(a, r.methodName);
                                    case 2:
                                        r.parent.handleSend(n, a.methods[r.methodName], s, e, t);
                                    case 3:
                                    case "end":
                                        return i.stop();
                                }
                            }, o);
                        }));
                        return function(e) {
                            return a.apply(this, arguments);
                        };
                    }()).catch(function(e) {
                        "function" != typeof t ? n.reject(e) : t(e, null);
                    }), n.eventEmitter;
                }, f.prototype.handleCall = function(e, t, r, n, i) {
                    return t.apply(this, r).call().then(function(t) {
                        n && (t = n(t)), "function" != typeof i ? e.resolve(t) : i(t, t);
                    }).catch(function(t) {
                        "function" != typeof i ? e.reject(t) : i(t, null);
                    }), e;
                }, f.prototype.handleSend = function(e, t, r, n, i) {
                    return t.apply(this, r).send(n).on("sending", function() {
                        e.eventEmitter.emit("sending");
                    }).on("sent", function() {
                        e.eventEmitter.emit("sent");
                    }).on("transactionHash", function(t) {
                        e.eventEmitter.emit("transactionHash", t);
                    }).on("confirmation", function(t, r) {
                        e.eventEmitter.emit("confirmation", t, r);
                    }).on("receipt", function(t) {
                        e.eventEmitter.emit("receipt", t), e.resolve(t), "function" == typeof i && i(t, t);
                    }).on("error", function(t) {
                        e.eventEmitter.emit("error", t), "function" != typeof i ? e.reject(t) : i(t, null);
                    }), e;
                }, f.prototype.prepareArguments = function(e, t) {
                    var r = s.hash(e);
                    return t.length > 0 ? (t.unshift(r), t) : [
                        r
                    ];
                }, f.prototype.checkInterfaceSupport = function() {
                    var e = (0, o.default)(i.default.mark(function e(t, r) {
                        var n;
                        return i.default.wrap(function(e) {
                            for(;;)switch(e.prev = e.next){
                                case 0:
                                    if (c[r]) {
                                        e.next = 2;
                                        break;
                                    }
                                    return e.abrupt("return");
                                case 2:
                                    return n = !1, e.prev = 3, e.next = 6, t.methods.supportsInterface(c[r]).call();
                                case 6:
                                    n = e.sent, e.next = 12;
                                    break;
                                case 9:
                                    e.prev = 9, e.t0 = e.catch(3), console.warn('Could not verify interface of resolver contract at "' + t.options.address + '". ');
                                case 12:
                                    if (n) {
                                        e.next = 14;
                                        break;
                                    }
                                    throw u.ResolverMethodMissingError(t.options.address, r);
                                case 14:
                                case "end":
                                    return e.stop();
                            }
                        }, e, null, [
                            [
                                3,
                                9
                            ]
                        ]);
                    }));
                    return function(t, r) {
                        return e.apply(this, arguments);
                    };
                }(), e.exports = f;
            },
            22689: (e, t, r)=>{
                "use strict";
                var n = r(94308);
                e.exports = {
                    decode: function(e) {
                        var t = null, r = null, i = null;
                        if (e && e.error) return {
                            protocolType: null,
                            decoded: e.error
                        };
                        if (e) try {
                            t = n.decode(e);
                            var o = n.getCodec(e);
                            "ipfs-ns" === o ? r = "ipfs" : "swarm-ns" === o ? r = "bzz" : "onion" === o ? r = "onion" : "onion3" === o ? r = "onion3" : t = e;
                        } catch (e) {
                            i = e.message;
                        }
                        return {
                            protocolType: r,
                            decoded: t,
                            error: i
                        };
                    },
                    encode: function(e) {
                        var t, r, i = !1;
                        if (e) {
                            var o = e.match(/^(ipfs|bzz|onion|onion3):\/\/(.*)/) || e.match(/\/(ipfs)\/(.*)/);
                            o && (r = o[1], t = o[2]);
                            try {
                                if ("ipfs" === r) t.length >= 4 && (i = "0x" + n.fromIpfs(t));
                                else if ("bzz" === r) t.length >= 4 && (i = "0x" + n.fromSwarm(t));
                                else if ("onion" === r) 16 === t.length && (i = "0x" + n.encode("onion", t));
                                else {
                                    if ("onion3" !== r) throw new Error("Could not encode content hash: unsupported content type");
                                    56 === t.length && (i = "0x" + n.encode("onion3", t));
                                }
                            } catch (e) {
                                throw e;
                            }
                        }
                        return i;
                    }
                };
            },
            43205: (e)=>{
                "use strict";
                e.exports = [
                    {
                        constant: !0,
                        inputs: [
                            {
                                name: "node",
                                type: "bytes32"
                            }
                        ],
                        name: "resolver",
                        outputs: [
                            {
                                name: "",
                                type: "address"
                            }
                        ],
                        payable: !1,
                        type: "function"
                    },
                    {
                        constant: !0,
                        inputs: [
                            {
                                name: "node",
                                type: "bytes32"
                            }
                        ],
                        name: "owner",
                        outputs: [
                            {
                                name: "",
                                type: "address"
                            }
                        ],
                        payable: !1,
                        type: "function"
                    },
                    {
                        constant: !1,
                        inputs: [
                            {
                                name: "node",
                                type: "bytes32"
                            },
                            {
                                name: "label",
                                type: "bytes32"
                            },
                            {
                                name: "owner",
                                type: "address"
                            }
                        ],
                        name: "setSubnodeOwner",
                        outputs: [],
                        payable: !1,
                        type: "function"
                    },
                    {
                        constant: !1,
                        inputs: [
                            {
                                name: "node",
                                type: "bytes32"
                            },
                            {
                                name: "ttl",
                                type: "uint64"
                            }
                        ],
                        name: "setTTL",
                        outputs: [],
                        payable: !1,
                        type: "function"
                    },
                    {
                        constant: !0,
                        inputs: [
                            {
                                name: "node",
                                type: "bytes32"
                            }
                        ],
                        name: "ttl",
                        outputs: [
                            {
                                name: "",
                                type: "uint64"
                            }
                        ],
                        payable: !1,
                        type: "function"
                    },
                    {
                        constant: !1,
                        inputs: [
                            {
                                name: "node",
                                type: "bytes32"
                            },
                            {
                                name: "resolver",
                                type: "address"
                            }
                        ],
                        name: "setResolver",
                        outputs: [],
                        payable: !1,
                        type: "function"
                    },
                    {
                        constant: !1,
                        inputs: [
                            {
                                name: "node",
                                type: "bytes32"
                            },
                            {
                                name: "owner",
                                type: "address"
                            }
                        ],
                        name: "setOwner",
                        outputs: [],
                        payable: !1,
                        type: "function"
                    },
                    {
                        anonymous: !1,
                        inputs: [
                            {
                                indexed: !0,
                                name: "node",
                                type: "bytes32"
                            },
                            {
                                indexed: !1,
                                name: "owner",
                                type: "address"
                            }
                        ],
                        name: "Transfer",
                        type: "event"
                    },
                    {
                        anonymous: !1,
                        inputs: [
                            {
                                indexed: !0,
                                name: "node",
                                type: "bytes32"
                            },
                            {
                                indexed: !0,
                                name: "label",
                                type: "bytes32"
                            },
                            {
                                indexed: !1,
                                name: "owner",
                                type: "address"
                            }
                        ],
                        name: "NewOwner",
                        type: "event"
                    },
                    {
                        anonymous: !1,
                        inputs: [
                            {
                                indexed: !0,
                                name: "node",
                                type: "bytes32"
                            },
                            {
                                indexed: !1,
                                name: "resolver",
                                type: "address"
                            }
                        ],
                        name: "NewResolver",
                        type: "event"
                    },
                    {
                        anonymous: !1,
                        inputs: [
                            {
                                indexed: !0,
                                name: "node",
                                type: "bytes32"
                            },
                            {
                                indexed: !1,
                                name: "ttl",
                                type: "uint64"
                            }
                        ],
                        name: "NewTTL",
                        type: "event"
                    },
                    {
                        constant: !1,
                        inputs: [
                            {
                                internalType: "bytes32",
                                name: "node",
                                type: "bytes32"
                            },
                            {
                                internalType: "address",
                                name: "owner",
                                type: "address"
                            },
                            {
                                internalType: "address",
                                name: "resolver",
                                type: "address"
                            },
                            {
                                internalType: "uint64",
                                name: "ttl",
                                type: "uint64"
                            }
                        ],
                        name: "setRecord",
                        outputs: [],
                        payable: !1,
                        stateMutability: "nonpayable",
                        type: "function"
                    },
                    {
                        constant: !1,
                        inputs: [
                            {
                                internalType: "address",
                                name: "operator",
                                type: "address"
                            },
                            {
                                internalType: "bool",
                                name: "approved",
                                type: "bool"
                            }
                        ],
                        name: "setApprovalForAll",
                        outputs: [],
                        payable: !1,
                        stateMutability: "nonpayable",
                        type: "function"
                    },
                    {
                        anonymous: !1,
                        inputs: [
                            {
                                indexed: !0,
                                internalType: "address",
                                name: "owner",
                                type: "address"
                            },
                            {
                                indexed: !0,
                                internalType: "address",
                                name: "operator",
                                type: "address"
                            },
                            {
                                indexed: !1,
                                internalType: "bool",
                                name: "approved",
                                type: "bool"
                            }
                        ],
                        name: "ApprovalForAll",
                        type: "event"
                    },
                    {
                        constant: !0,
                        inputs: [
                            {
                                internalType: "address",
                                name: "owner",
                                type: "address"
                            },
                            {
                                internalType: "address",
                                name: "operator",
                                type: "address"
                            }
                        ],
                        name: "isApprovedForAll",
                        outputs: [
                            {
                                internalType: "bool",
                                name: "",
                                type: "bool"
                            }
                        ],
                        payable: !1,
                        stateMutability: "view",
                        type: "function"
                    },
                    {
                        constant: !0,
                        inputs: [
                            {
                                internalType: "bytes32",
                                name: "node",
                                type: "bytes32"
                            }
                        ],
                        name: "recordExists",
                        outputs: [
                            {
                                internalType: "bool",
                                name: "",
                                type: "bool"
                            }
                        ],
                        payable: !1,
                        stateMutability: "view",
                        type: "function"
                    },
                    {
                        constant: !1,
                        inputs: [
                            {
                                internalType: "bytes32",
                                name: "node",
                                type: "bytes32"
                            },
                            {
                                internalType: "bytes32",
                                name: "label",
                                type: "bytes32"
                            },
                            {
                                internalType: "address",
                                name: "owner",
                                type: "address"
                            },
                            {
                                internalType: "address",
                                name: "resolver",
                                type: "address"
                            },
                            {
                                internalType: "uint64",
                                name: "ttl",
                                type: "uint64"
                            }
                        ],
                        name: "setSubnodeRecord",
                        outputs: [],
                        payable: !1,
                        stateMutability: "nonpayable",
                        type: "function"
                    }
                ];
            },
            48384: (e)=>{
                "use strict";
                e.exports = [
                    {
                        constant: !0,
                        inputs: [
                            {
                                name: "interfaceID",
                                type: "bytes4"
                            }
                        ],
                        name: "supportsInterface",
                        outputs: [
                            {
                                name: "",
                                type: "bool"
                            }
                        ],
                        payable: !1,
                        type: "function"
                    },
                    {
                        constant: !0,
                        inputs: [
                            {
                                name: "node",
                                type: "bytes32"
                            },
                            {
                                name: "contentTypes",
                                type: "uint256"
                            }
                        ],
                        name: "ABI",
                        outputs: [
                            {
                                name: "contentType",
                                type: "uint256"
                            },
                            {
                                name: "data",
                                type: "bytes"
                            }
                        ],
                        payable: !1,
                        type: "function"
                    },
                    {
                        constant: !1,
                        inputs: [
                            {
                                name: "node",
                                type: "bytes32"
                            },
                            {
                                name: "hash",
                                type: "bytes"
                            }
                        ],
                        name: "setMultihash",
                        outputs: [],
                        payable: !1,
                        stateMutability: "nonpayable",
                        type: "function"
                    },
                    {
                        constant: !0,
                        inputs: [
                            {
                                name: "node",
                                type: "bytes32"
                            }
                        ],
                        name: "multihash",
                        outputs: [
                            {
                                name: "",
                                type: "bytes"
                            }
                        ],
                        payable: !1,
                        stateMutability: "view",
                        type: "function"
                    },
                    {
                        constant: !1,
                        inputs: [
                            {
                                name: "node",
                                type: "bytes32"
                            },
                            {
                                name: "x",
                                type: "bytes32"
                            },
                            {
                                name: "y",
                                type: "bytes32"
                            }
                        ],
                        name: "setPubkey",
                        outputs: [],
                        payable: !1,
                        type: "function"
                    },
                    {
                        constant: !0,
                        inputs: [
                            {
                                name: "node",
                                type: "bytes32"
                            }
                        ],
                        name: "content",
                        outputs: [
                            {
                                name: "ret",
                                type: "bytes32"
                            }
                        ],
                        payable: !1,
                        type: "function"
                    },
                    {
                        constant: !0,
                        inputs: [
                            {
                                name: "node",
                                type: "bytes32"
                            }
                        ],
                        name: "addr",
                        outputs: [
                            {
                                name: "ret",
                                type: "address"
                            }
                        ],
                        payable: !1,
                        type: "function"
                    },
                    {
                        constant: !1,
                        inputs: [
                            {
                                name: "node",
                                type: "bytes32"
                            },
                            {
                                name: "contentType",
                                type: "uint256"
                            },
                            {
                                name: "data",
                                type: "bytes"
                            }
                        ],
                        name: "setABI",
                        outputs: [],
                        payable: !1,
                        type: "function"
                    },
                    {
                        constant: !0,
                        inputs: [
                            {
                                name: "node",
                                type: "bytes32"
                            }
                        ],
                        name: "name",
                        outputs: [
                            {
                                name: "ret",
                                type: "string"
                            }
                        ],
                        payable: !1,
                        type: "function"
                    },
                    {
                        constant: !1,
                        inputs: [
                            {
                                name: "node",
                                type: "bytes32"
                            },
                            {
                                name: "name",
                                type: "string"
                            }
                        ],
                        name: "setName",
                        outputs: [],
                        payable: !1,
                        type: "function"
                    },
                    {
                        constant: !1,
                        inputs: [
                            {
                                name: "node",
                                type: "bytes32"
                            },
                            {
                                name: "hash",
                                type: "bytes32"
                            }
                        ],
                        name: "setContent",
                        outputs: [],
                        payable: !1,
                        type: "function"
                    },
                    {
                        constant: !0,
                        inputs: [
                            {
                                name: "node",
                                type: "bytes32"
                            }
                        ],
                        name: "pubkey",
                        outputs: [
                            {
                                name: "x",
                                type: "bytes32"
                            },
                            {
                                name: "y",
                                type: "bytes32"
                            }
                        ],
                        payable: !1,
                        type: "function"
                    },
                    {
                        constant: !1,
                        inputs: [
                            {
                                name: "node",
                                type: "bytes32"
                            },
                            {
                                name: "addr",
                                type: "address"
                            }
                        ],
                        name: "setAddr",
                        outputs: [],
                        payable: !1,
                        type: "function"
                    },
                    {
                        inputs: [
                            {
                                name: "ensAddr",
                                type: "address"
                            }
                        ],
                        payable: !1,
                        type: "constructor"
                    },
                    {
                        anonymous: !1,
                        inputs: [
                            {
                                indexed: !0,
                                name: "node",
                                type: "bytes32"
                            },
                            {
                                indexed: !1,
                                name: "a",
                                type: "address"
                            }
                        ],
                        name: "AddrChanged",
                        type: "event"
                    },
                    {
                        anonymous: !1,
                        inputs: [
                            {
                                indexed: !0,
                                name: "node",
                                type: "bytes32"
                            },
                            {
                                indexed: !1,
                                name: "hash",
                                type: "bytes32"
                            }
                        ],
                        name: "ContentChanged",
                        type: "event"
                    },
                    {
                        anonymous: !1,
                        inputs: [
                            {
                                indexed: !0,
                                name: "node",
                                type: "bytes32"
                            },
                            {
                                indexed: !1,
                                name: "name",
                                type: "string"
                            }
                        ],
                        name: "NameChanged",
                        type: "event"
                    },
                    {
                        anonymous: !1,
                        inputs: [
                            {
                                indexed: !0,
                                name: "node",
                                type: "bytes32"
                            },
                            {
                                indexed: !0,
                                name: "contentType",
                                type: "uint256"
                            }
                        ],
                        name: "ABIChanged",
                        type: "event"
                    },
                    {
                        anonymous: !1,
                        inputs: [
                            {
                                indexed: !0,
                                name: "node",
                                type: "bytes32"
                            },
                            {
                                indexed: !1,
                                name: "x",
                                type: "bytes32"
                            },
                            {
                                indexed: !1,
                                name: "y",
                                type: "bytes32"
                            }
                        ],
                        name: "PubkeyChanged",
                        type: "event"
                    },
                    {
                        anonymous: !1,
                        inputs: [
                            {
                                indexed: !0,
                                name: "node",
                                type: "bytes32"
                            },
                            {
                                indexed: !1,
                                name: "hash",
                                type: "bytes"
                            }
                        ],
                        name: "ContenthashChanged",
                        type: "event"
                    },
                    {
                        constant: !0,
                        inputs: [
                            {
                                name: "node",
                                type: "bytes32"
                            }
                        ],
                        name: "contenthash",
                        outputs: [
                            {
                                name: "",
                                type: "bytes"
                            }
                        ],
                        payable: !1,
                        stateMutability: "view",
                        type: "function"
                    },
                    {
                        constant: !1,
                        inputs: [
                            {
                                name: "node",
                                type: "bytes32"
                            },
                            {
                                name: "hash",
                                type: "bytes"
                            }
                        ],
                        name: "setContenthash",
                        outputs: [],
                        payable: !1,
                        stateMutability: "nonpayable",
                        type: "function"
                    }
                ];
            },
            30006: (e, t, r)=>{
                "use strict";
                var n = r(28847), i = n(r(69721)), o = n(r(58985)), a = r(48161), s = r(31734), u = function(e) {
                    var t = "A".charCodeAt(0), r = "Z".charCodeAt(0);
                    return (e = (e = e.toUpperCase()).slice(4) + e.slice(0, 4)).split("").map(function(e) {
                        var n = e.charCodeAt(0);
                        return n >= t && n <= r ? n - t + 10 : e;
                    }).join("");
                }, c = function(e) {
                    for(var t, r = e; r.length > 2;)t = r.slice(0, 9), r = parseInt(t, 10) % 97 + r.slice(t.length);
                    return parseInt(r, 10) % 97;
                }, f = function() {
                    function e(t) {
                        (0, i.default)(this, e), this._iban = t;
                    }
                    return (0, o.default)(e, [
                        {
                            key: "isValid",
                            value: function() {
                                return /^XE[0-9]{2}(ETH[0-9A-Z]{13}|[0-9A-Z]{30,31})$/.test(this._iban) && 1 === c(u(this._iban));
                            }
                        },
                        {
                            key: "isDirect",
                            value: function() {
                                return 34 === this._iban.length || 35 === this._iban.length;
                            }
                        },
                        {
                            key: "isIndirect",
                            value: function() {
                                return 20 === this._iban.length;
                            }
                        },
                        {
                            key: "checksum",
                            value: function() {
                                return this._iban.slice(2, 4);
                            }
                        },
                        {
                            key: "institution",
                            value: function() {
                                return this.isIndirect() ? this._iban.slice(7, 11) : "";
                            }
                        },
                        {
                            key: "client",
                            value: function() {
                                return this.isIndirect() ? this._iban.slice(11) : "";
                            }
                        },
                        {
                            key: "toAddress",
                            value: function() {
                                if (this.isDirect()) {
                                    var e = this._iban.slice(4), t = new s(e, 36);
                                    return a.toChecksumAddress(t.toString(16, 20));
                                }
                                return "";
                            }
                        },
                        {
                            key: "toString",
                            value: function() {
                                return this._iban;
                            }
                        }
                    ], [
                        {
                            key: "toAddress",
                            value: function(t) {
                                if (!(t = new e(t)).isDirect()) throw new Error("IBAN is indirect and can't be converted");
                                return t.toAddress();
                            }
                        },
                        {
                            key: "toIban",
                            value: function(t) {
                                return e.fromAddress(t).toString();
                            }
                        },
                        {
                            key: "fromAddress",
                            value: function(t) {
                                if (!a.isAddress(t)) throw new Error("Provided address is not a valid address: " + t);
                                t = t.replace("0x", "").replace("0X", "");
                                var r = function(e, t) {
                                    for(var r = e; r.length < 30;)r = "0" + r;
                                    return r;
                                }(new s(t, 16).toString(36));
                                return e.fromBban(r.toUpperCase());
                            }
                        },
                        {
                            key: "fromBban",
                            value: function(t) {
                                return new e("XE" + ("0" + (98 - c(u("XE00" + t)))).slice(-2) + t);
                            }
                        },
                        {
                            key: "createIndirect",
                            value: function(t) {
                                return e.fromBban("ETH" + t.institution + t.identifier);
                            }
                        },
                        {
                            key: "isValid",
                            value: function(t) {
                                return new e(t).isValid();
                            }
                        }
                    ]), e;
                }();
                e.exports = f;
            },
            96306: (e, t, r)=>{
                "use strict";
                var n = r(80606), i = r(53349), o = r(48161), a = r(473), s = r(11314).formatters, u = function() {
                    var e = this;
                    n.packageInit(this, arguments), this.net = new a(this);
                    var t = null, r = "latest";
                    Object.defineProperty(this, "defaultAccount", {
                        get: function() {
                            return t;
                        },
                        set: function(e) {
                            return e && (t = o.toChecksumAddress(s.inputAddressFormatter(e))), u.forEach(function(e) {
                                e.defaultAccount = t;
                            }), e;
                        },
                        enumerable: !0
                    }), Object.defineProperty(this, "defaultBlock", {
                        get: function() {
                            return r;
                        },
                        set: function(e) {
                            return r = e, u.forEach(function(e) {
                                e.defaultBlock = r;
                            }), e;
                        },
                        enumerable: !0
                    });
                    var u = [
                        new i({
                            name: "getAccounts",
                            call: "personal_listAccounts",
                            params: 0,
                            outputFormatter: o.toChecksumAddress
                        }),
                        new i({
                            name: "newAccount",
                            call: "personal_newAccount",
                            params: 1,
                            inputFormatter: [
                                null
                            ],
                            outputFormatter: o.toChecksumAddress
                        }),
                        new i({
                            name: "unlockAccount",
                            call: "personal_unlockAccount",
                            params: 3,
                            inputFormatter: [
                                s.inputAddressFormatter,
                                null,
                                null
                            ]
                        }),
                        new i({
                            name: "lockAccount",
                            call: "personal_lockAccount",
                            params: 1,
                            inputFormatter: [
                                s.inputAddressFormatter
                            ]
                        }),
                        new i({
                            name: "importRawKey",
                            call: "personal_importRawKey",
                            params: 2
                        }),
                        new i({
                            name: "sendTransaction",
                            call: "personal_sendTransaction",
                            params: 2,
                            inputFormatter: [
                                s.inputTransactionFormatter,
                                null
                            ]
                        }),
                        new i({
                            name: "signTransaction",
                            call: "personal_signTransaction",
                            params: 2,
                            inputFormatter: [
                                s.inputTransactionFormatter,
                                null
                            ]
                        }),
                        new i({
                            name: "sign",
                            call: "personal_sign",
                            params: 3,
                            inputFormatter: [
                                s.inputSignFormatter,
                                s.inputAddressFormatter,
                                null
                            ]
                        }),
                        new i({
                            name: "ecRecover",
                            call: "personal_ecRecover",
                            params: 2,
                            inputFormatter: [
                                s.inputSignFormatter,
                                null
                            ]
                        })
                    ];
                    u.forEach(function(t) {
                        t.attachToObject(e), t.setRequestManager(e._requestManager), t.defaultBlock = e.defaultBlock, t.defaultAccount = e.defaultAccount;
                    });
                };
                n.addProviders(u), e.exports = u;
            },
            28130: (e)=>{
                "use strict";
                e.exports = function(e) {
                    var t, r = this;
                    return this.net.getId().then(function(e) {
                        return t = e, r.getBlock(0);
                    }).then(function(r) {
                        var n = "private";
                        return "0xd4e56740f876aef8c010b86a40d5f56745a118d0906a34e69aec8c0db1cb8fa3" === r.hash && 1 === t && (n = "main"), "0x41941023680923e0fe4d74a34bdac8141f2540e3ae90623718e47d66d1ca4a2d" === r.hash && 3 === t && (n = "ropsten"), "0x6341fd3daf94b748c72ced5a5b26028f2474f5f00d824504e4fa37a75767e177" === r.hash && 4 === t && (n = "rinkeby"), "0xbf7e331f7f7c1dd2e05159666b3bf8bc7a8a3a9eb1d518969eab529dd9b88c1a" === r.hash && 5 === t && (n = "goerli"), "0xa3c565fc15c7478862d50ccd6561e3c06b24cc509bf388941c25ea985ce32cb9" === r.hash && 42 === t && (n = "kovan"), "function" == typeof e && e(null, n), n;
                    }).catch(function(t) {
                        if ("function" != typeof e) throw t;
                        e(t);
                    });
                };
            },
            66748: (e, t, r)=>{
                "use strict";
                var n = r(80606), i = r(11314), o = r(34178).subscriptions, a = r(53349), s = r(48161), u = r(473), c = r(30715), f = r(96306), d = r(58164), l = r(30006), h = r(99819), p = r(79901), b = r(28130), y = i.formatters, v = function(e) {
                    return "string" == typeof e[0] && 0 === e[0].indexOf("0x") ? "eth_getBlockByHash" : "eth_getBlockByNumber";
                }, m = function(e) {
                    return "string" == typeof e[0] && 0 === e[0].indexOf("0x") ? "eth_getTransactionByBlockHashAndIndex" : "eth_getTransactionByBlockNumberAndIndex";
                }, g = function(e) {
                    return "string" == typeof e[0] && 0 === e[0].indexOf("0x") ? "eth_getUncleByBlockHashAndIndex" : "eth_getUncleByBlockNumberAndIndex";
                }, w = function(e) {
                    return "string" == typeof e[0] && 0 === e[0].indexOf("0x") ? "eth_getBlockTransactionCountByHash" : "eth_getBlockTransactionCountByNumber";
                }, k = function(e) {
                    return "string" == typeof e[0] && 0 === e[0].indexOf("0x") ? "eth_getUncleCountByBlockHash" : "eth_getUncleCountByBlockNumber";
                }, _ = function() {
                    var e = this;
                    n.packageInit(this, arguments);
                    var t = this.setRequestManager;
                    this.setRequestManager = function(r) {
                        return t(r), e.net.setRequestManager(r), e.personal.setRequestManager(r), e.accounts.setRequestManager(r), e.Contract._requestManager = e._requestManager, e.Contract.currentProvider = e._provider, !0;
                    };
                    var r = this.setProvider;
                    this.setProvider = function() {
                        r.apply(e, arguments), e.setRequestManager(e._requestManager), e.ens._detectedAddress = null, e.ens._lastSyncCheck = null;
                    };
                    var i, _, A, E = !1, S = null, x = "latest", B = 50, O = 24, P = 750, I = 1e3, T = 10, C = 100;
                    Object.defineProperty(this, "handleRevert", {
                        get: function() {
                            return E;
                        },
                        set: function(t) {
                            E = t, e.Contract.handleRevert = E, U.forEach(function(e) {
                                e.handleRevert = E;
                            });
                        },
                        enumerable: !0
                    }), Object.defineProperty(this, "defaultCommon", {
                        get: function() {
                            return A;
                        },
                        set: function(t) {
                            A = t, e.Contract.defaultCommon = A, U.forEach(function(e) {
                                e.defaultCommon = A;
                            });
                        },
                        enumerable: !0
                    }), Object.defineProperty(this, "defaultHardfork", {
                        get: function() {
                            return _;
                        },
                        set: function(t) {
                            _ = t, e.Contract.defaultHardfork = _, U.forEach(function(e) {
                                e.defaultHardfork = _;
                            });
                        },
                        enumerable: !0
                    }), Object.defineProperty(this, "defaultChain", {
                        get: function() {
                            return i;
                        },
                        set: function(t) {
                            i = t, e.Contract.defaultChain = i, U.forEach(function(e) {
                                e.defaultChain = i;
                            });
                        },
                        enumerable: !0
                    }), Object.defineProperty(this, "transactionPollingTimeout", {
                        get: function() {
                            return P;
                        },
                        set: function(t) {
                            P = t, e.Contract.transactionPollingTimeout = P, U.forEach(function(e) {
                                e.transactionPollingTimeout = P;
                            });
                        },
                        enumerable: !0
                    }), Object.defineProperty(this, "transactionPollingInterval", {
                        get: function() {
                            return I;
                        },
                        set: function(t) {
                            I = t, e.Contract.transactionPollingInterval = I, U.forEach(function(e) {
                                e.transactionPollingInterval = I;
                            });
                        },
                        enumerable: !0
                    }), Object.defineProperty(this, "transactionConfirmationBlocks", {
                        get: function() {
                            return O;
                        },
                        set: function(t) {
                            O = t, e.Contract.transactionConfirmationBlocks = O, U.forEach(function(e) {
                                e.transactionConfirmationBlocks = O;
                            });
                        },
                        enumerable: !0
                    }), Object.defineProperty(this, "transactionBlockTimeout", {
                        get: function() {
                            return B;
                        },
                        set: function(t) {
                            B = t, e.Contract.transactionBlockTimeout = B, U.forEach(function(e) {
                                e.transactionBlockTimeout = B;
                            });
                        },
                        enumerable: !0
                    }), Object.defineProperty(this, "blockHeaderTimeout", {
                        get: function() {
                            return T;
                        },
                        set: function(t) {
                            T = t, e.Contract.blockHeaderTimeout = T, U.forEach(function(e) {
                                e.blockHeaderTimeout = T;
                            });
                        },
                        enumerable: !0
                    }), Object.defineProperty(this, "defaultAccount", {
                        get: function() {
                            return S;
                        },
                        set: function(t) {
                            return t && (S = s.toChecksumAddress(y.inputAddressFormatter(t))), e.Contract.defaultAccount = S, e.personal.defaultAccount = S, U.forEach(function(e) {
                                e.defaultAccount = S;
                            }), t;
                        },
                        enumerable: !0
                    }), Object.defineProperty(this, "defaultBlock", {
                        get: function() {
                            return x;
                        },
                        set: function(t) {
                            return x = t, e.Contract.defaultBlock = x, e.personal.defaultBlock = x, U.forEach(function(e) {
                                e.defaultBlock = x;
                            }), t;
                        },
                        enumerable: !0
                    }), Object.defineProperty(this, "maxListenersWarningThreshold", {
                        get: function() {
                            return C;
                        },
                        set: function(t) {
                            e.currentProvider && e.currentProvider.setMaxListeners && (C = t, e.currentProvider.setMaxListeners(t));
                        },
                        enumerable: !0
                    }), this.clearSubscriptions = e._requestManager.clearSubscriptions.bind(e._requestManager), this.removeSubscriptionById = e._requestManager.removeSubscription.bind(e._requestManager), this.net = new u(this), this.net.getNetworkType = b.bind(this), this.accounts = new h(this), this.personal = new f(this), this.personal.defaultAccount = this.defaultAccount, this.maxListenersWarningThreshold = C;
                    var M = this, R = function() {
                        d.apply(this, arguments);
                        var e = this, t = M.setProvider;
                        M.setProvider = function() {
                            t.apply(M, arguments), n.packageInit(e, [
                                M
                            ]);
                        };
                    };
                    R.setProvider = function() {
                        d.setProvider.apply(this, arguments);
                    }, (R.prototype = Object.create(d.prototype)).constructor = R, this.Contract = R, this.Contract.defaultAccount = this.defaultAccount, this.Contract.defaultBlock = this.defaultBlock, this.Contract.transactionBlockTimeout = this.transactionBlockTimeout, this.Contract.transactionConfirmationBlocks = this.transactionConfirmationBlocks, this.Contract.transactionPollingTimeout = this.transactionPollingTimeout, this.Contract.transactionPollingInterval = this.transactionPollingInterval, this.Contract.blockHeaderTimeout = this.blockHeaderTimeout, this.Contract.handleRevert = this.handleRevert, this.Contract._requestManager = this._requestManager, this.Contract._ethAccounts = this.accounts, this.Contract.currentProvider = this._requestManager.provider, this.Iban = l, this.abi = p, this.ens = new c(this);
                    var U = [
                        new a({
                            name: "getNodeInfo",
                            call: "web3_clientVersion"
                        }),
                        new a({
                            name: "getProtocolVersion",
                            call: "eth_protocolVersion",
                            params: 0
                        }),
                        new a({
                            name: "getCoinbase",
                            call: "eth_coinbase",
                            params: 0
                        }),
                        new a({
                            name: "isMining",
                            call: "eth_mining",
                            params: 0
                        }),
                        new a({
                            name: "getHashrate",
                            call: "eth_hashrate",
                            params: 0,
                            outputFormatter: s.hexToNumber
                        }),
                        new a({
                            name: "isSyncing",
                            call: "eth_syncing",
                            params: 0,
                            outputFormatter: y.outputSyncingFormatter
                        }),
                        new a({
                            name: "getGasPrice",
                            call: "eth_gasPrice",
                            params: 0,
                            outputFormatter: y.outputBigNumberFormatter
                        }),
                        new a({
                            name: "getFeeHistory",
                            call: "eth_feeHistory",
                            params: 3,
                            inputFormatter: [
                                s.numberToHex,
                                y.inputBlockNumberFormatter,
                                null
                            ]
                        }),
                        new a({
                            name: "getAccounts",
                            call: "eth_accounts",
                            params: 0,
                            outputFormatter: s.toChecksumAddress
                        }),
                        new a({
                            name: "getBlockNumber",
                            call: "eth_blockNumber",
                            params: 0,
                            outputFormatter: s.hexToNumber
                        }),
                        new a({
                            name: "getBalance",
                            call: "eth_getBalance",
                            params: 2,
                            inputFormatter: [
                                y.inputAddressFormatter,
                                y.inputDefaultBlockNumberFormatter
                            ],
                            outputFormatter: y.outputBigNumberFormatter
                        }),
                        new a({
                            name: "getStorageAt",
                            call: "eth_getStorageAt",
                            params: 3,
                            inputFormatter: [
                                y.inputAddressFormatter,
                                s.numberToHex,
                                y.inputDefaultBlockNumberFormatter
                            ]
                        }),
                        new a({
                            name: "getCode",
                            call: "eth_getCode",
                            params: 2,
                            inputFormatter: [
                                y.inputAddressFormatter,
                                y.inputDefaultBlockNumberFormatter
                            ]
                        }),
                        new a({
                            name: "getBlock",
                            call: v,
                            params: 2,
                            inputFormatter: [
                                y.inputBlockNumberFormatter,
                                function(e) {
                                    return !!e;
                                }
                            ],
                            outputFormatter: y.outputBlockFormatter
                        }),
                        new a({
                            name: "getUncle",
                            call: g,
                            params: 2,
                            inputFormatter: [
                                y.inputBlockNumberFormatter,
                                s.numberToHex
                            ],
                            outputFormatter: y.outputBlockFormatter
                        }),
                        new a({
                            name: "getBlockTransactionCount",
                            call: w,
                            params: 1,
                            inputFormatter: [
                                y.inputBlockNumberFormatter
                            ],
                            outputFormatter: s.hexToNumber
                        }),
                        new a({
                            name: "getBlockUncleCount",
                            call: k,
                            params: 1,
                            inputFormatter: [
                                y.inputBlockNumberFormatter
                            ],
                            outputFormatter: s.hexToNumber
                        }),
                        new a({
                            name: "getTransaction",
                            call: "eth_getTransactionByHash",
                            params: 1,
                            inputFormatter: [
                                null
                            ],
                            outputFormatter: y.outputTransactionFormatter
                        }),
                        new a({
                            name: "getTransactionFromBlock",
                            call: m,
                            params: 2,
                            inputFormatter: [
                                y.inputBlockNumberFormatter,
                                s.numberToHex
                            ],
                            outputFormatter: y.outputTransactionFormatter
                        }),
                        new a({
                            name: "getTransactionReceipt",
                            call: "eth_getTransactionReceipt",
                            params: 1,
                            inputFormatter: [
                                null
                            ],
                            outputFormatter: y.outputTransactionReceiptFormatter
                        }),
                        new a({
                            name: "getTransactionCount",
                            call: "eth_getTransactionCount",
                            params: 2,
                            inputFormatter: [
                                y.inputAddressFormatter,
                                y.inputDefaultBlockNumberFormatter
                            ],
                            outputFormatter: s.hexToNumber
                        }),
                        new a({
                            name: "sendSignedTransaction",
                            call: "eth_sendRawTransaction",
                            params: 1,
                            inputFormatter: [
                                null
                            ],
                            abiCoder: p
                        }),
                        new a({
                            name: "signTransaction",
                            call: "eth_signTransaction",
                            params: 1,
                            inputFormatter: [
                                y.inputTransactionFormatter
                            ]
                        }),
                        new a({
                            name: "sendTransaction",
                            call: "eth_sendTransaction",
                            params: 1,
                            inputFormatter: [
                                y.inputTransactionFormatter
                            ],
                            abiCoder: p
                        }),
                        new a({
                            name: "sign",
                            call: "eth_sign",
                            params: 2,
                            inputFormatter: [
                                y.inputSignFormatter,
                                y.inputAddressFormatter
                            ],
                            transformPayload: function(e) {
                                return e.params.reverse(), e;
                            }
                        }),
                        new a({
                            name: "call",
                            call: "eth_call",
                            params: 2,
                            inputFormatter: [
                                y.inputCallFormatter,
                                y.inputDefaultBlockNumberFormatter
                            ],
                            abiCoder: p
                        }),
                        new a({
                            name: "estimateGas",
                            call: "eth_estimateGas",
                            params: 1,
                            inputFormatter: [
                                y.inputCallFormatter
                            ],
                            outputFormatter: s.hexToNumber
                        }),
                        new a({
                            name: "submitWork",
                            call: "eth_submitWork",
                            params: 3
                        }),
                        new a({
                            name: "getWork",
                            call: "eth_getWork",
                            params: 0
                        }),
                        new a({
                            name: "getPastLogs",
                            call: "eth_getLogs",
                            params: 1,
                            inputFormatter: [
                                y.inputLogFormatter
                            ],
                            outputFormatter: y.outputLogFormatter
                        }),
                        new a({
                            name: "getChainId",
                            call: "eth_chainId",
                            params: 0,
                            outputFormatter: s.hexToNumber
                        }),
                        new a({
                            name: "requestAccounts",
                            call: "eth_requestAccounts",
                            params: 0,
                            outputFormatter: s.toChecksumAddress
                        }),
                        new a({
                            name: "getProof",
                            call: "eth_getProof",
                            params: 3,
                            inputFormatter: [
                                y.inputAddressFormatter,
                                y.inputStorageKeysFormatter,
                                y.inputDefaultBlockNumberFormatter
                            ],
                            outputFormatter: y.outputProofFormatter
                        }),
                        new a({
                            name: "getPendingTransactions",
                            call: "eth_pendingTransactions",
                            params: 0,
                            outputFormatter: y.outputTransactionFormatter
                        }),
                        new a({
                            name: "createAccessList",
                            call: "eth_createAccessList",
                            params: 2,
                            inputFormatter: [
                                y.inputTransactionFormatter,
                                y.inputDefaultBlockNumberFormatter
                            ]
                        }),
                        new o({
                            name: "subscribe",
                            type: "eth",
                            subscriptions: {
                                newBlockHeaders: {
                                    subscriptionName: "newHeads",
                                    params: 0,
                                    outputFormatter: y.outputBlockFormatter
                                },
                                pendingTransactions: {
                                    subscriptionName: "newPendingTransactions",
                                    params: 0
                                },
                                logs: {
                                    params: 1,
                                    inputFormatter: [
                                        y.inputLogFormatter
                                    ],
                                    outputFormatter: y.outputLogFormatter,
                                    subscriptionHandler: function(e) {
                                        e.removed ? this.emit("changed", e) : this.emit("data", e), "function" == typeof this.callback && this.callback(null, e, this);
                                    }
                                },
                                syncing: {
                                    params: 0,
                                    outputFormatter: y.outputSyncingFormatter,
                                    subscriptionHandler: function(e) {
                                        var t = this;
                                        !0 !== this._isSyncing ? (this._isSyncing = !0, this.emit("changed", t._isSyncing), "function" == typeof this.callback && this.callback(null, t._isSyncing, this), setTimeout(function() {
                                            t.emit("data", e), "function" == typeof t.callback && t.callback(null, e, t);
                                        }, 0)) : (this.emit("data", e), "function" == typeof t.callback && this.callback(null, e, this), clearTimeout(this._isSyncingTimeout), this._isSyncingTimeout = setTimeout(function() {
                                            e.currentBlock > e.highestBlock - 200 && (t._isSyncing = !1, t.emit("changed", t._isSyncing), "function" == typeof t.callback && t.callback(null, t._isSyncing, t));
                                        }, 500));
                                    }
                                }
                            }
                        })
                    ];
                    U.forEach(function(t) {
                        t.attachToObject(e), t.setRequestManager(e._requestManager, e.accounts), t.defaultBlock = e.defaultBlock, t.defaultAccount = e.defaultAccount, t.transactionBlockTimeout = e.transactionBlockTimeout, t.transactionConfirmationBlocks = e.transactionConfirmationBlocks, t.transactionPollingTimeout = e.transactionPollingTimeout, t.transactionPollingInterval = e.transactionPollingInterval, t.handleRevert = e.handleRevert;
                    });
                };
                n.addProviders(_), e.exports = _;
            },
            473: (e, t, r)=>{
                "use strict";
                var n = r(80606), i = r(53349), o = r(48161), a = function() {
                    var e = this;
                    n.packageInit(this, arguments), [
                        new i({
                            name: "getId",
                            call: "net_version",
                            params: 0,
                            outputFormatter: parseInt
                        }),
                        new i({
                            name: "isListening",
                            call: "net_listening",
                            params: 0
                        }),
                        new i({
                            name: "getPeerCount",
                            call: "net_peerCount",
                            params: 0,
                            outputFormatter: o.hexToNumber
                        })
                    ].forEach(function(t) {
                        t.attachToObject(e), t.setRequestManager(e._requestManager);
                    });
                };
                n.addProviders(a), e.exports = a;
            },
            14565: (e, t, r)=>{
                "use strict";
                var n = r(11314).errors, i = r(33768), o = r(29519), a = r(90912);
                r(54258).polyfill(), void 0 === r.g || r.g.AbortController || r(53368);
                var s = function(e, t) {
                    t = t || {}, this.withCredentials = t.withCredentials, this.timeout = t.timeout || 0, this.headers = t.headers, this.agent = t.agent, this.forceGlobalFetch = t.forceGlobalFetch || !1, this.connected = !1;
                    var r = !1 !== t.keepAlive;
                    this.host = e || "http://localhost:8545", this.agent || ("https" === this.host.substring(0, 5) ? this.httpsAgent = new a.Agent({
                        keepAlive: r
                    }) : this.httpAgent = new o.Agent({
                        keepAlive: r
                    }));
                };
                s.prototype.send = function(e, t) {
                    var r, o = {
                        method: "POST",
                        body: JSON.stringify(e)
                    }, a = {}, s = this.forceGlobalFetch ? globalThis.fetch : i;
                    if ("undefined" != typeof AbortController ? r = new AbortController : "undefined" != typeof window && void 0 !== window.AbortController && (r = new window.AbortController), void 0 !== r && (o.signal = r.signal), "undefined" == typeof XMLHttpRequest) {
                        var u = {
                            httpsAgent: this.httpsAgent,
                            httpAgent: this.httpAgent
                        };
                        this.agent && (u.httpsAgent = this.agent.https, u.httpAgent = this.agent.http), "https" === this.host.substring(0, 5) ? o.agent = u.httpsAgent : o.agent = u.httpAgent;
                    }
                    this.headers && this.headers.forEach(function(e) {
                        a[e.name] = e.value;
                    }), a["Content-Type"] || (a["Content-Type"] = "application/json"), this.withCredentials ? o.credentials = "include" : o.credentials = "omit", o.headers = a, this.timeout > 0 && void 0 !== r && (this.timeoutId = setTimeout(function() {
                        r.abort();
                    }, this.timeout)), s(this.host, o).then((function(e) {
                        void 0 !== this.timeoutId && clearTimeout(this.timeoutId), e.json().then(function(e) {
                            t(null, e);
                        }, function() {
                            e.text().then(function(e) {
                                t(n.InvalidResponse(e));
                            }, function() {
                                t(n.InvalidResponse(""));
                            });
                        });
                    }).bind(this), (function(e) {
                        void 0 !== this.timeoutId && clearTimeout(this.timeoutId), "AbortError" !== e.name ? t(n.InvalidConnection(this.host, e)) : t(n.ConnectionTimeout(this.timeout));
                    }).bind(this));
                }, s.prototype.disconnect = function() {}, s.prototype.supportsSubscriptions = function() {
                    return !1;
                }, e.exports = s;
            },
            52683: (e, t, r)=>{
                "use strict";
                var n = r(11314).errors, i = r(83150), o = function(e, t) {
                    var r = this;
                    this.responseCallbacks = {}, this.notificationCallbacks = [], this.path = e, this.connected = !1, this.connection = t.connect({
                        path: this.path
                    }), this.addDefaultEvents();
                    var n = function(e) {
                        var t = null;
                        Array.isArray(e) ? e.forEach(function(e) {
                            r.responseCallbacks[e.id] && (t = e.id);
                        }) : t = e.id, t || -1 === e.method.indexOf("_subscription") ? r.responseCallbacks[t] && (r.responseCallbacks[t](null, e), delete r.responseCallbacks[t]) : r.notificationCallbacks.forEach(function(t) {
                            "function" == typeof t && t(e);
                        });
                    };
                    "Socket" === t.constructor.name ? i(this.connection).done(n) : this.connection.on("data", function(e) {
                        r._parseResponse(e.toString()).forEach(n);
                    });
                };
                o.prototype.addDefaultEvents = function() {
                    var e = this;
                    this.connection.on("connect", function() {
                        e.connected = !0;
                    }), this.connection.on("close", function() {
                        e.connected = !1;
                    }), this.connection.on("error", function() {
                        e._timeout();
                    }), this.connection.on("end", function() {
                        e._timeout();
                    }), this.connection.on("timeout", function() {
                        e._timeout();
                    });
                }, o.prototype._parseResponse = function(e) {
                    var t = this, r = [];
                    return e.replace(/\}[\n\r]?\{/g, "}|--|{").replace(/\}\][\n\r]?\[\{/g, "}]|--|[{").replace(/\}[\n\r]?\[\{/g, "}|--|[{").replace(/\}\][\n\r]?\{/g, "}]|--|{").split("|--|").forEach(function(e) {
                        t.lastChunk && (e = t.lastChunk + e);
                        var i = null;
                        try {
                            i = JSON.parse(e);
                        } catch (r) {
                            return t.lastChunk = e, clearTimeout(t.lastChunkTimeout), void (t.lastChunkTimeout = setTimeout(function() {
                                throw t._timeout(), n.InvalidResponse(e);
                            }, 15e3));
                        }
                        clearTimeout(t.lastChunkTimeout), t.lastChunk = null, i && r.push(i);
                    }), r;
                }, o.prototype._addResponseCallback = function(e, t) {
                    var r = e.id || e[0].id, n = e.method || e[0].method;
                    this.responseCallbacks[r] = t, this.responseCallbacks[r].method = n;
                }, o.prototype._timeout = function() {
                    for(var e in this.responseCallbacks)this.responseCallbacks.hasOwnProperty(e) && (this.responseCallbacks[e](n.InvalidConnection("on IPC")), delete this.responseCallbacks[e]);
                }, o.prototype.reconnect = function() {
                    this.connection.connect({
                        path: this.path
                    });
                }, o.prototype.send = function(e, t) {
                    this.connection.writable || this.connection.connect({
                        path: this.path
                    }), this.connection.write(JSON.stringify(e)), this._addResponseCallback(e, t);
                }, o.prototype.on = function(e, t) {
                    if ("function" != typeof t) throw new Error("The second parameter callback must be a function.");
                    "data" === e ? this.notificationCallbacks.push(t) : this.connection.on(e, t);
                }, o.prototype.once = function(e, t) {
                    if ("function" != typeof t) throw new Error("The second parameter callback must be a function.");
                    this.connection.once(e, t);
                }, o.prototype.removeListener = function(e, t) {
                    var r = this;
                    "data" === e ? this.notificationCallbacks.forEach(function(e, n) {
                        e === t && r.notificationCallbacks.splice(n, 1);
                    }) : this.connection.removeListener(e, t);
                }, o.prototype.removeAllListeners = function(e) {
                    "data" === e ? this.notificationCallbacks = [] : this.connection.removeAllListeners(e);
                }, o.prototype.reset = function() {
                    this._timeout(), this.notificationCallbacks = [], this.connection.removeAllListeners("error"), this.connection.removeAllListeners("end"), this.connection.removeAllListeners("timeout"), this.addDefaultEvents();
                }, o.prototype.supportsSubscriptions = function() {
                    return !0;
                }, e.exports = o;
            },
            40360: (e, t, r)=>{
                "use strict";
                var n = r(19142), i = r(29033).Buffer, o = r(28847)(r(3355)), a = "[object process]" === Object.prototype.toString.call(void 0 !== n ? n : 0), s = "undefined" != typeof navigator && "ReactNative" === navigator.product, u = null, c = null;
                if (a || s) {
                    u = function(e) {
                        return i.from(e).toString("base64");
                    };
                    var f = r(51143);
                    if (f.URL) {
                        var d = f.URL;
                        c = function(e) {
                            return new d(e);
                        };
                    } else c = r(51143).parse;
                } else u = btoa.bind("object" === ("undefined" == typeof globalThis ? "undefined" : (0, o.default)(globalThis)) ? globalThis : self), c = function(e) {
                    return new URL(e);
                };
                e.exports = {
                    parseURL: c,
                    btoa: u
                };
            },
            77651: (e, t, r)=>{
                "use strict";
                var n = r(98008), i = r(40360), o = r(11314).errors, a = r(1158).w3cwebsocket, s = function(e, t) {
                    n.call(this), t = t || {}, this.url = e, this._customTimeout = t.timeout || 15e3, this.headers = t.headers || {}, this.protocol = t.protocol || void 0, this.reconnectOptions = Object.assign({
                        auto: !1,
                        delay: 5e3,
                        maxAttempts: !1,
                        onTimeout: !1
                    }, t.reconnect), this.clientConfig = t.clientConfig || void 0, this.requestOptions = t.requestOptions || void 0, this.DATA = "data", this.CLOSE = "close", this.ERROR = "error", this.CONNECT = "connect", this.RECONNECT = "reconnect", this.connection = null, this.requestQueue = new Map, this.responseQueue = new Map, this.reconnectAttempts = 0, this.reconnecting = !1, this.connectFailedDescription = null;
                    var r = i.parseURL(e);
                    r.username && r.password && (this.headers.authorization = "Basic " + i.btoa(r.username + ":" + r.password)), r.auth && (this.headers.authorization = "Basic " + i.btoa(r.auth)), Object.defineProperty(this, "connected", {
                        get: function() {
                            return this.connection && this.connection.readyState === this.connection.OPEN;
                        },
                        enumerable: !0
                    }), this.connect();
                };
                (s.prototype = Object.create(n.prototype)).constructor = s, s.prototype.connect = function() {
                    this.connection = new a(this.url, this.protocol, void 0, this.headers, this.requestOptions, this.clientConfig), this._addSocketListeners();
                }, s.prototype._onMessage = function(e) {
                    var t = this;
                    this._parseResponse("string" == typeof e.data ? e.data : "").forEach(function(e) {
                        if (e.method && -1 !== e.method.indexOf("_subscription")) t.emit(t.DATA, e);
                        else {
                            var r = e.id;
                            Array.isArray(e) && (r = e[0].id), t.responseQueue.has(r) && (void 0 !== t.responseQueue.get(r).callback && t.responseQueue.get(r).callback(!1, e), t.responseQueue.delete(r));
                        }
                    });
                }, s.prototype._onConnect = function() {
                    if (this.emit(this.CONNECT), this.reconnectAttempts = 0, this.reconnecting = !1, this.requestQueue.size > 0) {
                        var e = this;
                        this.requestQueue.forEach(function(t, r) {
                            e.send(t.payload, t.callback), e.requestQueue.delete(r);
                        });
                    }
                }, s.prototype._onConnectFailed = function(e) {
                    this.connectFailedDescription = e.toString().split("\n")[0];
                    var t = this;
                    this.connectFailedDescription && (e.description = this.connectFailedDescription, this.connectFailedDescription = null), e.code = 1006, e.reason = "connection failed", !this.reconnectOptions.auto || [
                        1e3,
                        1001
                    ].includes(e.code) && !1 !== e.wasClean ? (this.emit(this.ERROR, e), this.requestQueue.size > 0 && this.requestQueue.forEach(function(r, n) {
                        r.callback(o.ConnectionNotOpenError(e)), t.requestQueue.delete(n);
                    }), this.responseQueue.size > 0 && this.responseQueue.forEach(function(r, n) {
                        r.callback(o.InvalidConnection("on WS", e)), t.responseQueue.delete(n);
                    }), this.connection._connection && this.connection._connection.removeAllListeners(), this.connection._client.removeAllListeners(), this.connection._readyState = 3, this.emit(this.CLOSE, e)) : this.reconnect();
                }, s.prototype._onClose = function(e) {
                    var t = this;
                    !this.reconnectOptions.auto || [
                        1e3,
                        1001
                    ].includes(e.code) && !1 !== e.wasClean ? (this.emit(this.CLOSE, e), this.requestQueue.size > 0 && this.requestQueue.forEach(function(r, n) {
                        r.callback(o.ConnectionNotOpenError(e)), t.requestQueue.delete(n);
                    }), this.responseQueue.size > 0 && this.responseQueue.forEach(function(r, n) {
                        r.callback(o.InvalidConnection("on WS", e)), t.responseQueue.delete(n);
                    }), this._removeSocketListeners(), this.removeAllListeners()) : this.reconnect();
                }, s.prototype._addSocketListeners = function() {
                    this.connection.addEventListener("message", this._onMessage.bind(this)), this.connection.addEventListener("open", this._onConnect.bind(this)), this.connection.addEventListener("close", this._onClose.bind(this)), this.connection._client && (this.connection._client.removeAllListeners("connectFailed"), this.connection._client.on("connectFailed", this._onConnectFailed.bind(this)));
                }, s.prototype._removeSocketListeners = function() {
                    this.connection.removeEventListener("message", this._onMessage), this.connection.removeEventListener("open", this._onConnect), this.connection.removeEventListener("close", this._onClose), this.connection._connection && this.connection._client.removeListener("connectFailed", this._onConnectFailed);
                }, s.prototype._parseResponse = function(e) {
                    var t = this, r = [];
                    return e.replace(/\}[\n\r]?\{/g, "}|--|{").replace(/\}\][\n\r]?\[\{/g, "}]|--|[{").replace(/\}[\n\r]?\[\{/g, "}|--|[{").replace(/\}\][\n\r]?\{/g, "}]|--|{").split("|--|").forEach(function(e) {
                        t.lastChunk && (e = t.lastChunk + e);
                        var n = null;
                        try {
                            n = JSON.parse(e);
                        } catch (r) {
                            return t.lastChunk = e, clearTimeout(t.lastChunkTimeout), void (t.lastChunkTimeout = setTimeout(function() {
                                t.reconnectOptions.auto && t.reconnectOptions.onTimeout ? t.reconnect() : (t.emit(t.ERROR, o.ConnectionTimeout(t._customTimeout)), t.requestQueue.size > 0 && t.requestQueue.forEach(function(e, r) {
                                    e.callback(o.ConnectionTimeout(t._customTimeout)), t.requestQueue.delete(r);
                                }));
                            }, t._customTimeout));
                        }
                        clearTimeout(t.lastChunkTimeout), t.lastChunk = null, n && r.push(n);
                    }), r;
                }, s.prototype.send = function(e, t) {
                    var r = e.id, n = {
                        payload: e,
                        callback: t
                    };
                    if (Array.isArray(e) && (r = e[0].id), this.connection.readyState === this.connection.CONNECTING || this.reconnecting) this.requestQueue.set(r, n);
                    else {
                        if (this.connection.readyState !== this.connection.OPEN) return this.requestQueue.delete(r), this.emit(this.ERROR, o.ConnectionNotOpenError()), void n.callback(o.ConnectionNotOpenError());
                        this.responseQueue.set(r, n), this.requestQueue.delete(r);
                        try {
                            this.connection.send(JSON.stringify(n.payload));
                        } catch (e) {
                            n.callback(e), this.responseQueue.delete(r);
                        }
                    }
                }, s.prototype.reset = function() {
                    this.responseQueue.clear(), this.requestQueue.clear(), this.removeAllListeners(), this._removeSocketListeners(), this._addSocketListeners();
                }, s.prototype.disconnect = function(e, t) {
                    this._removeSocketListeners(), this.connection.close(e || 1e3, t);
                }, s.prototype.supportsSubscriptions = function() {
                    return !0;
                }, s.prototype.reconnect = function() {
                    var e = this;
                    this.reconnecting = !0, this.responseQueue.size > 0 && this.responseQueue.forEach(function(t, r) {
                        try {
                            e.responseQueue.delete(r), t.callback(o.PendingRequestsOnReconnectingError());
                        } catch (e) {
                            console.error("Error encountered in reconnect: ", e);
                        }
                    }), !this.reconnectOptions.maxAttempts || this.reconnectAttempts < this.reconnectOptions.maxAttempts ? setTimeout(function() {
                        e.reconnectAttempts++, e._removeSocketListeners(), e.emit(e.RECONNECT, e.reconnectAttempts), e.connect();
                    }, this.reconnectOptions.delay) : (this.emit(this.ERROR, o.MaxAttemptsReachedOnReconnectingError()), this.reconnecting = !1, this.requestQueue.size > 0 && this.requestQueue.forEach(function(t, r) {
                        t.callback(o.MaxAttemptsReachedOnReconnectingError()), e.requestQueue.delete(r);
                    }));
                }, e.exports = s;
            },
            92565: (e, t, r)=>{
                "use strict";
                var n = r(80606), i = r(34178).subscriptions, o = r(53349), a = r(473), s = function() {
                    var e = this;
                    n.packageInit(this, arguments);
                    var t = this.setRequestManager;
                    this.setRequestManager = function(r) {
                        return t(r), e.net.setRequestManager(r), !0;
                    };
                    var r = this.setProvider;
                    this.setProvider = function() {
                        r.apply(e, arguments), e.setRequestManager(e._requestManager);
                    }, this.net = new a(this), [
                        new i({
                            name: "subscribe",
                            type: "shh",
                            subscriptions: {
                                messages: {
                                    params: 1
                                }
                            }
                        }),
                        new o({
                            name: "getVersion",
                            call: "shh_version",
                            params: 0
                        }),
                        new o({
                            name: "getInfo",
                            call: "shh_info",
                            params: 0
                        }),
                        new o({
                            name: "setMaxMessageSize",
                            call: "shh_setMaxMessageSize",
                            params: 1
                        }),
                        new o({
                            name: "setMinPoW",
                            call: "shh_setMinPoW",
                            params: 1
                        }),
                        new o({
                            name: "markTrustedPeer",
                            call: "shh_markTrustedPeer",
                            params: 1
                        }),
                        new o({
                            name: "newKeyPair",
                            call: "shh_newKeyPair",
                            params: 0
                        }),
                        new o({
                            name: "addPrivateKey",
                            call: "shh_addPrivateKey",
                            params: 1
                        }),
                        new o({
                            name: "deleteKeyPair",
                            call: "shh_deleteKeyPair",
                            params: 1
                        }),
                        new o({
                            name: "hasKeyPair",
                            call: "shh_hasKeyPair",
                            params: 1
                        }),
                        new o({
                            name: "getPublicKey",
                            call: "shh_getPublicKey",
                            params: 1
                        }),
                        new o({
                            name: "getPrivateKey",
                            call: "shh_getPrivateKey",
                            params: 1
                        }),
                        new o({
                            name: "newSymKey",
                            call: "shh_newSymKey",
                            params: 0
                        }),
                        new o({
                            name: "addSymKey",
                            call: "shh_addSymKey",
                            params: 1
                        }),
                        new o({
                            name: "generateSymKeyFromPassword",
                            call: "shh_generateSymKeyFromPassword",
                            params: 1
                        }),
                        new o({
                            name: "hasSymKey",
                            call: "shh_hasSymKey",
                            params: 1
                        }),
                        new o({
                            name: "getSymKey",
                            call: "shh_getSymKey",
                            params: 1
                        }),
                        new o({
                            name: "deleteSymKey",
                            call: "shh_deleteSymKey",
                            params: 1
                        }),
                        new o({
                            name: "newMessageFilter",
                            call: "shh_newMessageFilter",
                            params: 1
                        }),
                        new o({
                            name: "getFilterMessages",
                            call: "shh_getFilterMessages",
                            params: 1
                        }),
                        new o({
                            name: "deleteMessageFilter",
                            call: "shh_deleteMessageFilter",
                            params: 1
                        }),
                        new o({
                            name: "post",
                            call: "shh_post",
                            params: 1,
                            inputFormatter: [
                                null
                            ]
                        }),
                        new o({
                            name: "unsubscribe",
                            call: "shh_unsubscribe",
                            params: 1
                        })
                    ].forEach(function(t) {
                        t.attachToObject(e), t.setRequestManager(e._requestManager);
                    });
                };
                s.prototype.clearSubscriptions = function() {
                    this._requestManager.clearSubscriptions();
                }, n.addProviders(s), e.exports = s;
            },
            48161: (e, t, r)=>{
                "use strict";
                var n = r(28847)(r(3355)), i = r(17130), o = r(90323), a = r(747), s = r(75010), u = r(31734), c = function e(t, r) {
                    var i = [];
                    return r.forEach(function(r) {
                        if ("object" === (0, n.default)(r.components)) {
                            if ("tuple" !== r.type.substring(0, 5)) throw new Error("components found but type is not tuple; report on GitHub");
                            var o = "", a = r.type.indexOf("[");
                            a >= 0 && (o = r.type.substring(a));
                            var s = e(t, r.components);
                            Array.isArray(s) && t ? i.push("tuple(" + s.join(",") + ")" + o) : t ? i.push("(" + s + ")") : i.push("(" + s.join(",") + ")" + o);
                        } else i.push(r.type);
                    }), i;
                }, f = function(e) {
                    if (!o.isHexStrict(e)) throw new Error("The parameter must be a valid HEX string.");
                    var t = "", r = 0, n = e.length;
                    for("0x" === e.substring(0, 2) && (r = 2); r < n; r += 2){
                        var i = parseInt(e.slice(r, r + 2), 16);
                        t += String.fromCharCode(i);
                    }
                    return t;
                }, d = function(e) {
                    if (!e) return "0x00";
                    for(var t = "", r = 0; r < e.length; r++){
                        var n = e.charCodeAt(r).toString(16);
                        t += n.length < 2 ? "0" + n : n;
                    }
                    return "0x" + t;
                }, l = function(e) {
                    if (e = e ? e.toLowerCase() : "ether", !i.unitMap[e]) throw new Error('This unit "' + e + "\" doesn't exist, please use the one of the following units" + JSON.stringify(i.unitMap, null, 2));
                    return e;
                };
                e.exports = {
                    _fireError: function(e, t, r, i, o) {
                        return !e || "object" !== (0, n.default)(e) || e instanceof Error || !e.data || ((e.data && "object" === (0, n.default)(e.data) || Array.isArray(e.data)) && (e.data = JSON.stringify(e.data, null, 2)), e = e.message + "\n" + e.data), "string" == typeof e && (e = new Error(e)), "function" == typeof i && i(e, o), "function" == typeof r && ((t && "function" == typeof t.listeners && t.listeners("error").length || "function" == typeof i) && t.catch(function() {}), setTimeout(function() {
                            r(e);
                        }, 1)), t && "function" == typeof t.emit && setTimeout(function() {
                            t.emit("error", e, o), t.removeAllListeners();
                        }, 1), t;
                    },
                    _jsonInterfaceMethodToString: function(e) {
                        return e && "object" === (0, n.default)(e) && e.name && -1 !== e.name.indexOf("(") ? e.name : e.name + "(" + c(!1, e.inputs).join(",") + ")";
                    },
                    _flattenTypes: c,
                    randomHex: function(e) {
                        return "0x" + s(e).toString("hex");
                    },
                    BN: o.BN,
                    isBN: o.isBN,
                    isBigNumber: o.isBigNumber,
                    isHex: o.isHex,
                    isHexStrict: o.isHexStrict,
                    sha3: o.sha3,
                    sha3Raw: o.sha3Raw,
                    keccak256: o.sha3,
                    soliditySha3: a.soliditySha3,
                    soliditySha3Raw: a.soliditySha3Raw,
                    encodePacked: a.encodePacked,
                    isAddress: o.isAddress,
                    checkAddressChecksum: o.checkAddressChecksum,
                    toChecksumAddress: function(e) {
                        if (void 0 === e) return "";
                        if (!/^(0x)?[0-9a-f]{40}$/i.test(e)) throw new Error('Given address "' + e + '" is not a valid Ethereum address.');
                        e = e.toLowerCase().replace(/^0x/i, "");
                        for(var t = o.sha3(e).replace(/^0x/i, ""), r = "0x", n = 0; n < e.length; n++)parseInt(t[n], 16) > 7 ? r += e[n].toUpperCase() : r += e[n];
                        return r;
                    },
                    toHex: o.toHex,
                    toBN: o.toBN,
                    bytesToHex: o.bytesToHex,
                    hexToBytes: o.hexToBytes,
                    hexToNumberString: o.hexToNumberString,
                    hexToNumber: o.hexToNumber,
                    toDecimal: o.hexToNumber,
                    numberToHex: o.numberToHex,
                    fromDecimal: o.numberToHex,
                    hexToUtf8: o.hexToUtf8,
                    hexToString: o.hexToUtf8,
                    toUtf8: o.hexToUtf8,
                    stripHexPrefix: o.stripHexPrefix,
                    utf8ToHex: o.utf8ToHex,
                    stringToHex: o.utf8ToHex,
                    fromUtf8: o.utf8ToHex,
                    hexToAscii: f,
                    toAscii: f,
                    asciiToHex: d,
                    fromAscii: d,
                    unitMap: i.unitMap,
                    toWei: function(e, t) {
                        if (t = l(t), !o.isBN(e) && "string" != typeof e) throw new Error("Please pass numbers as strings or BN objects to avoid precision errors.");
                        return o.isBN(e) ? i.toWei(e, t) : i.toWei(e, t).toString(10);
                    },
                    fromWei: function(e, t) {
                        if (t = l(t), !o.isBN(e) && "string" != typeof e) throw new Error("Please pass numbers as strings or BN objects to avoid precision errors.");
                        return o.isBN(e) ? i.fromWei(e, t) : i.fromWei(e, t).toString(10);
                    },
                    padLeft: o.leftPad,
                    leftPad: o.leftPad,
                    padRight: o.rightPad,
                    rightPad: o.rightPad,
                    toTwosComplement: o.toTwosComplement,
                    isBloom: o.isBloom,
                    isUserEthereumAddressInBloom: o.isUserEthereumAddressInBloom,
                    isContractAddressInBloom: o.isContractAddressInBloom,
                    isTopic: o.isTopic,
                    isTopicInBloom: o.isTopicInBloom,
                    isInBloom: o.isInBloom,
                    compareBlockNumbers: function(e, t) {
                        if (e === t) return 0;
                        if ("genesis" !== e && "earliest" !== e && 0 !== e || "genesis" !== t && "earliest" !== t && 0 !== t) {
                            if ("genesis" === e || "earliest" === e || 0 === e) return -1;
                            if ("genesis" === t || "earliest" === t || 0 === t) return 1;
                            if ("latest" === e || "finalized" === e) return "pending" === t ? -1 : 1;
                            if ("latest" === t || "finalized" === t) return "pending" === e ? 1 : -1;
                            if ("pending" === e) return 1;
                            if ("pending" === t) return -1;
                            if ("safe" === e || "safe" === t) return;
                            var r = new u(e), n = new u(t);
                            return r.lt(n) ? -1 : r.eq(n) ? 0 : 1;
                        }
                        return 0;
                    },
                    toNumber: o.toNumber
                };
            },
            747: (e, t, r)=>{
                "use strict";
                var n = r(28847)(r(3355)), i = r(31734), o = r(90323), a = function(e) {
                    var t = (0, n.default)(e);
                    if ("string" === t) return o.isHexStrict(e) ? new i(e.replace(/0x/i, ""), 16) : new i(e, 10);
                    if ("number" === t) return new i(e);
                    if (o.isBigNumber(e)) return new i(e.toString(10));
                    if (o.isBN(e)) return e;
                    throw new Error(e + " is not a number");
                }, s = function(e, t, r) {
                    var n, s;
                    if ("bytes" === (e = function(e) {
                        return e.startsWith("int[") ? "int256" + e.slice(3) : "int" === e ? "int256" : e.startsWith("uint[") ? "uint256" + e.slice(4) : "uint" === e ? "uint256" : e.startsWith("fixed[") ? "fixed128x128" + e.slice(5) : "fixed" === e ? "fixed128x128" : e.startsWith("ufixed[") ? "ufixed128x128" + e.slice(6) : "ufixed" === e ? "ufixed128x128" : e;
                    }(e))) {
                        if (t.replace(/^0x/i, "").length % 2 != 0) throw new Error("Invalid bytes characters " + t.length);
                        return t;
                    }
                    if ("string" === e) return o.utf8ToHex(t);
                    if ("bool" === e) return t ? "01" : "00";
                    if (e.startsWith("address")) {
                        if (n = r ? 64 : 40, !o.isAddress(t)) throw new Error(t + " is not a valid address, or the checksum is invalid.");
                        return o.leftPad(t.toLowerCase(), n);
                    }
                    if (n = function(e) {
                        var t = /^\D+(\d+).*$/.exec(e);
                        return t ? parseInt(t[1], 10) : null;
                    }(e), e.startsWith("bytes")) {
                        if (!n) throw new Error("bytes[] not yet supported in solidity");
                        if (r && (n = 32), n < 1 || n > 32 || n < t.replace(/^0x/i, "").length / 2) throw new Error("Invalid bytes" + n + " for " + t);
                        return o.rightPad(t, 2 * n);
                    }
                    if (e.startsWith("uint")) {
                        if (n % 8 || n < 8 || n > 256) throw new Error("Invalid uint" + n + " size");
                        if ((s = a(t)).bitLength() > n) throw new Error("Supplied uint exceeds width: " + n + " vs " + s.bitLength());
                        if (s.lt(new i(0))) throw new Error("Supplied uint " + s.toString() + " is negative");
                        return n ? o.leftPad(s.toString("hex"), n / 8 * 2) : s;
                    }
                    if (e.startsWith("int")) {
                        if (n % 8 || n < 8 || n > 256) throw new Error("Invalid int" + n + " size");
                        if ((s = a(t)).bitLength() > n) throw new Error("Supplied int exceeds width: " + n + " vs " + s.bitLength());
                        return s.lt(new i(0)) ? s.toTwos(n).toString("hex") : n ? o.leftPad(s.toString("hex"), n / 8 * 2) : s;
                    }
                    throw new Error("Unsupported or invalid type: " + e);
                }, u = function(e) {
                    if (Array.isArray(e)) throw new Error("Autodetection of array types is not supported.");
                    var t, r, a = "";
                    if (e && "object" === (0, n.default)(e) && (e.hasOwnProperty("v") || e.hasOwnProperty("t") || e.hasOwnProperty("value") || e.hasOwnProperty("type")) ? (t = e.hasOwnProperty("t") ? e.t : e.type, a = e.hasOwnProperty("v") ? e.v : e.value) : (t = o.toHex(e, !0), a = o.toHex(e), t.startsWith("int") || t.startsWith("uint") || (t = "bytes")), !t.startsWith("int") && !t.startsWith("uint") || "string" != typeof a || /^(-)?0x/i.test(a) || (a = new i(a)), Array.isArray(a)) {
                        if (r = function(e) {
                            var t = /^\D+\d*\[(\d+)\]$/.exec(e);
                            return t ? parseInt(t[1], 10) : null;
                        }(t), r && a.length !== r) throw new Error(t + " is not matching the given array " + JSON.stringify(a));
                        r = a.length;
                    }
                    return Array.isArray(a) ? a.map(function(e) {
                        return s(t, e, r).toString("hex").replace("0x", "");
                    }).join("") : s(t, a, r).toString("hex").replace("0x", "");
                };
                e.exports = {
                    soliditySha3: function() {
                        var e = Array.prototype.slice.call(arguments).map(u);
                        return o.sha3("0x" + e.join(""));
                    },
                    soliditySha3Raw: function() {
                        return o.sha3Raw("0x" + Array.prototype.slice.call(arguments).map(u).join(""));
                    },
                    encodePacked: function() {
                        return "0x" + Array.prototype.slice.call(arguments).map(u).join("").toLowerCase();
                    }
                };
            },
            90323: (e, t, r)=>{
                "use strict";
                var n = r(29033).Buffer, i = r(28847), o = i(r(74519)), a = i(r(3355)), s = r(31734), u = r(77277), c = r(88632), f = r(65907), d = r(19313), l = r(1243).keccak256, h = function(e) {
                    return s.isBN(e);
                }, p = function(e) {
                    return e && e.constructor && "BigNumber" === e.constructor.name;
                }, b = function(e) {
                    try {
                        return u.apply(null, arguments);
                    } catch (t) {
                        throw new Error(t + ' Given value: "' + e + '"');
                    }
                }, y = function(e) {
                    return !!/^(0x)?[0-9a-f]{40}$/i.test(e) && (!(!/^(0x|0X)?[0-9a-f]{40}$/.test(e) && !/^(0x|0X)?[0-9A-F]{40}$/.test(e)) || v(e));
                }, v = function(e) {
                    e = e.replace(/^0x/i, "");
                    for(var t = S(e.toLowerCase()).replace(/^0x/i, ""), r = 0; r < 40; r++)if (parseInt(t[r], 16) > 7 && e[r].toUpperCase() !== e[r] || parseInt(t[r], 16) <= 7 && e[r].toLowerCase() !== e[r]) return !1;
                    return !0;
                }, m = function(e) {
                    var t = "";
                    e = (e = (e = (e = (e = c.encode(e)).replace(/^(?:\u0000)*/, "")).split("").reverse().join("")).replace(/^(?:\u0000)*/, "")).split("").reverse().join("");
                    for(var r = 0; r < e.length; r++){
                        var n = e.charCodeAt(r).toString(16);
                        t += n.length < 2 ? "0" + n : n;
                    }
                    return "0x" + t;
                }, g = function(e) {
                    var t = arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
                    if (!e) return e;
                    if ("string" == typeof e && !_(e)) throw new Error('Given value "' + e + '" is not a valid hex string.');
                    var r = b(e);
                    return t && (r > Number.MAX_SAFE_INTEGER || r < Number.MIN_SAFE_INTEGER) ? BigInt(r) : r.toNumber();
                }, w = function(e) {
                    if (null == e) return e;
                    if (!isFinite(e) && !_(e)) throw new Error('Given input "' + e + '" is not a number.');
                    var t = b(e), r = t.toString(16);
                    return t.lt(new s(0)) ? "-0x" + r.slice(1) : "0x" + r;
                }, k = function(e, t) {
                    if (y(e)) return t ? "address" : "0x" + e.toLowerCase().replace(/^0x/i, "");
                    if ("boolean" == typeof e) return t ? "bool" : e ? "0x01" : "0x00";
                    if (n.isBuffer(e)) return "0x" + e.toString("hex");
                    if ("object" === (0, a.default)(e) && e && !p(e) && !h(e)) return t ? "string" : m(JSON.stringify(e));
                    if ("string" == typeof e) {
                        if (0 === e.indexOf("-0x") || 0 === e.indexOf("-0X")) return t ? "int256" : w(e);
                        if (0 === e.indexOf("0x") || 0 === e.indexOf("0X")) return t ? "bytes" : e;
                        if (!isFinite(e)) return t ? "string" : m(e);
                    }
                    return t ? e < 0 ? "int256" : "uint256" : w(e);
                }, _ = function(e) {
                    return ("string" == typeof e || "number" == typeof e) && /^(-)?0x[0-9a-f]*$/i.test(e);
                }, A = function(e) {
                    return ("string" == typeof e || "number" == typeof e) && /^(-0x|0x)?[0-9a-f]*$/i.test(e);
                }, E = "0xc5d2460186f7233c927e7db2dcc703c0e500b653ca82273b7bfad8045d85a470", S = function(e) {
                    h(e) && (e = e.toString()), _(e) && /^0x/i.test(e.toString()) ? e = f.toBuffer(e) : "string" == typeof e && (e = n.from(e, "utf-8"));
                    var t = f.bufferToHex(l(e));
                    return t === E ? null : t;
                };
                S._Hash = l;
                var x = function(e) {
                    if ("string" == typeof e && e.includes("0x")) {
                        var t = e.toLocaleLowerCase().startsWith("-") ? [
                            "-",
                            e.slice(3)
                        ] : [
                            "",
                            e.slice(2)
                        ], r = (0, o.default)(t, 2), n = r[0], i = r[1];
                        return new s(n + i, 16);
                    }
                    return new s(e);
                };
                Object.setPrototypeOf(x, s), Object.setPrototypeOf(x.prototype, s.prototype), e.exports = {
                    BN: x,
                    isBN: h,
                    isBigNumber: p,
                    toBN: b,
                    isAddress: y,
                    isBloom: function(e) {
                        return d.isBloom(e);
                    },
                    isUserEthereumAddressInBloom: function(e, t) {
                        return d.isUserEthereumAddressInBloom(e, t);
                    },
                    isContractAddressInBloom: function(e, t) {
                        return d.isContractAddressInBloom(e, t);
                    },
                    isTopic: function(e) {
                        return d.isTopic(e);
                    },
                    isTopicInBloom: function(e, t) {
                        return d.isTopicInBloom(e, t);
                    },
                    isInBloom: function(e, t) {
                        return d.isInBloom(e, t);
                    },
                    checkAddressChecksum: v,
                    utf8ToHex: m,
                    hexToUtf8: function(e) {
                        if (!_(e)) throw new Error('The parameter "' + e + '" must be a valid HEX string.');
                        for(var t = "", r = 0, n = (e = (e = (e = (e = (e = e.replace(/^0x/i, "")).replace(/^(?:00)*/, "")).split("").reverse().join("")).replace(/^(?:00)*/, "")).split("").reverse().join("")).length, i = 0; i < n; i += 2)r = parseInt(e.slice(i, i + 2), 16), t += String.fromCharCode(r);
                        return c.decode(t);
                    },
                    hexToNumber: g,
                    hexToNumberString: function(e) {
                        if (!e) return e;
                        if ("string" == typeof e && !_(e)) throw new Error('Given value "' + e + '" is not a valid hex string.');
                        return b(e).toString(10);
                    },
                    numberToHex: w,
                    toHex: k,
                    hexToBytes: function(e) {
                        if (e = e.toString(16), !_(e)) throw new Error('Given value "' + e + '" is not a valid hex string.');
                        e = e.replace(/^0x/i, "");
                        for(var t = [], r = 0; r < e.length; r += 2)t.push(parseInt(e.slice(r, r + 2), 16));
                        return t;
                    },
                    bytesToHex: function(e) {
                        for(var t = [], r = 0; r < e.length; r++)t.push((e[r] >>> 4).toString(16)), t.push((15 & e[r]).toString(16));
                        return "0x" + t.join("");
                    },
                    isHex: A,
                    isHexStrict: _,
                    stripHexPrefix: function(e) {
                        return 0 !== e && A(e) ? e.replace(/^(-)?0x/i, "$1") : e;
                    },
                    leftPad: function(e, t, r) {
                        var n = /^0x/i.test(e) || "number" == typeof e, i = t - (e = e.toString(16).replace(/^0x/i, "")).length + 1 >= 0 ? t - e.length + 1 : 0;
                        return (n ? "0x" : "") + new Array(i).join(r || "0") + e;
                    },
                    rightPad: function(e, t, r) {
                        var n = /^0x/i.test(e) || "number" == typeof e, i = t - (e = e.toString(16).replace(/^0x/i, "")).length + 1 >= 0 ? t - e.length + 1 : 0;
                        return (n ? "0x" : "") + e + new Array(i).join(r || "0");
                    },
                    toTwosComplement: function(e) {
                        return "0x" + b(e).toTwos(256).toString(16, 64);
                    },
                    sha3: S,
                    sha3Raw: function(e) {
                        return null === (e = S(e)) ? E : e;
                    },
                    toNumber: function(e) {
                        var t = arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
                        return "number" == typeof e ? e : g(k(e), t);
                    }
                };
            },
            17001: (e, t, r)=>{
                "use strict";
                var n = r(78920).i8, i = r(80606), o = r(66748), a = r(473), s = r(96306), u = r(92565), c = r(42463), f = r(48161), d = function() {
                    var e = this;
                    i.packageInit(this, arguments), this.version = n, this.utils = f, this.eth = new o(this), this.shh = new u(this), this.bzz = new c(this);
                    var t = this.setProvider;
                    this.setProvider = function(r, n) {
                        return t.apply(e, arguments), e.eth.setRequestManager(e._requestManager), e.shh.setRequestManager(e._requestManager), e.bzz.setProvider(r), !0;
                    };
                };
                d.version = n, d.utils = f, d.modules = {
                    Eth: o,
                    Net: a,
                    Personal: s,
                    Shh: u,
                    Bzz: c
                }, i.addProviders(d), e.exports = d;
            },
            89214: ()=>{},
            52361: ()=>{},
            94616: ()=>{},
            38768: (e)=>{
                "use strict";
                e.exports = function(e, t) {
                    (null == t || t > e.length) && (t = e.length);
                    for(var r = 0, n = new Array(t); r < t; r++)n[r] = e[r];
                    return n;
                }, e.exports.__esModule = !0, e.exports.default = e.exports;
            },
            12338: (e)=>{
                "use strict";
                e.exports = function(e) {
                    if (Array.isArray(e)) return e;
                }, e.exports.__esModule = !0, e.exports.default = e.exports;
            },
            77907: (e, t, r)=>{
                "use strict";
                var n = r(38768);
                e.exports = function(e) {
                    if (Array.isArray(e)) return n(e);
                }, e.exports.__esModule = !0, e.exports.default = e.exports;
            },
            58975: (e)=>{
                "use strict";
                e.exports = function(e) {
                    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                    return e;
                }, e.exports.__esModule = !0, e.exports.default = e.exports;
            },
            94571: (e)=>{
                "use strict";
                function t(e, t, r, n, i, o, a) {
                    try {
                        var s = e[o](a), u = s.value;
                    } catch (e) {
                        return void r(e);
                    }
                    s.done ? t(u) : Promise.resolve(u).then(n, i);
                }
                e.exports = function(e) {
                    return function() {
                        var r = this, n = arguments;
                        return new Promise(function(i, o) {
                            var a = e.apply(r, n);
                            function s(e) {
                                t(a, i, o, s, u, "next", e);
                            }
                            function u(e) {
                                t(a, i, o, s, u, "throw", e);
                            }
                            s(void 0);
                        });
                    };
                }, e.exports.__esModule = !0, e.exports.default = e.exports;
            },
            69721: (e)=>{
                "use strict";
                e.exports = function(e, t) {
                    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                }, e.exports.__esModule = !0, e.exports.default = e.exports;
            },
            14727: (e, t, r)=>{
                "use strict";
                var n = r(38746), i = r(36923);
                function o(t, r, a) {
                    return i() ? (e.exports = o = Reflect.construct.bind(), e.exports.__esModule = !0, e.exports.default = e.exports) : (e.exports = o = function(e, t, r) {
                        var i = [
                            null
                        ];
                        i.push.apply(i, t);
                        var o = new (Function.bind.apply(e, i));
                        return r && n(o, r.prototype), o;
                    }, e.exports.__esModule = !0, e.exports.default = e.exports), o.apply(null, arguments);
                }
                e.exports = o, e.exports.__esModule = !0, e.exports.default = e.exports;
            },
            58985: (e, t, r)=>{
                "use strict";
                var n = r(32310);
                function i(e, t) {
                    for(var r = 0; r < t.length; r++){
                        var i = t[r];
                        i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(e, n(i.key), i);
                    }
                }
                e.exports = function(e, t, r) {
                    return t && i(e.prototype, t), r && i(e, r), Object.defineProperty(e, "prototype", {
                        writable: !1
                    }), e;
                }, e.exports.__esModule = !0, e.exports.default = e.exports;
            },
            90775: (e, t, r)=>{
                "use strict";
                var n = r(32310);
                e.exports = function(e, t, r) {
                    return (t = n(t)) in e ? Object.defineProperty(e, t, {
                        value: r,
                        enumerable: !0,
                        configurable: !0,
                        writable: !0
                    }) : e[t] = r, e;
                }, e.exports.__esModule = !0, e.exports.default = e.exports;
            },
            119: (e, t, r)=>{
                "use strict";
                var n = r(47460);
                function i() {
                    return "undefined" != typeof Reflect && Reflect.get ? (e.exports = i = Reflect.get.bind(), e.exports.__esModule = !0, e.exports.default = e.exports) : (e.exports = i = function(e, t, r) {
                        var i = n(e, t);
                        if (i) {
                            var o = Object.getOwnPropertyDescriptor(i, t);
                            return o.get ? o.get.call(arguments.length < 3 ? e : r) : o.value;
                        }
                    }, e.exports.__esModule = !0, e.exports.default = e.exports), i.apply(this, arguments);
                }
                e.exports = i, e.exports.__esModule = !0, e.exports.default = e.exports;
            },
            21949: (e)=>{
                "use strict";
                function t(r) {
                    return e.exports = t = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(e) {
                        return e.__proto__ || Object.getPrototypeOf(e);
                    }, e.exports.__esModule = !0, e.exports.default = e.exports, t(r);
                }
                e.exports = t, e.exports.__esModule = !0, e.exports.default = e.exports;
            },
            15163: (e, t, r)=>{
                "use strict";
                var n = r(38746);
                e.exports = function(e, t) {
                    if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
                    e.prototype = Object.create(t && t.prototype, {
                        constructor: {
                            value: e,
                            writable: !0,
                            configurable: !0
                        }
                    }), Object.defineProperty(e, "prototype", {
                        writable: !1
                    }), t && n(e, t);
                }, e.exports.__esModule = !0, e.exports.default = e.exports;
            },
            28847: (e)=>{
                "use strict";
                e.exports = function(e) {
                    return e && e.__esModule ? e : {
                        default: e
                    };
                }, e.exports.__esModule = !0, e.exports.default = e.exports;
            },
            78958: (e)=>{
                "use strict";
                e.exports = function(e) {
                    return -1 !== Function.toString.call(e).indexOf("[native code]");
                }, e.exports.__esModule = !0, e.exports.default = e.exports;
            },
            36923: (e)=>{
                "use strict";
                e.exports = function() {
                    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                    if (Reflect.construct.sham) return !1;
                    if ("function" == typeof Proxy) return !0;
                    try {
                        return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                    } catch (e) {
                        return !1;
                    }
                }, e.exports.__esModule = !0, e.exports.default = e.exports;
            },
            41642: (e)=>{
                "use strict";
                e.exports = function(e) {
                    if ("undefined" != typeof Symbol && null != e[Symbol.iterator] || null != e["@@iterator"]) return Array.from(e);
                }, e.exports.__esModule = !0, e.exports.default = e.exports;
            },
            91436: (e)=>{
                "use strict";
                e.exports = function(e, t) {
                    var r = null == e ? null : "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
                    if (null != r) {
                        var n, i, o, a, s = [], u = !0, c = !1;
                        try {
                            if (o = (r = r.call(e)).next, 0 === t) {
                                if (Object(r) !== r) return;
                                u = !1;
                            } else for(; !(u = (n = o.call(r)).done) && (s.push(n.value), s.length !== t); u = !0);
                        } catch (e) {
                            c = !0, i = e;
                        } finally{
                            try {
                                if (!u && null != r.return && (a = r.return(), Object(a) !== a)) return;
                            } finally{
                                if (c) throw i;
                            }
                        }
                        return s;
                    }
                }, e.exports.__esModule = !0, e.exports.default = e.exports;
            },
            82966: (e)=>{
                "use strict";
                e.exports = function() {
                    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                }, e.exports.__esModule = !0, e.exports.default = e.exports;
            },
            22344: (e)=>{
                "use strict";
                e.exports = function() {
                    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                }, e.exports.__esModule = !0, e.exports.default = e.exports;
            },
            34650: (e, t, r)=>{
                "use strict";
                var n = r(3355).default, i = r(58975);
                e.exports = function(e, t) {
                    if (t && ("object" === n(t) || "function" == typeof t)) return t;
                    if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
                    return i(e);
                }, e.exports.__esModule = !0, e.exports.default = e.exports;
            },
            82028: (e, t, r)=>{
                "use strict";
                var n = r(3355).default;
                function i() {
                    e.exports = i = function() {
                        return t;
                    }, e.exports.__esModule = !0, e.exports.default = e.exports;
                    var t = {}, r = Object.prototype, o = r.hasOwnProperty, a = Object.defineProperty || function(e, t, r) {
                        e[t] = r.value;
                    }, s = "function" == typeof Symbol ? Symbol : {}, u = s.iterator || "@@iterator", c = s.asyncIterator || "@@asyncIterator", f = s.toStringTag || "@@toStringTag";
                    function d(e, t, r) {
                        return Object.defineProperty(e, t, {
                            value: r,
                            enumerable: !0,
                            configurable: !0,
                            writable: !0
                        }), e[t];
                    }
                    try {
                        d({}, "");
                    } catch (e) {
                        d = function(e, t, r) {
                            return e[t] = r;
                        };
                    }
                    function l(e, t, r, n) {
                        var i = t && t.prototype instanceof b ? t : b, o = Object.create(i.prototype), s = new O(n || []);
                        return a(o, "_invoke", {
                            value: E(e, r, s)
                        }), o;
                    }
                    function h(e, t, r) {
                        try {
                            return {
                                type: "normal",
                                arg: e.call(t, r)
                            };
                        } catch (e) {
                            return {
                                type: "throw",
                                arg: e
                            };
                        }
                    }
                    t.wrap = l;
                    var p = {};
                    function b() {}
                    function y() {}
                    function v() {}
                    var m = {};
                    d(m, u, function() {
                        return this;
                    });
                    var g = Object.getPrototypeOf, w = g && g(g(P([])));
                    w && w !== r && o.call(w, u) && (m = w);
                    var k = v.prototype = b.prototype = Object.create(m);
                    function _(e) {
                        [
                            "next",
                            "throw",
                            "return"
                        ].forEach(function(t) {
                            d(e, t, function(e) {
                                return this._invoke(t, e);
                            });
                        });
                    }
                    function A(e, t) {
                        function r(i, a, s, u) {
                            var c = h(e[i], e, a);
                            if ("throw" !== c.type) {
                                var f = c.arg, d = f.value;
                                return d && "object" == n(d) && o.call(d, "__await") ? t.resolve(d.__await).then(function(e) {
                                    r("next", e, s, u);
                                }, function(e) {
                                    r("throw", e, s, u);
                                }) : t.resolve(d).then(function(e) {
                                    f.value = e, s(f);
                                }, function(e) {
                                    return r("throw", e, s, u);
                                });
                            }
                            u(c.arg);
                        }
                        var i;
                        a(this, "_invoke", {
                            value: function(e, n) {
                                function o() {
                                    return new t(function(t, i) {
                                        r(e, n, t, i);
                                    });
                                }
                                return i = i ? i.then(o, o) : o();
                            }
                        });
                    }
                    function E(e, t, r) {
                        var n = "suspendedStart";
                        return function(i, o) {
                            if ("executing" === n) throw new Error("Generator is already running");
                            if ("completed" === n) {
                                if ("throw" === i) throw o;
                                return {
                                    value: void 0,
                                    done: !0
                                };
                            }
                            for(r.method = i, r.arg = o;;){
                                var a = r.delegate;
                                if (a) {
                                    var s = S(a, r);
                                    if (s) {
                                        if (s === p) continue;
                                        return s;
                                    }
                                }
                                if ("next" === r.method) r.sent = r._sent = r.arg;
                                else if ("throw" === r.method) {
                                    if ("suspendedStart" === n) throw n = "completed", r.arg;
                                    r.dispatchException(r.arg);
                                } else "return" === r.method && r.abrupt("return", r.arg);
                                n = "executing";
                                var u = h(e, t, r);
                                if ("normal" === u.type) {
                                    if (n = r.done ? "completed" : "suspendedYield", u.arg === p) continue;
                                    return {
                                        value: u.arg,
                                        done: r.done
                                    };
                                }
                                "throw" === u.type && (n = "completed", r.method = "throw", r.arg = u.arg);
                            }
                        };
                    }
                    function S(e, t) {
                        var r = t.method, n = e.iterator[r];
                        if (void 0 === n) return t.delegate = null, "throw" === r && e.iterator.return && (t.method = "return", t.arg = void 0, S(e, t), "throw" === t.method) || "return" !== r && (t.method = "throw", t.arg = new TypeError("The iterator does not provide a '" + r + "' method")), p;
                        var i = h(n, e.iterator, t.arg);
                        if ("throw" === i.type) return t.method = "throw", t.arg = i.arg, t.delegate = null, p;
                        var o = i.arg;
                        return o ? o.done ? (t[e.resultName] = o.value, t.next = e.nextLoc, "return" !== t.method && (t.method = "next", t.arg = void 0), t.delegate = null, p) : o : (t.method = "throw", t.arg = new TypeError("iterator result is not an object"), t.delegate = null, p);
                    }
                    function x(e) {
                        var t = {
                            tryLoc: e[0]
                        };
                        1 in e && (t.catchLoc = e[1]), 2 in e && (t.finallyLoc = e[2], t.afterLoc = e[3]), this.tryEntries.push(t);
                    }
                    function B(e) {
                        var t = e.completion || {};
                        t.type = "normal", delete t.arg, e.completion = t;
                    }
                    function O(e) {
                        this.tryEntries = [
                            {
                                tryLoc: "root"
                            }
                        ], e.forEach(x, this), this.reset(!0);
                    }
                    function P(e) {
                        if (e) {
                            var t = e[u];
                            if (t) return t.call(e);
                            if ("function" == typeof e.next) return e;
                            if (!isNaN(e.length)) {
                                var r = -1, n = function t() {
                                    for(; ++r < e.length;)if (o.call(e, r)) return t.value = e[r], t.done = !1, t;
                                    return t.value = void 0, t.done = !0, t;
                                };
                                return n.next = n;
                            }
                        }
                        return {
                            next: I
                        };
                    }
                    function I() {
                        return {
                            value: void 0,
                            done: !0
                        };
                    }
                    return y.prototype = v, a(k, "constructor", {
                        value: v,
                        configurable: !0
                    }), a(v, "constructor", {
                        value: y,
                        configurable: !0
                    }), y.displayName = d(v, f, "GeneratorFunction"), t.isGeneratorFunction = function(e) {
                        var t = "function" == typeof e && e.constructor;
                        return !!t && (t === y || "GeneratorFunction" === (t.displayName || t.name));
                    }, t.mark = function(e) {
                        return Object.setPrototypeOf ? Object.setPrototypeOf(e, v) : (e.__proto__ = v, d(e, f, "GeneratorFunction")), e.prototype = Object.create(k), e;
                    }, t.awrap = function(e) {
                        return {
                            __await: e
                        };
                    }, _(A.prototype), d(A.prototype, c, function() {
                        return this;
                    }), t.AsyncIterator = A, t.async = function(e, r, n, i, o) {
                        void 0 === o && (o = Promise);
                        var a = new A(l(e, r, n, i), o);
                        return t.isGeneratorFunction(r) ? a : a.next().then(function(e) {
                            return e.done ? e.value : a.next();
                        });
                    }, _(k), d(k, f, "Generator"), d(k, u, function() {
                        return this;
                    }), d(k, "toString", function() {
                        return "[object Generator]";
                    }), t.keys = function(e) {
                        var t = Object(e), r = [];
                        for(var n in t)r.push(n);
                        return r.reverse(), function e() {
                            for(; r.length;){
                                var n = r.pop();
                                if (n in t) return e.value = n, e.done = !1, e;
                            }
                            return e.done = !0, e;
                        };
                    }, t.values = P, O.prototype = {
                        constructor: O,
                        reset: function(e) {
                            if (this.prev = 0, this.next = 0, this.sent = this._sent = void 0, this.done = !1, this.delegate = null, this.method = "next", this.arg = void 0, this.tryEntries.forEach(B), !e) for(var t in this)"t" === t.charAt(0) && o.call(this, t) && !isNaN(+t.slice(1)) && (this[t] = void 0);
                        },
                        stop: function() {
                            this.done = !0;
                            var e = this.tryEntries[0].completion;
                            if ("throw" === e.type) throw e.arg;
                            return this.rval;
                        },
                        dispatchException: function(e) {
                            if (this.done) throw e;
                            var t = this;
                            function r(r, n) {
                                return a.type = "throw", a.arg = e, t.next = r, n && (t.method = "next", t.arg = void 0), !!n;
                            }
                            for(var n = this.tryEntries.length - 1; n >= 0; --n){
                                var i = this.tryEntries[n], a = i.completion;
                                if ("root" === i.tryLoc) return r("end");
                                if (i.tryLoc <= this.prev) {
                                    var s = o.call(i, "catchLoc"), u = o.call(i, "finallyLoc");
                                    if (s && u) {
                                        if (this.prev < i.catchLoc) return r(i.catchLoc, !0);
                                        if (this.prev < i.finallyLoc) return r(i.finallyLoc);
                                    } else if (s) {
                                        if (this.prev < i.catchLoc) return r(i.catchLoc, !0);
                                    } else {
                                        if (!u) throw new Error("try statement without catch or finally");
                                        if (this.prev < i.finallyLoc) return r(i.finallyLoc);
                                    }
                                }
                            }
                        },
                        abrupt: function(e, t) {
                            for(var r = this.tryEntries.length - 1; r >= 0; --r){
                                var n = this.tryEntries[r];
                                if (n.tryLoc <= this.prev && o.call(n, "finallyLoc") && this.prev < n.finallyLoc) {
                                    var i = n;
                                    break;
                                }
                            }
                            i && ("break" === e || "continue" === e) && i.tryLoc <= t && t <= i.finallyLoc && (i = null);
                            var a = i ? i.completion : {};
                            return a.type = e, a.arg = t, i ? (this.method = "next", this.next = i.finallyLoc, p) : this.complete(a);
                        },
                        complete: function(e, t) {
                            if ("throw" === e.type) throw e.arg;
                            return "break" === e.type || "continue" === e.type ? this.next = e.arg : "return" === e.type ? (this.rval = this.arg = e.arg, this.method = "return", this.next = "end") : "normal" === e.type && t && (this.next = t), p;
                        },
                        finish: function(e) {
                            for(var t = this.tryEntries.length - 1; t >= 0; --t){
                                var r = this.tryEntries[t];
                                if (r.finallyLoc === e) return this.complete(r.completion, r.afterLoc), B(r), p;
                            }
                        },
                        catch: function(e) {
                            for(var t = this.tryEntries.length - 1; t >= 0; --t){
                                var r = this.tryEntries[t];
                                if (r.tryLoc === e) {
                                    var n = r.completion;
                                    if ("throw" === n.type) {
                                        var i = n.arg;
                                        B(r);
                                    }
                                    return i;
                                }
                            }
                            throw new Error("illegal catch attempt");
                        },
                        delegateYield: function(e, t, r) {
                            return this.delegate = {
                                iterator: P(e),
                                resultName: t,
                                nextLoc: r
                            }, "next" === this.method && (this.arg = void 0), p;
                        }
                    }, t;
                }
                e.exports = i, e.exports.__esModule = !0, e.exports.default = e.exports;
            },
            38746: (e)=>{
                "use strict";
                function t(r, n) {
                    return e.exports = t = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(e, t) {
                        return e.__proto__ = t, e;
                    }, e.exports.__esModule = !0, e.exports.default = e.exports, t(r, n);
                }
                e.exports = t, e.exports.__esModule = !0, e.exports.default = e.exports;
            },
            74519: (e, t, r)=>{
                "use strict";
                var n = r(12338), i = r(91436), o = r(46906), a = r(82966);
                e.exports = function(e, t) {
                    return n(e) || i(e, t) || o(e, t) || a();
                }, e.exports.__esModule = !0, e.exports.default = e.exports;
            },
            47460: (e, t, r)=>{
                "use strict";
                var n = r(21949);
                e.exports = function(e, t) {
                    for(; !Object.prototype.hasOwnProperty.call(e, t) && null !== (e = n(e)););
                    return e;
                }, e.exports.__esModule = !0, e.exports.default = e.exports;
            },
            93106: (e, t, r)=>{
                "use strict";
                var n = r(77907), i = r(41642), o = r(46906), a = r(22344);
                e.exports = function(e) {
                    return n(e) || i(e) || o(e) || a();
                }, e.exports.__esModule = !0, e.exports.default = e.exports;
            },
            79662: (e, t, r)=>{
                "use strict";
                var n = r(3355).default;
                e.exports = function(e, t) {
                    if ("object" !== n(e) || null === e) return e;
                    var r = e[Symbol.toPrimitive];
                    if (void 0 !== r) {
                        var i = r.call(e, t || "default");
                        if ("object" !== n(i)) return i;
                        throw new TypeError("@@toPrimitive must return a primitive value.");
                    }
                    return ("string" === t ? String : Number)(e);
                }, e.exports.__esModule = !0, e.exports.default = e.exports;
            },
            32310: (e, t, r)=>{
                "use strict";
                var n = r(3355).default, i = r(79662);
                e.exports = function(e) {
                    var t = i(e, "string");
                    return "symbol" === n(t) ? t : String(t);
                }, e.exports.__esModule = !0, e.exports.default = e.exports;
            },
            3355: (e)=>{
                "use strict";
                function t(r) {
                    return e.exports = t = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                        return typeof e;
                    } : function(e) {
                        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
                    }, e.exports.__esModule = !0, e.exports.default = e.exports, t(r);
                }
                e.exports = t, e.exports.__esModule = !0, e.exports.default = e.exports;
            },
            46906: (e, t, r)=>{
                "use strict";
                var n = r(38768);
                e.exports = function(e, t) {
                    if (e) {
                        if ("string" == typeof e) return n(e, t);
                        var r = Object.prototype.toString.call(e).slice(8, -1);
                        return "Object" === r && e.constructor && (r = e.constructor.name), "Map" === r || "Set" === r ? Array.from(e) : "Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? n(e, t) : void 0;
                    }
                }, e.exports.__esModule = !0, e.exports.default = e.exports;
            },
            22940: (e, t, r)=>{
                "use strict";
                var n = r(21949), i = r(38746), o = r(78958), a = r(14727);
                function s(t) {
                    var r = "function" == typeof Map ? new Map : void 0;
                    return e.exports = s = function(e) {
                        if (null === e || !o(e)) return e;
                        if ("function" != typeof e) throw new TypeError("Super expression must either be null or a function");
                        if (void 0 !== r) {
                            if (r.has(e)) return r.get(e);
                            r.set(e, t);
                        }
                        function t() {
                            return a(e, arguments, n(this).constructor);
                        }
                        return t.prototype = Object.create(e.prototype, {
                            constructor: {
                                value: t,
                                enumerable: !1,
                                writable: !0,
                                configurable: !0
                            }
                        }), i(t, e);
                    }, e.exports.__esModule = !0, e.exports.default = e.exports, s(t);
                }
                e.exports = s, e.exports.__esModule = !0, e.exports.default = e.exports;
            },
            82247: (e, t, r)=>{
                "use strict";
                var n = r(28847)(r(3355)), i = r(82028)();
                e.exports = i;
                try {
                    regeneratorRuntime = i;
                } catch (e) {
                    "object" === ("undefined" == typeof globalThis ? "undefined" : (0, n.default)(globalThis)) ? globalThis.regeneratorRuntime = i : Function("r", "regeneratorRuntime = r")(i);
                }
            },
            43604: (e, t, r)=>{
                "use strict";
                var n = [
                    "BigInt64Array",
                    "BigUint64Array",
                    "Float32Array",
                    "Float64Array",
                    "Int16Array",
                    "Int32Array",
                    "Int8Array",
                    "Uint16Array",
                    "Uint32Array",
                    "Uint8Array",
                    "Uint8ClampedArray"
                ], i = "undefined" == typeof globalThis ? r.g : globalThis;
                e.exports = function() {
                    for(var e = [], t = 0; t < n.length; t++)"function" == typeof i[n[t]] && (e[e.length] = n[t]);
                    return e;
                };
            },
            17687: (e)=>{
                "use strict";
                e.exports = JSON.parse('{"name":"goerli","chainId":5,"networkId":5,"defaultHardfork":"istanbul","consensus":{"type":"poa","algorithm":"clique","clique":{"period":15,"epoch":30000}},"comment":"Cross-client PoA test network","url":"https://github.com/goerli/testnet","genesis":{"hash":"0xbf7e331f7f7c1dd2e05159666b3bf8bc7a8a3a9eb1d518969eab529dd9b88c1a","timestamp":"0x5c51a607","gasLimit":10485760,"difficulty":1,"nonce":"0x0000000000000000","extraData":"0x22466c6578692069732061207468696e6722202d204166726900000000000000e0a2bd4258d2768837baa26a28fe71dc079f84c70000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000","stateRoot":"0x5d6cded585e73c4e322c30c2f782a336316f17dd85a4863b9d838d2d4b8b3008"},"hardforks":[{"name":"chainstart","block":0,"forkHash":"0xa3f5ab08"},{"name":"homestead","block":0,"forkHash":"0xa3f5ab08"},{"name":"tangerineWhistle","block":0,"forkHash":"0xa3f5ab08"},{"name":"spuriousDragon","block":0,"forkHash":"0xa3f5ab08"},{"name":"byzantium","block":0,"forkHash":"0xa3f5ab08"},{"name":"constantinople","block":0,"forkHash":"0xa3f5ab08"},{"name":"petersburg","block":0,"forkHash":"0xa3f5ab08"},{"name":"istanbul","block":1561651,"forkHash":"0xc25efa5c"},{"name":"berlin","block":4460644,"forkHash":"0x757a1c47"},{"name":"london","block":5062605,"forkHash":"0xb8c6299d"},{"name":"merge","block":null,"forkHash":null},{"name":"shanghai","block":null,"forkHash":null}],"bootstrapNodes":[{"ip":"51.141.78.53","port":30303,"id":"011f758e6552d105183b1761c5e2dea0111bc20fd5f6422bc7f91e0fabbec9a6595caf6239b37feb773dddd3f87240d99d859431891e4a642cf2a0a9e6cbb98a","location":"","comment":"Upstream bootnode 1"},{"ip":"13.93.54.137","port":30303,"id":"176b9417f511d05b6b2cf3e34b756cf0a7096b3094572a8f6ef4cdcb9d1f9d00683bf0f83347eebdf3b81c3521c2332086d9592802230bf528eaf606a1d9677b","location":"","comment":"Upstream bootnode 2"},{"ip":"94.237.54.114","port":30313,"id":"46add44b9f13965f7b9875ac6b85f016f341012d84f975377573800a863526f4da19ae2c620ec73d11591fa9510e992ecc03ad0751f53cc02f7c7ed6d55c7291","location":"","comment":"Upstream bootnode 3"},{"ip":"18.218.250.66","port":30313,"id":"b5948a2d3e9d486c4d75bf32713221c2bd6cf86463302339299bd227dc2e276cd5a1c7ca4f43a0e9122fe9af884efed563bd2a1fd28661f3b5f5ad7bf1de5949","location":"","comment":"Upstream bootnode 4"},{"ip":"3.11.147.67","port":30303,"id":"a61215641fb8714a373c80edbfa0ea8878243193f57c96eeb44d0bc019ef295abd4e044fd619bfc4c59731a73fb79afe84e9ab6da0c743ceb479cbb6d263fa91","location":"","comment":"Ethereum Foundation bootnode"},{"ip":"51.15.116.226","port":30303,"id":"a869b02cec167211fb4815a82941db2e7ed2936fd90e78619c53eb17753fcf0207463e3419c264e2a1dd8786de0df7e68cf99571ab8aeb7c4e51367ef186b1dd","location":"","comment":"Goerli Initiative bootnode"},{"ip":"51.15.119.157","port":30303,"id":"807b37ee4816ecf407e9112224494b74dd5933625f655962d892f2f0f02d7fbbb3e2a94cf87a96609526f30c998fd71e93e2f53015c558ffc8b03eceaf30ee33","location":"","comment":"Goerli Initiative bootnode"},{"ip":"51.15.119.157","port":40303,"id":"a59e33ccd2b3e52d578f1fbd70c6f9babda2650f0760d6ff3b37742fdcdfdb3defba5d56d315b40c46b70198c7621e63ffa3f987389c7118634b0fefbbdfa7fd","location":"","comment":"Goerli Initiative bootnode"}],"dnsNetworks":["enrtree://AKA3AM6LPBYEUDMVNU3BSVQJ5AD45Y7YPOHJLEF6W26QOE4VTUDPE@all.goerli.ethdisco.net"]}');
            },
            37098: (e)=>{
                "use strict";
                e.exports = JSON.parse('{"name":"kovan","chainId":42,"networkId":42,"defaultHardfork":"istanbul","consensus":{"type":"poa","algorithm":"aura","aura":{}},"comment":"Parity PoA test network","url":"https://kovan-testnet.github.io/website/","genesis":{"hash":"0xa3c565fc15c7478862d50ccd6561e3c06b24cc509bf388941c25ea985ce32cb9","timestamp":null,"gasLimit":6000000,"difficulty":131072,"nonce":"0x0000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000","extraData":"0x","stateRoot":"0x2480155b48a1cea17d67dbfdfaafe821c1d19cdd478c5358e8ec56dec24502b2"},"hardforks":[{"name":"chainstart","block":0,"forkHash":"0x010ffe56"},{"name":"homestead","block":0,"forkHash":"0x010ffe56"},{"name":"tangerineWhistle","block":0,"forkHash":"0x010ffe56"},{"name":"spuriousDragon","block":0,"forkHash":"0x010ffe56"},{"name":"byzantium","block":5067000,"forkHash":"0x7f83c620"},{"name":"constantinople","block":9200000,"forkHash":"0xa94e3dc4"},{"name":"petersburg","block":10255201,"forkHash":"0x186874aa"},{"name":"istanbul","block":14111141,"forkHash":"0x7f6599a6"},{"name":"berlin","block":24770900,"forkHash":"0x1a0f10d9"},{"name":"london","block":26741100,"forkHash":"0x1ed20b71"},{"name":"merge","block":null,"forkHash":null},{"name":"shanghai","block":null,"forkHash":null}],"bootstrapNodes":[{"ip":"116.203.116.241","port":30303,"id":"16898006ba2cd4fa8bf9a3dfe32684c178fa861df144bfc21fe800dc4838a03e342056951fa9fd533dcb0be1219e306106442ff2cf1f7e9f8faa5f2fc1a3aa45","location":"","comment":"1"},{"ip":"3.217.96.11","port":30303,"id":"2909846f78c37510cc0e306f185323b83bb2209e5ff4fdd279d93c60e3f365e3c6e62ad1d2133ff11f9fd6d23ad9c3dad73bb974d53a22f7d1ac5b7dea79d0b0","location":"","comment":"2"},{"ip":"108.61.170.124","port":30303,"id":"740e1c8ea64e71762c71a463a04e2046070a0c9394fcab5891d41301dc473c0cff00ebab5a9bc87fbcb610ab98ac18225ff897bc8b7b38def5975d5ceb0a7d7c","location":"","comment":"3"},{"ip":"157.230.31.163","port":30303,"id":"2909846f78c37510cc0e306f185323b83bb2209e5ff4fdd279d93c60e3f365e3c6e62ad1d2133ff11f9fd6d23ad9c3dad73bb974d53a22f7d1ac5b7dea79d0b0","location":"","comment":"4"}]}');
            },
            87295: (e)=>{
                "use strict";
                e.exports = JSON.parse('{"name":"mainnet","chainId":1,"networkId":1,"defaultHardfork":"istanbul","consensus":{"type":"pow","algorithm":"ethash","ethash":{}},"comment":"The Ethereum main chain","url":"https://ethstats.net/","genesis":{"hash":"0xd4e56740f876aef8c010b86a40d5f56745a118d0906a34e69aec8c0db1cb8fa3","timestamp":null,"gasLimit":5000,"difficulty":17179869184,"nonce":"0x0000000000000042","extraData":"0x11bbe8db4e347b4e8c937c1c8370e4b5ed33adb3db69cbdb7a38e1e50b1b82fa","stateRoot":"0xd7f8974fb5ac78d9ac099b9ad5018bedc2ce0a72dad1827a1709da30580f0544"},"hardforks":[{"name":"chainstart","block":0,"forkHash":"0xfc64ec04"},{"name":"homestead","block":1150000,"forkHash":"0x97c2c34c"},{"name":"dao","block":1920000,"forkHash":"0x91d1f948"},{"name":"tangerineWhistle","block":2463000,"forkHash":"0x7a64da13"},{"name":"spuriousDragon","block":2675000,"forkHash":"0x3edd5b10"},{"name":"byzantium","block":4370000,"forkHash":"0xa00bc324"},{"name":"constantinople","block":7280000,"forkHash":"0x668db0af"},{"name":"petersburg","block":7280000,"forkHash":"0x668db0af"},{"name":"istanbul","block":9069000,"forkHash":"0x879d6e30"},{"name":"muirGlacier","block":9200000,"forkHash":"0xe029e991"},{"name":"berlin","block":12244000,"forkHash":"0x0eb440f6"},{"name":"london","block":12965000,"forkHash":"0xb715077d"},{"name":"arrowGlacier","block":13773000,"forkHash":"0x20c327fc"},{"name":"grayGlacier","block":15050000,"forkHash":"0xf0afd0e3"},{"name":"mergeForkIdTransition","block":null,"forkHash":null},{"name":"merge","block":null,"forkHash":null},{"name":"shanghai","block":null,"forkHash":null}],"bootstrapNodes":[{"ip":"18.138.108.67","port":30303,"id":"d860a01f9722d78051619d1e2351aba3f43f943f6f00718d1b9baa4101932a1f5011f16bb2b1bb35db20d6fe28fa0bf09636d26a87d31de9ec6203eeedb1f666","location":"ap-southeast-1-001","comment":"bootnode-aws-ap-southeast-1-001"},{"ip":"3.209.45.79","port":30303,"id":"22a8232c3abc76a16ae9d6c3b164f98775fe226f0917b0ca871128a74a8e9630b458460865bab457221f1d448dd9791d24c4e5d88786180ac185df813a68d4de","location":"us-east-1-001","comment":"bootnode-aws-us-east-1-001"},{"ip":"34.255.23.113","port":30303,"id":"ca6de62fce278f96aea6ec5a2daadb877e51651247cb96ee310a318def462913b653963c155a0ef6c7d50048bba6e6cea881130857413d9f50a621546b590758","location":"eu-west-1-001","comment":"bootnode-aws-eu-west-1-001"},{"ip":"35.158.244.151","port":30303,"id":"279944d8dcd428dffaa7436f25ca0ca43ae19e7bcf94a8fb7d1641651f92d121e972ac2e8f381414b80cc8e5555811c2ec6e1a99bb009b3f53c4c69923e11bd8","location":"eu-central-1-001","comment":"bootnode-aws-eu-central-1-001"},{"ip":"52.187.207.27","port":30303,"id":"8499da03c47d637b20eee24eec3c356c9a2e6148d6fe25ca195c7949ab8ec2c03e3556126b0d7ed644675e78c4318b08691b7b57de10e5f0d40d05b09238fa0a","location":"australiaeast-001","comment":"bootnode-azure-australiaeast-001"},{"ip":"191.234.162.198","port":30303,"id":"103858bdb88756c71f15e9b5e09b56dc1be52f0a5021d46301dbbfb7e130029cc9d0d6f73f693bc29b665770fff7da4d34f3c6379fe12721b5d7a0bcb5ca1fc1","location":"brazilsouth-001","comment":"bootnode-azure-brazilsouth-001"},{"ip":"52.231.165.108","port":30303,"id":"715171f50508aba88aecd1250af392a45a330af91d7b90701c436b618c86aaa1589c9184561907bebbb56439b8f8787bc01f49a7c77276c58c1b09822d75e8e8","location":"koreasouth-001","comment":"bootnode-azure-koreasouth-001"},{"ip":"104.42.217.25","port":30303,"id":"5d6d7cd20d6da4bb83a1d28cadb5d409b64edf314c0335df658c1a54e32c7c4a7ab7823d57c39b6a757556e68ff1df17c748b698544a55cb488b52479a92b60f","location":"westus-001","comment":"bootnode-azure-westus-001"}],"dnsNetworks":["enrtree://AKA3AM6LPBYEUDMVNU3BSVQJ5AD45Y7YPOHJLEF6W26QOE4VTUDPE@all.mainnet.ethdisco.net"]}');
            },
            40439: (e)=>{
                "use strict";
                e.exports = JSON.parse('{"name":"rinkeby","chainId":4,"networkId":4,"defaultHardfork":"istanbul","consensus":{"type":"poa","algorithm":"clique","clique":{"period":15,"epoch":30000}},"comment":"PoA test network","url":"https://www.rinkeby.io","genesis":{"hash":"0x6341fd3daf94b748c72ced5a5b26028f2474f5f00d824504e4fa37a75767e177","timestamp":"0x58ee40ba","gasLimit":4700000,"difficulty":1,"nonce":"0x0000000000000000","extraData":"0x52657370656374206d7920617574686f7269746168207e452e436172746d616e42eb768f2244c8811c63729a21a3569731535f067ffc57839b00206d1ad20c69a1981b489f772031b279182d99e65703f0076e4812653aab85fca0f00000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000","stateRoot":"0x53580584816f617295ea26c0e17641e0120cab2f0a8ffb53a866fd53aa8e8c2d"},"hardforks":[{"name":"chainstart","block":0,"forkHash":"0x3b8e0691"},{"name":"homestead","block":1,"forkHash":"0x60949295"},{"name":"tangerineWhistle","block":2,"forkHash":"0x8bde40dd"},{"name":"spuriousDragon","block":3,"forkHash":"0xcb3a64bb"},{"name":"byzantium","block":1035301,"forkHash":"0x8d748b57"},{"name":"constantinople","block":3660663,"forkHash":"0xe49cab14"},{"name":"petersburg","block":4321234,"forkHash":"0xafec6b27"},{"name":"istanbul","block":5435345,"forkHash":"0xcbdb8838"},{"name":"berlin","block":8290928,"forkHash":"0x6910c8bd"},{"name":"london","block":8897988,"forkHash":"0x8e29f2f3"},{"name":"merge","block":null,"forkHash":null},{"name":"shanghai","block":null,"forkHash":null}],"bootstrapNodes":[{"ip":"52.169.42.101","port":30303,"id":"a24ac7c5484ef4ed0c5eb2d36620ba4e4aa13b8c84684e1b4aab0cebea2ae45cb4d375b77eab56516d34bfbd3c1a833fc51296ff084b770b94fb9028c4d25ccf","location":"","comment":"IE"},{"ip":"52.3.158.184","port":30303,"id":"343149e4feefa15d882d9fe4ac7d88f885bd05ebb735e547f12e12080a9fa07c8014ca6fd7f373123488102fe5e34111f8509cf0b7de3f5b44339c9f25e87cb8","location":"","comment":"INFURA"},{"ip":"159.89.28.211","port":30303,"id":"b6b28890b006743680c52e64e0d16db57f28124885595fa03a562be1d2bf0f3a1da297d56b13da25fb992888fd556d4c1a27b1f39d531bde7de1921c90061cc6","location":"","comment":"AKASHA"}],"dnsNetworks":["enrtree://AKA3AM6LPBYEUDMVNU3BSVQJ5AD45Y7YPOHJLEF6W26QOE4VTUDPE@all.rinkeby.ethdisco.net"]}');
            },
            31227: (e)=>{
                "use strict";
                e.exports = JSON.parse('{"name":"ropsten","chainId":3,"networkId":3,"defaultHardfork":"istanbul","consensus":{"type":"pow","algorithm":"ethash","ethash":{}},"comment":"PoW test network","url":"https://github.com/ethereum/ropsten","genesis":{"hash":"0x41941023680923e0fe4d74a34bdac8141f2540e3ae90623718e47d66d1ca4a2d","timestamp":null,"gasLimit":16777216,"difficulty":1048576,"nonce":"0x0000000000000042","extraData":"0x3535353535353535353535353535353535353535353535353535353535353535","stateRoot":"0x217b0bbcfb72e2d57e28f33cb361b9983513177755dc3f33ce3e7022ed62b77b"},"hardforks":[{"name":"chainstart","block":0,"forkHash":"0x30c7ddbc"},{"name":"homestead","block":0,"forkHash":"0x30c7ddbc"},{"name":"tangerineWhistle","block":0,"forkHash":"0x30c7ddbc"},{"name":"spuriousDragon","block":10,"forkHash":"0x63760190"},{"name":"byzantium","block":1700000,"forkHash":"0x3ea159c7"},{"name":"constantinople","block":4230000,"forkHash":"0x97b544f3"},{"name":"petersburg","block":4939394,"forkHash":"0xd6e2149b"},{"name":"istanbul","block":6485846,"forkHash":"0x4bc66396"},{"name":"muirGlacier","block":7117117,"forkHash":"0x6727ef90"},{"name":"berlin","block":9812189,"forkHash":"0xa157d377"},{"name":"london","block":10499401,"forkHash":"0x7119b6b3"},{"name":"merge","block":null,"forkHash":null},{"name":"shanghai","block":null,"forkHash":null}],"bootstrapNodes":[{"ip":"52.176.7.10","port":30303,"id":"30b7ab30a01c124a6cceca36863ece12c4f5fa68e3ba9b0b51407ccc002eeed3b3102d20a88f1c1d3c3154e2449317b8ef95090e77b312d5cc39354f86d5d606","location":"","comment":"US-Azure geth"},{"ip":"52.176.100.77","port":30303,"id":"865a63255b3bb68023b6bffd5095118fcc13e79dcf014fe4e47e065c350c7cc72af2e53eff895f11ba1bbb6a2b33271c1116ee870f266618eadfc2e78aa7349c","location":"","comment":"US-Azure parity"},{"ip":"52.232.243.152","port":30303,"id":"6332792c4a00e3e4ee0926ed89e0d27ef985424d97b6a45bf0f23e51f0dcb5e66b875777506458aea7af6f9e4ffb69f43f3778ee73c81ed9d34c51c4b16b0b0f","location":"","comment":"Parity"},{"ip":"192.81.208.223","port":30303,"id":"94c15d1b9e2fe7ce56e458b9a3b672ef11894ddedd0c6f247e0f1d3487f52b66208fb4aeb8179fce6e3a749ea93ed147c37976d67af557508d199d9594c35f09","location":"","comment":"@gpip"}],"dnsNetworks":["enrtree://AKA3AM6LPBYEUDMVNU3BSVQJ5AD45Y7YPOHJLEF6W26QOE4VTUDPE@all.ropsten.ethdisco.net"]}');
            },
            49422: (e)=>{
                "use strict";
                e.exports = JSON.parse('{"name":"sepolia","chainId":11155111,"networkId":11155111,"defaultHardfork":"istanbul","consensus":{"type":"pow","algorithm":"ethash","ethash":{}},"comment":"PoW test network to replace Ropsten","url":"https://github.com/ethereum/go-ethereum/pull/23730","genesis":{"hash":"0x25a5cc106eea7138acab33231d7160d69cb777ee0c2c553fcddf5138993e6dd9","timestamp":"0x6159af19","gasLimit":30000000,"difficulty":131072,"nonce":"0x0000000000000000","extraData":"0x5365706f6c69612c20417468656e732c204174746963612c2047726565636521","stateRoot":"0x5eb6e371a698b8d68f665192350ffcecbbbf322916f4b51bd79bb6887da3f494"},"hardforks":[{"name":"chainstart","block":0,"forkHash":"0xfe3366e7"},{"name":"homestead","block":0,"forkHash":"0xfe3366e7"},{"name":"tangerineWhistle","block":0,"forkHash":"0xfe3366e7"},{"name":"spuriousDragon","block":0,"forkHash":"0xfe3366e7"},{"name":"byzantium","block":0,"forkHash":"0xfe3366e7"},{"name":"constantinople","block":0,"forkHash":"0xfe3366e7"},{"name":"petersburg","block":0,"forkHash":"0xfe3366e7"},{"name":"istanbul","block":0,"forkHash":"0xfe3366e7"},{"name":"muirGlacier","block":0,"forkHash":"0xfe3366e7"},{"name":"berlin","block":0,"forkHash":"0xfe3366e7"},{"name":"london","block":0,"forkHash":"0xfe3366e7"},{"name":"merge","block":null,"forkHash":null},{"name":"shanghai","block":null,"forkHash":null}],"bootstrapNodes":[{"ip":"18.168.182.86","port":30303,"id":"9246d00bc8fd1742e5ad2428b80fc4dc45d786283e05ef6edbd9002cbc335d40998444732fbe921cb88e1d2c73d1b1de53bae6a2237996e9bfe14f871baf7066","location":"","comment":"geth"},{"ip":"52.14.151.177","port":30303,"id":"ec66ddcf1a974950bd4c782789a7e04f8aa7110a72569b6e65fcd51e937e74eed303b1ea734e4d19cfaec9fbff9b6ee65bf31dcb50ba79acce9dd63a6aca61c7","location":"","comment":"besu"}],"dnsNetworks":[]}');
            },
            96561: (e)=>{
                "use strict";
                e.exports = JSON.parse('{"name":"EIP-1153","number":1153,"comment":"Transient Storage","url":"https://eips.ethereum.org/EIPS/eip-1153","status":"Review","minimumHardfork":"chainstart","requiredEIPs":[],"gasConfig":{},"gasPrices":{"tstore":{"v":100,"d":"Base fee of the TSTORE opcode"},"tload":{"v":100,"d":"Base fee of the TLOAD opcode"}},"vm":{},"pow":{}}');
            },
            77523: (e)=>{
                "use strict";
                e.exports = JSON.parse('{"name":"EIP-1559","number":1559,"comment":"Fee market change for ETH 1.0 chain","url":"https://eips.ethereum.org/EIPS/eip-1559","status":"Final","minimumHardfork":"berlin","requiredEIPs":[2930],"gasConfig":{"baseFeeMaxChangeDenominator":{"v":8,"d":"Maximum base fee change denominator"},"elasticityMultiplier":{"v":2,"d":"Maximum block gas target elasticity"},"initialBaseFee":{"v":1000000000,"d":"Initial base fee on first EIP1559 block"}},"gasPrices":{},"vm":{},"pow":{}}');
            },
            83339: (e)=>{
                "use strict";
                e.exports = JSON.parse('{"name":"EIP-2315","number":2315,"comment":"Simple subroutines for the EVM","url":"https://eips.ethereum.org/EIPS/eip-2315","status":"Draft","minimumHardfork":"istanbul","gasConfig":{},"gasPrices":{"beginsub":{"v":2,"d":"Base fee of the BEGINSUB opcode"},"returnsub":{"v":5,"d":"Base fee of the RETURNSUB opcode"},"jumpsub":{"v":10,"d":"Base fee of the JUMPSUB opcode"}},"vm":{},"pow":{}}');
            },
            26769: (e)=>{
                "use strict";
                e.exports = JSON.parse('{"name":"EIP-2537","number":2537,"comment":"BLS12-381 precompiles","url":"https://eips.ethereum.org/EIPS/eip-2537","status":"Draft","minimumHardfork":"chainstart","gasConfig":{},"gasPrices":{"Bls12381G1AddGas":{"v":600,"d":"Gas cost of a single BLS12-381 G1 addition precompile-call"},"Bls12381G1MulGas":{"v":12000,"d":"Gas cost of a single BLS12-381 G1 multiplication precompile-call"},"Bls12381G2AddGas":{"v":4500,"d":"Gas cost of a single BLS12-381 G2 addition precompile-call"},"Bls12381G2MulGas":{"v":55000,"d":"Gas cost of a single BLS12-381 G2 multiplication precompile-call"},"Bls12381PairingBaseGas":{"v":115000,"d":"Base gas cost of BLS12-381 pairing check"},"Bls12381PairingPerPairGas":{"v":23000,"d":"Per-pair gas cost of BLS12-381 pairing check"},"Bls12381MapG1Gas":{"v":5500,"d":"Gas cost of BLS12-381 map field element to G1"},"Bls12381MapG2Gas":{"v":110000,"d":"Gas cost of BLS12-381 map field element to G2"},"Bls12381MultiExpGasDiscount":{"v":[[1,1200],[2,888],[3,764],[4,641],[5,594],[6,547],[7,500],[8,453],[9,438],[10,423],[11,408],[12,394],[13,379],[14,364],[15,349],[16,334],[17,330],[18,326],[19,322],[20,318],[21,314],[22,310],[23,306],[24,302],[25,298],[26,294],[27,289],[28,285],[29,281],[30,277],[31,273],[32,269],[33,268],[34,266],[35,265],[36,263],[37,262],[38,260],[39,259],[40,257],[41,256],[42,254],[43,253],[44,251],[45,250],[46,248],[47,247],[48,245],[49,244],[50,242],[51,241],[52,239],[53,238],[54,236],[55,235],[56,233],[57,232],[58,231],[59,229],[60,228],[61,226],[62,225],[63,223],[64,222],[65,221],[66,220],[67,219],[68,219],[69,218],[70,217],[71,216],[72,216],[73,215],[74,214],[75,213],[76,213],[77,212],[78,211],[79,211],[80,210],[81,209],[82,208],[83,208],[84,207],[85,206],[86,205],[87,205],[88,204],[89,203],[90,202],[91,202],[92,201],[93,200],[94,199],[95,199],[96,198],[97,197],[98,196],[99,196],[100,195],[101,194],[102,193],[103,193],[104,192],[105,191],[106,191],[107,190],[108,189],[109,188],[110,188],[111,187],[112,186],[113,185],[114,185],[115,184],[116,183],[117,182],[118,182],[119,181],[120,180],[121,179],[122,179],[123,178],[124,177],[125,176],[126,176],[127,175],[128,174]],"d":"Discount gas costs of calls to the MultiExp precompiles with `k` (point, scalar) pair"}},"vm":{},"pow":{}}');
            },
            17897: (e)=>{
                "use strict";
                e.exports = JSON.parse('{"name":"EIP-2565","number":2565,"comment":"ModExp gas cost","url":"https://eips.ethereum.org/EIPS/eip-2565","status":"Final","minimumHardfork":"byzantium","gasConfig":{},"gasPrices":{"modexpGquaddivisor":{"v":3,"d":"Gquaddivisor from modexp precompile for gas calculation"}},"vm":{},"pow":{}}');
            },
            62170: (e)=>{
                "use strict";
                e.exports = JSON.parse('{"name":"EIP-2718","comment":"Typed Transaction Envelope","url":"https://eips.ethereum.org/EIPS/eip-2718","status":"Final","minimumHardfork":"chainstart","gasConfig":{},"gasPrices":{},"vm":{},"pow":{}}');
            },
            88436: (e)=>{
                "use strict";
                e.exports = JSON.parse('{"name":"EIP-2929","comment":"Gas cost increases for state access opcodes","url":"https://eips.ethereum.org/EIPS/eip-2929","status":"Final","minimumHardfork":"chainstart","gasConfig":{},"gasPrices":{"coldsload":{"v":2100,"d":"Gas cost of the first read of storage from a given location (per transaction)"},"coldaccountaccess":{"v":2600,"d":"Gas cost of the first read of a given address (per transaction)"},"warmstorageread":{"v":100,"d":"Gas cost of reading storage locations which have already loaded \'cold\'"},"sstoreCleanGasEIP2200":{"v":2900,"d":"Once per SSTORE operation from clean non-zero to something else"},"sstoreNoopGasEIP2200":{"v":100,"d":"Once per SSTORE operation if the value doesn\'t change"},"sstoreDirtyGasEIP2200":{"v":100,"d":"Once per SSTORE operation if a dirty value is changed"},"sstoreInitRefundEIP2200":{"v":19900,"d":"Once per SSTORE operation for resetting to the original zero value"},"sstoreCleanRefundEIP2200":{"v":4900,"d":"Once per SSTORE operation for resetting to the original non-zero value"},"call":{"v":0,"d":"Base fee of the CALL opcode"},"callcode":{"v":0,"d":"Base fee of the CALLCODE opcode"},"delegatecall":{"v":0,"d":"Base fee of the DELEGATECALL opcode"},"staticcall":{"v":0,"d":"Base fee of the STATICCALL opcode"},"balance":{"v":0,"d":"Base fee of the BALANCE opcode"},"extcodesize":{"v":0,"d":"Base fee of the EXTCODESIZE opcode"},"extcodecopy":{"v":0,"d":"Base fee of the EXTCODECOPY opcode"},"extcodehash":{"v":0,"d":"Base fee of the EXTCODEHASH opcode"},"sload":{"v":0,"d":"Base fee of the SLOAD opcode"},"sstore":{"v":0,"d":"Base fee of the SSTORE opcode"}},"vm":{},"pow":{}}');
            },
            96213: (e)=>{
                "use strict";
                e.exports = JSON.parse('{"name":"EIP-2930","comment":"Optional access lists","url":"https://eips.ethereum.org/EIPS/eip-2930","status":"Final","minimumHardfork":"istanbul","requiredEIPs":[2718,2929],"gasConfig":{},"gasPrices":{"accessListStorageKeyCost":{"v":1900,"d":"Gas cost per storage key in an Access List transaction"},"accessListAddressCost":{"v":2400,"d":"Gas cost per storage key in an Access List transaction"}},"vm":{},"pow":{}}');
            },
            25491: (e)=>{
                "use strict";
                e.exports = JSON.parse('{"name":"EIP-3198","number":3198,"comment":"BASEFEE opcode","url":"https://eips.ethereum.org/EIPS/eip-3198","status":"Final","minimumHardfork":"london","gasConfig":{},"gasPrices":{"basefee":{"v":2,"d":"Gas cost of the BASEFEE opcode"}},"vm":{},"pow":{}}');
            },
            20070: (e)=>{
                "use strict";
                e.exports = JSON.parse('{"name":"EIP-3529","comment":"Reduction in refunds","url":"https://eips.ethereum.org/EIPS/eip-3529","status":"Final","minimumHardfork":"berlin","requiredEIPs":[2929],"gasConfig":{"maxRefundQuotient":{"v":5,"d":"Maximum refund quotient; max tx refund is min(tx.gasUsed/maxRefundQuotient, tx.gasRefund)"}},"gasPrices":{"selfdestructRefund":{"v":0,"d":"Refunded following a selfdestruct operation"},"sstoreClearRefundEIP2200":{"v":4800,"d":"Once per SSTORE operation for clearing an originally existing storage slot"}},"vm":{},"pow":{}}');
            },
            52256: (e)=>{
                "use strict";
                e.exports = JSON.parse('{"name":"EIP-3540","number":3540,"comment":"EVM Object Format (EOF) v1","url":"https://eips.ethereum.org/EIPS/eip-3540","status":"Review","minimumHardfork":"london","requiredEIPs":[3541],"gasConfig":{},"gasPrices":{},"vm":{},"pow":{}}');
            },
            21871: (e)=>{
                "use strict";
                e.exports = JSON.parse('{"name":"EIP-3541","comment":"Reject new contracts starting with the 0xEF byte","url":"https://eips.ethereum.org/EIPS/eip-3541","status":"Final","minimumHardfork":"berlin","requiredEIPs":[],"gasConfig":{},"gasPrices":{},"vm":{},"pow":{}}');
            },
            47225: (e)=>{
                "use strict";
                e.exports = JSON.parse('{"name":"EIP-3554","comment":"Reduction in refunds","url":"Difficulty Bomb Delay to December 1st 2021","status":"Final","minimumHardfork":"muirGlacier","requiredEIPs":[],"gasConfig":{},"gasPrices":{},"vm":{},"pow":{"difficultyBombDelay":{"v":9500000,"d":"the amount of blocks to delay the difficulty bomb with"}}}');
            },
            3968: (e)=>{
                "use strict";
                e.exports = JSON.parse('{"name":"EIP-3607","number":3607,"comment":"Reject transactions from senders with deployed code","url":"https://eips.ethereum.org/EIPS/eip-3607","status":"Final","minimumHardfork":"chainstart","requiredEIPs":[],"gasConfig":{},"gasPrices":{},"vm":{},"pow":{}}');
            },
            29496: (e)=>{
                "use strict";
                e.exports = JSON.parse('{"name":"EIP-3651","number":3198,"comment":"Warm COINBASE","url":"https://eips.ethereum.org/EIPS/eip-3651","status":"Review","minimumHardfork":"london","requiredEIPs":[2929],"gasConfig":{},"gasPrices":{},"vm":{},"pow":{}}');
            },
            74290: (e)=>{
                "use strict";
                e.exports = JSON.parse('{"name":"EIP-3670","number":3670,"comment":"EOF - Code Validation","url":"https://eips.ethereum.org/EIPS/eip-3670","status":"Review","minimumHardfork":"london","requiredEIPs":[3540],"gasConfig":{},"gasPrices":{},"vm":{},"pow":{}}');
            },
            98571: (e)=>{
                "use strict";
                e.exports = JSON.parse('{"name":"EIP-3675","number":3675,"comment":"Upgrade consensus to Proof-of-Stake","url":"https://eips.ethereum.org/EIPS/eip-3675","status":"Review","minimumHardfork":"london","requiredEIPs":[],"gasConfig":{},"gasPrices":{},"vm":{},"pow":{}}');
            },
            64551: (e)=>{
                "use strict";
                e.exports = JSON.parse('{"name":"EIP-3855","number":3855,"comment":"PUSH0 instruction","url":"https://eips.ethereum.org/EIPS/eip-3855","status":"Review","minimumHardfork":"chainstart","requiredEIPs":[],"gasConfig":{},"gasPrices":{"push0":{"v":2,"d":"Base fee of the PUSH0 opcode"}},"vm":{},"pow":{}}');
            },
            94300: (e)=>{
                "use strict";
                e.exports = JSON.parse('{"name":"EIP-3860","number":3860,"comment":"Limit and meter initcode","url":"https://eips.ethereum.org/EIPS/eip-3860","status":"Review","minimumHardfork":"spuriousDragon","requiredEIPs":[],"gasConfig":{},"gasPrices":{"initCodeWordCost":{"v":2,"d":"Gas to pay for each word (32 bytes) of initcode when creating a contract"}},"vm":{"maxInitCodeSize":{"v":49152,"d":"Maximum length of initialization code when creating a contract"}},"pow":{}}');
            },
            74818: (e)=>{
                "use strict";
                e.exports = JSON.parse('{"name":"EIP-4345","number":4345,"comment":"Difficulty Bomb Delay to June 2022","url":"https://eips.ethereum.org/EIPS/eip-4345","status":"Final","minimumHardfork":"london","gasConfig":{},"gasPrices":{},"vm":{},"pow":{"difficultyBombDelay":{"v":10700000,"d":"the amount of blocks to delay the difficulty bomb with"}}}');
            },
            68372: (e)=>{
                "use strict";
                e.exports = JSON.parse('{"name":"EIP-4399","number":4399,"comment":"Supplant DIFFICULTY opcode with PREVRANDAO","url":"https://eips.ethereum.org/EIPS/eip-4399","status":"Review","minimumHardfork":"london","requiredEIPs":[],"gasConfig":{},"gasPrices":{},"vm":{},"pow":{}}');
            },
            4759: (e)=>{
                "use strict";
                e.exports = JSON.parse('{"name":"EIP-5133","number":5133,"comment":"Delaying Difficulty Bomb to mid-September 2022","url":"https://eips.ethereum.org/EIPS/eip-5133","status":"Draft","minimumHardfork":"grayGlacier","gasConfig":{},"gasPrices":{},"vm":{},"pow":{"difficultyBombDelay":{"v":11400000,"d":"the amount of blocks to delay the difficulty bomb with"}}}');
            },
            51971: (e)=>{
                "use strict";
                e.exports = JSON.parse('{"name":"arrowGlacier","comment":"HF to delay the difficulty bomb","url":"https://github.com/ethereum/execution-specs/blob/master/network-upgrades/mainnet-upgrades/arrow-glacier.md","status":"Final","eips":[4345],"gasConfig":{},"gasPrices":{},"vm":{},"pow":{}}');
            },
            20015: (e)=>{
                "use strict";
                e.exports = JSON.parse('{"name":"berlin","comment":"HF targeted for July 2020 following the Muir Glacier HF","url":"https://eips.ethereum.org/EIPS/eip-2070","status":"Final","eips":[2565,2929,2718,2930]}');
            },
            26985: (e)=>{
                "use strict";
                e.exports = JSON.parse('{"name":"byzantium","comment":"Hardfork with new precompiles, instructions and other protocol changes","url":"https://eips.ethereum.org/EIPS/eip-609","status":"Final","gasConfig":{},"gasPrices":{"modexpGquaddivisor":{"v":20,"d":"Gquaddivisor from modexp precompile for gas calculation"},"ecAdd":{"v":500,"d":"Gas costs for curve addition precompile"},"ecMul":{"v":40000,"d":"Gas costs for curve multiplication precompile"},"ecPairing":{"v":100000,"d":"Base gas costs for curve pairing precompile"},"ecPairingWord":{"v":80000,"d":"Gas costs regarding curve pairing precompile input length"},"revert":{"v":0,"d":"Base fee of the REVERT opcode"},"staticcall":{"v":700,"d":"Base fee of the STATICCALL opcode"},"returndatasize":{"v":2,"d":"Base fee of the RETURNDATASIZE opcode"},"returndatacopy":{"v":3,"d":"Base fee of the RETURNDATACOPY opcode"}},"vm":{},"pow":{"minerReward":{"v":"3000000000000000000","d":"the amount a miner get rewarded for mining a block"},"difficultyBombDelay":{"v":3000000,"d":"the amount of blocks to delay the difficulty bomb with"}}}');
            },
            60114: (e)=>{
                "use strict";
                e.exports = JSON.parse('{"name":"chainstart","comment":"Start of the Ethereum main chain","url":"","status":"","gasConfig":{"minGasLimit":{"v":5000,"d":"Minimum the gas limit may ever be"},"gasLimitBoundDivisor":{"v":1024,"d":"The bound divisor of the gas limit, used in update calculations"},"maxRefundQuotient":{"v":2,"d":"Maximum refund quotient; max tx refund is min(tx.gasUsed/maxRefundQuotient, tx.gasRefund)"}},"gasPrices":{"base":{"v":2,"d":"Gas base cost, used e.g. for ChainID opcode (Istanbul)"},"tierStep":{"v":[0,2,3,5,8,10,20],"d":"Once per operation, for a selection of them"},"exp":{"v":10,"d":"Base fee of the EXP opcode"},"expByte":{"v":10,"d":"Times ceil(log256(exponent)) for the EXP instruction"},"sha3":{"v":30,"d":"Base fee of the SHA3 opcode"},"sha3Word":{"v":6,"d":"Once per word of the SHA3 operation\'s data"},"sload":{"v":50,"d":"Base fee of the SLOAD opcode"},"sstoreSet":{"v":20000,"d":"Once per SSTORE operation if the zeroness changes from zero"},"sstoreReset":{"v":5000,"d":"Once per SSTORE operation if the zeroness does not change from zero"},"sstoreRefund":{"v":15000,"d":"Once per SSTORE operation if the zeroness changes to zero"},"jumpdest":{"v":1,"d":"Base fee of the JUMPDEST opcode"},"log":{"v":375,"d":"Base fee of the LOG opcode"},"logData":{"v":8,"d":"Per byte in a LOG* operation\'s data"},"logTopic":{"v":375,"d":"Multiplied by the * of the LOG*, per LOG transaction. e.g. LOG0 incurs 0 * c_txLogTopicGas, LOG4 incurs 4 * c_txLogTopicGas"},"create":{"v":32000,"d":"Base fee of the CREATE opcode"},"call":{"v":40,"d":"Base fee of the CALL opcode"},"callStipend":{"v":2300,"d":"Free gas given at beginning of call"},"callValueTransfer":{"v":9000,"d":"Paid for CALL when the value transfor is non-zero"},"callNewAccount":{"v":25000,"d":"Paid for CALL when the destination address didn\'t exist prior"},"selfdestructRefund":{"v":24000,"d":"Refunded following a selfdestruct operation"},"memory":{"v":3,"d":"Times the address of the (highest referenced byte in memory + 1). NOTE: referencing happens on read, write and in instructions such as RETURN and CALL"},"quadCoeffDiv":{"v":512,"d":"Divisor for the quadratic particle of the memory cost equation"},"createData":{"v":200,"d":""},"tx":{"v":21000,"d":"Per transaction. NOTE: Not payable on data of calls between transactions"},"txCreation":{"v":32000,"d":"The cost of creating a contract via tx"},"txDataZero":{"v":4,"d":"Per byte of data attached to a transaction that equals zero. NOTE: Not payable on data of calls between transactions"},"txDataNonZero":{"v":68,"d":"Per byte of data attached to a transaction that is not equal to zero. NOTE: Not payable on data of calls between transactions"},"copy":{"v":3,"d":"Multiplied by the number of 32-byte words that are copied (round up) for any *COPY operation and added"},"ecRecover":{"v":3000,"d":""},"sha256":{"v":60,"d":""},"sha256Word":{"v":12,"d":""},"ripemd160":{"v":600,"d":""},"ripemd160Word":{"v":120,"d":""},"identity":{"v":15,"d":""},"identityWord":{"v":3,"d":""},"stop":{"v":0,"d":"Base fee of the STOP opcode"},"add":{"v":3,"d":"Base fee of the ADD opcode"},"mul":{"v":5,"d":"Base fee of the MUL opcode"},"sub":{"v":3,"d":"Base fee of the SUB opcode"},"div":{"v":5,"d":"Base fee of the DIV opcode"},"sdiv":{"v":5,"d":"Base fee of the SDIV opcode"},"mod":{"v":5,"d":"Base fee of the MOD opcode"},"smod":{"v":5,"d":"Base fee of the SMOD opcode"},"addmod":{"v":8,"d":"Base fee of the ADDMOD opcode"},"mulmod":{"v":8,"d":"Base fee of the MULMOD opcode"},"signextend":{"v":5,"d":"Base fee of the SIGNEXTEND opcode"},"lt":{"v":3,"d":"Base fee of the LT opcode"},"gt":{"v":3,"d":"Base fee of the GT opcode"},"slt":{"v":3,"d":"Base fee of the SLT opcode"},"sgt":{"v":3,"d":"Base fee of the SGT opcode"},"eq":{"v":3,"d":"Base fee of the EQ opcode"},"iszero":{"v":3,"d":"Base fee of the ISZERO opcode"},"and":{"v":3,"d":"Base fee of the AND opcode"},"or":{"v":3,"d":"Base fee of the OR opcode"},"xor":{"v":3,"d":"Base fee of the XOR opcode"},"not":{"v":3,"d":"Base fee of the NOT opcode"},"byte":{"v":3,"d":"Base fee of the BYTE opcode"},"address":{"v":2,"d":"Base fee of the ADDRESS opcode"},"balance":{"v":20,"d":"Base fee of the BALANCE opcode"},"origin":{"v":2,"d":"Base fee of the ORIGIN opcode"},"caller":{"v":2,"d":"Base fee of the CALLER opcode"},"callvalue":{"v":2,"d":"Base fee of the CALLVALUE opcode"},"calldataload":{"v":3,"d":"Base fee of the CALLDATALOAD opcode"},"calldatasize":{"v":2,"d":"Base fee of the CALLDATASIZE opcode"},"calldatacopy":{"v":3,"d":"Base fee of the CALLDATACOPY opcode"},"codesize":{"v":2,"d":"Base fee of the CODESIZE opcode"},"codecopy":{"v":3,"d":"Base fee of the CODECOPY opcode"},"gasprice":{"v":2,"d":"Base fee of the GASPRICE opcode"},"extcodesize":{"v":20,"d":"Base fee of the EXTCODESIZE opcode"},"extcodecopy":{"v":20,"d":"Base fee of the EXTCODECOPY opcode"},"blockhash":{"v":20,"d":"Base fee of the BLOCKHASH opcode"},"coinbase":{"v":2,"d":"Base fee of the COINBASE opcode"},"timestamp":{"v":2,"d":"Base fee of the TIMESTAMP opcode"},"number":{"v":2,"d":"Base fee of the NUMBER opcode"},"difficulty":{"v":2,"d":"Base fee of the DIFFICULTY opcode"},"gaslimit":{"v":2,"d":"Base fee of the GASLIMIT opcode"},"pop":{"v":2,"d":"Base fee of the POP opcode"},"mload":{"v":3,"d":"Base fee of the MLOAD opcode"},"mstore":{"v":3,"d":"Base fee of the MSTORE opcode"},"mstore8":{"v":3,"d":"Base fee of the MSTORE8 opcode"},"sstore":{"v":0,"d":"Base fee of the SSTORE opcode"},"jump":{"v":8,"d":"Base fee of the JUMP opcode"},"jumpi":{"v":10,"d":"Base fee of the JUMPI opcode"},"pc":{"v":2,"d":"Base fee of the PC opcode"},"msize":{"v":2,"d":"Base fee of the MSIZE opcode"},"gas":{"v":2,"d":"Base fee of the GAS opcode"},"push":{"v":3,"d":"Base fee of the PUSH opcode"},"dup":{"v":3,"d":"Base fee of the DUP opcode"},"swap":{"v":3,"d":"Base fee of the SWAP opcode"},"callcode":{"v":40,"d":"Base fee of the CALLCODE opcode"},"return":{"v":0,"d":"Base fee of the RETURN opcode"},"invalid":{"v":0,"d":"Base fee of the INVALID opcode"},"selfdestruct":{"v":0,"d":"Base fee of the SELFDESTRUCT opcode"}},"vm":{"stackLimit":{"v":1024,"d":"Maximum size of VM stack allowed"},"callCreateDepth":{"v":1024,"d":"Maximum depth of call/create stack"},"maxExtraDataSize":{"v":32,"d":"Maximum size extra data may be after Genesis"}},"pow":{"minimumDifficulty":{"v":131072,"d":"The minimum that the difficulty may ever be"},"difficultyBoundDivisor":{"v":2048,"d":"The bound divisor of the difficulty, used in the update calculations"},"durationLimit":{"v":13,"d":"The decision boundary on the blocktime duration used to determine whether difficulty should go up or not"},"epochDuration":{"v":30000,"d":"Duration between proof-of-work epochs"},"timebombPeriod":{"v":100000,"d":"Exponential difficulty timebomb period"},"minerReward":{"v":"5000000000000000000","d":"the amount a miner get rewarded for mining a block"},"difficultyBombDelay":{"v":0,"d":"the amount of blocks to delay the difficulty bomb with"}}}');
            },
            35993: (e)=>{
                "use strict";
                e.exports = JSON.parse('{"name":"constantinople","comment":"Postponed hardfork including EIP-1283 (SSTORE gas metering changes)","url":"https://eips.ethereum.org/EIPS/eip-1013","status":"Final","gasConfig":{},"gasPrices":{"netSstoreNoopGas":{"v":200,"d":"Once per SSTORE operation if the value doesn\'t change"},"netSstoreInitGas":{"v":20000,"d":"Once per SSTORE operation from clean zero"},"netSstoreCleanGas":{"v":5000,"d":"Once per SSTORE operation from clean non-zero"},"netSstoreDirtyGas":{"v":200,"d":"Once per SSTORE operation from dirty"},"netSstoreClearRefund":{"v":15000,"d":"Once per SSTORE operation for clearing an originally existing storage slot"},"netSstoreResetRefund":{"v":4800,"d":"Once per SSTORE operation for resetting to the original non-zero value"},"netSstoreResetClearRefund":{"v":19800,"d":"Once per SSTORE operation for resetting to the original zero value"},"shl":{"v":3,"d":"Base fee of the SHL opcode"},"shr":{"v":3,"d":"Base fee of the SHR opcode"},"sar":{"v":3,"d":"Base fee of the SAR opcode"},"extcodehash":{"v":400,"d":"Base fee of the EXTCODEHASH opcode"},"create2":{"v":32000,"d":"Base fee of the CREATE2 opcode"}},"vm":{},"pow":{"minerReward":{"v":"2000000000000000000","d":"The amount a miner gets rewarded for mining a block"},"difficultyBombDelay":{"v":5000000,"d":"the amount of blocks to delay the difficulty bomb with"}}}');
            },
            7197: (e)=>{
                "use strict";
                e.exports = JSON.parse('{"name":"dao","comment":"DAO rescue hardfork","url":"https://eips.ethereum.org/EIPS/eip-779","status":"Final","gasConfig":{},"gasPrices":{},"vm":{},"pow":{}}');
            },
            31088: (e)=>{
                "use strict";
                e.exports = JSON.parse('{"name":"grayGlacier","comment":"Delaying the difficulty bomb to Mid September 2022","url":"https://github.com/ethereum/execution-specs/blob/master/network-upgrades/mainnet-upgrades/gray-glacier.md","status":"Draft","eips":[5133],"gasConfig":{},"gasPrices":{},"vm":{},"pow":{}}');
            },
            62800: (e)=>{
                "use strict";
                e.exports = JSON.parse('{"name":"homestead","comment":"Homestead hardfork with protocol and network changes","url":"https://eips.ethereum.org/EIPS/eip-606","status":"Final","gasConfig":{},"gasPrices":{"delegatecall":{"v":40,"d":"Base fee of the DELEGATECALL opcode"}},"vm":{},"pow":{}}');
            },
            83166: (e)=>{
                "use strict";
                e.exports = JSON.parse('{"name":"istanbul","comment":"HF targeted for December 2019 following the Constantinople/Petersburg HF","url":"https://eips.ethereum.org/EIPS/eip-1679","status":"Final","gasConfig":{},"gasPrices":{"blake2Round":{"v":1,"d":"Gas cost per round for the Blake2 F precompile"},"ecAdd":{"v":150,"d":"Gas costs for curve addition precompile"},"ecMul":{"v":6000,"d":"Gas costs for curve multiplication precompile"},"ecPairing":{"v":45000,"d":"Base gas costs for curve pairing precompile"},"ecPairingWord":{"v":34000,"d":"Gas costs regarding curve pairing precompile input length"},"txDataNonZero":{"v":16,"d":"Per byte of data attached to a transaction that is not equal to zero. NOTE: Not payable on data of calls between transactions"},"sstoreSentryGasEIP2200":{"v":2300,"d":"Minimum gas required to be present for an SSTORE call, not consumed"},"sstoreNoopGasEIP2200":{"v":800,"d":"Once per SSTORE operation if the value doesn\'t change"},"sstoreDirtyGasEIP2200":{"v":800,"d":"Once per SSTORE operation if a dirty value is changed"},"sstoreInitGasEIP2200":{"v":20000,"d":"Once per SSTORE operation from clean zero to non-zero"},"sstoreInitRefundEIP2200":{"v":19200,"d":"Once per SSTORE operation for resetting to the original zero value"},"sstoreCleanGasEIP2200":{"v":5000,"d":"Once per SSTORE operation from clean non-zero to something else"},"sstoreCleanRefundEIP2200":{"v":4200,"d":"Once per SSTORE operation for resetting to the original non-zero value"},"sstoreClearRefundEIP2200":{"v":15000,"d":"Once per SSTORE operation for clearing an originally existing storage slot"},"balance":{"v":700,"d":"Base fee of the BALANCE opcode"},"extcodehash":{"v":700,"d":"Base fee of the EXTCODEHASH opcode"},"chainid":{"v":2,"d":"Base fee of the CHAINID opcode"},"selfbalance":{"v":5,"d":"Base fee of the SELFBALANCE opcode"},"sload":{"v":800,"d":"Base fee of the SLOAD opcode"}},"vm":{},"pow":{}}');
            },
            61250: (e)=>{
                "use strict";
                e.exports = JSON.parse('{"name":"london","comment":"HF targeted for July 2021 following the Berlin fork","url":"https://github.com/ethereum/eth1.0-specs/blob/master/network-upgrades/mainnet-upgrades/london.md","status":"Final","eips":[1559,3198,3529,3541]}');
            },
            88648: (e)=>{
                "use strict";
                e.exports = JSON.parse('{"name":"merge","comment":"Hardfork to upgrade the consensus mechanism to Proof-of-Stake","url":"https://github.com/ethereum/execution-specs/blob/master/network-upgrades/mainnet-upgrades/merge.md","status":"Draft","consensus":{"type":"pos","algorithm":"casper","casper":{}},"eips":[3675,4399]}');
            },
            49347: (e)=>{
                "use strict";
                e.exports = JSON.parse('{"name":"mergeForkIdTransition","comment":"Pre-merge hardfork to fork off non-upgraded clients","url":"https://eips.ethereum.org/EIPS/eip-3675","status":"Draft","eips":[]}');
            },
            42946: (e)=>{
                "use strict";
                e.exports = JSON.parse('{"name":"muirGlacier","comment":"HF to delay the difficulty bomb","url":"https://eips.ethereum.org/EIPS/eip-2384","status":"Final","gasConfig":{},"gasPrices":{},"vm":{},"pow":{"difficultyBombDelay":{"v":9000000,"d":"the amount of blocks to delay the difficulty bomb with"}}}');
            },
            4064: (e)=>{
                "use strict";
                e.exports = JSON.parse('{"name":"petersburg","comment":"Aka constantinopleFix, removes EIP-1283, activate together with or after constantinople","url":"https://eips.ethereum.org/EIPS/eip-1716","status":"Final","gasConfig":{},"gasPrices":{"netSstoreNoopGas":{"v":null,"d":"Removed along EIP-1283"},"netSstoreInitGas":{"v":null,"d":"Removed along EIP-1283"},"netSstoreCleanGas":{"v":null,"d":"Removed along EIP-1283"},"netSstoreDirtyGas":{"v":null,"d":"Removed along EIP-1283"},"netSstoreClearRefund":{"v":null,"d":"Removed along EIP-1283"},"netSstoreResetRefund":{"v":null,"d":"Removed along EIP-1283"},"netSstoreResetClearRefund":{"v":null,"d":"Removed along EIP-1283"}},"vm":{},"pow":{}}');
            },
            5553: (e)=>{
                "use strict";
                e.exports = JSON.parse('{"name":"shanghai","comment":"Next feature hardfork after the merge hardfork","url":"https://github.com/ethereum/pm/issues/356","status":"Pre-Draft","eips":[]}');
            },
            90716: (e)=>{
                "use strict";
                e.exports = JSON.parse('{"name":"spuriousDragon","comment":"HF with EIPs for simple replay attack protection, EXP cost increase, state trie clearing, contract code size limit","url":"https://eips.ethereum.org/EIPS/eip-607","status":"Final","gasConfig":{},"gasPrices":{"expByte":{"v":50,"d":"Times ceil(log256(exponent)) for the EXP instruction"}},"vm":{"maxCodeSize":{"v":24576,"d":"Maximum length of contract code"}},"pow":{}}');
            },
            22302: (e)=>{
                "use strict";
                e.exports = JSON.parse('{"name":"tangerineWhistle","comment":"Hardfork with gas cost changes for IO-heavy operations","url":"https://eips.ethereum.org/EIPS/eip-608","status":"Final","gasConfig":{},"gasPrices":{"sload":{"v":200,"d":"Once per SLOAD operation"},"call":{"v":700,"d":"Once per CALL operation & message call transaction"},"extcodesize":{"v":700,"d":"Base fee of the EXTCODESIZE opcode"},"extcodecopy":{"v":700,"d":"Base fee of the EXTCODECOPY opcode"},"balance":{"v":400,"d":"Base fee of the BALANCE opcode"},"delegatecall":{"v":700,"d":"Base fee of the DELEGATECALL opcode"},"callcode":{"v":700,"d":"Base fee of the CALLCODE opcode"},"selfdestruct":{"v":5000,"d":"Base fee of the SELFDESTRUCT opcode"}},"vm":{},"pow":{}}');
            },
            44946: (e)=>{
                "use strict";
                e.exports = JSON.parse('{"aes-128-ecb":{"cipher":"AES","key":128,"iv":0,"mode":"ECB","type":"block"},"aes-192-ecb":{"cipher":"AES","key":192,"iv":0,"mode":"ECB","type":"block"},"aes-256-ecb":{"cipher":"AES","key":256,"iv":0,"mode":"ECB","type":"block"},"aes-128-cbc":{"cipher":"AES","key":128,"iv":16,"mode":"CBC","type":"block"},"aes-192-cbc":{"cipher":"AES","key":192,"iv":16,"mode":"CBC","type":"block"},"aes-256-cbc":{"cipher":"AES","key":256,"iv":16,"mode":"CBC","type":"block"},"aes128":{"cipher":"AES","key":128,"iv":16,"mode":"CBC","type":"block"},"aes192":{"cipher":"AES","key":192,"iv":16,"mode":"CBC","type":"block"},"aes256":{"cipher":"AES","key":256,"iv":16,"mode":"CBC","type":"block"},"aes-128-cfb":{"cipher":"AES","key":128,"iv":16,"mode":"CFB","type":"stream"},"aes-192-cfb":{"cipher":"AES","key":192,"iv":16,"mode":"CFB","type":"stream"},"aes-256-cfb":{"cipher":"AES","key":256,"iv":16,"mode":"CFB","type":"stream"},"aes-128-cfb8":{"cipher":"AES","key":128,"iv":16,"mode":"CFB8","type":"stream"},"aes-192-cfb8":{"cipher":"AES","key":192,"iv":16,"mode":"CFB8","type":"stream"},"aes-256-cfb8":{"cipher":"AES","key":256,"iv":16,"mode":"CFB8","type":"stream"},"aes-128-cfb1":{"cipher":"AES","key":128,"iv":16,"mode":"CFB1","type":"stream"},"aes-192-cfb1":{"cipher":"AES","key":192,"iv":16,"mode":"CFB1","type":"stream"},"aes-256-cfb1":{"cipher":"AES","key":256,"iv":16,"mode":"CFB1","type":"stream"},"aes-128-ofb":{"cipher":"AES","key":128,"iv":16,"mode":"OFB","type":"stream"},"aes-192-ofb":{"cipher":"AES","key":192,"iv":16,"mode":"OFB","type":"stream"},"aes-256-ofb":{"cipher":"AES","key":256,"iv":16,"mode":"OFB","type":"stream"},"aes-128-ctr":{"cipher":"AES","key":128,"iv":16,"mode":"CTR","type":"stream"},"aes-192-ctr":{"cipher":"AES","key":192,"iv":16,"mode":"CTR","type":"stream"},"aes-256-ctr":{"cipher":"AES","key":256,"iv":16,"mode":"CTR","type":"stream"},"aes-128-gcm":{"cipher":"AES","key":128,"iv":12,"mode":"GCM","type":"auth"},"aes-192-gcm":{"cipher":"AES","key":192,"iv":12,"mode":"GCM","type":"auth"},"aes-256-gcm":{"cipher":"AES","key":256,"iv":12,"mode":"GCM","type":"auth"}}');
            },
            75207: (e)=>{
                "use strict";
                e.exports = JSON.parse('{"sha224WithRSAEncryption":{"sign":"rsa","hash":"sha224","id":"302d300d06096086480165030402040500041c"},"RSA-SHA224":{"sign":"ecdsa/rsa","hash":"sha224","id":"302d300d06096086480165030402040500041c"},"sha256WithRSAEncryption":{"sign":"rsa","hash":"sha256","id":"3031300d060960864801650304020105000420"},"RSA-SHA256":{"sign":"ecdsa/rsa","hash":"sha256","id":"3031300d060960864801650304020105000420"},"sha384WithRSAEncryption":{"sign":"rsa","hash":"sha384","id":"3041300d060960864801650304020205000430"},"RSA-SHA384":{"sign":"ecdsa/rsa","hash":"sha384","id":"3041300d060960864801650304020205000430"},"sha512WithRSAEncryption":{"sign":"rsa","hash":"sha512","id":"3051300d060960864801650304020305000440"},"RSA-SHA512":{"sign":"ecdsa/rsa","hash":"sha512","id":"3051300d060960864801650304020305000440"},"RSA-SHA1":{"sign":"rsa","hash":"sha1","id":"3021300906052b0e03021a05000414"},"ecdsa-with-SHA1":{"sign":"ecdsa","hash":"sha1","id":""},"sha256":{"sign":"ecdsa","hash":"sha256","id":""},"sha224":{"sign":"ecdsa","hash":"sha224","id":""},"sha384":{"sign":"ecdsa","hash":"sha384","id":""},"sha512":{"sign":"ecdsa","hash":"sha512","id":""},"DSA-SHA":{"sign":"dsa","hash":"sha1","id":""},"DSA-SHA1":{"sign":"dsa","hash":"sha1","id":""},"DSA":{"sign":"dsa","hash":"sha1","id":""},"DSA-WITH-SHA224":{"sign":"dsa","hash":"sha224","id":""},"DSA-SHA224":{"sign":"dsa","hash":"sha224","id":""},"DSA-WITH-SHA256":{"sign":"dsa","hash":"sha256","id":""},"DSA-SHA256":{"sign":"dsa","hash":"sha256","id":""},"DSA-WITH-SHA384":{"sign":"dsa","hash":"sha384","id":""},"DSA-SHA384":{"sign":"dsa","hash":"sha384","id":""},"DSA-WITH-SHA512":{"sign":"dsa","hash":"sha512","id":""},"DSA-SHA512":{"sign":"dsa","hash":"sha512","id":""},"DSA-RIPEMD160":{"sign":"dsa","hash":"rmd160","id":""},"ripemd160WithRSA":{"sign":"rsa","hash":"rmd160","id":"3021300906052b2403020105000414"},"RSA-RIPEMD160":{"sign":"rsa","hash":"rmd160","id":"3021300906052b2403020105000414"},"md5WithRSAEncryption":{"sign":"rsa","hash":"md5","id":"3020300c06082a864886f70d020505000410"},"RSA-MD5":{"sign":"rsa","hash":"md5","id":"3020300c06082a864886f70d020505000410"}}');
            },
            1308: (e)=>{
                "use strict";
                e.exports = JSON.parse('{"1.3.132.0.10":"secp256k1","1.3.132.0.33":"p224","1.2.840.10045.3.1.1":"p192","1.2.840.10045.3.1.7":"p256","1.3.132.0.34":"p384","1.3.132.0.35":"p521"}');
            },
            83630: (e)=>{
                "use strict";
                e.exports = JSON.parse('{"identity":0,"ip4":4,"tcp":6,"sha1":17,"sha2-256":18,"sha2-512":19,"sha3-512":20,"sha3-384":21,"sha3-256":22,"sha3-224":23,"shake-128":24,"shake-256":25,"keccak-224":26,"keccak-256":27,"keccak-384":28,"keccak-512":29,"blake3":30,"dccp":33,"murmur3-128":34,"murmur3-32":35,"ip6":41,"ip6zone":42,"path":47,"multicodec":48,"multihash":49,"multiaddr":50,"multibase":51,"dns":53,"dns4":54,"dns6":55,"dnsaddr":56,"protobuf":80,"cbor":81,"raw":85,"dbl-sha2-256":86,"rlp":96,"bencode":99,"dag-pb":112,"dag-cbor":113,"libp2p-key":114,"git-raw":120,"torrent-info":123,"torrent-file":124,"leofcoin-block":129,"leofcoin-tx":130,"leofcoin-pr":131,"sctp":132,"dag-jose":133,"dag-cose":134,"eth-block":144,"eth-block-list":145,"eth-tx-trie":146,"eth-tx":147,"eth-tx-receipt-trie":148,"eth-tx-receipt":149,"eth-state-trie":150,"eth-account-snapshot":151,"eth-storage-trie":152,"bitcoin-block":176,"bitcoin-tx":177,"bitcoin-witness-commitment":178,"zcash-block":192,"zcash-tx":193,"stellar-block":208,"stellar-tx":209,"md4":212,"md5":213,"bmt":214,"decred-block":224,"decred-tx":225,"ipld-ns":226,"ipfs-ns":227,"swarm-ns":228,"ipns-ns":229,"zeronet":230,"secp256k1-pub":231,"bls12_381-g1-pub":234,"bls12_381-g2-pub":235,"x25519-pub":236,"ed25519-pub":237,"dash-block":240,"dash-tx":241,"swarm-manifest":250,"swarm-feed":251,"udp":273,"p2p-webrtc-star":275,"p2p-webrtc-direct":276,"p2p-stardust":277,"p2p-circuit":290,"dag-json":297,"udt":301,"utp":302,"unix":400,"p2p":421,"ipfs":421,"https":443,"onion":444,"onion3":445,"garlic64":446,"garlic32":447,"tls":448,"quic":460,"ws":477,"wss":478,"p2p-websocket-star":479,"http":480,"json":512,"messagepack":513,"libp2p-peer-record":769,"sha2-256-trunc254-padded":4114,"ripemd-128":4178,"ripemd-160":4179,"ripemd-256":4180,"ripemd-320":4181,"x11":4352,"sm3-256":21325,"blake2b-8":45569,"blake2b-16":45570,"blake2b-24":45571,"blake2b-32":45572,"blake2b-40":45573,"blake2b-48":45574,"blake2b-56":45575,"blake2b-64":45576,"blake2b-72":45577,"blake2b-80":45578,"blake2b-88":45579,"blake2b-96":45580,"blake2b-104":45581,"blake2b-112":45582,"blake2b-120":45583,"blake2b-128":45584,"blake2b-136":45585,"blake2b-144":45586,"blake2b-152":45587,"blake2b-160":45588,"blake2b-168":45589,"blake2b-176":45590,"blake2b-184":45591,"blake2b-192":45592,"blake2b-200":45593,"blake2b-208":45594,"blake2b-216":45595,"blake2b-224":45596,"blake2b-232":45597,"blake2b-240":45598,"blake2b-248":45599,"blake2b-256":45600,"blake2b-264":45601,"blake2b-272":45602,"blake2b-280":45603,"blake2b-288":45604,"blake2b-296":45605,"blake2b-304":45606,"blake2b-312":45607,"blake2b-320":45608,"blake2b-328":45609,"blake2b-336":45610,"blake2b-344":45611,"blake2b-352":45612,"blake2b-360":45613,"blake2b-368":45614,"blake2b-376":45615,"blake2b-384":45616,"blake2b-392":45617,"blake2b-400":45618,"blake2b-408":45619,"blake2b-416":45620,"blake2b-424":45621,"blake2b-432":45622,"blake2b-440":45623,"blake2b-448":45624,"blake2b-456":45625,"blake2b-464":45626,"blake2b-472":45627,"blake2b-480":45628,"blake2b-488":45629,"blake2b-496":45630,"blake2b-504":45631,"blake2b-512":45632,"blake2s-8":45633,"blake2s-16":45634,"blake2s-24":45635,"blake2s-32":45636,"blake2s-40":45637,"blake2s-48":45638,"blake2s-56":45639,"blake2s-64":45640,"blake2s-72":45641,"blake2s-80":45642,"blake2s-88":45643,"blake2s-96":45644,"blake2s-104":45645,"blake2s-112":45646,"blake2s-120":45647,"blake2s-128":45648,"blake2s-136":45649,"blake2s-144":45650,"blake2s-152":45651,"blake2s-160":45652,"blake2s-168":45653,"blake2s-176":45654,"blake2s-184":45655,"blake2s-192":45656,"blake2s-200":45657,"blake2s-208":45658,"blake2s-216":45659,"blake2s-224":45660,"blake2s-232":45661,"blake2s-240":45662,"blake2s-248":45663,"blake2s-256":45664,"skein256-8":45825,"skein256-16":45826,"skein256-24":45827,"skein256-32":45828,"skein256-40":45829,"skein256-48":45830,"skein256-56":45831,"skein256-64":45832,"skein256-72":45833,"skein256-80":45834,"skein256-88":45835,"skein256-96":45836,"skein256-104":45837,"skein256-112":45838,"skein256-120":45839,"skein256-128":45840,"skein256-136":45841,"skein256-144":45842,"skein256-152":45843,"skein256-160":45844,"skein256-168":45845,"skein256-176":45846,"skein256-184":45847,"skein256-192":45848,"skein256-200":45849,"skein256-208":45850,"skein256-216":45851,"skein256-224":45852,"skein256-232":45853,"skein256-240":45854,"skein256-248":45855,"skein256-256":45856,"skein512-8":45857,"skein512-16":45858,"skein512-24":45859,"skein512-32":45860,"skein512-40":45861,"skein512-48":45862,"skein512-56":45863,"skein512-64":45864,"skein512-72":45865,"skein512-80":45866,"skein512-88":45867,"skein512-96":45868,"skein512-104":45869,"skein512-112":45870,"skein512-120":45871,"skein512-128":45872,"skein512-136":45873,"skein512-144":45874,"skein512-152":45875,"skein512-160":45876,"skein512-168":45877,"skein512-176":45878,"skein512-184":45879,"skein512-192":45880,"skein512-200":45881,"skein512-208":45882,"skein512-216":45883,"skein512-224":45884,"skein512-232":45885,"skein512-240":45886,"skein512-248":45887,"skein512-256":45888,"skein512-264":45889,"skein512-272":45890,"skein512-280":45891,"skein512-288":45892,"skein512-296":45893,"skein512-304":45894,"skein512-312":45895,"skein512-320":45896,"skein512-328":45897,"skein512-336":45898,"skein512-344":45899,"skein512-352":45900,"skein512-360":45901,"skein512-368":45902,"skein512-376":45903,"skein512-384":45904,"skein512-392":45905,"skein512-400":45906,"skein512-408":45907,"skein512-416":45908,"skein512-424":45909,"skein512-432":45910,"skein512-440":45911,"skein512-448":45912,"skein512-456":45913,"skein512-464":45914,"skein512-472":45915,"skein512-480":45916,"skein512-488":45917,"skein512-496":45918,"skein512-504":45919,"skein512-512":45920,"skein1024-8":45921,"skein1024-16":45922,"skein1024-24":45923,"skein1024-32":45924,"skein1024-40":45925,"skein1024-48":45926,"skein1024-56":45927,"skein1024-64":45928,"skein1024-72":45929,"skein1024-80":45930,"skein1024-88":45931,"skein1024-96":45932,"skein1024-104":45933,"skein1024-112":45934,"skein1024-120":45935,"skein1024-128":45936,"skein1024-136":45937,"skein1024-144":45938,"skein1024-152":45939,"skein1024-160":45940,"skein1024-168":45941,"skein1024-176":45942,"skein1024-184":45943,"skein1024-192":45944,"skein1024-200":45945,"skein1024-208":45946,"skein1024-216":45947,"skein1024-224":45948,"skein1024-232":45949,"skein1024-240":45950,"skein1024-248":45951,"skein1024-256":45952,"skein1024-264":45953,"skein1024-272":45954,"skein1024-280":45955,"skein1024-288":45956,"skein1024-296":45957,"skein1024-304":45958,"skein1024-312":45959,"skein1024-320":45960,"skein1024-328":45961,"skein1024-336":45962,"skein1024-344":45963,"skein1024-352":45964,"skein1024-360":45965,"skein1024-368":45966,"skein1024-376":45967,"skein1024-384":45968,"skein1024-392":45969,"skein1024-400":45970,"skein1024-408":45971,"skein1024-416":45972,"skein1024-424":45973,"skein1024-432":45974,"skein1024-440":45975,"skein1024-448":45976,"skein1024-456":45977,"skein1024-464":45978,"skein1024-472":45979,"skein1024-480":45980,"skein1024-488":45981,"skein1024-496":45982,"skein1024-504":45983,"skein1024-512":45984,"skein1024-520":45985,"skein1024-528":45986,"skein1024-536":45987,"skein1024-544":45988,"skein1024-552":45989,"skein1024-560":45990,"skein1024-568":45991,"skein1024-576":45992,"skein1024-584":45993,"skein1024-592":45994,"skein1024-600":45995,"skein1024-608":45996,"skein1024-616":45997,"skein1024-624":45998,"skein1024-632":45999,"skein1024-640":46000,"skein1024-648":46001,"skein1024-656":46002,"skein1024-664":46003,"skein1024-672":46004,"skein1024-680":46005,"skein1024-688":46006,"skein1024-696":46007,"skein1024-704":46008,"skein1024-712":46009,"skein1024-720":46010,"skein1024-728":46011,"skein1024-736":46012,"skein1024-744":46013,"skein1024-752":46014,"skein1024-760":46015,"skein1024-768":46016,"skein1024-776":46017,"skein1024-784":46018,"skein1024-792":46019,"skein1024-800":46020,"skein1024-808":46021,"skein1024-816":46022,"skein1024-824":46023,"skein1024-832":46024,"skein1024-840":46025,"skein1024-848":46026,"skein1024-856":46027,"skein1024-864":46028,"skein1024-872":46029,"skein1024-880":46030,"skein1024-888":46031,"skein1024-896":46032,"skein1024-904":46033,"skein1024-912":46034,"skein1024-920":46035,"skein1024-928":46036,"skein1024-936":46037,"skein1024-944":46038,"skein1024-952":46039,"skein1024-960":46040,"skein1024-968":46041,"skein1024-976":46042,"skein1024-984":46043,"skein1024-992":46044,"skein1024-1000":46045,"skein1024-1008":46046,"skein1024-1016":46047,"skein1024-1024":46048,"poseidon-bls12_381-a2-fc1":46081,"poseidon-bls12_381-a2-fc1-sc":46082,"zeroxcert-imprint-256":52753,"fil-commitment-unsealed":61697,"fil-commitment-sealed":61698,"holochain-adr-v0":8417572,"holochain-adr-v1":8483108,"holochain-key-v0":9728292,"holochain-key-v1":9793828,"holochain-sig-v0":10645796,"holochain-sig-v1":10711332}');
            },
            29799: (e)=>{
                "use strict";
                e.exports = JSON.parse('{"modp1":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a63a3620ffffffffffffffff"},"modp2":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece65381ffffffffffffffff"},"modp5":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca237327ffffffffffffffff"},"modp14":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aacaa68ffffffffffffffff"},"modp15":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a93ad2caffffffffffffffff"},"modp16":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c934063199ffffffffffffffff"},"modp17":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c93402849236c3fab4d27c7026c1d4dcb2602646dec9751e763dba37bdf8ff9406ad9e530ee5db382f413001aeb06a53ed9027d831179727b0865a8918da3edbebcf9b14ed44ce6cbaced4bb1bdb7f1447e6cc254b332051512bd7af426fb8f401378cd2bf5983ca01c64b92ecf032ea15d1721d03f482d7ce6e74fef6d55e702f46980c82b5a84031900b1c9e59e7c97fbec7e8f323a97a7e36cc88be0f1d45b7ff585ac54bd407b22b4154aacc8f6d7ebf48e1d814cc5ed20f8037e0a79715eef29be32806a1d58bb7c5da76f550aa3d8a1fbff0eb19ccb1a313d55cda56c9ec2ef29632387fe8d76e3c0468043e8f663f4860ee12bf2d5b0b7474d6e694f91e6dcc4024ffffffffffffffff"},"modp18":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c93402849236c3fab4d27c7026c1d4dcb2602646dec9751e763dba37bdf8ff9406ad9e530ee5db382f413001aeb06a53ed9027d831179727b0865a8918da3edbebcf9b14ed44ce6cbaced4bb1bdb7f1447e6cc254b332051512bd7af426fb8f401378cd2bf5983ca01c64b92ecf032ea15d1721d03f482d7ce6e74fef6d55e702f46980c82b5a84031900b1c9e59e7c97fbec7e8f323a97a7e36cc88be0f1d45b7ff585ac54bd407b22b4154aacc8f6d7ebf48e1d814cc5ed20f8037e0a79715eef29be32806a1d58bb7c5da76f550aa3d8a1fbff0eb19ccb1a313d55cda56c9ec2ef29632387fe8d76e3c0468043e8f663f4860ee12bf2d5b0b7474d6e694f91e6dbe115974a3926f12fee5e438777cb6a932df8cd8bec4d073b931ba3bc832b68d9dd300741fa7bf8afc47ed2576f6936ba424663aab639c5ae4f5683423b4742bf1c978238f16cbe39d652de3fdb8befc848ad922222e04a4037c0713eb57a81a23f0c73473fc646cea306b4bcbc8862f8385ddfa9d4b7fa2c087e879683303ed5bdd3a062b3cf5b3a278a66d2a13f83f44f82ddf310ee074ab6a364597e899a0255dc164f31cc50846851df9ab48195ded7ea1b1d510bd7ee74d73faf36bc31ecfa268359046f4eb879f924009438b481c6cd7889a002ed5ee382bc9190da6fc026e479558e4475677e9aa9e3050e2765694dfc81f56e880b96e7160c980dd98edd3dfffffffffffffffff"}}');
            },
            18597: (e)=>{
                "use strict";
                e.exports = {
                    i8: "6.5.4"
                };
            },
            24070: (e)=>{
                "use strict";
                e.exports = JSON.parse('{"identity":0,"ip4":4,"tcp":6,"sha1":17,"sha2-256":18,"sha2-512":19,"sha3-512":20,"sha3-384":21,"sha3-256":22,"sha3-224":23,"shake-128":24,"shake-256":25,"keccak-224":26,"keccak-256":27,"keccak-384":28,"keccak-512":29,"dccp":33,"murmur3-128":34,"murmur3-32":35,"ip6":41,"ip6zone":42,"path":47,"multicodec":48,"multihash":49,"multiaddr":50,"multibase":51,"dns":53,"dns4":54,"dns6":55,"dnsaddr":56,"protobuf":80,"cbor":81,"raw":85,"dbl-sha2-256":86,"rlp":96,"bencode":99,"dag-pb":112,"dag-cbor":113,"libp2p-key":114,"git-raw":120,"torrent-info":123,"torrent-file":124,"leofcoin-block":129,"leofcoin-tx":130,"leofcoin-pr":131,"sctp":132,"eth-block":144,"eth-block-list":145,"eth-tx-trie":146,"eth-tx":147,"eth-tx-receipt-trie":148,"eth-tx-receipt":149,"eth-state-trie":150,"eth-account-snapshot":151,"eth-storage-trie":152,"bitcoin-block":176,"bitcoin-tx":177,"zcash-block":192,"zcash-tx":193,"stellar-block":208,"stellar-tx":209,"md4":212,"md5":213,"bmt":214,"decred-block":224,"decred-tx":225,"ipld-ns":226,"ipfs-ns":227,"swarm-ns":228,"ipns-ns":229,"zeronet":230,"ed25519-pub":237,"dash-block":240,"dash-tx":241,"swarm-manifest":250,"swarm-feed":251,"udp":273,"p2p-webrtc-star":275,"p2p-webrtc-direct":276,"p2p-stardust":277,"p2p-circuit":290,"dag-json":297,"udt":301,"utp":302,"unix":400,"p2p":421,"ipfs":421,"https":443,"onion":444,"onion3":445,"garlic64":446,"garlic32":447,"tls":448,"quic":460,"ws":477,"wss":478,"p2p-websocket-star":479,"http":480,"json":512,"messagepack":513,"x11":4352,"blake2b-8":45569,"blake2b-16":45570,"blake2b-24":45571,"blake2b-32":45572,"blake2b-40":45573,"blake2b-48":45574,"blake2b-56":45575,"blake2b-64":45576,"blake2b-72":45577,"blake2b-80":45578,"blake2b-88":45579,"blake2b-96":45580,"blake2b-104":45581,"blake2b-112":45582,"blake2b-120":45583,"blake2b-128":45584,"blake2b-136":45585,"blake2b-144":45586,"blake2b-152":45587,"blake2b-160":45588,"blake2b-168":45589,"blake2b-176":45590,"blake2b-184":45591,"blake2b-192":45592,"blake2b-200":45593,"blake2b-208":45594,"blake2b-216":45595,"blake2b-224":45596,"blake2b-232":45597,"blake2b-240":45598,"blake2b-248":45599,"blake2b-256":45600,"blake2b-264":45601,"blake2b-272":45602,"blake2b-280":45603,"blake2b-288":45604,"blake2b-296":45605,"blake2b-304":45606,"blake2b-312":45607,"blake2b-320":45608,"blake2b-328":45609,"blake2b-336":45610,"blake2b-344":45611,"blake2b-352":45612,"blake2b-360":45613,"blake2b-368":45614,"blake2b-376":45615,"blake2b-384":45616,"blake2b-392":45617,"blake2b-400":45618,"blake2b-408":45619,"blake2b-416":45620,"blake2b-424":45621,"blake2b-432":45622,"blake2b-440":45623,"blake2b-448":45624,"blake2b-456":45625,"blake2b-464":45626,"blake2b-472":45627,"blake2b-480":45628,"blake2b-488":45629,"blake2b-496":45630,"blake2b-504":45631,"blake2b-512":45632,"blake2s-8":45633,"blake2s-16":45634,"blake2s-24":45635,"blake2s-32":45636,"blake2s-40":45637,"blake2s-48":45638,"blake2s-56":45639,"blake2s-64":45640,"blake2s-72":45641,"blake2s-80":45642,"blake2s-88":45643,"blake2s-96":45644,"blake2s-104":45645,"blake2s-112":45646,"blake2s-120":45647,"blake2s-128":45648,"blake2s-136":45649,"blake2s-144":45650,"blake2s-152":45651,"blake2s-160":45652,"blake2s-168":45653,"blake2s-176":45654,"blake2s-184":45655,"blake2s-192":45656,"blake2s-200":45657,"blake2s-208":45658,"blake2s-216":45659,"blake2s-224":45660,"blake2s-232":45661,"blake2s-240":45662,"blake2s-248":45663,"blake2s-256":45664,"skein256-8":45825,"skein256-16":45826,"skein256-24":45827,"skein256-32":45828,"skein256-40":45829,"skein256-48":45830,"skein256-56":45831,"skein256-64":45832,"skein256-72":45833,"skein256-80":45834,"skein256-88":45835,"skein256-96":45836,"skein256-104":45837,"skein256-112":45838,"skein256-120":45839,"skein256-128":45840,"skein256-136":45841,"skein256-144":45842,"skein256-152":45843,"skein256-160":45844,"skein256-168":45845,"skein256-176":45846,"skein256-184":45847,"skein256-192":45848,"skein256-200":45849,"skein256-208":45850,"skein256-216":45851,"skein256-224":45852,"skein256-232":45853,"skein256-240":45854,"skein256-248":45855,"skein256-256":45856,"skein512-8":45857,"skein512-16":45858,"skein512-24":45859,"skein512-32":45860,"skein512-40":45861,"skein512-48":45862,"skein512-56":45863,"skein512-64":45864,"skein512-72":45865,"skein512-80":45866,"skein512-88":45867,"skein512-96":45868,"skein512-104":45869,"skein512-112":45870,"skein512-120":45871,"skein512-128":45872,"skein512-136":45873,"skein512-144":45874,"skein512-152":45875,"skein512-160":45876,"skein512-168":45877,"skein512-176":45878,"skein512-184":45879,"skein512-192":45880,"skein512-200":45881,"skein512-208":45882,"skein512-216":45883,"skein512-224":45884,"skein512-232":45885,"skein512-240":45886,"skein512-248":45887,"skein512-256":45888,"skein512-264":45889,"skein512-272":45890,"skein512-280":45891,"skein512-288":45892,"skein512-296":45893,"skein512-304":45894,"skein512-312":45895,"skein512-320":45896,"skein512-328":45897,"skein512-336":45898,"skein512-344":45899,"skein512-352":45900,"skein512-360":45901,"skein512-368":45902,"skein512-376":45903,"skein512-384":45904,"skein512-392":45905,"skein512-400":45906,"skein512-408":45907,"skein512-416":45908,"skein512-424":45909,"skein512-432":45910,"skein512-440":45911,"skein512-448":45912,"skein512-456":45913,"skein512-464":45914,"skein512-472":45915,"skein512-480":45916,"skein512-488":45917,"skein512-496":45918,"skein512-504":45919,"skein512-512":45920,"skein1024-8":45921,"skein1024-16":45922,"skein1024-24":45923,"skein1024-32":45924,"skein1024-40":45925,"skein1024-48":45926,"skein1024-56":45927,"skein1024-64":45928,"skein1024-72":45929,"skein1024-80":45930,"skein1024-88":45931,"skein1024-96":45932,"skein1024-104":45933,"skein1024-112":45934,"skein1024-120":45935,"skein1024-128":45936,"skein1024-136":45937,"skein1024-144":45938,"skein1024-152":45939,"skein1024-160":45940,"skein1024-168":45941,"skein1024-176":45942,"skein1024-184":45943,"skein1024-192":45944,"skein1024-200":45945,"skein1024-208":45946,"skein1024-216":45947,"skein1024-224":45948,"skein1024-232":45949,"skein1024-240":45950,"skein1024-248":45951,"skein1024-256":45952,"skein1024-264":45953,"skein1024-272":45954,"skein1024-280":45955,"skein1024-288":45956,"skein1024-296":45957,"skein1024-304":45958,"skein1024-312":45959,"skein1024-320":45960,"skein1024-328":45961,"skein1024-336":45962,"skein1024-344":45963,"skein1024-352":45964,"skein1024-360":45965,"skein1024-368":45966,"skein1024-376":45967,"skein1024-384":45968,"skein1024-392":45969,"skein1024-400":45970,"skein1024-408":45971,"skein1024-416":45972,"skein1024-424":45973,"skein1024-432":45974,"skein1024-440":45975,"skein1024-448":45976,"skein1024-456":45977,"skein1024-464":45978,"skein1024-472":45979,"skein1024-480":45980,"skein1024-488":45981,"skein1024-496":45982,"skein1024-504":45983,"skein1024-512":45984,"skein1024-520":45985,"skein1024-528":45986,"skein1024-536":45987,"skein1024-544":45988,"skein1024-552":45989,"skein1024-560":45990,"skein1024-568":45991,"skein1024-576":45992,"skein1024-584":45993,"skein1024-592":45994,"skein1024-600":45995,"skein1024-608":45996,"skein1024-616":45997,"skein1024-624":45998,"skein1024-632":45999,"skein1024-640":46000,"skein1024-648":46001,"skein1024-656":46002,"skein1024-664":46003,"skein1024-672":46004,"skein1024-680":46005,"skein1024-688":46006,"skein1024-696":46007,"skein1024-704":46008,"skein1024-712":46009,"skein1024-720":46010,"skein1024-728":46011,"skein1024-736":46012,"skein1024-744":46013,"skein1024-752":46014,"skein1024-760":46015,"skein1024-768":46016,"skein1024-776":46017,"skein1024-784":46018,"skein1024-792":46019,"skein1024-800":46020,"skein1024-808":46021,"skein1024-816":46022,"skein1024-824":46023,"skein1024-832":46024,"skein1024-840":46025,"skein1024-848":46026,"skein1024-856":46027,"skein1024-864":46028,"skein1024-872":46029,"skein1024-880":46030,"skein1024-888":46031,"skein1024-896":46032,"skein1024-904":46033,"skein1024-912":46034,"skein1024-920":46035,"skein1024-928":46036,"skein1024-936":46037,"skein1024-944":46038,"skein1024-952":46039,"skein1024-960":46040,"skein1024-968":46041,"skein1024-976":46042,"skein1024-984":46043,"skein1024-992":46044,"skein1024-1000":46045,"skein1024-1008":46046,"skein1024-1016":46047,"skein1024-1024":46048,"holochain-adr-v0":8417572,"holochain-adr-v1":8483108,"holochain-key-v0":9728292,"holochain-key-v1":9793828,"holochain-sig-v0":10645796,"holochain-sig-v1":10711332}');
            },
            22562: (e)=>{
                "use strict";
                e.exports = JSON.parse('{"2.16.840.1.101.3.4.1.1":"aes-128-ecb","2.16.840.1.101.3.4.1.2":"aes-128-cbc","2.16.840.1.101.3.4.1.3":"aes-128-ofb","2.16.840.1.101.3.4.1.4":"aes-128-cfb","2.16.840.1.101.3.4.1.21":"aes-192-ecb","2.16.840.1.101.3.4.1.22":"aes-192-cbc","2.16.840.1.101.3.4.1.23":"aes-192-ofb","2.16.840.1.101.3.4.1.24":"aes-192-cfb","2.16.840.1.101.3.4.1.41":"aes-256-ecb","2.16.840.1.101.3.4.1.42":"aes-256-cbc","2.16.840.1.101.3.4.1.43":"aes-256-ofb","2.16.840.1.101.3.4.1.44":"aes-256-cfb"}');
            },
            19794: (e)=>{
                "use strict";
                e.exports = {
                    version: "1.0.34"
                };
            },
            78920: (e)=>{
                "use strict";
                e.exports = {
                    i8: "1.10.4"
                };
            }
        }, t = {};
        function r(n) {
            var i = t[n];
            if (void 0 !== i) return i.exports;
            var o = t[n] = {
                id: n,
                loaded: !1,
                exports: {}
            };
            return e[n](o, o.exports, r), o.loaded = !0, o.exports;
        }
        return r.amdO = {}, r.g = function() {
            if ("object" == typeof globalThis) return globalThis;
            try {
                return this || new Function("return this")();
            } catch (e) {
                if ("object" == typeof window) return window;
            }
        }(), r.nmd = (e)=>(e.paths = [], e.children || (e.children = []), e), r(17001);
    })());

},{}],"8zppS":[function() {},{}],"be8H8":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createAlchemyWeb3", ()=>createAlchemyWeb3);
var _tslib = require("tslib");
var _web3 = require("web3");
var _web3Default = parcelHelpers.interopDefault(_web3);
var _web3CoreSubscriptions = require("web3-core-subscriptions");
var _web3CoreSubscriptionsDefault = parcelHelpers.interopDefault(_web3CoreSubscriptions);
var _web3EthAbi = require("web3-eth-abi");
var _web3EthAbiDefault = parcelHelpers.interopDefault(_web3EthAbi);
var _web3Utils = require("web3-utils");
var _hex = require("./util/hex");
var _promises = require("./util/promises");
var _alchemyContext = require("./web3-adapter/alchemyContext");
var _customRPC = require("./web3-adapter/customRPC");
var _ethMaxPriorityFeePerGas = require("./web3-adapter/eth_maxPriorityFeePerGas");
var _ethPrivateTransactions = require("./web3-adapter/eth_PrivateTransactions");
var _types = require("./alchemy-apis/types");
parcelHelpers.exportAll(_types, exports);
var DEFAULT_MAX_RETRIES = 3;
var DEFAULT_RETRY_INTERVAL = 1000;
var DEFAULT_RETRY_JITTER = 250;
var DEFAULT_CONTRACT_ADDRESS = "DEFAULT_TOKENS";
function createAlchemyWeb3(alchemyUrl, config) {
    var fullConfig = fillInConfigDefaults(config);
    var _a = (0, _alchemyContext.makeAlchemyContext)(alchemyUrl, fullConfig), provider = _a.provider, jsonRpcSenders = _a.jsonRpcSenders, restSender = _a.restSender, setWriteProvider = _a.setWriteProvider;
    var alchemyWeb3 = new (0, _web3Default.default)(provider);
    alchemyWeb3.setProvider = function() {
        throw new Error("setProvider is not supported in Alchemy Web3. To change the provider used for writes, use setWriteProvider() instead.");
    };
    alchemyWeb3.setWriteProvider = setWriteProvider;
    function getNfts(params, callback) {
        return callAlchemyRestEndpoint({
            restSender: restSender,
            callback: callback,
            params: params,
            path: "getNFTs"
        });
    }
    alchemyWeb3.alchemy = {
        getTokenAllowance: function(params, callback) {
            return callAlchemyJsonRpcMethod({
                jsonRpcSenders: jsonRpcSenders,
                callback: callback,
                method: "alchemy_getTokenAllowance",
                params: [
                    params
                ]
            });
        },
        getTokenBalances: function(address, contractAddresses, callback) {
            return callAlchemyJsonRpcMethod({
                jsonRpcSenders: jsonRpcSenders,
                callback: callback,
                method: "alchemy_getTokenBalances",
                params: [
                    address,
                    contractAddresses || DEFAULT_CONTRACT_ADDRESS
                ],
                processResponse: processTokenBalanceResponse
            });
        },
        getTokenMetadata: function(address, callback) {
            return callAlchemyJsonRpcMethod({
                jsonRpcSenders: jsonRpcSenders,
                callback: callback,
                params: [
                    address
                ],
                method: "alchemy_getTokenMetadata"
            });
        },
        getAssetTransfers: function(params, callback) {
            return callAlchemyJsonRpcMethod({
                jsonRpcSenders: jsonRpcSenders,
                callback: callback,
                params: [
                    (0, _tslib.__assign)((0, _tslib.__assign)({}, params), {
                        fromBlock: params.fromBlock != null ? (0, _hex.formatBlock)(params.fromBlock) : undefined,
                        toBlock: params.toBlock != null ? (0, _hex.formatBlock)(params.toBlock) : undefined,
                        maxCount: params.maxCount != null ? (0, _web3Utils.toHex)(params.maxCount) : undefined
                    })
                ],
                method: "alchemy_getAssetTransfers"
            });
        },
        getNftMetadata: function(params, callback) {
            return callAlchemyRestEndpoint({
                restSender: restSender,
                callback: callback,
                params: params,
                path: "getNFTMetadata"
            });
        },
        getNfts: getNfts,
        getTransactionReceipts: function(params, callback) {
            return callAlchemyJsonRpcMethod({
                jsonRpcSenders: jsonRpcSenders,
                callback: callback,
                method: "alchemy_getTransactionReceipts",
                params: [
                    params
                ]
            });
        }
    };
    patchSubscriptions(alchemyWeb3);
    (0, _customRPC.patchEnableCustomRPC)(alchemyWeb3);
    (0, _ethMaxPriorityFeePerGas.patchEthMaxPriorityFeePerGasMethod)(alchemyWeb3);
    (0, _ethPrivateTransactions.patchEthPrivateTransactionMethods)(alchemyWeb3);
    return alchemyWeb3;
}
function fillInConfigDefaults(_a) {
    var _b = _a === void 0 ? {} : _a, _c = _b.writeProvider, writeProvider = _c === void 0 ? getWindowProvider() : _c, _d = _b.jsonRpcSenderMiddlewares, jsonRpcSenderMiddlewares = _d === void 0 ? [] : _d, _e = _b.maxRetries, maxRetries = _e === void 0 ? DEFAULT_MAX_RETRIES : _e, _f = _b.retryInterval, retryInterval = _f === void 0 ? DEFAULT_RETRY_INTERVAL : _f, _g = _b.retryJitter, retryJitter = _g === void 0 ? DEFAULT_RETRY_JITTER : _g;
    return {
        writeProvider: writeProvider,
        jsonRpcSenderMiddlewares: jsonRpcSenderMiddlewares,
        maxRetries: maxRetries,
        retryInterval: retryInterval,
        retryJitter: retryJitter
    };
}
function getWindowProvider() {
    return typeof window !== "undefined" ? window.ethereum : null;
}
function callAlchemyJsonRpcMethod(_a) {
    var _this = this;
    var jsonRpcSenders = _a.jsonRpcSenders, method = _a.method, params = _a.params, _b = _a.callback, callback = _b === void 0 ? noop : _b, _c = _a.processResponse, processResponse = _c === void 0 ? identity : _c;
    var promise = function() {
        return (0, _tslib.__awaiter)(_this, void 0, void 0, function() {
            var result;
            return (0, _tslib.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            jsonRpcSenders.send(method, params)
                        ];
                    case 1:
                        result = _a.sent();
                        return [
                            2 /*return*/ ,
                            processResponse(result)
                        ];
                }
            });
        });
    }();
    (0, _promises.callWhenDone)(promise, callback);
    return promise;
}
function callAlchemyRestEndpoint(_a) {
    var _this = this;
    var restSender = _a.restSender, path = _a.path, params = _a.params, _b = _a.callback, callback = _b === void 0 ? noop : _b, _c = _a.processResponse, processResponse = _c === void 0 ? identity : _c;
    var fixedParams = fixArrayQueryParams(params);
    var promise = function() {
        return (0, _tslib.__awaiter)(_this, void 0, void 0, function() {
            var result;
            return (0, _tslib.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            restSender.sendRestPayload(path, fixedParams)
                        ];
                    case 1:
                        result = _a.sent();
                        return [
                            2 /*return*/ ,
                            processResponse(result)
                        ];
                }
            });
        });
    }();
    (0, _promises.callWhenDone)(promise, callback);
    return promise;
}
function processTokenBalanceResponse(rawResponse) {
    // Convert token balance fields from hex-string to decimal-string.
    var fixedTokenBalances = rawResponse.tokenBalances.map(function(balance) {
        return balance.tokenBalance != null ? (0, _tslib.__assign)((0, _tslib.__assign)({}, balance), {
            tokenBalance: (0, _web3EthAbiDefault.default).decodeParameter("uint256", balance.tokenBalance)
        }) : balance;
    });
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, rawResponse), {
        tokenBalances: fixedTokenBalances
    });
}
/**
 * Updates Web3's internal subscription architecture to also handle Alchemy
 * specific subscriptions. This is to handle alternate namings of the existing
 * subscription endpoints, but the officially documented interfaces are
 * specified in the AlchemyEth interface.
 */ function patchSubscriptions(web3) {
    var eth = web3.eth;
    var oldSubscribe = eth.subscribe.bind(eth);
    eth.subscribe = function(type) {
        var rest = [];
        for(var _i = 1; _i < arguments.length; _i++)rest[_i - 1] = arguments[_i];
        if (type === "alchemy_fullPendingTransactions" || type === "alchemy_newFullPendingTransactions") {
            console.warn("This method is now deprecated. Please use `alchemy_pendingTransactions` instead.");
            return suppressNoSubscriptionExistsWarning(function() {
                return oldSubscribe.apply(void 0, (0, _tslib.__spreadArray)([
                    "alchemy_newFullPendingTransactions"
                ], (0, _tslib.__read)(rest)));
            });
        }
        if (type === "alchemy_filteredNewFullPendingTransactions" || type === "alchemy_filteredPendingTransactions" || type === "alchemy_filteredFullPendingTransactions") {
            console.warn("This method is now deprecated. Please use `alchemy_pendingTransactions` instead.");
            return suppressNoSubscriptionExistsWarning(function() {
                return oldSubscribe.apply(void 0, (0, _tslib.__spreadArray)([
                    "alchemy_filteredNewFullPendingTransactions"
                ], (0, _tslib.__read)(rest)));
            });
        }
        if (type === "alchemy_pendingTransactions") return suppressNoSubscriptionExistsWarning(function() {
            return oldSubscribe.apply(void 0, (0, _tslib.__spreadArray)([
                "alchemy_pendingTransactions"
            ], (0, _tslib.__read)(rest)));
        });
        return oldSubscribe.apply(void 0, (0, _tslib.__spreadArray)([
            type
        ], (0, _tslib.__read)(rest)));
    };
}
/**
 * VERY hacky wrapper to suppress a spurious warning when subscribing to an
 * Alchemy subscription that isn't built into Web3.
 */ function suppressNoSubscriptionExistsWarning(f) {
    var oldConsoleWarn = console.warn;
    console.warn = function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        if (typeof args[0] === "string" && args[0].includes(" doesn't exist. Subscribing anyway.")) return;
        return oldConsoleWarn.apply(console, args);
    };
    try {
        return f();
    } finally{
        console.warn = oldConsoleWarn;
    }
}
/**
 * Another VERY hacky monkeypatch to make sure that we can take extra parameters to certain alchemy subscriptions
 * I hate doing this, but the other option is to fork web3-core and I think for now this is better
 */ var subscription = (0, _web3CoreSubscriptionsDefault.default).subscription;
var oldSubscriptionPrototypeValidateArgs = subscription.prototype._validateArgs;
subscription.prototype._validateArgs = function(args) {
    if ([
        "alchemy_filteredNewFullPendingTransactions",
        "alchemy_filteredPendingTransactions",
        "alchemy_filteredFullPendingTransactions",
        "alchemy_pendingTransactions"
    ].includes(this.subscriptionMethod)) ;
    else {
        if ([
            "alchemy_fullPendingTransactions",
            "alchemy_newFullPendingTransactions"
        ].includes(this.subscriptionMethod)) {
            if (this.options.subscription) this.options.subscription.subscriptionName = this.subscriptionMethod;
        }
        var validator = oldSubscriptionPrototypeValidateArgs.bind(this);
        validator(args);
    }
};
function noop() {
// Nothing.
}
function identity(x) {
    return x;
}
/**
 * Alchemy's APIs receive multivalued params via keys with `[]` at the end.
 * Update any query params whose values are arrays to match this convention.
 */ function fixArrayQueryParams(params) {
    var result = {};
    Object.keys(params).forEach(function(key) {
        var value = params[key];
        var fixedKey = Array.isArray(value) ? toArrayKey(key) : key;
        result[fixedKey] = value;
    });
    return result;
}
function toArrayKey(key) {
    return endsWith(key, "[]") ? key : key + "[]";
}
/**
 * Like `String#endsWith`, for older environments.
 */ function endsWith(s, ending) {
    var index = s.lastIndexOf(ending);
    return index >= 0 && index === s.length - ending.length;
}

},{"tslib":"gBS4y","web3":"hK09n","web3-core-subscriptions":"393J3","web3-eth-abi":"bZHib","web3-utils":"ePzmI","./util/hex":"2yu6A","./util/promises":"03X3y","./web3-adapter/alchemyContext":"4vthg","./web3-adapter/customRPC":"5Xqsx","./web3-adapter/eth_maxPriorityFeePerGas":"6ZCUT","./web3-adapter/eth_PrivateTransactions":"6YomP","./alchemy-apis/types":false,"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"gBS4y":[function(require,module,exports) {
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol, Iterator */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__extends", ()=>__extends);
parcelHelpers.export(exports, "__assign", ()=>__assign);
parcelHelpers.export(exports, "__rest", ()=>__rest);
parcelHelpers.export(exports, "__decorate", ()=>__decorate);
parcelHelpers.export(exports, "__param", ()=>__param);
parcelHelpers.export(exports, "__esDecorate", ()=>__esDecorate);
parcelHelpers.export(exports, "__runInitializers", ()=>__runInitializers);
parcelHelpers.export(exports, "__propKey", ()=>__propKey);
parcelHelpers.export(exports, "__setFunctionName", ()=>__setFunctionName);
parcelHelpers.export(exports, "__metadata", ()=>__metadata);
parcelHelpers.export(exports, "__awaiter", ()=>__awaiter);
parcelHelpers.export(exports, "__generator", ()=>__generator);
parcelHelpers.export(exports, "__createBinding", ()=>__createBinding);
parcelHelpers.export(exports, "__exportStar", ()=>__exportStar);
parcelHelpers.export(exports, "__values", ()=>__values);
parcelHelpers.export(exports, "__read", ()=>__read);
/** @deprecated */ parcelHelpers.export(exports, "__spread", ()=>__spread);
/** @deprecated */ parcelHelpers.export(exports, "__spreadArrays", ()=>__spreadArrays);
parcelHelpers.export(exports, "__spreadArray", ()=>__spreadArray);
parcelHelpers.export(exports, "__await", ()=>__await);
parcelHelpers.export(exports, "__asyncGenerator", ()=>__asyncGenerator);
parcelHelpers.export(exports, "__asyncDelegator", ()=>__asyncDelegator);
parcelHelpers.export(exports, "__asyncValues", ()=>__asyncValues);
parcelHelpers.export(exports, "__makeTemplateObject", ()=>__makeTemplateObject);
parcelHelpers.export(exports, "__importStar", ()=>__importStar);
parcelHelpers.export(exports, "__importDefault", ()=>__importDefault);
parcelHelpers.export(exports, "__classPrivateFieldGet", ()=>__classPrivateFieldGet);
parcelHelpers.export(exports, "__classPrivateFieldSet", ()=>__classPrivateFieldSet);
parcelHelpers.export(exports, "__classPrivateFieldIn", ()=>__classPrivateFieldIn);
parcelHelpers.export(exports, "__addDisposableResource", ()=>__addDisposableResource);
parcelHelpers.export(exports, "__disposeResources", ()=>__disposeResources);
var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return extendStatics(d, b);
};
function __extends(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
function __rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function __param(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function __esDecorate(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function __runInitializers(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function __propKey(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function __setFunctionName(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function __generator(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var __createBinding = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function __exportStar(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) __createBinding(o, m, p);
}
function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function __spread() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat(__read(arguments[i]));
    return ar;
}
function __spreadArrays() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function __spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}
function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = Object.create((typeof AsyncIterator === "function" ? AsyncIterator : Object).prototype), verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function awaitReturn(f) {
        return function(v) {
            return Promise.resolve(v).then(f, reject);
        };
    }
    function verb(n, f) {
        if (g[n]) {
            i[n] = function(v) {
                return new Promise(function(a, b) {
                    q.push([
                        n,
                        v,
                        a,
                        b
                    ]) > 1 || resume(n, v);
                });
            };
            if (f) i[n] = f(i[n]);
        }
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: __await(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var __setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    }
    __setModuleDefault(result, mod);
    return result;
}
function __importDefault(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function __classPrivateFieldGet(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function __classPrivateFieldSet(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function __classPrivateFieldIn(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function __addDisposableResource(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose, inner;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
            if (async) inner = dispose;
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        if (inner) dispose = function() {
            try {
                inner.call(this);
            } catch (e) {
                return Promise.reject(e);
            }
        };
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var _SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function __disposeResources(env) {
    function fail(e) {
        env.error = env.hasError ? new _SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    var r, s = 0;
    function next() {
        while(r = env.stack.pop())try {
            if (!r.async && s === 1) return s = 0, env.stack.push(r), Promise.resolve().then(next);
            if (r.dispose) {
                var result = r.dispose.call(r.value);
                if (r.async) return s |= 2, Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } else s |= 1;
        } catch (e) {
            fail(e);
        }
        if (s === 1) return env.hasError ? Promise.reject(env.error) : Promise.resolve();
        if (env.hasError) throw env.error;
    }
    return next();
}
exports.default = {
    __extends: __extends,
    __assign: __assign,
    __rest: __rest,
    __decorate: __decorate,
    __param: __param,
    __metadata: __metadata,
    __awaiter: __awaiter,
    __generator: __generator,
    __createBinding: __createBinding,
    __exportStar: __exportStar,
    __values: __values,
    __read: __read,
    __spread: __spread,
    __spreadArrays: __spreadArrays,
    __spreadArray: __spreadArray,
    __await: __await,
    __asyncGenerator: __asyncGenerator,
    __asyncDelegator: __asyncDelegator,
    __asyncValues: __asyncValues,
    __makeTemplateObject: __makeTemplateObject,
    __importStar: __importStar,
    __importDefault: __importDefault,
    __classPrivateFieldGet: __classPrivateFieldGet,
    __classPrivateFieldSet: __classPrivateFieldSet,
    __classPrivateFieldIn: __classPrivateFieldIn,
    __addDisposableResource: __addDisposableResource,
    __disposeResources: __disposeResources
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"393J3":[function(require,module,exports) {
/*
    This file is part of web3.js.

    web3.js is free software: you can redistribute it and/or modify
    it under the terms of the GNU Lesser General Public License as published by
    the Free Software Foundation, either version 3 of the License, or
    (at your option) any later version.

    web3.js is distributed in the hope that it will be useful,
    but WITHOUT ANY WARRANTY; without even the implied warranty of
    MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
    GNU Lesser General Public License for more details.

    You should have received a copy of the GNU Lesser General Public License
    along with web3.js.  If not, see <http://www.gnu.org/licenses/>.
*/ /**
 * @file index.js
 * @author Fabian Vogelsteller <fabian@ethereum.org>
 * @date 2017
 */ "use strict";
var Subscription = require("62b141585fd65c0f");
var Subscriptions = function Subscriptions(options) {
    this.name = options.name;
    this.type = options.type;
    this.subscriptions = options.subscriptions || {};
    this.requestManager = null;
};
Subscriptions.prototype.setRequestManager = function(rm) {
    this.requestManager = rm;
};
Subscriptions.prototype.attachToObject = function(obj) {
    var func = this.buildCall();
    var name = this.name.split(".");
    if (name.length > 1) {
        obj[name[0]] = obj[name[0]] || {};
        obj[name[0]][name[1]] = func;
    } else obj[name[0]] = func;
};
Subscriptions.prototype.buildCall = function() {
    var _this = this;
    return function() {
        if (!_this.subscriptions[arguments[0]]) console.warn("Subscription " + JSON.stringify(arguments[0]) + " doesn't exist. Subscribing anyway.");
        var subscription = new Subscription({
            subscription: _this.subscriptions[arguments[0]] || {},
            requestManager: _this.requestManager,
            type: _this.type
        });
        return subscription.subscribe.apply(subscription, arguments);
    };
};
module.exports = {
    subscriptions: Subscriptions,
    subscription: Subscription
};

},{"62b141585fd65c0f":"96O5M"}],"96O5M":[function(require,module,exports) {
/*
    This file is part of web3.js.

    web3.js is free software: you can redistribute it and/or modify
    it under the terms of the GNU Lesser General Public License as published by
    the Free Software Foundation, either version 3 of the License, or
    (at your option) any later version.

    web3.js is distributed in the hope that it will be useful,
    but WITHOUT ANY WARRANTY; without even the implied warranty of
    MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
    GNU Lesser General Public License for more details.

    You should have received a copy of the GNU Lesser General Public License
    along with web3.js.  If not, see <http://www.gnu.org/licenses/>.
*/ /**
 * @file subscription.js
 * @author Fabian Vogelsteller <fabian@ethereum.org>
 * @date 2017
 */ "use strict";
var errors = require("21e3cd9a5df2ffb8").errors;
var EventEmitter = require("e6c311d60e882f52");
var formatters = require("21e3cd9a5df2ffb8").formatters;
function identity(value) {
    return value;
}
function Subscription(options) {
    EventEmitter.call(this);
    this.id = null;
    this.callback = identity;
    this.arguments = null;
    this.lastBlock = null; // "from" block tracker for backfilling events on reconnection
    this.options = {
        subscription: options.subscription,
        type: options.type,
        requestManager: options.requestManager
    };
}
// INHERIT
Subscription.prototype = Object.create(EventEmitter.prototype);
Subscription.prototype.constructor = Subscription;
/**
 * Should be used to extract callback from array of arguments. Modifies input param
 *
 * @method extractCallback
 * @param {Array} arguments
 * @return {Function|Null} callback, if exists
 */ Subscription.prototype._extractCallback = function(args) {
    if (typeof args[args.length - 1] === "function") return args.pop(); // modify the args array!
};
/**
 * Should be called to check if the number of arguments is correct
 *
 * @method validateArgs
 * @param {Array} arguments
 * @throws {Error} if it is not
 */ Subscription.prototype._validateArgs = function(args) {
    var subscription = this.options.subscription;
    if (!subscription) subscription = {};
    if (!subscription.params) subscription.params = 0;
    if (args.length !== subscription.params) throw errors.InvalidNumberOfParams(args.length, subscription.params, subscription.subscriptionName);
};
/**
 * Should be called to format input args of method
 *
 * @method formatInput
 * @param {Array}
 * @return {Array}
 */ Subscription.prototype._formatInput = function(args) {
    var subscription = this.options.subscription;
    if (!subscription) return args;
    if (!subscription.inputFormatter) return args;
    var formattedArgs = subscription.inputFormatter.map(function(formatter, index) {
        return formatter ? formatter(args[index]) : args[index];
    });
    return formattedArgs;
};
/**
 * Should be called to format output(result) of method
 *
 * @method formatOutput
 * @param result {Object}
 * @return {Object}
 */ Subscription.prototype._formatOutput = function(result) {
    var subscription = this.options.subscription;
    return subscription && subscription.outputFormatter && result ? subscription.outputFormatter(result) : result;
};
/**
 * Should create payload from given input args
 *
 * @method toPayload
 * @param {Array} args
 * @return {Object}
 */ Subscription.prototype._toPayload = function(args) {
    var params = [];
    this.callback = this._extractCallback(args) || identity;
    if (!this.subscriptionMethod) {
        this.subscriptionMethod = args.shift();
        // replace subscription with given name
        if (this.options.subscription.subscriptionName) this.subscriptionMethod = this.options.subscription.subscriptionName;
    }
    if (!this.arguments) {
        this.arguments = this._formatInput(args);
        this._validateArgs(this.arguments);
        args = []; // make empty after validation
    }
    // re-add subscriptionName
    params.push(this.subscriptionMethod);
    params = params.concat(this.arguments);
    if (args.length) throw new Error("Only a callback is allowed as parameter on an already instantiated subscription.");
    return {
        method: this.options.type + "_subscribe",
        params: params
    };
};
/**
 * Unsubscribes and clears callbacks
 *
 * @method unsubscribe
 * @return {Object}
 */ Subscription.prototype.unsubscribe = function(callback) {
    this.options.requestManager.removeSubscription(this.id, callback);
    this.id = null;
    this.lastBlock = null;
    this.removeAllListeners();
};
/**
 * Subscribes and watches for changes
 *
 * @method subscribe
 * @param {String} subscription the subscription
 * @param {Object} options the options object with address topics and fromBlock
 * @return {Object}
 */ Subscription.prototype.subscribe = function() {
    var _this = this;
    var args = Array.prototype.slice.call(arguments);
    var payload = this._toPayload(args);
    if (!payload) return this;
    // throw error, if provider is not set
    if (!this.options.requestManager.provider) {
        setTimeout(function() {
            var err1 = new Error("No provider set.");
            _this.callback(err1, null, _this);
            _this.emit("error", err1);
        }, 0);
        return this;
    }
    // throw error, if provider doesnt support subscriptions
    if (!this.options.requestManager.provider.on) {
        setTimeout(function() {
            var err2 = new Error("The current provider doesn't support subscriptions: " + _this.options.requestManager.provider.constructor.name);
            _this.callback(err2, null, _this);
            _this.emit("error", err2);
        }, 0);
        return this;
    }
    // Re-subscription only: continue fetching from the last block we received.
    // a dropped connection may have resulted in gaps in the logs...
    if (this.lastBlock && !!this.options.params && typeof this.options.params === "object") {
        payload.params[1] = this.options.params;
        payload.params[1].fromBlock = formatters.inputBlockNumberFormatter(this.lastBlock + 1);
    }
    // if id is there unsubscribe first
    if (this.id) this.unsubscribe();
    // store the params in the options object
    this.options.params = payload.params[1];
    // get past logs, if fromBlock is available
    if (payload.params[0] === "logs" && !!payload.params[1] && typeof payload.params[1] === "object" && payload.params[1].hasOwnProperty("fromBlock") && isFinite(payload.params[1].fromBlock)) {
        // send the subscription request
        // copy the params to avoid race-condition with deletion below this block
        var blockParams = Object.assign({}, payload.params[1]);
        this.options.requestManager.send({
            method: "eth_getLogs",
            params: [
                blockParams
            ]
        }, function(err, logs) {
            if (!err) logs.forEach(function(log) {
                var output = _this._formatOutput(log);
                _this.callback(null, output, _this);
                _this.emit("data", output);
            });
            else setTimeout(function() {
                _this.callback(err, null, _this);
                _this.emit("error", err);
            }, 0);
        });
    }
    // create subscription
    // TODO move to separate function? so that past logs can go first?
    if (typeof payload.params[1] === "object") delete payload.params[1].fromBlock;
    this.options.requestManager.send(payload, function(err, result) {
        if (!err && result) {
            _this.id = result;
            _this.method = payload.params[0];
            // call callback on notifications
            _this.options.requestManager.addSubscription(_this, function(error, result) {
                if (!error) {
                    if (!Array.isArray(result)) result = [
                        result
                    ];
                    result.forEach(function(resultItem) {
                        var output = _this._formatOutput(resultItem);
                        // Track current block (for gaps introduced by dropped connections)
                        _this.lastBlock = !!output && typeof output === "object" ? output.blockNumber : null;
                        if (typeof _this.options.subscription.subscriptionHandler === "function") return _this.options.subscription.subscriptionHandler.call(_this, output);
                        else _this.emit("data", output);
                        // call the callback, last so that unsubscribe there won't affect the emit above
                        _this.callback(null, output, _this);
                    });
                } else {
                    _this.callback(error, false, _this);
                    _this.emit("error", error);
                }
            });
            _this.emit("connected", result);
        } else setTimeout(function() {
            _this.callback(err, false, _this);
            _this.emit("error", err);
        }, 0);
    });
    // return an object to cancel the subscription
    return this;
};
/**
 * Resubscribe
 *
 * @method resubscribe
 *
 * @returns {void}
 */ Subscription.prototype.resubscribe = function() {
    this.options.requestManager.removeSubscription(this.id); // unsubscribe
    this.id = null;
    this.subscribe(this.callback);
};
module.exports = Subscription;

},{"21e3cd9a5df2ffb8":"9k0nb","e6c311d60e882f52":"3FCDz"}],"9k0nb":[function(require,module,exports) {
/*
    This file is part of web3.js.

    web3.js is free software: you can redistribute it and/or modify
    it under the terms of the GNU Lesser General Public License as published by
    the Free Software Foundation, either version 3 of the License, or
    (at your option) any later version.

    web3.js is distributed in the hope that it will be useful,
    but WITHOUT ANY WARRANTY; without even the implied warranty of
    MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
    GNU Lesser General Public License for more details.

    You should have received a copy of the GNU Lesser General Public License
    along with web3.js.  If not, see <http://www.gnu.org/licenses/>.
*/ /**
 * @file index.js
 * @author Fabian Vogelsteller <fabian@ethereum.org>
 * @date 2017
 */ "use strict";
var errors = require("5315b85d79dd4ab2");
var formatters = require("40de1668a9e36329");
module.exports = {
    errors: errors,
    formatters: formatters
};

},{"5315b85d79dd4ab2":"6Ak66","40de1668a9e36329":"eoqQa"}],"6Ak66":[function(require,module,exports) {
/*
    This file is part of web3.js.

    web3.js is free software: you can redistribute it and/or modify
    it under the terms of the GNU Lesser General Public License as published by
    the Free Software Foundation, either version 3 of the License, or
    (at your option) any later version.

    web3.js is distributed in the hope that it will be useful,
    but WITHOUT ANY WARRANTY; without even the implied warranty of
    MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
    GNU Lesser General Public License for more details.

    You should have received a copy of the GNU Lesser General Public License
    along with web3.js.  If not, see <http://www.gnu.org/licenses/>.
*/ /**
 * @file errors.js
 * @author Fabian Vogelsteller <fabian@ethereum.org>
 * @author Marek Kotewicz <marek@parity.io>
 * @date 2017
 */ "use strict";
module.exports = {
    ErrorResponse: function(result) {
        var message = !!result && !!result.error && !!result.error.message ? result.error.message : JSON.stringify(result);
        var data = !!result.error && !!result.error.data ? result.error.data : null;
        var err = new Error("Returned error: " + message);
        err.data = data;
        return err;
    },
    InvalidNumberOfParams: function(got, expected, method) {
        return new Error('Invalid number of parameters for "' + method + '". Got ' + got + " expected " + expected + "!");
    },
    InvalidConnection: function(host, event) {
        return this.ConnectionError("CONNECTION ERROR: Couldn't connect to node " + host + ".", event);
    },
    InvalidProvider: function() {
        return new Error("Provider not set or invalid");
    },
    InvalidResponse: function(result) {
        var message = !!result && !!result.error && !!result.error.message ? result.error.message : "Invalid JSON RPC response: " + JSON.stringify(result);
        return new Error(message);
    },
    ConnectionTimeout: function(ms) {
        return new Error("CONNECTION TIMEOUT: timeout of " + ms + " ms achived");
    },
    ConnectionNotOpenError: function(event) {
        return this.ConnectionError("connection not open on send()", event);
    },
    ConnectionCloseError: function(event) {
        if (typeof event === "object" && event.code && event.reason) return this.ConnectionError("CONNECTION ERROR: The connection got closed with the close code `" + event.code + "` and the following " + "reason string `" + event.reason + "`", event);
        return new Error("CONNECTION ERROR: The connection closed unexpectedly");
    },
    MaxAttemptsReachedOnReconnectingError: function() {
        return new Error("Maximum number of reconnect attempts reached!");
    },
    PendingRequestsOnReconnectingError: function() {
        return new Error("CONNECTION ERROR: Provider started to reconnect before the response got received!");
    },
    ConnectionError: function(msg, event) {
        const error = new Error(msg);
        if (event) {
            error.code = event.code;
            error.reason = event.reason;
            if (event.description) error.description = event.description;
        }
        return error;
    },
    RevertInstructionError: function(reason, signature) {
        var error = new Error("Your request got reverted with the following reason string: " + reason);
        error.reason = reason;
        error.signature = signature;
        return error;
    },
    TransactionRevertInstructionError: function(reason, signature, receipt) {
        var error = new Error("Transaction has been reverted by the EVM:\n" + JSON.stringify(receipt, null, 2));
        error.reason = reason;
        error.signature = signature;
        error.receipt = receipt;
        return error;
    },
    TransactionError: function(message, receipt) {
        var error = new Error(message);
        error.receipt = receipt;
        return error;
    },
    NoContractAddressFoundError: function(receipt) {
        return this.TransactionError("The transaction receipt didn't contain a contract address.", receipt);
    },
    ContractCodeNotStoredError: function(receipt) {
        return this.TransactionError("The contract code couldn't be stored, please check your gas limit.", receipt);
    },
    TransactionRevertedWithoutReasonError: function(receipt) {
        return this.TransactionError("Transaction has been reverted by the EVM:\n" + JSON.stringify(receipt, null, 2), receipt);
    },
    TransactionOutOfGasError: function(receipt) {
        return this.TransactionError("Transaction ran out of gas. Please provide more gas:\n" + JSON.stringify(receipt, null, 2), receipt);
    },
    ResolverMethodMissingError: function(address, name) {
        return new Error("The resolver at " + address + 'does not implement requested method: "' + name + '".');
    },
    ContractMissingABIError: function() {
        return new Error("You must provide the json interface of the contract when instantiating a contract object.");
    },
    ContractOnceRequiresCallbackError: function() {
        return new Error("Once requires a callback as the second parameter.");
    },
    ContractEventDoesNotExistError: function(eventName) {
        return new Error('Event "' + eventName + "\" doesn't exist in this contract.");
    },
    ContractReservedEventError: function(type) {
        return new Error('The event "' + type + "\" is a reserved event name, you can't use it.");
    },
    ContractMissingDeployDataError: function() {
        return new Error('No "data" specified in neither the given options, nor the default options.');
    },
    ContractNoAddressDefinedError: function() {
        return new Error("This contract object doesn't have address set yet, please set an address first.");
    },
    ContractNoFromAddressDefinedError: function() {
        return new Error('No "from" address specified in neither the given options, nor the default options.');
    }
};

},{}],"eoqQa":[function(require,module,exports) {
/*
    This file is part of web3.js.

    web3.js is free software: you can redistribute it and/or modify
    it under the terms of the GNU Lesser General Public License as published by
    the Free Software Foundation, either version 3 of the License, or
    (at your option) any later version.

    web3.js is distributed in the hope that it will be useful,
    but WITHOUT ANY WARRANTY; without even the implied warranty of
    MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
    GNU Lesser General Public License for more details.

    You should have received a copy of the GNU Lesser General Public License
    along with web3.js.  If not, see <http://www.gnu.org/licenses/>.
*/ /**
 * @file formatters.js
 * @author Fabian Vogelsteller <fabian@ethereum.org>
 * @author Marek Kotewicz <marek@parity.io>
 * @date 2017
 */ "use strict";
var utils = require("a91162e868a295f2");
var Iban = require("602e20045b7026b");
/**
 * Will format the given storage key array values to hex strings.
 *
 * @method inputStorageKeysFormatter
 *
 * @param {Array<Number|String|BN|BigNumber>} keys
 *
 * @returns {Array<String>}
 */ var inputStorageKeysFormatter = function(keys) {
    return keys.map(utils.numberToHex);
};
/**
 * Will format the given proof response from the node.
 *
 * @method outputProofFormatter
 *
 * @param {object} proof
 *
 * @returns {object}
 */ var outputProofFormatter = function(proof) {
    proof.address = utils.toChecksumAddress(proof.address);
    proof.nonce = utils.hexToNumberString(proof.nonce);
    proof.balance = utils.hexToNumberString(proof.balance);
    return proof;
};
/**
 * Should the format output to a big number
 *
 * @method outputBigNumberFormatter
 *
 * @param {String|Number|BigNumber|BN} number
 *
 * @returns {BN} object
 */ var outputBigNumberFormatter = function(number) {
    return utils.toBN(number).toString(10);
};
/**
 * Returns true if the given blockNumber is 'latest', 'pending', 'earliest, 'finalized' or 'safe'
 *
 * @method isPredefinedBlockNumber
 *
 * @param {String} blockNumber
 *
 * @returns {Boolean}
 */ var isPredefinedBlockNumber = function(blockNumber) {
    return [
        "latest",
        "pending",
        "earliest",
        "finalized",
        "safe"
    ].includes(blockNumber);
};
/**
 * Returns the given block number as hex string or does return the defaultBlock property of the current module
 *
 * @method inputDefaultBlockNumberFormatter
 *
 * @param {String|Number|BN|BigNumber} blockNumber
 *
 * @returns {String}
 */ var inputDefaultBlockNumberFormatter = function(blockNumber) {
    if (this && (blockNumber === undefined || blockNumber === null)) return inputBlockNumberFormatter(this.defaultBlock);
    return inputBlockNumberFormatter(blockNumber);
};
/**
 * Returns the given block number as hex string or the predefined block number 'latest', 'pending', 'earliest', 'finalized', 'safe', 'genesis'
 *
 * @param {String|Number|BN|BigNumber} blockNumber
 *
 * @returns {String}
 */ var inputBlockNumberFormatter = function(blockNumber) {
    if (blockNumber === undefined) return undefined;
    if (isPredefinedBlockNumber(blockNumber)) return blockNumber;
    if (blockNumber === "genesis") return "0x0";
    return utils.isHexStrict(blockNumber) ? typeof blockNumber === "string" ? blockNumber.toLowerCase() : blockNumber : utils.numberToHex(blockNumber);
};
/**
 * Formats the input of a transaction and converts all values to HEX
 *
 * @method _txInputFormatter
 * @param {Object} transaction options
 * @returns object
 */ var _txInputFormatter = function(options) {
    if (options.to) options.to = inputAddressFormatter(options.to);
    if (options.data && options.input) throw new Error('You can\'t have "data" and "input" as properties of transactions at the same time, please use either "data" or "input" instead.');
    if (!options.data && options.input) {
        options.data = options.input;
        delete options.input;
    }
    if (options.data && !options.data.startsWith("0x")) options.data = "0x" + options.data;
    if (options.data && !utils.isHex(options.data)) throw new Error("The data field must be HEX encoded data.");
    // allow both
    if (options.gas || options.gasLimit) options.gas = options.gas || options.gasLimit;
    if (options.maxPriorityFeePerGas || options.maxFeePerGas) delete options.gasPrice;
    [
        "gasPrice",
        "gas",
        "value",
        "maxPriorityFeePerGas",
        "maxFeePerGas",
        "nonce",
        "type"
    ].filter(function(key) {
        return options[key] !== undefined;
    }).forEach(function(key) {
        options[key] = utils.numberToHex(options[key]);
    });
    return options;
};
/**
 * Formats the input of a transaction and converts all values to HEX
 *
 * @method inputCallFormatter
 * @param {Object} transaction options
 * @returns object
 */ var inputCallFormatter = function(options) {
    options = _txInputFormatter(options);
    var from = options.from || (this ? this.defaultAccount : null);
    if (from) options.from = inputAddressFormatter(from);
    return options;
};
/**
 * Formats the input of a transaction and converts all values to HEX
 *
 * @method inputTransactionFormatter
 * @param {Object} options
 * @returns object
 */ var inputTransactionFormatter = function(options) {
    options = _txInputFormatter(options);
    // check from, only if not number, or object
    if (!(typeof options.from === "number") && !(!!options.from && typeof options.from === "object")) {
        options.from = options.from || (this ? this.defaultAccount : null);
        if (!options.from && !(typeof options.from === "number")) throw new Error('The send transactions "from" field must be defined!');
        options.from = inputAddressFormatter(options.from);
    }
    return options;
};
/**
 * Hex encodes the data passed to eth_sign and personal_sign
 *
 * @method inputSignFormatter
 * @param {String} data
 * @returns {String}
 */ var inputSignFormatter = function(data) {
    return utils.isHexStrict(data) ? data : utils.utf8ToHex(data);
};
/**
 * Formats the output of a transaction to its proper values
 *
 * @method outputTransactionFormatter
 * @param {Object} tx
 * @returns {Object}
 */ var outputTransactionFormatter = function(tx, hexFormat) {
    if (!hexFormat) {
        if (tx.blockNumber !== null) tx.blockNumber = utils.hexToNumber(tx.blockNumber);
        if (tx.transactionIndex !== null) tx.transactionIndex = utils.hexToNumber(tx.transactionIndex);
        tx.nonce = utils.hexToNumber(tx.nonce);
        tx.gas = utils.hexToNumber(tx.gas);
        if (tx.type) tx.type = utils.hexToNumber(tx.type);
    }
    if (tx.gasPrice) tx.gasPrice = outputBigNumberFormatter(tx.gasPrice);
    if (tx.maxFeePerGas) tx.maxFeePerGas = outputBigNumberFormatter(tx.maxFeePerGas);
    if (tx.maxPriorityFeePerGas) tx.maxPriorityFeePerGas = outputBigNumberFormatter(tx.maxPriorityFeePerGas);
    tx.value = outputBigNumberFormatter(tx.value);
    if (tx.to && utils.isAddress(tx.to)) tx.to = utils.toChecksumAddress(tx.to);
    else tx.to = null; // set to `null` if invalid address
    if (tx.from) tx.from = utils.toChecksumAddress(tx.from);
    return tx;
};
/**
 * Formats the output of a transaction receipt to its proper values
 *
 * @method outputTransactionReceiptFormatter
 * @param {Object} receipt
 * @returns {Object}
 */ var outputTransactionReceiptFormatter = function(receipt) {
    if (typeof receipt !== "object") throw new Error("Received receipt is invalid: " + receipt);
    if (!this.hexFormat) {
        if (receipt.blockNumber !== null) receipt.blockNumber = utils.hexToNumber(receipt.blockNumber);
        if (receipt.transactionIndex !== null) receipt.transactionIndex = utils.hexToNumber(receipt.transactionIndex);
        receipt.cumulativeGasUsed = utils.hexToNumber(receipt.cumulativeGasUsed);
        receipt.gasUsed = utils.hexToNumber(receipt.gasUsed);
        if (receipt.effectiveGasPrice) receipt.effectiveGasPrice = utils.hexToNumber(receipt.effectiveGasPrice);
    }
    if (Array.isArray(receipt.logs)) receipt.logs = receipt.logs.map(outputLogFormatter);
    if (receipt.contractAddress) receipt.contractAddress = utils.toChecksumAddress(receipt.contractAddress);
    if (typeof receipt.status !== "undefined" && receipt.status !== null) receipt.status = Boolean(parseInt(receipt.status));
    return receipt;
};
/**
 * Formats the output of a block to its proper values
 *
 * @method outputBlockFormatter
 * @param {Object} block
 * @returns {Object}
 */ var outputBlockFormatter = function(block, hexFormat) {
    if (!hexFormat) {
        // transform to number
        block.gasLimit = utils.hexToNumber(block.gasLimit);
        block.gasUsed = utils.hexToNumber(block.gasUsed);
        block.size = utils.hexToNumber(block.size);
        block.timestamp = utils.hexToNumber(block.timestamp);
        if (block.number !== null) block.number = utils.hexToNumber(block.number);
    }
    if (block.difficulty) block.difficulty = outputBigNumberFormatter(block.difficulty);
    if (block.totalDifficulty) block.totalDifficulty = outputBigNumberFormatter(block.totalDifficulty);
    if (Array.isArray(block.transactions)) block.transactions.forEach(function(item) {
        if (!(typeof item === "string")) return outputTransactionFormatter(item, hexFormat);
    });
    if (block.miner) block.miner = utils.toChecksumAddress(block.miner);
    if (block.baseFeePerGas) block.baseFeePerGas = utils.hexToNumber(block.baseFeePerGas);
    return block;
};
/**
 * Formats the input of a log
 *
 * @method inputLogFormatter
 * @param {Object} log object
 * @returns {Object} log
 */ var inputLogFormatter = function(options) {
    var toTopic = function(value) {
        if (value === null || typeof value === "undefined") return null;
        value = String(value);
        if (value.indexOf("0x") === 0) return value;
        else return utils.fromUtf8(value);
    };
    if (options === undefined) options = {};
    // If options !== undefined, don't blow out existing data
    if (options.fromBlock === undefined) options = {
        ...options,
        fromBlock: "latest"
    };
    if (options.fromBlock || options.fromBlock === 0) options.fromBlock = inputBlockNumberFormatter(options.fromBlock);
    if (options.toBlock || options.toBlock === 0) options.toBlock = inputBlockNumberFormatter(options.toBlock);
    // make sure topics, get converted to hex
    options.topics = options.topics || [];
    options.topics = options.topics.map(function(topic) {
        return Array.isArray(topic) ? topic.map(toTopic) : toTopic(topic);
    });
    toTopic = null;
    if (options.address) options.address = Array.isArray(options.address) ? options.address.map(function(addr) {
        return inputAddressFormatter(addr);
    }) : inputAddressFormatter(options.address);
    return options;
};
/**
 * Formats the output of a log
 *
 * @method outputLogFormatter
 * @param {Object} log object
 * @returns {Object} log
 */ var outputLogFormatter = function(log) {
    // generate a custom log id
    if (typeof log.blockHash === "string" && typeof log.transactionHash === "string" && typeof log.logIndex === "string") {
        var shaId = utils.sha3(log.blockHash.replace("0x", "") + log.transactionHash.replace("0x", "") + log.logIndex.replace("0x", ""));
        log.id = "log_" + shaId.replace("0x", "").slice(0, 8);
    } else if (!log.id) log.id = null;
    if (log.blockNumber !== null) log.blockNumber = utils.hexToNumber(log.blockNumber);
    if (log.transactionIndex !== null) log.transactionIndex = utils.hexToNumber(log.transactionIndex);
    if (log.logIndex !== null) log.logIndex = utils.hexToNumber(log.logIndex);
    if (log.address) log.address = utils.toChecksumAddress(log.address);
    return log;
};
/**
 * Formats the input of a whisper post and converts all values to HEX
 *
 * @method inputPostFormatter
 * @param {Object} transaction object
 * @returns {Object}
 */ var inputPostFormatter = function(post) {
    // post.payload = utils.toHex(post.payload);
    if (post.ttl) post.ttl = utils.numberToHex(post.ttl);
    if (post.workToProve) post.workToProve = utils.numberToHex(post.workToProve);
    if (post.priority) post.priority = utils.numberToHex(post.priority);
    // fallback
    if (!Array.isArray(post.topics)) post.topics = post.topics ? [
        post.topics
    ] : [];
    // format the following options
    post.topics = post.topics.map(function(topic) {
        // convert only if not hex
        return topic.indexOf("0x") === 0 ? topic : utils.fromUtf8(topic);
    });
    return post;
};
/**
 * Formats the output of a received post message
 *
 * @method outputPostFormatter
 * @param {Object}
 * @returns {Object}
 */ var outputPostFormatter = function(post) {
    post.expiry = utils.hexToNumber(post.expiry);
    post.sent = utils.hexToNumber(post.sent);
    post.ttl = utils.hexToNumber(post.ttl);
    post.workProved = utils.hexToNumber(post.workProved);
    // post.payloadRaw = post.payload;
    // post.payload = utils.hexToAscii(post.payload);
    // if (utils.isJson(post.payload)) {
    //     post.payload = JSON.parse(post.payload);
    // }
    // format the following options
    if (!post.topics) post.topics = [];
    post.topics = post.topics.map(function(topic) {
        return utils.toUtf8(topic);
    });
    return post;
};
var inputAddressFormatter = function(address) {
    var iban = new Iban(address);
    if (iban.isValid() && iban.isDirect()) return iban.toAddress().toLowerCase();
    else if (utils.isAddress(address)) return "0x" + address.toLowerCase().replace("0x", "");
    throw new Error(`Provided address ${address} is invalid, the capitalization checksum test failed, or it's an indirect IBAN address which can't be converted.`);
};
var outputSyncingFormatter = function(result) {
    result.startingBlock = utils.hexToNumber(result.startingBlock);
    result.currentBlock = utils.hexToNumber(result.currentBlock);
    result.highestBlock = utils.hexToNumber(result.highestBlock);
    if (result.knownStates) {
        result.knownStates = utils.hexToNumber(result.knownStates);
        result.pulledStates = utils.hexToNumber(result.pulledStates);
    }
    return result;
};
module.exports = {
    inputDefaultBlockNumberFormatter: inputDefaultBlockNumberFormatter,
    inputBlockNumberFormatter: inputBlockNumberFormatter,
    inputCallFormatter: inputCallFormatter,
    inputTransactionFormatter: inputTransactionFormatter,
    inputAddressFormatter: inputAddressFormatter,
    inputPostFormatter: inputPostFormatter,
    inputLogFormatter: inputLogFormatter,
    inputSignFormatter: inputSignFormatter,
    inputStorageKeysFormatter: inputStorageKeysFormatter,
    outputProofFormatter: outputProofFormatter,
    outputBigNumberFormatter: outputBigNumberFormatter,
    outputTransactionFormatter: outputTransactionFormatter,
    outputTransactionReceiptFormatter: outputTransactionReceiptFormatter,
    outputBlockFormatter: outputBlockFormatter,
    outputLogFormatter: outputLogFormatter,
    outputPostFormatter: outputPostFormatter,
    outputSyncingFormatter: outputSyncingFormatter
};

},{"a91162e868a295f2":"ePzmI","602e20045b7026b":"g2POl"}],"ePzmI":[function(require,module,exports) {
/*
 This file is part of web3.js.

 web3.js is free software: you can redistribute it and/or modify
 it under the terms of the GNU Lesser General Public License as published by
 the Free Software Foundation, either version 3 of the License, or
 (at your option) any later version.

 web3.js is distributed in the hope that it will be useful,
 but WITHOUT ANY WARRANTY; without even the implied warranty of
 MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 GNU Lesser General Public License for more details.

 You should have received a copy of the GNU Lesser General Public License
 along with web3.js.  If not, see <http://www.gnu.org/licenses/>.
 */ /**
 * @file utils.js
 * @author Marek Kotewicz <marek@parity.io>
 * @author Fabian Vogelsteller <fabian@ethereum.org>
 * @date 2017
 */ var ethjsUnit = require("8107079eb584b152");
var utils = require("5f93cde17be5b61e");
var soliditySha3 = require("a1cb26123021603d");
var randombytes = require("a13910bd2e0541f0");
var BN = require("7d0d15dae5938aca");
/**
 * Fires an error in an event emitter and callback and returns the eventemitter
 *
 * @method _fireError
 * @param {Object} error a string, a error, or an object with {message, data}
 * @param {Object} emitter
 * @param {Function} reject
 * @param {Function} callback
 * @param {any} optionalData
 * @return {Object} the emitter
 */ var _fireError = function(error, emitter, reject, callback, optionalData) {
    /*jshint maxcomplexity: 10 */ // add data if given
    if (!!error && typeof error === "object" && !(error instanceof Error) && error.data) {
        if (!!error.data && typeof error.data === "object" || Array.isArray(error.data)) error.data = JSON.stringify(error.data, null, 2);
        error = error.message + "\n" + error.data;
    }
    if (typeof error === "string") error = new Error(error);
    if (typeof callback === "function") callback(error, optionalData);
    if (typeof reject === "function") {
        // suppress uncatched error if an error listener is present
        // OR suppress uncatched error if an callback listener is present
        if (emitter && typeof emitter.listeners === "function" && emitter.listeners("error").length || typeof callback === "function") emitter.catch(function() {});
        // reject later, to be able to return emitter
        setTimeout(function() {
            reject(error);
        }, 1);
    }
    if (emitter && typeof emitter.emit === "function") // emit later, to be able to return emitter
    setTimeout(function() {
        emitter.emit("error", error, optionalData);
        emitter.removeAllListeners();
    }, 1);
    return emitter;
};
/**
 * Should be used to create full function/event name from json abi
 *
 * @method _jsonInterfaceMethodToString
 * @param {Object} json
 * @return {String} full function/event name
 */ var _jsonInterfaceMethodToString = function(json) {
    if (!!json && typeof json === "object" && json.name && json.name.indexOf("(") !== -1) return json.name;
    return json.name + "(" + _flattenTypes(false, json.inputs).join(",") + ")";
};
/**
 * Should be used to flatten json abi inputs/outputs into an array of type-representing-strings
 *
 * @method _flattenTypes
 * @param {bool} includeTuple
 * @param {Object} puts
 * @return {Array} parameters as strings
 */ var _flattenTypes = function(includeTuple, puts) {
    // console.log("entered _flattenTypes. inputs/outputs: " + puts)
    var types = [];
    puts.forEach(function(param) {
        if (typeof param.components === "object") {
            if (param.type.substring(0, 5) !== "tuple") throw new Error("components found but type is not tuple; report on GitHub");
            var suffix = "";
            var arrayBracket = param.type.indexOf("[");
            if (arrayBracket >= 0) suffix = param.type.substring(arrayBracket);
            var result = _flattenTypes(includeTuple, param.components);
            // console.log("result should have things: " + result)
            if (Array.isArray(result) && includeTuple) // console.log("include tuple word, and its an array. joining...: " + result.types)
            types.push("tuple(" + result.join(",") + ")" + suffix);
            else if (!includeTuple) // console.log("don't include tuple, but its an array. joining...: " + result)
            types.push("(" + result.join(",") + ")" + suffix);
            else // console.log("its a single type within a tuple: " + result.types)
            types.push("(" + result + ")");
        } else // console.log("its a type and not directly in a tuple: " + param.type)
        types.push(param.type);
    });
    return types;
};
/**
 * Returns a random hex string by the given bytes size
 *
 * @param {Number} size
 * @returns {string}
 */ var randomHex = function(size) {
    return "0x" + randombytes(size).toString("hex");
};
/**
 * Should be called to get ascii from it's hex representation
 *
 * @method hexToAscii
 * @param {String} hex
 * @returns {String} ascii string representation of hex value
 */ var hexToAscii = function(hex) {
    if (!utils.isHexStrict(hex)) throw new Error("The parameter must be a valid HEX string.");
    var str = "";
    var i = 0, l = hex.length;
    if (hex.substring(0, 2) === "0x") i = 2;
    for(; i < l; i += 2){
        var code = parseInt(hex.slice(i, i + 2), 16);
        str += String.fromCharCode(code);
    }
    return str;
};
/**
 * Should be called to get hex representation (prefixed by 0x) of ascii string
 *
 * @method asciiToHex
 * @param {String} str
 * @returns {String} hex representation of input string
 */ var asciiToHex = function(str) {
    if (!str) return "0x00";
    var hex = "";
    for(var i = 0; i < str.length; i++){
        var code = str.charCodeAt(i);
        var n = code.toString(16);
        hex += n.length < 2 ? "0" + n : n;
    }
    return "0x" + hex;
};
/**
 * Returns value of unit in Wei
 *
 * @method getUnitValue
 * @param {String} unit the unit to convert to, default ether
 * @returns {BN} value of the unit (in Wei)
 * @throws error if the unit is not correct:w
 */ var getUnitValue = function(unit) {
    unit = unit ? unit.toLowerCase() : "ether";
    if (!ethjsUnit.unitMap[unit]) throw new Error('This unit "' + unit + "\" doesn't exist, please use the one of the following units" + JSON.stringify(ethjsUnit.unitMap, null, 2));
    return unit;
};
/**
 * Takes a number of wei and converts it to any other ether unit.
 *
 * Possible units are:
 *   SI Short   SI Full        Effigy       Other
 * - kwei       femtoether     babbage
 * - mwei       picoether      lovelace
 * - gwei       nanoether      shannon      nano
 * - --         microether     szabo        micro
 * - --         milliether     finney       milli
 * - ether      --             --
 * - kether                    --           grand
 * - mether
 * - gether
 * - tether
 *
 * @method fromWei
 * @param {Number|String} number can be a number, number string or a HEX of a decimal
 * @param {String} unit the unit to convert to, default ether
 * @return {String|Object} When given a BN object it returns one as well, otherwise a number
 */ var fromWei = function(number, unit) {
    unit = getUnitValue(unit);
    if (!utils.isBN(number) && !(typeof number === "string")) throw new Error("Please pass numbers as strings or BN objects to avoid precision errors.");
    return utils.isBN(number) ? ethjsUnit.fromWei(number, unit) : ethjsUnit.fromWei(number, unit).toString(10);
};
/**
 * Takes a number of a unit and converts it to wei.
 *
 * Possible units are:
 *   SI Short   SI Full        Effigy       Other
 * - kwei       femtoether     babbage
 * - mwei       picoether      lovelace
 * - gwei       nanoether      shannon      nano
 * - --         microether     szabo        micro
 * - --         microether     szabo        micro
 * - --         milliether     finney       milli
 * - ether      --             --
 * - kether                    --           grand
 * - mether
 * - gether
 * - tether
 *
 * @method toWei
 * @param {Number|String|BN} number can be a number, number string or a HEX of a decimal
 * @param {String} unit the unit to convert from, default ether
 * @return {String|Object} When given a BN object it returns one as well, otherwise a number
 */ var toWei = function(number, unit) {
    unit = getUnitValue(unit);
    if (!utils.isBN(number) && !(typeof number === "string")) throw new Error("Please pass numbers as strings or BN objects to avoid precision errors.");
    return utils.isBN(number) ? ethjsUnit.toWei(number, unit) : ethjsUnit.toWei(number, unit).toString(10);
};
/**
 * Converts to a checksum address
 *
 * @method toChecksumAddress
 * @param {String} address the given HEX address
 * @return {String}
 */ var toChecksumAddress = function(address) {
    if (typeof address === "undefined") return "";
    if (!/^(0x)?[0-9a-f]{40}$/i.test(address)) throw new Error('Given address "' + address + '" is not a valid Ethereum address.');
    address = address.toLowerCase().replace(/^0x/i, "");
    var addressHash = utils.sha3(address).replace(/^0x/i, "");
    var checksumAddress = "0x";
    for(var i = 0; i < address.length; i++)// If ith character is 8 to f then make it uppercase
    if (parseInt(addressHash[i], 16) > 7) checksumAddress += address[i].toUpperCase();
    else checksumAddress += address[i];
    return checksumAddress;
};
/**
 * Returns -1 if a<b, 1 if a>b; 0 if a == b.
 * For more details on this type of function, see
 * developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/sort
 * Block tag `safe` and `block number` combination param is not supported
 * @method compareBlockNumbers
 *
 * @param {String|Number|BN} a
 *
 * @param {String|Number|BN} b
 *
 * @returns {Number} -1, 0, or 1
 */ var compareBlockNumbers = function(a, b) {
    // Increasing order: (genesis = earliest), safe, (finalized ~ latest), pending
    // safe vs block-num cant be compared as block number provided can be on left or right side of safe tag, until safe tag block number is extracted and compared
    if (a === b) return 0;
    else if (("genesis" === a || "earliest" === a || 0 === a) && ("genesis" === b || "earliest" === b || 0 === b)) return 0;
    else if ("genesis" === a || "earliest" === a || a === 0) // b !== a, thus a < b
    return -1;
    else if ("genesis" === b || "earliest" === b || b === 0) // b !== a, thus a > b
    return 1;
    else if (a === "latest" || a === "finalized") {
        if (b === "pending") return -1;
        else // b !== ("pending" OR "latest"), thus a > b
        return 1;
    } else if (b === "latest" || b === "finalized") {
        if (a === "pending") return 1;
        else // b !== ("pending" OR "latest"), thus a > b
        return -1;
    } else if (a === "pending") // b (== OR <) "latest", thus a > b
    return 1;
    else if (b === "pending") return -1;
    else if (a === "safe" || b === "safe") // either a or b is "safe" and the other one did not fall into any of the conditions above, so the other one is a number
    return undefined;
    else {
        let bnA = new BN(a);
        let bnB = new BN(b);
        if (bnA.lt(bnB)) return -1;
        else if (bnA.eq(bnB)) return 0;
        else return 1;
    }
};
module.exports = {
    _fireError: _fireError,
    _jsonInterfaceMethodToString: _jsonInterfaceMethodToString,
    _flattenTypes: _flattenTypes,
    // extractDisplayName: extractDisplayName,
    // extractTypeName: extractTypeName,
    randomHex: randomHex,
    BN: utils.BN,
    isBN: utils.isBN,
    isBigNumber: utils.isBigNumber,
    isHex: utils.isHex,
    isHexStrict: utils.isHexStrict,
    sha3: utils.sha3,
    sha3Raw: utils.sha3Raw,
    keccak256: utils.sha3,
    soliditySha3: soliditySha3.soliditySha3,
    soliditySha3Raw: soliditySha3.soliditySha3Raw,
    encodePacked: soliditySha3.encodePacked,
    isAddress: utils.isAddress,
    checkAddressChecksum: utils.checkAddressChecksum,
    toChecksumAddress: toChecksumAddress,
    toHex: utils.toHex,
    toBN: utils.toBN,
    bytesToHex: utils.bytesToHex,
    hexToBytes: utils.hexToBytes,
    hexToNumberString: utils.hexToNumberString,
    hexToNumber: utils.hexToNumber,
    toDecimal: utils.hexToNumber,
    numberToHex: utils.numberToHex,
    fromDecimal: utils.numberToHex,
    hexToUtf8: utils.hexToUtf8,
    hexToString: utils.hexToUtf8,
    toUtf8: utils.hexToUtf8,
    stripHexPrefix: utils.stripHexPrefix,
    utf8ToHex: utils.utf8ToHex,
    stringToHex: utils.utf8ToHex,
    fromUtf8: utils.utf8ToHex,
    hexToAscii: hexToAscii,
    toAscii: hexToAscii,
    asciiToHex: asciiToHex,
    fromAscii: asciiToHex,
    unitMap: ethjsUnit.unitMap,
    toWei: toWei,
    fromWei: fromWei,
    padLeft: utils.leftPad,
    leftPad: utils.leftPad,
    padRight: utils.rightPad,
    rightPad: utils.rightPad,
    toTwosComplement: utils.toTwosComplement,
    isBloom: utils.isBloom,
    isUserEthereumAddressInBloom: utils.isUserEthereumAddressInBloom,
    isContractAddressInBloom: utils.isContractAddressInBloom,
    isTopic: utils.isTopic,
    isTopicInBloom: utils.isTopicInBloom,
    isInBloom: utils.isInBloom,
    compareBlockNumbers: compareBlockNumbers,
    toNumber: utils.toNumber
};

},{"8107079eb584b152":"5yAXS","5f93cde17be5b61e":"lgE8d","a1cb26123021603d":"2CNKE","a13910bd2e0541f0":"c6z4K","7d0d15dae5938aca":"8wHT1"}],"5yAXS":[function(require,module,exports) {
"use strict";
var BN = require("1e1b8edf8bc9290c");
var numberToBN = require("6038193d557634e8");
var zero = new BN(0);
var negative1 = new BN(-1);
// complete ethereum unit map
var unitMap = {
    "noether": "0",
    "wei": "1",
    "kwei": "1000",
    "Kwei": "1000",
    "babbage": "1000",
    "femtoether": "1000",
    "mwei": "1000000",
    "Mwei": "1000000",
    "lovelace": "1000000",
    "picoether": "1000000",
    "gwei": "1000000000",
    "Gwei": "1000000000",
    "shannon": "1000000000",
    "nanoether": "1000000000",
    "nano": "1000000000",
    "szabo": "1000000000000",
    "microether": "1000000000000",
    "micro": "1000000000000",
    "finney": "1000000000000000",
    "milliether": "1000000000000000",
    "milli": "1000000000000000",
    "ether": "1000000000000000000",
    "kether": "1000000000000000000000",
    "grand": "1000000000000000000000",
    "mether": "1000000000000000000000000",
    "gether": "1000000000000000000000000000",
    "tether": "1000000000000000000000000000000"
};
/**
 * Returns value of unit in Wei
 *
 * @method getValueOfUnit
 * @param {String} unit the unit to convert to, default ether
 * @returns {BigNumber} value of the unit (in Wei)
 * @throws error if the unit is not correct:w
 */ function getValueOfUnit(unitInput) {
    var unit = unitInput ? unitInput.toLowerCase() : "ether";
    var unitValue = unitMap[unit]; // eslint-disable-line
    if (typeof unitValue !== "string") throw new Error("[ethjs-unit] the unit provided " + unitInput + " doesn't exists, please use the one of the following units " + JSON.stringify(unitMap, null, 2));
    return new BN(unitValue, 10);
}
function numberToString(arg) {
    if (typeof arg === "string") {
        if (!arg.match(/^-?[0-9.]+$/)) throw new Error("while converting number to string, invalid number value '" + arg + "', should be a number matching (^-?[0-9.]+).");
        return arg;
    } else if (typeof arg === "number") return String(arg);
    else if (typeof arg === "object" && arg.toString && (arg.toTwos || arg.dividedToIntegerBy)) {
        if (arg.toPrecision) return String(arg.toPrecision());
        else // eslint-disable-line
        return arg.toString(10);
    }
    throw new Error("while converting number to string, invalid number value '" + arg + "' type " + typeof arg + ".");
}
function fromWei(weiInput, unit, optionsInput) {
    var wei = numberToBN(weiInput); // eslint-disable-line
    var negative = wei.lt(zero); // eslint-disable-line
    var base = getValueOfUnit(unit);
    var baseLength = unitMap[unit].length - 1 || 1;
    var options = optionsInput || {};
    if (negative) wei = wei.mul(negative1);
    var fraction = wei.mod(base).toString(10); // eslint-disable-line
    while(fraction.length < baseLength)fraction = "0" + fraction;
    if (!options.pad) fraction = fraction.match(/^([0-9]*[1-9]|0)(0*)/)[1];
    var whole = wei.div(base).toString(10); // eslint-disable-line
    if (options.commify) whole = whole.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    var value = "" + whole + (fraction == "0" ? "" : "." + fraction); // eslint-disable-line
    if (negative) value = "-" + value;
    return value;
}
function toWei(etherInput, unit) {
    var ether = numberToString(etherInput); // eslint-disable-line
    var base = getValueOfUnit(unit);
    var baseLength = unitMap[unit].length - 1 || 1;
    // Is it negative?
    var negative = ether.substring(0, 1) === "-"; // eslint-disable-line
    if (negative) ether = ether.substring(1);
    if (ether === ".") throw new Error("[ethjs-unit] while converting number " + etherInput + " to wei, invalid value");
    // Split it into a whole and fractional part
    var comps = ether.split("."); // eslint-disable-line
    if (comps.length > 2) throw new Error("[ethjs-unit] while converting number " + etherInput + " to wei,  too many decimal points");
    var whole = comps[0], fraction = comps[1]; // eslint-disable-line
    if (!whole) whole = "0";
    if (!fraction) fraction = "0";
    if (fraction.length > baseLength) throw new Error("[ethjs-unit] while converting number " + etherInput + " to wei, too many decimal places");
    while(fraction.length < baseLength)fraction += "0";
    whole = new BN(whole);
    fraction = new BN(fraction);
    var wei = whole.mul(base).add(fraction); // eslint-disable-line
    if (negative) wei = wei.mul(negative1);
    return new BN(wei.toString(10), 10);
}
module.exports = {
    unitMap: unitMap,
    numberToString: numberToString,
    getValueOfUnit: getValueOfUnit,
    fromWei: fromWei,
    toWei: toWei
};

},{"1e1b8edf8bc9290c":"36T4X","6038193d557634e8":"gep00"}],"36T4X":[function(require,module,exports) {
(function(module1, exports) {
    "use strict";
    // Utils
    function assert(val, msg) {
        if (!val) throw new Error(msg || "Assertion failed");
    }
    // Could use `inherits` module, but don't want to move from single file
    // architecture yet.
    function inherits(ctor, superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
    // BN
    function BN(number, base, endian) {
        if (BN.isBN(number)) return number;
        this.negative = 0;
        this.words = null;
        this.length = 0;
        // Reduction context
        this.red = null;
        if (number !== null) {
            if (base === "le" || base === "be") {
                endian = base;
                base = 10;
            }
            this._init(number || 0, base || 10, endian || "be");
        }
    }
    if (typeof module1 === "object") module1.exports = BN;
    else exports.BN = BN;
    BN.BN = BN;
    BN.wordSize = 26;
    var Buffer;
    try {
        Buffer = require("63c0958e99cf166a").Buffer;
    } catch (e) {}
    BN.isBN = function isBN(num) {
        if (num instanceof BN) return true;
        return num !== null && typeof num === "object" && num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
    };
    BN.max = function max(left, right) {
        if (left.cmp(right) > 0) return left;
        return right;
    };
    BN.min = function min(left, right) {
        if (left.cmp(right) < 0) return left;
        return right;
    };
    BN.prototype._init = function init(number, base, endian) {
        if (typeof number === "number") return this._initNumber(number, base, endian);
        if (typeof number === "object") return this._initArray(number, base, endian);
        if (base === "hex") base = 16;
        assert(base === (base | 0) && base >= 2 && base <= 36);
        number = number.toString().replace(/\s+/g, "");
        var start = 0;
        if (number[0] === "-") start++;
        if (base === 16) this._parseHex(number, start);
        else this._parseBase(number, base, start);
        if (number[0] === "-") this.negative = 1;
        this.strip();
        if (endian !== "le") return;
        this._initArray(this.toArray(), base, endian);
    };
    BN.prototype._initNumber = function _initNumber(number, base, endian) {
        if (number < 0) {
            this.negative = 1;
            number = -number;
        }
        if (number < 0x4000000) {
            this.words = [
                number & 0x3ffffff
            ];
            this.length = 1;
        } else if (number < 0x10000000000000) {
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff
            ];
            this.length = 2;
        } else {
            assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff,
                1
            ];
            this.length = 3;
        }
        if (endian !== "le") return;
        // Reverse the bytes
        this._initArray(this.toArray(), base, endian);
    };
    BN.prototype._initArray = function _initArray(number, base, endian) {
        // Perhaps a Uint8Array
        assert(typeof number.length === "number");
        if (number.length <= 0) {
            this.words = [
                0
            ];
            this.length = 1;
            return this;
        }
        this.length = Math.ceil(number.length / 3);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        var j, w;
        var off = 0;
        if (endian === "be") for(i = number.length - 1, j = 0; i >= 0; i -= 3){
            w = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        else if (endian === "le") for(i = 0, j = 0; i < number.length; i += 3){
            w = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        return this.strip();
    };
    function parseHex(str, start, end) {
        var r = 0;
        var len = Math.min(str.length, end);
        for(var i = start; i < len; i++){
            var c = str.charCodeAt(i) - 48;
            r <<= 4;
            // 'a' - 'f'
            if (c >= 49 && c <= 54) r |= c - 49 + 0xa;
            else if (c >= 17 && c <= 22) r |= c - 17 + 0xa;
            else r |= c & 0xf;
        }
        return r;
    }
    BN.prototype._parseHex = function _parseHex(number, start) {
        // Create possibly bigger array to ensure that it fits the number
        this.length = Math.ceil((number.length - start) / 6);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        var j, w;
        // Scan 24-bit chunks and add them to the number
        var off = 0;
        for(i = number.length - 6, j = 0; i >= start; i -= 6){
            w = parseHex(number, i, i + 6);
            this.words[j] |= w << off & 0x3ffffff;
            // NOTE: `0x3fffff` is intentional here, 26bits max shift + 24bit hex limb
            this.words[j + 1] |= w >>> 26 - off & 0x3fffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        if (i + 6 !== start) {
            w = parseHex(number, start, i + 6);
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] |= w >>> 26 - off & 0x3fffff;
        }
        this.strip();
    };
    function parseBase(str, start, end, mul) {
        var r = 0;
        var len = Math.min(str.length, end);
        for(var i = start; i < len; i++){
            var c = str.charCodeAt(i) - 48;
            r *= mul;
            // 'a'
            if (c >= 49) r += c - 49 + 0xa;
            else if (c >= 17) r += c - 17 + 0xa;
            else r += c;
        }
        return r;
    }
    BN.prototype._parseBase = function _parseBase(number, base, start) {
        // Initialize as zero
        this.words = [
            0
        ];
        this.length = 1;
        // Find length of limb in base
        for(var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base)limbLen++;
        limbLen--;
        limbPow = limbPow / base | 0;
        var total = number.length - start;
        var mod = total % limbLen;
        var end = Math.min(total, total - mod) + start;
        var word = 0;
        for(var i = start; i < end; i += limbLen){
            word = parseBase(number, i, i + limbLen, base);
            this.imuln(limbPow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        if (mod !== 0) {
            var pow = 1;
            word = parseBase(number, i, number.length, base);
            for(i = 0; i < mod; i++)pow *= base;
            this.imuln(pow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
    };
    BN.prototype.copy = function copy(dest) {
        dest.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)dest.words[i] = this.words[i];
        dest.length = this.length;
        dest.negative = this.negative;
        dest.red = this.red;
    };
    BN.prototype.clone = function clone() {
        var r = new BN(null);
        this.copy(r);
        return r;
    };
    BN.prototype._expand = function _expand(size) {
        while(this.length < size)this.words[this.length++] = 0;
        return this;
    };
    // Remove leading `0` from `this`
    BN.prototype.strip = function strip() {
        while(this.length > 1 && this.words[this.length - 1] === 0)this.length--;
        return this._normSign();
    };
    BN.prototype._normSign = function _normSign() {
        // -0 = 0
        if (this.length === 1 && this.words[0] === 0) this.negative = 0;
        return this;
    };
    BN.prototype.inspect = function inspect() {
        return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
    };
    /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */ var zeros = [
        "",
        "0",
        "00",
        "000",
        "0000",
        "00000",
        "000000",
        "0000000",
        "00000000",
        "000000000",
        "0000000000",
        "00000000000",
        "000000000000",
        "0000000000000",
        "00000000000000",
        "000000000000000",
        "0000000000000000",
        "00000000000000000",
        "000000000000000000",
        "0000000000000000000",
        "00000000000000000000",
        "000000000000000000000",
        "0000000000000000000000",
        "00000000000000000000000",
        "000000000000000000000000",
        "0000000000000000000000000"
    ];
    var groupSizes = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
    ];
    var groupBases = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        10000000,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64000000,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        24300000,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
    ];
    BN.prototype.toString = function toString(base, padding) {
        base = base || 10;
        padding = padding | 0 || 1;
        var out;
        if (base === 16 || base === "hex") {
            out = "";
            var off = 0;
            var carry = 0;
            for(var i = 0; i < this.length; i++){
                var w = this.words[i];
                var word = ((w << off | carry) & 0xffffff).toString(16);
                carry = w >>> 24 - off & 0xffffff;
                if (carry !== 0 || i !== this.length - 1) out = zeros[6 - word.length] + word + out;
                else out = word + out;
                off += 2;
                if (off >= 26) {
                    off -= 26;
                    i--;
                }
            }
            if (carry !== 0) out = carry.toString(16) + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        if (base === (base | 0) && base >= 2 && base <= 36) {
            // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
            var groupSize = groupSizes[base];
            // var groupBase = Math.pow(base, groupSize);
            var groupBase = groupBases[base];
            out = "";
            var c = this.clone();
            c.negative = 0;
            while(!c.isZero()){
                var r = c.modn(groupBase).toString(base);
                c = c.idivn(groupBase);
                if (!c.isZero()) out = zeros[groupSize - r.length] + r + out;
                else out = r + out;
            }
            if (this.isZero()) out = "0" + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        assert(false, "Base should be between 2 and 36");
    };
    BN.prototype.toNumber = function toNumber() {
        var ret = this.words[0];
        if (this.length === 2) ret += this.words[1] * 0x4000000;
        else if (this.length === 3 && this.words[2] === 0x01) // NOTE: at this stage it is known that the top bit is set
        ret += 0x10000000000000 + this.words[1] * 0x4000000;
        else if (this.length > 2) assert(false, "Number can only safely store up to 53 bits");
        return this.negative !== 0 ? -ret : ret;
    };
    BN.prototype.toJSON = function toJSON() {
        return this.toString(16);
    };
    BN.prototype.toBuffer = function toBuffer(endian, length) {
        assert(typeof Buffer !== "undefined");
        return this.toArrayLike(Buffer, endian, length);
    };
    BN.prototype.toArray = function toArray(endian, length) {
        return this.toArrayLike(Array, endian, length);
    };
    BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
        var byteLength = this.byteLength();
        var reqLength = length || Math.max(1, byteLength);
        assert(byteLength <= reqLength, "byte array longer than desired length");
        assert(reqLength > 0, "Requested array length <= 0");
        this.strip();
        var littleEndian = endian === "le";
        var res = new ArrayType(reqLength);
        var b, i;
        var q = this.clone();
        if (!littleEndian) {
            // Assume big-endian
            for(i = 0; i < reqLength - byteLength; i++)res[i] = 0;
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[reqLength - i - 1] = b;
            }
        } else {
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[i] = b;
            }
            for(; i < reqLength; i++)res[i] = 0;
        }
        return res;
    };
    if (Math.clz32) BN.prototype._countBits = function _countBits(w) {
        return 32 - Math.clz32(w);
    };
    else BN.prototype._countBits = function _countBits(w) {
        var t = w;
        var r = 0;
        if (t >= 0x1000) {
            r += 13;
            t >>>= 13;
        }
        if (t >= 0x40) {
            r += 7;
            t >>>= 7;
        }
        if (t >= 0x8) {
            r += 4;
            t >>>= 4;
        }
        if (t >= 0x02) {
            r += 2;
            t >>>= 2;
        }
        return r + t;
    };
    BN.prototype._zeroBits = function _zeroBits(w) {
        // Short-cut
        if (w === 0) return 26;
        var t = w;
        var r = 0;
        if ((t & 0x1fff) === 0) {
            r += 13;
            t >>>= 13;
        }
        if ((t & 0x7f) === 0) {
            r += 7;
            t >>>= 7;
        }
        if ((t & 0xf) === 0) {
            r += 4;
            t >>>= 4;
        }
        if ((t & 0x3) === 0) {
            r += 2;
            t >>>= 2;
        }
        if ((t & 0x1) === 0) r++;
        return r;
    };
    // Return number of used bits in a BN
    BN.prototype.bitLength = function bitLength() {
        var w = this.words[this.length - 1];
        var hi = this._countBits(w);
        return (this.length - 1) * 26 + hi;
    };
    function toBitArray(num) {
        var w = new Array(num.bitLength());
        for(var bit = 0; bit < w.length; bit++){
            var off = bit / 26 | 0;
            var wbit = bit % 26;
            w[bit] = (num.words[off] & 1 << wbit) >>> wbit;
        }
        return w;
    }
    // Number of trailing zero bits
    BN.prototype.zeroBits = function zeroBits() {
        if (this.isZero()) return 0;
        var r = 0;
        for(var i = 0; i < this.length; i++){
            var b = this._zeroBits(this.words[i]);
            r += b;
            if (b !== 26) break;
        }
        return r;
    };
    BN.prototype.byteLength = function byteLength() {
        return Math.ceil(this.bitLength() / 8);
    };
    BN.prototype.toTwos = function toTwos(width) {
        if (this.negative !== 0) return this.abs().inotn(width).iaddn(1);
        return this.clone();
    };
    BN.prototype.fromTwos = function fromTwos(width) {
        if (this.testn(width - 1)) return this.notn(width).iaddn(1).ineg();
        return this.clone();
    };
    BN.prototype.isNeg = function isNeg() {
        return this.negative !== 0;
    };
    // Return negative clone of `this`
    BN.prototype.neg = function neg() {
        return this.clone().ineg();
    };
    BN.prototype.ineg = function ineg() {
        if (!this.isZero()) this.negative ^= 1;
        return this;
    };
    // Or `num` with `this` in-place
    BN.prototype.iuor = function iuor(num) {
        while(this.length < num.length)this.words[this.length++] = 0;
        for(var i = 0; i < num.length; i++)this.words[i] = this.words[i] | num.words[i];
        return this.strip();
    };
    BN.prototype.ior = function ior(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuor(num);
    };
    // Or `num` with `this`
    BN.prototype.or = function or(num) {
        if (this.length > num.length) return this.clone().ior(num);
        return num.clone().ior(this);
    };
    BN.prototype.uor = function uor(num) {
        if (this.length > num.length) return this.clone().iuor(num);
        return num.clone().iuor(this);
    };
    // And `num` with `this` in-place
    BN.prototype.iuand = function iuand(num) {
        // b = min-length(num, this)
        var b;
        if (this.length > num.length) b = num;
        else b = this;
        for(var i = 0; i < b.length; i++)this.words[i] = this.words[i] & num.words[i];
        this.length = b.length;
        return this.strip();
    };
    BN.prototype.iand = function iand(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuand(num);
    };
    // And `num` with `this`
    BN.prototype.and = function and(num) {
        if (this.length > num.length) return this.clone().iand(num);
        return num.clone().iand(this);
    };
    BN.prototype.uand = function uand(num) {
        if (this.length > num.length) return this.clone().iuand(num);
        return num.clone().iuand(this);
    };
    // Xor `num` with `this` in-place
    BN.prototype.iuxor = function iuxor(num) {
        // a.length > b.length
        var a;
        var b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        for(var i = 0; i < b.length; i++)this.words[i] = a.words[i] ^ b.words[i];
        if (this !== a) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = a.length;
        return this.strip();
    };
    BN.prototype.ixor = function ixor(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuxor(num);
    };
    // Xor `num` with `this`
    BN.prototype.xor = function xor(num) {
        if (this.length > num.length) return this.clone().ixor(num);
        return num.clone().ixor(this);
    };
    BN.prototype.uxor = function uxor(num) {
        if (this.length > num.length) return this.clone().iuxor(num);
        return num.clone().iuxor(this);
    };
    // Not ``this`` with ``width`` bitwidth
    BN.prototype.inotn = function inotn(width) {
        assert(typeof width === "number" && width >= 0);
        var bytesNeeded = Math.ceil(width / 26) | 0;
        var bitsLeft = width % 26;
        // Extend the buffer with leading zeroes
        this._expand(bytesNeeded);
        if (bitsLeft > 0) bytesNeeded--;
        // Handle complete words
        for(var i = 0; i < bytesNeeded; i++)this.words[i] = ~this.words[i] & 0x3ffffff;
        // Handle the residue
        if (bitsLeft > 0) this.words[i] = ~this.words[i] & 0x3ffffff >> 26 - bitsLeft;
        // And remove leading zeroes
        return this.strip();
    };
    BN.prototype.notn = function notn(width) {
        return this.clone().inotn(width);
    };
    // Set `bit` of `this`
    BN.prototype.setn = function setn(bit, val) {
        assert(typeof bit === "number" && bit >= 0);
        var off = bit / 26 | 0;
        var wbit = bit % 26;
        this._expand(off + 1);
        if (val) this.words[off] = this.words[off] | 1 << wbit;
        else this.words[off] = this.words[off] & ~(1 << wbit);
        return this.strip();
    };
    // Add `num` to `this` in-place
    BN.prototype.iadd = function iadd(num) {
        var r;
        // negative + positive
        if (this.negative !== 0 && num.negative === 0) {
            this.negative = 0;
            r = this.isub(num);
            this.negative ^= 1;
            return this._normSign();
        // positive + negative
        } else if (this.negative === 0 && num.negative !== 0) {
            num.negative = 0;
            r = this.isub(num);
            num.negative = 1;
            return r._normSign();
        }
        // a.length > b.length
        var a, b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        this.length = a.length;
        if (carry !== 0) {
            this.words[this.length] = carry;
            this.length++;
        // Copy the rest of the words
        } else if (a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        return this;
    };
    // Add `num` to `this`
    BN.prototype.add = function add(num) {
        var res;
        if (num.negative !== 0 && this.negative === 0) {
            num.negative = 0;
            res = this.sub(num);
            num.negative ^= 1;
            return res;
        } else if (num.negative === 0 && this.negative !== 0) {
            this.negative = 0;
            res = num.sub(this);
            this.negative = 1;
            return res;
        }
        if (this.length > num.length) return this.clone().iadd(num);
        return num.clone().iadd(this);
    };
    // Subtract `num` from `this` in-place
    BN.prototype.isub = function isub(num) {
        // this - (-num) = this + num
        if (num.negative !== 0) {
            num.negative = 0;
            var r = this.iadd(num);
            num.negative = 1;
            return r._normSign();
        // -this - num = -(this + num)
        } else if (this.negative !== 0) {
            this.negative = 0;
            this.iadd(num);
            this.negative = 1;
            return this._normSign();
        }
        // At this point both numbers are positive
        var cmp = this.cmp(num);
        // Optimization - zeroify
        if (cmp === 0) {
            this.negative = 0;
            this.length = 1;
            this.words[0] = 0;
            return this;
        }
        // a > b
        var a, b;
        if (cmp > 0) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        // Copy rest of the words
        if (carry === 0 && i < a.length && a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = Math.max(this.length, i);
        if (a !== this) this.negative = 1;
        return this.strip();
    };
    // Subtract `num` from `this`
    BN.prototype.sub = function sub(num) {
        return this.clone().isub(num);
    };
    function smallMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        var len = self.length + num.length | 0;
        out.length = len;
        len = len - 1 | 0;
        // Peel one iteration (compiler can't do it, because of code complexity)
        var a = self.words[0] | 0;
        var b = num.words[0] | 0;
        var r = a * b;
        var lo = r & 0x3ffffff;
        var carry = r / 0x4000000 | 0;
        out.words[0] = lo;
        for(var k = 1; k < len; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = carry >>> 26;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j | 0;
                a = self.words[i] | 0;
                b = num.words[j] | 0;
                r = a * b + rword;
                ncarry += r / 0x4000000 | 0;
                rword = r & 0x3ffffff;
            }
            out.words[k] = rword | 0;
            carry = ncarry | 0;
        }
        if (carry !== 0) out.words[k] = carry | 0;
        else out.length--;
        return out.strip();
    }
    // TODO(indutny): it may be reasonable to omit it for users who don't need
    // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
    // multiplication (like elliptic secp256k1).
    var comb10MulTo = function comb10MulTo(self, num, out) {
        var a = self.words;
        var b = num.words;
        var o = out.words;
        var c = 0;
        var lo;
        var mid;
        var hi;
        var a0 = a[0] | 0;
        var al0 = a0 & 0x1fff;
        var ah0 = a0 >>> 13;
        var a1 = a[1] | 0;
        var al1 = a1 & 0x1fff;
        var ah1 = a1 >>> 13;
        var a2 = a[2] | 0;
        var al2 = a2 & 0x1fff;
        var ah2 = a2 >>> 13;
        var a3 = a[3] | 0;
        var al3 = a3 & 0x1fff;
        var ah3 = a3 >>> 13;
        var a4 = a[4] | 0;
        var al4 = a4 & 0x1fff;
        var ah4 = a4 >>> 13;
        var a5 = a[5] | 0;
        var al5 = a5 & 0x1fff;
        var ah5 = a5 >>> 13;
        var a6 = a[6] | 0;
        var al6 = a6 & 0x1fff;
        var ah6 = a6 >>> 13;
        var a7 = a[7] | 0;
        var al7 = a7 & 0x1fff;
        var ah7 = a7 >>> 13;
        var a8 = a[8] | 0;
        var al8 = a8 & 0x1fff;
        var ah8 = a8 >>> 13;
        var a9 = a[9] | 0;
        var al9 = a9 & 0x1fff;
        var ah9 = a9 >>> 13;
        var b0 = b[0] | 0;
        var bl0 = b0 & 0x1fff;
        var bh0 = b0 >>> 13;
        var b1 = b[1] | 0;
        var bl1 = b1 & 0x1fff;
        var bh1 = b1 >>> 13;
        var b2 = b[2] | 0;
        var bl2 = b2 & 0x1fff;
        var bh2 = b2 >>> 13;
        var b3 = b[3] | 0;
        var bl3 = b3 & 0x1fff;
        var bh3 = b3 >>> 13;
        var b4 = b[4] | 0;
        var bl4 = b4 & 0x1fff;
        var bh4 = b4 >>> 13;
        var b5 = b[5] | 0;
        var bl5 = b5 & 0x1fff;
        var bh5 = b5 >>> 13;
        var b6 = b[6] | 0;
        var bl6 = b6 & 0x1fff;
        var bh6 = b6 >>> 13;
        var b7 = b[7] | 0;
        var bl7 = b7 & 0x1fff;
        var bh7 = b7 >>> 13;
        var b8 = b[8] | 0;
        var bl8 = b8 & 0x1fff;
        var bh8 = b8 >>> 13;
        var b9 = b[9] | 0;
        var bl9 = b9 & 0x1fff;
        var bh9 = b9 >>> 13;
        out.negative = self.negative ^ num.negative;
        out.length = 19;
        /* k = 0 */ lo = Math.imul(al0, bl0);
        mid = Math.imul(al0, bh0);
        mid = mid + Math.imul(ah0, bl0) | 0;
        hi = Math.imul(ah0, bh0);
        var w0 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
        w0 &= 0x3ffffff;
        /* k = 1 */ lo = Math.imul(al1, bl0);
        mid = Math.imul(al1, bh0);
        mid = mid + Math.imul(ah1, bl0) | 0;
        hi = Math.imul(ah1, bh0);
        lo = lo + Math.imul(al0, bl1) | 0;
        mid = mid + Math.imul(al0, bh1) | 0;
        mid = mid + Math.imul(ah0, bl1) | 0;
        hi = hi + Math.imul(ah0, bh1) | 0;
        var w1 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
        w1 &= 0x3ffffff;
        /* k = 2 */ lo = Math.imul(al2, bl0);
        mid = Math.imul(al2, bh0);
        mid = mid + Math.imul(ah2, bl0) | 0;
        hi = Math.imul(ah2, bh0);
        lo = lo + Math.imul(al1, bl1) | 0;
        mid = mid + Math.imul(al1, bh1) | 0;
        mid = mid + Math.imul(ah1, bl1) | 0;
        hi = hi + Math.imul(ah1, bh1) | 0;
        lo = lo + Math.imul(al0, bl2) | 0;
        mid = mid + Math.imul(al0, bh2) | 0;
        mid = mid + Math.imul(ah0, bl2) | 0;
        hi = hi + Math.imul(ah0, bh2) | 0;
        var w2 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
        w2 &= 0x3ffffff;
        /* k = 3 */ lo = Math.imul(al3, bl0);
        mid = Math.imul(al3, bh0);
        mid = mid + Math.imul(ah3, bl0) | 0;
        hi = Math.imul(ah3, bh0);
        lo = lo + Math.imul(al2, bl1) | 0;
        mid = mid + Math.imul(al2, bh1) | 0;
        mid = mid + Math.imul(ah2, bl1) | 0;
        hi = hi + Math.imul(ah2, bh1) | 0;
        lo = lo + Math.imul(al1, bl2) | 0;
        mid = mid + Math.imul(al1, bh2) | 0;
        mid = mid + Math.imul(ah1, bl2) | 0;
        hi = hi + Math.imul(ah1, bh2) | 0;
        lo = lo + Math.imul(al0, bl3) | 0;
        mid = mid + Math.imul(al0, bh3) | 0;
        mid = mid + Math.imul(ah0, bl3) | 0;
        hi = hi + Math.imul(ah0, bh3) | 0;
        var w3 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
        w3 &= 0x3ffffff;
        /* k = 4 */ lo = Math.imul(al4, bl0);
        mid = Math.imul(al4, bh0);
        mid = mid + Math.imul(ah4, bl0) | 0;
        hi = Math.imul(ah4, bh0);
        lo = lo + Math.imul(al3, bl1) | 0;
        mid = mid + Math.imul(al3, bh1) | 0;
        mid = mid + Math.imul(ah3, bl1) | 0;
        hi = hi + Math.imul(ah3, bh1) | 0;
        lo = lo + Math.imul(al2, bl2) | 0;
        mid = mid + Math.imul(al2, bh2) | 0;
        mid = mid + Math.imul(ah2, bl2) | 0;
        hi = hi + Math.imul(ah2, bh2) | 0;
        lo = lo + Math.imul(al1, bl3) | 0;
        mid = mid + Math.imul(al1, bh3) | 0;
        mid = mid + Math.imul(ah1, bl3) | 0;
        hi = hi + Math.imul(ah1, bh3) | 0;
        lo = lo + Math.imul(al0, bl4) | 0;
        mid = mid + Math.imul(al0, bh4) | 0;
        mid = mid + Math.imul(ah0, bl4) | 0;
        hi = hi + Math.imul(ah0, bh4) | 0;
        var w4 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
        w4 &= 0x3ffffff;
        /* k = 5 */ lo = Math.imul(al5, bl0);
        mid = Math.imul(al5, bh0);
        mid = mid + Math.imul(ah5, bl0) | 0;
        hi = Math.imul(ah5, bh0);
        lo = lo + Math.imul(al4, bl1) | 0;
        mid = mid + Math.imul(al4, bh1) | 0;
        mid = mid + Math.imul(ah4, bl1) | 0;
        hi = hi + Math.imul(ah4, bh1) | 0;
        lo = lo + Math.imul(al3, bl2) | 0;
        mid = mid + Math.imul(al3, bh2) | 0;
        mid = mid + Math.imul(ah3, bl2) | 0;
        hi = hi + Math.imul(ah3, bh2) | 0;
        lo = lo + Math.imul(al2, bl3) | 0;
        mid = mid + Math.imul(al2, bh3) | 0;
        mid = mid + Math.imul(ah2, bl3) | 0;
        hi = hi + Math.imul(ah2, bh3) | 0;
        lo = lo + Math.imul(al1, bl4) | 0;
        mid = mid + Math.imul(al1, bh4) | 0;
        mid = mid + Math.imul(ah1, bl4) | 0;
        hi = hi + Math.imul(ah1, bh4) | 0;
        lo = lo + Math.imul(al0, bl5) | 0;
        mid = mid + Math.imul(al0, bh5) | 0;
        mid = mid + Math.imul(ah0, bl5) | 0;
        hi = hi + Math.imul(ah0, bh5) | 0;
        var w5 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
        w5 &= 0x3ffffff;
        /* k = 6 */ lo = Math.imul(al6, bl0);
        mid = Math.imul(al6, bh0);
        mid = mid + Math.imul(ah6, bl0) | 0;
        hi = Math.imul(ah6, bh0);
        lo = lo + Math.imul(al5, bl1) | 0;
        mid = mid + Math.imul(al5, bh1) | 0;
        mid = mid + Math.imul(ah5, bl1) | 0;
        hi = hi + Math.imul(ah5, bh1) | 0;
        lo = lo + Math.imul(al4, bl2) | 0;
        mid = mid + Math.imul(al4, bh2) | 0;
        mid = mid + Math.imul(ah4, bl2) | 0;
        hi = hi + Math.imul(ah4, bh2) | 0;
        lo = lo + Math.imul(al3, bl3) | 0;
        mid = mid + Math.imul(al3, bh3) | 0;
        mid = mid + Math.imul(ah3, bl3) | 0;
        hi = hi + Math.imul(ah3, bh3) | 0;
        lo = lo + Math.imul(al2, bl4) | 0;
        mid = mid + Math.imul(al2, bh4) | 0;
        mid = mid + Math.imul(ah2, bl4) | 0;
        hi = hi + Math.imul(ah2, bh4) | 0;
        lo = lo + Math.imul(al1, bl5) | 0;
        mid = mid + Math.imul(al1, bh5) | 0;
        mid = mid + Math.imul(ah1, bl5) | 0;
        hi = hi + Math.imul(ah1, bh5) | 0;
        lo = lo + Math.imul(al0, bl6) | 0;
        mid = mid + Math.imul(al0, bh6) | 0;
        mid = mid + Math.imul(ah0, bl6) | 0;
        hi = hi + Math.imul(ah0, bh6) | 0;
        var w6 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
        w6 &= 0x3ffffff;
        /* k = 7 */ lo = Math.imul(al7, bl0);
        mid = Math.imul(al7, bh0);
        mid = mid + Math.imul(ah7, bl0) | 0;
        hi = Math.imul(ah7, bh0);
        lo = lo + Math.imul(al6, bl1) | 0;
        mid = mid + Math.imul(al6, bh1) | 0;
        mid = mid + Math.imul(ah6, bl1) | 0;
        hi = hi + Math.imul(ah6, bh1) | 0;
        lo = lo + Math.imul(al5, bl2) | 0;
        mid = mid + Math.imul(al5, bh2) | 0;
        mid = mid + Math.imul(ah5, bl2) | 0;
        hi = hi + Math.imul(ah5, bh2) | 0;
        lo = lo + Math.imul(al4, bl3) | 0;
        mid = mid + Math.imul(al4, bh3) | 0;
        mid = mid + Math.imul(ah4, bl3) | 0;
        hi = hi + Math.imul(ah4, bh3) | 0;
        lo = lo + Math.imul(al3, bl4) | 0;
        mid = mid + Math.imul(al3, bh4) | 0;
        mid = mid + Math.imul(ah3, bl4) | 0;
        hi = hi + Math.imul(ah3, bh4) | 0;
        lo = lo + Math.imul(al2, bl5) | 0;
        mid = mid + Math.imul(al2, bh5) | 0;
        mid = mid + Math.imul(ah2, bl5) | 0;
        hi = hi + Math.imul(ah2, bh5) | 0;
        lo = lo + Math.imul(al1, bl6) | 0;
        mid = mid + Math.imul(al1, bh6) | 0;
        mid = mid + Math.imul(ah1, bl6) | 0;
        hi = hi + Math.imul(ah1, bh6) | 0;
        lo = lo + Math.imul(al0, bl7) | 0;
        mid = mid + Math.imul(al0, bh7) | 0;
        mid = mid + Math.imul(ah0, bl7) | 0;
        hi = hi + Math.imul(ah0, bh7) | 0;
        var w7 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
        w7 &= 0x3ffffff;
        /* k = 8 */ lo = Math.imul(al8, bl0);
        mid = Math.imul(al8, bh0);
        mid = mid + Math.imul(ah8, bl0) | 0;
        hi = Math.imul(ah8, bh0);
        lo = lo + Math.imul(al7, bl1) | 0;
        mid = mid + Math.imul(al7, bh1) | 0;
        mid = mid + Math.imul(ah7, bl1) | 0;
        hi = hi + Math.imul(ah7, bh1) | 0;
        lo = lo + Math.imul(al6, bl2) | 0;
        mid = mid + Math.imul(al6, bh2) | 0;
        mid = mid + Math.imul(ah6, bl2) | 0;
        hi = hi + Math.imul(ah6, bh2) | 0;
        lo = lo + Math.imul(al5, bl3) | 0;
        mid = mid + Math.imul(al5, bh3) | 0;
        mid = mid + Math.imul(ah5, bl3) | 0;
        hi = hi + Math.imul(ah5, bh3) | 0;
        lo = lo + Math.imul(al4, bl4) | 0;
        mid = mid + Math.imul(al4, bh4) | 0;
        mid = mid + Math.imul(ah4, bl4) | 0;
        hi = hi + Math.imul(ah4, bh4) | 0;
        lo = lo + Math.imul(al3, bl5) | 0;
        mid = mid + Math.imul(al3, bh5) | 0;
        mid = mid + Math.imul(ah3, bl5) | 0;
        hi = hi + Math.imul(ah3, bh5) | 0;
        lo = lo + Math.imul(al2, bl6) | 0;
        mid = mid + Math.imul(al2, bh6) | 0;
        mid = mid + Math.imul(ah2, bl6) | 0;
        hi = hi + Math.imul(ah2, bh6) | 0;
        lo = lo + Math.imul(al1, bl7) | 0;
        mid = mid + Math.imul(al1, bh7) | 0;
        mid = mid + Math.imul(ah1, bl7) | 0;
        hi = hi + Math.imul(ah1, bh7) | 0;
        lo = lo + Math.imul(al0, bl8) | 0;
        mid = mid + Math.imul(al0, bh8) | 0;
        mid = mid + Math.imul(ah0, bl8) | 0;
        hi = hi + Math.imul(ah0, bh8) | 0;
        var w8 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
        w8 &= 0x3ffffff;
        /* k = 9 */ lo = Math.imul(al9, bl0);
        mid = Math.imul(al9, bh0);
        mid = mid + Math.imul(ah9, bl0) | 0;
        hi = Math.imul(ah9, bh0);
        lo = lo + Math.imul(al8, bl1) | 0;
        mid = mid + Math.imul(al8, bh1) | 0;
        mid = mid + Math.imul(ah8, bl1) | 0;
        hi = hi + Math.imul(ah8, bh1) | 0;
        lo = lo + Math.imul(al7, bl2) | 0;
        mid = mid + Math.imul(al7, bh2) | 0;
        mid = mid + Math.imul(ah7, bl2) | 0;
        hi = hi + Math.imul(ah7, bh2) | 0;
        lo = lo + Math.imul(al6, bl3) | 0;
        mid = mid + Math.imul(al6, bh3) | 0;
        mid = mid + Math.imul(ah6, bl3) | 0;
        hi = hi + Math.imul(ah6, bh3) | 0;
        lo = lo + Math.imul(al5, bl4) | 0;
        mid = mid + Math.imul(al5, bh4) | 0;
        mid = mid + Math.imul(ah5, bl4) | 0;
        hi = hi + Math.imul(ah5, bh4) | 0;
        lo = lo + Math.imul(al4, bl5) | 0;
        mid = mid + Math.imul(al4, bh5) | 0;
        mid = mid + Math.imul(ah4, bl5) | 0;
        hi = hi + Math.imul(ah4, bh5) | 0;
        lo = lo + Math.imul(al3, bl6) | 0;
        mid = mid + Math.imul(al3, bh6) | 0;
        mid = mid + Math.imul(ah3, bl6) | 0;
        hi = hi + Math.imul(ah3, bh6) | 0;
        lo = lo + Math.imul(al2, bl7) | 0;
        mid = mid + Math.imul(al2, bh7) | 0;
        mid = mid + Math.imul(ah2, bl7) | 0;
        hi = hi + Math.imul(ah2, bh7) | 0;
        lo = lo + Math.imul(al1, bl8) | 0;
        mid = mid + Math.imul(al1, bh8) | 0;
        mid = mid + Math.imul(ah1, bl8) | 0;
        hi = hi + Math.imul(ah1, bh8) | 0;
        lo = lo + Math.imul(al0, bl9) | 0;
        mid = mid + Math.imul(al0, bh9) | 0;
        mid = mid + Math.imul(ah0, bl9) | 0;
        hi = hi + Math.imul(ah0, bh9) | 0;
        var w9 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
        w9 &= 0x3ffffff;
        /* k = 10 */ lo = Math.imul(al9, bl1);
        mid = Math.imul(al9, bh1);
        mid = mid + Math.imul(ah9, bl1) | 0;
        hi = Math.imul(ah9, bh1);
        lo = lo + Math.imul(al8, bl2) | 0;
        mid = mid + Math.imul(al8, bh2) | 0;
        mid = mid + Math.imul(ah8, bl2) | 0;
        hi = hi + Math.imul(ah8, bh2) | 0;
        lo = lo + Math.imul(al7, bl3) | 0;
        mid = mid + Math.imul(al7, bh3) | 0;
        mid = mid + Math.imul(ah7, bl3) | 0;
        hi = hi + Math.imul(ah7, bh3) | 0;
        lo = lo + Math.imul(al6, bl4) | 0;
        mid = mid + Math.imul(al6, bh4) | 0;
        mid = mid + Math.imul(ah6, bl4) | 0;
        hi = hi + Math.imul(ah6, bh4) | 0;
        lo = lo + Math.imul(al5, bl5) | 0;
        mid = mid + Math.imul(al5, bh5) | 0;
        mid = mid + Math.imul(ah5, bl5) | 0;
        hi = hi + Math.imul(ah5, bh5) | 0;
        lo = lo + Math.imul(al4, bl6) | 0;
        mid = mid + Math.imul(al4, bh6) | 0;
        mid = mid + Math.imul(ah4, bl6) | 0;
        hi = hi + Math.imul(ah4, bh6) | 0;
        lo = lo + Math.imul(al3, bl7) | 0;
        mid = mid + Math.imul(al3, bh7) | 0;
        mid = mid + Math.imul(ah3, bl7) | 0;
        hi = hi + Math.imul(ah3, bh7) | 0;
        lo = lo + Math.imul(al2, bl8) | 0;
        mid = mid + Math.imul(al2, bh8) | 0;
        mid = mid + Math.imul(ah2, bl8) | 0;
        hi = hi + Math.imul(ah2, bh8) | 0;
        lo = lo + Math.imul(al1, bl9) | 0;
        mid = mid + Math.imul(al1, bh9) | 0;
        mid = mid + Math.imul(ah1, bl9) | 0;
        hi = hi + Math.imul(ah1, bh9) | 0;
        var w10 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
        w10 &= 0x3ffffff;
        /* k = 11 */ lo = Math.imul(al9, bl2);
        mid = Math.imul(al9, bh2);
        mid = mid + Math.imul(ah9, bl2) | 0;
        hi = Math.imul(ah9, bh2);
        lo = lo + Math.imul(al8, bl3) | 0;
        mid = mid + Math.imul(al8, bh3) | 0;
        mid = mid + Math.imul(ah8, bl3) | 0;
        hi = hi + Math.imul(ah8, bh3) | 0;
        lo = lo + Math.imul(al7, bl4) | 0;
        mid = mid + Math.imul(al7, bh4) | 0;
        mid = mid + Math.imul(ah7, bl4) | 0;
        hi = hi + Math.imul(ah7, bh4) | 0;
        lo = lo + Math.imul(al6, bl5) | 0;
        mid = mid + Math.imul(al6, bh5) | 0;
        mid = mid + Math.imul(ah6, bl5) | 0;
        hi = hi + Math.imul(ah6, bh5) | 0;
        lo = lo + Math.imul(al5, bl6) | 0;
        mid = mid + Math.imul(al5, bh6) | 0;
        mid = mid + Math.imul(ah5, bl6) | 0;
        hi = hi + Math.imul(ah5, bh6) | 0;
        lo = lo + Math.imul(al4, bl7) | 0;
        mid = mid + Math.imul(al4, bh7) | 0;
        mid = mid + Math.imul(ah4, bl7) | 0;
        hi = hi + Math.imul(ah4, bh7) | 0;
        lo = lo + Math.imul(al3, bl8) | 0;
        mid = mid + Math.imul(al3, bh8) | 0;
        mid = mid + Math.imul(ah3, bl8) | 0;
        hi = hi + Math.imul(ah3, bh8) | 0;
        lo = lo + Math.imul(al2, bl9) | 0;
        mid = mid + Math.imul(al2, bh9) | 0;
        mid = mid + Math.imul(ah2, bl9) | 0;
        hi = hi + Math.imul(ah2, bh9) | 0;
        var w11 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
        w11 &= 0x3ffffff;
        /* k = 12 */ lo = Math.imul(al9, bl3);
        mid = Math.imul(al9, bh3);
        mid = mid + Math.imul(ah9, bl3) | 0;
        hi = Math.imul(ah9, bh3);
        lo = lo + Math.imul(al8, bl4) | 0;
        mid = mid + Math.imul(al8, bh4) | 0;
        mid = mid + Math.imul(ah8, bl4) | 0;
        hi = hi + Math.imul(ah8, bh4) | 0;
        lo = lo + Math.imul(al7, bl5) | 0;
        mid = mid + Math.imul(al7, bh5) | 0;
        mid = mid + Math.imul(ah7, bl5) | 0;
        hi = hi + Math.imul(ah7, bh5) | 0;
        lo = lo + Math.imul(al6, bl6) | 0;
        mid = mid + Math.imul(al6, bh6) | 0;
        mid = mid + Math.imul(ah6, bl6) | 0;
        hi = hi + Math.imul(ah6, bh6) | 0;
        lo = lo + Math.imul(al5, bl7) | 0;
        mid = mid + Math.imul(al5, bh7) | 0;
        mid = mid + Math.imul(ah5, bl7) | 0;
        hi = hi + Math.imul(ah5, bh7) | 0;
        lo = lo + Math.imul(al4, bl8) | 0;
        mid = mid + Math.imul(al4, bh8) | 0;
        mid = mid + Math.imul(ah4, bl8) | 0;
        hi = hi + Math.imul(ah4, bh8) | 0;
        lo = lo + Math.imul(al3, bl9) | 0;
        mid = mid + Math.imul(al3, bh9) | 0;
        mid = mid + Math.imul(ah3, bl9) | 0;
        hi = hi + Math.imul(ah3, bh9) | 0;
        var w12 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
        w12 &= 0x3ffffff;
        /* k = 13 */ lo = Math.imul(al9, bl4);
        mid = Math.imul(al9, bh4);
        mid = mid + Math.imul(ah9, bl4) | 0;
        hi = Math.imul(ah9, bh4);
        lo = lo + Math.imul(al8, bl5) | 0;
        mid = mid + Math.imul(al8, bh5) | 0;
        mid = mid + Math.imul(ah8, bl5) | 0;
        hi = hi + Math.imul(ah8, bh5) | 0;
        lo = lo + Math.imul(al7, bl6) | 0;
        mid = mid + Math.imul(al7, bh6) | 0;
        mid = mid + Math.imul(ah7, bl6) | 0;
        hi = hi + Math.imul(ah7, bh6) | 0;
        lo = lo + Math.imul(al6, bl7) | 0;
        mid = mid + Math.imul(al6, bh7) | 0;
        mid = mid + Math.imul(ah6, bl7) | 0;
        hi = hi + Math.imul(ah6, bh7) | 0;
        lo = lo + Math.imul(al5, bl8) | 0;
        mid = mid + Math.imul(al5, bh8) | 0;
        mid = mid + Math.imul(ah5, bl8) | 0;
        hi = hi + Math.imul(ah5, bh8) | 0;
        lo = lo + Math.imul(al4, bl9) | 0;
        mid = mid + Math.imul(al4, bh9) | 0;
        mid = mid + Math.imul(ah4, bl9) | 0;
        hi = hi + Math.imul(ah4, bh9) | 0;
        var w13 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
        w13 &= 0x3ffffff;
        /* k = 14 */ lo = Math.imul(al9, bl5);
        mid = Math.imul(al9, bh5);
        mid = mid + Math.imul(ah9, bl5) | 0;
        hi = Math.imul(ah9, bh5);
        lo = lo + Math.imul(al8, bl6) | 0;
        mid = mid + Math.imul(al8, bh6) | 0;
        mid = mid + Math.imul(ah8, bl6) | 0;
        hi = hi + Math.imul(ah8, bh6) | 0;
        lo = lo + Math.imul(al7, bl7) | 0;
        mid = mid + Math.imul(al7, bh7) | 0;
        mid = mid + Math.imul(ah7, bl7) | 0;
        hi = hi + Math.imul(ah7, bh7) | 0;
        lo = lo + Math.imul(al6, bl8) | 0;
        mid = mid + Math.imul(al6, bh8) | 0;
        mid = mid + Math.imul(ah6, bl8) | 0;
        hi = hi + Math.imul(ah6, bh8) | 0;
        lo = lo + Math.imul(al5, bl9) | 0;
        mid = mid + Math.imul(al5, bh9) | 0;
        mid = mid + Math.imul(ah5, bl9) | 0;
        hi = hi + Math.imul(ah5, bh9) | 0;
        var w14 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
        w14 &= 0x3ffffff;
        /* k = 15 */ lo = Math.imul(al9, bl6);
        mid = Math.imul(al9, bh6);
        mid = mid + Math.imul(ah9, bl6) | 0;
        hi = Math.imul(ah9, bh6);
        lo = lo + Math.imul(al8, bl7) | 0;
        mid = mid + Math.imul(al8, bh7) | 0;
        mid = mid + Math.imul(ah8, bl7) | 0;
        hi = hi + Math.imul(ah8, bh7) | 0;
        lo = lo + Math.imul(al7, bl8) | 0;
        mid = mid + Math.imul(al7, bh8) | 0;
        mid = mid + Math.imul(ah7, bl8) | 0;
        hi = hi + Math.imul(ah7, bh8) | 0;
        lo = lo + Math.imul(al6, bl9) | 0;
        mid = mid + Math.imul(al6, bh9) | 0;
        mid = mid + Math.imul(ah6, bl9) | 0;
        hi = hi + Math.imul(ah6, bh9) | 0;
        var w15 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
        w15 &= 0x3ffffff;
        /* k = 16 */ lo = Math.imul(al9, bl7);
        mid = Math.imul(al9, bh7);
        mid = mid + Math.imul(ah9, bl7) | 0;
        hi = Math.imul(ah9, bh7);
        lo = lo + Math.imul(al8, bl8) | 0;
        mid = mid + Math.imul(al8, bh8) | 0;
        mid = mid + Math.imul(ah8, bl8) | 0;
        hi = hi + Math.imul(ah8, bh8) | 0;
        lo = lo + Math.imul(al7, bl9) | 0;
        mid = mid + Math.imul(al7, bh9) | 0;
        mid = mid + Math.imul(ah7, bl9) | 0;
        hi = hi + Math.imul(ah7, bh9) | 0;
        var w16 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
        w16 &= 0x3ffffff;
        /* k = 17 */ lo = Math.imul(al9, bl8);
        mid = Math.imul(al9, bh8);
        mid = mid + Math.imul(ah9, bl8) | 0;
        hi = Math.imul(ah9, bh8);
        lo = lo + Math.imul(al8, bl9) | 0;
        mid = mid + Math.imul(al8, bh9) | 0;
        mid = mid + Math.imul(ah8, bl9) | 0;
        hi = hi + Math.imul(ah8, bh9) | 0;
        var w17 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
        w17 &= 0x3ffffff;
        /* k = 18 */ lo = Math.imul(al9, bl9);
        mid = Math.imul(al9, bh9);
        mid = mid + Math.imul(ah9, bl9) | 0;
        hi = Math.imul(ah9, bh9);
        var w18 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
        w18 &= 0x3ffffff;
        o[0] = w0;
        o[1] = w1;
        o[2] = w2;
        o[3] = w3;
        o[4] = w4;
        o[5] = w5;
        o[6] = w6;
        o[7] = w7;
        o[8] = w8;
        o[9] = w9;
        o[10] = w10;
        o[11] = w11;
        o[12] = w12;
        o[13] = w13;
        o[14] = w14;
        o[15] = w15;
        o[16] = w16;
        o[17] = w17;
        o[18] = w18;
        if (c !== 0) {
            o[19] = c;
            out.length++;
        }
        return out;
    };
    // Polyfill comb
    if (!Math.imul) comb10MulTo = smallMulTo;
    function bigMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        out.length = self.length + num.length;
        var carry = 0;
        var hncarry = 0;
        for(var k = 0; k < out.length - 1; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = hncarry;
            hncarry = 0;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j;
                var a = self.words[i] | 0;
                var b = num.words[j] | 0;
                var r = a * b;
                var lo = r & 0x3ffffff;
                ncarry = ncarry + (r / 0x4000000 | 0) | 0;
                lo = lo + rword | 0;
                rword = lo & 0x3ffffff;
                ncarry = ncarry + (lo >>> 26) | 0;
                hncarry += ncarry >>> 26;
                ncarry &= 0x3ffffff;
            }
            out.words[k] = rword;
            carry = ncarry;
            ncarry = hncarry;
        }
        if (carry !== 0) out.words[k] = carry;
        else out.length--;
        return out.strip();
    }
    function jumboMulTo(self, num, out) {
        var fftm = new FFTM();
        return fftm.mulp(self, num, out);
    }
    BN.prototype.mulTo = function mulTo(num, out) {
        var res;
        var len = this.length + num.length;
        if (this.length === 10 && num.length === 10) res = comb10MulTo(this, num, out);
        else if (len < 63) res = smallMulTo(this, num, out);
        else if (len < 1024) res = bigMulTo(this, num, out);
        else res = jumboMulTo(this, num, out);
        return res;
    };
    // Cooley-Tukey algorithm for FFT
    // slightly revisited to rely on looping instead of recursion
    function FFTM(x, y) {
        this.x = x;
        this.y = y;
    }
    FFTM.prototype.makeRBT = function makeRBT(N) {
        var t = new Array(N);
        var l = BN.prototype._countBits(N) - 1;
        for(var i = 0; i < N; i++)t[i] = this.revBin(i, l, N);
        return t;
    };
    // Returns binary-reversed representation of `x`
    FFTM.prototype.revBin = function revBin(x, l, N) {
        if (x === 0 || x === N - 1) return x;
        var rb = 0;
        for(var i = 0; i < l; i++){
            rb |= (x & 1) << l - i - 1;
            x >>= 1;
        }
        return rb;
    };
    // Performs "tweedling" phase, therefore 'emulating'
    // behaviour of the recursive algorithm
    FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
        for(var i = 0; i < N; i++){
            rtws[i] = rws[rbt[i]];
            itws[i] = iws[rbt[i]];
        }
    };
    FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
        this.permute(rbt, rws, iws, rtws, itws, N);
        for(var s = 1; s < N; s <<= 1){
            var l = s << 1;
            var rtwdf = Math.cos(2 * Math.PI / l);
            var itwdf = Math.sin(2 * Math.PI / l);
            for(var p = 0; p < N; p += l){
                var rtwdf_ = rtwdf;
                var itwdf_ = itwdf;
                for(var j = 0; j < s; j++){
                    var re = rtws[p + j];
                    var ie = itws[p + j];
                    var ro = rtws[p + j + s];
                    var io = itws[p + j + s];
                    var rx = rtwdf_ * ro - itwdf_ * io;
                    io = rtwdf_ * io + itwdf_ * ro;
                    ro = rx;
                    rtws[p + j] = re + ro;
                    itws[p + j] = ie + io;
                    rtws[p + j + s] = re - ro;
                    itws[p + j + s] = ie - io;
                    /* jshint maxdepth : false */ if (j !== l) {
                        rx = rtwdf * rtwdf_ - itwdf * itwdf_;
                        itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                        rtwdf_ = rx;
                    }
                }
            }
        }
    };
    FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
        var N = Math.max(m, n) | 1;
        var odd = N & 1;
        var i = 0;
        for(N = N / 2 | 0; N; N = N >>> 1)i++;
        return 1 << i + 1 + odd;
    };
    FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
        if (N <= 1) return;
        for(var i = 0; i < N / 2; i++){
            var t = rws[i];
            rws[i] = rws[N - i - 1];
            rws[N - i - 1] = t;
            t = iws[i];
            iws[i] = -iws[N - i - 1];
            iws[N - i - 1] = -t;
        }
    };
    FFTM.prototype.normalize13b = function normalize13b(ws, N) {
        var carry = 0;
        for(var i = 0; i < N / 2; i++){
            var w = Math.round(ws[2 * i + 1] / N) * 0x2000 + Math.round(ws[2 * i] / N) + carry;
            ws[i] = w & 0x3ffffff;
            if (w < 0x4000000) carry = 0;
            else carry = w / 0x4000000 | 0;
        }
        return ws;
    };
    FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
        var carry = 0;
        for(var i = 0; i < len; i++){
            carry = carry + (ws[i] | 0);
            rws[2 * i] = carry & 0x1fff;
            carry = carry >>> 13;
            rws[2 * i + 1] = carry & 0x1fff;
            carry = carry >>> 13;
        }
        // Pad with zeroes
        for(i = 2 * len; i < N; ++i)rws[i] = 0;
        assert(carry === 0);
        assert((carry & -8192) === 0);
    };
    FFTM.prototype.stub = function stub(N) {
        var ph = new Array(N);
        for(var i = 0; i < N; i++)ph[i] = 0;
        return ph;
    };
    FFTM.prototype.mulp = function mulp(x, y, out) {
        var N = 2 * this.guessLen13b(x.length, y.length);
        var rbt = this.makeRBT(N);
        var _ = this.stub(N);
        var rws = new Array(N);
        var rwst = new Array(N);
        var iwst = new Array(N);
        var nrws = new Array(N);
        var nrwst = new Array(N);
        var niwst = new Array(N);
        var rmws = out.words;
        rmws.length = N;
        this.convert13b(x.words, x.length, rws, N);
        this.convert13b(y.words, y.length, nrws, N);
        this.transform(rws, _, rwst, iwst, N, rbt);
        this.transform(nrws, _, nrwst, niwst, N, rbt);
        for(var i = 0; i < N; i++){
            var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
            iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
            rwst[i] = rx;
        }
        this.conjugate(rwst, iwst, N);
        this.transform(rwst, iwst, rmws, _, N, rbt);
        this.conjugate(rmws, _, N);
        this.normalize13b(rmws, N);
        out.negative = x.negative ^ y.negative;
        out.length = x.length + y.length;
        return out.strip();
    };
    // Multiply `this` by `num`
    BN.prototype.mul = function mul(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return this.mulTo(num, out);
    };
    // Multiply employing FFT
    BN.prototype.mulf = function mulf(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return jumboMulTo(this, num, out);
    };
    // In-place Multiplication
    BN.prototype.imul = function imul(num) {
        return this.clone().mulTo(num, this);
    };
    BN.prototype.imuln = function imuln(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        // Carry
        var carry = 0;
        for(var i = 0; i < this.length; i++){
            var w = (this.words[i] | 0) * num;
            var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
            carry >>= 26;
            carry += w / 0x4000000 | 0;
            // NOTE: lo is 27bit maximum
            carry += lo >>> 26;
            this.words[i] = lo & 0x3ffffff;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.muln = function muln(num) {
        return this.clone().imuln(num);
    };
    // `this` * `this`
    BN.prototype.sqr = function sqr() {
        return this.mul(this);
    };
    // `this` * `this` in-place
    BN.prototype.isqr = function isqr() {
        return this.imul(this.clone());
    };
    // Math.pow(`this`, `num`)
    BN.prototype.pow = function pow(num) {
        var w = toBitArray(num);
        if (w.length === 0) return new BN(1);
        // Skip leading zeroes
        var res = this;
        for(var i = 0; i < w.length; i++, res = res.sqr()){
            if (w[i] !== 0) break;
        }
        if (++i < w.length) for(var q = res.sqr(); i < w.length; i++, q = q.sqr()){
            if (w[i] === 0) continue;
            res = res.mul(q);
        }
        return res;
    };
    // Shift-left in-place
    BN.prototype.iushln = function iushln(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        var carryMask = 0x3ffffff >>> 26 - r << 26 - r;
        var i;
        if (r !== 0) {
            var carry = 0;
            for(i = 0; i < this.length; i++){
                var newCarry = this.words[i] & carryMask;
                var c = (this.words[i] | 0) - newCarry << r;
                this.words[i] = c | carry;
                carry = newCarry >>> 26 - r;
            }
            if (carry) {
                this.words[i] = carry;
                this.length++;
            }
        }
        if (s !== 0) {
            for(i = this.length - 1; i >= 0; i--)this.words[i + s] = this.words[i];
            for(i = 0; i < s; i++)this.words[i] = 0;
            this.length += s;
        }
        return this.strip();
    };
    BN.prototype.ishln = function ishln(bits) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushln(bits);
    };
    // Shift-right in-place
    // NOTE: `hint` is a lowest bit before trailing zeroes
    // NOTE: if `extended` is present - it will be filled with destroyed bits
    BN.prototype.iushrn = function iushrn(bits, hint, extended) {
        assert(typeof bits === "number" && bits >= 0);
        var h;
        if (hint) h = (hint - hint % 26) / 26;
        else h = 0;
        var r = bits % 26;
        var s = Math.min((bits - r) / 26, this.length);
        var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
        var maskedWords = extended;
        h -= s;
        h = Math.max(0, h);
        // Extended mode, copy masked part
        if (maskedWords) {
            for(var i = 0; i < s; i++)maskedWords.words[i] = this.words[i];
            maskedWords.length = s;
        }
        if (s === 0) ;
        else if (this.length > s) {
            this.length -= s;
            for(i = 0; i < this.length; i++)this.words[i] = this.words[i + s];
        } else {
            this.words[0] = 0;
            this.length = 1;
        }
        var carry = 0;
        for(i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--){
            var word = this.words[i] | 0;
            this.words[i] = carry << 26 - r | word >>> r;
            carry = word & mask;
        }
        // Push carried bits as a mask
        if (maskedWords && carry !== 0) maskedWords.words[maskedWords.length++] = carry;
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this.strip();
    };
    BN.prototype.ishrn = function ishrn(bits, hint, extended) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushrn(bits, hint, extended);
    };
    // Shift-left
    BN.prototype.shln = function shln(bits) {
        return this.clone().ishln(bits);
    };
    BN.prototype.ushln = function ushln(bits) {
        return this.clone().iushln(bits);
    };
    // Shift-right
    BN.prototype.shrn = function shrn(bits) {
        return this.clone().ishrn(bits);
    };
    BN.prototype.ushrn = function ushrn(bits) {
        return this.clone().iushrn(bits);
    };
    // Test if n bit is set
    BN.prototype.testn = function testn(bit) {
        assert(typeof bit === "number" && bit >= 0);
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) return false;
        // Check bit and return
        var w = this.words[s];
        return !!(w & q);
    };
    // Return only lowers bits of number (in-place)
    BN.prototype.imaskn = function imaskn(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        assert(this.negative === 0, "imaskn works only with positive numbers");
        if (this.length <= s) return this;
        if (r !== 0) s++;
        this.length = Math.min(s, this.length);
        if (r !== 0) {
            var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
            this.words[this.length - 1] &= mask;
        }
        return this.strip();
    };
    // Return only lowers bits of number
    BN.prototype.maskn = function maskn(bits) {
        return this.clone().imaskn(bits);
    };
    // Add plain number `num` to `this`
    BN.prototype.iaddn = function iaddn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.isubn(-num);
        // Possible sign change
        if (this.negative !== 0) {
            if (this.length === 1 && (this.words[0] | 0) < num) {
                this.words[0] = num - (this.words[0] | 0);
                this.negative = 0;
                return this;
            }
            this.negative = 0;
            this.isubn(num);
            this.negative = 1;
            return this;
        }
        // Add without checks
        return this._iaddn(num);
    };
    BN.prototype._iaddn = function _iaddn(num) {
        this.words[0] += num;
        // Carry
        for(var i = 0; i < this.length && this.words[i] >= 0x4000000; i++){
            this.words[i] -= 0x4000000;
            if (i === this.length - 1) this.words[i + 1] = 1;
            else this.words[i + 1]++;
        }
        this.length = Math.max(this.length, i + 1);
        return this;
    };
    // Subtract plain number `num` from `this`
    BN.prototype.isubn = function isubn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.iaddn(-num);
        if (this.negative !== 0) {
            this.negative = 0;
            this.iaddn(num);
            this.negative = 1;
            return this;
        }
        this.words[0] -= num;
        if (this.length === 1 && this.words[0] < 0) {
            this.words[0] = -this.words[0];
            this.negative = 1;
        } else // Carry
        for(var i = 0; i < this.length && this.words[i] < 0; i++){
            this.words[i] += 0x4000000;
            this.words[i + 1] -= 1;
        }
        return this.strip();
    };
    BN.prototype.addn = function addn(num) {
        return this.clone().iaddn(num);
    };
    BN.prototype.subn = function subn(num) {
        return this.clone().isubn(num);
    };
    BN.prototype.iabs = function iabs() {
        this.negative = 0;
        return this;
    };
    BN.prototype.abs = function abs() {
        return this.clone().iabs();
    };
    BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
        var len = num.length + shift;
        var i;
        this._expand(len);
        var w;
        var carry = 0;
        for(i = 0; i < num.length; i++){
            w = (this.words[i + shift] | 0) + carry;
            var right = (num.words[i] | 0) * mul;
            w -= right & 0x3ffffff;
            carry = (w >> 26) - (right / 0x4000000 | 0);
            this.words[i + shift] = w & 0x3ffffff;
        }
        for(; i < this.length - shift; i++){
            w = (this.words[i + shift] | 0) + carry;
            carry = w >> 26;
            this.words[i + shift] = w & 0x3ffffff;
        }
        if (carry === 0) return this.strip();
        // Subtraction overflow
        assert(carry === -1);
        carry = 0;
        for(i = 0; i < this.length; i++){
            w = -(this.words[i] | 0) + carry;
            carry = w >> 26;
            this.words[i] = w & 0x3ffffff;
        }
        this.negative = 1;
        return this.strip();
    };
    BN.prototype._wordDiv = function _wordDiv(num, mode) {
        var shift = this.length - num.length;
        var a = this.clone();
        var b = num;
        // Normalize
        var bhi = b.words[b.length - 1] | 0;
        var bhiBits = this._countBits(bhi);
        shift = 26 - bhiBits;
        if (shift !== 0) {
            b = b.ushln(shift);
            a.iushln(shift);
            bhi = b.words[b.length - 1] | 0;
        }
        // Initialize quotient
        var m = a.length - b.length;
        var q;
        if (mode !== "mod") {
            q = new BN(null);
            q.length = m + 1;
            q.words = new Array(q.length);
            for(var i = 0; i < q.length; i++)q.words[i] = 0;
        }
        var diff = a.clone()._ishlnsubmul(b, 1, m);
        if (diff.negative === 0) {
            a = diff;
            if (q) q.words[m] = 1;
        }
        for(var j = m - 1; j >= 0; j--){
            var qj = (a.words[b.length + j] | 0) * 0x4000000 + (a.words[b.length + j - 1] | 0);
            // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
            // (0x7ffffff)
            qj = Math.min(qj / bhi | 0, 0x3ffffff);
            a._ishlnsubmul(b, qj, j);
            while(a.negative !== 0){
                qj--;
                a.negative = 0;
                a._ishlnsubmul(b, 1, j);
                if (!a.isZero()) a.negative ^= 1;
            }
            if (q) q.words[j] = qj;
        }
        if (q) q.strip();
        a.strip();
        // Denormalize
        if (mode !== "div" && shift !== 0) a.iushrn(shift);
        return {
            div: q || null,
            mod: a
        };
    };
    // NOTE: 1) `mode` can be set to `mod` to request mod only,
    //       to `div` to request div only, or be absent to
    //       request both div & mod
    //       2) `positive` is true if unsigned mod is requested
    BN.prototype.divmod = function divmod(num, mode, positive) {
        assert(!num.isZero());
        if (this.isZero()) return {
            div: new BN(0),
            mod: new BN(0)
        };
        var div, mod, res;
        if (this.negative !== 0 && num.negative === 0) {
            res = this.neg().divmod(num, mode);
            if (mode !== "mod") div = res.div.neg();
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.iadd(num);
            }
            return {
                div: div,
                mod: mod
            };
        }
        if (this.negative === 0 && num.negative !== 0) {
            res = this.divmod(num.neg(), mode);
            if (mode !== "mod") div = res.div.neg();
            return {
                div: div,
                mod: res.mod
            };
        }
        if ((this.negative & num.negative) !== 0) {
            res = this.neg().divmod(num.neg(), mode);
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.isub(num);
            }
            return {
                div: res.div,
                mod: mod
            };
        }
        // Both numbers are positive at this point
        // Strip both numbers to approximate shift value
        if (num.length > this.length || this.cmp(num) < 0) return {
            div: new BN(0),
            mod: this
        };
        // Very short reduction
        if (num.length === 1) {
            if (mode === "div") return {
                div: this.divn(num.words[0]),
                mod: null
            };
            if (mode === "mod") return {
                div: null,
                mod: new BN(this.modn(num.words[0]))
            };
            return {
                div: this.divn(num.words[0]),
                mod: new BN(this.modn(num.words[0]))
            };
        }
        return this._wordDiv(num, mode);
    };
    // Find `this` / `num`
    BN.prototype.div = function div(num) {
        return this.divmod(num, "div", false).div;
    };
    // Find `this` % `num`
    BN.prototype.mod = function mod(num) {
        return this.divmod(num, "mod", false).mod;
    };
    BN.prototype.umod = function umod(num) {
        return this.divmod(num, "mod", true).mod;
    };
    // Find Round(`this` / `num`)
    BN.prototype.divRound = function divRound(num) {
        var dm = this.divmod(num);
        // Fast case - exact division
        if (dm.mod.isZero()) return dm.div;
        var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;
        var half = num.ushrn(1);
        var r2 = num.andln(1);
        var cmp = mod.cmp(half);
        // Round down
        if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
        // Round up
        return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
    };
    BN.prototype.modn = function modn(num) {
        assert(num <= 0x3ffffff);
        var p = 67108864 % num;
        var acc = 0;
        for(var i = this.length - 1; i >= 0; i--)acc = (p * acc + (this.words[i] | 0)) % num;
        return acc;
    };
    // In-place division by number
    BN.prototype.idivn = function idivn(num) {
        assert(num <= 0x3ffffff);
        var carry = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var w = (this.words[i] | 0) + carry * 0x4000000;
            this.words[i] = w / num | 0;
            carry = w % num;
        }
        return this.strip();
    };
    BN.prototype.divn = function divn(num) {
        return this.clone().idivn(num);
    };
    BN.prototype.egcd = function egcd(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var x = this;
        var y = p.clone();
        if (x.negative !== 0) x = x.umod(p);
        else x = x.clone();
        // A * x + B * y = x
        var A = new BN(1);
        var B = new BN(0);
        // C * x + D * y = y
        var C = new BN(0);
        var D = new BN(1);
        var g = 0;
        while(x.isEven() && y.isEven()){
            x.iushrn(1);
            y.iushrn(1);
            ++g;
        }
        var yp = y.clone();
        var xp = x.clone();
        while(!x.isZero()){
            for(var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                x.iushrn(i);
                while(i-- > 0){
                    if (A.isOdd() || B.isOdd()) {
                        A.iadd(yp);
                        B.isub(xp);
                    }
                    A.iushrn(1);
                    B.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                y.iushrn(j);
                while(j-- > 0){
                    if (C.isOdd() || D.isOdd()) {
                        C.iadd(yp);
                        D.isub(xp);
                    }
                    C.iushrn(1);
                    D.iushrn(1);
                }
            }
            if (x.cmp(y) >= 0) {
                x.isub(y);
                A.isub(C);
                B.isub(D);
            } else {
                y.isub(x);
                C.isub(A);
                D.isub(B);
            }
        }
        return {
            a: C,
            b: D,
            gcd: y.iushln(g)
        };
    };
    // This is reduced incarnation of the binary EEA
    // above, designated to invert members of the
    // _prime_ fields F(p) at a maximal speed
    BN.prototype._invmp = function _invmp(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var a = this;
        var b = p.clone();
        if (a.negative !== 0) a = a.umod(p);
        else a = a.clone();
        var x1 = new BN(1);
        var x2 = new BN(0);
        var delta = b.clone();
        while(a.cmpn(1) > 0 && b.cmpn(1) > 0){
            for(var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                a.iushrn(i);
                while(i-- > 0){
                    if (x1.isOdd()) x1.iadd(delta);
                    x1.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                b.iushrn(j);
                while(j-- > 0){
                    if (x2.isOdd()) x2.iadd(delta);
                    x2.iushrn(1);
                }
            }
            if (a.cmp(b) >= 0) {
                a.isub(b);
                x1.isub(x2);
            } else {
                b.isub(a);
                x2.isub(x1);
            }
        }
        var res;
        if (a.cmpn(1) === 0) res = x1;
        else res = x2;
        if (res.cmpn(0) < 0) res.iadd(p);
        return res;
    };
    BN.prototype.gcd = function gcd(num) {
        if (this.isZero()) return num.abs();
        if (num.isZero()) return this.abs();
        var a = this.clone();
        var b = num.clone();
        a.negative = 0;
        b.negative = 0;
        // Remove common factor of two
        for(var shift = 0; a.isEven() && b.isEven(); shift++){
            a.iushrn(1);
            b.iushrn(1);
        }
        do {
            while(a.isEven())a.iushrn(1);
            while(b.isEven())b.iushrn(1);
            var r = a.cmp(b);
            if (r < 0) {
                // Swap `a` and `b` to make `a` always bigger than `b`
                var t = a;
                a = b;
                b = t;
            } else if (r === 0 || b.cmpn(1) === 0) break;
            a.isub(b);
        }while (true);
        return b.iushln(shift);
    };
    // Invert number in the field F(num)
    BN.prototype.invm = function invm(num) {
        return this.egcd(num).a.umod(num);
    };
    BN.prototype.isEven = function isEven() {
        return (this.words[0] & 1) === 0;
    };
    BN.prototype.isOdd = function isOdd() {
        return (this.words[0] & 1) === 1;
    };
    // And first word and num
    BN.prototype.andln = function andln(num) {
        return this.words[0] & num;
    };
    // Increment at the bit position in-line
    BN.prototype.bincn = function bincn(bit) {
        assert(typeof bit === "number");
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) {
            this._expand(s + 1);
            this.words[s] |= q;
            return this;
        }
        // Add bit and propagate, if needed
        var carry = q;
        for(var i = s; carry !== 0 && i < this.length; i++){
            var w = this.words[i] | 0;
            w += carry;
            carry = w >>> 26;
            w &= 0x3ffffff;
            this.words[i] = w;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.isZero = function isZero() {
        return this.length === 1 && this.words[0] === 0;
    };
    BN.prototype.cmpn = function cmpn(num) {
        var negative = num < 0;
        if (this.negative !== 0 && !negative) return -1;
        if (this.negative === 0 && negative) return 1;
        this.strip();
        var res;
        if (this.length > 1) res = 1;
        else {
            if (negative) num = -num;
            assert(num <= 0x3ffffff, "Number is too big");
            var w = this.words[0] | 0;
            res = w === num ? 0 : w < num ? -1 : 1;
        }
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Compare two numbers and return:
    // 1 - if `this` > `num`
    // 0 - if `this` == `num`
    // -1 - if `this` < `num`
    BN.prototype.cmp = function cmp(num) {
        if (this.negative !== 0 && num.negative === 0) return -1;
        if (this.negative === 0 && num.negative !== 0) return 1;
        var res = this.ucmp(num);
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Unsigned comparison
    BN.prototype.ucmp = function ucmp(num) {
        // At this point both numbers have the same sign
        if (this.length > num.length) return 1;
        if (this.length < num.length) return -1;
        var res = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var a = this.words[i] | 0;
            var b = num.words[i] | 0;
            if (a === b) continue;
            if (a < b) res = -1;
            else if (a > b) res = 1;
            break;
        }
        return res;
    };
    BN.prototype.gtn = function gtn(num) {
        return this.cmpn(num) === 1;
    };
    BN.prototype.gt = function gt(num) {
        return this.cmp(num) === 1;
    };
    BN.prototype.gten = function gten(num) {
        return this.cmpn(num) >= 0;
    };
    BN.prototype.gte = function gte(num) {
        return this.cmp(num) >= 0;
    };
    BN.prototype.ltn = function ltn(num) {
        return this.cmpn(num) === -1;
    };
    BN.prototype.lt = function lt(num) {
        return this.cmp(num) === -1;
    };
    BN.prototype.lten = function lten(num) {
        return this.cmpn(num) <= 0;
    };
    BN.prototype.lte = function lte(num) {
        return this.cmp(num) <= 0;
    };
    BN.prototype.eqn = function eqn(num) {
        return this.cmpn(num) === 0;
    };
    BN.prototype.eq = function eq(num) {
        return this.cmp(num) === 0;
    };
    //
    // A reduce context, could be using montgomery or something better, depending
    // on the `m` itself.
    //
    BN.red = function red(num) {
        return new Red(num);
    };
    BN.prototype.toRed = function toRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        assert(this.negative === 0, "red works only with positives");
        return ctx.convertTo(this)._forceRed(ctx);
    };
    BN.prototype.fromRed = function fromRed() {
        assert(this.red, "fromRed works only with numbers in reduction context");
        return this.red.convertFrom(this);
    };
    BN.prototype._forceRed = function _forceRed(ctx) {
        this.red = ctx;
        return this;
    };
    BN.prototype.forceRed = function forceRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        return this._forceRed(ctx);
    };
    BN.prototype.redAdd = function redAdd(num) {
        assert(this.red, "redAdd works only with red numbers");
        return this.red.add(this, num);
    };
    BN.prototype.redIAdd = function redIAdd(num) {
        assert(this.red, "redIAdd works only with red numbers");
        return this.red.iadd(this, num);
    };
    BN.prototype.redSub = function redSub(num) {
        assert(this.red, "redSub works only with red numbers");
        return this.red.sub(this, num);
    };
    BN.prototype.redISub = function redISub(num) {
        assert(this.red, "redISub works only with red numbers");
        return this.red.isub(this, num);
    };
    BN.prototype.redShl = function redShl(num) {
        assert(this.red, "redShl works only with red numbers");
        return this.red.shl(this, num);
    };
    BN.prototype.redMul = function redMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.mul(this, num);
    };
    BN.prototype.redIMul = function redIMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.imul(this, num);
    };
    BN.prototype.redSqr = function redSqr() {
        assert(this.red, "redSqr works only with red numbers");
        this.red._verify1(this);
        return this.red.sqr(this);
    };
    BN.prototype.redISqr = function redISqr() {
        assert(this.red, "redISqr works only with red numbers");
        this.red._verify1(this);
        return this.red.isqr(this);
    };
    // Square root over p
    BN.prototype.redSqrt = function redSqrt() {
        assert(this.red, "redSqrt works only with red numbers");
        this.red._verify1(this);
        return this.red.sqrt(this);
    };
    BN.prototype.redInvm = function redInvm() {
        assert(this.red, "redInvm works only with red numbers");
        this.red._verify1(this);
        return this.red.invm(this);
    };
    // Return negative clone of `this` % `red modulo`
    BN.prototype.redNeg = function redNeg() {
        assert(this.red, "redNeg works only with red numbers");
        this.red._verify1(this);
        return this.red.neg(this);
    };
    BN.prototype.redPow = function redPow(num) {
        assert(this.red && !num.red, "redPow(normalNum)");
        this.red._verify1(this);
        return this.red.pow(this, num);
    };
    // Prime numbers with efficient reduction
    var primes = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
    };
    // Pseudo-Mersenne prime
    function MPrime(name, p) {
        // P = 2 ^ N - K
        this.name = name;
        this.p = new BN(p, 16);
        this.n = this.p.bitLength();
        this.k = new BN(1).iushln(this.n).isub(this.p);
        this.tmp = this._tmp();
    }
    MPrime.prototype._tmp = function _tmp() {
        var tmp = new BN(null);
        tmp.words = new Array(Math.ceil(this.n / 13));
        return tmp;
    };
    MPrime.prototype.ireduce = function ireduce(num) {
        // Assumes that `num` is less than `P^2`
        // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
        var r = num;
        var rlen;
        do {
            this.split(r, this.tmp);
            r = this.imulK(r);
            r = r.iadd(this.tmp);
            rlen = r.bitLength();
        }while (rlen > this.n);
        var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
        if (cmp === 0) {
            r.words[0] = 0;
            r.length = 1;
        } else if (cmp > 0) r.isub(this.p);
        else r.strip();
        return r;
    };
    MPrime.prototype.split = function split(input, out) {
        input.iushrn(this.n, 0, out);
    };
    MPrime.prototype.imulK = function imulK(num) {
        return num.imul(this.k);
    };
    function K256() {
        MPrime.call(this, "k256", "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f");
    }
    inherits(K256, MPrime);
    K256.prototype.split = function split(input, output) {
        // 256 = 9 * 26 + 22
        var mask = 0x3fffff;
        var outLen = Math.min(input.length, 9);
        for(var i = 0; i < outLen; i++)output.words[i] = input.words[i];
        output.length = outLen;
        if (input.length <= 9) {
            input.words[0] = 0;
            input.length = 1;
            return;
        }
        // Shift by 9 limbs
        var prev = input.words[9];
        output.words[output.length++] = prev & mask;
        for(i = 10; i < input.length; i++){
            var next = input.words[i] | 0;
            input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
            prev = next;
        }
        prev >>>= 22;
        input.words[i - 10] = prev;
        if (prev === 0 && input.length > 10) input.length -= 10;
        else input.length -= 9;
    };
    K256.prototype.imulK = function imulK(num) {
        // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
        num.words[num.length] = 0;
        num.words[num.length + 1] = 0;
        num.length += 2;
        // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
        var lo = 0;
        for(var i = 0; i < num.length; i++){
            var w = num.words[i] | 0;
            lo += w * 0x3d1;
            num.words[i] = lo & 0x3ffffff;
            lo = w * 0x40 + (lo / 0x4000000 | 0);
        }
        // Fast length reduction
        if (num.words[num.length - 1] === 0) {
            num.length--;
            if (num.words[num.length - 1] === 0) num.length--;
        }
        return num;
    };
    function P224() {
        MPrime.call(this, "p224", "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001");
    }
    inherits(P224, MPrime);
    function P192() {
        MPrime.call(this, "p192", "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff");
    }
    inherits(P192, MPrime);
    function P25519() {
        // 2 ^ 255 - 19
        MPrime.call(this, "25519", "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed");
    }
    inherits(P25519, MPrime);
    P25519.prototype.imulK = function imulK(num) {
        // K = 0x13
        var carry = 0;
        for(var i = 0; i < num.length; i++){
            var hi = (num.words[i] | 0) * 0x13 + carry;
            var lo = hi & 0x3ffffff;
            hi >>>= 26;
            num.words[i] = lo;
            carry = hi;
        }
        if (carry !== 0) num.words[num.length++] = carry;
        return num;
    };
    // Exported mostly for testing purposes, use plain name instead
    BN._prime = function prime(name) {
        // Cached version of prime
        if (primes[name]) return primes[name];
        var prime;
        if (name === "k256") prime = new K256();
        else if (name === "p224") prime = new P224();
        else if (name === "p192") prime = new P192();
        else if (name === "p25519") prime = new P25519();
        else throw new Error("Unknown prime " + name);
        primes[name] = prime;
        return prime;
    };
    //
    // Base reduction engine
    //
    function Red(m) {
        if (typeof m === "string") {
            var prime = BN._prime(m);
            this.m = prime.p;
            this.prime = prime;
        } else {
            assert(m.gtn(1), "modulus must be greater than 1");
            this.m = m;
            this.prime = null;
        }
    }
    Red.prototype._verify1 = function _verify1(a) {
        assert(a.negative === 0, "red works only with positives");
        assert(a.red, "red works only with red numbers");
    };
    Red.prototype._verify2 = function _verify2(a, b) {
        assert((a.negative | b.negative) === 0, "red works only with positives");
        assert(a.red && a.red === b.red, "red works only with red numbers");
    };
    Red.prototype.imod = function imod(a) {
        if (this.prime) return this.prime.ireduce(a)._forceRed(this);
        return a.umod(this.m)._forceRed(this);
    };
    Red.prototype.neg = function neg(a) {
        if (a.isZero()) return a.clone();
        return this.m.sub(a)._forceRed(this);
    };
    Red.prototype.add = function add(a, b) {
        this._verify2(a, b);
        var res = a.add(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res._forceRed(this);
    };
    Red.prototype.iadd = function iadd(a, b) {
        this._verify2(a, b);
        var res = a.iadd(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res;
    };
    Red.prototype.sub = function sub(a, b) {
        this._verify2(a, b);
        var res = a.sub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res._forceRed(this);
    };
    Red.prototype.isub = function isub(a, b) {
        this._verify2(a, b);
        var res = a.isub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res;
    };
    Red.prototype.shl = function shl(a, num) {
        this._verify1(a);
        return this.imod(a.ushln(num));
    };
    Red.prototype.imul = function imul(a, b) {
        this._verify2(a, b);
        return this.imod(a.imul(b));
    };
    Red.prototype.mul = function mul(a, b) {
        this._verify2(a, b);
        return this.imod(a.mul(b));
    };
    Red.prototype.isqr = function isqr(a) {
        return this.imul(a, a.clone());
    };
    Red.prototype.sqr = function sqr(a) {
        return this.mul(a, a);
    };
    Red.prototype.sqrt = function sqrt(a) {
        if (a.isZero()) return a.clone();
        var mod3 = this.m.andln(3);
        assert(mod3 % 2 === 1);
        // Fast case
        if (mod3 === 3) {
            var pow = this.m.add(new BN(1)).iushrn(2);
            return this.pow(a, pow);
        }
        // Tonelli-Shanks algorithm (Totally unoptimized and slow)
        //
        // Find Q and S, that Q * 2 ^ S = (P - 1)
        var q = this.m.subn(1);
        var s = 0;
        while(!q.isZero() && q.andln(1) === 0){
            s++;
            q.iushrn(1);
        }
        assert(!q.isZero());
        var one = new BN(1).toRed(this);
        var nOne = one.redNeg();
        // Find quadratic non-residue
        // NOTE: Max is such because of generalized Riemann hypothesis.
        var lpow = this.m.subn(1).iushrn(1);
        var z = this.m.bitLength();
        z = new BN(2 * z * z).toRed(this);
        while(this.pow(z, lpow).cmp(nOne) !== 0)z.redIAdd(nOne);
        var c = this.pow(z, q);
        var r = this.pow(a, q.addn(1).iushrn(1));
        var t = this.pow(a, q);
        var m = s;
        while(t.cmp(one) !== 0){
            var tmp = t;
            for(var i = 0; tmp.cmp(one) !== 0; i++)tmp = tmp.redSqr();
            assert(i < m);
            var b = this.pow(c, new BN(1).iushln(m - i - 1));
            r = r.redMul(b);
            c = b.redSqr();
            t = t.redMul(c);
            m = i;
        }
        return r;
    };
    Red.prototype.invm = function invm(a) {
        var inv = a._invmp(this.m);
        if (inv.negative !== 0) {
            inv.negative = 0;
            return this.imod(inv).redNeg();
        } else return this.imod(inv);
    };
    Red.prototype.pow = function pow(a, num) {
        if (num.isZero()) return new BN(1);
        if (num.cmpn(1) === 0) return a.clone();
        var windowSize = 4;
        var wnd = new Array(1 << windowSize);
        wnd[0] = new BN(1).toRed(this);
        wnd[1] = a;
        for(var i = 2; i < wnd.length; i++)wnd[i] = this.mul(wnd[i - 1], a);
        var res = wnd[0];
        var current = 0;
        var currentLen = 0;
        var start = num.bitLength() % 26;
        if (start === 0) start = 26;
        for(i = num.length - 1; i >= 0; i--){
            var word = num.words[i];
            for(var j = start - 1; j >= 0; j--){
                var bit = word >> j & 1;
                if (res !== wnd[0]) res = this.sqr(res);
                if (bit === 0 && current === 0) {
                    currentLen = 0;
                    continue;
                }
                current <<= 1;
                current |= bit;
                currentLen++;
                if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
                res = this.mul(res, wnd[current]);
                currentLen = 0;
                current = 0;
            }
            start = 26;
        }
        return res;
    };
    Red.prototype.convertTo = function convertTo(num) {
        var r = num.umod(this.m);
        return r === num ? r.clone() : r;
    };
    Red.prototype.convertFrom = function convertFrom(num) {
        var res = num.clone();
        res.red = null;
        return res;
    };
    //
    // Montgomery method engine
    //
    BN.mont = function mont(num) {
        return new Mont(num);
    };
    function Mont(m) {
        Red.call(this, m);
        this.shift = this.m.bitLength();
        if (this.shift % 26 !== 0) this.shift += 26 - this.shift % 26;
        this.r = new BN(1).iushln(this.shift);
        this.r2 = this.imod(this.r.sqr());
        this.rinv = this.r._invmp(this.m);
        this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
        this.minv = this.minv.umod(this.r);
        this.minv = this.r.sub(this.minv);
    }
    inherits(Mont, Red);
    Mont.prototype.convertTo = function convertTo(num) {
        return this.imod(num.ushln(this.shift));
    };
    Mont.prototype.convertFrom = function convertFrom(num) {
        var r = this.imod(num.mul(this.rinv));
        r.red = null;
        return r;
    };
    Mont.prototype.imul = function imul(a, b) {
        if (a.isZero() || b.isZero()) {
            a.words[0] = 0;
            a.length = 1;
            return a;
        }
        var t = a.imul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.mul = function mul(a, b) {
        if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
        var t = a.mul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.invm = function invm(a) {
        // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
        var res = this.imod(a._invmp(this.m).mul(this.r2));
        return res._forceRed(this);
    };
})(module, this);

},{"63c0958e99cf166a":"l5Twm"}],"l5Twm":[function(require,module,exports) {
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ "use strict";
const base64 = require("9c62938f1dccc73c");
const ieee754 = require("aceacb6a4531a9d2");
const customInspectSymbol = typeof Symbol === "function" && typeof Symbol["for"] === "function" // eslint-disable-line dot-notation
 ? Symbol["for"]("nodejs.util.inspect.custom") // eslint-disable-line dot-notation
 : null;
exports.Buffer = Buffer;
exports.SlowBuffer = SlowBuffer;
exports.INSPECT_MAX_BYTES = 50;
const K_MAX_LENGTH = 0x7fffffff;
exports.kMaxLength = K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ Buffer.TYPED_ARRAY_SUPPORT = typedArraySupport();
if (!Buffer.TYPED_ARRAY_SUPPORT && typeof console !== "undefined" && typeof console.error === "function") console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        const arr = new Uint8Array(1);
        const proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty(Buffer.prototype, "parent", {
    enumerable: true,
    get: function() {
        if (!Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty(Buffer.prototype, "offset", {
    enumerable: true,
    get: function() {
        if (!Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function createBuffer(length) {
    if (length > K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === "number") {
        if (typeof encodingOrOffset === "string") throw new TypeError('The "string" argument must be of type string. Received type number');
        return allocUnsafe(arg);
    }
    return from(arg, encodingOrOffset, length);
}
Buffer.poolSize = 8192 // not used by this implementation
;
function from(value, encodingOrOffset, length) {
    if (typeof value === "string") return fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if (isInstance(value, ArrayBuffer) || value && isInstance(value.buffer, ArrayBuffer)) return fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== "undefined" && (isInstance(value, SharedArrayBuffer) || value && isInstance(value.buffer, SharedArrayBuffer))) return fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === "number") throw new TypeError('The "value" argument must not be of type number. Received type number');
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return Buffer.from(valueOf, encodingOrOffset, length);
    const b = fromObject(value);
    if (b) return b;
    if (typeof Symbol !== "undefined" && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === "function") return Buffer.from(value[Symbol.toPrimitive]("string"), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ Buffer.from = function(value, encodingOrOffset, length) {
    return from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf(Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf(Buffer, Uint8Array);
function assertSize(size) {
    if (typeof size !== "number") throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function alloc(size, fill, encoding) {
    assertSize(size);
    if (size <= 0) return createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === "string" ? createBuffer(size).fill(fill, encoding) : createBuffer(size).fill(fill);
    return createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ Buffer.alloc = function(size, fill, encoding) {
    return alloc(size, fill, encoding);
};
function allocUnsafe(size) {
    assertSize(size);
    return createBuffer(size < 0 ? 0 : checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ Buffer.allocUnsafe = function(size) {
    return allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ Buffer.allocUnsafeSlow = function(size) {
    return allocUnsafe(size);
};
function fromString(string, encoding) {
    if (typeof encoding !== "string" || encoding === "") encoding = "utf8";
    if (!Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
    const length = byteLength(string, encoding) | 0;
    let buf = createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function fromArrayLike(array) {
    const length = array.length < 0 ? 0 : checked(array.length) | 0;
    const buf = createBuffer(length);
    for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function fromArrayView(arrayView) {
    if (isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return fromArrayLike(arrayView);
}
function fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    let buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, Buffer.prototype);
    return buf;
}
function fromObject(obj) {
    if (Buffer.isBuffer(obj)) {
        const len = checked(obj.length) | 0;
        const buf = createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== "number" || numberIsNaN(obj.length)) return createBuffer(0);
        return fromArrayLike(obj);
    }
    if (obj.type === "Buffer" && Array.isArray(obj.data)) return fromArrayLike(obj.data);
}
function checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + K_MAX_LENGTH.toString(16) + " bytes");
    return length | 0;
}
function SlowBuffer(length) {
    if (+length != length) length = 0;
    return Buffer.alloc(+length);
}
Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
Buffer.compare = function compare(a, b) {
    if (isInstance(a, Uint8Array)) a = Buffer.from(a, a.offset, a.byteLength);
    if (isInstance(b, Uint8Array)) b = Buffer.from(b, b.offset, b.byteLength);
    if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    let x = a.length;
    let y = b.length;
    for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case "hex":
        case "utf8":
        case "utf-8":
        case "ascii":
        case "latin1":
        case "binary":
        case "base64":
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return true;
        default:
            return false;
    }
};
Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return Buffer.alloc(0);
    let i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    const buffer = Buffer.allocUnsafe(length);
    let pos = 0;
    for(i = 0; i < list.length; ++i){
        let buf = list[i];
        if (isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!Buffer.isBuffer(buf)) buf = Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function byteLength(string, encoding) {
    if (Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== "string") throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    let loweredCase = false;
    for(;;)switch(encoding){
        case "ascii":
        case "latin1":
        case "binary":
            return len;
        case "utf8":
        case "utf-8":
            return utf8ToBytes(string).length;
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return len * 2;
        case "hex":
            return len >>> 1;
        case "base64":
            return base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : utf8ToBytes(string).length // assume utf8
            ;
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
}
Buffer.byteLength = byteLength;
function slowToString(encoding, start, end) {
    let loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return "";
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return "";
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return "";
    if (!encoding) encoding = "utf8";
    while(true)switch(encoding){
        case "hex":
            return hexSlice(this, start, end);
        case "utf8":
        case "utf-8":
            return utf8Slice(this, start, end);
        case "ascii":
            return asciiSlice(this, start, end);
        case "latin1":
        case "binary":
            return latin1Slice(this, start, end);
        case "base64":
            return base64Slice(this, start, end);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = (encoding + "").toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
Buffer.prototype._isBuffer = true;
function swap(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
}
Buffer.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) throw new RangeError("Buffer size must be a multiple of 16-bits");
    for(let i = 0; i < len; i += 2)swap(this, i, i + 1);
    return this;
};
Buffer.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) throw new RangeError("Buffer size must be a multiple of 32-bits");
    for(let i = 0; i < len; i += 4){
        swap(this, i, i + 3);
        swap(this, i + 1, i + 2);
    }
    return this;
};
Buffer.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) throw new RangeError("Buffer size must be a multiple of 64-bits");
    for(let i = 0; i < len; i += 8){
        swap(this, i, i + 7);
        swap(this, i + 1, i + 6);
        swap(this, i + 2, i + 5);
        swap(this, i + 3, i + 4);
    }
    return this;
};
Buffer.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0) return "";
    if (arguments.length === 0) return utf8Slice(this, 0, length);
    return slowToString.apply(this, arguments);
};
Buffer.prototype.toLocaleString = Buffer.prototype.toString;
Buffer.prototype.equals = function equals(b) {
    if (!Buffer.isBuffer(b)) throw new TypeError("Argument must be a Buffer");
    if (this === b) return true;
    return Buffer.compare(this, b) === 0;
};
Buffer.prototype.inspect = function inspect() {
    let str = "";
    const max = exports.INSPECT_MAX_BYTES;
    str = this.toString("hex", 0, max).replace(/(.{2})/g, "$1 ").trim();
    if (this.length > max) str += " ... ";
    return "<Buffer " + str + ">";
};
if (customInspectSymbol) Buffer.prototype[customInspectSymbol] = Buffer.prototype.inspect;
Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if (isInstance(target, Uint8Array)) target = Buffer.from(target, target.offset, target.byteLength);
    if (!Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError("out of range index");
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    let x = thisEnd - thisStart;
    let y = end - start;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === "string") {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if (numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === "string") val = Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if (Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === "number") {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === "function") {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError("val must be string, number or Buffer");
}
function arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === "ucs2" || encoding === "ucs-2" || encoding === "utf16le" || encoding === "utf-16le") {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    let i;
    if (dir) {
        let foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            let found = true;
            for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    const strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    let i;
    for(i = 0; i < length; ++i){
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if (numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function utf8Write(buf, string, offset, length) {
    return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function asciiWrite(buf, string, offset, length) {
    return blitBuffer(asciiToBytes(string), buf, offset, length);
}
function base64Write(buf, string, offset, length) {
    return blitBuffer(base64ToBytes(string), buf, offset, length);
}
function ucs2Write(buf, string, offset, length) {
    return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = "utf8";
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === "string") {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = "utf8";
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
    const remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError("Attempt to write outside buffer bounds");
    if (!encoding) encoding = "utf8";
    let loweredCase = false;
    for(;;)switch(encoding){
        case "hex":
            return hexWrite(this, string, offset, length);
        case "utf8":
        case "utf-8":
            return utf8Write(this, string, offset, length);
        case "ascii":
        case "latin1":
        case "binary":
            return asciiWrite(this, string, offset, length);
        case "base64":
            // Warning: maxLength not taken into account in base64Write
            return base64Write(this, string, offset, length);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
};
Buffer.prototype.toJSON = function toJSON() {
    return {
        type: "Buffer",
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return base64.fromByteArray(buf);
    else return base64.fromByteArray(buf.slice(start, end));
}
function utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i = start;
    while(i < end){
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const MAX_ARGUMENTS_LENGTH = 0x1000;
function decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    let res = "";
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH));
    return res;
}
function asciiSlice(buf, start, end) {
    let ret = "";
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function latin1Slice(buf, start, end) {
    let ret = "";
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    let out = "";
    for(let i = start; i < end; ++i)out += hexSliceLookupTable[buf[i]];
    return out;
}
function utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = "";
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
Buffer.prototype.slice = function slice(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    const newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError("offset is not uint");
    if (offset + ext > length) throw new RangeError("Trying to access beyond buffer length");
}
Buffer.prototype.readUintLE = Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
Buffer.prototype.readUintBE = Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) checkOffset(offset, byteLength, this.length);
    let val = this[offset + --byteLength];
    let mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
Buffer.prototype.readUint8 = Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 1, this.length);
    return this[offset];
};
Buffer.prototype.readUint16LE = Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
Buffer.prototype.readUint16BE = Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
Buffer.prototype.readUint32LE = Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
Buffer.prototype.readUint32BE = Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
Buffer.prototype.readBigUInt64LE = defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) boundsError(offset, this.length - 8);
    const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
Buffer.prototype.readBigUInt64BE = defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) boundsError(offset, this.length - 8);
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) checkOffset(offset, byteLength, this.length);
    let i = byteLength;
    let mul = 1;
    let val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
Buffer.prototype.readBigInt64LE = defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) boundsError(offset, this.length - 8);
    const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
});
Buffer.prototype.readBigInt64BE = defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) boundsError(offset, this.length - 8);
    const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
});
Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 4, this.length);
    return ieee754.read(this, offset, true, 23, 4);
};
Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 4, this.length);
    return ieee754.read(this, offset, false, 23, 4);
};
Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 8, this.length);
    return ieee754.read(this, offset, true, 52, 8);
};
Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 8, this.length);
    return ieee754.read(this, offset, false, 52, 8);
};
function checkInt(buf, value, offset, ext, max, min) {
    if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
}
Buffer.prototype.writeUintLE = Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
Buffer.prototype.writeUintBE = Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let i = byteLength - 1;
    let mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
Buffer.prototype.writeUint8 = Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
Buffer.prototype.writeUint16LE = Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
Buffer.prototype.writeUint16BE = Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
Buffer.prototype.writeUint32LE = Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
Buffer.prototype.writeUint32BE = Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function wrtBigUInt64LE(buf, value, offset, min, max) {
    checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function wrtBigUInt64BE(buf, value, offset, min, max) {
    checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
Buffer.prototype.writeBigUInt64LE = defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt("0xffffffffffffffff"));
});
Buffer.prototype.writeBigUInt64BE = defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt("0xffffffffffffffff"));
});
Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = byteLength - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
Buffer.prototype.writeBigInt64LE = defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return wrtBigUInt64LE(this, value, offset, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
});
Buffer.prototype.writeBigInt64BE = defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return wrtBigUInt64BE(this, value, offset, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
});
function checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
    if (offset < 0) throw new RangeError("Index out of range");
}
function writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    ieee754.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return writeFloat(this, value, offset, true, noAssert);
};
Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return writeFloat(this, value, offset, false, noAssert);
};
function writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    ieee754.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return writeDouble(this, value, offset, true, noAssert);
};
Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!Buffer.isBuffer(target)) throw new TypeError("argument should be a Buffer");
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError("targetStart out of bounds");
    if (start < 0 || start >= this.length) throw new RangeError("Index out of range");
    if (end < 0) throw new RangeError("sourceEnd out of bounds");
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === "function") // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === "string") {
        if (typeof start === "string") {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === "string") {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== "string") throw new TypeError("encoding must be a string");
        if (typeof encoding === "string" && !Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
        if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === "utf8" && code < 128 || encoding === "latin1") // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === "number") val = val & 255;
    else if (typeof val === "boolean") val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError("Out of range index");
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    let i;
    if (typeof val === "number") for(i = start; i < end; ++i)this[i] = val;
    else {
        const bytes = Buffer.isBuffer(val) ? val : Buffer.from(val, encoding);
        const len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
const errors = {};
function E(sym, getMessage, Base) {
    errors[sym] = class NodeError extends Base {
        constructor(){
            super();
            Object.defineProperty(this, "message", {
                value: getMessage.apply(this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            this.name = `${this.name} [${sym}]`;
            // Access the stack to generate the error message including the error code
            // from the name.
            this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete this.name;
        }
        get code() {
            return sym;
        }
        set code(value) {
            Object.defineProperty(this, "code", {
                configurable: true,
                enumerable: true,
                value,
                writable: true
            });
        }
        toString() {
            return `${this.name} [${sym}]: ${this.message}`;
        }
    };
}
E("ERR_BUFFER_OUT_OF_BOUNDS", function(name) {
    if (name) return `${name} is outside of buffer bounds`;
    return "Attempt to access memory outside buffer bounds";
}, RangeError);
E("ERR_INVALID_ARG_TYPE", function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
}, TypeError);
E("ERR_OUT_OF_RANGE", function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = addNumericalSeparator(String(input));
    else if (typeof input === "bigint") {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = addNumericalSeparator(received);
        received += "n";
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
}, RangeError);
function addNumericalSeparator(val) {
    let res = "";
    let i = val.length;
    const start = val[0] === "-" ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
// CHECK FUNCTIONS
// ===============
function checkBounds(buf, offset, byteLength) {
    validateNumber(offset, "offset");
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) boundsError(offset, buf.length - (byteLength + 1));
}
function checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        const n = typeof min === "bigint" ? "n" : "";
        let range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
            else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
        } else range = `>= ${min}${n} and <= ${max}${n}`;
        throw new errors.ERR_OUT_OF_RANGE("value", range, value);
    }
    checkBounds(buf, offset, byteLength);
}
function validateNumber(value, name) {
    if (typeof value !== "number") throw new errors.ERR_INVALID_ARG_TYPE(name, "number", value);
}
function boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        validateNumber(value, type);
        throw new errors.ERR_OUT_OF_RANGE(type || "offset", "an integer", value);
    }
    if (length < 0) throw new errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new errors.ERR_OUT_OF_RANGE(type || "offset", `>= ${type ? 1 : 0} and <= ${length}`, value);
}
// HELPER FUNCTIONS
// ================
const INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split("=")[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace(INVALID_BASE64_RE, "");
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return "";
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + "=";
    return str;
}
function utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error("Invalid code point");
    }
    return bytes;
}
function asciiToBytes(str) {
    const byteArray = [];
    for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for(let i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function base64ToBytes(str) {
    return base64.toByteArray(base64clean(str));
}
function blitBuffer(src, dst, offset, length) {
    let i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const hexSliceLookupTable = function() {
    const alphabet = "0123456789abcdef";
    const table = new Array(256);
    for(let i = 0; i < 16; ++i){
        const i16 = i * 16;
        for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function defineBigIntMethod(fn) {
    return typeof BigInt === "undefined" ? BufferBigIntNotDefined : fn;
}
function BufferBigIntNotDefined() {
    throw new Error("BigInt not supported");
}

},{"9c62938f1dccc73c":"6Pb1S","aceacb6a4531a9d2":"6ifNR"}],"6Pb1S":[function(require,module,exports) {
"use strict";
exports.byteLength = byteLength;
exports.toByteArray = toByteArray;
exports.fromByteArray = fromByteArray;
var lookup = [];
var revLookup = [];
var Arr = typeof Uint8Array !== "undefined" ? Uint8Array : Array;
var code = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
for(var i = 0, len = code.length; i < len; ++i){
    lookup[i] = code[i];
    revLookup[code.charCodeAt(i)] = i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
revLookup["-".charCodeAt(0)] = 62;
revLookup["_".charCodeAt(0)] = 63;
function getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error("Invalid string. Length must be a multiple of 4");
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf("=");
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function byteLength(b64) {
    var lens = getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function _byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function toByteArray(b64) {
    var tmp;
    var lens = getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new Arr(_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = revLookup[b64.charCodeAt(i)] << 18 | revLookup[b64.charCodeAt(i + 1)] << 12 | revLookup[b64.charCodeAt(i + 2)] << 6 | revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = revLookup[b64.charCodeAt(i)] << 2 | revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = revLookup[b64.charCodeAt(i)] << 10 | revLookup[b64.charCodeAt(i + 1)] << 4 | revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function tripletToBase64(num) {
    return lookup[num >> 18 & 0x3F] + lookup[num >> 12 & 0x3F] + lookup[num >> 6 & 0x3F] + lookup[num & 0x3F];
}
function encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push(tripletToBase64(tmp));
    }
    return output.join("");
}
function fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push(encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push(lookup[tmp >> 2] + lookup[tmp << 4 & 0x3F] + "==");
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push(lookup[tmp >> 10] + lookup[tmp >> 4 & 0x3F] + lookup[tmp << 2 & 0x3F] + "=");
    }
    return parts.join("");
}

},{}],"6ifNR":[function(require,module,exports) {
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ exports.read = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
exports.write = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};

},{}],"gep00":[function(require,module,exports) {
var BN = require("897d9a307b7e0162");
var stripHexPrefix = require("8c51e0a686134773");
/**
 * Returns a BN object, converts a number value to a BN
 * @param {String|Number|Object} `arg` input a string number, hex string number, number, BigNumber or BN object
 * @return {Object} `output` BN object of the number
 * @throws if the argument is not an array, object that isn't a bignumber, not a string number or number
 */ module.exports = function numberToBN(arg) {
    if (typeof arg === "string" || typeof arg === "number") {
        var multiplier = new BN(1); // eslint-disable-line
        var formattedString = String(arg).toLowerCase().trim();
        var isHexPrefixed = formattedString.substr(0, 2) === "0x" || formattedString.substr(0, 3) === "-0x";
        var stringArg = stripHexPrefix(formattedString); // eslint-disable-line
        if (stringArg.substr(0, 1) === "-") {
            stringArg = stripHexPrefix(stringArg.slice(1));
            multiplier = new BN(-1, 10);
        }
        stringArg = stringArg === "" ? "0" : stringArg;
        if (!stringArg.match(/^-?[0-9]+$/) && stringArg.match(/^[0-9A-Fa-f]+$/) || stringArg.match(/^[a-fA-F]+$/) || isHexPrefixed === true && stringArg.match(/^[0-9A-Fa-f]+$/)) return new BN(stringArg, 16).mul(multiplier);
        if ((stringArg.match(/^-?[0-9]+$/) || stringArg === "") && isHexPrefixed === false) return new BN(stringArg, 10).mul(multiplier);
    } else if (typeof arg === "object" && arg.toString && !arg.pop && !arg.push) {
        if (arg.toString(10).match(/^-?[0-9]+$/) && (arg.mul || arg.dividedToIntegerBy)) return new BN(arg.toString(10), 10);
    }
    throw new Error("[number-to-bn] while converting number " + JSON.stringify(arg) + " to BN.js instance, error: invalid number value. Value must be an integer, hex string, BN or BigNumber instance. Note, decimals are not supported.");
};

},{"897d9a307b7e0162":"lvXcQ","8c51e0a686134773":"8BYNv"}],"lvXcQ":[function(require,module,exports) {
(function(module1, exports) {
    "use strict";
    // Utils
    function assert(val, msg) {
        if (!val) throw new Error(msg || "Assertion failed");
    }
    // Could use `inherits` module, but don't want to move from single file
    // architecture yet.
    function inherits(ctor, superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
    // BN
    function BN(number, base, endian) {
        if (BN.isBN(number)) return number;
        this.negative = 0;
        this.words = null;
        this.length = 0;
        // Reduction context
        this.red = null;
        if (number !== null) {
            if (base === "le" || base === "be") {
                endian = base;
                base = 10;
            }
            this._init(number || 0, base || 10, endian || "be");
        }
    }
    if (typeof module1 === "object") module1.exports = BN;
    else exports.BN = BN;
    BN.BN = BN;
    BN.wordSize = 26;
    var Buffer;
    try {
        Buffer = require("7c59a1f8cc803dfc").Buffer;
    } catch (e) {}
    BN.isBN = function isBN(num) {
        if (num instanceof BN) return true;
        return num !== null && typeof num === "object" && num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
    };
    BN.max = function max(left, right) {
        if (left.cmp(right) > 0) return left;
        return right;
    };
    BN.min = function min(left, right) {
        if (left.cmp(right) < 0) return left;
        return right;
    };
    BN.prototype._init = function init(number, base, endian) {
        if (typeof number === "number") return this._initNumber(number, base, endian);
        if (typeof number === "object") return this._initArray(number, base, endian);
        if (base === "hex") base = 16;
        assert(base === (base | 0) && base >= 2 && base <= 36);
        number = number.toString().replace(/\s+/g, "");
        var start = 0;
        if (number[0] === "-") start++;
        if (base === 16) this._parseHex(number, start);
        else this._parseBase(number, base, start);
        if (number[0] === "-") this.negative = 1;
        this.strip();
        if (endian !== "le") return;
        this._initArray(this.toArray(), base, endian);
    };
    BN.prototype._initNumber = function _initNumber(number, base, endian) {
        if (number < 0) {
            this.negative = 1;
            number = -number;
        }
        if (number < 0x4000000) {
            this.words = [
                number & 0x3ffffff
            ];
            this.length = 1;
        } else if (number < 0x10000000000000) {
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff
            ];
            this.length = 2;
        } else {
            assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff,
                1
            ];
            this.length = 3;
        }
        if (endian !== "le") return;
        // Reverse the bytes
        this._initArray(this.toArray(), base, endian);
    };
    BN.prototype._initArray = function _initArray(number, base, endian) {
        // Perhaps a Uint8Array
        assert(typeof number.length === "number");
        if (number.length <= 0) {
            this.words = [
                0
            ];
            this.length = 1;
            return this;
        }
        this.length = Math.ceil(number.length / 3);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        var j, w;
        var off = 0;
        if (endian === "be") for(i = number.length - 1, j = 0; i >= 0; i -= 3){
            w = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        else if (endian === "le") for(i = 0, j = 0; i < number.length; i += 3){
            w = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        return this.strip();
    };
    function parseHex(str, start, end) {
        var r = 0;
        var len = Math.min(str.length, end);
        for(var i = start; i < len; i++){
            var c = str.charCodeAt(i) - 48;
            r <<= 4;
            // 'a' - 'f'
            if (c >= 49 && c <= 54) r |= c - 49 + 0xa;
            else if (c >= 17 && c <= 22) r |= c - 17 + 0xa;
            else r |= c & 0xf;
        }
        return r;
    }
    BN.prototype._parseHex = function _parseHex(number, start) {
        // Create possibly bigger array to ensure that it fits the number
        this.length = Math.ceil((number.length - start) / 6);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        var j, w;
        // Scan 24-bit chunks and add them to the number
        var off = 0;
        for(i = number.length - 6, j = 0; i >= start; i -= 6){
            w = parseHex(number, i, i + 6);
            this.words[j] |= w << off & 0x3ffffff;
            // NOTE: `0x3fffff` is intentional here, 26bits max shift + 24bit hex limb
            this.words[j + 1] |= w >>> 26 - off & 0x3fffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        if (i + 6 !== start) {
            w = parseHex(number, start, i + 6);
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] |= w >>> 26 - off & 0x3fffff;
        }
        this.strip();
    };
    function parseBase(str, start, end, mul) {
        var r = 0;
        var len = Math.min(str.length, end);
        for(var i = start; i < len; i++){
            var c = str.charCodeAt(i) - 48;
            r *= mul;
            // 'a'
            if (c >= 49) r += c - 49 + 0xa;
            else if (c >= 17) r += c - 17 + 0xa;
            else r += c;
        }
        return r;
    }
    BN.prototype._parseBase = function _parseBase(number, base, start) {
        // Initialize as zero
        this.words = [
            0
        ];
        this.length = 1;
        // Find length of limb in base
        for(var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base)limbLen++;
        limbLen--;
        limbPow = limbPow / base | 0;
        var total = number.length - start;
        var mod = total % limbLen;
        var end = Math.min(total, total - mod) + start;
        var word = 0;
        for(var i = start; i < end; i += limbLen){
            word = parseBase(number, i, i + limbLen, base);
            this.imuln(limbPow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        if (mod !== 0) {
            var pow = 1;
            word = parseBase(number, i, number.length, base);
            for(i = 0; i < mod; i++)pow *= base;
            this.imuln(pow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
    };
    BN.prototype.copy = function copy(dest) {
        dest.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)dest.words[i] = this.words[i];
        dest.length = this.length;
        dest.negative = this.negative;
        dest.red = this.red;
    };
    BN.prototype.clone = function clone() {
        var r = new BN(null);
        this.copy(r);
        return r;
    };
    BN.prototype._expand = function _expand(size) {
        while(this.length < size)this.words[this.length++] = 0;
        return this;
    };
    // Remove leading `0` from `this`
    BN.prototype.strip = function strip() {
        while(this.length > 1 && this.words[this.length - 1] === 0)this.length--;
        return this._normSign();
    };
    BN.prototype._normSign = function _normSign() {
        // -0 = 0
        if (this.length === 1 && this.words[0] === 0) this.negative = 0;
        return this;
    };
    BN.prototype.inspect = function inspect() {
        return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
    };
    /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */ var zeros = [
        "",
        "0",
        "00",
        "000",
        "0000",
        "00000",
        "000000",
        "0000000",
        "00000000",
        "000000000",
        "0000000000",
        "00000000000",
        "000000000000",
        "0000000000000",
        "00000000000000",
        "000000000000000",
        "0000000000000000",
        "00000000000000000",
        "000000000000000000",
        "0000000000000000000",
        "00000000000000000000",
        "000000000000000000000",
        "0000000000000000000000",
        "00000000000000000000000",
        "000000000000000000000000",
        "0000000000000000000000000"
    ];
    var groupSizes = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
    ];
    var groupBases = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        10000000,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64000000,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        24300000,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
    ];
    BN.prototype.toString = function toString(base, padding) {
        base = base || 10;
        padding = padding | 0 || 1;
        var out;
        if (base === 16 || base === "hex") {
            out = "";
            var off = 0;
            var carry = 0;
            for(var i = 0; i < this.length; i++){
                var w = this.words[i];
                var word = ((w << off | carry) & 0xffffff).toString(16);
                carry = w >>> 24 - off & 0xffffff;
                if (carry !== 0 || i !== this.length - 1) out = zeros[6 - word.length] + word + out;
                else out = word + out;
                off += 2;
                if (off >= 26) {
                    off -= 26;
                    i--;
                }
            }
            if (carry !== 0) out = carry.toString(16) + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        if (base === (base | 0) && base >= 2 && base <= 36) {
            // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
            var groupSize = groupSizes[base];
            // var groupBase = Math.pow(base, groupSize);
            var groupBase = groupBases[base];
            out = "";
            var c = this.clone();
            c.negative = 0;
            while(!c.isZero()){
                var r = c.modn(groupBase).toString(base);
                c = c.idivn(groupBase);
                if (!c.isZero()) out = zeros[groupSize - r.length] + r + out;
                else out = r + out;
            }
            if (this.isZero()) out = "0" + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        assert(false, "Base should be between 2 and 36");
    };
    BN.prototype.toNumber = function toNumber() {
        var ret = this.words[0];
        if (this.length === 2) ret += this.words[1] * 0x4000000;
        else if (this.length === 3 && this.words[2] === 0x01) // NOTE: at this stage it is known that the top bit is set
        ret += 0x10000000000000 + this.words[1] * 0x4000000;
        else if (this.length > 2) assert(false, "Number can only safely store up to 53 bits");
        return this.negative !== 0 ? -ret : ret;
    };
    BN.prototype.toJSON = function toJSON() {
        return this.toString(16);
    };
    BN.prototype.toBuffer = function toBuffer(endian, length) {
        assert(typeof Buffer !== "undefined");
        return this.toArrayLike(Buffer, endian, length);
    };
    BN.prototype.toArray = function toArray(endian, length) {
        return this.toArrayLike(Array, endian, length);
    };
    BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
        var byteLength = this.byteLength();
        var reqLength = length || Math.max(1, byteLength);
        assert(byteLength <= reqLength, "byte array longer than desired length");
        assert(reqLength > 0, "Requested array length <= 0");
        this.strip();
        var littleEndian = endian === "le";
        var res = new ArrayType(reqLength);
        var b, i;
        var q = this.clone();
        if (!littleEndian) {
            // Assume big-endian
            for(i = 0; i < reqLength - byteLength; i++)res[i] = 0;
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[reqLength - i - 1] = b;
            }
        } else {
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[i] = b;
            }
            for(; i < reqLength; i++)res[i] = 0;
        }
        return res;
    };
    if (Math.clz32) BN.prototype._countBits = function _countBits(w) {
        return 32 - Math.clz32(w);
    };
    else BN.prototype._countBits = function _countBits(w) {
        var t = w;
        var r = 0;
        if (t >= 0x1000) {
            r += 13;
            t >>>= 13;
        }
        if (t >= 0x40) {
            r += 7;
            t >>>= 7;
        }
        if (t >= 0x8) {
            r += 4;
            t >>>= 4;
        }
        if (t >= 0x02) {
            r += 2;
            t >>>= 2;
        }
        return r + t;
    };
    BN.prototype._zeroBits = function _zeroBits(w) {
        // Short-cut
        if (w === 0) return 26;
        var t = w;
        var r = 0;
        if ((t & 0x1fff) === 0) {
            r += 13;
            t >>>= 13;
        }
        if ((t & 0x7f) === 0) {
            r += 7;
            t >>>= 7;
        }
        if ((t & 0xf) === 0) {
            r += 4;
            t >>>= 4;
        }
        if ((t & 0x3) === 0) {
            r += 2;
            t >>>= 2;
        }
        if ((t & 0x1) === 0) r++;
        return r;
    };
    // Return number of used bits in a BN
    BN.prototype.bitLength = function bitLength() {
        var w = this.words[this.length - 1];
        var hi = this._countBits(w);
        return (this.length - 1) * 26 + hi;
    };
    function toBitArray(num) {
        var w = new Array(num.bitLength());
        for(var bit = 0; bit < w.length; bit++){
            var off = bit / 26 | 0;
            var wbit = bit % 26;
            w[bit] = (num.words[off] & 1 << wbit) >>> wbit;
        }
        return w;
    }
    // Number of trailing zero bits
    BN.prototype.zeroBits = function zeroBits() {
        if (this.isZero()) return 0;
        var r = 0;
        for(var i = 0; i < this.length; i++){
            var b = this._zeroBits(this.words[i]);
            r += b;
            if (b !== 26) break;
        }
        return r;
    };
    BN.prototype.byteLength = function byteLength() {
        return Math.ceil(this.bitLength() / 8);
    };
    BN.prototype.toTwos = function toTwos(width) {
        if (this.negative !== 0) return this.abs().inotn(width).iaddn(1);
        return this.clone();
    };
    BN.prototype.fromTwos = function fromTwos(width) {
        if (this.testn(width - 1)) return this.notn(width).iaddn(1).ineg();
        return this.clone();
    };
    BN.prototype.isNeg = function isNeg() {
        return this.negative !== 0;
    };
    // Return negative clone of `this`
    BN.prototype.neg = function neg() {
        return this.clone().ineg();
    };
    BN.prototype.ineg = function ineg() {
        if (!this.isZero()) this.negative ^= 1;
        return this;
    };
    // Or `num` with `this` in-place
    BN.prototype.iuor = function iuor(num) {
        while(this.length < num.length)this.words[this.length++] = 0;
        for(var i = 0; i < num.length; i++)this.words[i] = this.words[i] | num.words[i];
        return this.strip();
    };
    BN.prototype.ior = function ior(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuor(num);
    };
    // Or `num` with `this`
    BN.prototype.or = function or(num) {
        if (this.length > num.length) return this.clone().ior(num);
        return num.clone().ior(this);
    };
    BN.prototype.uor = function uor(num) {
        if (this.length > num.length) return this.clone().iuor(num);
        return num.clone().iuor(this);
    };
    // And `num` with `this` in-place
    BN.prototype.iuand = function iuand(num) {
        // b = min-length(num, this)
        var b;
        if (this.length > num.length) b = num;
        else b = this;
        for(var i = 0; i < b.length; i++)this.words[i] = this.words[i] & num.words[i];
        this.length = b.length;
        return this.strip();
    };
    BN.prototype.iand = function iand(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuand(num);
    };
    // And `num` with `this`
    BN.prototype.and = function and(num) {
        if (this.length > num.length) return this.clone().iand(num);
        return num.clone().iand(this);
    };
    BN.prototype.uand = function uand(num) {
        if (this.length > num.length) return this.clone().iuand(num);
        return num.clone().iuand(this);
    };
    // Xor `num` with `this` in-place
    BN.prototype.iuxor = function iuxor(num) {
        // a.length > b.length
        var a;
        var b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        for(var i = 0; i < b.length; i++)this.words[i] = a.words[i] ^ b.words[i];
        if (this !== a) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = a.length;
        return this.strip();
    };
    BN.prototype.ixor = function ixor(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuxor(num);
    };
    // Xor `num` with `this`
    BN.prototype.xor = function xor(num) {
        if (this.length > num.length) return this.clone().ixor(num);
        return num.clone().ixor(this);
    };
    BN.prototype.uxor = function uxor(num) {
        if (this.length > num.length) return this.clone().iuxor(num);
        return num.clone().iuxor(this);
    };
    // Not ``this`` with ``width`` bitwidth
    BN.prototype.inotn = function inotn(width) {
        assert(typeof width === "number" && width >= 0);
        var bytesNeeded = Math.ceil(width / 26) | 0;
        var bitsLeft = width % 26;
        // Extend the buffer with leading zeroes
        this._expand(bytesNeeded);
        if (bitsLeft > 0) bytesNeeded--;
        // Handle complete words
        for(var i = 0; i < bytesNeeded; i++)this.words[i] = ~this.words[i] & 0x3ffffff;
        // Handle the residue
        if (bitsLeft > 0) this.words[i] = ~this.words[i] & 0x3ffffff >> 26 - bitsLeft;
        // And remove leading zeroes
        return this.strip();
    };
    BN.prototype.notn = function notn(width) {
        return this.clone().inotn(width);
    };
    // Set `bit` of `this`
    BN.prototype.setn = function setn(bit, val) {
        assert(typeof bit === "number" && bit >= 0);
        var off = bit / 26 | 0;
        var wbit = bit % 26;
        this._expand(off + 1);
        if (val) this.words[off] = this.words[off] | 1 << wbit;
        else this.words[off] = this.words[off] & ~(1 << wbit);
        return this.strip();
    };
    // Add `num` to `this` in-place
    BN.prototype.iadd = function iadd(num) {
        var r;
        // negative + positive
        if (this.negative !== 0 && num.negative === 0) {
            this.negative = 0;
            r = this.isub(num);
            this.negative ^= 1;
            return this._normSign();
        // positive + negative
        } else if (this.negative === 0 && num.negative !== 0) {
            num.negative = 0;
            r = this.isub(num);
            num.negative = 1;
            return r._normSign();
        }
        // a.length > b.length
        var a, b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        this.length = a.length;
        if (carry !== 0) {
            this.words[this.length] = carry;
            this.length++;
        // Copy the rest of the words
        } else if (a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        return this;
    };
    // Add `num` to `this`
    BN.prototype.add = function add(num) {
        var res;
        if (num.negative !== 0 && this.negative === 0) {
            num.negative = 0;
            res = this.sub(num);
            num.negative ^= 1;
            return res;
        } else if (num.negative === 0 && this.negative !== 0) {
            this.negative = 0;
            res = num.sub(this);
            this.negative = 1;
            return res;
        }
        if (this.length > num.length) return this.clone().iadd(num);
        return num.clone().iadd(this);
    };
    // Subtract `num` from `this` in-place
    BN.prototype.isub = function isub(num) {
        // this - (-num) = this + num
        if (num.negative !== 0) {
            num.negative = 0;
            var r = this.iadd(num);
            num.negative = 1;
            return r._normSign();
        // -this - num = -(this + num)
        } else if (this.negative !== 0) {
            this.negative = 0;
            this.iadd(num);
            this.negative = 1;
            return this._normSign();
        }
        // At this point both numbers are positive
        var cmp = this.cmp(num);
        // Optimization - zeroify
        if (cmp === 0) {
            this.negative = 0;
            this.length = 1;
            this.words[0] = 0;
            return this;
        }
        // a > b
        var a, b;
        if (cmp > 0) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        // Copy rest of the words
        if (carry === 0 && i < a.length && a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = Math.max(this.length, i);
        if (a !== this) this.negative = 1;
        return this.strip();
    };
    // Subtract `num` from `this`
    BN.prototype.sub = function sub(num) {
        return this.clone().isub(num);
    };
    function smallMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        var len = self.length + num.length | 0;
        out.length = len;
        len = len - 1 | 0;
        // Peel one iteration (compiler can't do it, because of code complexity)
        var a = self.words[0] | 0;
        var b = num.words[0] | 0;
        var r = a * b;
        var lo = r & 0x3ffffff;
        var carry = r / 0x4000000 | 0;
        out.words[0] = lo;
        for(var k = 1; k < len; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = carry >>> 26;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j | 0;
                a = self.words[i] | 0;
                b = num.words[j] | 0;
                r = a * b + rword;
                ncarry += r / 0x4000000 | 0;
                rword = r & 0x3ffffff;
            }
            out.words[k] = rword | 0;
            carry = ncarry | 0;
        }
        if (carry !== 0) out.words[k] = carry | 0;
        else out.length--;
        return out.strip();
    }
    // TODO(indutny): it may be reasonable to omit it for users who don't need
    // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
    // multiplication (like elliptic secp256k1).
    var comb10MulTo = function comb10MulTo(self, num, out) {
        var a = self.words;
        var b = num.words;
        var o = out.words;
        var c = 0;
        var lo;
        var mid;
        var hi;
        var a0 = a[0] | 0;
        var al0 = a0 & 0x1fff;
        var ah0 = a0 >>> 13;
        var a1 = a[1] | 0;
        var al1 = a1 & 0x1fff;
        var ah1 = a1 >>> 13;
        var a2 = a[2] | 0;
        var al2 = a2 & 0x1fff;
        var ah2 = a2 >>> 13;
        var a3 = a[3] | 0;
        var al3 = a3 & 0x1fff;
        var ah3 = a3 >>> 13;
        var a4 = a[4] | 0;
        var al4 = a4 & 0x1fff;
        var ah4 = a4 >>> 13;
        var a5 = a[5] | 0;
        var al5 = a5 & 0x1fff;
        var ah5 = a5 >>> 13;
        var a6 = a[6] | 0;
        var al6 = a6 & 0x1fff;
        var ah6 = a6 >>> 13;
        var a7 = a[7] | 0;
        var al7 = a7 & 0x1fff;
        var ah7 = a7 >>> 13;
        var a8 = a[8] | 0;
        var al8 = a8 & 0x1fff;
        var ah8 = a8 >>> 13;
        var a9 = a[9] | 0;
        var al9 = a9 & 0x1fff;
        var ah9 = a9 >>> 13;
        var b0 = b[0] | 0;
        var bl0 = b0 & 0x1fff;
        var bh0 = b0 >>> 13;
        var b1 = b[1] | 0;
        var bl1 = b1 & 0x1fff;
        var bh1 = b1 >>> 13;
        var b2 = b[2] | 0;
        var bl2 = b2 & 0x1fff;
        var bh2 = b2 >>> 13;
        var b3 = b[3] | 0;
        var bl3 = b3 & 0x1fff;
        var bh3 = b3 >>> 13;
        var b4 = b[4] | 0;
        var bl4 = b4 & 0x1fff;
        var bh4 = b4 >>> 13;
        var b5 = b[5] | 0;
        var bl5 = b5 & 0x1fff;
        var bh5 = b5 >>> 13;
        var b6 = b[6] | 0;
        var bl6 = b6 & 0x1fff;
        var bh6 = b6 >>> 13;
        var b7 = b[7] | 0;
        var bl7 = b7 & 0x1fff;
        var bh7 = b7 >>> 13;
        var b8 = b[8] | 0;
        var bl8 = b8 & 0x1fff;
        var bh8 = b8 >>> 13;
        var b9 = b[9] | 0;
        var bl9 = b9 & 0x1fff;
        var bh9 = b9 >>> 13;
        out.negative = self.negative ^ num.negative;
        out.length = 19;
        /* k = 0 */ lo = Math.imul(al0, bl0);
        mid = Math.imul(al0, bh0);
        mid = mid + Math.imul(ah0, bl0) | 0;
        hi = Math.imul(ah0, bh0);
        var w0 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
        w0 &= 0x3ffffff;
        /* k = 1 */ lo = Math.imul(al1, bl0);
        mid = Math.imul(al1, bh0);
        mid = mid + Math.imul(ah1, bl0) | 0;
        hi = Math.imul(ah1, bh0);
        lo = lo + Math.imul(al0, bl1) | 0;
        mid = mid + Math.imul(al0, bh1) | 0;
        mid = mid + Math.imul(ah0, bl1) | 0;
        hi = hi + Math.imul(ah0, bh1) | 0;
        var w1 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
        w1 &= 0x3ffffff;
        /* k = 2 */ lo = Math.imul(al2, bl0);
        mid = Math.imul(al2, bh0);
        mid = mid + Math.imul(ah2, bl0) | 0;
        hi = Math.imul(ah2, bh0);
        lo = lo + Math.imul(al1, bl1) | 0;
        mid = mid + Math.imul(al1, bh1) | 0;
        mid = mid + Math.imul(ah1, bl1) | 0;
        hi = hi + Math.imul(ah1, bh1) | 0;
        lo = lo + Math.imul(al0, bl2) | 0;
        mid = mid + Math.imul(al0, bh2) | 0;
        mid = mid + Math.imul(ah0, bl2) | 0;
        hi = hi + Math.imul(ah0, bh2) | 0;
        var w2 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
        w2 &= 0x3ffffff;
        /* k = 3 */ lo = Math.imul(al3, bl0);
        mid = Math.imul(al3, bh0);
        mid = mid + Math.imul(ah3, bl0) | 0;
        hi = Math.imul(ah3, bh0);
        lo = lo + Math.imul(al2, bl1) | 0;
        mid = mid + Math.imul(al2, bh1) | 0;
        mid = mid + Math.imul(ah2, bl1) | 0;
        hi = hi + Math.imul(ah2, bh1) | 0;
        lo = lo + Math.imul(al1, bl2) | 0;
        mid = mid + Math.imul(al1, bh2) | 0;
        mid = mid + Math.imul(ah1, bl2) | 0;
        hi = hi + Math.imul(ah1, bh2) | 0;
        lo = lo + Math.imul(al0, bl3) | 0;
        mid = mid + Math.imul(al0, bh3) | 0;
        mid = mid + Math.imul(ah0, bl3) | 0;
        hi = hi + Math.imul(ah0, bh3) | 0;
        var w3 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
        w3 &= 0x3ffffff;
        /* k = 4 */ lo = Math.imul(al4, bl0);
        mid = Math.imul(al4, bh0);
        mid = mid + Math.imul(ah4, bl0) | 0;
        hi = Math.imul(ah4, bh0);
        lo = lo + Math.imul(al3, bl1) | 0;
        mid = mid + Math.imul(al3, bh1) | 0;
        mid = mid + Math.imul(ah3, bl1) | 0;
        hi = hi + Math.imul(ah3, bh1) | 0;
        lo = lo + Math.imul(al2, bl2) | 0;
        mid = mid + Math.imul(al2, bh2) | 0;
        mid = mid + Math.imul(ah2, bl2) | 0;
        hi = hi + Math.imul(ah2, bh2) | 0;
        lo = lo + Math.imul(al1, bl3) | 0;
        mid = mid + Math.imul(al1, bh3) | 0;
        mid = mid + Math.imul(ah1, bl3) | 0;
        hi = hi + Math.imul(ah1, bh3) | 0;
        lo = lo + Math.imul(al0, bl4) | 0;
        mid = mid + Math.imul(al0, bh4) | 0;
        mid = mid + Math.imul(ah0, bl4) | 0;
        hi = hi + Math.imul(ah0, bh4) | 0;
        var w4 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
        w4 &= 0x3ffffff;
        /* k = 5 */ lo = Math.imul(al5, bl0);
        mid = Math.imul(al5, bh0);
        mid = mid + Math.imul(ah5, bl0) | 0;
        hi = Math.imul(ah5, bh0);
        lo = lo + Math.imul(al4, bl1) | 0;
        mid = mid + Math.imul(al4, bh1) | 0;
        mid = mid + Math.imul(ah4, bl1) | 0;
        hi = hi + Math.imul(ah4, bh1) | 0;
        lo = lo + Math.imul(al3, bl2) | 0;
        mid = mid + Math.imul(al3, bh2) | 0;
        mid = mid + Math.imul(ah3, bl2) | 0;
        hi = hi + Math.imul(ah3, bh2) | 0;
        lo = lo + Math.imul(al2, bl3) | 0;
        mid = mid + Math.imul(al2, bh3) | 0;
        mid = mid + Math.imul(ah2, bl3) | 0;
        hi = hi + Math.imul(ah2, bh3) | 0;
        lo = lo + Math.imul(al1, bl4) | 0;
        mid = mid + Math.imul(al1, bh4) | 0;
        mid = mid + Math.imul(ah1, bl4) | 0;
        hi = hi + Math.imul(ah1, bh4) | 0;
        lo = lo + Math.imul(al0, bl5) | 0;
        mid = mid + Math.imul(al0, bh5) | 0;
        mid = mid + Math.imul(ah0, bl5) | 0;
        hi = hi + Math.imul(ah0, bh5) | 0;
        var w5 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
        w5 &= 0x3ffffff;
        /* k = 6 */ lo = Math.imul(al6, bl0);
        mid = Math.imul(al6, bh0);
        mid = mid + Math.imul(ah6, bl0) | 0;
        hi = Math.imul(ah6, bh0);
        lo = lo + Math.imul(al5, bl1) | 0;
        mid = mid + Math.imul(al5, bh1) | 0;
        mid = mid + Math.imul(ah5, bl1) | 0;
        hi = hi + Math.imul(ah5, bh1) | 0;
        lo = lo + Math.imul(al4, bl2) | 0;
        mid = mid + Math.imul(al4, bh2) | 0;
        mid = mid + Math.imul(ah4, bl2) | 0;
        hi = hi + Math.imul(ah4, bh2) | 0;
        lo = lo + Math.imul(al3, bl3) | 0;
        mid = mid + Math.imul(al3, bh3) | 0;
        mid = mid + Math.imul(ah3, bl3) | 0;
        hi = hi + Math.imul(ah3, bh3) | 0;
        lo = lo + Math.imul(al2, bl4) | 0;
        mid = mid + Math.imul(al2, bh4) | 0;
        mid = mid + Math.imul(ah2, bl4) | 0;
        hi = hi + Math.imul(ah2, bh4) | 0;
        lo = lo + Math.imul(al1, bl5) | 0;
        mid = mid + Math.imul(al1, bh5) | 0;
        mid = mid + Math.imul(ah1, bl5) | 0;
        hi = hi + Math.imul(ah1, bh5) | 0;
        lo = lo + Math.imul(al0, bl6) | 0;
        mid = mid + Math.imul(al0, bh6) | 0;
        mid = mid + Math.imul(ah0, bl6) | 0;
        hi = hi + Math.imul(ah0, bh6) | 0;
        var w6 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
        w6 &= 0x3ffffff;
        /* k = 7 */ lo = Math.imul(al7, bl0);
        mid = Math.imul(al7, bh0);
        mid = mid + Math.imul(ah7, bl0) | 0;
        hi = Math.imul(ah7, bh0);
        lo = lo + Math.imul(al6, bl1) | 0;
        mid = mid + Math.imul(al6, bh1) | 0;
        mid = mid + Math.imul(ah6, bl1) | 0;
        hi = hi + Math.imul(ah6, bh1) | 0;
        lo = lo + Math.imul(al5, bl2) | 0;
        mid = mid + Math.imul(al5, bh2) | 0;
        mid = mid + Math.imul(ah5, bl2) | 0;
        hi = hi + Math.imul(ah5, bh2) | 0;
        lo = lo + Math.imul(al4, bl3) | 0;
        mid = mid + Math.imul(al4, bh3) | 0;
        mid = mid + Math.imul(ah4, bl3) | 0;
        hi = hi + Math.imul(ah4, bh3) | 0;
        lo = lo + Math.imul(al3, bl4) | 0;
        mid = mid + Math.imul(al3, bh4) | 0;
        mid = mid + Math.imul(ah3, bl4) | 0;
        hi = hi + Math.imul(ah3, bh4) | 0;
        lo = lo + Math.imul(al2, bl5) | 0;
        mid = mid + Math.imul(al2, bh5) | 0;
        mid = mid + Math.imul(ah2, bl5) | 0;
        hi = hi + Math.imul(ah2, bh5) | 0;
        lo = lo + Math.imul(al1, bl6) | 0;
        mid = mid + Math.imul(al1, bh6) | 0;
        mid = mid + Math.imul(ah1, bl6) | 0;
        hi = hi + Math.imul(ah1, bh6) | 0;
        lo = lo + Math.imul(al0, bl7) | 0;
        mid = mid + Math.imul(al0, bh7) | 0;
        mid = mid + Math.imul(ah0, bl7) | 0;
        hi = hi + Math.imul(ah0, bh7) | 0;
        var w7 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
        w7 &= 0x3ffffff;
        /* k = 8 */ lo = Math.imul(al8, bl0);
        mid = Math.imul(al8, bh0);
        mid = mid + Math.imul(ah8, bl0) | 0;
        hi = Math.imul(ah8, bh0);
        lo = lo + Math.imul(al7, bl1) | 0;
        mid = mid + Math.imul(al7, bh1) | 0;
        mid = mid + Math.imul(ah7, bl1) | 0;
        hi = hi + Math.imul(ah7, bh1) | 0;
        lo = lo + Math.imul(al6, bl2) | 0;
        mid = mid + Math.imul(al6, bh2) | 0;
        mid = mid + Math.imul(ah6, bl2) | 0;
        hi = hi + Math.imul(ah6, bh2) | 0;
        lo = lo + Math.imul(al5, bl3) | 0;
        mid = mid + Math.imul(al5, bh3) | 0;
        mid = mid + Math.imul(ah5, bl3) | 0;
        hi = hi + Math.imul(ah5, bh3) | 0;
        lo = lo + Math.imul(al4, bl4) | 0;
        mid = mid + Math.imul(al4, bh4) | 0;
        mid = mid + Math.imul(ah4, bl4) | 0;
        hi = hi + Math.imul(ah4, bh4) | 0;
        lo = lo + Math.imul(al3, bl5) | 0;
        mid = mid + Math.imul(al3, bh5) | 0;
        mid = mid + Math.imul(ah3, bl5) | 0;
        hi = hi + Math.imul(ah3, bh5) | 0;
        lo = lo + Math.imul(al2, bl6) | 0;
        mid = mid + Math.imul(al2, bh6) | 0;
        mid = mid + Math.imul(ah2, bl6) | 0;
        hi = hi + Math.imul(ah2, bh6) | 0;
        lo = lo + Math.imul(al1, bl7) | 0;
        mid = mid + Math.imul(al1, bh7) | 0;
        mid = mid + Math.imul(ah1, bl7) | 0;
        hi = hi + Math.imul(ah1, bh7) | 0;
        lo = lo + Math.imul(al0, bl8) | 0;
        mid = mid + Math.imul(al0, bh8) | 0;
        mid = mid + Math.imul(ah0, bl8) | 0;
        hi = hi + Math.imul(ah0, bh8) | 0;
        var w8 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
        w8 &= 0x3ffffff;
        /* k = 9 */ lo = Math.imul(al9, bl0);
        mid = Math.imul(al9, bh0);
        mid = mid + Math.imul(ah9, bl0) | 0;
        hi = Math.imul(ah9, bh0);
        lo = lo + Math.imul(al8, bl1) | 0;
        mid = mid + Math.imul(al8, bh1) | 0;
        mid = mid + Math.imul(ah8, bl1) | 0;
        hi = hi + Math.imul(ah8, bh1) | 0;
        lo = lo + Math.imul(al7, bl2) | 0;
        mid = mid + Math.imul(al7, bh2) | 0;
        mid = mid + Math.imul(ah7, bl2) | 0;
        hi = hi + Math.imul(ah7, bh2) | 0;
        lo = lo + Math.imul(al6, bl3) | 0;
        mid = mid + Math.imul(al6, bh3) | 0;
        mid = mid + Math.imul(ah6, bl3) | 0;
        hi = hi + Math.imul(ah6, bh3) | 0;
        lo = lo + Math.imul(al5, bl4) | 0;
        mid = mid + Math.imul(al5, bh4) | 0;
        mid = mid + Math.imul(ah5, bl4) | 0;
        hi = hi + Math.imul(ah5, bh4) | 0;
        lo = lo + Math.imul(al4, bl5) | 0;
        mid = mid + Math.imul(al4, bh5) | 0;
        mid = mid + Math.imul(ah4, bl5) | 0;
        hi = hi + Math.imul(ah4, bh5) | 0;
        lo = lo + Math.imul(al3, bl6) | 0;
        mid = mid + Math.imul(al3, bh6) | 0;
        mid = mid + Math.imul(ah3, bl6) | 0;
        hi = hi + Math.imul(ah3, bh6) | 0;
        lo = lo + Math.imul(al2, bl7) | 0;
        mid = mid + Math.imul(al2, bh7) | 0;
        mid = mid + Math.imul(ah2, bl7) | 0;
        hi = hi + Math.imul(ah2, bh7) | 0;
        lo = lo + Math.imul(al1, bl8) | 0;
        mid = mid + Math.imul(al1, bh8) | 0;
        mid = mid + Math.imul(ah1, bl8) | 0;
        hi = hi + Math.imul(ah1, bh8) | 0;
        lo = lo + Math.imul(al0, bl9) | 0;
        mid = mid + Math.imul(al0, bh9) | 0;
        mid = mid + Math.imul(ah0, bl9) | 0;
        hi = hi + Math.imul(ah0, bh9) | 0;
        var w9 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
        w9 &= 0x3ffffff;
        /* k = 10 */ lo = Math.imul(al9, bl1);
        mid = Math.imul(al9, bh1);
        mid = mid + Math.imul(ah9, bl1) | 0;
        hi = Math.imul(ah9, bh1);
        lo = lo + Math.imul(al8, bl2) | 0;
        mid = mid + Math.imul(al8, bh2) | 0;
        mid = mid + Math.imul(ah8, bl2) | 0;
        hi = hi + Math.imul(ah8, bh2) | 0;
        lo = lo + Math.imul(al7, bl3) | 0;
        mid = mid + Math.imul(al7, bh3) | 0;
        mid = mid + Math.imul(ah7, bl3) | 0;
        hi = hi + Math.imul(ah7, bh3) | 0;
        lo = lo + Math.imul(al6, bl4) | 0;
        mid = mid + Math.imul(al6, bh4) | 0;
        mid = mid + Math.imul(ah6, bl4) | 0;
        hi = hi + Math.imul(ah6, bh4) | 0;
        lo = lo + Math.imul(al5, bl5) | 0;
        mid = mid + Math.imul(al5, bh5) | 0;
        mid = mid + Math.imul(ah5, bl5) | 0;
        hi = hi + Math.imul(ah5, bh5) | 0;
        lo = lo + Math.imul(al4, bl6) | 0;
        mid = mid + Math.imul(al4, bh6) | 0;
        mid = mid + Math.imul(ah4, bl6) | 0;
        hi = hi + Math.imul(ah4, bh6) | 0;
        lo = lo + Math.imul(al3, bl7) | 0;
        mid = mid + Math.imul(al3, bh7) | 0;
        mid = mid + Math.imul(ah3, bl7) | 0;
        hi = hi + Math.imul(ah3, bh7) | 0;
        lo = lo + Math.imul(al2, bl8) | 0;
        mid = mid + Math.imul(al2, bh8) | 0;
        mid = mid + Math.imul(ah2, bl8) | 0;
        hi = hi + Math.imul(ah2, bh8) | 0;
        lo = lo + Math.imul(al1, bl9) | 0;
        mid = mid + Math.imul(al1, bh9) | 0;
        mid = mid + Math.imul(ah1, bl9) | 0;
        hi = hi + Math.imul(ah1, bh9) | 0;
        var w10 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
        w10 &= 0x3ffffff;
        /* k = 11 */ lo = Math.imul(al9, bl2);
        mid = Math.imul(al9, bh2);
        mid = mid + Math.imul(ah9, bl2) | 0;
        hi = Math.imul(ah9, bh2);
        lo = lo + Math.imul(al8, bl3) | 0;
        mid = mid + Math.imul(al8, bh3) | 0;
        mid = mid + Math.imul(ah8, bl3) | 0;
        hi = hi + Math.imul(ah8, bh3) | 0;
        lo = lo + Math.imul(al7, bl4) | 0;
        mid = mid + Math.imul(al7, bh4) | 0;
        mid = mid + Math.imul(ah7, bl4) | 0;
        hi = hi + Math.imul(ah7, bh4) | 0;
        lo = lo + Math.imul(al6, bl5) | 0;
        mid = mid + Math.imul(al6, bh5) | 0;
        mid = mid + Math.imul(ah6, bl5) | 0;
        hi = hi + Math.imul(ah6, bh5) | 0;
        lo = lo + Math.imul(al5, bl6) | 0;
        mid = mid + Math.imul(al5, bh6) | 0;
        mid = mid + Math.imul(ah5, bl6) | 0;
        hi = hi + Math.imul(ah5, bh6) | 0;
        lo = lo + Math.imul(al4, bl7) | 0;
        mid = mid + Math.imul(al4, bh7) | 0;
        mid = mid + Math.imul(ah4, bl7) | 0;
        hi = hi + Math.imul(ah4, bh7) | 0;
        lo = lo + Math.imul(al3, bl8) | 0;
        mid = mid + Math.imul(al3, bh8) | 0;
        mid = mid + Math.imul(ah3, bl8) | 0;
        hi = hi + Math.imul(ah3, bh8) | 0;
        lo = lo + Math.imul(al2, bl9) | 0;
        mid = mid + Math.imul(al2, bh9) | 0;
        mid = mid + Math.imul(ah2, bl9) | 0;
        hi = hi + Math.imul(ah2, bh9) | 0;
        var w11 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
        w11 &= 0x3ffffff;
        /* k = 12 */ lo = Math.imul(al9, bl3);
        mid = Math.imul(al9, bh3);
        mid = mid + Math.imul(ah9, bl3) | 0;
        hi = Math.imul(ah9, bh3);
        lo = lo + Math.imul(al8, bl4) | 0;
        mid = mid + Math.imul(al8, bh4) | 0;
        mid = mid + Math.imul(ah8, bl4) | 0;
        hi = hi + Math.imul(ah8, bh4) | 0;
        lo = lo + Math.imul(al7, bl5) | 0;
        mid = mid + Math.imul(al7, bh5) | 0;
        mid = mid + Math.imul(ah7, bl5) | 0;
        hi = hi + Math.imul(ah7, bh5) | 0;
        lo = lo + Math.imul(al6, bl6) | 0;
        mid = mid + Math.imul(al6, bh6) | 0;
        mid = mid + Math.imul(ah6, bl6) | 0;
        hi = hi + Math.imul(ah6, bh6) | 0;
        lo = lo + Math.imul(al5, bl7) | 0;
        mid = mid + Math.imul(al5, bh7) | 0;
        mid = mid + Math.imul(ah5, bl7) | 0;
        hi = hi + Math.imul(ah5, bh7) | 0;
        lo = lo + Math.imul(al4, bl8) | 0;
        mid = mid + Math.imul(al4, bh8) | 0;
        mid = mid + Math.imul(ah4, bl8) | 0;
        hi = hi + Math.imul(ah4, bh8) | 0;
        lo = lo + Math.imul(al3, bl9) | 0;
        mid = mid + Math.imul(al3, bh9) | 0;
        mid = mid + Math.imul(ah3, bl9) | 0;
        hi = hi + Math.imul(ah3, bh9) | 0;
        var w12 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
        w12 &= 0x3ffffff;
        /* k = 13 */ lo = Math.imul(al9, bl4);
        mid = Math.imul(al9, bh4);
        mid = mid + Math.imul(ah9, bl4) | 0;
        hi = Math.imul(ah9, bh4);
        lo = lo + Math.imul(al8, bl5) | 0;
        mid = mid + Math.imul(al8, bh5) | 0;
        mid = mid + Math.imul(ah8, bl5) | 0;
        hi = hi + Math.imul(ah8, bh5) | 0;
        lo = lo + Math.imul(al7, bl6) | 0;
        mid = mid + Math.imul(al7, bh6) | 0;
        mid = mid + Math.imul(ah7, bl6) | 0;
        hi = hi + Math.imul(ah7, bh6) | 0;
        lo = lo + Math.imul(al6, bl7) | 0;
        mid = mid + Math.imul(al6, bh7) | 0;
        mid = mid + Math.imul(ah6, bl7) | 0;
        hi = hi + Math.imul(ah6, bh7) | 0;
        lo = lo + Math.imul(al5, bl8) | 0;
        mid = mid + Math.imul(al5, bh8) | 0;
        mid = mid + Math.imul(ah5, bl8) | 0;
        hi = hi + Math.imul(ah5, bh8) | 0;
        lo = lo + Math.imul(al4, bl9) | 0;
        mid = mid + Math.imul(al4, bh9) | 0;
        mid = mid + Math.imul(ah4, bl9) | 0;
        hi = hi + Math.imul(ah4, bh9) | 0;
        var w13 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
        w13 &= 0x3ffffff;
        /* k = 14 */ lo = Math.imul(al9, bl5);
        mid = Math.imul(al9, bh5);
        mid = mid + Math.imul(ah9, bl5) | 0;
        hi = Math.imul(ah9, bh5);
        lo = lo + Math.imul(al8, bl6) | 0;
        mid = mid + Math.imul(al8, bh6) | 0;
        mid = mid + Math.imul(ah8, bl6) | 0;
        hi = hi + Math.imul(ah8, bh6) | 0;
        lo = lo + Math.imul(al7, bl7) | 0;
        mid = mid + Math.imul(al7, bh7) | 0;
        mid = mid + Math.imul(ah7, bl7) | 0;
        hi = hi + Math.imul(ah7, bh7) | 0;
        lo = lo + Math.imul(al6, bl8) | 0;
        mid = mid + Math.imul(al6, bh8) | 0;
        mid = mid + Math.imul(ah6, bl8) | 0;
        hi = hi + Math.imul(ah6, bh8) | 0;
        lo = lo + Math.imul(al5, bl9) | 0;
        mid = mid + Math.imul(al5, bh9) | 0;
        mid = mid + Math.imul(ah5, bl9) | 0;
        hi = hi + Math.imul(ah5, bh9) | 0;
        var w14 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
        w14 &= 0x3ffffff;
        /* k = 15 */ lo = Math.imul(al9, bl6);
        mid = Math.imul(al9, bh6);
        mid = mid + Math.imul(ah9, bl6) | 0;
        hi = Math.imul(ah9, bh6);
        lo = lo + Math.imul(al8, bl7) | 0;
        mid = mid + Math.imul(al8, bh7) | 0;
        mid = mid + Math.imul(ah8, bl7) | 0;
        hi = hi + Math.imul(ah8, bh7) | 0;
        lo = lo + Math.imul(al7, bl8) | 0;
        mid = mid + Math.imul(al7, bh8) | 0;
        mid = mid + Math.imul(ah7, bl8) | 0;
        hi = hi + Math.imul(ah7, bh8) | 0;
        lo = lo + Math.imul(al6, bl9) | 0;
        mid = mid + Math.imul(al6, bh9) | 0;
        mid = mid + Math.imul(ah6, bl9) | 0;
        hi = hi + Math.imul(ah6, bh9) | 0;
        var w15 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
        w15 &= 0x3ffffff;
        /* k = 16 */ lo = Math.imul(al9, bl7);
        mid = Math.imul(al9, bh7);
        mid = mid + Math.imul(ah9, bl7) | 0;
        hi = Math.imul(ah9, bh7);
        lo = lo + Math.imul(al8, bl8) | 0;
        mid = mid + Math.imul(al8, bh8) | 0;
        mid = mid + Math.imul(ah8, bl8) | 0;
        hi = hi + Math.imul(ah8, bh8) | 0;
        lo = lo + Math.imul(al7, bl9) | 0;
        mid = mid + Math.imul(al7, bh9) | 0;
        mid = mid + Math.imul(ah7, bl9) | 0;
        hi = hi + Math.imul(ah7, bh9) | 0;
        var w16 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
        w16 &= 0x3ffffff;
        /* k = 17 */ lo = Math.imul(al9, bl8);
        mid = Math.imul(al9, bh8);
        mid = mid + Math.imul(ah9, bl8) | 0;
        hi = Math.imul(ah9, bh8);
        lo = lo + Math.imul(al8, bl9) | 0;
        mid = mid + Math.imul(al8, bh9) | 0;
        mid = mid + Math.imul(ah8, bl9) | 0;
        hi = hi + Math.imul(ah8, bh9) | 0;
        var w17 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
        w17 &= 0x3ffffff;
        /* k = 18 */ lo = Math.imul(al9, bl9);
        mid = Math.imul(al9, bh9);
        mid = mid + Math.imul(ah9, bl9) | 0;
        hi = Math.imul(ah9, bh9);
        var w18 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
        w18 &= 0x3ffffff;
        o[0] = w0;
        o[1] = w1;
        o[2] = w2;
        o[3] = w3;
        o[4] = w4;
        o[5] = w5;
        o[6] = w6;
        o[7] = w7;
        o[8] = w8;
        o[9] = w9;
        o[10] = w10;
        o[11] = w11;
        o[12] = w12;
        o[13] = w13;
        o[14] = w14;
        o[15] = w15;
        o[16] = w16;
        o[17] = w17;
        o[18] = w18;
        if (c !== 0) {
            o[19] = c;
            out.length++;
        }
        return out;
    };
    // Polyfill comb
    if (!Math.imul) comb10MulTo = smallMulTo;
    function bigMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        out.length = self.length + num.length;
        var carry = 0;
        var hncarry = 0;
        for(var k = 0; k < out.length - 1; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = hncarry;
            hncarry = 0;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j;
                var a = self.words[i] | 0;
                var b = num.words[j] | 0;
                var r = a * b;
                var lo = r & 0x3ffffff;
                ncarry = ncarry + (r / 0x4000000 | 0) | 0;
                lo = lo + rword | 0;
                rword = lo & 0x3ffffff;
                ncarry = ncarry + (lo >>> 26) | 0;
                hncarry += ncarry >>> 26;
                ncarry &= 0x3ffffff;
            }
            out.words[k] = rword;
            carry = ncarry;
            ncarry = hncarry;
        }
        if (carry !== 0) out.words[k] = carry;
        else out.length--;
        return out.strip();
    }
    function jumboMulTo(self, num, out) {
        var fftm = new FFTM();
        return fftm.mulp(self, num, out);
    }
    BN.prototype.mulTo = function mulTo(num, out) {
        var res;
        var len = this.length + num.length;
        if (this.length === 10 && num.length === 10) res = comb10MulTo(this, num, out);
        else if (len < 63) res = smallMulTo(this, num, out);
        else if (len < 1024) res = bigMulTo(this, num, out);
        else res = jumboMulTo(this, num, out);
        return res;
    };
    // Cooley-Tukey algorithm for FFT
    // slightly revisited to rely on looping instead of recursion
    function FFTM(x, y) {
        this.x = x;
        this.y = y;
    }
    FFTM.prototype.makeRBT = function makeRBT(N) {
        var t = new Array(N);
        var l = BN.prototype._countBits(N) - 1;
        for(var i = 0; i < N; i++)t[i] = this.revBin(i, l, N);
        return t;
    };
    // Returns binary-reversed representation of `x`
    FFTM.prototype.revBin = function revBin(x, l, N) {
        if (x === 0 || x === N - 1) return x;
        var rb = 0;
        for(var i = 0; i < l; i++){
            rb |= (x & 1) << l - i - 1;
            x >>= 1;
        }
        return rb;
    };
    // Performs "tweedling" phase, therefore 'emulating'
    // behaviour of the recursive algorithm
    FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
        for(var i = 0; i < N; i++){
            rtws[i] = rws[rbt[i]];
            itws[i] = iws[rbt[i]];
        }
    };
    FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
        this.permute(rbt, rws, iws, rtws, itws, N);
        for(var s = 1; s < N; s <<= 1){
            var l = s << 1;
            var rtwdf = Math.cos(2 * Math.PI / l);
            var itwdf = Math.sin(2 * Math.PI / l);
            for(var p = 0; p < N; p += l){
                var rtwdf_ = rtwdf;
                var itwdf_ = itwdf;
                for(var j = 0; j < s; j++){
                    var re = rtws[p + j];
                    var ie = itws[p + j];
                    var ro = rtws[p + j + s];
                    var io = itws[p + j + s];
                    var rx = rtwdf_ * ro - itwdf_ * io;
                    io = rtwdf_ * io + itwdf_ * ro;
                    ro = rx;
                    rtws[p + j] = re + ro;
                    itws[p + j] = ie + io;
                    rtws[p + j + s] = re - ro;
                    itws[p + j + s] = ie - io;
                    /* jshint maxdepth : false */ if (j !== l) {
                        rx = rtwdf * rtwdf_ - itwdf * itwdf_;
                        itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                        rtwdf_ = rx;
                    }
                }
            }
        }
    };
    FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
        var N = Math.max(m, n) | 1;
        var odd = N & 1;
        var i = 0;
        for(N = N / 2 | 0; N; N = N >>> 1)i++;
        return 1 << i + 1 + odd;
    };
    FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
        if (N <= 1) return;
        for(var i = 0; i < N / 2; i++){
            var t = rws[i];
            rws[i] = rws[N - i - 1];
            rws[N - i - 1] = t;
            t = iws[i];
            iws[i] = -iws[N - i - 1];
            iws[N - i - 1] = -t;
        }
    };
    FFTM.prototype.normalize13b = function normalize13b(ws, N) {
        var carry = 0;
        for(var i = 0; i < N / 2; i++){
            var w = Math.round(ws[2 * i + 1] / N) * 0x2000 + Math.round(ws[2 * i] / N) + carry;
            ws[i] = w & 0x3ffffff;
            if (w < 0x4000000) carry = 0;
            else carry = w / 0x4000000 | 0;
        }
        return ws;
    };
    FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
        var carry = 0;
        for(var i = 0; i < len; i++){
            carry = carry + (ws[i] | 0);
            rws[2 * i] = carry & 0x1fff;
            carry = carry >>> 13;
            rws[2 * i + 1] = carry & 0x1fff;
            carry = carry >>> 13;
        }
        // Pad with zeroes
        for(i = 2 * len; i < N; ++i)rws[i] = 0;
        assert(carry === 0);
        assert((carry & -8192) === 0);
    };
    FFTM.prototype.stub = function stub(N) {
        var ph = new Array(N);
        for(var i = 0; i < N; i++)ph[i] = 0;
        return ph;
    };
    FFTM.prototype.mulp = function mulp(x, y, out) {
        var N = 2 * this.guessLen13b(x.length, y.length);
        var rbt = this.makeRBT(N);
        var _ = this.stub(N);
        var rws = new Array(N);
        var rwst = new Array(N);
        var iwst = new Array(N);
        var nrws = new Array(N);
        var nrwst = new Array(N);
        var niwst = new Array(N);
        var rmws = out.words;
        rmws.length = N;
        this.convert13b(x.words, x.length, rws, N);
        this.convert13b(y.words, y.length, nrws, N);
        this.transform(rws, _, rwst, iwst, N, rbt);
        this.transform(nrws, _, nrwst, niwst, N, rbt);
        for(var i = 0; i < N; i++){
            var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
            iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
            rwst[i] = rx;
        }
        this.conjugate(rwst, iwst, N);
        this.transform(rwst, iwst, rmws, _, N, rbt);
        this.conjugate(rmws, _, N);
        this.normalize13b(rmws, N);
        out.negative = x.negative ^ y.negative;
        out.length = x.length + y.length;
        return out.strip();
    };
    // Multiply `this` by `num`
    BN.prototype.mul = function mul(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return this.mulTo(num, out);
    };
    // Multiply employing FFT
    BN.prototype.mulf = function mulf(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return jumboMulTo(this, num, out);
    };
    // In-place Multiplication
    BN.prototype.imul = function imul(num) {
        return this.clone().mulTo(num, this);
    };
    BN.prototype.imuln = function imuln(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        // Carry
        var carry = 0;
        for(var i = 0; i < this.length; i++){
            var w = (this.words[i] | 0) * num;
            var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
            carry >>= 26;
            carry += w / 0x4000000 | 0;
            // NOTE: lo is 27bit maximum
            carry += lo >>> 26;
            this.words[i] = lo & 0x3ffffff;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.muln = function muln(num) {
        return this.clone().imuln(num);
    };
    // `this` * `this`
    BN.prototype.sqr = function sqr() {
        return this.mul(this);
    };
    // `this` * `this` in-place
    BN.prototype.isqr = function isqr() {
        return this.imul(this.clone());
    };
    // Math.pow(`this`, `num`)
    BN.prototype.pow = function pow(num) {
        var w = toBitArray(num);
        if (w.length === 0) return new BN(1);
        // Skip leading zeroes
        var res = this;
        for(var i = 0; i < w.length; i++, res = res.sqr()){
            if (w[i] !== 0) break;
        }
        if (++i < w.length) for(var q = res.sqr(); i < w.length; i++, q = q.sqr()){
            if (w[i] === 0) continue;
            res = res.mul(q);
        }
        return res;
    };
    // Shift-left in-place
    BN.prototype.iushln = function iushln(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        var carryMask = 0x3ffffff >>> 26 - r << 26 - r;
        var i;
        if (r !== 0) {
            var carry = 0;
            for(i = 0; i < this.length; i++){
                var newCarry = this.words[i] & carryMask;
                var c = (this.words[i] | 0) - newCarry << r;
                this.words[i] = c | carry;
                carry = newCarry >>> 26 - r;
            }
            if (carry) {
                this.words[i] = carry;
                this.length++;
            }
        }
        if (s !== 0) {
            for(i = this.length - 1; i >= 0; i--)this.words[i + s] = this.words[i];
            for(i = 0; i < s; i++)this.words[i] = 0;
            this.length += s;
        }
        return this.strip();
    };
    BN.prototype.ishln = function ishln(bits) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushln(bits);
    };
    // Shift-right in-place
    // NOTE: `hint` is a lowest bit before trailing zeroes
    // NOTE: if `extended` is present - it will be filled with destroyed bits
    BN.prototype.iushrn = function iushrn(bits, hint, extended) {
        assert(typeof bits === "number" && bits >= 0);
        var h;
        if (hint) h = (hint - hint % 26) / 26;
        else h = 0;
        var r = bits % 26;
        var s = Math.min((bits - r) / 26, this.length);
        var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
        var maskedWords = extended;
        h -= s;
        h = Math.max(0, h);
        // Extended mode, copy masked part
        if (maskedWords) {
            for(var i = 0; i < s; i++)maskedWords.words[i] = this.words[i];
            maskedWords.length = s;
        }
        if (s === 0) ;
        else if (this.length > s) {
            this.length -= s;
            for(i = 0; i < this.length; i++)this.words[i] = this.words[i + s];
        } else {
            this.words[0] = 0;
            this.length = 1;
        }
        var carry = 0;
        for(i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--){
            var word = this.words[i] | 0;
            this.words[i] = carry << 26 - r | word >>> r;
            carry = word & mask;
        }
        // Push carried bits as a mask
        if (maskedWords && carry !== 0) maskedWords.words[maskedWords.length++] = carry;
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this.strip();
    };
    BN.prototype.ishrn = function ishrn(bits, hint, extended) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushrn(bits, hint, extended);
    };
    // Shift-left
    BN.prototype.shln = function shln(bits) {
        return this.clone().ishln(bits);
    };
    BN.prototype.ushln = function ushln(bits) {
        return this.clone().iushln(bits);
    };
    // Shift-right
    BN.prototype.shrn = function shrn(bits) {
        return this.clone().ishrn(bits);
    };
    BN.prototype.ushrn = function ushrn(bits) {
        return this.clone().iushrn(bits);
    };
    // Test if n bit is set
    BN.prototype.testn = function testn(bit) {
        assert(typeof bit === "number" && bit >= 0);
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) return false;
        // Check bit and return
        var w = this.words[s];
        return !!(w & q);
    };
    // Return only lowers bits of number (in-place)
    BN.prototype.imaskn = function imaskn(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        assert(this.negative === 0, "imaskn works only with positive numbers");
        if (this.length <= s) return this;
        if (r !== 0) s++;
        this.length = Math.min(s, this.length);
        if (r !== 0) {
            var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
            this.words[this.length - 1] &= mask;
        }
        return this.strip();
    };
    // Return only lowers bits of number
    BN.prototype.maskn = function maskn(bits) {
        return this.clone().imaskn(bits);
    };
    // Add plain number `num` to `this`
    BN.prototype.iaddn = function iaddn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.isubn(-num);
        // Possible sign change
        if (this.negative !== 0) {
            if (this.length === 1 && (this.words[0] | 0) < num) {
                this.words[0] = num - (this.words[0] | 0);
                this.negative = 0;
                return this;
            }
            this.negative = 0;
            this.isubn(num);
            this.negative = 1;
            return this;
        }
        // Add without checks
        return this._iaddn(num);
    };
    BN.prototype._iaddn = function _iaddn(num) {
        this.words[0] += num;
        // Carry
        for(var i = 0; i < this.length && this.words[i] >= 0x4000000; i++){
            this.words[i] -= 0x4000000;
            if (i === this.length - 1) this.words[i + 1] = 1;
            else this.words[i + 1]++;
        }
        this.length = Math.max(this.length, i + 1);
        return this;
    };
    // Subtract plain number `num` from `this`
    BN.prototype.isubn = function isubn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.iaddn(-num);
        if (this.negative !== 0) {
            this.negative = 0;
            this.iaddn(num);
            this.negative = 1;
            return this;
        }
        this.words[0] -= num;
        if (this.length === 1 && this.words[0] < 0) {
            this.words[0] = -this.words[0];
            this.negative = 1;
        } else // Carry
        for(var i = 0; i < this.length && this.words[i] < 0; i++){
            this.words[i] += 0x4000000;
            this.words[i + 1] -= 1;
        }
        return this.strip();
    };
    BN.prototype.addn = function addn(num) {
        return this.clone().iaddn(num);
    };
    BN.prototype.subn = function subn(num) {
        return this.clone().isubn(num);
    };
    BN.prototype.iabs = function iabs() {
        this.negative = 0;
        return this;
    };
    BN.prototype.abs = function abs() {
        return this.clone().iabs();
    };
    BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
        var len = num.length + shift;
        var i;
        this._expand(len);
        var w;
        var carry = 0;
        for(i = 0; i < num.length; i++){
            w = (this.words[i + shift] | 0) + carry;
            var right = (num.words[i] | 0) * mul;
            w -= right & 0x3ffffff;
            carry = (w >> 26) - (right / 0x4000000 | 0);
            this.words[i + shift] = w & 0x3ffffff;
        }
        for(; i < this.length - shift; i++){
            w = (this.words[i + shift] | 0) + carry;
            carry = w >> 26;
            this.words[i + shift] = w & 0x3ffffff;
        }
        if (carry === 0) return this.strip();
        // Subtraction overflow
        assert(carry === -1);
        carry = 0;
        for(i = 0; i < this.length; i++){
            w = -(this.words[i] | 0) + carry;
            carry = w >> 26;
            this.words[i] = w & 0x3ffffff;
        }
        this.negative = 1;
        return this.strip();
    };
    BN.prototype._wordDiv = function _wordDiv(num, mode) {
        var shift = this.length - num.length;
        var a = this.clone();
        var b = num;
        // Normalize
        var bhi = b.words[b.length - 1] | 0;
        var bhiBits = this._countBits(bhi);
        shift = 26 - bhiBits;
        if (shift !== 0) {
            b = b.ushln(shift);
            a.iushln(shift);
            bhi = b.words[b.length - 1] | 0;
        }
        // Initialize quotient
        var m = a.length - b.length;
        var q;
        if (mode !== "mod") {
            q = new BN(null);
            q.length = m + 1;
            q.words = new Array(q.length);
            for(var i = 0; i < q.length; i++)q.words[i] = 0;
        }
        var diff = a.clone()._ishlnsubmul(b, 1, m);
        if (diff.negative === 0) {
            a = diff;
            if (q) q.words[m] = 1;
        }
        for(var j = m - 1; j >= 0; j--){
            var qj = (a.words[b.length + j] | 0) * 0x4000000 + (a.words[b.length + j - 1] | 0);
            // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
            // (0x7ffffff)
            qj = Math.min(qj / bhi | 0, 0x3ffffff);
            a._ishlnsubmul(b, qj, j);
            while(a.negative !== 0){
                qj--;
                a.negative = 0;
                a._ishlnsubmul(b, 1, j);
                if (!a.isZero()) a.negative ^= 1;
            }
            if (q) q.words[j] = qj;
        }
        if (q) q.strip();
        a.strip();
        // Denormalize
        if (mode !== "div" && shift !== 0) a.iushrn(shift);
        return {
            div: q || null,
            mod: a
        };
    };
    // NOTE: 1) `mode` can be set to `mod` to request mod only,
    //       to `div` to request div only, or be absent to
    //       request both div & mod
    //       2) `positive` is true if unsigned mod is requested
    BN.prototype.divmod = function divmod(num, mode, positive) {
        assert(!num.isZero());
        if (this.isZero()) return {
            div: new BN(0),
            mod: new BN(0)
        };
        var div, mod, res;
        if (this.negative !== 0 && num.negative === 0) {
            res = this.neg().divmod(num, mode);
            if (mode !== "mod") div = res.div.neg();
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.iadd(num);
            }
            return {
                div: div,
                mod: mod
            };
        }
        if (this.negative === 0 && num.negative !== 0) {
            res = this.divmod(num.neg(), mode);
            if (mode !== "mod") div = res.div.neg();
            return {
                div: div,
                mod: res.mod
            };
        }
        if ((this.negative & num.negative) !== 0) {
            res = this.neg().divmod(num.neg(), mode);
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.isub(num);
            }
            return {
                div: res.div,
                mod: mod
            };
        }
        // Both numbers are positive at this point
        // Strip both numbers to approximate shift value
        if (num.length > this.length || this.cmp(num) < 0) return {
            div: new BN(0),
            mod: this
        };
        // Very short reduction
        if (num.length === 1) {
            if (mode === "div") return {
                div: this.divn(num.words[0]),
                mod: null
            };
            if (mode === "mod") return {
                div: null,
                mod: new BN(this.modn(num.words[0]))
            };
            return {
                div: this.divn(num.words[0]),
                mod: new BN(this.modn(num.words[0]))
            };
        }
        return this._wordDiv(num, mode);
    };
    // Find `this` / `num`
    BN.prototype.div = function div(num) {
        return this.divmod(num, "div", false).div;
    };
    // Find `this` % `num`
    BN.prototype.mod = function mod(num) {
        return this.divmod(num, "mod", false).mod;
    };
    BN.prototype.umod = function umod(num) {
        return this.divmod(num, "mod", true).mod;
    };
    // Find Round(`this` / `num`)
    BN.prototype.divRound = function divRound(num) {
        var dm = this.divmod(num);
        // Fast case - exact division
        if (dm.mod.isZero()) return dm.div;
        var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;
        var half = num.ushrn(1);
        var r2 = num.andln(1);
        var cmp = mod.cmp(half);
        // Round down
        if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
        // Round up
        return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
    };
    BN.prototype.modn = function modn(num) {
        assert(num <= 0x3ffffff);
        var p = 67108864 % num;
        var acc = 0;
        for(var i = this.length - 1; i >= 0; i--)acc = (p * acc + (this.words[i] | 0)) % num;
        return acc;
    };
    // In-place division by number
    BN.prototype.idivn = function idivn(num) {
        assert(num <= 0x3ffffff);
        var carry = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var w = (this.words[i] | 0) + carry * 0x4000000;
            this.words[i] = w / num | 0;
            carry = w % num;
        }
        return this.strip();
    };
    BN.prototype.divn = function divn(num) {
        return this.clone().idivn(num);
    };
    BN.prototype.egcd = function egcd(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var x = this;
        var y = p.clone();
        if (x.negative !== 0) x = x.umod(p);
        else x = x.clone();
        // A * x + B * y = x
        var A = new BN(1);
        var B = new BN(0);
        // C * x + D * y = y
        var C = new BN(0);
        var D = new BN(1);
        var g = 0;
        while(x.isEven() && y.isEven()){
            x.iushrn(1);
            y.iushrn(1);
            ++g;
        }
        var yp = y.clone();
        var xp = x.clone();
        while(!x.isZero()){
            for(var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                x.iushrn(i);
                while(i-- > 0){
                    if (A.isOdd() || B.isOdd()) {
                        A.iadd(yp);
                        B.isub(xp);
                    }
                    A.iushrn(1);
                    B.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                y.iushrn(j);
                while(j-- > 0){
                    if (C.isOdd() || D.isOdd()) {
                        C.iadd(yp);
                        D.isub(xp);
                    }
                    C.iushrn(1);
                    D.iushrn(1);
                }
            }
            if (x.cmp(y) >= 0) {
                x.isub(y);
                A.isub(C);
                B.isub(D);
            } else {
                y.isub(x);
                C.isub(A);
                D.isub(B);
            }
        }
        return {
            a: C,
            b: D,
            gcd: y.iushln(g)
        };
    };
    // This is reduced incarnation of the binary EEA
    // above, designated to invert members of the
    // _prime_ fields F(p) at a maximal speed
    BN.prototype._invmp = function _invmp(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var a = this;
        var b = p.clone();
        if (a.negative !== 0) a = a.umod(p);
        else a = a.clone();
        var x1 = new BN(1);
        var x2 = new BN(0);
        var delta = b.clone();
        while(a.cmpn(1) > 0 && b.cmpn(1) > 0){
            for(var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                a.iushrn(i);
                while(i-- > 0){
                    if (x1.isOdd()) x1.iadd(delta);
                    x1.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                b.iushrn(j);
                while(j-- > 0){
                    if (x2.isOdd()) x2.iadd(delta);
                    x2.iushrn(1);
                }
            }
            if (a.cmp(b) >= 0) {
                a.isub(b);
                x1.isub(x2);
            } else {
                b.isub(a);
                x2.isub(x1);
            }
        }
        var res;
        if (a.cmpn(1) === 0) res = x1;
        else res = x2;
        if (res.cmpn(0) < 0) res.iadd(p);
        return res;
    };
    BN.prototype.gcd = function gcd(num) {
        if (this.isZero()) return num.abs();
        if (num.isZero()) return this.abs();
        var a = this.clone();
        var b = num.clone();
        a.negative = 0;
        b.negative = 0;
        // Remove common factor of two
        for(var shift = 0; a.isEven() && b.isEven(); shift++){
            a.iushrn(1);
            b.iushrn(1);
        }
        do {
            while(a.isEven())a.iushrn(1);
            while(b.isEven())b.iushrn(1);
            var r = a.cmp(b);
            if (r < 0) {
                // Swap `a` and `b` to make `a` always bigger than `b`
                var t = a;
                a = b;
                b = t;
            } else if (r === 0 || b.cmpn(1) === 0) break;
            a.isub(b);
        }while (true);
        return b.iushln(shift);
    };
    // Invert number in the field F(num)
    BN.prototype.invm = function invm(num) {
        return this.egcd(num).a.umod(num);
    };
    BN.prototype.isEven = function isEven() {
        return (this.words[0] & 1) === 0;
    };
    BN.prototype.isOdd = function isOdd() {
        return (this.words[0] & 1) === 1;
    };
    // And first word and num
    BN.prototype.andln = function andln(num) {
        return this.words[0] & num;
    };
    // Increment at the bit position in-line
    BN.prototype.bincn = function bincn(bit) {
        assert(typeof bit === "number");
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) {
            this._expand(s + 1);
            this.words[s] |= q;
            return this;
        }
        // Add bit and propagate, if needed
        var carry = q;
        for(var i = s; carry !== 0 && i < this.length; i++){
            var w = this.words[i] | 0;
            w += carry;
            carry = w >>> 26;
            w &= 0x3ffffff;
            this.words[i] = w;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.isZero = function isZero() {
        return this.length === 1 && this.words[0] === 0;
    };
    BN.prototype.cmpn = function cmpn(num) {
        var negative = num < 0;
        if (this.negative !== 0 && !negative) return -1;
        if (this.negative === 0 && negative) return 1;
        this.strip();
        var res;
        if (this.length > 1) res = 1;
        else {
            if (negative) num = -num;
            assert(num <= 0x3ffffff, "Number is too big");
            var w = this.words[0] | 0;
            res = w === num ? 0 : w < num ? -1 : 1;
        }
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Compare two numbers and return:
    // 1 - if `this` > `num`
    // 0 - if `this` == `num`
    // -1 - if `this` < `num`
    BN.prototype.cmp = function cmp(num) {
        if (this.negative !== 0 && num.negative === 0) return -1;
        if (this.negative === 0 && num.negative !== 0) return 1;
        var res = this.ucmp(num);
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Unsigned comparison
    BN.prototype.ucmp = function ucmp(num) {
        // At this point both numbers have the same sign
        if (this.length > num.length) return 1;
        if (this.length < num.length) return -1;
        var res = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var a = this.words[i] | 0;
            var b = num.words[i] | 0;
            if (a === b) continue;
            if (a < b) res = -1;
            else if (a > b) res = 1;
            break;
        }
        return res;
    };
    BN.prototype.gtn = function gtn(num) {
        return this.cmpn(num) === 1;
    };
    BN.prototype.gt = function gt(num) {
        return this.cmp(num) === 1;
    };
    BN.prototype.gten = function gten(num) {
        return this.cmpn(num) >= 0;
    };
    BN.prototype.gte = function gte(num) {
        return this.cmp(num) >= 0;
    };
    BN.prototype.ltn = function ltn(num) {
        return this.cmpn(num) === -1;
    };
    BN.prototype.lt = function lt(num) {
        return this.cmp(num) === -1;
    };
    BN.prototype.lten = function lten(num) {
        return this.cmpn(num) <= 0;
    };
    BN.prototype.lte = function lte(num) {
        return this.cmp(num) <= 0;
    };
    BN.prototype.eqn = function eqn(num) {
        return this.cmpn(num) === 0;
    };
    BN.prototype.eq = function eq(num) {
        return this.cmp(num) === 0;
    };
    //
    // A reduce context, could be using montgomery or something better, depending
    // on the `m` itself.
    //
    BN.red = function red(num) {
        return new Red(num);
    };
    BN.prototype.toRed = function toRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        assert(this.negative === 0, "red works only with positives");
        return ctx.convertTo(this)._forceRed(ctx);
    };
    BN.prototype.fromRed = function fromRed() {
        assert(this.red, "fromRed works only with numbers in reduction context");
        return this.red.convertFrom(this);
    };
    BN.prototype._forceRed = function _forceRed(ctx) {
        this.red = ctx;
        return this;
    };
    BN.prototype.forceRed = function forceRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        return this._forceRed(ctx);
    };
    BN.prototype.redAdd = function redAdd(num) {
        assert(this.red, "redAdd works only with red numbers");
        return this.red.add(this, num);
    };
    BN.prototype.redIAdd = function redIAdd(num) {
        assert(this.red, "redIAdd works only with red numbers");
        return this.red.iadd(this, num);
    };
    BN.prototype.redSub = function redSub(num) {
        assert(this.red, "redSub works only with red numbers");
        return this.red.sub(this, num);
    };
    BN.prototype.redISub = function redISub(num) {
        assert(this.red, "redISub works only with red numbers");
        return this.red.isub(this, num);
    };
    BN.prototype.redShl = function redShl(num) {
        assert(this.red, "redShl works only with red numbers");
        return this.red.shl(this, num);
    };
    BN.prototype.redMul = function redMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.mul(this, num);
    };
    BN.prototype.redIMul = function redIMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.imul(this, num);
    };
    BN.prototype.redSqr = function redSqr() {
        assert(this.red, "redSqr works only with red numbers");
        this.red._verify1(this);
        return this.red.sqr(this);
    };
    BN.prototype.redISqr = function redISqr() {
        assert(this.red, "redISqr works only with red numbers");
        this.red._verify1(this);
        return this.red.isqr(this);
    };
    // Square root over p
    BN.prototype.redSqrt = function redSqrt() {
        assert(this.red, "redSqrt works only with red numbers");
        this.red._verify1(this);
        return this.red.sqrt(this);
    };
    BN.prototype.redInvm = function redInvm() {
        assert(this.red, "redInvm works only with red numbers");
        this.red._verify1(this);
        return this.red.invm(this);
    };
    // Return negative clone of `this` % `red modulo`
    BN.prototype.redNeg = function redNeg() {
        assert(this.red, "redNeg works only with red numbers");
        this.red._verify1(this);
        return this.red.neg(this);
    };
    BN.prototype.redPow = function redPow(num) {
        assert(this.red && !num.red, "redPow(normalNum)");
        this.red._verify1(this);
        return this.red.pow(this, num);
    };
    // Prime numbers with efficient reduction
    var primes = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
    };
    // Pseudo-Mersenne prime
    function MPrime(name, p) {
        // P = 2 ^ N - K
        this.name = name;
        this.p = new BN(p, 16);
        this.n = this.p.bitLength();
        this.k = new BN(1).iushln(this.n).isub(this.p);
        this.tmp = this._tmp();
    }
    MPrime.prototype._tmp = function _tmp() {
        var tmp = new BN(null);
        tmp.words = new Array(Math.ceil(this.n / 13));
        return tmp;
    };
    MPrime.prototype.ireduce = function ireduce(num) {
        // Assumes that `num` is less than `P^2`
        // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
        var r = num;
        var rlen;
        do {
            this.split(r, this.tmp);
            r = this.imulK(r);
            r = r.iadd(this.tmp);
            rlen = r.bitLength();
        }while (rlen > this.n);
        var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
        if (cmp === 0) {
            r.words[0] = 0;
            r.length = 1;
        } else if (cmp > 0) r.isub(this.p);
        else r.strip();
        return r;
    };
    MPrime.prototype.split = function split(input, out) {
        input.iushrn(this.n, 0, out);
    };
    MPrime.prototype.imulK = function imulK(num) {
        return num.imul(this.k);
    };
    function K256() {
        MPrime.call(this, "k256", "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f");
    }
    inherits(K256, MPrime);
    K256.prototype.split = function split(input, output) {
        // 256 = 9 * 26 + 22
        var mask = 0x3fffff;
        var outLen = Math.min(input.length, 9);
        for(var i = 0; i < outLen; i++)output.words[i] = input.words[i];
        output.length = outLen;
        if (input.length <= 9) {
            input.words[0] = 0;
            input.length = 1;
            return;
        }
        // Shift by 9 limbs
        var prev = input.words[9];
        output.words[output.length++] = prev & mask;
        for(i = 10; i < input.length; i++){
            var next = input.words[i] | 0;
            input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
            prev = next;
        }
        prev >>>= 22;
        input.words[i - 10] = prev;
        if (prev === 0 && input.length > 10) input.length -= 10;
        else input.length -= 9;
    };
    K256.prototype.imulK = function imulK(num) {
        // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
        num.words[num.length] = 0;
        num.words[num.length + 1] = 0;
        num.length += 2;
        // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
        var lo = 0;
        for(var i = 0; i < num.length; i++){
            var w = num.words[i] | 0;
            lo += w * 0x3d1;
            num.words[i] = lo & 0x3ffffff;
            lo = w * 0x40 + (lo / 0x4000000 | 0);
        }
        // Fast length reduction
        if (num.words[num.length - 1] === 0) {
            num.length--;
            if (num.words[num.length - 1] === 0) num.length--;
        }
        return num;
    };
    function P224() {
        MPrime.call(this, "p224", "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001");
    }
    inherits(P224, MPrime);
    function P192() {
        MPrime.call(this, "p192", "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff");
    }
    inherits(P192, MPrime);
    function P25519() {
        // 2 ^ 255 - 19
        MPrime.call(this, "25519", "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed");
    }
    inherits(P25519, MPrime);
    P25519.prototype.imulK = function imulK(num) {
        // K = 0x13
        var carry = 0;
        for(var i = 0; i < num.length; i++){
            var hi = (num.words[i] | 0) * 0x13 + carry;
            var lo = hi & 0x3ffffff;
            hi >>>= 26;
            num.words[i] = lo;
            carry = hi;
        }
        if (carry !== 0) num.words[num.length++] = carry;
        return num;
    };
    // Exported mostly for testing purposes, use plain name instead
    BN._prime = function prime(name) {
        // Cached version of prime
        if (primes[name]) return primes[name];
        var prime;
        if (name === "k256") prime = new K256();
        else if (name === "p224") prime = new P224();
        else if (name === "p192") prime = new P192();
        else if (name === "p25519") prime = new P25519();
        else throw new Error("Unknown prime " + name);
        primes[name] = prime;
        return prime;
    };
    //
    // Base reduction engine
    //
    function Red(m) {
        if (typeof m === "string") {
            var prime = BN._prime(m);
            this.m = prime.p;
            this.prime = prime;
        } else {
            assert(m.gtn(1), "modulus must be greater than 1");
            this.m = m;
            this.prime = null;
        }
    }
    Red.prototype._verify1 = function _verify1(a) {
        assert(a.negative === 0, "red works only with positives");
        assert(a.red, "red works only with red numbers");
    };
    Red.prototype._verify2 = function _verify2(a, b) {
        assert((a.negative | b.negative) === 0, "red works only with positives");
        assert(a.red && a.red === b.red, "red works only with red numbers");
    };
    Red.prototype.imod = function imod(a) {
        if (this.prime) return this.prime.ireduce(a)._forceRed(this);
        return a.umod(this.m)._forceRed(this);
    };
    Red.prototype.neg = function neg(a) {
        if (a.isZero()) return a.clone();
        return this.m.sub(a)._forceRed(this);
    };
    Red.prototype.add = function add(a, b) {
        this._verify2(a, b);
        var res = a.add(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res._forceRed(this);
    };
    Red.prototype.iadd = function iadd(a, b) {
        this._verify2(a, b);
        var res = a.iadd(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res;
    };
    Red.prototype.sub = function sub(a, b) {
        this._verify2(a, b);
        var res = a.sub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res._forceRed(this);
    };
    Red.prototype.isub = function isub(a, b) {
        this._verify2(a, b);
        var res = a.isub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res;
    };
    Red.prototype.shl = function shl(a, num) {
        this._verify1(a);
        return this.imod(a.ushln(num));
    };
    Red.prototype.imul = function imul(a, b) {
        this._verify2(a, b);
        return this.imod(a.imul(b));
    };
    Red.prototype.mul = function mul(a, b) {
        this._verify2(a, b);
        return this.imod(a.mul(b));
    };
    Red.prototype.isqr = function isqr(a) {
        return this.imul(a, a.clone());
    };
    Red.prototype.sqr = function sqr(a) {
        return this.mul(a, a);
    };
    Red.prototype.sqrt = function sqrt(a) {
        if (a.isZero()) return a.clone();
        var mod3 = this.m.andln(3);
        assert(mod3 % 2 === 1);
        // Fast case
        if (mod3 === 3) {
            var pow = this.m.add(new BN(1)).iushrn(2);
            return this.pow(a, pow);
        }
        // Tonelli-Shanks algorithm (Totally unoptimized and slow)
        //
        // Find Q and S, that Q * 2 ^ S = (P - 1)
        var q = this.m.subn(1);
        var s = 0;
        while(!q.isZero() && q.andln(1) === 0){
            s++;
            q.iushrn(1);
        }
        assert(!q.isZero());
        var one = new BN(1).toRed(this);
        var nOne = one.redNeg();
        // Find quadratic non-residue
        // NOTE: Max is such because of generalized Riemann hypothesis.
        var lpow = this.m.subn(1).iushrn(1);
        var z = this.m.bitLength();
        z = new BN(2 * z * z).toRed(this);
        while(this.pow(z, lpow).cmp(nOne) !== 0)z.redIAdd(nOne);
        var c = this.pow(z, q);
        var r = this.pow(a, q.addn(1).iushrn(1));
        var t = this.pow(a, q);
        var m = s;
        while(t.cmp(one) !== 0){
            var tmp = t;
            for(var i = 0; tmp.cmp(one) !== 0; i++)tmp = tmp.redSqr();
            assert(i < m);
            var b = this.pow(c, new BN(1).iushln(m - i - 1));
            r = r.redMul(b);
            c = b.redSqr();
            t = t.redMul(c);
            m = i;
        }
        return r;
    };
    Red.prototype.invm = function invm(a) {
        var inv = a._invmp(this.m);
        if (inv.negative !== 0) {
            inv.negative = 0;
            return this.imod(inv).redNeg();
        } else return this.imod(inv);
    };
    Red.prototype.pow = function pow(a, num) {
        if (num.isZero()) return new BN(1);
        if (num.cmpn(1) === 0) return a.clone();
        var windowSize = 4;
        var wnd = new Array(1 << windowSize);
        wnd[0] = new BN(1).toRed(this);
        wnd[1] = a;
        for(var i = 2; i < wnd.length; i++)wnd[i] = this.mul(wnd[i - 1], a);
        var res = wnd[0];
        var current = 0;
        var currentLen = 0;
        var start = num.bitLength() % 26;
        if (start === 0) start = 26;
        for(i = num.length - 1; i >= 0; i--){
            var word = num.words[i];
            for(var j = start - 1; j >= 0; j--){
                var bit = word >> j & 1;
                if (res !== wnd[0]) res = this.sqr(res);
                if (bit === 0 && current === 0) {
                    currentLen = 0;
                    continue;
                }
                current <<= 1;
                current |= bit;
                currentLen++;
                if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
                res = this.mul(res, wnd[current]);
                currentLen = 0;
                current = 0;
            }
            start = 26;
        }
        return res;
    };
    Red.prototype.convertTo = function convertTo(num) {
        var r = num.umod(this.m);
        return r === num ? r.clone() : r;
    };
    Red.prototype.convertFrom = function convertFrom(num) {
        var res = num.clone();
        res.red = null;
        return res;
    };
    //
    // Montgomery method engine
    //
    BN.mont = function mont(num) {
        return new Mont(num);
    };
    function Mont(m) {
        Red.call(this, m);
        this.shift = this.m.bitLength();
        if (this.shift % 26 !== 0) this.shift += 26 - this.shift % 26;
        this.r = new BN(1).iushln(this.shift);
        this.r2 = this.imod(this.r.sqr());
        this.rinv = this.r._invmp(this.m);
        this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
        this.minv = this.minv.umod(this.r);
        this.minv = this.r.sub(this.minv);
    }
    inherits(Mont, Red);
    Mont.prototype.convertTo = function convertTo(num) {
        return this.imod(num.ushln(this.shift));
    };
    Mont.prototype.convertFrom = function convertFrom(num) {
        var r = this.imod(num.mul(this.rinv));
        r.red = null;
        return r;
    };
    Mont.prototype.imul = function imul(a, b) {
        if (a.isZero() || b.isZero()) {
            a.words[0] = 0;
            a.length = 1;
            return a;
        }
        var t = a.imul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.mul = function mul(a, b) {
        if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
        var t = a.mul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.invm = function invm(a) {
        // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
        var res = this.imod(a._invmp(this.m).mul(this.r2));
        return res._forceRed(this);
    };
})(module, this);

},{"7c59a1f8cc803dfc":"l5Twm"}],"8BYNv":[function(require,module,exports) {
var isHexPrefixed = require("d580a9700cbc2ebb");
/**
 * Removes '0x' from a given `String` is present
 * @param {String} str the string value
 * @return {String|Optional} a string by pass if necessary
 */ module.exports = function stripHexPrefix(str) {
    if (typeof str !== "string") return str;
    return isHexPrefixed(str) ? str.slice(2) : str;
};

},{"d580a9700cbc2ebb":"c2tRb"}],"c2tRb":[function(require,module,exports) {
/**
 * Returns a `Boolean` on whether or not the a `String` starts with '0x'
 * @param {String} str the string input value
 * @return {Boolean} a boolean if it is or is not hex prefixed
 * @throws if the str input is not a string
 */ module.exports = function isHexPrefixed(str) {
    if (typeof str !== "string") throw new Error("[is-hex-prefixed] value must be type 'string', is currently type " + typeof str + ", while checking isHexPrefixed.");
    return str.slice(0, 2) === "0x";
};

},{}],"lgE8d":[function(require,module,exports) {
/*
 This file is part of web3.js.

 web3.js is free software: you can redistribute it and/or modify
 it under the terms of the GNU Lesser General Public License as published by
 the Free Software Foundation, either version 3 of the License, or
 (at your option) any later version.

 web3.js is distributed in the hope that it will be useful,
 but WITHOUT ANY WARRANTY; without even the implied warranty of
 MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 GNU Lesser General Public License for more details.

 You should have received a copy of the GNU Lesser General Public License
 along with web3.js.  If not, see <http://www.gnu.org/licenses/>.
 */ /**
 * @file utils.js
 * @author Fabian Vogelsteller <fabian@ethereum.org>
 * @date 2017
 */ var Buffer = require("1d864edf4a3783f").Buffer;
var BN = require("a2887daf399c8c7");
var numberToBN = require("ae5bd781fdadbf1");
var utf8 = require("8a188cca72857951");
var ethereumjsUtil = require("29f91a1d2ba60006");
var ethereumBloomFilters = require("2fbc76d8eab8a545");
var { keccak256 } = require("aa3defb41b5bd3f5");
/**
 * Returns true if object is BN, otherwise false
 *
 * @method isBN
 * @param {Object} object
 * @return {Boolean}
 */ var isBN = function(object) {
    return BN.isBN(object);
};
/**
 * Returns true if object is BigNumber, otherwise false
 *
 * @method isBigNumber
 * @param {Object} object
 * @return {Boolean}
 */ var isBigNumber = function(object) {
    return object && object.constructor && object.constructor.name === "BigNumber";
};
/**
 * Takes an input and transforms it into an BN
 *
 * @method toBN
 * @param {Number|String|BN} number, string, HEX string or BN
 * @return {BN} BN
 */ var toBN = function(number) {
    try {
        return numberToBN.apply(null, arguments);
    } catch (e) {
        throw new Error(e + ' Given value: "' + number + '"');
    }
};
/**
 * Takes and input transforms it into BN and if it is negative value, into two's complement
 *
 * @method toTwosComplement
 * @param {Number|String|BN} number
 * @return {String}
 */ var toTwosComplement = function(number) {
    return "0x" + toBN(number).toTwos(256).toString(16, 64);
};
/**
 * Checks if the given string is an address
 *
 * @method isAddress
 * @param {String} address the given HEX address
 * @return {Boolean}
 */ var isAddress = function(address) {
    // check if it has the basic requirements of an address
    if (!/^(0x)?[0-9a-f]{40}$/i.test(address)) return false;
    else if (/^(0x|0X)?[0-9a-f]{40}$/.test(address) || /^(0x|0X)?[0-9A-F]{40}$/.test(address)) return true;
    else return checkAddressChecksum(address);
};
/**
 * Checks if the given string is a checksummed address
 *
 * @method checkAddressChecksum
 * @param {String} address the given HEX address
 * @return {Boolean}
 */ var checkAddressChecksum = function(address) {
    // Check each case
    address = address.replace(/^0x/i, "");
    var addressHash = sha3(address.toLowerCase()).replace(/^0x/i, "");
    for(var i = 0; i < 40; i++){
        // the nth letter should be uppercase if the nth digit of casemap is 1
        if (parseInt(addressHash[i], 16) > 7 && address[i].toUpperCase() !== address[i] || parseInt(addressHash[i], 16) <= 7 && address[i].toLowerCase() !== address[i]) return false;
    }
    return true;
};
/**
 * Should be called to pad string to expected length
 *
 * @method leftPad
 * @param {String} string to be padded
 * @param {Number} chars that result string should have
 * @param {String} sign, by default 0
 * @returns {String} right aligned string
 */ var leftPad = function(string, chars, sign) {
    var hasPrefix = /^0x/i.test(string) || typeof string === "number";
    string = string.toString(16).replace(/^0x/i, "");
    var padding = chars - string.length + 1 >= 0 ? chars - string.length + 1 : 0;
    return (hasPrefix ? "0x" : "") + new Array(padding).join(sign ? sign : "0") + string;
};
/**
 * Should be called to pad string to expected length
 *
 * @method rightPad
 * @param {String} string to be padded
 * @param {Number} chars that result string should have
 * @param {String} sign, by default 0
 * @returns {String} right aligned string
 */ var rightPad = function(string, chars, sign) {
    var hasPrefix = /^0x/i.test(string) || typeof string === "number";
    string = string.toString(16).replace(/^0x/i, "");
    var padding = chars - string.length + 1 >= 0 ? chars - string.length + 1 : 0;
    return (hasPrefix ? "0x" : "") + string + new Array(padding).join(sign ? sign : "0");
};
/**
 * Should be called to get hex representation (prefixed by 0x) of utf8 string
 *
 * @method utf8ToHex
 * @param {String} str
 * @returns {String} hex representation of input string
 */ var utf8ToHex = function(str) {
    str = utf8.encode(str);
    var hex = "";
    // remove \u0000 padding from either side
    str = str.replace(/^(?:\u0000)*/, "");
    str = str.split("").reverse().join("");
    str = str.replace(/^(?:\u0000)*/, "");
    str = str.split("").reverse().join("");
    for(var i = 0; i < str.length; i++){
        var code = str.charCodeAt(i);
        // if (code !== 0) {
        var n = code.toString(16);
        hex += n.length < 2 ? "0" + n : n;
    // }
    }
    return "0x" + hex;
};
/**
 * Should be called to get utf8 from it's hex representation
 *
 * @method hexToUtf8
 * @param {String} hex
 * @returns {String} ascii string representation of hex value
 */ var hexToUtf8 = function(hex) {
    if (!isHexStrict(hex)) throw new Error('The parameter "' + hex + '" must be a valid HEX string.');
    var str = "";
    var code = 0;
    hex = hex.replace(/^0x/i, "");
    // remove 00 padding from either side
    hex = hex.replace(/^(?:00)*/, "");
    hex = hex.split("").reverse().join("");
    hex = hex.replace(/^(?:00)*/, "");
    hex = hex.split("").reverse().join("");
    var l = hex.length;
    for(var i = 0; i < l; i += 2){
        code = parseInt(hex.slice(i, i + 2), 16);
        // if (code !== 0) {
        str += String.fromCharCode(code);
    // }
    }
    return utf8.decode(str);
};
/**
 * Converts value to it's number representation.
 * However, if the value is larger than the maximum safe integer, returns the value as a string.
 *
 * @method hexToNumber
 * @param {String|Number|BN} value
 * @param {Boolean} bigIntOnOverflow - if true, return the hex value in case of overflow
 * @return {Number|String}
 */ var hexToNumber = function(value, bigIntOnOverflow = false) {
    if (!value) return value;
    if (typeof value === "string" && !isHexStrict(value)) throw new Error('Given value "' + value + '" is not a valid hex string.');
    const n = toBN(value);
    if (bigIntOnOverflow && (n > Number.MAX_SAFE_INTEGER || n < Number.MIN_SAFE_INTEGER)) return BigInt(n);
    return n.toNumber();
};
/**
 * Converts value to it's decimal representation in string
 *
 * @method hexToNumberString
 * @param {String|Number|BN} value
 * @return {String}
 */ var hexToNumberString = function(value) {
    if (!value) return value;
    if (typeof value === "string" && !isHexStrict(value)) throw new Error('Given value "' + value + '" is not a valid hex string.');
    return toBN(value).toString(10);
};
/**
 * Converts value to it's hex representation
 *
 * @method numberToHex
 * @param {String|Number|BN} value
 * @return {String}
 */ var numberToHex = function(value) {
    if (value === null || value === undefined) return value;
    if (!isFinite(value) && !isHexStrict(value)) throw new Error('Given input "' + value + '" is not a number.');
    var number = toBN(value);
    var result = number.toString(16);
    return number.lt(new BN(0)) ? "-0x" + result.slice(1) : "0x" + result;
};
/**
 * Convert a byte array to a hex string
 *
 * Note: Implementation from crypto-js
 *
 * @method bytesToHex
 * @param {Array} bytes
 * @return {String} the hex string
 */ var bytesToHex = function(bytes) {
    for(var hex = [], i = 0; i < bytes.length; i++){
        /* jshint ignore:start */ hex.push((bytes[i] >>> 4).toString(16));
        hex.push((bytes[i] & 0xF).toString(16));
    /* jshint ignore:end */ }
    return "0x" + hex.join("");
};
/**
 * Convert a hex string to a byte array
 *
 * Note: Implementation from crypto-js
 *
 * @method hexToBytes
 * @param {string} hex
 * @return {Array} the byte array
 */ var hexToBytes = function(hex) {
    hex = hex.toString(16);
    if (!isHexStrict(hex)) throw new Error('Given value "' + hex + '" is not a valid hex string.');
    hex = hex.replace(/^0x/i, "");
    for(var bytes = [], c = 0; c < hex.length; c += 2)bytes.push(parseInt(hex.slice(c, c + 2), 16));
    return bytes;
};
/**
 * Auto converts any given value into it's hex representation.
 *
 * And even stringifys objects before.
 *
 * @method toHex
 * @param {String|Number|BN|Object|Buffer} value
 * @param {Boolean} returnType
 * @return {String}
 */ var toHex = function(value, returnType) {
    /*jshint maxcomplexity: false */ if (isAddress(value)) return returnType ? "address" : "0x" + value.toLowerCase().replace(/^0x/i, "");
    if (typeof value === "boolean") return returnType ? "bool" : value ? "0x01" : "0x00";
    if (Buffer.isBuffer(value)) return "0x" + value.toString("hex");
    if (typeof value === "object" && !!value && !isBigNumber(value) && !isBN(value)) return returnType ? "string" : utf8ToHex(JSON.stringify(value));
    // if its a negative number, pass it through numberToHex
    if (typeof value === "string") {
        if (value.indexOf("-0x") === 0 || value.indexOf("-0X") === 0) return returnType ? "int256" : numberToHex(value);
        else if (value.indexOf("0x") === 0 || value.indexOf("0X") === 0) return returnType ? "bytes" : value;
        else if (!isFinite(value)) return returnType ? "string" : utf8ToHex(value);
    }
    return returnType ? value < 0 ? "int256" : "uint256" : numberToHex(value);
};
/**
 * Check if string is HEX, requires a 0x in front
 *
 * @method isHexStrict
 * @param {String} hex to be checked
 * @returns {Boolean}
 */ var isHexStrict = function(hex) {
    return (typeof hex === "string" || typeof hex === "number") && /^(-)?0x[0-9a-f]*$/i.test(hex);
};
/**
 * Check if string is HEX
 *
 * @method isHex
 * @param {String} hex to be checked
 * @returns {Boolean}
 */ var isHex = function(hex) {
    return (typeof hex === "string" || typeof hex === "number") && /^(-0x|0x)?[0-9a-f]*$/i.test(hex);
};
/**
 * Remove 0x prefix from string
 *
 * @method stripHexPrefix
 * @param {String} str to be checked
 * @returns {String}
 */ var stripHexPrefix = function(str) {
    if (str !== 0 && isHex(str)) return str.replace(/^(-)?0x/i, "$1");
    return str;
};
/**
 * Returns true if given string is a valid Ethereum block header bloom.
 *
 * @method isBloom
 * @param {String} bloom encoded bloom filter
 * @return {Boolean}
 */ var isBloom = function(bloom) {
    return ethereumBloomFilters.isBloom(bloom);
};
/**
 * Returns true if the ethereum users address is part of the given bloom
 * note: false positives are possible.
 *
 * @method isUserEthereumAddressInBloom
 * @param {String} ethereumAddress encoded bloom filter
 * @param {String} bloom ethereum addresss
 * @return {Boolean}
 */ var isUserEthereumAddressInBloom = function(bloom, ethereumAddress) {
    return ethereumBloomFilters.isUserEthereumAddressInBloom(bloom, ethereumAddress);
};
/**
 * Returns true if the contract address is part of the given bloom
 * note: false positives are possible.
 *
 * @method isUserEthereumAddressInBloom
 * @param {String} bloom encoded bloom filter
 * @param {String} contractAddress contract addresss
 * @return {Boolean}
 */ var isContractAddressInBloom = function(bloom, contractAddress) {
    return ethereumBloomFilters.isContractAddressInBloom(bloom, contractAddress);
};
/**
 * Returns true if given string is a valid log topic.
 *
 * @method isTopic
 * @param {String} topic encoded topic
 * @return {Boolean}
 */ var isTopic = function(topic) {
    return ethereumBloomFilters.isTopic(topic);
};
/**
 * Returns true if the topic is part of the given bloom
 * note: false positives are possible.
 *
 * @method isTopicInBloom
 * @param {String} bloom encoded bloom filter
 * @param {String} topic encoded topic
 * @return {Boolean}
 */ var isTopicInBloom = function(bloom, topic) {
    return ethereumBloomFilters.isTopicInBloom(bloom, topic);
};
/**
 * Returns true if the value is part of the given bloom
 * note: false positives are possible.
 *
 * @method isInBloom
 * @param {String} bloom encoded bloom filter
 * @param {String | Uint8Array} topic encoded value
 * @return {Boolean}
 */ var isInBloom = function(bloom, topic) {
    return ethereumBloomFilters.isInBloom(bloom, topic);
};
/**
 * Hashes values to a sha3 hash using keccak 256
 *
 * To hash a HEX string the hex must have 0x in front.
 *
 * @method sha3
 * @return {String} the sha3 string
 */ var SHA3_NULL_S = "0xc5d2460186f7233c927e7db2dcc703c0e500b653ca82273b7bfad8045d85a470";
var sha3 = function(value) {
    if (isBN(value)) value = value.toString();
    if (isHexStrict(value) && /^0x/i.test(value.toString())) value = ethereumjsUtil.toBuffer(value);
    else if (typeof value === "string") // Assume value is an arbitrary string
    value = Buffer.from(value, "utf-8");
    var returnValue = ethereumjsUtil.bufferToHex(keccak256(value));
    if (returnValue === SHA3_NULL_S) return null;
    else return returnValue;
};
// expose the under the hood keccak256
sha3._Hash = keccak256;
/**
 * @method sha3Raw
 *
 * @param value
 *
 * @returns {string}
 */ var sha3Raw = function(value) {
    value = sha3(value);
    if (value === null) return SHA3_NULL_S;
    return value;
};
/**
 * Auto converts any given value into it's hex representation,
 * then converts hex to number.
 *
 * @method toNumber
 * @param {String|Number|BN} value
 * @param {Boolean} bigIntOnOverflow - if true, return the hex value in case of overflow
 * @return {Number|String}
 */ var toNumber = function(value, bigIntOnOverflow = false) {
    return typeof value === "number" ? value : hexToNumber(toHex(value), bigIntOnOverflow);
};
// 1.x currently accepts 0x... strings, bn.js after update doesn't. it would be a breaking change
var BNwrapped = function(value) {
    // check negative
    if (typeof value == "string" && value.includes("0x")) {
        const [negative, hexValue] = value.toLocaleLowerCase().startsWith("-") ? [
            "-",
            value.slice(3)
        ] : [
            "",
            value.slice(2)
        ];
        return new BN(negative + hexValue, 16);
    } else return new BN(value);
};
Object.setPrototypeOf(BNwrapped, BN);
Object.setPrototypeOf(BNwrapped.prototype, BN.prototype);
module.exports = {
    BN: BNwrapped,
    isBN: isBN,
    isBigNumber: isBigNumber,
    toBN: toBN,
    isAddress: isAddress,
    isBloom: isBloom,
    isUserEthereumAddressInBloom: isUserEthereumAddressInBloom,
    isContractAddressInBloom: isContractAddressInBloom,
    isTopic: isTopic,
    isTopicInBloom: isTopicInBloom,
    isInBloom: isInBloom,
    checkAddressChecksum: checkAddressChecksum,
    utf8ToHex: utf8ToHex,
    hexToUtf8: hexToUtf8,
    hexToNumber: hexToNumber,
    hexToNumberString: hexToNumberString,
    numberToHex: numberToHex,
    toHex: toHex,
    hexToBytes: hexToBytes,
    bytesToHex: bytesToHex,
    isHex: isHex,
    isHexStrict: isHexStrict,
    stripHexPrefix: stripHexPrefix,
    leftPad: leftPad,
    rightPad: rightPad,
    toTwosComplement: toTwosComplement,
    sha3: sha3,
    sha3Raw: sha3Raw,
    toNumber: toNumber
};

},{"1d864edf4a3783f":"l5Twm","a2887daf399c8c7":"8wHT1","ae5bd781fdadbf1":"gep00","8a188cca72857951":"dmzYn","29f91a1d2ba60006":"3JNxc","2fbc76d8eab8a545":"1VUnY","aa3defb41b5bd3f5":"hOh1t"}],"8wHT1":[function(require,module,exports) {
(function(module1, exports) {
    "use strict";
    // Utils
    function assert(val, msg) {
        if (!val) throw new Error(msg || "Assertion failed");
    }
    // Could use `inherits` module, but don't want to move from single file
    // architecture yet.
    function inherits(ctor, superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
    // BN
    function BN(number, base, endian) {
        if (BN.isBN(number)) return number;
        this.negative = 0;
        this.words = null;
        this.length = 0;
        // Reduction context
        this.red = null;
        if (number !== null) {
            if (base === "le" || base === "be") {
                endian = base;
                base = 10;
            }
            this._init(number || 0, base || 10, endian || "be");
        }
    }
    if (typeof module1 === "object") module1.exports = BN;
    else exports.BN = BN;
    BN.BN = BN;
    BN.wordSize = 26;
    var Buffer;
    try {
        if (typeof window !== "undefined" && typeof window.Buffer !== "undefined") Buffer = window.Buffer;
        else Buffer = require("d79974dcd5dc92bd").Buffer;
    } catch (e) {}
    BN.isBN = function isBN(num) {
        if (num instanceof BN) return true;
        return num !== null && typeof num === "object" && num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
    };
    BN.max = function max(left, right) {
        if (left.cmp(right) > 0) return left;
        return right;
    };
    BN.min = function min(left, right) {
        if (left.cmp(right) < 0) return left;
        return right;
    };
    BN.prototype._init = function init(number, base, endian) {
        if (typeof number === "number") return this._initNumber(number, base, endian);
        if (typeof number === "object") return this._initArray(number, base, endian);
        if (base === "hex") base = 16;
        assert(base === (base | 0) && base >= 2 && base <= 36);
        number = number.toString().replace(/\s+/g, "");
        var start = 0;
        if (number[0] === "-") {
            start++;
            this.negative = 1;
        }
        if (start < number.length) {
            if (base === 16) this._parseHex(number, start, endian);
            else {
                this._parseBase(number, base, start);
                if (endian === "le") this._initArray(this.toArray(), base, endian);
            }
        }
    };
    BN.prototype._initNumber = function _initNumber(number, base, endian) {
        if (number < 0) {
            this.negative = 1;
            number = -number;
        }
        if (number < 0x4000000) {
            this.words = [
                number & 0x3ffffff
            ];
            this.length = 1;
        } else if (number < 0x10000000000000) {
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff
            ];
            this.length = 2;
        } else {
            assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff,
                1
            ];
            this.length = 3;
        }
        if (endian !== "le") return;
        // Reverse the bytes
        this._initArray(this.toArray(), base, endian);
    };
    BN.prototype._initArray = function _initArray(number, base, endian) {
        // Perhaps a Uint8Array
        assert(typeof number.length === "number");
        if (number.length <= 0) {
            this.words = [
                0
            ];
            this.length = 1;
            return this;
        }
        this.length = Math.ceil(number.length / 3);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        var j, w;
        var off = 0;
        if (endian === "be") for(i = number.length - 1, j = 0; i >= 0; i -= 3){
            w = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        else if (endian === "le") for(i = 0, j = 0; i < number.length; i += 3){
            w = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        return this._strip();
    };
    function parseHex4Bits(string, index) {
        var c = string.charCodeAt(index);
        // '0' - '9'
        if (c >= 48 && c <= 57) return c - 48;
        else if (c >= 65 && c <= 70) return c - 55;
        else if (c >= 97 && c <= 102) return c - 87;
        else assert(false, "Invalid character in " + string);
    }
    function parseHexByte(string, lowerBound, index) {
        var r = parseHex4Bits(string, index);
        if (index - 1 >= lowerBound) r |= parseHex4Bits(string, index - 1) << 4;
        return r;
    }
    BN.prototype._parseHex = function _parseHex(number, start, endian) {
        // Create possibly bigger array to ensure that it fits the number
        this.length = Math.ceil((number.length - start) / 6);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        // 24-bits chunks
        var off = 0;
        var j = 0;
        var w;
        if (endian === "be") for(i = number.length - 1; i >= start; i -= 2){
            w = parseHexByte(number, start, i) << off;
            this.words[j] |= w & 0x3ffffff;
            if (off >= 18) {
                off -= 18;
                j += 1;
                this.words[j] |= w >>> 26;
            } else off += 8;
        }
        else {
            var parseLength = number.length - start;
            for(i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2){
                w = parseHexByte(number, start, i) << off;
                this.words[j] |= w & 0x3ffffff;
                if (off >= 18) {
                    off -= 18;
                    j += 1;
                    this.words[j] |= w >>> 26;
                } else off += 8;
            }
        }
        this._strip();
    };
    function parseBase(str, start, end, mul) {
        var r = 0;
        var b = 0;
        var len = Math.min(str.length, end);
        for(var i = start; i < len; i++){
            var c = str.charCodeAt(i) - 48;
            r *= mul;
            // 'a'
            if (c >= 49) b = c - 49 + 0xa;
            else if (c >= 17) b = c - 17 + 0xa;
            else b = c;
            assert(c >= 0 && b < mul, "Invalid character");
            r += b;
        }
        return r;
    }
    BN.prototype._parseBase = function _parseBase(number, base, start) {
        // Initialize as zero
        this.words = [
            0
        ];
        this.length = 1;
        // Find length of limb in base
        for(var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base)limbLen++;
        limbLen--;
        limbPow = limbPow / base | 0;
        var total = number.length - start;
        var mod = total % limbLen;
        var end = Math.min(total, total - mod) + start;
        var word = 0;
        for(var i = start; i < end; i += limbLen){
            word = parseBase(number, i, i + limbLen, base);
            this.imuln(limbPow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        if (mod !== 0) {
            var pow = 1;
            word = parseBase(number, i, number.length, base);
            for(i = 0; i < mod; i++)pow *= base;
            this.imuln(pow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        this._strip();
    };
    BN.prototype.copy = function copy(dest) {
        dest.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)dest.words[i] = this.words[i];
        dest.length = this.length;
        dest.negative = this.negative;
        dest.red = this.red;
    };
    function move(dest, src) {
        dest.words = src.words;
        dest.length = src.length;
        dest.negative = src.negative;
        dest.red = src.red;
    }
    BN.prototype._move = function _move(dest) {
        move(dest, this);
    };
    BN.prototype.clone = function clone() {
        var r = new BN(null);
        this.copy(r);
        return r;
    };
    BN.prototype._expand = function _expand(size) {
        while(this.length < size)this.words[this.length++] = 0;
        return this;
    };
    // Remove leading `0` from `this`
    BN.prototype._strip = function strip() {
        while(this.length > 1 && this.words[this.length - 1] === 0)this.length--;
        return this._normSign();
    };
    BN.prototype._normSign = function _normSign() {
        // -0 = 0
        if (this.length === 1 && this.words[0] === 0) this.negative = 0;
        return this;
    };
    // Check Symbol.for because not everywhere where Symbol defined
    // See https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Symbol#Browser_compatibility
    if (typeof Symbol !== "undefined" && typeof Symbol.for === "function") try {
        BN.prototype[Symbol.for("nodejs.util.inspect.custom")] = inspect;
    } catch (e) {
        BN.prototype.inspect = inspect;
    }
    else BN.prototype.inspect = inspect;
    function inspect() {
        return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
    }
    /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */ var zeros = [
        "",
        "0",
        "00",
        "000",
        "0000",
        "00000",
        "000000",
        "0000000",
        "00000000",
        "000000000",
        "0000000000",
        "00000000000",
        "000000000000",
        "0000000000000",
        "00000000000000",
        "000000000000000",
        "0000000000000000",
        "00000000000000000",
        "000000000000000000",
        "0000000000000000000",
        "00000000000000000000",
        "000000000000000000000",
        "0000000000000000000000",
        "00000000000000000000000",
        "000000000000000000000000",
        "0000000000000000000000000"
    ];
    var groupSizes = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
    ];
    var groupBases = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        10000000,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64000000,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        24300000,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
    ];
    BN.prototype.toString = function toString(base, padding) {
        base = base || 10;
        padding = padding | 0 || 1;
        var out;
        if (base === 16 || base === "hex") {
            out = "";
            var off = 0;
            var carry = 0;
            for(var i = 0; i < this.length; i++){
                var w = this.words[i];
                var word = ((w << off | carry) & 0xffffff).toString(16);
                carry = w >>> 24 - off & 0xffffff;
                off += 2;
                if (off >= 26) {
                    off -= 26;
                    i--;
                }
                if (carry !== 0 || i !== this.length - 1) out = zeros[6 - word.length] + word + out;
                else out = word + out;
            }
            if (carry !== 0) out = carry.toString(16) + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        if (base === (base | 0) && base >= 2 && base <= 36) {
            // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
            var groupSize = groupSizes[base];
            // var groupBase = Math.pow(base, groupSize);
            var groupBase = groupBases[base];
            out = "";
            var c = this.clone();
            c.negative = 0;
            while(!c.isZero()){
                var r = c.modrn(groupBase).toString(base);
                c = c.idivn(groupBase);
                if (!c.isZero()) out = zeros[groupSize - r.length] + r + out;
                else out = r + out;
            }
            if (this.isZero()) out = "0" + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        assert(false, "Base should be between 2 and 36");
    };
    BN.prototype.toNumber = function toNumber() {
        var ret = this.words[0];
        if (this.length === 2) ret += this.words[1] * 0x4000000;
        else if (this.length === 3 && this.words[2] === 0x01) // NOTE: at this stage it is known that the top bit is set
        ret += 0x10000000000000 + this.words[1] * 0x4000000;
        else if (this.length > 2) assert(false, "Number can only safely store up to 53 bits");
        return this.negative !== 0 ? -ret : ret;
    };
    BN.prototype.toJSON = function toJSON() {
        return this.toString(16, 2);
    };
    if (Buffer) BN.prototype.toBuffer = function toBuffer(endian, length) {
        return this.toArrayLike(Buffer, endian, length);
    };
    BN.prototype.toArray = function toArray(endian, length) {
        return this.toArrayLike(Array, endian, length);
    };
    var allocate = function allocate(ArrayType, size) {
        if (ArrayType.allocUnsafe) return ArrayType.allocUnsafe(size);
        return new ArrayType(size);
    };
    BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
        this._strip();
        var byteLength = this.byteLength();
        var reqLength = length || Math.max(1, byteLength);
        assert(byteLength <= reqLength, "byte array longer than desired length");
        assert(reqLength > 0, "Requested array length <= 0");
        var res = allocate(ArrayType, reqLength);
        var postfix = endian === "le" ? "LE" : "BE";
        this["_toArrayLike" + postfix](res, byteLength);
        return res;
    };
    BN.prototype._toArrayLikeLE = function _toArrayLikeLE(res, byteLength) {
        var position = 0;
        var carry = 0;
        for(var i = 0, shift = 0; i < this.length; i++){
            var word = this.words[i] << shift | carry;
            res[position++] = word & 0xff;
            if (position < res.length) res[position++] = word >> 8 & 0xff;
            if (position < res.length) res[position++] = word >> 16 & 0xff;
            if (shift === 6) {
                if (position < res.length) res[position++] = word >> 24 & 0xff;
                carry = 0;
                shift = 0;
            } else {
                carry = word >>> 24;
                shift += 2;
            }
        }
        if (position < res.length) {
            res[position++] = carry;
            while(position < res.length)res[position++] = 0;
        }
    };
    BN.prototype._toArrayLikeBE = function _toArrayLikeBE(res, byteLength) {
        var position = res.length - 1;
        var carry = 0;
        for(var i = 0, shift = 0; i < this.length; i++){
            var word = this.words[i] << shift | carry;
            res[position--] = word & 0xff;
            if (position >= 0) res[position--] = word >> 8 & 0xff;
            if (position >= 0) res[position--] = word >> 16 & 0xff;
            if (shift === 6) {
                if (position >= 0) res[position--] = word >> 24 & 0xff;
                carry = 0;
                shift = 0;
            } else {
                carry = word >>> 24;
                shift += 2;
            }
        }
        if (position >= 0) {
            res[position--] = carry;
            while(position >= 0)res[position--] = 0;
        }
    };
    if (Math.clz32) BN.prototype._countBits = function _countBits(w) {
        return 32 - Math.clz32(w);
    };
    else BN.prototype._countBits = function _countBits(w) {
        var t = w;
        var r = 0;
        if (t >= 0x1000) {
            r += 13;
            t >>>= 13;
        }
        if (t >= 0x40) {
            r += 7;
            t >>>= 7;
        }
        if (t >= 0x8) {
            r += 4;
            t >>>= 4;
        }
        if (t >= 0x02) {
            r += 2;
            t >>>= 2;
        }
        return r + t;
    };
    BN.prototype._zeroBits = function _zeroBits(w) {
        // Short-cut
        if (w === 0) return 26;
        var t = w;
        var r = 0;
        if ((t & 0x1fff) === 0) {
            r += 13;
            t >>>= 13;
        }
        if ((t & 0x7f) === 0) {
            r += 7;
            t >>>= 7;
        }
        if ((t & 0xf) === 0) {
            r += 4;
            t >>>= 4;
        }
        if ((t & 0x3) === 0) {
            r += 2;
            t >>>= 2;
        }
        if ((t & 0x1) === 0) r++;
        return r;
    };
    // Return number of used bits in a BN
    BN.prototype.bitLength = function bitLength() {
        var w = this.words[this.length - 1];
        var hi = this._countBits(w);
        return (this.length - 1) * 26 + hi;
    };
    function toBitArray(num) {
        var w = new Array(num.bitLength());
        for(var bit = 0; bit < w.length; bit++){
            var off = bit / 26 | 0;
            var wbit = bit % 26;
            w[bit] = num.words[off] >>> wbit & 0x01;
        }
        return w;
    }
    // Number of trailing zero bits
    BN.prototype.zeroBits = function zeroBits() {
        if (this.isZero()) return 0;
        var r = 0;
        for(var i = 0; i < this.length; i++){
            var b = this._zeroBits(this.words[i]);
            r += b;
            if (b !== 26) break;
        }
        return r;
    };
    BN.prototype.byteLength = function byteLength() {
        return Math.ceil(this.bitLength() / 8);
    };
    BN.prototype.toTwos = function toTwos(width) {
        if (this.negative !== 0) return this.abs().inotn(width).iaddn(1);
        return this.clone();
    };
    BN.prototype.fromTwos = function fromTwos(width) {
        if (this.testn(width - 1)) return this.notn(width).iaddn(1).ineg();
        return this.clone();
    };
    BN.prototype.isNeg = function isNeg() {
        return this.negative !== 0;
    };
    // Return negative clone of `this`
    BN.prototype.neg = function neg() {
        return this.clone().ineg();
    };
    BN.prototype.ineg = function ineg() {
        if (!this.isZero()) this.negative ^= 1;
        return this;
    };
    // Or `num` with `this` in-place
    BN.prototype.iuor = function iuor(num) {
        while(this.length < num.length)this.words[this.length++] = 0;
        for(var i = 0; i < num.length; i++)this.words[i] = this.words[i] | num.words[i];
        return this._strip();
    };
    BN.prototype.ior = function ior(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuor(num);
    };
    // Or `num` with `this`
    BN.prototype.or = function or(num) {
        if (this.length > num.length) return this.clone().ior(num);
        return num.clone().ior(this);
    };
    BN.prototype.uor = function uor(num) {
        if (this.length > num.length) return this.clone().iuor(num);
        return num.clone().iuor(this);
    };
    // And `num` with `this` in-place
    BN.prototype.iuand = function iuand(num) {
        // b = min-length(num, this)
        var b;
        if (this.length > num.length) b = num;
        else b = this;
        for(var i = 0; i < b.length; i++)this.words[i] = this.words[i] & num.words[i];
        this.length = b.length;
        return this._strip();
    };
    BN.prototype.iand = function iand(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuand(num);
    };
    // And `num` with `this`
    BN.prototype.and = function and(num) {
        if (this.length > num.length) return this.clone().iand(num);
        return num.clone().iand(this);
    };
    BN.prototype.uand = function uand(num) {
        if (this.length > num.length) return this.clone().iuand(num);
        return num.clone().iuand(this);
    };
    // Xor `num` with `this` in-place
    BN.prototype.iuxor = function iuxor(num) {
        // a.length > b.length
        var a;
        var b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        for(var i = 0; i < b.length; i++)this.words[i] = a.words[i] ^ b.words[i];
        if (this !== a) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = a.length;
        return this._strip();
    };
    BN.prototype.ixor = function ixor(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuxor(num);
    };
    // Xor `num` with `this`
    BN.prototype.xor = function xor(num) {
        if (this.length > num.length) return this.clone().ixor(num);
        return num.clone().ixor(this);
    };
    BN.prototype.uxor = function uxor(num) {
        if (this.length > num.length) return this.clone().iuxor(num);
        return num.clone().iuxor(this);
    };
    // Not ``this`` with ``width`` bitwidth
    BN.prototype.inotn = function inotn(width) {
        assert(typeof width === "number" && width >= 0);
        var bytesNeeded = Math.ceil(width / 26) | 0;
        var bitsLeft = width % 26;
        // Extend the buffer with leading zeroes
        this._expand(bytesNeeded);
        if (bitsLeft > 0) bytesNeeded--;
        // Handle complete words
        for(var i = 0; i < bytesNeeded; i++)this.words[i] = ~this.words[i] & 0x3ffffff;
        // Handle the residue
        if (bitsLeft > 0) this.words[i] = ~this.words[i] & 0x3ffffff >> 26 - bitsLeft;
        // And remove leading zeroes
        return this._strip();
    };
    BN.prototype.notn = function notn(width) {
        return this.clone().inotn(width);
    };
    // Set `bit` of `this`
    BN.prototype.setn = function setn(bit, val) {
        assert(typeof bit === "number" && bit >= 0);
        var off = bit / 26 | 0;
        var wbit = bit % 26;
        this._expand(off + 1);
        if (val) this.words[off] = this.words[off] | 1 << wbit;
        else this.words[off] = this.words[off] & ~(1 << wbit);
        return this._strip();
    };
    // Add `num` to `this` in-place
    BN.prototype.iadd = function iadd(num) {
        var r;
        // negative + positive
        if (this.negative !== 0 && num.negative === 0) {
            this.negative = 0;
            r = this.isub(num);
            this.negative ^= 1;
            return this._normSign();
        // positive + negative
        } else if (this.negative === 0 && num.negative !== 0) {
            num.negative = 0;
            r = this.isub(num);
            num.negative = 1;
            return r._normSign();
        }
        // a.length > b.length
        var a, b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        this.length = a.length;
        if (carry !== 0) {
            this.words[this.length] = carry;
            this.length++;
        // Copy the rest of the words
        } else if (a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        return this;
    };
    // Add `num` to `this`
    BN.prototype.add = function add(num) {
        var res;
        if (num.negative !== 0 && this.negative === 0) {
            num.negative = 0;
            res = this.sub(num);
            num.negative ^= 1;
            return res;
        } else if (num.negative === 0 && this.negative !== 0) {
            this.negative = 0;
            res = num.sub(this);
            this.negative = 1;
            return res;
        }
        if (this.length > num.length) return this.clone().iadd(num);
        return num.clone().iadd(this);
    };
    // Subtract `num` from `this` in-place
    BN.prototype.isub = function isub(num) {
        // this - (-num) = this + num
        if (num.negative !== 0) {
            num.negative = 0;
            var r = this.iadd(num);
            num.negative = 1;
            return r._normSign();
        // -this - num = -(this + num)
        } else if (this.negative !== 0) {
            this.negative = 0;
            this.iadd(num);
            this.negative = 1;
            return this._normSign();
        }
        // At this point both numbers are positive
        var cmp = this.cmp(num);
        // Optimization - zeroify
        if (cmp === 0) {
            this.negative = 0;
            this.length = 1;
            this.words[0] = 0;
            return this;
        }
        // a > b
        var a, b;
        if (cmp > 0) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        // Copy rest of the words
        if (carry === 0 && i < a.length && a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = Math.max(this.length, i);
        if (a !== this) this.negative = 1;
        return this._strip();
    };
    // Subtract `num` from `this`
    BN.prototype.sub = function sub(num) {
        return this.clone().isub(num);
    };
    function smallMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        var len = self.length + num.length | 0;
        out.length = len;
        len = len - 1 | 0;
        // Peel one iteration (compiler can't do it, because of code complexity)
        var a = self.words[0] | 0;
        var b = num.words[0] | 0;
        var r = a * b;
        var lo = r & 0x3ffffff;
        var carry = r / 0x4000000 | 0;
        out.words[0] = lo;
        for(var k = 1; k < len; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = carry >>> 26;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j | 0;
                a = self.words[i] | 0;
                b = num.words[j] | 0;
                r = a * b + rword;
                ncarry += r / 0x4000000 | 0;
                rword = r & 0x3ffffff;
            }
            out.words[k] = rword | 0;
            carry = ncarry | 0;
        }
        if (carry !== 0) out.words[k] = carry | 0;
        else out.length--;
        return out._strip();
    }
    // TODO(indutny): it may be reasonable to omit it for users who don't need
    // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
    // multiplication (like elliptic secp256k1).
    var comb10MulTo = function comb10MulTo(self, num, out) {
        var a = self.words;
        var b = num.words;
        var o = out.words;
        var c = 0;
        var lo;
        var mid;
        var hi;
        var a0 = a[0] | 0;
        var al0 = a0 & 0x1fff;
        var ah0 = a0 >>> 13;
        var a1 = a[1] | 0;
        var al1 = a1 & 0x1fff;
        var ah1 = a1 >>> 13;
        var a2 = a[2] | 0;
        var al2 = a2 & 0x1fff;
        var ah2 = a2 >>> 13;
        var a3 = a[3] | 0;
        var al3 = a3 & 0x1fff;
        var ah3 = a3 >>> 13;
        var a4 = a[4] | 0;
        var al4 = a4 & 0x1fff;
        var ah4 = a4 >>> 13;
        var a5 = a[5] | 0;
        var al5 = a5 & 0x1fff;
        var ah5 = a5 >>> 13;
        var a6 = a[6] | 0;
        var al6 = a6 & 0x1fff;
        var ah6 = a6 >>> 13;
        var a7 = a[7] | 0;
        var al7 = a7 & 0x1fff;
        var ah7 = a7 >>> 13;
        var a8 = a[8] | 0;
        var al8 = a8 & 0x1fff;
        var ah8 = a8 >>> 13;
        var a9 = a[9] | 0;
        var al9 = a9 & 0x1fff;
        var ah9 = a9 >>> 13;
        var b0 = b[0] | 0;
        var bl0 = b0 & 0x1fff;
        var bh0 = b0 >>> 13;
        var b1 = b[1] | 0;
        var bl1 = b1 & 0x1fff;
        var bh1 = b1 >>> 13;
        var b2 = b[2] | 0;
        var bl2 = b2 & 0x1fff;
        var bh2 = b2 >>> 13;
        var b3 = b[3] | 0;
        var bl3 = b3 & 0x1fff;
        var bh3 = b3 >>> 13;
        var b4 = b[4] | 0;
        var bl4 = b4 & 0x1fff;
        var bh4 = b4 >>> 13;
        var b5 = b[5] | 0;
        var bl5 = b5 & 0x1fff;
        var bh5 = b5 >>> 13;
        var b6 = b[6] | 0;
        var bl6 = b6 & 0x1fff;
        var bh6 = b6 >>> 13;
        var b7 = b[7] | 0;
        var bl7 = b7 & 0x1fff;
        var bh7 = b7 >>> 13;
        var b8 = b[8] | 0;
        var bl8 = b8 & 0x1fff;
        var bh8 = b8 >>> 13;
        var b9 = b[9] | 0;
        var bl9 = b9 & 0x1fff;
        var bh9 = b9 >>> 13;
        out.negative = self.negative ^ num.negative;
        out.length = 19;
        /* k = 0 */ lo = Math.imul(al0, bl0);
        mid = Math.imul(al0, bh0);
        mid = mid + Math.imul(ah0, bl0) | 0;
        hi = Math.imul(ah0, bh0);
        var w0 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
        w0 &= 0x3ffffff;
        /* k = 1 */ lo = Math.imul(al1, bl0);
        mid = Math.imul(al1, bh0);
        mid = mid + Math.imul(ah1, bl0) | 0;
        hi = Math.imul(ah1, bh0);
        lo = lo + Math.imul(al0, bl1) | 0;
        mid = mid + Math.imul(al0, bh1) | 0;
        mid = mid + Math.imul(ah0, bl1) | 0;
        hi = hi + Math.imul(ah0, bh1) | 0;
        var w1 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
        w1 &= 0x3ffffff;
        /* k = 2 */ lo = Math.imul(al2, bl0);
        mid = Math.imul(al2, bh0);
        mid = mid + Math.imul(ah2, bl0) | 0;
        hi = Math.imul(ah2, bh0);
        lo = lo + Math.imul(al1, bl1) | 0;
        mid = mid + Math.imul(al1, bh1) | 0;
        mid = mid + Math.imul(ah1, bl1) | 0;
        hi = hi + Math.imul(ah1, bh1) | 0;
        lo = lo + Math.imul(al0, bl2) | 0;
        mid = mid + Math.imul(al0, bh2) | 0;
        mid = mid + Math.imul(ah0, bl2) | 0;
        hi = hi + Math.imul(ah0, bh2) | 0;
        var w2 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
        w2 &= 0x3ffffff;
        /* k = 3 */ lo = Math.imul(al3, bl0);
        mid = Math.imul(al3, bh0);
        mid = mid + Math.imul(ah3, bl0) | 0;
        hi = Math.imul(ah3, bh0);
        lo = lo + Math.imul(al2, bl1) | 0;
        mid = mid + Math.imul(al2, bh1) | 0;
        mid = mid + Math.imul(ah2, bl1) | 0;
        hi = hi + Math.imul(ah2, bh1) | 0;
        lo = lo + Math.imul(al1, bl2) | 0;
        mid = mid + Math.imul(al1, bh2) | 0;
        mid = mid + Math.imul(ah1, bl2) | 0;
        hi = hi + Math.imul(ah1, bh2) | 0;
        lo = lo + Math.imul(al0, bl3) | 0;
        mid = mid + Math.imul(al0, bh3) | 0;
        mid = mid + Math.imul(ah0, bl3) | 0;
        hi = hi + Math.imul(ah0, bh3) | 0;
        var w3 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
        w3 &= 0x3ffffff;
        /* k = 4 */ lo = Math.imul(al4, bl0);
        mid = Math.imul(al4, bh0);
        mid = mid + Math.imul(ah4, bl0) | 0;
        hi = Math.imul(ah4, bh0);
        lo = lo + Math.imul(al3, bl1) | 0;
        mid = mid + Math.imul(al3, bh1) | 0;
        mid = mid + Math.imul(ah3, bl1) | 0;
        hi = hi + Math.imul(ah3, bh1) | 0;
        lo = lo + Math.imul(al2, bl2) | 0;
        mid = mid + Math.imul(al2, bh2) | 0;
        mid = mid + Math.imul(ah2, bl2) | 0;
        hi = hi + Math.imul(ah2, bh2) | 0;
        lo = lo + Math.imul(al1, bl3) | 0;
        mid = mid + Math.imul(al1, bh3) | 0;
        mid = mid + Math.imul(ah1, bl3) | 0;
        hi = hi + Math.imul(ah1, bh3) | 0;
        lo = lo + Math.imul(al0, bl4) | 0;
        mid = mid + Math.imul(al0, bh4) | 0;
        mid = mid + Math.imul(ah0, bl4) | 0;
        hi = hi + Math.imul(ah0, bh4) | 0;
        var w4 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
        w4 &= 0x3ffffff;
        /* k = 5 */ lo = Math.imul(al5, bl0);
        mid = Math.imul(al5, bh0);
        mid = mid + Math.imul(ah5, bl0) | 0;
        hi = Math.imul(ah5, bh0);
        lo = lo + Math.imul(al4, bl1) | 0;
        mid = mid + Math.imul(al4, bh1) | 0;
        mid = mid + Math.imul(ah4, bl1) | 0;
        hi = hi + Math.imul(ah4, bh1) | 0;
        lo = lo + Math.imul(al3, bl2) | 0;
        mid = mid + Math.imul(al3, bh2) | 0;
        mid = mid + Math.imul(ah3, bl2) | 0;
        hi = hi + Math.imul(ah3, bh2) | 0;
        lo = lo + Math.imul(al2, bl3) | 0;
        mid = mid + Math.imul(al2, bh3) | 0;
        mid = mid + Math.imul(ah2, bl3) | 0;
        hi = hi + Math.imul(ah2, bh3) | 0;
        lo = lo + Math.imul(al1, bl4) | 0;
        mid = mid + Math.imul(al1, bh4) | 0;
        mid = mid + Math.imul(ah1, bl4) | 0;
        hi = hi + Math.imul(ah1, bh4) | 0;
        lo = lo + Math.imul(al0, bl5) | 0;
        mid = mid + Math.imul(al0, bh5) | 0;
        mid = mid + Math.imul(ah0, bl5) | 0;
        hi = hi + Math.imul(ah0, bh5) | 0;
        var w5 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
        w5 &= 0x3ffffff;
        /* k = 6 */ lo = Math.imul(al6, bl0);
        mid = Math.imul(al6, bh0);
        mid = mid + Math.imul(ah6, bl0) | 0;
        hi = Math.imul(ah6, bh0);
        lo = lo + Math.imul(al5, bl1) | 0;
        mid = mid + Math.imul(al5, bh1) | 0;
        mid = mid + Math.imul(ah5, bl1) | 0;
        hi = hi + Math.imul(ah5, bh1) | 0;
        lo = lo + Math.imul(al4, bl2) | 0;
        mid = mid + Math.imul(al4, bh2) | 0;
        mid = mid + Math.imul(ah4, bl2) | 0;
        hi = hi + Math.imul(ah4, bh2) | 0;
        lo = lo + Math.imul(al3, bl3) | 0;
        mid = mid + Math.imul(al3, bh3) | 0;
        mid = mid + Math.imul(ah3, bl3) | 0;
        hi = hi + Math.imul(ah3, bh3) | 0;
        lo = lo + Math.imul(al2, bl4) | 0;
        mid = mid + Math.imul(al2, bh4) | 0;
        mid = mid + Math.imul(ah2, bl4) | 0;
        hi = hi + Math.imul(ah2, bh4) | 0;
        lo = lo + Math.imul(al1, bl5) | 0;
        mid = mid + Math.imul(al1, bh5) | 0;
        mid = mid + Math.imul(ah1, bl5) | 0;
        hi = hi + Math.imul(ah1, bh5) | 0;
        lo = lo + Math.imul(al0, bl6) | 0;
        mid = mid + Math.imul(al0, bh6) | 0;
        mid = mid + Math.imul(ah0, bl6) | 0;
        hi = hi + Math.imul(ah0, bh6) | 0;
        var w6 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
        w6 &= 0x3ffffff;
        /* k = 7 */ lo = Math.imul(al7, bl0);
        mid = Math.imul(al7, bh0);
        mid = mid + Math.imul(ah7, bl0) | 0;
        hi = Math.imul(ah7, bh0);
        lo = lo + Math.imul(al6, bl1) | 0;
        mid = mid + Math.imul(al6, bh1) | 0;
        mid = mid + Math.imul(ah6, bl1) | 0;
        hi = hi + Math.imul(ah6, bh1) | 0;
        lo = lo + Math.imul(al5, bl2) | 0;
        mid = mid + Math.imul(al5, bh2) | 0;
        mid = mid + Math.imul(ah5, bl2) | 0;
        hi = hi + Math.imul(ah5, bh2) | 0;
        lo = lo + Math.imul(al4, bl3) | 0;
        mid = mid + Math.imul(al4, bh3) | 0;
        mid = mid + Math.imul(ah4, bl3) | 0;
        hi = hi + Math.imul(ah4, bh3) | 0;
        lo = lo + Math.imul(al3, bl4) | 0;
        mid = mid + Math.imul(al3, bh4) | 0;
        mid = mid + Math.imul(ah3, bl4) | 0;
        hi = hi + Math.imul(ah3, bh4) | 0;
        lo = lo + Math.imul(al2, bl5) | 0;
        mid = mid + Math.imul(al2, bh5) | 0;
        mid = mid + Math.imul(ah2, bl5) | 0;
        hi = hi + Math.imul(ah2, bh5) | 0;
        lo = lo + Math.imul(al1, bl6) | 0;
        mid = mid + Math.imul(al1, bh6) | 0;
        mid = mid + Math.imul(ah1, bl6) | 0;
        hi = hi + Math.imul(ah1, bh6) | 0;
        lo = lo + Math.imul(al0, bl7) | 0;
        mid = mid + Math.imul(al0, bh7) | 0;
        mid = mid + Math.imul(ah0, bl7) | 0;
        hi = hi + Math.imul(ah0, bh7) | 0;
        var w7 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
        w7 &= 0x3ffffff;
        /* k = 8 */ lo = Math.imul(al8, bl0);
        mid = Math.imul(al8, bh0);
        mid = mid + Math.imul(ah8, bl0) | 0;
        hi = Math.imul(ah8, bh0);
        lo = lo + Math.imul(al7, bl1) | 0;
        mid = mid + Math.imul(al7, bh1) | 0;
        mid = mid + Math.imul(ah7, bl1) | 0;
        hi = hi + Math.imul(ah7, bh1) | 0;
        lo = lo + Math.imul(al6, bl2) | 0;
        mid = mid + Math.imul(al6, bh2) | 0;
        mid = mid + Math.imul(ah6, bl2) | 0;
        hi = hi + Math.imul(ah6, bh2) | 0;
        lo = lo + Math.imul(al5, bl3) | 0;
        mid = mid + Math.imul(al5, bh3) | 0;
        mid = mid + Math.imul(ah5, bl3) | 0;
        hi = hi + Math.imul(ah5, bh3) | 0;
        lo = lo + Math.imul(al4, bl4) | 0;
        mid = mid + Math.imul(al4, bh4) | 0;
        mid = mid + Math.imul(ah4, bl4) | 0;
        hi = hi + Math.imul(ah4, bh4) | 0;
        lo = lo + Math.imul(al3, bl5) | 0;
        mid = mid + Math.imul(al3, bh5) | 0;
        mid = mid + Math.imul(ah3, bl5) | 0;
        hi = hi + Math.imul(ah3, bh5) | 0;
        lo = lo + Math.imul(al2, bl6) | 0;
        mid = mid + Math.imul(al2, bh6) | 0;
        mid = mid + Math.imul(ah2, bl6) | 0;
        hi = hi + Math.imul(ah2, bh6) | 0;
        lo = lo + Math.imul(al1, bl7) | 0;
        mid = mid + Math.imul(al1, bh7) | 0;
        mid = mid + Math.imul(ah1, bl7) | 0;
        hi = hi + Math.imul(ah1, bh7) | 0;
        lo = lo + Math.imul(al0, bl8) | 0;
        mid = mid + Math.imul(al0, bh8) | 0;
        mid = mid + Math.imul(ah0, bl8) | 0;
        hi = hi + Math.imul(ah0, bh8) | 0;
        var w8 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
        w8 &= 0x3ffffff;
        /* k = 9 */ lo = Math.imul(al9, bl0);
        mid = Math.imul(al9, bh0);
        mid = mid + Math.imul(ah9, bl0) | 0;
        hi = Math.imul(ah9, bh0);
        lo = lo + Math.imul(al8, bl1) | 0;
        mid = mid + Math.imul(al8, bh1) | 0;
        mid = mid + Math.imul(ah8, bl1) | 0;
        hi = hi + Math.imul(ah8, bh1) | 0;
        lo = lo + Math.imul(al7, bl2) | 0;
        mid = mid + Math.imul(al7, bh2) | 0;
        mid = mid + Math.imul(ah7, bl2) | 0;
        hi = hi + Math.imul(ah7, bh2) | 0;
        lo = lo + Math.imul(al6, bl3) | 0;
        mid = mid + Math.imul(al6, bh3) | 0;
        mid = mid + Math.imul(ah6, bl3) | 0;
        hi = hi + Math.imul(ah6, bh3) | 0;
        lo = lo + Math.imul(al5, bl4) | 0;
        mid = mid + Math.imul(al5, bh4) | 0;
        mid = mid + Math.imul(ah5, bl4) | 0;
        hi = hi + Math.imul(ah5, bh4) | 0;
        lo = lo + Math.imul(al4, bl5) | 0;
        mid = mid + Math.imul(al4, bh5) | 0;
        mid = mid + Math.imul(ah4, bl5) | 0;
        hi = hi + Math.imul(ah4, bh5) | 0;
        lo = lo + Math.imul(al3, bl6) | 0;
        mid = mid + Math.imul(al3, bh6) | 0;
        mid = mid + Math.imul(ah3, bl6) | 0;
        hi = hi + Math.imul(ah3, bh6) | 0;
        lo = lo + Math.imul(al2, bl7) | 0;
        mid = mid + Math.imul(al2, bh7) | 0;
        mid = mid + Math.imul(ah2, bl7) | 0;
        hi = hi + Math.imul(ah2, bh7) | 0;
        lo = lo + Math.imul(al1, bl8) | 0;
        mid = mid + Math.imul(al1, bh8) | 0;
        mid = mid + Math.imul(ah1, bl8) | 0;
        hi = hi + Math.imul(ah1, bh8) | 0;
        lo = lo + Math.imul(al0, bl9) | 0;
        mid = mid + Math.imul(al0, bh9) | 0;
        mid = mid + Math.imul(ah0, bl9) | 0;
        hi = hi + Math.imul(ah0, bh9) | 0;
        var w9 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
        w9 &= 0x3ffffff;
        /* k = 10 */ lo = Math.imul(al9, bl1);
        mid = Math.imul(al9, bh1);
        mid = mid + Math.imul(ah9, bl1) | 0;
        hi = Math.imul(ah9, bh1);
        lo = lo + Math.imul(al8, bl2) | 0;
        mid = mid + Math.imul(al8, bh2) | 0;
        mid = mid + Math.imul(ah8, bl2) | 0;
        hi = hi + Math.imul(ah8, bh2) | 0;
        lo = lo + Math.imul(al7, bl3) | 0;
        mid = mid + Math.imul(al7, bh3) | 0;
        mid = mid + Math.imul(ah7, bl3) | 0;
        hi = hi + Math.imul(ah7, bh3) | 0;
        lo = lo + Math.imul(al6, bl4) | 0;
        mid = mid + Math.imul(al6, bh4) | 0;
        mid = mid + Math.imul(ah6, bl4) | 0;
        hi = hi + Math.imul(ah6, bh4) | 0;
        lo = lo + Math.imul(al5, bl5) | 0;
        mid = mid + Math.imul(al5, bh5) | 0;
        mid = mid + Math.imul(ah5, bl5) | 0;
        hi = hi + Math.imul(ah5, bh5) | 0;
        lo = lo + Math.imul(al4, bl6) | 0;
        mid = mid + Math.imul(al4, bh6) | 0;
        mid = mid + Math.imul(ah4, bl6) | 0;
        hi = hi + Math.imul(ah4, bh6) | 0;
        lo = lo + Math.imul(al3, bl7) | 0;
        mid = mid + Math.imul(al3, bh7) | 0;
        mid = mid + Math.imul(ah3, bl7) | 0;
        hi = hi + Math.imul(ah3, bh7) | 0;
        lo = lo + Math.imul(al2, bl8) | 0;
        mid = mid + Math.imul(al2, bh8) | 0;
        mid = mid + Math.imul(ah2, bl8) | 0;
        hi = hi + Math.imul(ah2, bh8) | 0;
        lo = lo + Math.imul(al1, bl9) | 0;
        mid = mid + Math.imul(al1, bh9) | 0;
        mid = mid + Math.imul(ah1, bl9) | 0;
        hi = hi + Math.imul(ah1, bh9) | 0;
        var w10 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
        w10 &= 0x3ffffff;
        /* k = 11 */ lo = Math.imul(al9, bl2);
        mid = Math.imul(al9, bh2);
        mid = mid + Math.imul(ah9, bl2) | 0;
        hi = Math.imul(ah9, bh2);
        lo = lo + Math.imul(al8, bl3) | 0;
        mid = mid + Math.imul(al8, bh3) | 0;
        mid = mid + Math.imul(ah8, bl3) | 0;
        hi = hi + Math.imul(ah8, bh3) | 0;
        lo = lo + Math.imul(al7, bl4) | 0;
        mid = mid + Math.imul(al7, bh4) | 0;
        mid = mid + Math.imul(ah7, bl4) | 0;
        hi = hi + Math.imul(ah7, bh4) | 0;
        lo = lo + Math.imul(al6, bl5) | 0;
        mid = mid + Math.imul(al6, bh5) | 0;
        mid = mid + Math.imul(ah6, bl5) | 0;
        hi = hi + Math.imul(ah6, bh5) | 0;
        lo = lo + Math.imul(al5, bl6) | 0;
        mid = mid + Math.imul(al5, bh6) | 0;
        mid = mid + Math.imul(ah5, bl6) | 0;
        hi = hi + Math.imul(ah5, bh6) | 0;
        lo = lo + Math.imul(al4, bl7) | 0;
        mid = mid + Math.imul(al4, bh7) | 0;
        mid = mid + Math.imul(ah4, bl7) | 0;
        hi = hi + Math.imul(ah4, bh7) | 0;
        lo = lo + Math.imul(al3, bl8) | 0;
        mid = mid + Math.imul(al3, bh8) | 0;
        mid = mid + Math.imul(ah3, bl8) | 0;
        hi = hi + Math.imul(ah3, bh8) | 0;
        lo = lo + Math.imul(al2, bl9) | 0;
        mid = mid + Math.imul(al2, bh9) | 0;
        mid = mid + Math.imul(ah2, bl9) | 0;
        hi = hi + Math.imul(ah2, bh9) | 0;
        var w11 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
        w11 &= 0x3ffffff;
        /* k = 12 */ lo = Math.imul(al9, bl3);
        mid = Math.imul(al9, bh3);
        mid = mid + Math.imul(ah9, bl3) | 0;
        hi = Math.imul(ah9, bh3);
        lo = lo + Math.imul(al8, bl4) | 0;
        mid = mid + Math.imul(al8, bh4) | 0;
        mid = mid + Math.imul(ah8, bl4) | 0;
        hi = hi + Math.imul(ah8, bh4) | 0;
        lo = lo + Math.imul(al7, bl5) | 0;
        mid = mid + Math.imul(al7, bh5) | 0;
        mid = mid + Math.imul(ah7, bl5) | 0;
        hi = hi + Math.imul(ah7, bh5) | 0;
        lo = lo + Math.imul(al6, bl6) | 0;
        mid = mid + Math.imul(al6, bh6) | 0;
        mid = mid + Math.imul(ah6, bl6) | 0;
        hi = hi + Math.imul(ah6, bh6) | 0;
        lo = lo + Math.imul(al5, bl7) | 0;
        mid = mid + Math.imul(al5, bh7) | 0;
        mid = mid + Math.imul(ah5, bl7) | 0;
        hi = hi + Math.imul(ah5, bh7) | 0;
        lo = lo + Math.imul(al4, bl8) | 0;
        mid = mid + Math.imul(al4, bh8) | 0;
        mid = mid + Math.imul(ah4, bl8) | 0;
        hi = hi + Math.imul(ah4, bh8) | 0;
        lo = lo + Math.imul(al3, bl9) | 0;
        mid = mid + Math.imul(al3, bh9) | 0;
        mid = mid + Math.imul(ah3, bl9) | 0;
        hi = hi + Math.imul(ah3, bh9) | 0;
        var w12 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
        w12 &= 0x3ffffff;
        /* k = 13 */ lo = Math.imul(al9, bl4);
        mid = Math.imul(al9, bh4);
        mid = mid + Math.imul(ah9, bl4) | 0;
        hi = Math.imul(ah9, bh4);
        lo = lo + Math.imul(al8, bl5) | 0;
        mid = mid + Math.imul(al8, bh5) | 0;
        mid = mid + Math.imul(ah8, bl5) | 0;
        hi = hi + Math.imul(ah8, bh5) | 0;
        lo = lo + Math.imul(al7, bl6) | 0;
        mid = mid + Math.imul(al7, bh6) | 0;
        mid = mid + Math.imul(ah7, bl6) | 0;
        hi = hi + Math.imul(ah7, bh6) | 0;
        lo = lo + Math.imul(al6, bl7) | 0;
        mid = mid + Math.imul(al6, bh7) | 0;
        mid = mid + Math.imul(ah6, bl7) | 0;
        hi = hi + Math.imul(ah6, bh7) | 0;
        lo = lo + Math.imul(al5, bl8) | 0;
        mid = mid + Math.imul(al5, bh8) | 0;
        mid = mid + Math.imul(ah5, bl8) | 0;
        hi = hi + Math.imul(ah5, bh8) | 0;
        lo = lo + Math.imul(al4, bl9) | 0;
        mid = mid + Math.imul(al4, bh9) | 0;
        mid = mid + Math.imul(ah4, bl9) | 0;
        hi = hi + Math.imul(ah4, bh9) | 0;
        var w13 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
        w13 &= 0x3ffffff;
        /* k = 14 */ lo = Math.imul(al9, bl5);
        mid = Math.imul(al9, bh5);
        mid = mid + Math.imul(ah9, bl5) | 0;
        hi = Math.imul(ah9, bh5);
        lo = lo + Math.imul(al8, bl6) | 0;
        mid = mid + Math.imul(al8, bh6) | 0;
        mid = mid + Math.imul(ah8, bl6) | 0;
        hi = hi + Math.imul(ah8, bh6) | 0;
        lo = lo + Math.imul(al7, bl7) | 0;
        mid = mid + Math.imul(al7, bh7) | 0;
        mid = mid + Math.imul(ah7, bl7) | 0;
        hi = hi + Math.imul(ah7, bh7) | 0;
        lo = lo + Math.imul(al6, bl8) | 0;
        mid = mid + Math.imul(al6, bh8) | 0;
        mid = mid + Math.imul(ah6, bl8) | 0;
        hi = hi + Math.imul(ah6, bh8) | 0;
        lo = lo + Math.imul(al5, bl9) | 0;
        mid = mid + Math.imul(al5, bh9) | 0;
        mid = mid + Math.imul(ah5, bl9) | 0;
        hi = hi + Math.imul(ah5, bh9) | 0;
        var w14 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
        w14 &= 0x3ffffff;
        /* k = 15 */ lo = Math.imul(al9, bl6);
        mid = Math.imul(al9, bh6);
        mid = mid + Math.imul(ah9, bl6) | 0;
        hi = Math.imul(ah9, bh6);
        lo = lo + Math.imul(al8, bl7) | 0;
        mid = mid + Math.imul(al8, bh7) | 0;
        mid = mid + Math.imul(ah8, bl7) | 0;
        hi = hi + Math.imul(ah8, bh7) | 0;
        lo = lo + Math.imul(al7, bl8) | 0;
        mid = mid + Math.imul(al7, bh8) | 0;
        mid = mid + Math.imul(ah7, bl8) | 0;
        hi = hi + Math.imul(ah7, bh8) | 0;
        lo = lo + Math.imul(al6, bl9) | 0;
        mid = mid + Math.imul(al6, bh9) | 0;
        mid = mid + Math.imul(ah6, bl9) | 0;
        hi = hi + Math.imul(ah6, bh9) | 0;
        var w15 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
        w15 &= 0x3ffffff;
        /* k = 16 */ lo = Math.imul(al9, bl7);
        mid = Math.imul(al9, bh7);
        mid = mid + Math.imul(ah9, bl7) | 0;
        hi = Math.imul(ah9, bh7);
        lo = lo + Math.imul(al8, bl8) | 0;
        mid = mid + Math.imul(al8, bh8) | 0;
        mid = mid + Math.imul(ah8, bl8) | 0;
        hi = hi + Math.imul(ah8, bh8) | 0;
        lo = lo + Math.imul(al7, bl9) | 0;
        mid = mid + Math.imul(al7, bh9) | 0;
        mid = mid + Math.imul(ah7, bl9) | 0;
        hi = hi + Math.imul(ah7, bh9) | 0;
        var w16 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
        w16 &= 0x3ffffff;
        /* k = 17 */ lo = Math.imul(al9, bl8);
        mid = Math.imul(al9, bh8);
        mid = mid + Math.imul(ah9, bl8) | 0;
        hi = Math.imul(ah9, bh8);
        lo = lo + Math.imul(al8, bl9) | 0;
        mid = mid + Math.imul(al8, bh9) | 0;
        mid = mid + Math.imul(ah8, bl9) | 0;
        hi = hi + Math.imul(ah8, bh9) | 0;
        var w17 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
        w17 &= 0x3ffffff;
        /* k = 18 */ lo = Math.imul(al9, bl9);
        mid = Math.imul(al9, bh9);
        mid = mid + Math.imul(ah9, bl9) | 0;
        hi = Math.imul(ah9, bh9);
        var w18 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
        w18 &= 0x3ffffff;
        o[0] = w0;
        o[1] = w1;
        o[2] = w2;
        o[3] = w3;
        o[4] = w4;
        o[5] = w5;
        o[6] = w6;
        o[7] = w7;
        o[8] = w8;
        o[9] = w9;
        o[10] = w10;
        o[11] = w11;
        o[12] = w12;
        o[13] = w13;
        o[14] = w14;
        o[15] = w15;
        o[16] = w16;
        o[17] = w17;
        o[18] = w18;
        if (c !== 0) {
            o[19] = c;
            out.length++;
        }
        return out;
    };
    // Polyfill comb
    if (!Math.imul) comb10MulTo = smallMulTo;
    function bigMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        out.length = self.length + num.length;
        var carry = 0;
        var hncarry = 0;
        for(var k = 0; k < out.length - 1; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = hncarry;
            hncarry = 0;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j;
                var a = self.words[i] | 0;
                var b = num.words[j] | 0;
                var r = a * b;
                var lo = r & 0x3ffffff;
                ncarry = ncarry + (r / 0x4000000 | 0) | 0;
                lo = lo + rword | 0;
                rword = lo & 0x3ffffff;
                ncarry = ncarry + (lo >>> 26) | 0;
                hncarry += ncarry >>> 26;
                ncarry &= 0x3ffffff;
            }
            out.words[k] = rword;
            carry = ncarry;
            ncarry = hncarry;
        }
        if (carry !== 0) out.words[k] = carry;
        else out.length--;
        return out._strip();
    }
    function jumboMulTo(self, num, out) {
        // Temporary disable, see https://github.com/indutny/bn.js/issues/211
        // var fftm = new FFTM();
        // return fftm.mulp(self, num, out);
        return bigMulTo(self, num, out);
    }
    BN.prototype.mulTo = function mulTo(num, out) {
        var res;
        var len = this.length + num.length;
        if (this.length === 10 && num.length === 10) res = comb10MulTo(this, num, out);
        else if (len < 63) res = smallMulTo(this, num, out);
        else if (len < 1024) res = bigMulTo(this, num, out);
        else res = jumboMulTo(this, num, out);
        return res;
    };
    // Cooley-Tukey algorithm for FFT
    // slightly revisited to rely on looping instead of recursion
    function FFTM(x, y) {
        this.x = x;
        this.y = y;
    }
    FFTM.prototype.makeRBT = function makeRBT(N) {
        var t = new Array(N);
        var l = BN.prototype._countBits(N) - 1;
        for(var i = 0; i < N; i++)t[i] = this.revBin(i, l, N);
        return t;
    };
    // Returns binary-reversed representation of `x`
    FFTM.prototype.revBin = function revBin(x, l, N) {
        if (x === 0 || x === N - 1) return x;
        var rb = 0;
        for(var i = 0; i < l; i++){
            rb |= (x & 1) << l - i - 1;
            x >>= 1;
        }
        return rb;
    };
    // Performs "tweedling" phase, therefore 'emulating'
    // behaviour of the recursive algorithm
    FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
        for(var i = 0; i < N; i++){
            rtws[i] = rws[rbt[i]];
            itws[i] = iws[rbt[i]];
        }
    };
    FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
        this.permute(rbt, rws, iws, rtws, itws, N);
        for(var s = 1; s < N; s <<= 1){
            var l = s << 1;
            var rtwdf = Math.cos(2 * Math.PI / l);
            var itwdf = Math.sin(2 * Math.PI / l);
            for(var p = 0; p < N; p += l){
                var rtwdf_ = rtwdf;
                var itwdf_ = itwdf;
                for(var j = 0; j < s; j++){
                    var re = rtws[p + j];
                    var ie = itws[p + j];
                    var ro = rtws[p + j + s];
                    var io = itws[p + j + s];
                    var rx = rtwdf_ * ro - itwdf_ * io;
                    io = rtwdf_ * io + itwdf_ * ro;
                    ro = rx;
                    rtws[p + j] = re + ro;
                    itws[p + j] = ie + io;
                    rtws[p + j + s] = re - ro;
                    itws[p + j + s] = ie - io;
                    /* jshint maxdepth : false */ if (j !== l) {
                        rx = rtwdf * rtwdf_ - itwdf * itwdf_;
                        itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                        rtwdf_ = rx;
                    }
                }
            }
        }
    };
    FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
        var N = Math.max(m, n) | 1;
        var odd = N & 1;
        var i = 0;
        for(N = N / 2 | 0; N; N = N >>> 1)i++;
        return 1 << i + 1 + odd;
    };
    FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
        if (N <= 1) return;
        for(var i = 0; i < N / 2; i++){
            var t = rws[i];
            rws[i] = rws[N - i - 1];
            rws[N - i - 1] = t;
            t = iws[i];
            iws[i] = -iws[N - i - 1];
            iws[N - i - 1] = -t;
        }
    };
    FFTM.prototype.normalize13b = function normalize13b(ws, N) {
        var carry = 0;
        for(var i = 0; i < N / 2; i++){
            var w = Math.round(ws[2 * i + 1] / N) * 0x2000 + Math.round(ws[2 * i] / N) + carry;
            ws[i] = w & 0x3ffffff;
            if (w < 0x4000000) carry = 0;
            else carry = w / 0x4000000 | 0;
        }
        return ws;
    };
    FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
        var carry = 0;
        for(var i = 0; i < len; i++){
            carry = carry + (ws[i] | 0);
            rws[2 * i] = carry & 0x1fff;
            carry = carry >>> 13;
            rws[2 * i + 1] = carry & 0x1fff;
            carry = carry >>> 13;
        }
        // Pad with zeroes
        for(i = 2 * len; i < N; ++i)rws[i] = 0;
        assert(carry === 0);
        assert((carry & -8192) === 0);
    };
    FFTM.prototype.stub = function stub(N) {
        var ph = new Array(N);
        for(var i = 0; i < N; i++)ph[i] = 0;
        return ph;
    };
    FFTM.prototype.mulp = function mulp(x, y, out) {
        var N = 2 * this.guessLen13b(x.length, y.length);
        var rbt = this.makeRBT(N);
        var _ = this.stub(N);
        var rws = new Array(N);
        var rwst = new Array(N);
        var iwst = new Array(N);
        var nrws = new Array(N);
        var nrwst = new Array(N);
        var niwst = new Array(N);
        var rmws = out.words;
        rmws.length = N;
        this.convert13b(x.words, x.length, rws, N);
        this.convert13b(y.words, y.length, nrws, N);
        this.transform(rws, _, rwst, iwst, N, rbt);
        this.transform(nrws, _, nrwst, niwst, N, rbt);
        for(var i = 0; i < N; i++){
            var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
            iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
            rwst[i] = rx;
        }
        this.conjugate(rwst, iwst, N);
        this.transform(rwst, iwst, rmws, _, N, rbt);
        this.conjugate(rmws, _, N);
        this.normalize13b(rmws, N);
        out.negative = x.negative ^ y.negative;
        out.length = x.length + y.length;
        return out._strip();
    };
    // Multiply `this` by `num`
    BN.prototype.mul = function mul(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return this.mulTo(num, out);
    };
    // Multiply employing FFT
    BN.prototype.mulf = function mulf(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return jumboMulTo(this, num, out);
    };
    // In-place Multiplication
    BN.prototype.imul = function imul(num) {
        return this.clone().mulTo(num, this);
    };
    BN.prototype.imuln = function imuln(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(typeof num === "number");
        assert(num < 0x4000000);
        // Carry
        var carry = 0;
        for(var i = 0; i < this.length; i++){
            var w = (this.words[i] | 0) * num;
            var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
            carry >>= 26;
            carry += w / 0x4000000 | 0;
            // NOTE: lo is 27bit maximum
            carry += lo >>> 26;
            this.words[i] = lo & 0x3ffffff;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return isNegNum ? this.ineg() : this;
    };
    BN.prototype.muln = function muln(num) {
        return this.clone().imuln(num);
    };
    // `this` * `this`
    BN.prototype.sqr = function sqr() {
        return this.mul(this);
    };
    // `this` * `this` in-place
    BN.prototype.isqr = function isqr() {
        return this.imul(this.clone());
    };
    // Math.pow(`this`, `num`)
    BN.prototype.pow = function pow(num) {
        var w = toBitArray(num);
        if (w.length === 0) return new BN(1);
        // Skip leading zeroes
        var res = this;
        for(var i = 0; i < w.length; i++, res = res.sqr()){
            if (w[i] !== 0) break;
        }
        if (++i < w.length) for(var q = res.sqr(); i < w.length; i++, q = q.sqr()){
            if (w[i] === 0) continue;
            res = res.mul(q);
        }
        return res;
    };
    // Shift-left in-place
    BN.prototype.iushln = function iushln(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        var carryMask = 0x3ffffff >>> 26 - r << 26 - r;
        var i;
        if (r !== 0) {
            var carry = 0;
            for(i = 0; i < this.length; i++){
                var newCarry = this.words[i] & carryMask;
                var c = (this.words[i] | 0) - newCarry << r;
                this.words[i] = c | carry;
                carry = newCarry >>> 26 - r;
            }
            if (carry) {
                this.words[i] = carry;
                this.length++;
            }
        }
        if (s !== 0) {
            for(i = this.length - 1; i >= 0; i--)this.words[i + s] = this.words[i];
            for(i = 0; i < s; i++)this.words[i] = 0;
            this.length += s;
        }
        return this._strip();
    };
    BN.prototype.ishln = function ishln(bits) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushln(bits);
    };
    // Shift-right in-place
    // NOTE: `hint` is a lowest bit before trailing zeroes
    // NOTE: if `extended` is present - it will be filled with destroyed bits
    BN.prototype.iushrn = function iushrn(bits, hint, extended) {
        assert(typeof bits === "number" && bits >= 0);
        var h;
        if (hint) h = (hint - hint % 26) / 26;
        else h = 0;
        var r = bits % 26;
        var s = Math.min((bits - r) / 26, this.length);
        var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
        var maskedWords = extended;
        h -= s;
        h = Math.max(0, h);
        // Extended mode, copy masked part
        if (maskedWords) {
            for(var i = 0; i < s; i++)maskedWords.words[i] = this.words[i];
            maskedWords.length = s;
        }
        if (s === 0) ;
        else if (this.length > s) {
            this.length -= s;
            for(i = 0; i < this.length; i++)this.words[i] = this.words[i + s];
        } else {
            this.words[0] = 0;
            this.length = 1;
        }
        var carry = 0;
        for(i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--){
            var word = this.words[i] | 0;
            this.words[i] = carry << 26 - r | word >>> r;
            carry = word & mask;
        }
        // Push carried bits as a mask
        if (maskedWords && carry !== 0) maskedWords.words[maskedWords.length++] = carry;
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this._strip();
    };
    BN.prototype.ishrn = function ishrn(bits, hint, extended) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushrn(bits, hint, extended);
    };
    // Shift-left
    BN.prototype.shln = function shln(bits) {
        return this.clone().ishln(bits);
    };
    BN.prototype.ushln = function ushln(bits) {
        return this.clone().iushln(bits);
    };
    // Shift-right
    BN.prototype.shrn = function shrn(bits) {
        return this.clone().ishrn(bits);
    };
    BN.prototype.ushrn = function ushrn(bits) {
        return this.clone().iushrn(bits);
    };
    // Test if n bit is set
    BN.prototype.testn = function testn(bit) {
        assert(typeof bit === "number" && bit >= 0);
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) return false;
        // Check bit and return
        var w = this.words[s];
        return !!(w & q);
    };
    // Return only lowers bits of number (in-place)
    BN.prototype.imaskn = function imaskn(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        assert(this.negative === 0, "imaskn works only with positive numbers");
        if (this.length <= s) return this;
        if (r !== 0) s++;
        this.length = Math.min(s, this.length);
        if (r !== 0) {
            var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
            this.words[this.length - 1] &= mask;
        }
        return this._strip();
    };
    // Return only lowers bits of number
    BN.prototype.maskn = function maskn(bits) {
        return this.clone().imaskn(bits);
    };
    // Add plain number `num` to `this`
    BN.prototype.iaddn = function iaddn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.isubn(-num);
        // Possible sign change
        if (this.negative !== 0) {
            if (this.length === 1 && (this.words[0] | 0) <= num) {
                this.words[0] = num - (this.words[0] | 0);
                this.negative = 0;
                return this;
            }
            this.negative = 0;
            this.isubn(num);
            this.negative = 1;
            return this;
        }
        // Add without checks
        return this._iaddn(num);
    };
    BN.prototype._iaddn = function _iaddn(num) {
        this.words[0] += num;
        // Carry
        for(var i = 0; i < this.length && this.words[i] >= 0x4000000; i++){
            this.words[i] -= 0x4000000;
            if (i === this.length - 1) this.words[i + 1] = 1;
            else this.words[i + 1]++;
        }
        this.length = Math.max(this.length, i + 1);
        return this;
    };
    // Subtract plain number `num` from `this`
    BN.prototype.isubn = function isubn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.iaddn(-num);
        if (this.negative !== 0) {
            this.negative = 0;
            this.iaddn(num);
            this.negative = 1;
            return this;
        }
        this.words[0] -= num;
        if (this.length === 1 && this.words[0] < 0) {
            this.words[0] = -this.words[0];
            this.negative = 1;
        } else // Carry
        for(var i = 0; i < this.length && this.words[i] < 0; i++){
            this.words[i] += 0x4000000;
            this.words[i + 1] -= 1;
        }
        return this._strip();
    };
    BN.prototype.addn = function addn(num) {
        return this.clone().iaddn(num);
    };
    BN.prototype.subn = function subn(num) {
        return this.clone().isubn(num);
    };
    BN.prototype.iabs = function iabs() {
        this.negative = 0;
        return this;
    };
    BN.prototype.abs = function abs() {
        return this.clone().iabs();
    };
    BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
        var len = num.length + shift;
        var i;
        this._expand(len);
        var w;
        var carry = 0;
        for(i = 0; i < num.length; i++){
            w = (this.words[i + shift] | 0) + carry;
            var right = (num.words[i] | 0) * mul;
            w -= right & 0x3ffffff;
            carry = (w >> 26) - (right / 0x4000000 | 0);
            this.words[i + shift] = w & 0x3ffffff;
        }
        for(; i < this.length - shift; i++){
            w = (this.words[i + shift] | 0) + carry;
            carry = w >> 26;
            this.words[i + shift] = w & 0x3ffffff;
        }
        if (carry === 0) return this._strip();
        // Subtraction overflow
        assert(carry === -1);
        carry = 0;
        for(i = 0; i < this.length; i++){
            w = -(this.words[i] | 0) + carry;
            carry = w >> 26;
            this.words[i] = w & 0x3ffffff;
        }
        this.negative = 1;
        return this._strip();
    };
    BN.prototype._wordDiv = function _wordDiv(num, mode) {
        var shift = this.length - num.length;
        var a = this.clone();
        var b = num;
        // Normalize
        var bhi = b.words[b.length - 1] | 0;
        var bhiBits = this._countBits(bhi);
        shift = 26 - bhiBits;
        if (shift !== 0) {
            b = b.ushln(shift);
            a.iushln(shift);
            bhi = b.words[b.length - 1] | 0;
        }
        // Initialize quotient
        var m = a.length - b.length;
        var q;
        if (mode !== "mod") {
            q = new BN(null);
            q.length = m + 1;
            q.words = new Array(q.length);
            for(var i = 0; i < q.length; i++)q.words[i] = 0;
        }
        var diff = a.clone()._ishlnsubmul(b, 1, m);
        if (diff.negative === 0) {
            a = diff;
            if (q) q.words[m] = 1;
        }
        for(var j = m - 1; j >= 0; j--){
            var qj = (a.words[b.length + j] | 0) * 0x4000000 + (a.words[b.length + j - 1] | 0);
            // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
            // (0x7ffffff)
            qj = Math.min(qj / bhi | 0, 0x3ffffff);
            a._ishlnsubmul(b, qj, j);
            while(a.negative !== 0){
                qj--;
                a.negative = 0;
                a._ishlnsubmul(b, 1, j);
                if (!a.isZero()) a.negative ^= 1;
            }
            if (q) q.words[j] = qj;
        }
        if (q) q._strip();
        a._strip();
        // Denormalize
        if (mode !== "div" && shift !== 0) a.iushrn(shift);
        return {
            div: q || null,
            mod: a
        };
    };
    // NOTE: 1) `mode` can be set to `mod` to request mod only,
    //       to `div` to request div only, or be absent to
    //       request both div & mod
    //       2) `positive` is true if unsigned mod is requested
    BN.prototype.divmod = function divmod(num, mode, positive) {
        assert(!num.isZero());
        if (this.isZero()) return {
            div: new BN(0),
            mod: new BN(0)
        };
        var div, mod, res;
        if (this.negative !== 0 && num.negative === 0) {
            res = this.neg().divmod(num, mode);
            if (mode !== "mod") div = res.div.neg();
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.iadd(num);
            }
            return {
                div: div,
                mod: mod
            };
        }
        if (this.negative === 0 && num.negative !== 0) {
            res = this.divmod(num.neg(), mode);
            if (mode !== "mod") div = res.div.neg();
            return {
                div: div,
                mod: res.mod
            };
        }
        if ((this.negative & num.negative) !== 0) {
            res = this.neg().divmod(num.neg(), mode);
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.isub(num);
            }
            return {
                div: res.div,
                mod: mod
            };
        }
        // Both numbers are positive at this point
        // Strip both numbers to approximate shift value
        if (num.length > this.length || this.cmp(num) < 0) return {
            div: new BN(0),
            mod: this
        };
        // Very short reduction
        if (num.length === 1) {
            if (mode === "div") return {
                div: this.divn(num.words[0]),
                mod: null
            };
            if (mode === "mod") return {
                div: null,
                mod: new BN(this.modrn(num.words[0]))
            };
            return {
                div: this.divn(num.words[0]),
                mod: new BN(this.modrn(num.words[0]))
            };
        }
        return this._wordDiv(num, mode);
    };
    // Find `this` / `num`
    BN.prototype.div = function div(num) {
        return this.divmod(num, "div", false).div;
    };
    // Find `this` % `num`
    BN.prototype.mod = function mod(num) {
        return this.divmod(num, "mod", false).mod;
    };
    BN.prototype.umod = function umod(num) {
        return this.divmod(num, "mod", true).mod;
    };
    // Find Round(`this` / `num`)
    BN.prototype.divRound = function divRound(num) {
        var dm = this.divmod(num);
        // Fast case - exact division
        if (dm.mod.isZero()) return dm.div;
        var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;
        var half = num.ushrn(1);
        var r2 = num.andln(1);
        var cmp = mod.cmp(half);
        // Round down
        if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
        // Round up
        return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
    };
    BN.prototype.modrn = function modrn(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(num <= 0x3ffffff);
        var p = 67108864 % num;
        var acc = 0;
        for(var i = this.length - 1; i >= 0; i--)acc = (p * acc + (this.words[i] | 0)) % num;
        return isNegNum ? -acc : acc;
    };
    // WARNING: DEPRECATED
    BN.prototype.modn = function modn(num) {
        return this.modrn(num);
    };
    // In-place division by number
    BN.prototype.idivn = function idivn(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(num <= 0x3ffffff);
        var carry = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var w = (this.words[i] | 0) + carry * 0x4000000;
            this.words[i] = w / num | 0;
            carry = w % num;
        }
        this._strip();
        return isNegNum ? this.ineg() : this;
    };
    BN.prototype.divn = function divn(num) {
        return this.clone().idivn(num);
    };
    BN.prototype.egcd = function egcd(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var x = this;
        var y = p.clone();
        if (x.negative !== 0) x = x.umod(p);
        else x = x.clone();
        // A * x + B * y = x
        var A = new BN(1);
        var B = new BN(0);
        // C * x + D * y = y
        var C = new BN(0);
        var D = new BN(1);
        var g = 0;
        while(x.isEven() && y.isEven()){
            x.iushrn(1);
            y.iushrn(1);
            ++g;
        }
        var yp = y.clone();
        var xp = x.clone();
        while(!x.isZero()){
            for(var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                x.iushrn(i);
                while(i-- > 0){
                    if (A.isOdd() || B.isOdd()) {
                        A.iadd(yp);
                        B.isub(xp);
                    }
                    A.iushrn(1);
                    B.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                y.iushrn(j);
                while(j-- > 0){
                    if (C.isOdd() || D.isOdd()) {
                        C.iadd(yp);
                        D.isub(xp);
                    }
                    C.iushrn(1);
                    D.iushrn(1);
                }
            }
            if (x.cmp(y) >= 0) {
                x.isub(y);
                A.isub(C);
                B.isub(D);
            } else {
                y.isub(x);
                C.isub(A);
                D.isub(B);
            }
        }
        return {
            a: C,
            b: D,
            gcd: y.iushln(g)
        };
    };
    // This is reduced incarnation of the binary EEA
    // above, designated to invert members of the
    // _prime_ fields F(p) at a maximal speed
    BN.prototype._invmp = function _invmp(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var a = this;
        var b = p.clone();
        if (a.negative !== 0) a = a.umod(p);
        else a = a.clone();
        var x1 = new BN(1);
        var x2 = new BN(0);
        var delta = b.clone();
        while(a.cmpn(1) > 0 && b.cmpn(1) > 0){
            for(var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                a.iushrn(i);
                while(i-- > 0){
                    if (x1.isOdd()) x1.iadd(delta);
                    x1.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                b.iushrn(j);
                while(j-- > 0){
                    if (x2.isOdd()) x2.iadd(delta);
                    x2.iushrn(1);
                }
            }
            if (a.cmp(b) >= 0) {
                a.isub(b);
                x1.isub(x2);
            } else {
                b.isub(a);
                x2.isub(x1);
            }
        }
        var res;
        if (a.cmpn(1) === 0) res = x1;
        else res = x2;
        if (res.cmpn(0) < 0) res.iadd(p);
        return res;
    };
    BN.prototype.gcd = function gcd(num) {
        if (this.isZero()) return num.abs();
        if (num.isZero()) return this.abs();
        var a = this.clone();
        var b = num.clone();
        a.negative = 0;
        b.negative = 0;
        // Remove common factor of two
        for(var shift = 0; a.isEven() && b.isEven(); shift++){
            a.iushrn(1);
            b.iushrn(1);
        }
        do {
            while(a.isEven())a.iushrn(1);
            while(b.isEven())b.iushrn(1);
            var r = a.cmp(b);
            if (r < 0) {
                // Swap `a` and `b` to make `a` always bigger than `b`
                var t = a;
                a = b;
                b = t;
            } else if (r === 0 || b.cmpn(1) === 0) break;
            a.isub(b);
        }while (true);
        return b.iushln(shift);
    };
    // Invert number in the field F(num)
    BN.prototype.invm = function invm(num) {
        return this.egcd(num).a.umod(num);
    };
    BN.prototype.isEven = function isEven() {
        return (this.words[0] & 1) === 0;
    };
    BN.prototype.isOdd = function isOdd() {
        return (this.words[0] & 1) === 1;
    };
    // And first word and num
    BN.prototype.andln = function andln(num) {
        return this.words[0] & num;
    };
    // Increment at the bit position in-line
    BN.prototype.bincn = function bincn(bit) {
        assert(typeof bit === "number");
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) {
            this._expand(s + 1);
            this.words[s] |= q;
            return this;
        }
        // Add bit and propagate, if needed
        var carry = q;
        for(var i = s; carry !== 0 && i < this.length; i++){
            var w = this.words[i] | 0;
            w += carry;
            carry = w >>> 26;
            w &= 0x3ffffff;
            this.words[i] = w;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.isZero = function isZero() {
        return this.length === 1 && this.words[0] === 0;
    };
    BN.prototype.cmpn = function cmpn(num) {
        var negative = num < 0;
        if (this.negative !== 0 && !negative) return -1;
        if (this.negative === 0 && negative) return 1;
        this._strip();
        var res;
        if (this.length > 1) res = 1;
        else {
            if (negative) num = -num;
            assert(num <= 0x3ffffff, "Number is too big");
            var w = this.words[0] | 0;
            res = w === num ? 0 : w < num ? -1 : 1;
        }
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Compare two numbers and return:
    // 1 - if `this` > `num`
    // 0 - if `this` == `num`
    // -1 - if `this` < `num`
    BN.prototype.cmp = function cmp(num) {
        if (this.negative !== 0 && num.negative === 0) return -1;
        if (this.negative === 0 && num.negative !== 0) return 1;
        var res = this.ucmp(num);
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Unsigned comparison
    BN.prototype.ucmp = function ucmp(num) {
        // At this point both numbers have the same sign
        if (this.length > num.length) return 1;
        if (this.length < num.length) return -1;
        var res = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var a = this.words[i] | 0;
            var b = num.words[i] | 0;
            if (a === b) continue;
            if (a < b) res = -1;
            else if (a > b) res = 1;
            break;
        }
        return res;
    };
    BN.prototype.gtn = function gtn(num) {
        return this.cmpn(num) === 1;
    };
    BN.prototype.gt = function gt(num) {
        return this.cmp(num) === 1;
    };
    BN.prototype.gten = function gten(num) {
        return this.cmpn(num) >= 0;
    };
    BN.prototype.gte = function gte(num) {
        return this.cmp(num) >= 0;
    };
    BN.prototype.ltn = function ltn(num) {
        return this.cmpn(num) === -1;
    };
    BN.prototype.lt = function lt(num) {
        return this.cmp(num) === -1;
    };
    BN.prototype.lten = function lten(num) {
        return this.cmpn(num) <= 0;
    };
    BN.prototype.lte = function lte(num) {
        return this.cmp(num) <= 0;
    };
    BN.prototype.eqn = function eqn(num) {
        return this.cmpn(num) === 0;
    };
    BN.prototype.eq = function eq(num) {
        return this.cmp(num) === 0;
    };
    //
    // A reduce context, could be using montgomery or something better, depending
    // on the `m` itself.
    //
    BN.red = function red(num) {
        return new Red(num);
    };
    BN.prototype.toRed = function toRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        assert(this.negative === 0, "red works only with positives");
        return ctx.convertTo(this)._forceRed(ctx);
    };
    BN.prototype.fromRed = function fromRed() {
        assert(this.red, "fromRed works only with numbers in reduction context");
        return this.red.convertFrom(this);
    };
    BN.prototype._forceRed = function _forceRed(ctx) {
        this.red = ctx;
        return this;
    };
    BN.prototype.forceRed = function forceRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        return this._forceRed(ctx);
    };
    BN.prototype.redAdd = function redAdd(num) {
        assert(this.red, "redAdd works only with red numbers");
        return this.red.add(this, num);
    };
    BN.prototype.redIAdd = function redIAdd(num) {
        assert(this.red, "redIAdd works only with red numbers");
        return this.red.iadd(this, num);
    };
    BN.prototype.redSub = function redSub(num) {
        assert(this.red, "redSub works only with red numbers");
        return this.red.sub(this, num);
    };
    BN.prototype.redISub = function redISub(num) {
        assert(this.red, "redISub works only with red numbers");
        return this.red.isub(this, num);
    };
    BN.prototype.redShl = function redShl(num) {
        assert(this.red, "redShl works only with red numbers");
        return this.red.shl(this, num);
    };
    BN.prototype.redMul = function redMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.mul(this, num);
    };
    BN.prototype.redIMul = function redIMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.imul(this, num);
    };
    BN.prototype.redSqr = function redSqr() {
        assert(this.red, "redSqr works only with red numbers");
        this.red._verify1(this);
        return this.red.sqr(this);
    };
    BN.prototype.redISqr = function redISqr() {
        assert(this.red, "redISqr works only with red numbers");
        this.red._verify1(this);
        return this.red.isqr(this);
    };
    // Square root over p
    BN.prototype.redSqrt = function redSqrt() {
        assert(this.red, "redSqrt works only with red numbers");
        this.red._verify1(this);
        return this.red.sqrt(this);
    };
    BN.prototype.redInvm = function redInvm() {
        assert(this.red, "redInvm works only with red numbers");
        this.red._verify1(this);
        return this.red.invm(this);
    };
    // Return negative clone of `this` % `red modulo`
    BN.prototype.redNeg = function redNeg() {
        assert(this.red, "redNeg works only with red numbers");
        this.red._verify1(this);
        return this.red.neg(this);
    };
    BN.prototype.redPow = function redPow(num) {
        assert(this.red && !num.red, "redPow(normalNum)");
        this.red._verify1(this);
        return this.red.pow(this, num);
    };
    // Prime numbers with efficient reduction
    var primes = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
    };
    // Pseudo-Mersenne prime
    function MPrime(name, p) {
        // P = 2 ^ N - K
        this.name = name;
        this.p = new BN(p, 16);
        this.n = this.p.bitLength();
        this.k = new BN(1).iushln(this.n).isub(this.p);
        this.tmp = this._tmp();
    }
    MPrime.prototype._tmp = function _tmp() {
        var tmp = new BN(null);
        tmp.words = new Array(Math.ceil(this.n / 13));
        return tmp;
    };
    MPrime.prototype.ireduce = function ireduce(num) {
        // Assumes that `num` is less than `P^2`
        // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
        var r = num;
        var rlen;
        do {
            this.split(r, this.tmp);
            r = this.imulK(r);
            r = r.iadd(this.tmp);
            rlen = r.bitLength();
        }while (rlen > this.n);
        var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
        if (cmp === 0) {
            r.words[0] = 0;
            r.length = 1;
        } else if (cmp > 0) r.isub(this.p);
        else if (r.strip !== undefined) // r is a BN v4 instance
        r.strip();
        else // r is a BN v5 instance
        r._strip();
        return r;
    };
    MPrime.prototype.split = function split(input, out) {
        input.iushrn(this.n, 0, out);
    };
    MPrime.prototype.imulK = function imulK(num) {
        return num.imul(this.k);
    };
    function K256() {
        MPrime.call(this, "k256", "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f");
    }
    inherits(K256, MPrime);
    K256.prototype.split = function split(input, output) {
        // 256 = 9 * 26 + 22
        var mask = 0x3fffff;
        var outLen = Math.min(input.length, 9);
        for(var i = 0; i < outLen; i++)output.words[i] = input.words[i];
        output.length = outLen;
        if (input.length <= 9) {
            input.words[0] = 0;
            input.length = 1;
            return;
        }
        // Shift by 9 limbs
        var prev = input.words[9];
        output.words[output.length++] = prev & mask;
        for(i = 10; i < input.length; i++){
            var next = input.words[i] | 0;
            input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
            prev = next;
        }
        prev >>>= 22;
        input.words[i - 10] = prev;
        if (prev === 0 && input.length > 10) input.length -= 10;
        else input.length -= 9;
    };
    K256.prototype.imulK = function imulK(num) {
        // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
        num.words[num.length] = 0;
        num.words[num.length + 1] = 0;
        num.length += 2;
        // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
        var lo = 0;
        for(var i = 0; i < num.length; i++){
            var w = num.words[i] | 0;
            lo += w * 0x3d1;
            num.words[i] = lo & 0x3ffffff;
            lo = w * 0x40 + (lo / 0x4000000 | 0);
        }
        // Fast length reduction
        if (num.words[num.length - 1] === 0) {
            num.length--;
            if (num.words[num.length - 1] === 0) num.length--;
        }
        return num;
    };
    function P224() {
        MPrime.call(this, "p224", "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001");
    }
    inherits(P224, MPrime);
    function P192() {
        MPrime.call(this, "p192", "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff");
    }
    inherits(P192, MPrime);
    function P25519() {
        // 2 ^ 255 - 19
        MPrime.call(this, "25519", "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed");
    }
    inherits(P25519, MPrime);
    P25519.prototype.imulK = function imulK(num) {
        // K = 0x13
        var carry = 0;
        for(var i = 0; i < num.length; i++){
            var hi = (num.words[i] | 0) * 0x13 + carry;
            var lo = hi & 0x3ffffff;
            hi >>>= 26;
            num.words[i] = lo;
            carry = hi;
        }
        if (carry !== 0) num.words[num.length++] = carry;
        return num;
    };
    // Exported mostly for testing purposes, use plain name instead
    BN._prime = function prime(name) {
        // Cached version of prime
        if (primes[name]) return primes[name];
        var prime;
        if (name === "k256") prime = new K256();
        else if (name === "p224") prime = new P224();
        else if (name === "p192") prime = new P192();
        else if (name === "p25519") prime = new P25519();
        else throw new Error("Unknown prime " + name);
        primes[name] = prime;
        return prime;
    };
    //
    // Base reduction engine
    //
    function Red(m) {
        if (typeof m === "string") {
            var prime = BN._prime(m);
            this.m = prime.p;
            this.prime = prime;
        } else {
            assert(m.gtn(1), "modulus must be greater than 1");
            this.m = m;
            this.prime = null;
        }
    }
    Red.prototype._verify1 = function _verify1(a) {
        assert(a.negative === 0, "red works only with positives");
        assert(a.red, "red works only with red numbers");
    };
    Red.prototype._verify2 = function _verify2(a, b) {
        assert((a.negative | b.negative) === 0, "red works only with positives");
        assert(a.red && a.red === b.red, "red works only with red numbers");
    };
    Red.prototype.imod = function imod(a) {
        if (this.prime) return this.prime.ireduce(a)._forceRed(this);
        move(a, a.umod(this.m)._forceRed(this));
        return a;
    };
    Red.prototype.neg = function neg(a) {
        if (a.isZero()) return a.clone();
        return this.m.sub(a)._forceRed(this);
    };
    Red.prototype.add = function add(a, b) {
        this._verify2(a, b);
        var res = a.add(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res._forceRed(this);
    };
    Red.prototype.iadd = function iadd(a, b) {
        this._verify2(a, b);
        var res = a.iadd(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res;
    };
    Red.prototype.sub = function sub(a, b) {
        this._verify2(a, b);
        var res = a.sub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res._forceRed(this);
    };
    Red.prototype.isub = function isub(a, b) {
        this._verify2(a, b);
        var res = a.isub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res;
    };
    Red.prototype.shl = function shl(a, num) {
        this._verify1(a);
        return this.imod(a.ushln(num));
    };
    Red.prototype.imul = function imul(a, b) {
        this._verify2(a, b);
        return this.imod(a.imul(b));
    };
    Red.prototype.mul = function mul(a, b) {
        this._verify2(a, b);
        return this.imod(a.mul(b));
    };
    Red.prototype.isqr = function isqr(a) {
        return this.imul(a, a.clone());
    };
    Red.prototype.sqr = function sqr(a) {
        return this.mul(a, a);
    };
    Red.prototype.sqrt = function sqrt(a) {
        if (a.isZero()) return a.clone();
        var mod3 = this.m.andln(3);
        assert(mod3 % 2 === 1);
        // Fast case
        if (mod3 === 3) {
            var pow = this.m.add(new BN(1)).iushrn(2);
            return this.pow(a, pow);
        }
        // Tonelli-Shanks algorithm (Totally unoptimized and slow)
        //
        // Find Q and S, that Q * 2 ^ S = (P - 1)
        var q = this.m.subn(1);
        var s = 0;
        while(!q.isZero() && q.andln(1) === 0){
            s++;
            q.iushrn(1);
        }
        assert(!q.isZero());
        var one = new BN(1).toRed(this);
        var nOne = one.redNeg();
        // Find quadratic non-residue
        // NOTE: Max is such because of generalized Riemann hypothesis.
        var lpow = this.m.subn(1).iushrn(1);
        var z = this.m.bitLength();
        z = new BN(2 * z * z).toRed(this);
        while(this.pow(z, lpow).cmp(nOne) !== 0)z.redIAdd(nOne);
        var c = this.pow(z, q);
        var r = this.pow(a, q.addn(1).iushrn(1));
        var t = this.pow(a, q);
        var m = s;
        while(t.cmp(one) !== 0){
            var tmp = t;
            for(var i = 0; tmp.cmp(one) !== 0; i++)tmp = tmp.redSqr();
            assert(i < m);
            var b = this.pow(c, new BN(1).iushln(m - i - 1));
            r = r.redMul(b);
            c = b.redSqr();
            t = t.redMul(c);
            m = i;
        }
        return r;
    };
    Red.prototype.invm = function invm(a) {
        var inv = a._invmp(this.m);
        if (inv.negative !== 0) {
            inv.negative = 0;
            return this.imod(inv).redNeg();
        } else return this.imod(inv);
    };
    Red.prototype.pow = function pow(a, num) {
        if (num.isZero()) return new BN(1).toRed(this);
        if (num.cmpn(1) === 0) return a.clone();
        var windowSize = 4;
        var wnd = new Array(1 << windowSize);
        wnd[0] = new BN(1).toRed(this);
        wnd[1] = a;
        for(var i = 2; i < wnd.length; i++)wnd[i] = this.mul(wnd[i - 1], a);
        var res = wnd[0];
        var current = 0;
        var currentLen = 0;
        var start = num.bitLength() % 26;
        if (start === 0) start = 26;
        for(i = num.length - 1; i >= 0; i--){
            var word = num.words[i];
            for(var j = start - 1; j >= 0; j--){
                var bit = word >> j & 1;
                if (res !== wnd[0]) res = this.sqr(res);
                if (bit === 0 && current === 0) {
                    currentLen = 0;
                    continue;
                }
                current <<= 1;
                current |= bit;
                currentLen++;
                if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
                res = this.mul(res, wnd[current]);
                currentLen = 0;
                current = 0;
            }
            start = 26;
        }
        return res;
    };
    Red.prototype.convertTo = function convertTo(num) {
        var r = num.umod(this.m);
        return r === num ? r.clone() : r;
    };
    Red.prototype.convertFrom = function convertFrom(num) {
        var res = num.clone();
        res.red = null;
        return res;
    };
    //
    // Montgomery method engine
    //
    BN.mont = function mont(num) {
        return new Mont(num);
    };
    function Mont(m) {
        Red.call(this, m);
        this.shift = this.m.bitLength();
        if (this.shift % 26 !== 0) this.shift += 26 - this.shift % 26;
        this.r = new BN(1).iushln(this.shift);
        this.r2 = this.imod(this.r.sqr());
        this.rinv = this.r._invmp(this.m);
        this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
        this.minv = this.minv.umod(this.r);
        this.minv = this.r.sub(this.minv);
    }
    inherits(Mont, Red);
    Mont.prototype.convertTo = function convertTo(num) {
        return this.imod(num.ushln(this.shift));
    };
    Mont.prototype.convertFrom = function convertFrom(num) {
        var r = this.imod(num.mul(this.rinv));
        r.red = null;
        return r;
    };
    Mont.prototype.imul = function imul(a, b) {
        if (a.isZero() || b.isZero()) {
            a.words[0] = 0;
            a.length = 1;
            return a;
        }
        var t = a.imul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.mul = function mul(a, b) {
        if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
        var t = a.mul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.invm = function invm(a) {
        // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
        var res = this.imod(a._invmp(this.m).mul(this.r2));
        return res._forceRed(this);
    };
})(module, this);

},{"d79974dcd5dc92bd":"13Pcp"}],"13Pcp":[function(require,module,exports) {
"use strict";

},{}],"dmzYn":[function(require,module,exports) {
(function(root) {
    var stringFromCharCode = String.fromCharCode;
    // Taken from https://mths.be/punycode
    function ucs2decode(string) {
        var output = [];
        var counter = 0;
        var length = string.length;
        var value;
        var extra;
        while(counter < length){
            value = string.charCodeAt(counter++);
            if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
                // high surrogate, and there is a next character
                extra = string.charCodeAt(counter++);
                if ((extra & 0xFC00) == 0xDC00) output.push(((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
                else {
                    // unmatched surrogate; only append this code unit, in case the next
                    // code unit is the high surrogate of a surrogate pair
                    output.push(value);
                    counter--;
                }
            } else output.push(value);
        }
        return output;
    }
    // Taken from https://mths.be/punycode
    function ucs2encode(array) {
        var length = array.length;
        var index = -1;
        var value;
        var output = "";
        while(++index < length){
            value = array[index];
            if (value > 0xFFFF) {
                value -= 0x10000;
                output += stringFromCharCode(value >>> 10 & 0x3FF | 0xD800);
                value = 0xDC00 | value & 0x3FF;
            }
            output += stringFromCharCode(value);
        }
        return output;
    }
    function checkScalarValue(codePoint) {
        if (codePoint >= 0xD800 && codePoint <= 0xDFFF) throw Error("Lone surrogate U+" + codePoint.toString(16).toUpperCase() + " is not a scalar value");
    }
    /*--------------------------------------------------------------------------*/ function createByte(codePoint, shift) {
        return stringFromCharCode(codePoint >> shift & 0x3F | 0x80);
    }
    function encodeCodePoint(codePoint) {
        if ((codePoint & 0xFFFFFF80) == 0) return stringFromCharCode(codePoint);
        var symbol = "";
        if ((codePoint & 0xFFFFF800) == 0) symbol = stringFromCharCode(codePoint >> 6 & 0x1F | 0xC0);
        else if ((codePoint & 0xFFFF0000) == 0) {
            checkScalarValue(codePoint);
            symbol = stringFromCharCode(codePoint >> 12 & 0x0F | 0xE0);
            symbol += createByte(codePoint, 6);
        } else if ((codePoint & 0xFFE00000) == 0) {
            symbol = stringFromCharCode(codePoint >> 18 & 0x07 | 0xF0);
            symbol += createByte(codePoint, 12);
            symbol += createByte(codePoint, 6);
        }
        symbol += stringFromCharCode(codePoint & 0x3F | 0x80);
        return symbol;
    }
    function utf8encode(string) {
        var codePoints = ucs2decode(string);
        var length = codePoints.length;
        var index = -1;
        var codePoint;
        var byteString = "";
        while(++index < length){
            codePoint = codePoints[index];
            byteString += encodeCodePoint(codePoint);
        }
        return byteString;
    }
    /*--------------------------------------------------------------------------*/ function readContinuationByte() {
        if (byteIndex >= byteCount) throw Error("Invalid byte index");
        var continuationByte = byteArray[byteIndex] & 0xFF;
        byteIndex++;
        if ((continuationByte & 0xC0) == 0x80) return continuationByte & 0x3F;
        // If we end up here, it’s not a continuation byte
        throw Error("Invalid continuation byte");
    }
    function decodeSymbol() {
        var byte1;
        var byte2;
        var byte3;
        var byte4;
        var codePoint;
        if (byteIndex > byteCount) throw Error("Invalid byte index");
        if (byteIndex == byteCount) return false;
        // Read first byte
        byte1 = byteArray[byteIndex] & 0xFF;
        byteIndex++;
        // 1-byte sequence (no continuation bytes)
        if ((byte1 & 0x80) == 0) return byte1;
        // 2-byte sequence
        if ((byte1 & 0xE0) == 0xC0) {
            byte2 = readContinuationByte();
            codePoint = (byte1 & 0x1F) << 6 | byte2;
            if (codePoint >= 0x80) return codePoint;
            else throw Error("Invalid continuation byte");
        }
        // 3-byte sequence (may include unpaired surrogates)
        if ((byte1 & 0xF0) == 0xE0) {
            byte2 = readContinuationByte();
            byte3 = readContinuationByte();
            codePoint = (byte1 & 0x0F) << 12 | byte2 << 6 | byte3;
            if (codePoint >= 0x0800) {
                checkScalarValue(codePoint);
                return codePoint;
            } else throw Error("Invalid continuation byte");
        }
        // 4-byte sequence
        if ((byte1 & 0xF8) == 0xF0) {
            byte2 = readContinuationByte();
            byte3 = readContinuationByte();
            byte4 = readContinuationByte();
            codePoint = (byte1 & 0x07) << 0x12 | byte2 << 0x0C | byte3 << 0x06 | byte4;
            if (codePoint >= 0x010000 && codePoint <= 0x10FFFF) return codePoint;
        }
        throw Error("Invalid UTF-8 detected");
    }
    var byteArray;
    var byteCount;
    var byteIndex;
    function utf8decode(byteString) {
        byteArray = ucs2decode(byteString);
        byteCount = byteArray.length;
        byteIndex = 0;
        var codePoints = [];
        var tmp;
        while((tmp = decodeSymbol()) !== false)codePoints.push(tmp);
        return ucs2encode(codePoints);
    }
    /*--------------------------------------------------------------------------*/ root.version = "3.0.0";
    root.encode = utf8encode;
    root.decode = utf8decode;
})(exports);

},{}],"3JNxc":[function(require,module,exports) {
"use strict";
var __createBinding = this && this.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var __exportStar = this && this.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) __createBinding(exports1, m, p);
};
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.toAscii = exports.stripHexPrefix = exports.padToEven = exports.isHexString = exports.isHexPrefixed = exports.getKeys = exports.getBinarySize = exports.fromUtf8 = exports.fromAscii = exports.arrayContainsArray = void 0;
/**
 * Constants
 */ __exportStar(require("65a8833dbdd27db9"), exports);
/**
 * Units helpers
 */ __exportStar(require("a035d4efc09b930d"), exports);
/**
 * Account class and helper functions
 */ __exportStar(require("33374bbeeaa8cbfc"), exports);
/**
 * Address type
 */ __exportStar(require("ab0c1bff9812d86b"), exports);
/**
 * Withdrawal type
 */ __exportStar(require("848c7df721fd9a97"), exports);
/**
 * ECDSA signature
 */ __exportStar(require("93eb83c273b7c0fa"), exports);
/**
 * Utilities for manipulating Buffers, byte arrays, etc.
 */ __exportStar(require("ce01eef2b4bc97eb"), exports);
/**
 * Helpful TypeScript types
 */ __exportStar(require("845302895f69e32c"), exports);
/**
 * Helper function for working with compact encoding
 */ __exportStar(require("c71fb6312cc14c04"), exports);
/**
 * Export ethjs-util methods
 */ __exportStar(require("80589c946797921d"), exports);
var internal_1 = require("be66e499afc8585e");
Object.defineProperty(exports, "arrayContainsArray", {
    enumerable: true,
    get: function() {
        return internal_1.arrayContainsArray;
    }
});
Object.defineProperty(exports, "fromAscii", {
    enumerable: true,
    get: function() {
        return internal_1.fromAscii;
    }
});
Object.defineProperty(exports, "fromUtf8", {
    enumerable: true,
    get: function() {
        return internal_1.fromUtf8;
    }
});
Object.defineProperty(exports, "getBinarySize", {
    enumerable: true,
    get: function() {
        return internal_1.getBinarySize;
    }
});
Object.defineProperty(exports, "getKeys", {
    enumerable: true,
    get: function() {
        return internal_1.getKeys;
    }
});
Object.defineProperty(exports, "isHexPrefixed", {
    enumerable: true,
    get: function() {
        return internal_1.isHexPrefixed;
    }
});
Object.defineProperty(exports, "isHexString", {
    enumerable: true,
    get: function() {
        return internal_1.isHexString;
    }
});
Object.defineProperty(exports, "padToEven", {
    enumerable: true,
    get: function() {
        return internal_1.padToEven;
    }
});
Object.defineProperty(exports, "stripHexPrefix", {
    enumerable: true,
    get: function() {
        return internal_1.stripHexPrefix;
    }
});
Object.defineProperty(exports, "toAscii", {
    enumerable: true,
    get: function() {
        return internal_1.toAscii;
    }
});
__exportStar(require("64c9cbf46c74d00c"), exports);
__exportStar(require("8c1cd91c58efb25b"), exports);

},{"65a8833dbdd27db9":"6h8b5","a035d4efc09b930d":"dc499","33374bbeeaa8cbfc":"9gMXk","ab0c1bff9812d86b":"gl5Qp","848c7df721fd9a97":"2TPtq","93eb83c273b7c0fa":"coUSP","ce01eef2b4bc97eb":"8sUeR","845302895f69e32c":"1fvPO","c71fb6312cc14c04":"eFPjw","80589c946797921d":"5wXE6","be66e499afc8585e":"lVKB6","64c9cbf46c74d00c":"49zHC","8c1cd91c58efb25b":"6LX36"}],"6h8b5":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.MAX_WITHDRAWALS_PER_PAYLOAD = exports.RLP_EMPTY_STRING = exports.KECCAK256_RLP = exports.KECCAK256_RLP_S = exports.KECCAK256_RLP_ARRAY = exports.KECCAK256_RLP_ARRAY_S = exports.KECCAK256_NULL = exports.KECCAK256_NULL_S = exports.TWO_POW256 = exports.SECP256K1_ORDER_DIV_2 = exports.SECP256K1_ORDER = exports.MAX_INTEGER_BIGINT = exports.MAX_INTEGER = exports.MAX_UINT64 = void 0;
const buffer_1 = require("9801962e1b2be4a1");
const secp256k1_1 = require("9af1ba76a36ae7d0");
/**
 * 2^64-1
 */ exports.MAX_UINT64 = BigInt("0xffffffffffffffff");
/**
 * The max integer that the evm can handle (2^256-1)
 */ exports.MAX_INTEGER = BigInt("0xffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff");
/**
 * The max integer that the evm can handle (2^256-1) as a bigint
 * 2^256-1 equals to 340282366920938463463374607431768211455
 * We use literal value instead of calculated value for compatibility issue.
 */ exports.MAX_INTEGER_BIGINT = BigInt("115792089237316195423570985008687907853269984665640564039457584007913129639935");
exports.SECP256K1_ORDER = secp256k1_1.secp256k1.CURVE.n;
exports.SECP256K1_ORDER_DIV_2 = secp256k1_1.secp256k1.CURVE.n / BigInt(2);
/**
 * 2^256
 */ exports.TWO_POW256 = BigInt("0x10000000000000000000000000000000000000000000000000000000000000000");
/**
 * Keccak-256 hash of null
 */ exports.KECCAK256_NULL_S = "c5d2460186f7233c927e7db2dcc703c0e500b653ca82273b7bfad8045d85a470";
/**
 * Keccak-256 hash of null
 */ exports.KECCAK256_NULL = buffer_1.Buffer.from(exports.KECCAK256_NULL_S, "hex");
/**
 * Keccak-256 of an RLP of an empty array
 */ exports.KECCAK256_RLP_ARRAY_S = "1dcc4de8dec75d7aab85b567b6ccd41ad312451b948a7413f0a142fd40d49347";
/**
 * Keccak-256 of an RLP of an empty array
 */ exports.KECCAK256_RLP_ARRAY = buffer_1.Buffer.from(exports.KECCAK256_RLP_ARRAY_S, "hex");
/**
 * Keccak-256 hash of the RLP of null
 */ exports.KECCAK256_RLP_S = "56e81f171bcc55a6ff8345e692c0f86e5b48e01b996cadc001622fb5e363b421";
/**
 * Keccak-256 hash of the RLP of null
 */ exports.KECCAK256_RLP = buffer_1.Buffer.from(exports.KECCAK256_RLP_S, "hex");
/**
 *  RLP encoded empty string
 */ exports.RLP_EMPTY_STRING = buffer_1.Buffer.from([
    0x80
]);
exports.MAX_WITHDRAWALS_PER_PAYLOAD = 16;

},{"9801962e1b2be4a1":"l5Twm","9af1ba76a36ae7d0":"dV4a1"}],"dV4a1":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.secp256k1 = void 0;
var secp256k1_1 = require("298622ef1e667ecc");
Object.defineProperty(exports, "secp256k1", {
    enumerable: true,
    get: function() {
        return secp256k1_1.secp256k1;
    }
});

},{"298622ef1e667ecc":"1QeZ1"}],"1QeZ1":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.encodeToCurve = exports.hashToCurve = exports.schnorr = exports.secp256k1 = void 0;
/*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */ const sha256_1 = require("a89c1505decc763e");
const utils_1 = require("362802f5a451efcb");
const _shortw_utils_js_1 = require("8a5ef77428763709");
const hash_to_curve_js_1 = require("992867e7d1ef8b");
const modular_js_1 = require("6a274edd04635854");
const utils_js_1 = require("49209a65a14a4a44");
const weierstrass_js_1 = require("4687d8e71912c9bd");
const secp256k1P = BigInt("0xfffffffffffffffffffffffffffffffffffffffffffffffffffffffefffffc2f");
const secp256k1N = BigInt("0xfffffffffffffffffffffffffffffffebaaedce6af48a03bbfd25e8cd0364141");
const _1n = BigInt(1);
const _2n = BigInt(2);
const divNearest = (a, b)=>(a + b / _2n) / b;
/**
 * √n = n^((p+1)/4) for fields p = 3 mod 4. We unwrap the loop and multiply bit-by-bit.
 * (P+1n/4n).toString(2) would produce bits [223x 1, 0, 22x 1, 4x 0, 11, 00]
 */ function sqrtMod(y) {
    const P = secp256k1P;
    // prettier-ignore
    const _3n = BigInt(3), _6n = BigInt(6), _11n = BigInt(11), _22n = BigInt(22);
    // prettier-ignore
    const _23n = BigInt(23), _44n = BigInt(44), _88n = BigInt(88);
    const b2 = y * y * y % P; // x^3, 11
    const b3 = b2 * b2 * y % P; // x^7
    const b6 = (0, modular_js_1.pow2)(b3, _3n, P) * b3 % P;
    const b9 = (0, modular_js_1.pow2)(b6, _3n, P) * b3 % P;
    const b11 = (0, modular_js_1.pow2)(b9, _2n, P) * b2 % P;
    const b22 = (0, modular_js_1.pow2)(b11, _11n, P) * b11 % P;
    const b44 = (0, modular_js_1.pow2)(b22, _22n, P) * b22 % P;
    const b88 = (0, modular_js_1.pow2)(b44, _44n, P) * b44 % P;
    const b176 = (0, modular_js_1.pow2)(b88, _88n, P) * b88 % P;
    const b220 = (0, modular_js_1.pow2)(b176, _44n, P) * b44 % P;
    const b223 = (0, modular_js_1.pow2)(b220, _3n, P) * b3 % P;
    const t1 = (0, modular_js_1.pow2)(b223, _23n, P) * b22 % P;
    const t2 = (0, modular_js_1.pow2)(t1, _6n, P) * b2 % P;
    const root = (0, modular_js_1.pow2)(t2, _2n, P);
    if (!Fp.eql(Fp.sqr(root), y)) throw new Error("Cannot find square root");
    return root;
}
const Fp = (0, modular_js_1.Field)(secp256k1P, undefined, undefined, {
    sqrt: sqrtMod
});
exports.secp256k1 = (0, _shortw_utils_js_1.createCurve)({
    a: BigInt(0),
    b: BigInt(7),
    Fp,
    n: secp256k1N,
    // Base point (x, y) aka generator point
    Gx: BigInt("55066263022277343669578718895168534326250603453777594175500187360389116729240"),
    Gy: BigInt("32670510020758816978083085130507043184471273380659243275938904335757337482424"),
    h: BigInt(1),
    lowS: true,
    /**
     * secp256k1 belongs to Koblitz curves: it has efficiently computable endomorphism.
     * Endomorphism uses 2x less RAM, speeds up precomputation by 2x and ECDH / key recovery by 20%.
     * For precomputed wNAF it trades off 1/2 init time & 1/3 ram for 20% perf hit.
     * Explanation: https://gist.github.com/paulmillr/eb670806793e84df628a7c434a873066
     */ endo: {
        beta: BigInt("0x7ae96a2b657c07106e64479eac3434e99cf0497512f58995c1396c28719501ee"),
        splitScalar: (k)=>{
            const n = secp256k1N;
            const a1 = BigInt("0x3086d221a7d46bcde86c90e49284eb15");
            const b1 = -_1n * BigInt("0xe4437ed6010e88286f547fa90abfe4c3");
            const a2 = BigInt("0x114ca50f7a8e2f3f657c1108d9d44cfd8");
            const b2 = a1;
            const POW_2_128 = BigInt("0x100000000000000000000000000000000"); // (2n**128n).toString(16)
            const c1 = divNearest(b2 * k, n);
            const c2 = divNearest(-b1 * k, n);
            let k1 = (0, modular_js_1.mod)(k - c1 * a1 - c2 * a2, n);
            let k2 = (0, modular_js_1.mod)(-c1 * b1 - c2 * b2, n);
            const k1neg = k1 > POW_2_128;
            const k2neg = k2 > POW_2_128;
            if (k1neg) k1 = n - k1;
            if (k2neg) k2 = n - k2;
            if (k1 > POW_2_128 || k2 > POW_2_128) throw new Error("splitScalar: Endomorphism failed, k=" + k);
            return {
                k1neg,
                k1,
                k2neg,
                k2
            };
        }
    }
}, sha256_1.sha256);
// Schnorr signatures are superior to ECDSA from above. Below is Schnorr-specific BIP0340 code.
// https://github.com/bitcoin/bips/blob/master/bip-0340.mediawiki
const _0n = BigInt(0);
const fe = (x)=>typeof x === "bigint" && _0n < x && x < secp256k1P;
const ge = (x)=>typeof x === "bigint" && _0n < x && x < secp256k1N;
/** An object mapping tags to their tagged hash prefix of [SHA256(tag) | SHA256(tag)] */ const TAGGED_HASH_PREFIXES = {};
function taggedHash(tag, ...messages) {
    let tagP = TAGGED_HASH_PREFIXES[tag];
    if (tagP === undefined) {
        const tagH = (0, sha256_1.sha256)(Uint8Array.from(tag, (c)=>c.charCodeAt(0)));
        tagP = (0, utils_js_1.concatBytes)(tagH, tagH);
        TAGGED_HASH_PREFIXES[tag] = tagP;
    }
    return (0, sha256_1.sha256)((0, utils_js_1.concatBytes)(tagP, ...messages));
}
// ECDSA compact points are 33-byte. Schnorr is 32: we strip first byte 0x02 or 0x03
const pointToBytes = (point)=>point.toRawBytes(true).slice(1);
const numTo32b = (n)=>(0, utils_js_1.numberToBytesBE)(n, 32);
const modP = (x)=>(0, modular_js_1.mod)(x, secp256k1P);
const modN = (x)=>(0, modular_js_1.mod)(x, secp256k1N);
const Point = exports.secp256k1.ProjectivePoint;
const GmulAdd = (Q, a, b)=>Point.BASE.multiplyAndAddUnsafe(Q, a, b);
// Calculate point, scalar and bytes
function schnorrGetExtPubKey(priv) {
    let d_ = exports.secp256k1.utils.normPrivateKeyToScalar(priv); // same method executed in fromPrivateKey
    let p = Point.fromPrivateKey(d_); // P = d'⋅G; 0 < d' < n check is done inside
    const scalar = p.hasEvenY() ? d_ : modN(-d_);
    return {
        scalar: scalar,
        bytes: pointToBytes(p)
    };
}
/**
 * lift_x from BIP340. Convert 32-byte x coordinate to elliptic curve point.
 * @returns valid point checked for being on-curve
 */ function lift_x(x) {
    if (!fe(x)) throw new Error("bad x: need 0 < x < p"); // Fail if x ≥ p.
    const xx = modP(x * x);
    const c = modP(xx * x + BigInt(7)); // Let c = x³ + 7 mod p.
    let y = sqrtMod(c); // Let y = c^(p+1)/4 mod p.
    if (y % _2n !== _0n) y = modP(-y); // Return the unique point P such that x(P) = x and
    const p = new Point(x, y, _1n); // y(P) = y if y mod 2 = 0 or y(P) = p-y otherwise.
    p.assertValidity();
    return p;
}
/**
 * Create tagged hash, convert it to bigint, reduce modulo-n.
 */ function challenge(...args) {
    return modN((0, utils_js_1.bytesToNumberBE)(taggedHash("BIP0340/challenge", ...args)));
}
/**
 * Schnorr public key is just `x` coordinate of Point as per BIP340.
 */ function schnorrGetPublicKey(privateKey) {
    return schnorrGetExtPubKey(privateKey).bytes; // d'=int(sk). Fail if d'=0 or d'≥n. Ret bytes(d'⋅G)
}
/**
 * Creates Schnorr signature as per BIP340. Verifies itself before returning anything.
 * auxRand is optional and is not the sole source of k generation: bad CSPRNG won't be dangerous.
 */ function schnorrSign(message, privateKey, auxRand = (0, utils_1.randomBytes)(32)) {
    const m = (0, utils_js_1.ensureBytes)("message", message);
    const { bytes: px, scalar: d } = schnorrGetExtPubKey(privateKey); // checks for isWithinCurveOrder
    const a = (0, utils_js_1.ensureBytes)("auxRand", auxRand, 32); // Auxiliary random data a: a 32-byte array
    const t = numTo32b(d ^ (0, utils_js_1.bytesToNumberBE)(taggedHash("BIP0340/aux", a))); // Let t be the byte-wise xor of bytes(d) and hash/aux(a)
    const rand = taggedHash("BIP0340/nonce", t, px, m); // Let rand = hash/nonce(t || bytes(P) || m)
    const k_ = modN((0, utils_js_1.bytesToNumberBE)(rand)); // Let k' = int(rand) mod n
    if (k_ === _0n) throw new Error("sign failed: k is zero"); // Fail if k' = 0.
    const { bytes: rx, scalar: k } = schnorrGetExtPubKey(k_); // Let R = k'⋅G.
    const e = challenge(rx, px, m); // Let e = int(hash/challenge(bytes(R) || bytes(P) || m)) mod n.
    const sig = new Uint8Array(64); // Let sig = bytes(R) || bytes((k + ed) mod n).
    sig.set(rx, 0);
    sig.set(numTo32b(modN(k + e * d)), 32);
    // If Verify(bytes(P), m, sig) (see below) returns failure, abort
    if (!schnorrVerify(sig, m, px)) throw new Error("sign: Invalid signature produced");
    return sig;
}
/**
 * Verifies Schnorr signature.
 * Will swallow errors & return false except for initial type validation of arguments.
 */ function schnorrVerify(signature, message, publicKey) {
    const sig = (0, utils_js_1.ensureBytes)("signature", signature, 64);
    const m = (0, utils_js_1.ensureBytes)("message", message);
    const pub = (0, utils_js_1.ensureBytes)("publicKey", publicKey, 32);
    try {
        const P = lift_x((0, utils_js_1.bytesToNumberBE)(pub)); // P = lift_x(int(pk)); fail if that fails
        const r = (0, utils_js_1.bytesToNumberBE)(sig.subarray(0, 32)); // Let r = int(sig[0:32]); fail if r ≥ p.
        if (!fe(r)) return false;
        const s = (0, utils_js_1.bytesToNumberBE)(sig.subarray(32, 64)); // Let s = int(sig[32:64]); fail if s ≥ n.
        if (!ge(s)) return false;
        const e = challenge(numTo32b(r), pointToBytes(P), m); // int(challenge(bytes(r)||bytes(P)||m))%n
        const R = GmulAdd(P, s, modN(-e)); // R = s⋅G - e⋅P
        if (!R || !R.hasEvenY() || R.toAffine().x !== r) return false; // -eP == (n-e)P
        return true; // Fail if is_infinite(R) / not has_even_y(R) / x(R) ≠ r.
    } catch (error) {
        return false;
    }
}
exports.schnorr = (()=>({
        getPublicKey: schnorrGetPublicKey,
        sign: schnorrSign,
        verify: schnorrVerify,
        utils: {
            randomPrivateKey: exports.secp256k1.utils.randomPrivateKey,
            lift_x,
            pointToBytes,
            numberToBytesBE: utils_js_1.numberToBytesBE,
            bytesToNumberBE: utils_js_1.bytesToNumberBE,
            taggedHash,
            mod: modular_js_1.mod
        }
    }))();
const isoMap = /* @__PURE__ */ (()=>(0, hash_to_curve_js_1.isogenyMap)(Fp, [
        // xNum
        [
            "0x8e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38daaaaa8c7",
            "0x7d3d4c80bc321d5b9f315cea7fd44c5d595d2fc0bf63b92dfff1044f17c6581",
            "0x534c328d23f234e6e2a413deca25caece4506144037c40314ecbd0b53d9dd262",
            "0x8e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38daaaaa88c"
        ],
        // xDen
        [
            "0xd35771193d94918a9ca34ccbb7b640dd86cd409542f8487d9fe6b745781eb49b",
            "0xedadc6f64383dc1df7c4b2d51b54225406d36b641f5e41bbc52a56612a8c6d14",
            "0x0000000000000000000000000000000000000000000000000000000000000001"
        ],
        // yNum
        [
            "0x4bda12f684bda12f684bda12f684bda12f684bda12f684bda12f684b8e38e23c",
            "0xc75e0c32d5cb7c0fa9d0a54b12a0a6d5647ab046d686da6fdffc90fc201d71a3",
            "0x29a6194691f91a73715209ef6512e576722830a201be2018a765e85a9ecee931",
            "0x2f684bda12f684bda12f684bda12f684bda12f684bda12f684bda12f38e38d84"
        ],
        // yDen
        [
            "0xfffffffffffffffffffffffffffffffffffffffffffffffffffffffefffff93b",
            "0x7a06534bb8bdb49fd5e9e6632722c2989467c1bfc8e8d978dfb425d2685c2573",
            "0x6484aa716545ca2cf3a70c3fa8fe337e0a3d21162f0d6299a7bf8192bfd2a76f",
            "0x0000000000000000000000000000000000000000000000000000000000000001"
        ]
    ].map((i)=>i.map((j)=>BigInt(j)))))();
const mapSWU = /* @__PURE__ */ (()=>(0, weierstrass_js_1.mapToCurveSimpleSWU)(Fp, {
        A: BigInt("0x3f8731abdd661adca08a5558f0f5d272e953d363cb6f0e5d405447c01a444533"),
        B: BigInt("1771"),
        Z: Fp.create(BigInt("-11"))
    }))();
const htf = /* @__PURE__ */ (()=>(0, hash_to_curve_js_1.createHasher)(exports.secp256k1.ProjectivePoint, (scalars)=>{
        const { x, y } = mapSWU(Fp.create(scalars[0]));
        return isoMap(x, y);
    }, {
        DST: "secp256k1_XMD:SHA-256_SSWU_RO_",
        encodeDST: "secp256k1_XMD:SHA-256_SSWU_NU_",
        p: Fp.ORDER,
        m: 1,
        k: 128,
        expand: "xmd",
        hash: sha256_1.sha256
    }))();
exports.hashToCurve = (()=>htf.hashToCurve)();
exports.encodeToCurve = (()=>htf.encodeToCurve)();

},{"a89c1505decc763e":"3Z8i0","362802f5a451efcb":"4AcYC","8a5ef77428763709":"kntfS","992867e7d1ef8b":"bBhTF","6a274edd04635854":"iu8hF","49209a65a14a4a44":"loicZ","4687d8e71912c9bd":"hsGle"}],"3Z8i0":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.sha224 = exports.sha256 = void 0;
const _md_js_1 = require("f833411e4152792e");
const utils_js_1 = require("2582a2a48878bf64");
// SHA2-256 need to try 2^128 hashes to execute birthday attack.
// BTC network is doing 2^67 hashes/sec as per early 2023.
// Round constants:
// first 32 bits of the fractional parts of the cube roots of the first 64 primes 2..311)
// prettier-ignore
const SHA256_K = /* @__PURE__ */ new Uint32Array([
    0x428a2f98,
    0x71374491,
    0xb5c0fbcf,
    0xe9b5dba5,
    0x3956c25b,
    0x59f111f1,
    0x923f82a4,
    0xab1c5ed5,
    0xd807aa98,
    0x12835b01,
    0x243185be,
    0x550c7dc3,
    0x72be5d74,
    0x80deb1fe,
    0x9bdc06a7,
    0xc19bf174,
    0xe49b69c1,
    0xefbe4786,
    0x0fc19dc6,
    0x240ca1cc,
    0x2de92c6f,
    0x4a7484aa,
    0x5cb0a9dc,
    0x76f988da,
    0x983e5152,
    0xa831c66d,
    0xb00327c8,
    0xbf597fc7,
    0xc6e00bf3,
    0xd5a79147,
    0x06ca6351,
    0x14292967,
    0x27b70a85,
    0x2e1b2138,
    0x4d2c6dfc,
    0x53380d13,
    0x650a7354,
    0x766a0abb,
    0x81c2c92e,
    0x92722c85,
    0xa2bfe8a1,
    0xa81a664b,
    0xc24b8b70,
    0xc76c51a3,
    0xd192e819,
    0xd6990624,
    0xf40e3585,
    0x106aa070,
    0x19a4c116,
    0x1e376c08,
    0x2748774c,
    0x34b0bcb5,
    0x391c0cb3,
    0x4ed8aa4a,
    0x5b9cca4f,
    0x682e6ff3,
    0x748f82ee,
    0x78a5636f,
    0x84c87814,
    0x8cc70208,
    0x90befffa,
    0xa4506ceb,
    0xbef9a3f7,
    0xc67178f2
]);
// Initial state:
// first 32 bits of the fractional parts of the square roots of the first 8 primes 2..19
// prettier-ignore
const SHA256_IV = /* @__PURE__ */ new Uint32Array([
    0x6a09e667,
    0xbb67ae85,
    0x3c6ef372,
    0xa54ff53a,
    0x510e527f,
    0x9b05688c,
    0x1f83d9ab,
    0x5be0cd19
]);
// Temporary buffer, not used to store anything between runs
// Named this way because it matches specification.
const SHA256_W = /* @__PURE__ */ new Uint32Array(64);
class SHA256 extends _md_js_1.HashMD {
    constructor(){
        super(64, 32, 8, false);
        // We cannot use array here since array allows indexing by variable
        // which means optimizer/compiler cannot use registers.
        this.A = SHA256_IV[0] | 0;
        this.B = SHA256_IV[1] | 0;
        this.C = SHA256_IV[2] | 0;
        this.D = SHA256_IV[3] | 0;
        this.E = SHA256_IV[4] | 0;
        this.F = SHA256_IV[5] | 0;
        this.G = SHA256_IV[6] | 0;
        this.H = SHA256_IV[7] | 0;
    }
    get() {
        const { A, B, C, D, E, F, G, H } = this;
        return [
            A,
            B,
            C,
            D,
            E,
            F,
            G,
            H
        ];
    }
    // prettier-ignore
    set(A, B, C, D, E, F, G, H) {
        this.A = A | 0;
        this.B = B | 0;
        this.C = C | 0;
        this.D = D | 0;
        this.E = E | 0;
        this.F = F | 0;
        this.G = G | 0;
        this.H = H | 0;
    }
    process(view, offset) {
        // Extend the first 16 words into the remaining 48 words w[16..63] of the message schedule array
        for(let i = 0; i < 16; i++, offset += 4)SHA256_W[i] = view.getUint32(offset, false);
        for(let i = 16; i < 64; i++){
            const W15 = SHA256_W[i - 15];
            const W2 = SHA256_W[i - 2];
            const s0 = (0, utils_js_1.rotr)(W15, 7) ^ (0, utils_js_1.rotr)(W15, 18) ^ W15 >>> 3;
            const s1 = (0, utils_js_1.rotr)(W2, 17) ^ (0, utils_js_1.rotr)(W2, 19) ^ W2 >>> 10;
            SHA256_W[i] = s1 + SHA256_W[i - 7] + s0 + SHA256_W[i - 16] | 0;
        }
        // Compression function main loop, 64 rounds
        let { A, B, C, D, E, F, G, H } = this;
        for(let i = 0; i < 64; i++){
            const sigma1 = (0, utils_js_1.rotr)(E, 6) ^ (0, utils_js_1.rotr)(E, 11) ^ (0, utils_js_1.rotr)(E, 25);
            const T1 = H + sigma1 + (0, _md_js_1.Chi)(E, F, G) + SHA256_K[i] + SHA256_W[i] | 0;
            const sigma0 = (0, utils_js_1.rotr)(A, 2) ^ (0, utils_js_1.rotr)(A, 13) ^ (0, utils_js_1.rotr)(A, 22);
            const T2 = sigma0 + (0, _md_js_1.Maj)(A, B, C) | 0;
            H = G;
            G = F;
            F = E;
            E = D + T1 | 0;
            D = C;
            C = B;
            B = A;
            A = T1 + T2 | 0;
        }
        // Add the compressed chunk to the current hash value
        A = A + this.A | 0;
        B = B + this.B | 0;
        C = C + this.C | 0;
        D = D + this.D | 0;
        E = E + this.E | 0;
        F = F + this.F | 0;
        G = G + this.G | 0;
        H = H + this.H | 0;
        this.set(A, B, C, D, E, F, G, H);
    }
    roundClean() {
        SHA256_W.fill(0);
    }
    destroy() {
        this.set(0, 0, 0, 0, 0, 0, 0, 0);
        this.buffer.fill(0);
    }
}
// Constants from https://nvlpubs.nist.gov/nistpubs/FIPS/NIST.FIPS.180-4.pdf
class SHA224 extends SHA256 {
    constructor(){
        super();
        this.A = -1056596264;
        this.B = 914150663;
        this.C = 812702999;
        this.D = -150054599;
        this.E = -4191439;
        this.F = 1750603025;
        this.G = 1694076839;
        this.H = -1090891868;
        this.outputLen = 28;
    }
}
/**
 * SHA2-256 hash function
 * @param message - data that would be hashed
 */ exports.sha256 = (0, utils_js_1.wrapConstructor)(()=>new SHA256());
exports.sha224 = (0, utils_js_1.wrapConstructor)(()=>new SHA224());

},{"f833411e4152792e":"8AZTC","2582a2a48878bf64":"4AcYC"}],"8AZTC":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.HashMD = exports.Maj = exports.Chi = void 0;
const _assert_js_1 = require("e4b209aaee4ae5e1");
const utils_js_1 = require("2629587449b452fc");
// Polyfill for Safari 14
function setBigUint64(view, byteOffset, value, isLE) {
    if (typeof view.setBigUint64 === "function") return view.setBigUint64(byteOffset, value, isLE);
    const _32n = BigInt(32);
    const _u32_max = BigInt(0xffffffff);
    const wh = Number(value >> _32n & _u32_max);
    const wl = Number(value & _u32_max);
    const h = isLE ? 4 : 0;
    const l = isLE ? 0 : 4;
    view.setUint32(byteOffset + h, wh, isLE);
    view.setUint32(byteOffset + l, wl, isLE);
}
// Choice: a ? b : c
const Chi = (a, b, c)=>a & b ^ ~a & c;
exports.Chi = Chi;
// Majority function, true if any two inpust is true
const Maj = (a, b, c)=>a & b ^ a & c ^ b & c;
exports.Maj = Maj;
/**
 * Merkle-Damgard hash construction base class.
 * Could be used to create MD5, RIPEMD, SHA1, SHA2.
 */ class HashMD extends utils_js_1.Hash {
    constructor(blockLen, outputLen, padOffset, isLE){
        super();
        this.blockLen = blockLen;
        this.outputLen = outputLen;
        this.padOffset = padOffset;
        this.isLE = isLE;
        this.finished = false;
        this.length = 0;
        this.pos = 0;
        this.destroyed = false;
        this.buffer = new Uint8Array(blockLen);
        this.view = (0, utils_js_1.createView)(this.buffer);
    }
    update(data) {
        (0, _assert_js_1.exists)(this);
        const { view, buffer, blockLen } = this;
        data = (0, utils_js_1.toBytes)(data);
        const len = data.length;
        for(let pos = 0; pos < len;){
            const take = Math.min(blockLen - this.pos, len - pos);
            // Fast path: we have at least one block in input, cast it to view and process
            if (take === blockLen) {
                const dataView = (0, utils_js_1.createView)(data);
                for(; blockLen <= len - pos; pos += blockLen)this.process(dataView, pos);
                continue;
            }
            buffer.set(data.subarray(pos, pos + take), this.pos);
            this.pos += take;
            pos += take;
            if (this.pos === blockLen) {
                this.process(view, 0);
                this.pos = 0;
            }
        }
        this.length += data.length;
        this.roundClean();
        return this;
    }
    digestInto(out) {
        (0, _assert_js_1.exists)(this);
        (0, _assert_js_1.output)(out, this);
        this.finished = true;
        // Padding
        // We can avoid allocation of buffer for padding completely if it
        // was previously not allocated here. But it won't change performance.
        const { buffer, view, blockLen, isLE } = this;
        let { pos } = this;
        // append the bit '1' to the message
        buffer[pos++] = 128;
        this.buffer.subarray(pos).fill(0);
        // we have less than padOffset left in buffer, so we cannot put length in
        // current block, need process it and pad again
        if (this.padOffset > blockLen - pos) {
            this.process(view, 0);
            pos = 0;
        }
        // Pad until full block byte with zeros
        for(let i = pos; i < blockLen; i++)buffer[i] = 0;
        // Note: sha512 requires length to be 128bit integer, but length in JS will overflow before that
        // You need to write around 2 exabytes (u64_max / 8 / (1024**6)) for this to happen.
        // So we just write lowest 64 bits of that value.
        setBigUint64(view, blockLen - 8, BigInt(this.length * 8), isLE);
        this.process(view, 0);
        const oview = (0, utils_js_1.createView)(out);
        const len = this.outputLen;
        // NOTE: we do division by 4 later, which should be fused in single op with modulo by JIT
        if (len % 4) throw new Error("_sha2: outputLen should be aligned to 32bit");
        const outLen = len / 4;
        const state = this.get();
        if (outLen > state.length) throw new Error("_sha2: outputLen bigger than state");
        for(let i = 0; i < outLen; i++)oview.setUint32(4 * i, state[i], isLE);
    }
    digest() {
        const { buffer, outputLen } = this;
        this.digestInto(buffer);
        const res = buffer.slice(0, outputLen);
        this.destroy();
        return res;
    }
    _cloneInto(to) {
        to || (to = new this.constructor());
        to.set(...this.get());
        const { blockLen, buffer, length, finished, destroyed, pos } = this;
        to.length = length;
        to.pos = pos;
        to.finished = finished;
        to.destroyed = destroyed;
        if (length % blockLen) to.buffer.set(buffer);
        return to;
    }
}
exports.HashMD = HashMD;

},{"e4b209aaee4ae5e1":"034e5","2629587449b452fc":"4AcYC"}],"034e5":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.output = exports.exists = exports.hash = exports.bytes = exports.bool = exports.number = exports.isBytes = void 0;
function number(n) {
    if (!Number.isSafeInteger(n) || n < 0) throw new Error(`positive integer expected, not ${n}`);
}
exports.number = number;
function bool(b) {
    if (typeof b !== "boolean") throw new Error(`boolean expected, not ${b}`);
}
exports.bool = bool;
// copied from utils
function isBytes(a) {
    return a instanceof Uint8Array || a != null && typeof a === "object" && a.constructor.name === "Uint8Array";
}
exports.isBytes = isBytes;
function bytes(b, ...lengths) {
    if (!isBytes(b)) throw new Error("Uint8Array expected");
    if (lengths.length > 0 && !lengths.includes(b.length)) throw new Error(`Uint8Array expected of length ${lengths}, not of length=${b.length}`);
}
exports.bytes = bytes;
function hash(h) {
    if (typeof h !== "function" || typeof h.create !== "function") throw new Error("Hash should be wrapped by utils.wrapConstructor");
    number(h.outputLen);
    number(h.blockLen);
}
exports.hash = hash;
function exists(instance, checkFinished = true) {
    if (instance.destroyed) throw new Error("Hash instance has been destroyed");
    if (checkFinished && instance.finished) throw new Error("Hash#digest() has already been called");
}
exports.exists = exists;
function output(out, instance) {
    bytes(out);
    const min = instance.outputLen;
    if (out.length < min) throw new Error(`digestInto() expects output buffer of length at least ${min}`);
}
exports.output = output;
const assert = {
    number,
    bool,
    bytes,
    hash,
    exists,
    output
};
exports.default = assert;

},{}],"4AcYC":[function(require,module,exports) {
"use strict";
/*! noble-hashes - MIT License (c) 2022 Paul Miller (paulmillr.com) */ Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.randomBytes = exports.wrapXOFConstructorWithOpts = exports.wrapConstructorWithOpts = exports.wrapConstructor = exports.checkOpts = exports.Hash = exports.concatBytes = exports.toBytes = exports.utf8ToBytes = exports.asyncLoop = exports.nextTick = exports.hexToBytes = exports.bytesToHex = exports.byteSwap32 = exports.byteSwapIfBE = exports.byteSwap = exports.isLE = exports.rotl = exports.rotr = exports.createView = exports.u32 = exports.u8 = exports.isBytes = void 0;
// We use WebCrypto aka globalThis.crypto, which exists in browsers and node.js 16+.
// node.js versions earlier than v19 don't declare it in global scope.
// For node.js, package.json#exports field mapping rewrites import
// from `crypto` to `cryptoNode`, which imports native module.
// Makes the utils un-importable in browsers without a bundler.
// Once node.js 18 is deprecated (2025-04-30), we can just drop the import.
const crypto_1 = require("68fd839c1f011a30");
const _assert_js_1 = require("e546f0455ded250");
// export { isBytes } from './_assert.js';
// We can't reuse isBytes from _assert, because somehow this causes huge perf issues
function isBytes(a) {
    return a instanceof Uint8Array || a != null && typeof a === "object" && a.constructor.name === "Uint8Array";
}
exports.isBytes = isBytes;
// Cast array to different type
const u8 = (arr)=>new Uint8Array(arr.buffer, arr.byteOffset, arr.byteLength);
exports.u8 = u8;
const u32 = (arr)=>new Uint32Array(arr.buffer, arr.byteOffset, Math.floor(arr.byteLength / 4));
exports.u32 = u32;
// Cast array to view
const createView = (arr)=>new DataView(arr.buffer, arr.byteOffset, arr.byteLength);
exports.createView = createView;
// The rotate right (circular right shift) operation for uint32
const rotr = (word, shift)=>word << 32 - shift | word >>> shift;
exports.rotr = rotr;
// The rotate left (circular left shift) operation for uint32
const rotl = (word, shift)=>word << shift | word >>> 32 - shift >>> 0;
exports.rotl = rotl;
exports.isLE = new Uint8Array(new Uint32Array([
    0x11223344
]).buffer)[0] === 0x44;
// The byte swap operation for uint32
const byteSwap = (word)=>word << 24 & 0xff000000 | word << 8 & 0xff0000 | word >>> 8 & 0xff00 | word >>> 24 & 0xff;
exports.byteSwap = byteSwap;
// Conditionally byte swap if on a big-endian platform
exports.byteSwapIfBE = exports.isLE ? (n)=>n : (n)=>(0, exports.byteSwap)(n);
// In place byte swap for Uint32Array
function byteSwap32(arr) {
    for(let i = 0; i < arr.length; i++)arr[i] = (0, exports.byteSwap)(arr[i]);
}
exports.byteSwap32 = byteSwap32;
// Array where index 0xf0 (240) is mapped to string 'f0'
const hexes = /* @__PURE__ */ Array.from({
    length: 256
}, (_, i)=>i.toString(16).padStart(2, "0"));
/**
 * @example bytesToHex(Uint8Array.from([0xca, 0xfe, 0x01, 0x23])) // 'cafe0123'
 */ function bytesToHex(bytes) {
    (0, _assert_js_1.bytes)(bytes);
    // pre-caching improves the speed 6x
    let hex = "";
    for(let i = 0; i < bytes.length; i++)hex += hexes[bytes[i]];
    return hex;
}
exports.bytesToHex = bytesToHex;
// We use optimized technique to convert hex string to byte array
const asciis = {
    _0: 48,
    _9: 57,
    _A: 65,
    _F: 70,
    _a: 97,
    _f: 102
};
function asciiToBase16(char) {
    if (char >= asciis._0 && char <= asciis._9) return char - asciis._0;
    if (char >= asciis._A && char <= asciis._F) return char - (asciis._A - 10);
    if (char >= asciis._a && char <= asciis._f) return char - (asciis._a - 10);
    return;
}
/**
 * @example hexToBytes('cafe0123') // Uint8Array.from([0xca, 0xfe, 0x01, 0x23])
 */ function hexToBytes(hex) {
    if (typeof hex !== "string") throw new Error("hex string expected, got " + typeof hex);
    const hl = hex.length;
    const al = hl / 2;
    if (hl % 2) throw new Error("padded hex string expected, got unpadded hex of length " + hl);
    const array = new Uint8Array(al);
    for(let ai = 0, hi = 0; ai < al; ai++, hi += 2){
        const n1 = asciiToBase16(hex.charCodeAt(hi));
        const n2 = asciiToBase16(hex.charCodeAt(hi + 1));
        if (n1 === undefined || n2 === undefined) {
            const char = hex[hi] + hex[hi + 1];
            throw new Error('hex string expected, got non-hex character "' + char + '" at index ' + hi);
        }
        array[ai] = n1 * 16 + n2;
    }
    return array;
}
exports.hexToBytes = hexToBytes;
// There is no setImmediate in browser and setTimeout is slow.
// call of async fn will return Promise, which will be fullfiled only on
// next scheduler queue processing step and this is exactly what we need.
const nextTick = async ()=>{};
exports.nextTick = nextTick;
// Returns control to thread each 'tick' ms to avoid blocking
async function asyncLoop(iters, tick, cb) {
    let ts = Date.now();
    for(let i = 0; i < iters; i++){
        cb(i);
        // Date.now() is not monotonic, so in case if clock goes backwards we return return control too
        const diff = Date.now() - ts;
        if (diff >= 0 && diff < tick) continue;
        await (0, exports.nextTick)();
        ts += diff;
    }
}
exports.asyncLoop = asyncLoop;
/**
 * @example utf8ToBytes('abc') // new Uint8Array([97, 98, 99])
 */ function utf8ToBytes(str) {
    if (typeof str !== "string") throw new Error(`utf8ToBytes expected string, got ${typeof str}`);
    return new Uint8Array(new TextEncoder().encode(str)); // https://bugzil.la/1681809
}
exports.utf8ToBytes = utf8ToBytes;
/**
 * Normalizes (non-hex) string or Uint8Array to Uint8Array.
 * Warning: when Uint8Array is passed, it would NOT get copied.
 * Keep in mind for future mutable operations.
 */ function toBytes(data) {
    if (typeof data === "string") data = utf8ToBytes(data);
    (0, _assert_js_1.bytes)(data);
    return data;
}
exports.toBytes = toBytes;
/**
 * Copies several Uint8Arrays into one.
 */ function concatBytes(...arrays) {
    let sum = 0;
    for(let i = 0; i < arrays.length; i++){
        const a = arrays[i];
        (0, _assert_js_1.bytes)(a);
        sum += a.length;
    }
    const res = new Uint8Array(sum);
    for(let i = 0, pad = 0; i < arrays.length; i++){
        const a = arrays[i];
        res.set(a, pad);
        pad += a.length;
    }
    return res;
}
exports.concatBytes = concatBytes;
// For runtime check if class implements interface
class Hash {
    // Safe version that clones internal state
    clone() {
        return this._cloneInto();
    }
}
exports.Hash = Hash;
const toStr = {}.toString;
function checkOpts(defaults, opts) {
    if (opts !== undefined && toStr.call(opts) !== "[object Object]") throw new Error("Options should be object or undefined");
    const merged = Object.assign(defaults, opts);
    return merged;
}
exports.checkOpts = checkOpts;
function wrapConstructor(hashCons) {
    const hashC = (msg)=>hashCons().update(toBytes(msg)).digest();
    const tmp = hashCons();
    hashC.outputLen = tmp.outputLen;
    hashC.blockLen = tmp.blockLen;
    hashC.create = ()=>hashCons();
    return hashC;
}
exports.wrapConstructor = wrapConstructor;
function wrapConstructorWithOpts(hashCons) {
    const hashC = (msg, opts)=>hashCons(opts).update(toBytes(msg)).digest();
    const tmp = hashCons({});
    hashC.outputLen = tmp.outputLen;
    hashC.blockLen = tmp.blockLen;
    hashC.create = (opts)=>hashCons(opts);
    return hashC;
}
exports.wrapConstructorWithOpts = wrapConstructorWithOpts;
function wrapXOFConstructorWithOpts(hashCons) {
    const hashC = (msg, opts)=>hashCons(opts).update(toBytes(msg)).digest();
    const tmp = hashCons({});
    hashC.outputLen = tmp.outputLen;
    hashC.blockLen = tmp.blockLen;
    hashC.create = (opts)=>hashCons(opts);
    return hashC;
}
exports.wrapXOFConstructorWithOpts = wrapXOFConstructorWithOpts;
/**
 * Secure PRNG. Uses `crypto.getRandomValues`, which defers to OS.
 */ function randomBytes(bytesLength = 32) {
    if (crypto_1.crypto && typeof crypto_1.crypto.getRandomValues === "function") return crypto_1.crypto.getRandomValues(new Uint8Array(bytesLength));
    throw new Error("crypto.getRandomValues must be defined");
}
exports.randomBytes = randomBytes;

},{"68fd839c1f011a30":"6oZE2","e546f0455ded250":"034e5"}],"6oZE2":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.crypto = void 0;
exports.crypto = typeof globalThis === "object" && "crypto" in globalThis ? globalThis.crypto : undefined;

},{}],"kntfS":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getHash = getHash;
exports.createCurve = createCurve;
/*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */ const hmac_1 = require("2bb3ed73a71161e3");
const utils_1 = require("808050cc11f056c7");
const weierstrass_js_1 = require("bceff96a5b87336d");
// connects noble-curves to noble-hashes
function getHash(hash) {
    return {
        hash,
        hmac: (key, ...msgs)=>(0, hmac_1.hmac)(hash, key, (0, utils_1.concatBytes)(...msgs)),
        randomBytes: utils_1.randomBytes
    };
}
function createCurve(curveDef, defHash) {
    const create = (hash)=>(0, weierstrass_js_1.weierstrass)({
            ...curveDef,
            ...getHash(hash)
        });
    return Object.freeze({
        ...create(defHash),
        create
    });
}

},{"2bb3ed73a71161e3":"ija3b","808050cc11f056c7":"4AcYC","bceff96a5b87336d":"hsGle"}],"ija3b":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.hmac = exports.HMAC = void 0;
const _assert_js_1 = require("6b524da50970d987");
const utils_js_1 = require("54bb4061811e0f46");
// HMAC (RFC 2104)
class HMAC extends utils_js_1.Hash {
    constructor(hash, _key){
        super();
        this.finished = false;
        this.destroyed = false;
        (0, _assert_js_1.hash)(hash);
        const key = (0, utils_js_1.toBytes)(_key);
        this.iHash = hash.create();
        if (typeof this.iHash.update !== "function") throw new Error("Expected instance of class which extends utils.Hash");
        this.blockLen = this.iHash.blockLen;
        this.outputLen = this.iHash.outputLen;
        const blockLen = this.blockLen;
        const pad = new Uint8Array(blockLen);
        // blockLen can be bigger than outputLen
        pad.set(key.length > blockLen ? hash.create().update(key).digest() : key);
        for(let i = 0; i < pad.length; i++)pad[i] ^= 0x36;
        this.iHash.update(pad);
        // By doing update (processing of first block) of outer hash here we can re-use it between multiple calls via clone
        this.oHash = hash.create();
        // Undo internal XOR && apply outer XOR
        for(let i = 0; i < pad.length; i++)pad[i] ^= 106;
        this.oHash.update(pad);
        pad.fill(0);
    }
    update(buf) {
        (0, _assert_js_1.exists)(this);
        this.iHash.update(buf);
        return this;
    }
    digestInto(out) {
        (0, _assert_js_1.exists)(this);
        (0, _assert_js_1.bytes)(out, this.outputLen);
        this.finished = true;
        this.iHash.digestInto(out);
        this.oHash.update(out);
        this.oHash.digestInto(out);
        this.destroy();
    }
    digest() {
        const out = new Uint8Array(this.oHash.outputLen);
        this.digestInto(out);
        return out;
    }
    _cloneInto(to) {
        // Create new instance without calling constructor since key already in state and we don't know it.
        to || (to = Object.create(Object.getPrototypeOf(this), {}));
        const { oHash, iHash, finished, destroyed, blockLen, outputLen } = this;
        to;
        to.finished = finished;
        to.destroyed = destroyed;
        to.blockLen = blockLen;
        to.outputLen = outputLen;
        to.oHash = oHash._cloneInto(to.oHash);
        to.iHash = iHash._cloneInto(to.iHash);
        return to;
    }
    destroy() {
        this.destroyed = true;
        this.oHash.destroy();
        this.iHash.destroy();
    }
}
exports.HMAC = HMAC;
/**
 * HMAC: RFC2104 message authentication code.
 * @param hash - function that would be used e.g. sha256
 * @param key - message key
 * @param message - message data
 */ const hmac = (hash, key, message)=>new HMAC(hash, key).update(message).digest();
exports.hmac = hmac;
exports.hmac.create = (hash, key)=>new HMAC(hash, key);

},{"6b524da50970d987":"034e5","54bb4061811e0f46":"4AcYC"}],"hsGle":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.DER = void 0;
exports.weierstrassPoints = weierstrassPoints;
exports.weierstrass = weierstrass;
exports.SWUFpSqrtRatio = SWUFpSqrtRatio;
exports.mapToCurveSimpleSWU = mapToCurveSimpleSWU;
/*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */ // Short Weierstrass curve. The formula is: y² = x³ + ax + b
const curve_js_1 = require("11f68d725b0f6f5d");
const mod = require("d8b1615c256fe3fa");
const ut = require("aae491f09795d5ee");
const utils_js_1 = require("aae491f09795d5ee");
function validatePointOpts(curve) {
    const opts = (0, curve_js_1.validateBasic)(curve);
    ut.validateObject(opts, {
        a: "field",
        b: "field"
    }, {
        allowedPrivateKeyLengths: "array",
        wrapPrivateKey: "boolean",
        isTorsionFree: "function",
        clearCofactor: "function",
        allowInfinityPoint: "boolean",
        fromBytes: "function",
        toBytes: "function"
    });
    const { endo, Fp, a } = opts;
    if (endo) {
        if (!Fp.eql(a, Fp.ZERO)) throw new Error("Endomorphism can only be defined for Koblitz curves that have a=0");
        if (typeof endo !== "object" || typeof endo.beta !== "bigint" || typeof endo.splitScalar !== "function") throw new Error("Expected endomorphism with beta: bigint and splitScalar: function");
    }
    return Object.freeze({
        ...opts
    });
}
// ASN.1 DER encoding utilities
const { bytesToNumberBE: b2n, hexToBytes: h2b } = ut;
exports.DER = {
    // asn.1 DER encoding utils
    Err: class DERErr extends Error {
        constructor(m = ""){
            super(m);
        }
    },
    _parseInt (data) {
        const { Err: E } = exports.DER;
        if (data.length < 2 || data[0] !== 0x02) throw new E("Invalid signature integer tag");
        const len = data[1];
        const res = data.subarray(2, len + 2);
        if (!len || res.length !== len) throw new E("Invalid signature integer: wrong length");
        // https://crypto.stackexchange.com/a/57734 Leftmost bit of first byte is 'negative' flag,
        // since we always use positive integers here. It must always be empty:
        // - add zero byte if exists
        // - if next byte doesn't have a flag, leading zero is not allowed (minimal encoding)
        if (res[0] & 128) throw new E("Invalid signature integer: negative");
        if (res[0] === 0x00 && !(res[1] & 128)) throw new E("Invalid signature integer: unnecessary leading zero");
        return {
            d: b2n(res),
            l: data.subarray(len + 2)
        }; // d is data, l is left
    },
    toSig (hex) {
        // parse DER signature
        const { Err: E } = exports.DER;
        const data = typeof hex === "string" ? h2b(hex) : hex;
        ut.abytes(data);
        let l = data.length;
        if (l < 2 || data[0] != 0x30) throw new E("Invalid signature tag");
        if (data[1] !== l - 2) throw new E("Invalid signature: incorrect length");
        const { d: r, l: sBytes } = exports.DER._parseInt(data.subarray(2));
        const { d: s, l: rBytesLeft } = exports.DER._parseInt(sBytes);
        if (rBytesLeft.length) throw new E("Invalid signature: left bytes after parsing");
        return {
            r,
            s
        };
    },
    hexFromSig (sig) {
        // Add leading zero if first byte has negative bit enabled. More details in '_parseInt'
        const slice = (s)=>Number.parseInt(s[0], 16) & 8 ? "00" + s : s;
        const h = (num)=>{
            const hex = num.toString(16);
            return hex.length & 1 ? `0${hex}` : hex;
        };
        const s = slice(h(sig.s));
        const r = slice(h(sig.r));
        const shl = s.length / 2;
        const rhl = r.length / 2;
        const sl = h(shl);
        const rl = h(rhl);
        return `30${h(rhl + shl + 4)}02${rl}${r}02${sl}${s}`;
    }
};
// Be friendly to bad ECMAScript parsers by not using bigint literals
// prettier-ignore
const _0n = BigInt(0), _1n = BigInt(1), _2n = BigInt(2), _3n = BigInt(3), _4n = BigInt(4);
function weierstrassPoints(opts) {
    const CURVE = validatePointOpts(opts);
    const { Fp } = CURVE; // All curves has same field / group length as for now, but they can differ
    const toBytes = CURVE.toBytes || ((_c, point, _isCompressed)=>{
        const a = point.toAffine();
        return ut.concatBytes(Uint8Array.from([
            0x04
        ]), Fp.toBytes(a.x), Fp.toBytes(a.y));
    });
    const fromBytes = CURVE.fromBytes || ((bytes)=>{
        // const head = bytes[0];
        const tail = bytes.subarray(1);
        // if (head !== 0x04) throw new Error('Only non-compressed encoding is supported');
        const x = Fp.fromBytes(tail.subarray(0, Fp.BYTES));
        const y = Fp.fromBytes(tail.subarray(Fp.BYTES, 2 * Fp.BYTES));
        return {
            x,
            y
        };
    });
    /**
     * y² = x³ + ax + b: Short weierstrass curve formula
     * @returns y²
     */ function weierstrassEquation(x) {
        const { a, b } = CURVE;
        const x2 = Fp.sqr(x); // x * x
        const x3 = Fp.mul(x2, x); // x2 * x
        return Fp.add(Fp.add(x3, Fp.mul(x, a)), b); // x3 + a * x + b
    }
    // Validate whether the passed curve params are valid.
    // We check if curve equation works for generator point.
    // `assertValidity()` won't work: `isTorsionFree()` is not available at this point in bls12-381.
    // ProjectivePoint class has not been initialized yet.
    if (!Fp.eql(Fp.sqr(CURVE.Gy), weierstrassEquation(CURVE.Gx))) throw new Error("bad generator point: equation left != right");
    // Valid group elements reside in range 1..n-1
    function isWithinCurveOrder(num) {
        return typeof num === "bigint" && _0n < num && num < CURVE.n;
    }
    function assertGE(num) {
        if (!isWithinCurveOrder(num)) throw new Error("Expected valid bigint: 0 < bigint < curve.n");
    }
    // Validates if priv key is valid and converts it to bigint.
    // Supports options allowedPrivateKeyLengths and wrapPrivateKey.
    function normPrivateKeyToScalar(key) {
        const { allowedPrivateKeyLengths: lengths, nByteLength, wrapPrivateKey, n } = CURVE;
        if (lengths && typeof key !== "bigint") {
            if (ut.isBytes(key)) key = ut.bytesToHex(key);
            // Normalize to hex string, pad. E.g. P521 would norm 130-132 char hex to 132-char bytes
            if (typeof key !== "string" || !lengths.includes(key.length)) throw new Error("Invalid key");
            key = key.padStart(nByteLength * 2, "0");
        }
        let num;
        try {
            num = typeof key === "bigint" ? key : ut.bytesToNumberBE((0, utils_js_1.ensureBytes)("private key", key, nByteLength));
        } catch (error) {
            throw new Error(`private key must be ${nByteLength} bytes, hex or bigint, not ${typeof key}`);
        }
        if (wrapPrivateKey) num = mod.mod(num, n); // disabled by default, enabled for BLS
        assertGE(num); // num in range [1..N-1]
        return num;
    }
    const pointPrecomputes = new Map();
    function assertPrjPoint(other) {
        if (!(other instanceof Point)) throw new Error("ProjectivePoint expected");
    }
    /**
     * Projective Point works in 3d / projective (homogeneous) coordinates: (x, y, z) ∋ (x=x/z, y=y/z)
     * Default Point works in 2d / affine coordinates: (x, y)
     * We're doing calculations in projective, because its operations don't require costly inversion.
     */ class Point {
        constructor(px, py, pz){
            this.px = px;
            this.py = py;
            this.pz = pz;
            if (px == null || !Fp.isValid(px)) throw new Error("x required");
            if (py == null || !Fp.isValid(py)) throw new Error("y required");
            if (pz == null || !Fp.isValid(pz)) throw new Error("z required");
        }
        // Does not validate if the point is on-curve.
        // Use fromHex instead, or call assertValidity() later.
        static fromAffine(p) {
            const { x, y } = p || {};
            if (!p || !Fp.isValid(x) || !Fp.isValid(y)) throw new Error("invalid affine point");
            if (p instanceof Point) throw new Error("projective point not allowed");
            const is0 = (i)=>Fp.eql(i, Fp.ZERO);
            // fromAffine(x:0, y:0) would produce (x:0, y:0, z:1), but we need (x:0, y:1, z:0)
            if (is0(x) && is0(y)) return Point.ZERO;
            return new Point(x, y, Fp.ONE);
        }
        get x() {
            return this.toAffine().x;
        }
        get y() {
            return this.toAffine().y;
        }
        /**
         * Takes a bunch of Projective Points but executes only one
         * inversion on all of them. Inversion is very slow operation,
         * so this improves performance massively.
         * Optimization: converts a list of projective points to a list of identical points with Z=1.
         */ static normalizeZ(points) {
            const toInv = Fp.invertBatch(points.map((p)=>p.pz));
            return points.map((p, i)=>p.toAffine(toInv[i])).map(Point.fromAffine);
        }
        /**
         * Converts hash string or Uint8Array to Point.
         * @param hex short/long ECDSA hex
         */ static fromHex(hex) {
            const P = Point.fromAffine(fromBytes((0, utils_js_1.ensureBytes)("pointHex", hex)));
            P.assertValidity();
            return P;
        }
        // Multiplies generator point by privateKey.
        static fromPrivateKey(privateKey) {
            return Point.BASE.multiply(normPrivateKeyToScalar(privateKey));
        }
        // "Private method", don't use it directly
        _setWindowSize(windowSize) {
            this._WINDOW_SIZE = windowSize;
            pointPrecomputes.delete(this);
        }
        // A point on curve is valid if it conforms to equation.
        assertValidity() {
            if (this.is0()) {
                // (0, 1, 0) aka ZERO is invalid in most contexts.
                // In BLS, ZERO can be serialized, so we allow it.
                // (0, 0, 0) is wrong representation of ZERO and is always invalid.
                if (CURVE.allowInfinityPoint && !Fp.is0(this.py)) return;
                throw new Error("bad point: ZERO");
            }
            // Some 3rd-party test vectors require different wording between here & `fromCompressedHex`
            const { x, y } = this.toAffine();
            // Check if x, y are valid field elements
            if (!Fp.isValid(x) || !Fp.isValid(y)) throw new Error("bad point: x or y not FE");
            const left = Fp.sqr(y); // y²
            const right = weierstrassEquation(x); // x³ + ax + b
            if (!Fp.eql(left, right)) throw new Error("bad point: equation left != right");
            if (!this.isTorsionFree()) throw new Error("bad point: not in prime-order subgroup");
        }
        hasEvenY() {
            const { y } = this.toAffine();
            if (Fp.isOdd) return !Fp.isOdd(y);
            throw new Error("Field doesn't support isOdd");
        }
        /**
         * Compare one point to another.
         */ equals(other) {
            assertPrjPoint(other);
            const { px: X1, py: Y1, pz: Z1 } = this;
            const { px: X2, py: Y2, pz: Z2 } = other;
            const U1 = Fp.eql(Fp.mul(X1, Z2), Fp.mul(X2, Z1));
            const U2 = Fp.eql(Fp.mul(Y1, Z2), Fp.mul(Y2, Z1));
            return U1 && U2;
        }
        /**
         * Flips point to one corresponding to (x, -y) in Affine coordinates.
         */ negate() {
            return new Point(this.px, Fp.neg(this.py), this.pz);
        }
        // Renes-Costello-Batina exception-free doubling formula.
        // There is 30% faster Jacobian formula, but it is not complete.
        // https://eprint.iacr.org/2015/1060, algorithm 3
        // Cost: 8M + 3S + 3*a + 2*b3 + 15add.
        double() {
            const { a, b } = CURVE;
            const b3 = Fp.mul(b, _3n);
            const { px: X1, py: Y1, pz: Z1 } = this;
            let X3 = Fp.ZERO, Y3 = Fp.ZERO, Z3 = Fp.ZERO; // prettier-ignore
            let t0 = Fp.mul(X1, X1); // step 1
            let t1 = Fp.mul(Y1, Y1);
            let t2 = Fp.mul(Z1, Z1);
            let t3 = Fp.mul(X1, Y1);
            t3 = Fp.add(t3, t3); // step 5
            Z3 = Fp.mul(X1, Z1);
            Z3 = Fp.add(Z3, Z3);
            X3 = Fp.mul(a, Z3);
            Y3 = Fp.mul(b3, t2);
            Y3 = Fp.add(X3, Y3); // step 10
            X3 = Fp.sub(t1, Y3);
            Y3 = Fp.add(t1, Y3);
            Y3 = Fp.mul(X3, Y3);
            X3 = Fp.mul(t3, X3);
            Z3 = Fp.mul(b3, Z3); // step 15
            t2 = Fp.mul(a, t2);
            t3 = Fp.sub(t0, t2);
            t3 = Fp.mul(a, t3);
            t3 = Fp.add(t3, Z3);
            Z3 = Fp.add(t0, t0); // step 20
            t0 = Fp.add(Z3, t0);
            t0 = Fp.add(t0, t2);
            t0 = Fp.mul(t0, t3);
            Y3 = Fp.add(Y3, t0);
            t2 = Fp.mul(Y1, Z1); // step 25
            t2 = Fp.add(t2, t2);
            t0 = Fp.mul(t2, t3);
            X3 = Fp.sub(X3, t0);
            Z3 = Fp.mul(t2, t1);
            Z3 = Fp.add(Z3, Z3); // step 30
            Z3 = Fp.add(Z3, Z3);
            return new Point(X3, Y3, Z3);
        }
        // Renes-Costello-Batina exception-free addition formula.
        // There is 30% faster Jacobian formula, but it is not complete.
        // https://eprint.iacr.org/2015/1060, algorithm 1
        // Cost: 12M + 0S + 3*a + 3*b3 + 23add.
        add(other) {
            assertPrjPoint(other);
            const { px: X1, py: Y1, pz: Z1 } = this;
            const { px: X2, py: Y2, pz: Z2 } = other;
            let X3 = Fp.ZERO, Y3 = Fp.ZERO, Z3 = Fp.ZERO; // prettier-ignore
            const a = CURVE.a;
            const b3 = Fp.mul(CURVE.b, _3n);
            let t0 = Fp.mul(X1, X2); // step 1
            let t1 = Fp.mul(Y1, Y2);
            let t2 = Fp.mul(Z1, Z2);
            let t3 = Fp.add(X1, Y1);
            let t4 = Fp.add(X2, Y2); // step 5
            t3 = Fp.mul(t3, t4);
            t4 = Fp.add(t0, t1);
            t3 = Fp.sub(t3, t4);
            t4 = Fp.add(X1, Z1);
            let t5 = Fp.add(X2, Z2); // step 10
            t4 = Fp.mul(t4, t5);
            t5 = Fp.add(t0, t2);
            t4 = Fp.sub(t4, t5);
            t5 = Fp.add(Y1, Z1);
            X3 = Fp.add(Y2, Z2); // step 15
            t5 = Fp.mul(t5, X3);
            X3 = Fp.add(t1, t2);
            t5 = Fp.sub(t5, X3);
            Z3 = Fp.mul(a, t4);
            X3 = Fp.mul(b3, t2); // step 20
            Z3 = Fp.add(X3, Z3);
            X3 = Fp.sub(t1, Z3);
            Z3 = Fp.add(t1, Z3);
            Y3 = Fp.mul(X3, Z3);
            t1 = Fp.add(t0, t0); // step 25
            t1 = Fp.add(t1, t0);
            t2 = Fp.mul(a, t2);
            t4 = Fp.mul(b3, t4);
            t1 = Fp.add(t1, t2);
            t2 = Fp.sub(t0, t2); // step 30
            t2 = Fp.mul(a, t2);
            t4 = Fp.add(t4, t2);
            t0 = Fp.mul(t1, t4);
            Y3 = Fp.add(Y3, t0);
            t0 = Fp.mul(t5, t4); // step 35
            X3 = Fp.mul(t3, X3);
            X3 = Fp.sub(X3, t0);
            t0 = Fp.mul(t3, t1);
            Z3 = Fp.mul(t5, Z3);
            Z3 = Fp.add(Z3, t0); // step 40
            return new Point(X3, Y3, Z3);
        }
        subtract(other) {
            return this.add(other.negate());
        }
        is0() {
            return this.equals(Point.ZERO);
        }
        wNAF(n) {
            return wnaf.wNAFCached(this, pointPrecomputes, n, (comp)=>{
                const toInv = Fp.invertBatch(comp.map((p)=>p.pz));
                return comp.map((p, i)=>p.toAffine(toInv[i])).map(Point.fromAffine);
            });
        }
        /**
         * Non-constant-time multiplication. Uses double-and-add algorithm.
         * It's faster, but should only be used when you don't care about
         * an exposed private key e.g. sig verification, which works over *public* keys.
         */ multiplyUnsafe(n) {
            const I = Point.ZERO;
            if (n === _0n) return I;
            assertGE(n); // Will throw on 0
            if (n === _1n) return this;
            const { endo } = CURVE;
            if (!endo) return wnaf.unsafeLadder(this, n);
            // Apply endomorphism
            let { k1neg, k1, k2neg, k2 } = endo.splitScalar(n);
            let k1p = I;
            let k2p = I;
            let d = this;
            while(k1 > _0n || k2 > _0n){
                if (k1 & _1n) k1p = k1p.add(d);
                if (k2 & _1n) k2p = k2p.add(d);
                d = d.double();
                k1 >>= _1n;
                k2 >>= _1n;
            }
            if (k1neg) k1p = k1p.negate();
            if (k2neg) k2p = k2p.negate();
            k2p = new Point(Fp.mul(k2p.px, endo.beta), k2p.py, k2p.pz);
            return k1p.add(k2p);
        }
        /**
         * Constant time multiplication.
         * Uses wNAF method. Windowed method may be 10% faster,
         * but takes 2x longer to generate and consumes 2x memory.
         * Uses precomputes when available.
         * Uses endomorphism for Koblitz curves.
         * @param scalar by which the point would be multiplied
         * @returns New point
         */ multiply(scalar) {
            assertGE(scalar);
            let n = scalar;
            let point, fake; // Fake point is used to const-time mult
            const { endo } = CURVE;
            if (endo) {
                const { k1neg, k1, k2neg, k2 } = endo.splitScalar(n);
                let { p: k1p, f: f1p } = this.wNAF(k1);
                let { p: k2p, f: f2p } = this.wNAF(k2);
                k1p = wnaf.constTimeNegate(k1neg, k1p);
                k2p = wnaf.constTimeNegate(k2neg, k2p);
                k2p = new Point(Fp.mul(k2p.px, endo.beta), k2p.py, k2p.pz);
                point = k1p.add(k2p);
                fake = f1p.add(f2p);
            } else {
                const { p, f } = this.wNAF(n);
                point = p;
                fake = f;
            }
            // Normalize `z` for both points, but return only real one
            return Point.normalizeZ([
                point,
                fake
            ])[0];
        }
        /**
         * Efficiently calculate `aP + bQ`. Unsafe, can expose private key, if used incorrectly.
         * Not using Strauss-Shamir trick: precomputation tables are faster.
         * The trick could be useful if both P and Q are not G (not in our case).
         * @returns non-zero affine point
         */ multiplyAndAddUnsafe(Q, a, b) {
            const G = Point.BASE; // No Strauss-Shamir trick: we have 10% faster G precomputes
            const mul = (P, a // Select faster multiply() method
            )=>a === _0n || a === _1n || !P.equals(G) ? P.multiplyUnsafe(a) : P.multiply(a);
            const sum = mul(this, a).add(mul(Q, b));
            return sum.is0() ? undefined : sum;
        }
        // Converts Projective point to affine (x, y) coordinates.
        // Can accept precomputed Z^-1 - for example, from invertBatch.
        // (x, y, z) ∋ (x=x/z, y=y/z)
        toAffine(iz) {
            const { px: x, py: y, pz: z } = this;
            const is0 = this.is0();
            // If invZ was 0, we return zero point. However we still want to execute
            // all operations, so we replace invZ with a random number, 1.
            if (iz == null) iz = is0 ? Fp.ONE : Fp.inv(z);
            const ax = Fp.mul(x, iz);
            const ay = Fp.mul(y, iz);
            const zz = Fp.mul(z, iz);
            if (is0) return {
                x: Fp.ZERO,
                y: Fp.ZERO
            };
            if (!Fp.eql(zz, Fp.ONE)) throw new Error("invZ was invalid");
            return {
                x: ax,
                y: ay
            };
        }
        isTorsionFree() {
            const { h: cofactor, isTorsionFree } = CURVE;
            if (cofactor === _1n) return true; // No subgroups, always torsion-free
            if (isTorsionFree) return isTorsionFree(Point, this);
            throw new Error("isTorsionFree() has not been declared for the elliptic curve");
        }
        clearCofactor() {
            const { h: cofactor, clearCofactor } = CURVE;
            if (cofactor === _1n) return this; // Fast-path
            if (clearCofactor) return clearCofactor(Point, this);
            return this.multiplyUnsafe(CURVE.h);
        }
        toRawBytes(isCompressed = true) {
            this.assertValidity();
            return toBytes(Point, this, isCompressed);
        }
        toHex(isCompressed = true) {
            return ut.bytesToHex(this.toRawBytes(isCompressed));
        }
    }
    Point.BASE = new Point(CURVE.Gx, CURVE.Gy, Fp.ONE);
    Point.ZERO = new Point(Fp.ZERO, Fp.ONE, Fp.ZERO);
    const _bits = CURVE.nBitLength;
    const wnaf = (0, curve_js_1.wNAF)(Point, CURVE.endo ? Math.ceil(_bits / 2) : _bits);
    // Validate if generator point is on curve
    return {
        CURVE,
        ProjectivePoint: Point,
        normPrivateKeyToScalar,
        weierstrassEquation,
        isWithinCurveOrder
    };
}
function validateOpts(curve) {
    const opts = (0, curve_js_1.validateBasic)(curve);
    ut.validateObject(opts, {
        hash: "hash",
        hmac: "function",
        randomBytes: "function"
    }, {
        bits2int: "function",
        bits2int_modN: "function",
        lowS: "boolean"
    });
    return Object.freeze({
        lowS: true,
        ...opts
    });
}
function weierstrass(curveDef) {
    const CURVE = validateOpts(curveDef);
    const { Fp, n: CURVE_ORDER } = CURVE;
    const compressedLen = Fp.BYTES + 1; // e.g. 33 for 32
    const uncompressedLen = 2 * Fp.BYTES + 1; // e.g. 65 for 32
    function isValidFieldElement(num) {
        return _0n < num && num < Fp.ORDER; // 0 is banned since it's not invertible FE
    }
    function modN(a) {
        return mod.mod(a, CURVE_ORDER);
    }
    function invN(a) {
        return mod.invert(a, CURVE_ORDER);
    }
    const { ProjectivePoint: Point, normPrivateKeyToScalar, weierstrassEquation, isWithinCurveOrder } = weierstrassPoints({
        ...CURVE,
        toBytes (_c, point, isCompressed) {
            const a = point.toAffine();
            const x = Fp.toBytes(a.x);
            const cat = ut.concatBytes;
            if (isCompressed) return cat(Uint8Array.from([
                point.hasEvenY() ? 0x02 : 0x03
            ]), x);
            else return cat(Uint8Array.from([
                0x04
            ]), x, Fp.toBytes(a.y));
        },
        fromBytes (bytes) {
            const len = bytes.length;
            const head = bytes[0];
            const tail = bytes.subarray(1);
            // this.assertValidity() is done inside of fromHex
            if (len === compressedLen && (head === 0x02 || head === 0x03)) {
                const x = ut.bytesToNumberBE(tail);
                if (!isValidFieldElement(x)) throw new Error("Point is not on curve");
                const y2 = weierstrassEquation(x); // y² = x³ + ax + b
                let y;
                try {
                    y = Fp.sqrt(y2); // y = y² ^ (p+1)/4
                } catch (sqrtError) {
                    const suffix = sqrtError instanceof Error ? ": " + sqrtError.message : "";
                    throw new Error("Point is not on curve" + suffix);
                }
                const isYOdd = (y & _1n) === _1n;
                // ECDSA
                const isHeadOdd = (head & 1) === 1;
                if (isHeadOdd !== isYOdd) y = Fp.neg(y);
                return {
                    x,
                    y
                };
            } else if (len === uncompressedLen && head === 0x04) {
                const x = Fp.fromBytes(tail.subarray(0, Fp.BYTES));
                const y = Fp.fromBytes(tail.subarray(Fp.BYTES, 2 * Fp.BYTES));
                return {
                    x,
                    y
                };
            } else throw new Error(`Point of length ${len} was invalid. Expected ${compressedLen} compressed bytes or ${uncompressedLen} uncompressed bytes`);
        }
    });
    const numToNByteStr = (num)=>ut.bytesToHex(ut.numberToBytesBE(num, CURVE.nByteLength));
    function isBiggerThanHalfOrder(number) {
        const HALF = CURVE_ORDER >> _1n;
        return number > HALF;
    }
    function normalizeS(s) {
        return isBiggerThanHalfOrder(s) ? modN(-s) : s;
    }
    // slice bytes num
    const slcNum = (b, from, to)=>ut.bytesToNumberBE(b.slice(from, to));
    /**
     * ECDSA signature with its (r, s) properties. Supports DER & compact representations.
     */ class Signature {
        constructor(r, s, recovery){
            this.r = r;
            this.s = s;
            this.recovery = recovery;
            this.assertValidity();
        }
        // pair (bytes of r, bytes of s)
        static fromCompact(hex) {
            const l = CURVE.nByteLength;
            hex = (0, utils_js_1.ensureBytes)("compactSignature", hex, l * 2);
            return new Signature(slcNum(hex, 0, l), slcNum(hex, l, 2 * l));
        }
        // DER encoded ECDSA signature
        // https://bitcoin.stackexchange.com/questions/57644/what-are-the-parts-of-a-bitcoin-transaction-input-script
        static fromDER(hex) {
            const { r, s } = exports.DER.toSig((0, utils_js_1.ensureBytes)("DER", hex));
            return new Signature(r, s);
        }
        assertValidity() {
            // can use assertGE here
            if (!isWithinCurveOrder(this.r)) throw new Error("r must be 0 < r < CURVE.n");
            if (!isWithinCurveOrder(this.s)) throw new Error("s must be 0 < s < CURVE.n");
        }
        addRecoveryBit(recovery) {
            return new Signature(this.r, this.s, recovery);
        }
        recoverPublicKey(msgHash) {
            const { r, s, recovery: rec } = this;
            const h = bits2int_modN((0, utils_js_1.ensureBytes)("msgHash", msgHash)); // Truncate hash
            if (rec == null || ![
                0,
                1,
                2,
                3
            ].includes(rec)) throw new Error("recovery id invalid");
            const radj = rec === 2 || rec === 3 ? r + CURVE.n : r;
            if (radj >= Fp.ORDER) throw new Error("recovery id 2 or 3 invalid");
            const prefix = (rec & 1) === 0 ? "02" : "03";
            const R = Point.fromHex(prefix + numToNByteStr(radj));
            const ir = invN(radj); // r^-1
            const u1 = modN(-h * ir); // -hr^-1
            const u2 = modN(s * ir); // sr^-1
            const Q = Point.BASE.multiplyAndAddUnsafe(R, u1, u2); // (sr^-1)R-(hr^-1)G = -(hr^-1)G + (sr^-1)
            if (!Q) throw new Error("point at infinify"); // unsafe is fine: no priv data leaked
            Q.assertValidity();
            return Q;
        }
        // Signatures should be low-s, to prevent malleability.
        hasHighS() {
            return isBiggerThanHalfOrder(this.s);
        }
        normalizeS() {
            return this.hasHighS() ? new Signature(this.r, modN(-this.s), this.recovery) : this;
        }
        // DER-encoded
        toDERRawBytes() {
            return ut.hexToBytes(this.toDERHex());
        }
        toDERHex() {
            return exports.DER.hexFromSig({
                r: this.r,
                s: this.s
            });
        }
        // padded bytes of r, then padded bytes of s
        toCompactRawBytes() {
            return ut.hexToBytes(this.toCompactHex());
        }
        toCompactHex() {
            return numToNByteStr(this.r) + numToNByteStr(this.s);
        }
    }
    const utils = {
        isValidPrivateKey (privateKey) {
            try {
                normPrivateKeyToScalar(privateKey);
                return true;
            } catch (error) {
                return false;
            }
        },
        normPrivateKeyToScalar: normPrivateKeyToScalar,
        /**
         * Produces cryptographically secure private key from random of size
         * (groupLen + ceil(groupLen / 2)) with modulo bias being negligible.
         */ randomPrivateKey: ()=>{
            const length = mod.getMinHashLength(CURVE.n);
            return mod.mapHashToField(CURVE.randomBytes(length), CURVE.n);
        },
        /**
         * Creates precompute table for an arbitrary EC point. Makes point "cached".
         * Allows to massively speed-up `point.multiply(scalar)`.
         * @returns cached point
         * @example
         * const fast = utils.precompute(8, ProjectivePoint.fromHex(someonesPubKey));
         * fast.multiply(privKey); // much faster ECDH now
         */ precompute (windowSize = 8, point = Point.BASE) {
            point._setWindowSize(windowSize);
            point.multiply(BigInt(3)); // 3 is arbitrary, just need any number here
            return point;
        }
    };
    /**
     * Computes public key for a private key. Checks for validity of the private key.
     * @param privateKey private key
     * @param isCompressed whether to return compact (default), or full key
     * @returns Public key, full when isCompressed=false; short when isCompressed=true
     */ function getPublicKey(privateKey, isCompressed = true) {
        return Point.fromPrivateKey(privateKey).toRawBytes(isCompressed);
    }
    /**
     * Quick and dirty check for item being public key. Does not validate hex, or being on-curve.
     */ function isProbPub(item) {
        const arr = ut.isBytes(item);
        const str = typeof item === "string";
        const len = (arr || str) && item.length;
        if (arr) return len === compressedLen || len === uncompressedLen;
        if (str) return len === 2 * compressedLen || len === 2 * uncompressedLen;
        if (item instanceof Point) return true;
        return false;
    }
    /**
     * ECDH (Elliptic Curve Diffie Hellman).
     * Computes shared public key from private key and public key.
     * Checks: 1) private key validity 2) shared key is on-curve.
     * Does NOT hash the result.
     * @param privateA private key
     * @param publicB different public key
     * @param isCompressed whether to return compact (default), or full key
     * @returns shared public key
     */ function getSharedSecret(privateA, publicB, isCompressed = true) {
        if (isProbPub(privateA)) throw new Error("first arg must be private key");
        if (!isProbPub(publicB)) throw new Error("second arg must be public key");
        const b = Point.fromHex(publicB); // check for being on-curve
        return b.multiply(normPrivateKeyToScalar(privateA)).toRawBytes(isCompressed);
    }
    // RFC6979: ensure ECDSA msg is X bytes and < N. RFC suggests optional truncating via bits2octets.
    // FIPS 186-4 4.6 suggests the leftmost min(nBitLen, outLen) bits, which matches bits2int.
    // bits2int can produce res>N, we can do mod(res, N) since the bitLen is the same.
    // int2octets can't be used; pads small msgs with 0: unacceptatble for trunc as per RFC vectors
    const bits2int = CURVE.bits2int || function(bytes) {
        // For curves with nBitLength % 8 !== 0: bits2octets(bits2octets(m)) !== bits2octets(m)
        // for some cases, since bytes.length * 8 is not actual bitLength.
        const num = ut.bytesToNumberBE(bytes); // check for == u8 done here
        const delta = bytes.length * 8 - CURVE.nBitLength; // truncate to nBitLength leftmost bits
        return delta > 0 ? num >> BigInt(delta) : num;
    };
    const bits2int_modN = CURVE.bits2int_modN || function(bytes) {
        return modN(bits2int(bytes)); // can't use bytesToNumberBE here
    };
    // NOTE: pads output with zero as per spec
    const ORDER_MASK = ut.bitMask(CURVE.nBitLength);
    /**
     * Converts to bytes. Checks if num in `[0..ORDER_MASK-1]` e.g.: `[0..2^256-1]`.
     */ function int2octets(num) {
        if (typeof num !== "bigint") throw new Error("bigint expected");
        if (!(_0n <= num && num < ORDER_MASK)) throw new Error(`bigint expected < 2^${CURVE.nBitLength}`);
        // works with order, can have different size than numToField!
        return ut.numberToBytesBE(num, CURVE.nByteLength);
    }
    // Steps A, D of RFC6979 3.2
    // Creates RFC6979 seed; converts msg/privKey to numbers.
    // Used only in sign, not in verify.
    // NOTE: we cannot assume here that msgHash has same amount of bytes as curve order, this will be wrong at least for P521.
    // Also it can be bigger for P224 + SHA256
    function prepSig(msgHash, privateKey, opts = defaultSigOpts) {
        if ([
            "recovered",
            "canonical"
        ].some((k)=>k in opts)) throw new Error("sign() legacy options not supported");
        const { hash, randomBytes } = CURVE;
        let { lowS, prehash, extraEntropy: ent } = opts; // generates low-s sigs by default
        if (lowS == null) lowS = true; // RFC6979 3.2: we skip step A, because we already provide hash
        msgHash = (0, utils_js_1.ensureBytes)("msgHash", msgHash);
        if (prehash) msgHash = (0, utils_js_1.ensureBytes)("prehashed msgHash", hash(msgHash));
        // We can't later call bits2octets, since nested bits2int is broken for curves
        // with nBitLength % 8 !== 0. Because of that, we unwrap it here as int2octets call.
        // const bits2octets = (bits) => int2octets(bits2int_modN(bits))
        const h1int = bits2int_modN(msgHash);
        const d = normPrivateKeyToScalar(privateKey); // validate private key, convert to bigint
        const seedArgs = [
            int2octets(d),
            int2octets(h1int)
        ];
        // extraEntropy. RFC6979 3.6: additional k' (optional).
        if (ent != null && ent !== false) {
            // K = HMAC_K(V || 0x00 || int2octets(x) || bits2octets(h1) || k')
            const e = ent === true ? randomBytes(Fp.BYTES) : ent; // generate random bytes OR pass as-is
            seedArgs.push((0, utils_js_1.ensureBytes)("extraEntropy", e)); // check for being bytes
        }
        const seed = ut.concatBytes(...seedArgs); // Step D of RFC6979 3.2
        const m = h1int; // NOTE: no need to call bits2int second time here, it is inside truncateHash!
        // Converts signature params into point w r/s, checks result for validity.
        function k2sig(kBytes) {
            // RFC 6979 Section 3.2, step 3: k = bits2int(T)
            const k = bits2int(kBytes); // Cannot use fields methods, since it is group element
            if (!isWithinCurveOrder(k)) return; // Important: all mod() calls here must be done over N
            const ik = invN(k); // k^-1 mod n
            const q = Point.BASE.multiply(k).toAffine(); // q = Gk
            const r = modN(q.x); // r = q.x mod n
            if (r === _0n) return;
            // Can use scalar blinding b^-1(bm + bdr) where b ∈ [1,q−1] according to
            // https://tches.iacr.org/index.php/TCHES/article/view/7337/6509. We've decided against it:
            // a) dependency on CSPRNG b) 15% slowdown c) doesn't really help since bigints are not CT
            const s = modN(ik * modN(m + r * d)); // Not using blinding here
            if (s === _0n) return;
            let recovery = (q.x === r ? 0 : 2) | Number(q.y & _1n); // recovery bit (2 or 3, when q.x > n)
            let normS = s;
            if (lowS && isBiggerThanHalfOrder(s)) {
                normS = normalizeS(s); // if lowS was passed, ensure s is always
                recovery ^= 1; // // in the bottom half of N
            }
            return new Signature(r, normS, recovery); // use normS, not s
        }
        return {
            seed,
            k2sig
        };
    }
    const defaultSigOpts = {
        lowS: CURVE.lowS,
        prehash: false
    };
    const defaultVerOpts = {
        lowS: CURVE.lowS,
        prehash: false
    };
    /**
     * Signs message hash with a private key.
     * ```
     * sign(m, d, k) where
     *   (x, y) = G × k
     *   r = x mod n
     *   s = (m + dr)/k mod n
     * ```
     * @param msgHash NOT message. msg needs to be hashed to `msgHash`, or use `prehash`.
     * @param privKey private key
     * @param opts lowS for non-malleable sigs. extraEntropy for mixing randomness into k. prehash will hash first arg.
     * @returns signature with recovery param
     */ function sign(msgHash, privKey, opts = defaultSigOpts) {
        const { seed, k2sig } = prepSig(msgHash, privKey, opts); // Steps A, D of RFC6979 3.2.
        const C = CURVE;
        const drbg = ut.createHmacDrbg(C.hash.outputLen, C.nByteLength, C.hmac);
        return drbg(seed, k2sig); // Steps B, C, D, E, F, G
    }
    // Enable precomputes. Slows down first publicKey computation by 20ms.
    Point.BASE._setWindowSize(8);
    // utils.precompute(8, ProjectivePoint.BASE)
    /**
     * Verifies a signature against message hash and public key.
     * Rejects lowS signatures by default: to override,
     * specify option `{lowS: false}`. Implements section 4.1.4 from https://www.secg.org/sec1-v2.pdf:
     *
     * ```
     * verify(r, s, h, P) where
     *   U1 = hs^-1 mod n
     *   U2 = rs^-1 mod n
     *   R = U1⋅G - U2⋅P
     *   mod(R.x, n) == r
     * ```
     */ function verify(signature, msgHash, publicKey, opts = defaultVerOpts) {
        const sg = signature;
        msgHash = (0, utils_js_1.ensureBytes)("msgHash", msgHash);
        publicKey = (0, utils_js_1.ensureBytes)("publicKey", publicKey);
        if ("strict" in opts) throw new Error("options.strict was renamed to lowS");
        const { lowS, prehash } = opts;
        let _sig = undefined;
        let P;
        try {
            if (typeof sg === "string" || ut.isBytes(sg)) // Signature can be represented in 2 ways: compact (2*nByteLength) & DER (variable-length).
            // Since DER can also be 2*nByteLength bytes, we check for it first.
            try {
                _sig = Signature.fromDER(sg);
            } catch (derError) {
                if (!(derError instanceof exports.DER.Err)) throw derError;
                _sig = Signature.fromCompact(sg);
            }
            else if (typeof sg === "object" && typeof sg.r === "bigint" && typeof sg.s === "bigint") {
                const { r, s } = sg;
                _sig = new Signature(r, s);
            } else throw new Error("PARSE");
            P = Point.fromHex(publicKey);
        } catch (error) {
            if (error.message === "PARSE") throw new Error(`signature must be Signature instance, Uint8Array or hex string`);
            return false;
        }
        if (lowS && _sig.hasHighS()) return false;
        if (prehash) msgHash = CURVE.hash(msgHash);
        const { r, s } = _sig;
        const h = bits2int_modN(msgHash); // Cannot use fields methods, since it is group element
        const is = invN(s); // s^-1
        const u1 = modN(h * is); // u1 = hs^-1 mod n
        const u2 = modN(r * is); // u2 = rs^-1 mod n
        const R = Point.BASE.multiplyAndAddUnsafe(P, u1, u2)?.toAffine(); // R = u1⋅G + u2⋅P
        if (!R) return false;
        const v = modN(R.x);
        return v === r;
    }
    return {
        CURVE,
        getPublicKey,
        getSharedSecret,
        sign,
        verify,
        ProjectivePoint: Point,
        Signature,
        utils
    };
}
/**
 * Implementation of the Shallue and van de Woestijne method for any weierstrass curve.
 * TODO: check if there is a way to merge this with uvRatio in Edwards; move to modular.
 * b = True and y = sqrt(u / v) if (u / v) is square in F, and
 * b = False and y = sqrt(Z * (u / v)) otherwise.
 * @param Fp
 * @param Z
 * @returns
 */ function SWUFpSqrtRatio(Fp, Z) {
    // Generic implementation
    const q = Fp.ORDER;
    let l = _0n;
    for(let o = q - _1n; o % _2n === _0n; o /= _2n)l += _1n;
    const c1 = l; // 1. c1, the largest integer such that 2^c1 divides q - 1.
    // We need 2n ** c1 and 2n ** (c1-1). We can't use **; but we can use <<.
    // 2n ** c1 == 2n << (c1-1)
    const _2n_pow_c1_1 = _2n << c1 - _1n - _1n;
    const _2n_pow_c1 = _2n_pow_c1_1 * _2n;
    const c2 = (q - _1n) / _2n_pow_c1; // 2. c2 = (q - 1) / (2^c1)  # Integer arithmetic
    const c3 = (c2 - _1n) / _2n; // 3. c3 = (c2 - 1) / 2            # Integer arithmetic
    const c4 = _2n_pow_c1 - _1n; // 4. c4 = 2^c1 - 1                # Integer arithmetic
    const c5 = _2n_pow_c1_1; // 5. c5 = 2^(c1 - 1)                  # Integer arithmetic
    const c6 = Fp.pow(Z, c2); // 6. c6 = Z^c2
    const c7 = Fp.pow(Z, (c2 + _1n) / _2n); // 7. c7 = Z^((c2 + 1) / 2)
    let sqrtRatio = (u, v)=>{
        let tv1 = c6; // 1. tv1 = c6
        let tv2 = Fp.pow(v, c4); // 2. tv2 = v^c4
        let tv3 = Fp.sqr(tv2); // 3. tv3 = tv2^2
        tv3 = Fp.mul(tv3, v); // 4. tv3 = tv3 * v
        let tv5 = Fp.mul(u, tv3); // 5. tv5 = u * tv3
        tv5 = Fp.pow(tv5, c3); // 6. tv5 = tv5^c3
        tv5 = Fp.mul(tv5, tv2); // 7. tv5 = tv5 * tv2
        tv2 = Fp.mul(tv5, v); // 8. tv2 = tv5 * v
        tv3 = Fp.mul(tv5, u); // 9. tv3 = tv5 * u
        let tv4 = Fp.mul(tv3, tv2); // 10. tv4 = tv3 * tv2
        tv5 = Fp.pow(tv4, c5); // 11. tv5 = tv4^c5
        let isQR = Fp.eql(tv5, Fp.ONE); // 12. isQR = tv5 == 1
        tv2 = Fp.mul(tv3, c7); // 13. tv2 = tv3 * c7
        tv5 = Fp.mul(tv4, tv1); // 14. tv5 = tv4 * tv1
        tv3 = Fp.cmov(tv2, tv3, isQR); // 15. tv3 = CMOV(tv2, tv3, isQR)
        tv4 = Fp.cmov(tv5, tv4, isQR); // 16. tv4 = CMOV(tv5, tv4, isQR)
        // 17. for i in (c1, c1 - 1, ..., 2):
        for(let i = c1; i > _1n; i--){
            let tv5 = i - _2n; // 18.    tv5 = i - 2
            tv5 = _2n << tv5 - _1n; // 19.    tv5 = 2^tv5
            let tvv5 = Fp.pow(tv4, tv5); // 20.    tv5 = tv4^tv5
            const e1 = Fp.eql(tvv5, Fp.ONE); // 21.    e1 = tv5 == 1
            tv2 = Fp.mul(tv3, tv1); // 22.    tv2 = tv3 * tv1
            tv1 = Fp.mul(tv1, tv1); // 23.    tv1 = tv1 * tv1
            tvv5 = Fp.mul(tv4, tv1); // 24.    tv5 = tv4 * tv1
            tv3 = Fp.cmov(tv2, tv3, e1); // 25.    tv3 = CMOV(tv2, tv3, e1)
            tv4 = Fp.cmov(tvv5, tv4, e1); // 26.    tv4 = CMOV(tv5, tv4, e1)
        }
        return {
            isValid: isQR,
            value: tv3
        };
    };
    if (Fp.ORDER % _4n === _3n) {
        // sqrt_ratio_3mod4(u, v)
        const c1 = (Fp.ORDER - _3n) / _4n; // 1. c1 = (q - 3) / 4     # Integer arithmetic
        const c2 = Fp.sqrt(Fp.neg(Z)); // 2. c2 = sqrt(-Z)
        sqrtRatio = (u, v)=>{
            let tv1 = Fp.sqr(v); // 1. tv1 = v^2
            const tv2 = Fp.mul(u, v); // 2. tv2 = u * v
            tv1 = Fp.mul(tv1, tv2); // 3. tv1 = tv1 * tv2
            let y1 = Fp.pow(tv1, c1); // 4. y1 = tv1^c1
            y1 = Fp.mul(y1, tv2); // 5. y1 = y1 * tv2
            const y2 = Fp.mul(y1, c2); // 6. y2 = y1 * c2
            const tv3 = Fp.mul(Fp.sqr(y1), v); // 7. tv3 = y1^2; 8. tv3 = tv3 * v
            const isQR = Fp.eql(tv3, u); // 9. isQR = tv3 == u
            let y = Fp.cmov(y2, y1, isQR); // 10. y = CMOV(y2, y1, isQR)
            return {
                isValid: isQR,
                value: y
            }; // 11. return (isQR, y) isQR ? y : y*c2
        };
    }
    // No curves uses that
    // if (Fp.ORDER % _8n === _5n) // sqrt_ratio_5mod8
    return sqrtRatio;
}
/**
 * Simplified Shallue-van de Woestijne-Ulas Method
 * https://www.rfc-editor.org/rfc/rfc9380#section-6.6.2
 */ function mapToCurveSimpleSWU(Fp, opts) {
    mod.validateField(Fp);
    if (!Fp.isValid(opts.A) || !Fp.isValid(opts.B) || !Fp.isValid(opts.Z)) throw new Error("mapToCurveSimpleSWU: invalid opts");
    const sqrtRatio = SWUFpSqrtRatio(Fp, opts.Z);
    if (!Fp.isOdd) throw new Error("Fp.isOdd is not implemented!");
    // Input: u, an element of F.
    // Output: (x, y), a point on E.
    return (u)=>{
        // prettier-ignore
        let tv1, tv2, tv3, tv4, tv5, tv6, x, y;
        tv1 = Fp.sqr(u); // 1.  tv1 = u^2
        tv1 = Fp.mul(tv1, opts.Z); // 2.  tv1 = Z * tv1
        tv2 = Fp.sqr(tv1); // 3.  tv2 = tv1^2
        tv2 = Fp.add(tv2, tv1); // 4.  tv2 = tv2 + tv1
        tv3 = Fp.add(tv2, Fp.ONE); // 5.  tv3 = tv2 + 1
        tv3 = Fp.mul(tv3, opts.B); // 6.  tv3 = B * tv3
        tv4 = Fp.cmov(opts.Z, Fp.neg(tv2), !Fp.eql(tv2, Fp.ZERO)); // 7.  tv4 = CMOV(Z, -tv2, tv2 != 0)
        tv4 = Fp.mul(tv4, opts.A); // 8.  tv4 = A * tv4
        tv2 = Fp.sqr(tv3); // 9.  tv2 = tv3^2
        tv6 = Fp.sqr(tv4); // 10. tv6 = tv4^2
        tv5 = Fp.mul(tv6, opts.A); // 11. tv5 = A * tv6
        tv2 = Fp.add(tv2, tv5); // 12. tv2 = tv2 + tv5
        tv2 = Fp.mul(tv2, tv3); // 13. tv2 = tv2 * tv3
        tv6 = Fp.mul(tv6, tv4); // 14. tv6 = tv6 * tv4
        tv5 = Fp.mul(tv6, opts.B); // 15. tv5 = B * tv6
        tv2 = Fp.add(tv2, tv5); // 16. tv2 = tv2 + tv5
        x = Fp.mul(tv1, tv3); // 17.   x = tv1 * tv3
        const { isValid, value } = sqrtRatio(tv2, tv6); // 18. (is_gx1_square, y1) = sqrt_ratio(tv2, tv6)
        y = Fp.mul(tv1, u); // 19.   y = tv1 * u  -> Z * u^3 * y1
        y = Fp.mul(y, value); // 20.   y = y * y1
        x = Fp.cmov(x, tv3, isValid); // 21.   x = CMOV(x, tv3, is_gx1_square)
        y = Fp.cmov(y, value, isValid); // 22.   y = CMOV(y, y1, is_gx1_square)
        const e1 = Fp.isOdd(u) === Fp.isOdd(y); // 23.  e1 = sgn0(u) == sgn0(y)
        y = Fp.cmov(Fp.neg(y), y, e1); // 24.   y = CMOV(-y, y, e1)
        x = Fp.div(x, tv4); // 25.   x = x / tv4
        return {
            x,
            y
        };
    };
}

},{"11f68d725b0f6f5d":"jVdcz","d8b1615c256fe3fa":"iu8hF","aae491f09795d5ee":"loicZ"}],"jVdcz":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.wNAF = wNAF;
exports.validateBasic = validateBasic;
/*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */ // Abelian group utilities
const modular_js_1 = require("72c8f755a25fddc3");
const utils_js_1 = require("f90fcba6ea31de55");
const _0n = BigInt(0);
const _1n = BigInt(1);
// Elliptic curve multiplication of Point by scalar. Fragile.
// Scalars should always be less than curve order: this should be checked inside of a curve itself.
// Creates precomputation tables for fast multiplication:
// - private scalar is split by fixed size windows of W bits
// - every window point is collected from window's table & added to accumulator
// - since windows are different, same point inside tables won't be accessed more than once per calc
// - each multiplication is 'Math.ceil(CURVE_ORDER / 𝑊) + 1' point additions (fixed for any scalar)
// - +1 window is neccessary for wNAF
// - wNAF reduces table size: 2x less memory + 2x faster generation, but 10% slower multiplication
// TODO: Research returning 2d JS array of windows, instead of a single window. This would allow
// windows to be in different memory locations
function wNAF(c, bits) {
    const constTimeNegate = (condition, item)=>{
        const neg = item.negate();
        return condition ? neg : item;
    };
    const opts = (W)=>{
        const windows = Math.ceil(bits / W) + 1; // +1, because
        const windowSize = 2 ** (W - 1); // -1 because we skip zero
        return {
            windows,
            windowSize
        };
    };
    return {
        constTimeNegate,
        // non-const time multiplication ladder
        unsafeLadder (elm, n) {
            let p = c.ZERO;
            let d = elm;
            while(n > _0n){
                if (n & _1n) p = p.add(d);
                d = d.double();
                n >>= _1n;
            }
            return p;
        },
        /**
         * Creates a wNAF precomputation window. Used for caching.
         * Default window size is set by `utils.precompute()` and is equal to 8.
         * Number of precomputed points depends on the curve size:
         * 2^(𝑊−1) * (Math.ceil(𝑛 / 𝑊) + 1), where:
         * - 𝑊 is the window size
         * - 𝑛 is the bitlength of the curve order.
         * For a 256-bit curve and window size 8, the number of precomputed points is 128 * 33 = 4224.
         * @returns precomputed point tables flattened to a single array
         */ precomputeWindow (elm, W) {
            const { windows, windowSize } = opts(W);
            const points = [];
            let p = elm;
            let base = p;
            for(let window = 0; window < windows; window++){
                base = p;
                points.push(base);
                // =1, because we skip zero
                for(let i = 1; i < windowSize; i++){
                    base = base.add(p);
                    points.push(base);
                }
                p = base.double();
            }
            return points;
        },
        /**
         * Implements ec multiplication using precomputed tables and w-ary non-adjacent form.
         * @param W window size
         * @param precomputes precomputed tables
         * @param n scalar (we don't check here, but should be less than curve order)
         * @returns real and fake (for const-time) points
         */ wNAF (W, precomputes, n) {
            // TODO: maybe check that scalar is less than group order? wNAF behavious is undefined otherwise
            // But need to carefully remove other checks before wNAF. ORDER == bits here
            const { windows, windowSize } = opts(W);
            let p = c.ZERO;
            let f = c.BASE;
            const mask = BigInt(2 ** W - 1); // Create mask with W ones: 0b1111 for W=4 etc.
            const maxNumber = 2 ** W;
            const shiftBy = BigInt(W);
            for(let window = 0; window < windows; window++){
                const offset = window * windowSize;
                // Extract W bits.
                let wbits = Number(n & mask);
                // Shift number by W bits.
                n >>= shiftBy;
                // If the bits are bigger than max size, we'll split those.
                // +224 => 256 - 32
                if (wbits > windowSize) {
                    wbits -= maxNumber;
                    n += _1n;
                }
                // This code was first written with assumption that 'f' and 'p' will never be infinity point:
                // since each addition is multiplied by 2 ** W, it cannot cancel each other. However,
                // there is negate now: it is possible that negated element from low value
                // would be the same as high element, which will create carry into next window.
                // It's not obvious how this can fail, but still worth investigating later.
                // Check if we're onto Zero point.
                // Add random point inside current window to f.
                const offset1 = offset;
                const offset2 = offset + Math.abs(wbits) - 1; // -1 because we skip zero
                const cond1 = window % 2 !== 0;
                const cond2 = wbits < 0;
                if (wbits === 0) // The most important part for const-time getPublicKey
                f = f.add(constTimeNegate(cond1, precomputes[offset1]));
                else p = p.add(constTimeNegate(cond2, precomputes[offset2]));
            }
            // JIT-compiler should not eliminate f here, since it will later be used in normalizeZ()
            // Even if the variable is still unused, there are some checks which will
            // throw an exception, so compiler needs to prove they won't happen, which is hard.
            // At this point there is a way to F be infinity-point even if p is not,
            // which makes it less const-time: around 1 bigint multiply.
            return {
                p,
                f
            };
        },
        wNAFCached (P, precomputesMap, n, transform) {
            // @ts-ignore
            const W = P._WINDOW_SIZE || 1;
            // Calculate precomputes on a first run, reuse them after
            let comp = precomputesMap.get(P);
            if (!comp) {
                comp = this.precomputeWindow(P, W);
                if (W !== 1) precomputesMap.set(P, transform(comp));
            }
            return this.wNAF(W, comp, n);
        }
    };
}
function validateBasic(curve) {
    (0, modular_js_1.validateField)(curve.Fp);
    (0, utils_js_1.validateObject)(curve, {
        n: "bigint",
        h: "bigint",
        Gx: "field",
        Gy: "field"
    }, {
        nBitLength: "isSafeInteger",
        nByteLength: "isSafeInteger"
    });
    // Set defaults
    return Object.freeze({
        ...(0, modular_js_1.nLength)(curve.n, curve.nBitLength),
        ...curve,
        p: curve.Fp.ORDER
    });
}

},{"72c8f755a25fddc3":"iu8hF","f90fcba6ea31de55":"loicZ"}],"iu8hF":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.isNegativeLE = void 0;
exports.mod = mod;
exports.pow = pow;
exports.pow2 = pow2;
exports.invert = invert;
exports.tonelliShanks = tonelliShanks;
exports.FpSqrt = FpSqrt;
exports.validateField = validateField;
exports.FpPow = FpPow;
exports.FpInvertBatch = FpInvertBatch;
exports.FpDiv = FpDiv;
exports.FpIsSquare = FpIsSquare;
exports.nLength = nLength;
exports.Field = Field;
exports.FpSqrtOdd = FpSqrtOdd;
exports.FpSqrtEven = FpSqrtEven;
exports.hashToPrivateScalar = hashToPrivateScalar;
exports.getFieldBytesLength = getFieldBytesLength;
exports.getMinHashLength = getMinHashLength;
exports.mapHashToField = mapHashToField;
/*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */ // Utilities for modular arithmetics and finite fields
const utils_js_1 = require("d8ac4b6c79c60614");
// prettier-ignore
const _0n = BigInt(0), _1n = BigInt(1), _2n = BigInt(2), _3n = BigInt(3);
// prettier-ignore
const _4n = BigInt(4), _5n = BigInt(5), _8n = BigInt(8);
// prettier-ignore
const _9n = BigInt(9), _16n = BigInt(16);
// Calculates a modulo b
function mod(a, b) {
    const result = a % b;
    return result >= _0n ? result : b + result;
}
/**
 * Efficiently raise num to power and do modular division.
 * Unsafe in some contexts: uses ladder, so can expose bigint bits.
 * @example
 * pow(2n, 6n, 11n) // 64n % 11n == 9n
 */ // TODO: use field version && remove
function pow(num, power, modulo) {
    if (modulo <= _0n || power < _0n) throw new Error("Expected power/modulo > 0");
    if (modulo === _1n) return _0n;
    let res = _1n;
    while(power > _0n){
        if (power & _1n) res = res * num % modulo;
        num = num * num % modulo;
        power >>= _1n;
    }
    return res;
}
// Does x ^ (2 ^ power) mod p. pow2(30, 4) == 30 ^ (2 ^ 4)
function pow2(x, power, modulo) {
    let res = x;
    while(power-- > _0n){
        res *= res;
        res %= modulo;
    }
    return res;
}
// Inverses number over modulo
function invert(number, modulo) {
    if (number === _0n || modulo <= _0n) throw new Error(`invert: expected positive integers, got n=${number} mod=${modulo}`);
    // Euclidean GCD https://brilliant.org/wiki/extended-euclidean-algorithm/
    // Fermat's little theorem "CT-like" version inv(n) = n^(m-2) mod m is 30x slower.
    let a = mod(number, modulo);
    let b = modulo;
    // prettier-ignore
    let x = _0n, y = _1n, u = _1n, v = _0n;
    while(a !== _0n){
        // JIT applies optimization if those two lines follow each other
        const q = b / a;
        const r = b % a;
        const m = x - u * q;
        const n = y - v * q;
        // prettier-ignore
        b = a, a = r, x = u, y = v, u = m, v = n;
    }
    const gcd = b;
    if (gcd !== _1n) throw new Error("invert: does not exist");
    return mod(x, modulo);
}
/**
 * Tonelli-Shanks square root search algorithm.
 * 1. https://eprint.iacr.org/2012/685.pdf (page 12)
 * 2. Square Roots from 1; 24, 51, 10 to Dan Shanks
 * Will start an infinite loop if field order P is not prime.
 * @param P field order
 * @returns function that takes field Fp (created from P) and number n
 */ function tonelliShanks(P) {
    // Legendre constant: used to calculate Legendre symbol (a | p),
    // which denotes the value of a^((p-1)/2) (mod p).
    // (a | p) ≡ 1    if a is a square (mod p)
    // (a | p) ≡ -1   if a is not a square (mod p)
    // (a | p) ≡ 0    if a ≡ 0 (mod p)
    const legendreC = (P - _1n) / _2n;
    let Q, S, Z;
    // Step 1: By factoring out powers of 2 from p - 1,
    // find q and s such that p - 1 = q*(2^s) with q odd
    for(Q = P - _1n, S = 0; Q % _2n === _0n; Q /= _2n, S++);
    // Step 2: Select a non-square z such that (z | p) ≡ -1 and set c ≡ zq
    for(Z = _2n; Z < P && pow(Z, legendreC, P) !== P - _1n; Z++);
    // Fast-path
    if (S === 1) {
        const p1div4 = (P + _1n) / _4n;
        return function tonelliFast(Fp, n) {
            const root = Fp.pow(n, p1div4);
            if (!Fp.eql(Fp.sqr(root), n)) throw new Error("Cannot find square root");
            return root;
        };
    }
    // Slow-path
    const Q1div2 = (Q + _1n) / _2n;
    return function tonelliSlow(Fp, n) {
        // Step 0: Check that n is indeed a square: (n | p) should not be ≡ -1
        if (Fp.pow(n, legendreC) === Fp.neg(Fp.ONE)) throw new Error("Cannot find square root");
        let r = S;
        // TODO: will fail at Fp2/etc
        let g = Fp.pow(Fp.mul(Fp.ONE, Z), Q); // will update both x and b
        let x = Fp.pow(n, Q1div2); // first guess at the square root
        let b = Fp.pow(n, Q); // first guess at the fudge factor
        while(!Fp.eql(b, Fp.ONE)){
            if (Fp.eql(b, Fp.ZERO)) return Fp.ZERO; // https://en.wikipedia.org/wiki/Tonelli%E2%80%93Shanks_algorithm (4. If t = 0, return r = 0)
            // Find m such b^(2^m)==1
            let m = 1;
            for(let t2 = Fp.sqr(b); m < r; m++){
                if (Fp.eql(t2, Fp.ONE)) break;
                t2 = Fp.sqr(t2); // t2 *= t2
            }
            // NOTE: r-m-1 can be bigger than 32, need to convert to bigint before shift, otherwise there will be overflow
            const ge = Fp.pow(g, _1n << BigInt(r - m - 1)); // ge = 2^(r-m-1)
            g = Fp.sqr(ge); // g = ge * ge
            x = Fp.mul(x, ge); // x *= ge
            b = Fp.mul(b, g); // b *= g
            r = m;
        }
        return x;
    };
}
function FpSqrt(P) {
    // NOTE: different algorithms can give different roots, it is up to user to decide which one they want.
    // For example there is FpSqrtOdd/FpSqrtEven to choice root based on oddness (used for hash-to-curve).
    // P ≡ 3 (mod 4)
    // √n = n^((P+1)/4)
    if (P % _4n === _3n) {
        // Not all roots possible!
        // const ORDER =
        //   0x1a0111ea397fe69a4b1ba7b6434bacd764774b84f38512bf6730d2a0f6b0f6241eabfffeb153ffffb9feffffffffaaabn;
        // const NUM = 72057594037927816n;
        const p1div4 = (P + _1n) / _4n;
        return function sqrt3mod4(Fp, n) {
            const root = Fp.pow(n, p1div4);
            // Throw if root**2 != n
            if (!Fp.eql(Fp.sqr(root), n)) throw new Error("Cannot find square root");
            return root;
        };
    }
    // Atkin algorithm for q ≡ 5 (mod 8), https://eprint.iacr.org/2012/685.pdf (page 10)
    if (P % _8n === _5n) {
        const c1 = (P - _5n) / _8n;
        return function sqrt5mod8(Fp, n) {
            const n2 = Fp.mul(n, _2n);
            const v = Fp.pow(n2, c1);
            const nv = Fp.mul(n, v);
            const i = Fp.mul(Fp.mul(nv, _2n), v);
            const root = Fp.mul(nv, Fp.sub(i, Fp.ONE));
            if (!Fp.eql(Fp.sqr(root), n)) throw new Error("Cannot find square root");
            return root;
        };
    }
    // P ≡ 9 (mod 16)
    _9n;
    // Other cases: Tonelli-Shanks algorithm
    return tonelliShanks(P);
}
// Little-endian check for first LE bit (last BE bit);
const isNegativeLE = (num, modulo)=>(mod(num, modulo) & _1n) === _1n;
exports.isNegativeLE = isNegativeLE;
// prettier-ignore
const FIELD_FIELDS = [
    "create",
    "isValid",
    "is0",
    "neg",
    "inv",
    "sqrt",
    "sqr",
    "eql",
    "add",
    "sub",
    "mul",
    "pow",
    "div",
    "addN",
    "subN",
    "mulN",
    "sqrN"
];
function validateField(field) {
    const initial = {
        ORDER: "bigint",
        MASK: "bigint",
        BYTES: "isSafeInteger",
        BITS: "isSafeInteger"
    };
    const opts = FIELD_FIELDS.reduce((map, val)=>{
        map[val] = "function";
        return map;
    }, initial);
    return (0, utils_js_1.validateObject)(field, opts);
}
// Generic field functions
/**
 * Same as `pow` but for Fp: non-constant-time.
 * Unsafe in some contexts: uses ladder, so can expose bigint bits.
 */ function FpPow(f, num, power) {
    // Should have same speed as pow for bigints
    // TODO: benchmark!
    if (power < _0n) throw new Error("Expected power > 0");
    if (power === _0n) return f.ONE;
    if (power === _1n) return num;
    let p = f.ONE;
    let d = num;
    while(power > _0n){
        if (power & _1n) p = f.mul(p, d);
        d = f.sqr(d);
        power >>= _1n;
    }
    return p;
}
/**
 * Efficiently invert an array of Field elements.
 * `inv(0)` will return `undefined` here: make sure to throw an error.
 */ function FpInvertBatch(f, nums) {
    const tmp = new Array(nums.length);
    // Walk from first to last, multiply them by each other MOD p
    const lastMultiplied = nums.reduce((acc, num, i)=>{
        if (f.is0(num)) return acc;
        tmp[i] = acc;
        return f.mul(acc, num);
    }, f.ONE);
    // Invert last element
    const inverted = f.inv(lastMultiplied);
    // Walk from last to first, multiply them by inverted each other MOD p
    nums.reduceRight((acc, num, i)=>{
        if (f.is0(num)) return acc;
        tmp[i] = f.mul(acc, tmp[i]);
        return f.mul(acc, num);
    }, inverted);
    return tmp;
}
function FpDiv(f, lhs, rhs) {
    return f.mul(lhs, typeof rhs === "bigint" ? invert(rhs, f.ORDER) : f.inv(rhs));
}
// This function returns True whenever the value x is a square in the field F.
function FpIsSquare(f) {
    const legendreConst = (f.ORDER - _1n) / _2n; // Integer arithmetic
    return (x)=>{
        const p = f.pow(x, legendreConst);
        return f.eql(p, f.ZERO) || f.eql(p, f.ONE);
    };
}
// CURVE.n lengths
function nLength(n, nBitLength) {
    // Bit size, byte size of CURVE.n
    const _nBitLength = nBitLength !== undefined ? nBitLength : n.toString(2).length;
    const nByteLength = Math.ceil(_nBitLength / 8);
    return {
        nBitLength: _nBitLength,
        nByteLength
    };
}
/**
 * Initializes a finite field over prime. **Non-primes are not supported.**
 * Do not init in loop: slow. Very fragile: always run a benchmark on a change.
 * Major performance optimizations:
 * * a) denormalized operations like mulN instead of mul
 * * b) same object shape: never add or remove keys
 * * c) Object.freeze
 * @param ORDER prime positive bigint
 * @param bitLen how many bits the field consumes
 * @param isLE (def: false) if encoding / decoding should be in little-endian
 * @param redef optional faster redefinitions of sqrt and other methods
 */ function Field(ORDER, bitLen, isLE = false, redef = {}) {
    if (ORDER <= _0n) throw new Error(`Expected Field ORDER > 0, got ${ORDER}`);
    const { nBitLength: BITS, nByteLength: BYTES } = nLength(ORDER, bitLen);
    if (BYTES > 2048) throw new Error("Field lengths over 2048 bytes are not supported");
    const sqrtP = FpSqrt(ORDER);
    const f = Object.freeze({
        ORDER,
        BITS,
        BYTES,
        MASK: (0, utils_js_1.bitMask)(BITS),
        ZERO: _0n,
        ONE: _1n,
        create: (num)=>mod(num, ORDER),
        isValid: (num)=>{
            if (typeof num !== "bigint") throw new Error(`Invalid field element: expected bigint, got ${typeof num}`);
            return _0n <= num && num < ORDER; // 0 is valid element, but it's not invertible
        },
        is0: (num)=>num === _0n,
        isOdd: (num)=>(num & _1n) === _1n,
        neg: (num)=>mod(-num, ORDER),
        eql: (lhs, rhs)=>lhs === rhs,
        sqr: (num)=>mod(num * num, ORDER),
        add: (lhs, rhs)=>mod(lhs + rhs, ORDER),
        sub: (lhs, rhs)=>mod(lhs - rhs, ORDER),
        mul: (lhs, rhs)=>mod(lhs * rhs, ORDER),
        pow: (num, power)=>FpPow(f, num, power),
        div: (lhs, rhs)=>mod(lhs * invert(rhs, ORDER), ORDER),
        // Same as above, but doesn't normalize
        sqrN: (num)=>num * num,
        addN: (lhs, rhs)=>lhs + rhs,
        subN: (lhs, rhs)=>lhs - rhs,
        mulN: (lhs, rhs)=>lhs * rhs,
        inv: (num)=>invert(num, ORDER),
        sqrt: redef.sqrt || ((n)=>sqrtP(f, n)),
        invertBatch: (lst)=>FpInvertBatch(f, lst),
        // TODO: do we really need constant cmov?
        // We don't have const-time bigints anyway, so probably will be not very useful
        cmov: (a, b, c)=>c ? b : a,
        toBytes: (num)=>isLE ? (0, utils_js_1.numberToBytesLE)(num, BYTES) : (0, utils_js_1.numberToBytesBE)(num, BYTES),
        fromBytes: (bytes)=>{
            if (bytes.length !== BYTES) throw new Error(`Fp.fromBytes: expected ${BYTES}, got ${bytes.length}`);
            return isLE ? (0, utils_js_1.bytesToNumberLE)(bytes) : (0, utils_js_1.bytesToNumberBE)(bytes);
        }
    });
    return Object.freeze(f);
}
function FpSqrtOdd(Fp, elm) {
    if (!Fp.isOdd) throw new Error(`Field doesn't have isOdd`);
    const root = Fp.sqrt(elm);
    return Fp.isOdd(root) ? root : Fp.neg(root);
}
function FpSqrtEven(Fp, elm) {
    if (!Fp.isOdd) throw new Error(`Field doesn't have isOdd`);
    const root = Fp.sqrt(elm);
    return Fp.isOdd(root) ? Fp.neg(root) : root;
}
/**
 * "Constant-time" private key generation utility.
 * Same as mapKeyToField, but accepts less bytes (40 instead of 48 for 32-byte field).
 * Which makes it slightly more biased, less secure.
 * @deprecated use mapKeyToField instead
 */ function hashToPrivateScalar(hash, groupOrder, isLE = false) {
    hash = (0, utils_js_1.ensureBytes)("privateHash", hash);
    const hashLen = hash.length;
    const minLen = nLength(groupOrder).nByteLength + 8;
    if (minLen < 24 || hashLen < minLen || hashLen > 1024) throw new Error(`hashToPrivateScalar: expected ${minLen}-1024 bytes of input, got ${hashLen}`);
    const num = isLE ? (0, utils_js_1.bytesToNumberLE)(hash) : (0, utils_js_1.bytesToNumberBE)(hash);
    return mod(num, groupOrder - _1n) + _1n;
}
/**
 * Returns total number of bytes consumed by the field element.
 * For example, 32 bytes for usual 256-bit weierstrass curve.
 * @param fieldOrder number of field elements, usually CURVE.n
 * @returns byte length of field
 */ function getFieldBytesLength(fieldOrder) {
    if (typeof fieldOrder !== "bigint") throw new Error("field order must be bigint");
    const bitLength = fieldOrder.toString(2).length;
    return Math.ceil(bitLength / 8);
}
/**
 * Returns minimal amount of bytes that can be safely reduced
 * by field order.
 * Should be 2^-128 for 128-bit curve such as P256.
 * @param fieldOrder number of field elements, usually CURVE.n
 * @returns byte length of target hash
 */ function getMinHashLength(fieldOrder) {
    const length = getFieldBytesLength(fieldOrder);
    return length + Math.ceil(length / 2);
}
/**
 * "Constant-time" private key generation utility.
 * Can take (n + n/2) or more bytes of uniform input e.g. from CSPRNG or KDF
 * and convert them into private scalar, with the modulo bias being negligible.
 * Needs at least 48 bytes of input for 32-byte private key.
 * https://research.kudelskisecurity.com/2020/07/28/the-definitive-guide-to-modulo-bias-and-how-to-avoid-it/
 * FIPS 186-5, A.2 https://csrc.nist.gov/publications/detail/fips/186/5/final
 * RFC 9380, https://www.rfc-editor.org/rfc/rfc9380#section-5
 * @param hash hash output from SHA3 or a similar function
 * @param groupOrder size of subgroup - (e.g. secp256k1.CURVE.n)
 * @param isLE interpret hash bytes as LE num
 * @returns valid private scalar
 */ function mapHashToField(key, fieldOrder, isLE = false) {
    const len = key.length;
    const fieldLen = getFieldBytesLength(fieldOrder);
    const minLen = getMinHashLength(fieldOrder);
    // No small numbers: need to understand bias story. No huge numbers: easier to detect JS timings.
    if (len < 16 || len < minLen || len > 1024) throw new Error(`expected ${minLen}-1024 bytes of input, got ${len}`);
    const num = isLE ? (0, utils_js_1.bytesToNumberBE)(key) : (0, utils_js_1.bytesToNumberLE)(key);
    // `mod(x, 11)` can sometimes produce 0. `mod(x, 10) + 1` is the same, but no 0
    const reduced = mod(num, fieldOrder - _1n) + _1n;
    return isLE ? (0, utils_js_1.numberToBytesLE)(reduced, fieldLen) : (0, utils_js_1.numberToBytesBE)(reduced, fieldLen);
}

},{"d8ac4b6c79c60614":"loicZ"}],"loicZ":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.bitMask = void 0;
exports.isBytes = isBytes;
exports.abytes = abytes;
exports.bytesToHex = bytesToHex;
exports.numberToHexUnpadded = numberToHexUnpadded;
exports.hexToNumber = hexToNumber;
exports.hexToBytes = hexToBytes;
exports.bytesToNumberBE = bytesToNumberBE;
exports.bytesToNumberLE = bytesToNumberLE;
exports.numberToBytesBE = numberToBytesBE;
exports.numberToBytesLE = numberToBytesLE;
exports.numberToVarBytesBE = numberToVarBytesBE;
exports.ensureBytes = ensureBytes;
exports.concatBytes = concatBytes;
exports.equalBytes = equalBytes;
exports.utf8ToBytes = utf8ToBytes;
exports.bitLen = bitLen;
exports.bitGet = bitGet;
exports.bitSet = bitSet;
exports.createHmacDrbg = createHmacDrbg;
exports.validateObject = validateObject;
/*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */ // 100 lines of code in the file are duplicated from noble-hashes (utils).
// This is OK: `abstract` directory does not use noble-hashes.
// User may opt-in into using different hashing library. This way, noble-hashes
// won't be included into their bundle.
const _0n = /* @__PURE__ */ BigInt(0);
const _1n = /* @__PURE__ */ BigInt(1);
const _2n = /* @__PURE__ */ BigInt(2);
function isBytes(a) {
    return a instanceof Uint8Array || a != null && typeof a === "object" && a.constructor.name === "Uint8Array";
}
function abytes(item) {
    if (!isBytes(item)) throw new Error("Uint8Array expected");
}
// Array where index 0xf0 (240) is mapped to string 'f0'
const hexes = /* @__PURE__ */ Array.from({
    length: 256
}, (_, i)=>i.toString(16).padStart(2, "0"));
/**
 * @example bytesToHex(Uint8Array.from([0xca, 0xfe, 0x01, 0x23])) // 'cafe0123'
 */ function bytesToHex(bytes) {
    abytes(bytes);
    // pre-caching improves the speed 6x
    let hex = "";
    for(let i = 0; i < bytes.length; i++)hex += hexes[bytes[i]];
    return hex;
}
function numberToHexUnpadded(num) {
    const hex = num.toString(16);
    return hex.length & 1 ? `0${hex}` : hex;
}
function hexToNumber(hex) {
    if (typeof hex !== "string") throw new Error("hex string expected, got " + typeof hex);
    // Big Endian
    return BigInt(hex === "" ? "0" : `0x${hex}`);
}
// We use optimized technique to convert hex string to byte array
const asciis = {
    _0: 48,
    _9: 57,
    _A: 65,
    _F: 70,
    _a: 97,
    _f: 102
};
function asciiToBase16(char) {
    if (char >= asciis._0 && char <= asciis._9) return char - asciis._0;
    if (char >= asciis._A && char <= asciis._F) return char - (asciis._A - 10);
    if (char >= asciis._a && char <= asciis._f) return char - (asciis._a - 10);
    return;
}
/**
 * @example hexToBytes('cafe0123') // Uint8Array.from([0xca, 0xfe, 0x01, 0x23])
 */ function hexToBytes(hex) {
    if (typeof hex !== "string") throw new Error("hex string expected, got " + typeof hex);
    const hl = hex.length;
    const al = hl / 2;
    if (hl % 2) throw new Error("padded hex string expected, got unpadded hex of length " + hl);
    const array = new Uint8Array(al);
    for(let ai = 0, hi = 0; ai < al; ai++, hi += 2){
        const n1 = asciiToBase16(hex.charCodeAt(hi));
        const n2 = asciiToBase16(hex.charCodeAt(hi + 1));
        if (n1 === undefined || n2 === undefined) {
            const char = hex[hi] + hex[hi + 1];
            throw new Error('hex string expected, got non-hex character "' + char + '" at index ' + hi);
        }
        array[ai] = n1 * 16 + n2;
    }
    return array;
}
// BE: Big Endian, LE: Little Endian
function bytesToNumberBE(bytes) {
    return hexToNumber(bytesToHex(bytes));
}
function bytesToNumberLE(bytes) {
    abytes(bytes);
    return hexToNumber(bytesToHex(Uint8Array.from(bytes).reverse()));
}
function numberToBytesBE(n, len) {
    return hexToBytes(n.toString(16).padStart(len * 2, "0"));
}
function numberToBytesLE(n, len) {
    return numberToBytesBE(n, len).reverse();
}
// Unpadded, rarely used
function numberToVarBytesBE(n) {
    return hexToBytes(numberToHexUnpadded(n));
}
/**
 * Takes hex string or Uint8Array, converts to Uint8Array.
 * Validates output length.
 * Will throw error for other types.
 * @param title descriptive title for an error e.g. 'private key'
 * @param hex hex string or Uint8Array
 * @param expectedLength optional, will compare to result array's length
 * @returns
 */ function ensureBytes(title, hex, expectedLength) {
    let res;
    if (typeof hex === "string") try {
        res = hexToBytes(hex);
    } catch (e) {
        throw new Error(`${title} must be valid hex string, got "${hex}". Cause: ${e}`);
    }
    else if (isBytes(hex)) // Uint8Array.from() instead of hash.slice() because node.js Buffer
    // is instance of Uint8Array, and its slice() creates **mutable** copy
    res = Uint8Array.from(hex);
    else throw new Error(`${title} must be hex string or Uint8Array`);
    const len = res.length;
    if (typeof expectedLength === "number" && len !== expectedLength) throw new Error(`${title} expected ${expectedLength} bytes, got ${len}`);
    return res;
}
/**
 * Copies several Uint8Arrays into one.
 */ function concatBytes(...arrays) {
    let sum = 0;
    for(let i = 0; i < arrays.length; i++){
        const a = arrays[i];
        abytes(a);
        sum += a.length;
    }
    const res = new Uint8Array(sum);
    for(let i = 0, pad = 0; i < arrays.length; i++){
        const a = arrays[i];
        res.set(a, pad);
        pad += a.length;
    }
    return res;
}
// Compares 2 u8a-s in kinda constant time
function equalBytes(a, b) {
    if (a.length !== b.length) return false;
    let diff = 0;
    for(let i = 0; i < a.length; i++)diff |= a[i] ^ b[i];
    return diff === 0;
}
/**
 * @example utf8ToBytes('abc') // new Uint8Array([97, 98, 99])
 */ function utf8ToBytes(str) {
    if (typeof str !== "string") throw new Error(`utf8ToBytes expected string, got ${typeof str}`);
    return new Uint8Array(new TextEncoder().encode(str)); // https://bugzil.la/1681809
}
// Bit operations
/**
 * Calculates amount of bits in a bigint.
 * Same as `n.toString(2).length`
 */ function bitLen(n) {
    let len;
    for(len = 0; n > _0n; n >>= _1n, len += 1);
    return len;
}
/**
 * Gets single bit at position.
 * NOTE: first bit position is 0 (same as arrays)
 * Same as `!!+Array.from(n.toString(2)).reverse()[pos]`
 */ function bitGet(n, pos) {
    return n >> BigInt(pos) & _1n;
}
/**
 * Sets single bit at position.
 */ function bitSet(n, pos, value) {
    return n | (value ? _1n : _0n) << BigInt(pos);
}
/**
 * Calculate mask for N bits. Not using ** operator with bigints because of old engines.
 * Same as BigInt(`0b${Array(i).fill('1').join('')}`)
 */ const bitMask = (n)=>(_2n << BigInt(n - 1)) - _1n;
exports.bitMask = bitMask;
// DRBG
const u8n = (data)=>new Uint8Array(data); // creates Uint8Array
const u8fr = (arr)=>Uint8Array.from(arr); // another shortcut
/**
 * Minimal HMAC-DRBG from NIST 800-90 for RFC6979 sigs.
 * @returns function that will call DRBG until 2nd arg returns something meaningful
 * @example
 *   const drbg = createHmacDRBG<Key>(32, 32, hmac);
 *   drbg(seed, bytesToKey); // bytesToKey must return Key or undefined
 */ function createHmacDrbg(hashLen, qByteLen, hmacFn) {
    if (typeof hashLen !== "number" || hashLen < 2) throw new Error("hashLen must be a number");
    if (typeof qByteLen !== "number" || qByteLen < 2) throw new Error("qByteLen must be a number");
    if (typeof hmacFn !== "function") throw new Error("hmacFn must be a function");
    // Step B, Step C: set hashLen to 8*ceil(hlen/8)
    let v = u8n(hashLen); // Minimal non-full-spec HMAC-DRBG from NIST 800-90 for RFC6979 sigs.
    let k = u8n(hashLen); // Steps B and C of RFC6979 3.2: set hashLen, in our case always same
    let i = 0; // Iterations counter, will throw when over 1000
    const reset = ()=>{
        v.fill(1);
        k.fill(0);
        i = 0;
    };
    const h = (...b)=>hmacFn(k, v, ...b); // hmac(k)(v, ...values)
    const reseed = (seed = u8n())=>{
        // HMAC-DRBG reseed() function. Steps D-G
        k = h(u8fr([
            0x00
        ]), seed); // k = hmac(k || v || 0x00 || seed)
        v = h(); // v = hmac(k || v)
        if (seed.length === 0) return;
        k = h(u8fr([
            0x01
        ]), seed); // k = hmac(k || v || 0x01 || seed)
        v = h(); // v = hmac(k || v)
    };
    const gen = ()=>{
        // HMAC-DRBG generate() function
        if (i++ >= 1000) throw new Error("drbg: tried 1000 values");
        let len = 0;
        const out = [];
        while(len < qByteLen){
            v = h();
            const sl = v.slice();
            out.push(sl);
            len += v.length;
        }
        return concatBytes(...out);
    };
    const genUntil = (seed, pred)=>{
        reset();
        reseed(seed); // Steps D-G
        let res = undefined; // Step H: grind until k is in [1..n-1]
        while(!(res = pred(gen())))reseed();
        reset();
        return res;
    };
    return genUntil;
}
// Validating curves and fields
const validatorFns = {
    bigint: (val)=>typeof val === "bigint",
    function: (val)=>typeof val === "function",
    boolean: (val)=>typeof val === "boolean",
    string: (val)=>typeof val === "string",
    stringOrUint8Array: (val)=>typeof val === "string" || isBytes(val),
    isSafeInteger: (val)=>Number.isSafeInteger(val),
    array: (val)=>Array.isArray(val),
    field: (val, object)=>object.Fp.isValid(val),
    hash: (val)=>typeof val === "function" && Number.isSafeInteger(val.outputLen)
};
// type Record<K extends string | number | symbol, T> = { [P in K]: T; }
function validateObject(object, validators, optValidators = {}) {
    const checkField = (fieldName, type, isOptional)=>{
        const checkVal = validatorFns[type];
        if (typeof checkVal !== "function") throw new Error(`Invalid validator "${type}", expected function`);
        const val = object[fieldName];
        if (isOptional && val === undefined) return;
        if (!checkVal(val, object)) throw new Error(`Invalid param ${String(fieldName)}=${val} (${typeof val}), expected ${type}`);
    };
    for (const [fieldName, type] of Object.entries(validators))checkField(fieldName, type, false);
    for (const [fieldName, type] of Object.entries(optValidators))checkField(fieldName, type, true);
    return object;
} // validate type tests
 // const o: { a: number; b: number; c: number } = { a: 1, b: 5, c: 6 };
 // const z0 = validateObject(o, { a: 'isSafeInteger' }, { c: 'bigint' }); // Ok!
 // // Should fail type-check
 // const z1 = validateObject(o, { a: 'tmp' }, { c: 'zz' });
 // const z2 = validateObject(o, { a: 'isSafeInteger' }, { c: 'zz' });
 // const z3 = validateObject(o, { test: 'boolean', z: 'bug' });
 // const z4 = validateObject(o, { a: 'boolean', z: 'bug' });

},{}],"bBhTF":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.expand_message_xmd = expand_message_xmd;
exports.expand_message_xof = expand_message_xof;
exports.hash_to_field = hash_to_field;
exports.isogenyMap = isogenyMap;
exports.createHasher = createHasher;
const modular_js_1 = require("eccb35e649679ca");
const utils_js_1 = require("202487820f28c009");
// Octet Stream to Integer. "spec" implementation of os2ip is 2.5x slower vs bytesToNumberBE.
const os2ip = utils_js_1.bytesToNumberBE;
// Integer to Octet Stream (numberToBytesBE)
function i2osp(value, length) {
    if (value < 0 || value >= 1 << 8 * length) throw new Error(`bad I2OSP call: value=${value} length=${length}`);
    const res = Array.from({
        length
    }).fill(0);
    for(let i = length - 1; i >= 0; i--){
        res[i] = value & 0xff;
        value >>>= 8;
    }
    return new Uint8Array(res);
}
function strxor(a, b) {
    const arr = new Uint8Array(a.length);
    for(let i = 0; i < a.length; i++)arr[i] = a[i] ^ b[i];
    return arr;
}
function anum(item) {
    if (!Number.isSafeInteger(item)) throw new Error("number expected");
}
// Produces a uniformly random byte string using a cryptographic hash function H that outputs b bits
// https://www.rfc-editor.org/rfc/rfc9380#section-5.3.1
function expand_message_xmd(msg, DST, lenInBytes, H) {
    (0, utils_js_1.abytes)(msg);
    (0, utils_js_1.abytes)(DST);
    anum(lenInBytes);
    // https://www.rfc-editor.org/rfc/rfc9380#section-5.3.3
    if (DST.length > 255) DST = H((0, utils_js_1.concatBytes)((0, utils_js_1.utf8ToBytes)("H2C-OVERSIZE-DST-"), DST));
    const { outputLen: b_in_bytes, blockLen: r_in_bytes } = H;
    const ell = Math.ceil(lenInBytes / b_in_bytes);
    if (ell > 255) throw new Error("Invalid xmd length");
    const DST_prime = (0, utils_js_1.concatBytes)(DST, i2osp(DST.length, 1));
    const Z_pad = i2osp(0, r_in_bytes);
    const l_i_b_str = i2osp(lenInBytes, 2); // len_in_bytes_str
    const b = new Array(ell);
    const b_0 = H((0, utils_js_1.concatBytes)(Z_pad, msg, l_i_b_str, i2osp(0, 1), DST_prime));
    b[0] = H((0, utils_js_1.concatBytes)(b_0, i2osp(1, 1), DST_prime));
    for(let i = 1; i <= ell; i++){
        const args = [
            strxor(b_0, b[i - 1]),
            i2osp(i + 1, 1),
            DST_prime
        ];
        b[i] = H((0, utils_js_1.concatBytes)(...args));
    }
    const pseudo_random_bytes = (0, utils_js_1.concatBytes)(...b);
    return pseudo_random_bytes.slice(0, lenInBytes);
}
// Produces a uniformly random byte string using an extendable-output function (XOF) H.
// 1. The collision resistance of H MUST be at least k bits.
// 2. H MUST be an XOF that has been proved indifferentiable from
//    a random oracle under a reasonable cryptographic assumption.
// https://www.rfc-editor.org/rfc/rfc9380#section-5.3.2
function expand_message_xof(msg, DST, lenInBytes, k, H) {
    (0, utils_js_1.abytes)(msg);
    (0, utils_js_1.abytes)(DST);
    anum(lenInBytes);
    // https://www.rfc-editor.org/rfc/rfc9380#section-5.3.3
    // DST = H('H2C-OVERSIZE-DST-' || a_very_long_DST, Math.ceil((lenInBytes * k) / 8));
    if (DST.length > 255) {
        const dkLen = Math.ceil(2 * k / 8);
        DST = H.create({
            dkLen
        }).update((0, utils_js_1.utf8ToBytes)("H2C-OVERSIZE-DST-")).update(DST).digest();
    }
    if (lenInBytes > 65535 || DST.length > 255) throw new Error("expand_message_xof: invalid lenInBytes");
    return H.create({
        dkLen: lenInBytes
    }).update(msg).update(i2osp(lenInBytes, 2))// 2. DST_prime = DST || I2OSP(len(DST), 1)
    .update(DST).update(i2osp(DST.length, 1)).digest();
}
/**
 * Hashes arbitrary-length byte strings to a list of one or more elements of a finite field F
 * https://www.rfc-editor.org/rfc/rfc9380#section-5.2
 * @param msg a byte string containing the message to hash
 * @param count the number of elements of F to output
 * @param options `{DST: string, p: bigint, m: number, k: number, expand: 'xmd' | 'xof', hash: H}`, see above
 * @returns [u_0, ..., u_(count - 1)], a list of field elements.
 */ function hash_to_field(msg, count, options) {
    (0, utils_js_1.validateObject)(options, {
        DST: "stringOrUint8Array",
        p: "bigint",
        m: "isSafeInteger",
        k: "isSafeInteger",
        hash: "hash"
    });
    const { p, k, m, hash, expand, DST: _DST } = options;
    (0, utils_js_1.abytes)(msg);
    anum(count);
    const DST = typeof _DST === "string" ? (0, utils_js_1.utf8ToBytes)(_DST) : _DST;
    const log2p = p.toString(2).length;
    const L = Math.ceil((log2p + k) / 8); // section 5.1 of ietf draft link above
    const len_in_bytes = count * m * L;
    let prb; // pseudo_random_bytes
    if (expand === "xmd") prb = expand_message_xmd(msg, DST, len_in_bytes, hash);
    else if (expand === "xof") prb = expand_message_xof(msg, DST, len_in_bytes, k, hash);
    else if (expand === "_internal_pass") // for internal tests only
    prb = msg;
    else throw new Error('expand must be "xmd" or "xof"');
    const u = new Array(count);
    for(let i = 0; i < count; i++){
        const e = new Array(m);
        for(let j = 0; j < m; j++){
            const elm_offset = L * (j + i * m);
            const tv = prb.subarray(elm_offset, elm_offset + L);
            e[j] = (0, modular_js_1.mod)(os2ip(tv), p);
        }
        u[i] = e;
    }
    return u;
}
function isogenyMap(field, map) {
    // Make same order as in spec
    const COEFF = map.map((i)=>Array.from(i).reverse());
    return (x, y)=>{
        const [xNum, xDen, yNum, yDen] = COEFF.map((val)=>val.reduce((acc, i)=>field.add(field.mul(acc, x), i)));
        x = field.div(xNum, xDen); // xNum / xDen
        y = field.mul(y, field.div(yNum, yDen)); // y * (yNum / yDev)
        return {
            x,
            y
        };
    };
}
function createHasher(Point, mapToCurve, def) {
    if (typeof mapToCurve !== "function") throw new Error("mapToCurve() must be defined");
    return {
        // Encodes byte string to elliptic curve.
        // hash_to_curve from https://www.rfc-editor.org/rfc/rfc9380#section-3
        hashToCurve (msg, options) {
            const u = hash_to_field(msg, 2, {
                ...def,
                DST: def.DST,
                ...options
            });
            const u0 = Point.fromAffine(mapToCurve(u[0]));
            const u1 = Point.fromAffine(mapToCurve(u[1]));
            const P = u0.add(u1).clearCofactor();
            P.assertValidity();
            return P;
        },
        // Encodes byte string to elliptic curve.
        // encode_to_curve from https://www.rfc-editor.org/rfc/rfc9380#section-3
        encodeToCurve (msg, options) {
            const u = hash_to_field(msg, 1, {
                ...def,
                DST: def.encodeDST,
                ...options
            });
            const P = Point.fromAffine(mapToCurve(u[0])).clearCofactor();
            P.assertValidity();
            return P;
        },
        // Same as encodeToCurve, but without hash
        mapToCurve (scalars) {
            if (!Array.isArray(scalars)) throw new Error("mapToCurve: expected array of bigints");
            for (const i of scalars)if (typeof i !== "bigint") throw new Error(`mapToCurve: expected array of bigints, got ${i} in array`);
            const P = Point.fromAffine(mapToCurve(scalars)).clearCofactor();
            P.assertValidity();
            return P;
        }
    };
}

},{"eccb35e649679ca":"iu8hF","202487820f28c009":"loicZ"}],"dc499":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.GWEI_TO_WEI = void 0;
/** Easy conversion from Gwei to wei */ exports.GWEI_TO_WEI = BigInt(1000000000);

},{}],"9gMXk":[function(require,module,exports) {
var Buffer = require("e2c3a6bbeddb5fc1").Buffer;
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.accountBodyToRLP = exports.accountBodyToSlim = exports.accountBodyFromSlim = exports.isZeroAddress = exports.zeroAddress = exports.importPublic = exports.privateToAddress = exports.privateToPublic = exports.publicToAddress = exports.pubToAddress = exports.isValidPublic = exports.isValidPrivate = exports.generateAddress2 = exports.generateAddress = exports.isValidChecksumAddress = exports.toChecksumAddress = exports.isValidAddress = exports.Account = void 0;
const rlp_1 = require("35ca2ee31c7879db");
const keccak_1 = require("bcbed7211a54d14e");
const secp256k1_1 = require("b33049b23a1844ca");
const utils_1 = require("bd2e3cfed4f0b9b0");
const bytes_1 = require("adba5876ab1194d5");
const constants_1 = require("5e5bf220267536c2");
const helpers_1 = require("9b6806e6768d889b");
const internal_1 = require("918e37cf52018f67");
const _0n = BigInt(0);
class Account {
    /**
     * This constructor assigns and validates the values.
     * Use the static factory methods to assist in creating an Account from varying data types.
     */ constructor(nonce = _0n, balance = _0n, storageRoot = constants_1.KECCAK256_RLP, codeHash = constants_1.KECCAK256_NULL){
        this.nonce = nonce;
        this.balance = balance;
        this.storageRoot = storageRoot;
        this.codeHash = codeHash;
        this._validate();
    }
    static fromAccountData(accountData) {
        const { nonce, balance, storageRoot, codeHash } = accountData;
        return new Account(nonce !== undefined ? (0, bytes_1.bufferToBigInt)((0, bytes_1.toBuffer)(nonce)) : undefined, balance !== undefined ? (0, bytes_1.bufferToBigInt)((0, bytes_1.toBuffer)(balance)) : undefined, storageRoot !== undefined ? (0, bytes_1.toBuffer)(storageRoot) : undefined, codeHash !== undefined ? (0, bytes_1.toBuffer)(codeHash) : undefined);
    }
    static fromRlpSerializedAccount(serialized) {
        const values = (0, bytes_1.arrToBufArr)(rlp_1.RLP.decode(Uint8Array.from(serialized)));
        if (!Array.isArray(values)) throw new Error("Invalid serialized account input. Must be array");
        return this.fromValuesArray(values);
    }
    static fromValuesArray(values) {
        const [nonce, balance, storageRoot, codeHash] = values;
        return new Account((0, bytes_1.bufferToBigInt)(nonce), (0, bytes_1.bufferToBigInt)(balance), storageRoot, codeHash);
    }
    _validate() {
        if (this.nonce < _0n) throw new Error("nonce must be greater than zero");
        if (this.balance < _0n) throw new Error("balance must be greater than zero");
        if (this.storageRoot.length !== 32) throw new Error("storageRoot must have a length of 32");
        if (this.codeHash.length !== 32) throw new Error("codeHash must have a length of 32");
    }
    /**
     * Returns a Buffer Array of the raw Buffers for the account, in order.
     */ raw() {
        return [
            (0, bytes_1.bigIntToUnpaddedBuffer)(this.nonce),
            (0, bytes_1.bigIntToUnpaddedBuffer)(this.balance),
            this.storageRoot,
            this.codeHash
        ];
    }
    /**
     * Returns the RLP serialization of the account as a `Buffer`.
     */ serialize() {
        return Buffer.from(rlp_1.RLP.encode((0, bytes_1.bufArrToArr)(this.raw())));
    }
    /**
     * Returns a `Boolean` determining if the account is a contract.
     */ isContract() {
        return !this.codeHash.equals(constants_1.KECCAK256_NULL);
    }
    /**
     * Returns a `Boolean` determining if the account is empty complying to the definition of
     * account emptiness in [EIP-161](https://eips.ethereum.org/EIPS/eip-161):
     * "An account is considered empty when it has no code and zero nonce and zero balance."
     */ isEmpty() {
        return this.balance === _0n && this.nonce === _0n && this.codeHash.equals(constants_1.KECCAK256_NULL);
    }
}
exports.Account = Account;
/**
 * Checks if the address is a valid. Accepts checksummed addresses too.
 */ const isValidAddress = function(hexAddress) {
    try {
        (0, helpers_1.assertIsString)(hexAddress);
    } catch (e) {
        return false;
    }
    return /^0x[0-9a-fA-F]{40}$/.test(hexAddress);
};
exports.isValidAddress = isValidAddress;
/**
 * Returns a checksummed address.
 *
 * If an eip1191ChainId is provided, the chainId will be included in the checksum calculation. This
 * has the effect of checksummed addresses for one chain having invalid checksums for others.
 * For more details see [EIP-1191](https://eips.ethereum.org/EIPS/eip-1191).
 *
 * WARNING: Checksums with and without the chainId will differ and the EIP-1191 checksum is not
 * backwards compatible to the original widely adopted checksum format standard introduced in
 * [EIP-55](https://eips.ethereum.org/EIPS/eip-55), so this will break in existing applications.
 * Usage of this EIP is therefore discouraged unless you have a very targeted use case.
 */ const toChecksumAddress = function(hexAddress, eip1191ChainId) {
    (0, helpers_1.assertIsHexString)(hexAddress);
    const address = (0, internal_1.stripHexPrefix)(hexAddress).toLowerCase();
    let prefix = "";
    if (eip1191ChainId !== undefined) {
        const chainId = (0, bytes_1.bufferToBigInt)((0, bytes_1.toBuffer)(eip1191ChainId));
        prefix = chainId.toString() + "0x";
    }
    const buf = Buffer.from(prefix + address, "utf8");
    const hash = (0, utils_1.bytesToHex)((0, keccak_1.keccak256)(buf));
    let ret = "0x";
    for(let i = 0; i < address.length; i++)if (parseInt(hash[i], 16) >= 8) ret += address[i].toUpperCase();
    else ret += address[i];
    return ret;
};
exports.toChecksumAddress = toChecksumAddress;
/**
 * Checks if the address is a valid checksummed address.
 *
 * See toChecksumAddress' documentation for details about the eip1191ChainId parameter.
 */ const isValidChecksumAddress = function(hexAddress, eip1191ChainId) {
    return (0, exports.isValidAddress)(hexAddress) && (0, exports.toChecksumAddress)(hexAddress, eip1191ChainId) === hexAddress;
};
exports.isValidChecksumAddress = isValidChecksumAddress;
/**
 * Generates an address of a newly created contract.
 * @param from The address which is creating this new address
 * @param nonce The nonce of the from account
 */ const generateAddress = function(from, nonce) {
    (0, helpers_1.assertIsBuffer)(from);
    (0, helpers_1.assertIsBuffer)(nonce);
    if ((0, bytes_1.bufferToBigInt)(nonce) === BigInt(0)) // in RLP we want to encode null in the case of zero nonce
    // read the RLP documentation for an answer if you dare
    return Buffer.from((0, keccak_1.keccak256)(rlp_1.RLP.encode((0, bytes_1.bufArrToArr)([
        from,
        null
    ])))).slice(-20);
    // Only take the lower 160bits of the hash
    return Buffer.from((0, keccak_1.keccak256)(rlp_1.RLP.encode((0, bytes_1.bufArrToArr)([
        from,
        nonce
    ])))).slice(-20);
};
exports.generateAddress = generateAddress;
/**
 * Generates an address for a contract created using CREATE2.
 * @param from The address which is creating this new address
 * @param salt A salt
 * @param initCode The init code of the contract being created
 */ const generateAddress2 = function(from, salt, initCode) {
    (0, helpers_1.assertIsBuffer)(from);
    (0, helpers_1.assertIsBuffer)(salt);
    (0, helpers_1.assertIsBuffer)(initCode);
    if (from.length !== 20) throw new Error("Expected from to be of length 20");
    if (salt.length !== 32) throw new Error("Expected salt to be of length 32");
    const address = (0, keccak_1.keccak256)(Buffer.concat([
        Buffer.from("ff", "hex"),
        from,
        salt,
        (0, keccak_1.keccak256)(initCode)
    ]));
    return (0, bytes_1.toBuffer)(address).slice(-20);
};
exports.generateAddress2 = generateAddress2;
/**
 * Checks if the private key satisfies the rules of the curve secp256k1.
 */ const isValidPrivate = function(privateKey) {
    return secp256k1_1.secp256k1.utils.isValidPrivateKey(privateKey);
};
exports.isValidPrivate = isValidPrivate;
/**
 * Checks if the public key satisfies the rules of the curve secp256k1
 * and the requirements of Ethereum.
 * @param publicKey The two points of an uncompressed key, unless sanitize is enabled
 * @param sanitize Accept public keys in other formats
 */ const isValidPublic = function(publicKey, sanitize = false) {
    (0, helpers_1.assertIsBuffer)(publicKey);
    if (publicKey.length === 64) // Convert to SEC1 for secp256k1
    // Automatically checks whether point is on curve
    try {
        secp256k1_1.secp256k1.ProjectivePoint.fromHex(Buffer.concat([
            Buffer.from([
                4
            ]),
            publicKey
        ]));
        return true;
    } catch (e) {
        return false;
    }
    if (!sanitize) return false;
    try {
        secp256k1_1.secp256k1.ProjectivePoint.fromHex(publicKey);
        return true;
    } catch (e) {
        return false;
    }
};
exports.isValidPublic = isValidPublic;
/**
 * Returns the ethereum address of a given public key.
 * Accepts "Ethereum public keys" and SEC1 encoded keys.
 * @param pubKey The two points of an uncompressed key, unless sanitize is enabled
 * @param sanitize Accept public keys in other formats
 */ const pubToAddress = function(pubKey, sanitize = false) {
    (0, helpers_1.assertIsBuffer)(pubKey);
    if (sanitize && pubKey.length !== 64) pubKey = Buffer.from(secp256k1_1.secp256k1.ProjectivePoint.fromHex(pubKey).toRawBytes(false).slice(1));
    if (pubKey.length !== 64) throw new Error("Expected pubKey to be of length 64");
    // Only take the lower 160bits of the hash
    return Buffer.from((0, keccak_1.keccak256)(pubKey)).slice(-20);
};
exports.pubToAddress = pubToAddress;
exports.publicToAddress = exports.pubToAddress;
/**
 * Returns the ethereum public key of a given private key.
 * @param privateKey A private key must be 256 bits wide
 */ const privateToPublic = function(privateKey) {
    (0, helpers_1.assertIsBuffer)(privateKey);
    // skip the type flag and use the X, Y points
    return Buffer.from(secp256k1_1.secp256k1.ProjectivePoint.fromPrivateKey(privateKey).toRawBytes(false).slice(1));
};
exports.privateToPublic = privateToPublic;
/**
 * Returns the ethereum address of a given private key.
 * @param privateKey A private key must be 256 bits wide
 */ const privateToAddress = function(privateKey) {
    return (0, exports.publicToAddress)((0, exports.privateToPublic)(privateKey));
};
exports.privateToAddress = privateToAddress;
/**
 * Converts a public key to the Ethereum format.
 */ const importPublic = function(publicKey) {
    (0, helpers_1.assertIsBuffer)(publicKey);
    if (publicKey.length !== 64) publicKey = Buffer.from(secp256k1_1.secp256k1.ProjectivePoint.fromHex(publicKey).toRawBytes(false).slice(1));
    return publicKey;
};
exports.importPublic = importPublic;
/**
 * Returns the zero address.
 */ const zeroAddress = function() {
    const addressLength = 20;
    const addr = (0, bytes_1.zeros)(addressLength);
    return (0, bytes_1.bufferToHex)(addr);
};
exports.zeroAddress = zeroAddress;
/**
 * Checks if a given address is the zero address.
 */ const isZeroAddress = function(hexAddress) {
    try {
        (0, helpers_1.assertIsString)(hexAddress);
    } catch (e) {
        return false;
    }
    const zeroAddr = (0, exports.zeroAddress)();
    return zeroAddr === hexAddress;
};
exports.isZeroAddress = isZeroAddress;
function accountBodyFromSlim(body) {
    const [nonce, balance, storageRoot, codeHash] = body;
    return [
        nonce,
        balance,
        (0, bytes_1.arrToBufArr)(storageRoot).length === 0 ? constants_1.KECCAK256_RLP : storageRoot,
        (0, bytes_1.arrToBufArr)(codeHash).length === 0 ? constants_1.KECCAK256_NULL : codeHash
    ];
}
exports.accountBodyFromSlim = accountBodyFromSlim;
const emptyUint8Arr = new Uint8Array(0);
function accountBodyToSlim(body) {
    const [nonce, balance, storageRoot, codeHash] = body;
    return [
        nonce,
        balance,
        (0, bytes_1.arrToBufArr)(storageRoot).equals(constants_1.KECCAK256_RLP) ? emptyUint8Arr : storageRoot,
        (0, bytes_1.arrToBufArr)(codeHash).equals(constants_1.KECCAK256_NULL) ? emptyUint8Arr : codeHash
    ];
}
exports.accountBodyToSlim = accountBodyToSlim;
/**
 * Converts a slim account (per snap protocol spec) to the RLP encoded version of the account
 * @param body Array of 4 Buffer-like items to represent the account
 * @returns RLP encoded version of the account
 */ function accountBodyToRLP(body, couldBeSlim = true) {
    const accountBody = couldBeSlim ? accountBodyFromSlim(body) : body;
    return (0, bytes_1.arrToBufArr)(rlp_1.RLP.encode(accountBody));
}
exports.accountBodyToRLP = accountBodyToRLP;

},{"e2c3a6bbeddb5fc1":"l5Twm","35ca2ee31c7879db":"btFHi","bcbed7211a54d14e":"43gkh","b33049b23a1844ca":"dV4a1","bd2e3cfed4f0b9b0":"qhvgg","adba5876ab1194d5":"8sUeR","5e5bf220267536c2":"6h8b5","9b6806e6768d889b":"1PcKH","918e37cf52018f67":"lVKB6"}],"btFHi":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.RLP = exports.utils = exports.decode = exports.encode = void 0;
/**
 * RLP Encoding based on https://ethereum.org/en/developers/docs/data-structures-and-encoding/rlp/
 * This function takes in data, converts it to Uint8Array if not,
 * and adds a length for recursion.
 * @param input Will be converted to Uint8Array
 * @returns Uint8Array of encoded data
 **/ function encode(input) {
    if (Array.isArray(input)) {
        const output = [];
        let outputLength = 0;
        for(let i = 0; i < input.length; i++){
            const encoded = encode(input[i]);
            output.push(encoded);
            outputLength += encoded.length;
        }
        return concatBytes(encodeLength(outputLength, 192), ...output);
    }
    const inputBuf = toBytes(input);
    if (inputBuf.length === 1 && inputBuf[0] < 128) return inputBuf;
    return concatBytes(encodeLength(inputBuf.length, 128), inputBuf);
}
exports.encode = encode;
/**
 * Slices a Uint8Array, throws if the slice goes out-of-bounds of the Uint8Array.
 * E.g. `safeSlice(hexToBytes('aa'), 1, 2)` will throw.
 * @param input
 * @param start
 * @param end
 */ function safeSlice(input, start, end) {
    if (end > input.length) throw new Error("invalid RLP (safeSlice): end slice of Uint8Array out-of-bounds");
    return input.slice(start, end);
}
/**
 * Parse integers. Check if there is no leading zeros
 * @param v The value to parse
 */ function decodeLength(v) {
    if (v[0] === 0) throw new Error("invalid RLP: extra zeros");
    return parseHexByte(bytesToHex(v));
}
function encodeLength(len, offset) {
    if (len < 56) return Uint8Array.from([
        len + offset
    ]);
    const hexLength = numberToHex(len);
    const lLength = hexLength.length / 2;
    const firstByte = numberToHex(offset + 55 + lLength);
    return Uint8Array.from(hexToBytes(firstByte + hexLength));
}
function decode(input, stream = false) {
    if (typeof input === "undefined" || input === null || input.length === 0) return Uint8Array.from([]);
    const inputBytes = toBytes(input);
    const decoded = _decode(inputBytes);
    if (stream) return decoded;
    if (decoded.remainder.length !== 0) throw new Error("invalid RLP: remainder must be zero");
    return decoded.data;
}
exports.decode = decode;
/** Decode an input with RLP */ function _decode(input) {
    let length, llength, data, innerRemainder, d;
    const decoded = [];
    const firstByte = input[0];
    if (firstByte <= 0x7f) // a single byte whose value is in the [0x00, 0x7f] range, that byte is its own RLP encoding.
    return {
        data: input.slice(0, 1),
        remainder: input.slice(1)
    };
    else if (firstByte <= 0xb7) {
        // string is 0-55 bytes long. A single byte with value 0x80 plus the length of the string followed by the string
        // The range of the first byte is [0x80, 0xb7]
        length = firstByte - 0x7f;
        // set 0x80 null to 0
        if (firstByte === 0x80) data = Uint8Array.from([]);
        else data = safeSlice(input, 1, length);
        if (length === 2 && data[0] < 0x80) throw new Error("invalid RLP encoding: invalid prefix, single byte < 0x80 are not prefixed");
        return {
            data,
            remainder: input.slice(length)
        };
    } else if (firstByte <= 0xbf) {
        // string is greater than 55 bytes long. A single byte with the value (0xb7 plus the length of the length),
        // followed by the length, followed by the string
        llength = firstByte - 0xb6;
        if (input.length - 1 < llength) throw new Error("invalid RLP: not enough bytes for string length");
        length = decodeLength(safeSlice(input, 1, llength));
        if (length <= 55) throw new Error("invalid RLP: expected string length to be greater than 55");
        data = safeSlice(input, llength, length + llength);
        return {
            data,
            remainder: input.slice(length + llength)
        };
    } else if (firstByte <= 0xf7) {
        // a list between 0-55 bytes long
        length = firstByte - 0xbf;
        innerRemainder = safeSlice(input, 1, length);
        while(innerRemainder.length){
            d = _decode(innerRemainder);
            decoded.push(d.data);
            innerRemainder = d.remainder;
        }
        return {
            data: decoded,
            remainder: input.slice(length)
        };
    } else {
        // a list over 55 bytes long
        llength = firstByte - 0xf6;
        length = decodeLength(safeSlice(input, 1, llength));
        if (length < 56) throw new Error("invalid RLP: encoded list too short");
        const totalLength = llength + length;
        if (totalLength > input.length) throw new Error("invalid RLP: total length is larger than the data");
        innerRemainder = safeSlice(input, llength, totalLength);
        while(innerRemainder.length){
            d = _decode(innerRemainder);
            decoded.push(d.data);
            innerRemainder = d.remainder;
        }
        return {
            data: decoded,
            remainder: input.slice(totalLength)
        };
    }
}
const cachedHexes = Array.from({
    length: 256
}, (_v, i)=>i.toString(16).padStart(2, "0"));
function bytesToHex(uint8a) {
    // Pre-caching chars with `cachedHexes` speeds this up 6x
    let hex = "";
    for(let i = 0; i < uint8a.length; i++)hex += cachedHexes[uint8a[i]];
    return hex;
}
function parseHexByte(hexByte) {
    const byte = Number.parseInt(hexByte, 16);
    if (Number.isNaN(byte)) throw new Error("Invalid byte sequence");
    return byte;
}
// Caching slows it down 2-3x
function hexToBytes(hex) {
    if (typeof hex !== "string") throw new TypeError("hexToBytes: expected string, got " + typeof hex);
    if (hex.length % 2) throw new Error("hexToBytes: received invalid unpadded hex");
    const array = new Uint8Array(hex.length / 2);
    for(let i = 0; i < array.length; i++){
        const j = i * 2;
        array[i] = parseHexByte(hex.slice(j, j + 2));
    }
    return array;
}
/** Concatenates two Uint8Arrays into one. */ function concatBytes(...arrays) {
    if (arrays.length === 1) return arrays[0];
    const length = arrays.reduce((a, arr)=>a + arr.length, 0);
    const result = new Uint8Array(length);
    for(let i = 0, pad = 0; i < arrays.length; i++){
        const arr = arrays[i];
        result.set(arr, pad);
        pad += arr.length;
    }
    return result;
}
function utf8ToBytes(utf) {
    return new TextEncoder().encode(utf);
}
/** Transform an integer into its hexadecimal value */ function numberToHex(integer) {
    if (integer < 0) throw new Error("Invalid integer as argument, must be unsigned!");
    const hex = integer.toString(16);
    return hex.length % 2 ? `0${hex}` : hex;
}
/** Pad a string to be even */ function padToEven(a) {
    return a.length % 2 ? `0${a}` : a;
}
/** Check if a string is prefixed by 0x */ function isHexPrefixed(str) {
    return str.length >= 2 && str[0] === "0" && str[1] === "x";
}
/** Removes 0x from a given String */ function stripHexPrefix(str) {
    if (typeof str !== "string") return str;
    return isHexPrefixed(str) ? str.slice(2) : str;
}
/** Transform anything into a Uint8Array */ function toBytes(v) {
    if (v instanceof Uint8Array) return v;
    if (typeof v === "string") {
        if (isHexPrefixed(v)) return hexToBytes(padToEven(stripHexPrefix(v)));
        return utf8ToBytes(v);
    }
    if (typeof v === "number" || typeof v === "bigint") {
        if (!v) return Uint8Array.from([]);
        return hexToBytes(numberToHex(v));
    }
    if (v === null || v === undefined) return Uint8Array.from([]);
    throw new Error("toBytes: received unsupported type " + typeof v);
}
exports.utils = {
    bytesToHex,
    concatBytes,
    hexToBytes,
    utf8ToBytes
};
exports.RLP = {
    encode,
    decode
};

},{}],"43gkh":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.keccak512 = exports.keccak384 = exports.keccak256 = exports.keccak224 = void 0;
const sha3_1 = require("98c746e16dfc7394");
const utils_js_1 = require("c64cd2f30b3cc15c");
exports.keccak224 = (0, utils_js_1.wrapHash)(sha3_1.keccak_224);
exports.keccak256 = (()=>{
    const k = (0, utils_js_1.wrapHash)(sha3_1.keccak_256);
    k.create = sha3_1.keccak_256.create;
    return k;
})();
exports.keccak384 = (0, utils_js_1.wrapHash)(sha3_1.keccak_384);
exports.keccak512 = (0, utils_js_1.wrapHash)(sha3_1.keccak_512);

},{"98c746e16dfc7394":"bLGYp","c64cd2f30b3cc15c":"qhvgg"}],"bLGYp":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.shake256 = exports.shake128 = exports.keccak_512 = exports.keccak_384 = exports.keccak_256 = exports.keccak_224 = exports.sha3_512 = exports.sha3_384 = exports.sha3_256 = exports.sha3_224 = exports.Keccak = exports.keccakP = void 0;
const _assert_js_1 = require("4c814ca21eb237ea");
const _u64_js_1 = require("100ff59689cbc467");
const utils_js_1 = require("5bd19748768978c9");
// SHA3 (keccak) is based on a new design: basically, the internal state is bigger than output size.
// It's called a sponge function.
// Various per round constants calculations
const SHA3_PI = [];
const SHA3_ROTL = [];
const _SHA3_IOTA = [];
const _0n = /* @__PURE__ */ BigInt(0);
const _1n = /* @__PURE__ */ BigInt(1);
const _2n = /* @__PURE__ */ BigInt(2);
const _7n = /* @__PURE__ */ BigInt(7);
const _256n = /* @__PURE__ */ BigInt(256);
const _0x71n = /* @__PURE__ */ BigInt(0x71);
for(let round = 0, R = _1n, x = 1, y = 0; round < 24; round++){
    // Pi
    [x, y] = [
        y,
        (2 * x + 3 * y) % 5
    ];
    SHA3_PI.push(2 * (5 * y + x));
    // Rotational
    SHA3_ROTL.push((round + 1) * (round + 2) / 2 % 64);
    // Iota
    let t = _0n;
    for(let j = 0; j < 7; j++){
        R = (R << _1n ^ (R >> _7n) * _0x71n) % _256n;
        if (R & _2n) t ^= _1n << (_1n << /* @__PURE__ */ BigInt(j)) - _1n;
    }
    _SHA3_IOTA.push(t);
}
const [SHA3_IOTA_H, SHA3_IOTA_L] = /* @__PURE__ */ (0, _u64_js_1.split)(_SHA3_IOTA, true);
// Left rotation (without 0, 32, 64)
const rotlH = (h, l, s)=>s > 32 ? (0, _u64_js_1.rotlBH)(h, l, s) : (0, _u64_js_1.rotlSH)(h, l, s);
const rotlL = (h, l, s)=>s > 32 ? (0, _u64_js_1.rotlBL)(h, l, s) : (0, _u64_js_1.rotlSL)(h, l, s);
// Same as keccakf1600, but allows to skip some rounds
function keccakP(s, rounds = 24) {
    const B = new Uint32Array(10);
    // NOTE: all indices are x2 since we store state as u32 instead of u64 (bigints to slow in js)
    for(let round = 24 - rounds; round < 24; round++){
        // Theta θ
        for(let x = 0; x < 10; x++)B[x] = s[x] ^ s[x + 10] ^ s[x + 20] ^ s[x + 30] ^ s[x + 40];
        for(let x = 0; x < 10; x += 2){
            const idx1 = (x + 8) % 10;
            const idx0 = (x + 2) % 10;
            const B0 = B[idx0];
            const B1 = B[idx0 + 1];
            const Th = rotlH(B0, B1, 1) ^ B[idx1];
            const Tl = rotlL(B0, B1, 1) ^ B[idx1 + 1];
            for(let y = 0; y < 50; y += 10){
                s[x + y] ^= Th;
                s[x + y + 1] ^= Tl;
            }
        }
        // Rho (ρ) and Pi (π)
        let curH = s[2];
        let curL = s[3];
        for(let t = 0; t < 24; t++){
            const shift = SHA3_ROTL[t];
            const Th = rotlH(curH, curL, shift);
            const Tl = rotlL(curH, curL, shift);
            const PI = SHA3_PI[t];
            curH = s[PI];
            curL = s[PI + 1];
            s[PI] = Th;
            s[PI + 1] = Tl;
        }
        // Chi (χ)
        for(let y = 0; y < 50; y += 10){
            for(let x = 0; x < 10; x++)B[x] = s[y + x];
            for(let x = 0; x < 10; x++)s[y + x] ^= ~B[(x + 2) % 10] & B[(x + 4) % 10];
        }
        // Iota (ι)
        s[0] ^= SHA3_IOTA_H[round];
        s[1] ^= SHA3_IOTA_L[round];
    }
    B.fill(0);
}
exports.keccakP = keccakP;
class Keccak extends utils_js_1.Hash {
    // NOTE: we accept arguments in bytes instead of bits here.
    constructor(blockLen, suffix, outputLen, enableXOF = false, rounds = 24){
        super();
        this.blockLen = blockLen;
        this.suffix = suffix;
        this.outputLen = outputLen;
        this.enableXOF = enableXOF;
        this.rounds = rounds;
        this.pos = 0;
        this.posOut = 0;
        this.finished = false;
        this.destroyed = false;
        // Can be passed from user as dkLen
        (0, _assert_js_1.number)(outputLen);
        // 1600 = 5x5 matrix of 64bit.  1600 bits === 200 bytes
        if (0 >= this.blockLen || this.blockLen >= 200) throw new Error("Sha3 supports only keccak-f1600 function");
        this.state = new Uint8Array(200);
        this.state32 = (0, utils_js_1.u32)(this.state);
    }
    keccak() {
        if (!utils_js_1.isLE) (0, utils_js_1.byteSwap32)(this.state32);
        keccakP(this.state32, this.rounds);
        if (!utils_js_1.isLE) (0, utils_js_1.byteSwap32)(this.state32);
        this.posOut = 0;
        this.pos = 0;
    }
    update(data) {
        (0, _assert_js_1.exists)(this);
        const { blockLen, state } = this;
        data = (0, utils_js_1.toBytes)(data);
        const len = data.length;
        for(let pos = 0; pos < len;){
            const take = Math.min(blockLen - this.pos, len - pos);
            for(let i = 0; i < take; i++)state[this.pos++] ^= data[pos++];
            if (this.pos === blockLen) this.keccak();
        }
        return this;
    }
    finish() {
        if (this.finished) return;
        this.finished = true;
        const { state, suffix, pos, blockLen } = this;
        // Do the padding
        state[pos] ^= suffix;
        if ((suffix & 0x80) !== 0 && pos === blockLen - 1) this.keccak();
        state[blockLen - 1] ^= 0x80;
        this.keccak();
    }
    writeInto(out) {
        (0, _assert_js_1.exists)(this, false);
        (0, _assert_js_1.bytes)(out);
        this.finish();
        const bufferOut = this.state;
        const { blockLen } = this;
        for(let pos = 0, len = out.length; pos < len;){
            if (this.posOut >= blockLen) this.keccak();
            const take = Math.min(blockLen - this.posOut, len - pos);
            out.set(bufferOut.subarray(this.posOut, this.posOut + take), pos);
            this.posOut += take;
            pos += take;
        }
        return out;
    }
    xofInto(out) {
        // Sha3/Keccak usage with XOF is probably mistake, only SHAKE instances can do XOF
        if (!this.enableXOF) throw new Error("XOF is not possible for this instance");
        return this.writeInto(out);
    }
    xof(bytes) {
        (0, _assert_js_1.number)(bytes);
        return this.xofInto(new Uint8Array(bytes));
    }
    digestInto(out) {
        (0, _assert_js_1.output)(out, this);
        if (this.finished) throw new Error("digest() was already called");
        this.writeInto(out);
        this.destroy();
        return out;
    }
    digest() {
        return this.digestInto(new Uint8Array(this.outputLen));
    }
    destroy() {
        this.destroyed = true;
        this.state.fill(0);
    }
    _cloneInto(to) {
        const { blockLen, suffix, outputLen, rounds, enableXOF } = this;
        to || (to = new Keccak(blockLen, suffix, outputLen, enableXOF, rounds));
        to.state32.set(this.state32);
        to.pos = this.pos;
        to.posOut = this.posOut;
        to.finished = this.finished;
        to.rounds = rounds;
        // Suffix can change in cSHAKE
        to.suffix = suffix;
        to.outputLen = outputLen;
        to.enableXOF = enableXOF;
        to.destroyed = this.destroyed;
        return to;
    }
}
exports.Keccak = Keccak;
const gen = (suffix, blockLen, outputLen)=>(0, utils_js_1.wrapConstructor)(()=>new Keccak(blockLen, suffix, outputLen));
exports.sha3_224 = gen(0x06, 144, 28);
/**
 * SHA3-256 hash function
 * @param message - that would be hashed
 */ exports.sha3_256 = gen(0x06, 136, 32);
exports.sha3_384 = gen(0x06, 104, 48);
exports.sha3_512 = gen(0x06, 72, 64);
exports.keccak_224 = gen(0x01, 144, 28);
/**
 * keccak-256 hash function. Different from SHA3-256.
 * @param message - that would be hashed
 */ exports.keccak_256 = gen(0x01, 136, 32);
exports.keccak_384 = gen(0x01, 104, 48);
exports.keccak_512 = gen(0x01, 72, 64);
const genShake = (suffix, blockLen, outputLen)=>(0, utils_js_1.wrapXOFConstructorWithOpts)((opts = {})=>new Keccak(blockLen, suffix, opts.dkLen === undefined ? outputLen : opts.dkLen, true));
exports.shake128 = genShake(0x1f, 168, 16);
exports.shake256 = genShake(0x1f, 136, 32);

},{"4c814ca21eb237ea":"fKrDX","100ff59689cbc467":"1Ztry","5bd19748768978c9":"cXRBA"}],"fKrDX":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.output = exports.exists = exports.hash = exports.bytes = exports.bool = exports.number = exports.isBytes = void 0;
function number(n) {
    if (!Number.isSafeInteger(n) || n < 0) throw new Error(`positive integer expected, not ${n}`);
}
exports.number = number;
function bool(b) {
    if (typeof b !== "boolean") throw new Error(`boolean expected, not ${b}`);
}
exports.bool = bool;
// copied from utils
function isBytes(a) {
    return a instanceof Uint8Array || a != null && typeof a === "object" && a.constructor.name === "Uint8Array";
}
exports.isBytes = isBytes;
function bytes(b, ...lengths) {
    if (!isBytes(b)) throw new Error("Uint8Array expected");
    if (lengths.length > 0 && !lengths.includes(b.length)) throw new Error(`Uint8Array expected of length ${lengths}, not of length=${b.length}`);
}
exports.bytes = bytes;
function hash(h) {
    if (typeof h !== "function" || typeof h.create !== "function") throw new Error("Hash should be wrapped by utils.wrapConstructor");
    number(h.outputLen);
    number(h.blockLen);
}
exports.hash = hash;
function exists(instance, checkFinished = true) {
    if (instance.destroyed) throw new Error("Hash instance has been destroyed");
    if (checkFinished && instance.finished) throw new Error("Hash#digest() has already been called");
}
exports.exists = exists;
function output(out, instance) {
    bytes(out);
    const min = instance.outputLen;
    if (out.length < min) throw new Error(`digestInto() expects output buffer of length at least ${min}`);
}
exports.output = output;
const assert = {
    number,
    bool,
    bytes,
    hash,
    exists,
    output
};
exports.default = assert;

},{}],"1Ztry":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.add5L = exports.add5H = exports.add4H = exports.add4L = exports.add3H = exports.add3L = exports.add = exports.rotlBL = exports.rotlBH = exports.rotlSL = exports.rotlSH = exports.rotr32L = exports.rotr32H = exports.rotrBL = exports.rotrBH = exports.rotrSL = exports.rotrSH = exports.shrSL = exports.shrSH = exports.toBig = exports.split = exports.fromBig = void 0;
const U32_MASK64 = /* @__PURE__ */ BigInt(2 ** 32 - 1);
const _32n = /* @__PURE__ */ BigInt(32);
// We are not using BigUint64Array, because they are extremely slow as per 2022
function fromBig(n, le = false) {
    if (le) return {
        h: Number(n & U32_MASK64),
        l: Number(n >> _32n & U32_MASK64)
    };
    return {
        h: Number(n >> _32n & U32_MASK64) | 0,
        l: Number(n & U32_MASK64) | 0
    };
}
exports.fromBig = fromBig;
function split(lst, le = false) {
    let Ah = new Uint32Array(lst.length);
    let Al = new Uint32Array(lst.length);
    for(let i = 0; i < lst.length; i++){
        const { h, l } = fromBig(lst[i], le);
        [Ah[i], Al[i]] = [
            h,
            l
        ];
    }
    return [
        Ah,
        Al
    ];
}
exports.split = split;
const toBig = (h, l)=>BigInt(h >>> 0) << _32n | BigInt(l >>> 0);
exports.toBig = toBig;
// for Shift in [0, 32)
const shrSH = (h, _l, s)=>h >>> s;
exports.shrSH = shrSH;
const shrSL = (h, l, s)=>h << 32 - s | l >>> s;
exports.shrSL = shrSL;
// Right rotate for Shift in [1, 32)
const rotrSH = (h, l, s)=>h >>> s | l << 32 - s;
exports.rotrSH = rotrSH;
const rotrSL = (h, l, s)=>h << 32 - s | l >>> s;
exports.rotrSL = rotrSL;
// Right rotate for Shift in (32, 64), NOTE: 32 is special case.
const rotrBH = (h, l, s)=>h << 64 - s | l >>> s - 32;
exports.rotrBH = rotrBH;
const rotrBL = (h, l, s)=>h >>> s - 32 | l << 64 - s;
exports.rotrBL = rotrBL;
// Right rotate for shift===32 (just swaps l&h)
const rotr32H = (_h, l)=>l;
exports.rotr32H = rotr32H;
const rotr32L = (h, _l)=>h;
exports.rotr32L = rotr32L;
// Left rotate for Shift in [1, 32)
const rotlSH = (h, l, s)=>h << s | l >>> 32 - s;
exports.rotlSH = rotlSH;
const rotlSL = (h, l, s)=>l << s | h >>> 32 - s;
exports.rotlSL = rotlSL;
// Left rotate for Shift in (32, 64), NOTE: 32 is special case.
const rotlBH = (h, l, s)=>l << s - 32 | h >>> 64 - s;
exports.rotlBH = rotlBH;
const rotlBL = (h, l, s)=>h << s - 32 | l >>> 64 - s;
exports.rotlBL = rotlBL;
// JS uses 32-bit signed integers for bitwise operations which means we cannot
// simple take carry out of low bit sum by shift, we need to use division.
function add(Ah, Al, Bh, Bl) {
    const l = (Al >>> 0) + (Bl >>> 0);
    return {
        h: Ah + Bh + (l / 2 ** 32 | 0) | 0,
        l: l | 0
    };
}
exports.add = add;
// Addition with more than 2 elements
const add3L = (Al, Bl, Cl)=>(Al >>> 0) + (Bl >>> 0) + (Cl >>> 0);
exports.add3L = add3L;
const add3H = (low, Ah, Bh, Ch)=>Ah + Bh + Ch + (low / 2 ** 32 | 0) | 0;
exports.add3H = add3H;
const add4L = (Al, Bl, Cl, Dl)=>(Al >>> 0) + (Bl >>> 0) + (Cl >>> 0) + (Dl >>> 0);
exports.add4L = add4L;
const add4H = (low, Ah, Bh, Ch, Dh)=>Ah + Bh + Ch + Dh + (low / 2 ** 32 | 0) | 0;
exports.add4H = add4H;
const add5L = (Al, Bl, Cl, Dl, El)=>(Al >>> 0) + (Bl >>> 0) + (Cl >>> 0) + (Dl >>> 0) + (El >>> 0);
exports.add5L = add5L;
const add5H = (low, Ah, Bh, Ch, Dh, Eh)=>Ah + Bh + Ch + Dh + Eh + (low / 2 ** 32 | 0) | 0;
exports.add5H = add5H;
// prettier-ignore
const u64 = {
    fromBig,
    split,
    toBig,
    shrSH,
    shrSL,
    rotrSH,
    rotrSL,
    rotrBH,
    rotrBL,
    rotr32H,
    rotr32L,
    rotlSH,
    rotlSL,
    rotlBH,
    rotlBL,
    add,
    add3L,
    add3H,
    add4L,
    add4H,
    add5H,
    add5L
};
exports.default = u64;

},{}],"cXRBA":[function(require,module,exports) {
"use strict";
/*! noble-hashes - MIT License (c) 2022 Paul Miller (paulmillr.com) */ Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.randomBytes = exports.wrapXOFConstructorWithOpts = exports.wrapConstructorWithOpts = exports.wrapConstructor = exports.checkOpts = exports.Hash = exports.concatBytes = exports.toBytes = exports.utf8ToBytes = exports.asyncLoop = exports.nextTick = exports.hexToBytes = exports.bytesToHex = exports.byteSwap32 = exports.byteSwapIfBE = exports.byteSwap = exports.isLE = exports.rotl = exports.rotr = exports.createView = exports.u32 = exports.u8 = exports.isBytes = void 0;
// We use WebCrypto aka globalThis.crypto, which exists in browsers and node.js 16+.
// node.js versions earlier than v19 don't declare it in global scope.
// For node.js, package.json#exports field mapping rewrites import
// from `crypto` to `cryptoNode`, which imports native module.
// Makes the utils un-importable in browsers without a bundler.
// Once node.js 18 is deprecated (2025-04-30), we can just drop the import.
const crypto_1 = require("dad4ac1610cd369d");
const _assert_js_1 = require("13497a3992d9723f");
// export { isBytes } from './_assert.js';
// We can't reuse isBytes from _assert, because somehow this causes huge perf issues
function isBytes(a) {
    return a instanceof Uint8Array || a != null && typeof a === "object" && a.constructor.name === "Uint8Array";
}
exports.isBytes = isBytes;
// Cast array to different type
const u8 = (arr)=>new Uint8Array(arr.buffer, arr.byteOffset, arr.byteLength);
exports.u8 = u8;
const u32 = (arr)=>new Uint32Array(arr.buffer, arr.byteOffset, Math.floor(arr.byteLength / 4));
exports.u32 = u32;
// Cast array to view
const createView = (arr)=>new DataView(arr.buffer, arr.byteOffset, arr.byteLength);
exports.createView = createView;
// The rotate right (circular right shift) operation for uint32
const rotr = (word, shift)=>word << 32 - shift | word >>> shift;
exports.rotr = rotr;
// The rotate left (circular left shift) operation for uint32
const rotl = (word, shift)=>word << shift | word >>> 32 - shift >>> 0;
exports.rotl = rotl;
exports.isLE = new Uint8Array(new Uint32Array([
    0x11223344
]).buffer)[0] === 0x44;
// The byte swap operation for uint32
const byteSwap = (word)=>word << 24 & 0xff000000 | word << 8 & 0xff0000 | word >>> 8 & 0xff00 | word >>> 24 & 0xff;
exports.byteSwap = byteSwap;
// Conditionally byte swap if on a big-endian platform
exports.byteSwapIfBE = exports.isLE ? (n)=>n : (n)=>(0, exports.byteSwap)(n);
// In place byte swap for Uint32Array
function byteSwap32(arr) {
    for(let i = 0; i < arr.length; i++)arr[i] = (0, exports.byteSwap)(arr[i]);
}
exports.byteSwap32 = byteSwap32;
// Array where index 0xf0 (240) is mapped to string 'f0'
const hexes = /* @__PURE__ */ Array.from({
    length: 256
}, (_, i)=>i.toString(16).padStart(2, "0"));
/**
 * @example bytesToHex(Uint8Array.from([0xca, 0xfe, 0x01, 0x23])) // 'cafe0123'
 */ function bytesToHex(bytes) {
    (0, _assert_js_1.bytes)(bytes);
    // pre-caching improves the speed 6x
    let hex = "";
    for(let i = 0; i < bytes.length; i++)hex += hexes[bytes[i]];
    return hex;
}
exports.bytesToHex = bytesToHex;
// We use optimized technique to convert hex string to byte array
const asciis = {
    _0: 48,
    _9: 57,
    _A: 65,
    _F: 70,
    _a: 97,
    _f: 102
};
function asciiToBase16(char) {
    if (char >= asciis._0 && char <= asciis._9) return char - asciis._0;
    if (char >= asciis._A && char <= asciis._F) return char - (asciis._A - 10);
    if (char >= asciis._a && char <= asciis._f) return char - (asciis._a - 10);
    return;
}
/**
 * @example hexToBytes('cafe0123') // Uint8Array.from([0xca, 0xfe, 0x01, 0x23])
 */ function hexToBytes(hex) {
    if (typeof hex !== "string") throw new Error("hex string expected, got " + typeof hex);
    const hl = hex.length;
    const al = hl / 2;
    if (hl % 2) throw new Error("padded hex string expected, got unpadded hex of length " + hl);
    const array = new Uint8Array(al);
    for(let ai = 0, hi = 0; ai < al; ai++, hi += 2){
        const n1 = asciiToBase16(hex.charCodeAt(hi));
        const n2 = asciiToBase16(hex.charCodeAt(hi + 1));
        if (n1 === undefined || n2 === undefined) {
            const char = hex[hi] + hex[hi + 1];
            throw new Error('hex string expected, got non-hex character "' + char + '" at index ' + hi);
        }
        array[ai] = n1 * 16 + n2;
    }
    return array;
}
exports.hexToBytes = hexToBytes;
// There is no setImmediate in browser and setTimeout is slow.
// call of async fn will return Promise, which will be fullfiled only on
// next scheduler queue processing step and this is exactly what we need.
const nextTick = async ()=>{};
exports.nextTick = nextTick;
// Returns control to thread each 'tick' ms to avoid blocking
async function asyncLoop(iters, tick, cb) {
    let ts = Date.now();
    for(let i = 0; i < iters; i++){
        cb(i);
        // Date.now() is not monotonic, so in case if clock goes backwards we return return control too
        const diff = Date.now() - ts;
        if (diff >= 0 && diff < tick) continue;
        await (0, exports.nextTick)();
        ts += diff;
    }
}
exports.asyncLoop = asyncLoop;
/**
 * @example utf8ToBytes('abc') // new Uint8Array([97, 98, 99])
 */ function utf8ToBytes(str) {
    if (typeof str !== "string") throw new Error(`utf8ToBytes expected string, got ${typeof str}`);
    return new Uint8Array(new TextEncoder().encode(str)); // https://bugzil.la/1681809
}
exports.utf8ToBytes = utf8ToBytes;
/**
 * Normalizes (non-hex) string or Uint8Array to Uint8Array.
 * Warning: when Uint8Array is passed, it would NOT get copied.
 * Keep in mind for future mutable operations.
 */ function toBytes(data) {
    if (typeof data === "string") data = utf8ToBytes(data);
    (0, _assert_js_1.bytes)(data);
    return data;
}
exports.toBytes = toBytes;
/**
 * Copies several Uint8Arrays into one.
 */ function concatBytes(...arrays) {
    let sum = 0;
    for(let i = 0; i < arrays.length; i++){
        const a = arrays[i];
        (0, _assert_js_1.bytes)(a);
        sum += a.length;
    }
    const res = new Uint8Array(sum);
    for(let i = 0, pad = 0; i < arrays.length; i++){
        const a = arrays[i];
        res.set(a, pad);
        pad += a.length;
    }
    return res;
}
exports.concatBytes = concatBytes;
// For runtime check if class implements interface
class Hash {
    // Safe version that clones internal state
    clone() {
        return this._cloneInto();
    }
}
exports.Hash = Hash;
const toStr = {}.toString;
function checkOpts(defaults, opts) {
    if (opts !== undefined && toStr.call(opts) !== "[object Object]") throw new Error("Options should be object or undefined");
    const merged = Object.assign(defaults, opts);
    return merged;
}
exports.checkOpts = checkOpts;
function wrapConstructor(hashCons) {
    const hashC = (msg)=>hashCons().update(toBytes(msg)).digest();
    const tmp = hashCons();
    hashC.outputLen = tmp.outputLen;
    hashC.blockLen = tmp.blockLen;
    hashC.create = ()=>hashCons();
    return hashC;
}
exports.wrapConstructor = wrapConstructor;
function wrapConstructorWithOpts(hashCons) {
    const hashC = (msg, opts)=>hashCons(opts).update(toBytes(msg)).digest();
    const tmp = hashCons({});
    hashC.outputLen = tmp.outputLen;
    hashC.blockLen = tmp.blockLen;
    hashC.create = (opts)=>hashCons(opts);
    return hashC;
}
exports.wrapConstructorWithOpts = wrapConstructorWithOpts;
function wrapXOFConstructorWithOpts(hashCons) {
    const hashC = (msg, opts)=>hashCons(opts).update(toBytes(msg)).digest();
    const tmp = hashCons({});
    hashC.outputLen = tmp.outputLen;
    hashC.blockLen = tmp.blockLen;
    hashC.create = (opts)=>hashCons(opts);
    return hashC;
}
exports.wrapXOFConstructorWithOpts = wrapXOFConstructorWithOpts;
/**
 * Secure PRNG. Uses `crypto.getRandomValues`, which defers to OS.
 */ function randomBytes(bytesLength = 32) {
    if (crypto_1.crypto && typeof crypto_1.crypto.getRandomValues === "function") return crypto_1.crypto.getRandomValues(new Uint8Array(bytesLength));
    throw new Error("crypto.getRandomValues must be defined");
}
exports.randomBytes = randomBytes;

},{"dad4ac1610cd369d":"7ZY8V","13497a3992d9723f":"fKrDX"}],"7ZY8V":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.crypto = void 0;
exports.crypto = typeof globalThis === "object" && "crypto" in globalThis ? globalThis.crypto : undefined;

},{}],"qhvgg":[function(require,module,exports) {
"use strict";
var __importDefault = this && this.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.crypto = exports.utf8ToBytes = exports.createView = exports.concatBytes = exports.toHex = exports.bytesToHex = exports.assertBytes = exports.assertBool = void 0;
exports.bytesToUtf8 = bytesToUtf8;
exports.hexToBytes = hexToBytes;
exports.equalsBytes = equalsBytes;
exports.wrapHash = wrapHash;
const _assert_1 = __importDefault(require("f7e335d82d99b8a8"));
const utils_1 = require("70bc41903156f823");
const assertBool = _assert_1.default.bool;
exports.assertBool = assertBool;
const assertBytes = _assert_1.default.bytes;
exports.assertBytes = assertBytes;
var utils_2 = require("70bc41903156f823");
Object.defineProperty(exports, "bytesToHex", {
    enumerable: true,
    get: function() {
        return utils_2.bytesToHex;
    }
});
Object.defineProperty(exports, "toHex", {
    enumerable: true,
    get: function() {
        return utils_2.bytesToHex;
    }
});
Object.defineProperty(exports, "concatBytes", {
    enumerable: true,
    get: function() {
        return utils_2.concatBytes;
    }
});
Object.defineProperty(exports, "createView", {
    enumerable: true,
    get: function() {
        return utils_2.createView;
    }
});
Object.defineProperty(exports, "utf8ToBytes", {
    enumerable: true,
    get: function() {
        return utils_2.utf8ToBytes;
    }
});
// buf.toString('utf8') -> bytesToUtf8(buf)
function bytesToUtf8(data) {
    if (!(data instanceof Uint8Array)) throw new TypeError(`bytesToUtf8 expected Uint8Array, got ${typeof data}`);
    return new TextDecoder().decode(data);
}
function hexToBytes(data) {
    const sliced = data.startsWith("0x") ? data.substring(2) : data;
    return (0, utils_1.hexToBytes)(sliced);
}
// buf.equals(buf2) -> equalsBytes(buf, buf2)
function equalsBytes(a, b) {
    if (a.length !== b.length) return false;
    for(let i = 0; i < a.length; i++){
        if (a[i] !== b[i]) return false;
    }
    return true;
}
// Internal utils
function wrapHash(hash) {
    return (msg)=>{
        _assert_1.default.bytes(msg);
        return hash(msg);
    };
}
// TODO(v3): switch away from node crypto, remove this unnecessary variable.
exports.crypto = (()=>{
    const webCrypto = typeof globalThis === "object" && "crypto" in globalThis ? globalThis.crypto : undefined;
    const nodeRequire = typeof module.require === "function" && module.require.bind(module);
    return {
        node: nodeRequire && !webCrypto ? nodeRequire("crypto") : undefined,
        web: webCrypto
    };
})();

},{"f7e335d82d99b8a8":"fKrDX","70bc41903156f823":"cXRBA"}],"8sUeR":[function(require,module,exports) {
var Buffer = require("e71ac2eca056a206").Buffer;
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.intToUnpaddedBuffer = exports.bigIntToUnpaddedBuffer = exports.bigIntToHex = exports.bufArrToArr = exports.arrToBufArr = exports.validateNoLeadingZeroes = exports.baToJSON = exports.toUtf8 = exports.short = exports.addHexPrefix = exports.toUnsigned = exports.fromSigned = exports.bufferToInt = exports.bigIntToBuffer = exports.bufferToBigInt = exports.bufferToHex = exports.toBuffer = exports.unpadHexString = exports.unpadArray = exports.unpadBuffer = exports.setLengthRight = exports.setLengthLeft = exports.zeros = exports.intToBuffer = exports.intToHex = void 0;
const helpers_1 = require("bad30fdc239a3c");
const internal_1 = require("f06b7880c7b18cad");
/**
 * Converts a `Number` into a hex `String`
 * @param {Number} i
 * @return {String}
 */ const intToHex = function(i) {
    if (!Number.isSafeInteger(i) || i < 0) throw new Error(`Received an invalid integer type: ${i}`);
    return `0x${i.toString(16)}`;
};
exports.intToHex = intToHex;
/**
 * Converts an `Number` to a `Buffer`
 * @param {Number} i
 * @return {Buffer}
 */ const intToBuffer = function(i) {
    const hex = (0, exports.intToHex)(i);
    return Buffer.from((0, internal_1.padToEven)(hex.slice(2)), "hex");
};
exports.intToBuffer = intToBuffer;
/**
 * Returns a buffer filled with 0s.
 * @param bytes the number of bytes the buffer should be
 */ const zeros = function(bytes) {
    return Buffer.allocUnsafe(bytes).fill(0);
};
exports.zeros = zeros;
/**
 * Pads a `Buffer` with zeros till it has `length` bytes.
 * Truncates the beginning or end of input if its length exceeds `length`.
 * @param msg the value to pad (Buffer)
 * @param length the number of bytes the output should be
 * @param right whether to start padding form the left or right
 * @return (Buffer)
 */ const setLength = function(msg, length, right) {
    const buf = (0, exports.zeros)(length);
    if (right) {
        if (msg.length < length) {
            msg.copy(buf);
            return buf;
        }
        return msg.slice(0, length);
    } else {
        if (msg.length < length) {
            msg.copy(buf, length - msg.length);
            return buf;
        }
        return msg.slice(-length);
    }
};
/**
 * Left Pads a `Buffer` with leading zeros till it has `length` bytes.
 * Or it truncates the beginning if it exceeds.
 * @param msg the value to pad (Buffer)
 * @param length the number of bytes the output should be
 * @return (Buffer)
 */ const setLengthLeft = function(msg, length) {
    (0, helpers_1.assertIsBuffer)(msg);
    return setLength(msg, length, false);
};
exports.setLengthLeft = setLengthLeft;
/**
 * Right Pads a `Buffer` with trailing zeros till it has `length` bytes.
 * it truncates the end if it exceeds.
 * @param msg the value to pad (Buffer)
 * @param length the number of bytes the output should be
 * @return (Buffer)
 */ const setLengthRight = function(msg, length) {
    (0, helpers_1.assertIsBuffer)(msg);
    return setLength(msg, length, true);
};
exports.setLengthRight = setLengthRight;
/**
 * Trims leading zeros from a `Buffer`, `String` or `Number[]`.
 * @param a (Buffer|Array|String)
 * @return (Buffer|Array|String)
 */ const stripZeros = function(a) {
    let first = a[0];
    while(a.length > 0 && first.toString() === "0"){
        a = a.slice(1);
        first = a[0];
    }
    return a;
};
/**
 * Trims leading zeros from a `Buffer`.
 * @param a (Buffer)
 * @return (Buffer)
 */ const unpadBuffer = function(a) {
    (0, helpers_1.assertIsBuffer)(a);
    return stripZeros(a);
};
exports.unpadBuffer = unpadBuffer;
/**
 * Trims leading zeros from an `Array` (of numbers).
 * @param a (number[])
 * @return (number[])
 */ const unpadArray = function(a) {
    (0, helpers_1.assertIsArray)(a);
    return stripZeros(a);
};
exports.unpadArray = unpadArray;
/**
 * Trims leading zeros from a hex-prefixed `String`.
 * @param a (String)
 * @return (String)
 */ const unpadHexString = function(a) {
    (0, helpers_1.assertIsHexString)(a);
    a = (0, internal_1.stripHexPrefix)(a);
    return "0x" + stripZeros(a);
};
exports.unpadHexString = unpadHexString;
/**
 * Attempts to turn a value into a `Buffer`.
 * Inputs supported: `Buffer`, `String` (hex-prefixed), `Number`, null/undefined, `BigInt` and other objects
 * with a `toArray()` or `toBuffer()` method.
 * @param v the value
 */ const toBuffer = function(v) {
    if (v === null || v === undefined) return Buffer.allocUnsafe(0);
    if (Buffer.isBuffer(v)) return Buffer.from(v);
    if (Array.isArray(v) || v instanceof Uint8Array) return Buffer.from(v);
    if (typeof v === "string") {
        if (!(0, internal_1.isHexString)(v)) throw new Error(`Cannot convert string to buffer. toBuffer only supports 0x-prefixed hex strings and this string was given: ${v}`);
        return Buffer.from((0, internal_1.padToEven)((0, internal_1.stripHexPrefix)(v)), "hex");
    }
    if (typeof v === "number") return (0, exports.intToBuffer)(v);
    if (typeof v === "bigint") {
        if (v < BigInt(0)) throw new Error(`Cannot convert negative bigint to buffer. Given: ${v}`);
        let n = v.toString(16);
        if (n.length % 2) n = "0" + n;
        return Buffer.from(n, "hex");
    }
    if (v.toArray) // converts a BN to a Buffer
    return Buffer.from(v.toArray());
    if (v.toBuffer) return Buffer.from(v.toBuffer());
    throw new Error("invalid type");
};
exports.toBuffer = toBuffer;
/**
 * Converts a `Buffer` into a `0x`-prefixed hex `String`.
 * @param buf `Buffer` object to convert
 */ const bufferToHex = function(buf) {
    buf = (0, exports.toBuffer)(buf);
    return "0x" + buf.toString("hex");
};
exports.bufferToHex = bufferToHex;
/**
 * Converts a {@link Buffer} to a {@link bigint}
 */ function bufferToBigInt(buf) {
    const hex = (0, exports.bufferToHex)(buf);
    if (hex === "0x") return BigInt(0);
    return BigInt(hex);
}
exports.bufferToBigInt = bufferToBigInt;
/**
 * Converts a {@link bigint} to a {@link Buffer}
 */ function bigIntToBuffer(num) {
    return (0, exports.toBuffer)("0x" + num.toString(16));
}
exports.bigIntToBuffer = bigIntToBuffer;
/**
 * Converts a `Buffer` to a `Number`.
 * @param buf `Buffer` object to convert
 * @throws If the input number exceeds 53 bits.
 */ const bufferToInt = function(buf) {
    const res = Number(bufferToBigInt(buf));
    if (!Number.isSafeInteger(res)) throw new Error("Number exceeds 53 bits");
    return res;
};
exports.bufferToInt = bufferToInt;
/**
 * Interprets a `Buffer` as a signed integer and returns a `BigInt`. Assumes 256-bit numbers.
 * @param num Signed integer value
 */ const fromSigned = function(num) {
    return BigInt.asIntN(256, bufferToBigInt(num));
};
exports.fromSigned = fromSigned;
/**
 * Converts a `BigInt` to an unsigned integer and returns it as a `Buffer`. Assumes 256-bit numbers.
 * @param num
 */ const toUnsigned = function(num) {
    return bigIntToBuffer(BigInt.asUintN(256, num));
};
exports.toUnsigned = toUnsigned;
/**
 * Adds "0x" to a given `String` if it does not already start with "0x".
 */ const addHexPrefix = function(str) {
    if (typeof str !== "string") return str;
    return (0, internal_1.isHexPrefixed)(str) ? str : "0x" + str;
};
exports.addHexPrefix = addHexPrefix;
/**
 * Shortens a string  or buffer's hex string representation to maxLength (default 50).
 *
 * Examples:
 *
 * Input:  '657468657265756d000000000000000000000000000000000000000000000000'
 * Output: '657468657265756d0000000000000000000000000000000000…'
 */ function short(buffer, maxLength = 50) {
    const bufferStr = Buffer.isBuffer(buffer) ? buffer.toString("hex") : buffer;
    if (bufferStr.length <= maxLength) return bufferStr;
    return bufferStr.slice(0, maxLength) + "\u2026";
}
exports.short = short;
/**
 * Returns the utf8 string representation from a hex string.
 *
 * Examples:
 *
 * Input 1: '657468657265756d000000000000000000000000000000000000000000000000'
 * Input 2: '657468657265756d'
 * Input 3: '000000000000000000000000000000000000000000000000657468657265756d'
 *
 * Output (all 3 input variants): 'ethereum'
 *
 * Note that this method is not intended to be used with hex strings
 * representing quantities in both big endian or little endian notation.
 *
 * @param string Hex string, should be `0x` prefixed
 * @return Utf8 string
 */ const toUtf8 = function(hex) {
    const zerosRegexp = /^(00)+|(00)+$/g;
    hex = (0, internal_1.stripHexPrefix)(hex);
    if (hex.length % 2 !== 0) throw new Error("Invalid non-even hex string input for toUtf8() provided");
    const bufferVal = Buffer.from(hex.replace(zerosRegexp, ""), "hex");
    return bufferVal.toString("utf8");
};
exports.toUtf8 = toUtf8;
/**
 * Converts a `Buffer` or `Array` to JSON.
 * @param ba (Buffer|Array)
 * @return (Array|String|null)
 */ const baToJSON = function(ba) {
    if (Buffer.isBuffer(ba)) return `0x${ba.toString("hex")}`;
    else if (ba instanceof Array) {
        const array = [];
        for(let i = 0; i < ba.length; i++)array.push((0, exports.baToJSON)(ba[i]));
        return array;
    }
};
exports.baToJSON = baToJSON;
/**
 * Checks provided Buffers for leading zeroes and throws if found.
 *
 * Examples:
 *
 * Valid values: 0x1, 0x, 0x01, 0x1234
 * Invalid values: 0x0, 0x00, 0x001, 0x0001
 *
 * Note: This method is useful for validating that RLP encoded integers comply with the rule that all
 * integer values encoded to RLP must be in the most compact form and contain no leading zero bytes
 * @param values An object containing string keys and Buffer values
 * @throws if any provided value is found to have leading zero bytes
 */ const validateNoLeadingZeroes = function(values) {
    for (const [k, v] of Object.entries(values)){
        if (v !== undefined && v.length > 0 && v[0] === 0) throw new Error(`${k} cannot have leading zeroes, received: ${v.toString("hex")}`);
    }
};
exports.validateNoLeadingZeroes = validateNoLeadingZeroes;
function arrToBufArr(arr) {
    if (!Array.isArray(arr)) return Buffer.from(arr);
    return arr.map((a)=>arrToBufArr(a));
}
exports.arrToBufArr = arrToBufArr;
function bufArrToArr(arr) {
    if (!Array.isArray(arr)) return Uint8Array.from(arr ?? []);
    return arr.map((a)=>bufArrToArr(a));
}
exports.bufArrToArr = bufArrToArr;
/**
 * Converts a {@link bigint} to a `0x` prefixed hex string
 */ const bigIntToHex = (num)=>{
    return "0x" + num.toString(16);
};
exports.bigIntToHex = bigIntToHex;
/**
 * Convert value from bigint to an unpadded Buffer
 * (useful for RLP transport)
 * @param value value to convert
 */ function bigIntToUnpaddedBuffer(value) {
    return (0, exports.unpadBuffer)(bigIntToBuffer(value));
}
exports.bigIntToUnpaddedBuffer = bigIntToUnpaddedBuffer;
function intToUnpaddedBuffer(value) {
    return (0, exports.unpadBuffer)((0, exports.intToBuffer)(value));
}
exports.intToUnpaddedBuffer = intToUnpaddedBuffer;

},{"e71ac2eca056a206":"l5Twm","bad30fdc239a3c":"1PcKH","f06b7880c7b18cad":"lVKB6"}],"1PcKH":[function(require,module,exports) {
var Buffer = require("708ce8c1ac35692a").Buffer;
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.assertIsString = exports.assertIsArray = exports.assertIsBuffer = exports.assertIsHexString = void 0;
const internal_1 = require("54580dd1dfcd64d4");
/**
 * Throws if a string is not hex prefixed
 * @param {string} input string to check hex prefix of
 */ const assertIsHexString = function(input) {
    if (!(0, internal_1.isHexString)(input)) {
        const msg = `This method only supports 0x-prefixed hex strings but input was: ${input}`;
        throw new Error(msg);
    }
};
exports.assertIsHexString = assertIsHexString;
/**
 * Throws if input is not a buffer
 * @param {Buffer} input value to check
 */ const assertIsBuffer = function(input) {
    if (!Buffer.isBuffer(input)) {
        const msg = `This method only supports Buffer but input was: ${input}`;
        throw new Error(msg);
    }
};
exports.assertIsBuffer = assertIsBuffer;
/**
 * Throws if input is not an array
 * @param {number[]} input value to check
 */ const assertIsArray = function(input) {
    if (!Array.isArray(input)) {
        const msg = `This method only supports number arrays but input was: ${input}`;
        throw new Error(msg);
    }
};
exports.assertIsArray = assertIsArray;
/**
 * Throws if input is not a string
 * @param {string} input value to check
 */ const assertIsString = function(input) {
    if (typeof input !== "string") {
        const msg = `This method only supports strings but input was: ${input}`;
        throw new Error(msg);
    }
};
exports.assertIsString = assertIsString;

},{"708ce8c1ac35692a":"l5Twm","54580dd1dfcd64d4":"lVKB6"}],"lVKB6":[function(require,module,exports) {
var Buffer = require("35c46f00f4b4f813").Buffer;
"use strict";
/*
The MIT License

Copyright (c) 2016 Nick Dodson. nickdodson.com

Permission is hereby granted, free of charge, to any person obtaining a copy
of this software and associated documentation files (the "Software"), to deal
in the Software without restriction, including without limitation the rights
to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
copies of the Software, and to permit persons to whom the Software is
furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in
all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
THE SOFTWARE
 */ Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.isHexString = exports.getKeys = exports.fromAscii = exports.fromUtf8 = exports.toAscii = exports.arrayContainsArray = exports.getBinarySize = exports.padToEven = exports.stripHexPrefix = exports.isHexPrefixed = void 0;
/**
 * Returns a `Boolean` on whether or not the a `String` starts with '0x'
 * @param str the string input value
 * @return a boolean if it is or is not hex prefixed
 * @throws if the str input is not a string
 */ function isHexPrefixed(str) {
    if (typeof str !== "string") throw new Error(`[isHexPrefixed] input must be type 'string', received type ${typeof str}`);
    return str[0] === "0" && str[1] === "x";
}
exports.isHexPrefixed = isHexPrefixed;
/**
 * Removes '0x' from a given `String` if present
 * @param str the string value
 * @returns the string without 0x prefix
 */ const stripHexPrefix = (str)=>{
    if (typeof str !== "string") throw new Error(`[stripHexPrefix] input must be type 'string', received ${typeof str}`);
    return isHexPrefixed(str) ? str.slice(2) : str;
};
exports.stripHexPrefix = stripHexPrefix;
/**
 * Pads a `String` to have an even length
 * @param value
 * @return output
 */ function padToEven(value) {
    let a = value;
    if (typeof a !== "string") throw new Error(`[padToEven] value must be type 'string', received ${typeof a}`);
    if (a.length % 2) a = `0${a}`;
    return a;
}
exports.padToEven = padToEven;
/**
 * Get the binary size of a string
 * @param str
 * @returns the number of bytes contained within the string
 */ function getBinarySize(str) {
    if (typeof str !== "string") throw new Error(`[getBinarySize] method requires input type 'string', received ${typeof str}`);
    return Buffer.byteLength(str, "utf8");
}
exports.getBinarySize = getBinarySize;
/**
 * Returns TRUE if the first specified array contains all elements
 * from the second one. FALSE otherwise.
 *
 * @param superset
 * @param subset
 *
 */ function arrayContainsArray(superset, subset, some) {
    if (Array.isArray(superset) !== true) throw new Error(`[arrayContainsArray] method requires input 'superset' to be an array, got type '${typeof superset}'`);
    if (Array.isArray(subset) !== true) throw new Error(`[arrayContainsArray] method requires input 'subset' to be an array, got type '${typeof subset}'`);
    return subset[some === true ? "some" : "every"]((value)=>superset.indexOf(value) >= 0);
}
exports.arrayContainsArray = arrayContainsArray;
/**
 * Should be called to get ascii from its hex representation
 *
 * @param string in hex
 * @returns ascii string representation of hex value
 */ function toAscii(hex) {
    let str = "";
    let i = 0;
    const l = hex.length;
    if (hex.substring(0, 2) === "0x") i = 2;
    for(; i < l; i += 2){
        const code = parseInt(hex.substr(i, 2), 16);
        str += String.fromCharCode(code);
    }
    return str;
}
exports.toAscii = toAscii;
/**
 * Should be called to get hex representation (prefixed by 0x) of utf8 string
 *
 * @param string
 * @param optional padding
 * @returns hex representation of input string
 */ function fromUtf8(stringValue) {
    const str = Buffer.from(stringValue, "utf8");
    return `0x${padToEven(str.toString("hex")).replace(/^0+|0+$/g, "")}`;
}
exports.fromUtf8 = fromUtf8;
/**
 * Should be called to get hex representation (prefixed by 0x) of ascii string
 *
 * @param  string
 * @param  optional padding
 * @returns  hex representation of input string
 */ function fromAscii(stringValue) {
    let hex = "";
    for(let i = 0; i < stringValue.length; i++){
        const code = stringValue.charCodeAt(i);
        const n = code.toString(16);
        hex += n.length < 2 ? `0${n}` : n;
    }
    return `0x${hex}`;
}
exports.fromAscii = fromAscii;
/**
 * Returns the keys from an array of objects.
 * @example
 * ```js
 * getKeys([{a: '1', b: '2'}, {a: '3', b: '4'}], 'a') => ['1', '3']
 *````
 * @param  params
 * @param  key
 * @param  allowEmpty
 * @returns output just a simple array of output keys
 */ function getKeys(params, key, allowEmpty) {
    if (!Array.isArray(params)) throw new Error(`[getKeys] method expects input 'params' to be an array, got ${typeof params}`);
    if (typeof key !== "string") throw new Error(`[getKeys] method expects input 'key' to be type 'string', got ${typeof params}`);
    const result = [];
    for(let i = 0; i < params.length; i++){
        let value = params[i][key];
        if (allowEmpty === true && !value) value = "";
        else if (typeof value !== "string") throw new Error(`invalid abi - expected type 'string', received ${typeof value}`);
        result.push(value);
    }
    return result;
}
exports.getKeys = getKeys;
/**
 * Is the string a hex string.
 *
 * @param  value
 * @param  length
 * @returns  output the string is a hex string
 */ function isHexString(value, length) {
    if (typeof value !== "string" || !value.match(/^0x[0-9A-Fa-f]*$/)) return false;
    if (typeof length !== "undefined" && length > 0 && value.length !== 2 + 2 * length) return false;
    return true;
}
exports.isHexString = isHexString;

},{"35c46f00f4b4f813":"l5Twm"}],"gl5Qp":[function(require,module,exports) {
var Buffer = require("a6df26ac72bd3cce").Buffer;
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Address = void 0;
const account_1 = require("a0bca07c5df96cc8");
const bytes_1 = require("c1f8fc83d7b6da49");
/**
 * Handling and generating Ethereum addresses
 */ class Address {
    constructor(buf){
        if (buf.length !== 20) throw new Error("Invalid address length");
        this.buf = buf;
    }
    /**
     * Returns the zero address.
     */ static zero() {
        return new Address((0, bytes_1.zeros)(20));
    }
    /**
     * Returns an Address object from a hex-encoded string.
     * @param str - Hex-encoded address
     */ static fromString(str) {
        if (!(0, account_1.isValidAddress)(str)) throw new Error("Invalid address");
        return new Address((0, bytes_1.toBuffer)(str));
    }
    /**
     * Returns an address for a given public key.
     * @param pubKey The two points of an uncompressed key
     */ static fromPublicKey(pubKey) {
        if (!Buffer.isBuffer(pubKey)) throw new Error("Public key should be Buffer");
        const buf = (0, account_1.pubToAddress)(pubKey);
        return new Address(buf);
    }
    /**
     * Returns an address for a given private key.
     * @param privateKey A private key must be 256 bits wide
     */ static fromPrivateKey(privateKey) {
        if (!Buffer.isBuffer(privateKey)) throw new Error("Private key should be Buffer");
        const buf = (0, account_1.privateToAddress)(privateKey);
        return new Address(buf);
    }
    /**
     * Generates an address for a newly created contract.
     * @param from The address which is creating this new address
     * @param nonce The nonce of the from account
     */ static generate(from, nonce) {
        if (typeof nonce !== "bigint") throw new Error("Expected nonce to be a bigint");
        return new Address((0, account_1.generateAddress)(from.buf, (0, bytes_1.bigIntToBuffer)(nonce)));
    }
    /**
     * Generates an address for a contract created using CREATE2.
     * @param from The address which is creating this new address
     * @param salt A salt
     * @param initCode The init code of the contract being created
     */ static generate2(from, salt, initCode) {
        if (!Buffer.isBuffer(salt)) throw new Error("Expected salt to be a Buffer");
        if (!Buffer.isBuffer(initCode)) throw new Error("Expected initCode to be a Buffer");
        return new Address((0, account_1.generateAddress2)(from.buf, salt, initCode));
    }
    /**
     * Is address equal to another.
     */ equals(address) {
        return this.buf.equals(address.buf);
    }
    /**
     * Is address zero.
     */ isZero() {
        return this.equals(Address.zero());
    }
    /**
     * True if address is in the address range defined
     * by EIP-1352
     */ isPrecompileOrSystemAddress() {
        const address = (0, bytes_1.bufferToBigInt)(this.buf);
        const rangeMin = BigInt(0);
        const rangeMax = BigInt("0xffff");
        return address >= rangeMin && address <= rangeMax;
    }
    /**
     * Returns hex encoding of address.
     */ toString() {
        return "0x" + this.buf.toString("hex");
    }
    /**
     * Returns Buffer representation of address.
     */ toBuffer() {
        return Buffer.from(this.buf);
    }
}
exports.Address = Address;

},{"a6df26ac72bd3cce":"l5Twm","a0bca07c5df96cc8":"9gMXk","c1f8fc83d7b6da49":"8sUeR"}],"2TPtq":[function(require,module,exports) {
var Buffer = require("b8a4ea7fab5c1f74").Buffer;
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Withdrawal = void 0;
const address_1 = require("11d8398071472857");
const bytes_1 = require("5151998842770ea7");
const types_1 = require("aaca4860e1b74b60");
/**
 * Representation of EIP-4895 withdrawal data
 */ class Withdrawal {
    /**
     * This constructor assigns and validates the values.
     * Use the static factory methods to assist in creating a Withdrawal object from varying data types.
     * Its amount is in Gwei to match CL representation and for eventual ssz withdrawalsRoot
     */ constructor(index, validatorIndex, address, /**
     * withdrawal amount in Gwei to match the CL repesentation and eventually ssz withdrawalsRoot
     */ amount){
        this.index = index;
        this.validatorIndex = validatorIndex;
        this.address = address;
        this.amount = amount;
    }
    static fromWithdrawalData(withdrawalData) {
        const { index: indexData, validatorIndex: validatorIndexData, address: addressData, amount: amountData } = withdrawalData;
        const index = (0, types_1.toType)(indexData, types_1.TypeOutput.BigInt);
        const validatorIndex = (0, types_1.toType)(validatorIndexData, types_1.TypeOutput.BigInt);
        const address = new address_1.Address((0, types_1.toType)(addressData, types_1.TypeOutput.Buffer));
        const amount = (0, types_1.toType)(amountData, types_1.TypeOutput.BigInt);
        return new Withdrawal(index, validatorIndex, address, amount);
    }
    static fromValuesArray(withdrawalArray) {
        if (withdrawalArray.length !== 4) throw Error(`Invalid withdrawalArray length expected=4 actual=${withdrawalArray.length}`);
        const [index, validatorIndex, address, amount] = withdrawalArray;
        return Withdrawal.fromWithdrawalData({
            index,
            validatorIndex,
            address,
            amount
        });
    }
    /**
     * Convert a withdrawal to a buffer array
     * @param withdrawal the withdrawal to convert
     * @returns buffer array of the withdrawal
     */ static toBufferArray(withdrawal) {
        const { index, validatorIndex, address, amount } = withdrawal;
        const indexBuffer = (0, types_1.toType)(index, types_1.TypeOutput.BigInt) === BigInt(0) ? Buffer.alloc(0) : (0, types_1.toType)(index, types_1.TypeOutput.Buffer);
        const validatorIndexBuffer = (0, types_1.toType)(validatorIndex, types_1.TypeOutput.BigInt) === BigInt(0) ? Buffer.alloc(0) : (0, types_1.toType)(validatorIndex, types_1.TypeOutput.Buffer);
        let addressBuffer;
        if (address instanceof address_1.Address) addressBuffer = address.buf;
        else addressBuffer = (0, types_1.toType)(address, types_1.TypeOutput.Buffer);
        const amountBuffer = (0, types_1.toType)(amount, types_1.TypeOutput.BigInt) === BigInt(0) ? Buffer.alloc(0) : (0, types_1.toType)(amount, types_1.TypeOutput.Buffer);
        return [
            indexBuffer,
            validatorIndexBuffer,
            addressBuffer,
            amountBuffer
        ];
    }
    raw() {
        return Withdrawal.toBufferArray(this);
    }
    toValue() {
        return {
            index: this.index,
            validatorIndex: this.validatorIndex,
            address: this.address.buf,
            amount: this.amount
        };
    }
    toJSON() {
        return {
            index: (0, bytes_1.bigIntToHex)(this.index),
            validatorIndex: (0, bytes_1.bigIntToHex)(this.validatorIndex),
            address: "0x" + this.address.buf.toString("hex"),
            amount: (0, bytes_1.bigIntToHex)(this.amount)
        };
    }
}
exports.Withdrawal = Withdrawal;

},{"b8a4ea7fab5c1f74":"l5Twm","11d8398071472857":"gl5Qp","5151998842770ea7":"8sUeR","aaca4860e1b74b60":"1fvPO"}],"1fvPO":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.toType = exports.TypeOutput = void 0;
const bytes_1 = require("ae22f5a51df4eac3");
const internal_1 = require("9fead8fb2f0f0346");
/**
 * Type output options
 */ var TypeOutput;
(function(TypeOutput) {
    TypeOutput[TypeOutput["Number"] = 0] = "Number";
    TypeOutput[TypeOutput["BigInt"] = 1] = "BigInt";
    TypeOutput[TypeOutput["Buffer"] = 2] = "Buffer";
    TypeOutput[TypeOutput["PrefixedHexString"] = 3] = "PrefixedHexString";
})(TypeOutput = exports.TypeOutput || (exports.TypeOutput = {}));
function toType(input, outputType) {
    if (input === null) return null;
    if (input === undefined) return undefined;
    if (typeof input === "string" && !(0, internal_1.isHexString)(input)) throw new Error(`A string must be provided with a 0x-prefix, given: ${input}`);
    else if (typeof input === "number" && !Number.isSafeInteger(input)) throw new Error("The provided number is greater than MAX_SAFE_INTEGER (please use an alternative input type)");
    const output = (0, bytes_1.toBuffer)(input);
    switch(outputType){
        case TypeOutput.Buffer:
            return output;
        case TypeOutput.BigInt:
            return (0, bytes_1.bufferToBigInt)(output);
        case TypeOutput.Number:
            {
                const bigInt = (0, bytes_1.bufferToBigInt)(output);
                if (bigInt > BigInt(Number.MAX_SAFE_INTEGER)) throw new Error("The provided number is greater than MAX_SAFE_INTEGER (please use an alternative output type)");
                return Number(bigInt);
            }
        case TypeOutput.PrefixedHexString:
            return (0, bytes_1.bufferToHex)(output);
        default:
            throw new Error("unknown outputType");
    }
}
exports.toType = toType;

},{"ae22f5a51df4eac3":"8sUeR","9fead8fb2f0f0346":"lVKB6"}],"coUSP":[function(require,module,exports) {
var Buffer = require("61bb6aaf73bb9b70").Buffer;
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.hashPersonalMessage = exports.isValidSignature = exports.fromRpcSig = exports.toCompactSig = exports.toRpcSig = exports.ecrecover = exports.ecsign = void 0;
const keccak_1 = require("cb8b8ec7026d8461");
const secp256k1_1 = require("6ba52f0f03b67fe2");
const bytes_1 = require("b87b6e2481ad8a7d");
const constants_1 = require("7b733d83eb7a5ee0");
const helpers_1 = require("617853f657eff99d");
/**
 * Returns the ECDSA signature of a message hash.
 *
 * If `chainId` is provided assume an EIP-155-style signature and calculate the `v` value
 * accordingly, otherwise return a "static" `v` just derived from the `recovery` bit
 */ function ecsign(msgHash, privateKey, chainId) {
    const sig = secp256k1_1.secp256k1.sign(msgHash, privateKey);
    const buf = sig.toCompactRawBytes();
    const r = Buffer.from(buf.slice(0, 32));
    const s = Buffer.from(buf.slice(32, 64));
    const v = chainId === undefined ? BigInt(sig.recovery + 27) : BigInt(sig.recovery + 35) + BigInt(chainId) * BigInt(2);
    return {
        r,
        s,
        v
    };
}
exports.ecsign = ecsign;
function calculateSigRecovery(v, chainId) {
    if (v === BigInt(0) || v === BigInt(1)) return v;
    if (chainId === undefined) return v - BigInt(27);
    return v - (chainId * BigInt(2) + BigInt(35));
}
function isValidSigRecovery(recovery) {
    return recovery === BigInt(0) || recovery === BigInt(1);
}
/**
 * ECDSA public key recovery from signature.
 * NOTE: Accepts `v === 0 | v === 1` for EIP1559 transactions
 * @returns Recovered public key
 */ const ecrecover = function(msgHash, v, r, s, chainId) {
    const signature = Buffer.concat([
        (0, bytes_1.setLengthLeft)(r, 32),
        (0, bytes_1.setLengthLeft)(s, 32)
    ], 64);
    const recovery = calculateSigRecovery(v, chainId);
    if (!isValidSigRecovery(recovery)) throw new Error("Invalid signature v value");
    const sig = secp256k1_1.secp256k1.Signature.fromCompact(signature).addRecoveryBit(Number(recovery));
    const senderPubKey = sig.recoverPublicKey(msgHash);
    return Buffer.from(senderPubKey.toRawBytes(false).slice(1));
};
exports.ecrecover = ecrecover;
/**
 * Convert signature parameters into the format of `eth_sign` RPC method.
 * NOTE: Accepts `v === 0 | v === 1` for EIP1559 transactions
 * @returns Signature
 */ const toRpcSig = function(v, r, s, chainId) {
    const recovery = calculateSigRecovery(v, chainId);
    if (!isValidSigRecovery(recovery)) throw new Error("Invalid signature v value");
    // geth (and the RPC eth_sign method) uses the 65 byte format used by Bitcoin
    return (0, bytes_1.bufferToHex)(Buffer.concat([
        (0, bytes_1.setLengthLeft)(r, 32),
        (0, bytes_1.setLengthLeft)(s, 32),
        (0, bytes_1.toBuffer)(v)
    ]));
};
exports.toRpcSig = toRpcSig;
/**
 * Convert signature parameters into the format of Compact Signature Representation (EIP-2098).
 * NOTE: Accepts `v === 0 | v === 1` for EIP1559 transactions
 * @returns Signature
 */ const toCompactSig = function(v, r, s, chainId) {
    const recovery = calculateSigRecovery(v, chainId);
    if (!isValidSigRecovery(recovery)) throw new Error("Invalid signature v value");
    let ss = s;
    if (v > BigInt(28) && v % BigInt(2) === BigInt(1) || v === BigInt(1) || v === BigInt(28)) {
        ss = Buffer.from(s);
        ss[0] |= 0x80;
    }
    return (0, bytes_1.bufferToHex)(Buffer.concat([
        (0, bytes_1.setLengthLeft)(r, 32),
        (0, bytes_1.setLengthLeft)(ss, 32)
    ]));
};
exports.toCompactSig = toCompactSig;
/**
 * Convert signature format of the `eth_sign` RPC method to signature parameters
 *
 * NOTE: For an extracted `v` value < 27 (see Geth bug https://github.com/ethereum/go-ethereum/issues/2053)
 * `v + 27` is returned for the `v` value
 * NOTE: After EIP1559, `v` could be `0` or `1` but this function assumes
 * it's a signed message (EIP-191 or EIP-712) adding `27` at the end. Remove if needed.
 */ const fromRpcSig = function(sig) {
    const buf = (0, bytes_1.toBuffer)(sig);
    let r;
    let s;
    let v;
    if (buf.length >= 65) {
        r = buf.slice(0, 32);
        s = buf.slice(32, 64);
        v = (0, bytes_1.bufferToBigInt)(buf.slice(64));
    } else if (buf.length === 64) {
        // Compact Signature Representation (https://eips.ethereum.org/EIPS/eip-2098)
        r = buf.slice(0, 32);
        s = buf.slice(32, 64);
        v = BigInt((0, bytes_1.bufferToInt)(buf.slice(32, 33)) >> 7);
        s[0] &= 0x7f;
    } else throw new Error("Invalid signature length");
    // support both versions of `eth_sign` responses
    if (v < 27) v = v + BigInt(27);
    return {
        v,
        r,
        s
    };
};
exports.fromRpcSig = fromRpcSig;
/**
 * Validate a ECDSA signature.
 * NOTE: Accepts `v === 0 | v === 1` for EIP1559 transactions
 * @param homesteadOrLater Indicates whether this is being used on either the homestead hardfork or a later one
 */ const isValidSignature = function(v, r, s, homesteadOrLater = true, chainId) {
    if (r.length !== 32 || s.length !== 32) return false;
    if (!isValidSigRecovery(calculateSigRecovery(v, chainId))) return false;
    const rBigInt = (0, bytes_1.bufferToBigInt)(r);
    const sBigInt = (0, bytes_1.bufferToBigInt)(s);
    if (rBigInt === BigInt(0) || rBigInt >= constants_1.SECP256K1_ORDER || sBigInt === BigInt(0) || sBigInt >= constants_1.SECP256K1_ORDER) return false;
    if (homesteadOrLater && sBigInt >= constants_1.SECP256K1_ORDER_DIV_2) return false;
    return true;
};
exports.isValidSignature = isValidSignature;
/**
 * Returns the keccak-256 hash of `message`, prefixed with the header used by the `eth_sign` RPC call.
 * The output of this function can be fed into `ecsign` to produce the same signature as the `eth_sign`
 * call for a given `message`, or fed to `ecrecover` along with a signature to recover the public key
 * used to produce the signature.
 */ const hashPersonalMessage = function(message) {
    (0, helpers_1.assertIsBuffer)(message);
    const prefix = Buffer.from(`\u0019Ethereum Signed Message:\n${message.length}`, "utf-8");
    return Buffer.from((0, keccak_1.keccak256)(Buffer.concat([
        prefix,
        message
    ])));
};
exports.hashPersonalMessage = hashPersonalMessage;

},{"61bb6aaf73bb9b70":"l5Twm","cb8b8ec7026d8461":"43gkh","6ba52f0f03b67fe2":"dV4a1","b87b6e2481ad8a7d":"8sUeR","7b733d83eb7a5ee0":"6h8b5","617853f657eff99d":"1PcKH"}],"eFPjw":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.compactBytesToNibbles = exports.bytesToNibbles = exports.nibblesToCompactBytes = exports.nibblesToBytes = exports.hasTerminator = void 0;
// Reference: https://ethereum.org/en/developers/docs/data-structures-and-encoding/patricia-merkle-trie/
/**
 *
 * @param s byte sequence
 * @returns boolean indicating if input hex nibble sequence has terminator indicating leaf-node
 *          terminator is represented with 16 because a nibble ranges from 0 - 15(f)
 */ const hasTerminator = (nibbles)=>{
    return nibbles.length > 0 && nibbles[nibbles.length - 1] === 16;
};
exports.hasTerminator = hasTerminator;
const nibblesToBytes = (nibbles, bytes)=>{
    for(let bi = 0, ni = 0; ni < nibbles.length; bi += 1, ni += 2)bytes[bi] = nibbles[ni] << 4 | nibbles[ni + 1];
};
exports.nibblesToBytes = nibblesToBytes;
const nibblesToCompactBytes = (nibbles)=>{
    let terminator = 0;
    if ((0, exports.hasTerminator)(nibbles)) {
        terminator = 1;
        // Remove the terminator from the sequence
        nibbles = nibbles.subarray(0, nibbles.length - 1);
    }
    const buf = new Uint8Array(nibbles.length / 2 + 1);
    // Shift the terminator info into the first nibble of buf[0]
    buf[0] = terminator << 5;
    // If odd length, then add that flag into the first nibble and put the odd nibble to
    // second part of buf[0] which otherwise will be left padded with a 0
    if ((nibbles.length & 1) === 1) {
        buf[0] |= 16;
        buf[0] |= nibbles[0];
        nibbles = nibbles.subarray(1);
    }
    // create bytes out of the rest even nibbles
    (0, exports.nibblesToBytes)(nibbles, buf.subarray(1));
    return buf;
};
exports.nibblesToCompactBytes = nibblesToCompactBytes;
const bytesToNibbles = (str)=>{
    const l = str.length * 2 + 1;
    const nibbles = new Uint8Array(l);
    for(let i = 0; i < str.length; i++){
        const b = str[i];
        nibbles[i * 2] = b / 16;
        nibbles[i * 2 + 1] = b % 16;
    }
    // This will get removed from calling function if the first nibble
    // indicates that terminator is not present
    nibbles[l - 1] = 16;
    return nibbles;
};
exports.bytesToNibbles = bytesToNibbles;
const compactBytesToNibbles = (compact)=>{
    if (compact.length === 0) return compact;
    let base = (0, exports.bytesToNibbles)(compact);
    // delete terminator flag if terminator flag was not in first nibble
    if (base[0] < 2) base = base.subarray(0, base.length - 1);
    // chop the terminator nibble and the even padding (if there is one)
    // i.e.  chop 2 left nibbles when even else 1 when odd
    const chop = 2 - (base[0] & 1);
    return base.subarray(chop);
};
exports.compactBytesToNibbles = compactBytesToNibbles; /**
 * A test helper to generates compact path for a subset of key bytes
 *
 * TODO: Commenting the code for now as this seems to be helper function
 * (from geth codebase )
 *
 */  //
 //
 // export const getPathTo = (tillBytes: number, key: Buffer) => {
 //   const hexNibbles = bytesToNibbles(key).subarray(0, tillBytes)
 //   // Remove the terminator if its there, although it would be there only if tillBytes >= key.length
 //   // This seems to be a test helper to generate paths so correctness of this isn't necessary
 //   hexNibbles[hexNibbles.length - 1] = 0
 //   const compactBytes = nibblesToCompactBytes(hexNibbles)
 //   return [Buffer.from(compactBytes)]
 // }

},{}],"5wXE6":[function(require,module,exports) {
"use strict";
/**
 * Ported to Typescript from original implementation below:
 * https://github.com/ahultgren/async-eventemitter -- MIT licensed
 *
 * Type Definitions based on work by: patarapolw <https://github.com/patarapolw> -- MIT licensed
 * that was contributed to Definitely Typed below:
 * https://github.com/DefinitelyTyped/DefinitelyTyped/tree/master/types/async-eventemitter
 */ Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.AsyncEventEmitter = void 0;
const events_1 = require("87ee91575042b43e");
async function runInSeries(context, tasks, data) {
    let error;
    for await (const task of tasks)try {
        if (task.length < 2) //sync
        task.call(context, data);
        else await new Promise((resolve, reject)=>{
            task.call(context, data, (error)=>{
                if (error) reject(error);
                else resolve();
            });
        });
    } catch (e) {
        error = e;
    }
    if (error) throw error;
}
class AsyncEventEmitter extends events_1.EventEmitter {
    emit(event, ...args) {
        let [data, callback] = args;
        const self = this;
        let listeners = self._events[event] ?? [];
        // Optional data argument
        if (callback === undefined && typeof data === "function") {
            callback = data;
            data = undefined;
        }
        // Special treatment of internal newListener and removeListener events
        if (event === "newListener" || event === "removeListener") {
            data = {
                event: data,
                fn: callback
            };
            callback = undefined;
        }
        // A single listener is just a function not an array...
        listeners = Array.isArray(listeners) ? listeners : [
            listeners
        ];
        runInSeries(self, listeners.slice(), data).then(callback).catch(callback);
        return self.listenerCount(event) > 0;
    }
    once(event, listener) {
        const self = this;
        let g;
        if (typeof listener !== "function") throw new TypeError("listener must be a function");
        // Hack to support set arity
        if (listener.length >= 2) g = function(e, next) {
            self.removeListener(event, g);
            listener(e, next);
        };
        else g = function(e) {
            self.removeListener(event, g);
            listener(e, g);
        };
        self.on(event, g);
        return self;
    }
    first(event, listener) {
        let listeners = this._events[event] ?? [];
        // Contract
        if (typeof listener !== "function") throw new TypeError("listener must be a function");
        // Listeners are not always an array
        if (!Array.isArray(listeners)) this._events[event] = listeners = [
            listeners
        ];
        listeners.unshift(listener);
        return this;
    }
    before(event, target, listener) {
        return this.beforeOrAfter(event, target, listener);
    }
    after(event, target, listener) {
        return this.beforeOrAfter(event, target, listener, "after");
    }
    beforeOrAfter(event, target, listener, beforeOrAfter) {
        let listeners = this._events[event] ?? [];
        let i;
        let index;
        const add = beforeOrAfter === "after" ? 1 : 0;
        // Contract
        if (typeof listener !== "function") throw new TypeError("listener must be a function");
        if (typeof target !== "function") throw new TypeError("target must be a function");
        // Listeners are not always an array
        if (!Array.isArray(listeners)) this._events[event] = listeners = [
            listeners
        ];
        index = listeners.length;
        for(i = listeners.length; i--;)if (listeners[i] === target) {
            index = i + add;
            break;
        }
        listeners.splice(index, 0, listener);
        return this;
    }
    on(event, listener) {
        return super.on(event, listener);
    }
    addListener(event, listener) {
        return super.addListener(event, listener);
    }
    prependListener(event, listener) {
        return super.prependListener(event, listener);
    }
    prependOnceListener(event, listener) {
        return super.prependOnceListener(event, listener);
    }
    removeAllListeners(event) {
        return super.removeAllListeners(event);
    }
    removeListener(event, listener) {
        return super.removeListener(event, listener);
    }
    eventNames() {
        return super.eventNames();
    }
    listeners(event) {
        return super.listeners(event);
    }
    listenerCount(event) {
        return super.listenerCount(event);
    }
    getMaxListeners() {
        return super.getMaxListeners();
    }
    setMaxListeners(maxListeners) {
        return super.setMaxListeners(maxListeners);
    }
}
exports.AsyncEventEmitter = AsyncEventEmitter;

},{"87ee91575042b43e":"fqTtD"}],"fqTtD":[function(require,module,exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
"use strict";
var R = typeof Reflect === "object" ? Reflect : null;
var ReflectApply = R && typeof R.apply === "function" ? R.apply : function ReflectApply(target, receiver, args) {
    return Function.prototype.apply.call(target, receiver, args);
};
var ReflectOwnKeys;
if (R && typeof R.ownKeys === "function") ReflectOwnKeys = R.ownKeys;
else if (Object.getOwnPropertySymbols) ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target).concat(Object.getOwnPropertySymbols(target));
};
else ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target);
};
function ProcessEmitWarning(warning) {
    if (console && console.warn) console.warn(warning);
}
var NumberIsNaN = Number.isNaN || function NumberIsNaN(value) {
    return value !== value;
};
function EventEmitter() {
    EventEmitter.init.call(this);
}
module.exports = EventEmitter;
module.exports.once = once;
// Backwards-compat with node 0.10.x
EventEmitter.EventEmitter = EventEmitter;
EventEmitter.prototype._events = undefined;
EventEmitter.prototype._eventsCount = 0;
EventEmitter.prototype._maxListeners = undefined;
// By default EventEmitters will print a warning if more than 10 listeners are
// added to it. This is a useful default which helps finding memory leaks.
var defaultMaxListeners = 10;
function checkListener(listener) {
    if (typeof listener !== "function") throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof listener);
}
Object.defineProperty(EventEmitter, "defaultMaxListeners", {
    enumerable: true,
    get: function() {
        return defaultMaxListeners;
    },
    set: function(arg) {
        if (typeof arg !== "number" || arg < 0 || NumberIsNaN(arg)) throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + arg + ".");
        defaultMaxListeners = arg;
    }
});
EventEmitter.init = function() {
    if (this._events === undefined || this._events === Object.getPrototypeOf(this)._events) {
        this._events = Object.create(null);
        this._eventsCount = 0;
    }
    this._maxListeners = this._maxListeners || undefined;
};
// Obviously not all Emitters should be limited to 10. This function allows
// that to be increased. Set to zero for unlimited.
EventEmitter.prototype.setMaxListeners = function setMaxListeners(n) {
    if (typeof n !== "number" || n < 0 || NumberIsNaN(n)) throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + n + ".");
    this._maxListeners = n;
    return this;
};
function _getMaxListeners(that) {
    if (that._maxListeners === undefined) return EventEmitter.defaultMaxListeners;
    return that._maxListeners;
}
EventEmitter.prototype.getMaxListeners = function getMaxListeners() {
    return _getMaxListeners(this);
};
EventEmitter.prototype.emit = function emit(type) {
    var args = [];
    for(var i = 1; i < arguments.length; i++)args.push(arguments[i]);
    var doError = type === "error";
    var events = this._events;
    if (events !== undefined) doError = doError && events.error === undefined;
    else if (!doError) return false;
    // If there is no 'error' event listener then throw.
    if (doError) {
        var er;
        if (args.length > 0) er = args[0];
        if (er instanceof Error) // Note: The comments on the `throw` lines are intentional, they show
        // up in Node's output if this results in an unhandled exception.
        throw er; // Unhandled 'error' event
        // At least give some kind of context to the user
        var err = new Error("Unhandled error." + (er ? " (" + er.message + ")" : ""));
        err.context = er;
        throw err; // Unhandled 'error' event
    }
    var handler = events[type];
    if (handler === undefined) return false;
    if (typeof handler === "function") ReflectApply(handler, this, args);
    else {
        var len = handler.length;
        var listeners = arrayClone(handler, len);
        for(var i = 0; i < len; ++i)ReflectApply(listeners[i], this, args);
    }
    return true;
};
function _addListener(target, type, listener, prepend) {
    var m;
    var events;
    var existing;
    checkListener(listener);
    events = target._events;
    if (events === undefined) {
        events = target._events = Object.create(null);
        target._eventsCount = 0;
    } else {
        // To avoid recursion in the case that type === "newListener"! Before
        // adding it to the listeners, first emit "newListener".
        if (events.newListener !== undefined) {
            target.emit("newListener", type, listener.listener ? listener.listener : listener);
            // Re-assign `events` because a newListener handler could have caused the
            // this._events to be assigned to a new object
            events = target._events;
        }
        existing = events[type];
    }
    if (existing === undefined) {
        // Optimize the case of one listener. Don't need the extra array object.
        existing = events[type] = listener;
        ++target._eventsCount;
    } else {
        if (typeof existing === "function") // Adding the second element, need to change to array.
        existing = events[type] = prepend ? [
            listener,
            existing
        ] : [
            existing,
            listener
        ];
        else if (prepend) existing.unshift(listener);
        else existing.push(listener);
        // Check for listener leak
        m = _getMaxListeners(target);
        if (m > 0 && existing.length > m && !existing.warned) {
            existing.warned = true;
            // No error code for this since it is a Warning
            // eslint-disable-next-line no-restricted-syntax
            var w = new Error("Possible EventEmitter memory leak detected. " + existing.length + " " + String(type) + " listeners " + "added. Use emitter.setMaxListeners() to " + "increase limit");
            w.name = "MaxListenersExceededWarning";
            w.emitter = target;
            w.type = type;
            w.count = existing.length;
            ProcessEmitWarning(w);
        }
    }
    return target;
}
EventEmitter.prototype.addListener = function addListener(type, listener) {
    return _addListener(this, type, listener, false);
};
EventEmitter.prototype.on = EventEmitter.prototype.addListener;
EventEmitter.prototype.prependListener = function prependListener(type, listener) {
    return _addListener(this, type, listener, true);
};
function onceWrapper() {
    if (!this.fired) {
        this.target.removeListener(this.type, this.wrapFn);
        this.fired = true;
        if (arguments.length === 0) return this.listener.call(this.target);
        return this.listener.apply(this.target, arguments);
    }
}
function _onceWrap(target, type, listener) {
    var state = {
        fired: false,
        wrapFn: undefined,
        target: target,
        type: type,
        listener: listener
    };
    var wrapped = onceWrapper.bind(state);
    wrapped.listener = listener;
    state.wrapFn = wrapped;
    return wrapped;
}
EventEmitter.prototype.once = function once(type, listener) {
    checkListener(listener);
    this.on(type, _onceWrap(this, type, listener));
    return this;
};
EventEmitter.prototype.prependOnceListener = function prependOnceListener(type, listener) {
    checkListener(listener);
    this.prependListener(type, _onceWrap(this, type, listener));
    return this;
};
// Emits a 'removeListener' event if and only if the listener was removed.
EventEmitter.prototype.removeListener = function removeListener(type, listener) {
    var list, events, position, i, originalListener;
    checkListener(listener);
    events = this._events;
    if (events === undefined) return this;
    list = events[type];
    if (list === undefined) return this;
    if (list === listener || list.listener === listener) {
        if (--this._eventsCount === 0) this._events = Object.create(null);
        else {
            delete events[type];
            if (events.removeListener) this.emit("removeListener", type, list.listener || listener);
        }
    } else if (typeof list !== "function") {
        position = -1;
        for(i = list.length - 1; i >= 0; i--)if (list[i] === listener || list[i].listener === listener) {
            originalListener = list[i].listener;
            position = i;
            break;
        }
        if (position < 0) return this;
        if (position === 0) list.shift();
        else spliceOne(list, position);
        if (list.length === 1) events[type] = list[0];
        if (events.removeListener !== undefined) this.emit("removeListener", type, originalListener || listener);
    }
    return this;
};
EventEmitter.prototype.off = EventEmitter.prototype.removeListener;
EventEmitter.prototype.removeAllListeners = function removeAllListeners(type) {
    var listeners, events, i;
    events = this._events;
    if (events === undefined) return this;
    // not listening for removeListener, no need to emit
    if (events.removeListener === undefined) {
        if (arguments.length === 0) {
            this._events = Object.create(null);
            this._eventsCount = 0;
        } else if (events[type] !== undefined) {
            if (--this._eventsCount === 0) this._events = Object.create(null);
            else delete events[type];
        }
        return this;
    }
    // emit removeListener for all listeners on all events
    if (arguments.length === 0) {
        var keys = Object.keys(events);
        var key;
        for(i = 0; i < keys.length; ++i){
            key = keys[i];
            if (key === "removeListener") continue;
            this.removeAllListeners(key);
        }
        this.removeAllListeners("removeListener");
        this._events = Object.create(null);
        this._eventsCount = 0;
        return this;
    }
    listeners = events[type];
    if (typeof listeners === "function") this.removeListener(type, listeners);
    else if (listeners !== undefined) // LIFO order
    for(i = listeners.length - 1; i >= 0; i--)this.removeListener(type, listeners[i]);
    return this;
};
function _listeners(target, type, unwrap) {
    var events = target._events;
    if (events === undefined) return [];
    var evlistener = events[type];
    if (evlistener === undefined) return [];
    if (typeof evlistener === "function") return unwrap ? [
        evlistener.listener || evlistener
    ] : [
        evlistener
    ];
    return unwrap ? unwrapListeners(evlistener) : arrayClone(evlistener, evlistener.length);
}
EventEmitter.prototype.listeners = function listeners(type) {
    return _listeners(this, type, true);
};
EventEmitter.prototype.rawListeners = function rawListeners(type) {
    return _listeners(this, type, false);
};
EventEmitter.listenerCount = function(emitter, type) {
    if (typeof emitter.listenerCount === "function") return emitter.listenerCount(type);
    else return listenerCount.call(emitter, type);
};
EventEmitter.prototype.listenerCount = listenerCount;
function listenerCount(type) {
    var events = this._events;
    if (events !== undefined) {
        var evlistener = events[type];
        if (typeof evlistener === "function") return 1;
        else if (evlistener !== undefined) return evlistener.length;
    }
    return 0;
}
EventEmitter.prototype.eventNames = function eventNames() {
    return this._eventsCount > 0 ? ReflectOwnKeys(this._events) : [];
};
function arrayClone(arr, n) {
    var copy = new Array(n);
    for(var i = 0; i < n; ++i)copy[i] = arr[i];
    return copy;
}
function spliceOne(list, index) {
    for(; index + 1 < list.length; index++)list[index] = list[index + 1];
    list.pop();
}
function unwrapListeners(arr) {
    var ret = new Array(arr.length);
    for(var i = 0; i < ret.length; ++i)ret[i] = arr[i].listener || arr[i];
    return ret;
}
function once(emitter, name) {
    return new Promise(function(resolve, reject) {
        function errorListener(err) {
            emitter.removeListener(name, resolver);
            reject(err);
        }
        function resolver() {
            if (typeof emitter.removeListener === "function") emitter.removeListener("error", errorListener);
            resolve([].slice.call(arguments));
        }
        eventTargetAgnosticAddListener(emitter, name, resolver, {
            once: true
        });
        if (name !== "error") addErrorHandlerIfEventEmitter(emitter, errorListener, {
            once: true
        });
    });
}
function addErrorHandlerIfEventEmitter(emitter, handler, flags) {
    if (typeof emitter.on === "function") eventTargetAgnosticAddListener(emitter, "error", handler, flags);
}
function eventTargetAgnosticAddListener(emitter, name, listener, flags) {
    if (typeof emitter.on === "function") {
        if (flags.once) emitter.once(name, listener);
        else emitter.on(name, listener);
    } else if (typeof emitter.addEventListener === "function") // EventTarget does not have `error` event semantics like Node
    // EventEmitters, we do not listen for `error` events here.
    emitter.addEventListener(name, function wrapListener(arg) {
        // IE does not have builtin `{ once: true }` support so we
        // have to do it manually.
        if (flags.once) emitter.removeEventListener(name, wrapListener);
        listener(arg);
    });
    else throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + typeof emitter);
}

},{}],"49zHC":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Lock = void 0;
// Based on https://github.com/jsoendermann/semaphore-async-await/blob/master/src/Semaphore.ts
class Lock {
    constructor(){
        this.permits = 1;
        this.promiseResolverQueue = [];
    }
    /**
     * Returns a promise used to wait for a permit to become available. This method should be awaited on.
     * @returns  A promise that gets resolved when execution is allowed to proceed.
     */ async acquire() {
        if (this.permits > 0) {
            this.permits -= 1;
            return Promise.resolve(true);
        }
        // If there is no permit available, we return a promise that resolves once the semaphore gets
        // signaled enough times that permits is equal to one.
        return new Promise((resolver)=>this.promiseResolverQueue.push(resolver));
    }
    /**
     * Increases the number of permits by one. If there are other functions waiting, one of them will
     * continue to execute in a future iteration of the event loop.
     */ release() {
        this.permits += 1;
        if (this.permits > 1 && this.promiseResolverQueue.length > 0) // eslint-disable-next-line no-console
        console.warn("Lock.permits should never be > 0 when there is someone waiting.");
        else if (this.permits === 1 && this.promiseResolverQueue.length > 0) {
            // If there is someone else waiting, immediately consume the permit that was released
            // at the beginning of this function and let the waiting function resume.
            this.permits -= 1;
            const nextResolver = this.promiseResolverQueue.shift();
            if (nextResolver) nextResolver(true);
        }
    }
}
exports.Lock = Lock;

},{}],"6LX36":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getProvider = exports.fetchFromProvider = void 0;
const micro_ftch_1 = require("bef59122f32136b6");
const fetchFromProvider = async (url, params)=>{
    const res = await (0, micro_ftch_1.default)(url, {
        headers: {
            "content-type": "application/json"
        },
        type: "json",
        data: {
            method: params.method,
            params: params.params,
            jsonrpc: "2.0",
            id: 1
        }
    });
    return res.result;
};
exports.fetchFromProvider = fetchFromProvider;
const getProvider = (provider)=>{
    if (typeof provider === "string") return provider;
    else if (provider?.connection?.url !== undefined) return provider.connection.url;
    else throw new Error("Must provide valid provider URL or Web3Provider");
};
exports.getProvider = getProvider;

},{"bef59122f32136b6":"6ddCo"}],"6ddCo":[function(require,module,exports) {
var Buffer = require("e8a6ed4a736f2dc2").Buffer;
var process = require("f051819e20353639");
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.InvalidStatusCodeError = exports.InvalidCertError = void 0;
const DEFAULT_OPT = Object.freeze({
    redirect: true,
    expectStatusCode: 200,
    headers: {},
    full: false,
    keepAlive: true,
    cors: false,
    referrer: false,
    sslAllowSelfSigned: false,
    _redirectCount: 0
});
class InvalidCertError extends Error {
    constructor(msg, fingerprint256){
        super(msg);
        this.fingerprint256 = fingerprint256;
    }
}
exports.InvalidCertError = InvalidCertError;
class InvalidStatusCodeError extends Error {
    constructor(statusCode){
        super(`Request Failed. Status Code: ${statusCode}`);
        this.statusCode = statusCode;
    }
}
exports.InvalidStatusCodeError = InvalidStatusCodeError;
function detectType(b, type) {
    if (!type || type === "text" || type === "json") try {
        let text = new TextDecoder("utf8", {
            fatal: true
        }).decode(b);
        if (type === "text") return text;
        try {
            return JSON.parse(text);
        } catch (err) {
            if (type === "json") throw err;
            return text;
        }
    } catch (err) {
        if (type === "text" || type === "json") throw err;
    }
    return b;
}
let agents = {};
function fetchNode(url, _options) {
    let options = {
        ...DEFAULT_OPT,
        ..._options
    };
    const http = require("b20a1ab7bdad4ee6");
    const https = require("e7636a13cd6e124c");
    const zlib = require("1c47c68a9de4886a");
    const { promisify } = require("7deb2e69efd5b226");
    const { resolve: urlResolve } = require("d514852d8ce4ba5f");
    const isSecure = !!/^https/.test(url);
    let opts = {
        method: options.method || "GET",
        headers: {
            "Accept-Encoding": "gzip, deflate, br"
        }
    };
    const compactFP = (s)=>s.replace(/:| /g, "").toLowerCase();
    if (options.keepAlive) {
        const agentOpt = {
            keepAlive: true,
            keepAliveMsecs: 30000,
            maxFreeSockets: 1024,
            maxCachedSessions: 1024
        };
        const agentKey = [
            isSecure,
            isSecure && options.sslPinnedCertificates?.map((i)=>compactFP(i)).sort()
        ].join();
        opts.agent = agents[agentKey] || (agents[agentKey] = new (isSecure ? https : http).Agent(agentOpt));
    }
    if (options.type === "json") opts.headers["Content-Type"] = "application/json";
    if (options.data) {
        if (!options.method) opts.method = "POST";
        opts.body = options.type === "json" ? JSON.stringify(options.data) : options.data;
    }
    opts.headers = {
        ...opts.headers,
        ...options.headers
    };
    if (options.sslAllowSelfSigned) opts.rejectUnauthorized = false;
    const handleRes = async (res)=>{
        const status = res.statusCode;
        if (options.redirect && 300 <= status && status < 400 && res.headers["location"]) {
            if (options._redirectCount == 10) throw new Error("Request failed. Too much redirects.");
            options._redirectCount += 1;
            return await fetchNode(urlResolve(url, res.headers["location"]), options);
        }
        if (options.expectStatusCode && status !== options.expectStatusCode) {
            res.resume();
            throw new InvalidStatusCodeError(status);
        }
        let buf = [];
        for await (const chunk of res)buf.push(chunk);
        let bytes = Buffer.concat(buf);
        const encoding = res.headers["content-encoding"];
        if (encoding === "br") bytes = await promisify(zlib.brotliDecompress)(bytes);
        if (encoding === "gzip" || encoding === "deflate") bytes = await promisify(zlib.unzip)(bytes);
        const body = detectType(bytes, options.type);
        if (options.full) return {
            headers: res.headers,
            status,
            body
        };
        return body;
    };
    return new Promise((resolve, reject)=>{
        const handleError = async (err)=>{
            if (err && err.code === "DEPTH_ZERO_SELF_SIGNED_CERT") try {
                await fetchNode(url, {
                    ...options,
                    sslAllowSelfSigned: true,
                    sslPinnedCertificates: []
                });
            } catch (e) {
                if (e && e.fingerprint256) err = new InvalidCertError(`Self-signed SSL certificate: ${e.fingerprint256}`, e.fingerprint256);
            }
            reject(err);
        };
        const req = (isSecure ? https : http).request(url, opts, (res)=>{
            res.on("error", handleError);
            (async ()=>{
                try {
                    resolve(await handleRes(res));
                } catch (error) {
                    reject(error);
                }
            })();
        });
        req.on("error", handleError);
        const pinned = options.sslPinnedCertificates?.map((i)=>compactFP(i));
        const mfetchSecureConnect = (socket)=>{
            const fp256 = compactFP(socket.getPeerCertificate()?.fingerprint256 || "");
            if (!fp256 && socket.isSessionReused()) return;
            if (pinned.includes(fp256)) return;
            req.emit("error", new InvalidCertError(`Invalid SSL certificate: ${fp256} Expected: ${pinned}`, fp256));
            return req.abort();
        };
        if (options.sslPinnedCertificates) req.on("socket", (socket)=>{
            const hasListeners = socket.listeners("secureConnect").map((i)=>(i.name || "").replace("bound ", "")).includes("mfetchSecureConnect");
            if (hasListeners) return;
            socket.on("secureConnect", mfetchSecureConnect.bind(null, socket));
        });
        if (options.keepAlive) req.setNoDelay(true);
        if (opts.body) req.write(opts.body);
        req.end();
    });
}
const SAFE_HEADERS = new Set([
    "Accept",
    "Accept-Language",
    "Content-Language",
    "Content-Type"
].map((i)=>i.toLowerCase()));
const FORBIDDEN_HEADERS = new Set([
    "Accept-Charset",
    "Accept-Encoding",
    "Access-Control-Request-Headers",
    "Access-Control-Request-Method",
    "Connection",
    "Content-Length",
    "Cookie",
    "Cookie2",
    "Date",
    "DNT",
    "Expect",
    "Host",
    "Keep-Alive",
    "Origin",
    "Referer",
    "TE",
    "Trailer",
    "Transfer-Encoding",
    "Upgrade",
    "Via"
].map((i)=>i.toLowerCase()));
async function fetchBrowser(url, _options) {
    let options = {
        ...DEFAULT_OPT,
        ..._options
    };
    const headers = new Headers();
    if (options.type === "json") headers.set("Content-Type", "application/json");
    let parsed = new URL(url);
    if (parsed.username) {
        const auth = btoa(`${parsed.username}:${parsed.password}`);
        headers.set("Authorization", `Basic ${auth}`);
        parsed.username = "";
        parsed.password = "";
    }
    url = "" + parsed;
    for(let k in options.headers){
        const name = k.toLowerCase();
        if (SAFE_HEADERS.has(name) || options.cors && !FORBIDDEN_HEADERS.has(name)) headers.set(k, options.headers[k]);
    }
    let opts = {
        headers,
        redirect: options.redirect ? "follow" : "manual"
    };
    if (!options.referrer) opts.referrerPolicy = "no-referrer";
    if (options.cors) opts.mode = "cors";
    if (options.data) {
        if (!options.method) opts.method = "POST";
        opts.body = options.type === "json" ? JSON.stringify(options.data) : options.data;
    }
    const res = await fetch(url, opts);
    if (options.expectStatusCode && res.status !== options.expectStatusCode) throw new InvalidStatusCodeError(res.status);
    const body = detectType(new Uint8Array(await res.arrayBuffer()), options.type);
    if (options.full) return {
        headers: Object.fromEntries(res.headers.entries()),
        status: res.status,
        body
    };
    return body;
}
const IS_NODE = !!(typeof process == "object" && process.versions && process.versions.node && process.versions.v8);
function fetchUrl(url, options) {
    const fn = IS_NODE ? fetchNode : fetchBrowser;
    return fn(url, options);
}
exports.default = fetchUrl;

},{"e8a6ed4a736f2dc2":"l5Twm","f051819e20353639":"5QIF0","b20a1ab7bdad4ee6":"biwe9","e7636a13cd6e124c":"h9uDr","1c47c68a9de4886a":"IZkiP","7deb2e69efd5b226":"jInrX","d514852d8ce4ba5f":"280SV"}],"biwe9":[function(require,module,exports) {
var global = arguments[3];
var ClientRequest = require("83d28c734ca853c7");
var response = require("48c6aa21794e4a2c");
var extend = require("cc32961fe07c8fa5");
var statusCodes = require("381164753d333ab6");
var url = require("6039c69b7d2da501");
var http = exports;
http.request = function(opts, cb) {
    if (typeof opts === "string") opts = url.parse(opts);
    else opts = extend(opts);
    // Normally, the page is loaded from http or https, so not specifying a protocol
    // will result in a (valid) protocol-relative url. However, this won't work if
    // the protocol is something else, like 'file:'
    var defaultProtocol = global.location.protocol.search(/^https?:$/) === -1 ? "http:" : "";
    var protocol = opts.protocol || defaultProtocol;
    var host = opts.hostname || opts.host;
    var port = opts.port;
    var path = opts.path || "/";
    // Necessary for IPv6 addresses
    if (host && host.indexOf(":") !== -1) host = "[" + host + "]";
    // This may be a relative url. The browser should always be able to interpret it correctly.
    opts.url = (host ? protocol + "//" + host : "") + (port ? ":" + port : "") + path;
    opts.method = (opts.method || "GET").toUpperCase();
    opts.headers = opts.headers || {};
    // Also valid opts.auth, opts.mode
    var req = new ClientRequest(opts);
    if (cb) req.on("response", cb);
    return req;
};
http.get = function get(opts, cb) {
    var req = http.request(opts, cb);
    req.end();
    return req;
};
http.ClientRequest = ClientRequest;
http.IncomingMessage = response.IncomingMessage;
http.Agent = function() {};
http.Agent.defaultMaxSockets = 4;
http.globalAgent = new http.Agent();
http.STATUS_CODES = statusCodes;
http.METHODS = [
    "CHECKOUT",
    "CONNECT",
    "COPY",
    "DELETE",
    "GET",
    "HEAD",
    "LOCK",
    "M-SEARCH",
    "MERGE",
    "MKACTIVITY",
    "MKCOL",
    "MOVE",
    "NOTIFY",
    "OPTIONS",
    "PATCH",
    "POST",
    "PROPFIND",
    "PROPPATCH",
    "PURGE",
    "PUT",
    "REPORT",
    "SEARCH",
    "SUBSCRIBE",
    "TRACE",
    "UNLOCK",
    "UNSUBSCRIBE"
];

},{"83d28c734ca853c7":"3MspK","48c6aa21794e4a2c":"288qE","cc32961fe07c8fa5":"7rqcZ","381164753d333ab6":"fHu7L","6039c69b7d2da501":"280SV"}],"3MspK":[function(require,module,exports) {
var Buffer = require("171a808a93d7935a").Buffer;
var global = arguments[3];
var process = require("a9ea3f73cd8e4ec0");
var capability = require("47a5b3351a25523b");
var inherits = require("33d332b21b1041");
var response = require("90881d49dd53d428");
var stream = require("c817ce87e1330fb2");
var IncomingMessage = response.IncomingMessage;
var rStates = response.readyStates;
function decideMode(preferBinary, useFetch) {
    if (capability.fetch && useFetch) return "fetch";
    else if (capability.mozchunkedarraybuffer) return "moz-chunked-arraybuffer";
    else if (capability.msstream) return "ms-stream";
    else if (capability.arraybuffer && preferBinary) return "arraybuffer";
    else return "text";
}
var ClientRequest = module.exports = function(opts) {
    var self = this;
    stream.Writable.call(self);
    self._opts = opts;
    self._body = [];
    self._headers = {};
    if (opts.auth) self.setHeader("Authorization", "Basic " + Buffer.from(opts.auth).toString("base64"));
    Object.keys(opts.headers).forEach(function(name) {
        self.setHeader(name, opts.headers[name]);
    });
    var preferBinary;
    var useFetch = true;
    if (opts.mode === "disable-fetch" || "requestTimeout" in opts && !capability.abortController) {
        // If the use of XHR should be preferred. Not typically needed.
        useFetch = false;
        preferBinary = true;
    } else if (opts.mode === "prefer-streaming") // If streaming is a high priority but binary compatibility and
    // the accuracy of the 'content-type' header aren't
    preferBinary = false;
    else if (opts.mode === "allow-wrong-content-type") // If streaming is more important than preserving the 'content-type' header
    preferBinary = !capability.overrideMimeType;
    else if (!opts.mode || opts.mode === "default" || opts.mode === "prefer-fast") // Use binary if text streaming may corrupt data or the content-type header, or for speed
    preferBinary = true;
    else throw new Error("Invalid value for opts.mode");
    self._mode = decideMode(preferBinary, useFetch);
    self._fetchTimer = null;
    self._socketTimeout = null;
    self._socketTimer = null;
    self.on("finish", function() {
        self._onFinish();
    });
};
inherits(ClientRequest, stream.Writable);
ClientRequest.prototype.setHeader = function(name, value) {
    var self = this;
    var lowerName = name.toLowerCase();
    // This check is not necessary, but it prevents warnings from browsers about setting unsafe
    // headers. To be honest I'm not entirely sure hiding these warnings is a good thing, but
    // http-browserify did it, so I will too.
    if (unsafeHeaders.indexOf(lowerName) !== -1) return;
    self._headers[lowerName] = {
        name: name,
        value: value
    };
};
ClientRequest.prototype.getHeader = function(name) {
    var header = this._headers[name.toLowerCase()];
    if (header) return header.value;
    return null;
};
ClientRequest.prototype.removeHeader = function(name) {
    var self = this;
    delete self._headers[name.toLowerCase()];
};
ClientRequest.prototype._onFinish = function() {
    var self = this;
    if (self._destroyed) return;
    var opts = self._opts;
    if ("timeout" in opts && opts.timeout !== 0) self.setTimeout(opts.timeout);
    var headersObj = self._headers;
    var body = null;
    if (opts.method !== "GET" && opts.method !== "HEAD") body = new Blob(self._body, {
        type: (headersObj["content-type"] || {}).value || ""
    });
    // create flattened list of headers
    var headersList = [];
    Object.keys(headersObj).forEach(function(keyName) {
        var name = headersObj[keyName].name;
        var value = headersObj[keyName].value;
        if (Array.isArray(value)) value.forEach(function(v) {
            headersList.push([
                name,
                v
            ]);
        });
        else headersList.push([
            name,
            value
        ]);
    });
    if (self._mode === "fetch") {
        var signal = null;
        if (capability.abortController) {
            var controller = new AbortController();
            signal = controller.signal;
            self._fetchAbortController = controller;
            if ("requestTimeout" in opts && opts.requestTimeout !== 0) self._fetchTimer = global.setTimeout(function() {
                self.emit("requestTimeout");
                if (self._fetchAbortController) self._fetchAbortController.abort();
            }, opts.requestTimeout);
        }
        global.fetch(self._opts.url, {
            method: self._opts.method,
            headers: headersList,
            body: body || undefined,
            mode: "cors",
            credentials: opts.withCredentials ? "include" : "same-origin",
            signal: signal
        }).then(function(response) {
            self._fetchResponse = response;
            self._resetTimers(false);
            self._connect();
        }, function(reason) {
            self._resetTimers(true);
            if (!self._destroyed) self.emit("error", reason);
        });
    } else {
        var xhr = self._xhr = new global.XMLHttpRequest();
        try {
            xhr.open(self._opts.method, self._opts.url, true);
        } catch (err) {
            process.nextTick(function() {
                self.emit("error", err);
            });
            return;
        }
        // Can't set responseType on really old browsers
        if ("responseType" in xhr) xhr.responseType = self._mode;
        if ("withCredentials" in xhr) xhr.withCredentials = !!opts.withCredentials;
        if (self._mode === "text" && "overrideMimeType" in xhr) xhr.overrideMimeType("text/plain; charset=x-user-defined");
        if ("requestTimeout" in opts) {
            xhr.timeout = opts.requestTimeout;
            xhr.ontimeout = function() {
                self.emit("requestTimeout");
            };
        }
        headersList.forEach(function(header) {
            xhr.setRequestHeader(header[0], header[1]);
        });
        self._response = null;
        xhr.onreadystatechange = function() {
            switch(xhr.readyState){
                case rStates.LOADING:
                case rStates.DONE:
                    self._onXHRProgress();
                    break;
            }
        };
        // Necessary for streaming in Firefox, since xhr.response is ONLY defined
        // in onprogress, not in onreadystatechange with xhr.readyState = 3
        if (self._mode === "moz-chunked-arraybuffer") xhr.onprogress = function() {
            self._onXHRProgress();
        };
        xhr.onerror = function() {
            if (self._destroyed) return;
            self._resetTimers(true);
            self.emit("error", new Error("XHR error"));
        };
        try {
            xhr.send(body);
        } catch (err) {
            process.nextTick(function() {
                self.emit("error", err);
            });
            return;
        }
    }
};
/**
 * Checks if xhr.status is readable and non-zero, indicating no error.
 * Even though the spec says it should be available in readyState 3,
 * accessing it throws an exception in IE8
 */ function statusValid(xhr) {
    try {
        var status = xhr.status;
        return status !== null && status !== 0;
    } catch (e) {
        return false;
    }
}
ClientRequest.prototype._onXHRProgress = function() {
    var self = this;
    self._resetTimers(false);
    if (!statusValid(self._xhr) || self._destroyed) return;
    if (!self._response) self._connect();
    self._response._onXHRProgress(self._resetTimers.bind(self));
};
ClientRequest.prototype._connect = function() {
    var self = this;
    if (self._destroyed) return;
    self._response = new IncomingMessage(self._xhr, self._fetchResponse, self._mode, self._resetTimers.bind(self));
    self._response.on("error", function(err) {
        self.emit("error", err);
    });
    self.emit("response", self._response);
};
ClientRequest.prototype._write = function(chunk, encoding, cb) {
    var self = this;
    self._body.push(chunk);
    cb();
};
ClientRequest.prototype._resetTimers = function(done) {
    var self = this;
    global.clearTimeout(self._socketTimer);
    self._socketTimer = null;
    if (done) {
        global.clearTimeout(self._fetchTimer);
        self._fetchTimer = null;
    } else if (self._socketTimeout) self._socketTimer = global.setTimeout(function() {
        self.emit("timeout");
    }, self._socketTimeout);
};
ClientRequest.prototype.abort = ClientRequest.prototype.destroy = function(err) {
    var self = this;
    self._destroyed = true;
    self._resetTimers(true);
    if (self._response) self._response._destroyed = true;
    if (self._xhr) self._xhr.abort();
    else if (self._fetchAbortController) self._fetchAbortController.abort();
    if (err) self.emit("error", err);
};
ClientRequest.prototype.end = function(data, encoding, cb) {
    var self = this;
    if (typeof data === "function") {
        cb = data;
        data = undefined;
    }
    stream.Writable.prototype.end.call(self, data, encoding, cb);
};
ClientRequest.prototype.setTimeout = function(timeout, cb) {
    var self = this;
    if (cb) self.once("timeout", cb);
    self._socketTimeout = timeout;
    self._resetTimers(false);
};
ClientRequest.prototype.flushHeaders = function() {};
ClientRequest.prototype.setNoDelay = function() {};
ClientRequest.prototype.setSocketKeepAlive = function() {};
// Taken from http://www.w3.org/TR/XMLHttpRequest/#the-setrequestheader%28%29-method
var unsafeHeaders = [
    "accept-charset",
    "accept-encoding",
    "access-control-request-headers",
    "access-control-request-method",
    "connection",
    "content-length",
    "cookie",
    "cookie2",
    "date",
    "dnt",
    "expect",
    "host",
    "keep-alive",
    "origin",
    "referer",
    "te",
    "trailer",
    "transfer-encoding",
    "upgrade",
    "via"
];

},{"171a808a93d7935a":"l5Twm","a9ea3f73cd8e4ec0":"5QIF0","47a5b3351a25523b":"kHzFH","33d332b21b1041":"8LxVj","90881d49dd53d428":"288qE","c817ce87e1330fb2":"k5khq"}],"kHzFH":[function(require,module,exports) {
var global = arguments[3];
exports.fetch = isFunction(global.fetch) && isFunction(global.ReadableStream);
exports.writableStream = isFunction(global.WritableStream);
exports.abortController = isFunction(global.AbortController);
// The xhr request to example.com may violate some restrictive CSP configurations,
// so if we're running in a browser that supports `fetch`, avoid calling getXHR()
// and assume support for certain features below.
var xhr;
function getXHR() {
    // Cache the xhr value
    if (xhr !== undefined) return xhr;
    if (global.XMLHttpRequest) {
        xhr = new global.XMLHttpRequest();
        // If XDomainRequest is available (ie only, where xhr might not work
        // cross domain), use the page location. Otherwise use example.com
        // Note: this doesn't actually make an http request.
        try {
            xhr.open("GET", global.XDomainRequest ? "/" : "https://example.com");
        } catch (e) {
            xhr = null;
        }
    } else // Service workers don't have XHR
    xhr = null;
    return xhr;
}
function checkTypeSupport(type) {
    var xhr = getXHR();
    if (!xhr) return false;
    try {
        xhr.responseType = type;
        return xhr.responseType === type;
    } catch (e) {}
    return false;
}
// If fetch is supported, then arraybuffer will be supported too. Skip calling
// checkTypeSupport(), since that calls getXHR().
exports.arraybuffer = exports.fetch || checkTypeSupport("arraybuffer");
// These next two tests unavoidably show warnings in Chrome. Since fetch will always
// be used if it's available, just return false for these to avoid the warnings.
exports.msstream = !exports.fetch && checkTypeSupport("ms-stream");
exports.mozchunkedarraybuffer = !exports.fetch && checkTypeSupport("moz-chunked-arraybuffer");
// If fetch is supported, then overrideMimeType will be supported too. Skip calling
// getXHR().
exports.overrideMimeType = exports.fetch || (getXHR() ? isFunction(getXHR().overrideMimeType) : false);
function isFunction(value) {
    return typeof value === "function";
}
xhr = null // Help gc
;

},{}],"8LxVj":[function(require,module,exports) {
if (typeof Object.create === "function") // implementation from standard node.js 'util' module
module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
        ctor.super_ = superCtor;
        ctor.prototype = Object.create(superCtor.prototype, {
            constructor: {
                value: ctor,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
    }
};
else // old school shim for old browsers
module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
};

},{}],"288qE":[function(require,module,exports) {
var process = require("d1269065c33ee7fe");
var Buffer = require("77d4ce6cf763caca").Buffer;
var global = arguments[3];
var capability = require("7dcf7aadbb533bfb");
var inherits = require("57b1383434ef92a1");
var stream = require("fa2873d490014c0a");
var rStates = exports.readyStates = {
    UNSENT: 0,
    OPENED: 1,
    HEADERS_RECEIVED: 2,
    LOADING: 3,
    DONE: 4
};
var IncomingMessage = exports.IncomingMessage = function(xhr, response, mode, resetTimers) {
    var self = this;
    stream.Readable.call(self);
    self._mode = mode;
    self.headers = {};
    self.rawHeaders = [];
    self.trailers = {};
    self.rawTrailers = [];
    // Fake the 'close' event, but only once 'end' fires
    self.on("end", function() {
        // The nextTick is necessary to prevent the 'request' module from causing an infinite loop
        process.nextTick(function() {
            self.emit("close");
        });
    });
    if (mode === "fetch") {
        self._fetchResponse = response;
        self.url = response.url;
        self.statusCode = response.status;
        self.statusMessage = response.statusText;
        response.headers.forEach(function(header, key) {
            self.headers[key.toLowerCase()] = header;
            self.rawHeaders.push(key, header);
        });
        if (capability.writableStream) {
            var writable = new WritableStream({
                write: function(chunk) {
                    resetTimers(false);
                    return new Promise(function(resolve, reject) {
                        if (self._destroyed) reject();
                        else if (self.push(Buffer.from(chunk))) resolve();
                        else self._resumeFetch = resolve;
                    });
                },
                close: function() {
                    resetTimers(true);
                    if (!self._destroyed) self.push(null);
                },
                abort: function(err) {
                    resetTimers(true);
                    if (!self._destroyed) self.emit("error", err);
                }
            });
            try {
                response.body.pipeTo(writable).catch(function(err) {
                    resetTimers(true);
                    if (!self._destroyed) self.emit("error", err);
                });
                return;
            } catch (e) {} // pipeTo method isn't defined. Can't find a better way to feature test this
        }
        // fallback for when writableStream or pipeTo aren't available
        var reader = response.body.getReader();
        function read() {
            reader.read().then(function(result) {
                if (self._destroyed) return;
                resetTimers(result.done);
                if (result.done) {
                    self.push(null);
                    return;
                }
                self.push(Buffer.from(result.value));
                read();
            }).catch(function(err) {
                resetTimers(true);
                if (!self._destroyed) self.emit("error", err);
            });
        }
        read();
    } else {
        self._xhr = xhr;
        self._pos = 0;
        self.url = xhr.responseURL;
        self.statusCode = xhr.status;
        self.statusMessage = xhr.statusText;
        var headers = xhr.getAllResponseHeaders().split(/\r?\n/);
        headers.forEach(function(header) {
            var matches = header.match(/^([^:]+):\s*(.*)/);
            if (matches) {
                var key = matches[1].toLowerCase();
                if (key === "set-cookie") {
                    if (self.headers[key] === undefined) self.headers[key] = [];
                    self.headers[key].push(matches[2]);
                } else if (self.headers[key] !== undefined) self.headers[key] += ", " + matches[2];
                else self.headers[key] = matches[2];
                self.rawHeaders.push(matches[1], matches[2]);
            }
        });
        self._charset = "x-user-defined";
        if (!capability.overrideMimeType) {
            var mimeType = self.rawHeaders["mime-type"];
            if (mimeType) {
                var charsetMatch = mimeType.match(/;\s*charset=([^;])(;|$)/);
                if (charsetMatch) self._charset = charsetMatch[1].toLowerCase();
            }
            if (!self._charset) self._charset = "utf-8" // best guess
            ;
        }
    }
};
inherits(IncomingMessage, stream.Readable);
IncomingMessage.prototype._read = function() {
    var self = this;
    var resolve = self._resumeFetch;
    if (resolve) {
        self._resumeFetch = null;
        resolve();
    }
};
IncomingMessage.prototype._onXHRProgress = function(resetTimers) {
    var self = this;
    var xhr = self._xhr;
    var response = null;
    switch(self._mode){
        case "text":
            response = xhr.responseText;
            if (response.length > self._pos) {
                var newData = response.substr(self._pos);
                if (self._charset === "x-user-defined") {
                    var buffer = Buffer.alloc(newData.length);
                    for(var i = 0; i < newData.length; i++)buffer[i] = newData.charCodeAt(i) & 0xff;
                    self.push(buffer);
                } else self.push(newData, self._charset);
                self._pos = response.length;
            }
            break;
        case "arraybuffer":
            if (xhr.readyState !== rStates.DONE || !xhr.response) break;
            response = xhr.response;
            self.push(Buffer.from(new Uint8Array(response)));
            break;
        case "moz-chunked-arraybuffer":
            response = xhr.response;
            if (xhr.readyState !== rStates.LOADING || !response) break;
            self.push(Buffer.from(new Uint8Array(response)));
            break;
        case "ms-stream":
            response = xhr.response;
            if (xhr.readyState !== rStates.LOADING) break;
            var reader = new global.MSStreamReader();
            reader.onprogress = function() {
                if (reader.result.byteLength > self._pos) {
                    self.push(Buffer.from(new Uint8Array(reader.result.slice(self._pos))));
                    self._pos = reader.result.byteLength;
                }
            };
            reader.onload = function() {
                resetTimers(true);
                self.push(null);
            };
            // reader.onerror = ??? // TODO: this
            reader.readAsArrayBuffer(response);
            break;
    }
    // The ms-stream case handles end separately in reader.onload()
    if (self._xhr.readyState === rStates.DONE && self._mode !== "ms-stream") {
        resetTimers(true);
        self.push(null);
    }
};

},{"d1269065c33ee7fe":"5QIF0","77d4ce6cf763caca":"l5Twm","7dcf7aadbb533bfb":"kHzFH","57b1383434ef92a1":"8LxVj","fa2873d490014c0a":"k5khq"}],"k5khq":[function(require,module,exports) {
exports = module.exports = require("68bb3bdae87803ec");
exports.Stream = exports;
exports.Readable = exports;
exports.Writable = require("74167f79b688eaf7");
exports.Duplex = require("84600f6783428a47");
exports.Transform = require("23bee5f697448a0");
exports.PassThrough = require("e0ec4b8e438dbbd");
exports.finished = require("6cc0f9af7147cdbc");
exports.pipeline = require("f90db22d01d3c3d1");

},{"68bb3bdae87803ec":"cKiEz","74167f79b688eaf7":"1l9D3","84600f6783428a47":"jXYL7","23bee5f697448a0":"fyAZh","e0ec4b8e438dbbd":"3kmEt","6cc0f9af7147cdbc":"YQEqF","f90db22d01d3c3d1":"3jCgz"}],"cKiEz":[function(require,module,exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
var global = arguments[3];
var process = require("896ff8d56553f7a");
"use strict";
module.exports = Readable;
/*<replacement>*/ var Duplex;
/*</replacement>*/ Readable.ReadableState = ReadableState;
/*<replacement>*/ var EE = require("16782d660ac22e0c").EventEmitter;
var EElistenerCount = function EElistenerCount(emitter, type) {
    return emitter.listeners(type).length;
};
/*</replacement>*/ /*<replacement>*/ var Stream = require("9a34f23fa53f83f7");
/*</replacement>*/ var Buffer = require("fb95ecaa88342eae").Buffer;
var OurUint8Array = (typeof global !== "undefined" ? global : typeof window !== "undefined" ? window : typeof self !== "undefined" ? self : {}).Uint8Array || function() {};
function _uint8ArrayToBuffer(chunk) {
    return Buffer.from(chunk);
}
function _isUint8Array(obj) {
    return Buffer.isBuffer(obj) || obj instanceof OurUint8Array;
}
/*<replacement>*/ var debugUtil = require("a4a723b7297c7152");
var debug;
if (debugUtil && debugUtil.debuglog) debug = debugUtil.debuglog("stream");
else debug = function debug() {};
/*</replacement>*/ var BufferList = require("7a14cc1689b8c63e");
var destroyImpl = require("efa8155386cc4283");
var _require = require("994c984d08c7bbf2"), getHighWaterMark = _require.getHighWaterMark;
var _require$codes = require("8de60461b822641b").codes, ERR_INVALID_ARG_TYPE = _require$codes.ERR_INVALID_ARG_TYPE, ERR_STREAM_PUSH_AFTER_EOF = _require$codes.ERR_STREAM_PUSH_AFTER_EOF, ERR_METHOD_NOT_IMPLEMENTED = _require$codes.ERR_METHOD_NOT_IMPLEMENTED, ERR_STREAM_UNSHIFT_AFTER_END_EVENT = _require$codes.ERR_STREAM_UNSHIFT_AFTER_END_EVENT;
// Lazy loaded to improve the startup performance.
var StringDecoder;
var createReadableStreamAsyncIterator;
var from;
require("19affa8ce41f090d")(Readable, Stream);
var errorOrDestroy = destroyImpl.errorOrDestroy;
var kProxyEvents = [
    "error",
    "close",
    "destroy",
    "pause",
    "resume"
];
function prependListener(emitter, event, fn) {
    // Sadly this is not cacheable as some libraries bundle their own
    // event emitter implementation with them.
    if (typeof emitter.prependListener === "function") return emitter.prependListener(event, fn);
    // This is a hack to make sure that our error handler is attached before any
    // userland ones.  NEVER DO THIS. This is here only because this code needs
    // to continue to work with older versions of Node.js that do not include
    // the prependListener() method. The goal is to eventually remove this hack.
    if (!emitter._events || !emitter._events[event]) emitter.on(event, fn);
    else if (Array.isArray(emitter._events[event])) emitter._events[event].unshift(fn);
    else emitter._events[event] = [
        fn,
        emitter._events[event]
    ];
}
function ReadableState(options, stream, isDuplex) {
    Duplex = Duplex || require("f1c95f846e94e4eb");
    options = options || {};
    // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream.
    // These options can be provided separately as readableXXX and writableXXX.
    if (typeof isDuplex !== "boolean") isDuplex = stream instanceof Duplex;
    // object stream flag. Used to make read(n) ignore n and to
    // make all the buffer merging and length checks go away
    this.objectMode = !!options.objectMode;
    if (isDuplex) this.objectMode = this.objectMode || !!options.readableObjectMode;
    // the point at which it stops calling _read() to fill the buffer
    // Note: 0 is a valid value, means "don't call _read preemptively ever"
    this.highWaterMark = getHighWaterMark(this, options, "readableHighWaterMark", isDuplex);
    // A linked list is used to store data chunks instead of an array because the
    // linked list can remove elements from the beginning faster than
    // array.shift()
    this.buffer = new BufferList();
    this.length = 0;
    this.pipes = null;
    this.pipesCount = 0;
    this.flowing = null;
    this.ended = false;
    this.endEmitted = false;
    this.reading = false;
    // a flag to be able to tell if the event 'readable'/'data' is emitted
    // immediately, or on a later tick.  We set this to true at first, because
    // any actions that shouldn't happen until "later" should generally also
    // not happen before the first read call.
    this.sync = true;
    // whenever we return null, then we set a flag to say
    // that we're awaiting a 'readable' event emission.
    this.needReadable = false;
    this.emittedReadable = false;
    this.readableListening = false;
    this.resumeScheduled = false;
    this.paused = true;
    // Should close be emitted on destroy. Defaults to true.
    this.emitClose = options.emitClose !== false;
    // Should .destroy() be called after 'end' (and potentially 'finish')
    this.autoDestroy = !!options.autoDestroy;
    // has it been destroyed
    this.destroyed = false;
    // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options.defaultEncoding || "utf8";
    // the number of writers that are awaiting a drain event in .pipe()s
    this.awaitDrain = 0;
    // if true, a maybeReadMore has been scheduled
    this.readingMore = false;
    this.decoder = null;
    this.encoding = null;
    if (options.encoding) {
        if (!StringDecoder) StringDecoder = require("6392acd10886f115").StringDecoder;
        this.decoder = new StringDecoder(options.encoding);
        this.encoding = options.encoding;
    }
}
function Readable(options) {
    Duplex = Duplex || require("f1c95f846e94e4eb");
    if (!(this instanceof Readable)) return new Readable(options);
    // Checking for a Stream.Duplex instance is faster here instead of inside
    // the ReadableState constructor, at least with V8 6.5
    var isDuplex = this instanceof Duplex;
    this._readableState = new ReadableState(options, this, isDuplex);
    // legacy
    this.readable = true;
    if (options) {
        if (typeof options.read === "function") this._read = options.read;
        if (typeof options.destroy === "function") this._destroy = options.destroy;
    }
    Stream.call(this);
}
Object.defineProperty(Readable.prototype, "destroyed", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        if (this._readableState === undefined) return false;
        return this._readableState.destroyed;
    },
    set: function set(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (!this._readableState) return;
        // backward compatibility, the user is explicitly
        // managing destroyed
        this._readableState.destroyed = value;
    }
});
Readable.prototype.destroy = destroyImpl.destroy;
Readable.prototype._undestroy = destroyImpl.undestroy;
Readable.prototype._destroy = function(err, cb) {
    cb(err);
};
// Manually shove something into the read() buffer.
// This returns true if the highWaterMark has not been hit yet,
// similar to how Writable.write() returns true if you should
// write() some more.
Readable.prototype.push = function(chunk, encoding) {
    var state = this._readableState;
    var skipChunkCheck;
    if (!state.objectMode) {
        if (typeof chunk === "string") {
            encoding = encoding || state.defaultEncoding;
            if (encoding !== state.encoding) {
                chunk = Buffer.from(chunk, encoding);
                encoding = "";
            }
            skipChunkCheck = true;
        }
    } else skipChunkCheck = true;
    return readableAddChunk(this, chunk, encoding, false, skipChunkCheck);
};
// Unshift should *always* be something directly out of read()
Readable.prototype.unshift = function(chunk) {
    return readableAddChunk(this, chunk, null, true, false);
};
function readableAddChunk(stream, chunk, encoding, addToFront, skipChunkCheck) {
    debug("readableAddChunk", chunk);
    var state = stream._readableState;
    if (chunk === null) {
        state.reading = false;
        onEofChunk(stream, state);
    } else {
        var er;
        if (!skipChunkCheck) er = chunkInvalid(state, chunk);
        if (er) errorOrDestroy(stream, er);
        else if (state.objectMode || chunk && chunk.length > 0) {
            if (typeof chunk !== "string" && !state.objectMode && Object.getPrototypeOf(chunk) !== Buffer.prototype) chunk = _uint8ArrayToBuffer(chunk);
            if (addToFront) {
                if (state.endEmitted) errorOrDestroy(stream, new ERR_STREAM_UNSHIFT_AFTER_END_EVENT());
                else addChunk(stream, state, chunk, true);
            } else if (state.ended) errorOrDestroy(stream, new ERR_STREAM_PUSH_AFTER_EOF());
            else if (state.destroyed) return false;
            else {
                state.reading = false;
                if (state.decoder && !encoding) {
                    chunk = state.decoder.write(chunk);
                    if (state.objectMode || chunk.length !== 0) addChunk(stream, state, chunk, false);
                    else maybeReadMore(stream, state);
                } else addChunk(stream, state, chunk, false);
            }
        } else if (!addToFront) {
            state.reading = false;
            maybeReadMore(stream, state);
        }
    }
    // We can push more data if we are below the highWaterMark.
    // Also, if we have no data yet, we can stand some more bytes.
    // This is to work around cases where hwm=0, such as the repl.
    return !state.ended && (state.length < state.highWaterMark || state.length === 0);
}
function addChunk(stream, state, chunk, addToFront) {
    if (state.flowing && state.length === 0 && !state.sync) {
        state.awaitDrain = 0;
        stream.emit("data", chunk);
    } else {
        // update the buffer info.
        state.length += state.objectMode ? 1 : chunk.length;
        if (addToFront) state.buffer.unshift(chunk);
        else state.buffer.push(chunk);
        if (state.needReadable) emitReadable(stream);
    }
    maybeReadMore(stream, state);
}
function chunkInvalid(state, chunk) {
    var er;
    if (!_isUint8Array(chunk) && typeof chunk !== "string" && chunk !== undefined && !state.objectMode) er = new ERR_INVALID_ARG_TYPE("chunk", [
        "string",
        "Buffer",
        "Uint8Array"
    ], chunk);
    return er;
}
Readable.prototype.isPaused = function() {
    return this._readableState.flowing === false;
};
// backwards compatibility.
Readable.prototype.setEncoding = function(enc) {
    if (!StringDecoder) StringDecoder = require("6392acd10886f115").StringDecoder;
    var decoder = new StringDecoder(enc);
    this._readableState.decoder = decoder;
    // If setEncoding(null), decoder.encoding equals utf8
    this._readableState.encoding = this._readableState.decoder.encoding;
    // Iterate over current buffer to convert already stored Buffers:
    var p = this._readableState.buffer.head;
    var content = "";
    while(p !== null){
        content += decoder.write(p.data);
        p = p.next;
    }
    this._readableState.buffer.clear();
    if (content !== "") this._readableState.buffer.push(content);
    this._readableState.length = content.length;
    return this;
};
// Don't raise the hwm > 1GB
var MAX_HWM = 0x40000000;
function computeNewHighWaterMark(n) {
    if (n >= MAX_HWM) // TODO(ronag): Throw ERR_VALUE_OUT_OF_RANGE.
    n = MAX_HWM;
    else {
        // Get the next highest power of 2 to prevent increasing hwm excessively in
        // tiny amounts
        n--;
        n |= n >>> 1;
        n |= n >>> 2;
        n |= n >>> 4;
        n |= n >>> 8;
        n |= n >>> 16;
        n++;
    }
    return n;
}
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function howMuchToRead(n, state) {
    if (n <= 0 || state.length === 0 && state.ended) return 0;
    if (state.objectMode) return 1;
    if (n !== n) {
        // Only flow one buffer at a time
        if (state.flowing && state.length) return state.buffer.head.data.length;
        else return state.length;
    }
    // If we're asking for more than the current hwm, then raise the hwm.
    if (n > state.highWaterMark) state.highWaterMark = computeNewHighWaterMark(n);
    if (n <= state.length) return n;
    // Don't have enough
    if (!state.ended) {
        state.needReadable = true;
        return 0;
    }
    return state.length;
}
// you can override either this method, or the async _read(n) below.
Readable.prototype.read = function(n) {
    debug("read", n);
    n = parseInt(n, 10);
    var state = this._readableState;
    var nOrig = n;
    if (n !== 0) state.emittedReadable = false;
    // if we're doing read(0) to trigger a readable event, but we
    // already have a bunch of data in the buffer, then just trigger
    // the 'readable' event and move on.
    if (n === 0 && state.needReadable && ((state.highWaterMark !== 0 ? state.length >= state.highWaterMark : state.length > 0) || state.ended)) {
        debug("read: emitReadable", state.length, state.ended);
        if (state.length === 0 && state.ended) endReadable(this);
        else emitReadable(this);
        return null;
    }
    n = howMuchToRead(n, state);
    // if we've ended, and we're now clear, then finish it up.
    if (n === 0 && state.ended) {
        if (state.length === 0) endReadable(this);
        return null;
    }
    // All the actual chunk generation logic needs to be
    // *below* the call to _read.  The reason is that in certain
    // synthetic stream cases, such as passthrough streams, _read
    // may be a completely synchronous operation which may change
    // the state of the read buffer, providing enough data when
    // before there was *not* enough.
    //
    // So, the steps are:
    // 1. Figure out what the state of things will be after we do
    // a read from the buffer.
    //
    // 2. If that resulting state will trigger a _read, then call _read.
    // Note that this may be asynchronous, or synchronous.  Yes, it is
    // deeply ugly to write APIs this way, but that still doesn't mean
    // that the Readable class should behave improperly, as streams are
    // designed to be sync/async agnostic.
    // Take note if the _read call is sync or async (ie, if the read call
    // has returned yet), so that we know whether or not it's safe to emit
    // 'readable' etc.
    //
    // 3. Actually pull the requested chunks out of the buffer and return.
    // if we need a readable event, then we need to do some reading.
    var doRead = state.needReadable;
    debug("need readable", doRead);
    // if we currently have less than the highWaterMark, then also read some
    if (state.length === 0 || state.length - n < state.highWaterMark) {
        doRead = true;
        debug("length less than watermark", doRead);
    }
    // however, if we've ended, then there's no point, and if we're already
    // reading, then it's unnecessary.
    if (state.ended || state.reading) {
        doRead = false;
        debug("reading or ended", doRead);
    } else if (doRead) {
        debug("do read");
        state.reading = true;
        state.sync = true;
        // if the length is currently zero, then we *need* a readable event.
        if (state.length === 0) state.needReadable = true;
        // call internal read method
        this._read(state.highWaterMark);
        state.sync = false;
        // If _read pushed data synchronously, then `reading` will be false,
        // and we need to re-evaluate how much data we can return to the user.
        if (!state.reading) n = howMuchToRead(nOrig, state);
    }
    var ret;
    if (n > 0) ret = fromList(n, state);
    else ret = null;
    if (ret === null) {
        state.needReadable = state.length <= state.highWaterMark;
        n = 0;
    } else {
        state.length -= n;
        state.awaitDrain = 0;
    }
    if (state.length === 0) {
        // If we have nothing in the buffer, then we want to know
        // as soon as we *do* get something into the buffer.
        if (!state.ended) state.needReadable = true;
        // If we tried to read() past the EOF, then emit end on the next tick.
        if (nOrig !== n && state.ended) endReadable(this);
    }
    if (ret !== null) this.emit("data", ret);
    return ret;
};
function onEofChunk(stream, state) {
    debug("onEofChunk");
    if (state.ended) return;
    if (state.decoder) {
        var chunk = state.decoder.end();
        if (chunk && chunk.length) {
            state.buffer.push(chunk);
            state.length += state.objectMode ? 1 : chunk.length;
        }
    }
    state.ended = true;
    if (state.sync) // if we are sync, wait until next tick to emit the data.
    // Otherwise we risk emitting data in the flow()
    // the readable code triggers during a read() call
    emitReadable(stream);
    else {
        // emit 'readable' now to make sure it gets picked up.
        state.needReadable = false;
        if (!state.emittedReadable) {
            state.emittedReadable = true;
            emitReadable_(stream);
        }
    }
}
// Don't emit readable right away in sync mode, because this can trigger
// another read() call => stack overflow.  This way, it might trigger
// a nextTick recursion warning, but that's not so bad.
function emitReadable(stream) {
    var state = stream._readableState;
    debug("emitReadable", state.needReadable, state.emittedReadable);
    state.needReadable = false;
    if (!state.emittedReadable) {
        debug("emitReadable", state.flowing);
        state.emittedReadable = true;
        process.nextTick(emitReadable_, stream);
    }
}
function emitReadable_(stream) {
    var state = stream._readableState;
    debug("emitReadable_", state.destroyed, state.length, state.ended);
    if (!state.destroyed && (state.length || state.ended)) {
        stream.emit("readable");
        state.emittedReadable = false;
    }
    // The stream needs another readable event if
    // 1. It is not flowing, as the flow mechanism will take
    //    care of it.
    // 2. It is not ended.
    // 3. It is below the highWaterMark, so we can schedule
    //    another readable later.
    state.needReadable = !state.flowing && !state.ended && state.length <= state.highWaterMark;
    flow(stream);
}
// at this point, the user has presumably seen the 'readable' event,
// and called read() to consume some data.  that may have triggered
// in turn another _read(n) call, in which case reading = true if
// it's in progress.
// However, if we're not ended, or reading, and the length < hwm,
// then go ahead and try to read some more preemptively.
function maybeReadMore(stream, state) {
    if (!state.readingMore) {
        state.readingMore = true;
        process.nextTick(maybeReadMore_, stream, state);
    }
}
function maybeReadMore_(stream, state) {
    // Attempt to read more data if we should.
    //
    // The conditions for reading more data are (one of):
    // - Not enough data buffered (state.length < state.highWaterMark). The loop
    //   is responsible for filling the buffer with enough data if such data
    //   is available. If highWaterMark is 0 and we are not in the flowing mode
    //   we should _not_ attempt to buffer any extra data. We'll get more data
    //   when the stream consumer calls read() instead.
    // - No data in the buffer, and the stream is in flowing mode. In this mode
    //   the loop below is responsible for ensuring read() is called. Failing to
    //   call read here would abort the flow and there's no other mechanism for
    //   continuing the flow if the stream consumer has just subscribed to the
    //   'data' event.
    //
    // In addition to the above conditions to keep reading data, the following
    // conditions prevent the data from being read:
    // - The stream has ended (state.ended).
    // - There is already a pending 'read' operation (state.reading). This is a
    //   case where the the stream has called the implementation defined _read()
    //   method, but they are processing the call asynchronously and have _not_
    //   called push() with new data. In this case we skip performing more
    //   read()s. The execution ends in this method again after the _read() ends
    //   up calling push() with more data.
    while(!state.reading && !state.ended && (state.length < state.highWaterMark || state.flowing && state.length === 0)){
        var len = state.length;
        debug("maybeReadMore read 0");
        stream.read(0);
        if (len === state.length) break;
    }
    state.readingMore = false;
}
// abstract method.  to be overridden in specific implementation classes.
// call cb(er, data) where data is <= n in length.
// for virtual (non-string, non-buffer) streams, "length" is somewhat
// arbitrary, and perhaps not very meaningful.
Readable.prototype._read = function(n) {
    errorOrDestroy(this, new ERR_METHOD_NOT_IMPLEMENTED("_read()"));
};
Readable.prototype.pipe = function(dest, pipeOpts) {
    var src = this;
    var state = this._readableState;
    switch(state.pipesCount){
        case 0:
            state.pipes = dest;
            break;
        case 1:
            state.pipes = [
                state.pipes,
                dest
            ];
            break;
        default:
            state.pipes.push(dest);
            break;
    }
    state.pipesCount += 1;
    debug("pipe count=%d opts=%j", state.pipesCount, pipeOpts);
    var doEnd = (!pipeOpts || pipeOpts.end !== false) && dest !== process.stdout && dest !== process.stderr;
    var endFn = doEnd ? onend : unpipe;
    if (state.endEmitted) process.nextTick(endFn);
    else src.once("end", endFn);
    dest.on("unpipe", onunpipe);
    function onunpipe(readable, unpipeInfo) {
        debug("onunpipe");
        if (readable === src) {
            if (unpipeInfo && unpipeInfo.hasUnpiped === false) {
                unpipeInfo.hasUnpiped = true;
                cleanup();
            }
        }
    }
    function onend() {
        debug("onend");
        dest.end();
    }
    // when the dest drains, it reduces the awaitDrain counter
    // on the source.  This would be more elegant with a .once()
    // handler in flow(), but adding and removing repeatedly is
    // too slow.
    var ondrain = pipeOnDrain(src);
    dest.on("drain", ondrain);
    var cleanedUp = false;
    function cleanup() {
        debug("cleanup");
        // cleanup event handlers once the pipe is broken
        dest.removeListener("close", onclose);
        dest.removeListener("finish", onfinish);
        dest.removeListener("drain", ondrain);
        dest.removeListener("error", onerror);
        dest.removeListener("unpipe", onunpipe);
        src.removeListener("end", onend);
        src.removeListener("end", unpipe);
        src.removeListener("data", ondata);
        cleanedUp = true;
        // if the reader is waiting for a drain event from this
        // specific writer, then it would cause it to never start
        // flowing again.
        // So, if this is awaiting a drain, then we just call it now.
        // If we don't know, then assume that we are waiting for one.
        if (state.awaitDrain && (!dest._writableState || dest._writableState.needDrain)) ondrain();
    }
    src.on("data", ondata);
    function ondata(chunk) {
        debug("ondata");
        var ret = dest.write(chunk);
        debug("dest.write", ret);
        if (ret === false) {
            // If the user unpiped during `dest.write()`, it is possible
            // to get stuck in a permanently paused state if that write
            // also returned false.
            // => Check whether `dest` is still a piping destination.
            if ((state.pipesCount === 1 && state.pipes === dest || state.pipesCount > 1 && indexOf(state.pipes, dest) !== -1) && !cleanedUp) {
                debug("false write response, pause", state.awaitDrain);
                state.awaitDrain++;
            }
            src.pause();
        }
    }
    // if the dest has an error, then stop piping into it.
    // however, don't suppress the throwing behavior for this.
    function onerror(er) {
        debug("onerror", er);
        unpipe();
        dest.removeListener("error", onerror);
        if (EElistenerCount(dest, "error") === 0) errorOrDestroy(dest, er);
    }
    // Make sure our error handler is attached before userland ones.
    prependListener(dest, "error", onerror);
    // Both close and finish should trigger unpipe, but only once.
    function onclose() {
        dest.removeListener("finish", onfinish);
        unpipe();
    }
    dest.once("close", onclose);
    function onfinish() {
        debug("onfinish");
        dest.removeListener("close", onclose);
        unpipe();
    }
    dest.once("finish", onfinish);
    function unpipe() {
        debug("unpipe");
        src.unpipe(dest);
    }
    // tell the dest that it's being piped to
    dest.emit("pipe", src);
    // start the flow if it hasn't been started already.
    if (!state.flowing) {
        debug("pipe resume");
        src.resume();
    }
    return dest;
};
function pipeOnDrain(src) {
    return function pipeOnDrainFunctionResult() {
        var state = src._readableState;
        debug("pipeOnDrain", state.awaitDrain);
        if (state.awaitDrain) state.awaitDrain--;
        if (state.awaitDrain === 0 && EElistenerCount(src, "data")) {
            state.flowing = true;
            flow(src);
        }
    };
}
Readable.prototype.unpipe = function(dest) {
    var state = this._readableState;
    var unpipeInfo = {
        hasUnpiped: false
    };
    // if we're not piping anywhere, then do nothing.
    if (state.pipesCount === 0) return this;
    // just one destination.  most common case.
    if (state.pipesCount === 1) {
        // passed in one, but it's not the right one.
        if (dest && dest !== state.pipes) return this;
        if (!dest) dest = state.pipes;
        // got a match.
        state.pipes = null;
        state.pipesCount = 0;
        state.flowing = false;
        if (dest) dest.emit("unpipe", this, unpipeInfo);
        return this;
    }
    // slow case. multiple pipe destinations.
    if (!dest) {
        // remove all.
        var dests = state.pipes;
        var len = state.pipesCount;
        state.pipes = null;
        state.pipesCount = 0;
        state.flowing = false;
        for(var i = 0; i < len; i++)dests[i].emit("unpipe", this, {
            hasUnpiped: false
        });
        return this;
    }
    // try to find the right one.
    var index = indexOf(state.pipes, dest);
    if (index === -1) return this;
    state.pipes.splice(index, 1);
    state.pipesCount -= 1;
    if (state.pipesCount === 1) state.pipes = state.pipes[0];
    dest.emit("unpipe", this, unpipeInfo);
    return this;
};
// set up data events if they are asked for
// Ensure readable listeners eventually get something
Readable.prototype.on = function(ev, fn) {
    var res = Stream.prototype.on.call(this, ev, fn);
    var state = this._readableState;
    if (ev === "data") {
        // update readableListening so that resume() may be a no-op
        // a few lines down. This is needed to support once('readable').
        state.readableListening = this.listenerCount("readable") > 0;
        // Try start flowing on next tick if stream isn't explicitly paused
        if (state.flowing !== false) this.resume();
    } else if (ev === "readable") {
        if (!state.endEmitted && !state.readableListening) {
            state.readableListening = state.needReadable = true;
            state.flowing = false;
            state.emittedReadable = false;
            debug("on readable", state.length, state.reading);
            if (state.length) emitReadable(this);
            else if (!state.reading) process.nextTick(nReadingNextTick, this);
        }
    }
    return res;
};
Readable.prototype.addListener = Readable.prototype.on;
Readable.prototype.removeListener = function(ev, fn) {
    var res = Stream.prototype.removeListener.call(this, ev, fn);
    if (ev === "readable") // We need to check if there is someone still listening to
    // readable and reset the state. However this needs to happen
    // after readable has been emitted but before I/O (nextTick) to
    // support once('readable', fn) cycles. This means that calling
    // resume within the same tick will have no
    // effect.
    process.nextTick(updateReadableListening, this);
    return res;
};
Readable.prototype.removeAllListeners = function(ev) {
    var res = Stream.prototype.removeAllListeners.apply(this, arguments);
    if (ev === "readable" || ev === undefined) // We need to check if there is someone still listening to
    // readable and reset the state. However this needs to happen
    // after readable has been emitted but before I/O (nextTick) to
    // support once('readable', fn) cycles. This means that calling
    // resume within the same tick will have no
    // effect.
    process.nextTick(updateReadableListening, this);
    return res;
};
function updateReadableListening(self1) {
    var state = self1._readableState;
    state.readableListening = self1.listenerCount("readable") > 0;
    if (state.resumeScheduled && !state.paused) // flowing needs to be set to true now, otherwise
    // the upcoming resume will not flow.
    state.flowing = true;
    else if (self1.listenerCount("data") > 0) self1.resume();
}
function nReadingNextTick(self1) {
    debug("readable nexttick read 0");
    self1.read(0);
}
// pause() and resume() are remnants of the legacy readable stream API
// If the user uses them, then switch into old mode.
Readable.prototype.resume = function() {
    var state = this._readableState;
    if (!state.flowing) {
        debug("resume");
        // we flow only if there is no one listening
        // for readable, but we still have to call
        // resume()
        state.flowing = !state.readableListening;
        resume(this, state);
    }
    state.paused = false;
    return this;
};
function resume(stream, state) {
    if (!state.resumeScheduled) {
        state.resumeScheduled = true;
        process.nextTick(resume_, stream, state);
    }
}
function resume_(stream, state) {
    debug("resume", state.reading);
    if (!state.reading) stream.read(0);
    state.resumeScheduled = false;
    stream.emit("resume");
    flow(stream);
    if (state.flowing && !state.reading) stream.read(0);
}
Readable.prototype.pause = function() {
    debug("call pause flowing=%j", this._readableState.flowing);
    if (this._readableState.flowing !== false) {
        debug("pause");
        this._readableState.flowing = false;
        this.emit("pause");
    }
    this._readableState.paused = true;
    return this;
};
function flow(stream) {
    var state = stream._readableState;
    debug("flow", state.flowing);
    while(state.flowing && stream.read() !== null);
}
// wrap an old-style stream as the async data source.
// This is *not* part of the readable stream interface.
// It is an ugly unfortunate mess of history.
Readable.prototype.wrap = function(stream) {
    var _this = this;
    var state = this._readableState;
    var paused = false;
    stream.on("end", function() {
        debug("wrapped end");
        if (state.decoder && !state.ended) {
            var chunk = state.decoder.end();
            if (chunk && chunk.length) _this.push(chunk);
        }
        _this.push(null);
    });
    stream.on("data", function(chunk) {
        debug("wrapped data");
        if (state.decoder) chunk = state.decoder.write(chunk);
        // don't skip over falsy values in objectMode
        if (state.objectMode && (chunk === null || chunk === undefined)) return;
        else if (!state.objectMode && (!chunk || !chunk.length)) return;
        var ret = _this.push(chunk);
        if (!ret) {
            paused = true;
            stream.pause();
        }
    });
    // proxy all the other methods.
    // important when wrapping filters and duplexes.
    for(var i in stream)if (this[i] === undefined && typeof stream[i] === "function") this[i] = function methodWrap(method) {
        return function methodWrapReturnFunction() {
            return stream[method].apply(stream, arguments);
        };
    }(i);
    // proxy certain important events.
    for(var n = 0; n < kProxyEvents.length; n++)stream.on(kProxyEvents[n], this.emit.bind(this, kProxyEvents[n]));
    // when we try to consume some more bytes, simply unpause the
    // underlying stream.
    this._read = function(n) {
        debug("wrapped _read", n);
        if (paused) {
            paused = false;
            stream.resume();
        }
    };
    return this;
};
if (typeof Symbol === "function") Readable.prototype[Symbol.asyncIterator] = function() {
    if (createReadableStreamAsyncIterator === undefined) createReadableStreamAsyncIterator = require("830c56f840811f05");
    return createReadableStreamAsyncIterator(this);
};
Object.defineProperty(Readable.prototype, "readableHighWaterMark", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._readableState.highWaterMark;
    }
});
Object.defineProperty(Readable.prototype, "readableBuffer", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._readableState && this._readableState.buffer;
    }
});
Object.defineProperty(Readable.prototype, "readableFlowing", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._readableState.flowing;
    },
    set: function set(state) {
        if (this._readableState) this._readableState.flowing = state;
    }
});
// exposed for testing purposes only.
Readable._fromList = fromList;
Object.defineProperty(Readable.prototype, "readableLength", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._readableState.length;
    }
});
// Pluck off n bytes from an array of buffers.
// Length is the combined lengths of all the buffers in the list.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function fromList(n, state) {
    // nothing buffered
    if (state.length === 0) return null;
    var ret;
    if (state.objectMode) ret = state.buffer.shift();
    else if (!n || n >= state.length) {
        // read it all, truncate the list
        if (state.decoder) ret = state.buffer.join("");
        else if (state.buffer.length === 1) ret = state.buffer.first();
        else ret = state.buffer.concat(state.length);
        state.buffer.clear();
    } else // read part of list
    ret = state.buffer.consume(n, state.decoder);
    return ret;
}
function endReadable(stream) {
    var state = stream._readableState;
    debug("endReadable", state.endEmitted);
    if (!state.endEmitted) {
        state.ended = true;
        process.nextTick(endReadableNT, state, stream);
    }
}
function endReadableNT(state, stream) {
    debug("endReadableNT", state.endEmitted, state.length);
    // Check that we didn't get one last unshift.
    if (!state.endEmitted && state.length === 0) {
        state.endEmitted = true;
        stream.readable = false;
        stream.emit("end");
        if (state.autoDestroy) {
            // In case of duplex streams we need a way to detect
            // if the writable side is ready for autoDestroy as well
            var wState = stream._writableState;
            if (!wState || wState.autoDestroy && wState.finished) stream.destroy();
        }
    }
}
if (typeof Symbol === "function") Readable.from = function(iterable, opts) {
    if (from === undefined) from = require("7451b8c4bf72370");
    return from(Readable, iterable, opts);
};
function indexOf(xs, x) {
    for(var i = 0, l = xs.length; i < l; i++){
        if (xs[i] === x) return i;
    }
    return -1;
}

},{"896ff8d56553f7a":"5QIF0","16782d660ac22e0c":"fqTtD","9a34f23fa53f83f7":"9k4qR","fb95ecaa88342eae":"l5Twm","a4a723b7297c7152":"13Pcp","7a14cc1689b8c63e":"XxY4N","efa8155386cc4283":"jRCu7","994c984d08c7bbf2":"e5vN8","8de60461b822641b":"64341","19affa8ce41f090d":"8LxVj","f1c95f846e94e4eb":"jXYL7","6392acd10886f115":"dr7zb","830c56f840811f05":"3TcjU","7451b8c4bf72370":"39HiC"}],"9k4qR":[function(require,module,exports) {
module.exports = require("ed88fc9aa73f911").EventEmitter;

},{"ed88fc9aa73f911":"fqTtD"}],"XxY4N":[function(require,module,exports) {
"use strict";
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? ownKeys(Object(source), !0).forEach(function(key) {
            _defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _defineProperty(obj, key, value) {
    key = _toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function _toPropertyKey(arg) {
    var key = _toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
function _toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
var _require = require("59f5d0111b7fa075"), Buffer = _require.Buffer;
var _require2 = require("eef6a677577349b8"), inspect = _require2.inspect;
var custom = inspect && inspect.custom || "inspect";
function copyBuffer(src, target, offset) {
    Buffer.prototype.copy.call(src, target, offset);
}
module.exports = /*#__PURE__*/ function() {
    function BufferList() {
        _classCallCheck(this, BufferList);
        this.head = null;
        this.tail = null;
        this.length = 0;
    }
    _createClass(BufferList, [
        {
            key: "push",
            value: function push(v) {
                var entry = {
                    data: v,
                    next: null
                };
                if (this.length > 0) this.tail.next = entry;
                else this.head = entry;
                this.tail = entry;
                ++this.length;
            }
        },
        {
            key: "unshift",
            value: function unshift(v) {
                var entry = {
                    data: v,
                    next: this.head
                };
                if (this.length === 0) this.tail = entry;
                this.head = entry;
                ++this.length;
            }
        },
        {
            key: "shift",
            value: function shift() {
                if (this.length === 0) return;
                var ret = this.head.data;
                if (this.length === 1) this.head = this.tail = null;
                else this.head = this.head.next;
                --this.length;
                return ret;
            }
        },
        {
            key: "clear",
            value: function clear() {
                this.head = this.tail = null;
                this.length = 0;
            }
        },
        {
            key: "join",
            value: function join(s) {
                if (this.length === 0) return "";
                var p = this.head;
                var ret = "" + p.data;
                while(p = p.next)ret += s + p.data;
                return ret;
            }
        },
        {
            key: "concat",
            value: function concat(n) {
                if (this.length === 0) return Buffer.alloc(0);
                var ret = Buffer.allocUnsafe(n >>> 0);
                var p = this.head;
                var i = 0;
                while(p){
                    copyBuffer(p.data, ret, i);
                    i += p.data.length;
                    p = p.next;
                }
                return ret;
            }
        },
        {
            key: "consume",
            value: function consume(n, hasStrings) {
                var ret;
                if (n < this.head.data.length) {
                    // `slice` is the same for buffers and strings.
                    ret = this.head.data.slice(0, n);
                    this.head.data = this.head.data.slice(n);
                } else if (n === this.head.data.length) // First chunk is a perfect match.
                ret = this.shift();
                else // Result spans more than one buffer.
                ret = hasStrings ? this._getString(n) : this._getBuffer(n);
                return ret;
            }
        },
        {
            key: "first",
            value: function first() {
                return this.head.data;
            }
        },
        {
            key: "_getString",
            value: function _getString(n) {
                var p = this.head;
                var c = 1;
                var ret = p.data;
                n -= ret.length;
                while(p = p.next){
                    var str = p.data;
                    var nb = n > str.length ? str.length : n;
                    if (nb === str.length) ret += str;
                    else ret += str.slice(0, n);
                    n -= nb;
                    if (n === 0) {
                        if (nb === str.length) {
                            ++c;
                            if (p.next) this.head = p.next;
                            else this.head = this.tail = null;
                        } else {
                            this.head = p;
                            p.data = str.slice(nb);
                        }
                        break;
                    }
                    ++c;
                }
                this.length -= c;
                return ret;
            }
        },
        {
            key: "_getBuffer",
            value: function _getBuffer(n) {
                var ret = Buffer.allocUnsafe(n);
                var p = this.head;
                var c = 1;
                p.data.copy(ret);
                n -= p.data.length;
                while(p = p.next){
                    var buf = p.data;
                    var nb = n > buf.length ? buf.length : n;
                    buf.copy(ret, ret.length - n, 0, nb);
                    n -= nb;
                    if (n === 0) {
                        if (nb === buf.length) {
                            ++c;
                            if (p.next) this.head = p.next;
                            else this.head = this.tail = null;
                        } else {
                            this.head = p;
                            p.data = buf.slice(nb);
                        }
                        break;
                    }
                    ++c;
                }
                this.length -= c;
                return ret;
            }
        },
        {
            key: custom,
            value: function value(_, options) {
                return inspect(this, _objectSpread(_objectSpread({}, options), {}, {
                    // Only inspect one level.
                    depth: 0,
                    // It should not recurse.
                    customInspect: false
                }));
            }
        }
    ]);
    return BufferList;
}();

},{"59f5d0111b7fa075":"l5Twm","eef6a677577349b8":"13Pcp"}],"jRCu7":[function(require,module,exports) {
var process = require("4284522496af5dfb");
"use strict";
// undocumented cb() API, needed for core, not for public API
function destroy(err, cb) {
    var _this = this;
    var readableDestroyed = this._readableState && this._readableState.destroyed;
    var writableDestroyed = this._writableState && this._writableState.destroyed;
    if (readableDestroyed || writableDestroyed) {
        if (cb) cb(err);
        else if (err) {
            if (!this._writableState) process.nextTick(emitErrorNT, this, err);
            else if (!this._writableState.errorEmitted) {
                this._writableState.errorEmitted = true;
                process.nextTick(emitErrorNT, this, err);
            }
        }
        return this;
    }
    // we set destroyed to true before firing error callbacks in order
    // to make it re-entrance safe in case destroy() is called within callbacks
    if (this._readableState) this._readableState.destroyed = true;
    // if this is a duplex stream mark the writable part as destroyed as well
    if (this._writableState) this._writableState.destroyed = true;
    this._destroy(err || null, function(err) {
        if (!cb && err) {
            if (!_this._writableState) process.nextTick(emitErrorAndCloseNT, _this, err);
            else if (!_this._writableState.errorEmitted) {
                _this._writableState.errorEmitted = true;
                process.nextTick(emitErrorAndCloseNT, _this, err);
            } else process.nextTick(emitCloseNT, _this);
        } else if (cb) {
            process.nextTick(emitCloseNT, _this);
            cb(err);
        } else process.nextTick(emitCloseNT, _this);
    });
    return this;
}
function emitErrorAndCloseNT(self, err) {
    emitErrorNT(self, err);
    emitCloseNT(self);
}
function emitCloseNT(self) {
    if (self._writableState && !self._writableState.emitClose) return;
    if (self._readableState && !self._readableState.emitClose) return;
    self.emit("close");
}
function undestroy() {
    if (this._readableState) {
        this._readableState.destroyed = false;
        this._readableState.reading = false;
        this._readableState.ended = false;
        this._readableState.endEmitted = false;
    }
    if (this._writableState) {
        this._writableState.destroyed = false;
        this._writableState.ended = false;
        this._writableState.ending = false;
        this._writableState.finalCalled = false;
        this._writableState.prefinished = false;
        this._writableState.finished = false;
        this._writableState.errorEmitted = false;
    }
}
function emitErrorNT(self, err) {
    self.emit("error", err);
}
function errorOrDestroy(stream, err) {
    // We have tests that rely on errors being emitted
    // in the same tick, so changing this is semver major.
    // For now when you opt-in to autoDestroy we allow
    // the error to be emitted nextTick. In a future
    // semver major update we should change the default to this.
    var rState = stream._readableState;
    var wState = stream._writableState;
    if (rState && rState.autoDestroy || wState && wState.autoDestroy) stream.destroy(err);
    else stream.emit("error", err);
}
module.exports = {
    destroy: destroy,
    undestroy: undestroy,
    errorOrDestroy: errorOrDestroy
};

},{"4284522496af5dfb":"5QIF0"}],"e5vN8":[function(require,module,exports) {
"use strict";
var ERR_INVALID_OPT_VALUE = require("4e508d569e2117ef").codes.ERR_INVALID_OPT_VALUE;
function highWaterMarkFrom(options, isDuplex, duplexKey) {
    return options.highWaterMark != null ? options.highWaterMark : isDuplex ? options[duplexKey] : null;
}
function getHighWaterMark(state, options, duplexKey, isDuplex) {
    var hwm = highWaterMarkFrom(options, isDuplex, duplexKey);
    if (hwm != null) {
        if (!(isFinite(hwm) && Math.floor(hwm) === hwm) || hwm < 0) {
            var name = isDuplex ? duplexKey : "highWaterMark";
            throw new ERR_INVALID_OPT_VALUE(name, hwm);
        }
        return Math.floor(hwm);
    }
    // Default value
    return state.objectMode ? 16 : 16384;
}
module.exports = {
    getHighWaterMark: getHighWaterMark
};

},{"4e508d569e2117ef":"64341"}],"64341":[function(require,module,exports) {
"use strict";
function _inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
var codes = {};
function createErrorType(code, message, Base) {
    if (!Base) Base = Error;
    function getMessage(arg1, arg2, arg3) {
        if (typeof message === "string") return message;
        else return message(arg1, arg2, arg3);
    }
    var NodeError = /*#__PURE__*/ function(_Base) {
        _inheritsLoose(NodeError, _Base);
        function NodeError(arg1, arg2, arg3) {
            return _Base.call(this, getMessage(arg1, arg2, arg3)) || this;
        }
        return NodeError;
    }(Base);
    NodeError.prototype.name = Base.name;
    NodeError.prototype.code = code;
    codes[code] = NodeError;
} // https://github.com/nodejs/node/blob/v10.8.0/lib/internal/errors.js
function oneOf(expected, thing) {
    if (Array.isArray(expected)) {
        var len = expected.length;
        expected = expected.map(function(i) {
            return String(i);
        });
        if (len > 2) return "one of ".concat(thing, " ").concat(expected.slice(0, len - 1).join(", "), ", or ") + expected[len - 1];
        else if (len === 2) return "one of ".concat(thing, " ").concat(expected[0], " or ").concat(expected[1]);
        else return "of ".concat(thing, " ").concat(expected[0]);
    } else return "of ".concat(thing, " ").concat(String(expected));
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/startsWith
function startsWith(str, search, pos) {
    return str.substr(!pos || pos < 0 ? 0 : +pos, search.length) === search;
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/endsWith
function endsWith(str, search, this_len) {
    if (this_len === undefined || this_len > str.length) this_len = str.length;
    return str.substring(this_len - search.length, this_len) === search;
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/includes
function includes(str, search, start) {
    if (typeof start !== "number") start = 0;
    if (start + search.length > str.length) return false;
    else return str.indexOf(search, start) !== -1;
}
createErrorType("ERR_INVALID_OPT_VALUE", function(name, value) {
    return 'The value "' + value + '" is invalid for option "' + name + '"';
}, TypeError);
createErrorType("ERR_INVALID_ARG_TYPE", function(name, expected, actual) {
    // determiner: 'must be' or 'must not be'
    var determiner;
    if (typeof expected === "string" && startsWith(expected, "not ")) {
        determiner = "must not be";
        expected = expected.replace(/^not /, "");
    } else determiner = "must be";
    var msg;
    if (endsWith(name, " argument")) // For cases like 'first argument'
    msg = "The ".concat(name, " ").concat(determiner, " ").concat(oneOf(expected, "type"));
    else {
        var type = includes(name, ".") ? "property" : "argument";
        msg = 'The "'.concat(name, '" ').concat(type, " ").concat(determiner, " ").concat(oneOf(expected, "type"));
    }
    msg += ". Received type ".concat(typeof actual);
    return msg;
}, TypeError);
createErrorType("ERR_STREAM_PUSH_AFTER_EOF", "stream.push() after EOF");
createErrorType("ERR_METHOD_NOT_IMPLEMENTED", function(name) {
    return "The " + name + " method is not implemented";
});
createErrorType("ERR_STREAM_PREMATURE_CLOSE", "Premature close");
createErrorType("ERR_STREAM_DESTROYED", function(name) {
    return "Cannot call " + name + " after a stream was destroyed";
});
createErrorType("ERR_MULTIPLE_CALLBACK", "Callback called multiple times");
createErrorType("ERR_STREAM_CANNOT_PIPE", "Cannot pipe, not readable");
createErrorType("ERR_STREAM_WRITE_AFTER_END", "write after end");
createErrorType("ERR_STREAM_NULL_VALUES", "May not write null values to stream", TypeError);
createErrorType("ERR_UNKNOWN_ENCODING", function(arg) {
    return "Unknown encoding: " + arg;
}, TypeError);
createErrorType("ERR_STREAM_UNSHIFT_AFTER_END_EVENT", "stream.unshift() after end event");
module.exports.codes = codes;

},{}],"jXYL7":[function(require,module,exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a duplex stream is just a stream that is both readable and writable.
// Since JS doesn't have multiple prototypal inheritance, this class
// prototypally inherits from Readable, and then parasitically from
// Writable.
var process = require("2ab1115635c50a9f");
"use strict";
/*<replacement>*/ var objectKeys = Object.keys || function(obj) {
    var keys = [];
    for(var key in obj)keys.push(key);
    return keys;
};
/*</replacement>*/ module.exports = Duplex;
var Readable = require("68a7582259cd5865");
var Writable = require("93d042f8bb80078e");
require("aa7b11ba5bf4defc")(Duplex, Readable);
// Allow the keys array to be GC'ed.
var keys = objectKeys(Writable.prototype);
for(var v = 0; v < keys.length; v++){
    var method = keys[v];
    if (!Duplex.prototype[method]) Duplex.prototype[method] = Writable.prototype[method];
}
function Duplex(options) {
    if (!(this instanceof Duplex)) return new Duplex(options);
    Readable.call(this, options);
    Writable.call(this, options);
    this.allowHalfOpen = true;
    if (options) {
        if (options.readable === false) this.readable = false;
        if (options.writable === false) this.writable = false;
        if (options.allowHalfOpen === false) {
            this.allowHalfOpen = false;
            this.once("end", onend);
        }
    }
}
Object.defineProperty(Duplex.prototype, "writableHighWaterMark", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState.highWaterMark;
    }
});
Object.defineProperty(Duplex.prototype, "writableBuffer", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState && this._writableState.getBuffer();
    }
});
Object.defineProperty(Duplex.prototype, "writableLength", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState.length;
    }
});
// the no-half-open enforcer
function onend() {
    // If the writable side ended, then we're ok.
    if (this._writableState.ended) return;
    // no more data can be written.
    // But allow more writes to happen in this tick.
    process.nextTick(onEndNT, this);
}
function onEndNT(self) {
    self.end();
}
Object.defineProperty(Duplex.prototype, "destroyed", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        if (this._readableState === undefined || this._writableState === undefined) return false;
        return this._readableState.destroyed && this._writableState.destroyed;
    },
    set: function set(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (this._readableState === undefined || this._writableState === undefined) return;
        // backward compatibility, the user is explicitly
        // managing destroyed
        this._readableState.destroyed = value;
        this._writableState.destroyed = value;
    }
});

},{"2ab1115635c50a9f":"5QIF0","68a7582259cd5865":"cKiEz","93d042f8bb80078e":"1l9D3","aa7b11ba5bf4defc":"8LxVj"}],"1l9D3":[function(require,module,exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// A bit simpler than readable streams.
// Implement an async ._write(chunk, encoding, cb), and it'll handle all
// the drain event emission and buffering.
var global = arguments[3];
var process = require("f05a2a5a09d4d8b0");
"use strict";
module.exports = Writable;
/* <replacement> */ function WriteReq(chunk, encoding, cb) {
    this.chunk = chunk;
    this.encoding = encoding;
    this.callback = cb;
    this.next = null;
}
// It seems a linked list but it is not
// there will be only 2 of these for each stream
function CorkedRequest(state) {
    var _this = this;
    this.next = null;
    this.entry = null;
    this.finish = function() {
        onCorkedFinish(_this, state);
    };
}
/* </replacement> */ /*<replacement>*/ var Duplex;
/*</replacement>*/ Writable.WritableState = WritableState;
/*<replacement>*/ var internalUtil = {
    deprecate: require("dc51171b07b54af1")
};
/*</replacement>*/ /*<replacement>*/ var Stream = require("44a3cc22ec64fcd3");
/*</replacement>*/ var Buffer = require("de8f7fb7ccda8086").Buffer;
var OurUint8Array = (typeof global !== "undefined" ? global : typeof window !== "undefined" ? window : typeof self !== "undefined" ? self : {}).Uint8Array || function() {};
function _uint8ArrayToBuffer(chunk) {
    return Buffer.from(chunk);
}
function _isUint8Array(obj) {
    return Buffer.isBuffer(obj) || obj instanceof OurUint8Array;
}
var destroyImpl = require("acf48fb5d9dc6204");
var _require = require("9d146cd974da0f53"), getHighWaterMark = _require.getHighWaterMark;
var _require$codes = require("3c574b8881abcf86").codes, ERR_INVALID_ARG_TYPE = _require$codes.ERR_INVALID_ARG_TYPE, ERR_METHOD_NOT_IMPLEMENTED = _require$codes.ERR_METHOD_NOT_IMPLEMENTED, ERR_MULTIPLE_CALLBACK = _require$codes.ERR_MULTIPLE_CALLBACK, ERR_STREAM_CANNOT_PIPE = _require$codes.ERR_STREAM_CANNOT_PIPE, ERR_STREAM_DESTROYED = _require$codes.ERR_STREAM_DESTROYED, ERR_STREAM_NULL_VALUES = _require$codes.ERR_STREAM_NULL_VALUES, ERR_STREAM_WRITE_AFTER_END = _require$codes.ERR_STREAM_WRITE_AFTER_END, ERR_UNKNOWN_ENCODING = _require$codes.ERR_UNKNOWN_ENCODING;
var errorOrDestroy = destroyImpl.errorOrDestroy;
require("10dad555ffe77dde")(Writable, Stream);
function nop() {}
function WritableState(options, stream, isDuplex) {
    Duplex = Duplex || require("c5e7171d6f58d3c0");
    options = options || {};
    // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream,
    // e.g. options.readableObjectMode vs. options.writableObjectMode, etc.
    if (typeof isDuplex !== "boolean") isDuplex = stream instanceof Duplex;
    // object stream flag to indicate whether or not this stream
    // contains buffers or objects.
    this.objectMode = !!options.objectMode;
    if (isDuplex) this.objectMode = this.objectMode || !!options.writableObjectMode;
    // the point at which write() starts returning false
    // Note: 0 is a valid value, means that we always return false if
    // the entire buffer is not flushed immediately on write()
    this.highWaterMark = getHighWaterMark(this, options, "writableHighWaterMark", isDuplex);
    // if _final has been called
    this.finalCalled = false;
    // drain event flag.
    this.needDrain = false;
    // at the start of calling end()
    this.ending = false;
    // when end() has been called, and returned
    this.ended = false;
    // when 'finish' is emitted
    this.finished = false;
    // has it been destroyed
    this.destroyed = false;
    // should we decode strings into buffers before passing to _write?
    // this is here so that some node-core streams can optimize string
    // handling at a lower level.
    var noDecode = options.decodeStrings === false;
    this.decodeStrings = !noDecode;
    // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options.defaultEncoding || "utf8";
    // not an actual buffer we keep track of, but a measurement
    // of how much we're waiting to get pushed to some underlying
    // socket or file.
    this.length = 0;
    // a flag to see when we're in the middle of a write.
    this.writing = false;
    // when true all writes will be buffered until .uncork() call
    this.corked = 0;
    // a flag to be able to tell if the onwrite cb is called immediately,
    // or on a later tick.  We set this to true at first, because any
    // actions that shouldn't happen until "later" should generally also
    // not happen before the first write call.
    this.sync = true;
    // a flag to know if we're processing previously buffered items, which
    // may call the _write() callback in the same tick, so that we don't
    // end up in an overlapped onwrite situation.
    this.bufferProcessing = false;
    // the callback that's passed to _write(chunk,cb)
    this.onwrite = function(er) {
        onwrite(stream, er);
    };
    // the callback that the user supplies to write(chunk,encoding,cb)
    this.writecb = null;
    // the amount that is being written when _write is called.
    this.writelen = 0;
    this.bufferedRequest = null;
    this.lastBufferedRequest = null;
    // number of pending user-supplied write callbacks
    // this must be 0 before 'finish' can be emitted
    this.pendingcb = 0;
    // emit prefinish if the only thing we're waiting for is _write cbs
    // This is relevant for synchronous Transform streams
    this.prefinished = false;
    // True if the error was already emitted and should not be thrown again
    this.errorEmitted = false;
    // Should close be emitted on destroy. Defaults to true.
    this.emitClose = options.emitClose !== false;
    // Should .destroy() be called after 'finish' (and potentially 'end')
    this.autoDestroy = !!options.autoDestroy;
    // count buffered requests
    this.bufferedRequestCount = 0;
    // allocate the first CorkedRequest, there is always
    // one allocated and free to use, and we maintain at most two
    this.corkedRequestsFree = new CorkedRequest(this);
}
WritableState.prototype.getBuffer = function getBuffer() {
    var current = this.bufferedRequest;
    var out = [];
    while(current){
        out.push(current);
        current = current.next;
    }
    return out;
};
(function() {
    try {
        Object.defineProperty(WritableState.prototype, "buffer", {
            get: internalUtil.deprecate(function writableStateBufferGetter() {
                return this.getBuffer();
            }, "_writableState.buffer is deprecated. Use _writableState.getBuffer instead.", "DEP0003")
        });
    } catch (_) {}
})();
// Test _writableState for inheritance to account for Duplex streams,
// whose prototype chain only points to Readable.
var realHasInstance;
if (typeof Symbol === "function" && Symbol.hasInstance && typeof Function.prototype[Symbol.hasInstance] === "function") {
    realHasInstance = Function.prototype[Symbol.hasInstance];
    Object.defineProperty(Writable, Symbol.hasInstance, {
        value: function value(object) {
            if (realHasInstance.call(this, object)) return true;
            if (this !== Writable) return false;
            return object && object._writableState instanceof WritableState;
        }
    });
} else realHasInstance = function realHasInstance(object) {
    return object instanceof this;
};
function Writable(options) {
    Duplex = Duplex || require("c5e7171d6f58d3c0");
    // Writable ctor is applied to Duplexes, too.
    // `realHasInstance` is necessary because using plain `instanceof`
    // would return false, as no `_writableState` property is attached.
    // Trying to use the custom `instanceof` for Writable here will also break the
    // Node.js LazyTransform implementation, which has a non-trivial getter for
    // `_writableState` that would lead to infinite recursion.
    // Checking for a Stream.Duplex instance is faster here instead of inside
    // the WritableState constructor, at least with V8 6.5
    var isDuplex = this instanceof Duplex;
    if (!isDuplex && !realHasInstance.call(Writable, this)) return new Writable(options);
    this._writableState = new WritableState(options, this, isDuplex);
    // legacy.
    this.writable = true;
    if (options) {
        if (typeof options.write === "function") this._write = options.write;
        if (typeof options.writev === "function") this._writev = options.writev;
        if (typeof options.destroy === "function") this._destroy = options.destroy;
        if (typeof options.final === "function") this._final = options.final;
    }
    Stream.call(this);
}
// Otherwise people can pipe Writable streams, which is just wrong.
Writable.prototype.pipe = function() {
    errorOrDestroy(this, new ERR_STREAM_CANNOT_PIPE());
};
function writeAfterEnd(stream, cb) {
    var er = new ERR_STREAM_WRITE_AFTER_END();
    // TODO: defer error events consistently everywhere, not just the cb
    errorOrDestroy(stream, er);
    process.nextTick(cb, er);
}
// Checks that a user-supplied chunk is valid, especially for the particular
// mode the stream is in. Currently this means that `null` is never accepted
// and undefined/non-string values are only allowed in object mode.
function validChunk(stream, state, chunk, cb) {
    var er;
    if (chunk === null) er = new ERR_STREAM_NULL_VALUES();
    else if (typeof chunk !== "string" && !state.objectMode) er = new ERR_INVALID_ARG_TYPE("chunk", [
        "string",
        "Buffer"
    ], chunk);
    if (er) {
        errorOrDestroy(stream, er);
        process.nextTick(cb, er);
        return false;
    }
    return true;
}
Writable.prototype.write = function(chunk, encoding, cb) {
    var state = this._writableState;
    var ret = false;
    var isBuf = !state.objectMode && _isUint8Array(chunk);
    if (isBuf && !Buffer.isBuffer(chunk)) chunk = _uint8ArrayToBuffer(chunk);
    if (typeof encoding === "function") {
        cb = encoding;
        encoding = null;
    }
    if (isBuf) encoding = "buffer";
    else if (!encoding) encoding = state.defaultEncoding;
    if (typeof cb !== "function") cb = nop;
    if (state.ending) writeAfterEnd(this, cb);
    else if (isBuf || validChunk(this, state, chunk, cb)) {
        state.pendingcb++;
        ret = writeOrBuffer(this, state, isBuf, chunk, encoding, cb);
    }
    return ret;
};
Writable.prototype.cork = function() {
    this._writableState.corked++;
};
Writable.prototype.uncork = function() {
    var state = this._writableState;
    if (state.corked) {
        state.corked--;
        if (!state.writing && !state.corked && !state.bufferProcessing && state.bufferedRequest) clearBuffer(this, state);
    }
};
Writable.prototype.setDefaultEncoding = function setDefaultEncoding(encoding) {
    // node::ParseEncoding() requires lower case.
    if (typeof encoding === "string") encoding = encoding.toLowerCase();
    if (!([
        "hex",
        "utf8",
        "utf-8",
        "ascii",
        "binary",
        "base64",
        "ucs2",
        "ucs-2",
        "utf16le",
        "utf-16le",
        "raw"
    ].indexOf((encoding + "").toLowerCase()) > -1)) throw new ERR_UNKNOWN_ENCODING(encoding);
    this._writableState.defaultEncoding = encoding;
    return this;
};
Object.defineProperty(Writable.prototype, "writableBuffer", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState && this._writableState.getBuffer();
    }
});
function decodeChunk(state, chunk, encoding) {
    if (!state.objectMode && state.decodeStrings !== false && typeof chunk === "string") chunk = Buffer.from(chunk, encoding);
    return chunk;
}
Object.defineProperty(Writable.prototype, "writableHighWaterMark", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState.highWaterMark;
    }
});
// if we're already writing something, then just put this
// in the queue, and wait our turn.  Otherwise, call _write
// If we return false, then we need a drain event, so set that flag.
function writeOrBuffer(stream, state, isBuf, chunk, encoding, cb) {
    if (!isBuf) {
        var newChunk = decodeChunk(state, chunk, encoding);
        if (chunk !== newChunk) {
            isBuf = true;
            encoding = "buffer";
            chunk = newChunk;
        }
    }
    var len = state.objectMode ? 1 : chunk.length;
    state.length += len;
    var ret = state.length < state.highWaterMark;
    // we must ensure that previous needDrain will not be reset to false.
    if (!ret) state.needDrain = true;
    if (state.writing || state.corked) {
        var last = state.lastBufferedRequest;
        state.lastBufferedRequest = {
            chunk: chunk,
            encoding: encoding,
            isBuf: isBuf,
            callback: cb,
            next: null
        };
        if (last) last.next = state.lastBufferedRequest;
        else state.bufferedRequest = state.lastBufferedRequest;
        state.bufferedRequestCount += 1;
    } else doWrite(stream, state, false, len, chunk, encoding, cb);
    return ret;
}
function doWrite(stream, state, writev, len, chunk, encoding, cb) {
    state.writelen = len;
    state.writecb = cb;
    state.writing = true;
    state.sync = true;
    if (state.destroyed) state.onwrite(new ERR_STREAM_DESTROYED("write"));
    else if (writev) stream._writev(chunk, state.onwrite);
    else stream._write(chunk, encoding, state.onwrite);
    state.sync = false;
}
function onwriteError(stream, state, sync, er, cb) {
    --state.pendingcb;
    if (sync) {
        // defer the callback if we are being called synchronously
        // to avoid piling up things on the stack
        process.nextTick(cb, er);
        // this can emit finish, and it will always happen
        // after error
        process.nextTick(finishMaybe, stream, state);
        stream._writableState.errorEmitted = true;
        errorOrDestroy(stream, er);
    } else {
        // the caller expect this to happen before if
        // it is async
        cb(er);
        stream._writableState.errorEmitted = true;
        errorOrDestroy(stream, er);
        // this can emit finish, but finish must
        // always follow error
        finishMaybe(stream, state);
    }
}
function onwriteStateUpdate(state) {
    state.writing = false;
    state.writecb = null;
    state.length -= state.writelen;
    state.writelen = 0;
}
function onwrite(stream, er) {
    var state = stream._writableState;
    var sync = state.sync;
    var cb = state.writecb;
    if (typeof cb !== "function") throw new ERR_MULTIPLE_CALLBACK();
    onwriteStateUpdate(state);
    if (er) onwriteError(stream, state, sync, er, cb);
    else {
        // Check if we're actually ready to finish, but don't emit yet
        var finished = needFinish(state) || stream.destroyed;
        if (!finished && !state.corked && !state.bufferProcessing && state.bufferedRequest) clearBuffer(stream, state);
        if (sync) process.nextTick(afterWrite, stream, state, finished, cb);
        else afterWrite(stream, state, finished, cb);
    }
}
function afterWrite(stream, state, finished, cb) {
    if (!finished) onwriteDrain(stream, state);
    state.pendingcb--;
    cb();
    finishMaybe(stream, state);
}
// Must force callback to be called on nextTick, so that we don't
// emit 'drain' before the write() consumer gets the 'false' return
// value, and has a chance to attach a 'drain' listener.
function onwriteDrain(stream, state) {
    if (state.length === 0 && state.needDrain) {
        state.needDrain = false;
        stream.emit("drain");
    }
}
// if there's something in the buffer waiting, then process it
function clearBuffer(stream, state) {
    state.bufferProcessing = true;
    var entry = state.bufferedRequest;
    if (stream._writev && entry && entry.next) {
        // Fast case, write everything using _writev()
        var l = state.bufferedRequestCount;
        var buffer = new Array(l);
        var holder = state.corkedRequestsFree;
        holder.entry = entry;
        var count = 0;
        var allBuffers = true;
        while(entry){
            buffer[count] = entry;
            if (!entry.isBuf) allBuffers = false;
            entry = entry.next;
            count += 1;
        }
        buffer.allBuffers = allBuffers;
        doWrite(stream, state, true, state.length, buffer, "", holder.finish);
        // doWrite is almost always async, defer these to save a bit of time
        // as the hot path ends with doWrite
        state.pendingcb++;
        state.lastBufferedRequest = null;
        if (holder.next) {
            state.corkedRequestsFree = holder.next;
            holder.next = null;
        } else state.corkedRequestsFree = new CorkedRequest(state);
        state.bufferedRequestCount = 0;
    } else {
        // Slow case, write chunks one-by-one
        while(entry){
            var chunk = entry.chunk;
            var encoding = entry.encoding;
            var cb = entry.callback;
            var len = state.objectMode ? 1 : chunk.length;
            doWrite(stream, state, false, len, chunk, encoding, cb);
            entry = entry.next;
            state.bufferedRequestCount--;
            // if we didn't call the onwrite immediately, then
            // it means that we need to wait until it does.
            // also, that means that the chunk and cb are currently
            // being processed, so move the buffer counter past them.
            if (state.writing) break;
        }
        if (entry === null) state.lastBufferedRequest = null;
    }
    state.bufferedRequest = entry;
    state.bufferProcessing = false;
}
Writable.prototype._write = function(chunk, encoding, cb) {
    cb(new ERR_METHOD_NOT_IMPLEMENTED("_write()"));
};
Writable.prototype._writev = null;
Writable.prototype.end = function(chunk, encoding, cb) {
    var state = this._writableState;
    if (typeof chunk === "function") {
        cb = chunk;
        chunk = null;
        encoding = null;
    } else if (typeof encoding === "function") {
        cb = encoding;
        encoding = null;
    }
    if (chunk !== null && chunk !== undefined) this.write(chunk, encoding);
    // .end() fully uncorks
    if (state.corked) {
        state.corked = 1;
        this.uncork();
    }
    // ignore unnecessary end() calls.
    if (!state.ending) endWritable(this, state, cb);
    return this;
};
Object.defineProperty(Writable.prototype, "writableLength", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState.length;
    }
});
function needFinish(state) {
    return state.ending && state.length === 0 && state.bufferedRequest === null && !state.finished && !state.writing;
}
function callFinal(stream, state) {
    stream._final(function(err) {
        state.pendingcb--;
        if (err) errorOrDestroy(stream, err);
        state.prefinished = true;
        stream.emit("prefinish");
        finishMaybe(stream, state);
    });
}
function prefinish(stream, state) {
    if (!state.prefinished && !state.finalCalled) {
        if (typeof stream._final === "function" && !state.destroyed) {
            state.pendingcb++;
            state.finalCalled = true;
            process.nextTick(callFinal, stream, state);
        } else {
            state.prefinished = true;
            stream.emit("prefinish");
        }
    }
}
function finishMaybe(stream, state) {
    var need = needFinish(state);
    if (need) {
        prefinish(stream, state);
        if (state.pendingcb === 0) {
            state.finished = true;
            stream.emit("finish");
            if (state.autoDestroy) {
                // In case of duplex streams we need a way to detect
                // if the readable side is ready for autoDestroy as well
                var rState = stream._readableState;
                if (!rState || rState.autoDestroy && rState.endEmitted) stream.destroy();
            }
        }
    }
    return need;
}
function endWritable(stream, state, cb) {
    state.ending = true;
    finishMaybe(stream, state);
    if (cb) {
        if (state.finished) process.nextTick(cb);
        else stream.once("finish", cb);
    }
    state.ended = true;
    stream.writable = false;
}
function onCorkedFinish(corkReq, state, err) {
    var entry = corkReq.entry;
    corkReq.entry = null;
    while(entry){
        var cb = entry.callback;
        state.pendingcb--;
        cb(err);
        entry = entry.next;
    }
    // reuse the free corkReq.
    state.corkedRequestsFree.next = corkReq;
}
Object.defineProperty(Writable.prototype, "destroyed", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        if (this._writableState === undefined) return false;
        return this._writableState.destroyed;
    },
    set: function set(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (!this._writableState) return;
        // backward compatibility, the user is explicitly
        // managing destroyed
        this._writableState.destroyed = value;
    }
});
Writable.prototype.destroy = destroyImpl.destroy;
Writable.prototype._undestroy = destroyImpl.undestroy;
Writable.prototype._destroy = function(err, cb) {
    cb(err);
};

},{"f05a2a5a09d4d8b0":"5QIF0","dc51171b07b54af1":"3YafI","44a3cc22ec64fcd3":"9k4qR","de8f7fb7ccda8086":"l5Twm","acf48fb5d9dc6204":"jRCu7","9d146cd974da0f53":"e5vN8","3c574b8881abcf86":"64341","10dad555ffe77dde":"8LxVj","c5e7171d6f58d3c0":"jXYL7"}],"3YafI":[function(require,module,exports) {
/**
 * Module exports.
 */ var global = arguments[3];
module.exports = deprecate;
/**
 * Mark that a method should not be used.
 * Returns a modified function which warns once by default.
 *
 * If `localStorage.noDeprecation = true` is set, then it is a no-op.
 *
 * If `localStorage.throwDeprecation = true` is set, then deprecated functions
 * will throw an Error when invoked.
 *
 * If `localStorage.traceDeprecation = true` is set, then deprecated functions
 * will invoke `console.trace()` instead of `console.error()`.
 *
 * @param {Function} fn - the function to deprecate
 * @param {String} msg - the string to print to the console when `fn` is invoked
 * @returns {Function} a new "deprecated" version of `fn`
 * @api public
 */ function deprecate(fn, msg) {
    if (config("noDeprecation")) return fn;
    var warned = false;
    function deprecated() {
        if (!warned) {
            if (config("throwDeprecation")) throw new Error(msg);
            else if (config("traceDeprecation")) console.trace(msg);
            else console.warn(msg);
            warned = true;
        }
        return fn.apply(this, arguments);
    }
    return deprecated;
}
/**
 * Checks `localStorage` for boolean values for the given `name`.
 *
 * @param {String} name
 * @returns {Boolean}
 * @api private
 */ function config(name) {
    // accessing global.localStorage can trigger a DOMException in sandboxed iframes
    try {
        if (!global.localStorage) return false;
    } catch (_) {
        return false;
    }
    var val = global.localStorage[name];
    if (null == val) return false;
    return String(val).toLowerCase() === "true";
}

},{}],"dr7zb":[function(require,module,exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
"use strict";
/*<replacement>*/ var Buffer = require("2a29807c689a070a").Buffer;
/*</replacement>*/ var isEncoding = Buffer.isEncoding || function(encoding) {
    encoding = "" + encoding;
    switch(encoding && encoding.toLowerCase()){
        case "hex":
        case "utf8":
        case "utf-8":
        case "ascii":
        case "binary":
        case "base64":
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
        case "raw":
            return true;
        default:
            return false;
    }
};
function _normalizeEncoding(enc) {
    if (!enc) return "utf8";
    var retried;
    while(true)switch(enc){
        case "utf8":
        case "utf-8":
            return "utf8";
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return "utf16le";
        case "latin1":
        case "binary":
            return "latin1";
        case "base64":
        case "ascii":
        case "hex":
            return enc;
        default:
            if (retried) return; // undefined
            enc = ("" + enc).toLowerCase();
            retried = true;
    }
}
// Do not cache `Buffer.isEncoding` when checking encoding names as some
// modules monkey-patch it to support additional encodings
function normalizeEncoding(enc) {
    var nenc = _normalizeEncoding(enc);
    if (typeof nenc !== "string" && (Buffer.isEncoding === isEncoding || !isEncoding(enc))) throw new Error("Unknown encoding: " + enc);
    return nenc || enc;
}
// StringDecoder provides an interface for efficiently splitting a series of
// buffers into a series of JS strings without breaking apart multi-byte
// characters.
exports.StringDecoder = StringDecoder;
function StringDecoder(encoding) {
    this.encoding = normalizeEncoding(encoding);
    var nb;
    switch(this.encoding){
        case "utf16le":
            this.text = utf16Text;
            this.end = utf16End;
            nb = 4;
            break;
        case "utf8":
            this.fillLast = utf8FillLast;
            nb = 4;
            break;
        case "base64":
            this.text = base64Text;
            this.end = base64End;
            nb = 3;
            break;
        default:
            this.write = simpleWrite;
            this.end = simpleEnd;
            return;
    }
    this.lastNeed = 0;
    this.lastTotal = 0;
    this.lastChar = Buffer.allocUnsafe(nb);
}
StringDecoder.prototype.write = function(buf) {
    if (buf.length === 0) return "";
    var r;
    var i;
    if (this.lastNeed) {
        r = this.fillLast(buf);
        if (r === undefined) return "";
        i = this.lastNeed;
        this.lastNeed = 0;
    } else i = 0;
    if (i < buf.length) return r ? r + this.text(buf, i) : this.text(buf, i);
    return r || "";
};
StringDecoder.prototype.end = utf8End;
// Returns only complete characters in a Buffer
StringDecoder.prototype.text = utf8Text;
// Attempts to complete a partial non-UTF-8 character using bytes from a Buffer
StringDecoder.prototype.fillLast = function(buf) {
    if (this.lastNeed <= buf.length) {
        buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, this.lastNeed);
        return this.lastChar.toString(this.encoding, 0, this.lastTotal);
    }
    buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, buf.length);
    this.lastNeed -= buf.length;
};
// Checks the type of a UTF-8 byte, whether it's ASCII, a leading byte, or a
// continuation byte. If an invalid byte is detected, -2 is returned.
function utf8CheckByte(byte) {
    if (byte <= 0x7F) return 0;
    else if (byte >> 5 === 0x06) return 2;
    else if (byte >> 4 === 0x0E) return 3;
    else if (byte >> 3 === 0x1E) return 4;
    return byte >> 6 === 0x02 ? -1 : -2;
}
// Checks at most 3 bytes at the end of a Buffer in order to detect an
// incomplete multi-byte UTF-8 character. The total number of bytes (2, 3, or 4)
// needed to complete the UTF-8 character (if applicable) are returned.
function utf8CheckIncomplete(self, buf, i) {
    var j = buf.length - 1;
    if (j < i) return 0;
    var nb = utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) self.lastNeed = nb - 1;
        return nb;
    }
    if (--j < i || nb === -2) return 0;
    nb = utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) self.lastNeed = nb - 2;
        return nb;
    }
    if (--j < i || nb === -2) return 0;
    nb = utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) {
            if (nb === 2) nb = 0;
            else self.lastNeed = nb - 3;
        }
        return nb;
    }
    return 0;
}
// Validates as many continuation bytes for a multi-byte UTF-8 character as
// needed or are available. If we see a non-continuation byte where we expect
// one, we "replace" the validated continuation bytes we've seen so far with
// a single UTF-8 replacement character ('\ufffd'), to match v8's UTF-8 decoding
// behavior. The continuation byte check is included three times in the case
// where all of the continuation bytes for a character exist in the same buffer.
// It is also done this way as a slight performance increase instead of using a
// loop.
function utf8CheckExtraBytes(self, buf, p) {
    if ((buf[0] & 0xC0) !== 0x80) {
        self.lastNeed = 0;
        return "\uFFFD";
    }
    if (self.lastNeed > 1 && buf.length > 1) {
        if ((buf[1] & 0xC0) !== 0x80) {
            self.lastNeed = 1;
            return "\uFFFD";
        }
        if (self.lastNeed > 2 && buf.length > 2) {
            if ((buf[2] & 0xC0) !== 0x80) {
                self.lastNeed = 2;
                return "\uFFFD";
            }
        }
    }
}
// Attempts to complete a multi-byte UTF-8 character using bytes from a Buffer.
function utf8FillLast(buf) {
    var p = this.lastTotal - this.lastNeed;
    var r = utf8CheckExtraBytes(this, buf, p);
    if (r !== undefined) return r;
    if (this.lastNeed <= buf.length) {
        buf.copy(this.lastChar, p, 0, this.lastNeed);
        return this.lastChar.toString(this.encoding, 0, this.lastTotal);
    }
    buf.copy(this.lastChar, p, 0, buf.length);
    this.lastNeed -= buf.length;
}
// Returns all complete UTF-8 characters in a Buffer. If the Buffer ended on a
// partial character, the character's bytes are buffered until the required
// number of bytes are available.
function utf8Text(buf, i) {
    var total = utf8CheckIncomplete(this, buf, i);
    if (!this.lastNeed) return buf.toString("utf8", i);
    this.lastTotal = total;
    var end = buf.length - (total - this.lastNeed);
    buf.copy(this.lastChar, 0, end);
    return buf.toString("utf8", i, end);
}
// For UTF-8, a replacement character is added when ending on a partial
// character.
function utf8End(buf) {
    var r = buf && buf.length ? this.write(buf) : "";
    if (this.lastNeed) return r + "\uFFFD";
    return r;
}
// UTF-16LE typically needs two bytes per character, but even if we have an even
// number of bytes available, we need to check if we end on a leading/high
// surrogate. In that case, we need to wait for the next two bytes in order to
// decode the last character properly.
function utf16Text(buf, i) {
    if ((buf.length - i) % 2 === 0) {
        var r = buf.toString("utf16le", i);
        if (r) {
            var c = r.charCodeAt(r.length - 1);
            if (c >= 0xD800 && c <= 0xDBFF) {
                this.lastNeed = 2;
                this.lastTotal = 4;
                this.lastChar[0] = buf[buf.length - 2];
                this.lastChar[1] = buf[buf.length - 1];
                return r.slice(0, -1);
            }
        }
        return r;
    }
    this.lastNeed = 1;
    this.lastTotal = 2;
    this.lastChar[0] = buf[buf.length - 1];
    return buf.toString("utf16le", i, buf.length - 1);
}
// For UTF-16LE we do not explicitly append special replacement characters if we
// end on a partial character, we simply let v8 handle that.
function utf16End(buf) {
    var r = buf && buf.length ? this.write(buf) : "";
    if (this.lastNeed) {
        var end = this.lastTotal - this.lastNeed;
        return r + this.lastChar.toString("utf16le", 0, end);
    }
    return r;
}
function base64Text(buf, i) {
    var n = (buf.length - i) % 3;
    if (n === 0) return buf.toString("base64", i);
    this.lastNeed = 3 - n;
    this.lastTotal = 3;
    if (n === 1) this.lastChar[0] = buf[buf.length - 1];
    else {
        this.lastChar[0] = buf[buf.length - 2];
        this.lastChar[1] = buf[buf.length - 1];
    }
    return buf.toString("base64", i, buf.length - n);
}
function base64End(buf) {
    var r = buf && buf.length ? this.write(buf) : "";
    if (this.lastNeed) return r + this.lastChar.toString("base64", 0, 3 - this.lastNeed);
    return r;
}
// Pass bytes on through for single-byte encodings (e.g. ascii, latin1, hex)
function simpleWrite(buf) {
    return buf.toString(this.encoding);
}
function simpleEnd(buf) {
    return buf && buf.length ? this.write(buf) : "";
}

},{"2a29807c689a070a":"6hBQU"}],"6hBQU":[function(require,module,exports) {
/*! safe-buffer. MIT License. Feross Aboukhadijeh <https://feross.org/opensource> */ /* eslint-disable node/no-deprecated-api */ var buffer = require("7e0d6ecd698c3ca6");
var Buffer = buffer.Buffer;
// alternative to using Object.keys for old browsers
function copyProps(src, dst) {
    for(var key in src)dst[key] = src[key];
}
if (Buffer.from && Buffer.alloc && Buffer.allocUnsafe && Buffer.allocUnsafeSlow) module.exports = buffer;
else {
    // Copy properties from require('buffer')
    copyProps(buffer, exports);
    exports.Buffer = SafeBuffer;
}
function SafeBuffer(arg, encodingOrOffset, length) {
    return Buffer(arg, encodingOrOffset, length);
}
SafeBuffer.prototype = Object.create(Buffer.prototype);
// Copy static methods from Buffer
copyProps(Buffer, SafeBuffer);
SafeBuffer.from = function(arg, encodingOrOffset, length) {
    if (typeof arg === "number") throw new TypeError("Argument must not be a number");
    return Buffer(arg, encodingOrOffset, length);
};
SafeBuffer.alloc = function(size, fill, encoding) {
    if (typeof size !== "number") throw new TypeError("Argument must be a number");
    var buf = Buffer(size);
    if (fill !== undefined) {
        if (typeof encoding === "string") buf.fill(fill, encoding);
        else buf.fill(fill);
    } else buf.fill(0);
    return buf;
};
SafeBuffer.allocUnsafe = function(size) {
    if (typeof size !== "number") throw new TypeError("Argument must be a number");
    return Buffer(size);
};
SafeBuffer.allocUnsafeSlow = function(size) {
    if (typeof size !== "number") throw new TypeError("Argument must be a number");
    return buffer.SlowBuffer(size);
};

},{"7e0d6ecd698c3ca6":"l5Twm"}],"3TcjU":[function(require,module,exports) {
var process = require("96b869862a96261a");
"use strict";
var _Object$setPrototypeO;
function _defineProperty(obj, key, value) {
    key = _toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _toPropertyKey(arg) {
    var key = _toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
function _toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
var finished = require("745a3cd8f6469ed5");
var kLastResolve = Symbol("lastResolve");
var kLastReject = Symbol("lastReject");
var kError = Symbol("error");
var kEnded = Symbol("ended");
var kLastPromise = Symbol("lastPromise");
var kHandlePromise = Symbol("handlePromise");
var kStream = Symbol("stream");
function createIterResult(value, done) {
    return {
        value: value,
        done: done
    };
}
function readAndResolve(iter) {
    var resolve = iter[kLastResolve];
    if (resolve !== null) {
        var data = iter[kStream].read();
        // we defer if data is null
        // we can be expecting either 'end' or
        // 'error'
        if (data !== null) {
            iter[kLastPromise] = null;
            iter[kLastResolve] = null;
            iter[kLastReject] = null;
            resolve(createIterResult(data, false));
        }
    }
}
function onReadable(iter) {
    // we wait for the next tick, because it might
    // emit an error with process.nextTick
    process.nextTick(readAndResolve, iter);
}
function wrapForNext(lastPromise, iter) {
    return function(resolve, reject) {
        lastPromise.then(function() {
            if (iter[kEnded]) {
                resolve(createIterResult(undefined, true));
                return;
            }
            iter[kHandlePromise](resolve, reject);
        }, reject);
    };
}
var AsyncIteratorPrototype = Object.getPrototypeOf(function() {});
var ReadableStreamAsyncIteratorPrototype = Object.setPrototypeOf((_Object$setPrototypeO = {
    get stream () {
        return this[kStream];
    },
    next: function next() {
        var _this = this;
        // if we have detected an error in the meanwhile
        // reject straight away
        var error = this[kError];
        if (error !== null) return Promise.reject(error);
        if (this[kEnded]) return Promise.resolve(createIterResult(undefined, true));
        if (this[kStream].destroyed) // We need to defer via nextTick because if .destroy(err) is
        // called, the error will be emitted via nextTick, and
        // we cannot guarantee that there is no error lingering around
        // waiting to be emitted.
        return new Promise(function(resolve, reject) {
            process.nextTick(function() {
                if (_this[kError]) reject(_this[kError]);
                else resolve(createIterResult(undefined, true));
            });
        });
        // if we have multiple next() calls
        // we will wait for the previous Promise to finish
        // this logic is optimized to support for await loops,
        // where next() is only called once at a time
        var lastPromise = this[kLastPromise];
        var promise;
        if (lastPromise) promise = new Promise(wrapForNext(lastPromise, this));
        else {
            // fast path needed to support multiple this.push()
            // without triggering the next() queue
            var data = this[kStream].read();
            if (data !== null) return Promise.resolve(createIterResult(data, false));
            promise = new Promise(this[kHandlePromise]);
        }
        this[kLastPromise] = promise;
        return promise;
    }
}, _defineProperty(_Object$setPrototypeO, Symbol.asyncIterator, function() {
    return this;
}), _defineProperty(_Object$setPrototypeO, "return", function _return() {
    var _this2 = this;
    // destroy(err, cb) is a private API
    // we can guarantee we have that here, because we control the
    // Readable class this is attached to
    return new Promise(function(resolve, reject) {
        _this2[kStream].destroy(null, function(err) {
            if (err) {
                reject(err);
                return;
            }
            resolve(createIterResult(undefined, true));
        });
    });
}), _Object$setPrototypeO), AsyncIteratorPrototype);
var createReadableStreamAsyncIterator = function createReadableStreamAsyncIterator(stream) {
    var _Object$create;
    var iterator = Object.create(ReadableStreamAsyncIteratorPrototype, (_Object$create = {}, _defineProperty(_Object$create, kStream, {
        value: stream,
        writable: true
    }), _defineProperty(_Object$create, kLastResolve, {
        value: null,
        writable: true
    }), _defineProperty(_Object$create, kLastReject, {
        value: null,
        writable: true
    }), _defineProperty(_Object$create, kError, {
        value: null,
        writable: true
    }), _defineProperty(_Object$create, kEnded, {
        value: stream._readableState.endEmitted,
        writable: true
    }), _defineProperty(_Object$create, kHandlePromise, {
        value: function value(resolve, reject) {
            var data = iterator[kStream].read();
            if (data) {
                iterator[kLastPromise] = null;
                iterator[kLastResolve] = null;
                iterator[kLastReject] = null;
                resolve(createIterResult(data, false));
            } else {
                iterator[kLastResolve] = resolve;
                iterator[kLastReject] = reject;
            }
        },
        writable: true
    }), _Object$create));
    iterator[kLastPromise] = null;
    finished(stream, function(err) {
        if (err && err.code !== "ERR_STREAM_PREMATURE_CLOSE") {
            var reject = iterator[kLastReject];
            // reject if we are waiting for data in the Promise
            // returned by next() and store the error
            if (reject !== null) {
                iterator[kLastPromise] = null;
                iterator[kLastResolve] = null;
                iterator[kLastReject] = null;
                reject(err);
            }
            iterator[kError] = err;
            return;
        }
        var resolve = iterator[kLastResolve];
        if (resolve !== null) {
            iterator[kLastPromise] = null;
            iterator[kLastResolve] = null;
            iterator[kLastReject] = null;
            resolve(createIterResult(undefined, true));
        }
        iterator[kEnded] = true;
    });
    stream.on("readable", onReadable.bind(null, iterator));
    return iterator;
};
module.exports = createReadableStreamAsyncIterator;

},{"96b869862a96261a":"5QIF0","745a3cd8f6469ed5":"YQEqF"}],"YQEqF":[function(require,module,exports) {
// Ported from https://github.com/mafintosh/end-of-stream with
// permission from the author, Mathias Buus (@mafintosh).
"use strict";
var ERR_STREAM_PREMATURE_CLOSE = require("d35458f585bdd360").codes.ERR_STREAM_PREMATURE_CLOSE;
function once(callback) {
    var called = false;
    return function() {
        if (called) return;
        called = true;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        callback.apply(this, args);
    };
}
function noop() {}
function isRequest(stream) {
    return stream.setHeader && typeof stream.abort === "function";
}
function eos(stream, opts, callback) {
    if (typeof opts === "function") return eos(stream, null, opts);
    if (!opts) opts = {};
    callback = once(callback || noop);
    var readable = opts.readable || opts.readable !== false && stream.readable;
    var writable = opts.writable || opts.writable !== false && stream.writable;
    var onlegacyfinish = function onlegacyfinish() {
        if (!stream.writable) onfinish();
    };
    var writableEnded = stream._writableState && stream._writableState.finished;
    var onfinish = function onfinish() {
        writable = false;
        writableEnded = true;
        if (!readable) callback.call(stream);
    };
    var readableEnded = stream._readableState && stream._readableState.endEmitted;
    var onend = function onend() {
        readable = false;
        readableEnded = true;
        if (!writable) callback.call(stream);
    };
    var onerror = function onerror(err) {
        callback.call(stream, err);
    };
    var onclose = function onclose() {
        var err;
        if (readable && !readableEnded) {
            if (!stream._readableState || !stream._readableState.ended) err = new ERR_STREAM_PREMATURE_CLOSE();
            return callback.call(stream, err);
        }
        if (writable && !writableEnded) {
            if (!stream._writableState || !stream._writableState.ended) err = new ERR_STREAM_PREMATURE_CLOSE();
            return callback.call(stream, err);
        }
    };
    var onrequest = function onrequest() {
        stream.req.on("finish", onfinish);
    };
    if (isRequest(stream)) {
        stream.on("complete", onfinish);
        stream.on("abort", onclose);
        if (stream.req) onrequest();
        else stream.on("request", onrequest);
    } else if (writable && !stream._writableState) {
        // legacy streams
        stream.on("end", onlegacyfinish);
        stream.on("close", onlegacyfinish);
    }
    stream.on("end", onend);
    stream.on("finish", onfinish);
    if (opts.error !== false) stream.on("error", onerror);
    stream.on("close", onclose);
    return function() {
        stream.removeListener("complete", onfinish);
        stream.removeListener("abort", onclose);
        stream.removeListener("request", onrequest);
        if (stream.req) stream.req.removeListener("finish", onfinish);
        stream.removeListener("end", onlegacyfinish);
        stream.removeListener("close", onlegacyfinish);
        stream.removeListener("finish", onfinish);
        stream.removeListener("end", onend);
        stream.removeListener("error", onerror);
        stream.removeListener("close", onclose);
    };
}
module.exports = eos;

},{"d35458f585bdd360":"64341"}],"39HiC":[function(require,module,exports) {
module.exports = function() {
    throw new Error("Readable.from is not available in the browser");
};

},{}],"fyAZh":[function(require,module,exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a transform stream is a readable/writable stream where you do
// something with the data.  Sometimes it's called a "filter",
// but that's not a great name for it, since that implies a thing where
// some bits pass through, and others are simply ignored.  (That would
// be a valid example of a transform, of course.)
//
// While the output is causally related to the input, it's not a
// necessarily symmetric or synchronous transformation.  For example,
// a zlib stream might take multiple plain-text writes(), and then
// emit a single compressed chunk some time in the future.
//
// Here's how this works:
//
// The Transform stream has all the aspects of the readable and writable
// stream classes.  When you write(chunk), that calls _write(chunk,cb)
// internally, and returns false if there's a lot of pending writes
// buffered up.  When you call read(), that calls _read(n) until
// there's enough pending readable data buffered up.
//
// In a transform stream, the written data is placed in a buffer.  When
// _read(n) is called, it transforms the queued up data, calling the
// buffered _write cb's as it consumes chunks.  If consuming a single
// written chunk would result in multiple output chunks, then the first
// outputted bit calls the readcb, and subsequent chunks just go into
// the read buffer, and will cause it to emit 'readable' if necessary.
//
// This way, back-pressure is actually determined by the reading side,
// since _read has to be called to start processing a new chunk.  However,
// a pathological inflate type of transform can cause excessive buffering
// here.  For example, imagine a stream where every byte of input is
// interpreted as an integer from 0-255, and then results in that many
// bytes of output.  Writing the 4 bytes {ff,ff,ff,ff} would result in
// 1kb of data being output.  In this case, you could write a very small
// amount of input, and end up with a very large amount of output.  In
// such a pathological inflating mechanism, there'd be no way to tell
// the system to stop doing the transform.  A single 4MB write could
// cause the system to run out of memory.
//
// However, even in such a pathological case, only a single written chunk
// would be consumed, and then the rest would wait (un-transformed) until
// the results of the previous transformed chunk were consumed.
"use strict";
module.exports = Transform;
var _require$codes = require("baab47252aa06434").codes, ERR_METHOD_NOT_IMPLEMENTED = _require$codes.ERR_METHOD_NOT_IMPLEMENTED, ERR_MULTIPLE_CALLBACK = _require$codes.ERR_MULTIPLE_CALLBACK, ERR_TRANSFORM_ALREADY_TRANSFORMING = _require$codes.ERR_TRANSFORM_ALREADY_TRANSFORMING, ERR_TRANSFORM_WITH_LENGTH_0 = _require$codes.ERR_TRANSFORM_WITH_LENGTH_0;
var Duplex = require("db11ebf938e536ed");
require("82049677fa603d40")(Transform, Duplex);
function afterTransform(er, data) {
    var ts = this._transformState;
    ts.transforming = false;
    var cb = ts.writecb;
    if (cb === null) return this.emit("error", new ERR_MULTIPLE_CALLBACK());
    ts.writechunk = null;
    ts.writecb = null;
    if (data != null) // single equals check for both `null` and `undefined`
    this.push(data);
    cb(er);
    var rs = this._readableState;
    rs.reading = false;
    if (rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
}
function Transform(options) {
    if (!(this instanceof Transform)) return new Transform(options);
    Duplex.call(this, options);
    this._transformState = {
        afterTransform: afterTransform.bind(this),
        needTransform: false,
        transforming: false,
        writecb: null,
        writechunk: null,
        writeencoding: null
    };
    // start out asking for a readable event once data is transformed.
    this._readableState.needReadable = true;
    // we have implemented the _read method, and done the other things
    // that Readable wants before the first _read call, so unset the
    // sync guard flag.
    this._readableState.sync = false;
    if (options) {
        if (typeof options.transform === "function") this._transform = options.transform;
        if (typeof options.flush === "function") this._flush = options.flush;
    }
    // When the writable side finishes, then flush out anything remaining.
    this.on("prefinish", prefinish);
}
function prefinish() {
    var _this = this;
    if (typeof this._flush === "function" && !this._readableState.destroyed) this._flush(function(er, data) {
        done(_this, er, data);
    });
    else done(this, null, null);
}
Transform.prototype.push = function(chunk, encoding) {
    this._transformState.needTransform = false;
    return Duplex.prototype.push.call(this, chunk, encoding);
};
// This is the part where you do stuff!
// override this function in implementation classes.
// 'chunk' is an input chunk.
//
// Call `push(newChunk)` to pass along transformed output
// to the readable side.  You may call 'push' zero or more times.
//
// Call `cb(err)` when you are done with this chunk.  If you pass
// an error, then that'll put the hurt on the whole operation.  If you
// never call cb(), then you'll never get another chunk.
Transform.prototype._transform = function(chunk, encoding, cb) {
    cb(new ERR_METHOD_NOT_IMPLEMENTED("_transform()"));
};
Transform.prototype._write = function(chunk, encoding, cb) {
    var ts = this._transformState;
    ts.writecb = cb;
    ts.writechunk = chunk;
    ts.writeencoding = encoding;
    if (!ts.transforming) {
        var rs = this._readableState;
        if (ts.needTransform || rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
    }
};
// Doesn't matter what the args are here.
// _transform does all the work.
// That we got here means that the readable side wants more data.
Transform.prototype._read = function(n) {
    var ts = this._transformState;
    if (ts.writechunk !== null && !ts.transforming) {
        ts.transforming = true;
        this._transform(ts.writechunk, ts.writeencoding, ts.afterTransform);
    } else // mark that we need a transform, so that any data that comes in
    // will get processed, now that we've asked for it.
    ts.needTransform = true;
};
Transform.prototype._destroy = function(err, cb) {
    Duplex.prototype._destroy.call(this, err, function(err2) {
        cb(err2);
    });
};
function done(stream, er, data) {
    if (er) return stream.emit("error", er);
    if (data != null) // single equals check for both `null` and `undefined`
    stream.push(data);
    // TODO(BridgeAR): Write a test for these two error cases
    // if there's nothing in the write buffer, then that means
    // that nothing more will ever be provided
    if (stream._writableState.length) throw new ERR_TRANSFORM_WITH_LENGTH_0();
    if (stream._transformState.transforming) throw new ERR_TRANSFORM_ALREADY_TRANSFORMING();
    return stream.push(null);
}

},{"baab47252aa06434":"64341","db11ebf938e536ed":"jXYL7","82049677fa603d40":"8LxVj"}],"3kmEt":[function(require,module,exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a passthrough stream.
// basically just the most minimal sort of Transform stream.
// Every written chunk gets output as-is.
"use strict";
module.exports = PassThrough;
var Transform = require("7ab21291895ec3d2");
require("f24ec1883eef5e9b")(PassThrough, Transform);
function PassThrough(options) {
    if (!(this instanceof PassThrough)) return new PassThrough(options);
    Transform.call(this, options);
}
PassThrough.prototype._transform = function(chunk, encoding, cb) {
    cb(null, chunk);
};

},{"7ab21291895ec3d2":"fyAZh","f24ec1883eef5e9b":"8LxVj"}],"3jCgz":[function(require,module,exports) {
// Ported from https://github.com/mafintosh/pump with
// permission from the author, Mathias Buus (@mafintosh).
"use strict";
var eos;
function once(callback) {
    var called = false;
    return function() {
        if (called) return;
        called = true;
        callback.apply(void 0, arguments);
    };
}
var _require$codes = require("6ba21bd580ac7d57").codes, ERR_MISSING_ARGS = _require$codes.ERR_MISSING_ARGS, ERR_STREAM_DESTROYED = _require$codes.ERR_STREAM_DESTROYED;
function noop(err) {
    // Rethrow the error if it exists to avoid swallowing it
    if (err) throw err;
}
function isRequest(stream) {
    return stream.setHeader && typeof stream.abort === "function";
}
function destroyer(stream, reading, writing, callback) {
    callback = once(callback);
    var closed = false;
    stream.on("close", function() {
        closed = true;
    });
    if (eos === undefined) eos = require("dd7fd89dd81b8674");
    eos(stream, {
        readable: reading,
        writable: writing
    }, function(err) {
        if (err) return callback(err);
        closed = true;
        callback();
    });
    var destroyed = false;
    return function(err) {
        if (closed) return;
        if (destroyed) return;
        destroyed = true;
        // request.destroy just do .end - .abort is what we want
        if (isRequest(stream)) return stream.abort();
        if (typeof stream.destroy === "function") return stream.destroy();
        callback(err || new ERR_STREAM_DESTROYED("pipe"));
    };
}
function call(fn) {
    fn();
}
function pipe(from, to) {
    return from.pipe(to);
}
function popCallback(streams) {
    if (!streams.length) return noop;
    if (typeof streams[streams.length - 1] !== "function") return noop;
    return streams.pop();
}
function pipeline() {
    for(var _len = arguments.length, streams = new Array(_len), _key = 0; _key < _len; _key++)streams[_key] = arguments[_key];
    var callback = popCallback(streams);
    if (Array.isArray(streams[0])) streams = streams[0];
    if (streams.length < 2) throw new ERR_MISSING_ARGS("streams");
    var error;
    var destroys = streams.map(function(stream, i) {
        var reading = i < streams.length - 1;
        var writing = i > 0;
        return destroyer(stream, reading, writing, function(err) {
            if (!error) error = err;
            if (err) destroys.forEach(call);
            if (reading) return;
            destroys.forEach(call);
            callback(error);
        });
    });
    return streams.reduce(pipe);
}
module.exports = pipeline;

},{"6ba21bd580ac7d57":"64341","dd7fd89dd81b8674":"YQEqF"}],"7rqcZ":[function(require,module,exports) {
module.exports = extend;
var hasOwnProperty = Object.prototype.hasOwnProperty;
function extend() {
    var target = {};
    for(var i = 0; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
}

},{}],"fHu7L":[function(require,module,exports) {
module.exports = {
    "100": "Continue",
    "101": "Switching Protocols",
    "102": "Processing",
    "200": "OK",
    "201": "Created",
    "202": "Accepted",
    "203": "Non-Authoritative Information",
    "204": "No Content",
    "205": "Reset Content",
    "206": "Partial Content",
    "207": "Multi-Status",
    "208": "Already Reported",
    "226": "IM Used",
    "300": "Multiple Choices",
    "301": "Moved Permanently",
    "302": "Found",
    "303": "See Other",
    "304": "Not Modified",
    "305": "Use Proxy",
    "307": "Temporary Redirect",
    "308": "Permanent Redirect",
    "400": "Bad Request",
    "401": "Unauthorized",
    "402": "Payment Required",
    "403": "Forbidden",
    "404": "Not Found",
    "405": "Method Not Allowed",
    "406": "Not Acceptable",
    "407": "Proxy Authentication Required",
    "408": "Request Timeout",
    "409": "Conflict",
    "410": "Gone",
    "411": "Length Required",
    "412": "Precondition Failed",
    "413": "Payload Too Large",
    "414": "URI Too Long",
    "415": "Unsupported Media Type",
    "416": "Range Not Satisfiable",
    "417": "Expectation Failed",
    "418": "I'm a teapot",
    "421": "Misdirected Request",
    "422": "Unprocessable Entity",
    "423": "Locked",
    "424": "Failed Dependency",
    "425": "Unordered Collection",
    "426": "Upgrade Required",
    "428": "Precondition Required",
    "429": "Too Many Requests",
    "431": "Request Header Fields Too Large",
    "451": "Unavailable For Legal Reasons",
    "500": "Internal Server Error",
    "501": "Not Implemented",
    "502": "Bad Gateway",
    "503": "Service Unavailable",
    "504": "Gateway Timeout",
    "505": "HTTP Version Not Supported",
    "506": "Variant Also Negotiates",
    "507": "Insufficient Storage",
    "508": "Loop Detected",
    "509": "Bandwidth Limit Exceeded",
    "510": "Not Extended",
    "511": "Network Authentication Required"
};

},{}],"280SV":[function(require,module,exports) {
/*
 * Copyright Joyent, Inc. and other Node contributors.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a
 * copy of this software and associated documentation files (the
 * "Software"), to deal in the Software without restriction, including
 * without limitation the rights to use, copy, modify, merge, publish,
 * distribute, sublicense, and/or sell copies of the Software, and to permit
 * persons to whom the Software is furnished to do so, subject to the
 * following conditions:
 *
 * The above copyright notice and this permission notice shall be included
 * in all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
 * OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
 * MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
 * NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
 * DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
 * OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
 * USE OR OTHER DEALINGS IN THE SOFTWARE.
 */ "use strict";
var punycode = require("50de7006740ce793");
function Url() {
    this.protocol = null;
    this.slashes = null;
    this.auth = null;
    this.host = null;
    this.port = null;
    this.hostname = null;
    this.hash = null;
    this.search = null;
    this.query = null;
    this.pathname = null;
    this.path = null;
    this.href = null;
}
// Reference: RFC 3986, RFC 1808, RFC 2396
/*
 * define these here so at least they only have to be
 * compiled once on the first module load.
 */ var protocolPattern = /^([a-z0-9.+-]+:)/i, portPattern = /:[0-9]*$/, // Special case for a simple path URL
simplePathPattern = /^(\/\/?(?!\/)[^?\s]*)(\?[^\s]*)?$/, /*
   * RFC 2396: characters reserved for delimiting URLs.
   * We actually just auto-escape these.
   */ delims = [
    "<",
    ">",
    '"',
    "`",
    " ",
    "\r",
    "\n",
    "	"
], // RFC 2396: characters not allowed for various reasons.
unwise = [
    "{",
    "}",
    "|",
    "\\",
    "^",
    "`"
].concat(delims), // Allowed by RFCs, but cause of XSS attacks.  Always escape these.
autoEscape = [
    "'"
].concat(unwise), /*
   * Characters that are never ever allowed in a hostname.
   * Note that any invalid chars are also handled, but these
   * are the ones that are *expected* to be seen, so we fast-path
   * them.
   */ nonHostChars = [
    "%",
    "/",
    "?",
    ";",
    "#"
].concat(autoEscape), hostEndingChars = [
    "/",
    "?",
    "#"
], hostnameMaxLen = 255, hostnamePartPattern = /^[+a-z0-9A-Z_-]{0,63}$/, hostnamePartStart = /^([+a-z0-9A-Z_-]{0,63})(.*)$/, // protocols that can allow "unsafe" and "unwise" chars.
unsafeProtocol = {
    javascript: true,
    "javascript:": true
}, // protocols that never have a hostname.
hostlessProtocol = {
    javascript: true,
    "javascript:": true
}, // protocols that always contain a // bit.
slashedProtocol = {
    http: true,
    https: true,
    ftp: true,
    gopher: true,
    file: true,
    "http:": true,
    "https:": true,
    "ftp:": true,
    "gopher:": true,
    "file:": true
}, querystring = require("6724c84b9b69726b");
function urlParse(url, parseQueryString, slashesDenoteHost) {
    if (url && typeof url === "object" && url instanceof Url) return url;
    var u = new Url();
    u.parse(url, parseQueryString, slashesDenoteHost);
    return u;
}
Url.prototype.parse = function(url, parseQueryString, slashesDenoteHost) {
    if (typeof url !== "string") throw new TypeError("Parameter 'url' must be a string, not " + typeof url);
    /*
   * Copy chrome, IE, opera backslash-handling behavior.
   * Back slashes before the query string get converted to forward slashes
   * See: https://code.google.com/p/chromium/issues/detail?id=25916
   */ var queryIndex = url.indexOf("?"), splitter = queryIndex !== -1 && queryIndex < url.indexOf("#") ? "?" : "#", uSplit = url.split(splitter), slashRegex = /\\/g;
    uSplit[0] = uSplit[0].replace(slashRegex, "/");
    url = uSplit.join(splitter);
    var rest = url;
    /*
   * trim before proceeding.
   * This is to support parse stuff like "  http://foo.com  \n"
   */ rest = rest.trim();
    if (!slashesDenoteHost && url.split("#").length === 1) {
        // Try fast path regexp
        var simplePath = simplePathPattern.exec(rest);
        if (simplePath) {
            this.path = rest;
            this.href = rest;
            this.pathname = simplePath[1];
            if (simplePath[2]) {
                this.search = simplePath[2];
                if (parseQueryString) this.query = querystring.parse(this.search.substr(1));
                else this.query = this.search.substr(1);
            } else if (parseQueryString) {
                this.search = "";
                this.query = {};
            }
            return this;
        }
    }
    var proto = protocolPattern.exec(rest);
    if (proto) {
        proto = proto[0];
        var lowerProto = proto.toLowerCase();
        this.protocol = lowerProto;
        rest = rest.substr(proto.length);
    }
    /*
   * figure out if it's got a host
   * user@server is *always* interpreted as a hostname, and url
   * resolution will treat //foo/bar as host=foo,path=bar because that's
   * how the browser resolves relative URLs.
   */ if (slashesDenoteHost || proto || rest.match(/^\/\/[^@/]+@[^@/]+/)) {
        var slashes = rest.substr(0, 2) === "//";
        if (slashes && !(proto && hostlessProtocol[proto])) {
            rest = rest.substr(2);
            this.slashes = true;
        }
    }
    if (!hostlessProtocol[proto] && (slashes || proto && !slashedProtocol[proto])) {
        /*
     * there's a hostname.
     * the first instance of /, ?, ;, or # ends the host.
     *
     * If there is an @ in the hostname, then non-host chars *are* allowed
     * to the left of the last @ sign, unless some host-ending character
     * comes *before* the @-sign.
     * URLs are obnoxious.
     *
     * ex:
     * http://a@b@c/ => user:a@b host:c
     * http://a@b?@c => user:a host:c path:/?@c
     */ /*
     * v0.12 TODO(isaacs): This is not quite how Chrome does things.
     * Review our test case against browsers more comprehensively.
     */ // find the first instance of any hostEndingChars
        var hostEnd = -1;
        for(var i = 0; i < hostEndingChars.length; i++){
            var hec = rest.indexOf(hostEndingChars[i]);
            if (hec !== -1 && (hostEnd === -1 || hec < hostEnd)) hostEnd = hec;
        }
        /*
     * at this point, either we have an explicit point where the
     * auth portion cannot go past, or the last @ char is the decider.
     */ var auth, atSign;
        if (hostEnd === -1) // atSign can be anywhere.
        atSign = rest.lastIndexOf("@");
        else /*
       * atSign must be in auth portion.
       * http://a@b/c@d => host:b auth:a path:/c@d
       */ atSign = rest.lastIndexOf("@", hostEnd);
        /*
     * Now we have a portion which is definitely the auth.
     * Pull that off.
     */ if (atSign !== -1) {
            auth = rest.slice(0, atSign);
            rest = rest.slice(atSign + 1);
            this.auth = decodeURIComponent(auth);
        }
        // the host is the remaining to the left of the first non-host char
        hostEnd = -1;
        for(var i = 0; i < nonHostChars.length; i++){
            var hec = rest.indexOf(nonHostChars[i]);
            if (hec !== -1 && (hostEnd === -1 || hec < hostEnd)) hostEnd = hec;
        }
        // if we still have not hit it, then the entire thing is a host.
        if (hostEnd === -1) hostEnd = rest.length;
        this.host = rest.slice(0, hostEnd);
        rest = rest.slice(hostEnd);
        // pull out port.
        this.parseHost();
        /*
     * we've indicated that there is a hostname,
     * so even if it's empty, it has to be present.
     */ this.hostname = this.hostname || "";
        /*
     * if hostname begins with [ and ends with ]
     * assume that it's an IPv6 address.
     */ var ipv6Hostname = this.hostname[0] === "[" && this.hostname[this.hostname.length - 1] === "]";
        // validate a little.
        if (!ipv6Hostname) {
            var hostparts = this.hostname.split(/\./);
            for(var i = 0, l = hostparts.length; i < l; i++){
                var part = hostparts[i];
                if (!part) continue;
                if (!part.match(hostnamePartPattern)) {
                    var newpart = "";
                    for(var j = 0, k = part.length; j < k; j++)if (part.charCodeAt(j) > 127) /*
               * we replace non-ASCII char with a temporary placeholder
               * we need this to make sure size of hostname is not
               * broken by replacing non-ASCII by nothing
               */ newpart += "x";
                    else newpart += part[j];
                    // we test again with ASCII char only
                    if (!newpart.match(hostnamePartPattern)) {
                        var validParts = hostparts.slice(0, i);
                        var notHost = hostparts.slice(i + 1);
                        var bit = part.match(hostnamePartStart);
                        if (bit) {
                            validParts.push(bit[1]);
                            notHost.unshift(bit[2]);
                        }
                        if (notHost.length) rest = "/" + notHost.join(".") + rest;
                        this.hostname = validParts.join(".");
                        break;
                    }
                }
            }
        }
        if (this.hostname.length > hostnameMaxLen) this.hostname = "";
        else // hostnames are always lower case.
        this.hostname = this.hostname.toLowerCase();
        if (!ipv6Hostname) /*
       * IDNA Support: Returns a punycoded representation of "domain".
       * It only converts parts of the domain name that
       * have non-ASCII characters, i.e. it doesn't matter if
       * you call it with a domain that already is ASCII-only.
       */ this.hostname = punycode.toASCII(this.hostname);
        var p = this.port ? ":" + this.port : "";
        var h = this.hostname || "";
        this.host = h + p;
        this.href += this.host;
        /*
     * strip [ and ] from the hostname
     * the host field still retains them, though
     */ if (ipv6Hostname) {
            this.hostname = this.hostname.substr(1, this.hostname.length - 2);
            if (rest[0] !== "/") rest = "/" + rest;
        }
    }
    /*
   * now rest is set to the post-host stuff.
   * chop off any delim chars.
   */ if (!unsafeProtocol[lowerProto]) /*
     * First, make 100% sure that any "autoEscape" chars get
     * escaped, even if encodeURIComponent doesn't think they
     * need to be.
     */ for(var i = 0, l = autoEscape.length; i < l; i++){
        var ae = autoEscape[i];
        if (rest.indexOf(ae) === -1) continue;
        var esc = encodeURIComponent(ae);
        if (esc === ae) esc = escape(ae);
        rest = rest.split(ae).join(esc);
    }
    // chop off from the tail first.
    var hash = rest.indexOf("#");
    if (hash !== -1) {
        // got a fragment string.
        this.hash = rest.substr(hash);
        rest = rest.slice(0, hash);
    }
    var qm = rest.indexOf("?");
    if (qm !== -1) {
        this.search = rest.substr(qm);
        this.query = rest.substr(qm + 1);
        if (parseQueryString) this.query = querystring.parse(this.query);
        rest = rest.slice(0, qm);
    } else if (parseQueryString) {
        // no query string, but parseQueryString still requested
        this.search = "";
        this.query = {};
    }
    if (rest) this.pathname = rest;
    if (slashedProtocol[lowerProto] && this.hostname && !this.pathname) this.pathname = "/";
    // to support http.request
    if (this.pathname || this.search) {
        var p = this.pathname || "";
        var s = this.search || "";
        this.path = p + s;
    }
    // finally, reconstruct the href based on what has been validated.
    this.href = this.format();
    return this;
};
// format a parsed object into a url string
function urlFormat(obj) {
    /*
   * ensure it's an object, and not a string url.
   * If it's an obj, this is a no-op.
   * this way, you can call url_format() on strings
   * to clean up potentially wonky urls.
   */ if (typeof obj === "string") obj = urlParse(obj);
    if (!(obj instanceof Url)) return Url.prototype.format.call(obj);
    return obj.format();
}
Url.prototype.format = function() {
    var auth = this.auth || "";
    if (auth) {
        auth = encodeURIComponent(auth);
        auth = auth.replace(/%3A/i, ":");
        auth += "@";
    }
    var protocol = this.protocol || "", pathname = this.pathname || "", hash = this.hash || "", host = false, query = "";
    if (this.host) host = auth + this.host;
    else if (this.hostname) {
        host = auth + (this.hostname.indexOf(":") === -1 ? this.hostname : "[" + this.hostname + "]");
        if (this.port) host += ":" + this.port;
    }
    if (this.query && typeof this.query === "object" && Object.keys(this.query).length) query = querystring.stringify(this.query, {
        arrayFormat: "repeat",
        addQueryPrefix: false
    });
    var search = this.search || query && "?" + query || "";
    if (protocol && protocol.substr(-1) !== ":") protocol += ":";
    /*
   * only the slashedProtocols get the //.  Not mailto:, xmpp:, etc.
   * unless they had them to begin with.
   */ if (this.slashes || (!protocol || slashedProtocol[protocol]) && host !== false) {
        host = "//" + (host || "");
        if (pathname && pathname.charAt(0) !== "/") pathname = "/" + pathname;
    } else if (!host) host = "";
    if (hash && hash.charAt(0) !== "#") hash = "#" + hash;
    if (search && search.charAt(0) !== "?") search = "?" + search;
    pathname = pathname.replace(/[?#]/g, function(match) {
        return encodeURIComponent(match);
    });
    search = search.replace("#", "%23");
    return protocol + host + pathname + search + hash;
};
function urlResolve(source, relative) {
    return urlParse(source, false, true).resolve(relative);
}
Url.prototype.resolve = function(relative) {
    return this.resolveObject(urlParse(relative, false, true)).format();
};
function urlResolveObject(source, relative) {
    if (!source) return relative;
    return urlParse(source, false, true).resolveObject(relative);
}
Url.prototype.resolveObject = function(relative) {
    if (typeof relative === "string") {
        var rel = new Url();
        rel.parse(relative, false, true);
        relative = rel;
    }
    var result = new Url();
    var tkeys = Object.keys(this);
    for(var tk = 0; tk < tkeys.length; tk++){
        var tkey = tkeys[tk];
        result[tkey] = this[tkey];
    }
    /*
   * hash is always overridden, no matter what.
   * even href="" will remove it.
   */ result.hash = relative.hash;
    // if the relative url is empty, then there's nothing left to do here.
    if (relative.href === "") {
        result.href = result.format();
        return result;
    }
    // hrefs like //foo/bar always cut to the protocol.
    if (relative.slashes && !relative.protocol) {
        // take everything except the protocol from relative
        var rkeys = Object.keys(relative);
        for(var rk = 0; rk < rkeys.length; rk++){
            var rkey = rkeys[rk];
            if (rkey !== "protocol") result[rkey] = relative[rkey];
        }
        // urlParse appends trailing / to urls like http://www.example.com
        if (slashedProtocol[result.protocol] && result.hostname && !result.pathname) {
            result.pathname = "/";
            result.path = result.pathname;
        }
        result.href = result.format();
        return result;
    }
    if (relative.protocol && relative.protocol !== result.protocol) {
        /*
     * if it's a known url protocol, then changing
     * the protocol does weird things
     * first, if it's not file:, then we MUST have a host,
     * and if there was a path
     * to begin with, then we MUST have a path.
     * if it is file:, then the host is dropped,
     * because that's known to be hostless.
     * anything else is assumed to be absolute.
     */ if (!slashedProtocol[relative.protocol]) {
            var keys = Object.keys(relative);
            for(var v = 0; v < keys.length; v++){
                var k = keys[v];
                result[k] = relative[k];
            }
            result.href = result.format();
            return result;
        }
        result.protocol = relative.protocol;
        if (!relative.host && !hostlessProtocol[relative.protocol]) {
            var relPath = (relative.pathname || "").split("/");
            while(relPath.length && !(relative.host = relPath.shift()));
            if (!relative.host) relative.host = "";
            if (!relative.hostname) relative.hostname = "";
            if (relPath[0] !== "") relPath.unshift("");
            if (relPath.length < 2) relPath.unshift("");
            result.pathname = relPath.join("/");
        } else result.pathname = relative.pathname;
        result.search = relative.search;
        result.query = relative.query;
        result.host = relative.host || "";
        result.auth = relative.auth;
        result.hostname = relative.hostname || relative.host;
        result.port = relative.port;
        // to support http.request
        if (result.pathname || result.search) {
            var p = result.pathname || "";
            var s = result.search || "";
            result.path = p + s;
        }
        result.slashes = result.slashes || relative.slashes;
        result.href = result.format();
        return result;
    }
    var isSourceAbs = result.pathname && result.pathname.charAt(0) === "/", isRelAbs = relative.host || relative.pathname && relative.pathname.charAt(0) === "/", mustEndAbs = isRelAbs || isSourceAbs || result.host && relative.pathname, removeAllDots = mustEndAbs, srcPath = result.pathname && result.pathname.split("/") || [], relPath = relative.pathname && relative.pathname.split("/") || [], psychotic = result.protocol && !slashedProtocol[result.protocol];
    /*
   * if the url is a non-slashed url, then relative
   * links like ../.. should be able
   * to crawl up to the hostname, as well.  This is strange.
   * result.protocol has already been set by now.
   * Later on, put the first path part into the host field.
   */ if (psychotic) {
        result.hostname = "";
        result.port = null;
        if (result.host) {
            if (srcPath[0] === "") srcPath[0] = result.host;
            else srcPath.unshift(result.host);
        }
        result.host = "";
        if (relative.protocol) {
            relative.hostname = null;
            relative.port = null;
            if (relative.host) {
                if (relPath[0] === "") relPath[0] = relative.host;
                else relPath.unshift(relative.host);
            }
            relative.host = null;
        }
        mustEndAbs = mustEndAbs && (relPath[0] === "" || srcPath[0] === "");
    }
    if (isRelAbs) {
        // it's absolute.
        result.host = relative.host || relative.host === "" ? relative.host : result.host;
        result.hostname = relative.hostname || relative.hostname === "" ? relative.hostname : result.hostname;
        result.search = relative.search;
        result.query = relative.query;
        srcPath = relPath;
    // fall through to the dot-handling below.
    } else if (relPath.length) {
        /*
     * it's relative
     * throw away the existing file, and take the new path instead.
     */ if (!srcPath) srcPath = [];
        srcPath.pop();
        srcPath = srcPath.concat(relPath);
        result.search = relative.search;
        result.query = relative.query;
    } else if (relative.search != null) {
        /*
     * just pull out the search.
     * like href='?foo'.
     * Put this after the other two cases because it simplifies the booleans
     */ if (psychotic) {
            result.host = srcPath.shift();
            result.hostname = result.host;
            /*
       * occationaly the auth can get stuck only in host
       * this especially happens in cases like
       * url.resolveObject('mailto:local1@domain1', 'local2@domain2')
       */ var authInHost = result.host && result.host.indexOf("@") > 0 ? result.host.split("@") : false;
            if (authInHost) {
                result.auth = authInHost.shift();
                result.hostname = authInHost.shift();
                result.host = result.hostname;
            }
        }
        result.search = relative.search;
        result.query = relative.query;
        // to support http.request
        if (result.pathname !== null || result.search !== null) result.path = (result.pathname ? result.pathname : "") + (result.search ? result.search : "");
        result.href = result.format();
        return result;
    }
    if (!srcPath.length) {
        /*
     * no path at all.  easy.
     * we've already handled the other stuff above.
     */ result.pathname = null;
        // to support http.request
        if (result.search) result.path = "/" + result.search;
        else result.path = null;
        result.href = result.format();
        return result;
    }
    /*
   * if a url ENDs in . or .., then it must get a trailing slash.
   * however, if it ends in anything else non-slashy,
   * then it must NOT get a trailing slash.
   */ var last = srcPath.slice(-1)[0];
    var hasTrailingSlash = (result.host || relative.host || srcPath.length > 1) && (last === "." || last === "..") || last === "";
    /*
   * strip single dots, resolve double dots to parent dir
   * if the path tries to go above the root, `up` ends up > 0
   */ var up = 0;
    for(var i = srcPath.length; i >= 0; i--){
        last = srcPath[i];
        if (last === ".") srcPath.splice(i, 1);
        else if (last === "..") {
            srcPath.splice(i, 1);
            up++;
        } else if (up) {
            srcPath.splice(i, 1);
            up--;
        }
    }
    // if the path is allowed to go above the root, restore leading ..s
    if (!mustEndAbs && !removeAllDots) for(; up--; up)srcPath.unshift("..");
    if (mustEndAbs && srcPath[0] !== "" && (!srcPath[0] || srcPath[0].charAt(0) !== "/")) srcPath.unshift("");
    if (hasTrailingSlash && srcPath.join("/").substr(-1) !== "/") srcPath.push("");
    var isAbsolute = srcPath[0] === "" || srcPath[0] && srcPath[0].charAt(0) === "/";
    // put the host back
    if (psychotic) {
        result.hostname = isAbsolute ? "" : srcPath.length ? srcPath.shift() : "";
        result.host = result.hostname;
        /*
     * occationaly the auth can get stuck only in host
     * this especially happens in cases like
     * url.resolveObject('mailto:local1@domain1', 'local2@domain2')
     */ var authInHost = result.host && result.host.indexOf("@") > 0 ? result.host.split("@") : false;
        if (authInHost) {
            result.auth = authInHost.shift();
            result.hostname = authInHost.shift();
            result.host = result.hostname;
        }
    }
    mustEndAbs = mustEndAbs || result.host && srcPath.length;
    if (mustEndAbs && !isAbsolute) srcPath.unshift("");
    if (srcPath.length > 0) result.pathname = srcPath.join("/");
    else {
        result.pathname = null;
        result.path = null;
    }
    // to support request.http
    if (result.pathname !== null || result.search !== null) result.path = (result.pathname ? result.pathname : "") + (result.search ? result.search : "");
    result.auth = relative.auth || result.auth;
    result.slashes = result.slashes || relative.slashes;
    result.href = result.format();
    return result;
};
Url.prototype.parseHost = function() {
    var host = this.host;
    var port = portPattern.exec(host);
    if (port) {
        port = port[0];
        if (port !== ":") this.port = port.substr(1);
        host = host.substr(0, host.length - port.length);
    }
    if (host) this.hostname = host;
};
exports.parse = urlParse;
exports.resolve = urlResolve;
exports.resolveObject = urlResolveObject;
exports.format = urlFormat;
exports.Url = Url;

},{"50de7006740ce793":"8ORYx","6724c84b9b69726b":"3KnnP"}],"8ORYx":[function(require,module,exports) {
var global = arguments[3];
(function(root) {
    /** Detect free variables */ var freeExports = exports && !exports.nodeType && exports;
    var freeModule = module && !module.nodeType && module;
    var freeGlobal = typeof global == "object" && global;
    if (freeGlobal.global === freeGlobal || freeGlobal.window === freeGlobal || freeGlobal.self === freeGlobal) root = freeGlobal;
    /**
	 * The `punycode` object.
	 * @name punycode
	 * @type Object
	 */ var punycode, /** Highest positive signed 32-bit float value */ maxInt = 2147483647, /** Bootstring parameters */ base = 36, tMin = 1, tMax = 26, skew = 38, damp = 700, initialBias = 72, initialN = 128, delimiter = "-", /** Regular expressions */ regexPunycode = /^xn--/, regexNonASCII = /[^\x20-\x7E]/, regexSeparators = /[\x2E\u3002\uFF0E\uFF61]/g, /** Error messages */ errors = {
        "overflow": "Overflow: input needs wider integers to process",
        "not-basic": "Illegal input >= 0x80 (not a basic code point)",
        "invalid-input": "Invalid input"
    }, /** Convenience shortcuts */ baseMinusTMin = base - tMin, floor = Math.floor, stringFromCharCode = String.fromCharCode, /** Temporary variable */ key;
    /*--------------------------------------------------------------------------*/ /**
	 * A generic error utility function.
	 * @private
	 * @param {String} type The error type.
	 * @returns {Error} Throws a `RangeError` with the applicable error message.
	 */ function error(type) {
        throw new RangeError(errors[type]);
    }
    /**
	 * A generic `Array#map` utility function.
	 * @private
	 * @param {Array} array The array to iterate over.
	 * @param {Function} callback The function that gets called for every array
	 * item.
	 * @returns {Array} A new array of values returned by the callback function.
	 */ function map(array, fn) {
        var length = array.length;
        var result = [];
        while(length--)result[length] = fn(array[length]);
        return result;
    }
    /**
	 * A simple `Array#map`-like wrapper to work with domain name strings or email
	 * addresses.
	 * @private
	 * @param {String} domain The domain name or email address.
	 * @param {Function} callback The function that gets called for every
	 * character.
	 * @returns {Array} A new string of characters returned by the callback
	 * function.
	 */ function mapDomain(string, fn) {
        var parts = string.split("@");
        var result = "";
        if (parts.length > 1) {
            // In email addresses, only the domain name should be punycoded. Leave
            // the local part (i.e. everything up to `@`) intact.
            result = parts[0] + "@";
            string = parts[1];
        }
        // Avoid `split(regex)` for IE8 compatibility. See #17.
        string = string.replace(regexSeparators, ".");
        var labels = string.split(".");
        var encoded = map(labels, fn).join(".");
        return result + encoded;
    }
    /**
	 * Creates an array containing the numeric code points of each Unicode
	 * character in the string. While JavaScript uses UCS-2 internally,
	 * this function will convert a pair of surrogate halves (each of which
	 * UCS-2 exposes as separate characters) into a single code point,
	 * matching UTF-16.
	 * @see `punycode.ucs2.encode`
	 * @see <https://mathiasbynens.be/notes/javascript-encoding>
	 * @memberOf punycode.ucs2
	 * @name decode
	 * @param {String} string The Unicode input string (UCS-2).
	 * @returns {Array} The new array of code points.
	 */ function ucs2decode(string) {
        var output = [], counter = 0, length = string.length, value, extra;
        while(counter < length){
            value = string.charCodeAt(counter++);
            if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
                // high surrogate, and there is a next character
                extra = string.charCodeAt(counter++);
                if ((extra & 0xFC00) == 0xDC00) output.push(((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
                else {
                    // unmatched surrogate; only append this code unit, in case the next
                    // code unit is the high surrogate of a surrogate pair
                    output.push(value);
                    counter--;
                }
            } else output.push(value);
        }
        return output;
    }
    /**
	 * Creates a string based on an array of numeric code points.
	 * @see `punycode.ucs2.decode`
	 * @memberOf punycode.ucs2
	 * @name encode
	 * @param {Array} codePoints The array of numeric code points.
	 * @returns {String} The new Unicode string (UCS-2).
	 */ function ucs2encode(array) {
        return map(array, function(value) {
            var output = "";
            if (value > 0xFFFF) {
                value -= 0x10000;
                output += stringFromCharCode(value >>> 10 & 0x3FF | 0xD800);
                value = 0xDC00 | value & 0x3FF;
            }
            output += stringFromCharCode(value);
            return output;
        }).join("");
    }
    /**
	 * Converts a basic code point into a digit/integer.
	 * @see `digitToBasic()`
	 * @private
	 * @param {Number} codePoint The basic numeric code point value.
	 * @returns {Number} The numeric value of a basic code point (for use in
	 * representing integers) in the range `0` to `base - 1`, or `base` if
	 * the code point does not represent a value.
	 */ function basicToDigit(codePoint) {
        if (codePoint - 48 < 10) return codePoint - 22;
        if (codePoint - 65 < 26) return codePoint - 65;
        if (codePoint - 97 < 26) return codePoint - 97;
        return base;
    }
    /**
	 * Converts a digit/integer into a basic code point.
	 * @see `basicToDigit()`
	 * @private
	 * @param {Number} digit The numeric value of a basic code point.
	 * @returns {Number} The basic code point whose value (when used for
	 * representing integers) is `digit`, which needs to be in the range
	 * `0` to `base - 1`. If `flag` is non-zero, the uppercase form is
	 * used; else, the lowercase form is used. The behavior is undefined
	 * if `flag` is non-zero and `digit` has no uppercase form.
	 */ function digitToBasic(digit, flag) {
        //  0..25 map to ASCII a..z or A..Z
        // 26..35 map to ASCII 0..9
        return digit + 22 + 75 * (digit < 26) - ((flag != 0) << 5);
    }
    /**
	 * Bias adaptation function as per section 3.4 of RFC 3492.
	 * https://tools.ietf.org/html/rfc3492#section-3.4
	 * @private
	 */ function adapt(delta, numPoints, firstTime) {
        var k = 0;
        delta = firstTime ? floor(delta / damp) : delta >> 1;
        delta += floor(delta / numPoints);
        for(; delta > baseMinusTMin * tMax >> 1; k += base)delta = floor(delta / baseMinusTMin);
        return floor(k + (baseMinusTMin + 1) * delta / (delta + skew));
    }
    /**
	 * Converts a Punycode string of ASCII-only symbols to a string of Unicode
	 * symbols.
	 * @memberOf punycode
	 * @param {String} input The Punycode string of ASCII-only symbols.
	 * @returns {String} The resulting string of Unicode symbols.
	 */ function decode(input) {
        // Don't use UCS-2
        var output = [], inputLength = input.length, out, i = 0, n = initialN, bias = initialBias, basic, j, index, oldi, w, k, digit, t, /** Cached calculation results */ baseMinusT;
        // Handle the basic code points: let `basic` be the number of input code
        // points before the last delimiter, or `0` if there is none, then copy
        // the first basic code points to the output.
        basic = input.lastIndexOf(delimiter);
        if (basic < 0) basic = 0;
        for(j = 0; j < basic; ++j){
            // if it's not a basic code point
            if (input.charCodeAt(j) >= 0x80) error("not-basic");
            output.push(input.charCodeAt(j));
        }
        // Main decoding loop: start just after the last delimiter if any basic code
        // points were copied; start at the beginning otherwise.
        for(index = basic > 0 ? basic + 1 : 0; index < inputLength;){
            // `index` is the index of the next character to be consumed.
            // Decode a generalized variable-length integer into `delta`,
            // which gets added to `i`. The overflow checking is easier
            // if we increase `i` as we go, then subtract off its starting
            // value at the end to obtain `delta`.
            for(oldi = i, w = 1, k = base;; k += base){
                if (index >= inputLength) error("invalid-input");
                digit = basicToDigit(input.charCodeAt(index++));
                if (digit >= base || digit > floor((maxInt - i) / w)) error("overflow");
                i += digit * w;
                t = k <= bias ? tMin : k >= bias + tMax ? tMax : k - bias;
                if (digit < t) break;
                baseMinusT = base - t;
                if (w > floor(maxInt / baseMinusT)) error("overflow");
                w *= baseMinusT;
            }
            out = output.length + 1;
            bias = adapt(i - oldi, out, oldi == 0);
            // `i` was supposed to wrap around from `out` to `0`,
            // incrementing `n` each time, so we'll fix that now:
            if (floor(i / out) > maxInt - n) error("overflow");
            n += floor(i / out);
            i %= out;
            // Insert `n` at position `i` of the output
            output.splice(i++, 0, n);
        }
        return ucs2encode(output);
    }
    /**
	 * Converts a string of Unicode symbols (e.g. a domain name label) to a
	 * Punycode string of ASCII-only symbols.
	 * @memberOf punycode
	 * @param {String} input The string of Unicode symbols.
	 * @returns {String} The resulting Punycode string of ASCII-only symbols.
	 */ function encode(input) {
        var n, delta, handledCPCount, basicLength, bias, j, m, q, k, t, currentValue, output = [], /** `inputLength` will hold the number of code points in `input`. */ inputLength, /** Cached calculation results */ handledCPCountPlusOne, baseMinusT, qMinusT;
        // Convert the input in UCS-2 to Unicode
        input = ucs2decode(input);
        // Cache the length
        inputLength = input.length;
        // Initialize the state
        n = initialN;
        delta = 0;
        bias = initialBias;
        // Handle the basic code points
        for(j = 0; j < inputLength; ++j){
            currentValue = input[j];
            if (currentValue < 0x80) output.push(stringFromCharCode(currentValue));
        }
        handledCPCount = basicLength = output.length;
        // `handledCPCount` is the number of code points that have been handled;
        // `basicLength` is the number of basic code points.
        // Finish the basic string - if it is not empty - with a delimiter
        if (basicLength) output.push(delimiter);
        // Main encoding loop:
        while(handledCPCount < inputLength){
            // All non-basic code points < n have been handled already. Find the next
            // larger one:
            for(m = maxInt, j = 0; j < inputLength; ++j){
                currentValue = input[j];
                if (currentValue >= n && currentValue < m) m = currentValue;
            }
            // Increase `delta` enough to advance the decoder's <n,i> state to <m,0>,
            // but guard against overflow
            handledCPCountPlusOne = handledCPCount + 1;
            if (m - n > floor((maxInt - delta) / handledCPCountPlusOne)) error("overflow");
            delta += (m - n) * handledCPCountPlusOne;
            n = m;
            for(j = 0; j < inputLength; ++j){
                currentValue = input[j];
                if (currentValue < n && ++delta > maxInt) error("overflow");
                if (currentValue == n) {
                    // Represent delta as a generalized variable-length integer
                    for(q = delta, k = base;; k += base){
                        t = k <= bias ? tMin : k >= bias + tMax ? tMax : k - bias;
                        if (q < t) break;
                        qMinusT = q - t;
                        baseMinusT = base - t;
                        output.push(stringFromCharCode(digitToBasic(t + qMinusT % baseMinusT, 0)));
                        q = floor(qMinusT / baseMinusT);
                    }
                    output.push(stringFromCharCode(digitToBasic(q, 0)));
                    bias = adapt(delta, handledCPCountPlusOne, handledCPCount == basicLength);
                    delta = 0;
                    ++handledCPCount;
                }
            }
            ++delta;
            ++n;
        }
        return output.join("");
    }
    /**
	 * Converts a Punycode string representing a domain name or an email address
	 * to Unicode. Only the Punycoded parts of the input will be converted, i.e.
	 * it doesn't matter if you call it on a string that has already been
	 * converted to Unicode.
	 * @memberOf punycode
	 * @param {String} input The Punycoded domain name or email address to
	 * convert to Unicode.
	 * @returns {String} The Unicode representation of the given Punycode
	 * string.
	 */ function toUnicode(input) {
        return mapDomain(input, function(string) {
            return regexPunycode.test(string) ? decode(string.slice(4).toLowerCase()) : string;
        });
    }
    /**
	 * Converts a Unicode string representing a domain name or an email address to
	 * Punycode. Only the non-ASCII parts of the domain name will be converted,
	 * i.e. it doesn't matter if you call it with a domain that's already in
	 * ASCII.
	 * @memberOf punycode
	 * @param {String} input The domain name or email address to convert, as a
	 * Unicode string.
	 * @returns {String} The Punycode representation of the given domain name or
	 * email address.
	 */ function toASCII(input) {
        return mapDomain(input, function(string) {
            return regexNonASCII.test(string) ? "xn--" + encode(string) : string;
        });
    }
    /*--------------------------------------------------------------------------*/ /** Define the public API */ punycode = {
        /**
		 * A string representing the current Punycode.js version number.
		 * @memberOf punycode
		 * @type String
		 */ "version": "1.4.1",
        /**
		 * An object of methods to convert from JavaScript's internal character
		 * representation (UCS-2) to Unicode code points, and back.
		 * @see <https://mathiasbynens.be/notes/javascript-encoding>
		 * @memberOf punycode
		 * @type Object
		 */ "ucs2": {
            "decode": ucs2decode,
            "encode": ucs2encode
        },
        "decode": decode,
        "encode": encode,
        "toASCII": toASCII,
        "toUnicode": toUnicode
    };
    /** Expose `punycode` */ // Some AMD build optimizers, like r.js, check for specific condition patterns
    // like the following:
    if (typeof define == "function" && typeof define.amd == "object" && define.amd) define("punycode", function() {
        return punycode;
    });
    else if (freeExports && freeModule) {
        if (module.exports == freeExports) // in Node.js, io.js, or RingoJS v0.8.0+
        freeModule.exports = punycode;
        else // in Narwhal or RingoJS v0.7.0-
        for(key in punycode)punycode.hasOwnProperty(key) && (freeExports[key] = punycode[key]);
    } else // in Rhino or a web browser
    root.punycode = punycode;
})(this);

},{}],"3KnnP":[function(require,module,exports) {
"use strict";
var stringify = require("a472ccaa2f2351e9");
var parse = require("7ffa4249597bf32b");
var formats = require("454df9476704f887");
module.exports = {
    formats: formats,
    parse: parse,
    stringify: stringify
};

},{"a472ccaa2f2351e9":"c65e4","7ffa4249597bf32b":"4TH1Q","454df9476704f887":"4FjOV"}],"c65e4":[function(require,module,exports) {
"use strict";
var getSideChannel = require("6246bbb805756d41");
var utils = require("44263cc7b702ebf");
var formats = require("929f8531a94a537c");
var has = Object.prototype.hasOwnProperty;
var arrayPrefixGenerators = {
    brackets: function brackets(prefix) {
        return prefix + "[]";
    },
    comma: "comma",
    indices: function indices(prefix, key) {
        return prefix + "[" + key + "]";
    },
    repeat: function repeat(prefix) {
        return prefix;
    }
};
var isArray = Array.isArray;
var push = Array.prototype.push;
var pushToArray = function(arr, valueOrArray) {
    push.apply(arr, isArray(valueOrArray) ? valueOrArray : [
        valueOrArray
    ]);
};
var toISO = Date.prototype.toISOString;
var defaultFormat = formats["default"];
var defaults = {
    addQueryPrefix: false,
    allowDots: false,
    allowEmptyArrays: false,
    arrayFormat: "indices",
    charset: "utf-8",
    charsetSentinel: false,
    delimiter: "&",
    encode: true,
    encodeDotInKeys: false,
    encoder: utils.encode,
    encodeValuesOnly: false,
    format: defaultFormat,
    formatter: formats.formatters[defaultFormat],
    // deprecated
    indices: false,
    serializeDate: function serializeDate(date) {
        return toISO.call(date);
    },
    skipNulls: false,
    strictNullHandling: false
};
var isNonNullishPrimitive = function isNonNullishPrimitive(v) {
    return typeof v === "string" || typeof v === "number" || typeof v === "boolean" || typeof v === "symbol" || typeof v === "bigint";
};
var sentinel = {};
var stringify = function stringify(object, prefix, generateArrayPrefix, commaRoundTrip, allowEmptyArrays, strictNullHandling, skipNulls, encodeDotInKeys, encoder, filter, sort, allowDots, serializeDate, format, formatter, encodeValuesOnly, charset, sideChannel) {
    var obj = object;
    var tmpSc = sideChannel;
    var step = 0;
    var findFlag = false;
    while((tmpSc = tmpSc.get(sentinel)) !== void 0 && !findFlag){
        // Where object last appeared in the ref tree
        var pos = tmpSc.get(object);
        step += 1;
        if (typeof pos !== "undefined") {
            if (pos === step) throw new RangeError("Cyclic object value");
            else findFlag = true; // Break while
        }
        if (typeof tmpSc.get(sentinel) === "undefined") step = 0;
    }
    if (typeof filter === "function") obj = filter(prefix, obj);
    else if (obj instanceof Date) obj = serializeDate(obj);
    else if (generateArrayPrefix === "comma" && isArray(obj)) obj = utils.maybeMap(obj, function(value) {
        if (value instanceof Date) return serializeDate(value);
        return value;
    });
    if (obj === null) {
        if (strictNullHandling) return encoder && !encodeValuesOnly ? encoder(prefix, defaults.encoder, charset, "key", format) : prefix;
        obj = "";
    }
    if (isNonNullishPrimitive(obj) || utils.isBuffer(obj)) {
        if (encoder) {
            var keyValue = encodeValuesOnly ? prefix : encoder(prefix, defaults.encoder, charset, "key", format);
            return [
                formatter(keyValue) + "=" + formatter(encoder(obj, defaults.encoder, charset, "value", format))
            ];
        }
        return [
            formatter(prefix) + "=" + formatter(String(obj))
        ];
    }
    var values = [];
    if (typeof obj === "undefined") return values;
    var objKeys;
    if (generateArrayPrefix === "comma" && isArray(obj)) {
        // we need to join elements in
        if (encodeValuesOnly && encoder) obj = utils.maybeMap(obj, encoder);
        objKeys = [
            {
                value: obj.length > 0 ? obj.join(",") || null : void 0
            }
        ];
    } else if (isArray(filter)) objKeys = filter;
    else {
        var keys = Object.keys(obj);
        objKeys = sort ? keys.sort(sort) : keys;
    }
    var encodedPrefix = encodeDotInKeys ? prefix.replace(/\./g, "%2E") : prefix;
    var adjustedPrefix = commaRoundTrip && isArray(obj) && obj.length === 1 ? encodedPrefix + "[]" : encodedPrefix;
    if (allowEmptyArrays && isArray(obj) && obj.length === 0) return adjustedPrefix + "[]";
    for(var j = 0; j < objKeys.length; ++j){
        var key = objKeys[j];
        var value = typeof key === "object" && typeof key.value !== "undefined" ? key.value : obj[key];
        if (skipNulls && value === null) continue;
        var encodedKey = allowDots && encodeDotInKeys ? key.replace(/\./g, "%2E") : key;
        var keyPrefix = isArray(obj) ? typeof generateArrayPrefix === "function" ? generateArrayPrefix(adjustedPrefix, encodedKey) : adjustedPrefix : adjustedPrefix + (allowDots ? "." + encodedKey : "[" + encodedKey + "]");
        sideChannel.set(object, step);
        var valueSideChannel = getSideChannel();
        valueSideChannel.set(sentinel, sideChannel);
        pushToArray(values, stringify(value, keyPrefix, generateArrayPrefix, commaRoundTrip, allowEmptyArrays, strictNullHandling, skipNulls, encodeDotInKeys, generateArrayPrefix === "comma" && encodeValuesOnly && isArray(obj) ? null : encoder, filter, sort, allowDots, serializeDate, format, formatter, encodeValuesOnly, charset, valueSideChannel));
    }
    return values;
};
var normalizeStringifyOptions = function normalizeStringifyOptions(opts) {
    if (!opts) return defaults;
    if (typeof opts.allowEmptyArrays !== "undefined" && typeof opts.allowEmptyArrays !== "boolean") throw new TypeError("`allowEmptyArrays` option can only be `true` or `false`, when provided");
    if (typeof opts.encodeDotInKeys !== "undefined" && typeof opts.encodeDotInKeys !== "boolean") throw new TypeError("`encodeDotInKeys` option can only be `true` or `false`, when provided");
    if (opts.encoder !== null && typeof opts.encoder !== "undefined" && typeof opts.encoder !== "function") throw new TypeError("Encoder has to be a function.");
    var charset = opts.charset || defaults.charset;
    if (typeof opts.charset !== "undefined" && opts.charset !== "utf-8" && opts.charset !== "iso-8859-1") throw new TypeError("The charset option must be either utf-8, iso-8859-1, or undefined");
    var format = formats["default"];
    if (typeof opts.format !== "undefined") {
        if (!has.call(formats.formatters, opts.format)) throw new TypeError("Unknown format option provided.");
        format = opts.format;
    }
    var formatter = formats.formatters[format];
    var filter = defaults.filter;
    if (typeof opts.filter === "function" || isArray(opts.filter)) filter = opts.filter;
    var arrayFormat;
    if (opts.arrayFormat in arrayPrefixGenerators) arrayFormat = opts.arrayFormat;
    else if ("indices" in opts) arrayFormat = opts.indices ? "indices" : "repeat";
    else arrayFormat = defaults.arrayFormat;
    if ("commaRoundTrip" in opts && typeof opts.commaRoundTrip !== "boolean") throw new TypeError("`commaRoundTrip` must be a boolean, or absent");
    var allowDots = typeof opts.allowDots === "undefined" ? opts.encodeDotInKeys === true ? true : defaults.allowDots : !!opts.allowDots;
    return {
        addQueryPrefix: typeof opts.addQueryPrefix === "boolean" ? opts.addQueryPrefix : defaults.addQueryPrefix,
        allowDots: allowDots,
        allowEmptyArrays: typeof opts.allowEmptyArrays === "boolean" ? !!opts.allowEmptyArrays : defaults.allowEmptyArrays,
        arrayFormat: arrayFormat,
        charset: charset,
        charsetSentinel: typeof opts.charsetSentinel === "boolean" ? opts.charsetSentinel : defaults.charsetSentinel,
        commaRoundTrip: opts.commaRoundTrip,
        delimiter: typeof opts.delimiter === "undefined" ? defaults.delimiter : opts.delimiter,
        encode: typeof opts.encode === "boolean" ? opts.encode : defaults.encode,
        encodeDotInKeys: typeof opts.encodeDotInKeys === "boolean" ? opts.encodeDotInKeys : defaults.encodeDotInKeys,
        encoder: typeof opts.encoder === "function" ? opts.encoder : defaults.encoder,
        encodeValuesOnly: typeof opts.encodeValuesOnly === "boolean" ? opts.encodeValuesOnly : defaults.encodeValuesOnly,
        filter: filter,
        format: format,
        formatter: formatter,
        serializeDate: typeof opts.serializeDate === "function" ? opts.serializeDate : defaults.serializeDate,
        skipNulls: typeof opts.skipNulls === "boolean" ? opts.skipNulls : defaults.skipNulls,
        sort: typeof opts.sort === "function" ? opts.sort : null,
        strictNullHandling: typeof opts.strictNullHandling === "boolean" ? opts.strictNullHandling : defaults.strictNullHandling
    };
};
module.exports = function(object, opts) {
    var obj = object;
    var options = normalizeStringifyOptions(opts);
    var objKeys;
    var filter;
    if (typeof options.filter === "function") {
        filter = options.filter;
        obj = filter("", obj);
    } else if (isArray(options.filter)) {
        filter = options.filter;
        objKeys = filter;
    }
    var keys = [];
    if (typeof obj !== "object" || obj === null) return "";
    var generateArrayPrefix = arrayPrefixGenerators[options.arrayFormat];
    var commaRoundTrip = generateArrayPrefix === "comma" && options.commaRoundTrip;
    if (!objKeys) objKeys = Object.keys(obj);
    if (options.sort) objKeys.sort(options.sort);
    var sideChannel = getSideChannel();
    for(var i = 0; i < objKeys.length; ++i){
        var key = objKeys[i];
        if (options.skipNulls && obj[key] === null) continue;
        pushToArray(keys, stringify(obj[key], key, generateArrayPrefix, commaRoundTrip, options.allowEmptyArrays, options.strictNullHandling, options.skipNulls, options.encodeDotInKeys, options.encode ? options.encoder : null, options.filter, options.sort, options.allowDots, options.serializeDate, options.format, options.formatter, options.encodeValuesOnly, options.charset, sideChannel));
    }
    var joined = keys.join(options.delimiter);
    var prefix = options.addQueryPrefix === true ? "?" : "";
    if (options.charsetSentinel) {
        if (options.charset === "iso-8859-1") // encodeURIComponent('&#10003;'), the "numeric entity" representation of a checkmark
        prefix += "utf8=%26%2310003%3B&";
        else // encodeURIComponent('✓')
        prefix += "utf8=%E2%9C%93&";
    }
    return joined.length > 0 ? prefix + joined : "";
};

},{"6246bbb805756d41":"kTEaB","44263cc7b702ebf":"3YhBn","929f8531a94a537c":"4FjOV"}],"kTEaB":[function(require,module,exports) {
"use strict";
var GetIntrinsic = require("7911ec51a2dc9f3e");
var callBound = require("125062ab9035288f");
var inspect = require("9f4f5a92d8c6543");
var $TypeError = require("1d3f7a3f029b095e");
var $WeakMap = GetIntrinsic("%WeakMap%", true);
var $Map = GetIntrinsic("%Map%", true);
var $weakMapGet = callBound("WeakMap.prototype.get", true);
var $weakMapSet = callBound("WeakMap.prototype.set", true);
var $weakMapHas = callBound("WeakMap.prototype.has", true);
var $mapGet = callBound("Map.prototype.get", true);
var $mapSet = callBound("Map.prototype.set", true);
var $mapHas = callBound("Map.prototype.has", true);
/*
* This function traverses the list returning the node corresponding to the given key.
*
* That node is also moved to the head of the list, so that if it's accessed again we don't need to traverse the whole list. By doing so, all the recently used nodes can be accessed relatively quickly.
*/ /** @type {import('.').listGetNode} */ var listGetNode = function(list, key) {
    /** @type {typeof list | NonNullable<(typeof list)['next']>} */ var prev = list;
    /** @type {(typeof list)['next']} */ var curr;
    for(; (curr = prev.next) !== null; prev = curr)if (curr.key === key) {
        prev.next = curr.next;
        // eslint-disable-next-line no-extra-parens
        curr.next = /** @type {NonNullable<typeof list.next>} */ list.next;
        list.next = curr; // eslint-disable-line no-param-reassign
        return curr;
    }
};
/** @type {import('.').listGet} */ var listGet = function(objects, key) {
    var node = listGetNode(objects, key);
    return node && node.value;
};
/** @type {import('.').listSet} */ var listSet = function(objects, key, value) {
    var node = listGetNode(objects, key);
    if (node) node.value = value;
    else // Prepend the new node to the beginning of the list
    objects.next = /** @type {import('.').ListNode<typeof value>} */ {
        key: key,
        next: objects.next,
        value: value
    };
};
/** @type {import('.').listHas} */ var listHas = function(objects, key) {
    return !!listGetNode(objects, key);
};
/** @type {import('.')} */ module.exports = function getSideChannel() {
    /** @type {WeakMap<object, unknown>} */ var $wm;
    /** @type {Map<object, unknown>} */ var $m;
    /** @type {import('.').RootNode<unknown>} */ var $o;
    /** @type {import('.').Channel} */ var channel = {
        assert: function(key) {
            if (!channel.has(key)) throw new $TypeError("Side channel does not contain " + inspect(key));
        },
        get: function(key) {
            if ($WeakMap && key && (typeof key === "object" || typeof key === "function")) {
                if ($wm) return $weakMapGet($wm, key);
            } else if ($Map) {
                if ($m) return $mapGet($m, key);
            } else {
                if ($o) return listGet($o, key);
            }
        },
        has: function(key) {
            if ($WeakMap && key && (typeof key === "object" || typeof key === "function")) {
                if ($wm) return $weakMapHas($wm, key);
            } else if ($Map) {
                if ($m) return $mapHas($m, key);
            } else {
                if ($o) return listHas($o, key);
            }
            return false;
        },
        set: function(key, value) {
            if ($WeakMap && key && (typeof key === "object" || typeof key === "function")) {
                if (!$wm) $wm = new $WeakMap();
                $weakMapSet($wm, key, value);
            } else if ($Map) {
                if (!$m) $m = new $Map();
                $mapSet($m, key, value);
            } else {
                if (!$o) // Initialize the linked list as an empty node, so that we don't have to special-case handling of the first node: we can always refer to it as (previous node).next, instead of something like (list).head
                $o = {
                    key: {},
                    next: null
                };
                listSet($o, key, value);
            }
        }
    };
    return channel;
};

},{"7911ec51a2dc9f3e":"igBhj","125062ab9035288f":"eK6wT","9f4f5a92d8c6543":"87sBP","1d3f7a3f029b095e":"8YLfd"}],"igBhj":[function(require,module,exports) {
"use strict";
var undefined1;
var $Error = require("ff34c740859aa28e");
var $EvalError = require("349515b7ea9b6cef");
var $RangeError = require("9da01653b2dd9abf");
var $ReferenceError = require("68586abd6b0136da");
var $SyntaxError = require("662263fdbc077fc8");
var $TypeError = require("abdfc34e5f6bb86");
var $URIError = require("daca1f932429e03e");
var $Function = Function;
// eslint-disable-next-line consistent-return
var getEvalledConstructor = function(expressionSyntax) {
    try {
        return $Function('"use strict"; return (' + expressionSyntax + ").constructor;")();
    } catch (e) {}
};
var $gOPD = Object.getOwnPropertyDescriptor;
if ($gOPD) try {
    $gOPD({}, "");
} catch (e) {
    $gOPD = null; // this is IE 8, which has a broken gOPD
}
var throwTypeError = function() {
    throw new $TypeError();
};
var ThrowTypeError = $gOPD ? function() {
    try {
        // eslint-disable-next-line no-unused-expressions, no-caller, no-restricted-properties
        arguments.callee; // IE 8 does not throw here
        return throwTypeError;
    } catch (calleeThrows) {
        try {
            // IE 8 throws on Object.getOwnPropertyDescriptor(arguments, '')
            return $gOPD(arguments, "callee").get;
        } catch (gOPDthrows) {
            return throwTypeError;
        }
    }
}() : throwTypeError;
var hasSymbols = require("1f00f712d594ccf")();
var hasProto = require("23730654306aa64c")();
var getProto = Object.getPrototypeOf || (hasProto ? function(x) {
    return x.__proto__;
} // eslint-disable-line no-proto
 : null);
var needsEval = {};
var TypedArray = typeof Uint8Array === "undefined" || !getProto ? undefined : getProto(Uint8Array);
var INTRINSICS = {
    __proto__: null,
    "%AggregateError%": typeof AggregateError === "undefined" ? undefined : AggregateError,
    "%Array%": Array,
    "%ArrayBuffer%": typeof ArrayBuffer === "undefined" ? undefined : ArrayBuffer,
    "%ArrayIteratorPrototype%": hasSymbols && getProto ? getProto([][Symbol.iterator]()) : undefined,
    "%AsyncFromSyncIteratorPrototype%": undefined,
    "%AsyncFunction%": needsEval,
    "%AsyncGenerator%": needsEval,
    "%AsyncGeneratorFunction%": needsEval,
    "%AsyncIteratorPrototype%": needsEval,
    "%Atomics%": typeof Atomics === "undefined" ? undefined : Atomics,
    "%BigInt%": typeof BigInt === "undefined" ? undefined : BigInt,
    "%BigInt64Array%": typeof BigInt64Array === "undefined" ? undefined : BigInt64Array,
    "%BigUint64Array%": typeof BigUint64Array === "undefined" ? undefined : BigUint64Array,
    "%Boolean%": Boolean,
    "%DataView%": typeof DataView === "undefined" ? undefined : DataView,
    "%Date%": Date,
    "%decodeURI%": decodeURI,
    "%decodeURIComponent%": decodeURIComponent,
    "%encodeURI%": encodeURI,
    "%encodeURIComponent%": encodeURIComponent,
    "%Error%": $Error,
    "%eval%": eval,
    "%EvalError%": $EvalError,
    "%Float32Array%": typeof Float32Array === "undefined" ? undefined : Float32Array,
    "%Float64Array%": typeof Float64Array === "undefined" ? undefined : Float64Array,
    "%FinalizationRegistry%": typeof FinalizationRegistry === "undefined" ? undefined : FinalizationRegistry,
    "%Function%": $Function,
    "%GeneratorFunction%": needsEval,
    "%Int8Array%": typeof Int8Array === "undefined" ? undefined : Int8Array,
    "%Int16Array%": typeof Int16Array === "undefined" ? undefined : Int16Array,
    "%Int32Array%": typeof Int32Array === "undefined" ? undefined : Int32Array,
    "%isFinite%": isFinite,
    "%isNaN%": isNaN,
    "%IteratorPrototype%": hasSymbols && getProto ? getProto(getProto([][Symbol.iterator]())) : undefined,
    "%JSON%": typeof JSON === "object" ? JSON : undefined,
    "%Map%": typeof Map === "undefined" ? undefined : Map,
    "%MapIteratorPrototype%": typeof Map === "undefined" || !hasSymbols || !getProto ? undefined : getProto(new Map()[Symbol.iterator]()),
    "%Math%": Math,
    "%Number%": Number,
    "%Object%": Object,
    "%parseFloat%": parseFloat,
    "%parseInt%": parseInt,
    "%Promise%": typeof Promise === "undefined" ? undefined : Promise,
    "%Proxy%": typeof Proxy === "undefined" ? undefined : Proxy,
    "%RangeError%": $RangeError,
    "%ReferenceError%": $ReferenceError,
    "%Reflect%": typeof Reflect === "undefined" ? undefined : Reflect,
    "%RegExp%": RegExp,
    "%Set%": typeof Set === "undefined" ? undefined : Set,
    "%SetIteratorPrototype%": typeof Set === "undefined" || !hasSymbols || !getProto ? undefined : getProto(new Set()[Symbol.iterator]()),
    "%SharedArrayBuffer%": typeof SharedArrayBuffer === "undefined" ? undefined : SharedArrayBuffer,
    "%String%": String,
    "%StringIteratorPrototype%": hasSymbols && getProto ? getProto(""[Symbol.iterator]()) : undefined,
    "%Symbol%": hasSymbols ? Symbol : undefined,
    "%SyntaxError%": $SyntaxError,
    "%ThrowTypeError%": ThrowTypeError,
    "%TypedArray%": TypedArray,
    "%TypeError%": $TypeError,
    "%Uint8Array%": typeof Uint8Array === "undefined" ? undefined : Uint8Array,
    "%Uint8ClampedArray%": typeof Uint8ClampedArray === "undefined" ? undefined : Uint8ClampedArray,
    "%Uint16Array%": typeof Uint16Array === "undefined" ? undefined : Uint16Array,
    "%Uint32Array%": typeof Uint32Array === "undefined" ? undefined : Uint32Array,
    "%URIError%": $URIError,
    "%WeakMap%": typeof WeakMap === "undefined" ? undefined : WeakMap,
    "%WeakRef%": typeof WeakRef === "undefined" ? undefined : WeakRef,
    "%WeakSet%": typeof WeakSet === "undefined" ? undefined : WeakSet
};
if (getProto) try {
    null.error; // eslint-disable-line no-unused-expressions
} catch (e) {
    // https://github.com/tc39/proposal-shadowrealm/pull/384#issuecomment-1364264229
    var errorProto = getProto(getProto(e));
    INTRINSICS["%Error.prototype%"] = errorProto;
}
var doEval = function doEval(name) {
    var value;
    if (name === "%AsyncFunction%") value = getEvalledConstructor("async function () {}");
    else if (name === "%GeneratorFunction%") value = getEvalledConstructor("function* () {}");
    else if (name === "%AsyncGeneratorFunction%") value = getEvalledConstructor("async function* () {}");
    else if (name === "%AsyncGenerator%") {
        var fn = doEval("%AsyncGeneratorFunction%");
        if (fn) value = fn.prototype;
    } else if (name === "%AsyncIteratorPrototype%") {
        var gen = doEval("%AsyncGenerator%");
        if (gen && getProto) value = getProto(gen.prototype);
    }
    INTRINSICS[name] = value;
    return value;
};
var LEGACY_ALIASES = {
    __proto__: null,
    "%ArrayBufferPrototype%": [
        "ArrayBuffer",
        "prototype"
    ],
    "%ArrayPrototype%": [
        "Array",
        "prototype"
    ],
    "%ArrayProto_entries%": [
        "Array",
        "prototype",
        "entries"
    ],
    "%ArrayProto_forEach%": [
        "Array",
        "prototype",
        "forEach"
    ],
    "%ArrayProto_keys%": [
        "Array",
        "prototype",
        "keys"
    ],
    "%ArrayProto_values%": [
        "Array",
        "prototype",
        "values"
    ],
    "%AsyncFunctionPrototype%": [
        "AsyncFunction",
        "prototype"
    ],
    "%AsyncGenerator%": [
        "AsyncGeneratorFunction",
        "prototype"
    ],
    "%AsyncGeneratorPrototype%": [
        "AsyncGeneratorFunction",
        "prototype",
        "prototype"
    ],
    "%BooleanPrototype%": [
        "Boolean",
        "prototype"
    ],
    "%DataViewPrototype%": [
        "DataView",
        "prototype"
    ],
    "%DatePrototype%": [
        "Date",
        "prototype"
    ],
    "%ErrorPrototype%": [
        "Error",
        "prototype"
    ],
    "%EvalErrorPrototype%": [
        "EvalError",
        "prototype"
    ],
    "%Float32ArrayPrototype%": [
        "Float32Array",
        "prototype"
    ],
    "%Float64ArrayPrototype%": [
        "Float64Array",
        "prototype"
    ],
    "%FunctionPrototype%": [
        "Function",
        "prototype"
    ],
    "%Generator%": [
        "GeneratorFunction",
        "prototype"
    ],
    "%GeneratorPrototype%": [
        "GeneratorFunction",
        "prototype",
        "prototype"
    ],
    "%Int8ArrayPrototype%": [
        "Int8Array",
        "prototype"
    ],
    "%Int16ArrayPrototype%": [
        "Int16Array",
        "prototype"
    ],
    "%Int32ArrayPrototype%": [
        "Int32Array",
        "prototype"
    ],
    "%JSONParse%": [
        "JSON",
        "parse"
    ],
    "%JSONStringify%": [
        "JSON",
        "stringify"
    ],
    "%MapPrototype%": [
        "Map",
        "prototype"
    ],
    "%NumberPrototype%": [
        "Number",
        "prototype"
    ],
    "%ObjectPrototype%": [
        "Object",
        "prototype"
    ],
    "%ObjProto_toString%": [
        "Object",
        "prototype",
        "toString"
    ],
    "%ObjProto_valueOf%": [
        "Object",
        "prototype",
        "valueOf"
    ],
    "%PromisePrototype%": [
        "Promise",
        "prototype"
    ],
    "%PromiseProto_then%": [
        "Promise",
        "prototype",
        "then"
    ],
    "%Promise_all%": [
        "Promise",
        "all"
    ],
    "%Promise_reject%": [
        "Promise",
        "reject"
    ],
    "%Promise_resolve%": [
        "Promise",
        "resolve"
    ],
    "%RangeErrorPrototype%": [
        "RangeError",
        "prototype"
    ],
    "%ReferenceErrorPrototype%": [
        "ReferenceError",
        "prototype"
    ],
    "%RegExpPrototype%": [
        "RegExp",
        "prototype"
    ],
    "%SetPrototype%": [
        "Set",
        "prototype"
    ],
    "%SharedArrayBufferPrototype%": [
        "SharedArrayBuffer",
        "prototype"
    ],
    "%StringPrototype%": [
        "String",
        "prototype"
    ],
    "%SymbolPrototype%": [
        "Symbol",
        "prototype"
    ],
    "%SyntaxErrorPrototype%": [
        "SyntaxError",
        "prototype"
    ],
    "%TypedArrayPrototype%": [
        "TypedArray",
        "prototype"
    ],
    "%TypeErrorPrototype%": [
        "TypeError",
        "prototype"
    ],
    "%Uint8ArrayPrototype%": [
        "Uint8Array",
        "prototype"
    ],
    "%Uint8ClampedArrayPrototype%": [
        "Uint8ClampedArray",
        "prototype"
    ],
    "%Uint16ArrayPrototype%": [
        "Uint16Array",
        "prototype"
    ],
    "%Uint32ArrayPrototype%": [
        "Uint32Array",
        "prototype"
    ],
    "%URIErrorPrototype%": [
        "URIError",
        "prototype"
    ],
    "%WeakMapPrototype%": [
        "WeakMap",
        "prototype"
    ],
    "%WeakSetPrototype%": [
        "WeakSet",
        "prototype"
    ]
};
var bind = require("7c5e688e48cd07b0");
var hasOwn = require("af36d49b4b8c6c7c");
var $concat = bind.call(Function.call, Array.prototype.concat);
var $spliceApply = bind.call(Function.apply, Array.prototype.splice);
var $replace = bind.call(Function.call, String.prototype.replace);
var $strSlice = bind.call(Function.call, String.prototype.slice);
var $exec = bind.call(Function.call, RegExp.prototype.exec);
/* adapted from https://github.com/lodash/lodash/blob/4.17.15/dist/lodash.js#L6735-L6744 */ var rePropName = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;
var reEscapeChar = /\\(\\)?/g; /** Used to match backslashes in property paths. */ 
var stringToPath = function stringToPath(string) {
    var first = $strSlice(string, 0, 1);
    var last = $strSlice(string, -1);
    if (first === "%" && last !== "%") throw new $SyntaxError("invalid intrinsic syntax, expected closing `%`");
    else if (last === "%" && first !== "%") throw new $SyntaxError("invalid intrinsic syntax, expected opening `%`");
    var result = [];
    $replace(string, rePropName, function(match, number, quote, subString) {
        result[result.length] = quote ? $replace(subString, reEscapeChar, "$1") : number || match;
    });
    return result;
};
/* end adaptation */ var getBaseIntrinsic = function getBaseIntrinsic(name, allowMissing) {
    var intrinsicName = name;
    var alias;
    if (hasOwn(LEGACY_ALIASES, intrinsicName)) {
        alias = LEGACY_ALIASES[intrinsicName];
        intrinsicName = "%" + alias[0] + "%";
    }
    if (hasOwn(INTRINSICS, intrinsicName)) {
        var value = INTRINSICS[intrinsicName];
        if (value === needsEval) value = doEval(intrinsicName);
        if (typeof value === "undefined" && !allowMissing) throw new $TypeError("intrinsic " + name + " exists, but is not available. Please file an issue!");
        return {
            alias: alias,
            name: intrinsicName,
            value: value
        };
    }
    throw new $SyntaxError("intrinsic " + name + " does not exist!");
};
module.exports = function GetIntrinsic(name, allowMissing) {
    if (typeof name !== "string" || name.length === 0) throw new $TypeError("intrinsic name must be a non-empty string");
    if (arguments.length > 1 && typeof allowMissing !== "boolean") throw new $TypeError('"allowMissing" argument must be a boolean');
    if ($exec(/^%?[^%]*%?$/, name) === null) throw new $SyntaxError("`%` may not be present anywhere but at the beginning and end of the intrinsic name");
    var parts = stringToPath(name);
    var intrinsicBaseName = parts.length > 0 ? parts[0] : "";
    var intrinsic = getBaseIntrinsic("%" + intrinsicBaseName + "%", allowMissing);
    var intrinsicRealName = intrinsic.name;
    var value = intrinsic.value;
    var skipFurtherCaching = false;
    var alias = intrinsic.alias;
    if (alias) {
        intrinsicBaseName = alias[0];
        $spliceApply(parts, $concat([
            0,
            1
        ], alias));
    }
    for(var i = 1, isOwn = true; i < parts.length; i += 1){
        var part = parts[i];
        var first = $strSlice(part, 0, 1);
        var last = $strSlice(part, -1);
        if ((first === '"' || first === "'" || first === "`" || last === '"' || last === "'" || last === "`") && first !== last) throw new $SyntaxError("property names with quotes must have matching quotes");
        if (part === "constructor" || !isOwn) skipFurtherCaching = true;
        intrinsicBaseName += "." + part;
        intrinsicRealName = "%" + intrinsicBaseName + "%";
        if (hasOwn(INTRINSICS, intrinsicRealName)) value = INTRINSICS[intrinsicRealName];
        else if (value != null) {
            if (!(part in value)) {
                if (!allowMissing) throw new $TypeError("base intrinsic for " + name + " exists, but the property is not available.");
                return void 0;
            }
            if ($gOPD && i + 1 >= parts.length) {
                var desc = $gOPD(value, part);
                isOwn = !!desc;
                // By convention, when a data property is converted to an accessor
                // property to emulate a data property that does not suffer from
                // the override mistake, that accessor's getter is marked with
                // an `originalValue` property. Here, when we detect this, we
                // uphold the illusion by pretending to see that original data
                // property, i.e., returning the value rather than the getter
                // itself.
                if (isOwn && "get" in desc && !("originalValue" in desc.get)) value = desc.get;
                else value = value[part];
            } else {
                isOwn = hasOwn(value, part);
                value = value[part];
            }
            if (isOwn && !skipFurtherCaching) INTRINSICS[intrinsicRealName] = value;
        }
    }
    return value;
};

},{"ff34c740859aa28e":"5DjZP","349515b7ea9b6cef":"ilptm","9da01653b2dd9abf":"dIEDM","68586abd6b0136da":"fEjTP","662263fdbc077fc8":"5eMyt","abdfc34e5f6bb86":"8YLfd","daca1f932429e03e":"0AO4W","1f00f712d594ccf":"7Qiml","23730654306aa64c":"bIcqy","7c5e688e48cd07b0":"42Rnv","af36d49b4b8c6c7c":"b31Xs"}],"5DjZP":[function(require,module,exports) {
"use strict";
/** @type {import('.')} */ module.exports = Error;

},{}],"ilptm":[function(require,module,exports) {
"use strict";
/** @type {import('./eval')} */ module.exports = EvalError;

},{}],"dIEDM":[function(require,module,exports) {
"use strict";
/** @type {import('./range')} */ module.exports = RangeError;

},{}],"fEjTP":[function(require,module,exports) {
"use strict";
/** @type {import('./ref')} */ module.exports = ReferenceError;

},{}],"5eMyt":[function(require,module,exports) {
"use strict";
/** @type {import('./syntax')} */ module.exports = SyntaxError;

},{}],"8YLfd":[function(require,module,exports) {
"use strict";
/** @type {import('./type')} */ module.exports = TypeError;

},{}],"0AO4W":[function(require,module,exports) {
"use strict";
/** @type {import('./uri')} */ module.exports = URIError;

},{}],"7Qiml":[function(require,module,exports) {
"use strict";
var origSymbol = typeof Symbol !== "undefined" && Symbol;
var hasSymbolSham = require("3fb25678c62d2fce");
module.exports = function hasNativeSymbols() {
    if (typeof origSymbol !== "function") return false;
    if (typeof Symbol !== "function") return false;
    if (typeof origSymbol("foo") !== "symbol") return false;
    if (typeof Symbol("bar") !== "symbol") return false;
    return hasSymbolSham();
};

},{"3fb25678c62d2fce":"8apFc"}],"8apFc":[function(require,module,exports) {
"use strict";
/* eslint complexity: [2, 18], max-statements: [2, 33] */ module.exports = function hasSymbols() {
    if (typeof Symbol !== "function" || typeof Object.getOwnPropertySymbols !== "function") return false;
    if (typeof Symbol.iterator === "symbol") return true;
    var obj = {};
    var sym = Symbol("test");
    var symObj = Object(sym);
    if (typeof sym === "string") return false;
    if (Object.prototype.toString.call(sym) !== "[object Symbol]") return false;
    if (Object.prototype.toString.call(symObj) !== "[object Symbol]") return false;
    // temp disabled per https://github.com/ljharb/object.assign/issues/17
    // if (sym instanceof Symbol) { return false; }
    // temp disabled per https://github.com/WebReflection/get-own-property-symbols/issues/4
    // if (!(symObj instanceof Symbol)) { return false; }
    // if (typeof Symbol.prototype.toString !== 'function') { return false; }
    // if (String(sym) !== Symbol.prototype.toString.call(sym)) { return false; }
    var symVal = 42;
    obj[sym] = symVal;
    for(sym in obj)return false;
     // eslint-disable-line no-restricted-syntax, no-unreachable-loop
    if (typeof Object.keys === "function" && Object.keys(obj).length !== 0) return false;
    if (typeof Object.getOwnPropertyNames === "function" && Object.getOwnPropertyNames(obj).length !== 0) return false;
    var syms = Object.getOwnPropertySymbols(obj);
    if (syms.length !== 1 || syms[0] !== sym) return false;
    if (!Object.prototype.propertyIsEnumerable.call(obj, sym)) return false;
    if (typeof Object.getOwnPropertyDescriptor === "function") {
        var descriptor = Object.getOwnPropertyDescriptor(obj, sym);
        if (descriptor.value !== symVal || descriptor.enumerable !== true) return false;
    }
    return true;
};

},{}],"bIcqy":[function(require,module,exports) {
"use strict";
var test = {
    __proto__: null,
    foo: {}
};
var $Object = Object;
/** @type {import('.')} */ module.exports = function hasProto() {
    // @ts-expect-error: TS errors on an inherited property for some reason
    return ({
        __proto__: test
    }).foo === test.foo && !(test instanceof $Object);
};

},{}],"42Rnv":[function(require,module,exports) {
"use strict";
var implementation = require("12e173b4dbaee960");
module.exports = Function.prototype.bind || implementation;

},{"12e173b4dbaee960":"g2Nry"}],"g2Nry":[function(require,module,exports) {
"use strict";
/* eslint no-invalid-this: 1 */ var ERROR_MESSAGE = "Function.prototype.bind called on incompatible ";
var toStr = Object.prototype.toString;
var max = Math.max;
var funcType = "[object Function]";
var concatty = function concatty(a, b) {
    var arr = [];
    for(var i = 0; i < a.length; i += 1)arr[i] = a[i];
    for(var j = 0; j < b.length; j += 1)arr[j + a.length] = b[j];
    return arr;
};
var slicy = function slicy(arrLike, offset) {
    var arr = [];
    for(var i = offset || 0, j = 0; i < arrLike.length; i += 1, j += 1)arr[j] = arrLike[i];
    return arr;
};
var joiny = function(arr, joiner) {
    var str = "";
    for(var i = 0; i < arr.length; i += 1){
        str += arr[i];
        if (i + 1 < arr.length) str += joiner;
    }
    return str;
};
module.exports = function bind(that) {
    var target = this;
    if (typeof target !== "function" || toStr.apply(target) !== funcType) throw new TypeError(ERROR_MESSAGE + target);
    var args = slicy(arguments, 1);
    var bound;
    var binder = function() {
        if (this instanceof bound) {
            var result = target.apply(this, concatty(args, arguments));
            if (Object(result) === result) return result;
            return this;
        }
        return target.apply(that, concatty(args, arguments));
    };
    var boundLength = max(0, target.length - args.length);
    var boundArgs = [];
    for(var i = 0; i < boundLength; i++)boundArgs[i] = "$" + i;
    bound = Function("binder", "return function (" + joiny(boundArgs, ",") + "){ return binder.apply(this,arguments); }")(binder);
    if (target.prototype) {
        var Empty = function Empty() {};
        Empty.prototype = target.prototype;
        bound.prototype = new Empty();
        Empty.prototype = null;
    }
    return bound;
};

},{}],"b31Xs":[function(require,module,exports) {
"use strict";
var call = Function.prototype.call;
var $hasOwn = Object.prototype.hasOwnProperty;
var bind = require("126cb75e62f8e17b");
/** @type {import('.')} */ module.exports = bind.call(call, $hasOwn);

},{"126cb75e62f8e17b":"42Rnv"}],"eK6wT":[function(require,module,exports) {
"use strict";
var GetIntrinsic = require("8b08ecb81cf4de17");
var callBind = require("266fc50410cfc4a");
var $indexOf = callBind(GetIntrinsic("String.prototype.indexOf"));
module.exports = function callBoundIntrinsic(name, allowMissing) {
    var intrinsic = GetIntrinsic(name, !!allowMissing);
    if (typeof intrinsic === "function" && $indexOf(name, ".prototype.") > -1) return callBind(intrinsic);
    return intrinsic;
};

},{"8b08ecb81cf4de17":"igBhj","266fc50410cfc4a":"8iKie"}],"8iKie":[function(require,module,exports) {
"use strict";
var bind = require("4f9d84d5de4909bc");
var GetIntrinsic = require("68d2ad3775278f43");
var setFunctionLength = require("f4b53071c102d4e");
var $TypeError = require("761613670c43be80");
var $apply = GetIntrinsic("%Function.prototype.apply%");
var $call = GetIntrinsic("%Function.prototype.call%");
var $reflectApply = GetIntrinsic("%Reflect.apply%", true) || bind.call($call, $apply);
var $defineProperty = require("3426ee59b177cf96");
var $max = GetIntrinsic("%Math.max%");
module.exports = function callBind(originalFunction) {
    if (typeof originalFunction !== "function") throw new $TypeError("a function is required");
    var func = $reflectApply(bind, $call, arguments);
    return setFunctionLength(func, 1 + $max(0, originalFunction.length - (arguments.length - 1)), true);
};
var applyBind = function applyBind() {
    return $reflectApply(bind, $apply, arguments);
};
if ($defineProperty) $defineProperty(module.exports, "apply", {
    value: applyBind
});
else module.exports.apply = applyBind;

},{"4f9d84d5de4909bc":"42Rnv","68d2ad3775278f43":"igBhj","f4b53071c102d4e":"3pGTz","761613670c43be80":"8YLfd","3426ee59b177cf96":"fFPki"}],"3pGTz":[function(require,module,exports) {
"use strict";
var GetIntrinsic = require("8b1c9107ef1524f2");
var define = require("37dd1486f0f556ef");
var hasDescriptors = require("6a9d2b46085df706")();
var gOPD = require("2d412b0f532d1834");
var $TypeError = require("4352c534d27fe477");
var $floor = GetIntrinsic("%Math.floor%");
/** @type {import('.')} */ module.exports = function setFunctionLength(fn, length) {
    if (typeof fn !== "function") throw new $TypeError("`fn` is not a function");
    if (typeof length !== "number" || length < 0 || length > 0xFFFFFFFF || $floor(length) !== length) throw new $TypeError("`length` must be a positive 32-bit integer");
    var loose = arguments.length > 2 && !!arguments[2];
    var functionLengthIsConfigurable = true;
    var functionLengthIsWritable = true;
    if ("length" in fn && gOPD) {
        var desc = gOPD(fn, "length");
        if (desc && !desc.configurable) functionLengthIsConfigurable = false;
        if (desc && !desc.writable) functionLengthIsWritable = false;
    }
    if (functionLengthIsConfigurable || functionLengthIsWritable || !loose) {
        if (hasDescriptors) define(/** @type {Parameters<define>[0]} */ fn, "length", length, true, true);
        else define(/** @type {Parameters<define>[0]} */ fn, "length", length);
    }
    return fn;
};

},{"8b1c9107ef1524f2":"igBhj","37dd1486f0f556ef":"1VH5F","6a9d2b46085df706":"h7wkG","2d412b0f532d1834":"bOKb6","4352c534d27fe477":"8YLfd"}],"1VH5F":[function(require,module,exports) {
"use strict";
var $defineProperty = require("f17fd23367965521");
var $SyntaxError = require("50f12088ee0f6bb");
var $TypeError = require("45c79de2b2f9c949");
var gopd = require("3f9bd39335781ec7");
/** @type {import('.')} */ module.exports = function defineDataProperty(obj, property, value) {
    if (!obj || typeof obj !== "object" && typeof obj !== "function") throw new $TypeError("`obj` must be an object or a function`");
    if (typeof property !== "string" && typeof property !== "symbol") throw new $TypeError("`property` must be a string or a symbol`");
    if (arguments.length > 3 && typeof arguments[3] !== "boolean" && arguments[3] !== null) throw new $TypeError("`nonEnumerable`, if provided, must be a boolean or null");
    if (arguments.length > 4 && typeof arguments[4] !== "boolean" && arguments[4] !== null) throw new $TypeError("`nonWritable`, if provided, must be a boolean or null");
    if (arguments.length > 5 && typeof arguments[5] !== "boolean" && arguments[5] !== null) throw new $TypeError("`nonConfigurable`, if provided, must be a boolean or null");
    if (arguments.length > 6 && typeof arguments[6] !== "boolean") throw new $TypeError("`loose`, if provided, must be a boolean");
    var nonEnumerable = arguments.length > 3 ? arguments[3] : null;
    var nonWritable = arguments.length > 4 ? arguments[4] : null;
    var nonConfigurable = arguments.length > 5 ? arguments[5] : null;
    var loose = arguments.length > 6 ? arguments[6] : false;
    /* @type {false | TypedPropertyDescriptor<unknown>} */ var desc = !!gopd && gopd(obj, property);
    if ($defineProperty) $defineProperty(obj, property, {
        configurable: nonConfigurable === null && desc ? desc.configurable : !nonConfigurable,
        enumerable: nonEnumerable === null && desc ? desc.enumerable : !nonEnumerable,
        value: value,
        writable: nonWritable === null && desc ? desc.writable : !nonWritable
    });
    else if (loose || !nonEnumerable && !nonWritable && !nonConfigurable) // must fall back to [[Set]], and was not explicitly asked to make non-enumerable, non-writable, or non-configurable
    obj[property] = value; // eslint-disable-line no-param-reassign
    else throw new $SyntaxError("This environment does not support defining a property as non-configurable, non-writable, or non-enumerable.");
};

},{"f17fd23367965521":"fFPki","50f12088ee0f6bb":"5eMyt","45c79de2b2f9c949":"8YLfd","3f9bd39335781ec7":"bOKb6"}],"fFPki":[function(require,module,exports) {
"use strict";
var GetIntrinsic = require("8e0b8e4026aaf38a");
/** @type {import('.')} */ var $defineProperty = GetIntrinsic("%Object.defineProperty%", true) || false;
if ($defineProperty) try {
    $defineProperty({}, "a", {
        value: 1
    });
} catch (e) {
    // IE 8 has a broken defineProperty
    $defineProperty = false;
}
module.exports = $defineProperty;

},{"8e0b8e4026aaf38a":"igBhj"}],"bOKb6":[function(require,module,exports) {
"use strict";
var GetIntrinsic = require("693e651525841e04");
var $gOPD = GetIntrinsic("%Object.getOwnPropertyDescriptor%", true);
if ($gOPD) try {
    $gOPD([], "length");
} catch (e) {
    // IE 8 has a broken gOPD
    $gOPD = null;
}
module.exports = $gOPD;

},{"693e651525841e04":"igBhj"}],"h7wkG":[function(require,module,exports) {
"use strict";
var $defineProperty = require("1c3b0ce871129f60");
var hasPropertyDescriptors = function hasPropertyDescriptors() {
    return !!$defineProperty;
};
hasPropertyDescriptors.hasArrayLengthDefineBug = function hasArrayLengthDefineBug() {
    // node v0.6 has a bug where array lengths can be Set but not Defined
    if (!$defineProperty) return null;
    try {
        return $defineProperty([], "length", {
            value: 1
        }).length !== 1;
    } catch (e) {
        // In Firefox 4-22, defining length on an array throws an exception.
        return true;
    }
};
module.exports = hasPropertyDescriptors;

},{"1c3b0ce871129f60":"fFPki"}],"87sBP":[function(require,module,exports) {
var global = arguments[3];
var hasMap = typeof Map === "function" && Map.prototype;
var mapSizeDescriptor = Object.getOwnPropertyDescriptor && hasMap ? Object.getOwnPropertyDescriptor(Map.prototype, "size") : null;
var mapSize = hasMap && mapSizeDescriptor && typeof mapSizeDescriptor.get === "function" ? mapSizeDescriptor.get : null;
var mapForEach = hasMap && Map.prototype.forEach;
var hasSet = typeof Set === "function" && Set.prototype;
var setSizeDescriptor = Object.getOwnPropertyDescriptor && hasSet ? Object.getOwnPropertyDescriptor(Set.prototype, "size") : null;
var setSize = hasSet && setSizeDescriptor && typeof setSizeDescriptor.get === "function" ? setSizeDescriptor.get : null;
var setForEach = hasSet && Set.prototype.forEach;
var hasWeakMap = typeof WeakMap === "function" && WeakMap.prototype;
var weakMapHas = hasWeakMap ? WeakMap.prototype.has : null;
var hasWeakSet = typeof WeakSet === "function" && WeakSet.prototype;
var weakSetHas = hasWeakSet ? WeakSet.prototype.has : null;
var hasWeakRef = typeof WeakRef === "function" && WeakRef.prototype;
var weakRefDeref = hasWeakRef ? WeakRef.prototype.deref : null;
var booleanValueOf = Boolean.prototype.valueOf;
var objectToString = Object.prototype.toString;
var functionToString = Function.prototype.toString;
var $match = String.prototype.match;
var $slice = String.prototype.slice;
var $replace = String.prototype.replace;
var $toUpperCase = String.prototype.toUpperCase;
var $toLowerCase = String.prototype.toLowerCase;
var $test = RegExp.prototype.test;
var $concat = Array.prototype.concat;
var $join = Array.prototype.join;
var $arrSlice = Array.prototype.slice;
var $floor = Math.floor;
var bigIntValueOf = typeof BigInt === "function" ? BigInt.prototype.valueOf : null;
var gOPS = Object.getOwnPropertySymbols;
var symToString = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? Symbol.prototype.toString : null;
var hasShammedSymbols = typeof Symbol === "function" && typeof Symbol.iterator === "object";
// ie, `has-tostringtag/shams
var toStringTag = typeof Symbol === "function" && Symbol.toStringTag && (typeof Symbol.toStringTag === hasShammedSymbols ? "object" : "symbol") ? Symbol.toStringTag : null;
var isEnumerable = Object.prototype.propertyIsEnumerable;
var gPO = (typeof Reflect === "function" ? Reflect.getPrototypeOf : Object.getPrototypeOf) || ([].__proto__ === Array.prototype // eslint-disable-line no-proto
 ? function(O) {
    return O.__proto__; // eslint-disable-line no-proto
} : null);
function addNumericSeparator(num, str) {
    if (num === Infinity || num === -Infinity || num !== num || num && num > -1000 && num < 1000 || $test.call(/e/, str)) return str;
    var sepRegex = /[0-9](?=(?:[0-9]{3})+(?![0-9]))/g;
    if (typeof num === "number") {
        var int = num < 0 ? -$floor(-num) : $floor(num); // trunc(num)
        if (int !== num) {
            var intStr = String(int);
            var dec = $slice.call(str, intStr.length + 1);
            return $replace.call(intStr, sepRegex, "$&_") + "." + $replace.call($replace.call(dec, /([0-9]{3})/g, "$&_"), /_$/, "");
        }
    }
    return $replace.call(str, sepRegex, "$&_");
}
var utilInspect = require("faefcb1694f2ad90");
var inspectCustom = utilInspect.custom;
var inspectSymbol = isSymbol(inspectCustom) ? inspectCustom : null;
module.exports = function inspect_(obj, options, depth, seen) {
    var opts = options || {};
    if (has(opts, "quoteStyle") && opts.quoteStyle !== "single" && opts.quoteStyle !== "double") throw new TypeError('option "quoteStyle" must be "single" or "double"');
    if (has(opts, "maxStringLength") && (typeof opts.maxStringLength === "number" ? opts.maxStringLength < 0 && opts.maxStringLength !== Infinity : opts.maxStringLength !== null)) throw new TypeError('option "maxStringLength", if provided, must be a positive integer, Infinity, or `null`');
    var customInspect = has(opts, "customInspect") ? opts.customInspect : true;
    if (typeof customInspect !== "boolean" && customInspect !== "symbol") throw new TypeError("option \"customInspect\", if provided, must be `true`, `false`, or `'symbol'`");
    if (has(opts, "indent") && opts.indent !== null && opts.indent !== "	" && !(parseInt(opts.indent, 10) === opts.indent && opts.indent > 0)) throw new TypeError('option "indent" must be "\\t", an integer > 0, or `null`');
    if (has(opts, "numericSeparator") && typeof opts.numericSeparator !== "boolean") throw new TypeError('option "numericSeparator", if provided, must be `true` or `false`');
    var numericSeparator = opts.numericSeparator;
    if (typeof obj === "undefined") return "undefined";
    if (obj === null) return "null";
    if (typeof obj === "boolean") return obj ? "true" : "false";
    if (typeof obj === "string") return inspectString(obj, opts);
    if (typeof obj === "number") {
        if (obj === 0) return Infinity / obj > 0 ? "0" : "-0";
        var str = String(obj);
        return numericSeparator ? addNumericSeparator(obj, str) : str;
    }
    if (typeof obj === "bigint") {
        var bigIntStr = String(obj) + "n";
        return numericSeparator ? addNumericSeparator(obj, bigIntStr) : bigIntStr;
    }
    var maxDepth = typeof opts.depth === "undefined" ? 5 : opts.depth;
    if (typeof depth === "undefined") depth = 0;
    if (depth >= maxDepth && maxDepth > 0 && typeof obj === "object") return isArray(obj) ? "[Array]" : "[Object]";
    var indent = getIndent(opts, depth);
    if (typeof seen === "undefined") seen = [];
    else if (indexOf(seen, obj) >= 0) return "[Circular]";
    function inspect(value, from, noIndent) {
        if (from) {
            seen = $arrSlice.call(seen);
            seen.push(from);
        }
        if (noIndent) {
            var newOpts = {
                depth: opts.depth
            };
            if (has(opts, "quoteStyle")) newOpts.quoteStyle = opts.quoteStyle;
            return inspect_(value, newOpts, depth + 1, seen);
        }
        return inspect_(value, opts, depth + 1, seen);
    }
    if (typeof obj === "function" && !isRegExp(obj)) {
        var name = nameOf(obj);
        var keys = arrObjKeys(obj, inspect);
        return "[Function" + (name ? ": " + name : " (anonymous)") + "]" + (keys.length > 0 ? " { " + $join.call(keys, ", ") + " }" : "");
    }
    if (isSymbol(obj)) {
        var symString = hasShammedSymbols ? $replace.call(String(obj), /^(Symbol\(.*\))_[^)]*$/, "$1") : symToString.call(obj);
        return typeof obj === "object" && !hasShammedSymbols ? markBoxed(symString) : symString;
    }
    if (isElement(obj)) {
        var s = "<" + $toLowerCase.call(String(obj.nodeName));
        var attrs = obj.attributes || [];
        for(var i = 0; i < attrs.length; i++)s += " " + attrs[i].name + "=" + wrapQuotes(quote(attrs[i].value), "double", opts);
        s += ">";
        if (obj.childNodes && obj.childNodes.length) s += "...";
        s += "</" + $toLowerCase.call(String(obj.nodeName)) + ">";
        return s;
    }
    if (isArray(obj)) {
        if (obj.length === 0) return "[]";
        var xs = arrObjKeys(obj, inspect);
        if (indent && !singleLineValues(xs)) return "[" + indentedJoin(xs, indent) + "]";
        return "[ " + $join.call(xs, ", ") + " ]";
    }
    if (isError(obj)) {
        var parts = arrObjKeys(obj, inspect);
        if (!("cause" in Error.prototype) && "cause" in obj && !isEnumerable.call(obj, "cause")) return "{ [" + String(obj) + "] " + $join.call($concat.call("[cause]: " + inspect(obj.cause), parts), ", ") + " }";
        if (parts.length === 0) return "[" + String(obj) + "]";
        return "{ [" + String(obj) + "] " + $join.call(parts, ", ") + " }";
    }
    if (typeof obj === "object" && customInspect) {
        if (inspectSymbol && typeof obj[inspectSymbol] === "function" && utilInspect) return utilInspect(obj, {
            depth: maxDepth - depth
        });
        else if (customInspect !== "symbol" && typeof obj.inspect === "function") return obj.inspect();
    }
    if (isMap(obj)) {
        var mapParts = [];
        if (mapForEach) mapForEach.call(obj, function(value, key) {
            mapParts.push(inspect(key, obj, true) + " => " + inspect(value, obj));
        });
        return collectionOf("Map", mapSize.call(obj), mapParts, indent);
    }
    if (isSet(obj)) {
        var setParts = [];
        if (setForEach) setForEach.call(obj, function(value) {
            setParts.push(inspect(value, obj));
        });
        return collectionOf("Set", setSize.call(obj), setParts, indent);
    }
    if (isWeakMap(obj)) return weakCollectionOf("WeakMap");
    if (isWeakSet(obj)) return weakCollectionOf("WeakSet");
    if (isWeakRef(obj)) return weakCollectionOf("WeakRef");
    if (isNumber(obj)) return markBoxed(inspect(Number(obj)));
    if (isBigInt(obj)) return markBoxed(inspect(bigIntValueOf.call(obj)));
    if (isBoolean(obj)) return markBoxed(booleanValueOf.call(obj));
    if (isString(obj)) return markBoxed(inspect(String(obj)));
    // note: in IE 8, sometimes `global !== window` but both are the prototypes of each other
    /* eslint-env browser */ if (typeof window !== "undefined" && obj === window) return "{ [object Window] }";
    if (typeof globalThis !== "undefined" && obj === globalThis || typeof global !== "undefined" && obj === global) return "{ [object globalThis] }";
    if (!isDate(obj) && !isRegExp(obj)) {
        var ys = arrObjKeys(obj, inspect);
        var isPlainObject = gPO ? gPO(obj) === Object.prototype : obj instanceof Object || obj.constructor === Object;
        var protoTag = obj instanceof Object ? "" : "null prototype";
        var stringTag = !isPlainObject && toStringTag && Object(obj) === obj && toStringTag in obj ? $slice.call(toStr(obj), 8, -1) : protoTag ? "Object" : "";
        var constructorTag = isPlainObject || typeof obj.constructor !== "function" ? "" : obj.constructor.name ? obj.constructor.name + " " : "";
        var tag = constructorTag + (stringTag || protoTag ? "[" + $join.call($concat.call([], stringTag || [], protoTag || []), ": ") + "] " : "");
        if (ys.length === 0) return tag + "{}";
        if (indent) return tag + "{" + indentedJoin(ys, indent) + "}";
        return tag + "{ " + $join.call(ys, ", ") + " }";
    }
    return String(obj);
};
function wrapQuotes(s, defaultStyle, opts) {
    var quoteChar = (opts.quoteStyle || defaultStyle) === "double" ? '"' : "'";
    return quoteChar + s + quoteChar;
}
function quote(s) {
    return $replace.call(String(s), /"/g, "&quot;");
}
function isArray(obj) {
    return toStr(obj) === "[object Array]" && (!toStringTag || !(typeof obj === "object" && toStringTag in obj));
}
function isDate(obj) {
    return toStr(obj) === "[object Date]" && (!toStringTag || !(typeof obj === "object" && toStringTag in obj));
}
function isRegExp(obj) {
    return toStr(obj) === "[object RegExp]" && (!toStringTag || !(typeof obj === "object" && toStringTag in obj));
}
function isError(obj) {
    return toStr(obj) === "[object Error]" && (!toStringTag || !(typeof obj === "object" && toStringTag in obj));
}
function isString(obj) {
    return toStr(obj) === "[object String]" && (!toStringTag || !(typeof obj === "object" && toStringTag in obj));
}
function isNumber(obj) {
    return toStr(obj) === "[object Number]" && (!toStringTag || !(typeof obj === "object" && toStringTag in obj));
}
function isBoolean(obj) {
    return toStr(obj) === "[object Boolean]" && (!toStringTag || !(typeof obj === "object" && toStringTag in obj));
}
// Symbol and BigInt do have Symbol.toStringTag by spec, so that can't be used to eliminate false positives
function isSymbol(obj) {
    if (hasShammedSymbols) return obj && typeof obj === "object" && obj instanceof Symbol;
    if (typeof obj === "symbol") return true;
    if (!obj || typeof obj !== "object" || !symToString) return false;
    try {
        symToString.call(obj);
        return true;
    } catch (e) {}
    return false;
}
function isBigInt(obj) {
    if (!obj || typeof obj !== "object" || !bigIntValueOf) return false;
    try {
        bigIntValueOf.call(obj);
        return true;
    } catch (e) {}
    return false;
}
var hasOwn = Object.prototype.hasOwnProperty || function(key) {
    return key in this;
};
function has(obj, key) {
    return hasOwn.call(obj, key);
}
function toStr(obj) {
    return objectToString.call(obj);
}
function nameOf(f) {
    if (f.name) return f.name;
    var m = $match.call(functionToString.call(f), /^function\s*([\w$]+)/);
    if (m) return m[1];
    return null;
}
function indexOf(xs, x) {
    if (xs.indexOf) return xs.indexOf(x);
    for(var i = 0, l = xs.length; i < l; i++){
        if (xs[i] === x) return i;
    }
    return -1;
}
function isMap(x) {
    if (!mapSize || !x || typeof x !== "object") return false;
    try {
        mapSize.call(x);
        try {
            setSize.call(x);
        } catch (s) {
            return true;
        }
        return x instanceof Map; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}
function isWeakMap(x) {
    if (!weakMapHas || !x || typeof x !== "object") return false;
    try {
        weakMapHas.call(x, weakMapHas);
        try {
            weakSetHas.call(x, weakSetHas);
        } catch (s) {
            return true;
        }
        return x instanceof WeakMap; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}
function isWeakRef(x) {
    if (!weakRefDeref || !x || typeof x !== "object") return false;
    try {
        weakRefDeref.call(x);
        return true;
    } catch (e) {}
    return false;
}
function isSet(x) {
    if (!setSize || !x || typeof x !== "object") return false;
    try {
        setSize.call(x);
        try {
            mapSize.call(x);
        } catch (m) {
            return true;
        }
        return x instanceof Set; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}
function isWeakSet(x) {
    if (!weakSetHas || !x || typeof x !== "object") return false;
    try {
        weakSetHas.call(x, weakSetHas);
        try {
            weakMapHas.call(x, weakMapHas);
        } catch (s) {
            return true;
        }
        return x instanceof WeakSet; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}
function isElement(x) {
    if (!x || typeof x !== "object") return false;
    if (typeof HTMLElement !== "undefined" && x instanceof HTMLElement) return true;
    return typeof x.nodeName === "string" && typeof x.getAttribute === "function";
}
function inspectString(str, opts) {
    if (str.length > opts.maxStringLength) {
        var remaining = str.length - opts.maxStringLength;
        var trailer = "... " + remaining + " more character" + (remaining > 1 ? "s" : "");
        return inspectString($slice.call(str, 0, opts.maxStringLength), opts) + trailer;
    }
    // eslint-disable-next-line no-control-regex
    var s = $replace.call($replace.call(str, /(['\\])/g, "\\$1"), /[\x00-\x1f]/g, lowbyte);
    return wrapQuotes(s, "single", opts);
}
function lowbyte(c) {
    var n = c.charCodeAt(0);
    var x = {
        8: "b",
        9: "t",
        10: "n",
        12: "f",
        13: "r"
    }[n];
    if (x) return "\\" + x;
    return "\\x" + (n < 0x10 ? "0" : "") + $toUpperCase.call(n.toString(16));
}
function markBoxed(str) {
    return "Object(" + str + ")";
}
function weakCollectionOf(type) {
    return type + " { ? }";
}
function collectionOf(type, size, entries, indent) {
    var joinedEntries = indent ? indentedJoin(entries, indent) : $join.call(entries, ", ");
    return type + " (" + size + ") {" + joinedEntries + "}";
}
function singleLineValues(xs) {
    for(var i = 0; i < xs.length; i++){
        if (indexOf(xs[i], "\n") >= 0) return false;
    }
    return true;
}
function getIndent(opts, depth) {
    var baseIndent;
    if (opts.indent === "	") baseIndent = "	";
    else if (typeof opts.indent === "number" && opts.indent > 0) baseIndent = $join.call(Array(opts.indent + 1), " ");
    else return null;
    return {
        base: baseIndent,
        prev: $join.call(Array(depth + 1), baseIndent)
    };
}
function indentedJoin(xs, indent) {
    if (xs.length === 0) return "";
    var lineJoiner = "\n" + indent.prev + indent.base;
    return lineJoiner + $join.call(xs, "," + lineJoiner) + "\n" + indent.prev;
}
function arrObjKeys(obj, inspect) {
    var isArr = isArray(obj);
    var xs = [];
    if (isArr) {
        xs.length = obj.length;
        for(var i = 0; i < obj.length; i++)xs[i] = has(obj, i) ? inspect(obj[i], obj) : "";
    }
    var syms = typeof gOPS === "function" ? gOPS(obj) : [];
    var symMap;
    if (hasShammedSymbols) {
        symMap = {};
        for(var k = 0; k < syms.length; k++)symMap["$" + syms[k]] = syms[k];
    }
    for(var key in obj){
        if (!has(obj, key)) continue;
         // eslint-disable-line no-restricted-syntax, no-continue
        if (isArr && String(Number(key)) === key && key < obj.length) continue;
         // eslint-disable-line no-restricted-syntax, no-continue
        if (hasShammedSymbols && symMap["$" + key] instanceof Symbol) continue; // eslint-disable-line no-restricted-syntax, no-continue
        else if ($test.call(/[^\w$]/, key)) xs.push(inspect(key, obj) + ": " + inspect(obj[key], obj));
        else xs.push(key + ": " + inspect(obj[key], obj));
    }
    if (typeof gOPS === "function") {
        for(var j = 0; j < syms.length; j++)if (isEnumerable.call(obj, syms[j])) xs.push("[" + inspect(syms[j]) + "]: " + inspect(obj[syms[j]], obj));
    }
    return xs;
}

},{"faefcb1694f2ad90":"13Pcp"}],"3YhBn":[function(require,module,exports) {
"use strict";
var formats = require("7adf3674f81a2c87");
var has = Object.prototype.hasOwnProperty;
var isArray = Array.isArray;
var hexTable = function() {
    var array = [];
    for(var i = 0; i < 256; ++i)array.push("%" + ((i < 16 ? "0" : "") + i.toString(16)).toUpperCase());
    return array;
}();
var compactQueue = function compactQueue(queue) {
    while(queue.length > 1){
        var item = queue.pop();
        var obj = item.obj[item.prop];
        if (isArray(obj)) {
            var compacted = [];
            for(var j = 0; j < obj.length; ++j)if (typeof obj[j] !== "undefined") compacted.push(obj[j]);
            item.obj[item.prop] = compacted;
        }
    }
};
var arrayToObject = function arrayToObject(source, options) {
    var obj = options && options.plainObjects ? Object.create(null) : {};
    for(var i = 0; i < source.length; ++i)if (typeof source[i] !== "undefined") obj[i] = source[i];
    return obj;
};
var merge = function merge(target, source, options) {
    /* eslint no-param-reassign: 0 */ if (!source) return target;
    if (typeof source !== "object") {
        if (isArray(target)) target.push(source);
        else if (target && typeof target === "object") {
            if (options && (options.plainObjects || options.allowPrototypes) || !has.call(Object.prototype, source)) target[source] = true;
        } else return [
            target,
            source
        ];
        return target;
    }
    if (!target || typeof target !== "object") return [
        target
    ].concat(source);
    var mergeTarget = target;
    if (isArray(target) && !isArray(source)) mergeTarget = arrayToObject(target, options);
    if (isArray(target) && isArray(source)) {
        source.forEach(function(item, i) {
            if (has.call(target, i)) {
                var targetItem = target[i];
                if (targetItem && typeof targetItem === "object" && item && typeof item === "object") target[i] = merge(targetItem, item, options);
                else target.push(item);
            } else target[i] = item;
        });
        return target;
    }
    return Object.keys(source).reduce(function(acc, key) {
        var value = source[key];
        if (has.call(acc, key)) acc[key] = merge(acc[key], value, options);
        else acc[key] = value;
        return acc;
    }, mergeTarget);
};
var assign = function assignSingleSource(target, source) {
    return Object.keys(source).reduce(function(acc, key) {
        acc[key] = source[key];
        return acc;
    }, target);
};
var decode = function(str, decoder, charset) {
    var strWithoutPlus = str.replace(/\+/g, " ");
    if (charset === "iso-8859-1") // unescape never throws, no try...catch needed:
    return strWithoutPlus.replace(/%[0-9a-f]{2}/gi, unescape);
    // utf-8
    try {
        return decodeURIComponent(strWithoutPlus);
    } catch (e) {
        return strWithoutPlus;
    }
};
var limit = 1024;
/* eslint operator-linebreak: [2, "before"] */ var encode = function encode(str, defaultEncoder, charset, kind, format) {
    // This code was originally written by Brian White (mscdex) for the io.js core querystring library.
    // It has been adapted here for stricter adherence to RFC 3986
    if (str.length === 0) return str;
    var string = str;
    if (typeof str === "symbol") string = Symbol.prototype.toString.call(str);
    else if (typeof str !== "string") string = String(str);
    if (charset === "iso-8859-1") return escape(string).replace(/%u[0-9a-f]{4}/gi, function($0) {
        return "%26%23" + parseInt($0.slice(2), 16) + "%3B";
    });
    var out = "";
    for(var j = 0; j < string.length; j += limit){
        var segment = string.length >= limit ? string.slice(j, j + limit) : string;
        var arr = [];
        for(var i = 0; i < segment.length; ++i){
            var c = segment.charCodeAt(i);
            if (c === 0x2D // -
             || c === 0x2E // .
             || c === 0x5F // _
             || c === 0x7E // ~
             || c >= 0x30 && c <= 0x39 // 0-9
             || c >= 0x41 && c <= 0x5A // a-z
             || c >= 0x61 && c <= 0x7A // A-Z
             || format === formats.RFC1738 && (c === 0x28 || c === 0x29) // ( )
            ) {
                arr[arr.length] = segment.charAt(i);
                continue;
            }
            if (c < 0x80) {
                arr[arr.length] = hexTable[c];
                continue;
            }
            if (c < 0x800) {
                arr[arr.length] = hexTable[0xC0 | c >> 6] + hexTable[0x80 | c & 0x3F];
                continue;
            }
            if (c < 0xD800 || c >= 0xE000) {
                arr[arr.length] = hexTable[0xE0 | c >> 12] + hexTable[0x80 | c >> 6 & 0x3F] + hexTable[0x80 | c & 0x3F];
                continue;
            }
            i += 1;
            c = 0x10000 + ((c & 0x3FF) << 10 | segment.charCodeAt(i) & 0x3FF);
            arr[arr.length] = hexTable[0xF0 | c >> 18] + hexTable[0x80 | c >> 12 & 0x3F] + hexTable[0x80 | c >> 6 & 0x3F] + hexTable[0x80 | c & 0x3F];
        }
        out += arr.join("");
    }
    return out;
};
var compact = function compact(value) {
    var queue = [
        {
            obj: {
                o: value
            },
            prop: "o"
        }
    ];
    var refs = [];
    for(var i = 0; i < queue.length; ++i){
        var item = queue[i];
        var obj = item.obj[item.prop];
        var keys = Object.keys(obj);
        for(var j = 0; j < keys.length; ++j){
            var key = keys[j];
            var val = obj[key];
            if (typeof val === "object" && val !== null && refs.indexOf(val) === -1) {
                queue.push({
                    obj: obj,
                    prop: key
                });
                refs.push(val);
            }
        }
    }
    compactQueue(queue);
    return value;
};
var isRegExp = function isRegExp(obj) {
    return Object.prototype.toString.call(obj) === "[object RegExp]";
};
var isBuffer = function isBuffer(obj) {
    if (!obj || typeof obj !== "object") return false;
    return !!(obj.constructor && obj.constructor.isBuffer && obj.constructor.isBuffer(obj));
};
var combine = function combine(a, b) {
    return [].concat(a, b);
};
var maybeMap = function maybeMap(val, fn) {
    if (isArray(val)) {
        var mapped = [];
        for(var i = 0; i < val.length; i += 1)mapped.push(fn(val[i]));
        return mapped;
    }
    return fn(val);
};
module.exports = {
    arrayToObject: arrayToObject,
    assign: assign,
    combine: combine,
    compact: compact,
    decode: decode,
    encode: encode,
    isBuffer: isBuffer,
    isRegExp: isRegExp,
    maybeMap: maybeMap,
    merge: merge
};

},{"7adf3674f81a2c87":"4FjOV"}],"4FjOV":[function(require,module,exports) {
"use strict";
var replace = String.prototype.replace;
var percentTwenties = /%20/g;
var Format = {
    RFC1738: "RFC1738",
    RFC3986: "RFC3986"
};
module.exports = {
    "default": Format.RFC3986,
    formatters: {
        RFC1738: function(value) {
            return replace.call(value, percentTwenties, "+");
        },
        RFC3986: function(value) {
            return String(value);
        }
    },
    RFC1738: Format.RFC1738,
    RFC3986: Format.RFC3986
};

},{}],"4TH1Q":[function(require,module,exports) {
"use strict";
var utils = require("e76649c95dd0e736");
var has = Object.prototype.hasOwnProperty;
var isArray = Array.isArray;
var defaults = {
    allowDots: false,
    allowEmptyArrays: false,
    allowPrototypes: false,
    allowSparse: false,
    arrayLimit: 20,
    charset: "utf-8",
    charsetSentinel: false,
    comma: false,
    decodeDotInKeys: false,
    decoder: utils.decode,
    delimiter: "&",
    depth: 5,
    duplicates: "combine",
    ignoreQueryPrefix: false,
    interpretNumericEntities: false,
    parameterLimit: 1000,
    parseArrays: true,
    plainObjects: false,
    strictDepth: false,
    strictNullHandling: false
};
var interpretNumericEntities = function(str) {
    return str.replace(/&#(\d+);/g, function($0, numberStr) {
        return String.fromCharCode(parseInt(numberStr, 10));
    });
};
var parseArrayValue = function(val, options) {
    if (val && typeof val === "string" && options.comma && val.indexOf(",") > -1) return val.split(",");
    return val;
};
// This is what browsers will submit when the ✓ character occurs in an
// application/x-www-form-urlencoded body and the encoding of the page containing
// the form is iso-8859-1, or when the submitted form has an accept-charset
// attribute of iso-8859-1. Presumably also with other charsets that do not contain
// the ✓ character, such as us-ascii.
var isoSentinel = "utf8=%26%2310003%3B"; // encodeURIComponent('&#10003;')
// These are the percent-encoded utf-8 octets representing a checkmark, indicating that the request actually is utf-8 encoded.
var charsetSentinel = "utf8=%E2%9C%93"; // encodeURIComponent('✓')
var parseValues = function parseQueryStringValues(str, options) {
    var obj = {
        __proto__: null
    };
    var cleanStr = options.ignoreQueryPrefix ? str.replace(/^\?/, "") : str;
    cleanStr = cleanStr.replace(/%5B/gi, "[").replace(/%5D/gi, "]");
    var limit = options.parameterLimit === Infinity ? undefined : options.parameterLimit;
    var parts = cleanStr.split(options.delimiter, limit);
    var skipIndex = -1; // Keep track of where the utf8 sentinel was found
    var i;
    var charset = options.charset;
    if (options.charsetSentinel) {
        for(i = 0; i < parts.length; ++i)if (parts[i].indexOf("utf8=") === 0) {
            if (parts[i] === charsetSentinel) charset = "utf-8";
            else if (parts[i] === isoSentinel) charset = "iso-8859-1";
            skipIndex = i;
            i = parts.length; // The eslint settings do not allow break;
        }
    }
    for(i = 0; i < parts.length; ++i){
        if (i === skipIndex) continue;
        var part = parts[i];
        var bracketEqualsPos = part.indexOf("]=");
        var pos = bracketEqualsPos === -1 ? part.indexOf("=") : bracketEqualsPos + 1;
        var key, val;
        if (pos === -1) {
            key = options.decoder(part, defaults.decoder, charset, "key");
            val = options.strictNullHandling ? null : "";
        } else {
            key = options.decoder(part.slice(0, pos), defaults.decoder, charset, "key");
            val = utils.maybeMap(parseArrayValue(part.slice(pos + 1), options), function(encodedVal) {
                return options.decoder(encodedVal, defaults.decoder, charset, "value");
            });
        }
        if (val && options.interpretNumericEntities && charset === "iso-8859-1") val = interpretNumericEntities(val);
        if (part.indexOf("[]=") > -1) val = isArray(val) ? [
            val
        ] : val;
        var existing = has.call(obj, key);
        if (existing && options.duplicates === "combine") obj[key] = utils.combine(obj[key], val);
        else if (!existing || options.duplicates === "last") obj[key] = val;
    }
    return obj;
};
var parseObject = function(chain, val, options, valuesParsed) {
    var leaf = valuesParsed ? val : parseArrayValue(val, options);
    for(var i = chain.length - 1; i >= 0; --i){
        var obj;
        var root = chain[i];
        if (root === "[]" && options.parseArrays) obj = options.allowEmptyArrays && (leaf === "" || options.strictNullHandling && leaf === null) ? [] : [].concat(leaf);
        else {
            obj = options.plainObjects ? Object.create(null) : {};
            var cleanRoot = root.charAt(0) === "[" && root.charAt(root.length - 1) === "]" ? root.slice(1, -1) : root;
            var decodedRoot = options.decodeDotInKeys ? cleanRoot.replace(/%2E/g, ".") : cleanRoot;
            var index = parseInt(decodedRoot, 10);
            if (!options.parseArrays && decodedRoot === "") obj = {
                0: leaf
            };
            else if (!isNaN(index) && root !== decodedRoot && String(index) === decodedRoot && index >= 0 && options.parseArrays && index <= options.arrayLimit) {
                obj = [];
                obj[index] = leaf;
            } else if (decodedRoot !== "__proto__") obj[decodedRoot] = leaf;
        }
        leaf = obj;
    }
    return leaf;
};
var parseKeys = function parseQueryStringKeys(givenKey, val, options, valuesParsed) {
    if (!givenKey) return;
    // Transform dot notation to bracket notation
    var key = options.allowDots ? givenKey.replace(/\.([^.[]+)/g, "[$1]") : givenKey;
    // The regex chunks
    var brackets = /(\[[^[\]]*])/;
    var child = /(\[[^[\]]*])/g;
    // Get the parent
    var segment = options.depth > 0 && brackets.exec(key);
    var parent = segment ? key.slice(0, segment.index) : key;
    // Stash the parent if it exists
    var keys = [];
    if (parent) {
        // If we aren't using plain objects, optionally prefix keys that would overwrite object prototype properties
        if (!options.plainObjects && has.call(Object.prototype, parent)) {
            if (!options.allowPrototypes) return;
        }
        keys.push(parent);
    }
    // Loop through children appending to the array until we hit depth
    var i = 0;
    while(options.depth > 0 && (segment = child.exec(key)) !== null && i < options.depth){
        i += 1;
        if (!options.plainObjects && has.call(Object.prototype, segment[1].slice(1, -1))) {
            if (!options.allowPrototypes) return;
        }
        keys.push(segment[1]);
    }
    // If there's a remainder, check strictDepth option for throw, else just add whatever is left
    if (segment) {
        if (options.strictDepth === true) throw new RangeError("Input depth exceeded depth option of " + options.depth + " and strictDepth is true");
        keys.push("[" + key.slice(segment.index) + "]");
    }
    return parseObject(keys, val, options, valuesParsed);
};
var normalizeParseOptions = function normalizeParseOptions(opts) {
    if (!opts) return defaults;
    if (typeof opts.allowEmptyArrays !== "undefined" && typeof opts.allowEmptyArrays !== "boolean") throw new TypeError("`allowEmptyArrays` option can only be `true` or `false`, when provided");
    if (typeof opts.decodeDotInKeys !== "undefined" && typeof opts.decodeDotInKeys !== "boolean") throw new TypeError("`decodeDotInKeys` option can only be `true` or `false`, when provided");
    if (opts.decoder !== null && typeof opts.decoder !== "undefined" && typeof opts.decoder !== "function") throw new TypeError("Decoder has to be a function.");
    if (typeof opts.charset !== "undefined" && opts.charset !== "utf-8" && opts.charset !== "iso-8859-1") throw new TypeError("The charset option must be either utf-8, iso-8859-1, or undefined");
    var charset = typeof opts.charset === "undefined" ? defaults.charset : opts.charset;
    var duplicates = typeof opts.duplicates === "undefined" ? defaults.duplicates : opts.duplicates;
    if (duplicates !== "combine" && duplicates !== "first" && duplicates !== "last") throw new TypeError("The duplicates option must be either combine, first, or last");
    var allowDots = typeof opts.allowDots === "undefined" ? opts.decodeDotInKeys === true ? true : defaults.allowDots : !!opts.allowDots;
    return {
        allowDots: allowDots,
        allowEmptyArrays: typeof opts.allowEmptyArrays === "boolean" ? !!opts.allowEmptyArrays : defaults.allowEmptyArrays,
        allowPrototypes: typeof opts.allowPrototypes === "boolean" ? opts.allowPrototypes : defaults.allowPrototypes,
        allowSparse: typeof opts.allowSparse === "boolean" ? opts.allowSparse : defaults.allowSparse,
        arrayLimit: typeof opts.arrayLimit === "number" ? opts.arrayLimit : defaults.arrayLimit,
        charset: charset,
        charsetSentinel: typeof opts.charsetSentinel === "boolean" ? opts.charsetSentinel : defaults.charsetSentinel,
        comma: typeof opts.comma === "boolean" ? opts.comma : defaults.comma,
        decodeDotInKeys: typeof opts.decodeDotInKeys === "boolean" ? opts.decodeDotInKeys : defaults.decodeDotInKeys,
        decoder: typeof opts.decoder === "function" ? opts.decoder : defaults.decoder,
        delimiter: typeof opts.delimiter === "string" || utils.isRegExp(opts.delimiter) ? opts.delimiter : defaults.delimiter,
        // eslint-disable-next-line no-implicit-coercion, no-extra-parens
        depth: typeof opts.depth === "number" || opts.depth === false ? +opts.depth : defaults.depth,
        duplicates: duplicates,
        ignoreQueryPrefix: opts.ignoreQueryPrefix === true,
        interpretNumericEntities: typeof opts.interpretNumericEntities === "boolean" ? opts.interpretNumericEntities : defaults.interpretNumericEntities,
        parameterLimit: typeof opts.parameterLimit === "number" ? opts.parameterLimit : defaults.parameterLimit,
        parseArrays: opts.parseArrays !== false,
        plainObjects: typeof opts.plainObjects === "boolean" ? opts.plainObjects : defaults.plainObjects,
        strictDepth: typeof opts.strictDepth === "boolean" ? !!opts.strictDepth : defaults.strictDepth,
        strictNullHandling: typeof opts.strictNullHandling === "boolean" ? opts.strictNullHandling : defaults.strictNullHandling
    };
};
module.exports = function(str, opts) {
    var options = normalizeParseOptions(opts);
    if (str === "" || str === null || typeof str === "undefined") return options.plainObjects ? Object.create(null) : {};
    var tempObj = typeof str === "string" ? parseValues(str, options) : str;
    var obj = options.plainObjects ? Object.create(null) : {};
    // Iterate over the keys and setup the new object
    var keys = Object.keys(tempObj);
    for(var i = 0; i < keys.length; ++i){
        var key = keys[i];
        var newObj = parseKeys(key, tempObj[key], options, typeof str === "string");
        obj = utils.merge(obj, newObj, options);
    }
    if (options.allowSparse === true) return obj;
    return utils.compact(obj);
};

},{"e76649c95dd0e736":"3YhBn"}],"h9uDr":[function(require,module,exports) {
var http = require("c0383d0f5be55d6b");
var url = require("23c94c23cc2fc416");
var https = module.exports;
for(var key in http)if (http.hasOwnProperty(key)) https[key] = http[key];
https.request = function(params, cb) {
    params = validateParams(params);
    return http.request.call(this, params, cb);
};
https.get = function(params, cb) {
    params = validateParams(params);
    return http.get.call(this, params, cb);
};
function validateParams(params) {
    if (typeof params === "string") params = url.parse(params);
    if (!params.protocol) params.protocol = "https:";
    if (params.protocol !== "https:") throw new Error('Protocol "' + params.protocol + '" not supported. Expected "https:"');
    return params;
}

},{"c0383d0f5be55d6b":"biwe9","23c94c23cc2fc416":"280SV"}],"IZkiP":[function(require,module,exports) {
var process = require("85b5e5b1fe9ac2d6");
"use strict";
var Buffer = require("b45d57ded3095448").Buffer;
var Transform = require("302f6ba8c9b288cd").Transform;
var binding = require("18c3507b0ec1fd53");
var util = require("eb7830382781fd77");
var assert = require("6d05aa73f6370f9e").ok;
var kMaxLength = require("b45d57ded3095448").kMaxLength;
var kRangeErrorMessage = "Cannot create final Buffer. It would be larger than 0x" + kMaxLength.toString(16) + " bytes";
// zlib doesn't provide these, so kludge them in following the same
// const naming scheme zlib uses.
binding.Z_MIN_WINDOWBITS = 8;
binding.Z_MAX_WINDOWBITS = 15;
binding.Z_DEFAULT_WINDOWBITS = 15;
// fewer than 64 bytes per chunk is stupid.
// technically it could work with as few as 8, but even 64 bytes
// is absurdly low.  Usually a MB or more is best.
binding.Z_MIN_CHUNK = 64;
binding.Z_MAX_CHUNK = Infinity;
binding.Z_DEFAULT_CHUNK = 16384;
binding.Z_MIN_MEMLEVEL = 1;
binding.Z_MAX_MEMLEVEL = 9;
binding.Z_DEFAULT_MEMLEVEL = 8;
binding.Z_MIN_LEVEL = -1;
binding.Z_MAX_LEVEL = 9;
binding.Z_DEFAULT_LEVEL = binding.Z_DEFAULT_COMPRESSION;
// expose all the zlib constants
var bkeys = Object.keys(binding);
for(var bk = 0; bk < bkeys.length; bk++){
    var bkey = bkeys[bk];
    if (bkey.match(/^Z/)) Object.defineProperty(exports, bkey, {
        enumerable: true,
        value: binding[bkey],
        writable: false
    });
}
// translation table for return codes.
var codes = {
    Z_OK: binding.Z_OK,
    Z_STREAM_END: binding.Z_STREAM_END,
    Z_NEED_DICT: binding.Z_NEED_DICT,
    Z_ERRNO: binding.Z_ERRNO,
    Z_STREAM_ERROR: binding.Z_STREAM_ERROR,
    Z_DATA_ERROR: binding.Z_DATA_ERROR,
    Z_MEM_ERROR: binding.Z_MEM_ERROR,
    Z_BUF_ERROR: binding.Z_BUF_ERROR,
    Z_VERSION_ERROR: binding.Z_VERSION_ERROR
};
var ckeys = Object.keys(codes);
for(var ck = 0; ck < ckeys.length; ck++){
    var ckey = ckeys[ck];
    codes[codes[ckey]] = ckey;
}
Object.defineProperty(exports, "codes", {
    enumerable: true,
    value: Object.freeze(codes),
    writable: false
});
exports.Deflate = Deflate;
exports.Inflate = Inflate;
exports.Gzip = Gzip;
exports.Gunzip = Gunzip;
exports.DeflateRaw = DeflateRaw;
exports.InflateRaw = InflateRaw;
exports.Unzip = Unzip;
exports.createDeflate = function(o) {
    return new Deflate(o);
};
exports.createInflate = function(o) {
    return new Inflate(o);
};
exports.createDeflateRaw = function(o) {
    return new DeflateRaw(o);
};
exports.createInflateRaw = function(o) {
    return new InflateRaw(o);
};
exports.createGzip = function(o) {
    return new Gzip(o);
};
exports.createGunzip = function(o) {
    return new Gunzip(o);
};
exports.createUnzip = function(o) {
    return new Unzip(o);
};
// Convenience methods.
// compress/decompress a string or buffer in one step.
exports.deflate = function(buffer, opts, callback) {
    if (typeof opts === "function") {
        callback = opts;
        opts = {};
    }
    return zlibBuffer(new Deflate(opts), buffer, callback);
};
exports.deflateSync = function(buffer, opts) {
    return zlibBufferSync(new Deflate(opts), buffer);
};
exports.gzip = function(buffer, opts, callback) {
    if (typeof opts === "function") {
        callback = opts;
        opts = {};
    }
    return zlibBuffer(new Gzip(opts), buffer, callback);
};
exports.gzipSync = function(buffer, opts) {
    return zlibBufferSync(new Gzip(opts), buffer);
};
exports.deflateRaw = function(buffer, opts, callback) {
    if (typeof opts === "function") {
        callback = opts;
        opts = {};
    }
    return zlibBuffer(new DeflateRaw(opts), buffer, callback);
};
exports.deflateRawSync = function(buffer, opts) {
    return zlibBufferSync(new DeflateRaw(opts), buffer);
};
exports.unzip = function(buffer, opts, callback) {
    if (typeof opts === "function") {
        callback = opts;
        opts = {};
    }
    return zlibBuffer(new Unzip(opts), buffer, callback);
};
exports.unzipSync = function(buffer, opts) {
    return zlibBufferSync(new Unzip(opts), buffer);
};
exports.inflate = function(buffer, opts, callback) {
    if (typeof opts === "function") {
        callback = opts;
        opts = {};
    }
    return zlibBuffer(new Inflate(opts), buffer, callback);
};
exports.inflateSync = function(buffer, opts) {
    return zlibBufferSync(new Inflate(opts), buffer);
};
exports.gunzip = function(buffer, opts, callback) {
    if (typeof opts === "function") {
        callback = opts;
        opts = {};
    }
    return zlibBuffer(new Gunzip(opts), buffer, callback);
};
exports.gunzipSync = function(buffer, opts) {
    return zlibBufferSync(new Gunzip(opts), buffer);
};
exports.inflateRaw = function(buffer, opts, callback) {
    if (typeof opts === "function") {
        callback = opts;
        opts = {};
    }
    return zlibBuffer(new InflateRaw(opts), buffer, callback);
};
exports.inflateRawSync = function(buffer, opts) {
    return zlibBufferSync(new InflateRaw(opts), buffer);
};
function zlibBuffer(engine, buffer, callback) {
    var buffers = [];
    var nread = 0;
    engine.on("error", onError);
    engine.on("end", onEnd);
    engine.end(buffer);
    flow();
    function flow() {
        var chunk;
        while(null !== (chunk = engine.read())){
            buffers.push(chunk);
            nread += chunk.length;
        }
        engine.once("readable", flow);
    }
    function onError(err) {
        engine.removeListener("end", onEnd);
        engine.removeListener("readable", flow);
        callback(err);
    }
    function onEnd() {
        var buf;
        var err = null;
        if (nread >= kMaxLength) err = new RangeError(kRangeErrorMessage);
        else buf = Buffer.concat(buffers, nread);
        buffers = [];
        engine.close();
        callback(err, buf);
    }
}
function zlibBufferSync(engine, buffer) {
    if (typeof buffer === "string") buffer = Buffer.from(buffer);
    if (!Buffer.isBuffer(buffer)) throw new TypeError("Not a string or buffer");
    var flushFlag = engine._finishFlushFlag;
    return engine._processChunk(buffer, flushFlag);
}
// generic zlib
// minimal 2-byte header
function Deflate(opts) {
    if (!(this instanceof Deflate)) return new Deflate(opts);
    Zlib.call(this, opts, binding.DEFLATE);
}
function Inflate(opts) {
    if (!(this instanceof Inflate)) return new Inflate(opts);
    Zlib.call(this, opts, binding.INFLATE);
}
// gzip - bigger header, same deflate compression
function Gzip(opts) {
    if (!(this instanceof Gzip)) return new Gzip(opts);
    Zlib.call(this, opts, binding.GZIP);
}
function Gunzip(opts) {
    if (!(this instanceof Gunzip)) return new Gunzip(opts);
    Zlib.call(this, opts, binding.GUNZIP);
}
// raw - no header
function DeflateRaw(opts) {
    if (!(this instanceof DeflateRaw)) return new DeflateRaw(opts);
    Zlib.call(this, opts, binding.DEFLATERAW);
}
function InflateRaw(opts) {
    if (!(this instanceof InflateRaw)) return new InflateRaw(opts);
    Zlib.call(this, opts, binding.INFLATERAW);
}
// auto-detect header.
function Unzip(opts) {
    if (!(this instanceof Unzip)) return new Unzip(opts);
    Zlib.call(this, opts, binding.UNZIP);
}
function isValidFlushFlag(flag) {
    return flag === binding.Z_NO_FLUSH || flag === binding.Z_PARTIAL_FLUSH || flag === binding.Z_SYNC_FLUSH || flag === binding.Z_FULL_FLUSH || flag === binding.Z_FINISH || flag === binding.Z_BLOCK;
}
// the Zlib class they all inherit from
// This thing manages the queue of requests, and returns
// true or false if there is anything in the queue when
// you call the .write() method.
function Zlib(opts, mode) {
    var _this = this;
    this._opts = opts = opts || {};
    this._chunkSize = opts.chunkSize || exports.Z_DEFAULT_CHUNK;
    Transform.call(this, opts);
    if (opts.flush && !isValidFlushFlag(opts.flush)) throw new Error("Invalid flush flag: " + opts.flush);
    if (opts.finishFlush && !isValidFlushFlag(opts.finishFlush)) throw new Error("Invalid flush flag: " + opts.finishFlush);
    this._flushFlag = opts.flush || binding.Z_NO_FLUSH;
    this._finishFlushFlag = typeof opts.finishFlush !== "undefined" ? opts.finishFlush : binding.Z_FINISH;
    if (opts.chunkSize) {
        if (opts.chunkSize < exports.Z_MIN_CHUNK || opts.chunkSize > exports.Z_MAX_CHUNK) throw new Error("Invalid chunk size: " + opts.chunkSize);
    }
    if (opts.windowBits) {
        if (opts.windowBits < exports.Z_MIN_WINDOWBITS || opts.windowBits > exports.Z_MAX_WINDOWBITS) throw new Error("Invalid windowBits: " + opts.windowBits);
    }
    if (opts.level) {
        if (opts.level < exports.Z_MIN_LEVEL || opts.level > exports.Z_MAX_LEVEL) throw new Error("Invalid compression level: " + opts.level);
    }
    if (opts.memLevel) {
        if (opts.memLevel < exports.Z_MIN_MEMLEVEL || opts.memLevel > exports.Z_MAX_MEMLEVEL) throw new Error("Invalid memLevel: " + opts.memLevel);
    }
    if (opts.strategy) {
        if (opts.strategy != exports.Z_FILTERED && opts.strategy != exports.Z_HUFFMAN_ONLY && opts.strategy != exports.Z_RLE && opts.strategy != exports.Z_FIXED && opts.strategy != exports.Z_DEFAULT_STRATEGY) throw new Error("Invalid strategy: " + opts.strategy);
    }
    if (opts.dictionary) {
        if (!Buffer.isBuffer(opts.dictionary)) throw new Error("Invalid dictionary: it should be a Buffer instance");
    }
    this._handle = new binding.Zlib(mode);
    var self = this;
    this._hadError = false;
    this._handle.onerror = function(message, errno) {
        // there is no way to cleanly recover.
        // continuing only obscures problems.
        _close(self);
        self._hadError = true;
        var error = new Error(message);
        error.errno = errno;
        error.code = exports.codes[errno];
        self.emit("error", error);
    };
    var level = exports.Z_DEFAULT_COMPRESSION;
    if (typeof opts.level === "number") level = opts.level;
    var strategy = exports.Z_DEFAULT_STRATEGY;
    if (typeof opts.strategy === "number") strategy = opts.strategy;
    this._handle.init(opts.windowBits || exports.Z_DEFAULT_WINDOWBITS, level, opts.memLevel || exports.Z_DEFAULT_MEMLEVEL, strategy, opts.dictionary);
    this._buffer = Buffer.allocUnsafe(this._chunkSize);
    this._offset = 0;
    this._level = level;
    this._strategy = strategy;
    this.once("end", this.close);
    Object.defineProperty(this, "_closed", {
        get: function() {
            return !_this._handle;
        },
        configurable: true,
        enumerable: true
    });
}
util.inherits(Zlib, Transform);
Zlib.prototype.params = function(level, strategy, callback) {
    if (level < exports.Z_MIN_LEVEL || level > exports.Z_MAX_LEVEL) throw new RangeError("Invalid compression level: " + level);
    if (strategy != exports.Z_FILTERED && strategy != exports.Z_HUFFMAN_ONLY && strategy != exports.Z_RLE && strategy != exports.Z_FIXED && strategy != exports.Z_DEFAULT_STRATEGY) throw new TypeError("Invalid strategy: " + strategy);
    if (this._level !== level || this._strategy !== strategy) {
        var self = this;
        this.flush(binding.Z_SYNC_FLUSH, function() {
            assert(self._handle, "zlib binding closed");
            self._handle.params(level, strategy);
            if (!self._hadError) {
                self._level = level;
                self._strategy = strategy;
                if (callback) callback();
            }
        });
    } else process.nextTick(callback);
};
Zlib.prototype.reset = function() {
    assert(this._handle, "zlib binding closed");
    return this._handle.reset();
};
// This is the _flush function called by the transform class,
// internally, when the last chunk has been written.
Zlib.prototype._flush = function(callback) {
    this._transform(Buffer.alloc(0), "", callback);
};
Zlib.prototype.flush = function(kind, callback) {
    var _this2 = this;
    var ws = this._writableState;
    if (typeof kind === "function" || kind === undefined && !callback) {
        callback = kind;
        kind = binding.Z_FULL_FLUSH;
    }
    if (ws.ended) {
        if (callback) process.nextTick(callback);
    } else if (ws.ending) {
        if (callback) this.once("end", callback);
    } else if (ws.needDrain) {
        if (callback) this.once("drain", function() {
            return _this2.flush(kind, callback);
        });
    } else {
        this._flushFlag = kind;
        this.write(Buffer.alloc(0), "", callback);
    }
};
Zlib.prototype.close = function(callback) {
    _close(this, callback);
    process.nextTick(emitCloseNT, this);
};
function _close(engine, callback) {
    if (callback) process.nextTick(callback);
    // Caller may invoke .close after a zlib error (which will null _handle).
    if (!engine._handle) return;
    engine._handle.close();
    engine._handle = null;
}
function emitCloseNT(self) {
    self.emit("close");
}
Zlib.prototype._transform = function(chunk, encoding, cb) {
    var flushFlag;
    var ws = this._writableState;
    var ending = ws.ending || ws.ended;
    var last = ending && (!chunk || ws.length === chunk.length);
    if (chunk !== null && !Buffer.isBuffer(chunk)) return cb(new Error("invalid input"));
    if (!this._handle) return cb(new Error("zlib binding closed"));
    // If it's the last chunk, or a final flush, we use the Z_FINISH flush flag
    // (or whatever flag was provided using opts.finishFlush).
    // If it's explicitly flushing at some other time, then we use
    // Z_FULL_FLUSH. Otherwise, use Z_NO_FLUSH for maximum compression
    // goodness.
    if (last) flushFlag = this._finishFlushFlag;
    else {
        flushFlag = this._flushFlag;
        // once we've flushed the last of the queue, stop flushing and
        // go back to the normal behavior.
        if (chunk.length >= ws.length) this._flushFlag = this._opts.flush || binding.Z_NO_FLUSH;
    }
    this._processChunk(chunk, flushFlag, cb);
};
Zlib.prototype._processChunk = function(chunk, flushFlag, cb) {
    var availInBefore = chunk && chunk.length;
    var availOutBefore = this._chunkSize - this._offset;
    var inOff = 0;
    var self = this;
    var async = typeof cb === "function";
    if (!async) {
        var buffers = [];
        var nread = 0;
        var error;
        this.on("error", function(er) {
            error = er;
        });
        assert(this._handle, "zlib binding closed");
        do var res = this._handle.writeSync(flushFlag, chunk, inOff, availInBefore, this._buffer, this._offset, availOutBefore); // out_len
        while (!this._hadError && callback(res[0], res[1]));
        if (this._hadError) throw error;
        if (nread >= kMaxLength) {
            _close(this);
            throw new RangeError(kRangeErrorMessage);
        }
        var buf = Buffer.concat(buffers, nread);
        _close(this);
        return buf;
    }
    assert(this._handle, "zlib binding closed");
    var req = this._handle.write(flushFlag, chunk, inOff, availInBefore, this._buffer, this._offset, availOutBefore); // out_len
    req.buffer = chunk;
    req.callback = callback;
    function callback(availInAfter, availOutAfter) {
        // When the callback is used in an async write, the callback's
        // context is the `req` object that was created. The req object
        // is === this._handle, and that's why it's important to null
        // out the values after they are done being used. `this._handle`
        // can stay in memory longer than the callback and buffer are needed.
        if (this) {
            this.buffer = null;
            this.callback = null;
        }
        if (self._hadError) return;
        var have = availOutBefore - availOutAfter;
        assert(have >= 0, "have should not go down");
        if (have > 0) {
            var out = self._buffer.slice(self._offset, self._offset + have);
            self._offset += have;
            // serve some output to the consumer.
            if (async) self.push(out);
            else {
                buffers.push(out);
                nread += out.length;
            }
        }
        // exhausted the output buffer, or used all the input create a new one.
        if (availOutAfter === 0 || self._offset >= self._chunkSize) {
            availOutBefore = self._chunkSize;
            self._offset = 0;
            self._buffer = Buffer.allocUnsafe(self._chunkSize);
        }
        if (availOutAfter === 0) {
            // Not actually done.  Need to reprocess.
            // Also, update the availInBefore to the availInAfter value,
            // so that if we have to hit it a third (fourth, etc.) time,
            // it'll have the correct byte counts.
            inOff += availInBefore - availInAfter;
            availInBefore = availInAfter;
            if (!async) return true;
            var newReq = self._handle.write(flushFlag, chunk, inOff, availInBefore, self._buffer, self._offset, self._chunkSize);
            newReq.callback = callback; // this same function
            newReq.buffer = chunk;
            return;
        }
        if (!async) return false;
        // finished with the chunk.
        cb();
    }
};
util.inherits(Deflate, Zlib);
util.inherits(Inflate, Zlib);
util.inherits(Gzip, Zlib);
util.inherits(Gunzip, Zlib);
util.inherits(DeflateRaw, Zlib);
util.inherits(InflateRaw, Zlib);
util.inherits(Unzip, Zlib);

},{"85b5e5b1fe9ac2d6":"5QIF0","b45d57ded3095448":"l5Twm","302f6ba8c9b288cd":"gHHLM","18c3507b0ec1fd53":"blebQ","eb7830382781fd77":"jInrX","6d05aa73f6370f9e":"jRkR3"}],"gHHLM":[function(require,module,exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
module.exports = Stream;
var EE = require("96b62835346f84f0").EventEmitter;
var inherits = require("4a6ee9586f51c38d");
inherits(Stream, EE);
Stream.Readable = require("e6206e1f4d20abc7");
Stream.Writable = require("a3f1405f37e1dfb1");
Stream.Duplex = require("6691a72c5fc222fd");
Stream.Transform = require("43a905ce7ec6ac9e");
Stream.PassThrough = require("dd715550d7783885");
Stream.finished = require("d90a3520974ec96e");
Stream.pipeline = require("eb2779cfd287c5c9");
// Backwards-compat with node 0.4.x
Stream.Stream = Stream;
// old-style streams.  Note that the pipe method (the only relevant
// part of this class) is overridden in the Readable class.
function Stream() {
    EE.call(this);
}
Stream.prototype.pipe = function(dest, options) {
    var source = this;
    function ondata(chunk) {
        if (dest.writable) {
            if (false === dest.write(chunk) && source.pause) source.pause();
        }
    }
    source.on("data", ondata);
    function ondrain() {
        if (source.readable && source.resume) source.resume();
    }
    dest.on("drain", ondrain);
    // If the 'end' option is not supplied, dest.end() will be called when
    // source gets the 'end' or 'close' events.  Only dest.end() once.
    if (!dest._isStdio && (!options || options.end !== false)) {
        source.on("end", onend);
        source.on("close", onclose);
    }
    var didOnEnd = false;
    function onend() {
        if (didOnEnd) return;
        didOnEnd = true;
        dest.end();
    }
    function onclose() {
        if (didOnEnd) return;
        didOnEnd = true;
        if (typeof dest.destroy === "function") dest.destroy();
    }
    // don't leave dangling pipes when there are errors.
    function onerror(er) {
        cleanup();
        if (EE.listenerCount(this, "error") === 0) throw er; // Unhandled stream error in pipe.
    }
    source.on("error", onerror);
    dest.on("error", onerror);
    // remove all the event listeners that were added.
    function cleanup() {
        source.removeListener("data", ondata);
        dest.removeListener("drain", ondrain);
        source.removeListener("end", onend);
        source.removeListener("close", onclose);
        source.removeListener("error", onerror);
        dest.removeListener("error", onerror);
        source.removeListener("end", cleanup);
        source.removeListener("close", cleanup);
        dest.removeListener("close", cleanup);
    }
    source.on("end", cleanup);
    source.on("close", cleanup);
    dest.on("close", cleanup);
    dest.emit("pipe", source);
    // Allow for unix-like usage: A.pipe(B).pipe(C)
    return dest;
};

},{"96b62835346f84f0":"fqTtD","4a6ee9586f51c38d":"8LxVj","e6206e1f4d20abc7":"cKiEz","a3f1405f37e1dfb1":"1l9D3","6691a72c5fc222fd":"jXYL7","43a905ce7ec6ac9e":"fyAZh","dd715550d7783885":"3kmEt","d90a3520974ec96e":"YQEqF","eb2779cfd287c5c9":"3jCgz"}],"blebQ":[function(require,module,exports) {
var Buffer = require("c0875ec23d3f711b").Buffer;
var process = require("275b523c6d34b701");
"use strict";
/* eslint camelcase: "off" */ var assert = require("77b161f030b665c6");
var Zstream = require("fd1f09d11ac7dfac");
var zlib_deflate = require("df246bd555afd20e");
var zlib_inflate = require("38e8b32c21318329");
var constants = require("5b80d7a6197bcc1e");
for(var key in constants)exports[key] = constants[key];
// zlib modes
exports.NONE = 0;
exports.DEFLATE = 1;
exports.INFLATE = 2;
exports.GZIP = 3;
exports.GUNZIP = 4;
exports.DEFLATERAW = 5;
exports.INFLATERAW = 6;
exports.UNZIP = 7;
var GZIP_HEADER_ID1 = 0x1f;
var GZIP_HEADER_ID2 = 0x8b;
/**
 * Emulate Node's zlib C++ layer for use by the JS layer in index.js
 */ function Zlib(mode) {
    if (typeof mode !== "number" || mode < exports.DEFLATE || mode > exports.UNZIP) throw new TypeError("Bad argument");
    this.dictionary = null;
    this.err = 0;
    this.flush = 0;
    this.init_done = false;
    this.level = 0;
    this.memLevel = 0;
    this.mode = mode;
    this.strategy = 0;
    this.windowBits = 0;
    this.write_in_progress = false;
    this.pending_close = false;
    this.gzip_id_bytes_read = 0;
}
Zlib.prototype.close = function() {
    if (this.write_in_progress) {
        this.pending_close = true;
        return;
    }
    this.pending_close = false;
    assert(this.init_done, "close before init");
    assert(this.mode <= exports.UNZIP);
    if (this.mode === exports.DEFLATE || this.mode === exports.GZIP || this.mode === exports.DEFLATERAW) zlib_deflate.deflateEnd(this.strm);
    else if (this.mode === exports.INFLATE || this.mode === exports.GUNZIP || this.mode === exports.INFLATERAW || this.mode === exports.UNZIP) zlib_inflate.inflateEnd(this.strm);
    this.mode = exports.NONE;
    this.dictionary = null;
};
Zlib.prototype.write = function(flush, input, in_off, in_len, out, out_off, out_len) {
    return this._write(true, flush, input, in_off, in_len, out, out_off, out_len);
};
Zlib.prototype.writeSync = function(flush, input, in_off, in_len, out, out_off, out_len) {
    return this._write(false, flush, input, in_off, in_len, out, out_off, out_len);
};
Zlib.prototype._write = function(async, flush, input, in_off, in_len, out, out_off, out_len) {
    assert.equal(arguments.length, 8);
    assert(this.init_done, "write before init");
    assert(this.mode !== exports.NONE, "already finalized");
    assert.equal(false, this.write_in_progress, "write already in progress");
    assert.equal(false, this.pending_close, "close is pending");
    this.write_in_progress = true;
    assert.equal(false, flush === undefined, "must provide flush value");
    this.write_in_progress = true;
    if (flush !== exports.Z_NO_FLUSH && flush !== exports.Z_PARTIAL_FLUSH && flush !== exports.Z_SYNC_FLUSH && flush !== exports.Z_FULL_FLUSH && flush !== exports.Z_FINISH && flush !== exports.Z_BLOCK) throw new Error("Invalid flush value");
    if (input == null) {
        input = Buffer.alloc(0);
        in_len = 0;
        in_off = 0;
    }
    this.strm.avail_in = in_len;
    this.strm.input = input;
    this.strm.next_in = in_off;
    this.strm.avail_out = out_len;
    this.strm.output = out;
    this.strm.next_out = out_off;
    this.flush = flush;
    if (!async) {
        // sync version
        this._process();
        if (this._checkError()) return this._afterSync();
        return;
    }
    // async version
    var self = this;
    process.nextTick(function() {
        self._process();
        self._after();
    });
    return this;
};
Zlib.prototype._afterSync = function() {
    var avail_out = this.strm.avail_out;
    var avail_in = this.strm.avail_in;
    this.write_in_progress = false;
    return [
        avail_in,
        avail_out
    ];
};
Zlib.prototype._process = function() {
    var next_expected_header_byte = null;
    // If the avail_out is left at 0, then it means that it ran out
    // of room.  If there was avail_out left over, then it means
    // that all of the input was consumed.
    switch(this.mode){
        case exports.DEFLATE:
        case exports.GZIP:
        case exports.DEFLATERAW:
            this.err = zlib_deflate.deflate(this.strm, this.flush);
            break;
        case exports.UNZIP:
            if (this.strm.avail_in > 0) next_expected_header_byte = this.strm.next_in;
            switch(this.gzip_id_bytes_read){
                case 0:
                    if (next_expected_header_byte === null) break;
                    if (this.strm.input[next_expected_header_byte] === GZIP_HEADER_ID1) {
                        this.gzip_id_bytes_read = 1;
                        next_expected_header_byte++;
                        if (this.strm.avail_in === 1) break;
                    } else {
                        this.mode = exports.INFLATE;
                        break;
                    }
                // fallthrough
                case 1:
                    if (next_expected_header_byte === null) break;
                    if (this.strm.input[next_expected_header_byte] === GZIP_HEADER_ID2) {
                        this.gzip_id_bytes_read = 2;
                        this.mode = exports.GUNZIP;
                    } else // There is no actual difference between INFLATE and INFLATERAW
                    // (after initialization).
                    this.mode = exports.INFLATE;
                    break;
                default:
                    throw new Error("invalid number of gzip magic number bytes read");
            }
        // fallthrough
        case exports.INFLATE:
        case exports.GUNZIP:
        case exports.INFLATERAW:
            this.err = zlib_inflate.inflate(this.strm, this.flush);
            if (this.err === exports.Z_NEED_DICT && this.dictionary) {
                // Load it
                this.err = zlib_inflate.inflateSetDictionary(this.strm, this.dictionary);
                if (this.err === exports.Z_OK) // And try to decode again
                this.err = zlib_inflate.inflate(this.strm, this.flush);
                else if (this.err === exports.Z_DATA_ERROR) // Both inflateSetDictionary() and inflate() return Z_DATA_ERROR.
                // Make it possible for After() to tell a bad dictionary from bad
                // input.
                this.err = exports.Z_NEED_DICT;
            }
            while(this.strm.avail_in > 0 && this.mode === exports.GUNZIP && this.err === exports.Z_STREAM_END && this.strm.next_in[0] !== 0x00){
                // Bytes remain in input buffer. Perhaps this is another compressed
                // member in the same archive, or just trailing garbage.
                // Trailing zero bytes are okay, though, since they are frequently
                // used for padding.
                this.reset();
                this.err = zlib_inflate.inflate(this.strm, this.flush);
            }
            break;
        default:
            throw new Error("Unknown mode " + this.mode);
    }
};
Zlib.prototype._checkError = function() {
    // Acceptable error states depend on the type of zlib stream.
    switch(this.err){
        case exports.Z_OK:
        case exports.Z_BUF_ERROR:
            if (this.strm.avail_out !== 0 && this.flush === exports.Z_FINISH) {
                this._error("unexpected end of file");
                return false;
            }
            break;
        case exports.Z_STREAM_END:
            break;
        case exports.Z_NEED_DICT:
            if (this.dictionary == null) this._error("Missing dictionary");
            else this._error("Bad dictionary");
            return false;
        default:
            // something else.
            this._error("Zlib error");
            return false;
    }
    return true;
};
Zlib.prototype._after = function() {
    if (!this._checkError()) return;
    var avail_out = this.strm.avail_out;
    var avail_in = this.strm.avail_in;
    this.write_in_progress = false;
    // call the write() cb
    this.callback(avail_in, avail_out);
    if (this.pending_close) this.close();
};
Zlib.prototype._error = function(message) {
    if (this.strm.msg) message = this.strm.msg;
    this.onerror(message, this.err);
    this.write_in_progress = false;
    if (this.pending_close) this.close();
};
Zlib.prototype.init = function(windowBits, level, memLevel, strategy, dictionary) {
    assert(arguments.length === 4 || arguments.length === 5, "init(windowBits, level, memLevel, strategy, [dictionary])");
    assert(windowBits >= 8 && windowBits <= 15, "invalid windowBits");
    assert(level >= -1 && level <= 9, "invalid compression level");
    assert(memLevel >= 1 && memLevel <= 9, "invalid memlevel");
    assert(strategy === exports.Z_FILTERED || strategy === exports.Z_HUFFMAN_ONLY || strategy === exports.Z_RLE || strategy === exports.Z_FIXED || strategy === exports.Z_DEFAULT_STRATEGY, "invalid strategy");
    this._init(level, windowBits, memLevel, strategy, dictionary);
    this._setDictionary();
};
Zlib.prototype.params = function() {
    throw new Error("deflateParams Not supported");
};
Zlib.prototype.reset = function() {
    this._reset();
    this._setDictionary();
};
Zlib.prototype._init = function(level, windowBits, memLevel, strategy, dictionary) {
    this.level = level;
    this.windowBits = windowBits;
    this.memLevel = memLevel;
    this.strategy = strategy;
    this.flush = exports.Z_NO_FLUSH;
    this.err = exports.Z_OK;
    if (this.mode === exports.GZIP || this.mode === exports.GUNZIP) this.windowBits += 16;
    if (this.mode === exports.UNZIP) this.windowBits += 32;
    if (this.mode === exports.DEFLATERAW || this.mode === exports.INFLATERAW) this.windowBits = -1 * this.windowBits;
    this.strm = new Zstream();
    switch(this.mode){
        case exports.DEFLATE:
        case exports.GZIP:
        case exports.DEFLATERAW:
            this.err = zlib_deflate.deflateInit2(this.strm, this.level, exports.Z_DEFLATED, this.windowBits, this.memLevel, this.strategy);
            break;
        case exports.INFLATE:
        case exports.GUNZIP:
        case exports.INFLATERAW:
        case exports.UNZIP:
            this.err = zlib_inflate.inflateInit2(this.strm, this.windowBits);
            break;
        default:
            throw new Error("Unknown mode " + this.mode);
    }
    if (this.err !== exports.Z_OK) this._error("Init error");
    this.dictionary = dictionary;
    this.write_in_progress = false;
    this.init_done = true;
};
Zlib.prototype._setDictionary = function() {
    if (this.dictionary == null) return;
    this.err = exports.Z_OK;
    switch(this.mode){
        case exports.DEFLATE:
        case exports.DEFLATERAW:
            this.err = zlib_deflate.deflateSetDictionary(this.strm, this.dictionary);
            break;
        default:
            break;
    }
    if (this.err !== exports.Z_OK) this._error("Failed to set dictionary");
};
Zlib.prototype._reset = function() {
    this.err = exports.Z_OK;
    switch(this.mode){
        case exports.DEFLATE:
        case exports.DEFLATERAW:
        case exports.GZIP:
            this.err = zlib_deflate.deflateReset(this.strm);
            break;
        case exports.INFLATE:
        case exports.INFLATERAW:
        case exports.GUNZIP:
            this.err = zlib_inflate.inflateReset(this.strm);
            break;
        default:
            break;
    }
    if (this.err !== exports.Z_OK) this._error("Failed to reset stream");
};
exports.Zlib = Zlib;

},{"c0875ec23d3f711b":"l5Twm","275b523c6d34b701":"5QIF0","77b161f030b665c6":"jRkR3","fd1f09d11ac7dfac":"f9npt","df246bd555afd20e":"3t1Bq","38e8b32c21318329":"5iIel","5b80d7a6197bcc1e":"3iJxm"}],"jRkR3":[function(require,module,exports) {
// Currently in sync with Node.js lib/assert.js
// https://github.com/nodejs/node/commit/2a51ae424a513ec9a6aa3466baa0cc1d55dd4f3b
// Originally from narwhal.js (http://narwhaljs.org)
// Copyright (c) 2009 Thomas Robinson <280north.com>
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the 'Software'), to
// deal in the Software without restriction, including without limitation the
// rights to use, copy, modify, merge, publish, distribute, sublicense, and/or
// sell copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED 'AS IS', WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN
// ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION
// WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
var process = require("17530e9a8e9dd8de");
"use strict";
function _typeof(o) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, _typeof(o);
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function _toPropertyKey(arg) {
    var key = _toPrimitive(arg, "string");
    return _typeof(key) === "symbol" ? key : String(key);
}
function _toPrimitive(input, hint) {
    if (_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
var _require = require("67930e3bebc18ea9"), _require$codes = _require.codes, ERR_AMBIGUOUS_ARGUMENT = _require$codes.ERR_AMBIGUOUS_ARGUMENT, ERR_INVALID_ARG_TYPE = _require$codes.ERR_INVALID_ARG_TYPE, ERR_INVALID_ARG_VALUE = _require$codes.ERR_INVALID_ARG_VALUE, ERR_INVALID_RETURN_VALUE = _require$codes.ERR_INVALID_RETURN_VALUE, ERR_MISSING_ARGS = _require$codes.ERR_MISSING_ARGS;
var AssertionError = require("11bdd262fb706a54");
var _require2 = require("d61a3396666721b6"), inspect = _require2.inspect;
var _require$types = require("d61a3396666721b6").types, isPromise = _require$types.isPromise, isRegExp = _require$types.isRegExp;
var objectAssign = require("fe81af847d362e93")();
var objectIs = require("4ad4507c8e372c71")();
var RegExpPrototypeTest = require("11f208d8f2e10b17")("RegExp.prototype.test");
var errorCache = new Map();
var isDeepEqual;
var isDeepStrictEqual;
var parseExpressionAt;
var findNodeAround;
var decoder;
function lazyLoadComparison() {
    var comparison = require("131e25d2408617a4");
    isDeepEqual = comparison.isDeepEqual;
    isDeepStrictEqual = comparison.isDeepStrictEqual;
}
// Escape control characters but not \n and \t to keep the line breaks and
// indentation intact.
// eslint-disable-next-line no-control-regex
var escapeSequencesRegExp = /[\x00-\x08\x0b\x0c\x0e-\x1f]/g;
var meta = [
    "\\u0000",
    "\\u0001",
    "\\u0002",
    "\\u0003",
    "\\u0004",
    "\\u0005",
    "\\u0006",
    "\\u0007",
    "\\b",
    "",
    "",
    "\\u000b",
    "\\f",
    "",
    "\\u000e",
    "\\u000f",
    "\\u0010",
    "\\u0011",
    "\\u0012",
    "\\u0013",
    "\\u0014",
    "\\u0015",
    "\\u0016",
    "\\u0017",
    "\\u0018",
    "\\u0019",
    "\\u001a",
    "\\u001b",
    "\\u001c",
    "\\u001d",
    "\\u001e",
    "\\u001f"
];
var escapeFn = function escapeFn(str) {
    return meta[str.charCodeAt(0)];
};
var warned = false;
// The assert module provides functions that throw
// AssertionError's when particular conditions are not met. The
// assert module must conform to the following interface.
var assert = module.exports = ok;
var NO_EXCEPTION_SENTINEL = {};
// All of the following functions must throw an AssertionError
// when a corresponding condition is not met, with a message that
// may be undefined if not provided. All assertion methods provide
// both the actual and expected values to the assertion error for
// display purposes.
function innerFail(obj) {
    if (obj.message instanceof Error) throw obj.message;
    throw new AssertionError(obj);
}
function fail(actual, expected, message, operator, stackStartFn) {
    var argsLen = arguments.length;
    var internalMessage;
    if (argsLen === 0) internalMessage = "Failed";
    else if (argsLen === 1) {
        message = actual;
        actual = undefined;
    } else {
        if (warned === false) {
            warned = true;
            var warn = process.emitWarning ? process.emitWarning : console.warn.bind(console);
            warn("assert.fail() with more than one argument is deprecated. Please use assert.strictEqual() instead or only pass a message.", "DeprecationWarning", "DEP0094");
        }
        if (argsLen === 2) operator = "!=";
    }
    if (message instanceof Error) throw message;
    var errArgs = {
        actual: actual,
        expected: expected,
        operator: operator === undefined ? "fail" : operator,
        stackStartFn: stackStartFn || fail
    };
    if (message !== undefined) errArgs.message = message;
    var err = new AssertionError(errArgs);
    if (internalMessage) {
        err.message = internalMessage;
        err.generatedMessage = true;
    }
    throw err;
}
assert.fail = fail;
// The AssertionError is defined in internal/error.
assert.AssertionError = AssertionError;
function innerOk(fn, argLen, value, message) {
    if (!value) {
        var generatedMessage = false;
        if (argLen === 0) {
            generatedMessage = true;
            message = "No value argument passed to `assert.ok()`";
        } else if (message instanceof Error) throw message;
        var err = new AssertionError({
            actual: value,
            expected: true,
            message: message,
            operator: "==",
            stackStartFn: fn
        });
        err.generatedMessage = generatedMessage;
        throw err;
    }
}
// Pure assertion tests whether a value is truthy, as determined
// by !!value.
function ok() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    innerOk.apply(void 0, [
        ok,
        args.length
    ].concat(args));
}
assert.ok = ok;
// The equality assertion tests shallow, coercive equality with ==.
/* eslint-disable no-restricted-properties */ assert.equal = function equal(actual, expected, message) {
    if (arguments.length < 2) throw new ERR_MISSING_ARGS("actual", "expected");
    // eslint-disable-next-line eqeqeq
    if (actual != expected) innerFail({
        actual: actual,
        expected: expected,
        message: message,
        operator: "==",
        stackStartFn: equal
    });
};
// The non-equality assertion tests for whether two objects are not
// equal with !=.
assert.notEqual = function notEqual(actual, expected, message) {
    if (arguments.length < 2) throw new ERR_MISSING_ARGS("actual", "expected");
    // eslint-disable-next-line eqeqeq
    if (actual == expected) innerFail({
        actual: actual,
        expected: expected,
        message: message,
        operator: "!=",
        stackStartFn: notEqual
    });
};
// The equivalence assertion tests a deep equality relation.
assert.deepEqual = function deepEqual(actual, expected, message) {
    if (arguments.length < 2) throw new ERR_MISSING_ARGS("actual", "expected");
    if (isDeepEqual === undefined) lazyLoadComparison();
    if (!isDeepEqual(actual, expected)) innerFail({
        actual: actual,
        expected: expected,
        message: message,
        operator: "deepEqual",
        stackStartFn: deepEqual
    });
};
// The non-equivalence assertion tests for any deep inequality.
assert.notDeepEqual = function notDeepEqual(actual, expected, message) {
    if (arguments.length < 2) throw new ERR_MISSING_ARGS("actual", "expected");
    if (isDeepEqual === undefined) lazyLoadComparison();
    if (isDeepEqual(actual, expected)) innerFail({
        actual: actual,
        expected: expected,
        message: message,
        operator: "notDeepEqual",
        stackStartFn: notDeepEqual
    });
};
/* eslint-enable */ assert.deepStrictEqual = function deepStrictEqual(actual, expected, message) {
    if (arguments.length < 2) throw new ERR_MISSING_ARGS("actual", "expected");
    if (isDeepEqual === undefined) lazyLoadComparison();
    if (!isDeepStrictEqual(actual, expected)) innerFail({
        actual: actual,
        expected: expected,
        message: message,
        operator: "deepStrictEqual",
        stackStartFn: deepStrictEqual
    });
};
assert.notDeepStrictEqual = notDeepStrictEqual;
function notDeepStrictEqual(actual, expected, message) {
    if (arguments.length < 2) throw new ERR_MISSING_ARGS("actual", "expected");
    if (isDeepEqual === undefined) lazyLoadComparison();
    if (isDeepStrictEqual(actual, expected)) innerFail({
        actual: actual,
        expected: expected,
        message: message,
        operator: "notDeepStrictEqual",
        stackStartFn: notDeepStrictEqual
    });
}
assert.strictEqual = function strictEqual(actual, expected, message) {
    if (arguments.length < 2) throw new ERR_MISSING_ARGS("actual", "expected");
    if (!objectIs(actual, expected)) innerFail({
        actual: actual,
        expected: expected,
        message: message,
        operator: "strictEqual",
        stackStartFn: strictEqual
    });
};
assert.notStrictEqual = function notStrictEqual(actual, expected, message) {
    if (arguments.length < 2) throw new ERR_MISSING_ARGS("actual", "expected");
    if (objectIs(actual, expected)) innerFail({
        actual: actual,
        expected: expected,
        message: message,
        operator: "notStrictEqual",
        stackStartFn: notStrictEqual
    });
};
var Comparison = /*#__PURE__*/ _createClass(function Comparison(obj, keys, actual) {
    var _this = this;
    _classCallCheck(this, Comparison);
    keys.forEach(function(key) {
        if (key in obj) {
            if (actual !== undefined && typeof actual[key] === "string" && isRegExp(obj[key]) && RegExpPrototypeTest(obj[key], actual[key])) _this[key] = actual[key];
            else _this[key] = obj[key];
        }
    });
});
function compareExceptionKey(actual, expected, key, message, keys, fn) {
    if (!(key in actual) || !isDeepStrictEqual(actual[key], expected[key])) {
        if (!message) {
            // Create placeholder objects to create a nice output.
            var a = new Comparison(actual, keys);
            var b = new Comparison(expected, keys, actual);
            var err = new AssertionError({
                actual: a,
                expected: b,
                operator: "deepStrictEqual",
                stackStartFn: fn
            });
            err.actual = actual;
            err.expected = expected;
            err.operator = fn.name;
            throw err;
        }
        innerFail({
            actual: actual,
            expected: expected,
            message: message,
            operator: fn.name,
            stackStartFn: fn
        });
    }
}
function expectedException(actual, expected, msg, fn) {
    if (typeof expected !== "function") {
        if (isRegExp(expected)) return RegExpPrototypeTest(expected, actual);
        // assert.doesNotThrow does not accept objects.
        if (arguments.length === 2) throw new ERR_INVALID_ARG_TYPE("expected", [
            "Function",
            "RegExp"
        ], expected);
        // Handle primitives properly.
        if (_typeof(actual) !== "object" || actual === null) {
            var err = new AssertionError({
                actual: actual,
                expected: expected,
                message: msg,
                operator: "deepStrictEqual",
                stackStartFn: fn
            });
            err.operator = fn.name;
            throw err;
        }
        var keys = Object.keys(expected);
        // Special handle errors to make sure the name and the message are compared
        // as well.
        if (expected instanceof Error) keys.push("name", "message");
        else if (keys.length === 0) throw new ERR_INVALID_ARG_VALUE("error", expected, "may not be an empty object");
        if (isDeepEqual === undefined) lazyLoadComparison();
        keys.forEach(function(key) {
            if (typeof actual[key] === "string" && isRegExp(expected[key]) && RegExpPrototypeTest(expected[key], actual[key])) return;
            compareExceptionKey(actual, expected, key, msg, keys, fn);
        });
        return true;
    }
    // Guard instanceof against arrow functions as they don't have a prototype.
    if (expected.prototype !== undefined && actual instanceof expected) return true;
    if (Error.isPrototypeOf(expected)) return false;
    return expected.call({}, actual) === true;
}
function getActual(fn) {
    if (typeof fn !== "function") throw new ERR_INVALID_ARG_TYPE("fn", "Function", fn);
    try {
        fn();
    } catch (e) {
        return e;
    }
    return NO_EXCEPTION_SENTINEL;
}
function checkIsPromise(obj) {
    // Accept native ES6 promises and promises that are implemented in a similar
    // way. Do not accept thenables that use a function as `obj` and that have no
    // `catch` handler.
    // TODO: thenables are checked up until they have the correct methods,
    // but according to documentation, the `then` method should receive
    // the `fulfill` and `reject` arguments as well or it may be never resolved.
    return isPromise(obj) || obj !== null && _typeof(obj) === "object" && typeof obj.then === "function" && typeof obj.catch === "function";
}
function waitForActual(promiseFn) {
    return Promise.resolve().then(function() {
        var resultPromise;
        if (typeof promiseFn === "function") {
            // Return a rejected promise if `promiseFn` throws synchronously.
            resultPromise = promiseFn();
            // Fail in case no promise is returned.
            if (!checkIsPromise(resultPromise)) throw new ERR_INVALID_RETURN_VALUE("instance of Promise", "promiseFn", resultPromise);
        } else if (checkIsPromise(promiseFn)) resultPromise = promiseFn;
        else throw new ERR_INVALID_ARG_TYPE("promiseFn", [
            "Function",
            "Promise"
        ], promiseFn);
        return Promise.resolve().then(function() {
            return resultPromise;
        }).then(function() {
            return NO_EXCEPTION_SENTINEL;
        }).catch(function(e) {
            return e;
        });
    });
}
function expectsError(stackStartFn, actual, error, message) {
    if (typeof error === "string") {
        if (arguments.length === 4) throw new ERR_INVALID_ARG_TYPE("error", [
            "Object",
            "Error",
            "Function",
            "RegExp"
        ], error);
        if (_typeof(actual) === "object" && actual !== null) {
            if (actual.message === error) throw new ERR_AMBIGUOUS_ARGUMENT("error/message", 'The error message "'.concat(actual.message, '" is identical to the message.'));
        } else if (actual === error) throw new ERR_AMBIGUOUS_ARGUMENT("error/message", 'The error "'.concat(actual, '" is identical to the message.'));
        message = error;
        error = undefined;
    } else if (error != null && _typeof(error) !== "object" && typeof error !== "function") throw new ERR_INVALID_ARG_TYPE("error", [
        "Object",
        "Error",
        "Function",
        "RegExp"
    ], error);
    if (actual === NO_EXCEPTION_SENTINEL) {
        var details = "";
        if (error && error.name) details += " (".concat(error.name, ")");
        details += message ? ": ".concat(message) : ".";
        var fnType = stackStartFn.name === "rejects" ? "rejection" : "exception";
        innerFail({
            actual: undefined,
            expected: error,
            operator: stackStartFn.name,
            message: "Missing expected ".concat(fnType).concat(details),
            stackStartFn: stackStartFn
        });
    }
    if (error && !expectedException(actual, error, message, stackStartFn)) throw actual;
}
function expectsNoError(stackStartFn, actual, error, message) {
    if (actual === NO_EXCEPTION_SENTINEL) return;
    if (typeof error === "string") {
        message = error;
        error = undefined;
    }
    if (!error || expectedException(actual, error)) {
        var details = message ? ": ".concat(message) : ".";
        var fnType = stackStartFn.name === "doesNotReject" ? "rejection" : "exception";
        innerFail({
            actual: actual,
            expected: error,
            operator: stackStartFn.name,
            message: "Got unwanted ".concat(fnType).concat(details, "\n") + 'Actual message: "'.concat(actual && actual.message, '"'),
            stackStartFn: stackStartFn
        });
    }
    throw actual;
}
assert.throws = function throws(promiseFn) {
    for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
    expectsError.apply(void 0, [
        throws,
        getActual(promiseFn)
    ].concat(args));
};
assert.rejects = function rejects(promiseFn) {
    for(var _len3 = arguments.length, args = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++)args[_key3 - 1] = arguments[_key3];
    return waitForActual(promiseFn).then(function(result) {
        return expectsError.apply(void 0, [
            rejects,
            result
        ].concat(args));
    });
};
assert.doesNotThrow = function doesNotThrow(fn) {
    for(var _len4 = arguments.length, args = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++)args[_key4 - 1] = arguments[_key4];
    expectsNoError.apply(void 0, [
        doesNotThrow,
        getActual(fn)
    ].concat(args));
};
assert.doesNotReject = function doesNotReject(fn) {
    for(var _len5 = arguments.length, args = new Array(_len5 > 1 ? _len5 - 1 : 0), _key5 = 1; _key5 < _len5; _key5++)args[_key5 - 1] = arguments[_key5];
    return waitForActual(fn).then(function(result) {
        return expectsNoError.apply(void 0, [
            doesNotReject,
            result
        ].concat(args));
    });
};
assert.ifError = function ifError(err) {
    if (err !== null && err !== undefined) {
        var message = "ifError got unwanted exception: ";
        if (_typeof(err) === "object" && typeof err.message === "string") {
            if (err.message.length === 0 && err.constructor) message += err.constructor.name;
            else message += err.message;
        } else message += inspect(err);
        var newErr = new AssertionError({
            actual: err,
            expected: null,
            operator: "ifError",
            message: message,
            stackStartFn: ifError
        });
        // Make sure we actually have a stack trace!
        var origStack = err.stack;
        if (typeof origStack === "string") {
            // This will remove any duplicated frames from the error frames taken
            // from within `ifError` and add the original error frames to the newly
            // created ones.
            var tmp2 = origStack.split("\n");
            tmp2.shift();
            // Filter all frames existing in err.stack.
            var tmp1 = newErr.stack.split("\n");
            for(var i = 0; i < tmp2.length; i++){
                // Find the first occurrence of the frame.
                var pos = tmp1.indexOf(tmp2[i]);
                if (pos !== -1) {
                    // Only keep new frames.
                    tmp1 = tmp1.slice(0, pos);
                    break;
                }
            }
            newErr.stack = "".concat(tmp1.join("\n"), "\n").concat(tmp2.join("\n"));
        }
        throw newErr;
    }
};
// Currently in sync with Node.js lib/assert.js
// https://github.com/nodejs/node/commit/2a871df3dfb8ea663ef5e1f8f62701ec51384ecb
function internalMatch(string, regexp, message, fn, fnName) {
    if (!isRegExp(regexp)) throw new ERR_INVALID_ARG_TYPE("regexp", "RegExp", regexp);
    var match = fnName === "match";
    if (typeof string !== "string" || RegExpPrototypeTest(regexp, string) !== match) {
        if (message instanceof Error) throw message;
        var generatedMessage = !message;
        // 'The input was expected to not match the regular expression ' +
        message = message || (typeof string !== "string" ? 'The "string" argument must be of type string. Received type ' + "".concat(_typeof(string), " (").concat(inspect(string), ")") : (match ? "The input did not match the regular expression " : "The input was expected to not match the regular expression ") + "".concat(inspect(regexp), ". Input:\n\n").concat(inspect(string), "\n"));
        var err = new AssertionError({
            actual: string,
            expected: regexp,
            message: message,
            operator: fnName,
            stackStartFn: fn
        });
        err.generatedMessage = generatedMessage;
        throw err;
    }
}
assert.match = function match(string, regexp, message) {
    internalMatch(string, regexp, message, match, "match");
};
assert.doesNotMatch = function doesNotMatch(string, regexp, message) {
    internalMatch(string, regexp, message, doesNotMatch, "doesNotMatch");
};
// Expose a strict only variant of assert
function strict() {
    for(var _len6 = arguments.length, args = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++)args[_key6] = arguments[_key6];
    innerOk.apply(void 0, [
        strict,
        args.length
    ].concat(args));
}
assert.strict = objectAssign(strict, assert, {
    equal: assert.strictEqual,
    deepEqual: assert.deepStrictEqual,
    notEqual: assert.notStrictEqual,
    notDeepEqual: assert.notDeepStrictEqual
});
assert.strict.strict = assert.strict;

},{"17530e9a8e9dd8de":"5QIF0","67930e3bebc18ea9":"lcRXS","11bdd262fb706a54":"a6g2R","d61a3396666721b6":"jInrX","fe81af847d362e93":"7uZe2","4ad4507c8e372c71":"jCZAj","11f208d8f2e10b17":"eK6wT","131e25d2408617a4":"1aL1U"}],"lcRXS":[function(require,module,exports) {
// Currently in sync with Node.js lib/internal/errors.js
// https://github.com/nodejs/node/commit/3b044962c48fe313905877a96b5d0894a5404f6f
/* eslint node-core/documented-errors: "error" */ /* eslint node-core/alphabetize-errors: "error" */ /* eslint node-core/prefer-util-format-errors: "error" */ "use strict";
// The whole point behind this internal module is to allow Node.js to no
// longer be forced to treat every error message change as a semver-major
// change. The NodeError classes here all expose a `code` property whose
// value statically and permanently identifies the error. While the error
// message may change, the code should not.
function _typeof(o) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, _typeof(o);
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function _toPropertyKey(arg) {
    var key = _toPrimitive(arg, "string");
    return _typeof(key) === "symbol" ? key : String(key);
}
function _toPrimitive(input, hint) {
    if (_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return _possibleConstructorReturn(this, result);
    };
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return _assertThisInitialized(self);
}
function _assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
var codes = {};
// Lazy loaded
var assert;
var util;
function createErrorType(code, message, Base) {
    if (!Base) Base = Error;
    function getMessage(arg1, arg2, arg3) {
        if (typeof message === "string") return message;
        else return message(arg1, arg2, arg3);
    }
    var NodeError = /*#__PURE__*/ function(_Base) {
        _inherits(NodeError, _Base);
        var _super = _createSuper(NodeError);
        function NodeError(arg1, arg2, arg3) {
            var _this;
            _classCallCheck(this, NodeError);
            _this = _super.call(this, getMessage(arg1, arg2, arg3));
            _this.code = code;
            return _this;
        }
        return _createClass(NodeError);
    }(Base);
    codes[code] = NodeError;
}
// https://github.com/nodejs/node/blob/v10.8.0/lib/internal/errors.js
function oneOf(expected, thing) {
    if (Array.isArray(expected)) {
        var len = expected.length;
        expected = expected.map(function(i) {
            return String(i);
        });
        if (len > 2) return "one of ".concat(thing, " ").concat(expected.slice(0, len - 1).join(", "), ", or ") + expected[len - 1];
        else if (len === 2) return "one of ".concat(thing, " ").concat(expected[0], " or ").concat(expected[1]);
        else return "of ".concat(thing, " ").concat(expected[0]);
    } else return "of ".concat(thing, " ").concat(String(expected));
}
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/startsWith
function startsWith(str, search, pos) {
    return str.substr(!pos || pos < 0 ? 0 : +pos, search.length) === search;
}
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/endsWith
function endsWith(str, search, this_len) {
    if (this_len === undefined || this_len > str.length) this_len = str.length;
    return str.substring(this_len - search.length, this_len) === search;
}
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/includes
function includes(str, search, start) {
    if (typeof start !== "number") start = 0;
    if (start + search.length > str.length) return false;
    else return str.indexOf(search, start) !== -1;
}
createErrorType("ERR_AMBIGUOUS_ARGUMENT", 'The "%s" argument is ambiguous. %s', TypeError);
createErrorType("ERR_INVALID_ARG_TYPE", function(name, expected, actual) {
    if (assert === undefined) assert = require("f73a3052b95b9ed");
    assert(typeof name === "string", "'name' must be a string");
    // determiner: 'must be' or 'must not be'
    var determiner;
    if (typeof expected === "string" && startsWith(expected, "not ")) {
        determiner = "must not be";
        expected = expected.replace(/^not /, "");
    } else determiner = "must be";
    var msg;
    if (endsWith(name, " argument")) // For cases like 'first argument'
    msg = "The ".concat(name, " ").concat(determiner, " ").concat(oneOf(expected, "type"));
    else {
        var type = includes(name, ".") ? "property" : "argument";
        msg = 'The "'.concat(name, '" ').concat(type, " ").concat(determiner, " ").concat(oneOf(expected, "type"));
    }
    // TODO(BridgeAR): Improve the output by showing `null` and similar.
    msg += ". Received type ".concat(_typeof(actual));
    return msg;
}, TypeError);
createErrorType("ERR_INVALID_ARG_VALUE", function(name, value) {
    var reason = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "is invalid";
    if (util === undefined) util = require("1fd472100fa8826f");
    var inspected = util.inspect(value);
    if (inspected.length > 128) inspected = "".concat(inspected.slice(0, 128), "...");
    return "The argument '".concat(name, "' ").concat(reason, ". Received ").concat(inspected);
}, TypeError, RangeError);
createErrorType("ERR_INVALID_RETURN_VALUE", function(input, name, value) {
    var type;
    if (value && value.constructor && value.constructor.name) type = "instance of ".concat(value.constructor.name);
    else type = "type ".concat(_typeof(value));
    return "Expected ".concat(input, ' to be returned from the "').concat(name, '"') + " function but got ".concat(type, ".");
}, TypeError);
createErrorType("ERR_MISSING_ARGS", function() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    if (assert === undefined) assert = require("f73a3052b95b9ed");
    assert(args.length > 0, "At least one arg needs to be specified");
    var msg = "The ";
    var len = args.length;
    args = args.map(function(a) {
        return '"'.concat(a, '"');
    });
    switch(len){
        case 1:
            msg += "".concat(args[0], " argument");
            break;
        case 2:
            msg += "".concat(args[0], " and ").concat(args[1], " arguments");
            break;
        default:
            msg += args.slice(0, len - 1).join(", ");
            msg += ", and ".concat(args[len - 1], " arguments");
            break;
    }
    return "".concat(msg, " must be specified");
}, TypeError);
module.exports.codes = codes;

},{"f73a3052b95b9ed":"jRkR3","1fd472100fa8826f":"jInrX"}],"jInrX":[function(require,module,exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
var process = require("bc23a3ea4a141c0b");
var getOwnPropertyDescriptors = Object.getOwnPropertyDescriptors || function getOwnPropertyDescriptors(obj) {
    var keys = Object.keys(obj);
    var descriptors = {};
    for(var i = 0; i < keys.length; i++)descriptors[keys[i]] = Object.getOwnPropertyDescriptor(obj, keys[i]);
    return descriptors;
};
var formatRegExp = /%[sdj%]/g;
exports.format = function(f) {
    if (!isString(f)) {
        var objects = [];
        for(var i = 0; i < arguments.length; i++)objects.push(inspect(arguments[i]));
        return objects.join(" ");
    }
    var i = 1;
    var args = arguments;
    var len = args.length;
    var str = String(f).replace(formatRegExp, function(x) {
        if (x === "%%") return "%";
        if (i >= len) return x;
        switch(x){
            case "%s":
                return String(args[i++]);
            case "%d":
                return Number(args[i++]);
            case "%j":
                try {
                    return JSON.stringify(args[i++]);
                } catch (_) {
                    return "[Circular]";
                }
            default:
                return x;
        }
    });
    for(var x = args[i]; i < len; x = args[++i])if (isNull(x) || !isObject(x)) str += " " + x;
    else str += " " + inspect(x);
    return str;
};
// Mark that a method should not be used.
// Returns a modified function which warns once by default.
// If --no-deprecation is set, then it is a no-op.
exports.deprecate = function(fn, msg) {
    if (typeof process !== "undefined" && process.noDeprecation === true) return fn;
    // Allow for deprecating things in the process of starting up.
    if (typeof process === "undefined") return function() {
        return exports.deprecate(fn, msg).apply(this, arguments);
    };
    var warned = false;
    function deprecated() {
        if (!warned) {
            if (process.throwDeprecation) throw new Error(msg);
            else if (process.traceDeprecation) console.trace(msg);
            else console.error(msg);
            warned = true;
        }
        return fn.apply(this, arguments);
    }
    return deprecated;
};
var debugs = {};
var debugEnvRegex = /^$/;
var debugEnv;
exports.debuglog = function(set) {
    set = set.toUpperCase();
    if (!debugs[set]) {
        if (debugEnvRegex.test(set)) {
            var pid = process.pid;
            debugs[set] = function() {
                var msg = exports.format.apply(exports, arguments);
                console.error("%s %d: %s", set, pid, msg);
            };
        } else debugs[set] = function() {};
    }
    return debugs[set];
};
/**
 * Echos the value of a value. Trys to print the value out
 * in the best way possible given the different types.
 *
 * @param {Object} obj The object to print out.
 * @param {Object} opts Optional options object that alters the output.
 */ /* legacy: obj, showHidden, depth, colors*/ function inspect(obj, opts) {
    // default options
    var ctx = {
        seen: [],
        stylize: stylizeNoColor
    };
    // legacy...
    if (arguments.length >= 3) ctx.depth = arguments[2];
    if (arguments.length >= 4) ctx.colors = arguments[3];
    if (isBoolean(opts)) // legacy...
    ctx.showHidden = opts;
    else if (opts) // got an "options" object
    exports._extend(ctx, opts);
    // set default options
    if (isUndefined(ctx.showHidden)) ctx.showHidden = false;
    if (isUndefined(ctx.depth)) ctx.depth = 2;
    if (isUndefined(ctx.colors)) ctx.colors = false;
    if (isUndefined(ctx.customInspect)) ctx.customInspect = true;
    if (ctx.colors) ctx.stylize = stylizeWithColor;
    return formatValue(ctx, obj, ctx.depth);
}
exports.inspect = inspect;
// http://en.wikipedia.org/wiki/ANSI_escape_code#graphics
inspect.colors = {
    "bold": [
        1,
        22
    ],
    "italic": [
        3,
        23
    ],
    "underline": [
        4,
        24
    ],
    "inverse": [
        7,
        27
    ],
    "white": [
        37,
        39
    ],
    "grey": [
        90,
        39
    ],
    "black": [
        30,
        39
    ],
    "blue": [
        34,
        39
    ],
    "cyan": [
        36,
        39
    ],
    "green": [
        32,
        39
    ],
    "magenta": [
        35,
        39
    ],
    "red": [
        31,
        39
    ],
    "yellow": [
        33,
        39
    ]
};
// Don't use 'blue' not visible on cmd.exe
inspect.styles = {
    "special": "cyan",
    "number": "yellow",
    "boolean": "yellow",
    "undefined": "grey",
    "null": "bold",
    "string": "green",
    "date": "magenta",
    // "name": intentionally not styling
    "regexp": "red"
};
function stylizeWithColor(str, styleType) {
    var style = inspect.styles[styleType];
    if (style) return "\x1b[" + inspect.colors[style][0] + "m" + str + "\x1b[" + inspect.colors[style][1] + "m";
    else return str;
}
function stylizeNoColor(str, styleType) {
    return str;
}
function arrayToHash(array) {
    var hash = {};
    array.forEach(function(val, idx) {
        hash[val] = true;
    });
    return hash;
}
function formatValue(ctx, value, recurseTimes) {
    // Provide a hook for user-specified inspect functions.
    // Check that value is an object with an inspect function on it
    if (ctx.customInspect && value && isFunction(value.inspect) && // Filter out the util module, it's inspect function is special
    value.inspect !== exports.inspect && // Also filter out any prototype objects using the circular check.
    !(value.constructor && value.constructor.prototype === value)) {
        var ret = value.inspect(recurseTimes, ctx);
        if (!isString(ret)) ret = formatValue(ctx, ret, recurseTimes);
        return ret;
    }
    // Primitive types cannot have properties
    var primitive = formatPrimitive(ctx, value);
    if (primitive) return primitive;
    // Look up the keys of the object.
    var keys = Object.keys(value);
    var visibleKeys = arrayToHash(keys);
    if (ctx.showHidden) keys = Object.getOwnPropertyNames(value);
    // IE doesn't make error fields non-enumerable
    // http://msdn.microsoft.com/en-us/library/ie/dww52sbt(v=vs.94).aspx
    if (isError(value) && (keys.indexOf("message") >= 0 || keys.indexOf("description") >= 0)) return formatError(value);
    // Some type of object without properties can be shortcutted.
    if (keys.length === 0) {
        if (isFunction(value)) {
            var name = value.name ? ": " + value.name : "";
            return ctx.stylize("[Function" + name + "]", "special");
        }
        if (isRegExp(value)) return ctx.stylize(RegExp.prototype.toString.call(value), "regexp");
        if (isDate(value)) return ctx.stylize(Date.prototype.toString.call(value), "date");
        if (isError(value)) return formatError(value);
    }
    var base = "", array = false, braces = [
        "{",
        "}"
    ];
    // Make Array say that they are Array
    if (isArray(value)) {
        array = true;
        braces = [
            "[",
            "]"
        ];
    }
    // Make functions say that they are functions
    if (isFunction(value)) {
        var n = value.name ? ": " + value.name : "";
        base = " [Function" + n + "]";
    }
    // Make RegExps say that they are RegExps
    if (isRegExp(value)) base = " " + RegExp.prototype.toString.call(value);
    // Make dates with properties first say the date
    if (isDate(value)) base = " " + Date.prototype.toUTCString.call(value);
    // Make error with message first say the error
    if (isError(value)) base = " " + formatError(value);
    if (keys.length === 0 && (!array || value.length == 0)) return braces[0] + base + braces[1];
    if (recurseTimes < 0) {
        if (isRegExp(value)) return ctx.stylize(RegExp.prototype.toString.call(value), "regexp");
        else return ctx.stylize("[Object]", "special");
    }
    ctx.seen.push(value);
    var output;
    if (array) output = formatArray(ctx, value, recurseTimes, visibleKeys, keys);
    else output = keys.map(function(key) {
        return formatProperty(ctx, value, recurseTimes, visibleKeys, key, array);
    });
    ctx.seen.pop();
    return reduceToSingleString(output, base, braces);
}
function formatPrimitive(ctx, value) {
    if (isUndefined(value)) return ctx.stylize("undefined", "undefined");
    if (isString(value)) {
        var simple = "'" + JSON.stringify(value).replace(/^"|"$/g, "").replace(/'/g, "\\'").replace(/\\"/g, '"') + "'";
        return ctx.stylize(simple, "string");
    }
    if (isNumber(value)) return ctx.stylize("" + value, "number");
    if (isBoolean(value)) return ctx.stylize("" + value, "boolean");
    // For some reason typeof null is "object", so special case here.
    if (isNull(value)) return ctx.stylize("null", "null");
}
function formatError(value) {
    return "[" + Error.prototype.toString.call(value) + "]";
}
function formatArray(ctx, value, recurseTimes, visibleKeys, keys) {
    var output = [];
    for(var i = 0, l = value.length; i < l; ++i)if (hasOwnProperty(value, String(i))) output.push(formatProperty(ctx, value, recurseTimes, visibleKeys, String(i), true));
    else output.push("");
    keys.forEach(function(key) {
        if (!key.match(/^\d+$/)) output.push(formatProperty(ctx, value, recurseTimes, visibleKeys, key, true));
    });
    return output;
}
function formatProperty(ctx, value, recurseTimes, visibleKeys, key, array) {
    var name, str, desc;
    desc = Object.getOwnPropertyDescriptor(value, key) || {
        value: value[key]
    };
    if (desc.get) {
        if (desc.set) str = ctx.stylize("[Getter/Setter]", "special");
        else str = ctx.stylize("[Getter]", "special");
    } else if (desc.set) str = ctx.stylize("[Setter]", "special");
    if (!hasOwnProperty(visibleKeys, key)) name = "[" + key + "]";
    if (!str) {
        if (ctx.seen.indexOf(desc.value) < 0) {
            if (isNull(recurseTimes)) str = formatValue(ctx, desc.value, null);
            else str = formatValue(ctx, desc.value, recurseTimes - 1);
            if (str.indexOf("\n") > -1) {
                if (array) str = str.split("\n").map(function(line) {
                    return "  " + line;
                }).join("\n").slice(2);
                else str = "\n" + str.split("\n").map(function(line) {
                    return "   " + line;
                }).join("\n");
            }
        } else str = ctx.stylize("[Circular]", "special");
    }
    if (isUndefined(name)) {
        if (array && key.match(/^\d+$/)) return str;
        name = JSON.stringify("" + key);
        if (name.match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/)) {
            name = name.slice(1, -1);
            name = ctx.stylize(name, "name");
        } else {
            name = name.replace(/'/g, "\\'").replace(/\\"/g, '"').replace(/(^"|"$)/g, "'");
            name = ctx.stylize(name, "string");
        }
    }
    return name + ": " + str;
}
function reduceToSingleString(output, base, braces) {
    var numLinesEst = 0;
    var length = output.reduce(function(prev, cur) {
        numLinesEst++;
        if (cur.indexOf("\n") >= 0) numLinesEst++;
        return prev + cur.replace(/\u001b\[\d\d?m/g, "").length + 1;
    }, 0);
    if (length > 60) return braces[0] + (base === "" ? "" : base + "\n ") + " " + output.join(",\n  ") + " " + braces[1];
    return braces[0] + base + " " + output.join(", ") + " " + braces[1];
}
// NOTE: These type checking functions intentionally don't use `instanceof`
// because it is fragile and can be easily faked with `Object.create()`.
exports.types = require("6a1c15bae847a134");
function isArray(ar) {
    return Array.isArray(ar);
}
exports.isArray = isArray;
function isBoolean(arg) {
    return typeof arg === "boolean";
}
exports.isBoolean = isBoolean;
function isNull(arg) {
    return arg === null;
}
exports.isNull = isNull;
function isNullOrUndefined(arg) {
    return arg == null;
}
exports.isNullOrUndefined = isNullOrUndefined;
function isNumber(arg) {
    return typeof arg === "number";
}
exports.isNumber = isNumber;
function isString(arg) {
    return typeof arg === "string";
}
exports.isString = isString;
function isSymbol(arg) {
    return typeof arg === "symbol";
}
exports.isSymbol = isSymbol;
function isUndefined(arg) {
    return arg === void 0;
}
exports.isUndefined = isUndefined;
function isRegExp(re) {
    return isObject(re) && objectToString(re) === "[object RegExp]";
}
exports.isRegExp = isRegExp;
exports.types.isRegExp = isRegExp;
function isObject(arg) {
    return typeof arg === "object" && arg !== null;
}
exports.isObject = isObject;
function isDate(d) {
    return isObject(d) && objectToString(d) === "[object Date]";
}
exports.isDate = isDate;
exports.types.isDate = isDate;
function isError(e) {
    return isObject(e) && (objectToString(e) === "[object Error]" || e instanceof Error);
}
exports.isError = isError;
exports.types.isNativeError = isError;
function isFunction(arg) {
    return typeof arg === "function";
}
exports.isFunction = isFunction;
function isPrimitive(arg) {
    return arg === null || typeof arg === "boolean" || typeof arg === "number" || typeof arg === "string" || typeof arg === "symbol" || // ES6 symbol
    typeof arg === "undefined";
}
exports.isPrimitive = isPrimitive;
exports.isBuffer = require("a42137cd7fc8700d");
function objectToString(o) {
    return Object.prototype.toString.call(o);
}
function pad(n) {
    return n < 10 ? "0" + n.toString(10) : n.toString(10);
}
var months = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
];
// 26 Feb 16:19:34
function timestamp() {
    var d = new Date();
    var time = [
        pad(d.getHours()),
        pad(d.getMinutes()),
        pad(d.getSeconds())
    ].join(":");
    return [
        d.getDate(),
        months[d.getMonth()],
        time
    ].join(" ");
}
// log is just a thin wrapper to console.log that prepends a timestamp
exports.log = function() {
    console.log("%s - %s", timestamp(), exports.format.apply(exports, arguments));
};
/**
 * Inherit the prototype methods from one constructor into another.
 *
 * The Function.prototype.inherits from lang.js rewritten as a standalone
 * function (not on Function.prototype). NOTE: If this file is to be loaded
 * during bootstrapping this function needs to be rewritten using some native
 * functions as prototype setup using normal JavaScript does not work as
 * expected during bootstrapping (see mirror.js in r114903).
 *
 * @param {function} ctor Constructor function which needs to inherit the
 *     prototype.
 * @param {function} superCtor Constructor function to inherit prototype from.
 */ exports.inherits = require("a792e8e3e2aa1973");
exports._extend = function(origin, add) {
    // Don't do anything if add isn't an object
    if (!add || !isObject(add)) return origin;
    var keys = Object.keys(add);
    var i = keys.length;
    while(i--)origin[keys[i]] = add[keys[i]];
    return origin;
};
function hasOwnProperty(obj, prop) {
    return Object.prototype.hasOwnProperty.call(obj, prop);
}
var kCustomPromisifiedSymbol = typeof Symbol !== "undefined" ? Symbol("util.promisify.custom") : undefined;
exports.promisify = function promisify(original) {
    if (typeof original !== "function") throw new TypeError('The "original" argument must be of type Function');
    if (kCustomPromisifiedSymbol && original[kCustomPromisifiedSymbol]) {
        var fn = original[kCustomPromisifiedSymbol];
        if (typeof fn !== "function") throw new TypeError('The "util.promisify.custom" argument must be of type Function');
        Object.defineProperty(fn, kCustomPromisifiedSymbol, {
            value: fn,
            enumerable: false,
            writable: false,
            configurable: true
        });
        return fn;
    }
    function fn() {
        var promiseResolve, promiseReject;
        var promise = new Promise(function(resolve, reject) {
            promiseResolve = resolve;
            promiseReject = reject;
        });
        var args = [];
        for(var i = 0; i < arguments.length; i++)args.push(arguments[i]);
        args.push(function(err, value) {
            if (err) promiseReject(err);
            else promiseResolve(value);
        });
        try {
            original.apply(this, args);
        } catch (err) {
            promiseReject(err);
        }
        return promise;
    }
    Object.setPrototypeOf(fn, Object.getPrototypeOf(original));
    if (kCustomPromisifiedSymbol) Object.defineProperty(fn, kCustomPromisifiedSymbol, {
        value: fn,
        enumerable: false,
        writable: false,
        configurable: true
    });
    return Object.defineProperties(fn, getOwnPropertyDescriptors(original));
};
exports.promisify.custom = kCustomPromisifiedSymbol;
function callbackifyOnRejected(reason, cb) {
    // `!reason` guard inspired by bluebird (Ref: https://goo.gl/t5IS6M).
    // Because `null` is a special error value in callbacks which means "no error
    // occurred", we error-wrap so the callback consumer can distinguish between
    // "the promise rejected with null" or "the promise fulfilled with undefined".
    if (!reason) {
        var newReason = new Error("Promise was rejected with a falsy value");
        newReason.reason = reason;
        reason = newReason;
    }
    return cb(reason);
}
function callbackify(original) {
    if (typeof original !== "function") throw new TypeError('The "original" argument must be of type Function');
    // We DO NOT return the promise as it gives the user a false sense that
    // the promise is actually somehow related to the callback's execution
    // and that the callback throwing will reject the promise.
    function callbackified() {
        var args = [];
        for(var i = 0; i < arguments.length; i++)args.push(arguments[i]);
        var maybeCb = args.pop();
        if (typeof maybeCb !== "function") throw new TypeError("The last argument must be of type Function");
        var self = this;
        var cb = function() {
            return maybeCb.apply(self, arguments);
        };
        // In true node style we process the callback on `nextTick` with all the
        // implications (stack, `uncaughtException`, `async_hooks`)
        original.apply(this, args).then(function(ret) {
            process.nextTick(cb.bind(null, null, ret));
        }, function(rej) {
            process.nextTick(callbackifyOnRejected.bind(null, rej, cb));
        });
    }
    Object.setPrototypeOf(callbackified, Object.getPrototypeOf(original));
    Object.defineProperties(callbackified, getOwnPropertyDescriptors(original));
    return callbackified;
}
exports.callbackify = callbackify;

},{"bc23a3ea4a141c0b":"5QIF0","6a1c15bae847a134":"17BWb","a42137cd7fc8700d":"1xkSL","a792e8e3e2aa1973":"8LxVj"}],"17BWb":[function(require,module,exports) {
// Currently in sync with Node.js lib/internal/util/types.js
// https://github.com/nodejs/node/commit/112cc7c27551254aa2b17098fb774867f05ed0d9
"use strict";
var isArgumentsObject = require("6b5f9ae3e436d527");
var isGeneratorFunction = require("285c2b8081bf4b68");
var whichTypedArray = require("e95b88ccd80e1671");
var isTypedArray = require("7db151546a22c2a8");
function uncurryThis(f) {
    return f.call.bind(f);
}
var BigIntSupported = typeof BigInt !== "undefined";
var SymbolSupported = typeof Symbol !== "undefined";
var ObjectToString = uncurryThis(Object.prototype.toString);
var numberValue = uncurryThis(Number.prototype.valueOf);
var stringValue = uncurryThis(String.prototype.valueOf);
var booleanValue = uncurryThis(Boolean.prototype.valueOf);
if (BigIntSupported) var bigIntValue = uncurryThis(BigInt.prototype.valueOf);
if (SymbolSupported) var symbolValue = uncurryThis(Symbol.prototype.valueOf);
function checkBoxedPrimitive(value, prototypeValueOf) {
    if (typeof value !== "object") return false;
    try {
        prototypeValueOf(value);
        return true;
    } catch (e) {
        return false;
    }
}
exports.isArgumentsObject = isArgumentsObject;
exports.isGeneratorFunction = isGeneratorFunction;
exports.isTypedArray = isTypedArray;
// Taken from here and modified for better browser support
// https://github.com/sindresorhus/p-is-promise/blob/cda35a513bda03f977ad5cde3a079d237e82d7ef/index.js
function isPromise(input) {
    return typeof Promise !== "undefined" && input instanceof Promise || input !== null && typeof input === "object" && typeof input.then === "function" && typeof input.catch === "function";
}
exports.isPromise = isPromise;
function isArrayBufferView(value) {
    if (typeof ArrayBuffer !== "undefined" && ArrayBuffer.isView) return ArrayBuffer.isView(value);
    return isTypedArray(value) || isDataView(value);
}
exports.isArrayBufferView = isArrayBufferView;
function isUint8Array(value) {
    return whichTypedArray(value) === "Uint8Array";
}
exports.isUint8Array = isUint8Array;
function isUint8ClampedArray(value) {
    return whichTypedArray(value) === "Uint8ClampedArray";
}
exports.isUint8ClampedArray = isUint8ClampedArray;
function isUint16Array(value) {
    return whichTypedArray(value) === "Uint16Array";
}
exports.isUint16Array = isUint16Array;
function isUint32Array(value) {
    return whichTypedArray(value) === "Uint32Array";
}
exports.isUint32Array = isUint32Array;
function isInt8Array(value) {
    return whichTypedArray(value) === "Int8Array";
}
exports.isInt8Array = isInt8Array;
function isInt16Array(value) {
    return whichTypedArray(value) === "Int16Array";
}
exports.isInt16Array = isInt16Array;
function isInt32Array(value) {
    return whichTypedArray(value) === "Int32Array";
}
exports.isInt32Array = isInt32Array;
function isFloat32Array(value) {
    return whichTypedArray(value) === "Float32Array";
}
exports.isFloat32Array = isFloat32Array;
function isFloat64Array(value) {
    return whichTypedArray(value) === "Float64Array";
}
exports.isFloat64Array = isFloat64Array;
function isBigInt64Array(value) {
    return whichTypedArray(value) === "BigInt64Array";
}
exports.isBigInt64Array = isBigInt64Array;
function isBigUint64Array(value) {
    return whichTypedArray(value) === "BigUint64Array";
}
exports.isBigUint64Array = isBigUint64Array;
function isMapToString(value) {
    return ObjectToString(value) === "[object Map]";
}
isMapToString.working = typeof Map !== "undefined" && isMapToString(new Map());
function isMap(value) {
    if (typeof Map === "undefined") return false;
    return isMapToString.working ? isMapToString(value) : value instanceof Map;
}
exports.isMap = isMap;
function isSetToString(value) {
    return ObjectToString(value) === "[object Set]";
}
isSetToString.working = typeof Set !== "undefined" && isSetToString(new Set());
function isSet(value) {
    if (typeof Set === "undefined") return false;
    return isSetToString.working ? isSetToString(value) : value instanceof Set;
}
exports.isSet = isSet;
function isWeakMapToString(value) {
    return ObjectToString(value) === "[object WeakMap]";
}
isWeakMapToString.working = typeof WeakMap !== "undefined" && isWeakMapToString(new WeakMap());
function isWeakMap(value) {
    if (typeof WeakMap === "undefined") return false;
    return isWeakMapToString.working ? isWeakMapToString(value) : value instanceof WeakMap;
}
exports.isWeakMap = isWeakMap;
function isWeakSetToString(value) {
    return ObjectToString(value) === "[object WeakSet]";
}
isWeakSetToString.working = typeof WeakSet !== "undefined" && isWeakSetToString(new WeakSet());
function isWeakSet(value) {
    return isWeakSetToString(value);
}
exports.isWeakSet = isWeakSet;
function isArrayBufferToString(value) {
    return ObjectToString(value) === "[object ArrayBuffer]";
}
isArrayBufferToString.working = typeof ArrayBuffer !== "undefined" && isArrayBufferToString(new ArrayBuffer());
function isArrayBuffer(value) {
    if (typeof ArrayBuffer === "undefined") return false;
    return isArrayBufferToString.working ? isArrayBufferToString(value) : value instanceof ArrayBuffer;
}
exports.isArrayBuffer = isArrayBuffer;
function isDataViewToString(value) {
    return ObjectToString(value) === "[object DataView]";
}
isDataViewToString.working = typeof ArrayBuffer !== "undefined" && typeof DataView !== "undefined" && isDataViewToString(new DataView(new ArrayBuffer(1), 0, 1));
function isDataView(value) {
    if (typeof DataView === "undefined") return false;
    return isDataViewToString.working ? isDataViewToString(value) : value instanceof DataView;
}
exports.isDataView = isDataView;
// Store a copy of SharedArrayBuffer in case it's deleted elsewhere
var SharedArrayBufferCopy = typeof SharedArrayBuffer !== "undefined" ? SharedArrayBuffer : undefined;
function isSharedArrayBufferToString(value) {
    return ObjectToString(value) === "[object SharedArrayBuffer]";
}
function isSharedArrayBuffer(value) {
    if (typeof SharedArrayBufferCopy === "undefined") return false;
    if (typeof isSharedArrayBufferToString.working === "undefined") isSharedArrayBufferToString.working = isSharedArrayBufferToString(new SharedArrayBufferCopy());
    return isSharedArrayBufferToString.working ? isSharedArrayBufferToString(value) : value instanceof SharedArrayBufferCopy;
}
exports.isSharedArrayBuffer = isSharedArrayBuffer;
function isAsyncFunction(value) {
    return ObjectToString(value) === "[object AsyncFunction]";
}
exports.isAsyncFunction = isAsyncFunction;
function isMapIterator(value) {
    return ObjectToString(value) === "[object Map Iterator]";
}
exports.isMapIterator = isMapIterator;
function isSetIterator(value) {
    return ObjectToString(value) === "[object Set Iterator]";
}
exports.isSetIterator = isSetIterator;
function isGeneratorObject(value) {
    return ObjectToString(value) === "[object Generator]";
}
exports.isGeneratorObject = isGeneratorObject;
function isWebAssemblyCompiledModule(value) {
    return ObjectToString(value) === "[object WebAssembly.Module]";
}
exports.isWebAssemblyCompiledModule = isWebAssemblyCompiledModule;
function isNumberObject(value) {
    return checkBoxedPrimitive(value, numberValue);
}
exports.isNumberObject = isNumberObject;
function isStringObject(value) {
    return checkBoxedPrimitive(value, stringValue);
}
exports.isStringObject = isStringObject;
function isBooleanObject(value) {
    return checkBoxedPrimitive(value, booleanValue);
}
exports.isBooleanObject = isBooleanObject;
function isBigIntObject(value) {
    return BigIntSupported && checkBoxedPrimitive(value, bigIntValue);
}
exports.isBigIntObject = isBigIntObject;
function isSymbolObject(value) {
    return SymbolSupported && checkBoxedPrimitive(value, symbolValue);
}
exports.isSymbolObject = isSymbolObject;
function isBoxedPrimitive(value) {
    return isNumberObject(value) || isStringObject(value) || isBooleanObject(value) || isBigIntObject(value) || isSymbolObject(value);
}
exports.isBoxedPrimitive = isBoxedPrimitive;
function isAnyArrayBuffer(value) {
    return typeof Uint8Array !== "undefined" && (isArrayBuffer(value) || isSharedArrayBuffer(value));
}
exports.isAnyArrayBuffer = isAnyArrayBuffer;
[
    "isProxy",
    "isExternal",
    "isModuleNamespaceObject"
].forEach(function(method) {
    Object.defineProperty(exports, method, {
        enumerable: false,
        value: function() {
            throw new Error(method + " is not supported in userland");
        }
    });
});

},{"6b5f9ae3e436d527":"iLchu","285c2b8081bf4b68":"hoFlX","e95b88ccd80e1671":"cJp9E","7db151546a22c2a8":"hAUjF"}],"iLchu":[function(require,module,exports) {
"use strict";
var hasToStringTag = require("e2b01ce809f132fb")();
var callBound = require("649cbf9949986a39");
var $toString = callBound("Object.prototype.toString");
var isStandardArguments = function isArguments(value) {
    if (hasToStringTag && value && typeof value === "object" && Symbol.toStringTag in value) return false;
    return $toString(value) === "[object Arguments]";
};
var isLegacyArguments = function isArguments(value) {
    if (isStandardArguments(value)) return true;
    return value !== null && typeof value === "object" && typeof value.length === "number" && value.length >= 0 && $toString(value) !== "[object Array]" && $toString(value.callee) === "[object Function]";
};
var supportsStandardArguments = function() {
    return isStandardArguments(arguments);
}();
isStandardArguments.isLegacyArguments = isLegacyArguments; // for tests
module.exports = supportsStandardArguments ? isStandardArguments : isLegacyArguments;

},{"e2b01ce809f132fb":"aOvfF","649cbf9949986a39":"eK6wT"}],"aOvfF":[function(require,module,exports) {
"use strict";
var hasSymbols = require("2ef89576d4959bff");
/** @type {import('.')} */ module.exports = function hasToStringTagShams() {
    return hasSymbols() && !!Symbol.toStringTag;
};

},{"2ef89576d4959bff":"8apFc"}],"hoFlX":[function(require,module,exports) {
"use strict";
var toStr = Object.prototype.toString;
var fnToStr = Function.prototype.toString;
var isFnRegex = /^\s*(?:function)?\*/;
var hasToStringTag = require("b42ab74c25dbb155")();
var getProto = Object.getPrototypeOf;
var getGeneratorFunc = function() {
    if (!hasToStringTag) return false;
    try {
        return Function("return function*() {}")();
    } catch (e) {}
};
var GeneratorFunction;
module.exports = function isGeneratorFunction(fn) {
    if (typeof fn !== "function") return false;
    if (isFnRegex.test(fnToStr.call(fn))) return true;
    if (!hasToStringTag) {
        var str = toStr.call(fn);
        return str === "[object GeneratorFunction]";
    }
    if (!getProto) return false;
    if (typeof GeneratorFunction === "undefined") {
        var generatorFunc = getGeneratorFunc();
        GeneratorFunction = generatorFunc ? getProto(generatorFunc) : false;
    }
    return getProto(fn) === GeneratorFunction;
};

},{"b42ab74c25dbb155":"aOvfF"}],"cJp9E":[function(require,module,exports) {
var global = arguments[3];
"use strict";
var forEach = require("2941d48f36957e3c");
var availableTypedArrays = require("beaf5502a5823cce");
var callBind = require("e5d203a1b4c809f9");
var callBound = require("83f633f9b335db8f");
var gOPD = require("ce6b45c571ba4e3e");
/** @type {(O: object) => string} */ var $toString = callBound("Object.prototype.toString");
var hasToStringTag = require("9e7ef6c88184c56")();
var g = typeof globalThis === "undefined" ? global : globalThis;
var typedArrays = availableTypedArrays();
var $slice = callBound("String.prototype.slice");
var getPrototypeOf = Object.getPrototypeOf; // require('getprototypeof');
/** @type {<T = unknown>(array: readonly T[], value: unknown) => number} */ var $indexOf = callBound("Array.prototype.indexOf", true) || function indexOf(array, value) {
    for(var i = 0; i < array.length; i += 1){
        if (array[i] === value) return i;
    }
    return -1;
};
/** @typedef {(receiver: import('.').TypedArray) => string | typeof Uint8Array.prototype.slice.call | typeof Uint8Array.prototype.set.call} Getter */ /** @type {{ [k in `\$${import('.').TypedArrayName}`]?: Getter } & { __proto__: null }} */ var cache = {
    __proto__: null
};
if (hasToStringTag && gOPD && getPrototypeOf) forEach(typedArrays, function(typedArray) {
    var arr = new g[typedArray]();
    if (Symbol.toStringTag in arr) {
        var proto = getPrototypeOf(arr);
        // @ts-expect-error TS won't narrow inside a closure
        var descriptor = gOPD(proto, Symbol.toStringTag);
        if (!descriptor) {
            var superProto = getPrototypeOf(proto);
            // @ts-expect-error TS won't narrow inside a closure
            descriptor = gOPD(superProto, Symbol.toStringTag);
        }
        // @ts-expect-error TODO: fix
        cache["$" + typedArray] = callBind(descriptor.get);
    }
});
else forEach(typedArrays, function(typedArray) {
    var arr = new g[typedArray]();
    var fn = arr.slice || arr.set;
    if (fn) // @ts-expect-error TODO: fix
    cache["$" + typedArray] = callBind(fn);
});
/** @type {(value: object) => false | import('.').TypedArrayName} */ var tryTypedArrays = function tryAllTypedArrays(value) {
    /** @type {ReturnType<typeof tryAllTypedArrays>} */ var found = false;
    forEach(// eslint-disable-next-line no-extra-parens
    /** @type {Record<`\$${TypedArrayName}`, Getter>} */ /** @type {any} */ cache, /** @type {(getter: Getter, name: `\$${import('.').TypedArrayName}`) => void} */ function(getter, typedArray) {
        if (!found) try {
            // @ts-expect-error TODO: fix
            if ("$" + getter(value) === typedArray) found = $slice(typedArray, 1);
        } catch (e) {}
    });
    return found;
};
/** @type {(value: object) => false | import('.').TypedArrayName} */ var trySlices = function tryAllSlices(value) {
    /** @type {ReturnType<typeof tryAllSlices>} */ var found = false;
    forEach(// eslint-disable-next-line no-extra-parens
    /** @type {Record<`\$${TypedArrayName}`, Getter>} */ /** @type {any} */ cache, /** @type {(getter: typeof cache, name: `\$${import('.').TypedArrayName}`) => void} */ function(getter, name) {
        if (!found) try {
            // @ts-expect-error TODO: fix
            getter(value);
            found = $slice(name, 1);
        } catch (e) {}
    });
    return found;
};
/** @type {import('.')} */ module.exports = function whichTypedArray(value) {
    if (!value || typeof value !== "object") return false;
    if (!hasToStringTag) {
        /** @type {string} */ var tag = $slice($toString(value), 8, -1);
        if ($indexOf(typedArrays, tag) > -1) return tag;
        if (tag !== "Object") return false;
        // node < 0.6 hits here on real Typed Arrays
        return trySlices(value);
    }
    if (!gOPD) return null;
     // unknown engine
    return tryTypedArrays(value);
};

},{"2941d48f36957e3c":"168ia","beaf5502a5823cce":"eu5Zb","e5d203a1b4c809f9":"8iKie","83f633f9b335db8f":"eK6wT","ce6b45c571ba4e3e":"bOKb6","9e7ef6c88184c56":"aOvfF"}],"168ia":[function(require,module,exports) {
"use strict";
var isCallable = require("e50ebc24bbb25feb");
var toStr = Object.prototype.toString;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var forEachArray = function forEachArray(array, iterator, receiver) {
    for(var i = 0, len = array.length; i < len; i++)if (hasOwnProperty.call(array, i)) {
        if (receiver == null) iterator(array[i], i, array);
        else iterator.call(receiver, array[i], i, array);
    }
};
var forEachString = function forEachString(string, iterator, receiver) {
    for(var i = 0, len = string.length; i < len; i++)// no such thing as a sparse string.
    if (receiver == null) iterator(string.charAt(i), i, string);
    else iterator.call(receiver, string.charAt(i), i, string);
};
var forEachObject = function forEachObject(object, iterator, receiver) {
    for(var k in object)if (hasOwnProperty.call(object, k)) {
        if (receiver == null) iterator(object[k], k, object);
        else iterator.call(receiver, object[k], k, object);
    }
};
var forEach = function forEach(list, iterator, thisArg) {
    if (!isCallable(iterator)) throw new TypeError("iterator must be a function");
    var receiver;
    if (arguments.length >= 3) receiver = thisArg;
    if (toStr.call(list) === "[object Array]") forEachArray(list, iterator, receiver);
    else if (typeof list === "string") forEachString(list, iterator, receiver);
    else forEachObject(list, iterator, receiver);
};
module.exports = forEach;

},{"e50ebc24bbb25feb":"9JXX5"}],"9JXX5":[function(require,module,exports) {
"use strict";
var fnToStr = Function.prototype.toString;
var reflectApply = typeof Reflect === "object" && Reflect !== null && Reflect.apply;
var badArrayLike;
var isCallableMarker;
if (typeof reflectApply === "function" && typeof Object.defineProperty === "function") try {
    badArrayLike = Object.defineProperty({}, "length", {
        get: function() {
            throw isCallableMarker;
        }
    });
    isCallableMarker = {};
    // eslint-disable-next-line no-throw-literal
    reflectApply(function() {
        throw 42;
    }, null, badArrayLike);
} catch (_) {
    if (_ !== isCallableMarker) reflectApply = null;
}
else reflectApply = null;
var constructorRegex = /^\s*class\b/;
var isES6ClassFn = function isES6ClassFunction(value) {
    try {
        var fnStr = fnToStr.call(value);
        return constructorRegex.test(fnStr);
    } catch (e) {
        return false; // not a function
    }
};
var tryFunctionObject = function tryFunctionToStr(value) {
    try {
        if (isES6ClassFn(value)) return false;
        fnToStr.call(value);
        return true;
    } catch (e) {
        return false;
    }
};
var toStr = Object.prototype.toString;
var objectClass = "[object Object]";
var fnClass = "[object Function]";
var genClass = "[object GeneratorFunction]";
var ddaClass = "[object HTMLAllCollection]"; // IE 11
var ddaClass2 = "[object HTML document.all class]";
var ddaClass3 = "[object HTMLCollection]"; // IE 9-10
var hasToStringTag = typeof Symbol === "function" && !!Symbol.toStringTag; // better: use `has-tostringtag`
var isIE68 = !(0 in [
    , 
]); // eslint-disable-line no-sparse-arrays, comma-spacing
var isDDA = function isDocumentDotAll() {
    return false;
};
if (typeof document === "object") {
    // Firefox 3 canonicalizes DDA to undefined when it's not accessed directly
    var all = document.all;
    if (toStr.call(all) === toStr.call(document.all)) isDDA = function isDocumentDotAll(value) {
        /* globals document: false */ // in IE 6-8, typeof document.all is "object" and it's truthy
        if ((isIE68 || !value) && (typeof value === "undefined" || typeof value === "object")) try {
            var str = toStr.call(value);
            return (str === ddaClass || str === ddaClass2 || str === ddaClass3 // opera 12.16
             || str === objectClass // IE 6-8
            ) && value("") == null; // eslint-disable-line eqeqeq
        } catch (e) {}
        return false;
    };
}
module.exports = reflectApply ? function isCallable(value) {
    if (isDDA(value)) return true;
    if (!value) return false;
    if (typeof value !== "function" && typeof value !== "object") return false;
    try {
        reflectApply(value, null, badArrayLike);
    } catch (e) {
        if (e !== isCallableMarker) return false;
    }
    return !isES6ClassFn(value) && tryFunctionObject(value);
} : function isCallable(value) {
    if (isDDA(value)) return true;
    if (!value) return false;
    if (typeof value !== "function" && typeof value !== "object") return false;
    if (hasToStringTag) return tryFunctionObject(value);
    if (isES6ClassFn(value)) return false;
    var strClass = toStr.call(value);
    if (strClass !== fnClass && strClass !== genClass && !/^\[object HTML/.test(strClass)) return false;
    return tryFunctionObject(value);
};

},{}],"eu5Zb":[function(require,module,exports) {
var global = arguments[3];
"use strict";
var possibleNames = require("3021d1584ad62785");
var g = typeof globalThis === "undefined" ? global : globalThis;
/** @type {import('.')} */ module.exports = function availableTypedArrays() {
    var /** @type {ReturnType<typeof availableTypedArrays>} */ out = [];
    for(var i = 0; i < possibleNames.length; i++)if (typeof g[possibleNames[i]] === "function") // @ts-expect-error
    out[out.length] = possibleNames[i];
    return out;
};

},{"3021d1584ad62785":"bDy8Y"}],"bDy8Y":[function(require,module,exports) {
"use strict";
/** @type {import('.')} */ module.exports = [
    "Float32Array",
    "Float64Array",
    "Int8Array",
    "Int16Array",
    "Int32Array",
    "Uint8Array",
    "Uint8ClampedArray",
    "Uint16Array",
    "Uint32Array",
    "BigInt64Array",
    "BigUint64Array"
];

},{}],"hAUjF":[function(require,module,exports) {
"use strict";
var whichTypedArray = require("ccf73e5f240c2b8");
/** @type {import('.')} */ module.exports = function isTypedArray(value) {
    return !!whichTypedArray(value);
};

},{"ccf73e5f240c2b8":"cJp9E"}],"1xkSL":[function(require,module,exports) {
module.exports = function isBuffer(arg) {
    return arg && typeof arg === "object" && typeof arg.copy === "function" && typeof arg.fill === "function" && typeof arg.readUInt8 === "function";
};

},{}],"a6g2R":[function(require,module,exports) {
// Currently in sync with Node.js lib/internal/assert/assertion_error.js
// https://github.com/nodejs/node/commit/0817840f775032169ddd70c85ac059f18ffcc81c
var process = require("228da2c254a5e871");
"use strict";
function ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function _objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? ownKeys(Object(t), !0).forEach(function(r) {
            _defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function _defineProperty(obj, key, value) {
    key = _toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function _toPropertyKey(arg) {
    var key = _toPrimitive(arg, "string");
    return _typeof(key) === "symbol" ? key : String(key);
}
function _toPrimitive(input, hint) {
    if (_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return _possibleConstructorReturn(this, result);
    };
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return _assertThisInitialized(self);
}
function _assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function _wrapNativeSuper(Class) {
    var _cache = typeof Map === "function" ? new Map() : undefined;
    _wrapNativeSuper = function _wrapNativeSuper(Class) {
        if (Class === null || !_isNativeFunction(Class)) return Class;
        if (typeof Class !== "function") throw new TypeError("Super expression must either be null or a function");
        if (typeof _cache !== "undefined") {
            if (_cache.has(Class)) return _cache.get(Class);
            _cache.set(Class, Wrapper);
        }
        function Wrapper() {
            return _construct(Class, arguments, _getPrototypeOf(this).constructor);
        }
        Wrapper.prototype = Object.create(Class.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        return _setPrototypeOf(Wrapper, Class);
    };
    return _wrapNativeSuper(Class);
}
function _construct(Parent, args, Class) {
    if (_isNativeReflectConstruct()) _construct = Reflect.construct.bind();
    else _construct = function _construct(Parent, args, Class) {
        var a = [
            null
        ];
        a.push.apply(a, args);
        var Constructor = Function.bind.apply(Parent, a);
        var instance = new Constructor();
        if (Class) _setPrototypeOf(instance, Class.prototype);
        return instance;
    };
    return _construct.apply(null, arguments);
}
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _isNativeFunction(fn) {
    return Function.toString.call(fn).indexOf("[native code]") !== -1;
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _typeof(o) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, _typeof(o);
}
var _require = require("9984e91d63ed614c"), inspect = _require.inspect;
var _require2 = require("1670766d7c5cef96"), ERR_INVALID_ARG_TYPE = _require2.codes.ERR_INVALID_ARG_TYPE;
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/endsWith
function endsWith(str, search, this_len) {
    if (this_len === undefined || this_len > str.length) this_len = str.length;
    return str.substring(this_len - search.length, this_len) === search;
}
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/repeat
function repeat(str, count) {
    count = Math.floor(count);
    if (str.length == 0 || count == 0) return "";
    var maxCount = str.length * count;
    count = Math.floor(Math.log(count) / Math.log(2));
    while(count){
        str += str;
        count--;
    }
    str += str.substring(0, maxCount - str.length);
    return str;
}
var blue = "";
var green = "";
var red = "";
var white = "";
var kReadableOperator = {
    deepStrictEqual: "Expected values to be strictly deep-equal:",
    strictEqual: "Expected values to be strictly equal:",
    strictEqualObject: 'Expected "actual" to be reference-equal to "expected":',
    deepEqual: "Expected values to be loosely deep-equal:",
    equal: "Expected values to be loosely equal:",
    notDeepStrictEqual: 'Expected "actual" not to be strictly deep-equal to:',
    notStrictEqual: 'Expected "actual" to be strictly unequal to:',
    notStrictEqualObject: 'Expected "actual" not to be reference-equal to "expected":',
    notDeepEqual: 'Expected "actual" not to be loosely deep-equal to:',
    notEqual: 'Expected "actual" to be loosely unequal to:',
    notIdentical: "Values identical but not reference-equal:"
};
// Comparing short primitives should just show === / !== instead of using the
// diff.
var kMaxShortLength = 10;
function copyError(source) {
    var keys = Object.keys(source);
    var target = Object.create(Object.getPrototypeOf(source));
    keys.forEach(function(key) {
        target[key] = source[key];
    });
    Object.defineProperty(target, "message", {
        value: source.message
    });
    return target;
}
function inspectValue(val) {
    // The util.inspect default values could be changed. This makes sure the
    // error messages contain the necessary information nevertheless.
    return inspect(val, {
        compact: false,
        customInspect: false,
        depth: 1000,
        maxArrayLength: Infinity,
        // Assert compares only enumerable properties (with a few exceptions).
        showHidden: false,
        // Having a long line as error is better than wrapping the line for
        // comparison for now.
        // TODO(BridgeAR): `breakLength` should be limited as soon as soon as we
        // have meta information about the inspected properties (i.e., know where
        // in what line the property starts and ends).
        breakLength: Infinity,
        // Assert does not detect proxies currently.
        showProxy: false,
        sorted: true,
        // Inspect getters as we also check them when comparing entries.
        getters: true
    });
}
function createErrDiff(actual, expected, operator) {
    var other = "";
    var res = "";
    var lastPos = 0;
    var end = "";
    var skipped = false;
    var actualInspected = inspectValue(actual);
    var actualLines = actualInspected.split("\n");
    var expectedLines = inspectValue(expected).split("\n");
    var i = 0;
    var indicator = "";
    // In case both values are objects explicitly mark them as not reference equal
    // for the `strictEqual` operator.
    if (operator === "strictEqual" && _typeof(actual) === "object" && _typeof(expected) === "object" && actual !== null && expected !== null) operator = "strictEqualObject";
    // If "actual" and "expected" fit on a single line and they are not strictly
    // equal, check further special handling.
    if (actualLines.length === 1 && expectedLines.length === 1 && actualLines[0] !== expectedLines[0]) {
        var inputLength = actualLines[0].length + expectedLines[0].length;
        // If the character length of "actual" and "expected" together is less than
        // kMaxShortLength and if neither is an object and at least one of them is
        // not `zero`, use the strict equal comparison to visualize the output.
        if (inputLength <= kMaxShortLength) {
            if ((_typeof(actual) !== "object" || actual === null) && (_typeof(expected) !== "object" || expected === null) && (actual !== 0 || expected !== 0)) // -0 === +0
            return "".concat(kReadableOperator[operator], "\n\n") + "".concat(actualLines[0], " !== ").concat(expectedLines[0], "\n");
        } else if (operator !== "strictEqualObject") {
            // If the stderr is a tty and the input length is lower than the current
            // columns per line, add a mismatch indicator below the output. If it is
            // not a tty, use a default value of 80 characters.
            var maxLength = process.stderr && process.stderr.isTTY ? process.stderr.columns : 80;
            if (inputLength < maxLength) {
                while(actualLines[0][i] === expectedLines[0][i])i++;
                // Ignore the first characters.
                if (i > 2) {
                    // Add position indicator for the first mismatch in case it is a
                    // single line and the input length is less than the column length.
                    indicator = "\n  ".concat(repeat(" ", i), "^");
                    i = 0;
                }
            }
        }
    }
    // Remove all ending lines that match (this optimizes the output for
    // readability by reducing the number of total changed lines).
    var a = actualLines[actualLines.length - 1];
    var b = expectedLines[expectedLines.length - 1];
    while(a === b){
        if (i++ < 2) end = "\n  ".concat(a).concat(end);
        else other = a;
        actualLines.pop();
        expectedLines.pop();
        if (actualLines.length === 0 || expectedLines.length === 0) break;
        a = actualLines[actualLines.length - 1];
        b = expectedLines[expectedLines.length - 1];
    }
    var maxLines = Math.max(actualLines.length, expectedLines.length);
    // Strict equal with identical objects that are not identical by reference.
    // E.g., assert.deepStrictEqual({ a: Symbol() }, { a: Symbol() })
    if (maxLines === 0) {
        // We have to get the result again. The lines were all removed before.
        var _actualLines = actualInspected.split("\n");
        // Only remove lines in case it makes sense to collapse those.
        // TODO: Accept env to always show the full error.
        if (_actualLines.length > 30) {
            _actualLines[26] = "".concat(blue, "...").concat(white);
            while(_actualLines.length > 27)_actualLines.pop();
        }
        return "".concat(kReadableOperator.notIdentical, "\n\n").concat(_actualLines.join("\n"), "\n");
    }
    if (i > 3) {
        end = "\n".concat(blue, "...").concat(white).concat(end);
        skipped = true;
    }
    if (other !== "") {
        end = "\n  ".concat(other).concat(end);
        other = "";
    }
    var printedLines = 0;
    var msg = kReadableOperator[operator] + "\n".concat(green, "+ actual").concat(white, " ").concat(red, "- expected").concat(white);
    var skippedMsg = " ".concat(blue, "...").concat(white, " Lines skipped");
    for(i = 0; i < maxLines; i++){
        // Only extra expected lines exist
        var cur = i - lastPos;
        if (actualLines.length < i + 1) {
            // If the last diverging line is more than one line above and the
            // current line is at least line three, add some of the former lines and
            // also add dots to indicate skipped entries.
            if (cur > 1 && i > 2) {
                if (cur > 4) {
                    res += "\n".concat(blue, "...").concat(white);
                    skipped = true;
                } else if (cur > 3) {
                    res += "\n  ".concat(expectedLines[i - 2]);
                    printedLines++;
                }
                res += "\n  ".concat(expectedLines[i - 1]);
                printedLines++;
            }
            // Mark the current line as the last diverging one.
            lastPos = i;
            // Add the expected line to the cache.
            other += "\n".concat(red, "-").concat(white, " ").concat(expectedLines[i]);
            printedLines++;
        // Only extra actual lines exist
        } else if (expectedLines.length < i + 1) {
            // If the last diverging line is more than one line above and the
            // current line is at least line three, add some of the former lines and
            // also add dots to indicate skipped entries.
            if (cur > 1 && i > 2) {
                if (cur > 4) {
                    res += "\n".concat(blue, "...").concat(white);
                    skipped = true;
                } else if (cur > 3) {
                    res += "\n  ".concat(actualLines[i - 2]);
                    printedLines++;
                }
                res += "\n  ".concat(actualLines[i - 1]);
                printedLines++;
            }
            // Mark the current line as the last diverging one.
            lastPos = i;
            // Add the actual line to the result.
            res += "\n".concat(green, "+").concat(white, " ").concat(actualLines[i]);
            printedLines++;
        // Lines diverge
        } else {
            var expectedLine = expectedLines[i];
            var actualLine = actualLines[i];
            // If the lines diverge, specifically check for lines that only diverge by
            // a trailing comma. In that case it is actually identical and we should
            // mark it as such.
            var divergingLines = actualLine !== expectedLine && (!endsWith(actualLine, ",") || actualLine.slice(0, -1) !== expectedLine);
            // If the expected line has a trailing comma but is otherwise identical,
            // add a comma at the end of the actual line. Otherwise the output could
            // look weird as in:
            //
            //   [
            //     1         // No comma at the end!
            // +   2
            //   ]
            //
            if (divergingLines && endsWith(expectedLine, ",") && expectedLine.slice(0, -1) === actualLine) {
                divergingLines = false;
                actualLine += ",";
            }
            if (divergingLines) {
                // If the last diverging line is more than one line above and the
                // current line is at least line three, add some of the former lines and
                // also add dots to indicate skipped entries.
                if (cur > 1 && i > 2) {
                    if (cur > 4) {
                        res += "\n".concat(blue, "...").concat(white);
                        skipped = true;
                    } else if (cur > 3) {
                        res += "\n  ".concat(actualLines[i - 2]);
                        printedLines++;
                    }
                    res += "\n  ".concat(actualLines[i - 1]);
                    printedLines++;
                }
                // Mark the current line as the last diverging one.
                lastPos = i;
                // Add the actual line to the result and cache the expected diverging
                // line so consecutive diverging lines show up as +++--- and not +-+-+-.
                res += "\n".concat(green, "+").concat(white, " ").concat(actualLine);
                other += "\n".concat(red, "-").concat(white, " ").concat(expectedLine);
                printedLines += 2;
            // Lines are identical
            } else {
                // Add all cached information to the result before adding other things
                // and reset the cache.
                res += other;
                other = "";
                // If the last diverging line is exactly one line above or if it is the
                // very first line, add the line to the result.
                if (cur === 1 || i === 0) {
                    res += "\n  ".concat(actualLine);
                    printedLines++;
                }
            }
        }
        // Inspected object to big (Show ~20 rows max)
        if (printedLines > 20 && i < maxLines - 2) return "".concat(msg).concat(skippedMsg, "\n").concat(res, "\n").concat(blue, "...").concat(white).concat(other, "\n") + "".concat(blue, "...").concat(white);
    }
    return "".concat(msg).concat(skipped ? skippedMsg : "", "\n").concat(res).concat(other).concat(end).concat(indicator);
}
var AssertionError = /*#__PURE__*/ function(_Error, _inspect$custom) {
    _inherits(AssertionError, _Error);
    var _super = _createSuper(AssertionError);
    function AssertionError(options) {
        var _this;
        _classCallCheck(this, AssertionError);
        if (_typeof(options) !== "object" || options === null) throw new ERR_INVALID_ARG_TYPE("options", "Object", options);
        var message = options.message, operator = options.operator, stackStartFn = options.stackStartFn;
        var actual = options.actual, expected = options.expected;
        var limit = Error.stackTraceLimit;
        Error.stackTraceLimit = 0;
        if (message != null) _this = _super.call(this, String(message));
        else {
            if (process.stderr && process.stderr.isTTY) {
                // Reset on each call to make sure we handle dynamically set environment
                // variables correct.
                if (process.stderr && process.stderr.getColorDepth && process.stderr.getColorDepth() !== 1) {
                    blue = "\x1b[34m";
                    green = "\x1b[32m";
                    white = "\x1b[39m";
                    red = "\x1b[31m";
                } else {
                    blue = "";
                    green = "";
                    white = "";
                    red = "";
                }
            }
            // Prevent the error stack from being visible by duplicating the error
            // in a very close way to the original in case both sides are actually
            // instances of Error.
            if (_typeof(actual) === "object" && actual !== null && _typeof(expected) === "object" && expected !== null && "stack" in actual && actual instanceof Error && "stack" in expected && expected instanceof Error) {
                actual = copyError(actual);
                expected = copyError(expected);
            }
            if (operator === "deepStrictEqual" || operator === "strictEqual") _this = _super.call(this, createErrDiff(actual, expected, operator));
            else if (operator === "notDeepStrictEqual" || operator === "notStrictEqual") {
                // In case the objects are equal but the operator requires unequal, show
                // the first object and say A equals B
                var base = kReadableOperator[operator];
                var res = inspectValue(actual).split("\n");
                // In case "actual" is an object, it should not be reference equal.
                if (operator === "notStrictEqual" && _typeof(actual) === "object" && actual !== null) base = kReadableOperator.notStrictEqualObject;
                // Only remove lines in case it makes sense to collapse those.
                // TODO: Accept env to always show the full error.
                if (res.length > 30) {
                    res[26] = "".concat(blue, "...").concat(white);
                    while(res.length > 27)res.pop();
                }
                // Only print a single input.
                if (res.length === 1) _this = _super.call(this, "".concat(base, " ").concat(res[0]));
                else _this = _super.call(this, "".concat(base, "\n\n").concat(res.join("\n"), "\n"));
            } else {
                var _res = inspectValue(actual);
                var other = "";
                var knownOperators = kReadableOperator[operator];
                if (operator === "notDeepEqual" || operator === "notEqual") {
                    _res = "".concat(kReadableOperator[operator], "\n\n").concat(_res);
                    if (_res.length > 1024) _res = "".concat(_res.slice(0, 1021), "...");
                } else {
                    other = "".concat(inspectValue(expected));
                    if (_res.length > 512) _res = "".concat(_res.slice(0, 509), "...");
                    if (other.length > 512) other = "".concat(other.slice(0, 509), "...");
                    if (operator === "deepEqual" || operator === "equal") _res = "".concat(knownOperators, "\n\n").concat(_res, "\n\nshould equal\n\n");
                    else other = " ".concat(operator, " ").concat(other);
                }
                _this = _super.call(this, "".concat(_res).concat(other));
            }
        }
        Error.stackTraceLimit = limit;
        _this.generatedMessage = !message;
        Object.defineProperty(_assertThisInitialized(_this), "name", {
            value: "AssertionError [ERR_ASSERTION]",
            enumerable: false,
            writable: true,
            configurable: true
        });
        _this.code = "ERR_ASSERTION";
        _this.actual = actual;
        _this.expected = expected;
        _this.operator = operator;
        if (Error.captureStackTrace) // eslint-disable-next-line no-restricted-syntax
        Error.captureStackTrace(_assertThisInitialized(_this), stackStartFn);
        // Create error message including the error code in the name.
        _this.stack;
        // Reset the name.
        _this.name = "AssertionError";
        return _possibleConstructorReturn(_this);
    }
    _createClass(AssertionError, [
        {
            key: "toString",
            value: function toString() {
                return "".concat(this.name, " [").concat(this.code, "]: ").concat(this.message);
            }
        },
        {
            key: _inspect$custom,
            value: function value(recurseTimes, ctx) {
                // This limits the `actual` and `expected` property default inspection to
                // the minimum depth. Otherwise those values would be too verbose compared
                // to the actual error message which contains a combined view of these two
                // input values.
                return inspect(this, _objectSpread(_objectSpread({}, ctx), {}, {
                    customInspect: false,
                    depth: 0
                }));
            }
        }
    ]);
    return AssertionError;
}(/*#__PURE__*/ _wrapNativeSuper(Error), inspect.custom);
module.exports = AssertionError;

},{"228da2c254a5e871":"5QIF0","9984e91d63ed614c":"jInrX","1670766d7c5cef96":"lcRXS"}],"7uZe2":[function(require,module,exports) {
"use strict";
var implementation = require("b7e83063a8ec29e5");
var lacksProperEnumerationOrder = function() {
    if (!Object.assign) return false;
    /*
	 * v8, specifically in node 4.x, has a bug with incorrect property enumeration order
	 * note: this does not detect the bug unless there's 20 characters
	 */ var str = "abcdefghijklmnopqrst";
    var letters = str.split("");
    var map = {};
    for(var i = 0; i < letters.length; ++i)map[letters[i]] = letters[i];
    var obj = Object.assign({}, map);
    var actual = "";
    for(var k in obj)actual += k;
    return str !== actual;
};
var assignHasPendingExceptions = function() {
    if (!Object.assign || !Object.preventExtensions) return false;
    /*
	 * Firefox 37 still has "pending exception" logic in its Object.assign implementation,
	 * which is 72% slower than our shim, and Firefox 40's native implementation.
	 */ var thrower = Object.preventExtensions({
        1: 2
    });
    try {
        Object.assign(thrower, "xy");
    } catch (e) {
        return thrower[1] === "y";
    }
    return false;
};
module.exports = function getPolyfill() {
    if (!Object.assign) return implementation;
    if (lacksProperEnumerationOrder()) return implementation;
    if (assignHasPendingExceptions()) return implementation;
    return Object.assign;
};

},{"b7e83063a8ec29e5":"PTrux"}],"PTrux":[function(require,module,exports) {
"use strict";
// modified from https://github.com/es-shims/es6-shim
var objectKeys = require("334c0bea01e613e6");
var hasSymbols = require("1964e25feb5e87a1")();
var callBound = require("6fb85b5b56dcab21");
var toObject = Object;
var $push = callBound("Array.prototype.push");
var $propIsEnumerable = callBound("Object.prototype.propertyIsEnumerable");
var originalGetSymbols = hasSymbols ? Object.getOwnPropertySymbols : null;
// eslint-disable-next-line no-unused-vars
module.exports = function assign(target, source1) {
    if (target == null) throw new TypeError("target must be an object");
    var to = toObject(target); // step 1
    if (arguments.length === 1) return to; // step 2
    for(var s = 1; s < arguments.length; ++s){
        var from = toObject(arguments[s]); // step 3.a.i
        // step 3.a.ii:
        var keys = objectKeys(from);
        var getSymbols = hasSymbols && (Object.getOwnPropertySymbols || originalGetSymbols);
        if (getSymbols) {
            var syms = getSymbols(from);
            for(var j = 0; j < syms.length; ++j){
                var key = syms[j];
                if ($propIsEnumerable(from, key)) $push(keys, key);
            }
        }
        // step 3.a.iii:
        for(var i = 0; i < keys.length; ++i){
            var nextKey = keys[i];
            if ($propIsEnumerable(from, nextKey)) {
                var propValue = from[nextKey]; // step 3.a.iii.2.a
                to[nextKey] = propValue; // step 3.a.iii.2.b
            }
        }
    }
    return to; // step 4
};

},{"334c0bea01e613e6":"3gfZs","1964e25feb5e87a1":"8apFc","6fb85b5b56dcab21":"eK6wT"}],"3gfZs":[function(require,module,exports) {
"use strict";
var slice = Array.prototype.slice;
var isArgs = require("93e8460f624c96f4");
var origKeys = Object.keys;
var keysShim = origKeys ? function keys(o) {
    return origKeys(o);
} : require("344bb0d7b2568e03");
var originalKeys = Object.keys;
keysShim.shim = function shimObjectKeys() {
    if (Object.keys) {
        var keysWorksWithArguments = function() {
            // Safari 5.0 bug
            var args = Object.keys(arguments);
            return args && args.length === arguments.length;
        }(1, 2);
        if (!keysWorksWithArguments) Object.keys = function keys(object) {
            if (isArgs(object)) return originalKeys(slice.call(object));
            return originalKeys(object);
        };
    } else Object.keys = keysShim;
    return Object.keys || keysShim;
};
module.exports = keysShim;

},{"93e8460f624c96f4":"24QAG","344bb0d7b2568e03":"fKvNx"}],"24QAG":[function(require,module,exports) {
"use strict";
var toStr = Object.prototype.toString;
module.exports = function isArguments(value) {
    var str = toStr.call(value);
    var isArgs = str === "[object Arguments]";
    if (!isArgs) isArgs = str !== "[object Array]" && value !== null && typeof value === "object" && typeof value.length === "number" && value.length >= 0 && toStr.call(value.callee) === "[object Function]";
    return isArgs;
};

},{}],"fKvNx":[function(require,module,exports) {
"use strict";
var keysShim;
if (!Object.keys) {
    // modified from https://github.com/es-shims/es5-shim
    var has = Object.prototype.hasOwnProperty;
    var toStr = Object.prototype.toString;
    var isArgs = require("b0d8c8b84be91ffd"); // eslint-disable-line global-require
    var isEnumerable = Object.prototype.propertyIsEnumerable;
    var hasDontEnumBug = !isEnumerable.call({
        toString: null
    }, "toString");
    var hasProtoEnumBug = isEnumerable.call(function() {}, "prototype");
    var dontEnums = [
        "toString",
        "toLocaleString",
        "valueOf",
        "hasOwnProperty",
        "isPrototypeOf",
        "propertyIsEnumerable",
        "constructor"
    ];
    var equalsConstructorPrototype = function(o) {
        var ctor = o.constructor;
        return ctor && ctor.prototype === o;
    };
    var excludedKeys = {
        $applicationCache: true,
        $console: true,
        $external: true,
        $frame: true,
        $frameElement: true,
        $frames: true,
        $innerHeight: true,
        $innerWidth: true,
        $onmozfullscreenchange: true,
        $onmozfullscreenerror: true,
        $outerHeight: true,
        $outerWidth: true,
        $pageXOffset: true,
        $pageYOffset: true,
        $parent: true,
        $scrollLeft: true,
        $scrollTop: true,
        $scrollX: true,
        $scrollY: true,
        $self: true,
        $webkitIndexedDB: true,
        $webkitStorageInfo: true,
        $window: true
    };
    var hasAutomationEqualityBug = function() {
        /* global window */ if (typeof window === "undefined") return false;
        for(var k in window)try {
            if (!excludedKeys["$" + k] && has.call(window, k) && window[k] !== null && typeof window[k] === "object") try {
                equalsConstructorPrototype(window[k]);
            } catch (e) {
                return true;
            }
        } catch (e) {
            return true;
        }
        return false;
    }();
    var equalsConstructorPrototypeIfNotBuggy = function(o) {
        /* global window */ if (typeof window === "undefined" || !hasAutomationEqualityBug) return equalsConstructorPrototype(o);
        try {
            return equalsConstructorPrototype(o);
        } catch (e) {
            return false;
        }
    };
    keysShim = function keys(object) {
        var isObject = object !== null && typeof object === "object";
        var isFunction = toStr.call(object) === "[object Function]";
        var isArguments = isArgs(object);
        var isString = isObject && toStr.call(object) === "[object String]";
        var theKeys = [];
        if (!isObject && !isFunction && !isArguments) throw new TypeError("Object.keys called on a non-object");
        var skipProto = hasProtoEnumBug && isFunction;
        if (isString && object.length > 0 && !has.call(object, 0)) for(var i = 0; i < object.length; ++i)theKeys.push(String(i));
        if (isArguments && object.length > 0) for(var j = 0; j < object.length; ++j)theKeys.push(String(j));
        else {
            for(var name in object)if (!(skipProto && name === "prototype") && has.call(object, name)) theKeys.push(String(name));
        }
        if (hasDontEnumBug) {
            var skipConstructor = equalsConstructorPrototypeIfNotBuggy(object);
            for(var k = 0; k < dontEnums.length; ++k)if (!(skipConstructor && dontEnums[k] === "constructor") && has.call(object, dontEnums[k])) theKeys.push(dontEnums[k]);
        }
        return theKeys;
    };
}
module.exports = keysShim;

},{"b0d8c8b84be91ffd":"24QAG"}],"jCZAj":[function(require,module,exports) {
"use strict";
var implementation = require("ff80ab827617d6fd");
module.exports = function getPolyfill() {
    return typeof Object.is === "function" ? Object.is : implementation;
};

},{"ff80ab827617d6fd":"epWtd"}],"epWtd":[function(require,module,exports) {
"use strict";
var numberIsNaN = function(value) {
    return value !== value;
};
module.exports = function is(a, b) {
    if (a === 0 && b === 0) return 1 / a === 1 / b;
    if (a === b) return true;
    if (numberIsNaN(a) && numberIsNaN(b)) return true;
    return false;
};

},{}],"1aL1U":[function(require,module,exports) {
// Currently in sync with Node.js lib/internal/util/comparisons.js
// https://github.com/nodejs/node/commit/112cc7c27551254aa2b17098fb774867f05ed0d9
"use strict";
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _typeof(o) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, _typeof(o);
}
var regexFlagsSupported = /a/g.flags !== undefined;
var arrayFromSet = function arrayFromSet(set) {
    var array = [];
    set.forEach(function(value) {
        return array.push(value);
    });
    return array;
};
var arrayFromMap = function arrayFromMap(map) {
    var array = [];
    map.forEach(function(value, key) {
        return array.push([
            key,
            value
        ]);
    });
    return array;
};
var objectIs = Object.is ? Object.is : require("3addb16fbdd05c1c");
var objectGetOwnPropertySymbols = Object.getOwnPropertySymbols ? Object.getOwnPropertySymbols : function() {
    return [];
};
var numberIsNaN = Number.isNaN ? Number.isNaN : require("a27e57a3fd2e2e23");
function uncurryThis(f) {
    return f.call.bind(f);
}
var hasOwnProperty = uncurryThis(Object.prototype.hasOwnProperty);
var propertyIsEnumerable = uncurryThis(Object.prototype.propertyIsEnumerable);
var objectToString = uncurryThis(Object.prototype.toString);
var _require$types = require("4940125679601087").types, isAnyArrayBuffer = _require$types.isAnyArrayBuffer, isArrayBufferView = _require$types.isArrayBufferView, isDate = _require$types.isDate, isMap = _require$types.isMap, isRegExp = _require$types.isRegExp, isSet = _require$types.isSet, isNativeError = _require$types.isNativeError, isBoxedPrimitive = _require$types.isBoxedPrimitive, isNumberObject = _require$types.isNumberObject, isStringObject = _require$types.isStringObject, isBooleanObject = _require$types.isBooleanObject, isBigIntObject = _require$types.isBigIntObject, isSymbolObject = _require$types.isSymbolObject, isFloat32Array = _require$types.isFloat32Array, isFloat64Array = _require$types.isFloat64Array;
function isNonIndex(key) {
    if (key.length === 0 || key.length > 10) return true;
    for(var i = 0; i < key.length; i++){
        var code = key.charCodeAt(i);
        if (code < 48 || code > 57) return true;
    }
    // The maximum size for an array is 2 ** 32 -1.
    return key.length === 10 && key >= Math.pow(2, 32);
}
function getOwnNonIndexProperties(value) {
    return Object.keys(value).filter(isNonIndex).concat(objectGetOwnPropertySymbols(value).filter(Object.prototype.propertyIsEnumerable.bind(value)));
}
// Taken from https://github.com/feross/buffer/blob/680e9e5e488f22aac27599a57dc844a6315928dd/index.js
// original notice:
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
 * @license  MIT
 */ function compare(a, b) {
    if (a === b) return 0;
    var x = a.length;
    var y = b.length;
    for(var i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
}
var ONLY_ENUMERABLE = undefined;
var kStrict = true;
var kLoose = false;
var kNoIterator = 0;
var kIsArray = 1;
var kIsSet = 2;
var kIsMap = 3;
// Check if they have the same source and flags
function areSimilarRegExps(a, b) {
    return regexFlagsSupported ? a.source === b.source && a.flags === b.flags : RegExp.prototype.toString.call(a) === RegExp.prototype.toString.call(b);
}
function areSimilarFloatArrays(a, b) {
    if (a.byteLength !== b.byteLength) return false;
    for(var offset = 0; offset < a.byteLength; offset++){
        if (a[offset] !== b[offset]) return false;
    }
    return true;
}
function areSimilarTypedArrays(a, b) {
    if (a.byteLength !== b.byteLength) return false;
    return compare(new Uint8Array(a.buffer, a.byteOffset, a.byteLength), new Uint8Array(b.buffer, b.byteOffset, b.byteLength)) === 0;
}
function areEqualArrayBuffers(buf1, buf2) {
    return buf1.byteLength === buf2.byteLength && compare(new Uint8Array(buf1), new Uint8Array(buf2)) === 0;
}
function isEqualBoxedPrimitive(val1, val2) {
    if (isNumberObject(val1)) return isNumberObject(val2) && objectIs(Number.prototype.valueOf.call(val1), Number.prototype.valueOf.call(val2));
    if (isStringObject(val1)) return isStringObject(val2) && String.prototype.valueOf.call(val1) === String.prototype.valueOf.call(val2);
    if (isBooleanObject(val1)) return isBooleanObject(val2) && Boolean.prototype.valueOf.call(val1) === Boolean.prototype.valueOf.call(val2);
    if (isBigIntObject(val1)) return isBigIntObject(val2) && BigInt.prototype.valueOf.call(val1) === BigInt.prototype.valueOf.call(val2);
    return isSymbolObject(val2) && Symbol.prototype.valueOf.call(val1) === Symbol.prototype.valueOf.call(val2);
}
// Notes: Type tags are historical [[Class]] properties that can be set by
// FunctionTemplate::SetClassName() in C++ or Symbol.toStringTag in JS
// and retrieved using Object.prototype.toString.call(obj) in JS
// See https://tc39.github.io/ecma262/#sec-object.prototype.tostring
// for a list of tags pre-defined in the spec.
// There are some unspecified tags in the wild too (e.g. typed array tags).
// Since tags can be altered, they only serve fast failures
//
// Typed arrays and buffers are checked by comparing the content in their
// underlying ArrayBuffer. This optimization requires that it's
// reasonable to interpret their underlying memory in the same way,
// which is checked by comparing their type tags.
// (e.g. a Uint8Array and a Uint16Array with the same memory content
// could still be different because they will be interpreted differently).
//
// For strict comparison, objects should have
// a) The same built-in type tags
// b) The same prototypes.
function innerDeepEqual(val1, val2, strict, memos) {
    // All identical values are equivalent, as determined by ===.
    if (val1 === val2) {
        if (val1 !== 0) return true;
        return strict ? objectIs(val1, val2) : true;
    }
    // Check more closely if val1 and val2 are equal.
    if (strict) {
        if (_typeof(val1) !== "object") return typeof val1 === "number" && numberIsNaN(val1) && numberIsNaN(val2);
        if (_typeof(val2) !== "object" || val1 === null || val2 === null) return false;
        if (Object.getPrototypeOf(val1) !== Object.getPrototypeOf(val2)) return false;
    } else {
        if (val1 === null || _typeof(val1) !== "object") {
            if (val2 === null || _typeof(val2) !== "object") // eslint-disable-next-line eqeqeq
            return val1 == val2;
            return false;
        }
        if (val2 === null || _typeof(val2) !== "object") return false;
    }
    var val1Tag = objectToString(val1);
    var val2Tag = objectToString(val2);
    if (val1Tag !== val2Tag) return false;
    if (Array.isArray(val1)) {
        // Check for sparse arrays and general fast path
        if (val1.length !== val2.length) return false;
        var keys1 = getOwnNonIndexProperties(val1, ONLY_ENUMERABLE);
        var keys2 = getOwnNonIndexProperties(val2, ONLY_ENUMERABLE);
        if (keys1.length !== keys2.length) return false;
        return keyCheck(val1, val2, strict, memos, kIsArray, keys1);
    }
    // [browserify] This triggers on certain types in IE (Map/Set) so we don't
    // wan't to early return out of the rest of the checks. However we can check
    // if the second value is one of these values and the first isn't.
    if (val1Tag === "[object Object]") {
        // return keyCheck(val1, val2, strict, memos, kNoIterator);
        if (!isMap(val1) && isMap(val2) || !isSet(val1) && isSet(val2)) return false;
    }
    if (isDate(val1)) {
        if (!isDate(val2) || Date.prototype.getTime.call(val1) !== Date.prototype.getTime.call(val2)) return false;
    } else if (isRegExp(val1)) {
        if (!isRegExp(val2) || !areSimilarRegExps(val1, val2)) return false;
    } else if (isNativeError(val1) || val1 instanceof Error) {
        // Do not compare the stack as it might differ even though the error itself
        // is otherwise identical.
        if (val1.message !== val2.message || val1.name !== val2.name) return false;
    } else if (isArrayBufferView(val1)) {
        if (!strict && (isFloat32Array(val1) || isFloat64Array(val1))) {
            if (!areSimilarFloatArrays(val1, val2)) return false;
        } else if (!areSimilarTypedArrays(val1, val2)) return false;
        // Buffer.compare returns true, so val1.length === val2.length. If they both
        // only contain numeric keys, we don't need to exam further than checking
        // the symbols.
        var _keys = getOwnNonIndexProperties(val1, ONLY_ENUMERABLE);
        var _keys2 = getOwnNonIndexProperties(val2, ONLY_ENUMERABLE);
        if (_keys.length !== _keys2.length) return false;
        return keyCheck(val1, val2, strict, memos, kNoIterator, _keys);
    } else if (isSet(val1)) {
        if (!isSet(val2) || val1.size !== val2.size) return false;
        return keyCheck(val1, val2, strict, memos, kIsSet);
    } else if (isMap(val1)) {
        if (!isMap(val2) || val1.size !== val2.size) return false;
        return keyCheck(val1, val2, strict, memos, kIsMap);
    } else if (isAnyArrayBuffer(val1)) {
        if (!areEqualArrayBuffers(val1, val2)) return false;
    } else if (isBoxedPrimitive(val1) && !isEqualBoxedPrimitive(val1, val2)) return false;
    return keyCheck(val1, val2, strict, memos, kNoIterator);
}
function getEnumerables(val, keys) {
    return keys.filter(function(k) {
        return propertyIsEnumerable(val, k);
    });
}
function keyCheck(val1, val2, strict, memos, iterationType, aKeys) {
    // For all remaining Object pairs, including Array, objects and Maps,
    // equivalence is determined by having:
    // a) The same number of owned enumerable properties
    // b) The same set of keys/indexes (although not necessarily the same order)
    // c) Equivalent values for every corresponding key/index
    // d) For Sets and Maps, equal contents
    // Note: this accounts for both named and indexed properties on Arrays.
    if (arguments.length === 5) {
        aKeys = Object.keys(val1);
        var bKeys = Object.keys(val2);
        // The pair must have the same number of owned properties.
        if (aKeys.length !== bKeys.length) return false;
    }
    // Cheap key test
    var i = 0;
    for(; i < aKeys.length; i++){
        if (!hasOwnProperty(val2, aKeys[i])) return false;
    }
    if (strict && arguments.length === 5) {
        var symbolKeysA = objectGetOwnPropertySymbols(val1);
        if (symbolKeysA.length !== 0) {
            var count = 0;
            for(i = 0; i < symbolKeysA.length; i++){
                var key = symbolKeysA[i];
                if (propertyIsEnumerable(val1, key)) {
                    if (!propertyIsEnumerable(val2, key)) return false;
                    aKeys.push(key);
                    count++;
                } else if (propertyIsEnumerable(val2, key)) return false;
            }
            var symbolKeysB = objectGetOwnPropertySymbols(val2);
            if (symbolKeysA.length !== symbolKeysB.length && getEnumerables(val2, symbolKeysB).length !== count) return false;
        } else {
            var _symbolKeysB = objectGetOwnPropertySymbols(val2);
            if (_symbolKeysB.length !== 0 && getEnumerables(val2, _symbolKeysB).length !== 0) return false;
        }
    }
    if (aKeys.length === 0 && (iterationType === kNoIterator || iterationType === kIsArray && val1.length === 0 || val1.size === 0)) return true;
    // Use memos to handle cycles.
    if (memos === undefined) memos = {
        val1: new Map(),
        val2: new Map(),
        position: 0
    };
    else {
        // We prevent up to two map.has(x) calls by directly retrieving the value
        // and checking for undefined. The map can only contain numbers, so it is
        // safe to check for undefined only.
        var val2MemoA = memos.val1.get(val1);
        if (val2MemoA !== undefined) {
            var val2MemoB = memos.val2.get(val2);
            if (val2MemoB !== undefined) return val2MemoA === val2MemoB;
        }
        memos.position++;
    }
    memos.val1.set(val1, memos.position);
    memos.val2.set(val2, memos.position);
    var areEq = objEquiv(val1, val2, strict, aKeys, memos, iterationType);
    memos.val1.delete(val1);
    memos.val2.delete(val2);
    return areEq;
}
function setHasEqualElement(set, val1, strict, memo) {
    // Go looking.
    var setValues = arrayFromSet(set);
    for(var i = 0; i < setValues.length; i++){
        var val2 = setValues[i];
        if (innerDeepEqual(val1, val2, strict, memo)) {
            // Remove the matching element to make sure we do not check that again.
            set.delete(val2);
            return true;
        }
    }
    return false;
}
// See https://developer.mozilla.org/en-US/docs/Web/JavaScript/Equality_comparisons_and_sameness#Loose_equality_using
// Sadly it is not possible to detect corresponding values properly in case the
// type is a string, number, bigint or boolean. The reason is that those values
// can match lots of different string values (e.g., 1n == '+00001').
function findLooseMatchingPrimitives(prim) {
    switch(_typeof(prim)){
        case "undefined":
            return null;
        case "object":
            // Only pass in null as object!
            return undefined;
        case "symbol":
            return false;
        case "string":
            prim = +prim;
        // Loose equal entries exist only if the string is possible to convert to
        // a regular number and not NaN.
        // Fall through
        case "number":
            if (numberIsNaN(prim)) return false;
    }
    return true;
}
function setMightHaveLoosePrim(a, b, prim) {
    var altValue = findLooseMatchingPrimitives(prim);
    if (altValue != null) return altValue;
    return b.has(altValue) && !a.has(altValue);
}
function mapMightHaveLoosePrim(a, b, prim, item, memo) {
    var altValue = findLooseMatchingPrimitives(prim);
    if (altValue != null) return altValue;
    var curB = b.get(altValue);
    if (curB === undefined && !b.has(altValue) || !innerDeepEqual(item, curB, false, memo)) return false;
    return !a.has(altValue) && innerDeepEqual(item, curB, false, memo);
}
function setEquiv(a, b, strict, memo) {
    // This is a lazily initiated Set of entries which have to be compared
    // pairwise.
    var set = null;
    var aValues = arrayFromSet(a);
    for(var i = 0; i < aValues.length; i++){
        var val = aValues[i];
        // Note: Checking for the objects first improves the performance for object
        // heavy sets but it is a minor slow down for primitives. As they are fast
        // to check this improves the worst case scenario instead.
        if (_typeof(val) === "object" && val !== null) {
            if (set === null) set = new Set();
            // If the specified value doesn't exist in the second set its an not null
            // object (or non strict only: a not matching primitive) we'll need to go
            // hunting for something thats deep-(strict-)equal to it. To make this
            // O(n log n) complexity we have to copy these values in a new set first.
            set.add(val);
        } else if (!b.has(val)) {
            if (strict) return false;
            // Fast path to detect missing string, symbol, undefined and null values.
            if (!setMightHaveLoosePrim(a, b, val)) return false;
            if (set === null) set = new Set();
            set.add(val);
        }
    }
    if (set !== null) {
        var bValues = arrayFromSet(b);
        for(var _i = 0; _i < bValues.length; _i++){
            var _val = bValues[_i];
            // We have to check if a primitive value is already
            // matching and only if it's not, go hunting for it.
            if (_typeof(_val) === "object" && _val !== null) {
                if (!setHasEqualElement(set, _val, strict, memo)) return false;
            } else if (!strict && !a.has(_val) && !setHasEqualElement(set, _val, strict, memo)) return false;
        }
        return set.size === 0;
    }
    return true;
}
function mapHasEqualEntry(set, map, key1, item1, strict, memo) {
    // To be able to handle cases like:
    //   Map([[{}, 'a'], [{}, 'b']]) vs Map([[{}, 'b'], [{}, 'a']])
    // ... we need to consider *all* matching keys, not just the first we find.
    var setValues = arrayFromSet(set);
    for(var i = 0; i < setValues.length; i++){
        var key2 = setValues[i];
        if (innerDeepEqual(key1, key2, strict, memo) && innerDeepEqual(item1, map.get(key2), strict, memo)) {
            set.delete(key2);
            return true;
        }
    }
    return false;
}
function mapEquiv(a, b, strict, memo) {
    var set = null;
    var aEntries = arrayFromMap(a);
    for(var i = 0; i < aEntries.length; i++){
        var _aEntries$i = _slicedToArray(aEntries[i], 2), key = _aEntries$i[0], item1 = _aEntries$i[1];
        if (_typeof(key) === "object" && key !== null) {
            if (set === null) set = new Set();
            set.add(key);
        } else {
            // By directly retrieving the value we prevent another b.has(key) check in
            // almost all possible cases.
            var item2 = b.get(key);
            if (item2 === undefined && !b.has(key) || !innerDeepEqual(item1, item2, strict, memo)) {
                if (strict) return false;
                // Fast path to detect missing string, symbol, undefined and null
                // keys.
                if (!mapMightHaveLoosePrim(a, b, key, item1, memo)) return false;
                if (set === null) set = new Set();
                set.add(key);
            }
        }
    }
    if (set !== null) {
        var bEntries = arrayFromMap(b);
        for(var _i2 = 0; _i2 < bEntries.length; _i2++){
            var _bEntries$_i = _slicedToArray(bEntries[_i2], 2), _key = _bEntries$_i[0], item = _bEntries$_i[1];
            if (_typeof(_key) === "object" && _key !== null) {
                if (!mapHasEqualEntry(set, a, _key, item, strict, memo)) return false;
            } else if (!strict && (!a.has(_key) || !innerDeepEqual(a.get(_key), item, false, memo)) && !mapHasEqualEntry(set, a, _key, item, false, memo)) return false;
        }
        return set.size === 0;
    }
    return true;
}
function objEquiv(a, b, strict, keys, memos, iterationType) {
    // Sets and maps don't have their entries accessible via normal object
    // properties.
    var i = 0;
    if (iterationType === kIsSet) {
        if (!setEquiv(a, b, strict, memos)) return false;
    } else if (iterationType === kIsMap) {
        if (!mapEquiv(a, b, strict, memos)) return false;
    } else if (iterationType === kIsArray) for(; i < a.length; i++){
        if (hasOwnProperty(a, i)) {
            if (!hasOwnProperty(b, i) || !innerDeepEqual(a[i], b[i], strict, memos)) return false;
        } else if (hasOwnProperty(b, i)) return false;
        else {
            // Array is sparse.
            var keysA = Object.keys(a);
            for(; i < keysA.length; i++){
                var key = keysA[i];
                if (!hasOwnProperty(b, key) || !innerDeepEqual(a[key], b[key], strict, memos)) return false;
            }
            if (keysA.length !== Object.keys(b).length) return false;
            return true;
        }
    }
    // The pair must have equivalent values for every corresponding key.
    // Possibly expensive deep test:
    for(i = 0; i < keys.length; i++){
        var _key2 = keys[i];
        if (!innerDeepEqual(a[_key2], b[_key2], strict, memos)) return false;
    }
    return true;
}
function isDeepEqual(val1, val2) {
    return innerDeepEqual(val1, val2, kLoose);
}
function isDeepStrictEqual(val1, val2) {
    return innerDeepEqual(val1, val2, kStrict);
}
module.exports = {
    isDeepEqual: isDeepEqual,
    isDeepStrictEqual: isDeepStrictEqual
};

},{"3addb16fbdd05c1c":"bToc8","a27e57a3fd2e2e23":"a3ssb","4940125679601087":"jInrX"}],"bToc8":[function(require,module,exports) {
"use strict";
var define = require("7a0bb7df335a6af");
var callBind = require("794ce1103c4a65ba");
var implementation = require("f52a71fcf365d3bd");
var getPolyfill = require("59addbaef079e040");
var shim = require("c0e8b0f7342ba484");
var polyfill = callBind(getPolyfill(), Object);
define(polyfill, {
    getPolyfill: getPolyfill,
    implementation: implementation,
    shim: shim
});
module.exports = polyfill;

},{"7a0bb7df335a6af":"eEkhr","794ce1103c4a65ba":"8iKie","f52a71fcf365d3bd":"epWtd","59addbaef079e040":"jCZAj","c0e8b0f7342ba484":"heKHd"}],"eEkhr":[function(require,module,exports) {
"use strict";
var keys = require("7ff177585d1618f0");
var hasSymbols = typeof Symbol === "function" && typeof Symbol("foo") === "symbol";
var toStr = Object.prototype.toString;
var concat = Array.prototype.concat;
var defineDataProperty = require("84ca194f5a28ce70");
var isFunction = function(fn) {
    return typeof fn === "function" && toStr.call(fn) === "[object Function]";
};
var supportsDescriptors = require("c52d62086511583f")();
var defineProperty = function(object, name, value, predicate) {
    if (name in object) {
        if (predicate === true) {
            if (object[name] === value) return;
        } else if (!isFunction(predicate) || !predicate()) return;
    }
    if (supportsDescriptors) defineDataProperty(object, name, value, true);
    else defineDataProperty(object, name, value);
};
var defineProperties = function(object, map) {
    var predicates = arguments.length > 2 ? arguments[2] : {};
    var props = keys(map);
    if (hasSymbols) props = concat.call(props, Object.getOwnPropertySymbols(map));
    for(var i = 0; i < props.length; i += 1)defineProperty(object, props[i], map[props[i]], predicates[props[i]]);
};
defineProperties.supportsDescriptors = !!supportsDescriptors;
module.exports = defineProperties;

},{"7ff177585d1618f0":"3gfZs","84ca194f5a28ce70":"1VH5F","c52d62086511583f":"h7wkG"}],"heKHd":[function(require,module,exports) {
"use strict";
var getPolyfill = require("f188d636391a5061");
var define = require("155865cffc557cd");
module.exports = function shimObjectIs() {
    var polyfill = getPolyfill();
    define(Object, {
        is: polyfill
    }, {
        is: function testObjectIs() {
            return Object.is !== polyfill;
        }
    });
    return polyfill;
};

},{"f188d636391a5061":"jCZAj","155865cffc557cd":"eEkhr"}],"a3ssb":[function(require,module,exports) {
"use strict";
var callBind = require("8bc778ead6edc2b");
var define = require("1e9a111647ec40d6");
var implementation = require("db9e8266e38a0a1c");
var getPolyfill = require("37ae20d268339d21");
var shim = require("9fe13ad91d3d9c68");
var polyfill = callBind(getPolyfill(), Number);
/* http://www.ecma-international.org/ecma-262/6.0/#sec-number.isnan */ define(polyfill, {
    getPolyfill: getPolyfill,
    implementation: implementation,
    shim: shim
});
module.exports = polyfill;

},{"8bc778ead6edc2b":"8iKie","1e9a111647ec40d6":"eEkhr","db9e8266e38a0a1c":"hc3R8","37ae20d268339d21":"kIW67","9fe13ad91d3d9c68":"aiotY"}],"hc3R8":[function(require,module,exports) {
"use strict";
/* http://www.ecma-international.org/ecma-262/6.0/#sec-number.isnan */ module.exports = function isNaN(value) {
    return value !== value;
};

},{}],"kIW67":[function(require,module,exports) {
"use strict";
var implementation = require("e25466f067cfd8fc");
module.exports = function getPolyfill() {
    if (Number.isNaN && Number.isNaN(NaN) && !Number.isNaN("a")) return Number.isNaN;
    return implementation;
};

},{"e25466f067cfd8fc":"hc3R8"}],"aiotY":[function(require,module,exports) {
"use strict";
var define = require("6e613ddb8bace1c6");
var getPolyfill = require("f2ce5ac0488eb372");
/* http://www.ecma-international.org/ecma-262/6.0/#sec-number.isnan */ module.exports = function shimNumberIsNaN() {
    var polyfill = getPolyfill();
    define(Number, {
        isNaN: polyfill
    }, {
        isNaN: function testIsNaN() {
            return Number.isNaN !== polyfill;
        }
    });
    return polyfill;
};

},{"6e613ddb8bace1c6":"eEkhr","f2ce5ac0488eb372":"kIW67"}],"f9npt":[function(require,module,exports) {
"use strict";
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
function ZStream() {
    /* next input byte */ this.input = null; // JS specific, because we have no pointers
    this.next_in = 0;
    /* number of bytes available at input */ this.avail_in = 0;
    /* total number of input bytes read so far */ this.total_in = 0;
    /* next output byte should be put there */ this.output = null; // JS specific, because we have no pointers
    this.next_out = 0;
    /* remaining free space at output */ this.avail_out = 0;
    /* total number of bytes output so far */ this.total_out = 0;
    /* last error message, NULL if no error */ this.msg = "" /*Z_NULL*/ ;
    /* not visible by applications */ this.state = null;
    /* best guess about the data type: binary or text */ this.data_type = 2 /*Z_UNKNOWN*/ ;
    /* adler32 value of the uncompressed data */ this.adler = 0;
}
module.exports = ZStream;

},{}],"3t1Bq":[function(require,module,exports) {
"use strict";
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
var utils = require("6ecd050ab5cf9e92");
var trees = require("b17b4660c9a756a1");
var adler32 = require("8a0173ce93724f81");
var crc32 = require("9fe740ea87b93669");
var msg = require("86729d90d4373c72");
/* Public constants ==========================================================*/ /* ===========================================================================*/ /* Allowed flush values; see deflate() and inflate() below for details */ var Z_NO_FLUSH = 0;
var Z_PARTIAL_FLUSH = 1;
//var Z_SYNC_FLUSH    = 2;
var Z_FULL_FLUSH = 3;
var Z_FINISH = 4;
var Z_BLOCK = 5;
//var Z_TREES         = 6;
/* Return codes for the compression/decompression functions. Negative values
 * are errors, positive values are used for special but normal events.
 */ var Z_OK = 0;
var Z_STREAM_END = 1;
//var Z_NEED_DICT     = 2;
//var Z_ERRNO         = -1;
var Z_STREAM_ERROR = -2;
var Z_DATA_ERROR = -3;
//var Z_MEM_ERROR     = -4;
var Z_BUF_ERROR = -5;
//var Z_VERSION_ERROR = -6;
/* compression levels */ //var Z_NO_COMPRESSION      = 0;
//var Z_BEST_SPEED          = 1;
//var Z_BEST_COMPRESSION    = 9;
var Z_DEFAULT_COMPRESSION = -1;
var Z_FILTERED = 1;
var Z_HUFFMAN_ONLY = 2;
var Z_RLE = 3;
var Z_FIXED = 4;
var Z_DEFAULT_STRATEGY = 0;
/* Possible values of the data_type field (though see inflate()) */ //var Z_BINARY              = 0;
//var Z_TEXT                = 1;
//var Z_ASCII               = 1; // = Z_TEXT
var Z_UNKNOWN = 2;
/* The deflate compression method */ var Z_DEFLATED = 8;
/*============================================================================*/ var MAX_MEM_LEVEL = 9;
/* Maximum value for memLevel in deflateInit2 */ var MAX_WBITS = 15;
/* 32K LZ77 window */ var DEF_MEM_LEVEL = 8;
var LENGTH_CODES = 29;
/* number of length codes, not counting the special END_BLOCK code */ var LITERALS = 256;
/* number of literal bytes 0..255 */ var L_CODES = LITERALS + 1 + LENGTH_CODES;
/* number of Literal or Length codes, including the END_BLOCK code */ var D_CODES = 30;
/* number of distance codes */ var BL_CODES = 19;
/* number of codes used to transfer the bit lengths */ var HEAP_SIZE = 2 * L_CODES + 1;
/* maximum heap size */ var MAX_BITS = 15;
/* All codes must not exceed MAX_BITS bits */ var MIN_MATCH = 3;
var MAX_MATCH = 258;
var MIN_LOOKAHEAD = MAX_MATCH + MIN_MATCH + 1;
var PRESET_DICT = 0x20;
var INIT_STATE = 42;
var EXTRA_STATE = 69;
var NAME_STATE = 73;
var COMMENT_STATE = 91;
var HCRC_STATE = 103;
var BUSY_STATE = 113;
var FINISH_STATE = 666;
var BS_NEED_MORE = 1; /* block not completed, need more input or more output */ 
var BS_BLOCK_DONE = 2; /* block flush performed */ 
var BS_FINISH_STARTED = 3; /* finish started, need only more output at next deflate */ 
var BS_FINISH_DONE = 4; /* finish done, accept no more input or output */ 
var OS_CODE = 0x03; // Unix :) . Don't detect, use this default.
function err(strm, errorCode) {
    strm.msg = msg[errorCode];
    return errorCode;
}
function rank(f) {
    return (f << 1) - (f > 4 ? 9 : 0);
}
function zero(buf) {
    var len = buf.length;
    while(--len >= 0)buf[len] = 0;
}
/* =========================================================================
 * Flush as much pending output as possible. All deflate() output goes
 * through this function so some applications may wish to modify it
 * to avoid allocating a large strm->output buffer and copying into it.
 * (See also read_buf()).
 */ function flush_pending(strm) {
    var s = strm.state;
    //_tr_flush_bits(s);
    var len = s.pending;
    if (len > strm.avail_out) len = strm.avail_out;
    if (len === 0) return;
    utils.arraySet(strm.output, s.pending_buf, s.pending_out, len, strm.next_out);
    strm.next_out += len;
    s.pending_out += len;
    strm.total_out += len;
    strm.avail_out -= len;
    s.pending -= len;
    if (s.pending === 0) s.pending_out = 0;
}
function flush_block_only(s, last) {
    trees._tr_flush_block(s, s.block_start >= 0 ? s.block_start : -1, s.strstart - s.block_start, last);
    s.block_start = s.strstart;
    flush_pending(s.strm);
}
function put_byte(s, b) {
    s.pending_buf[s.pending++] = b;
}
/* =========================================================================
 * Put a short in the pending buffer. The 16-bit value is put in MSB order.
 * IN assertion: the stream state is correct and there is enough room in
 * pending_buf.
 */ function putShortMSB(s, b) {
    //  put_byte(s, (Byte)(b >> 8));
    //  put_byte(s, (Byte)(b & 0xff));
    s.pending_buf[s.pending++] = b >>> 8 & 0xff;
    s.pending_buf[s.pending++] = b & 0xff;
}
/* ===========================================================================
 * Read a new buffer from the current input stream, update the adler32
 * and total number of bytes read.  All deflate() input goes through
 * this function so some applications may wish to modify it to avoid
 * allocating a large strm->input buffer and copying from it.
 * (See also flush_pending()).
 */ function read_buf(strm, buf, start, size) {
    var len = strm.avail_in;
    if (len > size) len = size;
    if (len === 0) return 0;
    strm.avail_in -= len;
    // zmemcpy(buf, strm->next_in, len);
    utils.arraySet(buf, strm.input, strm.next_in, len, start);
    if (strm.state.wrap === 1) strm.adler = adler32(strm.adler, buf, len, start);
    else if (strm.state.wrap === 2) strm.adler = crc32(strm.adler, buf, len, start);
    strm.next_in += len;
    strm.total_in += len;
    return len;
}
/* ===========================================================================
 * Set match_start to the longest match starting at the given string and
 * return its length. Matches shorter or equal to prev_length are discarded,
 * in which case the result is equal to prev_length and match_start is
 * garbage.
 * IN assertions: cur_match is the head of the hash chain for the current
 *   string (strstart) and its distance is <= MAX_DIST, and prev_length >= 1
 * OUT assertion: the match length is not greater than s->lookahead.
 */ function longest_match(s, cur_match) {
    var chain_length = s.max_chain_length; /* max hash chain length */ 
    var scan = s.strstart; /* current string */ 
    var match; /* matched string */ 
    var len; /* length of current match */ 
    var best_len = s.prev_length; /* best match length so far */ 
    var nice_match = s.nice_match; /* stop if match long enough */ 
    var limit = s.strstart > s.w_size - MIN_LOOKAHEAD ? s.strstart - (s.w_size - MIN_LOOKAHEAD) : 0 /*NIL*/ ;
    var _win = s.window; // shortcut
    var wmask = s.w_mask;
    var prev = s.prev;
    /* Stop when cur_match becomes <= limit. To simplify the code,
   * we prevent matches with the string of window index 0.
   */ var strend = s.strstart + MAX_MATCH;
    var scan_end1 = _win[scan + best_len - 1];
    var scan_end = _win[scan + best_len];
    /* The code is optimized for HASH_BITS >= 8 and MAX_MATCH-2 multiple of 16.
   * It is easy to get rid of this optimization if necessary.
   */ // Assert(s->hash_bits >= 8 && MAX_MATCH == 258, "Code too clever");
    /* Do not waste too much time if we already have a good match: */ if (s.prev_length >= s.good_match) chain_length >>= 2;
    /* Do not look for matches beyond the end of the input. This is necessary
   * to make deflate deterministic.
   */ if (nice_match > s.lookahead) nice_match = s.lookahead;
    // Assert((ulg)s->strstart <= s->window_size-MIN_LOOKAHEAD, "need lookahead");
    do {
        // Assert(cur_match < s->strstart, "no future");
        match = cur_match;
        /* Skip to next match if the match length cannot increase
     * or if the match length is less than 2.  Note that the checks below
     * for insufficient lookahead only occur occasionally for performance
     * reasons.  Therefore uninitialized memory will be accessed, and
     * conditional jumps will be made that depend on those values.
     * However the length of the match is limited to the lookahead, so
     * the output of deflate is not affected by the uninitialized values.
     */ if (_win[match + best_len] !== scan_end || _win[match + best_len - 1] !== scan_end1 || _win[match] !== _win[scan] || _win[++match] !== _win[scan + 1]) continue;
        /* The check at best_len-1 can be removed because it will be made
     * again later. (This heuristic is not always a win.)
     * It is not necessary to compare scan[2] and match[2] since they
     * are always equal when the other bytes match, given that
     * the hash keys are equal and that HASH_BITS >= 8.
     */ scan += 2;
        match++;
        // Assert(*scan == *match, "match[2]?");
        /* We check for insufficient lookahead only every 8th comparison;
     * the 256th check will be made at strstart+258.
     */ do ;
        while (_win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && scan < strend);
        // Assert(scan <= s->window+(unsigned)(s->window_size-1), "wild scan");
        len = MAX_MATCH - (strend - scan);
        scan = strend - MAX_MATCH;
        if (len > best_len) {
            s.match_start = cur_match;
            best_len = len;
            if (len >= nice_match) break;
            scan_end1 = _win[scan + best_len - 1];
            scan_end = _win[scan + best_len];
        }
    }while ((cur_match = prev[cur_match & wmask]) > limit && --chain_length !== 0);
    if (best_len <= s.lookahead) return best_len;
    return s.lookahead;
}
/* ===========================================================================
 * Fill the window when the lookahead becomes insufficient.
 * Updates strstart and lookahead.
 *
 * IN assertion: lookahead < MIN_LOOKAHEAD
 * OUT assertions: strstart <= window_size-MIN_LOOKAHEAD
 *    At least one byte has been read, or avail_in == 0; reads are
 *    performed for at least two bytes (required for the zip translate_eol
 *    option -- not supported here).
 */ function fill_window(s) {
    var _w_size = s.w_size;
    var p, n, m, more, str;
    //Assert(s->lookahead < MIN_LOOKAHEAD, "already enough lookahead");
    do {
        more = s.window_size - s.lookahead - s.strstart;
        // JS ints have 32 bit, block below not needed
        /* Deal with !@#$% 64K limit: */ //if (sizeof(int) <= 2) {
        //    if (more == 0 && s->strstart == 0 && s->lookahead == 0) {
        //        more = wsize;
        //
        //  } else if (more == (unsigned)(-1)) {
        //        /* Very unlikely, but possible on 16 bit machine if
        //         * strstart == 0 && lookahead == 1 (input done a byte at time)
        //         */
        //        more--;
        //    }
        //}
        /* If the window is almost full and there is insufficient lookahead,
     * move the upper half to the lower one to make room in the upper half.
     */ if (s.strstart >= _w_size + (_w_size - MIN_LOOKAHEAD)) {
            utils.arraySet(s.window, s.window, _w_size, _w_size, 0);
            s.match_start -= _w_size;
            s.strstart -= _w_size;
            /* we now have strstart >= MAX_DIST */ s.block_start -= _w_size;
            /* Slide the hash table (could be avoided with 32 bit values
       at the expense of memory usage). We slide even when level == 0
       to keep the hash table consistent if we switch back to level > 0
       later. (Using level 0 permanently is not an optimal usage of
       zlib, so we don't care about this pathological case.)
       */ n = s.hash_size;
            p = n;
            do {
                m = s.head[--p];
                s.head[p] = m >= _w_size ? m - _w_size : 0;
            }while (--n);
            n = _w_size;
            p = n;
            do {
                m = s.prev[--p];
                s.prev[p] = m >= _w_size ? m - _w_size : 0;
            /* If n is not on any hash chain, prev[n] is garbage but
         * its value will never be used.
         */ }while (--n);
            more += _w_size;
        }
        if (s.strm.avail_in === 0) break;
        /* If there was no sliding:
     *    strstart <= WSIZE+MAX_DIST-1 && lookahead <= MIN_LOOKAHEAD - 1 &&
     *    more == window_size - lookahead - strstart
     * => more >= window_size - (MIN_LOOKAHEAD-1 + WSIZE + MAX_DIST-1)
     * => more >= window_size - 2*WSIZE + 2
     * In the BIG_MEM or MMAP case (not yet supported),
     *   window_size == input_size + MIN_LOOKAHEAD  &&
     *   strstart + s->lookahead <= input_size => more >= MIN_LOOKAHEAD.
     * Otherwise, window_size == 2*WSIZE so more >= 2.
     * If there was sliding, more >= WSIZE. So in all cases, more >= 2.
     */ //Assert(more >= 2, "more < 2");
        n = read_buf(s.strm, s.window, s.strstart + s.lookahead, more);
        s.lookahead += n;
        /* Initialize the hash value now that we have some input: */ if (s.lookahead + s.insert >= MIN_MATCH) {
            str = s.strstart - s.insert;
            s.ins_h = s.window[str];
            /* UPDATE_HASH(s, s->ins_h, s->window[str + 1]); */ s.ins_h = (s.ins_h << s.hash_shift ^ s.window[str + 1]) & s.hash_mask;
            //#if MIN_MATCH != 3
            //        Call update_hash() MIN_MATCH-3 more times
            //#endif
            while(s.insert){
                /* UPDATE_HASH(s, s->ins_h, s->window[str + MIN_MATCH-1]); */ s.ins_h = (s.ins_h << s.hash_shift ^ s.window[str + MIN_MATCH - 1]) & s.hash_mask;
                s.prev[str & s.w_mask] = s.head[s.ins_h];
                s.head[s.ins_h] = str;
                str++;
                s.insert--;
                if (s.lookahead + s.insert < MIN_MATCH) break;
            }
        }
    /* If the whole input has less than MIN_MATCH bytes, ins_h is garbage,
     * but this is not important since only literal bytes will be emitted.
     */ }while (s.lookahead < MIN_LOOKAHEAD && s.strm.avail_in !== 0);
/* If the WIN_INIT bytes after the end of the current data have never been
   * written, then zero those bytes in order to avoid memory check reports of
   * the use of uninitialized (or uninitialised as Julian writes) bytes by
   * the longest match routines.  Update the high water mark for the next
   * time through here.  WIN_INIT is set to MAX_MATCH since the longest match
   * routines allow scanning to strstart + MAX_MATCH, ignoring lookahead.
   */ //  if (s.high_water < s.window_size) {
//    var curr = s.strstart + s.lookahead;
//    var init = 0;
//
//    if (s.high_water < curr) {
//      /* Previous high water mark below current data -- zero WIN_INIT
//       * bytes or up to end of window, whichever is less.
//       */
//      init = s.window_size - curr;
//      if (init > WIN_INIT)
//        init = WIN_INIT;
//      zmemzero(s->window + curr, (unsigned)init);
//      s->high_water = curr + init;
//    }
//    else if (s->high_water < (ulg)curr + WIN_INIT) {
//      /* High water mark at or above current data, but below current data
//       * plus WIN_INIT -- zero out to current data plus WIN_INIT, or up
//       * to end of window, whichever is less.
//       */
//      init = (ulg)curr + WIN_INIT - s->high_water;
//      if (init > s->window_size - s->high_water)
//        init = s->window_size - s->high_water;
//      zmemzero(s->window + s->high_water, (unsigned)init);
//      s->high_water += init;
//    }
//  }
//
//  Assert((ulg)s->strstart <= s->window_size - MIN_LOOKAHEAD,
//    "not enough room for search");
}
/* ===========================================================================
 * Copy without compression as much as possible from the input stream, return
 * the current block state.
 * This function does not insert new strings in the dictionary since
 * uncompressible data is probably not useful. This function is used
 * only for the level=0 compression option.
 * NOTE: this function should be optimized to avoid extra copying from
 * window to pending_buf.
 */ function deflate_stored(s, flush) {
    /* Stored blocks are limited to 0xffff bytes, pending_buf is limited
   * to pending_buf_size, and each stored block has a 5 byte header:
   */ var max_block_size = 0xffff;
    if (max_block_size > s.pending_buf_size - 5) max_block_size = s.pending_buf_size - 5;
    /* Copy as much as possible from input to output: */ for(;;){
        /* Fill the window as much as possible: */ if (s.lookahead <= 1) {
            //Assert(s->strstart < s->w_size+MAX_DIST(s) ||
            //  s->block_start >= (long)s->w_size, "slide too late");
            //      if (!(s.strstart < s.w_size + (s.w_size - MIN_LOOKAHEAD) ||
            //        s.block_start >= s.w_size)) {
            //        throw  new Error("slide too late");
            //      }
            fill_window(s);
            if (s.lookahead === 0 && flush === Z_NO_FLUSH) return BS_NEED_MORE;
            if (s.lookahead === 0) break;
        /* flush the current block */ }
        //Assert(s->block_start >= 0L, "block gone");
        //    if (s.block_start < 0) throw new Error("block gone");
        s.strstart += s.lookahead;
        s.lookahead = 0;
        /* Emit a stored block if pending_buf will be full: */ var max_start = s.block_start + max_block_size;
        if (s.strstart === 0 || s.strstart >= max_start) {
            /* strstart == 0 is possible when wraparound on 16-bit machine */ s.lookahead = s.strstart - max_start;
            s.strstart = max_start;
            /*** FLUSH_BLOCK(s, 0); ***/ flush_block_only(s, false);
            if (s.strm.avail_out === 0) return BS_NEED_MORE;
        /***/ }
        /* Flush if we may have to slide, otherwise block_start may become
     * negative and the data will be gone:
     */ if (s.strstart - s.block_start >= s.w_size - MIN_LOOKAHEAD) {
            /*** FLUSH_BLOCK(s, 0); ***/ flush_block_only(s, false);
            if (s.strm.avail_out === 0) return BS_NEED_MORE;
        /***/ }
    }
    s.insert = 0;
    if (flush === Z_FINISH) {
        /*** FLUSH_BLOCK(s, 1); ***/ flush_block_only(s, true);
        if (s.strm.avail_out === 0) return BS_FINISH_STARTED;
        /***/ return BS_FINISH_DONE;
    }
    if (s.strstart > s.block_start) {
        /*** FLUSH_BLOCK(s, 0); ***/ flush_block_only(s, false);
        if (s.strm.avail_out === 0) return BS_NEED_MORE;
    /***/ }
    return BS_NEED_MORE;
}
/* ===========================================================================
 * Compress as much as possible from the input stream, return the current
 * block state.
 * This function does not perform lazy evaluation of matches and inserts
 * new strings in the dictionary only for unmatched strings or for short
 * matches. It is used only for the fast compression options.
 */ function deflate_fast(s, flush) {
    var hash_head; /* head of the hash chain */ 
    var bflush; /* set if current block must be flushed */ 
    for(;;){
        /* Make sure that we always have enough lookahead, except
     * at the end of the input file. We need MAX_MATCH bytes
     * for the next match, plus MIN_MATCH bytes to insert the
     * string following the next match.
     */ if (s.lookahead < MIN_LOOKAHEAD) {
            fill_window(s);
            if (s.lookahead < MIN_LOOKAHEAD && flush === Z_NO_FLUSH) return BS_NEED_MORE;
            if (s.lookahead === 0) break; /* flush the current block */ 
        }
        /* Insert the string window[strstart .. strstart+2] in the
     * dictionary, and set hash_head to the head of the hash chain:
     */ hash_head = 0 /*NIL*/ ;
        if (s.lookahead >= MIN_MATCH) {
            /*** INSERT_STRING(s, s.strstart, hash_head); ***/ s.ins_h = (s.ins_h << s.hash_shift ^ s.window[s.strstart + MIN_MATCH - 1]) & s.hash_mask;
            hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
            s.head[s.ins_h] = s.strstart;
        /***/ }
        /* Find the longest match, discarding those <= prev_length.
     * At this point we have always match_length < MIN_MATCH
     */ if (hash_head !== 0 /*NIL*/  && s.strstart - hash_head <= s.w_size - MIN_LOOKAHEAD) /* To simplify the code, we prevent matches with the string
       * of window index 0 (in particular we have to avoid a match
       * of the string with itself at the start of the input file).
       */ s.match_length = longest_match(s, hash_head);
        if (s.match_length >= MIN_MATCH) {
            // check_match(s, s.strstart, s.match_start, s.match_length); // for debug only
            /*** _tr_tally_dist(s, s.strstart - s.match_start,
                     s.match_length - MIN_MATCH, bflush); ***/ bflush = trees._tr_tally(s, s.strstart - s.match_start, s.match_length - MIN_MATCH);
            s.lookahead -= s.match_length;
            /* Insert new strings in the hash table only if the match length
       * is not too large. This saves time but degrades compression.
       */ if (s.match_length <= s.max_lazy_match /*max_insert_length*/  && s.lookahead >= MIN_MATCH) {
                s.match_length--; /* string at strstart already in table */ 
                do {
                    s.strstart++;
                    /*** INSERT_STRING(s, s.strstart, hash_head); ***/ s.ins_h = (s.ins_h << s.hash_shift ^ s.window[s.strstart + MIN_MATCH - 1]) & s.hash_mask;
                    hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
                    s.head[s.ins_h] = s.strstart;
                /***/ /* strstart never exceeds WSIZE-MAX_MATCH, so there are
           * always MIN_MATCH bytes ahead.
           */ }while (--s.match_length !== 0);
                s.strstart++;
            } else {
                s.strstart += s.match_length;
                s.match_length = 0;
                s.ins_h = s.window[s.strstart];
                /* UPDATE_HASH(s, s.ins_h, s.window[s.strstart+1]); */ s.ins_h = (s.ins_h << s.hash_shift ^ s.window[s.strstart + 1]) & s.hash_mask;
            //#if MIN_MATCH != 3
            //                Call UPDATE_HASH() MIN_MATCH-3 more times
            //#endif
            /* If lookahead < MIN_MATCH, ins_h is garbage, but it does not
         * matter since it will be recomputed at next deflate call.
         */ }
        } else {
            /* No match, output a literal byte */ //Tracevv((stderr,"%c", s.window[s.strstart]));
            /*** _tr_tally_lit(s, s.window[s.strstart], bflush); ***/ bflush = trees._tr_tally(s, 0, s.window[s.strstart]);
            s.lookahead--;
            s.strstart++;
        }
        if (bflush) {
            /*** FLUSH_BLOCK(s, 0); ***/ flush_block_only(s, false);
            if (s.strm.avail_out === 0) return BS_NEED_MORE;
        /***/ }
    }
    s.insert = s.strstart < MIN_MATCH - 1 ? s.strstart : MIN_MATCH - 1;
    if (flush === Z_FINISH) {
        /*** FLUSH_BLOCK(s, 1); ***/ flush_block_only(s, true);
        if (s.strm.avail_out === 0) return BS_FINISH_STARTED;
        /***/ return BS_FINISH_DONE;
    }
    if (s.last_lit) {
        /*** FLUSH_BLOCK(s, 0); ***/ flush_block_only(s, false);
        if (s.strm.avail_out === 0) return BS_NEED_MORE;
    /***/ }
    return BS_BLOCK_DONE;
}
/* ===========================================================================
 * Same as above, but achieves better compression. We use a lazy
 * evaluation for matches: a match is finally adopted only if there is
 * no better match at the next window position.
 */ function deflate_slow(s, flush) {
    var hash_head; /* head of hash chain */ 
    var bflush; /* set if current block must be flushed */ 
    var max_insert;
    /* Process the input block. */ for(;;){
        /* Make sure that we always have enough lookahead, except
     * at the end of the input file. We need MAX_MATCH bytes
     * for the next match, plus MIN_MATCH bytes to insert the
     * string following the next match.
     */ if (s.lookahead < MIN_LOOKAHEAD) {
            fill_window(s);
            if (s.lookahead < MIN_LOOKAHEAD && flush === Z_NO_FLUSH) return BS_NEED_MORE;
            if (s.lookahead === 0) break;
             /* flush the current block */ 
        }
        /* Insert the string window[strstart .. strstart+2] in the
     * dictionary, and set hash_head to the head of the hash chain:
     */ hash_head = 0 /*NIL*/ ;
        if (s.lookahead >= MIN_MATCH) {
            /*** INSERT_STRING(s, s.strstart, hash_head); ***/ s.ins_h = (s.ins_h << s.hash_shift ^ s.window[s.strstart + MIN_MATCH - 1]) & s.hash_mask;
            hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
            s.head[s.ins_h] = s.strstart;
        /***/ }
        /* Find the longest match, discarding those <= prev_length.
     */ s.prev_length = s.match_length;
        s.prev_match = s.match_start;
        s.match_length = MIN_MATCH - 1;
        if (hash_head !== 0 /*NIL*/  && s.prev_length < s.max_lazy_match && s.strstart - hash_head <= s.w_size - MIN_LOOKAHEAD) {
            /* To simplify the code, we prevent matches with the string
       * of window index 0 (in particular we have to avoid a match
       * of the string with itself at the start of the input file).
       */ s.match_length = longest_match(s, hash_head);
            /* longest_match() sets match_start */ if (s.match_length <= 5 && (s.strategy === Z_FILTERED || s.match_length === MIN_MATCH && s.strstart - s.match_start > 4096 /*TOO_FAR*/ )) /* If prev_match is also MIN_MATCH, match_start is garbage
         * but we will ignore the current match anyway.
         */ s.match_length = MIN_MATCH - 1;
        }
        /* If there was a match at the previous step and the current
     * match is not better, output the previous match:
     */ if (s.prev_length >= MIN_MATCH && s.match_length <= s.prev_length) {
            max_insert = s.strstart + s.lookahead - MIN_MATCH;
            /* Do not insert strings in hash table beyond this. */ //check_match(s, s.strstart-1, s.prev_match, s.prev_length);
            /***_tr_tally_dist(s, s.strstart - 1 - s.prev_match,
                     s.prev_length - MIN_MATCH, bflush);***/ bflush = trees._tr_tally(s, s.strstart - 1 - s.prev_match, s.prev_length - MIN_MATCH);
            /* Insert in hash table all strings up to the end of the match.
       * strstart-1 and strstart are already inserted. If there is not
       * enough lookahead, the last two strings are not inserted in
       * the hash table.
       */ s.lookahead -= s.prev_length - 1;
            s.prev_length -= 2;
            do if (++s.strstart <= max_insert) {
                /*** INSERT_STRING(s, s.strstart, hash_head); ***/ s.ins_h = (s.ins_h << s.hash_shift ^ s.window[s.strstart + MIN_MATCH - 1]) & s.hash_mask;
                hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
                s.head[s.ins_h] = s.strstart;
            /***/ }
            while (--s.prev_length !== 0);
            s.match_available = 0;
            s.match_length = MIN_MATCH - 1;
            s.strstart++;
            if (bflush) {
                /*** FLUSH_BLOCK(s, 0); ***/ flush_block_only(s, false);
                if (s.strm.avail_out === 0) return BS_NEED_MORE;
            /***/ }
        } else if (s.match_available) {
            /* If there was no match at the previous position, output a
       * single literal. If there was a match but the current match
       * is longer, truncate the previous match to a single literal.
       */ //Tracevv((stderr,"%c", s->window[s->strstart-1]));
            /*** _tr_tally_lit(s, s.window[s.strstart-1], bflush); ***/ bflush = trees._tr_tally(s, 0, s.window[s.strstart - 1]);
            if (bflush) /*** FLUSH_BLOCK_ONLY(s, 0) ***/ flush_block_only(s, false);
            s.strstart++;
            s.lookahead--;
            if (s.strm.avail_out === 0) return BS_NEED_MORE;
        } else {
            /* There is no previous match to compare with, wait for
       * the next step to decide.
       */ s.match_available = 1;
            s.strstart++;
            s.lookahead--;
        }
    }
    //Assert (flush != Z_NO_FLUSH, "no flush?");
    if (s.match_available) {
        //Tracevv((stderr,"%c", s->window[s->strstart-1]));
        /*** _tr_tally_lit(s, s.window[s.strstart-1], bflush); ***/ bflush = trees._tr_tally(s, 0, s.window[s.strstart - 1]);
        s.match_available = 0;
    }
    s.insert = s.strstart < MIN_MATCH - 1 ? s.strstart : MIN_MATCH - 1;
    if (flush === Z_FINISH) {
        /*** FLUSH_BLOCK(s, 1); ***/ flush_block_only(s, true);
        if (s.strm.avail_out === 0) return BS_FINISH_STARTED;
        /***/ return BS_FINISH_DONE;
    }
    if (s.last_lit) {
        /*** FLUSH_BLOCK(s, 0); ***/ flush_block_only(s, false);
        if (s.strm.avail_out === 0) return BS_NEED_MORE;
    /***/ }
    return BS_BLOCK_DONE;
}
/* ===========================================================================
 * For Z_RLE, simply look for runs of bytes, generate matches only of distance
 * one.  Do not maintain a hash table.  (It will be regenerated if this run of
 * deflate switches away from Z_RLE.)
 */ function deflate_rle(s, flush) {
    var bflush; /* set if current block must be flushed */ 
    var prev; /* byte at distance one to match */ 
    var scan, strend; /* scan goes up to strend for length of run */ 
    var _win = s.window;
    for(;;){
        /* Make sure that we always have enough lookahead, except
     * at the end of the input file. We need MAX_MATCH bytes
     * for the longest run, plus one for the unrolled loop.
     */ if (s.lookahead <= MAX_MATCH) {
            fill_window(s);
            if (s.lookahead <= MAX_MATCH && flush === Z_NO_FLUSH) return BS_NEED_MORE;
            if (s.lookahead === 0) break;
             /* flush the current block */ 
        }
        /* See how many times the previous byte repeats */ s.match_length = 0;
        if (s.lookahead >= MIN_MATCH && s.strstart > 0) {
            scan = s.strstart - 1;
            prev = _win[scan];
            if (prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan]) {
                strend = s.strstart + MAX_MATCH;
                do ;
                while (prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && scan < strend);
                s.match_length = MAX_MATCH - (strend - scan);
                if (s.match_length > s.lookahead) s.match_length = s.lookahead;
            }
        //Assert(scan <= s->window+(uInt)(s->window_size-1), "wild scan");
        }
        /* Emit match if have run of MIN_MATCH or longer, else emit literal */ if (s.match_length >= MIN_MATCH) {
            //check_match(s, s.strstart, s.strstart - 1, s.match_length);
            /*** _tr_tally_dist(s, 1, s.match_length - MIN_MATCH, bflush); ***/ bflush = trees._tr_tally(s, 1, s.match_length - MIN_MATCH);
            s.lookahead -= s.match_length;
            s.strstart += s.match_length;
            s.match_length = 0;
        } else {
            /* No match, output a literal byte */ //Tracevv((stderr,"%c", s->window[s->strstart]));
            /*** _tr_tally_lit(s, s.window[s.strstart], bflush); ***/ bflush = trees._tr_tally(s, 0, s.window[s.strstart]);
            s.lookahead--;
            s.strstart++;
        }
        if (bflush) {
            /*** FLUSH_BLOCK(s, 0); ***/ flush_block_only(s, false);
            if (s.strm.avail_out === 0) return BS_NEED_MORE;
        /***/ }
    }
    s.insert = 0;
    if (flush === Z_FINISH) {
        /*** FLUSH_BLOCK(s, 1); ***/ flush_block_only(s, true);
        if (s.strm.avail_out === 0) return BS_FINISH_STARTED;
        /***/ return BS_FINISH_DONE;
    }
    if (s.last_lit) {
        /*** FLUSH_BLOCK(s, 0); ***/ flush_block_only(s, false);
        if (s.strm.avail_out === 0) return BS_NEED_MORE;
    /***/ }
    return BS_BLOCK_DONE;
}
/* ===========================================================================
 * For Z_HUFFMAN_ONLY, do not look for matches.  Do not maintain a hash table.
 * (It will be regenerated if this run of deflate switches away from Huffman.)
 */ function deflate_huff(s, flush) {
    var bflush; /* set if current block must be flushed */ 
    for(;;){
        /* Make sure that we have a literal to write. */ if (s.lookahead === 0) {
            fill_window(s);
            if (s.lookahead === 0) {
                if (flush === Z_NO_FLUSH) return BS_NEED_MORE;
                break; /* flush the current block */ 
            }
        }
        /* Output a literal byte */ s.match_length = 0;
        //Tracevv((stderr,"%c", s->window[s->strstart]));
        /*** _tr_tally_lit(s, s.window[s.strstart], bflush); ***/ bflush = trees._tr_tally(s, 0, s.window[s.strstart]);
        s.lookahead--;
        s.strstart++;
        if (bflush) {
            /*** FLUSH_BLOCK(s, 0); ***/ flush_block_only(s, false);
            if (s.strm.avail_out === 0) return BS_NEED_MORE;
        /***/ }
    }
    s.insert = 0;
    if (flush === Z_FINISH) {
        /*** FLUSH_BLOCK(s, 1); ***/ flush_block_only(s, true);
        if (s.strm.avail_out === 0) return BS_FINISH_STARTED;
        /***/ return BS_FINISH_DONE;
    }
    if (s.last_lit) {
        /*** FLUSH_BLOCK(s, 0); ***/ flush_block_only(s, false);
        if (s.strm.avail_out === 0) return BS_NEED_MORE;
    /***/ }
    return BS_BLOCK_DONE;
}
/* Values for max_lazy_match, good_match and max_chain_length, depending on
 * the desired pack level (0..9). The values given below have been tuned to
 * exclude worst case performance for pathological files. Better values may be
 * found for specific files.
 */ function Config(good_length, max_lazy, nice_length, max_chain, func) {
    this.good_length = good_length;
    this.max_lazy = max_lazy;
    this.nice_length = nice_length;
    this.max_chain = max_chain;
    this.func = func;
}
var configuration_table;
configuration_table = [
    /*      good lazy nice chain */ new Config(0, 0, 0, 0, deflate_stored),
    /* 0 store only */ new Config(4, 4, 8, 4, deflate_fast),
    /* 1 max speed, no lazy matches */ new Config(4, 5, 16, 8, deflate_fast),
    /* 2 */ new Config(4, 6, 32, 32, deflate_fast),
    /* 3 */ new Config(4, 4, 16, 16, deflate_slow),
    /* 4 lazy matches */ new Config(8, 16, 32, 32, deflate_slow),
    /* 5 */ new Config(8, 16, 128, 128, deflate_slow),
    /* 6 */ new Config(8, 32, 128, 256, deflate_slow),
    /* 7 */ new Config(32, 128, 258, 1024, deflate_slow),
    /* 8 */ new Config(32, 258, 258, 4096, deflate_slow)
];
/* ===========================================================================
 * Initialize the "longest match" routines for a new zlib stream
 */ function lm_init(s) {
    s.window_size = 2 * s.w_size;
    /*** CLEAR_HASH(s); ***/ zero(s.head); // Fill with NIL (= 0);
    /* Set the default configuration parameters:
   */ s.max_lazy_match = configuration_table[s.level].max_lazy;
    s.good_match = configuration_table[s.level].good_length;
    s.nice_match = configuration_table[s.level].nice_length;
    s.max_chain_length = configuration_table[s.level].max_chain;
    s.strstart = 0;
    s.block_start = 0;
    s.lookahead = 0;
    s.insert = 0;
    s.match_length = s.prev_length = MIN_MATCH - 1;
    s.match_available = 0;
    s.ins_h = 0;
}
function DeflateState() {
    this.strm = null; /* pointer back to this zlib stream */ 
    this.status = 0; /* as the name implies */ 
    this.pending_buf = null; /* output still pending */ 
    this.pending_buf_size = 0; /* size of pending_buf */ 
    this.pending_out = 0; /* next pending byte to output to the stream */ 
    this.pending = 0; /* nb of bytes in the pending buffer */ 
    this.wrap = 0; /* bit 0 true for zlib, bit 1 true for gzip */ 
    this.gzhead = null; /* gzip header information to write */ 
    this.gzindex = 0; /* where in extra, name, or comment */ 
    this.method = Z_DEFLATED; /* can only be DEFLATED */ 
    this.last_flush = -1; /* value of flush param for previous deflate call */ 
    this.w_size = 0; /* LZ77 window size (32K by default) */ 
    this.w_bits = 0; /* log2(w_size)  (8..16) */ 
    this.w_mask = 0; /* w_size - 1 */ 
    this.window = null;
    /* Sliding window. Input bytes are read into the second half of the window,
   * and move to the first half later to keep a dictionary of at least wSize
   * bytes. With this organization, matches are limited to a distance of
   * wSize-MAX_MATCH bytes, but this ensures that IO is always
   * performed with a length multiple of the block size.
   */ this.window_size = 0;
    /* Actual size of window: 2*wSize, except when the user input buffer
   * is directly used as sliding window.
   */ this.prev = null;
    /* Link to older string with same hash index. To limit the size of this
   * array to 64K, this link is maintained only for the last 32K strings.
   * An index in this array is thus a window index modulo 32K.
   */ this.head = null; /* Heads of the hash chains or NIL. */ 
    this.ins_h = 0; /* hash index of string to be inserted */ 
    this.hash_size = 0; /* number of elements in hash table */ 
    this.hash_bits = 0; /* log2(hash_size) */ 
    this.hash_mask = 0; /* hash_size-1 */ 
    this.hash_shift = 0;
    /* Number of bits by which ins_h must be shifted at each input
   * step. It must be such that after MIN_MATCH steps, the oldest
   * byte no longer takes part in the hash key, that is:
   *   hash_shift * MIN_MATCH >= hash_bits
   */ this.block_start = 0;
    /* Window position at the beginning of the current output block. Gets
   * negative when the window is moved backwards.
   */ this.match_length = 0; /* length of best match */ 
    this.prev_match = 0; /* previous match */ 
    this.match_available = 0; /* set if previous match exists */ 
    this.strstart = 0; /* start of string to insert */ 
    this.match_start = 0; /* start of matching string */ 
    this.lookahead = 0; /* number of valid bytes ahead in window */ 
    this.prev_length = 0;
    /* Length of the best match at previous step. Matches not greater than this
   * are discarded. This is used in the lazy match evaluation.
   */ this.max_chain_length = 0;
    /* To speed up deflation, hash chains are never searched beyond this
   * length.  A higher limit improves compression ratio but degrades the
   * speed.
   */ this.max_lazy_match = 0;
    /* Attempt to find a better match only when the current match is strictly
   * smaller than this value. This mechanism is used only for compression
   * levels >= 4.
   */ // That's alias to max_lazy_match, don't use directly
    //this.max_insert_length = 0;
    /* Insert new strings in the hash table only if the match length is not
   * greater than this length. This saves time but degrades compression.
   * max_insert_length is used only for compression levels <= 3.
   */ this.level = 0; /* compression level (1..9) */ 
    this.strategy = 0; /* favor or force Huffman coding*/ 
    this.good_match = 0;
    /* Use a faster search when the previous match is longer than this */ this.nice_match = 0; /* Stop searching when current match exceeds this */ 
    /* used by trees.c: */ /* Didn't use ct_data typedef below to suppress compiler warning */ // struct ct_data_s dyn_ltree[HEAP_SIZE];   /* literal and length tree */
    // struct ct_data_s dyn_dtree[2*D_CODES+1]; /* distance tree */
    // struct ct_data_s bl_tree[2*BL_CODES+1];  /* Huffman tree for bit lengths */
    // Use flat array of DOUBLE size, with interleaved fata,
    // because JS does not support effective
    this.dyn_ltree = new utils.Buf16(HEAP_SIZE * 2);
    this.dyn_dtree = new utils.Buf16((2 * D_CODES + 1) * 2);
    this.bl_tree = new utils.Buf16((2 * BL_CODES + 1) * 2);
    zero(this.dyn_ltree);
    zero(this.dyn_dtree);
    zero(this.bl_tree);
    this.l_desc = null; /* desc. for literal tree */ 
    this.d_desc = null; /* desc. for distance tree */ 
    this.bl_desc = null; /* desc. for bit length tree */ 
    //ush bl_count[MAX_BITS+1];
    this.bl_count = new utils.Buf16(MAX_BITS + 1);
    /* number of codes at each bit length for an optimal tree */ //int heap[2*L_CODES+1];      /* heap used to build the Huffman trees */
    this.heap = new utils.Buf16(2 * L_CODES + 1); /* heap used to build the Huffman trees */ 
    zero(this.heap);
    this.heap_len = 0; /* number of elements in the heap */ 
    this.heap_max = 0; /* element of largest frequency */ 
    /* The sons of heap[n] are heap[2*n] and heap[2*n+1]. heap[0] is not used.
   * The same heap array is used to build all trees.
   */ this.depth = new utils.Buf16(2 * L_CODES + 1); //uch depth[2*L_CODES+1];
    zero(this.depth);
    /* Depth of each subtree used as tie breaker for trees of equal frequency
   */ this.l_buf = 0; /* buffer index for literals or lengths */ 
    this.lit_bufsize = 0;
    /* Size of match buffer for literals/lengths.  There are 4 reasons for
   * limiting lit_bufsize to 64K:
   *   - frequencies can be kept in 16 bit counters
   *   - if compression is not successful for the first block, all input
   *     data is still in the window so we can still emit a stored block even
   *     when input comes from standard input.  (This can also be done for
   *     all blocks if lit_bufsize is not greater than 32K.)
   *   - if compression is not successful for a file smaller than 64K, we can
   *     even emit a stored file instead of a stored block (saving 5 bytes).
   *     This is applicable only for zip (not gzip or zlib).
   *   - creating new Huffman trees less frequently may not provide fast
   *     adaptation to changes in the input data statistics. (Take for
   *     example a binary file with poorly compressible code followed by
   *     a highly compressible string table.) Smaller buffer sizes give
   *     fast adaptation but have of course the overhead of transmitting
   *     trees more frequently.
   *   - I can't count above 4
   */ this.last_lit = 0; /* running index in l_buf */ 
    this.d_buf = 0;
    /* Buffer index for distances. To simplify the code, d_buf and l_buf have
   * the same number of elements. To use different lengths, an extra flag
   * array would be necessary.
   */ this.opt_len = 0; /* bit length of current block with optimal trees */ 
    this.static_len = 0; /* bit length of current block with static trees */ 
    this.matches = 0; /* number of string matches in current block */ 
    this.insert = 0; /* bytes at end of window left to insert */ 
    this.bi_buf = 0;
    /* Output buffer. bits are inserted starting at the bottom (least
   * significant bits).
   */ this.bi_valid = 0;
/* Number of valid bits in bi_buf.  All bits above the last valid bit
   * are always zero.
   */ // Used for window memory init. We safely ignore it for JS. That makes
// sense only for pointers and memory check tools.
//this.high_water = 0;
/* High water mark offset in window for initialized bytes -- bytes above
   * this are set to zero in order to avoid memory check warnings when
   * longest match routines access bytes past the input.  This is then
   * updated to the new high water mark.
   */ }
function deflateResetKeep(strm) {
    var s;
    if (!strm || !strm.state) return err(strm, Z_STREAM_ERROR);
    strm.total_in = strm.total_out = 0;
    strm.data_type = Z_UNKNOWN;
    s = strm.state;
    s.pending = 0;
    s.pending_out = 0;
    if (s.wrap < 0) s.wrap = -s.wrap;
    s.status = s.wrap ? INIT_STATE : BUSY_STATE;
    strm.adler = s.wrap === 2 ? 0 // crc32(0, Z_NULL, 0)
     : 1; // adler32(0, Z_NULL, 0)
    s.last_flush = Z_NO_FLUSH;
    trees._tr_init(s);
    return Z_OK;
}
function deflateReset(strm) {
    var ret = deflateResetKeep(strm);
    if (ret === Z_OK) lm_init(strm.state);
    return ret;
}
function deflateSetHeader(strm, head) {
    if (!strm || !strm.state) return Z_STREAM_ERROR;
    if (strm.state.wrap !== 2) return Z_STREAM_ERROR;
    strm.state.gzhead = head;
    return Z_OK;
}
function deflateInit2(strm, level, method, windowBits, memLevel, strategy) {
    if (!strm) return Z_STREAM_ERROR;
    var wrap = 1;
    if (level === Z_DEFAULT_COMPRESSION) level = 6;
    if (windowBits < 0) {
        wrap = 0;
        windowBits = -windowBits;
    } else if (windowBits > 15) {
        wrap = 2; /* write gzip wrapper instead */ 
        windowBits -= 16;
    }
    if (memLevel < 1 || memLevel > MAX_MEM_LEVEL || method !== Z_DEFLATED || windowBits < 8 || windowBits > 15 || level < 0 || level > 9 || strategy < 0 || strategy > Z_FIXED) return err(strm, Z_STREAM_ERROR);
    if (windowBits === 8) windowBits = 9;
    /* until 256-byte window bug fixed */ var s = new DeflateState();
    strm.state = s;
    s.strm = strm;
    s.wrap = wrap;
    s.gzhead = null;
    s.w_bits = windowBits;
    s.w_size = 1 << s.w_bits;
    s.w_mask = s.w_size - 1;
    s.hash_bits = memLevel + 7;
    s.hash_size = 1 << s.hash_bits;
    s.hash_mask = s.hash_size - 1;
    s.hash_shift = ~~((s.hash_bits + MIN_MATCH - 1) / MIN_MATCH);
    s.window = new utils.Buf8(s.w_size * 2);
    s.head = new utils.Buf16(s.hash_size);
    s.prev = new utils.Buf16(s.w_size);
    // Don't need mem init magic for JS.
    //s.high_water = 0;  /* nothing written to s->window yet */
    s.lit_bufsize = 1 << memLevel + 6; /* 16K elements by default */ 
    s.pending_buf_size = s.lit_bufsize * 4;
    //overlay = (ushf *) ZALLOC(strm, s->lit_bufsize, sizeof(ush)+2);
    //s->pending_buf = (uchf *) overlay;
    s.pending_buf = new utils.Buf8(s.pending_buf_size);
    // It is offset from `s.pending_buf` (size is `s.lit_bufsize * 2`)
    //s->d_buf = overlay + s->lit_bufsize/sizeof(ush);
    s.d_buf = 1 * s.lit_bufsize;
    //s->l_buf = s->pending_buf + (1+sizeof(ush))*s->lit_bufsize;
    s.l_buf = 3 * s.lit_bufsize;
    s.level = level;
    s.strategy = strategy;
    s.method = method;
    return deflateReset(strm);
}
function deflateInit(strm, level) {
    return deflateInit2(strm, level, Z_DEFLATED, MAX_WBITS, DEF_MEM_LEVEL, Z_DEFAULT_STRATEGY);
}
function deflate(strm, flush) {
    var old_flush, s;
    var beg, val; // for gzip header write only
    if (!strm || !strm.state || flush > Z_BLOCK || flush < 0) return strm ? err(strm, Z_STREAM_ERROR) : Z_STREAM_ERROR;
    s = strm.state;
    if (!strm.output || !strm.input && strm.avail_in !== 0 || s.status === FINISH_STATE && flush !== Z_FINISH) return err(strm, strm.avail_out === 0 ? Z_BUF_ERROR : Z_STREAM_ERROR);
    s.strm = strm; /* just in case */ 
    old_flush = s.last_flush;
    s.last_flush = flush;
    /* Write the header */ if (s.status === INIT_STATE) {
        if (s.wrap === 2) {
            strm.adler = 0; //crc32(0L, Z_NULL, 0);
            put_byte(s, 31);
            put_byte(s, 139);
            put_byte(s, 8);
            if (!s.gzhead) {
                put_byte(s, 0);
                put_byte(s, 0);
                put_byte(s, 0);
                put_byte(s, 0);
                put_byte(s, 0);
                put_byte(s, s.level === 9 ? 2 : s.strategy >= Z_HUFFMAN_ONLY || s.level < 2 ? 4 : 0);
                put_byte(s, OS_CODE);
                s.status = BUSY_STATE;
            } else {
                put_byte(s, (s.gzhead.text ? 1 : 0) + (s.gzhead.hcrc ? 2 : 0) + (!s.gzhead.extra ? 0 : 4) + (!s.gzhead.name ? 0 : 8) + (!s.gzhead.comment ? 0 : 16));
                put_byte(s, s.gzhead.time & 0xff);
                put_byte(s, s.gzhead.time >> 8 & 0xff);
                put_byte(s, s.gzhead.time >> 16 & 0xff);
                put_byte(s, s.gzhead.time >> 24 & 0xff);
                put_byte(s, s.level === 9 ? 2 : s.strategy >= Z_HUFFMAN_ONLY || s.level < 2 ? 4 : 0);
                put_byte(s, s.gzhead.os & 0xff);
                if (s.gzhead.extra && s.gzhead.extra.length) {
                    put_byte(s, s.gzhead.extra.length & 0xff);
                    put_byte(s, s.gzhead.extra.length >> 8 & 0xff);
                }
                if (s.gzhead.hcrc) strm.adler = crc32(strm.adler, s.pending_buf, s.pending, 0);
                s.gzindex = 0;
                s.status = EXTRA_STATE;
            }
        } else {
            var header = Z_DEFLATED + (s.w_bits - 8 << 4) << 8;
            var level_flags = -1;
            if (s.strategy >= Z_HUFFMAN_ONLY || s.level < 2) level_flags = 0;
            else if (s.level < 6) level_flags = 1;
            else if (s.level === 6) level_flags = 2;
            else level_flags = 3;
            header |= level_flags << 6;
            if (s.strstart !== 0) header |= PRESET_DICT;
            header += 31 - header % 31;
            s.status = BUSY_STATE;
            putShortMSB(s, header);
            /* Save the adler32 of the preset dictionary: */ if (s.strstart !== 0) {
                putShortMSB(s, strm.adler >>> 16);
                putShortMSB(s, strm.adler & 0xffff);
            }
            strm.adler = 1; // adler32(0L, Z_NULL, 0);
        }
    }
    //#ifdef GZIP
    if (s.status === EXTRA_STATE) {
        if (s.gzhead.extra /* != Z_NULL*/ ) {
            beg = s.pending; /* start of bytes to update crc */ 
            while(s.gzindex < (s.gzhead.extra.length & 0xffff)){
                if (s.pending === s.pending_buf_size) {
                    if (s.gzhead.hcrc && s.pending > beg) strm.adler = crc32(strm.adler, s.pending_buf, s.pending - beg, beg);
                    flush_pending(strm);
                    beg = s.pending;
                    if (s.pending === s.pending_buf_size) break;
                }
                put_byte(s, s.gzhead.extra[s.gzindex] & 0xff);
                s.gzindex++;
            }
            if (s.gzhead.hcrc && s.pending > beg) strm.adler = crc32(strm.adler, s.pending_buf, s.pending - beg, beg);
            if (s.gzindex === s.gzhead.extra.length) {
                s.gzindex = 0;
                s.status = NAME_STATE;
            }
        } else s.status = NAME_STATE;
    }
    if (s.status === NAME_STATE) {
        if (s.gzhead.name /* != Z_NULL*/ ) {
            beg = s.pending; /* start of bytes to update crc */ 
            //int val;
            do {
                if (s.pending === s.pending_buf_size) {
                    if (s.gzhead.hcrc && s.pending > beg) strm.adler = crc32(strm.adler, s.pending_buf, s.pending - beg, beg);
                    flush_pending(strm);
                    beg = s.pending;
                    if (s.pending === s.pending_buf_size) {
                        val = 1;
                        break;
                    }
                }
                // JS specific: little magic to add zero terminator to end of string
                if (s.gzindex < s.gzhead.name.length) val = s.gzhead.name.charCodeAt(s.gzindex++) & 0xff;
                else val = 0;
                put_byte(s, val);
            }while (val !== 0);
            if (s.gzhead.hcrc && s.pending > beg) strm.adler = crc32(strm.adler, s.pending_buf, s.pending - beg, beg);
            if (val === 0) {
                s.gzindex = 0;
                s.status = COMMENT_STATE;
            }
        } else s.status = COMMENT_STATE;
    }
    if (s.status === COMMENT_STATE) {
        if (s.gzhead.comment /* != Z_NULL*/ ) {
            beg = s.pending; /* start of bytes to update crc */ 
            //int val;
            do {
                if (s.pending === s.pending_buf_size) {
                    if (s.gzhead.hcrc && s.pending > beg) strm.adler = crc32(strm.adler, s.pending_buf, s.pending - beg, beg);
                    flush_pending(strm);
                    beg = s.pending;
                    if (s.pending === s.pending_buf_size) {
                        val = 1;
                        break;
                    }
                }
                // JS specific: little magic to add zero terminator to end of string
                if (s.gzindex < s.gzhead.comment.length) val = s.gzhead.comment.charCodeAt(s.gzindex++) & 0xff;
                else val = 0;
                put_byte(s, val);
            }while (val !== 0);
            if (s.gzhead.hcrc && s.pending > beg) strm.adler = crc32(strm.adler, s.pending_buf, s.pending - beg, beg);
            if (val === 0) s.status = HCRC_STATE;
        } else s.status = HCRC_STATE;
    }
    if (s.status === HCRC_STATE) {
        if (s.gzhead.hcrc) {
            if (s.pending + 2 > s.pending_buf_size) flush_pending(strm);
            if (s.pending + 2 <= s.pending_buf_size) {
                put_byte(s, strm.adler & 0xff);
                put_byte(s, strm.adler >> 8 & 0xff);
                strm.adler = 0; //crc32(0L, Z_NULL, 0);
                s.status = BUSY_STATE;
            }
        } else s.status = BUSY_STATE;
    }
    //#endif
    /* Flush as much pending output as possible */ if (s.pending !== 0) {
        flush_pending(strm);
        if (strm.avail_out === 0) {
            /* Since avail_out is 0, deflate will be called again with
       * more output space, but possibly with both pending and
       * avail_in equal to zero. There won't be anything to do,
       * but this is not an error situation so make sure we
       * return OK instead of BUF_ERROR at next call of deflate:
       */ s.last_flush = -1;
            return Z_OK;
        }
    /* Make sure there is something to do and avoid duplicate consecutive
     * flushes. For repeated and useless calls with Z_FINISH, we keep
     * returning Z_STREAM_END instead of Z_BUF_ERROR.
     */ } else if (strm.avail_in === 0 && rank(flush) <= rank(old_flush) && flush !== Z_FINISH) return err(strm, Z_BUF_ERROR);
    /* User must not provide more input after the first FINISH: */ if (s.status === FINISH_STATE && strm.avail_in !== 0) return err(strm, Z_BUF_ERROR);
    /* Start a new block or continue the current one.
   */ if (strm.avail_in !== 0 || s.lookahead !== 0 || flush !== Z_NO_FLUSH && s.status !== FINISH_STATE) {
        var bstate = s.strategy === Z_HUFFMAN_ONLY ? deflate_huff(s, flush) : s.strategy === Z_RLE ? deflate_rle(s, flush) : configuration_table[s.level].func(s, flush);
        if (bstate === BS_FINISH_STARTED || bstate === BS_FINISH_DONE) s.status = FINISH_STATE;
        if (bstate === BS_NEED_MORE || bstate === BS_FINISH_STARTED) {
            if (strm.avail_out === 0) s.last_flush = -1;
            return Z_OK;
        /* If flush != Z_NO_FLUSH && avail_out == 0, the next call
       * of deflate should use the same flush parameter to make sure
       * that the flush is complete. So we don't have to output an
       * empty block here, this will be done at next call. This also
       * ensures that for a very small output buffer, we emit at most
       * one empty block.
       */ }
        if (bstate === BS_BLOCK_DONE) {
            if (flush === Z_PARTIAL_FLUSH) trees._tr_align(s);
            else if (flush !== Z_BLOCK) {
                trees._tr_stored_block(s, 0, 0, false);
                /* For a full flush, this empty block will be recognized
         * as a special marker by inflate_sync().
         */ if (flush === Z_FULL_FLUSH) {
                    /*** CLEAR_HASH(s); ***/ /* forget history */ zero(s.head); // Fill with NIL (= 0);
                    if (s.lookahead === 0) {
                        s.strstart = 0;
                        s.block_start = 0;
                        s.insert = 0;
                    }
                }
            }
            flush_pending(strm);
            if (strm.avail_out === 0) {
                s.last_flush = -1; /* avoid BUF_ERROR at next call, see above */ 
                return Z_OK;
            }
        }
    }
    //Assert(strm->avail_out > 0, "bug2");
    //if (strm.avail_out <= 0) { throw new Error("bug2");}
    if (flush !== Z_FINISH) return Z_OK;
    if (s.wrap <= 0) return Z_STREAM_END;
    /* Write the trailer */ if (s.wrap === 2) {
        put_byte(s, strm.adler & 0xff);
        put_byte(s, strm.adler >> 8 & 0xff);
        put_byte(s, strm.adler >> 16 & 0xff);
        put_byte(s, strm.adler >> 24 & 0xff);
        put_byte(s, strm.total_in & 0xff);
        put_byte(s, strm.total_in >> 8 & 0xff);
        put_byte(s, strm.total_in >> 16 & 0xff);
        put_byte(s, strm.total_in >> 24 & 0xff);
    } else {
        putShortMSB(s, strm.adler >>> 16);
        putShortMSB(s, strm.adler & 0xffff);
    }
    flush_pending(strm);
    /* If avail_out is zero, the application will call deflate again
   * to flush the rest.
   */ if (s.wrap > 0) s.wrap = -s.wrap;
    /* write the trailer only once! */ return s.pending !== 0 ? Z_OK : Z_STREAM_END;
}
function deflateEnd(strm) {
    var status;
    if (!strm /*== Z_NULL*/  || !strm.state /*== Z_NULL*/ ) return Z_STREAM_ERROR;
    status = strm.state.status;
    if (status !== INIT_STATE && status !== EXTRA_STATE && status !== NAME_STATE && status !== COMMENT_STATE && status !== HCRC_STATE && status !== BUSY_STATE && status !== FINISH_STATE) return err(strm, Z_STREAM_ERROR);
    strm.state = null;
    return status === BUSY_STATE ? err(strm, Z_DATA_ERROR) : Z_OK;
}
/* =========================================================================
 * Initializes the compression dictionary from the given byte
 * sequence without producing any compressed output.
 */ function deflateSetDictionary(strm, dictionary) {
    var dictLength = dictionary.length;
    var s;
    var str, n;
    var wrap;
    var avail;
    var next;
    var input;
    var tmpDict;
    if (!strm /*== Z_NULL*/  || !strm.state /*== Z_NULL*/ ) return Z_STREAM_ERROR;
    s = strm.state;
    wrap = s.wrap;
    if (wrap === 2 || wrap === 1 && s.status !== INIT_STATE || s.lookahead) return Z_STREAM_ERROR;
    /* when using zlib wrappers, compute Adler-32 for provided dictionary */ if (wrap === 1) /* adler32(strm->adler, dictionary, dictLength); */ strm.adler = adler32(strm.adler, dictionary, dictLength, 0);
    s.wrap = 0; /* avoid computing Adler-32 in read_buf */ 
    /* if dictionary would fill window, just replace the history */ if (dictLength >= s.w_size) {
        if (wrap === 0) {
            /*** CLEAR_HASH(s); ***/ zero(s.head); // Fill with NIL (= 0);
            s.strstart = 0;
            s.block_start = 0;
            s.insert = 0;
        }
        /* use the tail */ // dictionary = dictionary.slice(dictLength - s.w_size);
        tmpDict = new utils.Buf8(s.w_size);
        utils.arraySet(tmpDict, dictionary, dictLength - s.w_size, s.w_size, 0);
        dictionary = tmpDict;
        dictLength = s.w_size;
    }
    /* insert dictionary into window and hash */ avail = strm.avail_in;
    next = strm.next_in;
    input = strm.input;
    strm.avail_in = dictLength;
    strm.next_in = 0;
    strm.input = dictionary;
    fill_window(s);
    while(s.lookahead >= MIN_MATCH){
        str = s.strstart;
        n = s.lookahead - (MIN_MATCH - 1);
        do {
            /* UPDATE_HASH(s, s->ins_h, s->window[str + MIN_MATCH-1]); */ s.ins_h = (s.ins_h << s.hash_shift ^ s.window[str + MIN_MATCH - 1]) & s.hash_mask;
            s.prev[str & s.w_mask] = s.head[s.ins_h];
            s.head[s.ins_h] = str;
            str++;
        }while (--n);
        s.strstart = str;
        s.lookahead = MIN_MATCH - 1;
        fill_window(s);
    }
    s.strstart += s.lookahead;
    s.block_start = s.strstart;
    s.insert = s.lookahead;
    s.lookahead = 0;
    s.match_length = s.prev_length = MIN_MATCH - 1;
    s.match_available = 0;
    strm.next_in = next;
    strm.input = input;
    strm.avail_in = avail;
    s.wrap = wrap;
    return Z_OK;
}
exports.deflateInit = deflateInit;
exports.deflateInit2 = deflateInit2;
exports.deflateReset = deflateReset;
exports.deflateResetKeep = deflateResetKeep;
exports.deflateSetHeader = deflateSetHeader;
exports.deflate = deflate;
exports.deflateEnd = deflateEnd;
exports.deflateSetDictionary = deflateSetDictionary;
exports.deflateInfo = "pako deflate (from Nodeca project)"; /* Not implemented
exports.deflateBound = deflateBound;
exports.deflateCopy = deflateCopy;
exports.deflateParams = deflateParams;
exports.deflatePending = deflatePending;
exports.deflatePrime = deflatePrime;
exports.deflateTune = deflateTune;
*/ 

},{"6ecd050ab5cf9e92":"k0GcC","b17b4660c9a756a1":"4qe7r","8a0173ce93724f81":"kqcG1","9fe740ea87b93669":"fMNkF","86729d90d4373c72":"6LyRz"}],"k0GcC":[function(require,module,exports) {
"use strict";
var TYPED_OK = typeof Uint8Array !== "undefined" && typeof Uint16Array !== "undefined" && typeof Int32Array !== "undefined";
function _has(obj, key) {
    return Object.prototype.hasOwnProperty.call(obj, key);
}
exports.assign = function(obj /*from1, from2, from3, ...*/ ) {
    var sources = Array.prototype.slice.call(arguments, 1);
    while(sources.length){
        var source = sources.shift();
        if (!source) continue;
        if (typeof source !== "object") throw new TypeError(source + "must be non-object");
        for(var p in source)if (_has(source, p)) obj[p] = source[p];
    }
    return obj;
};
// reduce buffer size, avoiding mem copy
exports.shrinkBuf = function(buf, size) {
    if (buf.length === size) return buf;
    if (buf.subarray) return buf.subarray(0, size);
    buf.length = size;
    return buf;
};
var fnTyped = {
    arraySet: function(dest, src, src_offs, len, dest_offs) {
        if (src.subarray && dest.subarray) {
            dest.set(src.subarray(src_offs, src_offs + len), dest_offs);
            return;
        }
        // Fallback to ordinary array
        for(var i = 0; i < len; i++)dest[dest_offs + i] = src[src_offs + i];
    },
    // Join array of chunks to single array.
    flattenChunks: function(chunks) {
        var i, l, len, pos, chunk, result;
        // calculate data length
        len = 0;
        for(i = 0, l = chunks.length; i < l; i++)len += chunks[i].length;
        // join chunks
        result = new Uint8Array(len);
        pos = 0;
        for(i = 0, l = chunks.length; i < l; i++){
            chunk = chunks[i];
            result.set(chunk, pos);
            pos += chunk.length;
        }
        return result;
    }
};
var fnUntyped = {
    arraySet: function(dest, src, src_offs, len, dest_offs) {
        for(var i = 0; i < len; i++)dest[dest_offs + i] = src[src_offs + i];
    },
    // Join array of chunks to single array.
    flattenChunks: function(chunks) {
        return [].concat.apply([], chunks);
    }
};
// Enable/Disable typed arrays use, for testing
//
exports.setTyped = function(on) {
    if (on) {
        exports.Buf8 = Uint8Array;
        exports.Buf16 = Uint16Array;
        exports.Buf32 = Int32Array;
        exports.assign(exports, fnTyped);
    } else {
        exports.Buf8 = Array;
        exports.Buf16 = Array;
        exports.Buf32 = Array;
        exports.assign(exports, fnUntyped);
    }
};
exports.setTyped(TYPED_OK);

},{}],"4qe7r":[function(require,module,exports) {
"use strict";
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
/* eslint-disable space-unary-ops */ var utils = require("f7e73d4e313a2bb7");
/* Public constants ==========================================================*/ /* ===========================================================================*/ //var Z_FILTERED          = 1;
//var Z_HUFFMAN_ONLY      = 2;
//var Z_RLE               = 3;
var Z_FIXED = 4;
//var Z_DEFAULT_STRATEGY  = 0;
/* Possible values of the data_type field (though see inflate()) */ var Z_BINARY = 0;
var Z_TEXT = 1;
//var Z_ASCII             = 1; // = Z_TEXT
var Z_UNKNOWN = 2;
/*============================================================================*/ function zero(buf) {
    var len = buf.length;
    while(--len >= 0)buf[len] = 0;
}
// From zutil.h
var STORED_BLOCK = 0;
var STATIC_TREES = 1;
var DYN_TREES = 2;
/* The three kinds of block type */ var MIN_MATCH = 3;
var MAX_MATCH = 258;
/* The minimum and maximum match lengths */ // From deflate.h
/* ===========================================================================
 * Internal compression state.
 */ var LENGTH_CODES = 29;
/* number of length codes, not counting the special END_BLOCK code */ var LITERALS = 256;
/* number of literal bytes 0..255 */ var L_CODES = LITERALS + 1 + LENGTH_CODES;
/* number of Literal or Length codes, including the END_BLOCK code */ var D_CODES = 30;
/* number of distance codes */ var BL_CODES = 19;
/* number of codes used to transfer the bit lengths */ var HEAP_SIZE = 2 * L_CODES + 1;
/* maximum heap size */ var MAX_BITS = 15;
/* All codes must not exceed MAX_BITS bits */ var Buf_size = 16;
/* size of bit buffer in bi_buf */ /* ===========================================================================
 * Constants
 */ var MAX_BL_BITS = 7;
/* Bit length codes must not exceed MAX_BL_BITS bits */ var END_BLOCK = 256;
/* end of block literal code */ var REP_3_6 = 16;
/* repeat previous bit length 3-6 times (2 bits of repeat count) */ var REPZ_3_10 = 17;
/* repeat a zero length 3-10 times  (3 bits of repeat count) */ var REPZ_11_138 = 18;
/* repeat a zero length 11-138 times  (7 bits of repeat count) */ /* eslint-disable comma-spacing,array-bracket-spacing */ var extra_lbits = /* extra bits for each length code */ [
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    1,
    1,
    1,
    2,
    2,
    2,
    2,
    3,
    3,
    3,
    3,
    4,
    4,
    4,
    4,
    5,
    5,
    5,
    5,
    0
];
var extra_dbits = /* extra bits for each distance code */ [
    0,
    0,
    0,
    0,
    1,
    1,
    2,
    2,
    3,
    3,
    4,
    4,
    5,
    5,
    6,
    6,
    7,
    7,
    8,
    8,
    9,
    9,
    10,
    10,
    11,
    11,
    12,
    12,
    13,
    13
];
var extra_blbits = /* extra bits for each bit length code */ [
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    3,
    7
];
var bl_order = [
    16,
    17,
    18,
    0,
    8,
    7,
    9,
    6,
    10,
    5,
    11,
    4,
    12,
    3,
    13,
    2,
    14,
    1,
    15
];
/* eslint-enable comma-spacing,array-bracket-spacing */ /* The lengths of the bit length codes are sent in order of decreasing
 * probability, to avoid transmitting the lengths for unused bit length codes.
 */ /* ===========================================================================
 * Local data. These are initialized only once.
 */ // We pre-fill arrays with 0 to avoid uninitialized gaps
var DIST_CODE_LEN = 512; /* see definition of array dist_code below */ 
// !!!! Use flat array instead of structure, Freq = i*2, Len = i*2+1
var static_ltree = new Array((L_CODES + 2) * 2);
zero(static_ltree);
/* The static literal tree. Since the bit lengths are imposed, there is no
 * need for the L_CODES extra codes used during heap construction. However
 * The codes 286 and 287 are needed to build a canonical tree (see _tr_init
 * below).
 */ var static_dtree = new Array(D_CODES * 2);
zero(static_dtree);
/* The static distance tree. (Actually a trivial tree since all codes use
 * 5 bits.)
 */ var _dist_code = new Array(DIST_CODE_LEN);
zero(_dist_code);
/* Distance codes. The first 256 values correspond to the distances
 * 3 .. 258, the last 256 values correspond to the top 8 bits of
 * the 15 bit distances.
 */ var _length_code = new Array(MAX_MATCH - MIN_MATCH + 1);
zero(_length_code);
/* length code for each normalized match length (0 == MIN_MATCH) */ var base_length = new Array(LENGTH_CODES);
zero(base_length);
/* First normalized length for each code (0 = MIN_MATCH) */ var base_dist = new Array(D_CODES);
zero(base_dist);
/* First normalized distance for each code (0 = distance of 1) */ function StaticTreeDesc(static_tree, extra_bits, extra_base, elems, max_length) {
    this.static_tree = static_tree; /* static tree or NULL */ 
    this.extra_bits = extra_bits; /* extra bits for each code or NULL */ 
    this.extra_base = extra_base; /* base index for extra_bits */ 
    this.elems = elems; /* max number of elements in the tree */ 
    this.max_length = max_length; /* max bit length for the codes */ 
    // show if `static_tree` has data or dummy - needed for monomorphic objects
    this.has_stree = static_tree && static_tree.length;
}
var static_l_desc;
var static_d_desc;
var static_bl_desc;
function TreeDesc(dyn_tree, stat_desc) {
    this.dyn_tree = dyn_tree; /* the dynamic tree */ 
    this.max_code = 0; /* largest code with non zero frequency */ 
    this.stat_desc = stat_desc; /* the corresponding static tree */ 
}
function d_code(dist) {
    return dist < 256 ? _dist_code[dist] : _dist_code[256 + (dist >>> 7)];
}
/* ===========================================================================
 * Output a short LSB first on the stream.
 * IN assertion: there is enough room in pendingBuf.
 */ function put_short(s, w) {
    //    put_byte(s, (uch)((w) & 0xff));
    //    put_byte(s, (uch)((ush)(w) >> 8));
    s.pending_buf[s.pending++] = w & 0xff;
    s.pending_buf[s.pending++] = w >>> 8 & 0xff;
}
/* ===========================================================================
 * Send a value on a given number of bits.
 * IN assertion: length <= 16 and value fits in length bits.
 */ function send_bits(s, value, length) {
    if (s.bi_valid > Buf_size - length) {
        s.bi_buf |= value << s.bi_valid & 0xffff;
        put_short(s, s.bi_buf);
        s.bi_buf = value >> Buf_size - s.bi_valid;
        s.bi_valid += length - Buf_size;
    } else {
        s.bi_buf |= value << s.bi_valid & 0xffff;
        s.bi_valid += length;
    }
}
function send_code(s, c, tree) {
    send_bits(s, tree[c * 2], tree[c * 2 + 1]);
}
/* ===========================================================================
 * Reverse the first len bits of a code, using straightforward code (a faster
 * method would use a table)
 * IN assertion: 1 <= len <= 15
 */ function bi_reverse(code, len) {
    var res = 0;
    do {
        res |= code & 1;
        code >>>= 1;
        res <<= 1;
    }while (--len > 0);
    return res >>> 1;
}
/* ===========================================================================
 * Flush the bit buffer, keeping at most 7 bits in it.
 */ function bi_flush(s) {
    if (s.bi_valid === 16) {
        put_short(s, s.bi_buf);
        s.bi_buf = 0;
        s.bi_valid = 0;
    } else if (s.bi_valid >= 8) {
        s.pending_buf[s.pending++] = s.bi_buf & 0xff;
        s.bi_buf >>= 8;
        s.bi_valid -= 8;
    }
}
/* ===========================================================================
 * Compute the optimal bit lengths for a tree and update the total bit length
 * for the current block.
 * IN assertion: the fields freq and dad are set, heap[heap_max] and
 *    above are the tree nodes sorted by increasing frequency.
 * OUT assertions: the field len is set to the optimal bit length, the
 *     array bl_count contains the frequencies for each bit length.
 *     The length opt_len is updated; static_len is also updated if stree is
 *     not null.
 */ function gen_bitlen(s, desc) //    deflate_state *s;
//    tree_desc *desc;    /* the tree descriptor */
{
    var tree = desc.dyn_tree;
    var max_code = desc.max_code;
    var stree = desc.stat_desc.static_tree;
    var has_stree = desc.stat_desc.has_stree;
    var extra = desc.stat_desc.extra_bits;
    var base = desc.stat_desc.extra_base;
    var max_length = desc.stat_desc.max_length;
    var h; /* heap index */ 
    var n, m; /* iterate over the tree elements */ 
    var bits; /* bit length */ 
    var xbits; /* extra bits */ 
    var f; /* frequency */ 
    var overflow = 0; /* number of elements with bit length too large */ 
    for(bits = 0; bits <= MAX_BITS; bits++)s.bl_count[bits] = 0;
    /* In a first pass, compute the optimal bit lengths (which may
   * overflow in the case of the bit length tree).
   */ tree[s.heap[s.heap_max] * 2 + 1] = 0; /* root of the heap */ 
    for(h = s.heap_max + 1; h < HEAP_SIZE; h++){
        n = s.heap[h];
        bits = tree[tree[n * 2 + 1] * 2 + 1] + 1;
        if (bits > max_length) {
            bits = max_length;
            overflow++;
        }
        tree[n * 2 + 1] = bits;
        /* We overwrite tree[n].Dad which is no longer needed */ if (n > max_code) continue;
         /* not a leaf node */ 
        s.bl_count[bits]++;
        xbits = 0;
        if (n >= base) xbits = extra[n - base];
        f = tree[n * 2] /*.Freq*/ ;
        s.opt_len += f * (bits + xbits);
        if (has_stree) s.static_len += f * (stree[n * 2 + 1] + xbits);
    }
    if (overflow === 0) return;
    // Trace((stderr,"\nbit length overflow\n"));
    /* This happens for example on obj2 and pic of the Calgary corpus */ /* Find the first bit length which could increase: */ do {
        bits = max_length - 1;
        while(s.bl_count[bits] === 0)bits--;
        s.bl_count[bits]--; /* move one leaf down the tree */ 
        s.bl_count[bits + 1] += 2; /* move one overflow item as its brother */ 
        s.bl_count[max_length]--;
        /* The brother of the overflow item also moves one step up,
     * but this does not affect bl_count[max_length]
     */ overflow -= 2;
    }while (overflow > 0);
    /* Now recompute all bit lengths, scanning in increasing frequency.
   * h is still equal to HEAP_SIZE. (It is simpler to reconstruct all
   * lengths instead of fixing only the wrong ones. This idea is taken
   * from 'ar' written by Haruhiko Okumura.)
   */ for(bits = max_length; bits !== 0; bits--){
        n = s.bl_count[bits];
        while(n !== 0){
            m = s.heap[--h];
            if (m > max_code) continue;
            if (tree[m * 2 + 1] !== bits) {
                // Trace((stderr,"code %d bits %d->%d\n", m, tree[m].Len, bits));
                s.opt_len += (bits - tree[m * 2 + 1]) * tree[m * 2] /*.Freq*/ ;
                tree[m * 2 + 1] = bits;
            }
            n--;
        }
    }
}
/* ===========================================================================
 * Generate the codes for a given tree and bit counts (which need not be
 * optimal).
 * IN assertion: the array bl_count contains the bit length statistics for
 * the given tree and the field len is set for all tree elements.
 * OUT assertion: the field code is set for all tree elements of non
 *     zero code length.
 */ function gen_codes(tree, max_code, bl_count) //    ct_data *tree;             /* the tree to decorate */
//    int max_code;              /* largest code with non zero frequency */
//    ushf *bl_count;            /* number of codes at each bit length */
{
    var next_code = new Array(MAX_BITS + 1); /* next code value for each bit length */ 
    var code = 0; /* running code value */ 
    var bits; /* bit index */ 
    var n; /* code index */ 
    /* The distribution counts are first used to generate the code values
   * without bit reversal.
   */ for(bits = 1; bits <= MAX_BITS; bits++)next_code[bits] = code = code + bl_count[bits - 1] << 1;
    /* Check that the bit counts in bl_count are consistent. The last code
   * must be all ones.
   */ //Assert (code + bl_count[MAX_BITS]-1 == (1<<MAX_BITS)-1,
    //        "inconsistent bit counts");
    //Tracev((stderr,"\ngen_codes: max_code %d ", max_code));
    for(n = 0; n <= max_code; n++){
        var len = tree[n * 2 + 1] /*.Len*/ ;
        if (len === 0) continue;
        /* Now reverse the bits */ tree[n * 2] = bi_reverse(next_code[len]++, len);
    //Tracecv(tree != static_ltree, (stderr,"\nn %3d %c l %2d c %4x (%x) ",
    //     n, (isgraph(n) ? n : ' '), len, tree[n].Code, next_code[len]-1));
    }
}
/* ===========================================================================
 * Initialize the various 'constant' tables.
 */ function tr_static_init() {
    var n; /* iterates over tree elements */ 
    var bits; /* bit counter */ 
    var length; /* length value */ 
    var code; /* code value */ 
    var dist; /* distance index */ 
    var bl_count = new Array(MAX_BITS + 1);
    /* number of codes at each bit length for an optimal tree */ // do check in _tr_init()
    //if (static_init_done) return;
    /* For some embedded targets, global variables are not initialized: */ /*#ifdef NO_INIT_GLOBAL_POINTERS
  static_l_desc.static_tree = static_ltree;
  static_l_desc.extra_bits = extra_lbits;
  static_d_desc.static_tree = static_dtree;
  static_d_desc.extra_bits = extra_dbits;
  static_bl_desc.extra_bits = extra_blbits;
#endif*/ /* Initialize the mapping length (0..255) -> length code (0..28) */ length = 0;
    for(code = 0; code < LENGTH_CODES - 1; code++){
        base_length[code] = length;
        for(n = 0; n < 1 << extra_lbits[code]; n++)_length_code[length++] = code;
    }
    //Assert (length == 256, "tr_static_init: length != 256");
    /* Note that the length 255 (match length 258) can be represented
   * in two different ways: code 284 + 5 bits or code 285, so we
   * overwrite length_code[255] to use the best encoding:
   */ _length_code[length - 1] = code;
    /* Initialize the mapping dist (0..32K) -> dist code (0..29) */ dist = 0;
    for(code = 0; code < 16; code++){
        base_dist[code] = dist;
        for(n = 0; n < 1 << extra_dbits[code]; n++)_dist_code[dist++] = code;
    }
    //Assert (dist == 256, "tr_static_init: dist != 256");
    dist >>= 7; /* from now on, all distances are divided by 128 */ 
    for(; code < D_CODES; code++){
        base_dist[code] = dist << 7;
        for(n = 0; n < 1 << extra_dbits[code] - 7; n++)_dist_code[256 + dist++] = code;
    }
    //Assert (dist == 256, "tr_static_init: 256+dist != 512");
    /* Construct the codes of the static literal tree */ for(bits = 0; bits <= MAX_BITS; bits++)bl_count[bits] = 0;
    n = 0;
    while(n <= 143){
        static_ltree[n * 2 + 1] = 8;
        n++;
        bl_count[8]++;
    }
    while(n <= 255){
        static_ltree[n * 2 + 1] = 9;
        n++;
        bl_count[9]++;
    }
    while(n <= 279){
        static_ltree[n * 2 + 1] = 7;
        n++;
        bl_count[7]++;
    }
    while(n <= 287){
        static_ltree[n * 2 + 1] = 8;
        n++;
        bl_count[8]++;
    }
    /* Codes 286 and 287 do not exist, but we must include them in the
   * tree construction to get a canonical Huffman tree (longest code
   * all ones)
   */ gen_codes(static_ltree, L_CODES + 1, bl_count);
    /* The static distance tree is trivial: */ for(n = 0; n < D_CODES; n++){
        static_dtree[n * 2 + 1] = 5;
        static_dtree[n * 2] = bi_reverse(n, 5);
    }
    // Now data ready and we can init static trees
    static_l_desc = new StaticTreeDesc(static_ltree, extra_lbits, LITERALS + 1, L_CODES, MAX_BITS);
    static_d_desc = new StaticTreeDesc(static_dtree, extra_dbits, 0, D_CODES, MAX_BITS);
    static_bl_desc = new StaticTreeDesc(new Array(0), extra_blbits, 0, BL_CODES, MAX_BL_BITS);
//static_init_done = true;
}
/* ===========================================================================
 * Initialize a new block.
 */ function init_block(s) {
    var n; /* iterates over tree elements */ 
    /* Initialize the trees. */ for(n = 0; n < L_CODES; n++)s.dyn_ltree[n * 2] = 0;
    for(n = 0; n < D_CODES; n++)s.dyn_dtree[n * 2] = 0;
    for(n = 0; n < BL_CODES; n++)s.bl_tree[n * 2] = 0;
    s.dyn_ltree[END_BLOCK * 2] = 1;
    s.opt_len = s.static_len = 0;
    s.last_lit = s.matches = 0;
}
/* ===========================================================================
 * Flush the bit buffer and align the output on a byte boundary
 */ function bi_windup(s) {
    if (s.bi_valid > 8) put_short(s, s.bi_buf);
    else if (s.bi_valid > 0) //put_byte(s, (Byte)s->bi_buf);
    s.pending_buf[s.pending++] = s.bi_buf;
    s.bi_buf = 0;
    s.bi_valid = 0;
}
/* ===========================================================================
 * Copy a stored block, storing first the length and its
 * one's complement if requested.
 */ function copy_block(s, buf, len, header) //DeflateState *s;
//charf    *buf;    /* the input data */
//unsigned len;     /* its length */
//int      header;  /* true if block header must be written */
{
    bi_windup(s); /* align on byte boundary */ 
    if (header) {
        put_short(s, len);
        put_short(s, ~len);
    }
    //  while (len--) {
    //    put_byte(s, *buf++);
    //  }
    utils.arraySet(s.pending_buf, s.window, buf, len, s.pending);
    s.pending += len;
}
/* ===========================================================================
 * Compares to subtrees, using the tree depth as tie breaker when
 * the subtrees have equal frequency. This minimizes the worst case length.
 */ function smaller(tree, n, m, depth) {
    var _n2 = n * 2;
    var _m2 = m * 2;
    return tree[_n2] < tree[_m2] || tree[_n2] === tree[_m2] && depth[n] <= depth[m];
}
/* ===========================================================================
 * Restore the heap property by moving down the tree starting at node k,
 * exchanging a node with the smallest of its two sons if necessary, stopping
 * when the heap property is re-established (each father smaller than its
 * two sons).
 */ function pqdownheap(s, tree, k) //    deflate_state *s;
//    ct_data *tree;  /* the tree to restore */
//    int k;               /* node to move down */
{
    var v = s.heap[k];
    var j = k << 1; /* left son of k */ 
    while(j <= s.heap_len){
        /* Set j to the smallest of the two sons: */ if (j < s.heap_len && smaller(tree, s.heap[j + 1], s.heap[j], s.depth)) j++;
        /* Exit if v is smaller than both sons */ if (smaller(tree, v, s.heap[j], s.depth)) break;
        /* Exchange v with the smallest son */ s.heap[k] = s.heap[j];
        k = j;
        /* And continue down the tree, setting j to the left son of k */ j <<= 1;
    }
    s.heap[k] = v;
}
// inlined manually
// var SMALLEST = 1;
/* ===========================================================================
 * Send the block data compressed using the given Huffman trees
 */ function compress_block(s, ltree, dtree) //    deflate_state *s;
//    const ct_data *ltree; /* literal tree */
//    const ct_data *dtree; /* distance tree */
{
    var dist; /* distance of matched string */ 
    var lc; /* match length or unmatched char (if dist == 0) */ 
    var lx = 0; /* running index in l_buf */ 
    var code; /* the code to send */ 
    var extra; /* number of extra bits to send */ 
    if (s.last_lit !== 0) do {
        dist = s.pending_buf[s.d_buf + lx * 2] << 8 | s.pending_buf[s.d_buf + lx * 2 + 1];
        lc = s.pending_buf[s.l_buf + lx];
        lx++;
        if (dist === 0) send_code(s, lc, ltree); /* send a literal byte */ 
        else {
            /* Here, lc is the match length - MIN_MATCH */ code = _length_code[lc];
            send_code(s, code + LITERALS + 1, ltree); /* send the length code */ 
            extra = extra_lbits[code];
            if (extra !== 0) {
                lc -= base_length[code];
                send_bits(s, lc, extra); /* send the extra length bits */ 
            }
            dist--; /* dist is now the match distance - 1 */ 
            code = d_code(dist);
            //Assert (code < D_CODES, "bad d_code");
            send_code(s, code, dtree); /* send the distance code */ 
            extra = extra_dbits[code];
            if (extra !== 0) {
                dist -= base_dist[code];
                send_bits(s, dist, extra); /* send the extra distance bits */ 
            }
        } /* literal or match pair ? */ 
    /* Check that the overlay between pending_buf and d_buf+l_buf is ok: */ //Assert((uInt)(s->pending) < s->lit_bufsize + 2*lx,
    //       "pendingBuf overflow");
    }while (lx < s.last_lit);
    send_code(s, END_BLOCK, ltree);
}
/* ===========================================================================
 * Construct one Huffman tree and assigns the code bit strings and lengths.
 * Update the total bit length for the current block.
 * IN assertion: the field freq is set for all tree elements.
 * OUT assertions: the fields len and code are set to the optimal bit length
 *     and corresponding code. The length opt_len is updated; static_len is
 *     also updated if stree is not null. The field max_code is set.
 */ function build_tree(s, desc) //    deflate_state *s;
//    tree_desc *desc; /* the tree descriptor */
{
    var tree = desc.dyn_tree;
    var stree = desc.stat_desc.static_tree;
    var has_stree = desc.stat_desc.has_stree;
    var elems = desc.stat_desc.elems;
    var n, m; /* iterate over heap elements */ 
    var max_code = -1; /* largest code with non zero frequency */ 
    var node; /* new node being created */ 
    /* Construct the initial heap, with least frequent element in
   * heap[SMALLEST]. The sons of heap[n] are heap[2*n] and heap[2*n+1].
   * heap[0] is not used.
   */ s.heap_len = 0;
    s.heap_max = HEAP_SIZE;
    for(n = 0; n < elems; n++)if (tree[n * 2] !== 0) {
        s.heap[++s.heap_len] = max_code = n;
        s.depth[n] = 0;
    } else tree[n * 2 + 1] = 0;
    /* The pkzip format requires that at least one distance code exists,
   * and that at least one bit should be sent even if there is only one
   * possible code. So to avoid special checks later on we force at least
   * two codes of non zero frequency.
   */ while(s.heap_len < 2){
        node = s.heap[++s.heap_len] = max_code < 2 ? ++max_code : 0;
        tree[node * 2] = 1;
        s.depth[node] = 0;
        s.opt_len--;
        if (has_stree) s.static_len -= stree[node * 2 + 1] /*.Len*/ ;
    /* node is 0 or 1 so it does not have extra bits */ }
    desc.max_code = max_code;
    /* The elements heap[heap_len/2+1 .. heap_len] are leaves of the tree,
   * establish sub-heaps of increasing lengths:
   */ for(n = s.heap_len >> 1 /*int /2*/ ; n >= 1; n--)pqdownheap(s, tree, n);
    /* Construct the Huffman tree by repeatedly combining the least two
   * frequent nodes.
   */ node = elems; /* next internal node of the tree */ 
    do {
        //pqremove(s, tree, n);  /* n = node of least frequency */
        /*** pqremove ***/ n = s.heap[1 /*SMALLEST*/ ];
        s.heap[1 /*SMALLEST*/ ] = s.heap[s.heap_len--];
        pqdownheap(s, tree, 1 /*SMALLEST*/ );
        /***/ m = s.heap[1 /*SMALLEST*/ ]; /* m = node of next least frequency */ 
        s.heap[--s.heap_max] = n; /* keep the nodes sorted by frequency */ 
        s.heap[--s.heap_max] = m;
        /* Create a new node father of n and m */ tree[node * 2] = tree[n * 2] + tree[m * 2] /*.Freq*/ ;
        s.depth[node] = (s.depth[n] >= s.depth[m] ? s.depth[n] : s.depth[m]) + 1;
        tree[n * 2 + 1] = tree[m * 2 + 1] = node;
        /* and insert the new node in the heap */ s.heap[1 /*SMALLEST*/ ] = node++;
        pqdownheap(s, tree, 1 /*SMALLEST*/ );
    }while (s.heap_len >= 2);
    s.heap[--s.heap_max] = s.heap[1 /*SMALLEST*/ ];
    /* At this point, the fields freq and dad are set. We can now
   * generate the bit lengths.
   */ gen_bitlen(s, desc);
    /* The field len is now set, we can generate the bit codes */ gen_codes(tree, max_code, s.bl_count);
}
/* ===========================================================================
 * Scan a literal or distance tree to determine the frequencies of the codes
 * in the bit length tree.
 */ function scan_tree(s, tree, max_code) //    deflate_state *s;
//    ct_data *tree;   /* the tree to be scanned */
//    int max_code;    /* and its largest code of non zero frequency */
{
    var n; /* iterates over all tree elements */ 
    var prevlen = -1; /* last emitted length */ 
    var curlen; /* length of current code */ 
    var nextlen = tree[1] /*.Len*/ ; /* length of next code */ 
    var count = 0; /* repeat count of the current code */ 
    var max_count = 7; /* max repeat count */ 
    var min_count = 4; /* min repeat count */ 
    if (nextlen === 0) {
        max_count = 138;
        min_count = 3;
    }
    tree[(max_code + 1) * 2 + 1] = 0xffff; /* guard */ 
    for(n = 0; n <= max_code; n++){
        curlen = nextlen;
        nextlen = tree[(n + 1) * 2 + 1] /*.Len*/ ;
        if (++count < max_count && curlen === nextlen) continue;
        else if (count < min_count) s.bl_tree[curlen * 2] += count;
        else if (curlen !== 0) {
            if (curlen !== prevlen) s.bl_tree[curlen * 2]++;
            s.bl_tree[REP_3_6 * 2]++;
        } else if (count <= 10) s.bl_tree[REPZ_3_10 * 2]++;
        else s.bl_tree[REPZ_11_138 * 2]++;
        count = 0;
        prevlen = curlen;
        if (nextlen === 0) {
            max_count = 138;
            min_count = 3;
        } else if (curlen === nextlen) {
            max_count = 6;
            min_count = 3;
        } else {
            max_count = 7;
            min_count = 4;
        }
    }
}
/* ===========================================================================
 * Send a literal or distance tree in compressed form, using the codes in
 * bl_tree.
 */ function send_tree(s, tree, max_code) //    deflate_state *s;
//    ct_data *tree; /* the tree to be scanned */
//    int max_code;       /* and its largest code of non zero frequency */
{
    var n; /* iterates over all tree elements */ 
    var prevlen = -1; /* last emitted length */ 
    var curlen; /* length of current code */ 
    var nextlen = tree[1] /*.Len*/ ; /* length of next code */ 
    var count = 0; /* repeat count of the current code */ 
    var max_count = 7; /* max repeat count */ 
    var min_count = 4; /* min repeat count */ 
    /* tree[max_code+1].Len = -1; */ /* guard already set */ if (nextlen === 0) {
        max_count = 138;
        min_count = 3;
    }
    for(n = 0; n <= max_code; n++){
        curlen = nextlen;
        nextlen = tree[(n + 1) * 2 + 1] /*.Len*/ ;
        if (++count < max_count && curlen === nextlen) continue;
        else if (count < min_count) do send_code(s, curlen, s.bl_tree);
        while (--count !== 0);
        else if (curlen !== 0) {
            if (curlen !== prevlen) {
                send_code(s, curlen, s.bl_tree);
                count--;
            }
            //Assert(count >= 3 && count <= 6, " 3_6?");
            send_code(s, REP_3_6, s.bl_tree);
            send_bits(s, count - 3, 2);
        } else if (count <= 10) {
            send_code(s, REPZ_3_10, s.bl_tree);
            send_bits(s, count - 3, 3);
        } else {
            send_code(s, REPZ_11_138, s.bl_tree);
            send_bits(s, count - 11, 7);
        }
        count = 0;
        prevlen = curlen;
        if (nextlen === 0) {
            max_count = 138;
            min_count = 3;
        } else if (curlen === nextlen) {
            max_count = 6;
            min_count = 3;
        } else {
            max_count = 7;
            min_count = 4;
        }
    }
}
/* ===========================================================================
 * Construct the Huffman tree for the bit lengths and return the index in
 * bl_order of the last bit length code to send.
 */ function build_bl_tree(s) {
    var max_blindex; /* index of last bit length code of non zero freq */ 
    /* Determine the bit length frequencies for literal and distance trees */ scan_tree(s, s.dyn_ltree, s.l_desc.max_code);
    scan_tree(s, s.dyn_dtree, s.d_desc.max_code);
    /* Build the bit length tree: */ build_tree(s, s.bl_desc);
    /* opt_len now includes the length of the tree representations, except
   * the lengths of the bit lengths codes and the 5+5+4 bits for the counts.
   */ /* Determine the number of bit length codes to send. The pkzip format
   * requires that at least 4 bit length codes be sent. (appnote.txt says
   * 3 but the actual value used is 4.)
   */ for(max_blindex = BL_CODES - 1; max_blindex >= 3; max_blindex--){
        if (s.bl_tree[bl_order[max_blindex] * 2 + 1] !== 0) break;
    }
    /* Update opt_len to include the bit length tree and counts */ s.opt_len += 3 * (max_blindex + 1) + 5 + 5 + 4;
    //Tracev((stderr, "\ndyn trees: dyn %ld, stat %ld",
    //        s->opt_len, s->static_len));
    return max_blindex;
}
/* ===========================================================================
 * Send the header for a block using dynamic Huffman trees: the counts, the
 * lengths of the bit length codes, the literal tree and the distance tree.
 * IN assertion: lcodes >= 257, dcodes >= 1, blcodes >= 4.
 */ function send_all_trees(s, lcodes, dcodes, blcodes) //    deflate_state *s;
//    int lcodes, dcodes, blcodes; /* number of codes for each tree */
{
    var rank; /* index in bl_order */ 
    //Assert (lcodes >= 257 && dcodes >= 1 && blcodes >= 4, "not enough codes");
    //Assert (lcodes <= L_CODES && dcodes <= D_CODES && blcodes <= BL_CODES,
    //        "too many codes");
    //Tracev((stderr, "\nbl counts: "));
    send_bits(s, lcodes - 257, 5); /* not +255 as stated in appnote.txt */ 
    send_bits(s, dcodes - 1, 5);
    send_bits(s, blcodes - 4, 4); /* not -3 as stated in appnote.txt */ 
    for(rank = 0; rank < blcodes; rank++)//Tracev((stderr, "\nbl code %2d ", bl_order[rank]));
    send_bits(s, s.bl_tree[bl_order[rank] * 2 + 1], 3);
    //Tracev((stderr, "\nbl tree: sent %ld", s->bits_sent));
    send_tree(s, s.dyn_ltree, lcodes - 1); /* literal tree */ 
    //Tracev((stderr, "\nlit tree: sent %ld", s->bits_sent));
    send_tree(s, s.dyn_dtree, dcodes - 1); /* distance tree */ 
//Tracev((stderr, "\ndist tree: sent %ld", s->bits_sent));
}
/* ===========================================================================
 * Check if the data type is TEXT or BINARY, using the following algorithm:
 * - TEXT if the two conditions below are satisfied:
 *    a) There are no non-portable control characters belonging to the
 *       "black list" (0..6, 14..25, 28..31).
 *    b) There is at least one printable character belonging to the
 *       "white list" (9 {TAB}, 10 {LF}, 13 {CR}, 32..255).
 * - BINARY otherwise.
 * - The following partially-portable control characters form a
 *   "gray list" that is ignored in this detection algorithm:
 *   (7 {BEL}, 8 {BS}, 11 {VT}, 12 {FF}, 26 {SUB}, 27 {ESC}).
 * IN assertion: the fields Freq of dyn_ltree are set.
 */ function detect_data_type(s) {
    /* black_mask is the bit mask of black-listed bytes
   * set bits 0..6, 14..25, and 28..31
   * 0xf3ffc07f = binary 11110011111111111100000001111111
   */ var black_mask = 0xf3ffc07f;
    var n;
    /* Check for non-textual ("black-listed") bytes. */ for(n = 0; n <= 31; n++, black_mask >>>= 1){
        if (black_mask & 1 && s.dyn_ltree[n * 2] !== 0) return Z_BINARY;
    }
    /* Check for textual ("white-listed") bytes. */ if (s.dyn_ltree[18] !== 0 || s.dyn_ltree[20] !== 0 || s.dyn_ltree[26] !== 0) return Z_TEXT;
    for(n = 32; n < LITERALS; n++){
        if (s.dyn_ltree[n * 2] !== 0) return Z_TEXT;
    }
    /* There are no "black-listed" or "white-listed" bytes:
   * this stream either is empty or has tolerated ("gray-listed") bytes only.
   */ return Z_BINARY;
}
var static_init_done = false;
/* ===========================================================================
 * Initialize the tree data structures for a new zlib stream.
 */ function _tr_init(s) {
    if (!static_init_done) {
        tr_static_init();
        static_init_done = true;
    }
    s.l_desc = new TreeDesc(s.dyn_ltree, static_l_desc);
    s.d_desc = new TreeDesc(s.dyn_dtree, static_d_desc);
    s.bl_desc = new TreeDesc(s.bl_tree, static_bl_desc);
    s.bi_buf = 0;
    s.bi_valid = 0;
    /* Initialize the first block of the first file: */ init_block(s);
}
/* ===========================================================================
 * Send a stored block
 */ function _tr_stored_block(s, buf, stored_len, last) //DeflateState *s;
//charf *buf;       /* input block */
//ulg stored_len;   /* length of input block */
//int last;         /* one if this is the last block for a file */
{
    send_bits(s, (STORED_BLOCK << 1) + (last ? 1 : 0), 3); /* send block type */ 
    copy_block(s, buf, stored_len, true); /* with header */ 
}
/* ===========================================================================
 * Send one empty static block to give enough lookahead for inflate.
 * This takes 10 bits, of which 7 may remain in the bit buffer.
 */ function _tr_align(s) {
    send_bits(s, STATIC_TREES << 1, 3);
    send_code(s, END_BLOCK, static_ltree);
    bi_flush(s);
}
/* ===========================================================================
 * Determine the best encoding for the current block: dynamic trees, static
 * trees or store, and output the encoded block to the zip file.
 */ function _tr_flush_block(s, buf, stored_len, last) //DeflateState *s;
//charf *buf;       /* input block, or NULL if too old */
//ulg stored_len;   /* length of input block */
//int last;         /* one if this is the last block for a file */
{
    var opt_lenb, static_lenb; /* opt_len and static_len in bytes */ 
    var max_blindex = 0; /* index of last bit length code of non zero freq */ 
    /* Build the Huffman trees unless a stored block is forced */ if (s.level > 0) {
        /* Check if the file is binary or text */ if (s.strm.data_type === Z_UNKNOWN) s.strm.data_type = detect_data_type(s);
        /* Construct the literal and distance trees */ build_tree(s, s.l_desc);
        // Tracev((stderr, "\nlit data: dyn %ld, stat %ld", s->opt_len,
        //        s->static_len));
        build_tree(s, s.d_desc);
        // Tracev((stderr, "\ndist data: dyn %ld, stat %ld", s->opt_len,
        //        s->static_len));
        /* At this point, opt_len and static_len are the total bit lengths of
     * the compressed block data, excluding the tree representations.
     */ /* Build the bit length tree for the above two trees, and get the index
     * in bl_order of the last bit length code to send.
     */ max_blindex = build_bl_tree(s);
        /* Determine the best encoding. Compute the block lengths in bytes. */ opt_lenb = s.opt_len + 3 + 7 >>> 3;
        static_lenb = s.static_len + 3 + 7 >>> 3;
        // Tracev((stderr, "\nopt %lu(%lu) stat %lu(%lu) stored %lu lit %u ",
        //        opt_lenb, s->opt_len, static_lenb, s->static_len, stored_len,
        //        s->last_lit));
        if (static_lenb <= opt_lenb) opt_lenb = static_lenb;
    } else // Assert(buf != (char*)0, "lost buf");
    opt_lenb = static_lenb = stored_len + 5; /* force a stored block */ 
    if (stored_len + 4 <= opt_lenb && buf !== -1) /* 4: two words for the lengths */ /* The test buf != NULL is only necessary if LIT_BUFSIZE > WSIZE.
     * Otherwise we can't have processed more than WSIZE input bytes since
     * the last block flush, because compression would have been
     * successful. If LIT_BUFSIZE <= WSIZE, it is never too late to
     * transform a block into a stored block.
     */ _tr_stored_block(s, buf, stored_len, last);
    else if (s.strategy === Z_FIXED || static_lenb === opt_lenb) {
        send_bits(s, (STATIC_TREES << 1) + (last ? 1 : 0), 3);
        compress_block(s, static_ltree, static_dtree);
    } else {
        send_bits(s, (DYN_TREES << 1) + (last ? 1 : 0), 3);
        send_all_trees(s, s.l_desc.max_code + 1, s.d_desc.max_code + 1, max_blindex + 1);
        compress_block(s, s.dyn_ltree, s.dyn_dtree);
    }
    // Assert (s->compressed_len == s->bits_sent, "bad compressed size");
    /* The above check is made mod 2^32, for files larger than 512 MB
   * and uLong implemented on 32 bits.
   */ init_block(s);
    if (last) bi_windup(s);
// Tracev((stderr,"\ncomprlen %lu(%lu) ", s->compressed_len>>3,
//       s->compressed_len-7*last));
}
/* ===========================================================================
 * Save the match info and tally the frequency counts. Return true if
 * the current block must be flushed.
 */ function _tr_tally(s, dist, lc) //    deflate_state *s;
//    unsigned dist;  /* distance of matched string */
//    unsigned lc;    /* match length-MIN_MATCH or unmatched char (if dist==0) */
{
    //var out_length, in_length, dcode;
    s.pending_buf[s.d_buf + s.last_lit * 2] = dist >>> 8 & 0xff;
    s.pending_buf[s.d_buf + s.last_lit * 2 + 1] = dist & 0xff;
    s.pending_buf[s.l_buf + s.last_lit] = lc & 0xff;
    s.last_lit++;
    if (dist === 0) /* lc is the unmatched char */ s.dyn_ltree[lc * 2]++;
    else {
        s.matches++;
        /* Here, lc is the match length - MIN_MATCH */ dist--; /* dist = match distance - 1 */ 
        //Assert((ush)dist < (ush)MAX_DIST(s) &&
        //       (ush)lc <= (ush)(MAX_MATCH-MIN_MATCH) &&
        //       (ush)d_code(dist) < (ush)D_CODES,  "_tr_tally: bad match");
        s.dyn_ltree[(_length_code[lc] + LITERALS + 1) * 2]++;
        s.dyn_dtree[d_code(dist) * 2]++;
    }
    // (!) This block is disabled in zlib defaults,
    // don't enable it for binary compatibility
    //#ifdef TRUNCATE_BLOCK
    //  /* Try to guess if it is profitable to stop the current block here */
    //  if ((s.last_lit & 0x1fff) === 0 && s.level > 2) {
    //    /* Compute an upper bound for the compressed length */
    //    out_length = s.last_lit*8;
    //    in_length = s.strstart - s.block_start;
    //
    //    for (dcode = 0; dcode < D_CODES; dcode++) {
    //      out_length += s.dyn_dtree[dcode*2]/*.Freq*/ * (5 + extra_dbits[dcode]);
    //    }
    //    out_length >>>= 3;
    //    //Tracev((stderr,"\nlast_lit %u, in %ld, out ~%ld(%ld%%) ",
    //    //       s->last_lit, in_length, out_length,
    //    //       100L - out_length*100L/in_length));
    //    if (s.matches < (s.last_lit>>1)/*int /2*/ && out_length < (in_length>>1)/*int /2*/) {
    //      return true;
    //    }
    //  }
    //#endif
    return s.last_lit === s.lit_bufsize - 1;
/* We avoid equality with lit_bufsize because of wraparound at 64K
   * on 16 bit machines and because stored blocks are restricted to
   * 64K-1 bytes.
   */ }
exports._tr_init = _tr_init;
exports._tr_stored_block = _tr_stored_block;
exports._tr_flush_block = _tr_flush_block;
exports._tr_tally = _tr_tally;
exports._tr_align = _tr_align;

},{"f7e73d4e313a2bb7":"k0GcC"}],"kqcG1":[function(require,module,exports) {
"use strict";
// Note: adler32 takes 12% for level 0 and 2% for level 6.
// It isn't worth it to make additional optimizations as in original.
// Small size is preferable.
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
function adler32(adler, buf, len, pos) {
    var s1 = adler & 0xffff | 0, s2 = adler >>> 16 & 0xffff | 0, n = 0;
    while(len !== 0){
        // Set limit ~ twice less than 5552, to keep
        // s2 in 31-bits, because we force signed ints.
        // in other case %= will fail.
        n = len > 2000 ? 2000 : len;
        len -= n;
        do {
            s1 = s1 + buf[pos++] | 0;
            s2 = s2 + s1 | 0;
        }while (--n);
        s1 %= 65521;
        s2 %= 65521;
    }
    return s1 | s2 << 16 | 0;
}
module.exports = adler32;

},{}],"fMNkF":[function(require,module,exports) {
"use strict";
// Note: we can't get significant speed boost here.
// So write code to minimize size - no pregenerated tables
// and array tools dependencies.
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
// Use ordinary array, since untyped makes no boost here
function makeTable() {
    var c, table = [];
    for(var n = 0; n < 256; n++){
        c = n;
        for(var k = 0; k < 8; k++)c = c & 1 ? 0xEDB88320 ^ c >>> 1 : c >>> 1;
        table[n] = c;
    }
    return table;
}
// Create table on load. Just 255 signed longs. Not a problem.
var crcTable = makeTable();
function crc32(crc, buf, len, pos) {
    var t = crcTable, end = pos + len;
    crc ^= -1;
    for(var i = pos; i < end; i++)crc = crc >>> 8 ^ t[(crc ^ buf[i]) & 0xFF];
    return crc ^ -1; // >>> 0;
}
module.exports = crc32;

},{}],"6LyRz":[function(require,module,exports) {
"use strict";
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
module.exports = {
    2: "need dictionary",
    /* Z_NEED_DICT       2  */ 1: "stream end",
    /* Z_STREAM_END      1  */ 0: "",
    /* Z_OK              0  */ "-1": "file error",
    /* Z_ERRNO         (-1) */ "-2": "stream error",
    /* Z_STREAM_ERROR  (-2) */ "-3": "data error",
    /* Z_DATA_ERROR    (-3) */ "-4": "insufficient memory",
    /* Z_MEM_ERROR     (-4) */ "-5": "buffer error",
    /* Z_BUF_ERROR     (-5) */ "-6": "incompatible version" /* Z_VERSION_ERROR (-6) */ 
};

},{}],"5iIel":[function(require,module,exports) {
"use strict";
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
var utils = require("3693fcbb98dc8df0");
var adler32 = require("6ebe24dff7c86ec6");
var crc32 = require("733ae5de3dad536a");
var inflate_fast = require("d6c5d4935fa23026");
var inflate_table = require("f4fe87fcccdc3597");
var CODES = 0;
var LENS = 1;
var DISTS = 2;
/* Public constants ==========================================================*/ /* ===========================================================================*/ /* Allowed flush values; see deflate() and inflate() below for details */ //var Z_NO_FLUSH      = 0;
//var Z_PARTIAL_FLUSH = 1;
//var Z_SYNC_FLUSH    = 2;
//var Z_FULL_FLUSH    = 3;
var Z_FINISH = 4;
var Z_BLOCK = 5;
var Z_TREES = 6;
/* Return codes for the compression/decompression functions. Negative values
 * are errors, positive values are used for special but normal events.
 */ var Z_OK = 0;
var Z_STREAM_END = 1;
var Z_NEED_DICT = 2;
//var Z_ERRNO         = -1;
var Z_STREAM_ERROR = -2;
var Z_DATA_ERROR = -3;
var Z_MEM_ERROR = -4;
var Z_BUF_ERROR = -5;
//var Z_VERSION_ERROR = -6;
/* The deflate compression method */ var Z_DEFLATED = 8;
/* STATES ====================================================================*/ /* ===========================================================================*/ var HEAD = 1; /* i: waiting for magic header */ 
var FLAGS = 2; /* i: waiting for method and flags (gzip) */ 
var TIME = 3; /* i: waiting for modification time (gzip) */ 
var OS = 4; /* i: waiting for extra flags and operating system (gzip) */ 
var EXLEN = 5; /* i: waiting for extra length (gzip) */ 
var EXTRA = 6; /* i: waiting for extra bytes (gzip) */ 
var NAME = 7; /* i: waiting for end of file name (gzip) */ 
var COMMENT = 8; /* i: waiting for end of comment (gzip) */ 
var HCRC = 9; /* i: waiting for header crc (gzip) */ 
var DICTID = 10; /* i: waiting for dictionary check value */ 
var DICT = 11; /* waiting for inflateSetDictionary() call */ 
var TYPE = 12; /* i: waiting for type bits, including last-flag bit */ 
var TYPEDO = 13; /* i: same, but skip check to exit inflate on new block */ 
var STORED = 14; /* i: waiting for stored size (length and complement) */ 
var COPY_ = 15; /* i/o: same as COPY below, but only first time in */ 
var COPY = 16; /* i/o: waiting for input or output to copy stored block */ 
var TABLE = 17; /* i: waiting for dynamic block table lengths */ 
var LENLENS = 18; /* i: waiting for code length code lengths */ 
var CODELENS = 19; /* i: waiting for length/lit and distance code lengths */ 
var LEN_ = 20; /* i: same as LEN below, but only first time in */ 
var LEN = 21; /* i: waiting for length/lit/eob code */ 
var LENEXT = 22; /* i: waiting for length extra bits */ 
var DIST = 23; /* i: waiting for distance code */ 
var DISTEXT = 24; /* i: waiting for distance extra bits */ 
var MATCH = 25; /* o: waiting for output space to copy string */ 
var LIT = 26; /* o: waiting for output space to write literal */ 
var CHECK = 27; /* i: waiting for 32-bit check value */ 
var LENGTH = 28; /* i: waiting for 32-bit length (gzip) */ 
var DONE = 29; /* finished check, done -- remain here until reset */ 
var BAD = 30; /* got a data error -- remain here until reset */ 
var MEM = 31; /* got an inflate() memory error -- remain here until reset */ 
var SYNC = 32; /* looking for synchronization bytes to restart inflate() */ 
/* ===========================================================================*/ var ENOUGH_LENS = 852;
var ENOUGH_DISTS = 592;
//var ENOUGH =  (ENOUGH_LENS+ENOUGH_DISTS);
var MAX_WBITS = 15;
/* 32K LZ77 window */ var DEF_WBITS = MAX_WBITS;
function zswap32(q) {
    return (q >>> 24 & 0xff) + (q >>> 8 & 0xff00) + ((q & 0xff00) << 8) + ((q & 0xff) << 24);
}
function InflateState() {
    this.mode = 0; /* current inflate mode */ 
    this.last = false; /* true if processing last block */ 
    this.wrap = 0; /* bit 0 true for zlib, bit 1 true for gzip */ 
    this.havedict = false; /* true if dictionary provided */ 
    this.flags = 0; /* gzip header method and flags (0 if zlib) */ 
    this.dmax = 0; /* zlib header max distance (INFLATE_STRICT) */ 
    this.check = 0; /* protected copy of check value */ 
    this.total = 0; /* protected copy of output count */ 
    // TODO: may be {}
    this.head = null; /* where to save gzip header information */ 
    /* sliding window */ this.wbits = 0; /* log base 2 of requested window size */ 
    this.wsize = 0; /* window size or zero if not using window */ 
    this.whave = 0; /* valid bytes in the window */ 
    this.wnext = 0; /* window write index */ 
    this.window = null; /* allocated sliding window, if needed */ 
    /* bit accumulator */ this.hold = 0; /* input bit accumulator */ 
    this.bits = 0; /* number of bits in "in" */ 
    /* for string and stored block copying */ this.length = 0; /* literal or length of data to copy */ 
    this.offset = 0; /* distance back to copy string from */ 
    /* for table and code decoding */ this.extra = 0; /* extra bits needed */ 
    /* fixed and dynamic code tables */ this.lencode = null; /* starting table for length/literal codes */ 
    this.distcode = null; /* starting table for distance codes */ 
    this.lenbits = 0; /* index bits for lencode */ 
    this.distbits = 0; /* index bits for distcode */ 
    /* dynamic table building */ this.ncode = 0; /* number of code length code lengths */ 
    this.nlen = 0; /* number of length code lengths */ 
    this.ndist = 0; /* number of distance code lengths */ 
    this.have = 0; /* number of code lengths in lens[] */ 
    this.next = null; /* next available space in codes[] */ 
    this.lens = new utils.Buf16(320); /* temporary storage for code lengths */ 
    this.work = new utils.Buf16(288); /* work area for code table building */ 
    /*
   because we don't have pointers in js, we use lencode and distcode directly
   as buffers so we don't need codes
  */ //this.codes = new utils.Buf32(ENOUGH);       /* space for code tables */
    this.lendyn = null; /* dynamic table for length/literal codes (JS specific) */ 
    this.distdyn = null; /* dynamic table for distance codes (JS specific) */ 
    this.sane = 0; /* if false, allow invalid distance too far */ 
    this.back = 0; /* bits back of last unprocessed length/lit */ 
    this.was = 0; /* initial length of match */ 
}
function inflateResetKeep(strm) {
    var state;
    if (!strm || !strm.state) return Z_STREAM_ERROR;
    state = strm.state;
    strm.total_in = strm.total_out = state.total = 0;
    strm.msg = ""; /*Z_NULL*/ 
    if (state.wrap) strm.adler = state.wrap & 1;
    state.mode = HEAD;
    state.last = 0;
    state.havedict = 0;
    state.dmax = 32768;
    state.head = null /*Z_NULL*/ ;
    state.hold = 0;
    state.bits = 0;
    //state.lencode = state.distcode = state.next = state.codes;
    state.lencode = state.lendyn = new utils.Buf32(ENOUGH_LENS);
    state.distcode = state.distdyn = new utils.Buf32(ENOUGH_DISTS);
    state.sane = 1;
    state.back = -1;
    //Tracev((stderr, "inflate: reset\n"));
    return Z_OK;
}
function inflateReset(strm) {
    var state;
    if (!strm || !strm.state) return Z_STREAM_ERROR;
    state = strm.state;
    state.wsize = 0;
    state.whave = 0;
    state.wnext = 0;
    return inflateResetKeep(strm);
}
function inflateReset2(strm, windowBits) {
    var wrap;
    var state;
    /* get the state */ if (!strm || !strm.state) return Z_STREAM_ERROR;
    state = strm.state;
    /* extract wrap request from windowBits parameter */ if (windowBits < 0) {
        wrap = 0;
        windowBits = -windowBits;
    } else {
        wrap = (windowBits >> 4) + 1;
        if (windowBits < 48) windowBits &= 15;
    }
    /* set number of window bits, free window if different */ if (windowBits && (windowBits < 8 || windowBits > 15)) return Z_STREAM_ERROR;
    if (state.window !== null && state.wbits !== windowBits) state.window = null;
    /* update state and reset the rest of it */ state.wrap = wrap;
    state.wbits = windowBits;
    return inflateReset(strm);
}
function inflateInit2(strm, windowBits) {
    var ret;
    var state;
    if (!strm) return Z_STREAM_ERROR;
    //strm.msg = Z_NULL;                 /* in case we return an error */
    state = new InflateState();
    //if (state === Z_NULL) return Z_MEM_ERROR;
    //Tracev((stderr, "inflate: allocated\n"));
    strm.state = state;
    state.window = null /*Z_NULL*/ ;
    ret = inflateReset2(strm, windowBits);
    if (ret !== Z_OK) strm.state = null /*Z_NULL*/ ;
    return ret;
}
function inflateInit(strm) {
    return inflateInit2(strm, DEF_WBITS);
}
/*
 Return state with length and distance decoding tables and index sizes set to
 fixed code decoding.  Normally this returns fixed tables from inffixed.h.
 If BUILDFIXED is defined, then instead this routine builds the tables the
 first time it's called, and returns those tables the first time and
 thereafter.  This reduces the size of the code by about 2K bytes, in
 exchange for a little execution time.  However, BUILDFIXED should not be
 used for threaded applications, since the rewriting of the tables and virgin
 may not be thread-safe.
 */ var virgin = true;
var lenfix, distfix; // We have no pointers in JS, so keep tables separate
function fixedtables(state) {
    /* build fixed huffman tables if first call (may not be thread safe) */ if (virgin) {
        var sym;
        lenfix = new utils.Buf32(512);
        distfix = new utils.Buf32(32);
        /* literal/length table */ sym = 0;
        while(sym < 144)state.lens[sym++] = 8;
        while(sym < 256)state.lens[sym++] = 9;
        while(sym < 280)state.lens[sym++] = 7;
        while(sym < 288)state.lens[sym++] = 8;
        inflate_table(LENS, state.lens, 0, 288, lenfix, 0, state.work, {
            bits: 9
        });
        /* distance table */ sym = 0;
        while(sym < 32)state.lens[sym++] = 5;
        inflate_table(DISTS, state.lens, 0, 32, distfix, 0, state.work, {
            bits: 5
        });
        /* do this just once */ virgin = false;
    }
    state.lencode = lenfix;
    state.lenbits = 9;
    state.distcode = distfix;
    state.distbits = 5;
}
/*
 Update the window with the last wsize (normally 32K) bytes written before
 returning.  If window does not exist yet, create it.  This is only called
 when a window is already in use, or when output has been written during this
 inflate call, but the end of the deflate stream has not been reached yet.
 It is also called to create a window for dictionary data when a dictionary
 is loaded.

 Providing output buffers larger than 32K to inflate() should provide a speed
 advantage, since only the last 32K of output is copied to the sliding window
 upon return from inflate(), and since all distances after the first 32K of
 output will fall in the output data, making match copies simpler and faster.
 The advantage may be dependent on the size of the processor's data caches.
 */ function updatewindow(strm, src, end, copy) {
    var dist;
    var state = strm.state;
    /* if it hasn't been done already, allocate space for the window */ if (state.window === null) {
        state.wsize = 1 << state.wbits;
        state.wnext = 0;
        state.whave = 0;
        state.window = new utils.Buf8(state.wsize);
    }
    /* copy state->wsize or less output bytes into the circular window */ if (copy >= state.wsize) {
        utils.arraySet(state.window, src, end - state.wsize, state.wsize, 0);
        state.wnext = 0;
        state.whave = state.wsize;
    } else {
        dist = state.wsize - state.wnext;
        if (dist > copy) dist = copy;
        //zmemcpy(state->window + state->wnext, end - copy, dist);
        utils.arraySet(state.window, src, end - copy, dist, state.wnext);
        copy -= dist;
        if (copy) {
            //zmemcpy(state->window, end - copy, copy);
            utils.arraySet(state.window, src, end - copy, copy, 0);
            state.wnext = copy;
            state.whave = state.wsize;
        } else {
            state.wnext += dist;
            if (state.wnext === state.wsize) state.wnext = 0;
            if (state.whave < state.wsize) state.whave += dist;
        }
    }
    return 0;
}
function inflate(strm, flush) {
    var state;
    var input, output; // input/output buffers
    var next; /* next input INDEX */ 
    var put; /* next output INDEX */ 
    var have, left; /* available input and output */ 
    var hold; /* bit buffer */ 
    var bits; /* bits in bit buffer */ 
    var _in, _out; /* save starting available input and output */ 
    var copy; /* number of stored or match bytes to copy */ 
    var from; /* where to copy match bytes from */ 
    var from_source;
    var here = 0; /* current decoding table entry */ 
    var here_bits, here_op, here_val; // paked "here" denormalized (JS specific)
    //var last;                   /* parent table entry */
    var last_bits, last_op, last_val; // paked "last" denormalized (JS specific)
    var len; /* length to copy for repeats, bits to drop */ 
    var ret; /* return code */ 
    var hbuf = new utils.Buf8(4); /* buffer for gzip header crc calculation */ 
    var opts;
    var n; // temporary var for NEED_BITS
    var order = /* permutation of code lengths */ [
        16,
        17,
        18,
        0,
        8,
        7,
        9,
        6,
        10,
        5,
        11,
        4,
        12,
        3,
        13,
        2,
        14,
        1,
        15
    ];
    if (!strm || !strm.state || !strm.output || !strm.input && strm.avail_in !== 0) return Z_STREAM_ERROR;
    state = strm.state;
    if (state.mode === TYPE) state.mode = TYPEDO;
     /* skip check */ 
    //--- LOAD() ---
    put = strm.next_out;
    output = strm.output;
    left = strm.avail_out;
    next = strm.next_in;
    input = strm.input;
    have = strm.avail_in;
    hold = state.hold;
    bits = state.bits;
    //---
    _in = have;
    _out = left;
    ret = Z_OK;
    inf_leave: for(;;)switch(state.mode){
        case HEAD:
            if (state.wrap === 0) {
                state.mode = TYPEDO;
                break;
            }
            //=== NEEDBITS(16);
            while(bits < 16){
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            }
            //===//
            if (state.wrap & 2 && hold === 0x8b1f) {
                state.check = 0 /*crc32(0L, Z_NULL, 0)*/ ;
                //=== CRC2(state.check, hold);
                hbuf[0] = hold & 0xff;
                hbuf[1] = hold >>> 8 & 0xff;
                state.check = crc32(state.check, hbuf, 2, 0);
                //===//
                //=== INITBITS();
                hold = 0;
                bits = 0;
                //===//
                state.mode = FLAGS;
                break;
            }
            state.flags = 0; /* expect zlib header */ 
            if (state.head) state.head.done = false;
            if (!(state.wrap & 1) || /* check if zlib header allowed */ (((hold & 0xff) << 8) + (hold >> 8)) % 31) {
                strm.msg = "incorrect header check";
                state.mode = BAD;
                break;
            }
            if ((hold & 0x0f) !== Z_DEFLATED) {
                strm.msg = "unknown compression method";
                state.mode = BAD;
                break;
            }
            //--- DROPBITS(4) ---//
            hold >>>= 4;
            bits -= 4;
            //---//
            len = (hold & 0x0f) + 8;
            if (state.wbits === 0) state.wbits = len;
            else if (len > state.wbits) {
                strm.msg = "invalid window size";
                state.mode = BAD;
                break;
            }
            state.dmax = 1 << len;
            //Tracev((stderr, "inflate:   zlib header ok\n"));
            strm.adler = state.check = 1 /*adler32(0L, Z_NULL, 0)*/ ;
            state.mode = hold & 0x200 ? DICTID : TYPE;
            //=== INITBITS();
            hold = 0;
            bits = 0;
            break;
        case FLAGS:
            //=== NEEDBITS(16); */
            while(bits < 16){
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            }
            //===//
            state.flags = hold;
            if ((state.flags & 0xff) !== Z_DEFLATED) {
                strm.msg = "unknown compression method";
                state.mode = BAD;
                break;
            }
            if (state.flags & 0xe000) {
                strm.msg = "unknown header flags set";
                state.mode = BAD;
                break;
            }
            if (state.head) state.head.text = hold >> 8 & 1;
            if (state.flags & 0x0200) {
                //=== CRC2(state.check, hold);
                hbuf[0] = hold & 0xff;
                hbuf[1] = hold >>> 8 & 0xff;
                state.check = crc32(state.check, hbuf, 2, 0);
            //===//
            }
            //=== INITBITS();
            hold = 0;
            bits = 0;
            //===//
            state.mode = TIME;
        /* falls through */ case TIME:
            //=== NEEDBITS(32); */
            while(bits < 32){
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            }
            //===//
            if (state.head) state.head.time = hold;
            if (state.flags & 0x0200) {
                //=== CRC4(state.check, hold)
                hbuf[0] = hold & 0xff;
                hbuf[1] = hold >>> 8 & 0xff;
                hbuf[2] = hold >>> 16 & 0xff;
                hbuf[3] = hold >>> 24 & 0xff;
                state.check = crc32(state.check, hbuf, 4, 0);
            //===
            }
            //=== INITBITS();
            hold = 0;
            bits = 0;
            //===//
            state.mode = OS;
        /* falls through */ case OS:
            //=== NEEDBITS(16); */
            while(bits < 16){
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            }
            //===//
            if (state.head) {
                state.head.xflags = hold & 0xff;
                state.head.os = hold >> 8;
            }
            if (state.flags & 0x0200) {
                //=== CRC2(state.check, hold);
                hbuf[0] = hold & 0xff;
                hbuf[1] = hold >>> 8 & 0xff;
                state.check = crc32(state.check, hbuf, 2, 0);
            //===//
            }
            //=== INITBITS();
            hold = 0;
            bits = 0;
            //===//
            state.mode = EXLEN;
        /* falls through */ case EXLEN:
            if (state.flags & 0x0400) {
                //=== NEEDBITS(16); */
                while(bits < 16){
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                }
                //===//
                state.length = hold;
                if (state.head) state.head.extra_len = hold;
                if (state.flags & 0x0200) {
                    //=== CRC2(state.check, hold);
                    hbuf[0] = hold & 0xff;
                    hbuf[1] = hold >>> 8 & 0xff;
                    state.check = crc32(state.check, hbuf, 2, 0);
                //===//
                }
                //=== INITBITS();
                hold = 0;
                bits = 0;
            //===//
            } else if (state.head) state.head.extra = null /*Z_NULL*/ ;
            state.mode = EXTRA;
        /* falls through */ case EXTRA:
            if (state.flags & 0x0400) {
                copy = state.length;
                if (copy > have) copy = have;
                if (copy) {
                    if (state.head) {
                        len = state.head.extra_len - state.length;
                        if (!state.head.extra) // Use untyped array for more convenient processing later
                        state.head.extra = new Array(state.head.extra_len);
                        utils.arraySet(state.head.extra, input, next, // extra field is limited to 65536 bytes
                        // - no need for additional size check
                        copy, /*len + copy > state.head.extra_max - len ? state.head.extra_max : copy,*/ len);
                    //zmemcpy(state.head.extra + len, next,
                    //        len + copy > state.head.extra_max ?
                    //        state.head.extra_max - len : copy);
                    }
                    if (state.flags & 0x0200) state.check = crc32(state.check, input, copy, next);
                    have -= copy;
                    next += copy;
                    state.length -= copy;
                }
                if (state.length) break inf_leave;
            }
            state.length = 0;
            state.mode = NAME;
        /* falls through */ case NAME:
            if (state.flags & 0x0800) {
                if (have === 0) break inf_leave;
                copy = 0;
                do {
                    // TODO: 2 or 1 bytes?
                    len = input[next + copy++];
                    /* use constant limit because in js we should not preallocate memory */ if (state.head && len && state.length < 65536 /*state.head.name_max*/ ) state.head.name += String.fromCharCode(len);
                }while (len && copy < have);
                if (state.flags & 0x0200) state.check = crc32(state.check, input, copy, next);
                have -= copy;
                next += copy;
                if (len) break inf_leave;
            } else if (state.head) state.head.name = null;
            state.length = 0;
            state.mode = COMMENT;
        /* falls through */ case COMMENT:
            if (state.flags & 0x1000) {
                if (have === 0) break inf_leave;
                copy = 0;
                do {
                    len = input[next + copy++];
                    /* use constant limit because in js we should not preallocate memory */ if (state.head && len && state.length < 65536 /*state.head.comm_max*/ ) state.head.comment += String.fromCharCode(len);
                }while (len && copy < have);
                if (state.flags & 0x0200) state.check = crc32(state.check, input, copy, next);
                have -= copy;
                next += copy;
                if (len) break inf_leave;
            } else if (state.head) state.head.comment = null;
            state.mode = HCRC;
        /* falls through */ case HCRC:
            if (state.flags & 0x0200) {
                //=== NEEDBITS(16); */
                while(bits < 16){
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                }
                //===//
                if (hold !== (state.check & 0xffff)) {
                    strm.msg = "header crc mismatch";
                    state.mode = BAD;
                    break;
                }
                //=== INITBITS();
                hold = 0;
                bits = 0;
            //===//
            }
            if (state.head) {
                state.head.hcrc = state.flags >> 9 & 1;
                state.head.done = true;
            }
            strm.adler = state.check = 0;
            state.mode = TYPE;
            break;
        case DICTID:
            //=== NEEDBITS(32); */
            while(bits < 32){
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            }
            //===//
            strm.adler = state.check = zswap32(hold);
            //=== INITBITS();
            hold = 0;
            bits = 0;
            //===//
            state.mode = DICT;
        /* falls through */ case DICT:
            if (state.havedict === 0) {
                //--- RESTORE() ---
                strm.next_out = put;
                strm.avail_out = left;
                strm.next_in = next;
                strm.avail_in = have;
                state.hold = hold;
                state.bits = bits;
                //---
                return Z_NEED_DICT;
            }
            strm.adler = state.check = 1 /*adler32(0L, Z_NULL, 0)*/ ;
            state.mode = TYPE;
        /* falls through */ case TYPE:
            if (flush === Z_BLOCK || flush === Z_TREES) break inf_leave;
        /* falls through */ case TYPEDO:
            if (state.last) {
                //--- BYTEBITS() ---//
                hold >>>= bits & 7;
                bits -= bits & 7;
                //---//
                state.mode = CHECK;
                break;
            }
            //=== NEEDBITS(3); */
            while(bits < 3){
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            }
            //===//
            state.last = hold & 0x01 /*BITS(1)*/ ;
            //--- DROPBITS(1) ---//
            hold >>>= 1;
            bits -= 1;
            //---//
            switch(hold & 0x03){
                case 0:
                    /* stored block */ //Tracev((stderr, "inflate:     stored block%s\n",
                    //        state.last ? " (last)" : ""));
                    state.mode = STORED;
                    break;
                case 1:
                    /* fixed block */ fixedtables(state);
                    //Tracev((stderr, "inflate:     fixed codes block%s\n",
                    //        state.last ? " (last)" : ""));
                    state.mode = LEN_; /* decode codes */ 
                    if (flush === Z_TREES) {
                        //--- DROPBITS(2) ---//
                        hold >>>= 2;
                        bits -= 2;
                        break inf_leave;
                    }
                    break;
                case 2:
                    /* dynamic block */ //Tracev((stderr, "inflate:     dynamic codes block%s\n",
                    //        state.last ? " (last)" : ""));
                    state.mode = TABLE;
                    break;
                case 3:
                    strm.msg = "invalid block type";
                    state.mode = BAD;
            }
            //--- DROPBITS(2) ---//
            hold >>>= 2;
            bits -= 2;
            break;
        case STORED:
            //--- BYTEBITS() ---// /* go to byte boundary */
            hold >>>= bits & 7;
            bits -= bits & 7;
            //---//
            //=== NEEDBITS(32); */
            while(bits < 32){
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            }
            //===//
            if ((hold & 0xffff) !== (hold >>> 16 ^ 0xffff)) {
                strm.msg = "invalid stored block lengths";
                state.mode = BAD;
                break;
            }
            state.length = hold & 0xffff;
            //Tracev((stderr, "inflate:       stored length %u\n",
            //        state.length));
            //=== INITBITS();
            hold = 0;
            bits = 0;
            //===//
            state.mode = COPY_;
            if (flush === Z_TREES) break inf_leave;
        /* falls through */ case COPY_:
            state.mode = COPY;
        /* falls through */ case COPY:
            copy = state.length;
            if (copy) {
                if (copy > have) copy = have;
                if (copy > left) copy = left;
                if (copy === 0) break inf_leave;
                //--- zmemcpy(put, next, copy); ---
                utils.arraySet(output, input, next, copy, put);
                //---//
                have -= copy;
                next += copy;
                left -= copy;
                put += copy;
                state.length -= copy;
                break;
            }
            //Tracev((stderr, "inflate:       stored end\n"));
            state.mode = TYPE;
            break;
        case TABLE:
            //=== NEEDBITS(14); */
            while(bits < 14){
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            }
            //===//
            state.nlen = (hold & 0x1f) + 257;
            //--- DROPBITS(5) ---//
            hold >>>= 5;
            bits -= 5;
            //---//
            state.ndist = (hold & 0x1f) + 1;
            //--- DROPBITS(5) ---//
            hold >>>= 5;
            bits -= 5;
            //---//
            state.ncode = (hold & 0x0f) + 4;
            //--- DROPBITS(4) ---//
            hold >>>= 4;
            bits -= 4;
            //---//
            //#ifndef PKZIP_BUG_WORKAROUND
            if (state.nlen > 286 || state.ndist > 30) {
                strm.msg = "too many length or distance symbols";
                state.mode = BAD;
                break;
            }
            //#endif
            //Tracev((stderr, "inflate:       table sizes ok\n"));
            state.have = 0;
            state.mode = LENLENS;
        /* falls through */ case LENLENS:
            while(state.have < state.ncode){
                //=== NEEDBITS(3);
                while(bits < 3){
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                }
                //===//
                state.lens[order[state.have++]] = hold & 0x07; //BITS(3);
                //--- DROPBITS(3) ---//
                hold >>>= 3;
                bits -= 3;
            //---//
            }
            while(state.have < 19)state.lens[order[state.have++]] = 0;
            // We have separate tables & no pointers. 2 commented lines below not needed.
            //state.next = state.codes;
            //state.lencode = state.next;
            // Switch to use dynamic table
            state.lencode = state.lendyn;
            state.lenbits = 7;
            opts = {
                bits: state.lenbits
            };
            ret = inflate_table(CODES, state.lens, 0, 19, state.lencode, 0, state.work, opts);
            state.lenbits = opts.bits;
            if (ret) {
                strm.msg = "invalid code lengths set";
                state.mode = BAD;
                break;
            }
            //Tracev((stderr, "inflate:       code lengths ok\n"));
            state.have = 0;
            state.mode = CODELENS;
        /* falls through */ case CODELENS:
            while(state.have < state.nlen + state.ndist){
                for(;;){
                    here = state.lencode[hold & (1 << state.lenbits) - 1]; /*BITS(state.lenbits)*/ 
                    here_bits = here >>> 24;
                    here_op = here >>> 16 & 0xff;
                    here_val = here & 0xffff;
                    if (here_bits <= bits) break;
                    //--- PULLBYTE() ---//
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                //---//
                }
                if (here_val < 16) {
                    //--- DROPBITS(here.bits) ---//
                    hold >>>= here_bits;
                    bits -= here_bits;
                    //---//
                    state.lens[state.have++] = here_val;
                } else {
                    if (here_val === 16) {
                        //=== NEEDBITS(here.bits + 2);
                        n = here_bits + 2;
                        while(bits < n){
                            if (have === 0) break inf_leave;
                            have--;
                            hold += input[next++] << bits;
                            bits += 8;
                        }
                        //===//
                        //--- DROPBITS(here.bits) ---//
                        hold >>>= here_bits;
                        bits -= here_bits;
                        //---//
                        if (state.have === 0) {
                            strm.msg = "invalid bit length repeat";
                            state.mode = BAD;
                            break;
                        }
                        len = state.lens[state.have - 1];
                        copy = 3 + (hold & 0x03); //BITS(2);
                        //--- DROPBITS(2) ---//
                        hold >>>= 2;
                        bits -= 2;
                    //---//
                    } else if (here_val === 17) {
                        //=== NEEDBITS(here.bits + 3);
                        n = here_bits + 3;
                        while(bits < n){
                            if (have === 0) break inf_leave;
                            have--;
                            hold += input[next++] << bits;
                            bits += 8;
                        }
                        //===//
                        //--- DROPBITS(here.bits) ---//
                        hold >>>= here_bits;
                        bits -= here_bits;
                        //---//
                        len = 0;
                        copy = 3 + (hold & 0x07); //BITS(3);
                        //--- DROPBITS(3) ---//
                        hold >>>= 3;
                        bits -= 3;
                    //---//
                    } else {
                        //=== NEEDBITS(here.bits + 7);
                        n = here_bits + 7;
                        while(bits < n){
                            if (have === 0) break inf_leave;
                            have--;
                            hold += input[next++] << bits;
                            bits += 8;
                        }
                        //===//
                        //--- DROPBITS(here.bits) ---//
                        hold >>>= here_bits;
                        bits -= here_bits;
                        //---//
                        len = 0;
                        copy = 11 + (hold & 0x7f); //BITS(7);
                        //--- DROPBITS(7) ---//
                        hold >>>= 7;
                        bits -= 7;
                    //---//
                    }
                    if (state.have + copy > state.nlen + state.ndist) {
                        strm.msg = "invalid bit length repeat";
                        state.mode = BAD;
                        break;
                    }
                    while(copy--)state.lens[state.have++] = len;
                }
            }
            /* handle error breaks in while */ if (state.mode === BAD) break;
            /* check for end-of-block code (better have one) */ if (state.lens[256] === 0) {
                strm.msg = "invalid code -- missing end-of-block";
                state.mode = BAD;
                break;
            }
            /* build code tables -- note: do not change the lenbits or distbits
           values here (9 and 6) without reading the comments in inftrees.h
           concerning the ENOUGH constants, which depend on those values */ state.lenbits = 9;
            opts = {
                bits: state.lenbits
            };
            ret = inflate_table(LENS, state.lens, 0, state.nlen, state.lencode, 0, state.work, opts);
            // We have separate tables & no pointers. 2 commented lines below not needed.
            // state.next_index = opts.table_index;
            state.lenbits = opts.bits;
            // state.lencode = state.next;
            if (ret) {
                strm.msg = "invalid literal/lengths set";
                state.mode = BAD;
                break;
            }
            state.distbits = 6;
            //state.distcode.copy(state.codes);
            // Switch to use dynamic table
            state.distcode = state.distdyn;
            opts = {
                bits: state.distbits
            };
            ret = inflate_table(DISTS, state.lens, state.nlen, state.ndist, state.distcode, 0, state.work, opts);
            // We have separate tables & no pointers. 2 commented lines below not needed.
            // state.next_index = opts.table_index;
            state.distbits = opts.bits;
            // state.distcode = state.next;
            if (ret) {
                strm.msg = "invalid distances set";
                state.mode = BAD;
                break;
            }
            //Tracev((stderr, 'inflate:       codes ok\n'));
            state.mode = LEN_;
            if (flush === Z_TREES) break inf_leave;
        /* falls through */ case LEN_:
            state.mode = LEN;
        /* falls through */ case LEN:
            if (have >= 6 && left >= 258) {
                //--- RESTORE() ---
                strm.next_out = put;
                strm.avail_out = left;
                strm.next_in = next;
                strm.avail_in = have;
                state.hold = hold;
                state.bits = bits;
                //---
                inflate_fast(strm, _out);
                //--- LOAD() ---
                put = strm.next_out;
                output = strm.output;
                left = strm.avail_out;
                next = strm.next_in;
                input = strm.input;
                have = strm.avail_in;
                hold = state.hold;
                bits = state.bits;
                //---
                if (state.mode === TYPE) state.back = -1;
                break;
            }
            state.back = 0;
            for(;;){
                here = state.lencode[hold & (1 << state.lenbits) - 1]; /*BITS(state.lenbits)*/ 
                here_bits = here >>> 24;
                here_op = here >>> 16 & 0xff;
                here_val = here & 0xffff;
                if (here_bits <= bits) break;
                //--- PULLBYTE() ---//
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            //---//
            }
            if (here_op && (here_op & 0xf0) === 0) {
                last_bits = here_bits;
                last_op = here_op;
                last_val = here_val;
                for(;;){
                    here = state.lencode[last_val + ((hold & (1 << last_bits + last_op) - 1) >> last_bits)];
                    here_bits = here >>> 24;
                    here_op = here >>> 16 & 0xff;
                    here_val = here & 0xffff;
                    if (last_bits + here_bits <= bits) break;
                    //--- PULLBYTE() ---//
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                //---//
                }
                //--- DROPBITS(last.bits) ---//
                hold >>>= last_bits;
                bits -= last_bits;
                //---//
                state.back += last_bits;
            }
            //--- DROPBITS(here.bits) ---//
            hold >>>= here_bits;
            bits -= here_bits;
            //---//
            state.back += here_bits;
            state.length = here_val;
            if (here_op === 0) {
                //Tracevv((stderr, here.val >= 0x20 && here.val < 0x7f ?
                //        "inflate:         literal '%c'\n" :
                //        "inflate:         literal 0x%02x\n", here.val));
                state.mode = LIT;
                break;
            }
            if (here_op & 32) {
                //Tracevv((stderr, "inflate:         end of block\n"));
                state.back = -1;
                state.mode = TYPE;
                break;
            }
            if (here_op & 64) {
                strm.msg = "invalid literal/length code";
                state.mode = BAD;
                break;
            }
            state.extra = here_op & 15;
            state.mode = LENEXT;
        /* falls through */ case LENEXT:
            if (state.extra) {
                //=== NEEDBITS(state.extra);
                n = state.extra;
                while(bits < n){
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                }
                //===//
                state.length += hold & (1 << state.extra) - 1 /*BITS(state.extra)*/ ;
                //--- DROPBITS(state.extra) ---//
                hold >>>= state.extra;
                bits -= state.extra;
                //---//
                state.back += state.extra;
            }
            //Tracevv((stderr, "inflate:         length %u\n", state.length));
            state.was = state.length;
            state.mode = DIST;
        /* falls through */ case DIST:
            for(;;){
                here = state.distcode[hold & (1 << state.distbits) - 1]; /*BITS(state.distbits)*/ 
                here_bits = here >>> 24;
                here_op = here >>> 16 & 0xff;
                here_val = here & 0xffff;
                if (here_bits <= bits) break;
                //--- PULLBYTE() ---//
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            //---//
            }
            if ((here_op & 0xf0) === 0) {
                last_bits = here_bits;
                last_op = here_op;
                last_val = here_val;
                for(;;){
                    here = state.distcode[last_val + ((hold & (1 << last_bits + last_op) - 1) >> last_bits)];
                    here_bits = here >>> 24;
                    here_op = here >>> 16 & 0xff;
                    here_val = here & 0xffff;
                    if (last_bits + here_bits <= bits) break;
                    //--- PULLBYTE() ---//
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                //---//
                }
                //--- DROPBITS(last.bits) ---//
                hold >>>= last_bits;
                bits -= last_bits;
                //---//
                state.back += last_bits;
            }
            //--- DROPBITS(here.bits) ---//
            hold >>>= here_bits;
            bits -= here_bits;
            //---//
            state.back += here_bits;
            if (here_op & 64) {
                strm.msg = "invalid distance code";
                state.mode = BAD;
                break;
            }
            state.offset = here_val;
            state.extra = here_op & 15;
            state.mode = DISTEXT;
        /* falls through */ case DISTEXT:
            if (state.extra) {
                //=== NEEDBITS(state.extra);
                n = state.extra;
                while(bits < n){
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                }
                //===//
                state.offset += hold & (1 << state.extra) - 1 /*BITS(state.extra)*/ ;
                //--- DROPBITS(state.extra) ---//
                hold >>>= state.extra;
                bits -= state.extra;
                //---//
                state.back += state.extra;
            }
            //#ifdef INFLATE_STRICT
            if (state.offset > state.dmax) {
                strm.msg = "invalid distance too far back";
                state.mode = BAD;
                break;
            }
            //#endif
            //Tracevv((stderr, "inflate:         distance %u\n", state.offset));
            state.mode = MATCH;
        /* falls through */ case MATCH:
            if (left === 0) break inf_leave;
            copy = _out - left;
            if (state.offset > copy) {
                copy = state.offset - copy;
                if (copy > state.whave) {
                    if (state.sane) {
                        strm.msg = "invalid distance too far back";
                        state.mode = BAD;
                        break;
                    }
                }
                if (copy > state.wnext) {
                    copy -= state.wnext;
                    from = state.wsize - copy;
                } else from = state.wnext - copy;
                if (copy > state.length) copy = state.length;
                from_source = state.window;
            } else {
                from_source = output;
                from = put - state.offset;
                copy = state.length;
            }
            if (copy > left) copy = left;
            left -= copy;
            state.length -= copy;
            do output[put++] = from_source[from++];
            while (--copy);
            if (state.length === 0) state.mode = LEN;
            break;
        case LIT:
            if (left === 0) break inf_leave;
            output[put++] = state.length;
            left--;
            state.mode = LEN;
            break;
        case CHECK:
            if (state.wrap) {
                //=== NEEDBITS(32);
                while(bits < 32){
                    if (have === 0) break inf_leave;
                    have--;
                    // Use '|' instead of '+' to make sure that result is signed
                    hold |= input[next++] << bits;
                    bits += 8;
                }
                //===//
                _out -= left;
                strm.total_out += _out;
                state.total += _out;
                if (_out) strm.adler = state.check = /*UPDATE(state.check, put - _out, _out);*/ state.flags ? crc32(state.check, output, _out, put - _out) : adler32(state.check, output, _out, put - _out);
                _out = left;
                // NB: crc32 stored as signed 32-bit int, zswap32 returns signed too
                if ((state.flags ? hold : zswap32(hold)) !== state.check) {
                    strm.msg = "incorrect data check";
                    state.mode = BAD;
                    break;
                }
                //=== INITBITS();
                hold = 0;
                bits = 0;
            //===//
            //Tracev((stderr, "inflate:   check matches trailer\n"));
            }
            state.mode = LENGTH;
        /* falls through */ case LENGTH:
            if (state.wrap && state.flags) {
                //=== NEEDBITS(32);
                while(bits < 32){
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                }
                //===//
                if (hold !== (state.total & 0xffffffff)) {
                    strm.msg = "incorrect length check";
                    state.mode = BAD;
                    break;
                }
                //=== INITBITS();
                hold = 0;
                bits = 0;
            //===//
            //Tracev((stderr, "inflate:   length matches trailer\n"));
            }
            state.mode = DONE;
        /* falls through */ case DONE:
            ret = Z_STREAM_END;
            break inf_leave;
        case BAD:
            ret = Z_DATA_ERROR;
            break inf_leave;
        case MEM:
            return Z_MEM_ERROR;
        case SYNC:
        /* falls through */ default:
            return Z_STREAM_ERROR;
    }
    // inf_leave <- here is real place for "goto inf_leave", emulated via "break inf_leave"
    /*
     Return from inflate(), updating the total counts and the check value.
     If there was no progress during the inflate() call, return a buffer
     error.  Call updatewindow() to create and/or update the window state.
     Note: a memory error from inflate() is non-recoverable.
   */ //--- RESTORE() ---
    strm.next_out = put;
    strm.avail_out = left;
    strm.next_in = next;
    strm.avail_in = have;
    state.hold = hold;
    state.bits = bits;
    //---
    if (state.wsize || _out !== strm.avail_out && state.mode < BAD && (state.mode < CHECK || flush !== Z_FINISH)) {
        if (updatewindow(strm, strm.output, strm.next_out, _out - strm.avail_out)) {
            state.mode = MEM;
            return Z_MEM_ERROR;
        }
    }
    _in -= strm.avail_in;
    _out -= strm.avail_out;
    strm.total_in += _in;
    strm.total_out += _out;
    state.total += _out;
    if (state.wrap && _out) strm.adler = state.check = /*UPDATE(state.check, strm.next_out - _out, _out);*/ state.flags ? crc32(state.check, output, _out, strm.next_out - _out) : adler32(state.check, output, _out, strm.next_out - _out);
    strm.data_type = state.bits + (state.last ? 64 : 0) + (state.mode === TYPE ? 128 : 0) + (state.mode === LEN_ || state.mode === COPY_ ? 256 : 0);
    if ((_in === 0 && _out === 0 || flush === Z_FINISH) && ret === Z_OK) ret = Z_BUF_ERROR;
    return ret;
}
function inflateEnd(strm) {
    if (!strm || !strm.state /*|| strm->zfree == (free_func)0*/ ) return Z_STREAM_ERROR;
    var state = strm.state;
    if (state.window) state.window = null;
    strm.state = null;
    return Z_OK;
}
function inflateGetHeader(strm, head) {
    var state;
    /* check state */ if (!strm || !strm.state) return Z_STREAM_ERROR;
    state = strm.state;
    if ((state.wrap & 2) === 0) return Z_STREAM_ERROR;
    /* save header structure */ state.head = head;
    head.done = false;
    return Z_OK;
}
function inflateSetDictionary(strm, dictionary) {
    var dictLength = dictionary.length;
    var state;
    var dictid;
    var ret;
    /* check state */ if (!strm /* == Z_NULL */  || !strm.state /* == Z_NULL */ ) return Z_STREAM_ERROR;
    state = strm.state;
    if (state.wrap !== 0 && state.mode !== DICT) return Z_STREAM_ERROR;
    /* check for correct dictionary identifier */ if (state.mode === DICT) {
        dictid = 1; /* adler32(0, null, 0)*/ 
        /* dictid = adler32(dictid, dictionary, dictLength); */ dictid = adler32(dictid, dictionary, dictLength, 0);
        if (dictid !== state.check) return Z_DATA_ERROR;
    }
    /* copy dictionary to window using updatewindow(), which will amend the
   existing dictionary if appropriate */ ret = updatewindow(strm, dictionary, dictLength, dictLength);
    if (ret) {
        state.mode = MEM;
        return Z_MEM_ERROR;
    }
    state.havedict = 1;
    // Tracev((stderr, "inflate:   dictionary set\n"));
    return Z_OK;
}
exports.inflateReset = inflateReset;
exports.inflateReset2 = inflateReset2;
exports.inflateResetKeep = inflateResetKeep;
exports.inflateInit = inflateInit;
exports.inflateInit2 = inflateInit2;
exports.inflate = inflate;
exports.inflateEnd = inflateEnd;
exports.inflateGetHeader = inflateGetHeader;
exports.inflateSetDictionary = inflateSetDictionary;
exports.inflateInfo = "pako inflate (from Nodeca project)"; /* Not implemented
exports.inflateCopy = inflateCopy;
exports.inflateGetDictionary = inflateGetDictionary;
exports.inflateMark = inflateMark;
exports.inflatePrime = inflatePrime;
exports.inflateSync = inflateSync;
exports.inflateSyncPoint = inflateSyncPoint;
exports.inflateUndermine = inflateUndermine;
*/ 

},{"3693fcbb98dc8df0":"k0GcC","6ebe24dff7c86ec6":"kqcG1","733ae5de3dad536a":"fMNkF","d6c5d4935fa23026":"kBLS6","f4fe87fcccdc3597":"6cuhA"}],"kBLS6":[function(require,module,exports) {
"use strict";
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
// See state defs from inflate.js
var BAD = 30; /* got a data error -- remain here until reset */ 
var TYPE = 12; /* i: waiting for type bits, including last-flag bit */ 
/*
   Decode literal, length, and distance codes and write out the resulting
   literal and match bytes until either not enough input or output is
   available, an end-of-block is encountered, or a data error is encountered.
   When large enough input and output buffers are supplied to inflate(), for
   example, a 16K input buffer and a 64K output buffer, more than 95% of the
   inflate execution time is spent in this routine.

   Entry assumptions:

        state.mode === LEN
        strm.avail_in >= 6
        strm.avail_out >= 258
        start >= strm.avail_out
        state.bits < 8

   On return, state.mode is one of:

        LEN -- ran out of enough output space or enough available input
        TYPE -- reached end of block code, inflate() to interpret next block
        BAD -- error in block data

   Notes:

    - The maximum input bits used by a length/distance pair is 15 bits for the
      length code, 5 bits for the length extra, 15 bits for the distance code,
      and 13 bits for the distance extra.  This totals 48 bits, or six bytes.
      Therefore if strm.avail_in >= 6, then there is enough input to avoid
      checking for available input while decoding.

    - The maximum bytes that a single length/distance pair can output is 258
      bytes, which is the maximum length that can be coded.  inflate_fast()
      requires strm.avail_out >= 258 for each loop to avoid checking for
      output space.
 */ module.exports = function inflate_fast(strm, start) {
    var state;
    var _in; /* local strm.input */ 
    var last; /* have enough input while in < last */ 
    var _out; /* local strm.output */ 
    var beg; /* inflate()'s initial strm.output */ 
    var end; /* while out < end, enough space available */ 
    //#ifdef INFLATE_STRICT
    var dmax; /* maximum distance from zlib header */ 
    //#endif
    var wsize; /* window size or zero if not using window */ 
    var whave; /* valid bytes in the window */ 
    var wnext; /* window write index */ 
    // Use `s_window` instead `window`, avoid conflict with instrumentation tools
    var s_window; /* allocated sliding window, if wsize != 0 */ 
    var hold; /* local strm.hold */ 
    var bits; /* local strm.bits */ 
    var lcode; /* local strm.lencode */ 
    var dcode; /* local strm.distcode */ 
    var lmask; /* mask for first level of length codes */ 
    var dmask; /* mask for first level of distance codes */ 
    var here; /* retrieved table entry */ 
    var op; /* code bits, operation, extra bits, or */ 
    /*  window position, window bytes to copy */ var len; /* match length, unused bytes */ 
    var dist; /* match distance */ 
    var from; /* where to copy match from */ 
    var from_source;
    var input, output; // JS specific, because we have no pointers
    /* copy state to local variables */ state = strm.state;
    //here = state.here;
    _in = strm.next_in;
    input = strm.input;
    last = _in + (strm.avail_in - 5);
    _out = strm.next_out;
    output = strm.output;
    beg = _out - (start - strm.avail_out);
    end = _out + (strm.avail_out - 257);
    //#ifdef INFLATE_STRICT
    dmax = state.dmax;
    //#endif
    wsize = state.wsize;
    whave = state.whave;
    wnext = state.wnext;
    s_window = state.window;
    hold = state.hold;
    bits = state.bits;
    lcode = state.lencode;
    dcode = state.distcode;
    lmask = (1 << state.lenbits) - 1;
    dmask = (1 << state.distbits) - 1;
    /* decode literals and length/distances until end-of-block or not enough
     input data or output space */ top: do {
        if (bits < 15) {
            hold += input[_in++] << bits;
            bits += 8;
            hold += input[_in++] << bits;
            bits += 8;
        }
        here = lcode[hold & lmask];
        dolen: for(;;){
            op = here >>> 24 /*here.bits*/ ;
            hold >>>= op;
            bits -= op;
            op = here >>> 16 & 0xff /*here.op*/ ;
            if (op === 0) //Tracevv((stderr, here.val >= 0x20 && here.val < 0x7f ?
            //        "inflate:         literal '%c'\n" :
            //        "inflate:         literal 0x%02x\n", here.val));
            output[_out++] = here & 0xffff /*here.val*/ ;
            else if (op & 16) {
                len = here & 0xffff /*here.val*/ ;
                op &= 15; /* number of extra bits */ 
                if (op) {
                    if (bits < op) {
                        hold += input[_in++] << bits;
                        bits += 8;
                    }
                    len += hold & (1 << op) - 1;
                    hold >>>= op;
                    bits -= op;
                }
                //Tracevv((stderr, "inflate:         length %u\n", len));
                if (bits < 15) {
                    hold += input[_in++] << bits;
                    bits += 8;
                    hold += input[_in++] << bits;
                    bits += 8;
                }
                here = dcode[hold & dmask];
                dodist: for(;;){
                    op = here >>> 24 /*here.bits*/ ;
                    hold >>>= op;
                    bits -= op;
                    op = here >>> 16 & 0xff /*here.op*/ ;
                    if (op & 16) {
                        dist = here & 0xffff /*here.val*/ ;
                        op &= 15; /* number of extra bits */ 
                        if (bits < op) {
                            hold += input[_in++] << bits;
                            bits += 8;
                            if (bits < op) {
                                hold += input[_in++] << bits;
                                bits += 8;
                            }
                        }
                        dist += hold & (1 << op) - 1;
                        //#ifdef INFLATE_STRICT
                        if (dist > dmax) {
                            strm.msg = "invalid distance too far back";
                            state.mode = BAD;
                            break top;
                        }
                        //#endif
                        hold >>>= op;
                        bits -= op;
                        //Tracevv((stderr, "inflate:         distance %u\n", dist));
                        op = _out - beg; /* max distance in output */ 
                        if (dist > op) {
                            op = dist - op; /* distance back in window */ 
                            if (op > whave) {
                                if (state.sane) {
                                    strm.msg = "invalid distance too far back";
                                    state.mode = BAD;
                                    break top;
                                }
                            }
                            from = 0; // window index
                            from_source = s_window;
                            if (wnext === 0) {
                                from += wsize - op;
                                if (op < len) {
                                    len -= op;
                                    do output[_out++] = s_window[from++];
                                    while (--op);
                                    from = _out - dist; /* rest from output */ 
                                    from_source = output;
                                }
                            } else if (wnext < op) {
                                from += wsize + wnext - op;
                                op -= wnext;
                                if (op < len) {
                                    len -= op;
                                    do output[_out++] = s_window[from++];
                                    while (--op);
                                    from = 0;
                                    if (wnext < len) {
                                        op = wnext;
                                        len -= op;
                                        do output[_out++] = s_window[from++];
                                        while (--op);
                                        from = _out - dist; /* rest from output */ 
                                        from_source = output;
                                    }
                                }
                            } else {
                                from += wnext - op;
                                if (op < len) {
                                    len -= op;
                                    do output[_out++] = s_window[from++];
                                    while (--op);
                                    from = _out - dist; /* rest from output */ 
                                    from_source = output;
                                }
                            }
                            while(len > 2){
                                output[_out++] = from_source[from++];
                                output[_out++] = from_source[from++];
                                output[_out++] = from_source[from++];
                                len -= 3;
                            }
                            if (len) {
                                output[_out++] = from_source[from++];
                                if (len > 1) output[_out++] = from_source[from++];
                            }
                        } else {
                            from = _out - dist; /* copy direct from output */ 
                            do {
                                output[_out++] = output[from++];
                                output[_out++] = output[from++];
                                output[_out++] = output[from++];
                                len -= 3;
                            }while (len > 2);
                            if (len) {
                                output[_out++] = output[from++];
                                if (len > 1) output[_out++] = output[from++];
                            }
                        }
                    } else if ((op & 64) === 0) {
                        here = dcode[(here & 0xffff) + (hold & (1 << op) - 1)];
                        continue dodist;
                    } else {
                        strm.msg = "invalid distance code";
                        state.mode = BAD;
                        break top;
                    }
                    break; // need to emulate goto via "continue"
                }
            } else if ((op & 64) === 0) {
                here = lcode[(here & 0xffff) + (hold & (1 << op) - 1)];
                continue dolen;
            } else if (op & 32) {
                //Tracevv((stderr, "inflate:         end of block\n"));
                state.mode = TYPE;
                break top;
            } else {
                strm.msg = "invalid literal/length code";
                state.mode = BAD;
                break top;
            }
            break; // need to emulate goto via "continue"
        }
    }while (_in < last && _out < end);
    /* return unused bytes (on entry, bits < 8, so in won't go too far back) */ len = bits >> 3;
    _in -= len;
    bits -= len << 3;
    hold &= (1 << bits) - 1;
    /* update state and return */ strm.next_in = _in;
    strm.next_out = _out;
    strm.avail_in = _in < last ? 5 + (last - _in) : 5 - (_in - last);
    strm.avail_out = _out < end ? 257 + (end - _out) : 257 - (_out - end);
    state.hold = hold;
    state.bits = bits;
    return;
};

},{}],"6cuhA":[function(require,module,exports) {
"use strict";
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
var utils = require("11b3fa99ba8f3902");
var MAXBITS = 15;
var ENOUGH_LENS = 852;
var ENOUGH_DISTS = 592;
//var ENOUGH = (ENOUGH_LENS+ENOUGH_DISTS);
var CODES = 0;
var LENS = 1;
var DISTS = 2;
var lbase = [
    /* Length codes 257..285 base */ 3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    13,
    15,
    17,
    19,
    23,
    27,
    31,
    35,
    43,
    51,
    59,
    67,
    83,
    99,
    115,
    131,
    163,
    195,
    227,
    258,
    0,
    0
];
var lext = [
    /* Length codes 257..285 extra */ 16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    17,
    17,
    17,
    17,
    18,
    18,
    18,
    18,
    19,
    19,
    19,
    19,
    20,
    20,
    20,
    20,
    21,
    21,
    21,
    21,
    16,
    72,
    78
];
var dbase = [
    /* Distance codes 0..29 base */ 1,
    2,
    3,
    4,
    5,
    7,
    9,
    13,
    17,
    25,
    33,
    49,
    65,
    97,
    129,
    193,
    257,
    385,
    513,
    769,
    1025,
    1537,
    2049,
    3073,
    4097,
    6145,
    8193,
    12289,
    16385,
    24577,
    0,
    0
];
var dext = [
    /* Distance codes 0..29 extra */ 16,
    16,
    16,
    16,
    17,
    17,
    18,
    18,
    19,
    19,
    20,
    20,
    21,
    21,
    22,
    22,
    23,
    23,
    24,
    24,
    25,
    25,
    26,
    26,
    27,
    27,
    28,
    28,
    29,
    29,
    64,
    64
];
module.exports = function inflate_table(type, lens, lens_index, codes, table, table_index, work, opts) {
    var bits = opts.bits;
    //here = opts.here; /* table entry for duplication */
    var len = 0; /* a code's length in bits */ 
    var sym = 0; /* index of code symbols */ 
    var min = 0, max = 0; /* minimum and maximum code lengths */ 
    var root = 0; /* number of index bits for root table */ 
    var curr = 0; /* number of index bits for current table */ 
    var drop = 0; /* code bits to drop for sub-table */ 
    var left = 0; /* number of prefix codes available */ 
    var used = 0; /* code entries in table used */ 
    var huff = 0; /* Huffman code */ 
    var incr; /* for incrementing code, index */ 
    var fill; /* index for replicating entries */ 
    var low; /* low bits for current root entry */ 
    var mask; /* mask for low root bits */ 
    var next; /* next available space in table */ 
    var base = null; /* base value table to use */ 
    var base_index = 0;
    //  var shoextra;    /* extra bits table to use */
    var end; /* use base and extra for symbol > end */ 
    var count = new utils.Buf16(MAXBITS + 1); //[MAXBITS+1];    /* number of codes of each length */
    var offs = new utils.Buf16(MAXBITS + 1); //[MAXBITS+1];     /* offsets in table for each length */
    var extra = null;
    var extra_index = 0;
    var here_bits, here_op, here_val;
    /*
   Process a set of code lengths to create a canonical Huffman code.  The
   code lengths are lens[0..codes-1].  Each length corresponds to the
   symbols 0..codes-1.  The Huffman code is generated by first sorting the
   symbols by length from short to long, and retaining the symbol order
   for codes with equal lengths.  Then the code starts with all zero bits
   for the first code of the shortest length, and the codes are integer
   increments for the same length, and zeros are appended as the length
   increases.  For the deflate format, these bits are stored backwards
   from their more natural integer increment ordering, and so when the
   decoding tables are built in the large loop below, the integer codes
   are incremented backwards.

   This routine assumes, but does not check, that all of the entries in
   lens[] are in the range 0..MAXBITS.  The caller must assure this.
   1..MAXBITS is interpreted as that code length.  zero means that that
   symbol does not occur in this code.

   The codes are sorted by computing a count of codes for each length,
   creating from that a table of starting indices for each length in the
   sorted table, and then entering the symbols in order in the sorted
   table.  The sorted table is work[], with that space being provided by
   the caller.

   The length counts are used for other purposes as well, i.e. finding
   the minimum and maximum length codes, determining if there are any
   codes at all, checking for a valid set of lengths, and looking ahead
   at length counts to determine sub-table sizes when building the
   decoding tables.
   */ /* accumulate lengths for codes (assumes lens[] all in 0..MAXBITS) */ for(len = 0; len <= MAXBITS; len++)count[len] = 0;
    for(sym = 0; sym < codes; sym++)count[lens[lens_index + sym]]++;
    /* bound code lengths, force root to be within code lengths */ root = bits;
    for(max = MAXBITS; max >= 1; max--){
        if (count[max] !== 0) break;
    }
    if (root > max) root = max;
    if (max === 0) {
        //table.op[opts.table_index] = 64;  //here.op = (var char)64;    /* invalid code marker */
        //table.bits[opts.table_index] = 1;   //here.bits = (var char)1;
        //table.val[opts.table_index++] = 0;   //here.val = (var short)0;
        table[table_index++] = 20971520;
        //table.op[opts.table_index] = 64;
        //table.bits[opts.table_index] = 1;
        //table.val[opts.table_index++] = 0;
        table[table_index++] = 20971520;
        opts.bits = 1;
        return 0; /* no symbols, but wait for decoding to report error */ 
    }
    for(min = 1; min < max; min++){
        if (count[min] !== 0) break;
    }
    if (root < min) root = min;
    /* check for an over-subscribed or incomplete set of lengths */ left = 1;
    for(len = 1; len <= MAXBITS; len++){
        left <<= 1;
        left -= count[len];
        if (left < 0) return -1;
         /* over-subscribed */ 
    }
    if (left > 0 && (type === CODES || max !== 1)) return -1; /* incomplete set */ 
    /* generate offsets into symbol table for each length for sorting */ offs[1] = 0;
    for(len = 1; len < MAXBITS; len++)offs[len + 1] = offs[len] + count[len];
    /* sort symbols by length, by symbol order within each length */ for(sym = 0; sym < codes; sym++)if (lens[lens_index + sym] !== 0) work[offs[lens[lens_index + sym]]++] = sym;
    /*
   Create and fill in decoding tables.  In this loop, the table being
   filled is at next and has curr index bits.  The code being used is huff
   with length len.  That code is converted to an index by dropping drop
   bits off of the bottom.  For codes where len is less than drop + curr,
   those top drop + curr - len bits are incremented through all values to
   fill the table with replicated entries.

   root is the number of index bits for the root table.  When len exceeds
   root, sub-tables are created pointed to by the root entry with an index
   of the low root bits of huff.  This is saved in low to check for when a
   new sub-table should be started.  drop is zero when the root table is
   being filled, and drop is root when sub-tables are being filled.

   When a new sub-table is needed, it is necessary to look ahead in the
   code lengths to determine what size sub-table is needed.  The length
   counts are used for this, and so count[] is decremented as codes are
   entered in the tables.

   used keeps track of how many table entries have been allocated from the
   provided *table space.  It is checked for LENS and DIST tables against
   the constants ENOUGH_LENS and ENOUGH_DISTS to guard against changes in
   the initial root table size constants.  See the comments in inftrees.h
   for more information.

   sym increments through all symbols, and the loop terminates when
   all codes of length max, i.e. all codes, have been processed.  This
   routine permits incomplete codes, so another loop after this one fills
   in the rest of the decoding tables with invalid code markers.
   */ /* set up for code type */ // poor man optimization - use if-else instead of switch,
    // to avoid deopts in old v8
    if (type === CODES) {
        base = extra = work; /* dummy value--not used */ 
        end = 19;
    } else if (type === LENS) {
        base = lbase;
        base_index -= 257;
        extra = lext;
        extra_index -= 257;
        end = 256;
    } else {
        base = dbase;
        extra = dext;
        end = -1;
    }
    /* initialize opts for loop */ huff = 0; /* starting code */ 
    sym = 0; /* starting code symbol */ 
    len = min; /* starting code length */ 
    next = table_index; /* current table to fill in */ 
    curr = root; /* current table index bits */ 
    drop = 0; /* current bits to drop from code for index */ 
    low = -1; /* trigger new sub-table when len > root */ 
    used = 1 << root; /* use root table entries */ 
    mask = used - 1; /* mask for comparing low */ 
    /* check available table space */ if (type === LENS && used > ENOUGH_LENS || type === DISTS && used > ENOUGH_DISTS) return 1;
    /* process all codes and make table entries */ for(;;){
        /* create table entry */ here_bits = len - drop;
        if (work[sym] < end) {
            here_op = 0;
            here_val = work[sym];
        } else if (work[sym] > end) {
            here_op = extra[extra_index + work[sym]];
            here_val = base[base_index + work[sym]];
        } else {
            here_op = 96; /* end of block */ 
            here_val = 0;
        }
        /* replicate for those indices with low len bits equal to huff */ incr = 1 << len - drop;
        fill = 1 << curr;
        min = fill; /* save offset to next table */ 
        do {
            fill -= incr;
            table[next + (huff >> drop) + fill] = here_bits << 24 | here_op << 16 | here_val | 0;
        }while (fill !== 0);
        /* backwards increment the len-bit code huff */ incr = 1 << len - 1;
        while(huff & incr)incr >>= 1;
        if (incr !== 0) {
            huff &= incr - 1;
            huff += incr;
        } else huff = 0;
        /* go to next symbol, update count, len */ sym++;
        if (--count[len] === 0) {
            if (len === max) break;
            len = lens[lens_index + work[sym]];
        }
        /* create new sub-table if needed */ if (len > root && (huff & mask) !== low) {
            /* if first time, transition to sub-tables */ if (drop === 0) drop = root;
            /* increment past last table */ next += min; /* here min is 1 << curr */ 
            /* determine length of next table */ curr = len - drop;
            left = 1 << curr;
            while(curr + drop < max){
                left -= count[curr + drop];
                if (left <= 0) break;
                curr++;
                left <<= 1;
            }
            /* check for enough space */ used += 1 << curr;
            if (type === LENS && used > ENOUGH_LENS || type === DISTS && used > ENOUGH_DISTS) return 1;
            /* point entry in root table to sub-table */ low = huff & mask;
            /*table.op[low] = curr;
      table.bits[low] = root;
      table.val[low] = next - opts.table_index;*/ table[low] = root << 24 | curr << 16 | next - table_index | 0;
        }
    }
    /* fill in remaining table entry if code is incomplete (guaranteed to have
   at most one remaining entry, since if the code is incomplete, the
   maximum code length that was allowed to get this far is one bit) */ if (huff !== 0) //table.op[next + huff] = 64;            /* invalid code marker */
    //table.bits[next + huff] = len - drop;
    //table.val[next + huff] = 0;
    table[next + huff] = len - drop << 24 | 4194304;
    /* set return parameters */ //opts.table_index += used;
    opts.bits = root;
    return 0;
};

},{"11b3fa99ba8f3902":"k0GcC"}],"3iJxm":[function(require,module,exports) {
"use strict";
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
module.exports = {
    /* Allowed flush values; see deflate() and inflate() below for details */ Z_NO_FLUSH: 0,
    Z_PARTIAL_FLUSH: 1,
    Z_SYNC_FLUSH: 2,
    Z_FULL_FLUSH: 3,
    Z_FINISH: 4,
    Z_BLOCK: 5,
    Z_TREES: 6,
    /* Return codes for the compression/decompression functions. Negative values
  * are errors, positive values are used for special but normal events.
  */ Z_OK: 0,
    Z_STREAM_END: 1,
    Z_NEED_DICT: 2,
    Z_ERRNO: -1,
    Z_STREAM_ERROR: -2,
    Z_DATA_ERROR: -3,
    //Z_MEM_ERROR:     -4,
    Z_BUF_ERROR: -5,
    //Z_VERSION_ERROR: -6,
    /* compression levels */ Z_NO_COMPRESSION: 0,
    Z_BEST_SPEED: 1,
    Z_BEST_COMPRESSION: 9,
    Z_DEFAULT_COMPRESSION: -1,
    Z_FILTERED: 1,
    Z_HUFFMAN_ONLY: 2,
    Z_RLE: 3,
    Z_FIXED: 4,
    Z_DEFAULT_STRATEGY: 0,
    /* Possible values of the data_type field (though see inflate()) */ Z_BINARY: 0,
    Z_TEXT: 1,
    //Z_ASCII:                1, // = Z_TEXT (deprecated)
    Z_UNKNOWN: 2,
    /* The deflate compression method */ Z_DEFLATED: 8
};

},{}],"1VUnY":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
const utils_1 = require("6adef7f335aac87f");
/**
 * Returns true if the bloom is a valid bloom
 * @param bloom The bloom
 */ function isBloom(bloom) {
    if (typeof bloom !== "string") return false;
    if (!/^(0x)?[0-9a-f]{512}$/i.test(bloom)) return false;
    if (/^(0x)?[0-9a-f]{512}$/.test(bloom) || /^(0x)?[0-9A-F]{512}$/.test(bloom)) return true;
    return false;
}
exports.isBloom = isBloom;
/**
 * Returns true if the value is part of the given bloom
 * note: false positives are possible.
 * @param bloom encoded bloom
 * @param value The value
 */ function isInBloom(bloom, value) {
    if (typeof value === "object" && value.constructor === Uint8Array) value = utils_1.bytesToHex(value);
    const hash = utils_1.keccak256(value).replace("0x", "");
    for(let i = 0; i < 12; i += 4){
        // calculate bit position in bloom filter that must be active
        const bitpos = (parseInt(hash.substr(i, 2), 16) << 8) + parseInt(hash.substr(i + 2, 2), 16) & 2047;
        // test if bitpos in bloom is active
        const code = codePointToInt(bloom.charCodeAt(bloom.length - 1 - Math.floor(bitpos / 4)));
        const offset = 1 << bitpos % 4;
        if ((code & offset) !== offset) return false;
    }
    return true;
}
exports.isInBloom = isInBloom;
/**
 * Code points to int
 * @param codePoint The code point
 */ function codePointToInt(codePoint) {
    if (codePoint >= 48 && codePoint <= 57) /* ['0'..'9'] -> [0..9] */ return codePoint - 48;
    if (codePoint >= 65 && codePoint <= 70) /* ['A'..'F'] -> [10..15] */ return codePoint - 55;
    if (codePoint >= 97 && codePoint <= 102) /* ['a'..'f'] -> [10..15] */ return codePoint - 87;
    throw new Error("invalid bloom");
}
/**
 * Returns true if the ethereum users address is part of the given bloom.
 * note: false positives are possible.
 * @param bloom encoded bloom
 * @param address the address to test
 */ function isUserEthereumAddressInBloom(bloom, ethereumAddress) {
    if (!isBloom(bloom)) throw new Error("Invalid bloom given");
    if (!isAddress(ethereumAddress)) throw new Error(`Invalid ethereum address given: "${ethereumAddress}"`);
    // you have to pad the ethereum address to 32 bytes
    // else the bloom filter does not work
    // this is only if your matching the USERS
    // ethereum address. Contract address do not need this
    // hence why we have 2 methods
    // (0x is not in the 2nd parameter of padleft so 64 chars is fine)
    const address = utils_1.padLeft(ethereumAddress, 64);
    return isInBloom(bloom, address);
}
exports.isUserEthereumAddressInBloom = isUserEthereumAddressInBloom;
/**
 * Returns true if the contract address is part of the given bloom.
 * note: false positives are possible.
 * @param bloom encoded bloom
 * @param contractAddress the contract address to test
 */ function isContractAddressInBloom(bloom, contractAddress) {
    if (!isBloom(bloom)) throw new Error("Invalid bloom given");
    if (!isAddress(contractAddress)) throw new Error(`Invalid contract address given: "${contractAddress}"`);
    return isInBloom(bloom, contractAddress);
}
exports.isContractAddressInBloom = isContractAddressInBloom;
/**
 * Returns true if the topic is part of the given bloom.
 * note: false positives are possible.
 * @param bloom encoded bloom
 * @param topic the topic encoded hex
 */ function isTopicInBloom(bloom, topic) {
    if (!isBloom(bloom)) throw new Error("Invalid bloom given");
    if (!isTopic(topic)) throw new Error("Invalid topic");
    return isInBloom(bloom, topic);
}
exports.isTopicInBloom = isTopicInBloom;
/**
 * Checks if its a valid topic
 * @param topic encoded hex topic
 */ function isTopic(topic) {
    if (typeof topic !== "string") return false;
    if (!/^(0x)?[0-9a-f]{64}$/i.test(topic)) return false;
    else if (/^(0x)?[0-9a-f]{64}$/.test(topic) || /^(0x)?[0-9A-F]{64}$/.test(topic)) return true;
    return false;
}
exports.isTopic = isTopic;
/**
 * Is valid address
 * @param address The address
 */ function isAddress(address) {
    if (typeof address !== "string") return false;
    if (address.match(/^(0x)?[0-9a-fA-F]{40}$/)) return true;
    if (address.match(/^XE[0-9]{2}[0-9A-Za-z]{30,31}$/)) return true;
    return false;
}
exports.isAddress = isAddress;

},{"6adef7f335aac87f":"1RaCD"}],"1RaCD":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
const sha3_1 = require("e956c6c0daaaaf00");
const utils_1 = require("2f4f99252fb15da6");
/**
 * Keccak256 hash
 * @param data The data
 */ function keccak256(data) {
    return bytesToHex(sha3_1.keccak_256(toByteArray(data)));
}
exports.keccak256 = keccak256;
/**
 * Adding padding to string on the left
 * @param value The value
 * @param chars The chars
 */ exports.padLeft = (value, chars)=>{
    const hasPrefix = /^0x/i.test(value) || typeof value === "number";
    value = value.toString().replace(/^0x/i, "");
    const padding = chars - value.length + 1 >= 0 ? chars - value.length + 1 : 0;
    return (hasPrefix ? "0x" : "") + new Array(padding).join("0") + value;
};
/**
 * Convert bytes to hex
 * @param bytes The bytes
 */ function bytesToHex(bytes) {
    return "0x" + utils_1.bytesToHex(bytes);
}
exports.bytesToHex = bytesToHex;
/**
 * To byte array
 * @param value The value
 */ function toByteArray(value) {
    if (value == null) throw new Error("cannot convert null value to array");
    if (typeof value === "string") {
        const match = value.match(/^(0x)?[0-9a-fA-F]*$/);
        if (!match) throw new Error("invalid hexidecimal string");
        if (match[1] !== "0x") throw new Error("hex string must have 0x prefix");
        value = value.substring(2);
        if (value.length % 2) value = "0" + value;
        const result = [];
        for(let i = 0; i < value.length; i += 2)result.push(parseInt(value.substr(i, 2), 16));
        return addSlice(new Uint8Array(result));
    }
    if (isByteArray(value)) return addSlice(new Uint8Array(value));
    throw new Error("invalid arrayify value");
}
exports.toByteArray = toByteArray;
/**
 * Is byte array
 * @param value The value
 */ function isByteArray(value) {
    if (!value || // tslint:disable-next-line: radix
    parseInt(String(value.length)) != value.length || typeof value === "string") return false;
    for(let i = 0; i < value.length; i++){
        const v = value[i];
        // tslint:disable-next-line: radix
        if (v < 0 || v >= 256 || parseInt(String(v)) != v) return false;
    }
    return true;
}
/**
 * Add slice to array
 * @param array The array
 */ function addSlice(array) {
    if (array.slice !== undefined) return array;
    array.slice = ()=>{
        const args = Array.prototype.slice.call(arguments);
        return addSlice(new Uint8Array(Array.prototype.slice.apply(array, args)));
    };
    return array;
}

},{"e956c6c0daaaaf00":"18IUA","2f4f99252fb15da6":"bXBkz"}],"18IUA":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.shake256 = exports.shake128 = exports.keccak_512 = exports.keccak_384 = exports.keccak_256 = exports.keccak_224 = exports.sha3_512 = exports.sha3_384 = exports.sha3_256 = exports.sha3_224 = exports.Keccak = void 0;
exports.keccakP = keccakP;
const _assert_js_1 = require("14db7b8ea2b5bceb");
const _u64_js_1 = require("45e8a44e40fd6b7f");
const utils_js_1 = require("5a04751f3e786b49");
// SHA3 (keccak) is based on a new design: basically, the internal state is bigger than output size.
// It's called a sponge function.
// Various per round constants calculations
const SHA3_PI = [];
const SHA3_ROTL = [];
const _SHA3_IOTA = [];
const _0n = /* @__PURE__ */ BigInt(0);
const _1n = /* @__PURE__ */ BigInt(1);
const _2n = /* @__PURE__ */ BigInt(2);
const _7n = /* @__PURE__ */ BigInt(7);
const _256n = /* @__PURE__ */ BigInt(256);
const _0x71n = /* @__PURE__ */ BigInt(0x71);
for(let round = 0, R = _1n, x = 1, y = 0; round < 24; round++){
    // Pi
    [x, y] = [
        y,
        (2 * x + 3 * y) % 5
    ];
    SHA3_PI.push(2 * (5 * y + x));
    // Rotational
    SHA3_ROTL.push((round + 1) * (round + 2) / 2 % 64);
    // Iota
    let t = _0n;
    for(let j = 0; j < 7; j++){
        R = (R << _1n ^ (R >> _7n) * _0x71n) % _256n;
        if (R & _2n) t ^= _1n << (_1n << /* @__PURE__ */ BigInt(j)) - _1n;
    }
    _SHA3_IOTA.push(t);
}
const [SHA3_IOTA_H, SHA3_IOTA_L] = /* @__PURE__ */ (0, _u64_js_1.split)(_SHA3_IOTA, true);
// Left rotation (without 0, 32, 64)
const rotlH = (h, l, s)=>s > 32 ? (0, _u64_js_1.rotlBH)(h, l, s) : (0, _u64_js_1.rotlSH)(h, l, s);
const rotlL = (h, l, s)=>s > 32 ? (0, _u64_js_1.rotlBL)(h, l, s) : (0, _u64_js_1.rotlSL)(h, l, s);
// Same as keccakf1600, but allows to skip some rounds
function keccakP(s, rounds = 24) {
    const B = new Uint32Array(10);
    // NOTE: all indices are x2 since we store state as u32 instead of u64 (bigints to slow in js)
    for(let round = 24 - rounds; round < 24; round++){
        // Theta θ
        for(let x = 0; x < 10; x++)B[x] = s[x] ^ s[x + 10] ^ s[x + 20] ^ s[x + 30] ^ s[x + 40];
        for(let x = 0; x < 10; x += 2){
            const idx1 = (x + 8) % 10;
            const idx0 = (x + 2) % 10;
            const B0 = B[idx0];
            const B1 = B[idx0 + 1];
            const Th = rotlH(B0, B1, 1) ^ B[idx1];
            const Tl = rotlL(B0, B1, 1) ^ B[idx1 + 1];
            for(let y = 0; y < 50; y += 10){
                s[x + y] ^= Th;
                s[x + y + 1] ^= Tl;
            }
        }
        // Rho (ρ) and Pi (π)
        let curH = s[2];
        let curL = s[3];
        for(let t = 0; t < 24; t++){
            const shift = SHA3_ROTL[t];
            const Th = rotlH(curH, curL, shift);
            const Tl = rotlL(curH, curL, shift);
            const PI = SHA3_PI[t];
            curH = s[PI];
            curL = s[PI + 1];
            s[PI] = Th;
            s[PI + 1] = Tl;
        }
        // Chi (χ)
        for(let y = 0; y < 50; y += 10){
            for(let x = 0; x < 10; x++)B[x] = s[y + x];
            for(let x = 0; x < 10; x++)s[y + x] ^= ~B[(x + 2) % 10] & B[(x + 4) % 10];
        }
        // Iota (ι)
        s[0] ^= SHA3_IOTA_H[round];
        s[1] ^= SHA3_IOTA_L[round];
    }
    B.fill(0);
}
class Keccak extends utils_js_1.Hash {
    // NOTE: we accept arguments in bytes instead of bits here.
    constructor(blockLen, suffix, outputLen, enableXOF = false, rounds = 24){
        super();
        this.blockLen = blockLen;
        this.suffix = suffix;
        this.outputLen = outputLen;
        this.enableXOF = enableXOF;
        this.rounds = rounds;
        this.pos = 0;
        this.posOut = 0;
        this.finished = false;
        this.destroyed = false;
        // Can be passed from user as dkLen
        (0, _assert_js_1.number)(outputLen);
        // 1600 = 5x5 matrix of 64bit.  1600 bits === 200 bytes
        if (0 >= this.blockLen || this.blockLen >= 200) throw new Error("Sha3 supports only keccak-f1600 function");
        this.state = new Uint8Array(200);
        this.state32 = (0, utils_js_1.u32)(this.state);
    }
    keccak() {
        if (!utils_js_1.isLE) (0, utils_js_1.byteSwap32)(this.state32);
        keccakP(this.state32, this.rounds);
        if (!utils_js_1.isLE) (0, utils_js_1.byteSwap32)(this.state32);
        this.posOut = 0;
        this.pos = 0;
    }
    update(data) {
        (0, _assert_js_1.exists)(this);
        const { blockLen, state } = this;
        data = (0, utils_js_1.toBytes)(data);
        const len = data.length;
        for(let pos = 0; pos < len;){
            const take = Math.min(blockLen - this.pos, len - pos);
            for(let i = 0; i < take; i++)state[this.pos++] ^= data[pos++];
            if (this.pos === blockLen) this.keccak();
        }
        return this;
    }
    finish() {
        if (this.finished) return;
        this.finished = true;
        const { state, suffix, pos, blockLen } = this;
        // Do the padding
        state[pos] ^= suffix;
        if ((suffix & 0x80) !== 0 && pos === blockLen - 1) this.keccak();
        state[blockLen - 1] ^= 0x80;
        this.keccak();
    }
    writeInto(out) {
        (0, _assert_js_1.exists)(this, false);
        (0, _assert_js_1.bytes)(out);
        this.finish();
        const bufferOut = this.state;
        const { blockLen } = this;
        for(let pos = 0, len = out.length; pos < len;){
            if (this.posOut >= blockLen) this.keccak();
            const take = Math.min(blockLen - this.posOut, len - pos);
            out.set(bufferOut.subarray(this.posOut, this.posOut + take), pos);
            this.posOut += take;
            pos += take;
        }
        return out;
    }
    xofInto(out) {
        // Sha3/Keccak usage with XOF is probably mistake, only SHAKE instances can do XOF
        if (!this.enableXOF) throw new Error("XOF is not possible for this instance");
        return this.writeInto(out);
    }
    xof(bytes) {
        (0, _assert_js_1.number)(bytes);
        return this.xofInto(new Uint8Array(bytes));
    }
    digestInto(out) {
        (0, _assert_js_1.output)(out, this);
        if (this.finished) throw new Error("digest() was already called");
        this.writeInto(out);
        this.destroy();
        return out;
    }
    digest() {
        return this.digestInto(new Uint8Array(this.outputLen));
    }
    destroy() {
        this.destroyed = true;
        this.state.fill(0);
    }
    _cloneInto(to) {
        const { blockLen, suffix, outputLen, rounds, enableXOF } = this;
        to || (to = new Keccak(blockLen, suffix, outputLen, enableXOF, rounds));
        to.state32.set(this.state32);
        to.pos = this.pos;
        to.posOut = this.posOut;
        to.finished = this.finished;
        to.rounds = rounds;
        // Suffix can change in cSHAKE
        to.suffix = suffix;
        to.outputLen = outputLen;
        to.enableXOF = enableXOF;
        to.destroyed = this.destroyed;
        return to;
    }
}
exports.Keccak = Keccak;
const gen = (suffix, blockLen, outputLen)=>(0, utils_js_1.wrapConstructor)(()=>new Keccak(blockLen, suffix, outputLen));
exports.sha3_224 = gen(0x06, 144, 28);
/**
 * SHA3-256 hash function
 * @param message - that would be hashed
 */ exports.sha3_256 = gen(0x06, 136, 32);
exports.sha3_384 = gen(0x06, 104, 48);
exports.sha3_512 = gen(0x06, 72, 64);
exports.keccak_224 = gen(0x01, 144, 28);
/**
 * keccak-256 hash function. Different from SHA3-256.
 * @param message - that would be hashed
 */ exports.keccak_256 = gen(0x01, 136, 32);
exports.keccak_384 = gen(0x01, 104, 48);
exports.keccak_512 = gen(0x01, 72, 64);
const genShake = (suffix, blockLen, outputLen)=>(0, utils_js_1.wrapXOFConstructorWithOpts)((opts = {})=>new Keccak(blockLen, suffix, opts.dkLen === undefined ? outputLen : opts.dkLen, true));
exports.shake128 = genShake(0x1f, 168, 16);
exports.shake256 = genShake(0x1f, 136, 32);

},{"14db7b8ea2b5bceb":"2SEX7","45e8a44e40fd6b7f":"kyFSr","5a04751f3e786b49":"bXBkz"}],"2SEX7":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.isBytes = isBytes;
exports.number = number;
exports.bool = bool;
exports.bytes = bytes;
exports.hash = hash;
exports.exists = exists;
exports.output = output;
function number(n) {
    if (!Number.isSafeInteger(n) || n < 0) throw new Error(`positive integer expected, not ${n}`);
}
function bool(b) {
    if (typeof b !== "boolean") throw new Error(`boolean expected, not ${b}`);
}
// copied from utils
function isBytes(a) {
    return a instanceof Uint8Array || a != null && typeof a === "object" && a.constructor.name === "Uint8Array";
}
function bytes(b, ...lengths) {
    if (!isBytes(b)) throw new Error("Uint8Array expected");
    if (lengths.length > 0 && !lengths.includes(b.length)) throw new Error(`Uint8Array expected of length ${lengths}, not of length=${b.length}`);
}
function hash(h) {
    if (typeof h !== "function" || typeof h.create !== "function") throw new Error("Hash should be wrapped by utils.wrapConstructor");
    number(h.outputLen);
    number(h.blockLen);
}
function exists(instance, checkFinished = true) {
    if (instance.destroyed) throw new Error("Hash instance has been destroyed");
    if (checkFinished && instance.finished) throw new Error("Hash#digest() has already been called");
}
function output(out, instance) {
    bytes(out);
    const min = instance.outputLen;
    if (out.length < min) throw new Error(`digestInto() expects output buffer of length at least ${min}`);
}
const assert = {
    number,
    bool,
    bytes,
    hash,
    exists,
    output
};
exports.default = assert;

},{}],"kyFSr":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.add5L = exports.add5H = exports.add4H = exports.add4L = exports.add3H = exports.add3L = exports.rotlBL = exports.rotlBH = exports.rotlSL = exports.rotlSH = exports.rotr32L = exports.rotr32H = exports.rotrBL = exports.rotrBH = exports.rotrSL = exports.rotrSH = exports.shrSL = exports.shrSH = exports.toBig = void 0;
exports.fromBig = fromBig;
exports.split = split;
exports.add = add;
const U32_MASK64 = /* @__PURE__ */ BigInt(2 ** 32 - 1);
const _32n = /* @__PURE__ */ BigInt(32);
// We are not using BigUint64Array, because they are extremely slow as per 2022
function fromBig(n, le = false) {
    if (le) return {
        h: Number(n & U32_MASK64),
        l: Number(n >> _32n & U32_MASK64)
    };
    return {
        h: Number(n >> _32n & U32_MASK64) | 0,
        l: Number(n & U32_MASK64) | 0
    };
}
function split(lst, le = false) {
    let Ah = new Uint32Array(lst.length);
    let Al = new Uint32Array(lst.length);
    for(let i = 0; i < lst.length; i++){
        const { h, l } = fromBig(lst[i], le);
        [Ah[i], Al[i]] = [
            h,
            l
        ];
    }
    return [
        Ah,
        Al
    ];
}
const toBig = (h, l)=>BigInt(h >>> 0) << _32n | BigInt(l >>> 0);
exports.toBig = toBig;
// for Shift in [0, 32)
const shrSH = (h, _l, s)=>h >>> s;
exports.shrSH = shrSH;
const shrSL = (h, l, s)=>h << 32 - s | l >>> s;
exports.shrSL = shrSL;
// Right rotate for Shift in [1, 32)
const rotrSH = (h, l, s)=>h >>> s | l << 32 - s;
exports.rotrSH = rotrSH;
const rotrSL = (h, l, s)=>h << 32 - s | l >>> s;
exports.rotrSL = rotrSL;
// Right rotate for Shift in (32, 64), NOTE: 32 is special case.
const rotrBH = (h, l, s)=>h << 64 - s | l >>> s - 32;
exports.rotrBH = rotrBH;
const rotrBL = (h, l, s)=>h >>> s - 32 | l << 64 - s;
exports.rotrBL = rotrBL;
// Right rotate for shift===32 (just swaps l&h)
const rotr32H = (_h, l)=>l;
exports.rotr32H = rotr32H;
const rotr32L = (h, _l)=>h;
exports.rotr32L = rotr32L;
// Left rotate for Shift in [1, 32)
const rotlSH = (h, l, s)=>h << s | l >>> 32 - s;
exports.rotlSH = rotlSH;
const rotlSL = (h, l, s)=>l << s | h >>> 32 - s;
exports.rotlSL = rotlSL;
// Left rotate for Shift in (32, 64), NOTE: 32 is special case.
const rotlBH = (h, l, s)=>l << s - 32 | h >>> 64 - s;
exports.rotlBH = rotlBH;
const rotlBL = (h, l, s)=>h << s - 32 | l >>> 64 - s;
exports.rotlBL = rotlBL;
// JS uses 32-bit signed integers for bitwise operations which means we cannot
// simple take carry out of low bit sum by shift, we need to use division.
function add(Ah, Al, Bh, Bl) {
    const l = (Al >>> 0) + (Bl >>> 0);
    return {
        h: Ah + Bh + (l / 2 ** 32 | 0) | 0,
        l: l | 0
    };
}
// Addition with more than 2 elements
const add3L = (Al, Bl, Cl)=>(Al >>> 0) + (Bl >>> 0) + (Cl >>> 0);
exports.add3L = add3L;
const add3H = (low, Ah, Bh, Ch)=>Ah + Bh + Ch + (low / 2 ** 32 | 0) | 0;
exports.add3H = add3H;
const add4L = (Al, Bl, Cl, Dl)=>(Al >>> 0) + (Bl >>> 0) + (Cl >>> 0) + (Dl >>> 0);
exports.add4L = add4L;
const add4H = (low, Ah, Bh, Ch, Dh)=>Ah + Bh + Ch + Dh + (low / 2 ** 32 | 0) | 0;
exports.add4H = add4H;
const add5L = (Al, Bl, Cl, Dl, El)=>(Al >>> 0) + (Bl >>> 0) + (Cl >>> 0) + (Dl >>> 0) + (El >>> 0);
exports.add5L = add5L;
const add5H = (low, Ah, Bh, Ch, Dh, Eh)=>Ah + Bh + Ch + Dh + Eh + (low / 2 ** 32 | 0) | 0;
exports.add5H = add5H;
// prettier-ignore
const u64 = {
    fromBig,
    split,
    toBig,
    shrSH,
    shrSL,
    rotrSH,
    rotrSL,
    rotrBH,
    rotrBL,
    rotr32H,
    rotr32L,
    rotlSH,
    rotlSL,
    rotlBH,
    rotlBL,
    add,
    add3L,
    add3H,
    add4L,
    add4H,
    add5H,
    add5L
};
exports.default = u64;

},{}],"bXBkz":[function(require,module,exports) {
"use strict";
/*! noble-hashes - MIT License (c) 2022 Paul Miller (paulmillr.com) */ Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Hash = exports.nextTick = exports.byteSwapIfBE = exports.byteSwap = exports.isLE = exports.rotl = exports.rotr = exports.createView = exports.u32 = exports.u8 = void 0;
exports.isBytes = isBytes;
exports.byteSwap32 = byteSwap32;
exports.bytesToHex = bytesToHex;
exports.hexToBytes = hexToBytes;
exports.asyncLoop = asyncLoop;
exports.utf8ToBytes = utf8ToBytes;
exports.toBytes = toBytes;
exports.concatBytes = concatBytes;
exports.checkOpts = checkOpts;
exports.wrapConstructor = wrapConstructor;
exports.wrapConstructorWithOpts = wrapConstructorWithOpts;
exports.wrapXOFConstructorWithOpts = wrapXOFConstructorWithOpts;
exports.randomBytes = randomBytes;
// We use WebCrypto aka globalThis.crypto, which exists in browsers and node.js 16+.
// node.js versions earlier than v19 don't declare it in global scope.
// For node.js, package.json#exports field mapping rewrites import
// from `crypto` to `cryptoNode`, which imports native module.
// Makes the utils un-importable in browsers without a bundler.
// Once node.js 18 is deprecated (2025-04-30), we can just drop the import.
const crypto_1 = require("308a0f9b8753b4af");
const _assert_js_1 = require("f33264417aee0570");
// export { isBytes } from './_assert.js';
// We can't reuse isBytes from _assert, because somehow this causes huge perf issues
function isBytes(a) {
    return a instanceof Uint8Array || a != null && typeof a === "object" && a.constructor.name === "Uint8Array";
}
// Cast array to different type
const u8 = (arr)=>new Uint8Array(arr.buffer, arr.byteOffset, arr.byteLength);
exports.u8 = u8;
const u32 = (arr)=>new Uint32Array(arr.buffer, arr.byteOffset, Math.floor(arr.byteLength / 4));
exports.u32 = u32;
// Cast array to view
const createView = (arr)=>new DataView(arr.buffer, arr.byteOffset, arr.byteLength);
exports.createView = createView;
// The rotate right (circular right shift) operation for uint32
const rotr = (word, shift)=>word << 32 - shift | word >>> shift;
exports.rotr = rotr;
// The rotate left (circular left shift) operation for uint32
const rotl = (word, shift)=>word << shift | word >>> 32 - shift >>> 0;
exports.rotl = rotl;
exports.isLE = new Uint8Array(new Uint32Array([
    0x11223344
]).buffer)[0] === 0x44;
// The byte swap operation for uint32
const byteSwap = (word)=>word << 24 & 0xff000000 | word << 8 & 0xff0000 | word >>> 8 & 0xff00 | word >>> 24 & 0xff;
exports.byteSwap = byteSwap;
// Conditionally byte swap if on a big-endian platform
exports.byteSwapIfBE = exports.isLE ? (n)=>n : (n)=>(0, exports.byteSwap)(n);
// In place byte swap for Uint32Array
function byteSwap32(arr) {
    for(let i = 0; i < arr.length; i++)arr[i] = (0, exports.byteSwap)(arr[i]);
}
// Array where index 0xf0 (240) is mapped to string 'f0'
const hexes = /* @__PURE__ */ Array.from({
    length: 256
}, (_, i)=>i.toString(16).padStart(2, "0"));
/**
 * @example bytesToHex(Uint8Array.from([0xca, 0xfe, 0x01, 0x23])) // 'cafe0123'
 */ function bytesToHex(bytes) {
    (0, _assert_js_1.bytes)(bytes);
    // pre-caching improves the speed 6x
    let hex = "";
    for(let i = 0; i < bytes.length; i++)hex += hexes[bytes[i]];
    return hex;
}
// We use optimized technique to convert hex string to byte array
const asciis = {
    _0: 48,
    _9: 57,
    _A: 65,
    _F: 70,
    _a: 97,
    _f: 102
};
function asciiToBase16(char) {
    if (char >= asciis._0 && char <= asciis._9) return char - asciis._0;
    if (char >= asciis._A && char <= asciis._F) return char - (asciis._A - 10);
    if (char >= asciis._a && char <= asciis._f) return char - (asciis._a - 10);
    return;
}
/**
 * @example hexToBytes('cafe0123') // Uint8Array.from([0xca, 0xfe, 0x01, 0x23])
 */ function hexToBytes(hex) {
    if (typeof hex !== "string") throw new Error("hex string expected, got " + typeof hex);
    const hl = hex.length;
    const al = hl / 2;
    if (hl % 2) throw new Error("padded hex string expected, got unpadded hex of length " + hl);
    const array = new Uint8Array(al);
    for(let ai = 0, hi = 0; ai < al; ai++, hi += 2){
        const n1 = asciiToBase16(hex.charCodeAt(hi));
        const n2 = asciiToBase16(hex.charCodeAt(hi + 1));
        if (n1 === undefined || n2 === undefined) {
            const char = hex[hi] + hex[hi + 1];
            throw new Error('hex string expected, got non-hex character "' + char + '" at index ' + hi);
        }
        array[ai] = n1 * 16 + n2;
    }
    return array;
}
// There is no setImmediate in browser and setTimeout is slow.
// call of async fn will return Promise, which will be fullfiled only on
// next scheduler queue processing step and this is exactly what we need.
const nextTick = async ()=>{};
exports.nextTick = nextTick;
// Returns control to thread each 'tick' ms to avoid blocking
async function asyncLoop(iters, tick, cb) {
    let ts = Date.now();
    for(let i = 0; i < iters; i++){
        cb(i);
        // Date.now() is not monotonic, so in case if clock goes backwards we return return control too
        const diff = Date.now() - ts;
        if (diff >= 0 && diff < tick) continue;
        await (0, exports.nextTick)();
        ts += diff;
    }
}
/**
 * @example utf8ToBytes('abc') // new Uint8Array([97, 98, 99])
 */ function utf8ToBytes(str) {
    if (typeof str !== "string") throw new Error(`utf8ToBytes expected string, got ${typeof str}`);
    return new Uint8Array(new TextEncoder().encode(str)); // https://bugzil.la/1681809
}
/**
 * Normalizes (non-hex) string or Uint8Array to Uint8Array.
 * Warning: when Uint8Array is passed, it would NOT get copied.
 * Keep in mind for future mutable operations.
 */ function toBytes(data) {
    if (typeof data === "string") data = utf8ToBytes(data);
    (0, _assert_js_1.bytes)(data);
    return data;
}
/**
 * Copies several Uint8Arrays into one.
 */ function concatBytes(...arrays) {
    let sum = 0;
    for(let i = 0; i < arrays.length; i++){
        const a = arrays[i];
        (0, _assert_js_1.bytes)(a);
        sum += a.length;
    }
    const res = new Uint8Array(sum);
    for(let i = 0, pad = 0; i < arrays.length; i++){
        const a = arrays[i];
        res.set(a, pad);
        pad += a.length;
    }
    return res;
}
// For runtime check if class implements interface
class Hash {
    // Safe version that clones internal state
    clone() {
        return this._cloneInto();
    }
}
exports.Hash = Hash;
const toStr = {}.toString;
function checkOpts(defaults, opts) {
    if (opts !== undefined && toStr.call(opts) !== "[object Object]") throw new Error("Options should be object or undefined");
    const merged = Object.assign(defaults, opts);
    return merged;
}
function wrapConstructor(hashCons) {
    const hashC = (msg)=>hashCons().update(toBytes(msg)).digest();
    const tmp = hashCons();
    hashC.outputLen = tmp.outputLen;
    hashC.blockLen = tmp.blockLen;
    hashC.create = ()=>hashCons();
    return hashC;
}
function wrapConstructorWithOpts(hashCons) {
    const hashC = (msg, opts)=>hashCons(opts).update(toBytes(msg)).digest();
    const tmp = hashCons({});
    hashC.outputLen = tmp.outputLen;
    hashC.blockLen = tmp.blockLen;
    hashC.create = (opts)=>hashCons(opts);
    return hashC;
}
function wrapXOFConstructorWithOpts(hashCons) {
    const hashC = (msg, opts)=>hashCons(opts).update(toBytes(msg)).digest();
    const tmp = hashCons({});
    hashC.outputLen = tmp.outputLen;
    hashC.blockLen = tmp.blockLen;
    hashC.create = (opts)=>hashCons(opts);
    return hashC;
}
/**
 * Secure PRNG. Uses `crypto.getRandomValues`, which defers to OS.
 */ function randomBytes(bytesLength = 32) {
    if (crypto_1.crypto && typeof crypto_1.crypto.getRandomValues === "function") return crypto_1.crypto.getRandomValues(new Uint8Array(bytesLength));
    // Legacy Node.js compatibility
    if (crypto_1.crypto && typeof crypto_1.crypto.randomBytes === "function") return crypto_1.crypto.randomBytes(bytesLength);
    throw new Error("crypto.getRandomValues must be defined");
}

},{"308a0f9b8753b4af":"1zxne","f33264417aee0570":"2SEX7"}],"1zxne":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.crypto = void 0;
exports.crypto = typeof globalThis === "object" && "crypto" in globalThis ? globalThis.crypto : undefined;

},{}],"hOh1t":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.keccak512 = exports.keccak384 = exports.keccak256 = exports.keccak224 = void 0;
const sha3_1 = require("7da18f2a59b1d910");
const utils_js_1 = require("6547c4c60a06ea7");
exports.keccak224 = (0, utils_js_1.wrapHash)(sha3_1.keccak_224);
exports.keccak256 = (()=>{
    const k = (0, utils_js_1.wrapHash)(sha3_1.keccak_256);
    k.create = sha3_1.keccak_256.create;
    return k;
})();
exports.keccak384 = (0, utils_js_1.wrapHash)(sha3_1.keccak_384);
exports.keccak512 = (0, utils_js_1.wrapHash)(sha3_1.keccak_512);

},{"7da18f2a59b1d910":"1jko4","6547c4c60a06ea7":"7cvqv"}],"1jko4":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.shake256 = exports.shake128 = exports.keccak_512 = exports.keccak_384 = exports.keccak_256 = exports.keccak_224 = exports.sha3_512 = exports.sha3_384 = exports.sha3_256 = exports.sha3_224 = exports.Keccak = exports.keccakP = void 0;
const _assert_js_1 = require("962ddd6a536086f");
const _u64_js_1 = require("76c6de76cd55695c");
const utils_js_1 = require("cc87c7466a0b4af");
// SHA3 (keccak) is based on a new design: basically, the internal state is bigger than output size.
// It's called a sponge function.
// Various per round constants calculations
const SHA3_PI = [];
const SHA3_ROTL = [];
const _SHA3_IOTA = [];
const _0n = /* @__PURE__ */ BigInt(0);
const _1n = /* @__PURE__ */ BigInt(1);
const _2n = /* @__PURE__ */ BigInt(2);
const _7n = /* @__PURE__ */ BigInt(7);
const _256n = /* @__PURE__ */ BigInt(256);
const _0x71n = /* @__PURE__ */ BigInt(0x71);
for(let round = 0, R = _1n, x = 1, y = 0; round < 24; round++){
    // Pi
    [x, y] = [
        y,
        (2 * x + 3 * y) % 5
    ];
    SHA3_PI.push(2 * (5 * y + x));
    // Rotational
    SHA3_ROTL.push((round + 1) * (round + 2) / 2 % 64);
    // Iota
    let t = _0n;
    for(let j = 0; j < 7; j++){
        R = (R << _1n ^ (R >> _7n) * _0x71n) % _256n;
        if (R & _2n) t ^= _1n << (_1n << /* @__PURE__ */ BigInt(j)) - _1n;
    }
    _SHA3_IOTA.push(t);
}
const [SHA3_IOTA_H, SHA3_IOTA_L] = /* @__PURE__ */ (0, _u64_js_1.split)(_SHA3_IOTA, true);
// Left rotation (without 0, 32, 64)
const rotlH = (h, l, s)=>s > 32 ? (0, _u64_js_1.rotlBH)(h, l, s) : (0, _u64_js_1.rotlSH)(h, l, s);
const rotlL = (h, l, s)=>s > 32 ? (0, _u64_js_1.rotlBL)(h, l, s) : (0, _u64_js_1.rotlSL)(h, l, s);
// Same as keccakf1600, but allows to skip some rounds
function keccakP(s, rounds = 24) {
    const B = new Uint32Array(10);
    // NOTE: all indices are x2 since we store state as u32 instead of u64 (bigints to slow in js)
    for(let round = 24 - rounds; round < 24; round++){
        // Theta θ
        for(let x = 0; x < 10; x++)B[x] = s[x] ^ s[x + 10] ^ s[x + 20] ^ s[x + 30] ^ s[x + 40];
        for(let x = 0; x < 10; x += 2){
            const idx1 = (x + 8) % 10;
            const idx0 = (x + 2) % 10;
            const B0 = B[idx0];
            const B1 = B[idx0 + 1];
            const Th = rotlH(B0, B1, 1) ^ B[idx1];
            const Tl = rotlL(B0, B1, 1) ^ B[idx1 + 1];
            for(let y = 0; y < 50; y += 10){
                s[x + y] ^= Th;
                s[x + y + 1] ^= Tl;
            }
        }
        // Rho (ρ) and Pi (π)
        let curH = s[2];
        let curL = s[3];
        for(let t = 0; t < 24; t++){
            const shift = SHA3_ROTL[t];
            const Th = rotlH(curH, curL, shift);
            const Tl = rotlL(curH, curL, shift);
            const PI = SHA3_PI[t];
            curH = s[PI];
            curL = s[PI + 1];
            s[PI] = Th;
            s[PI + 1] = Tl;
        }
        // Chi (χ)
        for(let y = 0; y < 50; y += 10){
            for(let x = 0; x < 10; x++)B[x] = s[y + x];
            for(let x = 0; x < 10; x++)s[y + x] ^= ~B[(x + 2) % 10] & B[(x + 4) % 10];
        }
        // Iota (ι)
        s[0] ^= SHA3_IOTA_H[round];
        s[1] ^= SHA3_IOTA_L[round];
    }
    B.fill(0);
}
exports.keccakP = keccakP;
class Keccak extends utils_js_1.Hash {
    // NOTE: we accept arguments in bytes instead of bits here.
    constructor(blockLen, suffix, outputLen, enableXOF = false, rounds = 24){
        super();
        this.blockLen = blockLen;
        this.suffix = suffix;
        this.outputLen = outputLen;
        this.enableXOF = enableXOF;
        this.rounds = rounds;
        this.pos = 0;
        this.posOut = 0;
        this.finished = false;
        this.destroyed = false;
        // Can be passed from user as dkLen
        (0, _assert_js_1.number)(outputLen);
        // 1600 = 5x5 matrix of 64bit.  1600 bits === 200 bytes
        if (0 >= this.blockLen || this.blockLen >= 200) throw new Error("Sha3 supports only keccak-f1600 function");
        this.state = new Uint8Array(200);
        this.state32 = (0, utils_js_1.u32)(this.state);
    }
    keccak() {
        if (!utils_js_1.isLE) (0, utils_js_1.byteSwap32)(this.state32);
        keccakP(this.state32, this.rounds);
        if (!utils_js_1.isLE) (0, utils_js_1.byteSwap32)(this.state32);
        this.posOut = 0;
        this.pos = 0;
    }
    update(data) {
        (0, _assert_js_1.exists)(this);
        const { blockLen, state } = this;
        data = (0, utils_js_1.toBytes)(data);
        const len = data.length;
        for(let pos = 0; pos < len;){
            const take = Math.min(blockLen - this.pos, len - pos);
            for(let i = 0; i < take; i++)state[this.pos++] ^= data[pos++];
            if (this.pos === blockLen) this.keccak();
        }
        return this;
    }
    finish() {
        if (this.finished) return;
        this.finished = true;
        const { state, suffix, pos, blockLen } = this;
        // Do the padding
        state[pos] ^= suffix;
        if ((suffix & 0x80) !== 0 && pos === blockLen - 1) this.keccak();
        state[blockLen - 1] ^= 0x80;
        this.keccak();
    }
    writeInto(out) {
        (0, _assert_js_1.exists)(this, false);
        (0, _assert_js_1.bytes)(out);
        this.finish();
        const bufferOut = this.state;
        const { blockLen } = this;
        for(let pos = 0, len = out.length; pos < len;){
            if (this.posOut >= blockLen) this.keccak();
            const take = Math.min(blockLen - this.posOut, len - pos);
            out.set(bufferOut.subarray(this.posOut, this.posOut + take), pos);
            this.posOut += take;
            pos += take;
        }
        return out;
    }
    xofInto(out) {
        // Sha3/Keccak usage with XOF is probably mistake, only SHAKE instances can do XOF
        if (!this.enableXOF) throw new Error("XOF is not possible for this instance");
        return this.writeInto(out);
    }
    xof(bytes) {
        (0, _assert_js_1.number)(bytes);
        return this.xofInto(new Uint8Array(bytes));
    }
    digestInto(out) {
        (0, _assert_js_1.output)(out, this);
        if (this.finished) throw new Error("digest() was already called");
        this.writeInto(out);
        this.destroy();
        return out;
    }
    digest() {
        return this.digestInto(new Uint8Array(this.outputLen));
    }
    destroy() {
        this.destroyed = true;
        this.state.fill(0);
    }
    _cloneInto(to) {
        const { blockLen, suffix, outputLen, rounds, enableXOF } = this;
        to || (to = new Keccak(blockLen, suffix, outputLen, enableXOF, rounds));
        to.state32.set(this.state32);
        to.pos = this.pos;
        to.posOut = this.posOut;
        to.finished = this.finished;
        to.rounds = rounds;
        // Suffix can change in cSHAKE
        to.suffix = suffix;
        to.outputLen = outputLen;
        to.enableXOF = enableXOF;
        to.destroyed = this.destroyed;
        return to;
    }
}
exports.Keccak = Keccak;
const gen = (suffix, blockLen, outputLen)=>(0, utils_js_1.wrapConstructor)(()=>new Keccak(blockLen, suffix, outputLen));
exports.sha3_224 = gen(0x06, 144, 28);
/**
 * SHA3-256 hash function
 * @param message - that would be hashed
 */ exports.sha3_256 = gen(0x06, 136, 32);
exports.sha3_384 = gen(0x06, 104, 48);
exports.sha3_512 = gen(0x06, 72, 64);
exports.keccak_224 = gen(0x01, 144, 28);
/**
 * keccak-256 hash function. Different from SHA3-256.
 * @param message - that would be hashed
 */ exports.keccak_256 = gen(0x01, 136, 32);
exports.keccak_384 = gen(0x01, 104, 48);
exports.keccak_512 = gen(0x01, 72, 64);
const genShake = (suffix, blockLen, outputLen)=>(0, utils_js_1.wrapXOFConstructorWithOpts)((opts = {})=>new Keccak(blockLen, suffix, opts.dkLen === undefined ? outputLen : opts.dkLen, true));
exports.shake128 = genShake(0x1f, 168, 16);
exports.shake256 = genShake(0x1f, 136, 32);

},{"962ddd6a536086f":"kqyCC","76c6de76cd55695c":"1O4bH","cc87c7466a0b4af":"1Fq7H"}],"kqyCC":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.output = exports.exists = exports.hash = exports.bytes = exports.bool = exports.number = exports.isBytes = void 0;
function number(n) {
    if (!Number.isSafeInteger(n) || n < 0) throw new Error(`positive integer expected, not ${n}`);
}
exports.number = number;
function bool(b) {
    if (typeof b !== "boolean") throw new Error(`boolean expected, not ${b}`);
}
exports.bool = bool;
// copied from utils
function isBytes(a) {
    return a instanceof Uint8Array || a != null && typeof a === "object" && a.constructor.name === "Uint8Array";
}
exports.isBytes = isBytes;
function bytes(b, ...lengths) {
    if (!isBytes(b)) throw new Error("Uint8Array expected");
    if (lengths.length > 0 && !lengths.includes(b.length)) throw new Error(`Uint8Array expected of length ${lengths}, not of length=${b.length}`);
}
exports.bytes = bytes;
function hash(h) {
    if (typeof h !== "function" || typeof h.create !== "function") throw new Error("Hash should be wrapped by utils.wrapConstructor");
    number(h.outputLen);
    number(h.blockLen);
}
exports.hash = hash;
function exists(instance, checkFinished = true) {
    if (instance.destroyed) throw new Error("Hash instance has been destroyed");
    if (checkFinished && instance.finished) throw new Error("Hash#digest() has already been called");
}
exports.exists = exists;
function output(out, instance) {
    bytes(out);
    const min = instance.outputLen;
    if (out.length < min) throw new Error(`digestInto() expects output buffer of length at least ${min}`);
}
exports.output = output;
const assert = {
    number,
    bool,
    bytes,
    hash,
    exists,
    output
};
exports.default = assert;

},{}],"1O4bH":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.add5L = exports.add5H = exports.add4H = exports.add4L = exports.add3H = exports.add3L = exports.add = exports.rotlBL = exports.rotlBH = exports.rotlSL = exports.rotlSH = exports.rotr32L = exports.rotr32H = exports.rotrBL = exports.rotrBH = exports.rotrSL = exports.rotrSH = exports.shrSL = exports.shrSH = exports.toBig = exports.split = exports.fromBig = void 0;
const U32_MASK64 = /* @__PURE__ */ BigInt(2 ** 32 - 1);
const _32n = /* @__PURE__ */ BigInt(32);
// We are not using BigUint64Array, because they are extremely slow as per 2022
function fromBig(n, le = false) {
    if (le) return {
        h: Number(n & U32_MASK64),
        l: Number(n >> _32n & U32_MASK64)
    };
    return {
        h: Number(n >> _32n & U32_MASK64) | 0,
        l: Number(n & U32_MASK64) | 0
    };
}
exports.fromBig = fromBig;
function split(lst, le = false) {
    let Ah = new Uint32Array(lst.length);
    let Al = new Uint32Array(lst.length);
    for(let i = 0; i < lst.length; i++){
        const { h, l } = fromBig(lst[i], le);
        [Ah[i], Al[i]] = [
            h,
            l
        ];
    }
    return [
        Ah,
        Al
    ];
}
exports.split = split;
const toBig = (h, l)=>BigInt(h >>> 0) << _32n | BigInt(l >>> 0);
exports.toBig = toBig;
// for Shift in [0, 32)
const shrSH = (h, _l, s)=>h >>> s;
exports.shrSH = shrSH;
const shrSL = (h, l, s)=>h << 32 - s | l >>> s;
exports.shrSL = shrSL;
// Right rotate for Shift in [1, 32)
const rotrSH = (h, l, s)=>h >>> s | l << 32 - s;
exports.rotrSH = rotrSH;
const rotrSL = (h, l, s)=>h << 32 - s | l >>> s;
exports.rotrSL = rotrSL;
// Right rotate for Shift in (32, 64), NOTE: 32 is special case.
const rotrBH = (h, l, s)=>h << 64 - s | l >>> s - 32;
exports.rotrBH = rotrBH;
const rotrBL = (h, l, s)=>h >>> s - 32 | l << 64 - s;
exports.rotrBL = rotrBL;
// Right rotate for shift===32 (just swaps l&h)
const rotr32H = (_h, l)=>l;
exports.rotr32H = rotr32H;
const rotr32L = (h, _l)=>h;
exports.rotr32L = rotr32L;
// Left rotate for Shift in [1, 32)
const rotlSH = (h, l, s)=>h << s | l >>> 32 - s;
exports.rotlSH = rotlSH;
const rotlSL = (h, l, s)=>l << s | h >>> 32 - s;
exports.rotlSL = rotlSL;
// Left rotate for Shift in (32, 64), NOTE: 32 is special case.
const rotlBH = (h, l, s)=>l << s - 32 | h >>> 64 - s;
exports.rotlBH = rotlBH;
const rotlBL = (h, l, s)=>h << s - 32 | l >>> 64 - s;
exports.rotlBL = rotlBL;
// JS uses 32-bit signed integers for bitwise operations which means we cannot
// simple take carry out of low bit sum by shift, we need to use division.
function add(Ah, Al, Bh, Bl) {
    const l = (Al >>> 0) + (Bl >>> 0);
    return {
        h: Ah + Bh + (l / 2 ** 32 | 0) | 0,
        l: l | 0
    };
}
exports.add = add;
// Addition with more than 2 elements
const add3L = (Al, Bl, Cl)=>(Al >>> 0) + (Bl >>> 0) + (Cl >>> 0);
exports.add3L = add3L;
const add3H = (low, Ah, Bh, Ch)=>Ah + Bh + Ch + (low / 2 ** 32 | 0) | 0;
exports.add3H = add3H;
const add4L = (Al, Bl, Cl, Dl)=>(Al >>> 0) + (Bl >>> 0) + (Cl >>> 0) + (Dl >>> 0);
exports.add4L = add4L;
const add4H = (low, Ah, Bh, Ch, Dh)=>Ah + Bh + Ch + Dh + (low / 2 ** 32 | 0) | 0;
exports.add4H = add4H;
const add5L = (Al, Bl, Cl, Dl, El)=>(Al >>> 0) + (Bl >>> 0) + (Cl >>> 0) + (Dl >>> 0) + (El >>> 0);
exports.add5L = add5L;
const add5H = (low, Ah, Bh, Ch, Dh, Eh)=>Ah + Bh + Ch + Dh + Eh + (low / 2 ** 32 | 0) | 0;
exports.add5H = add5H;
// prettier-ignore
const u64 = {
    fromBig,
    split,
    toBig,
    shrSH,
    shrSL,
    rotrSH,
    rotrSL,
    rotrBH,
    rotrBL,
    rotr32H,
    rotr32L,
    rotlSH,
    rotlSL,
    rotlBH,
    rotlBL,
    add,
    add3L,
    add3H,
    add4L,
    add4H,
    add5H,
    add5L
};
exports.default = u64;

},{}],"1Fq7H":[function(require,module,exports) {
"use strict";
/*! noble-hashes - MIT License (c) 2022 Paul Miller (paulmillr.com) */ Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.randomBytes = exports.wrapXOFConstructorWithOpts = exports.wrapConstructorWithOpts = exports.wrapConstructor = exports.checkOpts = exports.Hash = exports.concatBytes = exports.toBytes = exports.utf8ToBytes = exports.asyncLoop = exports.nextTick = exports.hexToBytes = exports.bytesToHex = exports.byteSwap32 = exports.byteSwapIfBE = exports.byteSwap = exports.isLE = exports.rotl = exports.rotr = exports.createView = exports.u32 = exports.u8 = exports.isBytes = void 0;
// We use WebCrypto aka globalThis.crypto, which exists in browsers and node.js 16+.
// node.js versions earlier than v19 don't declare it in global scope.
// For node.js, package.json#exports field mapping rewrites import
// from `crypto` to `cryptoNode`, which imports native module.
// Makes the utils un-importable in browsers without a bundler.
// Once node.js 18 is deprecated (2025-04-30), we can just drop the import.
const crypto_1 = require("509c7fefd71edc3f");
const _assert_js_1 = require("ce85604589c10b2d");
// export { isBytes } from './_assert.js';
// We can't reuse isBytes from _assert, because somehow this causes huge perf issues
function isBytes(a) {
    return a instanceof Uint8Array || a != null && typeof a === "object" && a.constructor.name === "Uint8Array";
}
exports.isBytes = isBytes;
// Cast array to different type
const u8 = (arr)=>new Uint8Array(arr.buffer, arr.byteOffset, arr.byteLength);
exports.u8 = u8;
const u32 = (arr)=>new Uint32Array(arr.buffer, arr.byteOffset, Math.floor(arr.byteLength / 4));
exports.u32 = u32;
// Cast array to view
const createView = (arr)=>new DataView(arr.buffer, arr.byteOffset, arr.byteLength);
exports.createView = createView;
// The rotate right (circular right shift) operation for uint32
const rotr = (word, shift)=>word << 32 - shift | word >>> shift;
exports.rotr = rotr;
// The rotate left (circular left shift) operation for uint32
const rotl = (word, shift)=>word << shift | word >>> 32 - shift >>> 0;
exports.rotl = rotl;
exports.isLE = new Uint8Array(new Uint32Array([
    0x11223344
]).buffer)[0] === 0x44;
// The byte swap operation for uint32
const byteSwap = (word)=>word << 24 & 0xff000000 | word << 8 & 0xff0000 | word >>> 8 & 0xff00 | word >>> 24 & 0xff;
exports.byteSwap = byteSwap;
// Conditionally byte swap if on a big-endian platform
exports.byteSwapIfBE = exports.isLE ? (n)=>n : (n)=>(0, exports.byteSwap)(n);
// In place byte swap for Uint32Array
function byteSwap32(arr) {
    for(let i = 0; i < arr.length; i++)arr[i] = (0, exports.byteSwap)(arr[i]);
}
exports.byteSwap32 = byteSwap32;
// Array where index 0xf0 (240) is mapped to string 'f0'
const hexes = /* @__PURE__ */ Array.from({
    length: 256
}, (_, i)=>i.toString(16).padStart(2, "0"));
/**
 * @example bytesToHex(Uint8Array.from([0xca, 0xfe, 0x01, 0x23])) // 'cafe0123'
 */ function bytesToHex(bytes) {
    (0, _assert_js_1.bytes)(bytes);
    // pre-caching improves the speed 6x
    let hex = "";
    for(let i = 0; i < bytes.length; i++)hex += hexes[bytes[i]];
    return hex;
}
exports.bytesToHex = bytesToHex;
// We use optimized technique to convert hex string to byte array
const asciis = {
    _0: 48,
    _9: 57,
    _A: 65,
    _F: 70,
    _a: 97,
    _f: 102
};
function asciiToBase16(char) {
    if (char >= asciis._0 && char <= asciis._9) return char - asciis._0;
    if (char >= asciis._A && char <= asciis._F) return char - (asciis._A - 10);
    if (char >= asciis._a && char <= asciis._f) return char - (asciis._a - 10);
    return;
}
/**
 * @example hexToBytes('cafe0123') // Uint8Array.from([0xca, 0xfe, 0x01, 0x23])
 */ function hexToBytes(hex) {
    if (typeof hex !== "string") throw new Error("hex string expected, got " + typeof hex);
    const hl = hex.length;
    const al = hl / 2;
    if (hl % 2) throw new Error("padded hex string expected, got unpadded hex of length " + hl);
    const array = new Uint8Array(al);
    for(let ai = 0, hi = 0; ai < al; ai++, hi += 2){
        const n1 = asciiToBase16(hex.charCodeAt(hi));
        const n2 = asciiToBase16(hex.charCodeAt(hi + 1));
        if (n1 === undefined || n2 === undefined) {
            const char = hex[hi] + hex[hi + 1];
            throw new Error('hex string expected, got non-hex character "' + char + '" at index ' + hi);
        }
        array[ai] = n1 * 16 + n2;
    }
    return array;
}
exports.hexToBytes = hexToBytes;
// There is no setImmediate in browser and setTimeout is slow.
// call of async fn will return Promise, which will be fullfiled only on
// next scheduler queue processing step and this is exactly what we need.
const nextTick = async ()=>{};
exports.nextTick = nextTick;
// Returns control to thread each 'tick' ms to avoid blocking
async function asyncLoop(iters, tick, cb) {
    let ts = Date.now();
    for(let i = 0; i < iters; i++){
        cb(i);
        // Date.now() is not monotonic, so in case if clock goes backwards we return return control too
        const diff = Date.now() - ts;
        if (diff >= 0 && diff < tick) continue;
        await (0, exports.nextTick)();
        ts += diff;
    }
}
exports.asyncLoop = asyncLoop;
/**
 * @example utf8ToBytes('abc') // new Uint8Array([97, 98, 99])
 */ function utf8ToBytes(str) {
    if (typeof str !== "string") throw new Error(`utf8ToBytes expected string, got ${typeof str}`);
    return new Uint8Array(new TextEncoder().encode(str)); // https://bugzil.la/1681809
}
exports.utf8ToBytes = utf8ToBytes;
/**
 * Normalizes (non-hex) string or Uint8Array to Uint8Array.
 * Warning: when Uint8Array is passed, it would NOT get copied.
 * Keep in mind for future mutable operations.
 */ function toBytes(data) {
    if (typeof data === "string") data = utf8ToBytes(data);
    (0, _assert_js_1.bytes)(data);
    return data;
}
exports.toBytes = toBytes;
/**
 * Copies several Uint8Arrays into one.
 */ function concatBytes(...arrays) {
    let sum = 0;
    for(let i = 0; i < arrays.length; i++){
        const a = arrays[i];
        (0, _assert_js_1.bytes)(a);
        sum += a.length;
    }
    const res = new Uint8Array(sum);
    for(let i = 0, pad = 0; i < arrays.length; i++){
        const a = arrays[i];
        res.set(a, pad);
        pad += a.length;
    }
    return res;
}
exports.concatBytes = concatBytes;
// For runtime check if class implements interface
class Hash {
    // Safe version that clones internal state
    clone() {
        return this._cloneInto();
    }
}
exports.Hash = Hash;
const toStr = {}.toString;
function checkOpts(defaults, opts) {
    if (opts !== undefined && toStr.call(opts) !== "[object Object]") throw new Error("Options should be object or undefined");
    const merged = Object.assign(defaults, opts);
    return merged;
}
exports.checkOpts = checkOpts;
function wrapConstructor(hashCons) {
    const hashC = (msg)=>hashCons().update(toBytes(msg)).digest();
    const tmp = hashCons();
    hashC.outputLen = tmp.outputLen;
    hashC.blockLen = tmp.blockLen;
    hashC.create = ()=>hashCons();
    return hashC;
}
exports.wrapConstructor = wrapConstructor;
function wrapConstructorWithOpts(hashCons) {
    const hashC = (msg, opts)=>hashCons(opts).update(toBytes(msg)).digest();
    const tmp = hashCons({});
    hashC.outputLen = tmp.outputLen;
    hashC.blockLen = tmp.blockLen;
    hashC.create = (opts)=>hashCons(opts);
    return hashC;
}
exports.wrapConstructorWithOpts = wrapConstructorWithOpts;
function wrapXOFConstructorWithOpts(hashCons) {
    const hashC = (msg, opts)=>hashCons(opts).update(toBytes(msg)).digest();
    const tmp = hashCons({});
    hashC.outputLen = tmp.outputLen;
    hashC.blockLen = tmp.blockLen;
    hashC.create = (opts)=>hashCons(opts);
    return hashC;
}
exports.wrapXOFConstructorWithOpts = wrapXOFConstructorWithOpts;
/**
 * Secure PRNG. Uses `crypto.getRandomValues`, which defers to OS.
 */ function randomBytes(bytesLength = 32) {
    if (crypto_1.crypto && typeof crypto_1.crypto.getRandomValues === "function") return crypto_1.crypto.getRandomValues(new Uint8Array(bytesLength));
    throw new Error("crypto.getRandomValues must be defined");
}
exports.randomBytes = randomBytes;

},{"509c7fefd71edc3f":"fzIeh","ce85604589c10b2d":"kqyCC"}],"fzIeh":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.crypto = void 0;
exports.crypto = typeof globalThis === "object" && "crypto" in globalThis ? globalThis.crypto : undefined;

},{}],"7cvqv":[function(require,module,exports) {
"use strict";
var __importDefault = this && this.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.crypto = exports.utf8ToBytes = exports.createView = exports.concatBytes = exports.toHex = exports.bytesToHex = exports.assertBytes = exports.assertBool = void 0;
exports.bytesToUtf8 = bytesToUtf8;
exports.hexToBytes = hexToBytes;
exports.equalsBytes = equalsBytes;
exports.wrapHash = wrapHash;
const _assert_1 = __importDefault(require("8c0d163fd806f3ef"));
const utils_1 = require("433fc1479f0fc692");
const assertBool = _assert_1.default.bool;
exports.assertBool = assertBool;
const assertBytes = _assert_1.default.bytes;
exports.assertBytes = assertBytes;
var utils_2 = require("433fc1479f0fc692");
Object.defineProperty(exports, "bytesToHex", {
    enumerable: true,
    get: function() {
        return utils_2.bytesToHex;
    }
});
Object.defineProperty(exports, "toHex", {
    enumerable: true,
    get: function() {
        return utils_2.bytesToHex;
    }
});
Object.defineProperty(exports, "concatBytes", {
    enumerable: true,
    get: function() {
        return utils_2.concatBytes;
    }
});
Object.defineProperty(exports, "createView", {
    enumerable: true,
    get: function() {
        return utils_2.createView;
    }
});
Object.defineProperty(exports, "utf8ToBytes", {
    enumerable: true,
    get: function() {
        return utils_2.utf8ToBytes;
    }
});
// buf.toString('utf8') -> bytesToUtf8(buf)
function bytesToUtf8(data) {
    if (!(data instanceof Uint8Array)) throw new TypeError(`bytesToUtf8 expected Uint8Array, got ${typeof data}`);
    return new TextDecoder().decode(data);
}
function hexToBytes(data) {
    const sliced = data.startsWith("0x") ? data.substring(2) : data;
    return (0, utils_1.hexToBytes)(sliced);
}
// buf.equals(buf2) -> equalsBytes(buf, buf2)
function equalsBytes(a, b) {
    if (a.length !== b.length) return false;
    for(let i = 0; i < a.length; i++){
        if (a[i] !== b[i]) return false;
    }
    return true;
}
// Internal utils
function wrapHash(hash) {
    return (msg)=>{
        _assert_1.default.bytes(msg);
        return hash(msg);
    };
}
// TODO(v3): switch away from node crypto, remove this unnecessary variable.
exports.crypto = (()=>{
    const webCrypto = typeof globalThis === "object" && "crypto" in globalThis ? globalThis.crypto : undefined;
    const nodeRequire = typeof module.require === "function" && module.require.bind(module);
    return {
        node: nodeRequire && !webCrypto ? nodeRequire("crypto") : undefined,
        web: webCrypto
    };
})();

},{"8c0d163fd806f3ef":"kqyCC","433fc1479f0fc692":"1Fq7H"}],"2CNKE":[function(require,module,exports) {
/*
 This file is part of web3.js.

 web3.js is free software: you can redistribute it and/or modify
 it under the terms of the GNU Lesser General Public License as published by
 the Free Software Foundation, either version 3 of the License, or
 (at your option) any later version.

 web3.js is distributed in the hope that it will be useful,
 but WITHOUT ANY WARRANTY; without even the implied warranty of
 MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 GNU Lesser General Public License for more details.

 You should have received a copy of the GNU Lesser General Public License
 along with web3.js.  If not, see <http://www.gnu.org/licenses/>.
 */ /**
 * @file soliditySha3.js
 * @author Fabian Vogelsteller <fabian@ethereum.org>
 * @date 2017
 */ var BN = require("b9bb7288ff24025b");
var utils = require("2098090ae1c8bd12");
var _elementaryName = function(name) {
    /*jshint maxcomplexity:false */ if (name.startsWith("int[")) return "int256" + name.slice(3);
    else if (name === "int") return "int256";
    else if (name.startsWith("uint[")) return "uint256" + name.slice(4);
    else if (name === "uint") return "uint256";
    else if (name.startsWith("fixed[")) return "fixed128x128" + name.slice(5);
    else if (name === "fixed") return "fixed128x128";
    else if (name.startsWith("ufixed[")) return "ufixed128x128" + name.slice(6);
    else if (name === "ufixed") return "ufixed128x128";
    return name;
};
// Parse N from type<N>
var _parseTypeN = function(type) {
    var typesize = /^\D+(\d+).*$/.exec(type);
    return typesize ? parseInt(typesize[1], 10) : null;
};
// Parse N from type[<N>]
var _parseTypeNArray = function(type) {
    var arraySize = /^\D+\d*\[(\d+)\]$/.exec(type);
    return arraySize ? parseInt(arraySize[1], 10) : null;
};
var _parseNumber = function(arg) {
    var type = typeof arg;
    if (type === "string") {
        if (utils.isHexStrict(arg)) return new BN(arg.replace(/0x/i, ""), 16);
        else return new BN(arg, 10);
    } else if (type === "number") return new BN(arg);
    else if (utils.isBigNumber(arg)) return new BN(arg.toString(10));
    else if (utils.isBN(arg)) return arg;
    else throw new Error(arg + " is not a number");
};
var _solidityPack = function(type, value, arraySize) {
    /*jshint maxcomplexity:false */ var size, num;
    type = _elementaryName(type);
    if (type === "bytes") {
        if (value.replace(/^0x/i, "").length % 2 !== 0) throw new Error("Invalid bytes characters " + value.length);
        return value;
    } else if (type === "string") return utils.utf8ToHex(value);
    else if (type === "bool") return value ? "01" : "00";
    else if (type.startsWith("address")) {
        if (arraySize) size = 64;
        else size = 40;
        if (!utils.isAddress(value)) throw new Error(value + " is not a valid address, or the checksum is invalid.");
        return utils.leftPad(value.toLowerCase(), size);
    }
    size = _parseTypeN(type);
    if (type.startsWith("bytes")) {
        if (!size) throw new Error("bytes[] not yet supported in solidity");
        // must be 32 byte slices when in an array
        if (arraySize) size = 32;
        if (size < 1 || size > 32 || size < value.replace(/^0x/i, "").length / 2) throw new Error("Invalid bytes" + size + " for " + value);
        return utils.rightPad(value, size * 2);
    } else if (type.startsWith("uint")) {
        if (size % 8 || size < 8 || size > 256) throw new Error("Invalid uint" + size + " size");
        num = _parseNumber(value);
        if (num.bitLength() > size) throw new Error("Supplied uint exceeds width: " + size + " vs " + num.bitLength());
        if (num.lt(new BN(0))) throw new Error("Supplied uint " + num.toString() + " is negative");
        return size ? utils.leftPad(num.toString("hex"), size / 8 * 2) : num;
    } else if (type.startsWith("int")) {
        if (size % 8 || size < 8 || size > 256) throw new Error("Invalid int" + size + " size");
        num = _parseNumber(value);
        if (num.bitLength() > size) throw new Error("Supplied int exceeds width: " + size + " vs " + num.bitLength());
        if (num.lt(new BN(0))) return num.toTwos(size).toString("hex");
        else return size ? utils.leftPad(num.toString("hex"), size / 8 * 2) : num;
    } else // FIXME: support all other types
    throw new Error("Unsupported or invalid type: " + type);
};
var _processSolidityEncodePackedArgs = function(arg) {
    /*jshint maxcomplexity:false */ if (Array.isArray(arg)) throw new Error("Autodetection of array types is not supported.");
    var type, value = "";
    var hexArg, arraySize;
    // if type is given
    if (!!arg && typeof arg === "object" && (arg.hasOwnProperty("v") || arg.hasOwnProperty("t") || arg.hasOwnProperty("value") || arg.hasOwnProperty("type"))) {
        type = arg.hasOwnProperty("t") ? arg.t : arg.type;
        value = arg.hasOwnProperty("v") ? arg.v : arg.value;
    // otherwise try to guess the type
    } else {
        type = utils.toHex(arg, true);
        value = utils.toHex(arg);
        if (!type.startsWith("int") && !type.startsWith("uint")) type = "bytes";
    }
    if ((type.startsWith("int") || type.startsWith("uint")) && typeof value === "string" && !/^(-)?0x/i.test(value)) value = new BN(value);
    // get the array size
    if (Array.isArray(value)) {
        arraySize = _parseTypeNArray(type);
        if (arraySize && value.length !== arraySize) throw new Error(type + " is not matching the given array " + JSON.stringify(value));
        else arraySize = value.length;
    }
    if (Array.isArray(value)) {
        hexArg = value.map(function(val) {
            return _solidityPack(type, val, arraySize).toString("hex").replace("0x", "");
        });
        return hexArg.join("");
    } else {
        hexArg = _solidityPack(type, value, arraySize);
        return hexArg.toString("hex").replace("0x", "");
    }
};
/**
 * Hashes solidity values to a sha3 hash using keccak 256
 *
 * @method soliditySha3
 * @return {Object} the sha3
 */ var soliditySha3 = function() {
    /*jshint maxcomplexity:false */ var args = Array.prototype.slice.call(arguments);
    var hexArgs = args.map(_processSolidityEncodePackedArgs);
    // console.log(args, hexArgs);
    // console.log('0x'+ hexArgs.join(''));
    return utils.sha3("0x" + hexArgs.join(""));
};
/**
 * Hashes solidity values to a sha3 hash using keccak 256 but does return the hash of value `null` instead of `null`
 *
 * @method soliditySha3Raw
 * @return {Object} the sha3
 */ var soliditySha3Raw = function() {
    return utils.sha3Raw("0x" + Array.prototype.slice.call(arguments).map(_processSolidityEncodePackedArgs).join(""));
};
/**
 * Encode packed args to hex
 *
 * @method encodePacked
 * @return {String} the hex encoded arguments
 */ var encodePacked = function() {
    /*jshint maxcomplexity:false */ var args = Array.prototype.slice.call(arguments);
    var hexArgs = args.map(_processSolidityEncodePackedArgs);
    return "0x" + hexArgs.join("").toLowerCase();
};
module.exports = {
    soliditySha3: soliditySha3,
    soliditySha3Raw: soliditySha3Raw,
    encodePacked: encodePacked
};

},{"b9bb7288ff24025b":"8wHT1","2098090ae1c8bd12":"lgE8d"}],"c6z4K":[function(require,module,exports) {
var global = arguments[3];
var process = require("9f5c61be6bd9c67a");
"use strict";
// limit of Crypto.getRandomValues()
// https://developer.mozilla.org/en-US/docs/Web/API/Crypto/getRandomValues
var MAX_BYTES = 65536;
// Node supports requesting up to this number of bytes
// https://github.com/nodejs/node/blob/master/lib/internal/crypto/random.js#L48
var MAX_UINT32 = 4294967295;
function oldBrowser() {
    throw new Error("Secure random number generation is not supported by this browser.\nUse Chrome, Firefox or Internet Explorer 11");
}
var Buffer = require("caff9346743c214e").Buffer;
var crypto = global.crypto || global.msCrypto;
if (crypto && crypto.getRandomValues) module.exports = randomBytes;
else module.exports = oldBrowser;
function randomBytes(size, cb) {
    // phantomjs needs to throw
    if (size > MAX_UINT32) throw new RangeError("requested too many random bytes");
    var bytes = Buffer.allocUnsafe(size);
    if (size > 0) {
        if (size > MAX_BYTES) // can do at once see https://developer.mozilla.org/en-US/docs/Web/API/window.crypto.getRandomValues
        for(var generated = 0; generated < size; generated += MAX_BYTES)// buffer.slice automatically checks if the end is past the end of
        // the buffer so we don't have to here
        crypto.getRandomValues(bytes.slice(generated, generated + MAX_BYTES));
        else crypto.getRandomValues(bytes);
    }
    if (typeof cb === "function") return process.nextTick(function() {
        cb(null, bytes);
    });
    return bytes;
}

},{"9f5c61be6bd9c67a":"5QIF0","caff9346743c214e":"6hBQU"}],"g2POl":[function(require,module,exports) {
/*
    This file is part of web3.js.

    web3.js is free software: you can redistribute it and/or modify
    it under the terms of the GNU Lesser General Public License as published by
    the Free Software Foundation, either version 3 of the License, or
    (at your option) any later version.

    web3.js is distributed in the hope that it will be useful,
    but WITHOUT ANY WARRANTY; without even the implied warranty of
    MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
    GNU Lesser General Public License for more details.

    You should have received a copy of the GNU Lesser General Public License
    along with web3.js.  If not, see <http://www.gnu.org/licenses/>.
*/ /**
 * @file iban.js
 *
 * Details: https://github.com/ethereum/wiki/wiki/ICAP:-Inter-exchange-Client-Address-Protocol
 *
 * @author Marek Kotewicz <marek@parity.io>
 * @date 2015
 */ "use strict";
const utils = require("8deed2f82bdee205");
const BigNumber = require("f67989cefd25c2e7");
const leftPad = function(string, bytes) {
    let result = string;
    while(result.length < bytes * 2)result = "0" + result;
    return result;
};
/**
 * Prepare an IBAN for mod 97 computation by moving the first 4 chars to the end and transforming the letters to
 * numbers (A = 10, B = 11, ..., Z = 35), as specified in ISO13616.
 *
 * @method iso13616Prepare
 * @param {String} iban the IBAN
 * @returns {String} the prepared IBAN
 */ const iso13616Prepare = function(iban) {
    const A = "A".charCodeAt(0);
    const Z = "Z".charCodeAt(0);
    iban = iban.toUpperCase();
    iban = iban.slice(4) + iban.slice(0, 4);
    return iban.split("").map(function(n) {
        const code = n.charCodeAt(0);
        if (code >= A && code <= Z) // A = 10, B = 11, ... Z = 35
        return code - A + 10;
        else return n;
    }).join("");
};
/**
 * Calculates the MOD 97 10 of the passed IBAN as specified in ISO7064.
 *
 * @method mod9710
 * @param {String} iban
 * @returns {Number}
 */ const mod9710 = function(iban) {
    let remainder = iban;
    let block;
    while(remainder.length > 2){
        block = remainder.slice(0, 9);
        remainder = parseInt(block, 10) % 97 + remainder.slice(block.length);
    }
    return parseInt(remainder, 10) % 97;
};
/**
 * This prototype should be used to create iban object from iban correct string
 *
 * @param {String} iban
 */ class Iban {
    constructor(iban){
        this._iban = iban;
    }
    /**
     * This method should be used to create an ethereum address from a direct iban address
     *
     * @method toAddress
     * @param {String} iban address
     * @return {String} the ethereum address
     */ static toAddress(ib) {
        ib = new Iban(ib);
        if (!ib.isDirect()) throw new Error("IBAN is indirect and can't be converted");
        return ib.toAddress();
    }
    /**
     * This method should be used to create iban address from an ethereum address
     *
     * @method toIban
     * @param {String} address
     * @return {String} the IBAN address
     */ static toIban(address) {
        return Iban.fromAddress(address).toString();
    }
    /**
     * This method should be used to create iban object from an ethereum address
     *
     * @method fromAddress
     * @param {String} address
     * @return {Iban} the IBAN object
     */ static fromAddress(address) {
        if (!utils.isAddress(address)) throw new Error("Provided address is not a valid address: " + address);
        address = address.replace("0x", "").replace("0X", "");
        const asBn = new BigNumber(address, 16);
        const base36 = asBn.toString(36);
        const padded = leftPad(base36, 15);
        return Iban.fromBban(padded.toUpperCase());
    }
    /**
     * Convert the passed BBAN to an IBAN for this country specification.
     * Please note that <i>"generation of the IBAN shall be the exclusive responsibility of the bank/branch servicing the account"</i>.
     * This method implements the preferred algorithm described in http://en.wikipedia.org/wiki/International_Bank_Account_Number#Generating_IBAN_check_digits
     *
     * @method fromBban
     * @param {String} bban the BBAN to convert to IBAN
     * @returns {Iban} the IBAN object
     */ static fromBban(bban) {
        const countryCode = "XE";
        const remainder = mod9710(iso13616Prepare(countryCode + "00" + bban));
        const checkDigit = ("0" + (98 - remainder)).slice(-2);
        return new Iban(countryCode + checkDigit + bban);
    }
    /**
     * Should be used to create IBAN object for given institution and identifier
     *
     * @method createIndirect
     * @param {Object} options, required options are "institution" and "identifier"
     * @return {Iban} the IBAN object
     */ static createIndirect(options) {
        return Iban.fromBban("ETH" + options.institution + options.identifier);
    }
    /**
     * This method should be used to check if given string is valid iban object
     *
     * @method isValid
     * @param {String} iban string
     * @return {Boolean} true if it is valid IBAN
     */ static isValid(iban) {
        const i = new Iban(iban);
        return i.isValid();
    }
    /**
     * Should be called to check if iban is correct
     *
     * @method isValid
     * @returns {Boolean} true if it is, otherwise false
     */ isValid() {
        return /^XE[0-9]{2}(ETH[0-9A-Z]{13}|[0-9A-Z]{30,31})$/.test(this._iban) && mod9710(iso13616Prepare(this._iban)) === 1;
    }
    /**
     * Should be called to check if iban number is direct
     *
     * @method isDirect
     * @returns {Boolean} true if it is, otherwise false
     */ isDirect() {
        return this._iban.length === 34 || this._iban.length === 35;
    }
    /**
     * Should be called to check if iban number if indirect
     *
     * @method isIndirect
     * @returns {Boolean} true if it is, otherwise false
     */ isIndirect() {
        return this._iban.length === 20;
    }
    /**
     * Should be called to get iban checksum
     * Uses the mod-97-10 checksumming protocol (ISO/IEC 7064:2003)
     *
     * @method checksum
     * @returns {String} checksum
     */ checksum() {
        return this._iban.slice(2, 4);
    }
    /**
     * Should be called to get institution identifier
     * eg. XREG
     *
     * @method institution
     * @returns {String} institution identifier
     */ institution() {
        return this.isIndirect() ? this._iban.slice(7, 11) : "";
    }
    /**
     * Should be called to get client identifier within institution
     * eg. GAVOFYORK
     *
     * @method client
     * @returns {String} client identifier
     */ client() {
        return this.isIndirect() ? this._iban.slice(11) : "";
    }
    /**
     * Should be called to get client direct address
     *
     * @method toAddress
     * @returns {String} ethereum address
     */ toAddress() {
        if (this.isDirect()) {
            const base36 = this._iban.slice(4);
            const asBn = new BigNumber(base36, 36);
            return utils.toChecksumAddress(asBn.toString(16, 20));
        }
        return "";
    }
    toString() {
        return this._iban;
    }
}
module.exports = Iban;

},{"8deed2f82bdee205":"ePzmI","f67989cefd25c2e7":"aDsMX"}],"aDsMX":[function(require,module,exports) {
(function(module1, exports) {
    "use strict";
    // Utils
    function assert(val, msg) {
        if (!val) throw new Error(msg || "Assertion failed");
    }
    // Could use `inherits` module, but don't want to move from single file
    // architecture yet.
    function inherits(ctor, superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
    // BN
    function BN(number, base, endian) {
        if (BN.isBN(number)) return number;
        this.negative = 0;
        this.words = null;
        this.length = 0;
        // Reduction context
        this.red = null;
        if (number !== null) {
            if (base === "le" || base === "be") {
                endian = base;
                base = 10;
            }
            this._init(number || 0, base || 10, endian || "be");
        }
    }
    if (typeof module1 === "object") module1.exports = BN;
    else exports.BN = BN;
    BN.BN = BN;
    BN.wordSize = 26;
    var Buffer;
    try {
        if (typeof window !== "undefined" && typeof window.Buffer !== "undefined") Buffer = window.Buffer;
        else Buffer = require("4a621f69fb9775d4").Buffer;
    } catch (e) {}
    BN.isBN = function isBN(num) {
        if (num instanceof BN) return true;
        return num !== null && typeof num === "object" && num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
    };
    BN.max = function max(left, right) {
        if (left.cmp(right) > 0) return left;
        return right;
    };
    BN.min = function min(left, right) {
        if (left.cmp(right) < 0) return left;
        return right;
    };
    BN.prototype._init = function init(number, base, endian) {
        if (typeof number === "number") return this._initNumber(number, base, endian);
        if (typeof number === "object") return this._initArray(number, base, endian);
        if (base === "hex") base = 16;
        assert(base === (base | 0) && base >= 2 && base <= 36);
        number = number.toString().replace(/\s+/g, "");
        var start = 0;
        if (number[0] === "-") {
            start++;
            this.negative = 1;
        }
        if (start < number.length) {
            if (base === 16) this._parseHex(number, start, endian);
            else {
                this._parseBase(number, base, start);
                if (endian === "le") this._initArray(this.toArray(), base, endian);
            }
        }
    };
    BN.prototype._initNumber = function _initNumber(number, base, endian) {
        if (number < 0) {
            this.negative = 1;
            number = -number;
        }
        if (number < 0x4000000) {
            this.words = [
                number & 0x3ffffff
            ];
            this.length = 1;
        } else if (number < 0x10000000000000) {
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff
            ];
            this.length = 2;
        } else {
            assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff,
                1
            ];
            this.length = 3;
        }
        if (endian !== "le") return;
        // Reverse the bytes
        this._initArray(this.toArray(), base, endian);
    };
    BN.prototype._initArray = function _initArray(number, base, endian) {
        // Perhaps a Uint8Array
        assert(typeof number.length === "number");
        if (number.length <= 0) {
            this.words = [
                0
            ];
            this.length = 1;
            return this;
        }
        this.length = Math.ceil(number.length / 3);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        var j, w;
        var off = 0;
        if (endian === "be") for(i = number.length - 1, j = 0; i >= 0; i -= 3){
            w = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        else if (endian === "le") for(i = 0, j = 0; i < number.length; i += 3){
            w = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        return this._strip();
    };
    function parseHex4Bits(string, index) {
        var c = string.charCodeAt(index);
        // '0' - '9'
        if (c >= 48 && c <= 57) return c - 48;
        else if (c >= 65 && c <= 70) return c - 55;
        else if (c >= 97 && c <= 102) return c - 87;
        else assert(false, "Invalid character in " + string);
    }
    function parseHexByte(string, lowerBound, index) {
        var r = parseHex4Bits(string, index);
        if (index - 1 >= lowerBound) r |= parseHex4Bits(string, index - 1) << 4;
        return r;
    }
    BN.prototype._parseHex = function _parseHex(number, start, endian) {
        // Create possibly bigger array to ensure that it fits the number
        this.length = Math.ceil((number.length - start) / 6);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        // 24-bits chunks
        var off = 0;
        var j = 0;
        var w;
        if (endian === "be") for(i = number.length - 1; i >= start; i -= 2){
            w = parseHexByte(number, start, i) << off;
            this.words[j] |= w & 0x3ffffff;
            if (off >= 18) {
                off -= 18;
                j += 1;
                this.words[j] |= w >>> 26;
            } else off += 8;
        }
        else {
            var parseLength = number.length - start;
            for(i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2){
                w = parseHexByte(number, start, i) << off;
                this.words[j] |= w & 0x3ffffff;
                if (off >= 18) {
                    off -= 18;
                    j += 1;
                    this.words[j] |= w >>> 26;
                } else off += 8;
            }
        }
        this._strip();
    };
    function parseBase(str, start, end, mul) {
        var r = 0;
        var b = 0;
        var len = Math.min(str.length, end);
        for(var i = start; i < len; i++){
            var c = str.charCodeAt(i) - 48;
            r *= mul;
            // 'a'
            if (c >= 49) b = c - 49 + 0xa;
            else if (c >= 17) b = c - 17 + 0xa;
            else b = c;
            assert(c >= 0 && b < mul, "Invalid character");
            r += b;
        }
        return r;
    }
    BN.prototype._parseBase = function _parseBase(number, base, start) {
        // Initialize as zero
        this.words = [
            0
        ];
        this.length = 1;
        // Find length of limb in base
        for(var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base)limbLen++;
        limbLen--;
        limbPow = limbPow / base | 0;
        var total = number.length - start;
        var mod = total % limbLen;
        var end = Math.min(total, total - mod) + start;
        var word = 0;
        for(var i = start; i < end; i += limbLen){
            word = parseBase(number, i, i + limbLen, base);
            this.imuln(limbPow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        if (mod !== 0) {
            var pow = 1;
            word = parseBase(number, i, number.length, base);
            for(i = 0; i < mod; i++)pow *= base;
            this.imuln(pow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        this._strip();
    };
    BN.prototype.copy = function copy(dest) {
        dest.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)dest.words[i] = this.words[i];
        dest.length = this.length;
        dest.negative = this.negative;
        dest.red = this.red;
    };
    function move(dest, src) {
        dest.words = src.words;
        dest.length = src.length;
        dest.negative = src.negative;
        dest.red = src.red;
    }
    BN.prototype._move = function _move(dest) {
        move(dest, this);
    };
    BN.prototype.clone = function clone() {
        var r = new BN(null);
        this.copy(r);
        return r;
    };
    BN.prototype._expand = function _expand(size) {
        while(this.length < size)this.words[this.length++] = 0;
        return this;
    };
    // Remove leading `0` from `this`
    BN.prototype._strip = function strip() {
        while(this.length > 1 && this.words[this.length - 1] === 0)this.length--;
        return this._normSign();
    };
    BN.prototype._normSign = function _normSign() {
        // -0 = 0
        if (this.length === 1 && this.words[0] === 0) this.negative = 0;
        return this;
    };
    // Check Symbol.for because not everywhere where Symbol defined
    // See https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Symbol#Browser_compatibility
    if (typeof Symbol !== "undefined" && typeof Symbol.for === "function") try {
        BN.prototype[Symbol.for("nodejs.util.inspect.custom")] = inspect;
    } catch (e) {
        BN.prototype.inspect = inspect;
    }
    else BN.prototype.inspect = inspect;
    function inspect() {
        return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
    }
    /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */ var zeros = [
        "",
        "0",
        "00",
        "000",
        "0000",
        "00000",
        "000000",
        "0000000",
        "00000000",
        "000000000",
        "0000000000",
        "00000000000",
        "000000000000",
        "0000000000000",
        "00000000000000",
        "000000000000000",
        "0000000000000000",
        "00000000000000000",
        "000000000000000000",
        "0000000000000000000",
        "00000000000000000000",
        "000000000000000000000",
        "0000000000000000000000",
        "00000000000000000000000",
        "000000000000000000000000",
        "0000000000000000000000000"
    ];
    var groupSizes = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
    ];
    var groupBases = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        10000000,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64000000,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        24300000,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
    ];
    BN.prototype.toString = function toString(base, padding) {
        base = base || 10;
        padding = padding | 0 || 1;
        var out;
        if (base === 16 || base === "hex") {
            out = "";
            var off = 0;
            var carry = 0;
            for(var i = 0; i < this.length; i++){
                var w = this.words[i];
                var word = ((w << off | carry) & 0xffffff).toString(16);
                carry = w >>> 24 - off & 0xffffff;
                off += 2;
                if (off >= 26) {
                    off -= 26;
                    i--;
                }
                if (carry !== 0 || i !== this.length - 1) out = zeros[6 - word.length] + word + out;
                else out = word + out;
            }
            if (carry !== 0) out = carry.toString(16) + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        if (base === (base | 0) && base >= 2 && base <= 36) {
            // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
            var groupSize = groupSizes[base];
            // var groupBase = Math.pow(base, groupSize);
            var groupBase = groupBases[base];
            out = "";
            var c = this.clone();
            c.negative = 0;
            while(!c.isZero()){
                var r = c.modrn(groupBase).toString(base);
                c = c.idivn(groupBase);
                if (!c.isZero()) out = zeros[groupSize - r.length] + r + out;
                else out = r + out;
            }
            if (this.isZero()) out = "0" + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        assert(false, "Base should be between 2 and 36");
    };
    BN.prototype.toNumber = function toNumber() {
        var ret = this.words[0];
        if (this.length === 2) ret += this.words[1] * 0x4000000;
        else if (this.length === 3 && this.words[2] === 0x01) // NOTE: at this stage it is known that the top bit is set
        ret += 0x10000000000000 + this.words[1] * 0x4000000;
        else if (this.length > 2) assert(false, "Number can only safely store up to 53 bits");
        return this.negative !== 0 ? -ret : ret;
    };
    BN.prototype.toJSON = function toJSON() {
        return this.toString(16, 2);
    };
    if (Buffer) BN.prototype.toBuffer = function toBuffer(endian, length) {
        return this.toArrayLike(Buffer, endian, length);
    };
    BN.prototype.toArray = function toArray(endian, length) {
        return this.toArrayLike(Array, endian, length);
    };
    var allocate = function allocate(ArrayType, size) {
        if (ArrayType.allocUnsafe) return ArrayType.allocUnsafe(size);
        return new ArrayType(size);
    };
    BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
        this._strip();
        var byteLength = this.byteLength();
        var reqLength = length || Math.max(1, byteLength);
        assert(byteLength <= reqLength, "byte array longer than desired length");
        assert(reqLength > 0, "Requested array length <= 0");
        var res = allocate(ArrayType, reqLength);
        var postfix = endian === "le" ? "LE" : "BE";
        this["_toArrayLike" + postfix](res, byteLength);
        return res;
    };
    BN.prototype._toArrayLikeLE = function _toArrayLikeLE(res, byteLength) {
        var position = 0;
        var carry = 0;
        for(var i = 0, shift = 0; i < this.length; i++){
            var word = this.words[i] << shift | carry;
            res[position++] = word & 0xff;
            if (position < res.length) res[position++] = word >> 8 & 0xff;
            if (position < res.length) res[position++] = word >> 16 & 0xff;
            if (shift === 6) {
                if (position < res.length) res[position++] = word >> 24 & 0xff;
                carry = 0;
                shift = 0;
            } else {
                carry = word >>> 24;
                shift += 2;
            }
        }
        if (position < res.length) {
            res[position++] = carry;
            while(position < res.length)res[position++] = 0;
        }
    };
    BN.prototype._toArrayLikeBE = function _toArrayLikeBE(res, byteLength) {
        var position = res.length - 1;
        var carry = 0;
        for(var i = 0, shift = 0; i < this.length; i++){
            var word = this.words[i] << shift | carry;
            res[position--] = word & 0xff;
            if (position >= 0) res[position--] = word >> 8 & 0xff;
            if (position >= 0) res[position--] = word >> 16 & 0xff;
            if (shift === 6) {
                if (position >= 0) res[position--] = word >> 24 & 0xff;
                carry = 0;
                shift = 0;
            } else {
                carry = word >>> 24;
                shift += 2;
            }
        }
        if (position >= 0) {
            res[position--] = carry;
            while(position >= 0)res[position--] = 0;
        }
    };
    if (Math.clz32) BN.prototype._countBits = function _countBits(w) {
        return 32 - Math.clz32(w);
    };
    else BN.prototype._countBits = function _countBits(w) {
        var t = w;
        var r = 0;
        if (t >= 0x1000) {
            r += 13;
            t >>>= 13;
        }
        if (t >= 0x40) {
            r += 7;
            t >>>= 7;
        }
        if (t >= 0x8) {
            r += 4;
            t >>>= 4;
        }
        if (t >= 0x02) {
            r += 2;
            t >>>= 2;
        }
        return r + t;
    };
    BN.prototype._zeroBits = function _zeroBits(w) {
        // Short-cut
        if (w === 0) return 26;
        var t = w;
        var r = 0;
        if ((t & 0x1fff) === 0) {
            r += 13;
            t >>>= 13;
        }
        if ((t & 0x7f) === 0) {
            r += 7;
            t >>>= 7;
        }
        if ((t & 0xf) === 0) {
            r += 4;
            t >>>= 4;
        }
        if ((t & 0x3) === 0) {
            r += 2;
            t >>>= 2;
        }
        if ((t & 0x1) === 0) r++;
        return r;
    };
    // Return number of used bits in a BN
    BN.prototype.bitLength = function bitLength() {
        var w = this.words[this.length - 1];
        var hi = this._countBits(w);
        return (this.length - 1) * 26 + hi;
    };
    function toBitArray(num) {
        var w = new Array(num.bitLength());
        for(var bit = 0; bit < w.length; bit++){
            var off = bit / 26 | 0;
            var wbit = bit % 26;
            w[bit] = num.words[off] >>> wbit & 0x01;
        }
        return w;
    }
    // Number of trailing zero bits
    BN.prototype.zeroBits = function zeroBits() {
        if (this.isZero()) return 0;
        var r = 0;
        for(var i = 0; i < this.length; i++){
            var b = this._zeroBits(this.words[i]);
            r += b;
            if (b !== 26) break;
        }
        return r;
    };
    BN.prototype.byteLength = function byteLength() {
        return Math.ceil(this.bitLength() / 8);
    };
    BN.prototype.toTwos = function toTwos(width) {
        if (this.negative !== 0) return this.abs().inotn(width).iaddn(1);
        return this.clone();
    };
    BN.prototype.fromTwos = function fromTwos(width) {
        if (this.testn(width - 1)) return this.notn(width).iaddn(1).ineg();
        return this.clone();
    };
    BN.prototype.isNeg = function isNeg() {
        return this.negative !== 0;
    };
    // Return negative clone of `this`
    BN.prototype.neg = function neg() {
        return this.clone().ineg();
    };
    BN.prototype.ineg = function ineg() {
        if (!this.isZero()) this.negative ^= 1;
        return this;
    };
    // Or `num` with `this` in-place
    BN.prototype.iuor = function iuor(num) {
        while(this.length < num.length)this.words[this.length++] = 0;
        for(var i = 0; i < num.length; i++)this.words[i] = this.words[i] | num.words[i];
        return this._strip();
    };
    BN.prototype.ior = function ior(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuor(num);
    };
    // Or `num` with `this`
    BN.prototype.or = function or(num) {
        if (this.length > num.length) return this.clone().ior(num);
        return num.clone().ior(this);
    };
    BN.prototype.uor = function uor(num) {
        if (this.length > num.length) return this.clone().iuor(num);
        return num.clone().iuor(this);
    };
    // And `num` with `this` in-place
    BN.prototype.iuand = function iuand(num) {
        // b = min-length(num, this)
        var b;
        if (this.length > num.length) b = num;
        else b = this;
        for(var i = 0; i < b.length; i++)this.words[i] = this.words[i] & num.words[i];
        this.length = b.length;
        return this._strip();
    };
    BN.prototype.iand = function iand(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuand(num);
    };
    // And `num` with `this`
    BN.prototype.and = function and(num) {
        if (this.length > num.length) return this.clone().iand(num);
        return num.clone().iand(this);
    };
    BN.prototype.uand = function uand(num) {
        if (this.length > num.length) return this.clone().iuand(num);
        return num.clone().iuand(this);
    };
    // Xor `num` with `this` in-place
    BN.prototype.iuxor = function iuxor(num) {
        // a.length > b.length
        var a;
        var b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        for(var i = 0; i < b.length; i++)this.words[i] = a.words[i] ^ b.words[i];
        if (this !== a) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = a.length;
        return this._strip();
    };
    BN.prototype.ixor = function ixor(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuxor(num);
    };
    // Xor `num` with `this`
    BN.prototype.xor = function xor(num) {
        if (this.length > num.length) return this.clone().ixor(num);
        return num.clone().ixor(this);
    };
    BN.prototype.uxor = function uxor(num) {
        if (this.length > num.length) return this.clone().iuxor(num);
        return num.clone().iuxor(this);
    };
    // Not ``this`` with ``width`` bitwidth
    BN.prototype.inotn = function inotn(width) {
        assert(typeof width === "number" && width >= 0);
        var bytesNeeded = Math.ceil(width / 26) | 0;
        var bitsLeft = width % 26;
        // Extend the buffer with leading zeroes
        this._expand(bytesNeeded);
        if (bitsLeft > 0) bytesNeeded--;
        // Handle complete words
        for(var i = 0; i < bytesNeeded; i++)this.words[i] = ~this.words[i] & 0x3ffffff;
        // Handle the residue
        if (bitsLeft > 0) this.words[i] = ~this.words[i] & 0x3ffffff >> 26 - bitsLeft;
        // And remove leading zeroes
        return this._strip();
    };
    BN.prototype.notn = function notn(width) {
        return this.clone().inotn(width);
    };
    // Set `bit` of `this`
    BN.prototype.setn = function setn(bit, val) {
        assert(typeof bit === "number" && bit >= 0);
        var off = bit / 26 | 0;
        var wbit = bit % 26;
        this._expand(off + 1);
        if (val) this.words[off] = this.words[off] | 1 << wbit;
        else this.words[off] = this.words[off] & ~(1 << wbit);
        return this._strip();
    };
    // Add `num` to `this` in-place
    BN.prototype.iadd = function iadd(num) {
        var r;
        // negative + positive
        if (this.negative !== 0 && num.negative === 0) {
            this.negative = 0;
            r = this.isub(num);
            this.negative ^= 1;
            return this._normSign();
        // positive + negative
        } else if (this.negative === 0 && num.negative !== 0) {
            num.negative = 0;
            r = this.isub(num);
            num.negative = 1;
            return r._normSign();
        }
        // a.length > b.length
        var a, b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        this.length = a.length;
        if (carry !== 0) {
            this.words[this.length] = carry;
            this.length++;
        // Copy the rest of the words
        } else if (a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        return this;
    };
    // Add `num` to `this`
    BN.prototype.add = function add(num) {
        var res;
        if (num.negative !== 0 && this.negative === 0) {
            num.negative = 0;
            res = this.sub(num);
            num.negative ^= 1;
            return res;
        } else if (num.negative === 0 && this.negative !== 0) {
            this.negative = 0;
            res = num.sub(this);
            this.negative = 1;
            return res;
        }
        if (this.length > num.length) return this.clone().iadd(num);
        return num.clone().iadd(this);
    };
    // Subtract `num` from `this` in-place
    BN.prototype.isub = function isub(num) {
        // this - (-num) = this + num
        if (num.negative !== 0) {
            num.negative = 0;
            var r = this.iadd(num);
            num.negative = 1;
            return r._normSign();
        // -this - num = -(this + num)
        } else if (this.negative !== 0) {
            this.negative = 0;
            this.iadd(num);
            this.negative = 1;
            return this._normSign();
        }
        // At this point both numbers are positive
        var cmp = this.cmp(num);
        // Optimization - zeroify
        if (cmp === 0) {
            this.negative = 0;
            this.length = 1;
            this.words[0] = 0;
            return this;
        }
        // a > b
        var a, b;
        if (cmp > 0) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        // Copy rest of the words
        if (carry === 0 && i < a.length && a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = Math.max(this.length, i);
        if (a !== this) this.negative = 1;
        return this._strip();
    };
    // Subtract `num` from `this`
    BN.prototype.sub = function sub(num) {
        return this.clone().isub(num);
    };
    function smallMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        var len = self.length + num.length | 0;
        out.length = len;
        len = len - 1 | 0;
        // Peel one iteration (compiler can't do it, because of code complexity)
        var a = self.words[0] | 0;
        var b = num.words[0] | 0;
        var r = a * b;
        var lo = r & 0x3ffffff;
        var carry = r / 0x4000000 | 0;
        out.words[0] = lo;
        for(var k = 1; k < len; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = carry >>> 26;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j | 0;
                a = self.words[i] | 0;
                b = num.words[j] | 0;
                r = a * b + rword;
                ncarry += r / 0x4000000 | 0;
                rword = r & 0x3ffffff;
            }
            out.words[k] = rword | 0;
            carry = ncarry | 0;
        }
        if (carry !== 0) out.words[k] = carry | 0;
        else out.length--;
        return out._strip();
    }
    // TODO(indutny): it may be reasonable to omit it for users who don't need
    // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
    // multiplication (like elliptic secp256k1).
    var comb10MulTo = function comb10MulTo(self, num, out) {
        var a = self.words;
        var b = num.words;
        var o = out.words;
        var c = 0;
        var lo;
        var mid;
        var hi;
        var a0 = a[0] | 0;
        var al0 = a0 & 0x1fff;
        var ah0 = a0 >>> 13;
        var a1 = a[1] | 0;
        var al1 = a1 & 0x1fff;
        var ah1 = a1 >>> 13;
        var a2 = a[2] | 0;
        var al2 = a2 & 0x1fff;
        var ah2 = a2 >>> 13;
        var a3 = a[3] | 0;
        var al3 = a3 & 0x1fff;
        var ah3 = a3 >>> 13;
        var a4 = a[4] | 0;
        var al4 = a4 & 0x1fff;
        var ah4 = a4 >>> 13;
        var a5 = a[5] | 0;
        var al5 = a5 & 0x1fff;
        var ah5 = a5 >>> 13;
        var a6 = a[6] | 0;
        var al6 = a6 & 0x1fff;
        var ah6 = a6 >>> 13;
        var a7 = a[7] | 0;
        var al7 = a7 & 0x1fff;
        var ah7 = a7 >>> 13;
        var a8 = a[8] | 0;
        var al8 = a8 & 0x1fff;
        var ah8 = a8 >>> 13;
        var a9 = a[9] | 0;
        var al9 = a9 & 0x1fff;
        var ah9 = a9 >>> 13;
        var b0 = b[0] | 0;
        var bl0 = b0 & 0x1fff;
        var bh0 = b0 >>> 13;
        var b1 = b[1] | 0;
        var bl1 = b1 & 0x1fff;
        var bh1 = b1 >>> 13;
        var b2 = b[2] | 0;
        var bl2 = b2 & 0x1fff;
        var bh2 = b2 >>> 13;
        var b3 = b[3] | 0;
        var bl3 = b3 & 0x1fff;
        var bh3 = b3 >>> 13;
        var b4 = b[4] | 0;
        var bl4 = b4 & 0x1fff;
        var bh4 = b4 >>> 13;
        var b5 = b[5] | 0;
        var bl5 = b5 & 0x1fff;
        var bh5 = b5 >>> 13;
        var b6 = b[6] | 0;
        var bl6 = b6 & 0x1fff;
        var bh6 = b6 >>> 13;
        var b7 = b[7] | 0;
        var bl7 = b7 & 0x1fff;
        var bh7 = b7 >>> 13;
        var b8 = b[8] | 0;
        var bl8 = b8 & 0x1fff;
        var bh8 = b8 >>> 13;
        var b9 = b[9] | 0;
        var bl9 = b9 & 0x1fff;
        var bh9 = b9 >>> 13;
        out.negative = self.negative ^ num.negative;
        out.length = 19;
        /* k = 0 */ lo = Math.imul(al0, bl0);
        mid = Math.imul(al0, bh0);
        mid = mid + Math.imul(ah0, bl0) | 0;
        hi = Math.imul(ah0, bh0);
        var w0 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
        w0 &= 0x3ffffff;
        /* k = 1 */ lo = Math.imul(al1, bl0);
        mid = Math.imul(al1, bh0);
        mid = mid + Math.imul(ah1, bl0) | 0;
        hi = Math.imul(ah1, bh0);
        lo = lo + Math.imul(al0, bl1) | 0;
        mid = mid + Math.imul(al0, bh1) | 0;
        mid = mid + Math.imul(ah0, bl1) | 0;
        hi = hi + Math.imul(ah0, bh1) | 0;
        var w1 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
        w1 &= 0x3ffffff;
        /* k = 2 */ lo = Math.imul(al2, bl0);
        mid = Math.imul(al2, bh0);
        mid = mid + Math.imul(ah2, bl0) | 0;
        hi = Math.imul(ah2, bh0);
        lo = lo + Math.imul(al1, bl1) | 0;
        mid = mid + Math.imul(al1, bh1) | 0;
        mid = mid + Math.imul(ah1, bl1) | 0;
        hi = hi + Math.imul(ah1, bh1) | 0;
        lo = lo + Math.imul(al0, bl2) | 0;
        mid = mid + Math.imul(al0, bh2) | 0;
        mid = mid + Math.imul(ah0, bl2) | 0;
        hi = hi + Math.imul(ah0, bh2) | 0;
        var w2 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
        w2 &= 0x3ffffff;
        /* k = 3 */ lo = Math.imul(al3, bl0);
        mid = Math.imul(al3, bh0);
        mid = mid + Math.imul(ah3, bl0) | 0;
        hi = Math.imul(ah3, bh0);
        lo = lo + Math.imul(al2, bl1) | 0;
        mid = mid + Math.imul(al2, bh1) | 0;
        mid = mid + Math.imul(ah2, bl1) | 0;
        hi = hi + Math.imul(ah2, bh1) | 0;
        lo = lo + Math.imul(al1, bl2) | 0;
        mid = mid + Math.imul(al1, bh2) | 0;
        mid = mid + Math.imul(ah1, bl2) | 0;
        hi = hi + Math.imul(ah1, bh2) | 0;
        lo = lo + Math.imul(al0, bl3) | 0;
        mid = mid + Math.imul(al0, bh3) | 0;
        mid = mid + Math.imul(ah0, bl3) | 0;
        hi = hi + Math.imul(ah0, bh3) | 0;
        var w3 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
        w3 &= 0x3ffffff;
        /* k = 4 */ lo = Math.imul(al4, bl0);
        mid = Math.imul(al4, bh0);
        mid = mid + Math.imul(ah4, bl0) | 0;
        hi = Math.imul(ah4, bh0);
        lo = lo + Math.imul(al3, bl1) | 0;
        mid = mid + Math.imul(al3, bh1) | 0;
        mid = mid + Math.imul(ah3, bl1) | 0;
        hi = hi + Math.imul(ah3, bh1) | 0;
        lo = lo + Math.imul(al2, bl2) | 0;
        mid = mid + Math.imul(al2, bh2) | 0;
        mid = mid + Math.imul(ah2, bl2) | 0;
        hi = hi + Math.imul(ah2, bh2) | 0;
        lo = lo + Math.imul(al1, bl3) | 0;
        mid = mid + Math.imul(al1, bh3) | 0;
        mid = mid + Math.imul(ah1, bl3) | 0;
        hi = hi + Math.imul(ah1, bh3) | 0;
        lo = lo + Math.imul(al0, bl4) | 0;
        mid = mid + Math.imul(al0, bh4) | 0;
        mid = mid + Math.imul(ah0, bl4) | 0;
        hi = hi + Math.imul(ah0, bh4) | 0;
        var w4 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
        w4 &= 0x3ffffff;
        /* k = 5 */ lo = Math.imul(al5, bl0);
        mid = Math.imul(al5, bh0);
        mid = mid + Math.imul(ah5, bl0) | 0;
        hi = Math.imul(ah5, bh0);
        lo = lo + Math.imul(al4, bl1) | 0;
        mid = mid + Math.imul(al4, bh1) | 0;
        mid = mid + Math.imul(ah4, bl1) | 0;
        hi = hi + Math.imul(ah4, bh1) | 0;
        lo = lo + Math.imul(al3, bl2) | 0;
        mid = mid + Math.imul(al3, bh2) | 0;
        mid = mid + Math.imul(ah3, bl2) | 0;
        hi = hi + Math.imul(ah3, bh2) | 0;
        lo = lo + Math.imul(al2, bl3) | 0;
        mid = mid + Math.imul(al2, bh3) | 0;
        mid = mid + Math.imul(ah2, bl3) | 0;
        hi = hi + Math.imul(ah2, bh3) | 0;
        lo = lo + Math.imul(al1, bl4) | 0;
        mid = mid + Math.imul(al1, bh4) | 0;
        mid = mid + Math.imul(ah1, bl4) | 0;
        hi = hi + Math.imul(ah1, bh4) | 0;
        lo = lo + Math.imul(al0, bl5) | 0;
        mid = mid + Math.imul(al0, bh5) | 0;
        mid = mid + Math.imul(ah0, bl5) | 0;
        hi = hi + Math.imul(ah0, bh5) | 0;
        var w5 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
        w5 &= 0x3ffffff;
        /* k = 6 */ lo = Math.imul(al6, bl0);
        mid = Math.imul(al6, bh0);
        mid = mid + Math.imul(ah6, bl0) | 0;
        hi = Math.imul(ah6, bh0);
        lo = lo + Math.imul(al5, bl1) | 0;
        mid = mid + Math.imul(al5, bh1) | 0;
        mid = mid + Math.imul(ah5, bl1) | 0;
        hi = hi + Math.imul(ah5, bh1) | 0;
        lo = lo + Math.imul(al4, bl2) | 0;
        mid = mid + Math.imul(al4, bh2) | 0;
        mid = mid + Math.imul(ah4, bl2) | 0;
        hi = hi + Math.imul(ah4, bh2) | 0;
        lo = lo + Math.imul(al3, bl3) | 0;
        mid = mid + Math.imul(al3, bh3) | 0;
        mid = mid + Math.imul(ah3, bl3) | 0;
        hi = hi + Math.imul(ah3, bh3) | 0;
        lo = lo + Math.imul(al2, bl4) | 0;
        mid = mid + Math.imul(al2, bh4) | 0;
        mid = mid + Math.imul(ah2, bl4) | 0;
        hi = hi + Math.imul(ah2, bh4) | 0;
        lo = lo + Math.imul(al1, bl5) | 0;
        mid = mid + Math.imul(al1, bh5) | 0;
        mid = mid + Math.imul(ah1, bl5) | 0;
        hi = hi + Math.imul(ah1, bh5) | 0;
        lo = lo + Math.imul(al0, bl6) | 0;
        mid = mid + Math.imul(al0, bh6) | 0;
        mid = mid + Math.imul(ah0, bl6) | 0;
        hi = hi + Math.imul(ah0, bh6) | 0;
        var w6 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
        w6 &= 0x3ffffff;
        /* k = 7 */ lo = Math.imul(al7, bl0);
        mid = Math.imul(al7, bh0);
        mid = mid + Math.imul(ah7, bl0) | 0;
        hi = Math.imul(ah7, bh0);
        lo = lo + Math.imul(al6, bl1) | 0;
        mid = mid + Math.imul(al6, bh1) | 0;
        mid = mid + Math.imul(ah6, bl1) | 0;
        hi = hi + Math.imul(ah6, bh1) | 0;
        lo = lo + Math.imul(al5, bl2) | 0;
        mid = mid + Math.imul(al5, bh2) | 0;
        mid = mid + Math.imul(ah5, bl2) | 0;
        hi = hi + Math.imul(ah5, bh2) | 0;
        lo = lo + Math.imul(al4, bl3) | 0;
        mid = mid + Math.imul(al4, bh3) | 0;
        mid = mid + Math.imul(ah4, bl3) | 0;
        hi = hi + Math.imul(ah4, bh3) | 0;
        lo = lo + Math.imul(al3, bl4) | 0;
        mid = mid + Math.imul(al3, bh4) | 0;
        mid = mid + Math.imul(ah3, bl4) | 0;
        hi = hi + Math.imul(ah3, bh4) | 0;
        lo = lo + Math.imul(al2, bl5) | 0;
        mid = mid + Math.imul(al2, bh5) | 0;
        mid = mid + Math.imul(ah2, bl5) | 0;
        hi = hi + Math.imul(ah2, bh5) | 0;
        lo = lo + Math.imul(al1, bl6) | 0;
        mid = mid + Math.imul(al1, bh6) | 0;
        mid = mid + Math.imul(ah1, bl6) | 0;
        hi = hi + Math.imul(ah1, bh6) | 0;
        lo = lo + Math.imul(al0, bl7) | 0;
        mid = mid + Math.imul(al0, bh7) | 0;
        mid = mid + Math.imul(ah0, bl7) | 0;
        hi = hi + Math.imul(ah0, bh7) | 0;
        var w7 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
        w7 &= 0x3ffffff;
        /* k = 8 */ lo = Math.imul(al8, bl0);
        mid = Math.imul(al8, bh0);
        mid = mid + Math.imul(ah8, bl0) | 0;
        hi = Math.imul(ah8, bh0);
        lo = lo + Math.imul(al7, bl1) | 0;
        mid = mid + Math.imul(al7, bh1) | 0;
        mid = mid + Math.imul(ah7, bl1) | 0;
        hi = hi + Math.imul(ah7, bh1) | 0;
        lo = lo + Math.imul(al6, bl2) | 0;
        mid = mid + Math.imul(al6, bh2) | 0;
        mid = mid + Math.imul(ah6, bl2) | 0;
        hi = hi + Math.imul(ah6, bh2) | 0;
        lo = lo + Math.imul(al5, bl3) | 0;
        mid = mid + Math.imul(al5, bh3) | 0;
        mid = mid + Math.imul(ah5, bl3) | 0;
        hi = hi + Math.imul(ah5, bh3) | 0;
        lo = lo + Math.imul(al4, bl4) | 0;
        mid = mid + Math.imul(al4, bh4) | 0;
        mid = mid + Math.imul(ah4, bl4) | 0;
        hi = hi + Math.imul(ah4, bh4) | 0;
        lo = lo + Math.imul(al3, bl5) | 0;
        mid = mid + Math.imul(al3, bh5) | 0;
        mid = mid + Math.imul(ah3, bl5) | 0;
        hi = hi + Math.imul(ah3, bh5) | 0;
        lo = lo + Math.imul(al2, bl6) | 0;
        mid = mid + Math.imul(al2, bh6) | 0;
        mid = mid + Math.imul(ah2, bl6) | 0;
        hi = hi + Math.imul(ah2, bh6) | 0;
        lo = lo + Math.imul(al1, bl7) | 0;
        mid = mid + Math.imul(al1, bh7) | 0;
        mid = mid + Math.imul(ah1, bl7) | 0;
        hi = hi + Math.imul(ah1, bh7) | 0;
        lo = lo + Math.imul(al0, bl8) | 0;
        mid = mid + Math.imul(al0, bh8) | 0;
        mid = mid + Math.imul(ah0, bl8) | 0;
        hi = hi + Math.imul(ah0, bh8) | 0;
        var w8 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
        w8 &= 0x3ffffff;
        /* k = 9 */ lo = Math.imul(al9, bl0);
        mid = Math.imul(al9, bh0);
        mid = mid + Math.imul(ah9, bl0) | 0;
        hi = Math.imul(ah9, bh0);
        lo = lo + Math.imul(al8, bl1) | 0;
        mid = mid + Math.imul(al8, bh1) | 0;
        mid = mid + Math.imul(ah8, bl1) | 0;
        hi = hi + Math.imul(ah8, bh1) | 0;
        lo = lo + Math.imul(al7, bl2) | 0;
        mid = mid + Math.imul(al7, bh2) | 0;
        mid = mid + Math.imul(ah7, bl2) | 0;
        hi = hi + Math.imul(ah7, bh2) | 0;
        lo = lo + Math.imul(al6, bl3) | 0;
        mid = mid + Math.imul(al6, bh3) | 0;
        mid = mid + Math.imul(ah6, bl3) | 0;
        hi = hi + Math.imul(ah6, bh3) | 0;
        lo = lo + Math.imul(al5, bl4) | 0;
        mid = mid + Math.imul(al5, bh4) | 0;
        mid = mid + Math.imul(ah5, bl4) | 0;
        hi = hi + Math.imul(ah5, bh4) | 0;
        lo = lo + Math.imul(al4, bl5) | 0;
        mid = mid + Math.imul(al4, bh5) | 0;
        mid = mid + Math.imul(ah4, bl5) | 0;
        hi = hi + Math.imul(ah4, bh5) | 0;
        lo = lo + Math.imul(al3, bl6) | 0;
        mid = mid + Math.imul(al3, bh6) | 0;
        mid = mid + Math.imul(ah3, bl6) | 0;
        hi = hi + Math.imul(ah3, bh6) | 0;
        lo = lo + Math.imul(al2, bl7) | 0;
        mid = mid + Math.imul(al2, bh7) | 0;
        mid = mid + Math.imul(ah2, bl7) | 0;
        hi = hi + Math.imul(ah2, bh7) | 0;
        lo = lo + Math.imul(al1, bl8) | 0;
        mid = mid + Math.imul(al1, bh8) | 0;
        mid = mid + Math.imul(ah1, bl8) | 0;
        hi = hi + Math.imul(ah1, bh8) | 0;
        lo = lo + Math.imul(al0, bl9) | 0;
        mid = mid + Math.imul(al0, bh9) | 0;
        mid = mid + Math.imul(ah0, bl9) | 0;
        hi = hi + Math.imul(ah0, bh9) | 0;
        var w9 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
        w9 &= 0x3ffffff;
        /* k = 10 */ lo = Math.imul(al9, bl1);
        mid = Math.imul(al9, bh1);
        mid = mid + Math.imul(ah9, bl1) | 0;
        hi = Math.imul(ah9, bh1);
        lo = lo + Math.imul(al8, bl2) | 0;
        mid = mid + Math.imul(al8, bh2) | 0;
        mid = mid + Math.imul(ah8, bl2) | 0;
        hi = hi + Math.imul(ah8, bh2) | 0;
        lo = lo + Math.imul(al7, bl3) | 0;
        mid = mid + Math.imul(al7, bh3) | 0;
        mid = mid + Math.imul(ah7, bl3) | 0;
        hi = hi + Math.imul(ah7, bh3) | 0;
        lo = lo + Math.imul(al6, bl4) | 0;
        mid = mid + Math.imul(al6, bh4) | 0;
        mid = mid + Math.imul(ah6, bl4) | 0;
        hi = hi + Math.imul(ah6, bh4) | 0;
        lo = lo + Math.imul(al5, bl5) | 0;
        mid = mid + Math.imul(al5, bh5) | 0;
        mid = mid + Math.imul(ah5, bl5) | 0;
        hi = hi + Math.imul(ah5, bh5) | 0;
        lo = lo + Math.imul(al4, bl6) | 0;
        mid = mid + Math.imul(al4, bh6) | 0;
        mid = mid + Math.imul(ah4, bl6) | 0;
        hi = hi + Math.imul(ah4, bh6) | 0;
        lo = lo + Math.imul(al3, bl7) | 0;
        mid = mid + Math.imul(al3, bh7) | 0;
        mid = mid + Math.imul(ah3, bl7) | 0;
        hi = hi + Math.imul(ah3, bh7) | 0;
        lo = lo + Math.imul(al2, bl8) | 0;
        mid = mid + Math.imul(al2, bh8) | 0;
        mid = mid + Math.imul(ah2, bl8) | 0;
        hi = hi + Math.imul(ah2, bh8) | 0;
        lo = lo + Math.imul(al1, bl9) | 0;
        mid = mid + Math.imul(al1, bh9) | 0;
        mid = mid + Math.imul(ah1, bl9) | 0;
        hi = hi + Math.imul(ah1, bh9) | 0;
        var w10 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
        w10 &= 0x3ffffff;
        /* k = 11 */ lo = Math.imul(al9, bl2);
        mid = Math.imul(al9, bh2);
        mid = mid + Math.imul(ah9, bl2) | 0;
        hi = Math.imul(ah9, bh2);
        lo = lo + Math.imul(al8, bl3) | 0;
        mid = mid + Math.imul(al8, bh3) | 0;
        mid = mid + Math.imul(ah8, bl3) | 0;
        hi = hi + Math.imul(ah8, bh3) | 0;
        lo = lo + Math.imul(al7, bl4) | 0;
        mid = mid + Math.imul(al7, bh4) | 0;
        mid = mid + Math.imul(ah7, bl4) | 0;
        hi = hi + Math.imul(ah7, bh4) | 0;
        lo = lo + Math.imul(al6, bl5) | 0;
        mid = mid + Math.imul(al6, bh5) | 0;
        mid = mid + Math.imul(ah6, bl5) | 0;
        hi = hi + Math.imul(ah6, bh5) | 0;
        lo = lo + Math.imul(al5, bl6) | 0;
        mid = mid + Math.imul(al5, bh6) | 0;
        mid = mid + Math.imul(ah5, bl6) | 0;
        hi = hi + Math.imul(ah5, bh6) | 0;
        lo = lo + Math.imul(al4, bl7) | 0;
        mid = mid + Math.imul(al4, bh7) | 0;
        mid = mid + Math.imul(ah4, bl7) | 0;
        hi = hi + Math.imul(ah4, bh7) | 0;
        lo = lo + Math.imul(al3, bl8) | 0;
        mid = mid + Math.imul(al3, bh8) | 0;
        mid = mid + Math.imul(ah3, bl8) | 0;
        hi = hi + Math.imul(ah3, bh8) | 0;
        lo = lo + Math.imul(al2, bl9) | 0;
        mid = mid + Math.imul(al2, bh9) | 0;
        mid = mid + Math.imul(ah2, bl9) | 0;
        hi = hi + Math.imul(ah2, bh9) | 0;
        var w11 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
        w11 &= 0x3ffffff;
        /* k = 12 */ lo = Math.imul(al9, bl3);
        mid = Math.imul(al9, bh3);
        mid = mid + Math.imul(ah9, bl3) | 0;
        hi = Math.imul(ah9, bh3);
        lo = lo + Math.imul(al8, bl4) | 0;
        mid = mid + Math.imul(al8, bh4) | 0;
        mid = mid + Math.imul(ah8, bl4) | 0;
        hi = hi + Math.imul(ah8, bh4) | 0;
        lo = lo + Math.imul(al7, bl5) | 0;
        mid = mid + Math.imul(al7, bh5) | 0;
        mid = mid + Math.imul(ah7, bl5) | 0;
        hi = hi + Math.imul(ah7, bh5) | 0;
        lo = lo + Math.imul(al6, bl6) | 0;
        mid = mid + Math.imul(al6, bh6) | 0;
        mid = mid + Math.imul(ah6, bl6) | 0;
        hi = hi + Math.imul(ah6, bh6) | 0;
        lo = lo + Math.imul(al5, bl7) | 0;
        mid = mid + Math.imul(al5, bh7) | 0;
        mid = mid + Math.imul(ah5, bl7) | 0;
        hi = hi + Math.imul(ah5, bh7) | 0;
        lo = lo + Math.imul(al4, bl8) | 0;
        mid = mid + Math.imul(al4, bh8) | 0;
        mid = mid + Math.imul(ah4, bl8) | 0;
        hi = hi + Math.imul(ah4, bh8) | 0;
        lo = lo + Math.imul(al3, bl9) | 0;
        mid = mid + Math.imul(al3, bh9) | 0;
        mid = mid + Math.imul(ah3, bl9) | 0;
        hi = hi + Math.imul(ah3, bh9) | 0;
        var w12 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
        w12 &= 0x3ffffff;
        /* k = 13 */ lo = Math.imul(al9, bl4);
        mid = Math.imul(al9, bh4);
        mid = mid + Math.imul(ah9, bl4) | 0;
        hi = Math.imul(ah9, bh4);
        lo = lo + Math.imul(al8, bl5) | 0;
        mid = mid + Math.imul(al8, bh5) | 0;
        mid = mid + Math.imul(ah8, bl5) | 0;
        hi = hi + Math.imul(ah8, bh5) | 0;
        lo = lo + Math.imul(al7, bl6) | 0;
        mid = mid + Math.imul(al7, bh6) | 0;
        mid = mid + Math.imul(ah7, bl6) | 0;
        hi = hi + Math.imul(ah7, bh6) | 0;
        lo = lo + Math.imul(al6, bl7) | 0;
        mid = mid + Math.imul(al6, bh7) | 0;
        mid = mid + Math.imul(ah6, bl7) | 0;
        hi = hi + Math.imul(ah6, bh7) | 0;
        lo = lo + Math.imul(al5, bl8) | 0;
        mid = mid + Math.imul(al5, bh8) | 0;
        mid = mid + Math.imul(ah5, bl8) | 0;
        hi = hi + Math.imul(ah5, bh8) | 0;
        lo = lo + Math.imul(al4, bl9) | 0;
        mid = mid + Math.imul(al4, bh9) | 0;
        mid = mid + Math.imul(ah4, bl9) | 0;
        hi = hi + Math.imul(ah4, bh9) | 0;
        var w13 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
        w13 &= 0x3ffffff;
        /* k = 14 */ lo = Math.imul(al9, bl5);
        mid = Math.imul(al9, bh5);
        mid = mid + Math.imul(ah9, bl5) | 0;
        hi = Math.imul(ah9, bh5);
        lo = lo + Math.imul(al8, bl6) | 0;
        mid = mid + Math.imul(al8, bh6) | 0;
        mid = mid + Math.imul(ah8, bl6) | 0;
        hi = hi + Math.imul(ah8, bh6) | 0;
        lo = lo + Math.imul(al7, bl7) | 0;
        mid = mid + Math.imul(al7, bh7) | 0;
        mid = mid + Math.imul(ah7, bl7) | 0;
        hi = hi + Math.imul(ah7, bh7) | 0;
        lo = lo + Math.imul(al6, bl8) | 0;
        mid = mid + Math.imul(al6, bh8) | 0;
        mid = mid + Math.imul(ah6, bl8) | 0;
        hi = hi + Math.imul(ah6, bh8) | 0;
        lo = lo + Math.imul(al5, bl9) | 0;
        mid = mid + Math.imul(al5, bh9) | 0;
        mid = mid + Math.imul(ah5, bl9) | 0;
        hi = hi + Math.imul(ah5, bh9) | 0;
        var w14 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
        w14 &= 0x3ffffff;
        /* k = 15 */ lo = Math.imul(al9, bl6);
        mid = Math.imul(al9, bh6);
        mid = mid + Math.imul(ah9, bl6) | 0;
        hi = Math.imul(ah9, bh6);
        lo = lo + Math.imul(al8, bl7) | 0;
        mid = mid + Math.imul(al8, bh7) | 0;
        mid = mid + Math.imul(ah8, bl7) | 0;
        hi = hi + Math.imul(ah8, bh7) | 0;
        lo = lo + Math.imul(al7, bl8) | 0;
        mid = mid + Math.imul(al7, bh8) | 0;
        mid = mid + Math.imul(ah7, bl8) | 0;
        hi = hi + Math.imul(ah7, bh8) | 0;
        lo = lo + Math.imul(al6, bl9) | 0;
        mid = mid + Math.imul(al6, bh9) | 0;
        mid = mid + Math.imul(ah6, bl9) | 0;
        hi = hi + Math.imul(ah6, bh9) | 0;
        var w15 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
        w15 &= 0x3ffffff;
        /* k = 16 */ lo = Math.imul(al9, bl7);
        mid = Math.imul(al9, bh7);
        mid = mid + Math.imul(ah9, bl7) | 0;
        hi = Math.imul(ah9, bh7);
        lo = lo + Math.imul(al8, bl8) | 0;
        mid = mid + Math.imul(al8, bh8) | 0;
        mid = mid + Math.imul(ah8, bl8) | 0;
        hi = hi + Math.imul(ah8, bh8) | 0;
        lo = lo + Math.imul(al7, bl9) | 0;
        mid = mid + Math.imul(al7, bh9) | 0;
        mid = mid + Math.imul(ah7, bl9) | 0;
        hi = hi + Math.imul(ah7, bh9) | 0;
        var w16 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
        w16 &= 0x3ffffff;
        /* k = 17 */ lo = Math.imul(al9, bl8);
        mid = Math.imul(al9, bh8);
        mid = mid + Math.imul(ah9, bl8) | 0;
        hi = Math.imul(ah9, bh8);
        lo = lo + Math.imul(al8, bl9) | 0;
        mid = mid + Math.imul(al8, bh9) | 0;
        mid = mid + Math.imul(ah8, bl9) | 0;
        hi = hi + Math.imul(ah8, bh9) | 0;
        var w17 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
        w17 &= 0x3ffffff;
        /* k = 18 */ lo = Math.imul(al9, bl9);
        mid = Math.imul(al9, bh9);
        mid = mid + Math.imul(ah9, bl9) | 0;
        hi = Math.imul(ah9, bh9);
        var w18 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
        w18 &= 0x3ffffff;
        o[0] = w0;
        o[1] = w1;
        o[2] = w2;
        o[3] = w3;
        o[4] = w4;
        o[5] = w5;
        o[6] = w6;
        o[7] = w7;
        o[8] = w8;
        o[9] = w9;
        o[10] = w10;
        o[11] = w11;
        o[12] = w12;
        o[13] = w13;
        o[14] = w14;
        o[15] = w15;
        o[16] = w16;
        o[17] = w17;
        o[18] = w18;
        if (c !== 0) {
            o[19] = c;
            out.length++;
        }
        return out;
    };
    // Polyfill comb
    if (!Math.imul) comb10MulTo = smallMulTo;
    function bigMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        out.length = self.length + num.length;
        var carry = 0;
        var hncarry = 0;
        for(var k = 0; k < out.length - 1; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = hncarry;
            hncarry = 0;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j;
                var a = self.words[i] | 0;
                var b = num.words[j] | 0;
                var r = a * b;
                var lo = r & 0x3ffffff;
                ncarry = ncarry + (r / 0x4000000 | 0) | 0;
                lo = lo + rword | 0;
                rword = lo & 0x3ffffff;
                ncarry = ncarry + (lo >>> 26) | 0;
                hncarry += ncarry >>> 26;
                ncarry &= 0x3ffffff;
            }
            out.words[k] = rword;
            carry = ncarry;
            ncarry = hncarry;
        }
        if (carry !== 0) out.words[k] = carry;
        else out.length--;
        return out._strip();
    }
    function jumboMulTo(self, num, out) {
        // Temporary disable, see https://github.com/indutny/bn.js/issues/211
        // var fftm = new FFTM();
        // return fftm.mulp(self, num, out);
        return bigMulTo(self, num, out);
    }
    BN.prototype.mulTo = function mulTo(num, out) {
        var res;
        var len = this.length + num.length;
        if (this.length === 10 && num.length === 10) res = comb10MulTo(this, num, out);
        else if (len < 63) res = smallMulTo(this, num, out);
        else if (len < 1024) res = bigMulTo(this, num, out);
        else res = jumboMulTo(this, num, out);
        return res;
    };
    // Cooley-Tukey algorithm for FFT
    // slightly revisited to rely on looping instead of recursion
    function FFTM(x, y) {
        this.x = x;
        this.y = y;
    }
    FFTM.prototype.makeRBT = function makeRBT(N) {
        var t = new Array(N);
        var l = BN.prototype._countBits(N) - 1;
        for(var i = 0; i < N; i++)t[i] = this.revBin(i, l, N);
        return t;
    };
    // Returns binary-reversed representation of `x`
    FFTM.prototype.revBin = function revBin(x, l, N) {
        if (x === 0 || x === N - 1) return x;
        var rb = 0;
        for(var i = 0; i < l; i++){
            rb |= (x & 1) << l - i - 1;
            x >>= 1;
        }
        return rb;
    };
    // Performs "tweedling" phase, therefore 'emulating'
    // behaviour of the recursive algorithm
    FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
        for(var i = 0; i < N; i++){
            rtws[i] = rws[rbt[i]];
            itws[i] = iws[rbt[i]];
        }
    };
    FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
        this.permute(rbt, rws, iws, rtws, itws, N);
        for(var s = 1; s < N; s <<= 1){
            var l = s << 1;
            var rtwdf = Math.cos(2 * Math.PI / l);
            var itwdf = Math.sin(2 * Math.PI / l);
            for(var p = 0; p < N; p += l){
                var rtwdf_ = rtwdf;
                var itwdf_ = itwdf;
                for(var j = 0; j < s; j++){
                    var re = rtws[p + j];
                    var ie = itws[p + j];
                    var ro = rtws[p + j + s];
                    var io = itws[p + j + s];
                    var rx = rtwdf_ * ro - itwdf_ * io;
                    io = rtwdf_ * io + itwdf_ * ro;
                    ro = rx;
                    rtws[p + j] = re + ro;
                    itws[p + j] = ie + io;
                    rtws[p + j + s] = re - ro;
                    itws[p + j + s] = ie - io;
                    /* jshint maxdepth : false */ if (j !== l) {
                        rx = rtwdf * rtwdf_ - itwdf * itwdf_;
                        itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                        rtwdf_ = rx;
                    }
                }
            }
        }
    };
    FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
        var N = Math.max(m, n) | 1;
        var odd = N & 1;
        var i = 0;
        for(N = N / 2 | 0; N; N = N >>> 1)i++;
        return 1 << i + 1 + odd;
    };
    FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
        if (N <= 1) return;
        for(var i = 0; i < N / 2; i++){
            var t = rws[i];
            rws[i] = rws[N - i - 1];
            rws[N - i - 1] = t;
            t = iws[i];
            iws[i] = -iws[N - i - 1];
            iws[N - i - 1] = -t;
        }
    };
    FFTM.prototype.normalize13b = function normalize13b(ws, N) {
        var carry = 0;
        for(var i = 0; i < N / 2; i++){
            var w = Math.round(ws[2 * i + 1] / N) * 0x2000 + Math.round(ws[2 * i] / N) + carry;
            ws[i] = w & 0x3ffffff;
            if (w < 0x4000000) carry = 0;
            else carry = w / 0x4000000 | 0;
        }
        return ws;
    };
    FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
        var carry = 0;
        for(var i = 0; i < len; i++){
            carry = carry + (ws[i] | 0);
            rws[2 * i] = carry & 0x1fff;
            carry = carry >>> 13;
            rws[2 * i + 1] = carry & 0x1fff;
            carry = carry >>> 13;
        }
        // Pad with zeroes
        for(i = 2 * len; i < N; ++i)rws[i] = 0;
        assert(carry === 0);
        assert((carry & -8192) === 0);
    };
    FFTM.prototype.stub = function stub(N) {
        var ph = new Array(N);
        for(var i = 0; i < N; i++)ph[i] = 0;
        return ph;
    };
    FFTM.prototype.mulp = function mulp(x, y, out) {
        var N = 2 * this.guessLen13b(x.length, y.length);
        var rbt = this.makeRBT(N);
        var _ = this.stub(N);
        var rws = new Array(N);
        var rwst = new Array(N);
        var iwst = new Array(N);
        var nrws = new Array(N);
        var nrwst = new Array(N);
        var niwst = new Array(N);
        var rmws = out.words;
        rmws.length = N;
        this.convert13b(x.words, x.length, rws, N);
        this.convert13b(y.words, y.length, nrws, N);
        this.transform(rws, _, rwst, iwst, N, rbt);
        this.transform(nrws, _, nrwst, niwst, N, rbt);
        for(var i = 0; i < N; i++){
            var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
            iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
            rwst[i] = rx;
        }
        this.conjugate(rwst, iwst, N);
        this.transform(rwst, iwst, rmws, _, N, rbt);
        this.conjugate(rmws, _, N);
        this.normalize13b(rmws, N);
        out.negative = x.negative ^ y.negative;
        out.length = x.length + y.length;
        return out._strip();
    };
    // Multiply `this` by `num`
    BN.prototype.mul = function mul(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return this.mulTo(num, out);
    };
    // Multiply employing FFT
    BN.prototype.mulf = function mulf(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return jumboMulTo(this, num, out);
    };
    // In-place Multiplication
    BN.prototype.imul = function imul(num) {
        return this.clone().mulTo(num, this);
    };
    BN.prototype.imuln = function imuln(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(typeof num === "number");
        assert(num < 0x4000000);
        // Carry
        var carry = 0;
        for(var i = 0; i < this.length; i++){
            var w = (this.words[i] | 0) * num;
            var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
            carry >>= 26;
            carry += w / 0x4000000 | 0;
            // NOTE: lo is 27bit maximum
            carry += lo >>> 26;
            this.words[i] = lo & 0x3ffffff;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return isNegNum ? this.ineg() : this;
    };
    BN.prototype.muln = function muln(num) {
        return this.clone().imuln(num);
    };
    // `this` * `this`
    BN.prototype.sqr = function sqr() {
        return this.mul(this);
    };
    // `this` * `this` in-place
    BN.prototype.isqr = function isqr() {
        return this.imul(this.clone());
    };
    // Math.pow(`this`, `num`)
    BN.prototype.pow = function pow(num) {
        var w = toBitArray(num);
        if (w.length === 0) return new BN(1);
        // Skip leading zeroes
        var res = this;
        for(var i = 0; i < w.length; i++, res = res.sqr()){
            if (w[i] !== 0) break;
        }
        if (++i < w.length) for(var q = res.sqr(); i < w.length; i++, q = q.sqr()){
            if (w[i] === 0) continue;
            res = res.mul(q);
        }
        return res;
    };
    // Shift-left in-place
    BN.prototype.iushln = function iushln(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        var carryMask = 0x3ffffff >>> 26 - r << 26 - r;
        var i;
        if (r !== 0) {
            var carry = 0;
            for(i = 0; i < this.length; i++){
                var newCarry = this.words[i] & carryMask;
                var c = (this.words[i] | 0) - newCarry << r;
                this.words[i] = c | carry;
                carry = newCarry >>> 26 - r;
            }
            if (carry) {
                this.words[i] = carry;
                this.length++;
            }
        }
        if (s !== 0) {
            for(i = this.length - 1; i >= 0; i--)this.words[i + s] = this.words[i];
            for(i = 0; i < s; i++)this.words[i] = 0;
            this.length += s;
        }
        return this._strip();
    };
    BN.prototype.ishln = function ishln(bits) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushln(bits);
    };
    // Shift-right in-place
    // NOTE: `hint` is a lowest bit before trailing zeroes
    // NOTE: if `extended` is present - it will be filled with destroyed bits
    BN.prototype.iushrn = function iushrn(bits, hint, extended) {
        assert(typeof bits === "number" && bits >= 0);
        var h;
        if (hint) h = (hint - hint % 26) / 26;
        else h = 0;
        var r = bits % 26;
        var s = Math.min((bits - r) / 26, this.length);
        var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
        var maskedWords = extended;
        h -= s;
        h = Math.max(0, h);
        // Extended mode, copy masked part
        if (maskedWords) {
            for(var i = 0; i < s; i++)maskedWords.words[i] = this.words[i];
            maskedWords.length = s;
        }
        if (s === 0) ;
        else if (this.length > s) {
            this.length -= s;
            for(i = 0; i < this.length; i++)this.words[i] = this.words[i + s];
        } else {
            this.words[0] = 0;
            this.length = 1;
        }
        var carry = 0;
        for(i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--){
            var word = this.words[i] | 0;
            this.words[i] = carry << 26 - r | word >>> r;
            carry = word & mask;
        }
        // Push carried bits as a mask
        if (maskedWords && carry !== 0) maskedWords.words[maskedWords.length++] = carry;
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this._strip();
    };
    BN.prototype.ishrn = function ishrn(bits, hint, extended) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushrn(bits, hint, extended);
    };
    // Shift-left
    BN.prototype.shln = function shln(bits) {
        return this.clone().ishln(bits);
    };
    BN.prototype.ushln = function ushln(bits) {
        return this.clone().iushln(bits);
    };
    // Shift-right
    BN.prototype.shrn = function shrn(bits) {
        return this.clone().ishrn(bits);
    };
    BN.prototype.ushrn = function ushrn(bits) {
        return this.clone().iushrn(bits);
    };
    // Test if n bit is set
    BN.prototype.testn = function testn(bit) {
        assert(typeof bit === "number" && bit >= 0);
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) return false;
        // Check bit and return
        var w = this.words[s];
        return !!(w & q);
    };
    // Return only lowers bits of number (in-place)
    BN.prototype.imaskn = function imaskn(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        assert(this.negative === 0, "imaskn works only with positive numbers");
        if (this.length <= s) return this;
        if (r !== 0) s++;
        this.length = Math.min(s, this.length);
        if (r !== 0) {
            var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
            this.words[this.length - 1] &= mask;
        }
        return this._strip();
    };
    // Return only lowers bits of number
    BN.prototype.maskn = function maskn(bits) {
        return this.clone().imaskn(bits);
    };
    // Add plain number `num` to `this`
    BN.prototype.iaddn = function iaddn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.isubn(-num);
        // Possible sign change
        if (this.negative !== 0) {
            if (this.length === 1 && (this.words[0] | 0) <= num) {
                this.words[0] = num - (this.words[0] | 0);
                this.negative = 0;
                return this;
            }
            this.negative = 0;
            this.isubn(num);
            this.negative = 1;
            return this;
        }
        // Add without checks
        return this._iaddn(num);
    };
    BN.prototype._iaddn = function _iaddn(num) {
        this.words[0] += num;
        // Carry
        for(var i = 0; i < this.length && this.words[i] >= 0x4000000; i++){
            this.words[i] -= 0x4000000;
            if (i === this.length - 1) this.words[i + 1] = 1;
            else this.words[i + 1]++;
        }
        this.length = Math.max(this.length, i + 1);
        return this;
    };
    // Subtract plain number `num` from `this`
    BN.prototype.isubn = function isubn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.iaddn(-num);
        if (this.negative !== 0) {
            this.negative = 0;
            this.iaddn(num);
            this.negative = 1;
            return this;
        }
        this.words[0] -= num;
        if (this.length === 1 && this.words[0] < 0) {
            this.words[0] = -this.words[0];
            this.negative = 1;
        } else // Carry
        for(var i = 0; i < this.length && this.words[i] < 0; i++){
            this.words[i] += 0x4000000;
            this.words[i + 1] -= 1;
        }
        return this._strip();
    };
    BN.prototype.addn = function addn(num) {
        return this.clone().iaddn(num);
    };
    BN.prototype.subn = function subn(num) {
        return this.clone().isubn(num);
    };
    BN.prototype.iabs = function iabs() {
        this.negative = 0;
        return this;
    };
    BN.prototype.abs = function abs() {
        return this.clone().iabs();
    };
    BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
        var len = num.length + shift;
        var i;
        this._expand(len);
        var w;
        var carry = 0;
        for(i = 0; i < num.length; i++){
            w = (this.words[i + shift] | 0) + carry;
            var right = (num.words[i] | 0) * mul;
            w -= right & 0x3ffffff;
            carry = (w >> 26) - (right / 0x4000000 | 0);
            this.words[i + shift] = w & 0x3ffffff;
        }
        for(; i < this.length - shift; i++){
            w = (this.words[i + shift] | 0) + carry;
            carry = w >> 26;
            this.words[i + shift] = w & 0x3ffffff;
        }
        if (carry === 0) return this._strip();
        // Subtraction overflow
        assert(carry === -1);
        carry = 0;
        for(i = 0; i < this.length; i++){
            w = -(this.words[i] | 0) + carry;
            carry = w >> 26;
            this.words[i] = w & 0x3ffffff;
        }
        this.negative = 1;
        return this._strip();
    };
    BN.prototype._wordDiv = function _wordDiv(num, mode) {
        var shift = this.length - num.length;
        var a = this.clone();
        var b = num;
        // Normalize
        var bhi = b.words[b.length - 1] | 0;
        var bhiBits = this._countBits(bhi);
        shift = 26 - bhiBits;
        if (shift !== 0) {
            b = b.ushln(shift);
            a.iushln(shift);
            bhi = b.words[b.length - 1] | 0;
        }
        // Initialize quotient
        var m = a.length - b.length;
        var q;
        if (mode !== "mod") {
            q = new BN(null);
            q.length = m + 1;
            q.words = new Array(q.length);
            for(var i = 0; i < q.length; i++)q.words[i] = 0;
        }
        var diff = a.clone()._ishlnsubmul(b, 1, m);
        if (diff.negative === 0) {
            a = diff;
            if (q) q.words[m] = 1;
        }
        for(var j = m - 1; j >= 0; j--){
            var qj = (a.words[b.length + j] | 0) * 0x4000000 + (a.words[b.length + j - 1] | 0);
            // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
            // (0x7ffffff)
            qj = Math.min(qj / bhi | 0, 0x3ffffff);
            a._ishlnsubmul(b, qj, j);
            while(a.negative !== 0){
                qj--;
                a.negative = 0;
                a._ishlnsubmul(b, 1, j);
                if (!a.isZero()) a.negative ^= 1;
            }
            if (q) q.words[j] = qj;
        }
        if (q) q._strip();
        a._strip();
        // Denormalize
        if (mode !== "div" && shift !== 0) a.iushrn(shift);
        return {
            div: q || null,
            mod: a
        };
    };
    // NOTE: 1) `mode` can be set to `mod` to request mod only,
    //       to `div` to request div only, or be absent to
    //       request both div & mod
    //       2) `positive` is true if unsigned mod is requested
    BN.prototype.divmod = function divmod(num, mode, positive) {
        assert(!num.isZero());
        if (this.isZero()) return {
            div: new BN(0),
            mod: new BN(0)
        };
        var div, mod, res;
        if (this.negative !== 0 && num.negative === 0) {
            res = this.neg().divmod(num, mode);
            if (mode !== "mod") div = res.div.neg();
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.iadd(num);
            }
            return {
                div: div,
                mod: mod
            };
        }
        if (this.negative === 0 && num.negative !== 0) {
            res = this.divmod(num.neg(), mode);
            if (mode !== "mod") div = res.div.neg();
            return {
                div: div,
                mod: res.mod
            };
        }
        if ((this.negative & num.negative) !== 0) {
            res = this.neg().divmod(num.neg(), mode);
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.isub(num);
            }
            return {
                div: res.div,
                mod: mod
            };
        }
        // Both numbers are positive at this point
        // Strip both numbers to approximate shift value
        if (num.length > this.length || this.cmp(num) < 0) return {
            div: new BN(0),
            mod: this
        };
        // Very short reduction
        if (num.length === 1) {
            if (mode === "div") return {
                div: this.divn(num.words[0]),
                mod: null
            };
            if (mode === "mod") return {
                div: null,
                mod: new BN(this.modrn(num.words[0]))
            };
            return {
                div: this.divn(num.words[0]),
                mod: new BN(this.modrn(num.words[0]))
            };
        }
        return this._wordDiv(num, mode);
    };
    // Find `this` / `num`
    BN.prototype.div = function div(num) {
        return this.divmod(num, "div", false).div;
    };
    // Find `this` % `num`
    BN.prototype.mod = function mod(num) {
        return this.divmod(num, "mod", false).mod;
    };
    BN.prototype.umod = function umod(num) {
        return this.divmod(num, "mod", true).mod;
    };
    // Find Round(`this` / `num`)
    BN.prototype.divRound = function divRound(num) {
        var dm = this.divmod(num);
        // Fast case - exact division
        if (dm.mod.isZero()) return dm.div;
        var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;
        var half = num.ushrn(1);
        var r2 = num.andln(1);
        var cmp = mod.cmp(half);
        // Round down
        if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
        // Round up
        return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
    };
    BN.prototype.modrn = function modrn(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(num <= 0x3ffffff);
        var p = 67108864 % num;
        var acc = 0;
        for(var i = this.length - 1; i >= 0; i--)acc = (p * acc + (this.words[i] | 0)) % num;
        return isNegNum ? -acc : acc;
    };
    // WARNING: DEPRECATED
    BN.prototype.modn = function modn(num) {
        return this.modrn(num);
    };
    // In-place division by number
    BN.prototype.idivn = function idivn(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(num <= 0x3ffffff);
        var carry = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var w = (this.words[i] | 0) + carry * 0x4000000;
            this.words[i] = w / num | 0;
            carry = w % num;
        }
        this._strip();
        return isNegNum ? this.ineg() : this;
    };
    BN.prototype.divn = function divn(num) {
        return this.clone().idivn(num);
    };
    BN.prototype.egcd = function egcd(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var x = this;
        var y = p.clone();
        if (x.negative !== 0) x = x.umod(p);
        else x = x.clone();
        // A * x + B * y = x
        var A = new BN(1);
        var B = new BN(0);
        // C * x + D * y = y
        var C = new BN(0);
        var D = new BN(1);
        var g = 0;
        while(x.isEven() && y.isEven()){
            x.iushrn(1);
            y.iushrn(1);
            ++g;
        }
        var yp = y.clone();
        var xp = x.clone();
        while(!x.isZero()){
            for(var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                x.iushrn(i);
                while(i-- > 0){
                    if (A.isOdd() || B.isOdd()) {
                        A.iadd(yp);
                        B.isub(xp);
                    }
                    A.iushrn(1);
                    B.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                y.iushrn(j);
                while(j-- > 0){
                    if (C.isOdd() || D.isOdd()) {
                        C.iadd(yp);
                        D.isub(xp);
                    }
                    C.iushrn(1);
                    D.iushrn(1);
                }
            }
            if (x.cmp(y) >= 0) {
                x.isub(y);
                A.isub(C);
                B.isub(D);
            } else {
                y.isub(x);
                C.isub(A);
                D.isub(B);
            }
        }
        return {
            a: C,
            b: D,
            gcd: y.iushln(g)
        };
    };
    // This is reduced incarnation of the binary EEA
    // above, designated to invert members of the
    // _prime_ fields F(p) at a maximal speed
    BN.prototype._invmp = function _invmp(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var a = this;
        var b = p.clone();
        if (a.negative !== 0) a = a.umod(p);
        else a = a.clone();
        var x1 = new BN(1);
        var x2 = new BN(0);
        var delta = b.clone();
        while(a.cmpn(1) > 0 && b.cmpn(1) > 0){
            for(var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                a.iushrn(i);
                while(i-- > 0){
                    if (x1.isOdd()) x1.iadd(delta);
                    x1.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                b.iushrn(j);
                while(j-- > 0){
                    if (x2.isOdd()) x2.iadd(delta);
                    x2.iushrn(1);
                }
            }
            if (a.cmp(b) >= 0) {
                a.isub(b);
                x1.isub(x2);
            } else {
                b.isub(a);
                x2.isub(x1);
            }
        }
        var res;
        if (a.cmpn(1) === 0) res = x1;
        else res = x2;
        if (res.cmpn(0) < 0) res.iadd(p);
        return res;
    };
    BN.prototype.gcd = function gcd(num) {
        if (this.isZero()) return num.abs();
        if (num.isZero()) return this.abs();
        var a = this.clone();
        var b = num.clone();
        a.negative = 0;
        b.negative = 0;
        // Remove common factor of two
        for(var shift = 0; a.isEven() && b.isEven(); shift++){
            a.iushrn(1);
            b.iushrn(1);
        }
        do {
            while(a.isEven())a.iushrn(1);
            while(b.isEven())b.iushrn(1);
            var r = a.cmp(b);
            if (r < 0) {
                // Swap `a` and `b` to make `a` always bigger than `b`
                var t = a;
                a = b;
                b = t;
            } else if (r === 0 || b.cmpn(1) === 0) break;
            a.isub(b);
        }while (true);
        return b.iushln(shift);
    };
    // Invert number in the field F(num)
    BN.prototype.invm = function invm(num) {
        return this.egcd(num).a.umod(num);
    };
    BN.prototype.isEven = function isEven() {
        return (this.words[0] & 1) === 0;
    };
    BN.prototype.isOdd = function isOdd() {
        return (this.words[0] & 1) === 1;
    };
    // And first word and num
    BN.prototype.andln = function andln(num) {
        return this.words[0] & num;
    };
    // Increment at the bit position in-line
    BN.prototype.bincn = function bincn(bit) {
        assert(typeof bit === "number");
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) {
            this._expand(s + 1);
            this.words[s] |= q;
            return this;
        }
        // Add bit and propagate, if needed
        var carry = q;
        for(var i = s; carry !== 0 && i < this.length; i++){
            var w = this.words[i] | 0;
            w += carry;
            carry = w >>> 26;
            w &= 0x3ffffff;
            this.words[i] = w;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.isZero = function isZero() {
        return this.length === 1 && this.words[0] === 0;
    };
    BN.prototype.cmpn = function cmpn(num) {
        var negative = num < 0;
        if (this.negative !== 0 && !negative) return -1;
        if (this.negative === 0 && negative) return 1;
        this._strip();
        var res;
        if (this.length > 1) res = 1;
        else {
            if (negative) num = -num;
            assert(num <= 0x3ffffff, "Number is too big");
            var w = this.words[0] | 0;
            res = w === num ? 0 : w < num ? -1 : 1;
        }
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Compare two numbers and return:
    // 1 - if `this` > `num`
    // 0 - if `this` == `num`
    // -1 - if `this` < `num`
    BN.prototype.cmp = function cmp(num) {
        if (this.negative !== 0 && num.negative === 0) return -1;
        if (this.negative === 0 && num.negative !== 0) return 1;
        var res = this.ucmp(num);
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Unsigned comparison
    BN.prototype.ucmp = function ucmp(num) {
        // At this point both numbers have the same sign
        if (this.length > num.length) return 1;
        if (this.length < num.length) return -1;
        var res = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var a = this.words[i] | 0;
            var b = num.words[i] | 0;
            if (a === b) continue;
            if (a < b) res = -1;
            else if (a > b) res = 1;
            break;
        }
        return res;
    };
    BN.prototype.gtn = function gtn(num) {
        return this.cmpn(num) === 1;
    };
    BN.prototype.gt = function gt(num) {
        return this.cmp(num) === 1;
    };
    BN.prototype.gten = function gten(num) {
        return this.cmpn(num) >= 0;
    };
    BN.prototype.gte = function gte(num) {
        return this.cmp(num) >= 0;
    };
    BN.prototype.ltn = function ltn(num) {
        return this.cmpn(num) === -1;
    };
    BN.prototype.lt = function lt(num) {
        return this.cmp(num) === -1;
    };
    BN.prototype.lten = function lten(num) {
        return this.cmpn(num) <= 0;
    };
    BN.prototype.lte = function lte(num) {
        return this.cmp(num) <= 0;
    };
    BN.prototype.eqn = function eqn(num) {
        return this.cmpn(num) === 0;
    };
    BN.prototype.eq = function eq(num) {
        return this.cmp(num) === 0;
    };
    //
    // A reduce context, could be using montgomery or something better, depending
    // on the `m` itself.
    //
    BN.red = function red(num) {
        return new Red(num);
    };
    BN.prototype.toRed = function toRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        assert(this.negative === 0, "red works only with positives");
        return ctx.convertTo(this)._forceRed(ctx);
    };
    BN.prototype.fromRed = function fromRed() {
        assert(this.red, "fromRed works only with numbers in reduction context");
        return this.red.convertFrom(this);
    };
    BN.prototype._forceRed = function _forceRed(ctx) {
        this.red = ctx;
        return this;
    };
    BN.prototype.forceRed = function forceRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        return this._forceRed(ctx);
    };
    BN.prototype.redAdd = function redAdd(num) {
        assert(this.red, "redAdd works only with red numbers");
        return this.red.add(this, num);
    };
    BN.prototype.redIAdd = function redIAdd(num) {
        assert(this.red, "redIAdd works only with red numbers");
        return this.red.iadd(this, num);
    };
    BN.prototype.redSub = function redSub(num) {
        assert(this.red, "redSub works only with red numbers");
        return this.red.sub(this, num);
    };
    BN.prototype.redISub = function redISub(num) {
        assert(this.red, "redISub works only with red numbers");
        return this.red.isub(this, num);
    };
    BN.prototype.redShl = function redShl(num) {
        assert(this.red, "redShl works only with red numbers");
        return this.red.shl(this, num);
    };
    BN.prototype.redMul = function redMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.mul(this, num);
    };
    BN.prototype.redIMul = function redIMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.imul(this, num);
    };
    BN.prototype.redSqr = function redSqr() {
        assert(this.red, "redSqr works only with red numbers");
        this.red._verify1(this);
        return this.red.sqr(this);
    };
    BN.prototype.redISqr = function redISqr() {
        assert(this.red, "redISqr works only with red numbers");
        this.red._verify1(this);
        return this.red.isqr(this);
    };
    // Square root over p
    BN.prototype.redSqrt = function redSqrt() {
        assert(this.red, "redSqrt works only with red numbers");
        this.red._verify1(this);
        return this.red.sqrt(this);
    };
    BN.prototype.redInvm = function redInvm() {
        assert(this.red, "redInvm works only with red numbers");
        this.red._verify1(this);
        return this.red.invm(this);
    };
    // Return negative clone of `this` % `red modulo`
    BN.prototype.redNeg = function redNeg() {
        assert(this.red, "redNeg works only with red numbers");
        this.red._verify1(this);
        return this.red.neg(this);
    };
    BN.prototype.redPow = function redPow(num) {
        assert(this.red && !num.red, "redPow(normalNum)");
        this.red._verify1(this);
        return this.red.pow(this, num);
    };
    // Prime numbers with efficient reduction
    var primes = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
    };
    // Pseudo-Mersenne prime
    function MPrime(name, p) {
        // P = 2 ^ N - K
        this.name = name;
        this.p = new BN(p, 16);
        this.n = this.p.bitLength();
        this.k = new BN(1).iushln(this.n).isub(this.p);
        this.tmp = this._tmp();
    }
    MPrime.prototype._tmp = function _tmp() {
        var tmp = new BN(null);
        tmp.words = new Array(Math.ceil(this.n / 13));
        return tmp;
    };
    MPrime.prototype.ireduce = function ireduce(num) {
        // Assumes that `num` is less than `P^2`
        // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
        var r = num;
        var rlen;
        do {
            this.split(r, this.tmp);
            r = this.imulK(r);
            r = r.iadd(this.tmp);
            rlen = r.bitLength();
        }while (rlen > this.n);
        var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
        if (cmp === 0) {
            r.words[0] = 0;
            r.length = 1;
        } else if (cmp > 0) r.isub(this.p);
        else if (r.strip !== undefined) // r is a BN v4 instance
        r.strip();
        else // r is a BN v5 instance
        r._strip();
        return r;
    };
    MPrime.prototype.split = function split(input, out) {
        input.iushrn(this.n, 0, out);
    };
    MPrime.prototype.imulK = function imulK(num) {
        return num.imul(this.k);
    };
    function K256() {
        MPrime.call(this, "k256", "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f");
    }
    inherits(K256, MPrime);
    K256.prototype.split = function split(input, output) {
        // 256 = 9 * 26 + 22
        var mask = 0x3fffff;
        var outLen = Math.min(input.length, 9);
        for(var i = 0; i < outLen; i++)output.words[i] = input.words[i];
        output.length = outLen;
        if (input.length <= 9) {
            input.words[0] = 0;
            input.length = 1;
            return;
        }
        // Shift by 9 limbs
        var prev = input.words[9];
        output.words[output.length++] = prev & mask;
        for(i = 10; i < input.length; i++){
            var next = input.words[i] | 0;
            input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
            prev = next;
        }
        prev >>>= 22;
        input.words[i - 10] = prev;
        if (prev === 0 && input.length > 10) input.length -= 10;
        else input.length -= 9;
    };
    K256.prototype.imulK = function imulK(num) {
        // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
        num.words[num.length] = 0;
        num.words[num.length + 1] = 0;
        num.length += 2;
        // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
        var lo = 0;
        for(var i = 0; i < num.length; i++){
            var w = num.words[i] | 0;
            lo += w * 0x3d1;
            num.words[i] = lo & 0x3ffffff;
            lo = w * 0x40 + (lo / 0x4000000 | 0);
        }
        // Fast length reduction
        if (num.words[num.length - 1] === 0) {
            num.length--;
            if (num.words[num.length - 1] === 0) num.length--;
        }
        return num;
    };
    function P224() {
        MPrime.call(this, "p224", "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001");
    }
    inherits(P224, MPrime);
    function P192() {
        MPrime.call(this, "p192", "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff");
    }
    inherits(P192, MPrime);
    function P25519() {
        // 2 ^ 255 - 19
        MPrime.call(this, "25519", "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed");
    }
    inherits(P25519, MPrime);
    P25519.prototype.imulK = function imulK(num) {
        // K = 0x13
        var carry = 0;
        for(var i = 0; i < num.length; i++){
            var hi = (num.words[i] | 0) * 0x13 + carry;
            var lo = hi & 0x3ffffff;
            hi >>>= 26;
            num.words[i] = lo;
            carry = hi;
        }
        if (carry !== 0) num.words[num.length++] = carry;
        return num;
    };
    // Exported mostly for testing purposes, use plain name instead
    BN._prime = function prime(name) {
        // Cached version of prime
        if (primes[name]) return primes[name];
        var prime;
        if (name === "k256") prime = new K256();
        else if (name === "p224") prime = new P224();
        else if (name === "p192") prime = new P192();
        else if (name === "p25519") prime = new P25519();
        else throw new Error("Unknown prime " + name);
        primes[name] = prime;
        return prime;
    };
    //
    // Base reduction engine
    //
    function Red(m) {
        if (typeof m === "string") {
            var prime = BN._prime(m);
            this.m = prime.p;
            this.prime = prime;
        } else {
            assert(m.gtn(1), "modulus must be greater than 1");
            this.m = m;
            this.prime = null;
        }
    }
    Red.prototype._verify1 = function _verify1(a) {
        assert(a.negative === 0, "red works only with positives");
        assert(a.red, "red works only with red numbers");
    };
    Red.prototype._verify2 = function _verify2(a, b) {
        assert((a.negative | b.negative) === 0, "red works only with positives");
        assert(a.red && a.red === b.red, "red works only with red numbers");
    };
    Red.prototype.imod = function imod(a) {
        if (this.prime) return this.prime.ireduce(a)._forceRed(this);
        move(a, a.umod(this.m)._forceRed(this));
        return a;
    };
    Red.prototype.neg = function neg(a) {
        if (a.isZero()) return a.clone();
        return this.m.sub(a)._forceRed(this);
    };
    Red.prototype.add = function add(a, b) {
        this._verify2(a, b);
        var res = a.add(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res._forceRed(this);
    };
    Red.prototype.iadd = function iadd(a, b) {
        this._verify2(a, b);
        var res = a.iadd(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res;
    };
    Red.prototype.sub = function sub(a, b) {
        this._verify2(a, b);
        var res = a.sub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res._forceRed(this);
    };
    Red.prototype.isub = function isub(a, b) {
        this._verify2(a, b);
        var res = a.isub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res;
    };
    Red.prototype.shl = function shl(a, num) {
        this._verify1(a);
        return this.imod(a.ushln(num));
    };
    Red.prototype.imul = function imul(a, b) {
        this._verify2(a, b);
        return this.imod(a.imul(b));
    };
    Red.prototype.mul = function mul(a, b) {
        this._verify2(a, b);
        return this.imod(a.mul(b));
    };
    Red.prototype.isqr = function isqr(a) {
        return this.imul(a, a.clone());
    };
    Red.prototype.sqr = function sqr(a) {
        return this.mul(a, a);
    };
    Red.prototype.sqrt = function sqrt(a) {
        if (a.isZero()) return a.clone();
        var mod3 = this.m.andln(3);
        assert(mod3 % 2 === 1);
        // Fast case
        if (mod3 === 3) {
            var pow = this.m.add(new BN(1)).iushrn(2);
            return this.pow(a, pow);
        }
        // Tonelli-Shanks algorithm (Totally unoptimized and slow)
        //
        // Find Q and S, that Q * 2 ^ S = (P - 1)
        var q = this.m.subn(1);
        var s = 0;
        while(!q.isZero() && q.andln(1) === 0){
            s++;
            q.iushrn(1);
        }
        assert(!q.isZero());
        var one = new BN(1).toRed(this);
        var nOne = one.redNeg();
        // Find quadratic non-residue
        // NOTE: Max is such because of generalized Riemann hypothesis.
        var lpow = this.m.subn(1).iushrn(1);
        var z = this.m.bitLength();
        z = new BN(2 * z * z).toRed(this);
        while(this.pow(z, lpow).cmp(nOne) !== 0)z.redIAdd(nOne);
        var c = this.pow(z, q);
        var r = this.pow(a, q.addn(1).iushrn(1));
        var t = this.pow(a, q);
        var m = s;
        while(t.cmp(one) !== 0){
            var tmp = t;
            for(var i = 0; tmp.cmp(one) !== 0; i++)tmp = tmp.redSqr();
            assert(i < m);
            var b = this.pow(c, new BN(1).iushln(m - i - 1));
            r = r.redMul(b);
            c = b.redSqr();
            t = t.redMul(c);
            m = i;
        }
        return r;
    };
    Red.prototype.invm = function invm(a) {
        var inv = a._invmp(this.m);
        if (inv.negative !== 0) {
            inv.negative = 0;
            return this.imod(inv).redNeg();
        } else return this.imod(inv);
    };
    Red.prototype.pow = function pow(a, num) {
        if (num.isZero()) return new BN(1).toRed(this);
        if (num.cmpn(1) === 0) return a.clone();
        var windowSize = 4;
        var wnd = new Array(1 << windowSize);
        wnd[0] = new BN(1).toRed(this);
        wnd[1] = a;
        for(var i = 2; i < wnd.length; i++)wnd[i] = this.mul(wnd[i - 1], a);
        var res = wnd[0];
        var current = 0;
        var currentLen = 0;
        var start = num.bitLength() % 26;
        if (start === 0) start = 26;
        for(i = num.length - 1; i >= 0; i--){
            var word = num.words[i];
            for(var j = start - 1; j >= 0; j--){
                var bit = word >> j & 1;
                if (res !== wnd[0]) res = this.sqr(res);
                if (bit === 0 && current === 0) {
                    currentLen = 0;
                    continue;
                }
                current <<= 1;
                current |= bit;
                currentLen++;
                if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
                res = this.mul(res, wnd[current]);
                currentLen = 0;
                current = 0;
            }
            start = 26;
        }
        return res;
    };
    Red.prototype.convertTo = function convertTo(num) {
        var r = num.umod(this.m);
        return r === num ? r.clone() : r;
    };
    Red.prototype.convertFrom = function convertFrom(num) {
        var res = num.clone();
        res.red = null;
        return res;
    };
    //
    // Montgomery method engine
    //
    BN.mont = function mont(num) {
        return new Mont(num);
    };
    function Mont(m) {
        Red.call(this, m);
        this.shift = this.m.bitLength();
        if (this.shift % 26 !== 0) this.shift += 26 - this.shift % 26;
        this.r = new BN(1).iushln(this.shift);
        this.r2 = this.imod(this.r.sqr());
        this.rinv = this.r._invmp(this.m);
        this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
        this.minv = this.minv.umod(this.r);
        this.minv = this.r.sub(this.minv);
    }
    inherits(Mont, Red);
    Mont.prototype.convertTo = function convertTo(num) {
        return this.imod(num.ushln(this.shift));
    };
    Mont.prototype.convertFrom = function convertFrom(num) {
        var r = this.imod(num.mul(this.rinv));
        r.red = null;
        return r;
    };
    Mont.prototype.imul = function imul(a, b) {
        if (a.isZero() || b.isZero()) {
            a.words[0] = 0;
            a.length = 1;
            return a;
        }
        var t = a.imul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.mul = function mul(a, b) {
        if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
        var t = a.mul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.invm = function invm(a) {
        // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
        var res = this.imod(a._invmp(this.m).mul(this.r2));
        return res._forceRed(this);
    };
})(module, this);

},{"4a621f69fb9775d4":"13Pcp"}],"3FCDz":[function(require,module,exports) {
"use strict";
var has = Object.prototype.hasOwnProperty, prefix = "~";
/**
 * Constructor to create a storage for our `EE` objects.
 * An `Events` instance is a plain object whose properties are event names.
 *
 * @constructor
 * @private
 */ function Events() {}
//
// We try to not inherit from `Object.prototype`. In some engines creating an
// instance in this way is faster than calling `Object.create(null)` directly.
// If `Object.create(null)` is not supported we prefix the event names with a
// character to make sure that the built-in object properties are not
// overridden or used as an attack vector.
//
if (Object.create) {
    Events.prototype = Object.create(null);
    //
    // This hack is needed because the `__proto__` property is still inherited in
    // some old browsers like Android 4, iPhone 5.1, Opera 11 and Safari 5.
    //
    if (!new Events().__proto__) prefix = false;
}
/**
 * Representation of a single event listener.
 *
 * @param {Function} fn The listener function.
 * @param {*} context The context to invoke the listener with.
 * @param {Boolean} [once=false] Specify if the listener is a one-time listener.
 * @constructor
 * @private
 */ function EE(fn, context, once) {
    this.fn = fn;
    this.context = context;
    this.once = once || false;
}
/**
 * Add a listener for a given event.
 *
 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} context The context to invoke the listener with.
 * @param {Boolean} once Specify if the listener is a one-time listener.
 * @returns {EventEmitter}
 * @private
 */ function addListener(emitter, event, fn, context, once) {
    if (typeof fn !== "function") throw new TypeError("The listener must be a function");
    var listener = new EE(fn, context || emitter, once), evt = prefix ? prefix + event : event;
    if (!emitter._events[evt]) emitter._events[evt] = listener, emitter._eventsCount++;
    else if (!emitter._events[evt].fn) emitter._events[evt].push(listener);
    else emitter._events[evt] = [
        emitter._events[evt],
        listener
    ];
    return emitter;
}
/**
 * Clear event by name.
 *
 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
 * @param {(String|Symbol)} evt The Event name.
 * @private
 */ function clearEvent(emitter, evt) {
    if (--emitter._eventsCount === 0) emitter._events = new Events();
    else delete emitter._events[evt];
}
/**
 * Minimal `EventEmitter` interface that is molded against the Node.js
 * `EventEmitter` interface.
 *
 * @constructor
 * @public
 */ function EventEmitter() {
    this._events = new Events();
    this._eventsCount = 0;
}
/**
 * Return an array listing the events for which the emitter has registered
 * listeners.
 *
 * @returns {Array}
 * @public
 */ EventEmitter.prototype.eventNames = function eventNames() {
    var names = [], events, name;
    if (this._eventsCount === 0) return names;
    for(name in events = this._events)if (has.call(events, name)) names.push(prefix ? name.slice(1) : name);
    if (Object.getOwnPropertySymbols) return names.concat(Object.getOwnPropertySymbols(events));
    return names;
};
/**
 * Return the listeners registered for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Array} The registered listeners.
 * @public
 */ EventEmitter.prototype.listeners = function listeners(event) {
    var evt = prefix ? prefix + event : event, handlers = this._events[evt];
    if (!handlers) return [];
    if (handlers.fn) return [
        handlers.fn
    ];
    for(var i = 0, l = handlers.length, ee = new Array(l); i < l; i++)ee[i] = handlers[i].fn;
    return ee;
};
/**
 * Return the number of listeners listening to a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Number} The number of listeners.
 * @public
 */ EventEmitter.prototype.listenerCount = function listenerCount(event) {
    var evt = prefix ? prefix + event : event, listeners = this._events[evt];
    if (!listeners) return 0;
    if (listeners.fn) return 1;
    return listeners.length;
};
/**
 * Calls each of the listeners registered for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Boolean} `true` if the event had listeners, else `false`.
 * @public
 */ EventEmitter.prototype.emit = function emit(event, a1, a2, a3, a4, a5) {
    var evt = prefix ? prefix + event : event;
    if (!this._events[evt]) return false;
    var listeners = this._events[evt], len = arguments.length, args, i;
    if (listeners.fn) {
        if (listeners.once) this.removeListener(event, listeners.fn, undefined, true);
        switch(len){
            case 1:
                return listeners.fn.call(listeners.context), true;
            case 2:
                return listeners.fn.call(listeners.context, a1), true;
            case 3:
                return listeners.fn.call(listeners.context, a1, a2), true;
            case 4:
                return listeners.fn.call(listeners.context, a1, a2, a3), true;
            case 5:
                return listeners.fn.call(listeners.context, a1, a2, a3, a4), true;
            case 6:
                return listeners.fn.call(listeners.context, a1, a2, a3, a4, a5), true;
        }
        for(i = 1, args = new Array(len - 1); i < len; i++)args[i - 1] = arguments[i];
        listeners.fn.apply(listeners.context, args);
    } else {
        var length = listeners.length, j;
        for(i = 0; i < length; i++){
            if (listeners[i].once) this.removeListener(event, listeners[i].fn, undefined, true);
            switch(len){
                case 1:
                    listeners[i].fn.call(listeners[i].context);
                    break;
                case 2:
                    listeners[i].fn.call(listeners[i].context, a1);
                    break;
                case 3:
                    listeners[i].fn.call(listeners[i].context, a1, a2);
                    break;
                case 4:
                    listeners[i].fn.call(listeners[i].context, a1, a2, a3);
                    break;
                default:
                    if (!args) for(j = 1, args = new Array(len - 1); j < len; j++)args[j - 1] = arguments[j];
                    listeners[i].fn.apply(listeners[i].context, args);
            }
        }
    }
    return true;
};
/**
 * Add a listener for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @public
 */ EventEmitter.prototype.on = function on(event, fn, context) {
    return addListener(this, event, fn, context, false);
};
/**
 * Add a one-time listener for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @public
 */ EventEmitter.prototype.once = function once(event, fn, context) {
    return addListener(this, event, fn, context, true);
};
/**
 * Remove the listeners of a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn Only remove the listeners that match this function.
 * @param {*} context Only remove the listeners that have this context.
 * @param {Boolean} once Only remove one-time listeners.
 * @returns {EventEmitter} `this`.
 * @public
 */ EventEmitter.prototype.removeListener = function removeListener(event, fn, context, once) {
    var evt = prefix ? prefix + event : event;
    if (!this._events[evt]) return this;
    if (!fn) {
        clearEvent(this, evt);
        return this;
    }
    var listeners = this._events[evt];
    if (listeners.fn) {
        if (listeners.fn === fn && (!once || listeners.once) && (!context || listeners.context === context)) clearEvent(this, evt);
    } else {
        for(var i = 0, events = [], length = listeners.length; i < length; i++)if (listeners[i].fn !== fn || once && !listeners[i].once || context && listeners[i].context !== context) events.push(listeners[i]);
        //
        // Reset the array, or remove it completely if we have no more listeners.
        //
        if (events.length) this._events[evt] = events.length === 1 ? events[0] : events;
        else clearEvent(this, evt);
    }
    return this;
};
/**
 * Remove all listeners, or those of the specified event.
 *
 * @param {(String|Symbol)} [event] The event name.
 * @returns {EventEmitter} `this`.
 * @public
 */ EventEmitter.prototype.removeAllListeners = function removeAllListeners(event) {
    var evt;
    if (event) {
        evt = prefix ? prefix + event : event;
        if (this._events[evt]) clearEvent(this, evt);
    } else {
        this._events = new Events();
        this._eventsCount = 0;
    }
    return this;
};
//
// Alias methods names because people roll like that.
//
EventEmitter.prototype.off = EventEmitter.prototype.removeListener;
EventEmitter.prototype.addListener = EventEmitter.prototype.on;
//
// Expose the prefix.
//
EventEmitter.prefixed = prefix;
//
// Allow `EventEmitter` to be imported as module namespace.
//
EventEmitter.EventEmitter = EventEmitter;
module.exports = EventEmitter;

},{}],"bZHib":[function(require,module,exports) {
/*
 This file is part of web3.js.

 web3.js is free software: you can redistribute it and/or modify
 it under the terms of the GNU Lesser General Public License as published by
 the Free Software Foundation, either version 3 of the License, or
 (at your option) any later version.

 web3.js is distributed in the hope that it will be useful,
 but WITHOUT ANY WARRANTY; without even the implied warranty of
 MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 GNU Lesser General Public License for more details.

 You should have received a copy of the GNU Lesser General Public License
 along with web3.js.  If not, see <http://www.gnu.org/licenses/>.
 */ /**
 * @file index.js
 * @author Marek Kotewicz <marek@parity.io>
 * @author Fabian Vogelsteller <fabian@frozeman.de>
 * @date 2018
 */ var Buffer = require("fb581cb840e79aec").Buffer;
var utils = require("eb419bc66f723c43");
var EthersAbiCoder = require("ccebc4f548423cf8").AbiCoder;
var ParamType = require("ccebc4f548423cf8").ParamType;
var ethersAbiCoder = new EthersAbiCoder(function(type, value) {
    if (type.match(/^u?int/) && !Array.isArray(value) && (!(!!value && typeof value === "object") || value.constructor.name !== "BN")) return value.toString();
    return value;
});
// result method
function Result() {}
/**
 * ABICoder prototype should be used to encode/decode solidity params of any type
 */ var ABICoder = function() {};
/**
 * Encodes the function name to its ABI representation, which are the first 4 bytes of the sha3 of the function name including  types.
 *
 * @method encodeFunctionSignature
 * @param {String|Object} functionName
 * @return {String} encoded function name
 */ ABICoder.prototype.encodeFunctionSignature = function(functionName) {
    if (typeof functionName === "function" || typeof functionName === "object" && functionName) functionName = utils._jsonInterfaceMethodToString(functionName);
    return utils.sha3(functionName).slice(0, 10);
};
/**
 * Encodes the function name to its ABI representation, which are the first 4 bytes of the sha3 of the function name including  types.
 *
 * @method encodeEventSignature
 * @param {String|Object} functionName
 * @return {String} encoded function name
 */ ABICoder.prototype.encodeEventSignature = function(functionName) {
    if (typeof functionName === "function" || typeof functionName === "object" && functionName) functionName = utils._jsonInterfaceMethodToString(functionName);
    return utils.sha3(functionName);
};
/**
 * Should be used to encode plain param
 *
 * @method encodeParameter
 *
 * @param {String|Object} type
 * @param {any} param
 *
 * @return {String} encoded plain param
 */ ABICoder.prototype.encodeParameter = function(type, param) {
    return this.encodeParameters([
        type
    ], [
        param
    ]);
};
/**
 * Should be used to encode list of params
 *
 * @method encodeParameters
 *
 * @param {Array<String|Object>} types
 * @param {Array<any>} params
 *
 * @return {String} encoded list of params
 */ ABICoder.prototype.encodeParameters = function(types, params) {
    var self = this;
    types = self.mapTypes(types);
    params = params.map(function(param, index) {
        let type = types[index];
        if (typeof type === "object" && type.type) // We may get a named type of shape {name, type}
        type = type.type;
        param = self.formatParam(type, param);
        // Format params for tuples
        if (typeof type === "string" && type.includes("tuple")) {
            const coder = ethersAbiCoder._getCoder(ParamType.from(type));
            const modifyParams = (coder, param)=>{
                if (coder.name === "array") {
                    if (!coder.type.match(/\[(\d+)\]/)) return param.map((p)=>modifyParams(ethersAbiCoder._getCoder(ParamType.from(coder.type.replace("[]", ""))), p));
                    const arrayLength = parseInt(coder.type.match(/\[(\d+)\]/)[1]);
                    if (param.length !== arrayLength) throw new Error("Array length does not matches with the given input");
                    return param.map((p)=>modifyParams(ethersAbiCoder._getCoder(ParamType.from(coder.type.replace(/\[\d+\]/, ""))), p));
                }
                coder.coders.forEach((c, i)=>{
                    if (c.name === "tuple") modifyParams(c, param[i]);
                    else param[i] = self.formatParam(c.name, param[i]);
                });
            };
            modifyParams(coder, param);
        }
        return param;
    });
    return ethersAbiCoder.encode(types, params);
};
/**
 * Map types if simplified format is used
 *
 * @method mapTypes
 * @param {Array} types
 * @return {Array}
 */ ABICoder.prototype.mapTypes = function(types) {
    var self = this;
    var mappedTypes = [];
    types.forEach(function(type) {
        // Remap `function` type params to bytes24 since Ethers does not
        // recognize former type. Solidity docs say `Function` is a bytes24
        // encoding the contract address followed by the function selector hash.
        if (typeof type === "object" && type.type === "function") type = Object.assign({}, type, {
            type: "bytes24"
        });
        if (self.isSimplifiedStructFormat(type)) {
            var structName = Object.keys(type)[0];
            mappedTypes.push(Object.assign(self.mapStructNameAndType(structName), {
                components: self.mapStructToCoderFormat(type[structName])
            }));
            return;
        }
        mappedTypes.push(type);
    });
    return mappedTypes;
};
/**
 * Check if type is simplified struct format
 *
 * @method isSimplifiedStructFormat
 * @param {string | Object} type
 * @returns {boolean}
 */ ABICoder.prototype.isSimplifiedStructFormat = function(type) {
    return typeof type === "object" && typeof type.components === "undefined" && typeof type.name === "undefined";
};
/**
 * Maps the correct tuple type and name when the simplified format in encode/decodeParameter is used
 *
 * @method mapStructNameAndType
 * @param {string} structName
 * @return {{type: string, name: *}}
 */ ABICoder.prototype.mapStructNameAndType = function(structName) {
    var type = "tuple";
    if (structName.indexOf("[]") > -1) {
        type = "tuple[]";
        structName = structName.slice(0, -2);
    }
    return {
        type: type,
        name: structName
    };
};
/**
 * Maps the simplified format in to the expected format of the ABICoder
 *
 * @method mapStructToCoderFormat
 * @param {Object} struct
 * @return {Array}
 */ ABICoder.prototype.mapStructToCoderFormat = function(struct) {
    var self = this;
    var components = [];
    Object.keys(struct).forEach(function(key) {
        if (typeof struct[key] === "object") {
            components.push(Object.assign(self.mapStructNameAndType(key), {
                components: self.mapStructToCoderFormat(struct[key])
            }));
            return;
        }
        components.push({
            name: key,
            type: struct[key]
        });
    });
    return components;
};
/**
 * Handle some formatting of params for backwards compatability with Ethers V4
 *
 * @method formatParam
 * @param {String} - type
 * @param {any} - param
 * @return {any} - The formatted param
 */ ABICoder.prototype.formatParam = function(type, param) {
    const paramTypeBytes = new RegExp(/^bytes([0-9]*)$/);
    const paramTypeBytesArray = new RegExp(/^bytes([0-9]*)\[\]$/);
    const paramTypeNumber = new RegExp(/^(u?int)([0-9]*)$/);
    const paramTypeNumberArray = new RegExp(/^(u?int)([0-9]*)\[\]$/);
    // Format BN to string
    if (utils.isBN(param) || utils.isBigNumber(param)) return param.toString(10);
    if (type.match(paramTypeBytesArray) || type.match(paramTypeNumberArray)) return param.map((p)=>this.formatParam(type.replace("[]", ""), p));
    // Format correct width for u?int[0-9]*
    let match = type.match(paramTypeNumber);
    if (match) {
        let size = parseInt(match[2] || "256");
        if (size / 8 < param.length) param = param.startsWith("-") ? `-${utils.leftPad(param.substring(1), size)}` : utils.leftPad(param, size);
    }
    // Format correct length for bytes[0-9]+
    match = type.match(paramTypeBytes);
    if (match) {
        if (Buffer.isBuffer(param)) param = utils.toHex(param);
        // format to correct length
        let size = parseInt(match[1]);
        if (size) {
            let maxSize = size * 2;
            if (param.substring(0, 2) === "0x") maxSize += 2;
            if (param.length < maxSize) // pad to correct length
            param = utils.rightPad(param, size * 2);
        }
        // format odd-length bytes to even-length
        if (param.length % 2 === 1) param = "0x0" + param.substring(2);
    }
    return param;
};
/**
 * Encodes a function call from its json interface and parameters.
 *
 * @method encodeFunctionCall
 * @param {Array} jsonInterface
 * @param {Array} params
 * @return {String} The encoded ABI for this function call
 */ ABICoder.prototype.encodeFunctionCall = function(jsonInterface, params) {
    return this.encodeFunctionSignature(jsonInterface) + this.encodeParameters(jsonInterface.inputs, params).replace("0x", "");
};
/**
 * Should be used to decode bytes to plain param
 *
 * @method decodeParameter
 * @param {String} type
 * @param {String} bytes
 * @return {Object} plain param
 */ ABICoder.prototype.decodeParameter = function(type, bytes) {
    return this.decodeParameters([
        type
    ], bytes)[0];
};
/**
 * Should be used to decode list of params
 *
 * @method decodeParameter
 * @param {Array} outputs
 * @param {String} bytes
 * @return {Array} array of plain params
 */ ABICoder.prototype.decodeParameters = function(outputs, bytes) {
    return this.decodeParametersWith(outputs, bytes, false);
};
/**
 * Should be used to decode list of params
 *
 * @method decodeParameter
 * @param {Array} outputs
 * @param {String} bytes
 * @param {Boolean} loose
 * @return {Array} array of plain params
 */ ABICoder.prototype.decodeParametersWith = function(outputs, bytes, loose) {
    if (outputs.length > 0 && (!bytes || bytes === "0x" || bytes === "0X")) throw new Error("Returned values aren't valid, did it run Out of Gas? You might also see this error if you are not using the correct ABI for the contract you are retrieving data from, requesting data from a block number that does not exist, or querying a node which is not fully synced.");
    var res = ethersAbiCoder.decode(this.mapTypes(outputs), "0x" + bytes.replace(/0x/i, ""), loose);
    var returnValue = new Result();
    returnValue.__length__ = 0;
    outputs.forEach(function(output, i) {
        var decodedValue = res[returnValue.__length__];
        const isStringObject = typeof output === "object" && output.type && output.type === "string";
        const isStringType = typeof output === "string" && output === "string";
        // only convert `0x` to null if it's not string value
        decodedValue = decodedValue === "0x" && !isStringObject && !isStringType ? null : decodedValue;
        returnValue[i] = decodedValue;
        if ((typeof output === "function" || !!output && typeof output === "object") && output.name) returnValue[output.name] = decodedValue;
        returnValue.__length__++;
    });
    return returnValue;
};
/**
 * Decodes events non- and indexed parameters.
 *
 * @method decodeLog
 * @param {Object} inputs
 * @param {String} data
 * @param {Array} topics
 * @return {Array} array of plain params
 */ ABICoder.prototype.decodeLog = function(inputs, data, topics) {
    var _this = this;
    topics = Array.isArray(topics) ? topics : [
        topics
    ];
    data = data || "";
    var notIndexedInputs = [];
    var indexedParams = [];
    var topicCount = 0;
    // TODO check for anonymous logs?
    inputs.forEach(function(input, i) {
        if (input.indexed) {
            indexedParams[i] = [
                "bool",
                "int",
                "uint",
                "address",
                "fixed",
                "ufixed"
            ].find(function(staticType) {
                return input.type.indexOf(staticType) !== -1;
            }) ? _this.decodeParameter(input.type, topics[topicCount]) : topics[topicCount];
            topicCount++;
        } else notIndexedInputs[i] = input;
    });
    var nonIndexedData = data;
    var notIndexedParams = nonIndexedData ? this.decodeParametersWith(notIndexedInputs, nonIndexedData, true) : [];
    var returnValue = new Result();
    returnValue.__length__ = 0;
    inputs.forEach(function(res, i) {
        returnValue[i] = res.type === "string" ? "" : null;
        if (typeof notIndexedParams[i] !== "undefined") returnValue[i] = notIndexedParams[i];
        if (typeof indexedParams[i] !== "undefined") returnValue[i] = indexedParams[i];
        if (res.name) returnValue[res.name] = returnValue[i];
        returnValue.__length__++;
    });
    return returnValue;
};
var coder = new ABICoder();
module.exports = coder;

},{"fb581cb840e79aec":"l5Twm","eb419bc66f723c43":"ePzmI","ccebc4f548423cf8":"dZNbh"}],"dZNbh":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ConstructorFragment", ()=>(0, _fragments.ConstructorFragment));
parcelHelpers.export(exports, "ErrorFragment", ()=>(0, _fragments.ErrorFragment));
parcelHelpers.export(exports, "EventFragment", ()=>(0, _fragments.EventFragment));
parcelHelpers.export(exports, "Fragment", ()=>(0, _fragments.Fragment));
parcelHelpers.export(exports, "FunctionFragment", ()=>(0, _fragments.FunctionFragment));
parcelHelpers.export(exports, "ParamType", ()=>(0, _fragments.ParamType));
parcelHelpers.export(exports, "FormatTypes", ()=>(0, _fragments.FormatTypes));
parcelHelpers.export(exports, "AbiCoder", ()=>(0, _abiCoder.AbiCoder));
parcelHelpers.export(exports, "defaultAbiCoder", ()=>(0, _abiCoder.defaultAbiCoder));
parcelHelpers.export(exports, "Interface", ()=>(0, _interface.Interface));
parcelHelpers.export(exports, "Indexed", ()=>(0, _interface.Indexed));
parcelHelpers.export(exports, "checkResultErrors", ()=>(0, _interface.checkResultErrors));
parcelHelpers.export(exports, "LogDescription", ()=>(0, _interface.LogDescription));
parcelHelpers.export(exports, "TransactionDescription", ()=>(0, _interface.TransactionDescription));
var _fragments = require("./fragments");
var _abiCoder = require("./abi-coder");
var _interface = require("./interface");
"use strict";

},{"./fragments":"5nqWe","./abi-coder":"jFGBW","./interface":"jBHig","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"5nqWe":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "FormatTypes", ()=>FormatTypes);
parcelHelpers.export(exports, "ParamType", ()=>ParamType);
parcelHelpers.export(exports, "Fragment", ()=>Fragment);
parcelHelpers.export(exports, "EventFragment", ()=>EventFragment);
parcelHelpers.export(exports, "ConstructorFragment", ()=>ConstructorFragment);
parcelHelpers.export(exports, "FunctionFragment", ()=>FunctionFragment);
parcelHelpers.export(exports, "ErrorFragment", ()=>ErrorFragment);
var _bignumber = require("@ethersproject/bignumber");
var _properties = require("@ethersproject/properties");
var _logger = require("@ethersproject/logger");
var _version = require("./_version");
"use strict";
const logger = new (0, _logger.Logger)((0, _version.version));
const _constructorGuard = {};
let ModifiersBytes = {
    calldata: true,
    memory: true,
    storage: true
};
let ModifiersNest = {
    calldata: true,
    memory: true
};
function checkModifier(type, name) {
    if (type === "bytes" || type === "string") {
        if (ModifiersBytes[name]) return true;
    } else if (type === "address") {
        if (name === "payable") return true;
    } else if (type.indexOf("[") >= 0 || type === "tuple") {
        if (ModifiersNest[name]) return true;
    }
    if (ModifiersBytes[name] || name === "payable") logger.throwArgumentError("invalid modifier", "name", name);
    return false;
}
// @TODO: Make sure that children of an indexed tuple are marked with a null indexed
function parseParamType(param, allowIndexed) {
    let originalParam = param;
    function throwError(i) {
        logger.throwArgumentError(`unexpected character at position ${i}`, "param", param);
    }
    param = param.replace(/\s/g, " ");
    function newNode(parent) {
        let node = {
            type: "",
            name: "",
            parent: parent,
            state: {
                allowType: true
            }
        };
        if (allowIndexed) node.indexed = false;
        return node;
    }
    let parent = {
        type: "",
        name: "",
        state: {
            allowType: true
        }
    };
    let node = parent;
    for(let i = 0; i < param.length; i++){
        let c = param[i];
        switch(c){
            case "(":
                if (node.state.allowType && node.type === "") node.type = "tuple";
                else if (!node.state.allowParams) throwError(i);
                node.state.allowType = false;
                node.type = verifyType(node.type);
                node.components = [
                    newNode(node)
                ];
                node = node.components[0];
                break;
            case ")":
                delete node.state;
                if (node.name === "indexed") {
                    if (!allowIndexed) throwError(i);
                    node.indexed = true;
                    node.name = "";
                }
                if (checkModifier(node.type, node.name)) node.name = "";
                node.type = verifyType(node.type);
                let child = node;
                node = node.parent;
                if (!node) throwError(i);
                delete child.parent;
                node.state.allowParams = false;
                node.state.allowName = true;
                node.state.allowArray = true;
                break;
            case ",":
                delete node.state;
                if (node.name === "indexed") {
                    if (!allowIndexed) throwError(i);
                    node.indexed = true;
                    node.name = "";
                }
                if (checkModifier(node.type, node.name)) node.name = "";
                node.type = verifyType(node.type);
                let sibling = newNode(node.parent);
                //{ type: "", name: "", parent: node.parent, state: { allowType: true } };
                node.parent.components.push(sibling);
                delete node.parent;
                node = sibling;
                break;
            // Hit a space...
            case " ":
                // If reading type, the type is done and may read a param or name
                if (node.state.allowType) {
                    if (node.type !== "") {
                        node.type = verifyType(node.type);
                        delete node.state.allowType;
                        node.state.allowName = true;
                        node.state.allowParams = true;
                    }
                }
                // If reading name, the name is done
                if (node.state.allowName) {
                    if (node.name !== "") {
                        if (node.name === "indexed") {
                            if (!allowIndexed) throwError(i);
                            if (node.indexed) throwError(i);
                            node.indexed = true;
                            node.name = "";
                        } else if (checkModifier(node.type, node.name)) node.name = "";
                        else node.state.allowName = false;
                    }
                }
                break;
            case "[":
                if (!node.state.allowArray) throwError(i);
                node.type += c;
                node.state.allowArray = false;
                node.state.allowName = false;
                node.state.readArray = true;
                break;
            case "]":
                if (!node.state.readArray) throwError(i);
                node.type += c;
                node.state.readArray = false;
                node.state.allowArray = true;
                node.state.allowName = true;
                break;
            default:
                if (node.state.allowType) {
                    node.type += c;
                    node.state.allowParams = true;
                    node.state.allowArray = true;
                } else if (node.state.allowName) {
                    node.name += c;
                    delete node.state.allowArray;
                } else if (node.state.readArray) node.type += c;
                else throwError(i);
        }
    }
    if (node.parent) logger.throwArgumentError("unexpected eof", "param", param);
    delete parent.state;
    if (node.name === "indexed") {
        if (!allowIndexed) throwError(originalParam.length - 7);
        if (node.indexed) throwError(originalParam.length - 7);
        node.indexed = true;
        node.name = "";
    } else if (checkModifier(node.type, node.name)) node.name = "";
    parent.type = verifyType(parent.type);
    return parent;
}
function populate(object, params) {
    for(let key in params)(0, _properties.defineReadOnly)(object, key, params[key]);
}
const FormatTypes = Object.freeze({
    // Bare formatting, as is needed for computing a sighash of an event or function
    sighash: "sighash",
    // Human-Readable with Minimal spacing and without names (compact human-readable)
    minimal: "minimal",
    // Human-Readable with nice spacing, including all names
    full: "full",
    // JSON-format a la Solidity
    json: "json"
});
const paramTypeArray = new RegExp(/^(.*)\[([0-9]*)\]$/);
class ParamType {
    constructor(constructorGuard, params){
        if (constructorGuard !== _constructorGuard) logger.throwError("use fromString", (0, _logger.Logger).errors.UNSUPPORTED_OPERATION, {
            operation: "new ParamType()"
        });
        populate(this, params);
        let match = this.type.match(paramTypeArray);
        if (match) populate(this, {
            arrayLength: parseInt(match[2] || "-1"),
            arrayChildren: ParamType.fromObject({
                type: match[1],
                components: this.components
            }),
            baseType: "array"
        });
        else populate(this, {
            arrayLength: null,
            arrayChildren: null,
            baseType: this.components != null ? "tuple" : this.type
        });
        this._isParamType = true;
        Object.freeze(this);
    }
    // Format the parameter fragment
    //   - sighash: "(uint256,address)"
    //   - minimal: "tuple(uint256,address) indexed"
    //   - full:    "tuple(uint256 foo, address bar) indexed baz"
    format(format) {
        if (!format) format = FormatTypes.sighash;
        if (!FormatTypes[format]) logger.throwArgumentError("invalid format type", "format", format);
        if (format === FormatTypes.json) {
            let result = {
                type: this.baseType === "tuple" ? "tuple" : this.type,
                name: this.name || undefined
            };
            if (typeof this.indexed === "boolean") result.indexed = this.indexed;
            if (this.components) result.components = this.components.map((comp)=>JSON.parse(comp.format(format)));
            return JSON.stringify(result);
        }
        let result = "";
        // Array
        if (this.baseType === "array") {
            result += this.arrayChildren.format(format);
            result += "[" + (this.arrayLength < 0 ? "" : String(this.arrayLength)) + "]";
        } else if (this.baseType === "tuple") {
            if (format !== FormatTypes.sighash) result += this.type;
            result += "(" + this.components.map((comp)=>comp.format(format)).join(format === FormatTypes.full ? ", " : ",") + ")";
        } else result += this.type;
        if (format !== FormatTypes.sighash) {
            if (this.indexed === true) result += " indexed";
            if (format === FormatTypes.full && this.name) result += " " + this.name;
        }
        return result;
    }
    static from(value, allowIndexed) {
        if (typeof value === "string") return ParamType.fromString(value, allowIndexed);
        return ParamType.fromObject(value);
    }
    static fromObject(value) {
        if (ParamType.isParamType(value)) return value;
        return new ParamType(_constructorGuard, {
            name: value.name || null,
            type: verifyType(value.type),
            indexed: value.indexed == null ? null : !!value.indexed,
            components: value.components ? value.components.map(ParamType.fromObject) : null
        });
    }
    static fromString(value, allowIndexed) {
        function ParamTypify(node) {
            return ParamType.fromObject({
                name: node.name,
                type: node.type,
                indexed: node.indexed,
                components: node.components
            });
        }
        return ParamTypify(parseParamType(value, !!allowIndexed));
    }
    static isParamType(value) {
        return !!(value != null && value._isParamType);
    }
}
function parseParams(value, allowIndex) {
    return splitNesting(value).map((param)=>ParamType.fromString(param, allowIndex));
}
class Fragment {
    constructor(constructorGuard, params){
        if (constructorGuard !== _constructorGuard) logger.throwError("use a static from method", (0, _logger.Logger).errors.UNSUPPORTED_OPERATION, {
            operation: "new Fragment()"
        });
        populate(this, params);
        this._isFragment = true;
        Object.freeze(this);
    }
    static from(value) {
        if (Fragment.isFragment(value)) return value;
        if (typeof value === "string") return Fragment.fromString(value);
        return Fragment.fromObject(value);
    }
    static fromObject(value) {
        if (Fragment.isFragment(value)) return value;
        switch(value.type){
            case "function":
                return FunctionFragment.fromObject(value);
            case "event":
                return EventFragment.fromObject(value);
            case "constructor":
                return ConstructorFragment.fromObject(value);
            case "error":
                return ErrorFragment.fromObject(value);
            case "fallback":
            case "receive":
                // @TODO: Something? Maybe return a FunctionFragment? A custom DefaultFunctionFragment?
                return null;
        }
        return logger.throwArgumentError("invalid fragment object", "value", value);
    }
    static fromString(value) {
        // Make sure the "returns" is surrounded by a space and all whitespace is exactly one space
        value = value.replace(/\s/g, " ");
        value = value.replace(/\(/g, " (").replace(/\)/g, ") ").replace(/\s+/g, " ");
        value = value.trim();
        if (value.split(" ")[0] === "event") return EventFragment.fromString(value.substring(5).trim());
        else if (value.split(" ")[0] === "function") return FunctionFragment.fromString(value.substring(8).trim());
        else if (value.split("(")[0].trim() === "constructor") return ConstructorFragment.fromString(value.trim());
        else if (value.split(" ")[0] === "error") return ErrorFragment.fromString(value.substring(5).trim());
        return logger.throwArgumentError("unsupported fragment", "value", value);
    }
    static isFragment(value) {
        return !!(value && value._isFragment);
    }
}
class EventFragment extends Fragment {
    format(format) {
        if (!format) format = FormatTypes.sighash;
        if (!FormatTypes[format]) logger.throwArgumentError("invalid format type", "format", format);
        if (format === FormatTypes.json) return JSON.stringify({
            type: "event",
            anonymous: this.anonymous,
            name: this.name,
            inputs: this.inputs.map((input)=>JSON.parse(input.format(format)))
        });
        let result = "";
        if (format !== FormatTypes.sighash) result += "event ";
        result += this.name + "(" + this.inputs.map((input)=>input.format(format)).join(format === FormatTypes.full ? ", " : ",") + ") ";
        if (format !== FormatTypes.sighash) {
            if (this.anonymous) result += "anonymous ";
        }
        return result.trim();
    }
    static from(value) {
        if (typeof value === "string") return EventFragment.fromString(value);
        return EventFragment.fromObject(value);
    }
    static fromObject(value) {
        if (EventFragment.isEventFragment(value)) return value;
        if (value.type !== "event") logger.throwArgumentError("invalid event object", "value", value);
        const params = {
            name: verifyIdentifier(value.name),
            anonymous: value.anonymous,
            inputs: value.inputs ? value.inputs.map(ParamType.fromObject) : [],
            type: "event"
        };
        return new EventFragment(_constructorGuard, params);
    }
    static fromString(value) {
        let match = value.match(regexParen);
        if (!match) logger.throwArgumentError("invalid event string", "value", value);
        let anonymous = false;
        match[3].split(" ").forEach((modifier)=>{
            switch(modifier.trim()){
                case "anonymous":
                    anonymous = true;
                    break;
                case "":
                    break;
                default:
                    logger.warn("unknown modifier: " + modifier);
            }
        });
        return EventFragment.fromObject({
            name: match[1].trim(),
            anonymous: anonymous,
            inputs: parseParams(match[2], true),
            type: "event"
        });
    }
    static isEventFragment(value) {
        return value && value._isFragment && value.type === "event";
    }
}
function parseGas(value, params) {
    params.gas = null;
    let comps = value.split("@");
    if (comps.length !== 1) {
        if (comps.length > 2) logger.throwArgumentError("invalid human-readable ABI signature", "value", value);
        if (!comps[1].match(/^[0-9]+$/)) logger.throwArgumentError("invalid human-readable ABI signature gas", "value", value);
        params.gas = (0, _bignumber.BigNumber).from(comps[1]);
        return comps[0];
    }
    return value;
}
function parseModifiers(value, params) {
    params.constant = false;
    params.payable = false;
    params.stateMutability = "nonpayable";
    value.split(" ").forEach((modifier)=>{
        switch(modifier.trim()){
            case "constant":
                params.constant = true;
                break;
            case "payable":
                params.payable = true;
                params.stateMutability = "payable";
                break;
            case "nonpayable":
                params.payable = false;
                params.stateMutability = "nonpayable";
                break;
            case "pure":
                params.constant = true;
                params.stateMutability = "pure";
                break;
            case "view":
                params.constant = true;
                params.stateMutability = "view";
                break;
            case "external":
            case "public":
            case "":
                break;
            default:
                console.log("unknown modifier: " + modifier);
        }
    });
}
function verifyState(value) {
    let result = {
        constant: false,
        payable: true,
        stateMutability: "payable"
    };
    if (value.stateMutability != null) {
        result.stateMutability = value.stateMutability;
        // Set (and check things are consistent) the constant property
        result.constant = result.stateMutability === "view" || result.stateMutability === "pure";
        if (value.constant != null) {
            if (!!value.constant !== result.constant) logger.throwArgumentError("cannot have constant function with mutability " + result.stateMutability, "value", value);
        }
        // Set (and check things are consistent) the payable property
        result.payable = result.stateMutability === "payable";
        if (value.payable != null) {
            if (!!value.payable !== result.payable) logger.throwArgumentError("cannot have payable function with mutability " + result.stateMutability, "value", value);
        }
    } else if (value.payable != null) {
        result.payable = !!value.payable;
        // If payable we can assume non-constant; otherwise we can't assume
        if (value.constant == null && !result.payable && value.type !== "constructor") logger.throwArgumentError("unable to determine stateMutability", "value", value);
        result.constant = !!value.constant;
        if (result.constant) result.stateMutability = "view";
        else result.stateMutability = result.payable ? "payable" : "nonpayable";
        if (result.payable && result.constant) logger.throwArgumentError("cannot have constant payable function", "value", value);
    } else if (value.constant != null) {
        result.constant = !!value.constant;
        result.payable = !result.constant;
        result.stateMutability = result.constant ? "view" : "payable";
    } else if (value.type !== "constructor") logger.throwArgumentError("unable to determine stateMutability", "value", value);
    return result;
}
class ConstructorFragment extends Fragment {
    format(format) {
        if (!format) format = FormatTypes.sighash;
        if (!FormatTypes[format]) logger.throwArgumentError("invalid format type", "format", format);
        if (format === FormatTypes.json) return JSON.stringify({
            type: "constructor",
            stateMutability: this.stateMutability !== "nonpayable" ? this.stateMutability : undefined,
            payable: this.payable,
            gas: this.gas ? this.gas.toNumber() : undefined,
            inputs: this.inputs.map((input)=>JSON.parse(input.format(format)))
        });
        if (format === FormatTypes.sighash) logger.throwError("cannot format a constructor for sighash", (0, _logger.Logger).errors.UNSUPPORTED_OPERATION, {
            operation: "format(sighash)"
        });
        let result = "constructor(" + this.inputs.map((input)=>input.format(format)).join(format === FormatTypes.full ? ", " : ",") + ") ";
        if (this.stateMutability && this.stateMutability !== "nonpayable") result += this.stateMutability + " ";
        return result.trim();
    }
    static from(value) {
        if (typeof value === "string") return ConstructorFragment.fromString(value);
        return ConstructorFragment.fromObject(value);
    }
    static fromObject(value) {
        if (ConstructorFragment.isConstructorFragment(value)) return value;
        if (value.type !== "constructor") logger.throwArgumentError("invalid constructor object", "value", value);
        let state = verifyState(value);
        if (state.constant) logger.throwArgumentError("constructor cannot be constant", "value", value);
        const params = {
            name: null,
            type: value.type,
            inputs: value.inputs ? value.inputs.map(ParamType.fromObject) : [],
            payable: state.payable,
            stateMutability: state.stateMutability,
            gas: value.gas ? (0, _bignumber.BigNumber).from(value.gas) : null
        };
        return new ConstructorFragment(_constructorGuard, params);
    }
    static fromString(value) {
        let params = {
            type: "constructor"
        };
        value = parseGas(value, params);
        let parens = value.match(regexParen);
        if (!parens || parens[1].trim() !== "constructor") logger.throwArgumentError("invalid constructor string", "value", value);
        params.inputs = parseParams(parens[2].trim(), false);
        parseModifiers(parens[3].trim(), params);
        return ConstructorFragment.fromObject(params);
    }
    static isConstructorFragment(value) {
        return value && value._isFragment && value.type === "constructor";
    }
}
class FunctionFragment extends ConstructorFragment {
    format(format) {
        if (!format) format = FormatTypes.sighash;
        if (!FormatTypes[format]) logger.throwArgumentError("invalid format type", "format", format);
        if (format === FormatTypes.json) return JSON.stringify({
            type: "function",
            name: this.name,
            constant: this.constant,
            stateMutability: this.stateMutability !== "nonpayable" ? this.stateMutability : undefined,
            payable: this.payable,
            gas: this.gas ? this.gas.toNumber() : undefined,
            inputs: this.inputs.map((input)=>JSON.parse(input.format(format))),
            outputs: this.outputs.map((output)=>JSON.parse(output.format(format)))
        });
        let result = "";
        if (format !== FormatTypes.sighash) result += "function ";
        result += this.name + "(" + this.inputs.map((input)=>input.format(format)).join(format === FormatTypes.full ? ", " : ",") + ") ";
        if (format !== FormatTypes.sighash) {
            if (this.stateMutability) {
                if (this.stateMutability !== "nonpayable") result += this.stateMutability + " ";
            } else if (this.constant) result += "view ";
            if (this.outputs && this.outputs.length) result += "returns (" + this.outputs.map((output)=>output.format(format)).join(", ") + ") ";
            if (this.gas != null) result += "@" + this.gas.toString() + " ";
        }
        return result.trim();
    }
    static from(value) {
        if (typeof value === "string") return FunctionFragment.fromString(value);
        return FunctionFragment.fromObject(value);
    }
    static fromObject(value) {
        if (FunctionFragment.isFunctionFragment(value)) return value;
        if (value.type !== "function") logger.throwArgumentError("invalid function object", "value", value);
        let state = verifyState(value);
        const params = {
            type: value.type,
            name: verifyIdentifier(value.name),
            constant: state.constant,
            inputs: value.inputs ? value.inputs.map(ParamType.fromObject) : [],
            outputs: value.outputs ? value.outputs.map(ParamType.fromObject) : [],
            payable: state.payable,
            stateMutability: state.stateMutability,
            gas: value.gas ? (0, _bignumber.BigNumber).from(value.gas) : null
        };
        return new FunctionFragment(_constructorGuard, params);
    }
    static fromString(value) {
        let params = {
            type: "function"
        };
        value = parseGas(value, params);
        let comps = value.split(" returns ");
        if (comps.length > 2) logger.throwArgumentError("invalid function string", "value", value);
        let parens = comps[0].match(regexParen);
        if (!parens) logger.throwArgumentError("invalid function signature", "value", value);
        params.name = parens[1].trim();
        if (params.name) verifyIdentifier(params.name);
        params.inputs = parseParams(parens[2], false);
        parseModifiers(parens[3].trim(), params);
        // We have outputs
        if (comps.length > 1) {
            let returns = comps[1].match(regexParen);
            if (returns[1].trim() != "" || returns[3].trim() != "") logger.throwArgumentError("unexpected tokens", "value", value);
            params.outputs = parseParams(returns[2], false);
        } else params.outputs = [];
        return FunctionFragment.fromObject(params);
    }
    static isFunctionFragment(value) {
        return value && value._isFragment && value.type === "function";
    }
}
//export class StructFragment extends Fragment {
//}
function checkForbidden(fragment) {
    const sig = fragment.format();
    if (sig === "Error(string)" || sig === "Panic(uint256)") logger.throwArgumentError(`cannot specify user defined ${sig} error`, "fragment", fragment);
    return fragment;
}
class ErrorFragment extends Fragment {
    format(format) {
        if (!format) format = FormatTypes.sighash;
        if (!FormatTypes[format]) logger.throwArgumentError("invalid format type", "format", format);
        if (format === FormatTypes.json) return JSON.stringify({
            type: "error",
            name: this.name,
            inputs: this.inputs.map((input)=>JSON.parse(input.format(format)))
        });
        let result = "";
        if (format !== FormatTypes.sighash) result += "error ";
        result += this.name + "(" + this.inputs.map((input)=>input.format(format)).join(format === FormatTypes.full ? ", " : ",") + ") ";
        return result.trim();
    }
    static from(value) {
        if (typeof value === "string") return ErrorFragment.fromString(value);
        return ErrorFragment.fromObject(value);
    }
    static fromObject(value) {
        if (ErrorFragment.isErrorFragment(value)) return value;
        if (value.type !== "error") logger.throwArgumentError("invalid error object", "value", value);
        const params = {
            type: value.type,
            name: verifyIdentifier(value.name),
            inputs: value.inputs ? value.inputs.map(ParamType.fromObject) : []
        };
        return checkForbidden(new ErrorFragment(_constructorGuard, params));
    }
    static fromString(value) {
        let params = {
            type: "error"
        };
        let parens = value.match(regexParen);
        if (!parens) logger.throwArgumentError("invalid error signature", "value", value);
        params.name = parens[1].trim();
        if (params.name) verifyIdentifier(params.name);
        params.inputs = parseParams(parens[2], false);
        return checkForbidden(ErrorFragment.fromObject(params));
    }
    static isErrorFragment(value) {
        return value && value._isFragment && value.type === "error";
    }
}
function verifyType(type) {
    // These need to be transformed to their full description
    if (type.match(/^uint($|[^1-9])/)) type = "uint256" + type.substring(4);
    else if (type.match(/^int($|[^1-9])/)) type = "int256" + type.substring(3);
    // @TODO: more verification
    return type;
}
// See: https://github.com/ethereum/solidity/blob/1f8f1a3db93a548d0555e3e14cfc55a10e25b60e/docs/grammar/SolidityLexer.g4#L234
const regexIdentifier = new RegExp("^[a-zA-Z$_][a-zA-Z0-9$_]*$");
function verifyIdentifier(value) {
    if (!value || !value.match(regexIdentifier)) logger.throwArgumentError(`invalid identifier "${value}"`, "value", value);
    return value;
}
const regexParen = new RegExp("^([^)(]*)\\((.*)\\)([^)(]*)$");
function splitNesting(value) {
    value = value.trim();
    let result = [];
    let accum = "";
    let depth = 0;
    for(let offset = 0; offset < value.length; offset++){
        let c = value[offset];
        if (c === "," && depth === 0) {
            result.push(accum);
            accum = "";
        } else {
            accum += c;
            if (c === "(") depth++;
            else if (c === ")") {
                depth--;
                if (depth === -1) logger.throwArgumentError("unbalanced parenthesis", "value", value);
            }
        }
    }
    if (accum) result.push(accum);
    return result;
}

},{"@ethersproject/bignumber":"fUhf1","@ethersproject/properties":"016Tj","@ethersproject/logger":"jADah","./_version":"fI0Q8","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"fUhf1":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BigNumber", ()=>(0, _bignumber.BigNumber));
parcelHelpers.export(exports, "formatFixed", ()=>(0, _fixednumber.formatFixed));
parcelHelpers.export(exports, "FixedFormat", ()=>(0, _fixednumber.FixedFormat));
parcelHelpers.export(exports, "FixedNumber", ()=>(0, _fixednumber.FixedNumber));
parcelHelpers.export(exports, "parseFixed", ()=>(0, _fixednumber.parseFixed));
// Internal methods used by address
parcelHelpers.export(exports, "_base16To36", ()=>(0, _bignumber._base16To36));
parcelHelpers.export(exports, "_base36To16", ()=>(0, _bignumber._base36To16));
var _bignumber = require("./bignumber");
var _fixednumber = require("./fixednumber");

},{"./bignumber":"egiLJ","./fixednumber":false,"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"egiLJ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isBigNumberish", ()=>isBigNumberish);
parcelHelpers.export(exports, "BigNumber", ()=>BigNumber);
// value should have no prefix
parcelHelpers.export(exports, "_base36To16", ()=>_base36To16);
// value should have no prefix
parcelHelpers.export(exports, "_base16To36", ()=>_base16To36);
/**
 *  BigNumber
 *
 *  A wrapper around the BN.js object. We use the BN.js library
 *  because it is used by elliptic, so it is required regardless.
 *
 */ var _bnJs = require("bn.js");
var _bnJsDefault = parcelHelpers.interopDefault(_bnJs);
var _bytes = require("@ethersproject/bytes");
var _logger = require("@ethersproject/logger");
var _version = require("./_version");
"use strict";
var BN = (0, _bnJsDefault.default).BN;
const logger = new (0, _logger.Logger)((0, _version.version));
const _constructorGuard = {};
const MAX_SAFE = 0x1fffffffffffff;
function isBigNumberish(value) {
    return value != null && (BigNumber.isBigNumber(value) || typeof value === "number" && value % 1 === 0 || typeof value === "string" && !!value.match(/^-?[0-9]+$/) || (0, _bytes.isHexString)(value) || typeof value === "bigint" || (0, _bytes.isBytes)(value));
}
// Only warn about passing 10 into radix once
let _warnedToStringRadix = false;
class BigNumber {
    constructor(constructorGuard, hex){
        if (constructorGuard !== _constructorGuard) logger.throwError("cannot call constructor directly; use BigNumber.from", (0, _logger.Logger).errors.UNSUPPORTED_OPERATION, {
            operation: "new (BigNumber)"
        });
        this._hex = hex;
        this._isBigNumber = true;
        Object.freeze(this);
    }
    fromTwos(value) {
        return toBigNumber(toBN(this).fromTwos(value));
    }
    toTwos(value) {
        return toBigNumber(toBN(this).toTwos(value));
    }
    abs() {
        if (this._hex[0] === "-") return BigNumber.from(this._hex.substring(1));
        return this;
    }
    add(other) {
        return toBigNumber(toBN(this).add(toBN(other)));
    }
    sub(other) {
        return toBigNumber(toBN(this).sub(toBN(other)));
    }
    div(other) {
        const o = BigNumber.from(other);
        if (o.isZero()) throwFault("division-by-zero", "div");
        return toBigNumber(toBN(this).div(toBN(other)));
    }
    mul(other) {
        return toBigNumber(toBN(this).mul(toBN(other)));
    }
    mod(other) {
        const value = toBN(other);
        if (value.isNeg()) throwFault("division-by-zero", "mod");
        return toBigNumber(toBN(this).umod(value));
    }
    pow(other) {
        const value = toBN(other);
        if (value.isNeg()) throwFault("negative-power", "pow");
        return toBigNumber(toBN(this).pow(value));
    }
    and(other) {
        const value = toBN(other);
        if (this.isNegative() || value.isNeg()) throwFault("unbound-bitwise-result", "and");
        return toBigNumber(toBN(this).and(value));
    }
    or(other) {
        const value = toBN(other);
        if (this.isNegative() || value.isNeg()) throwFault("unbound-bitwise-result", "or");
        return toBigNumber(toBN(this).or(value));
    }
    xor(other) {
        const value = toBN(other);
        if (this.isNegative() || value.isNeg()) throwFault("unbound-bitwise-result", "xor");
        return toBigNumber(toBN(this).xor(value));
    }
    mask(value) {
        if (this.isNegative() || value < 0) throwFault("negative-width", "mask");
        return toBigNumber(toBN(this).maskn(value));
    }
    shl(value) {
        if (this.isNegative() || value < 0) throwFault("negative-width", "shl");
        return toBigNumber(toBN(this).shln(value));
    }
    shr(value) {
        if (this.isNegative() || value < 0) throwFault("negative-width", "shr");
        return toBigNumber(toBN(this).shrn(value));
    }
    eq(other) {
        return toBN(this).eq(toBN(other));
    }
    lt(other) {
        return toBN(this).lt(toBN(other));
    }
    lte(other) {
        return toBN(this).lte(toBN(other));
    }
    gt(other) {
        return toBN(this).gt(toBN(other));
    }
    gte(other) {
        return toBN(this).gte(toBN(other));
    }
    isNegative() {
        return this._hex[0] === "-";
    }
    isZero() {
        return toBN(this).isZero();
    }
    toNumber() {
        try {
            return toBN(this).toNumber();
        } catch (error) {
            throwFault("overflow", "toNumber", this.toString());
        }
        return null;
    }
    toBigInt() {
        try {
            return BigInt(this.toString());
        } catch (e) {}
        return logger.throwError("this platform does not support BigInt", (0, _logger.Logger).errors.UNSUPPORTED_OPERATION, {
            value: this.toString()
        });
    }
    toString() {
        // Lots of people expect this, which we do not support, so check (See: #889)
        if (arguments.length > 0) {
            if (arguments[0] === 10) {
                if (!_warnedToStringRadix) {
                    _warnedToStringRadix = true;
                    logger.warn("BigNumber.toString does not accept any parameters; base-10 is assumed");
                }
            } else if (arguments[0] === 16) logger.throwError("BigNumber.toString does not accept any parameters; use bigNumber.toHexString()", (0, _logger.Logger).errors.UNEXPECTED_ARGUMENT, {});
            else logger.throwError("BigNumber.toString does not accept parameters", (0, _logger.Logger).errors.UNEXPECTED_ARGUMENT, {});
        }
        return toBN(this).toString(10);
    }
    toHexString() {
        return this._hex;
    }
    toJSON(key) {
        return {
            type: "BigNumber",
            hex: this.toHexString()
        };
    }
    static from(value) {
        if (value instanceof BigNumber) return value;
        if (typeof value === "string") {
            if (value.match(/^-?0x[0-9a-f]+$/i)) return new BigNumber(_constructorGuard, toHex(value));
            if (value.match(/^-?[0-9]+$/)) return new BigNumber(_constructorGuard, toHex(new BN(value)));
            return logger.throwArgumentError("invalid BigNumber string", "value", value);
        }
        if (typeof value === "number") {
            if (value % 1) throwFault("underflow", "BigNumber.from", value);
            if (value >= MAX_SAFE || value <= -MAX_SAFE) throwFault("overflow", "BigNumber.from", value);
            return BigNumber.from(String(value));
        }
        const anyValue = value;
        if (typeof anyValue === "bigint") return BigNumber.from(anyValue.toString());
        if ((0, _bytes.isBytes)(anyValue)) return BigNumber.from((0, _bytes.hexlify)(anyValue));
        if (anyValue) {
            // Hexable interface (takes priority)
            if (anyValue.toHexString) {
                const hex = anyValue.toHexString();
                if (typeof hex === "string") return BigNumber.from(hex);
            } else {
                // For now, handle legacy JSON-ified values (goes away in v6)
                let hex = anyValue._hex;
                // New-form JSON
                if (hex == null && anyValue.type === "BigNumber") hex = anyValue.hex;
                if (typeof hex === "string") {
                    if ((0, _bytes.isHexString)(hex) || hex[0] === "-" && (0, _bytes.isHexString)(hex.substring(1))) return BigNumber.from(hex);
                }
            }
        }
        return logger.throwArgumentError("invalid BigNumber value", "value", value);
    }
    static isBigNumber(value) {
        return !!(value && value._isBigNumber);
    }
}
// Normalize the hex string
function toHex(value) {
    // For BN, call on the hex string
    if (typeof value !== "string") return toHex(value.toString(16));
    // If negative, prepend the negative sign to the normalized positive value
    if (value[0] === "-") {
        // Strip off the negative sign
        value = value.substring(1);
        // Cannot have multiple negative signs (e.g. "--0x04")
        if (value[0] === "-") logger.throwArgumentError("invalid hex", "value", value);
        // Call toHex on the positive component
        value = toHex(value);
        // Do not allow "-0x00"
        if (value === "0x00") return value;
        // Negate the value
        return "-" + value;
    }
    // Add a "0x" prefix if missing
    if (value.substring(0, 2) !== "0x") value = "0x" + value;
    // Normalize zero
    if (value === "0x") return "0x00";
    // Make the string even length
    if (value.length % 2) value = "0x0" + value.substring(2);
    // Trim to smallest even-length string
    while(value.length > 4 && value.substring(0, 4) === "0x00")value = "0x" + value.substring(4);
    return value;
}
function toBigNumber(value) {
    return BigNumber.from(toHex(value));
}
function toBN(value) {
    const hex = BigNumber.from(value).toHexString();
    if (hex[0] === "-") return new BN("-" + hex.substring(3), 16);
    return new BN(hex.substring(2), 16);
}
function throwFault(fault, operation, value) {
    const params = {
        fault: fault,
        operation: operation
    };
    if (value != null) params.value = value;
    return logger.throwError(fault, (0, _logger.Logger).errors.NUMERIC_FAULT, params);
}
function _base36To16(value) {
    return new BN(value, 36).toString(16);
}
function _base16To36(value) {
    return new BN(value, 16).toString(36);
}

},{"bn.js":"l8wse","@ethersproject/bytes":"4xCgN","@ethersproject/logger":"jADah","./_version":"5YGz5","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"l8wse":[function(require,module,exports) {
(function(module1, exports) {
    "use strict";
    // Utils
    function assert(val, msg) {
        if (!val) throw new Error(msg || "Assertion failed");
    }
    // Could use `inherits` module, but don't want to move from single file
    // architecture yet.
    function inherits(ctor, superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
    // BN
    function BN(number, base, endian) {
        if (BN.isBN(number)) return number;
        this.negative = 0;
        this.words = null;
        this.length = 0;
        // Reduction context
        this.red = null;
        if (number !== null) {
            if (base === "le" || base === "be") {
                endian = base;
                base = 10;
            }
            this._init(number || 0, base || 10, endian || "be");
        }
    }
    if (typeof module1 === "object") module1.exports = BN;
    else exports.BN = BN;
    BN.BN = BN;
    BN.wordSize = 26;
    var Buffer;
    try {
        if (typeof window !== "undefined" && typeof window.Buffer !== "undefined") Buffer = window.Buffer;
        else Buffer = require("c3a61706559b2db2").Buffer;
    } catch (e) {}
    BN.isBN = function isBN(num) {
        if (num instanceof BN) return true;
        return num !== null && typeof num === "object" && num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
    };
    BN.max = function max(left, right) {
        if (left.cmp(right) > 0) return left;
        return right;
    };
    BN.min = function min(left, right) {
        if (left.cmp(right) < 0) return left;
        return right;
    };
    BN.prototype._init = function init(number, base, endian) {
        if (typeof number === "number") return this._initNumber(number, base, endian);
        if (typeof number === "object") return this._initArray(number, base, endian);
        if (base === "hex") base = 16;
        assert(base === (base | 0) && base >= 2 && base <= 36);
        number = number.toString().replace(/\s+/g, "");
        var start = 0;
        if (number[0] === "-") {
            start++;
            this.negative = 1;
        }
        if (start < number.length) {
            if (base === 16) this._parseHex(number, start, endian);
            else {
                this._parseBase(number, base, start);
                if (endian === "le") this._initArray(this.toArray(), base, endian);
            }
        }
    };
    BN.prototype._initNumber = function _initNumber(number, base, endian) {
        if (number < 0) {
            this.negative = 1;
            number = -number;
        }
        if (number < 0x4000000) {
            this.words = [
                number & 0x3ffffff
            ];
            this.length = 1;
        } else if (number < 0x10000000000000) {
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff
            ];
            this.length = 2;
        } else {
            assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff,
                1
            ];
            this.length = 3;
        }
        if (endian !== "le") return;
        // Reverse the bytes
        this._initArray(this.toArray(), base, endian);
    };
    BN.prototype._initArray = function _initArray(number, base, endian) {
        // Perhaps a Uint8Array
        assert(typeof number.length === "number");
        if (number.length <= 0) {
            this.words = [
                0
            ];
            this.length = 1;
            return this;
        }
        this.length = Math.ceil(number.length / 3);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        var j, w;
        var off = 0;
        if (endian === "be") for(i = number.length - 1, j = 0; i >= 0; i -= 3){
            w = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        else if (endian === "le") for(i = 0, j = 0; i < number.length; i += 3){
            w = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        return this._strip();
    };
    function parseHex4Bits(string, index) {
        var c = string.charCodeAt(index);
        // '0' - '9'
        if (c >= 48 && c <= 57) return c - 48;
        else if (c >= 65 && c <= 70) return c - 55;
        else if (c >= 97 && c <= 102) return c - 87;
        else assert(false, "Invalid character in " + string);
    }
    function parseHexByte(string, lowerBound, index) {
        var r = parseHex4Bits(string, index);
        if (index - 1 >= lowerBound) r |= parseHex4Bits(string, index - 1) << 4;
        return r;
    }
    BN.prototype._parseHex = function _parseHex(number, start, endian) {
        // Create possibly bigger array to ensure that it fits the number
        this.length = Math.ceil((number.length - start) / 6);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        // 24-bits chunks
        var off = 0;
        var j = 0;
        var w;
        if (endian === "be") for(i = number.length - 1; i >= start; i -= 2){
            w = parseHexByte(number, start, i) << off;
            this.words[j] |= w & 0x3ffffff;
            if (off >= 18) {
                off -= 18;
                j += 1;
                this.words[j] |= w >>> 26;
            } else off += 8;
        }
        else {
            var parseLength = number.length - start;
            for(i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2){
                w = parseHexByte(number, start, i) << off;
                this.words[j] |= w & 0x3ffffff;
                if (off >= 18) {
                    off -= 18;
                    j += 1;
                    this.words[j] |= w >>> 26;
                } else off += 8;
            }
        }
        this._strip();
    };
    function parseBase(str, start, end, mul) {
        var r = 0;
        var b = 0;
        var len = Math.min(str.length, end);
        for(var i = start; i < len; i++){
            var c = str.charCodeAt(i) - 48;
            r *= mul;
            // 'a'
            if (c >= 49) b = c - 49 + 0xa;
            else if (c >= 17) b = c - 17 + 0xa;
            else b = c;
            assert(c >= 0 && b < mul, "Invalid character");
            r += b;
        }
        return r;
    }
    BN.prototype._parseBase = function _parseBase(number, base, start) {
        // Initialize as zero
        this.words = [
            0
        ];
        this.length = 1;
        // Find length of limb in base
        for(var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base)limbLen++;
        limbLen--;
        limbPow = limbPow / base | 0;
        var total = number.length - start;
        var mod = total % limbLen;
        var end = Math.min(total, total - mod) + start;
        var word = 0;
        for(var i = start; i < end; i += limbLen){
            word = parseBase(number, i, i + limbLen, base);
            this.imuln(limbPow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        if (mod !== 0) {
            var pow = 1;
            word = parseBase(number, i, number.length, base);
            for(i = 0; i < mod; i++)pow *= base;
            this.imuln(pow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        this._strip();
    };
    BN.prototype.copy = function copy(dest) {
        dest.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)dest.words[i] = this.words[i];
        dest.length = this.length;
        dest.negative = this.negative;
        dest.red = this.red;
    };
    function move(dest, src) {
        dest.words = src.words;
        dest.length = src.length;
        dest.negative = src.negative;
        dest.red = src.red;
    }
    BN.prototype._move = function _move(dest) {
        move(dest, this);
    };
    BN.prototype.clone = function clone() {
        var r = new BN(null);
        this.copy(r);
        return r;
    };
    BN.prototype._expand = function _expand(size) {
        while(this.length < size)this.words[this.length++] = 0;
        return this;
    };
    // Remove leading `0` from `this`
    BN.prototype._strip = function strip() {
        while(this.length > 1 && this.words[this.length - 1] === 0)this.length--;
        return this._normSign();
    };
    BN.prototype._normSign = function _normSign() {
        // -0 = 0
        if (this.length === 1 && this.words[0] === 0) this.negative = 0;
        return this;
    };
    // Check Symbol.for because not everywhere where Symbol defined
    // See https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Symbol#Browser_compatibility
    if (typeof Symbol !== "undefined" && typeof Symbol.for === "function") try {
        BN.prototype[Symbol.for("nodejs.util.inspect.custom")] = inspect;
    } catch (e) {
        BN.prototype.inspect = inspect;
    }
    else BN.prototype.inspect = inspect;
    function inspect() {
        return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
    }
    /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */ var zeros = [
        "",
        "0",
        "00",
        "000",
        "0000",
        "00000",
        "000000",
        "0000000",
        "00000000",
        "000000000",
        "0000000000",
        "00000000000",
        "000000000000",
        "0000000000000",
        "00000000000000",
        "000000000000000",
        "0000000000000000",
        "00000000000000000",
        "000000000000000000",
        "0000000000000000000",
        "00000000000000000000",
        "000000000000000000000",
        "0000000000000000000000",
        "00000000000000000000000",
        "000000000000000000000000",
        "0000000000000000000000000"
    ];
    var groupSizes = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
    ];
    var groupBases = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        10000000,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64000000,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        24300000,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
    ];
    BN.prototype.toString = function toString(base, padding) {
        base = base || 10;
        padding = padding | 0 || 1;
        var out;
        if (base === 16 || base === "hex") {
            out = "";
            var off = 0;
            var carry = 0;
            for(var i = 0; i < this.length; i++){
                var w = this.words[i];
                var word = ((w << off | carry) & 0xffffff).toString(16);
                carry = w >>> 24 - off & 0xffffff;
                off += 2;
                if (off >= 26) {
                    off -= 26;
                    i--;
                }
                if (carry !== 0 || i !== this.length - 1) out = zeros[6 - word.length] + word + out;
                else out = word + out;
            }
            if (carry !== 0) out = carry.toString(16) + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        if (base === (base | 0) && base >= 2 && base <= 36) {
            // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
            var groupSize = groupSizes[base];
            // var groupBase = Math.pow(base, groupSize);
            var groupBase = groupBases[base];
            out = "";
            var c = this.clone();
            c.negative = 0;
            while(!c.isZero()){
                var r = c.modrn(groupBase).toString(base);
                c = c.idivn(groupBase);
                if (!c.isZero()) out = zeros[groupSize - r.length] + r + out;
                else out = r + out;
            }
            if (this.isZero()) out = "0" + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        assert(false, "Base should be between 2 and 36");
    };
    BN.prototype.toNumber = function toNumber() {
        var ret = this.words[0];
        if (this.length === 2) ret += this.words[1] * 0x4000000;
        else if (this.length === 3 && this.words[2] === 0x01) // NOTE: at this stage it is known that the top bit is set
        ret += 0x10000000000000 + this.words[1] * 0x4000000;
        else if (this.length > 2) assert(false, "Number can only safely store up to 53 bits");
        return this.negative !== 0 ? -ret : ret;
    };
    BN.prototype.toJSON = function toJSON() {
        return this.toString(16, 2);
    };
    if (Buffer) BN.prototype.toBuffer = function toBuffer(endian, length) {
        return this.toArrayLike(Buffer, endian, length);
    };
    BN.prototype.toArray = function toArray(endian, length) {
        return this.toArrayLike(Array, endian, length);
    };
    var allocate = function allocate(ArrayType, size) {
        if (ArrayType.allocUnsafe) return ArrayType.allocUnsafe(size);
        return new ArrayType(size);
    };
    BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
        this._strip();
        var byteLength = this.byteLength();
        var reqLength = length || Math.max(1, byteLength);
        assert(byteLength <= reqLength, "byte array longer than desired length");
        assert(reqLength > 0, "Requested array length <= 0");
        var res = allocate(ArrayType, reqLength);
        var postfix = endian === "le" ? "LE" : "BE";
        this["_toArrayLike" + postfix](res, byteLength);
        return res;
    };
    BN.prototype._toArrayLikeLE = function _toArrayLikeLE(res, byteLength) {
        var position = 0;
        var carry = 0;
        for(var i = 0, shift = 0; i < this.length; i++){
            var word = this.words[i] << shift | carry;
            res[position++] = word & 0xff;
            if (position < res.length) res[position++] = word >> 8 & 0xff;
            if (position < res.length) res[position++] = word >> 16 & 0xff;
            if (shift === 6) {
                if (position < res.length) res[position++] = word >> 24 & 0xff;
                carry = 0;
                shift = 0;
            } else {
                carry = word >>> 24;
                shift += 2;
            }
        }
        if (position < res.length) {
            res[position++] = carry;
            while(position < res.length)res[position++] = 0;
        }
    };
    BN.prototype._toArrayLikeBE = function _toArrayLikeBE(res, byteLength) {
        var position = res.length - 1;
        var carry = 0;
        for(var i = 0, shift = 0; i < this.length; i++){
            var word = this.words[i] << shift | carry;
            res[position--] = word & 0xff;
            if (position >= 0) res[position--] = word >> 8 & 0xff;
            if (position >= 0) res[position--] = word >> 16 & 0xff;
            if (shift === 6) {
                if (position >= 0) res[position--] = word >> 24 & 0xff;
                carry = 0;
                shift = 0;
            } else {
                carry = word >>> 24;
                shift += 2;
            }
        }
        if (position >= 0) {
            res[position--] = carry;
            while(position >= 0)res[position--] = 0;
        }
    };
    if (Math.clz32) BN.prototype._countBits = function _countBits(w) {
        return 32 - Math.clz32(w);
    };
    else BN.prototype._countBits = function _countBits(w) {
        var t = w;
        var r = 0;
        if (t >= 0x1000) {
            r += 13;
            t >>>= 13;
        }
        if (t >= 0x40) {
            r += 7;
            t >>>= 7;
        }
        if (t >= 0x8) {
            r += 4;
            t >>>= 4;
        }
        if (t >= 0x02) {
            r += 2;
            t >>>= 2;
        }
        return r + t;
    };
    BN.prototype._zeroBits = function _zeroBits(w) {
        // Short-cut
        if (w === 0) return 26;
        var t = w;
        var r = 0;
        if ((t & 0x1fff) === 0) {
            r += 13;
            t >>>= 13;
        }
        if ((t & 0x7f) === 0) {
            r += 7;
            t >>>= 7;
        }
        if ((t & 0xf) === 0) {
            r += 4;
            t >>>= 4;
        }
        if ((t & 0x3) === 0) {
            r += 2;
            t >>>= 2;
        }
        if ((t & 0x1) === 0) r++;
        return r;
    };
    // Return number of used bits in a BN
    BN.prototype.bitLength = function bitLength() {
        var w = this.words[this.length - 1];
        var hi = this._countBits(w);
        return (this.length - 1) * 26 + hi;
    };
    function toBitArray(num) {
        var w = new Array(num.bitLength());
        for(var bit = 0; bit < w.length; bit++){
            var off = bit / 26 | 0;
            var wbit = bit % 26;
            w[bit] = num.words[off] >>> wbit & 0x01;
        }
        return w;
    }
    // Number of trailing zero bits
    BN.prototype.zeroBits = function zeroBits() {
        if (this.isZero()) return 0;
        var r = 0;
        for(var i = 0; i < this.length; i++){
            var b = this._zeroBits(this.words[i]);
            r += b;
            if (b !== 26) break;
        }
        return r;
    };
    BN.prototype.byteLength = function byteLength() {
        return Math.ceil(this.bitLength() / 8);
    };
    BN.prototype.toTwos = function toTwos(width) {
        if (this.negative !== 0) return this.abs().inotn(width).iaddn(1);
        return this.clone();
    };
    BN.prototype.fromTwos = function fromTwos(width) {
        if (this.testn(width - 1)) return this.notn(width).iaddn(1).ineg();
        return this.clone();
    };
    BN.prototype.isNeg = function isNeg() {
        return this.negative !== 0;
    };
    // Return negative clone of `this`
    BN.prototype.neg = function neg() {
        return this.clone().ineg();
    };
    BN.prototype.ineg = function ineg() {
        if (!this.isZero()) this.negative ^= 1;
        return this;
    };
    // Or `num` with `this` in-place
    BN.prototype.iuor = function iuor(num) {
        while(this.length < num.length)this.words[this.length++] = 0;
        for(var i = 0; i < num.length; i++)this.words[i] = this.words[i] | num.words[i];
        return this._strip();
    };
    BN.prototype.ior = function ior(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuor(num);
    };
    // Or `num` with `this`
    BN.prototype.or = function or(num) {
        if (this.length > num.length) return this.clone().ior(num);
        return num.clone().ior(this);
    };
    BN.prototype.uor = function uor(num) {
        if (this.length > num.length) return this.clone().iuor(num);
        return num.clone().iuor(this);
    };
    // And `num` with `this` in-place
    BN.prototype.iuand = function iuand(num) {
        // b = min-length(num, this)
        var b;
        if (this.length > num.length) b = num;
        else b = this;
        for(var i = 0; i < b.length; i++)this.words[i] = this.words[i] & num.words[i];
        this.length = b.length;
        return this._strip();
    };
    BN.prototype.iand = function iand(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuand(num);
    };
    // And `num` with `this`
    BN.prototype.and = function and(num) {
        if (this.length > num.length) return this.clone().iand(num);
        return num.clone().iand(this);
    };
    BN.prototype.uand = function uand(num) {
        if (this.length > num.length) return this.clone().iuand(num);
        return num.clone().iuand(this);
    };
    // Xor `num` with `this` in-place
    BN.prototype.iuxor = function iuxor(num) {
        // a.length > b.length
        var a;
        var b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        for(var i = 0; i < b.length; i++)this.words[i] = a.words[i] ^ b.words[i];
        if (this !== a) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = a.length;
        return this._strip();
    };
    BN.prototype.ixor = function ixor(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuxor(num);
    };
    // Xor `num` with `this`
    BN.prototype.xor = function xor(num) {
        if (this.length > num.length) return this.clone().ixor(num);
        return num.clone().ixor(this);
    };
    BN.prototype.uxor = function uxor(num) {
        if (this.length > num.length) return this.clone().iuxor(num);
        return num.clone().iuxor(this);
    };
    // Not ``this`` with ``width`` bitwidth
    BN.prototype.inotn = function inotn(width) {
        assert(typeof width === "number" && width >= 0);
        var bytesNeeded = Math.ceil(width / 26) | 0;
        var bitsLeft = width % 26;
        // Extend the buffer with leading zeroes
        this._expand(bytesNeeded);
        if (bitsLeft > 0) bytesNeeded--;
        // Handle complete words
        for(var i = 0; i < bytesNeeded; i++)this.words[i] = ~this.words[i] & 0x3ffffff;
        // Handle the residue
        if (bitsLeft > 0) this.words[i] = ~this.words[i] & 0x3ffffff >> 26 - bitsLeft;
        // And remove leading zeroes
        return this._strip();
    };
    BN.prototype.notn = function notn(width) {
        return this.clone().inotn(width);
    };
    // Set `bit` of `this`
    BN.prototype.setn = function setn(bit, val) {
        assert(typeof bit === "number" && bit >= 0);
        var off = bit / 26 | 0;
        var wbit = bit % 26;
        this._expand(off + 1);
        if (val) this.words[off] = this.words[off] | 1 << wbit;
        else this.words[off] = this.words[off] & ~(1 << wbit);
        return this._strip();
    };
    // Add `num` to `this` in-place
    BN.prototype.iadd = function iadd(num) {
        var r;
        // negative + positive
        if (this.negative !== 0 && num.negative === 0) {
            this.negative = 0;
            r = this.isub(num);
            this.negative ^= 1;
            return this._normSign();
        // positive + negative
        } else if (this.negative === 0 && num.negative !== 0) {
            num.negative = 0;
            r = this.isub(num);
            num.negative = 1;
            return r._normSign();
        }
        // a.length > b.length
        var a, b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        this.length = a.length;
        if (carry !== 0) {
            this.words[this.length] = carry;
            this.length++;
        // Copy the rest of the words
        } else if (a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        return this;
    };
    // Add `num` to `this`
    BN.prototype.add = function add(num) {
        var res;
        if (num.negative !== 0 && this.negative === 0) {
            num.negative = 0;
            res = this.sub(num);
            num.negative ^= 1;
            return res;
        } else if (num.negative === 0 && this.negative !== 0) {
            this.negative = 0;
            res = num.sub(this);
            this.negative = 1;
            return res;
        }
        if (this.length > num.length) return this.clone().iadd(num);
        return num.clone().iadd(this);
    };
    // Subtract `num` from `this` in-place
    BN.prototype.isub = function isub(num) {
        // this - (-num) = this + num
        if (num.negative !== 0) {
            num.negative = 0;
            var r = this.iadd(num);
            num.negative = 1;
            return r._normSign();
        // -this - num = -(this + num)
        } else if (this.negative !== 0) {
            this.negative = 0;
            this.iadd(num);
            this.negative = 1;
            return this._normSign();
        }
        // At this point both numbers are positive
        var cmp = this.cmp(num);
        // Optimization - zeroify
        if (cmp === 0) {
            this.negative = 0;
            this.length = 1;
            this.words[0] = 0;
            return this;
        }
        // a > b
        var a, b;
        if (cmp > 0) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        // Copy rest of the words
        if (carry === 0 && i < a.length && a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = Math.max(this.length, i);
        if (a !== this) this.negative = 1;
        return this._strip();
    };
    // Subtract `num` from `this`
    BN.prototype.sub = function sub(num) {
        return this.clone().isub(num);
    };
    function smallMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        var len = self.length + num.length | 0;
        out.length = len;
        len = len - 1 | 0;
        // Peel one iteration (compiler can't do it, because of code complexity)
        var a = self.words[0] | 0;
        var b = num.words[0] | 0;
        var r = a * b;
        var lo = r & 0x3ffffff;
        var carry = r / 0x4000000 | 0;
        out.words[0] = lo;
        for(var k = 1; k < len; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = carry >>> 26;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j | 0;
                a = self.words[i] | 0;
                b = num.words[j] | 0;
                r = a * b + rword;
                ncarry += r / 0x4000000 | 0;
                rword = r & 0x3ffffff;
            }
            out.words[k] = rword | 0;
            carry = ncarry | 0;
        }
        if (carry !== 0) out.words[k] = carry | 0;
        else out.length--;
        return out._strip();
    }
    // TODO(indutny): it may be reasonable to omit it for users who don't need
    // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
    // multiplication (like elliptic secp256k1).
    var comb10MulTo = function comb10MulTo(self, num, out) {
        var a = self.words;
        var b = num.words;
        var o = out.words;
        var c = 0;
        var lo;
        var mid;
        var hi;
        var a0 = a[0] | 0;
        var al0 = a0 & 0x1fff;
        var ah0 = a0 >>> 13;
        var a1 = a[1] | 0;
        var al1 = a1 & 0x1fff;
        var ah1 = a1 >>> 13;
        var a2 = a[2] | 0;
        var al2 = a2 & 0x1fff;
        var ah2 = a2 >>> 13;
        var a3 = a[3] | 0;
        var al3 = a3 & 0x1fff;
        var ah3 = a3 >>> 13;
        var a4 = a[4] | 0;
        var al4 = a4 & 0x1fff;
        var ah4 = a4 >>> 13;
        var a5 = a[5] | 0;
        var al5 = a5 & 0x1fff;
        var ah5 = a5 >>> 13;
        var a6 = a[6] | 0;
        var al6 = a6 & 0x1fff;
        var ah6 = a6 >>> 13;
        var a7 = a[7] | 0;
        var al7 = a7 & 0x1fff;
        var ah7 = a7 >>> 13;
        var a8 = a[8] | 0;
        var al8 = a8 & 0x1fff;
        var ah8 = a8 >>> 13;
        var a9 = a[9] | 0;
        var al9 = a9 & 0x1fff;
        var ah9 = a9 >>> 13;
        var b0 = b[0] | 0;
        var bl0 = b0 & 0x1fff;
        var bh0 = b0 >>> 13;
        var b1 = b[1] | 0;
        var bl1 = b1 & 0x1fff;
        var bh1 = b1 >>> 13;
        var b2 = b[2] | 0;
        var bl2 = b2 & 0x1fff;
        var bh2 = b2 >>> 13;
        var b3 = b[3] | 0;
        var bl3 = b3 & 0x1fff;
        var bh3 = b3 >>> 13;
        var b4 = b[4] | 0;
        var bl4 = b4 & 0x1fff;
        var bh4 = b4 >>> 13;
        var b5 = b[5] | 0;
        var bl5 = b5 & 0x1fff;
        var bh5 = b5 >>> 13;
        var b6 = b[6] | 0;
        var bl6 = b6 & 0x1fff;
        var bh6 = b6 >>> 13;
        var b7 = b[7] | 0;
        var bl7 = b7 & 0x1fff;
        var bh7 = b7 >>> 13;
        var b8 = b[8] | 0;
        var bl8 = b8 & 0x1fff;
        var bh8 = b8 >>> 13;
        var b9 = b[9] | 0;
        var bl9 = b9 & 0x1fff;
        var bh9 = b9 >>> 13;
        out.negative = self.negative ^ num.negative;
        out.length = 19;
        /* k = 0 */ lo = Math.imul(al0, bl0);
        mid = Math.imul(al0, bh0);
        mid = mid + Math.imul(ah0, bl0) | 0;
        hi = Math.imul(ah0, bh0);
        var w0 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
        w0 &= 0x3ffffff;
        /* k = 1 */ lo = Math.imul(al1, bl0);
        mid = Math.imul(al1, bh0);
        mid = mid + Math.imul(ah1, bl0) | 0;
        hi = Math.imul(ah1, bh0);
        lo = lo + Math.imul(al0, bl1) | 0;
        mid = mid + Math.imul(al0, bh1) | 0;
        mid = mid + Math.imul(ah0, bl1) | 0;
        hi = hi + Math.imul(ah0, bh1) | 0;
        var w1 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
        w1 &= 0x3ffffff;
        /* k = 2 */ lo = Math.imul(al2, bl0);
        mid = Math.imul(al2, bh0);
        mid = mid + Math.imul(ah2, bl0) | 0;
        hi = Math.imul(ah2, bh0);
        lo = lo + Math.imul(al1, bl1) | 0;
        mid = mid + Math.imul(al1, bh1) | 0;
        mid = mid + Math.imul(ah1, bl1) | 0;
        hi = hi + Math.imul(ah1, bh1) | 0;
        lo = lo + Math.imul(al0, bl2) | 0;
        mid = mid + Math.imul(al0, bh2) | 0;
        mid = mid + Math.imul(ah0, bl2) | 0;
        hi = hi + Math.imul(ah0, bh2) | 0;
        var w2 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
        w2 &= 0x3ffffff;
        /* k = 3 */ lo = Math.imul(al3, bl0);
        mid = Math.imul(al3, bh0);
        mid = mid + Math.imul(ah3, bl0) | 0;
        hi = Math.imul(ah3, bh0);
        lo = lo + Math.imul(al2, bl1) | 0;
        mid = mid + Math.imul(al2, bh1) | 0;
        mid = mid + Math.imul(ah2, bl1) | 0;
        hi = hi + Math.imul(ah2, bh1) | 0;
        lo = lo + Math.imul(al1, bl2) | 0;
        mid = mid + Math.imul(al1, bh2) | 0;
        mid = mid + Math.imul(ah1, bl2) | 0;
        hi = hi + Math.imul(ah1, bh2) | 0;
        lo = lo + Math.imul(al0, bl3) | 0;
        mid = mid + Math.imul(al0, bh3) | 0;
        mid = mid + Math.imul(ah0, bl3) | 0;
        hi = hi + Math.imul(ah0, bh3) | 0;
        var w3 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
        w3 &= 0x3ffffff;
        /* k = 4 */ lo = Math.imul(al4, bl0);
        mid = Math.imul(al4, bh0);
        mid = mid + Math.imul(ah4, bl0) | 0;
        hi = Math.imul(ah4, bh0);
        lo = lo + Math.imul(al3, bl1) | 0;
        mid = mid + Math.imul(al3, bh1) | 0;
        mid = mid + Math.imul(ah3, bl1) | 0;
        hi = hi + Math.imul(ah3, bh1) | 0;
        lo = lo + Math.imul(al2, bl2) | 0;
        mid = mid + Math.imul(al2, bh2) | 0;
        mid = mid + Math.imul(ah2, bl2) | 0;
        hi = hi + Math.imul(ah2, bh2) | 0;
        lo = lo + Math.imul(al1, bl3) | 0;
        mid = mid + Math.imul(al1, bh3) | 0;
        mid = mid + Math.imul(ah1, bl3) | 0;
        hi = hi + Math.imul(ah1, bh3) | 0;
        lo = lo + Math.imul(al0, bl4) | 0;
        mid = mid + Math.imul(al0, bh4) | 0;
        mid = mid + Math.imul(ah0, bl4) | 0;
        hi = hi + Math.imul(ah0, bh4) | 0;
        var w4 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
        w4 &= 0x3ffffff;
        /* k = 5 */ lo = Math.imul(al5, bl0);
        mid = Math.imul(al5, bh0);
        mid = mid + Math.imul(ah5, bl0) | 0;
        hi = Math.imul(ah5, bh0);
        lo = lo + Math.imul(al4, bl1) | 0;
        mid = mid + Math.imul(al4, bh1) | 0;
        mid = mid + Math.imul(ah4, bl1) | 0;
        hi = hi + Math.imul(ah4, bh1) | 0;
        lo = lo + Math.imul(al3, bl2) | 0;
        mid = mid + Math.imul(al3, bh2) | 0;
        mid = mid + Math.imul(ah3, bl2) | 0;
        hi = hi + Math.imul(ah3, bh2) | 0;
        lo = lo + Math.imul(al2, bl3) | 0;
        mid = mid + Math.imul(al2, bh3) | 0;
        mid = mid + Math.imul(ah2, bl3) | 0;
        hi = hi + Math.imul(ah2, bh3) | 0;
        lo = lo + Math.imul(al1, bl4) | 0;
        mid = mid + Math.imul(al1, bh4) | 0;
        mid = mid + Math.imul(ah1, bl4) | 0;
        hi = hi + Math.imul(ah1, bh4) | 0;
        lo = lo + Math.imul(al0, bl5) | 0;
        mid = mid + Math.imul(al0, bh5) | 0;
        mid = mid + Math.imul(ah0, bl5) | 0;
        hi = hi + Math.imul(ah0, bh5) | 0;
        var w5 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
        w5 &= 0x3ffffff;
        /* k = 6 */ lo = Math.imul(al6, bl0);
        mid = Math.imul(al6, bh0);
        mid = mid + Math.imul(ah6, bl0) | 0;
        hi = Math.imul(ah6, bh0);
        lo = lo + Math.imul(al5, bl1) | 0;
        mid = mid + Math.imul(al5, bh1) | 0;
        mid = mid + Math.imul(ah5, bl1) | 0;
        hi = hi + Math.imul(ah5, bh1) | 0;
        lo = lo + Math.imul(al4, bl2) | 0;
        mid = mid + Math.imul(al4, bh2) | 0;
        mid = mid + Math.imul(ah4, bl2) | 0;
        hi = hi + Math.imul(ah4, bh2) | 0;
        lo = lo + Math.imul(al3, bl3) | 0;
        mid = mid + Math.imul(al3, bh3) | 0;
        mid = mid + Math.imul(ah3, bl3) | 0;
        hi = hi + Math.imul(ah3, bh3) | 0;
        lo = lo + Math.imul(al2, bl4) | 0;
        mid = mid + Math.imul(al2, bh4) | 0;
        mid = mid + Math.imul(ah2, bl4) | 0;
        hi = hi + Math.imul(ah2, bh4) | 0;
        lo = lo + Math.imul(al1, bl5) | 0;
        mid = mid + Math.imul(al1, bh5) | 0;
        mid = mid + Math.imul(ah1, bl5) | 0;
        hi = hi + Math.imul(ah1, bh5) | 0;
        lo = lo + Math.imul(al0, bl6) | 0;
        mid = mid + Math.imul(al0, bh6) | 0;
        mid = mid + Math.imul(ah0, bl6) | 0;
        hi = hi + Math.imul(ah0, bh6) | 0;
        var w6 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
        w6 &= 0x3ffffff;
        /* k = 7 */ lo = Math.imul(al7, bl0);
        mid = Math.imul(al7, bh0);
        mid = mid + Math.imul(ah7, bl0) | 0;
        hi = Math.imul(ah7, bh0);
        lo = lo + Math.imul(al6, bl1) | 0;
        mid = mid + Math.imul(al6, bh1) | 0;
        mid = mid + Math.imul(ah6, bl1) | 0;
        hi = hi + Math.imul(ah6, bh1) | 0;
        lo = lo + Math.imul(al5, bl2) | 0;
        mid = mid + Math.imul(al5, bh2) | 0;
        mid = mid + Math.imul(ah5, bl2) | 0;
        hi = hi + Math.imul(ah5, bh2) | 0;
        lo = lo + Math.imul(al4, bl3) | 0;
        mid = mid + Math.imul(al4, bh3) | 0;
        mid = mid + Math.imul(ah4, bl3) | 0;
        hi = hi + Math.imul(ah4, bh3) | 0;
        lo = lo + Math.imul(al3, bl4) | 0;
        mid = mid + Math.imul(al3, bh4) | 0;
        mid = mid + Math.imul(ah3, bl4) | 0;
        hi = hi + Math.imul(ah3, bh4) | 0;
        lo = lo + Math.imul(al2, bl5) | 0;
        mid = mid + Math.imul(al2, bh5) | 0;
        mid = mid + Math.imul(ah2, bl5) | 0;
        hi = hi + Math.imul(ah2, bh5) | 0;
        lo = lo + Math.imul(al1, bl6) | 0;
        mid = mid + Math.imul(al1, bh6) | 0;
        mid = mid + Math.imul(ah1, bl6) | 0;
        hi = hi + Math.imul(ah1, bh6) | 0;
        lo = lo + Math.imul(al0, bl7) | 0;
        mid = mid + Math.imul(al0, bh7) | 0;
        mid = mid + Math.imul(ah0, bl7) | 0;
        hi = hi + Math.imul(ah0, bh7) | 0;
        var w7 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
        w7 &= 0x3ffffff;
        /* k = 8 */ lo = Math.imul(al8, bl0);
        mid = Math.imul(al8, bh0);
        mid = mid + Math.imul(ah8, bl0) | 0;
        hi = Math.imul(ah8, bh0);
        lo = lo + Math.imul(al7, bl1) | 0;
        mid = mid + Math.imul(al7, bh1) | 0;
        mid = mid + Math.imul(ah7, bl1) | 0;
        hi = hi + Math.imul(ah7, bh1) | 0;
        lo = lo + Math.imul(al6, bl2) | 0;
        mid = mid + Math.imul(al6, bh2) | 0;
        mid = mid + Math.imul(ah6, bl2) | 0;
        hi = hi + Math.imul(ah6, bh2) | 0;
        lo = lo + Math.imul(al5, bl3) | 0;
        mid = mid + Math.imul(al5, bh3) | 0;
        mid = mid + Math.imul(ah5, bl3) | 0;
        hi = hi + Math.imul(ah5, bh3) | 0;
        lo = lo + Math.imul(al4, bl4) | 0;
        mid = mid + Math.imul(al4, bh4) | 0;
        mid = mid + Math.imul(ah4, bl4) | 0;
        hi = hi + Math.imul(ah4, bh4) | 0;
        lo = lo + Math.imul(al3, bl5) | 0;
        mid = mid + Math.imul(al3, bh5) | 0;
        mid = mid + Math.imul(ah3, bl5) | 0;
        hi = hi + Math.imul(ah3, bh5) | 0;
        lo = lo + Math.imul(al2, bl6) | 0;
        mid = mid + Math.imul(al2, bh6) | 0;
        mid = mid + Math.imul(ah2, bl6) | 0;
        hi = hi + Math.imul(ah2, bh6) | 0;
        lo = lo + Math.imul(al1, bl7) | 0;
        mid = mid + Math.imul(al1, bh7) | 0;
        mid = mid + Math.imul(ah1, bl7) | 0;
        hi = hi + Math.imul(ah1, bh7) | 0;
        lo = lo + Math.imul(al0, bl8) | 0;
        mid = mid + Math.imul(al0, bh8) | 0;
        mid = mid + Math.imul(ah0, bl8) | 0;
        hi = hi + Math.imul(ah0, bh8) | 0;
        var w8 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
        w8 &= 0x3ffffff;
        /* k = 9 */ lo = Math.imul(al9, bl0);
        mid = Math.imul(al9, bh0);
        mid = mid + Math.imul(ah9, bl0) | 0;
        hi = Math.imul(ah9, bh0);
        lo = lo + Math.imul(al8, bl1) | 0;
        mid = mid + Math.imul(al8, bh1) | 0;
        mid = mid + Math.imul(ah8, bl1) | 0;
        hi = hi + Math.imul(ah8, bh1) | 0;
        lo = lo + Math.imul(al7, bl2) | 0;
        mid = mid + Math.imul(al7, bh2) | 0;
        mid = mid + Math.imul(ah7, bl2) | 0;
        hi = hi + Math.imul(ah7, bh2) | 0;
        lo = lo + Math.imul(al6, bl3) | 0;
        mid = mid + Math.imul(al6, bh3) | 0;
        mid = mid + Math.imul(ah6, bl3) | 0;
        hi = hi + Math.imul(ah6, bh3) | 0;
        lo = lo + Math.imul(al5, bl4) | 0;
        mid = mid + Math.imul(al5, bh4) | 0;
        mid = mid + Math.imul(ah5, bl4) | 0;
        hi = hi + Math.imul(ah5, bh4) | 0;
        lo = lo + Math.imul(al4, bl5) | 0;
        mid = mid + Math.imul(al4, bh5) | 0;
        mid = mid + Math.imul(ah4, bl5) | 0;
        hi = hi + Math.imul(ah4, bh5) | 0;
        lo = lo + Math.imul(al3, bl6) | 0;
        mid = mid + Math.imul(al3, bh6) | 0;
        mid = mid + Math.imul(ah3, bl6) | 0;
        hi = hi + Math.imul(ah3, bh6) | 0;
        lo = lo + Math.imul(al2, bl7) | 0;
        mid = mid + Math.imul(al2, bh7) | 0;
        mid = mid + Math.imul(ah2, bl7) | 0;
        hi = hi + Math.imul(ah2, bh7) | 0;
        lo = lo + Math.imul(al1, bl8) | 0;
        mid = mid + Math.imul(al1, bh8) | 0;
        mid = mid + Math.imul(ah1, bl8) | 0;
        hi = hi + Math.imul(ah1, bh8) | 0;
        lo = lo + Math.imul(al0, bl9) | 0;
        mid = mid + Math.imul(al0, bh9) | 0;
        mid = mid + Math.imul(ah0, bl9) | 0;
        hi = hi + Math.imul(ah0, bh9) | 0;
        var w9 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
        w9 &= 0x3ffffff;
        /* k = 10 */ lo = Math.imul(al9, bl1);
        mid = Math.imul(al9, bh1);
        mid = mid + Math.imul(ah9, bl1) | 0;
        hi = Math.imul(ah9, bh1);
        lo = lo + Math.imul(al8, bl2) | 0;
        mid = mid + Math.imul(al8, bh2) | 0;
        mid = mid + Math.imul(ah8, bl2) | 0;
        hi = hi + Math.imul(ah8, bh2) | 0;
        lo = lo + Math.imul(al7, bl3) | 0;
        mid = mid + Math.imul(al7, bh3) | 0;
        mid = mid + Math.imul(ah7, bl3) | 0;
        hi = hi + Math.imul(ah7, bh3) | 0;
        lo = lo + Math.imul(al6, bl4) | 0;
        mid = mid + Math.imul(al6, bh4) | 0;
        mid = mid + Math.imul(ah6, bl4) | 0;
        hi = hi + Math.imul(ah6, bh4) | 0;
        lo = lo + Math.imul(al5, bl5) | 0;
        mid = mid + Math.imul(al5, bh5) | 0;
        mid = mid + Math.imul(ah5, bl5) | 0;
        hi = hi + Math.imul(ah5, bh5) | 0;
        lo = lo + Math.imul(al4, bl6) | 0;
        mid = mid + Math.imul(al4, bh6) | 0;
        mid = mid + Math.imul(ah4, bl6) | 0;
        hi = hi + Math.imul(ah4, bh6) | 0;
        lo = lo + Math.imul(al3, bl7) | 0;
        mid = mid + Math.imul(al3, bh7) | 0;
        mid = mid + Math.imul(ah3, bl7) | 0;
        hi = hi + Math.imul(ah3, bh7) | 0;
        lo = lo + Math.imul(al2, bl8) | 0;
        mid = mid + Math.imul(al2, bh8) | 0;
        mid = mid + Math.imul(ah2, bl8) | 0;
        hi = hi + Math.imul(ah2, bh8) | 0;
        lo = lo + Math.imul(al1, bl9) | 0;
        mid = mid + Math.imul(al1, bh9) | 0;
        mid = mid + Math.imul(ah1, bl9) | 0;
        hi = hi + Math.imul(ah1, bh9) | 0;
        var w10 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
        w10 &= 0x3ffffff;
        /* k = 11 */ lo = Math.imul(al9, bl2);
        mid = Math.imul(al9, bh2);
        mid = mid + Math.imul(ah9, bl2) | 0;
        hi = Math.imul(ah9, bh2);
        lo = lo + Math.imul(al8, bl3) | 0;
        mid = mid + Math.imul(al8, bh3) | 0;
        mid = mid + Math.imul(ah8, bl3) | 0;
        hi = hi + Math.imul(ah8, bh3) | 0;
        lo = lo + Math.imul(al7, bl4) | 0;
        mid = mid + Math.imul(al7, bh4) | 0;
        mid = mid + Math.imul(ah7, bl4) | 0;
        hi = hi + Math.imul(ah7, bh4) | 0;
        lo = lo + Math.imul(al6, bl5) | 0;
        mid = mid + Math.imul(al6, bh5) | 0;
        mid = mid + Math.imul(ah6, bl5) | 0;
        hi = hi + Math.imul(ah6, bh5) | 0;
        lo = lo + Math.imul(al5, bl6) | 0;
        mid = mid + Math.imul(al5, bh6) | 0;
        mid = mid + Math.imul(ah5, bl6) | 0;
        hi = hi + Math.imul(ah5, bh6) | 0;
        lo = lo + Math.imul(al4, bl7) | 0;
        mid = mid + Math.imul(al4, bh7) | 0;
        mid = mid + Math.imul(ah4, bl7) | 0;
        hi = hi + Math.imul(ah4, bh7) | 0;
        lo = lo + Math.imul(al3, bl8) | 0;
        mid = mid + Math.imul(al3, bh8) | 0;
        mid = mid + Math.imul(ah3, bl8) | 0;
        hi = hi + Math.imul(ah3, bh8) | 0;
        lo = lo + Math.imul(al2, bl9) | 0;
        mid = mid + Math.imul(al2, bh9) | 0;
        mid = mid + Math.imul(ah2, bl9) | 0;
        hi = hi + Math.imul(ah2, bh9) | 0;
        var w11 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
        w11 &= 0x3ffffff;
        /* k = 12 */ lo = Math.imul(al9, bl3);
        mid = Math.imul(al9, bh3);
        mid = mid + Math.imul(ah9, bl3) | 0;
        hi = Math.imul(ah9, bh3);
        lo = lo + Math.imul(al8, bl4) | 0;
        mid = mid + Math.imul(al8, bh4) | 0;
        mid = mid + Math.imul(ah8, bl4) | 0;
        hi = hi + Math.imul(ah8, bh4) | 0;
        lo = lo + Math.imul(al7, bl5) | 0;
        mid = mid + Math.imul(al7, bh5) | 0;
        mid = mid + Math.imul(ah7, bl5) | 0;
        hi = hi + Math.imul(ah7, bh5) | 0;
        lo = lo + Math.imul(al6, bl6) | 0;
        mid = mid + Math.imul(al6, bh6) | 0;
        mid = mid + Math.imul(ah6, bl6) | 0;
        hi = hi + Math.imul(ah6, bh6) | 0;
        lo = lo + Math.imul(al5, bl7) | 0;
        mid = mid + Math.imul(al5, bh7) | 0;
        mid = mid + Math.imul(ah5, bl7) | 0;
        hi = hi + Math.imul(ah5, bh7) | 0;
        lo = lo + Math.imul(al4, bl8) | 0;
        mid = mid + Math.imul(al4, bh8) | 0;
        mid = mid + Math.imul(ah4, bl8) | 0;
        hi = hi + Math.imul(ah4, bh8) | 0;
        lo = lo + Math.imul(al3, bl9) | 0;
        mid = mid + Math.imul(al3, bh9) | 0;
        mid = mid + Math.imul(ah3, bl9) | 0;
        hi = hi + Math.imul(ah3, bh9) | 0;
        var w12 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
        w12 &= 0x3ffffff;
        /* k = 13 */ lo = Math.imul(al9, bl4);
        mid = Math.imul(al9, bh4);
        mid = mid + Math.imul(ah9, bl4) | 0;
        hi = Math.imul(ah9, bh4);
        lo = lo + Math.imul(al8, bl5) | 0;
        mid = mid + Math.imul(al8, bh5) | 0;
        mid = mid + Math.imul(ah8, bl5) | 0;
        hi = hi + Math.imul(ah8, bh5) | 0;
        lo = lo + Math.imul(al7, bl6) | 0;
        mid = mid + Math.imul(al7, bh6) | 0;
        mid = mid + Math.imul(ah7, bl6) | 0;
        hi = hi + Math.imul(ah7, bh6) | 0;
        lo = lo + Math.imul(al6, bl7) | 0;
        mid = mid + Math.imul(al6, bh7) | 0;
        mid = mid + Math.imul(ah6, bl7) | 0;
        hi = hi + Math.imul(ah6, bh7) | 0;
        lo = lo + Math.imul(al5, bl8) | 0;
        mid = mid + Math.imul(al5, bh8) | 0;
        mid = mid + Math.imul(ah5, bl8) | 0;
        hi = hi + Math.imul(ah5, bh8) | 0;
        lo = lo + Math.imul(al4, bl9) | 0;
        mid = mid + Math.imul(al4, bh9) | 0;
        mid = mid + Math.imul(ah4, bl9) | 0;
        hi = hi + Math.imul(ah4, bh9) | 0;
        var w13 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
        w13 &= 0x3ffffff;
        /* k = 14 */ lo = Math.imul(al9, bl5);
        mid = Math.imul(al9, bh5);
        mid = mid + Math.imul(ah9, bl5) | 0;
        hi = Math.imul(ah9, bh5);
        lo = lo + Math.imul(al8, bl6) | 0;
        mid = mid + Math.imul(al8, bh6) | 0;
        mid = mid + Math.imul(ah8, bl6) | 0;
        hi = hi + Math.imul(ah8, bh6) | 0;
        lo = lo + Math.imul(al7, bl7) | 0;
        mid = mid + Math.imul(al7, bh7) | 0;
        mid = mid + Math.imul(ah7, bl7) | 0;
        hi = hi + Math.imul(ah7, bh7) | 0;
        lo = lo + Math.imul(al6, bl8) | 0;
        mid = mid + Math.imul(al6, bh8) | 0;
        mid = mid + Math.imul(ah6, bl8) | 0;
        hi = hi + Math.imul(ah6, bh8) | 0;
        lo = lo + Math.imul(al5, bl9) | 0;
        mid = mid + Math.imul(al5, bh9) | 0;
        mid = mid + Math.imul(ah5, bl9) | 0;
        hi = hi + Math.imul(ah5, bh9) | 0;
        var w14 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
        w14 &= 0x3ffffff;
        /* k = 15 */ lo = Math.imul(al9, bl6);
        mid = Math.imul(al9, bh6);
        mid = mid + Math.imul(ah9, bl6) | 0;
        hi = Math.imul(ah9, bh6);
        lo = lo + Math.imul(al8, bl7) | 0;
        mid = mid + Math.imul(al8, bh7) | 0;
        mid = mid + Math.imul(ah8, bl7) | 0;
        hi = hi + Math.imul(ah8, bh7) | 0;
        lo = lo + Math.imul(al7, bl8) | 0;
        mid = mid + Math.imul(al7, bh8) | 0;
        mid = mid + Math.imul(ah7, bl8) | 0;
        hi = hi + Math.imul(ah7, bh8) | 0;
        lo = lo + Math.imul(al6, bl9) | 0;
        mid = mid + Math.imul(al6, bh9) | 0;
        mid = mid + Math.imul(ah6, bl9) | 0;
        hi = hi + Math.imul(ah6, bh9) | 0;
        var w15 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
        w15 &= 0x3ffffff;
        /* k = 16 */ lo = Math.imul(al9, bl7);
        mid = Math.imul(al9, bh7);
        mid = mid + Math.imul(ah9, bl7) | 0;
        hi = Math.imul(ah9, bh7);
        lo = lo + Math.imul(al8, bl8) | 0;
        mid = mid + Math.imul(al8, bh8) | 0;
        mid = mid + Math.imul(ah8, bl8) | 0;
        hi = hi + Math.imul(ah8, bh8) | 0;
        lo = lo + Math.imul(al7, bl9) | 0;
        mid = mid + Math.imul(al7, bh9) | 0;
        mid = mid + Math.imul(ah7, bl9) | 0;
        hi = hi + Math.imul(ah7, bh9) | 0;
        var w16 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
        w16 &= 0x3ffffff;
        /* k = 17 */ lo = Math.imul(al9, bl8);
        mid = Math.imul(al9, bh8);
        mid = mid + Math.imul(ah9, bl8) | 0;
        hi = Math.imul(ah9, bh8);
        lo = lo + Math.imul(al8, bl9) | 0;
        mid = mid + Math.imul(al8, bh9) | 0;
        mid = mid + Math.imul(ah8, bl9) | 0;
        hi = hi + Math.imul(ah8, bh9) | 0;
        var w17 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
        w17 &= 0x3ffffff;
        /* k = 18 */ lo = Math.imul(al9, bl9);
        mid = Math.imul(al9, bh9);
        mid = mid + Math.imul(ah9, bl9) | 0;
        hi = Math.imul(ah9, bh9);
        var w18 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
        w18 &= 0x3ffffff;
        o[0] = w0;
        o[1] = w1;
        o[2] = w2;
        o[3] = w3;
        o[4] = w4;
        o[5] = w5;
        o[6] = w6;
        o[7] = w7;
        o[8] = w8;
        o[9] = w9;
        o[10] = w10;
        o[11] = w11;
        o[12] = w12;
        o[13] = w13;
        o[14] = w14;
        o[15] = w15;
        o[16] = w16;
        o[17] = w17;
        o[18] = w18;
        if (c !== 0) {
            o[19] = c;
            out.length++;
        }
        return out;
    };
    // Polyfill comb
    if (!Math.imul) comb10MulTo = smallMulTo;
    function bigMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        out.length = self.length + num.length;
        var carry = 0;
        var hncarry = 0;
        for(var k = 0; k < out.length - 1; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = hncarry;
            hncarry = 0;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j;
                var a = self.words[i] | 0;
                var b = num.words[j] | 0;
                var r = a * b;
                var lo = r & 0x3ffffff;
                ncarry = ncarry + (r / 0x4000000 | 0) | 0;
                lo = lo + rword | 0;
                rword = lo & 0x3ffffff;
                ncarry = ncarry + (lo >>> 26) | 0;
                hncarry += ncarry >>> 26;
                ncarry &= 0x3ffffff;
            }
            out.words[k] = rword;
            carry = ncarry;
            ncarry = hncarry;
        }
        if (carry !== 0) out.words[k] = carry;
        else out.length--;
        return out._strip();
    }
    function jumboMulTo(self, num, out) {
        // Temporary disable, see https://github.com/indutny/bn.js/issues/211
        // var fftm = new FFTM();
        // return fftm.mulp(self, num, out);
        return bigMulTo(self, num, out);
    }
    BN.prototype.mulTo = function mulTo(num, out) {
        var res;
        var len = this.length + num.length;
        if (this.length === 10 && num.length === 10) res = comb10MulTo(this, num, out);
        else if (len < 63) res = smallMulTo(this, num, out);
        else if (len < 1024) res = bigMulTo(this, num, out);
        else res = jumboMulTo(this, num, out);
        return res;
    };
    // Cooley-Tukey algorithm for FFT
    // slightly revisited to rely on looping instead of recursion
    function FFTM(x, y) {
        this.x = x;
        this.y = y;
    }
    FFTM.prototype.makeRBT = function makeRBT(N) {
        var t = new Array(N);
        var l = BN.prototype._countBits(N) - 1;
        for(var i = 0; i < N; i++)t[i] = this.revBin(i, l, N);
        return t;
    };
    // Returns binary-reversed representation of `x`
    FFTM.prototype.revBin = function revBin(x, l, N) {
        if (x === 0 || x === N - 1) return x;
        var rb = 0;
        for(var i = 0; i < l; i++){
            rb |= (x & 1) << l - i - 1;
            x >>= 1;
        }
        return rb;
    };
    // Performs "tweedling" phase, therefore 'emulating'
    // behaviour of the recursive algorithm
    FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
        for(var i = 0; i < N; i++){
            rtws[i] = rws[rbt[i]];
            itws[i] = iws[rbt[i]];
        }
    };
    FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
        this.permute(rbt, rws, iws, rtws, itws, N);
        for(var s = 1; s < N; s <<= 1){
            var l = s << 1;
            var rtwdf = Math.cos(2 * Math.PI / l);
            var itwdf = Math.sin(2 * Math.PI / l);
            for(var p = 0; p < N; p += l){
                var rtwdf_ = rtwdf;
                var itwdf_ = itwdf;
                for(var j = 0; j < s; j++){
                    var re = rtws[p + j];
                    var ie = itws[p + j];
                    var ro = rtws[p + j + s];
                    var io = itws[p + j + s];
                    var rx = rtwdf_ * ro - itwdf_ * io;
                    io = rtwdf_ * io + itwdf_ * ro;
                    ro = rx;
                    rtws[p + j] = re + ro;
                    itws[p + j] = ie + io;
                    rtws[p + j + s] = re - ro;
                    itws[p + j + s] = ie - io;
                    /* jshint maxdepth : false */ if (j !== l) {
                        rx = rtwdf * rtwdf_ - itwdf * itwdf_;
                        itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                        rtwdf_ = rx;
                    }
                }
            }
        }
    };
    FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
        var N = Math.max(m, n) | 1;
        var odd = N & 1;
        var i = 0;
        for(N = N / 2 | 0; N; N = N >>> 1)i++;
        return 1 << i + 1 + odd;
    };
    FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
        if (N <= 1) return;
        for(var i = 0; i < N / 2; i++){
            var t = rws[i];
            rws[i] = rws[N - i - 1];
            rws[N - i - 1] = t;
            t = iws[i];
            iws[i] = -iws[N - i - 1];
            iws[N - i - 1] = -t;
        }
    };
    FFTM.prototype.normalize13b = function normalize13b(ws, N) {
        var carry = 0;
        for(var i = 0; i < N / 2; i++){
            var w = Math.round(ws[2 * i + 1] / N) * 0x2000 + Math.round(ws[2 * i] / N) + carry;
            ws[i] = w & 0x3ffffff;
            if (w < 0x4000000) carry = 0;
            else carry = w / 0x4000000 | 0;
        }
        return ws;
    };
    FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
        var carry = 0;
        for(var i = 0; i < len; i++){
            carry = carry + (ws[i] | 0);
            rws[2 * i] = carry & 0x1fff;
            carry = carry >>> 13;
            rws[2 * i + 1] = carry & 0x1fff;
            carry = carry >>> 13;
        }
        // Pad with zeroes
        for(i = 2 * len; i < N; ++i)rws[i] = 0;
        assert(carry === 0);
        assert((carry & -8192) === 0);
    };
    FFTM.prototype.stub = function stub(N) {
        var ph = new Array(N);
        for(var i = 0; i < N; i++)ph[i] = 0;
        return ph;
    };
    FFTM.prototype.mulp = function mulp(x, y, out) {
        var N = 2 * this.guessLen13b(x.length, y.length);
        var rbt = this.makeRBT(N);
        var _ = this.stub(N);
        var rws = new Array(N);
        var rwst = new Array(N);
        var iwst = new Array(N);
        var nrws = new Array(N);
        var nrwst = new Array(N);
        var niwst = new Array(N);
        var rmws = out.words;
        rmws.length = N;
        this.convert13b(x.words, x.length, rws, N);
        this.convert13b(y.words, y.length, nrws, N);
        this.transform(rws, _, rwst, iwst, N, rbt);
        this.transform(nrws, _, nrwst, niwst, N, rbt);
        for(var i = 0; i < N; i++){
            var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
            iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
            rwst[i] = rx;
        }
        this.conjugate(rwst, iwst, N);
        this.transform(rwst, iwst, rmws, _, N, rbt);
        this.conjugate(rmws, _, N);
        this.normalize13b(rmws, N);
        out.negative = x.negative ^ y.negative;
        out.length = x.length + y.length;
        return out._strip();
    };
    // Multiply `this` by `num`
    BN.prototype.mul = function mul(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return this.mulTo(num, out);
    };
    // Multiply employing FFT
    BN.prototype.mulf = function mulf(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return jumboMulTo(this, num, out);
    };
    // In-place Multiplication
    BN.prototype.imul = function imul(num) {
        return this.clone().mulTo(num, this);
    };
    BN.prototype.imuln = function imuln(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(typeof num === "number");
        assert(num < 0x4000000);
        // Carry
        var carry = 0;
        for(var i = 0; i < this.length; i++){
            var w = (this.words[i] | 0) * num;
            var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
            carry >>= 26;
            carry += w / 0x4000000 | 0;
            // NOTE: lo is 27bit maximum
            carry += lo >>> 26;
            this.words[i] = lo & 0x3ffffff;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return isNegNum ? this.ineg() : this;
    };
    BN.prototype.muln = function muln(num) {
        return this.clone().imuln(num);
    };
    // `this` * `this`
    BN.prototype.sqr = function sqr() {
        return this.mul(this);
    };
    // `this` * `this` in-place
    BN.prototype.isqr = function isqr() {
        return this.imul(this.clone());
    };
    // Math.pow(`this`, `num`)
    BN.prototype.pow = function pow(num) {
        var w = toBitArray(num);
        if (w.length === 0) return new BN(1);
        // Skip leading zeroes
        var res = this;
        for(var i = 0; i < w.length; i++, res = res.sqr()){
            if (w[i] !== 0) break;
        }
        if (++i < w.length) for(var q = res.sqr(); i < w.length; i++, q = q.sqr()){
            if (w[i] === 0) continue;
            res = res.mul(q);
        }
        return res;
    };
    // Shift-left in-place
    BN.prototype.iushln = function iushln(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        var carryMask = 0x3ffffff >>> 26 - r << 26 - r;
        var i;
        if (r !== 0) {
            var carry = 0;
            for(i = 0; i < this.length; i++){
                var newCarry = this.words[i] & carryMask;
                var c = (this.words[i] | 0) - newCarry << r;
                this.words[i] = c | carry;
                carry = newCarry >>> 26 - r;
            }
            if (carry) {
                this.words[i] = carry;
                this.length++;
            }
        }
        if (s !== 0) {
            for(i = this.length - 1; i >= 0; i--)this.words[i + s] = this.words[i];
            for(i = 0; i < s; i++)this.words[i] = 0;
            this.length += s;
        }
        return this._strip();
    };
    BN.prototype.ishln = function ishln(bits) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushln(bits);
    };
    // Shift-right in-place
    // NOTE: `hint` is a lowest bit before trailing zeroes
    // NOTE: if `extended` is present - it will be filled with destroyed bits
    BN.prototype.iushrn = function iushrn(bits, hint, extended) {
        assert(typeof bits === "number" && bits >= 0);
        var h;
        if (hint) h = (hint - hint % 26) / 26;
        else h = 0;
        var r = bits % 26;
        var s = Math.min((bits - r) / 26, this.length);
        var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
        var maskedWords = extended;
        h -= s;
        h = Math.max(0, h);
        // Extended mode, copy masked part
        if (maskedWords) {
            for(var i = 0; i < s; i++)maskedWords.words[i] = this.words[i];
            maskedWords.length = s;
        }
        if (s === 0) ;
        else if (this.length > s) {
            this.length -= s;
            for(i = 0; i < this.length; i++)this.words[i] = this.words[i + s];
        } else {
            this.words[0] = 0;
            this.length = 1;
        }
        var carry = 0;
        for(i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--){
            var word = this.words[i] | 0;
            this.words[i] = carry << 26 - r | word >>> r;
            carry = word & mask;
        }
        // Push carried bits as a mask
        if (maskedWords && carry !== 0) maskedWords.words[maskedWords.length++] = carry;
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this._strip();
    };
    BN.prototype.ishrn = function ishrn(bits, hint, extended) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushrn(bits, hint, extended);
    };
    // Shift-left
    BN.prototype.shln = function shln(bits) {
        return this.clone().ishln(bits);
    };
    BN.prototype.ushln = function ushln(bits) {
        return this.clone().iushln(bits);
    };
    // Shift-right
    BN.prototype.shrn = function shrn(bits) {
        return this.clone().ishrn(bits);
    };
    BN.prototype.ushrn = function ushrn(bits) {
        return this.clone().iushrn(bits);
    };
    // Test if n bit is set
    BN.prototype.testn = function testn(bit) {
        assert(typeof bit === "number" && bit >= 0);
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) return false;
        // Check bit and return
        var w = this.words[s];
        return !!(w & q);
    };
    // Return only lowers bits of number (in-place)
    BN.prototype.imaskn = function imaskn(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        assert(this.negative === 0, "imaskn works only with positive numbers");
        if (this.length <= s) return this;
        if (r !== 0) s++;
        this.length = Math.min(s, this.length);
        if (r !== 0) {
            var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
            this.words[this.length - 1] &= mask;
        }
        return this._strip();
    };
    // Return only lowers bits of number
    BN.prototype.maskn = function maskn(bits) {
        return this.clone().imaskn(bits);
    };
    // Add plain number `num` to `this`
    BN.prototype.iaddn = function iaddn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.isubn(-num);
        // Possible sign change
        if (this.negative !== 0) {
            if (this.length === 1 && (this.words[0] | 0) <= num) {
                this.words[0] = num - (this.words[0] | 0);
                this.negative = 0;
                return this;
            }
            this.negative = 0;
            this.isubn(num);
            this.negative = 1;
            return this;
        }
        // Add without checks
        return this._iaddn(num);
    };
    BN.prototype._iaddn = function _iaddn(num) {
        this.words[0] += num;
        // Carry
        for(var i = 0; i < this.length && this.words[i] >= 0x4000000; i++){
            this.words[i] -= 0x4000000;
            if (i === this.length - 1) this.words[i + 1] = 1;
            else this.words[i + 1]++;
        }
        this.length = Math.max(this.length, i + 1);
        return this;
    };
    // Subtract plain number `num` from `this`
    BN.prototype.isubn = function isubn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.iaddn(-num);
        if (this.negative !== 0) {
            this.negative = 0;
            this.iaddn(num);
            this.negative = 1;
            return this;
        }
        this.words[0] -= num;
        if (this.length === 1 && this.words[0] < 0) {
            this.words[0] = -this.words[0];
            this.negative = 1;
        } else // Carry
        for(var i = 0; i < this.length && this.words[i] < 0; i++){
            this.words[i] += 0x4000000;
            this.words[i + 1] -= 1;
        }
        return this._strip();
    };
    BN.prototype.addn = function addn(num) {
        return this.clone().iaddn(num);
    };
    BN.prototype.subn = function subn(num) {
        return this.clone().isubn(num);
    };
    BN.prototype.iabs = function iabs() {
        this.negative = 0;
        return this;
    };
    BN.prototype.abs = function abs() {
        return this.clone().iabs();
    };
    BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
        var len = num.length + shift;
        var i;
        this._expand(len);
        var w;
        var carry = 0;
        for(i = 0; i < num.length; i++){
            w = (this.words[i + shift] | 0) + carry;
            var right = (num.words[i] | 0) * mul;
            w -= right & 0x3ffffff;
            carry = (w >> 26) - (right / 0x4000000 | 0);
            this.words[i + shift] = w & 0x3ffffff;
        }
        for(; i < this.length - shift; i++){
            w = (this.words[i + shift] | 0) + carry;
            carry = w >> 26;
            this.words[i + shift] = w & 0x3ffffff;
        }
        if (carry === 0) return this._strip();
        // Subtraction overflow
        assert(carry === -1);
        carry = 0;
        for(i = 0; i < this.length; i++){
            w = -(this.words[i] | 0) + carry;
            carry = w >> 26;
            this.words[i] = w & 0x3ffffff;
        }
        this.negative = 1;
        return this._strip();
    };
    BN.prototype._wordDiv = function _wordDiv(num, mode) {
        var shift = this.length - num.length;
        var a = this.clone();
        var b = num;
        // Normalize
        var bhi = b.words[b.length - 1] | 0;
        var bhiBits = this._countBits(bhi);
        shift = 26 - bhiBits;
        if (shift !== 0) {
            b = b.ushln(shift);
            a.iushln(shift);
            bhi = b.words[b.length - 1] | 0;
        }
        // Initialize quotient
        var m = a.length - b.length;
        var q;
        if (mode !== "mod") {
            q = new BN(null);
            q.length = m + 1;
            q.words = new Array(q.length);
            for(var i = 0; i < q.length; i++)q.words[i] = 0;
        }
        var diff = a.clone()._ishlnsubmul(b, 1, m);
        if (diff.negative === 0) {
            a = diff;
            if (q) q.words[m] = 1;
        }
        for(var j = m - 1; j >= 0; j--){
            var qj = (a.words[b.length + j] | 0) * 0x4000000 + (a.words[b.length + j - 1] | 0);
            // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
            // (0x7ffffff)
            qj = Math.min(qj / bhi | 0, 0x3ffffff);
            a._ishlnsubmul(b, qj, j);
            while(a.negative !== 0){
                qj--;
                a.negative = 0;
                a._ishlnsubmul(b, 1, j);
                if (!a.isZero()) a.negative ^= 1;
            }
            if (q) q.words[j] = qj;
        }
        if (q) q._strip();
        a._strip();
        // Denormalize
        if (mode !== "div" && shift !== 0) a.iushrn(shift);
        return {
            div: q || null,
            mod: a
        };
    };
    // NOTE: 1) `mode` can be set to `mod` to request mod only,
    //       to `div` to request div only, or be absent to
    //       request both div & mod
    //       2) `positive` is true if unsigned mod is requested
    BN.prototype.divmod = function divmod(num, mode, positive) {
        assert(!num.isZero());
        if (this.isZero()) return {
            div: new BN(0),
            mod: new BN(0)
        };
        var div, mod, res;
        if (this.negative !== 0 && num.negative === 0) {
            res = this.neg().divmod(num, mode);
            if (mode !== "mod") div = res.div.neg();
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.iadd(num);
            }
            return {
                div: div,
                mod: mod
            };
        }
        if (this.negative === 0 && num.negative !== 0) {
            res = this.divmod(num.neg(), mode);
            if (mode !== "mod") div = res.div.neg();
            return {
                div: div,
                mod: res.mod
            };
        }
        if ((this.negative & num.negative) !== 0) {
            res = this.neg().divmod(num.neg(), mode);
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.isub(num);
            }
            return {
                div: res.div,
                mod: mod
            };
        }
        // Both numbers are positive at this point
        // Strip both numbers to approximate shift value
        if (num.length > this.length || this.cmp(num) < 0) return {
            div: new BN(0),
            mod: this
        };
        // Very short reduction
        if (num.length === 1) {
            if (mode === "div") return {
                div: this.divn(num.words[0]),
                mod: null
            };
            if (mode === "mod") return {
                div: null,
                mod: new BN(this.modrn(num.words[0]))
            };
            return {
                div: this.divn(num.words[0]),
                mod: new BN(this.modrn(num.words[0]))
            };
        }
        return this._wordDiv(num, mode);
    };
    // Find `this` / `num`
    BN.prototype.div = function div(num) {
        return this.divmod(num, "div", false).div;
    };
    // Find `this` % `num`
    BN.prototype.mod = function mod(num) {
        return this.divmod(num, "mod", false).mod;
    };
    BN.prototype.umod = function umod(num) {
        return this.divmod(num, "mod", true).mod;
    };
    // Find Round(`this` / `num`)
    BN.prototype.divRound = function divRound(num) {
        var dm = this.divmod(num);
        // Fast case - exact division
        if (dm.mod.isZero()) return dm.div;
        var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;
        var half = num.ushrn(1);
        var r2 = num.andln(1);
        var cmp = mod.cmp(half);
        // Round down
        if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
        // Round up
        return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
    };
    BN.prototype.modrn = function modrn(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(num <= 0x3ffffff);
        var p = 67108864 % num;
        var acc = 0;
        for(var i = this.length - 1; i >= 0; i--)acc = (p * acc + (this.words[i] | 0)) % num;
        return isNegNum ? -acc : acc;
    };
    // WARNING: DEPRECATED
    BN.prototype.modn = function modn(num) {
        return this.modrn(num);
    };
    // In-place division by number
    BN.prototype.idivn = function idivn(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(num <= 0x3ffffff);
        var carry = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var w = (this.words[i] | 0) + carry * 0x4000000;
            this.words[i] = w / num | 0;
            carry = w % num;
        }
        this._strip();
        return isNegNum ? this.ineg() : this;
    };
    BN.prototype.divn = function divn(num) {
        return this.clone().idivn(num);
    };
    BN.prototype.egcd = function egcd(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var x = this;
        var y = p.clone();
        if (x.negative !== 0) x = x.umod(p);
        else x = x.clone();
        // A * x + B * y = x
        var A = new BN(1);
        var B = new BN(0);
        // C * x + D * y = y
        var C = new BN(0);
        var D = new BN(1);
        var g = 0;
        while(x.isEven() && y.isEven()){
            x.iushrn(1);
            y.iushrn(1);
            ++g;
        }
        var yp = y.clone();
        var xp = x.clone();
        while(!x.isZero()){
            for(var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                x.iushrn(i);
                while(i-- > 0){
                    if (A.isOdd() || B.isOdd()) {
                        A.iadd(yp);
                        B.isub(xp);
                    }
                    A.iushrn(1);
                    B.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                y.iushrn(j);
                while(j-- > 0){
                    if (C.isOdd() || D.isOdd()) {
                        C.iadd(yp);
                        D.isub(xp);
                    }
                    C.iushrn(1);
                    D.iushrn(1);
                }
            }
            if (x.cmp(y) >= 0) {
                x.isub(y);
                A.isub(C);
                B.isub(D);
            } else {
                y.isub(x);
                C.isub(A);
                D.isub(B);
            }
        }
        return {
            a: C,
            b: D,
            gcd: y.iushln(g)
        };
    };
    // This is reduced incarnation of the binary EEA
    // above, designated to invert members of the
    // _prime_ fields F(p) at a maximal speed
    BN.prototype._invmp = function _invmp(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var a = this;
        var b = p.clone();
        if (a.negative !== 0) a = a.umod(p);
        else a = a.clone();
        var x1 = new BN(1);
        var x2 = new BN(0);
        var delta = b.clone();
        while(a.cmpn(1) > 0 && b.cmpn(1) > 0){
            for(var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                a.iushrn(i);
                while(i-- > 0){
                    if (x1.isOdd()) x1.iadd(delta);
                    x1.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                b.iushrn(j);
                while(j-- > 0){
                    if (x2.isOdd()) x2.iadd(delta);
                    x2.iushrn(1);
                }
            }
            if (a.cmp(b) >= 0) {
                a.isub(b);
                x1.isub(x2);
            } else {
                b.isub(a);
                x2.isub(x1);
            }
        }
        var res;
        if (a.cmpn(1) === 0) res = x1;
        else res = x2;
        if (res.cmpn(0) < 0) res.iadd(p);
        return res;
    };
    BN.prototype.gcd = function gcd(num) {
        if (this.isZero()) return num.abs();
        if (num.isZero()) return this.abs();
        var a = this.clone();
        var b = num.clone();
        a.negative = 0;
        b.negative = 0;
        // Remove common factor of two
        for(var shift = 0; a.isEven() && b.isEven(); shift++){
            a.iushrn(1);
            b.iushrn(1);
        }
        do {
            while(a.isEven())a.iushrn(1);
            while(b.isEven())b.iushrn(1);
            var r = a.cmp(b);
            if (r < 0) {
                // Swap `a` and `b` to make `a` always bigger than `b`
                var t = a;
                a = b;
                b = t;
            } else if (r === 0 || b.cmpn(1) === 0) break;
            a.isub(b);
        }while (true);
        return b.iushln(shift);
    };
    // Invert number in the field F(num)
    BN.prototype.invm = function invm(num) {
        return this.egcd(num).a.umod(num);
    };
    BN.prototype.isEven = function isEven() {
        return (this.words[0] & 1) === 0;
    };
    BN.prototype.isOdd = function isOdd() {
        return (this.words[0] & 1) === 1;
    };
    // And first word and num
    BN.prototype.andln = function andln(num) {
        return this.words[0] & num;
    };
    // Increment at the bit position in-line
    BN.prototype.bincn = function bincn(bit) {
        assert(typeof bit === "number");
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) {
            this._expand(s + 1);
            this.words[s] |= q;
            return this;
        }
        // Add bit and propagate, if needed
        var carry = q;
        for(var i = s; carry !== 0 && i < this.length; i++){
            var w = this.words[i] | 0;
            w += carry;
            carry = w >>> 26;
            w &= 0x3ffffff;
            this.words[i] = w;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.isZero = function isZero() {
        return this.length === 1 && this.words[0] === 0;
    };
    BN.prototype.cmpn = function cmpn(num) {
        var negative = num < 0;
        if (this.negative !== 0 && !negative) return -1;
        if (this.negative === 0 && negative) return 1;
        this._strip();
        var res;
        if (this.length > 1) res = 1;
        else {
            if (negative) num = -num;
            assert(num <= 0x3ffffff, "Number is too big");
            var w = this.words[0] | 0;
            res = w === num ? 0 : w < num ? -1 : 1;
        }
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Compare two numbers and return:
    // 1 - if `this` > `num`
    // 0 - if `this` == `num`
    // -1 - if `this` < `num`
    BN.prototype.cmp = function cmp(num) {
        if (this.negative !== 0 && num.negative === 0) return -1;
        if (this.negative === 0 && num.negative !== 0) return 1;
        var res = this.ucmp(num);
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Unsigned comparison
    BN.prototype.ucmp = function ucmp(num) {
        // At this point both numbers have the same sign
        if (this.length > num.length) return 1;
        if (this.length < num.length) return -1;
        var res = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var a = this.words[i] | 0;
            var b = num.words[i] | 0;
            if (a === b) continue;
            if (a < b) res = -1;
            else if (a > b) res = 1;
            break;
        }
        return res;
    };
    BN.prototype.gtn = function gtn(num) {
        return this.cmpn(num) === 1;
    };
    BN.prototype.gt = function gt(num) {
        return this.cmp(num) === 1;
    };
    BN.prototype.gten = function gten(num) {
        return this.cmpn(num) >= 0;
    };
    BN.prototype.gte = function gte(num) {
        return this.cmp(num) >= 0;
    };
    BN.prototype.ltn = function ltn(num) {
        return this.cmpn(num) === -1;
    };
    BN.prototype.lt = function lt(num) {
        return this.cmp(num) === -1;
    };
    BN.prototype.lten = function lten(num) {
        return this.cmpn(num) <= 0;
    };
    BN.prototype.lte = function lte(num) {
        return this.cmp(num) <= 0;
    };
    BN.prototype.eqn = function eqn(num) {
        return this.cmpn(num) === 0;
    };
    BN.prototype.eq = function eq(num) {
        return this.cmp(num) === 0;
    };
    //
    // A reduce context, could be using montgomery or something better, depending
    // on the `m` itself.
    //
    BN.red = function red(num) {
        return new Red(num);
    };
    BN.prototype.toRed = function toRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        assert(this.negative === 0, "red works only with positives");
        return ctx.convertTo(this)._forceRed(ctx);
    };
    BN.prototype.fromRed = function fromRed() {
        assert(this.red, "fromRed works only with numbers in reduction context");
        return this.red.convertFrom(this);
    };
    BN.prototype._forceRed = function _forceRed(ctx) {
        this.red = ctx;
        return this;
    };
    BN.prototype.forceRed = function forceRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        return this._forceRed(ctx);
    };
    BN.prototype.redAdd = function redAdd(num) {
        assert(this.red, "redAdd works only with red numbers");
        return this.red.add(this, num);
    };
    BN.prototype.redIAdd = function redIAdd(num) {
        assert(this.red, "redIAdd works only with red numbers");
        return this.red.iadd(this, num);
    };
    BN.prototype.redSub = function redSub(num) {
        assert(this.red, "redSub works only with red numbers");
        return this.red.sub(this, num);
    };
    BN.prototype.redISub = function redISub(num) {
        assert(this.red, "redISub works only with red numbers");
        return this.red.isub(this, num);
    };
    BN.prototype.redShl = function redShl(num) {
        assert(this.red, "redShl works only with red numbers");
        return this.red.shl(this, num);
    };
    BN.prototype.redMul = function redMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.mul(this, num);
    };
    BN.prototype.redIMul = function redIMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.imul(this, num);
    };
    BN.prototype.redSqr = function redSqr() {
        assert(this.red, "redSqr works only with red numbers");
        this.red._verify1(this);
        return this.red.sqr(this);
    };
    BN.prototype.redISqr = function redISqr() {
        assert(this.red, "redISqr works only with red numbers");
        this.red._verify1(this);
        return this.red.isqr(this);
    };
    // Square root over p
    BN.prototype.redSqrt = function redSqrt() {
        assert(this.red, "redSqrt works only with red numbers");
        this.red._verify1(this);
        return this.red.sqrt(this);
    };
    BN.prototype.redInvm = function redInvm() {
        assert(this.red, "redInvm works only with red numbers");
        this.red._verify1(this);
        return this.red.invm(this);
    };
    // Return negative clone of `this` % `red modulo`
    BN.prototype.redNeg = function redNeg() {
        assert(this.red, "redNeg works only with red numbers");
        this.red._verify1(this);
        return this.red.neg(this);
    };
    BN.prototype.redPow = function redPow(num) {
        assert(this.red && !num.red, "redPow(normalNum)");
        this.red._verify1(this);
        return this.red.pow(this, num);
    };
    // Prime numbers with efficient reduction
    var primes = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
    };
    // Pseudo-Mersenne prime
    function MPrime(name, p) {
        // P = 2 ^ N - K
        this.name = name;
        this.p = new BN(p, 16);
        this.n = this.p.bitLength();
        this.k = new BN(1).iushln(this.n).isub(this.p);
        this.tmp = this._tmp();
    }
    MPrime.prototype._tmp = function _tmp() {
        var tmp = new BN(null);
        tmp.words = new Array(Math.ceil(this.n / 13));
        return tmp;
    };
    MPrime.prototype.ireduce = function ireduce(num) {
        // Assumes that `num` is less than `P^2`
        // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
        var r = num;
        var rlen;
        do {
            this.split(r, this.tmp);
            r = this.imulK(r);
            r = r.iadd(this.tmp);
            rlen = r.bitLength();
        }while (rlen > this.n);
        var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
        if (cmp === 0) {
            r.words[0] = 0;
            r.length = 1;
        } else if (cmp > 0) r.isub(this.p);
        else if (r.strip !== undefined) // r is a BN v4 instance
        r.strip();
        else // r is a BN v5 instance
        r._strip();
        return r;
    };
    MPrime.prototype.split = function split(input, out) {
        input.iushrn(this.n, 0, out);
    };
    MPrime.prototype.imulK = function imulK(num) {
        return num.imul(this.k);
    };
    function K256() {
        MPrime.call(this, "k256", "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f");
    }
    inherits(K256, MPrime);
    K256.prototype.split = function split(input, output) {
        // 256 = 9 * 26 + 22
        var mask = 0x3fffff;
        var outLen = Math.min(input.length, 9);
        for(var i = 0; i < outLen; i++)output.words[i] = input.words[i];
        output.length = outLen;
        if (input.length <= 9) {
            input.words[0] = 0;
            input.length = 1;
            return;
        }
        // Shift by 9 limbs
        var prev = input.words[9];
        output.words[output.length++] = prev & mask;
        for(i = 10; i < input.length; i++){
            var next = input.words[i] | 0;
            input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
            prev = next;
        }
        prev >>>= 22;
        input.words[i - 10] = prev;
        if (prev === 0 && input.length > 10) input.length -= 10;
        else input.length -= 9;
    };
    K256.prototype.imulK = function imulK(num) {
        // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
        num.words[num.length] = 0;
        num.words[num.length + 1] = 0;
        num.length += 2;
        // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
        var lo = 0;
        for(var i = 0; i < num.length; i++){
            var w = num.words[i] | 0;
            lo += w * 0x3d1;
            num.words[i] = lo & 0x3ffffff;
            lo = w * 0x40 + (lo / 0x4000000 | 0);
        }
        // Fast length reduction
        if (num.words[num.length - 1] === 0) {
            num.length--;
            if (num.words[num.length - 1] === 0) num.length--;
        }
        return num;
    };
    function P224() {
        MPrime.call(this, "p224", "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001");
    }
    inherits(P224, MPrime);
    function P192() {
        MPrime.call(this, "p192", "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff");
    }
    inherits(P192, MPrime);
    function P25519() {
        // 2 ^ 255 - 19
        MPrime.call(this, "25519", "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed");
    }
    inherits(P25519, MPrime);
    P25519.prototype.imulK = function imulK(num) {
        // K = 0x13
        var carry = 0;
        for(var i = 0; i < num.length; i++){
            var hi = (num.words[i] | 0) * 0x13 + carry;
            var lo = hi & 0x3ffffff;
            hi >>>= 26;
            num.words[i] = lo;
            carry = hi;
        }
        if (carry !== 0) num.words[num.length++] = carry;
        return num;
    };
    // Exported mostly for testing purposes, use plain name instead
    BN._prime = function prime(name) {
        // Cached version of prime
        if (primes[name]) return primes[name];
        var prime;
        if (name === "k256") prime = new K256();
        else if (name === "p224") prime = new P224();
        else if (name === "p192") prime = new P192();
        else if (name === "p25519") prime = new P25519();
        else throw new Error("Unknown prime " + name);
        primes[name] = prime;
        return prime;
    };
    //
    // Base reduction engine
    //
    function Red(m) {
        if (typeof m === "string") {
            var prime = BN._prime(m);
            this.m = prime.p;
            this.prime = prime;
        } else {
            assert(m.gtn(1), "modulus must be greater than 1");
            this.m = m;
            this.prime = null;
        }
    }
    Red.prototype._verify1 = function _verify1(a) {
        assert(a.negative === 0, "red works only with positives");
        assert(a.red, "red works only with red numbers");
    };
    Red.prototype._verify2 = function _verify2(a, b) {
        assert((a.negative | b.negative) === 0, "red works only with positives");
        assert(a.red && a.red === b.red, "red works only with red numbers");
    };
    Red.prototype.imod = function imod(a) {
        if (this.prime) return this.prime.ireduce(a)._forceRed(this);
        move(a, a.umod(this.m)._forceRed(this));
        return a;
    };
    Red.prototype.neg = function neg(a) {
        if (a.isZero()) return a.clone();
        return this.m.sub(a)._forceRed(this);
    };
    Red.prototype.add = function add(a, b) {
        this._verify2(a, b);
        var res = a.add(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res._forceRed(this);
    };
    Red.prototype.iadd = function iadd(a, b) {
        this._verify2(a, b);
        var res = a.iadd(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res;
    };
    Red.prototype.sub = function sub(a, b) {
        this._verify2(a, b);
        var res = a.sub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res._forceRed(this);
    };
    Red.prototype.isub = function isub(a, b) {
        this._verify2(a, b);
        var res = a.isub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res;
    };
    Red.prototype.shl = function shl(a, num) {
        this._verify1(a);
        return this.imod(a.ushln(num));
    };
    Red.prototype.imul = function imul(a, b) {
        this._verify2(a, b);
        return this.imod(a.imul(b));
    };
    Red.prototype.mul = function mul(a, b) {
        this._verify2(a, b);
        return this.imod(a.mul(b));
    };
    Red.prototype.isqr = function isqr(a) {
        return this.imul(a, a.clone());
    };
    Red.prototype.sqr = function sqr(a) {
        return this.mul(a, a);
    };
    Red.prototype.sqrt = function sqrt(a) {
        if (a.isZero()) return a.clone();
        var mod3 = this.m.andln(3);
        assert(mod3 % 2 === 1);
        // Fast case
        if (mod3 === 3) {
            var pow = this.m.add(new BN(1)).iushrn(2);
            return this.pow(a, pow);
        }
        // Tonelli-Shanks algorithm (Totally unoptimized and slow)
        //
        // Find Q and S, that Q * 2 ^ S = (P - 1)
        var q = this.m.subn(1);
        var s = 0;
        while(!q.isZero() && q.andln(1) === 0){
            s++;
            q.iushrn(1);
        }
        assert(!q.isZero());
        var one = new BN(1).toRed(this);
        var nOne = one.redNeg();
        // Find quadratic non-residue
        // NOTE: Max is such because of generalized Riemann hypothesis.
        var lpow = this.m.subn(1).iushrn(1);
        var z = this.m.bitLength();
        z = new BN(2 * z * z).toRed(this);
        while(this.pow(z, lpow).cmp(nOne) !== 0)z.redIAdd(nOne);
        var c = this.pow(z, q);
        var r = this.pow(a, q.addn(1).iushrn(1));
        var t = this.pow(a, q);
        var m = s;
        while(t.cmp(one) !== 0){
            var tmp = t;
            for(var i = 0; tmp.cmp(one) !== 0; i++)tmp = tmp.redSqr();
            assert(i < m);
            var b = this.pow(c, new BN(1).iushln(m - i - 1));
            r = r.redMul(b);
            c = b.redSqr();
            t = t.redMul(c);
            m = i;
        }
        return r;
    };
    Red.prototype.invm = function invm(a) {
        var inv = a._invmp(this.m);
        if (inv.negative !== 0) {
            inv.negative = 0;
            return this.imod(inv).redNeg();
        } else return this.imod(inv);
    };
    Red.prototype.pow = function pow(a, num) {
        if (num.isZero()) return new BN(1).toRed(this);
        if (num.cmpn(1) === 0) return a.clone();
        var windowSize = 4;
        var wnd = new Array(1 << windowSize);
        wnd[0] = new BN(1).toRed(this);
        wnd[1] = a;
        for(var i = 2; i < wnd.length; i++)wnd[i] = this.mul(wnd[i - 1], a);
        var res = wnd[0];
        var current = 0;
        var currentLen = 0;
        var start = num.bitLength() % 26;
        if (start === 0) start = 26;
        for(i = num.length - 1; i >= 0; i--){
            var word = num.words[i];
            for(var j = start - 1; j >= 0; j--){
                var bit = word >> j & 1;
                if (res !== wnd[0]) res = this.sqr(res);
                if (bit === 0 && current === 0) {
                    currentLen = 0;
                    continue;
                }
                current <<= 1;
                current |= bit;
                currentLen++;
                if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
                res = this.mul(res, wnd[current]);
                currentLen = 0;
                current = 0;
            }
            start = 26;
        }
        return res;
    };
    Red.prototype.convertTo = function convertTo(num) {
        var r = num.umod(this.m);
        return r === num ? r.clone() : r;
    };
    Red.prototype.convertFrom = function convertFrom(num) {
        var res = num.clone();
        res.red = null;
        return res;
    };
    //
    // Montgomery method engine
    //
    BN.mont = function mont(num) {
        return new Mont(num);
    };
    function Mont(m) {
        Red.call(this, m);
        this.shift = this.m.bitLength();
        if (this.shift % 26 !== 0) this.shift += 26 - this.shift % 26;
        this.r = new BN(1).iushln(this.shift);
        this.r2 = this.imod(this.r.sqr());
        this.rinv = this.r._invmp(this.m);
        this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
        this.minv = this.minv.umod(this.r);
        this.minv = this.r.sub(this.minv);
    }
    inherits(Mont, Red);
    Mont.prototype.convertTo = function convertTo(num) {
        return this.imod(num.ushln(this.shift));
    };
    Mont.prototype.convertFrom = function convertFrom(num) {
        var r = this.imod(num.mul(this.rinv));
        r.red = null;
        return r;
    };
    Mont.prototype.imul = function imul(a, b) {
        if (a.isZero() || b.isZero()) {
            a.words[0] = 0;
            a.length = 1;
            return a;
        }
        var t = a.imul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.mul = function mul(a, b) {
        if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
        var t = a.mul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.invm = function invm(a) {
        // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
        var res = this.imod(a._invmp(this.m).mul(this.r2));
        return res._forceRed(this);
    };
})(module, this);

},{"c3a61706559b2db2":"13Pcp"}],"4xCgN":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isBytesLike", ()=>isBytesLike);
parcelHelpers.export(exports, "isBytes", ()=>isBytes);
parcelHelpers.export(exports, "arrayify", ()=>arrayify);
parcelHelpers.export(exports, "concat", ()=>concat);
parcelHelpers.export(exports, "stripZeros", ()=>stripZeros);
parcelHelpers.export(exports, "zeroPad", ()=>zeroPad);
parcelHelpers.export(exports, "isHexString", ()=>isHexString);
parcelHelpers.export(exports, "hexlify", ()=>hexlify);
/*
function unoddify(value: BytesLike | Hexable | number): BytesLike | Hexable | number {
    if (typeof(value) === "string" && value.length % 2 && value.substring(0, 2) === "0x") {
        return "0x0" + value.substring(2);
    }
    return value;
}
*/ parcelHelpers.export(exports, "hexDataLength", ()=>hexDataLength);
parcelHelpers.export(exports, "hexDataSlice", ()=>hexDataSlice);
parcelHelpers.export(exports, "hexConcat", ()=>hexConcat);
parcelHelpers.export(exports, "hexValue", ()=>hexValue);
parcelHelpers.export(exports, "hexStripZeros", ()=>hexStripZeros);
parcelHelpers.export(exports, "hexZeroPad", ()=>hexZeroPad);
parcelHelpers.export(exports, "splitSignature", ()=>splitSignature);
parcelHelpers.export(exports, "joinSignature", ()=>joinSignature);
var _logger = require("@ethersproject/logger");
var _version = require("./_version");
"use strict";
const logger = new (0, _logger.Logger)((0, _version.version));
///////////////////////////////
function isHexable(value) {
    return !!value.toHexString;
}
function addSlice(array) {
    if (array.slice) return array;
    array.slice = function() {
        const args = Array.prototype.slice.call(arguments);
        return addSlice(new Uint8Array(Array.prototype.slice.apply(array, args)));
    };
    return array;
}
function isBytesLike(value) {
    return isHexString(value) && !(value.length % 2) || isBytes(value);
}
function isInteger(value) {
    return typeof value === "number" && value == value && value % 1 === 0;
}
function isBytes(value) {
    if (value == null) return false;
    if (value.constructor === Uint8Array) return true;
    if (typeof value === "string") return false;
    if (!isInteger(value.length) || value.length < 0) return false;
    for(let i = 0; i < value.length; i++){
        const v = value[i];
        if (!isInteger(v) || v < 0 || v >= 256) return false;
    }
    return true;
}
function arrayify(value, options) {
    if (!options) options = {};
    if (typeof value === "number") {
        logger.checkSafeUint53(value, "invalid arrayify value");
        const result = [];
        while(value){
            result.unshift(value & 0xff);
            value = parseInt(String(value / 256));
        }
        if (result.length === 0) result.push(0);
        return addSlice(new Uint8Array(result));
    }
    if (options.allowMissingPrefix && typeof value === "string" && value.substring(0, 2) !== "0x") value = "0x" + value;
    if (isHexable(value)) value = value.toHexString();
    if (isHexString(value)) {
        let hex = value.substring(2);
        if (hex.length % 2) {
            if (options.hexPad === "left") hex = "0" + hex;
            else if (options.hexPad === "right") hex += "0";
            else logger.throwArgumentError("hex data is odd-length", "value", value);
        }
        const result = [];
        for(let i = 0; i < hex.length; i += 2)result.push(parseInt(hex.substring(i, i + 2), 16));
        return addSlice(new Uint8Array(result));
    }
    if (isBytes(value)) return addSlice(new Uint8Array(value));
    return logger.throwArgumentError("invalid arrayify value", "value", value);
}
function concat(items) {
    const objects = items.map((item)=>arrayify(item));
    const length = objects.reduce((accum, item)=>accum + item.length, 0);
    const result = new Uint8Array(length);
    objects.reduce((offset, object)=>{
        result.set(object, offset);
        return offset + object.length;
    }, 0);
    return addSlice(result);
}
function stripZeros(value) {
    let result = arrayify(value);
    if (result.length === 0) return result;
    // Find the first non-zero entry
    let start = 0;
    while(start < result.length && result[start] === 0)start++;
    // If we started with zeros, strip them
    if (start) result = result.slice(start);
    return result;
}
function zeroPad(value, length) {
    value = arrayify(value);
    if (value.length > length) logger.throwArgumentError("value out of range", "value", arguments[0]);
    const result = new Uint8Array(length);
    result.set(value, length - value.length);
    return addSlice(result);
}
function isHexString(value, length) {
    if (typeof value !== "string" || !value.match(/^0x[0-9A-Fa-f]*$/)) return false;
    if (length && value.length !== 2 + 2 * length) return false;
    return true;
}
const HexCharacters = "0123456789abcdef";
function hexlify(value, options) {
    if (!options) options = {};
    if (typeof value === "number") {
        logger.checkSafeUint53(value, "invalid hexlify value");
        let hex = "";
        while(value){
            hex = HexCharacters[value & 0xf] + hex;
            value = Math.floor(value / 16);
        }
        if (hex.length) {
            if (hex.length % 2) hex = "0" + hex;
            return "0x" + hex;
        }
        return "0x00";
    }
    if (typeof value === "bigint") {
        value = value.toString(16);
        if (value.length % 2) return "0x0" + value;
        return "0x" + value;
    }
    if (options.allowMissingPrefix && typeof value === "string" && value.substring(0, 2) !== "0x") value = "0x" + value;
    if (isHexable(value)) return value.toHexString();
    if (isHexString(value)) {
        if (value.length % 2) {
            if (options.hexPad === "left") value = "0x0" + value.substring(2);
            else if (options.hexPad === "right") value += "0";
            else logger.throwArgumentError("hex data is odd-length", "value", value);
        }
        return value.toLowerCase();
    }
    if (isBytes(value)) {
        let result = "0x";
        for(let i = 0; i < value.length; i++){
            let v = value[i];
            result += HexCharacters[(v & 0xf0) >> 4] + HexCharacters[v & 0x0f];
        }
        return result;
    }
    return logger.throwArgumentError("invalid hexlify value", "value", value);
}
function hexDataLength(data) {
    if (typeof data !== "string") data = hexlify(data);
    else if (!isHexString(data) || data.length % 2) return null;
    return (data.length - 2) / 2;
}
function hexDataSlice(data, offset, endOffset) {
    if (typeof data !== "string") data = hexlify(data);
    else if (!isHexString(data) || data.length % 2) logger.throwArgumentError("invalid hexData", "value", data);
    offset = 2 + 2 * offset;
    if (endOffset != null) return "0x" + data.substring(offset, 2 + 2 * endOffset);
    return "0x" + data.substring(offset);
}
function hexConcat(items) {
    let result = "0x";
    items.forEach((item)=>{
        result += hexlify(item).substring(2);
    });
    return result;
}
function hexValue(value) {
    const trimmed = hexStripZeros(hexlify(value, {
        hexPad: "left"
    }));
    if (trimmed === "0x") return "0x0";
    return trimmed;
}
function hexStripZeros(value) {
    if (typeof value !== "string") value = hexlify(value);
    if (!isHexString(value)) logger.throwArgumentError("invalid hex string", "value", value);
    value = value.substring(2);
    let offset = 0;
    while(offset < value.length && value[offset] === "0")offset++;
    return "0x" + value.substring(offset);
}
function hexZeroPad(value, length) {
    if (typeof value !== "string") value = hexlify(value);
    else if (!isHexString(value)) logger.throwArgumentError("invalid hex string", "value", value);
    if (value.length > 2 * length + 2) logger.throwArgumentError("value out of range", "value", arguments[1]);
    while(value.length < 2 * length + 2)value = "0x0" + value.substring(2);
    return value;
}
function splitSignature(signature) {
    const result = {
        r: "0x",
        s: "0x",
        _vs: "0x",
        recoveryParam: 0,
        v: 0,
        yParityAndS: "0x",
        compact: "0x"
    };
    if (isBytesLike(signature)) {
        let bytes = arrayify(signature);
        // Get the r, s and v
        if (bytes.length === 64) {
            // EIP-2098; pull the v from the top bit of s and clear it
            result.v = 27 + (bytes[32] >> 7);
            bytes[32] &= 0x7f;
            result.r = hexlify(bytes.slice(0, 32));
            result.s = hexlify(bytes.slice(32, 64));
        } else if (bytes.length === 65) {
            result.r = hexlify(bytes.slice(0, 32));
            result.s = hexlify(bytes.slice(32, 64));
            result.v = bytes[64];
        } else logger.throwArgumentError("invalid signature string", "signature", signature);
        // Allow a recid to be used as the v
        if (result.v < 27) {
            if (result.v === 0 || result.v === 1) result.v += 27;
            else logger.throwArgumentError("signature invalid v byte", "signature", signature);
        }
        // Compute recoveryParam from v
        result.recoveryParam = 1 - result.v % 2;
        // Compute _vs from recoveryParam and s
        if (result.recoveryParam) bytes[32] |= 0x80;
        result._vs = hexlify(bytes.slice(32, 64));
    } else {
        result.r = signature.r;
        result.s = signature.s;
        result.v = signature.v;
        result.recoveryParam = signature.recoveryParam;
        result._vs = signature._vs;
        // If the _vs is available, use it to populate missing s, v and recoveryParam
        // and verify non-missing s, v and recoveryParam
        if (result._vs != null) {
            const vs = zeroPad(arrayify(result._vs), 32);
            result._vs = hexlify(vs);
            // Set or check the recid
            const recoveryParam = vs[0] >= 128 ? 1 : 0;
            if (result.recoveryParam == null) result.recoveryParam = recoveryParam;
            else if (result.recoveryParam !== recoveryParam) logger.throwArgumentError("signature recoveryParam mismatch _vs", "signature", signature);
            // Set or check the s
            vs[0] &= 0x7f;
            const s = hexlify(vs);
            if (result.s == null) result.s = s;
            else if (result.s !== s) logger.throwArgumentError("signature v mismatch _vs", "signature", signature);
        }
        // Use recid and v to populate each other
        if (result.recoveryParam == null) {
            if (result.v == null) logger.throwArgumentError("signature missing v and recoveryParam", "signature", signature);
            else if (result.v === 0 || result.v === 1) result.recoveryParam = result.v;
            else result.recoveryParam = 1 - result.v % 2;
        } else if (result.v == null) result.v = 27 + result.recoveryParam;
        else {
            const recId = result.v === 0 || result.v === 1 ? result.v : 1 - result.v % 2;
            if (result.recoveryParam !== recId) logger.throwArgumentError("signature recoveryParam mismatch v", "signature", signature);
        }
        if (result.r == null || !isHexString(result.r)) logger.throwArgumentError("signature missing or invalid r", "signature", signature);
        else result.r = hexZeroPad(result.r, 32);
        if (result.s == null || !isHexString(result.s)) logger.throwArgumentError("signature missing or invalid s", "signature", signature);
        else result.s = hexZeroPad(result.s, 32);
        const vs = arrayify(result.s);
        if (vs[0] >= 128) logger.throwArgumentError("signature s out of range", "signature", signature);
        if (result.recoveryParam) vs[0] |= 0x80;
        const _vs = hexlify(vs);
        if (result._vs) {
            if (!isHexString(result._vs)) logger.throwArgumentError("signature invalid _vs", "signature", signature);
            result._vs = hexZeroPad(result._vs, 32);
        }
        // Set or check the _vs
        if (result._vs == null) result._vs = _vs;
        else if (result._vs !== _vs) logger.throwArgumentError("signature _vs mismatch v and s", "signature", signature);
    }
    result.yParityAndS = result._vs;
    result.compact = result.r + result.yParityAndS.substring(2);
    return result;
}
function joinSignature(signature) {
    signature = splitSignature(signature);
    return hexlify(concat([
        signature.r,
        signature.s,
        signature.recoveryParam ? "0x1c" : "0x1b"
    ]));
}

},{"@ethersproject/logger":"jADah","./_version":"4NFxO","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"jADah":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LogLevel", ()=>LogLevel);
parcelHelpers.export(exports, "ErrorCode", ()=>ErrorCode);
parcelHelpers.export(exports, "Logger", ()=>Logger);
var _version = require("./_version");
"use strict";
let _permanentCensorErrors = false;
let _censorErrors = false;
const LogLevels = {
    debug: 1,
    "default": 2,
    info: 2,
    warning: 3,
    error: 4,
    off: 5
};
let _logLevel = LogLevels["default"];
let _globalLogger = null;
function _checkNormalize() {
    try {
        const missing = [];
        // Make sure all forms of normalization are supported
        [
            "NFD",
            "NFC",
            "NFKD",
            "NFKC"
        ].forEach((form)=>{
            try {
                if ("test".normalize(form) !== "test") throw new Error("bad normalize");
            } catch (error) {
                missing.push(form);
            }
        });
        if (missing.length) throw new Error("missing " + missing.join(", "));
        if (String.fromCharCode(0xe9).normalize("NFD") !== String.fromCharCode(0x65, 0x0301)) throw new Error("broken implementation");
    } catch (error) {
        return error.message;
    }
    return null;
}
const _normalizeError = _checkNormalize();
var LogLevel;
(function(LogLevel) {
    LogLevel["DEBUG"] = "DEBUG";
    LogLevel["INFO"] = "INFO";
    LogLevel["WARNING"] = "WARNING";
    LogLevel["ERROR"] = "ERROR";
    LogLevel["OFF"] = "OFF";
})(LogLevel || (LogLevel = {}));
var ErrorCode;
(function(ErrorCode) {
    ///////////////////
    // Generic Errors
    // Unknown Error
    ErrorCode["UNKNOWN_ERROR"] = "UNKNOWN_ERROR";
    // Not Implemented
    ErrorCode["NOT_IMPLEMENTED"] = "NOT_IMPLEMENTED";
    // Unsupported Operation
    //   - operation
    ErrorCode["UNSUPPORTED_OPERATION"] = "UNSUPPORTED_OPERATION";
    // Network Error (i.e. Ethereum Network, such as an invalid chain ID)
    //   - event ("noNetwork" is not re-thrown in provider.ready; otherwise thrown)
    ErrorCode["NETWORK_ERROR"] = "NETWORK_ERROR";
    // Some sort of bad response from the server
    ErrorCode["SERVER_ERROR"] = "SERVER_ERROR";
    // Timeout
    ErrorCode["TIMEOUT"] = "TIMEOUT";
    ///////////////////
    // Operational  Errors
    // Buffer Overrun
    ErrorCode["BUFFER_OVERRUN"] = "BUFFER_OVERRUN";
    // Numeric Fault
    //   - operation: the operation being executed
    //   - fault: the reason this faulted
    ErrorCode["NUMERIC_FAULT"] = "NUMERIC_FAULT";
    ///////////////////
    // Argument Errors
    // Missing new operator to an object
    //  - name: The name of the class
    ErrorCode["MISSING_NEW"] = "MISSING_NEW";
    // Invalid argument (e.g. value is incompatible with type) to a function:
    //   - argument: The argument name that was invalid
    //   - value: The value of the argument
    ErrorCode["INVALID_ARGUMENT"] = "INVALID_ARGUMENT";
    // Missing argument to a function:
    //   - count: The number of arguments received
    //   - expectedCount: The number of arguments expected
    ErrorCode["MISSING_ARGUMENT"] = "MISSING_ARGUMENT";
    // Too many arguments
    //   - count: The number of arguments received
    //   - expectedCount: The number of arguments expected
    ErrorCode["UNEXPECTED_ARGUMENT"] = "UNEXPECTED_ARGUMENT";
    ///////////////////
    // Blockchain Errors
    // Call exception
    //  - transaction: the transaction
    //  - address?: the contract address
    //  - args?: The arguments passed into the function
    //  - method?: The Solidity method signature
    //  - errorSignature?: The EIP848 error signature
    //  - errorArgs?: The EIP848 error parameters
    //  - reason: The reason (only for EIP848 "Error(string)")
    ErrorCode["CALL_EXCEPTION"] = "CALL_EXCEPTION";
    // Insufficient funds (< value + gasLimit * gasPrice)
    //   - transaction: the transaction attempted
    ErrorCode["INSUFFICIENT_FUNDS"] = "INSUFFICIENT_FUNDS";
    // Nonce has already been used
    //   - transaction: the transaction attempted
    ErrorCode["NONCE_EXPIRED"] = "NONCE_EXPIRED";
    // The replacement fee for the transaction is too low
    //   - transaction: the transaction attempted
    ErrorCode["REPLACEMENT_UNDERPRICED"] = "REPLACEMENT_UNDERPRICED";
    // The gas limit could not be estimated
    //   - transaction: the transaction passed to estimateGas
    ErrorCode["UNPREDICTABLE_GAS_LIMIT"] = "UNPREDICTABLE_GAS_LIMIT";
    // The transaction was replaced by one with a higher gas price
    //   - reason: "cancelled", "replaced" or "repriced"
    //   - cancelled: true if reason == "cancelled" or reason == "replaced")
    //   - hash: original transaction hash
    //   - replacement: the full TransactionsResponse for the replacement
    //   - receipt: the receipt of the replacement
    ErrorCode["TRANSACTION_REPLACED"] = "TRANSACTION_REPLACED";
    ///////////////////
    // Interaction Errors
    // The user rejected the action, such as signing a message or sending
    // a transaction
    ErrorCode["ACTION_REJECTED"] = "ACTION_REJECTED";
})(ErrorCode || (ErrorCode = {}));
const HEX = "0123456789abcdef";
class Logger {
    constructor(version){
        Object.defineProperty(this, "version", {
            enumerable: true,
            value: version,
            writable: false
        });
    }
    _log(logLevel, args) {
        const level = logLevel.toLowerCase();
        if (LogLevels[level] == null) this.throwArgumentError("invalid log level name", "logLevel", logLevel);
        if (_logLevel > LogLevels[level]) return;
        console.log.apply(console, args);
    }
    debug(...args) {
        this._log(Logger.levels.DEBUG, args);
    }
    info(...args) {
        this._log(Logger.levels.INFO, args);
    }
    warn(...args) {
        this._log(Logger.levels.WARNING, args);
    }
    makeError(message, code, params) {
        // Errors are being censored
        if (_censorErrors) return this.makeError("censored error", code, {});
        if (!code) code = Logger.errors.UNKNOWN_ERROR;
        if (!params) params = {};
        const messageDetails = [];
        Object.keys(params).forEach((key)=>{
            const value = params[key];
            try {
                if (value instanceof Uint8Array) {
                    let hex = "";
                    for(let i = 0; i < value.length; i++){
                        hex += HEX[value[i] >> 4];
                        hex += HEX[value[i] & 0x0f];
                    }
                    messageDetails.push(key + "=Uint8Array(0x" + hex + ")");
                } else messageDetails.push(key + "=" + JSON.stringify(value));
            } catch (error) {
                messageDetails.push(key + "=" + JSON.stringify(params[key].toString()));
            }
        });
        messageDetails.push(`code=${code}`);
        messageDetails.push(`version=${this.version}`);
        const reason = message;
        let url = "";
        switch(code){
            case ErrorCode.NUMERIC_FAULT:
                {
                    url = "NUMERIC_FAULT";
                    const fault = message;
                    switch(fault){
                        case "overflow":
                        case "underflow":
                        case "division-by-zero":
                            url += "-" + fault;
                            break;
                        case "negative-power":
                        case "negative-width":
                            url += "-unsupported";
                            break;
                        case "unbound-bitwise-result":
                            url += "-unbound-result";
                            break;
                    }
                    break;
                }
            case ErrorCode.CALL_EXCEPTION:
            case ErrorCode.INSUFFICIENT_FUNDS:
            case ErrorCode.MISSING_NEW:
            case ErrorCode.NONCE_EXPIRED:
            case ErrorCode.REPLACEMENT_UNDERPRICED:
            case ErrorCode.TRANSACTION_REPLACED:
            case ErrorCode.UNPREDICTABLE_GAS_LIMIT:
                url = code;
                break;
        }
        if (url) message += " [ See: https://links.ethers.org/v5-errors-" + url + " ]";
        if (messageDetails.length) message += " (" + messageDetails.join(", ") + ")";
        // @TODO: Any??
        const error = new Error(message);
        error.reason = reason;
        error.code = code;
        Object.keys(params).forEach(function(key) {
            error[key] = params[key];
        });
        return error;
    }
    throwError(message, code, params) {
        throw this.makeError(message, code, params);
    }
    throwArgumentError(message, name, value) {
        return this.throwError(message, Logger.errors.INVALID_ARGUMENT, {
            argument: name,
            value: value
        });
    }
    assert(condition, message, code, params) {
        if (!!condition) return;
        this.throwError(message, code, params);
    }
    assertArgument(condition, message, name, value) {
        if (!!condition) return;
        this.throwArgumentError(message, name, value);
    }
    checkNormalize(message) {
        if (message == null) message = "platform missing String.prototype.normalize";
        if (_normalizeError) this.throwError("platform missing String.prototype.normalize", Logger.errors.UNSUPPORTED_OPERATION, {
            operation: "String.prototype.normalize",
            form: _normalizeError
        });
    }
    checkSafeUint53(value, message) {
        if (typeof value !== "number") return;
        if (message == null) message = "value not safe";
        if (value < 0 || value >= 0x1fffffffffffff) this.throwError(message, Logger.errors.NUMERIC_FAULT, {
            operation: "checkSafeInteger",
            fault: "out-of-safe-range",
            value: value
        });
        if (value % 1) this.throwError(message, Logger.errors.NUMERIC_FAULT, {
            operation: "checkSafeInteger",
            fault: "non-integer",
            value: value
        });
    }
    checkArgumentCount(count, expectedCount, message) {
        if (message) message = ": " + message;
        else message = "";
        if (count < expectedCount) this.throwError("missing argument" + message, Logger.errors.MISSING_ARGUMENT, {
            count: count,
            expectedCount: expectedCount
        });
        if (count > expectedCount) this.throwError("too many arguments" + message, Logger.errors.UNEXPECTED_ARGUMENT, {
            count: count,
            expectedCount: expectedCount
        });
    }
    checkNew(target, kind) {
        if (target === Object || target == null) this.throwError("missing new", Logger.errors.MISSING_NEW, {
            name: kind.name
        });
    }
    checkAbstract(target, kind) {
        if (target === kind) this.throwError("cannot instantiate abstract class " + JSON.stringify(kind.name) + " directly; use a sub-class", Logger.errors.UNSUPPORTED_OPERATION, {
            name: target.name,
            operation: "new"
        });
        else if (target === Object || target == null) this.throwError("missing new", Logger.errors.MISSING_NEW, {
            name: kind.name
        });
    }
    static globalLogger() {
        if (!_globalLogger) _globalLogger = new Logger((0, _version.version));
        return _globalLogger;
    }
    static setCensorship(censorship, permanent) {
        if (!censorship && permanent) this.globalLogger().throwError("cannot permanently disable censorship", Logger.errors.UNSUPPORTED_OPERATION, {
            operation: "setCensorship"
        });
        if (_permanentCensorErrors) {
            if (!censorship) return;
            this.globalLogger().throwError("error censorship permanent", Logger.errors.UNSUPPORTED_OPERATION, {
                operation: "setCensorship"
            });
        }
        _censorErrors = !!censorship;
        _permanentCensorErrors = !!permanent;
    }
    static setLogLevel(logLevel) {
        const level = LogLevels[logLevel.toLowerCase()];
        if (level == null) {
            Logger.globalLogger().warn("invalid log level - " + logLevel);
            return;
        }
        _logLevel = level;
    }
    static from(version) {
        return new Logger(version);
    }
}
Logger.errors = ErrorCode;
Logger.levels = LogLevel;

},{"./_version":"lgkJb","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"lgkJb":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "version", ()=>version);
const version = "logger/5.7.0";

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4NFxO":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "version", ()=>version);
const version = "bytes/5.7.0";

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"5YGz5":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "version", ()=>version);
const version = "bignumber/5.7.0";

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"016Tj":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "defineReadOnly", ()=>defineReadOnly);
// Crawl up the constructor chain to find a static method
parcelHelpers.export(exports, "getStatic", ()=>getStatic);
parcelHelpers.export(exports, "resolveProperties", ()=>resolveProperties);
parcelHelpers.export(exports, "checkProperties", ()=>checkProperties);
parcelHelpers.export(exports, "shallowCopy", ()=>shallowCopy);
parcelHelpers.export(exports, "deepCopy", ()=>deepCopy);
parcelHelpers.export(exports, "Description", ()=>Description);
var _logger = require("@ethersproject/logger");
var _version = require("./_version");
"use strict";
var __awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const logger = new (0, _logger.Logger)((0, _version.version));
function defineReadOnly(object, name, value) {
    Object.defineProperty(object, name, {
        enumerable: true,
        value: value,
        writable: false
    });
}
function getStatic(ctor, key) {
    for(let i = 0; i < 32; i++){
        if (ctor[key]) return ctor[key];
        if (!ctor.prototype || typeof ctor.prototype !== "object") break;
        ctor = Object.getPrototypeOf(ctor.prototype).constructor;
    }
    return null;
}
function resolveProperties(object) {
    return __awaiter(this, void 0, void 0, function*() {
        const promises = Object.keys(object).map((key)=>{
            const value = object[key];
            return Promise.resolve(value).then((v)=>({
                    key: key,
                    value: v
                }));
        });
        const results = yield Promise.all(promises);
        return results.reduce((accum, result)=>{
            accum[result.key] = result.value;
            return accum;
        }, {});
    });
}
function checkProperties(object, properties) {
    if (!object || typeof object !== "object") logger.throwArgumentError("invalid object", "object", object);
    Object.keys(object).forEach((key)=>{
        if (!properties[key]) logger.throwArgumentError("invalid object key - " + key, "transaction:" + key, object);
    });
}
function shallowCopy(object) {
    const result = {};
    for(const key in object)result[key] = object[key];
    return result;
}
const opaque = {
    bigint: true,
    boolean: true,
    "function": true,
    number: true,
    string: true
};
function _isFrozen(object) {
    // Opaque objects are not mutable, so safe to copy by assignment
    if (object === undefined || object === null || opaque[typeof object]) return true;
    if (Array.isArray(object) || typeof object === "object") {
        if (!Object.isFrozen(object)) return false;
        const keys = Object.keys(object);
        for(let i = 0; i < keys.length; i++){
            let value = null;
            try {
                value = object[keys[i]];
            } catch (error) {
                continue;
            }
            if (!_isFrozen(value)) return false;
        }
        return true;
    }
    return logger.throwArgumentError(`Cannot deepCopy ${typeof object}`, "object", object);
}
// Returns a new copy of object, such that no properties may be replaced.
// New properties may be added only to objects.
function _deepCopy(object) {
    if (_isFrozen(object)) return object;
    // Arrays are mutable, so we need to create a copy
    if (Array.isArray(object)) return Object.freeze(object.map((item)=>deepCopy(item)));
    if (typeof object === "object") {
        const result = {};
        for(const key in object){
            const value = object[key];
            if (value === undefined) continue;
            defineReadOnly(result, key, deepCopy(value));
        }
        return result;
    }
    return logger.throwArgumentError(`Cannot deepCopy ${typeof object}`, "object", object);
}
function deepCopy(object) {
    return _deepCopy(object);
}
class Description {
    constructor(info){
        for(const key in info)this[key] = deepCopy(info[key]);
    }
}

},{"@ethersproject/logger":"jADah","./_version":"1Elzn","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"1Elzn":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "version", ()=>version);
const version = "properties/5.7.0";

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"fI0Q8":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "version", ()=>version);
const version = "abi/5.7.0";

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"jFGBW":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AbiCoder", ()=>AbiCoder);
parcelHelpers.export(exports, "defaultAbiCoder", ()=>defaultAbiCoder);
// See: https://github.com/ethereum/wiki/wiki/Ethereum-Contract-ABI
var _bytes = require("@ethersproject/bytes");
var _properties = require("@ethersproject/properties");
var _logger = require("@ethersproject/logger");
var _version = require("./_version");
var _abstractCoder = require("./coders/abstract-coder");
var _address = require("./coders/address");
var _array = require("./coders/array");
var _boolean = require("./coders/boolean");
var _bytes1 = require("./coders/bytes");
var _fixedBytes = require("./coders/fixed-bytes");
var _null = require("./coders/null");
var _number = require("./coders/number");
var _string = require("./coders/string");
var _tuple = require("./coders/tuple");
var _fragments = require("./fragments");
"use strict";
const logger = new (0, _logger.Logger)((0, _version.version));
const paramTypeBytes = new RegExp(/^bytes([0-9]*)$/);
const paramTypeNumber = new RegExp(/^(u?int)([0-9]*)$/);
class AbiCoder {
    constructor(coerceFunc){
        (0, _properties.defineReadOnly)(this, "coerceFunc", coerceFunc || null);
    }
    _getCoder(param) {
        switch(param.baseType){
            case "address":
                return new (0, _address.AddressCoder)(param.name);
            case "bool":
                return new (0, _boolean.BooleanCoder)(param.name);
            case "string":
                return new (0, _string.StringCoder)(param.name);
            case "bytes":
                return new (0, _bytes1.BytesCoder)(param.name);
            case "array":
                return new (0, _array.ArrayCoder)(this._getCoder(param.arrayChildren), param.arrayLength, param.name);
            case "tuple":
                return new (0, _tuple.TupleCoder)((param.components || []).map((component)=>{
                    return this._getCoder(component);
                }), param.name);
            case "":
                return new (0, _null.NullCoder)(param.name);
        }
        // u?int[0-9]*
        let match = param.type.match(paramTypeNumber);
        if (match) {
            let size = parseInt(match[2] || "256");
            if (size === 0 || size > 256 || size % 8 !== 0) logger.throwArgumentError("invalid " + match[1] + " bit length", "param", param);
            return new (0, _number.NumberCoder)(size / 8, match[1] === "int", param.name);
        }
        // bytes[0-9]+
        match = param.type.match(paramTypeBytes);
        if (match) {
            let size = parseInt(match[1]);
            if (size === 0 || size > 32) logger.throwArgumentError("invalid bytes length", "param", param);
            return new (0, _fixedBytes.FixedBytesCoder)(size, param.name);
        }
        return logger.throwArgumentError("invalid type", "type", param.type);
    }
    _getWordSize() {
        return 32;
    }
    _getReader(data, allowLoose) {
        return new (0, _abstractCoder.Reader)(data, this._getWordSize(), this.coerceFunc, allowLoose);
    }
    _getWriter() {
        return new (0, _abstractCoder.Writer)(this._getWordSize());
    }
    getDefaultValue(types) {
        const coders = types.map((type)=>this._getCoder((0, _fragments.ParamType).from(type)));
        const coder = new (0, _tuple.TupleCoder)(coders, "_");
        return coder.defaultValue();
    }
    encode(types, values) {
        if (types.length !== values.length) logger.throwError("types/values length mismatch", (0, _logger.Logger).errors.INVALID_ARGUMENT, {
            count: {
                types: types.length,
                values: values.length
            },
            value: {
                types: types,
                values: values
            }
        });
        const coders = types.map((type)=>this._getCoder((0, _fragments.ParamType).from(type)));
        const coder = new (0, _tuple.TupleCoder)(coders, "_");
        const writer = this._getWriter();
        coder.encode(writer, values);
        return writer.data;
    }
    decode(types, data, loose) {
        const coders = types.map((type)=>this._getCoder((0, _fragments.ParamType).from(type)));
        const coder = new (0, _tuple.TupleCoder)(coders, "_");
        return coder.decode(this._getReader((0, _bytes.arrayify)(data), loose));
    }
}
const defaultAbiCoder = new AbiCoder();

},{"@ethersproject/bytes":"4xCgN","@ethersproject/properties":"016Tj","@ethersproject/logger":"jADah","./_version":"fI0Q8","./coders/abstract-coder":"2f9zv","./coders/address":"DpFWc","./coders/array":"2M9jf","./coders/boolean":"iJaNf","./coders/bytes":"2hbOn","./coders/fixed-bytes":"i8yh4","./coders/null":"kYhlL","./coders/number":"hHewr","./coders/string":"bBha8","./coders/tuple":"w68kH","./fragments":"5nqWe","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2f9zv":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "checkResultErrors", ()=>checkResultErrors);
parcelHelpers.export(exports, "Coder", ()=>Coder);
parcelHelpers.export(exports, "Writer", ()=>Writer);
parcelHelpers.export(exports, "Reader", ()=>Reader);
var _bytes = require("@ethersproject/bytes");
var _bignumber = require("@ethersproject/bignumber");
var _properties = require("@ethersproject/properties");
var _logger = require("@ethersproject/logger");
var _version = require("../_version");
"use strict";
const logger = new (0, _logger.Logger)((0, _version.version));
function checkResultErrors(result) {
    // Find the first error (if any)
    const errors = [];
    const checkErrors = function(path, object) {
        if (!Array.isArray(object)) return;
        for(let key in object){
            const childPath = path.slice();
            childPath.push(key);
            try {
                checkErrors(childPath, object[key]);
            } catch (error) {
                errors.push({
                    path: childPath,
                    error: error
                });
            }
        }
    };
    checkErrors([], result);
    return errors;
}
class Coder {
    constructor(name, type, localName, dynamic){
        // @TODO: defineReadOnly these
        this.name = name;
        this.type = type;
        this.localName = localName;
        this.dynamic = dynamic;
    }
    _throwError(message, value) {
        logger.throwArgumentError(message, this.localName, value);
    }
}
class Writer {
    constructor(wordSize){
        (0, _properties.defineReadOnly)(this, "wordSize", wordSize || 32);
        this._data = [];
        this._dataLength = 0;
        this._padding = new Uint8Array(wordSize);
    }
    get data() {
        return (0, _bytes.hexConcat)(this._data);
    }
    get length() {
        return this._dataLength;
    }
    _writeData(data) {
        this._data.push(data);
        this._dataLength += data.length;
        return data.length;
    }
    appendWriter(writer) {
        return this._writeData((0, _bytes.concat)(writer._data));
    }
    // Arrayish items; padded on the right to wordSize
    writeBytes(value) {
        let bytes = (0, _bytes.arrayify)(value);
        const paddingOffset = bytes.length % this.wordSize;
        if (paddingOffset) bytes = (0, _bytes.concat)([
            bytes,
            this._padding.slice(paddingOffset)
        ]);
        return this._writeData(bytes);
    }
    _getValue(value) {
        let bytes = (0, _bytes.arrayify)((0, _bignumber.BigNumber).from(value));
        if (bytes.length > this.wordSize) logger.throwError("value out-of-bounds", (0, _logger.Logger).errors.BUFFER_OVERRUN, {
            length: this.wordSize,
            offset: bytes.length
        });
        if (bytes.length % this.wordSize) bytes = (0, _bytes.concat)([
            this._padding.slice(bytes.length % this.wordSize),
            bytes
        ]);
        return bytes;
    }
    // BigNumberish items; padded on the left to wordSize
    writeValue(value) {
        return this._writeData(this._getValue(value));
    }
    writeUpdatableValue() {
        const offset = this._data.length;
        this._data.push(this._padding);
        this._dataLength += this.wordSize;
        return (value)=>{
            this._data[offset] = this._getValue(value);
        };
    }
}
class Reader {
    constructor(data, wordSize, coerceFunc, allowLoose){
        (0, _properties.defineReadOnly)(this, "_data", (0, _bytes.arrayify)(data));
        (0, _properties.defineReadOnly)(this, "wordSize", wordSize || 32);
        (0, _properties.defineReadOnly)(this, "_coerceFunc", coerceFunc);
        (0, _properties.defineReadOnly)(this, "allowLoose", allowLoose);
        this._offset = 0;
    }
    get data() {
        return (0, _bytes.hexlify)(this._data);
    }
    get consumed() {
        return this._offset;
    }
    // The default Coerce function
    static coerce(name, value) {
        let match = name.match("^u?int([0-9]+)$");
        if (match && parseInt(match[1]) <= 48) value = value.toNumber();
        return value;
    }
    coerce(name, value) {
        if (this._coerceFunc) return this._coerceFunc(name, value);
        return Reader.coerce(name, value);
    }
    _peekBytes(offset, length, loose) {
        let alignedLength = Math.ceil(length / this.wordSize) * this.wordSize;
        if (this._offset + alignedLength > this._data.length) {
            if (this.allowLoose && loose && this._offset + length <= this._data.length) alignedLength = length;
            else logger.throwError("data out-of-bounds", (0, _logger.Logger).errors.BUFFER_OVERRUN, {
                length: this._data.length,
                offset: this._offset + alignedLength
            });
        }
        return this._data.slice(this._offset, this._offset + alignedLength);
    }
    subReader(offset) {
        return new Reader(this._data.slice(this._offset + offset), this.wordSize, this._coerceFunc, this.allowLoose);
    }
    readBytes(length, loose) {
        let bytes = this._peekBytes(0, length, !!loose);
        this._offset += bytes.length;
        // @TODO: Make sure the length..end bytes are all 0?
        return bytes.slice(0, length);
    }
    readValue() {
        return (0, _bignumber.BigNumber).from(this.readBytes(this.wordSize));
    }
}

},{"@ethersproject/bytes":"4xCgN","@ethersproject/bignumber":"fUhf1","@ethersproject/properties":"016Tj","@ethersproject/logger":"jADah","../_version":"fI0Q8","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"DpFWc":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AddressCoder", ()=>AddressCoder);
var _address = require("@ethersproject/address");
var _bytes = require("@ethersproject/bytes");
var _abstractCoder = require("./abstract-coder");
"use strict";
class AddressCoder extends (0, _abstractCoder.Coder) {
    constructor(localName){
        super("address", "address", localName, false);
    }
    defaultValue() {
        return "0x0000000000000000000000000000000000000000";
    }
    encode(writer, value) {
        try {
            value = (0, _address.getAddress)(value);
        } catch (error) {
            this._throwError(error.message, value);
        }
        return writer.writeValue(value);
    }
    decode(reader) {
        return (0, _address.getAddress)((0, _bytes.hexZeroPad)(reader.readValue().toHexString(), 20));
    }
}

},{"@ethersproject/address":"4jHq7","@ethersproject/bytes":"4xCgN","./abstract-coder":"2f9zv","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4jHq7":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getAddress", ()=>getAddress);
parcelHelpers.export(exports, "isAddress", ()=>isAddress);
parcelHelpers.export(exports, "getIcapAddress", ()=>getIcapAddress);
// http://ethereum.stackexchange.com/questions/760/how-is-the-address-of-an-ethereum-contract-computed
parcelHelpers.export(exports, "getContractAddress", ()=>getContractAddress);
parcelHelpers.export(exports, "getCreate2Address", ()=>getCreate2Address);
var _bytes = require("@ethersproject/bytes");
var _bignumber = require("@ethersproject/bignumber");
var _keccak256 = require("@ethersproject/keccak256");
var _rlp = require("@ethersproject/rlp");
var _logger = require("@ethersproject/logger");
var _version = require("./_version");
"use strict";
const logger = new (0, _logger.Logger)((0, _version.version));
function getChecksumAddress(address) {
    if (!(0, _bytes.isHexString)(address, 20)) logger.throwArgumentError("invalid address", "address", address);
    address = address.toLowerCase();
    const chars = address.substring(2).split("");
    const expanded = new Uint8Array(40);
    for(let i = 0; i < 40; i++)expanded[i] = chars[i].charCodeAt(0);
    const hashed = (0, _bytes.arrayify)((0, _keccak256.keccak256)(expanded));
    for(let i = 0; i < 40; i += 2){
        if (hashed[i >> 1] >> 4 >= 8) chars[i] = chars[i].toUpperCase();
        if ((hashed[i >> 1] & 0x0f) >= 8) chars[i + 1] = chars[i + 1].toUpperCase();
    }
    return "0x" + chars.join("");
}
// Shims for environments that are missing some required constants and functions
const MAX_SAFE_INTEGER = 0x1fffffffffffff;
function log10(x) {
    if (Math.log10) return Math.log10(x);
    return Math.log(x) / Math.LN10;
}
// See: https://en.wikipedia.org/wiki/International_Bank_Account_Number
// Create lookup table
const ibanLookup = {};
for(let i = 0; i < 10; i++)ibanLookup[String(i)] = String(i);
for(let i = 0; i < 26; i++)ibanLookup[String.fromCharCode(65 + i)] = String(10 + i);
// How many decimal digits can we process? (for 64-bit float, this is 15)
const safeDigits = Math.floor(log10(MAX_SAFE_INTEGER));
function ibanChecksum(address) {
    address = address.toUpperCase();
    address = address.substring(4) + address.substring(0, 2) + "00";
    let expanded = address.split("").map((c)=>{
        return ibanLookup[c];
    }).join("");
    // Javascript can handle integers safely up to 15 (decimal) digits
    while(expanded.length >= safeDigits){
        let block = expanded.substring(0, safeDigits);
        expanded = parseInt(block, 10) % 97 + expanded.substring(block.length);
    }
    let checksum = String(98 - parseInt(expanded, 10) % 97);
    while(checksum.length < 2)checksum = "0" + checksum;
    return checksum;
}
function getAddress(address) {
    let result = null;
    if (typeof address !== "string") logger.throwArgumentError("invalid address", "address", address);
    if (address.match(/^(0x)?[0-9a-fA-F]{40}$/)) {
        // Missing the 0x prefix
        if (address.substring(0, 2) !== "0x") address = "0x" + address;
        result = getChecksumAddress(address);
        // It is a checksummed address with a bad checksum
        if (address.match(/([A-F].*[a-f])|([a-f].*[A-F])/) && result !== address) logger.throwArgumentError("bad address checksum", "address", address);
    // Maybe ICAP? (we only support direct mode)
    } else if (address.match(/^XE[0-9]{2}[0-9A-Za-z]{30,31}$/)) {
        // It is an ICAP address with a bad checksum
        if (address.substring(2, 4) !== ibanChecksum(address)) logger.throwArgumentError("bad icap checksum", "address", address);
        result = (0, _bignumber._base36To16)(address.substring(4));
        while(result.length < 40)result = "0" + result;
        result = getChecksumAddress("0x" + result);
    } else logger.throwArgumentError("invalid address", "address", address);
    return result;
}
function isAddress(address) {
    try {
        getAddress(address);
        return true;
    } catch (error) {}
    return false;
}
function getIcapAddress(address) {
    let base36 = (0, _bignumber._base16To36)(getAddress(address).substring(2)).toUpperCase();
    while(base36.length < 30)base36 = "0" + base36;
    return "XE" + ibanChecksum("XE00" + base36) + base36;
}
function getContractAddress(transaction) {
    let from = null;
    try {
        from = getAddress(transaction.from);
    } catch (error) {
        logger.throwArgumentError("missing from address", "transaction", transaction);
    }
    const nonce = (0, _bytes.stripZeros)((0, _bytes.arrayify)((0, _bignumber.BigNumber).from(transaction.nonce).toHexString()));
    return getAddress((0, _bytes.hexDataSlice)((0, _keccak256.keccak256)((0, _rlp.encode)([
        from,
        nonce
    ])), 12));
}
function getCreate2Address(from, salt, initCodeHash) {
    if ((0, _bytes.hexDataLength)(salt) !== 32) logger.throwArgumentError("salt must be 32 bytes", "salt", salt);
    if ((0, _bytes.hexDataLength)(initCodeHash) !== 32) logger.throwArgumentError("initCodeHash must be 32 bytes", "initCodeHash", initCodeHash);
    return getAddress((0, _bytes.hexDataSlice)((0, _keccak256.keccak256)((0, _bytes.concat)([
        "0xff",
        getAddress(from),
        salt,
        initCodeHash
    ])), 12));
}

},{"@ethersproject/bytes":"4xCgN","@ethersproject/bignumber":"fUhf1","@ethersproject/keccak256":"jDqTa","@ethersproject/rlp":"ciscP","@ethersproject/logger":"jADah","./_version":"d5xgo","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"jDqTa":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "keccak256", ()=>keccak256);
var _jsSha3 = require("js-sha3");
var _jsSha3Default = parcelHelpers.interopDefault(_jsSha3);
var _bytes = require("@ethersproject/bytes");
"use strict";
function keccak256(data) {
    return "0x" + (0, _jsSha3Default.default).keccak_256((0, _bytes.arrayify)(data));
}

},{"js-sha3":"hqGBR","@ethersproject/bytes":"4xCgN","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"hqGBR":[function(require,module,exports) {
var process = require("5defb539e98cbde3");
var global = arguments[3];
/**
 * [js-sha3]{@link https://github.com/emn178/js-sha3}
 *
 * @version 0.8.0
 * @author Chen, Yi-Cyuan [emn178@gmail.com]
 * @copyright Chen, Yi-Cyuan 2015-2018
 * @license MIT
 */ /*jslint bitwise: true */ (function() {
    "use strict";
    var INPUT_ERROR = "input is invalid type";
    var FINALIZE_ERROR = "finalize already called";
    var WINDOW = typeof window === "object";
    var root = WINDOW ? window : {};
    if (root.JS_SHA3_NO_WINDOW) WINDOW = false;
    var WEB_WORKER = !WINDOW && typeof self === "object";
    var NODE_JS = !root.JS_SHA3_NO_NODE_JS && typeof process === "object" && process.versions && process.versions.node;
    if (NODE_JS) root = global;
    else if (WEB_WORKER) root = self;
    var COMMON_JS = !root.JS_SHA3_NO_COMMON_JS && true && module.exports;
    var AMD = typeof define === "function" && define.amd;
    var ARRAY_BUFFER = !root.JS_SHA3_NO_ARRAY_BUFFER && typeof ArrayBuffer !== "undefined";
    var HEX_CHARS = "0123456789abcdef".split("");
    var SHAKE_PADDING = [
        31,
        7936,
        2031616,
        520093696
    ];
    var CSHAKE_PADDING = [
        4,
        1024,
        262144,
        67108864
    ];
    var KECCAK_PADDING = [
        1,
        256,
        65536,
        16777216
    ];
    var PADDING = [
        6,
        1536,
        393216,
        100663296
    ];
    var SHIFT = [
        0,
        8,
        16,
        24
    ];
    var RC = [
        1,
        0,
        32898,
        0,
        32906,
        2147483648,
        2147516416,
        2147483648,
        32907,
        0,
        2147483649,
        0,
        2147516545,
        2147483648,
        32777,
        2147483648,
        138,
        0,
        136,
        0,
        2147516425,
        0,
        2147483658,
        0,
        2147516555,
        0,
        139,
        2147483648,
        32905,
        2147483648,
        32771,
        2147483648,
        32770,
        2147483648,
        128,
        2147483648,
        32778,
        0,
        2147483658,
        2147483648,
        2147516545,
        2147483648,
        32896,
        2147483648,
        2147483649,
        0,
        2147516424,
        2147483648
    ];
    var BITS = [
        224,
        256,
        384,
        512
    ];
    var SHAKE_BITS = [
        128,
        256
    ];
    var OUTPUT_TYPES = [
        "hex",
        "buffer",
        "arrayBuffer",
        "array",
        "digest"
    ];
    var CSHAKE_BYTEPAD = {
        "128": 168,
        "256": 136
    };
    if (root.JS_SHA3_NO_NODE_JS || !Array.isArray) Array.isArray = function(obj) {
        return Object.prototype.toString.call(obj) === "[object Array]";
    };
    if (ARRAY_BUFFER && (root.JS_SHA3_NO_ARRAY_BUFFER_IS_VIEW || !ArrayBuffer.isView)) ArrayBuffer.isView = function(obj) {
        return typeof obj === "object" && obj.buffer && obj.buffer.constructor === ArrayBuffer;
    };
    var createOutputMethod = function(bits, padding, outputType) {
        return function(message) {
            return new Keccak(bits, padding, bits).update(message)[outputType]();
        };
    };
    var createShakeOutputMethod = function(bits, padding, outputType) {
        return function(message, outputBits) {
            return new Keccak(bits, padding, outputBits).update(message)[outputType]();
        };
    };
    var createCshakeOutputMethod = function(bits, padding, outputType) {
        return function(message, outputBits, n, s) {
            return methods["cshake" + bits].update(message, outputBits, n, s)[outputType]();
        };
    };
    var createKmacOutputMethod = function(bits, padding, outputType) {
        return function(key, message, outputBits, s) {
            return methods["kmac" + bits].update(key, message, outputBits, s)[outputType]();
        };
    };
    var createOutputMethods = function(method, createMethod, bits, padding) {
        for(var i = 0; i < OUTPUT_TYPES.length; ++i){
            var type = OUTPUT_TYPES[i];
            method[type] = createMethod(bits, padding, type);
        }
        return method;
    };
    var createMethod = function(bits, padding) {
        var method = createOutputMethod(bits, padding, "hex");
        method.create = function() {
            return new Keccak(bits, padding, bits);
        };
        method.update = function(message) {
            return method.create().update(message);
        };
        return createOutputMethods(method, createOutputMethod, bits, padding);
    };
    var createShakeMethod = function(bits, padding) {
        var method = createShakeOutputMethod(bits, padding, "hex");
        method.create = function(outputBits) {
            return new Keccak(bits, padding, outputBits);
        };
        method.update = function(message, outputBits) {
            return method.create(outputBits).update(message);
        };
        return createOutputMethods(method, createShakeOutputMethod, bits, padding);
    };
    var createCshakeMethod = function(bits, padding) {
        var w = CSHAKE_BYTEPAD[bits];
        var method = createCshakeOutputMethod(bits, padding, "hex");
        method.create = function(outputBits, n, s) {
            if (!n && !s) return methods["shake" + bits].create(outputBits);
            else return new Keccak(bits, padding, outputBits).bytepad([
                n,
                s
            ], w);
        };
        method.update = function(message, outputBits, n, s) {
            return method.create(outputBits, n, s).update(message);
        };
        return createOutputMethods(method, createCshakeOutputMethod, bits, padding);
    };
    var createKmacMethod = function(bits, padding) {
        var w = CSHAKE_BYTEPAD[bits];
        var method = createKmacOutputMethod(bits, padding, "hex");
        method.create = function(key, outputBits, s) {
            return new Kmac(bits, padding, outputBits).bytepad([
                "KMAC",
                s
            ], w).bytepad([
                key
            ], w);
        };
        method.update = function(key, message, outputBits, s) {
            return method.create(key, outputBits, s).update(message);
        };
        return createOutputMethods(method, createKmacOutputMethod, bits, padding);
    };
    var algorithms = [
        {
            name: "keccak",
            padding: KECCAK_PADDING,
            bits: BITS,
            createMethod: createMethod
        },
        {
            name: "sha3",
            padding: PADDING,
            bits: BITS,
            createMethod: createMethod
        },
        {
            name: "shake",
            padding: SHAKE_PADDING,
            bits: SHAKE_BITS,
            createMethod: createShakeMethod
        },
        {
            name: "cshake",
            padding: CSHAKE_PADDING,
            bits: SHAKE_BITS,
            createMethod: createCshakeMethod
        },
        {
            name: "kmac",
            padding: CSHAKE_PADDING,
            bits: SHAKE_BITS,
            createMethod: createKmacMethod
        }
    ];
    var methods = {}, methodNames = [];
    for(var i = 0; i < algorithms.length; ++i){
        var algorithm = algorithms[i];
        var bits = algorithm.bits;
        for(var j = 0; j < bits.length; ++j){
            var methodName = algorithm.name + "_" + bits[j];
            methodNames.push(methodName);
            methods[methodName] = algorithm.createMethod(bits[j], algorithm.padding);
            if (algorithm.name !== "sha3") {
                var newMethodName = algorithm.name + bits[j];
                methodNames.push(newMethodName);
                methods[newMethodName] = methods[methodName];
            }
        }
    }
    function Keccak(bits, padding, outputBits) {
        this.blocks = [];
        this.s = [];
        this.padding = padding;
        this.outputBits = outputBits;
        this.reset = true;
        this.finalized = false;
        this.block = 0;
        this.start = 0;
        this.blockCount = 1600 - (bits << 1) >> 5;
        this.byteCount = this.blockCount << 2;
        this.outputBlocks = outputBits >> 5;
        this.extraBytes = (outputBits & 31) >> 3;
        for(var i = 0; i < 50; ++i)this.s[i] = 0;
    }
    Keccak.prototype.update = function(message) {
        if (this.finalized) throw new Error(FINALIZE_ERROR);
        var notString, type = typeof message;
        if (type !== "string") {
            if (type === "object") {
                if (message === null) throw new Error(INPUT_ERROR);
                else if (ARRAY_BUFFER && message.constructor === ArrayBuffer) message = new Uint8Array(message);
                else if (!Array.isArray(message)) {
                    if (!ARRAY_BUFFER || !ArrayBuffer.isView(message)) throw new Error(INPUT_ERROR);
                }
            } else throw new Error(INPUT_ERROR);
            notString = true;
        }
        var blocks = this.blocks, byteCount = this.byteCount, length = message.length, blockCount = this.blockCount, index = 0, s = this.s, i, code;
        while(index < length){
            if (this.reset) {
                this.reset = false;
                blocks[0] = this.block;
                for(i = 1; i < blockCount + 1; ++i)blocks[i] = 0;
            }
            if (notString) for(i = this.start; index < length && i < byteCount; ++index)blocks[i >> 2] |= message[index] << SHIFT[i++ & 3];
            else for(i = this.start; index < length && i < byteCount; ++index){
                code = message.charCodeAt(index);
                if (code < 0x80) blocks[i >> 2] |= code << SHIFT[i++ & 3];
                else if (code < 0x800) {
                    blocks[i >> 2] |= (0xc0 | code >> 6) << SHIFT[i++ & 3];
                    blocks[i >> 2] |= (0x80 | code & 0x3f) << SHIFT[i++ & 3];
                } else if (code < 0xd800 || code >= 0xe000) {
                    blocks[i >> 2] |= (0xe0 | code >> 12) << SHIFT[i++ & 3];
                    blocks[i >> 2] |= (0x80 | code >> 6 & 0x3f) << SHIFT[i++ & 3];
                    blocks[i >> 2] |= (0x80 | code & 0x3f) << SHIFT[i++ & 3];
                } else {
                    code = 0x10000 + ((code & 0x3ff) << 10 | message.charCodeAt(++index) & 0x3ff);
                    blocks[i >> 2] |= (0xf0 | code >> 18) << SHIFT[i++ & 3];
                    blocks[i >> 2] |= (0x80 | code >> 12 & 0x3f) << SHIFT[i++ & 3];
                    blocks[i >> 2] |= (0x80 | code >> 6 & 0x3f) << SHIFT[i++ & 3];
                    blocks[i >> 2] |= (0x80 | code & 0x3f) << SHIFT[i++ & 3];
                }
            }
            this.lastByteIndex = i;
            if (i >= byteCount) {
                this.start = i - byteCount;
                this.block = blocks[blockCount];
                for(i = 0; i < blockCount; ++i)s[i] ^= blocks[i];
                f(s);
                this.reset = true;
            } else this.start = i;
        }
        return this;
    };
    Keccak.prototype.encode = function(x, right) {
        var o = x & 255, n = 1;
        var bytes = [
            o
        ];
        x = x >> 8;
        o = x & 255;
        while(o > 0){
            bytes.unshift(o);
            x = x >> 8;
            o = x & 255;
            ++n;
        }
        if (right) bytes.push(n);
        else bytes.unshift(n);
        this.update(bytes);
        return bytes.length;
    };
    Keccak.prototype.encodeString = function(str) {
        var notString, type = typeof str;
        if (type !== "string") {
            if (type === "object") {
                if (str === null) throw new Error(INPUT_ERROR);
                else if (ARRAY_BUFFER && str.constructor === ArrayBuffer) str = new Uint8Array(str);
                else if (!Array.isArray(str)) {
                    if (!ARRAY_BUFFER || !ArrayBuffer.isView(str)) throw new Error(INPUT_ERROR);
                }
            } else throw new Error(INPUT_ERROR);
            notString = true;
        }
        var bytes = 0, length = str.length;
        if (notString) bytes = length;
        else for(var i = 0; i < str.length; ++i){
            var code = str.charCodeAt(i);
            if (code < 0x80) bytes += 1;
            else if (code < 0x800) bytes += 2;
            else if (code < 0xd800 || code >= 0xe000) bytes += 3;
            else {
                code = 0x10000 + ((code & 0x3ff) << 10 | str.charCodeAt(++i) & 0x3ff);
                bytes += 4;
            }
        }
        bytes += this.encode(bytes * 8);
        this.update(str);
        return bytes;
    };
    Keccak.prototype.bytepad = function(strs, w) {
        var bytes = this.encode(w);
        for(var i = 0; i < strs.length; ++i)bytes += this.encodeString(strs[i]);
        var paddingBytes = w - bytes % w;
        var zeros = [];
        zeros.length = paddingBytes;
        this.update(zeros);
        return this;
    };
    Keccak.prototype.finalize = function() {
        if (this.finalized) return;
        this.finalized = true;
        var blocks = this.blocks, i = this.lastByteIndex, blockCount = this.blockCount, s = this.s;
        blocks[i >> 2] |= this.padding[i & 3];
        if (this.lastByteIndex === this.byteCount) {
            blocks[0] = blocks[blockCount];
            for(i = 1; i < blockCount + 1; ++i)blocks[i] = 0;
        }
        blocks[blockCount - 1] |= 0x80000000;
        for(i = 0; i < blockCount; ++i)s[i] ^= blocks[i];
        f(s);
    };
    Keccak.prototype.toString = Keccak.prototype.hex = function() {
        this.finalize();
        var blockCount = this.blockCount, s = this.s, outputBlocks = this.outputBlocks, extraBytes = this.extraBytes, i = 0, j = 0;
        var hex = "", block;
        while(j < outputBlocks){
            for(i = 0; i < blockCount && j < outputBlocks; ++i, ++j){
                block = s[i];
                hex += HEX_CHARS[block >> 4 & 0x0F] + HEX_CHARS[block & 0x0F] + HEX_CHARS[block >> 12 & 0x0F] + HEX_CHARS[block >> 8 & 0x0F] + HEX_CHARS[block >> 20 & 0x0F] + HEX_CHARS[block >> 16 & 0x0F] + HEX_CHARS[block >> 28 & 0x0F] + HEX_CHARS[block >> 24 & 0x0F];
            }
            if (j % blockCount === 0) {
                f(s);
                i = 0;
            }
        }
        if (extraBytes) {
            block = s[i];
            hex += HEX_CHARS[block >> 4 & 0x0F] + HEX_CHARS[block & 0x0F];
            if (extraBytes > 1) hex += HEX_CHARS[block >> 12 & 0x0F] + HEX_CHARS[block >> 8 & 0x0F];
            if (extraBytes > 2) hex += HEX_CHARS[block >> 20 & 0x0F] + HEX_CHARS[block >> 16 & 0x0F];
        }
        return hex;
    };
    Keccak.prototype.arrayBuffer = function() {
        this.finalize();
        var blockCount = this.blockCount, s = this.s, outputBlocks = this.outputBlocks, extraBytes = this.extraBytes, i = 0, j = 0;
        var bytes = this.outputBits >> 3;
        var buffer;
        if (extraBytes) buffer = new ArrayBuffer(outputBlocks + 1 << 2);
        else buffer = new ArrayBuffer(bytes);
        var array = new Uint32Array(buffer);
        while(j < outputBlocks){
            for(i = 0; i < blockCount && j < outputBlocks; ++i, ++j)array[j] = s[i];
            if (j % blockCount === 0) f(s);
        }
        if (extraBytes) {
            array[i] = s[i];
            buffer = buffer.slice(0, bytes);
        }
        return buffer;
    };
    Keccak.prototype.buffer = Keccak.prototype.arrayBuffer;
    Keccak.prototype.digest = Keccak.prototype.array = function() {
        this.finalize();
        var blockCount = this.blockCount, s = this.s, outputBlocks = this.outputBlocks, extraBytes = this.extraBytes, i = 0, j = 0;
        var array = [], offset, block;
        while(j < outputBlocks){
            for(i = 0; i < blockCount && j < outputBlocks; ++i, ++j){
                offset = j << 2;
                block = s[i];
                array[offset] = block & 0xFF;
                array[offset + 1] = block >> 8 & 0xFF;
                array[offset + 2] = block >> 16 & 0xFF;
                array[offset + 3] = block >> 24 & 0xFF;
            }
            if (j % blockCount === 0) f(s);
        }
        if (extraBytes) {
            offset = j << 2;
            block = s[i];
            array[offset] = block & 0xFF;
            if (extraBytes > 1) array[offset + 1] = block >> 8 & 0xFF;
            if (extraBytes > 2) array[offset + 2] = block >> 16 & 0xFF;
        }
        return array;
    };
    function Kmac(bits, padding, outputBits) {
        Keccak.call(this, bits, padding, outputBits);
    }
    Kmac.prototype = new Keccak();
    Kmac.prototype.finalize = function() {
        this.encode(this.outputBits, true);
        return Keccak.prototype.finalize.call(this);
    };
    var f = function(s) {
        var h, l, n, c0, c1, c2, c3, c4, c5, c6, c7, c8, c9, b0, b1, b2, b3, b4, b5, b6, b7, b8, b9, b10, b11, b12, b13, b14, b15, b16, b17, b18, b19, b20, b21, b22, b23, b24, b25, b26, b27, b28, b29, b30, b31, b32, b33, b34, b35, b36, b37, b38, b39, b40, b41, b42, b43, b44, b45, b46, b47, b48, b49;
        for(n = 0; n < 48; n += 2){
            c0 = s[0] ^ s[10] ^ s[20] ^ s[30] ^ s[40];
            c1 = s[1] ^ s[11] ^ s[21] ^ s[31] ^ s[41];
            c2 = s[2] ^ s[12] ^ s[22] ^ s[32] ^ s[42];
            c3 = s[3] ^ s[13] ^ s[23] ^ s[33] ^ s[43];
            c4 = s[4] ^ s[14] ^ s[24] ^ s[34] ^ s[44];
            c5 = s[5] ^ s[15] ^ s[25] ^ s[35] ^ s[45];
            c6 = s[6] ^ s[16] ^ s[26] ^ s[36] ^ s[46];
            c7 = s[7] ^ s[17] ^ s[27] ^ s[37] ^ s[47];
            c8 = s[8] ^ s[18] ^ s[28] ^ s[38] ^ s[48];
            c9 = s[9] ^ s[19] ^ s[29] ^ s[39] ^ s[49];
            h = c8 ^ (c2 << 1 | c3 >>> 31);
            l = c9 ^ (c3 << 1 | c2 >>> 31);
            s[0] ^= h;
            s[1] ^= l;
            s[10] ^= h;
            s[11] ^= l;
            s[20] ^= h;
            s[21] ^= l;
            s[30] ^= h;
            s[31] ^= l;
            s[40] ^= h;
            s[41] ^= l;
            h = c0 ^ (c4 << 1 | c5 >>> 31);
            l = c1 ^ (c5 << 1 | c4 >>> 31);
            s[2] ^= h;
            s[3] ^= l;
            s[12] ^= h;
            s[13] ^= l;
            s[22] ^= h;
            s[23] ^= l;
            s[32] ^= h;
            s[33] ^= l;
            s[42] ^= h;
            s[43] ^= l;
            h = c2 ^ (c6 << 1 | c7 >>> 31);
            l = c3 ^ (c7 << 1 | c6 >>> 31);
            s[4] ^= h;
            s[5] ^= l;
            s[14] ^= h;
            s[15] ^= l;
            s[24] ^= h;
            s[25] ^= l;
            s[34] ^= h;
            s[35] ^= l;
            s[44] ^= h;
            s[45] ^= l;
            h = c4 ^ (c8 << 1 | c9 >>> 31);
            l = c5 ^ (c9 << 1 | c8 >>> 31);
            s[6] ^= h;
            s[7] ^= l;
            s[16] ^= h;
            s[17] ^= l;
            s[26] ^= h;
            s[27] ^= l;
            s[36] ^= h;
            s[37] ^= l;
            s[46] ^= h;
            s[47] ^= l;
            h = c6 ^ (c0 << 1 | c1 >>> 31);
            l = c7 ^ (c1 << 1 | c0 >>> 31);
            s[8] ^= h;
            s[9] ^= l;
            s[18] ^= h;
            s[19] ^= l;
            s[28] ^= h;
            s[29] ^= l;
            s[38] ^= h;
            s[39] ^= l;
            s[48] ^= h;
            s[49] ^= l;
            b0 = s[0];
            b1 = s[1];
            b32 = s[11] << 4 | s[10] >>> 28;
            b33 = s[10] << 4 | s[11] >>> 28;
            b14 = s[20] << 3 | s[21] >>> 29;
            b15 = s[21] << 3 | s[20] >>> 29;
            b46 = s[31] << 9 | s[30] >>> 23;
            b47 = s[30] << 9 | s[31] >>> 23;
            b28 = s[40] << 18 | s[41] >>> 14;
            b29 = s[41] << 18 | s[40] >>> 14;
            b20 = s[2] << 1 | s[3] >>> 31;
            b21 = s[3] << 1 | s[2] >>> 31;
            b2 = s[13] << 12 | s[12] >>> 20;
            b3 = s[12] << 12 | s[13] >>> 20;
            b34 = s[22] << 10 | s[23] >>> 22;
            b35 = s[23] << 10 | s[22] >>> 22;
            b16 = s[33] << 13 | s[32] >>> 19;
            b17 = s[32] << 13 | s[33] >>> 19;
            b48 = s[42] << 2 | s[43] >>> 30;
            b49 = s[43] << 2 | s[42] >>> 30;
            b40 = s[5] << 30 | s[4] >>> 2;
            b41 = s[4] << 30 | s[5] >>> 2;
            b22 = s[14] << 6 | s[15] >>> 26;
            b23 = s[15] << 6 | s[14] >>> 26;
            b4 = s[25] << 11 | s[24] >>> 21;
            b5 = s[24] << 11 | s[25] >>> 21;
            b36 = s[34] << 15 | s[35] >>> 17;
            b37 = s[35] << 15 | s[34] >>> 17;
            b18 = s[45] << 29 | s[44] >>> 3;
            b19 = s[44] << 29 | s[45] >>> 3;
            b10 = s[6] << 28 | s[7] >>> 4;
            b11 = s[7] << 28 | s[6] >>> 4;
            b42 = s[17] << 23 | s[16] >>> 9;
            b43 = s[16] << 23 | s[17] >>> 9;
            b24 = s[26] << 25 | s[27] >>> 7;
            b25 = s[27] << 25 | s[26] >>> 7;
            b6 = s[36] << 21 | s[37] >>> 11;
            b7 = s[37] << 21 | s[36] >>> 11;
            b38 = s[47] << 24 | s[46] >>> 8;
            b39 = s[46] << 24 | s[47] >>> 8;
            b30 = s[8] << 27 | s[9] >>> 5;
            b31 = s[9] << 27 | s[8] >>> 5;
            b12 = s[18] << 20 | s[19] >>> 12;
            b13 = s[19] << 20 | s[18] >>> 12;
            b44 = s[29] << 7 | s[28] >>> 25;
            b45 = s[28] << 7 | s[29] >>> 25;
            b26 = s[38] << 8 | s[39] >>> 24;
            b27 = s[39] << 8 | s[38] >>> 24;
            b8 = s[48] << 14 | s[49] >>> 18;
            b9 = s[49] << 14 | s[48] >>> 18;
            s[0] = b0 ^ ~b2 & b4;
            s[1] = b1 ^ ~b3 & b5;
            s[10] = b10 ^ ~b12 & b14;
            s[11] = b11 ^ ~b13 & b15;
            s[20] = b20 ^ ~b22 & b24;
            s[21] = b21 ^ ~b23 & b25;
            s[30] = b30 ^ ~b32 & b34;
            s[31] = b31 ^ ~b33 & b35;
            s[40] = b40 ^ ~b42 & b44;
            s[41] = b41 ^ ~b43 & b45;
            s[2] = b2 ^ ~b4 & b6;
            s[3] = b3 ^ ~b5 & b7;
            s[12] = b12 ^ ~b14 & b16;
            s[13] = b13 ^ ~b15 & b17;
            s[22] = b22 ^ ~b24 & b26;
            s[23] = b23 ^ ~b25 & b27;
            s[32] = b32 ^ ~b34 & b36;
            s[33] = b33 ^ ~b35 & b37;
            s[42] = b42 ^ ~b44 & b46;
            s[43] = b43 ^ ~b45 & b47;
            s[4] = b4 ^ ~b6 & b8;
            s[5] = b5 ^ ~b7 & b9;
            s[14] = b14 ^ ~b16 & b18;
            s[15] = b15 ^ ~b17 & b19;
            s[24] = b24 ^ ~b26 & b28;
            s[25] = b25 ^ ~b27 & b29;
            s[34] = b34 ^ ~b36 & b38;
            s[35] = b35 ^ ~b37 & b39;
            s[44] = b44 ^ ~b46 & b48;
            s[45] = b45 ^ ~b47 & b49;
            s[6] = b6 ^ ~b8 & b0;
            s[7] = b7 ^ ~b9 & b1;
            s[16] = b16 ^ ~b18 & b10;
            s[17] = b17 ^ ~b19 & b11;
            s[26] = b26 ^ ~b28 & b20;
            s[27] = b27 ^ ~b29 & b21;
            s[36] = b36 ^ ~b38 & b30;
            s[37] = b37 ^ ~b39 & b31;
            s[46] = b46 ^ ~b48 & b40;
            s[47] = b47 ^ ~b49 & b41;
            s[8] = b8 ^ ~b0 & b2;
            s[9] = b9 ^ ~b1 & b3;
            s[18] = b18 ^ ~b10 & b12;
            s[19] = b19 ^ ~b11 & b13;
            s[28] = b28 ^ ~b20 & b22;
            s[29] = b29 ^ ~b21 & b23;
            s[38] = b38 ^ ~b30 & b32;
            s[39] = b39 ^ ~b31 & b33;
            s[48] = b48 ^ ~b40 & b42;
            s[49] = b49 ^ ~b41 & b43;
            s[0] ^= RC[n];
            s[1] ^= RC[n + 1];
        }
    };
    if (COMMON_JS) module.exports = methods;
    else {
        for(i = 0; i < methodNames.length; ++i)root[methodNames[i]] = methods[methodNames[i]];
        if (AMD) define(function() {
            return methods;
        });
    }
})();

},{"5defb539e98cbde3":"5QIF0"}],"ciscP":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "encode", ()=>encode);
parcelHelpers.export(exports, "decode", ()=>decode);
//See: https://github.com/ethereum/wiki/wiki/RLP
var _bytes = require("@ethersproject/bytes");
var _logger = require("@ethersproject/logger");
var _version = require("./_version");
"use strict";
const logger = new (0, _logger.Logger)((0, _version.version));
function arrayifyInteger(value) {
    const result = [];
    while(value){
        result.unshift(value & 0xff);
        value >>= 8;
    }
    return result;
}
function unarrayifyInteger(data, offset, length) {
    let result = 0;
    for(let i = 0; i < length; i++)result = result * 256 + data[offset + i];
    return result;
}
function _encode(object) {
    if (Array.isArray(object)) {
        let payload = [];
        object.forEach(function(child) {
            payload = payload.concat(_encode(child));
        });
        if (payload.length <= 55) {
            payload.unshift(0xc0 + payload.length);
            return payload;
        }
        const length = arrayifyInteger(payload.length);
        length.unshift(0xf7 + length.length);
        return length.concat(payload);
    }
    if (!(0, _bytes.isBytesLike)(object)) logger.throwArgumentError("RLP object must be BytesLike", "object", object);
    const data = Array.prototype.slice.call((0, _bytes.arrayify)(object));
    if (data.length === 1 && data[0] <= 0x7f) return data;
    else if (data.length <= 55) {
        data.unshift(0x80 + data.length);
        return data;
    }
    const length = arrayifyInteger(data.length);
    length.unshift(0xb7 + length.length);
    return length.concat(data);
}
function encode(object) {
    return (0, _bytes.hexlify)(_encode(object));
}
function _decodeChildren(data, offset, childOffset, length) {
    const result = [];
    while(childOffset < offset + 1 + length){
        const decoded = _decode(data, childOffset);
        result.push(decoded.result);
        childOffset += decoded.consumed;
        if (childOffset > offset + 1 + length) logger.throwError("child data too short", (0, _logger.Logger).errors.BUFFER_OVERRUN, {});
    }
    return {
        consumed: 1 + length,
        result: result
    };
}
// returns { consumed: number, result: Object }
function _decode(data, offset) {
    if (data.length === 0) logger.throwError("data too short", (0, _logger.Logger).errors.BUFFER_OVERRUN, {});
    // Array with extra length prefix
    if (data[offset] >= 0xf8) {
        const lengthLength = data[offset] - 0xf7;
        if (offset + 1 + lengthLength > data.length) logger.throwError("data short segment too short", (0, _logger.Logger).errors.BUFFER_OVERRUN, {});
        const length = unarrayifyInteger(data, offset + 1, lengthLength);
        if (offset + 1 + lengthLength + length > data.length) logger.throwError("data long segment too short", (0, _logger.Logger).errors.BUFFER_OVERRUN, {});
        return _decodeChildren(data, offset, offset + 1 + lengthLength, lengthLength + length);
    } else if (data[offset] >= 0xc0) {
        const length = data[offset] - 0xc0;
        if (offset + 1 + length > data.length) logger.throwError("data array too short", (0, _logger.Logger).errors.BUFFER_OVERRUN, {});
        return _decodeChildren(data, offset, offset + 1, length);
    } else if (data[offset] >= 0xb8) {
        const lengthLength = data[offset] - 0xb7;
        if (offset + 1 + lengthLength > data.length) logger.throwError("data array too short", (0, _logger.Logger).errors.BUFFER_OVERRUN, {});
        const length = unarrayifyInteger(data, offset + 1, lengthLength);
        if (offset + 1 + lengthLength + length > data.length) logger.throwError("data array too short", (0, _logger.Logger).errors.BUFFER_OVERRUN, {});
        const result = (0, _bytes.hexlify)(data.slice(offset + 1 + lengthLength, offset + 1 + lengthLength + length));
        return {
            consumed: 1 + lengthLength + length,
            result: result
        };
    } else if (data[offset] >= 0x80) {
        const length = data[offset] - 0x80;
        if (offset + 1 + length > data.length) logger.throwError("data too short", (0, _logger.Logger).errors.BUFFER_OVERRUN, {});
        const result = (0, _bytes.hexlify)(data.slice(offset + 1, offset + 1 + length));
        return {
            consumed: 1 + length,
            result: result
        };
    }
    return {
        consumed: 1,
        result: (0, _bytes.hexlify)(data[offset])
    };
}
function decode(data) {
    const bytes = (0, _bytes.arrayify)(data);
    const decoded = _decode(bytes, 0);
    if (decoded.consumed !== bytes.length) logger.throwArgumentError("invalid rlp data", "data", data);
    return decoded.result;
}

},{"@ethersproject/bytes":"4xCgN","@ethersproject/logger":"jADah","./_version":"6k5En","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"6k5En":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "version", ()=>version);
const version = "rlp/5.7.0";

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"d5xgo":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "version", ()=>version);
const version = "address/5.7.0";

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2M9jf":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "pack", ()=>pack);
parcelHelpers.export(exports, "unpack", ()=>unpack);
parcelHelpers.export(exports, "ArrayCoder", ()=>ArrayCoder);
var _logger = require("@ethersproject/logger");
var _version = require("../_version");
var _abstractCoder = require("./abstract-coder");
var _anonymous = require("./anonymous");
"use strict";
const logger = new (0, _logger.Logger)((0, _version.version));
function pack(writer, coders, values) {
    let arrayValues = null;
    if (Array.isArray(values)) arrayValues = values;
    else if (values && typeof values === "object") {
        let unique = {};
        arrayValues = coders.map((coder)=>{
            const name = coder.localName;
            if (!name) logger.throwError("cannot encode object for signature with missing names", (0, _logger.Logger).errors.INVALID_ARGUMENT, {
                argument: "values",
                coder: coder,
                value: values
            });
            if (unique[name]) logger.throwError("cannot encode object for signature with duplicate names", (0, _logger.Logger).errors.INVALID_ARGUMENT, {
                argument: "values",
                coder: coder,
                value: values
            });
            unique[name] = true;
            return values[name];
        });
    } else logger.throwArgumentError("invalid tuple value", "tuple", values);
    if (coders.length !== arrayValues.length) logger.throwArgumentError("types/value length mismatch", "tuple", values);
    let staticWriter = new (0, _abstractCoder.Writer)(writer.wordSize);
    let dynamicWriter = new (0, _abstractCoder.Writer)(writer.wordSize);
    let updateFuncs = [];
    coders.forEach((coder, index)=>{
        let value = arrayValues[index];
        if (coder.dynamic) {
            // Get current dynamic offset (for the future pointer)
            let dynamicOffset = dynamicWriter.length;
            // Encode the dynamic value into the dynamicWriter
            coder.encode(dynamicWriter, value);
            // Prepare to populate the correct offset once we are done
            let updateFunc = staticWriter.writeUpdatableValue();
            updateFuncs.push((baseOffset)=>{
                updateFunc(baseOffset + dynamicOffset);
            });
        } else coder.encode(staticWriter, value);
    });
    // Backfill all the dynamic offsets, now that we know the static length
    updateFuncs.forEach((func)=>{
        func(staticWriter.length);
    });
    let length = writer.appendWriter(staticWriter);
    length += writer.appendWriter(dynamicWriter);
    return length;
}
function unpack(reader, coders) {
    let values = [];
    // A reader anchored to this base
    let baseReader = reader.subReader(0);
    coders.forEach((coder)=>{
        let value = null;
        if (coder.dynamic) {
            let offset = reader.readValue();
            let offsetReader = baseReader.subReader(offset.toNumber());
            try {
                value = coder.decode(offsetReader);
            } catch (error) {
                // Cannot recover from this
                if (error.code === (0, _logger.Logger).errors.BUFFER_OVERRUN) throw error;
                value = error;
                value.baseType = coder.name;
                value.name = coder.localName;
                value.type = coder.type;
            }
        } else try {
            value = coder.decode(reader);
        } catch (error) {
            // Cannot recover from this
            if (error.code === (0, _logger.Logger).errors.BUFFER_OVERRUN) throw error;
            value = error;
            value.baseType = coder.name;
            value.name = coder.localName;
            value.type = coder.type;
        }
        if (value != undefined) values.push(value);
    });
    // We only output named properties for uniquely named coders
    const uniqueNames = coders.reduce((accum, coder)=>{
        const name = coder.localName;
        if (name) {
            if (!accum[name]) accum[name] = 0;
            accum[name]++;
        }
        return accum;
    }, {});
    // Add any named parameters (i.e. tuples)
    coders.forEach((coder, index)=>{
        let name = coder.localName;
        if (!name || uniqueNames[name] !== 1) return;
        if (name === "length") name = "_length";
        if (values[name] != null) return;
        const value = values[index];
        if (value instanceof Error) Object.defineProperty(values, name, {
            enumerable: true,
            get: ()=>{
                throw value;
            }
        });
        else values[name] = value;
    });
    for(let i = 0; i < values.length; i++){
        const value = values[i];
        if (value instanceof Error) Object.defineProperty(values, i, {
            enumerable: true,
            get: ()=>{
                throw value;
            }
        });
    }
    return Object.freeze(values);
}
class ArrayCoder extends (0, _abstractCoder.Coder) {
    constructor(coder, length, localName){
        const type = coder.type + "[" + (length >= 0 ? length : "") + "]";
        const dynamic = length === -1 || coder.dynamic;
        super("array", type, localName, dynamic);
        this.coder = coder;
        this.length = length;
    }
    defaultValue() {
        // Verifies the child coder is valid (even if the array is dynamic or 0-length)
        const defaultChild = this.coder.defaultValue();
        const result = [];
        for(let i = 0; i < this.length; i++)result.push(defaultChild);
        return result;
    }
    encode(writer, value) {
        if (!Array.isArray(value)) this._throwError("expected array value", value);
        let count = this.length;
        if (count === -1) {
            count = value.length;
            writer.writeValue(value.length);
        }
        logger.checkArgumentCount(value.length, count, "coder array" + (this.localName ? " " + this.localName : ""));
        let coders = [];
        for(let i = 0; i < value.length; i++)coders.push(this.coder);
        return pack(writer, coders, value);
    }
    decode(reader) {
        let count = this.length;
        if (count === -1) {
            count = reader.readValue().toNumber();
            // Check that there is *roughly* enough data to ensure
            // stray random data is not being read as a length. Each
            // slot requires at least 32 bytes for their value (or 32
            // bytes as a link to the data). This could use a much
            // tighter bound, but we are erroring on the side of safety.
            if (count * 32 > reader._data.length) logger.throwError("insufficient data length", (0, _logger.Logger).errors.BUFFER_OVERRUN, {
                length: reader._data.length,
                count: count
            });
        }
        let coders = [];
        for(let i = 0; i < count; i++)coders.push(new (0, _anonymous.AnonymousCoder)(this.coder));
        return reader.coerce(this.name, unpack(reader, coders));
    }
}

},{"@ethersproject/logger":"jADah","../_version":"fI0Q8","./abstract-coder":"2f9zv","./anonymous":"52Z3l","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"52Z3l":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// Clones the functionality of an existing Coder, but without a localName
parcelHelpers.export(exports, "AnonymousCoder", ()=>AnonymousCoder);
var _abstractCoder = require("./abstract-coder");
"use strict";
class AnonymousCoder extends (0, _abstractCoder.Coder) {
    constructor(coder){
        super(coder.name, coder.type, undefined, coder.dynamic);
        this.coder = coder;
    }
    defaultValue() {
        return this.coder.defaultValue();
    }
    encode(writer, value) {
        return this.coder.encode(writer, value);
    }
    decode(reader) {
        return this.coder.decode(reader);
    }
}

},{"./abstract-coder":"2f9zv","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"iJaNf":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BooleanCoder", ()=>BooleanCoder);
var _abstractCoder = require("./abstract-coder");
"use strict";
class BooleanCoder extends (0, _abstractCoder.Coder) {
    constructor(localName){
        super("bool", "bool", localName, false);
    }
    defaultValue() {
        return false;
    }
    encode(writer, value) {
        return writer.writeValue(value ? 1 : 0);
    }
    decode(reader) {
        return reader.coerce(this.type, !reader.readValue().isZero());
    }
}

},{"./abstract-coder":"2f9zv","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2hbOn":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DynamicBytesCoder", ()=>DynamicBytesCoder);
parcelHelpers.export(exports, "BytesCoder", ()=>BytesCoder);
var _bytes = require("@ethersproject/bytes");
var _abstractCoder = require("./abstract-coder");
"use strict";
class DynamicBytesCoder extends (0, _abstractCoder.Coder) {
    constructor(type, localName){
        super(type, type, localName, true);
    }
    defaultValue() {
        return "0x";
    }
    encode(writer, value) {
        value = (0, _bytes.arrayify)(value);
        let length = writer.writeValue(value.length);
        length += writer.writeBytes(value);
        return length;
    }
    decode(reader) {
        return reader.readBytes(reader.readValue().toNumber(), true);
    }
}
class BytesCoder extends DynamicBytesCoder {
    constructor(localName){
        super("bytes", localName);
    }
    decode(reader) {
        return reader.coerce(this.name, (0, _bytes.hexlify)(super.decode(reader)));
    }
}

},{"@ethersproject/bytes":"4xCgN","./abstract-coder":"2f9zv","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"i8yh4":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// @TODO: Merge this with bytes
parcelHelpers.export(exports, "FixedBytesCoder", ()=>FixedBytesCoder);
var _bytes = require("@ethersproject/bytes");
var _abstractCoder = require("./abstract-coder");
"use strict";
class FixedBytesCoder extends (0, _abstractCoder.Coder) {
    constructor(size, localName){
        let name = "bytes" + String(size);
        super(name, name, localName, false);
        this.size = size;
    }
    defaultValue() {
        return "0x0000000000000000000000000000000000000000000000000000000000000000".substring(0, 2 + this.size * 2);
    }
    encode(writer, value) {
        let data = (0, _bytes.arrayify)(value);
        if (data.length !== this.size) this._throwError("incorrect data length", value);
        return writer.writeBytes(data);
    }
    decode(reader) {
        return reader.coerce(this.name, (0, _bytes.hexlify)(reader.readBytes(this.size)));
    }
}

},{"@ethersproject/bytes":"4xCgN","./abstract-coder":"2f9zv","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"kYhlL":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "NullCoder", ()=>NullCoder);
var _abstractCoder = require("./abstract-coder");
"use strict";
class NullCoder extends (0, _abstractCoder.Coder) {
    constructor(localName){
        super("null", "", localName, false);
    }
    defaultValue() {
        return null;
    }
    encode(writer, value) {
        if (value != null) this._throwError("not null", value);
        return writer.writeBytes([]);
    }
    decode(reader) {
        reader.readBytes(0);
        return reader.coerce(this.name, null);
    }
}

},{"./abstract-coder":"2f9zv","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"hHewr":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "NumberCoder", ()=>NumberCoder);
var _bignumber = require("@ethersproject/bignumber");
var _constants = require("@ethersproject/constants");
var _abstractCoder = require("./abstract-coder");
"use strict";
class NumberCoder extends (0, _abstractCoder.Coder) {
    constructor(size, signed, localName){
        const name = (signed ? "int" : "uint") + size * 8;
        super(name, name, localName, false);
        this.size = size;
        this.signed = signed;
    }
    defaultValue() {
        return 0;
    }
    encode(writer, value) {
        let v = (0, _bignumber.BigNumber).from(value);
        // Check bounds are safe for encoding
        let maxUintValue = (0, _constants.MaxUint256).mask(writer.wordSize * 8);
        if (this.signed) {
            let bounds = maxUintValue.mask(this.size * 8 - 1);
            if (v.gt(bounds) || v.lt(bounds.add((0, _constants.One)).mul((0, _constants.NegativeOne)))) this._throwError("value out-of-bounds", value);
        } else if (v.lt((0, _constants.Zero)) || v.gt(maxUintValue.mask(this.size * 8))) this._throwError("value out-of-bounds", value);
        v = v.toTwos(this.size * 8).mask(this.size * 8);
        if (this.signed) v = v.fromTwos(this.size * 8).toTwos(8 * writer.wordSize);
        return writer.writeValue(v);
    }
    decode(reader) {
        let value = reader.readValue().mask(this.size * 8);
        if (this.signed) value = value.fromTwos(this.size * 8);
        return reader.coerce(this.name, value);
    }
}

},{"@ethersproject/bignumber":"fUhf1","@ethersproject/constants":"gOwoz","./abstract-coder":"2f9zv","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"gOwoz":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AddressZero", ()=>(0, _addresses.AddressZero));
parcelHelpers.export(exports, "NegativeOne", ()=>(0, _bignumbers.NegativeOne));
parcelHelpers.export(exports, "Zero", ()=>(0, _bignumbers.Zero));
parcelHelpers.export(exports, "One", ()=>(0, _bignumbers.One));
parcelHelpers.export(exports, "Two", ()=>(0, _bignumbers.Two));
parcelHelpers.export(exports, "WeiPerEther", ()=>(0, _bignumbers.WeiPerEther));
parcelHelpers.export(exports, "MaxUint256", ()=>(0, _bignumbers.MaxUint256));
parcelHelpers.export(exports, "MinInt256", ()=>(0, _bignumbers.MinInt256));
parcelHelpers.export(exports, "MaxInt256", ()=>(0, _bignumbers.MaxInt256));
parcelHelpers.export(exports, "HashZero", ()=>(0, _hashes.HashZero));
parcelHelpers.export(exports, "EtherSymbol", ()=>(0, _strings.EtherSymbol));
var _addresses = require("./addresses");
var _bignumbers = require("./bignumbers");
var _hashes = require("./hashes");
var _strings = require("./strings");
"use strict";

},{"./addresses":false,"./bignumbers":"jfS4R","./hashes":false,"./strings":false,"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"jfS4R":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "NegativeOne", ()=>NegativeOne);
parcelHelpers.export(exports, "Zero", ()=>Zero);
parcelHelpers.export(exports, "One", ()=>One);
parcelHelpers.export(exports, "Two", ()=>Two);
parcelHelpers.export(exports, "WeiPerEther", ()=>WeiPerEther);
parcelHelpers.export(exports, "MaxUint256", ()=>MaxUint256);
parcelHelpers.export(exports, "MinInt256", ()=>MinInt256);
parcelHelpers.export(exports, "MaxInt256", ()=>MaxInt256);
var _bignumber = require("@ethersproject/bignumber");
const NegativeOne = /*#__PURE__*/ (0, _bignumber.BigNumber).from(-1);
const Zero = /*#__PURE__*/ (0, _bignumber.BigNumber).from(0);
const One = /*#__PURE__*/ (0, _bignumber.BigNumber).from(1);
const Two = /*#__PURE__*/ (0, _bignumber.BigNumber).from(2);
const WeiPerEther = /*#__PURE__*/ (0, _bignumber.BigNumber).from("1000000000000000000");
const MaxUint256 = /*#__PURE__*/ (0, _bignumber.BigNumber).from("0xffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff");
const MinInt256 = /*#__PURE__*/ (0, _bignumber.BigNumber).from("-0x8000000000000000000000000000000000000000000000000000000000000000");
const MaxInt256 = /*#__PURE__*/ (0, _bignumber.BigNumber).from("0x7fffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff");

},{"@ethersproject/bignumber":"fUhf1","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"bBha8":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StringCoder", ()=>StringCoder);
var _strings = require("@ethersproject/strings");
var _bytes = require("./bytes");
"use strict";
class StringCoder extends (0, _bytes.DynamicBytesCoder) {
    constructor(localName){
        super("string", localName);
    }
    defaultValue() {
        return "";
    }
    encode(writer, value) {
        return super.encode(writer, (0, _strings.toUtf8Bytes)(value));
    }
    decode(reader) {
        return (0, _strings.toUtf8String)(super.decode(reader));
    }
}

},{"@ethersproject/strings":"9TQil","./bytes":"2hbOn","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9TQil":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_toEscapedUtf8String", ()=>(0, _utf8._toEscapedUtf8String));
parcelHelpers.export(exports, "toUtf8Bytes", ()=>(0, _utf8.toUtf8Bytes));
parcelHelpers.export(exports, "toUtf8CodePoints", ()=>(0, _utf8.toUtf8CodePoints));
parcelHelpers.export(exports, "toUtf8String", ()=>(0, _utf8.toUtf8String));
parcelHelpers.export(exports, "Utf8ErrorFuncs", ()=>(0, _utf8.Utf8ErrorFuncs));
parcelHelpers.export(exports, "Utf8ErrorReason", ()=>(0, _utf8.Utf8ErrorReason));
parcelHelpers.export(exports, "UnicodeNormalizationForm", ()=>(0, _utf8.UnicodeNormalizationForm));
parcelHelpers.export(exports, "formatBytes32String", ()=>(0, _bytes32.formatBytes32String));
parcelHelpers.export(exports, "parseBytes32String", ()=>(0, _bytes32.parseBytes32String));
parcelHelpers.export(exports, "nameprep", ()=>(0, _idna.nameprep));
var _bytes32 = require("./bytes32");
var _idna = require("./idna");
var _utf8 = require("./utf8");
"use strict";

},{"./bytes32":false,"./idna":false,"./utf8":"8aOA2","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8aOA2":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "UnicodeNormalizationForm", ()=>UnicodeNormalizationForm);
parcelHelpers.export(exports, "Utf8ErrorReason", ()=>Utf8ErrorReason);
parcelHelpers.export(exports, "Utf8ErrorFuncs", ()=>Utf8ErrorFuncs);
// http://stackoverflow.com/questions/18729405/how-to-convert-utf8-string-to-byte-array
parcelHelpers.export(exports, "toUtf8Bytes", ()=>toUtf8Bytes);
parcelHelpers.export(exports, "_toEscapedUtf8String", ()=>_toEscapedUtf8String);
parcelHelpers.export(exports, "_toUtf8String", ()=>_toUtf8String);
parcelHelpers.export(exports, "toUtf8String", ()=>toUtf8String);
parcelHelpers.export(exports, "toUtf8CodePoints", ()=>toUtf8CodePoints);
var _bytes = require("@ethersproject/bytes");
var _logger = require("@ethersproject/logger");
var _version = require("./_version");
"use strict";
const logger = new (0, _logger.Logger)((0, _version.version));
var UnicodeNormalizationForm;
(function(UnicodeNormalizationForm) {
    UnicodeNormalizationForm["current"] = "";
    UnicodeNormalizationForm["NFC"] = "NFC";
    UnicodeNormalizationForm["NFD"] = "NFD";
    UnicodeNormalizationForm["NFKC"] = "NFKC";
    UnicodeNormalizationForm["NFKD"] = "NFKD";
})(UnicodeNormalizationForm || (UnicodeNormalizationForm = {}));
var Utf8ErrorReason;
(function(Utf8ErrorReason) {
    // A continuation byte was present where there was nothing to continue
    // - offset = the index the codepoint began in
    Utf8ErrorReason["UNEXPECTED_CONTINUE"] = "unexpected continuation byte";
    // An invalid (non-continuation) byte to start a UTF-8 codepoint was found
    // - offset = the index the codepoint began in
    Utf8ErrorReason["BAD_PREFIX"] = "bad codepoint prefix";
    // The string is too short to process the expected codepoint
    // - offset = the index the codepoint began in
    Utf8ErrorReason["OVERRUN"] = "string overrun";
    // A missing continuation byte was expected but not found
    // - offset = the index the continuation byte was expected at
    Utf8ErrorReason["MISSING_CONTINUE"] = "missing continuation byte";
    // The computed code point is outside the range for UTF-8
    // - offset       = start of this codepoint
    // - badCodepoint = the computed codepoint; outside the UTF-8 range
    Utf8ErrorReason["OUT_OF_RANGE"] = "out of UTF-8 range";
    // UTF-8 strings may not contain UTF-16 surrogate pairs
    // - offset       = start of this codepoint
    // - badCodepoint = the computed codepoint; inside the UTF-16 surrogate range
    Utf8ErrorReason["UTF16_SURROGATE"] = "UTF-16 surrogate";
    // The string is an overlong representation
    // - offset       = start of this codepoint
    // - badCodepoint = the computed codepoint; already bounds checked
    Utf8ErrorReason["OVERLONG"] = "overlong representation";
})(Utf8ErrorReason || (Utf8ErrorReason = {}));
function errorFunc(reason, offset, bytes, output, badCodepoint) {
    return logger.throwArgumentError(`invalid codepoint at offset ${offset}; ${reason}`, "bytes", bytes);
}
function ignoreFunc(reason, offset, bytes, output, badCodepoint) {
    // If there is an invalid prefix (including stray continuation), skip any additional continuation bytes
    if (reason === Utf8ErrorReason.BAD_PREFIX || reason === Utf8ErrorReason.UNEXPECTED_CONTINUE) {
        let i = 0;
        for(let o = offset + 1; o < bytes.length; o++){
            if (bytes[o] >> 6 !== 0x02) break;
            i++;
        }
        return i;
    }
    // This byte runs us past the end of the string, so just jump to the end
    // (but the first byte was read already read and therefore skipped)
    if (reason === Utf8ErrorReason.OVERRUN) return bytes.length - offset - 1;
    // Nothing to skip
    return 0;
}
function replaceFunc(reason, offset, bytes, output, badCodepoint) {
    // Overlong representations are otherwise "valid" code points; just non-deistingtished
    if (reason === Utf8ErrorReason.OVERLONG) {
        output.push(badCodepoint);
        return 0;
    }
    // Put the replacement character into the output
    output.push(0xfffd);
    // Otherwise, process as if ignoring errors
    return ignoreFunc(reason, offset, bytes, output, badCodepoint);
}
const Utf8ErrorFuncs = Object.freeze({
    error: errorFunc,
    ignore: ignoreFunc,
    replace: replaceFunc
});
// http://stackoverflow.com/questions/13356493/decode-utf-8-with-javascript#13691499
function getUtf8CodePoints(bytes, onError) {
    if (onError == null) onError = Utf8ErrorFuncs.error;
    bytes = (0, _bytes.arrayify)(bytes);
    const result = [];
    let i = 0;
    // Invalid bytes are ignored
    while(i < bytes.length){
        const c = bytes[i++];
        // 0xxx xxxx
        if (c >> 7 === 0) {
            result.push(c);
            continue;
        }
        // Multibyte; how many bytes left for this character?
        let extraLength = null;
        let overlongMask = null;
        // 110x xxxx 10xx xxxx
        if ((c & 0xe0) === 0xc0) {
            extraLength = 1;
            overlongMask = 0x7f;
        // 1110 xxxx 10xx xxxx 10xx xxxx
        } else if ((c & 0xf0) === 0xe0) {
            extraLength = 2;
            overlongMask = 0x7ff;
        // 1111 0xxx 10xx xxxx 10xx xxxx 10xx xxxx
        } else if ((c & 0xf8) === 0xf0) {
            extraLength = 3;
            overlongMask = 0xffff;
        } else {
            if ((c & 0xc0) === 0x80) i += onError(Utf8ErrorReason.UNEXPECTED_CONTINUE, i - 1, bytes, result);
            else i += onError(Utf8ErrorReason.BAD_PREFIX, i - 1, bytes, result);
            continue;
        }
        // Do we have enough bytes in our data?
        if (i - 1 + extraLength >= bytes.length) {
            i += onError(Utf8ErrorReason.OVERRUN, i - 1, bytes, result);
            continue;
        }
        // Remove the length prefix from the char
        let res = c & (1 << 8 - extraLength - 1) - 1;
        for(let j = 0; j < extraLength; j++){
            let nextChar = bytes[i];
            // Invalid continuation byte
            if ((nextChar & 0xc0) != 0x80) {
                i += onError(Utf8ErrorReason.MISSING_CONTINUE, i, bytes, result);
                res = null;
                break;
            }
            res = res << 6 | nextChar & 0x3f;
            i++;
        }
        // See above loop for invalid continuation byte
        if (res === null) continue;
        // Maximum code point
        if (res > 0x10ffff) {
            i += onError(Utf8ErrorReason.OUT_OF_RANGE, i - 1 - extraLength, bytes, result, res);
            continue;
        }
        // Reserved for UTF-16 surrogate halves
        if (res >= 0xd800 && res <= 0xdfff) {
            i += onError(Utf8ErrorReason.UTF16_SURROGATE, i - 1 - extraLength, bytes, result, res);
            continue;
        }
        // Check for overlong sequences (more bytes than needed)
        if (res <= overlongMask) {
            i += onError(Utf8ErrorReason.OVERLONG, i - 1 - extraLength, bytes, result, res);
            continue;
        }
        result.push(res);
    }
    return result;
}
function toUtf8Bytes(str, form = UnicodeNormalizationForm.current) {
    if (form != UnicodeNormalizationForm.current) {
        logger.checkNormalize();
        str = str.normalize(form);
    }
    let result = [];
    for(let i = 0; i < str.length; i++){
        const c = str.charCodeAt(i);
        if (c < 0x80) result.push(c);
        else if (c < 0x800) {
            result.push(c >> 6 | 0xc0);
            result.push(c & 0x3f | 0x80);
        } else if ((c & 0xfc00) == 0xd800) {
            i++;
            const c2 = str.charCodeAt(i);
            if (i >= str.length || (c2 & 0xfc00) !== 0xdc00) throw new Error("invalid utf-8 string");
            // Surrogate Pair
            const pair = 0x10000 + ((c & 0x03ff) << 10) + (c2 & 0x03ff);
            result.push(pair >> 18 | 0xf0);
            result.push(pair >> 12 & 0x3f | 0x80);
            result.push(pair >> 6 & 0x3f | 0x80);
            result.push(pair & 0x3f | 0x80);
        } else {
            result.push(c >> 12 | 0xe0);
            result.push(c >> 6 & 0x3f | 0x80);
            result.push(c & 0x3f | 0x80);
        }
    }
    return (0, _bytes.arrayify)(result);
}
function escapeChar(value) {
    const hex = "0000" + value.toString(16);
    return "\\u" + hex.substring(hex.length - 4);
}
function _toEscapedUtf8String(bytes, onError) {
    return '"' + getUtf8CodePoints(bytes, onError).map((codePoint)=>{
        if (codePoint < 256) {
            switch(codePoint){
                case 8:
                    return "\\b";
                case 9:
                    return "\\t";
                case 10:
                    return "\\n";
                case 13:
                    return "\\r";
                case 34:
                    return '\\"';
                case 92:
                    return "\\\\";
            }
            if (codePoint >= 32 && codePoint < 127) return String.fromCharCode(codePoint);
        }
        if (codePoint <= 0xffff) return escapeChar(codePoint);
        codePoint -= 0x10000;
        return escapeChar((codePoint >> 10 & 0x3ff) + 0xd800) + escapeChar((codePoint & 0x3ff) + 0xdc00);
    }).join("") + '"';
}
function _toUtf8String(codePoints) {
    return codePoints.map((codePoint)=>{
        if (codePoint <= 0xffff) return String.fromCharCode(codePoint);
        codePoint -= 0x10000;
        return String.fromCharCode((codePoint >> 10 & 0x3ff) + 0xd800, (codePoint & 0x3ff) + 0xdc00);
    }).join("");
}
function toUtf8String(bytes, onError) {
    return _toUtf8String(getUtf8CodePoints(bytes, onError));
}
function toUtf8CodePoints(str, form = UnicodeNormalizationForm.current) {
    return getUtf8CodePoints(toUtf8Bytes(str, form));
}

},{"@ethersproject/bytes":"4xCgN","@ethersproject/logger":"jADah","./_version":"kxmDP","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"kxmDP":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "version", ()=>version);
const version = "strings/5.7.0";

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"w68kH":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TupleCoder", ()=>TupleCoder);
var _abstractCoder = require("./abstract-coder");
var _array = require("./array");
"use strict";
class TupleCoder extends (0, _abstractCoder.Coder) {
    constructor(coders, localName){
        let dynamic = false;
        const types = [];
        coders.forEach((coder)=>{
            if (coder.dynamic) dynamic = true;
            types.push(coder.type);
        });
        const type = "tuple(" + types.join(",") + ")";
        super("tuple", type, localName, dynamic);
        this.coders = coders;
    }
    defaultValue() {
        const values = [];
        this.coders.forEach((coder)=>{
            values.push(coder.defaultValue());
        });
        // We only output named properties for uniquely named coders
        const uniqueNames = this.coders.reduce((accum, coder)=>{
            const name = coder.localName;
            if (name) {
                if (!accum[name]) accum[name] = 0;
                accum[name]++;
            }
            return accum;
        }, {});
        // Add named values
        this.coders.forEach((coder, index)=>{
            let name = coder.localName;
            if (!name || uniqueNames[name] !== 1) return;
            if (name === "length") name = "_length";
            if (values[name] != null) return;
            values[name] = values[index];
        });
        return Object.freeze(values);
    }
    encode(writer, value) {
        return (0, _array.pack)(writer, this.coders, value);
    }
    decode(reader) {
        return reader.coerce(this.name, (0, _array.unpack)(reader, this.coders));
    }
}

},{"./abstract-coder":"2f9zv","./array":"2M9jf","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"jBHig":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "checkResultErrors", ()=>(0, _abstractCoder.checkResultErrors));
parcelHelpers.export(exports, "LogDescription", ()=>LogDescription);
parcelHelpers.export(exports, "TransactionDescription", ()=>TransactionDescription);
parcelHelpers.export(exports, "ErrorDescription", ()=>ErrorDescription);
parcelHelpers.export(exports, "Indexed", ()=>Indexed);
/*
function checkNames(fragment: Fragment, type: "input" | "output", params: Array<ParamType>): void {
    params.reduce((accum, param) => {
        if (param.name) {
            if (accum[param.name]) {
                logger.throwArgumentError(`duplicate ${ type } parameter ${ JSON.stringify(param.name) } in ${ fragment.format("full") }`, "fragment", fragment);
            }
            accum[param.name] = true;
        }
        return accum;
    }, <{ [ name: string ]: boolean }>{ });
}
*/ parcelHelpers.export(exports, "Interface", ()=>Interface);
var _address = require("@ethersproject/address");
var _bignumber = require("@ethersproject/bignumber");
var _bytes = require("@ethersproject/bytes");
var _hash = require("@ethersproject/hash");
var _keccak256 = require("@ethersproject/keccak256");
var _properties = require("@ethersproject/properties");
var _abiCoder = require("./abi-coder");
var _abstractCoder = require("./coders/abstract-coder");
var _fragments = require("./fragments");
var _logger = require("@ethersproject/logger");
var _version = require("./_version");
"use strict";
const logger = new (0, _logger.Logger)((0, _version.version));
class LogDescription extends (0, _properties.Description) {
}
class TransactionDescription extends (0, _properties.Description) {
}
class ErrorDescription extends (0, _properties.Description) {
}
class Indexed extends (0, _properties.Description) {
    static isIndexed(value) {
        return !!(value && value._isIndexed);
    }
}
const BuiltinErrors = {
    "0x08c379a0": {
        signature: "Error(string)",
        name: "Error",
        inputs: [
            "string"
        ],
        reason: true
    },
    "0x4e487b71": {
        signature: "Panic(uint256)",
        name: "Panic",
        inputs: [
            "uint256"
        ]
    }
};
function wrapAccessError(property, error) {
    const wrap = new Error(`deferred error during ABI decoding triggered accessing ${property}`);
    wrap.error = error;
    return wrap;
}
class Interface {
    constructor(fragments){
        let abi = [];
        if (typeof fragments === "string") abi = JSON.parse(fragments);
        else abi = fragments;
        (0, _properties.defineReadOnly)(this, "fragments", abi.map((fragment)=>{
            return (0, _fragments.Fragment).from(fragment);
        }).filter((fragment)=>fragment != null));
        (0, _properties.defineReadOnly)(this, "_abiCoder", (0, _properties.getStatic)(new.target, "getAbiCoder")());
        (0, _properties.defineReadOnly)(this, "functions", {});
        (0, _properties.defineReadOnly)(this, "errors", {});
        (0, _properties.defineReadOnly)(this, "events", {});
        (0, _properties.defineReadOnly)(this, "structs", {});
        // Add all fragments by their signature
        this.fragments.forEach((fragment)=>{
            let bucket = null;
            switch(fragment.type){
                case "constructor":
                    if (this.deploy) {
                        logger.warn("duplicate definition - constructor");
                        return;
                    }
                    //checkNames(fragment, "input", fragment.inputs);
                    (0, _properties.defineReadOnly)(this, "deploy", fragment);
                    return;
                case "function":
                    //checkNames(fragment, "input", fragment.inputs);
                    //checkNames(fragment, "output", (<FunctionFragment>fragment).outputs);
                    bucket = this.functions;
                    break;
                case "event":
                    //checkNames(fragment, "input", fragment.inputs);
                    bucket = this.events;
                    break;
                case "error":
                    bucket = this.errors;
                    break;
                default:
                    return;
            }
            let signature = fragment.format();
            if (bucket[signature]) {
                logger.warn("duplicate definition - " + signature);
                return;
            }
            bucket[signature] = fragment;
        });
        // If we do not have a constructor add a default
        if (!this.deploy) (0, _properties.defineReadOnly)(this, "deploy", (0, _fragments.ConstructorFragment).from({
            payable: false,
            type: "constructor"
        }));
        (0, _properties.defineReadOnly)(this, "_isInterface", true);
    }
    format(format) {
        if (!format) format = (0, _fragments.FormatTypes).full;
        if (format === (0, _fragments.FormatTypes).sighash) logger.throwArgumentError("interface does not support formatting sighash", "format", format);
        const abi = this.fragments.map((fragment)=>fragment.format(format));
        // We need to re-bundle the JSON fragments a bit
        if (format === (0, _fragments.FormatTypes).json) return JSON.stringify(abi.map((j)=>JSON.parse(j)));
        return abi;
    }
    // Sub-classes can override these to handle other blockchains
    static getAbiCoder() {
        return 0, _abiCoder.defaultAbiCoder;
    }
    static getAddress(address) {
        return (0, _address.getAddress)(address);
    }
    static getSighash(fragment) {
        return (0, _bytes.hexDataSlice)((0, _hash.id)(fragment.format()), 0, 4);
    }
    static getEventTopic(eventFragment) {
        return (0, _hash.id)(eventFragment.format());
    }
    // Find a function definition by any means necessary (unless it is ambiguous)
    getFunction(nameOrSignatureOrSighash) {
        if ((0, _bytes.isHexString)(nameOrSignatureOrSighash)) {
            for(const name in this.functions){
                if (nameOrSignatureOrSighash === this.getSighash(name)) return this.functions[name];
            }
            logger.throwArgumentError("no matching function", "sighash", nameOrSignatureOrSighash);
        }
        // It is a bare name, look up the function (will return null if ambiguous)
        if (nameOrSignatureOrSighash.indexOf("(") === -1) {
            const name = nameOrSignatureOrSighash.trim();
            const matching = Object.keys(this.functions).filter((f)=>f.split("(" /* fix:) */ )[0] === name);
            if (matching.length === 0) logger.throwArgumentError("no matching function", "name", name);
            else if (matching.length > 1) logger.throwArgumentError("multiple matching functions", "name", name);
            return this.functions[matching[0]];
        }
        // Normalize the signature and lookup the function
        const result = this.functions[(0, _fragments.FunctionFragment).fromString(nameOrSignatureOrSighash).format()];
        if (!result) logger.throwArgumentError("no matching function", "signature", nameOrSignatureOrSighash);
        return result;
    }
    // Find an event definition by any means necessary (unless it is ambiguous)
    getEvent(nameOrSignatureOrTopic) {
        if ((0, _bytes.isHexString)(nameOrSignatureOrTopic)) {
            const topichash = nameOrSignatureOrTopic.toLowerCase();
            for(const name in this.events){
                if (topichash === this.getEventTopic(name)) return this.events[name];
            }
            logger.throwArgumentError("no matching event", "topichash", topichash);
        }
        // It is a bare name, look up the function (will return null if ambiguous)
        if (nameOrSignatureOrTopic.indexOf("(") === -1) {
            const name = nameOrSignatureOrTopic.trim();
            const matching = Object.keys(this.events).filter((f)=>f.split("(" /* fix:) */ )[0] === name);
            if (matching.length === 0) logger.throwArgumentError("no matching event", "name", name);
            else if (matching.length > 1) logger.throwArgumentError("multiple matching events", "name", name);
            return this.events[matching[0]];
        }
        // Normalize the signature and lookup the function
        const result = this.events[(0, _fragments.EventFragment).fromString(nameOrSignatureOrTopic).format()];
        if (!result) logger.throwArgumentError("no matching event", "signature", nameOrSignatureOrTopic);
        return result;
    }
    // Find a function definition by any means necessary (unless it is ambiguous)
    getError(nameOrSignatureOrSighash) {
        if ((0, _bytes.isHexString)(nameOrSignatureOrSighash)) {
            const getSighash = (0, _properties.getStatic)(this.constructor, "getSighash");
            for(const name in this.errors){
                const error = this.errors[name];
                if (nameOrSignatureOrSighash === getSighash(error)) return this.errors[name];
            }
            logger.throwArgumentError("no matching error", "sighash", nameOrSignatureOrSighash);
        }
        // It is a bare name, look up the function (will return null if ambiguous)
        if (nameOrSignatureOrSighash.indexOf("(") === -1) {
            const name = nameOrSignatureOrSighash.trim();
            const matching = Object.keys(this.errors).filter((f)=>f.split("(" /* fix:) */ )[0] === name);
            if (matching.length === 0) logger.throwArgumentError("no matching error", "name", name);
            else if (matching.length > 1) logger.throwArgumentError("multiple matching errors", "name", name);
            return this.errors[matching[0]];
        }
        // Normalize the signature and lookup the function
        const result = this.errors[(0, _fragments.FunctionFragment).fromString(nameOrSignatureOrSighash).format()];
        if (!result) logger.throwArgumentError("no matching error", "signature", nameOrSignatureOrSighash);
        return result;
    }
    // Get the sighash (the bytes4 selector) used by Solidity to identify a function
    getSighash(fragment) {
        if (typeof fragment === "string") try {
            fragment = this.getFunction(fragment);
        } catch (error) {
            try {
                fragment = this.getError(fragment);
            } catch (_) {
                throw error;
            }
        }
        return (0, _properties.getStatic)(this.constructor, "getSighash")(fragment);
    }
    // Get the topic (the bytes32 hash) used by Solidity to identify an event
    getEventTopic(eventFragment) {
        if (typeof eventFragment === "string") eventFragment = this.getEvent(eventFragment);
        return (0, _properties.getStatic)(this.constructor, "getEventTopic")(eventFragment);
    }
    _decodeParams(params, data) {
        return this._abiCoder.decode(params, data);
    }
    _encodeParams(params, values) {
        return this._abiCoder.encode(params, values);
    }
    encodeDeploy(values) {
        return this._encodeParams(this.deploy.inputs, values || []);
    }
    decodeErrorResult(fragment, data) {
        if (typeof fragment === "string") fragment = this.getError(fragment);
        const bytes = (0, _bytes.arrayify)(data);
        if ((0, _bytes.hexlify)(bytes.slice(0, 4)) !== this.getSighash(fragment)) logger.throwArgumentError(`data signature does not match error ${fragment.name}.`, "data", (0, _bytes.hexlify)(bytes));
        return this._decodeParams(fragment.inputs, bytes.slice(4));
    }
    encodeErrorResult(fragment, values) {
        if (typeof fragment === "string") fragment = this.getError(fragment);
        return (0, _bytes.hexlify)((0, _bytes.concat)([
            this.getSighash(fragment),
            this._encodeParams(fragment.inputs, values || [])
        ]));
    }
    // Decode the data for a function call (e.g. tx.data)
    decodeFunctionData(functionFragment, data) {
        if (typeof functionFragment === "string") functionFragment = this.getFunction(functionFragment);
        const bytes = (0, _bytes.arrayify)(data);
        if ((0, _bytes.hexlify)(bytes.slice(0, 4)) !== this.getSighash(functionFragment)) logger.throwArgumentError(`data signature does not match function ${functionFragment.name}.`, "data", (0, _bytes.hexlify)(bytes));
        return this._decodeParams(functionFragment.inputs, bytes.slice(4));
    }
    // Encode the data for a function call (e.g. tx.data)
    encodeFunctionData(functionFragment, values) {
        if (typeof functionFragment === "string") functionFragment = this.getFunction(functionFragment);
        return (0, _bytes.hexlify)((0, _bytes.concat)([
            this.getSighash(functionFragment),
            this._encodeParams(functionFragment.inputs, values || [])
        ]));
    }
    // Decode the result from a function call (e.g. from eth_call)
    decodeFunctionResult(functionFragment, data) {
        if (typeof functionFragment === "string") functionFragment = this.getFunction(functionFragment);
        let bytes = (0, _bytes.arrayify)(data);
        let reason = null;
        let message = "";
        let errorArgs = null;
        let errorName = null;
        let errorSignature = null;
        switch(bytes.length % this._abiCoder._getWordSize()){
            case 0:
                try {
                    return this._abiCoder.decode(functionFragment.outputs, bytes);
                } catch (error) {}
                break;
            case 4:
                {
                    const selector = (0, _bytes.hexlify)(bytes.slice(0, 4));
                    const builtin = BuiltinErrors[selector];
                    if (builtin) {
                        errorArgs = this._abiCoder.decode(builtin.inputs, bytes.slice(4));
                        errorName = builtin.name;
                        errorSignature = builtin.signature;
                        if (builtin.reason) reason = errorArgs[0];
                        if (errorName === "Error") message = `; VM Exception while processing transaction: reverted with reason string ${JSON.stringify(errorArgs[0])}`;
                        else if (errorName === "Panic") message = `; VM Exception while processing transaction: reverted with panic code ${errorArgs[0]}`;
                    } else try {
                        const error = this.getError(selector);
                        errorArgs = this._abiCoder.decode(error.inputs, bytes.slice(4));
                        errorName = error.name;
                        errorSignature = error.format();
                    } catch (error) {}
                    break;
                }
        }
        return logger.throwError("call revert exception" + message, (0, _logger.Logger).errors.CALL_EXCEPTION, {
            method: functionFragment.format(),
            data: (0, _bytes.hexlify)(data),
            errorArgs,
            errorName,
            errorSignature,
            reason
        });
    }
    // Encode the result for a function call (e.g. for eth_call)
    encodeFunctionResult(functionFragment, values) {
        if (typeof functionFragment === "string") functionFragment = this.getFunction(functionFragment);
        return (0, _bytes.hexlify)(this._abiCoder.encode(functionFragment.outputs, values || []));
    }
    // Create the filter for the event with search criteria (e.g. for eth_filterLog)
    encodeFilterTopics(eventFragment, values) {
        if (typeof eventFragment === "string") eventFragment = this.getEvent(eventFragment);
        if (values.length > eventFragment.inputs.length) logger.throwError("too many arguments for " + eventFragment.format(), (0, _logger.Logger).errors.UNEXPECTED_ARGUMENT, {
            argument: "values",
            value: values
        });
        let topics = [];
        if (!eventFragment.anonymous) topics.push(this.getEventTopic(eventFragment));
        const encodeTopic = (param, value)=>{
            if (param.type === "string") return (0, _hash.id)(value);
            else if (param.type === "bytes") return (0, _keccak256.keccak256)((0, _bytes.hexlify)(value));
            if (param.type === "bool" && typeof value === "boolean") value = value ? "0x01" : "0x00";
            if (param.type.match(/^u?int/)) value = (0, _bignumber.BigNumber).from(value).toHexString();
            // Check addresses are valid
            if (param.type === "address") this._abiCoder.encode([
                "address"
            ], [
                value
            ]);
            return (0, _bytes.hexZeroPad)((0, _bytes.hexlify)(value), 32);
        };
        values.forEach((value, index)=>{
            let param = eventFragment.inputs[index];
            if (!param.indexed) {
                if (value != null) logger.throwArgumentError("cannot filter non-indexed parameters; must be null", "contract." + param.name, value);
                return;
            }
            if (value == null) topics.push(null);
            else if (param.baseType === "array" || param.baseType === "tuple") logger.throwArgumentError("filtering with tuples or arrays not supported", "contract." + param.name, value);
            else if (Array.isArray(value)) topics.push(value.map((value)=>encodeTopic(param, value)));
            else topics.push(encodeTopic(param, value));
        });
        // Trim off trailing nulls
        while(topics.length && topics[topics.length - 1] === null)topics.pop();
        return topics;
    }
    encodeEventLog(eventFragment, values) {
        if (typeof eventFragment === "string") eventFragment = this.getEvent(eventFragment);
        const topics = [];
        const dataTypes = [];
        const dataValues = [];
        if (!eventFragment.anonymous) topics.push(this.getEventTopic(eventFragment));
        if (values.length !== eventFragment.inputs.length) logger.throwArgumentError("event arguments/values mismatch", "values", values);
        eventFragment.inputs.forEach((param, index)=>{
            const value = values[index];
            if (param.indexed) {
                if (param.type === "string") topics.push((0, _hash.id)(value));
                else if (param.type === "bytes") topics.push((0, _keccak256.keccak256)(value));
                else if (param.baseType === "tuple" || param.baseType === "array") // @TODO
                throw new Error("not implemented");
                else topics.push(this._abiCoder.encode([
                    param.type
                ], [
                    value
                ]));
            } else {
                dataTypes.push(param);
                dataValues.push(value);
            }
        });
        return {
            data: this._abiCoder.encode(dataTypes, dataValues),
            topics: topics
        };
    }
    // Decode a filter for the event and the search criteria
    decodeEventLog(eventFragment, data, topics) {
        if (typeof eventFragment === "string") eventFragment = this.getEvent(eventFragment);
        if (topics != null && !eventFragment.anonymous) {
            let topicHash = this.getEventTopic(eventFragment);
            if (!(0, _bytes.isHexString)(topics[0], 32) || topics[0].toLowerCase() !== topicHash) logger.throwError("fragment/topic mismatch", (0, _logger.Logger).errors.INVALID_ARGUMENT, {
                argument: "topics[0]",
                expected: topicHash,
                value: topics[0]
            });
            topics = topics.slice(1);
        }
        let indexed = [];
        let nonIndexed = [];
        let dynamic = [];
        eventFragment.inputs.forEach((param, index)=>{
            if (param.indexed) {
                if (param.type === "string" || param.type === "bytes" || param.baseType === "tuple" || param.baseType === "array") {
                    indexed.push((0, _fragments.ParamType).fromObject({
                        type: "bytes32",
                        name: param.name
                    }));
                    dynamic.push(true);
                } else {
                    indexed.push(param);
                    dynamic.push(false);
                }
            } else {
                nonIndexed.push(param);
                dynamic.push(false);
            }
        });
        let resultIndexed = topics != null ? this._abiCoder.decode(indexed, (0, _bytes.concat)(topics)) : null;
        let resultNonIndexed = this._abiCoder.decode(nonIndexed, data, true);
        let result = [];
        let nonIndexedIndex = 0, indexedIndex = 0;
        eventFragment.inputs.forEach((param, index)=>{
            if (param.indexed) {
                if (resultIndexed == null) result[index] = new Indexed({
                    _isIndexed: true,
                    hash: null
                });
                else if (dynamic[index]) result[index] = new Indexed({
                    _isIndexed: true,
                    hash: resultIndexed[indexedIndex++]
                });
                else try {
                    result[index] = resultIndexed[indexedIndex++];
                } catch (error) {
                    result[index] = error;
                }
            } else try {
                result[index] = resultNonIndexed[nonIndexedIndex++];
            } catch (error) {
                result[index] = error;
            }
            // Add the keyword argument if named and safe
            if (param.name && result[param.name] == null) {
                const value = result[index];
                // Make error named values throw on access
                if (value instanceof Error) Object.defineProperty(result, param.name, {
                    enumerable: true,
                    get: ()=>{
                        throw wrapAccessError(`property ${JSON.stringify(param.name)}`, value);
                    }
                });
                else result[param.name] = value;
            }
        });
        // Make all error indexed values throw on access
        for(let i = 0; i < result.length; i++){
            const value = result[i];
            if (value instanceof Error) Object.defineProperty(result, i, {
                enumerable: true,
                get: ()=>{
                    throw wrapAccessError(`index ${i}`, value);
                }
            });
        }
        return Object.freeze(result);
    }
    // Given a transaction, find the matching function fragment (if any) and
    // determine all its properties and call parameters
    parseTransaction(tx) {
        let fragment = this.getFunction(tx.data.substring(0, 10).toLowerCase());
        if (!fragment) return null;
        return new TransactionDescription({
            args: this._abiCoder.decode(fragment.inputs, "0x" + tx.data.substring(10)),
            functionFragment: fragment,
            name: fragment.name,
            signature: fragment.format(),
            sighash: this.getSighash(fragment),
            value: (0, _bignumber.BigNumber).from(tx.value || "0")
        });
    }
    // @TODO
    //parseCallResult(data: BytesLike): ??
    // Given an event log, find the matching event fragment (if any) and
    // determine all its properties and values
    parseLog(log) {
        let fragment = this.getEvent(log.topics[0]);
        if (!fragment || fragment.anonymous) return null;
        // @TODO: If anonymous, and the only method, and the input count matches, should we parse?
        //        Probably not, because just because it is the only event in the ABI does
        //        not mean we have the full ABI; maybe just a fragment?
        return new LogDescription({
            eventFragment: fragment,
            name: fragment.name,
            signature: fragment.format(),
            topic: this.getEventTopic(fragment),
            args: this.decodeEventLog(fragment, log.data, log.topics)
        });
    }
    parseError(data) {
        const hexData = (0, _bytes.hexlify)(data);
        let fragment = this.getError(hexData.substring(0, 10).toLowerCase());
        if (!fragment) return null;
        return new ErrorDescription({
            args: this._abiCoder.decode(fragment.inputs, "0x" + hexData.substring(10)),
            errorFragment: fragment,
            name: fragment.name,
            signature: fragment.format(),
            sighash: this.getSighash(fragment)
        });
    }
    /*
    static from(value: Array<Fragment | string | JsonAbi> | string | Interface) {
        if (Interface.isInterface(value)) {
            return value;
        }
        if (typeof(value) === "string") {
            return new Interface(JSON.parse(value));
        }
        return new Interface(value);
    }
    */ static isInterface(value) {
        return !!(value && value._isInterface);
    }
}

},{"@ethersproject/address":"4jHq7","@ethersproject/bignumber":"fUhf1","@ethersproject/bytes":"4xCgN","@ethersproject/hash":"5pRZ2","@ethersproject/keccak256":"jDqTa","@ethersproject/properties":"016Tj","./abi-coder":"jFGBW","./coders/abstract-coder":"2f9zv","./fragments":"5nqWe","@ethersproject/logger":"jADah","./_version":"fI0Q8","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"5pRZ2":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "id", ()=>(0, _id.id));
parcelHelpers.export(exports, "dnsEncode", ()=>(0, _namehash.dnsEncode));
parcelHelpers.export(exports, "namehash", ()=>(0, _namehash.namehash));
parcelHelpers.export(exports, "isValidName", ()=>(0, _namehash.isValidName));
parcelHelpers.export(exports, "ensNormalize", ()=>(0, _namehash.ensNormalize));
parcelHelpers.export(exports, "messagePrefix", ()=>(0, _message.messagePrefix));
parcelHelpers.export(exports, "hashMessage", ()=>(0, _message.hashMessage));
parcelHelpers.export(exports, "_TypedDataEncoder", ()=>(0, _typedData.TypedDataEncoder));
var _id = require("./id");
var _namehash = require("./namehash");
var _message = require("./message");
var _typedData = require("./typed-data");
"use strict";

},{"./id":"ahQ4U","./namehash":false,"./message":false,"./typed-data":false,"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"ahQ4U":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "id", ()=>id);
var _keccak256 = require("@ethersproject/keccak256");
var _strings = require("@ethersproject/strings");
function id(text) {
    return (0, _keccak256.keccak256)((0, _strings.toUtf8Bytes)(text));
}

},{"@ethersproject/keccak256":"jDqTa","@ethersproject/strings":"9TQil","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2yu6A":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "toHex", ()=>toHex);
parcelHelpers.export(exports, "fromHex", ()=>fromHex);
parcelHelpers.export(exports, "formatBlock", ()=>formatBlock);
function toHex(n) {
    return "0x" + n.toString(16);
}
function fromHex(hexString) {
    return Number.parseInt(hexString, 16);
}
function formatBlock(block) {
    if (typeof block === "string") return block;
    else if (typeof block === "number" && Number.isInteger(block)) return toHex(block);
    return block.toString();
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"03X3y":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Helper for converting functions which take a callback as their final argument
 * to functions which return a promise.
 */ parcelHelpers.export(exports, "promisify", ()=>promisify);
/**
 * Helper for converting functions which return a promise to functions which
 * take a callback as their final argument.
 */ parcelHelpers.export(exports, "callWhenDone", ()=>callWhenDone);
parcelHelpers.export(exports, "delay", ()=>delay);
parcelHelpers.export(exports, "withTimeout", ()=>withTimeout);
parcelHelpers.export(exports, "withBackoffRetries", ()=>withBackoffRetries);
parcelHelpers.export(exports, "makeCancelToken", ()=>makeCancelToken);
parcelHelpers.export(exports, "throwIfCancelled", ()=>throwIfCancelled);
parcelHelpers.export(exports, "CANCELLED", ()=>CANCELLED);
var _tslib = require("tslib");
function promisify(f) {
    return new Promise(function(resolve, reject) {
        return f(function(error, result) {
            if (error != null) reject(error);
            else resolve(result);
        });
    });
}
function callWhenDone(promise, callback) {
    promise.then(function(result) {
        callback(null, result);
    }, function(error) {
        callback(error);
    });
}
function delay(ms) {
    return new Promise(function(resolve) {
        return setTimeout(resolve, ms);
    });
}
function withTimeout(promise, ms) {
    return Promise.race([
        promise,
        new Promise(function(_, reject) {
            return setTimeout(function() {
                return reject(new Error("Timeout"));
            }, ms);
        })
    ]);
}
var MIN_RETRY_DELAY = 1000;
var RETRY_BACKOFF_FACTOR = 2;
var MAX_RETRY_DELAY = 30000;
function withBackoffRetries(f, retryCount, shouldRetry) {
    if (shouldRetry === void 0) shouldRetry = function() {
        return true;
    };
    return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
        var nextWaitTime, i, error_1;
        return (0, _tslib.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    nextWaitTime = 0;
                    i = 0;
                    _a.label = 1;
                case 1:
                    _a.label = 2;
                case 2:
                    _a.trys.push([
                        2,
                        4,
                        ,
                        6
                    ]);
                    return [
                        4 /*yield*/ ,
                        f()
                    ];
                case 3:
                    return [
                        2 /*return*/ ,
                        _a.sent()
                    ];
                case 4:
                    error_1 = _a.sent();
                    i++;
                    if (i >= retryCount || !shouldRetry(error_1)) throw error_1;
                    return [
                        4 /*yield*/ ,
                        delay(nextWaitTime)
                    ];
                case 5:
                    _a.sent();
                    if (!shouldRetry(error_1)) throw error_1;
                    nextWaitTime = nextWaitTime === 0 ? MIN_RETRY_DELAY : Math.min(MAX_RETRY_DELAY, RETRY_BACKOFF_FACTOR * nextWaitTime);
                    return [
                        3 /*break*/ ,
                        6
                    ];
                case 6:
                    return [
                        3 /*break*/ ,
                        1
                    ];
                case 7:
                    return [
                        2 /*return*/ 
                    ];
            }
        });
    });
}
function makeCancelToken() {
    var cancelled = false;
    return {
        cancel: function() {
            return cancelled = true;
        },
        isCancelled: function() {
            return cancelled;
        }
    };
}
function throwIfCancelled(isCancelled) {
    if (isCancelled()) throw CANCELLED;
}
var CANCELLED = new Error("Cancelled");

},{"tslib":"gBS4y","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4vthg":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "makeAlchemyContext", ()=>makeAlchemyContext);
var _sturdyWebsocket = require("sturdy-websocket");
var _sturdyWebsocketDefault = parcelHelpers.interopDefault(_sturdyWebsocket);
var _websocket = require("websocket");
var _jsonRpc = require("../util/jsonRpc");
var _version = require("../version");
var _alchemySendHttp = require("./alchemySendHttp");
var _alchemySendWebSocket = require("./alchemySendWebSocket");
var _httpProvider = require("./httpProvider");
var _sendJsonRpcPayload = require("./sendJsonRpcPayload");
var _sendRestPayload = require("./sendRestPayload");
var _webSocketProvider = require("./webSocketProvider");
var process = require("e757a4c5e7de8bee");
var NODE_MAX_WS_FRAME_SIZE = 104857600; // 100 MB
function makeAlchemyContext(url, config) {
    var makeJsonRpcPayload = (0, _jsonRpc.makeJsonRpcPayloadFactory)();
    var restSender = (0, _sendRestPayload.makeRestPayloadSender)({
        config: config,
        url: url
    });
    if (/^https?:\/\//.test(url)) {
        var alchemySendJsonrRpc = (0, _alchemySendHttp.makeJsonRpcHttpSender)(url);
        var _a = (0, _sendJsonRpcPayload.makeJsonRpcPayloadSender)(alchemySendJsonrRpc, config), sendJsonRpcPayload = _a.sendJsonRpcPayload, setWriteProvider = _a.setWriteProvider;
        var jsonRpcSenders = (0, _jsonRpc.makeJsonRpcSenders)(sendJsonRpcPayload, makeJsonRpcPayload);
        var provider = (0, _httpProvider.makeAlchemyHttpProvider)(sendJsonRpcPayload);
        return {
            provider: provider,
            jsonRpcSenders: jsonRpcSenders,
            restSender: restSender,
            setWriteProvider: setWriteProvider
        };
    } else if (/^wss?:\/\//.test(url)) {
        var protocol = isAlchemyUrl(url) ? "alchemy-web3-" + (0, _version.VERSION) : undefined;
        var ws = new (0, _sturdyWebsocketDefault.default)(url, protocol, {
            wsConstructor: getWebSocketConstructor()
        });
        var alchemySend = (0, _alchemySendWebSocket.makeWebSocketSender)(ws);
        var _b = (0, _sendJsonRpcPayload.makeJsonRpcPayloadSender)(alchemySend, config), sendJsonRpcPayload = _b.sendJsonRpcPayload, setWriteProvider = _b.setWriteProvider;
        var jsonRpcSenders = (0, _jsonRpc.makeJsonRpcSenders)(sendJsonRpcPayload, makeJsonRpcPayload);
        var provider = new (0, _webSocketProvider.AlchemyWebSocketProvider)(ws, sendJsonRpcPayload, jsonRpcSenders);
        return {
            provider: provider,
            jsonRpcSenders: jsonRpcSenders,
            restSender: restSender,
            setWriteProvider: setWriteProvider
        };
    } else throw new Error("Alchemy URL protocol must be one of http, https, ws, or wss. Recieved: " + url);
}
function getWebSocketConstructor() {
    return isNodeEnvironment() ? function(url, protocols) {
        return new (0, _websocket.w3cwebsocket)(url, protocols, undefined, undefined, undefined, {
            maxReceivedMessageSize: NODE_MAX_WS_FRAME_SIZE,
            maxReceivedFrameSize: NODE_MAX_WS_FRAME_SIZE
        });
    } : WebSocket;
}
function isNodeEnvironment() {
    return typeof process !== "undefined" && process != null && process.versions != null && process.versions.node != null;
}
function isAlchemyUrl(url) {
    return url.indexOf("alchemy.com") >= 0 || url.indexOf("alchemyapi.io") >= 0;
}

},{"e757a4c5e7de8bee":"5QIF0","sturdy-websocket":"d7NDw","websocket":"g48Be","../util/jsonRpc":"lHMPJ","../version":"lkx9n","./alchemySendHttp":"iI0oM","./alchemySendWebSocket":"fKdyf","./httpProvider":"1tlbO","./sendJsonRpcPayload":"3ia1r","./sendRestPayload":"78Gu2","./webSocketProvider":"e9ZDO","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"d7NDw":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
var SHOULD_RECONNECT_FALSE_MESSAGE = "Provided shouldReconnect() returned false. Closing permanently.";
var SHOULD_RECONNECT_PROMISE_FALSE_MESSAGE = "Provided shouldReconnect() resolved to false. Closing permanently.";
var SturdyWebSocket = /** @class */ function() {
    function SturdyWebSocket(url, protocolsOrOptions, options) {
        if (options === void 0) options = {};
        this.url = url;
        this.onclose = null;
        this.onerror = null;
        this.onmessage = null;
        this.onopen = null;
        this.ondown = null;
        this.onreopen = null;
        this.CONNECTING = SturdyWebSocket.CONNECTING;
        this.OPEN = SturdyWebSocket.OPEN;
        this.CLOSING = SturdyWebSocket.CLOSING;
        this.CLOSED = SturdyWebSocket.CLOSED;
        this.hasBeenOpened = false;
        this.isClosed = false;
        this.messageBuffer = [];
        this.nextRetryTime = 0;
        this.reconnectCount = 0;
        this.lastKnownExtensions = "";
        this.lastKnownProtocol = "";
        this.listeners = {};
        if (protocolsOrOptions == null || typeof protocolsOrOptions === "string" || Array.isArray(protocolsOrOptions)) this.protocols = protocolsOrOptions;
        else options = protocolsOrOptions;
        this.options = applyDefaultOptions(options);
        if (!this.options.wsConstructor) {
            if (typeof WebSocket !== "undefined") this.options.wsConstructor = WebSocket;
            else throw new Error("WebSocket not present in global scope and no wsConstructor option was provided.");
        }
        this.openNewWebSocket();
    }
    Object.defineProperty(SturdyWebSocket.prototype, "binaryType", {
        get: function() {
            return this.binaryTypeInternal || "blob";
        },
        set: function(binaryType) {
            this.binaryTypeInternal = binaryType;
            if (this.ws) this.ws.binaryType = binaryType;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SturdyWebSocket.prototype, "bufferedAmount", {
        get: function() {
            var sum = this.ws ? this.ws.bufferedAmount : 0;
            var hasUnknownAmount = false;
            this.messageBuffer.forEach(function(data) {
                var byteLength = getDataByteLength(data);
                if (byteLength != null) sum += byteLength;
                else hasUnknownAmount = true;
            });
            if (hasUnknownAmount) this.debugLog("Some buffered data had unknown length. bufferedAmount() return value may be below the correct amount.");
            return sum;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SturdyWebSocket.prototype, "extensions", {
        get: function() {
            return this.ws ? this.ws.extensions : this.lastKnownExtensions;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SturdyWebSocket.prototype, "protocol", {
        get: function() {
            return this.ws ? this.ws.protocol : this.lastKnownProtocol;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SturdyWebSocket.prototype, "readyState", {
        get: function() {
            return this.isClosed ? SturdyWebSocket.CLOSED : SturdyWebSocket.OPEN;
        },
        enumerable: true,
        configurable: true
    });
    SturdyWebSocket.prototype.close = function(code, reason) {
        this.disposeSocket(code, reason);
        this.shutdown();
        this.debugLog("WebSocket permanently closed by client.");
    };
    SturdyWebSocket.prototype.send = function(data) {
        if (this.isClosed) throw new Error("WebSocket is already in CLOSING or CLOSED state.");
        else if (this.ws && this.ws.readyState === this.OPEN) this.ws.send(data);
        else this.messageBuffer.push(data);
    };
    SturdyWebSocket.prototype.reconnect = function() {
        if (this.isClosed) throw new Error("Cannot call reconnect() on socket which is permanently closed.");
        this.disposeSocket(1000, "Client requested reconnect.");
        this.handleClose(undefined);
    };
    SturdyWebSocket.prototype.addEventListener = function(type, listener) {
        if (!this.listeners[type]) this.listeners[type] = [];
        this.listeners[type].push(listener);
    };
    SturdyWebSocket.prototype.dispatchEvent = function(event) {
        return this.dispatchEventOfType(event.type, event);
    };
    SturdyWebSocket.prototype.removeEventListener = function(type, listener) {
        if (this.listeners[type]) this.listeners[type] = this.listeners[type].filter(function(l) {
            return l !== listener;
        });
    };
    SturdyWebSocket.prototype.openNewWebSocket = function() {
        var _this = this;
        if (this.isClosed) return;
        var _a = this.options, connectTimeout = _a.connectTimeout, wsConstructor = _a.wsConstructor;
        this.debugLog("Opening new WebSocket to " + this.url + ".");
        var ws = new wsConstructor(this.url, this.protocols);
        ws.onclose = function(event) {
            return _this.handleClose(event);
        };
        ws.onerror = function(event) {
            return _this.handleError(event);
        };
        ws.onmessage = function(event) {
            return _this.handleMessage(event);
        };
        ws.onopen = function(event) {
            return _this.handleOpen(event);
        };
        this.connectTimeoutId = setTimeout(function() {
            // If this is running, we still haven't opened the websocket.
            // Kill it so we can try again.
            _this.clearConnectTimeout();
            _this.disposeSocket();
            _this.handleClose(undefined);
        }, connectTimeout);
        this.ws = ws;
    };
    SturdyWebSocket.prototype.handleOpen = function(event) {
        var _this = this;
        if (!this.ws || this.isClosed) return;
        var allClearResetTime = this.options.allClearResetTime;
        this.debugLog("WebSocket opened.");
        if (this.binaryTypeInternal != null) this.ws.binaryType = this.binaryTypeInternal;
        else this.binaryTypeInternal = this.ws.binaryType;
        this.clearConnectTimeout();
        if (this.hasBeenOpened) this.dispatchEventOfType("reopen", event);
        else {
            this.dispatchEventOfType("open", event);
            this.hasBeenOpened = true;
        }
        this.messageBuffer.forEach(function(message) {
            return _this.send(message);
        });
        this.messageBuffer = [];
        this.allClearTimeoutId = setTimeout(function() {
            _this.clearAllClearTimeout();
            _this.nextRetryTime = 0;
            _this.reconnectCount = 0;
            var openTime = allClearResetTime / 1000 | 0;
            _this.debugLog("WebSocket remained open for " + openTime + " seconds. Resetting" + " retry time and count.");
        }, allClearResetTime);
    };
    SturdyWebSocket.prototype.handleMessage = function(event) {
        if (this.isClosed) return;
        this.dispatchEventOfType("message", event);
    };
    SturdyWebSocket.prototype.handleClose = function(event) {
        var _this = this;
        if (this.isClosed) return;
        var _a = this.options, maxReconnectAttempts = _a.maxReconnectAttempts, shouldReconnect = _a.shouldReconnect;
        this.clearConnectTimeout();
        this.clearAllClearTimeout();
        if (this.ws) {
            this.lastKnownExtensions = this.ws.extensions;
            this.lastKnownProtocol = this.ws.protocol;
            this.disposeSocket();
        }
        this.dispatchEventOfType("down", event);
        if (this.reconnectCount >= maxReconnectAttempts) {
            this.stopReconnecting(event, this.getTooManyFailedReconnectsMessage());
            return;
        }
        var willReconnect = !event || shouldReconnect(event);
        if (typeof willReconnect === "boolean") this.handleWillReconnect(willReconnect, event, SHOULD_RECONNECT_FALSE_MESSAGE);
        else willReconnect.then(function(willReconnectResolved) {
            if (_this.isClosed) return;
            _this.handleWillReconnect(willReconnectResolved, event, SHOULD_RECONNECT_PROMISE_FALSE_MESSAGE);
        });
    };
    SturdyWebSocket.prototype.handleError = function(event) {
        this.dispatchEventOfType("error", event);
        this.debugLog("WebSocket encountered an error.");
    };
    SturdyWebSocket.prototype.handleWillReconnect = function(willReconnect, event, denialReason) {
        if (willReconnect) this.reestablishConnection();
        else this.stopReconnecting(event, denialReason);
    };
    SturdyWebSocket.prototype.reestablishConnection = function() {
        var _this = this;
        var _a = this.options, minReconnectDelay = _a.minReconnectDelay, maxReconnectDelay = _a.maxReconnectDelay, reconnectBackoffFactor = _a.reconnectBackoffFactor;
        this.reconnectCount++;
        var retryTime = this.nextRetryTime;
        this.nextRetryTime = Math.max(minReconnectDelay, Math.min(this.nextRetryTime * reconnectBackoffFactor, maxReconnectDelay));
        setTimeout(function() {
            return _this.openNewWebSocket();
        }, retryTime);
        var retryTimeSeconds = retryTime / 1000 | 0;
        this.debugLog("WebSocket was closed. Re-opening in " + retryTimeSeconds + " seconds.");
    };
    SturdyWebSocket.prototype.stopReconnecting = function(event, debugReason) {
        this.debugLog(debugReason);
        this.shutdown();
        if (event) this.dispatchEventOfType("close", event);
    };
    SturdyWebSocket.prototype.shutdown = function() {
        this.isClosed = true;
        this.clearAllTimeouts();
        this.messageBuffer = [];
        this.disposeSocket();
    };
    SturdyWebSocket.prototype.disposeSocket = function(closeCode, reason) {
        if (!this.ws) return;
        // Use noop handlers instead of null because some WebSocket
        // implementations, such as the one from isomorphic-ws, raise a stink on
        // unhandled events.
        this.ws.onerror = noop;
        this.ws.onclose = noop;
        this.ws.onmessage = noop;
        this.ws.onopen = noop;
        this.ws.close(closeCode, reason);
        this.ws = undefined;
    };
    SturdyWebSocket.prototype.clearAllTimeouts = function() {
        this.clearConnectTimeout();
        this.clearAllClearTimeout();
    };
    SturdyWebSocket.prototype.clearConnectTimeout = function() {
        if (this.connectTimeoutId != null) {
            clearTimeout(this.connectTimeoutId);
            this.connectTimeoutId = undefined;
        }
    };
    SturdyWebSocket.prototype.clearAllClearTimeout = function() {
        if (this.allClearTimeoutId != null) {
            clearTimeout(this.allClearTimeoutId);
            this.allClearTimeoutId = undefined;
        }
    };
    SturdyWebSocket.prototype.dispatchEventOfType = function(type, event) {
        var _this = this;
        switch(type){
            case "close":
                if (this.onclose) this.onclose(event);
                break;
            case "error":
                if (this.onerror) this.onerror(event);
                break;
            case "message":
                if (this.onmessage) this.onmessage(event);
                break;
            case "open":
                if (this.onopen) this.onopen(event);
                break;
            case "down":
                if (this.ondown) this.ondown(event);
                break;
            case "reopen":
                if (this.onreopen) this.onreopen(event);
                break;
        }
        if (type in this.listeners) this.listeners[type].slice().forEach(function(listener) {
            return _this.callListener(listener, event);
        });
        return !event || !event.defaultPrevented;
    };
    SturdyWebSocket.prototype.callListener = function(listener, event) {
        if (typeof listener === "function") listener.call(this, event);
        else listener.handleEvent.call(this, event);
    };
    SturdyWebSocket.prototype.debugLog = function(message) {
        if (this.options.debug) // tslint:disable-next-line:no-console
        console.log(message);
    };
    SturdyWebSocket.prototype.getTooManyFailedReconnectsMessage = function() {
        var maxReconnectAttempts = this.options.maxReconnectAttempts;
        return "Failed to reconnect after " + maxReconnectAttempts + " " + pluralize("attempt", maxReconnectAttempts) + ". Closing permanently.";
    };
    SturdyWebSocket.DEFAULT_OPTIONS = {
        allClearResetTime: 5000,
        connectTimeout: 5000,
        debug: false,
        minReconnectDelay: 1000,
        maxReconnectDelay: 30000,
        maxReconnectAttempts: Number.POSITIVE_INFINITY,
        reconnectBackoffFactor: 1.5,
        shouldReconnect: function() {
            return true;
        },
        wsConstructor: undefined
    };
    SturdyWebSocket.CONNECTING = 0;
    SturdyWebSocket.OPEN = 1;
    SturdyWebSocket.CLOSING = 2;
    SturdyWebSocket.CLOSED = 3;
    return SturdyWebSocket;
}();
exports.default = SturdyWebSocket;
function applyDefaultOptions(options) {
    var result = {};
    Object.keys(SturdyWebSocket.DEFAULT_OPTIONS).forEach(function(key) {
        var value = options[key];
        result[key] = value === undefined ? SturdyWebSocket.DEFAULT_OPTIONS[key] : value;
    });
    return result;
}
function getDataByteLength(data) {
    if (typeof data === "string") // UTF-16 strings use two bytes per character.
    return 2 * data.length;
    else if (data instanceof ArrayBuffer) return data.byteLength;
    else if (data instanceof Blob) return data.size;
    else return undefined;
}
function pluralize(s, n) {
    return n === 1 ? s : s + "s";
}
function noop() {
// Nothing.
}

},{}],"g48Be":[function(require,module,exports) {
var _globalThis;
if (typeof globalThis === "object") _globalThis = globalThis;
else try {
    _globalThis = require("b04a60909374582b");
} catch (error) {} finally{
    if (!_globalThis && typeof window !== "undefined") _globalThis = window;
    if (!_globalThis) throw new Error("Could not determine global this");
}
var NativeWebSocket = _globalThis.WebSocket || _globalThis.MozWebSocket;
var websocket_version = require("c8c7d948d8164168");
/**
 * Expose a W3C WebSocket class with just one or two arguments.
 */ function W3CWebSocket(uri, protocols) {
    var native_instance;
    if (protocols) native_instance = new NativeWebSocket(uri, protocols);
    else native_instance = new NativeWebSocket(uri);
    /**
	 * 'native_instance' is an instance of nativeWebSocket (the browser's WebSocket
	 * class). Since it is an Object it will be returned as it is when creating an
	 * instance of W3CWebSocket via 'new W3CWebSocket()'.
	 *
	 * ECMAScript 5: http://bclary.com/2004/11/07/#a-13.2.2
	 */ return native_instance;
}
if (NativeWebSocket) [
    "CONNECTING",
    "OPEN",
    "CLOSING",
    "CLOSED"
].forEach(function(prop) {
    Object.defineProperty(W3CWebSocket, prop, {
        get: function() {
            return NativeWebSocket[prop];
        }
    });
});
/**
 * Module exports.
 */ module.exports = {
    "w3cwebsocket": NativeWebSocket ? W3CWebSocket : null,
    "version": websocket_version
};

},{"b04a60909374582b":"eDqRS","c8c7d948d8164168":"6dRz2"}],"eDqRS":[function(require,module,exports) {
var naiveFallback = function() {
    if (typeof self === "object" && self) return self;
    if (typeof window === "object" && window) return window;
    throw new Error("Unable to resolve global `this`");
};
module.exports = function() {
    if (this) return this;
    // Unexpected strict mode (may happen if e.g. bundled into ESM module)
    // Fallback to standard globalThis if available
    if (typeof globalThis === "object" && globalThis) return globalThis;
    // Thanks @mathiasbynens -> https://mathiasbynens.be/notes/globalthis
    // In all ES5+ engines global object inherits from Object.prototype
    // (if you approached one that doesn't please report)
    try {
        Object.defineProperty(Object.prototype, "__global__", {
            get: function() {
                return this;
            },
            configurable: true
        });
    } catch (error) {
        // Unfortunate case of updates to Object.prototype being restricted
        // via preventExtensions, seal or freeze
        return naiveFallback();
    }
    try {
        // Safari case (window.__global__ works, but __global__ does not)
        if (!__global__) return naiveFallback();
        return __global__;
    } finally{
        delete Object.prototype.__global__;
    }
}();

},{}],"6dRz2":[function(require,module,exports) {
module.exports = require("5eb8256032dc5ca9").version;

},{"5eb8256032dc5ca9":"cKhcR"}],"cKhcR":[function(require,module,exports) {
module.exports = JSON.parse('{"name":"websocket","description":"Websocket Client & Server Library implementing the WebSocket protocol as specified in RFC 6455.","keywords":["websocket","websockets","socket","networking","comet","push","RFC-6455","realtime","server","client"],"author":"Brian McKelvey <theturtle32@gmail.com> (https://github.com/theturtle32)","contributors":["I\xf1aki Baz Castillo <ibc@aliax.net> (http://dev.sipdoc.net)"],"version":"1.0.35","repository":{"type":"git","url":"https://github.com/theturtle32/WebSocket-Node.git"},"homepage":"https://github.com/theturtle32/WebSocket-Node","engines":{"node":">=4.0.0"},"dependencies":{"bufferutil":"^4.0.1","debug":"^2.2.0","es5-ext":"^0.10.63","typedarray-to-buffer":"^3.1.5","utf-8-validate":"^5.0.2","yaeti":"^0.0.6"},"devDependencies":{"buffer-equal":"^1.0.0","gulp":"^4.0.2","gulp-jshint":"^2.0.4","jshint-stylish":"^2.2.1","jshint":"^2.0.0","tape":"^4.9.1"},"config":{"verbose":false},"scripts":{"test":"tape test/unit/*.js","gulp":"gulp"},"main":"index","directories":{"lib":"./lib"},"browser":"lib/browser.js","license":"Apache-2.0"}');

},{}],"lHMPJ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "makeJsonRpcPayloadFactory", ()=>makeJsonRpcPayloadFactory);
parcelHelpers.export(exports, "makeJsonRpcSenders", ()=>makeJsonRpcSenders);
parcelHelpers.export(exports, "makeResponse", ()=>makeResponse);
var _tslib = require("tslib");
function makeJsonRpcPayloadFactory() {
    var nextId = 0;
    return function(method, params) {
        return {
            method: method,
            params: params,
            jsonrpc: "2.0",
            id: "alc-web3:" + nextId++
        };
    };
}
function makeJsonRpcSenders(sendJsonRpcPayload, makeJsonRpcPayload) {
    var _this = this;
    var send = function(method, params) {
        return (0, _tslib.__awaiter)(_this, void 0, void 0, function() {
            var response;
            return (0, _tslib.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            sendJsonRpcPayload(makeJsonRpcPayload(method, params))
                        ];
                    case 1:
                        response = _a.sent();
                        if (response.error) throw new Error(response.error.message);
                        return [
                            2 /*return*/ ,
                            response.result
                        ];
                }
            });
        });
    };
    function sendBatch(parts) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var payload, response, message, errorResponse;
            return (0, _tslib.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        payload = parts.map(function(_a) {
                            var method = _a.method, params = _a.params;
                            return makeJsonRpcPayload(method, params);
                        });
                        return [
                            4 /*yield*/ ,
                            sendJsonRpcPayload(payload)
                        ];
                    case 1:
                        response = _a.sent();
                        if (!Array.isArray(response)) {
                            message = response.error ? response.error.message : "Batch request failed";
                            throw new Error(message);
                        }
                        errorResponse = response.find(function(r) {
                            return !!r.error;
                        });
                        if (errorResponse) throw new Error(errorResponse.error.message);
                        // The ids are ascending numbers because that's what Payload Factories do.
                        return [
                            2 /*return*/ ,
                            response.sort(function(r1, r2) {
                                return r1.id - r2.id;
                            }).map(function(r) {
                                return r.result;
                            })
                        ];
                }
            });
        });
    }
    return {
        send: send,
        sendBatch: sendBatch
    };
}
function makeResponse(id, result) {
    return {
        jsonrpc: "2.0",
        id: id,
        result: result
    };
}

},{"tslib":"gBS4y","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"lkx9n":[function(require,module,exports) {
// This file is autogenerated by injectVersion.js. Any changes will be
// overwritten on commit!
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "VERSION", ()=>VERSION);
var VERSION = "1.4.7";

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"iI0oM":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "makeJsonRpcHttpSender", ()=>makeJsonRpcHttpSender);
var _tslib = require("tslib");
var _fetchPonyfill = require("fetch-ponyfill");
var _fetchPonyfillDefault = parcelHelpers.interopDefault(_fetchPonyfill);
var _version = require("../version");
var _a = (0, _fetchPonyfillDefault.default)(), fetch = _a.fetch, Headers = _a.Headers;
var ALCHEMY_HEADERS = new Headers({
    Accept: "application/json",
    "Content-Type": "application/json",
    "Alchemy-Web3-Version": (0, _version.VERSION)
});
var RATE_LIMIT_STATUS = 429;
function makeJsonRpcHttpSender(url) {
    var _this = this;
    return function(request) {
        return (0, _tslib.__awaiter)(_this, void 0, void 0, function() {
            var response, status, _a;
            var _b, _c;
            var _d;
            return (0, _tslib.__generator)(this, function(_e) {
                switch(_e.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            fetch(url, {
                                method: "POST",
                                headers: ALCHEMY_HEADERS,
                                body: JSON.stringify(request)
                            })
                        ];
                    case 1:
                        response = _e.sent();
                        status = response.status;
                        _a = status;
                        switch(_a){
                            case 200:
                                return [
                                    3 /*break*/ ,
                                    2
                                ];
                            case RATE_LIMIT_STATUS:
                                return [
                                    3 /*break*/ ,
                                    4
                                ];
                            case 0:
                                return [
                                    3 /*break*/ ,
                                    5
                                ];
                        }
                        return [
                            3 /*break*/ ,
                            6
                        ];
                    case 2:
                        _b = {
                            type: "jsonrpc"
                        };
                        return [
                            4 /*yield*/ ,
                            response.json()
                        ];
                    case 3:
                        return [
                            2 /*return*/ ,
                            (_b.response = _e.sent(), _b)
                        ];
                    case 4:
                        return [
                            2 /*return*/ ,
                            {
                                type: "rateLimit"
                            }
                        ];
                    case 5:
                        return [
                            2 /*return*/ ,
                            {
                                type: "networkError",
                                status: 0,
                                message: "Connection failed."
                            }
                        ];
                    case 6:
                        _c = {
                            status: status,
                            type: "networkError"
                        };
                        return [
                            4 /*yield*/ ,
                            response.json()
                        ];
                    case 7:
                        return [
                            2 /*return*/ ,
                            (_c.message = (_d = _e.sent().error) === null || _d === void 0 ? void 0 : _d.message, _c)
                        ];
                }
            });
        });
    };
}

},{"tslib":"gBS4y","fetch-ponyfill":"fKQLJ","../version":"lkx9n","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"fKQLJ":[function(require,module,exports) {
var global = arguments[3];
(function(self1) {
    "use strict";
    function fetchPonyfill(options) {
        var Promise = options && options.Promise || self1.Promise;
        var XMLHttpRequest = options && options.XMLHttpRequest || self1.XMLHttpRequest;
        var global = self1;
        return function() {
            var self1 = Object.create(global, {
                fetch: {
                    value: undefined,
                    writable: true
                }
            });
            (function(self1) {
                "use strict";
                if (self1.fetch) return;
                var support = {
                    searchParams: "URLSearchParams" in self1,
                    iterable: "Symbol" in self1 && "iterator" in Symbol,
                    blob: "FileReader" in self1 && "Blob" in self1 && function() {
                        try {
                            new Blob();
                            return true;
                        } catch (e) {
                            return false;
                        }
                    }(),
                    formData: "FormData" in self1,
                    arrayBuffer: "ArrayBuffer" in self1
                };
                if (support.arrayBuffer) {
                    var viewClasses = [
                        "[object Int8Array]",
                        "[object Uint8Array]",
                        "[object Uint8ClampedArray]",
                        "[object Int16Array]",
                        "[object Uint16Array]",
                        "[object Int32Array]",
                        "[object Uint32Array]",
                        "[object Float32Array]",
                        "[object Float64Array]"
                    ];
                    var isDataView = function(obj) {
                        return obj && DataView.prototype.isPrototypeOf(obj);
                    };
                    var isArrayBufferView = ArrayBuffer.isView || function(obj) {
                        return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1;
                    };
                }
                function normalizeName(name) {
                    if (typeof name !== "string") name = String(name);
                    if (/[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(name)) throw new TypeError("Invalid character in header field name");
                    return name.toLowerCase();
                }
                function normalizeValue(value) {
                    if (typeof value !== "string") value = String(value);
                    return value;
                }
                // Build a destructive iterator for the value list
                function iteratorFor(items) {
                    var iterator = {
                        next: function() {
                            var value = items.shift();
                            return {
                                done: value === undefined,
                                value: value
                            };
                        }
                    };
                    if (support.iterable) iterator[Symbol.iterator] = function() {
                        return iterator;
                    };
                    return iterator;
                }
                function Headers(headers) {
                    this.map = {};
                    if (headers instanceof Headers) headers.forEach(function(value, name) {
                        this.append(name, value);
                    }, this);
                    else if (Array.isArray(headers)) headers.forEach(function(header) {
                        this.append(header[0], header[1]);
                    }, this);
                    else if (headers) Object.getOwnPropertyNames(headers).forEach(function(name) {
                        this.append(name, headers[name]);
                    }, this);
                }
                Headers.prototype.append = function(name, value) {
                    name = normalizeName(name);
                    value = normalizeValue(value);
                    var oldValue = this.map[name];
                    this.map[name] = oldValue ? oldValue + "," + value : value;
                };
                Headers.prototype["delete"] = function(name) {
                    delete this.map[normalizeName(name)];
                };
                Headers.prototype.get = function(name) {
                    name = normalizeName(name);
                    return this.has(name) ? this.map[name] : null;
                };
                Headers.prototype.has = function(name) {
                    return this.map.hasOwnProperty(normalizeName(name));
                };
                Headers.prototype.set = function(name, value) {
                    this.map[normalizeName(name)] = normalizeValue(value);
                };
                Headers.prototype.forEach = function(callback, thisArg) {
                    for(var name in this.map)if (this.map.hasOwnProperty(name)) callback.call(thisArg, this.map[name], name, this);
                };
                Headers.prototype.keys = function() {
                    var items = [];
                    this.forEach(function(value, name) {
                        items.push(name);
                    });
                    return iteratorFor(items);
                };
                Headers.prototype.values = function() {
                    var items = [];
                    this.forEach(function(value) {
                        items.push(value);
                    });
                    return iteratorFor(items);
                };
                Headers.prototype.entries = function() {
                    var items = [];
                    this.forEach(function(value, name) {
                        items.push([
                            name,
                            value
                        ]);
                    });
                    return iteratorFor(items);
                };
                if (support.iterable) Headers.prototype[Symbol.iterator] = Headers.prototype.entries;
                function consumed(body) {
                    if (body.bodyUsed) return Promise.reject(new TypeError("Already read"));
                    body.bodyUsed = true;
                }
                function fileReaderReady(reader) {
                    return new Promise(function(resolve, reject) {
                        reader.onload = function() {
                            resolve(reader.result);
                        };
                        reader.onerror = function() {
                            reject(reader.error);
                        };
                    });
                }
                function readBlobAsArrayBuffer(blob) {
                    var reader = new FileReader();
                    var promise = fileReaderReady(reader);
                    reader.readAsArrayBuffer(blob);
                    return promise;
                }
                function readBlobAsText(blob) {
                    var reader = new FileReader();
                    var promise = fileReaderReady(reader);
                    reader.readAsText(blob);
                    return promise;
                }
                function readArrayBufferAsText(buf) {
                    var view = new Uint8Array(buf);
                    var chars = new Array(view.length);
                    for(var i = 0; i < view.length; i++)chars[i] = String.fromCharCode(view[i]);
                    return chars.join("");
                }
                function bufferClone(buf) {
                    if (buf.slice) return buf.slice(0);
                    else {
                        var view = new Uint8Array(buf.byteLength);
                        view.set(new Uint8Array(buf));
                        return view.buffer;
                    }
                }
                function Body() {
                    this.bodyUsed = false;
                    this._initBody = function(body) {
                        this._bodyInit = body;
                        if (!body) this._bodyText = "";
                        else if (typeof body === "string") this._bodyText = body;
                        else if (support.blob && Blob.prototype.isPrototypeOf(body)) this._bodyBlob = body;
                        else if (support.formData && FormData.prototype.isPrototypeOf(body)) this._bodyFormData = body;
                        else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) this._bodyText = body.toString();
                        else if (support.arrayBuffer && support.blob && isDataView(body)) {
                            this._bodyArrayBuffer = bufferClone(body.buffer);
                            // IE 10-11 can't handle a DataView body.
                            this._bodyInit = new Blob([
                                this._bodyArrayBuffer
                            ]);
                        } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) this._bodyArrayBuffer = bufferClone(body);
                        else throw new Error("unsupported BodyInit type");
                        if (!this.headers.get("content-type")) {
                            if (typeof body === "string") this.headers.set("content-type", "text/plain;charset=UTF-8");
                            else if (this._bodyBlob && this._bodyBlob.type) this.headers.set("content-type", this._bodyBlob.type);
                            else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) this.headers.set("content-type", "application/x-www-form-urlencoded;charset=UTF-8");
                        }
                    };
                    if (support.blob) {
                        this.blob = function() {
                            var rejected = consumed(this);
                            if (rejected) return rejected;
                            if (this._bodyBlob) return Promise.resolve(this._bodyBlob);
                            else if (this._bodyArrayBuffer) return Promise.resolve(new Blob([
                                this._bodyArrayBuffer
                            ]));
                            else if (this._bodyFormData) throw new Error("could not read FormData body as blob");
                            else return Promise.resolve(new Blob([
                                this._bodyText
                            ]));
                        };
                        this.arrayBuffer = function() {
                            if (this._bodyArrayBuffer) return consumed(this) || Promise.resolve(this._bodyArrayBuffer);
                            else return this.blob().then(readBlobAsArrayBuffer);
                        };
                    }
                    this.text = function() {
                        var rejected = consumed(this);
                        if (rejected) return rejected;
                        if (this._bodyBlob) return readBlobAsText(this._bodyBlob);
                        else if (this._bodyArrayBuffer) return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer));
                        else if (this._bodyFormData) throw new Error("could not read FormData body as text");
                        else return Promise.resolve(this._bodyText);
                    };
                    if (support.formData) this.formData = function() {
                        return this.text().then(decode);
                    };
                    this.json = function() {
                        return this.text().then(JSON.parse);
                    };
                    return this;
                }
                // HTTP methods whose capitalization should be normalized
                var methods = [
                    "DELETE",
                    "GET",
                    "HEAD",
                    "OPTIONS",
                    "POST",
                    "PUT"
                ];
                function normalizeMethod(method) {
                    var upcased = method.toUpperCase();
                    return methods.indexOf(upcased) > -1 ? upcased : method;
                }
                function Request(input, options) {
                    options = options || {};
                    var body = options.body;
                    if (input instanceof Request) {
                        if (input.bodyUsed) throw new TypeError("Already read");
                        this.url = input.url;
                        this.credentials = input.credentials;
                        if (!options.headers) this.headers = new Headers(input.headers);
                        this.method = input.method;
                        this.mode = input.mode;
                        if (!body && input._bodyInit != null) {
                            body = input._bodyInit;
                            input.bodyUsed = true;
                        }
                    } else this.url = String(input);
                    this.credentials = options.credentials || this.credentials || "omit";
                    if (options.headers || !this.headers) this.headers = new Headers(options.headers);
                    this.method = normalizeMethod(options.method || this.method || "GET");
                    this.mode = options.mode || this.mode || null;
                    this.referrer = null;
                    if ((this.method === "GET" || this.method === "HEAD") && body) throw new TypeError("Body not allowed for GET or HEAD requests");
                    this._initBody(body);
                }
                Request.prototype.clone = function() {
                    return new Request(this, {
                        body: this._bodyInit
                    });
                };
                function decode(body) {
                    var form = new FormData();
                    body.trim().split("&").forEach(function(bytes) {
                        if (bytes) {
                            var split = bytes.split("=");
                            var name = split.shift().replace(/\+/g, " ");
                            var value = split.join("=").replace(/\+/g, " ");
                            form.append(decodeURIComponent(name), decodeURIComponent(value));
                        }
                    });
                    return form;
                }
                function parseHeaders(rawHeaders) {
                    var headers = new Headers();
                    // Replace instances of \r\n and \n followed by at least one space or horizontal tab with a space
                    // https://tools.ietf.org/html/rfc7230#section-3.2
                    var preProcessedHeaders = rawHeaders.replace(/\r?\n[\t ]+/g, " ");
                    preProcessedHeaders.split(/\r?\n/).forEach(function(line) {
                        var parts = line.split(":");
                        var key = parts.shift().trim();
                        if (key) {
                            var value = parts.join(":").trim();
                            headers.append(key, value);
                        }
                    });
                    return headers;
                }
                Body.call(Request.prototype);
                function Response(bodyInit, options) {
                    if (!options) options = {};
                    this.type = "default";
                    this.status = options.status === undefined ? 200 : options.status;
                    this.ok = this.status >= 200 && this.status < 300;
                    this.statusText = "statusText" in options ? options.statusText : "OK";
                    this.headers = new Headers(options.headers);
                    this.url = options.url || "";
                    this._initBody(bodyInit);
                }
                Body.call(Response.prototype);
                Response.prototype.clone = function() {
                    return new Response(this._bodyInit, {
                        status: this.status,
                        statusText: this.statusText,
                        headers: new Headers(this.headers),
                        url: this.url
                    });
                };
                Response.error = function() {
                    var response = new Response(null, {
                        status: 0,
                        statusText: ""
                    });
                    response.type = "error";
                    return response;
                };
                var redirectStatuses = [
                    301,
                    302,
                    303,
                    307,
                    308
                ];
                Response.redirect = function(url, status) {
                    if (redirectStatuses.indexOf(status) === -1) throw new RangeError("Invalid status code");
                    return new Response(null, {
                        status: status,
                        headers: {
                            location: url
                        }
                    });
                };
                self1.Headers = Headers;
                self1.Request = Request;
                self1.Response = Response;
                self1.fetch = function(input, init) {
                    return new Promise(function(resolve, reject) {
                        var request = new Request(input, init);
                        var xhr = new XMLHttpRequest();
                        xhr.onload = function() {
                            var options = {
                                status: xhr.status,
                                statusText: xhr.statusText,
                                headers: parseHeaders(xhr.getAllResponseHeaders() || "")
                            };
                            options.url = "responseURL" in xhr ? xhr.responseURL : options.headers.get("X-Request-URL");
                            var body = "response" in xhr ? xhr.response : xhr.responseText;
                            resolve(new Response(body, options));
                        };
                        xhr.onerror = function() {
                            reject(new TypeError("Network request failed"));
                        };
                        xhr.ontimeout = function() {
                            reject(new TypeError("Network request failed"));
                        };
                        xhr.open(request.method, request.url, true);
                        if (request.credentials === "include") xhr.withCredentials = true;
                        else if (request.credentials === "omit") xhr.withCredentials = false;
                        if ("responseType" in xhr && support.blob) xhr.responseType = "blob";
                        request.headers.forEach(function(value, name) {
                            xhr.setRequestHeader(name, value);
                        });
                        xhr.send(typeof request._bodyInit === "undefined" ? null : request._bodyInit);
                    });
                };
                self1.fetch.polyfill = true;
            })(typeof self1 !== "undefined" ? self1 : this);
            return {
                fetch: self1.fetch,
                Headers: self1.Headers,
                Request: self1.Request,
                Response: self1.Response
            };
        }();
    }
    if (typeof define === "function" && define.amd) define(function() {
        return fetchPonyfill;
    });
    else module.exports = fetchPonyfill;
})(typeof self !== "undefined" ? self : typeof global !== "undefined" ? global : this);

},{}],"fKdyf":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "makeWebSocketSender", ()=>makeWebSocketSender);
var _tslib = require("tslib");
var _types = require("../types");
function makeWebSocketSender(ws) {
    var contextsById = new Map();
    ws.addEventListener("message", function(message) {
        var response = JSON.parse(message.data);
        if (!(0, _types.isResponse)(response)) return;
        var id = getIdFromResponse(response);
        if (id === undefined) return;
        var context = contextsById.get(id);
        if (!context) return;
        var resolve = context.resolve;
        contextsById.delete(id);
        if (!Array.isArray(response) && response.error && response.error.code === 429) resolve({
            type: "rateLimit"
        });
        else resolve({
            response: response,
            type: "jsonrpc"
        });
    });
    ws.addEventListener("down", function() {
        (0, _tslib.__spreadArray)([], (0, _tslib.__read)(contextsById)).forEach(function(_a) {
            var _b = (0, _tslib.__read)(_a, 2), id = _b[0], _c = _b[1], request = _c.request, resolve = _c.resolve;
            if (isWrite(request)) {
                // Writes cannot be resent because they will fail for a duplicate nonce.
                contextsById.delete(id);
                resolve({
                    type: "networkError",
                    status: 0,
                    message: "WebSocket closed before receiving a response for write request with id: " + id + "."
                });
            }
        });
    });
    ws.addEventListener("reopen", function() {
        var e_1, _a;
        try {
            for(var _b = (0, _tslib.__values)(contextsById.values()), _c = _b.next(); !_c.done; _c = _b.next()){
                var request = _c.value.request;
                ws.send(JSON.stringify(request));
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
    });
    return function(request) {
        return new Promise(function(resolve) {
            var id = getIdFromRequest(request);
            if (id !== undefined) {
                var existingContext = contextsById.get(id);
                if (existingContext) {
                    var message = "Another WebSocket request was made with the same id (" + id + ") before a response was received.";
                    console.error(message);
                    existingContext.resolve({
                        message: message,
                        type: "networkError",
                        status: 0
                    });
                }
                contextsById.set(id, {
                    request: request,
                    resolve: resolve
                });
            }
            ws.send(JSON.stringify(request));
        });
    };
}
function getIdFromRequest(request) {
    if (!Array.isArray(request)) return request.id;
    return getCanonicalIdFromList(request.map(function(p) {
        return p.id;
    }));
}
function getIdFromResponse(response) {
    if (!Array.isArray(response)) return response.id;
    return getCanonicalIdFromList(response.map(function(p) {
        return p.id;
    }));
}
/**
 * Since the JSON-RPC spec allows responses to be returned in a different order
 * than sent, we need a mechanism for choosing a canonical id from a list that
 * doesn't depend on the order. This chooses the "minimum" id by an arbitrary
 * ordering: the smallest string if possible, otherwise the smallest number,
 * otherwise null.
 */ function getCanonicalIdFromList(ids) {
    var stringIds = ids.filter(function(id) {
        return typeof id === "string";
    });
    if (stringIds.length > 0) return stringIds.reduce(function(bestId, id) {
        return bestId < id ? bestId : id;
    });
    var numberIds = ids.filter(function(id) {
        return typeof id === "number";
    });
    if (numberIds.length > 0) return Math.min.apply(Math, (0, _tslib.__spreadArray)([], (0, _tslib.__read)(numberIds)));
    return ids.indexOf(null) >= 0 ? null : undefined;
}
function isWrite(request) {
    return Array.isArray(request) ? request.every(isSingleWrite) : isSingleWrite(request);
}
var WRITE_METHODS = [
    "eth_sendTransaction",
    "eth_sendRawTransaction"
];
function isSingleWrite(request) {
    return WRITE_METHODS.includes(request.method);
}

},{"tslib":"gBS4y","../types":"9neWU","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9neWU":[function(require,module,exports) {
// The JSON-RPC types in Web3 definitions aren't quite right. Use these instead.
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isResponse", ()=>isResponse);
parcelHelpers.export(exports, "isSubscriptionEvent", ()=>isSubscriptionEvent);
function isResponse(message) {
    return Array.isArray(message) || message.jsonrpc === "2.0" && message.id !== undefined;
}
function isSubscriptionEvent(message) {
    return !isResponse(message);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"1tlbO":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Returns a "provider" which can be passed to the Web3 constructor.
 */ parcelHelpers.export(exports, "makeAlchemyHttpProvider", ()=>makeAlchemyHttpProvider);
var _promises = require("../util/promises");
function makeAlchemyHttpProvider(sendJsonRpcPayload) {
    function send(payload, callback) {
        (0, _promises.callWhenDone)(sendJsonRpcPayload(payload), callback);
    }
    return {
        send: send
    };
}

},{"../util/promises":"03X3y","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"3ia1r":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "makeJsonRpcPayloadSender", ()=>makeJsonRpcPayloadSender);
var _tslib = require("tslib");
var _assertNever = require("assert-never");
var _assertNeverDefault = parcelHelpers.interopDefault(_assertNever);
var _promises = require("../util/promises");
var ALCHEMY_DISALLOWED_METHODS = [
    "eth_accounts",
    "eth_sendTransaction",
    "eth_sign",
    "eth_signTypedData_v3",
    "eth_signTypedData"
];
var ALCHEMY_DISALLOWED_PREFIXES = [
    "personal"
];
function makeJsonRpcPayloadSender(alchemySendJsonRpc, config) {
    // Copy middlewares from config.
    var middlewares = [];
    config.jsonRpcSenderMiddlewares.forEach(function(m) {
        return middlewares.push(m);
    });
    var currentWriteProvider = config.writeProvider;
    middlewares.push(function(payload) {
        var disallowedMethod = getDisallowedMethod(payload);
        if (!disallowedMethod) try {
            return sendJsonRpcWithRetries(payload, alchemySendJsonRpc, config);
        } catch (alchemyError) {
            // Fallback to write provider, but if both fail throw the error from
            // Alchemy.
            if (!currentWriteProvider) throw alchemyError;
            try {
                return sendJsonRpcWithProvider(currentWriteProvider, payload);
            } catch (_a) {
                throw alchemyError;
            }
        }
        else {
            if (!currentWriteProvider) throw new Error('No provider available for method "' + disallowedMethod + '"');
            return sendJsonRpcWithProvider(currentWriteProvider, payload);
        }
    });
    var sendJsonRpcPayload = function(payload) {
        var getNext = function(i) {
            var middleware = middlewares[i];
            return function() {
                return middleware(payload, getNext(i + 1));
            };
        };
        return getNext(0)();
    };
    function setWriteProvider(writeProvider) {
        currentWriteProvider = writeProvider !== null && writeProvider !== void 0 ? writeProvider : null;
    }
    return {
        sendJsonRpcPayload: sendJsonRpcPayload,
        setWriteProvider: setWriteProvider
    };
}
function sendJsonRpcWithProvider(provider, payload) {
    var anyProvider = provider;
    var sendMethod = (anyProvider.sendAsync ? anyProvider.sendAsync : anyProvider.send).bind(anyProvider);
    return (0, _promises.promisify)(function(callback) {
        return sendMethod(payload, callback);
    });
}
function getDisallowedMethod(payload) {
    var payloads = Array.isArray(payload) ? payload : [
        payload
    ];
    // Check if the payload method is a disallowed method or starts with a
    // disallowed prefix.
    var disallowedRequest = payloads.find(function(p) {
        return ALCHEMY_DISALLOWED_METHODS.indexOf(p.method) >= 0 || ALCHEMY_DISALLOWED_PREFIXES.some(function(prefix) {
            return p.method.startsWith(prefix);
        });
    }) || undefined;
    return disallowedRequest && disallowedRequest.method;
}
function sendJsonRpcWithRetries(payload, alchemySendJsonRpc, _a) {
    var maxRetries = _a.maxRetries, retryInterval = _a.retryInterval, retryJitter = _a.retryJitter;
    return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
        var i, result, status_1, message, statusString;
        return (0, _tslib.__generator)(this, function(_b) {
            switch(_b.label){
                case 0:
                    i = 0;
                    _b.label = 1;
                case 1:
                    if (!(i < maxRetries + 1)) return [
                        3 /*break*/ ,
                        5
                    ];
                    return [
                        4 /*yield*/ ,
                        alchemySendJsonRpc(payload)
                    ];
                case 2:
                    result = _b.sent();
                    switch(result.type){
                        case "jsonrpc":
                            return [
                                2 /*return*/ ,
                                result.response
                            ];
                        case "rateLimit":
                            break;
                        case "networkError":
                            status_1 = result.status, message = result.message;
                            statusString = status_1 !== 0 ? "(" + status_1 + ") " : "";
                            throw new Error(statusString + " " + message);
                        default:
                            return [
                                2 /*return*/ ,
                                (0, _assertNeverDefault.default)(result)
                            ];
                    }
                    return [
                        4 /*yield*/ ,
                        (0, _promises.delay)(retryInterval + (retryJitter * Math.random() | 0))
                    ];
                case 3:
                    _b.sent();
                    _b.label = 4;
                case 4:
                    i++;
                    return [
                        3 /*break*/ ,
                        1
                    ];
                case 5:
                    throw new Error("Rate limited for " + (maxRetries + 1) + " consecutive attempts.");
            }
        });
    });
}

},{"tslib":"gBS4y","assert-never":"cC1Be","../util/promises":"03X3y","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"cC1Be":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.assertNever = assertNever;
/**
 * Helper function for exhaustive checks of discriminated unions.
 * https://basarat.gitbooks.io/typescript/docs/types/discriminated-unions.html
 *
 * @example
 *
 *    type A = {type: 'a'};
 *    type B = {type: 'b'};
 *    type Union = A | B;
 *
 *    function doSomething(arg: Union) {
 *      if (arg.type === 'a') {
 *        return something;
 *      }
 *
 *      if (arg.type === 'b') {
 *        return somethingElse;
 *      }
 *
 *      // TS will error if there are other types in the union
 *      // Will throw an Error when called at runtime.
 *      // Use `assertNever(arg, true)` instead to fail silently.
 *      return assertNever(arg);
 *    }
 */ function assertNever(value, errorMessageOrNoThrow) {
    if (typeof errorMessageOrNoThrow === "string") throw new Error(errorMessageOrNoThrow);
    if (typeof errorMessageOrNoThrow === "function") throw new Error(errorMessageOrNoThrow(value));
    if (errorMessageOrNoThrow) return value;
    throw new Error("Unhandled discriminated union member: ".concat(JSON.stringify(value)));
}
exports.default = assertNever;

},{}],"78Gu2":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "makeRestPayloadSender", ()=>makeRestPayloadSender);
var _tslib = require("tslib");
var _fetchPonyfill = require("fetch-ponyfill");
var _fetchPonyfillDefault = parcelHelpers.interopDefault(_fetchPonyfill);
var _urijs = require("urijs");
var _urijsDefault = parcelHelpers.interopDefault(_urijs);
var _promises = require("../util/promises");
function makeRestPayloadSender(_a) {
    var _this = this;
    var url = _a.url, config = _a.config;
    // The rest payload sender only works for alchemy.com http endpoints.
    var error;
    if (/^wss?:\/\//.test(url)) error = "Alchemy rest endpoints are not available via websockets";
    if (!url.includes("alchemy")) error = "Alchemy specific rest endpoints are not available with a non Alchemy provider.";
    if (url.includes("alchemyapi.io") && !url.includes("eth-")) error = "Alchemy specific rest endpoints on L2 networks are not available with our legacy endpoints on alchemyapi.io. Please switch over to alchemy.com";
    // Don't use the native `URL` class for this. It doesn't work in React Native.
    var urlObject = new (0, _urijsDefault.default)(url);
    var origin = urlObject.origin();
    var pathname = urlObject.path();
    var apiKey = pathname.substring(pathname.lastIndexOf("/") + 1);
    var fetch = (0, _fetchPonyfillDefault.default)().fetch;
    // NFT endpoints are prefixed differently, so the path must be constructed separately
    var NFT_ENDPOINTS = [
        "getNFTs",
        "getNFTMetadata"
    ];
    var NFT_PREFIX = "nft/v2/";
    var isNftPath = function(path) {
        return NFT_ENDPOINTS.includes(path);
    };
    var formatNftPath = function(path) {
        return NFT_PREFIX + apiKey + "/" + path;
    };
    var sendRestPayload = function(path, payload) {
        return (0, _tslib.__awaiter)(_this, void 0, void 0, function() {
            var maxRetries, retryInterval, retryJitter, endpoint, i, response, status_1;
            return (0, _tslib.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (error) throw new Error(error);
                        maxRetries = config.maxRetries, retryInterval = config.retryInterval, retryJitter = config.retryJitter;
                        if (!(origin && apiKey)) return [
                            3 /*break*/ ,
                            6
                        ];
                        endpoint = new (0, _urijsDefault.default)(origin).search(payload).path(isNftPath(path) ? formatNftPath(path) : apiKey + path).toString();
                        i = 0;
                        _a.label = 1;
                    case 1:
                        if (!(i < maxRetries + 1)) return [
                            3 /*break*/ ,
                            5
                        ];
                        return [
                            4 /*yield*/ ,
                            fetch(endpoint)
                        ];
                    case 2:
                        response = _a.sent();
                        status_1 = response.status;
                        switch(status_1){
                            case 200:
                                return [
                                    2 /*return*/ ,
                                    response.json()
                                ];
                            case 429:
                                break;
                            default:
                                throw new Error(response.status + ":" + response.statusText);
                        }
                        return [
                            4 /*yield*/ ,
                            (0, _promises.delay)(retryInterval + (retryJitter * Math.random() | 0))
                        ];
                    case 3:
                        _a.sent();
                        _a.label = 4;
                    case 4:
                        i++;
                        return [
                            3 /*break*/ ,
                            1
                        ];
                    case 5:
                        throw new Error("Rate limited for " + (maxRetries + 1) + " consecutive attempts.");
                    case 6:
                        return [
                            2 /*return*/ ,
                            Promise.resolve()
                        ];
                }
            });
        });
    };
    return {
        sendRestPayload: sendRestPayload
    };
}

},{"tslib":"gBS4y","fetch-ponyfill":"fKQLJ","urijs":"cLy1n","../util/promises":"03X3y","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"cLy1n":[function(require,module,exports) {
/*!
 * URI.js - Mutating URLs
 *
 * Version: 1.19.11
 *
 * Author: Rodney Rehm
 * Web: http://medialize.github.io/URI.js/
 *
 * Licensed under
 *   MIT License http://www.opensource.org/licenses/mit-license
 *
 */ (function(root, factory) {
    "use strict";
    // https://github.com/umdjs/umd/blob/master/returnExports.js
    if (0, module.exports) // Node
    module.exports = factory(require("c0c01881d6d80b64"), require("a7a250f099ff4d9b"), require("847a203e5519704d"));
    else if (typeof define === "function" && define.amd) // AMD. Register as an anonymous module.
    define([
        "./punycode",
        "./IPv6",
        "./SecondLevelDomains"
    ], factory);
    else // Browser globals (root is window)
    root.URI = factory(root.punycode, root.IPv6, root.SecondLevelDomains, root);
})(this, function(punycode, IPv6, SLD, root) {
    "use strict";
    /*global location, escape, unescape */ // FIXME: v2.0.0 renamce non-camelCase properties to uppercase
    /*jshint camelcase: false */ // save current URI variable, if any
    var _URI = root && root.URI;
    function URI(url, base) {
        var _urlSupplied = arguments.length >= 1;
        var _baseSupplied = arguments.length >= 2;
        // Allow instantiation without the 'new' keyword
        if (!(this instanceof URI)) {
            if (_urlSupplied) {
                if (_baseSupplied) return new URI(url, base);
                return new URI(url);
            }
            return new URI();
        }
        if (url === undefined) {
            if (_urlSupplied) throw new TypeError("undefined is not a valid argument for URI");
            if (typeof location !== "undefined") url = location.href + "";
            else url = "";
        }
        if (url === null) {
            if (_urlSupplied) throw new TypeError("null is not a valid argument for URI");
        }
        this.href(url);
        // resolve to base according to http://dvcs.w3.org/hg/url/raw-file/tip/Overview.html#constructor
        if (base !== undefined) return this.absoluteTo(base);
        return this;
    }
    function isInteger(value) {
        return /^[0-9]+$/.test(value);
    }
    URI.version = "1.19.11";
    var p = URI.prototype;
    var hasOwn = Object.prototype.hasOwnProperty;
    function escapeRegEx(string) {
        // https://github.com/medialize/URI.js/commit/85ac21783c11f8ccab06106dba9735a31a86924d#commitcomment-821963
        return string.replace(/([.*+?^=!:${}()|[\]\/\\])/g, "\\$1");
    }
    function getType(value) {
        // IE8 doesn't return [Object Undefined] but [Object Object] for undefined value
        if (value === undefined) return "Undefined";
        return String(Object.prototype.toString.call(value)).slice(8, -1);
    }
    function isArray(obj) {
        return getType(obj) === "Array";
    }
    function filterArrayValues(data, value) {
        var lookup = {};
        var i, length;
        if (getType(value) === "RegExp") lookup = null;
        else if (isArray(value)) for(i = 0, length = value.length; i < length; i++)lookup[value[i]] = true;
        else lookup[value] = true;
        for(i = 0, length = data.length; i < length; i++){
            /*jshint laxbreak: true */ var _match = lookup && lookup[data[i]] !== undefined || !lookup && value.test(data[i]);
            /*jshint laxbreak: false */ if (_match) {
                data.splice(i, 1);
                length--;
                i--;
            }
        }
        return data;
    }
    function arrayContains(list, value) {
        var i, length;
        // value may be string, number, array, regexp
        if (isArray(value)) {
            // Note: this can be optimized to O(n) (instead of current O(m * n))
            for(i = 0, length = value.length; i < length; i++){
                if (!arrayContains(list, value[i])) return false;
            }
            return true;
        }
        var _type = getType(value);
        for(i = 0, length = list.length; i < length; i++){
            if (_type === "RegExp") {
                if (typeof list[i] === "string" && list[i].match(value)) return true;
            } else if (list[i] === value) return true;
        }
        return false;
    }
    function arraysEqual(one, two) {
        if (!isArray(one) || !isArray(two)) return false;
        // arrays can't be equal if they have different amount of content
        if (one.length !== two.length) return false;
        one.sort();
        two.sort();
        for(var i = 0, l = one.length; i < l; i++){
            if (one[i] !== two[i]) return false;
        }
        return true;
    }
    function trimSlashes(text) {
        var trim_expression = /^\/+|\/+$/g;
        return text.replace(trim_expression, "");
    }
    URI._parts = function() {
        return {
            protocol: null,
            username: null,
            password: null,
            hostname: null,
            urn: null,
            port: null,
            path: null,
            query: null,
            fragment: null,
            // state
            preventInvalidHostname: URI.preventInvalidHostname,
            duplicateQueryParameters: URI.duplicateQueryParameters,
            escapeQuerySpace: URI.escapeQuerySpace
        };
    };
    // state: throw on invalid hostname
    // see https://github.com/medialize/URI.js/pull/345
    // and https://github.com/medialize/URI.js/issues/354
    URI.preventInvalidHostname = false;
    // state: allow duplicate query parameters (a=1&a=1)
    URI.duplicateQueryParameters = false;
    // state: replaces + with %20 (space in query strings)
    URI.escapeQuerySpace = true;
    // static properties
    URI.protocol_expression = /^[a-z][a-z0-9.+-]*$/i;
    URI.idn_expression = /[^a-z0-9\._-]/i;
    URI.punycode_expression = /(xn--)/i;
    // well, 333.444.555.666 matches, but it sure ain't no IPv4 - do we care?
    URI.ip4_expression = /^\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}$/;
    // credits to Rich Brown
    // source: http://forums.intermapper.com/viewtopic.php?p=1096#1096
    // specification: http://www.ietf.org/rfc/rfc4291.txt
    URI.ip6_expression = /^\s*((([0-9A-Fa-f]{1,4}:){7}([0-9A-Fa-f]{1,4}|:))|(([0-9A-Fa-f]{1,4}:){6}(:[0-9A-Fa-f]{1,4}|((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(([0-9A-Fa-f]{1,4}:){5}(((:[0-9A-Fa-f]{1,4}){1,2})|:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(([0-9A-Fa-f]{1,4}:){4}(((:[0-9A-Fa-f]{1,4}){1,3})|((:[0-9A-Fa-f]{1,4})?:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){3}(((:[0-9A-Fa-f]{1,4}){1,4})|((:[0-9A-Fa-f]{1,4}){0,2}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){2}(((:[0-9A-Fa-f]{1,4}){1,5})|((:[0-9A-Fa-f]{1,4}){0,3}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){1}(((:[0-9A-Fa-f]{1,4}){1,6})|((:[0-9A-Fa-f]{1,4}){0,4}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(:(((:[0-9A-Fa-f]{1,4}){1,7})|((:[0-9A-Fa-f]{1,4}){0,5}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:)))(%.+)?\s*$/;
    // expression used is "gruber revised" (@gruber v2) determined to be the
    // best solution in a regex-golf we did a couple of ages ago at
    // * http://mathiasbynens.be/demo/url-regex
    // * http://rodneyrehm.de/t/url-regex.html
    URI.find_uri_expression = /\b((?:[a-z][\w-]+:(?:\/{1,3}|[a-z0-9%])|www\d{0,3}[.]|[a-z0-9.\-]+[.][a-z]{2,4}\/)(?:[^\s()<>]+|\(([^\s()<>]+|(\([^\s()<>]+\)))*\))+(?:\(([^\s()<>]+|(\([^\s()<>]+\)))*\)|[^\s`!()\[\]{};:'".,<>?«»“”‘’]))/ig;
    URI.findUri = {
        // valid "scheme://" or "www."
        start: /\b(?:([a-z][a-z0-9.+-]*:\/\/)|www\.)/gi,
        // everything up to the next whitespace
        end: /[\s\r\n]|$/,
        // trim trailing punctuation captured by end RegExp
        trim: /[`!()\[\]{};:'".,<>?«»“”„‘’]+$/,
        // balanced parens inclusion (), [], {}, <>
        parens: /(\([^\)]*\)|\[[^\]]*\]|\{[^}]*\}|<[^>]*>)/g
    };
    URI.leading_whitespace_expression = /^[\x00-\x20\u00a0\u1680\u2000-\u200a\u2028\u2029\u202f\u205f\u3000\ufeff]+/;
    // https://infra.spec.whatwg.org/#ascii-tab-or-newline
    URI.ascii_tab_whitespace = /[\u0009\u000A\u000D]+/g;
    // http://www.iana.org/assignments/uri-schemes.html
    // http://en.wikipedia.org/wiki/List_of_TCP_and_UDP_port_numbers#Well-known_ports
    URI.defaultPorts = {
        http: "80",
        https: "443",
        ftp: "21",
        gopher: "70",
        ws: "80",
        wss: "443"
    };
    // list of protocols which always require a hostname
    URI.hostProtocols = [
        "http",
        "https"
    ];
    // allowed hostname characters according to RFC 3986
    // ALPHA DIGIT "-" "." "_" "~" "!" "$" "&" "'" "(" ")" "*" "+" "," ";" "=" %encoded
    // I've never seen a (non-IDN) hostname other than: ALPHA DIGIT . - _
    URI.invalid_hostname_characters = /[^a-zA-Z0-9\.\-:_]/;
    // map DOM Elements to their URI attribute
    URI.domAttributes = {
        "a": "href",
        "blockquote": "cite",
        "link": "href",
        "base": "href",
        "script": "src",
        "form": "action",
        "img": "src",
        "area": "href",
        "iframe": "src",
        "embed": "src",
        "source": "src",
        "track": "src",
        "input": "src",
        "audio": "src",
        "video": "src"
    };
    URI.getDomAttribute = function(node) {
        if (!node || !node.nodeName) return undefined;
        var nodeName = node.nodeName.toLowerCase();
        // <input> should only expose src for type="image"
        if (nodeName === "input" && node.type !== "image") return undefined;
        return URI.domAttributes[nodeName];
    };
    function escapeForDumbFirefox36(value) {
        // https://github.com/medialize/URI.js/issues/91
        return escape(value);
    }
    // encoding / decoding according to RFC3986
    function strictEncodeURIComponent(string) {
        // see https://developer.mozilla.org/en-US/docs/JavaScript/Reference/Global_Objects/encodeURIComponent
        return encodeURIComponent(string).replace(/[!'()*]/g, escapeForDumbFirefox36).replace(/\*/g, "%2A");
    }
    URI.encode = strictEncodeURIComponent;
    URI.decode = decodeURIComponent;
    URI.iso8859 = function() {
        URI.encode = escape;
        URI.decode = unescape;
    };
    URI.unicode = function() {
        URI.encode = strictEncodeURIComponent;
        URI.decode = decodeURIComponent;
    };
    URI.characters = {
        pathname: {
            encode: {
                // RFC3986 2.1: For consistency, URI producers and normalizers should
                // use uppercase hexadecimal digits for all percent-encodings.
                expression: /%(24|26|2B|2C|3B|3D|3A|40)/ig,
                map: {
                    // -._~!'()*
                    "%24": "$",
                    "%26": "&",
                    "%2B": "+",
                    "%2C": ",",
                    "%3B": ";",
                    "%3D": "=",
                    "%3A": ":",
                    "%40": "@"
                }
            },
            decode: {
                expression: /[\/\?#]/g,
                map: {
                    "/": "%2F",
                    "?": "%3F",
                    "#": "%23"
                }
            }
        },
        reserved: {
            encode: {
                // RFC3986 2.1: For consistency, URI producers and normalizers should
                // use uppercase hexadecimal digits for all percent-encodings.
                expression: /%(21|23|24|26|27|28|29|2A|2B|2C|2F|3A|3B|3D|3F|40|5B|5D)/ig,
                map: {
                    // gen-delims
                    "%3A": ":",
                    "%2F": "/",
                    "%3F": "?",
                    "%23": "#",
                    "%5B": "[",
                    "%5D": "]",
                    "%40": "@",
                    // sub-delims
                    "%21": "!",
                    "%24": "$",
                    "%26": "&",
                    "%27": "'",
                    "%28": "(",
                    "%29": ")",
                    "%2A": "*",
                    "%2B": "+",
                    "%2C": ",",
                    "%3B": ";",
                    "%3D": "="
                }
            }
        },
        urnpath: {
            // The characters under `encode` are the characters called out by RFC 2141 as being acceptable
            // for usage in a URN. RFC2141 also calls out "-", ".", and "_" as acceptable characters, but
            // these aren't encoded by encodeURIComponent, so we don't have to call them out here. Also
            // note that the colon character is not featured in the encoding map; this is because URI.js
            // gives the colons in URNs semantic meaning as the delimiters of path segements, and so it
            // should not appear unencoded in a segment itself.
            // See also the note above about RFC3986 and capitalalized hex digits.
            encode: {
                expression: /%(21|24|27|28|29|2A|2B|2C|3B|3D|40)/ig,
                map: {
                    "%21": "!",
                    "%24": "$",
                    "%27": "'",
                    "%28": "(",
                    "%29": ")",
                    "%2A": "*",
                    "%2B": "+",
                    "%2C": ",",
                    "%3B": ";",
                    "%3D": "=",
                    "%40": "@"
                }
            },
            // These characters are the characters called out by RFC2141 as "reserved" characters that
            // should never appear in a URN, plus the colon character (see note above).
            decode: {
                expression: /[\/\?#:]/g,
                map: {
                    "/": "%2F",
                    "?": "%3F",
                    "#": "%23",
                    ":": "%3A"
                }
            }
        }
    };
    URI.encodeQuery = function(string, escapeQuerySpace) {
        var escaped = URI.encode(string + "");
        if (escapeQuerySpace === undefined) escapeQuerySpace = URI.escapeQuerySpace;
        return escapeQuerySpace ? escaped.replace(/%20/g, "+") : escaped;
    };
    URI.decodeQuery = function(string, escapeQuerySpace) {
        string += "";
        if (escapeQuerySpace === undefined) escapeQuerySpace = URI.escapeQuerySpace;
        try {
            return URI.decode(escapeQuerySpace ? string.replace(/\+/g, "%20") : string);
        } catch (e) {
            // we're not going to mess with weird encodings,
            // give up and return the undecoded original string
            // see https://github.com/medialize/URI.js/issues/87
            // see https://github.com/medialize/URI.js/issues/92
            return string;
        }
    };
    // generate encode/decode path functions
    var _parts = {
        "encode": "encode",
        "decode": "decode"
    };
    var _part;
    var generateAccessor = function(_group, _part) {
        return function(string) {
            try {
                return URI[_part](string + "").replace(URI.characters[_group][_part].expression, function(c) {
                    return URI.characters[_group][_part].map[c];
                });
            } catch (e) {
                // we're not going to mess with weird encodings,
                // give up and return the undecoded original string
                // see https://github.com/medialize/URI.js/issues/87
                // see https://github.com/medialize/URI.js/issues/92
                return string;
            }
        };
    };
    for(_part in _parts){
        URI[_part + "PathSegment"] = generateAccessor("pathname", _parts[_part]);
        URI[_part + "UrnPathSegment"] = generateAccessor("urnpath", _parts[_part]);
    }
    var generateSegmentedPathFunction = function(_sep, _codingFuncName, _innerCodingFuncName) {
        return function(string) {
            // Why pass in names of functions, rather than the function objects themselves? The
            // definitions of some functions (but in particular, URI.decode) will occasionally change due
            // to URI.js having ISO8859 and Unicode modes. Passing in the name and getting it will ensure
            // that the functions we use here are "fresh".
            var actualCodingFunc;
            if (!_innerCodingFuncName) actualCodingFunc = URI[_codingFuncName];
            else actualCodingFunc = function(string) {
                return URI[_codingFuncName](URI[_innerCodingFuncName](string));
            };
            var segments = (string + "").split(_sep);
            for(var i = 0, length = segments.length; i < length; i++)segments[i] = actualCodingFunc(segments[i]);
            return segments.join(_sep);
        };
    };
    // This takes place outside the above loop because we don't want, e.g., encodeUrnPath functions.
    URI.decodePath = generateSegmentedPathFunction("/", "decodePathSegment");
    URI.decodeUrnPath = generateSegmentedPathFunction(":", "decodeUrnPathSegment");
    URI.recodePath = generateSegmentedPathFunction("/", "encodePathSegment", "decode");
    URI.recodeUrnPath = generateSegmentedPathFunction(":", "encodeUrnPathSegment", "decode");
    URI.encodeReserved = generateAccessor("reserved", "encode");
    URI.parse = function(string, parts) {
        var pos;
        if (!parts) parts = {
            preventInvalidHostname: URI.preventInvalidHostname
        };
        string = string.replace(URI.leading_whitespace_expression, "");
        // https://infra.spec.whatwg.org/#ascii-tab-or-newline
        string = string.replace(URI.ascii_tab_whitespace, "");
        // [protocol"://"[username[":"password]"@"]hostname[":"port]"/"?][path]["?"querystring]["#"fragment]
        // extract fragment
        pos = string.indexOf("#");
        if (pos > -1) {
            // escaping?
            parts.fragment = string.substring(pos + 1) || null;
            string = string.substring(0, pos);
        }
        // extract query
        pos = string.indexOf("?");
        if (pos > -1) {
            // escaping?
            parts.query = string.substring(pos + 1) || null;
            string = string.substring(0, pos);
        }
        // slashes and backslashes have lost all meaning for the web protocols (https, http, wss, ws)
        string = string.replace(/^(https?|ftp|wss?)?:+[/\\]*/i, "$1://");
        // slashes and backslashes have lost all meaning for scheme relative URLs
        string = string.replace(/^[/\\]{2,}/i, "//");
        // extract protocol
        if (string.substring(0, 2) === "//") {
            // relative-scheme
            parts.protocol = null;
            string = string.substring(2);
            // extract "user:pass@host:port"
            string = URI.parseAuthority(string, parts);
        } else {
            pos = string.indexOf(":");
            if (pos > -1) {
                parts.protocol = string.substring(0, pos) || null;
                if (parts.protocol && !parts.protocol.match(URI.protocol_expression)) // : may be within the path
                parts.protocol = undefined;
                else if (string.substring(pos + 1, pos + 3).replace(/\\/g, "/") === "//") {
                    string = string.substring(pos + 3);
                    // extract "user:pass@host:port"
                    string = URI.parseAuthority(string, parts);
                } else {
                    string = string.substring(pos + 1);
                    parts.urn = true;
                }
            }
        }
        // what's left must be the path
        parts.path = string;
        // and we're done
        return parts;
    };
    URI.parseHost = function(string, parts) {
        if (!string) string = "";
        // Copy chrome, IE, opera backslash-handling behavior.
        // Back slashes before the query string get converted to forward slashes
        // See: https://github.com/joyent/node/blob/386fd24f49b0e9d1a8a076592a404168faeecc34/lib/url.js#L115-L124
        // See: https://code.google.com/p/chromium/issues/detail?id=25916
        // https://github.com/medialize/URI.js/pull/233
        string = string.replace(/\\/g, "/");
        // extract host:port
        var pos = string.indexOf("/");
        var bracketPos;
        var t;
        if (pos === -1) pos = string.length;
        if (string.charAt(0) === "[") {
            // IPv6 host - http://tools.ietf.org/html/draft-ietf-6man-text-addr-representation-04#section-6
            // I claim most client software breaks on IPv6 anyways. To simplify things, URI only accepts
            // IPv6+port in the format [2001:db8::1]:80 (for the time being)
            bracketPos = string.indexOf("]");
            parts.hostname = string.substring(1, bracketPos) || null;
            parts.port = string.substring(bracketPos + 2, pos) || null;
            if (parts.port === "/") parts.port = null;
        } else {
            var firstColon = string.indexOf(":");
            var firstSlash = string.indexOf("/");
            var nextColon = string.indexOf(":", firstColon + 1);
            if (nextColon !== -1 && (firstSlash === -1 || nextColon < firstSlash)) {
                // IPv6 host contains multiple colons - but no port
                // this notation is actually not allowed by RFC 3986, but we're a liberal parser
                parts.hostname = string.substring(0, pos) || null;
                parts.port = null;
            } else {
                t = string.substring(0, pos).split(":");
                parts.hostname = t[0] || null;
                parts.port = t[1] || null;
            }
        }
        if (parts.hostname && string.substring(pos).charAt(0) !== "/") {
            pos++;
            string = "/" + string;
        }
        if (parts.preventInvalidHostname) URI.ensureValidHostname(parts.hostname, parts.protocol);
        if (parts.port) URI.ensureValidPort(parts.port);
        return string.substring(pos) || "/";
    };
    URI.parseAuthority = function(string, parts) {
        string = URI.parseUserinfo(string, parts);
        return URI.parseHost(string, parts);
    };
    URI.parseUserinfo = function(string, parts) {
        // extract username:password
        var _string = string;
        var firstBackSlash = string.indexOf("\\");
        if (firstBackSlash !== -1) string = string.replace(/\\/g, "/");
        var firstSlash = string.indexOf("/");
        var pos = string.lastIndexOf("@", firstSlash > -1 ? firstSlash : string.length - 1);
        var t;
        // authority@ must come before /path or \path
        if (pos > -1 && (firstSlash === -1 || pos < firstSlash)) {
            t = string.substring(0, pos).split(":");
            parts.username = t[0] ? URI.decode(t[0]) : null;
            t.shift();
            parts.password = t[0] ? URI.decode(t.join(":")) : null;
            string = _string.substring(pos + 1);
        } else {
            parts.username = null;
            parts.password = null;
        }
        return string;
    };
    URI.parseQuery = function(string, escapeQuerySpace) {
        if (!string) return {};
        // throw out the funky business - "?"[name"="value"&"]+
        string = string.replace(/&+/g, "&").replace(/^\?*&*|&+$/g, "");
        if (!string) return {};
        var items = {};
        var splits = string.split("&");
        var length = splits.length;
        var v, name, value;
        for(var i = 0; i < length; i++){
            v = splits[i].split("=");
            name = URI.decodeQuery(v.shift(), escapeQuerySpace);
            // no "=" is null according to http://dvcs.w3.org/hg/url/raw-file/tip/Overview.html#collect-url-parameters
            value = v.length ? URI.decodeQuery(v.join("="), escapeQuerySpace) : null;
            if (name === "__proto__") continue;
            else if (hasOwn.call(items, name)) {
                if (typeof items[name] === "string" || items[name] === null) items[name] = [
                    items[name]
                ];
                items[name].push(value);
            } else items[name] = value;
        }
        return items;
    };
    URI.build = function(parts) {
        var t = "";
        var requireAbsolutePath = false;
        if (parts.protocol) t += parts.protocol + ":";
        if (!parts.urn && (t || parts.hostname)) {
            t += "//";
            requireAbsolutePath = true;
        }
        t += URI.buildAuthority(parts) || "";
        if (typeof parts.path === "string") {
            if (parts.path.charAt(0) !== "/" && requireAbsolutePath) t += "/";
            t += parts.path;
        }
        if (typeof parts.query === "string" && parts.query) t += "?" + parts.query;
        if (typeof parts.fragment === "string" && parts.fragment) t += "#" + parts.fragment;
        return t;
    };
    URI.buildHost = function(parts) {
        var t = "";
        if (!parts.hostname) return "";
        else if (URI.ip6_expression.test(parts.hostname)) t += "[" + parts.hostname + "]";
        else t += parts.hostname;
        if (parts.port) t += ":" + parts.port;
        return t;
    };
    URI.buildAuthority = function(parts) {
        return URI.buildUserinfo(parts) + URI.buildHost(parts);
    };
    URI.buildUserinfo = function(parts) {
        var t = "";
        if (parts.username) t += URI.encode(parts.username);
        if (parts.password) t += ":" + URI.encode(parts.password);
        if (t) t += "@";
        return t;
    };
    URI.buildQuery = function(data, duplicateQueryParameters, escapeQuerySpace) {
        // according to http://tools.ietf.org/html/rfc3986 or http://labs.apache.org/webarch/uri/rfc/rfc3986.html
        // being »-._~!$&'()*+,;=:@/?« %HEX and alnum are allowed
        // the RFC explicitly states ?/foo being a valid use case, no mention of parameter syntax!
        // URI.js treats the query string as being application/x-www-form-urlencoded
        // see http://www.w3.org/TR/REC-html40/interact/forms.html#form-content-type
        var t = "";
        var unique, key, i, length;
        for(key in data){
            if (key === "__proto__") continue;
            else if (hasOwn.call(data, key)) {
                if (isArray(data[key])) {
                    unique = {};
                    for(i = 0, length = data[key].length; i < length; i++)if (data[key][i] !== undefined && unique[data[key][i] + ""] === undefined) {
                        t += "&" + URI.buildQueryParameter(key, data[key][i], escapeQuerySpace);
                        if (duplicateQueryParameters !== true) unique[data[key][i] + ""] = true;
                    }
                } else if (data[key] !== undefined) t += "&" + URI.buildQueryParameter(key, data[key], escapeQuerySpace);
            }
        }
        return t.substring(1);
    };
    URI.buildQueryParameter = function(name, value, escapeQuerySpace) {
        // http://www.w3.org/TR/REC-html40/interact/forms.html#form-content-type -- application/x-www-form-urlencoded
        // don't append "=" for null values, according to http://dvcs.w3.org/hg/url/raw-file/tip/Overview.html#url-parameter-serialization
        return URI.encodeQuery(name, escapeQuerySpace) + (value !== null ? "=" + URI.encodeQuery(value, escapeQuerySpace) : "");
    };
    URI.addQuery = function(data, name, value) {
        if (typeof name === "object") {
            for(var key in name)if (hasOwn.call(name, key)) URI.addQuery(data, key, name[key]);
        } else if (typeof name === "string") {
            if (data[name] === undefined) {
                data[name] = value;
                return;
            } else if (typeof data[name] === "string") data[name] = [
                data[name]
            ];
            if (!isArray(value)) value = [
                value
            ];
            data[name] = (data[name] || []).concat(value);
        } else throw new TypeError("URI.addQuery() accepts an object, string as the name parameter");
    };
    URI.setQuery = function(data, name, value) {
        if (typeof name === "object") {
            for(var key in name)if (hasOwn.call(name, key)) URI.setQuery(data, key, name[key]);
        } else if (typeof name === "string") data[name] = value === undefined ? null : value;
        else throw new TypeError("URI.setQuery() accepts an object, string as the name parameter");
    };
    URI.removeQuery = function(data, name, value) {
        var i, length, key;
        if (isArray(name)) for(i = 0, length = name.length; i < length; i++)data[name[i]] = undefined;
        else if (getType(name) === "RegExp") {
            for(key in data)if (name.test(key)) data[key] = undefined;
        } else if (typeof name === "object") {
            for(key in name)if (hasOwn.call(name, key)) URI.removeQuery(data, key, name[key]);
        } else if (typeof name === "string") {
            if (value !== undefined) {
                if (getType(value) === "RegExp") {
                    if (!isArray(data[name]) && value.test(data[name])) data[name] = undefined;
                    else data[name] = filterArrayValues(data[name], value);
                } else if (data[name] === String(value) && (!isArray(value) || value.length === 1)) data[name] = undefined;
                else if (isArray(data[name])) data[name] = filterArrayValues(data[name], value);
            } else data[name] = undefined;
        } else throw new TypeError("URI.removeQuery() accepts an object, string, RegExp as the first parameter");
    };
    URI.hasQuery = function(data, name, value, withinArray) {
        switch(getType(name)){
            case "String":
                break;
            case "RegExp":
                for(var key in data)if (hasOwn.call(data, key)) {
                    if (name.test(key) && (value === undefined || URI.hasQuery(data, key, value))) return true;
                }
                return false;
            case "Object":
                for(var _key in name)if (hasOwn.call(name, _key)) {
                    if (!URI.hasQuery(data, _key, name[_key])) return false;
                }
                return true;
            default:
                throw new TypeError("URI.hasQuery() accepts a string, regular expression or object as the name parameter");
        }
        switch(getType(value)){
            case "Undefined":
                // true if exists (but may be empty)
                return name in data; // data[name] !== undefined;
            case "Boolean":
                // true if exists and non-empty
                var _booly = Boolean(isArray(data[name]) ? data[name].length : data[name]);
                return value === _booly;
            case "Function":
                // allow complex comparison
                return !!value(data[name], name, data);
            case "Array":
                if (!isArray(data[name])) return false;
                var op = withinArray ? arrayContains : arraysEqual;
                return op(data[name], value);
            case "RegExp":
                if (!isArray(data[name])) return Boolean(data[name] && data[name].match(value));
                if (!withinArray) return false;
                return arrayContains(data[name], value);
            case "Number":
                value = String(value);
            /* falls through */ case "String":
                if (!isArray(data[name])) return data[name] === value;
                if (!withinArray) return false;
                return arrayContains(data[name], value);
            default:
                throw new TypeError("URI.hasQuery() accepts undefined, boolean, string, number, RegExp, Function as the value parameter");
        }
    };
    URI.joinPaths = function() {
        var input = [];
        var segments = [];
        var nonEmptySegments = 0;
        for(var i = 0; i < arguments.length; i++){
            var url = new URI(arguments[i]);
            input.push(url);
            var _segments = url.segment();
            for(var s = 0; s < _segments.length; s++){
                if (typeof _segments[s] === "string") segments.push(_segments[s]);
                if (_segments[s]) nonEmptySegments++;
            }
        }
        if (!segments.length || !nonEmptySegments) return new URI("");
        var uri = new URI("").segment(segments);
        if (input[0].path() === "" || input[0].path().slice(0, 1) === "/") uri.path("/" + uri.path());
        return uri.normalize();
    };
    URI.commonPath = function(one, two) {
        var length = Math.min(one.length, two.length);
        var pos;
        // find first non-matching character
        for(pos = 0; pos < length; pos++)if (one.charAt(pos) !== two.charAt(pos)) {
            pos--;
            break;
        }
        if (pos < 1) return one.charAt(0) === two.charAt(0) && one.charAt(0) === "/" ? "/" : "";
        // revert to last /
        if (one.charAt(pos) !== "/" || two.charAt(pos) !== "/") pos = one.substring(0, pos).lastIndexOf("/");
        return one.substring(0, pos + 1);
    };
    URI.withinString = function(string, callback, options) {
        options || (options = {});
        var _start = options.start || URI.findUri.start;
        var _end = options.end || URI.findUri.end;
        var _trim = options.trim || URI.findUri.trim;
        var _parens = options.parens || URI.findUri.parens;
        var _attributeOpen = /[a-z0-9-]=["']?$/i;
        _start.lastIndex = 0;
        while(true){
            var match = _start.exec(string);
            if (!match) break;
            var start = match.index;
            if (options.ignoreHtml) {
                // attribut(e=["']?$)
                var attributeOpen = string.slice(Math.max(start - 3, 0), start);
                if (attributeOpen && _attributeOpen.test(attributeOpen)) continue;
            }
            var end = start + string.slice(start).search(_end);
            var slice = string.slice(start, end);
            // make sure we include well balanced parens
            var parensEnd = -1;
            while(true){
                var parensMatch = _parens.exec(slice);
                if (!parensMatch) break;
                var parensMatchEnd = parensMatch.index + parensMatch[0].length;
                parensEnd = Math.max(parensEnd, parensMatchEnd);
            }
            if (parensEnd > -1) slice = slice.slice(0, parensEnd) + slice.slice(parensEnd).replace(_trim, "");
            else slice = slice.replace(_trim, "");
            if (slice.length <= match[0].length) continue;
            if (options.ignore && options.ignore.test(slice)) continue;
            end = start + slice.length;
            var result = callback(slice, start, end, string);
            if (result === undefined) {
                _start.lastIndex = end;
                continue;
            }
            result = String(result);
            string = string.slice(0, start) + result + string.slice(end);
            _start.lastIndex = start + result.length;
        }
        _start.lastIndex = 0;
        return string;
    };
    URI.ensureValidHostname = function(v, protocol) {
        // Theoretically URIs allow percent-encoding in Hostnames (according to RFC 3986)
        // they are not part of DNS and therefore ignored by URI.js
        var hasHostname = !!v; // not null and not an empty string
        var hasProtocol = !!protocol;
        var rejectEmptyHostname = false;
        if (hasProtocol) rejectEmptyHostname = arrayContains(URI.hostProtocols, protocol);
        if (rejectEmptyHostname && !hasHostname) throw new TypeError("Hostname cannot be empty, if protocol is " + protocol);
        else if (v && v.match(URI.invalid_hostname_characters)) {
            // test punycode
            if (!punycode) throw new TypeError('Hostname "' + v + '" contains characters other than [A-Z0-9.-:_] and Punycode.js is not available');
            if (punycode.toASCII(v).match(URI.invalid_hostname_characters)) throw new TypeError('Hostname "' + v + '" contains characters other than [A-Z0-9.-:_]');
        }
    };
    URI.ensureValidPort = function(v) {
        if (!v) return;
        var port = Number(v);
        if (isInteger(port) && port > 0 && port < 65536) return;
        throw new TypeError('Port "' + v + '" is not a valid port');
    };
    // noConflict
    URI.noConflict = function(removeAll) {
        if (removeAll) {
            var unconflicted = {
                URI: this.noConflict()
            };
            if (root.URITemplate && typeof root.URITemplate.noConflict === "function") unconflicted.URITemplate = root.URITemplate.noConflict();
            if (root.IPv6 && typeof root.IPv6.noConflict === "function") unconflicted.IPv6 = root.IPv6.noConflict();
            if (root.SecondLevelDomains && typeof root.SecondLevelDomains.noConflict === "function") unconflicted.SecondLevelDomains = root.SecondLevelDomains.noConflict();
            return unconflicted;
        } else if (root.URI === this) root.URI = _URI;
        return this;
    };
    p.build = function(deferBuild) {
        if (deferBuild === true) this._deferred_build = true;
        else if (deferBuild === undefined || this._deferred_build) {
            this._string = URI.build(this._parts);
            this._deferred_build = false;
        }
        return this;
    };
    p.clone = function() {
        return new URI(this);
    };
    p.valueOf = p.toString = function() {
        return this.build(false)._string;
    };
    function generateSimpleAccessor(_part) {
        return function(v, build) {
            if (v === undefined) return this._parts[_part] || "";
            else {
                this._parts[_part] = v || null;
                this.build(!build);
                return this;
            }
        };
    }
    function generatePrefixAccessor(_part, _key) {
        return function(v, build) {
            if (v === undefined) return this._parts[_part] || "";
            else {
                if (v !== null) {
                    v = v + "";
                    if (v.charAt(0) === _key) v = v.substring(1);
                }
                this._parts[_part] = v;
                this.build(!build);
                return this;
            }
        };
    }
    p.protocol = generateSimpleAccessor("protocol");
    p.username = generateSimpleAccessor("username");
    p.password = generateSimpleAccessor("password");
    p.hostname = generateSimpleAccessor("hostname");
    p.port = generateSimpleAccessor("port");
    p.query = generatePrefixAccessor("query", "?");
    p.fragment = generatePrefixAccessor("fragment", "#");
    p.search = function(v, build) {
        var t = this.query(v, build);
        return typeof t === "string" && t.length ? "?" + t : t;
    };
    p.hash = function(v, build) {
        var t = this.fragment(v, build);
        return typeof t === "string" && t.length ? "#" + t : t;
    };
    p.pathname = function(v, build) {
        if (v === undefined || v === true) {
            var res = this._parts.path || (this._parts.hostname ? "/" : "");
            return v ? (this._parts.urn ? URI.decodeUrnPath : URI.decodePath)(res) : res;
        } else {
            if (this._parts.urn) this._parts.path = v ? URI.recodeUrnPath(v) : "";
            else this._parts.path = v ? URI.recodePath(v) : "/";
            this.build(!build);
            return this;
        }
    };
    p.path = p.pathname;
    p.href = function(href, build) {
        var key;
        if (href === undefined) return this.toString();
        this._string = "";
        this._parts = URI._parts();
        var _URI = href instanceof URI;
        var _object = typeof href === "object" && (href.hostname || href.path || href.pathname);
        if (href.nodeName) {
            var attribute = URI.getDomAttribute(href);
            href = href[attribute] || "";
            _object = false;
        }
        // window.location is reported to be an object, but it's not the sort
        // of object we're looking for:
        // * location.protocol ends with a colon
        // * location.query != object.search
        // * location.hash != object.fragment
        // simply serializing the unknown object should do the trick
        // (for location, not for everything...)
        if (!_URI && _object && href.pathname !== undefined) href = href.toString();
        if (typeof href === "string" || href instanceof String) this._parts = URI.parse(String(href), this._parts);
        else if (_URI || _object) {
            var src = _URI ? href._parts : href;
            for(key in src){
                if (key === "query") continue;
                if (hasOwn.call(this._parts, key)) this._parts[key] = src[key];
            }
            if (src.query) this.query(src.query, false);
        } else throw new TypeError("invalid input");
        this.build(!build);
        return this;
    };
    // identification accessors
    p.is = function(what) {
        var ip = false;
        var ip4 = false;
        var ip6 = false;
        var name = false;
        var sld = false;
        var idn = false;
        var punycode = false;
        var relative = !this._parts.urn;
        if (this._parts.hostname) {
            relative = false;
            ip4 = URI.ip4_expression.test(this._parts.hostname);
            ip6 = URI.ip6_expression.test(this._parts.hostname);
            ip = ip4 || ip6;
            name = !ip;
            sld = name && SLD && SLD.has(this._parts.hostname);
            idn = name && URI.idn_expression.test(this._parts.hostname);
            punycode = name && URI.punycode_expression.test(this._parts.hostname);
        }
        switch(what.toLowerCase()){
            case "relative":
                return relative;
            case "absolute":
                return !relative;
            // hostname identification
            case "domain":
            case "name":
                return name;
            case "sld":
                return sld;
            case "ip":
                return ip;
            case "ip4":
            case "ipv4":
            case "inet4":
                return ip4;
            case "ip6":
            case "ipv6":
            case "inet6":
                return ip6;
            case "idn":
                return idn;
            case "url":
                return !this._parts.urn;
            case "urn":
                return !!this._parts.urn;
            case "punycode":
                return punycode;
        }
        return null;
    };
    // component specific input validation
    var _protocol = p.protocol;
    var _port = p.port;
    var _hostname = p.hostname;
    p.protocol = function(v, build) {
        if (v) {
            // accept trailing ://
            v = v.replace(/:(\/\/)?$/, "");
            if (!v.match(URI.protocol_expression)) throw new TypeError('Protocol "' + v + "\" contains characters other than [A-Z0-9.+-] or doesn't start with [A-Z]");
        }
        return _protocol.call(this, v, build);
    };
    p.scheme = p.protocol;
    p.port = function(v, build) {
        if (this._parts.urn) return v === undefined ? "" : this;
        if (v !== undefined) {
            if (v === 0) v = null;
            if (v) {
                v += "";
                if (v.charAt(0) === ":") v = v.substring(1);
                URI.ensureValidPort(v);
            }
        }
        return _port.call(this, v, build);
    };
    p.hostname = function(v, build) {
        if (this._parts.urn) return v === undefined ? "" : this;
        if (v !== undefined) {
            var x = {
                preventInvalidHostname: this._parts.preventInvalidHostname
            };
            var res = URI.parseHost(v, x);
            if (res !== "/") throw new TypeError('Hostname "' + v + '" contains characters other than [A-Z0-9.-]');
            v = x.hostname;
            if (this._parts.preventInvalidHostname) URI.ensureValidHostname(v, this._parts.protocol);
        }
        return _hostname.call(this, v, build);
    };
    // compound accessors
    p.origin = function(v, build) {
        if (this._parts.urn) return v === undefined ? "" : this;
        if (v === undefined) {
            var protocol = this.protocol();
            var authority = this.authority();
            if (!authority) return "";
            return (protocol ? protocol + "://" : "") + this.authority();
        } else {
            var origin = URI(v);
            this.protocol(origin.protocol()).authority(origin.authority()).build(!build);
            return this;
        }
    };
    p.host = function(v, build) {
        if (this._parts.urn) return v === undefined ? "" : this;
        if (v === undefined) return this._parts.hostname ? URI.buildHost(this._parts) : "";
        else {
            var res = URI.parseHost(v, this._parts);
            if (res !== "/") throw new TypeError('Hostname "' + v + '" contains characters other than [A-Z0-9.-]');
            this.build(!build);
            return this;
        }
    };
    p.authority = function(v, build) {
        if (this._parts.urn) return v === undefined ? "" : this;
        if (v === undefined) return this._parts.hostname ? URI.buildAuthority(this._parts) : "";
        else {
            var res = URI.parseAuthority(v, this._parts);
            if (res !== "/") throw new TypeError('Hostname "' + v + '" contains characters other than [A-Z0-9.-]');
            this.build(!build);
            return this;
        }
    };
    p.userinfo = function(v, build) {
        if (this._parts.urn) return v === undefined ? "" : this;
        if (v === undefined) {
            var t = URI.buildUserinfo(this._parts);
            return t ? t.substring(0, t.length - 1) : t;
        } else {
            if (v[v.length - 1] !== "@") v += "@";
            URI.parseUserinfo(v, this._parts);
            this.build(!build);
            return this;
        }
    };
    p.resource = function(v, build) {
        var parts;
        if (v === undefined) return this.path() + this.search() + this.hash();
        parts = URI.parse(v);
        this._parts.path = parts.path;
        this._parts.query = parts.query;
        this._parts.fragment = parts.fragment;
        this.build(!build);
        return this;
    };
    // fraction accessors
    p.subdomain = function(v, build) {
        if (this._parts.urn) return v === undefined ? "" : this;
        // convenience, return "www" from "www.example.org"
        if (v === undefined) {
            if (!this._parts.hostname || this.is("IP")) return "";
            // grab domain and add another segment
            var end = this._parts.hostname.length - this.domain().length - 1;
            return this._parts.hostname.substring(0, end) || "";
        } else {
            var e = this._parts.hostname.length - this.domain().length;
            var sub = this._parts.hostname.substring(0, e);
            var replace = new RegExp("^" + escapeRegEx(sub));
            if (v && v.charAt(v.length - 1) !== ".") v += ".";
            if (v.indexOf(":") !== -1) throw new TypeError("Domains cannot contain colons");
            if (v) URI.ensureValidHostname(v, this._parts.protocol);
            this._parts.hostname = this._parts.hostname.replace(replace, v);
            this.build(!build);
            return this;
        }
    };
    p.domain = function(v, build) {
        if (this._parts.urn) return v === undefined ? "" : this;
        if (typeof v === "boolean") {
            build = v;
            v = undefined;
        }
        // convenience, return "example.org" from "www.example.org"
        if (v === undefined) {
            if (!this._parts.hostname || this.is("IP")) return "";
            // if hostname consists of 1 or 2 segments, it must be the domain
            var t = this._parts.hostname.match(/\./g);
            if (t && t.length < 2) return this._parts.hostname;
            // grab tld and add another segment
            var end = this._parts.hostname.length - this.tld(build).length - 1;
            end = this._parts.hostname.lastIndexOf(".", end - 1) + 1;
            return this._parts.hostname.substring(end) || "";
        } else {
            if (!v) throw new TypeError("cannot set domain empty");
            if (v.indexOf(":") !== -1) throw new TypeError("Domains cannot contain colons");
            URI.ensureValidHostname(v, this._parts.protocol);
            if (!this._parts.hostname || this.is("IP")) this._parts.hostname = v;
            else {
                var replace = new RegExp(escapeRegEx(this.domain()) + "$");
                this._parts.hostname = this._parts.hostname.replace(replace, v);
            }
            this.build(!build);
            return this;
        }
    };
    p.tld = function(v, build) {
        if (this._parts.urn) return v === undefined ? "" : this;
        if (typeof v === "boolean") {
            build = v;
            v = undefined;
        }
        // return "org" from "www.example.org"
        if (v === undefined) {
            if (!this._parts.hostname || this.is("IP")) return "";
            var pos = this._parts.hostname.lastIndexOf(".");
            var tld = this._parts.hostname.substring(pos + 1);
            if (build !== true && SLD && SLD.list[tld.toLowerCase()]) return SLD.get(this._parts.hostname) || tld;
            return tld;
        } else {
            var replace;
            if (!v) throw new TypeError("cannot set TLD empty");
            else if (v.match(/[^a-zA-Z0-9-]/)) {
                if (SLD && SLD.is(v)) {
                    replace = new RegExp(escapeRegEx(this.tld()) + "$");
                    this._parts.hostname = this._parts.hostname.replace(replace, v);
                } else throw new TypeError('TLD "' + v + '" contains characters other than [A-Z0-9]');
            } else if (!this._parts.hostname || this.is("IP")) throw new ReferenceError("cannot set TLD on non-domain host");
            else {
                replace = new RegExp(escapeRegEx(this.tld()) + "$");
                this._parts.hostname = this._parts.hostname.replace(replace, v);
            }
            this.build(!build);
            return this;
        }
    };
    p.directory = function(v, build) {
        if (this._parts.urn) return v === undefined ? "" : this;
        if (v === undefined || v === true) {
            if (!this._parts.path && !this._parts.hostname) return "";
            if (this._parts.path === "/") return "/";
            var end = this._parts.path.length - this.filename().length - 1;
            var res = this._parts.path.substring(0, end) || (this._parts.hostname ? "/" : "");
            return v ? URI.decodePath(res) : res;
        } else {
            var e = this._parts.path.length - this.filename().length;
            var directory = this._parts.path.substring(0, e);
            var replace = new RegExp("^" + escapeRegEx(directory));
            // fully qualifier directories begin with a slash
            if (!this.is("relative")) {
                if (!v) v = "/";
                if (v.charAt(0) !== "/") v = "/" + v;
            }
            // directories always end with a slash
            if (v && v.charAt(v.length - 1) !== "/") v += "/";
            v = URI.recodePath(v);
            this._parts.path = this._parts.path.replace(replace, v);
            this.build(!build);
            return this;
        }
    };
    p.filename = function(v, build) {
        if (this._parts.urn) return v === undefined ? "" : this;
        if (typeof v !== "string") {
            if (!this._parts.path || this._parts.path === "/") return "";
            var pos = this._parts.path.lastIndexOf("/");
            var res = this._parts.path.substring(pos + 1);
            return v ? URI.decodePathSegment(res) : res;
        } else {
            var mutatedDirectory = false;
            if (v.charAt(0) === "/") v = v.substring(1);
            if (v.match(/\.?\//)) mutatedDirectory = true;
            var replace = new RegExp(escapeRegEx(this.filename()) + "$");
            v = URI.recodePath(v);
            this._parts.path = this._parts.path.replace(replace, v);
            if (mutatedDirectory) this.normalizePath(build);
            else this.build(!build);
            return this;
        }
    };
    p.suffix = function(v, build) {
        if (this._parts.urn) return v === undefined ? "" : this;
        if (v === undefined || v === true) {
            if (!this._parts.path || this._parts.path === "/") return "";
            var filename = this.filename();
            var pos = filename.lastIndexOf(".");
            var s, res;
            if (pos === -1) return "";
            // suffix may only contain alnum characters (yup, I made this up.)
            s = filename.substring(pos + 1);
            res = /^[a-z0-9%]+$/i.test(s) ? s : "";
            return v ? URI.decodePathSegment(res) : res;
        } else {
            if (v.charAt(0) === ".") v = v.substring(1);
            var suffix = this.suffix();
            var replace;
            if (!suffix) {
                if (!v) return this;
                this._parts.path += "." + URI.recodePath(v);
            } else if (!v) replace = new RegExp(escapeRegEx("." + suffix) + "$");
            else replace = new RegExp(escapeRegEx(suffix) + "$");
            if (replace) {
                v = URI.recodePath(v);
                this._parts.path = this._parts.path.replace(replace, v);
            }
            this.build(!build);
            return this;
        }
    };
    p.segment = function(segment, v, build) {
        var separator = this._parts.urn ? ":" : "/";
        var path = this.path();
        var absolute = path.substring(0, 1) === "/";
        var segments = path.split(separator);
        if (segment !== undefined && typeof segment !== "number") {
            build = v;
            v = segment;
            segment = undefined;
        }
        if (segment !== undefined && typeof segment !== "number") throw new Error('Bad segment "' + segment + '", must be 0-based integer');
        if (absolute) segments.shift();
        if (segment < 0) // allow negative indexes to address from the end
        segment = Math.max(segments.length + segment, 0);
        if (v === undefined) /*jshint laxbreak: true */ return segment === undefined ? segments : segments[segment];
        else if (segment === null || segments[segment] === undefined) {
            if (isArray(v)) {
                segments = [];
                // collapse empty elements within array
                for(var i = 0, l = v.length; i < l; i++){
                    if (!v[i].length && (!segments.length || !segments[segments.length - 1].length)) continue;
                    if (segments.length && !segments[segments.length - 1].length) segments.pop();
                    segments.push(trimSlashes(v[i]));
                }
            } else if (v || typeof v === "string") {
                v = trimSlashes(v);
                if (segments[segments.length - 1] === "") // empty trailing elements have to be overwritten
                // to prevent results such as /foo//bar
                segments[segments.length - 1] = v;
                else segments.push(v);
            }
        } else if (v) segments[segment] = trimSlashes(v);
        else segments.splice(segment, 1);
        if (absolute) segments.unshift("");
        return this.path(segments.join(separator), build);
    };
    p.segmentCoded = function(segment, v, build) {
        var segments, i, l;
        if (typeof segment !== "number") {
            build = v;
            v = segment;
            segment = undefined;
        }
        if (v === undefined) {
            segments = this.segment(segment, v, build);
            if (!isArray(segments)) segments = segments !== undefined ? URI.decode(segments) : undefined;
            else for(i = 0, l = segments.length; i < l; i++)segments[i] = URI.decode(segments[i]);
            return segments;
        }
        if (!isArray(v)) v = typeof v === "string" || v instanceof String ? URI.encode(v) : v;
        else for(i = 0, l = v.length; i < l; i++)v[i] = URI.encode(v[i]);
        return this.segment(segment, v, build);
    };
    // mutating query string
    var q = p.query;
    p.query = function(v, build) {
        if (v === true) return URI.parseQuery(this._parts.query, this._parts.escapeQuerySpace);
        else if (typeof v === "function") {
            var data = URI.parseQuery(this._parts.query, this._parts.escapeQuerySpace);
            var result = v.call(this, data);
            this._parts.query = URI.buildQuery(result || data, this._parts.duplicateQueryParameters, this._parts.escapeQuerySpace);
            this.build(!build);
            return this;
        } else if (v !== undefined && typeof v !== "string") {
            this._parts.query = URI.buildQuery(v, this._parts.duplicateQueryParameters, this._parts.escapeQuerySpace);
            this.build(!build);
            return this;
        } else return q.call(this, v, build);
    };
    p.setQuery = function(name, value, build) {
        var data = URI.parseQuery(this._parts.query, this._parts.escapeQuerySpace);
        if (typeof name === "string" || name instanceof String) data[name] = value !== undefined ? value : null;
        else if (typeof name === "object") {
            for(var key in name)if (hasOwn.call(name, key)) data[key] = name[key];
        } else throw new TypeError("URI.addQuery() accepts an object, string as the name parameter");
        this._parts.query = URI.buildQuery(data, this._parts.duplicateQueryParameters, this._parts.escapeQuerySpace);
        if (typeof name !== "string") build = value;
        this.build(!build);
        return this;
    };
    p.addQuery = function(name, value, build) {
        var data = URI.parseQuery(this._parts.query, this._parts.escapeQuerySpace);
        URI.addQuery(data, name, value === undefined ? null : value);
        this._parts.query = URI.buildQuery(data, this._parts.duplicateQueryParameters, this._parts.escapeQuerySpace);
        if (typeof name !== "string") build = value;
        this.build(!build);
        return this;
    };
    p.removeQuery = function(name, value, build) {
        var data = URI.parseQuery(this._parts.query, this._parts.escapeQuerySpace);
        URI.removeQuery(data, name, value);
        this._parts.query = URI.buildQuery(data, this._parts.duplicateQueryParameters, this._parts.escapeQuerySpace);
        if (typeof name !== "string") build = value;
        this.build(!build);
        return this;
    };
    p.hasQuery = function(name, value, withinArray) {
        var data = URI.parseQuery(this._parts.query, this._parts.escapeQuerySpace);
        return URI.hasQuery(data, name, value, withinArray);
    };
    p.setSearch = p.setQuery;
    p.addSearch = p.addQuery;
    p.removeSearch = p.removeQuery;
    p.hasSearch = p.hasQuery;
    // sanitizing URLs
    p.normalize = function() {
        if (this._parts.urn) return this.normalizeProtocol(false).normalizePath(false).normalizeQuery(false).normalizeFragment(false).build();
        return this.normalizeProtocol(false).normalizeHostname(false).normalizePort(false).normalizePath(false).normalizeQuery(false).normalizeFragment(false).build();
    };
    p.normalizeProtocol = function(build) {
        if (typeof this._parts.protocol === "string") {
            this._parts.protocol = this._parts.protocol.toLowerCase();
            this.build(!build);
        }
        return this;
    };
    p.normalizeHostname = function(build) {
        if (this._parts.hostname) {
            if (this.is("IDN") && punycode) this._parts.hostname = punycode.toASCII(this._parts.hostname);
            else if (this.is("IPv6") && IPv6) this._parts.hostname = IPv6.best(this._parts.hostname);
            this._parts.hostname = this._parts.hostname.toLowerCase();
            this.build(!build);
        }
        return this;
    };
    p.normalizePort = function(build) {
        // remove port of it's the protocol's default
        if (typeof this._parts.protocol === "string" && this._parts.port === URI.defaultPorts[this._parts.protocol]) {
            this._parts.port = null;
            this.build(!build);
        }
        return this;
    };
    p.normalizePath = function(build) {
        var _path = this._parts.path;
        if (!_path) return this;
        if (this._parts.urn) {
            this._parts.path = URI.recodeUrnPath(this._parts.path);
            this.build(!build);
            return this;
        }
        if (this._parts.path === "/") return this;
        _path = URI.recodePath(_path);
        var _was_relative;
        var _leadingParents = "";
        var _parent, _pos;
        // handle relative paths
        if (_path.charAt(0) !== "/") {
            _was_relative = true;
            _path = "/" + _path;
        }
        // handle relative files (as opposed to directories)
        if (_path.slice(-3) === "/.." || _path.slice(-2) === "/.") _path += "/";
        // resolve simples
        _path = _path.replace(/(\/(\.\/)+)|(\/\.$)/g, "/").replace(/\/{2,}/g, "/");
        // remember leading parents
        if (_was_relative) {
            _leadingParents = _path.substring(1).match(/^(\.\.\/)+/) || "";
            if (_leadingParents) _leadingParents = _leadingParents[0];
        }
        // resolve parents
        while(true){
            _parent = _path.search(/\/\.\.(\/|$)/);
            if (_parent === -1) break;
            else if (_parent === 0) {
                // top level cannot be relative, skip it
                _path = _path.substring(3);
                continue;
            }
            _pos = _path.substring(0, _parent).lastIndexOf("/");
            if (_pos === -1) _pos = _parent;
            _path = _path.substring(0, _pos) + _path.substring(_parent + 3);
        }
        // revert to relative
        if (_was_relative && this.is("relative")) _path = _leadingParents + _path.substring(1);
        this._parts.path = _path;
        this.build(!build);
        return this;
    };
    p.normalizePathname = p.normalizePath;
    p.normalizeQuery = function(build) {
        if (typeof this._parts.query === "string") {
            if (!this._parts.query.length) this._parts.query = null;
            else this.query(URI.parseQuery(this._parts.query, this._parts.escapeQuerySpace));
            this.build(!build);
        }
        return this;
    };
    p.normalizeFragment = function(build) {
        if (!this._parts.fragment) {
            this._parts.fragment = null;
            this.build(!build);
        }
        return this;
    };
    p.normalizeSearch = p.normalizeQuery;
    p.normalizeHash = p.normalizeFragment;
    p.iso8859 = function() {
        // expect unicode input, iso8859 output
        var e = URI.encode;
        var d = URI.decode;
        URI.encode = escape;
        URI.decode = decodeURIComponent;
        try {
            this.normalize();
        } finally{
            URI.encode = e;
            URI.decode = d;
        }
        return this;
    };
    p.unicode = function() {
        // expect iso8859 input, unicode output
        var e = URI.encode;
        var d = URI.decode;
        URI.encode = strictEncodeURIComponent;
        URI.decode = unescape;
        try {
            this.normalize();
        } finally{
            URI.encode = e;
            URI.decode = d;
        }
        return this;
    };
    p.readable = function() {
        var uri = this.clone();
        // removing username, password, because they shouldn't be displayed according to RFC 3986
        uri.username("").password("").normalize();
        var t = "";
        if (uri._parts.protocol) t += uri._parts.protocol + "://";
        if (uri._parts.hostname) {
            if (uri.is("punycode") && punycode) {
                t += punycode.toUnicode(uri._parts.hostname);
                if (uri._parts.port) t += ":" + uri._parts.port;
            } else t += uri.host();
        }
        if (uri._parts.hostname && uri._parts.path && uri._parts.path.charAt(0) !== "/") t += "/";
        t += uri.path(true);
        if (uri._parts.query) {
            var q = "";
            for(var i = 0, qp = uri._parts.query.split("&"), l = qp.length; i < l; i++){
                var kv = (qp[i] || "").split("=");
                q += "&" + URI.decodeQuery(kv[0], this._parts.escapeQuerySpace).replace(/&/g, "%26");
                if (kv[1] !== undefined) q += "=" + URI.decodeQuery(kv[1], this._parts.escapeQuerySpace).replace(/&/g, "%26");
            }
            t += "?" + q.substring(1);
        }
        t += URI.decodeQuery(uri.hash(), true);
        return t;
    };
    // resolving relative and absolute URLs
    p.absoluteTo = function(base) {
        var resolved = this.clone();
        var properties = [
            "protocol",
            "username",
            "password",
            "hostname",
            "port"
        ];
        var basedir, i, p;
        if (this._parts.urn) throw new Error("URNs do not have any generally defined hierarchical components");
        if (!(base instanceof URI)) base = new URI(base);
        if (resolved._parts.protocol) // Directly returns even if this._parts.hostname is empty.
        return resolved;
        else resolved._parts.protocol = base._parts.protocol;
        if (this._parts.hostname) return resolved;
        for(i = 0; p = properties[i]; i++)resolved._parts[p] = base._parts[p];
        if (!resolved._parts.path) {
            resolved._parts.path = base._parts.path;
            if (!resolved._parts.query) resolved._parts.query = base._parts.query;
        } else {
            if (resolved._parts.path.substring(-2) === "..") resolved._parts.path += "/";
            if (resolved.path().charAt(0) !== "/") {
                basedir = base.directory();
                basedir = basedir ? basedir : base.path().indexOf("/") === 0 ? "/" : "";
                resolved._parts.path = (basedir ? basedir + "/" : "") + resolved._parts.path;
                resolved.normalizePath();
            }
        }
        resolved.build();
        return resolved;
    };
    p.relativeTo = function(base) {
        var relative = this.clone().normalize();
        var relativeParts, baseParts, common, relativePath, basePath;
        if (relative._parts.urn) throw new Error("URNs do not have any generally defined hierarchical components");
        base = new URI(base).normalize();
        relativeParts = relative._parts;
        baseParts = base._parts;
        relativePath = relative.path();
        basePath = base.path();
        if (relativePath.charAt(0) !== "/") throw new Error("URI is already relative");
        if (basePath.charAt(0) !== "/") throw new Error("Cannot calculate a URI relative to another relative URI");
        if (relativeParts.protocol === baseParts.protocol) relativeParts.protocol = null;
        if (relativeParts.username !== baseParts.username || relativeParts.password !== baseParts.password) return relative.build();
        if (relativeParts.protocol !== null || relativeParts.username !== null || relativeParts.password !== null) return relative.build();
        if (relativeParts.hostname === baseParts.hostname && relativeParts.port === baseParts.port) {
            relativeParts.hostname = null;
            relativeParts.port = null;
        } else return relative.build();
        if (relativePath === basePath) {
            relativeParts.path = "";
            return relative.build();
        }
        // determine common sub path
        common = URI.commonPath(relativePath, basePath);
        // If the paths have nothing in common, return a relative URL with the absolute path.
        if (!common) return relative.build();
        var parents = baseParts.path.substring(common.length).replace(/[^\/]*$/, "").replace(/.*?\//g, "../");
        relativeParts.path = parents + relativeParts.path.substring(common.length) || "./";
        return relative.build();
    };
    // comparing URIs
    p.equals = function(uri) {
        var one = this.clone();
        var two = new URI(uri);
        var one_map = {};
        var two_map = {};
        var checked = {};
        var one_query, two_query, key;
        one.normalize();
        two.normalize();
        // exact match
        if (one.toString() === two.toString()) return true;
        // extract query string
        one_query = one.query();
        two_query = two.query();
        one.query("");
        two.query("");
        // definitely not equal if not even non-query parts match
        if (one.toString() !== two.toString()) return false;
        // query parameters have the same length, even if they're permuted
        if (one_query.length !== two_query.length) return false;
        one_map = URI.parseQuery(one_query, this._parts.escapeQuerySpace);
        two_map = URI.parseQuery(two_query, this._parts.escapeQuerySpace);
        for(key in one_map)if (hasOwn.call(one_map, key)) {
            if (!isArray(one_map[key])) {
                if (one_map[key] !== two_map[key]) return false;
            } else if (!arraysEqual(one_map[key], two_map[key])) return false;
            checked[key] = true;
        }
        for(key in two_map)if (hasOwn.call(two_map, key)) {
            if (!checked[key]) // two contains a parameter not present in one
            return false;
        }
        return true;
    };
    // state
    p.preventInvalidHostname = function(v) {
        this._parts.preventInvalidHostname = !!v;
        return this;
    };
    p.duplicateQueryParameters = function(v) {
        this._parts.duplicateQueryParameters = !!v;
        return this;
    };
    p.escapeQuerySpace = function(v) {
        this._parts.escapeQuerySpace = !!v;
        return this;
    };
    return URI;
});

},{"c0c01881d6d80b64":"6FYmq","a7a250f099ff4d9b":"029VJ","847a203e5519704d":"dIMve"}],"6FYmq":[function(require,module,exports) {
var global = arguments[3];
(function(root) {
    /** Detect free variables */ var freeExports = exports && !exports.nodeType && exports;
    var freeModule = module && !module.nodeType && module;
    var freeGlobal = typeof global == "object" && global;
    if (freeGlobal.global === freeGlobal || freeGlobal.window === freeGlobal || freeGlobal.self === freeGlobal) root = freeGlobal;
    /**
	 * The `punycode` object.
	 * @name punycode
	 * @type Object
	 */ var punycode, /** Highest positive signed 32-bit float value */ maxInt = 2147483647, /** Bootstring parameters */ base = 36, tMin = 1, tMax = 26, skew = 38, damp = 700, initialBias = 72, initialN = 128, delimiter = "-", /** Regular expressions */ regexPunycode = /^xn--/, regexNonASCII = /[^\x20-\x7E]/, regexSeparators = /[\x2E\u3002\uFF0E\uFF61]/g, /** Error messages */ errors = {
        "overflow": "Overflow: input needs wider integers to process",
        "not-basic": "Illegal input >= 0x80 (not a basic code point)",
        "invalid-input": "Invalid input"
    }, /** Convenience shortcuts */ baseMinusTMin = base - tMin, floor = Math.floor, stringFromCharCode = String.fromCharCode, /** Temporary variable */ key;
    /*--------------------------------------------------------------------------*/ /**
	 * A generic error utility function.
	 * @private
	 * @param {String} type The error type.
	 * @returns {Error} Throws a `RangeError` with the applicable error message.
	 */ function error(type) {
        throw new RangeError(errors[type]);
    }
    /**
	 * A generic `Array#map` utility function.
	 * @private
	 * @param {Array} array The array to iterate over.
	 * @param {Function} callback The function that gets called for every array
	 * item.
	 * @returns {Array} A new array of values returned by the callback function.
	 */ function map(array, fn) {
        var length = array.length;
        var result = [];
        while(length--)result[length] = fn(array[length]);
        return result;
    }
    /**
	 * A simple `Array#map`-like wrapper to work with domain name strings or email
	 * addresses.
	 * @private
	 * @param {String} domain The domain name or email address.
	 * @param {Function} callback The function that gets called for every
	 * character.
	 * @returns {Array} A new string of characters returned by the callback
	 * function.
	 */ function mapDomain(string, fn) {
        var parts = string.split("@");
        var result = "";
        if (parts.length > 1) {
            // In email addresses, only the domain name should be punycoded. Leave
            // the local part (i.e. everything up to `@`) intact.
            result = parts[0] + "@";
            string = parts[1];
        }
        // Avoid `split(regex)` for IE8 compatibility. See #17.
        string = string.replace(regexSeparators, ".");
        var labels = string.split(".");
        var encoded = map(labels, fn).join(".");
        return result + encoded;
    }
    /**
	 * Creates an array containing the numeric code points of each Unicode
	 * character in the string. While JavaScript uses UCS-2 internally,
	 * this function will convert a pair of surrogate halves (each of which
	 * UCS-2 exposes as separate characters) into a single code point,
	 * matching UTF-16.
	 * @see `punycode.ucs2.encode`
	 * @see <https://mathiasbynens.be/notes/javascript-encoding>
	 * @memberOf punycode.ucs2
	 * @name decode
	 * @param {String} string The Unicode input string (UCS-2).
	 * @returns {Array} The new array of code points.
	 */ function ucs2decode(string) {
        var output = [], counter = 0, length = string.length, value, extra;
        while(counter < length){
            value = string.charCodeAt(counter++);
            if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
                // high surrogate, and there is a next character
                extra = string.charCodeAt(counter++);
                if ((extra & 0xFC00) == 0xDC00) output.push(((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
                else {
                    // unmatched surrogate; only append this code unit, in case the next
                    // code unit is the high surrogate of a surrogate pair
                    output.push(value);
                    counter--;
                }
            } else output.push(value);
        }
        return output;
    }
    /**
	 * Creates a string based on an array of numeric code points.
	 * @see `punycode.ucs2.decode`
	 * @memberOf punycode.ucs2
	 * @name encode
	 * @param {Array} codePoints The array of numeric code points.
	 * @returns {String} The new Unicode string (UCS-2).
	 */ function ucs2encode(array) {
        return map(array, function(value) {
            var output = "";
            if (value > 0xFFFF) {
                value -= 0x10000;
                output += stringFromCharCode(value >>> 10 & 0x3FF | 0xD800);
                value = 0xDC00 | value & 0x3FF;
            }
            output += stringFromCharCode(value);
            return output;
        }).join("");
    }
    /**
	 * Converts a basic code point into a digit/integer.
	 * @see `digitToBasic()`
	 * @private
	 * @param {Number} codePoint The basic numeric code point value.
	 * @returns {Number} The numeric value of a basic code point (for use in
	 * representing integers) in the range `0` to `base - 1`, or `base` if
	 * the code point does not represent a value.
	 */ function basicToDigit(codePoint) {
        if (codePoint - 48 < 10) return codePoint - 22;
        if (codePoint - 65 < 26) return codePoint - 65;
        if (codePoint - 97 < 26) return codePoint - 97;
        return base;
    }
    /**
	 * Converts a digit/integer into a basic code point.
	 * @see `basicToDigit()`
	 * @private
	 * @param {Number} digit The numeric value of a basic code point.
	 * @returns {Number} The basic code point whose value (when used for
	 * representing integers) is `digit`, which needs to be in the range
	 * `0` to `base - 1`. If `flag` is non-zero, the uppercase form is
	 * used; else, the lowercase form is used. The behavior is undefined
	 * if `flag` is non-zero and `digit` has no uppercase form.
	 */ function digitToBasic(digit, flag) {
        //  0..25 map to ASCII a..z or A..Z
        // 26..35 map to ASCII 0..9
        return digit + 22 + 75 * (digit < 26) - ((flag != 0) << 5);
    }
    /**
	 * Bias adaptation function as per section 3.4 of RFC 3492.
	 * https://tools.ietf.org/html/rfc3492#section-3.4
	 * @private
	 */ function adapt(delta, numPoints, firstTime) {
        var k = 0;
        delta = firstTime ? floor(delta / damp) : delta >> 1;
        delta += floor(delta / numPoints);
        for(; delta > baseMinusTMin * tMax >> 1; k += base)delta = floor(delta / baseMinusTMin);
        return floor(k + (baseMinusTMin + 1) * delta / (delta + skew));
    }
    /**
	 * Converts a Punycode string of ASCII-only symbols to a string of Unicode
	 * symbols.
	 * @memberOf punycode
	 * @param {String} input The Punycode string of ASCII-only symbols.
	 * @returns {String} The resulting string of Unicode symbols.
	 */ function decode(input) {
        // Don't use UCS-2
        var output = [], inputLength = input.length, out, i = 0, n = initialN, bias = initialBias, basic, j, index, oldi, w, k, digit, t, /** Cached calculation results */ baseMinusT;
        // Handle the basic code points: let `basic` be the number of input code
        // points before the last delimiter, or `0` if there is none, then copy
        // the first basic code points to the output.
        basic = input.lastIndexOf(delimiter);
        if (basic < 0) basic = 0;
        for(j = 0; j < basic; ++j){
            // if it's not a basic code point
            if (input.charCodeAt(j) >= 0x80) error("not-basic");
            output.push(input.charCodeAt(j));
        }
        // Main decoding loop: start just after the last delimiter if any basic code
        // points were copied; start at the beginning otherwise.
        for(index = basic > 0 ? basic + 1 : 0; index < inputLength;){
            // `index` is the index of the next character to be consumed.
            // Decode a generalized variable-length integer into `delta`,
            // which gets added to `i`. The overflow checking is easier
            // if we increase `i` as we go, then subtract off its starting
            // value at the end to obtain `delta`.
            for(oldi = i, w = 1, k = base;; k += base){
                if (index >= inputLength) error("invalid-input");
                digit = basicToDigit(input.charCodeAt(index++));
                if (digit >= base || digit > floor((maxInt - i) / w)) error("overflow");
                i += digit * w;
                t = k <= bias ? tMin : k >= bias + tMax ? tMax : k - bias;
                if (digit < t) break;
                baseMinusT = base - t;
                if (w > floor(maxInt / baseMinusT)) error("overflow");
                w *= baseMinusT;
            }
            out = output.length + 1;
            bias = adapt(i - oldi, out, oldi == 0);
            // `i` was supposed to wrap around from `out` to `0`,
            // incrementing `n` each time, so we'll fix that now:
            if (floor(i / out) > maxInt - n) error("overflow");
            n += floor(i / out);
            i %= out;
            // Insert `n` at position `i` of the output
            output.splice(i++, 0, n);
        }
        return ucs2encode(output);
    }
    /**
	 * Converts a string of Unicode symbols (e.g. a domain name label) to a
	 * Punycode string of ASCII-only symbols.
	 * @memberOf punycode
	 * @param {String} input The string of Unicode symbols.
	 * @returns {String} The resulting Punycode string of ASCII-only symbols.
	 */ function encode(input) {
        var n, delta, handledCPCount, basicLength, bias, j, m, q, k, t, currentValue, output = [], /** `inputLength` will hold the number of code points in `input`. */ inputLength, /** Cached calculation results */ handledCPCountPlusOne, baseMinusT, qMinusT;
        // Convert the input in UCS-2 to Unicode
        input = ucs2decode(input);
        // Cache the length
        inputLength = input.length;
        // Initialize the state
        n = initialN;
        delta = 0;
        bias = initialBias;
        // Handle the basic code points
        for(j = 0; j < inputLength; ++j){
            currentValue = input[j];
            if (currentValue < 0x80) output.push(stringFromCharCode(currentValue));
        }
        handledCPCount = basicLength = output.length;
        // `handledCPCount` is the number of code points that have been handled;
        // `basicLength` is the number of basic code points.
        // Finish the basic string - if it is not empty - with a delimiter
        if (basicLength) output.push(delimiter);
        // Main encoding loop:
        while(handledCPCount < inputLength){
            // All non-basic code points < n have been handled already. Find the next
            // larger one:
            for(m = maxInt, j = 0; j < inputLength; ++j){
                currentValue = input[j];
                if (currentValue >= n && currentValue < m) m = currentValue;
            }
            // Increase `delta` enough to advance the decoder's <n,i> state to <m,0>,
            // but guard against overflow
            handledCPCountPlusOne = handledCPCount + 1;
            if (m - n > floor((maxInt - delta) / handledCPCountPlusOne)) error("overflow");
            delta += (m - n) * handledCPCountPlusOne;
            n = m;
            for(j = 0; j < inputLength; ++j){
                currentValue = input[j];
                if (currentValue < n && ++delta > maxInt) error("overflow");
                if (currentValue == n) {
                    // Represent delta as a generalized variable-length integer
                    for(q = delta, k = base;; k += base){
                        t = k <= bias ? tMin : k >= bias + tMax ? tMax : k - bias;
                        if (q < t) break;
                        qMinusT = q - t;
                        baseMinusT = base - t;
                        output.push(stringFromCharCode(digitToBasic(t + qMinusT % baseMinusT, 0)));
                        q = floor(qMinusT / baseMinusT);
                    }
                    output.push(stringFromCharCode(digitToBasic(q, 0)));
                    bias = adapt(delta, handledCPCountPlusOne, handledCPCount == basicLength);
                    delta = 0;
                    ++handledCPCount;
                }
            }
            ++delta;
            ++n;
        }
        return output.join("");
    }
    /**
	 * Converts a Punycode string representing a domain name or an email address
	 * to Unicode. Only the Punycoded parts of the input will be converted, i.e.
	 * it doesn't matter if you call it on a string that has already been
	 * converted to Unicode.
	 * @memberOf punycode
	 * @param {String} input The Punycoded domain name or email address to
	 * convert to Unicode.
	 * @returns {String} The Unicode representation of the given Punycode
	 * string.
	 */ function toUnicode(input) {
        return mapDomain(input, function(string) {
            return regexPunycode.test(string) ? decode(string.slice(4).toLowerCase()) : string;
        });
    }
    /**
	 * Converts a Unicode string representing a domain name or an email address to
	 * Punycode. Only the non-ASCII parts of the domain name will be converted,
	 * i.e. it doesn't matter if you call it with a domain that's already in
	 * ASCII.
	 * @memberOf punycode
	 * @param {String} input The domain name or email address to convert, as a
	 * Unicode string.
	 * @returns {String} The Punycode representation of the given domain name or
	 * email address.
	 */ function toASCII(input) {
        return mapDomain(input, function(string) {
            return regexNonASCII.test(string) ? "xn--" + encode(string) : string;
        });
    }
    /*--------------------------------------------------------------------------*/ /** Define the public API */ punycode = {
        /**
		 * A string representing the current Punycode.js version number.
		 * @memberOf punycode
		 * @type String
		 */ "version": "1.3.2",
        /**
		 * An object of methods to convert from JavaScript's internal character
		 * representation (UCS-2) to Unicode code points, and back.
		 * @see <https://mathiasbynens.be/notes/javascript-encoding>
		 * @memberOf punycode
		 * @type Object
		 */ "ucs2": {
            "decode": ucs2decode,
            "encode": ucs2encode
        },
        "decode": decode,
        "encode": encode,
        "toASCII": toASCII,
        "toUnicode": toUnicode
    };
    /** Expose `punycode` */ // Some AMD build optimizers, like r.js, check for specific condition patterns
    // like the following:
    if (typeof define == "function" && typeof define.amd == "object" && define.amd) define("punycode", function() {
        return punycode;
    });
    else if (freeExports && freeModule) {
        if (module.exports == freeExports) // in Node.js, io.js, or RingoJS v0.8.0+
        freeModule.exports = punycode;
        else // in Narwhal or RingoJS v0.7.0-
        for(key in punycode)punycode.hasOwnProperty(key) && (freeExports[key] = punycode[key]);
    } else // in Rhino or a web browser
    root.punycode = punycode;
})(this);

},{}],"029VJ":[function(require,module,exports) {
/*!
 * URI.js - Mutating URLs
 * IPv6 Support
 *
 * Version: 1.19.11
 *
 * Author: Rodney Rehm
 * Web: http://medialize.github.io/URI.js/
 *
 * Licensed under
 *   MIT License http://www.opensource.org/licenses/mit-license
 *
 */ (function(root, factory) {
    "use strict";
    // https://github.com/umdjs/umd/blob/master/returnExports.js
    if (0, module.exports) // Node
    module.exports = factory();
    else if (typeof define === "function" && define.amd) // AMD. Register as an anonymous module.
    define(factory);
    else // Browser globals (root is window)
    root.IPv6 = factory(root);
})(this, function(root) {
    "use strict";
    /*
  var _in = "fe80:0000:0000:0000:0204:61ff:fe9d:f156";
  var _out = IPv6.best(_in);
  var _expected = "fe80::204:61ff:fe9d:f156";

  console.log(_in, _out, _expected, _out === _expected);
  */ // save current IPv6 variable, if any
    var _IPv6 = root && root.IPv6;
    function bestPresentation(address) {
        // based on:
        // Javascript to test an IPv6 address for proper format, and to
        // present the "best text representation" according to IETF Draft RFC at
        // http://tools.ietf.org/html/draft-ietf-6man-text-addr-representation-04
        // 8 Feb 2010 Rich Brown, Dartware, LLC
        // Please feel free to use this code as long as you provide a link to
        // http://www.intermapper.com
        // http://intermapper.com/support/tools/IPV6-Validator.aspx
        // http://download.dartware.com/thirdparty/ipv6validator.js
        var _address = address.toLowerCase();
        var segments = _address.split(":");
        var length = segments.length;
        var total = 8;
        // trim colons (:: or ::a:b:c… or …a:b:c::)
        if (segments[0] === "" && segments[1] === "" && segments[2] === "") {
            // must have been ::
            // remove first two items
            segments.shift();
            segments.shift();
        } else if (segments[0] === "" && segments[1] === "") // must have been ::xxxx
        // remove the first item
        segments.shift();
        else if (segments[length - 1] === "" && segments[length - 2] === "") // must have been xxxx::
        segments.pop();
        length = segments.length;
        // adjust total segments for IPv4 trailer
        if (segments[length - 1].indexOf(".") !== -1) // found a "." which means IPv4
        total = 7;
        // fill empty segments them with "0000"
        var pos;
        for(pos = 0; pos < length; pos++){
            if (segments[pos] === "") break;
        }
        if (pos < total) {
            segments.splice(pos, 1, "0000");
            while(segments.length < total)segments.splice(pos, 0, "0000");
        }
        // strip leading zeros
        var _segments;
        for(var i = 0; i < total; i++){
            _segments = segments[i].split("");
            for(var j = 0; j < 3; j++){
                if (_segments[0] === "0" && _segments.length > 1) _segments.splice(0, 1);
                else break;
            }
            segments[i] = _segments.join("");
        }
        // find longest sequence of zeroes and coalesce them into one segment
        var best = -1;
        var _best = 0;
        var _current = 0;
        var current = -1;
        var inzeroes = false;
        // i; already declared
        for(i = 0; i < total; i++){
            if (inzeroes) {
                if (segments[i] === "0") _current += 1;
                else {
                    inzeroes = false;
                    if (_current > _best) {
                        best = current;
                        _best = _current;
                    }
                }
            } else if (segments[i] === "0") {
                inzeroes = true;
                current = i;
                _current = 1;
            }
        }
        if (_current > _best) {
            best = current;
            _best = _current;
        }
        if (_best > 1) segments.splice(best, _best, "");
        length = segments.length;
        // assemble remaining segments
        var result = "";
        if (segments[0] === "") result = ":";
        for(i = 0; i < length; i++){
            result += segments[i];
            if (i === length - 1) break;
            result += ":";
        }
        if (segments[length - 1] === "") result += ":";
        return result;
    }
    function noConflict() {
        /*jshint validthis: true */ if (root.IPv6 === this) root.IPv6 = _IPv6;
        return this;
    }
    return {
        best: bestPresentation,
        noConflict: noConflict
    };
});

},{}],"dIMve":[function(require,module,exports) {
/*!
 * URI.js - Mutating URLs
 * Second Level Domain (SLD) Support
 *
 * Version: 1.19.11
 *
 * Author: Rodney Rehm
 * Web: http://medialize.github.io/URI.js/
 *
 * Licensed under
 *   MIT License http://www.opensource.org/licenses/mit-license
 *
 */ (function(root, factory) {
    "use strict";
    // https://github.com/umdjs/umd/blob/master/returnExports.js
    if (0, module.exports) // Node
    module.exports = factory();
    else if (typeof define === "function" && define.amd) // AMD. Register as an anonymous module.
    define(factory);
    else // Browser globals (root is window)
    root.SecondLevelDomains = factory(root);
})(this, function(root) {
    "use strict";
    // save current SecondLevelDomains variable, if any
    var _SecondLevelDomains = root && root.SecondLevelDomains;
    var SLD = {
        // list of known Second Level Domains
        // converted list of SLDs from https://github.com/gavingmiller/second-level-domains
        // ----
        // publicsuffix.org is more current and actually used by a couple of browsers internally.
        // downside is it also contains domains like "dyndns.org" - which is fine for the security
        // issues browser have to deal with (SOP for cookies, etc) - but is way overboard for URI.js
        // ----
        list: {
            "ac": " com gov mil net org ",
            "ae": " ac co gov mil name net org pro sch ",
            "af": " com edu gov net org ",
            "al": " com edu gov mil net org ",
            "ao": " co ed gv it og pb ",
            "ar": " com edu gob gov int mil net org tur ",
            "at": " ac co gv or ",
            "au": " asn com csiro edu gov id net org ",
            "ba": " co com edu gov mil net org rs unbi unmo unsa untz unze ",
            "bb": " biz co com edu gov info net org store tv ",
            "bh": " biz cc com edu gov info net org ",
            "bn": " com edu gov net org ",
            "bo": " com edu gob gov int mil net org tv ",
            "br": " adm adv agr am arq art ato b bio blog bmd cim cng cnt com coop ecn edu eng esp etc eti far flog fm fnd fot fst g12 ggf gov imb ind inf jor jus lel mat med mil mus net nom not ntr odo org ppg pro psc psi qsl rec slg srv tmp trd tur tv vet vlog wiki zlg ",
            "bs": " com edu gov net org ",
            "bz": " du et om ov rg ",
            "ca": " ab bc mb nb nf nl ns nt nu on pe qc sk yk ",
            "ck": " biz co edu gen gov info net org ",
            "cn": " ac ah bj com cq edu fj gd gov gs gx gz ha hb he hi hl hn jl js jx ln mil net nm nx org qh sc sd sh sn sx tj tw xj xz yn zj ",
            "co": " com edu gov mil net nom org ",
            "cr": " ac c co ed fi go or sa ",
            "cy": " ac biz com ekloges gov ltd name net org parliament press pro tm ",
            "do": " art com edu gob gov mil net org sld web ",
            "dz": " art asso com edu gov net org pol ",
            "ec": " com edu fin gov info med mil net org pro ",
            "eg": " com edu eun gov mil name net org sci ",
            "er": " com edu gov ind mil net org rochest w ",
            "es": " com edu gob nom org ",
            "et": " biz com edu gov info name net org ",
            "fj": " ac biz com info mil name net org pro ",
            "fk": " ac co gov net nom org ",
            "fr": " asso com f gouv nom prd presse tm ",
            "gg": " co net org ",
            "gh": " com edu gov mil org ",
            "gn": " ac com gov net org ",
            "gr": " com edu gov mil net org ",
            "gt": " com edu gob ind mil net org ",
            "gu": " com edu gov net org ",
            "hk": " com edu gov idv net org ",
            "hu": " 2000 agrar bolt casino city co erotica erotika film forum games hotel info ingatlan jogasz konyvelo lakas media news org priv reklam sex shop sport suli szex tm tozsde utazas video ",
            "id": " ac co go mil net or sch web ",
            "il": " ac co gov idf k12 muni net org ",
            "in": " ac co edu ernet firm gen gov i ind mil net nic org res ",
            "iq": " com edu gov i mil net org ",
            "ir": " ac co dnssec gov i id net org sch ",
            "it": " edu gov ",
            "je": " co net org ",
            "jo": " com edu gov mil name net org sch ",
            "jp": " ac ad co ed go gr lg ne or ",
            "ke": " ac co go info me mobi ne or sc ",
            "kh": " com edu gov mil net org per ",
            "ki": " biz com de edu gov info mob net org tel ",
            "km": " asso com coop edu gouv k medecin mil nom notaires pharmaciens presse tm veterinaire ",
            "kn": " edu gov net org ",
            "kr": " ac busan chungbuk chungnam co daegu daejeon es gangwon go gwangju gyeongbuk gyeonggi gyeongnam hs incheon jeju jeonbuk jeonnam k kg mil ms ne or pe re sc seoul ulsan ",
            "kw": " com edu gov net org ",
            "ky": " com edu gov net org ",
            "kz": " com edu gov mil net org ",
            "lb": " com edu gov net org ",
            "lk": " assn com edu gov grp hotel int ltd net ngo org sch soc web ",
            "lr": " com edu gov net org ",
            "lv": " asn com conf edu gov id mil net org ",
            "ly": " com edu gov id med net org plc sch ",
            "ma": " ac co gov m net org press ",
            "mc": " asso tm ",
            "me": " ac co edu gov its net org priv ",
            "mg": " com edu gov mil nom org prd tm ",
            "mk": " com edu gov inf name net org pro ",
            "ml": " com edu gov net org presse ",
            "mn": " edu gov org ",
            "mo": " com edu gov net org ",
            "mt": " com edu gov net org ",
            "mv": " aero biz com coop edu gov info int mil museum name net org pro ",
            "mw": " ac co com coop edu gov int museum net org ",
            "mx": " com edu gob net org ",
            "my": " com edu gov mil name net org sch ",
            "nf": " arts com firm info net other per rec store web ",
            "ng": " biz com edu gov mil mobi name net org sch ",
            "ni": " ac co com edu gob mil net nom org ",
            "np": " com edu gov mil net org ",
            "nr": " biz com edu gov info net org ",
            "om": " ac biz co com edu gov med mil museum net org pro sch ",
            "pe": " com edu gob mil net nom org sld ",
            "ph": " com edu gov i mil net ngo org ",
            "pk": " biz com edu fam gob gok gon gop gos gov net org web ",
            "pl": " art bialystok biz com edu gda gdansk gorzow gov info katowice krakow lodz lublin mil net ngo olsztyn org poznan pwr radom slupsk szczecin torun warszawa waw wroc wroclaw zgora ",
            "pr": " ac biz com edu est gov info isla name net org pro prof ",
            "ps": " com edu gov net org plo sec ",
            "pw": " belau co ed go ne or ",
            "ro": " arts com firm info nom nt org rec store tm www ",
            "rs": " ac co edu gov in org ",
            "sb": " com edu gov net org ",
            "sc": " com edu gov net org ",
            "sh": " co com edu gov net nom org ",
            "sl": " com edu gov net org ",
            "st": " co com consulado edu embaixada gov mil net org principe saotome store ",
            "sv": " com edu gob org red ",
            "sz": " ac co org ",
            "tr": " av bbs bel biz com dr edu gen gov info k12 name net org pol tel tsk tv web ",
            "tt": " aero biz cat co com coop edu gov info int jobs mil mobi museum name net org pro tel travel ",
            "tw": " club com ebiz edu game gov idv mil net org ",
            "mu": " ac co com gov net or org ",
            "mz": " ac co edu gov org ",
            "na": " co com ",
            "nz": " ac co cri geek gen govt health iwi maori mil net org parliament school ",
            "pa": " abo ac com edu gob ing med net nom org sld ",
            "pt": " com edu gov int net nome org publ ",
            "py": " com edu gov mil net org ",
            "qa": " com edu gov mil net org ",
            "re": " asso com nom ",
            "ru": " ac adygeya altai amur arkhangelsk astrakhan bashkiria belgorod bir bryansk buryatia cbg chel chelyabinsk chita chukotka chuvashia com dagestan e-burg edu gov grozny int irkutsk ivanovo izhevsk jar joshkar-ola kalmykia kaluga kamchatka karelia kazan kchr kemerovo khabarovsk khakassia khv kirov koenig komi kostroma kranoyarsk kuban kurgan kursk lipetsk magadan mari mari-el marine mil mordovia mosreg msk murmansk nalchik net nnov nov novosibirsk nsk omsk orenburg org oryol penza perm pp pskov ptz rnd ryazan sakhalin samara saratov simbirsk smolensk spb stavropol stv surgut tambov tatarstan tom tomsk tsaritsyn tsk tula tuva tver tyumen udm udmurtia ulan-ude vladikavkaz vladimir vladivostok volgograd vologda voronezh vrn vyatka yakutia yamal yekaterinburg yuzhno-sakhalinsk ",
            "rw": " ac co com edu gouv gov int mil net ",
            "sa": " com edu gov med net org pub sch ",
            "sd": " com edu gov info med net org tv ",
            "se": " a ac b bd c d e f g h i k l m n o org p parti pp press r s t tm u w x y z ",
            "sg": " com edu gov idn net org per ",
            "sn": " art com edu gouv org perso univ ",
            "sy": " com edu gov mil net news org ",
            "th": " ac co go in mi net or ",
            "tj": " ac biz co com edu go gov info int mil name net nic org test web ",
            "tn": " agrinet com defense edunet ens fin gov ind info intl mincom nat net org perso rnrt rns rnu tourism ",
            "tz": " ac co go ne or ",
            "ua": " biz cherkassy chernigov chernovtsy ck cn co com crimea cv dn dnepropetrovsk donetsk dp edu gov if in ivano-frankivsk kh kharkov kherson khmelnitskiy kiev kirovograd km kr ks kv lg lugansk lutsk lviv me mk net nikolaev od odessa org pl poltava pp rovno rv sebastopol sumy te ternopil uzhgorod vinnica vn zaporizhzhe zhitomir zp zt ",
            "ug": " ac co go ne or org sc ",
            "uk": " ac bl british-library co cym gov govt icnet jet lea ltd me mil mod national-library-scotland nel net nhs nic nls org orgn parliament plc police sch scot soc ",
            "us": " dni fed isa kids nsn ",
            "uy": " com edu gub mil net org ",
            "ve": " co com edu gob info mil net org web ",
            "vi": " co com k12 net org ",
            "vn": " ac biz com edu gov health info int name net org pro ",
            "ye": " co com gov ltd me net org plc ",
            "yu": " ac co edu gov org ",
            "za": " ac agric alt bourse city co cybernet db edu gov grondar iaccess imt inca landesign law mil net ngo nis nom olivetti org pix school tm web ",
            "zm": " ac co com edu gov net org sch ",
            // https://en.wikipedia.org/wiki/CentralNic#Second-level_domains
            "com": "ar br cn de eu gb gr hu jpn kr no qc ru sa se uk us uy za ",
            "net": "gb jp se uk ",
            "org": "ae",
            "de": "com "
        },
        // gorhill 2013-10-25: Using indexOf() instead Regexp(). Significant boost
        // in both performance and memory footprint. No initialization required.
        // http://jsperf.com/uri-js-sld-regex-vs-binary-search/4
        // Following methods use lastIndexOf() rather than array.split() in order
        // to avoid any memory allocations.
        has: function(domain) {
            var tldOffset = domain.lastIndexOf(".");
            if (tldOffset <= 0 || tldOffset >= domain.length - 1) return false;
            var sldOffset = domain.lastIndexOf(".", tldOffset - 1);
            if (sldOffset <= 0 || sldOffset >= tldOffset - 1) return false;
            var sldList = SLD.list[domain.slice(tldOffset + 1)];
            if (!sldList) return false;
            return sldList.indexOf(" " + domain.slice(sldOffset + 1, tldOffset) + " ") >= 0;
        },
        is: function(domain) {
            var tldOffset = domain.lastIndexOf(".");
            if (tldOffset <= 0 || tldOffset >= domain.length - 1) return false;
            var sldOffset = domain.lastIndexOf(".", tldOffset - 1);
            if (sldOffset >= 0) return false;
            var sldList = SLD.list[domain.slice(tldOffset + 1)];
            if (!sldList) return false;
            return sldList.indexOf(" " + domain.slice(0, tldOffset) + " ") >= 0;
        },
        get: function(domain) {
            var tldOffset = domain.lastIndexOf(".");
            if (tldOffset <= 0 || tldOffset >= domain.length - 1) return null;
            var sldOffset = domain.lastIndexOf(".", tldOffset - 1);
            if (sldOffset <= 0 || sldOffset >= tldOffset - 1) return null;
            var sldList = SLD.list[domain.slice(tldOffset + 1)];
            if (!sldList) return null;
            if (sldList.indexOf(" " + domain.slice(sldOffset + 1, tldOffset) + " ") < 0) return null;
            return domain.slice(sldOffset + 1);
        },
        noConflict: function() {
            if (root.SecondLevelDomains === this) root.SecondLevelDomains = _SecondLevelDomains;
            return this;
        }
    };
    return SLD;
});

},{}],"e9ZDO":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AlchemyWebSocketProvider", ()=>AlchemyWebSocketProvider);
var _tslib = require("tslib");
var _eventemitter3 = require("eventemitter3");
var _eventemitter3Default = parcelHelpers.interopDefault(_eventemitter3);
var _subscriptionBackfill = require("../subscriptions/subscriptionBackfill");
var _types = require("../types");
var _hex = require("../util/hex");
var _jsonRpc = require("../util/jsonRpc");
var _promises = require("../util/promises");
var HEARTBEAT_INTERVAL = 30000;
var HEARTBEAT_WAIT_TIME = 10000;
var BACKFILL_TIMEOUT = 60000;
var BACKFILL_RETRIES = 5;
/**
 * Subscriptions have a memory of recent events they have sent so that in the
 * event that they disconnect and need to backfill, they can detect re-orgs.
 * Keep a buffer that goes back at least these many blocks, the maximum amount
 * at which we might conceivably see a re-org.
 *
 * Note that while our buffer goes back this many blocks, it may contain more
 * than this many elements, since in the case of logs subscriptions more than
 * one event may be emitted for a block.
 */ var RETAINED_EVENT_BLOCK_COUNT = 10;
var AlchemyWebSocketProvider = /** @class */ function(_super) {
    (0, _tslib.__extends)(AlchemyWebSocketProvider, _super);
    function AlchemyWebSocketProvider(ws, sendJsonRpcPayload, jsonRpcSenders) {
        var _this = _super.call(this) || this;
        _this.ws = ws;
        _this.sendJsonRpcPayload = sendJsonRpcPayload;
        _this.jsonRpcSenders = jsonRpcSenders;
        // In the case of a WebSocket reconnection, all subscriptions are lost and we
        // create new ones to replace them, but we want to create the illusion that
        // the original subscriptions persist. Thus, maintain a mapping from the
        // "virtual" subscription ids which are visible to the consumer to the
        // "physical" subscription ids of the actual connections. This terminology is
        // borrowed from virtual and physical memory, which has a similar mapping.
        _this.virtualSubscriptionsById = new Map();
        _this.virtualIdsByPhysicalId = new Map();
        _this.cancelBackfill = noop;
        _this.startHeartbeat = function() {
            if (_this.heartbeatIntervalId != null) return;
            _this.heartbeatIntervalId = setInterval(function() {
                return (0, _tslib.__awaiter)(_this, void 0, void 0, function() {
                    var _a;
                    return (0, _tslib.__generator)(this, function(_b) {
                        switch(_b.label){
                            case 0:
                                _b.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                return [
                                    4 /*yield*/ ,
                                    (0, _promises.withTimeout)(this.jsonRpcSenders.send("net_version"), HEARTBEAT_WAIT_TIME)
                                ];
                            case 1:
                                _b.sent();
                                return [
                                    3 /*break*/ ,
                                    3
                                ];
                            case 2:
                                _a = _b.sent();
                                this.ws.reconnect();
                                return [
                                    3 /*break*/ ,
                                    3
                                ];
                            case 3:
                                return [
                                    2 /*return*/ 
                                ];
                        }
                    });
                });
            }, HEARTBEAT_INTERVAL);
        };
        _this.stopHeartbeatAndBackfill = function() {
            if (_this.heartbeatIntervalId != null) {
                clearInterval(_this.heartbeatIntervalId);
                _this.heartbeatIntervalId = undefined;
            }
            _this.cancelBackfill();
        };
        _this.handleMessage = function(event) {
            var message = JSON.parse(event.data);
            if (!(0, _types.isSubscriptionEvent)(message)) return;
            var physicalId = message.params.subscription;
            var virtualId = _this.virtualIdsByPhysicalId.get(physicalId);
            if (!virtualId) return;
            var subscription = _this.virtualSubscriptionsById.get(virtualId);
            if (subscription.method !== "eth_subscribe") {
                _this.emitGenericEvent(virtualId, message.params.result);
                return;
            }
            switch(subscription.params[0]){
                case "newHeads":
                    var newHeadsSubscription = subscription;
                    var newHeadsMessage = message;
                    var isBackfilling = newHeadsSubscription.isBackfilling, backfillBuffer = newHeadsSubscription.backfillBuffer;
                    var result = newHeadsMessage.params.result;
                    if (isBackfilling) addToNewHeadsEventsBuffer(backfillBuffer, result);
                    else _this.emitNewHeadsEvent(virtualId, result);
                    break;
                case "logs":
                    var logsSubscription = subscription;
                    var logsMessage = message;
                    var isBackfilling = logsSubscription.isBackfilling, backfillBuffer = logsSubscription.backfillBuffer;
                    var result = logsMessage.params.result;
                    if (isBackfilling) addToLogsEventsBuffer(backfillBuffer, result);
                    else _this.emitLogsEvent(virtualId, result);
                    break;
                default:
                    _this.emitGenericEvent(virtualId, message.params.result);
            }
        };
        _this.handleReopen = function() {
            var e_1, _a;
            _this.virtualIdsByPhysicalId.clear();
            var _b = (0, _promises.makeCancelToken)(), cancel = _b.cancel, isCancelled = _b.isCancelled;
            _this.cancelBackfill = cancel;
            var _loop_1 = function(subscription) {
                (function() {
                    return (0, _tslib.__awaiter)(_this, void 0, void 0, function() {
                        var error_1;
                        return (0, _tslib.__generator)(this, function(_a) {
                            switch(_a.label){
                                case 0:
                                    _a.trys.push([
                                        0,
                                        2,
                                        ,
                                        3
                                    ]);
                                    return [
                                        4 /*yield*/ ,
                                        this.resubscribeAndBackfill(isCancelled, subscription)
                                    ];
                                case 1:
                                    _a.sent();
                                    return [
                                        3 /*break*/ ,
                                        3
                                    ];
                                case 2:
                                    error_1 = _a.sent();
                                    if (!isCancelled()) console.error('Error while backfilling "' + subscription.params[0] + '" subscription. Some events may be missing.', error_1);
                                    return [
                                        3 /*break*/ ,
                                        3
                                    ];
                                case 3:
                                    return [
                                        2 /*return*/ 
                                    ];
                            }
                        });
                    });
                })();
            };
            try {
                for(var _c = (0, _tslib.__values)(_this.virtualSubscriptionsById.values()), _d = _c.next(); !_d.done; _d = _c.next()){
                    var subscription = _d.value;
                    _loop_1(subscription);
                }
            } catch (e_1_1) {
                e_1 = {
                    error: e_1_1
                };
            } finally{
                try {
                    if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
                } finally{
                    if (e_1) throw e_1.error;
                }
            }
            _this.startHeartbeat();
        };
        _this.backfiller = (0, _subscriptionBackfill.makeBackfiller)(jsonRpcSenders);
        _this.addSocketListeners();
        _this.startHeartbeat();
        return _this;
    }
    AlchemyWebSocketProvider.prototype.send = function(request, callback) {
        if (isSubscribeRequest(request)) {
            var id = request.id;
            if (id === undefined) // The JSON-RPC spec says to return nothing if there is no request id.
            return;
            (0, _promises.callWhenDone)(this.subscribe(request), callback);
            return;
        }
        if (isUnsubscribeRequest(request)) {
            (0, _promises.callWhenDone)(this.unsubscribe(request), callback);
            return;
        }
        (0, _promises.callWhenDone)(this.sendJsonRpcPayload(request), callback);
    };
    AlchemyWebSocketProvider.prototype.supportsSubscriptions = function() {
        return true;
    };
    AlchemyWebSocketProvider.prototype.disconnect = function(code, reason) {
        this.removeSocketListeners();
        this.removeAllListeners();
        this.stopHeartbeatAndBackfill();
        this.ws.close(code, reason);
    };
    AlchemyWebSocketProvider.prototype.connect = function() {
    // No-op. We're already connected when passed a websocket in the
    // constructor.
    };
    AlchemyWebSocketProvider.prototype.reset = function() {
    // No-op.
    };
    AlchemyWebSocketProvider.prototype.reconnect = function() {
    // No-op. This isn't called anywhere.
    };
    AlchemyWebSocketProvider.prototype.subscribe = function(request) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var method, _a, params, startingBlockNumber, response, id;
            return (0, _tslib.__generator)(this, function(_b) {
                switch(_b.label){
                    case 0:
                        method = request.method, _a = request.params, params = _a === void 0 ? [] : _a;
                        return [
                            4 /*yield*/ ,
                            this.getBlockNumber()
                        ];
                    case 1:
                        startingBlockNumber = _b.sent();
                        return [
                            4 /*yield*/ ,
                            this.sendJsonRpcPayload(request)
                        ];
                    case 2:
                        response = _b.sent();
                        id = response.result;
                        this.virtualSubscriptionsById.set(id, {
                            method: method,
                            params: params,
                            startingBlockNumber: startingBlockNumber,
                            virtualId: id,
                            physicalId: id,
                            sentEvents: [],
                            isBackfilling: false,
                            backfillBuffer: []
                        });
                        this.virtualIdsByPhysicalId.set(id, id);
                        return [
                            2 /*return*/ ,
                            (0, _jsonRpc.makeResponse)(request.id, id)
                        ];
                }
            });
        });
    };
    AlchemyWebSocketProvider.prototype.unsubscribe = function(request) {
        var _a;
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var subscriptionId, virtualSubscription, physicalId, physicalRequest;
            return (0, _tslib.__generator)(this, function(_b) {
                switch(_b.label){
                    case 0:
                        subscriptionId = (_a = request.params) === null || _a === void 0 ? void 0 : _a[0];
                        virtualSubscription = this.virtualSubscriptionsById.get(subscriptionId);
                        if (!virtualSubscription) return [
                            2 /*return*/ ,
                            (0, _jsonRpc.makeResponse)(request.id, false)
                        ];
                        physicalId = virtualSubscription.physicalId;
                        physicalRequest = (0, _tslib.__assign)((0, _tslib.__assign)({}, request), {
                            params: [
                                physicalId
                            ]
                        });
                        return [
                            4 /*yield*/ ,
                            this.sendJsonRpcPayload(physicalRequest)
                        ];
                    case 1:
                        _b.sent();
                        this.virtualSubscriptionsById.delete(subscriptionId);
                        this.virtualIdsByPhysicalId.delete(physicalId);
                        return [
                            2 /*return*/ ,
                            (0, _jsonRpc.makeResponse)(request.id, true)
                        ];
                }
            });
        });
    };
    AlchemyWebSocketProvider.prototype.addSocketListeners = function() {
        this.ws.addEventListener("message", this.handleMessage);
        this.ws.addEventListener("reopen", this.handleReopen);
        this.ws.addEventListener("down", this.stopHeartbeatAndBackfill);
    };
    AlchemyWebSocketProvider.prototype.removeSocketListeners = function() {
        this.ws.removeEventListener("message", this.handleMessage);
        this.ws.removeEventListener("reopen", this.handleReopen);
        this.ws.removeEventListener("down", this.stopHeartbeatAndBackfill);
    };
    AlchemyWebSocketProvider.prototype.resubscribeAndBackfill = function(isCancelled, subscription) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var virtualId, method, params, sentEvents, backfillBuffer, startingBlockNumber, physicalId, _a, backfillEvents, events, filter_1, backfillEvents, events;
            var _this = this;
            return (0, _tslib.__generator)(this, function(_b) {
                switch(_b.label){
                    case 0:
                        virtualId = subscription.virtualId, method = subscription.method, params = subscription.params, sentEvents = subscription.sentEvents, backfillBuffer = subscription.backfillBuffer, startingBlockNumber = subscription.startingBlockNumber;
                        subscription.isBackfilling = true;
                        backfillBuffer.length = 0;
                        _b.label = 1;
                    case 1:
                        _b.trys.push([
                            1,
                            ,
                            9,
                            10
                        ]);
                        return [
                            4 /*yield*/ ,
                            this.jsonRpcSenders.send(method, params)
                        ];
                    case 2:
                        physicalId = _b.sent();
                        (0, _promises.throwIfCancelled)(isCancelled);
                        subscription.physicalId = physicalId;
                        this.virtualIdsByPhysicalId.set(physicalId, virtualId);
                        _a = params[0];
                        switch(_a){
                            case "newHeads":
                                return [
                                    3 /*break*/ ,
                                    3
                                ];
                            case "logs":
                                return [
                                    3 /*break*/ ,
                                    5
                                ];
                        }
                        return [
                            3 /*break*/ ,
                            7
                        ];
                    case 3:
                        return [
                            4 /*yield*/ ,
                            (0, _promises.withBackoffRetries)(function() {
                                return (0, _promises.withTimeout)(_this.backfiller.getNewHeadsBackfill(isCancelled, sentEvents, startingBlockNumber), BACKFILL_TIMEOUT);
                            }, BACKFILL_RETRIES, function() {
                                return !isCancelled();
                            })
                        ];
                    case 4:
                        backfillEvents = _b.sent();
                        (0, _promises.throwIfCancelled)(isCancelled);
                        events = (0, _subscriptionBackfill.dedupeNewHeads)((0, _tslib.__spreadArray)((0, _tslib.__spreadArray)([], (0, _tslib.__read)(backfillEvents)), (0, _tslib.__read)(backfillBuffer)));
                        events.forEach(function(event) {
                            return _this.emitNewHeadsEvent(virtualId, event);
                        });
                        return [
                            3 /*break*/ ,
                            8
                        ];
                    case 5:
                        filter_1 = params[1] || {};
                        return [
                            4 /*yield*/ ,
                            (0, _promises.withBackoffRetries)(function() {
                                return (0, _promises.withTimeout)(_this.backfiller.getLogsBackfill(isCancelled, filter_1, sentEvents, startingBlockNumber), BACKFILL_TIMEOUT);
                            }, BACKFILL_RETRIES, function() {
                                return !isCancelled();
                            })
                        ];
                    case 6:
                        backfillEvents = _b.sent();
                        (0, _promises.throwIfCancelled)(isCancelled);
                        events = (0, _subscriptionBackfill.dedupeLogs)((0, _tslib.__spreadArray)((0, _tslib.__spreadArray)([], (0, _tslib.__read)(backfillEvents)), (0, _tslib.__read)(backfillBuffer)));
                        events.forEach(function(event) {
                            return _this.emitLogsEvent(virtualId, event);
                        });
                        return [
                            3 /*break*/ ,
                            8
                        ];
                    case 7:
                        return [
                            3 /*break*/ ,
                            8
                        ];
                    case 8:
                        return [
                            3 /*break*/ ,
                            10
                        ];
                    case 9:
                        subscription.isBackfilling = false;
                        backfillBuffer.length = 0;
                        return [
                            7 /*endfinally*/ 
                        ];
                    case 10:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    AlchemyWebSocketProvider.prototype.getBlockNumber = function() {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var blockNumberHex;
            return (0, _tslib.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.jsonRpcSenders.send("eth_blockNumber")
                        ];
                    case 1:
                        blockNumberHex = _a.sent();
                        return [
                            2 /*return*/ ,
                            (0, _hex.fromHex)(blockNumberHex)
                        ];
                }
            });
        });
    };
    AlchemyWebSocketProvider.prototype.emitNewHeadsEvent = function(virtualId, result) {
        this.emitAndRememberEvent(virtualId, result, getNewHeadsBlockNumber);
    };
    AlchemyWebSocketProvider.prototype.emitLogsEvent = function(virtualId, result) {
        this.emitAndRememberEvent(virtualId, result, getLogsBlockNumber);
    };
    /**
     * Emits an event to consumers, but also remembers it in its subscriptions's
     * `sentEvents` buffer so that we can detect re-orgs if the connection drops
     * and needs to be reconnected.
     */ AlchemyWebSocketProvider.prototype.emitAndRememberEvent = function(virtualId, result, getBlockNumber) {
        var subscription = this.virtualSubscriptionsById.get(virtualId);
        if (!subscription) return;
        // Web3 modifies these event objects once we pass them on (changing hex
        // numbers to numbers). We want the original event, so make a defensive
        // copy.
        addToPastEventsBuffer(subscription.sentEvents, (0, _tslib.__assign)({}, result), getBlockNumber);
        this.emitGenericEvent(virtualId, result);
    };
    AlchemyWebSocketProvider.prototype.emitGenericEvent = function(virtualId, result) {
        var event = {
            jsonrpc: "2.0",
            method: "eth_subscription",
            params: {
                subscription: virtualId,
                result: result
            }
        };
        this.emit("data", event);
    };
    return AlchemyWebSocketProvider;
}((0, _eventemitter3Default.default));
function addToNewHeadsEventsBuffer(pastEvents, event) {
    addToPastEventsBuffer(pastEvents, event, getNewHeadsBlockNumber);
}
function addToLogsEventsBuffer(pastEvents, event) {
    addToPastEventsBuffer(pastEvents, event, getLogsBlockNumber);
}
/**
 * Adds a new event to an array of events, evicting any events which
 * are so old that they will no longer feasibly be part of a reorg.
 */ function addToPastEventsBuffer(pastEvents, event, getBlockNumber) {
    var currentBlockNumber = getBlockNumber(event);
    // Find first index of an event recent enough to retain, then drop everything
    // at a lower index.
    var firstGoodIndex = pastEvents.findIndex(function(e) {
        return getBlockNumber(e) > currentBlockNumber - RETAINED_EVENT_BLOCK_COUNT;
    });
    if (firstGoodIndex === -1) pastEvents.length = 0;
    else pastEvents.splice(0, firstGoodIndex);
    pastEvents.push(event);
}
function isSubscribeRequest(request) {
    return !Array.isArray(request) && request.method === "eth_subscribe";
}
function isUnsubscribeRequest(request) {
    return !Array.isArray(request) && request.method === "eth_unsubscribe";
}
function getNewHeadsBlockNumber(event) {
    return (0, _hex.fromHex)(event.number);
}
function getLogsBlockNumber(event) {
    return (0, _hex.fromHex)(event.blockNumber);
}
function noop() {
// Nothing.
}

},{"tslib":"gBS4y","eventemitter3":"6xgnM","../subscriptions/subscriptionBackfill":"iOupD","../types":"9neWU","../util/hex":"2yu6A","../util/jsonRpc":"lHMPJ","../util/promises":"03X3y","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"6xgnM":[function(require,module,exports) {
"use strict";
var has = Object.prototype.hasOwnProperty, prefix = "~";
/**
 * Constructor to create a storage for our `EE` objects.
 * An `Events` instance is a plain object whose properties are event names.
 *
 * @constructor
 * @private
 */ function Events() {}
//
// We try to not inherit from `Object.prototype`. In some engines creating an
// instance in this way is faster than calling `Object.create(null)` directly.
// If `Object.create(null)` is not supported we prefix the event names with a
// character to make sure that the built-in object properties are not
// overridden or used as an attack vector.
//
if (Object.create) {
    Events.prototype = Object.create(null);
    //
    // This hack is needed because the `__proto__` property is still inherited in
    // some old browsers like Android 4, iPhone 5.1, Opera 11 and Safari 5.
    //
    if (!new Events().__proto__) prefix = false;
}
/**
 * Representation of a single event listener.
 *
 * @param {Function} fn The listener function.
 * @param {*} context The context to invoke the listener with.
 * @param {Boolean} [once=false] Specify if the listener is a one-time listener.
 * @constructor
 * @private
 */ function EE(fn, context, once) {
    this.fn = fn;
    this.context = context;
    this.once = once || false;
}
/**
 * Add a listener for a given event.
 *
 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} context The context to invoke the listener with.
 * @param {Boolean} once Specify if the listener is a one-time listener.
 * @returns {EventEmitter}
 * @private
 */ function addListener(emitter, event, fn, context, once) {
    if (typeof fn !== "function") throw new TypeError("The listener must be a function");
    var listener = new EE(fn, context || emitter, once), evt = prefix ? prefix + event : event;
    if (!emitter._events[evt]) emitter._events[evt] = listener, emitter._eventsCount++;
    else if (!emitter._events[evt].fn) emitter._events[evt].push(listener);
    else emitter._events[evt] = [
        emitter._events[evt],
        listener
    ];
    return emitter;
}
/**
 * Clear event by name.
 *
 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
 * @param {(String|Symbol)} evt The Event name.
 * @private
 */ function clearEvent(emitter, evt) {
    if (--emitter._eventsCount === 0) emitter._events = new Events();
    else delete emitter._events[evt];
}
/**
 * Minimal `EventEmitter` interface that is molded against the Node.js
 * `EventEmitter` interface.
 *
 * @constructor
 * @public
 */ function EventEmitter() {
    this._events = new Events();
    this._eventsCount = 0;
}
/**
 * Return an array listing the events for which the emitter has registered
 * listeners.
 *
 * @returns {Array}
 * @public
 */ EventEmitter.prototype.eventNames = function eventNames() {
    var names = [], events, name;
    if (this._eventsCount === 0) return names;
    for(name in events = this._events)if (has.call(events, name)) names.push(prefix ? name.slice(1) : name);
    if (Object.getOwnPropertySymbols) return names.concat(Object.getOwnPropertySymbols(events));
    return names;
};
/**
 * Return the listeners registered for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Array} The registered listeners.
 * @public
 */ EventEmitter.prototype.listeners = function listeners(event) {
    var evt = prefix ? prefix + event : event, handlers = this._events[evt];
    if (!handlers) return [];
    if (handlers.fn) return [
        handlers.fn
    ];
    for(var i = 0, l = handlers.length, ee = new Array(l); i < l; i++)ee[i] = handlers[i].fn;
    return ee;
};
/**
 * Return the number of listeners listening to a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Number} The number of listeners.
 * @public
 */ EventEmitter.prototype.listenerCount = function listenerCount(event) {
    var evt = prefix ? prefix + event : event, listeners = this._events[evt];
    if (!listeners) return 0;
    if (listeners.fn) return 1;
    return listeners.length;
};
/**
 * Calls each of the listeners registered for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Boolean} `true` if the event had listeners, else `false`.
 * @public
 */ EventEmitter.prototype.emit = function emit(event, a1, a2, a3, a4, a5) {
    var evt = prefix ? prefix + event : event;
    if (!this._events[evt]) return false;
    var listeners = this._events[evt], len = arguments.length, args, i;
    if (listeners.fn) {
        if (listeners.once) this.removeListener(event, listeners.fn, undefined, true);
        switch(len){
            case 1:
                return listeners.fn.call(listeners.context), true;
            case 2:
                return listeners.fn.call(listeners.context, a1), true;
            case 3:
                return listeners.fn.call(listeners.context, a1, a2), true;
            case 4:
                return listeners.fn.call(listeners.context, a1, a2, a3), true;
            case 5:
                return listeners.fn.call(listeners.context, a1, a2, a3, a4), true;
            case 6:
                return listeners.fn.call(listeners.context, a1, a2, a3, a4, a5), true;
        }
        for(i = 1, args = new Array(len - 1); i < len; i++)args[i - 1] = arguments[i];
        listeners.fn.apply(listeners.context, args);
    } else {
        var length = listeners.length, j;
        for(i = 0; i < length; i++){
            if (listeners[i].once) this.removeListener(event, listeners[i].fn, undefined, true);
            switch(len){
                case 1:
                    listeners[i].fn.call(listeners[i].context);
                    break;
                case 2:
                    listeners[i].fn.call(listeners[i].context, a1);
                    break;
                case 3:
                    listeners[i].fn.call(listeners[i].context, a1, a2);
                    break;
                case 4:
                    listeners[i].fn.call(listeners[i].context, a1, a2, a3);
                    break;
                default:
                    if (!args) for(j = 1, args = new Array(len - 1); j < len; j++)args[j - 1] = arguments[j];
                    listeners[i].fn.apply(listeners[i].context, args);
            }
        }
    }
    return true;
};
/**
 * Add a listener for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @public
 */ EventEmitter.prototype.on = function on(event, fn, context) {
    return addListener(this, event, fn, context, false);
};
/**
 * Add a one-time listener for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @public
 */ EventEmitter.prototype.once = function once(event, fn, context) {
    return addListener(this, event, fn, context, true);
};
/**
 * Remove the listeners of a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn Only remove the listeners that match this function.
 * @param {*} context Only remove the listeners that have this context.
 * @param {Boolean} once Only remove one-time listeners.
 * @returns {EventEmitter} `this`.
 * @public
 */ EventEmitter.prototype.removeListener = function removeListener(event, fn, context, once) {
    var evt = prefix ? prefix + event : event;
    if (!this._events[evt]) return this;
    if (!fn) {
        clearEvent(this, evt);
        return this;
    }
    var listeners = this._events[evt];
    if (listeners.fn) {
        if (listeners.fn === fn && (!once || listeners.once) && (!context || listeners.context === context)) clearEvent(this, evt);
    } else {
        for(var i = 0, events = [], length = listeners.length; i < length; i++)if (listeners[i].fn !== fn || once && !listeners[i].once || context && listeners[i].context !== context) events.push(listeners[i]);
        //
        // Reset the array, or remove it completely if we have no more listeners.
        //
        if (events.length) this._events[evt] = events.length === 1 ? events[0] : events;
        else clearEvent(this, evt);
    }
    return this;
};
/**
 * Remove all listeners, or those of the specified event.
 *
 * @param {(String|Symbol)} [event] The event name.
 * @returns {EventEmitter} `this`.
 * @public
 */ EventEmitter.prototype.removeAllListeners = function removeAllListeners(event) {
    var evt;
    if (event) {
        evt = prefix ? prefix + event : event;
        if (this._events[evt]) clearEvent(this, evt);
    } else {
        this._events = new Events();
        this._eventsCount = 0;
    }
    return this;
};
//
// Alias methods names because people roll like that.
//
EventEmitter.prototype.off = EventEmitter.prototype.removeListener;
EventEmitter.prototype.addListener = EventEmitter.prototype.on;
//
// Expose the prefix.
//
EventEmitter.prefixed = prefix;
//
// Allow `EventEmitter` to be imported as module namespace.
//
EventEmitter.EventEmitter = EventEmitter;
module.exports = EventEmitter;

},{}],"iOupD":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "makeBackfiller", ()=>makeBackfiller);
parcelHelpers.export(exports, "dedupeNewHeads", ()=>dedupeNewHeads);
parcelHelpers.export(exports, "dedupeLogs", ()=>dedupeLogs);
var _tslib = require("tslib");
var _hex = require("../util/hex");
var _promises = require("../util/promises");
/**
 * The maximum number of blocks to backfill. If more than this many blocks have
 * been missed, then we'll sadly miss data, but we want to make sure we don't
 * end up requesting thousands of blocks if somebody left their laptop closed
 * for a week.
 */ var MAX_BACKFILL_BLOCKS = 120;
/**
 * The maximum number of requests that can be included in a single batch request.
 * This value is enforced by the backend.
 */ var MAX_BATCH_SIZE = 10;
function makeBackfiller(jsonRpcSenders) {
    return {
        getNewHeadsBackfill: getNewHeadsBackfill,
        getLogsBackfill: getLogsBackfill
    };
    function getNewHeadsBackfill(isCancelled, previousHeads, fromBlockNumber) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var toBlockNumber, lastSeenBlockNumber, minBlockNumber, reorgHeads, intermediateHeads;
            return (0, _tslib.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        (0, _promises.throwIfCancelled)(isCancelled);
                        return [
                            4 /*yield*/ ,
                            getBlockNumber()
                        ];
                    case 1:
                        toBlockNumber = _a.sent();
                        (0, _promises.throwIfCancelled)(isCancelled);
                        if (previousHeads.length === 0) return [
                            2 /*return*/ ,
                            getHeadEventsInRange(Math.max(fromBlockNumber, toBlockNumber - MAX_BACKFILL_BLOCKS) + 1, toBlockNumber + 1)
                        ];
                        lastSeenBlockNumber = (0, _hex.fromHex)(previousHeads[previousHeads.length - 1].number);
                        minBlockNumber = Math.max(0, lastSeenBlockNumber - MAX_BACKFILL_BLOCKS);
                        if (lastSeenBlockNumber < minBlockNumber) return [
                            2 /*return*/ ,
                            getHeadEventsInRange(minBlockNumber, toBlockNumber + 1)
                        ];
                        return [
                            4 /*yield*/ ,
                            getReorgHeads(isCancelled, previousHeads)
                        ];
                    case 2:
                        reorgHeads = _a.sent();
                        (0, _promises.throwIfCancelled)(isCancelled);
                        return [
                            4 /*yield*/ ,
                            getHeadEventsInRange(lastSeenBlockNumber + 1, toBlockNumber + 1)
                        ];
                    case 3:
                        intermediateHeads = _a.sent();
                        (0, _promises.throwIfCancelled)(isCancelled);
                        return [
                            2 /*return*/ ,
                            (0, _tslib.__spreadArray)((0, _tslib.__spreadArray)([], (0, _tslib.__read)(reorgHeads)), (0, _tslib.__read)(intermediateHeads))
                        ];
                }
            });
        });
    }
    function getReorgHeads(isCancelled, previousHeads) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var result, i, oldEvent, blockHead;
            return (0, _tslib.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        result = [];
                        i = previousHeads.length - 1;
                        _a.label = 1;
                    case 1:
                        if (!(i >= 0)) return [
                            3 /*break*/ ,
                            4
                        ];
                        oldEvent = previousHeads[i];
                        return [
                            4 /*yield*/ ,
                            getBlockByNumber((0, _hex.fromHex)(oldEvent.number))
                        ];
                    case 2:
                        blockHead = _a.sent();
                        (0, _promises.throwIfCancelled)(isCancelled);
                        if (oldEvent.hash === blockHead.hash) return [
                            3 /*break*/ ,
                            4
                        ];
                        result.push(toNewHeadsEvent(blockHead));
                        _a.label = 3;
                    case 3:
                        i--;
                        return [
                            3 /*break*/ ,
                            1
                        ];
                    case 4:
                        return [
                            2 /*return*/ ,
                            result.reverse()
                        ];
                }
            });
        });
    }
    function getHeadEventsInRange(fromBlockInclusive, toBlockExclusive) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var batchParts, headEventBatches, i, batchedBlockHeads, blockHeads;
            return (0, _tslib.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (fromBlockInclusive >= toBlockExclusive) return [
                            2 /*return*/ ,
                            []
                        ];
                        batchParts = [];
                        headEventBatches = [];
                        for(i = fromBlockInclusive; i < toBlockExclusive; i++){
                            batchParts.push({
                                method: "eth_getBlockByNumber",
                                params: [
                                    (0, _hex.toHex)(i),
                                    false
                                ]
                            });
                            if (batchParts.length % MAX_BATCH_SIZE === 0) {
                                headEventBatches.push(jsonRpcSenders.sendBatch(batchParts));
                                batchParts = [];
                            }
                        }
                        if (batchParts.length > 0) headEventBatches.push(jsonRpcSenders.sendBatch(batchParts));
                        return [
                            4 /*yield*/ ,
                            Promise.all(headEventBatches)
                        ];
                    case 1:
                        batchedBlockHeads = _a.sent();
                        blockHeads = batchedBlockHeads.reduce(function(acc, batch) {
                            return acc.concat(batch);
                        }, []);
                        return [
                            2 /*return*/ ,
                            blockHeads.map(toNewHeadsEvent)
                        ];
                }
            });
        });
    }
    function getBlockByNumber(blockNumber) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            return (0, _tslib.__generator)(this, function(_a) {
                return [
                    2 /*return*/ ,
                    jsonRpcSenders.send("eth_getBlockByNumber", [
                        (0, _hex.toHex)(blockNumber),
                        false
                    ])
                ];
            });
        });
    }
    function getLogsBackfill(isCancelled, filter, previousLogs, fromBlockNumber) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var toBlockNumber, lastSeenBlockNumber, minBlockNumber, commonAncestorNumber, removedLogs, addedLogs;
            return (0, _tslib.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        (0, _promises.throwIfCancelled)(isCancelled);
                        return [
                            4 /*yield*/ ,
                            getBlockNumber()
                        ];
                    case 1:
                        toBlockNumber = _a.sent();
                        (0, _promises.throwIfCancelled)(isCancelled);
                        if (previousLogs.length === 0) return [
                            2 /*return*/ ,
                            getLogsInRange(filter, Math.max(fromBlockNumber, toBlockNumber - MAX_BACKFILL_BLOCKS) + 1, toBlockNumber + 1)
                        ];
                        lastSeenBlockNumber = (0, _hex.fromHex)(previousLogs[previousLogs.length - 1].blockNumber);
                        minBlockNumber = Math.max(0, lastSeenBlockNumber - MAX_BACKFILL_BLOCKS);
                        if (lastSeenBlockNumber < minBlockNumber) return [
                            2 /*return*/ ,
                            getLogsInRange(filter, minBlockNumber, toBlockNumber + 1)
                        ];
                        return [
                            4 /*yield*/ ,
                            getCommonAncestorNumber(isCancelled, previousLogs)
                        ];
                    case 2:
                        commonAncestorNumber = _a.sent();
                        (0, _promises.throwIfCancelled)(isCancelled);
                        removedLogs = previousLogs.filter(function(log) {
                            return (0, _hex.fromHex)(log.blockNumber) > commonAncestorNumber;
                        }).map(function(log) {
                            return (0, _tslib.__assign)((0, _tslib.__assign)({}, log), {
                                removed: true
                            });
                        });
                        return [
                            4 /*yield*/ ,
                            getLogsInRange(filter, commonAncestorNumber + 1, toBlockNumber + 1)
                        ];
                    case 3:
                        addedLogs = _a.sent();
                        (0, _promises.throwIfCancelled)(isCancelled);
                        return [
                            2 /*return*/ ,
                            (0, _tslib.__spreadArray)((0, _tslib.__spreadArray)([], (0, _tslib.__read)(removedLogs)), (0, _tslib.__read)(addedLogs))
                        ];
                }
            });
        });
    }
    function getCommonAncestorNumber(isCancelled, previousLogs) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var i, _a, blockHash, blockNumber, hash;
            return (0, _tslib.__generator)(this, function(_b) {
                switch(_b.label){
                    case 0:
                        i = previousLogs.length - 1;
                        _b.label = 1;
                    case 1:
                        if (!(i >= 0)) return [
                            3 /*break*/ ,
                            4
                        ];
                        _a = previousLogs[i], blockHash = _a.blockHash, blockNumber = _a.blockNumber;
                        return [
                            4 /*yield*/ ,
                            getBlockByNumber((0, _hex.fromHex)(blockNumber))
                        ];
                    case 2:
                        hash = _b.sent().hash;
                        (0, _promises.throwIfCancelled)(isCancelled);
                        if (blockHash === hash) return [
                            2 /*return*/ ,
                            (0, _hex.fromHex)(blockNumber)
                        ];
                        _b.label = 3;
                    case 3:
                        i--;
                        return [
                            3 /*break*/ ,
                            1
                        ];
                    case 4:
                        return [
                            2 /*return*/ ,
                            Number.NEGATIVE_INFINITY
                        ];
                }
            });
        });
    }
    function getLogsInRange(filter, fromBlockInclusive, toBlockExclusive) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var rangeFilter;
            return (0, _tslib.__generator)(this, function(_a) {
                if (fromBlockInclusive >= toBlockExclusive) return [
                    2 /*return*/ ,
                    []
                ];
                rangeFilter = (0, _tslib.__assign)((0, _tslib.__assign)({}, filter), {
                    fromBlock: (0, _hex.toHex)(fromBlockInclusive),
                    toBlock: (0, _hex.toHex)(toBlockExclusive - 1)
                });
                return [
                    2 /*return*/ ,
                    jsonRpcSenders.send("eth_getLogs", [
                        rangeFilter
                    ])
                ];
            });
        });
    }
    function getBlockNumber() {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var blockNumberHex;
            return (0, _tslib.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            jsonRpcSenders.send("eth_blockNumber")
                        ];
                    case 1:
                        blockNumberHex = _a.sent();
                        return [
                            2 /*return*/ ,
                            (0, _hex.fromHex)(blockNumberHex)
                        ];
                }
            });
        });
    }
}
function toNewHeadsEvent(head) {
    var result = (0, _tslib.__assign)({}, head);
    delete result.totalDifficulty;
    delete result.transactions;
    delete result.uncles;
    return result;
}
function dedupeNewHeads(events) {
    return dedupe(events, function(event) {
        return event.hash;
    });
}
function dedupeLogs(events) {
    return dedupe(events, function(event) {
        return event.blockHash + "/" + event.logIndex;
    });
}
function dedupe(items, getKey) {
    var keysSeen = new Set();
    var result = [];
    items.forEach(function(item) {
        var key = getKey(item);
        if (!keysSeen.has(key)) {
            keysSeen.add(key);
            result.push(item);
        }
    });
    return result;
}

},{"tslib":"gBS4y","../util/hex":"2yu6A","../util/promises":"03X3y","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"5Xqsx":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Private method to enable adding custom RPC calls to the web3 object. This
 * allows the addition of custom endpoints to the web3 object.
 */ parcelHelpers.export(exports, "patchEnableCustomRPC", ()=>patchEnableCustomRPC);
var _web3CoreMethod = require("web3-core-method");
var _web3CoreMethodDefault = parcelHelpers.interopDefault(_web3CoreMethod);
var MethodFn = (0, _web3CoreMethodDefault.default);
function patchEnableCustomRPC(web3) {
    web3.eth.customRPC = function(opts) {
        var newMethod = new MethodFn({
            name: opts.name,
            call: opts.call,
            params: opts.params || 0,
            inputFormatter: opts.inputFormatter || null,
            outputFormatter: opts.outputFormatter || null
        });
        newMethod.attachToObject(this);
        newMethod.setRequestManager(this._requestManager, this.accounts);
    };
}

},{"web3-core-method":"dlLBZ","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"dlLBZ":[function(require,module,exports) {
/*
    This file is part of web3.js.

    web3.js is free software: you can redistribute it and/or modify
    it under the terms of the GNU Lesser General Public License as published by
    the Free Software Foundation, either version 3 of the License, or
    (at your option) any later version.

    web3.js is distributed in the hope that it will be useful,
    but WITHOUT ANY WARRANTY; without even the implied warranty of
    MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
    GNU Lesser General Public License for more details.

    You should have received a copy of the GNU Lesser General Public License
    along with web3.js.  If not, see <http://www.gnu.org/licenses/>.
*/ /**
 * @file index.js
 * @author Fabian Vogelsteller <fabian@ethereum.org>
 * @author Marek Kotewicz <marek@parity.io>
 * @date 2017
 */ "use strict";
var errors = require("37aaeab935ec8820").errors;
var formatters = require("37aaeab935ec8820").formatters;
var utils = require("2a967d42186c1e8");
var promiEvent = require("45f90d93d6687be8");
var Subscriptions = require("970a33fdcb189d04").subscriptions;
var EthersTransactionUtils = require("698bef7aa4d0213d");
var Method = function Method(options) {
    if (!options.call || !options.name) throw new Error('When creating a method you need to provide at least the "name" and "call" property.');
    this.name = options.name;
    this.call = options.call;
    this.params = options.params || 0;
    this.inputFormatter = options.inputFormatter;
    this.outputFormatter = options.outputFormatter;
    this.transformPayload = options.transformPayload;
    this.extraFormatters = options.extraFormatters;
    this.abiCoder = options.abiCoder; // Will be used to encode the revert reason string
    this.requestManager = options.requestManager;
    // reference to eth.accounts
    this.accounts = options.accounts;
    this.defaultBlock = options.defaultBlock || "latest";
    this.defaultAccount = options.defaultAccount || null;
    this.transactionBlockTimeout = options.transactionBlockTimeout || 50;
    this.transactionConfirmationBlocks = options.transactionConfirmationBlocks || 24;
    this.transactionPollingTimeout = options.transactionPollingTimeout || 750;
    this.transactionPollingInterval = options.transactionPollingInterval || 1000;
    this.blockHeaderTimeout = options.blockHeaderTimeout || 10; // 10 seconds
    this.defaultCommon = options.defaultCommon;
    this.defaultChain = options.defaultChain;
    this.defaultHardfork = options.defaultHardfork;
    this.handleRevert = options.handleRevert;
};
Method.prototype.setRequestManager = function(requestManager, accounts) {
    this.requestManager = requestManager;
    // reference to eth.accounts
    if (accounts) this.accounts = accounts;
};
Method.prototype.createFunction = function(requestManager, accounts) {
    var func = this.buildCall();
    Object.defineProperty(func, "call", {
        configurable: true,
        writable: true,
        value: this.call
    });
    this.setRequestManager(requestManager || this.requestManager, accounts || this.accounts);
    return func;
};
Method.prototype.attachToObject = function(obj) {
    var func = this.buildCall();
    Object.defineProperty(func, "call", {
        configurable: true,
        writable: true,
        value: this.call
    });
    var name = this.name.split(".");
    if (name.length > 1) {
        obj[name[0]] = obj[name[0]] || {};
        obj[name[0]][name[1]] = func;
    } else obj[name[0]] = func;
};
/**
 * Should be used to determine name of the jsonrpc method based on arguments
 *
 * @method getCall
 * @param {Array} arguments
 * @return {String} name of jsonrpc method
 */ Method.prototype.getCall = function(args) {
    return typeof this.call === "function" ? this.call(args) : this.call;
};
/**
 * Should be used to extract callback from array of arguments. Modifies input param
 *
 * @method extractCallback
 * @param {Array} arguments
 * @return {Function|Null} callback, if exists
 */ Method.prototype.extractCallback = function(args) {
    if (typeof args[args.length - 1] === "function") return args.pop(); // modify the args array!
};
/**
 * Should be called to check if the number of arguments is correct
 *
 * @method validateArgs
 * @param {Array} arguments
 * @throws {Error} if it is not
 */ Method.prototype.validateArgs = function(args) {
    if (args.length !== this.params) throw errors.InvalidNumberOfParams(args.length, this.params, this.name);
};
/**
 * Should be called to format input args of method
 *
 * @method formatInput
 * @param {Array}
 * @return {Array}
 */ Method.prototype.formatInput = function(args) {
    var _this = this;
    if (!this.inputFormatter) return args;
    return this.inputFormatter.map(function(formatter, index) {
        // bind this for defaultBlock, and defaultAccount
        return formatter ? formatter.call(_this, args[index]) : args[index];
    });
};
/**
 * Should be called to format output(result) of method
 *
 * @method formatOutput
 * @param {Object}
 * @return {Object}
 */ Method.prototype.formatOutput = function(result) {
    var _this = this;
    if (Array.isArray(result)) return result.map(function(res) {
        return _this.outputFormatter && res ? _this.outputFormatter(res, this?.hexFormat) : res;
    });
    else return this.outputFormatter && result ? this.outputFormatter(result, this?.hexFormat) : result;
};
/**
 * Should create payload from given input args
 *
 * @method toPayload
 * @param {Array} args
 * @return {Object}
 */ Method.prototype.toPayload = function(args) {
    var call = this.getCall(args);
    var callback = this.extractCallback(args);
    var params = this.formatInput(args);
    this.validateArgs(params);
    var payload = {
        method: call,
        params: params,
        callback: callback
    };
    if (this.transformPayload) payload = this.transformPayload(payload);
    return payload;
};
Method.prototype._confirmTransaction = function(defer, result, payload) {
    var method = this, promiseResolved = false, canUnsubscribe = true, timeoutCount = 0, confirmationCount = 0, intervalId = null, blockHeaderTimeoutId = null, lastBlock = null, receiptJSON = "", gasProvided = !!payload.params[0] && typeof payload.params[0] === "object" && payload.params[0].gas ? payload.params[0].gas : null, isContractDeployment = !!payload.params[0] && typeof payload.params[0] === "object" && payload.params[0].data && payload.params[0].from && !payload.params[0].to, hasBytecode = isContractDeployment && payload.params[0].data.length > 2;
    // add custom send Methods
    var _ethereumCalls = [
        new Method({
            name: "getBlockByNumber",
            call: "eth_getBlockByNumber",
            params: 2,
            inputFormatter: [
                formatters.inputBlockNumberFormatter,
                function(val) {
                    return !!val;
                }
            ],
            outputFormatter: formatters.outputBlockFormatter
        }),
        new Method({
            name: "getTransactionReceipt",
            call: "eth_getTransactionReceipt",
            params: 1,
            inputFormatter: [
                null
            ],
            outputFormatter: formatters.outputTransactionReceiptFormatter
        }),
        new Method({
            name: "getCode",
            call: "eth_getCode",
            params: 2,
            inputFormatter: [
                formatters.inputAddressFormatter,
                formatters.inputDefaultBlockNumberFormatter
            ]
        }),
        new Method({
            name: "getTransactionByHash",
            call: "eth_getTransactionByHash",
            params: 1,
            inputFormatter: [
                null
            ],
            outputFormatter: formatters.outputTransactionFormatter
        }),
        new Subscriptions({
            name: "subscribe",
            type: "eth",
            subscriptions: {
                "newBlockHeaders": {
                    subscriptionName: "newHeads",
                    params: 0,
                    outputFormatter: formatters.outputBlockFormatter
                }
            }
        })
    ];
    // attach methods to this._ethereumCall
    var _ethereumCall = {};
    _ethereumCalls.forEach((mthd)=>{
        mthd.attachToObject(_ethereumCall);
        mthd.requestManager = method.requestManager; // assign rather than call setRequestManager()
    });
    // fire "receipt" and confirmation events and resolve after
    var checkConfirmation = function(existingReceipt, isPolling, err, blockHeader, sub) {
        if (!err) {
            // create fake unsubscribe
            if (!sub) sub = {
                unsubscribe: function() {
                    clearInterval(intervalId);
                    clearTimeout(blockHeaderTimeoutId);
                }
            };
            // if we have a valid receipt we don't need to send a request
            return (existingReceipt ? promiEvent.resolve(existingReceipt) : _ethereumCall.getTransactionReceipt(result))// catch error from requesting receipt
            .catch(function(err) {
                sub.unsubscribe();
                promiseResolved = true;
                utils._fireError({
                    message: "Failed to check for transaction receipt:",
                    data: err
                }, defer.eventEmitter, defer.reject);
            })// if CONFIRMATION listener exists check for confirmations, by setting canUnsubscribe = false
            .then(async function(receipt) {
                if (!receipt || !receipt.blockHash) throw new Error("Receipt missing or blockHash null");
                // apply extra formatters
                if (method.extraFormatters && method.extraFormatters.receiptFormatter) receipt = method.extraFormatters.receiptFormatter(receipt);
                // check if confirmation listener exists
                if (defer.eventEmitter.listeners("confirmation").length > 0) {
                    var block;
                    // If there was an immediately retrieved receipt, it's already
                    // been confirmed by the direct call to checkConfirmation needed
                    // for parity instant-seal
                    if (existingReceipt === undefined || confirmationCount !== 0) {
                        // Get latest block to emit with confirmation
                        var latestBlock = await _ethereumCall.getBlockByNumber("latest");
                        var latestBlockHash = latestBlock ? latestBlock.hash : null;
                        if (isPolling) {
                            if (lastBlock) {
                                block = await _ethereumCall.getBlockByNumber(lastBlock.number + 1);
                                if (block) {
                                    lastBlock = block;
                                    defer.eventEmitter.emit("confirmation", confirmationCount, receipt, latestBlockHash);
                                }
                            } else {
                                block = await _ethereumCall.getBlockByNumber(receipt.blockNumber);
                                lastBlock = block;
                                defer.eventEmitter.emit("confirmation", confirmationCount, receipt, latestBlockHash);
                            }
                        } else defer.eventEmitter.emit("confirmation", confirmationCount, receipt, latestBlockHash);
                    }
                    if (isPolling && block || !isPolling) confirmationCount++;
                    canUnsubscribe = false;
                    if (confirmationCount === method.transactionConfirmationBlocks + 1) {
                        sub.unsubscribe();
                        defer.eventEmitter.removeAllListeners();
                    }
                }
                return receipt;
            })// CHECK for CONTRACT DEPLOYMENT
            .then(async function(receipt) {
                if (isContractDeployment && !promiseResolved) {
                    if (!receipt.contractAddress) {
                        if (canUnsubscribe) {
                            sub.unsubscribe();
                            promiseResolved = true;
                        }
                        utils._fireError(errors.NoContractAddressFoundError(receipt), defer.eventEmitter, defer.reject, null, receipt);
                        return;
                    }
                    var code;
                    try {
                        code = await _ethereumCall.getCode(receipt.contractAddress);
                    } catch (err) {
                    // ignore;
                    }
                    if (!code) return;
                    // If deployment is status.true and there was a real
                    // bytecode string, assume it was successful.
                    var deploymentSuccess = receipt.status === true && hasBytecode;
                    if (deploymentSuccess || code.length > 2) {
                        defer.eventEmitter.emit("receipt", receipt);
                        // if contract, return instance instead of receipt
                        if (method.extraFormatters && method.extraFormatters.contractDeployFormatter) defer.resolve(method.extraFormatters.contractDeployFormatter(receipt));
                        else defer.resolve(receipt);
                        // need to remove listeners, as they aren't removed automatically when succesfull
                        if (canUnsubscribe) defer.eventEmitter.removeAllListeners();
                    } else utils._fireError(errors.ContractCodeNotStoredError(receipt), defer.eventEmitter, defer.reject, null, receipt);
                    if (canUnsubscribe) sub.unsubscribe();
                    promiseResolved = true;
                }
                return receipt;
            })// CHECK for normal tx check for receipt only
            .then(async function(receipt) {
                if (!isContractDeployment && !promiseResolved) {
                    if (!receipt.outOfGas && (!gasProvided || gasProvided !== receipt.gasUsed) && (receipt.status === true || receipt.status === "0x1" || typeof receipt.status === "undefined")) {
                        defer.eventEmitter.emit("receipt", receipt);
                        defer.resolve(receipt);
                        // need to remove listeners, as they aren't removed automatically when succesfull
                        if (canUnsubscribe) defer.eventEmitter.removeAllListeners();
                    } else {
                        receiptJSON = JSON.stringify(receipt, null, 2);
                        if (receipt.status === false || receipt.status === "0x0") try {
                            var revertMessage = null;
                            if (method.handleRevert && (method.call === "eth_sendTransaction" || method.call === "eth_sendRawTransaction")) {
                                var txReplayOptions = payload.params[0];
                                // If send was raw, fetch the transaction and reconstitute the
                                // original params so they can be replayed with `eth_call`
                                if (method.call === "eth_sendRawTransaction") {
                                    var rawTransactionHex = payload.params[0];
                                    var parsedTx = EthersTransactionUtils.parse(rawTransactionHex);
                                    txReplayOptions = formatters.inputTransactionFormatter({
                                        data: parsedTx.data,
                                        to: parsedTx.to,
                                        from: parsedTx.from,
                                        gas: parsedTx.gasLimit.toHexString(),
                                        gasPrice: parsedTx.gasPrice ? parsedTx.gasPrice.toHexString() : undefined,
                                        value: parsedTx.value.toHexString()
                                    });
                                }
                                // Get revert reason string with eth_call
                                revertMessage = await method.getRevertReason(txReplayOptions, receipt.blockNumber);
                                if (revertMessage) utils._fireError(errors.TransactionRevertInstructionError(revertMessage.reason, revertMessage.signature, receipt), defer.eventEmitter, defer.reject, null, receipt);
                                else throw false; // Throw false and let the try/catch statement handle the error correctly after
                            } else throw false; // Throw false and let the try/catch statement handle the error correctly after
                        } catch (error) {
                            // Throw an normal revert error if no revert reason is given or the detection of it is disabled
                            utils._fireError(errors.TransactionRevertedWithoutReasonError(receipt), defer.eventEmitter, defer.reject, null, receipt);
                        }
                        else // Throw OOG if status is not existing and provided gas and used gas are equal
                        utils._fireError(errors.TransactionOutOfGasError(receipt), defer.eventEmitter, defer.reject, null, receipt);
                    }
                    if (canUnsubscribe) sub.unsubscribe();
                    promiseResolved = true;
                }
            })// time out the transaction if not mined after 50 blocks
            .catch(function() {
                timeoutCount++;
                // check to see if we are http polling
                if (!!isPolling) // polling timeout is different than transactionBlockTimeout blocks since we are triggering every second
                {
                    if (timeoutCount - 1 >= method.transactionPollingTimeout) {
                        sub.unsubscribe();
                        promiseResolved = true;
                        utils._fireError(errors.TransactionError("Transaction was not mined within " + method.transactionPollingTimeout + " seconds, please make sure your transaction was properly sent. Be aware that it might still be mined!"), defer.eventEmitter, defer.reject);
                    }
                } else if (timeoutCount - 1 >= method.transactionBlockTimeout) {
                    sub.unsubscribe();
                    promiseResolved = true;
                    utils._fireError(errors.TransactionError("Transaction was not mined within " + method.transactionBlockTimeout + " blocks, please make sure your transaction was properly sent. Be aware that it might still be mined!"), defer.eventEmitter, defer.reject);
                }
            });
        } else {
            sub.unsubscribe();
            promiseResolved = true;
            utils._fireError({
                message: "Failed to subscribe to new newBlockHeaders to confirm the transaction receipts.",
                data: err
            }, defer.eventEmitter, defer.reject);
        }
    };
    // start watching for confirmation depending on the support features of the provider
    var startWatching = (function(existingReceipt) {
        let blockHeaderArrived = false;
        const startInterval = ()=>{
            intervalId = setInterval(checkConfirmation.bind(null, existingReceipt, true), method.transactionPollingInterval);
        };
        // If provider do not support event subscription use polling
        if (!this.requestManager.provider.on) return startInterval();
        // Subscribe to new block headers to look for tx receipt
        _ethereumCall.subscribe("newBlockHeaders", function(err, blockHeader, sub) {
            blockHeaderArrived = true;
            if (err || !blockHeader) // fall back to polling
            return startInterval();
            checkConfirmation(existingReceipt, false, err, blockHeader, sub);
        });
        // Fallback to polling if tx receipt didn't arrived in "blockHeaderTimeout" [10 seconds]
        blockHeaderTimeoutId = setTimeout(()=>{
            if (!blockHeaderArrived) startInterval();
        }, this.blockHeaderTimeout * 1000);
    }).bind(this);
    // first check if we already have a confirmed transaction
    _ethereumCall.getTransactionReceipt(result).then(function(receipt) {
        if (receipt && receipt.blockHash) {
            if (defer.eventEmitter.listeners("confirmation").length > 0) // We must keep on watching for new Blocks, if a confirmation listener is present
            startWatching(receipt);
            checkConfirmation(receipt, false);
        } else if (!promiseResolved) startWatching();
    }).catch(function() {
        if (!promiseResolved) startWatching();
    });
};
var getWallet = function(from, accounts) {
    var wallet = null;
    // is index given
    if (typeof from === "number") wallet = accounts.wallet[from];
    else if (!!from && typeof from === "object" && from.address && from.privateKey) wallet = from;
    else wallet = accounts.wallet[from.toLowerCase()];
    return wallet;
};
Method.prototype.buildCall = function() {
    var method = this, isSendTx = method.call === "eth_sendTransaction" || method.call === "eth_sendRawTransaction", isCall = method.call === "eth_call";
    // actual send function
    var send = function() {
        let args = Array.prototype.slice.call(arguments);
        var defer = promiEvent(!isSendTx), payload = method.toPayload(args);
        method.hexFormat = false;
        if (method.call === "eth_getTransactionReceipt" || method.call === "eth_getTransactionByHash" || method.name === "getBlock") method.hexFormat = payload.params.length < args.length && args[args.length - 1] === "hex";
        // CALLBACK function
        var sendTxCallback = function(err, result) {
            if (method.handleRevert && isCall && method.abiCoder) {
                var reasonData;
                // Ganache / Geth <= 1.9.13 return the reason data as a successful eth_call response
                // Geth >= 1.9.15 attaches the reason data to an error object.
                // Geth 1.9.14 is missing revert reason (https://github.com/ethereum/web3.js/issues/3520)
                if (!err && method.isRevertReasonString(result)) reasonData = result.substring(10);
                else if (err && err.data) {
                    // workaround embedded error details got from some providers like MetaMask
                    if (typeof err.data === "object") {
                        // Ganache has no `originalError` sub-object unlike others
                        var originalError = err.data.originalError ?? err.data;
                        reasonData = originalError.data.substring(10);
                    } else reasonData = err.data.substring(10);
                }
                if (reasonData) {
                    var reason = method.abiCoder.decodeParameter("string", "0x" + reasonData);
                    var signature = "Error(String)";
                    utils._fireError(errors.RevertInstructionError(reason, signature), defer.eventEmitter, defer.reject, payload.callback, {
                        reason: reason,
                        signature: signature
                    });
                    return;
                }
            }
            try {
                result = method.formatOutput(result);
            } catch (e) {
                err = e;
            }
            if (result instanceof Error) err = result;
            if (!err) {
                if (payload.callback) payload.callback(null, result);
            } else {
                if (err.error) err = err.error;
                return utils._fireError(err, defer.eventEmitter, defer.reject, payload.callback);
            }
            // return PROMISE
            if (!isSendTx) {
                if (!err) defer.resolve(result);
            } else {
                defer.eventEmitter.emit("transactionHash", result);
                method._confirmTransaction(defer, result, payload);
            }
        };
        // SENDS the SIGNED SIGNATURE
        var sendSignedTx = function(sign) {
            var signedPayload = {
                ...payload,
                method: "eth_sendRawTransaction",
                params: [
                    sign.rawTransaction
                ]
            };
            method.requestManager.send(signedPayload, sendTxCallback);
        };
        var sendRequest = function(payload, method) {
            if (method && method.accounts && method.accounts.wallet && method.accounts.wallet.length) {
                var wallet;
                // ETH_SENDTRANSACTION
                if (payload.method === "eth_sendTransaction") {
                    var tx = payload.params[0];
                    wallet = getWallet(!!tx && typeof tx === "object" ? tx.from : null, method.accounts);
                    // If wallet was found, sign tx, and send using sendRawTransaction
                    if (wallet && wallet.privateKey) {
                        var tx = JSON.parse(JSON.stringify(tx));
                        delete tx.from;
                        if (method.defaultChain && !tx.chain) tx.chain = method.defaultChain;
                        if (method.defaultHardfork && !tx.hardfork) tx.hardfork = method.defaultHardfork;
                        if (method.defaultCommon && !tx.common) tx.common = method.defaultCommon;
                        method.accounts.signTransaction(tx, wallet.privateKey).then(sendSignedTx).catch(function(err) {
                            if (typeof defer.eventEmitter.listeners === "function" && defer.eventEmitter.listeners("error").length) {
                                try {
                                    defer.eventEmitter.emit("error", err);
                                } catch (err) {
                                // Ignore userland error prevent it to bubble up within web3.
                                }
                                defer.eventEmitter.removeAllListeners();
                                defer.eventEmitter.catch(function() {});
                            }
                            defer.reject(err);
                        });
                        return;
                    }
                // ETH_SIGN
                } else if (payload.method === "eth_sign") {
                    var data = payload.params[1];
                    wallet = getWallet(payload.params[0], method.accounts);
                    // If wallet was found, sign tx, and send using sendRawTransaction
                    if (wallet && wallet.privateKey) {
                        var sign = method.accounts.sign(data, wallet.privateKey);
                        if (payload.callback) payload.callback(null, sign.signature);
                        defer.resolve(sign.signature);
                        return;
                    }
                }
            }
            return method.requestManager.send(payload, sendTxCallback);
        };
        const hasSendTxObject = isSendTx && !!payload.params[0] && typeof payload.params[0] === "object";
        if (hasSendTxObject && payload.params[0].type === "0x1" && typeof payload.params[0].accessList === "undefined") payload.params[0].accessList = [];
        // Send the actual transaction
        if (hasSendTxObject && typeof payload.params[0].gasPrice === "undefined" && (typeof payload.params[0].maxPriorityFeePerGas === "undefined" || typeof payload.params[0].maxFeePerGas === "undefined")) _handleTxPricing(method, payload.params[0]).then((txPricing)=>{
            if (txPricing.gasPrice !== undefined) payload.params[0].gasPrice = txPricing.gasPrice;
            else if (txPricing.maxPriorityFeePerGas !== undefined && txPricing.maxFeePerGas !== undefined) {
                payload.params[0].maxPriorityFeePerGas = txPricing.maxPriorityFeePerGas;
                payload.params[0].maxFeePerGas = txPricing.maxFeePerGas;
            }
            if (isSendTx) setTimeout(()=>{
                defer.eventEmitter.emit("sending", payload);
            }, 0);
            sendRequest(payload, method);
        });
        else {
            if (isSendTx) setTimeout(()=>{
                defer.eventEmitter.emit("sending", payload);
            }, 0);
            sendRequest(payload, method);
        }
        if (isSendTx) setTimeout(()=>{
            defer.eventEmitter.emit("sent", payload);
        }, 0);
        return defer.eventEmitter;
    };
    // necessary to attach things to the method
    send.method = method;
    // necessary for batch requests
    send.request = this.request.bind(this);
    return send;
};
function _handleTxPricing(method, tx) {
    return new Promise((resolve, reject)=>{
        try {
            var getBlockByNumber = new Method({
                name: "getBlockByNumber",
                call: "eth_getBlockByNumber",
                params: 2,
                inputFormatter: [
                    function(blockNumber) {
                        return blockNumber ? utils.toHex(blockNumber) : "latest";
                    },
                    function() {
                        return false;
                    }
                ]
            }).createFunction(method.requestManager);
            var getGasPrice = new Method({
                name: "getGasPrice",
                call: "eth_gasPrice",
                params: 0
            }).createFunction(method.requestManager);
            Promise.all([
                getBlockByNumber(),
                getGasPrice()
            ]).then((responses)=>{
                const [block, gasPrice] = responses;
                if ((tx.type === "0x2" || tx.type === undefined) && block && block.baseFeePerGas) {
                    // The network supports EIP-1559
                    // Taken from https://github.com/ethers-io/ethers.js/blob/ba6854bdd5a912fe873d5da494cb5c62c190adde/packages/abstract-provider/src.ts/index.ts#L230
                    let maxPriorityFeePerGas, maxFeePerGas;
                    if (tx.gasPrice) {
                        // Using legacy gasPrice property on an eip-1559 network,
                        // so use gasPrice as both fee properties
                        maxPriorityFeePerGas = tx.gasPrice;
                        maxFeePerGas = tx.gasPrice;
                        delete tx.gasPrice;
                    } else {
                        maxPriorityFeePerGas = tx.maxPriorityFeePerGas || "0x9502F900"; // 2.5 Gwei
                        maxFeePerGas = tx.maxFeePerGas || utils.toHex(utils.toBN(block.baseFeePerGas).mul(utils.toBN(2)).add(utils.toBN(maxPriorityFeePerGas)));
                    }
                    resolve({
                        maxFeePerGas,
                        maxPriorityFeePerGas
                    });
                } else {
                    if (tx.maxPriorityFeePerGas || tx.maxFeePerGas) throw Error("Network doesn't support eip-1559");
                    resolve({
                        gasPrice
                    });
                }
            });
        } catch (error) {
            reject(error);
        }
    });
}
/**
 * Returns the revert reason string if existing or otherwise false.
 *
 * @method getRevertReason
 *
 * @param {Object} txOptions
 * @param {Number} blockNumber
 *
 * @returns {Promise<Boolean|String>}
 */ Method.prototype.getRevertReason = function(txOptions, blockNumber) {
    var self = this;
    return new Promise(function(resolve, reject) {
        new Method({
            name: "call",
            call: "eth_call",
            params: 2,
            abiCoder: self.abiCoder,
            handleRevert: true
        }).createFunction(self.requestManager)(txOptions, utils.numberToHex(blockNumber)).then(function() {
            resolve(false);
        }).catch(function(error) {
            if (error.reason) resolve({
                reason: error.reason,
                signature: error.signature
            });
            else reject(error);
        });
    });
};
/**
 * Checks if the given hex string is a revert message from the EVM
 *
 * @method isRevertReasonString
 *
 * @param {String} data - Hex string prefixed with 0x
 *
 * @returns {Boolean}
 */ Method.prototype.isRevertReasonString = function(data) {
    return typeof data === "string" && (data.length - 2) / 2 % 32 === 4 && data.substring(0, 10) === "0x08c379a0";
};
/**
 * Should be called to create the pure JSONRPC request which can be used in a batch request
 *
 * @method request
 * @return {Object} jsonrpc request
 */ Method.prototype.request = function() {
    var payload = this.toPayload(Array.prototype.slice.call(arguments));
    payload.format = this.formatOutput.bind(this);
    return payload;
};
module.exports = Method;

},{"37aaeab935ec8820":"9k0nb","2a967d42186c1e8":"ePzmI","45f90d93d6687be8":"6cJA1","970a33fdcb189d04":"393J3","698bef7aa4d0213d":"iweSA"}],"6cJA1":[function(require,module,exports) {
/*
 This file is part of web3.js.

 web3.js is free software: you can redistribute it and/or modify
 it under the terms of the GNU Lesser General Public License as published by
 the Free Software Foundation, either version 3 of the License, or
 (at your option) any later version.

 web3.js is distributed in the hope that it will be useful,
 but WITHOUT ANY WARRANTY; without even the implied warranty of
 MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 GNU Lesser General Public License for more details.

 You should have received a copy of the GNU Lesser General Public License
 along with web3.js.  If not, see <http://www.gnu.org/licenses/>.
 */ /**
 * @file index.js
 * @author Fabian Vogelsteller <fabian@ethereum.org>
 * @date 2016
 */ "use strict";
var EventEmitter = require("506fcfcfc7aeb28");
/**
 * This function generates a defer promise and adds eventEmitter functionality to it
 *
 * @method eventifiedPromise
 */ var PromiEvent = function PromiEvent(justPromise) {
    var resolve, reject, eventEmitter = new Promise(function() {
        resolve = arguments[0];
        reject = arguments[1];
    });
    if (justPromise) return {
        resolve: resolve,
        reject: reject,
        eventEmitter: eventEmitter
    };
    // get eventEmitter
    var emitter = new EventEmitter();
    // add eventEmitter to the promise
    eventEmitter._events = emitter._events;
    eventEmitter.emit = emitter.emit;
    eventEmitter.on = emitter.on;
    eventEmitter.once = emitter.once;
    eventEmitter.off = emitter.off;
    eventEmitter.listeners = emitter.listeners;
    eventEmitter.addListener = emitter.addListener;
    eventEmitter.removeListener = emitter.removeListener;
    eventEmitter.removeAllListeners = emitter.removeAllListeners;
    return {
        resolve: resolve,
        reject: reject,
        eventEmitter: eventEmitter
    };
};
PromiEvent.resolve = function(value) {
    var promise = PromiEvent(true);
    promise.resolve(value);
    return promise.eventEmitter;
};
module.exports = PromiEvent;

},{"506fcfcfc7aeb28":"aUdrT"}],"aUdrT":[function(require,module,exports) {
"use strict";
var has = Object.prototype.hasOwnProperty, prefix = "~";
/**
 * Constructor to create a storage for our `EE` objects.
 * An `Events` instance is a plain object whose properties are event names.
 *
 * @constructor
 * @private
 */ function Events() {}
//
// We try to not inherit from `Object.prototype`. In some engines creating an
// instance in this way is faster than calling `Object.create(null)` directly.
// If `Object.create(null)` is not supported we prefix the event names with a
// character to make sure that the built-in object properties are not
// overridden or used as an attack vector.
//
if (Object.create) {
    Events.prototype = Object.create(null);
    //
    // This hack is needed because the `__proto__` property is still inherited in
    // some old browsers like Android 4, iPhone 5.1, Opera 11 and Safari 5.
    //
    if (!new Events().__proto__) prefix = false;
}
/**
 * Representation of a single event listener.
 *
 * @param {Function} fn The listener function.
 * @param {*} context The context to invoke the listener with.
 * @param {Boolean} [once=false] Specify if the listener is a one-time listener.
 * @constructor
 * @private
 */ function EE(fn, context, once) {
    this.fn = fn;
    this.context = context;
    this.once = once || false;
}
/**
 * Add a listener for a given event.
 *
 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} context The context to invoke the listener with.
 * @param {Boolean} once Specify if the listener is a one-time listener.
 * @returns {EventEmitter}
 * @private
 */ function addListener(emitter, event, fn, context, once) {
    if (typeof fn !== "function") throw new TypeError("The listener must be a function");
    var listener = new EE(fn, context || emitter, once), evt = prefix ? prefix + event : event;
    if (!emitter._events[evt]) emitter._events[evt] = listener, emitter._eventsCount++;
    else if (!emitter._events[evt].fn) emitter._events[evt].push(listener);
    else emitter._events[evt] = [
        emitter._events[evt],
        listener
    ];
    return emitter;
}
/**
 * Clear event by name.
 *
 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
 * @param {(String|Symbol)} evt The Event name.
 * @private
 */ function clearEvent(emitter, evt) {
    if (--emitter._eventsCount === 0) emitter._events = new Events();
    else delete emitter._events[evt];
}
/**
 * Minimal `EventEmitter` interface that is molded against the Node.js
 * `EventEmitter` interface.
 *
 * @constructor
 * @public
 */ function EventEmitter() {
    this._events = new Events();
    this._eventsCount = 0;
}
/**
 * Return an array listing the events for which the emitter has registered
 * listeners.
 *
 * @returns {Array}
 * @public
 */ EventEmitter.prototype.eventNames = function eventNames() {
    var names = [], events, name;
    if (this._eventsCount === 0) return names;
    for(name in events = this._events)if (has.call(events, name)) names.push(prefix ? name.slice(1) : name);
    if (Object.getOwnPropertySymbols) return names.concat(Object.getOwnPropertySymbols(events));
    return names;
};
/**
 * Return the listeners registered for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Array} The registered listeners.
 * @public
 */ EventEmitter.prototype.listeners = function listeners(event) {
    var evt = prefix ? prefix + event : event, handlers = this._events[evt];
    if (!handlers) return [];
    if (handlers.fn) return [
        handlers.fn
    ];
    for(var i = 0, l = handlers.length, ee = new Array(l); i < l; i++)ee[i] = handlers[i].fn;
    return ee;
};
/**
 * Return the number of listeners listening to a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Number} The number of listeners.
 * @public
 */ EventEmitter.prototype.listenerCount = function listenerCount(event) {
    var evt = prefix ? prefix + event : event, listeners = this._events[evt];
    if (!listeners) return 0;
    if (listeners.fn) return 1;
    return listeners.length;
};
/**
 * Calls each of the listeners registered for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Boolean} `true` if the event had listeners, else `false`.
 * @public
 */ EventEmitter.prototype.emit = function emit(event, a1, a2, a3, a4, a5) {
    var evt = prefix ? prefix + event : event;
    if (!this._events[evt]) return false;
    var listeners = this._events[evt], len = arguments.length, args, i;
    if (listeners.fn) {
        if (listeners.once) this.removeListener(event, listeners.fn, undefined, true);
        switch(len){
            case 1:
                return listeners.fn.call(listeners.context), true;
            case 2:
                return listeners.fn.call(listeners.context, a1), true;
            case 3:
                return listeners.fn.call(listeners.context, a1, a2), true;
            case 4:
                return listeners.fn.call(listeners.context, a1, a2, a3), true;
            case 5:
                return listeners.fn.call(listeners.context, a1, a2, a3, a4), true;
            case 6:
                return listeners.fn.call(listeners.context, a1, a2, a3, a4, a5), true;
        }
        for(i = 1, args = new Array(len - 1); i < len; i++)args[i - 1] = arguments[i];
        listeners.fn.apply(listeners.context, args);
    } else {
        var length = listeners.length, j;
        for(i = 0; i < length; i++){
            if (listeners[i].once) this.removeListener(event, listeners[i].fn, undefined, true);
            switch(len){
                case 1:
                    listeners[i].fn.call(listeners[i].context);
                    break;
                case 2:
                    listeners[i].fn.call(listeners[i].context, a1);
                    break;
                case 3:
                    listeners[i].fn.call(listeners[i].context, a1, a2);
                    break;
                case 4:
                    listeners[i].fn.call(listeners[i].context, a1, a2, a3);
                    break;
                default:
                    if (!args) for(j = 1, args = new Array(len - 1); j < len; j++)args[j - 1] = arguments[j];
                    listeners[i].fn.apply(listeners[i].context, args);
            }
        }
    }
    return true;
};
/**
 * Add a listener for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @public
 */ EventEmitter.prototype.on = function on(event, fn, context) {
    return addListener(this, event, fn, context, false);
};
/**
 * Add a one-time listener for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @public
 */ EventEmitter.prototype.once = function once(event, fn, context) {
    return addListener(this, event, fn, context, true);
};
/**
 * Remove the listeners of a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn Only remove the listeners that match this function.
 * @param {*} context Only remove the listeners that have this context.
 * @param {Boolean} once Only remove one-time listeners.
 * @returns {EventEmitter} `this`.
 * @public
 */ EventEmitter.prototype.removeListener = function removeListener(event, fn, context, once) {
    var evt = prefix ? prefix + event : event;
    if (!this._events[evt]) return this;
    if (!fn) {
        clearEvent(this, evt);
        return this;
    }
    var listeners = this._events[evt];
    if (listeners.fn) {
        if (listeners.fn === fn && (!once || listeners.once) && (!context || listeners.context === context)) clearEvent(this, evt);
    } else {
        for(var i = 0, events = [], length = listeners.length; i < length; i++)if (listeners[i].fn !== fn || once && !listeners[i].once || context && listeners[i].context !== context) events.push(listeners[i]);
        //
        // Reset the array, or remove it completely if we have no more listeners.
        //
        if (events.length) this._events[evt] = events.length === 1 ? events[0] : events;
        else clearEvent(this, evt);
    }
    return this;
};
/**
 * Remove all listeners, or those of the specified event.
 *
 * @param {(String|Symbol)} [event] The event name.
 * @returns {EventEmitter} `this`.
 * @public
 */ EventEmitter.prototype.removeAllListeners = function removeAllListeners(event) {
    var evt;
    if (event) {
        evt = prefix ? prefix + event : event;
        if (this._events[evt]) clearEvent(this, evt);
    } else {
        this._events = new Events();
        this._eventsCount = 0;
    }
    return this;
};
//
// Alias methods names because people roll like that.
//
EventEmitter.prototype.off = EventEmitter.prototype.removeListener;
EventEmitter.prototype.addListener = EventEmitter.prototype.on;
//
// Expose the prefix.
//
EventEmitter.prefixed = prefix;
//
// Allow `EventEmitter` to be imported as module namespace.
//
EventEmitter.EventEmitter = EventEmitter;
module.exports = EventEmitter;

},{}],"iweSA":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TransactionTypes", ()=>TransactionTypes);
parcelHelpers.export(exports, "computeAddress", ()=>computeAddress);
parcelHelpers.export(exports, "recoverAddress", ()=>recoverAddress);
parcelHelpers.export(exports, "accessListify", ()=>accessListify);
parcelHelpers.export(exports, "serialize", ()=>serialize);
parcelHelpers.export(exports, "parse", ()=>parse);
var _address = require("@ethersproject/address");
var _bignumber = require("@ethersproject/bignumber");
var _bytes = require("@ethersproject/bytes");
var _constants = require("@ethersproject/constants");
var _keccak256 = require("@ethersproject/keccak256");
var _properties = require("@ethersproject/properties");
var _rlp = require("@ethersproject/rlp");
var _signingKey = require("@ethersproject/signing-key");
var _logger = require("@ethersproject/logger");
var _version = require("./_version");
"use strict";
const logger = new (0, _logger.Logger)((0, _version.version));
var TransactionTypes;
(function(TransactionTypes) {
    TransactionTypes[TransactionTypes["legacy"] = 0] = "legacy";
    TransactionTypes[TransactionTypes["eip2930"] = 1] = "eip2930";
    TransactionTypes[TransactionTypes["eip1559"] = 2] = "eip1559";
})(TransactionTypes || (TransactionTypes = {}));
///////////////////////////////
function handleAddress(value) {
    if (value === "0x") return null;
    return (0, _address.getAddress)(value);
}
function handleNumber(value) {
    if (value === "0x") return 0, _constants.Zero;
    return (0, _bignumber.BigNumber).from(value);
}
// Legacy Transaction Fields
const transactionFields = [
    {
        name: "nonce",
        maxLength: 32,
        numeric: true
    },
    {
        name: "gasPrice",
        maxLength: 32,
        numeric: true
    },
    {
        name: "gasLimit",
        maxLength: 32,
        numeric: true
    },
    {
        name: "to",
        length: 20
    },
    {
        name: "value",
        maxLength: 32,
        numeric: true
    },
    {
        name: "data"
    }
];
const allowedTransactionKeys = {
    chainId: true,
    data: true,
    gasLimit: true,
    gasPrice: true,
    nonce: true,
    to: true,
    type: true,
    value: true
};
function computeAddress(key) {
    const publicKey = (0, _signingKey.computePublicKey)(key);
    return (0, _address.getAddress)((0, _bytes.hexDataSlice)((0, _keccak256.keccak256)((0, _bytes.hexDataSlice)(publicKey, 1)), 12));
}
function recoverAddress(digest, signature) {
    return computeAddress((0, _signingKey.recoverPublicKey)((0, _bytes.arrayify)(digest), signature));
}
function formatNumber(value, name) {
    const result = (0, _bytes.stripZeros)((0, _bignumber.BigNumber).from(value).toHexString());
    if (result.length > 32) logger.throwArgumentError("invalid length for " + name, "transaction:" + name, value);
    return result;
}
function accessSetify(addr, storageKeys) {
    return {
        address: (0, _address.getAddress)(addr),
        storageKeys: (storageKeys || []).map((storageKey, index)=>{
            if ((0, _bytes.hexDataLength)(storageKey) !== 32) logger.throwArgumentError("invalid access list storageKey", `accessList[${addr}:${index}]`, storageKey);
            return storageKey.toLowerCase();
        })
    };
}
function accessListify(value) {
    if (Array.isArray(value)) return value.map((set, index)=>{
        if (Array.isArray(set)) {
            if (set.length > 2) logger.throwArgumentError("access list expected to be [ address, storageKeys[] ]", `value[${index}]`, set);
            return accessSetify(set[0], set[1]);
        }
        return accessSetify(set.address, set.storageKeys);
    });
    const result = Object.keys(value).map((addr)=>{
        const storageKeys = value[addr].reduce((accum, storageKey)=>{
            accum[storageKey] = true;
            return accum;
        }, {});
        return accessSetify(addr, Object.keys(storageKeys).sort());
    });
    result.sort((a, b)=>a.address.localeCompare(b.address));
    return result;
}
function formatAccessList(value) {
    return accessListify(value).map((set)=>[
            set.address,
            set.storageKeys
        ]);
}
function _serializeEip1559(transaction, signature) {
    // If there is an explicit gasPrice, make sure it matches the
    // EIP-1559 fees; otherwise they may not understand what they
    // think they are setting in terms of fee.
    if (transaction.gasPrice != null) {
        const gasPrice = (0, _bignumber.BigNumber).from(transaction.gasPrice);
        const maxFeePerGas = (0, _bignumber.BigNumber).from(transaction.maxFeePerGas || 0);
        if (!gasPrice.eq(maxFeePerGas)) logger.throwArgumentError("mismatch EIP-1559 gasPrice != maxFeePerGas", "tx", {
            gasPrice,
            maxFeePerGas
        });
    }
    const fields = [
        formatNumber(transaction.chainId || 0, "chainId"),
        formatNumber(transaction.nonce || 0, "nonce"),
        formatNumber(transaction.maxPriorityFeePerGas || 0, "maxPriorityFeePerGas"),
        formatNumber(transaction.maxFeePerGas || 0, "maxFeePerGas"),
        formatNumber(transaction.gasLimit || 0, "gasLimit"),
        transaction.to != null ? (0, _address.getAddress)(transaction.to) : "0x",
        formatNumber(transaction.value || 0, "value"),
        transaction.data || "0x",
        formatAccessList(transaction.accessList || [])
    ];
    if (signature) {
        const sig = (0, _bytes.splitSignature)(signature);
        fields.push(formatNumber(sig.recoveryParam, "recoveryParam"));
        fields.push((0, _bytes.stripZeros)(sig.r));
        fields.push((0, _bytes.stripZeros)(sig.s));
    }
    return (0, _bytes.hexConcat)([
        "0x02",
        _rlp.encode(fields)
    ]);
}
function _serializeEip2930(transaction, signature) {
    const fields = [
        formatNumber(transaction.chainId || 0, "chainId"),
        formatNumber(transaction.nonce || 0, "nonce"),
        formatNumber(transaction.gasPrice || 0, "gasPrice"),
        formatNumber(transaction.gasLimit || 0, "gasLimit"),
        transaction.to != null ? (0, _address.getAddress)(transaction.to) : "0x",
        formatNumber(transaction.value || 0, "value"),
        transaction.data || "0x",
        formatAccessList(transaction.accessList || [])
    ];
    if (signature) {
        const sig = (0, _bytes.splitSignature)(signature);
        fields.push(formatNumber(sig.recoveryParam, "recoveryParam"));
        fields.push((0, _bytes.stripZeros)(sig.r));
        fields.push((0, _bytes.stripZeros)(sig.s));
    }
    return (0, _bytes.hexConcat)([
        "0x01",
        _rlp.encode(fields)
    ]);
}
// Legacy Transactions and EIP-155
function _serialize(transaction, signature) {
    (0, _properties.checkProperties)(transaction, allowedTransactionKeys);
    const raw = [];
    transactionFields.forEach(function(fieldInfo) {
        let value = transaction[fieldInfo.name] || [];
        const options = {};
        if (fieldInfo.numeric) options.hexPad = "left";
        value = (0, _bytes.arrayify)((0, _bytes.hexlify)(value, options));
        // Fixed-width field
        if (fieldInfo.length && value.length !== fieldInfo.length && value.length > 0) logger.throwArgumentError("invalid length for " + fieldInfo.name, "transaction:" + fieldInfo.name, value);
        // Variable-width (with a maximum)
        if (fieldInfo.maxLength) {
            value = (0, _bytes.stripZeros)(value);
            if (value.length > fieldInfo.maxLength) logger.throwArgumentError("invalid length for " + fieldInfo.name, "transaction:" + fieldInfo.name, value);
        }
        raw.push((0, _bytes.hexlify)(value));
    });
    let chainId = 0;
    if (transaction.chainId != null) {
        // A chainId was provided; if non-zero we'll use EIP-155
        chainId = transaction.chainId;
        if (typeof chainId !== "number") logger.throwArgumentError("invalid transaction.chainId", "transaction", transaction);
    } else if (signature && !(0, _bytes.isBytesLike)(signature) && signature.v > 28) // No chainId provided, but the signature is signing with EIP-155; derive chainId
    chainId = Math.floor((signature.v - 35) / 2);
    // We have an EIP-155 transaction (chainId was specified and non-zero)
    if (chainId !== 0) {
        raw.push((0, _bytes.hexlify)(chainId)); // @TODO: hexValue?
        raw.push("0x");
        raw.push("0x");
    }
    // Requesting an unsigned transaction
    if (!signature) return _rlp.encode(raw);
    // The splitSignature will ensure the transaction has a recoveryParam in the
    // case that the signTransaction function only adds a v.
    const sig = (0, _bytes.splitSignature)(signature);
    // We pushed a chainId and null r, s on for hashing only; remove those
    let v = 27 + sig.recoveryParam;
    if (chainId !== 0) {
        raw.pop();
        raw.pop();
        raw.pop();
        v += chainId * 2 + 8;
        // If an EIP-155 v (directly or indirectly; maybe _vs) was provided, check it!
        if (sig.v > 28 && sig.v !== v) logger.throwArgumentError("transaction.chainId/signature.v mismatch", "signature", signature);
    } else if (sig.v !== v) logger.throwArgumentError("transaction.chainId/signature.v mismatch", "signature", signature);
    raw.push((0, _bytes.hexlify)(v));
    raw.push((0, _bytes.stripZeros)((0, _bytes.arrayify)(sig.r)));
    raw.push((0, _bytes.stripZeros)((0, _bytes.arrayify)(sig.s)));
    return _rlp.encode(raw);
}
function serialize(transaction, signature) {
    // Legacy and EIP-155 Transactions
    if (transaction.type == null || transaction.type === 0) {
        if (transaction.accessList != null) logger.throwArgumentError("untyped transactions do not support accessList; include type: 1", "transaction", transaction);
        return _serialize(transaction, signature);
    }
    // Typed Transactions (EIP-2718)
    switch(transaction.type){
        case 1:
            return _serializeEip2930(transaction, signature);
        case 2:
            return _serializeEip1559(transaction, signature);
        default:
            break;
    }
    return logger.throwError(`unsupported transaction type: ${transaction.type}`, (0, _logger.Logger).errors.UNSUPPORTED_OPERATION, {
        operation: "serializeTransaction",
        transactionType: transaction.type
    });
}
function _parseEipSignature(tx, fields, serialize) {
    try {
        const recid = handleNumber(fields[0]).toNumber();
        if (recid !== 0 && recid !== 1) throw new Error("bad recid");
        tx.v = recid;
    } catch (error) {
        logger.throwArgumentError("invalid v for transaction type: 1", "v", fields[0]);
    }
    tx.r = (0, _bytes.hexZeroPad)(fields[1], 32);
    tx.s = (0, _bytes.hexZeroPad)(fields[2], 32);
    try {
        const digest = (0, _keccak256.keccak256)(serialize(tx));
        tx.from = recoverAddress(digest, {
            r: tx.r,
            s: tx.s,
            recoveryParam: tx.v
        });
    } catch (error) {}
}
function _parseEip1559(payload) {
    const transaction = _rlp.decode(payload.slice(1));
    if (transaction.length !== 9 && transaction.length !== 12) logger.throwArgumentError("invalid component count for transaction type: 2", "payload", (0, _bytes.hexlify)(payload));
    const maxPriorityFeePerGas = handleNumber(transaction[2]);
    const maxFeePerGas = handleNumber(transaction[3]);
    const tx = {
        type: 2,
        chainId: handleNumber(transaction[0]).toNumber(),
        nonce: handleNumber(transaction[1]).toNumber(),
        maxPriorityFeePerGas: maxPriorityFeePerGas,
        maxFeePerGas: maxFeePerGas,
        gasPrice: null,
        gasLimit: handleNumber(transaction[4]),
        to: handleAddress(transaction[5]),
        value: handleNumber(transaction[6]),
        data: transaction[7],
        accessList: accessListify(transaction[8])
    };
    // Unsigned EIP-1559 Transaction
    if (transaction.length === 9) return tx;
    tx.hash = (0, _keccak256.keccak256)(payload);
    _parseEipSignature(tx, transaction.slice(9), _serializeEip1559);
    return tx;
}
function _parseEip2930(payload) {
    const transaction = _rlp.decode(payload.slice(1));
    if (transaction.length !== 8 && transaction.length !== 11) logger.throwArgumentError("invalid component count for transaction type: 1", "payload", (0, _bytes.hexlify)(payload));
    const tx = {
        type: 1,
        chainId: handleNumber(transaction[0]).toNumber(),
        nonce: handleNumber(transaction[1]).toNumber(),
        gasPrice: handleNumber(transaction[2]),
        gasLimit: handleNumber(transaction[3]),
        to: handleAddress(transaction[4]),
        value: handleNumber(transaction[5]),
        data: transaction[6],
        accessList: accessListify(transaction[7])
    };
    // Unsigned EIP-2930 Transaction
    if (transaction.length === 8) return tx;
    tx.hash = (0, _keccak256.keccak256)(payload);
    _parseEipSignature(tx, transaction.slice(8), _serializeEip2930);
    return tx;
}
// Legacy Transactions and EIP-155
function _parse(rawTransaction) {
    const transaction = _rlp.decode(rawTransaction);
    if (transaction.length !== 9 && transaction.length !== 6) logger.throwArgumentError("invalid raw transaction", "rawTransaction", rawTransaction);
    const tx = {
        nonce: handleNumber(transaction[0]).toNumber(),
        gasPrice: handleNumber(transaction[1]),
        gasLimit: handleNumber(transaction[2]),
        to: handleAddress(transaction[3]),
        value: handleNumber(transaction[4]),
        data: transaction[5],
        chainId: 0
    };
    // Legacy unsigned transaction
    if (transaction.length === 6) return tx;
    try {
        tx.v = (0, _bignumber.BigNumber).from(transaction[6]).toNumber();
    } catch (error) {
        // @TODO: What makes snese to do? The v is too big
        return tx;
    }
    tx.r = (0, _bytes.hexZeroPad)(transaction[7], 32);
    tx.s = (0, _bytes.hexZeroPad)(transaction[8], 32);
    if ((0, _bignumber.BigNumber).from(tx.r).isZero() && (0, _bignumber.BigNumber).from(tx.s).isZero()) {
        // EIP-155 unsigned transaction
        tx.chainId = tx.v;
        tx.v = 0;
    } else {
        // Signed Transaction
        tx.chainId = Math.floor((tx.v - 35) / 2);
        if (tx.chainId < 0) tx.chainId = 0;
        let recoveryParam = tx.v - 27;
        const raw = transaction.slice(0, 6);
        if (tx.chainId !== 0) {
            raw.push((0, _bytes.hexlify)(tx.chainId));
            raw.push("0x");
            raw.push("0x");
            recoveryParam -= tx.chainId * 2 + 8;
        }
        const digest = (0, _keccak256.keccak256)(_rlp.encode(raw));
        try {
            tx.from = recoverAddress(digest, {
                r: (0, _bytes.hexlify)(tx.r),
                s: (0, _bytes.hexlify)(tx.s),
                recoveryParam: recoveryParam
            });
        } catch (error) {}
        tx.hash = (0, _keccak256.keccak256)(rawTransaction);
    }
    tx.type = null;
    return tx;
}
function parse(rawTransaction) {
    const payload = (0, _bytes.arrayify)(rawTransaction);
    // Legacy and EIP-155 Transactions
    if (payload[0] > 0x7f) return _parse(payload);
    // Typed Transaction (EIP-2718)
    switch(payload[0]){
        case 1:
            return _parseEip2930(payload);
        case 2:
            return _parseEip1559(payload);
        default:
            break;
    }
    return logger.throwError(`unsupported transaction type: ${payload[0]}`, (0, _logger.Logger).errors.UNSUPPORTED_OPERATION, {
        operation: "parseTransaction",
        transactionType: payload[0]
    });
}

},{"@ethersproject/address":"4jHq7","@ethersproject/bignumber":"fUhf1","@ethersproject/bytes":"4xCgN","@ethersproject/constants":"gOwoz","@ethersproject/keccak256":"jDqTa","@ethersproject/properties":"016Tj","@ethersproject/rlp":"ciscP","@ethersproject/signing-key":"ap4cY","@ethersproject/logger":"jADah","./_version":"8X5lB","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"ap4cY":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SigningKey", ()=>SigningKey);
parcelHelpers.export(exports, "recoverPublicKey", ()=>recoverPublicKey);
parcelHelpers.export(exports, "computePublicKey", ()=>computePublicKey);
var _elliptic = require("./elliptic");
var _bytes = require("@ethersproject/bytes");
var _properties = require("@ethersproject/properties");
var _logger = require("@ethersproject/logger");
var _version = require("./_version");
"use strict";
const logger = new (0, _logger.Logger)((0, _version.version));
let _curve = null;
function getCurve() {
    if (!_curve) _curve = new (0, _elliptic.EC)("secp256k1");
    return _curve;
}
class SigningKey {
    constructor(privateKey){
        (0, _properties.defineReadOnly)(this, "curve", "secp256k1");
        (0, _properties.defineReadOnly)(this, "privateKey", (0, _bytes.hexlify)(privateKey));
        if ((0, _bytes.hexDataLength)(this.privateKey) !== 32) logger.throwArgumentError("invalid private key", "privateKey", "[[ REDACTED ]]");
        const keyPair = getCurve().keyFromPrivate((0, _bytes.arrayify)(this.privateKey));
        (0, _properties.defineReadOnly)(this, "publicKey", "0x" + keyPair.getPublic(false, "hex"));
        (0, _properties.defineReadOnly)(this, "compressedPublicKey", "0x" + keyPair.getPublic(true, "hex"));
        (0, _properties.defineReadOnly)(this, "_isSigningKey", true);
    }
    _addPoint(other) {
        const p0 = getCurve().keyFromPublic((0, _bytes.arrayify)(this.publicKey));
        const p1 = getCurve().keyFromPublic((0, _bytes.arrayify)(other));
        return "0x" + p0.pub.add(p1.pub).encodeCompressed("hex");
    }
    signDigest(digest) {
        const keyPair = getCurve().keyFromPrivate((0, _bytes.arrayify)(this.privateKey));
        const digestBytes = (0, _bytes.arrayify)(digest);
        if (digestBytes.length !== 32) logger.throwArgumentError("bad digest length", "digest", digest);
        const signature = keyPair.sign(digestBytes, {
            canonical: true
        });
        return (0, _bytes.splitSignature)({
            recoveryParam: signature.recoveryParam,
            r: (0, _bytes.hexZeroPad)("0x" + signature.r.toString(16), 32),
            s: (0, _bytes.hexZeroPad)("0x" + signature.s.toString(16), 32)
        });
    }
    computeSharedSecret(otherKey) {
        const keyPair = getCurve().keyFromPrivate((0, _bytes.arrayify)(this.privateKey));
        const otherKeyPair = getCurve().keyFromPublic((0, _bytes.arrayify)(computePublicKey(otherKey)));
        return (0, _bytes.hexZeroPad)("0x" + keyPair.derive(otherKeyPair.getPublic()).toString(16), 32);
    }
    static isSigningKey(value) {
        return !!(value && value._isSigningKey);
    }
}
function recoverPublicKey(digest, signature) {
    const sig = (0, _bytes.splitSignature)(signature);
    const rs = {
        r: (0, _bytes.arrayify)(sig.r),
        s: (0, _bytes.arrayify)(sig.s)
    };
    return "0x" + getCurve().recoverPubKey((0, _bytes.arrayify)(digest), rs, sig.recoveryParam).encode("hex", false);
}
function computePublicKey(key, compressed) {
    const bytes = (0, _bytes.arrayify)(key);
    if (bytes.length === 32) {
        const signingKey = new SigningKey(bytes);
        if (compressed) return "0x" + getCurve().keyFromPrivate(bytes).getPublic(true, "hex");
        return signingKey.publicKey;
    } else if (bytes.length === 33) {
        if (compressed) return (0, _bytes.hexlify)(bytes);
        return "0x" + getCurve().keyFromPublic(bytes).getPublic(false, "hex");
    } else if (bytes.length === 65) {
        if (!compressed) return (0, _bytes.hexlify)(bytes);
        return "0x" + getCurve().keyFromPublic(bytes).getPublic(true, "hex");
    }
    return logger.throwArgumentError("invalid public or private key", "key", "[REDACTED]");
}

},{"./elliptic":"27jIb","@ethersproject/bytes":"4xCgN","@ethersproject/properties":"016Tj","@ethersproject/logger":"jADah","./_version":"5ltWl","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"27jIb":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "EC", ()=>EC$1);
var _bnJs = require("bn.js");
var _bnJsDefault = parcelHelpers.interopDefault(_bnJs);
var _hashJs = require("hash.js");
var _hashJsDefault = parcelHelpers.interopDefault(_hashJs);
var global = arguments[3];
var commonjsGlobal = typeof globalThis !== "undefined" ? globalThis : typeof window !== "undefined" ? window : typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : {};
function getDefaultExportFromCjs(x) {
    return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, "default") ? x["default"] : x;
}
function createCommonjsModule(fn, basedir, module) {
    return module = {
        path: basedir,
        exports: {},
        require: function(path, base) {
            return commonjsRequire(path, base === undefined || base === null ? module.path : base);
        }
    }, fn(module, module.exports), module.exports;
}
function getDefaultExportFromNamespaceIfPresent(n) {
    return n && Object.prototype.hasOwnProperty.call(n, "default") ? n["default"] : n;
}
function getDefaultExportFromNamespaceIfNotNamed(n) {
    return n && Object.prototype.hasOwnProperty.call(n, "default") && Object.keys(n).length === 1 ? n["default"] : n;
}
function getAugmentedNamespace(n) {
    if (n.__esModule) return n;
    var a = Object.defineProperty({}, "__esModule", {
        value: true
    });
    Object.keys(n).forEach(function(k) {
        var d = Object.getOwnPropertyDescriptor(n, k);
        Object.defineProperty(a, k, d.get ? d : {
            enumerable: true,
            get: function() {
                return n[k];
            }
        });
    });
    return a;
}
function commonjsRequire() {
    throw new Error("Dynamic requires are not currently supported by @rollup/plugin-commonjs");
}
var minimalisticAssert = assert;
function assert(val, msg) {
    if (!val) throw new Error(msg || "Assertion failed");
}
assert.equal = function assertEqual(l, r, msg) {
    if (l != r) throw new Error(msg || "Assertion failed: " + l + " != " + r);
};
var utils_1 = createCommonjsModule(function(module, exports) {
    "use strict";
    var utils = exports;
    function toArray(msg, enc) {
        if (Array.isArray(msg)) return msg.slice();
        if (!msg) return [];
        var res = [];
        if (typeof msg !== "string") {
            for(var i = 0; i < msg.length; i++)res[i] = msg[i] | 0;
            return res;
        }
        if (enc === "hex") {
            msg = msg.replace(/[^a-z0-9]+/ig, "");
            if (msg.length % 2 !== 0) msg = "0" + msg;
            for(var i = 0; i < msg.length; i += 2)res.push(parseInt(msg[i] + msg[i + 1], 16));
        } else for(var i = 0; i < msg.length; i++){
            var c = msg.charCodeAt(i);
            var hi = c >> 8;
            var lo = c & 0xff;
            if (hi) res.push(hi, lo);
            else res.push(lo);
        }
        return res;
    }
    utils.toArray = toArray;
    function zero2(word) {
        if (word.length === 1) return "0" + word;
        else return word;
    }
    utils.zero2 = zero2;
    function toHex(msg) {
        var res = "";
        for(var i = 0; i < msg.length; i++)res += zero2(msg[i].toString(16));
        return res;
    }
    utils.toHex = toHex;
    utils.encode = function encode(arr, enc) {
        if (enc === "hex") return toHex(arr);
        else return arr;
    };
});
var utils_1$1 = createCommonjsModule(function(module, exports) {
    "use strict";
    var utils = exports;
    utils.assert = minimalisticAssert;
    utils.toArray = utils_1.toArray;
    utils.zero2 = utils_1.zero2;
    utils.toHex = utils_1.toHex;
    utils.encode = utils_1.encode;
    // Represent num in a w-NAF form
    function getNAF(num, w, bits) {
        var naf = new Array(Math.max(num.bitLength(), bits) + 1);
        naf.fill(0);
        var ws = 1 << w + 1;
        var k = num.clone();
        for(var i = 0; i < naf.length; i++){
            var z;
            var mod = k.andln(ws - 1);
            if (k.isOdd()) {
                if (mod > (ws >> 1) - 1) z = (ws >> 1) - mod;
                else z = mod;
                k.isubn(z);
            } else z = 0;
            naf[i] = z;
            k.iushrn(1);
        }
        return naf;
    }
    utils.getNAF = getNAF;
    // Represent k1, k2 in a Joint Sparse Form
    function getJSF(k1, k2) {
        var jsf = [
            [],
            []
        ];
        k1 = k1.clone();
        k2 = k2.clone();
        var d1 = 0;
        var d2 = 0;
        var m8;
        while(k1.cmpn(-d1) > 0 || k2.cmpn(-d2) > 0){
            // First phase
            var m14 = k1.andln(3) + d1 & 3;
            var m24 = k2.andln(3) + d2 & 3;
            if (m14 === 3) m14 = -1;
            if (m24 === 3) m24 = -1;
            var u1;
            if ((m14 & 1) === 0) u1 = 0;
            else {
                m8 = k1.andln(7) + d1 & 7;
                if ((m8 === 3 || m8 === 5) && m24 === 2) u1 = -m14;
                else u1 = m14;
            }
            jsf[0].push(u1);
            var u2;
            if ((m24 & 1) === 0) u2 = 0;
            else {
                m8 = k2.andln(7) + d2 & 7;
                if ((m8 === 3 || m8 === 5) && m14 === 2) u2 = -m24;
                else u2 = m24;
            }
            jsf[1].push(u2);
            // Second phase
            if (2 * d1 === u1 + 1) d1 = 1 - d1;
            if (2 * d2 === u2 + 1) d2 = 1 - d2;
            k1.iushrn(1);
            k2.iushrn(1);
        }
        return jsf;
    }
    utils.getJSF = getJSF;
    function cachedProperty(obj, name, computer) {
        var key = "_" + name;
        obj.prototype[name] = function cachedProperty() {
            return this[key] !== undefined ? this[key] : this[key] = computer.call(this);
        };
    }
    utils.cachedProperty = cachedProperty;
    function parseBytes(bytes) {
        return typeof bytes === "string" ? utils.toArray(bytes, "hex") : bytes;
    }
    utils.parseBytes = parseBytes;
    function intFromLE(bytes) {
        return new (0, _bnJsDefault.default)(bytes, "hex", "le");
    }
    utils.intFromLE = intFromLE;
});
"use strict";
var getNAF = utils_1$1.getNAF;
var getJSF = utils_1$1.getJSF;
var assert$1 = utils_1$1.assert;
function BaseCurve(type, conf) {
    this.type = type;
    this.p = new (0, _bnJsDefault.default)(conf.p, 16);
    // Use Montgomery, when there is no fast reduction for the prime
    this.red = conf.prime ? (0, _bnJsDefault.default).red(conf.prime) : (0, _bnJsDefault.default).mont(this.p);
    // Useful for many curves
    this.zero = new (0, _bnJsDefault.default)(0).toRed(this.red);
    this.one = new (0, _bnJsDefault.default)(1).toRed(this.red);
    this.two = new (0, _bnJsDefault.default)(2).toRed(this.red);
    // Curve configuration, optional
    this.n = conf.n && new (0, _bnJsDefault.default)(conf.n, 16);
    this.g = conf.g && this.pointFromJSON(conf.g, conf.gRed);
    // Temporary arrays
    this._wnafT1 = new Array(4);
    this._wnafT2 = new Array(4);
    this._wnafT3 = new Array(4);
    this._wnafT4 = new Array(4);
    this._bitLength = this.n ? this.n.bitLength() : 0;
    // Generalized Greg Maxwell's trick
    var adjustCount = this.n && this.p.div(this.n);
    if (!adjustCount || adjustCount.cmpn(100) > 0) this.redN = null;
    else {
        this._maxwellTrick = true;
        this.redN = this.n.toRed(this.red);
    }
}
var base = BaseCurve;
BaseCurve.prototype.point = function point() {
    throw new Error("Not implemented");
};
BaseCurve.prototype.validate = function validate() {
    throw new Error("Not implemented");
};
BaseCurve.prototype._fixedNafMul = function _fixedNafMul(p, k) {
    assert$1(p.precomputed);
    var doubles = p._getDoubles();
    var naf = getNAF(k, 1, this._bitLength);
    var I = (1 << doubles.step + 1) - (doubles.step % 2 === 0 ? 2 : 1);
    I /= 3;
    // Translate into more windowed form
    var repr = [];
    var j;
    var nafW;
    for(j = 0; j < naf.length; j += doubles.step){
        nafW = 0;
        for(var l = j + doubles.step - 1; l >= j; l--)nafW = (nafW << 1) + naf[l];
        repr.push(nafW);
    }
    var a = this.jpoint(null, null, null);
    var b = this.jpoint(null, null, null);
    for(var i = I; i > 0; i--){
        for(j = 0; j < repr.length; j++){
            nafW = repr[j];
            if (nafW === i) b = b.mixedAdd(doubles.points[j]);
            else if (nafW === -i) b = b.mixedAdd(doubles.points[j].neg());
        }
        a = a.add(b);
    }
    return a.toP();
};
BaseCurve.prototype._wnafMul = function _wnafMul(p, k) {
    var w = 4;
    // Precompute window
    var nafPoints = p._getNAFPoints(w);
    w = nafPoints.wnd;
    var wnd = nafPoints.points;
    // Get NAF form
    var naf = getNAF(k, w, this._bitLength);
    // Add `this`*(N+1) for every w-NAF index
    var acc = this.jpoint(null, null, null);
    for(var i = naf.length - 1; i >= 0; i--){
        // Count zeroes
        for(var l = 0; i >= 0 && naf[i] === 0; i--)l++;
        if (i >= 0) l++;
        acc = acc.dblp(l);
        if (i < 0) break;
        var z = naf[i];
        assert$1(z !== 0);
        if (p.type === "affine") {
            // J +- P
            if (z > 0) acc = acc.mixedAdd(wnd[z - 1 >> 1]);
            else acc = acc.mixedAdd(wnd[-z - 1 >> 1].neg());
        } else // J +- J
        if (z > 0) acc = acc.add(wnd[z - 1 >> 1]);
        else acc = acc.add(wnd[-z - 1 >> 1].neg());
    }
    return p.type === "affine" ? acc.toP() : acc;
};
BaseCurve.prototype._wnafMulAdd = function _wnafMulAdd(defW, points, coeffs, len, jacobianResult) {
    var wndWidth = this._wnafT1;
    var wnd = this._wnafT2;
    var naf = this._wnafT3;
    // Fill all arrays
    var max = 0;
    var i;
    var j;
    var p;
    for(i = 0; i < len; i++){
        p = points[i];
        var nafPoints = p._getNAFPoints(defW);
        wndWidth[i] = nafPoints.wnd;
        wnd[i] = nafPoints.points;
    }
    // Comb small window NAFs
    for(i = len - 1; i >= 1; i -= 2){
        var a = i - 1;
        var b = i;
        if (wndWidth[a] !== 1 || wndWidth[b] !== 1) {
            naf[a] = getNAF(coeffs[a], wndWidth[a], this._bitLength);
            naf[b] = getNAF(coeffs[b], wndWidth[b], this._bitLength);
            max = Math.max(naf[a].length, max);
            max = Math.max(naf[b].length, max);
            continue;
        }
        var comb = [
            points[a],
            /* 1 */ null,
            /* 3 */ null,
            /* 5 */ points[b]
        ];
        // Try to avoid Projective points, if possible
        if (points[a].y.cmp(points[b].y) === 0) {
            comb[1] = points[a].add(points[b]);
            comb[2] = points[a].toJ().mixedAdd(points[b].neg());
        } else if (points[a].y.cmp(points[b].y.redNeg()) === 0) {
            comb[1] = points[a].toJ().mixedAdd(points[b]);
            comb[2] = points[a].add(points[b].neg());
        } else {
            comb[1] = points[a].toJ().mixedAdd(points[b]);
            comb[2] = points[a].toJ().mixedAdd(points[b].neg());
        }
        var index = [
            -3,
            /* -1 -1 */ -1,
            /* -1 0 */ -5,
            /* -1 1 */ -7,
            /* 0 -1 */ 0,
            /* 0 0 */ 7,
            /* 0 1 */ 5,
            /* 1 -1 */ 1,
            /* 1 0 */ 3
        ];
        var jsf = getJSF(coeffs[a], coeffs[b]);
        max = Math.max(jsf[0].length, max);
        naf[a] = new Array(max);
        naf[b] = new Array(max);
        for(j = 0; j < max; j++){
            var ja = jsf[0][j] | 0;
            var jb = jsf[1][j] | 0;
            naf[a][j] = index[(ja + 1) * 3 + (jb + 1)];
            naf[b][j] = 0;
            wnd[a] = comb;
        }
    }
    var acc = this.jpoint(null, null, null);
    var tmp = this._wnafT4;
    for(i = max; i >= 0; i--){
        var k = 0;
        while(i >= 0){
            var zero = true;
            for(j = 0; j < len; j++){
                tmp[j] = naf[j][i] | 0;
                if (tmp[j] !== 0) zero = false;
            }
            if (!zero) break;
            k++;
            i--;
        }
        if (i >= 0) k++;
        acc = acc.dblp(k);
        if (i < 0) break;
        for(j = 0; j < len; j++){
            var z = tmp[j];
            p;
            if (z === 0) continue;
            else if (z > 0) p = wnd[j][z - 1 >> 1];
            else if (z < 0) p = wnd[j][-z - 1 >> 1].neg();
            if (p.type === "affine") acc = acc.mixedAdd(p);
            else acc = acc.add(p);
        }
    }
    // Zeroify references
    for(i = 0; i < len; i++)wnd[i] = null;
    if (jacobianResult) return acc;
    else return acc.toP();
};
function BasePoint(curve, type) {
    this.curve = curve;
    this.type = type;
    this.precomputed = null;
}
BaseCurve.BasePoint = BasePoint;
BasePoint.prototype.eq = function eq() {
    throw new Error("Not implemented");
};
BasePoint.prototype.validate = function validate() {
    return this.curve.validate(this);
};
BaseCurve.prototype.decodePoint = function decodePoint(bytes, enc) {
    bytes = utils_1$1.toArray(bytes, enc);
    var len = this.p.byteLength();
    // uncompressed, hybrid-odd, hybrid-even
    if ((bytes[0] === 0x04 || bytes[0] === 0x06 || bytes[0] === 0x07) && bytes.length - 1 === 2 * len) {
        if (bytes[0] === 0x06) assert$1(bytes[bytes.length - 1] % 2 === 0);
        else if (bytes[0] === 0x07) assert$1(bytes[bytes.length - 1] % 2 === 1);
        var res = this.point(bytes.slice(1, 1 + len), bytes.slice(1 + len, 1 + 2 * len));
        return res;
    } else if ((bytes[0] === 0x02 || bytes[0] === 0x03) && bytes.length - 1 === len) return this.pointFromX(bytes.slice(1, 1 + len), bytes[0] === 0x03);
    throw new Error("Unknown point format");
};
BasePoint.prototype.encodeCompressed = function encodeCompressed(enc) {
    return this.encode(enc, true);
};
BasePoint.prototype._encode = function _encode(compact) {
    var len = this.curve.p.byteLength();
    var x = this.getX().toArray("be", len);
    if (compact) return [
        this.getY().isEven() ? 0x02 : 0x03
    ].concat(x);
    return [
        0x04
    ].concat(x, this.getY().toArray("be", len));
};
BasePoint.prototype.encode = function encode(enc, compact) {
    return utils_1$1.encode(this._encode(compact), enc);
};
BasePoint.prototype.precompute = function precompute(power) {
    if (this.precomputed) return this;
    var precomputed = {
        doubles: null,
        naf: null,
        beta: null
    };
    precomputed.naf = this._getNAFPoints(8);
    precomputed.doubles = this._getDoubles(4, power);
    precomputed.beta = this._getBeta();
    this.precomputed = precomputed;
    return this;
};
BasePoint.prototype._hasDoubles = function _hasDoubles(k) {
    if (!this.precomputed) return false;
    var doubles = this.precomputed.doubles;
    if (!doubles) return false;
    return doubles.points.length >= Math.ceil((k.bitLength() + 1) / doubles.step);
};
BasePoint.prototype._getDoubles = function _getDoubles(step, power) {
    if (this.precomputed && this.precomputed.doubles) return this.precomputed.doubles;
    var doubles = [
        this
    ];
    var acc = this;
    for(var i = 0; i < power; i += step){
        for(var j = 0; j < step; j++)acc = acc.dbl();
        doubles.push(acc);
    }
    return {
        step: step,
        points: doubles
    };
};
BasePoint.prototype._getNAFPoints = function _getNAFPoints(wnd) {
    if (this.precomputed && this.precomputed.naf) return this.precomputed.naf;
    var res = [
        this
    ];
    var max = (1 << wnd) - 1;
    var dbl = max === 1 ? null : this.dbl();
    for(var i = 1; i < max; i++)res[i] = res[i - 1].add(dbl);
    return {
        wnd: wnd,
        points: res
    };
};
BasePoint.prototype._getBeta = function _getBeta() {
    return null;
};
BasePoint.prototype.dblp = function dblp(k) {
    var r = this;
    for(var i = 0; i < k; i++)r = r.dbl();
    return r;
};
var inherits_browser = createCommonjsModule(function(module) {
    if (typeof Object.create === "function") // implementation from standard node.js 'util' module
    module.exports = function inherits(ctor, superCtor) {
        if (superCtor) {
            ctor.super_ = superCtor;
            ctor.prototype = Object.create(superCtor.prototype, {
                constructor: {
                    value: ctor,
                    enumerable: false,
                    writable: true,
                    configurable: true
                }
            });
        }
    };
    else // old school shim for old browsers
    module.exports = function inherits(ctor, superCtor) {
        if (superCtor) {
            ctor.super_ = superCtor;
            var TempCtor = function() {};
            TempCtor.prototype = superCtor.prototype;
            ctor.prototype = new TempCtor();
            ctor.prototype.constructor = ctor;
        }
    };
});
"use strict";
var assert$2 = utils_1$1.assert;
function ShortCurve(conf) {
    base.call(this, "short", conf);
    this.a = new (0, _bnJsDefault.default)(conf.a, 16).toRed(this.red);
    this.b = new (0, _bnJsDefault.default)(conf.b, 16).toRed(this.red);
    this.tinv = this.two.redInvm();
    this.zeroA = this.a.fromRed().cmpn(0) === 0;
    this.threeA = this.a.fromRed().sub(this.p).cmpn(-3) === 0;
    // If the curve is endomorphic, precalculate beta and lambda
    this.endo = this._getEndomorphism(conf);
    this._endoWnafT1 = new Array(4);
    this._endoWnafT2 = new Array(4);
}
inherits_browser(ShortCurve, base);
var short_1 = ShortCurve;
ShortCurve.prototype._getEndomorphism = function _getEndomorphism(conf) {
    // No efficient endomorphism
    if (!this.zeroA || !this.g || !this.n || this.p.modn(3) !== 1) return;
    // Compute beta and lambda, that lambda * P = (beta * Px; Py)
    var beta;
    var lambda;
    if (conf.beta) beta = new (0, _bnJsDefault.default)(conf.beta, 16).toRed(this.red);
    else {
        var betas = this._getEndoRoots(this.p);
        // Choose the smallest beta
        beta = betas[0].cmp(betas[1]) < 0 ? betas[0] : betas[1];
        beta = beta.toRed(this.red);
    }
    if (conf.lambda) lambda = new (0, _bnJsDefault.default)(conf.lambda, 16);
    else {
        // Choose the lambda that is matching selected beta
        var lambdas = this._getEndoRoots(this.n);
        if (this.g.mul(lambdas[0]).x.cmp(this.g.x.redMul(beta)) === 0) lambda = lambdas[0];
        else {
            lambda = lambdas[1];
            assert$2(this.g.mul(lambda).x.cmp(this.g.x.redMul(beta)) === 0);
        }
    }
    // Get basis vectors, used for balanced length-two representation
    var basis;
    if (conf.basis) basis = conf.basis.map(function(vec) {
        return {
            a: new (0, _bnJsDefault.default)(vec.a, 16),
            b: new (0, _bnJsDefault.default)(vec.b, 16)
        };
    });
    else basis = this._getEndoBasis(lambda);
    return {
        beta: beta,
        lambda: lambda,
        basis: basis
    };
};
ShortCurve.prototype._getEndoRoots = function _getEndoRoots(num) {
    // Find roots of for x^2 + x + 1 in F
    // Root = (-1 +- Sqrt(-3)) / 2
    //
    var red = num === this.p ? this.red : (0, _bnJsDefault.default).mont(num);
    var tinv = new (0, _bnJsDefault.default)(2).toRed(red).redInvm();
    var ntinv = tinv.redNeg();
    var s = new (0, _bnJsDefault.default)(3).toRed(red).redNeg().redSqrt().redMul(tinv);
    var l1 = ntinv.redAdd(s).fromRed();
    var l2 = ntinv.redSub(s).fromRed();
    return [
        l1,
        l2
    ];
};
ShortCurve.prototype._getEndoBasis = function _getEndoBasis(lambda) {
    // aprxSqrt >= sqrt(this.n)
    var aprxSqrt = this.n.ushrn(Math.floor(this.n.bitLength() / 2));
    // 3.74
    // Run EGCD, until r(L + 1) < aprxSqrt
    var u = lambda;
    var v = this.n.clone();
    var x1 = new (0, _bnJsDefault.default)(1);
    var y1 = new (0, _bnJsDefault.default)(0);
    var x2 = new (0, _bnJsDefault.default)(0);
    var y2 = new (0, _bnJsDefault.default)(1);
    // NOTE: all vectors are roots of: a + b * lambda = 0 (mod n)
    var a0;
    var b0;
    // First vector
    var a1;
    var b1;
    // Second vector
    var a2;
    var b2;
    var prevR;
    var i = 0;
    var r;
    var x;
    while(u.cmpn(0) !== 0){
        var q = v.div(u);
        r = v.sub(q.mul(u));
        x = x2.sub(q.mul(x1));
        var y = y2.sub(q.mul(y1));
        if (!a1 && r.cmp(aprxSqrt) < 0) {
            a0 = prevR.neg();
            b0 = x1;
            a1 = r.neg();
            b1 = x;
        } else if (a1 && ++i === 2) break;
        prevR = r;
        v = u;
        u = r;
        x2 = x1;
        x1 = x;
        y2 = y1;
        y1 = y;
    }
    a2 = r.neg();
    b2 = x;
    var len1 = a1.sqr().add(b1.sqr());
    var len2 = a2.sqr().add(b2.sqr());
    if (len2.cmp(len1) >= 0) {
        a2 = a0;
        b2 = b0;
    }
    // Normalize signs
    if (a1.negative) {
        a1 = a1.neg();
        b1 = b1.neg();
    }
    if (a2.negative) {
        a2 = a2.neg();
        b2 = b2.neg();
    }
    return [
        {
            a: a1,
            b: b1
        },
        {
            a: a2,
            b: b2
        }
    ];
};
ShortCurve.prototype._endoSplit = function _endoSplit(k) {
    var basis = this.endo.basis;
    var v1 = basis[0];
    var v2 = basis[1];
    var c1 = v2.b.mul(k).divRound(this.n);
    var c2 = v1.b.neg().mul(k).divRound(this.n);
    var p1 = c1.mul(v1.a);
    var p2 = c2.mul(v2.a);
    var q1 = c1.mul(v1.b);
    var q2 = c2.mul(v2.b);
    // Calculate answer
    var k1 = k.sub(p1).sub(p2);
    var k2 = q1.add(q2).neg();
    return {
        k1: k1,
        k2: k2
    };
};
ShortCurve.prototype.pointFromX = function pointFromX(x, odd) {
    x = new (0, _bnJsDefault.default)(x, 16);
    if (!x.red) x = x.toRed(this.red);
    var y2 = x.redSqr().redMul(x).redIAdd(x.redMul(this.a)).redIAdd(this.b);
    var y = y2.redSqrt();
    if (y.redSqr().redSub(y2).cmp(this.zero) !== 0) throw new Error("invalid point");
    // XXX Is there any way to tell if the number is odd without converting it
    // to non-red form?
    var isOdd = y.fromRed().isOdd();
    if (odd && !isOdd || !odd && isOdd) y = y.redNeg();
    return this.point(x, y);
};
ShortCurve.prototype.validate = function validate(point) {
    if (point.inf) return true;
    var x = point.x;
    var y = point.y;
    var ax = this.a.redMul(x);
    var rhs = x.redSqr().redMul(x).redIAdd(ax).redIAdd(this.b);
    return y.redSqr().redISub(rhs).cmpn(0) === 0;
};
ShortCurve.prototype._endoWnafMulAdd = function _endoWnafMulAdd(points, coeffs, jacobianResult) {
    var npoints = this._endoWnafT1;
    var ncoeffs = this._endoWnafT2;
    for(var i = 0; i < points.length; i++){
        var split = this._endoSplit(coeffs[i]);
        var p = points[i];
        var beta = p._getBeta();
        if (split.k1.negative) {
            split.k1.ineg();
            p = p.neg(true);
        }
        if (split.k2.negative) {
            split.k2.ineg();
            beta = beta.neg(true);
        }
        npoints[i * 2] = p;
        npoints[i * 2 + 1] = beta;
        ncoeffs[i * 2] = split.k1;
        ncoeffs[i * 2 + 1] = split.k2;
    }
    var res = this._wnafMulAdd(1, npoints, ncoeffs, i * 2, jacobianResult);
    // Clean-up references to points and coefficients
    for(var j = 0; j < i * 2; j++){
        npoints[j] = null;
        ncoeffs[j] = null;
    }
    return res;
};
function Point(curve, x, y, isRed) {
    base.BasePoint.call(this, curve, "affine");
    if (x === null && y === null) {
        this.x = null;
        this.y = null;
        this.inf = true;
    } else {
        this.x = new (0, _bnJsDefault.default)(x, 16);
        this.y = new (0, _bnJsDefault.default)(y, 16);
        // Force redgomery representation when loading from JSON
        if (isRed) {
            this.x.forceRed(this.curve.red);
            this.y.forceRed(this.curve.red);
        }
        if (!this.x.red) this.x = this.x.toRed(this.curve.red);
        if (!this.y.red) this.y = this.y.toRed(this.curve.red);
        this.inf = false;
    }
}
inherits_browser(Point, base.BasePoint);
ShortCurve.prototype.point = function point(x, y, isRed) {
    return new Point(this, x, y, isRed);
};
ShortCurve.prototype.pointFromJSON = function pointFromJSON(obj, red) {
    return Point.fromJSON(this, obj, red);
};
Point.prototype._getBeta = function _getBeta() {
    if (!this.curve.endo) return;
    var pre = this.precomputed;
    if (pre && pre.beta) return pre.beta;
    var beta = this.curve.point(this.x.redMul(this.curve.endo.beta), this.y);
    if (pre) {
        var curve = this.curve;
        var endoMul = function(p) {
            return curve.point(p.x.redMul(curve.endo.beta), p.y);
        };
        pre.beta = beta;
        beta.precomputed = {
            beta: null,
            naf: pre.naf && {
                wnd: pre.naf.wnd,
                points: pre.naf.points.map(endoMul)
            },
            doubles: pre.doubles && {
                step: pre.doubles.step,
                points: pre.doubles.points.map(endoMul)
            }
        };
    }
    return beta;
};
Point.prototype.toJSON = function toJSON() {
    if (!this.precomputed) return [
        this.x,
        this.y
    ];
    return [
        this.x,
        this.y,
        this.precomputed && {
            doubles: this.precomputed.doubles && {
                step: this.precomputed.doubles.step,
                points: this.precomputed.doubles.points.slice(1)
            },
            naf: this.precomputed.naf && {
                wnd: this.precomputed.naf.wnd,
                points: this.precomputed.naf.points.slice(1)
            }
        }
    ];
};
Point.fromJSON = function fromJSON(curve, obj, red) {
    if (typeof obj === "string") obj = JSON.parse(obj);
    var res = curve.point(obj[0], obj[1], red);
    if (!obj[2]) return res;
    function obj2point(obj) {
        return curve.point(obj[0], obj[1], red);
    }
    var pre = obj[2];
    res.precomputed = {
        beta: null,
        doubles: pre.doubles && {
            step: pre.doubles.step,
            points: [
                res
            ].concat(pre.doubles.points.map(obj2point))
        },
        naf: pre.naf && {
            wnd: pre.naf.wnd,
            points: [
                res
            ].concat(pre.naf.points.map(obj2point))
        }
    };
    return res;
};
Point.prototype.inspect = function inspect() {
    if (this.isInfinity()) return "<EC Point Infinity>";
    return "<EC Point x: " + this.x.fromRed().toString(16, 2) + " y: " + this.y.fromRed().toString(16, 2) + ">";
};
Point.prototype.isInfinity = function isInfinity() {
    return this.inf;
};
Point.prototype.add = function add(p) {
    // O + P = P
    if (this.inf) return p;
    // P + O = P
    if (p.inf) return this;
    // P + P = 2P
    if (this.eq(p)) return this.dbl();
    // P + (-P) = O
    if (this.neg().eq(p)) return this.curve.point(null, null);
    // P + Q = O
    if (this.x.cmp(p.x) === 0) return this.curve.point(null, null);
    var c = this.y.redSub(p.y);
    if (c.cmpn(0) !== 0) c = c.redMul(this.x.redSub(p.x).redInvm());
    var nx = c.redSqr().redISub(this.x).redISub(p.x);
    var ny = c.redMul(this.x.redSub(nx)).redISub(this.y);
    return this.curve.point(nx, ny);
};
Point.prototype.dbl = function dbl() {
    if (this.inf) return this;
    // 2P = O
    var ys1 = this.y.redAdd(this.y);
    if (ys1.cmpn(0) === 0) return this.curve.point(null, null);
    var a = this.curve.a;
    var x2 = this.x.redSqr();
    var dyinv = ys1.redInvm();
    var c = x2.redAdd(x2).redIAdd(x2).redIAdd(a).redMul(dyinv);
    var nx = c.redSqr().redISub(this.x.redAdd(this.x));
    var ny = c.redMul(this.x.redSub(nx)).redISub(this.y);
    return this.curve.point(nx, ny);
};
Point.prototype.getX = function getX() {
    return this.x.fromRed();
};
Point.prototype.getY = function getY() {
    return this.y.fromRed();
};
Point.prototype.mul = function mul(k) {
    k = new (0, _bnJsDefault.default)(k, 16);
    if (this.isInfinity()) return this;
    else if (this._hasDoubles(k)) return this.curve._fixedNafMul(this, k);
    else if (this.curve.endo) return this.curve._endoWnafMulAdd([
        this
    ], [
        k
    ]);
    else return this.curve._wnafMul(this, k);
};
Point.prototype.mulAdd = function mulAdd(k1, p2, k2) {
    var points = [
        this,
        p2
    ];
    var coeffs = [
        k1,
        k2
    ];
    if (this.curve.endo) return this.curve._endoWnafMulAdd(points, coeffs);
    else return this.curve._wnafMulAdd(1, points, coeffs, 2);
};
Point.prototype.jmulAdd = function jmulAdd(k1, p2, k2) {
    var points = [
        this,
        p2
    ];
    var coeffs = [
        k1,
        k2
    ];
    if (this.curve.endo) return this.curve._endoWnafMulAdd(points, coeffs, true);
    else return this.curve._wnafMulAdd(1, points, coeffs, 2, true);
};
Point.prototype.eq = function eq(p) {
    return this === p || this.inf === p.inf && (this.inf || this.x.cmp(p.x) === 0 && this.y.cmp(p.y) === 0);
};
Point.prototype.neg = function neg(_precompute) {
    if (this.inf) return this;
    var res = this.curve.point(this.x, this.y.redNeg());
    if (_precompute && this.precomputed) {
        var pre = this.precomputed;
        var negate = function(p) {
            return p.neg();
        };
        res.precomputed = {
            naf: pre.naf && {
                wnd: pre.naf.wnd,
                points: pre.naf.points.map(negate)
            },
            doubles: pre.doubles && {
                step: pre.doubles.step,
                points: pre.doubles.points.map(negate)
            }
        };
    }
    return res;
};
Point.prototype.toJ = function toJ() {
    if (this.inf) return this.curve.jpoint(null, null, null);
    var res = this.curve.jpoint(this.x, this.y, this.curve.one);
    return res;
};
function JPoint(curve, x, y, z) {
    base.BasePoint.call(this, curve, "jacobian");
    if (x === null && y === null && z === null) {
        this.x = this.curve.one;
        this.y = this.curve.one;
        this.z = new (0, _bnJsDefault.default)(0);
    } else {
        this.x = new (0, _bnJsDefault.default)(x, 16);
        this.y = new (0, _bnJsDefault.default)(y, 16);
        this.z = new (0, _bnJsDefault.default)(z, 16);
    }
    if (!this.x.red) this.x = this.x.toRed(this.curve.red);
    if (!this.y.red) this.y = this.y.toRed(this.curve.red);
    if (!this.z.red) this.z = this.z.toRed(this.curve.red);
    this.zOne = this.z === this.curve.one;
}
inherits_browser(JPoint, base.BasePoint);
ShortCurve.prototype.jpoint = function jpoint(x, y, z) {
    return new JPoint(this, x, y, z);
};
JPoint.prototype.toP = function toP() {
    if (this.isInfinity()) return this.curve.point(null, null);
    var zinv = this.z.redInvm();
    var zinv2 = zinv.redSqr();
    var ax = this.x.redMul(zinv2);
    var ay = this.y.redMul(zinv2).redMul(zinv);
    return this.curve.point(ax, ay);
};
JPoint.prototype.neg = function neg() {
    return this.curve.jpoint(this.x, this.y.redNeg(), this.z);
};
JPoint.prototype.add = function add(p) {
    // O + P = P
    if (this.isInfinity()) return p;
    // P + O = P
    if (p.isInfinity()) return this;
    // 12M + 4S + 7A
    var pz2 = p.z.redSqr();
    var z2 = this.z.redSqr();
    var u1 = this.x.redMul(pz2);
    var u2 = p.x.redMul(z2);
    var s1 = this.y.redMul(pz2.redMul(p.z));
    var s2 = p.y.redMul(z2.redMul(this.z));
    var h = u1.redSub(u2);
    var r = s1.redSub(s2);
    if (h.cmpn(0) === 0) {
        if (r.cmpn(0) !== 0) return this.curve.jpoint(null, null, null);
        else return this.dbl();
    }
    var h2 = h.redSqr();
    var h3 = h2.redMul(h);
    var v = u1.redMul(h2);
    var nx = r.redSqr().redIAdd(h3).redISub(v).redISub(v);
    var ny = r.redMul(v.redISub(nx)).redISub(s1.redMul(h3));
    var nz = this.z.redMul(p.z).redMul(h);
    return this.curve.jpoint(nx, ny, nz);
};
JPoint.prototype.mixedAdd = function mixedAdd(p) {
    // O + P = P
    if (this.isInfinity()) return p.toJ();
    // P + O = P
    if (p.isInfinity()) return this;
    // 8M + 3S + 7A
    var z2 = this.z.redSqr();
    var u1 = this.x;
    var u2 = p.x.redMul(z2);
    var s1 = this.y;
    var s2 = p.y.redMul(z2).redMul(this.z);
    var h = u1.redSub(u2);
    var r = s1.redSub(s2);
    if (h.cmpn(0) === 0) {
        if (r.cmpn(0) !== 0) return this.curve.jpoint(null, null, null);
        else return this.dbl();
    }
    var h2 = h.redSqr();
    var h3 = h2.redMul(h);
    var v = u1.redMul(h2);
    var nx = r.redSqr().redIAdd(h3).redISub(v).redISub(v);
    var ny = r.redMul(v.redISub(nx)).redISub(s1.redMul(h3));
    var nz = this.z.redMul(h);
    return this.curve.jpoint(nx, ny, nz);
};
JPoint.prototype.dblp = function dblp(pow) {
    if (pow === 0) return this;
    if (this.isInfinity()) return this;
    if (!pow) return this.dbl();
    var i;
    if (this.curve.zeroA || this.curve.threeA) {
        var r = this;
        for(i = 0; i < pow; i++)r = r.dbl();
        return r;
    }
    // 1M + 2S + 1A + N * (4S + 5M + 8A)
    // N = 1 => 6M + 6S + 9A
    var a = this.curve.a;
    var tinv = this.curve.tinv;
    var jx = this.x;
    var jy = this.y;
    var jz = this.z;
    var jz4 = jz.redSqr().redSqr();
    // Reuse results
    var jyd = jy.redAdd(jy);
    for(i = 0; i < pow; i++){
        var jx2 = jx.redSqr();
        var jyd2 = jyd.redSqr();
        var jyd4 = jyd2.redSqr();
        var c = jx2.redAdd(jx2).redIAdd(jx2).redIAdd(a.redMul(jz4));
        var t1 = jx.redMul(jyd2);
        var nx = c.redSqr().redISub(t1.redAdd(t1));
        var t2 = t1.redISub(nx);
        var dny = c.redMul(t2);
        dny = dny.redIAdd(dny).redISub(jyd4);
        var nz = jyd.redMul(jz);
        if (i + 1 < pow) jz4 = jz4.redMul(jyd4);
        jx = nx;
        jz = nz;
        jyd = dny;
    }
    return this.curve.jpoint(jx, jyd.redMul(tinv), jz);
};
JPoint.prototype.dbl = function dbl() {
    if (this.isInfinity()) return this;
    if (this.curve.zeroA) return this._zeroDbl();
    else if (this.curve.threeA) return this._threeDbl();
    else return this._dbl();
};
JPoint.prototype._zeroDbl = function _zeroDbl() {
    var nx;
    var ny;
    var nz;
    // Z = 1
    if (this.zOne) {
        // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-0.html
        //     #doubling-mdbl-2007-bl
        // 1M + 5S + 14A
        // XX = X1^2
        var xx = this.x.redSqr();
        // YY = Y1^2
        var yy = this.y.redSqr();
        // YYYY = YY^2
        var yyyy = yy.redSqr();
        // S = 2 * ((X1 + YY)^2 - XX - YYYY)
        var s = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
        s = s.redIAdd(s);
        // M = 3 * XX + a; a = 0
        var m = xx.redAdd(xx).redIAdd(xx);
        // T = M ^ 2 - 2*S
        var t = m.redSqr().redISub(s).redISub(s);
        // 8 * YYYY
        var yyyy8 = yyyy.redIAdd(yyyy);
        yyyy8 = yyyy8.redIAdd(yyyy8);
        yyyy8 = yyyy8.redIAdd(yyyy8);
        // X3 = T
        nx = t;
        // Y3 = M * (S - T) - 8 * YYYY
        ny = m.redMul(s.redISub(t)).redISub(yyyy8);
        // Z3 = 2*Y1
        nz = this.y.redAdd(this.y);
    } else {
        // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-0.html
        //     #doubling-dbl-2009-l
        // 2M + 5S + 13A
        // A = X1^2
        var a = this.x.redSqr();
        // B = Y1^2
        var b = this.y.redSqr();
        // C = B^2
        var c = b.redSqr();
        // D = 2 * ((X1 + B)^2 - A - C)
        var d = this.x.redAdd(b).redSqr().redISub(a).redISub(c);
        d = d.redIAdd(d);
        // E = 3 * A
        var e = a.redAdd(a).redIAdd(a);
        // F = E^2
        var f = e.redSqr();
        // 8 * C
        var c8 = c.redIAdd(c);
        c8 = c8.redIAdd(c8);
        c8 = c8.redIAdd(c8);
        // X3 = F - 2 * D
        nx = f.redISub(d).redISub(d);
        // Y3 = E * (D - X3) - 8 * C
        ny = e.redMul(d.redISub(nx)).redISub(c8);
        // Z3 = 2 * Y1 * Z1
        nz = this.y.redMul(this.z);
        nz = nz.redIAdd(nz);
    }
    return this.curve.jpoint(nx, ny, nz);
};
JPoint.prototype._threeDbl = function _threeDbl() {
    var nx;
    var ny;
    var nz;
    // Z = 1
    if (this.zOne) {
        // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-3.html
        //     #doubling-mdbl-2007-bl
        // 1M + 5S + 15A
        // XX = X1^2
        var xx = this.x.redSqr();
        // YY = Y1^2
        var yy = this.y.redSqr();
        // YYYY = YY^2
        var yyyy = yy.redSqr();
        // S = 2 * ((X1 + YY)^2 - XX - YYYY)
        var s = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
        s = s.redIAdd(s);
        // M = 3 * XX + a
        var m = xx.redAdd(xx).redIAdd(xx).redIAdd(this.curve.a);
        // T = M^2 - 2 * S
        var t = m.redSqr().redISub(s).redISub(s);
        // X3 = T
        nx = t;
        // Y3 = M * (S - T) - 8 * YYYY
        var yyyy8 = yyyy.redIAdd(yyyy);
        yyyy8 = yyyy8.redIAdd(yyyy8);
        yyyy8 = yyyy8.redIAdd(yyyy8);
        ny = m.redMul(s.redISub(t)).redISub(yyyy8);
        // Z3 = 2 * Y1
        nz = this.y.redAdd(this.y);
    } else {
        // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-3.html#doubling-dbl-2001-b
        // 3M + 5S
        // delta = Z1^2
        var delta = this.z.redSqr();
        // gamma = Y1^2
        var gamma = this.y.redSqr();
        // beta = X1 * gamma
        var beta = this.x.redMul(gamma);
        // alpha = 3 * (X1 - delta) * (X1 + delta)
        var alpha = this.x.redSub(delta).redMul(this.x.redAdd(delta));
        alpha = alpha.redAdd(alpha).redIAdd(alpha);
        // X3 = alpha^2 - 8 * beta
        var beta4 = beta.redIAdd(beta);
        beta4 = beta4.redIAdd(beta4);
        var beta8 = beta4.redAdd(beta4);
        nx = alpha.redSqr().redISub(beta8);
        // Z3 = (Y1 + Z1)^2 - gamma - delta
        nz = this.y.redAdd(this.z).redSqr().redISub(gamma).redISub(delta);
        // Y3 = alpha * (4 * beta - X3) - 8 * gamma^2
        var ggamma8 = gamma.redSqr();
        ggamma8 = ggamma8.redIAdd(ggamma8);
        ggamma8 = ggamma8.redIAdd(ggamma8);
        ggamma8 = ggamma8.redIAdd(ggamma8);
        ny = alpha.redMul(beta4.redISub(nx)).redISub(ggamma8);
    }
    return this.curve.jpoint(nx, ny, nz);
};
JPoint.prototype._dbl = function _dbl() {
    var a = this.curve.a;
    // 4M + 6S + 10A
    var jx = this.x;
    var jy = this.y;
    var jz = this.z;
    var jz4 = jz.redSqr().redSqr();
    var jx2 = jx.redSqr();
    var jy2 = jy.redSqr();
    var c = jx2.redAdd(jx2).redIAdd(jx2).redIAdd(a.redMul(jz4));
    var jxd4 = jx.redAdd(jx);
    jxd4 = jxd4.redIAdd(jxd4);
    var t1 = jxd4.redMul(jy2);
    var nx = c.redSqr().redISub(t1.redAdd(t1));
    var t2 = t1.redISub(nx);
    var jyd8 = jy2.redSqr();
    jyd8 = jyd8.redIAdd(jyd8);
    jyd8 = jyd8.redIAdd(jyd8);
    jyd8 = jyd8.redIAdd(jyd8);
    var ny = c.redMul(t2).redISub(jyd8);
    var nz = jy.redAdd(jy).redMul(jz);
    return this.curve.jpoint(nx, ny, nz);
};
JPoint.prototype.trpl = function trpl() {
    if (!this.curve.zeroA) return this.dbl().add(this);
    // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-0.html#tripling-tpl-2007-bl
    // 5M + 10S + ...
    // XX = X1^2
    var xx = this.x.redSqr();
    // YY = Y1^2
    var yy = this.y.redSqr();
    // ZZ = Z1^2
    var zz = this.z.redSqr();
    // YYYY = YY^2
    var yyyy = yy.redSqr();
    // M = 3 * XX + a * ZZ2; a = 0
    var m = xx.redAdd(xx).redIAdd(xx);
    // MM = M^2
    var mm = m.redSqr();
    // E = 6 * ((X1 + YY)^2 - XX - YYYY) - MM
    var e = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
    e = e.redIAdd(e);
    e = e.redAdd(e).redIAdd(e);
    e = e.redISub(mm);
    // EE = E^2
    var ee = e.redSqr();
    // T = 16*YYYY
    var t = yyyy.redIAdd(yyyy);
    t = t.redIAdd(t);
    t = t.redIAdd(t);
    t = t.redIAdd(t);
    // U = (M + E)^2 - MM - EE - T
    var u = m.redIAdd(e).redSqr().redISub(mm).redISub(ee).redISub(t);
    // X3 = 4 * (X1 * EE - 4 * YY * U)
    var yyu4 = yy.redMul(u);
    yyu4 = yyu4.redIAdd(yyu4);
    yyu4 = yyu4.redIAdd(yyu4);
    var nx = this.x.redMul(ee).redISub(yyu4);
    nx = nx.redIAdd(nx);
    nx = nx.redIAdd(nx);
    // Y3 = 8 * Y1 * (U * (T - U) - E * EE)
    var ny = this.y.redMul(u.redMul(t.redISub(u)).redISub(e.redMul(ee)));
    ny = ny.redIAdd(ny);
    ny = ny.redIAdd(ny);
    ny = ny.redIAdd(ny);
    // Z3 = (Z1 + E)^2 - ZZ - EE
    var nz = this.z.redAdd(e).redSqr().redISub(zz).redISub(ee);
    return this.curve.jpoint(nx, ny, nz);
};
JPoint.prototype.mul = function mul(k, kbase) {
    k = new (0, _bnJsDefault.default)(k, kbase);
    return this.curve._wnafMul(this, k);
};
JPoint.prototype.eq = function eq(p) {
    if (p.type === "affine") return this.eq(p.toJ());
    if (this === p) return true;
    // x1 * z2^2 == x2 * z1^2
    var z2 = this.z.redSqr();
    var pz2 = p.z.redSqr();
    if (this.x.redMul(pz2).redISub(p.x.redMul(z2)).cmpn(0) !== 0) return false;
    // y1 * z2^3 == y2 * z1^3
    var z3 = z2.redMul(this.z);
    var pz3 = pz2.redMul(p.z);
    return this.y.redMul(pz3).redISub(p.y.redMul(z3)).cmpn(0) === 0;
};
JPoint.prototype.eqXToP = function eqXToP(x) {
    var zs = this.z.redSqr();
    var rx = x.toRed(this.curve.red).redMul(zs);
    if (this.x.cmp(rx) === 0) return true;
    var xc = x.clone();
    var t = this.curve.redN.redMul(zs);
    for(;;){
        xc.iadd(this.curve.n);
        if (xc.cmp(this.curve.p) >= 0) return false;
        rx.redIAdd(t);
        if (this.x.cmp(rx) === 0) return true;
    }
};
JPoint.prototype.inspect = function inspect() {
    if (this.isInfinity()) return "<EC JPoint Infinity>";
    return "<EC JPoint x: " + this.x.toString(16, 2) + " y: " + this.y.toString(16, 2) + " z: " + this.z.toString(16, 2) + ">";
};
JPoint.prototype.isInfinity = function isInfinity() {
    // XXX This code assumes that zero is always zero in red
    return this.z.cmpn(0) === 0;
};
var curve_1 = createCommonjsModule(function(module, exports) {
    "use strict";
    var curve = exports;
    curve.base = base;
    curve.short = short_1;
    curve.mont = /*RicMoo:ethers:require(./mont)*/ null;
    curve.edwards = /*RicMoo:ethers:require(./edwards)*/ null;
});
var curves_1 = createCommonjsModule(function(module, exports) {
    "use strict";
    var curves = exports;
    var assert = utils_1$1.assert;
    function PresetCurve(options) {
        if (options.type === "short") this.curve = new curve_1.short(options);
        else if (options.type === "edwards") this.curve = new curve_1.edwards(options);
        else this.curve = new curve_1.mont(options);
        this.g = this.curve.g;
        this.n = this.curve.n;
        this.hash = options.hash;
        assert(this.g.validate(), "Invalid curve");
        assert(this.g.mul(this.n).isInfinity(), "Invalid curve, G*N != O");
    }
    curves.PresetCurve = PresetCurve;
    function defineCurve(name, options) {
        Object.defineProperty(curves, name, {
            configurable: true,
            enumerable: true,
            get: function() {
                var curve = new PresetCurve(options);
                Object.defineProperty(curves, name, {
                    configurable: true,
                    enumerable: true,
                    value: curve
                });
                return curve;
            }
        });
    }
    defineCurve("p192", {
        type: "short",
        prime: "p192",
        p: "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff",
        a: "ffffffff ffffffff ffffffff fffffffe ffffffff fffffffc",
        b: "64210519 e59c80e7 0fa7e9ab 72243049 feb8deec c146b9b1",
        n: "ffffffff ffffffff ffffffff 99def836 146bc9b1 b4d22831",
        hash: (0, _hashJsDefault.default).sha256,
        gRed: false,
        g: [
            "188da80e b03090f6 7cbf20eb 43a18800 f4ff0afd 82ff1012",
            "07192b95 ffc8da78 631011ed 6b24cdd5 73f977a1 1e794811"
        ]
    });
    defineCurve("p224", {
        type: "short",
        prime: "p224",
        p: "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001",
        a: "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff fffffffe",
        b: "b4050a85 0c04b3ab f5413256 5044b0b7 d7bfd8ba 270b3943 2355ffb4",
        n: "ffffffff ffffffff ffffffff ffff16a2 e0b8f03e 13dd2945 5c5c2a3d",
        hash: (0, _hashJsDefault.default).sha256,
        gRed: false,
        g: [
            "b70e0cbd 6bb4bf7f 321390b9 4a03c1d3 56c21122 343280d6 115c1d21",
            "bd376388 b5f723fb 4c22dfe6 cd4375a0 5a074764 44d58199 85007e34"
        ]
    });
    defineCurve("p256", {
        type: "short",
        prime: null,
        p: "ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff ffffffff",
        a: "ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff fffffffc",
        b: "5ac635d8 aa3a93e7 b3ebbd55 769886bc 651d06b0 cc53b0f6 3bce3c3e 27d2604b",
        n: "ffffffff 00000000 ffffffff ffffffff bce6faad a7179e84 f3b9cac2 fc632551",
        hash: (0, _hashJsDefault.default).sha256,
        gRed: false,
        g: [
            "6b17d1f2 e12c4247 f8bce6e5 63a440f2 77037d81 2deb33a0 f4a13945 d898c296",
            "4fe342e2 fe1a7f9b 8ee7eb4a 7c0f9e16 2bce3357 6b315ece cbb64068 37bf51f5"
        ]
    });
    defineCurve("p384", {
        type: "short",
        prime: null,
        p: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe ffffffff 00000000 00000000 ffffffff",
        a: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe ffffffff 00000000 00000000 fffffffc",
        b: "b3312fa7 e23ee7e4 988e056b e3f82d19 181d9c6e fe814112 0314088f 5013875a c656398d 8a2ed19d 2a85c8ed d3ec2aef",
        n: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff c7634d81 f4372ddf 581a0db2 48b0a77a ecec196a ccc52973",
        hash: (0, _hashJsDefault.default).sha384,
        gRed: false,
        g: [
            "aa87ca22 be8b0537 8eb1c71e f320ad74 6e1d3b62 8ba79b98 59f741e0 82542a38 5502f25d bf55296c 3a545e38 72760ab7",
            "3617de4a 96262c6f 5d9e98bf 9292dc29 f8f41dbd 289a147c e9da3113 b5f0b8c0 0a60b1ce 1d7e819d 7a431d7c 90ea0e5f"
        ]
    });
    defineCurve("p521", {
        type: "short",
        prime: null,
        p: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff",
        a: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffc",
        b: "00000051 953eb961 8e1c9a1f 929a21a0 b68540ee a2da725b 99b315f3 b8b48991 8ef109e1 56193951 ec7e937b 1652c0bd 3bb1bf07 3573df88 3d2c34f1 ef451fd4 6b503f00",
        n: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffa 51868783 bf2f966b 7fcc0148 f709a5d0 3bb5c9b8 899c47ae bb6fb71e 91386409",
        hash: (0, _hashJsDefault.default).sha512,
        gRed: false,
        g: [
            "000000c6 858e06b7 0404e9cd 9e3ecb66 2395b442 9c648139 053fb521 f828af60 6b4d3dba a14b5e77 efe75928 fe1dc127 a2ffa8de 3348b3c1 856a429b f97e7e31 c2e5bd66",
            "00000118 39296a78 9a3bc004 5c8a5fb4 2c7d1bd9 98f54449 579b4468 17afbd17 273e662c 97ee7299 5ef42640 c550b901 3fad0761 353c7086 a272c240 88be9476 9fd16650"
        ]
    });
    defineCurve("curve25519", {
        type: "mont",
        prime: "p25519",
        p: "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed",
        a: "76d06",
        b: "1",
        n: "1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed",
        hash: (0, _hashJsDefault.default).sha256,
        gRed: false,
        g: [
            "9"
        ]
    });
    defineCurve("ed25519", {
        type: "edwards",
        prime: "p25519",
        p: "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed",
        a: "-1",
        c: "1",
        // -121665 * (121666^(-1)) (mod P)
        d: "52036cee2b6ffe73 8cc740797779e898 00700a4d4141d8ab 75eb4dca135978a3",
        n: "1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed",
        hash: (0, _hashJsDefault.default).sha256,
        gRed: false,
        g: [
            "216936d3cd6e53fec0a4e231fdd6dc5c692cc7609525a7b2c9562d608f25d51a",
            // 4/5
            "6666666666666666666666666666666666666666666666666666666666666658"
        ]
    });
    var pre;
    try {
        pre = /*RicMoo:ethers:require(./precomputed/secp256k1)*/ null.crash();
    } catch (e) {
        pre = undefined;
    }
    defineCurve("secp256k1", {
        type: "short",
        prime: "k256",
        p: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f",
        a: "0",
        b: "7",
        n: "ffffffff ffffffff ffffffff fffffffe baaedce6 af48a03b bfd25e8c d0364141",
        h: "1",
        hash: (0, _hashJsDefault.default).sha256,
        // Precomputed endomorphism
        beta: "7ae96a2b657c07106e64479eac3434e99cf0497512f58995c1396c28719501ee",
        lambda: "5363ad4cc05c30e0a5261c028812645a122e22ea20816678df02967c1b23bd72",
        basis: [
            {
                a: "3086d221a7d46bcde86c90e49284eb15",
                b: "-e4437ed6010e88286f547fa90abfe4c3"
            },
            {
                a: "114ca50f7a8e2f3f657c1108d9d44cfd8",
                b: "3086d221a7d46bcde86c90e49284eb15"
            }
        ],
        gRed: false,
        g: [
            "79be667ef9dcbbac55a06295ce870b07029bfcdb2dce28d959f2815b16f81798",
            "483ada7726a3c4655da4fbfc0e1108a8fd17b448a68554199c47d08ffb10d4b8",
            pre
        ]
    });
});
"use strict";
function HmacDRBG(options) {
    if (!(this instanceof HmacDRBG)) return new HmacDRBG(options);
    this.hash = options.hash;
    this.predResist = !!options.predResist;
    this.outLen = this.hash.outSize;
    this.minEntropy = options.minEntropy || this.hash.hmacStrength;
    this._reseed = null;
    this.reseedInterval = null;
    this.K = null;
    this.V = null;
    var entropy = utils_1.toArray(options.entropy, options.entropyEnc || "hex");
    var nonce = utils_1.toArray(options.nonce, options.nonceEnc || "hex");
    var pers = utils_1.toArray(options.pers, options.persEnc || "hex");
    minimalisticAssert(entropy.length >= this.minEntropy / 8, "Not enough entropy. Minimum is: " + this.minEntropy + " bits");
    this._init(entropy, nonce, pers);
}
var hmacDrbg = HmacDRBG;
HmacDRBG.prototype._init = function init(entropy, nonce, pers) {
    var seed = entropy.concat(nonce).concat(pers);
    this.K = new Array(this.outLen / 8);
    this.V = new Array(this.outLen / 8);
    for(var i = 0; i < this.V.length; i++){
        this.K[i] = 0x00;
        this.V[i] = 0x01;
    }
    this._update(seed);
    this._reseed = 1;
    this.reseedInterval = 0x1000000000000; // 2^48
};
HmacDRBG.prototype._hmac = function hmac() {
    return new (0, _hashJsDefault.default).hmac(this.hash, this.K);
};
HmacDRBG.prototype._update = function update(seed) {
    var kmac = this._hmac().update(this.V).update([
        0x00
    ]);
    if (seed) kmac = kmac.update(seed);
    this.K = kmac.digest();
    this.V = this._hmac().update(this.V).digest();
    if (!seed) return;
    this.K = this._hmac().update(this.V).update([
        0x01
    ]).update(seed).digest();
    this.V = this._hmac().update(this.V).digest();
};
HmacDRBG.prototype.reseed = function reseed(entropy, entropyEnc, add, addEnc) {
    // Optional entropy enc
    if (typeof entropyEnc !== "string") {
        addEnc = add;
        add = entropyEnc;
        entropyEnc = null;
    }
    entropy = utils_1.toArray(entropy, entropyEnc);
    add = utils_1.toArray(add, addEnc);
    minimalisticAssert(entropy.length >= this.minEntropy / 8, "Not enough entropy. Minimum is: " + this.minEntropy + " bits");
    this._update(entropy.concat(add || []));
    this._reseed = 1;
};
HmacDRBG.prototype.generate = function generate(len, enc, add, addEnc) {
    if (this._reseed > this.reseedInterval) throw new Error("Reseed is required");
    // Optional encoding
    if (typeof enc !== "string") {
        addEnc = add;
        add = enc;
        enc = null;
    }
    // Optional additional data
    if (add) {
        add = utils_1.toArray(add, addEnc || "hex");
        this._update(add);
    }
    var temp = [];
    while(temp.length < len){
        this.V = this._hmac().update(this.V).digest();
        temp = temp.concat(this.V);
    }
    var res = temp.slice(0, len);
    this._update(add);
    this._reseed++;
    return utils_1.encode(res, enc);
};
"use strict";
var assert$3 = utils_1$1.assert;
function KeyPair(ec, options) {
    this.ec = ec;
    this.priv = null;
    this.pub = null;
    // KeyPair(ec, { priv: ..., pub: ... })
    if (options.priv) this._importPrivate(options.priv, options.privEnc);
    if (options.pub) this._importPublic(options.pub, options.pubEnc);
}
var key = KeyPair;
KeyPair.fromPublic = function fromPublic(ec, pub, enc) {
    if (pub instanceof KeyPair) return pub;
    return new KeyPair(ec, {
        pub: pub,
        pubEnc: enc
    });
};
KeyPair.fromPrivate = function fromPrivate(ec, priv, enc) {
    if (priv instanceof KeyPair) return priv;
    return new KeyPair(ec, {
        priv: priv,
        privEnc: enc
    });
};
KeyPair.prototype.validate = function validate() {
    var pub = this.getPublic();
    if (pub.isInfinity()) return {
        result: false,
        reason: "Invalid public key"
    };
    if (!pub.validate()) return {
        result: false,
        reason: "Public key is not a point"
    };
    if (!pub.mul(this.ec.curve.n).isInfinity()) return {
        result: false,
        reason: "Public key * N != O"
    };
    return {
        result: true,
        reason: null
    };
};
KeyPair.prototype.getPublic = function getPublic(compact, enc) {
    // compact is optional argument
    if (typeof compact === "string") {
        enc = compact;
        compact = null;
    }
    if (!this.pub) this.pub = this.ec.g.mul(this.priv);
    if (!enc) return this.pub;
    return this.pub.encode(enc, compact);
};
KeyPair.prototype.getPrivate = function getPrivate(enc) {
    if (enc === "hex") return this.priv.toString(16, 2);
    else return this.priv;
};
KeyPair.prototype._importPrivate = function _importPrivate(key, enc) {
    this.priv = new (0, _bnJsDefault.default)(key, enc || 16);
    // Ensure that the priv won't be bigger than n, otherwise we may fail
    // in fixed multiplication method
    this.priv = this.priv.umod(this.ec.curve.n);
};
KeyPair.prototype._importPublic = function _importPublic(key, enc) {
    if (key.x || key.y) {
        // Montgomery points only have an `x` coordinate.
        // Weierstrass/Edwards points on the other hand have both `x` and
        // `y` coordinates.
        if (this.ec.curve.type === "mont") assert$3(key.x, "Need x coordinate");
        else if (this.ec.curve.type === "short" || this.ec.curve.type === "edwards") assert$3(key.x && key.y, "Need both x and y coordinate");
        this.pub = this.ec.curve.point(key.x, key.y);
        return;
    }
    this.pub = this.ec.curve.decodePoint(key, enc);
};
// ECDH
KeyPair.prototype.derive = function derive(pub) {
    if (!pub.validate()) assert$3(pub.validate(), "public point not validated");
    return pub.mul(this.priv).getX();
};
// ECDSA
KeyPair.prototype.sign = function sign(msg, enc, options) {
    return this.ec.sign(msg, this, enc, options);
};
KeyPair.prototype.verify = function verify(msg, signature) {
    return this.ec.verify(msg, signature, this);
};
KeyPair.prototype.inspect = function inspect() {
    return "<Key priv: " + (this.priv && this.priv.toString(16, 2)) + " pub: " + (this.pub && this.pub.inspect()) + " >";
};
"use strict";
var assert$4 = utils_1$1.assert;
function Signature(options, enc) {
    if (options instanceof Signature) return options;
    if (this._importDER(options, enc)) return;
    assert$4(options.r && options.s, "Signature without r or s");
    this.r = new (0, _bnJsDefault.default)(options.r, 16);
    this.s = new (0, _bnJsDefault.default)(options.s, 16);
    if (options.recoveryParam === undefined) this.recoveryParam = null;
    else this.recoveryParam = options.recoveryParam;
}
var signature = Signature;
function Position() {
    this.place = 0;
}
function getLength(buf, p) {
    var initial = buf[p.place++];
    if (!(initial & 0x80)) return initial;
    var octetLen = initial & 0xf;
    // Indefinite length or overflow
    if (octetLen === 0 || octetLen > 4) return false;
    var val = 0;
    for(var i = 0, off = p.place; i < octetLen; i++, off++){
        val <<= 8;
        val |= buf[off];
        val >>>= 0;
    }
    // Leading zeroes
    if (val <= 0x7f) return false;
    p.place = off;
    return val;
}
function rmPadding(buf) {
    var i = 0;
    var len = buf.length - 1;
    while(!buf[i] && !(buf[i + 1] & 0x80) && i < len)i++;
    if (i === 0) return buf;
    return buf.slice(i);
}
Signature.prototype._importDER = function _importDER(data, enc) {
    data = utils_1$1.toArray(data, enc);
    var p = new Position();
    if (data[p.place++] !== 0x30) return false;
    var len = getLength(data, p);
    if (len === false) return false;
    if (len + p.place !== data.length) return false;
    if (data[p.place++] !== 0x02) return false;
    var rlen = getLength(data, p);
    if (rlen === false) return false;
    var r = data.slice(p.place, rlen + p.place);
    p.place += rlen;
    if (data[p.place++] !== 0x02) return false;
    var slen = getLength(data, p);
    if (slen === false) return false;
    if (data.length !== slen + p.place) return false;
    var s = data.slice(p.place, slen + p.place);
    if (r[0] === 0) {
        if (r[1] & 0x80) r = r.slice(1);
        else // Leading zeroes
        return false;
    }
    if (s[0] === 0) {
        if (s[1] & 0x80) s = s.slice(1);
        else // Leading zeroes
        return false;
    }
    this.r = new (0, _bnJsDefault.default)(r);
    this.s = new (0, _bnJsDefault.default)(s);
    this.recoveryParam = null;
    return true;
};
function constructLength(arr, len) {
    if (len < 0x80) {
        arr.push(len);
        return;
    }
    var octets = 1 + (Math.log(len) / Math.LN2 >>> 3);
    arr.push(octets | 0x80);
    while(--octets)arr.push(len >>> (octets << 3) & 0xff);
    arr.push(len);
}
Signature.prototype.toDER = function toDER(enc) {
    var r = this.r.toArray();
    var s = this.s.toArray();
    // Pad values
    if (r[0] & 0x80) r = [
        0
    ].concat(r);
    // Pad values
    if (s[0] & 0x80) s = [
        0
    ].concat(s);
    r = rmPadding(r);
    s = rmPadding(s);
    while(!s[0] && !(s[1] & 0x80))s = s.slice(1);
    var arr = [
        0x02
    ];
    constructLength(arr, r.length);
    arr = arr.concat(r);
    arr.push(0x02);
    constructLength(arr, s.length);
    var backHalf = arr.concat(s);
    var res = [
        0x30
    ];
    constructLength(res, backHalf.length);
    res = res.concat(backHalf);
    return utils_1$1.encode(res, enc);
};
"use strict";
var rand = /*RicMoo:ethers:require(brorand)*/ function() {
    throw new Error("unsupported");
};
var assert$5 = utils_1$1.assert;
function EC(options) {
    if (!(this instanceof EC)) return new EC(options);
    // Shortcut `elliptic.ec(curve-name)`
    if (typeof options === "string") {
        assert$5(Object.prototype.hasOwnProperty.call(curves_1, options), "Unknown curve " + options);
        options = curves_1[options];
    }
    // Shortcut for `elliptic.ec(elliptic.curves.curveName)`
    if (options instanceof curves_1.PresetCurve) options = {
        curve: options
    };
    this.curve = options.curve.curve;
    this.n = this.curve.n;
    this.nh = this.n.ushrn(1);
    this.g = this.curve.g;
    // Point on curve
    this.g = options.curve.g;
    this.g.precompute(options.curve.n.bitLength() + 1);
    // Hash for function for DRBG
    this.hash = options.hash || options.curve.hash;
}
var ec = EC;
EC.prototype.keyPair = function keyPair(options) {
    return new key(this, options);
};
EC.prototype.keyFromPrivate = function keyFromPrivate(priv, enc) {
    return key.fromPrivate(this, priv, enc);
};
EC.prototype.keyFromPublic = function keyFromPublic(pub, enc) {
    return key.fromPublic(this, pub, enc);
};
EC.prototype.genKeyPair = function genKeyPair(options) {
    if (!options) options = {};
    // Instantiate Hmac_DRBG
    var drbg = new hmacDrbg({
        hash: this.hash,
        pers: options.pers,
        persEnc: options.persEnc || "utf8",
        entropy: options.entropy || rand(this.hash.hmacStrength),
        entropyEnc: options.entropy && options.entropyEnc || "utf8",
        nonce: this.n.toArray()
    });
    var bytes = this.n.byteLength();
    var ns2 = this.n.sub(new (0, _bnJsDefault.default)(2));
    for(;;){
        var priv = new (0, _bnJsDefault.default)(drbg.generate(bytes));
        if (priv.cmp(ns2) > 0) continue;
        priv.iaddn(1);
        return this.keyFromPrivate(priv);
    }
};
EC.prototype._truncateToN = function _truncateToN(msg, truncOnly) {
    var delta = msg.byteLength() * 8 - this.n.bitLength();
    if (delta > 0) msg = msg.ushrn(delta);
    if (!truncOnly && msg.cmp(this.n) >= 0) return msg.sub(this.n);
    else return msg;
};
EC.prototype.sign = function sign(msg, key, enc, options) {
    if (typeof enc === "object") {
        options = enc;
        enc = null;
    }
    if (!options) options = {};
    key = this.keyFromPrivate(key, enc);
    msg = this._truncateToN(new (0, _bnJsDefault.default)(msg, 16));
    // Zero-extend key to provide enough entropy
    var bytes = this.n.byteLength();
    var bkey = key.getPrivate().toArray("be", bytes);
    // Zero-extend nonce to have the same byte size as N
    var nonce = msg.toArray("be", bytes);
    // Instantiate Hmac_DRBG
    var drbg = new hmacDrbg({
        hash: this.hash,
        entropy: bkey,
        nonce: nonce,
        pers: options.pers,
        persEnc: options.persEnc || "utf8"
    });
    // Number of bytes to generate
    var ns1 = this.n.sub(new (0, _bnJsDefault.default)(1));
    for(var iter = 0;; iter++){
        var k = options.k ? options.k(iter) : new (0, _bnJsDefault.default)(drbg.generate(this.n.byteLength()));
        k = this._truncateToN(k, true);
        if (k.cmpn(1) <= 0 || k.cmp(ns1) >= 0) continue;
        var kp = this.g.mul(k);
        if (kp.isInfinity()) continue;
        var kpX = kp.getX();
        var r = kpX.umod(this.n);
        if (r.cmpn(0) === 0) continue;
        var s = k.invm(this.n).mul(r.mul(key.getPrivate()).iadd(msg));
        s = s.umod(this.n);
        if (s.cmpn(0) === 0) continue;
        var recoveryParam = (kp.getY().isOdd() ? 1 : 0) | (kpX.cmp(r) !== 0 ? 2 : 0);
        // Use complement of `s`, if it is > `n / 2`
        if (options.canonical && s.cmp(this.nh) > 0) {
            s = this.n.sub(s);
            recoveryParam ^= 1;
        }
        return new signature({
            r: r,
            s: s,
            recoveryParam: recoveryParam
        });
    }
};
EC.prototype.verify = function verify(msg, signature$1, key, enc) {
    msg = this._truncateToN(new (0, _bnJsDefault.default)(msg, 16));
    key = this.keyFromPublic(key, enc);
    signature$1 = new signature(signature$1, "hex");
    // Perform primitive values validation
    var r = signature$1.r;
    var s = signature$1.s;
    if (r.cmpn(1) < 0 || r.cmp(this.n) >= 0) return false;
    if (s.cmpn(1) < 0 || s.cmp(this.n) >= 0) return false;
    // Validate signature
    var sinv = s.invm(this.n);
    var u1 = sinv.mul(msg).umod(this.n);
    var u2 = sinv.mul(r).umod(this.n);
    var p;
    if (!this.curve._maxwellTrick) {
        p = this.g.mulAdd(u1, key.getPublic(), u2);
        if (p.isInfinity()) return false;
        return p.getX().umod(this.n).cmp(r) === 0;
    }
    // NOTE: Greg Maxwell's trick, inspired by:
    // https://git.io/vad3K
    p = this.g.jmulAdd(u1, key.getPublic(), u2);
    if (p.isInfinity()) return false;
    // Compare `p.x` of Jacobian point with `r`,
    // this will do `p.x == r * p.z^2` instead of multiplying `p.x` by the
    // inverse of `p.z^2`
    return p.eqXToP(r);
};
EC.prototype.recoverPubKey = function(msg, signature$1, j, enc) {
    assert$5((3 & j) === j, "The recovery param is more than two bits");
    signature$1 = new signature(signature$1, enc);
    var n = this.n;
    var e = new (0, _bnJsDefault.default)(msg);
    var r = signature$1.r;
    var s = signature$1.s;
    // A set LSB signifies that the y-coordinate is odd
    var isYOdd = j & 1;
    var isSecondKey = j >> 1;
    if (r.cmp(this.curve.p.umod(this.curve.n)) >= 0 && isSecondKey) throw new Error("Unable to find sencond key candinate");
    // 1.1. Let x = r + jn.
    if (isSecondKey) r = this.curve.pointFromX(r.add(this.curve.n), isYOdd);
    else r = this.curve.pointFromX(r, isYOdd);
    var rInv = signature$1.r.invm(n);
    var s1 = n.sub(e).mul(rInv).umod(n);
    var s2 = s.mul(rInv).umod(n);
    // 1.6.1 Compute Q = r^-1 (sR -  eG)
    //               Q = r^-1 (sR + -eG)
    return this.g.mulAdd(s1, r, s2);
};
EC.prototype.getKeyRecoveryParam = function(e, signature$1, Q, enc) {
    signature$1 = new signature(signature$1, enc);
    if (signature$1.recoveryParam !== null) return signature$1.recoveryParam;
    for(var i = 0; i < 4; i++){
        var Qprime;
        try {
            Qprime = this.recoverPubKey(e, signature$1, i);
        } catch (e) {
            continue;
        }
        if (Qprime.eq(Q)) return i;
    }
    throw new Error("Unable to find valid recovery factor");
};
var elliptic_1 = createCommonjsModule(function(module, exports) {
    "use strict";
    var elliptic = exports;
    elliptic.version = "6.5.4";
    elliptic.utils = utils_1$1;
    elliptic.rand = /*RicMoo:ethers:require(brorand)*/ function() {
        throw new Error("unsupported");
    };
    elliptic.curve = curve_1;
    elliptic.curves = curves_1;
    // Protocols
    elliptic.ec = ec;
    elliptic.eddsa = /*RicMoo:ethers:require(./elliptic/eddsa)*/ null;
});
var EC$1 = elliptic_1.ec;

},{"bn.js":"jMHQf","hash.js":"dElqS","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"jMHQf":[function(require,module,exports) {
(function(module1, exports) {
    "use strict";
    // Utils
    function assert(val, msg) {
        if (!val) throw new Error(msg || "Assertion failed");
    }
    // Could use `inherits` module, but don't want to move from single file
    // architecture yet.
    function inherits(ctor, superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
    // BN
    function BN(number, base, endian) {
        if (BN.isBN(number)) return number;
        this.negative = 0;
        this.words = null;
        this.length = 0;
        // Reduction context
        this.red = null;
        if (number !== null) {
            if (base === "le" || base === "be") {
                endian = base;
                base = 10;
            }
            this._init(number || 0, base || 10, endian || "be");
        }
    }
    if (typeof module1 === "object") module1.exports = BN;
    else exports.BN = BN;
    BN.BN = BN;
    BN.wordSize = 26;
    var Buffer;
    try {
        if (typeof window !== "undefined" && typeof window.Buffer !== "undefined") Buffer = window.Buffer;
        else Buffer = require("7e4fa78919672b87").Buffer;
    } catch (e) {}
    BN.isBN = function isBN(num) {
        if (num instanceof BN) return true;
        return num !== null && typeof num === "object" && num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
    };
    BN.max = function max(left, right) {
        if (left.cmp(right) > 0) return left;
        return right;
    };
    BN.min = function min(left, right) {
        if (left.cmp(right) < 0) return left;
        return right;
    };
    BN.prototype._init = function init(number, base, endian) {
        if (typeof number === "number") return this._initNumber(number, base, endian);
        if (typeof number === "object") return this._initArray(number, base, endian);
        if (base === "hex") base = 16;
        assert(base === (base | 0) && base >= 2 && base <= 36);
        number = number.toString().replace(/\s+/g, "");
        var start = 0;
        if (number[0] === "-") {
            start++;
            this.negative = 1;
        }
        if (start < number.length) {
            if (base === 16) this._parseHex(number, start, endian);
            else {
                this._parseBase(number, base, start);
                if (endian === "le") this._initArray(this.toArray(), base, endian);
            }
        }
    };
    BN.prototype._initNumber = function _initNumber(number, base, endian) {
        if (number < 0) {
            this.negative = 1;
            number = -number;
        }
        if (number < 0x4000000) {
            this.words = [
                number & 0x3ffffff
            ];
            this.length = 1;
        } else if (number < 0x10000000000000) {
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff
            ];
            this.length = 2;
        } else {
            assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff,
                1
            ];
            this.length = 3;
        }
        if (endian !== "le") return;
        // Reverse the bytes
        this._initArray(this.toArray(), base, endian);
    };
    BN.prototype._initArray = function _initArray(number, base, endian) {
        // Perhaps a Uint8Array
        assert(typeof number.length === "number");
        if (number.length <= 0) {
            this.words = [
                0
            ];
            this.length = 1;
            return this;
        }
        this.length = Math.ceil(number.length / 3);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        var j, w;
        var off = 0;
        if (endian === "be") for(i = number.length - 1, j = 0; i >= 0; i -= 3){
            w = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        else if (endian === "le") for(i = 0, j = 0; i < number.length; i += 3){
            w = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        return this._strip();
    };
    function parseHex4Bits(string, index) {
        var c = string.charCodeAt(index);
        // '0' - '9'
        if (c >= 48 && c <= 57) return c - 48;
        else if (c >= 65 && c <= 70) return c - 55;
        else if (c >= 97 && c <= 102) return c - 87;
        else assert(false, "Invalid character in " + string);
    }
    function parseHexByte(string, lowerBound, index) {
        var r = parseHex4Bits(string, index);
        if (index - 1 >= lowerBound) r |= parseHex4Bits(string, index - 1) << 4;
        return r;
    }
    BN.prototype._parseHex = function _parseHex(number, start, endian) {
        // Create possibly bigger array to ensure that it fits the number
        this.length = Math.ceil((number.length - start) / 6);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        // 24-bits chunks
        var off = 0;
        var j = 0;
        var w;
        if (endian === "be") for(i = number.length - 1; i >= start; i -= 2){
            w = parseHexByte(number, start, i) << off;
            this.words[j] |= w & 0x3ffffff;
            if (off >= 18) {
                off -= 18;
                j += 1;
                this.words[j] |= w >>> 26;
            } else off += 8;
        }
        else {
            var parseLength = number.length - start;
            for(i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2){
                w = parseHexByte(number, start, i) << off;
                this.words[j] |= w & 0x3ffffff;
                if (off >= 18) {
                    off -= 18;
                    j += 1;
                    this.words[j] |= w >>> 26;
                } else off += 8;
            }
        }
        this._strip();
    };
    function parseBase(str, start, end, mul) {
        var r = 0;
        var b = 0;
        var len = Math.min(str.length, end);
        for(var i = start; i < len; i++){
            var c = str.charCodeAt(i) - 48;
            r *= mul;
            // 'a'
            if (c >= 49) b = c - 49 + 0xa;
            else if (c >= 17) b = c - 17 + 0xa;
            else b = c;
            assert(c >= 0 && b < mul, "Invalid character");
            r += b;
        }
        return r;
    }
    BN.prototype._parseBase = function _parseBase(number, base, start) {
        // Initialize as zero
        this.words = [
            0
        ];
        this.length = 1;
        // Find length of limb in base
        for(var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base)limbLen++;
        limbLen--;
        limbPow = limbPow / base | 0;
        var total = number.length - start;
        var mod = total % limbLen;
        var end = Math.min(total, total - mod) + start;
        var word = 0;
        for(var i = start; i < end; i += limbLen){
            word = parseBase(number, i, i + limbLen, base);
            this.imuln(limbPow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        if (mod !== 0) {
            var pow = 1;
            word = parseBase(number, i, number.length, base);
            for(i = 0; i < mod; i++)pow *= base;
            this.imuln(pow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        this._strip();
    };
    BN.prototype.copy = function copy(dest) {
        dest.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)dest.words[i] = this.words[i];
        dest.length = this.length;
        dest.negative = this.negative;
        dest.red = this.red;
    };
    function move(dest, src) {
        dest.words = src.words;
        dest.length = src.length;
        dest.negative = src.negative;
        dest.red = src.red;
    }
    BN.prototype._move = function _move(dest) {
        move(dest, this);
    };
    BN.prototype.clone = function clone() {
        var r = new BN(null);
        this.copy(r);
        return r;
    };
    BN.prototype._expand = function _expand(size) {
        while(this.length < size)this.words[this.length++] = 0;
        return this;
    };
    // Remove leading `0` from `this`
    BN.prototype._strip = function strip() {
        while(this.length > 1 && this.words[this.length - 1] === 0)this.length--;
        return this._normSign();
    };
    BN.prototype._normSign = function _normSign() {
        // -0 = 0
        if (this.length === 1 && this.words[0] === 0) this.negative = 0;
        return this;
    };
    // Check Symbol.for because not everywhere where Symbol defined
    // See https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Symbol#Browser_compatibility
    if (typeof Symbol !== "undefined" && typeof Symbol.for === "function") try {
        BN.prototype[Symbol.for("nodejs.util.inspect.custom")] = inspect;
    } catch (e) {
        BN.prototype.inspect = inspect;
    }
    else BN.prototype.inspect = inspect;
    function inspect() {
        return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
    }
    /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */ var zeros = [
        "",
        "0",
        "00",
        "000",
        "0000",
        "00000",
        "000000",
        "0000000",
        "00000000",
        "000000000",
        "0000000000",
        "00000000000",
        "000000000000",
        "0000000000000",
        "00000000000000",
        "000000000000000",
        "0000000000000000",
        "00000000000000000",
        "000000000000000000",
        "0000000000000000000",
        "00000000000000000000",
        "000000000000000000000",
        "0000000000000000000000",
        "00000000000000000000000",
        "000000000000000000000000",
        "0000000000000000000000000"
    ];
    var groupSizes = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
    ];
    var groupBases = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        10000000,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64000000,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        24300000,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
    ];
    BN.prototype.toString = function toString(base, padding) {
        base = base || 10;
        padding = padding | 0 || 1;
        var out;
        if (base === 16 || base === "hex") {
            out = "";
            var off = 0;
            var carry = 0;
            for(var i = 0; i < this.length; i++){
                var w = this.words[i];
                var word = ((w << off | carry) & 0xffffff).toString(16);
                carry = w >>> 24 - off & 0xffffff;
                off += 2;
                if (off >= 26) {
                    off -= 26;
                    i--;
                }
                if (carry !== 0 || i !== this.length - 1) out = zeros[6 - word.length] + word + out;
                else out = word + out;
            }
            if (carry !== 0) out = carry.toString(16) + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        if (base === (base | 0) && base >= 2 && base <= 36) {
            // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
            var groupSize = groupSizes[base];
            // var groupBase = Math.pow(base, groupSize);
            var groupBase = groupBases[base];
            out = "";
            var c = this.clone();
            c.negative = 0;
            while(!c.isZero()){
                var r = c.modrn(groupBase).toString(base);
                c = c.idivn(groupBase);
                if (!c.isZero()) out = zeros[groupSize - r.length] + r + out;
                else out = r + out;
            }
            if (this.isZero()) out = "0" + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        assert(false, "Base should be between 2 and 36");
    };
    BN.prototype.toNumber = function toNumber() {
        var ret = this.words[0];
        if (this.length === 2) ret += this.words[1] * 0x4000000;
        else if (this.length === 3 && this.words[2] === 0x01) // NOTE: at this stage it is known that the top bit is set
        ret += 0x10000000000000 + this.words[1] * 0x4000000;
        else if (this.length > 2) assert(false, "Number can only safely store up to 53 bits");
        return this.negative !== 0 ? -ret : ret;
    };
    BN.prototype.toJSON = function toJSON() {
        return this.toString(16, 2);
    };
    if (Buffer) BN.prototype.toBuffer = function toBuffer(endian, length) {
        return this.toArrayLike(Buffer, endian, length);
    };
    BN.prototype.toArray = function toArray(endian, length) {
        return this.toArrayLike(Array, endian, length);
    };
    var allocate = function allocate(ArrayType, size) {
        if (ArrayType.allocUnsafe) return ArrayType.allocUnsafe(size);
        return new ArrayType(size);
    };
    BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
        this._strip();
        var byteLength = this.byteLength();
        var reqLength = length || Math.max(1, byteLength);
        assert(byteLength <= reqLength, "byte array longer than desired length");
        assert(reqLength > 0, "Requested array length <= 0");
        var res = allocate(ArrayType, reqLength);
        var postfix = endian === "le" ? "LE" : "BE";
        this["_toArrayLike" + postfix](res, byteLength);
        return res;
    };
    BN.prototype._toArrayLikeLE = function _toArrayLikeLE(res, byteLength) {
        var position = 0;
        var carry = 0;
        for(var i = 0, shift = 0; i < this.length; i++){
            var word = this.words[i] << shift | carry;
            res[position++] = word & 0xff;
            if (position < res.length) res[position++] = word >> 8 & 0xff;
            if (position < res.length) res[position++] = word >> 16 & 0xff;
            if (shift === 6) {
                if (position < res.length) res[position++] = word >> 24 & 0xff;
                carry = 0;
                shift = 0;
            } else {
                carry = word >>> 24;
                shift += 2;
            }
        }
        if (position < res.length) {
            res[position++] = carry;
            while(position < res.length)res[position++] = 0;
        }
    };
    BN.prototype._toArrayLikeBE = function _toArrayLikeBE(res, byteLength) {
        var position = res.length - 1;
        var carry = 0;
        for(var i = 0, shift = 0; i < this.length; i++){
            var word = this.words[i] << shift | carry;
            res[position--] = word & 0xff;
            if (position >= 0) res[position--] = word >> 8 & 0xff;
            if (position >= 0) res[position--] = word >> 16 & 0xff;
            if (shift === 6) {
                if (position >= 0) res[position--] = word >> 24 & 0xff;
                carry = 0;
                shift = 0;
            } else {
                carry = word >>> 24;
                shift += 2;
            }
        }
        if (position >= 0) {
            res[position--] = carry;
            while(position >= 0)res[position--] = 0;
        }
    };
    if (Math.clz32) BN.prototype._countBits = function _countBits(w) {
        return 32 - Math.clz32(w);
    };
    else BN.prototype._countBits = function _countBits(w) {
        var t = w;
        var r = 0;
        if (t >= 0x1000) {
            r += 13;
            t >>>= 13;
        }
        if (t >= 0x40) {
            r += 7;
            t >>>= 7;
        }
        if (t >= 0x8) {
            r += 4;
            t >>>= 4;
        }
        if (t >= 0x02) {
            r += 2;
            t >>>= 2;
        }
        return r + t;
    };
    BN.prototype._zeroBits = function _zeroBits(w) {
        // Short-cut
        if (w === 0) return 26;
        var t = w;
        var r = 0;
        if ((t & 0x1fff) === 0) {
            r += 13;
            t >>>= 13;
        }
        if ((t & 0x7f) === 0) {
            r += 7;
            t >>>= 7;
        }
        if ((t & 0xf) === 0) {
            r += 4;
            t >>>= 4;
        }
        if ((t & 0x3) === 0) {
            r += 2;
            t >>>= 2;
        }
        if ((t & 0x1) === 0) r++;
        return r;
    };
    // Return number of used bits in a BN
    BN.prototype.bitLength = function bitLength() {
        var w = this.words[this.length - 1];
        var hi = this._countBits(w);
        return (this.length - 1) * 26 + hi;
    };
    function toBitArray(num) {
        var w = new Array(num.bitLength());
        for(var bit = 0; bit < w.length; bit++){
            var off = bit / 26 | 0;
            var wbit = bit % 26;
            w[bit] = num.words[off] >>> wbit & 0x01;
        }
        return w;
    }
    // Number of trailing zero bits
    BN.prototype.zeroBits = function zeroBits() {
        if (this.isZero()) return 0;
        var r = 0;
        for(var i = 0; i < this.length; i++){
            var b = this._zeroBits(this.words[i]);
            r += b;
            if (b !== 26) break;
        }
        return r;
    };
    BN.prototype.byteLength = function byteLength() {
        return Math.ceil(this.bitLength() / 8);
    };
    BN.prototype.toTwos = function toTwos(width) {
        if (this.negative !== 0) return this.abs().inotn(width).iaddn(1);
        return this.clone();
    };
    BN.prototype.fromTwos = function fromTwos(width) {
        if (this.testn(width - 1)) return this.notn(width).iaddn(1).ineg();
        return this.clone();
    };
    BN.prototype.isNeg = function isNeg() {
        return this.negative !== 0;
    };
    // Return negative clone of `this`
    BN.prototype.neg = function neg() {
        return this.clone().ineg();
    };
    BN.prototype.ineg = function ineg() {
        if (!this.isZero()) this.negative ^= 1;
        return this;
    };
    // Or `num` with `this` in-place
    BN.prototype.iuor = function iuor(num) {
        while(this.length < num.length)this.words[this.length++] = 0;
        for(var i = 0; i < num.length; i++)this.words[i] = this.words[i] | num.words[i];
        return this._strip();
    };
    BN.prototype.ior = function ior(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuor(num);
    };
    // Or `num` with `this`
    BN.prototype.or = function or(num) {
        if (this.length > num.length) return this.clone().ior(num);
        return num.clone().ior(this);
    };
    BN.prototype.uor = function uor(num) {
        if (this.length > num.length) return this.clone().iuor(num);
        return num.clone().iuor(this);
    };
    // And `num` with `this` in-place
    BN.prototype.iuand = function iuand(num) {
        // b = min-length(num, this)
        var b;
        if (this.length > num.length) b = num;
        else b = this;
        for(var i = 0; i < b.length; i++)this.words[i] = this.words[i] & num.words[i];
        this.length = b.length;
        return this._strip();
    };
    BN.prototype.iand = function iand(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuand(num);
    };
    // And `num` with `this`
    BN.prototype.and = function and(num) {
        if (this.length > num.length) return this.clone().iand(num);
        return num.clone().iand(this);
    };
    BN.prototype.uand = function uand(num) {
        if (this.length > num.length) return this.clone().iuand(num);
        return num.clone().iuand(this);
    };
    // Xor `num` with `this` in-place
    BN.prototype.iuxor = function iuxor(num) {
        // a.length > b.length
        var a;
        var b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        for(var i = 0; i < b.length; i++)this.words[i] = a.words[i] ^ b.words[i];
        if (this !== a) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = a.length;
        return this._strip();
    };
    BN.prototype.ixor = function ixor(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuxor(num);
    };
    // Xor `num` with `this`
    BN.prototype.xor = function xor(num) {
        if (this.length > num.length) return this.clone().ixor(num);
        return num.clone().ixor(this);
    };
    BN.prototype.uxor = function uxor(num) {
        if (this.length > num.length) return this.clone().iuxor(num);
        return num.clone().iuxor(this);
    };
    // Not ``this`` with ``width`` bitwidth
    BN.prototype.inotn = function inotn(width) {
        assert(typeof width === "number" && width >= 0);
        var bytesNeeded = Math.ceil(width / 26) | 0;
        var bitsLeft = width % 26;
        // Extend the buffer with leading zeroes
        this._expand(bytesNeeded);
        if (bitsLeft > 0) bytesNeeded--;
        // Handle complete words
        for(var i = 0; i < bytesNeeded; i++)this.words[i] = ~this.words[i] & 0x3ffffff;
        // Handle the residue
        if (bitsLeft > 0) this.words[i] = ~this.words[i] & 0x3ffffff >> 26 - bitsLeft;
        // And remove leading zeroes
        return this._strip();
    };
    BN.prototype.notn = function notn(width) {
        return this.clone().inotn(width);
    };
    // Set `bit` of `this`
    BN.prototype.setn = function setn(bit, val) {
        assert(typeof bit === "number" && bit >= 0);
        var off = bit / 26 | 0;
        var wbit = bit % 26;
        this._expand(off + 1);
        if (val) this.words[off] = this.words[off] | 1 << wbit;
        else this.words[off] = this.words[off] & ~(1 << wbit);
        return this._strip();
    };
    // Add `num` to `this` in-place
    BN.prototype.iadd = function iadd(num) {
        var r;
        // negative + positive
        if (this.negative !== 0 && num.negative === 0) {
            this.negative = 0;
            r = this.isub(num);
            this.negative ^= 1;
            return this._normSign();
        // positive + negative
        } else if (this.negative === 0 && num.negative !== 0) {
            num.negative = 0;
            r = this.isub(num);
            num.negative = 1;
            return r._normSign();
        }
        // a.length > b.length
        var a, b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        this.length = a.length;
        if (carry !== 0) {
            this.words[this.length] = carry;
            this.length++;
        // Copy the rest of the words
        } else if (a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        return this;
    };
    // Add `num` to `this`
    BN.prototype.add = function add(num) {
        var res;
        if (num.negative !== 0 && this.negative === 0) {
            num.negative = 0;
            res = this.sub(num);
            num.negative ^= 1;
            return res;
        } else if (num.negative === 0 && this.negative !== 0) {
            this.negative = 0;
            res = num.sub(this);
            this.negative = 1;
            return res;
        }
        if (this.length > num.length) return this.clone().iadd(num);
        return num.clone().iadd(this);
    };
    // Subtract `num` from `this` in-place
    BN.prototype.isub = function isub(num) {
        // this - (-num) = this + num
        if (num.negative !== 0) {
            num.negative = 0;
            var r = this.iadd(num);
            num.negative = 1;
            return r._normSign();
        // -this - num = -(this + num)
        } else if (this.negative !== 0) {
            this.negative = 0;
            this.iadd(num);
            this.negative = 1;
            return this._normSign();
        }
        // At this point both numbers are positive
        var cmp = this.cmp(num);
        // Optimization - zeroify
        if (cmp === 0) {
            this.negative = 0;
            this.length = 1;
            this.words[0] = 0;
            return this;
        }
        // a > b
        var a, b;
        if (cmp > 0) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        // Copy rest of the words
        if (carry === 0 && i < a.length && a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = Math.max(this.length, i);
        if (a !== this) this.negative = 1;
        return this._strip();
    };
    // Subtract `num` from `this`
    BN.prototype.sub = function sub(num) {
        return this.clone().isub(num);
    };
    function smallMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        var len = self.length + num.length | 0;
        out.length = len;
        len = len - 1 | 0;
        // Peel one iteration (compiler can't do it, because of code complexity)
        var a = self.words[0] | 0;
        var b = num.words[0] | 0;
        var r = a * b;
        var lo = r & 0x3ffffff;
        var carry = r / 0x4000000 | 0;
        out.words[0] = lo;
        for(var k = 1; k < len; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = carry >>> 26;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j | 0;
                a = self.words[i] | 0;
                b = num.words[j] | 0;
                r = a * b + rword;
                ncarry += r / 0x4000000 | 0;
                rword = r & 0x3ffffff;
            }
            out.words[k] = rword | 0;
            carry = ncarry | 0;
        }
        if (carry !== 0) out.words[k] = carry | 0;
        else out.length--;
        return out._strip();
    }
    // TODO(indutny): it may be reasonable to omit it for users who don't need
    // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
    // multiplication (like elliptic secp256k1).
    var comb10MulTo = function comb10MulTo(self, num, out) {
        var a = self.words;
        var b = num.words;
        var o = out.words;
        var c = 0;
        var lo;
        var mid;
        var hi;
        var a0 = a[0] | 0;
        var al0 = a0 & 0x1fff;
        var ah0 = a0 >>> 13;
        var a1 = a[1] | 0;
        var al1 = a1 & 0x1fff;
        var ah1 = a1 >>> 13;
        var a2 = a[2] | 0;
        var al2 = a2 & 0x1fff;
        var ah2 = a2 >>> 13;
        var a3 = a[3] | 0;
        var al3 = a3 & 0x1fff;
        var ah3 = a3 >>> 13;
        var a4 = a[4] | 0;
        var al4 = a4 & 0x1fff;
        var ah4 = a4 >>> 13;
        var a5 = a[5] | 0;
        var al5 = a5 & 0x1fff;
        var ah5 = a5 >>> 13;
        var a6 = a[6] | 0;
        var al6 = a6 & 0x1fff;
        var ah6 = a6 >>> 13;
        var a7 = a[7] | 0;
        var al7 = a7 & 0x1fff;
        var ah7 = a7 >>> 13;
        var a8 = a[8] | 0;
        var al8 = a8 & 0x1fff;
        var ah8 = a8 >>> 13;
        var a9 = a[9] | 0;
        var al9 = a9 & 0x1fff;
        var ah9 = a9 >>> 13;
        var b0 = b[0] | 0;
        var bl0 = b0 & 0x1fff;
        var bh0 = b0 >>> 13;
        var b1 = b[1] | 0;
        var bl1 = b1 & 0x1fff;
        var bh1 = b1 >>> 13;
        var b2 = b[2] | 0;
        var bl2 = b2 & 0x1fff;
        var bh2 = b2 >>> 13;
        var b3 = b[3] | 0;
        var bl3 = b3 & 0x1fff;
        var bh3 = b3 >>> 13;
        var b4 = b[4] | 0;
        var bl4 = b4 & 0x1fff;
        var bh4 = b4 >>> 13;
        var b5 = b[5] | 0;
        var bl5 = b5 & 0x1fff;
        var bh5 = b5 >>> 13;
        var b6 = b[6] | 0;
        var bl6 = b6 & 0x1fff;
        var bh6 = b6 >>> 13;
        var b7 = b[7] | 0;
        var bl7 = b7 & 0x1fff;
        var bh7 = b7 >>> 13;
        var b8 = b[8] | 0;
        var bl8 = b8 & 0x1fff;
        var bh8 = b8 >>> 13;
        var b9 = b[9] | 0;
        var bl9 = b9 & 0x1fff;
        var bh9 = b9 >>> 13;
        out.negative = self.negative ^ num.negative;
        out.length = 19;
        /* k = 0 */ lo = Math.imul(al0, bl0);
        mid = Math.imul(al0, bh0);
        mid = mid + Math.imul(ah0, bl0) | 0;
        hi = Math.imul(ah0, bh0);
        var w0 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
        w0 &= 0x3ffffff;
        /* k = 1 */ lo = Math.imul(al1, bl0);
        mid = Math.imul(al1, bh0);
        mid = mid + Math.imul(ah1, bl0) | 0;
        hi = Math.imul(ah1, bh0);
        lo = lo + Math.imul(al0, bl1) | 0;
        mid = mid + Math.imul(al0, bh1) | 0;
        mid = mid + Math.imul(ah0, bl1) | 0;
        hi = hi + Math.imul(ah0, bh1) | 0;
        var w1 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
        w1 &= 0x3ffffff;
        /* k = 2 */ lo = Math.imul(al2, bl0);
        mid = Math.imul(al2, bh0);
        mid = mid + Math.imul(ah2, bl0) | 0;
        hi = Math.imul(ah2, bh0);
        lo = lo + Math.imul(al1, bl1) | 0;
        mid = mid + Math.imul(al1, bh1) | 0;
        mid = mid + Math.imul(ah1, bl1) | 0;
        hi = hi + Math.imul(ah1, bh1) | 0;
        lo = lo + Math.imul(al0, bl2) | 0;
        mid = mid + Math.imul(al0, bh2) | 0;
        mid = mid + Math.imul(ah0, bl2) | 0;
        hi = hi + Math.imul(ah0, bh2) | 0;
        var w2 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
        w2 &= 0x3ffffff;
        /* k = 3 */ lo = Math.imul(al3, bl0);
        mid = Math.imul(al3, bh0);
        mid = mid + Math.imul(ah3, bl0) | 0;
        hi = Math.imul(ah3, bh0);
        lo = lo + Math.imul(al2, bl1) | 0;
        mid = mid + Math.imul(al2, bh1) | 0;
        mid = mid + Math.imul(ah2, bl1) | 0;
        hi = hi + Math.imul(ah2, bh1) | 0;
        lo = lo + Math.imul(al1, bl2) | 0;
        mid = mid + Math.imul(al1, bh2) | 0;
        mid = mid + Math.imul(ah1, bl2) | 0;
        hi = hi + Math.imul(ah1, bh2) | 0;
        lo = lo + Math.imul(al0, bl3) | 0;
        mid = mid + Math.imul(al0, bh3) | 0;
        mid = mid + Math.imul(ah0, bl3) | 0;
        hi = hi + Math.imul(ah0, bh3) | 0;
        var w3 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
        w3 &= 0x3ffffff;
        /* k = 4 */ lo = Math.imul(al4, bl0);
        mid = Math.imul(al4, bh0);
        mid = mid + Math.imul(ah4, bl0) | 0;
        hi = Math.imul(ah4, bh0);
        lo = lo + Math.imul(al3, bl1) | 0;
        mid = mid + Math.imul(al3, bh1) | 0;
        mid = mid + Math.imul(ah3, bl1) | 0;
        hi = hi + Math.imul(ah3, bh1) | 0;
        lo = lo + Math.imul(al2, bl2) | 0;
        mid = mid + Math.imul(al2, bh2) | 0;
        mid = mid + Math.imul(ah2, bl2) | 0;
        hi = hi + Math.imul(ah2, bh2) | 0;
        lo = lo + Math.imul(al1, bl3) | 0;
        mid = mid + Math.imul(al1, bh3) | 0;
        mid = mid + Math.imul(ah1, bl3) | 0;
        hi = hi + Math.imul(ah1, bh3) | 0;
        lo = lo + Math.imul(al0, bl4) | 0;
        mid = mid + Math.imul(al0, bh4) | 0;
        mid = mid + Math.imul(ah0, bl4) | 0;
        hi = hi + Math.imul(ah0, bh4) | 0;
        var w4 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
        w4 &= 0x3ffffff;
        /* k = 5 */ lo = Math.imul(al5, bl0);
        mid = Math.imul(al5, bh0);
        mid = mid + Math.imul(ah5, bl0) | 0;
        hi = Math.imul(ah5, bh0);
        lo = lo + Math.imul(al4, bl1) | 0;
        mid = mid + Math.imul(al4, bh1) | 0;
        mid = mid + Math.imul(ah4, bl1) | 0;
        hi = hi + Math.imul(ah4, bh1) | 0;
        lo = lo + Math.imul(al3, bl2) | 0;
        mid = mid + Math.imul(al3, bh2) | 0;
        mid = mid + Math.imul(ah3, bl2) | 0;
        hi = hi + Math.imul(ah3, bh2) | 0;
        lo = lo + Math.imul(al2, bl3) | 0;
        mid = mid + Math.imul(al2, bh3) | 0;
        mid = mid + Math.imul(ah2, bl3) | 0;
        hi = hi + Math.imul(ah2, bh3) | 0;
        lo = lo + Math.imul(al1, bl4) | 0;
        mid = mid + Math.imul(al1, bh4) | 0;
        mid = mid + Math.imul(ah1, bl4) | 0;
        hi = hi + Math.imul(ah1, bh4) | 0;
        lo = lo + Math.imul(al0, bl5) | 0;
        mid = mid + Math.imul(al0, bh5) | 0;
        mid = mid + Math.imul(ah0, bl5) | 0;
        hi = hi + Math.imul(ah0, bh5) | 0;
        var w5 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
        w5 &= 0x3ffffff;
        /* k = 6 */ lo = Math.imul(al6, bl0);
        mid = Math.imul(al6, bh0);
        mid = mid + Math.imul(ah6, bl0) | 0;
        hi = Math.imul(ah6, bh0);
        lo = lo + Math.imul(al5, bl1) | 0;
        mid = mid + Math.imul(al5, bh1) | 0;
        mid = mid + Math.imul(ah5, bl1) | 0;
        hi = hi + Math.imul(ah5, bh1) | 0;
        lo = lo + Math.imul(al4, bl2) | 0;
        mid = mid + Math.imul(al4, bh2) | 0;
        mid = mid + Math.imul(ah4, bl2) | 0;
        hi = hi + Math.imul(ah4, bh2) | 0;
        lo = lo + Math.imul(al3, bl3) | 0;
        mid = mid + Math.imul(al3, bh3) | 0;
        mid = mid + Math.imul(ah3, bl3) | 0;
        hi = hi + Math.imul(ah3, bh3) | 0;
        lo = lo + Math.imul(al2, bl4) | 0;
        mid = mid + Math.imul(al2, bh4) | 0;
        mid = mid + Math.imul(ah2, bl4) | 0;
        hi = hi + Math.imul(ah2, bh4) | 0;
        lo = lo + Math.imul(al1, bl5) | 0;
        mid = mid + Math.imul(al1, bh5) | 0;
        mid = mid + Math.imul(ah1, bl5) | 0;
        hi = hi + Math.imul(ah1, bh5) | 0;
        lo = lo + Math.imul(al0, bl6) | 0;
        mid = mid + Math.imul(al0, bh6) | 0;
        mid = mid + Math.imul(ah0, bl6) | 0;
        hi = hi + Math.imul(ah0, bh6) | 0;
        var w6 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
        w6 &= 0x3ffffff;
        /* k = 7 */ lo = Math.imul(al7, bl0);
        mid = Math.imul(al7, bh0);
        mid = mid + Math.imul(ah7, bl0) | 0;
        hi = Math.imul(ah7, bh0);
        lo = lo + Math.imul(al6, bl1) | 0;
        mid = mid + Math.imul(al6, bh1) | 0;
        mid = mid + Math.imul(ah6, bl1) | 0;
        hi = hi + Math.imul(ah6, bh1) | 0;
        lo = lo + Math.imul(al5, bl2) | 0;
        mid = mid + Math.imul(al5, bh2) | 0;
        mid = mid + Math.imul(ah5, bl2) | 0;
        hi = hi + Math.imul(ah5, bh2) | 0;
        lo = lo + Math.imul(al4, bl3) | 0;
        mid = mid + Math.imul(al4, bh3) | 0;
        mid = mid + Math.imul(ah4, bl3) | 0;
        hi = hi + Math.imul(ah4, bh3) | 0;
        lo = lo + Math.imul(al3, bl4) | 0;
        mid = mid + Math.imul(al3, bh4) | 0;
        mid = mid + Math.imul(ah3, bl4) | 0;
        hi = hi + Math.imul(ah3, bh4) | 0;
        lo = lo + Math.imul(al2, bl5) | 0;
        mid = mid + Math.imul(al2, bh5) | 0;
        mid = mid + Math.imul(ah2, bl5) | 0;
        hi = hi + Math.imul(ah2, bh5) | 0;
        lo = lo + Math.imul(al1, bl6) | 0;
        mid = mid + Math.imul(al1, bh6) | 0;
        mid = mid + Math.imul(ah1, bl6) | 0;
        hi = hi + Math.imul(ah1, bh6) | 0;
        lo = lo + Math.imul(al0, bl7) | 0;
        mid = mid + Math.imul(al0, bh7) | 0;
        mid = mid + Math.imul(ah0, bl7) | 0;
        hi = hi + Math.imul(ah0, bh7) | 0;
        var w7 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
        w7 &= 0x3ffffff;
        /* k = 8 */ lo = Math.imul(al8, bl0);
        mid = Math.imul(al8, bh0);
        mid = mid + Math.imul(ah8, bl0) | 0;
        hi = Math.imul(ah8, bh0);
        lo = lo + Math.imul(al7, bl1) | 0;
        mid = mid + Math.imul(al7, bh1) | 0;
        mid = mid + Math.imul(ah7, bl1) | 0;
        hi = hi + Math.imul(ah7, bh1) | 0;
        lo = lo + Math.imul(al6, bl2) | 0;
        mid = mid + Math.imul(al6, bh2) | 0;
        mid = mid + Math.imul(ah6, bl2) | 0;
        hi = hi + Math.imul(ah6, bh2) | 0;
        lo = lo + Math.imul(al5, bl3) | 0;
        mid = mid + Math.imul(al5, bh3) | 0;
        mid = mid + Math.imul(ah5, bl3) | 0;
        hi = hi + Math.imul(ah5, bh3) | 0;
        lo = lo + Math.imul(al4, bl4) | 0;
        mid = mid + Math.imul(al4, bh4) | 0;
        mid = mid + Math.imul(ah4, bl4) | 0;
        hi = hi + Math.imul(ah4, bh4) | 0;
        lo = lo + Math.imul(al3, bl5) | 0;
        mid = mid + Math.imul(al3, bh5) | 0;
        mid = mid + Math.imul(ah3, bl5) | 0;
        hi = hi + Math.imul(ah3, bh5) | 0;
        lo = lo + Math.imul(al2, bl6) | 0;
        mid = mid + Math.imul(al2, bh6) | 0;
        mid = mid + Math.imul(ah2, bl6) | 0;
        hi = hi + Math.imul(ah2, bh6) | 0;
        lo = lo + Math.imul(al1, bl7) | 0;
        mid = mid + Math.imul(al1, bh7) | 0;
        mid = mid + Math.imul(ah1, bl7) | 0;
        hi = hi + Math.imul(ah1, bh7) | 0;
        lo = lo + Math.imul(al0, bl8) | 0;
        mid = mid + Math.imul(al0, bh8) | 0;
        mid = mid + Math.imul(ah0, bl8) | 0;
        hi = hi + Math.imul(ah0, bh8) | 0;
        var w8 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
        w8 &= 0x3ffffff;
        /* k = 9 */ lo = Math.imul(al9, bl0);
        mid = Math.imul(al9, bh0);
        mid = mid + Math.imul(ah9, bl0) | 0;
        hi = Math.imul(ah9, bh0);
        lo = lo + Math.imul(al8, bl1) | 0;
        mid = mid + Math.imul(al8, bh1) | 0;
        mid = mid + Math.imul(ah8, bl1) | 0;
        hi = hi + Math.imul(ah8, bh1) | 0;
        lo = lo + Math.imul(al7, bl2) | 0;
        mid = mid + Math.imul(al7, bh2) | 0;
        mid = mid + Math.imul(ah7, bl2) | 0;
        hi = hi + Math.imul(ah7, bh2) | 0;
        lo = lo + Math.imul(al6, bl3) | 0;
        mid = mid + Math.imul(al6, bh3) | 0;
        mid = mid + Math.imul(ah6, bl3) | 0;
        hi = hi + Math.imul(ah6, bh3) | 0;
        lo = lo + Math.imul(al5, bl4) | 0;
        mid = mid + Math.imul(al5, bh4) | 0;
        mid = mid + Math.imul(ah5, bl4) | 0;
        hi = hi + Math.imul(ah5, bh4) | 0;
        lo = lo + Math.imul(al4, bl5) | 0;
        mid = mid + Math.imul(al4, bh5) | 0;
        mid = mid + Math.imul(ah4, bl5) | 0;
        hi = hi + Math.imul(ah4, bh5) | 0;
        lo = lo + Math.imul(al3, bl6) | 0;
        mid = mid + Math.imul(al3, bh6) | 0;
        mid = mid + Math.imul(ah3, bl6) | 0;
        hi = hi + Math.imul(ah3, bh6) | 0;
        lo = lo + Math.imul(al2, bl7) | 0;
        mid = mid + Math.imul(al2, bh7) | 0;
        mid = mid + Math.imul(ah2, bl7) | 0;
        hi = hi + Math.imul(ah2, bh7) | 0;
        lo = lo + Math.imul(al1, bl8) | 0;
        mid = mid + Math.imul(al1, bh8) | 0;
        mid = mid + Math.imul(ah1, bl8) | 0;
        hi = hi + Math.imul(ah1, bh8) | 0;
        lo = lo + Math.imul(al0, bl9) | 0;
        mid = mid + Math.imul(al0, bh9) | 0;
        mid = mid + Math.imul(ah0, bl9) | 0;
        hi = hi + Math.imul(ah0, bh9) | 0;
        var w9 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
        w9 &= 0x3ffffff;
        /* k = 10 */ lo = Math.imul(al9, bl1);
        mid = Math.imul(al9, bh1);
        mid = mid + Math.imul(ah9, bl1) | 0;
        hi = Math.imul(ah9, bh1);
        lo = lo + Math.imul(al8, bl2) | 0;
        mid = mid + Math.imul(al8, bh2) | 0;
        mid = mid + Math.imul(ah8, bl2) | 0;
        hi = hi + Math.imul(ah8, bh2) | 0;
        lo = lo + Math.imul(al7, bl3) | 0;
        mid = mid + Math.imul(al7, bh3) | 0;
        mid = mid + Math.imul(ah7, bl3) | 0;
        hi = hi + Math.imul(ah7, bh3) | 0;
        lo = lo + Math.imul(al6, bl4) | 0;
        mid = mid + Math.imul(al6, bh4) | 0;
        mid = mid + Math.imul(ah6, bl4) | 0;
        hi = hi + Math.imul(ah6, bh4) | 0;
        lo = lo + Math.imul(al5, bl5) | 0;
        mid = mid + Math.imul(al5, bh5) | 0;
        mid = mid + Math.imul(ah5, bl5) | 0;
        hi = hi + Math.imul(ah5, bh5) | 0;
        lo = lo + Math.imul(al4, bl6) | 0;
        mid = mid + Math.imul(al4, bh6) | 0;
        mid = mid + Math.imul(ah4, bl6) | 0;
        hi = hi + Math.imul(ah4, bh6) | 0;
        lo = lo + Math.imul(al3, bl7) | 0;
        mid = mid + Math.imul(al3, bh7) | 0;
        mid = mid + Math.imul(ah3, bl7) | 0;
        hi = hi + Math.imul(ah3, bh7) | 0;
        lo = lo + Math.imul(al2, bl8) | 0;
        mid = mid + Math.imul(al2, bh8) | 0;
        mid = mid + Math.imul(ah2, bl8) | 0;
        hi = hi + Math.imul(ah2, bh8) | 0;
        lo = lo + Math.imul(al1, bl9) | 0;
        mid = mid + Math.imul(al1, bh9) | 0;
        mid = mid + Math.imul(ah1, bl9) | 0;
        hi = hi + Math.imul(ah1, bh9) | 0;
        var w10 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
        w10 &= 0x3ffffff;
        /* k = 11 */ lo = Math.imul(al9, bl2);
        mid = Math.imul(al9, bh2);
        mid = mid + Math.imul(ah9, bl2) | 0;
        hi = Math.imul(ah9, bh2);
        lo = lo + Math.imul(al8, bl3) | 0;
        mid = mid + Math.imul(al8, bh3) | 0;
        mid = mid + Math.imul(ah8, bl3) | 0;
        hi = hi + Math.imul(ah8, bh3) | 0;
        lo = lo + Math.imul(al7, bl4) | 0;
        mid = mid + Math.imul(al7, bh4) | 0;
        mid = mid + Math.imul(ah7, bl4) | 0;
        hi = hi + Math.imul(ah7, bh4) | 0;
        lo = lo + Math.imul(al6, bl5) | 0;
        mid = mid + Math.imul(al6, bh5) | 0;
        mid = mid + Math.imul(ah6, bl5) | 0;
        hi = hi + Math.imul(ah6, bh5) | 0;
        lo = lo + Math.imul(al5, bl6) | 0;
        mid = mid + Math.imul(al5, bh6) | 0;
        mid = mid + Math.imul(ah5, bl6) | 0;
        hi = hi + Math.imul(ah5, bh6) | 0;
        lo = lo + Math.imul(al4, bl7) | 0;
        mid = mid + Math.imul(al4, bh7) | 0;
        mid = mid + Math.imul(ah4, bl7) | 0;
        hi = hi + Math.imul(ah4, bh7) | 0;
        lo = lo + Math.imul(al3, bl8) | 0;
        mid = mid + Math.imul(al3, bh8) | 0;
        mid = mid + Math.imul(ah3, bl8) | 0;
        hi = hi + Math.imul(ah3, bh8) | 0;
        lo = lo + Math.imul(al2, bl9) | 0;
        mid = mid + Math.imul(al2, bh9) | 0;
        mid = mid + Math.imul(ah2, bl9) | 0;
        hi = hi + Math.imul(ah2, bh9) | 0;
        var w11 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
        w11 &= 0x3ffffff;
        /* k = 12 */ lo = Math.imul(al9, bl3);
        mid = Math.imul(al9, bh3);
        mid = mid + Math.imul(ah9, bl3) | 0;
        hi = Math.imul(ah9, bh3);
        lo = lo + Math.imul(al8, bl4) | 0;
        mid = mid + Math.imul(al8, bh4) | 0;
        mid = mid + Math.imul(ah8, bl4) | 0;
        hi = hi + Math.imul(ah8, bh4) | 0;
        lo = lo + Math.imul(al7, bl5) | 0;
        mid = mid + Math.imul(al7, bh5) | 0;
        mid = mid + Math.imul(ah7, bl5) | 0;
        hi = hi + Math.imul(ah7, bh5) | 0;
        lo = lo + Math.imul(al6, bl6) | 0;
        mid = mid + Math.imul(al6, bh6) | 0;
        mid = mid + Math.imul(ah6, bl6) | 0;
        hi = hi + Math.imul(ah6, bh6) | 0;
        lo = lo + Math.imul(al5, bl7) | 0;
        mid = mid + Math.imul(al5, bh7) | 0;
        mid = mid + Math.imul(ah5, bl7) | 0;
        hi = hi + Math.imul(ah5, bh7) | 0;
        lo = lo + Math.imul(al4, bl8) | 0;
        mid = mid + Math.imul(al4, bh8) | 0;
        mid = mid + Math.imul(ah4, bl8) | 0;
        hi = hi + Math.imul(ah4, bh8) | 0;
        lo = lo + Math.imul(al3, bl9) | 0;
        mid = mid + Math.imul(al3, bh9) | 0;
        mid = mid + Math.imul(ah3, bl9) | 0;
        hi = hi + Math.imul(ah3, bh9) | 0;
        var w12 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
        w12 &= 0x3ffffff;
        /* k = 13 */ lo = Math.imul(al9, bl4);
        mid = Math.imul(al9, bh4);
        mid = mid + Math.imul(ah9, bl4) | 0;
        hi = Math.imul(ah9, bh4);
        lo = lo + Math.imul(al8, bl5) | 0;
        mid = mid + Math.imul(al8, bh5) | 0;
        mid = mid + Math.imul(ah8, bl5) | 0;
        hi = hi + Math.imul(ah8, bh5) | 0;
        lo = lo + Math.imul(al7, bl6) | 0;
        mid = mid + Math.imul(al7, bh6) | 0;
        mid = mid + Math.imul(ah7, bl6) | 0;
        hi = hi + Math.imul(ah7, bh6) | 0;
        lo = lo + Math.imul(al6, bl7) | 0;
        mid = mid + Math.imul(al6, bh7) | 0;
        mid = mid + Math.imul(ah6, bl7) | 0;
        hi = hi + Math.imul(ah6, bh7) | 0;
        lo = lo + Math.imul(al5, bl8) | 0;
        mid = mid + Math.imul(al5, bh8) | 0;
        mid = mid + Math.imul(ah5, bl8) | 0;
        hi = hi + Math.imul(ah5, bh8) | 0;
        lo = lo + Math.imul(al4, bl9) | 0;
        mid = mid + Math.imul(al4, bh9) | 0;
        mid = mid + Math.imul(ah4, bl9) | 0;
        hi = hi + Math.imul(ah4, bh9) | 0;
        var w13 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
        w13 &= 0x3ffffff;
        /* k = 14 */ lo = Math.imul(al9, bl5);
        mid = Math.imul(al9, bh5);
        mid = mid + Math.imul(ah9, bl5) | 0;
        hi = Math.imul(ah9, bh5);
        lo = lo + Math.imul(al8, bl6) | 0;
        mid = mid + Math.imul(al8, bh6) | 0;
        mid = mid + Math.imul(ah8, bl6) | 0;
        hi = hi + Math.imul(ah8, bh6) | 0;
        lo = lo + Math.imul(al7, bl7) | 0;
        mid = mid + Math.imul(al7, bh7) | 0;
        mid = mid + Math.imul(ah7, bl7) | 0;
        hi = hi + Math.imul(ah7, bh7) | 0;
        lo = lo + Math.imul(al6, bl8) | 0;
        mid = mid + Math.imul(al6, bh8) | 0;
        mid = mid + Math.imul(ah6, bl8) | 0;
        hi = hi + Math.imul(ah6, bh8) | 0;
        lo = lo + Math.imul(al5, bl9) | 0;
        mid = mid + Math.imul(al5, bh9) | 0;
        mid = mid + Math.imul(ah5, bl9) | 0;
        hi = hi + Math.imul(ah5, bh9) | 0;
        var w14 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
        w14 &= 0x3ffffff;
        /* k = 15 */ lo = Math.imul(al9, bl6);
        mid = Math.imul(al9, bh6);
        mid = mid + Math.imul(ah9, bl6) | 0;
        hi = Math.imul(ah9, bh6);
        lo = lo + Math.imul(al8, bl7) | 0;
        mid = mid + Math.imul(al8, bh7) | 0;
        mid = mid + Math.imul(ah8, bl7) | 0;
        hi = hi + Math.imul(ah8, bh7) | 0;
        lo = lo + Math.imul(al7, bl8) | 0;
        mid = mid + Math.imul(al7, bh8) | 0;
        mid = mid + Math.imul(ah7, bl8) | 0;
        hi = hi + Math.imul(ah7, bh8) | 0;
        lo = lo + Math.imul(al6, bl9) | 0;
        mid = mid + Math.imul(al6, bh9) | 0;
        mid = mid + Math.imul(ah6, bl9) | 0;
        hi = hi + Math.imul(ah6, bh9) | 0;
        var w15 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
        w15 &= 0x3ffffff;
        /* k = 16 */ lo = Math.imul(al9, bl7);
        mid = Math.imul(al9, bh7);
        mid = mid + Math.imul(ah9, bl7) | 0;
        hi = Math.imul(ah9, bh7);
        lo = lo + Math.imul(al8, bl8) | 0;
        mid = mid + Math.imul(al8, bh8) | 0;
        mid = mid + Math.imul(ah8, bl8) | 0;
        hi = hi + Math.imul(ah8, bh8) | 0;
        lo = lo + Math.imul(al7, bl9) | 0;
        mid = mid + Math.imul(al7, bh9) | 0;
        mid = mid + Math.imul(ah7, bl9) | 0;
        hi = hi + Math.imul(ah7, bh9) | 0;
        var w16 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
        w16 &= 0x3ffffff;
        /* k = 17 */ lo = Math.imul(al9, bl8);
        mid = Math.imul(al9, bh8);
        mid = mid + Math.imul(ah9, bl8) | 0;
        hi = Math.imul(ah9, bh8);
        lo = lo + Math.imul(al8, bl9) | 0;
        mid = mid + Math.imul(al8, bh9) | 0;
        mid = mid + Math.imul(ah8, bl9) | 0;
        hi = hi + Math.imul(ah8, bh9) | 0;
        var w17 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
        w17 &= 0x3ffffff;
        /* k = 18 */ lo = Math.imul(al9, bl9);
        mid = Math.imul(al9, bh9);
        mid = mid + Math.imul(ah9, bl9) | 0;
        hi = Math.imul(ah9, bh9);
        var w18 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
        w18 &= 0x3ffffff;
        o[0] = w0;
        o[1] = w1;
        o[2] = w2;
        o[3] = w3;
        o[4] = w4;
        o[5] = w5;
        o[6] = w6;
        o[7] = w7;
        o[8] = w8;
        o[9] = w9;
        o[10] = w10;
        o[11] = w11;
        o[12] = w12;
        o[13] = w13;
        o[14] = w14;
        o[15] = w15;
        o[16] = w16;
        o[17] = w17;
        o[18] = w18;
        if (c !== 0) {
            o[19] = c;
            out.length++;
        }
        return out;
    };
    // Polyfill comb
    if (!Math.imul) comb10MulTo = smallMulTo;
    function bigMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        out.length = self.length + num.length;
        var carry = 0;
        var hncarry = 0;
        for(var k = 0; k < out.length - 1; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = hncarry;
            hncarry = 0;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j;
                var a = self.words[i] | 0;
                var b = num.words[j] | 0;
                var r = a * b;
                var lo = r & 0x3ffffff;
                ncarry = ncarry + (r / 0x4000000 | 0) | 0;
                lo = lo + rword | 0;
                rword = lo & 0x3ffffff;
                ncarry = ncarry + (lo >>> 26) | 0;
                hncarry += ncarry >>> 26;
                ncarry &= 0x3ffffff;
            }
            out.words[k] = rword;
            carry = ncarry;
            ncarry = hncarry;
        }
        if (carry !== 0) out.words[k] = carry;
        else out.length--;
        return out._strip();
    }
    function jumboMulTo(self, num, out) {
        // Temporary disable, see https://github.com/indutny/bn.js/issues/211
        // var fftm = new FFTM();
        // return fftm.mulp(self, num, out);
        return bigMulTo(self, num, out);
    }
    BN.prototype.mulTo = function mulTo(num, out) {
        var res;
        var len = this.length + num.length;
        if (this.length === 10 && num.length === 10) res = comb10MulTo(this, num, out);
        else if (len < 63) res = smallMulTo(this, num, out);
        else if (len < 1024) res = bigMulTo(this, num, out);
        else res = jumboMulTo(this, num, out);
        return res;
    };
    // Cooley-Tukey algorithm for FFT
    // slightly revisited to rely on looping instead of recursion
    function FFTM(x, y) {
        this.x = x;
        this.y = y;
    }
    FFTM.prototype.makeRBT = function makeRBT(N) {
        var t = new Array(N);
        var l = BN.prototype._countBits(N) - 1;
        for(var i = 0; i < N; i++)t[i] = this.revBin(i, l, N);
        return t;
    };
    // Returns binary-reversed representation of `x`
    FFTM.prototype.revBin = function revBin(x, l, N) {
        if (x === 0 || x === N - 1) return x;
        var rb = 0;
        for(var i = 0; i < l; i++){
            rb |= (x & 1) << l - i - 1;
            x >>= 1;
        }
        return rb;
    };
    // Performs "tweedling" phase, therefore 'emulating'
    // behaviour of the recursive algorithm
    FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
        for(var i = 0; i < N; i++){
            rtws[i] = rws[rbt[i]];
            itws[i] = iws[rbt[i]];
        }
    };
    FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
        this.permute(rbt, rws, iws, rtws, itws, N);
        for(var s = 1; s < N; s <<= 1){
            var l = s << 1;
            var rtwdf = Math.cos(2 * Math.PI / l);
            var itwdf = Math.sin(2 * Math.PI / l);
            for(var p = 0; p < N; p += l){
                var rtwdf_ = rtwdf;
                var itwdf_ = itwdf;
                for(var j = 0; j < s; j++){
                    var re = rtws[p + j];
                    var ie = itws[p + j];
                    var ro = rtws[p + j + s];
                    var io = itws[p + j + s];
                    var rx = rtwdf_ * ro - itwdf_ * io;
                    io = rtwdf_ * io + itwdf_ * ro;
                    ro = rx;
                    rtws[p + j] = re + ro;
                    itws[p + j] = ie + io;
                    rtws[p + j + s] = re - ro;
                    itws[p + j + s] = ie - io;
                    /* jshint maxdepth : false */ if (j !== l) {
                        rx = rtwdf * rtwdf_ - itwdf * itwdf_;
                        itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                        rtwdf_ = rx;
                    }
                }
            }
        }
    };
    FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
        var N = Math.max(m, n) | 1;
        var odd = N & 1;
        var i = 0;
        for(N = N / 2 | 0; N; N = N >>> 1)i++;
        return 1 << i + 1 + odd;
    };
    FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
        if (N <= 1) return;
        for(var i = 0; i < N / 2; i++){
            var t = rws[i];
            rws[i] = rws[N - i - 1];
            rws[N - i - 1] = t;
            t = iws[i];
            iws[i] = -iws[N - i - 1];
            iws[N - i - 1] = -t;
        }
    };
    FFTM.prototype.normalize13b = function normalize13b(ws, N) {
        var carry = 0;
        for(var i = 0; i < N / 2; i++){
            var w = Math.round(ws[2 * i + 1] / N) * 0x2000 + Math.round(ws[2 * i] / N) + carry;
            ws[i] = w & 0x3ffffff;
            if (w < 0x4000000) carry = 0;
            else carry = w / 0x4000000 | 0;
        }
        return ws;
    };
    FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
        var carry = 0;
        for(var i = 0; i < len; i++){
            carry = carry + (ws[i] | 0);
            rws[2 * i] = carry & 0x1fff;
            carry = carry >>> 13;
            rws[2 * i + 1] = carry & 0x1fff;
            carry = carry >>> 13;
        }
        // Pad with zeroes
        for(i = 2 * len; i < N; ++i)rws[i] = 0;
        assert(carry === 0);
        assert((carry & -8192) === 0);
    };
    FFTM.prototype.stub = function stub(N) {
        var ph = new Array(N);
        for(var i = 0; i < N; i++)ph[i] = 0;
        return ph;
    };
    FFTM.prototype.mulp = function mulp(x, y, out) {
        var N = 2 * this.guessLen13b(x.length, y.length);
        var rbt = this.makeRBT(N);
        var _ = this.stub(N);
        var rws = new Array(N);
        var rwst = new Array(N);
        var iwst = new Array(N);
        var nrws = new Array(N);
        var nrwst = new Array(N);
        var niwst = new Array(N);
        var rmws = out.words;
        rmws.length = N;
        this.convert13b(x.words, x.length, rws, N);
        this.convert13b(y.words, y.length, nrws, N);
        this.transform(rws, _, rwst, iwst, N, rbt);
        this.transform(nrws, _, nrwst, niwst, N, rbt);
        for(var i = 0; i < N; i++){
            var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
            iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
            rwst[i] = rx;
        }
        this.conjugate(rwst, iwst, N);
        this.transform(rwst, iwst, rmws, _, N, rbt);
        this.conjugate(rmws, _, N);
        this.normalize13b(rmws, N);
        out.negative = x.negative ^ y.negative;
        out.length = x.length + y.length;
        return out._strip();
    };
    // Multiply `this` by `num`
    BN.prototype.mul = function mul(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return this.mulTo(num, out);
    };
    // Multiply employing FFT
    BN.prototype.mulf = function mulf(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return jumboMulTo(this, num, out);
    };
    // In-place Multiplication
    BN.prototype.imul = function imul(num) {
        return this.clone().mulTo(num, this);
    };
    BN.prototype.imuln = function imuln(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(typeof num === "number");
        assert(num < 0x4000000);
        // Carry
        var carry = 0;
        for(var i = 0; i < this.length; i++){
            var w = (this.words[i] | 0) * num;
            var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
            carry >>= 26;
            carry += w / 0x4000000 | 0;
            // NOTE: lo is 27bit maximum
            carry += lo >>> 26;
            this.words[i] = lo & 0x3ffffff;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return isNegNum ? this.ineg() : this;
    };
    BN.prototype.muln = function muln(num) {
        return this.clone().imuln(num);
    };
    // `this` * `this`
    BN.prototype.sqr = function sqr() {
        return this.mul(this);
    };
    // `this` * `this` in-place
    BN.prototype.isqr = function isqr() {
        return this.imul(this.clone());
    };
    // Math.pow(`this`, `num`)
    BN.prototype.pow = function pow(num) {
        var w = toBitArray(num);
        if (w.length === 0) return new BN(1);
        // Skip leading zeroes
        var res = this;
        for(var i = 0; i < w.length; i++, res = res.sqr()){
            if (w[i] !== 0) break;
        }
        if (++i < w.length) for(var q = res.sqr(); i < w.length; i++, q = q.sqr()){
            if (w[i] === 0) continue;
            res = res.mul(q);
        }
        return res;
    };
    // Shift-left in-place
    BN.prototype.iushln = function iushln(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        var carryMask = 0x3ffffff >>> 26 - r << 26 - r;
        var i;
        if (r !== 0) {
            var carry = 0;
            for(i = 0; i < this.length; i++){
                var newCarry = this.words[i] & carryMask;
                var c = (this.words[i] | 0) - newCarry << r;
                this.words[i] = c | carry;
                carry = newCarry >>> 26 - r;
            }
            if (carry) {
                this.words[i] = carry;
                this.length++;
            }
        }
        if (s !== 0) {
            for(i = this.length - 1; i >= 0; i--)this.words[i + s] = this.words[i];
            for(i = 0; i < s; i++)this.words[i] = 0;
            this.length += s;
        }
        return this._strip();
    };
    BN.prototype.ishln = function ishln(bits) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushln(bits);
    };
    // Shift-right in-place
    // NOTE: `hint` is a lowest bit before trailing zeroes
    // NOTE: if `extended` is present - it will be filled with destroyed bits
    BN.prototype.iushrn = function iushrn(bits, hint, extended) {
        assert(typeof bits === "number" && bits >= 0);
        var h;
        if (hint) h = (hint - hint % 26) / 26;
        else h = 0;
        var r = bits % 26;
        var s = Math.min((bits - r) / 26, this.length);
        var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
        var maskedWords = extended;
        h -= s;
        h = Math.max(0, h);
        // Extended mode, copy masked part
        if (maskedWords) {
            for(var i = 0; i < s; i++)maskedWords.words[i] = this.words[i];
            maskedWords.length = s;
        }
        if (s === 0) ;
        else if (this.length > s) {
            this.length -= s;
            for(i = 0; i < this.length; i++)this.words[i] = this.words[i + s];
        } else {
            this.words[0] = 0;
            this.length = 1;
        }
        var carry = 0;
        for(i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--){
            var word = this.words[i] | 0;
            this.words[i] = carry << 26 - r | word >>> r;
            carry = word & mask;
        }
        // Push carried bits as a mask
        if (maskedWords && carry !== 0) maskedWords.words[maskedWords.length++] = carry;
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this._strip();
    };
    BN.prototype.ishrn = function ishrn(bits, hint, extended) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushrn(bits, hint, extended);
    };
    // Shift-left
    BN.prototype.shln = function shln(bits) {
        return this.clone().ishln(bits);
    };
    BN.prototype.ushln = function ushln(bits) {
        return this.clone().iushln(bits);
    };
    // Shift-right
    BN.prototype.shrn = function shrn(bits) {
        return this.clone().ishrn(bits);
    };
    BN.prototype.ushrn = function ushrn(bits) {
        return this.clone().iushrn(bits);
    };
    // Test if n bit is set
    BN.prototype.testn = function testn(bit) {
        assert(typeof bit === "number" && bit >= 0);
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) return false;
        // Check bit and return
        var w = this.words[s];
        return !!(w & q);
    };
    // Return only lowers bits of number (in-place)
    BN.prototype.imaskn = function imaskn(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        assert(this.negative === 0, "imaskn works only with positive numbers");
        if (this.length <= s) return this;
        if (r !== 0) s++;
        this.length = Math.min(s, this.length);
        if (r !== 0) {
            var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
            this.words[this.length - 1] &= mask;
        }
        return this._strip();
    };
    // Return only lowers bits of number
    BN.prototype.maskn = function maskn(bits) {
        return this.clone().imaskn(bits);
    };
    // Add plain number `num` to `this`
    BN.prototype.iaddn = function iaddn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.isubn(-num);
        // Possible sign change
        if (this.negative !== 0) {
            if (this.length === 1 && (this.words[0] | 0) <= num) {
                this.words[0] = num - (this.words[0] | 0);
                this.negative = 0;
                return this;
            }
            this.negative = 0;
            this.isubn(num);
            this.negative = 1;
            return this;
        }
        // Add without checks
        return this._iaddn(num);
    };
    BN.prototype._iaddn = function _iaddn(num) {
        this.words[0] += num;
        // Carry
        for(var i = 0; i < this.length && this.words[i] >= 0x4000000; i++){
            this.words[i] -= 0x4000000;
            if (i === this.length - 1) this.words[i + 1] = 1;
            else this.words[i + 1]++;
        }
        this.length = Math.max(this.length, i + 1);
        return this;
    };
    // Subtract plain number `num` from `this`
    BN.prototype.isubn = function isubn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.iaddn(-num);
        if (this.negative !== 0) {
            this.negative = 0;
            this.iaddn(num);
            this.negative = 1;
            return this;
        }
        this.words[0] -= num;
        if (this.length === 1 && this.words[0] < 0) {
            this.words[0] = -this.words[0];
            this.negative = 1;
        } else // Carry
        for(var i = 0; i < this.length && this.words[i] < 0; i++){
            this.words[i] += 0x4000000;
            this.words[i + 1] -= 1;
        }
        return this._strip();
    };
    BN.prototype.addn = function addn(num) {
        return this.clone().iaddn(num);
    };
    BN.prototype.subn = function subn(num) {
        return this.clone().isubn(num);
    };
    BN.prototype.iabs = function iabs() {
        this.negative = 0;
        return this;
    };
    BN.prototype.abs = function abs() {
        return this.clone().iabs();
    };
    BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
        var len = num.length + shift;
        var i;
        this._expand(len);
        var w;
        var carry = 0;
        for(i = 0; i < num.length; i++){
            w = (this.words[i + shift] | 0) + carry;
            var right = (num.words[i] | 0) * mul;
            w -= right & 0x3ffffff;
            carry = (w >> 26) - (right / 0x4000000 | 0);
            this.words[i + shift] = w & 0x3ffffff;
        }
        for(; i < this.length - shift; i++){
            w = (this.words[i + shift] | 0) + carry;
            carry = w >> 26;
            this.words[i + shift] = w & 0x3ffffff;
        }
        if (carry === 0) return this._strip();
        // Subtraction overflow
        assert(carry === -1);
        carry = 0;
        for(i = 0; i < this.length; i++){
            w = -(this.words[i] | 0) + carry;
            carry = w >> 26;
            this.words[i] = w & 0x3ffffff;
        }
        this.negative = 1;
        return this._strip();
    };
    BN.prototype._wordDiv = function _wordDiv(num, mode) {
        var shift = this.length - num.length;
        var a = this.clone();
        var b = num;
        // Normalize
        var bhi = b.words[b.length - 1] | 0;
        var bhiBits = this._countBits(bhi);
        shift = 26 - bhiBits;
        if (shift !== 0) {
            b = b.ushln(shift);
            a.iushln(shift);
            bhi = b.words[b.length - 1] | 0;
        }
        // Initialize quotient
        var m = a.length - b.length;
        var q;
        if (mode !== "mod") {
            q = new BN(null);
            q.length = m + 1;
            q.words = new Array(q.length);
            for(var i = 0; i < q.length; i++)q.words[i] = 0;
        }
        var diff = a.clone()._ishlnsubmul(b, 1, m);
        if (diff.negative === 0) {
            a = diff;
            if (q) q.words[m] = 1;
        }
        for(var j = m - 1; j >= 0; j--){
            var qj = (a.words[b.length + j] | 0) * 0x4000000 + (a.words[b.length + j - 1] | 0);
            // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
            // (0x7ffffff)
            qj = Math.min(qj / bhi | 0, 0x3ffffff);
            a._ishlnsubmul(b, qj, j);
            while(a.negative !== 0){
                qj--;
                a.negative = 0;
                a._ishlnsubmul(b, 1, j);
                if (!a.isZero()) a.negative ^= 1;
            }
            if (q) q.words[j] = qj;
        }
        if (q) q._strip();
        a._strip();
        // Denormalize
        if (mode !== "div" && shift !== 0) a.iushrn(shift);
        return {
            div: q || null,
            mod: a
        };
    };
    // NOTE: 1) `mode` can be set to `mod` to request mod only,
    //       to `div` to request div only, or be absent to
    //       request both div & mod
    //       2) `positive` is true if unsigned mod is requested
    BN.prototype.divmod = function divmod(num, mode, positive) {
        assert(!num.isZero());
        if (this.isZero()) return {
            div: new BN(0),
            mod: new BN(0)
        };
        var div, mod, res;
        if (this.negative !== 0 && num.negative === 0) {
            res = this.neg().divmod(num, mode);
            if (mode !== "mod") div = res.div.neg();
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.iadd(num);
            }
            return {
                div: div,
                mod: mod
            };
        }
        if (this.negative === 0 && num.negative !== 0) {
            res = this.divmod(num.neg(), mode);
            if (mode !== "mod") div = res.div.neg();
            return {
                div: div,
                mod: res.mod
            };
        }
        if ((this.negative & num.negative) !== 0) {
            res = this.neg().divmod(num.neg(), mode);
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.isub(num);
            }
            return {
                div: res.div,
                mod: mod
            };
        }
        // Both numbers are positive at this point
        // Strip both numbers to approximate shift value
        if (num.length > this.length || this.cmp(num) < 0) return {
            div: new BN(0),
            mod: this
        };
        // Very short reduction
        if (num.length === 1) {
            if (mode === "div") return {
                div: this.divn(num.words[0]),
                mod: null
            };
            if (mode === "mod") return {
                div: null,
                mod: new BN(this.modrn(num.words[0]))
            };
            return {
                div: this.divn(num.words[0]),
                mod: new BN(this.modrn(num.words[0]))
            };
        }
        return this._wordDiv(num, mode);
    };
    // Find `this` / `num`
    BN.prototype.div = function div(num) {
        return this.divmod(num, "div", false).div;
    };
    // Find `this` % `num`
    BN.prototype.mod = function mod(num) {
        return this.divmod(num, "mod", false).mod;
    };
    BN.prototype.umod = function umod(num) {
        return this.divmod(num, "mod", true).mod;
    };
    // Find Round(`this` / `num`)
    BN.prototype.divRound = function divRound(num) {
        var dm = this.divmod(num);
        // Fast case - exact division
        if (dm.mod.isZero()) return dm.div;
        var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;
        var half = num.ushrn(1);
        var r2 = num.andln(1);
        var cmp = mod.cmp(half);
        // Round down
        if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
        // Round up
        return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
    };
    BN.prototype.modrn = function modrn(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(num <= 0x3ffffff);
        var p = 67108864 % num;
        var acc = 0;
        for(var i = this.length - 1; i >= 0; i--)acc = (p * acc + (this.words[i] | 0)) % num;
        return isNegNum ? -acc : acc;
    };
    // WARNING: DEPRECATED
    BN.prototype.modn = function modn(num) {
        return this.modrn(num);
    };
    // In-place division by number
    BN.prototype.idivn = function idivn(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(num <= 0x3ffffff);
        var carry = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var w = (this.words[i] | 0) + carry * 0x4000000;
            this.words[i] = w / num | 0;
            carry = w % num;
        }
        this._strip();
        return isNegNum ? this.ineg() : this;
    };
    BN.prototype.divn = function divn(num) {
        return this.clone().idivn(num);
    };
    BN.prototype.egcd = function egcd(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var x = this;
        var y = p.clone();
        if (x.negative !== 0) x = x.umod(p);
        else x = x.clone();
        // A * x + B * y = x
        var A = new BN(1);
        var B = new BN(0);
        // C * x + D * y = y
        var C = new BN(0);
        var D = new BN(1);
        var g = 0;
        while(x.isEven() && y.isEven()){
            x.iushrn(1);
            y.iushrn(1);
            ++g;
        }
        var yp = y.clone();
        var xp = x.clone();
        while(!x.isZero()){
            for(var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                x.iushrn(i);
                while(i-- > 0){
                    if (A.isOdd() || B.isOdd()) {
                        A.iadd(yp);
                        B.isub(xp);
                    }
                    A.iushrn(1);
                    B.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                y.iushrn(j);
                while(j-- > 0){
                    if (C.isOdd() || D.isOdd()) {
                        C.iadd(yp);
                        D.isub(xp);
                    }
                    C.iushrn(1);
                    D.iushrn(1);
                }
            }
            if (x.cmp(y) >= 0) {
                x.isub(y);
                A.isub(C);
                B.isub(D);
            } else {
                y.isub(x);
                C.isub(A);
                D.isub(B);
            }
        }
        return {
            a: C,
            b: D,
            gcd: y.iushln(g)
        };
    };
    // This is reduced incarnation of the binary EEA
    // above, designated to invert members of the
    // _prime_ fields F(p) at a maximal speed
    BN.prototype._invmp = function _invmp(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var a = this;
        var b = p.clone();
        if (a.negative !== 0) a = a.umod(p);
        else a = a.clone();
        var x1 = new BN(1);
        var x2 = new BN(0);
        var delta = b.clone();
        while(a.cmpn(1) > 0 && b.cmpn(1) > 0){
            for(var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                a.iushrn(i);
                while(i-- > 0){
                    if (x1.isOdd()) x1.iadd(delta);
                    x1.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                b.iushrn(j);
                while(j-- > 0){
                    if (x2.isOdd()) x2.iadd(delta);
                    x2.iushrn(1);
                }
            }
            if (a.cmp(b) >= 0) {
                a.isub(b);
                x1.isub(x2);
            } else {
                b.isub(a);
                x2.isub(x1);
            }
        }
        var res;
        if (a.cmpn(1) === 0) res = x1;
        else res = x2;
        if (res.cmpn(0) < 0) res.iadd(p);
        return res;
    };
    BN.prototype.gcd = function gcd(num) {
        if (this.isZero()) return num.abs();
        if (num.isZero()) return this.abs();
        var a = this.clone();
        var b = num.clone();
        a.negative = 0;
        b.negative = 0;
        // Remove common factor of two
        for(var shift = 0; a.isEven() && b.isEven(); shift++){
            a.iushrn(1);
            b.iushrn(1);
        }
        do {
            while(a.isEven())a.iushrn(1);
            while(b.isEven())b.iushrn(1);
            var r = a.cmp(b);
            if (r < 0) {
                // Swap `a` and `b` to make `a` always bigger than `b`
                var t = a;
                a = b;
                b = t;
            } else if (r === 0 || b.cmpn(1) === 0) break;
            a.isub(b);
        }while (true);
        return b.iushln(shift);
    };
    // Invert number in the field F(num)
    BN.prototype.invm = function invm(num) {
        return this.egcd(num).a.umod(num);
    };
    BN.prototype.isEven = function isEven() {
        return (this.words[0] & 1) === 0;
    };
    BN.prototype.isOdd = function isOdd() {
        return (this.words[0] & 1) === 1;
    };
    // And first word and num
    BN.prototype.andln = function andln(num) {
        return this.words[0] & num;
    };
    // Increment at the bit position in-line
    BN.prototype.bincn = function bincn(bit) {
        assert(typeof bit === "number");
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) {
            this._expand(s + 1);
            this.words[s] |= q;
            return this;
        }
        // Add bit and propagate, if needed
        var carry = q;
        for(var i = s; carry !== 0 && i < this.length; i++){
            var w = this.words[i] | 0;
            w += carry;
            carry = w >>> 26;
            w &= 0x3ffffff;
            this.words[i] = w;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.isZero = function isZero() {
        return this.length === 1 && this.words[0] === 0;
    };
    BN.prototype.cmpn = function cmpn(num) {
        var negative = num < 0;
        if (this.negative !== 0 && !negative) return -1;
        if (this.negative === 0 && negative) return 1;
        this._strip();
        var res;
        if (this.length > 1) res = 1;
        else {
            if (negative) num = -num;
            assert(num <= 0x3ffffff, "Number is too big");
            var w = this.words[0] | 0;
            res = w === num ? 0 : w < num ? -1 : 1;
        }
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Compare two numbers and return:
    // 1 - if `this` > `num`
    // 0 - if `this` == `num`
    // -1 - if `this` < `num`
    BN.prototype.cmp = function cmp(num) {
        if (this.negative !== 0 && num.negative === 0) return -1;
        if (this.negative === 0 && num.negative !== 0) return 1;
        var res = this.ucmp(num);
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Unsigned comparison
    BN.prototype.ucmp = function ucmp(num) {
        // At this point both numbers have the same sign
        if (this.length > num.length) return 1;
        if (this.length < num.length) return -1;
        var res = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var a = this.words[i] | 0;
            var b = num.words[i] | 0;
            if (a === b) continue;
            if (a < b) res = -1;
            else if (a > b) res = 1;
            break;
        }
        return res;
    };
    BN.prototype.gtn = function gtn(num) {
        return this.cmpn(num) === 1;
    };
    BN.prototype.gt = function gt(num) {
        return this.cmp(num) === 1;
    };
    BN.prototype.gten = function gten(num) {
        return this.cmpn(num) >= 0;
    };
    BN.prototype.gte = function gte(num) {
        return this.cmp(num) >= 0;
    };
    BN.prototype.ltn = function ltn(num) {
        return this.cmpn(num) === -1;
    };
    BN.prototype.lt = function lt(num) {
        return this.cmp(num) === -1;
    };
    BN.prototype.lten = function lten(num) {
        return this.cmpn(num) <= 0;
    };
    BN.prototype.lte = function lte(num) {
        return this.cmp(num) <= 0;
    };
    BN.prototype.eqn = function eqn(num) {
        return this.cmpn(num) === 0;
    };
    BN.prototype.eq = function eq(num) {
        return this.cmp(num) === 0;
    };
    //
    // A reduce context, could be using montgomery or something better, depending
    // on the `m` itself.
    //
    BN.red = function red(num) {
        return new Red(num);
    };
    BN.prototype.toRed = function toRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        assert(this.negative === 0, "red works only with positives");
        return ctx.convertTo(this)._forceRed(ctx);
    };
    BN.prototype.fromRed = function fromRed() {
        assert(this.red, "fromRed works only with numbers in reduction context");
        return this.red.convertFrom(this);
    };
    BN.prototype._forceRed = function _forceRed(ctx) {
        this.red = ctx;
        return this;
    };
    BN.prototype.forceRed = function forceRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        return this._forceRed(ctx);
    };
    BN.prototype.redAdd = function redAdd(num) {
        assert(this.red, "redAdd works only with red numbers");
        return this.red.add(this, num);
    };
    BN.prototype.redIAdd = function redIAdd(num) {
        assert(this.red, "redIAdd works only with red numbers");
        return this.red.iadd(this, num);
    };
    BN.prototype.redSub = function redSub(num) {
        assert(this.red, "redSub works only with red numbers");
        return this.red.sub(this, num);
    };
    BN.prototype.redISub = function redISub(num) {
        assert(this.red, "redISub works only with red numbers");
        return this.red.isub(this, num);
    };
    BN.prototype.redShl = function redShl(num) {
        assert(this.red, "redShl works only with red numbers");
        return this.red.shl(this, num);
    };
    BN.prototype.redMul = function redMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.mul(this, num);
    };
    BN.prototype.redIMul = function redIMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.imul(this, num);
    };
    BN.prototype.redSqr = function redSqr() {
        assert(this.red, "redSqr works only with red numbers");
        this.red._verify1(this);
        return this.red.sqr(this);
    };
    BN.prototype.redISqr = function redISqr() {
        assert(this.red, "redISqr works only with red numbers");
        this.red._verify1(this);
        return this.red.isqr(this);
    };
    // Square root over p
    BN.prototype.redSqrt = function redSqrt() {
        assert(this.red, "redSqrt works only with red numbers");
        this.red._verify1(this);
        return this.red.sqrt(this);
    };
    BN.prototype.redInvm = function redInvm() {
        assert(this.red, "redInvm works only with red numbers");
        this.red._verify1(this);
        return this.red.invm(this);
    };
    // Return negative clone of `this` % `red modulo`
    BN.prototype.redNeg = function redNeg() {
        assert(this.red, "redNeg works only with red numbers");
        this.red._verify1(this);
        return this.red.neg(this);
    };
    BN.prototype.redPow = function redPow(num) {
        assert(this.red && !num.red, "redPow(normalNum)");
        this.red._verify1(this);
        return this.red.pow(this, num);
    };
    // Prime numbers with efficient reduction
    var primes = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
    };
    // Pseudo-Mersenne prime
    function MPrime(name, p) {
        // P = 2 ^ N - K
        this.name = name;
        this.p = new BN(p, 16);
        this.n = this.p.bitLength();
        this.k = new BN(1).iushln(this.n).isub(this.p);
        this.tmp = this._tmp();
    }
    MPrime.prototype._tmp = function _tmp() {
        var tmp = new BN(null);
        tmp.words = new Array(Math.ceil(this.n / 13));
        return tmp;
    };
    MPrime.prototype.ireduce = function ireduce(num) {
        // Assumes that `num` is less than `P^2`
        // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
        var r = num;
        var rlen;
        do {
            this.split(r, this.tmp);
            r = this.imulK(r);
            r = r.iadd(this.tmp);
            rlen = r.bitLength();
        }while (rlen > this.n);
        var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
        if (cmp === 0) {
            r.words[0] = 0;
            r.length = 1;
        } else if (cmp > 0) r.isub(this.p);
        else if (r.strip !== undefined) // r is a BN v4 instance
        r.strip();
        else // r is a BN v5 instance
        r._strip();
        return r;
    };
    MPrime.prototype.split = function split(input, out) {
        input.iushrn(this.n, 0, out);
    };
    MPrime.prototype.imulK = function imulK(num) {
        return num.imul(this.k);
    };
    function K256() {
        MPrime.call(this, "k256", "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f");
    }
    inherits(K256, MPrime);
    K256.prototype.split = function split(input, output) {
        // 256 = 9 * 26 + 22
        var mask = 0x3fffff;
        var outLen = Math.min(input.length, 9);
        for(var i = 0; i < outLen; i++)output.words[i] = input.words[i];
        output.length = outLen;
        if (input.length <= 9) {
            input.words[0] = 0;
            input.length = 1;
            return;
        }
        // Shift by 9 limbs
        var prev = input.words[9];
        output.words[output.length++] = prev & mask;
        for(i = 10; i < input.length; i++){
            var next = input.words[i] | 0;
            input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
            prev = next;
        }
        prev >>>= 22;
        input.words[i - 10] = prev;
        if (prev === 0 && input.length > 10) input.length -= 10;
        else input.length -= 9;
    };
    K256.prototype.imulK = function imulK(num) {
        // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
        num.words[num.length] = 0;
        num.words[num.length + 1] = 0;
        num.length += 2;
        // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
        var lo = 0;
        for(var i = 0; i < num.length; i++){
            var w = num.words[i] | 0;
            lo += w * 0x3d1;
            num.words[i] = lo & 0x3ffffff;
            lo = w * 0x40 + (lo / 0x4000000 | 0);
        }
        // Fast length reduction
        if (num.words[num.length - 1] === 0) {
            num.length--;
            if (num.words[num.length - 1] === 0) num.length--;
        }
        return num;
    };
    function P224() {
        MPrime.call(this, "p224", "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001");
    }
    inherits(P224, MPrime);
    function P192() {
        MPrime.call(this, "p192", "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff");
    }
    inherits(P192, MPrime);
    function P25519() {
        // 2 ^ 255 - 19
        MPrime.call(this, "25519", "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed");
    }
    inherits(P25519, MPrime);
    P25519.prototype.imulK = function imulK(num) {
        // K = 0x13
        var carry = 0;
        for(var i = 0; i < num.length; i++){
            var hi = (num.words[i] | 0) * 0x13 + carry;
            var lo = hi & 0x3ffffff;
            hi >>>= 26;
            num.words[i] = lo;
            carry = hi;
        }
        if (carry !== 0) num.words[num.length++] = carry;
        return num;
    };
    // Exported mostly for testing purposes, use plain name instead
    BN._prime = function prime(name) {
        // Cached version of prime
        if (primes[name]) return primes[name];
        var prime;
        if (name === "k256") prime = new K256();
        else if (name === "p224") prime = new P224();
        else if (name === "p192") prime = new P192();
        else if (name === "p25519") prime = new P25519();
        else throw new Error("Unknown prime " + name);
        primes[name] = prime;
        return prime;
    };
    //
    // Base reduction engine
    //
    function Red(m) {
        if (typeof m === "string") {
            var prime = BN._prime(m);
            this.m = prime.p;
            this.prime = prime;
        } else {
            assert(m.gtn(1), "modulus must be greater than 1");
            this.m = m;
            this.prime = null;
        }
    }
    Red.prototype._verify1 = function _verify1(a) {
        assert(a.negative === 0, "red works only with positives");
        assert(a.red, "red works only with red numbers");
    };
    Red.prototype._verify2 = function _verify2(a, b) {
        assert((a.negative | b.negative) === 0, "red works only with positives");
        assert(a.red && a.red === b.red, "red works only with red numbers");
    };
    Red.prototype.imod = function imod(a) {
        if (this.prime) return this.prime.ireduce(a)._forceRed(this);
        move(a, a.umod(this.m)._forceRed(this));
        return a;
    };
    Red.prototype.neg = function neg(a) {
        if (a.isZero()) return a.clone();
        return this.m.sub(a)._forceRed(this);
    };
    Red.prototype.add = function add(a, b) {
        this._verify2(a, b);
        var res = a.add(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res._forceRed(this);
    };
    Red.prototype.iadd = function iadd(a, b) {
        this._verify2(a, b);
        var res = a.iadd(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res;
    };
    Red.prototype.sub = function sub(a, b) {
        this._verify2(a, b);
        var res = a.sub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res._forceRed(this);
    };
    Red.prototype.isub = function isub(a, b) {
        this._verify2(a, b);
        var res = a.isub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res;
    };
    Red.prototype.shl = function shl(a, num) {
        this._verify1(a);
        return this.imod(a.ushln(num));
    };
    Red.prototype.imul = function imul(a, b) {
        this._verify2(a, b);
        return this.imod(a.imul(b));
    };
    Red.prototype.mul = function mul(a, b) {
        this._verify2(a, b);
        return this.imod(a.mul(b));
    };
    Red.prototype.isqr = function isqr(a) {
        return this.imul(a, a.clone());
    };
    Red.prototype.sqr = function sqr(a) {
        return this.mul(a, a);
    };
    Red.prototype.sqrt = function sqrt(a) {
        if (a.isZero()) return a.clone();
        var mod3 = this.m.andln(3);
        assert(mod3 % 2 === 1);
        // Fast case
        if (mod3 === 3) {
            var pow = this.m.add(new BN(1)).iushrn(2);
            return this.pow(a, pow);
        }
        // Tonelli-Shanks algorithm (Totally unoptimized and slow)
        //
        // Find Q and S, that Q * 2 ^ S = (P - 1)
        var q = this.m.subn(1);
        var s = 0;
        while(!q.isZero() && q.andln(1) === 0){
            s++;
            q.iushrn(1);
        }
        assert(!q.isZero());
        var one = new BN(1).toRed(this);
        var nOne = one.redNeg();
        // Find quadratic non-residue
        // NOTE: Max is such because of generalized Riemann hypothesis.
        var lpow = this.m.subn(1).iushrn(1);
        var z = this.m.bitLength();
        z = new BN(2 * z * z).toRed(this);
        while(this.pow(z, lpow).cmp(nOne) !== 0)z.redIAdd(nOne);
        var c = this.pow(z, q);
        var r = this.pow(a, q.addn(1).iushrn(1));
        var t = this.pow(a, q);
        var m = s;
        while(t.cmp(one) !== 0){
            var tmp = t;
            for(var i = 0; tmp.cmp(one) !== 0; i++)tmp = tmp.redSqr();
            assert(i < m);
            var b = this.pow(c, new BN(1).iushln(m - i - 1));
            r = r.redMul(b);
            c = b.redSqr();
            t = t.redMul(c);
            m = i;
        }
        return r;
    };
    Red.prototype.invm = function invm(a) {
        var inv = a._invmp(this.m);
        if (inv.negative !== 0) {
            inv.negative = 0;
            return this.imod(inv).redNeg();
        } else return this.imod(inv);
    };
    Red.prototype.pow = function pow(a, num) {
        if (num.isZero()) return new BN(1).toRed(this);
        if (num.cmpn(1) === 0) return a.clone();
        var windowSize = 4;
        var wnd = new Array(1 << windowSize);
        wnd[0] = new BN(1).toRed(this);
        wnd[1] = a;
        for(var i = 2; i < wnd.length; i++)wnd[i] = this.mul(wnd[i - 1], a);
        var res = wnd[0];
        var current = 0;
        var currentLen = 0;
        var start = num.bitLength() % 26;
        if (start === 0) start = 26;
        for(i = num.length - 1; i >= 0; i--){
            var word = num.words[i];
            for(var j = start - 1; j >= 0; j--){
                var bit = word >> j & 1;
                if (res !== wnd[0]) res = this.sqr(res);
                if (bit === 0 && current === 0) {
                    currentLen = 0;
                    continue;
                }
                current <<= 1;
                current |= bit;
                currentLen++;
                if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
                res = this.mul(res, wnd[current]);
                currentLen = 0;
                current = 0;
            }
            start = 26;
        }
        return res;
    };
    Red.prototype.convertTo = function convertTo(num) {
        var r = num.umod(this.m);
        return r === num ? r.clone() : r;
    };
    Red.prototype.convertFrom = function convertFrom(num) {
        var res = num.clone();
        res.red = null;
        return res;
    };
    //
    // Montgomery method engine
    //
    BN.mont = function mont(num) {
        return new Mont(num);
    };
    function Mont(m) {
        Red.call(this, m);
        this.shift = this.m.bitLength();
        if (this.shift % 26 !== 0) this.shift += 26 - this.shift % 26;
        this.r = new BN(1).iushln(this.shift);
        this.r2 = this.imod(this.r.sqr());
        this.rinv = this.r._invmp(this.m);
        this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
        this.minv = this.minv.umod(this.r);
        this.minv = this.r.sub(this.minv);
    }
    inherits(Mont, Red);
    Mont.prototype.convertTo = function convertTo(num) {
        return this.imod(num.ushln(this.shift));
    };
    Mont.prototype.convertFrom = function convertFrom(num) {
        var r = this.imod(num.mul(this.rinv));
        r.red = null;
        return r;
    };
    Mont.prototype.imul = function imul(a, b) {
        if (a.isZero() || b.isZero()) {
            a.words[0] = 0;
            a.length = 1;
            return a;
        }
        var t = a.imul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.mul = function mul(a, b) {
        if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
        var t = a.mul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.invm = function invm(a) {
        // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
        var res = this.imod(a._invmp(this.m).mul(this.r2));
        return res._forceRed(this);
    };
})(module, this);

},{"7e4fa78919672b87":"13Pcp"}],"dElqS":[function(require,module,exports) {
var hash = exports;
hash.utils = require("38593959f18bd562");
hash.common = require("31a457752237e8ad");
hash.sha = require("3e37816d2a2fd68d");
hash.ripemd = require("ce5a13b5bd10f171");
hash.hmac = require("c32fbac97a361580");
// Proxy hash functions to the main object
hash.sha1 = hash.sha.sha1;
hash.sha256 = hash.sha.sha256;
hash.sha224 = hash.sha.sha224;
hash.sha384 = hash.sha.sha384;
hash.sha512 = hash.sha.sha512;
hash.ripemd160 = hash.ripemd.ripemd160;

},{"38593959f18bd562":"gaAPT","31a457752237e8ad":"1z68J","3e37816d2a2fd68d":"ckm08","ce5a13b5bd10f171":"jxx9f","c32fbac97a361580":"fbLYV"}],"gaAPT":[function(require,module,exports) {
"use strict";
var assert = require("6002b0feade022a4");
var inherits = require("d4826c9d0ff1b1f");
exports.inherits = inherits;
function isSurrogatePair(msg, i) {
    if ((msg.charCodeAt(i) & 0xFC00) !== 0xD800) return false;
    if (i < 0 || i + 1 >= msg.length) return false;
    return (msg.charCodeAt(i + 1) & 0xFC00) === 0xDC00;
}
function toArray(msg, enc) {
    if (Array.isArray(msg)) return msg.slice();
    if (!msg) return [];
    var res = [];
    if (typeof msg === "string") {
        if (!enc) {
            // Inspired by stringToUtf8ByteArray() in closure-library by Google
            // https://github.com/google/closure-library/blob/8598d87242af59aac233270742c8984e2b2bdbe0/closure/goog/crypt/crypt.js#L117-L143
            // Apache License 2.0
            // https://github.com/google/closure-library/blob/master/LICENSE
            var p = 0;
            for(var i = 0; i < msg.length; i++){
                var c = msg.charCodeAt(i);
                if (c < 128) res[p++] = c;
                else if (c < 2048) {
                    res[p++] = c >> 6 | 192;
                    res[p++] = c & 63 | 128;
                } else if (isSurrogatePair(msg, i)) {
                    c = 0x10000 + ((c & 0x03FF) << 10) + (msg.charCodeAt(++i) & 0x03FF);
                    res[p++] = c >> 18 | 240;
                    res[p++] = c >> 12 & 63 | 128;
                    res[p++] = c >> 6 & 63 | 128;
                    res[p++] = c & 63 | 128;
                } else {
                    res[p++] = c >> 12 | 224;
                    res[p++] = c >> 6 & 63 | 128;
                    res[p++] = c & 63 | 128;
                }
            }
        } else if (enc === "hex") {
            msg = msg.replace(/[^a-z0-9]+/ig, "");
            if (msg.length % 2 !== 0) msg = "0" + msg;
            for(i = 0; i < msg.length; i += 2)res.push(parseInt(msg[i] + msg[i + 1], 16));
        }
    } else for(i = 0; i < msg.length; i++)res[i] = msg[i] | 0;
    return res;
}
exports.toArray = toArray;
function toHex(msg) {
    var res = "";
    for(var i = 0; i < msg.length; i++)res += zero2(msg[i].toString(16));
    return res;
}
exports.toHex = toHex;
function htonl(w) {
    var res = w >>> 24 | w >>> 8 & 0xff00 | w << 8 & 0xff0000 | (w & 0xff) << 24;
    return res >>> 0;
}
exports.htonl = htonl;
function toHex32(msg, endian) {
    var res = "";
    for(var i = 0; i < msg.length; i++){
        var w = msg[i];
        if (endian === "little") w = htonl(w);
        res += zero8(w.toString(16));
    }
    return res;
}
exports.toHex32 = toHex32;
function zero2(word) {
    if (word.length === 1) return "0" + word;
    else return word;
}
exports.zero2 = zero2;
function zero8(word) {
    if (word.length === 7) return "0" + word;
    else if (word.length === 6) return "00" + word;
    else if (word.length === 5) return "000" + word;
    else if (word.length === 4) return "0000" + word;
    else if (word.length === 3) return "00000" + word;
    else if (word.length === 2) return "000000" + word;
    else if (word.length === 1) return "0000000" + word;
    else return word;
}
exports.zero8 = zero8;
function join32(msg, start, end, endian) {
    var len = end - start;
    assert(len % 4 === 0);
    var res = new Array(len / 4);
    for(var i = 0, k = start; i < res.length; i++, k += 4){
        var w;
        if (endian === "big") w = msg[k] << 24 | msg[k + 1] << 16 | msg[k + 2] << 8 | msg[k + 3];
        else w = msg[k + 3] << 24 | msg[k + 2] << 16 | msg[k + 1] << 8 | msg[k];
        res[i] = w >>> 0;
    }
    return res;
}
exports.join32 = join32;
function split32(msg, endian) {
    var res = new Array(msg.length * 4);
    for(var i = 0, k = 0; i < msg.length; i++, k += 4){
        var m = msg[i];
        if (endian === "big") {
            res[k] = m >>> 24;
            res[k + 1] = m >>> 16 & 0xff;
            res[k + 2] = m >>> 8 & 0xff;
            res[k + 3] = m & 0xff;
        } else {
            res[k + 3] = m >>> 24;
            res[k + 2] = m >>> 16 & 0xff;
            res[k + 1] = m >>> 8 & 0xff;
            res[k] = m & 0xff;
        }
    }
    return res;
}
exports.split32 = split32;
function rotr32(w, b) {
    return w >>> b | w << 32 - b;
}
exports.rotr32 = rotr32;
function rotl32(w, b) {
    return w << b | w >>> 32 - b;
}
exports.rotl32 = rotl32;
function sum32(a, b) {
    return a + b >>> 0;
}
exports.sum32 = sum32;
function sum32_3(a, b, c) {
    return a + b + c >>> 0;
}
exports.sum32_3 = sum32_3;
function sum32_4(a, b, c, d) {
    return a + b + c + d >>> 0;
}
exports.sum32_4 = sum32_4;
function sum32_5(a, b, c, d, e) {
    return a + b + c + d + e >>> 0;
}
exports.sum32_5 = sum32_5;
function sum64(buf, pos, ah, al) {
    var bh = buf[pos];
    var bl = buf[pos + 1];
    var lo = al + bl >>> 0;
    var hi = (lo < al ? 1 : 0) + ah + bh;
    buf[pos] = hi >>> 0;
    buf[pos + 1] = lo;
}
exports.sum64 = sum64;
function sum64_hi(ah, al, bh, bl) {
    var lo = al + bl >>> 0;
    var hi = (lo < al ? 1 : 0) + ah + bh;
    return hi >>> 0;
}
exports.sum64_hi = sum64_hi;
function sum64_lo(ah, al, bh, bl) {
    var lo = al + bl;
    return lo >>> 0;
}
exports.sum64_lo = sum64_lo;
function sum64_4_hi(ah, al, bh, bl, ch, cl, dh, dl) {
    var carry = 0;
    var lo = al;
    lo = lo + bl >>> 0;
    carry += lo < al ? 1 : 0;
    lo = lo + cl >>> 0;
    carry += lo < cl ? 1 : 0;
    lo = lo + dl >>> 0;
    carry += lo < dl ? 1 : 0;
    var hi = ah + bh + ch + dh + carry;
    return hi >>> 0;
}
exports.sum64_4_hi = sum64_4_hi;
function sum64_4_lo(ah, al, bh, bl, ch, cl, dh, dl) {
    var lo = al + bl + cl + dl;
    return lo >>> 0;
}
exports.sum64_4_lo = sum64_4_lo;
function sum64_5_hi(ah, al, bh, bl, ch, cl, dh, dl, eh, el) {
    var carry = 0;
    var lo = al;
    lo = lo + bl >>> 0;
    carry += lo < al ? 1 : 0;
    lo = lo + cl >>> 0;
    carry += lo < cl ? 1 : 0;
    lo = lo + dl >>> 0;
    carry += lo < dl ? 1 : 0;
    lo = lo + el >>> 0;
    carry += lo < el ? 1 : 0;
    var hi = ah + bh + ch + dh + eh + carry;
    return hi >>> 0;
}
exports.sum64_5_hi = sum64_5_hi;
function sum64_5_lo(ah, al, bh, bl, ch, cl, dh, dl, eh, el) {
    var lo = al + bl + cl + dl + el;
    return lo >>> 0;
}
exports.sum64_5_lo = sum64_5_lo;
function rotr64_hi(ah, al, num) {
    var r = al << 32 - num | ah >>> num;
    return r >>> 0;
}
exports.rotr64_hi = rotr64_hi;
function rotr64_lo(ah, al, num) {
    var r = ah << 32 - num | al >>> num;
    return r >>> 0;
}
exports.rotr64_lo = rotr64_lo;
function shr64_hi(ah, al, num) {
    return ah >>> num;
}
exports.shr64_hi = shr64_hi;
function shr64_lo(ah, al, num) {
    var r = ah << 32 - num | al >>> num;
    return r >>> 0;
}
exports.shr64_lo = shr64_lo;

},{"6002b0feade022a4":"cKbUa","d4826c9d0ff1b1f":"8LxVj"}],"cKbUa":[function(require,module,exports) {
module.exports = assert;
function assert(val, msg) {
    if (!val) throw new Error(msg || "Assertion failed");
}
assert.equal = function assertEqual(l, r, msg) {
    if (l != r) throw new Error(msg || "Assertion failed: " + l + " != " + r);
};

},{}],"1z68J":[function(require,module,exports) {
"use strict";
var utils = require("e9291abdfb47ee4f");
var assert = require("ea8841b701712638");
function BlockHash() {
    this.pending = null;
    this.pendingTotal = 0;
    this.blockSize = this.constructor.blockSize;
    this.outSize = this.constructor.outSize;
    this.hmacStrength = this.constructor.hmacStrength;
    this.padLength = this.constructor.padLength / 8;
    this.endian = "big";
    this._delta8 = this.blockSize / 8;
    this._delta32 = this.blockSize / 32;
}
exports.BlockHash = BlockHash;
BlockHash.prototype.update = function update(msg, enc) {
    // Convert message to array, pad it, and join into 32bit blocks
    msg = utils.toArray(msg, enc);
    if (!this.pending) this.pending = msg;
    else this.pending = this.pending.concat(msg);
    this.pendingTotal += msg.length;
    // Enough data, try updating
    if (this.pending.length >= this._delta8) {
        msg = this.pending;
        // Process pending data in blocks
        var r = msg.length % this._delta8;
        this.pending = msg.slice(msg.length - r, msg.length);
        if (this.pending.length === 0) this.pending = null;
        msg = utils.join32(msg, 0, msg.length - r, this.endian);
        for(var i = 0; i < msg.length; i += this._delta32)this._update(msg, i, i + this._delta32);
    }
    return this;
};
BlockHash.prototype.digest = function digest(enc) {
    this.update(this._pad());
    assert(this.pending === null);
    return this._digest(enc);
};
BlockHash.prototype._pad = function pad() {
    var len = this.pendingTotal;
    var bytes = this._delta8;
    var k = bytes - (len + this.padLength) % bytes;
    var res = new Array(k + this.padLength);
    res[0] = 0x80;
    for(var i = 1; i < k; i++)res[i] = 0;
    // Append length
    len <<= 3;
    if (this.endian === "big") {
        for(var t = 8; t < this.padLength; t++)res[i++] = 0;
        res[i++] = 0;
        res[i++] = 0;
        res[i++] = 0;
        res[i++] = 0;
        res[i++] = len >>> 24 & 0xff;
        res[i++] = len >>> 16 & 0xff;
        res[i++] = len >>> 8 & 0xff;
        res[i++] = len & 0xff;
    } else {
        res[i++] = len & 0xff;
        res[i++] = len >>> 8 & 0xff;
        res[i++] = len >>> 16 & 0xff;
        res[i++] = len >>> 24 & 0xff;
        res[i++] = 0;
        res[i++] = 0;
        res[i++] = 0;
        res[i++] = 0;
        for(t = 8; t < this.padLength; t++)res[i++] = 0;
    }
    return res;
};

},{"e9291abdfb47ee4f":"gaAPT","ea8841b701712638":"cKbUa"}],"ckm08":[function(require,module,exports) {
"use strict";
exports.sha1 = require("3835379564860fd7");
exports.sha224 = require("bb9f72f042233648");
exports.sha256 = require("20a3b0fa42e37dfe");
exports.sha384 = require("ad4827efa7d953c2");
exports.sha512 = require("301292595a944c1d");

},{"3835379564860fd7":"h9TRQ","bb9f72f042233648":"4rHQO","20a3b0fa42e37dfe":"dM6zL","ad4827efa7d953c2":"2OiZQ","301292595a944c1d":"gqcqX"}],"h9TRQ":[function(require,module,exports) {
"use strict";
var utils = require("b75f3c1442bf9100");
var common = require("a29e68029e4c48f8");
var shaCommon = require("1be62f90a237cba5");
var rotl32 = utils.rotl32;
var sum32 = utils.sum32;
var sum32_5 = utils.sum32_5;
var ft_1 = shaCommon.ft_1;
var BlockHash = common.BlockHash;
var sha1_K = [
    0x5A827999,
    0x6ED9EBA1,
    0x8F1BBCDC,
    0xCA62C1D6
];
function SHA1() {
    if (!(this instanceof SHA1)) return new SHA1();
    BlockHash.call(this);
    this.h = [
        0x67452301,
        0xefcdab89,
        0x98badcfe,
        0x10325476,
        0xc3d2e1f0
    ];
    this.W = new Array(80);
}
utils.inherits(SHA1, BlockHash);
module.exports = SHA1;
SHA1.blockSize = 512;
SHA1.outSize = 160;
SHA1.hmacStrength = 80;
SHA1.padLength = 64;
SHA1.prototype._update = function _update(msg, start) {
    var W = this.W;
    for(var i = 0; i < 16; i++)W[i] = msg[start + i];
    for(; i < W.length; i++)W[i] = rotl32(W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16], 1);
    var a = this.h[0];
    var b = this.h[1];
    var c = this.h[2];
    var d = this.h[3];
    var e = this.h[4];
    for(i = 0; i < W.length; i++){
        var s = ~~(i / 20);
        var t = sum32_5(rotl32(a, 5), ft_1(s, b, c, d), e, W[i], sha1_K[s]);
        e = d;
        d = c;
        c = rotl32(b, 30);
        b = a;
        a = t;
    }
    this.h[0] = sum32(this.h[0], a);
    this.h[1] = sum32(this.h[1], b);
    this.h[2] = sum32(this.h[2], c);
    this.h[3] = sum32(this.h[3], d);
    this.h[4] = sum32(this.h[4], e);
};
SHA1.prototype._digest = function digest(enc) {
    if (enc === "hex") return utils.toHex32(this.h, "big");
    else return utils.split32(this.h, "big");
};

},{"b75f3c1442bf9100":"gaAPT","a29e68029e4c48f8":"1z68J","1be62f90a237cba5":"gx3FZ"}],"gx3FZ":[function(require,module,exports) {
"use strict";
var utils = require("f0fb61f828bacd0f");
var rotr32 = utils.rotr32;
function ft_1(s, x, y, z) {
    if (s === 0) return ch32(x, y, z);
    if (s === 1 || s === 3) return p32(x, y, z);
    if (s === 2) return maj32(x, y, z);
}
exports.ft_1 = ft_1;
function ch32(x, y, z) {
    return x & y ^ ~x & z;
}
exports.ch32 = ch32;
function maj32(x, y, z) {
    return x & y ^ x & z ^ y & z;
}
exports.maj32 = maj32;
function p32(x, y, z) {
    return x ^ y ^ z;
}
exports.p32 = p32;
function s0_256(x) {
    return rotr32(x, 2) ^ rotr32(x, 13) ^ rotr32(x, 22);
}
exports.s0_256 = s0_256;
function s1_256(x) {
    return rotr32(x, 6) ^ rotr32(x, 11) ^ rotr32(x, 25);
}
exports.s1_256 = s1_256;
function g0_256(x) {
    return rotr32(x, 7) ^ rotr32(x, 18) ^ x >>> 3;
}
exports.g0_256 = g0_256;
function g1_256(x) {
    return rotr32(x, 17) ^ rotr32(x, 19) ^ x >>> 10;
}
exports.g1_256 = g1_256;

},{"f0fb61f828bacd0f":"gaAPT"}],"4rHQO":[function(require,module,exports) {
"use strict";
var utils = require("fe5acd040463c159");
var SHA256 = require("fa3503eda3738d05");
function SHA224() {
    if (!(this instanceof SHA224)) return new SHA224();
    SHA256.call(this);
    this.h = [
        0xc1059ed8,
        0x367cd507,
        0x3070dd17,
        0xf70e5939,
        0xffc00b31,
        0x68581511,
        0x64f98fa7,
        0xbefa4fa4
    ];
}
utils.inherits(SHA224, SHA256);
module.exports = SHA224;
SHA224.blockSize = 512;
SHA224.outSize = 224;
SHA224.hmacStrength = 192;
SHA224.padLength = 64;
SHA224.prototype._digest = function digest(enc) {
    // Just truncate output
    if (enc === "hex") return utils.toHex32(this.h.slice(0, 7), "big");
    else return utils.split32(this.h.slice(0, 7), "big");
};

},{"fe5acd040463c159":"gaAPT","fa3503eda3738d05":"dM6zL"}],"dM6zL":[function(require,module,exports) {
"use strict";
var utils = require("32ad3e510bd41f2a");
var common = require("469ad88ad505772a");
var shaCommon = require("fffa7d1ddf1f0b43");
var assert = require("126369f57b5225ed");
var sum32 = utils.sum32;
var sum32_4 = utils.sum32_4;
var sum32_5 = utils.sum32_5;
var ch32 = shaCommon.ch32;
var maj32 = shaCommon.maj32;
var s0_256 = shaCommon.s0_256;
var s1_256 = shaCommon.s1_256;
var g0_256 = shaCommon.g0_256;
var g1_256 = shaCommon.g1_256;
var BlockHash = common.BlockHash;
var sha256_K = [
    0x428a2f98,
    0x71374491,
    0xb5c0fbcf,
    0xe9b5dba5,
    0x3956c25b,
    0x59f111f1,
    0x923f82a4,
    0xab1c5ed5,
    0xd807aa98,
    0x12835b01,
    0x243185be,
    0x550c7dc3,
    0x72be5d74,
    0x80deb1fe,
    0x9bdc06a7,
    0xc19bf174,
    0xe49b69c1,
    0xefbe4786,
    0x0fc19dc6,
    0x240ca1cc,
    0x2de92c6f,
    0x4a7484aa,
    0x5cb0a9dc,
    0x76f988da,
    0x983e5152,
    0xa831c66d,
    0xb00327c8,
    0xbf597fc7,
    0xc6e00bf3,
    0xd5a79147,
    0x06ca6351,
    0x14292967,
    0x27b70a85,
    0x2e1b2138,
    0x4d2c6dfc,
    0x53380d13,
    0x650a7354,
    0x766a0abb,
    0x81c2c92e,
    0x92722c85,
    0xa2bfe8a1,
    0xa81a664b,
    0xc24b8b70,
    0xc76c51a3,
    0xd192e819,
    0xd6990624,
    0xf40e3585,
    0x106aa070,
    0x19a4c116,
    0x1e376c08,
    0x2748774c,
    0x34b0bcb5,
    0x391c0cb3,
    0x4ed8aa4a,
    0x5b9cca4f,
    0x682e6ff3,
    0x748f82ee,
    0x78a5636f,
    0x84c87814,
    0x8cc70208,
    0x90befffa,
    0xa4506ceb,
    0xbef9a3f7,
    0xc67178f2
];
function SHA256() {
    if (!(this instanceof SHA256)) return new SHA256();
    BlockHash.call(this);
    this.h = [
        0x6a09e667,
        0xbb67ae85,
        0x3c6ef372,
        0xa54ff53a,
        0x510e527f,
        0x9b05688c,
        0x1f83d9ab,
        0x5be0cd19
    ];
    this.k = sha256_K;
    this.W = new Array(64);
}
utils.inherits(SHA256, BlockHash);
module.exports = SHA256;
SHA256.blockSize = 512;
SHA256.outSize = 256;
SHA256.hmacStrength = 192;
SHA256.padLength = 64;
SHA256.prototype._update = function _update(msg, start) {
    var W = this.W;
    for(var i = 0; i < 16; i++)W[i] = msg[start + i];
    for(; i < W.length; i++)W[i] = sum32_4(g1_256(W[i - 2]), W[i - 7], g0_256(W[i - 15]), W[i - 16]);
    var a = this.h[0];
    var b = this.h[1];
    var c = this.h[2];
    var d = this.h[3];
    var e = this.h[4];
    var f = this.h[5];
    var g = this.h[6];
    var h = this.h[7];
    assert(this.k.length === W.length);
    for(i = 0; i < W.length; i++){
        var T1 = sum32_5(h, s1_256(e), ch32(e, f, g), this.k[i], W[i]);
        var T2 = sum32(s0_256(a), maj32(a, b, c));
        h = g;
        g = f;
        f = e;
        e = sum32(d, T1);
        d = c;
        c = b;
        b = a;
        a = sum32(T1, T2);
    }
    this.h[0] = sum32(this.h[0], a);
    this.h[1] = sum32(this.h[1], b);
    this.h[2] = sum32(this.h[2], c);
    this.h[3] = sum32(this.h[3], d);
    this.h[4] = sum32(this.h[4], e);
    this.h[5] = sum32(this.h[5], f);
    this.h[6] = sum32(this.h[6], g);
    this.h[7] = sum32(this.h[7], h);
};
SHA256.prototype._digest = function digest(enc) {
    if (enc === "hex") return utils.toHex32(this.h, "big");
    else return utils.split32(this.h, "big");
};

},{"32ad3e510bd41f2a":"gaAPT","469ad88ad505772a":"1z68J","fffa7d1ddf1f0b43":"gx3FZ","126369f57b5225ed":"cKbUa"}],"2OiZQ":[function(require,module,exports) {
"use strict";
var utils = require("a696ee34c45713da");
var SHA512 = require("fff95253fdaa49ea");
function SHA384() {
    if (!(this instanceof SHA384)) return new SHA384();
    SHA512.call(this);
    this.h = [
        0xcbbb9d5d,
        0xc1059ed8,
        0x629a292a,
        0x367cd507,
        0x9159015a,
        0x3070dd17,
        0x152fecd8,
        0xf70e5939,
        0x67332667,
        0xffc00b31,
        0x8eb44a87,
        0x68581511,
        0xdb0c2e0d,
        0x64f98fa7,
        0x47b5481d,
        0xbefa4fa4
    ];
}
utils.inherits(SHA384, SHA512);
module.exports = SHA384;
SHA384.blockSize = 1024;
SHA384.outSize = 384;
SHA384.hmacStrength = 192;
SHA384.padLength = 128;
SHA384.prototype._digest = function digest(enc) {
    if (enc === "hex") return utils.toHex32(this.h.slice(0, 12), "big");
    else return utils.split32(this.h.slice(0, 12), "big");
};

},{"a696ee34c45713da":"gaAPT","fff95253fdaa49ea":"gqcqX"}],"gqcqX":[function(require,module,exports) {
"use strict";
var utils = require("7753b1fa702fbb54");
var common = require("81b6970d75627ce1");
var assert = require("f660976cede694e2");
var rotr64_hi = utils.rotr64_hi;
var rotr64_lo = utils.rotr64_lo;
var shr64_hi = utils.shr64_hi;
var shr64_lo = utils.shr64_lo;
var sum64 = utils.sum64;
var sum64_hi = utils.sum64_hi;
var sum64_lo = utils.sum64_lo;
var sum64_4_hi = utils.sum64_4_hi;
var sum64_4_lo = utils.sum64_4_lo;
var sum64_5_hi = utils.sum64_5_hi;
var sum64_5_lo = utils.sum64_5_lo;
var BlockHash = common.BlockHash;
var sha512_K = [
    0x428a2f98,
    0xd728ae22,
    0x71374491,
    0x23ef65cd,
    0xb5c0fbcf,
    0xec4d3b2f,
    0xe9b5dba5,
    0x8189dbbc,
    0x3956c25b,
    0xf348b538,
    0x59f111f1,
    0xb605d019,
    0x923f82a4,
    0xaf194f9b,
    0xab1c5ed5,
    0xda6d8118,
    0xd807aa98,
    0xa3030242,
    0x12835b01,
    0x45706fbe,
    0x243185be,
    0x4ee4b28c,
    0x550c7dc3,
    0xd5ffb4e2,
    0x72be5d74,
    0xf27b896f,
    0x80deb1fe,
    0x3b1696b1,
    0x9bdc06a7,
    0x25c71235,
    0xc19bf174,
    0xcf692694,
    0xe49b69c1,
    0x9ef14ad2,
    0xefbe4786,
    0x384f25e3,
    0x0fc19dc6,
    0x8b8cd5b5,
    0x240ca1cc,
    0x77ac9c65,
    0x2de92c6f,
    0x592b0275,
    0x4a7484aa,
    0x6ea6e483,
    0x5cb0a9dc,
    0xbd41fbd4,
    0x76f988da,
    0x831153b5,
    0x983e5152,
    0xee66dfab,
    0xa831c66d,
    0x2db43210,
    0xb00327c8,
    0x98fb213f,
    0xbf597fc7,
    0xbeef0ee4,
    0xc6e00bf3,
    0x3da88fc2,
    0xd5a79147,
    0x930aa725,
    0x06ca6351,
    0xe003826f,
    0x14292967,
    0x0a0e6e70,
    0x27b70a85,
    0x46d22ffc,
    0x2e1b2138,
    0x5c26c926,
    0x4d2c6dfc,
    0x5ac42aed,
    0x53380d13,
    0x9d95b3df,
    0x650a7354,
    0x8baf63de,
    0x766a0abb,
    0x3c77b2a8,
    0x81c2c92e,
    0x47edaee6,
    0x92722c85,
    0x1482353b,
    0xa2bfe8a1,
    0x4cf10364,
    0xa81a664b,
    0xbc423001,
    0xc24b8b70,
    0xd0f89791,
    0xc76c51a3,
    0x0654be30,
    0xd192e819,
    0xd6ef5218,
    0xd6990624,
    0x5565a910,
    0xf40e3585,
    0x5771202a,
    0x106aa070,
    0x32bbd1b8,
    0x19a4c116,
    0xb8d2d0c8,
    0x1e376c08,
    0x5141ab53,
    0x2748774c,
    0xdf8eeb99,
    0x34b0bcb5,
    0xe19b48a8,
    0x391c0cb3,
    0xc5c95a63,
    0x4ed8aa4a,
    0xe3418acb,
    0x5b9cca4f,
    0x7763e373,
    0x682e6ff3,
    0xd6b2b8a3,
    0x748f82ee,
    0x5defb2fc,
    0x78a5636f,
    0x43172f60,
    0x84c87814,
    0xa1f0ab72,
    0x8cc70208,
    0x1a6439ec,
    0x90befffa,
    0x23631e28,
    0xa4506ceb,
    0xde82bde9,
    0xbef9a3f7,
    0xb2c67915,
    0xc67178f2,
    0xe372532b,
    0xca273ece,
    0xea26619c,
    0xd186b8c7,
    0x21c0c207,
    0xeada7dd6,
    0xcde0eb1e,
    0xf57d4f7f,
    0xee6ed178,
    0x06f067aa,
    0x72176fba,
    0x0a637dc5,
    0xa2c898a6,
    0x113f9804,
    0xbef90dae,
    0x1b710b35,
    0x131c471b,
    0x28db77f5,
    0x23047d84,
    0x32caab7b,
    0x40c72493,
    0x3c9ebe0a,
    0x15c9bebc,
    0x431d67c4,
    0x9c100d4c,
    0x4cc5d4be,
    0xcb3e42b6,
    0x597f299c,
    0xfc657e2a,
    0x5fcb6fab,
    0x3ad6faec,
    0x6c44198c,
    0x4a475817
];
function SHA512() {
    if (!(this instanceof SHA512)) return new SHA512();
    BlockHash.call(this);
    this.h = [
        0x6a09e667,
        0xf3bcc908,
        0xbb67ae85,
        0x84caa73b,
        0x3c6ef372,
        0xfe94f82b,
        0xa54ff53a,
        0x5f1d36f1,
        0x510e527f,
        0xade682d1,
        0x9b05688c,
        0x2b3e6c1f,
        0x1f83d9ab,
        0xfb41bd6b,
        0x5be0cd19,
        0x137e2179
    ];
    this.k = sha512_K;
    this.W = new Array(160);
}
utils.inherits(SHA512, BlockHash);
module.exports = SHA512;
SHA512.blockSize = 1024;
SHA512.outSize = 512;
SHA512.hmacStrength = 192;
SHA512.padLength = 128;
SHA512.prototype._prepareBlock = function _prepareBlock(msg, start) {
    var W = this.W;
    // 32 x 32bit words
    for(var i = 0; i < 32; i++)W[i] = msg[start + i];
    for(; i < W.length; i += 2){
        var c0_hi = g1_512_hi(W[i - 4], W[i - 3]); // i - 2
        var c0_lo = g1_512_lo(W[i - 4], W[i - 3]);
        var c1_hi = W[i - 14]; // i - 7
        var c1_lo = W[i - 13];
        var c2_hi = g0_512_hi(W[i - 30], W[i - 29]); // i - 15
        var c2_lo = g0_512_lo(W[i - 30], W[i - 29]);
        var c3_hi = W[i - 32]; // i - 16
        var c3_lo = W[i - 31];
        W[i] = sum64_4_hi(c0_hi, c0_lo, c1_hi, c1_lo, c2_hi, c2_lo, c3_hi, c3_lo);
        W[i + 1] = sum64_4_lo(c0_hi, c0_lo, c1_hi, c1_lo, c2_hi, c2_lo, c3_hi, c3_lo);
    }
};
SHA512.prototype._update = function _update(msg, start) {
    this._prepareBlock(msg, start);
    var W = this.W;
    var ah = this.h[0];
    var al = this.h[1];
    var bh = this.h[2];
    var bl = this.h[3];
    var ch = this.h[4];
    var cl = this.h[5];
    var dh = this.h[6];
    var dl = this.h[7];
    var eh = this.h[8];
    var el = this.h[9];
    var fh = this.h[10];
    var fl = this.h[11];
    var gh = this.h[12];
    var gl = this.h[13];
    var hh = this.h[14];
    var hl = this.h[15];
    assert(this.k.length === W.length);
    for(var i = 0; i < W.length; i += 2){
        var c0_hi = hh;
        var c0_lo = hl;
        var c1_hi = s1_512_hi(eh, el);
        var c1_lo = s1_512_lo(eh, el);
        var c2_hi = ch64_hi(eh, el, fh, fl, gh, gl);
        var c2_lo = ch64_lo(eh, el, fh, fl, gh, gl);
        var c3_hi = this.k[i];
        var c3_lo = this.k[i + 1];
        var c4_hi = W[i];
        var c4_lo = W[i + 1];
        var T1_hi = sum64_5_hi(c0_hi, c0_lo, c1_hi, c1_lo, c2_hi, c2_lo, c3_hi, c3_lo, c4_hi, c4_lo);
        var T1_lo = sum64_5_lo(c0_hi, c0_lo, c1_hi, c1_lo, c2_hi, c2_lo, c3_hi, c3_lo, c4_hi, c4_lo);
        c0_hi = s0_512_hi(ah, al);
        c0_lo = s0_512_lo(ah, al);
        c1_hi = maj64_hi(ah, al, bh, bl, ch, cl);
        c1_lo = maj64_lo(ah, al, bh, bl, ch, cl);
        var T2_hi = sum64_hi(c0_hi, c0_lo, c1_hi, c1_lo);
        var T2_lo = sum64_lo(c0_hi, c0_lo, c1_hi, c1_lo);
        hh = gh;
        hl = gl;
        gh = fh;
        gl = fl;
        fh = eh;
        fl = el;
        eh = sum64_hi(dh, dl, T1_hi, T1_lo);
        el = sum64_lo(dl, dl, T1_hi, T1_lo);
        dh = ch;
        dl = cl;
        ch = bh;
        cl = bl;
        bh = ah;
        bl = al;
        ah = sum64_hi(T1_hi, T1_lo, T2_hi, T2_lo);
        al = sum64_lo(T1_hi, T1_lo, T2_hi, T2_lo);
    }
    sum64(this.h, 0, ah, al);
    sum64(this.h, 2, bh, bl);
    sum64(this.h, 4, ch, cl);
    sum64(this.h, 6, dh, dl);
    sum64(this.h, 8, eh, el);
    sum64(this.h, 10, fh, fl);
    sum64(this.h, 12, gh, gl);
    sum64(this.h, 14, hh, hl);
};
SHA512.prototype._digest = function digest(enc) {
    if (enc === "hex") return utils.toHex32(this.h, "big");
    else return utils.split32(this.h, "big");
};
function ch64_hi(xh, xl, yh, yl, zh) {
    var r = xh & yh ^ ~xh & zh;
    if (r < 0) r += 0x100000000;
    return r;
}
function ch64_lo(xh, xl, yh, yl, zh, zl) {
    var r = xl & yl ^ ~xl & zl;
    if (r < 0) r += 0x100000000;
    return r;
}
function maj64_hi(xh, xl, yh, yl, zh) {
    var r = xh & yh ^ xh & zh ^ yh & zh;
    if (r < 0) r += 0x100000000;
    return r;
}
function maj64_lo(xh, xl, yh, yl, zh, zl) {
    var r = xl & yl ^ xl & zl ^ yl & zl;
    if (r < 0) r += 0x100000000;
    return r;
}
function s0_512_hi(xh, xl) {
    var c0_hi = rotr64_hi(xh, xl, 28);
    var c1_hi = rotr64_hi(xl, xh, 2); // 34
    var c2_hi = rotr64_hi(xl, xh, 7); // 39
    var r = c0_hi ^ c1_hi ^ c2_hi;
    if (r < 0) r += 0x100000000;
    return r;
}
function s0_512_lo(xh, xl) {
    var c0_lo = rotr64_lo(xh, xl, 28);
    var c1_lo = rotr64_lo(xl, xh, 2); // 34
    var c2_lo = rotr64_lo(xl, xh, 7); // 39
    var r = c0_lo ^ c1_lo ^ c2_lo;
    if (r < 0) r += 0x100000000;
    return r;
}
function s1_512_hi(xh, xl) {
    var c0_hi = rotr64_hi(xh, xl, 14);
    var c1_hi = rotr64_hi(xh, xl, 18);
    var c2_hi = rotr64_hi(xl, xh, 9); // 41
    var r = c0_hi ^ c1_hi ^ c2_hi;
    if (r < 0) r += 0x100000000;
    return r;
}
function s1_512_lo(xh, xl) {
    var c0_lo = rotr64_lo(xh, xl, 14);
    var c1_lo = rotr64_lo(xh, xl, 18);
    var c2_lo = rotr64_lo(xl, xh, 9); // 41
    var r = c0_lo ^ c1_lo ^ c2_lo;
    if (r < 0) r += 0x100000000;
    return r;
}
function g0_512_hi(xh, xl) {
    var c0_hi = rotr64_hi(xh, xl, 1);
    var c1_hi = rotr64_hi(xh, xl, 8);
    var c2_hi = shr64_hi(xh, xl, 7);
    var r = c0_hi ^ c1_hi ^ c2_hi;
    if (r < 0) r += 0x100000000;
    return r;
}
function g0_512_lo(xh, xl) {
    var c0_lo = rotr64_lo(xh, xl, 1);
    var c1_lo = rotr64_lo(xh, xl, 8);
    var c2_lo = shr64_lo(xh, xl, 7);
    var r = c0_lo ^ c1_lo ^ c2_lo;
    if (r < 0) r += 0x100000000;
    return r;
}
function g1_512_hi(xh, xl) {
    var c0_hi = rotr64_hi(xh, xl, 19);
    var c1_hi = rotr64_hi(xl, xh, 29); // 61
    var c2_hi = shr64_hi(xh, xl, 6);
    var r = c0_hi ^ c1_hi ^ c2_hi;
    if (r < 0) r += 0x100000000;
    return r;
}
function g1_512_lo(xh, xl) {
    var c0_lo = rotr64_lo(xh, xl, 19);
    var c1_lo = rotr64_lo(xl, xh, 29); // 61
    var c2_lo = shr64_lo(xh, xl, 6);
    var r = c0_lo ^ c1_lo ^ c2_lo;
    if (r < 0) r += 0x100000000;
    return r;
}

},{"7753b1fa702fbb54":"gaAPT","81b6970d75627ce1":"1z68J","f660976cede694e2":"cKbUa"}],"jxx9f":[function(require,module,exports) {
"use strict";
var utils = require("36495272d446418f");
var common = require("ad8cf0490e28e8d7");
var rotl32 = utils.rotl32;
var sum32 = utils.sum32;
var sum32_3 = utils.sum32_3;
var sum32_4 = utils.sum32_4;
var BlockHash = common.BlockHash;
function RIPEMD160() {
    if (!(this instanceof RIPEMD160)) return new RIPEMD160();
    BlockHash.call(this);
    this.h = [
        0x67452301,
        0xefcdab89,
        0x98badcfe,
        0x10325476,
        0xc3d2e1f0
    ];
    this.endian = "little";
}
utils.inherits(RIPEMD160, BlockHash);
exports.ripemd160 = RIPEMD160;
RIPEMD160.blockSize = 512;
RIPEMD160.outSize = 160;
RIPEMD160.hmacStrength = 192;
RIPEMD160.padLength = 64;
RIPEMD160.prototype._update = function update(msg, start) {
    var A = this.h[0];
    var B = this.h[1];
    var C = this.h[2];
    var D = this.h[3];
    var E = this.h[4];
    var Ah = A;
    var Bh = B;
    var Ch = C;
    var Dh = D;
    var Eh = E;
    for(var j = 0; j < 80; j++){
        var T = sum32(rotl32(sum32_4(A, f(j, B, C, D), msg[r[j] + start], K(j)), s[j]), E);
        A = E;
        E = D;
        D = rotl32(C, 10);
        C = B;
        B = T;
        T = sum32(rotl32(sum32_4(Ah, f(79 - j, Bh, Ch, Dh), msg[rh[j] + start], Kh(j)), sh[j]), Eh);
        Ah = Eh;
        Eh = Dh;
        Dh = rotl32(Ch, 10);
        Ch = Bh;
        Bh = T;
    }
    T = sum32_3(this.h[1], C, Dh);
    this.h[1] = sum32_3(this.h[2], D, Eh);
    this.h[2] = sum32_3(this.h[3], E, Ah);
    this.h[3] = sum32_3(this.h[4], A, Bh);
    this.h[4] = sum32_3(this.h[0], B, Ch);
    this.h[0] = T;
};
RIPEMD160.prototype._digest = function digest(enc) {
    if (enc === "hex") return utils.toHex32(this.h, "little");
    else return utils.split32(this.h, "little");
};
function f(j, x, y, z) {
    if (j <= 15) return x ^ y ^ z;
    else if (j <= 31) return x & y | ~x & z;
    else if (j <= 47) return (x | ~y) ^ z;
    else if (j <= 63) return x & z | y & ~z;
    else return x ^ (y | ~z);
}
function K(j) {
    if (j <= 15) return 0x00000000;
    else if (j <= 31) return 0x5a827999;
    else if (j <= 47) return 0x6ed9eba1;
    else if (j <= 63) return 0x8f1bbcdc;
    else return 0xa953fd4e;
}
function Kh(j) {
    if (j <= 15) return 0x50a28be6;
    else if (j <= 31) return 0x5c4dd124;
    else if (j <= 47) return 0x6d703ef3;
    else if (j <= 63) return 0x7a6d76e9;
    else return 0x00000000;
}
var r = [
    0,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12,
    13,
    14,
    15,
    7,
    4,
    13,
    1,
    10,
    6,
    15,
    3,
    12,
    0,
    9,
    5,
    2,
    14,
    11,
    8,
    3,
    10,
    14,
    4,
    9,
    15,
    8,
    1,
    2,
    7,
    0,
    6,
    13,
    11,
    5,
    12,
    1,
    9,
    11,
    10,
    0,
    8,
    12,
    4,
    13,
    3,
    7,
    15,
    14,
    5,
    6,
    2,
    4,
    0,
    5,
    9,
    7,
    12,
    2,
    10,
    14,
    1,
    3,
    8,
    11,
    6,
    15,
    13
];
var rh = [
    5,
    14,
    7,
    0,
    9,
    2,
    11,
    4,
    13,
    6,
    15,
    8,
    1,
    10,
    3,
    12,
    6,
    11,
    3,
    7,
    0,
    13,
    5,
    10,
    14,
    15,
    8,
    12,
    4,
    9,
    1,
    2,
    15,
    5,
    1,
    3,
    7,
    14,
    6,
    9,
    11,
    8,
    12,
    2,
    10,
    0,
    4,
    13,
    8,
    6,
    4,
    1,
    3,
    11,
    15,
    0,
    5,
    12,
    2,
    13,
    9,
    7,
    10,
    14,
    12,
    15,
    10,
    4,
    1,
    5,
    8,
    7,
    6,
    2,
    13,
    14,
    0,
    3,
    9,
    11
];
var s = [
    11,
    14,
    15,
    12,
    5,
    8,
    7,
    9,
    11,
    13,
    14,
    15,
    6,
    7,
    9,
    8,
    7,
    6,
    8,
    13,
    11,
    9,
    7,
    15,
    7,
    12,
    15,
    9,
    11,
    7,
    13,
    12,
    11,
    13,
    6,
    7,
    14,
    9,
    13,
    15,
    14,
    8,
    13,
    6,
    5,
    12,
    7,
    5,
    11,
    12,
    14,
    15,
    14,
    15,
    9,
    8,
    9,
    14,
    5,
    6,
    8,
    6,
    5,
    12,
    9,
    15,
    5,
    11,
    6,
    8,
    13,
    12,
    5,
    12,
    13,
    14,
    11,
    8,
    5,
    6
];
var sh = [
    8,
    9,
    9,
    11,
    13,
    15,
    15,
    5,
    7,
    7,
    8,
    11,
    14,
    14,
    12,
    6,
    9,
    13,
    15,
    7,
    12,
    8,
    9,
    11,
    7,
    7,
    12,
    7,
    6,
    15,
    13,
    11,
    9,
    7,
    15,
    11,
    8,
    6,
    6,
    14,
    12,
    13,
    5,
    14,
    13,
    13,
    7,
    5,
    15,
    5,
    8,
    11,
    14,
    14,
    6,
    14,
    6,
    9,
    12,
    9,
    12,
    5,
    15,
    8,
    8,
    5,
    12,
    9,
    12,
    5,
    14,
    6,
    8,
    13,
    6,
    5,
    15,
    13,
    11,
    11
];

},{"36495272d446418f":"gaAPT","ad8cf0490e28e8d7":"1z68J"}],"fbLYV":[function(require,module,exports) {
"use strict";
var utils = require("596c08b6835a6e2d");
var assert = require("be527907d4f06808");
function Hmac(hash, key, enc) {
    if (!(this instanceof Hmac)) return new Hmac(hash, key, enc);
    this.Hash = hash;
    this.blockSize = hash.blockSize / 8;
    this.outSize = hash.outSize / 8;
    this.inner = null;
    this.outer = null;
    this._init(utils.toArray(key, enc));
}
module.exports = Hmac;
Hmac.prototype._init = function init(key) {
    // Shorten key, if needed
    if (key.length > this.blockSize) key = new this.Hash().update(key).digest();
    assert(key.length <= this.blockSize);
    // Add padding to key
    for(var i = key.length; i < this.blockSize; i++)key.push(0);
    for(i = 0; i < key.length; i++)key[i] ^= 0x36;
    this.inner = new this.Hash().update(key);
    // 0x36 ^ 0x5c = 0x6a
    for(i = 0; i < key.length; i++)key[i] ^= 0x6a;
    this.outer = new this.Hash().update(key);
};
Hmac.prototype.update = function update(msg, enc) {
    this.inner.update(msg, enc);
    return this;
};
Hmac.prototype.digest = function digest(enc) {
    this.outer.update(this.inner.digest());
    return this.outer.digest(enc);
};

},{"596c08b6835a6e2d":"gaAPT","be527907d4f06808":"cKbUa"}],"5ltWl":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "version", ()=>version);
const version = "signing-key/5.7.0";

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8X5lB":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "version", ()=>version);
const version = "transactions/5.7.0";

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"6ZCUT":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "patchEthMaxPriorityFeePerGasMethod", ()=>patchEthMaxPriorityFeePerGasMethod);
function patchEthMaxPriorityFeePerGasMethod(web3) {
    web3.eth.customRPC({
        name: "getMaxPriorityFeePerGas",
        call: "eth_maxPriorityFeePerGas",
        params: 0
    });
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"6YomP":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "patchEthPrivateTransactionMethods", ()=>patchEthPrivateTransactionMethods);
function patchEthPrivateTransactionMethods(web3) {
    web3.eth.customRPC({
        name: "sendPrivateTransaction",
        call: "eth_sendPrivateTransaction",
        params: 3
    });
    web3.eth.customRPC({
        name: "cancelPrivateTransaction",
        call: "eth_cancelPrivateTransaction",
        params: 1
    });
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2GqqW":[function(require,module,exports) {
"use strict";
var __importDefault = this && this.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.MerkleTree = void 0;
const MerkleTree_1 = __importDefault(require("261ff894f8ee625a"));
exports.MerkleTree = MerkleTree_1.default;
var MerkleMountainRange_1 = require("f5d49219d8879483");
Object.defineProperty(exports, "MerkleMountainRange", {
    enumerable: true,
    get: function() {
        return MerkleMountainRange_1.MerkleMountainRange;
    }
});
exports.default = MerkleTree_1.default;

},{"261ff894f8ee625a":"dXivv","f5d49219d8879483":"9dcOp"}],"dXivv":[function(require,module,exports) {
"use strict";
var __importDefault = this && this.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.MerkleTree = void 0;
const buffer_1 = require("938cbc9edfc86787");
const buffer_reverse_1 = __importDefault(require("d944a10eabf3fb17"));
const sha256_1 = __importDefault(require("f80ffa3f8aad886"));
const treeify_1 = __importDefault(require("4b7b719d9d291d96"));
const Base_1 = __importDefault(require("fb750d59094db1d2"));
/**
 * Class reprensenting a Merkle Tree
 * @namespace MerkleTree
 */ class MerkleTree extends Base_1.default {
    /**
     * @desc Constructs a Merkle Tree.
     * All nodes and leaves are stored as Buffers.
     * Lonely leaf nodes are promoted to the next level up without being hashed again.
     * @param {Buffer[]} leaves - Array of hashed leaves. Each leaf must be a Buffer.
     * @param {Function} hashFunction - Hash function to use for hashing leaves and nodes
     * @param {Object} options - Additional options
     * @example
     *```js
     *const MerkleTree = require('merkletreejs')
     *const crypto = require('crypto')
     *
     *function sha256(data) {
     *  // returns Buffer
     *  return crypto.createHash('sha256').update(data).digest()
     *}
     *
     *const leaves = ['a', 'b', 'c'].map(value => keccak(value))
     *
     *const tree = new MerkleTree(leaves, sha256)
     *```
     */ constructor(leaves, hashFn = sha256_1.default, options = {}){
        super();
        this.duplicateOdd = false;
        this.hashLeaves = false;
        this.isBitcoinTree = false;
        this.leaves = [];
        this.layers = [];
        this.sortLeaves = false;
        this.sortPairs = false;
        this.sort = false;
        this.fillDefaultHash = null;
        this.isBitcoinTree = !!options.isBitcoinTree;
        this.hashLeaves = !!options.hashLeaves;
        this.sortLeaves = !!options.sortLeaves;
        this.sortPairs = !!options.sortPairs;
        if (options.fillDefaultHash) {
            if (typeof options.fillDefaultHash === "function") this.fillDefaultHash = options.fillDefaultHash;
            else if (buffer_1.Buffer.isBuffer(options.fillDefaultHash) || typeof options.fillDefaultHash === "string") this.fillDefaultHash = (idx, hashFn)=>options.fillDefaultHash;
            else throw new Error('method "fillDefaultHash" must be a function, Buffer, or string');
        }
        this.sort = !!options.sort;
        if (this.sort) {
            this.sortLeaves = true;
            this.sortPairs = true;
        }
        this.duplicateOdd = !!options.duplicateOdd;
        this.hashFn = this.bufferifyFn(hashFn);
        this.processLeaves(leaves);
    }
    processLeaves(leaves) {
        if (this.hashLeaves) leaves = leaves.map(this.hashFn);
        this.leaves = leaves.map(this.bufferify);
        if (this.sortLeaves) this.leaves = this.leaves.sort(buffer_1.Buffer.compare);
        if (this.fillDefaultHash) {
            for(let i = 0; i < Math.pow(2, Math.ceil(Math.log2(this.leaves.length))); i++)if (i >= this.leaves.length) this.leaves.push(this.bufferify(this.fillDefaultHash(i, this.hashFn)));
        }
        this.layers = [
            this.leaves
        ];
        this._createHashes(this.leaves);
    }
    _createHashes(nodes) {
        while(nodes.length > 1){
            const layerIndex = this.layers.length;
            this.layers.push([]);
            for(let i = 0; i < nodes.length; i += 2){
                if (i + 1 === nodes.length) {
                    if (nodes.length % 2 === 1) {
                        let data = nodes[nodes.length - 1];
                        let hash = data;
                        // is bitcoin tree
                        if (this.isBitcoinTree) {
                            // Bitcoin method of duplicating the odd ending nodes
                            data = buffer_1.Buffer.concat([
                                buffer_reverse_1.default(data),
                                buffer_reverse_1.default(data)
                            ]);
                            hash = this.hashFn(data);
                            hash = buffer_reverse_1.default(this.hashFn(hash));
                            this.layers[layerIndex].push(hash);
                            continue;
                        } else {
                            if (this.duplicateOdd) ;
                            else {
                                // push copy of hash and continue iteration
                                this.layers[layerIndex].push(nodes[i]);
                                continue;
                            }
                        }
                    }
                }
                const left = nodes[i];
                const right = i + 1 === nodes.length ? left : nodes[i + 1];
                let data = null;
                let combined = null;
                if (this.isBitcoinTree) combined = [
                    buffer_reverse_1.default(left),
                    buffer_reverse_1.default(right)
                ];
                else combined = [
                    left,
                    right
                ];
                if (this.sortPairs) combined.sort(buffer_1.Buffer.compare);
                data = buffer_1.Buffer.concat(combined);
                let hash = this.hashFn(data);
                // double hash if bitcoin tree
                if (this.isBitcoinTree) hash = buffer_reverse_1.default(this.hashFn(hash));
                this.layers[layerIndex].push(hash);
            }
            nodes = this.layers[layerIndex];
        }
    }
    /**
     * addLeaf
     * @desc Adds a leaf to the tree and re-calculates layers.
     * @param {String|Buffer} - Leaf
     * @param {Boolean} - Set to true if the leaf should be hashed before being added to tree.
     * @example
     *```js
     *tree.addLeaf(newLeaf)
     *```
     */ addLeaf(leaf, shouldHash = false) {
        if (shouldHash) leaf = this.hashFn(leaf);
        this.processLeaves(this.leaves.concat(leaf));
    }
    /**
     * addLeaves
     * @desc Adds multiple leaves to the tree and re-calculates layers.
     * @param {String[]|Buffer[]} - Array of leaves
     * @param {Boolean} - Set to true if the leaves should be hashed before being added to tree.
     * @example
     *```js
     *tree.addLeaves(newLeaves)
     *```
     */ addLeaves(leaves, shouldHash = false) {
        if (shouldHash) leaves = leaves.map(this.hashFn);
        this.processLeaves(this.leaves.concat(leaves));
    }
    /**
     * getLeaves
     * @desc Returns array of leaves of Merkle Tree.
     * @return {Buffer[]}
     * @example
     *```js
     *const leaves = tree.getLeaves()
     *```
     */ getLeaves(values) {
        if (Array.isArray(values)) {
            if (this.hashLeaves) {
                values = values.map(this.hashFn);
                if (this.sortLeaves) values = values.sort(buffer_1.Buffer.compare);
            }
            return this.leaves.filter((leaf)=>this._bufferIndexOf(values, leaf) !== -1);
        }
        return this.leaves;
    }
    /**
     * getLeaf
     * @desc Returns the leaf at the given index.
     * @param {Number} - Index number
     * @return {Buffer}
     * @example
     *```js
     *const leaf = tree.getLeaf(1)
     *```
     */ getLeaf(index) {
        if (index < 0 || index > this.leaves.length - 1) return buffer_1.Buffer.from([]);
        return this.leaves[index];
    }
    /**
     * getLeafIndex
     * @desc Returns the index of the given leaf, or -1 if the leaf is not found.
     * @param {String|Buffer} - Target leaf
     * @return {number}
     * @example
     *```js
     *const leaf = Buffer.from('abc')
     *const index = tree.getLeafIndex(leaf)
     *```
     */ getLeafIndex(target) {
        target = this.bufferify(target);
        const leaves = this.getLeaves();
        for(let i = 0; i < leaves.length; i++){
            const leaf = leaves[i];
            if (leaf.equals(target)) return i;
        }
        return -1;
    }
    /**
     * getLeafCount
     * @desc Returns the total number of leaves.
     * @return {number}
     * @example
     *```js
     *const count = tree.getLeafCount()
     *```
     */ getLeafCount() {
        return this.leaves.length;
    }
    /**
     * getHexLeaves
     * @desc Returns array of leaves of Merkle Tree as hex strings.
     * @return {String[]}
     * @example
     *```js
     *const leaves = tree.getHexLeaves()
     *```
     */ getHexLeaves() {
        return this.leaves.map((leaf)=>this.bufferToHex(leaf));
    }
    /**
     * marshalLeaves
     * @desc Returns array of leaves of Merkle Tree as a JSON string.
     * @param {String[]|Buffer[]} - Merkle tree leaves
     * @return {String} - List of leaves as JSON string
     * @example
     *```js
     *const jsonStr = MerkleTree.marshalLeaves(leaves)
     *```
     */ static marshalLeaves(leaves) {
        return JSON.stringify(leaves.map((leaf)=>MerkleTree.bufferToHex(leaf)), null, 2);
    }
    /**
     * unmarshalLeaves
     * @desc Returns array of leaves of Merkle Tree as a Buffers.
     * @param {String|Object} - JSON stringified leaves
     * @return {Buffer[]} - Unmarshalled list of leaves
     * @example
     *```js
     *const leaves = MerkleTree.unmarshalLeaves(jsonStr)
     *```
     */ static unmarshalLeaves(jsonStr) {
        let parsed = null;
        if (typeof jsonStr === "string") parsed = JSON.parse(jsonStr);
        else if (jsonStr instanceof Object) parsed = jsonStr;
        else throw new Error("Expected type of string or object");
        if (!parsed) return [];
        if (!Array.isArray(parsed)) throw new Error("Expected JSON string to be array");
        return parsed.map(MerkleTree.bufferify);
    }
    /**
     * getLayers
     * @desc Returns multi-dimensional array of all layers of Merkle Tree, including leaves and root.
     * @return {Buffer[]}
     * @example
     *```js
     *const layers = tree.getLayers()
     *```
     */ getLayers() {
        return this.layers;
    }
    /**
     * getHexLayers
     * @desc Returns multi-dimensional array of all layers of Merkle Tree, including leaves and root as hex strings.
     * @return {String[]}
     * @example
     *```js
     *const layers = tree.getHexLayers()
     *```
     */ getHexLayers() {
        return this.layers.reduce((acc, item)=>{
            if (Array.isArray(item)) acc.push(item.map((layer)=>this.bufferToHex(layer)));
            else acc.push(item);
            return acc;
        }, []);
    }
    /**
     * getLayersFlat
     * @desc Returns single flat array of all layers of Merkle Tree, including leaves and root.
     * @return {Buffer[]}
     * @example
     *```js
     *const layers = tree.getLayersFlat()
     *```
     */ getLayersFlat() {
        const layers = this.layers.reduce((acc, item)=>{
            if (Array.isArray(item)) acc.unshift(...item);
            else acc.unshift(item);
            return acc;
        }, []);
        layers.unshift(buffer_1.Buffer.from([
            0
        ]));
        return layers;
    }
    /**
     * getHexLayersFlat
     * @desc Returns single flat array of all layers of Merkle Tree, including leaves and root as hex string.
     * @return {String[]}
     * @example
     *```js
     *const layers = tree.getHexLayersFlat()
     *```
     */ getHexLayersFlat() {
        return this.getLayersFlat().map((layer)=>this.bufferToHex(layer));
    }
    /**
     * getLayerCount
     * @desc Returns the total number of layers.
     * @return {number}
     * @example
     *```js
     *const count = tree.getLayerCount()
     *```
     */ getLayerCount() {
        return this.getLayers().length;
    }
    /**
     * getRoot
     * @desc Returns the Merkle root hash as a Buffer.
     * @return {Buffer}
     * @example
     *```js
     *const root = tree.getRoot()
     *```
     */ getRoot() {
        if (this.layers.length === 0) return buffer_1.Buffer.from([]);
        return this.layers[this.layers.length - 1][0] || buffer_1.Buffer.from([]);
    }
    /**
     * getHexRoot
     * @desc Returns the Merkle root hash as a hex string.
     * @return {String}
     * @example
     *```js
     *const root = tree.getHexRoot()
     *```
     */ getHexRoot() {
        return this.bufferToHex(this.getRoot());
    }
    /**
     * getProof
     * @desc Returns the proof for a target leaf.
     * @param {Buffer} leaf - Target leaf
     * @param {Number} [index] - Target leaf index in leaves array.
     * Use if there are leaves containing duplicate data in order to distinguish it.
     * @return {Object[]} - Array of objects containing a position property of type string
     * with values of 'left' or 'right' and a data property of type Buffer.
     * @example
     * ```js
     *const proof = tree.getProof(leaves[2])
     *```
     *
     * @example
     *```js
     *const leaves = ['a', 'b', 'a'].map(value => keccak(value))
     *const tree = new MerkleTree(leaves, keccak)
     *const proof = tree.getProof(leaves[2], 2)
     *```
     */ getProof(leaf, index) {
        if (typeof leaf === "undefined") throw new Error("leaf is required");
        leaf = this.bufferify(leaf);
        const proof = [];
        if (!Number.isInteger(index)) {
            index = -1;
            for(let i = 0; i < this.leaves.length; i++)if (buffer_1.Buffer.compare(leaf, this.leaves[i]) === 0) index = i;
        }
        if (index <= -1) return [];
        for(let i = 0; i < this.layers.length; i++){
            const layer = this.layers[i];
            const isRightNode = index % 2;
            const pairIndex = isRightNode ? index - 1 : this.isBitcoinTree && index === layer.length - 1 && i < this.layers.length - 1 ? index : index + 1;
            if (pairIndex < layer.length) proof.push({
                position: isRightNode ? "left" : "right",
                data: layer[pairIndex]
            });
            // set index to parent index
            index = index / 2 | 0;
        }
        return proof;
    }
    /**
     * getHexProof
     * @desc Returns the proof for a target leaf as hex strings.
     * @param {Buffer} leaf - Target leaf
     * @param {Number} [index] - Target leaf index in leaves array.
     * Use if there are leaves containing duplicate data in order to distinguish it.
     * @return {String[]} - Proof array as hex strings.
     * @example
     * ```js
     *const proof = tree.getHexProof(leaves[2])
     *```
     */ getHexProof(leaf, index) {
        return this.getProof(leaf, index).map((item)=>this.bufferToHex(item.data));
    }
    /**
    * getPositionalHexProof
    * @desc Returns the proof for a target leaf as hex strings and the position in binary (left == 0).
    * @param {Buffer} leaf - Target leaf
    * @param {Number} [index] - Target leaf index in leaves array.
    * Use if there are leaves containing duplicate data in order to distinguish it.
    * @return {(string | number)[][]} - Proof array as hex strings. position at index 0
    * @example
    * ```js
    *const proof = tree.getPositionalHexProof(leaves[2])
    *```
    */ getPositionalHexProof(leaf, index) {
        return this.getProof(leaf, index).map((item)=>{
            return [
                item.position === "left" ? 0 : 1,
                this.bufferToHex(item.data)
            ];
        });
    }
    /**
     * marshalProof
     * @desc Returns proof array as JSON string.
     * @param {String[]|Object[]} proof - Merkle tree proof array
     * @return {String} - Proof array as JSON string.
     * @example
     * ```js
     *const jsonStr = MerkleTree.marshalProof(proof)
     *```
     */ static marshalProof(proof) {
        const json = proof.map((item)=>{
            if (typeof item === "string") return item;
            if (buffer_1.Buffer.isBuffer(item)) return MerkleTree.bufferToHex(item);
            return {
                position: item.position,
                data: MerkleTree.bufferToHex(item.data)
            };
        });
        return JSON.stringify(json, null, 2);
    }
    /**
     * unmarshalProof
     * @desc Returns the proof for a target leaf as a list of Buffers.
     * @param {String|Object} - Merkle tree leaves
     * @return {String|Object} - Marshalled proof
     * @example
     * ```js
     *const proof = MerkleTree.unmarshalProof(jsonStr)
     *```
     */ static unmarshalProof(jsonStr) {
        let parsed = null;
        if (typeof jsonStr === "string") parsed = JSON.parse(jsonStr);
        else if (jsonStr instanceof Object) parsed = jsonStr;
        else throw new Error("Expected type of string or object");
        if (!parsed) return [];
        if (!Array.isArray(parsed)) throw new Error("Expected JSON string to be array");
        return parsed.map((item)=>{
            if (typeof item === "string") return MerkleTree.bufferify(item);
            else if (item instanceof Object) return {
                position: item.position,
                data: MerkleTree.bufferify(item.data)
            };
            else throw new Error("Expected item to be of type string or object");
        });
    }
    /**
     * getProofIndices
     * @desc Returns the proof indices for given tree indices.
     * @param {Number[]} treeIndices - Tree indices
     * @param {Number} depth - Tree depth; number of layers.
     * @return {Number[]} - Proof indices
     * @example
     * ```js
     *const proofIndices = tree.getProofIndices([2,5,6], 4)
     *console.log(proofIndices) // [ 23, 20, 19, 8, 3 ]
     *```
     */ getProofIndices(treeIndices, depth) {
        const leafCount = Math.pow(2, depth);
        let maximalIndices = new Set();
        for (const index of treeIndices){
            let x = leafCount + index;
            while(x > 1){
                maximalIndices.add(x ^ 1);
                x = x / 2 | 0;
            }
        }
        const a = treeIndices.map((index)=>leafCount + index);
        const b = Array.from(maximalIndices).sort((a, b)=>a - b).reverse();
        maximalIndices = a.concat(b);
        const redundantIndices = new Set();
        const proof = [];
        for (let index of maximalIndices)if (!redundantIndices.has(index)) {
            proof.push(index);
            while(index > 1){
                redundantIndices.add(index);
                if (!redundantIndices.has(index ^ 1)) break;
                index = index / 2 | 0;
            }
        }
        return proof.filter((index)=>{
            return !treeIndices.includes(index - leafCount);
        });
    }
    getProofIndicesForUnevenTree(sortedLeafIndices, leavesCount) {
        const depth = Math.ceil(Math.log2(leavesCount));
        const unevenLayers = [];
        for(let index = 0; index < depth; index++){
            const unevenLayer = leavesCount % 2 !== 0;
            if (unevenLayer) unevenLayers.push({
                index,
                leavesCount
            });
            leavesCount = Math.ceil(leavesCount / 2);
        }
        const proofIndices = [];
        let layerNodes = sortedLeafIndices;
        for(let layerIndex = 0; layerIndex < depth; layerIndex++){
            const siblingIndices = layerNodes.map((index)=>{
                if (index % 2 === 0) return index + 1;
                return index - 1;
            });
            let proofNodeIndices = siblingIndices.filter((index)=>!layerNodes.includes(index));
            const unevenLayer = unevenLayers.find(({ index })=>index === layerIndex);
            if (unevenLayer && layerNodes.includes(unevenLayer.leavesCount - 1)) proofNodeIndices = proofNodeIndices.slice(0, -1);
            proofIndices.push(proofNodeIndices);
            layerNodes = [
                ...new Set(layerNodes.map((index)=>{
                    if (index % 2 === 0) return index / 2;
                    if (index % 2 === 0) return (index + 1) / 2;
                    return (index - 1) / 2;
                }))
            ];
        }
        return proofIndices;
    }
    /**
     * getMultiProof
     * @desc Returns the multiproof for given tree indices.
     * @param {Number[]} indices - Tree indices.
     * @return {Buffer[]} - Multiproofs
     * @example
     * ```js
     *const indices = [2, 5, 6]
     *const proof = tree.getMultiProof(indices)
     *```
     */ getMultiProof(tree, indices) {
        if (!indices) {
            indices = tree;
            tree = this.getLayersFlat();
        }
        const isUneven = this.isUnevenTree();
        if (isUneven) {
            if (indices.every(Number.isInteger)) return this.getMultiProofForUnevenTree(indices);
        }
        if (!indices.every(Number.isInteger)) {
            let els = indices;
            if (this.sortPairs) els = els.sort(buffer_1.Buffer.compare);
            let ids = els.map((el)=>this._bufferIndexOf(this.leaves, el)).sort((a, b)=>a === b ? 0 : a > b ? 1 : -1);
            if (!ids.every((idx)=>idx !== -1)) throw new Error("Element does not exist in Merkle tree");
            const hashes = [];
            const proof = [];
            let nextIds = [];
            for(let i = 0; i < this.layers.length; i++){
                const layer = this.layers[i];
                for(let j = 0; j < ids.length; j++){
                    const idx = ids[j];
                    const pairElement = this._getPairNode(layer, idx);
                    hashes.push(layer[idx]);
                    if (pairElement) proof.push(pairElement);
                    nextIds.push(idx / 2 | 0);
                }
                ids = nextIds.filter((value, i, self)=>self.indexOf(value) === i);
                nextIds = [];
            }
            return proof.filter((value)=>!hashes.includes(value));
        }
        return this.getProofIndices(indices, this._log2(tree.length / 2 | 0)).map((index)=>tree[index]);
    }
    getMultiProofForUnevenTree(tree, indices) {
        if (!indices) {
            indices = tree;
            tree = this.getLayers();
        }
        let proofHashes = [];
        let currentLayerIndices = indices;
        for (const treeLayer of tree){
            const siblings = [];
            for (const index of currentLayerIndices){
                if (index % 2 === 0) {
                    const idx = index + 1;
                    if (!currentLayerIndices.includes(idx)) {
                        if (treeLayer[idx]) {
                            siblings.push(treeLayer[idx]);
                            continue;
                        }
                    }
                }
                const idx = index - 1;
                if (!currentLayerIndices.includes(idx)) {
                    if (treeLayer[idx]) {
                        siblings.push(treeLayer[idx]);
                        continue;
                    }
                }
            }
            proofHashes = proofHashes.concat(siblings);
            const uniqueIndices = new Set();
            for (const index of currentLayerIndices){
                if (index % 2 === 0) {
                    uniqueIndices.add(index / 2);
                    continue;
                }
                if (index % 2 === 0) {
                    uniqueIndices.add((index + 1) / 2);
                    continue;
                }
                uniqueIndices.add((index - 1) / 2);
            }
            currentLayerIndices = Array.from(uniqueIndices);
        }
        return proofHashes;
    }
    /**
     * getHexMultiProof
     * @desc Returns the multiproof for given tree indices as hex strings.
     * @param {Number[]} indices - Tree indices.
     * @return {String[]} - Multiproofs as hex strings.
     * @example
     * ```js
     *const indices = [2, 5, 6]
     *const proof = tree.getHexMultiProof(indices)
     *```
     */ getHexMultiProof(tree, indices) {
        return this.getMultiProof(tree, indices).map((x)=>this.bufferToHex(x));
    }
    /**
     * getProofFlags
     * @desc Returns list of booleans where proofs should be used instead of hashing.
     * Proof flags are used in the Solidity multiproof verifiers.
     * @param {Number[]|Buffer[]} leaves
     * @param {Buffer[]} proofs
     * @return {Boolean[]} - Boolean flags
     * @example
     * ```js
     *const indices = [2, 5, 6]
     *const proof = tree.getMultiProof(indices)
     *const proofFlags = tree.getProofFlags(leaves, proof)
     *```
     */ getProofFlags(leaves, proofs) {
        if (!Array.isArray(leaves) || leaves.length <= 0) throw new Error("Invalid Inputs!");
        let ids;
        if (leaves.every(Number.isInteger)) ids = leaves.sort((a, b)=>a === b ? 0 : a > b ? 1 : -1); // Indices where passed
        else ids = leaves.map((el)=>this._bufferIndexOf(this.leaves, el)).sort((a, b)=>a === b ? 0 : a > b ? 1 : -1);
        if (!ids.every((idx)=>idx !== -1)) throw new Error("Element does not exist in Merkle tree");
        const _proofs = proofs.map((item)=>this.bufferify(item));
        const tested = [];
        const flags = [];
        for(let index = 0; index < this.layers.length; index++){
            const layer = this.layers[index];
            ids = ids.reduce((ids, idx)=>{
                const skipped = tested.includes(layer[idx]);
                if (!skipped) {
                    const pairElement = this._getPairNode(layer, idx);
                    const proofUsed = _proofs.includes(layer[idx]) || _proofs.includes(pairElement);
                    pairElement && flags.push(!proofUsed);
                    tested.push(layer[idx]);
                    tested.push(pairElement);
                }
                ids.push(idx / 2 | 0);
                return ids;
            }, []);
        }
        return flags;
    }
    /**
     * verify
     * @desc Returns true if the proof path (array of hashes) can connect the target node
     * to the Merkle root.
     * @param {Object[]} proof - Array of proof objects that should connect
     * target node to Merkle root.
     * @param {Buffer} targetNode - Target node Buffer
     * @param {Buffer} root - Merkle root Buffer
     * @return {Boolean}
     * @example
     *```js
     *const root = tree.getRoot()
     *const proof = tree.getProof(leaves[2])
     *const verified = tree.verify(proof, leaves[2], root)
     *```
     */ verify(proof, targetNode, root) {
        let hash = this.bufferify(targetNode);
        root = this.bufferify(root);
        if (!Array.isArray(proof) || !targetNode || !root) return false;
        for(let i = 0; i < proof.length; i++){
            const node = proof[i];
            let data = null;
            let isLeftNode = null;
            // case for when proof is hex values only
            if (typeof node === "string") {
                data = this.bufferify(node);
                isLeftNode = true;
            } else if (Array.isArray(node)) {
                isLeftNode = node[0] === 0;
                data = this.bufferify(node[1]);
            } else if (buffer_1.Buffer.isBuffer(node)) {
                data = node;
                isLeftNode = true;
            } else if (node instanceof Object) {
                data = this.bufferify(node.data);
                isLeftNode = node.position === "left";
            } else throw new Error("Expected node to be of type string or object");
            const buffers = [];
            if (this.isBitcoinTree) {
                buffers.push(buffer_reverse_1.default(hash));
                buffers[isLeftNode ? "unshift" : "push"](buffer_reverse_1.default(data));
                hash = this.hashFn(buffer_1.Buffer.concat(buffers));
                hash = buffer_reverse_1.default(this.hashFn(hash));
            } else if (this.sortPairs) {
                if (buffer_1.Buffer.compare(hash, data) === -1) {
                    buffers.push(hash, data);
                    hash = this.hashFn(buffer_1.Buffer.concat(buffers));
                } else {
                    buffers.push(data, hash);
                    hash = this.hashFn(buffer_1.Buffer.concat(buffers));
                }
            } else {
                buffers.push(hash);
                buffers[isLeftNode ? "unshift" : "push"](data);
                hash = this.hashFn(buffer_1.Buffer.concat(buffers));
            }
        }
        return buffer_1.Buffer.compare(hash, root) === 0;
    }
    /**
     * verifyMultiProof
     * @desc Returns true if the multiproofs can connect the leaves to the Merkle root.
     * @param {Buffer} root - Merkle tree root
     * @param {Number[]} proofIndices - Leave indices for proof
     * @param {Buffer[]} proofLeaves - Leaf values at indices for proof
     * @param {Number} leavesCount - Count of original leaves
     * @param {Buffer[]} proof - Multiproofs given indices
     * @return {Boolean}
     * @example
     *```js
     *const leaves = tree.getLeaves()
     *const root = tree.getRoot()
     *const treeFlat = tree.getLayersFlat()
     *const leavesCount = leaves.length
     *const proofIndices = [2, 5, 6]
     *const proofLeaves = proofIndices.map(i => leaves[i])
     *const proof = tree.getMultiProof(treeFlat, indices)
     *const verified = tree.verifyMultiProof(root, proofIndices, proofLeaves, leavesCount, proof)
     *```
     */ verifyMultiProof(root, proofIndices, proofLeaves, leavesCount, proof) {
        const isUneven = this.isUnevenTree();
        if (isUneven) // TODO: combine these functions and simplify
        return this.verifyMultiProofForUnevenTree(root, proofIndices, proofLeaves, leavesCount, proof);
        const depth = Math.ceil(Math.log2(leavesCount));
        root = this.bufferify(root);
        proofLeaves = proofLeaves.map((leaf)=>this.bufferify(leaf));
        proof = proof.map((leaf)=>this.bufferify(leaf));
        const tree = {};
        for (const [index, leaf] of this._zip(proofIndices, proofLeaves))tree[Math.pow(2, depth) + index] = leaf;
        for (const [index, proofitem] of this._zip(this.getProofIndices(proofIndices, depth), proof))tree[index] = proofitem;
        let indexqueue = Object.keys(tree).map((value)=>+value).sort((a, b)=>a - b);
        indexqueue = indexqueue.slice(0, indexqueue.length - 1);
        let i = 0;
        while(i < indexqueue.length){
            const index = indexqueue[i];
            if (index >= 2 && ({}).hasOwnProperty.call(tree, index ^ 1)) {
                let pair = [
                    tree[index - index % 2],
                    tree[index - index % 2 + 1]
                ];
                if (this.sortPairs) pair = pair.sort(buffer_1.Buffer.compare);
                const hash = pair[1] ? this.hashFn(buffer_1.Buffer.concat(pair)) : pair[0];
                tree[index / 2 | 0] = hash;
                indexqueue.push(index / 2 | 0);
            }
            i += 1;
        }
        return !proofIndices.length || ({}).hasOwnProperty.call(tree, 1) && tree[1].equals(root);
    }
    verifyMultiProofWithFlags(root, leaves, proofs, proofFlag) {
        root = this.bufferify(root);
        leaves = leaves.map(this.bufferify);
        proofs = proofs.map(this.bufferify);
        const leavesLen = leaves.length;
        const totalHashes = proofFlag.length;
        const hashes = [];
        let leafPos = 0;
        let hashPos = 0;
        let proofPos = 0;
        for(let i = 0; i < totalHashes; i++){
            const bufA = proofFlag[i] ? leafPos < leavesLen ? leaves[leafPos++] : hashes[hashPos++] : proofs[proofPos++];
            const bufB = leafPos < leavesLen ? leaves[leafPos++] : hashes[hashPos++];
            const buffers = [
                bufA,
                bufB
            ].sort(buffer_1.Buffer.compare);
            hashes[i] = this.hashFn(buffer_1.Buffer.concat(buffers));
        }
        return buffer_1.Buffer.compare(hashes[totalHashes - 1], root) === 0;
    }
    verifyMultiProofForUnevenTree(root, indices, leaves, leavesCount, proof) {
        root = this.bufferify(root);
        leaves = leaves.map((leaf)=>this.bufferify(leaf));
        proof = proof.map((leaf)=>this.bufferify(leaf));
        const computedRoot = this.calculateRootForUnevenTree(indices, leaves, leavesCount, proof);
        return root.equals(computedRoot);
    }
    /**
     * getDepth
     * @desc Returns the tree depth (number of layers)
     * @return {Number}
     * @example
     *```js
     *const depth = tree.getDepth()
     *```
     */ getDepth() {
        return this.getLayers().length - 1;
    }
    /**
     * getLayersAsObject
     * @desc Returns the layers as nested objects instead of an array.
     * @example
     *```js
     *const layersObj = tree.getLayersAsObject()
     *```
     */ getLayersAsObject() {
        const layers = this.getLayers().map((layer)=>layer.map((value)=>this.bufferToHex(value, false)));
        const objs = [];
        for(let i = 0; i < layers.length; i++){
            const arr = [];
            for(let j = 0; j < layers[i].length; j++){
                const obj = {
                    [layers[i][j]]: null
                };
                if (objs.length) {
                    obj[layers[i][j]] = {};
                    const a = objs.shift();
                    const akey = Object.keys(a)[0];
                    obj[layers[i][j]][akey] = a[akey];
                    if (objs.length) {
                        const b = objs.shift();
                        const bkey = Object.keys(b)[0];
                        obj[layers[i][j]][bkey] = b[bkey];
                    }
                }
                arr.push(obj);
            }
            objs.push(...arr);
        }
        return objs[0];
    }
    /**
     * verify
     * @desc Returns true if the proof path (array of hashes) can connect the target node
     * to the Merkle root.
     * @param {Object[]} proof - Array of proof objects that should connect
     * target node to Merkle root.
     * @param {Buffer} targetNode - Target node Buffer
     * @param {Buffer} root - Merkle root Buffer
     * @param {Function} hashFunction - Hash function for hashing leaves and nodes
     * @param {Object} options - Additional options
     * @return {Boolean}
     * @example
     *```js
     *const verified = MerkleTree.verify(proof, leaf, root, sha256, options)
     *```
     */ static verify(proof, targetNode, root, hashFn = sha256_1.default, options = {}) {
        const tree = new MerkleTree([], hashFn, options);
        return tree.verify(proof, targetNode, root);
    }
    /**
     * getMultiProof
     * @desc Returns the multiproof for given tree indices.
     * @param {Buffer[]} tree - Tree as a flat array.
     * @param {Number[]} indices - Tree indices.
     * @return {Buffer[]} - Multiproofs
     *
     *@example
     * ```js
     *const flatTree = tree.getLayersFlat()
     *const indices = [2, 5, 6]
     *const proof = MerkleTree.getMultiProof(flatTree, indices)
     *```
     */ static getMultiProof(tree, indices) {
        const t = new MerkleTree([]);
        return t.getMultiProof(tree, indices);
    }
    /**
     * resetTree
     * @desc Resets the tree by clearing the leaves and layers.
     * @example
     *```js
     *tree.resetTree()
     *```
     */ resetTree() {
        this.leaves = [];
        this.layers = [];
    }
    /**
     * getPairNode
     * @desc Returns the node at the index for given layer.
     * @param {Buffer[]} layer - Tree layer
     * @param {Number} index - Index at layer.
     * @return {Buffer} - Node
     *
     *@example
     * ```js
     *const node = tree.getPairNode(layer, index)
     *```
     */ _getPairNode(layer, idx) {
        const pairIdx = idx % 2 === 0 ? idx + 1 : idx - 1;
        if (pairIdx < layer.length) return layer[pairIdx];
        else return null;
    }
    /**
     * toTreeString
     * @desc Returns a visual representation of the merkle tree as a string.
     * @return {String}
     * @example
     *```js
     *console.log(tree.toTreeString())
     *```
     */ _toTreeString() {
        const obj = this.getLayersAsObject();
        return treeify_1.default.asTree(obj, true);
    }
    /**
     * toString
     * @desc Returns a visual representation of the merkle tree as a string.
     * @example
     *```js
     *console.log(tree.toString())
     *```
     */ toString() {
        return this._toTreeString();
    }
    isUnevenTree(treeLayers) {
        const depth = (treeLayers === null || treeLayers === void 0 ? void 0 : treeLayers.length) || this.getDepth();
        return !this.isPowOf2(depth);
    }
    isPowOf2(v) {
        return v && !(v & v - 1);
    }
    calculateRootForUnevenTree(leafIndices, leafHashes, totalLeavesCount, proofHashes) {
        const leafTuples = this._zip(leafIndices, leafHashes).sort(([indexA], [indexB])=>indexA - indexB);
        const leafTupleIndices = leafTuples.map(([index])=>index);
        const proofIndices = this.getProofIndicesForUnevenTree(leafTupleIndices, totalLeavesCount);
        let nextSliceStart = 0;
        const proofTuplesByLayers = [];
        for(let i = 0; i < proofIndices.length; i++){
            const indices = proofIndices[i];
            const sliceStart = nextSliceStart;
            nextSliceStart += indices.length;
            proofTuplesByLayers[i] = this._zip(indices, proofHashes.slice(sliceStart, nextSliceStart));
        }
        const tree = [
            leafTuples
        ];
        for(let layerIndex = 0; layerIndex < proofTuplesByLayers.length; layerIndex++){
            const currentLayer = proofTuplesByLayers[layerIndex].concat(tree[layerIndex]).sort(([indexA], [indexB])=>indexA - indexB).map(([, hash])=>hash);
            const s = tree[layerIndex].map(([layerIndex])=>layerIndex);
            const parentIndices = [
                ...new Set(s.map((index)=>{
                    if (index % 2 === 0) return index / 2;
                    if (index % 2 === 0) return (index + 1) / 2;
                    return (index - 1) / 2;
                }))
            ];
            const parentLayer = [];
            for(let i = 0; i < parentIndices.length; i++){
                const parentNodeTreeIndex = parentIndices[i];
                const bufA = currentLayer[i * 2];
                const bufB = currentLayer[i * 2 + 1];
                const hash = bufB ? this.hashFn(buffer_1.Buffer.concat([
                    bufA,
                    bufB
                ])) : bufA;
                parentLayer.push([
                    parentNodeTreeIndex,
                    hash
                ]);
            }
            tree.push(parentLayer);
        }
        return tree[tree.length - 1][0][1];
    }
}
exports.MerkleTree = MerkleTree;
if (typeof window !== "undefined") window.MerkleTree = MerkleTree;
exports.default = MerkleTree;

},{"938cbc9edfc86787":"l5Twm","d944a10eabf3fb17":"97BRL","f80ffa3f8aad886":"geCX9","4b7b719d9d291d96":"dPxsH","fb750d59094db1d2":"8bIo2"}],"97BRL":[function(require,module,exports) {
var Buffer = require("587429211e03b9bf").Buffer;
module.exports = function reverse(src) {
    var buffer = new Buffer(src.length);
    for(var i = 0, j = src.length - 1; i <= j; ++i, --j){
        buffer[i] = src[j];
        buffer[j] = src[i];
    }
    return buffer;
};

},{"587429211e03b9bf":"l5Twm"}],"geCX9":[function(require,module,exports) {
(function(root, factory) {
    // CommonJS
    module.exports = exports = factory(require("cd9e8447cb14a145"));
})(this, function(CryptoJS) {
    (function(Math1) {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var WordArray = C_lib.WordArray;
        var Hasher = C_lib.Hasher;
        var C_algo = C.algo;
        // Initialization and round constants tables
        var H = [];
        var K = [];
        // Compute constants
        (function() {
            function isPrime(n) {
                var sqrtN = Math1.sqrt(n);
                for(var factor = 2; factor <= sqrtN; factor++){
                    if (!(n % factor)) return false;
                }
                return true;
            }
            function getFractionalBits(n) {
                return (n - (n | 0)) * 0x100000000 | 0;
            }
            var n = 2;
            var nPrime = 0;
            while(nPrime < 64){
                if (isPrime(n)) {
                    if (nPrime < 8) H[nPrime] = getFractionalBits(Math1.pow(n, 0.5));
                    K[nPrime] = getFractionalBits(Math1.pow(n, 1 / 3));
                    nPrime++;
                }
                n++;
            }
        })();
        // Reusable object
        var W = [];
        /**
	     * SHA-256 hash algorithm.
	     */ var SHA256 = C_algo.SHA256 = Hasher.extend({
            _doReset: function() {
                this._hash = new WordArray.init(H.slice(0));
            },
            _doProcessBlock: function(M, offset) {
                // Shortcut
                var H = this._hash.words;
                // Working variables
                var a = H[0];
                var b = H[1];
                var c = H[2];
                var d = H[3];
                var e = H[4];
                var f = H[5];
                var g = H[6];
                var h = H[7];
                // Computation
                for(var i = 0; i < 64; i++){
                    if (i < 16) W[i] = M[offset + i] | 0;
                    else {
                        var gamma0x = W[i - 15];
                        var gamma0 = (gamma0x << 25 | gamma0x >>> 7) ^ (gamma0x << 14 | gamma0x >>> 18) ^ gamma0x >>> 3;
                        var gamma1x = W[i - 2];
                        var gamma1 = (gamma1x << 15 | gamma1x >>> 17) ^ (gamma1x << 13 | gamma1x >>> 19) ^ gamma1x >>> 10;
                        W[i] = gamma0 + W[i - 7] + gamma1 + W[i - 16];
                    }
                    var ch = e & f ^ ~e & g;
                    var maj = a & b ^ a & c ^ b & c;
                    var sigma0 = (a << 30 | a >>> 2) ^ (a << 19 | a >>> 13) ^ (a << 10 | a >>> 22);
                    var sigma1 = (e << 26 | e >>> 6) ^ (e << 21 | e >>> 11) ^ (e << 7 | e >>> 25);
                    var t1 = h + sigma1 + ch + K[i] + W[i];
                    var t2 = sigma0 + maj;
                    h = g;
                    g = f;
                    f = e;
                    e = d + t1 | 0;
                    d = c;
                    c = b;
                    b = a;
                    a = t1 + t2 | 0;
                }
                // Intermediate hash value
                H[0] = H[0] + a | 0;
                H[1] = H[1] + b | 0;
                H[2] = H[2] + c | 0;
                H[3] = H[3] + d | 0;
                H[4] = H[4] + e | 0;
                H[5] = H[5] + f | 0;
                H[6] = H[6] + g | 0;
                H[7] = H[7] + h | 0;
            },
            _doFinalize: function() {
                // Shortcuts
                var data = this._data;
                var dataWords = data.words;
                var nBitsTotal = this._nDataBytes * 8;
                var nBitsLeft = data.sigBytes * 8;
                // Add padding
                dataWords[nBitsLeft >>> 5] |= 0x80 << 24 - nBitsLeft % 32;
                dataWords[(nBitsLeft + 64 >>> 9 << 4) + 14] = Math1.floor(nBitsTotal / 0x100000000);
                dataWords[(nBitsLeft + 64 >>> 9 << 4) + 15] = nBitsTotal;
                data.sigBytes = dataWords.length * 4;
                // Hash final blocks
                this._process();
                // Return final computed hash
                return this._hash;
            },
            clone: function() {
                var clone = Hasher.clone.call(this);
                clone._hash = this._hash.clone();
                return clone;
            }
        });
        /**
	     * Shortcut function to the hasher's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     *
	     * @return {WordArray} The hash.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hash = CryptoJS.SHA256('message');
	     *     var hash = CryptoJS.SHA256(wordArray);
	     */ C.SHA256 = Hasher._createHelper(SHA256);
        /**
	     * Shortcut function to the HMAC's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     * @param {WordArray|string} key The secret key.
	     *
	     * @return {WordArray} The HMAC.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hmac = CryptoJS.HmacSHA256(message, key);
	     */ C.HmacSHA256 = Hasher._createHmacHelper(SHA256);
    })(Math);
    return CryptoJS.SHA256;
});

},{"cd9e8447cb14a145":"isPlo"}],"isPlo":[function(require,module,exports) {
(function(root, factory) {
    // CommonJS
    module.exports = exports = factory();
})(this, function() {
    /**
	 * CryptoJS core components.
	 */ var CryptoJS = CryptoJS || function(Math1, undefined) {
        /*
	     * Local polyfil of Object.create
	     */ var create = Object.create || function() {
            function F() {}
            return function(obj) {
                var subtype;
                F.prototype = obj;
                subtype = new F();
                F.prototype = null;
                return subtype;
            };
        }();
        /**
	     * CryptoJS namespace.
	     */ var C = {};
        /**
	     * Library namespace.
	     */ var C_lib = C.lib = {};
        /**
	     * Base object for prototypal inheritance.
	     */ var Base = C_lib.Base = function() {
            return {
                /**
	             * Creates a new object that inherits from this object.
	             *
	             * @param {Object} overrides Properties to copy into the new object.
	             *
	             * @return {Object} The new object.
	             *
	             * @static
	             *
	             * @example
	             *
	             *     var MyType = CryptoJS.lib.Base.extend({
	             *         field: 'value',
	             *
	             *         method: function () {
	             *         }
	             *     });
	             */ extend: function(overrides) {
                    // Spawn
                    var subtype = create(this);
                    // Augment
                    if (overrides) subtype.mixIn(overrides);
                    // Create default initializer
                    if (!subtype.hasOwnProperty("init") || this.init === subtype.init) subtype.init = function() {
                        subtype.$super.init.apply(this, arguments);
                    };
                    // Initializer's prototype is the subtype object
                    subtype.init.prototype = subtype;
                    // Reference supertype
                    subtype.$super = this;
                    return subtype;
                },
                /**
	             * Extends this object and runs the init method.
	             * Arguments to create() will be passed to init().
	             *
	             * @return {Object} The new object.
	             *
	             * @static
	             *
	             * @example
	             *
	             *     var instance = MyType.create();
	             */ create: function() {
                    var instance = this.extend();
                    instance.init.apply(instance, arguments);
                    return instance;
                },
                /**
	             * Initializes a newly created object.
	             * Override this method to add some logic when your objects are created.
	             *
	             * @example
	             *
	             *     var MyType = CryptoJS.lib.Base.extend({
	             *         init: function () {
	             *             // ...
	             *         }
	             *     });
	             */ init: function() {},
                /**
	             * Copies properties into this object.
	             *
	             * @param {Object} properties The properties to mix in.
	             *
	             * @example
	             *
	             *     MyType.mixIn({
	             *         field: 'value'
	             *     });
	             */ mixIn: function(properties) {
                    for(var propertyName in properties)if (properties.hasOwnProperty(propertyName)) this[propertyName] = properties[propertyName];
                    // IE won't copy toString using the loop above
                    if (properties.hasOwnProperty("toString")) this.toString = properties.toString;
                },
                /**
	             * Creates a copy of this object.
	             *
	             * @return {Object} The clone.
	             *
	             * @example
	             *
	             *     var clone = instance.clone();
	             */ clone: function() {
                    return this.init.prototype.extend(this);
                }
            };
        }();
        /**
	     * An array of 32-bit words.
	     *
	     * @property {Array} words The array of 32-bit words.
	     * @property {number} sigBytes The number of significant bytes in this word array.
	     */ var WordArray = C_lib.WordArray = Base.extend({
            /**
	         * Initializes a newly created word array.
	         *
	         * @param {Array} words (Optional) An array of 32-bit words.
	         * @param {number} sigBytes (Optional) The number of significant bytes in the words.
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.lib.WordArray.create();
	         *     var wordArray = CryptoJS.lib.WordArray.create([0x00010203, 0x04050607]);
	         *     var wordArray = CryptoJS.lib.WordArray.create([0x00010203, 0x04050607], 6);
	         */ init: function(words, sigBytes) {
                words = this.words = words || [];
                if (sigBytes != undefined) this.sigBytes = sigBytes;
                else this.sigBytes = words.length * 4;
            },
            /**
	         * Converts this word array to a string.
	         *
	         * @param {Encoder} encoder (Optional) The encoding strategy to use. Default: CryptoJS.enc.Hex
	         *
	         * @return {string} The stringified word array.
	         *
	         * @example
	         *
	         *     var string = wordArray + '';
	         *     var string = wordArray.toString();
	         *     var string = wordArray.toString(CryptoJS.enc.Utf8);
	         */ toString: function(encoder) {
                return (encoder || Hex).stringify(this);
            },
            /**
	         * Concatenates a word array to this word array.
	         *
	         * @param {WordArray} wordArray The word array to append.
	         *
	         * @return {WordArray} This word array.
	         *
	         * @example
	         *
	         *     wordArray1.concat(wordArray2);
	         */ concat: function(wordArray) {
                // Shortcuts
                var thisWords = this.words;
                var thatWords = wordArray.words;
                var thisSigBytes = this.sigBytes;
                var thatSigBytes = wordArray.sigBytes;
                // Clamp excess bits
                this.clamp();
                // Concat
                if (thisSigBytes % 4) // Copy one byte at a time
                for(var i = 0; i < thatSigBytes; i++){
                    var thatByte = thatWords[i >>> 2] >>> 24 - i % 4 * 8 & 0xff;
                    thisWords[thisSigBytes + i >>> 2] |= thatByte << 24 - (thisSigBytes + i) % 4 * 8;
                }
                else // Copy one word at a time
                for(var i = 0; i < thatSigBytes; i += 4)thisWords[thisSigBytes + i >>> 2] = thatWords[i >>> 2];
                this.sigBytes += thatSigBytes;
                // Chainable
                return this;
            },
            /**
	         * Removes insignificant bits.
	         *
	         * @example
	         *
	         *     wordArray.clamp();
	         */ clamp: function() {
                // Shortcuts
                var words = this.words;
                var sigBytes = this.sigBytes;
                // Clamp
                words[sigBytes >>> 2] &= 0xffffffff << 32 - sigBytes % 4 * 8;
                words.length = Math1.ceil(sigBytes / 4);
            },
            /**
	         * Creates a copy of this word array.
	         *
	         * @return {WordArray} The clone.
	         *
	         * @example
	         *
	         *     var clone = wordArray.clone();
	         */ clone: function() {
                var clone = Base.clone.call(this);
                clone.words = this.words.slice(0);
                return clone;
            },
            /**
	         * Creates a word array filled with random bytes.
	         *
	         * @param {number} nBytes The number of random bytes to generate.
	         *
	         * @return {WordArray} The random word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.lib.WordArray.random(16);
	         */ random: function(nBytes) {
                var words = [];
                var r = function(m_w) {
                    var m_w = m_w;
                    var m_z = 0x3ade68b1;
                    var mask = 0xffffffff;
                    return function() {
                        m_z = 0x9069 * (m_z & 0xFFFF) + (m_z >> 0x10) & mask;
                        m_w = 0x4650 * (m_w & 0xFFFF) + (m_w >> 0x10) & mask;
                        var result = (m_z << 0x10) + m_w & mask;
                        result /= 0x100000000;
                        result += 0.5;
                        return result * (Math1.random() > .5 ? 1 : -1);
                    };
                };
                for(var i = 0, rcache; i < nBytes; i += 4){
                    var _r = r((rcache || Math1.random()) * 0x100000000);
                    rcache = _r() * 0x3ade67b7;
                    words.push(_r() * 0x100000000 | 0);
                }
                return new WordArray.init(words, nBytes);
            }
        });
        /**
	     * Encoder namespace.
	     */ var C_enc = C.enc = {};
        /**
	     * Hex encoding strategy.
	     */ var Hex = C_enc.Hex = {
            /**
	         * Converts a word array to a hex string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @return {string} The hex string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var hexString = CryptoJS.enc.Hex.stringify(wordArray);
	         */ stringify: function(wordArray) {
                // Shortcuts
                var words = wordArray.words;
                var sigBytes = wordArray.sigBytes;
                // Convert
                var hexChars = [];
                for(var i = 0; i < sigBytes; i++){
                    var bite = words[i >>> 2] >>> 24 - i % 4 * 8 & 0xff;
                    hexChars.push((bite >>> 4).toString(16));
                    hexChars.push((bite & 0x0f).toString(16));
                }
                return hexChars.join("");
            },
            /**
	         * Converts a hex string to a word array.
	         *
	         * @param {string} hexStr The hex string.
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Hex.parse(hexString);
	         */ parse: function(hexStr) {
                // Shortcut
                var hexStrLength = hexStr.length;
                // Convert
                var words = [];
                for(var i = 0; i < hexStrLength; i += 2)words[i >>> 3] |= parseInt(hexStr.substr(i, 2), 16) << 24 - i % 8 * 4;
                return new WordArray.init(words, hexStrLength / 2);
            }
        };
        /**
	     * Latin1 encoding strategy.
	     */ var Latin1 = C_enc.Latin1 = {
            /**
	         * Converts a word array to a Latin1 string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @return {string} The Latin1 string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var latin1String = CryptoJS.enc.Latin1.stringify(wordArray);
	         */ stringify: function(wordArray) {
                // Shortcuts
                var words = wordArray.words;
                var sigBytes = wordArray.sigBytes;
                // Convert
                var latin1Chars = [];
                for(var i = 0; i < sigBytes; i++){
                    var bite = words[i >>> 2] >>> 24 - i % 4 * 8 & 0xff;
                    latin1Chars.push(String.fromCharCode(bite));
                }
                return latin1Chars.join("");
            },
            /**
	         * Converts a Latin1 string to a word array.
	         *
	         * @param {string} latin1Str The Latin1 string.
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Latin1.parse(latin1String);
	         */ parse: function(latin1Str) {
                // Shortcut
                var latin1StrLength = latin1Str.length;
                // Convert
                var words = [];
                for(var i = 0; i < latin1StrLength; i++)words[i >>> 2] |= (latin1Str.charCodeAt(i) & 0xff) << 24 - i % 4 * 8;
                return new WordArray.init(words, latin1StrLength);
            }
        };
        /**
	     * UTF-8 encoding strategy.
	     */ var Utf8 = C_enc.Utf8 = {
            /**
	         * Converts a word array to a UTF-8 string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @return {string} The UTF-8 string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var utf8String = CryptoJS.enc.Utf8.stringify(wordArray);
	         */ stringify: function(wordArray) {
                try {
                    return decodeURIComponent(escape(Latin1.stringify(wordArray)));
                } catch (e) {
                    throw new Error("Malformed UTF-8 data");
                }
            },
            /**
	         * Converts a UTF-8 string to a word array.
	         *
	         * @param {string} utf8Str The UTF-8 string.
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Utf8.parse(utf8String);
	         */ parse: function(utf8Str) {
                return Latin1.parse(unescape(encodeURIComponent(utf8Str)));
            }
        };
        /**
	     * Abstract buffered block algorithm template.
	     *
	     * The property blockSize must be implemented in a concrete subtype.
	     *
	     * @property {number} _minBufferSize The number of blocks that should be kept unprocessed in the buffer. Default: 0
	     */ var BufferedBlockAlgorithm = C_lib.BufferedBlockAlgorithm = Base.extend({
            /**
	         * Resets this block algorithm's data buffer to its initial state.
	         *
	         * @example
	         *
	         *     bufferedBlockAlgorithm.reset();
	         */ reset: function() {
                // Initial values
                this._data = new WordArray.init();
                this._nDataBytes = 0;
            },
            /**
	         * Adds new data to this block algorithm's buffer.
	         *
	         * @param {WordArray|string} data The data to append. Strings are converted to a WordArray using UTF-8.
	         *
	         * @example
	         *
	         *     bufferedBlockAlgorithm._append('data');
	         *     bufferedBlockAlgorithm._append(wordArray);
	         */ _append: function(data) {
                // Convert string to WordArray, else assume WordArray already
                if (typeof data == "string") data = Utf8.parse(data);
                // Append
                this._data.concat(data);
                this._nDataBytes += data.sigBytes;
            },
            /**
	         * Processes available data blocks.
	         *
	         * This method invokes _doProcessBlock(offset), which must be implemented by a concrete subtype.
	         *
	         * @param {boolean} doFlush Whether all blocks and partial blocks should be processed.
	         *
	         * @return {WordArray} The processed data.
	         *
	         * @example
	         *
	         *     var processedData = bufferedBlockAlgorithm._process();
	         *     var processedData = bufferedBlockAlgorithm._process(!!'flush');
	         */ _process: function(doFlush) {
                // Shortcuts
                var data = this._data;
                var dataWords = data.words;
                var dataSigBytes = data.sigBytes;
                var blockSize = this.blockSize;
                var blockSizeBytes = blockSize * 4;
                // Count blocks ready
                var nBlocksReady = dataSigBytes / blockSizeBytes;
                if (doFlush) // Round up to include partial blocks
                nBlocksReady = Math1.ceil(nBlocksReady);
                else // Round down to include only full blocks,
                // less the number of blocks that must remain in the buffer
                nBlocksReady = Math1.max((nBlocksReady | 0) - this._minBufferSize, 0);
                // Count words ready
                var nWordsReady = nBlocksReady * blockSize;
                // Count bytes ready
                var nBytesReady = Math1.min(nWordsReady * 4, dataSigBytes);
                // Process blocks
                if (nWordsReady) {
                    for(var offset = 0; offset < nWordsReady; offset += blockSize)// Perform concrete-algorithm logic
                    this._doProcessBlock(dataWords, offset);
                    // Remove processed words
                    var processedWords = dataWords.splice(0, nWordsReady);
                    data.sigBytes -= nBytesReady;
                }
                // Return processed words
                return new WordArray.init(processedWords, nBytesReady);
            },
            /**
	         * Creates a copy of this object.
	         *
	         * @return {Object} The clone.
	         *
	         * @example
	         *
	         *     var clone = bufferedBlockAlgorithm.clone();
	         */ clone: function() {
                var clone = Base.clone.call(this);
                clone._data = this._data.clone();
                return clone;
            },
            _minBufferSize: 0
        });
        /**
	     * Abstract hasher template.
	     *
	     * @property {number} blockSize The number of 32-bit words this hasher operates on. Default: 16 (512 bits)
	     */ var Hasher = C_lib.Hasher = BufferedBlockAlgorithm.extend({
            /**
	         * Configuration options.
	         */ cfg: Base.extend(),
            /**
	         * Initializes a newly created hasher.
	         *
	         * @param {Object} cfg (Optional) The configuration options to use for this hash computation.
	         *
	         * @example
	         *
	         *     var hasher = CryptoJS.algo.SHA256.create();
	         */ init: function(cfg) {
                // Apply config defaults
                this.cfg = this.cfg.extend(cfg);
                // Set initial values
                this.reset();
            },
            /**
	         * Resets this hasher to its initial state.
	         *
	         * @example
	         *
	         *     hasher.reset();
	         */ reset: function() {
                // Reset data buffer
                BufferedBlockAlgorithm.reset.call(this);
                // Perform concrete-hasher logic
                this._doReset();
            },
            /**
	         * Updates this hasher with a message.
	         *
	         * @param {WordArray|string} messageUpdate The message to append.
	         *
	         * @return {Hasher} This hasher.
	         *
	         * @example
	         *
	         *     hasher.update('message');
	         *     hasher.update(wordArray);
	         */ update: function(messageUpdate) {
                // Append
                this._append(messageUpdate);
                // Update the hash
                this._process();
                // Chainable
                return this;
            },
            /**
	         * Finalizes the hash computation.
	         * Note that the finalize operation is effectively a destructive, read-once operation.
	         *
	         * @param {WordArray|string} messageUpdate (Optional) A final message update.
	         *
	         * @return {WordArray} The hash.
	         *
	         * @example
	         *
	         *     var hash = hasher.finalize();
	         *     var hash = hasher.finalize('message');
	         *     var hash = hasher.finalize(wordArray);
	         */ finalize: function(messageUpdate) {
                // Final message update
                if (messageUpdate) this._append(messageUpdate);
                // Perform concrete-hasher logic
                var hash = this._doFinalize();
                return hash;
            },
            blockSize: 16,
            /**
	         * Creates a shortcut function to a hasher's object interface.
	         *
	         * @param {Hasher} hasher The hasher to create a helper for.
	         *
	         * @return {Function} The shortcut function.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var SHA256 = CryptoJS.lib.Hasher._createHelper(CryptoJS.algo.SHA256);
	         */ _createHelper: function(hasher) {
                return function(message, cfg) {
                    return new hasher.init(cfg).finalize(message);
                };
            },
            /**
	         * Creates a shortcut function to the HMAC's object interface.
	         *
	         * @param {Hasher} hasher The hasher to use in this HMAC helper.
	         *
	         * @return {Function} The shortcut function.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var HmacSHA256 = CryptoJS.lib.Hasher._createHmacHelper(CryptoJS.algo.SHA256);
	         */ _createHmacHelper: function(hasher) {
                return function(message, key) {
                    return new C_algo.HMAC.init(hasher, key).finalize(message);
                };
            }
        });
        /**
	     * Algorithm namespace.
	     */ var C_algo = C.algo = {};
        return C;
    }(Math);
    return CryptoJS;
});

},{}],"dPxsH":[function(require,module,exports) {
//     treeify.js
//     Luke Plaster <notatestuser@gmail.com>
//     https://github.com/notatestuser/treeify.js
// do the universal module definition dance
(function(root, factory) {
    module.exports = factory();
})(this, function() {
    function makePrefix(key, last) {
        var str = last ? "\u2514" : "\u251C";
        if (key) str += "\u2500 ";
        else str += "\u2500\u2500\u2510";
        return str;
    }
    function filterKeys(obj, hideFunctions) {
        var keys = [];
        for(var branch in obj){
            // always exclude anything in the object's prototype
            if (!obj.hasOwnProperty(branch)) continue;
            // ... and hide any keys mapped to functions if we've been told to
            if (hideFunctions && typeof obj[branch] === "function") continue;
            keys.push(branch);
        }
        return keys;
    }
    function growBranch(key, root, last, lastStates, showValues, hideFunctions, callback) {
        var line = "", index = 0, lastKey, circular, lastStatesCopy = lastStates.slice(0);
        if (lastStatesCopy.push([
            root,
            last
        ]) && lastStates.length > 0) {
            // based on the "was last element" states of whatever we're nested within,
            // we need to append either blankness or a branch to our line
            lastStates.forEach(function(lastState, idx) {
                if (idx > 0) line += (lastState[1] ? " " : "\u2502") + "  ";
                if (!circular && lastState[0] === root) circular = true;
            });
            // the prefix varies based on whether the key contains something to show and
            // whether we're dealing with the last element in this collection
            line += makePrefix(key, last) + key;
            // append values and the circular reference indicator
            showValues && (typeof root !== "object" || root instanceof Date) && (line += ": " + root);
            circular && (line += " (circular ref.)");
            callback(line);
        }
        // can we descend into the next item?
        if (!circular && typeof root === "object") {
            var keys = filterKeys(root, hideFunctions);
            keys.forEach(function(branch) {
                // the last key is always printed with a different prefix, so we'll need to know if we have it
                lastKey = ++index === keys.length;
                // hold your breath for recursive action
                growBranch(branch, root[branch], lastKey, lastStatesCopy, showValues, hideFunctions, callback);
            });
        }
    }
    // --------------------
    var Treeify = {};
    // Treeify.asLines
    // --------------------
    // Outputs the tree line-by-line, calling the lineCallback when each one is available.
    Treeify.asLines = function(obj, showValues, hideFunctions, lineCallback) {
        /* hideFunctions and lineCallback are curried, which means we don't break apps using the older form */ var hideFunctionsArg = typeof hideFunctions !== "function" ? hideFunctions : false;
        growBranch(".", obj, false, [], showValues, hideFunctionsArg, lineCallback || hideFunctions);
    };
    // Treeify.asTree
    // --------------------
    // Outputs the entire tree, returning it as a string with line breaks.
    Treeify.asTree = function(obj, showValues, hideFunctions) {
        var tree = "";
        growBranch(".", obj, false, [], showValues, hideFunctions, function(line) {
            tree += line + "\n";
        });
        return tree;
    };
    // --------------------
    return Treeify;
});

},{}],"8bIo2":[function(require,module,exports) {
"use strict";
var __importDefault = this && this.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Base = void 0;
const buffer_1 = require("c022275cf54bd09c");
const crypto_js_1 = __importDefault(require("e2a152918118cc8f"));
class Base {
    /**
     * print
     * @desc Prints out a visual representation of the merkle tree.
     * @example
     *```js
     *tree.print()
     *```
     */ print() {
        Base.print(this);
    }
    /**
     * bufferIndexOf
     * @desc Returns the first index of which given buffer is found in array.
     * @param {Buffer[]} haystack - Array of buffers.
     * @param {Buffer} needle - Buffer to find.
     * @return {Number} - Index number
     *
     * @example
     * ```js
     *const index = tree.bufferIndexOf(haystack, needle)
     *```
     */ _bufferIndexOf(array, element) {
        for(let i = 0; i < array.length; i++){
            if (element.equals(array[i])) return i;
        }
        return -1;
    }
    /**
     * bufferify
     * @desc Returns a buffer type for the given value.
     * @param {String|Number|Object|Buffer|ArrayBuffer} value
     * @return {Buffer}
     *
     * @example
     * ```js
     *const buf = MerkleTree.bufferify('0x1234')
     *```
     */ static bufferify(value) {
        if (!buffer_1.Buffer.isBuffer(value)) {
            // crypto-js support
            if (typeof value === "object" && value.words) return buffer_1.Buffer.from(value.toString(crypto_js_1.default.enc.Hex), "hex");
            else if (Base.isHexString(value)) return buffer_1.Buffer.from(value.replace(/^0x/, ""), "hex");
            else if (typeof value === "string") return buffer_1.Buffer.from(value);
            else if (typeof value === "number") {
                let s = value.toString();
                if (s.length % 2) s = `0${s}`;
                return buffer_1.Buffer.from(s, "hex");
            } else if (ArrayBuffer.isView(value)) return buffer_1.Buffer.from(value.buffer, value.byteOffset, value.byteLength);
        }
        return value;
    }
    /**
     * isHexString
     * @desc Returns true if value is a hex string.
     * @param {String} value
     * @return {Boolean}
     *
     * @example
     * ```js
     *console.log(MerkleTree.isHexString('0x1234'))
     *```
     */ static isHexString(v) {
        return typeof v === "string" && /^(0x)?[0-9A-Fa-f]*$/.test(v);
    }
    /**
     * print
     * @desc Prints out a visual representation of the given merkle tree.
     * @param {Object} tree - Merkle tree instance.
     * @return {String}
     * @example
     *```js
     *MerkleTree.print(tree)
     *```
     */ static print(tree) {
        console.log(tree.toString());
    }
    /**
     * bufferToHex
     * @desc Returns a hex string with 0x prefix for given buffer.
     * @param {Buffer} value
     * @return {String}
     * @example
     *```js
     *const hexStr = tree.bufferToHex(Buffer.from('A'))
     *```
     */ bufferToHex(value, withPrefix = true) {
        return Base.bufferToHex(value, withPrefix);
    }
    /**
     * bufferToHex
     * @desc Returns a hex string with 0x prefix for given buffer.
     * @param {Buffer} value
     * @return {String}
     * @example
     *```js
     *const hexStr = MerkleTree.bufferToHex(Buffer.from('A'))
     *```
     */ static bufferToHex(value, withPrefix = true) {
        return `${withPrefix ? "0x" : ""}${(value || buffer_1.Buffer.alloc(0)).toString("hex")}`;
    }
    /**
     * bufferify
     * @desc Returns a buffer type for the given value.
     * @param {String|Number|Object|Buffer} value
     * @return {Buffer}
     *
     * @example
     * ```js
     *const buf = tree.bufferify('0x1234')
     *```
     */ bufferify(value) {
        return Base.bufferify(value);
    }
    /**
     * bufferifyFn
     * @desc Returns a function that will bufferify the return value.
     * @param {Function}
     * @return {Function}
     *
     * @example
     * ```js
     *const fn = tree.bufferifyFn((value) => sha256(value))
     *```
     */ bufferifyFn(f) {
        return (value)=>{
            const v = f(value);
            if (buffer_1.Buffer.isBuffer(v)) return v;
            if (this._isHexString(v)) return buffer_1.Buffer.from(v.replace("0x", ""), "hex");
            if (typeof v === "string") return buffer_1.Buffer.from(v);
            if (ArrayBuffer.isView(v)) return buffer_1.Buffer.from(v.buffer, v.byteOffset, v.byteLength);
            // crypto-js support
            return buffer_1.Buffer.from(f(crypto_js_1.default.enc.Hex.parse(value.toString("hex"))).toString(crypto_js_1.default.enc.Hex), "hex");
        };
    }
    /**
     * isHexString
     * @desc Returns true if value is a hex string.
     * @param {String} value
     * @return {Boolean}
     *
     * @example
     * ```js
     *console.log(MerkleTree.isHexString('0x1234'))
     *```
     */ _isHexString(value) {
        return Base.isHexString(value);
    }
    /**
     * log2
     * @desc Returns the log2 of number.
     * @param {Number} value
     * @return {Number}
     */ _log2(n) {
        return n === 1 ? 0 : 1 + this._log2(n / 2 | 0);
    }
    /**
     * zip
     * @desc Returns true if value is a hex string.
     * @param {String[]|Number[]|Buffer[]} a - first array
     * @param {String[]|Number[]|Buffer[]} b -  second array
     * @return {String[][]|Number[][]|Buffer[][]}
     *
     * @example
     * ```js
     *const zipped = tree.zip(['a', 'b'],['A', 'B'])
     *console.log(zipped) // [ [ 'a', 'A' ], [ 'b', 'B' ] ]
     *```
     */ _zip(a, b) {
        return a.map((e, i)=>[
                e,
                b[i]
            ]);
    }
}
exports.Base = Base;
exports.default = Base;

},{"c022275cf54bd09c":"l5Twm","e2a152918118cc8f":"4YsAU"}],"4YsAU":[function(require,module,exports) {
(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory(require("5eee6dbf972ff0c"), require("1ae7fff9f8fa4b2e"), require("5d5c6779507b6ecf"), require("8fed7daa3b4cc142"), require("789bad1b0dff9a96"), require("8ccb3bce525f169d"), require("f6a9495b1c254449"), require("fd2e65bc40b77537"), require("7fa06e499cf8a103"), require("c1cce0659b03adfe"), require("c5af184fa8c7874f"), require("4ae38a06cb259786"), require("c72e494c732a963f"), require("88bf72f2d872110"), require("89a6ccecb9711f00"), require("fe47fecb97678a27"), require("8494f33137888286"), require("a180680a3a0b6778"), require("5c9b46cec008dfa5"), require("4cba38335b9a1036"), require("52ef67a0df2f7b37"), require("1790c68efb06b110"), require("540eb4174417cc86"), require("e53c0db805905662"), require("cab1508d99737362"), require("c0ecce6689437d58"), require("5809aadf1a05b38"), require("72de7f0923a744f6"), require("8676fff60d27e6aa"), require("753c41c24ae9eb5b"), require("c4b3c473a798ab37"), require("64cf109d48a11849"), require("c44065b70e4f6cb8"));
})(this, function(CryptoJS) {
    return CryptoJS;
});

},{"5eee6dbf972ff0c":"isPlo","1ae7fff9f8fa4b2e":"hv2ZZ","5d5c6779507b6ecf":"1JZDN","8fed7daa3b4cc142":"jGy47","789bad1b0dff9a96":"7G9uR","8ccb3bce525f169d":"fzW7d","f6a9495b1c254449":"39xfW","fd2e65bc40b77537":"geCX9","7fa06e499cf8a103":"wtT9M","c1cce0659b03adfe":"lotkt","c5af184fa8c7874f":"9c54x","4ae38a06cb259786":"9CwDJ","c72e494c732a963f":"lsKgK","88bf72f2d872110":"ffTZ0","89a6ccecb9711f00":"lfgIo","fe47fecb97678a27":"8HKlY","8494f33137888286":"inDpW","a180680a3a0b6778":"id1jR","5c9b46cec008dfa5":"5A5s6","4cba38335b9a1036":"2eh9E","52ef67a0df2f7b37":"8Twub","1790c68efb06b110":"4bAaW","540eb4174417cc86":"8CpOC","e53c0db805905662":"aflvs","cab1508d99737362":"9tt4Q","c0ecce6689437d58":"3tegu","5809aadf1a05b38":"2HGq1","72de7f0923a744f6":"g96aD","8676fff60d27e6aa":"afzf0","753c41c24ae9eb5b":"izdbG","c4b3c473a798ab37":"33ZtO","64cf109d48a11849":"blsgg","c44065b70e4f6cb8":"jBbSq"}],"hv2ZZ":[function(require,module,exports) {
(function(root, factory) {
    // CommonJS
    module.exports = exports = factory(require("d48fed549de80b2b"));
})(this, function(CryptoJS) {
    (function(undefined) {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var Base = C_lib.Base;
        var X32WordArray = C_lib.WordArray;
        /**
	     * x64 namespace.
	     */ var C_x64 = C.x64 = {};
        /**
	     * A 64-bit word.
	     */ var X64Word = C_x64.Word = Base.extend({
            /**
	         * Initializes a newly created 64-bit word.
	         *
	         * @param {number} high The high 32 bits.
	         * @param {number} low The low 32 bits.
	         *
	         * @example
	         *
	         *     var x64Word = CryptoJS.x64.Word.create(0x00010203, 0x04050607);
	         */ init: function(high, low) {
                this.high = high;
                this.low = low;
            }
        });
        /**
	     * An array of 64-bit words.
	     *
	     * @property {Array} words The array of CryptoJS.x64.Word objects.
	     * @property {number} sigBytes The number of significant bytes in this word array.
	     */ var X64WordArray = C_x64.WordArray = Base.extend({
            /**
	         * Initializes a newly created word array.
	         *
	         * @param {Array} words (Optional) An array of CryptoJS.x64.Word objects.
	         * @param {number} sigBytes (Optional) The number of significant bytes in the words.
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.x64.WordArray.create();
	         *
	         *     var wordArray = CryptoJS.x64.WordArray.create([
	         *         CryptoJS.x64.Word.create(0x00010203, 0x04050607),
	         *         CryptoJS.x64.Word.create(0x18191a1b, 0x1c1d1e1f)
	         *     ]);
	         *
	         *     var wordArray = CryptoJS.x64.WordArray.create([
	         *         CryptoJS.x64.Word.create(0x00010203, 0x04050607),
	         *         CryptoJS.x64.Word.create(0x18191a1b, 0x1c1d1e1f)
	         *     ], 10);
	         */ init: function(words, sigBytes) {
                words = this.words = words || [];
                if (sigBytes != undefined) this.sigBytes = sigBytes;
                else this.sigBytes = words.length * 8;
            },
            /**
	         * Converts this 64-bit word array to a 32-bit word array.
	         *
	         * @return {CryptoJS.lib.WordArray} This word array's data as a 32-bit word array.
	         *
	         * @example
	         *
	         *     var x32WordArray = x64WordArray.toX32();
	         */ toX32: function() {
                // Shortcuts
                var x64Words = this.words;
                var x64WordsLength = x64Words.length;
                // Convert
                var x32Words = [];
                for(var i = 0; i < x64WordsLength; i++){
                    var x64Word = x64Words[i];
                    x32Words.push(x64Word.high);
                    x32Words.push(x64Word.low);
                }
                return X32WordArray.create(x32Words, this.sigBytes);
            },
            /**
	         * Creates a copy of this word array.
	         *
	         * @return {X64WordArray} The clone.
	         *
	         * @example
	         *
	         *     var clone = x64WordArray.clone();
	         */ clone: function() {
                var clone = Base.clone.call(this);
                // Clone "words" array
                var words = clone.words = this.words.slice(0);
                // Clone each X64Word object
                var wordsLength = words.length;
                for(var i = 0; i < wordsLength; i++)words[i] = words[i].clone();
                return clone;
            }
        });
    })();
    return CryptoJS;
});

},{"d48fed549de80b2b":"isPlo"}],"1JZDN":[function(require,module,exports) {
(function(root, factory) {
    // CommonJS
    module.exports = exports = factory(require("300da5cb0ae97e38"));
})(this, function(CryptoJS) {
    (function() {
        // Check if typed arrays are supported
        if (typeof ArrayBuffer != "function") return;
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var WordArray = C_lib.WordArray;
        // Reference original init
        var superInit = WordArray.init;
        // Augment WordArray.init to handle typed arrays
        var subInit = WordArray.init = function(typedArray) {
            // Convert buffers to uint8
            if (typedArray instanceof ArrayBuffer) typedArray = new Uint8Array(typedArray);
            // Convert other array views to uint8
            if (typedArray instanceof Int8Array || typeof Uint8ClampedArray !== "undefined" && typedArray instanceof Uint8ClampedArray || typedArray instanceof Int16Array || typedArray instanceof Uint16Array || typedArray instanceof Int32Array || typedArray instanceof Uint32Array || typedArray instanceof Float32Array || typedArray instanceof Float64Array) typedArray = new Uint8Array(typedArray.buffer, typedArray.byteOffset, typedArray.byteLength);
            // Handle Uint8Array
            if (typedArray instanceof Uint8Array) {
                // Shortcut
                var typedArrayByteLength = typedArray.byteLength;
                // Extract bytes
                var words = [];
                for(var i = 0; i < typedArrayByteLength; i++)words[i >>> 2] |= typedArray[i] << 24 - i % 4 * 8;
                // Initialize this word array
                superInit.call(this, words, typedArrayByteLength);
            } else // Else call normal init
            superInit.apply(this, arguments);
        };
        subInit.prototype = WordArray;
    })();
    return CryptoJS.lib.WordArray;
});

},{"300da5cb0ae97e38":"isPlo"}],"jGy47":[function(require,module,exports) {
(function(root, factory) {
    // CommonJS
    module.exports = exports = factory(require("3d8e0cedd47ceed4"));
})(this, function(CryptoJS) {
    (function() {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var WordArray = C_lib.WordArray;
        var C_enc = C.enc;
        /**
	     * UTF-16 BE encoding strategy.
	     */ var Utf16BE = C_enc.Utf16 = C_enc.Utf16BE = {
            /**
	         * Converts a word array to a UTF-16 BE string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @return {string} The UTF-16 BE string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var utf16String = CryptoJS.enc.Utf16.stringify(wordArray);
	         */ stringify: function(wordArray) {
                // Shortcuts
                var words = wordArray.words;
                var sigBytes = wordArray.sigBytes;
                // Convert
                var utf16Chars = [];
                for(var i = 0; i < sigBytes; i += 2){
                    var codePoint = words[i >>> 2] >>> 16 - i % 4 * 8 & 0xffff;
                    utf16Chars.push(String.fromCharCode(codePoint));
                }
                return utf16Chars.join("");
            },
            /**
	         * Converts a UTF-16 BE string to a word array.
	         *
	         * @param {string} utf16Str The UTF-16 BE string.
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Utf16.parse(utf16String);
	         */ parse: function(utf16Str) {
                // Shortcut
                var utf16StrLength = utf16Str.length;
                // Convert
                var words = [];
                for(var i = 0; i < utf16StrLength; i++)words[i >>> 1] |= utf16Str.charCodeAt(i) << 16 - i % 2 * 16;
                return WordArray.create(words, utf16StrLength * 2);
            }
        };
        /**
	     * UTF-16 LE encoding strategy.
	     */ C_enc.Utf16LE = {
            /**
	         * Converts a word array to a UTF-16 LE string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @return {string} The UTF-16 LE string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var utf16Str = CryptoJS.enc.Utf16LE.stringify(wordArray);
	         */ stringify: function(wordArray) {
                // Shortcuts
                var words = wordArray.words;
                var sigBytes = wordArray.sigBytes;
                // Convert
                var utf16Chars = [];
                for(var i = 0; i < sigBytes; i += 2){
                    var codePoint = swapEndian(words[i >>> 2] >>> 16 - i % 4 * 8 & 0xffff);
                    utf16Chars.push(String.fromCharCode(codePoint));
                }
                return utf16Chars.join("");
            },
            /**
	         * Converts a UTF-16 LE string to a word array.
	         *
	         * @param {string} utf16Str The UTF-16 LE string.
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Utf16LE.parse(utf16Str);
	         */ parse: function(utf16Str) {
                // Shortcut
                var utf16StrLength = utf16Str.length;
                // Convert
                var words = [];
                for(var i = 0; i < utf16StrLength; i++)words[i >>> 1] |= swapEndian(utf16Str.charCodeAt(i) << 16 - i % 2 * 16);
                return WordArray.create(words, utf16StrLength * 2);
            }
        };
        function swapEndian(word) {
            return word << 8 & 0xff00ff00 | word >>> 8 & 0x00ff00ff;
        }
    })();
    return CryptoJS.enc.Utf16;
});

},{"3d8e0cedd47ceed4":"isPlo"}],"7G9uR":[function(require,module,exports) {
(function(root, factory) {
    // CommonJS
    module.exports = exports = factory(require("6c67d43f833ec62e"));
})(this, function(CryptoJS) {
    (function() {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var WordArray = C_lib.WordArray;
        var C_enc = C.enc;
        /**
	     * Base64 encoding strategy.
	     */ var Base64 = C_enc.Base64 = {
            /**
	         * Converts a word array to a Base64 string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @return {string} The Base64 string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var base64String = CryptoJS.enc.Base64.stringify(wordArray);
	         */ stringify: function(wordArray) {
                // Shortcuts
                var words = wordArray.words;
                var sigBytes = wordArray.sigBytes;
                var map = this._map;
                // Clamp excess bits
                wordArray.clamp();
                // Convert
                var base64Chars = [];
                for(var i = 0; i < sigBytes; i += 3){
                    var byte1 = words[i >>> 2] >>> 24 - i % 4 * 8 & 0xff;
                    var byte2 = words[i + 1 >>> 2] >>> 24 - (i + 1) % 4 * 8 & 0xff;
                    var byte3 = words[i + 2 >>> 2] >>> 24 - (i + 2) % 4 * 8 & 0xff;
                    var triplet = byte1 << 16 | byte2 << 8 | byte3;
                    for(var j = 0; j < 4 && i + j * 0.75 < sigBytes; j++)base64Chars.push(map.charAt(triplet >>> 6 * (3 - j) & 0x3f));
                }
                // Add padding
                var paddingChar = map.charAt(64);
                if (paddingChar) while(base64Chars.length % 4)base64Chars.push(paddingChar);
                return base64Chars.join("");
            },
            /**
	         * Converts a Base64 string to a word array.
	         *
	         * @param {string} base64Str The Base64 string.
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Base64.parse(base64String);
	         */ parse: function(base64Str) {
                // Shortcuts
                var base64StrLength = base64Str.length;
                var map = this._map;
                var reverseMap = this._reverseMap;
                if (!reverseMap) {
                    reverseMap = this._reverseMap = [];
                    for(var j = 0; j < map.length; j++)reverseMap[map.charCodeAt(j)] = j;
                }
                // Ignore padding
                var paddingChar = map.charAt(64);
                if (paddingChar) {
                    var paddingIndex = base64Str.indexOf(paddingChar);
                    if (paddingIndex !== -1) base64StrLength = paddingIndex;
                }
                // Convert
                return parseLoop(base64Str, base64StrLength, reverseMap);
            },
            _map: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/="
        };
        function parseLoop(base64Str, base64StrLength, reverseMap) {
            var words = [];
            var nBytes = 0;
            for(var i = 0; i < base64StrLength; i++)if (i % 4) {
                var bits1 = reverseMap[base64Str.charCodeAt(i - 1)] << i % 4 * 2;
                var bits2 = reverseMap[base64Str.charCodeAt(i)] >>> 6 - i % 4 * 2;
                words[nBytes >>> 2] |= (bits1 | bits2) << 24 - nBytes % 4 * 8;
                nBytes++;
            }
            return WordArray.create(words, nBytes);
        }
    })();
    return CryptoJS.enc.Base64;
});

},{"6c67d43f833ec62e":"isPlo"}],"fzW7d":[function(require,module,exports) {
(function(root, factory) {
    // CommonJS
    module.exports = exports = factory(require("df297d5f1a7605f5"));
})(this, function(CryptoJS) {
    (function(Math1) {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var WordArray = C_lib.WordArray;
        var Hasher = C_lib.Hasher;
        var C_algo = C.algo;
        // Constants table
        var T = [];
        // Compute constants
        (function() {
            for(var i = 0; i < 64; i++)T[i] = Math1.abs(Math1.sin(i + 1)) * 0x100000000 | 0;
        })();
        /**
	     * MD5 hash algorithm.
	     */ var MD5 = C_algo.MD5 = Hasher.extend({
            _doReset: function() {
                this._hash = new WordArray.init([
                    0x67452301,
                    0xefcdab89,
                    0x98badcfe,
                    0x10325476
                ]);
            },
            _doProcessBlock: function(M, offset) {
                // Swap endian
                for(var i = 0; i < 16; i++){
                    // Shortcuts
                    var offset_i = offset + i;
                    var M_offset_i = M[offset_i];
                    M[offset_i] = (M_offset_i << 8 | M_offset_i >>> 24) & 0x00ff00ff | (M_offset_i << 24 | M_offset_i >>> 8) & 0xff00ff00;
                }
                // Shortcuts
                var H = this._hash.words;
                var M_offset_0 = M[offset + 0];
                var M_offset_1 = M[offset + 1];
                var M_offset_2 = M[offset + 2];
                var M_offset_3 = M[offset + 3];
                var M_offset_4 = M[offset + 4];
                var M_offset_5 = M[offset + 5];
                var M_offset_6 = M[offset + 6];
                var M_offset_7 = M[offset + 7];
                var M_offset_8 = M[offset + 8];
                var M_offset_9 = M[offset + 9];
                var M_offset_10 = M[offset + 10];
                var M_offset_11 = M[offset + 11];
                var M_offset_12 = M[offset + 12];
                var M_offset_13 = M[offset + 13];
                var M_offset_14 = M[offset + 14];
                var M_offset_15 = M[offset + 15];
                // Working varialbes
                var a = H[0];
                var b = H[1];
                var c = H[2];
                var d = H[3];
                // Computation
                a = FF(a, b, c, d, M_offset_0, 7, T[0]);
                d = FF(d, a, b, c, M_offset_1, 12, T[1]);
                c = FF(c, d, a, b, M_offset_2, 17, T[2]);
                b = FF(b, c, d, a, M_offset_3, 22, T[3]);
                a = FF(a, b, c, d, M_offset_4, 7, T[4]);
                d = FF(d, a, b, c, M_offset_5, 12, T[5]);
                c = FF(c, d, a, b, M_offset_6, 17, T[6]);
                b = FF(b, c, d, a, M_offset_7, 22, T[7]);
                a = FF(a, b, c, d, M_offset_8, 7, T[8]);
                d = FF(d, a, b, c, M_offset_9, 12, T[9]);
                c = FF(c, d, a, b, M_offset_10, 17, T[10]);
                b = FF(b, c, d, a, M_offset_11, 22, T[11]);
                a = FF(a, b, c, d, M_offset_12, 7, T[12]);
                d = FF(d, a, b, c, M_offset_13, 12, T[13]);
                c = FF(c, d, a, b, M_offset_14, 17, T[14]);
                b = FF(b, c, d, a, M_offset_15, 22, T[15]);
                a = GG(a, b, c, d, M_offset_1, 5, T[16]);
                d = GG(d, a, b, c, M_offset_6, 9, T[17]);
                c = GG(c, d, a, b, M_offset_11, 14, T[18]);
                b = GG(b, c, d, a, M_offset_0, 20, T[19]);
                a = GG(a, b, c, d, M_offset_5, 5, T[20]);
                d = GG(d, a, b, c, M_offset_10, 9, T[21]);
                c = GG(c, d, a, b, M_offset_15, 14, T[22]);
                b = GG(b, c, d, a, M_offset_4, 20, T[23]);
                a = GG(a, b, c, d, M_offset_9, 5, T[24]);
                d = GG(d, a, b, c, M_offset_14, 9, T[25]);
                c = GG(c, d, a, b, M_offset_3, 14, T[26]);
                b = GG(b, c, d, a, M_offset_8, 20, T[27]);
                a = GG(a, b, c, d, M_offset_13, 5, T[28]);
                d = GG(d, a, b, c, M_offset_2, 9, T[29]);
                c = GG(c, d, a, b, M_offset_7, 14, T[30]);
                b = GG(b, c, d, a, M_offset_12, 20, T[31]);
                a = HH(a, b, c, d, M_offset_5, 4, T[32]);
                d = HH(d, a, b, c, M_offset_8, 11, T[33]);
                c = HH(c, d, a, b, M_offset_11, 16, T[34]);
                b = HH(b, c, d, a, M_offset_14, 23, T[35]);
                a = HH(a, b, c, d, M_offset_1, 4, T[36]);
                d = HH(d, a, b, c, M_offset_4, 11, T[37]);
                c = HH(c, d, a, b, M_offset_7, 16, T[38]);
                b = HH(b, c, d, a, M_offset_10, 23, T[39]);
                a = HH(a, b, c, d, M_offset_13, 4, T[40]);
                d = HH(d, a, b, c, M_offset_0, 11, T[41]);
                c = HH(c, d, a, b, M_offset_3, 16, T[42]);
                b = HH(b, c, d, a, M_offset_6, 23, T[43]);
                a = HH(a, b, c, d, M_offset_9, 4, T[44]);
                d = HH(d, a, b, c, M_offset_12, 11, T[45]);
                c = HH(c, d, a, b, M_offset_15, 16, T[46]);
                b = HH(b, c, d, a, M_offset_2, 23, T[47]);
                a = II(a, b, c, d, M_offset_0, 6, T[48]);
                d = II(d, a, b, c, M_offset_7, 10, T[49]);
                c = II(c, d, a, b, M_offset_14, 15, T[50]);
                b = II(b, c, d, a, M_offset_5, 21, T[51]);
                a = II(a, b, c, d, M_offset_12, 6, T[52]);
                d = II(d, a, b, c, M_offset_3, 10, T[53]);
                c = II(c, d, a, b, M_offset_10, 15, T[54]);
                b = II(b, c, d, a, M_offset_1, 21, T[55]);
                a = II(a, b, c, d, M_offset_8, 6, T[56]);
                d = II(d, a, b, c, M_offset_15, 10, T[57]);
                c = II(c, d, a, b, M_offset_6, 15, T[58]);
                b = II(b, c, d, a, M_offset_13, 21, T[59]);
                a = II(a, b, c, d, M_offset_4, 6, T[60]);
                d = II(d, a, b, c, M_offset_11, 10, T[61]);
                c = II(c, d, a, b, M_offset_2, 15, T[62]);
                b = II(b, c, d, a, M_offset_9, 21, T[63]);
                // Intermediate hash value
                H[0] = H[0] + a | 0;
                H[1] = H[1] + b | 0;
                H[2] = H[2] + c | 0;
                H[3] = H[3] + d | 0;
            },
            _doFinalize: function() {
                // Shortcuts
                var data = this._data;
                var dataWords = data.words;
                var nBitsTotal = this._nDataBytes * 8;
                var nBitsLeft = data.sigBytes * 8;
                // Add padding
                dataWords[nBitsLeft >>> 5] |= 0x80 << 24 - nBitsLeft % 32;
                var nBitsTotalH = Math1.floor(nBitsTotal / 0x100000000);
                var nBitsTotalL = nBitsTotal;
                dataWords[(nBitsLeft + 64 >>> 9 << 4) + 15] = (nBitsTotalH << 8 | nBitsTotalH >>> 24) & 0x00ff00ff | (nBitsTotalH << 24 | nBitsTotalH >>> 8) & 0xff00ff00;
                dataWords[(nBitsLeft + 64 >>> 9 << 4) + 14] = (nBitsTotalL << 8 | nBitsTotalL >>> 24) & 0x00ff00ff | (nBitsTotalL << 24 | nBitsTotalL >>> 8) & 0xff00ff00;
                data.sigBytes = (dataWords.length + 1) * 4;
                // Hash final blocks
                this._process();
                // Shortcuts
                var hash = this._hash;
                var H = hash.words;
                // Swap endian
                for(var i = 0; i < 4; i++){
                    // Shortcut
                    var H_i = H[i];
                    H[i] = (H_i << 8 | H_i >>> 24) & 0x00ff00ff | (H_i << 24 | H_i >>> 8) & 0xff00ff00;
                }
                // Return final computed hash
                return hash;
            },
            clone: function() {
                var clone = Hasher.clone.call(this);
                clone._hash = this._hash.clone();
                return clone;
            }
        });
        function FF(a, b, c, d, x, s, t) {
            var n = a + (b & c | ~b & d) + x + t;
            return (n << s | n >>> 32 - s) + b;
        }
        function GG(a, b, c, d, x, s, t) {
            var n = a + (b & d | c & ~d) + x + t;
            return (n << s | n >>> 32 - s) + b;
        }
        function HH(a, b, c, d, x, s, t) {
            var n = a + (b ^ c ^ d) + x + t;
            return (n << s | n >>> 32 - s) + b;
        }
        function II(a, b, c, d, x, s, t) {
            var n = a + (c ^ (b | ~d)) + x + t;
            return (n << s | n >>> 32 - s) + b;
        }
        /**
	     * Shortcut function to the hasher's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     *
	     * @return {WordArray} The hash.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hash = CryptoJS.MD5('message');
	     *     var hash = CryptoJS.MD5(wordArray);
	     */ C.MD5 = Hasher._createHelper(MD5);
        /**
	     * Shortcut function to the HMAC's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     * @param {WordArray|string} key The secret key.
	     *
	     * @return {WordArray} The HMAC.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hmac = CryptoJS.HmacMD5(message, key);
	     */ C.HmacMD5 = Hasher._createHmacHelper(MD5);
    })(Math);
    return CryptoJS.MD5;
});

},{"df297d5f1a7605f5":"isPlo"}],"39xfW":[function(require,module,exports) {
(function(root, factory) {
    // CommonJS
    module.exports = exports = factory(require("7b9891bafba06348"));
})(this, function(CryptoJS) {
    (function() {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var WordArray = C_lib.WordArray;
        var Hasher = C_lib.Hasher;
        var C_algo = C.algo;
        // Reusable object
        var W = [];
        /**
	     * SHA-1 hash algorithm.
	     */ var SHA1 = C_algo.SHA1 = Hasher.extend({
            _doReset: function() {
                this._hash = new WordArray.init([
                    0x67452301,
                    0xefcdab89,
                    0x98badcfe,
                    0x10325476,
                    0xc3d2e1f0
                ]);
            },
            _doProcessBlock: function(M, offset) {
                // Shortcut
                var H = this._hash.words;
                // Working variables
                var a = H[0];
                var b = H[1];
                var c = H[2];
                var d = H[3];
                var e = H[4];
                // Computation
                for(var i = 0; i < 80; i++){
                    if (i < 16) W[i] = M[offset + i] | 0;
                    else {
                        var n = W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16];
                        W[i] = n << 1 | n >>> 31;
                    }
                    var t = (a << 5 | a >>> 27) + e + W[i];
                    if (i < 20) t += (b & c | ~b & d) + 0x5a827999;
                    else if (i < 40) t += (b ^ c ^ d) + 0x6ed9eba1;
                    else if (i < 60) t += (b & c | b & d | c & d) - 0x70e44324;
                    else t += (b ^ c ^ d) - 0x359d3e2a;
                    e = d;
                    d = c;
                    c = b << 30 | b >>> 2;
                    b = a;
                    a = t;
                }
                // Intermediate hash value
                H[0] = H[0] + a | 0;
                H[1] = H[1] + b | 0;
                H[2] = H[2] + c | 0;
                H[3] = H[3] + d | 0;
                H[4] = H[4] + e | 0;
            },
            _doFinalize: function() {
                // Shortcuts
                var data = this._data;
                var dataWords = data.words;
                var nBitsTotal = this._nDataBytes * 8;
                var nBitsLeft = data.sigBytes * 8;
                // Add padding
                dataWords[nBitsLeft >>> 5] |= 0x80 << 24 - nBitsLeft % 32;
                dataWords[(nBitsLeft + 64 >>> 9 << 4) + 14] = Math.floor(nBitsTotal / 0x100000000);
                dataWords[(nBitsLeft + 64 >>> 9 << 4) + 15] = nBitsTotal;
                data.sigBytes = dataWords.length * 4;
                // Hash final blocks
                this._process();
                // Return final computed hash
                return this._hash;
            },
            clone: function() {
                var clone = Hasher.clone.call(this);
                clone._hash = this._hash.clone();
                return clone;
            }
        });
        /**
	     * Shortcut function to the hasher's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     *
	     * @return {WordArray} The hash.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hash = CryptoJS.SHA1('message');
	     *     var hash = CryptoJS.SHA1(wordArray);
	     */ C.SHA1 = Hasher._createHelper(SHA1);
        /**
	     * Shortcut function to the HMAC's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     * @param {WordArray|string} key The secret key.
	     *
	     * @return {WordArray} The HMAC.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hmac = CryptoJS.HmacSHA1(message, key);
	     */ C.HmacSHA1 = Hasher._createHmacHelper(SHA1);
    })();
    return CryptoJS.SHA1;
});

},{"7b9891bafba06348":"isPlo"}],"wtT9M":[function(require,module,exports) {
(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory(require("e8965157f10402b0"), require("422fd5a45e67fd9c"));
})(this, function(CryptoJS) {
    (function() {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var WordArray = C_lib.WordArray;
        var C_algo = C.algo;
        var SHA256 = C_algo.SHA256;
        /**
	     * SHA-224 hash algorithm.
	     */ var SHA224 = C_algo.SHA224 = SHA256.extend({
            _doReset: function() {
                this._hash = new WordArray.init([
                    0xc1059ed8,
                    0x367cd507,
                    0x3070dd17,
                    0xf70e5939,
                    0xffc00b31,
                    0x68581511,
                    0x64f98fa7,
                    0xbefa4fa4
                ]);
            },
            _doFinalize: function() {
                var hash = SHA256._doFinalize.call(this);
                hash.sigBytes -= 4;
                return hash;
            }
        });
        /**
	     * Shortcut function to the hasher's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     *
	     * @return {WordArray} The hash.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hash = CryptoJS.SHA224('message');
	     *     var hash = CryptoJS.SHA224(wordArray);
	     */ C.SHA224 = SHA256._createHelper(SHA224);
        /**
	     * Shortcut function to the HMAC's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     * @param {WordArray|string} key The secret key.
	     *
	     * @return {WordArray} The HMAC.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hmac = CryptoJS.HmacSHA224(message, key);
	     */ C.HmacSHA224 = SHA256._createHmacHelper(SHA224);
    })();
    return CryptoJS.SHA224;
});

},{"e8965157f10402b0":"isPlo","422fd5a45e67fd9c":"geCX9"}],"lotkt":[function(require,module,exports) {
(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory(require("31d6ad3465d16167"), require("c6b2cb3d09716a55"));
})(this, function(CryptoJS) {
    (function() {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var Hasher = C_lib.Hasher;
        var C_x64 = C.x64;
        var X64Word = C_x64.Word;
        var X64WordArray = C_x64.WordArray;
        var C_algo = C.algo;
        function X64Word_create() {
            return X64Word.create.apply(X64Word, arguments);
        }
        // Constants
        var K = [
            X64Word_create(0x428a2f98, 0xd728ae22),
            X64Word_create(0x71374491, 0x23ef65cd),
            X64Word_create(0xb5c0fbcf, 0xec4d3b2f),
            X64Word_create(0xe9b5dba5, 0x8189dbbc),
            X64Word_create(0x3956c25b, 0xf348b538),
            X64Word_create(0x59f111f1, 0xb605d019),
            X64Word_create(0x923f82a4, 0xaf194f9b),
            X64Word_create(0xab1c5ed5, 0xda6d8118),
            X64Word_create(0xd807aa98, 0xa3030242),
            X64Word_create(0x12835b01, 0x45706fbe),
            X64Word_create(0x243185be, 0x4ee4b28c),
            X64Word_create(0x550c7dc3, 0xd5ffb4e2),
            X64Word_create(0x72be5d74, 0xf27b896f),
            X64Word_create(0x80deb1fe, 0x3b1696b1),
            X64Word_create(0x9bdc06a7, 0x25c71235),
            X64Word_create(0xc19bf174, 0xcf692694),
            X64Word_create(0xe49b69c1, 0x9ef14ad2),
            X64Word_create(0xefbe4786, 0x384f25e3),
            X64Word_create(0x0fc19dc6, 0x8b8cd5b5),
            X64Word_create(0x240ca1cc, 0x77ac9c65),
            X64Word_create(0x2de92c6f, 0x592b0275),
            X64Word_create(0x4a7484aa, 0x6ea6e483),
            X64Word_create(0x5cb0a9dc, 0xbd41fbd4),
            X64Word_create(0x76f988da, 0x831153b5),
            X64Word_create(0x983e5152, 0xee66dfab),
            X64Word_create(0xa831c66d, 0x2db43210),
            X64Word_create(0xb00327c8, 0x98fb213f),
            X64Word_create(0xbf597fc7, 0xbeef0ee4),
            X64Word_create(0xc6e00bf3, 0x3da88fc2),
            X64Word_create(0xd5a79147, 0x930aa725),
            X64Word_create(0x06ca6351, 0xe003826f),
            X64Word_create(0x14292967, 0x0a0e6e70),
            X64Word_create(0x27b70a85, 0x46d22ffc),
            X64Word_create(0x2e1b2138, 0x5c26c926),
            X64Word_create(0x4d2c6dfc, 0x5ac42aed),
            X64Word_create(0x53380d13, 0x9d95b3df),
            X64Word_create(0x650a7354, 0x8baf63de),
            X64Word_create(0x766a0abb, 0x3c77b2a8),
            X64Word_create(0x81c2c92e, 0x47edaee6),
            X64Word_create(0x92722c85, 0x1482353b),
            X64Word_create(0xa2bfe8a1, 0x4cf10364),
            X64Word_create(0xa81a664b, 0xbc423001),
            X64Word_create(0xc24b8b70, 0xd0f89791),
            X64Word_create(0xc76c51a3, 0x0654be30),
            X64Word_create(0xd192e819, 0xd6ef5218),
            X64Word_create(0xd6990624, 0x5565a910),
            X64Word_create(0xf40e3585, 0x5771202a),
            X64Word_create(0x106aa070, 0x32bbd1b8),
            X64Word_create(0x19a4c116, 0xb8d2d0c8),
            X64Word_create(0x1e376c08, 0x5141ab53),
            X64Word_create(0x2748774c, 0xdf8eeb99),
            X64Word_create(0x34b0bcb5, 0xe19b48a8),
            X64Word_create(0x391c0cb3, 0xc5c95a63),
            X64Word_create(0x4ed8aa4a, 0xe3418acb),
            X64Word_create(0x5b9cca4f, 0x7763e373),
            X64Word_create(0x682e6ff3, 0xd6b2b8a3),
            X64Word_create(0x748f82ee, 0x5defb2fc),
            X64Word_create(0x78a5636f, 0x43172f60),
            X64Word_create(0x84c87814, 0xa1f0ab72),
            X64Word_create(0x8cc70208, 0x1a6439ec),
            X64Word_create(0x90befffa, 0x23631e28),
            X64Word_create(0xa4506ceb, 0xde82bde9),
            X64Word_create(0xbef9a3f7, 0xb2c67915),
            X64Word_create(0xc67178f2, 0xe372532b),
            X64Word_create(0xca273ece, 0xea26619c),
            X64Word_create(0xd186b8c7, 0x21c0c207),
            X64Word_create(0xeada7dd6, 0xcde0eb1e),
            X64Word_create(0xf57d4f7f, 0xee6ed178),
            X64Word_create(0x06f067aa, 0x72176fba),
            X64Word_create(0x0a637dc5, 0xa2c898a6),
            X64Word_create(0x113f9804, 0xbef90dae),
            X64Word_create(0x1b710b35, 0x131c471b),
            X64Word_create(0x28db77f5, 0x23047d84),
            X64Word_create(0x32caab7b, 0x40c72493),
            X64Word_create(0x3c9ebe0a, 0x15c9bebc),
            X64Word_create(0x431d67c4, 0x9c100d4c),
            X64Word_create(0x4cc5d4be, 0xcb3e42b6),
            X64Word_create(0x597f299c, 0xfc657e2a),
            X64Word_create(0x5fcb6fab, 0x3ad6faec),
            X64Word_create(0x6c44198c, 0x4a475817)
        ];
        // Reusable objects
        var W = [];
        (function() {
            for(var i = 0; i < 80; i++)W[i] = X64Word_create();
        })();
        /**
	     * SHA-512 hash algorithm.
	     */ var SHA512 = C_algo.SHA512 = Hasher.extend({
            _doReset: function() {
                this._hash = new X64WordArray.init([
                    new X64Word.init(0x6a09e667, 0xf3bcc908),
                    new X64Word.init(0xbb67ae85, 0x84caa73b),
                    new X64Word.init(0x3c6ef372, 0xfe94f82b),
                    new X64Word.init(0xa54ff53a, 0x5f1d36f1),
                    new X64Word.init(0x510e527f, 0xade682d1),
                    new X64Word.init(0x9b05688c, 0x2b3e6c1f),
                    new X64Word.init(0x1f83d9ab, 0xfb41bd6b),
                    new X64Word.init(0x5be0cd19, 0x137e2179)
                ]);
            },
            _doProcessBlock: function(M, offset) {
                // Shortcuts
                var H = this._hash.words;
                var H0 = H[0];
                var H1 = H[1];
                var H2 = H[2];
                var H3 = H[3];
                var H4 = H[4];
                var H5 = H[5];
                var H6 = H[6];
                var H7 = H[7];
                var H0h = H0.high;
                var H0l = H0.low;
                var H1h = H1.high;
                var H1l = H1.low;
                var H2h = H2.high;
                var H2l = H2.low;
                var H3h = H3.high;
                var H3l = H3.low;
                var H4h = H4.high;
                var H4l = H4.low;
                var H5h = H5.high;
                var H5l = H5.low;
                var H6h = H6.high;
                var H6l = H6.low;
                var H7h = H7.high;
                var H7l = H7.low;
                // Working variables
                var ah = H0h;
                var al = H0l;
                var bh = H1h;
                var bl = H1l;
                var ch = H2h;
                var cl = H2l;
                var dh = H3h;
                var dl = H3l;
                var eh = H4h;
                var el = H4l;
                var fh = H5h;
                var fl = H5l;
                var gh = H6h;
                var gl = H6l;
                var hh = H7h;
                var hl = H7l;
                // Rounds
                for(var i = 0; i < 80; i++){
                    // Shortcut
                    var Wi = W[i];
                    // Extend message
                    if (i < 16) {
                        var Wih = Wi.high = M[offset + i * 2] | 0;
                        var Wil = Wi.low = M[offset + i * 2 + 1] | 0;
                    } else {
                        // Gamma0
                        var gamma0x = W[i - 15];
                        var gamma0xh = gamma0x.high;
                        var gamma0xl = gamma0x.low;
                        var gamma0h = (gamma0xh >>> 1 | gamma0xl << 31) ^ (gamma0xh >>> 8 | gamma0xl << 24) ^ gamma0xh >>> 7;
                        var gamma0l = (gamma0xl >>> 1 | gamma0xh << 31) ^ (gamma0xl >>> 8 | gamma0xh << 24) ^ (gamma0xl >>> 7 | gamma0xh << 25);
                        // Gamma1
                        var gamma1x = W[i - 2];
                        var gamma1xh = gamma1x.high;
                        var gamma1xl = gamma1x.low;
                        var gamma1h = (gamma1xh >>> 19 | gamma1xl << 13) ^ (gamma1xh << 3 | gamma1xl >>> 29) ^ gamma1xh >>> 6;
                        var gamma1l = (gamma1xl >>> 19 | gamma1xh << 13) ^ (gamma1xl << 3 | gamma1xh >>> 29) ^ (gamma1xl >>> 6 | gamma1xh << 26);
                        // W[i] = gamma0 + W[i - 7] + gamma1 + W[i - 16]
                        var Wi7 = W[i - 7];
                        var Wi7h = Wi7.high;
                        var Wi7l = Wi7.low;
                        var Wi16 = W[i - 16];
                        var Wi16h = Wi16.high;
                        var Wi16l = Wi16.low;
                        var Wil = gamma0l + Wi7l;
                        var Wih = gamma0h + Wi7h + (Wil >>> 0 < gamma0l >>> 0 ? 1 : 0);
                        var Wil = Wil + gamma1l;
                        var Wih = Wih + gamma1h + (Wil >>> 0 < gamma1l >>> 0 ? 1 : 0);
                        var Wil = Wil + Wi16l;
                        var Wih = Wih + Wi16h + (Wil >>> 0 < Wi16l >>> 0 ? 1 : 0);
                        Wi.high = Wih;
                        Wi.low = Wil;
                    }
                    var chh = eh & fh ^ ~eh & gh;
                    var chl = el & fl ^ ~el & gl;
                    var majh = ah & bh ^ ah & ch ^ bh & ch;
                    var majl = al & bl ^ al & cl ^ bl & cl;
                    var sigma0h = (ah >>> 28 | al << 4) ^ (ah << 30 | al >>> 2) ^ (ah << 25 | al >>> 7);
                    var sigma0l = (al >>> 28 | ah << 4) ^ (al << 30 | ah >>> 2) ^ (al << 25 | ah >>> 7);
                    var sigma1h = (eh >>> 14 | el << 18) ^ (eh >>> 18 | el << 14) ^ (eh << 23 | el >>> 9);
                    var sigma1l = (el >>> 14 | eh << 18) ^ (el >>> 18 | eh << 14) ^ (el << 23 | eh >>> 9);
                    // t1 = h + sigma1 + ch + K[i] + W[i]
                    var Ki = K[i];
                    var Kih = Ki.high;
                    var Kil = Ki.low;
                    var t1l = hl + sigma1l;
                    var t1h = hh + sigma1h + (t1l >>> 0 < hl >>> 0 ? 1 : 0);
                    var t1l = t1l + chl;
                    var t1h = t1h + chh + (t1l >>> 0 < chl >>> 0 ? 1 : 0);
                    var t1l = t1l + Kil;
                    var t1h = t1h + Kih + (t1l >>> 0 < Kil >>> 0 ? 1 : 0);
                    var t1l = t1l + Wil;
                    var t1h = t1h + Wih + (t1l >>> 0 < Wil >>> 0 ? 1 : 0);
                    // t2 = sigma0 + maj
                    var t2l = sigma0l + majl;
                    var t2h = sigma0h + majh + (t2l >>> 0 < sigma0l >>> 0 ? 1 : 0);
                    // Update working variables
                    hh = gh;
                    hl = gl;
                    gh = fh;
                    gl = fl;
                    fh = eh;
                    fl = el;
                    el = dl + t1l | 0;
                    eh = dh + t1h + (el >>> 0 < dl >>> 0 ? 1 : 0) | 0;
                    dh = ch;
                    dl = cl;
                    ch = bh;
                    cl = bl;
                    bh = ah;
                    bl = al;
                    al = t1l + t2l | 0;
                    ah = t1h + t2h + (al >>> 0 < t1l >>> 0 ? 1 : 0) | 0;
                }
                // Intermediate hash value
                H0l = H0.low = H0l + al;
                H0.high = H0h + ah + (H0l >>> 0 < al >>> 0 ? 1 : 0);
                H1l = H1.low = H1l + bl;
                H1.high = H1h + bh + (H1l >>> 0 < bl >>> 0 ? 1 : 0);
                H2l = H2.low = H2l + cl;
                H2.high = H2h + ch + (H2l >>> 0 < cl >>> 0 ? 1 : 0);
                H3l = H3.low = H3l + dl;
                H3.high = H3h + dh + (H3l >>> 0 < dl >>> 0 ? 1 : 0);
                H4l = H4.low = H4l + el;
                H4.high = H4h + eh + (H4l >>> 0 < el >>> 0 ? 1 : 0);
                H5l = H5.low = H5l + fl;
                H5.high = H5h + fh + (H5l >>> 0 < fl >>> 0 ? 1 : 0);
                H6l = H6.low = H6l + gl;
                H6.high = H6h + gh + (H6l >>> 0 < gl >>> 0 ? 1 : 0);
                H7l = H7.low = H7l + hl;
                H7.high = H7h + hh + (H7l >>> 0 < hl >>> 0 ? 1 : 0);
            },
            _doFinalize: function() {
                // Shortcuts
                var data = this._data;
                var dataWords = data.words;
                var nBitsTotal = this._nDataBytes * 8;
                var nBitsLeft = data.sigBytes * 8;
                // Add padding
                dataWords[nBitsLeft >>> 5] |= 0x80 << 24 - nBitsLeft % 32;
                dataWords[(nBitsLeft + 128 >>> 10 << 5) + 30] = Math.floor(nBitsTotal / 0x100000000);
                dataWords[(nBitsLeft + 128 >>> 10 << 5) + 31] = nBitsTotal;
                data.sigBytes = dataWords.length * 4;
                // Hash final blocks
                this._process();
                // Convert hash to 32-bit word array before returning
                var hash = this._hash.toX32();
                // Return final computed hash
                return hash;
            },
            clone: function() {
                var clone = Hasher.clone.call(this);
                clone._hash = this._hash.clone();
                return clone;
            },
            blockSize: 32
        });
        /**
	     * Shortcut function to the hasher's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     *
	     * @return {WordArray} The hash.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hash = CryptoJS.SHA512('message');
	     *     var hash = CryptoJS.SHA512(wordArray);
	     */ C.SHA512 = Hasher._createHelper(SHA512);
        /**
	     * Shortcut function to the HMAC's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     * @param {WordArray|string} key The secret key.
	     *
	     * @return {WordArray} The HMAC.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hmac = CryptoJS.HmacSHA512(message, key);
	     */ C.HmacSHA512 = Hasher._createHmacHelper(SHA512);
    })();
    return CryptoJS.SHA512;
});

},{"31d6ad3465d16167":"isPlo","c6b2cb3d09716a55":"hv2ZZ"}],"9c54x":[function(require,module,exports) {
(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory(require("b5fe0ebcfe1041bc"), require("a9e41ebd870c4542"), require("df3c8766d63d1a4"));
})(this, function(CryptoJS) {
    (function() {
        // Shortcuts
        var C = CryptoJS;
        var C_x64 = C.x64;
        var X64Word = C_x64.Word;
        var X64WordArray = C_x64.WordArray;
        var C_algo = C.algo;
        var SHA512 = C_algo.SHA512;
        /**
	     * SHA-384 hash algorithm.
	     */ var SHA384 = C_algo.SHA384 = SHA512.extend({
            _doReset: function() {
                this._hash = new X64WordArray.init([
                    new X64Word.init(0xcbbb9d5d, 0xc1059ed8),
                    new X64Word.init(0x629a292a, 0x367cd507),
                    new X64Word.init(0x9159015a, 0x3070dd17),
                    new X64Word.init(0x152fecd8, 0xf70e5939),
                    new X64Word.init(0x67332667, 0xffc00b31),
                    new X64Word.init(0x8eb44a87, 0x68581511),
                    new X64Word.init(0xdb0c2e0d, 0x64f98fa7),
                    new X64Word.init(0x47b5481d, 0xbefa4fa4)
                ]);
            },
            _doFinalize: function() {
                var hash = SHA512._doFinalize.call(this);
                hash.sigBytes -= 16;
                return hash;
            }
        });
        /**
	     * Shortcut function to the hasher's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     *
	     * @return {WordArray} The hash.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hash = CryptoJS.SHA384('message');
	     *     var hash = CryptoJS.SHA384(wordArray);
	     */ C.SHA384 = SHA512._createHelper(SHA384);
        /**
	     * Shortcut function to the HMAC's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     * @param {WordArray|string} key The secret key.
	     *
	     * @return {WordArray} The HMAC.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hmac = CryptoJS.HmacSHA384(message, key);
	     */ C.HmacSHA384 = SHA512._createHmacHelper(SHA384);
    })();
    return CryptoJS.SHA384;
});

},{"b5fe0ebcfe1041bc":"isPlo","a9e41ebd870c4542":"hv2ZZ","df3c8766d63d1a4":"lotkt"}],"9CwDJ":[function(require,module,exports) {
(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory(require("50cd159714e45996"), require("93026947822c59d9"));
})(this, function(CryptoJS) {
    (function(Math1) {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var WordArray = C_lib.WordArray;
        var Hasher = C_lib.Hasher;
        var C_x64 = C.x64;
        var X64Word = C_x64.Word;
        var C_algo = C.algo;
        // Constants tables
        var RHO_OFFSETS = [];
        var PI_INDEXES = [];
        var ROUND_CONSTANTS = [];
        // Compute Constants
        (function() {
            // Compute rho offset constants
            var x = 1, y = 0;
            for(var t = 0; t < 24; t++){
                RHO_OFFSETS[x + 5 * y] = (t + 1) * (t + 2) / 2 % 64;
                var newX = y % 5;
                var newY = (2 * x + 3 * y) % 5;
                x = newX;
                y = newY;
            }
            // Compute pi index constants
            for(var x = 0; x < 5; x++)for(var y = 0; y < 5; y++)PI_INDEXES[x + 5 * y] = y + (2 * x + 3 * y) % 5 * 5;
            // Compute round constants
            var LFSR = 0x01;
            for(var i = 0; i < 24; i++){
                var roundConstantMsw = 0;
                var roundConstantLsw = 0;
                for(var j = 0; j < 7; j++){
                    if (LFSR & 0x01) {
                        var bitPosition = (1 << j) - 1;
                        if (bitPosition < 32) roundConstantLsw ^= 1 << bitPosition;
                        else roundConstantMsw ^= 1 << bitPosition - 32;
                    }
                    // Compute next LFSR
                    if (LFSR & 0x80) // Primitive polynomial over GF(2): x^8 + x^6 + x^5 + x^4 + 1
                    LFSR = LFSR << 1 ^ 0x71;
                    else LFSR <<= 1;
                }
                ROUND_CONSTANTS[i] = X64Word.create(roundConstantMsw, roundConstantLsw);
            }
        })();
        // Reusable objects for temporary values
        var T = [];
        (function() {
            for(var i = 0; i < 25; i++)T[i] = X64Word.create();
        })();
        /**
	     * SHA-3 hash algorithm.
	     */ var SHA3 = C_algo.SHA3 = Hasher.extend({
            /**
	         * Configuration options.
	         *
	         * @property {number} outputLength
	         *   The desired number of bits in the output hash.
	         *   Only values permitted are: 224, 256, 384, 512.
	         *   Default: 512
	         */ cfg: Hasher.cfg.extend({
                outputLength: 512
            }),
            _doReset: function() {
                var state = this._state = [];
                for(var i = 0; i < 25; i++)state[i] = new X64Word.init();
                this.blockSize = (1600 - 2 * this.cfg.outputLength) / 32;
            },
            _doProcessBlock: function(M, offset) {
                // Shortcuts
                var state = this._state;
                var nBlockSizeLanes = this.blockSize / 2;
                // Absorb
                for(var i = 0; i < nBlockSizeLanes; i++){
                    // Shortcuts
                    var M2i = M[offset + 2 * i];
                    var M2i1 = M[offset + 2 * i + 1];
                    // Swap endian
                    M2i = (M2i << 8 | M2i >>> 24) & 0x00ff00ff | (M2i << 24 | M2i >>> 8) & 0xff00ff00;
                    M2i1 = (M2i1 << 8 | M2i1 >>> 24) & 0x00ff00ff | (M2i1 << 24 | M2i1 >>> 8) & 0xff00ff00;
                    // Absorb message into state
                    var lane = state[i];
                    lane.high ^= M2i1;
                    lane.low ^= M2i;
                }
                // Rounds
                for(var round = 0; round < 24; round++){
                    // Theta
                    for(var x = 0; x < 5; x++){
                        // Mix column lanes
                        var tMsw = 0, tLsw = 0;
                        for(var y = 0; y < 5; y++){
                            var lane = state[x + 5 * y];
                            tMsw ^= lane.high;
                            tLsw ^= lane.low;
                        }
                        // Temporary values
                        var Tx = T[x];
                        Tx.high = tMsw;
                        Tx.low = tLsw;
                    }
                    for(var x = 0; x < 5; x++){
                        // Shortcuts
                        var Tx4 = T[(x + 4) % 5];
                        var Tx1 = T[(x + 1) % 5];
                        var Tx1Msw = Tx1.high;
                        var Tx1Lsw = Tx1.low;
                        // Mix surrounding columns
                        var tMsw = Tx4.high ^ (Tx1Msw << 1 | Tx1Lsw >>> 31);
                        var tLsw = Tx4.low ^ (Tx1Lsw << 1 | Tx1Msw >>> 31);
                        for(var y = 0; y < 5; y++){
                            var lane = state[x + 5 * y];
                            lane.high ^= tMsw;
                            lane.low ^= tLsw;
                        }
                    }
                    // Rho Pi
                    for(var laneIndex = 1; laneIndex < 25; laneIndex++){
                        // Shortcuts
                        var lane = state[laneIndex];
                        var laneMsw = lane.high;
                        var laneLsw = lane.low;
                        var rhoOffset = RHO_OFFSETS[laneIndex];
                        // Rotate lanes
                        if (rhoOffset < 32) {
                            var tMsw = laneMsw << rhoOffset | laneLsw >>> 32 - rhoOffset;
                            var tLsw = laneLsw << rhoOffset | laneMsw >>> 32 - rhoOffset;
                        } else /* if (rhoOffset >= 32) */ {
                            var tMsw = laneLsw << rhoOffset - 32 | laneMsw >>> 64 - rhoOffset;
                            var tLsw = laneMsw << rhoOffset - 32 | laneLsw >>> 64 - rhoOffset;
                        }
                        // Transpose lanes
                        var TPiLane = T[PI_INDEXES[laneIndex]];
                        TPiLane.high = tMsw;
                        TPiLane.low = tLsw;
                    }
                    // Rho pi at x = y = 0
                    var T0 = T[0];
                    var state0 = state[0];
                    T0.high = state0.high;
                    T0.low = state0.low;
                    // Chi
                    for(var x = 0; x < 5; x++)for(var y = 0; y < 5; y++){
                        // Shortcuts
                        var laneIndex = x + 5 * y;
                        var lane = state[laneIndex];
                        var TLane = T[laneIndex];
                        var Tx1Lane = T[(x + 1) % 5 + 5 * y];
                        var Tx2Lane = T[(x + 2) % 5 + 5 * y];
                        // Mix rows
                        lane.high = TLane.high ^ ~Tx1Lane.high & Tx2Lane.high;
                        lane.low = TLane.low ^ ~Tx1Lane.low & Tx2Lane.low;
                    }
                    // Iota
                    var lane = state[0];
                    var roundConstant = ROUND_CONSTANTS[round];
                    lane.high ^= roundConstant.high;
                    lane.low ^= roundConstant.low;
                }
            },
            _doFinalize: function() {
                // Shortcuts
                var data = this._data;
                var dataWords = data.words;
                var nBitsTotal = this._nDataBytes * 8;
                var nBitsLeft = data.sigBytes * 8;
                var blockSizeBits = this.blockSize * 32;
                // Add padding
                dataWords[nBitsLeft >>> 5] |= 0x1 << 24 - nBitsLeft % 32;
                dataWords[(Math1.ceil((nBitsLeft + 1) / blockSizeBits) * blockSizeBits >>> 5) - 1] |= 0x80;
                data.sigBytes = dataWords.length * 4;
                // Hash final blocks
                this._process();
                // Shortcuts
                var state = this._state;
                var outputLengthBytes = this.cfg.outputLength / 8;
                var outputLengthLanes = outputLengthBytes / 8;
                // Squeeze
                var hashWords = [];
                for(var i = 0; i < outputLengthLanes; i++){
                    // Shortcuts
                    var lane = state[i];
                    var laneMsw = lane.high;
                    var laneLsw = lane.low;
                    // Swap endian
                    laneMsw = (laneMsw << 8 | laneMsw >>> 24) & 0x00ff00ff | (laneMsw << 24 | laneMsw >>> 8) & 0xff00ff00;
                    laneLsw = (laneLsw << 8 | laneLsw >>> 24) & 0x00ff00ff | (laneLsw << 24 | laneLsw >>> 8) & 0xff00ff00;
                    // Squeeze state to retrieve hash
                    hashWords.push(laneLsw);
                    hashWords.push(laneMsw);
                }
                // Return final computed hash
                return new WordArray.init(hashWords, outputLengthBytes);
            },
            clone: function() {
                var clone = Hasher.clone.call(this);
                var state = clone._state = this._state.slice(0);
                for(var i = 0; i < 25; i++)state[i] = state[i].clone();
                return clone;
            }
        });
        /**
	     * Shortcut function to the hasher's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     *
	     * @return {WordArray} The hash.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hash = CryptoJS.SHA3('message');
	     *     var hash = CryptoJS.SHA3(wordArray);
	     */ C.SHA3 = Hasher._createHelper(SHA3);
        /**
	     * Shortcut function to the HMAC's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     * @param {WordArray|string} key The secret key.
	     *
	     * @return {WordArray} The HMAC.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hmac = CryptoJS.HmacSHA3(message, key);
	     */ C.HmacSHA3 = Hasher._createHmacHelper(SHA3);
    })(Math);
    return CryptoJS.SHA3;
});

},{"50cd159714e45996":"isPlo","93026947822c59d9":"hv2ZZ"}],"lsKgK":[function(require,module,exports) {
(function(root, factory) {
    // CommonJS
    module.exports = exports = factory(require("f465710c5187ca82"));
})(this, function(CryptoJS) {
    /** @preserve
	(c) 2012 by Cédric Mesnil. All rights reserved.

	Redistribution and use in source and binary forms, with or without modification, are permitted provided that the following conditions are met:

	    - Redistributions of source code must retain the above copyright notice, this list of conditions and the following disclaimer.
	    - Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the following disclaimer in the documentation and/or other materials provided with the distribution.

	THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
	*/ (function(Math1) {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var WordArray = C_lib.WordArray;
        var Hasher = C_lib.Hasher;
        var C_algo = C.algo;
        // Constants table
        var _zl = WordArray.create([
            0,
            1,
            2,
            3,
            4,
            5,
            6,
            7,
            8,
            9,
            10,
            11,
            12,
            13,
            14,
            15,
            7,
            4,
            13,
            1,
            10,
            6,
            15,
            3,
            12,
            0,
            9,
            5,
            2,
            14,
            11,
            8,
            3,
            10,
            14,
            4,
            9,
            15,
            8,
            1,
            2,
            7,
            0,
            6,
            13,
            11,
            5,
            12,
            1,
            9,
            11,
            10,
            0,
            8,
            12,
            4,
            13,
            3,
            7,
            15,
            14,
            5,
            6,
            2,
            4,
            0,
            5,
            9,
            7,
            12,
            2,
            10,
            14,
            1,
            3,
            8,
            11,
            6,
            15,
            13
        ]);
        var _zr = WordArray.create([
            5,
            14,
            7,
            0,
            9,
            2,
            11,
            4,
            13,
            6,
            15,
            8,
            1,
            10,
            3,
            12,
            6,
            11,
            3,
            7,
            0,
            13,
            5,
            10,
            14,
            15,
            8,
            12,
            4,
            9,
            1,
            2,
            15,
            5,
            1,
            3,
            7,
            14,
            6,
            9,
            11,
            8,
            12,
            2,
            10,
            0,
            4,
            13,
            8,
            6,
            4,
            1,
            3,
            11,
            15,
            0,
            5,
            12,
            2,
            13,
            9,
            7,
            10,
            14,
            12,
            15,
            10,
            4,
            1,
            5,
            8,
            7,
            6,
            2,
            13,
            14,
            0,
            3,
            9,
            11
        ]);
        var _sl = WordArray.create([
            11,
            14,
            15,
            12,
            5,
            8,
            7,
            9,
            11,
            13,
            14,
            15,
            6,
            7,
            9,
            8,
            7,
            6,
            8,
            13,
            11,
            9,
            7,
            15,
            7,
            12,
            15,
            9,
            11,
            7,
            13,
            12,
            11,
            13,
            6,
            7,
            14,
            9,
            13,
            15,
            14,
            8,
            13,
            6,
            5,
            12,
            7,
            5,
            11,
            12,
            14,
            15,
            14,
            15,
            9,
            8,
            9,
            14,
            5,
            6,
            8,
            6,
            5,
            12,
            9,
            15,
            5,
            11,
            6,
            8,
            13,
            12,
            5,
            12,
            13,
            14,
            11,
            8,
            5,
            6
        ]);
        var _sr = WordArray.create([
            8,
            9,
            9,
            11,
            13,
            15,
            15,
            5,
            7,
            7,
            8,
            11,
            14,
            14,
            12,
            6,
            9,
            13,
            15,
            7,
            12,
            8,
            9,
            11,
            7,
            7,
            12,
            7,
            6,
            15,
            13,
            11,
            9,
            7,
            15,
            11,
            8,
            6,
            6,
            14,
            12,
            13,
            5,
            14,
            13,
            13,
            7,
            5,
            15,
            5,
            8,
            11,
            14,
            14,
            6,
            14,
            6,
            9,
            12,
            9,
            12,
            5,
            15,
            8,
            8,
            5,
            12,
            9,
            12,
            5,
            14,
            6,
            8,
            13,
            6,
            5,
            15,
            13,
            11,
            11
        ]);
        var _hl = WordArray.create([
            0x00000000,
            0x5A827999,
            0x6ED9EBA1,
            0x8F1BBCDC,
            0xA953FD4E
        ]);
        var _hr = WordArray.create([
            0x50A28BE6,
            0x5C4DD124,
            0x6D703EF3,
            0x7A6D76E9,
            0x00000000
        ]);
        /**
	     * RIPEMD160 hash algorithm.
	     */ var RIPEMD160 = C_algo.RIPEMD160 = Hasher.extend({
            _doReset: function() {
                this._hash = WordArray.create([
                    0x67452301,
                    0xEFCDAB89,
                    0x98BADCFE,
                    0x10325476,
                    0xC3D2E1F0
                ]);
            },
            _doProcessBlock: function(M, offset) {
                // Swap endian
                for(var i = 0; i < 16; i++){
                    // Shortcuts
                    var offset_i = offset + i;
                    var M_offset_i = M[offset_i];
                    // Swap
                    M[offset_i] = (M_offset_i << 8 | M_offset_i >>> 24) & 0x00ff00ff | (M_offset_i << 24 | M_offset_i >>> 8) & 0xff00ff00;
                }
                // Shortcut
                var H = this._hash.words;
                var hl = _hl.words;
                var hr = _hr.words;
                var zl = _zl.words;
                var zr = _zr.words;
                var sl = _sl.words;
                var sr = _sr.words;
                // Working variables
                var al, bl, cl, dl, el;
                var ar, br, cr, dr, er;
                ar = al = H[0];
                br = bl = H[1];
                cr = cl = H[2];
                dr = dl = H[3];
                er = el = H[4];
                // Computation
                var t;
                for(var i = 0; i < 80; i += 1){
                    t = al + M[offset + zl[i]] | 0;
                    if (i < 16) t += f1(bl, cl, dl) + hl[0];
                    else if (i < 32) t += f2(bl, cl, dl) + hl[1];
                    else if (i < 48) t += f3(bl, cl, dl) + hl[2];
                    else if (i < 64) t += f4(bl, cl, dl) + hl[3];
                    else t += f5(bl, cl, dl) + hl[4];
                    t = t | 0;
                    t = rotl(t, sl[i]);
                    t = t + el | 0;
                    al = el;
                    el = dl;
                    dl = rotl(cl, 10);
                    cl = bl;
                    bl = t;
                    t = ar + M[offset + zr[i]] | 0;
                    if (i < 16) t += f5(br, cr, dr) + hr[0];
                    else if (i < 32) t += f4(br, cr, dr) + hr[1];
                    else if (i < 48) t += f3(br, cr, dr) + hr[2];
                    else if (i < 64) t += f2(br, cr, dr) + hr[3];
                    else t += f1(br, cr, dr) + hr[4];
                    t = t | 0;
                    t = rotl(t, sr[i]);
                    t = t + er | 0;
                    ar = er;
                    er = dr;
                    dr = rotl(cr, 10);
                    cr = br;
                    br = t;
                }
                // Intermediate hash value
                t = H[1] + cl + dr | 0;
                H[1] = H[2] + dl + er | 0;
                H[2] = H[3] + el + ar | 0;
                H[3] = H[4] + al + br | 0;
                H[4] = H[0] + bl + cr | 0;
                H[0] = t;
            },
            _doFinalize: function() {
                // Shortcuts
                var data = this._data;
                var dataWords = data.words;
                var nBitsTotal = this._nDataBytes * 8;
                var nBitsLeft = data.sigBytes * 8;
                // Add padding
                dataWords[nBitsLeft >>> 5] |= 0x80 << 24 - nBitsLeft % 32;
                dataWords[(nBitsLeft + 64 >>> 9 << 4) + 14] = (nBitsTotal << 8 | nBitsTotal >>> 24) & 0x00ff00ff | (nBitsTotal << 24 | nBitsTotal >>> 8) & 0xff00ff00;
                data.sigBytes = (dataWords.length + 1) * 4;
                // Hash final blocks
                this._process();
                // Shortcuts
                var hash = this._hash;
                var H = hash.words;
                // Swap endian
                for(var i = 0; i < 5; i++){
                    // Shortcut
                    var H_i = H[i];
                    // Swap
                    H[i] = (H_i << 8 | H_i >>> 24) & 0x00ff00ff | (H_i << 24 | H_i >>> 8) & 0xff00ff00;
                }
                // Return final computed hash
                return hash;
            },
            clone: function() {
                var clone = Hasher.clone.call(this);
                clone._hash = this._hash.clone();
                return clone;
            }
        });
        function f1(x, y, z) {
            return x ^ y ^ z;
        }
        function f2(x, y, z) {
            return x & y | ~x & z;
        }
        function f3(x, y, z) {
            return (x | ~y) ^ z;
        }
        function f4(x, y, z) {
            return x & z | y & ~z;
        }
        function f5(x, y, z) {
            return x ^ (y | ~z);
        }
        function rotl(x, n) {
            return x << n | x >>> 32 - n;
        }
        /**
	     * Shortcut function to the hasher's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     *
	     * @return {WordArray} The hash.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hash = CryptoJS.RIPEMD160('message');
	     *     var hash = CryptoJS.RIPEMD160(wordArray);
	     */ C.RIPEMD160 = Hasher._createHelper(RIPEMD160);
        /**
	     * Shortcut function to the HMAC's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     * @param {WordArray|string} key The secret key.
	     *
	     * @return {WordArray} The HMAC.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hmac = CryptoJS.HmacRIPEMD160(message, key);
	     */ C.HmacRIPEMD160 = Hasher._createHmacHelper(RIPEMD160);
    })(Math);
    return CryptoJS.RIPEMD160;
});

},{"f465710c5187ca82":"isPlo"}],"ffTZ0":[function(require,module,exports) {
(function(root, factory) {
    // CommonJS
    module.exports = exports = factory(require("7479609d4f7429fa"));
})(this, function(CryptoJS) {
    (function() {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var Base = C_lib.Base;
        var C_enc = C.enc;
        var Utf8 = C_enc.Utf8;
        var C_algo = C.algo;
        /**
	     * HMAC algorithm.
	     */ var HMAC = C_algo.HMAC = Base.extend({
            /**
	         * Initializes a newly created HMAC.
	         *
	         * @param {Hasher} hasher The hash algorithm to use.
	         * @param {WordArray|string} key The secret key.
	         *
	         * @example
	         *
	         *     var hmacHasher = CryptoJS.algo.HMAC.create(CryptoJS.algo.SHA256, key);
	         */ init: function(hasher, key) {
                // Init hasher
                hasher = this._hasher = new hasher.init();
                // Convert string to WordArray, else assume WordArray already
                if (typeof key == "string") key = Utf8.parse(key);
                // Shortcuts
                var hasherBlockSize = hasher.blockSize;
                var hasherBlockSizeBytes = hasherBlockSize * 4;
                // Allow arbitrary length keys
                if (key.sigBytes > hasherBlockSizeBytes) key = hasher.finalize(key);
                // Clamp excess bits
                key.clamp();
                // Clone key for inner and outer pads
                var oKey = this._oKey = key.clone();
                var iKey = this._iKey = key.clone();
                // Shortcuts
                var oKeyWords = oKey.words;
                var iKeyWords = iKey.words;
                // XOR keys with pad constants
                for(var i = 0; i < hasherBlockSize; i++){
                    oKeyWords[i] ^= 0x5c5c5c5c;
                    iKeyWords[i] ^= 0x36363636;
                }
                oKey.sigBytes = iKey.sigBytes = hasherBlockSizeBytes;
                // Set initial values
                this.reset();
            },
            /**
	         * Resets this HMAC to its initial state.
	         *
	         * @example
	         *
	         *     hmacHasher.reset();
	         */ reset: function() {
                // Shortcut
                var hasher = this._hasher;
                // Reset
                hasher.reset();
                hasher.update(this._iKey);
            },
            /**
	         * Updates this HMAC with a message.
	         *
	         * @param {WordArray|string} messageUpdate The message to append.
	         *
	         * @return {HMAC} This HMAC instance.
	         *
	         * @example
	         *
	         *     hmacHasher.update('message');
	         *     hmacHasher.update(wordArray);
	         */ update: function(messageUpdate) {
                this._hasher.update(messageUpdate);
                // Chainable
                return this;
            },
            /**
	         * Finalizes the HMAC computation.
	         * Note that the finalize operation is effectively a destructive, read-once operation.
	         *
	         * @param {WordArray|string} messageUpdate (Optional) A final message update.
	         *
	         * @return {WordArray} The HMAC.
	         *
	         * @example
	         *
	         *     var hmac = hmacHasher.finalize();
	         *     var hmac = hmacHasher.finalize('message');
	         *     var hmac = hmacHasher.finalize(wordArray);
	         */ finalize: function(messageUpdate) {
                // Shortcut
                var hasher = this._hasher;
                // Compute HMAC
                var innerHash = hasher.finalize(messageUpdate);
                hasher.reset();
                var hmac = hasher.finalize(this._oKey.clone().concat(innerHash));
                return hmac;
            }
        });
    })();
});

},{"7479609d4f7429fa":"isPlo"}],"lfgIo":[function(require,module,exports) {
(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory(require("1c341b8fa9fa7ba5"), require("976dced35bc171"), require("d435910d805b159d"));
})(this, function(CryptoJS) {
    (function() {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var Base = C_lib.Base;
        var WordArray = C_lib.WordArray;
        var C_algo = C.algo;
        var SHA1 = C_algo.SHA1;
        var HMAC = C_algo.HMAC;
        /**
	     * Password-Based Key Derivation Function 2 algorithm.
	     */ var PBKDF2 = C_algo.PBKDF2 = Base.extend({
            /**
	         * Configuration options.
	         *
	         * @property {number} keySize The key size in words to generate. Default: 4 (128 bits)
	         * @property {Hasher} hasher The hasher to use. Default: SHA1
	         * @property {number} iterations The number of iterations to perform. Default: 1
	         */ cfg: Base.extend({
                keySize: 4,
                hasher: SHA1,
                iterations: 1
            }),
            /**
	         * Initializes a newly created key derivation function.
	         *
	         * @param {Object} cfg (Optional) The configuration options to use for the derivation.
	         *
	         * @example
	         *
	         *     var kdf = CryptoJS.algo.PBKDF2.create();
	         *     var kdf = CryptoJS.algo.PBKDF2.create({ keySize: 8 });
	         *     var kdf = CryptoJS.algo.PBKDF2.create({ keySize: 8, iterations: 1000 });
	         */ init: function(cfg) {
                this.cfg = this.cfg.extend(cfg);
            },
            /**
	         * Computes the Password-Based Key Derivation Function 2.
	         *
	         * @param {WordArray|string} password The password.
	         * @param {WordArray|string} salt A salt.
	         *
	         * @return {WordArray} The derived key.
	         *
	         * @example
	         *
	         *     var key = kdf.compute(password, salt);
	         */ compute: function(password, salt) {
                // Shortcut
                var cfg = this.cfg;
                // Init HMAC
                var hmac = HMAC.create(cfg.hasher, password);
                // Initial values
                var derivedKey = WordArray.create();
                var blockIndex = WordArray.create([
                    0x00000001
                ]);
                // Shortcuts
                var derivedKeyWords = derivedKey.words;
                var blockIndexWords = blockIndex.words;
                var keySize = cfg.keySize;
                var iterations = cfg.iterations;
                // Generate key
                while(derivedKeyWords.length < keySize){
                    var block = hmac.update(salt).finalize(blockIndex);
                    hmac.reset();
                    // Shortcuts
                    var blockWords = block.words;
                    var blockWordsLength = blockWords.length;
                    // Iterations
                    var intermediate = block;
                    for(var i = 1; i < iterations; i++){
                        intermediate = hmac.finalize(intermediate);
                        hmac.reset();
                        // Shortcut
                        var intermediateWords = intermediate.words;
                        // XOR intermediate with block
                        for(var j = 0; j < blockWordsLength; j++)blockWords[j] ^= intermediateWords[j];
                    }
                    derivedKey.concat(block);
                    blockIndexWords[0]++;
                }
                derivedKey.sigBytes = keySize * 4;
                return derivedKey;
            }
        });
        /**
	     * Computes the Password-Based Key Derivation Function 2.
	     *
	     * @param {WordArray|string} password The password.
	     * @param {WordArray|string} salt A salt.
	     * @param {Object} cfg (Optional) The configuration options to use for this computation.
	     *
	     * @return {WordArray} The derived key.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var key = CryptoJS.PBKDF2(password, salt);
	     *     var key = CryptoJS.PBKDF2(password, salt, { keySize: 8 });
	     *     var key = CryptoJS.PBKDF2(password, salt, { keySize: 8, iterations: 1000 });
	     */ C.PBKDF2 = function(password, salt, cfg) {
            return PBKDF2.create(cfg).compute(password, salt);
        };
    })();
    return CryptoJS.PBKDF2;
});

},{"1c341b8fa9fa7ba5":"isPlo","976dced35bc171":"39xfW","d435910d805b159d":"ffTZ0"}],"8HKlY":[function(require,module,exports) {
(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory(require("b3eece319621bd0d"), require("1519e429561ccd1a"), require("a4a8e103be66f413"));
})(this, function(CryptoJS) {
    (function() {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var Base = C_lib.Base;
        var WordArray = C_lib.WordArray;
        var C_algo = C.algo;
        var MD5 = C_algo.MD5;
        /**
	     * This key derivation function is meant to conform with EVP_BytesToKey.
	     * www.openssl.org/docs/crypto/EVP_BytesToKey.html
	     */ var EvpKDF = C_algo.EvpKDF = Base.extend({
            /**
	         * Configuration options.
	         *
	         * @property {number} keySize The key size in words to generate. Default: 4 (128 bits)
	         * @property {Hasher} hasher The hash algorithm to use. Default: MD5
	         * @property {number} iterations The number of iterations to perform. Default: 1
	         */ cfg: Base.extend({
                keySize: 4,
                hasher: MD5,
                iterations: 1
            }),
            /**
	         * Initializes a newly created key derivation function.
	         *
	         * @param {Object} cfg (Optional) The configuration options to use for the derivation.
	         *
	         * @example
	         *
	         *     var kdf = CryptoJS.algo.EvpKDF.create();
	         *     var kdf = CryptoJS.algo.EvpKDF.create({ keySize: 8 });
	         *     var kdf = CryptoJS.algo.EvpKDF.create({ keySize: 8, iterations: 1000 });
	         */ init: function(cfg) {
                this.cfg = this.cfg.extend(cfg);
            },
            /**
	         * Derives a key from a password.
	         *
	         * @param {WordArray|string} password The password.
	         * @param {WordArray|string} salt A salt.
	         *
	         * @return {WordArray} The derived key.
	         *
	         * @example
	         *
	         *     var key = kdf.compute(password, salt);
	         */ compute: function(password, salt) {
                // Shortcut
                var cfg = this.cfg;
                // Init hasher
                var hasher = cfg.hasher.create();
                // Initial values
                var derivedKey = WordArray.create();
                // Shortcuts
                var derivedKeyWords = derivedKey.words;
                var keySize = cfg.keySize;
                var iterations = cfg.iterations;
                // Generate key
                while(derivedKeyWords.length < keySize){
                    if (block) hasher.update(block);
                    var block = hasher.update(password).finalize(salt);
                    hasher.reset();
                    // Iterations
                    for(var i = 1; i < iterations; i++){
                        block = hasher.finalize(block);
                        hasher.reset();
                    }
                    derivedKey.concat(block);
                }
                derivedKey.sigBytes = keySize * 4;
                return derivedKey;
            }
        });
        /**
	     * Derives a key from a password.
	     *
	     * @param {WordArray|string} password The password.
	     * @param {WordArray|string} salt A salt.
	     * @param {Object} cfg (Optional) The configuration options to use for this computation.
	     *
	     * @return {WordArray} The derived key.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var key = CryptoJS.EvpKDF(password, salt);
	     *     var key = CryptoJS.EvpKDF(password, salt, { keySize: 8 });
	     *     var key = CryptoJS.EvpKDF(password, salt, { keySize: 8, iterations: 1000 });
	     */ C.EvpKDF = function(password, salt, cfg) {
            return EvpKDF.create(cfg).compute(password, salt);
        };
    })();
    return CryptoJS.EvpKDF;
});

},{"b3eece319621bd0d":"isPlo","1519e429561ccd1a":"39xfW","a4a8e103be66f413":"ffTZ0"}],"inDpW":[function(require,module,exports) {
(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory(require("cd9e7c148581f3f"), require("a566ab64a571fabc"));
})(this, function(CryptoJS) {
    /**
	 * Cipher core components.
	 */ CryptoJS.lib.Cipher || function(undefined) {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var Base = C_lib.Base;
        var WordArray = C_lib.WordArray;
        var BufferedBlockAlgorithm = C_lib.BufferedBlockAlgorithm;
        var C_enc = C.enc;
        var Utf8 = C_enc.Utf8;
        var Base64 = C_enc.Base64;
        var C_algo = C.algo;
        var EvpKDF = C_algo.EvpKDF;
        /**
	     * Abstract base cipher template.
	     *
	     * @property {number} keySize This cipher's key size. Default: 4 (128 bits)
	     * @property {number} ivSize This cipher's IV size. Default: 4 (128 bits)
	     * @property {number} _ENC_XFORM_MODE A constant representing encryption mode.
	     * @property {number} _DEC_XFORM_MODE A constant representing decryption mode.
	     */ var Cipher = C_lib.Cipher = BufferedBlockAlgorithm.extend({
            /**
	         * Configuration options.
	         *
	         * @property {WordArray} iv The IV to use for this operation.
	         */ cfg: Base.extend(),
            /**
	         * Creates this cipher in encryption mode.
	         *
	         * @param {WordArray} key The key.
	         * @param {Object} cfg (Optional) The configuration options to use for this operation.
	         *
	         * @return {Cipher} A cipher instance.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var cipher = CryptoJS.algo.AES.createEncryptor(keyWordArray, { iv: ivWordArray });
	         */ createEncryptor: function(key, cfg) {
                return this.create(this._ENC_XFORM_MODE, key, cfg);
            },
            /**
	         * Creates this cipher in decryption mode.
	         *
	         * @param {WordArray} key The key.
	         * @param {Object} cfg (Optional) The configuration options to use for this operation.
	         *
	         * @return {Cipher} A cipher instance.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var cipher = CryptoJS.algo.AES.createDecryptor(keyWordArray, { iv: ivWordArray });
	         */ createDecryptor: function(key, cfg) {
                return this.create(this._DEC_XFORM_MODE, key, cfg);
            },
            /**
	         * Initializes a newly created cipher.
	         *
	         * @param {number} xformMode Either the encryption or decryption transormation mode constant.
	         * @param {WordArray} key The key.
	         * @param {Object} cfg (Optional) The configuration options to use for this operation.
	         *
	         * @example
	         *
	         *     var cipher = CryptoJS.algo.AES.create(CryptoJS.algo.AES._ENC_XFORM_MODE, keyWordArray, { iv: ivWordArray });
	         */ init: function(xformMode, key, cfg) {
                // Apply config defaults
                this.cfg = this.cfg.extend(cfg);
                // Store transform mode and key
                this._xformMode = xformMode;
                this._key = key;
                // Set initial values
                this.reset();
            },
            /**
	         * Resets this cipher to its initial state.
	         *
	         * @example
	         *
	         *     cipher.reset();
	         */ reset: function() {
                // Reset data buffer
                BufferedBlockAlgorithm.reset.call(this);
                // Perform concrete-cipher logic
                this._doReset();
            },
            /**
	         * Adds data to be encrypted or decrypted.
	         *
	         * @param {WordArray|string} dataUpdate The data to encrypt or decrypt.
	         *
	         * @return {WordArray} The data after processing.
	         *
	         * @example
	         *
	         *     var encrypted = cipher.process('data');
	         *     var encrypted = cipher.process(wordArray);
	         */ process: function(dataUpdate) {
                // Append
                this._append(dataUpdate);
                // Process available blocks
                return this._process();
            },
            /**
	         * Finalizes the encryption or decryption process.
	         * Note that the finalize operation is effectively a destructive, read-once operation.
	         *
	         * @param {WordArray|string} dataUpdate The final data to encrypt or decrypt.
	         *
	         * @return {WordArray} The data after final processing.
	         *
	         * @example
	         *
	         *     var encrypted = cipher.finalize();
	         *     var encrypted = cipher.finalize('data');
	         *     var encrypted = cipher.finalize(wordArray);
	         */ finalize: function(dataUpdate) {
                // Final data update
                if (dataUpdate) this._append(dataUpdate);
                // Perform concrete-cipher logic
                var finalProcessedData = this._doFinalize();
                return finalProcessedData;
            },
            keySize: 4,
            ivSize: 4,
            _ENC_XFORM_MODE: 1,
            _DEC_XFORM_MODE: 2,
            /**
	         * Creates shortcut functions to a cipher's object interface.
	         *
	         * @param {Cipher} cipher The cipher to create a helper for.
	         *
	         * @return {Object} An object with encrypt and decrypt shortcut functions.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var AES = CryptoJS.lib.Cipher._createHelper(CryptoJS.algo.AES);
	         */ _createHelper: function() {
                function selectCipherStrategy(key) {
                    if (typeof key == "string") return PasswordBasedCipher;
                    else return SerializableCipher;
                }
                return function(cipher) {
                    return {
                        encrypt: function(message, key, cfg) {
                            return selectCipherStrategy(key).encrypt(cipher, message, key, cfg);
                        },
                        decrypt: function(ciphertext, key, cfg) {
                            return selectCipherStrategy(key).decrypt(cipher, ciphertext, key, cfg);
                        }
                    };
                };
            }()
        });
        /**
	     * Abstract base stream cipher template.
	     *
	     * @property {number} blockSize The number of 32-bit words this cipher operates on. Default: 1 (32 bits)
	     */ var StreamCipher = C_lib.StreamCipher = Cipher.extend({
            _doFinalize: function() {
                // Process partial blocks
                var finalProcessedBlocks = this._process(true);
                return finalProcessedBlocks;
            },
            blockSize: 1
        });
        /**
	     * Mode namespace.
	     */ var C_mode = C.mode = {};
        /**
	     * Abstract base block cipher mode template.
	     */ var BlockCipherMode = C_lib.BlockCipherMode = Base.extend({
            /**
	         * Creates this mode for encryption.
	         *
	         * @param {Cipher} cipher A block cipher instance.
	         * @param {Array} iv The IV words.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var mode = CryptoJS.mode.CBC.createEncryptor(cipher, iv.words);
	         */ createEncryptor: function(cipher, iv) {
                return this.Encryptor.create(cipher, iv);
            },
            /**
	         * Creates this mode for decryption.
	         *
	         * @param {Cipher} cipher A block cipher instance.
	         * @param {Array} iv The IV words.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var mode = CryptoJS.mode.CBC.createDecryptor(cipher, iv.words);
	         */ createDecryptor: function(cipher, iv) {
                return this.Decryptor.create(cipher, iv);
            },
            /**
	         * Initializes a newly created mode.
	         *
	         * @param {Cipher} cipher A block cipher instance.
	         * @param {Array} iv The IV words.
	         *
	         * @example
	         *
	         *     var mode = CryptoJS.mode.CBC.Encryptor.create(cipher, iv.words);
	         */ init: function(cipher, iv) {
                this._cipher = cipher;
                this._iv = iv;
            }
        });
        /**
	     * Cipher Block Chaining mode.
	     */ var CBC = C_mode.CBC = function() {
            /**
	         * Abstract base CBC mode.
	         */ var CBC = BlockCipherMode.extend();
            /**
	         * CBC encryptor.
	         */ CBC.Encryptor = CBC.extend({
                /**
	             * Processes the data block at offset.
	             *
	             * @param {Array} words The data words to operate on.
	             * @param {number} offset The offset where the block starts.
	             *
	             * @example
	             *
	             *     mode.processBlock(data.words, offset);
	             */ processBlock: function(words, offset) {
                    // Shortcuts
                    var cipher = this._cipher;
                    var blockSize = cipher.blockSize;
                    // XOR and encrypt
                    xorBlock.call(this, words, offset, blockSize);
                    cipher.encryptBlock(words, offset);
                    // Remember this block to use with next block
                    this._prevBlock = words.slice(offset, offset + blockSize);
                }
            });
            /**
	         * CBC decryptor.
	         */ CBC.Decryptor = CBC.extend({
                /**
	             * Processes the data block at offset.
	             *
	             * @param {Array} words The data words to operate on.
	             * @param {number} offset The offset where the block starts.
	             *
	             * @example
	             *
	             *     mode.processBlock(data.words, offset);
	             */ processBlock: function(words, offset) {
                    // Shortcuts
                    var cipher = this._cipher;
                    var blockSize = cipher.blockSize;
                    // Remember this block to use with next block
                    var thisBlock = words.slice(offset, offset + blockSize);
                    // Decrypt and XOR
                    cipher.decryptBlock(words, offset);
                    xorBlock.call(this, words, offset, blockSize);
                    // This block becomes the previous block
                    this._prevBlock = thisBlock;
                }
            });
            function xorBlock(words, offset, blockSize) {
                // Shortcut
                var iv = this._iv;
                // Choose mixing block
                if (iv) {
                    var block = iv;
                    // Remove IV for subsequent blocks
                    this._iv = undefined;
                } else var block = this._prevBlock;
                // XOR blocks
                for(var i = 0; i < blockSize; i++)words[offset + i] ^= block[i];
            }
            return CBC;
        }();
        /**
	     * Padding namespace.
	     */ var C_pad = C.pad = {};
        /**
	     * PKCS #5/7 padding strategy.
	     */ var Pkcs7 = C_pad.Pkcs7 = {
            /**
	         * Pads data using the algorithm defined in PKCS #5/7.
	         *
	         * @param {WordArray} data The data to pad.
	         * @param {number} blockSize The multiple that the data should be padded to.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     CryptoJS.pad.Pkcs7.pad(wordArray, 4);
	         */ pad: function(data, blockSize) {
                // Shortcut
                var blockSizeBytes = blockSize * 4;
                // Count padding bytes
                var nPaddingBytes = blockSizeBytes - data.sigBytes % blockSizeBytes;
                // Create padding word
                var paddingWord = nPaddingBytes << 24 | nPaddingBytes << 16 | nPaddingBytes << 8 | nPaddingBytes;
                // Create padding
                var paddingWords = [];
                for(var i = 0; i < nPaddingBytes; i += 4)paddingWords.push(paddingWord);
                var padding = WordArray.create(paddingWords, nPaddingBytes);
                // Add padding
                data.concat(padding);
            },
            /**
	         * Unpads data that had been padded using the algorithm defined in PKCS #5/7.
	         *
	         * @param {WordArray} data The data to unpad.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     CryptoJS.pad.Pkcs7.unpad(wordArray);
	         */ unpad: function(data) {
                // Get number of padding bytes from last byte
                var nPaddingBytes = data.words[data.sigBytes - 1 >>> 2] & 0xff;
                // Remove padding
                data.sigBytes -= nPaddingBytes;
            }
        };
        /**
	     * Abstract base block cipher template.
	     *
	     * @property {number} blockSize The number of 32-bit words this cipher operates on. Default: 4 (128 bits)
	     */ var BlockCipher = C_lib.BlockCipher = Cipher.extend({
            /**
	         * Configuration options.
	         *
	         * @property {Mode} mode The block mode to use. Default: CBC
	         * @property {Padding} padding The padding strategy to use. Default: Pkcs7
	         */ cfg: Cipher.cfg.extend({
                mode: CBC,
                padding: Pkcs7
            }),
            reset: function() {
                // Reset cipher
                Cipher.reset.call(this);
                // Shortcuts
                var cfg = this.cfg;
                var iv = cfg.iv;
                var mode = cfg.mode;
                // Reset block mode
                if (this._xformMode == this._ENC_XFORM_MODE) var modeCreator = mode.createEncryptor;
                else /* if (this._xformMode == this._DEC_XFORM_MODE) */ {
                    var modeCreator = mode.createDecryptor;
                    // Keep at least one block in the buffer for unpadding
                    this._minBufferSize = 1;
                }
                if (this._mode && this._mode.__creator == modeCreator) this._mode.init(this, iv && iv.words);
                else {
                    this._mode = modeCreator.call(mode, this, iv && iv.words);
                    this._mode.__creator = modeCreator;
                }
            },
            _doProcessBlock: function(words, offset) {
                this._mode.processBlock(words, offset);
            },
            _doFinalize: function() {
                // Shortcut
                var padding = this.cfg.padding;
                // Finalize
                if (this._xformMode == this._ENC_XFORM_MODE) {
                    // Pad data
                    padding.pad(this._data, this.blockSize);
                    // Process final blocks
                    var finalProcessedBlocks = this._process(true);
                } else /* if (this._xformMode == this._DEC_XFORM_MODE) */ {
                    // Process final blocks
                    var finalProcessedBlocks = this._process(true);
                    // Unpad data
                    padding.unpad(finalProcessedBlocks);
                }
                return finalProcessedBlocks;
            },
            blockSize: 4
        });
        /**
	     * A collection of cipher parameters.
	     *
	     * @property {WordArray} ciphertext The raw ciphertext.
	     * @property {WordArray} key The key to this ciphertext.
	     * @property {WordArray} iv The IV used in the ciphering operation.
	     * @property {WordArray} salt The salt used with a key derivation function.
	     * @property {Cipher} algorithm The cipher algorithm.
	     * @property {Mode} mode The block mode used in the ciphering operation.
	     * @property {Padding} padding The padding scheme used in the ciphering operation.
	     * @property {number} blockSize The block size of the cipher.
	     * @property {Format} formatter The default formatting strategy to convert this cipher params object to a string.
	     */ var CipherParams = C_lib.CipherParams = Base.extend({
            /**
	         * Initializes a newly created cipher params object.
	         *
	         * @param {Object} cipherParams An object with any of the possible cipher parameters.
	         *
	         * @example
	         *
	         *     var cipherParams = CryptoJS.lib.CipherParams.create({
	         *         ciphertext: ciphertextWordArray,
	         *         key: keyWordArray,
	         *         iv: ivWordArray,
	         *         salt: saltWordArray,
	         *         algorithm: CryptoJS.algo.AES,
	         *         mode: CryptoJS.mode.CBC,
	         *         padding: CryptoJS.pad.PKCS7,
	         *         blockSize: 4,
	         *         formatter: CryptoJS.format.OpenSSL
	         *     });
	         */ init: function(cipherParams) {
                this.mixIn(cipherParams);
            },
            /**
	         * Converts this cipher params object to a string.
	         *
	         * @param {Format} formatter (Optional) The formatting strategy to use.
	         *
	         * @return {string} The stringified cipher params.
	         *
	         * @throws Error If neither the formatter nor the default formatter is set.
	         *
	         * @example
	         *
	         *     var string = cipherParams + '';
	         *     var string = cipherParams.toString();
	         *     var string = cipherParams.toString(CryptoJS.format.OpenSSL);
	         */ toString: function(formatter) {
                return (formatter || this.formatter).stringify(this);
            }
        });
        /**
	     * Format namespace.
	     */ var C_format = C.format = {};
        /**
	     * OpenSSL formatting strategy.
	     */ var OpenSSLFormatter = C_format.OpenSSL = {
            /**
	         * Converts a cipher params object to an OpenSSL-compatible string.
	         *
	         * @param {CipherParams} cipherParams The cipher params object.
	         *
	         * @return {string} The OpenSSL-compatible string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var openSSLString = CryptoJS.format.OpenSSL.stringify(cipherParams);
	         */ stringify: function(cipherParams) {
                // Shortcuts
                var ciphertext = cipherParams.ciphertext;
                var salt = cipherParams.salt;
                // Format
                if (salt) var wordArray = WordArray.create([
                    0x53616c74,
                    0x65645f5f
                ]).concat(salt).concat(ciphertext);
                else var wordArray = ciphertext;
                return wordArray.toString(Base64);
            },
            /**
	         * Converts an OpenSSL-compatible string to a cipher params object.
	         *
	         * @param {string} openSSLStr The OpenSSL-compatible string.
	         *
	         * @return {CipherParams} The cipher params object.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var cipherParams = CryptoJS.format.OpenSSL.parse(openSSLString);
	         */ parse: function(openSSLStr) {
                // Parse base64
                var ciphertext = Base64.parse(openSSLStr);
                // Shortcut
                var ciphertextWords = ciphertext.words;
                // Test for salt
                if (ciphertextWords[0] == 0x53616c74 && ciphertextWords[1] == 0x65645f5f) {
                    // Extract salt
                    var salt = WordArray.create(ciphertextWords.slice(2, 4));
                    // Remove salt from ciphertext
                    ciphertextWords.splice(0, 4);
                    ciphertext.sigBytes -= 16;
                }
                return CipherParams.create({
                    ciphertext: ciphertext,
                    salt: salt
                });
            }
        };
        /**
	     * A cipher wrapper that returns ciphertext as a serializable cipher params object.
	     */ var SerializableCipher = C_lib.SerializableCipher = Base.extend({
            /**
	         * Configuration options.
	         *
	         * @property {Formatter} format The formatting strategy to convert cipher param objects to and from a string. Default: OpenSSL
	         */ cfg: Base.extend({
                format: OpenSSLFormatter
            }),
            /**
	         * Encrypts a message.
	         *
	         * @param {Cipher} cipher The cipher algorithm to use.
	         * @param {WordArray|string} message The message to encrypt.
	         * @param {WordArray} key The key.
	         * @param {Object} cfg (Optional) The configuration options to use for this operation.
	         *
	         * @return {CipherParams} A cipher params object.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var ciphertextParams = CryptoJS.lib.SerializableCipher.encrypt(CryptoJS.algo.AES, message, key);
	         *     var ciphertextParams = CryptoJS.lib.SerializableCipher.encrypt(CryptoJS.algo.AES, message, key, { iv: iv });
	         *     var ciphertextParams = CryptoJS.lib.SerializableCipher.encrypt(CryptoJS.algo.AES, message, key, { iv: iv, format: CryptoJS.format.OpenSSL });
	         */ encrypt: function(cipher, message, key, cfg) {
                // Apply config defaults
                cfg = this.cfg.extend(cfg);
                // Encrypt
                var encryptor = cipher.createEncryptor(key, cfg);
                var ciphertext = encryptor.finalize(message);
                // Shortcut
                var cipherCfg = encryptor.cfg;
                // Create and return serializable cipher params
                return CipherParams.create({
                    ciphertext: ciphertext,
                    key: key,
                    iv: cipherCfg.iv,
                    algorithm: cipher,
                    mode: cipherCfg.mode,
                    padding: cipherCfg.padding,
                    blockSize: cipher.blockSize,
                    formatter: cfg.format
                });
            },
            /**
	         * Decrypts serialized ciphertext.
	         *
	         * @param {Cipher} cipher The cipher algorithm to use.
	         * @param {CipherParams|string} ciphertext The ciphertext to decrypt.
	         * @param {WordArray} key The key.
	         * @param {Object} cfg (Optional) The configuration options to use for this operation.
	         *
	         * @return {WordArray} The plaintext.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var plaintext = CryptoJS.lib.SerializableCipher.decrypt(CryptoJS.algo.AES, formattedCiphertext, key, { iv: iv, format: CryptoJS.format.OpenSSL });
	         *     var plaintext = CryptoJS.lib.SerializableCipher.decrypt(CryptoJS.algo.AES, ciphertextParams, key, { iv: iv, format: CryptoJS.format.OpenSSL });
	         */ decrypt: function(cipher, ciphertext, key, cfg) {
                // Apply config defaults
                cfg = this.cfg.extend(cfg);
                // Convert string to CipherParams
                ciphertext = this._parse(ciphertext, cfg.format);
                // Decrypt
                var plaintext = cipher.createDecryptor(key, cfg).finalize(ciphertext.ciphertext);
                return plaintext;
            },
            /**
	         * Converts serialized ciphertext to CipherParams,
	         * else assumed CipherParams already and returns ciphertext unchanged.
	         *
	         * @param {CipherParams|string} ciphertext The ciphertext.
	         * @param {Formatter} format The formatting strategy to use to parse serialized ciphertext.
	         *
	         * @return {CipherParams} The unserialized ciphertext.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var ciphertextParams = CryptoJS.lib.SerializableCipher._parse(ciphertextStringOrParams, format);
	         */ _parse: function(ciphertext, format) {
                if (typeof ciphertext == "string") return format.parse(ciphertext, this);
                else return ciphertext;
            }
        });
        /**
	     * Key derivation function namespace.
	     */ var C_kdf = C.kdf = {};
        /**
	     * OpenSSL key derivation function.
	     */ var OpenSSLKdf = C_kdf.OpenSSL = {
            /**
	         * Derives a key and IV from a password.
	         *
	         * @param {string} password The password to derive from.
	         * @param {number} keySize The size in words of the key to generate.
	         * @param {number} ivSize The size in words of the IV to generate.
	         * @param {WordArray|string} salt (Optional) A 64-bit salt to use. If omitted, a salt will be generated randomly.
	         *
	         * @return {CipherParams} A cipher params object with the key, IV, and salt.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var derivedParams = CryptoJS.kdf.OpenSSL.execute('Password', 256/32, 128/32);
	         *     var derivedParams = CryptoJS.kdf.OpenSSL.execute('Password', 256/32, 128/32, 'saltsalt');
	         */ execute: function(password, keySize, ivSize, salt) {
                // Generate random salt
                if (!salt) salt = WordArray.random(8);
                // Derive key and IV
                var key = EvpKDF.create({
                    keySize: keySize + ivSize
                }).compute(password, salt);
                // Separate key and IV
                var iv = WordArray.create(key.words.slice(keySize), ivSize * 4);
                key.sigBytes = keySize * 4;
                // Return params
                return CipherParams.create({
                    key: key,
                    iv: iv,
                    salt: salt
                });
            }
        };
        /**
	     * A serializable cipher wrapper that derives the key from a password,
	     * and returns ciphertext as a serializable cipher params object.
	     */ var PasswordBasedCipher = C_lib.PasswordBasedCipher = SerializableCipher.extend({
            /**
	         * Configuration options.
	         *
	         * @property {KDF} kdf The key derivation function to use to generate a key and IV from a password. Default: OpenSSL
	         */ cfg: SerializableCipher.cfg.extend({
                kdf: OpenSSLKdf
            }),
            /**
	         * Encrypts a message using a password.
	         *
	         * @param {Cipher} cipher The cipher algorithm to use.
	         * @param {WordArray|string} message The message to encrypt.
	         * @param {string} password The password.
	         * @param {Object} cfg (Optional) The configuration options to use for this operation.
	         *
	         * @return {CipherParams} A cipher params object.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var ciphertextParams = CryptoJS.lib.PasswordBasedCipher.encrypt(CryptoJS.algo.AES, message, 'password');
	         *     var ciphertextParams = CryptoJS.lib.PasswordBasedCipher.encrypt(CryptoJS.algo.AES, message, 'password', { format: CryptoJS.format.OpenSSL });
	         */ encrypt: function(cipher, message, password, cfg) {
                // Apply config defaults
                cfg = this.cfg.extend(cfg);
                // Derive key and other params
                var derivedParams = cfg.kdf.execute(password, cipher.keySize, cipher.ivSize);
                // Add IV to config
                cfg.iv = derivedParams.iv;
                // Encrypt
                var ciphertext = SerializableCipher.encrypt.call(this, cipher, message, derivedParams.key, cfg);
                // Mix in derived params
                ciphertext.mixIn(derivedParams);
                return ciphertext;
            },
            /**
	         * Decrypts serialized ciphertext using a password.
	         *
	         * @param {Cipher} cipher The cipher algorithm to use.
	         * @param {CipherParams|string} ciphertext The ciphertext to decrypt.
	         * @param {string} password The password.
	         * @param {Object} cfg (Optional) The configuration options to use for this operation.
	         *
	         * @return {WordArray} The plaintext.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var plaintext = CryptoJS.lib.PasswordBasedCipher.decrypt(CryptoJS.algo.AES, formattedCiphertext, 'password', { format: CryptoJS.format.OpenSSL });
	         *     var plaintext = CryptoJS.lib.PasswordBasedCipher.decrypt(CryptoJS.algo.AES, ciphertextParams, 'password', { format: CryptoJS.format.OpenSSL });
	         */ decrypt: function(cipher, ciphertext, password, cfg) {
                // Apply config defaults
                cfg = this.cfg.extend(cfg);
                // Convert string to CipherParams
                ciphertext = this._parse(ciphertext, cfg.format);
                // Derive key and other params
                var derivedParams = cfg.kdf.execute(password, cipher.keySize, cipher.ivSize, ciphertext.salt);
                // Add IV to config
                cfg.iv = derivedParams.iv;
                // Decrypt
                var plaintext = SerializableCipher.decrypt.call(this, cipher, ciphertext, derivedParams.key, cfg);
                return plaintext;
            }
        });
    }();
});

},{"cd9e7c148581f3f":"isPlo","a566ab64a571fabc":"8HKlY"}],"id1jR":[function(require,module,exports) {
(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory(require("2f52414e12ae6909"), require("1eb0a66f8f1f67cf"));
})(this, function(CryptoJS) {
    /**
	 * Cipher Feedback block mode.
	 */ CryptoJS.mode.CFB = function() {
        var CFB = CryptoJS.lib.BlockCipherMode.extend();
        CFB.Encryptor = CFB.extend({
            processBlock: function(words, offset) {
                // Shortcuts
                var cipher = this._cipher;
                var blockSize = cipher.blockSize;
                generateKeystreamAndEncrypt.call(this, words, offset, blockSize, cipher);
                // Remember this block to use with next block
                this._prevBlock = words.slice(offset, offset + blockSize);
            }
        });
        CFB.Decryptor = CFB.extend({
            processBlock: function(words, offset) {
                // Shortcuts
                var cipher = this._cipher;
                var blockSize = cipher.blockSize;
                // Remember this block to use with next block
                var thisBlock = words.slice(offset, offset + blockSize);
                generateKeystreamAndEncrypt.call(this, words, offset, blockSize, cipher);
                // This block becomes the previous block
                this._prevBlock = thisBlock;
            }
        });
        function generateKeystreamAndEncrypt(words, offset, blockSize, cipher) {
            // Shortcut
            var iv = this._iv;
            // Generate keystream
            if (iv) {
                var keystream = iv.slice(0);
                // Remove IV for subsequent blocks
                this._iv = undefined;
            } else var keystream = this._prevBlock;
            cipher.encryptBlock(keystream, 0);
            // Encrypt
            for(var i = 0; i < blockSize; i++)words[offset + i] ^= keystream[i];
        }
        return CFB;
    }();
    return CryptoJS.mode.CFB;
});

},{"2f52414e12ae6909":"isPlo","1eb0a66f8f1f67cf":"inDpW"}],"5A5s6":[function(require,module,exports) {
(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory(require("8279613429749f72"), require("6366f0a420ff853a"));
})(this, function(CryptoJS) {
    /**
	 * Counter block mode.
	 */ CryptoJS.mode.CTR = function() {
        var CTR = CryptoJS.lib.BlockCipherMode.extend();
        var Encryptor = CTR.Encryptor = CTR.extend({
            processBlock: function(words, offset) {
                // Shortcuts
                var cipher = this._cipher;
                var blockSize = cipher.blockSize;
                var iv = this._iv;
                var counter = this._counter;
                // Generate keystream
                if (iv) {
                    counter = this._counter = iv.slice(0);
                    // Remove IV for subsequent blocks
                    this._iv = undefined;
                }
                var keystream = counter.slice(0);
                cipher.encryptBlock(keystream, 0);
                // Increment counter
                counter[blockSize - 1] = counter[blockSize - 1] + 1 | 0;
                // Encrypt
                for(var i = 0; i < blockSize; i++)words[offset + i] ^= keystream[i];
            }
        });
        CTR.Decryptor = Encryptor;
        return CTR;
    }();
    return CryptoJS.mode.CTR;
});

},{"8279613429749f72":"isPlo","6366f0a420ff853a":"inDpW"}],"2eh9E":[function(require,module,exports) {
(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory(require("1da69dc95c930e7b"), require("3c652faf883d007a"));
})(this, function(CryptoJS) {
    /** @preserve
	 * Counter block mode compatible with  Dr Brian Gladman fileenc.c
	 * derived from CryptoJS.mode.CTR
	 * Jan Hruby jhruby.web@gmail.com
	 */ CryptoJS.mode.CTRGladman = function() {
        var CTRGladman = CryptoJS.lib.BlockCipherMode.extend();
        function incWord(word) {
            if ((word >> 24 & 0xff) === 0xff) {
                var b1 = word >> 16 & 0xff;
                var b2 = word >> 8 & 0xff;
                var b3 = word & 0xff;
                if (b1 === 0xff) {
                    b1 = 0;
                    if (b2 === 0xff) {
                        b2 = 0;
                        if (b3 === 0xff) b3 = 0;
                        else ++b3;
                    } else ++b2;
                } else ++b1;
                word = 0;
                word += b1 << 16;
                word += b2 << 8;
                word += b3;
            } else word += 16777216;
            return word;
        }
        function incCounter(counter) {
            if ((counter[0] = incWord(counter[0])) === 0) // encr_data in fileenc.c from  Dr Brian Gladman's counts only with DWORD j < 8
            counter[1] = incWord(counter[1]);
            return counter;
        }
        var Encryptor = CTRGladman.Encryptor = CTRGladman.extend({
            processBlock: function(words, offset) {
                // Shortcuts
                var cipher = this._cipher;
                var blockSize = cipher.blockSize;
                var iv = this._iv;
                var counter = this._counter;
                // Generate keystream
                if (iv) {
                    counter = this._counter = iv.slice(0);
                    // Remove IV for subsequent blocks
                    this._iv = undefined;
                }
                incCounter(counter);
                var keystream = counter.slice(0);
                cipher.encryptBlock(keystream, 0);
                // Encrypt
                for(var i = 0; i < blockSize; i++)words[offset + i] ^= keystream[i];
            }
        });
        CTRGladman.Decryptor = Encryptor;
        return CTRGladman;
    }();
    return CryptoJS.mode.CTRGladman;
});

},{"1da69dc95c930e7b":"isPlo","3c652faf883d007a":"inDpW"}],"8Twub":[function(require,module,exports) {
(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory(require("26be4bcd9270328c"), require("827fa2cf583dbf3f"));
})(this, function(CryptoJS) {
    /**
	 * Output Feedback block mode.
	 */ CryptoJS.mode.OFB = function() {
        var OFB = CryptoJS.lib.BlockCipherMode.extend();
        var Encryptor = OFB.Encryptor = OFB.extend({
            processBlock: function(words, offset) {
                // Shortcuts
                var cipher = this._cipher;
                var blockSize = cipher.blockSize;
                var iv = this._iv;
                var keystream = this._keystream;
                // Generate keystream
                if (iv) {
                    keystream = this._keystream = iv.slice(0);
                    // Remove IV for subsequent blocks
                    this._iv = undefined;
                }
                cipher.encryptBlock(keystream, 0);
                // Encrypt
                for(var i = 0; i < blockSize; i++)words[offset + i] ^= keystream[i];
            }
        });
        OFB.Decryptor = Encryptor;
        return OFB;
    }();
    return CryptoJS.mode.OFB;
});

},{"26be4bcd9270328c":"isPlo","827fa2cf583dbf3f":"inDpW"}],"4bAaW":[function(require,module,exports) {
(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory(require("4bb76acc2aaa6fdd"), require("f7fd8399632190ae"));
})(this, function(CryptoJS) {
    /**
	 * Electronic Codebook block mode.
	 */ CryptoJS.mode.ECB = function() {
        var ECB = CryptoJS.lib.BlockCipherMode.extend();
        ECB.Encryptor = ECB.extend({
            processBlock: function(words, offset) {
                this._cipher.encryptBlock(words, offset);
            }
        });
        ECB.Decryptor = ECB.extend({
            processBlock: function(words, offset) {
                this._cipher.decryptBlock(words, offset);
            }
        });
        return ECB;
    }();
    return CryptoJS.mode.ECB;
});

},{"4bb76acc2aaa6fdd":"isPlo","f7fd8399632190ae":"inDpW"}],"8CpOC":[function(require,module,exports) {
(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory(require("655f8cc9ca5eb2ce"), require("5c1782efee2c6874"));
})(this, function(CryptoJS) {
    /**
	 * ANSI X.923 padding strategy.
	 */ CryptoJS.pad.AnsiX923 = {
        pad: function(data, blockSize) {
            // Shortcuts
            var dataSigBytes = data.sigBytes;
            var blockSizeBytes = blockSize * 4;
            // Count padding bytes
            var nPaddingBytes = blockSizeBytes - dataSigBytes % blockSizeBytes;
            // Compute last byte position
            var lastBytePos = dataSigBytes + nPaddingBytes - 1;
            // Pad
            data.clamp();
            data.words[lastBytePos >>> 2] |= nPaddingBytes << 24 - lastBytePos % 4 * 8;
            data.sigBytes += nPaddingBytes;
        },
        unpad: function(data) {
            // Get number of padding bytes from last byte
            var nPaddingBytes = data.words[data.sigBytes - 1 >>> 2] & 0xff;
            // Remove padding
            data.sigBytes -= nPaddingBytes;
        }
    };
    return CryptoJS.pad.Ansix923;
});

},{"655f8cc9ca5eb2ce":"isPlo","5c1782efee2c6874":"inDpW"}],"aflvs":[function(require,module,exports) {
(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory(require("5c66ff56d234cbf"), require("fcb5c1ae9ec239c4"));
})(this, function(CryptoJS) {
    /**
	 * ISO 10126 padding strategy.
	 */ CryptoJS.pad.Iso10126 = {
        pad: function(data, blockSize) {
            // Shortcut
            var blockSizeBytes = blockSize * 4;
            // Count padding bytes
            var nPaddingBytes = blockSizeBytes - data.sigBytes % blockSizeBytes;
            // Pad
            data.concat(CryptoJS.lib.WordArray.random(nPaddingBytes - 1)).concat(CryptoJS.lib.WordArray.create([
                nPaddingBytes << 24
            ], 1));
        },
        unpad: function(data) {
            // Get number of padding bytes from last byte
            var nPaddingBytes = data.words[data.sigBytes - 1 >>> 2] & 0xff;
            // Remove padding
            data.sigBytes -= nPaddingBytes;
        }
    };
    return CryptoJS.pad.Iso10126;
});

},{"5c66ff56d234cbf":"isPlo","fcb5c1ae9ec239c4":"inDpW"}],"9tt4Q":[function(require,module,exports) {
(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory(require("44479225b8698d21"), require("ef25b57e3868eb7f"));
})(this, function(CryptoJS) {
    /**
	 * ISO/IEC 9797-1 Padding Method 2.
	 */ CryptoJS.pad.Iso97971 = {
        pad: function(data, blockSize) {
            // Add 0x80 byte
            data.concat(CryptoJS.lib.WordArray.create([
                0x80000000
            ], 1));
            // Zero pad the rest
            CryptoJS.pad.ZeroPadding.pad(data, blockSize);
        },
        unpad: function(data) {
            // Remove zero padding
            CryptoJS.pad.ZeroPadding.unpad(data);
            // Remove one more byte -- the 0x80 byte
            data.sigBytes--;
        }
    };
    return CryptoJS.pad.Iso97971;
});

},{"44479225b8698d21":"isPlo","ef25b57e3868eb7f":"inDpW"}],"3tegu":[function(require,module,exports) {
(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory(require("87af21168aa44acb"), require("133ca1805bb6433e"));
})(this, function(CryptoJS) {
    /**
	 * Zero padding strategy.
	 */ CryptoJS.pad.ZeroPadding = {
        pad: function(data, blockSize) {
            // Shortcut
            var blockSizeBytes = blockSize * 4;
            // Pad
            data.clamp();
            data.sigBytes += blockSizeBytes - (data.sigBytes % blockSizeBytes || blockSizeBytes);
        },
        unpad: function(data) {
            // Shortcut
            var dataWords = data.words;
            // Unpad
            var i = data.sigBytes - 1;
            while(!(dataWords[i >>> 2] >>> 24 - i % 4 * 8 & 0xff))i--;
            data.sigBytes = i + 1;
        }
    };
    return CryptoJS.pad.ZeroPadding;
});

},{"87af21168aa44acb":"isPlo","133ca1805bb6433e":"inDpW"}],"2HGq1":[function(require,module,exports) {
(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory(require("aa3c737d0aca3c8c"), require("48009bd77daa7164"));
})(this, function(CryptoJS) {
    /**
	 * A noop padding strategy.
	 */ CryptoJS.pad.NoPadding = {
        pad: function() {},
        unpad: function() {}
    };
    return CryptoJS.pad.NoPadding;
});

},{"aa3c737d0aca3c8c":"isPlo","48009bd77daa7164":"inDpW"}],"g96aD":[function(require,module,exports) {
(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory(require("21b80cefb2d8bce5"), require("edcb376f8d1cabe8"));
})(this, function(CryptoJS) {
    (function(undefined) {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var CipherParams = C_lib.CipherParams;
        var C_enc = C.enc;
        var Hex = C_enc.Hex;
        var C_format = C.format;
        var HexFormatter = C_format.Hex = {
            /**
	         * Converts the ciphertext of a cipher params object to a hexadecimally encoded string.
	         *
	         * @param {CipherParams} cipherParams The cipher params object.
	         *
	         * @return {string} The hexadecimally encoded string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var hexString = CryptoJS.format.Hex.stringify(cipherParams);
	         */ stringify: function(cipherParams) {
                return cipherParams.ciphertext.toString(Hex);
            },
            /**
	         * Converts a hexadecimally encoded ciphertext string to a cipher params object.
	         *
	         * @param {string} input The hexadecimally encoded string.
	         *
	         * @return {CipherParams} The cipher params object.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var cipherParams = CryptoJS.format.Hex.parse(hexString);
	         */ parse: function(input) {
                var ciphertext = Hex.parse(input);
                return CipherParams.create({
                    ciphertext: ciphertext
                });
            }
        };
    })();
    return CryptoJS.format.Hex;
});

},{"21b80cefb2d8bce5":"isPlo","edcb376f8d1cabe8":"inDpW"}],"afzf0":[function(require,module,exports) {
(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory(require("16bcadd944502d8b"), require("5d6f4d12778ce0e2"), require("50eb63fc72836bd1"), require("7dfc9b682a0ce247"), require("3a168c81f3f01a90"));
})(this, function(CryptoJS) {
    (function() {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var BlockCipher = C_lib.BlockCipher;
        var C_algo = C.algo;
        // Lookup tables
        var SBOX = [];
        var INV_SBOX = [];
        var SUB_MIX_0 = [];
        var SUB_MIX_1 = [];
        var SUB_MIX_2 = [];
        var SUB_MIX_3 = [];
        var INV_SUB_MIX_0 = [];
        var INV_SUB_MIX_1 = [];
        var INV_SUB_MIX_2 = [];
        var INV_SUB_MIX_3 = [];
        // Compute lookup tables
        (function() {
            // Compute double table
            var d = [];
            for(var i = 0; i < 256; i++)if (i < 128) d[i] = i << 1;
            else d[i] = i << 1 ^ 0x11b;
            // Walk GF(2^8)
            var x = 0;
            var xi = 0;
            for(var i = 0; i < 256; i++){
                // Compute sbox
                var sx = xi ^ xi << 1 ^ xi << 2 ^ xi << 3 ^ xi << 4;
                sx = sx >>> 8 ^ sx & 0xff ^ 0x63;
                SBOX[x] = sx;
                INV_SBOX[sx] = x;
                // Compute multiplication
                var x2 = d[x];
                var x4 = d[x2];
                var x8 = d[x4];
                // Compute sub bytes, mix columns tables
                var t = d[sx] * 0x101 ^ sx * 0x1010100;
                SUB_MIX_0[x] = t << 24 | t >>> 8;
                SUB_MIX_1[x] = t << 16 | t >>> 16;
                SUB_MIX_2[x] = t << 8 | t >>> 24;
                SUB_MIX_3[x] = t;
                // Compute inv sub bytes, inv mix columns tables
                var t = x8 * 0x1010101 ^ x4 * 0x10001 ^ x2 * 0x101 ^ x * 0x1010100;
                INV_SUB_MIX_0[sx] = t << 24 | t >>> 8;
                INV_SUB_MIX_1[sx] = t << 16 | t >>> 16;
                INV_SUB_MIX_2[sx] = t << 8 | t >>> 24;
                INV_SUB_MIX_3[sx] = t;
                // Compute next counter
                if (!x) x = xi = 1;
                else {
                    x = x2 ^ d[d[d[x8 ^ x2]]];
                    xi ^= d[d[xi]];
                }
            }
        })();
        // Precomputed Rcon lookup
        var RCON = [
            0x00,
            0x01,
            0x02,
            0x04,
            0x08,
            0x10,
            0x20,
            0x40,
            0x80,
            0x1b,
            0x36
        ];
        /**
	     * AES block cipher algorithm.
	     */ var AES = C_algo.AES = BlockCipher.extend({
            _doReset: function() {
                // Skip reset of nRounds has been set before and key did not change
                if (this._nRounds && this._keyPriorReset === this._key) return;
                // Shortcuts
                var key = this._keyPriorReset = this._key;
                var keyWords = key.words;
                var keySize = key.sigBytes / 4;
                // Compute number of rounds
                var nRounds = this._nRounds = keySize + 6;
                // Compute number of key schedule rows
                var ksRows = (nRounds + 1) * 4;
                // Compute key schedule
                var keySchedule = this._keySchedule = [];
                for(var ksRow = 0; ksRow < ksRows; ksRow++)if (ksRow < keySize) keySchedule[ksRow] = keyWords[ksRow];
                else {
                    var t = keySchedule[ksRow - 1];
                    if (!(ksRow % keySize)) {
                        // Rot word
                        t = t << 8 | t >>> 24;
                        // Sub word
                        t = SBOX[t >>> 24] << 24 | SBOX[t >>> 16 & 0xff] << 16 | SBOX[t >>> 8 & 0xff] << 8 | SBOX[t & 0xff];
                        // Mix Rcon
                        t ^= RCON[ksRow / keySize | 0] << 24;
                    } else if (keySize > 6 && ksRow % keySize == 4) // Sub word
                    t = SBOX[t >>> 24] << 24 | SBOX[t >>> 16 & 0xff] << 16 | SBOX[t >>> 8 & 0xff] << 8 | SBOX[t & 0xff];
                    keySchedule[ksRow] = keySchedule[ksRow - keySize] ^ t;
                }
                // Compute inv key schedule
                var invKeySchedule = this._invKeySchedule = [];
                for(var invKsRow = 0; invKsRow < ksRows; invKsRow++){
                    var ksRow = ksRows - invKsRow;
                    if (invKsRow % 4) var t = keySchedule[ksRow];
                    else var t = keySchedule[ksRow - 4];
                    if (invKsRow < 4 || ksRow <= 4) invKeySchedule[invKsRow] = t;
                    else invKeySchedule[invKsRow] = INV_SUB_MIX_0[SBOX[t >>> 24]] ^ INV_SUB_MIX_1[SBOX[t >>> 16 & 0xff]] ^ INV_SUB_MIX_2[SBOX[t >>> 8 & 0xff]] ^ INV_SUB_MIX_3[SBOX[t & 0xff]];
                }
            },
            encryptBlock: function(M, offset) {
                this._doCryptBlock(M, offset, this._keySchedule, SUB_MIX_0, SUB_MIX_1, SUB_MIX_2, SUB_MIX_3, SBOX);
            },
            decryptBlock: function(M, offset) {
                // Swap 2nd and 4th rows
                var t = M[offset + 1];
                M[offset + 1] = M[offset + 3];
                M[offset + 3] = t;
                this._doCryptBlock(M, offset, this._invKeySchedule, INV_SUB_MIX_0, INV_SUB_MIX_1, INV_SUB_MIX_2, INV_SUB_MIX_3, INV_SBOX);
                // Inv swap 2nd and 4th rows
                var t = M[offset + 1];
                M[offset + 1] = M[offset + 3];
                M[offset + 3] = t;
            },
            _doCryptBlock: function(M, offset, keySchedule, SUB_MIX_0, SUB_MIX_1, SUB_MIX_2, SUB_MIX_3, SBOX) {
                // Shortcut
                var nRounds = this._nRounds;
                // Get input, add round key
                var s0 = M[offset] ^ keySchedule[0];
                var s1 = M[offset + 1] ^ keySchedule[1];
                var s2 = M[offset + 2] ^ keySchedule[2];
                var s3 = M[offset + 3] ^ keySchedule[3];
                // Key schedule row counter
                var ksRow = 4;
                // Rounds
                for(var round = 1; round < nRounds; round++){
                    // Shift rows, sub bytes, mix columns, add round key
                    var t0 = SUB_MIX_0[s0 >>> 24] ^ SUB_MIX_1[s1 >>> 16 & 0xff] ^ SUB_MIX_2[s2 >>> 8 & 0xff] ^ SUB_MIX_3[s3 & 0xff] ^ keySchedule[ksRow++];
                    var t1 = SUB_MIX_0[s1 >>> 24] ^ SUB_MIX_1[s2 >>> 16 & 0xff] ^ SUB_MIX_2[s3 >>> 8 & 0xff] ^ SUB_MIX_3[s0 & 0xff] ^ keySchedule[ksRow++];
                    var t2 = SUB_MIX_0[s2 >>> 24] ^ SUB_MIX_1[s3 >>> 16 & 0xff] ^ SUB_MIX_2[s0 >>> 8 & 0xff] ^ SUB_MIX_3[s1 & 0xff] ^ keySchedule[ksRow++];
                    var t3 = SUB_MIX_0[s3 >>> 24] ^ SUB_MIX_1[s0 >>> 16 & 0xff] ^ SUB_MIX_2[s1 >>> 8 & 0xff] ^ SUB_MIX_3[s2 & 0xff] ^ keySchedule[ksRow++];
                    // Update state
                    s0 = t0;
                    s1 = t1;
                    s2 = t2;
                    s3 = t3;
                }
                // Shift rows, sub bytes, add round key
                var t0 = (SBOX[s0 >>> 24] << 24 | SBOX[s1 >>> 16 & 0xff] << 16 | SBOX[s2 >>> 8 & 0xff] << 8 | SBOX[s3 & 0xff]) ^ keySchedule[ksRow++];
                var t1 = (SBOX[s1 >>> 24] << 24 | SBOX[s2 >>> 16 & 0xff] << 16 | SBOX[s3 >>> 8 & 0xff] << 8 | SBOX[s0 & 0xff]) ^ keySchedule[ksRow++];
                var t2 = (SBOX[s2 >>> 24] << 24 | SBOX[s3 >>> 16 & 0xff] << 16 | SBOX[s0 >>> 8 & 0xff] << 8 | SBOX[s1 & 0xff]) ^ keySchedule[ksRow++];
                var t3 = (SBOX[s3 >>> 24] << 24 | SBOX[s0 >>> 16 & 0xff] << 16 | SBOX[s1 >>> 8 & 0xff] << 8 | SBOX[s2 & 0xff]) ^ keySchedule[ksRow++];
                // Set output
                M[offset] = t0;
                M[offset + 1] = t1;
                M[offset + 2] = t2;
                M[offset + 3] = t3;
            },
            keySize: 8
        });
        /**
	     * Shortcut functions to the cipher's object interface.
	     *
	     * @example
	     *
	     *     var ciphertext = CryptoJS.AES.encrypt(message, key, cfg);
	     *     var plaintext  = CryptoJS.AES.decrypt(ciphertext, key, cfg);
	     */ C.AES = BlockCipher._createHelper(AES);
    })();
    return CryptoJS.AES;
});

},{"16bcadd944502d8b":"isPlo","5d6f4d12778ce0e2":"7G9uR","50eb63fc72836bd1":"fzW7d","7dfc9b682a0ce247":"8HKlY","3a168c81f3f01a90":"inDpW"}],"izdbG":[function(require,module,exports) {
(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory(require("62629f7fb07c1dd7"), require("feb8e609cc5885ca"), require("6ec5b2354b411f51"), require("b62ab3b1c080ae4c"), require("baa70509b18bd19a"));
})(this, function(CryptoJS) {
    (function() {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var WordArray = C_lib.WordArray;
        var BlockCipher = C_lib.BlockCipher;
        var C_algo = C.algo;
        // Permuted Choice 1 constants
        var PC1 = [
            57,
            49,
            41,
            33,
            25,
            17,
            9,
            1,
            58,
            50,
            42,
            34,
            26,
            18,
            10,
            2,
            59,
            51,
            43,
            35,
            27,
            19,
            11,
            3,
            60,
            52,
            44,
            36,
            63,
            55,
            47,
            39,
            31,
            23,
            15,
            7,
            62,
            54,
            46,
            38,
            30,
            22,
            14,
            6,
            61,
            53,
            45,
            37,
            29,
            21,
            13,
            5,
            28,
            20,
            12,
            4
        ];
        // Permuted Choice 2 constants
        var PC2 = [
            14,
            17,
            11,
            24,
            1,
            5,
            3,
            28,
            15,
            6,
            21,
            10,
            23,
            19,
            12,
            4,
            26,
            8,
            16,
            7,
            27,
            20,
            13,
            2,
            41,
            52,
            31,
            37,
            47,
            55,
            30,
            40,
            51,
            45,
            33,
            48,
            44,
            49,
            39,
            56,
            34,
            53,
            46,
            42,
            50,
            36,
            29,
            32
        ];
        // Cumulative bit shift constants
        var BIT_SHIFTS = [
            1,
            2,
            4,
            6,
            8,
            10,
            12,
            14,
            15,
            17,
            19,
            21,
            23,
            25,
            27,
            28
        ];
        // SBOXes and round permutation constants
        var SBOX_P = [
            {
                0x0: 0x808200,
                0x10000000: 0x8000,
                0x20000000: 0x808002,
                0x30000000: 0x2,
                0x40000000: 0x200,
                0x50000000: 0x808202,
                0x60000000: 0x800202,
                0x70000000: 0x800000,
                0x80000000: 0x202,
                0x90000000: 0x800200,
                0xa0000000: 0x8200,
                0xb0000000: 0x808000,
                0xc0000000: 0x8002,
                0xd0000000: 0x800002,
                0xe0000000: 0x0,
                0xf0000000: 0x8202,
                0x8000000: 0x0,
                0x18000000: 0x808202,
                0x28000000: 0x8202,
                0x38000000: 0x8000,
                0x48000000: 0x808200,
                0x58000000: 0x200,
                0x68000000: 0x808002,
                0x78000000: 0x2,
                0x88000000: 0x800200,
                0x98000000: 0x8200,
                0xa8000000: 0x808000,
                0xb8000000: 0x800202,
                0xc8000000: 0x800002,
                0xd8000000: 0x8002,
                0xe8000000: 0x202,
                0xf8000000: 0x800000,
                0x1: 0x8000,
                0x10000001: 0x2,
                0x20000001: 0x808200,
                0x30000001: 0x800000,
                0x40000001: 0x808002,
                0x50000001: 0x8200,
                0x60000001: 0x200,
                0x70000001: 0x800202,
                0x80000001: 0x808202,
                0x90000001: 0x808000,
                0xa0000001: 0x800002,
                0xb0000001: 0x8202,
                0xc0000001: 0x202,
                0xd0000001: 0x800200,
                0xe0000001: 0x8002,
                0xf0000001: 0x0,
                0x8000001: 0x808202,
                0x18000001: 0x808000,
                0x28000001: 0x800000,
                0x38000001: 0x200,
                0x48000001: 0x8000,
                0x58000001: 0x800002,
                0x68000001: 0x2,
                0x78000001: 0x8202,
                0x88000001: 0x8002,
                0x98000001: 0x800202,
                0xa8000001: 0x202,
                0xb8000001: 0x808200,
                0xc8000001: 0x800200,
                0xd8000001: 0x0,
                0xe8000001: 0x8200,
                0xf8000001: 0x808002
            },
            {
                0x0: 0x40084010,
                0x1000000: 0x4000,
                0x2000000: 0x80000,
                0x3000000: 0x40080010,
                0x4000000: 0x40000010,
                0x5000000: 0x40084000,
                0x6000000: 0x40004000,
                0x7000000: 0x10,
                0x8000000: 0x84000,
                0x9000000: 0x40004010,
                0xa000000: 0x40000000,
                0xb000000: 0x84010,
                0xc000000: 0x80010,
                0xd000000: 0x0,
                0xe000000: 0x4010,
                0xf000000: 0x40080000,
                0x800000: 0x40004000,
                0x1800000: 0x84010,
                0x2800000: 0x10,
                0x3800000: 0x40004010,
                0x4800000: 0x40084010,
                0x5800000: 0x40000000,
                0x6800000: 0x80000,
                0x7800000: 0x40080010,
                0x8800000: 0x80010,
                0x9800000: 0x0,
                0xa800000: 0x4000,
                0xb800000: 0x40080000,
                0xc800000: 0x40000010,
                0xd800000: 0x84000,
                0xe800000: 0x40084000,
                0xf800000: 0x4010,
                0x10000000: 0x0,
                0x11000000: 0x40080010,
                0x12000000: 0x40004010,
                0x13000000: 0x40084000,
                0x14000000: 0x40080000,
                0x15000000: 0x10,
                0x16000000: 0x84010,
                0x17000000: 0x4000,
                0x18000000: 0x4010,
                0x19000000: 0x80000,
                0x1a000000: 0x80010,
                0x1b000000: 0x40000010,
                0x1c000000: 0x84000,
                0x1d000000: 0x40004000,
                0x1e000000: 0x40000000,
                0x1f000000: 0x40084010,
                0x10800000: 0x84010,
                0x11800000: 0x80000,
                0x12800000: 0x40080000,
                0x13800000: 0x4000,
                0x14800000: 0x40004000,
                0x15800000: 0x40084010,
                0x16800000: 0x10,
                0x17800000: 0x40000000,
                0x18800000: 0x40084000,
                0x19800000: 0x40000010,
                0x1a800000: 0x40004010,
                0x1b800000: 0x80010,
                0x1c800000: 0x0,
                0x1d800000: 0x4010,
                0x1e800000: 0x40080010,
                0x1f800000: 0x84000
            },
            {
                0x0: 0x104,
                0x100000: 0x0,
                0x200000: 0x4000100,
                0x300000: 0x10104,
                0x400000: 0x10004,
                0x500000: 0x4000004,
                0x600000: 0x4010104,
                0x700000: 0x4010000,
                0x800000: 0x4000000,
                0x900000: 0x4010100,
                0xa00000: 0x10100,
                0xb00000: 0x4010004,
                0xc00000: 0x4000104,
                0xd00000: 0x10000,
                0xe00000: 0x4,
                0xf00000: 0x100,
                0x80000: 0x4010100,
                0x180000: 0x4010004,
                0x280000: 0x0,
                0x380000: 0x4000100,
                0x480000: 0x4000004,
                0x580000: 0x10000,
                0x680000: 0x10004,
                0x780000: 0x104,
                0x880000: 0x4,
                0x980000: 0x100,
                0xa80000: 0x4010000,
                0xb80000: 0x10104,
                0xc80000: 0x10100,
                0xd80000: 0x4000104,
                0xe80000: 0x4010104,
                0xf80000: 0x4000000,
                0x1000000: 0x4010100,
                0x1100000: 0x10004,
                0x1200000: 0x10000,
                0x1300000: 0x4000100,
                0x1400000: 0x100,
                0x1500000: 0x4010104,
                0x1600000: 0x4000004,
                0x1700000: 0x0,
                0x1800000: 0x4000104,
                0x1900000: 0x4000000,
                0x1a00000: 0x4,
                0x1b00000: 0x10100,
                0x1c00000: 0x4010000,
                0x1d00000: 0x104,
                0x1e00000: 0x10104,
                0x1f00000: 0x4010004,
                0x1080000: 0x4000000,
                0x1180000: 0x104,
                0x1280000: 0x4010100,
                0x1380000: 0x0,
                0x1480000: 0x10004,
                0x1580000: 0x4000100,
                0x1680000: 0x100,
                0x1780000: 0x4010004,
                0x1880000: 0x10000,
                0x1980000: 0x4010104,
                0x1a80000: 0x10104,
                0x1b80000: 0x4000004,
                0x1c80000: 0x4000104,
                0x1d80000: 0x4010000,
                0x1e80000: 0x4,
                0x1f80000: 0x10100
            },
            {
                0x0: 0x80401000,
                0x10000: 0x80001040,
                0x20000: 0x401040,
                0x30000: 0x80400000,
                0x40000: 0x0,
                0x50000: 0x401000,
                0x60000: 0x80000040,
                0x70000: 0x400040,
                0x80000: 0x80000000,
                0x90000: 0x400000,
                0xa0000: 0x40,
                0xb0000: 0x80001000,
                0xc0000: 0x80400040,
                0xd0000: 0x1040,
                0xe0000: 0x1000,
                0xf0000: 0x80401040,
                0x8000: 0x80001040,
                0x18000: 0x40,
                0x28000: 0x80400040,
                0x38000: 0x80001000,
                0x48000: 0x401000,
                0x58000: 0x80401040,
                0x68000: 0x0,
                0x78000: 0x80400000,
                0x88000: 0x1000,
                0x98000: 0x80401000,
                0xa8000: 0x400000,
                0xb8000: 0x1040,
                0xc8000: 0x80000000,
                0xd8000: 0x400040,
                0xe8000: 0x401040,
                0xf8000: 0x80000040,
                0x100000: 0x400040,
                0x110000: 0x401000,
                0x120000: 0x80000040,
                0x130000: 0x0,
                0x140000: 0x1040,
                0x150000: 0x80400040,
                0x160000: 0x80401000,
                0x170000: 0x80001040,
                0x180000: 0x80401040,
                0x190000: 0x80000000,
                0x1a0000: 0x80400000,
                0x1b0000: 0x401040,
                0x1c0000: 0x80001000,
                0x1d0000: 0x400000,
                0x1e0000: 0x40,
                0x1f0000: 0x1000,
                0x108000: 0x80400000,
                0x118000: 0x80401040,
                0x128000: 0x0,
                0x138000: 0x401000,
                0x148000: 0x400040,
                0x158000: 0x80000000,
                0x168000: 0x80001040,
                0x178000: 0x40,
                0x188000: 0x80000040,
                0x198000: 0x1000,
                0x1a8000: 0x80001000,
                0x1b8000: 0x80400040,
                0x1c8000: 0x1040,
                0x1d8000: 0x80401000,
                0x1e8000: 0x400000,
                0x1f8000: 0x401040
            },
            {
                0x0: 0x80,
                0x1000: 0x1040000,
                0x2000: 0x40000,
                0x3000: 0x20000000,
                0x4000: 0x20040080,
                0x5000: 0x1000080,
                0x6000: 0x21000080,
                0x7000: 0x40080,
                0x8000: 0x1000000,
                0x9000: 0x20040000,
                0xa000: 0x20000080,
                0xb000: 0x21040080,
                0xc000: 0x21040000,
                0xd000: 0x0,
                0xe000: 0x1040080,
                0xf000: 0x21000000,
                0x800: 0x1040080,
                0x1800: 0x21000080,
                0x2800: 0x80,
                0x3800: 0x1040000,
                0x4800: 0x40000,
                0x5800: 0x20040080,
                0x6800: 0x21040000,
                0x7800: 0x20000000,
                0x8800: 0x20040000,
                0x9800: 0x0,
                0xa800: 0x21040080,
                0xb800: 0x1000080,
                0xc800: 0x20000080,
                0xd800: 0x21000000,
                0xe800: 0x1000000,
                0xf800: 0x40080,
                0x10000: 0x40000,
                0x11000: 0x80,
                0x12000: 0x20000000,
                0x13000: 0x21000080,
                0x14000: 0x1000080,
                0x15000: 0x21040000,
                0x16000: 0x20040080,
                0x17000: 0x1000000,
                0x18000: 0x21040080,
                0x19000: 0x21000000,
                0x1a000: 0x1040000,
                0x1b000: 0x20040000,
                0x1c000: 0x40080,
                0x1d000: 0x20000080,
                0x1e000: 0x0,
                0x1f000: 0x1040080,
                0x10800: 0x21000080,
                0x11800: 0x1000000,
                0x12800: 0x1040000,
                0x13800: 0x20040080,
                0x14800: 0x20000000,
                0x15800: 0x1040080,
                0x16800: 0x80,
                0x17800: 0x21040000,
                0x18800: 0x40080,
                0x19800: 0x21040080,
                0x1a800: 0x0,
                0x1b800: 0x21000000,
                0x1c800: 0x1000080,
                0x1d800: 0x40000,
                0x1e800: 0x20040000,
                0x1f800: 0x20000080
            },
            {
                0x0: 0x10000008,
                0x100: 0x2000,
                0x200: 0x10200000,
                0x300: 0x10202008,
                0x400: 0x10002000,
                0x500: 0x200000,
                0x600: 0x200008,
                0x700: 0x10000000,
                0x800: 0x0,
                0x900: 0x10002008,
                0xa00: 0x202000,
                0xb00: 0x8,
                0xc00: 0x10200008,
                0xd00: 0x202008,
                0xe00: 0x2008,
                0xf00: 0x10202000,
                0x80: 0x10200000,
                0x180: 0x10202008,
                0x280: 0x8,
                0x380: 0x200000,
                0x480: 0x202008,
                0x580: 0x10000008,
                0x680: 0x10002000,
                0x780: 0x2008,
                0x880: 0x200008,
                0x980: 0x2000,
                0xa80: 0x10002008,
                0xb80: 0x10200008,
                0xc80: 0x0,
                0xd80: 0x10202000,
                0xe80: 0x202000,
                0xf80: 0x10000000,
                0x1000: 0x10002000,
                0x1100: 0x10200008,
                0x1200: 0x10202008,
                0x1300: 0x2008,
                0x1400: 0x200000,
                0x1500: 0x10000000,
                0x1600: 0x10000008,
                0x1700: 0x202000,
                0x1800: 0x202008,
                0x1900: 0x0,
                0x1a00: 0x8,
                0x1b00: 0x10200000,
                0x1c00: 0x2000,
                0x1d00: 0x10002008,
                0x1e00: 0x10202000,
                0x1f00: 0x200008,
                0x1080: 0x8,
                0x1180: 0x202000,
                0x1280: 0x200000,
                0x1380: 0x10000008,
                0x1480: 0x10002000,
                0x1580: 0x2008,
                0x1680: 0x10202008,
                0x1780: 0x10200000,
                0x1880: 0x10202000,
                0x1980: 0x10200008,
                0x1a80: 0x2000,
                0x1b80: 0x202008,
                0x1c80: 0x200008,
                0x1d80: 0x0,
                0x1e80: 0x10000000,
                0x1f80: 0x10002008
            },
            {
                0x0: 0x100000,
                0x10: 0x2000401,
                0x20: 0x400,
                0x30: 0x100401,
                0x40: 0x2100401,
                0x50: 0x0,
                0x60: 0x1,
                0x70: 0x2100001,
                0x80: 0x2000400,
                0x90: 0x100001,
                0xa0: 0x2000001,
                0xb0: 0x2100400,
                0xc0: 0x2100000,
                0xd0: 0x401,
                0xe0: 0x100400,
                0xf0: 0x2000000,
                0x8: 0x2100001,
                0x18: 0x0,
                0x28: 0x2000401,
                0x38: 0x2100400,
                0x48: 0x100000,
                0x58: 0x2000001,
                0x68: 0x2000000,
                0x78: 0x401,
                0x88: 0x100401,
                0x98: 0x2000400,
                0xa8: 0x2100000,
                0xb8: 0x100001,
                0xc8: 0x400,
                0xd8: 0x2100401,
                0xe8: 0x1,
                0xf8: 0x100400,
                0x100: 0x2000000,
                0x110: 0x100000,
                0x120: 0x2000401,
                0x130: 0x2100001,
                0x140: 0x100001,
                0x150: 0x2000400,
                0x160: 0x2100400,
                0x170: 0x100401,
                0x180: 0x401,
                0x190: 0x2100401,
                0x1a0: 0x100400,
                0x1b0: 0x1,
                0x1c0: 0x0,
                0x1d0: 0x2100000,
                0x1e0: 0x2000001,
                0x1f0: 0x400,
                0x108: 0x100400,
                0x118: 0x2000401,
                0x128: 0x2100001,
                0x138: 0x1,
                0x148: 0x2000000,
                0x158: 0x100000,
                0x168: 0x401,
                0x178: 0x2100400,
                0x188: 0x2000001,
                0x198: 0x2100000,
                0x1a8: 0x0,
                0x1b8: 0x2100401,
                0x1c8: 0x100401,
                0x1d8: 0x400,
                0x1e8: 0x2000400,
                0x1f8: 0x100001
            },
            {
                0x0: 0x8000820,
                0x1: 0x20000,
                0x2: 0x8000000,
                0x3: 0x20,
                0x4: 0x20020,
                0x5: 0x8020820,
                0x6: 0x8020800,
                0x7: 0x800,
                0x8: 0x8020000,
                0x9: 0x8000800,
                0xa: 0x20800,
                0xb: 0x8020020,
                0xc: 0x820,
                0xd: 0x0,
                0xe: 0x8000020,
                0xf: 0x20820,
                0x80000000: 0x800,
                0x80000001: 0x8020820,
                0x80000002: 0x8000820,
                0x80000003: 0x8000000,
                0x80000004: 0x8020000,
                0x80000005: 0x20800,
                0x80000006: 0x20820,
                0x80000007: 0x20,
                0x80000008: 0x8000020,
                0x80000009: 0x820,
                0x8000000a: 0x20020,
                0x8000000b: 0x8020800,
                0x8000000c: 0x0,
                0x8000000d: 0x8020020,
                0x8000000e: 0x8000800,
                0x8000000f: 0x20000,
                0x10: 0x20820,
                0x11: 0x8020800,
                0x12: 0x20,
                0x13: 0x800,
                0x14: 0x8000800,
                0x15: 0x8000020,
                0x16: 0x8020020,
                0x17: 0x20000,
                0x18: 0x0,
                0x19: 0x20020,
                0x1a: 0x8020000,
                0x1b: 0x8000820,
                0x1c: 0x8020820,
                0x1d: 0x20800,
                0x1e: 0x820,
                0x1f: 0x8000000,
                0x80000010: 0x20000,
                0x80000011: 0x800,
                0x80000012: 0x8020020,
                0x80000013: 0x20820,
                0x80000014: 0x20,
                0x80000015: 0x8020000,
                0x80000016: 0x8000000,
                0x80000017: 0x8000820,
                0x80000018: 0x8020820,
                0x80000019: 0x8000020,
                0x8000001a: 0x8000800,
                0x8000001b: 0x0,
                0x8000001c: 0x20800,
                0x8000001d: 0x820,
                0x8000001e: 0x20020,
                0x8000001f: 0x8020800
            }
        ];
        // Masks that select the SBOX input
        var SBOX_MASK = [
            0xf8000001,
            0x1f800000,
            0x01f80000,
            0x001f8000,
            0x0001f800,
            0x00001f80,
            0x000001f8,
            0x8000001f
        ];
        /**
	     * DES block cipher algorithm.
	     */ var DES = C_algo.DES = BlockCipher.extend({
            _doReset: function() {
                // Shortcuts
                var key = this._key;
                var keyWords = key.words;
                // Select 56 bits according to PC1
                var keyBits = [];
                for(var i = 0; i < 56; i++){
                    var keyBitPos = PC1[i] - 1;
                    keyBits[i] = keyWords[keyBitPos >>> 5] >>> 31 - keyBitPos % 32 & 1;
                }
                // Assemble 16 subkeys
                var subKeys = this._subKeys = [];
                for(var nSubKey = 0; nSubKey < 16; nSubKey++){
                    // Create subkey
                    var subKey = subKeys[nSubKey] = [];
                    // Shortcut
                    var bitShift = BIT_SHIFTS[nSubKey];
                    // Select 48 bits according to PC2
                    for(var i = 0; i < 24; i++){
                        // Select from the left 28 key bits
                        subKey[i / 6 | 0] |= keyBits[(PC2[i] - 1 + bitShift) % 28] << 31 - i % 6;
                        // Select from the right 28 key bits
                        subKey[4 + (i / 6 | 0)] |= keyBits[28 + (PC2[i + 24] - 1 + bitShift) % 28] << 31 - i % 6;
                    }
                    // Since each subkey is applied to an expanded 32-bit input,
                    // the subkey can be broken into 8 values scaled to 32-bits,
                    // which allows the key to be used without expansion
                    subKey[0] = subKey[0] << 1 | subKey[0] >>> 31;
                    for(var i = 1; i < 7; i++)subKey[i] = subKey[i] >>> (i - 1) * 4 + 3;
                    subKey[7] = subKey[7] << 5 | subKey[7] >>> 27;
                }
                // Compute inverse subkeys
                var invSubKeys = this._invSubKeys = [];
                for(var i = 0; i < 16; i++)invSubKeys[i] = subKeys[15 - i];
            },
            encryptBlock: function(M, offset) {
                this._doCryptBlock(M, offset, this._subKeys);
            },
            decryptBlock: function(M, offset) {
                this._doCryptBlock(M, offset, this._invSubKeys);
            },
            _doCryptBlock: function(M, offset, subKeys) {
                // Get input
                this._lBlock = M[offset];
                this._rBlock = M[offset + 1];
                // Initial permutation
                exchangeLR.call(this, 4, 0x0f0f0f0f);
                exchangeLR.call(this, 16, 0x0000ffff);
                exchangeRL.call(this, 2, 0x33333333);
                exchangeRL.call(this, 8, 0x00ff00ff);
                exchangeLR.call(this, 1, 0x55555555);
                // Rounds
                for(var round = 0; round < 16; round++){
                    // Shortcuts
                    var subKey = subKeys[round];
                    var lBlock = this._lBlock;
                    var rBlock = this._rBlock;
                    // Feistel function
                    var f = 0;
                    for(var i = 0; i < 8; i++)f |= SBOX_P[i][((rBlock ^ subKey[i]) & SBOX_MASK[i]) >>> 0];
                    this._lBlock = rBlock;
                    this._rBlock = lBlock ^ f;
                }
                // Undo swap from last round
                var t = this._lBlock;
                this._lBlock = this._rBlock;
                this._rBlock = t;
                // Final permutation
                exchangeLR.call(this, 1, 0x55555555);
                exchangeRL.call(this, 8, 0x00ff00ff);
                exchangeRL.call(this, 2, 0x33333333);
                exchangeLR.call(this, 16, 0x0000ffff);
                exchangeLR.call(this, 4, 0x0f0f0f0f);
                // Set output
                M[offset] = this._lBlock;
                M[offset + 1] = this._rBlock;
            },
            keySize: 2,
            ivSize: 2,
            blockSize: 2
        });
        // Swap bits across the left and right words
        function exchangeLR(offset, mask) {
            var t = (this._lBlock >>> offset ^ this._rBlock) & mask;
            this._rBlock ^= t;
            this._lBlock ^= t << offset;
        }
        function exchangeRL(offset, mask) {
            var t = (this._rBlock >>> offset ^ this._lBlock) & mask;
            this._lBlock ^= t;
            this._rBlock ^= t << offset;
        }
        /**
	     * Shortcut functions to the cipher's object interface.
	     *
	     * @example
	     *
	     *     var ciphertext = CryptoJS.DES.encrypt(message, key, cfg);
	     *     var plaintext  = CryptoJS.DES.decrypt(ciphertext, key, cfg);
	     */ C.DES = BlockCipher._createHelper(DES);
        /**
	     * Triple-DES block cipher algorithm.
	     */ var TripleDES = C_algo.TripleDES = BlockCipher.extend({
            _doReset: function() {
                // Shortcuts
                var key = this._key;
                var keyWords = key.words;
                // Create DES instances
                this._des1 = DES.createEncryptor(WordArray.create(keyWords.slice(0, 2)));
                this._des2 = DES.createEncryptor(WordArray.create(keyWords.slice(2, 4)));
                this._des3 = DES.createEncryptor(WordArray.create(keyWords.slice(4, 6)));
            },
            encryptBlock: function(M, offset) {
                this._des1.encryptBlock(M, offset);
                this._des2.decryptBlock(M, offset);
                this._des3.encryptBlock(M, offset);
            },
            decryptBlock: function(M, offset) {
                this._des3.decryptBlock(M, offset);
                this._des2.encryptBlock(M, offset);
                this._des1.decryptBlock(M, offset);
            },
            keySize: 6,
            ivSize: 2,
            blockSize: 2
        });
        /**
	     * Shortcut functions to the cipher's object interface.
	     *
	     * @example
	     *
	     *     var ciphertext = CryptoJS.TripleDES.encrypt(message, key, cfg);
	     *     var plaintext  = CryptoJS.TripleDES.decrypt(ciphertext, key, cfg);
	     */ C.TripleDES = BlockCipher._createHelper(TripleDES);
    })();
    return CryptoJS.TripleDES;
});

},{"62629f7fb07c1dd7":"isPlo","feb8e609cc5885ca":"7G9uR","6ec5b2354b411f51":"fzW7d","b62ab3b1c080ae4c":"8HKlY","baa70509b18bd19a":"inDpW"}],"33ZtO":[function(require,module,exports) {
(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory(require("5adebd8db4e1f724"), require("d5eba26e964b3fe3"), require("be6b5d0f312e7e5b"), require("900f02bdbb6a3882"), require("ff3bd2d58928df2c"));
})(this, function(CryptoJS) {
    (function() {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var StreamCipher = C_lib.StreamCipher;
        var C_algo = C.algo;
        /**
	     * RC4 stream cipher algorithm.
	     */ var RC4 = C_algo.RC4 = StreamCipher.extend({
            _doReset: function() {
                // Shortcuts
                var key = this._key;
                var keyWords = key.words;
                var keySigBytes = key.sigBytes;
                // Init sbox
                var S = this._S = [];
                for(var i = 0; i < 256; i++)S[i] = i;
                // Key setup
                for(var i = 0, j = 0; i < 256; i++){
                    var keyByteIndex = i % keySigBytes;
                    var keyByte = keyWords[keyByteIndex >>> 2] >>> 24 - keyByteIndex % 4 * 8 & 0xff;
                    j = (j + S[i] + keyByte) % 256;
                    // Swap
                    var t = S[i];
                    S[i] = S[j];
                    S[j] = t;
                }
                // Counters
                this._i = this._j = 0;
            },
            _doProcessBlock: function(M, offset) {
                M[offset] ^= generateKeystreamWord.call(this);
            },
            keySize: 8,
            ivSize: 0
        });
        function generateKeystreamWord() {
            // Shortcuts
            var S = this._S;
            var i = this._i;
            var j = this._j;
            // Generate keystream word
            var keystreamWord = 0;
            for(var n = 0; n < 4; n++){
                i = (i + 1) % 256;
                j = (j + S[i]) % 256;
                // Swap
                var t = S[i];
                S[i] = S[j];
                S[j] = t;
                keystreamWord |= S[(S[i] + S[j]) % 256] << 24 - n * 8;
            }
            // Update counters
            this._i = i;
            this._j = j;
            return keystreamWord;
        }
        /**
	     * Shortcut functions to the cipher's object interface.
	     *
	     * @example
	     *
	     *     var ciphertext = CryptoJS.RC4.encrypt(message, key, cfg);
	     *     var plaintext  = CryptoJS.RC4.decrypt(ciphertext, key, cfg);
	     */ C.RC4 = StreamCipher._createHelper(RC4);
        /**
	     * Modified RC4 stream cipher algorithm.
	     */ var RC4Drop = C_algo.RC4Drop = RC4.extend({
            /**
	         * Configuration options.
	         *
	         * @property {number} drop The number of keystream words to drop. Default 192
	         */ cfg: RC4.cfg.extend({
                drop: 192
            }),
            _doReset: function() {
                RC4._doReset.call(this);
                // Drop
                for(var i = this.cfg.drop; i > 0; i--)generateKeystreamWord.call(this);
            }
        });
        /**
	     * Shortcut functions to the cipher's object interface.
	     *
	     * @example
	     *
	     *     var ciphertext = CryptoJS.RC4Drop.encrypt(message, key, cfg);
	     *     var plaintext  = CryptoJS.RC4Drop.decrypt(ciphertext, key, cfg);
	     */ C.RC4Drop = StreamCipher._createHelper(RC4Drop);
    })();
    return CryptoJS.RC4;
});

},{"5adebd8db4e1f724":"isPlo","d5eba26e964b3fe3":"7G9uR","be6b5d0f312e7e5b":"fzW7d","900f02bdbb6a3882":"8HKlY","ff3bd2d58928df2c":"inDpW"}],"blsgg":[function(require,module,exports) {
(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory(require("dce97015fe9c299f"), require("543b66e1a17bbf5f"), require("2dee0f2a2cc0a874"), require("6b6c48cc5ac6eba4"), require("6297c11c0d21147a"));
})(this, function(CryptoJS) {
    (function() {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var StreamCipher = C_lib.StreamCipher;
        var C_algo = C.algo;
        // Reusable objects
        var S = [];
        var C_ = [];
        var G = [];
        /**
	     * Rabbit stream cipher algorithm
	     */ var Rabbit = C_algo.Rabbit = StreamCipher.extend({
            _doReset: function() {
                // Shortcuts
                var K = this._key.words;
                var iv = this.cfg.iv;
                // Swap endian
                for(var i = 0; i < 4; i++)K[i] = (K[i] << 8 | K[i] >>> 24) & 0x00ff00ff | (K[i] << 24 | K[i] >>> 8) & 0xff00ff00;
                // Generate initial state values
                var X = this._X = [
                    K[0],
                    K[3] << 16 | K[2] >>> 16,
                    K[1],
                    K[0] << 16 | K[3] >>> 16,
                    K[2],
                    K[1] << 16 | K[0] >>> 16,
                    K[3],
                    K[2] << 16 | K[1] >>> 16
                ];
                // Generate initial counter values
                var C = this._C = [
                    K[2] << 16 | K[2] >>> 16,
                    K[0] & 0xffff0000 | K[1] & 0x0000ffff,
                    K[3] << 16 | K[3] >>> 16,
                    K[1] & 0xffff0000 | K[2] & 0x0000ffff,
                    K[0] << 16 | K[0] >>> 16,
                    K[2] & 0xffff0000 | K[3] & 0x0000ffff,
                    K[1] << 16 | K[1] >>> 16,
                    K[3] & 0xffff0000 | K[0] & 0x0000ffff
                ];
                // Carry bit
                this._b = 0;
                // Iterate the system four times
                for(var i = 0; i < 4; i++)nextState.call(this);
                // Modify the counters
                for(var i = 0; i < 8; i++)C[i] ^= X[i + 4 & 7];
                // IV setup
                if (iv) {
                    // Shortcuts
                    var IV = iv.words;
                    var IV_0 = IV[0];
                    var IV_1 = IV[1];
                    // Generate four subvectors
                    var i0 = (IV_0 << 8 | IV_0 >>> 24) & 0x00ff00ff | (IV_0 << 24 | IV_0 >>> 8) & 0xff00ff00;
                    var i2 = (IV_1 << 8 | IV_1 >>> 24) & 0x00ff00ff | (IV_1 << 24 | IV_1 >>> 8) & 0xff00ff00;
                    var i1 = i0 >>> 16 | i2 & 0xffff0000;
                    var i3 = i2 << 16 | i0 & 0x0000ffff;
                    // Modify counter values
                    C[0] ^= i0;
                    C[1] ^= i1;
                    C[2] ^= i2;
                    C[3] ^= i3;
                    C[4] ^= i0;
                    C[5] ^= i1;
                    C[6] ^= i2;
                    C[7] ^= i3;
                    // Iterate the system four times
                    for(var i = 0; i < 4; i++)nextState.call(this);
                }
            },
            _doProcessBlock: function(M, offset) {
                // Shortcut
                var X = this._X;
                // Iterate the system
                nextState.call(this);
                // Generate four keystream words
                S[0] = X[0] ^ X[5] >>> 16 ^ X[3] << 16;
                S[1] = X[2] ^ X[7] >>> 16 ^ X[5] << 16;
                S[2] = X[4] ^ X[1] >>> 16 ^ X[7] << 16;
                S[3] = X[6] ^ X[3] >>> 16 ^ X[1] << 16;
                for(var i = 0; i < 4; i++){
                    // Swap endian
                    S[i] = (S[i] << 8 | S[i] >>> 24) & 0x00ff00ff | (S[i] << 24 | S[i] >>> 8) & 0xff00ff00;
                    // Encrypt
                    M[offset + i] ^= S[i];
                }
            },
            blockSize: 4,
            ivSize: 2
        });
        function nextState() {
            // Shortcuts
            var X = this._X;
            var C = this._C;
            // Save old counter values
            for(var i = 0; i < 8; i++)C_[i] = C[i];
            // Calculate new counter values
            C[0] = C[0] + 0x4d34d34d + this._b | 0;
            C[1] = C[1] + 0xd34d34d3 + (C[0] >>> 0 < C_[0] >>> 0 ? 1 : 0) | 0;
            C[2] = C[2] + 0x34d34d34 + (C[1] >>> 0 < C_[1] >>> 0 ? 1 : 0) | 0;
            C[3] = C[3] + 0x4d34d34d + (C[2] >>> 0 < C_[2] >>> 0 ? 1 : 0) | 0;
            C[4] = C[4] + 0xd34d34d3 + (C[3] >>> 0 < C_[3] >>> 0 ? 1 : 0) | 0;
            C[5] = C[5] + 0x34d34d34 + (C[4] >>> 0 < C_[4] >>> 0 ? 1 : 0) | 0;
            C[6] = C[6] + 0x4d34d34d + (C[5] >>> 0 < C_[5] >>> 0 ? 1 : 0) | 0;
            C[7] = C[7] + 0xd34d34d3 + (C[6] >>> 0 < C_[6] >>> 0 ? 1 : 0) | 0;
            this._b = C[7] >>> 0 < C_[7] >>> 0 ? 1 : 0;
            // Calculate the g-values
            for(var i = 0; i < 8; i++){
                var gx = X[i] + C[i];
                // Construct high and low argument for squaring
                var ga = gx & 0xffff;
                var gb = gx >>> 16;
                // Calculate high and low result of squaring
                var gh = ((ga * ga >>> 17) + ga * gb >>> 15) + gb * gb;
                var gl = ((gx & 0xffff0000) * gx | 0) + ((gx & 0x0000ffff) * gx | 0);
                // High XOR low
                G[i] = gh ^ gl;
            }
            // Calculate new state values
            X[0] = G[0] + (G[7] << 16 | G[7] >>> 16) + (G[6] << 16 | G[6] >>> 16) | 0;
            X[1] = G[1] + (G[0] << 8 | G[0] >>> 24) + G[7] | 0;
            X[2] = G[2] + (G[1] << 16 | G[1] >>> 16) + (G[0] << 16 | G[0] >>> 16) | 0;
            X[3] = G[3] + (G[2] << 8 | G[2] >>> 24) + G[1] | 0;
            X[4] = G[4] + (G[3] << 16 | G[3] >>> 16) + (G[2] << 16 | G[2] >>> 16) | 0;
            X[5] = G[5] + (G[4] << 8 | G[4] >>> 24) + G[3] | 0;
            X[6] = G[6] + (G[5] << 16 | G[5] >>> 16) + (G[4] << 16 | G[4] >>> 16) | 0;
            X[7] = G[7] + (G[6] << 8 | G[6] >>> 24) + G[5] | 0;
        }
        /**
	     * Shortcut functions to the cipher's object interface.
	     *
	     * @example
	     *
	     *     var ciphertext = CryptoJS.Rabbit.encrypt(message, key, cfg);
	     *     var plaintext  = CryptoJS.Rabbit.decrypt(ciphertext, key, cfg);
	     */ C.Rabbit = StreamCipher._createHelper(Rabbit);
    })();
    return CryptoJS.Rabbit;
});

},{"dce97015fe9c299f":"isPlo","543b66e1a17bbf5f":"7G9uR","2dee0f2a2cc0a874":"fzW7d","6b6c48cc5ac6eba4":"8HKlY","6297c11c0d21147a":"inDpW"}],"jBbSq":[function(require,module,exports) {
(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory(require("4b15b17a67843352"), require("5fb7ffe89dc864c6"), require("2203652551377e3e"), require("5b0030ff2473b4d4"), require("7a115a0bc4f30748"));
})(this, function(CryptoJS) {
    (function() {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var StreamCipher = C_lib.StreamCipher;
        var C_algo = C.algo;
        // Reusable objects
        var S = [];
        var C_ = [];
        var G = [];
        /**
	     * Rabbit stream cipher algorithm.
	     *
	     * This is a legacy version that neglected to convert the key to little-endian.
	     * This error doesn't affect the cipher's security,
	     * but it does affect its compatibility with other implementations.
	     */ var RabbitLegacy = C_algo.RabbitLegacy = StreamCipher.extend({
            _doReset: function() {
                // Shortcuts
                var K = this._key.words;
                var iv = this.cfg.iv;
                // Generate initial state values
                var X = this._X = [
                    K[0],
                    K[3] << 16 | K[2] >>> 16,
                    K[1],
                    K[0] << 16 | K[3] >>> 16,
                    K[2],
                    K[1] << 16 | K[0] >>> 16,
                    K[3],
                    K[2] << 16 | K[1] >>> 16
                ];
                // Generate initial counter values
                var C = this._C = [
                    K[2] << 16 | K[2] >>> 16,
                    K[0] & 0xffff0000 | K[1] & 0x0000ffff,
                    K[3] << 16 | K[3] >>> 16,
                    K[1] & 0xffff0000 | K[2] & 0x0000ffff,
                    K[0] << 16 | K[0] >>> 16,
                    K[2] & 0xffff0000 | K[3] & 0x0000ffff,
                    K[1] << 16 | K[1] >>> 16,
                    K[3] & 0xffff0000 | K[0] & 0x0000ffff
                ];
                // Carry bit
                this._b = 0;
                // Iterate the system four times
                for(var i = 0; i < 4; i++)nextState.call(this);
                // Modify the counters
                for(var i = 0; i < 8; i++)C[i] ^= X[i + 4 & 7];
                // IV setup
                if (iv) {
                    // Shortcuts
                    var IV = iv.words;
                    var IV_0 = IV[0];
                    var IV_1 = IV[1];
                    // Generate four subvectors
                    var i0 = (IV_0 << 8 | IV_0 >>> 24) & 0x00ff00ff | (IV_0 << 24 | IV_0 >>> 8) & 0xff00ff00;
                    var i2 = (IV_1 << 8 | IV_1 >>> 24) & 0x00ff00ff | (IV_1 << 24 | IV_1 >>> 8) & 0xff00ff00;
                    var i1 = i0 >>> 16 | i2 & 0xffff0000;
                    var i3 = i2 << 16 | i0 & 0x0000ffff;
                    // Modify counter values
                    C[0] ^= i0;
                    C[1] ^= i1;
                    C[2] ^= i2;
                    C[3] ^= i3;
                    C[4] ^= i0;
                    C[5] ^= i1;
                    C[6] ^= i2;
                    C[7] ^= i3;
                    // Iterate the system four times
                    for(var i = 0; i < 4; i++)nextState.call(this);
                }
            },
            _doProcessBlock: function(M, offset) {
                // Shortcut
                var X = this._X;
                // Iterate the system
                nextState.call(this);
                // Generate four keystream words
                S[0] = X[0] ^ X[5] >>> 16 ^ X[3] << 16;
                S[1] = X[2] ^ X[7] >>> 16 ^ X[5] << 16;
                S[2] = X[4] ^ X[1] >>> 16 ^ X[7] << 16;
                S[3] = X[6] ^ X[3] >>> 16 ^ X[1] << 16;
                for(var i = 0; i < 4; i++){
                    // Swap endian
                    S[i] = (S[i] << 8 | S[i] >>> 24) & 0x00ff00ff | (S[i] << 24 | S[i] >>> 8) & 0xff00ff00;
                    // Encrypt
                    M[offset + i] ^= S[i];
                }
            },
            blockSize: 4,
            ivSize: 2
        });
        function nextState() {
            // Shortcuts
            var X = this._X;
            var C = this._C;
            // Save old counter values
            for(var i = 0; i < 8; i++)C_[i] = C[i];
            // Calculate new counter values
            C[0] = C[0] + 0x4d34d34d + this._b | 0;
            C[1] = C[1] + 0xd34d34d3 + (C[0] >>> 0 < C_[0] >>> 0 ? 1 : 0) | 0;
            C[2] = C[2] + 0x34d34d34 + (C[1] >>> 0 < C_[1] >>> 0 ? 1 : 0) | 0;
            C[3] = C[3] + 0x4d34d34d + (C[2] >>> 0 < C_[2] >>> 0 ? 1 : 0) | 0;
            C[4] = C[4] + 0xd34d34d3 + (C[3] >>> 0 < C_[3] >>> 0 ? 1 : 0) | 0;
            C[5] = C[5] + 0x34d34d34 + (C[4] >>> 0 < C_[4] >>> 0 ? 1 : 0) | 0;
            C[6] = C[6] + 0x4d34d34d + (C[5] >>> 0 < C_[5] >>> 0 ? 1 : 0) | 0;
            C[7] = C[7] + 0xd34d34d3 + (C[6] >>> 0 < C_[6] >>> 0 ? 1 : 0) | 0;
            this._b = C[7] >>> 0 < C_[7] >>> 0 ? 1 : 0;
            // Calculate the g-values
            for(var i = 0; i < 8; i++){
                var gx = X[i] + C[i];
                // Construct high and low argument for squaring
                var ga = gx & 0xffff;
                var gb = gx >>> 16;
                // Calculate high and low result of squaring
                var gh = ((ga * ga >>> 17) + ga * gb >>> 15) + gb * gb;
                var gl = ((gx & 0xffff0000) * gx | 0) + ((gx & 0x0000ffff) * gx | 0);
                // High XOR low
                G[i] = gh ^ gl;
            }
            // Calculate new state values
            X[0] = G[0] + (G[7] << 16 | G[7] >>> 16) + (G[6] << 16 | G[6] >>> 16) | 0;
            X[1] = G[1] + (G[0] << 8 | G[0] >>> 24) + G[7] | 0;
            X[2] = G[2] + (G[1] << 16 | G[1] >>> 16) + (G[0] << 16 | G[0] >>> 16) | 0;
            X[3] = G[3] + (G[2] << 8 | G[2] >>> 24) + G[1] | 0;
            X[4] = G[4] + (G[3] << 16 | G[3] >>> 16) + (G[2] << 16 | G[2] >>> 16) | 0;
            X[5] = G[5] + (G[4] << 8 | G[4] >>> 24) + G[3] | 0;
            X[6] = G[6] + (G[5] << 16 | G[5] >>> 16) + (G[4] << 16 | G[4] >>> 16) | 0;
            X[7] = G[7] + (G[6] << 8 | G[6] >>> 24) + G[5] | 0;
        }
        /**
	     * Shortcut functions to the cipher's object interface.
	     *
	     * @example
	     *
	     *     var ciphertext = CryptoJS.RabbitLegacy.encrypt(message, key, cfg);
	     *     var plaintext  = CryptoJS.RabbitLegacy.decrypt(ciphertext, key, cfg);
	     */ C.RabbitLegacy = StreamCipher._createHelper(RabbitLegacy);
    })();
    return CryptoJS.RabbitLegacy;
});

},{"4b15b17a67843352":"isPlo","5fb7ffe89dc864c6":"7G9uR","2203652551377e3e":"fzW7d","5b0030ff2473b4d4":"8HKlY","7a115a0bc4f30748":"inDpW"}],"9dcOp":[function(require,module,exports) {
"use strict";
var __importDefault = this && this.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.MerkleMountainRange = void 0;
const buffer_1 = require("23893301ecda63c0");
const sha256_1 = __importDefault(require("8ecd94603d5ff4cf"));
const Base_1 = __importDefault(require("7b1d3eb80cde9efb"));
// @credit: https://github.com/wanseob/solidity-mmr
/**
 * @desc The index of this MMR implementation starts from 1 not 0.
 */ class MerkleMountainRange extends Base_1.default {
    constructor(hashFn = sha256_1.default, leaves = [], hashLeafFn, peakBaggingFn, hashBranchFn){
        super();
        this.root = buffer_1.Buffer.alloc(0);
        this.size = 0;
        this.width = 0;
        this.hashes = {};
        this.data = {};
        leaves = leaves.map(this.bufferify);
        this.hashFn = this.bufferifyFn(hashFn);
        this.hashLeafFn = hashLeafFn;
        this.peakBaggingFn = peakBaggingFn;
        this.hashBranchFn = hashBranchFn;
        for (const leaf of leaves)this.append(leaf);
    }
    /**
     * @desc This only stores the hashed value of the leaf.
     * If you need to retrieve the detail data later, use a map to store them.
     */ append(data) {
        data = this.bufferify(data);
        const dataHash = this.hashFn(data);
        const dataHashHex = this.bufferToHex(dataHash);
        if (!this.data[dataHashHex] || this.bufferToHex(this.hashFn(this.data[dataHashHex])) !== dataHashHex) this.data[dataHashHex] = data;
        const leaf = this.hashLeaf(this.size + 1, dataHash);
        this.hashes[this.size + 1] = leaf;
        this.width += 1;
        // find peaks for enlarged tree
        const peakIndexes = this.getPeakIndexes(this.width);
        // the right most peak's value is the new size of the updated tree
        this.size = this.getSize(this.width);
        // starting from the left-most peak, get all peak hashes
        const peaks = [];
        for(let i = 0; i < peakIndexes.length; i++)peaks[i] = this._getOrCreateNode(peakIndexes[i]);
        // update the tree root hash
        this.root = this.peakBagging(this.width, peaks);
    }
    /**
     * @desc It returns the hash of a leaf node with hash(M | DATA )
     *       M is the index of the node.
     */ hashLeaf(index, dataHash) {
        dataHash = this.bufferify(dataHash);
        if (this.hashLeafFn) return this.bufferify(this.hashLeafFn(index, dataHash));
        return this.hashFn(buffer_1.Buffer.concat([
            this.bufferify(index),
            dataHash
        ]));
    }
    /**
     * @desc It returns the hash a parent node with hash(M | Left child | Right child)
     *       M is the index of the node.
     */ hashBranch(index, left, right) {
        if (this.hashBranchFn) return this.bufferify(this.hashBranchFn(index, left, right));
        return this.hashFn(buffer_1.Buffer.concat([
            this.bufferify(index),
            this.bufferify(left),
            this.bufferify(right)
        ]));
    }
    getPeaks() {
        const peakIndexes = this.getPeakIndexes(this.width);
        const peaks = [];
        for(let i = 0; i < peakIndexes.length; i++)peaks[i] = this.hashes[peakIndexes[i]];
        return peaks;
    }
    getLeafIndex(width) {
        if (width % 2 === 1) return this.getSize(width);
        return this.getSize(width - 1) + 1;
    }
    /**
     * @desc It returns all peaks of the smallest merkle mountain range tree which includes
     *       the given index(size).
     */ getPeakIndexes(width) {
        const numPeaks = this.numOfPeaks(width);
        const peakIndexes = [];
        let count = 0;
        let size = 0;
        for(let i = 255; i > 0; i--)if ((width & 1 << i - 1) !== 0) {
            // peak exists
            size = size + (1 << i) - 1;
            peakIndexes[count++] = size;
            if (peakIndexes.length >= numPeaks) break;
        }
        if (count !== peakIndexes.length) throw new Error("invalid bit calculation");
        return peakIndexes;
    }
    numOfPeaks(width) {
        let bits = width;
        let num = 0;
        while(bits > 0){
            if (bits % 2 === 1) num++;
            bits = bits >> 1;
        }
        return num;
    }
    peakBagging(width, peaks) {
        const size = this.getSize(width);
        if (this.numOfPeaks(width) !== peaks.length) throw new Error("received invalid number of peaks");
        if (width === 0 && !peaks.length) return buffer_1.Buffer.alloc(0);
        if (this.peakBaggingFn) return this.bufferify(this.peakBaggingFn(size, peaks));
        return this.hashFn(buffer_1.Buffer.concat([
            this.bufferify(size),
            ...peaks.map(this.bufferify)
        ]));
    }
    /**
     * @desc It returns the size of the tree.
     */ getSize(width) {
        return (width << 1) - this.numOfPeaks(width);
    }
    /**
     * @desc It returns the root value of the tree.
     */ getRoot() {
        return this.root;
    }
    getHexRoot() {
        return this.bufferToHex(this.getRoot());
    }
    /**
     * @dev It returns the hash value of a node for the given position. Note that the index starts from 1.
     */ getNode(index) {
        return this.hashes[index];
    }
    /**
     * @desc It returns the height of the highest peak.
     */ mountainHeight(size) {
        let height = 1;
        while(1 << height <= size + height)height++;
        return height - 1;
    }
    /**
     * @desc It returns the height of the index.
     */ heightAt(index) {
        let reducedIndex = index;
        let peakIndex = 0;
        let height = 0;
        // if an index has a left mountain then subtract the mountain
        while(reducedIndex > peakIndex){
            reducedIndex -= (1 << height) - 1;
            height = this.mountainHeight(reducedIndex);
            peakIndex = (1 << height) - 1;
        }
        // index is on the right slope
        return height - (peakIndex - reducedIndex);
    }
    /**
     * @desc It returns whether the index is the leaf node or not
     */ isLeaf(index) {
        return this.heightAt(index) === 1;
    }
    /**
     * @desc It returns the children when it is a parent node.
     */ getChildren(index) {
        const left = index - (1 << this.heightAt(index) - 1);
        const right = index - 1;
        if (left === right) throw new Error("not a parent");
        return [
            left,
            right
        ];
    }
    /**
     * @desc It returns a merkle proof for a leaf. Note that the index starts from 1.
     */ getMerkleProof(index) {
        if (index > this.size) throw new Error("out of range");
        if (!this.isLeaf(index)) throw new Error("not a leaf");
        const root = this.root;
        const width = this.width;
        // find all peaks for bagging
        const peaks = this.getPeakIndexes(this.width);
        const peakBagging = [];
        let cursor = 0;
        for(let i = 0; i < peaks.length; i++){
            // collect the hash of all peaks
            peakBagging[i] = this.hashes[peaks[i]];
            // find the peak which includes the target index
            if (peaks[i] >= index && cursor === 0) cursor = peaks[i];
        }
        let left = 0;
        let right = 0;
        // get hashes of the siblings in the mountain which the index belgons to.
        // it moves the cursor from the summit of the mountain down to the target index
        let height = this.heightAt(cursor);
        const siblings = [];
        while(cursor !== index){
            height--;
            [left, right] = this.getChildren(cursor);
            // move the cursor down to the left size or right size
            cursor = index <= left ? left : right;
            // remaining node is the sibling
            siblings[height - 1] = this.hashes[index <= left ? right : left];
        }
        return {
            root,
            width,
            peakBagging,
            siblings
        };
    }
    /**
     * @desc It returns true when the given params verifies that the given value exists in the tree or reverts the transaction.
     */ verify(root, width, index, value, peaks, siblings) {
        value = this.bufferify(value);
        const size = this.getSize(width);
        if (size < index) throw new Error("index is out of range");
        // check the root equals the peak bagging hash
        if (!root.equals(this.peakBagging(width, peaks))) throw new Error("invalid root hash from the peaks");
        // find the mountain where the target index belongs to
        let cursor = 0;
        let targetPeak;
        const peakIndexes = this.getPeakIndexes(width);
        for(let i = 0; i < peakIndexes.length; i++)if (peakIndexes[i] >= index) {
            targetPeak = peaks[i];
            cursor = peakIndexes[i];
            break;
        }
        if (!targetPeak) throw new Error("target not found");
        // find the path climbing down
        let height = siblings.length + 1;
        const path = new Array(height);
        let left = 0;
        let right = 0;
        while(height > 0){
            // record the current cursor and climb down
            path[--height] = cursor;
            if (cursor === index) break;
            else {
                // on the parent node. Go left or right
                [left, right] = this.getChildren(cursor);
                cursor = index > left ? right : left;
                continue;
            }
        }
        // calculate the summit hash climbing up again
        let node;
        while(height < path.length){
            // move cursor
            cursor = path[height];
            if (height === 0) // cusor is on the leaf
            node = this.hashLeaf(cursor, this.hashFn(value));
            else if (cursor - 1 === path[height - 1]) // cursor is on a parent and a siblings is on the left
            node = this.hashBranch(cursor, siblings[height - 1], node);
            else // cursor is on a parent and a siblings is on the right
            node = this.hashBranch(cursor, node, siblings[height - 1]);
            // climb up
            height++;
        }
        // computed hash value of the summit should equal to the target peak hash
        if (!node.equals(targetPeak)) throw new Error("hashed peak is invalid");
        return true;
    }
    peaksToPeakMap(width, peaks) {
        const peakMap = {};
        let bitIndex = 0;
        let peakRef = 0;
        let count = peaks.length;
        for(let height = 1; height <= 32; height++){
            // index starts from the right most bit
            bitIndex = 32 - height;
            peakRef = 1 << height - 1;
            if ((width & peakRef) !== 0) peakMap[bitIndex] = peaks[--count];
            else peakMap[bitIndex] = 0;
        }
        if (count !== 0) throw new Error("invalid number of peaks");
        return peakMap;
    }
    peakMapToPeaks(width, peakMap) {
        const arrLength = this.numOfPeaks(width);
        const peaks = new Array(arrLength);
        let count = 0;
        for(let i = 0; i < 32; i++)if (peakMap[i] !== 0) peaks[count++] = peakMap[i];
        if (count !== arrLength) throw new Error("invalid number of peaks");
        return peaks;
    }
    peakUpdate(width, prevPeakMap, itemHash) {
        const nextPeakMap = {};
        const newWidth = width + 1;
        let cursorIndex = this.getLeafIndex(newWidth);
        let cursorNode = this.hashLeaf(cursorIndex, itemHash);
        let bitIndex = 0;
        let peakRef = 0;
        let prevPeakExist = false;
        let nextPeakExist = false;
        let obtained = false;
        for(let height = 1; height <= 32; height++){
            // index starts from the right most bit
            bitIndex = 32 - height;
            if (obtained) nextPeakMap[bitIndex] = prevPeakMap[bitIndex];
            else {
                peakRef = 1 << height - 1;
                prevPeakExist = (width & peakRef) !== 0;
                nextPeakExist = (newWidth & peakRef) !== 0;
                // get new cursor node with hashing the peak and the current cursor
                cursorIndex++;
                if (prevPeakExist) cursorNode = this.hashBranch(cursorIndex, prevPeakMap[bitIndex], cursorNode);
                // if new peak exists for the bit index
                if (nextPeakExist) {
                    // if prev peak exists for the bit index
                    if (prevPeakExist) nextPeakMap[bitIndex] = prevPeakMap[bitIndex];
                    else nextPeakMap[bitIndex] = cursorNode;
                    obtained = true;
                } else nextPeakMap[bitIndex] = 0;
            }
        }
        return nextPeakMap;
    }
    rollUp(root, width, peaks, itemHashes) {
        // check the root equals the peak bagging hash
        if (!root.equals(this.peakBagging(width, peaks))) throw new Error("invalid root hash from the peaks");
        let tmpWidth = width;
        let tmpPeakMap = this.peaksToPeakMap(width, peaks);
        for(let i = 0; i < itemHashes.length; i++){
            tmpPeakMap = this.peakUpdate(tmpWidth, tmpPeakMap, itemHashes[i]);
            tmpWidth++;
        }
        return this.peakBagging(tmpWidth, this.peakMapToPeaks(tmpWidth, tmpPeakMap));
    }
    /**
     * @desc It returns the hash value of the node for the index.
     *      If the hash already exists it simply returns the stored value. On the other hand,
     *      it computes hashes recursively downward.
     *      Only appending an item calls this function.
     */ _getOrCreateNode(index) {
        if (index > this.size) throw new Error("out of range");
        if (!this.hashes[index]) {
            const [leftIndex, rightIndex] = this.getChildren(index);
            const leftHash = this._getOrCreateNode(leftIndex);
            const rightHash = this._getOrCreateNode(rightIndex);
            this.hashes[index] = this.hashBranch(index, leftHash, rightHash);
        }
        return this.hashes[index];
    }
}
exports.MerkleMountainRange = MerkleMountainRange;
exports.default = MerkleMountainRange;

},{"23893301ecda63c0":"l5Twm","8ecd94603d5ff4cf":"geCX9","7b1d3eb80cde9efb":"8bIo2"}],"6266D":[function(require,module,exports) {
"use strict";
var __importDefault = this && this.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
const bn_js_1 = __importDefault(require("1de2e2d37b33cfd6"));
const buffer_1 = __importDefault(require("9c49b7968c284629"));
const keccak_1 = __importDefault(require("a43462d5d45a3448"));
const Buffer = buffer_1.default.Buffer;
function keccak256(value) {
    value = toBuffer(value);
    return (0, keccak_1.default)("keccak256").update(value).digest();
}
function toBuffer(value) {
    if (!Buffer.isBuffer(value)) {
        if (Array.isArray(value)) value = Buffer.from(value);
        else if (typeof value === "string") {
            if (isHexString(value)) value = Buffer.from(padToEven(stripHexPrefix(value)), "hex");
            else value = Buffer.from(value);
        } else if (typeof value === "number") value = intToBuffer(value);
        else if (value === null || value === undefined) value = Buffer.allocUnsafe(0);
        else if (bn_js_1.default.isBN(value)) value = value.toArrayLike(Buffer);
        else if (value.toArray) // converts a BN to a Buffer
        value = Buffer.from(value.toArray());
        else throw new Error("invalid type");
    }
    return value;
}
function isHexString(value, length) {
    if (typeof value !== "string" || !value.match(/^0x[0-9A-Fa-f]*$/)) return false;
    if (length && value.length !== 2 + 2 * length) return false;
    return true;
}
function padToEven(value) {
    if (typeof value !== "string") throw new Error(`while padding to even, value must be string, is currently ${typeof value}, while padToEven.`);
    if (value.length % 2) value = `0${value}`;
    return value;
}
function stripHexPrefix(value) {
    if (typeof value !== "string") return value;
    return isHexPrefixed(value) ? value.slice(2) : value;
}
function isHexPrefixed(value) {
    if (typeof value !== "string") throw new Error("value must be type 'string', is currently type " + typeof value + ", while checking isHexPrefixed.");
    return value.slice(0, 2) === "0x";
}
function intToBuffer(i) {
    const hex = intToHex(i);
    return Buffer.from(padToEven(hex.slice(2)), "hex");
}
function intToHex(i) {
    const hex = i.toString(16);
    return `0x${hex}`;
}
if (typeof window !== "undefined") window.keccak256 = keccak256;
module.exports = keccak256;

},{"1de2e2d37b33cfd6":"ggv4q","9c49b7968c284629":"l5Twm","a43462d5d45a3448":"a11wB"}],"ggv4q":[function(require,module,exports) {
(function(module1, exports) {
    "use strict";
    // Utils
    function assert(val, msg) {
        if (!val) throw new Error(msg || "Assertion failed");
    }
    // Could use `inherits` module, but don't want to move from single file
    // architecture yet.
    function inherits(ctor, superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
    // BN
    function BN(number, base, endian) {
        if (BN.isBN(number)) return number;
        this.negative = 0;
        this.words = null;
        this.length = 0;
        // Reduction context
        this.red = null;
        if (number !== null) {
            if (base === "le" || base === "be") {
                endian = base;
                base = 10;
            }
            this._init(number || 0, base || 10, endian || "be");
        }
    }
    if (typeof module1 === "object") module1.exports = BN;
    else exports.BN = BN;
    BN.BN = BN;
    BN.wordSize = 26;
    var Buffer;
    try {
        if (typeof window !== "undefined" && typeof window.Buffer !== "undefined") Buffer = window.Buffer;
        else Buffer = require("5dd7d237d1064e27").Buffer;
    } catch (e) {}
    BN.isBN = function isBN(num) {
        if (num instanceof BN) return true;
        return num !== null && typeof num === "object" && num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
    };
    BN.max = function max(left, right) {
        if (left.cmp(right) > 0) return left;
        return right;
    };
    BN.min = function min(left, right) {
        if (left.cmp(right) < 0) return left;
        return right;
    };
    BN.prototype._init = function init(number, base, endian) {
        if (typeof number === "number") return this._initNumber(number, base, endian);
        if (typeof number === "object") return this._initArray(number, base, endian);
        if (base === "hex") base = 16;
        assert(base === (base | 0) && base >= 2 && base <= 36);
        number = number.toString().replace(/\s+/g, "");
        var start = 0;
        if (number[0] === "-") {
            start++;
            this.negative = 1;
        }
        if (start < number.length) {
            if (base === 16) this._parseHex(number, start, endian);
            else {
                this._parseBase(number, base, start);
                if (endian === "le") this._initArray(this.toArray(), base, endian);
            }
        }
    };
    BN.prototype._initNumber = function _initNumber(number, base, endian) {
        if (number < 0) {
            this.negative = 1;
            number = -number;
        }
        if (number < 0x4000000) {
            this.words = [
                number & 0x3ffffff
            ];
            this.length = 1;
        } else if (number < 0x10000000000000) {
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff
            ];
            this.length = 2;
        } else {
            assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff,
                1
            ];
            this.length = 3;
        }
        if (endian !== "le") return;
        // Reverse the bytes
        this._initArray(this.toArray(), base, endian);
    };
    BN.prototype._initArray = function _initArray(number, base, endian) {
        // Perhaps a Uint8Array
        assert(typeof number.length === "number");
        if (number.length <= 0) {
            this.words = [
                0
            ];
            this.length = 1;
            return this;
        }
        this.length = Math.ceil(number.length / 3);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        var j, w;
        var off = 0;
        if (endian === "be") for(i = number.length - 1, j = 0; i >= 0; i -= 3){
            w = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        else if (endian === "le") for(i = 0, j = 0; i < number.length; i += 3){
            w = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        return this._strip();
    };
    function parseHex4Bits(string, index) {
        var c = string.charCodeAt(index);
        // '0' - '9'
        if (c >= 48 && c <= 57) return c - 48;
        else if (c >= 65 && c <= 70) return c - 55;
        else if (c >= 97 && c <= 102) return c - 87;
        else assert(false, "Invalid character in " + string);
    }
    function parseHexByte(string, lowerBound, index) {
        var r = parseHex4Bits(string, index);
        if (index - 1 >= lowerBound) r |= parseHex4Bits(string, index - 1) << 4;
        return r;
    }
    BN.prototype._parseHex = function _parseHex(number, start, endian) {
        // Create possibly bigger array to ensure that it fits the number
        this.length = Math.ceil((number.length - start) / 6);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        // 24-bits chunks
        var off = 0;
        var j = 0;
        var w;
        if (endian === "be") for(i = number.length - 1; i >= start; i -= 2){
            w = parseHexByte(number, start, i) << off;
            this.words[j] |= w & 0x3ffffff;
            if (off >= 18) {
                off -= 18;
                j += 1;
                this.words[j] |= w >>> 26;
            } else off += 8;
        }
        else {
            var parseLength = number.length - start;
            for(i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2){
                w = parseHexByte(number, start, i) << off;
                this.words[j] |= w & 0x3ffffff;
                if (off >= 18) {
                    off -= 18;
                    j += 1;
                    this.words[j] |= w >>> 26;
                } else off += 8;
            }
        }
        this._strip();
    };
    function parseBase(str, start, end, mul) {
        var r = 0;
        var b = 0;
        var len = Math.min(str.length, end);
        for(var i = start; i < len; i++){
            var c = str.charCodeAt(i) - 48;
            r *= mul;
            // 'a'
            if (c >= 49) b = c - 49 + 0xa;
            else if (c >= 17) b = c - 17 + 0xa;
            else b = c;
            assert(c >= 0 && b < mul, "Invalid character");
            r += b;
        }
        return r;
    }
    BN.prototype._parseBase = function _parseBase(number, base, start) {
        // Initialize as zero
        this.words = [
            0
        ];
        this.length = 1;
        // Find length of limb in base
        for(var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base)limbLen++;
        limbLen--;
        limbPow = limbPow / base | 0;
        var total = number.length - start;
        var mod = total % limbLen;
        var end = Math.min(total, total - mod) + start;
        var word = 0;
        for(var i = start; i < end; i += limbLen){
            word = parseBase(number, i, i + limbLen, base);
            this.imuln(limbPow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        if (mod !== 0) {
            var pow = 1;
            word = parseBase(number, i, number.length, base);
            for(i = 0; i < mod; i++)pow *= base;
            this.imuln(pow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        this._strip();
    };
    BN.prototype.copy = function copy(dest) {
        dest.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)dest.words[i] = this.words[i];
        dest.length = this.length;
        dest.negative = this.negative;
        dest.red = this.red;
    };
    function move(dest, src) {
        dest.words = src.words;
        dest.length = src.length;
        dest.negative = src.negative;
        dest.red = src.red;
    }
    BN.prototype._move = function _move(dest) {
        move(dest, this);
    };
    BN.prototype.clone = function clone() {
        var r = new BN(null);
        this.copy(r);
        return r;
    };
    BN.prototype._expand = function _expand(size) {
        while(this.length < size)this.words[this.length++] = 0;
        return this;
    };
    // Remove leading `0` from `this`
    BN.prototype._strip = function strip() {
        while(this.length > 1 && this.words[this.length - 1] === 0)this.length--;
        return this._normSign();
    };
    BN.prototype._normSign = function _normSign() {
        // -0 = 0
        if (this.length === 1 && this.words[0] === 0) this.negative = 0;
        return this;
    };
    // Check Symbol.for because not everywhere where Symbol defined
    // See https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Symbol#Browser_compatibility
    if (typeof Symbol !== "undefined" && typeof Symbol.for === "function") try {
        BN.prototype[Symbol.for("nodejs.util.inspect.custom")] = inspect;
    } catch (e) {
        BN.prototype.inspect = inspect;
    }
    else BN.prototype.inspect = inspect;
    function inspect() {
        return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
    }
    /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */ var zeros = [
        "",
        "0",
        "00",
        "000",
        "0000",
        "00000",
        "000000",
        "0000000",
        "00000000",
        "000000000",
        "0000000000",
        "00000000000",
        "000000000000",
        "0000000000000",
        "00000000000000",
        "000000000000000",
        "0000000000000000",
        "00000000000000000",
        "000000000000000000",
        "0000000000000000000",
        "00000000000000000000",
        "000000000000000000000",
        "0000000000000000000000",
        "00000000000000000000000",
        "000000000000000000000000",
        "0000000000000000000000000"
    ];
    var groupSizes = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
    ];
    var groupBases = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        10000000,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64000000,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        24300000,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
    ];
    BN.prototype.toString = function toString(base, padding) {
        base = base || 10;
        padding = padding | 0 || 1;
        var out;
        if (base === 16 || base === "hex") {
            out = "";
            var off = 0;
            var carry = 0;
            for(var i = 0; i < this.length; i++){
                var w = this.words[i];
                var word = ((w << off | carry) & 0xffffff).toString(16);
                carry = w >>> 24 - off & 0xffffff;
                off += 2;
                if (off >= 26) {
                    off -= 26;
                    i--;
                }
                if (carry !== 0 || i !== this.length - 1) out = zeros[6 - word.length] + word + out;
                else out = word + out;
            }
            if (carry !== 0) out = carry.toString(16) + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        if (base === (base | 0) && base >= 2 && base <= 36) {
            // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
            var groupSize = groupSizes[base];
            // var groupBase = Math.pow(base, groupSize);
            var groupBase = groupBases[base];
            out = "";
            var c = this.clone();
            c.negative = 0;
            while(!c.isZero()){
                var r = c.modrn(groupBase).toString(base);
                c = c.idivn(groupBase);
                if (!c.isZero()) out = zeros[groupSize - r.length] + r + out;
                else out = r + out;
            }
            if (this.isZero()) out = "0" + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        assert(false, "Base should be between 2 and 36");
    };
    BN.prototype.toNumber = function toNumber() {
        var ret = this.words[0];
        if (this.length === 2) ret += this.words[1] * 0x4000000;
        else if (this.length === 3 && this.words[2] === 0x01) // NOTE: at this stage it is known that the top bit is set
        ret += 0x10000000000000 + this.words[1] * 0x4000000;
        else if (this.length > 2) assert(false, "Number can only safely store up to 53 bits");
        return this.negative !== 0 ? -ret : ret;
    };
    BN.prototype.toJSON = function toJSON() {
        return this.toString(16, 2);
    };
    if (Buffer) BN.prototype.toBuffer = function toBuffer(endian, length) {
        return this.toArrayLike(Buffer, endian, length);
    };
    BN.prototype.toArray = function toArray(endian, length) {
        return this.toArrayLike(Array, endian, length);
    };
    var allocate = function allocate(ArrayType, size) {
        if (ArrayType.allocUnsafe) return ArrayType.allocUnsafe(size);
        return new ArrayType(size);
    };
    BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
        this._strip();
        var byteLength = this.byteLength();
        var reqLength = length || Math.max(1, byteLength);
        assert(byteLength <= reqLength, "byte array longer than desired length");
        assert(reqLength > 0, "Requested array length <= 0");
        var res = allocate(ArrayType, reqLength);
        var postfix = endian === "le" ? "LE" : "BE";
        this["_toArrayLike" + postfix](res, byteLength);
        return res;
    };
    BN.prototype._toArrayLikeLE = function _toArrayLikeLE(res, byteLength) {
        var position = 0;
        var carry = 0;
        for(var i = 0, shift = 0; i < this.length; i++){
            var word = this.words[i] << shift | carry;
            res[position++] = word & 0xff;
            if (position < res.length) res[position++] = word >> 8 & 0xff;
            if (position < res.length) res[position++] = word >> 16 & 0xff;
            if (shift === 6) {
                if (position < res.length) res[position++] = word >> 24 & 0xff;
                carry = 0;
                shift = 0;
            } else {
                carry = word >>> 24;
                shift += 2;
            }
        }
        if (position < res.length) {
            res[position++] = carry;
            while(position < res.length)res[position++] = 0;
        }
    };
    BN.prototype._toArrayLikeBE = function _toArrayLikeBE(res, byteLength) {
        var position = res.length - 1;
        var carry = 0;
        for(var i = 0, shift = 0; i < this.length; i++){
            var word = this.words[i] << shift | carry;
            res[position--] = word & 0xff;
            if (position >= 0) res[position--] = word >> 8 & 0xff;
            if (position >= 0) res[position--] = word >> 16 & 0xff;
            if (shift === 6) {
                if (position >= 0) res[position--] = word >> 24 & 0xff;
                carry = 0;
                shift = 0;
            } else {
                carry = word >>> 24;
                shift += 2;
            }
        }
        if (position >= 0) {
            res[position--] = carry;
            while(position >= 0)res[position--] = 0;
        }
    };
    if (Math.clz32) BN.prototype._countBits = function _countBits(w) {
        return 32 - Math.clz32(w);
    };
    else BN.prototype._countBits = function _countBits(w) {
        var t = w;
        var r = 0;
        if (t >= 0x1000) {
            r += 13;
            t >>>= 13;
        }
        if (t >= 0x40) {
            r += 7;
            t >>>= 7;
        }
        if (t >= 0x8) {
            r += 4;
            t >>>= 4;
        }
        if (t >= 0x02) {
            r += 2;
            t >>>= 2;
        }
        return r + t;
    };
    BN.prototype._zeroBits = function _zeroBits(w) {
        // Short-cut
        if (w === 0) return 26;
        var t = w;
        var r = 0;
        if ((t & 0x1fff) === 0) {
            r += 13;
            t >>>= 13;
        }
        if ((t & 0x7f) === 0) {
            r += 7;
            t >>>= 7;
        }
        if ((t & 0xf) === 0) {
            r += 4;
            t >>>= 4;
        }
        if ((t & 0x3) === 0) {
            r += 2;
            t >>>= 2;
        }
        if ((t & 0x1) === 0) r++;
        return r;
    };
    // Return number of used bits in a BN
    BN.prototype.bitLength = function bitLength() {
        var w = this.words[this.length - 1];
        var hi = this._countBits(w);
        return (this.length - 1) * 26 + hi;
    };
    function toBitArray(num) {
        var w = new Array(num.bitLength());
        for(var bit = 0; bit < w.length; bit++){
            var off = bit / 26 | 0;
            var wbit = bit % 26;
            w[bit] = num.words[off] >>> wbit & 0x01;
        }
        return w;
    }
    // Number of trailing zero bits
    BN.prototype.zeroBits = function zeroBits() {
        if (this.isZero()) return 0;
        var r = 0;
        for(var i = 0; i < this.length; i++){
            var b = this._zeroBits(this.words[i]);
            r += b;
            if (b !== 26) break;
        }
        return r;
    };
    BN.prototype.byteLength = function byteLength() {
        return Math.ceil(this.bitLength() / 8);
    };
    BN.prototype.toTwos = function toTwos(width) {
        if (this.negative !== 0) return this.abs().inotn(width).iaddn(1);
        return this.clone();
    };
    BN.prototype.fromTwos = function fromTwos(width) {
        if (this.testn(width - 1)) return this.notn(width).iaddn(1).ineg();
        return this.clone();
    };
    BN.prototype.isNeg = function isNeg() {
        return this.negative !== 0;
    };
    // Return negative clone of `this`
    BN.prototype.neg = function neg() {
        return this.clone().ineg();
    };
    BN.prototype.ineg = function ineg() {
        if (!this.isZero()) this.negative ^= 1;
        return this;
    };
    // Or `num` with `this` in-place
    BN.prototype.iuor = function iuor(num) {
        while(this.length < num.length)this.words[this.length++] = 0;
        for(var i = 0; i < num.length; i++)this.words[i] = this.words[i] | num.words[i];
        return this._strip();
    };
    BN.prototype.ior = function ior(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuor(num);
    };
    // Or `num` with `this`
    BN.prototype.or = function or(num) {
        if (this.length > num.length) return this.clone().ior(num);
        return num.clone().ior(this);
    };
    BN.prototype.uor = function uor(num) {
        if (this.length > num.length) return this.clone().iuor(num);
        return num.clone().iuor(this);
    };
    // And `num` with `this` in-place
    BN.prototype.iuand = function iuand(num) {
        // b = min-length(num, this)
        var b;
        if (this.length > num.length) b = num;
        else b = this;
        for(var i = 0; i < b.length; i++)this.words[i] = this.words[i] & num.words[i];
        this.length = b.length;
        return this._strip();
    };
    BN.prototype.iand = function iand(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuand(num);
    };
    // And `num` with `this`
    BN.prototype.and = function and(num) {
        if (this.length > num.length) return this.clone().iand(num);
        return num.clone().iand(this);
    };
    BN.prototype.uand = function uand(num) {
        if (this.length > num.length) return this.clone().iuand(num);
        return num.clone().iuand(this);
    };
    // Xor `num` with `this` in-place
    BN.prototype.iuxor = function iuxor(num) {
        // a.length > b.length
        var a;
        var b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        for(var i = 0; i < b.length; i++)this.words[i] = a.words[i] ^ b.words[i];
        if (this !== a) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = a.length;
        return this._strip();
    };
    BN.prototype.ixor = function ixor(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuxor(num);
    };
    // Xor `num` with `this`
    BN.prototype.xor = function xor(num) {
        if (this.length > num.length) return this.clone().ixor(num);
        return num.clone().ixor(this);
    };
    BN.prototype.uxor = function uxor(num) {
        if (this.length > num.length) return this.clone().iuxor(num);
        return num.clone().iuxor(this);
    };
    // Not ``this`` with ``width`` bitwidth
    BN.prototype.inotn = function inotn(width) {
        assert(typeof width === "number" && width >= 0);
        var bytesNeeded = Math.ceil(width / 26) | 0;
        var bitsLeft = width % 26;
        // Extend the buffer with leading zeroes
        this._expand(bytesNeeded);
        if (bitsLeft > 0) bytesNeeded--;
        // Handle complete words
        for(var i = 0; i < bytesNeeded; i++)this.words[i] = ~this.words[i] & 0x3ffffff;
        // Handle the residue
        if (bitsLeft > 0) this.words[i] = ~this.words[i] & 0x3ffffff >> 26 - bitsLeft;
        // And remove leading zeroes
        return this._strip();
    };
    BN.prototype.notn = function notn(width) {
        return this.clone().inotn(width);
    };
    // Set `bit` of `this`
    BN.prototype.setn = function setn(bit, val) {
        assert(typeof bit === "number" && bit >= 0);
        var off = bit / 26 | 0;
        var wbit = bit % 26;
        this._expand(off + 1);
        if (val) this.words[off] = this.words[off] | 1 << wbit;
        else this.words[off] = this.words[off] & ~(1 << wbit);
        return this._strip();
    };
    // Add `num` to `this` in-place
    BN.prototype.iadd = function iadd(num) {
        var r;
        // negative + positive
        if (this.negative !== 0 && num.negative === 0) {
            this.negative = 0;
            r = this.isub(num);
            this.negative ^= 1;
            return this._normSign();
        // positive + negative
        } else if (this.negative === 0 && num.negative !== 0) {
            num.negative = 0;
            r = this.isub(num);
            num.negative = 1;
            return r._normSign();
        }
        // a.length > b.length
        var a, b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        this.length = a.length;
        if (carry !== 0) {
            this.words[this.length] = carry;
            this.length++;
        // Copy the rest of the words
        } else if (a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        return this;
    };
    // Add `num` to `this`
    BN.prototype.add = function add(num) {
        var res;
        if (num.negative !== 0 && this.negative === 0) {
            num.negative = 0;
            res = this.sub(num);
            num.negative ^= 1;
            return res;
        } else if (num.negative === 0 && this.negative !== 0) {
            this.negative = 0;
            res = num.sub(this);
            this.negative = 1;
            return res;
        }
        if (this.length > num.length) return this.clone().iadd(num);
        return num.clone().iadd(this);
    };
    // Subtract `num` from `this` in-place
    BN.prototype.isub = function isub(num) {
        // this - (-num) = this + num
        if (num.negative !== 0) {
            num.negative = 0;
            var r = this.iadd(num);
            num.negative = 1;
            return r._normSign();
        // -this - num = -(this + num)
        } else if (this.negative !== 0) {
            this.negative = 0;
            this.iadd(num);
            this.negative = 1;
            return this._normSign();
        }
        // At this point both numbers are positive
        var cmp = this.cmp(num);
        // Optimization - zeroify
        if (cmp === 0) {
            this.negative = 0;
            this.length = 1;
            this.words[0] = 0;
            return this;
        }
        // a > b
        var a, b;
        if (cmp > 0) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        // Copy rest of the words
        if (carry === 0 && i < a.length && a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = Math.max(this.length, i);
        if (a !== this) this.negative = 1;
        return this._strip();
    };
    // Subtract `num` from `this`
    BN.prototype.sub = function sub(num) {
        return this.clone().isub(num);
    };
    function smallMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        var len = self.length + num.length | 0;
        out.length = len;
        len = len - 1 | 0;
        // Peel one iteration (compiler can't do it, because of code complexity)
        var a = self.words[0] | 0;
        var b = num.words[0] | 0;
        var r = a * b;
        var lo = r & 0x3ffffff;
        var carry = r / 0x4000000 | 0;
        out.words[0] = lo;
        for(var k = 1; k < len; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = carry >>> 26;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j | 0;
                a = self.words[i] | 0;
                b = num.words[j] | 0;
                r = a * b + rword;
                ncarry += r / 0x4000000 | 0;
                rword = r & 0x3ffffff;
            }
            out.words[k] = rword | 0;
            carry = ncarry | 0;
        }
        if (carry !== 0) out.words[k] = carry | 0;
        else out.length--;
        return out._strip();
    }
    // TODO(indutny): it may be reasonable to omit it for users who don't need
    // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
    // multiplication (like elliptic secp256k1).
    var comb10MulTo = function comb10MulTo(self, num, out) {
        var a = self.words;
        var b = num.words;
        var o = out.words;
        var c = 0;
        var lo;
        var mid;
        var hi;
        var a0 = a[0] | 0;
        var al0 = a0 & 0x1fff;
        var ah0 = a0 >>> 13;
        var a1 = a[1] | 0;
        var al1 = a1 & 0x1fff;
        var ah1 = a1 >>> 13;
        var a2 = a[2] | 0;
        var al2 = a2 & 0x1fff;
        var ah2 = a2 >>> 13;
        var a3 = a[3] | 0;
        var al3 = a3 & 0x1fff;
        var ah3 = a3 >>> 13;
        var a4 = a[4] | 0;
        var al4 = a4 & 0x1fff;
        var ah4 = a4 >>> 13;
        var a5 = a[5] | 0;
        var al5 = a5 & 0x1fff;
        var ah5 = a5 >>> 13;
        var a6 = a[6] | 0;
        var al6 = a6 & 0x1fff;
        var ah6 = a6 >>> 13;
        var a7 = a[7] | 0;
        var al7 = a7 & 0x1fff;
        var ah7 = a7 >>> 13;
        var a8 = a[8] | 0;
        var al8 = a8 & 0x1fff;
        var ah8 = a8 >>> 13;
        var a9 = a[9] | 0;
        var al9 = a9 & 0x1fff;
        var ah9 = a9 >>> 13;
        var b0 = b[0] | 0;
        var bl0 = b0 & 0x1fff;
        var bh0 = b0 >>> 13;
        var b1 = b[1] | 0;
        var bl1 = b1 & 0x1fff;
        var bh1 = b1 >>> 13;
        var b2 = b[2] | 0;
        var bl2 = b2 & 0x1fff;
        var bh2 = b2 >>> 13;
        var b3 = b[3] | 0;
        var bl3 = b3 & 0x1fff;
        var bh3 = b3 >>> 13;
        var b4 = b[4] | 0;
        var bl4 = b4 & 0x1fff;
        var bh4 = b4 >>> 13;
        var b5 = b[5] | 0;
        var bl5 = b5 & 0x1fff;
        var bh5 = b5 >>> 13;
        var b6 = b[6] | 0;
        var bl6 = b6 & 0x1fff;
        var bh6 = b6 >>> 13;
        var b7 = b[7] | 0;
        var bl7 = b7 & 0x1fff;
        var bh7 = b7 >>> 13;
        var b8 = b[8] | 0;
        var bl8 = b8 & 0x1fff;
        var bh8 = b8 >>> 13;
        var b9 = b[9] | 0;
        var bl9 = b9 & 0x1fff;
        var bh9 = b9 >>> 13;
        out.negative = self.negative ^ num.negative;
        out.length = 19;
        /* k = 0 */ lo = Math.imul(al0, bl0);
        mid = Math.imul(al0, bh0);
        mid = mid + Math.imul(ah0, bl0) | 0;
        hi = Math.imul(ah0, bh0);
        var w0 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
        w0 &= 0x3ffffff;
        /* k = 1 */ lo = Math.imul(al1, bl0);
        mid = Math.imul(al1, bh0);
        mid = mid + Math.imul(ah1, bl0) | 0;
        hi = Math.imul(ah1, bh0);
        lo = lo + Math.imul(al0, bl1) | 0;
        mid = mid + Math.imul(al0, bh1) | 0;
        mid = mid + Math.imul(ah0, bl1) | 0;
        hi = hi + Math.imul(ah0, bh1) | 0;
        var w1 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
        w1 &= 0x3ffffff;
        /* k = 2 */ lo = Math.imul(al2, bl0);
        mid = Math.imul(al2, bh0);
        mid = mid + Math.imul(ah2, bl0) | 0;
        hi = Math.imul(ah2, bh0);
        lo = lo + Math.imul(al1, bl1) | 0;
        mid = mid + Math.imul(al1, bh1) | 0;
        mid = mid + Math.imul(ah1, bl1) | 0;
        hi = hi + Math.imul(ah1, bh1) | 0;
        lo = lo + Math.imul(al0, bl2) | 0;
        mid = mid + Math.imul(al0, bh2) | 0;
        mid = mid + Math.imul(ah0, bl2) | 0;
        hi = hi + Math.imul(ah0, bh2) | 0;
        var w2 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
        w2 &= 0x3ffffff;
        /* k = 3 */ lo = Math.imul(al3, bl0);
        mid = Math.imul(al3, bh0);
        mid = mid + Math.imul(ah3, bl0) | 0;
        hi = Math.imul(ah3, bh0);
        lo = lo + Math.imul(al2, bl1) | 0;
        mid = mid + Math.imul(al2, bh1) | 0;
        mid = mid + Math.imul(ah2, bl1) | 0;
        hi = hi + Math.imul(ah2, bh1) | 0;
        lo = lo + Math.imul(al1, bl2) | 0;
        mid = mid + Math.imul(al1, bh2) | 0;
        mid = mid + Math.imul(ah1, bl2) | 0;
        hi = hi + Math.imul(ah1, bh2) | 0;
        lo = lo + Math.imul(al0, bl3) | 0;
        mid = mid + Math.imul(al0, bh3) | 0;
        mid = mid + Math.imul(ah0, bl3) | 0;
        hi = hi + Math.imul(ah0, bh3) | 0;
        var w3 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
        w3 &= 0x3ffffff;
        /* k = 4 */ lo = Math.imul(al4, bl0);
        mid = Math.imul(al4, bh0);
        mid = mid + Math.imul(ah4, bl0) | 0;
        hi = Math.imul(ah4, bh0);
        lo = lo + Math.imul(al3, bl1) | 0;
        mid = mid + Math.imul(al3, bh1) | 0;
        mid = mid + Math.imul(ah3, bl1) | 0;
        hi = hi + Math.imul(ah3, bh1) | 0;
        lo = lo + Math.imul(al2, bl2) | 0;
        mid = mid + Math.imul(al2, bh2) | 0;
        mid = mid + Math.imul(ah2, bl2) | 0;
        hi = hi + Math.imul(ah2, bh2) | 0;
        lo = lo + Math.imul(al1, bl3) | 0;
        mid = mid + Math.imul(al1, bh3) | 0;
        mid = mid + Math.imul(ah1, bl3) | 0;
        hi = hi + Math.imul(ah1, bh3) | 0;
        lo = lo + Math.imul(al0, bl4) | 0;
        mid = mid + Math.imul(al0, bh4) | 0;
        mid = mid + Math.imul(ah0, bl4) | 0;
        hi = hi + Math.imul(ah0, bh4) | 0;
        var w4 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
        w4 &= 0x3ffffff;
        /* k = 5 */ lo = Math.imul(al5, bl0);
        mid = Math.imul(al5, bh0);
        mid = mid + Math.imul(ah5, bl0) | 0;
        hi = Math.imul(ah5, bh0);
        lo = lo + Math.imul(al4, bl1) | 0;
        mid = mid + Math.imul(al4, bh1) | 0;
        mid = mid + Math.imul(ah4, bl1) | 0;
        hi = hi + Math.imul(ah4, bh1) | 0;
        lo = lo + Math.imul(al3, bl2) | 0;
        mid = mid + Math.imul(al3, bh2) | 0;
        mid = mid + Math.imul(ah3, bl2) | 0;
        hi = hi + Math.imul(ah3, bh2) | 0;
        lo = lo + Math.imul(al2, bl3) | 0;
        mid = mid + Math.imul(al2, bh3) | 0;
        mid = mid + Math.imul(ah2, bl3) | 0;
        hi = hi + Math.imul(ah2, bh3) | 0;
        lo = lo + Math.imul(al1, bl4) | 0;
        mid = mid + Math.imul(al1, bh4) | 0;
        mid = mid + Math.imul(ah1, bl4) | 0;
        hi = hi + Math.imul(ah1, bh4) | 0;
        lo = lo + Math.imul(al0, bl5) | 0;
        mid = mid + Math.imul(al0, bh5) | 0;
        mid = mid + Math.imul(ah0, bl5) | 0;
        hi = hi + Math.imul(ah0, bh5) | 0;
        var w5 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
        w5 &= 0x3ffffff;
        /* k = 6 */ lo = Math.imul(al6, bl0);
        mid = Math.imul(al6, bh0);
        mid = mid + Math.imul(ah6, bl0) | 0;
        hi = Math.imul(ah6, bh0);
        lo = lo + Math.imul(al5, bl1) | 0;
        mid = mid + Math.imul(al5, bh1) | 0;
        mid = mid + Math.imul(ah5, bl1) | 0;
        hi = hi + Math.imul(ah5, bh1) | 0;
        lo = lo + Math.imul(al4, bl2) | 0;
        mid = mid + Math.imul(al4, bh2) | 0;
        mid = mid + Math.imul(ah4, bl2) | 0;
        hi = hi + Math.imul(ah4, bh2) | 0;
        lo = lo + Math.imul(al3, bl3) | 0;
        mid = mid + Math.imul(al3, bh3) | 0;
        mid = mid + Math.imul(ah3, bl3) | 0;
        hi = hi + Math.imul(ah3, bh3) | 0;
        lo = lo + Math.imul(al2, bl4) | 0;
        mid = mid + Math.imul(al2, bh4) | 0;
        mid = mid + Math.imul(ah2, bl4) | 0;
        hi = hi + Math.imul(ah2, bh4) | 0;
        lo = lo + Math.imul(al1, bl5) | 0;
        mid = mid + Math.imul(al1, bh5) | 0;
        mid = mid + Math.imul(ah1, bl5) | 0;
        hi = hi + Math.imul(ah1, bh5) | 0;
        lo = lo + Math.imul(al0, bl6) | 0;
        mid = mid + Math.imul(al0, bh6) | 0;
        mid = mid + Math.imul(ah0, bl6) | 0;
        hi = hi + Math.imul(ah0, bh6) | 0;
        var w6 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
        w6 &= 0x3ffffff;
        /* k = 7 */ lo = Math.imul(al7, bl0);
        mid = Math.imul(al7, bh0);
        mid = mid + Math.imul(ah7, bl0) | 0;
        hi = Math.imul(ah7, bh0);
        lo = lo + Math.imul(al6, bl1) | 0;
        mid = mid + Math.imul(al6, bh1) | 0;
        mid = mid + Math.imul(ah6, bl1) | 0;
        hi = hi + Math.imul(ah6, bh1) | 0;
        lo = lo + Math.imul(al5, bl2) | 0;
        mid = mid + Math.imul(al5, bh2) | 0;
        mid = mid + Math.imul(ah5, bl2) | 0;
        hi = hi + Math.imul(ah5, bh2) | 0;
        lo = lo + Math.imul(al4, bl3) | 0;
        mid = mid + Math.imul(al4, bh3) | 0;
        mid = mid + Math.imul(ah4, bl3) | 0;
        hi = hi + Math.imul(ah4, bh3) | 0;
        lo = lo + Math.imul(al3, bl4) | 0;
        mid = mid + Math.imul(al3, bh4) | 0;
        mid = mid + Math.imul(ah3, bl4) | 0;
        hi = hi + Math.imul(ah3, bh4) | 0;
        lo = lo + Math.imul(al2, bl5) | 0;
        mid = mid + Math.imul(al2, bh5) | 0;
        mid = mid + Math.imul(ah2, bl5) | 0;
        hi = hi + Math.imul(ah2, bh5) | 0;
        lo = lo + Math.imul(al1, bl6) | 0;
        mid = mid + Math.imul(al1, bh6) | 0;
        mid = mid + Math.imul(ah1, bl6) | 0;
        hi = hi + Math.imul(ah1, bh6) | 0;
        lo = lo + Math.imul(al0, bl7) | 0;
        mid = mid + Math.imul(al0, bh7) | 0;
        mid = mid + Math.imul(ah0, bl7) | 0;
        hi = hi + Math.imul(ah0, bh7) | 0;
        var w7 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
        w7 &= 0x3ffffff;
        /* k = 8 */ lo = Math.imul(al8, bl0);
        mid = Math.imul(al8, bh0);
        mid = mid + Math.imul(ah8, bl0) | 0;
        hi = Math.imul(ah8, bh0);
        lo = lo + Math.imul(al7, bl1) | 0;
        mid = mid + Math.imul(al7, bh1) | 0;
        mid = mid + Math.imul(ah7, bl1) | 0;
        hi = hi + Math.imul(ah7, bh1) | 0;
        lo = lo + Math.imul(al6, bl2) | 0;
        mid = mid + Math.imul(al6, bh2) | 0;
        mid = mid + Math.imul(ah6, bl2) | 0;
        hi = hi + Math.imul(ah6, bh2) | 0;
        lo = lo + Math.imul(al5, bl3) | 0;
        mid = mid + Math.imul(al5, bh3) | 0;
        mid = mid + Math.imul(ah5, bl3) | 0;
        hi = hi + Math.imul(ah5, bh3) | 0;
        lo = lo + Math.imul(al4, bl4) | 0;
        mid = mid + Math.imul(al4, bh4) | 0;
        mid = mid + Math.imul(ah4, bl4) | 0;
        hi = hi + Math.imul(ah4, bh4) | 0;
        lo = lo + Math.imul(al3, bl5) | 0;
        mid = mid + Math.imul(al3, bh5) | 0;
        mid = mid + Math.imul(ah3, bl5) | 0;
        hi = hi + Math.imul(ah3, bh5) | 0;
        lo = lo + Math.imul(al2, bl6) | 0;
        mid = mid + Math.imul(al2, bh6) | 0;
        mid = mid + Math.imul(ah2, bl6) | 0;
        hi = hi + Math.imul(ah2, bh6) | 0;
        lo = lo + Math.imul(al1, bl7) | 0;
        mid = mid + Math.imul(al1, bh7) | 0;
        mid = mid + Math.imul(ah1, bl7) | 0;
        hi = hi + Math.imul(ah1, bh7) | 0;
        lo = lo + Math.imul(al0, bl8) | 0;
        mid = mid + Math.imul(al0, bh8) | 0;
        mid = mid + Math.imul(ah0, bl8) | 0;
        hi = hi + Math.imul(ah0, bh8) | 0;
        var w8 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
        w8 &= 0x3ffffff;
        /* k = 9 */ lo = Math.imul(al9, bl0);
        mid = Math.imul(al9, bh0);
        mid = mid + Math.imul(ah9, bl0) | 0;
        hi = Math.imul(ah9, bh0);
        lo = lo + Math.imul(al8, bl1) | 0;
        mid = mid + Math.imul(al8, bh1) | 0;
        mid = mid + Math.imul(ah8, bl1) | 0;
        hi = hi + Math.imul(ah8, bh1) | 0;
        lo = lo + Math.imul(al7, bl2) | 0;
        mid = mid + Math.imul(al7, bh2) | 0;
        mid = mid + Math.imul(ah7, bl2) | 0;
        hi = hi + Math.imul(ah7, bh2) | 0;
        lo = lo + Math.imul(al6, bl3) | 0;
        mid = mid + Math.imul(al6, bh3) | 0;
        mid = mid + Math.imul(ah6, bl3) | 0;
        hi = hi + Math.imul(ah6, bh3) | 0;
        lo = lo + Math.imul(al5, bl4) | 0;
        mid = mid + Math.imul(al5, bh4) | 0;
        mid = mid + Math.imul(ah5, bl4) | 0;
        hi = hi + Math.imul(ah5, bh4) | 0;
        lo = lo + Math.imul(al4, bl5) | 0;
        mid = mid + Math.imul(al4, bh5) | 0;
        mid = mid + Math.imul(ah4, bl5) | 0;
        hi = hi + Math.imul(ah4, bh5) | 0;
        lo = lo + Math.imul(al3, bl6) | 0;
        mid = mid + Math.imul(al3, bh6) | 0;
        mid = mid + Math.imul(ah3, bl6) | 0;
        hi = hi + Math.imul(ah3, bh6) | 0;
        lo = lo + Math.imul(al2, bl7) | 0;
        mid = mid + Math.imul(al2, bh7) | 0;
        mid = mid + Math.imul(ah2, bl7) | 0;
        hi = hi + Math.imul(ah2, bh7) | 0;
        lo = lo + Math.imul(al1, bl8) | 0;
        mid = mid + Math.imul(al1, bh8) | 0;
        mid = mid + Math.imul(ah1, bl8) | 0;
        hi = hi + Math.imul(ah1, bh8) | 0;
        lo = lo + Math.imul(al0, bl9) | 0;
        mid = mid + Math.imul(al0, bh9) | 0;
        mid = mid + Math.imul(ah0, bl9) | 0;
        hi = hi + Math.imul(ah0, bh9) | 0;
        var w9 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
        w9 &= 0x3ffffff;
        /* k = 10 */ lo = Math.imul(al9, bl1);
        mid = Math.imul(al9, bh1);
        mid = mid + Math.imul(ah9, bl1) | 0;
        hi = Math.imul(ah9, bh1);
        lo = lo + Math.imul(al8, bl2) | 0;
        mid = mid + Math.imul(al8, bh2) | 0;
        mid = mid + Math.imul(ah8, bl2) | 0;
        hi = hi + Math.imul(ah8, bh2) | 0;
        lo = lo + Math.imul(al7, bl3) | 0;
        mid = mid + Math.imul(al7, bh3) | 0;
        mid = mid + Math.imul(ah7, bl3) | 0;
        hi = hi + Math.imul(ah7, bh3) | 0;
        lo = lo + Math.imul(al6, bl4) | 0;
        mid = mid + Math.imul(al6, bh4) | 0;
        mid = mid + Math.imul(ah6, bl4) | 0;
        hi = hi + Math.imul(ah6, bh4) | 0;
        lo = lo + Math.imul(al5, bl5) | 0;
        mid = mid + Math.imul(al5, bh5) | 0;
        mid = mid + Math.imul(ah5, bl5) | 0;
        hi = hi + Math.imul(ah5, bh5) | 0;
        lo = lo + Math.imul(al4, bl6) | 0;
        mid = mid + Math.imul(al4, bh6) | 0;
        mid = mid + Math.imul(ah4, bl6) | 0;
        hi = hi + Math.imul(ah4, bh6) | 0;
        lo = lo + Math.imul(al3, bl7) | 0;
        mid = mid + Math.imul(al3, bh7) | 0;
        mid = mid + Math.imul(ah3, bl7) | 0;
        hi = hi + Math.imul(ah3, bh7) | 0;
        lo = lo + Math.imul(al2, bl8) | 0;
        mid = mid + Math.imul(al2, bh8) | 0;
        mid = mid + Math.imul(ah2, bl8) | 0;
        hi = hi + Math.imul(ah2, bh8) | 0;
        lo = lo + Math.imul(al1, bl9) | 0;
        mid = mid + Math.imul(al1, bh9) | 0;
        mid = mid + Math.imul(ah1, bl9) | 0;
        hi = hi + Math.imul(ah1, bh9) | 0;
        var w10 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
        w10 &= 0x3ffffff;
        /* k = 11 */ lo = Math.imul(al9, bl2);
        mid = Math.imul(al9, bh2);
        mid = mid + Math.imul(ah9, bl2) | 0;
        hi = Math.imul(ah9, bh2);
        lo = lo + Math.imul(al8, bl3) | 0;
        mid = mid + Math.imul(al8, bh3) | 0;
        mid = mid + Math.imul(ah8, bl3) | 0;
        hi = hi + Math.imul(ah8, bh3) | 0;
        lo = lo + Math.imul(al7, bl4) | 0;
        mid = mid + Math.imul(al7, bh4) | 0;
        mid = mid + Math.imul(ah7, bl4) | 0;
        hi = hi + Math.imul(ah7, bh4) | 0;
        lo = lo + Math.imul(al6, bl5) | 0;
        mid = mid + Math.imul(al6, bh5) | 0;
        mid = mid + Math.imul(ah6, bl5) | 0;
        hi = hi + Math.imul(ah6, bh5) | 0;
        lo = lo + Math.imul(al5, bl6) | 0;
        mid = mid + Math.imul(al5, bh6) | 0;
        mid = mid + Math.imul(ah5, bl6) | 0;
        hi = hi + Math.imul(ah5, bh6) | 0;
        lo = lo + Math.imul(al4, bl7) | 0;
        mid = mid + Math.imul(al4, bh7) | 0;
        mid = mid + Math.imul(ah4, bl7) | 0;
        hi = hi + Math.imul(ah4, bh7) | 0;
        lo = lo + Math.imul(al3, bl8) | 0;
        mid = mid + Math.imul(al3, bh8) | 0;
        mid = mid + Math.imul(ah3, bl8) | 0;
        hi = hi + Math.imul(ah3, bh8) | 0;
        lo = lo + Math.imul(al2, bl9) | 0;
        mid = mid + Math.imul(al2, bh9) | 0;
        mid = mid + Math.imul(ah2, bl9) | 0;
        hi = hi + Math.imul(ah2, bh9) | 0;
        var w11 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
        w11 &= 0x3ffffff;
        /* k = 12 */ lo = Math.imul(al9, bl3);
        mid = Math.imul(al9, bh3);
        mid = mid + Math.imul(ah9, bl3) | 0;
        hi = Math.imul(ah9, bh3);
        lo = lo + Math.imul(al8, bl4) | 0;
        mid = mid + Math.imul(al8, bh4) | 0;
        mid = mid + Math.imul(ah8, bl4) | 0;
        hi = hi + Math.imul(ah8, bh4) | 0;
        lo = lo + Math.imul(al7, bl5) | 0;
        mid = mid + Math.imul(al7, bh5) | 0;
        mid = mid + Math.imul(ah7, bl5) | 0;
        hi = hi + Math.imul(ah7, bh5) | 0;
        lo = lo + Math.imul(al6, bl6) | 0;
        mid = mid + Math.imul(al6, bh6) | 0;
        mid = mid + Math.imul(ah6, bl6) | 0;
        hi = hi + Math.imul(ah6, bh6) | 0;
        lo = lo + Math.imul(al5, bl7) | 0;
        mid = mid + Math.imul(al5, bh7) | 0;
        mid = mid + Math.imul(ah5, bl7) | 0;
        hi = hi + Math.imul(ah5, bh7) | 0;
        lo = lo + Math.imul(al4, bl8) | 0;
        mid = mid + Math.imul(al4, bh8) | 0;
        mid = mid + Math.imul(ah4, bl8) | 0;
        hi = hi + Math.imul(ah4, bh8) | 0;
        lo = lo + Math.imul(al3, bl9) | 0;
        mid = mid + Math.imul(al3, bh9) | 0;
        mid = mid + Math.imul(ah3, bl9) | 0;
        hi = hi + Math.imul(ah3, bh9) | 0;
        var w12 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
        w12 &= 0x3ffffff;
        /* k = 13 */ lo = Math.imul(al9, bl4);
        mid = Math.imul(al9, bh4);
        mid = mid + Math.imul(ah9, bl4) | 0;
        hi = Math.imul(ah9, bh4);
        lo = lo + Math.imul(al8, bl5) | 0;
        mid = mid + Math.imul(al8, bh5) | 0;
        mid = mid + Math.imul(ah8, bl5) | 0;
        hi = hi + Math.imul(ah8, bh5) | 0;
        lo = lo + Math.imul(al7, bl6) | 0;
        mid = mid + Math.imul(al7, bh6) | 0;
        mid = mid + Math.imul(ah7, bl6) | 0;
        hi = hi + Math.imul(ah7, bh6) | 0;
        lo = lo + Math.imul(al6, bl7) | 0;
        mid = mid + Math.imul(al6, bh7) | 0;
        mid = mid + Math.imul(ah6, bl7) | 0;
        hi = hi + Math.imul(ah6, bh7) | 0;
        lo = lo + Math.imul(al5, bl8) | 0;
        mid = mid + Math.imul(al5, bh8) | 0;
        mid = mid + Math.imul(ah5, bl8) | 0;
        hi = hi + Math.imul(ah5, bh8) | 0;
        lo = lo + Math.imul(al4, bl9) | 0;
        mid = mid + Math.imul(al4, bh9) | 0;
        mid = mid + Math.imul(ah4, bl9) | 0;
        hi = hi + Math.imul(ah4, bh9) | 0;
        var w13 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
        w13 &= 0x3ffffff;
        /* k = 14 */ lo = Math.imul(al9, bl5);
        mid = Math.imul(al9, bh5);
        mid = mid + Math.imul(ah9, bl5) | 0;
        hi = Math.imul(ah9, bh5);
        lo = lo + Math.imul(al8, bl6) | 0;
        mid = mid + Math.imul(al8, bh6) | 0;
        mid = mid + Math.imul(ah8, bl6) | 0;
        hi = hi + Math.imul(ah8, bh6) | 0;
        lo = lo + Math.imul(al7, bl7) | 0;
        mid = mid + Math.imul(al7, bh7) | 0;
        mid = mid + Math.imul(ah7, bl7) | 0;
        hi = hi + Math.imul(ah7, bh7) | 0;
        lo = lo + Math.imul(al6, bl8) | 0;
        mid = mid + Math.imul(al6, bh8) | 0;
        mid = mid + Math.imul(ah6, bl8) | 0;
        hi = hi + Math.imul(ah6, bh8) | 0;
        lo = lo + Math.imul(al5, bl9) | 0;
        mid = mid + Math.imul(al5, bh9) | 0;
        mid = mid + Math.imul(ah5, bl9) | 0;
        hi = hi + Math.imul(ah5, bh9) | 0;
        var w14 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
        w14 &= 0x3ffffff;
        /* k = 15 */ lo = Math.imul(al9, bl6);
        mid = Math.imul(al9, bh6);
        mid = mid + Math.imul(ah9, bl6) | 0;
        hi = Math.imul(ah9, bh6);
        lo = lo + Math.imul(al8, bl7) | 0;
        mid = mid + Math.imul(al8, bh7) | 0;
        mid = mid + Math.imul(ah8, bl7) | 0;
        hi = hi + Math.imul(ah8, bh7) | 0;
        lo = lo + Math.imul(al7, bl8) | 0;
        mid = mid + Math.imul(al7, bh8) | 0;
        mid = mid + Math.imul(ah7, bl8) | 0;
        hi = hi + Math.imul(ah7, bh8) | 0;
        lo = lo + Math.imul(al6, bl9) | 0;
        mid = mid + Math.imul(al6, bh9) | 0;
        mid = mid + Math.imul(ah6, bl9) | 0;
        hi = hi + Math.imul(ah6, bh9) | 0;
        var w15 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
        w15 &= 0x3ffffff;
        /* k = 16 */ lo = Math.imul(al9, bl7);
        mid = Math.imul(al9, bh7);
        mid = mid + Math.imul(ah9, bl7) | 0;
        hi = Math.imul(ah9, bh7);
        lo = lo + Math.imul(al8, bl8) | 0;
        mid = mid + Math.imul(al8, bh8) | 0;
        mid = mid + Math.imul(ah8, bl8) | 0;
        hi = hi + Math.imul(ah8, bh8) | 0;
        lo = lo + Math.imul(al7, bl9) | 0;
        mid = mid + Math.imul(al7, bh9) | 0;
        mid = mid + Math.imul(ah7, bl9) | 0;
        hi = hi + Math.imul(ah7, bh9) | 0;
        var w16 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
        w16 &= 0x3ffffff;
        /* k = 17 */ lo = Math.imul(al9, bl8);
        mid = Math.imul(al9, bh8);
        mid = mid + Math.imul(ah9, bl8) | 0;
        hi = Math.imul(ah9, bh8);
        lo = lo + Math.imul(al8, bl9) | 0;
        mid = mid + Math.imul(al8, bh9) | 0;
        mid = mid + Math.imul(ah8, bl9) | 0;
        hi = hi + Math.imul(ah8, bh9) | 0;
        var w17 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
        w17 &= 0x3ffffff;
        /* k = 18 */ lo = Math.imul(al9, bl9);
        mid = Math.imul(al9, bh9);
        mid = mid + Math.imul(ah9, bl9) | 0;
        hi = Math.imul(ah9, bh9);
        var w18 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
        w18 &= 0x3ffffff;
        o[0] = w0;
        o[1] = w1;
        o[2] = w2;
        o[3] = w3;
        o[4] = w4;
        o[5] = w5;
        o[6] = w6;
        o[7] = w7;
        o[8] = w8;
        o[9] = w9;
        o[10] = w10;
        o[11] = w11;
        o[12] = w12;
        o[13] = w13;
        o[14] = w14;
        o[15] = w15;
        o[16] = w16;
        o[17] = w17;
        o[18] = w18;
        if (c !== 0) {
            o[19] = c;
            out.length++;
        }
        return out;
    };
    // Polyfill comb
    if (!Math.imul) comb10MulTo = smallMulTo;
    function bigMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        out.length = self.length + num.length;
        var carry = 0;
        var hncarry = 0;
        for(var k = 0; k < out.length - 1; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = hncarry;
            hncarry = 0;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j;
                var a = self.words[i] | 0;
                var b = num.words[j] | 0;
                var r = a * b;
                var lo = r & 0x3ffffff;
                ncarry = ncarry + (r / 0x4000000 | 0) | 0;
                lo = lo + rword | 0;
                rword = lo & 0x3ffffff;
                ncarry = ncarry + (lo >>> 26) | 0;
                hncarry += ncarry >>> 26;
                ncarry &= 0x3ffffff;
            }
            out.words[k] = rword;
            carry = ncarry;
            ncarry = hncarry;
        }
        if (carry !== 0) out.words[k] = carry;
        else out.length--;
        return out._strip();
    }
    function jumboMulTo(self, num, out) {
        // Temporary disable, see https://github.com/indutny/bn.js/issues/211
        // var fftm = new FFTM();
        // return fftm.mulp(self, num, out);
        return bigMulTo(self, num, out);
    }
    BN.prototype.mulTo = function mulTo(num, out) {
        var res;
        var len = this.length + num.length;
        if (this.length === 10 && num.length === 10) res = comb10MulTo(this, num, out);
        else if (len < 63) res = smallMulTo(this, num, out);
        else if (len < 1024) res = bigMulTo(this, num, out);
        else res = jumboMulTo(this, num, out);
        return res;
    };
    // Cooley-Tukey algorithm for FFT
    // slightly revisited to rely on looping instead of recursion
    function FFTM(x, y) {
        this.x = x;
        this.y = y;
    }
    FFTM.prototype.makeRBT = function makeRBT(N) {
        var t = new Array(N);
        var l = BN.prototype._countBits(N) - 1;
        for(var i = 0; i < N; i++)t[i] = this.revBin(i, l, N);
        return t;
    };
    // Returns binary-reversed representation of `x`
    FFTM.prototype.revBin = function revBin(x, l, N) {
        if (x === 0 || x === N - 1) return x;
        var rb = 0;
        for(var i = 0; i < l; i++){
            rb |= (x & 1) << l - i - 1;
            x >>= 1;
        }
        return rb;
    };
    // Performs "tweedling" phase, therefore 'emulating'
    // behaviour of the recursive algorithm
    FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
        for(var i = 0; i < N; i++){
            rtws[i] = rws[rbt[i]];
            itws[i] = iws[rbt[i]];
        }
    };
    FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
        this.permute(rbt, rws, iws, rtws, itws, N);
        for(var s = 1; s < N; s <<= 1){
            var l = s << 1;
            var rtwdf = Math.cos(2 * Math.PI / l);
            var itwdf = Math.sin(2 * Math.PI / l);
            for(var p = 0; p < N; p += l){
                var rtwdf_ = rtwdf;
                var itwdf_ = itwdf;
                for(var j = 0; j < s; j++){
                    var re = rtws[p + j];
                    var ie = itws[p + j];
                    var ro = rtws[p + j + s];
                    var io = itws[p + j + s];
                    var rx = rtwdf_ * ro - itwdf_ * io;
                    io = rtwdf_ * io + itwdf_ * ro;
                    ro = rx;
                    rtws[p + j] = re + ro;
                    itws[p + j] = ie + io;
                    rtws[p + j + s] = re - ro;
                    itws[p + j + s] = ie - io;
                    /* jshint maxdepth : false */ if (j !== l) {
                        rx = rtwdf * rtwdf_ - itwdf * itwdf_;
                        itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                        rtwdf_ = rx;
                    }
                }
            }
        }
    };
    FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
        var N = Math.max(m, n) | 1;
        var odd = N & 1;
        var i = 0;
        for(N = N / 2 | 0; N; N = N >>> 1)i++;
        return 1 << i + 1 + odd;
    };
    FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
        if (N <= 1) return;
        for(var i = 0; i < N / 2; i++){
            var t = rws[i];
            rws[i] = rws[N - i - 1];
            rws[N - i - 1] = t;
            t = iws[i];
            iws[i] = -iws[N - i - 1];
            iws[N - i - 1] = -t;
        }
    };
    FFTM.prototype.normalize13b = function normalize13b(ws, N) {
        var carry = 0;
        for(var i = 0; i < N / 2; i++){
            var w = Math.round(ws[2 * i + 1] / N) * 0x2000 + Math.round(ws[2 * i] / N) + carry;
            ws[i] = w & 0x3ffffff;
            if (w < 0x4000000) carry = 0;
            else carry = w / 0x4000000 | 0;
        }
        return ws;
    };
    FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
        var carry = 0;
        for(var i = 0; i < len; i++){
            carry = carry + (ws[i] | 0);
            rws[2 * i] = carry & 0x1fff;
            carry = carry >>> 13;
            rws[2 * i + 1] = carry & 0x1fff;
            carry = carry >>> 13;
        }
        // Pad with zeroes
        for(i = 2 * len; i < N; ++i)rws[i] = 0;
        assert(carry === 0);
        assert((carry & -8192) === 0);
    };
    FFTM.prototype.stub = function stub(N) {
        var ph = new Array(N);
        for(var i = 0; i < N; i++)ph[i] = 0;
        return ph;
    };
    FFTM.prototype.mulp = function mulp(x, y, out) {
        var N = 2 * this.guessLen13b(x.length, y.length);
        var rbt = this.makeRBT(N);
        var _ = this.stub(N);
        var rws = new Array(N);
        var rwst = new Array(N);
        var iwst = new Array(N);
        var nrws = new Array(N);
        var nrwst = new Array(N);
        var niwst = new Array(N);
        var rmws = out.words;
        rmws.length = N;
        this.convert13b(x.words, x.length, rws, N);
        this.convert13b(y.words, y.length, nrws, N);
        this.transform(rws, _, rwst, iwst, N, rbt);
        this.transform(nrws, _, nrwst, niwst, N, rbt);
        for(var i = 0; i < N; i++){
            var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
            iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
            rwst[i] = rx;
        }
        this.conjugate(rwst, iwst, N);
        this.transform(rwst, iwst, rmws, _, N, rbt);
        this.conjugate(rmws, _, N);
        this.normalize13b(rmws, N);
        out.negative = x.negative ^ y.negative;
        out.length = x.length + y.length;
        return out._strip();
    };
    // Multiply `this` by `num`
    BN.prototype.mul = function mul(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return this.mulTo(num, out);
    };
    // Multiply employing FFT
    BN.prototype.mulf = function mulf(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return jumboMulTo(this, num, out);
    };
    // In-place Multiplication
    BN.prototype.imul = function imul(num) {
        return this.clone().mulTo(num, this);
    };
    BN.prototype.imuln = function imuln(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(typeof num === "number");
        assert(num < 0x4000000);
        // Carry
        var carry = 0;
        for(var i = 0; i < this.length; i++){
            var w = (this.words[i] | 0) * num;
            var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
            carry >>= 26;
            carry += w / 0x4000000 | 0;
            // NOTE: lo is 27bit maximum
            carry += lo >>> 26;
            this.words[i] = lo & 0x3ffffff;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return isNegNum ? this.ineg() : this;
    };
    BN.prototype.muln = function muln(num) {
        return this.clone().imuln(num);
    };
    // `this` * `this`
    BN.prototype.sqr = function sqr() {
        return this.mul(this);
    };
    // `this` * `this` in-place
    BN.prototype.isqr = function isqr() {
        return this.imul(this.clone());
    };
    // Math.pow(`this`, `num`)
    BN.prototype.pow = function pow(num) {
        var w = toBitArray(num);
        if (w.length === 0) return new BN(1);
        // Skip leading zeroes
        var res = this;
        for(var i = 0; i < w.length; i++, res = res.sqr()){
            if (w[i] !== 0) break;
        }
        if (++i < w.length) for(var q = res.sqr(); i < w.length; i++, q = q.sqr()){
            if (w[i] === 0) continue;
            res = res.mul(q);
        }
        return res;
    };
    // Shift-left in-place
    BN.prototype.iushln = function iushln(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        var carryMask = 0x3ffffff >>> 26 - r << 26 - r;
        var i;
        if (r !== 0) {
            var carry = 0;
            for(i = 0; i < this.length; i++){
                var newCarry = this.words[i] & carryMask;
                var c = (this.words[i] | 0) - newCarry << r;
                this.words[i] = c | carry;
                carry = newCarry >>> 26 - r;
            }
            if (carry) {
                this.words[i] = carry;
                this.length++;
            }
        }
        if (s !== 0) {
            for(i = this.length - 1; i >= 0; i--)this.words[i + s] = this.words[i];
            for(i = 0; i < s; i++)this.words[i] = 0;
            this.length += s;
        }
        return this._strip();
    };
    BN.prototype.ishln = function ishln(bits) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushln(bits);
    };
    // Shift-right in-place
    // NOTE: `hint` is a lowest bit before trailing zeroes
    // NOTE: if `extended` is present - it will be filled with destroyed bits
    BN.prototype.iushrn = function iushrn(bits, hint, extended) {
        assert(typeof bits === "number" && bits >= 0);
        var h;
        if (hint) h = (hint - hint % 26) / 26;
        else h = 0;
        var r = bits % 26;
        var s = Math.min((bits - r) / 26, this.length);
        var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
        var maskedWords = extended;
        h -= s;
        h = Math.max(0, h);
        // Extended mode, copy masked part
        if (maskedWords) {
            for(var i = 0; i < s; i++)maskedWords.words[i] = this.words[i];
            maskedWords.length = s;
        }
        if (s === 0) ;
        else if (this.length > s) {
            this.length -= s;
            for(i = 0; i < this.length; i++)this.words[i] = this.words[i + s];
        } else {
            this.words[0] = 0;
            this.length = 1;
        }
        var carry = 0;
        for(i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--){
            var word = this.words[i] | 0;
            this.words[i] = carry << 26 - r | word >>> r;
            carry = word & mask;
        }
        // Push carried bits as a mask
        if (maskedWords && carry !== 0) maskedWords.words[maskedWords.length++] = carry;
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this._strip();
    };
    BN.prototype.ishrn = function ishrn(bits, hint, extended) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushrn(bits, hint, extended);
    };
    // Shift-left
    BN.prototype.shln = function shln(bits) {
        return this.clone().ishln(bits);
    };
    BN.prototype.ushln = function ushln(bits) {
        return this.clone().iushln(bits);
    };
    // Shift-right
    BN.prototype.shrn = function shrn(bits) {
        return this.clone().ishrn(bits);
    };
    BN.prototype.ushrn = function ushrn(bits) {
        return this.clone().iushrn(bits);
    };
    // Test if n bit is set
    BN.prototype.testn = function testn(bit) {
        assert(typeof bit === "number" && bit >= 0);
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) return false;
        // Check bit and return
        var w = this.words[s];
        return !!(w & q);
    };
    // Return only lowers bits of number (in-place)
    BN.prototype.imaskn = function imaskn(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        assert(this.negative === 0, "imaskn works only with positive numbers");
        if (this.length <= s) return this;
        if (r !== 0) s++;
        this.length = Math.min(s, this.length);
        if (r !== 0) {
            var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
            this.words[this.length - 1] &= mask;
        }
        return this._strip();
    };
    // Return only lowers bits of number
    BN.prototype.maskn = function maskn(bits) {
        return this.clone().imaskn(bits);
    };
    // Add plain number `num` to `this`
    BN.prototype.iaddn = function iaddn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.isubn(-num);
        // Possible sign change
        if (this.negative !== 0) {
            if (this.length === 1 && (this.words[0] | 0) <= num) {
                this.words[0] = num - (this.words[0] | 0);
                this.negative = 0;
                return this;
            }
            this.negative = 0;
            this.isubn(num);
            this.negative = 1;
            return this;
        }
        // Add without checks
        return this._iaddn(num);
    };
    BN.prototype._iaddn = function _iaddn(num) {
        this.words[0] += num;
        // Carry
        for(var i = 0; i < this.length && this.words[i] >= 0x4000000; i++){
            this.words[i] -= 0x4000000;
            if (i === this.length - 1) this.words[i + 1] = 1;
            else this.words[i + 1]++;
        }
        this.length = Math.max(this.length, i + 1);
        return this;
    };
    // Subtract plain number `num` from `this`
    BN.prototype.isubn = function isubn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.iaddn(-num);
        if (this.negative !== 0) {
            this.negative = 0;
            this.iaddn(num);
            this.negative = 1;
            return this;
        }
        this.words[0] -= num;
        if (this.length === 1 && this.words[0] < 0) {
            this.words[0] = -this.words[0];
            this.negative = 1;
        } else // Carry
        for(var i = 0; i < this.length && this.words[i] < 0; i++){
            this.words[i] += 0x4000000;
            this.words[i + 1] -= 1;
        }
        return this._strip();
    };
    BN.prototype.addn = function addn(num) {
        return this.clone().iaddn(num);
    };
    BN.prototype.subn = function subn(num) {
        return this.clone().isubn(num);
    };
    BN.prototype.iabs = function iabs() {
        this.negative = 0;
        return this;
    };
    BN.prototype.abs = function abs() {
        return this.clone().iabs();
    };
    BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
        var len = num.length + shift;
        var i;
        this._expand(len);
        var w;
        var carry = 0;
        for(i = 0; i < num.length; i++){
            w = (this.words[i + shift] | 0) + carry;
            var right = (num.words[i] | 0) * mul;
            w -= right & 0x3ffffff;
            carry = (w >> 26) - (right / 0x4000000 | 0);
            this.words[i + shift] = w & 0x3ffffff;
        }
        for(; i < this.length - shift; i++){
            w = (this.words[i + shift] | 0) + carry;
            carry = w >> 26;
            this.words[i + shift] = w & 0x3ffffff;
        }
        if (carry === 0) return this._strip();
        // Subtraction overflow
        assert(carry === -1);
        carry = 0;
        for(i = 0; i < this.length; i++){
            w = -(this.words[i] | 0) + carry;
            carry = w >> 26;
            this.words[i] = w & 0x3ffffff;
        }
        this.negative = 1;
        return this._strip();
    };
    BN.prototype._wordDiv = function _wordDiv(num, mode) {
        var shift = this.length - num.length;
        var a = this.clone();
        var b = num;
        // Normalize
        var bhi = b.words[b.length - 1] | 0;
        var bhiBits = this._countBits(bhi);
        shift = 26 - bhiBits;
        if (shift !== 0) {
            b = b.ushln(shift);
            a.iushln(shift);
            bhi = b.words[b.length - 1] | 0;
        }
        // Initialize quotient
        var m = a.length - b.length;
        var q;
        if (mode !== "mod") {
            q = new BN(null);
            q.length = m + 1;
            q.words = new Array(q.length);
            for(var i = 0; i < q.length; i++)q.words[i] = 0;
        }
        var diff = a.clone()._ishlnsubmul(b, 1, m);
        if (diff.negative === 0) {
            a = diff;
            if (q) q.words[m] = 1;
        }
        for(var j = m - 1; j >= 0; j--){
            var qj = (a.words[b.length + j] | 0) * 0x4000000 + (a.words[b.length + j - 1] | 0);
            // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
            // (0x7ffffff)
            qj = Math.min(qj / bhi | 0, 0x3ffffff);
            a._ishlnsubmul(b, qj, j);
            while(a.negative !== 0){
                qj--;
                a.negative = 0;
                a._ishlnsubmul(b, 1, j);
                if (!a.isZero()) a.negative ^= 1;
            }
            if (q) q.words[j] = qj;
        }
        if (q) q._strip();
        a._strip();
        // Denormalize
        if (mode !== "div" && shift !== 0) a.iushrn(shift);
        return {
            div: q || null,
            mod: a
        };
    };
    // NOTE: 1) `mode` can be set to `mod` to request mod only,
    //       to `div` to request div only, or be absent to
    //       request both div & mod
    //       2) `positive` is true if unsigned mod is requested
    BN.prototype.divmod = function divmod(num, mode, positive) {
        assert(!num.isZero());
        if (this.isZero()) return {
            div: new BN(0),
            mod: new BN(0)
        };
        var div, mod, res;
        if (this.negative !== 0 && num.negative === 0) {
            res = this.neg().divmod(num, mode);
            if (mode !== "mod") div = res.div.neg();
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.iadd(num);
            }
            return {
                div: div,
                mod: mod
            };
        }
        if (this.negative === 0 && num.negative !== 0) {
            res = this.divmod(num.neg(), mode);
            if (mode !== "mod") div = res.div.neg();
            return {
                div: div,
                mod: res.mod
            };
        }
        if ((this.negative & num.negative) !== 0) {
            res = this.neg().divmod(num.neg(), mode);
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.isub(num);
            }
            return {
                div: res.div,
                mod: mod
            };
        }
        // Both numbers are positive at this point
        // Strip both numbers to approximate shift value
        if (num.length > this.length || this.cmp(num) < 0) return {
            div: new BN(0),
            mod: this
        };
        // Very short reduction
        if (num.length === 1) {
            if (mode === "div") return {
                div: this.divn(num.words[0]),
                mod: null
            };
            if (mode === "mod") return {
                div: null,
                mod: new BN(this.modrn(num.words[0]))
            };
            return {
                div: this.divn(num.words[0]),
                mod: new BN(this.modrn(num.words[0]))
            };
        }
        return this._wordDiv(num, mode);
    };
    // Find `this` / `num`
    BN.prototype.div = function div(num) {
        return this.divmod(num, "div", false).div;
    };
    // Find `this` % `num`
    BN.prototype.mod = function mod(num) {
        return this.divmod(num, "mod", false).mod;
    };
    BN.prototype.umod = function umod(num) {
        return this.divmod(num, "mod", true).mod;
    };
    // Find Round(`this` / `num`)
    BN.prototype.divRound = function divRound(num) {
        var dm = this.divmod(num);
        // Fast case - exact division
        if (dm.mod.isZero()) return dm.div;
        var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;
        var half = num.ushrn(1);
        var r2 = num.andln(1);
        var cmp = mod.cmp(half);
        // Round down
        if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
        // Round up
        return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
    };
    BN.prototype.modrn = function modrn(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(num <= 0x3ffffff);
        var p = 67108864 % num;
        var acc = 0;
        for(var i = this.length - 1; i >= 0; i--)acc = (p * acc + (this.words[i] | 0)) % num;
        return isNegNum ? -acc : acc;
    };
    // WARNING: DEPRECATED
    BN.prototype.modn = function modn(num) {
        return this.modrn(num);
    };
    // In-place division by number
    BN.prototype.idivn = function idivn(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(num <= 0x3ffffff);
        var carry = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var w = (this.words[i] | 0) + carry * 0x4000000;
            this.words[i] = w / num | 0;
            carry = w % num;
        }
        this._strip();
        return isNegNum ? this.ineg() : this;
    };
    BN.prototype.divn = function divn(num) {
        return this.clone().idivn(num);
    };
    BN.prototype.egcd = function egcd(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var x = this;
        var y = p.clone();
        if (x.negative !== 0) x = x.umod(p);
        else x = x.clone();
        // A * x + B * y = x
        var A = new BN(1);
        var B = new BN(0);
        // C * x + D * y = y
        var C = new BN(0);
        var D = new BN(1);
        var g = 0;
        while(x.isEven() && y.isEven()){
            x.iushrn(1);
            y.iushrn(1);
            ++g;
        }
        var yp = y.clone();
        var xp = x.clone();
        while(!x.isZero()){
            for(var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                x.iushrn(i);
                while(i-- > 0){
                    if (A.isOdd() || B.isOdd()) {
                        A.iadd(yp);
                        B.isub(xp);
                    }
                    A.iushrn(1);
                    B.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                y.iushrn(j);
                while(j-- > 0){
                    if (C.isOdd() || D.isOdd()) {
                        C.iadd(yp);
                        D.isub(xp);
                    }
                    C.iushrn(1);
                    D.iushrn(1);
                }
            }
            if (x.cmp(y) >= 0) {
                x.isub(y);
                A.isub(C);
                B.isub(D);
            } else {
                y.isub(x);
                C.isub(A);
                D.isub(B);
            }
        }
        return {
            a: C,
            b: D,
            gcd: y.iushln(g)
        };
    };
    // This is reduced incarnation of the binary EEA
    // above, designated to invert members of the
    // _prime_ fields F(p) at a maximal speed
    BN.prototype._invmp = function _invmp(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var a = this;
        var b = p.clone();
        if (a.negative !== 0) a = a.umod(p);
        else a = a.clone();
        var x1 = new BN(1);
        var x2 = new BN(0);
        var delta = b.clone();
        while(a.cmpn(1) > 0 && b.cmpn(1) > 0){
            for(var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                a.iushrn(i);
                while(i-- > 0){
                    if (x1.isOdd()) x1.iadd(delta);
                    x1.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                b.iushrn(j);
                while(j-- > 0){
                    if (x2.isOdd()) x2.iadd(delta);
                    x2.iushrn(1);
                }
            }
            if (a.cmp(b) >= 0) {
                a.isub(b);
                x1.isub(x2);
            } else {
                b.isub(a);
                x2.isub(x1);
            }
        }
        var res;
        if (a.cmpn(1) === 0) res = x1;
        else res = x2;
        if (res.cmpn(0) < 0) res.iadd(p);
        return res;
    };
    BN.prototype.gcd = function gcd(num) {
        if (this.isZero()) return num.abs();
        if (num.isZero()) return this.abs();
        var a = this.clone();
        var b = num.clone();
        a.negative = 0;
        b.negative = 0;
        // Remove common factor of two
        for(var shift = 0; a.isEven() && b.isEven(); shift++){
            a.iushrn(1);
            b.iushrn(1);
        }
        do {
            while(a.isEven())a.iushrn(1);
            while(b.isEven())b.iushrn(1);
            var r = a.cmp(b);
            if (r < 0) {
                // Swap `a` and `b` to make `a` always bigger than `b`
                var t = a;
                a = b;
                b = t;
            } else if (r === 0 || b.cmpn(1) === 0) break;
            a.isub(b);
        }while (true);
        return b.iushln(shift);
    };
    // Invert number in the field F(num)
    BN.prototype.invm = function invm(num) {
        return this.egcd(num).a.umod(num);
    };
    BN.prototype.isEven = function isEven() {
        return (this.words[0] & 1) === 0;
    };
    BN.prototype.isOdd = function isOdd() {
        return (this.words[0] & 1) === 1;
    };
    // And first word and num
    BN.prototype.andln = function andln(num) {
        return this.words[0] & num;
    };
    // Increment at the bit position in-line
    BN.prototype.bincn = function bincn(bit) {
        assert(typeof bit === "number");
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) {
            this._expand(s + 1);
            this.words[s] |= q;
            return this;
        }
        // Add bit and propagate, if needed
        var carry = q;
        for(var i = s; carry !== 0 && i < this.length; i++){
            var w = this.words[i] | 0;
            w += carry;
            carry = w >>> 26;
            w &= 0x3ffffff;
            this.words[i] = w;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.isZero = function isZero() {
        return this.length === 1 && this.words[0] === 0;
    };
    BN.prototype.cmpn = function cmpn(num) {
        var negative = num < 0;
        if (this.negative !== 0 && !negative) return -1;
        if (this.negative === 0 && negative) return 1;
        this._strip();
        var res;
        if (this.length > 1) res = 1;
        else {
            if (negative) num = -num;
            assert(num <= 0x3ffffff, "Number is too big");
            var w = this.words[0] | 0;
            res = w === num ? 0 : w < num ? -1 : 1;
        }
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Compare two numbers and return:
    // 1 - if `this` > `num`
    // 0 - if `this` == `num`
    // -1 - if `this` < `num`
    BN.prototype.cmp = function cmp(num) {
        if (this.negative !== 0 && num.negative === 0) return -1;
        if (this.negative === 0 && num.negative !== 0) return 1;
        var res = this.ucmp(num);
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Unsigned comparison
    BN.prototype.ucmp = function ucmp(num) {
        // At this point both numbers have the same sign
        if (this.length > num.length) return 1;
        if (this.length < num.length) return -1;
        var res = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var a = this.words[i] | 0;
            var b = num.words[i] | 0;
            if (a === b) continue;
            if (a < b) res = -1;
            else if (a > b) res = 1;
            break;
        }
        return res;
    };
    BN.prototype.gtn = function gtn(num) {
        return this.cmpn(num) === 1;
    };
    BN.prototype.gt = function gt(num) {
        return this.cmp(num) === 1;
    };
    BN.prototype.gten = function gten(num) {
        return this.cmpn(num) >= 0;
    };
    BN.prototype.gte = function gte(num) {
        return this.cmp(num) >= 0;
    };
    BN.prototype.ltn = function ltn(num) {
        return this.cmpn(num) === -1;
    };
    BN.prototype.lt = function lt(num) {
        return this.cmp(num) === -1;
    };
    BN.prototype.lten = function lten(num) {
        return this.cmpn(num) <= 0;
    };
    BN.prototype.lte = function lte(num) {
        return this.cmp(num) <= 0;
    };
    BN.prototype.eqn = function eqn(num) {
        return this.cmpn(num) === 0;
    };
    BN.prototype.eq = function eq(num) {
        return this.cmp(num) === 0;
    };
    //
    // A reduce context, could be using montgomery or something better, depending
    // on the `m` itself.
    //
    BN.red = function red(num) {
        return new Red(num);
    };
    BN.prototype.toRed = function toRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        assert(this.negative === 0, "red works only with positives");
        return ctx.convertTo(this)._forceRed(ctx);
    };
    BN.prototype.fromRed = function fromRed() {
        assert(this.red, "fromRed works only with numbers in reduction context");
        return this.red.convertFrom(this);
    };
    BN.prototype._forceRed = function _forceRed(ctx) {
        this.red = ctx;
        return this;
    };
    BN.prototype.forceRed = function forceRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        return this._forceRed(ctx);
    };
    BN.prototype.redAdd = function redAdd(num) {
        assert(this.red, "redAdd works only with red numbers");
        return this.red.add(this, num);
    };
    BN.prototype.redIAdd = function redIAdd(num) {
        assert(this.red, "redIAdd works only with red numbers");
        return this.red.iadd(this, num);
    };
    BN.prototype.redSub = function redSub(num) {
        assert(this.red, "redSub works only with red numbers");
        return this.red.sub(this, num);
    };
    BN.prototype.redISub = function redISub(num) {
        assert(this.red, "redISub works only with red numbers");
        return this.red.isub(this, num);
    };
    BN.prototype.redShl = function redShl(num) {
        assert(this.red, "redShl works only with red numbers");
        return this.red.shl(this, num);
    };
    BN.prototype.redMul = function redMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.mul(this, num);
    };
    BN.prototype.redIMul = function redIMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.imul(this, num);
    };
    BN.prototype.redSqr = function redSqr() {
        assert(this.red, "redSqr works only with red numbers");
        this.red._verify1(this);
        return this.red.sqr(this);
    };
    BN.prototype.redISqr = function redISqr() {
        assert(this.red, "redISqr works only with red numbers");
        this.red._verify1(this);
        return this.red.isqr(this);
    };
    // Square root over p
    BN.prototype.redSqrt = function redSqrt() {
        assert(this.red, "redSqrt works only with red numbers");
        this.red._verify1(this);
        return this.red.sqrt(this);
    };
    BN.prototype.redInvm = function redInvm() {
        assert(this.red, "redInvm works only with red numbers");
        this.red._verify1(this);
        return this.red.invm(this);
    };
    // Return negative clone of `this` % `red modulo`
    BN.prototype.redNeg = function redNeg() {
        assert(this.red, "redNeg works only with red numbers");
        this.red._verify1(this);
        return this.red.neg(this);
    };
    BN.prototype.redPow = function redPow(num) {
        assert(this.red && !num.red, "redPow(normalNum)");
        this.red._verify1(this);
        return this.red.pow(this, num);
    };
    // Prime numbers with efficient reduction
    var primes = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
    };
    // Pseudo-Mersenne prime
    function MPrime(name, p) {
        // P = 2 ^ N - K
        this.name = name;
        this.p = new BN(p, 16);
        this.n = this.p.bitLength();
        this.k = new BN(1).iushln(this.n).isub(this.p);
        this.tmp = this._tmp();
    }
    MPrime.prototype._tmp = function _tmp() {
        var tmp = new BN(null);
        tmp.words = new Array(Math.ceil(this.n / 13));
        return tmp;
    };
    MPrime.prototype.ireduce = function ireduce(num) {
        // Assumes that `num` is less than `P^2`
        // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
        var r = num;
        var rlen;
        do {
            this.split(r, this.tmp);
            r = this.imulK(r);
            r = r.iadd(this.tmp);
            rlen = r.bitLength();
        }while (rlen > this.n);
        var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
        if (cmp === 0) {
            r.words[0] = 0;
            r.length = 1;
        } else if (cmp > 0) r.isub(this.p);
        else if (r.strip !== undefined) // r is a BN v4 instance
        r.strip();
        else // r is a BN v5 instance
        r._strip();
        return r;
    };
    MPrime.prototype.split = function split(input, out) {
        input.iushrn(this.n, 0, out);
    };
    MPrime.prototype.imulK = function imulK(num) {
        return num.imul(this.k);
    };
    function K256() {
        MPrime.call(this, "k256", "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f");
    }
    inherits(K256, MPrime);
    K256.prototype.split = function split(input, output) {
        // 256 = 9 * 26 + 22
        var mask = 0x3fffff;
        var outLen = Math.min(input.length, 9);
        for(var i = 0; i < outLen; i++)output.words[i] = input.words[i];
        output.length = outLen;
        if (input.length <= 9) {
            input.words[0] = 0;
            input.length = 1;
            return;
        }
        // Shift by 9 limbs
        var prev = input.words[9];
        output.words[output.length++] = prev & mask;
        for(i = 10; i < input.length; i++){
            var next = input.words[i] | 0;
            input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
            prev = next;
        }
        prev >>>= 22;
        input.words[i - 10] = prev;
        if (prev === 0 && input.length > 10) input.length -= 10;
        else input.length -= 9;
    };
    K256.prototype.imulK = function imulK(num) {
        // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
        num.words[num.length] = 0;
        num.words[num.length + 1] = 0;
        num.length += 2;
        // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
        var lo = 0;
        for(var i = 0; i < num.length; i++){
            var w = num.words[i] | 0;
            lo += w * 0x3d1;
            num.words[i] = lo & 0x3ffffff;
            lo = w * 0x40 + (lo / 0x4000000 | 0);
        }
        // Fast length reduction
        if (num.words[num.length - 1] === 0) {
            num.length--;
            if (num.words[num.length - 1] === 0) num.length--;
        }
        return num;
    };
    function P224() {
        MPrime.call(this, "p224", "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001");
    }
    inherits(P224, MPrime);
    function P192() {
        MPrime.call(this, "p192", "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff");
    }
    inherits(P192, MPrime);
    function P25519() {
        // 2 ^ 255 - 19
        MPrime.call(this, "25519", "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed");
    }
    inherits(P25519, MPrime);
    P25519.prototype.imulK = function imulK(num) {
        // K = 0x13
        var carry = 0;
        for(var i = 0; i < num.length; i++){
            var hi = (num.words[i] | 0) * 0x13 + carry;
            var lo = hi & 0x3ffffff;
            hi >>>= 26;
            num.words[i] = lo;
            carry = hi;
        }
        if (carry !== 0) num.words[num.length++] = carry;
        return num;
    };
    // Exported mostly for testing purposes, use plain name instead
    BN._prime = function prime(name) {
        // Cached version of prime
        if (primes[name]) return primes[name];
        var prime;
        if (name === "k256") prime = new K256();
        else if (name === "p224") prime = new P224();
        else if (name === "p192") prime = new P192();
        else if (name === "p25519") prime = new P25519();
        else throw new Error("Unknown prime " + name);
        primes[name] = prime;
        return prime;
    };
    //
    // Base reduction engine
    //
    function Red(m) {
        if (typeof m === "string") {
            var prime = BN._prime(m);
            this.m = prime.p;
            this.prime = prime;
        } else {
            assert(m.gtn(1), "modulus must be greater than 1");
            this.m = m;
            this.prime = null;
        }
    }
    Red.prototype._verify1 = function _verify1(a) {
        assert(a.negative === 0, "red works only with positives");
        assert(a.red, "red works only with red numbers");
    };
    Red.prototype._verify2 = function _verify2(a, b) {
        assert((a.negative | b.negative) === 0, "red works only with positives");
        assert(a.red && a.red === b.red, "red works only with red numbers");
    };
    Red.prototype.imod = function imod(a) {
        if (this.prime) return this.prime.ireduce(a)._forceRed(this);
        move(a, a.umod(this.m)._forceRed(this));
        return a;
    };
    Red.prototype.neg = function neg(a) {
        if (a.isZero()) return a.clone();
        return this.m.sub(a)._forceRed(this);
    };
    Red.prototype.add = function add(a, b) {
        this._verify2(a, b);
        var res = a.add(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res._forceRed(this);
    };
    Red.prototype.iadd = function iadd(a, b) {
        this._verify2(a, b);
        var res = a.iadd(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res;
    };
    Red.prototype.sub = function sub(a, b) {
        this._verify2(a, b);
        var res = a.sub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res._forceRed(this);
    };
    Red.prototype.isub = function isub(a, b) {
        this._verify2(a, b);
        var res = a.isub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res;
    };
    Red.prototype.shl = function shl(a, num) {
        this._verify1(a);
        return this.imod(a.ushln(num));
    };
    Red.prototype.imul = function imul(a, b) {
        this._verify2(a, b);
        return this.imod(a.imul(b));
    };
    Red.prototype.mul = function mul(a, b) {
        this._verify2(a, b);
        return this.imod(a.mul(b));
    };
    Red.prototype.isqr = function isqr(a) {
        return this.imul(a, a.clone());
    };
    Red.prototype.sqr = function sqr(a) {
        return this.mul(a, a);
    };
    Red.prototype.sqrt = function sqrt(a) {
        if (a.isZero()) return a.clone();
        var mod3 = this.m.andln(3);
        assert(mod3 % 2 === 1);
        // Fast case
        if (mod3 === 3) {
            var pow = this.m.add(new BN(1)).iushrn(2);
            return this.pow(a, pow);
        }
        // Tonelli-Shanks algorithm (Totally unoptimized and slow)
        //
        // Find Q and S, that Q * 2 ^ S = (P - 1)
        var q = this.m.subn(1);
        var s = 0;
        while(!q.isZero() && q.andln(1) === 0){
            s++;
            q.iushrn(1);
        }
        assert(!q.isZero());
        var one = new BN(1).toRed(this);
        var nOne = one.redNeg();
        // Find quadratic non-residue
        // NOTE: Max is such because of generalized Riemann hypothesis.
        var lpow = this.m.subn(1).iushrn(1);
        var z = this.m.bitLength();
        z = new BN(2 * z * z).toRed(this);
        while(this.pow(z, lpow).cmp(nOne) !== 0)z.redIAdd(nOne);
        var c = this.pow(z, q);
        var r = this.pow(a, q.addn(1).iushrn(1));
        var t = this.pow(a, q);
        var m = s;
        while(t.cmp(one) !== 0){
            var tmp = t;
            for(var i = 0; tmp.cmp(one) !== 0; i++)tmp = tmp.redSqr();
            assert(i < m);
            var b = this.pow(c, new BN(1).iushln(m - i - 1));
            r = r.redMul(b);
            c = b.redSqr();
            t = t.redMul(c);
            m = i;
        }
        return r;
    };
    Red.prototype.invm = function invm(a) {
        var inv = a._invmp(this.m);
        if (inv.negative !== 0) {
            inv.negative = 0;
            return this.imod(inv).redNeg();
        } else return this.imod(inv);
    };
    Red.prototype.pow = function pow(a, num) {
        if (num.isZero()) return new BN(1).toRed(this);
        if (num.cmpn(1) === 0) return a.clone();
        var windowSize = 4;
        var wnd = new Array(1 << windowSize);
        wnd[0] = new BN(1).toRed(this);
        wnd[1] = a;
        for(var i = 2; i < wnd.length; i++)wnd[i] = this.mul(wnd[i - 1], a);
        var res = wnd[0];
        var current = 0;
        var currentLen = 0;
        var start = num.bitLength() % 26;
        if (start === 0) start = 26;
        for(i = num.length - 1; i >= 0; i--){
            var word = num.words[i];
            for(var j = start - 1; j >= 0; j--){
                var bit = word >> j & 1;
                if (res !== wnd[0]) res = this.sqr(res);
                if (bit === 0 && current === 0) {
                    currentLen = 0;
                    continue;
                }
                current <<= 1;
                current |= bit;
                currentLen++;
                if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
                res = this.mul(res, wnd[current]);
                currentLen = 0;
                current = 0;
            }
            start = 26;
        }
        return res;
    };
    Red.prototype.convertTo = function convertTo(num) {
        var r = num.umod(this.m);
        return r === num ? r.clone() : r;
    };
    Red.prototype.convertFrom = function convertFrom(num) {
        var res = num.clone();
        res.red = null;
        return res;
    };
    //
    // Montgomery method engine
    //
    BN.mont = function mont(num) {
        return new Mont(num);
    };
    function Mont(m) {
        Red.call(this, m);
        this.shift = this.m.bitLength();
        if (this.shift % 26 !== 0) this.shift += 26 - this.shift % 26;
        this.r = new BN(1).iushln(this.shift);
        this.r2 = this.imod(this.r.sqr());
        this.rinv = this.r._invmp(this.m);
        this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
        this.minv = this.minv.umod(this.r);
        this.minv = this.r.sub(this.minv);
    }
    inherits(Mont, Red);
    Mont.prototype.convertTo = function convertTo(num) {
        return this.imod(num.ushln(this.shift));
    };
    Mont.prototype.convertFrom = function convertFrom(num) {
        var r = this.imod(num.mul(this.rinv));
        r.red = null;
        return r;
    };
    Mont.prototype.imul = function imul(a, b) {
        if (a.isZero() || b.isZero()) {
            a.words[0] = 0;
            a.length = 1;
            return a;
        }
        var t = a.imul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.mul = function mul(a, b) {
        if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
        var t = a.mul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.invm = function invm(a) {
        // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
        var res = this.imod(a._invmp(this.m).mul(this.r2));
        return res._forceRed(this);
    };
})(module, this);

},{"5dd7d237d1064e27":"13Pcp"}],"a11wB":[function(require,module,exports) {
module.exports = require("cfcede3c5a2d609c")(require("33fe87ed575eece2"));

},{"cfcede3c5a2d609c":"lsD5E","33fe87ed575eece2":"kCwym"}],"lsD5E":[function(require,module,exports) {
const createKeccak = require("304c44376128860b");
const createShake = require("ec4f90b0b5c51890");
module.exports = function(KeccakState) {
    const Keccak = createKeccak(KeccakState);
    const Shake = createShake(KeccakState);
    return function(algorithm, options) {
        const hash = typeof algorithm === "string" ? algorithm.toLowerCase() : algorithm;
        switch(hash){
            case "keccak224":
                return new Keccak(1152, 448, null, 224, options);
            case "keccak256":
                return new Keccak(1088, 512, null, 256, options);
            case "keccak384":
                return new Keccak(832, 768, null, 384, options);
            case "keccak512":
                return new Keccak(576, 1024, null, 512, options);
            case "sha3-224":
                return new Keccak(1152, 448, 0x06, 224, options);
            case "sha3-256":
                return new Keccak(1088, 512, 0x06, 256, options);
            case "sha3-384":
                return new Keccak(832, 768, 0x06, 384, options);
            case "sha3-512":
                return new Keccak(576, 1024, 0x06, 512, options);
            case "shake128":
                return new Shake(1344, 256, 0x1f, options);
            case "shake256":
                return new Shake(1088, 512, 0x1f, options);
            default:
                throw new Error("Invald algorithm: " + algorithm);
        }
    };
};

},{"304c44376128860b":"22MQL","ec4f90b0b5c51890":"jMdkc"}],"22MQL":[function(require,module,exports) {
var Buffer = require("9b446b5efc42414a").Buffer;
const { Transform } = require("4a9d844887716f9");
module.exports = (KeccakState)=>class Keccak extends Transform {
        constructor(rate, capacity, delimitedSuffix, hashBitLength, options){
            super(options);
            this._rate = rate;
            this._capacity = capacity;
            this._delimitedSuffix = delimitedSuffix;
            this._hashBitLength = hashBitLength;
            this._options = options;
            this._state = new KeccakState();
            this._state.initialize(rate, capacity);
            this._finalized = false;
        }
        _transform(chunk, encoding, callback) {
            let error = null;
            try {
                this.update(chunk, encoding);
            } catch (err) {
                error = err;
            }
            callback(error);
        }
        _flush(callback) {
            let error = null;
            try {
                this.push(this.digest());
            } catch (err) {
                error = err;
            }
            callback(error);
        }
        update(data, encoding) {
            if (!Buffer.isBuffer(data) && typeof data !== "string") throw new TypeError("Data must be a string or a buffer");
            if (this._finalized) throw new Error("Digest already called");
            if (!Buffer.isBuffer(data)) data = Buffer.from(data, encoding);
            this._state.absorb(data);
            return this;
        }
        digest(encoding) {
            if (this._finalized) throw new Error("Digest already called");
            this._finalized = true;
            if (this._delimitedSuffix) this._state.absorbLastFewBits(this._delimitedSuffix);
            let digest = this._state.squeeze(this._hashBitLength / 8);
            if (encoding !== undefined) digest = digest.toString(encoding);
            this._resetState();
            return digest;
        }
        // remove result from memory
        _resetState() {
            this._state.initialize(this._rate, this._capacity);
            return this;
        }
        // because sometimes we need hash right now and little later
        _clone() {
            const clone = new Keccak(this._rate, this._capacity, this._delimitedSuffix, this._hashBitLength, this._options);
            this._state.copy(clone._state);
            clone._finalized = this._finalized;
            return clone;
        }
    };

},{"9b446b5efc42414a":"l5Twm","4a9d844887716f9":"k5khq"}],"jMdkc":[function(require,module,exports) {
var Buffer = require("83229803548a78d9").Buffer;
const { Transform } = require("9b188b5e04c3a8b7");
module.exports = (KeccakState)=>class Shake extends Transform {
        constructor(rate, capacity, delimitedSuffix, options){
            super(options);
            this._rate = rate;
            this._capacity = capacity;
            this._delimitedSuffix = delimitedSuffix;
            this._options = options;
            this._state = new KeccakState();
            this._state.initialize(rate, capacity);
            this._finalized = false;
        }
        _transform(chunk, encoding, callback) {
            let error = null;
            try {
                this.update(chunk, encoding);
            } catch (err) {
                error = err;
            }
            callback(error);
        }
        _flush() {}
        _read(size) {
            this.push(this.squeeze(size));
        }
        update(data, encoding) {
            if (!Buffer.isBuffer(data) && typeof data !== "string") throw new TypeError("Data must be a string or a buffer");
            if (this._finalized) throw new Error("Squeeze already called");
            if (!Buffer.isBuffer(data)) data = Buffer.from(data, encoding);
            this._state.absorb(data);
            return this;
        }
        squeeze(dataByteLength, encoding) {
            if (!this._finalized) {
                this._finalized = true;
                this._state.absorbLastFewBits(this._delimitedSuffix);
            }
            let data = this._state.squeeze(dataByteLength);
            if (encoding !== undefined) data = data.toString(encoding);
            return data;
        }
        _resetState() {
            this._state.initialize(this._rate, this._capacity);
            return this;
        }
        _clone() {
            const clone = new Shake(this._rate, this._capacity, this._delimitedSuffix, this._options);
            this._state.copy(clone._state);
            clone._finalized = this._finalized;
            return clone;
        }
    };

},{"83229803548a78d9":"l5Twm","9b188b5e04c3a8b7":"k5khq"}],"kCwym":[function(require,module,exports) {
var Buffer = require("42eada955bd40f08").Buffer;
const keccakState = require("4a8c1cafa4e399e7");
function Keccak() {
    // much faster than `new Array(50)`
    this.state = [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ];
    this.blockSize = null;
    this.count = 0;
    this.squeezing = false;
}
Keccak.prototype.initialize = function(rate, capacity) {
    for(let i = 0; i < 50; ++i)this.state[i] = 0;
    this.blockSize = rate / 8;
    this.count = 0;
    this.squeezing = false;
};
Keccak.prototype.absorb = function(data) {
    for(let i = 0; i < data.length; ++i){
        this.state[~~(this.count / 4)] ^= data[i] << 8 * (this.count % 4);
        this.count += 1;
        if (this.count === this.blockSize) {
            keccakState.p1600(this.state);
            this.count = 0;
        }
    }
};
Keccak.prototype.absorbLastFewBits = function(bits) {
    this.state[~~(this.count / 4)] ^= bits << 8 * (this.count % 4);
    if ((bits & 0x80) !== 0 && this.count === this.blockSize - 1) keccakState.p1600(this.state);
    this.state[~~((this.blockSize - 1) / 4)] ^= 0x80 << 8 * ((this.blockSize - 1) % 4);
    keccakState.p1600(this.state);
    this.count = 0;
    this.squeezing = true;
};
Keccak.prototype.squeeze = function(length) {
    if (!this.squeezing) this.absorbLastFewBits(0x01);
    const output = Buffer.alloc(length);
    for(let i = 0; i < length; ++i){
        output[i] = this.state[~~(this.count / 4)] >>> 8 * (this.count % 4) & 0xff;
        this.count += 1;
        if (this.count === this.blockSize) {
            keccakState.p1600(this.state);
            this.count = 0;
        }
    }
    return output;
};
Keccak.prototype.copy = function(dest) {
    for(let i = 0; i < 50; ++i)dest.state[i] = this.state[i];
    dest.blockSize = this.blockSize;
    dest.count = this.count;
    dest.squeezing = this.squeezing;
};
module.exports = Keccak;

},{"42eada955bd40f08":"l5Twm","4a8c1cafa4e399e7":"1rQIQ"}],"1rQIQ":[function(require,module,exports) {
const P1600_ROUND_CONSTANTS = [
    1,
    0,
    32898,
    0,
    32906,
    2147483648,
    2147516416,
    2147483648,
    32907,
    0,
    2147483649,
    0,
    2147516545,
    2147483648,
    32777,
    2147483648,
    138,
    0,
    136,
    0,
    2147516425,
    0,
    2147483658,
    0,
    2147516555,
    0,
    139,
    2147483648,
    32905,
    2147483648,
    32771,
    2147483648,
    32770,
    2147483648,
    128,
    2147483648,
    32778,
    0,
    2147483658,
    2147483648,
    2147516545,
    2147483648,
    32896,
    2147483648,
    2147483649,
    0,
    2147516424,
    2147483648
];
exports.p1600 = function(s) {
    for(let round = 0; round < 24; ++round){
        // theta
        const lo0 = s[0] ^ s[10] ^ s[20] ^ s[30] ^ s[40];
        const hi0 = s[1] ^ s[11] ^ s[21] ^ s[31] ^ s[41];
        const lo1 = s[2] ^ s[12] ^ s[22] ^ s[32] ^ s[42];
        const hi1 = s[3] ^ s[13] ^ s[23] ^ s[33] ^ s[43];
        const lo2 = s[4] ^ s[14] ^ s[24] ^ s[34] ^ s[44];
        const hi2 = s[5] ^ s[15] ^ s[25] ^ s[35] ^ s[45];
        const lo3 = s[6] ^ s[16] ^ s[26] ^ s[36] ^ s[46];
        const hi3 = s[7] ^ s[17] ^ s[27] ^ s[37] ^ s[47];
        const lo4 = s[8] ^ s[18] ^ s[28] ^ s[38] ^ s[48];
        const hi4 = s[9] ^ s[19] ^ s[29] ^ s[39] ^ s[49];
        let lo = lo4 ^ (lo1 << 1 | hi1 >>> 31);
        let hi = hi4 ^ (hi1 << 1 | lo1 >>> 31);
        const t1slo0 = s[0] ^ lo;
        const t1shi0 = s[1] ^ hi;
        const t1slo5 = s[10] ^ lo;
        const t1shi5 = s[11] ^ hi;
        const t1slo10 = s[20] ^ lo;
        const t1shi10 = s[21] ^ hi;
        const t1slo15 = s[30] ^ lo;
        const t1shi15 = s[31] ^ hi;
        const t1slo20 = s[40] ^ lo;
        const t1shi20 = s[41] ^ hi;
        lo = lo0 ^ (lo2 << 1 | hi2 >>> 31);
        hi = hi0 ^ (hi2 << 1 | lo2 >>> 31);
        const t1slo1 = s[2] ^ lo;
        const t1shi1 = s[3] ^ hi;
        const t1slo6 = s[12] ^ lo;
        const t1shi6 = s[13] ^ hi;
        const t1slo11 = s[22] ^ lo;
        const t1shi11 = s[23] ^ hi;
        const t1slo16 = s[32] ^ lo;
        const t1shi16 = s[33] ^ hi;
        const t1slo21 = s[42] ^ lo;
        const t1shi21 = s[43] ^ hi;
        lo = lo1 ^ (lo3 << 1 | hi3 >>> 31);
        hi = hi1 ^ (hi3 << 1 | lo3 >>> 31);
        const t1slo2 = s[4] ^ lo;
        const t1shi2 = s[5] ^ hi;
        const t1slo7 = s[14] ^ lo;
        const t1shi7 = s[15] ^ hi;
        const t1slo12 = s[24] ^ lo;
        const t1shi12 = s[25] ^ hi;
        const t1slo17 = s[34] ^ lo;
        const t1shi17 = s[35] ^ hi;
        const t1slo22 = s[44] ^ lo;
        const t1shi22 = s[45] ^ hi;
        lo = lo2 ^ (lo4 << 1 | hi4 >>> 31);
        hi = hi2 ^ (hi4 << 1 | lo4 >>> 31);
        const t1slo3 = s[6] ^ lo;
        const t1shi3 = s[7] ^ hi;
        const t1slo8 = s[16] ^ lo;
        const t1shi8 = s[17] ^ hi;
        const t1slo13 = s[26] ^ lo;
        const t1shi13 = s[27] ^ hi;
        const t1slo18 = s[36] ^ lo;
        const t1shi18 = s[37] ^ hi;
        const t1slo23 = s[46] ^ lo;
        const t1shi23 = s[47] ^ hi;
        lo = lo3 ^ (lo0 << 1 | hi0 >>> 31);
        hi = hi3 ^ (hi0 << 1 | lo0 >>> 31);
        const t1slo4 = s[8] ^ lo;
        const t1shi4 = s[9] ^ hi;
        const t1slo9 = s[18] ^ lo;
        const t1shi9 = s[19] ^ hi;
        const t1slo14 = s[28] ^ lo;
        const t1shi14 = s[29] ^ hi;
        const t1slo19 = s[38] ^ lo;
        const t1shi19 = s[39] ^ hi;
        const t1slo24 = s[48] ^ lo;
        const t1shi24 = s[49] ^ hi;
        // rho & pi
        const t2slo0 = t1slo0;
        const t2shi0 = t1shi0;
        const t2slo16 = t1shi5 << 4 | t1slo5 >>> 28;
        const t2shi16 = t1slo5 << 4 | t1shi5 >>> 28;
        const t2slo7 = t1slo10 << 3 | t1shi10 >>> 29;
        const t2shi7 = t1shi10 << 3 | t1slo10 >>> 29;
        const t2slo23 = t1shi15 << 9 | t1slo15 >>> 23;
        const t2shi23 = t1slo15 << 9 | t1shi15 >>> 23;
        const t2slo14 = t1slo20 << 18 | t1shi20 >>> 14;
        const t2shi14 = t1shi20 << 18 | t1slo20 >>> 14;
        const t2slo10 = t1slo1 << 1 | t1shi1 >>> 31;
        const t2shi10 = t1shi1 << 1 | t1slo1 >>> 31;
        const t2slo1 = t1shi6 << 12 | t1slo6 >>> 20;
        const t2shi1 = t1slo6 << 12 | t1shi6 >>> 20;
        const t2slo17 = t1slo11 << 10 | t1shi11 >>> 22;
        const t2shi17 = t1shi11 << 10 | t1slo11 >>> 22;
        const t2slo8 = t1shi16 << 13 | t1slo16 >>> 19;
        const t2shi8 = t1slo16 << 13 | t1shi16 >>> 19;
        const t2slo24 = t1slo21 << 2 | t1shi21 >>> 30;
        const t2shi24 = t1shi21 << 2 | t1slo21 >>> 30;
        const t2slo20 = t1shi2 << 30 | t1slo2 >>> 2;
        const t2shi20 = t1slo2 << 30 | t1shi2 >>> 2;
        const t2slo11 = t1slo7 << 6 | t1shi7 >>> 26;
        const t2shi11 = t1shi7 << 6 | t1slo7 >>> 26;
        const t2slo2 = t1shi12 << 11 | t1slo12 >>> 21;
        const t2shi2 = t1slo12 << 11 | t1shi12 >>> 21;
        const t2slo18 = t1slo17 << 15 | t1shi17 >>> 17;
        const t2shi18 = t1shi17 << 15 | t1slo17 >>> 17;
        const t2slo9 = t1shi22 << 29 | t1slo22 >>> 3;
        const t2shi9 = t1slo22 << 29 | t1shi22 >>> 3;
        const t2slo5 = t1slo3 << 28 | t1shi3 >>> 4;
        const t2shi5 = t1shi3 << 28 | t1slo3 >>> 4;
        const t2slo21 = t1shi8 << 23 | t1slo8 >>> 9;
        const t2shi21 = t1slo8 << 23 | t1shi8 >>> 9;
        const t2slo12 = t1slo13 << 25 | t1shi13 >>> 7;
        const t2shi12 = t1shi13 << 25 | t1slo13 >>> 7;
        const t2slo3 = t1slo18 << 21 | t1shi18 >>> 11;
        const t2shi3 = t1shi18 << 21 | t1slo18 >>> 11;
        const t2slo19 = t1shi23 << 24 | t1slo23 >>> 8;
        const t2shi19 = t1slo23 << 24 | t1shi23 >>> 8;
        const t2slo15 = t1slo4 << 27 | t1shi4 >>> 5;
        const t2shi15 = t1shi4 << 27 | t1slo4 >>> 5;
        const t2slo6 = t1slo9 << 20 | t1shi9 >>> 12;
        const t2shi6 = t1shi9 << 20 | t1slo9 >>> 12;
        const t2slo22 = t1shi14 << 7 | t1slo14 >>> 25;
        const t2shi22 = t1slo14 << 7 | t1shi14 >>> 25;
        const t2slo13 = t1slo19 << 8 | t1shi19 >>> 24;
        const t2shi13 = t1shi19 << 8 | t1slo19 >>> 24;
        const t2slo4 = t1slo24 << 14 | t1shi24 >>> 18;
        const t2shi4 = t1shi24 << 14 | t1slo24 >>> 18;
        // chi
        s[0] = t2slo0 ^ ~t2slo1 & t2slo2;
        s[1] = t2shi0 ^ ~t2shi1 & t2shi2;
        s[10] = t2slo5 ^ ~t2slo6 & t2slo7;
        s[11] = t2shi5 ^ ~t2shi6 & t2shi7;
        s[20] = t2slo10 ^ ~t2slo11 & t2slo12;
        s[21] = t2shi10 ^ ~t2shi11 & t2shi12;
        s[30] = t2slo15 ^ ~t2slo16 & t2slo17;
        s[31] = t2shi15 ^ ~t2shi16 & t2shi17;
        s[40] = t2slo20 ^ ~t2slo21 & t2slo22;
        s[41] = t2shi20 ^ ~t2shi21 & t2shi22;
        s[2] = t2slo1 ^ ~t2slo2 & t2slo3;
        s[3] = t2shi1 ^ ~t2shi2 & t2shi3;
        s[12] = t2slo6 ^ ~t2slo7 & t2slo8;
        s[13] = t2shi6 ^ ~t2shi7 & t2shi8;
        s[22] = t2slo11 ^ ~t2slo12 & t2slo13;
        s[23] = t2shi11 ^ ~t2shi12 & t2shi13;
        s[32] = t2slo16 ^ ~t2slo17 & t2slo18;
        s[33] = t2shi16 ^ ~t2shi17 & t2shi18;
        s[42] = t2slo21 ^ ~t2slo22 & t2slo23;
        s[43] = t2shi21 ^ ~t2shi22 & t2shi23;
        s[4] = t2slo2 ^ ~t2slo3 & t2slo4;
        s[5] = t2shi2 ^ ~t2shi3 & t2shi4;
        s[14] = t2slo7 ^ ~t2slo8 & t2slo9;
        s[15] = t2shi7 ^ ~t2shi8 & t2shi9;
        s[24] = t2slo12 ^ ~t2slo13 & t2slo14;
        s[25] = t2shi12 ^ ~t2shi13 & t2shi14;
        s[34] = t2slo17 ^ ~t2slo18 & t2slo19;
        s[35] = t2shi17 ^ ~t2shi18 & t2shi19;
        s[44] = t2slo22 ^ ~t2slo23 & t2slo24;
        s[45] = t2shi22 ^ ~t2shi23 & t2shi24;
        s[6] = t2slo3 ^ ~t2slo4 & t2slo0;
        s[7] = t2shi3 ^ ~t2shi4 & t2shi0;
        s[16] = t2slo8 ^ ~t2slo9 & t2slo5;
        s[17] = t2shi8 ^ ~t2shi9 & t2shi5;
        s[26] = t2slo13 ^ ~t2slo14 & t2slo10;
        s[27] = t2shi13 ^ ~t2shi14 & t2shi10;
        s[36] = t2slo18 ^ ~t2slo19 & t2slo15;
        s[37] = t2shi18 ^ ~t2shi19 & t2shi15;
        s[46] = t2slo23 ^ ~t2slo24 & t2slo20;
        s[47] = t2shi23 ^ ~t2shi24 & t2shi20;
        s[8] = t2slo4 ^ ~t2slo0 & t2slo1;
        s[9] = t2shi4 ^ ~t2shi0 & t2shi1;
        s[18] = t2slo9 ^ ~t2slo5 & t2slo6;
        s[19] = t2shi9 ^ ~t2shi5 & t2shi6;
        s[28] = t2slo14 ^ ~t2slo10 & t2slo11;
        s[29] = t2shi14 ^ ~t2shi10 & t2shi11;
        s[38] = t2slo19 ^ ~t2slo15 & t2slo16;
        s[39] = t2shi19 ^ ~t2shi15 & t2shi16;
        s[48] = t2slo24 ^ ~t2slo20 & t2slo21;
        s[49] = t2shi24 ^ ~t2shi20 & t2shi21;
        // iota
        s[0] ^= P1600_ROUND_CONSTANTS[round * 2];
        s[1] ^= P1600_ROUND_CONSTANTS[round * 2 + 1];
    }
};

},{}],"btbjS":[function(require,module,exports) {
!function(e, t) {
    module.exports = t();
}(this, function() {
    return function(e) {
        var t = {};
        function n(i) {
            if (t[i]) return t[i].exports;
            var r = t[i] = {
                i: i,
                l: !1,
                exports: {}
            };
            return e[i].call(r.exports, r, r.exports, n), r.l = !0, r.exports;
        }
        return n.m = e, n.c = t, n.d = function(e, t, i) {
            n.o(e, t) || Object.defineProperty(e, t, {
                enumerable: !0,
                get: i
            });
        }, n.r = function(e) {
            "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
                value: "Module"
            }), Object.defineProperty(e, "__esModule", {
                value: !0
            });
        }, n.t = function(e, t) {
            if (1 & t && (e = n(e)), 8 & t) return e;
            if (4 & t && "object" == typeof e && e && e.__esModule) return e;
            var i = Object.create(null);
            if (n.r(i), Object.defineProperty(i, "default", {
                enumerable: !0,
                value: e
            }), 2 & t && "string" != typeof e) for(var r in e)n.d(i, r, (function(t) {
                return e[t];
            }).bind(null, r));
            return i;
        }, n.n = function(e) {
            var t = e && e.__esModule ? function() {
                return e.default;
            } : function() {
                return e;
            };
            return n.d(t, "a", t), t;
        }, n.o = function(e, t) {
            return Object.prototype.hasOwnProperty.call(e, t);
        }, n.p = "", n(n.s = 25);
    }([
        function(e, t, n) {
            "use strict";
            n.r(t), n.d(t, "__extends", function() {
                return r;
            }), n.d(t, "__assign", function() {
                return M;
            }), n.d(t, "__rest", function() {
                return u;
            }), n.d(t, "__decorate", function() {
                return o;
            }), n.d(t, "__param", function() {
                return c;
            }), n.d(t, "__metadata", function() {
                return a;
            }), n.d(t, "__awaiter", function() {
                return I;
            }), n.d(t, "__generator", function() {
                return l;
            }), n.d(t, "__createBinding", function() {
                return N;
            }), n.d(t, "__exportStar", function() {
                return j;
            }), n.d(t, "__values", function() {
                return g;
            }), n.d(t, "__read", function() {
                return s;
            }), n.d(t, "__spread", function() {
                return A;
            }), n.d(t, "__spreadArrays", function() {
                return D;
            }), n.d(t, "__spreadArray", function() {
                return d;
            }), n.d(t, "__await", function() {
                return T;
            }), n.d(t, "__asyncGenerator", function() {
                return y;
            }), n.d(t, "__asyncDelegator", function() {
                return z;
            }), n.d(t, "__asyncValues", function() {
                return w;
            }), n.d(t, "__makeTemplateObject", function() {
                return f;
            }), n.d(t, "__importStar", function() {
                return E;
            }), n.d(t, "__importDefault", function() {
                return C;
            }), n.d(t, "__classPrivateFieldGet", function() {
                return x;
            }), n.d(t, "__classPrivateFieldSet", function() {
                return p;
            });
            /*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ var i = function(e, t) {
                return (i = Object.setPrototypeOf || ({
                    __proto__: []
                }) instanceof Array && function(e, t) {
                    e.__proto__ = t;
                } || function(e, t) {
                    for(var n in t)Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
                })(e, t);
            };
            function r(e, t) {
                if ("function" != typeof t && null !== t) throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");
                function n() {
                    this.constructor = e;
                }
                i(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n);
            }
            var M = function() {
                return (M = Object.assign || function(e) {
                    for(var t, n = 1, i = arguments.length; n < i; n++)for(var r in t = arguments[n])Object.prototype.hasOwnProperty.call(t, r) && (e[r] = t[r]);
                    return e;
                }).apply(this, arguments);
            };
            function u(e, t) {
                var n = {};
                for(var i in e)Object.prototype.hasOwnProperty.call(e, i) && t.indexOf(i) < 0 && (n[i] = e[i]);
                if (null != e && "function" == typeof Object.getOwnPropertySymbols) {
                    var r = 0;
                    for(i = Object.getOwnPropertySymbols(e); r < i.length; r++)t.indexOf(i[r]) < 0 && Object.prototype.propertyIsEnumerable.call(e, i[r]) && (n[i[r]] = e[i[r]]);
                }
                return n;
            }
            function o(e, t, n, i) {
                var r, M = arguments.length, u = M < 3 ? t : null === i ? i = Object.getOwnPropertyDescriptor(t, n) : i;
                if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) u = Reflect.decorate(e, t, n, i);
                else for(var o = e.length - 1; o >= 0; o--)(r = e[o]) && (u = (M < 3 ? r(u) : M > 3 ? r(t, n, u) : r(t, n)) || u);
                return M > 3 && u && Object.defineProperty(t, n, u), u;
            }
            function c(e, t) {
                return function(n, i) {
                    t(n, i, e);
                };
            }
            function a(e, t) {
                if ("object" == typeof Reflect && "function" == typeof Reflect.metadata) return Reflect.metadata(e, t);
            }
            function I(e, t, n, i) {
                return new (n || (n = Promise))(function(r, M) {
                    function u(e) {
                        try {
                            c(i.next(e));
                        } catch (e) {
                            M(e);
                        }
                    }
                    function o(e) {
                        try {
                            c(i.throw(e));
                        } catch (e) {
                            M(e);
                        }
                    }
                    function c(e) {
                        var t;
                        e.done ? r(e.value) : (t = e.value, t instanceof n ? t : new n(function(e) {
                            e(t);
                        })).then(u, o);
                    }
                    c((i = i.apply(e, t || [])).next());
                });
            }
            function l(e, t) {
                var n, i, r, M, u = {
                    label: 0,
                    sent: function() {
                        if (1 & r[0]) throw r[1];
                        return r[1];
                    },
                    trys: [],
                    ops: []
                };
                return M = {
                    next: o(0),
                    throw: o(1),
                    return: o(2)
                }, "function" == typeof Symbol && (M[Symbol.iterator] = function() {
                    return this;
                }), M;
                function o(M) {
                    return function(o) {
                        return function(M) {
                            if (n) throw new TypeError("Generator is already executing.");
                            for(; u;)try {
                                if (n = 1, i && (r = 2 & M[0] ? i.return : M[0] ? i.throw || ((r = i.return) && r.call(i), 0) : i.next) && !(r = r.call(i, M[1])).done) return r;
                                switch(i = 0, r && (M = [
                                    2 & M[0],
                                    r.value
                                ]), M[0]){
                                    case 0:
                                    case 1:
                                        r = M;
                                        break;
                                    case 4:
                                        return u.label++, {
                                            value: M[1],
                                            done: !1
                                        };
                                    case 5:
                                        u.label++, i = M[1], M = [
                                            0
                                        ];
                                        continue;
                                    case 7:
                                        M = u.ops.pop(), u.trys.pop();
                                        continue;
                                    default:
                                        if (!(r = u.trys, (r = r.length > 0 && r[r.length - 1]) || 6 !== M[0] && 2 !== M[0])) {
                                            u = 0;
                                            continue;
                                        }
                                        if (3 === M[0] && (!r || M[1] > r[0] && M[1] < r[3])) {
                                            u.label = M[1];
                                            break;
                                        }
                                        if (6 === M[0] && u.label < r[1]) {
                                            u.label = r[1], r = M;
                                            break;
                                        }
                                        if (r && u.label < r[2]) {
                                            u.label = r[2], u.ops.push(M);
                                            break;
                                        }
                                        r[2] && u.ops.pop(), u.trys.pop();
                                        continue;
                                }
                                M = t.call(e, u);
                            } catch (e) {
                                M = [
                                    6,
                                    e
                                ], i = 0;
                            } finally{
                                n = r = 0;
                            }
                            if (5 & M[0]) throw M[1];
                            return {
                                value: M[0] ? M[1] : void 0,
                                done: !0
                            };
                        }([
                            M,
                            o
                        ]);
                    };
                }
            }
            var N = Object.create ? function(e, t, n, i) {
                void 0 === i && (i = n), Object.defineProperty(e, i, {
                    enumerable: !0,
                    get: function() {
                        return t[n];
                    }
                });
            } : function(e, t, n, i) {
                void 0 === i && (i = n), e[i] = t[n];
            };
            function j(e, t) {
                for(var n in e)"default" === n || Object.prototype.hasOwnProperty.call(t, n) || N(t, e, n);
            }
            function g(e) {
                var t = "function" == typeof Symbol && Symbol.iterator, n = t && e[t], i = 0;
                if (n) return n.call(e);
                if (e && "number" == typeof e.length) return {
                    next: function() {
                        return e && i >= e.length && (e = void 0), {
                            value: e && e[i++],
                            done: !e
                        };
                    }
                };
                throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
            }
            function s(e, t) {
                var n = "function" == typeof Symbol && e[Symbol.iterator];
                if (!n) return e;
                var i, r, M = n.call(e), u = [];
                try {
                    for(; (void 0 === t || t-- > 0) && !(i = M.next()).done;)u.push(i.value);
                } catch (e) {
                    r = {
                        error: e
                    };
                } finally{
                    try {
                        i && !i.done && (n = M.return) && n.call(M);
                    } finally{
                        if (r) throw r.error;
                    }
                }
                return u;
            }
            function A() {
                for(var e = [], t = 0; t < arguments.length; t++)e = e.concat(s(arguments[t]));
                return e;
            }
            function D() {
                for(var e = 0, t = 0, n = arguments.length; t < n; t++)e += arguments[t].length;
                var i = Array(e), r = 0;
                for(t = 0; t < n; t++)for(var M = arguments[t], u = 0, o = M.length; u < o; u++, r++)i[r] = M[u];
                return i;
            }
            function d(e, t, n) {
                if (n || 2 === arguments.length) for(var i, r = 0, M = t.length; r < M; r++)!i && r in t || (i || (i = Array.prototype.slice.call(t, 0, r)), i[r] = t[r]);
                return e.concat(i || Array.prototype.slice.call(t));
            }
            function T(e) {
                return this instanceof T ? (this.v = e, this) : new T(e);
            }
            function y(e, t, n) {
                if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
                var i, r = n.apply(e, t || []), M = [];
                return i = {}, u("next"), u("throw"), u("return"), i[Symbol.asyncIterator] = function() {
                    return this;
                }, i;
                function u(e) {
                    r[e] && (i[e] = function(t) {
                        return new Promise(function(n, i) {
                            M.push([
                                e,
                                t,
                                n,
                                i
                            ]) > 1 || o(e, t);
                        });
                    });
                }
                function o(e, t) {
                    try {
                        (n = r[e](t)).value instanceof T ? Promise.resolve(n.value.v).then(c, a) : I(M[0][2], n);
                    } catch (e) {
                        I(M[0][3], e);
                    }
                    var n;
                }
                function c(e) {
                    o("next", e);
                }
                function a(e) {
                    o("throw", e);
                }
                function I(e, t) {
                    e(t), M.shift(), M.length && o(M[0][0], M[0][1]);
                }
            }
            function z(e) {
                var t, n;
                return t = {}, i("next"), i("throw", function(e) {
                    throw e;
                }), i("return"), t[Symbol.iterator] = function() {
                    return this;
                }, t;
                function i(i, r) {
                    t[i] = e[i] ? function(t) {
                        return (n = !n) ? {
                            value: T(e[i](t)),
                            done: "return" === i
                        } : r ? r(t) : t;
                    } : r;
                }
            }
            function w(e) {
                if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
                var t, n = e[Symbol.asyncIterator];
                return n ? n.call(e) : (e = g(e), t = {}, i("next"), i("throw"), i("return"), t[Symbol.asyncIterator] = function() {
                    return this;
                }, t);
                function i(n) {
                    t[n] = e[n] && function(t) {
                        return new Promise(function(i, r) {
                            (function(e, t, n, i) {
                                Promise.resolve(i).then(function(t) {
                                    e({
                                        value: t,
                                        done: n
                                    });
                                }, t);
                            })(i, r, (t = e[n](t)).done, t.value);
                        });
                    };
                }
            }
            function f(e, t) {
                return Object.defineProperty ? Object.defineProperty(e, "raw", {
                    value: t
                }) : e.raw = t, e;
            }
            var L = Object.create ? function(e, t) {
                Object.defineProperty(e, "default", {
                    enumerable: !0,
                    value: t
                });
            } : function(e, t) {
                e.default = t;
            };
            function E(e) {
                if (e && e.__esModule) return e;
                var t = {};
                if (null != e) for(var n in e)"default" !== n && Object.prototype.hasOwnProperty.call(e, n) && N(t, e, n);
                return L(t, e), t;
            }
            function C(e) {
                return e && e.__esModule ? e : {
                    default: e
                };
            }
            function x(e, t, n, i) {
                if ("a" === n && !i) throw new TypeError("Private accessor was defined without a getter");
                if ("function" == typeof t ? e !== t || !i : !t.has(e)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
                return "m" === n ? i : "a" === n ? i.call(e) : i ? i.value : t.get(e);
            }
            function p(e, t, n, i, r) {
                if ("m" === i) throw new TypeError("Private method is not writable");
                if ("a" === i && !r) throw new TypeError("Private accessor was defined without a setter");
                if ("function" == typeof t ? e !== t || !r : !t.has(e)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
                return "a" === i ? r.call(e, n) : r ? r.value = n : t.set(e, n), n;
            }
        },
        function(e, t, n) {
            "use strict";
            e.exports = n(27);
        },
        function(e, t, n) {
            "use strict";
            Object.defineProperty(t, "__esModule", {
                value: !0
            });
            var i = n(0);
            i.__exportStar(n(34), t), i.__exportStar(n(35), t), i.__exportStar(n(36), t), i.__exportStar(n(37), t);
        },
        function(e, t, n) {
            "use strict";
            Object.defineProperty(t, "__esModule", {
                value: !0
            });
            var i = n(0);
            i.__exportStar(n(32), t), i.__exportStar(n(110), t), i.__exportStar(n(10), t);
        },
        function(e, t, n) {
            "use strict";
            var i;
            Object.defineProperty(t, "__esModule", {
                value: !0
            }), t.themesList = void 0;
            var r = n(0), M = r.__importDefault(n(38)), u = r.__importDefault(n(39));
            t.themesList = ((i = {
                default: M.default
            })[M.default.name] = M.default, i[u.default.name] = u.default, i);
        },
        function(e, t, n) {
            "use strict";
            Object.defineProperty(t, "__esModule", {
                value: !0
            }), t.providers = t.injected = t.connectors = void 0;
            var i = n(0), r = i.__importStar(n(40));
            t.connectors = r;
            var M = i.__importStar(n(12));
            t.injected = M;
            var u = i.__importStar(n(94));
            t.providers = u;
        },
        function(e, t, n) {
            "use strict";
            e.exports = n(115);
        },
        function(e, t, n) {
            "use strict";
            var i = n(116), r = {
                childContextTypes: !0,
                contextType: !0,
                contextTypes: !0,
                defaultProps: !0,
                displayName: !0,
                getDefaultProps: !0,
                getDerivedStateFromError: !0,
                getDerivedStateFromProps: !0,
                mixins: !0,
                propTypes: !0,
                type: !0
            }, M = {
                name: !0,
                length: !0,
                prototype: !0,
                caller: !0,
                callee: !0,
                arguments: !0,
                arity: !0
            }, u = {
                $$typeof: !0,
                compare: !0,
                defaultProps: !0,
                displayName: !0,
                propTypes: !0,
                type: !0
            }, o = {};
            function c(e) {
                return i.isMemo(e) ? u : o[e.$$typeof] || r;
            }
            o[i.ForwardRef] = {
                $$typeof: !0,
                render: !0,
                defaultProps: !0,
                displayName: !0,
                propTypes: !0
            }, o[i.Memo] = u;
            var a = Object.defineProperty, I = Object.getOwnPropertyNames, l = Object.getOwnPropertySymbols, N = Object.getOwnPropertyDescriptor, j = Object.getPrototypeOf, g = Object.prototype;
            e.exports = function e(t, n, i) {
                if ("string" != typeof n) {
                    if (g) {
                        var r = j(n);
                        r && r !== g && e(t, r, i);
                    }
                    var u = I(n);
                    l && (u = u.concat(l(n)));
                    for(var o = c(t), s = c(n), A = 0; A < u.length; ++A){
                        var D = u[A];
                        if (!(M[D] || i && i[D] || s && s[D] || o && o[D])) {
                            var d = N(n, D);
                            try {
                                a(t, D, d);
                            } catch (e) {}
                        }
                    }
                }
                return t;
            };
        },
        function(e, t, n) {
            "use strict";
            var i = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|download|draggable|encType|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|inert|itemProp|itemScope|itemType|itemID|itemRef|on|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/, r = function(e) {
                var t = {};
                return function(n) {
                    return void 0 === t[n] && (t[n] = e(n)), t[n];
                };
            }(function(e) {
                return i.test(e) || 111 === e.charCodeAt(0) && 110 === e.charCodeAt(1) && e.charCodeAt(2) < 91;
            });
            t.a = r;
        },
        function(e, t, n) {
            "use strict";
            /*
object-assign
(c) Sindre Sorhus
@license MIT
*/ var i = Object.getOwnPropertySymbols, r = Object.prototype.hasOwnProperty, M = Object.prototype.propertyIsEnumerable;
            function u(e) {
                if (null == e) throw new TypeError("Object.assign cannot be called with null or undefined");
                return Object(e);
            }
            e.exports = function() {
                try {
                    if (!Object.assign) return !1;
                    var e = new String("abc");
                    if (e[5] = "de", "5" === Object.getOwnPropertyNames(e)[0]) return !1;
                    for(var t = {}, n = 0; n < 10; n++)t["_" + String.fromCharCode(n)] = n;
                    if ("0123456789" !== Object.getOwnPropertyNames(t).map(function(e) {
                        return t[e];
                    }).join("")) return !1;
                    var i = {};
                    return "abcdefghijklmnopqrst".split("").forEach(function(e) {
                        i[e] = e;
                    }), "abcdefghijklmnopqrst" === Object.keys(Object.assign({}, i)).join("");
                } catch (e) {
                    return !1;
                }
            }() ? Object.assign : function(e, t) {
                for(var n, o, c = u(e), a = 1; a < arguments.length; a++){
                    for(var I in n = Object(arguments[a]))r.call(n, I) && (c[I] = n[I]);
                    if (i) {
                        o = i(n);
                        for(var l = 0; l < o.length; l++)M.call(n, o[l]) && (c[o[l]] = n[o[l]]);
                    }
                }
                return c;
            };
        },
        function(e, t, n) {
            "use strict";
            Object.defineProperty(t, "__esModule", {
                value: !0
            }), t.isLocalStorageAvailable = t.findMatchingRequiredOptions = t.getThemeColors = t.getChainId = t.filterProviderChecks = t.filterProviders = t.filterMatches = t.getProviderDescription = t.isMobile = t.getProviderInfoByCheck = t.getProviderInfoById = t.getProviderInfoByName = t.getProviderInfoFromChecksArray = t.getProviderInfo = t.getInjectedProviderName = t.getInjectedProvider = t.verifyInjectedProvider = t.checkInjectedProviders = void 0;
            var i = n(0).__importStar(n(33)), r = n(2), M = n(4), u = n(5);
            function o() {
                var e = {
                    injectedAvailable: !!window.ethereum || !!window.web3
                };
                if (e.injectedAvailable) {
                    var t = !0;
                    Object.values(u.injected).forEach(function(n) {
                        c(n.check) && (e[n.check] = !0, t = !1);
                    });
                    var n = i.detect();
                    n && "opera" === n.name && (e[u.injected.OPERA.check] = !0, t = !1), t && (e[u.injected.FALLBACK.check] = !0);
                }
                return e;
            }
            function c(e) {
                return window.ethereum ? window.ethereum[e] : window.web3 && window.web3.currentProvider && window.web3.currentProvider[e];
            }
            function a() {
                var e = null, t = o();
                t.injectedAvailable && (delete t.injectedAvailable, e = I(Object.keys(t)));
                return e;
            }
            function I(e) {
                return N("check", j(e));
            }
            function l(e, t, n) {
                var i = n, r = e.filter(t);
                return r && r.length && (i = r[0]), i;
            }
            function N(e, t) {
                return t && l(Object.values(u.providers), function(n) {
                    return n[e] === t;
                }, u.providers.FALLBACK) || u.providers.FALLBACK;
            }
            function j(e) {
                return e && e.length ? e.length > 1 && (e[0] === u.injected.METAMASK.check || e[0] === u.injected.CIPHER.check) ? e[1] : e[0] : u.providers.FALLBACK.check;
            }
            t.checkInjectedProviders = o, t.verifyInjectedProvider = c, t.getInjectedProvider = a, t.getInjectedProviderName = function() {
                var e = a();
                return e ? e.name : null;
            }, t.getProviderInfo = function(e) {
                return e ? I(Object.values(u.providers).filter(function(t) {
                    return e[t.check];
                }).map(function(e) {
                    return e.check;
                })) : u.providers.FALLBACK;
            }, t.getProviderInfoFromChecksArray = I, t.getProviderInfoByName = function(e) {
                return N("name", e);
            }, t.getProviderInfoById = function(e) {
                return N("id", e);
            }, t.getProviderInfoByCheck = function(e) {
                return N("check", e);
            }, t.isMobile = function() {
                return !(!/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(navigator.userAgent) && !/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw-(n|u)|c55\/|capi|ccwa|cdm-|cell|chtm|cldc|cmd-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc-s|devi|dica|dmob|do(c|p)o|ds(12|-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(-|_)|g1 u|g560|gene|gf-5|g-mo|go(.w|od)|gr(ad|un)|haie|hcit|hd-(m|p|t)|hei-|hi(pt|ta)|hp( i|ip)|hs-c|ht(c(-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i-(20|go|ma)|i230|iac( |-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|-[a-w])|libw|lynx|m1-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|-([1-8]|c))|phil|pire|pl(ay|uc)|pn-2|po(ck|rt|se)|prox|psio|pt-g|qa-a|qc(07|12|21|32|60|-[2-7]|i-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h-|oo|p-)|sdk\/|se(c(-|0|1)|47|mc|nd|ri)|sgh-|shar|sie(-|m)|sk-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h-|v-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl-|tdg-|tel(i|m)|tim-|t-mo|to(pl|sh)|ts(70|-|m3|m5)|tx-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas-|your|zeto|zte-/i.test(navigator.userAgent.substr(0, 4)) && !function() {
                    try {
                        return document.createEvent("TouchEvent"), !0;
                    } catch (e) {
                        return !1;
                    }
                }());
            }, t.getProviderDescription = function(e) {
                if (e.description) return e.description;
                var t = "";
                switch(e.type){
                    case "injected":
                        t = "Connect to your " + e.name + " Wallet";
                        break;
                    case "web":
                        t = "Connect with your " + e.name + " account";
                        break;
                    case "qrcode":
                        t = "Scan with " + e.name + " to connect";
                        break;
                    case "hardware":
                        t = "Connect to your " + e.name + " Hardware Wallet";
                }
                return t;
            }, t.filterMatches = l, t.filterProviders = N, t.filterProviderChecks = j, t.getChainId = function(e) {
                var t = l(Object.values(r.CHAIN_DATA_LIST), function(t) {
                    return t.network === e;
                }, void 0);
                if (!t) throw new Error("No chainId found match " + e);
                return t.chainId;
            }, t.getThemeColors = function(e) {
                return "string" == typeof e ? M.themesList[e].colors : e;
            }, t.findMatchingRequiredOptions = function e(t, n) {
                return t.filter(function(t) {
                    if ("string" == typeof t) return t in n;
                    var i = e(t, n);
                    return i && i.length;
                });
            }, t.isLocalStorageAvailable = function() {
                try {
                    return localStorage.setItem("test", "test"), localStorage.removeItem("test"), !0;
                } catch (e) {
                    return !1;
                }
            };
        },
        function(e, t) {
            var n, i, r = e.exports = {};
            function M() {
                throw new Error("setTimeout has not been defined");
            }
            function u() {
                throw new Error("clearTimeout has not been defined");
            }
            function o(e) {
                if (n === setTimeout) return setTimeout(e, 0);
                if ((n === M || !n) && setTimeout) return n = setTimeout, setTimeout(e, 0);
                try {
                    return n(e, 0);
                } catch (t) {
                    try {
                        return n.call(null, e, 0);
                    } catch (t) {
                        return n.call(this, e, 0);
                    }
                }
            }
            !function() {
                try {
                    n = "function" == typeof setTimeout ? setTimeout : M;
                } catch (e) {
                    n = M;
                }
                try {
                    i = "function" == typeof clearTimeout ? clearTimeout : u;
                } catch (e) {
                    i = u;
                }
            }();
            var c, a = [], I = !1, l = -1;
            function N() {
                I && c && (I = !1, c.length ? a = c.concat(a) : l = -1, a.length && j());
            }
            function j() {
                if (!I) {
                    var e = o(N);
                    I = !0;
                    for(var t = a.length; t;){
                        for(c = a, a = []; ++l < t;)c && c[l].run();
                        l = -1, t = a.length;
                    }
                    c = null, I = !1, function(e) {
                        if (i === clearTimeout) return clearTimeout(e);
                        if ((i === u || !i) && clearTimeout) return i = clearTimeout, clearTimeout(e);
                        try {
                            i(e);
                        } catch (t) {
                            try {
                                return i.call(null, e);
                            } catch (t) {
                                return i.call(this, e);
                            }
                        }
                    }(e);
                }
            }
            function g(e, t) {
                this.fun = e, this.array = t;
            }
            function s() {}
            r.nextTick = function(e) {
                var t = new Array(arguments.length - 1);
                if (arguments.length > 1) for(var n = 1; n < arguments.length; n++)t[n - 1] = arguments[n];
                a.push(new g(e, t)), 1 !== a.length || I || o(j);
            }, g.prototype.run = function() {
                this.fun.apply(null, this.array);
            }, r.title = "browser", r.browser = !0, r.env = {}, r.argv = [], r.version = "", r.versions = {}, r.on = s, r.addListener = s, r.once = s, r.off = s, r.removeListener = s, r.removeAllListeners = s, r.emit = s, r.prependListener = s, r.prependOnceListener = s, r.listeners = function(e) {
                return [];
            }, r.binding = function(e) {
                throw new Error("process.binding is not supported");
            }, r.cwd = function() {
                return "/";
            }, r.chdir = function(e) {
                throw new Error("process.chdir is not supported");
            }, r.umask = function() {
                return 0;
            };
        },
        function(e, t, n) {
            "use strict";
            Object.defineProperty(t, "__esModule", {
                value: !0
            }), t.RAINBOW = t.PHANTOM = t.ZERION = t.GAMESTOP = t.TOKENPOCKET = t.CORE = t.BITKEEPWALLET = t.CLV = t.BRAVE = t.RABBY = t.SEQUENCEINJECTED = t.PORTAL = t.TALLYINJECTED = t.BLOCKWALLET = t.CELOINJECTED = t.BITPIE = t.XDEFI = t.RWALLET = t.MATHWALLET = t.BOLTX = t.LIQUALITY = t.FRAMEINJECTED = t.TOKENARY = t.STATUS = t.IMTOKEN = t.CIPHER = t.COINBASE = t.TRUST = t.OPERA = t.DAPPER = t.NIFTY = t.SAFE = t.METAMASK = t.FALLBACK = void 0;
            var i = n(0), r = i.__importDefault(n(64)), M = i.__importDefault(n(65)), u = i.__importDefault(n(66)), o = i.__importDefault(n(67)), c = i.__importDefault(n(68)), a = i.__importDefault(n(69)), I = i.__importDefault(n(70)), l = i.__importDefault(n(71)), N = i.__importDefault(n(72)), j = i.__importDefault(n(73)), g = i.__importDefault(n(74)), s = i.__importDefault(n(13)), A = i.__importDefault(n(14)), D = i.__importDefault(n(75)), d = i.__importDefault(n(76)), T = i.__importDefault(n(77)), y = i.__importDefault(n(78)), z = i.__importDefault(n(79)), w = i.__importDefault(n(80)), f = i.__importDefault(n(81)), L = i.__importDefault(n(82)), E = i.__importDefault(n(83)), C = i.__importDefault(n(84)), x = i.__importDefault(n(15)), p = i.__importDefault(n(85)), S = i.__importDefault(n(86)), m = i.__importDefault(n(16)), O = i.__importDefault(n(87)), v = i.__importDefault(n(88)), b = i.__importDefault(n(89)), h = i.__importDefault(n(90)), k = i.__importDefault(n(91)), Q = i.__importDefault(n(92)), Y = i.__importDefault(n(93));
            t.FALLBACK = {
                id: "injected",
                name: "Web3",
                logo: r.default,
                type: "injected",
                check: "isWeb3"
            }, t.METAMASK = {
                id: "injected",
                name: "MetaMask",
                logo: M.default,
                type: "injected",
                check: "isMetaMask"
            }, t.SAFE = {
                id: "injected",
                name: "Safe",
                logo: u.default,
                type: "injected",
                check: "isSafe"
            }, t.NIFTY = {
                id: "injected",
                name: "Nifty",
                logo: o.default,
                type: "injected",
                check: "isNiftyWallet"
            }, t.DAPPER = {
                id: "injected",
                name: "Dapper",
                logo: a.default,
                type: "injected",
                check: "isDapper"
            }, t.OPERA = {
                id: "injected",
                name: "Opera",
                logo: s.default,
                type: "injected",
                check: "isOpera"
            }, t.TRUST = {
                id: "injected",
                name: "Trust",
                logo: c.default,
                type: "injected",
                check: "isTrust"
            }, t.COINBASE = {
                id: "injected",
                name: "Coinbase",
                logo: I.default,
                type: "injected",
                check: "isCoinbaseWallet"
            }, t.CIPHER = {
                id: "injected",
                name: "Cipher",
                logo: l.default,
                type: "injected",
                check: "isCipher"
            }, t.IMTOKEN = {
                id: "injected",
                name: "imToken",
                logo: N.default,
                type: "injected",
                check: "isImToken"
            }, t.STATUS = {
                id: "injected",
                name: "Status",
                logo: j.default,
                type: "injected",
                check: "isStatus"
            }, t.TOKENARY = {
                id: "injected",
                name: "Tokenary",
                logo: g.default,
                type: "injected",
                check: "isTokenary"
            }, t.FRAMEINJECTED = {
                id: "injected",
                name: "Frame",
                logo: A.default,
                type: "injected",
                check: "isFrame"
            }, t.LIQUALITY = {
                id: "injected",
                name: "Liquality",
                logo: D.default,
                type: "injected",
                check: "isLiquality"
            }, t.BOLTX = {
                id: "boltx",
                name: "Bolt-X",
                logo: d.default,
                type: "injected",
                check: "isBoltX"
            }, t.MATHWALLET = {
                id: "injected",
                name: "Math Wallet",
                logo: T.default,
                type: "injected",
                check: "isMathWallet"
            }, t.RWALLET = {
                id: "injected",
                name: "rWallet",
                logo: y.default,
                type: "injected",
                check: "isRWallet"
            }, t.XDEFI = {
                id: "injected",
                name: "XDEFI",
                logo: w.default,
                type: "injected",
                check: "__XDEFI"
            }, t.BITPIE = {
                id: "injected",
                name: "Bitpie",
                logo: z.default,
                type: "injected",
                check: "isBitpie"
            }, t.CELOINJECTED = {
                id: "injected",
                name: "Celo extension wallet",
                logo: f.default,
                type: "injected",
                check: "isCelo"
            }, t.BLOCKWALLET = {
                id: "injected",
                name: "BlockWallet",
                logo: L.default,
                type: "injected",
                check: "isBlockWallet"
            }, t.TALLYINJECTED = {
                id: "injected",
                name: "Tally",
                logo: E.default,
                type: "injected",
                check: "isTally"
            }, t.PORTAL = {
                id: "injected",
                name: "Ripio Portal",
                logo: C.default,
                type: "injected",
                check: "isPortal"
            }, t.SEQUENCEINJECTED = {
                id: "injected",
                name: "Sequence",
                logo: x.default,
                type: "injected",
                check: "isSequence"
            }, t.RABBY = {
                id: "injected",
                name: "Rabby",
                logo: S.default,
                type: "injected",
                check: "isRabby"
            }, t.BRAVE = {
                id: "injected",
                name: "Brave",
                logo: p.default,
                type: "injected",
                check: "isBraveWallet"
            }, t.CLV = {
                id: "injected",
                name: "CLV",
                logo: O.default,
                type: "injected",
                check: "isCloverWallet"
            }, t.BITKEEPWALLET = {
                id: "injected",
                name: "Bitkeep Wallet",
                logo: m.default,
                type: "injected",
                check: "isBitKeep"
            }, t.CORE = {
                id: "injected",
                name: "Core",
                logo: b.default,
                type: "injected",
                check: "isAvalanche"
            }, t.TOKENPOCKET = {
                id: "injected",
                name: "TokenPocket Wallet",
                logo: v.default,
                type: "injected",
                check: "isTokenPocket"
            }, t.GAMESTOP = {
                id: "injected",
                name: "GameStop Wallet",
                logo: h.default,
                type: "injected",
                check: "isGamestop"
            }, t.ZERION = {
                id: "injected",
                name: "Zerion Wallet",
                logo: k.default,
                type: "injected",
                check: "isZerion"
            }, t.PHANTOM = {
                id: "phantom",
                name: "Phantom",
                logo: Q.default,
                type: "injected",
                check: "isPhantom",
                package: {
                    required: [
                        "networkType"
                    ]
                }
            }, t.RAINBOW = {
                id: "injected",
                name: "Rainbow",
                logo: Y.default,
                type: "injected",
                check: "isRainbow"
            };
        },
        function(e, t) {
            e.exports = "data:image/svg+xml;base64,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";
        },
        function(e, t) {
            e.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB4PSIwcHgiIHk9IjBweCIgdmlld0JveD0iMCAwIDE1My40IDE1Mi45Ij48ZGVmcz48bGluZWFyR3JhZGllbnQgaWQ9InBoYXNlIiBncmFkaWVudFRyYW5zZm9ybT0icm90YXRlKDQ1KSI+PHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6ICMyYjI1NGYiLz48c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiAjMTkyZjQ1Ii8+PC9saW5lYXJHcmFkaWVudD48L2RlZnM+PHBhdGggZmlsbD0idXJsKCcjcGhhc2UnKSIgZD0iTTE0NS4xLDc1LjZ2LTU4YzAtNS4xLTQuMi05LjMtOS4zLTkuM2gwSDc3LjdjLTAuNiwwLTEuMS0wLjItMS42LTAuNmwtNy03Yy0wLjQtMC40LTEtMC43LTEuNi0wLjdIOS4zIEM0LjIsMCwwLDQuMSwwLDkuM2MwLDAsMCwwLDAsMGwwLDB2NThjMCwwLjYsMC4yLDEuMSwwLjYsMS42bDcsN2MwLjQsMC40LDAuNywxLDAuNywxLjZ2NThjMCw1LjEsNC4yLDkuMyw5LjMsOS4zYzAsMCwwLDAsMCwwaDU4LjIgYzAuNiwwLDEuMSwwLjIsMS42LDAuNmw3LDdjMC40LDAuNCwxLDAuNiwxLjYsMC42aDU4LjJjNS4xLDAsOS4zLTQuMSw5LjMtOS4zYzAsMCwwLDAsMCwwbDAsMHYtNThjMC0wLjYtMC4yLTEuMS0wLjYtMS42bC03LTcgQzE0NS40LDc2LjcsMTQ1LjEsNzYuMiwxNDUuMSw3NS42eiBNMTA1LjYsMTA2LjZINDcuOWMtMC43LDAtMS4zLTAuNi0xLjMtMS4zVjQ3LjdjMC0wLjcsMC42LTEuMywxLjMtMS4zaDU3LjcgYzAuNywwLDEuMywwLjYsMS4zLDEuM3Y1Ny42QzEwNywxMDYsMTA2LjQsMTA2LjYsMTA1LjYsMTA2LjZ6Ii8+PC9zdmc+Cg==";
        },
        function(e, t) {
            e.exports = "data:image/svg+xml;base64,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";
        },
        function(e, t) {
            e.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAASwAAAEsCAYAAAB5fY51AAAAAXNSR0IArs4c6QAAIABJREFUeF7tXXmcFMX1/1bPTM9wiwgGRSPsLAiKxvtABW8j3lfE23hh4gk7wyHqInLtLILiEVHjFZMYj59EjQeCouIV0aiowPYqKqLiCcjuTvfM1O9TC6vssrvdPdM901396h/9MK9evfq+19+tfl31ioEaIWABgeQA3oWn0SkUQucM9BjnrANCuT1E1xBXdm9SwYFf/r/x3zhfzhj7ufF/wVfkGP8BWWVxREHGUHh9iKlrAayrWsbWWTCDRAKOAAv4/Gn6GxEYG9d3y4IfC2BPAH0BDAAQKSFAXwD8QzC2hHH+yk/dos/MWcyMEtpDQ3sAASIsDzihWCZUDuLqej09DGBT0XIlVCwjnBtHV8BG1SFydw8NRiVYzjnVpMmrCBBhedUzBdqViDeUgeFExpU/cvCBBarzS/e1AL+HQflXlaa+4RejyU7rCBBhWcfK05LJ8vRAzvEwAyvn4DFPG1tc474ARyJVG324uMPSaG4gQITlBqpF0DmmX3pwTsFkACLvRM0qAhwrwHLn7aXFXj0NLGu1G8l5AwEiLG/4wZIVyXi6koNdBvAeljqQkBkCWQY8VqWppwOMmwnT76VHgAir9D5o04LKQbzzel2/G8AfPGymTKbVhqHvN1Xr8q1Mk5JpLkRYHvNm436nnJEC55d4zLSAmcNeVxRcOn25+l7AJu7p6RJhecQ9ibL0dDCMFvswPWISmfErAh+mtOjOBEjpESDCKqEPEmV1Q8BCCwCoJTSDhraBAAP/c5UWvYNyXjZAc1CUCMtBMK2qSsTTTwA43qo8yXkSgaW8o7pn9ftsvSetk9QoIqwiOXZUWd12IRaqARAt0pA0TLEQ4MrvU7WRZ4s1XJDHIcJy2fuJuP5Hsfva5WFIvRcQ4OwvqVr1Ui+YIqsNRFguebYinr6eAZUuqSe1HkaAc/5VdW1sGw+b6FvTiLAcdl2irGE6GEs6rJbU+RIBtoSFIvtT6RznnEeE5RCWiXjDEwCjRLpDeEqlhmNFqjYqSvZQKxABIqwCAUzE06JUy9gC1VD3ACDAwLSOamSnyo+YHoDpujJFIqw8YU2Up5PgmJ5nd+oWaAT4sykt9vtAQ5Dn5ImwbAI3emD9bxVDWWGzG4kTApshwICxVVqU/ujZiA0iLItgbTyIvApAF4tdSIwQsIRAjvEjZtTE5lkSDrgQEZaFAEiW669wzg+wIEoihECeCLC1KU3tlmfnwHQjwmrH1YmyhqPA2DOBiQaaaOkRYOzOVI06svSGeNMCIqw2/JKIp78C8Btvuo2skh2BHLDTDC36kezztDs/IqwWiCXLjQTnuSq7QJI8IeA0AoyxZVU16o5O6/WzPiKsjd5LDvi2C892/Y5Kvfg5nOW0nTN+eHVN7AU5Z2dvVkRYABJl6UlgmGAPOpImBIqHAAP/pkqLBT5FEWjCujzOozEYqwHetXihRyMRAvkjEPTcVmAJK1GePhkcj+YfOtSTECgVAvyplBYL5PVugSSsRDz9XwB7lircaFxCwAkEVmhq+JGA3a0YKML606DVnTvp3dY5ESykgxDwAgKM4eSqmujjXrClGDYEhrCSffW9eYi/WQxQaQxCoMgILE5p0UC8MQSCsCriDc8ysCOLHEQ0HCFQRATYujXdIj3mLGZGEQct+lDSE1Yirq8FOB1YLnpo0YClQICF1K4yVziVlrAqytb1Ykz9phRBQ2MSAqVEgANnV2vRv5XSBrfGlpKwKvo1HMYURuU63Ioa0usHBJ5NaVHpigRKR1jJuD6bg1/mh4giGwkBdxHgq1JabFt3xyiudqkIKxHXFwD84OJCSKMRAp5GQE9pUWku75WGsBLx9A8Auns6dMg4QqA0CPAGqB1mayxdmuGdG1UCwuIsEdcbqMqCc0FBmuREIKeoPWcsZ6IiiW+b7wkrEU9z36JPhhMCRUZACWOX6UujHxR5WMeG8y1hXbwHj3Rbo9P9bo6FAikKCgIc2f2rtY6v+3G+viSsDWVhGl8DqREChEA+CDCckaqJ/iOfrqXs4zvCqhzE1fW67vvkYSmdTmMTAgIBnsOZ1Z9E/+4nNHxFWERW/gitWBdA7cCwdjWlF73uMb+Rlm8Ii14DvRv62w5iOOf2MLpv23o46XXAO3OzePy6rHcnEWTLOL8kVRub4wcIfEFY5+3AYz3Der0fAA2Sjf0PUHDhvWFbU165hOOWE6UuKGALD68I+yUR7wvCoq0LXgnrDXZ06ckwZn4Eaof87Zp/WxbPzaIVV/4IOt+T5XKHVX3SYb7zmp3T6GnC4uAsGddzzk2XNBWCAFOAiYtVxDoXoqV53ylDDfy0inJdziFamKYM5+Uza2NaYVrc6+1pwkrE0+JroOre9EmzVQSOToYw7KKQVXFbcut/BKYN05Gus9WNhF1CoAFqzKvHeDxLWIl4eq14+3DJJ6TWIgJ992QY+fcIWBEiZcVijttPp/yWRde4KcZTWlRxc4B8dRchDO2blojrrwF8P/s9qYdTCHTtxTBhUcQpdbb0PDo+g7ceoUyALdBcEK7SVIWBeep93XOElYinHwRwlgv4k0qLCFz5RATb7lTa0MhlgdThBr7/wlPPi0UEpRGrT2nRjl6aTWmjsgUSifL0CHD4auetl5xZqC1HXhXCoX92J0+Vr21GA3D9HjoydGo0XwgL68fwfqomumthSpzr7RnCGt23/rdKSFnh3NRIk1UE+g9RcOF99vZTWdXtlNw7T+Twz0TGKXWkxwYCDOymKk0dbaOLa6KeISzaa+Waj9tVPOVDFWEffYd98PIMPniW8lvFjpZwWB0wdSlbXuxxW47nCcJKxNNiF3us1GAEaXzx5a/fXp5wf16wTzvUwA+fU34rL/Dy7BTS1S2nfc5+zLO7I91KHrGJeHoxgN0dmQ0pMUVg+JgQhl7orTyVqdFtCHz/Ocf0wwyAeCtfCO32y6W0aEmDp6SEVRGvv4BBudsuaiRvH4Hf9GcY9XRptinYt9Zej0UPZDH3xiwRlz3Y8pZOadGS8UbJBh5VVrddiIU+zxs16mgJgXAUuOYVFZ0CcD3HfSMz+Gg+5bcsBUYBQpwjVV0bTRagIu+uJSMsSrLn7TPLHZPPR7BV35K52LKdTguO6a+D02ui07A20xeJqNtM+Zh95eogrSgvSTQn4g3fAKxXsScblPFEjkrkqoLcPnuH4/YRhqiqSc0lBErxalh0wkrEjeuA3ESXMAy02p79GCqeiUBUVaC2AYGX/5rDU1Np/5ZL8bAypUW3c0l3q2qLSlhjt+fds6ouLjyl5iACotzLtW+oiEhzv6+D4GxUddNwA18vp/dEp5HlnI+sro3d6bTetvQVlbAq4ukMA4L9ruKwZy+4J4wBB9GSygqs677lmHyQgRwtuKzAZVmmmK+GRSOsRDz9JoC9LaNAgu0isM/pCk6e5O3jNF514Rfvc9x6ikGJeecclE1p0aIEY1EIa2x5Q78sZ7XO4RNcTdvtynD5o3Lupyq2V5+cksUr91KZZidwZ4zdUlWjXumErvZ0FIWwEvG0iAp6bynQmze8o0JcoUXNOQTE6+HEfXTUi3KR1ApCoBPUbpUacxVJ1wkrEW94EmDHFIREgDuLSp9nzQ5j8JHE926GgbhDcdohBjJ0RW9BMLudz3KVsMYO/ql7tr4DfRXMMwQOOj+EY8bTN4o84cur29KXcvjrRZSVzws80Ymx2aka9Yq8+5t0dJWwEuVpAxxFSca5BVAp9JayPHEp5uvFMe8YkcGnb9Ou03x806lO7VS5irlypYhrhJWIp8cDmJzPhIPaRwkD4jjNltu55pagQpvXvEW106rDDaz5mvZv2QRwTUqLbmGzjyVx154MOitoCf9fhEb+LYJ++7jmDnvGkHQzBNZ9C0zan2o02wkLzrL7Vtd0FFuZHG2uPCGJePp7AFs6aqmkyvY4QcEfUvTW7Af3Lrwri6eraBuERV+5clWY44SViK/fHQiLonzU2kGg4xbANa/ScRq/BYk4TC3yWyveofyWme8Y8GiVFj3VTM7O7y4QVppe+NvxQCQGjHkhgq5bOw69Hb+TbIEIZDPAjfsbWP8jhXt7UK7ppqpzFjPHbsd19KlJ9tNHcoXfUWAsSNv9zFlh7Dqc9lPJ5ODP3uW47TTHnkeZoGmay/qUFu3s1MQcJSxKtLfulu13ZbiMjtM4FbOe1DP/9iyem0n5rdacE2Jq2bQa9okTjnOMsBJl6cfBcKITRsmio/u2DInnI766RksW7Es1jznnZKC9TvmtFvjrKS3qSPEjRwirchBX1+s6HWrYxEvjX45gi96OwFuqZ4/GzROBhp+BiXvpEHkuak0IKMNSWmRhoXg48kQlytJvgWGvQo2Rof9xE8I44FzKU8ngy0LnUPtGDnPOzVCZ5o1AOnHO0BnCitOXwV2OVnDWzbSfqtCHXMb+/0ll8dIcym+B8USqJlZdiI8LJqxEWfpTMOxQiBF+7tuxG1D5to/uevcz2D63fepQAz+uCvY2iEJXWQURVnIA78Kzuqv1b7wao0oIuOLxCLYZVBCEXp0e2eUSAo1lbA42kAnoSR/G2JVVNeot+cJb0NOWiOsfAHznfAf3a78RN4Wx27GUp/Kr/7xg91dLOWYeG8z9W4WssgokrGDlrvofoODCeylP5YUHXhYbHroqg/eeDtY2CM74MdU1safz8WHehFVR1rCKMdY7n0H91qfjFgxjX4xAXKdFzRyBr5dxfFPLsevRtAo1RwtoLGNzmIE13wQnv5XvKisvwqoEV9bHdek/e4j6VGPnR7DFNnnBZCVWpZHR64DrdtORa2WxcOXcCLalXJ+pr0Vd+Un76UHJb52W0qKPmILSQiCvJzERTz8I4Cy7g/lJfvjYEIZeQOWJrfjs/ksz+PCF9l9rOnQDxi9UEe1kRWOwZd58OIfHJki/6zSv3e/5Epa0a1dx3XviObpGywplLJmXwwN/svdg9R7AcPVThK8VfG850cDKJdI+asgo2T4zl3f80goWTTK2CStRpp8Dxu+3M4gfZDv3YBDHacK0pcrUXas1jhnDjYJ2cB9/XRhDzqYclxnY4njP9EMM/PSVfMTFgIYqLdrBDINNf7dPWBLuahcHlHv2tQ2FHZylkb3xAANrHUoOMwUYMy+CLbcn7M0C5IeVG/ZvydbsJt9tRcqosrrtQiz0uSygHXBuCMdNoDyVFX8+Mi6D/z7qzud38RX2mlciEMUNqbWPgChhI0rZyNP4wpQWG2Z1PrYIKxFPfwGgj1XlXpUTX/9ufE+l1z8LDlr8RA7/SmbAi/BGIi6LPftW2udm5hbxmjhpXwN1a4rgFDNjHPjdzirLMmHJspUhFAGmfkSJKrM4E3uDrhlcmvMj598ZxsBDKL9l5qMJu+jQ682kvP87B06o1qJzrVhqmbAqyhuqGGcJK0q9KhMKA1M/JrIy88+s4w2s+qj0f73HzI+gB+W32nXX1GEGfvyy9L4yiymz362usiwTlgzlj8XKSqywqLWOwD8qMnh3rjt5qnwx774Nw7iF5LQ28eNAsn9pVsL5+rS1fo4SlgxVGXY/XsHp1ZQfaS1Ylr+aw93n29tP5WSwWtF1yKUhHDWKPpC0htVXyzhmHuPvL4iMsVeratQDzWLB0gorEU9/B6CHmTIv/15VQ6+CLf3TsJZj8oEG0nVe9lxz2y5+IIz4fpTfaumxZLnvV1mWLl61Sli+fkkuH6LgovtoddUU5LkscNPRBlZ/4l+33vCuSofRN2Gt2jc57jzL56sshe1TtVx9q70/n6aENTped4qCkO1Dil76m518IYKtfms6VS+Z7Jotz6SyeFGScr1l+yq45EH6Q9QULBKssv6X0qK7FURYibL0D2Do7toTVATF9DoIrPqYQ3z9g38XVW1GyvBkCEMvovyWBIQFs+R7u8sOWfZeBZmw6n4CbjxARyYAl7AFvYyNqGAqKpn6ufFQrl/1sg6ftjWHdgkrUWYMAcu96mcAhO1BJaybTzDw5Yf+DmC7sde1F8OERcHcBnHXuRnUvOatbSl2/QegPqVFO+ZHWJIcdA4aYb16Xxb/nizTeTP7Yb/zEQrOEcd8ApS6lISw2n0tbH+FRYRl/0kpYY8VizluP93fX4qchu8P08PY46RgbIOQhbA4x+Dq2uiS1mKhTcJK9jcO5bncC04HUCn0yb7C4jlgzADf78NxNTRkjwEBniyEBeCtlBbdxxZhJeLpDwBIcYWXtMHKgftGZvDRAt/nLVwlq6DkMSUirDZfC9tcYclwdrDpKZCRsBbelcXTVcHOU1lluYpnI+hVJn8ySybCQsbonVrR+euWPm7Vi8l4XR+OkKh9JUWTibBW13JUH0V5KiuBud8ZIZw4MTj7s6QiLI4bU7XRay0RVkW8YRoDG2MlKPwgIwVhcWDqwXKUEnE7ZsRFF2JPlhIcrmqEVCrCAlp9LWx1hSXT66Df8xei0ue9F2ew9CXKU5kRXTgKTHo3uCWEiLDMIsQnv/t1hfXGP3J4/Dpvl33xSgic95cwBh0ajO0LbWEuG2FlFLXPzOWs2TVgm62w/jiAd+mR1dd6JRCdsMOPhDVuoA5Ru5ta+wgccF4Ix10TsHe/NiCRjbAAfJzSooM2ne5mhJWI6y8BfKhMD4pfCCuXAVJHGvj+82Adp8kn1rYdtCFPRe1XBCQkrM1uh26FsBrLudm63NDrQeMHwvrb5Rm8/yzlqcxiSSTSx70UQbffyL9NwQyLlr+LUw7itINMrWX1htYIS64Ze/zw86dv53DHCHr3M3vIGAMu/GsE5QcQUbWFlQzlZVrOjbUo6tfM+6P6NfQPKWyZWfD47XcvrrB+/n7DTb4yXNPkdjwceF4Ix1Keql2Yf/iCY9ohEu7PY2x2qka9omnyzQgrEU+PBzDZ7QAstn6vEdaNQwysXS3dQtZxt8a6ABMXqxCrK2rtIyDj6mrjjJvVem8WCsny9CrO0Vu24PAKYT1TncWLd9JxGrP4UjsAyRdUdO1lJkm/r/kGmHKQDnEAXta2aR6r5QpLyj/7pSasT97K4c6zM1IHlVMPywX3hDHgoGDvp7KKZeoIA99+KuUj2wyCTn3USOVLrDHR+wthcXCWjOtS8nSpCGv9j8CNQ3RkJUwtWH2orMqJTZ9i8yc1cwQW3JHDszcF6UMNj6e0WG0zwro8zqMx6A3mcPlPohSEdespBj5/T/6/foVGg9ieIG41ikQL1SR//0/f5rjzTAM5KZcV7fmPL0xpsWHNCCsZT0/hwDgZ3V5Mwnrhtiyen0V5KrM4Ygow+QMVYbrf1gyqxhX6+J3lzlOZgdCUx/rllVC2A8+bAlAMwtLeyGHO2UFappuFWNu/H3dNGAecR3kqKwg2FmicH7gl1WbQEGFZiRYLMuIW5ev30JFeb0E44CLxfRVc9ECYtilYiIOX78nhqWn0B7AJKiIsC0HT7lt1DvjLmRmInerU2keg29YMY1+KIEQ5ddNQEQUaZ/zegCgrRO1XBDINao+ZK9kP9EqYR1TIdN17HtO31eXqJyPovSPt/LQCWmOBxpXEVK1jxS5LaeptjZE0Op4epAAfWgHVjzJO5bBEFYXph9IeBSsxcHQyhGF0fbwVqPCPURm8+ySt1E3A+ndKix7fSFgV8YZRDGyGJXR9KFQoYYn81PRDdfz8vQ8nX2ST+x+oQGz+pOM05sAvfjyHh8dQnsocqUaJT1NatF8jYSXK00+D42iLHX0nVghhTT9Ex/fSXMfhruumfEjbFKwgbKSBa3fVIT7YULOOgEi8NxJWMp6u4UDceld/SeZDWG8+nMNjE+ivnxVPX/pQGH33pm0KZliJAo3ixqPvPqM8lRlWrf3+C2HJvAdLTNwOYf24iqPqMIOO01iIqOFjQhh6IZUntgAV/jU2g7cfozyVFazakiHC2gQZowG4fk8dmXQhkAajr/jqJ77+UTNH4JO3OP5yJn2oMUfKXCIMtdeGHFY8LfUa1WyF9dCVGbz3H/rrZxYy0U7AuIUqOnYzk6Tf634CpgzVoYuC49QcQSCnYCBLDuBduGS35LREpy3CqlmUw13nUZ7KSjRd/e8Ieg+k/VRWsJq0n4F130m9BrACg+MynCuHCsLahmf1Znd/OT5SiRWKA7biC1ZTEzWEbjraoGu0LPiFrtGyANJGkXmzs5h3C336s46YPUkOfisb3T+9o5LDx/a6+lNalNw16kFEZcF9PfsxjH4mAoU+/pmitepjjlnHUZ7KFKiCBdhiligzhoDlXi1YFymQAoFoR+DaN1SIMsXU2kegbg0w5UCdLhIpYqCwinjDVQxsZhHHpKE8isAFd4cxYCgtqay4R9z/J+4BpFZcBFgy3nA3B7uguMPSaF5C4HfHKDhjJpVSyMcn1UcaWP0JJdjzwS6fPiwR198G+B75dKY+/kaA9lM54786Ubv/QNrD5wya7Wthsu/BKgaIfhzjhsUqYl39aLl3bf5qKcfMY+k10U0PEWG5ia4HdY+YEcZux1Geyk3XPDExi9f+Rtsb3MCYCMsNVD2oc5/TQjh5Mp37K5ZrRCWGWcca+FqUFaDmGAJEWI5B6U1FnXswXPcGnfsrlXdELbVJ+9HWB6fwJ8JyCkkP6hEbP7eO03EaL7jmw3k53P8nOgZWqC+IsApF0IP9z5odxi5HUZ7Kg67B/1Vm8PpDdNA+X98QYeWLnAf7DT5KwdmzaT+VB12zmUk3DTfw9XLKb9n1FRGWXcQ8KE/HaTzoFAsmrV3NMflAA5wWXBbQ2iBChGUZKu8JhiLAqKcj6NmX8lTe8451i0Qttr9flaG7CC1ARoRlASQvipx0Qxj7jqA8lRd9k69NVEbZHDkiLHOMPCWxzUCGq/5N2xQ85RSHjbn2dzrEdghqmyNAhOWTqBC1vK59TUUk5hODycyCEPj2E44Zww2Im3ao/YoAEZYPoiE5L4KtdqA8lQ9c5biJHy3I4b5LiLWagCXCcjzEnFN4yMgQjhpNx2mcQ9S/msTNO+IGnqA3IiwPRkC/vRlGPkR5Kg+6pqQmpX/ecBNP/dqSmlHSwYmwSgp/88HFNVrXv0XXvXvIJZ40RVyikjrSAAK44CLC8khIXnRfGOVDaJuCR9zheTOyGWDcQN3zdjptIFUcdRpRm/qOGhXCIZdSnsombCS+EYFkebBIiyXj+hwOfhFFQHER6DOY4YrHKU9VXNTlG61+DXD9nsEhLTa6vGGkwtkd8rnSmzMSx2mueTWCzlvSNgVvesh/Vj07M4sFtwejwikb3U/fS1H4W/5zk78sZgow8m8R9N2LiMqK5177Ww5PTPx1/5H4ICHOTXbflvBrDb+AvBrmAnXzs5UHxQ2ZYReHcHSC8lRWsF26MIe/Xtj2Rsktt2NIPB9BiKroNIPz5b9m8dRUuVdZHHiNJQfwbXhW/9JKMJGMPQQ6dAUmLlbtdQqodC4HjNtRt1yxoHx/BRfdT6zVFC6ihvzYHSXPZSm4gVUO4up6XU8H9DlxZdrimvfkCyq69nJFvVRKRS2oO87IYMXi/IpCnXNbGDsfQdtBRFDI/lqo5JQDGxMCdDehcxwgdqiLnerUzBGYe0MWix4s/DVG/IGY8JqKWGfzMWWWqD7KwOpaeXeT5hQMJMJyKIJ3OkzBuXfQK4oVOFd9zDHrOOcvHO2+LZCcp0J8iQ1iu+vcDGpey2+l6ge8jExddyKsAj21ZR+GiuciCFOqyhRJvQ6YdrCOn38wFS1IYM+TFZw2LXh/PGQnrJQWZY2ElYynl3Bgp4KiJGCdlRBww7sqxOsItfYR4By4+QQDqz4q7uuK2Abxm/7BeT0PDGFVxNOPMOAUevCsIXDq1DD2OoUSvVbQWvRgDnNvKF09J7F/a+yLKjp1t2Ktv2WCQ1jlDVcwzm72t7vct37nwxWcfVsYG9al1NpDYP0PHDcOMSAO6Xqhif1bYxfIndySnLCWprTohqR7Ml7XhyP0hRcCy4s2dN+GYcz8CJTgpUVsu0OvB6YcpKPuJ9tdi9LhhOtD2P8sOTfxykxYHHi0Woue+stagbY2tP68iF3VdI2WNS65f2QGH873/lcqWa9Hk5mwGHBWlRZ9iAirjWeR8lTWSEpImR2nsa6puJKRKFD5tjwXe8hMWJkGtePMlayeCKvFM0LXvVsnjR9WcojNihmfn5PY9WgFZ97s//d9mQlLbGkQkUmEtfH5DEeBG99TIbYrUDNH4LrddTSsM5fzk8SZs8LYdbh/v/4GjLDqLwSUu/wUYE7YKgjqyici6L0jffqzgqeoCCAqA8jaxIeVimf8ea1aoAjr8nhNNIbtG2QNxNbmdfx1YQw5279/UYvpq4/m53D/pRnL1RSKaZsbY22xDcP4hf7aBiErYXHOH6+ujZ3c7JUQ4KK+u/c/8TgQnX33VHDpP/yfs3AAClMV638AJg3RA3sD8b6nKzhpkj9iRVbCyjSs7jhz5Xb1LQhL/qoNHboB4xeqELufqZkjII7TfPlhcY/TmFtVGgmRlBfJeS83WQlrhaaGHwFrzEM0S9wk4un3AQz2slPyte28O8MYdIi3Ay7fuTnd7z9VGbx0VyAW27agE2Wupy9VWzw1tlS4KiwrYTV9IdycsMr0y8H4La6iWgLlB10QwjFj6fOfGfTa6xxzznG+7IvZuH76fZ/TQjh5sjdjSVLCWpPSols0xUizFdZVA9f3jhjhVX4KICu2Tl+u0vm/doDK6MDEvXWk11tBM9gyY1+MQJQU8mKTkbAYMLFKi1a2SljiH2U8olNVQ8WqWnvARB1wsaL65C3KU5kR0A57MPzpn97+aigjYeWAnWZo0Y/aIyxxbLWbmQP99DsR1ubeen5WFi/cJu9+KqfiMxIDxr2konMPpzS6p0dGwto0f7VZDkv8Q0VZ+jHGcJJ7sBZfMxHWr5j/tIpjylDKU1mJwquejGAbH20olo2wGFhdlaY2+6a/2cv45XEejUGXagMpERZg1G/YTyXbcRorxGNX5rDRAou9AAASzElEQVQ/h3DEVd5MrLc3F9kIC+ALU1ps2KZzbjV7KFseK+iENfsUA1+8R3kqM+LqshXDhEURiO0LfmyyEVanPq9FKl86uFkJyNYJqzxtgMMf23stRFZQCevtx3L411iPlPy04KdSiUQ6ANe97v8NxbIRVsv8Vas5LPGPyf4Nl/Ecm12qAHJ63KARlij7kjrcO+WJnfank/rE7dHiFmkZWmAJa9yOa3tkMtHvZHCimENQCEvsp6rcS4e4Tota+wjseZKC06ZL8xLROFmZCItxdnlVrXprSy+2uQNOpjxWEAjrnxUZvDOXjtOYEXWvMoarn4ogJBdXSUdYDVC7zdbYWhuE1fAqwIaYBYAffpeZsJa/ynH3+bRNwUocigKNakcrkv6UkWmF1Vr+qs0clvihoiy9M2P4wJ+ua261jIT1/Wcc0w8jorISn3+YHsYeJ8mRp2pvvrIQFgObV6WpR7Q213YPRcnyWigbYU072IBIrFNrH4HfHavgjJskfPdrY9qyEBbn+tbVtV1W50NY4noB3x/Ek4WwnpySxSv30nEaM6LeojfD+Je9fe7PbA75/C4LYbX1OtjuK6H4cXT/9I5KDh/nA56X+vidsJY8n8MDf6b9VGYxJerzj3oqgl5xb1ZTMLO/0N9lICwO/mW1FuvTFhamnpXhtdCvhCW2KYzfSS80jgPRf8SMMHY7Tv48VXvOTB1h4NtP/Z0qaIDea7bW5dtCCMv3VUgr/6ui4y8lwPzx/N4xIoNP36ZtCmbe2uX3Cs66JTh5qvbwSJb7/49be6+Dpq+EQiARN4YCuZfMAsfLvx87PoQDz/fHYdanp2ex8G7KU5nFU1gFJi6W59Zms/ma/W40ANcM9jdhMeCZKi16dHtzNX0l3EBaaX+vM32w2/3LJRw3n0jbFMwezFAEuPrJCMQGUGq/IvDiX7J4Zoa//9CpXN1+ci37omDCqihLL2MM/f0cIMl53r0cc9J+BtZ95/u/Ca6Hx0kTQ9j3DH+slF0Ho8UAErwO5lJa1NS5lv9M+X2V1XjjyTIP7dDgwO0jDKxYTERl9nD3HrDhOA211hF4bEIGbz7s83wnY3ematSRZj4ODGEJIAYerOD8OaVP0L58TxZPTfP38t0ssJz4vUNXYOyLKsR/qbWOwLpvOSbt7/9UglmyvWn2lgmroky/iDE+x++BU8rXCnErzfW768j5/I9hMWJg3EsRdN/WcngWwyRPjiHBq6C4HLWuSrN2vbGtiPD7a2FTxIkvhuLLYbFa1kBjHXXx15Ba+wgMOSeE468tnm/86g8Zvgo2Yc+h7F+tRV634gu7hPUhgEFWFHtdpktPhmtfcz8vcs8FGSx7mZZUZvGwdTnDVf+Ws+yL2dzt/r7sZY57LvD/a2DTvK2+Dgp5W4R18Ta8Y7eOulTXbYpT/OI0v9ONjtNYQzTaGZjwqv/LE1ubbWFS9WuAG/bTIVbsErW/p7TomVbnY4uwhFJZXgtbAnTKlDD2PrXwox3ff86ROtJAjo7+mcbghX8No/+BhWNuOpAEAredZuCzd+VLKdhZXdleYYkOo/vpeykKf0uCGGh1CpP+l/9f++t2p2u0rMSFjOWJrcw7HxnxNVl8VZa0rU1pUVuXNtteYcm8ymoKil79GCqes57fkmIfTBGeCLGf6sq5EYiqCtTaR6D2zRzuPEvuZXqmoaHHzJXdfrATC/kRVlk6BYYKOwP5UXbwUQrOnt12fuvDeTnc/ye5g8opv137egTi3j9q7SMg8lMT99bR8LPsSLEfU5q6pd1Z5h1BsuayWgNQbDYVm06bmqj2Kap+UjNH4PTqMHY/nvJUZkjxHDDreANfLZUvT9Xa3DnH4Ora6BIzXFr+XgBh6QsAfrDdAUk+GAjsc7qCkyc5//VVRvSem5nF/NulzVO1ylcpLZrXX7G8CSsIuSwZHw635yTqjon6Y9TMEfhuBUfV4cFbqaux7PaTl3RstypDW+gVRFjJsvRTnGG4uWtIQnYElDCQeC6CHtsXFFKyw9Q4P7GfavKBOvT6QEx3s0na3cqwqYKCoutU8NAOcZ2yzsGMu19m/ce7IthxWEGhFBgEZx4bnDxV605VjkxpkefzdXjBUZaIp98EsHe+BlA//yIw8BAF599JeSorHlz0YA5zbwj833YjpUULyhcUTFiUy7ISrnLJdN6KQVRTiETlmpcbs/l6GcfM4wyIr4BBb5xl962u6SgWOHk3RwgrWZb+B2c4PW8rqKMvEBDlicctjKBrT0fCxhdzztdIvQ6YsKu/a6znO/c2+lmqKGo2piORVwmurI/rgfouawasbL/76SKPUmN/7yUZfLyAllSb+oExDKqqiRZ8x6kjhCUMqyhrmM0Yu6zUwULjO4tAn8EMVzxu/ZiSs6P7S9vix3N4eEzg81StOI2tTmnq1k540zHColyWE+7wjo4uvRiuXUREZcUjqz7mmHVc8PZTWcFGyLDQ2q5Vy3qusyrfnpzDhKXvDvDFThhGOkqHQMWzdI2WVfQnH2hgzdfBOE5jFZNmchxfp2qjvfPq29pazSlFTXoSZen1YOjotF7S5z4CQy8IYfhYKqVgBemHrszgvf9QnsoMqypNVRiYY4zu6ApLGD++789bG6HI12YTod+9g0DfvRSMfCgM5ng0eGeOTlmy6IEs5k6i70tW8GTA+CotOtWKrFUZV0I0GU8v4cBOVo0gudIgII7TTPu4oH18pTG8BKPWrQEq96RtCjagd2QbQ8vxXCEsMUiQys/YcKJnRM+5PYydD8/rwLxn5lAMQzIGMHO4gW8/deytphhml36MjNE7taKz429arhHWmPKG4TnOnio9cmTBpggMuziEoxOUp7ISFfddksFHtJ/KClTNZBiwvEqLDrDd0UIH1whrwypL/wbgvSzYQSIuI7B1nGH0M7RNwQrMS57L4YHLaD+VFaxakymkGoPZmK4SViV4eH1cpw0qZl5w+Xe6RdkawPVrOCYNMZBJW5Mnqc0RYMidVaV1eMgtbFwlLGF0RTw9hgHT3JoA6W0bgfPvCmPgMMpTmcVILgtM3MeAICxqBSGQTmnRWEEaTDq7TlgbXg3TPwGwdZ2Pm5OWXTeVJ7bu4ceuyeDNf9F+KuuItS3ZADU2W2Ourk+LQliVw3h4/Up6NXQiKMx0TFikoitlDc1ggvYGx5yzKVthCpRFAc7ZxdW16l0WxfMWKwphCeuS5ca1nOduyNtS6mgJgaoa2lfVHlA/fcUx5SAiKkvBZFWIsx9Ttfav7LKqflO5ohEWvRrm4x77fYiwWseMcyB1hAFx8QM1ZxFw86tgS0uLSlgbSUskDIo+rrMu8q42IqwWvuHA09MzWHgP5alciVquHJCqjSxyRXcrSotOHMky42DOcguKNcGgjfPb3zH8+RHabyX8vuT5HB74M+2ncusZ4OAvV2uxoW7pb01v0Qlr4yrrbQB7FHOiQRtr7IIIttyuJO4tOdTi9W/MAB2gtz9XfVHMV8GmiZQsohPx9HqAytC4GVGxLsDYF1V0DMiGErGf6tZTDaz8gJjKzbgSup0symfH1pIR1uVxHo1Bb7BjLMnmh0DvHRmuflLu18RHxmXw30cpT5VfhNjrxYETqrXoXHu9nJEuGWEJ80f3T++o5FBwYXpnoJBfy4mVYex3plw7379cwnHzibRNoYjR+3ZKi+5VxPGaDVVSwmrMZ5Xrd4Lzi0sFQNDGZQpw+SMR9Nml5K4vCHqjYcN173XiDAW1oiDAwX6u1tQuRRmsjUE8EbWJePp7AFuWEoigjS0uQb3hXRXirkE/NZFQrzrMwPefU56qyH7jKS1a8uW5JwircaUVT1MEFjkCxXB+um5+3i1ZzJtN5YlLECYIQ+01VWPflmLsTcf0DGFd3Yd3CMfEfbnUSoHAiZUh7HemNwv7idVU6nADOcqplyI0wBg/oqomNq8kg7cY1DOEJewas2N6cC6D970ATFBtEEX+RLE/L7S6nzimH2qgfq0XrAmmDRy4t1qL/tErs/dGZG6CRqI8czJ49lGvABREO7b6LUPyhdImt27/g4EV71CWoKTxx/lnqdrYDiW1wcsrrCbbKsrT9zGOc70EVBBt2eX3Cs66JVzUqYvaVKJGFbWSI1CX0qKdSm6FHwhL2JiMp//HgV29BlgQ7RlxUxi7HevuB6LP/8dx++kGxG51aiVHIJPSoqVdYrcBgedeCTe1MxlPr+d0fKfk0SsMUEIbtkGoHZw355pddBj1zusljfkhkNJUBQ7e1pyfFa338jRhCZOpvLKT7i5clzjmc+UTkUYCK7Tde0kGH9M1WoXC6Gj/TnVqp8pVzLNf6z1PWBtJi7KvjoZl4cr2PjWEU6bkx1oL/pLFszPo3a9wLzirwcjUdZ+1orunzw74grA2kpZ4aXD1Rg5n3R8MbRfdH0b5/tbyWyJPJaopUPMeAjkl3XPG8q7fec+y5hb5hrA2khZVK/VoRPUewLD7CSHsfARDj+03hNWPX3K8/wzHe09nsXIJLZI96jpkOC+fWRvTvGrfpnb5irCItPwQUmSjnxAoRRG+QvDxHWFtvE1avB4Wd4NQIShTX0LAgwj4aWXVBJ/vCKvJcDos7cEngEzyDQLhsLrV1KVMVEnxVfMtYW18PaQbpX0VbmSsFxDww9fAtnDyNWGJSdHmUi88AmSDXxDIKWrPGcuZ578GSktYG1daywGU+yVoyE5CoAQI5FKaGvbqDnarePh+hdU00WQ8/SwHjrQ6cZIjBAKEQH1Ki3aUYb7SEFbj62FZw2jOWLUMjqE5EAIOIeDJqgv5zk0qwhIgVPRrGM4U9lS+gFA/QkAaBBj+L1UTPUma+Yj7EGWaTNNcxsXX9cxAXS3j3GhOhIAlBDhOT9VGH7Yk6yMhKQmrCf9EPK0D8GRdHx/FCJnqMwRCnJdP88lRG7vQSk1Yja+I8fQiBuxvFxiSJwR8iICe0qJRH9pt2WTpCasxGR/Xr+LgMy2jQoKEgP8Q+CKlRbf3n9n2LA4EYQlIru7Ptw3n9JX24CFpQsD7CHDw0dVa7CbvW1q4hYEhLAFVJbiyPq5T5bjC44Y0eAQBr1xwWiw4AkVYvyTjy9MpcFQUC2QahxBwGgEGLK/SogOc1ut1fYEkLOGUxA78NwjrX3ndQWQfIdASAQX4w3Qt+q8gIhNYwvpltVWWfg8MuwTR+TRn3yHg2eu3ioVk4AmrcbU1oG4IsqFXiwU6jUMI2EeAzUxp6ij7/eTqQYS10Z8iIV9Xnl7JOestl4tpNn5GgANcCa3tVrWs5zo/z8Mp24mwWiBZUV63D3jodSbpsSWnAof0FAMBdkdKU/9UjJH8MgYRVhueSsQbngTYMX5xJNkpDwIMqKuH2nu2xtbKMytnZkKE1Q6O5+3AYz3D+hoAqjNwkxZCoH0EOPhx1VrsScKpdQSIsCxERiLecCnAbrcgSiKEQH4ISFgKJj8g2u9FhGUZVc4SceMdgP/OchcSJAQsINBJVaOVHzFRWYSaCQJEWDZDpHIQV3/W9U8YsK3NriROCDRDgDO2b3WN+ibBYh0BIizrWDWTvLqsIR5mbBkAJU8V1C2gCHAFI6qXR/8Z0OkXNG0irILgA8Q2CMZDr1ChwAKBDEB3zvld1bWxiwMwVdemSITlELTJePoUDjzikDpSIxECjGFSVU30OommVLKpEGE5DP01O9dtpzeEPndYLanzJQLstpSmXuZL0z1qNBGWS44ZU2bsn2O55wF0cmkIUutRBBhQWaVFJ3rUPF+bRYTlsvvG9+VbG6HGMjaEtctYl1p9TsnsPWN5p/+W2g6Zx6eHqIjeTcQbngfY4UUckoZyGQEGaFklvd+M5V2/c3koUk9/9UsTAxXx9PEMeKI0o9OoTiDAOSZ9Vjt34iM4jUpuOwGoRR20wrIIlFtiiXj6AwA7u6Wf9DqKwJpOULevpEPJjoJqRxkRlh20XJRNlBlDwHJ3ARjo4jCk2j4CaXB2RapWnWO/K/VwGgEiLKcRLVgfZ2P7G3tmc/ytglWRgrwR4AwTOkfUFJ3xyxtCVzoSYbkCq3NKE/H0qQCmAihzTitpagWBNZzh1uqa6ARCx7sIEGF51zebWVZRlt6ZKWwWOD/UR2Z72FT+HcuFTq/6JDLfw0aSaZsgQITl43CoKKu/iDE2CWBb+3gaRTSd/QTg0ZSmXlTEQWkoBxEgwnIQzFKquroP7xCKGWcwcHEUhGp2bXDGGjDMzmVyd8/4tMNnpfQPje0MAkRYzuDoOS3iFiDsAPXnUPoWxlhQVhRv8lBuxN7LYp+fBkb7ozwXlYUbRIRVOIa+0pDY4effsFD4TM6UI4HcbgDbyk8T4IDBwN7m4C/nwB6+SVPf9ZP9ZGthCBBhFYafNL2TA77twrNdemXA+0QQOhPgB3MgXpIJctSB4dEczy0AU/6rhtVvpi5l35fEFhrUUwj8Pye4FXpG5At+AAAAAElFTkSuQmCC";
        },
        function(e, t, n) {
            "use strict";
            Object.defineProperty(t, "__esModule", {
                value: !0
            });
            var i = n(0);
            i.__exportStar(n(111), t), i.__exportStar(n(19), t);
        },
        function(e, t, n) {
            "use strict";
            n.r(t), (function(e) {
                n.d(t, "ServerStyleSheet", function() {
                    return Ze;
                }), n.d(t, "StyleSheetConsumer", function() {
                    return re;
                }), n.d(t, "StyleSheetContext", function() {
                    return ie;
                }), n.d(t, "StyleSheetManager", function() {
                    return Ie;
                }), n.d(t, "ThemeConsumer", function() {
                    return ve;
                }), n.d(t, "ThemeContext", function() {
                    return Oe;
                }), n.d(t, "ThemeProvider", function() {
                    return be;
                }), n.d(t, "__PRIVATE__", function() {
                    return Re;
                }), n.d(t, "createGlobalStyle", function() {
                    return Pe;
                }), n.d(t, "css", function() {
                    return ye;
                }), n.d(t, "isStyledComponent", function() {
                    return y;
                }), n.d(t, "keyframes", function() {
                    return Ue;
                }), n.d(t, "useTheme", function() {
                    return Be;
                }), n.d(t, "version", function() {
                    return w;
                }), n.d(t, "withTheme", function() {
                    return Ge;
                });
                var i = n(6), r = n(1), M = n.n(r), u = n(22), o = n.n(u), c = n(23), a = n(24), I = n(8), l = n(7), N = n.n(l);
                function j() {
                    return (j = Object.assign || function(e) {
                        for(var t = 1; t < arguments.length; t++){
                            var n = arguments[t];
                            for(var i in n)Object.prototype.hasOwnProperty.call(n, i) && (e[i] = n[i]);
                        }
                        return e;
                    }).apply(this, arguments);
                }
                var g = function(e, t) {
                    for(var n = [
                        e[0]
                    ], i = 0, r = t.length; i < r; i += 1)n.push(t[i], e[i + 1]);
                    return n;
                }, s = function(e) {
                    return null !== e && "object" == typeof e && "[object Object]" === (e.toString ? e.toString() : Object.prototype.toString.call(e)) && !Object(i.typeOf)(e);
                }, A = Object.freeze([]), D = Object.freeze({});
                function d(e) {
                    return "function" == typeof e;
                }
                function T(e) {
                    return e.displayName || e.name || "Component";
                }
                function y(e) {
                    return e && "string" == typeof e.styledComponentId;
                }
                var z = void 0 !== e && (e.env.REACT_APP_SC_ATTR || e.env.SC_ATTR) || "data-styled", w = "5.3.3", f = "undefined" != typeof window && "HTMLElement" in window, L = Boolean("boolean" == typeof SC_DISABLE_SPEEDY ? SC_DISABLE_SPEEDY : void 0 !== e && void 0 !== e.env.REACT_APP_SC_DISABLE_SPEEDY && "" !== e.env.REACT_APP_SC_DISABLE_SPEEDY ? "false" !== e.env.REACT_APP_SC_DISABLE_SPEEDY && e.env.REACT_APP_SC_DISABLE_SPEEDY : void 0 !== e && void 0 !== e.env.SC_DISABLE_SPEEDY && "" !== e.env.SC_DISABLE_SPEEDY && "false" !== e.env.SC_DISABLE_SPEEDY && e.env.SC_DISABLE_SPEEDY), E = {};
                function C(e) {
                    for(var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), i = 1; i < t; i++)n[i - 1] = arguments[i];
                    throw new Error("An error occurred. See https://git.io/JUIaE#" + e + " for more information." + (n.length > 0 ? " Args: " + n.join(", ") : ""));
                }
                var x = function() {
                    function e(e) {
                        this.groupSizes = new Uint32Array(512), this.length = 512, this.tag = e;
                    }
                    var t = e.prototype;
                    return t.indexOfGroup = function(e) {
                        for(var t = 0, n = 0; n < e; n++)t += this.groupSizes[n];
                        return t;
                    }, t.insertRules = function(e, t) {
                        if (e >= this.groupSizes.length) {
                            for(var n = this.groupSizes, i = n.length, r = i; e >= r;)(r <<= 1) < 0 && C(16, "" + e);
                            this.groupSizes = new Uint32Array(r), this.groupSizes.set(n), this.length = r;
                            for(var M = i; M < r; M++)this.groupSizes[M] = 0;
                        }
                        for(var u = this.indexOfGroup(e + 1), o = 0, c = t.length; o < c; o++)this.tag.insertRule(u, t[o]) && (this.groupSizes[e]++, u++);
                    }, t.clearGroup = function(e) {
                        if (e < this.length) {
                            var t = this.groupSizes[e], n = this.indexOfGroup(e), i = n + t;
                            this.groupSizes[e] = 0;
                            for(var r = n; r < i; r++)this.tag.deleteRule(n);
                        }
                    }, t.getGroup = function(e) {
                        var t = "";
                        if (e >= this.length || 0 === this.groupSizes[e]) return t;
                        for(var n = this.groupSizes[e], i = this.indexOfGroup(e), r = i + n, M = i; M < r; M++)t += this.tag.getRule(M) + "/*!sc*/\n";
                        return t;
                    }, e;
                }(), p = new Map, S = new Map, m = 1, O = function(e) {
                    if (p.has(e)) return p.get(e);
                    for(; S.has(m);)m++;
                    var t = m++;
                    return p.set(e, t), S.set(t, e), t;
                }, v = function(e) {
                    return S.get(e);
                }, b = function(e, t) {
                    t >= m && (m = t + 1), p.set(e, t), S.set(t, e);
                }, h = "style[" + z + '][data-styled-version="5.3.3"]', k = new RegExp("^" + z + '\\.g(\\d+)\\[id="([\\w\\d-]+)"\\].*?"([^"]*)'), Q = function(e, t, n) {
                    for(var i, r = n.split(","), M = 0, u = r.length; M < u; M++)(i = r[M]) && e.registerName(t, i);
                }, Y = function(e, t) {
                    for(var n = (t.textContent || "").split("/*!sc*/\n"), i = [], r = 0, M = n.length; r < M; r++){
                        var u = n[r].trim();
                        if (u) {
                            var o = u.match(k);
                            if (o) {
                                var c = 0 | parseInt(o[1], 10), a = o[2];
                                0 !== c && (b(a, c), Q(e, a, o[3]), e.getTag().insertRules(c, i)), i.length = 0;
                            } else i.push(u);
                        }
                    }
                }, P = function() {
                    return "undefined" != typeof window && void 0 !== window.__webpack_nonce__ ? window.__webpack_nonce__ : null;
                }, U = function(e) {
                    var t = document.head, n = e || t, i = document.createElement("style"), r = function(e) {
                        for(var t = e.childNodes, n = t.length; n >= 0; n--){
                            var i = t[n];
                            if (i && 1 === i.nodeType && i.hasAttribute(z)) return i;
                        }
                    }(n), M = void 0 !== r ? r.nextSibling : null;
                    i.setAttribute(z, "active"), i.setAttribute("data-styled-version", "5.3.3");
                    var u = P();
                    return u && i.setAttribute("nonce", u), n.insertBefore(i, M), i;
                }, Z = function() {
                    function e(e) {
                        var t = this.element = U(e);
                        t.appendChild(document.createTextNode("")), this.sheet = function(e) {
                            if (e.sheet) return e.sheet;
                            for(var t = document.styleSheets, n = 0, i = t.length; n < i; n++){
                                var r = t[n];
                                if (r.ownerNode === e) return r;
                            }
                            C(17);
                        }(t), this.length = 0;
                    }
                    var t = e.prototype;
                    return t.insertRule = function(e, t) {
                        try {
                            return this.sheet.insertRule(t, e), this.length++, !0;
                        } catch (e) {
                            return !1;
                        }
                    }, t.deleteRule = function(e) {
                        this.sheet.deleteRule(e), this.length--;
                    }, t.getRule = function(e) {
                        var t = this.sheet.cssRules[e];
                        return void 0 !== t && "string" == typeof t.cssText ? t.cssText : "";
                    }, e;
                }(), G = function() {
                    function e(e) {
                        var t = this.element = U(e);
                        this.nodes = t.childNodes, this.length = 0;
                    }
                    var t = e.prototype;
                    return t.insertRule = function(e, t) {
                        if (e <= this.length && e >= 0) {
                            var n = document.createTextNode(t), i = this.nodes[e];
                            return this.element.insertBefore(n, i || null), this.length++, !0;
                        }
                        return !1;
                    }, t.deleteRule = function(e) {
                        this.element.removeChild(this.nodes[e]), this.length--;
                    }, t.getRule = function(e) {
                        return e < this.length ? this.nodes[e].textContent : "";
                    }, e;
                }(), B = function() {
                    function e(e) {
                        this.rules = [], this.length = 0;
                    }
                    var t = e.prototype;
                    return t.insertRule = function(e, t) {
                        return e <= this.length && (this.rules.splice(e, 0, t), this.length++, !0);
                    }, t.deleteRule = function(e) {
                        this.rules.splice(e, 1), this.length--;
                    }, t.getRule = function(e) {
                        return e < this.length ? this.rules[e] : "";
                    }, e;
                }(), R = f, W = {
                    isServer: !f,
                    useCSSOMInjection: !L
                }, H = function() {
                    function e(e, t, n) {
                        void 0 === e && (e = D), void 0 === t && (t = {}), this.options = j({}, W, {}, e), this.gs = t, this.names = new Map(n), this.server = !!e.isServer, !this.server && f && R && (R = !1, function(e) {
                            for(var t = document.querySelectorAll(h), n = 0, i = t.length; n < i; n++){
                                var r = t[n];
                                r && "active" !== r.getAttribute(z) && (Y(e, r), r.parentNode && r.parentNode.removeChild(r));
                            }
                        }(this));
                    }
                    e.registerId = function(e) {
                        return O(e);
                    };
                    var t = e.prototype;
                    return t.reconstructWithOptions = function(t, n) {
                        return void 0 === n && (n = !0), new e(j({}, this.options, {}, t), this.gs, n && this.names || void 0);
                    }, t.allocateGSInstance = function(e) {
                        return this.gs[e] = (this.gs[e] || 0) + 1;
                    }, t.getTag = function() {
                        var e, t, n, i, r;
                        return this.tag || (this.tag = (n = (t = this.options).isServer, i = t.useCSSOMInjection, r = t.target, e = n ? new B(r) : i ? new Z(r) : new G(r), new x(e)));
                    }, t.hasNameForId = function(e, t) {
                        return this.names.has(e) && this.names.get(e).has(t);
                    }, t.registerName = function(e, t) {
                        if (O(e), this.names.has(e)) this.names.get(e).add(t);
                        else {
                            var n = new Set;
                            n.add(t), this.names.set(e, n);
                        }
                    }, t.insertRules = function(e, t, n) {
                        this.registerName(e, t), this.getTag().insertRules(O(e), n);
                    }, t.clearNames = function(e) {
                        this.names.has(e) && this.names.get(e).clear();
                    }, t.clearRules = function(e) {
                        this.getTag().clearGroup(O(e)), this.clearNames(e);
                    }, t.clearTag = function() {
                        this.tag = void 0;
                    }, t.toString = function() {
                        return function(e) {
                            for(var t = e.getTag(), n = t.length, i = "", r = 0; r < n; r++){
                                var M = v(r);
                                if (void 0 !== M) {
                                    var u = e.names.get(M), o = t.getGroup(r);
                                    if (u && o && u.size) {
                                        var c = z + ".g" + r + '[id="' + M + '"]', a = "";
                                        void 0 !== u && u.forEach(function(e) {
                                            e.length > 0 && (a += e + ",");
                                        }), i += "" + o + c + '{content:"' + a + '"}/*!sc*/\n';
                                    }
                                }
                            }
                            return i;
                        }(this);
                    }, e;
                }(), V = /(a)(d)/gi, J = function(e) {
                    return String.fromCharCode(e + (e > 25 ? 39 : 97));
                };
                function F(e) {
                    var t, n = "";
                    for(t = Math.abs(e); t > 52; t = t / 52 | 0)n = J(t % 52) + n;
                    return (J(t % 52) + n).replace(V, "$1-$2");
                }
                var X = function(e, t) {
                    for(var n = t.length; n;)e = 33 * e ^ t.charCodeAt(--n);
                    return e;
                }, K = function(e) {
                    return X(5381, e);
                };
                function q(e) {
                    for(var t = 0; t < e.length; t += 1){
                        var n = e[t];
                        if (d(n) && !y(n)) return !1;
                    }
                    return !0;
                }
                var _ = K("5.3.3"), $ = function() {
                    function e(e, t, n) {
                        this.rules = e, this.staticRulesId = "", this.isStatic = (void 0 === n || n.isStatic) && q(e), this.componentId = t, this.baseHash = X(_, t), this.baseStyle = n, H.registerId(t);
                    }
                    return e.prototype.generateAndInjectStyles = function(e, t, n) {
                        var i = this.componentId, r = [];
                        if (this.baseStyle && r.push(this.baseStyle.generateAndInjectStyles(e, t, n)), this.isStatic && !n.hash) {
                            if (this.staticRulesId && t.hasNameForId(i, this.staticRulesId)) r.push(this.staticRulesId);
                            else {
                                var M = de(this.rules, e, t, n).join(""), u = F(X(this.baseHash, M) >>> 0);
                                if (!t.hasNameForId(i, u)) {
                                    var o = n(M, "." + u, void 0, i);
                                    t.insertRules(i, u, o);
                                }
                                r.push(u), this.staticRulesId = u;
                            }
                        } else {
                            for(var c = this.rules.length, a = X(this.baseHash, n.hash), I = "", l = 0; l < c; l++){
                                var N = this.rules[l];
                                if ("string" == typeof N) I += N;
                                else if (N) {
                                    var j = de(N, e, t, n), g = Array.isArray(j) ? j.join("") : j;
                                    a = X(a, g + l), I += g;
                                }
                            }
                            if (I) {
                                var s = F(a >>> 0);
                                if (!t.hasNameForId(i, s)) {
                                    var A = n(I, "." + s, void 0, i);
                                    t.insertRules(i, s, A);
                                }
                                r.push(s);
                            }
                        }
                        return r.join(" ");
                    }, e;
                }(), ee = /^\s*\/\/.*$/gm, te = [
                    ":",
                    "[",
                    ".",
                    "#"
                ];
                function ne(e) {
                    var t, n, i, r, M = void 0 === e ? D : e, u = M.options, o = void 0 === u ? D : u, a = M.plugins, I = void 0 === a ? A : a, l = new c.a(o), N = [], j = function(e) {
                        function t(t) {
                            if (t) try {
                                e(t + "}");
                            } catch (e) {}
                        }
                        return function(n, i, r, M, u, o, c, a, I, l) {
                            switch(n){
                                case 1:
                                    if (0 === I && 64 === i.charCodeAt(0)) return e(i + ";"), "";
                                    break;
                                case 2:
                                    if (0 === a) return i + "/*|*/";
                                    break;
                                case 3:
                                    switch(a){
                                        case 102:
                                        case 112:
                                            return e(r[0] + i), "";
                                        default:
                                            return i + (0 === l ? "/*|*/" : "");
                                    }
                                case -2:
                                    i.split("/*|*/}").forEach(t);
                            }
                        };
                    }(function(e) {
                        N.push(e);
                    }), g = function(e, i, M) {
                        return 0 === i && -1 !== te.indexOf(M[n.length]) || M.match(r) ? e : "." + t;
                    };
                    function s(e, M, u, o) {
                        void 0 === o && (o = "&");
                        var c = e.replace(ee, ""), a = M && u ? u + " " + M + " { " + c + " }" : c;
                        return t = o, n = M, i = new RegExp("\\" + n + "\\b", "g"), r = new RegExp("(\\" + n + "\\b){2,}"), l(u || !M ? "" : M, a);
                    }
                    return l.use([].concat(I, [
                        function(e, t, r) {
                            2 === e && r.length && r[0].lastIndexOf(n) > 0 && (r[0] = r[0].replace(i, g));
                        },
                        j,
                        function(e) {
                            if (-2 === e) {
                                var t = N;
                                return N = [], t;
                            }
                        }
                    ])), s.hash = I.length ? I.reduce(function(e, t) {
                        return t.name || C(15), X(e, t.name);
                    }, 5381).toString() : "", s;
                }
                var ie = M.a.createContext(), re = ie.Consumer, Me = M.a.createContext(), ue = (Me.Consumer, new H), oe = ne();
                function ce() {
                    return Object(r.useContext)(ie) || ue;
                }
                function ae() {
                    return Object(r.useContext)(Me) || oe;
                }
                function Ie(e) {
                    var t = Object(r.useState)(e.stylisPlugins), n = t[0], i = t[1], u = ce(), c = Object(r.useMemo)(function() {
                        var t = u;
                        return e.sheet ? t = e.sheet : e.target && (t = t.reconstructWithOptions({
                            target: e.target
                        }, !1)), e.disableCSSOMInjection && (t = t.reconstructWithOptions({
                            useCSSOMInjection: !1
                        })), t;
                    }, [
                        e.disableCSSOMInjection,
                        e.sheet,
                        e.target
                    ]), a = Object(r.useMemo)(function() {
                        return ne({
                            options: {
                                prefix: !e.disableVendorPrefixes
                            },
                            plugins: n
                        });
                    }, [
                        e.disableVendorPrefixes,
                        n
                    ]);
                    return Object(r.useEffect)(function() {
                        o()(n, e.stylisPlugins) || i(e.stylisPlugins);
                    }, [
                        e.stylisPlugins
                    ]), M.a.createElement(ie.Provider, {
                        value: c
                    }, M.a.createElement(Me.Provider, {
                        value: a
                    }, e.children));
                }
                var le = function() {
                    function e(e, t) {
                        var n = this;
                        this.inject = function(e, t) {
                            void 0 === t && (t = oe);
                            var i = n.name + t.hash;
                            e.hasNameForId(n.id, i) || e.insertRules(n.id, i, t(n.rules, i, "@keyframes"));
                        }, this.toString = function() {
                            return C(12, String(n.name));
                        }, this.name = e, this.id = "sc-keyframes-" + e, this.rules = t;
                    }
                    return e.prototype.getName = function(e) {
                        return void 0 === e && (e = oe), this.name + e.hash;
                    }, e;
                }(), Ne = /([A-Z])/, je = /([A-Z])/g, ge = /^ms-/, se = function(e) {
                    return "-" + e.toLowerCase();
                };
                function Ae(e) {
                    return Ne.test(e) ? e.replace(je, se).replace(ge, "-ms-") : e;
                }
                var De = function(e) {
                    return null == e || !1 === e || "" === e;
                };
                function de(e, t, n, i) {
                    if (Array.isArray(e)) {
                        for(var r, M = [], u = 0, o = e.length; u < o; u += 1)"" !== (r = de(e[u], t, n, i)) && (Array.isArray(r) ? M.push.apply(M, r) : M.push(r));
                        return M;
                    }
                    var c;
                    return De(e) ? "" : y(e) ? "." + e.styledComponentId : d(e) ? "function" != typeof (c = e) || c.prototype && c.prototype.isReactComponent || !t ? e : de(e(t), t, n, i) : e instanceof le ? n ? (e.inject(n, i), e.getName(i)) : e : s(e) ? function e(t, n) {
                        var i, r, M = [];
                        for(var u in t)t.hasOwnProperty(u) && !De(t[u]) && (Array.isArray(t[u]) && t[u].isCss || d(t[u]) ? M.push(Ae(u) + ":", t[u], ";") : s(t[u]) ? M.push.apply(M, e(t[u], u)) : M.push(Ae(u) + ": " + (i = u, (null == (r = t[u]) || "boolean" == typeof r || "" === r ? "" : "number" != typeof r || 0 === r || i in a.a ? String(r).trim() : r + "px") + ";")));
                        return n ? [
                            n + " {"
                        ].concat(M, [
                            "}"
                        ]) : M;
                    }(e) : e.toString();
                }
                var Te = function(e) {
                    return Array.isArray(e) && (e.isCss = !0), e;
                };
                function ye(e) {
                    for(var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), i = 1; i < t; i++)n[i - 1] = arguments[i];
                    return d(e) || s(e) ? Te(de(g(A, [
                        e
                    ].concat(n)))) : 0 === n.length && 1 === e.length && "string" == typeof e[0] ? e : Te(de(g(e, n)));
                }
                new Set;
                var ze = function(e, t, n) {
                    return void 0 === n && (n = D), e.theme !== n.theme && e.theme || t || n.theme;
                }, we = /[!"#$%&'()*+,./:;<=>?@[\\\]^`{|}~-]+/g, fe = /(^-|-$)/g;
                function Le(e) {
                    return e.replace(we, "-").replace(fe, "");
                }
                var Ee = function(e) {
                    return F(K(e) >>> 0);
                };
                function Ce(e) {
                    return "string" == typeof e && !0;
                }
                var xe = function(e) {
                    return "function" == typeof e || "object" == typeof e && null !== e && !Array.isArray(e);
                }, pe = function(e) {
                    return "__proto__" !== e && "constructor" !== e && "prototype" !== e;
                };
                function Se(e, t, n) {
                    var i = e[n];
                    xe(t) && xe(i) ? me(i, t) : e[n] = t;
                }
                function me(e) {
                    for(var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), i = 1; i < t; i++)n[i - 1] = arguments[i];
                    for(var r = 0, M = n; r < M.length; r++){
                        var u = M[r];
                        if (xe(u)) for(var o in u)pe(o) && Se(e, u[o], o);
                    }
                    return e;
                }
                var Oe = M.a.createContext(), ve = Oe.Consumer;
                function be(e) {
                    var t = Object(r.useContext)(Oe), n = Object(r.useMemo)(function() {
                        return function(e, t) {
                            return e ? d(e) ? e(t) : Array.isArray(e) || "object" != typeof e ? C(8) : t ? j({}, t, {}, e) : e : C(14);
                        }(e.theme, t);
                    }, [
                        e.theme,
                        t
                    ]);
                    return e.children ? M.a.createElement(Oe.Provider, {
                        value: n
                    }, e.children) : null;
                }
                var he = {};
                function ke(e, t, n) {
                    var i = y(e), u = !Ce(e), o = t.attrs, c = void 0 === o ? A : o, a = t.componentId, l = void 0 === a ? function(e, t) {
                        var n = "string" != typeof e ? "sc" : Le(e);
                        he[n] = (he[n] || 0) + 1;
                        var i = n + "-" + Ee("5.3.3" + n + he[n]);
                        return t ? t + "-" + i : i;
                    }(t.displayName, t.parentComponentId) : a, g = t.displayName, s = void 0 === g ? function(e) {
                        return Ce(e) ? "styled." + e : "Styled(" + T(e) + ")";
                    }(e) : g, z = t.displayName && t.componentId ? Le(t.displayName) + "-" + t.componentId : t.componentId || l, w = i && e.attrs ? Array.prototype.concat(e.attrs, c).filter(Boolean) : c, f = t.shouldForwardProp;
                    i && e.shouldForwardProp && (f = t.shouldForwardProp ? function(n, i, r) {
                        return e.shouldForwardProp(n, i, r) && t.shouldForwardProp(n, i, r);
                    } : e.shouldForwardProp);
                    var L, E = new $(n, z, i ? e.componentStyle : void 0), C = E.isStatic && 0 === c.length, x = function(e, t) {
                        return function(e, t, n, i) {
                            var M = e.attrs, u = e.componentStyle, o = e.defaultProps, c = e.foldedComponentIds, a = e.shouldForwardProp, l = e.styledComponentId, N = e.target, g = function(e, t, n) {
                                void 0 === e && (e = D);
                                var i = j({}, t, {
                                    theme: e
                                }), r = {};
                                return n.forEach(function(e) {
                                    var t, n, M, u = e;
                                    for(t in d(u) && (u = u(i)), u)i[t] = r[t] = "className" === t ? (n = r[t], M = u[t], n && M ? n + " " + M : n || M) : u[t];
                                }), [
                                    i,
                                    r
                                ];
                            }(ze(t, Object(r.useContext)(Oe), o) || D, t, M), s = g[0], A = g[1], T = function(e, t, n, i) {
                                var r = ce(), M = ae();
                                return t ? e.generateAndInjectStyles(D, r, M) : e.generateAndInjectStyles(n, r, M);
                            }(u, i, s), y = n, z = A.$as || t.$as || A.as || t.as || N, w = Ce(z), f = A !== t ? j({}, t, {}, A) : t, L = {};
                            for(var E in f)"$" !== E[0] && "as" !== E && ("forwardedAs" === E ? L.as = f[E] : (a ? a(E, I.a, z) : !w || Object(I.a)(E)) && (L[E] = f[E]));
                            return t.style && A.style !== t.style && (L.style = j({}, t.style, {}, A.style)), L.className = Array.prototype.concat(c, l, T !== l ? T : null, t.className, A.className).filter(Boolean).join(" "), L.ref = y, Object(r.createElement)(z, L);
                        }(L, e, t, C);
                    };
                    return x.displayName = s, (L = M.a.forwardRef(x)).attrs = w, L.componentStyle = E, L.displayName = s, L.shouldForwardProp = f, L.foldedComponentIds = i ? Array.prototype.concat(e.foldedComponentIds, e.styledComponentId) : A, L.styledComponentId = z, L.target = i ? e.target : e, L.withComponent = function(e) {
                        var i = t.componentId, r = function(e, t) {
                            if (null == e) return {};
                            var n, i, r = {}, M = Object.keys(e);
                            for(i = 0; i < M.length; i++)n = M[i], t.indexOf(n) >= 0 || (r[n] = e[n]);
                            return r;
                        }(t, [
                            "componentId"
                        ]), M = i && i + "-" + (Ce(e) ? e : Le(T(e)));
                        return ke(e, j({}, r, {
                            attrs: w,
                            componentId: M
                        }), n);
                    }, Object.defineProperty(L, "defaultProps", {
                        get: function() {
                            return this._foldedDefaultProps;
                        },
                        set: function(t) {
                            this._foldedDefaultProps = i ? me({}, e.defaultProps, t) : t;
                        }
                    }), L.toString = function() {
                        return "." + L.styledComponentId;
                    }, u && N()(L, e, {
                        attrs: !0,
                        componentStyle: !0,
                        displayName: !0,
                        foldedComponentIds: !0,
                        shouldForwardProp: !0,
                        styledComponentId: !0,
                        target: !0,
                        withComponent: !0
                    }), L;
                }
                var Qe = function(e) {
                    return function e(t, n, r) {
                        if (void 0 === r && (r = D), !Object(i.isValidElementType)(n)) return C(1, String(n));
                        var M = function() {
                            return t(n, r, ye.apply(void 0, arguments));
                        };
                        return M.withConfig = function(i) {
                            return e(t, n, j({}, r, {}, i));
                        }, M.attrs = function(i) {
                            return e(t, n, j({}, r, {
                                attrs: Array.prototype.concat(r.attrs, i).filter(Boolean)
                            }));
                        }, M;
                    }(ke, e);
                };
                [
                    "a",
                    "abbr",
                    "address",
                    "area",
                    "article",
                    "aside",
                    "audio",
                    "b",
                    "base",
                    "bdi",
                    "bdo",
                    "big",
                    "blockquote",
                    "body",
                    "br",
                    "button",
                    "canvas",
                    "caption",
                    "cite",
                    "code",
                    "col",
                    "colgroup",
                    "data",
                    "datalist",
                    "dd",
                    "del",
                    "details",
                    "dfn",
                    "dialog",
                    "div",
                    "dl",
                    "dt",
                    "em",
                    "embed",
                    "fieldset",
                    "figcaption",
                    "figure",
                    "footer",
                    "form",
                    "h1",
                    "h2",
                    "h3",
                    "h4",
                    "h5",
                    "h6",
                    "head",
                    "header",
                    "hgroup",
                    "hr",
                    "html",
                    "i",
                    "iframe",
                    "img",
                    "input",
                    "ins",
                    "kbd",
                    "keygen",
                    "label",
                    "legend",
                    "li",
                    "link",
                    "main",
                    "map",
                    "mark",
                    "marquee",
                    "menu",
                    "menuitem",
                    "meta",
                    "meter",
                    "nav",
                    "noscript",
                    "object",
                    "ol",
                    "optgroup",
                    "option",
                    "output",
                    "p",
                    "param",
                    "picture",
                    "pre",
                    "progress",
                    "q",
                    "rp",
                    "rt",
                    "ruby",
                    "s",
                    "samp",
                    "script",
                    "section",
                    "select",
                    "small",
                    "source",
                    "span",
                    "strong",
                    "style",
                    "sub",
                    "summary",
                    "sup",
                    "table",
                    "tbody",
                    "td",
                    "textarea",
                    "tfoot",
                    "th",
                    "thead",
                    "time",
                    "title",
                    "tr",
                    "track",
                    "u",
                    "ul",
                    "var",
                    "video",
                    "wbr",
                    "circle",
                    "clipPath",
                    "defs",
                    "ellipse",
                    "foreignObject",
                    "g",
                    "image",
                    "line",
                    "linearGradient",
                    "marker",
                    "mask",
                    "path",
                    "pattern",
                    "polygon",
                    "polyline",
                    "radialGradient",
                    "rect",
                    "stop",
                    "svg",
                    "text",
                    "textPath",
                    "tspan"
                ].forEach(function(e) {
                    Qe[e] = Qe(e);
                });
                var Ye = function() {
                    function e(e, t) {
                        this.rules = e, this.componentId = t, this.isStatic = q(e), H.registerId(this.componentId + 1);
                    }
                    var t = e.prototype;
                    return t.createStyles = function(e, t, n, i) {
                        var r = i(de(this.rules, t, n, i).join(""), ""), M = this.componentId + e;
                        n.insertRules(M, M, r);
                    }, t.removeStyles = function(e, t) {
                        t.clearRules(this.componentId + e);
                    }, t.renderStyles = function(e, t, n, i) {
                        e > 2 && H.registerId(this.componentId + e), this.removeStyles(e, n), this.createStyles(e, t, n, i);
                    }, e;
                }();
                function Pe(e) {
                    for(var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), i = 1; i < t; i++)n[i - 1] = arguments[i];
                    var u = ye.apply(void 0, [
                        e
                    ].concat(n)), o = "sc-global-" + Ee(JSON.stringify(u)), c = new Ye(u, o);
                    function a(e) {
                        var t = ce(), n = ae(), i = Object(r.useContext)(Oe), M = Object(r.useRef)(t.allocateGSInstance(o)).current;
                        return t.server && I(M, e, t, i, n), Object(r.useLayoutEffect)(function() {
                            if (!t.server) return I(M, e, t, i, n), function() {
                                return c.removeStyles(M, t);
                            };
                        }, [
                            M,
                            e,
                            t,
                            i,
                            n
                        ]), null;
                    }
                    function I(e, t, n, i, r) {
                        if (c.isStatic) c.renderStyles(e, E, n, r);
                        else {
                            var M = j({}, t, {
                                theme: ze(t, i, a.defaultProps)
                            });
                            c.renderStyles(e, M, n, r);
                        }
                    }
                    return M.a.memo(a);
                }
                function Ue(e) {
                    for(var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), i = 1; i < t; i++)n[i - 1] = arguments[i];
                    var r = ye.apply(void 0, [
                        e
                    ].concat(n)).join(""), M = Ee(r);
                    return new le(M, r);
                }
                var Ze = function() {
                    function e() {
                        var e = this;
                        this._emitSheetCSS = function() {
                            var t = e.instance.toString();
                            if (!t) return "";
                            var n = P();
                            return "<style " + [
                                n && 'nonce="' + n + '"',
                                z + '="true"',
                                'data-styled-version="5.3.3"'
                            ].filter(Boolean).join(" ") + ">" + t + "</style>";
                        }, this.getStyleTags = function() {
                            return e.sealed ? C(2) : e._emitSheetCSS();
                        }, this.getStyleElement = function() {
                            var t;
                            if (e.sealed) return C(2);
                            var n = ((t = {})[z] = "", t["data-styled-version"] = "5.3.3", t.dangerouslySetInnerHTML = {
                                __html: e.instance.toString()
                            }, t), i = P();
                            return i && (n.nonce = i), [
                                M.a.createElement("style", j({}, n, {
                                    key: "sc-0-0"
                                }))
                            ];
                        }, this.seal = function() {
                            e.sealed = !0;
                        }, this.instance = new H({
                            isServer: !0
                        }), this.sealed = !1;
                    }
                    var t = e.prototype;
                    return t.collectStyles = function(e) {
                        return this.sealed ? C(2) : M.a.createElement(Ie, {
                            sheet: this.instance
                        }, e);
                    }, t.interleaveWithNodeStream = function(e) {
                        return C(3);
                    }, e;
                }(), Ge = function(e) {
                    var t = M.a.forwardRef(function(t, n) {
                        var i = Object(r.useContext)(Oe), u = e.defaultProps, o = ze(t, i, u);
                        return M.a.createElement(e, j({}, t, {
                            theme: o,
                            ref: n
                        }));
                    });
                    return N()(t, e), t.displayName = "WithTheme(" + T(e) + ")", t;
                }, Be = function() {
                    return Object(r.useContext)(Oe);
                }, Re = {
                    StyleSheet: H,
                    masterSheet: ue
                };
                t.default = Qe;
            }).call(this, n(11));
        },
        function(e, t, n) {
            "use strict";
            Object.defineProperty(t, "__esModule", {
                value: !0
            }), t.Provider = void 0;
            var i, r, M, u, o, c = n(0), a = c.__importStar(n(1)), I = c.__importDefault(n(18)), l = n(2), N = I.default.div(i || (i = c.__makeTemplateObject([
                "\n  width: 45px;\n  height: 45px;\n  display: flex;\n  border-radius: 50%;\n  overflow: visible;\n  box-shadow: none;\n  justify-content: center;\n  align-items: center;\n  & img {\n    width: 100%;\n    height: 100%;\n  }\n\n  @media screen and (max-width: 768px) {\n    width: 8.5vw;\n    height: 8.5vw;\n  }\n"
            ], [
                "\n  width: 45px;\n  height: 45px;\n  display: flex;\n  border-radius: 50%;\n  overflow: visible;\n  box-shadow: none;\n  justify-content: center;\n  align-items: center;\n  & img {\n    width: 100%;\n    height: 100%;\n  }\n\n  @media screen and (max-width: 768px) {\n    width: 8.5vw;\n    height: 8.5vw;\n  }\n"
            ]))), j = I.default.div(r || (r = c.__makeTemplateObject([
                "\n  width: 100%;\n  font-size: 24px;\n  font-weight: 700;\n  margin-top: 0.5em;\n  color: ",
                ";\n  @media screen and (max-width: 768px) {\n    font-size: 5vw;\n  }\n"
            ], [
                "\n  width: 100%;\n  font-size: 24px;\n  font-weight: 700;\n  margin-top: 0.5em;\n  color: ",
                ";\n  @media screen and (max-width: 768px) {\n    font-size: 5vw;\n  }\n"
            ])), function(e) {
                return e.themeColors.main;
            }), g = I.default.div(M || (M = c.__makeTemplateObject([
                "\n  width: 100%;\n  font-size: 18px;\n  margin: 0.333em 0;\n  color: ",
                ";\n  @media screen and (max-width: 768px) {\n    font-size: 4vw;\n  }\n"
            ], [
                "\n  width: 100%;\n  font-size: 18px;\n  margin: 0.333em 0;\n  color: ",
                ";\n  @media screen and (max-width: 768px) {\n    font-size: 4vw;\n  }\n"
            ])), function(e) {
                return e.themeColors.secondary;
            }), s = I.default.div(u || (u = c.__makeTemplateObject([
                "\n  transition: background-color 0.2s ease-in-out;\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  background-color: ",
                ";\n  border-radius: 12px;\n  padding: 24px 16px;\n  @media screen and (max-width: 768px) {\n    padding: 1vw;\n  }\n"
            ], [
                "\n  transition: background-color 0.2s ease-in-out;\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  background-color: ",
                ";\n  border-radius: 12px;\n  padding: 24px 16px;\n  @media screen and (max-width: 768px) {\n    padding: 1vw;\n  }\n"
            ])), function(e) {
                return e.themeColors.background;
            }), A = I.default.div(o || (o = c.__makeTemplateObject([
                "\n  width: 100%;\n  padding: 8px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-direction: column;\n  cursor: pointer;\n  border-radius: 0;\n  border: ",
                ";\n  @media (hover: hover) {\n    &:hover ",
                " {\n      background-color: ",
                ";\n    }\n  }\n"
            ], [
                "\n  width: 100%;\n  padding: 8px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-direction: column;\n  cursor: pointer;\n  border-radius: 0;\n  border: ",
                ";\n  @media (hover: hover) {\n    &:hover ",
                " {\n      background-color: ",
                ";\n    }\n  }\n"
            ])), function(e) {
                return "1px solid " + e.themeColors.border;
            }, s, function(e) {
                return e.themeColors.hover;
            });
            t.Provider = function(e) {
                var t = e.name, n = e.logo, i = e.description, r = e.themeColors, M = e.onClick, u = c.__rest(e, [
                    "name",
                    "logo",
                    "description",
                    "themeColors",
                    "onClick"
                ]);
                return a.createElement(A, c.__assign({
                    themeColors: r,
                    className: l.PROVIDER_WRAPPER_CLASSNAME,
                    onClick: M
                }, u), a.createElement(s, {
                    themeColors: r,
                    className: l.PROVIDER_CONTAINER_CLASSNAME
                }, a.createElement(N, {
                    className: l.PROVIDER_ICON_CLASSNAME
                }, a.createElement("img", {
                    src: n,
                    alt: t
                })), a.createElement(j, {
                    themeColors: r,
                    className: l.PROVIDER_NAME_CLASSNAME
                }, t), a.createElement(g, {
                    themeColors: r,
                    className: l.PROVIDER_DESCRIPTION_CLASSNAME
                }, i)));
            };
        },
        function(e, t, n) {
            "use strict";
            Object.defineProperty(t, "__esModule", {
                value: !0
            });
            var i = n(0);
            i.__exportStar(n(21), t), i.__exportStar(n(118), t);
        },
        function(e, t, n) {
            "use strict";
            Object.defineProperty(t, "__esModule", {
                value: !0
            }), t.EventController = void 0;
            var i = function() {
                function e() {
                    this._eventCallbacks = [];
                }
                return e.prototype.on = function(e) {
                    this._eventCallbacks.push(e);
                }, e.prototype.off = function(e) {
                    e ? e.callback ? this._eventCallbacks = this._eventCallbacks.filter(function(t) {
                        return t.event !== e.event || t.callback !== e.callback;
                    }) : this._eventCallbacks = this._eventCallbacks.filter(function(t) {
                        return t.event !== e.event;
                    }) : this._eventCallbacks = [];
                }, e.prototype.trigger = function(e, t) {
                    var n = this._eventCallbacks.filter(function(t) {
                        return t.event === e;
                    });
                    n && n.length && n.forEach(function(e) {
                        e.callback(t);
                    });
                }, e;
            }();
            t.EventController = i;
        },
        function(e, t) {
            e.exports = function(e, t, n, i) {
                var r = n ? n.call(i, e, t) : void 0;
                if (void 0 !== r) return !!r;
                if (e === t) return !0;
                if ("object" != typeof e || !e || "object" != typeof t || !t) return !1;
                var M = Object.keys(e), u = Object.keys(t);
                if (M.length !== u.length) return !1;
                for(var o = Object.prototype.hasOwnProperty.bind(t), c = 0; c < M.length; c++){
                    var a = M[c];
                    if (!o(a)) return !1;
                    var I = e[a], l = t[a];
                    if (!1 === (r = n ? n.call(i, I, l, a) : void 0) || void 0 === r && I !== l) return !1;
                }
                return !0;
            };
        },
        function(e, t, n) {
            "use strict";
            t.a = function(e) {
                function t(e, t, i) {
                    var r = t.trim().split(g);
                    t = r;
                    var M = r.length, u = e.length;
                    switch(u){
                        case 0:
                        case 1:
                            var o = 0;
                            for(e = 0 === u ? "" : e[0] + " "; o < M; ++o)t[o] = n(e, t[o], i).trim();
                            break;
                        default:
                            var c = o = 0;
                            for(t = []; o < M; ++o)for(var a = 0; a < u; ++a)t[c++] = n(e[a] + " ", r[o], i).trim();
                    }
                    return t;
                }
                function n(e, t, n) {
                    var i = t.charCodeAt(0);
                    switch(33 > i && (i = (t = t.trim()).charCodeAt(0)), i){
                        case 38:
                            return t.replace(s, "$1" + e.trim());
                        case 58:
                            return e.trim() + t.replace(s, "$1" + e.trim());
                        default:
                            if (0 < 1 * n && 0 < t.indexOf("\f")) return t.replace(s, (58 === e.charCodeAt(0) ? "" : "$1") + e.trim());
                    }
                    return e + t;
                }
                function i(e, t, n, M) {
                    var u = e + ";", o = 2 * t + 3 * n + 4 * M;
                    if (944 === o) {
                        e = u.indexOf(":", 9) + 1;
                        var c = u.substring(e, u.length - 1).trim();
                        return c = u.substring(0, e).trim() + c + ";", 1 === S || 2 === S && r(c, 1) ? "-webkit-" + c + c : c;
                    }
                    if (0 === S || 2 === S && !r(u, 1)) return u;
                    switch(o){
                        case 1015:
                            return 97 === u.charCodeAt(10) ? "-webkit-" + u + u : u;
                        case 951:
                            return 116 === u.charCodeAt(3) ? "-webkit-" + u + u : u;
                        case 963:
                            return 110 === u.charCodeAt(5) ? "-webkit-" + u + u : u;
                        case 1009:
                            if (100 !== u.charCodeAt(4)) break;
                        case 969:
                        case 942:
                            return "-webkit-" + u + u;
                        case 978:
                            return "-webkit-" + u + "-moz-" + u + u;
                        case 1019:
                        case 983:
                            return "-webkit-" + u + "-moz-" + u + "-ms-" + u + u;
                        case 883:
                            if (45 === u.charCodeAt(8)) return "-webkit-" + u + u;
                            if (0 < u.indexOf("image-set(", 11)) return u.replace(E, "$1-webkit-$2") + u;
                            break;
                        case 932:
                            if (45 === u.charCodeAt(4)) switch(u.charCodeAt(5)){
                                case 103:
                                    return "-webkit-box-" + u.replace("-grow", "") + "-webkit-" + u + "-ms-" + u.replace("grow", "positive") + u;
                                case 115:
                                    return "-webkit-" + u + "-ms-" + u.replace("shrink", "negative") + u;
                                case 98:
                                    return "-webkit-" + u + "-ms-" + u.replace("basis", "preferred-size") + u;
                            }
                            return "-webkit-" + u + "-ms-" + u + u;
                        case 964:
                            return "-webkit-" + u + "-ms-flex-" + u + u;
                        case 1023:
                            if (99 !== u.charCodeAt(8)) break;
                            return "-webkit-box-pack" + (c = u.substring(u.indexOf(":", 15)).replace("flex-", "").replace("space-between", "justify")) + "-webkit-" + u + "-ms-flex-pack" + c + u;
                        case 1005:
                            return N.test(u) ? u.replace(l, ":-webkit-") + u.replace(l, ":-moz-") + u : u;
                        case 1e3:
                            switch(t = (c = u.substring(13).trim()).indexOf("-") + 1, c.charCodeAt(0) + c.charCodeAt(t)){
                                case 226:
                                    c = u.replace(T, "tb");
                                    break;
                                case 232:
                                    c = u.replace(T, "tb-rl");
                                    break;
                                case 220:
                                    c = u.replace(T, "lr");
                                    break;
                                default:
                                    return u;
                            }
                            return "-webkit-" + u + "-ms-" + c + u;
                        case 1017:
                            if (-1 === u.indexOf("sticky", 9)) break;
                        case 975:
                            switch(t = (u = e).length - 10, o = (c = (33 === u.charCodeAt(t) ? u.substring(0, t) : u).substring(e.indexOf(":", 7) + 1).trim()).charCodeAt(0) + (0 | c.charCodeAt(7))){
                                case 203:
                                    if (111 > c.charCodeAt(8)) break;
                                case 115:
                                    u = u.replace(c, "-webkit-" + c) + ";" + u;
                                    break;
                                case 207:
                                case 102:
                                    u = u.replace(c, "-webkit-" + (102 < o ? "inline-" : "") + "box") + ";" + u.replace(c, "-webkit-" + c) + ";" + u.replace(c, "-ms-" + c + "box") + ";" + u;
                            }
                            return u + ";";
                        case 938:
                            if (45 === u.charCodeAt(5)) switch(u.charCodeAt(6)){
                                case 105:
                                    return c = u.replace("-items", ""), "-webkit-" + u + "-webkit-box-" + c + "-ms-flex-" + c + u;
                                case 115:
                                    return "-webkit-" + u + "-ms-flex-item-" + u.replace(w, "") + u;
                                default:
                                    return "-webkit-" + u + "-ms-flex-line-pack" + u.replace("align-content", "").replace(w, "") + u;
                            }
                            break;
                        case 973:
                        case 989:
                            if (45 !== u.charCodeAt(3) || 122 === u.charCodeAt(4)) break;
                        case 931:
                        case 953:
                            if (!0 === L.test(e)) return 115 === (c = e.substring(e.indexOf(":") + 1)).charCodeAt(0) ? i(e.replace("stretch", "fill-available"), t, n, M).replace(":fill-available", ":stretch") : u.replace(c, "-webkit-" + c) + u.replace(c, "-moz-" + c.replace("fill-", "")) + u;
                            break;
                        case 962:
                            if (u = "-webkit-" + u + (102 === u.charCodeAt(5) ? "-ms-" + u : "") + u, 211 === n + M && 105 === u.charCodeAt(13) && 0 < u.indexOf("transform", 10)) return u.substring(0, u.indexOf(";", 27) + 1).replace(j, "$1-webkit-$2") + u;
                    }
                    return u;
                }
                function r(e, t) {
                    var n = e.indexOf(1 === t ? ":" : "{"), i = e.substring(0, 3 !== t ? n : 10);
                    return n = e.substring(n + 1, e.length - 1), b(2 !== t ? i : i.replace(f, "$1"), n, t);
                }
                function M(e, t) {
                    var n = i(t, t.charCodeAt(0), t.charCodeAt(1), t.charCodeAt(2));
                    return n !== t + ";" ? n.replace(z, " or ($1)").substring(4) : "(" + t + ")";
                }
                function u(e, t, n, i, r, M, u, o, a, I) {
                    for(var l, N = 0, j = t; N < v; ++N)switch(l = O[N].call(c, e, j, n, i, r, M, u, o, a, I)){
                        case void 0:
                        case !1:
                        case !0:
                        case null:
                            break;
                        default:
                            j = l;
                    }
                    if (j !== t) return j;
                }
                function o(e) {
                    return void 0 !== (e = e.prefix) && (b = null, e ? "function" != typeof e ? S = 1 : (S = 2, b = e) : S = 0), o;
                }
                function c(e, n) {
                    var o = e;
                    if (33 > o.charCodeAt(0) && (o = o.trim()), o = [
                        o
                    ], 0 < v) {
                        var c = u(-1, n, o, o, x, C, 0, 0, 0, 0);
                        void 0 !== c && "string" == typeof c && (n = c);
                    }
                    var l = function e(n, o, c, l, N) {
                        for(var j, g, s, T, z, w = 0, f = 0, L = 0, E = 0, O = 0, b = 0, k = s = j = 0, Q = 0, Y = 0, P = 0, U = 0, Z = c.length, G = Z - 1, B = "", R = "", W = "", H = ""; Q < Z;){
                            if (g = c.charCodeAt(Q), Q === G && 0 !== f + E + L + w && (0 !== f && (g = 47 === f ? 10 : 47), E = L = w = 0, Z++, G++), 0 === f + E + L + w) {
                                if (Q === G && (0 < Y && (B = B.replace(I, "")), 0 < B.trim().length)) {
                                    switch(g){
                                        case 32:
                                        case 9:
                                        case 59:
                                        case 13:
                                        case 10:
                                            break;
                                        default:
                                            B += c.charAt(Q);
                                    }
                                    g = 59;
                                }
                                switch(g){
                                    case 123:
                                        for(j = (B = B.trim()).charCodeAt(0), s = 1, U = ++Q; Q < Z;){
                                            switch(g = c.charCodeAt(Q)){
                                                case 123:
                                                    s++;
                                                    break;
                                                case 125:
                                                    s--;
                                                    break;
                                                case 47:
                                                    switch(g = c.charCodeAt(Q + 1)){
                                                        case 42:
                                                        case 47:
                                                            e: {
                                                                for(k = Q + 1; k < G; ++k)switch(c.charCodeAt(k)){
                                                                    case 47:
                                                                        if (42 === g && 42 === c.charCodeAt(k - 1) && Q + 2 !== k) {
                                                                            Q = k + 1;
                                                                            break e;
                                                                        }
                                                                        break;
                                                                    case 10:
                                                                        if (47 === g) {
                                                                            Q = k + 1;
                                                                            break e;
                                                                        }
                                                                }
                                                                Q = k;
                                                            }
                                                    }
                                                    break;
                                                case 91:
                                                    g++;
                                                case 40:
                                                    g++;
                                                case 34:
                                                case 39:
                                                    for(; Q++ < G && c.charCodeAt(Q) !== g;);
                                            }
                                            if (0 === s) break;
                                            Q++;
                                        }
                                        switch(s = c.substring(U, Q), 0 === j && (j = (B = B.replace(a, "").trim()).charCodeAt(0)), j){
                                            case 64:
                                                switch(0 < Y && (B = B.replace(I, "")), g = B.charCodeAt(1)){
                                                    case 100:
                                                    case 109:
                                                    case 115:
                                                    case 45:
                                                        Y = o;
                                                        break;
                                                    default:
                                                        Y = m;
                                                }
                                                if (U = (s = e(o, Y, s, g, N + 1)).length, 0 < v && (z = u(3, s, Y = t(m, B, P), o, x, C, U, g, N, l), B = Y.join(""), void 0 !== z && 0 === (U = (s = z.trim()).length) && (g = 0, s = "")), 0 < U) switch(g){
                                                    case 115:
                                                        B = B.replace(y, M);
                                                    case 100:
                                                    case 109:
                                                    case 45:
                                                        s = B + "{" + s + "}";
                                                        break;
                                                    case 107:
                                                        s = (B = B.replace(A, "$1 $2")) + "{" + s + "}", s = 1 === S || 2 === S && r("@" + s, 3) ? "@-webkit-" + s + "@" + s : "@" + s;
                                                        break;
                                                    default:
                                                        s = B + s, 112 === l && (R += s, s = "");
                                                }
                                                else s = "";
                                                break;
                                            default:
                                                s = e(o, t(o, B, P), s, l, N + 1);
                                        }
                                        W += s, s = P = Y = k = j = 0, B = "", g = c.charCodeAt(++Q);
                                        break;
                                    case 125:
                                    case 59:
                                        if (1 < (U = (B = (0 < Y ? B.replace(I, "") : B).trim()).length)) switch(0 === k && (j = B.charCodeAt(0), 45 === j || 96 < j && 123 > j) && (U = (B = B.replace(" ", ":")).length), 0 < v && void 0 !== (z = u(1, B, o, n, x, C, R.length, l, N, l)) && 0 === (U = (B = z.trim()).length) && (B = "\0\0"), j = B.charCodeAt(0), g = B.charCodeAt(1), j){
                                            case 0:
                                                break;
                                            case 64:
                                                if (105 === g || 99 === g) {
                                                    H += B + c.charAt(Q);
                                                    break;
                                                }
                                            default:
                                                58 !== B.charCodeAt(U - 1) && (R += i(B, j, g, B.charCodeAt(2)));
                                        }
                                        P = Y = k = j = 0, B = "", g = c.charCodeAt(++Q);
                                }
                            }
                            switch(g){
                                case 13:
                                case 10:
                                    47 === f ? f = 0 : 0 === 1 + j && 107 !== l && 0 < B.length && (Y = 1, B += "\0"), 0 < v * h && u(0, B, o, n, x, C, R.length, l, N, l), C = 1, x++;
                                    break;
                                case 59:
                                case 125:
                                    if (0 === f + E + L + w) {
                                        C++;
                                        break;
                                    }
                                default:
                                    switch(C++, T = c.charAt(Q), g){
                                        case 9:
                                        case 32:
                                            if (0 === E + w + f) switch(O){
                                                case 44:
                                                case 58:
                                                case 9:
                                                case 32:
                                                    T = "";
                                                    break;
                                                default:
                                                    32 !== g && (T = " ");
                                            }
                                            break;
                                        case 0:
                                            T = "\\0";
                                            break;
                                        case 12:
                                            T = "\\f";
                                            break;
                                        case 11:
                                            T = "\\v";
                                            break;
                                        case 38:
                                            0 === E + f + w && (Y = P = 1, T = "\f" + T);
                                            break;
                                        case 108:
                                            if (0 === E + f + w + p && 0 < k) switch(Q - k){
                                                case 2:
                                                    112 === O && 58 === c.charCodeAt(Q - 3) && (p = O);
                                                case 8:
                                                    111 === b && (p = b);
                                            }
                                            break;
                                        case 58:
                                            0 === E + f + w && (k = Q);
                                            break;
                                        case 44:
                                            0 === f + L + E + w && (Y = 1, T += "\r");
                                            break;
                                        case 34:
                                        case 39:
                                            0 === f && (E = E === g ? 0 : 0 === E ? g : E);
                                            break;
                                        case 91:
                                            0 === E + f + L && w++;
                                            break;
                                        case 93:
                                            0 === E + f + L && w--;
                                            break;
                                        case 41:
                                            0 === E + f + w && L--;
                                            break;
                                        case 40:
                                            if (0 === E + f + w) {
                                                if (0 === j) switch(2 * O + 3 * b){
                                                    case 533:
                                                        break;
                                                    default:
                                                        j = 1;
                                                }
                                                L++;
                                            }
                                            break;
                                        case 64:
                                            0 === f + L + E + w + k + s && (s = 1);
                                            break;
                                        case 42:
                                        case 47:
                                            if (!(0 < E + w + L)) switch(f){
                                                case 0:
                                                    switch(2 * g + 3 * c.charCodeAt(Q + 1)){
                                                        case 235:
                                                            f = 47;
                                                            break;
                                                        case 220:
                                                            U = Q, f = 42;
                                                    }
                                                    break;
                                                case 42:
                                                    47 === g && 42 === O && U + 2 !== Q && (33 === c.charCodeAt(U + 2) && (R += c.substring(U, Q + 1)), T = "", f = 0);
                                            }
                                    }
                                    0 === f && (B += T);
                            }
                            b = O, O = g, Q++;
                        }
                        if (0 < (U = R.length)) {
                            if (Y = o, 0 < v && void 0 !== (z = u(2, R, Y, n, x, C, U, l, N, l)) && 0 === (R = z).length) return H + R + W;
                            if (R = Y.join(",") + "{" + R + "}", 0 != S * p) {
                                switch(2 !== S || r(R, 2) || (p = 0), p){
                                    case 111:
                                        R = R.replace(d, ":-moz-$1") + R;
                                        break;
                                    case 112:
                                        R = R.replace(D, "::-webkit-input-$1") + R.replace(D, "::-moz-$1") + R.replace(D, ":-ms-input-$1") + R;
                                }
                                p = 0;
                            }
                        }
                        return H + R + W;
                    }(m, o, n, 0, 0);
                    return 0 < v && void 0 !== (c = u(-2, l, o, o, x, C, l.length, 0, 0, 0)) && (l = c), p = 0, C = x = 1, l;
                }
                var a = /^\0+/g, I = /[\0\r\f]/g, l = /: */g, N = /zoo|gra/, j = /([,: ])(transform)/g, g = /,\r+?/g, s = /([\t\r\n ])*\f?&/g, A = /@(k\w+)\s*(\S*)\s*/, D = /::(place)/g, d = /:(read-only)/g, T = /[svh]\w+-[tblr]{2}/, y = /\(\s*(.*)\s*\)/g, z = /([\s\S]*?);/g, w = /-self|flex-/g, f = /[^]*?(:[rp][el]a[\w-]+)[^]*/, L = /stretch|:\s*\w+\-(?:conte|avail)/, E = /([^-])(image-set\()/, C = 1, x = 1, p = 0, S = 1, m = [], O = [], v = 0, b = null, h = 0;
                return c.use = function e(t) {
                    switch(t){
                        case void 0:
                        case null:
                            v = O.length = 0;
                            break;
                        default:
                            if ("function" == typeof t) O[v++] = t;
                            else if ("object" == typeof t) for(var n = 0, i = t.length; n < i; ++n)e(t[n]);
                            else h = 0 | !!t;
                    }
                    return e;
                }, c.set = o, void 0 !== e && o(e), c;
            };
        },
        function(e, t, n) {
            "use strict";
            t.a = {
                animationIterationCount: 1,
                borderImageOutset: 1,
                borderImageSlice: 1,
                borderImageWidth: 1,
                boxFlex: 1,
                boxFlexGroup: 1,
                boxOrdinalGroup: 1,
                columnCount: 1,
                columns: 1,
                flex: 1,
                flexGrow: 1,
                flexPositive: 1,
                flexShrink: 1,
                flexNegative: 1,
                flexOrder: 1,
                gridRow: 1,
                gridRowEnd: 1,
                gridRowSpan: 1,
                gridRowStart: 1,
                gridColumn: 1,
                gridColumnEnd: 1,
                gridColumnSpan: 1,
                gridColumnStart: 1,
                msGridRow: 1,
                msGridRowSpan: 1,
                msGridColumn: 1,
                msGridColumnSpan: 1,
                fontWeight: 1,
                lineHeight: 1,
                opacity: 1,
                order: 1,
                orphans: 1,
                tabSize: 1,
                widows: 1,
                zIndex: 1,
                zoom: 1,
                WebkitLineClamp: 1,
                fillOpacity: 1,
                floodOpacity: 1,
                stopOpacity: 1,
                strokeDasharray: 1,
                strokeDashoffset: 1,
                strokeMiterlimit: 1,
                strokeOpacity: 1,
                strokeWidth: 1
            };
        },
        function(e, t, n) {
            "use strict";
            Object.defineProperty(t, "__esModule", {
                value: !0
            });
            var i = n(0), r = n(26);
            i.__exportStar(n(17), t), i.__exportStar(n(2), t), i.__exportStar(n(20), t), i.__exportStar(n(5), t), i.__exportStar(n(3), t), i.__exportStar(n(4), t), t.default = r.Core;
        },
        function(e, t, n) {
            "use strict";
            Object.defineProperty(t, "__esModule", {
                value: !0
            }), t.Core = void 0;
            var i = n(0), r = i.__importStar(n(1)), M = i.__importStar(n(28)), u = n(3), o = n(2), c = n(4), a = n(17), I = n(20), l = {
                show: !1
            }, N = {
                lightboxOpacity: .4,
                theme: c.themesList.default.name,
                cacheProvider: !1,
                disableInjectedProvider: !1,
                providerOptions: {},
                network: ""
            }, j = function() {
                function e(e) {
                    var t = this;
                    this.show = l.show, this.eventController = new I.EventController, this.connect = function() {
                        return new Promise(function(e, n) {
                            return i.__awaiter(t, void 0, void 0, function() {
                                return i.__generator(this, function(t) {
                                    switch(t.label){
                                        case 0:
                                            return this.on(o.CONNECT_EVENT, function(t) {
                                                return e(t);
                                            }), this.on(o.ERROR_EVENT, function(e) {
                                                return n(e);
                                            }), this.on(o.CLOSE_EVENT, function() {
                                                return n("Modal closed by user");
                                            }), [
                                                4,
                                                this.toggleModal()
                                            ];
                                        case 1:
                                            return t.sent(), [
                                                2
                                            ];
                                    }
                                });
                            });
                        });
                    }, this.connectTo = function(e) {
                        return new Promise(function(n, r) {
                            return i.__awaiter(t, void 0, void 0, function() {
                                var t;
                                return i.__generator(this, function(i) {
                                    switch(i.label){
                                        case 0:
                                            return this.on(o.CONNECT_EVENT, function(e) {
                                                return n(e);
                                            }), this.on(o.ERROR_EVENT, function(e) {
                                                return r(e);
                                            }), this.on(o.CLOSE_EVENT, function() {
                                                return r("Modal closed by user");
                                            }), (t = this.providerController.getProvider(e)) ? [
                                                4,
                                                this.providerController.connectTo(t.id, t.connector)
                                            ] : [
                                                2,
                                                r(new Error("Cannot connect to provider (" + e + "), check provider options"))
                                            ];
                                        case 1:
                                            return i.sent(), [
                                                2
                                            ];
                                    }
                                });
                            });
                        });
                    }, this._toggleModal = function() {
                        return i.__awaiter(t, void 0, void 0, function() {
                            var e, t;
                            return i.__generator(this, function(n) {
                                switch(n.label){
                                    case 0:
                                        return e = "undefined" != typeof window ? document : "", (t = e ? e.body || e.getElementsByTagName("body")[0] : "") && (this.show ? t.style.overflow = "" : t.style.overflow = "hidden"), [
                                            4,
                                            this.updateState({
                                                show: !this.show
                                            })
                                        ];
                                    case 1:
                                        return n.sent(), [
                                            2
                                        ];
                                }
                            });
                        });
                    }, this.onError = function(e) {
                        return i.__awaiter(t, void 0, void 0, function() {
                            return i.__generator(this, function(t) {
                                switch(t.label){
                                    case 0:
                                        return this.show ? [
                                            4,
                                            this._toggleModal()
                                        ] : [
                                            3,
                                            2
                                        ];
                                    case 1:
                                        t.sent(), t.label = 2;
                                    case 2:
                                        return this.eventController.trigger(o.ERROR_EVENT, e), [
                                            2
                                        ];
                                }
                            });
                        });
                    }, this.onProviderSelect = function(e) {
                        t.eventController.trigger(o.SELECT_EVENT, e);
                    }, this.onConnect = function(e) {
                        return i.__awaiter(t, void 0, void 0, function() {
                            return i.__generator(this, function(t) {
                                switch(t.label){
                                    case 0:
                                        return this.show ? [
                                            4,
                                            this._toggleModal()
                                        ] : [
                                            3,
                                            2
                                        ];
                                    case 1:
                                        t.sent(), t.label = 2;
                                    case 2:
                                        return this.eventController.trigger(o.CONNECT_EVENT, e), [
                                            2
                                        ];
                                }
                            });
                        });
                    }, this.onClose = function() {
                        return i.__awaiter(t, void 0, void 0, function() {
                            return i.__generator(this, function(e) {
                                switch(e.label){
                                    case 0:
                                        return this.show ? [
                                            4,
                                            this._toggleModal()
                                        ] : [
                                            3,
                                            2
                                        ];
                                    case 1:
                                        e.sent(), e.label = 2;
                                    case 2:
                                        return this.eventController.trigger(o.CLOSE_EVENT), [
                                            2
                                        ];
                                }
                            });
                        });
                    }, this.updateState = function(e) {
                        return i.__awaiter(t, void 0, void 0, function() {
                            var t = this;
                            return i.__generator(this, function(n) {
                                switch(n.label){
                                    case 0:
                                        return Object.keys(e).forEach(function(n) {
                                            t[n] = e[n];
                                        }), [
                                            4,
                                            window.updateWeb3Modal(e)
                                        ];
                                    case 1:
                                        return n.sent(), [
                                            2
                                        ];
                                }
                            });
                        });
                    }, this.resetState = function() {
                        return t.updateState(i.__assign({}, l));
                    };
                    var n = i.__assign(i.__assign({}, N), e);
                    this.lightboxOpacity = n.lightboxOpacity, this.themeColors = u.getThemeColors(n.theme), this.providerController = new I.ProviderController({
                        disableInjectedProvider: n.disableInjectedProvider,
                        cacheProvider: n.cacheProvider,
                        providerOptions: n.providerOptions,
                        network: n.network
                    }), this.providerController.on(o.CONNECT_EVENT, function(e) {
                        return t.onConnect(e);
                    }), this.providerController.on(o.ERROR_EVENT, function(e) {
                        return t.onError(e);
                    }), this.providerController.on(o.SELECT_EVENT, this.onProviderSelect), this.userOptions = this.providerController.getUserOptions(), this.renderModal();
                }
                return Object.defineProperty(e.prototype, "cachedProvider", {
                    get: function() {
                        return this.providerController.cachedProvider;
                    },
                    enumerable: !1,
                    configurable: !0
                }), e.prototype.toggleModal = function() {
                    return i.__awaiter(this, void 0, void 0, function() {
                        return i.__generator(this, function(e) {
                            switch(e.label){
                                case 0:
                                    return this.cachedProvider ? [
                                        4,
                                        this.providerController.connectToCachedProvider()
                                    ] : [
                                        3,
                                        2
                                    ];
                                case 1:
                                    return e.sent(), [
                                        2
                                    ];
                                case 2:
                                    return this.userOptions && 1 === this.userOptions.length && this.userOptions[0].name ? [
                                        4,
                                        this.userOptions[0].onClick()
                                    ] : [
                                        3,
                                        4
                                    ];
                                case 3:
                                    return e.sent(), [
                                        2
                                    ];
                                case 4:
                                    return [
                                        4,
                                        this._toggleModal()
                                    ];
                                case 5:
                                    return e.sent(), [
                                        2
                                    ];
                            }
                        });
                    });
                }, e.prototype.on = function(e, t) {
                    var n = this;
                    return this.eventController.on({
                        event: e,
                        callback: t
                    }), function() {
                        return n.eventController.off({
                            event: e,
                            callback: t
                        });
                    };
                }, e.prototype.off = function(e, t) {
                    this.eventController.off({
                        event: e,
                        callback: t
                    });
                }, e.prototype.getUserOptions = function() {
                    return this.userOptions;
                }, e.prototype.clearCachedProvider = function() {
                    this.providerController.clearCachedProvider();
                }, e.prototype.setCachedProvider = function(e) {
                    this.providerController.setCachedProvider(e);
                }, e.prototype.updateTheme = function(e) {
                    return i.__awaiter(this, void 0, void 0, function() {
                        return i.__generator(this, function(t) {
                            switch(t.label){
                                case 0:
                                    return this.themeColors = u.getThemeColors(e), [
                                        4,
                                        this.updateState({
                                            themeColors: this.themeColors
                                        })
                                    ];
                                case 1:
                                    return t.sent(), [
                                        2
                                    ];
                            }
                        });
                    });
                }, e.prototype.renderModal = function() {
                    var e = document.createElement("div");
                    e.id = o.WEB3_CONNECT_MODAL_ID, document.body.appendChild(e), M.render(r.createElement(a.Modal, {
                        themeColors: this.themeColors,
                        userOptions: this.userOptions,
                        onClose: this.onClose,
                        resetState: this.resetState,
                        lightboxOpacity: this.lightboxOpacity
                    }), document.getElementById(o.WEB3_CONNECT_MODAL_ID));
                }, e;
            }();
            t.Core = j;
        },
        function(e, t, n) {
            "use strict";
            /** @license React v16.14.0
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var i = n(9), r = "function" == typeof Symbol && Symbol.for, M = r ? Symbol.for("react.element") : 60103, u = r ? Symbol.for("react.portal") : 60106, o = r ? Symbol.for("react.fragment") : 60107, c = r ? Symbol.for("react.strict_mode") : 60108, a = r ? Symbol.for("react.profiler") : 60114, I = r ? Symbol.for("react.provider") : 60109, l = r ? Symbol.for("react.context") : 60110, N = r ? Symbol.for("react.forward_ref") : 60112, j = r ? Symbol.for("react.suspense") : 60113, g = r ? Symbol.for("react.memo") : 60115, s = r ? Symbol.for("react.lazy") : 60116, A = "function" == typeof Symbol && Symbol.iterator;
            function D(e) {
                for(var t = "https://reactjs.org/docs/error-decoder.html?invariant=" + e, n = 1; n < arguments.length; n++)t += "&args[]=" + encodeURIComponent(arguments[n]);
                return "Minified React error #" + e + "; visit " + t + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
            }
            var d = {
                isMounted: function() {
                    return !1;
                },
                enqueueForceUpdate: function() {},
                enqueueReplaceState: function() {},
                enqueueSetState: function() {}
            }, T = {};
            function y(e, t, n) {
                this.props = e, this.context = t, this.refs = T, this.updater = n || d;
            }
            function z() {}
            function w(e, t, n) {
                this.props = e, this.context = t, this.refs = T, this.updater = n || d;
            }
            y.prototype.isReactComponent = {}, y.prototype.setState = function(e, t) {
                if ("object" != typeof e && "function" != typeof e && null != e) throw Error(D(85));
                this.updater.enqueueSetState(this, e, t, "setState");
            }, y.prototype.forceUpdate = function(e) {
                this.updater.enqueueForceUpdate(this, e, "forceUpdate");
            }, z.prototype = y.prototype;
            var f = w.prototype = new z;
            f.constructor = w, i(f, y.prototype), f.isPureReactComponent = !0;
            var L = {
                current: null
            }, E = Object.prototype.hasOwnProperty, C = {
                key: !0,
                ref: !0,
                __self: !0,
                __source: !0
            };
            function x(e, t, n) {
                var i, r = {}, u = null, o = null;
                if (null != t) for(i in void 0 !== t.ref && (o = t.ref), void 0 !== t.key && (u = "" + t.key), t)E.call(t, i) && !C.hasOwnProperty(i) && (r[i] = t[i]);
                var c = arguments.length - 2;
                if (1 === c) r.children = n;
                else if (1 < c) {
                    for(var a = Array(c), I = 0; I < c; I++)a[I] = arguments[I + 2];
                    r.children = a;
                }
                if (e && e.defaultProps) for(i in c = e.defaultProps)void 0 === r[i] && (r[i] = c[i]);
                return {
                    $$typeof: M,
                    type: e,
                    key: u,
                    ref: o,
                    props: r,
                    _owner: L.current
                };
            }
            function p(e) {
                return "object" == typeof e && null !== e && e.$$typeof === M;
            }
            var S = /\/+/g, m = [];
            function O(e, t, n, i) {
                if (m.length) {
                    var r = m.pop();
                    return r.result = e, r.keyPrefix = t, r.func = n, r.context = i, r.count = 0, r;
                }
                return {
                    result: e,
                    keyPrefix: t,
                    func: n,
                    context: i,
                    count: 0
                };
            }
            function v(e) {
                e.result = null, e.keyPrefix = null, e.func = null, e.context = null, e.count = 0, 10 > m.length && m.push(e);
            }
            function b(e, t, n) {
                return null == e ? 0 : function e(t, n, i, r) {
                    var o = typeof t;
                    "undefined" !== o && "boolean" !== o || (t = null);
                    var c = !1;
                    if (null === t) c = !0;
                    else switch(o){
                        case "string":
                        case "number":
                            c = !0;
                            break;
                        case "object":
                            switch(t.$$typeof){
                                case M:
                                case u:
                                    c = !0;
                            }
                    }
                    if (c) return i(r, t, "" === n ? "." + h(t, 0) : n), 1;
                    if (c = 0, n = "" === n ? "." : n + ":", Array.isArray(t)) for(var a = 0; a < t.length; a++){
                        var I = n + h(o = t[a], a);
                        c += e(o, I, i, r);
                    }
                    else if (null === t || "object" != typeof t ? I = null : I = "function" == typeof (I = A && t[A] || t["@@iterator"]) ? I : null, "function" == typeof I) for(t = I.call(t), a = 0; !(o = t.next()).done;)c += e(o = o.value, I = n + h(o, a++), i, r);
                    else if ("object" === o) throw i = "" + t, Error(D(31, "[object Object]" === i ? "object with keys {" + Object.keys(t).join(", ") + "}" : i, ""));
                    return c;
                }(e, "", t, n);
            }
            function h(e, t) {
                return "object" == typeof e && null !== e && null != e.key ? function(e) {
                    var t = {
                        "=": "=0",
                        ":": "=2"
                    };
                    return "$" + ("" + e).replace(/[=:]/g, function(e) {
                        return t[e];
                    });
                }(e.key) : t.toString(36);
            }
            function k(e, t) {
                e.func.call(e.context, t, e.count++);
            }
            function Q(e, t, n) {
                var i = e.result, r = e.keyPrefix;
                e = e.func.call(e.context, t, e.count++), Array.isArray(e) ? Y(e, i, n, function(e) {
                    return e;
                }) : null != e && (p(e) && (e = function(e, t) {
                    return {
                        $$typeof: M,
                        type: e.type,
                        key: t,
                        ref: e.ref,
                        props: e.props,
                        _owner: e._owner
                    };
                }(e, r + (!e.key || t && t.key === e.key ? "" : ("" + e.key).replace(S, "$&/") + "/") + n)), i.push(e));
            }
            function Y(e, t, n, i, r) {
                var M = "";
                null != n && (M = ("" + n).replace(S, "$&/") + "/"), b(e, Q, t = O(t, M, i, r)), v(t);
            }
            var P = {
                current: null
            };
            function U() {
                var e = P.current;
                if (null === e) throw Error(D(321));
                return e;
            }
            var Z = {
                ReactCurrentDispatcher: P,
                ReactCurrentBatchConfig: {
                    suspense: null
                },
                ReactCurrentOwner: L,
                IsSomeRendererActing: {
                    current: !1
                },
                assign: i
            };
            t.Children = {
                map: function(e, t, n) {
                    if (null == e) return e;
                    var i = [];
                    return Y(e, i, null, t, n), i;
                },
                forEach: function(e, t, n) {
                    if (null == e) return e;
                    b(e, k, t = O(null, null, t, n)), v(t);
                },
                count: function(e) {
                    return b(e, function() {
                        return null;
                    }, null);
                },
                toArray: function(e) {
                    var t = [];
                    return Y(e, t, null, function(e) {
                        return e;
                    }), t;
                },
                only: function(e) {
                    if (!p(e)) throw Error(D(143));
                    return e;
                }
            }, t.Component = y, t.Fragment = o, t.Profiler = a, t.PureComponent = w, t.StrictMode = c, t.Suspense = j, t.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = Z, t.cloneElement = function(e, t, n) {
                if (null == e) throw Error(D(267, e));
                var r = i({}, e.props), u = e.key, o = e.ref, c = e._owner;
                if (null != t) {
                    if (void 0 !== t.ref && (o = t.ref, c = L.current), void 0 !== t.key && (u = "" + t.key), e.type && e.type.defaultProps) var a = e.type.defaultProps;
                    for(I in t)E.call(t, I) && !C.hasOwnProperty(I) && (r[I] = void 0 === t[I] && void 0 !== a ? a[I] : t[I]);
                }
                var I = arguments.length - 2;
                if (1 === I) r.children = n;
                else if (1 < I) {
                    a = Array(I);
                    for(var l = 0; l < I; l++)a[l] = arguments[l + 2];
                    r.children = a;
                }
                return {
                    $$typeof: M,
                    type: e.type,
                    key: u,
                    ref: o,
                    props: r,
                    _owner: c
                };
            }, t.createContext = function(e, t) {
                return void 0 === t && (t = null), (e = {
                    $$typeof: l,
                    _calculateChangedBits: t,
                    _currentValue: e,
                    _currentValue2: e,
                    _threadCount: 0,
                    Provider: null,
                    Consumer: null
                }).Provider = {
                    $$typeof: I,
                    _context: e
                }, e.Consumer = e;
            }, t.createElement = x, t.createFactory = function(e) {
                var t = x.bind(null, e);
                return t.type = e, t;
            }, t.createRef = function() {
                return {
                    current: null
                };
            }, t.forwardRef = function(e) {
                return {
                    $$typeof: N,
                    render: e
                };
            }, t.isValidElement = p, t.lazy = function(e) {
                return {
                    $$typeof: s,
                    _ctor: e,
                    _status: -1,
                    _result: null
                };
            }, t.memo = function(e, t) {
                return {
                    $$typeof: g,
                    type: e,
                    compare: void 0 === t ? null : t
                };
            }, t.useCallback = function(e, t) {
                return U().useCallback(e, t);
            }, t.useContext = function(e, t) {
                return U().useContext(e, t);
            }, t.useDebugValue = function() {}, t.useEffect = function(e, t) {
                return U().useEffect(e, t);
            }, t.useImperativeHandle = function(e, t, n) {
                return U().useImperativeHandle(e, t, n);
            }, t.useLayoutEffect = function(e, t) {
                return U().useLayoutEffect(e, t);
            }, t.useMemo = function(e, t) {
                return U().useMemo(e, t);
            }, t.useReducer = function(e, t, n) {
                return U().useReducer(e, t, n);
            }, t.useRef = function(e) {
                return U().useRef(e);
            }, t.useState = function(e) {
                return U().useState(e);
            }, t.version = "16.14.0";
        },
        function(e, t, n) {
            "use strict";
            !function e() {
                if ("undefined" != typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ && "function" == typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE) try {
                    __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(e);
                } catch (e) {
                    console.error(e);
                }
            }(), e.exports = n(29);
        },
        function(e, t, n) {
            "use strict";
            /** @license React v16.14.0
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var i = n(1), r = n(9), M = n(30);
            function u(e) {
                for(var t = "https://reactjs.org/docs/error-decoder.html?invariant=" + e, n = 1; n < arguments.length; n++)t += "&args[]=" + encodeURIComponent(arguments[n]);
                return "Minified React error #" + e + "; visit " + t + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
            }
            if (!i) throw Error(u(227));
            function o(e, t, n, i, r, M, u, o, c) {
                var a = Array.prototype.slice.call(arguments, 3);
                try {
                    t.apply(n, a);
                } catch (e) {
                    this.onError(e);
                }
            }
            var c = !1, a = null, I = !1, l = null, N = {
                onError: function(e) {
                    c = !0, a = e;
                }
            };
            function j(e, t, n, i, r, M, u, I, l) {
                c = !1, a = null, o.apply(N, arguments);
            }
            var g = null, s = null, A = null;
            function D(e, t, n) {
                var i = e.type || "unknown-event";
                e.currentTarget = A(n), function(e, t, n, i, r, M, o, N, g) {
                    if (j.apply(this, arguments), c) {
                        if (!c) throw Error(u(198));
                        var s = a;
                        c = !1, a = null, I || (I = !0, l = s);
                    }
                }(i, t, void 0, e), e.currentTarget = null;
            }
            var d = null, T = {};
            function y() {
                if (d) for(var e in T){
                    var t = T[e], n = d.indexOf(e);
                    if (!(-1 < n)) throw Error(u(96, e));
                    if (!w[n]) {
                        if (!t.extractEvents) throw Error(u(97, e));
                        for(var i in w[n] = t, n = t.eventTypes){
                            var r = void 0, M = n[i], o = t, c = i;
                            if (f.hasOwnProperty(c)) throw Error(u(99, c));
                            f[c] = M;
                            var a = M.phasedRegistrationNames;
                            if (a) {
                                for(r in a)a.hasOwnProperty(r) && z(a[r], o, c);
                                r = !0;
                            } else M.registrationName ? (z(M.registrationName, o, c), r = !0) : r = !1;
                            if (!r) throw Error(u(98, i, e));
                        }
                    }
                }
            }
            function z(e, t, n) {
                if (L[e]) throw Error(u(100, e));
                L[e] = t, E[e] = t.eventTypes[n].dependencies;
            }
            var w = [], f = {}, L = {}, E = {};
            function C(e) {
                var t, n = !1;
                for(t in e)if (e.hasOwnProperty(t)) {
                    var i = e[t];
                    if (!T.hasOwnProperty(t) || T[t] !== i) {
                        if (T[t]) throw Error(u(102, t));
                        T[t] = i, n = !0;
                    }
                }
                n && y();
            }
            var x = !("undefined" == typeof window || void 0 === window.document || void 0 === window.document.createElement), p = null, S = null, m = null;
            function O(e) {
                if (e = s(e)) {
                    if ("function" != typeof p) throw Error(u(280));
                    var t = e.stateNode;
                    t && (t = g(t), p(e.stateNode, e.type, t));
                }
            }
            function v(e) {
                S ? m ? m.push(e) : m = [
                    e
                ] : S = e;
            }
            function b() {
                if (S) {
                    var e = S, t = m;
                    if (m = S = null, O(e), t) for(e = 0; e < t.length; e++)O(t[e]);
                }
            }
            function h(e, t) {
                return e(t);
            }
            function k(e, t, n, i, r) {
                return e(t, n, i, r);
            }
            function Q() {}
            var Y = h, P = !1, U = !1;
            function Z() {
                null === S && null === m || (Q(), b());
            }
            function G(e, t, n) {
                if (U) return e(t, n);
                U = !0;
                try {
                    return Y(e, t, n);
                } finally{
                    U = !1, Z();
                }
            }
            var B = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, R = Object.prototype.hasOwnProperty, W = {}, H = {};
            function V(e, t, n, i, r, M) {
                this.acceptsBooleans = 2 === t || 3 === t || 4 === t, this.attributeName = i, this.attributeNamespace = r, this.mustUseProperty = n, this.propertyName = e, this.type = t, this.sanitizeURL = M;
            }
            var J = {};
            "children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(e) {
                J[e] = new V(e, 0, !1, e, null, !1);
            }), [
                [
                    "acceptCharset",
                    "accept-charset"
                ],
                [
                    "className",
                    "class"
                ],
                [
                    "htmlFor",
                    "for"
                ],
                [
                    "httpEquiv",
                    "http-equiv"
                ]
            ].forEach(function(e) {
                var t = e[0];
                J[t] = new V(t, 1, !1, e[1], null, !1);
            }), [
                "contentEditable",
                "draggable",
                "spellCheck",
                "value"
            ].forEach(function(e) {
                J[e] = new V(e, 2, !1, e.toLowerCase(), null, !1);
            }), [
                "autoReverse",
                "externalResourcesRequired",
                "focusable",
                "preserveAlpha"
            ].forEach(function(e) {
                J[e] = new V(e, 2, !1, e, null, !1);
            }), "allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(e) {
                J[e] = new V(e, 3, !1, e.toLowerCase(), null, !1);
            }), [
                "checked",
                "multiple",
                "muted",
                "selected"
            ].forEach(function(e) {
                J[e] = new V(e, 3, !0, e, null, !1);
            }), [
                "capture",
                "download"
            ].forEach(function(e) {
                J[e] = new V(e, 4, !1, e, null, !1);
            }), [
                "cols",
                "rows",
                "size",
                "span"
            ].forEach(function(e) {
                J[e] = new V(e, 6, !1, e, null, !1);
            }), [
                "rowSpan",
                "start"
            ].forEach(function(e) {
                J[e] = new V(e, 5, !1, e.toLowerCase(), null, !1);
            });
            var F = /[\-:]([a-z])/g;
            function X(e) {
                return e[1].toUpperCase();
            }
            "accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(e) {
                var t = e.replace(F, X);
                J[t] = new V(t, 1, !1, e, null, !1);
            }), "xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(e) {
                var t = e.replace(F, X);
                J[t] = new V(t, 1, !1, e, "http://www.w3.org/1999/xlink", !1);
            }), [
                "xml:base",
                "xml:lang",
                "xml:space"
            ].forEach(function(e) {
                var t = e.replace(F, X);
                J[t] = new V(t, 1, !1, e, "http://www.w3.org/XML/1998/namespace", !1);
            }), [
                "tabIndex",
                "crossOrigin"
            ].forEach(function(e) {
                J[e] = new V(e, 1, !1, e.toLowerCase(), null, !1);
            }), J.xlinkHref = new V("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0), [
                "src",
                "href",
                "action",
                "formAction"
            ].forEach(function(e) {
                J[e] = new V(e, 1, !1, e.toLowerCase(), null, !0);
            });
            var K = i.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
            function q(e, t, n, i) {
                var r = J.hasOwnProperty(t) ? J[t] : null;
                (null !== r ? 0 === r.type : !i && 2 < t.length && ("o" === t[0] || "O" === t[0]) && ("n" === t[1] || "N" === t[1])) || (function(e, t, n, i) {
                    if (null == t || function(e, t, n, i) {
                        if (null !== n && 0 === n.type) return !1;
                        switch(typeof t){
                            case "function":
                            case "symbol":
                                return !0;
                            case "boolean":
                                return !i && (null !== n ? !n.acceptsBooleans : "data-" !== (e = e.toLowerCase().slice(0, 5)) && "aria-" !== e);
                            default:
                                return !1;
                        }
                    }(e, t, n, i)) return !0;
                    if (i) return !1;
                    if (null !== n) switch(n.type){
                        case 3:
                            return !t;
                        case 4:
                            return !1 === t;
                        case 5:
                            return isNaN(t);
                        case 6:
                            return isNaN(t) || 1 > t;
                    }
                    return !1;
                }(t, n, r, i) && (n = null), i || null === r ? function(e) {
                    return !!R.call(H, e) || !R.call(W, e) && (B.test(e) ? H[e] = !0 : (W[e] = !0, !1));
                }(t) && (null === n ? e.removeAttribute(t) : e.setAttribute(t, "" + n)) : r.mustUseProperty ? e[r.propertyName] = null === n ? 3 !== r.type && "" : n : (t = r.attributeName, i = r.attributeNamespace, null === n ? e.removeAttribute(t) : (n = 3 === (r = r.type) || 4 === r && !0 === n ? "" : "" + n, i ? e.setAttributeNS(i, t, n) : e.setAttribute(t, n))));
            }
            K.hasOwnProperty("ReactCurrentDispatcher") || (K.ReactCurrentDispatcher = {
                current: null
            }), K.hasOwnProperty("ReactCurrentBatchConfig") || (K.ReactCurrentBatchConfig = {
                suspense: null
            });
            var _ = /^(.*)[\\\/]/, $ = "function" == typeof Symbol && Symbol.for, ee = $ ? Symbol.for("react.element") : 60103, te = $ ? Symbol.for("react.portal") : 60106, ne = $ ? Symbol.for("react.fragment") : 60107, ie = $ ? Symbol.for("react.strict_mode") : 60108, re = $ ? Symbol.for("react.profiler") : 60114, Me = $ ? Symbol.for("react.provider") : 60109, ue = $ ? Symbol.for("react.context") : 60110, oe = $ ? Symbol.for("react.concurrent_mode") : 60111, ce = $ ? Symbol.for("react.forward_ref") : 60112, ae = $ ? Symbol.for("react.suspense") : 60113, Ie = $ ? Symbol.for("react.suspense_list") : 60120, le = $ ? Symbol.for("react.memo") : 60115, Ne = $ ? Symbol.for("react.lazy") : 60116, je = $ ? Symbol.for("react.block") : 60121, ge = "function" == typeof Symbol && Symbol.iterator;
            function se(e) {
                return null === e || "object" != typeof e ? null : "function" == typeof (e = ge && e[ge] || e["@@iterator"]) ? e : null;
            }
            function Ae(e) {
                if (null == e) return null;
                if ("function" == typeof e) return e.displayName || e.name || null;
                if ("string" == typeof e) return e;
                switch(e){
                    case ne:
                        return "Fragment";
                    case te:
                        return "Portal";
                    case re:
                        return "Profiler";
                    case ie:
                        return "StrictMode";
                    case ae:
                        return "Suspense";
                    case Ie:
                        return "SuspenseList";
                }
                if ("object" == typeof e) switch(e.$$typeof){
                    case ue:
                        return "Context.Consumer";
                    case Me:
                        return "Context.Provider";
                    case ce:
                        var t = e.render;
                        return t = t.displayName || t.name || "", e.displayName || ("" !== t ? "ForwardRef(" + t + ")" : "ForwardRef");
                    case le:
                        return Ae(e.type);
                    case je:
                        return Ae(e.render);
                    case Ne:
                        if (e = 1 === e._status ? e._result : null) return Ae(e);
                }
                return null;
            }
            function De(e) {
                var t = "";
                do {
                    e: switch(e.tag){
                        case 3:
                        case 4:
                        case 6:
                        case 7:
                        case 10:
                        case 9:
                            var n = "";
                            break e;
                        default:
                            var i = e._debugOwner, r = e._debugSource, M = Ae(e.type);
                            n = null, i && (n = Ae(i.type)), i = M, M = "", r ? M = " (at " + r.fileName.replace(_, "") + ":" + r.lineNumber + ")" : n && (M = " (created by " + n + ")"), n = "\n    in " + (i || "Unknown") + M;
                    }
                    t += n, e = e.return;
                }while (e);
                return t;
            }
            function de(e) {
                switch(typeof e){
                    case "boolean":
                    case "number":
                    case "object":
                    case "string":
                    case "undefined":
                        return e;
                    default:
                        return "";
                }
            }
            function Te(e) {
                var t = e.type;
                return (e = e.nodeName) && "input" === e.toLowerCase() && ("checkbox" === t || "radio" === t);
            }
            function ye(e) {
                e._valueTracker || (e._valueTracker = function(e) {
                    var t = Te(e) ? "checked" : "value", n = Object.getOwnPropertyDescriptor(e.constructor.prototype, t), i = "" + e[t];
                    if (!e.hasOwnProperty(t) && void 0 !== n && "function" == typeof n.get && "function" == typeof n.set) {
                        var r = n.get, M = n.set;
                        return Object.defineProperty(e, t, {
                            configurable: !0,
                            get: function() {
                                return r.call(this);
                            },
                            set: function(e) {
                                i = "" + e, M.call(this, e);
                            }
                        }), Object.defineProperty(e, t, {
                            enumerable: n.enumerable
                        }), {
                            getValue: function() {
                                return i;
                            },
                            setValue: function(e) {
                                i = "" + e;
                            },
                            stopTracking: function() {
                                e._valueTracker = null, delete e[t];
                            }
                        };
                    }
                }(e));
            }
            function ze(e) {
                if (!e) return !1;
                var t = e._valueTracker;
                if (!t) return !0;
                var n = t.getValue(), i = "";
                return e && (i = Te(e) ? e.checked ? "true" : "false" : e.value), (e = i) !== n && (t.setValue(e), !0);
            }
            function we(e, t) {
                var n = t.checked;
                return r({}, t, {
                    defaultChecked: void 0,
                    defaultValue: void 0,
                    value: void 0,
                    checked: null != n ? n : e._wrapperState.initialChecked
                });
            }
            function fe(e, t) {
                var n = null == t.defaultValue ? "" : t.defaultValue, i = null != t.checked ? t.checked : t.defaultChecked;
                n = de(null != t.value ? t.value : n), e._wrapperState = {
                    initialChecked: i,
                    initialValue: n,
                    controlled: "checkbox" === t.type || "radio" === t.type ? null != t.checked : null != t.value
                };
            }
            function Le(e, t) {
                null != (t = t.checked) && q(e, "checked", t, !1);
            }
            function Ee(e, t) {
                Le(e, t);
                var n = de(t.value), i = t.type;
                if (null != n) "number" === i ? (0 === n && "" === e.value || e.value != n) && (e.value = "" + n) : e.value !== "" + n && (e.value = "" + n);
                else if ("submit" === i || "reset" === i) return void e.removeAttribute("value");
                t.hasOwnProperty("value") ? xe(e, t.type, n) : t.hasOwnProperty("defaultValue") && xe(e, t.type, de(t.defaultValue)), null == t.checked && null != t.defaultChecked && (e.defaultChecked = !!t.defaultChecked);
            }
            function Ce(e, t, n) {
                if (t.hasOwnProperty("value") || t.hasOwnProperty("defaultValue")) {
                    var i = t.type;
                    if (!("submit" !== i && "reset" !== i || void 0 !== t.value && null !== t.value)) return;
                    t = "" + e._wrapperState.initialValue, n || t === e.value || (e.value = t), e.defaultValue = t;
                }
                "" !== (n = e.name) && (e.name = ""), e.defaultChecked = !!e._wrapperState.initialChecked, "" !== n && (e.name = n);
            }
            function xe(e, t, n) {
                "number" === t && e.ownerDocument.activeElement === e || (null == n ? e.defaultValue = "" + e._wrapperState.initialValue : e.defaultValue !== "" + n && (e.defaultValue = "" + n));
            }
            function pe(e, t) {
                return e = r({
                    children: void 0
                }, t), (t = function(e) {
                    var t = "";
                    return i.Children.forEach(e, function(e) {
                        null != e && (t += e);
                    }), t;
                }(t.children)) && (e.children = t), e;
            }
            function Se(e, t, n, i) {
                if (e = e.options, t) {
                    t = {};
                    for(var r = 0; r < n.length; r++)t["$" + n[r]] = !0;
                    for(n = 0; n < e.length; n++)r = t.hasOwnProperty("$" + e[n].value), e[n].selected !== r && (e[n].selected = r), r && i && (e[n].defaultSelected = !0);
                } else {
                    for(n = "" + de(n), t = null, r = 0; r < e.length; r++){
                        if (e[r].value === n) return e[r].selected = !0, void (i && (e[r].defaultSelected = !0));
                        null !== t || e[r].disabled || (t = e[r]);
                    }
                    null !== t && (t.selected = !0);
                }
            }
            function me(e, t) {
                if (null != t.dangerouslySetInnerHTML) throw Error(u(91));
                return r({}, t, {
                    value: void 0,
                    defaultValue: void 0,
                    children: "" + e._wrapperState.initialValue
                });
            }
            function Oe(e, t) {
                var n = t.value;
                if (null == n) {
                    if (n = t.children, t = t.defaultValue, null != n) {
                        if (null != t) throw Error(u(92));
                        if (Array.isArray(n)) {
                            if (!(1 >= n.length)) throw Error(u(93));
                            n = n[0];
                        }
                        t = n;
                    }
                    null == t && (t = ""), n = t;
                }
                e._wrapperState = {
                    initialValue: de(n)
                };
            }
            function ve(e, t) {
                var n = de(t.value), i = de(t.defaultValue);
                null != n && ((n = "" + n) !== e.value && (e.value = n), null == t.defaultValue && e.defaultValue !== n && (e.defaultValue = n)), null != i && (e.defaultValue = "" + i);
            }
            function be(e) {
                var t = e.textContent;
                t === e._wrapperState.initialValue && "" !== t && null !== t && (e.value = t);
            }
            var he = "http://www.w3.org/1999/xhtml", ke = "http://www.w3.org/2000/svg";
            function Qe(e) {
                switch(e){
                    case "svg":
                        return "http://www.w3.org/2000/svg";
                    case "math":
                        return "http://www.w3.org/1998/Math/MathML";
                    default:
                        return "http://www.w3.org/1999/xhtml";
                }
            }
            function Ye(e, t) {
                return null == e || "http://www.w3.org/1999/xhtml" === e ? Qe(t) : "http://www.w3.org/2000/svg" === e && "foreignObject" === t ? "http://www.w3.org/1999/xhtml" : e;
            }
            var Pe, Ue = function(e) {
                return "undefined" != typeof MSApp && MSApp.execUnsafeLocalFunction ? function(t, n, i, r) {
                    MSApp.execUnsafeLocalFunction(function() {
                        return e(t, n);
                    });
                } : e;
            }(function(e, t) {
                if (e.namespaceURI !== ke || "innerHTML" in e) e.innerHTML = t;
                else {
                    for((Pe = Pe || document.createElement("div")).innerHTML = "<svg>" + t.valueOf().toString() + "</svg>", t = Pe.firstChild; e.firstChild;)e.removeChild(e.firstChild);
                    for(; t.firstChild;)e.appendChild(t.firstChild);
                }
            });
            function Ze(e, t) {
                if (t) {
                    var n = e.firstChild;
                    if (n && n === e.lastChild && 3 === n.nodeType) return void (n.nodeValue = t);
                }
                e.textContent = t;
            }
            function Ge(e, t) {
                var n = {};
                return n[e.toLowerCase()] = t.toLowerCase(), n["Webkit" + e] = "webkit" + t, n["Moz" + e] = "moz" + t, n;
            }
            var Be = {
                animationend: Ge("Animation", "AnimationEnd"),
                animationiteration: Ge("Animation", "AnimationIteration"),
                animationstart: Ge("Animation", "AnimationStart"),
                transitionend: Ge("Transition", "TransitionEnd")
            }, Re = {}, We = {};
            function He(e) {
                if (Re[e]) return Re[e];
                if (!Be[e]) return e;
                var t, n = Be[e];
                for(t in n)if (n.hasOwnProperty(t) && t in We) return Re[e] = n[t];
                return e;
            }
            x && (We = document.createElement("div").style, "AnimationEvent" in window || (delete Be.animationend.animation, delete Be.animationiteration.animation, delete Be.animationstart.animation), "TransitionEvent" in window || delete Be.transitionend.transition);
            var Ve = He("animationend"), Je = He("animationiteration"), Fe = He("animationstart"), Xe = He("transitionend"), Ke = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), qe = new ("function" == typeof WeakMap ? WeakMap : Map);
            function _e(e) {
                var t = qe.get(e);
                return void 0 === t && (t = new Map, qe.set(e, t)), t;
            }
            function $e(e) {
                var t = e, n = e;
                if (e.alternate) for(; t.return;)t = t.return;
                else {
                    e = t;
                    do 0 != (1026 & (t = e).effectTag) && (n = t.return), e = t.return;
                    while (e);
                }
                return 3 === t.tag ? n : null;
            }
            function et(e) {
                if (13 === e.tag) {
                    var t = e.memoizedState;
                    if (null === t && null !== (e = e.alternate) && (t = e.memoizedState), null !== t) return t.dehydrated;
                }
                return null;
            }
            function tt(e) {
                if ($e(e) !== e) throw Error(u(188));
            }
            function nt(e) {
                if (!(e = function(e) {
                    var t = e.alternate;
                    if (!t) {
                        if (null === (t = $e(e))) throw Error(u(188));
                        return t !== e ? null : e;
                    }
                    for(var n = e, i = t;;){
                        var r = n.return;
                        if (null === r) break;
                        var M = r.alternate;
                        if (null === M) {
                            if (null !== (i = r.return)) {
                                n = i;
                                continue;
                            }
                            break;
                        }
                        if (r.child === M.child) {
                            for(M = r.child; M;){
                                if (M === n) return tt(r), e;
                                if (M === i) return tt(r), t;
                                M = M.sibling;
                            }
                            throw Error(u(188));
                        }
                        if (n.return !== i.return) n = r, i = M;
                        else {
                            for(var o = !1, c = r.child; c;){
                                if (c === n) {
                                    o = !0, n = r, i = M;
                                    break;
                                }
                                if (c === i) {
                                    o = !0, i = r, n = M;
                                    break;
                                }
                                c = c.sibling;
                            }
                            if (!o) {
                                for(c = M.child; c;){
                                    if (c === n) {
                                        o = !0, n = M, i = r;
                                        break;
                                    }
                                    if (c === i) {
                                        o = !0, i = M, n = r;
                                        break;
                                    }
                                    c = c.sibling;
                                }
                                if (!o) throw Error(u(189));
                            }
                        }
                        if (n.alternate !== i) throw Error(u(190));
                    }
                    if (3 !== n.tag) throw Error(u(188));
                    return n.stateNode.current === n ? e : t;
                }(e))) return null;
                for(var t = e;;){
                    if (5 === t.tag || 6 === t.tag) return t;
                    if (t.child) t.child.return = t, t = t.child;
                    else {
                        if (t === e) break;
                        for(; !t.sibling;){
                            if (!t.return || t.return === e) return null;
                            t = t.return;
                        }
                        t.sibling.return = t.return, t = t.sibling;
                    }
                }
                return null;
            }
            function it(e, t) {
                if (null == t) throw Error(u(30));
                return null == e ? t : Array.isArray(e) ? Array.isArray(t) ? (e.push.apply(e, t), e) : (e.push(t), e) : Array.isArray(t) ? [
                    e
                ].concat(t) : [
                    e,
                    t
                ];
            }
            function rt(e, t, n) {
                Array.isArray(e) ? e.forEach(t, n) : e && t.call(n, e);
            }
            var Mt = null;
            function ut(e) {
                if (e) {
                    var t = e._dispatchListeners, n = e._dispatchInstances;
                    if (Array.isArray(t)) for(var i = 0; i < t.length && !e.isPropagationStopped(); i++)D(e, t[i], n[i]);
                    else t && D(e, t, n);
                    e._dispatchListeners = null, e._dispatchInstances = null, e.isPersistent() || e.constructor.release(e);
                }
            }
            function ot(e) {
                if (null !== e && (Mt = it(Mt, e)), e = Mt, Mt = null, e) {
                    if (rt(e, ut), Mt) throw Error(u(95));
                    if (I) throw e = l, I = !1, l = null, e;
                }
            }
            function ct(e) {
                return (e = e.target || e.srcElement || window).correspondingUseElement && (e = e.correspondingUseElement), 3 === e.nodeType ? e.parentNode : e;
            }
            function at(e) {
                if (!x) return !1;
                var t = (e = "on" + e) in document;
                return t || ((t = document.createElement("div")).setAttribute(e, "return;"), t = "function" == typeof t[e]), t;
            }
            var It = [];
            function lt(e) {
                e.topLevelType = null, e.nativeEvent = null, e.targetInst = null, e.ancestors.length = 0, 10 > It.length && It.push(e);
            }
            function Nt(e, t, n, i) {
                if (It.length) {
                    var r = It.pop();
                    return r.topLevelType = e, r.eventSystemFlags = i, r.nativeEvent = t, r.targetInst = n, r;
                }
                return {
                    topLevelType: e,
                    eventSystemFlags: i,
                    nativeEvent: t,
                    targetInst: n,
                    ancestors: []
                };
            }
            function jt(e) {
                var t = e.targetInst, n = t;
                do {
                    if (!n) {
                        e.ancestors.push(n);
                        break;
                    }
                    var i = n;
                    if (3 === i.tag) i = i.stateNode.containerInfo;
                    else {
                        for(; i.return;)i = i.return;
                        i = 3 !== i.tag ? null : i.stateNode.containerInfo;
                    }
                    if (!i) break;
                    5 !== (t = n.tag) && 6 !== t || e.ancestors.push(n), n = xn(i);
                }while (n);
                for(n = 0; n < e.ancestors.length; n++){
                    t = e.ancestors[n];
                    var r = ct(e.nativeEvent);
                    i = e.topLevelType;
                    var M = e.nativeEvent, u = e.eventSystemFlags;
                    0 === n && (u |= 64);
                    for(var o = null, c = 0; c < w.length; c++){
                        var a = w[c];
                        a && (a = a.extractEvents(i, t, M, r, u)) && (o = it(o, a));
                    }
                    ot(o);
                }
            }
            function gt(e, t, n) {
                if (!n.has(e)) {
                    switch(e){
                        case "scroll":
                            Ft(t, "scroll", !0);
                            break;
                        case "focus":
                        case "blur":
                            Ft(t, "focus", !0), Ft(t, "blur", !0), n.set("blur", null), n.set("focus", null);
                            break;
                        case "cancel":
                        case "close":
                            at(e) && Ft(t, e, !0);
                            break;
                        case "invalid":
                        case "submit":
                        case "reset":
                            break;
                        default:
                            -1 === Ke.indexOf(e) && Jt(e, t);
                    }
                    n.set(e, null);
                }
            }
            var st, At, Dt, dt = !1, Tt = [], yt = null, zt = null, wt = null, ft = new Map, Lt = new Map, Et = [], Ct = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput close cancel copy cut paste click change contextmenu reset submit".split(" "), xt = "focus blur dragenter dragleave mouseover mouseout pointerover pointerout gotpointercapture lostpointercapture".split(" ");
            function pt(e, t, n, i, r) {
                return {
                    blockedOn: e,
                    topLevelType: t,
                    eventSystemFlags: 32 | n,
                    nativeEvent: r,
                    container: i
                };
            }
            function St(e, t) {
                switch(e){
                    case "focus":
                    case "blur":
                        yt = null;
                        break;
                    case "dragenter":
                    case "dragleave":
                        zt = null;
                        break;
                    case "mouseover":
                    case "mouseout":
                        wt = null;
                        break;
                    case "pointerover":
                    case "pointerout":
                        ft.delete(t.pointerId);
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                        Lt.delete(t.pointerId);
                }
            }
            function mt(e, t, n, i, r, M) {
                return null === e || e.nativeEvent !== M ? (e = pt(t, n, i, r, M), null !== t && null !== (t = pn(t)) && At(t), e) : (e.eventSystemFlags |= i, e);
            }
            function Ot(e) {
                var t = xn(e.target);
                if (null !== t) {
                    var n = $e(t);
                    if (null !== n) {
                        if (13 === (t = n.tag)) {
                            if (null !== (t = et(n))) return e.blockedOn = t, void M.unstable_runWithPriority(e.priority, function() {
                                Dt(n);
                            });
                        } else if (3 === t && n.stateNode.hydrate) return void (e.blockedOn = 3 === n.tag ? n.stateNode.containerInfo : null);
                    }
                }
                e.blockedOn = null;
            }
            function vt(e) {
                if (null !== e.blockedOn) return !1;
                var t = _t(e.topLevelType, e.eventSystemFlags, e.container, e.nativeEvent);
                if (null !== t) {
                    var n = pn(t);
                    return null !== n && At(n), e.blockedOn = t, !1;
                }
                return !0;
            }
            function bt(e, t, n) {
                vt(e) && n.delete(t);
            }
            function ht() {
                for(dt = !1; 0 < Tt.length;){
                    var e = Tt[0];
                    if (null !== e.blockedOn) {
                        null !== (e = pn(e.blockedOn)) && st(e);
                        break;
                    }
                    var t = _t(e.topLevelType, e.eventSystemFlags, e.container, e.nativeEvent);
                    null !== t ? e.blockedOn = t : Tt.shift();
                }
                null !== yt && vt(yt) && (yt = null), null !== zt && vt(zt) && (zt = null), null !== wt && vt(wt) && (wt = null), ft.forEach(bt), Lt.forEach(bt);
            }
            function kt(e, t) {
                e.blockedOn === t && (e.blockedOn = null, dt || (dt = !0, M.unstable_scheduleCallback(M.unstable_NormalPriority, ht)));
            }
            function Qt(e) {
                function t(t) {
                    return kt(t, e);
                }
                if (0 < Tt.length) {
                    kt(Tt[0], e);
                    for(var n = 1; n < Tt.length; n++){
                        var i = Tt[n];
                        i.blockedOn === e && (i.blockedOn = null);
                    }
                }
                for(null !== yt && kt(yt, e), null !== zt && kt(zt, e), null !== wt && kt(wt, e), ft.forEach(t), Lt.forEach(t), n = 0; n < Et.length; n++)(i = Et[n]).blockedOn === e && (i.blockedOn = null);
                for(; 0 < Et.length && null === (n = Et[0]).blockedOn;)Ot(n), null === n.blockedOn && Et.shift();
            }
            var Yt = {}, Pt = new Map, Ut = new Map, Zt = [
                "abort",
                "abort",
                Ve,
                "animationEnd",
                Je,
                "animationIteration",
                Fe,
                "animationStart",
                "canplay",
                "canPlay",
                "canplaythrough",
                "canPlayThrough",
                "durationchange",
                "durationChange",
                "emptied",
                "emptied",
                "encrypted",
                "encrypted",
                "ended",
                "ended",
                "error",
                "error",
                "gotpointercapture",
                "gotPointerCapture",
                "load",
                "load",
                "loadeddata",
                "loadedData",
                "loadedmetadata",
                "loadedMetadata",
                "loadstart",
                "loadStart",
                "lostpointercapture",
                "lostPointerCapture",
                "playing",
                "playing",
                "progress",
                "progress",
                "seeking",
                "seeking",
                "stalled",
                "stalled",
                "suspend",
                "suspend",
                "timeupdate",
                "timeUpdate",
                Xe,
                "transitionEnd",
                "waiting",
                "waiting"
            ];
            function Gt(e, t) {
                for(var n = 0; n < e.length; n += 2){
                    var i = e[n], r = e[n + 1], M = "on" + (r[0].toUpperCase() + r.slice(1));
                    M = {
                        phasedRegistrationNames: {
                            bubbled: M,
                            captured: M + "Capture"
                        },
                        dependencies: [
                            i
                        ],
                        eventPriority: t
                    }, Ut.set(i, t), Pt.set(i, M), Yt[r] = M;
                }
            }
            Gt("blur blur cancel cancel click click close close contextmenu contextMenu copy copy cut cut auxclick auxClick dblclick doubleClick dragend dragEnd dragstart dragStart drop drop focus focus input input invalid invalid keydown keyDown keypress keyPress keyup keyUp mousedown mouseDown mouseup mouseUp paste paste pause pause play play pointercancel pointerCancel pointerdown pointerDown pointerup pointerUp ratechange rateChange reset reset seeked seeked submit submit touchcancel touchCancel touchend touchEnd touchstart touchStart volumechange volumeChange".split(" "), 0), Gt("drag drag dragenter dragEnter dragexit dragExit dragleave dragLeave dragover dragOver mousemove mouseMove mouseout mouseOut mouseover mouseOver pointermove pointerMove pointerout pointerOut pointerover pointerOver scroll scroll toggle toggle touchmove touchMove wheel wheel".split(" "), 1), Gt(Zt, 2);
            for(var Bt = "change selectionchange textInput compositionstart compositionend compositionupdate".split(" "), Rt = 0; Rt < Bt.length; Rt++)Ut.set(Bt[Rt], 0);
            var Wt = M.unstable_UserBlockingPriority, Ht = M.unstable_runWithPriority, Vt = !0;
            function Jt(e, t) {
                Ft(t, e, !1);
            }
            function Ft(e, t, n) {
                var i = Ut.get(t);
                switch(void 0 === i ? 2 : i){
                    case 0:
                        i = Xt.bind(null, t, 1, e);
                        break;
                    case 1:
                        i = Kt.bind(null, t, 1, e);
                        break;
                    default:
                        i = qt.bind(null, t, 1, e);
                }
                n ? e.addEventListener(t, i, !0) : e.addEventListener(t, i, !1);
            }
            function Xt(e, t, n, i) {
                P || Q();
                var r = qt, M = P;
                P = !0;
                try {
                    k(r, e, t, n, i);
                } finally{
                    (P = M) || Z();
                }
            }
            function Kt(e, t, n, i) {
                Ht(Wt, qt.bind(null, e, t, n, i));
            }
            function qt(e, t, n, i) {
                if (Vt) {
                    if (0 < Tt.length && -1 < Ct.indexOf(e)) e = pt(null, e, t, n, i), Tt.push(e);
                    else {
                        var r = _t(e, t, n, i);
                        if (null === r) St(e, i);
                        else if (-1 < Ct.indexOf(e)) e = pt(r, e, t, n, i), Tt.push(e);
                        else if (!function(e, t, n, i, r) {
                            switch(t){
                                case "focus":
                                    return yt = mt(yt, e, t, n, i, r), !0;
                                case "dragenter":
                                    return zt = mt(zt, e, t, n, i, r), !0;
                                case "mouseover":
                                    return wt = mt(wt, e, t, n, i, r), !0;
                                case "pointerover":
                                    var M = r.pointerId;
                                    return ft.set(M, mt(ft.get(M) || null, e, t, n, i, r)), !0;
                                case "gotpointercapture":
                                    return M = r.pointerId, Lt.set(M, mt(Lt.get(M) || null, e, t, n, i, r)), !0;
                            }
                            return !1;
                        }(r, e, t, n, i)) {
                            St(e, i), e = Nt(e, i, null, t);
                            try {
                                G(jt, e);
                            } finally{
                                lt(e);
                            }
                        }
                    }
                }
            }
            function _t(e, t, n, i) {
                if (null !== (n = xn(n = ct(i)))) {
                    var r = $e(n);
                    if (null === r) n = null;
                    else {
                        var M = r.tag;
                        if (13 === M) {
                            if (null !== (n = et(r))) return n;
                            n = null;
                        } else if (3 === M) {
                            if (r.stateNode.hydrate) return 3 === r.tag ? r.stateNode.containerInfo : null;
                            n = null;
                        } else r !== n && (n = null);
                    }
                }
                e = Nt(e, i, n, t);
                try {
                    G(jt, e);
                } finally{
                    lt(e);
                }
                return null;
            }
            var $t = {
                animationIterationCount: !0,
                borderImageOutset: !0,
                borderImageSlice: !0,
                borderImageWidth: !0,
                boxFlex: !0,
                boxFlexGroup: !0,
                boxOrdinalGroup: !0,
                columnCount: !0,
                columns: !0,
                flex: !0,
                flexGrow: !0,
                flexPositive: !0,
                flexShrink: !0,
                flexNegative: !0,
                flexOrder: !0,
                gridArea: !0,
                gridRow: !0,
                gridRowEnd: !0,
                gridRowSpan: !0,
                gridRowStart: !0,
                gridColumn: !0,
                gridColumnEnd: !0,
                gridColumnSpan: !0,
                gridColumnStart: !0,
                fontWeight: !0,
                lineClamp: !0,
                lineHeight: !0,
                opacity: !0,
                order: !0,
                orphans: !0,
                tabSize: !0,
                widows: !0,
                zIndex: !0,
                zoom: !0,
                fillOpacity: !0,
                floodOpacity: !0,
                stopOpacity: !0,
                strokeDasharray: !0,
                strokeDashoffset: !0,
                strokeMiterlimit: !0,
                strokeOpacity: !0,
                strokeWidth: !0
            }, en = [
                "Webkit",
                "ms",
                "Moz",
                "O"
            ];
            function tn(e, t, n) {
                return null == t || "boolean" == typeof t || "" === t ? "" : n || "number" != typeof t || 0 === t || $t.hasOwnProperty(e) && $t[e] ? ("" + t).trim() : t + "px";
            }
            function nn(e, t) {
                for(var n in e = e.style, t)if (t.hasOwnProperty(n)) {
                    var i = 0 === n.indexOf("--"), r = tn(n, t[n], i);
                    "float" === n && (n = "cssFloat"), i ? e.setProperty(n, r) : e[n] = r;
                }
            }
            Object.keys($t).forEach(function(e) {
                en.forEach(function(t) {
                    t = t + e.charAt(0).toUpperCase() + e.substring(1), $t[t] = $t[e];
                });
            });
            var rn = r({
                menuitem: !0
            }, {
                area: !0,
                base: !0,
                br: !0,
                col: !0,
                embed: !0,
                hr: !0,
                img: !0,
                input: !0,
                keygen: !0,
                link: !0,
                meta: !0,
                param: !0,
                source: !0,
                track: !0,
                wbr: !0
            });
            function Mn(e, t) {
                if (t) {
                    if (rn[e] && (null != t.children || null != t.dangerouslySetInnerHTML)) throw Error(u(137, e, ""));
                    if (null != t.dangerouslySetInnerHTML) {
                        if (null != t.children) throw Error(u(60));
                        if ("object" != typeof t.dangerouslySetInnerHTML || !("__html" in t.dangerouslySetInnerHTML)) throw Error(u(61));
                    }
                    if (null != t.style && "object" != typeof t.style) throw Error(u(62, ""));
                }
            }
            function un(e, t) {
                if (-1 === e.indexOf("-")) return "string" == typeof t.is;
                switch(e){
                    case "annotation-xml":
                    case "color-profile":
                    case "font-face":
                    case "font-face-src":
                    case "font-face-uri":
                    case "font-face-format":
                    case "font-face-name":
                    case "missing-glyph":
                        return !1;
                    default:
                        return !0;
                }
            }
            var on = he;
            function cn(e, t) {
                var n = _e(e = 9 === e.nodeType || 11 === e.nodeType ? e : e.ownerDocument);
                t = E[t];
                for(var i = 0; i < t.length; i++)gt(t[i], e, n);
            }
            function an() {}
            function In(e) {
                if (void 0 === (e = e || ("undefined" != typeof document ? document : void 0))) return null;
                try {
                    return e.activeElement || e.body;
                } catch (t) {
                    return e.body;
                }
            }
            function ln(e) {
                for(; e && e.firstChild;)e = e.firstChild;
                return e;
            }
            function Nn(e, t) {
                var n, i = ln(e);
                for(e = 0; i;){
                    if (3 === i.nodeType) {
                        if (n = e + i.textContent.length, e <= t && n >= t) return {
                            node: i,
                            offset: t - e
                        };
                        e = n;
                    }
                    e: {
                        for(; i;){
                            if (i.nextSibling) {
                                i = i.nextSibling;
                                break e;
                            }
                            i = i.parentNode;
                        }
                        i = void 0;
                    }
                    i = ln(i);
                }
            }
            function jn() {
                for(var e = window, t = In(); t instanceof e.HTMLIFrameElement;){
                    try {
                        var n = "string" == typeof t.contentWindow.location.href;
                    } catch (e) {
                        n = !1;
                    }
                    if (!n) break;
                    t = In((e = t.contentWindow).document);
                }
                return t;
            }
            function gn(e) {
                var t = e && e.nodeName && e.nodeName.toLowerCase();
                return t && ("input" === t && ("text" === e.type || "search" === e.type || "tel" === e.type || "url" === e.type || "password" === e.type) || "textarea" === t || "true" === e.contentEditable);
            }
            var sn = null, An = null;
            function Dn(e, t) {
                switch(e){
                    case "button":
                    case "input":
                    case "select":
                    case "textarea":
                        return !!t.autoFocus;
                }
                return !1;
            }
            function dn(e, t) {
                return "textarea" === e || "option" === e || "noscript" === e || "string" == typeof t.children || "number" == typeof t.children || "object" == typeof t.dangerouslySetInnerHTML && null !== t.dangerouslySetInnerHTML && null != t.dangerouslySetInnerHTML.__html;
            }
            var Tn = "function" == typeof setTimeout ? setTimeout : void 0, yn = "function" == typeof clearTimeout ? clearTimeout : void 0;
            function zn(e) {
                for(; null != e; e = e.nextSibling){
                    var t = e.nodeType;
                    if (1 === t || 3 === t) break;
                }
                return e;
            }
            function wn(e) {
                e = e.previousSibling;
                for(var t = 0; e;){
                    if (8 === e.nodeType) {
                        var n = e.data;
                        if ("$" === n || "$!" === n || "$?" === n) {
                            if (0 === t) return e;
                            t--;
                        } else "/$" === n && t++;
                    }
                    e = e.previousSibling;
                }
                return null;
            }
            var fn = Math.random().toString(36).slice(2), Ln = "__reactInternalInstance$" + fn, En = "__reactEventHandlers$" + fn, Cn = "__reactContainere$" + fn;
            function xn(e) {
                var t = e[Ln];
                if (t) return t;
                for(var n = e.parentNode; n;){
                    if (t = n[Cn] || n[Ln]) {
                        if (n = t.alternate, null !== t.child || null !== n && null !== n.child) for(e = wn(e); null !== e;){
                            if (n = e[Ln]) return n;
                            e = wn(e);
                        }
                        return t;
                    }
                    n = (e = n).parentNode;
                }
                return null;
            }
            function pn(e) {
                return !(e = e[Ln] || e[Cn]) || 5 !== e.tag && 6 !== e.tag && 13 !== e.tag && 3 !== e.tag ? null : e;
            }
            function Sn(e) {
                if (5 === e.tag || 6 === e.tag) return e.stateNode;
                throw Error(u(33));
            }
            function mn(e) {
                return e[En] || null;
            }
            function On(e) {
                do e = e.return;
                while (e && 5 !== e.tag);
                return e || null;
            }
            function vn(e, t) {
                var n = e.stateNode;
                if (!n) return null;
                var i = g(n);
                if (!i) return null;
                n = i[t];
                e: switch(t){
                    case "onClick":
                    case "onClickCapture":
                    case "onDoubleClick":
                    case "onDoubleClickCapture":
                    case "onMouseDown":
                    case "onMouseDownCapture":
                    case "onMouseMove":
                    case "onMouseMoveCapture":
                    case "onMouseUp":
                    case "onMouseUpCapture":
                    case "onMouseEnter":
                        (i = !i.disabled) || (i = !("button" === (e = e.type) || "input" === e || "select" === e || "textarea" === e)), e = !i;
                        break e;
                    default:
                        e = !1;
                }
                if (e) return null;
                if (n && "function" != typeof n) throw Error(u(231, t, typeof n));
                return n;
            }
            function bn(e, t, n) {
                (t = vn(e, n.dispatchConfig.phasedRegistrationNames[t])) && (n._dispatchListeners = it(n._dispatchListeners, t), n._dispatchInstances = it(n._dispatchInstances, e));
            }
            function hn(e) {
                if (e && e.dispatchConfig.phasedRegistrationNames) {
                    for(var t = e._targetInst, n = []; t;)n.push(t), t = On(t);
                    for(t = n.length; 0 < t--;)bn(n[t], "captured", e);
                    for(t = 0; t < n.length; t++)bn(n[t], "bubbled", e);
                }
            }
            function kn(e, t, n) {
                e && n && n.dispatchConfig.registrationName && (t = vn(e, n.dispatchConfig.registrationName)) && (n._dispatchListeners = it(n._dispatchListeners, t), n._dispatchInstances = it(n._dispatchInstances, e));
            }
            function Qn(e) {
                e && e.dispatchConfig.registrationName && kn(e._targetInst, null, e);
            }
            function Yn(e) {
                rt(e, hn);
            }
            var Pn = null, Un = null, Zn = null;
            function Gn() {
                if (Zn) return Zn;
                var e, t, n = Un, i = n.length, r = "value" in Pn ? Pn.value : Pn.textContent, M = r.length;
                for(e = 0; e < i && n[e] === r[e]; e++);
                var u = i - e;
                for(t = 1; t <= u && n[i - t] === r[M - t]; t++);
                return Zn = r.slice(e, 1 < t ? 1 - t : void 0);
            }
            function Bn() {
                return !0;
            }
            function Rn() {
                return !1;
            }
            function Wn(e, t, n, i) {
                for(var r in this.dispatchConfig = e, this._targetInst = t, this.nativeEvent = n, e = this.constructor.Interface)e.hasOwnProperty(r) && ((t = e[r]) ? this[r] = t(n) : "target" === r ? this.target = i : this[r] = n[r]);
                return this.isDefaultPrevented = (null != n.defaultPrevented ? n.defaultPrevented : !1 === n.returnValue) ? Bn : Rn, this.isPropagationStopped = Rn, this;
            }
            function Hn(e, t, n, i) {
                if (this.eventPool.length) {
                    var r = this.eventPool.pop();
                    return this.call(r, e, t, n, i), r;
                }
                return new this(e, t, n, i);
            }
            function Vn(e) {
                if (!(e instanceof this)) throw Error(u(279));
                e.destructor(), 10 > this.eventPool.length && this.eventPool.push(e);
            }
            function Jn(e) {
                e.eventPool = [], e.getPooled = Hn, e.release = Vn;
            }
            r(Wn.prototype, {
                preventDefault: function() {
                    this.defaultPrevented = !0;
                    var e = this.nativeEvent;
                    e && (e.preventDefault ? e.preventDefault() : "unknown" != typeof e.returnValue && (e.returnValue = !1), this.isDefaultPrevented = Bn);
                },
                stopPropagation: function() {
                    var e = this.nativeEvent;
                    e && (e.stopPropagation ? e.stopPropagation() : "unknown" != typeof e.cancelBubble && (e.cancelBubble = !0), this.isPropagationStopped = Bn);
                },
                persist: function() {
                    this.isPersistent = Bn;
                },
                isPersistent: Rn,
                destructor: function() {
                    var e, t = this.constructor.Interface;
                    for(e in t)this[e] = null;
                    this.nativeEvent = this._targetInst = this.dispatchConfig = null, this.isPropagationStopped = this.isDefaultPrevented = Rn, this._dispatchInstances = this._dispatchListeners = null;
                }
            }), Wn.Interface = {
                type: null,
                target: null,
                currentTarget: function() {
                    return null;
                },
                eventPhase: null,
                bubbles: null,
                cancelable: null,
                timeStamp: function(e) {
                    return e.timeStamp || Date.now();
                },
                defaultPrevented: null,
                isTrusted: null
            }, Wn.extend = function(e) {
                function t() {}
                function n() {
                    return i.apply(this, arguments);
                }
                var i = this;
                t.prototype = i.prototype;
                var M = new t;
                return r(M, n.prototype), n.prototype = M, n.prototype.constructor = n, n.Interface = r({}, i.Interface, e), n.extend = i.extend, Jn(n), n;
            }, Jn(Wn);
            var Fn = Wn.extend({
                data: null
            }), Xn = Wn.extend({
                data: null
            }), Kn = [
                9,
                13,
                27,
                32
            ], qn = x && "CompositionEvent" in window, _n = null;
            x && "documentMode" in document && (_n = document.documentMode);
            var $n = x && "TextEvent" in window && !_n, ei = x && (!qn || _n && 8 < _n && 11 >= _n), ti = String.fromCharCode(32), ni = {
                beforeInput: {
                    phasedRegistrationNames: {
                        bubbled: "onBeforeInput",
                        captured: "onBeforeInputCapture"
                    },
                    dependencies: [
                        "compositionend",
                        "keypress",
                        "textInput",
                        "paste"
                    ]
                },
                compositionEnd: {
                    phasedRegistrationNames: {
                        bubbled: "onCompositionEnd",
                        captured: "onCompositionEndCapture"
                    },
                    dependencies: "blur compositionend keydown keypress keyup mousedown".split(" ")
                },
                compositionStart: {
                    phasedRegistrationNames: {
                        bubbled: "onCompositionStart",
                        captured: "onCompositionStartCapture"
                    },
                    dependencies: "blur compositionstart keydown keypress keyup mousedown".split(" ")
                },
                compositionUpdate: {
                    phasedRegistrationNames: {
                        bubbled: "onCompositionUpdate",
                        captured: "onCompositionUpdateCapture"
                    },
                    dependencies: "blur compositionupdate keydown keypress keyup mousedown".split(" ")
                }
            }, ii = !1;
            function ri(e, t) {
                switch(e){
                    case "keyup":
                        return -1 !== Kn.indexOf(t.keyCode);
                    case "keydown":
                        return 229 !== t.keyCode;
                    case "keypress":
                    case "mousedown":
                    case "blur":
                        return !0;
                    default:
                        return !1;
                }
            }
            function Mi(e) {
                return "object" == typeof (e = e.detail) && "data" in e ? e.data : null;
            }
            var ui = !1;
            var oi = {
                eventTypes: ni,
                extractEvents: function(e, t, n, i) {
                    var r;
                    if (qn) e: {
                        switch(e){
                            case "compositionstart":
                                var M = ni.compositionStart;
                                break e;
                            case "compositionend":
                                M = ni.compositionEnd;
                                break e;
                            case "compositionupdate":
                                M = ni.compositionUpdate;
                                break e;
                        }
                        M = void 0;
                    }
                    else ui ? ri(e, n) && (M = ni.compositionEnd) : "keydown" === e && 229 === n.keyCode && (M = ni.compositionStart);
                    return M ? (ei && "ko" !== n.locale && (ui || M !== ni.compositionStart ? M === ni.compositionEnd && ui && (r = Gn()) : (Un = "value" in (Pn = i) ? Pn.value : Pn.textContent, ui = !0)), M = Fn.getPooled(M, t, n, i), r ? M.data = r : null !== (r = Mi(n)) && (M.data = r), Yn(M), r = M) : r = null, (e = $n ? function(e, t) {
                        switch(e){
                            case "compositionend":
                                return Mi(t);
                            case "keypress":
                                return 32 !== t.which ? null : (ii = !0, ti);
                            case "textInput":
                                return (e = t.data) === ti && ii ? null : e;
                            default:
                                return null;
                        }
                    }(e, n) : function(e, t) {
                        if (ui) return "compositionend" === e || !qn && ri(e, t) ? (e = Gn(), Zn = Un = Pn = null, ui = !1, e) : null;
                        switch(e){
                            case "paste":
                                return null;
                            case "keypress":
                                if (!(t.ctrlKey || t.altKey || t.metaKey) || t.ctrlKey && t.altKey) {
                                    if (t.char && 1 < t.char.length) return t.char;
                                    if (t.which) return String.fromCharCode(t.which);
                                }
                                return null;
                            case "compositionend":
                                return ei && "ko" !== t.locale ? null : t.data;
                            default:
                                return null;
                        }
                    }(e, n)) ? ((t = Xn.getPooled(ni.beforeInput, t, n, i)).data = e, Yn(t)) : t = null, null === r ? t : null === t ? r : [
                        r,
                        t
                    ];
                }
            }, ci = {
                color: !0,
                date: !0,
                datetime: !0,
                "datetime-local": !0,
                email: !0,
                month: !0,
                number: !0,
                password: !0,
                range: !0,
                search: !0,
                tel: !0,
                text: !0,
                time: !0,
                url: !0,
                week: !0
            };
            function ai(e) {
                var t = e && e.nodeName && e.nodeName.toLowerCase();
                return "input" === t ? !!ci[e.type] : "textarea" === t;
            }
            var Ii = {
                change: {
                    phasedRegistrationNames: {
                        bubbled: "onChange",
                        captured: "onChangeCapture"
                    },
                    dependencies: "blur change click focus input keydown keyup selectionchange".split(" ")
                }
            };
            function li(e, t, n) {
                return (e = Wn.getPooled(Ii.change, e, t, n)).type = "change", v(n), Yn(e), e;
            }
            var Ni = null, ji = null;
            function gi(e) {
                ot(e);
            }
            function si(e) {
                if (ze(Sn(e))) return e;
            }
            function Ai(e, t) {
                if ("change" === e) return t;
            }
            var Di = !1;
            function di() {
                Ni && (Ni.detachEvent("onpropertychange", Ti), ji = Ni = null);
            }
            function Ti(e) {
                if ("value" === e.propertyName && si(ji)) {
                    if (e = li(ji, e, ct(e)), P) ot(e);
                    else {
                        P = !0;
                        try {
                            h(gi, e);
                        } finally{
                            P = !1, Z();
                        }
                    }
                }
            }
            function yi(e, t, n) {
                "focus" === e ? (di(), ji = n, (Ni = t).attachEvent("onpropertychange", Ti)) : "blur" === e && di();
            }
            function zi(e) {
                if ("selectionchange" === e || "keyup" === e || "keydown" === e) return si(ji);
            }
            function wi(e, t) {
                if ("click" === e) return si(t);
            }
            function fi(e, t) {
                if ("input" === e || "change" === e) return si(t);
            }
            x && (Di = at("input") && (!document.documentMode || 9 < document.documentMode));
            var Li = {
                eventTypes: Ii,
                _isInputEventSupported: Di,
                extractEvents: function(e, t, n, i) {
                    var r = t ? Sn(t) : window, M = r.nodeName && r.nodeName.toLowerCase();
                    if ("select" === M || "input" === M && "file" === r.type) var u = Ai;
                    else if (ai(r)) {
                        if (Di) u = fi;
                        else {
                            u = zi;
                            var o = yi;
                        }
                    } else (M = r.nodeName) && "input" === M.toLowerCase() && ("checkbox" === r.type || "radio" === r.type) && (u = wi);
                    if (u && (u = u(e, t))) return li(u, n, i);
                    o && o(e, r, t), "blur" === e && (e = r._wrapperState) && e.controlled && "number" === r.type && xe(r, "number", r.value);
                }
            }, Ei = Wn.extend({
                view: null,
                detail: null
            }), Ci = {
                Alt: "altKey",
                Control: "ctrlKey",
                Meta: "metaKey",
                Shift: "shiftKey"
            };
            function xi(e) {
                var t = this.nativeEvent;
                return t.getModifierState ? t.getModifierState(e) : !!(e = Ci[e]) && !!t[e];
            }
            function pi() {
                return xi;
            }
            var Si = 0, mi = 0, Oi = !1, vi = !1, bi = Ei.extend({
                screenX: null,
                screenY: null,
                clientX: null,
                clientY: null,
                pageX: null,
                pageY: null,
                ctrlKey: null,
                shiftKey: null,
                altKey: null,
                metaKey: null,
                getModifierState: pi,
                button: null,
                buttons: null,
                relatedTarget: function(e) {
                    return e.relatedTarget || (e.fromElement === e.srcElement ? e.toElement : e.fromElement);
                },
                movementX: function(e) {
                    if ("movementX" in e) return e.movementX;
                    var t = Si;
                    return Si = e.screenX, Oi ? "mousemove" === e.type ? e.screenX - t : 0 : (Oi = !0, 0);
                },
                movementY: function(e) {
                    if ("movementY" in e) return e.movementY;
                    var t = mi;
                    return mi = e.screenY, vi ? "mousemove" === e.type ? e.screenY - t : 0 : (vi = !0, 0);
                }
            }), hi = bi.extend({
                pointerId: null,
                width: null,
                height: null,
                pressure: null,
                tangentialPressure: null,
                tiltX: null,
                tiltY: null,
                twist: null,
                pointerType: null,
                isPrimary: null
            }), ki = {
                mouseEnter: {
                    registrationName: "onMouseEnter",
                    dependencies: [
                        "mouseout",
                        "mouseover"
                    ]
                },
                mouseLeave: {
                    registrationName: "onMouseLeave",
                    dependencies: [
                        "mouseout",
                        "mouseover"
                    ]
                },
                pointerEnter: {
                    registrationName: "onPointerEnter",
                    dependencies: [
                        "pointerout",
                        "pointerover"
                    ]
                },
                pointerLeave: {
                    registrationName: "onPointerLeave",
                    dependencies: [
                        "pointerout",
                        "pointerover"
                    ]
                }
            }, Qi = {
                eventTypes: ki,
                extractEvents: function(e, t, n, i, r) {
                    var M = "mouseover" === e || "pointerover" === e, u = "mouseout" === e || "pointerout" === e;
                    if (M && 0 == (32 & r) && (n.relatedTarget || n.fromElement) || !u && !M) return null;
                    (M = i.window === i ? i : (M = i.ownerDocument) ? M.defaultView || M.parentWindow : window, u) ? (u = t, null !== (t = (t = n.relatedTarget || n.toElement) ? xn(t) : null) && (t !== $e(t) || 5 !== t.tag && 6 !== t.tag) && (t = null)) : u = null;
                    if (u === t) return null;
                    if ("mouseout" === e || "mouseover" === e) var o = bi, c = ki.mouseLeave, a = ki.mouseEnter, I = "mouse";
                    else "pointerout" !== e && "pointerover" !== e || (o = hi, c = ki.pointerLeave, a = ki.pointerEnter, I = "pointer");
                    if (e = null == u ? M : Sn(u), M = null == t ? M : Sn(t), (c = o.getPooled(c, u, n, i)).type = I + "leave", c.target = e, c.relatedTarget = M, (n = o.getPooled(a, t, n, i)).type = I + "enter", n.target = M, n.relatedTarget = e, I = t, (i = u) && I) e: {
                        for(a = I, u = 0, e = o = i; e; e = On(e))u++;
                        for(e = 0, t = a; t; t = On(t))e++;
                        for(; 0 < u - e;)o = On(o), u--;
                        for(; 0 < e - u;)a = On(a), e--;
                        for(; u--;){
                            if (o === a || o === a.alternate) break e;
                            o = On(o), a = On(a);
                        }
                        o = null;
                    }
                    else o = null;
                    for(a = o, o = []; i && i !== a && (null === (u = i.alternate) || u !== a);)o.push(i), i = On(i);
                    for(i = []; I && I !== a && (null === (u = I.alternate) || u !== a);)i.push(I), I = On(I);
                    for(I = 0; I < o.length; I++)kn(o[I], "bubbled", c);
                    for(I = i.length; 0 < I--;)kn(i[I], "captured", n);
                    return 0 == (64 & r) ? [
                        c
                    ] : [
                        c,
                        n
                    ];
                }
            };
            var Yi = "function" == typeof Object.is ? Object.is : function(e, t) {
                return e === t && (0 !== e || 1 / e == 1 / t) || e != e && t != t;
            }, Pi = Object.prototype.hasOwnProperty;
            function Ui(e, t) {
                if (Yi(e, t)) return !0;
                if ("object" != typeof e || null === e || "object" != typeof t || null === t) return !1;
                var n = Object.keys(e), i = Object.keys(t);
                if (n.length !== i.length) return !1;
                for(i = 0; i < n.length; i++)if (!Pi.call(t, n[i]) || !Yi(e[n[i]], t[n[i]])) return !1;
                return !0;
            }
            var Zi = x && "documentMode" in document && 11 >= document.documentMode, Gi = {
                select: {
                    phasedRegistrationNames: {
                        bubbled: "onSelect",
                        captured: "onSelectCapture"
                    },
                    dependencies: "blur contextmenu dragend focus keydown keyup mousedown mouseup selectionchange".split(" ")
                }
            }, Bi = null, Ri = null, Wi = null, Hi = !1;
            function Vi(e, t) {
                var n = t.window === t ? t.document : 9 === t.nodeType ? t : t.ownerDocument;
                return Hi || null == Bi || Bi !== In(n) ? null : ("selectionStart" in (n = Bi) && gn(n) ? n = {
                    start: n.selectionStart,
                    end: n.selectionEnd
                } : n = {
                    anchorNode: (n = (n.ownerDocument && n.ownerDocument.defaultView || window).getSelection()).anchorNode,
                    anchorOffset: n.anchorOffset,
                    focusNode: n.focusNode,
                    focusOffset: n.focusOffset
                }, Wi && Ui(Wi, n) ? null : (Wi = n, (e = Wn.getPooled(Gi.select, Ri, e, t)).type = "select", e.target = Bi, Yn(e), e));
            }
            var Ji = {
                eventTypes: Gi,
                extractEvents: function(e, t, n, i, r, M) {
                    if (!(M = !(r = M || (i.window === i ? i.document : 9 === i.nodeType ? i : i.ownerDocument)))) {
                        e: {
                            r = _e(r), M = E.onSelect;
                            for(var u = 0; u < M.length; u++)if (!r.has(M[u])) {
                                r = !1;
                                break e;
                            }
                            r = !0;
                        }
                        M = !r;
                    }
                    if (M) return null;
                    switch(r = t ? Sn(t) : window, e){
                        case "focus":
                            (ai(r) || "true" === r.contentEditable) && (Bi = r, Ri = t, Wi = null);
                            break;
                        case "blur":
                            Wi = Ri = Bi = null;
                            break;
                        case "mousedown":
                            Hi = !0;
                            break;
                        case "contextmenu":
                        case "mouseup":
                        case "dragend":
                            return Hi = !1, Vi(n, i);
                        case "selectionchange":
                            if (Zi) break;
                        case "keydown":
                        case "keyup":
                            return Vi(n, i);
                    }
                    return null;
                }
            }, Fi = Wn.extend({
                animationName: null,
                elapsedTime: null,
                pseudoElement: null
            }), Xi = Wn.extend({
                clipboardData: function(e) {
                    return "clipboardData" in e ? e.clipboardData : window.clipboardData;
                }
            }), Ki = Ei.extend({
                relatedTarget: null
            });
            function qi(e) {
                var t = e.keyCode;
                return "charCode" in e ? 0 === (e = e.charCode) && 13 === t && (e = 13) : e = t, 10 === e && (e = 13), 32 <= e || 13 === e ? e : 0;
            }
            var _i = {
                Esc: "Escape",
                Spacebar: " ",
                Left: "ArrowLeft",
                Up: "ArrowUp",
                Right: "ArrowRight",
                Down: "ArrowDown",
                Del: "Delete",
                Win: "OS",
                Menu: "ContextMenu",
                Apps: "ContextMenu",
                Scroll: "ScrollLock",
                MozPrintableKey: "Unidentified"
            }, $i = {
                8: "Backspace",
                9: "Tab",
                12: "Clear",
                13: "Enter",
                16: "Shift",
                17: "Control",
                18: "Alt",
                19: "Pause",
                20: "CapsLock",
                27: "Escape",
                32: " ",
                33: "PageUp",
                34: "PageDown",
                35: "End",
                36: "Home",
                37: "ArrowLeft",
                38: "ArrowUp",
                39: "ArrowRight",
                40: "ArrowDown",
                45: "Insert",
                46: "Delete",
                112: "F1",
                113: "F2",
                114: "F3",
                115: "F4",
                116: "F5",
                117: "F6",
                118: "F7",
                119: "F8",
                120: "F9",
                121: "F10",
                122: "F11",
                123: "F12",
                144: "NumLock",
                145: "ScrollLock",
                224: "Meta"
            }, er = Ei.extend({
                key: function(e) {
                    if (e.key) {
                        var t = _i[e.key] || e.key;
                        if ("Unidentified" !== t) return t;
                    }
                    return "keypress" === e.type ? 13 === (e = qi(e)) ? "Enter" : String.fromCharCode(e) : "keydown" === e.type || "keyup" === e.type ? $i[e.keyCode] || "Unidentified" : "";
                },
                location: null,
                ctrlKey: null,
                shiftKey: null,
                altKey: null,
                metaKey: null,
                repeat: null,
                locale: null,
                getModifierState: pi,
                charCode: function(e) {
                    return "keypress" === e.type ? qi(e) : 0;
                },
                keyCode: function(e) {
                    return "keydown" === e.type || "keyup" === e.type ? e.keyCode : 0;
                },
                which: function(e) {
                    return "keypress" === e.type ? qi(e) : "keydown" === e.type || "keyup" === e.type ? e.keyCode : 0;
                }
            }), tr = bi.extend({
                dataTransfer: null
            }), nr = Ei.extend({
                touches: null,
                targetTouches: null,
                changedTouches: null,
                altKey: null,
                metaKey: null,
                ctrlKey: null,
                shiftKey: null,
                getModifierState: pi
            }), ir = Wn.extend({
                propertyName: null,
                elapsedTime: null,
                pseudoElement: null
            }), rr = bi.extend({
                deltaX: function(e) {
                    return "deltaX" in e ? e.deltaX : "wheelDeltaX" in e ? -e.wheelDeltaX : 0;
                },
                deltaY: function(e) {
                    return "deltaY" in e ? e.deltaY : "wheelDeltaY" in e ? -e.wheelDeltaY : "wheelDelta" in e ? -e.wheelDelta : 0;
                },
                deltaZ: null,
                deltaMode: null
            }), Mr = {
                eventTypes: Yt,
                extractEvents: function(e, t, n, i) {
                    var r = Pt.get(e);
                    if (!r) return null;
                    switch(e){
                        case "keypress":
                            if (0 === qi(n)) return null;
                        case "keydown":
                        case "keyup":
                            e = er;
                            break;
                        case "blur":
                        case "focus":
                            e = Ki;
                            break;
                        case "click":
                            if (2 === n.button) return null;
                        case "auxclick":
                        case "dblclick":
                        case "mousedown":
                        case "mousemove":
                        case "mouseup":
                        case "mouseout":
                        case "mouseover":
                        case "contextmenu":
                            e = bi;
                            break;
                        case "drag":
                        case "dragend":
                        case "dragenter":
                        case "dragexit":
                        case "dragleave":
                        case "dragover":
                        case "dragstart":
                        case "drop":
                            e = tr;
                            break;
                        case "touchcancel":
                        case "touchend":
                        case "touchmove":
                        case "touchstart":
                            e = nr;
                            break;
                        case Ve:
                        case Je:
                        case Fe:
                            e = Fi;
                            break;
                        case Xe:
                            e = ir;
                            break;
                        case "scroll":
                            e = Ei;
                            break;
                        case "wheel":
                            e = rr;
                            break;
                        case "copy":
                        case "cut":
                        case "paste":
                            e = Xi;
                            break;
                        case "gotpointercapture":
                        case "lostpointercapture":
                        case "pointercancel":
                        case "pointerdown":
                        case "pointermove":
                        case "pointerout":
                        case "pointerover":
                        case "pointerup":
                            e = hi;
                            break;
                        default:
                            e = Wn;
                    }
                    return Yn(t = e.getPooled(r, t, n, i)), t;
                }
            };
            if (d) throw Error(u(101));
            d = Array.prototype.slice.call("ResponderEventPlugin SimpleEventPlugin EnterLeaveEventPlugin ChangeEventPlugin SelectEventPlugin BeforeInputEventPlugin".split(" ")), y(), g = mn, s = pn, A = Sn, C({
                SimpleEventPlugin: Mr,
                EnterLeaveEventPlugin: Qi,
                ChangeEventPlugin: Li,
                SelectEventPlugin: Ji,
                BeforeInputEventPlugin: oi
            });
            var ur = [], or = -1;
            function cr(e) {
                0 > or || (e.current = ur[or], ur[or] = null, or--);
            }
            function ar(e, t) {
                or++, ur[or] = e.current, e.current = t;
            }
            var Ir = {}, lr = {
                current: Ir
            }, Nr = {
                current: !1
            }, jr = Ir;
            function gr(e, t) {
                var n = e.type.contextTypes;
                if (!n) return Ir;
                var i = e.stateNode;
                if (i && i.__reactInternalMemoizedUnmaskedChildContext === t) return i.__reactInternalMemoizedMaskedChildContext;
                var r, M = {};
                for(r in n)M[r] = t[r];
                return i && ((e = e.stateNode).__reactInternalMemoizedUnmaskedChildContext = t, e.__reactInternalMemoizedMaskedChildContext = M), M;
            }
            function sr(e) {
                return null != (e = e.childContextTypes);
            }
            function Ar() {
                cr(Nr), cr(lr);
            }
            function Dr(e, t, n) {
                if (lr.current !== Ir) throw Error(u(168));
                ar(lr, t), ar(Nr, n);
            }
            function dr(e, t, n) {
                var i = e.stateNode;
                if (e = t.childContextTypes, "function" != typeof i.getChildContext) return n;
                for(var M in i = i.getChildContext())if (!(M in e)) throw Error(u(108, Ae(t) || "Unknown", M));
                return r({}, n, {}, i);
            }
            function Tr(e) {
                return e = (e = e.stateNode) && e.__reactInternalMemoizedMergedChildContext || Ir, jr = lr.current, ar(lr, e), ar(Nr, Nr.current), !0;
            }
            function yr(e, t, n) {
                var i = e.stateNode;
                if (!i) throw Error(u(169));
                n ? (e = dr(e, t, jr), i.__reactInternalMemoizedMergedChildContext = e, cr(Nr), cr(lr), ar(lr, e)) : cr(Nr), ar(Nr, n);
            }
            var zr = M.unstable_runWithPriority, wr = M.unstable_scheduleCallback, fr = M.unstable_cancelCallback, Lr = M.unstable_requestPaint, Er = M.unstable_now, Cr = M.unstable_getCurrentPriorityLevel, xr = M.unstable_ImmediatePriority, pr = M.unstable_UserBlockingPriority, Sr = M.unstable_NormalPriority, mr = M.unstable_LowPriority, Or = M.unstable_IdlePriority, vr = {}, br = M.unstable_shouldYield, hr = void 0 !== Lr ? Lr : function() {}, kr = null, Qr = null, Yr = !1, Pr = Er(), Ur = 1e4 > Pr ? Er : function() {
                return Er() - Pr;
            };
            function Zr() {
                switch(Cr()){
                    case xr:
                        return 99;
                    case pr:
                        return 98;
                    case Sr:
                        return 97;
                    case mr:
                        return 96;
                    case Or:
                        return 95;
                    default:
                        throw Error(u(332));
                }
            }
            function Gr(e) {
                switch(e){
                    case 99:
                        return xr;
                    case 98:
                        return pr;
                    case 97:
                        return Sr;
                    case 96:
                        return mr;
                    case 95:
                        return Or;
                    default:
                        throw Error(u(332));
                }
            }
            function Br(e, t) {
                return e = Gr(e), zr(e, t);
            }
            function Rr(e, t, n) {
                return e = Gr(e), wr(e, t, n);
            }
            function Wr(e) {
                return null === kr ? (kr = [
                    e
                ], Qr = wr(xr, Vr)) : kr.push(e), vr;
            }
            function Hr() {
                if (null !== Qr) {
                    var e = Qr;
                    Qr = null, fr(e);
                }
                Vr();
            }
            function Vr() {
                if (!Yr && null !== kr) {
                    Yr = !0;
                    var e = 0;
                    try {
                        var t = kr;
                        Br(99, function() {
                            for(; e < t.length; e++){
                                var n = t[e];
                                do n = n(!0);
                                while (null !== n);
                            }
                        }), kr = null;
                    } catch (t) {
                        throw null !== kr && (kr = kr.slice(e + 1)), wr(xr, Hr), t;
                    } finally{
                        Yr = !1;
                    }
                }
            }
            function Jr(e, t, n) {
                return 1073741821 - (1 + ((1073741821 - e + t / 10) / (n /= 10) | 0)) * n;
            }
            function Fr(e, t) {
                if (e && e.defaultProps) for(var n in t = r({}, t), e = e.defaultProps)void 0 === t[n] && (t[n] = e[n]);
                return t;
            }
            var Xr = {
                current: null
            }, Kr = null, qr = null, _r = null;
            function $r() {
                _r = qr = Kr = null;
            }
            function eM(e) {
                var t = Xr.current;
                cr(Xr), e.type._context._currentValue = t;
            }
            function tM(e, t) {
                for(; null !== e;){
                    var n = e.alternate;
                    if (e.childExpirationTime < t) e.childExpirationTime = t, null !== n && n.childExpirationTime < t && (n.childExpirationTime = t);
                    else {
                        if (!(null !== n && n.childExpirationTime < t)) break;
                        n.childExpirationTime = t;
                    }
                    e = e.return;
                }
            }
            function nM(e, t) {
                Kr = e, _r = qr = null, null !== (e = e.dependencies) && null !== e.firstContext && (e.expirationTime >= t && (Su = !0), e.firstContext = null);
            }
            function iM(e, t) {
                if (_r !== e && !1 !== t && 0 !== t) {
                    if ("number" == typeof t && 1073741823 !== t || (_r = e, t = 1073741823), t = {
                        context: e,
                        observedBits: t,
                        next: null
                    }, null === qr) {
                        if (null === Kr) throw Error(u(308));
                        qr = t, Kr.dependencies = {
                            expirationTime: 0,
                            firstContext: t,
                            responders: null
                        };
                    } else qr = qr.next = t;
                }
                return e._currentValue;
            }
            var rM = !1;
            function MM(e) {
                e.updateQueue = {
                    baseState: e.memoizedState,
                    baseQueue: null,
                    shared: {
                        pending: null
                    },
                    effects: null
                };
            }
            function uM(e, t) {
                e = e.updateQueue, t.updateQueue === e && (t.updateQueue = {
                    baseState: e.baseState,
                    baseQueue: e.baseQueue,
                    shared: e.shared,
                    effects: e.effects
                });
            }
            function oM(e, t) {
                return (e = {
                    expirationTime: e,
                    suspenseConfig: t,
                    tag: 0,
                    payload: null,
                    callback: null,
                    next: null
                }).next = e;
            }
            function cM(e, t) {
                if (null !== (e = e.updateQueue)) {
                    var n = (e = e.shared).pending;
                    null === n ? t.next = t : (t.next = n.next, n.next = t), e.pending = t;
                }
            }
            function aM(e, t) {
                var n = e.alternate;
                null !== n && uM(n, e), null === (n = (e = e.updateQueue).baseQueue) ? (e.baseQueue = t.next = t, t.next = t) : (t.next = n.next, n.next = t);
            }
            function IM(e, t, n, i) {
                var M = e.updateQueue;
                rM = !1;
                var u = M.baseQueue, o = M.shared.pending;
                if (null !== o) {
                    if (null !== u) {
                        var c = u.next;
                        u.next = o.next, o.next = c;
                    }
                    u = o, M.shared.pending = null, null !== (c = e.alternate) && null !== (c = c.updateQueue) && (c.baseQueue = o);
                }
                if (null !== u) {
                    c = u.next;
                    var a = M.baseState, I = 0, l = null, N = null, j = null;
                    if (null !== c) for(var g = c;;){
                        if ((o = g.expirationTime) < i) {
                            var s = {
                                expirationTime: g.expirationTime,
                                suspenseConfig: g.suspenseConfig,
                                tag: g.tag,
                                payload: g.payload,
                                callback: g.callback,
                                next: null
                            };
                            null === j ? (N = j = s, l = a) : j = j.next = s, o > I && (I = o);
                        } else {
                            null !== j && (j = j.next = {
                                expirationTime: 1073741823,
                                suspenseConfig: g.suspenseConfig,
                                tag: g.tag,
                                payload: g.payload,
                                callback: g.callback,
                                next: null
                            }), Mc(o, g.suspenseConfig);
                            e: {
                                var A = e, D = g;
                                switch(o = t, s = n, D.tag){
                                    case 1:
                                        if ("function" == typeof (A = D.payload)) {
                                            a = A.call(s, a, o);
                                            break e;
                                        }
                                        a = A;
                                        break e;
                                    case 3:
                                        A.effectTag = -4097 & A.effectTag | 64;
                                    case 0:
                                        if (null == (o = "function" == typeof (A = D.payload) ? A.call(s, a, o) : A)) break e;
                                        a = r({}, a, o);
                                        break e;
                                    case 2:
                                        rM = !0;
                                }
                            }
                            null !== g.callback && (e.effectTag |= 32, null === (o = M.effects) ? M.effects = [
                                g
                            ] : o.push(g));
                        }
                        if (null === (g = g.next) || g === c) {
                            if (null === (o = M.shared.pending)) break;
                            g = u.next = o.next, o.next = c, M.baseQueue = u = o, M.shared.pending = null;
                        }
                    }
                    null === j ? l = a : j.next = N, M.baseState = l, M.baseQueue = j, uc(I), e.expirationTime = I, e.memoizedState = a;
                }
            }
            function lM(e, t, n) {
                if (e = t.effects, t.effects = null, null !== e) for(t = 0; t < e.length; t++){
                    var i = e[t], r = i.callback;
                    if (null !== r) {
                        if (i.callback = null, i = r, r = n, "function" != typeof i) throw Error(u(191, i));
                        i.call(r);
                    }
                }
            }
            var NM = K.ReactCurrentBatchConfig, jM = (new i.Component).refs;
            function gM(e, t, n, i) {
                n = null == (n = n(i, t = e.memoizedState)) ? t : r({}, t, n), e.memoizedState = n, 0 === e.expirationTime && (e.updateQueue.baseState = n);
            }
            var sM = {
                isMounted: function(e) {
                    return !!(e = e._reactInternalFiber) && $e(e) === e;
                },
                enqueueSetState: function(e, t, n) {
                    e = e._reactInternalFiber;
                    var i = Vo(), r = NM.suspense;
                    (r = oM(i = Jo(i, e, r), r)).payload = t, null != n && (r.callback = n), cM(e, r), Fo(e, i);
                },
                enqueueReplaceState: function(e, t, n) {
                    e = e._reactInternalFiber;
                    var i = Vo(), r = NM.suspense;
                    (r = oM(i = Jo(i, e, r), r)).tag = 1, r.payload = t, null != n && (r.callback = n), cM(e, r), Fo(e, i);
                },
                enqueueForceUpdate: function(e, t) {
                    e = e._reactInternalFiber;
                    var n = Vo(), i = NM.suspense;
                    (i = oM(n = Jo(n, e, i), i)).tag = 2, null != t && (i.callback = t), cM(e, i), Fo(e, n);
                }
            };
            function AM(e, t, n, i, r, M, u) {
                return "function" == typeof (e = e.stateNode).shouldComponentUpdate ? e.shouldComponentUpdate(i, M, u) : !t.prototype || !t.prototype.isPureReactComponent || !Ui(n, i) || !Ui(r, M);
            }
            function DM(e, t, n) {
                var i = !1, r = Ir, M = t.contextType;
                return "object" == typeof M && null !== M ? M = iM(M) : (r = sr(t) ? jr : lr.current, M = (i = null != (i = t.contextTypes)) ? gr(e, r) : Ir), t = new t(n, M), e.memoizedState = null !== t.state && void 0 !== t.state ? t.state : null, t.updater = sM, e.stateNode = t, t._reactInternalFiber = e, i && ((e = e.stateNode).__reactInternalMemoizedUnmaskedChildContext = r, e.__reactInternalMemoizedMaskedChildContext = M), t;
            }
            function dM(e, t, n, i) {
                e = t.state, "function" == typeof t.componentWillReceiveProps && t.componentWillReceiveProps(n, i), "function" == typeof t.UNSAFE_componentWillReceiveProps && t.UNSAFE_componentWillReceiveProps(n, i), t.state !== e && sM.enqueueReplaceState(t, t.state, null);
            }
            function TM(e, t, n, i) {
                var r = e.stateNode;
                r.props = n, r.state = e.memoizedState, r.refs = jM, MM(e);
                var M = t.contextType;
                "object" == typeof M && null !== M ? r.context = iM(M) : (M = sr(t) ? jr : lr.current, r.context = gr(e, M)), IM(e, n, r, i), r.state = e.memoizedState, "function" == typeof (M = t.getDerivedStateFromProps) && (gM(e, t, M, n), r.state = e.memoizedState), "function" == typeof t.getDerivedStateFromProps || "function" == typeof r.getSnapshotBeforeUpdate || "function" != typeof r.UNSAFE_componentWillMount && "function" != typeof r.componentWillMount || (t = r.state, "function" == typeof r.componentWillMount && r.componentWillMount(), "function" == typeof r.UNSAFE_componentWillMount && r.UNSAFE_componentWillMount(), t !== r.state && sM.enqueueReplaceState(r, r.state, null), IM(e, n, r, i), r.state = e.memoizedState), "function" == typeof r.componentDidMount && (e.effectTag |= 4);
            }
            var yM = Array.isArray;
            function zM(e, t, n) {
                if (null !== (e = n.ref) && "function" != typeof e && "object" != typeof e) {
                    if (n._owner) {
                        if (n = n._owner) {
                            if (1 !== n.tag) throw Error(u(309));
                            var i = n.stateNode;
                        }
                        if (!i) throw Error(u(147, e));
                        var r = "" + e;
                        return null !== t && null !== t.ref && "function" == typeof t.ref && t.ref._stringRef === r ? t.ref : ((t = function(e) {
                            var t = i.refs;
                            t === jM && (t = i.refs = {}), null === e ? delete t[r] : t[r] = e;
                        })._stringRef = r, t);
                    }
                    if ("string" != typeof e) throw Error(u(284));
                    if (!n._owner) throw Error(u(290, e));
                }
                return e;
            }
            function wM(e, t) {
                if ("textarea" !== e.type) throw Error(u(31, "[object Object]" === Object.prototype.toString.call(t) ? "object with keys {" + Object.keys(t).join(", ") + "}" : t, ""));
            }
            function fM(e) {
                function t(t, n) {
                    if (e) {
                        var i = t.lastEffect;
                        null !== i ? (i.nextEffect = n, t.lastEffect = n) : t.firstEffect = t.lastEffect = n, n.nextEffect = null, n.effectTag = 8;
                    }
                }
                function n(n, i) {
                    if (!e) return null;
                    for(; null !== i;)t(n, i), i = i.sibling;
                    return null;
                }
                function i(e, t) {
                    for(e = new Map; null !== t;)null !== t.key ? e.set(t.key, t) : e.set(t.index, t), t = t.sibling;
                    return e;
                }
                function r(e, t) {
                    return (e = Cc(e, t)).index = 0, e.sibling = null, e;
                }
                function M(t, n, i) {
                    return t.index = i, e ? null !== (i = t.alternate) ? (i = i.index) < n ? (t.effectTag = 2, n) : i : (t.effectTag = 2, n) : n;
                }
                function o(t) {
                    return e && null === t.alternate && (t.effectTag = 2), t;
                }
                function c(e, t, n, i) {
                    return null === t || 6 !== t.tag ? ((t = Sc(n, e.mode, i)).return = e, t) : ((t = r(t, n)).return = e, t);
                }
                function a(e, t, n, i) {
                    return null !== t && t.elementType === n.type ? ((i = r(t, n.props)).ref = zM(e, t, n), i.return = e, i) : ((i = xc(n.type, n.key, n.props, null, e.mode, i)).ref = zM(e, t, n), i.return = e, i);
                }
                function I(e, t, n, i) {
                    return null === t || 4 !== t.tag || t.stateNode.containerInfo !== n.containerInfo || t.stateNode.implementation !== n.implementation ? ((t = mc(n, e.mode, i)).return = e, t) : ((t = r(t, n.children || [])).return = e, t);
                }
                function l(e, t, n, i, M) {
                    return null === t || 7 !== t.tag ? ((t = pc(n, e.mode, i, M)).return = e, t) : ((t = r(t, n)).return = e, t);
                }
                function N(e, t, n) {
                    if ("string" == typeof t || "number" == typeof t) return (t = Sc("" + t, e.mode, n)).return = e, t;
                    if ("object" == typeof t && null !== t) {
                        switch(t.$$typeof){
                            case ee:
                                return (n = xc(t.type, t.key, t.props, null, e.mode, n)).ref = zM(e, null, t), n.return = e, n;
                            case te:
                                return (t = mc(t, e.mode, n)).return = e, t;
                        }
                        if (yM(t) || se(t)) return (t = pc(t, e.mode, n, null)).return = e, t;
                        wM(e, t);
                    }
                    return null;
                }
                function j(e, t, n, i) {
                    var r = null !== t ? t.key : null;
                    if ("string" == typeof n || "number" == typeof n) return null !== r ? null : c(e, t, "" + n, i);
                    if ("object" == typeof n && null !== n) {
                        switch(n.$$typeof){
                            case ee:
                                return n.key === r ? n.type === ne ? l(e, t, n.props.children, i, r) : a(e, t, n, i) : null;
                            case te:
                                return n.key === r ? I(e, t, n, i) : null;
                        }
                        if (yM(n) || se(n)) return null !== r ? null : l(e, t, n, i, null);
                        wM(e, n);
                    }
                    return null;
                }
                function g(e, t, n, i, r) {
                    if ("string" == typeof i || "number" == typeof i) return c(t, e = e.get(n) || null, "" + i, r);
                    if ("object" == typeof i && null !== i) {
                        switch(i.$$typeof){
                            case ee:
                                return e = e.get(null === i.key ? n : i.key) || null, i.type === ne ? l(t, e, i.props.children, r, i.key) : a(t, e, i, r);
                            case te:
                                return I(t, e = e.get(null === i.key ? n : i.key) || null, i, r);
                        }
                        if (yM(i) || se(i)) return l(t, e = e.get(n) || null, i, r, null);
                        wM(t, i);
                    }
                    return null;
                }
                function s(r, u, o, c) {
                    for(var a = null, I = null, l = u, s = u = 0, A = null; null !== l && s < o.length; s++){
                        l.index > s ? (A = l, l = null) : A = l.sibling;
                        var D = j(r, l, o[s], c);
                        if (null === D) {
                            null === l && (l = A);
                            break;
                        }
                        e && l && null === D.alternate && t(r, l), u = M(D, u, s), null === I ? a = D : I.sibling = D, I = D, l = A;
                    }
                    if (s === o.length) return n(r, l), a;
                    if (null === l) {
                        for(; s < o.length; s++)null !== (l = N(r, o[s], c)) && (u = M(l, u, s), null === I ? a = l : I.sibling = l, I = l);
                        return a;
                    }
                    for(l = i(r, l); s < o.length; s++)null !== (A = g(l, r, s, o[s], c)) && (e && null !== A.alternate && l.delete(null === A.key ? s : A.key), u = M(A, u, s), null === I ? a = A : I.sibling = A, I = A);
                    return e && l.forEach(function(e) {
                        return t(r, e);
                    }), a;
                }
                function A(r, o, c, a) {
                    var I = se(c);
                    if ("function" != typeof I) throw Error(u(150));
                    if (null == (c = I.call(c))) throw Error(u(151));
                    for(var l = I = null, s = o, A = o = 0, D = null, d = c.next(); null !== s && !d.done; A++, d = c.next()){
                        s.index > A ? (D = s, s = null) : D = s.sibling;
                        var T = j(r, s, d.value, a);
                        if (null === T) {
                            null === s && (s = D);
                            break;
                        }
                        e && s && null === T.alternate && t(r, s), o = M(T, o, A), null === l ? I = T : l.sibling = T, l = T, s = D;
                    }
                    if (d.done) return n(r, s), I;
                    if (null === s) {
                        for(; !d.done; A++, d = c.next())null !== (d = N(r, d.value, a)) && (o = M(d, o, A), null === l ? I = d : l.sibling = d, l = d);
                        return I;
                    }
                    for(s = i(r, s); !d.done; A++, d = c.next())null !== (d = g(s, r, A, d.value, a)) && (e && null !== d.alternate && s.delete(null === d.key ? A : d.key), o = M(d, o, A), null === l ? I = d : l.sibling = d, l = d);
                    return e && s.forEach(function(e) {
                        return t(r, e);
                    }), I;
                }
                return function(e, i, M, c) {
                    var a = "object" == typeof M && null !== M && M.type === ne && null === M.key;
                    a && (M = M.props.children);
                    var I = "object" == typeof M && null !== M;
                    if (I) switch(M.$$typeof){
                        case ee:
                            e: {
                                for(I = M.key, a = i; null !== a;){
                                    if (a.key === I) {
                                        switch(a.tag){
                                            case 7:
                                                if (M.type === ne) {
                                                    n(e, a.sibling), (i = r(a, M.props.children)).return = e, e = i;
                                                    break e;
                                                }
                                                break;
                                            default:
                                                if (a.elementType === M.type) {
                                                    n(e, a.sibling), (i = r(a, M.props)).ref = zM(e, a, M), i.return = e, e = i;
                                                    break e;
                                                }
                                        }
                                        n(e, a);
                                        break;
                                    }
                                    t(e, a), a = a.sibling;
                                }
                                M.type === ne ? ((i = pc(M.props.children, e.mode, c, M.key)).return = e, e = i) : ((c = xc(M.type, M.key, M.props, null, e.mode, c)).ref = zM(e, i, M), c.return = e, e = c);
                            }
                            return o(e);
                        case te:
                            e: {
                                for(a = M.key; null !== i;){
                                    if (i.key === a) {
                                        if (4 === i.tag && i.stateNode.containerInfo === M.containerInfo && i.stateNode.implementation === M.implementation) {
                                            n(e, i.sibling), (i = r(i, M.children || [])).return = e, e = i;
                                            break e;
                                        }
                                        n(e, i);
                                        break;
                                    }
                                    t(e, i), i = i.sibling;
                                }
                                (i = mc(M, e.mode, c)).return = e, e = i;
                            }
                            return o(e);
                    }
                    if ("string" == typeof M || "number" == typeof M) return M = "" + M, null !== i && 6 === i.tag ? (n(e, i.sibling), (i = r(i, M)).return = e, e = i) : (n(e, i), (i = Sc(M, e.mode, c)).return = e, e = i), o(e);
                    if (yM(M)) return s(e, i, M, c);
                    if (se(M)) return A(e, i, M, c);
                    if (I && wM(e, M), void 0 === M && !a) switch(e.tag){
                        case 1:
                        case 0:
                            throw e = e.type, Error(u(152, e.displayName || e.name || "Component"));
                    }
                    return n(e, i);
                };
            }
            var LM = fM(!0), EM = fM(!1), CM = {}, xM = {
                current: CM
            }, pM = {
                current: CM
            }, SM = {
                current: CM
            };
            function mM(e) {
                if (e === CM) throw Error(u(174));
                return e;
            }
            function OM(e, t) {
                switch(ar(SM, t), ar(pM, e), ar(xM, CM), e = t.nodeType){
                    case 9:
                    case 11:
                        t = (t = t.documentElement) ? t.namespaceURI : Ye(null, "");
                        break;
                    default:
                        t = Ye(t = (e = 8 === e ? t.parentNode : t).namespaceURI || null, e = e.tagName);
                }
                cr(xM), ar(xM, t);
            }
            function vM() {
                cr(xM), cr(pM), cr(SM);
            }
            function bM(e) {
                mM(SM.current);
                var t = mM(xM.current), n = Ye(t, e.type);
                t !== n && (ar(pM, e), ar(xM, n));
            }
            function hM(e) {
                pM.current === e && (cr(xM), cr(pM));
            }
            var kM = {
                current: 0
            };
            function QM(e) {
                for(var t = e; null !== t;){
                    if (13 === t.tag) {
                        var n = t.memoizedState;
                        if (null !== n && (null === (n = n.dehydrated) || "$?" === n.data || "$!" === n.data)) return t;
                    } else if (19 === t.tag && void 0 !== t.memoizedProps.revealOrder) {
                        if (0 != (64 & t.effectTag)) return t;
                    } else if (null !== t.child) {
                        t.child.return = t, t = t.child;
                        continue;
                    }
                    if (t === e) break;
                    for(; null === t.sibling;){
                        if (null === t.return || t.return === e) return null;
                        t = t.return;
                    }
                    t.sibling.return = t.return, t = t.sibling;
                }
                return null;
            }
            function YM(e, t) {
                return {
                    responder: e,
                    props: t
                };
            }
            var PM = K.ReactCurrentDispatcher, UM = K.ReactCurrentBatchConfig, ZM = 0, GM = null, BM = null, RM = null, WM = !1;
            function HM() {
                throw Error(u(321));
            }
            function VM(e, t) {
                if (null === t) return !1;
                for(var n = 0; n < t.length && n < e.length; n++)if (!Yi(e[n], t[n])) return !1;
                return !0;
            }
            function JM(e, t, n, i, r, M) {
                if (ZM = M, GM = t, t.memoizedState = null, t.updateQueue = null, t.expirationTime = 0, PM.current = null === e || null === e.memoizedState ? Au : Du, e = n(i, r), t.expirationTime === ZM) {
                    M = 0;
                    do {
                        if (t.expirationTime = 0, !(25 > M)) throw Error(u(301));
                        M += 1, RM = BM = null, t.updateQueue = null, PM.current = du, e = n(i, r);
                    }while (t.expirationTime === ZM);
                }
                if (PM.current = su, t = null !== BM && null !== BM.next, ZM = 0, RM = BM = GM = null, WM = !1, t) throw Error(u(300));
                return e;
            }
            function FM() {
                var e = {
                    memoizedState: null,
                    baseState: null,
                    baseQueue: null,
                    queue: null,
                    next: null
                };
                return null === RM ? GM.memoizedState = RM = e : RM = RM.next = e, RM;
            }
            function XM() {
                if (null === BM) {
                    var e = GM.alternate;
                    e = null !== e ? e.memoizedState : null;
                } else e = BM.next;
                var t = null === RM ? GM.memoizedState : RM.next;
                if (null !== t) RM = t, BM = e;
                else {
                    if (null === e) throw Error(u(310));
                    e = {
                        memoizedState: (BM = e).memoizedState,
                        baseState: BM.baseState,
                        baseQueue: BM.baseQueue,
                        queue: BM.queue,
                        next: null
                    }, null === RM ? GM.memoizedState = RM = e : RM = RM.next = e;
                }
                return RM;
            }
            function KM(e, t) {
                return "function" == typeof t ? t(e) : t;
            }
            function qM(e) {
                var t = XM(), n = t.queue;
                if (null === n) throw Error(u(311));
                n.lastRenderedReducer = e;
                var i = BM, r = i.baseQueue, M = n.pending;
                if (null !== M) {
                    if (null !== r) {
                        var o = r.next;
                        r.next = M.next, M.next = o;
                    }
                    i.baseQueue = r = M, n.pending = null;
                }
                if (null !== r) {
                    r = r.next, i = i.baseState;
                    var c = o = M = null, a = r;
                    do {
                        var I = a.expirationTime;
                        if (I < ZM) {
                            var l = {
                                expirationTime: a.expirationTime,
                                suspenseConfig: a.suspenseConfig,
                                action: a.action,
                                eagerReducer: a.eagerReducer,
                                eagerState: a.eagerState,
                                next: null
                            };
                            null === c ? (o = c = l, M = i) : c = c.next = l, I > GM.expirationTime && (GM.expirationTime = I, uc(I));
                        } else null !== c && (c = c.next = {
                            expirationTime: 1073741823,
                            suspenseConfig: a.suspenseConfig,
                            action: a.action,
                            eagerReducer: a.eagerReducer,
                            eagerState: a.eagerState,
                            next: null
                        }), Mc(I, a.suspenseConfig), i = a.eagerReducer === e ? a.eagerState : e(i, a.action);
                        a = a.next;
                    }while (null !== a && a !== r);
                    null === c ? M = i : c.next = o, Yi(i, t.memoizedState) || (Su = !0), t.memoizedState = i, t.baseState = M, t.baseQueue = c, n.lastRenderedState = i;
                }
                return [
                    t.memoizedState,
                    n.dispatch
                ];
            }
            function _M(e) {
                var t = XM(), n = t.queue;
                if (null === n) throw Error(u(311));
                n.lastRenderedReducer = e;
                var i = n.dispatch, r = n.pending, M = t.memoizedState;
                if (null !== r) {
                    n.pending = null;
                    var o = r = r.next;
                    do M = e(M, o.action), o = o.next;
                    while (o !== r);
                    Yi(M, t.memoizedState) || (Su = !0), t.memoizedState = M, null === t.baseQueue && (t.baseState = M), n.lastRenderedState = M;
                }
                return [
                    M,
                    i
                ];
            }
            function $M(e) {
                var t = FM();
                return "function" == typeof e && (e = e()), t.memoizedState = t.baseState = e, e = (e = t.queue = {
                    pending: null,
                    dispatch: null,
                    lastRenderedReducer: KM,
                    lastRenderedState: e
                }).dispatch = gu.bind(null, GM, e), [
                    t.memoizedState,
                    e
                ];
            }
            function eu(e, t, n, i) {
                return e = {
                    tag: e,
                    create: t,
                    destroy: n,
                    deps: i,
                    next: null
                }, null === (t = GM.updateQueue) ? (t = {
                    lastEffect: null
                }, GM.updateQueue = t, t.lastEffect = e.next = e) : null === (n = t.lastEffect) ? t.lastEffect = e.next = e : (i = n.next, n.next = e, e.next = i, t.lastEffect = e), e;
            }
            function tu() {
                return XM().memoizedState;
            }
            function nu(e, t, n, i) {
                var r = FM();
                GM.effectTag |= e, r.memoizedState = eu(1 | t, n, void 0, void 0 === i ? null : i);
            }
            function iu(e, t, n, i) {
                var r = XM();
                i = void 0 === i ? null : i;
                var M = void 0;
                if (null !== BM) {
                    var u = BM.memoizedState;
                    if (M = u.destroy, null !== i && VM(i, u.deps)) return void eu(t, n, M, i);
                }
                GM.effectTag |= e, r.memoizedState = eu(1 | t, n, M, i);
            }
            function ru(e, t) {
                return nu(516, 4, e, t);
            }
            function Mu(e, t) {
                return iu(516, 4, e, t);
            }
            function uu(e, t) {
                return iu(4, 2, e, t);
            }
            function ou(e, t) {
                return "function" == typeof t ? (e = e(), t(e), function() {
                    t(null);
                }) : null != t ? (e = e(), t.current = e, function() {
                    t.current = null;
                }) : void 0;
            }
            function cu(e, t, n) {
                return n = null != n ? n.concat([
                    e
                ]) : null, iu(4, 2, ou.bind(null, t, e), n);
            }
            function au() {}
            function Iu(e, t) {
                return FM().memoizedState = [
                    e,
                    void 0 === t ? null : t
                ], e;
            }
            function lu(e, t) {
                var n = XM();
                t = void 0 === t ? null : t;
                var i = n.memoizedState;
                return null !== i && null !== t && VM(t, i[1]) ? i[0] : (n.memoizedState = [
                    e,
                    t
                ], e);
            }
            function Nu(e, t) {
                var n = XM();
                t = void 0 === t ? null : t;
                var i = n.memoizedState;
                return null !== i && null !== t && VM(t, i[1]) ? i[0] : (e = e(), n.memoizedState = [
                    e,
                    t
                ], e);
            }
            function ju(e, t, n) {
                var i = Zr();
                Br(98 > i ? 98 : i, function() {
                    e(!0);
                }), Br(97 < i ? 97 : i, function() {
                    var i = UM.suspense;
                    UM.suspense = void 0 === t ? null : t;
                    try {
                        e(!1), n();
                    } finally{
                        UM.suspense = i;
                    }
                });
            }
            function gu(e, t, n) {
                var i = Vo(), r = NM.suspense;
                r = {
                    expirationTime: i = Jo(i, e, r),
                    suspenseConfig: r,
                    action: n,
                    eagerReducer: null,
                    eagerState: null,
                    next: null
                };
                var M = t.pending;
                if (null === M ? r.next = r : (r.next = M.next, M.next = r), t.pending = r, M = e.alternate, e === GM || null !== M && M === GM) WM = !0, r.expirationTime = ZM, GM.expirationTime = ZM;
                else {
                    if (0 === e.expirationTime && (null === M || 0 === M.expirationTime) && null !== (M = t.lastRenderedReducer)) try {
                        var u = t.lastRenderedState, o = M(u, n);
                        if (r.eagerReducer = M, r.eagerState = o, Yi(o, u)) return;
                    } catch (e) {}
                    Fo(e, i);
                }
            }
            var su = {
                readContext: iM,
                useCallback: HM,
                useContext: HM,
                useEffect: HM,
                useImperativeHandle: HM,
                useLayoutEffect: HM,
                useMemo: HM,
                useReducer: HM,
                useRef: HM,
                useState: HM,
                useDebugValue: HM,
                useResponder: HM,
                useDeferredValue: HM,
                useTransition: HM
            }, Au = {
                readContext: iM,
                useCallback: Iu,
                useContext: iM,
                useEffect: ru,
                useImperativeHandle: function(e, t, n) {
                    return n = null != n ? n.concat([
                        e
                    ]) : null, nu(4, 2, ou.bind(null, t, e), n);
                },
                useLayoutEffect: function(e, t) {
                    return nu(4, 2, e, t);
                },
                useMemo: function(e, t) {
                    var n = FM();
                    return t = void 0 === t ? null : t, e = e(), n.memoizedState = [
                        e,
                        t
                    ], e;
                },
                useReducer: function(e, t, n) {
                    var i = FM();
                    return t = void 0 !== n ? n(t) : t, i.memoizedState = i.baseState = t, e = (e = i.queue = {
                        pending: null,
                        dispatch: null,
                        lastRenderedReducer: e,
                        lastRenderedState: t
                    }).dispatch = gu.bind(null, GM, e), [
                        i.memoizedState,
                        e
                    ];
                },
                useRef: function(e) {
                    return e = {
                        current: e
                    }, FM().memoizedState = e;
                },
                useState: $M,
                useDebugValue: au,
                useResponder: YM,
                useDeferredValue: function(e, t) {
                    var n = $M(e), i = n[0], r = n[1];
                    return ru(function() {
                        var n = UM.suspense;
                        UM.suspense = void 0 === t ? null : t;
                        try {
                            r(e);
                        } finally{
                            UM.suspense = n;
                        }
                    }, [
                        e,
                        t
                    ]), i;
                },
                useTransition: function(e) {
                    var t = $M(!1), n = t[0];
                    return t = t[1], [
                        Iu(ju.bind(null, t, e), [
                            t,
                            e
                        ]),
                        n
                    ];
                }
            }, Du = {
                readContext: iM,
                useCallback: lu,
                useContext: iM,
                useEffect: Mu,
                useImperativeHandle: cu,
                useLayoutEffect: uu,
                useMemo: Nu,
                useReducer: qM,
                useRef: tu,
                useState: function() {
                    return qM(KM);
                },
                useDebugValue: au,
                useResponder: YM,
                useDeferredValue: function(e, t) {
                    var n = qM(KM), i = n[0], r = n[1];
                    return Mu(function() {
                        var n = UM.suspense;
                        UM.suspense = void 0 === t ? null : t;
                        try {
                            r(e);
                        } finally{
                            UM.suspense = n;
                        }
                    }, [
                        e,
                        t
                    ]), i;
                },
                useTransition: function(e) {
                    var t = qM(KM), n = t[0];
                    return t = t[1], [
                        lu(ju.bind(null, t, e), [
                            t,
                            e
                        ]),
                        n
                    ];
                }
            }, du = {
                readContext: iM,
                useCallback: lu,
                useContext: iM,
                useEffect: Mu,
                useImperativeHandle: cu,
                useLayoutEffect: uu,
                useMemo: Nu,
                useReducer: _M,
                useRef: tu,
                useState: function() {
                    return _M(KM);
                },
                useDebugValue: au,
                useResponder: YM,
                useDeferredValue: function(e, t) {
                    var n = _M(KM), i = n[0], r = n[1];
                    return Mu(function() {
                        var n = UM.suspense;
                        UM.suspense = void 0 === t ? null : t;
                        try {
                            r(e);
                        } finally{
                            UM.suspense = n;
                        }
                    }, [
                        e,
                        t
                    ]), i;
                },
                useTransition: function(e) {
                    var t = _M(KM), n = t[0];
                    return t = t[1], [
                        lu(ju.bind(null, t, e), [
                            t,
                            e
                        ]),
                        n
                    ];
                }
            }, Tu = null, yu = null, zu = !1;
            function wu(e, t) {
                var n = Lc(5, null, null, 0);
                n.elementType = "DELETED", n.type = "DELETED", n.stateNode = t, n.return = e, n.effectTag = 8, null !== e.lastEffect ? (e.lastEffect.nextEffect = n, e.lastEffect = n) : e.firstEffect = e.lastEffect = n;
            }
            function fu(e, t) {
                switch(e.tag){
                    case 5:
                        var n = e.type;
                        return null !== (t = 1 !== t.nodeType || n.toLowerCase() !== t.nodeName.toLowerCase() ? null : t) && (e.stateNode = t, !0);
                    case 6:
                        return null !== (t = "" === e.pendingProps || 3 !== t.nodeType ? null : t) && (e.stateNode = t, !0);
                    case 13:
                    default:
                        return !1;
                }
            }
            function Lu(e) {
                if (zu) {
                    var t = yu;
                    if (t) {
                        var n = t;
                        if (!fu(e, t)) {
                            if (!(t = zn(n.nextSibling)) || !fu(e, t)) return e.effectTag = -1025 & e.effectTag | 2, zu = !1, void (Tu = e);
                            wu(Tu, n);
                        }
                        Tu = e, yu = zn(t.firstChild);
                    } else e.effectTag = -1025 & e.effectTag | 2, zu = !1, Tu = e;
                }
            }
            function Eu(e) {
                for(e = e.return; null !== e && 5 !== e.tag && 3 !== e.tag && 13 !== e.tag;)e = e.return;
                Tu = e;
            }
            function Cu(e) {
                if (e !== Tu) return !1;
                if (!zu) return Eu(e), zu = !0, !1;
                var t = e.type;
                if (5 !== e.tag || "head" !== t && "body" !== t && !dn(t, e.memoizedProps)) for(t = yu; t;)wu(e, t), t = zn(t.nextSibling);
                if (Eu(e), 13 === e.tag) {
                    if (!(e = null !== (e = e.memoizedState) ? e.dehydrated : null)) throw Error(u(317));
                    e: {
                        for(e = e.nextSibling, t = 0; e;){
                            if (8 === e.nodeType) {
                                var n = e.data;
                                if ("/$" === n) {
                                    if (0 === t) {
                                        yu = zn(e.nextSibling);
                                        break e;
                                    }
                                    t--;
                                } else "$" !== n && "$!" !== n && "$?" !== n || t++;
                            }
                            e = e.nextSibling;
                        }
                        yu = null;
                    }
                } else yu = Tu ? zn(e.stateNode.nextSibling) : null;
                return !0;
            }
            function xu() {
                yu = Tu = null, zu = !1;
            }
            var pu = K.ReactCurrentOwner, Su = !1;
            function mu(e, t, n, i) {
                t.child = null === e ? EM(t, null, n, i) : LM(t, e.child, n, i);
            }
            function Ou(e, t, n, i, r) {
                n = n.render;
                var M = t.ref;
                return nM(t, r), i = JM(e, t, n, i, M, r), null === e || Su ? (t.effectTag |= 1, mu(e, t, i, r), t.child) : (t.updateQueue = e.updateQueue, t.effectTag &= -517, e.expirationTime <= r && (e.expirationTime = 0), Ju(e, t, r));
            }
            function vu(e, t, n, i, r, M) {
                if (null === e) {
                    var u = n.type;
                    return "function" != typeof u || Ec(u) || void 0 !== u.defaultProps || null !== n.compare || void 0 !== n.defaultProps ? ((e = xc(n.type, null, i, null, t.mode, M)).ref = t.ref, e.return = t, t.child = e) : (t.tag = 15, t.type = u, bu(e, t, u, i, r, M));
                }
                return u = e.child, r < M && (r = u.memoizedProps, (n = null !== (n = n.compare) ? n : Ui)(r, i) && e.ref === t.ref) ? Ju(e, t, M) : (t.effectTag |= 1, (e = Cc(u, i)).ref = t.ref, e.return = t, t.child = e);
            }
            function bu(e, t, n, i, r, M) {
                return null !== e && Ui(e.memoizedProps, i) && e.ref === t.ref && (Su = !1, r < M) ? (t.expirationTime = e.expirationTime, Ju(e, t, M)) : ku(e, t, n, i, M);
            }
            function hu(e, t) {
                var n = t.ref;
                (null === e && null !== n || null !== e && e.ref !== n) && (t.effectTag |= 128);
            }
            function ku(e, t, n, i, r) {
                var M = sr(n) ? jr : lr.current;
                return M = gr(t, M), nM(t, r), n = JM(e, t, n, i, M, r), null === e || Su ? (t.effectTag |= 1, mu(e, t, n, r), t.child) : (t.updateQueue = e.updateQueue, t.effectTag &= -517, e.expirationTime <= r && (e.expirationTime = 0), Ju(e, t, r));
            }
            function Qu(e, t, n, i, r) {
                if (sr(n)) {
                    var M = !0;
                    Tr(t);
                } else M = !1;
                if (nM(t, r), null === t.stateNode) null !== e && (e.alternate = null, t.alternate = null, t.effectTag |= 2), DM(t, n, i), TM(t, n, i, r), i = !0;
                else if (null === e) {
                    var u = t.stateNode, o = t.memoizedProps;
                    u.props = o;
                    var c = u.context, a = n.contextType;
                    "object" == typeof a && null !== a ? a = iM(a) : a = gr(t, a = sr(n) ? jr : lr.current);
                    var I = n.getDerivedStateFromProps, l = "function" == typeof I || "function" == typeof u.getSnapshotBeforeUpdate;
                    l || "function" != typeof u.UNSAFE_componentWillReceiveProps && "function" != typeof u.componentWillReceiveProps || (o !== i || c !== a) && dM(t, u, i, a), rM = !1;
                    var N = t.memoizedState;
                    u.state = N, IM(t, i, u, r), c = t.memoizedState, o !== i || N !== c || Nr.current || rM ? ("function" == typeof I && (gM(t, n, I, i), c = t.memoizedState), (o = rM || AM(t, n, o, i, N, c, a)) ? (l || "function" != typeof u.UNSAFE_componentWillMount && "function" != typeof u.componentWillMount || ("function" == typeof u.componentWillMount && u.componentWillMount(), "function" == typeof u.UNSAFE_componentWillMount && u.UNSAFE_componentWillMount()), "function" == typeof u.componentDidMount && (t.effectTag |= 4)) : ("function" == typeof u.componentDidMount && (t.effectTag |= 4), t.memoizedProps = i, t.memoizedState = c), u.props = i, u.state = c, u.context = a, i = o) : ("function" == typeof u.componentDidMount && (t.effectTag |= 4), i = !1);
                } else u = t.stateNode, uM(e, t), o = t.memoizedProps, u.props = t.type === t.elementType ? o : Fr(t.type, o), c = u.context, "object" == typeof (a = n.contextType) && null !== a ? a = iM(a) : a = gr(t, a = sr(n) ? jr : lr.current), (l = "function" == typeof (I = n.getDerivedStateFromProps) || "function" == typeof u.getSnapshotBeforeUpdate) || "function" != typeof u.UNSAFE_componentWillReceiveProps && "function" != typeof u.componentWillReceiveProps || (o !== i || c !== a) && dM(t, u, i, a), rM = !1, c = t.memoizedState, u.state = c, IM(t, i, u, r), N = t.memoizedState, o !== i || c !== N || Nr.current || rM ? ("function" == typeof I && (gM(t, n, I, i), N = t.memoizedState), (I = rM || AM(t, n, o, i, c, N, a)) ? (l || "function" != typeof u.UNSAFE_componentWillUpdate && "function" != typeof u.componentWillUpdate || ("function" == typeof u.componentWillUpdate && u.componentWillUpdate(i, N, a), "function" == typeof u.UNSAFE_componentWillUpdate && u.UNSAFE_componentWillUpdate(i, N, a)), "function" == typeof u.componentDidUpdate && (t.effectTag |= 4), "function" == typeof u.getSnapshotBeforeUpdate && (t.effectTag |= 256)) : ("function" != typeof u.componentDidUpdate || o === e.memoizedProps && c === e.memoizedState || (t.effectTag |= 4), "function" != typeof u.getSnapshotBeforeUpdate || o === e.memoizedProps && c === e.memoizedState || (t.effectTag |= 256), t.memoizedProps = i, t.memoizedState = N), u.props = i, u.state = N, u.context = a, i = I) : ("function" != typeof u.componentDidUpdate || o === e.memoizedProps && c === e.memoizedState || (t.effectTag |= 4), "function" != typeof u.getSnapshotBeforeUpdate || o === e.memoizedProps && c === e.memoizedState || (t.effectTag |= 256), i = !1);
                return Yu(e, t, n, i, M, r);
            }
            function Yu(e, t, n, i, r, M) {
                hu(e, t);
                var u = 0 != (64 & t.effectTag);
                if (!i && !u) return r && yr(t, n, !1), Ju(e, t, M);
                i = t.stateNode, pu.current = t;
                var o = u && "function" != typeof n.getDerivedStateFromError ? null : i.render();
                return t.effectTag |= 1, null !== e && u ? (t.child = LM(t, e.child, null, M), t.child = LM(t, null, o, M)) : mu(e, t, o, M), t.memoizedState = i.state, r && yr(t, n, !0), t.child;
            }
            function Pu(e) {
                var t = e.stateNode;
                t.pendingContext ? Dr(0, t.pendingContext, t.pendingContext !== t.context) : t.context && Dr(0, t.context, !1), OM(e, t.containerInfo);
            }
            var Uu, Zu, Gu, Bu = {
                dehydrated: null,
                retryTime: 0
            };
            function Ru(e, t, n) {
                var i, r = t.mode, M = t.pendingProps, u = kM.current, o = !1;
                if ((i = 0 != (64 & t.effectTag)) || (i = 0 != (2 & u) && (null === e || null !== e.memoizedState)), i ? (o = !0, t.effectTag &= -65) : null !== e && null === e.memoizedState || void 0 === M.fallback || !0 === M.unstable_avoidThisFallback || (u |= 1), ar(kM, 1 & u), null === e) {
                    if (void 0 !== M.fallback && Lu(t), o) {
                        if (o = M.fallback, (M = pc(null, r, 0, null)).return = t, 0 == (2 & t.mode)) for(e = null !== t.memoizedState ? t.child.child : t.child, M.child = e; null !== e;)e.return = M, e = e.sibling;
                        return (n = pc(o, r, n, null)).return = t, M.sibling = n, t.memoizedState = Bu, t.child = M, n;
                    }
                    return r = M.children, t.memoizedState = null, t.child = EM(t, null, r, n);
                }
                if (null !== e.memoizedState) {
                    if (r = (e = e.child).sibling, o) {
                        if (M = M.fallback, (n = Cc(e, e.pendingProps)).return = t, 0 == (2 & t.mode) && (o = null !== t.memoizedState ? t.child.child : t.child) !== e.child) for(n.child = o; null !== o;)o.return = n, o = o.sibling;
                        return (r = Cc(r, M)).return = t, n.sibling = r, n.childExpirationTime = 0, t.memoizedState = Bu, t.child = n, r;
                    }
                    return n = LM(t, e.child, M.children, n), t.memoizedState = null, t.child = n;
                }
                if (e = e.child, o) {
                    if (o = M.fallback, (M = pc(null, r, 0, null)).return = t, M.child = e, null !== e && (e.return = M), 0 == (2 & t.mode)) for(e = null !== t.memoizedState ? t.child.child : t.child, M.child = e; null !== e;)e.return = M, e = e.sibling;
                    return (n = pc(o, r, n, null)).return = t, M.sibling = n, n.effectTag |= 2, M.childExpirationTime = 0, t.memoizedState = Bu, t.child = M, n;
                }
                return t.memoizedState = null, t.child = LM(t, e, M.children, n);
            }
            function Wu(e, t) {
                e.expirationTime < t && (e.expirationTime = t);
                var n = e.alternate;
                null !== n && n.expirationTime < t && (n.expirationTime = t), tM(e.return, t);
            }
            function Hu(e, t, n, i, r, M) {
                var u = e.memoizedState;
                null === u ? e.memoizedState = {
                    isBackwards: t,
                    rendering: null,
                    renderingStartTime: 0,
                    last: i,
                    tail: n,
                    tailExpiration: 0,
                    tailMode: r,
                    lastEffect: M
                } : (u.isBackwards = t, u.rendering = null, u.renderingStartTime = 0, u.last = i, u.tail = n, u.tailExpiration = 0, u.tailMode = r, u.lastEffect = M);
            }
            function Vu(e, t, n) {
                var i = t.pendingProps, r = i.revealOrder, M = i.tail;
                if (mu(e, t, i.children, n), 0 != (2 & (i = kM.current))) i = 1 & i | 2, t.effectTag |= 64;
                else {
                    if (null !== e && 0 != (64 & e.effectTag)) e: for(e = t.child; null !== e;){
                        if (13 === e.tag) null !== e.memoizedState && Wu(e, n);
                        else if (19 === e.tag) Wu(e, n);
                        else if (null !== e.child) {
                            e.child.return = e, e = e.child;
                            continue;
                        }
                        if (e === t) break e;
                        for(; null === e.sibling;){
                            if (null === e.return || e.return === t) break e;
                            e = e.return;
                        }
                        e.sibling.return = e.return, e = e.sibling;
                    }
                    i &= 1;
                }
                if (ar(kM, i), 0 == (2 & t.mode)) t.memoizedState = null;
                else switch(r){
                    case "forwards":
                        for(n = t.child, r = null; null !== n;)null !== (e = n.alternate) && null === QM(e) && (r = n), n = n.sibling;
                        null === (n = r) ? (r = t.child, t.child = null) : (r = n.sibling, n.sibling = null), Hu(t, !1, r, n, M, t.lastEffect);
                        break;
                    case "backwards":
                        for(n = null, r = t.child, t.child = null; null !== r;){
                            if (null !== (e = r.alternate) && null === QM(e)) {
                                t.child = r;
                                break;
                            }
                            e = r.sibling, r.sibling = n, n = r, r = e;
                        }
                        Hu(t, !0, n, null, M, t.lastEffect);
                        break;
                    case "together":
                        Hu(t, !1, null, null, void 0, t.lastEffect);
                        break;
                    default:
                        t.memoizedState = null;
                }
                return t.child;
            }
            function Ju(e, t, n) {
                null !== e && (t.dependencies = e.dependencies);
                var i = t.expirationTime;
                if (0 !== i && uc(i), t.childExpirationTime < n) return null;
                if (null !== e && t.child !== e.child) throw Error(u(153));
                if (null !== t.child) {
                    for(n = Cc(e = t.child, e.pendingProps), t.child = n, n.return = t; null !== e.sibling;)e = e.sibling, (n = n.sibling = Cc(e, e.pendingProps)).return = t;
                    n.sibling = null;
                }
                return t.child;
            }
            function Fu(e, t) {
                switch(e.tailMode){
                    case "hidden":
                        t = e.tail;
                        for(var n = null; null !== t;)null !== t.alternate && (n = t), t = t.sibling;
                        null === n ? e.tail = null : n.sibling = null;
                        break;
                    case "collapsed":
                        n = e.tail;
                        for(var i = null; null !== n;)null !== n.alternate && (i = n), n = n.sibling;
                        null === i ? t || null === e.tail ? e.tail = null : e.tail.sibling = null : i.sibling = null;
                }
            }
            function Xu(e, t, n) {
                var i = t.pendingProps;
                switch(t.tag){
                    case 2:
                    case 16:
                    case 15:
                    case 0:
                    case 11:
                    case 7:
                    case 8:
                    case 12:
                    case 9:
                    case 14:
                        return null;
                    case 1:
                        return sr(t.type) && Ar(), null;
                    case 3:
                        return vM(), cr(Nr), cr(lr), (n = t.stateNode).pendingContext && (n.context = n.pendingContext, n.pendingContext = null), null !== e && null !== e.child || !Cu(t) || (t.effectTag |= 4), null;
                    case 5:
                        hM(t), n = mM(SM.current);
                        var M = t.type;
                        if (null !== e && null != t.stateNode) Zu(e, t, M, i, n), e.ref !== t.ref && (t.effectTag |= 128);
                        else {
                            if (!i) {
                                if (null === t.stateNode) throw Error(u(166));
                                return null;
                            }
                            if (e = mM(xM.current), Cu(t)) {
                                i = t.stateNode, M = t.type;
                                var o = t.memoizedProps;
                                switch(i[Ln] = t, i[En] = o, M){
                                    case "iframe":
                                    case "object":
                                    case "embed":
                                        Jt("load", i);
                                        break;
                                    case "video":
                                    case "audio":
                                        for(e = 0; e < Ke.length; e++)Jt(Ke[e], i);
                                        break;
                                    case "source":
                                        Jt("error", i);
                                        break;
                                    case "img":
                                    case "image":
                                    case "link":
                                        Jt("error", i), Jt("load", i);
                                        break;
                                    case "form":
                                        Jt("reset", i), Jt("submit", i);
                                        break;
                                    case "details":
                                        Jt("toggle", i);
                                        break;
                                    case "input":
                                        fe(i, o), Jt("invalid", i), cn(n, "onChange");
                                        break;
                                    case "select":
                                        i._wrapperState = {
                                            wasMultiple: !!o.multiple
                                        }, Jt("invalid", i), cn(n, "onChange");
                                        break;
                                    case "textarea":
                                        Oe(i, o), Jt("invalid", i), cn(n, "onChange");
                                }
                                for(var c in Mn(M, o), e = null, o)if (o.hasOwnProperty(c)) {
                                    var a = o[c];
                                    "children" === c ? "string" == typeof a ? i.textContent !== a && (e = [
                                        "children",
                                        a
                                    ]) : "number" == typeof a && i.textContent !== "" + a && (e = [
                                        "children",
                                        "" + a
                                    ]) : L.hasOwnProperty(c) && null != a && cn(n, c);
                                }
                                switch(M){
                                    case "input":
                                        ye(i), Ce(i, o, !0);
                                        break;
                                    case "textarea":
                                        ye(i), be(i);
                                        break;
                                    case "select":
                                    case "option":
                                        break;
                                    default:
                                        "function" == typeof o.onClick && (i.onclick = an);
                                }
                                n = e, t.updateQueue = n, null !== n && (t.effectTag |= 4);
                            } else {
                                switch(c = 9 === n.nodeType ? n : n.ownerDocument, e === on && (e = Qe(M)), e === on ? "script" === M ? ((e = c.createElement("div")).innerHTML = "<script></script>", e = e.removeChild(e.firstChild)) : "string" == typeof i.is ? e = c.createElement(M, {
                                    is: i.is
                                }) : (e = c.createElement(M), "select" === M && (c = e, i.multiple ? c.multiple = !0 : i.size && (c.size = i.size))) : e = c.createElementNS(e, M), e[Ln] = t, e[En] = i, Uu(e, t), t.stateNode = e, c = un(M, i), M){
                                    case "iframe":
                                    case "object":
                                    case "embed":
                                        Jt("load", e), a = i;
                                        break;
                                    case "video":
                                    case "audio":
                                        for(a = 0; a < Ke.length; a++)Jt(Ke[a], e);
                                        a = i;
                                        break;
                                    case "source":
                                        Jt("error", e), a = i;
                                        break;
                                    case "img":
                                    case "image":
                                    case "link":
                                        Jt("error", e), Jt("load", e), a = i;
                                        break;
                                    case "form":
                                        Jt("reset", e), Jt("submit", e), a = i;
                                        break;
                                    case "details":
                                        Jt("toggle", e), a = i;
                                        break;
                                    case "input":
                                        fe(e, i), a = we(e, i), Jt("invalid", e), cn(n, "onChange");
                                        break;
                                    case "option":
                                        a = pe(e, i);
                                        break;
                                    case "select":
                                        e._wrapperState = {
                                            wasMultiple: !!i.multiple
                                        }, a = r({}, i, {
                                            value: void 0
                                        }), Jt("invalid", e), cn(n, "onChange");
                                        break;
                                    case "textarea":
                                        Oe(e, i), a = me(e, i), Jt("invalid", e), cn(n, "onChange");
                                        break;
                                    default:
                                        a = i;
                                }
                                Mn(M, a);
                                var I = a;
                                for(o in I)if (I.hasOwnProperty(o)) {
                                    var l = I[o];
                                    "style" === o ? nn(e, l) : "dangerouslySetInnerHTML" === o ? null != (l = l ? l.__html : void 0) && Ue(e, l) : "children" === o ? "string" == typeof l ? ("textarea" !== M || "" !== l) && Ze(e, l) : "number" == typeof l && Ze(e, "" + l) : "suppressContentEditableWarning" !== o && "suppressHydrationWarning" !== o && "autoFocus" !== o && (L.hasOwnProperty(o) ? null != l && cn(n, o) : null != l && q(e, o, l, c));
                                }
                                switch(M){
                                    case "input":
                                        ye(e), Ce(e, i, !1);
                                        break;
                                    case "textarea":
                                        ye(e), be(e);
                                        break;
                                    case "option":
                                        null != i.value && e.setAttribute("value", "" + de(i.value));
                                        break;
                                    case "select":
                                        e.multiple = !!i.multiple, null != (n = i.value) ? Se(e, !!i.multiple, n, !1) : null != i.defaultValue && Se(e, !!i.multiple, i.defaultValue, !0);
                                        break;
                                    default:
                                        "function" == typeof a.onClick && (e.onclick = an);
                                }
                                Dn(M, i) && (t.effectTag |= 4);
                            }
                            null !== t.ref && (t.effectTag |= 128);
                        }
                        return null;
                    case 6:
                        if (e && null != t.stateNode) Gu(0, t, e.memoizedProps, i);
                        else {
                            if ("string" != typeof i && null === t.stateNode) throw Error(u(166));
                            n = mM(SM.current), mM(xM.current), Cu(t) ? (n = t.stateNode, i = t.memoizedProps, n[Ln] = t, n.nodeValue !== i && (t.effectTag |= 4)) : ((n = (9 === n.nodeType ? n : n.ownerDocument).createTextNode(i))[Ln] = t, t.stateNode = n);
                        }
                        return null;
                    case 13:
                        return cr(kM), i = t.memoizedState, 0 != (64 & t.effectTag) ? (t.expirationTime = n, t) : (n = null !== i, i = !1, null === e ? void 0 !== t.memoizedProps.fallback && Cu(t) : (i = null !== (M = e.memoizedState), n || null === M || null !== (M = e.child.sibling) && (null !== (o = t.firstEffect) ? (t.firstEffect = M, M.nextEffect = o) : (t.firstEffect = t.lastEffect = M, M.nextEffect = null), M.effectTag = 8)), n && !i && 0 != (2 & t.mode) && (null === e && !0 !== t.memoizedProps.unstable_avoidThisFallback || 0 != (1 & kM.current) ? xo === yo && (xo = zo) : (xo !== yo && xo !== zo || (xo = wo), 0 !== vo && null !== Lo && (bc(Lo, Co), hc(Lo, vo)))), (n || i) && (t.effectTag |= 4), null);
                    case 4:
                        return vM(), null;
                    case 10:
                        return eM(t), null;
                    case 17:
                        return sr(t.type) && Ar(), null;
                    case 19:
                        if (cr(kM), null === (i = t.memoizedState)) return null;
                        if (M = 0 != (64 & t.effectTag), null === (o = i.rendering)) {
                            if (M) Fu(i, !1);
                            else if (xo !== yo || null !== e && 0 != (64 & e.effectTag)) for(o = t.child; null !== o;){
                                if (null !== (e = QM(o))) {
                                    for(t.effectTag |= 64, Fu(i, !1), null !== (M = e.updateQueue) && (t.updateQueue = M, t.effectTag |= 4), null === i.lastEffect && (t.firstEffect = null), t.lastEffect = i.lastEffect, i = t.child; null !== i;)o = n, (M = i).effectTag &= 2, M.nextEffect = null, M.firstEffect = null, M.lastEffect = null, null === (e = M.alternate) ? (M.childExpirationTime = 0, M.expirationTime = o, M.child = null, M.memoizedProps = null, M.memoizedState = null, M.updateQueue = null, M.dependencies = null) : (M.childExpirationTime = e.childExpirationTime, M.expirationTime = e.expirationTime, M.child = e.child, M.memoizedProps = e.memoizedProps, M.memoizedState = e.memoizedState, M.updateQueue = e.updateQueue, o = e.dependencies, M.dependencies = null === o ? null : {
                                        expirationTime: o.expirationTime,
                                        firstContext: o.firstContext,
                                        responders: o.responders
                                    }), i = i.sibling;
                                    return ar(kM, 1 & kM.current | 2), t.child;
                                }
                                o = o.sibling;
                            }
                        } else {
                            if (!M) {
                                if (null !== (e = QM(o))) {
                                    if (t.effectTag |= 64, M = !0, null !== (n = e.updateQueue) && (t.updateQueue = n, t.effectTag |= 4), Fu(i, !0), null === i.tail && "hidden" === i.tailMode && !o.alternate) return null !== (t = t.lastEffect = i.lastEffect) && (t.nextEffect = null), null;
                                } else 2 * Ur() - i.renderingStartTime > i.tailExpiration && 1 < n && (t.effectTag |= 64, M = !0, Fu(i, !1), t.expirationTime = t.childExpirationTime = n - 1);
                            }
                            i.isBackwards ? (o.sibling = t.child, t.child = o) : (null !== (n = i.last) ? n.sibling = o : t.child = o, i.last = o);
                        }
                        return null !== i.tail ? (0 === i.tailExpiration && (i.tailExpiration = Ur() + 500), n = i.tail, i.rendering = n, i.tail = n.sibling, i.lastEffect = t.lastEffect, i.renderingStartTime = Ur(), n.sibling = null, t = kM.current, ar(kM, M ? 1 & t | 2 : 1 & t), n) : null;
                }
                throw Error(u(156, t.tag));
            }
            function Ku(e) {
                switch(e.tag){
                    case 1:
                        sr(e.type) && Ar();
                        var t = e.effectTag;
                        return 4096 & t ? (e.effectTag = -4097 & t | 64, e) : null;
                    case 3:
                        if (vM(), cr(Nr), cr(lr), 0 != (64 & (t = e.effectTag))) throw Error(u(285));
                        return e.effectTag = -4097 & t | 64, e;
                    case 5:
                        return hM(e), null;
                    case 13:
                        return cr(kM), 4096 & (t = e.effectTag) ? (e.effectTag = -4097 & t | 64, e) : null;
                    case 19:
                        return cr(kM), null;
                    case 4:
                        return vM(), null;
                    case 10:
                        return eM(e), null;
                    default:
                        return null;
                }
            }
            function qu(e, t) {
                return {
                    value: e,
                    source: t,
                    stack: De(t)
                };
            }
            Uu = function(e, t) {
                for(var n = t.child; null !== n;){
                    if (5 === n.tag || 6 === n.tag) e.appendChild(n.stateNode);
                    else if (4 !== n.tag && null !== n.child) {
                        n.child.return = n, n = n.child;
                        continue;
                    }
                    if (n === t) break;
                    for(; null === n.sibling;){
                        if (null === n.return || n.return === t) return;
                        n = n.return;
                    }
                    n.sibling.return = n.return, n = n.sibling;
                }
            }, Zu = function(e, t, n, i, M) {
                var u = e.memoizedProps;
                if (u !== i) {
                    var o, c, a = t.stateNode;
                    switch(mM(xM.current), e = null, n){
                        case "input":
                            u = we(a, u), i = we(a, i), e = [];
                            break;
                        case "option":
                            u = pe(a, u), i = pe(a, i), e = [];
                            break;
                        case "select":
                            u = r({}, u, {
                                value: void 0
                            }), i = r({}, i, {
                                value: void 0
                            }), e = [];
                            break;
                        case "textarea":
                            u = me(a, u), i = me(a, i), e = [];
                            break;
                        default:
                            "function" != typeof u.onClick && "function" == typeof i.onClick && (a.onclick = an);
                    }
                    for(o in Mn(n, i), n = null, u)if (!i.hasOwnProperty(o) && u.hasOwnProperty(o) && null != u[o]) {
                        if ("style" === o) for(c in a = u[o])a.hasOwnProperty(c) && (n || (n = {}), n[c] = "");
                        else "dangerouslySetInnerHTML" !== o && "children" !== o && "suppressContentEditableWarning" !== o && "suppressHydrationWarning" !== o && "autoFocus" !== o && (L.hasOwnProperty(o) ? e || (e = []) : (e = e || []).push(o, null));
                    }
                    for(o in i){
                        var I = i[o];
                        if (a = null != u ? u[o] : void 0, i.hasOwnProperty(o) && I !== a && (null != I || null != a)) {
                            if ("style" === o) {
                                if (a) {
                                    for(c in a)!a.hasOwnProperty(c) || I && I.hasOwnProperty(c) || (n || (n = {}), n[c] = "");
                                    for(c in I)I.hasOwnProperty(c) && a[c] !== I[c] && (n || (n = {}), n[c] = I[c]);
                                } else n || (e || (e = []), e.push(o, n)), n = I;
                            } else "dangerouslySetInnerHTML" === o ? (I = I ? I.__html : void 0, a = a ? a.__html : void 0, null != I && a !== I && (e = e || []).push(o, I)) : "children" === o ? a === I || "string" != typeof I && "number" != typeof I || (e = e || []).push(o, "" + I) : "suppressContentEditableWarning" !== o && "suppressHydrationWarning" !== o && (L.hasOwnProperty(o) ? (null != I && cn(M, o), e || a === I || (e = [])) : (e = e || []).push(o, I));
                        }
                    }
                    n && (e = e || []).push("style", n), M = e, (t.updateQueue = M) && (t.effectTag |= 4);
                }
            }, Gu = function(e, t, n, i) {
                n !== i && (t.effectTag |= 4);
            };
            var _u = "function" == typeof WeakSet ? WeakSet : Set;
            function $u(e, t) {
                var n = t.source, i = t.stack;
                null === i && null !== n && (i = De(n)), null !== n && Ae(n.type), t = t.value, null !== e && 1 === e.tag && Ae(e.type);
                try {
                    console.error(t);
                } catch (e) {
                    setTimeout(function() {
                        throw e;
                    });
                }
            }
            function eo(e) {
                var t = e.ref;
                if (null !== t) {
                    if ("function" == typeof t) try {
                        t(null);
                    } catch (t) {
                        dc(e, t);
                    }
                    else t.current = null;
                }
            }
            function to(e, t) {
                switch(t.tag){
                    case 0:
                    case 11:
                    case 15:
                    case 22:
                        return;
                    case 1:
                        if (256 & t.effectTag && null !== e) {
                            var n = e.memoizedProps, i = e.memoizedState;
                            t = (e = t.stateNode).getSnapshotBeforeUpdate(t.elementType === t.type ? n : Fr(t.type, n), i), e.__reactInternalSnapshotBeforeUpdate = t;
                        }
                        return;
                    case 3:
                    case 5:
                    case 6:
                    case 4:
                    case 17:
                        return;
                }
                throw Error(u(163));
            }
            function no(e, t) {
                if (null !== (t = null !== (t = t.updateQueue) ? t.lastEffect : null)) {
                    var n = t = t.next;
                    do {
                        if ((n.tag & e) === e) {
                            var i = n.destroy;
                            n.destroy = void 0, void 0 !== i && i();
                        }
                        n = n.next;
                    }while (n !== t);
                }
            }
            function io(e, t) {
                if (null !== (t = null !== (t = t.updateQueue) ? t.lastEffect : null)) {
                    var n = t = t.next;
                    do {
                        if ((n.tag & e) === e) {
                            var i = n.create;
                            n.destroy = i();
                        }
                        n = n.next;
                    }while (n !== t);
                }
            }
            function ro(e, t, n) {
                switch(n.tag){
                    case 0:
                    case 11:
                    case 15:
                    case 22:
                        return void io(3, n);
                    case 1:
                        if (e = n.stateNode, 4 & n.effectTag) {
                            if (null === t) e.componentDidMount();
                            else {
                                var i = n.elementType === n.type ? t.memoizedProps : Fr(n.type, t.memoizedProps);
                                e.componentDidUpdate(i, t.memoizedState, e.__reactInternalSnapshotBeforeUpdate);
                            }
                        }
                        return void (null !== (t = n.updateQueue) && lM(n, t, e));
                    case 3:
                        if (null !== (t = n.updateQueue)) {
                            if (e = null, null !== n.child) switch(n.child.tag){
                                case 5:
                                    e = n.child.stateNode;
                                    break;
                                case 1:
                                    e = n.child.stateNode;
                            }
                            lM(n, t, e);
                        }
                        return;
                    case 5:
                        return e = n.stateNode, void (null === t && 4 & n.effectTag && Dn(n.type, n.memoizedProps) && e.focus());
                    case 6:
                    case 4:
                    case 12:
                        return;
                    case 13:
                        return void (null === n.memoizedState && (n = n.alternate, null !== n && (n = n.memoizedState, null !== n && (n = n.dehydrated, null !== n && Qt(n)))));
                    case 19:
                    case 17:
                    case 20:
                    case 21:
                        return;
                }
                throw Error(u(163));
            }
            function Mo(e, t, n) {
                switch("function" == typeof wc && wc(t), t.tag){
                    case 0:
                    case 11:
                    case 14:
                    case 15:
                    case 22:
                        if (null !== (e = t.updateQueue) && null !== (e = e.lastEffect)) {
                            var i = e.next;
                            Br(97 < n ? 97 : n, function() {
                                var e = i;
                                do {
                                    var n = e.destroy;
                                    if (void 0 !== n) {
                                        var r = t;
                                        try {
                                            n();
                                        } catch (e) {
                                            dc(r, e);
                                        }
                                    }
                                    e = e.next;
                                }while (e !== i);
                            });
                        }
                        break;
                    case 1:
                        eo(t), "function" == typeof (n = t.stateNode).componentWillUnmount && function(e, t) {
                            try {
                                t.props = e.memoizedProps, t.state = e.memoizedState, t.componentWillUnmount();
                            } catch (t) {
                                dc(e, t);
                            }
                        }(t, n);
                        break;
                    case 5:
                        eo(t);
                        break;
                    case 4:
                        ao(e, t, n);
                }
            }
            function uo(e) {
                var t = e.alternate;
                e.return = null, e.child = null, e.memoizedState = null, e.updateQueue = null, e.dependencies = null, e.alternate = null, e.firstEffect = null, e.lastEffect = null, e.pendingProps = null, e.memoizedProps = null, e.stateNode = null, null !== t && uo(t);
            }
            function oo(e) {
                return 5 === e.tag || 3 === e.tag || 4 === e.tag;
            }
            function co(e) {
                e: {
                    for(var t = e.return; null !== t;){
                        if (oo(t)) {
                            var n = t;
                            break e;
                        }
                        t = t.return;
                    }
                    throw Error(u(160));
                }
                switch(t = n.stateNode, n.tag){
                    case 5:
                        var i = !1;
                        break;
                    case 3:
                    case 4:
                        t = t.containerInfo, i = !0;
                        break;
                    default:
                        throw Error(u(161));
                }
                16 & n.effectTag && (Ze(t, ""), n.effectTag &= -17);
                e: t: for(n = e;;){
                    for(; null === n.sibling;){
                        if (null === n.return || oo(n.return)) {
                            n = null;
                            break e;
                        }
                        n = n.return;
                    }
                    for(n.sibling.return = n.return, n = n.sibling; 5 !== n.tag && 6 !== n.tag && 18 !== n.tag;){
                        if (2 & n.effectTag) continue t;
                        if (null === n.child || 4 === n.tag) continue t;
                        n.child.return = n, n = n.child;
                    }
                    if (!(2 & n.effectTag)) {
                        n = n.stateNode;
                        break e;
                    }
                }
                i ? function e(t, n, i) {
                    var r = t.tag, M = 5 === r || 6 === r;
                    if (M) t = M ? t.stateNode : t.stateNode.instance, n ? 8 === i.nodeType ? i.parentNode.insertBefore(t, n) : i.insertBefore(t, n) : (8 === i.nodeType ? (n = i.parentNode).insertBefore(t, i) : (n = i).appendChild(t), null !== (i = i._reactRootContainer) && void 0 !== i || null !== n.onclick || (n.onclick = an));
                    else if (4 !== r && null !== (t = t.child)) for(e(t, n, i), t = t.sibling; null !== t;)e(t, n, i), t = t.sibling;
                }(e, n, t) : function e(t, n, i) {
                    var r = t.tag, M = 5 === r || 6 === r;
                    if (M) t = M ? t.stateNode : t.stateNode.instance, n ? i.insertBefore(t, n) : i.appendChild(t);
                    else if (4 !== r && null !== (t = t.child)) for(e(t, n, i), t = t.sibling; null !== t;)e(t, n, i), t = t.sibling;
                }(e, n, t);
            }
            function ao(e, t, n) {
                for(var i, r, M = t, o = !1;;){
                    if (!o) {
                        o = M.return;
                        e: for(;;){
                            if (null === o) throw Error(u(160));
                            switch(i = o.stateNode, o.tag){
                                case 5:
                                    r = !1;
                                    break e;
                                case 3:
                                case 4:
                                    i = i.containerInfo, r = !0;
                                    break e;
                            }
                            o = o.return;
                        }
                        o = !0;
                    }
                    if (5 === M.tag || 6 === M.tag) {
                        e: for(var c = e, a = M, I = n, l = a;;)if (Mo(c, l, I), null !== l.child && 4 !== l.tag) l.child.return = l, l = l.child;
                        else {
                            if (l === a) break e;
                            for(; null === l.sibling;){
                                if (null === l.return || l.return === a) break e;
                                l = l.return;
                            }
                            l.sibling.return = l.return, l = l.sibling;
                        }
                        r ? (c = i, a = M.stateNode, 8 === c.nodeType ? c.parentNode.removeChild(a) : c.removeChild(a)) : i.removeChild(M.stateNode);
                    } else if (4 === M.tag) {
                        if (null !== M.child) {
                            i = M.stateNode.containerInfo, r = !0, M.child.return = M, M = M.child;
                            continue;
                        }
                    } else if (Mo(e, M, n), null !== M.child) {
                        M.child.return = M, M = M.child;
                        continue;
                    }
                    if (M === t) break;
                    for(; null === M.sibling;){
                        if (null === M.return || M.return === t) return;
                        4 === (M = M.return).tag && (o = !1);
                    }
                    M.sibling.return = M.return, M = M.sibling;
                }
            }
            function Io(e, t) {
                switch(t.tag){
                    case 0:
                    case 11:
                    case 14:
                    case 15:
                    case 22:
                        return void no(3, t);
                    case 1:
                        return;
                    case 5:
                        var n = t.stateNode;
                        if (null != n) {
                            var i = t.memoizedProps, r = null !== e ? e.memoizedProps : i;
                            e = t.type;
                            var M = t.updateQueue;
                            if (t.updateQueue = null, null !== M) {
                                for(n[En] = i, "input" === e && "radio" === i.type && null != i.name && Le(n, i), un(e, r), t = un(e, i), r = 0; r < M.length; r += 2){
                                    var o = M[r], c = M[r + 1];
                                    "style" === o ? nn(n, c) : "dangerouslySetInnerHTML" === o ? Ue(n, c) : "children" === o ? Ze(n, c) : q(n, o, c, t);
                                }
                                switch(e){
                                    case "input":
                                        Ee(n, i);
                                        break;
                                    case "textarea":
                                        ve(n, i);
                                        break;
                                    case "select":
                                        t = n._wrapperState.wasMultiple, n._wrapperState.wasMultiple = !!i.multiple, null != (e = i.value) ? Se(n, !!i.multiple, e, !1) : t !== !!i.multiple && (null != i.defaultValue ? Se(n, !!i.multiple, i.defaultValue, !0) : Se(n, !!i.multiple, i.multiple ? [] : "", !1));
                                }
                            }
                        }
                        return;
                    case 6:
                        if (null === t.stateNode) throw Error(u(162));
                        return void (t.stateNode.nodeValue = t.memoizedProps);
                    case 3:
                        return void ((t = t.stateNode).hydrate && (t.hydrate = !1, Qt(t.containerInfo)));
                    case 12:
                        return;
                    case 13:
                        if (n = t, null === t.memoizedState ? i = !1 : (i = !0, n = t.child, ho = Ur()), null !== n) e: for(e = n;;){
                            if (5 === e.tag) M = e.stateNode, i ? "function" == typeof (M = M.style).setProperty ? M.setProperty("display", "none", "important") : M.display = "none" : (M = e.stateNode, r = null != (r = e.memoizedProps.style) && r.hasOwnProperty("display") ? r.display : null, M.style.display = tn("display", r));
                            else if (6 === e.tag) e.stateNode.nodeValue = i ? "" : e.memoizedProps;
                            else {
                                if (13 === e.tag && null !== e.memoizedState && null === e.memoizedState.dehydrated) {
                                    (M = e.child.sibling).return = e, e = M;
                                    continue;
                                }
                                if (null !== e.child) {
                                    e.child.return = e, e = e.child;
                                    continue;
                                }
                            }
                            if (e === n) break;
                            for(; null === e.sibling;){
                                if (null === e.return || e.return === n) break e;
                                e = e.return;
                            }
                            e.sibling.return = e.return, e = e.sibling;
                        }
                        return void lo(t);
                    case 19:
                        return void lo(t);
                    case 17:
                        return;
                }
                throw Error(u(163));
            }
            function lo(e) {
                var t = e.updateQueue;
                if (null !== t) {
                    e.updateQueue = null;
                    var n = e.stateNode;
                    null === n && (n = e.stateNode = new _u), t.forEach(function(t) {
                        var i = yc.bind(null, e, t);
                        n.has(t) || (n.add(t), t.then(i, i));
                    });
                }
            }
            var No = "function" == typeof WeakMap ? WeakMap : Map;
            function jo(e, t, n) {
                (n = oM(n, null)).tag = 3, n.payload = {
                    element: null
                };
                var i = t.value;
                return n.callback = function() {
                    Qo || (Qo = !0, Yo = i), $u(e, t);
                }, n;
            }
            function go(e, t, n) {
                (n = oM(n, null)).tag = 3;
                var i = e.type.getDerivedStateFromError;
                if ("function" == typeof i) {
                    var r = t.value;
                    n.payload = function() {
                        return $u(e, t), i(r);
                    };
                }
                var M = e.stateNode;
                return null !== M && "function" == typeof M.componentDidCatch && (n.callback = function() {
                    "function" != typeof i && (null === Po ? Po = new Set([
                        this
                    ]) : Po.add(this), $u(e, t));
                    var n = t.stack;
                    this.componentDidCatch(t.value, {
                        componentStack: null !== n ? n : ""
                    });
                }), n;
            }
            var so, Ao = Math.ceil, Do = K.ReactCurrentDispatcher, To = K.ReactCurrentOwner, yo = 0, zo = 3, wo = 4, fo = 0, Lo = null, Eo = null, Co = 0, xo = yo, po = null, So = 1073741823, mo = 1073741823, Oo = null, vo = 0, bo = !1, ho = 0, ko = null, Qo = !1, Yo = null, Po = null, Uo = !1, Zo = null, Go = 90, Bo = null, Ro = 0, Wo = null, Ho = 0;
            function Vo() {
                return 0 != (48 & fo) ? 1073741821 - (Ur() / 10 | 0) : 0 !== Ho ? Ho : Ho = 1073741821 - (Ur() / 10 | 0);
            }
            function Jo(e, t, n) {
                if (0 == (2 & (t = t.mode))) return 1073741823;
                var i = Zr();
                if (0 == (4 & t)) return 99 === i ? 1073741823 : 1073741822;
                if (0 != (16 & fo)) return Co;
                if (null !== n) e = Jr(e, 0 | n.timeoutMs || 5e3, 250);
                else switch(i){
                    case 99:
                        e = 1073741823;
                        break;
                    case 98:
                        e = Jr(e, 150, 100);
                        break;
                    case 97:
                    case 96:
                        e = Jr(e, 5e3, 250);
                        break;
                    case 95:
                        e = 2;
                        break;
                    default:
                        throw Error(u(326));
                }
                return null !== Lo && e === Co && --e, e;
            }
            function Fo(e, t) {
                if (50 < Ro) throw Ro = 0, Wo = null, Error(u(185));
                if (null !== (e = Xo(e, t))) {
                    var n = Zr();
                    1073741823 === t ? 0 != (8 & fo) && 0 == (48 & fo) ? $o(e) : (qo(e), 0 === fo && Hr()) : qo(e), 0 == (4 & fo) || 98 !== n && 99 !== n || (null === Bo ? Bo = new Map([
                        [
                            e,
                            t
                        ]
                    ]) : (void 0 === (n = Bo.get(e)) || n > t) && Bo.set(e, t));
                }
            }
            function Xo(e, t) {
                e.expirationTime < t && (e.expirationTime = t);
                var n = e.alternate;
                null !== n && n.expirationTime < t && (n.expirationTime = t);
                var i = e.return, r = null;
                if (null === i && 3 === e.tag) r = e.stateNode;
                else for(; null !== i;){
                    if (n = i.alternate, i.childExpirationTime < t && (i.childExpirationTime = t), null !== n && n.childExpirationTime < t && (n.childExpirationTime = t), null === i.return && 3 === i.tag) {
                        r = i.stateNode;
                        break;
                    }
                    i = i.return;
                }
                return null !== r && (Lo === r && (uc(t), xo === wo && bc(r, Co)), hc(r, t)), r;
            }
            function Ko(e) {
                var t = e.lastExpiredTime;
                if (0 !== t) return t;
                if (!vc(e, t = e.firstPendingTime)) return t;
                var n = e.lastPingedTime;
                return 2 >= (e = n > (e = e.nextKnownPendingLevel) ? n : e) && t !== e ? 0 : e;
            }
            function qo(e) {
                if (0 !== e.lastExpiredTime) e.callbackExpirationTime = 1073741823, e.callbackPriority = 99, e.callbackNode = Wr($o.bind(null, e));
                else {
                    var t = Ko(e), n = e.callbackNode;
                    if (0 === t) null !== n && (e.callbackNode = null, e.callbackExpirationTime = 0, e.callbackPriority = 90);
                    else {
                        var i = Vo();
                        if (1073741823 === t ? i = 99 : 1 === t || 2 === t ? i = 95 : i = 0 >= (i = 10 * (1073741821 - t) - 10 * (1073741821 - i)) ? 99 : 250 >= i ? 98 : 5250 >= i ? 97 : 95, null !== n) {
                            var r = e.callbackPriority;
                            if (e.callbackExpirationTime === t && r >= i) return;
                            n !== vr && fr(n);
                        }
                        e.callbackExpirationTime = t, e.callbackPriority = i, t = 1073741823 === t ? Wr($o.bind(null, e)) : Rr(i, _o.bind(null, e), {
                            timeout: 10 * (1073741821 - t) - Ur()
                        }), e.callbackNode = t;
                    }
                }
            }
            function _o(e, t) {
                if (Ho = 0, t) return kc(e, t = Vo()), qo(e), null;
                var n = Ko(e);
                if (0 !== n) {
                    if (t = e.callbackNode, 0 != (48 & fo)) throw Error(u(327));
                    if (sc(), e === Lo && n === Co || nc(e, n), null !== Eo) {
                        var i = fo;
                        fo |= 16;
                        for(var r = rc();;)try {
                            cc();
                            break;
                        } catch (t) {
                            ic(e, t);
                        }
                        if ($r(), fo = i, Do.current = r, 1 === xo) throw t = po, nc(e, n), bc(e, n), qo(e), t;
                        if (null === Eo) switch(r = e.finishedWork = e.current.alternate, e.finishedExpirationTime = n, i = xo, Lo = null, i){
                            case yo:
                            case 1:
                                throw Error(u(345));
                            case 2:
                                kc(e, 2 < n ? 2 : n);
                                break;
                            case zo:
                                if (bc(e, n), n === (i = e.lastSuspendedTime) && (e.nextKnownPendingLevel = lc(r)), 1073741823 === So && 10 < (r = ho + 500 - Ur())) {
                                    if (bo) {
                                        var M = e.lastPingedTime;
                                        if (0 === M || M >= n) {
                                            e.lastPingedTime = n, nc(e, n);
                                            break;
                                        }
                                    }
                                    if (0 !== (M = Ko(e)) && M !== n) break;
                                    if (0 !== i && i !== n) {
                                        e.lastPingedTime = i;
                                        break;
                                    }
                                    e.timeoutHandle = Tn(Nc.bind(null, e), r);
                                    break;
                                }
                                Nc(e);
                                break;
                            case wo:
                                if (bc(e, n), n === (i = e.lastSuspendedTime) && (e.nextKnownPendingLevel = lc(r)), bo && (0 === (r = e.lastPingedTime) || r >= n)) {
                                    e.lastPingedTime = n, nc(e, n);
                                    break;
                                }
                                if (0 !== (r = Ko(e)) && r !== n) break;
                                if (0 !== i && i !== n) {
                                    e.lastPingedTime = i;
                                    break;
                                }
                                if (1073741823 !== mo ? i = 10 * (1073741821 - mo) - Ur() : 1073741823 === So ? i = 0 : (i = 10 * (1073741821 - So) - 5e3, 0 > (i = (r = Ur()) - i) && (i = 0), (n = 10 * (1073741821 - n) - r) < (i = (120 > i ? 120 : 480 > i ? 480 : 1080 > i ? 1080 : 1920 > i ? 1920 : 3e3 > i ? 3e3 : 4320 > i ? 4320 : 1960 * Ao(i / 1960)) - i) && (i = n)), 10 < i) {
                                    e.timeoutHandle = Tn(Nc.bind(null, e), i);
                                    break;
                                }
                                Nc(e);
                                break;
                            case 5:
                                if (1073741823 !== So && null !== Oo) {
                                    M = So;
                                    var o = Oo;
                                    if (0 >= (i = 0 | o.busyMinDurationMs) ? i = 0 : (r = 0 | o.busyDelayMs, i = (M = Ur() - (10 * (1073741821 - M) - (0 | o.timeoutMs || 5e3))) <= r ? 0 : r + i - M), 10 < i) {
                                        bc(e, n), e.timeoutHandle = Tn(Nc.bind(null, e), i);
                                        break;
                                    }
                                }
                                Nc(e);
                                break;
                            default:
                                throw Error(u(329));
                        }
                        if (qo(e), e.callbackNode === t) return _o.bind(null, e);
                    }
                }
                return null;
            }
            function $o(e) {
                var t = e.lastExpiredTime;
                if (t = 0 !== t ? t : 1073741823, 0 != (48 & fo)) throw Error(u(327));
                if (sc(), e === Lo && t === Co || nc(e, t), null !== Eo) {
                    var n = fo;
                    fo |= 16;
                    for(var i = rc();;)try {
                        oc();
                        break;
                    } catch (t) {
                        ic(e, t);
                    }
                    if ($r(), fo = n, Do.current = i, 1 === xo) throw n = po, nc(e, t), bc(e, t), qo(e), n;
                    if (null !== Eo) throw Error(u(261));
                    e.finishedWork = e.current.alternate, e.finishedExpirationTime = t, Lo = null, Nc(e), qo(e);
                }
                return null;
            }
            function ec(e, t) {
                var n = fo;
                fo |= 1;
                try {
                    return e(t);
                } finally{
                    0 === (fo = n) && Hr();
                }
            }
            function tc(e, t) {
                var n = fo;
                fo &= -2, fo |= 8;
                try {
                    return e(t);
                } finally{
                    0 === (fo = n) && Hr();
                }
            }
            function nc(e, t) {
                e.finishedWork = null, e.finishedExpirationTime = 0;
                var n = e.timeoutHandle;
                if (-1 !== n && (e.timeoutHandle = -1, yn(n)), null !== Eo) for(n = Eo.return; null !== n;){
                    var i = n;
                    switch(i.tag){
                        case 1:
                            null != (i = i.type.childContextTypes) && Ar();
                            break;
                        case 3:
                            vM(), cr(Nr), cr(lr);
                            break;
                        case 5:
                            hM(i);
                            break;
                        case 4:
                            vM();
                            break;
                        case 13:
                        case 19:
                            cr(kM);
                            break;
                        case 10:
                            eM(i);
                    }
                    n = n.return;
                }
                Lo = e, Eo = Cc(e.current, null), Co = t, xo = yo, po = null, mo = So = 1073741823, Oo = null, vo = 0, bo = !1;
            }
            function ic(e, t) {
                for(;;){
                    try {
                        if ($r(), PM.current = su, WM) for(var n = GM.memoizedState; null !== n;){
                            var i = n.queue;
                            null !== i && (i.pending = null), n = n.next;
                        }
                        if (ZM = 0, RM = BM = GM = null, WM = !1, null === Eo || null === Eo.return) return xo = 1, po = t, Eo = null;
                        e: {
                            var r = e, M = Eo.return, u = Eo, o = t;
                            if (t = Co, u.effectTag |= 2048, u.firstEffect = u.lastEffect = null, null !== o && "object" == typeof o && "function" == typeof o.then) {
                                var c = o;
                                if (0 == (2 & u.mode)) {
                                    var a = u.alternate;
                                    a ? (u.updateQueue = a.updateQueue, u.memoizedState = a.memoizedState, u.expirationTime = a.expirationTime) : (u.updateQueue = null, u.memoizedState = null);
                                }
                                var I = 0 != (1 & kM.current), l = M;
                                do {
                                    var N;
                                    if (N = 13 === l.tag) {
                                        var j = l.memoizedState;
                                        if (null !== j) N = null !== j.dehydrated;
                                        else {
                                            var g = l.memoizedProps;
                                            N = void 0 !== g.fallback && (!0 !== g.unstable_avoidThisFallback || !I);
                                        }
                                    }
                                    if (N) {
                                        var s = l.updateQueue;
                                        if (null === s) {
                                            var A = new Set;
                                            A.add(c), l.updateQueue = A;
                                        } else s.add(c);
                                        if (0 == (2 & l.mode)) {
                                            if (l.effectTag |= 64, u.effectTag &= -2981, 1 === u.tag) {
                                                if (null === u.alternate) u.tag = 17;
                                                else {
                                                    var D = oM(1073741823, null);
                                                    D.tag = 2, cM(u, D);
                                                }
                                            }
                                            u.expirationTime = 1073741823;
                                            break e;
                                        }
                                        o = void 0, u = t;
                                        var d = r.pingCache;
                                        if (null === d ? (d = r.pingCache = new No, o = new Set, d.set(c, o)) : void 0 === (o = d.get(c)) && (o = new Set, d.set(c, o)), !o.has(u)) {
                                            o.add(u);
                                            var T = Tc.bind(null, r, c, u);
                                            c.then(T, T);
                                        }
                                        l.effectTag |= 4096, l.expirationTime = t;
                                        break e;
                                    }
                                    l = l.return;
                                }while (null !== l);
                                o = Error((Ae(u.type) || "A React component") + " suspended while rendering, but no fallback UI was specified.\n\nAdd a <Suspense fallback=...> component higher in the tree to provide a loading indicator or placeholder to display." + De(u));
                            }
                            5 !== xo && (xo = 2), o = qu(o, u), l = M;
                            do {
                                switch(l.tag){
                                    case 3:
                                        c = o, l.effectTag |= 4096, l.expirationTime = t, aM(l, jo(l, c, t));
                                        break e;
                                    case 1:
                                        c = o;
                                        var y = l.type, z = l.stateNode;
                                        if (0 == (64 & l.effectTag) && ("function" == typeof y.getDerivedStateFromError || null !== z && "function" == typeof z.componentDidCatch && (null === Po || !Po.has(z)))) {
                                            l.effectTag |= 4096, l.expirationTime = t, aM(l, go(l, c, t));
                                            break e;
                                        }
                                }
                                l = l.return;
                            }while (null !== l);
                        }
                        Eo = Ic(Eo);
                    } catch (e) {
                        t = e;
                        continue;
                    }
                    break;
                }
            }
            function rc() {
                var e = Do.current;
                return Do.current = su, null === e ? su : e;
            }
            function Mc(e, t) {
                e < So && 2 < e && (So = e), null !== t && e < mo && 2 < e && (mo = e, Oo = t);
            }
            function uc(e) {
                e > vo && (vo = e);
            }
            function oc() {
                for(; null !== Eo;)Eo = ac(Eo);
            }
            function cc() {
                for(; null !== Eo && !br();)Eo = ac(Eo);
            }
            function ac(e) {
                var t = so(e.alternate, e, Co);
                return e.memoizedProps = e.pendingProps, null === t && (t = Ic(e)), To.current = null, t;
            }
            function Ic(e) {
                Eo = e;
                do {
                    var t = Eo.alternate;
                    if (e = Eo.return, 0 == (2048 & Eo.effectTag)) {
                        if (t = Xu(t, Eo, Co), 1 === Co || 1 !== Eo.childExpirationTime) {
                            for(var n = 0, i = Eo.child; null !== i;){
                                var r = i.expirationTime, M = i.childExpirationTime;
                                r > n && (n = r), M > n && (n = M), i = i.sibling;
                            }
                            Eo.childExpirationTime = n;
                        }
                        if (null !== t) return t;
                        null !== e && 0 == (2048 & e.effectTag) && (null === e.firstEffect && (e.firstEffect = Eo.firstEffect), null !== Eo.lastEffect && (null !== e.lastEffect && (e.lastEffect.nextEffect = Eo.firstEffect), e.lastEffect = Eo.lastEffect), 1 < Eo.effectTag && (null !== e.lastEffect ? e.lastEffect.nextEffect = Eo : e.firstEffect = Eo, e.lastEffect = Eo));
                    } else {
                        if (null !== (t = Ku(Eo))) return t.effectTag &= 2047, t;
                        null !== e && (e.firstEffect = e.lastEffect = null, e.effectTag |= 2048);
                    }
                    if (null !== (t = Eo.sibling)) return t;
                    Eo = e;
                }while (null !== Eo);
                return xo === yo && (xo = 5), null;
            }
            function lc(e) {
                var t = e.expirationTime;
                return t > (e = e.childExpirationTime) ? t : e;
            }
            function Nc(e) {
                var t = Zr();
                return Br(99, jc.bind(null, e, t)), null;
            }
            function jc(e, t) {
                do sc();
                while (null !== Zo);
                if (0 != (48 & fo)) throw Error(u(327));
                var n = e.finishedWork, i = e.finishedExpirationTime;
                if (null === n) return null;
                if (e.finishedWork = null, e.finishedExpirationTime = 0, n === e.current) throw Error(u(177));
                e.callbackNode = null, e.callbackExpirationTime = 0, e.callbackPriority = 90, e.nextKnownPendingLevel = 0;
                var r = lc(n);
                if (e.firstPendingTime = r, i <= e.lastSuspendedTime ? e.firstSuspendedTime = e.lastSuspendedTime = e.nextKnownPendingLevel = 0 : i <= e.firstSuspendedTime && (e.firstSuspendedTime = i - 1), i <= e.lastPingedTime && (e.lastPingedTime = 0), i <= e.lastExpiredTime && (e.lastExpiredTime = 0), e === Lo && (Eo = Lo = null, Co = 0), 1 < n.effectTag ? null !== n.lastEffect ? (n.lastEffect.nextEffect = n, r = n.firstEffect) : r = n : r = n.firstEffect, null !== r) {
                    var M = fo;
                    fo |= 32, To.current = null, sn = Vt;
                    var o = jn();
                    if (gn(o)) {
                        if ("selectionStart" in o) var c = {
                            start: o.selectionStart,
                            end: o.selectionEnd
                        };
                        else e: {
                            var a = (c = (c = o.ownerDocument) && c.defaultView || window).getSelection && c.getSelection();
                            if (a && 0 !== a.rangeCount) {
                                c = a.anchorNode;
                                var I = a.anchorOffset, l = a.focusNode;
                                a = a.focusOffset;
                                try {
                                    c.nodeType, l.nodeType;
                                } catch (e) {
                                    c = null;
                                    break e;
                                }
                                var N = 0, j = -1, g = -1, s = 0, A = 0, D = o, d = null;
                                t: for(;;){
                                    for(var T; D !== c || 0 !== I && 3 !== D.nodeType || (j = N + I), D !== l || 0 !== a && 3 !== D.nodeType || (g = N + a), 3 === D.nodeType && (N += D.nodeValue.length), null !== (T = D.firstChild);)d = D, D = T;
                                    for(;;){
                                        if (D === o) break t;
                                        if (d === c && ++s === I && (j = N), d === l && ++A === a && (g = N), null !== (T = D.nextSibling)) break;
                                        d = (D = d).parentNode;
                                    }
                                    D = T;
                                }
                                c = -1 === j || -1 === g ? null : {
                                    start: j,
                                    end: g
                                };
                            } else c = null;
                        }
                        c = c || {
                            start: 0,
                            end: 0
                        };
                    } else c = null;
                    An = {
                        activeElementDetached: null,
                        focusedElem: o,
                        selectionRange: c
                    }, Vt = !1, ko = r;
                    do try {
                        gc();
                    } catch (e) {
                        if (null === ko) throw Error(u(330));
                        dc(ko, e), ko = ko.nextEffect;
                    }
                    while (null !== ko);
                    ko = r;
                    do try {
                        for(o = e, c = t; null !== ko;){
                            var y = ko.effectTag;
                            if (16 & y && Ze(ko.stateNode, ""), 128 & y) {
                                var z = ko.alternate;
                                if (null !== z) {
                                    var w = z.ref;
                                    null !== w && ("function" == typeof w ? w(null) : w.current = null);
                                }
                            }
                            switch(1038 & y){
                                case 2:
                                    co(ko), ko.effectTag &= -3;
                                    break;
                                case 6:
                                    co(ko), ko.effectTag &= -3, Io(ko.alternate, ko);
                                    break;
                                case 1024:
                                    ko.effectTag &= -1025;
                                    break;
                                case 1028:
                                    ko.effectTag &= -1025, Io(ko.alternate, ko);
                                    break;
                                case 4:
                                    Io(ko.alternate, ko);
                                    break;
                                case 8:
                                    ao(o, I = ko, c), uo(I);
                            }
                            ko = ko.nextEffect;
                        }
                    } catch (e) {
                        if (null === ko) throw Error(u(330));
                        dc(ko, e), ko = ko.nextEffect;
                    }
                    while (null !== ko);
                    if (w = An, z = jn(), y = w.focusedElem, c = w.selectionRange, z !== y && y && y.ownerDocument && function e(t, n) {
                        return !(!t || !n) && (t === n || (!t || 3 !== t.nodeType) && (n && 3 === n.nodeType ? e(t, n.parentNode) : "contains" in t ? t.contains(n) : !!t.compareDocumentPosition && !!(16 & t.compareDocumentPosition(n))));
                    }(y.ownerDocument.documentElement, y)) {
                        null !== c && gn(y) && (z = c.start, void 0 === (w = c.end) && (w = z), "selectionStart" in y ? (y.selectionStart = z, y.selectionEnd = Math.min(w, y.value.length)) : (w = (z = y.ownerDocument || document) && z.defaultView || window).getSelection && (w = w.getSelection(), I = y.textContent.length, o = Math.min(c.start, I), c = void 0 === c.end ? o : Math.min(c.end, I), !w.extend && o > c && (I = c, c = o, o = I), I = Nn(y, o), l = Nn(y, c), I && l && (1 !== w.rangeCount || w.anchorNode !== I.node || w.anchorOffset !== I.offset || w.focusNode !== l.node || w.focusOffset !== l.offset) && ((z = z.createRange()).setStart(I.node, I.offset), w.removeAllRanges(), o > c ? (w.addRange(z), w.extend(l.node, l.offset)) : (z.setEnd(l.node, l.offset), w.addRange(z))))), z = [];
                        for(w = y; w = w.parentNode;)1 === w.nodeType && z.push({
                            element: w,
                            left: w.scrollLeft,
                            top: w.scrollTop
                        });
                        for("function" == typeof y.focus && y.focus(), y = 0; y < z.length; y++)(w = z[y]).element.scrollLeft = w.left, w.element.scrollTop = w.top;
                    }
                    Vt = !!sn, An = sn = null, e.current = n, ko = r;
                    do try {
                        for(y = e; null !== ko;){
                            var f = ko.effectTag;
                            if (36 & f && ro(y, ko.alternate, ko), 128 & f) {
                                z = void 0;
                                var L = ko.ref;
                                if (null !== L) {
                                    var E = ko.stateNode;
                                    switch(ko.tag){
                                        case 5:
                                            z = E;
                                            break;
                                        default:
                                            z = E;
                                    }
                                    "function" == typeof L ? L(z) : L.current = z;
                                }
                            }
                            ko = ko.nextEffect;
                        }
                    } catch (e) {
                        if (null === ko) throw Error(u(330));
                        dc(ko, e), ko = ko.nextEffect;
                    }
                    while (null !== ko);
                    ko = null, hr(), fo = M;
                } else e.current = n;
                if (Uo) Uo = !1, Zo = e, Go = t;
                else for(ko = r; null !== ko;)t = ko.nextEffect, ko.nextEffect = null, ko = t;
                if (0 === (t = e.firstPendingTime) && (Po = null), 1073741823 === t ? e === Wo ? Ro++ : (Ro = 0, Wo = e) : Ro = 0, "function" == typeof zc && zc(n.stateNode, i), qo(e), Qo) throw Qo = !1, e = Yo, Yo = null, e;
                return 0 != (8 & fo) || Hr(), null;
            }
            function gc() {
                for(; null !== ko;){
                    var e = ko.effectTag;
                    0 != (256 & e) && to(ko.alternate, ko), 0 == (512 & e) || Uo || (Uo = !0, Rr(97, function() {
                        return sc(), null;
                    })), ko = ko.nextEffect;
                }
            }
            function sc() {
                if (90 !== Go) {
                    var e = 97 < Go ? 97 : Go;
                    return Go = 90, Br(e, Ac);
                }
            }
            function Ac() {
                if (null === Zo) return !1;
                var e = Zo;
                if (Zo = null, 0 != (48 & fo)) throw Error(u(331));
                var t = fo;
                for(fo |= 32, e = e.current.firstEffect; null !== e;){
                    try {
                        var n = e;
                        if (0 != (512 & n.effectTag)) switch(n.tag){
                            case 0:
                            case 11:
                            case 15:
                            case 22:
                                no(5, n), io(5, n);
                        }
                    } catch (t) {
                        if (null === e) throw Error(u(330));
                        dc(e, t);
                    }
                    n = e.nextEffect, e.nextEffect = null, e = n;
                }
                return fo = t, Hr(), !0;
            }
            function Dc(e, t, n) {
                cM(e, t = jo(e, t = qu(n, t), 1073741823)), null !== (e = Xo(e, 1073741823)) && qo(e);
            }
            function dc(e, t) {
                if (3 === e.tag) Dc(e, e, t);
                else for(var n = e.return; null !== n;){
                    if (3 === n.tag) {
                        Dc(n, e, t);
                        break;
                    }
                    if (1 === n.tag) {
                        var i = n.stateNode;
                        if ("function" == typeof n.type.getDerivedStateFromError || "function" == typeof i.componentDidCatch && (null === Po || !Po.has(i))) {
                            cM(n, e = go(n, e = qu(t, e), 1073741823)), null !== (n = Xo(n, 1073741823)) && qo(n);
                            break;
                        }
                    }
                    n = n.return;
                }
            }
            function Tc(e, t, n) {
                var i = e.pingCache;
                null !== i && i.delete(t), Lo === e && Co === n ? xo === wo || xo === zo && 1073741823 === So && Ur() - ho < 500 ? nc(e, Co) : bo = !0 : vc(e, n) && (0 !== (t = e.lastPingedTime) && t < n || (e.lastPingedTime = n, qo(e)));
            }
            function yc(e, t) {
                var n = e.stateNode;
                null !== n && n.delete(t), 0 === (t = 0) && (t = Jo(t = Vo(), e, null)), null !== (e = Xo(e, t)) && qo(e);
            }
            so = function(e, t, n) {
                var i = t.expirationTime;
                if (null !== e) {
                    var r = t.pendingProps;
                    if (e.memoizedProps !== r || Nr.current) Su = !0;
                    else {
                        if (i < n) {
                            switch(Su = !1, t.tag){
                                case 3:
                                    Pu(t), xu();
                                    break;
                                case 5:
                                    if (bM(t), 4 & t.mode && 1 !== n && r.hidden) return t.expirationTime = t.childExpirationTime = 1, null;
                                    break;
                                case 1:
                                    sr(t.type) && Tr(t);
                                    break;
                                case 4:
                                    OM(t, t.stateNode.containerInfo);
                                    break;
                                case 10:
                                    i = t.memoizedProps.value, r = t.type._context, ar(Xr, r._currentValue), r._currentValue = i;
                                    break;
                                case 13:
                                    if (null !== t.memoizedState) return 0 !== (i = t.child.childExpirationTime) && i >= n ? Ru(e, t, n) : (ar(kM, 1 & kM.current), null !== (t = Ju(e, t, n)) ? t.sibling : null);
                                    ar(kM, 1 & kM.current);
                                    break;
                                case 19:
                                    if (i = t.childExpirationTime >= n, 0 != (64 & e.effectTag)) {
                                        if (i) return Vu(e, t, n);
                                        t.effectTag |= 64;
                                    }
                                    if (null !== (r = t.memoizedState) && (r.rendering = null, r.tail = null), ar(kM, kM.current), !i) return null;
                            }
                            return Ju(e, t, n);
                        }
                        Su = !1;
                    }
                } else Su = !1;
                switch(t.expirationTime = 0, t.tag){
                    case 2:
                        if (i = t.type, null !== e && (e.alternate = null, t.alternate = null, t.effectTag |= 2), e = t.pendingProps, r = gr(t, lr.current), nM(t, n), r = JM(null, t, i, e, r, n), t.effectTag |= 1, "object" == typeof r && null !== r && "function" == typeof r.render && void 0 === r.$$typeof) {
                            if (t.tag = 1, t.memoizedState = null, t.updateQueue = null, sr(i)) {
                                var M = !0;
                                Tr(t);
                            } else M = !1;
                            t.memoizedState = null !== r.state && void 0 !== r.state ? r.state : null, MM(t);
                            var o = i.getDerivedStateFromProps;
                            "function" == typeof o && gM(t, i, o, e), r.updater = sM, t.stateNode = r, r._reactInternalFiber = t, TM(t, i, e, n), t = Yu(null, t, i, !0, M, n);
                        } else t.tag = 0, mu(null, t, r, n), t = t.child;
                        return t;
                    case 16:
                        e: {
                            if (r = t.elementType, null !== e && (e.alternate = null, t.alternate = null, t.effectTag |= 2), e = t.pendingProps, function(e) {
                                if (-1 === e._status) {
                                    e._status = 0;
                                    var t = e._ctor;
                                    t = t(), e._result = t, t.then(function(t) {
                                        0 === e._status && (t = t.default, e._status = 1, e._result = t);
                                    }, function(t) {
                                        0 === e._status && (e._status = 2, e._result = t);
                                    });
                                }
                            }(r), 1 !== r._status) throw r._result;
                            switch(r = r._result, t.type = r, M = t.tag = function(e) {
                                if ("function" == typeof e) return Ec(e) ? 1 : 0;
                                if (null != e) {
                                    if ((e = e.$$typeof) === ce) return 11;
                                    if (e === le) return 14;
                                }
                                return 2;
                            }(r), e = Fr(r, e), M){
                                case 0:
                                    t = ku(null, t, r, e, n);
                                    break e;
                                case 1:
                                    t = Qu(null, t, r, e, n);
                                    break e;
                                case 11:
                                    t = Ou(null, t, r, e, n);
                                    break e;
                                case 14:
                                    t = vu(null, t, r, Fr(r.type, e), i, n);
                                    break e;
                            }
                            throw Error(u(306, r, ""));
                        }
                        return t;
                    case 0:
                        return i = t.type, r = t.pendingProps, ku(e, t, i, r = t.elementType === i ? r : Fr(i, r), n);
                    case 1:
                        return i = t.type, r = t.pendingProps, Qu(e, t, i, r = t.elementType === i ? r : Fr(i, r), n);
                    case 3:
                        if (Pu(t), i = t.updateQueue, null === e || null === i) throw Error(u(282));
                        if (i = t.pendingProps, r = null !== (r = t.memoizedState) ? r.element : null, uM(e, t), IM(t, i, null, n), (i = t.memoizedState.element) === r) xu(), t = Ju(e, t, n);
                        else {
                            if ((r = t.stateNode.hydrate) && (yu = zn(t.stateNode.containerInfo.firstChild), Tu = t, r = zu = !0), r) for(n = EM(t, null, i, n), t.child = n; n;)n.effectTag = -3 & n.effectTag | 1024, n = n.sibling;
                            else mu(e, t, i, n), xu();
                            t = t.child;
                        }
                        return t;
                    case 5:
                        return bM(t), null === e && Lu(t), i = t.type, r = t.pendingProps, M = null !== e ? e.memoizedProps : null, o = r.children, dn(i, r) ? o = null : null !== M && dn(i, M) && (t.effectTag |= 16), hu(e, t), 4 & t.mode && 1 !== n && r.hidden ? (t.expirationTime = t.childExpirationTime = 1, t = null) : (mu(e, t, o, n), t = t.child), t;
                    case 6:
                        return null === e && Lu(t), null;
                    case 13:
                        return Ru(e, t, n);
                    case 4:
                        return OM(t, t.stateNode.containerInfo), i = t.pendingProps, null === e ? t.child = LM(t, null, i, n) : mu(e, t, i, n), t.child;
                    case 11:
                        return i = t.type, r = t.pendingProps, Ou(e, t, i, r = t.elementType === i ? r : Fr(i, r), n);
                    case 7:
                        return mu(e, t, t.pendingProps, n), t.child;
                    case 8:
                    case 12:
                        return mu(e, t, t.pendingProps.children, n), t.child;
                    case 10:
                        e: {
                            i = t.type._context, r = t.pendingProps, o = t.memoizedProps, M = r.value;
                            var c = t.type._context;
                            if (ar(Xr, c._currentValue), c._currentValue = M, null !== o) {
                                if (c = o.value, 0 === (M = Yi(c, M) ? 0 : 0 | ("function" == typeof i._calculateChangedBits ? i._calculateChangedBits(c, M) : 1073741823))) {
                                    if (o.children === r.children && !Nr.current) {
                                        t = Ju(e, t, n);
                                        break e;
                                    }
                                } else for(null !== (c = t.child) && (c.return = t); null !== c;){
                                    var a = c.dependencies;
                                    if (null !== a) {
                                        o = c.child;
                                        for(var I = a.firstContext; null !== I;){
                                            if (I.context === i && 0 != (I.observedBits & M)) {
                                                1 === c.tag && ((I = oM(n, null)).tag = 2, cM(c, I)), c.expirationTime < n && (c.expirationTime = n), null !== (I = c.alternate) && I.expirationTime < n && (I.expirationTime = n), tM(c.return, n), a.expirationTime < n && (a.expirationTime = n);
                                                break;
                                            }
                                            I = I.next;
                                        }
                                    } else o = 10 === c.tag && c.type === t.type ? null : c.child;
                                    if (null !== o) o.return = c;
                                    else for(o = c; null !== o;){
                                        if (o === t) {
                                            o = null;
                                            break;
                                        }
                                        if (null !== (c = o.sibling)) {
                                            c.return = o.return, o = c;
                                            break;
                                        }
                                        o = o.return;
                                    }
                                    c = o;
                                }
                            }
                            mu(e, t, r.children, n), t = t.child;
                        }
                        return t;
                    case 9:
                        return r = t.type, i = (M = t.pendingProps).children, nM(t, n), i = i(r = iM(r, M.unstable_observedBits)), t.effectTag |= 1, mu(e, t, i, n), t.child;
                    case 14:
                        return M = Fr(r = t.type, t.pendingProps), vu(e, t, r, M = Fr(r.type, M), i, n);
                    case 15:
                        return bu(e, t, t.type, t.pendingProps, i, n);
                    case 17:
                        return i = t.type, r = t.pendingProps, r = t.elementType === i ? r : Fr(i, r), null !== e && (e.alternate = null, t.alternate = null, t.effectTag |= 2), t.tag = 1, sr(i) ? (e = !0, Tr(t)) : e = !1, nM(t, n), DM(t, i, r), TM(t, i, r, n), Yu(null, t, i, !0, e, n);
                    case 19:
                        return Vu(e, t, n);
                }
                throw Error(u(156, t.tag));
            };
            var zc = null, wc = null;
            function fc(e, t, n, i) {
                this.tag = e, this.key = n, this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null, this.index = 0, this.ref = null, this.pendingProps = t, this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null, this.mode = i, this.effectTag = 0, this.lastEffect = this.firstEffect = this.nextEffect = null, this.childExpirationTime = this.expirationTime = 0, this.alternate = null;
            }
            function Lc(e, t, n, i) {
                return new fc(e, t, n, i);
            }
            function Ec(e) {
                return !(!(e = e.prototype) || !e.isReactComponent);
            }
            function Cc(e, t) {
                var n = e.alternate;
                return null === n ? ((n = Lc(e.tag, t, e.key, e.mode)).elementType = e.elementType, n.type = e.type, n.stateNode = e.stateNode, n.alternate = e, e.alternate = n) : (n.pendingProps = t, n.effectTag = 0, n.nextEffect = null, n.firstEffect = null, n.lastEffect = null), n.childExpirationTime = e.childExpirationTime, n.expirationTime = e.expirationTime, n.child = e.child, n.memoizedProps = e.memoizedProps, n.memoizedState = e.memoizedState, n.updateQueue = e.updateQueue, t = e.dependencies, n.dependencies = null === t ? null : {
                    expirationTime: t.expirationTime,
                    firstContext: t.firstContext,
                    responders: t.responders
                }, n.sibling = e.sibling, n.index = e.index, n.ref = e.ref, n;
            }
            function xc(e, t, n, i, r, M) {
                var o = 2;
                if (i = e, "function" == typeof e) Ec(e) && (o = 1);
                else if ("string" == typeof e) o = 5;
                else e: switch(e){
                    case ne:
                        return pc(n.children, r, M, t);
                    case oe:
                        o = 8, r |= 7;
                        break;
                    case ie:
                        o = 8, r |= 1;
                        break;
                    case re:
                        return (e = Lc(12, n, t, 8 | r)).elementType = re, e.type = re, e.expirationTime = M, e;
                    case ae:
                        return (e = Lc(13, n, t, r)).type = ae, e.elementType = ae, e.expirationTime = M, e;
                    case Ie:
                        return (e = Lc(19, n, t, r)).elementType = Ie, e.expirationTime = M, e;
                    default:
                        if ("object" == typeof e && null !== e) switch(e.$$typeof){
                            case Me:
                                o = 10;
                                break e;
                            case ue:
                                o = 9;
                                break e;
                            case ce:
                                o = 11;
                                break e;
                            case le:
                                o = 14;
                                break e;
                            case Ne:
                                o = 16, i = null;
                                break e;
                            case je:
                                o = 22;
                                break e;
                        }
                        throw Error(u(130, null == e ? e : typeof e, ""));
                }
                return (t = Lc(o, n, t, r)).elementType = e, t.type = i, t.expirationTime = M, t;
            }
            function pc(e, t, n, i) {
                return (e = Lc(7, e, i, t)).expirationTime = n, e;
            }
            function Sc(e, t, n) {
                return (e = Lc(6, e, null, t)).expirationTime = n, e;
            }
            function mc(e, t, n) {
                return (t = Lc(4, null !== e.children ? e.children : [], e.key, t)).expirationTime = n, t.stateNode = {
                    containerInfo: e.containerInfo,
                    pendingChildren: null,
                    implementation: e.implementation
                }, t;
            }
            function Oc(e, t, n) {
                this.tag = t, this.current = null, this.containerInfo = e, this.pingCache = this.pendingChildren = null, this.finishedExpirationTime = 0, this.finishedWork = null, this.timeoutHandle = -1, this.pendingContext = this.context = null, this.hydrate = n, this.callbackNode = null, this.callbackPriority = 90, this.lastExpiredTime = this.lastPingedTime = this.nextKnownPendingLevel = this.lastSuspendedTime = this.firstSuspendedTime = this.firstPendingTime = 0;
            }
            function vc(e, t) {
                var n = e.firstSuspendedTime;
                return e = e.lastSuspendedTime, 0 !== n && n >= t && e <= t;
            }
            function bc(e, t) {
                var n = e.firstSuspendedTime, i = e.lastSuspendedTime;
                n < t && (e.firstSuspendedTime = t), (i > t || 0 === n) && (e.lastSuspendedTime = t), t <= e.lastPingedTime && (e.lastPingedTime = 0), t <= e.lastExpiredTime && (e.lastExpiredTime = 0);
            }
            function hc(e, t) {
                t > e.firstPendingTime && (e.firstPendingTime = t);
                var n = e.firstSuspendedTime;
                0 !== n && (t >= n ? e.firstSuspendedTime = e.lastSuspendedTime = e.nextKnownPendingLevel = 0 : t >= e.lastSuspendedTime && (e.lastSuspendedTime = t + 1), t > e.nextKnownPendingLevel && (e.nextKnownPendingLevel = t));
            }
            function kc(e, t) {
                var n = e.lastExpiredTime;
                (0 === n || n > t) && (e.lastExpiredTime = t);
            }
            function Qc(e, t, n, i) {
                var r = t.current, M = Vo(), o = NM.suspense;
                M = Jo(M, r, o);
                e: if (n) {
                    t: {
                        if ($e(n = n._reactInternalFiber) !== n || 1 !== n.tag) throw Error(u(170));
                        var c = n;
                        do {
                            switch(c.tag){
                                case 3:
                                    c = c.stateNode.context;
                                    break t;
                                case 1:
                                    if (sr(c.type)) {
                                        c = c.stateNode.__reactInternalMemoizedMergedChildContext;
                                        break t;
                                    }
                            }
                            c = c.return;
                        }while (null !== c);
                        throw Error(u(171));
                    }
                    if (1 === n.tag) {
                        var a = n.type;
                        if (sr(a)) {
                            n = dr(n, a, c);
                            break e;
                        }
                    }
                    n = c;
                } else n = Ir;
                return null === t.context ? t.context = n : t.pendingContext = n, (t = oM(M, o)).payload = {
                    element: e
                }, null !== (i = void 0 === i ? null : i) && (t.callback = i), cM(r, t), Fo(r, M), M;
            }
            function Yc(e) {
                if (!(e = e.current).child) return null;
                e.child.tag;
                return e.child.stateNode;
            }
            function Pc(e, t) {
                null !== (e = e.memoizedState) && null !== e.dehydrated && e.retryTime < t && (e.retryTime = t);
            }
            function Uc(e, t) {
                Pc(e, t), (e = e.alternate) && Pc(e, t);
            }
            function Zc(e, t, n) {
                var i = new Oc(e, t, n = null != n && !0 === n.hydrate), r = Lc(3, null, null, 2 === t ? 7 : 1 === t ? 3 : 0);
                i.current = r, r.stateNode = i, MM(r), e[Cn] = i.current, n && 0 !== t && function(e, t) {
                    var n = _e(t);
                    Ct.forEach(function(e) {
                        gt(e, t, n);
                    }), xt.forEach(function(e) {
                        gt(e, t, n);
                    });
                }(0, 9 === e.nodeType ? e : e.ownerDocument), this._internalRoot = i;
            }
            function Gc(e) {
                return !(!e || 1 !== e.nodeType && 9 !== e.nodeType && 11 !== e.nodeType && (8 !== e.nodeType || " react-mount-point-unstable " !== e.nodeValue));
            }
            function Bc(e, t, n, i, r) {
                var M = n._reactRootContainer;
                if (M) {
                    var u = M._internalRoot;
                    if ("function" == typeof r) {
                        var o = r;
                        r = function() {
                            var e = Yc(u);
                            o.call(e);
                        };
                    }
                    Qc(t, u, e, r);
                } else {
                    if (M = n._reactRootContainer = function(e, t) {
                        if (t || (t = !(!(t = e ? 9 === e.nodeType ? e.documentElement : e.firstChild : null) || 1 !== t.nodeType || !t.hasAttribute("data-reactroot"))), !t) for(var n; n = e.lastChild;)e.removeChild(n);
                        return new Zc(e, 0, t ? {
                            hydrate: !0
                        } : void 0);
                    }(n, i), u = M._internalRoot, "function" == typeof r) {
                        var c = r;
                        r = function() {
                            var e = Yc(u);
                            c.call(e);
                        };
                    }
                    tc(function() {
                        Qc(t, u, e, r);
                    });
                }
                return Yc(u);
            }
            function Rc(e, t, n) {
                var i = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
                return {
                    $$typeof: te,
                    key: null == i ? null : "" + i,
                    children: e,
                    containerInfo: t,
                    implementation: n
                };
            }
            function Wc(e, t) {
                var n = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
                if (!Gc(t)) throw Error(u(200));
                return Rc(e, t, null, n);
            }
            Zc.prototype.render = function(e) {
                Qc(e, this._internalRoot, null, null);
            }, Zc.prototype.unmount = function() {
                var e = this._internalRoot, t = e.containerInfo;
                Qc(null, e, null, function() {
                    t[Cn] = null;
                });
            }, st = function(e) {
                if (13 === e.tag) {
                    var t = Jr(Vo(), 150, 100);
                    Fo(e, t), Uc(e, t);
                }
            }, At = function(e) {
                13 === e.tag && (Fo(e, 3), Uc(e, 3));
            }, Dt = function(e) {
                if (13 === e.tag) {
                    var t = Vo();
                    Fo(e, t = Jo(t, e, null)), Uc(e, t);
                }
            }, p = function(e, t, n) {
                switch(t){
                    case "input":
                        if (Ee(e, n), t = n.name, "radio" === n.type && null != t) {
                            for(n = e; n.parentNode;)n = n.parentNode;
                            for(n = n.querySelectorAll("input[name=" + JSON.stringify("" + t) + '][type="radio"]'), t = 0; t < n.length; t++){
                                var i = n[t];
                                if (i !== e && i.form === e.form) {
                                    var r = mn(i);
                                    if (!r) throw Error(u(90));
                                    ze(i), Ee(i, r);
                                }
                            }
                        }
                        break;
                    case "textarea":
                        ve(e, n);
                        break;
                    case "select":
                        null != (t = n.value) && Se(e, !!n.multiple, t, !1);
                }
            }, h = ec, k = function(e, t, n, i, r) {
                var M = fo;
                fo |= 4;
                try {
                    return Br(98, e.bind(null, t, n, i, r));
                } finally{
                    0 === (fo = M) && Hr();
                }
            }, Q = function() {
                0 == (49 & fo) && (function() {
                    if (null !== Bo) {
                        var e = Bo;
                        Bo = null, e.forEach(function(e, t) {
                            kc(t, e), qo(t);
                        }), Hr();
                    }
                }(), sc());
            }, Y = function(e, t) {
                var n = fo;
                fo |= 2;
                try {
                    return e(t);
                } finally{
                    0 === (fo = n) && Hr();
                }
            };
            var Hc, Vc, Jc = {
                Events: [
                    pn,
                    Sn,
                    mn,
                    C,
                    f,
                    Yn,
                    function(e) {
                        rt(e, Qn);
                    },
                    v,
                    b,
                    qt,
                    ot,
                    sc,
                    {
                        current: !1
                    }
                ]
            };
            Vc = (Hc = {
                findFiberByHostInstance: xn,
                bundleType: 0,
                version: "16.14.0",
                rendererPackageName: "react-dom"
            }).findFiberByHostInstance, function(e) {
                if ("undefined" == typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) return !1;
                var t = __REACT_DEVTOOLS_GLOBAL_HOOK__;
                if (t.isDisabled || !t.supportsFiber) return !0;
                try {
                    var n = t.inject(e);
                    zc = function(e) {
                        try {
                            t.onCommitFiberRoot(n, e, void 0, 64 == (64 & e.current.effectTag));
                        } catch (e) {}
                    }, wc = function(e) {
                        try {
                            t.onCommitFiberUnmount(n, e);
                        } catch (e) {}
                    };
                } catch (e) {}
            }(r({}, Hc, {
                overrideHookState: null,
                overrideProps: null,
                setSuspenseHandler: null,
                scheduleUpdate: null,
                currentDispatcherRef: K.ReactCurrentDispatcher,
                findHostInstanceByFiber: function(e) {
                    return null === (e = nt(e)) ? null : e.stateNode;
                },
                findFiberByHostInstance: function(e) {
                    return Vc ? Vc(e) : null;
                },
                findHostInstancesForRefresh: null,
                scheduleRefresh: null,
                scheduleRoot: null,
                setRefreshHandler: null,
                getCurrentFiber: null
            })), t.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = Jc, t.createPortal = Wc, t.findDOMNode = function(e) {
                if (null == e) return null;
                if (1 === e.nodeType) return e;
                var t = e._reactInternalFiber;
                if (void 0 === t) {
                    if ("function" == typeof e.render) throw Error(u(188));
                    throw Error(u(268, Object.keys(e)));
                }
                return e = null === (e = nt(t)) ? null : e.stateNode;
            }, t.flushSync = function(e, t) {
                if (0 != (48 & fo)) throw Error(u(187));
                var n = fo;
                fo |= 1;
                try {
                    return Br(99, e.bind(null, t));
                } finally{
                    fo = n, Hr();
                }
            }, t.hydrate = function(e, t, n) {
                if (!Gc(t)) throw Error(u(200));
                return Bc(null, e, t, !0, n);
            }, t.render = function(e, t, n) {
                if (!Gc(t)) throw Error(u(200));
                return Bc(null, e, t, !1, n);
            }, t.unmountComponentAtNode = function(e) {
                if (!Gc(e)) throw Error(u(40));
                return !!e._reactRootContainer && (tc(function() {
                    Bc(null, null, e, !1, function() {
                        e._reactRootContainer = null, e[Cn] = null;
                    });
                }), !0);
            }, t.unstable_batchedUpdates = ec, t.unstable_createPortal = function(e, t) {
                return Wc(e, t, 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null);
            }, t.unstable_renderSubtreeIntoContainer = function(e, t, n, i) {
                if (!Gc(n)) throw Error(u(200));
                if (null == e || void 0 === e._reactInternalFiber) throw Error(u(38));
                return Bc(e, t, n, !1, i);
            }, t.version = "16.14.0";
        },
        function(e, t, n) {
            "use strict";
            e.exports = n(31);
        },
        function(e, t, n) {
            "use strict";
            /** @license React v0.19.1
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var i, r, M, u, o;
            if ("undefined" == typeof window || "function" != typeof MessageChannel) {
                var c = null, a = null, I = function() {
                    if (null !== c) try {
                        var e = t.unstable_now();
                        c(!0, e), c = null;
                    } catch (e) {
                        throw setTimeout(I, 0), e;
                    }
                }, l = Date.now();
                t.unstable_now = function() {
                    return Date.now() - l;
                }, i = function(e) {
                    null !== c ? setTimeout(i, 0, e) : (c = e, setTimeout(I, 0));
                }, r = function(e, t) {
                    a = setTimeout(e, t);
                }, M = function() {
                    clearTimeout(a);
                }, u = function() {
                    return !1;
                }, o = t.unstable_forceFrameRate = function() {};
            } else {
                var N = window.performance, j = window.Date, g = window.setTimeout, s = window.clearTimeout;
                if ("undefined" != typeof console) {
                    var A = window.cancelAnimationFrame;
                    "function" != typeof window.requestAnimationFrame && console.error("This browser doesn't support requestAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills"), "function" != typeof A && console.error("This browser doesn't support cancelAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills");
                }
                if ("object" == typeof N && "function" == typeof N.now) t.unstable_now = function() {
                    return N.now();
                };
                else {
                    var D = j.now();
                    t.unstable_now = function() {
                        return j.now() - D;
                    };
                }
                var d = !1, T = null, y = -1, z = 5, w = 0;
                u = function() {
                    return t.unstable_now() >= w;
                }, o = function() {}, t.unstable_forceFrameRate = function(e) {
                    0 > e || 125 < e ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing framerates higher than 125 fps is not unsupported") : z = 0 < e ? Math.floor(1e3 / e) : 5;
                };
                var f = new MessageChannel, L = f.port2;
                f.port1.onmessage = function() {
                    if (null !== T) {
                        var e = t.unstable_now();
                        w = e + z;
                        try {
                            T(!0, e) ? L.postMessage(null) : (d = !1, T = null);
                        } catch (e) {
                            throw L.postMessage(null), e;
                        }
                    } else d = !1;
                }, i = function(e) {
                    T = e, d || (d = !0, L.postMessage(null));
                }, r = function(e, n) {
                    y = g(function() {
                        e(t.unstable_now());
                    }, n);
                }, M = function() {
                    s(y), y = -1;
                };
            }
            function E(e, t) {
                var n = e.length;
                e.push(t);
                e: for(;;){
                    var i = n - 1 >>> 1, r = e[i];
                    if (!(void 0 !== r && 0 < p(r, t))) break e;
                    e[i] = t, e[n] = r, n = i;
                }
            }
            function C(e) {
                return void 0 === (e = e[0]) ? null : e;
            }
            function x(e) {
                var t = e[0];
                if (void 0 !== t) {
                    var n = e.pop();
                    if (n !== t) {
                        e[0] = n;
                        e: for(var i = 0, r = e.length; i < r;){
                            var M = 2 * (i + 1) - 1, u = e[M], o = M + 1, c = e[o];
                            if (void 0 !== u && 0 > p(u, n)) void 0 !== c && 0 > p(c, u) ? (e[i] = c, e[o] = n, i = o) : (e[i] = u, e[M] = n, i = M);
                            else {
                                if (!(void 0 !== c && 0 > p(c, n))) break e;
                                e[i] = c, e[o] = n, i = o;
                            }
                        }
                    }
                    return t;
                }
                return null;
            }
            function p(e, t) {
                var n = e.sortIndex - t.sortIndex;
                return 0 !== n ? n : e.id - t.id;
            }
            var S = [], m = [], O = 1, v = null, b = 3, h = !1, k = !1, Q = !1;
            function Y(e) {
                for(var t = C(m); null !== t;){
                    if (null === t.callback) x(m);
                    else {
                        if (!(t.startTime <= e)) break;
                        x(m), t.sortIndex = t.expirationTime, E(S, t);
                    }
                    t = C(m);
                }
            }
            function P(e) {
                if (Q = !1, Y(e), !k) {
                    if (null !== C(S)) k = !0, i(U);
                    else {
                        var t = C(m);
                        null !== t && r(P, t.startTime - e);
                    }
                }
            }
            function U(e, n) {
                k = !1, Q && (Q = !1, M()), h = !0;
                var i = b;
                try {
                    for(Y(n), v = C(S); null !== v && (!(v.expirationTime > n) || e && !u());){
                        var o = v.callback;
                        if (null !== o) {
                            v.callback = null, b = v.priorityLevel;
                            var c = o(v.expirationTime <= n);
                            n = t.unstable_now(), "function" == typeof c ? v.callback = c : v === C(S) && x(S), Y(n);
                        } else x(S);
                        v = C(S);
                    }
                    if (null !== v) var a = !0;
                    else {
                        var I = C(m);
                        null !== I && r(P, I.startTime - n), a = !1;
                    }
                    return a;
                } finally{
                    v = null, b = i, h = !1;
                }
            }
            function Z(e) {
                switch(e){
                    case 1:
                        return -1;
                    case 2:
                        return 250;
                    case 5:
                        return 1073741823;
                    case 4:
                        return 1e4;
                    default:
                        return 5e3;
                }
            }
            var G = o;
            t.unstable_IdlePriority = 5, t.unstable_ImmediatePriority = 1, t.unstable_LowPriority = 4, t.unstable_NormalPriority = 3, t.unstable_Profiling = null, t.unstable_UserBlockingPriority = 2, t.unstable_cancelCallback = function(e) {
                e.callback = null;
            }, t.unstable_continueExecution = function() {
                k || h || (k = !0, i(U));
            }, t.unstable_getCurrentPriorityLevel = function() {
                return b;
            }, t.unstable_getFirstCallbackNode = function() {
                return C(S);
            }, t.unstable_next = function(e) {
                switch(b){
                    case 1:
                    case 2:
                    case 3:
                        var t = 3;
                        break;
                    default:
                        t = b;
                }
                var n = b;
                b = t;
                try {
                    return e();
                } finally{
                    b = n;
                }
            }, t.unstable_pauseExecution = function() {}, t.unstable_requestPaint = G, t.unstable_runWithPriority = function(e, t) {
                switch(e){
                    case 1:
                    case 2:
                    case 3:
                    case 4:
                    case 5:
                        break;
                    default:
                        e = 3;
                }
                var n = b;
                b = e;
                try {
                    return t();
                } finally{
                    b = n;
                }
            }, t.unstable_scheduleCallback = function(e, n, u) {
                var o = t.unstable_now();
                if ("object" == typeof u && null !== u) {
                    var c = u.delay;
                    c = "number" == typeof c && 0 < c ? o + c : o, u = "number" == typeof u.timeout ? u.timeout : Z(e);
                } else u = Z(e), c = o;
                return e = {
                    id: O++,
                    callback: n,
                    priorityLevel: e,
                    startTime: c,
                    expirationTime: u = c + u,
                    sortIndex: -1
                }, c > o ? (e.sortIndex = c, E(m, e), null === C(S) && e === C(m) && (Q ? M() : Q = !0, r(P, c - o))) : (e.sortIndex = u, E(S, e), k || h || (k = !0, i(U))), e;
            }, t.unstable_shouldYield = function() {
                var e = t.unstable_now();
                Y(e);
                var n = C(S);
                return n !== v && null !== v && null !== n && null !== n.callback && n.startTime <= e && n.expirationTime < v.expirationTime || u();
            }, t.unstable_wrapCallback = function(e) {
                var t = b;
                return function() {
                    var n = b;
                    b = t;
                    try {
                        return e.apply(this, arguments);
                    } finally{
                        b = n;
                    }
                };
            };
        },
        function(e, t, n) {
            "use strict";
            Object.defineProperty(t, "__esModule", {
                value: !0
            }), t.updateLocal = t.removeLocal = t.getLocal = t.setLocal = t.local = void 0;
            var i = n(0);
            n(10).isLocalStorageAvailable() && (t.local = window.localStorage), t.setLocal = function(e, n) {
                var i = JSON.stringify(n);
                t.local && t.local.setItem(e, i);
            }, t.getLocal = function(e) {
                var n = null, i = null;
                if (t.local && (i = t.local.getItem(e)), i && "string" == typeof i) try {
                    n = JSON.parse(i);
                } catch (e) {
                    return null;
                }
                return n;
            }, t.removeLocal = function(e) {
                t.local && t.local.removeItem(e);
            }, t.updateLocal = function(e, n) {
                var r = t.getLocal(e) || {}, M = i.__assign(i.__assign({}, r), n);
                t.setLocal(e, M);
            };
        },
        function(e, t, n) {
            "use strict";
            n.r(t), (function(e) {
                n.d(t, "BrowserInfo", function() {
                    return r;
                }), n.d(t, "NodeInfo", function() {
                    return M;
                }), n.d(t, "SearchBotDeviceInfo", function() {
                    return u;
                }), n.d(t, "BotInfo", function() {
                    return o;
                }), n.d(t, "ReactNativeInfo", function() {
                    return c;
                }), n.d(t, "detect", function() {
                    return N;
                }), n.d(t, "browserName", function() {
                    return g;
                }), n.d(t, "parseUserAgent", function() {
                    return s;
                }), n.d(t, "detectOS", function() {
                    return A;
                }), n.d(t, "getNodeVersion", function() {
                    return D;
                });
                var i = function(e, t, n) {
                    if (n || 2 === arguments.length) for(var i, r = 0, M = t.length; r < M; r++)!i && r in t || (i || (i = Array.prototype.slice.call(t, 0, r)), i[r] = t[r]);
                    return e.concat(i || Array.prototype.slice.call(t));
                }, r = function(e, t, n) {
                    this.name = e, this.version = t, this.os = n, this.type = "browser";
                }, M = function(t) {
                    this.version = t, this.type = "node", this.name = "node", this.os = e.platform;
                }, u = function(e, t, n, i) {
                    this.name = e, this.version = t, this.os = n, this.bot = i, this.type = "bot-device";
                }, o = function() {
                    this.type = "bot", this.bot = !0, this.name = "bot", this.version = null, this.os = null;
                }, c = function() {
                    this.type = "react-native", this.name = "react-native", this.version = null, this.os = null;
                }, a = /(nuhk|curl|Googlebot|Yammybot|Openbot|Slurp|MSNBot|Ask\ Jeeves\/Teoma|ia_archiver)/, I = [
                    [
                        "aol",
                        /AOLShield\/([0-9\._]+)/
                    ],
                    [
                        "edge",
                        /Edge\/([0-9\._]+)/
                    ],
                    [
                        "edge-ios",
                        /EdgiOS\/([0-9\._]+)/
                    ],
                    [
                        "yandexbrowser",
                        /YaBrowser\/([0-9\._]+)/
                    ],
                    [
                        "kakaotalk",
                        /KAKAOTALK\s([0-9\.]+)/
                    ],
                    [
                        "samsung",
                        /SamsungBrowser\/([0-9\.]+)/
                    ],
                    [
                        "silk",
                        /\bSilk\/([0-9._-]+)\b/
                    ],
                    [
                        "miui",
                        /MiuiBrowser\/([0-9\.]+)$/
                    ],
                    [
                        "beaker",
                        /BeakerBrowser\/([0-9\.]+)/
                    ],
                    [
                        "edge-chromium",
                        /EdgA?\/([0-9\.]+)/
                    ],
                    [
                        "chromium-webview",
                        /(?!Chrom.*OPR)wv\).*Chrom(?:e|ium)\/([0-9\.]+)(:?\s|$)/
                    ],
                    [
                        "chrome",
                        /(?!Chrom.*OPR)Chrom(?:e|ium)\/([0-9\.]+)(:?\s|$)/
                    ],
                    [
                        "phantomjs",
                        /PhantomJS\/([0-9\.]+)(:?\s|$)/
                    ],
                    [
                        "crios",
                        /CriOS\/([0-9\.]+)(:?\s|$)/
                    ],
                    [
                        "firefox",
                        /Firefox\/([0-9\.]+)(?:\s|$)/
                    ],
                    [
                        "fxios",
                        /FxiOS\/([0-9\.]+)/
                    ],
                    [
                        "opera-mini",
                        /Opera Mini.*Version\/([0-9\.]+)/
                    ],
                    [
                        "opera",
                        /Opera\/([0-9\.]+)(?:\s|$)/
                    ],
                    [
                        "opera",
                        /OPR\/([0-9\.]+)(:?\s|$)/
                    ],
                    [
                        "pie",
                        /^Microsoft Pocket Internet Explorer\/(\d+\.\d+)$/
                    ],
                    [
                        "pie",
                        /^Mozilla\/\d\.\d+\s\(compatible;\s(?:MSP?IE|MSInternet Explorer) (\d+\.\d+);.*Windows CE.*\)$/
                    ],
                    [
                        "netfront",
                        /^Mozilla\/\d\.\d+.*NetFront\/(\d.\d)/
                    ],
                    [
                        "ie",
                        /Trident\/7\.0.*rv\:([0-9\.]+).*\).*Gecko$/
                    ],
                    [
                        "ie",
                        /MSIE\s([0-9\.]+);.*Trident\/[4-7].0/
                    ],
                    [
                        "ie",
                        /MSIE\s(7\.0)/
                    ],
                    [
                        "bb10",
                        /BB10;\sTouch.*Version\/([0-9\.]+)/
                    ],
                    [
                        "android",
                        /Android\s([0-9\.]+)/
                    ],
                    [
                        "ios",
                        /Version\/([0-9\._]+).*Mobile.*Safari.*/
                    ],
                    [
                        "safari",
                        /Version\/([0-9\._]+).*Safari/
                    ],
                    [
                        "facebook",
                        /FB[AS]V\/([0-9\.]+)/
                    ],
                    [
                        "instagram",
                        /Instagram\s([0-9\.]+)/
                    ],
                    [
                        "ios-webview",
                        /AppleWebKit\/([0-9\.]+).*Mobile/
                    ],
                    [
                        "ios-webview",
                        /AppleWebKit\/([0-9\.]+).*Gecko\)$/
                    ],
                    [
                        "curl",
                        /^curl\/([0-9\.]+)$/
                    ],
                    [
                        "searchbot",
                        /alexa|bot|crawl(er|ing)|facebookexternalhit|feedburner|google web preview|nagios|postrank|pingdom|slurp|spider|yahoo!|yandex/
                    ]
                ], l = [
                    [
                        "iOS",
                        /iP(hone|od|ad)/
                    ],
                    [
                        "Android OS",
                        /Android/
                    ],
                    [
                        "BlackBerry OS",
                        /BlackBerry|BB10/
                    ],
                    [
                        "Windows Mobile",
                        /IEMobile/
                    ],
                    [
                        "Amazon OS",
                        /Kindle/
                    ],
                    [
                        "Windows 3.11",
                        /Win16/
                    ],
                    [
                        "Windows 95",
                        /(Windows 95)|(Win95)|(Windows_95)/
                    ],
                    [
                        "Windows 98",
                        /(Windows 98)|(Win98)/
                    ],
                    [
                        "Windows 2000",
                        /(Windows NT 5.0)|(Windows 2000)/
                    ],
                    [
                        "Windows XP",
                        /(Windows NT 5.1)|(Windows XP)/
                    ],
                    [
                        "Windows Server 2003",
                        /(Windows NT 5.2)/
                    ],
                    [
                        "Windows Vista",
                        /(Windows NT 6.0)/
                    ],
                    [
                        "Windows 7",
                        /(Windows NT 6.1)/
                    ],
                    [
                        "Windows 8",
                        /(Windows NT 6.2)/
                    ],
                    [
                        "Windows 8.1",
                        /(Windows NT 6.3)/
                    ],
                    [
                        "Windows 10",
                        /(Windows NT 10.0)/
                    ],
                    [
                        "Windows ME",
                        /Windows ME/
                    ],
                    [
                        "Windows CE",
                        /Windows CE|WinCE|Microsoft Pocket Internet Explorer/
                    ],
                    [
                        "Open BSD",
                        /OpenBSD/
                    ],
                    [
                        "Sun OS",
                        /SunOS/
                    ],
                    [
                        "Chrome OS",
                        /CrOS/
                    ],
                    [
                        "Linux",
                        /(Linux)|(X11)/
                    ],
                    [
                        "Mac OS",
                        /(Mac_PowerPC)|(Macintosh)/
                    ],
                    [
                        "QNX",
                        /QNX/
                    ],
                    [
                        "BeOS",
                        /BeOS/
                    ],
                    [
                        "OS/2",
                        /OS\/2/
                    ]
                ];
                function N(e) {
                    return e ? s(e) : "undefined" == typeof document && "undefined" != typeof navigator && "ReactNative" === navigator.product ? new c : "undefined" != typeof navigator ? s(navigator.userAgent) : D();
                }
                function j(e) {
                    return "" !== e && I.reduce(function(t, n) {
                        var i = n[0], r = n[1];
                        if (t) return t;
                        var M = r.exec(e);
                        return !!M && [
                            i,
                            M
                        ];
                    }, !1);
                }
                function g(e) {
                    var t = j(e);
                    return t ? t[0] : null;
                }
                function s(e) {
                    var t = j(e);
                    if (!t) return null;
                    var n = t[0], M = t[1];
                    if ("searchbot" === n) return new o;
                    var c = M[1] && M[1].split(".").join("_").split("_").slice(0, 3);
                    c ? c.length < 3 && (c = i(i([], c, !0), function(e) {
                        for(var t = [], n = 0; n < e; n++)t.push("0");
                        return t;
                    }(3 - c.length), !0)) : c = [];
                    var I = c.join("."), l = A(e), N = a.exec(e);
                    return N && N[1] ? new u(n, I, l, N[1]) : new r(n, I, l);
                }
                function A(e) {
                    for(var t = 0, n = l.length; t < n; t++){
                        var i = l[t], r = i[0];
                        if (i[1].exec(e)) return r;
                    }
                    return null;
                }
                function D() {
                    return void 0 !== e && e.version ? new M(e.version.slice(1)) : null;
                }
            }).call(this, n(11));
        },
        function(e, t, n) {
            "use strict";
            Object.defineProperty(t, "__esModule", {
                value: !0
            }), t.CHAIN_DATA_LIST = void 0, t.CHAIN_DATA_LIST = {
                1: {
                    chainId: 1,
                    chain: "ETH",
                    network: "mainnet",
                    networkId: 1
                },
                2: {
                    chainId: 2,
                    chain: "EXP",
                    network: "expanse",
                    networkId: 1
                },
                3: {
                    chainId: 3,
                    chain: "ETH",
                    network: "ropsten",
                    networkId: 3
                },
                4: {
                    chainId: 4,
                    chain: "ETH",
                    network: "rinkeby",
                    networkId: 4
                },
                5: {
                    chainId: 5,
                    chain: "ETH",
                    network: "goerli",
                    networkId: 5
                },
                6: {
                    chainId: 6,
                    chain: "ETC",
                    network: "kotti",
                    networkId: 6
                },
                8: {
                    chainId: 8,
                    chain: "UBQ",
                    network: "ubiq",
                    networkId: 88
                },
                9: {
                    chainId: 9,
                    chain: "UBQ",
                    network: "ubiq-testnet",
                    networkId: 2
                },
                10: {
                    chainId: 10,
                    chain: "ETH",
                    network: "optimism",
                    networkId: 10
                },
                11: {
                    chainId: 11,
                    chain: "META",
                    network: "metadium",
                    networkId: 11
                },
                12: {
                    chainId: 12,
                    chain: "META",
                    network: "metadium-testnet",
                    networkId: 12
                },
                18: {
                    chainId: 18,
                    chain: "TST",
                    network: "thundercore-testnet",
                    networkId: 18
                },
                22: {
                    chainId: 22,
                    chain: "LYX",
                    network: "lukso-l14-testnet",
                    networkId: 22
                },
                23: {
                    chainId: 23,
                    chain: "LYX",
                    network: "lukso-l15-testnet",
                    networkId: 23
                },
                25: {
                    chainId: 25,
                    chain: "CRO",
                    network: "cronos",
                    networkId: 25
                },
                30: {
                    chainId: 30,
                    chain: "RSK",
                    network: "rsk",
                    networkId: 30
                },
                31: {
                    chainId: 31,
                    chain: "RSK",
                    network: "rsk-testnet",
                    networkId: 31
                },
                42: {
                    chainId: 42,
                    chain: "ETH",
                    network: "kovan",
                    networkId: 42
                },
                56: {
                    chainId: 56,
                    chain: "BSC",
                    network: "binance",
                    networkId: 56
                },
                60: {
                    chainId: 60,
                    chain: "GO",
                    network: "gochain",
                    networkId: 60
                },
                61: {
                    chainId: 61,
                    chain: "ETC",
                    network: "etc",
                    networkId: 1
                },
                62: {
                    chainId: 62,
                    chain: "ETC",
                    network: "etc-morden",
                    networkId: 2
                },
                63: {
                    chainId: 63,
                    chain: "ETC",
                    network: "etc-testnet",
                    networkId: 7
                },
                64: {
                    chainId: 64,
                    chain: "ELLA",
                    network: "ellaism",
                    networkId: 64
                },
                69: {
                    chainId: 69,
                    chain: "ETH",
                    network: "optimism-kovan",
                    networkId: 69
                },
                76: {
                    chainId: 76,
                    chain: "MIX",
                    network: "mix",
                    networkId: 76
                },
                77: {
                    chainId: 77,
                    chain: "POA",
                    network: "poa-sokol",
                    networkId: 77
                },
                88: {
                    chainId: 88,
                    chain: "TOMO",
                    network: "tomochain",
                    networkId: 88
                },
                97: {
                    chainId: 97,
                    chain: "BSC",
                    network: "binance-testnet",
                    networkId: 97
                },
                99: {
                    chainId: 99,
                    chain: "POA",
                    network: "poa-core",
                    networkId: 99
                },
                100: {
                    chainId: 100,
                    chain: "XDAI",
                    network: "xdai",
                    networkId: 100
                },
                101: {
                    chainId: 101,
                    chain: "ETI",
                    network: "etherinc",
                    networkId: 1
                },
                108: {
                    chainId: 108,
                    chain: "TT",
                    network: "thundercore",
                    networkId: 108
                },
                162: {
                    chainId: 162,
                    chain: "PHT",
                    network: "sirius",
                    networkId: 162
                },
                163: {
                    chainId: 163,
                    chain: "PHT",
                    network: "lightstreams",
                    networkId: 163
                },
                180: {
                    chainId: 180,
                    chain: "AME",
                    network: "ame",
                    networkId: 180
                },
                211: {
                    chainId: 211,
                    chain: "FTN",
                    network: "freight",
                    networkId: 0
                },
                250: {
                    chainId: 250,
                    chain: "FTM",
                    network: "fantom",
                    networkId: 250
                },
                269: {
                    chainId: 269,
                    chain: "HPB",
                    network: "hpb",
                    networkId: 100
                },
                338: {
                    chainId: 338,
                    chain: "CRO",
                    network: "cronos-testnet",
                    networkId: 338
                },
                385: {
                    chainId: 385,
                    chain: "CRO",
                    network: "lisinski",
                    networkId: 385
                },
                534: {
                    chainId: 534,
                    chain: "CNDL",
                    network: "candle",
                    networkId: 534
                },
                820: {
                    chainId: 820,
                    chain: "CLO",
                    network: "callisto",
                    networkId: 1
                },
                821: {
                    chainId: 821,
                    chain: "CLO",
                    network: "callisto-testnet",
                    networkId: 2
                },
                137: {
                    chainId: 137,
                    chain: "MATIC",
                    network: "matic",
                    networkId: 137
                },
                1284: {
                    chainId: 1284,
                    chain: "GLMR",
                    network: "moonbeam",
                    networkId: 1284
                },
                1285: {
                    chainId: 1285,
                    chain: "MOVR",
                    network: "moonriver",
                    networkId: 1285
                },
                42161: {
                    chainId: 42161,
                    chain: "ETH",
                    network: "arbitrum",
                    networkId: 42161
                },
                42220: {
                    chainId: 42220,
                    chain: "CELO",
                    network: "celo",
                    networkId: 42220
                },
                44787: {
                    chainId: 44787,
                    chain: "CELO",
                    network: "celo-alfajores",
                    networkId: 44787
                },
                62320: {
                    chainId: 62320,
                    chain: "CELO",
                    network: "celo-baklava",
                    networkId: 62320
                },
                80001: {
                    chainId: 80001,
                    chain: "MUMBAI",
                    network: "mumbai",
                    networkId: 80001
                },
                43113: {
                    chainId: 43113,
                    chain: "AVAX",
                    network: "avalanche-fuji-testnet",
                    networkId: 43113
                },
                43114: {
                    chainId: 43114,
                    chain: "AVAX",
                    network: "avalanche-mainnet",
                    networkId: 43114
                },
                246529: {
                    chainId: 246529,
                    chain: "ARTIS sigma1",
                    network: "artis-s1",
                    networkId: 246529
                },
                246785: {
                    chainId: 246785,
                    chain: "ARTIS tau1",
                    network: "artis-t1",
                    networkId: 246785
                },
                1007: {
                    chainId: 1007,
                    chain: "NewChain TestNet",
                    network: "newchain-testnet",
                    networkId: 1007
                },
                1012: {
                    chainId: 1012,
                    chain: "NewChain MainNet",
                    network: "newchain-mainnet",
                    networkId: 1012
                },
                421611: {
                    chainId: 421611,
                    chain: "ETH",
                    network: "arbitrum-rinkeby",
                    networkId: 421611
                },
                16666e5: {
                    chainId: 16666e5,
                    chain: "ONE",
                    network: "harmony-shard1",
                    networkId: 16666e5
                },
                1313161554: {
                    chainId: 1313161554,
                    chain: "AETH",
                    network: "aurora",
                    networkId: 1313161554
                }
            };
        },
        function(e, t, n) {
            "use strict";
            Object.defineProperty(t, "__esModule", {
                value: !0
            }), t.CONNECT_BUTTON_CLASSNAME = t.PROVIDER_DESCRIPTION_CLASSNAME = t.PROVIDER_NAME_CLASSNAME = t.PROVIDER_ICON_CLASSNAME = t.PROVIDER_CONTAINER_CLASSNAME = t.PROVIDER_WRAPPER_CLASSNAME = t.MODAL_CARD_CLASSNAME = t.MODAL_HITBOX_CLASSNAME = t.MODAL_CONTAINER_CLASSNAME = t.MODAL_LIGHTBOX_CLASSNAME = void 0, t.MODAL_LIGHTBOX_CLASSNAME = "web3modal-modal-lightbox", t.MODAL_CONTAINER_CLASSNAME = "web3modal-modal-container", t.MODAL_HITBOX_CLASSNAME = "web3modal-modal-hitbox", t.MODAL_CARD_CLASSNAME = "web3modal-modal-card", t.PROVIDER_WRAPPER_CLASSNAME = "web3modal-provider-wrapper", t.PROVIDER_CONTAINER_CLASSNAME = "web3modal-provider-container", t.PROVIDER_ICON_CLASSNAME = "web3modal-provider-icon", t.PROVIDER_NAME_CLASSNAME = "web3modal-provider-name", t.PROVIDER_DESCRIPTION_CLASSNAME = "web3modal-provider-description", t.CONNECT_BUTTON_CLASSNAME = "web3modal-connect-button";
        },
        function(e, t, n) {
            "use strict";
            Object.defineProperty(t, "__esModule", {
                value: !0
            }), t.SELECT_EVENT = t.CLOSE_EVENT = t.ERROR_EVENT = t.CONNECT_EVENT = void 0, t.CONNECT_EVENT = "connect", t.ERROR_EVENT = "error", t.CLOSE_EVENT = "close", t.SELECT_EVENT = "select";
        },
        function(e, t, n) {
            "use strict";
            Object.defineProperty(t, "__esModule", {
                value: !0
            }), t.CACHED_PROVIDER_KEY = t.INJECTED_PROVIDER_ID = t.WEB3_CONNECT_MODAL_ID = void 0, t.WEB3_CONNECT_MODAL_ID = "WEB3_CONNECT_MODAL_ID", t.INJECTED_PROVIDER_ID = "injected", t.CACHED_PROVIDER_KEY = "WEB3_CONNECT_CACHED_PROVIDER";
        },
        function(e, t, n) {
            "use strict";
            Object.defineProperty(t, "__esModule", {
                value: !0
            });
            t.default = {
                name: "light",
                colors: {
                    background: "rgb(255, 255, 255)",
                    main: "rgb(12, 12, 13)",
                    secondary: "rgb(169, 169, 188)",
                    border: "rgba(195, 195, 195, 0.14)",
                    hover: "rgba(195, 195, 195, 0.14)"
                }
            };
        },
        function(e, t, n) {
            "use strict";
            Object.defineProperty(t, "__esModule", {
                value: !0
            });
            t.default = {
                name: "dark",
                colors: {
                    background: "rgb(39, 49, 56)",
                    main: "rgb(199, 199, 199)",
                    secondary: "rgb(136, 136, 136)",
                    border: "rgba(195, 195, 195, 0.14)",
                    hover: "rgb(16, 26, 32)"
                }
            };
        },
        function(e, t, n) {
            "use strict";
            Object.defineProperty(t, "__esModule", {
                value: !0
            }), t.phantom = t.ledger = t.web3auth = t.starzwallet = t.bitkeep = t.opera = t.clvwallet = t.sequence = t.walletlink = t.coinbasewallet = t.binancechainwallet = t.frame = t.bitski = t.dcentwallet = t.mewconnect = t.burnerconnect = t.authereum = t.venly = t.fortmatic = t.torus = t.portis = t.boltx = t.walletconnect = t.injected = void 0;
            var i = n(0), r = i.__importDefault(n(41));
            t.injected = r.default;
            var M = i.__importDefault(n(42));
            t.boltx = M.default;
            var u = i.__importDefault(n(43));
            t.walletconnect = u.default;
            var o = i.__importDefault(n(44));
            t.portis = o.default;
            var c = i.__importDefault(n(45));
            t.fortmatic = c.default;
            var a = i.__importDefault(n(46));
            t.torus = a.default;
            var I = i.__importDefault(n(47));
            t.venly = I.default;
            var l = i.__importDefault(n(48));
            t.authereum = l.default;
            var N = i.__importDefault(n(49));
            t.burnerconnect = N.default;
            var j = i.__importDefault(n(50));
            t.mewconnect = j.default;
            var g = i.__importDefault(n(51));
            t.dcentwallet = g.default;
            var s = i.__importDefault(n(52));
            t.bitski = s.default;
            var A = i.__importDefault(n(53));
            t.frame = A.default;
            var D = i.__importDefault(n(54));
            t.binancechainwallet = D.default;
            var d = i.__importStar(n(55));
            t.coinbasewallet = d.default, Object.defineProperty(t, "walletlink", {
                enumerable: !0,
                get: function() {
                    return d.walletlink;
                }
            });
            var T = i.__importDefault(n(56));
            t.sequence = T.default;
            var y = i.__importDefault(n(57));
            t.clvwallet = y.default;
            var z = i.__importDefault(n(58));
            t.opera = z.default;
            var w = i.__importDefault(n(59));
            t.web3auth = w.default;
            var f = i.__importDefault(n(60));
            t.bitkeep = f.default;
            var L = i.__importDefault(n(61));
            t.starzwallet = L.default;
            var E = i.__importDefault(n(62));
            t.ledger = E.default;
            var C = i.__importDefault(n(63));
            t.phantom = C.default;
        },
        function(e, t, n) {
            "use strict";
            Object.defineProperty(t, "__esModule", {
                value: !0
            });
            var i = n(0);
            t.default = function() {
                return i.__awaiter(void 0, void 0, void 0, function() {
                    var e;
                    return i.__generator(this, function(t) {
                        switch(t.label){
                            case 0:
                                if (e = null, void 0 === window.ethereum) return [
                                    3,
                                    5
                                ];
                                e = window.ethereum, t.label = 1;
                            case 1:
                                return t.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]), [
                                    4,
                                    e.request({
                                        method: "eth_requestAccounts"
                                    })
                                ];
                            case 2:
                                return t.sent(), [
                                    3,
                                    4
                                ];
                            case 3:
                                throw t.sent(), new Error("User Rejected");
                            case 4:
                                return [
                                    3,
                                    6
                                ];
                            case 5:
                                if (window.web3) e = window.web3.currentProvider;
                                else {
                                    if (!window.celo) throw new Error("No Web3 Provider found");
                                    e = window.celo;
                                }
                                t.label = 6;
                            case 6:
                                return [
                                    2,
                                    e
                                ];
                        }
                    });
                });
            };
        },
        function(e, t, n) {
            "use strict";
            Object.defineProperty(t, "__esModule", {
                value: !0
            });
            var i = n(0);
            t.default = function() {
                return i.__awaiter(void 0, void 0, void 0, function() {
                    var e;
                    return i.__generator(this, function(t) {
                        switch(t.label){
                            case 0:
                                if (e = null, void 0 === window.boltX) return [
                                    3,
                                    5
                                ];
                                e = window.boltX.ethereum, t.label = 1;
                            case 1:
                                return t.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]), [
                                    4,
                                    e.request({
                                        method: "eth_requestAccounts"
                                    })
                                ];
                            case 2:
                                return t.sent(), [
                                    3,
                                    4
                                ];
                            case 3:
                                throw t.sent(), new Error("User Rejected");
                            case 4:
                                return [
                                    3,
                                    6
                                ];
                            case 5:
                                throw new Error("BoltX not found");
                            case 6:
                                return [
                                    2,
                                    e
                                ];
                        }
                    });
                });
            };
        },
        function(e, t, n) {
            "use strict";
            Object.defineProperty(t, "__esModule", {
                value: !0
            });
            var i = n(0), r = n(3);
            t.default = function(e, t) {
                return new Promise(function(n, M) {
                    return i.__awaiter(void 0, void 0, void 0, function() {
                        var u, o, c, a, I, l, N, j;
                        return i.__generator(this, function(i) {
                            switch(i.label){
                                case 0:
                                    u = "https://bridge.walletconnect.org", o = !0, c = "", a = void 0, I = 1, l = void 0, t && (u = t.bridge || u, o = void 0 !== t.qrcode ? t.qrcode : o, c = t.infuraId || "", a = t.rpc || void 0, I = t.network && r.getChainId(t.network) ? r.getChainId(t.network) : 1, l = t.qrcodeModalOptions || void 0), N = new e({
                                        bridge: u,
                                        qrcode: o,
                                        infuraId: c,
                                        rpc: a,
                                        chainId: I,
                                        qrcodeModalOptions: l
                                    }), i.label = 1;
                                case 1:
                                    return i.trys.push([
                                        1,
                                        3,
                                        ,
                                        4
                                    ]), [
                                        4,
                                        N.enable()
                                    ];
                                case 2:
                                    return i.sent(), n(N), [
                                        3,
                                        4
                                    ];
                                case 3:
                                    return j = i.sent(), M(j), [
                                        3,
                                        4
                                    ];
                                case 4:
                                    return [
                                        2
                                    ];
                            }
                        });
                    });
                });
            };
        },
        function(e, t, n) {
            "use strict";
            Object.defineProperty(t, "__esModule", {
                value: !0
            });
            var i = n(0);
            t.default = function(e, t) {
                return new Promise(function(n, r) {
                    return i.__awaiter(void 0, void 0, void 0, function() {
                        var M, u, o, c, a;
                        return i.__generator(this, function(i) {
                            switch(i.label){
                                case 0:
                                    if (!t || !t.id) return [
                                        3,
                                        5
                                    ];
                                    i.label = 1;
                                case 1:
                                    return i.trys.push([
                                        1,
                                        3,
                                        ,
                                        4
                                    ]), M = t.id, u = t.network || "mainnet", o = t.config, [
                                        4,
                                        (c = new e(M, u, o)).provider.enable()
                                    ];
                                case 2:
                                    return i.sent(), c.provider._portis = c, n(c.provider), [
                                        3,
                                        4
                                    ];
                                case 3:
                                    return a = i.sent(), [
                                        2,
                                        r(a)
                                    ];
                                case 4:
                                    return [
                                        3,
                                        6
                                    ];
                                case 5:
                                    return [
                                        2,
                                        r(new Error("Missing Portis Id"))
                                    ];
                                case 6:
                                    return [
                                        2
                                    ];
                            }
                        });
                    });
                });
            };
        },
        function(e, t, n) {
            "use strict";
            Object.defineProperty(t, "__esModule", {
                value: !0
            });
            var i = n(0);
            t.default = function(e, t) {
                return i.__awaiter(void 0, void 0, void 0, function() {
                    var n, r, M;
                    return i.__generator(this, function(i) {
                        switch(i.label){
                            case 0:
                                if (!t || !t.key) return [
                                    3,
                                    7
                                ];
                                i.label = 1;
                            case 1:
                                return i.trys.push([
                                    1,
                                    5,
                                    ,
                                    6
                                ]), n = t.key, [
                                    4,
                                    (r = new e(n, t.network)).getProvider()
                                ];
                            case 2:
                                return (M = i.sent()).fm = r, [
                                    4,
                                    r.user.login()
                                ];
                            case 3:
                                return i.sent(), [
                                    4,
                                    r.user.isLoggedIn()
                                ];
                            case 4:
                                if (i.sent()) return [
                                    2,
                                    M
                                ];
                                throw new Error("Failed to login to Fortmatic");
                            case 5:
                                throw i.sent();
                            case 6:
                                return [
                                    3,
                                    8
                                ];
                            case 7:
                                throw new Error("Missing Fortmatic key");
                            case 8:
                                return [
                                    2
                                ];
                        }
                    });
                });
            };
        },
        function(e, t, n) {
            "use strict";
            Object.defineProperty(t, "__esModule", {
                value: !0
            });
            var i = n(0);
            t.default = function(e, t) {
                return i.__awaiter(void 0, void 0, void 0, function() {
                    return i.__generator(this, function(n) {
                        return [
                            2,
                            new Promise(function(n, r) {
                                return i.__awaiter(void 0, void 0, void 0, function() {
                                    var M, u, o, c, a, I, l, N;
                                    return i.__generator(this, function(j) {
                                        switch(j.label){
                                            case 0:
                                                return j.trys.push([
                                                    0,
                                                    3,
                                                    ,
                                                    4
                                                ]), M = {
                                                    host: "mainnet"
                                                }, u = void 0, M = t.networkParams || t.network ? i.__assign({
                                                    host: t.network
                                                }, t.networkParams) : M, [
                                                    4,
                                                    (o = new e({
                                                        buttonPosition: (null === (I = t.config) || void 0 === I ? void 0 : I.buttonPosition) || "bottom-left",
                                                        apiKey: (null === (l = t.config) || void 0 === l ? void 0 : l.apiKey) || "torus-default",
                                                        modalZIndex: (null === (N = t.config) || void 0 === N ? void 0 : N.modalZIndex) || 99999
                                                    })).init(i.__assign(i.__assign({
                                                        showTorusButton: !1
                                                    }, t.config), {
                                                        network: M
                                                    }))
                                                ];
                                            case 1:
                                                return j.sent(), t.loginParams && (u = t.loginParams.verifier), [
                                                    4,
                                                    o.login({
                                                        verifier: u
                                                    })
                                                ];
                                            case 2:
                                                return j.sent(), (c = o.provider).torus = o, n(c), [
                                                    3,
                                                    4
                                                ];
                                            case 3:
                                                return a = j.sent(), r(a), [
                                                    3,
                                                    4
                                                ];
                                            case 4:
                                                return [
                                                    2
                                                ];
                                        }
                                    });
                                });
                            })
                        ];
                    });
                });
            };
        },
        function(e, t, n) {
            "use strict";
            Object.defineProperty(t, "__esModule", {
                value: !0
            });
            var i = n(0);
            t.default = function(e, t) {
                return new Promise(function(e, n) {
                    return i.__awaiter(void 0, void 0, void 0, function() {
                        var r, M, u;
                        return i.__generator(this, function(i) {
                            switch(i.label){
                                case 0:
                                    if (!t || !t.clientId) return [
                                        3,
                                        5
                                    ];
                                    i.label = 1;
                                case 1:
                                    return i.trys.push([
                                        1,
                                        3,
                                        ,
                                        4
                                    ]), r = {
                                        clientId: t.clientId,
                                        secretType: t.secretType || "ETHEREUM",
                                        environment: t.environment,
                                        authenticationOptions: t.authenticationOptions,
                                        signMethod: "POPUP"
                                    }, [
                                        4,
                                        window.Venly.createProviderEngine(r)
                                    ];
                                case 2:
                                    return M = i.sent(), [
                                        2,
                                        e(M)
                                    ];
                                case 3:
                                    return u = i.sent(), console.error(u), [
                                        2,
                                        n(new Error("Failed to login to Venly"))
                                    ];
                                case 4:
                                    return [
                                        3,
                                        6
                                    ];
                                case 5:
                                    return [
                                        2,
                                        n(new Error("Please provide an Venly client id"))
                                    ];
                                case 6:
                                    return [
                                        2
                                    ];
                            }
                        });
                    });
                });
            };
        },
        function(e, t, n) {
            "use strict";
            Object.defineProperty(t, "__esModule", {
                value: !0
            });
            var i = n(0);
            t.default = function(e, t) {
                return void 0 === t && (t = {}), new Promise(function(n, r) {
                    return i.__awaiter(void 0, void 0, void 0, function() {
                        var M, u, o;
                        return i.__generator(this, function(c) {
                            switch(c.label){
                                case 0:
                                    return c.trys.push([
                                        0,
                                        2,
                                        ,
                                        3
                                    ]), M = new e(i.__assign(i.__assign({}, t), {
                                        networkName: t.networkName || t.network
                                    })), (u = M.getProvider()).authereum = M, [
                                        4,
                                        u.enable()
                                    ];
                                case 1:
                                    return c.sent(), n(u), [
                                        3,
                                        3
                                    ];
                                case 2:
                                    return o = c.sent(), [
                                        2,
                                        r(o)
                                    ];
                                case 3:
                                    return [
                                        2
                                    ];
                            }
                        });
                    });
                });
            };
        },
        function(e, t, n) {
            "use strict";
            Object.defineProperty(t, "__esModule", {
                value: !0
            });
            var i = n(0);
            t.default = function(e, t) {
                return i.__awaiter(void 0, void 0, void 0, function() {
                    var n;
                    return i.__generator(this, function(i) {
                        switch(i.label){
                            case 0:
                                return t.defaultNetwork = t.defaultNetwork || t.network, [
                                    4,
                                    (n = new e(t)).enable()
                                ];
                            case 1:
                                return i.sent(), [
                                    2,
                                    n
                                ];
                        }
                    });
                });
            };
        },
        function(e, t, n) {
            "use strict";
            Object.defineProperty(t, "__esModule", {
                value: !0
            });
            var i = n(0), r = n(3);
            t.default = function(e, t) {
                return new Promise(function(n, M) {
                    return i.__awaiter(void 0, void 0, void 0, function() {
                        var u, o, c, a, I, l, N;
                        return i.__generator(this, function(i) {
                            switch(i.label){
                                case 0:
                                    if (u = "", o = void 0, c = 1, t && (u = t.infuraId || "", o = t.rpc || void 0, t.infuraId && !o && (o = "wss://mainnet.infura.io/ws/v3/" + u), c = t.network && r.getChainId(t.network) ? r.getChainId(t.network) : 1), e.Provider.isConnected) return [
                                        3,
                                        4
                                    ];
                                    a = new e.Provider, I = a.makeWeb3Provider(c, o, !0), a.on("disconnected", function() {}), i.label = 1;
                                case 1:
                                    return i.trys.push([
                                        1,
                                        3,
                                        ,
                                        4
                                    ]), [
                                        4,
                                        a.enable()
                                    ];
                                case 2:
                                    return l = i.sent(), console.log(l), n(I), [
                                        3,
                                        4
                                    ];
                                case 3:
                                    return N = i.sent(), M(N), [
                                        3,
                                        4
                                    ];
                                case 4:
                                    return [
                                        2
                                    ];
                            }
                        });
                    });
                });
            };
        },
        function(e, t, n) {
            "use strict";
            Object.defineProperty(t, "__esModule", {
                value: !0
            });
            var i = n(0);
            t.default = function(e, t) {
                return i.__awaiter(void 0, void 0, void 0, function() {
                    var n;
                    return i.__generator(this, function(i) {
                        switch(i.label){
                            case 0:
                                return [
                                    4,
                                    (n = new e(t)).enable()
                                ];
                            case 1:
                                return i.sent(), [
                                    2,
                                    n
                                ];
                        }
                    });
                });
            };
        },
        function(e, t, n) {
            "use strict";
            Object.defineProperty(t, "__esModule", {
                value: !0
            });
            var i = n(0);
            t.default = function(e, t) {
                return i.__awaiter(void 0, void 0, void 0, function() {
                    var n;
                    return i.__generator(this, function(i) {
                        switch(i.label){
                            case 0:
                                return [
                                    4,
                                    (n = new e(t.clientId, t.callbackUrl, t.extraBitskiOptions)).signIn()
                                ];
                            case 1:
                                return i.sent(), [
                                    2,
                                    n.getProvider(t.extraProviderOptions)
                                ];
                        }
                    });
                });
            };
        },
        function(e, t, n) {
            "use strict";
            Object.defineProperty(t, "__esModule", {
                value: !0
            });
            var i = n(0);
            t.default = function(e) {
                return i.__awaiter(void 0, void 0, void 0, function() {
                    var t;
                    return i.__generator(this, function(n) {
                        try {
                            return (t = e("frame")).isFrameNative = !0, [
                                2,
                                t
                            ];
                        } catch (e) {
                            throw e;
                        }
                        return [
                            2
                        ];
                    });
                });
            };
        },
        function(e, t, n) {
            "use strict";
            Object.defineProperty(t, "__esModule", {
                value: !0
            });
            var i = n(0);
            t.default = function() {
                return i.__awaiter(void 0, void 0, void 0, function() {
                    var e;
                    return i.__generator(this, function(t) {
                        switch(t.label){
                            case 0:
                                if (e = null, void 0 === window.BinanceChain) return [
                                    3,
                                    5
                                ];
                                e = window.BinanceChain, t.label = 1;
                            case 1:
                                return t.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]), [
                                    4,
                                    e.request({
                                        method: "eth_requestAccounts"
                                    })
                                ];
                            case 2:
                                return t.sent(), [
                                    3,
                                    4
                                ];
                            case 3:
                                throw t.sent(), new Error("User Rejected");
                            case 4:
                                return [
                                    3,
                                    6
                                ];
                            case 5:
                                throw new Error("No Binance Chain Wallet found");
                            case 6:
                                return [
                                    2,
                                    e
                                ];
                        }
                    });
                });
            };
        },
        function(e, t, n) {
            "use strict";
            Object.defineProperty(t, "__esModule", {
                value: !0
            }), t.walletlink = void 0;
            var i = n(0), r = function(e, t) {
                return new Promise(function(n, r) {
                    return i.__awaiter(void 0, void 0, void 0, function() {
                        var M, u, o, c, a, I, l, N, j, g;
                        return i.__generator(this, function(i) {
                            switch(i.label){
                                case 0:
                                    u = (M = t || {}).infuraId || "", o = M.chainId || 1, c = M.appName || "", a = M.appLogoUrl, I = M.darkMode || !1, l = M.rpc || void 0, M.infuraId && !M.rpc && (l = "https://mainnet.infura.io/v3/" + u), N = new e({
                                        appName: c,
                                        appLogoUrl: a,
                                        darkMode: I
                                    }), i.label = 1;
                                case 1:
                                    return i.trys.push([
                                        1,
                                        3,
                                        ,
                                        4
                                    ]), [
                                        4,
                                        (j = N.makeWeb3Provider(l, o)).send("eth_requestAccounts")
                                    ];
                                case 2:
                                    return i.sent(), n(j), [
                                        3,
                                        4
                                    ];
                                case 3:
                                    return g = i.sent(), r(g), [
                                        3,
                                        4
                                    ];
                                case 4:
                                    return [
                                        2
                                    ];
                            }
                        });
                    });
                });
            };
            t.walletlink = r, t.default = r;
        },
        function(e, t, n) {
            "use strict";
            Object.defineProperty(t, "__esModule", {
                value: !0
            });
            var i = n(0);
            t.default = function(e, t) {
                return i.__awaiter(void 0, void 0, void 0, function() {
                    var n, r, M, u, o;
                    return i.__generator(this, function(i) {
                        switch(i.label){
                            case 0:
                                if (!(null === (o = null === window || void 0 === window ? void 0 : window.ethereum) || void 0 === o ? void 0 : o.isSequence)) return [
                                    3,
                                    4
                                ];
                                n = window.ethereum, i.label = 1;
                            case 1:
                                return i.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]), [
                                    4,
                                    n.request({
                                        method: "eth_requestAccounts"
                                    })
                                ];
                            case 2:
                                return i.sent(), [
                                    2,
                                    n
                                ];
                            case 3:
                                throw i.sent(), new Error("User Rejected");
                            case 4:
                                return i.trys.push([
                                    4,
                                    5,
                                    ,
                                    7
                                ]), r = e.getWallet(), [
                                    3,
                                    7
                                ];
                            case 5:
                                return i.sent(), M = {}, (null == t ? void 0 : t.networkRpcUrl) && (M = {
                                    networkRpcUrl: t.networkRpcUrl
                                }), [
                                    4,
                                    e.initWallet((null == t ? void 0 : t.defaultNetwork) || "mainnet", M)
                                ];
                            case 6:
                                return r = i.sent(), [
                                    3,
                                    7
                                ];
                            case 7:
                                return r.isConnected() ? [
                                    3,
                                    9
                                ] : [
                                    4,
                                    r.connect({
                                        app: null == t ? void 0 : t.appName,
                                        authorize: (null == t ? void 0 : t.authorize) || !1,
                                        keepWalletOpeneed: (null == t ? void 0 : t.keepWalletOpened) || !1
                                    })
                                ];
                            case 8:
                                if (!(u = i.sent()).connected) throw new Error("Failed to connect");
                                (null == t ? void 0 : t.onConnect) && t.onConnect(u), i.label = 9;
                            case 9:
                                return (n = r.getProvider()).sequence = r, (null == t ? void 0 : t.getSequenceWallet) && t.getSequenceWallet(r), [
                                    2,
                                    n
                                ];
                        }
                    });
                });
            };
        },
        function(e, t, n) {
            "use strict";
            Object.defineProperty(t, "__esModule", {
                value: !0
            });
            var i = n(0);
            t.default = function() {
                return i.__awaiter(void 0, void 0, void 0, function() {
                    var e;
                    return i.__generator(this, function(t) {
                        switch(t.label){
                            case 0:
                                if (e = null, void 0 === window.clover) return [
                                    3,
                                    5
                                ];
                                e = window.clover, t.label = 1;
                            case 1:
                                return t.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]), [
                                    4,
                                    e.request({
                                        method: "eth_requestAccounts"
                                    })
                                ];
                            case 2:
                                return t.sent(), [
                                    3,
                                    4
                                ];
                            case 3:
                                throw t.sent(), new Error("User Rejected");
                            case 4:
                                return [
                                    3,
                                    6
                                ];
                            case 5:
                                throw new Error("No CLV Wallet found");
                            case 6:
                                return [
                                    2,
                                    e
                                ];
                        }
                    });
                });
            };
        },
        function(e, t, n) {
            "use strict";
            Object.defineProperty(t, "__esModule", {
                value: !0
            });
            var i = n(0);
            t.default = function() {
                return i.__awaiter(void 0, void 0, void 0, function() {
                    var e, t;
                    return i.__generator(this, function(n) {
                        switch(n.label){
                            case 0:
                                if (e = null, void 0 === (null === (t = window.ethereum) || void 0 === t ? void 0 : t.isOpera)) return [
                                    3,
                                    5
                                ];
                                e = window.ethereum, n.label = 1;
                            case 1:
                                return n.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]), [
                                    4,
                                    e.request({
                                        method: "eth_requestAccounts"
                                    })
                                ];
                            case 2:
                                return n.sent(), [
                                    3,
                                    4
                                ];
                            case 3:
                                throw n.sent(), new Error("User Rejected");
                            case 4:
                                return [
                                    3,
                                    6
                                ];
                            case 5:
                                throw new Error("Opera not found");
                            case 6:
                                return [
                                    2,
                                    e
                                ];
                        }
                    });
                });
            };
        },
        function(e, t, n) {
            "use strict";
            Object.defineProperty(t, "__esModule", {
                value: !0
            });
            var i = n(0);
            t.default = function(e, t) {
                return i.__awaiter(void 0, void 0, void 0, function() {
                    return i.__generator(this, function(n) {
                        return [
                            2,
                            new Promise(function(n, r) {
                                return i.__awaiter(void 0, void 0, void 0, function() {
                                    var M, u, o, c, a, I, l;
                                    return i.__generator(this, function(i) {
                                        switch(i.label){
                                            case 0:
                                                return i.trys.push([
                                                    0,
                                                    3,
                                                    ,
                                                    4
                                                ]), u = (M = t || {}).chainId || "0x1", o = M.clientId || "localhostid", c = M.infuraId, a = new e({
                                                    chainConfig: {
                                                        chainNamespace: "eip155",
                                                        chainId: u,
                                                        rpcTarget: "https://mainnet.infura.io/v3/" + c
                                                    },
                                                    clientId: o
                                                }), console.log(a), [
                                                    4,
                                                    a.initModal()
                                                ];
                                            case 1:
                                                return i.sent(), [
                                                    4,
                                                    a.connect()
                                                ];
                                            case 2:
                                                return i.sent(), (I = a.provider).web3auth = a, n(I), [
                                                    3,
                                                    4
                                                ];
                                            case 3:
                                                return l = i.sent(), console.log(l), r(l), [
                                                    3,
                                                    4
                                                ];
                                            case 4:
                                                return [
                                                    2
                                                ];
                                        }
                                    });
                                });
                            })
                        ];
                    });
                });
            };
        },
        function(e, t, n) {
            "use strict";
            Object.defineProperty(t, "__esModule", {
                value: !0
            });
            var i = n(0);
            t.default = function() {
                return i.__awaiter(void 0, void 0, void 0, function() {
                    var e, t, n;
                    return i.__generator(this, function(i) {
                        switch(i.label){
                            case 0:
                                if (e = null, void 0 === (null === (t = null === window || void 0 === window ? void 0 : window.bitkeep) || void 0 === t ? void 0 : t.ethereum)) return [
                                    3,
                                    5
                                ];
                                e = null === (n = null === window || void 0 === window ? void 0 : window.bitkeep) || void 0 === n ? void 0 : n.ethereum, i.label = 1;
                            case 1:
                                return i.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]), console.log("ConnectToBitkeep"), [
                                    4,
                                    e.request({
                                        method: "eth_requestAccounts"
                                    })
                                ];
                            case 2:
                                return i.sent(), [
                                    3,
                                    4
                                ];
                            case 3:
                                throw i.sent(), new Error("User Rejected");
                            case 4:
                                return [
                                    3,
                                    6
                                ];
                            case 5:
                                if (!window.web3) throw new Error("No Web3 Provider found");
                                e = window.web3.currentProvider, i.label = 6;
                            case 6:
                                return [
                                    2,
                                    e
                                ];
                        }
                    });
                });
            };
        },
        function(e, t, n) {
            "use strict";
            Object.defineProperty(t, "__esModule", {
                value: !0
            });
            var i = n(0);
            t.default = function() {
                return i.__awaiter(void 0, void 0, void 0, function() {
                    var e;
                    return i.__generator(this, function(t) {
                        switch(t.label){
                            case 0:
                                return e = null, [
                                    4,
                                    new Promise(function(e) {
                                        return setTimeout(e, 1e3);
                                    })
                                ];
                            case 1:
                                if (t.sent(), void 0 === window.starzwallet) return [
                                    3,
                                    6
                                ];
                                e = window.starzwallet, t.label = 2;
                            case 2:
                                return t.trys.push([
                                    2,
                                    4,
                                    ,
                                    5
                                ]), [
                                    4,
                                    e.request({
                                        method: "eth_requestAccounts"
                                    })
                                ];
                            case 3:
                                return t.sent(), [
                                    3,
                                    5
                                ];
                            case 4:
                                throw t.sent(), new Error("User Rejected");
                            case 5:
                                return [
                                    3,
                                    7
                                ];
                            case 6:
                                throw new Error("No 99Starz Wallet found");
                            case 7:
                                return [
                                    2,
                                    e
                                ];
                        }
                    });
                });
            };
        },
        function(e, t, n) {
            "use strict";
            Object.defineProperty(t, "__esModule", {
                value: !0
            });
            var i = n(0);
            t.default = function(e, t) {
                return i.__awaiter(void 0, void 0, void 0, function() {
                    return i.__generator(this, function(n) {
                        return [
                            2,
                            new Promise(function(n, r) {
                                return i.__awaiter(void 0, void 0, void 0, function() {
                                    var M, u, o;
                                    return i.__generator(this, function(c) {
                                        switch(c.label){
                                            case 0:
                                                return c.trys.push([
                                                    0,
                                                    3,
                                                    ,
                                                    4
                                                ]), [
                                                    4,
                                                    e()
                                                ];
                                            case 1:
                                                return (M = c.sent()).checkSupport(i.__assign({
                                                    providerType: "Ethereum"
                                                }, t)), [
                                                    4,
                                                    M.getProvider()
                                                ];
                                            case 2:
                                                return (u = c.sent()).request({
                                                    method: "eth_requestAccounts"
                                                }), [
                                                    2,
                                                    n(u)
                                                ];
                                            case 3:
                                                return o = c.sent(), [
                                                    2,
                                                    r(o)
                                                ];
                                            case 4:
                                                return [
                                                    2
                                                ];
                                        }
                                    });
                                });
                            })
                        ];
                    });
                });
            };
        },
        function(e, t, n) {
            "use strict";
            Object.defineProperty(t, "__esModule", {
                value: !0
            });
            var i = n(0);
            t.default = function(e, t) {
                return i.__awaiter(void 0, void 0, void 0, function() {
                    var e, n, r;
                    return i.__generator(this, function(i) {
                        switch(i.label){
                            case 0:
                                if (e = null, void 0 === (null === (n = window.phantom) || void 0 === n ? void 0 : n[t.networkType])) return [
                                    3,
                                    5
                                ];
                                e = null === (r = window.phantom) || void 0 === r ? void 0 : r[t.networkType], i.label = 1;
                            case 1:
                                return i.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]), [
                                    4,
                                    e.request({
                                        method: "eth_requestAccounts"
                                    })
                                ];
                            case 2:
                                return i.sent(), [
                                    3,
                                    4
                                ];
                            case 3:
                                throw i.sent();
                            case 4:
                                return [
                                    3,
                                    6
                                ];
                            case 5:
                                throw new Error("phantom wallet not found");
                            case 6:
                                return [
                                    2,
                                    e
                                ];
                        }
                    });
                });
            };
        },
        function(e, t) {
            e.exports = "data:image/svg+xml;base64,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";
        },
        function(e, t) {
            e.exports = "data:image/svg+xml;base64,PHN2ZyBoZWlnaHQ9IjM1NSIgdmlld0JveD0iMCAwIDM5NyAzNTUiIHdpZHRoPSIzOTciIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGcgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMSAtMSkiPjxwYXRoIGQ9Im0xMTQuNjIyNjQ0IDMyNy4xOTU0NzIgNTIuMDA0NzE3IDEzLjgxMDE5OHYtMTguMDU5NDlsNC4yNDUyODMtNC4yNDkyOTJoMjkuNzE2OTgydjIxLjI0NjQ1OSAxNC44NzI1MjNoLTMxLjgzOTYyNGwtMzkuMjY4ODY4LTE2Ljk5NzE2OXoiIGZpbGw9IiNjZGJkYjIiLz48cGF0aCBkPSJtMTk5LjUyODMwNSAzMjcuMTk1NDcyIDUwLjk0MzM5NyAxMy44MTAxOTh2LTE4LjA1OTQ5bDQuMjQ1MjgzLTQuMjQ5MjkyaDI5LjcxNjk4MXYyMS4yNDY0NTkgMTQuODcyNTIzaC0zMS44Mzk2MjNsLTM5LjI2ODg2OC0xNi45OTcxNjl6IiBmaWxsPSIjY2RiZGIyIiB0cmFuc2Zvcm09Im1hdHJpeCgtMSAwIDAgMSA0ODMuOTYyMjcgMCkiLz48cGF0aCBkPSJtMTcwLjg3MjY0NCAyODcuODg5NTIzLTQuMjQ1MjgzIDM1LjA1NjY1NyA1LjMwNjYwNC00LjI0OTI5Mmg1NS4xODg2OGw2LjM2NzkyNSA0LjI0OTI5Mi00LjI0NTI4NC0zNS4wNTY2NTctOC40OTA1NjUtNS4zMTE2MTUtNDIuNDUyODMyIDEuMDYyMzIzeiIgZmlsbD0iIzM5MzkzOSIvPjxwYXRoIGQ9Im0xNDIuMjE2OTg0IDUwLjk5MTUwMjIgMjUuNDcxNjk4IDU5LjQ5MDA4NTggMTEuNjc0NTI4IDE3My4xNTg2NDNoNDEuMzkxNTExbDEyLjczNTg0OS0xNzMuMTU4NjQzIDIzLjM0OTA1Ni01OS40OTAwODU4eiIgZmlsbD0iI2Y4OWMzNSIvPjxwYXRoIGQ9Im0zMC43NzgzMDIzIDE4MS42NTcyMjYtMjkuNzE2OTgxNTMgODYuMDQ4MTYxIDc0LjI5MjQ1MzkzLTQuMjQ5MjkzaDQ3Ljc1OTQzNDN2LTM3LjE4MTMwM2wtMi4xMjI2NDEtNzYuNDg3MjUzLTEwLjYxMzIwOCA4LjQ5ODU4M3oiIGZpbGw9IiNmODlkMzUiLz48cGF0aCBkPSJtODcuMDI4MzAzMiAxOTEuMjE4MTM0IDg3LjAyODMwMjggMi4xMjQ2NDYtOS41NTE4ODYgNDQuNjE3NTYzLTQxLjM5MTUxMS0xMC42MjMyMjl6IiBmaWxsPSIjZDg3YzMwIi8+PHBhdGggZD0ibTg3LjAyODMwMzIgMTkyLjI4MDQ1NyAzNi4wODQ5MDU4IDMzLjk5NDMzNHYzMy45OTQzMzR6IiBmaWxsPSIjZWE4ZDNhIi8+PHBhdGggZD0ibTEyMy4xMTMyMDkgMjI3LjMzNzExNCA0Mi40NTI4MzEgMTAuNjIzMjI5IDEzLjc5NzE3IDQ1LjY3OTg4OC05LjU1MTg4NiA1LjMxMTYxNS00Ni42OTgxMTUtMjcuNjIwMzk4eiIgZmlsbD0iI2Y4OWQzNSIvPjxwYXRoIGQ9Im0xMjMuMTEzMjA5IDI2MS4zMzE0NDgtOC40OTA1NjUgNjUuODY0MDI0IDU2LjI1LTM5LjMwNTk0OXoiIGZpbGw9IiNlYjhmMzUiLz48cGF0aCBkPSJtMTc0LjA1NjYwNiAxOTMuMzQyNzggNS4zMDY2MDQgOTAuMjk3NDUxLTE1LjkxOTgxMi00Ni4yMTEwNDl6IiBmaWxsPSIjZWE4ZTNhIi8+PHBhdGggZD0ibTc0LjI5MjQ1MzkgMjYyLjM5Mzc3MSA0OC44MjA3NTUxLTEuMDYyMzIzLTguNDkwNTY1IDY1Ljg2NDAyNHoiIGZpbGw9IiNkODdjMzAiLz48cGF0aCBkPSJtMjQuNDEwMzc3NyAzNTUuODc4MTkzIDkwLjIxMjI2NjMtMjguNjgyNzIxLTQwLjMzMDE5MDEtNjQuODAxNzAxLTczLjIzMTEzMzEzIDUuMzExNjE2eiIgZmlsbD0iI2ViOGYzNSIvPjxwYXRoIGQ9Im0xNjcuNjg4NjgyIDExMC40ODE1ODgtNDUuNjM2NzkzIDM4LjI0MzYyNy0zNS4wMjM1ODU4IDQyLjQ5MjkxOSA4Ny4wMjgzMDI4IDMuMTg2OTY5eiIgZmlsbD0iI2U4ODIxZSIvPjxwYXRoIGQ9Im0xMTQuNjIyNjQ0IDMyNy4xOTU0NzIgNTYuMjUtMzkuMzA1OTQ5LTQuMjQ1MjgzIDMzLjk5NDMzNHYxOS4xMjE4MTNsLTM4LjIwNzU0OC03LjQzNjI2eiIgZmlsbD0iI2RmY2VjMyIvPjxwYXRoIGQ9Im0yMjkuMjQ1Mjg2IDMyNy4xOTU0NzIgNTUuMTg4NjgtMzkuMzA1OTQ5LTQuMjQ1MjgzIDMzLjk5NDMzNHYxOS4xMjE4MTNsLTM4LjIwNzU0OC03LjQzNjI2eiIgZmlsbD0iI2RmY2VjMyIgdHJhbnNmb3JtPSJtYXRyaXgoLTEgMCAwIDEgNTEzLjY3OTI1MiAwKSIvPjxwYXRoIGQ9Im0xMzIuNjY1MDk2IDIxMi40NjQ1OTMtMTEuNjc0NTI4IDI0LjQzMzQyNyA0MS4zOTE1MS0xMC42MjMyMjl6IiBmaWxsPSIjMzkzOTM5IiB0cmFuc2Zvcm09Im1hdHJpeCgtMSAwIDAgMSAyODMuMzcyNjQ2IDApIi8+PHBhdGggZD0ibTIzLjM0OTA1NyAxLjA2MjMyMjk2IDE0NC4zMzk2MjUgMTA5LjQxOTI2NTA0LTI0LjQxMDM3OC01OS40OTAwODU4eiIgZmlsbD0iI2U4OGYzNSIvPjxwYXRoIGQ9Im0yMy4zNDkwNTcgMS4wNjIzMjI5Ni0xOS4xMDM3NzM5MiA1OC40Mjc3NjI5NCAxMC42MTMyMDc3MiA2My43MzkzNzgxLTcuNDI5MjQ1NDEgNC4yNDkyOTIgMTAuNjEzMjA3NzEgOS41NjA5MDYtOC40OTA1NjYxNyA3LjQzNjI2MSAxMS42NzQ1Mjg0NyAxMC42MjMyMjktNy40MjkyNDU0IDYuMzczOTM4IDE2Ljk4MTEzMjMgMjEuMjQ2NDU5IDc5LjU5OTA1NzctMjQuNDMzNDI4YzM4LjkxNTA5Ni0zMS4xNjE0NzMgNTguMDE4ODY5LTQ3LjA5NjMxOCA1Ny4zMTEzMjItNDcuODA0NTMzLS43MDc1NDgtLjcwODIxNS00OC44MjA3NTYtMzcuMTgxMzAzNi0xNDQuMzM5NjI1LTEwOS40MTkyNjUwNHoiIGZpbGw9IiM4ZTVhMzAiLz48ZyB0cmFuc2Zvcm09Im1hdHJpeCgtMSAwIDAgMSAzOTkuMDU2NjExIDApIj48cGF0aCBkPSJtMzAuNzc4MzAyMyAxODEuNjU3MjI2LTI5LjcxNjk4MTUzIDg2LjA0ODE2MSA3NC4yOTI0NTM5My00LjI0OTI5M2g0Ny43NTk0MzQzdi0zNy4xODEzMDNsLTIuMTIyNjQxLTc2LjQ4NzI1My0xMC42MTMyMDggOC40OTg1ODN6IiBmaWxsPSIjZjg5ZDM1Ii8+PHBhdGggZD0ibTg3LjAyODMwMzIgMTkxLjIxODEzNCA4Ny4wMjgzMDI4IDIuMTI0NjQ2LTkuNTUxODg2IDQ0LjYxNzU2My00MS4zOTE1MTEtMTAuNjIzMjI5eiIgZmlsbD0iI2Q4N2MzMCIvPjxwYXRoIGQ9Im04Ny4wMjgzMDMyIDE5Mi4yODA0NTcgMzYuMDg0OTA1OCAzMy45OTQzMzR2MzMuOTk0MzM0eiIgZmlsbD0iI2VhOGQzYSIvPjxwYXRoIGQ9Im0xMjMuMTEzMjA5IDIyNy4zMzcxMTQgNDIuNDUyODMxIDEwLjYyMzIyOSAxMy43OTcxNyA0NS42Nzk4ODgtOS41NTE4ODYgNS4zMTE2MTUtNDYuNjk4MTE1LTI3LjYyMDM5OHoiIGZpbGw9IiNmODlkMzUiLz48cGF0aCBkPSJtMTIzLjExMzIwOSAyNjEuMzMxNDQ4LTguNDkwNTY1IDY1Ljg2NDAyNCA1NS4xODg2OC0zOC4yNDM2MjZ6IiBmaWxsPSIjZWI4ZjM1Ii8+PHBhdGggZD0ibTE3NC4wNTY2MDYgMTkzLjM0Mjc4IDUuMzA2NjA0IDkwLjI5NzQ1MS0xNS45MTk4MTItNDYuMjExMDQ5eiIgZmlsbD0iI2VhOGUzYSIvPjxwYXRoIGQ9Im03NC4yOTI0NTM5IDI2Mi4zOTM3NzEgNDguODIwNzU1MS0xLjA2MjMyMy04LjQ5MDU2NSA2NS44NjQwMjR6IiBmaWxsPSIjZDg3YzMwIi8+PHBhdGggZD0ibTI0LjQxMDM3NzcgMzU1Ljg3ODE5MyA5MC4yMTIyNjYzLTI4LjY4MjcyMS00MC4zMzAxOTAxLTY0LjgwMTcwMS03My4yMzExMzMxMyA1LjMxMTYxNnoiIGZpbGw9IiNlYjhmMzUiLz48cGF0aCBkPSJtMTY3LjY4ODY4MiAxMTAuNDgxNTg4LTQ1LjYzNjc5MyAzOC4yNDM2MjctMzUuMDIzNTg1OCA0Mi40OTI5MTkgODcuMDI4MzAyOCAzLjE4Njk2OXoiIGZpbGw9IiNlODgyMWUiLz48cGF0aCBkPSJtMTMyLjY2NTA5NiAyMTIuNDY0NTkzLTExLjY3NDUyOCAyNC40MzM0MjcgNDEuMzkxNTEtMTAuNjIzMjI5eiIgZmlsbD0iIzM5MzkzOSIgdHJhbnNmb3JtPSJtYXRyaXgoLTEgMCAwIDEgMjgzLjM3MjY0NiAwKSIvPjxwYXRoIGQ9Im0yMy4zNDkwNTcgMS4wNjIzMjI5NiAxNDQuMzM5NjI1IDEwOS40MTkyNjUwNC0yNC40MTAzNzgtNTkuNDkwMDg1OHoiIGZpbGw9IiNlODhmMzUiLz48cGF0aCBkPSJtMjMuMzQ5MDU3IDEuMDYyMzIyOTYtMTkuMTAzNzczOTIgNTguNDI3NzYyOTQgMTAuNjEzMjA3NzIgNjMuNzM5Mzc4MS03LjQyOTI0NTQxIDQuMjQ5MjkyIDEwLjYxMzIwNzcxIDkuNTYwOTA2LTguNDkwNTY2MTcgNy40MzYyNjEgMTEuNjc0NTI4NDcgMTAuNjIzMjI5LTcuNDI5MjQ1NCA2LjM3MzkzOCAxNi45ODExMzIzIDIxLjI0NjQ1OSA3OS41OTkwNTc3LTI0LjQzMzQyOGMzOC45MTUwOTYtMzEuMTYxNDczIDU4LjAxODg2OS00Ny4wOTYzMTggNTcuMzExMzIyLTQ3LjgwNDUzMy0uNzA3NTQ4LS43MDgyMTUtNDguODIwNzU2LTM3LjE4MTMwMzYtMTQ0LjMzOTYyNS0xMDkuNDE5MjY1MDR6IiBmaWxsPSIjOGU1YTMwIi8+PC9nPjwvZz48L3N2Zz4=";
        },
        function(e, t) {
            e.exports = "data:image/svg+xml;base64,PHN2ZyBpZD0iTGF5ZXJfMSIgZGF0YS1uYW1lPSJMYXllciAxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA0NDAgNDQwIj48ZGVmcz48c3R5bGU+LmNscy0xe2ZpbGw6IzAwOGM3Mzt9PC9zdHlsZT48L2RlZnM+PHRpdGxlPnNhbnNfd2hpdGUgY29weTwvdGl0bGU+PHBhdGggY2xhc3M9ImNscy0xIiBkPSJNMjIwLDkuODJDMTAzLjkyLDkuODIsOS44MiwxMDMuOTIsOS44MiwyMjBTMTAzLjkyLDQzMC4xOCwyMjAsNDMwLjE4LDQzMC4xOCwzMzYuMDgsNDMwLjE4LDIyMCwzMzYuMDgsOS44MiwyMjAsOS44MlpNMzczLjgzLDIzMS40N0gyNzYuM2E1OS40MSw1OS40MSwwLDEsMSwuNDUtMjAuNjdoOTcuMDhhMTAuMzQsMTAuMzQsMCwxLDEsMCwyMC42N1oiLz48L3N2Zz4=";
        },
        function(e, t) {
            e.exports = "data:image/png;base64,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";
        },
        function(e, t) {
            e.exports = "data:image/svg+xml;base64,PHN2ZyBlbmFibGUtYmFja2dyb3VuZD0ibmV3IDAgMCAxNTguOCAxODQiIHZpZXdCb3g9IjAgMCAxNTguOCAxODQiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMzU0IDM1MSkiPjxwYXRoIGQ9Im0tMjc0LjYtMzQzLjdjMjkuMyAyMi43IDYyLjkgMjEuMyA3Mi41IDIxLjMtMi4xIDEyOS4xLTE4LjEgMTExLjktNzIuNSAxNDguMS01NC40LTM2LjItNzAuMy0xOS03Mi40LTE0OC4xIDkuNSAwIDQzIDEuNCA3Mi40LTIxLjN6IiBmaWxsPSIjZmZmIi8+PHBhdGggZD0ibS0yNzQuNi0zNDMuNyA0LjItNS41Yy0yLjUtMS45LTYtMS45LTguNSAwem03Mi41IDIxLjMgNi45LjFjMC0xLjktLjctMy42LTItNS0xLjMtMS4zLTMuMS0yLjEtNC45LTIuMXptLTcyLjUgMTQ4LjEtMy44IDUuOGMyLjMgMS41IDUuMyAxLjUgNy43IDB6bS03Mi40LTE0OC4xdi02LjljLTEuOSAwLTMuNi43LTQuOSAyLjEtMS4zIDEuMy0yIDMuMS0yIDV6bTY4LjEtMTUuOGMzMS40IDI0LjMgNjcuMyAyMi43IDc2LjcgMjIuN3YtMTMuOGMtOS44IDAtNDEuMSAxLjItNjguMy0xOS45em02OS44IDE1LjdjLS41IDMyLjEtMS45IDU0LjgtNC41IDcxLjYtMi42IDE2LjYtNi4yIDI2LjYtMTEgMzMuNi00LjggNy4zLTEwLjggMTEuNi0xOS43IDE2LjktOSA1LjQtMjAuMyAxMS4yLTM0LjMgMjAuNGw3LjcgMTEuNWMxMy4zLTguOCAyNC4zLTE0LjUgMzMuNy0yMC4xIDkuNS01LjcgMTcuOC0xMS45IDI0LjEtMjEgNi4zLTkuNCAxMC41LTIxLjYgMTMuMi0zOS4yIDIuNy0xNy40IDQuMS00MSA0LjYtNzMuNXptLTYxLjcgMTQyLjRjLTEzLjktOS4zLTI1LjMtMTUuMS0zNC4yLTIwLjRzLTE0LjktOS42LTE5LjctMTYuOWMtNC43LTctOC40LTE2LjktMTAuOS0zMy42LTIuNi0xNi44LTMuOS0zOS40LTQuNS03MS42bC0xMy45LjNjLjUgMzIuNCAyIDU2IDQuNiA3My41IDIuNyAxNy42IDYuOCAyOS44IDEzLjEgMzkuMiA2LjMgOS4xIDE0LjYgMTUuMyAyNCAyMSA5LjQgNS42IDIwLjQgMTEuMiAzMy43IDIwLjF6bS03Ni4yLTEzNS40YzkuMyAwIDQ1LjMgMS42IDc2LjYtMjIuN2wtOC40LTExYy0yNy4yIDIxLjEtNTguNSAxOS45LTY4LjIgMTkuOXoiIGZpbGw9IiMzMzc1YmIiLz48L2c+PC9zdmc+";
        },
        function(e, t) {
            e.exports = "data:image/png;base64,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";
        },
        function(e, t) {
            e.exports = "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMTI4IDEyOCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+PGRlZnM+PGNpcmNsZSBpZD0iYSIgY3g9IjU5LjkyOCIgY3k9IjU5LjkyOCIgcj0iNTkuOTI4Ii8+PGxpbmVhckdyYWRpZW50IHgxPSI1MCUiIHkxPSIwJSIgeDI9IjUwJSIgeTI9IjEwMCUiIGlkPSJjIj48c3RvcCBzdG9wLWNvbG9yPSIjMkU2NkY4IiBvZmZzZXQ9IjAlIi8+PHN0b3Agc3RvcC1jb2xvcj0iIzEyNEFEQiIgb2Zmc2V0PSIxMDAlIi8+PC9saW5lYXJHcmFkaWVudD48L2RlZnM+PGcgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj48cGF0aCBmaWxsPSIjRkZGIiBmaWxsLXJ1bGU9Im5vbnplcm8iIGQ9Ik0wIDBoMTI4djEyOEgweiIvPjxwYXRoIGZpbGw9IiNGRkYiIGZpbGwtcnVsZT0ibm9uemVybyIgZD0iTTAgMGgxMjh2MTI4SDB6Ii8+PHBhdGggZD0iTTAgMGgxMjh2MTI4SDB6Ii8+PHBhdGggZD0iTTE5IDY0YzAgMjQuODUzIDIwLjE0NyA0NSA0NSA0NXM0NS0yMC4xNDcgNDUtNDUtMjAuMTQ3LTQ1LTQ1LTQ1LTQ1IDIwLjE0Ny00NSA0NXptMzMuNS0xNC41YTMgMyAwIDAgMC0zIDN2MjNhMyAzIDAgMCAwIDMgM2gyM2EzIDMgMCAwIDAgMy0zdi0yM2EzIDMgMCAwIDAtMy0zaC0yM3oiIGZpbGw9IiNGRkYiLz48ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSg0IDQpIj48bWFzayBpZD0iYiIgZmlsbD0iI2ZmZiI+PHVzZSB4bGluazpocmVmPSIjYSIvPjwvbWFzaz48ZyBtYXNrPSJ1cmwoI2IpIj48cGF0aCBkPSJNMCAwaDExOS44NTZ2MTE5Ljg1NkgweiIvPjxyZWN0IGZpbGw9InVybCgjYykiIGZpbGwtcnVsZT0ibm9uemVybyIgd2lkdGg9IjExOS44NTYiIGhlaWdodD0iMTE5Ljg1NiIgcng9IjQ4Ii8+PHBhdGggZD0iTTI0Ljk3IDU5LjkyOGMwIDE5LjMwNyAxNS42NTEgMzQuOTU4IDM0Ljk1OCAzNC45NThzMzQuOTU4LTE1LjY1MSAzNC45NTgtMzQuOTU4Uzc5LjIzNSAyNC45NyA1OS45MjggMjQuOTcgMjQuOTcgNDAuNjIgMjQuOTcgNTkuOTI4em0yNi4wMjQtMTEuMjY0YTIuMzMgMi4zMyAwIDAgMC0yLjMzIDIuMzN2MTcuODY4YTIuMzMgMi4zMyAwIDAgMCAyLjMzIDIuMzNoMTcuODY4YTIuMzMgMi4zMyAwIDAgMCAyLjMzLTIuMzNWNTAuOTk0YTIuMzMgMi4zMyAwIDAgMC0yLjMzLTIuMzNINTAuOTk0eiIgZmlsbD0iI0ZGRiIvPjwvZz48L2c+PC9nPjwvc3ZnPg==";
        },
        function(e, t) {
            e.exports = "data:image/svg+xml;base64,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";
        },
        function(e, t) {
            e.exports = "data:image/svg+xml;base64,PHN2ZyBlbmFibGUtYmFja2dyb3VuZD0ibmV3IDAgMCA2NCA2NCIgdmlld0JveD0iMCAwIDY0IDY0IiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIj48bGluZWFyR3JhZGllbnQgaWQ9ImEiIGdyYWRpZW50VHJhbnNmb3JtPSJtYXRyaXgoMjMuOTg2NiAwIDAgLTE2Ljk0NiA2NTk3LjEzNTMgNTY5NS40OTA3KSIgZ3JhZGllbnRVbml0cz0idXNlclNwYWNlT25Vc2UiIHgxPSItMjcyLjUyNzIiIHgyPSItMjc1LjEyMDciIHkxPSIzMzUuNTUzMiIgeTI9IjMzMi45NTk3Ij48c3RvcCBvZmZzZXQ9IjAiIHN0b3AtY29sb3I9IiMxMWM0ZDEiLz48c3RvcCBvZmZzZXQ9IjEiIHN0b3AtY29sb3I9IiMwMDYyYWQiLz48L2xpbmVhckdyYWRpZW50PjxwYXRoIGQ9Im02My44IDEwLjljMi4xIDI4LjYtMTYuMiA0Mi4xLTMyLjcgNDMuNi0xNS4zIDEuMy0yOS43LTguMS0zMS0yMi41LTEtMTEuOSA2LjMtMTcgMTIuMS0xNy41IDYtLjUgMTEgMy42IDExLjQgOC42LjQgNC44LTIuNiA3LTQuNiA3LjItMS42LjEtMy43LS45LTMuOS0zLS4yLTEuOC41LTIuMS40LTQtLjMtMy41LTMuMy0zLjktNS0zLjctMiAuMi01LjcgMi41LTUuMSA4LjQuNSA1LjkgNi4yIDEwLjYgMTMuNiA5LjkgOC0uNyAxMy42LTYuOSAxNC0xNS43IDAtLjUuMS0uOS4zLTEuMy4xLS4yLjItLjQuMy0uNS4yLS4zLjQtLjUuNy0uOC4yLS4yLjUtLjUuNy0uOCAzLjUtMy4zIDE2LjEtMTEuMSAyOC04LjYuNC0uMi44LjIuOC43IiBmaWxsPSJ1cmwoI2EpIi8+PC9zdmc+";
        },
        function(e, t) {
            e.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMDAwIiBoZWlnaHQ9IjIwMDAiPjxjaXJjbGUgY3g9IjEwMDAiIGN5PSIxMDAwIiByPSIxMDAwIiBmaWxsPSIjNWI2ZGVlIi8+PHBhdGggZD0iTTgzMS4yNyA5MzguNzlhNTcxLjUgNTcxLjUgMCAwIDAtMTA0IDguOTVjMjguMjUtMjYxLjI4IDI0Ni00NTkuMTIgNTA1LjI0LTQ1OS4xIDE1OC43MyAwIDI2Ny40OSA3Ny43MiAyNjcuNDkgMjM4LjY0cy0xMzAuNTQgMjM4LjY0LTMyMSAyMzguNjRjLTE0MC41OC0uMDEtMjA3LjEzLTI3LjEzLTM0Ny43My0yNy4xM20tMTAuMjcgOTUuM2MtMTkwLjQ1IDAtMzIxIDc3LjcyLTMyMSAyMzguNjRzMTA4Ljc2IDIzOC42NCAyNjcuNDkgMjM4LjY0YzI1OS4yNyAwIDQ3Ny0xOTcuODIgNTA1LjI0LTQ1OS4xYTU3MS41IDU3MS41IDAgMCAxLTEwNCA4Ljk1Yy0xNDAuNi0uMDEtMjA3LjE1LTI3LjEzLTM0Ny43My0yNy4xMyIgZmlsbD0iI2ZmZiIvPjwvc3ZnPg==";
        },
        function(e, t) {
            e.exports = "data:image/png;base64,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";
        },
        function(e, t) {
            e.exports = "data:image/png;base64,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";
        },
        function(e, t) {
            e.exports = "data:image/svg+xml;base64,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";
        },
        function(e, t) {
            e.exports = "data:image/png;base64,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";
        },
        function(e, t) {
            e.exports = "data:image/svg+xml;base64,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";
        },
        function(e, t) {
            e.exports = "data:image/svg+xml;base64,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";
        },
        function(e, t) {
            e.exports = "data:image/svg+xml;base64,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";
        },
        function(e, t) {
            e.exports = "data:image/svg+xml;base64,PHN2ZyBpZD0iQ2Vsb19SaW5ncyIgZGF0YS1uYW1lPSJDZWxvIFJpbmdzIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA5NTAgOTUwIj48ZGVmcz48c3R5bGU+LmNscy0xe2ZpbGw6I2ZiY2M1Yzt9LmNscy0ye2ZpbGw6IzM1ZDA3Zjt9LmNscy0ze2ZpbGw6IzVlYTMzYjt9PC9zdHlsZT48L2RlZnM+PHRpdGxlPkFydGJvYXJkIDE8L3RpdGxlPjxwYXRoIGlkPSJCb3R0b21fUmluZyIgZGF0YS1uYW1lPSJCb3R0b20gUmluZyIgY2xhc3M9ImNscy0xIiBkPSJNMzc1LDg1MGMxNTEuODgsMCwyNzUtMTIzLjEyLDI3NS0yNzVTNTI2Ljg4LDMwMCwzNzUsMzAwLDEwMCw0MjMuMTIsMTAwLDU3NSwyMjMuMTIsODUwLDM3NSw4NTBabTAsMTAwQzE2Ny45LDk1MCwwLDc4Mi4xLDAsNTc1UzE2Ny45LDIwMCwzNzUsMjAwLDc1MCwzNjcuOSw3NTAsNTc1LDU4Mi4xLDk1MCwzNzUsOTUwWiIvPjxwYXRoIGlkPSJUb3BfUmluZyIgZGF0YS1uYW1lPSJUb3AgUmluZyIgY2xhc3M9ImNscy0yIiBkPSJNNTc1LDY1MGMxNTEuODgsMCwyNzUtMTIzLjEyLDI3NS0yNzVTNzI2Ljg4LDEwMCw1NzUsMTAwLDMwMCwyMjMuMTIsMzAwLDM3NSw0MjMuMTIsNjUwLDU3NSw2NTBabTAsMTAwYy0yMDcuMSwwLTM3NS0xNjcuOS0zNzUtMzc1UzM2Ny45LDAsNTc1LDAsOTUwLDE2Ny45LDk1MCwzNzUsNzgyLjEsNzUwLDU3NSw3NTBaIi8+PHBhdGggaWQ9IlJpbmdzX092ZXJsYXAiIGRhdGEtbmFtZT0iUmluZ3MgT3ZlcmxhcCIgY2xhc3M9ImNscy0zIiBkPSJNNTg3LjM5LDc1MGEyNzQuMzgsMjc0LjM4LDAsMCwwLDU0LjU1LTEwOC4wNkEyNzQuMzYsMjc0LjM2LDAsMCwwLDc1MCw1ODcuNGEzNzMuNjMsMzczLjYzLDAsMCwxLTI5LjE2LDEzMy40NUEzNzMuNjIsMzczLjYyLDAsMCwxLDU4Ny4zOSw3NTBaTTMwOC4wNiwzMDguMDZBMjc0LjM2LDI3NC4zNiwwLDAsMCwyMDAsMzYyLjZhMzczLjYzLDM3My42MywwLDAsMSwyOS4xNi0xMzMuNDVBMzczLjYyLDM3My42MiwwLDAsMSwzNjIuNjEsMjAwLDI3NC4zOCwyNzQuMzgsMCwwLDAsMzA4LjA2LDMwOC4wNloiLz48L3N2Zz4=";
        },
        function(e, t) {
            e.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDg2IiBoZWlnaHQ9IjQ4NiIgdmlld0JveD0iMCAwIDQ4NiA0ODYiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxyZWN0IHdpZHRoPSI0ODYiIGhlaWdodD0iNDg2IiBmaWxsPSJ3aGl0ZSIvPgo8cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTI0MyA0ODZDMzc3LjIwNSA0ODYgNDg2IDM3Ny4yMDUgNDg2IDI0M0M0ODYgMTA4Ljc5NSAzNzcuMjA1IDAgMjQzIDBDMTA4Ljc5NSAwIDAgMTA4Ljc5NSAwIDI0M0MwIDM3Ny4yMDUgMTA4Ljc5NSA0ODYgMjQzIDQ4NlpNMzc4IDEwOEgxMDhWMzc4SDM3OFYxMDhaIiBmaWxsPSIjMEExMjFFIi8+Cjwvc3ZnPgo=";
        },
        function(e, t) {
            e.exports = "data:image/svg+xml;base64,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";
        },
        function(e, t) {
            e.exports = "data:image/svg+xml;base64,PHN2ZyBpZD0ibG9nby1yaXBpby1wb3J0YWwiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgd2lkdGg9IjMyIiBoZWlnaHQ9IjMyIiB2aWV3Qm94PSIwIDAgMzIgMzIiPgogIDxwYXRoIGlkPSJjb250YWluZXIiIGQ9Ik0zMiwxNkExNiwxNiwwLDEsMSwxNiwwLDE2LDE2LDAsMCwxLDMyLDE2IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgwIDApIiBmaWxsPSIjNjRmZmI1Ii8+CiAgPHBhdGggaWQ9ImlzbyIgZD0iTTc0LjA4LDYwLjA1NmwtMTIuMTY4LDQuOVY1My4zNjVsMTIuMTg4LTQuOVoiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC01Mi4wMDYgLTQwLjcxMSkiIGZpbGw9IiMyNjI2M2YiLz4KPC9zdmc+Cg==";
        },
        function(e, t) {
            e.exports = "data:image/svg+xml;base64,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";
        },
        function(e, t) {
            e.exports = "data:image/svg+xml;base64,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";
        },
        function(e, t) {
            e.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzYiIGhlaWdodD0iMzYiIHZpZXdCb3g9IjAgMCAzNiAzNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGNpcmNsZSBjeD0iMTgiIGN5PSIxOCIgcj0iMTgiIGZpbGw9InVybCgjcGFpbnQwX2xpbmVhcl82MTU3XzEzMDQ5MykiLz4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0yMS43NDkyIDYuNzVIMTQuMjQ5M1YxNC4zMjgzSDYuNzVWMjEuOTA3MkgxNC4yNDkzVjI5LjI1MDZIMjEuNzQ5MlYyMS42NzE3SDE0LjI1VjE0LjMyODlIMjEuNzQ5MlY2Ljc1Wk0yOS4yNTAyIDE0LjMyODNIMjEuNzUwMlYyMS45MDcySDI5LjI1MDJWMTQuMzI4M1oiIGZpbGw9ImJsYWNrIi8+CjxkZWZzPgo8bGluZWFyR3JhZGllbnQgaWQ9InBhaW50MF9saW5lYXJfNjE1N18xMzA0OTMiIHgxPSIzNiIgeTE9Ii0yLjE0NTc3ZS0wNiIgeDI9IjIuMTQ1NzdlLTA2IiB5Mj0iMzYiIGdyYWRpZW50VW5pdHM9InVzZXJTcGFjZU9uVXNlIj4KPHN0b3Agb2Zmc2V0PSIwLjM5NTgzMyIgc3RvcC1jb2xvcj0iI0E5RkZFMCIvPgo8c3RvcCBvZmZzZXQ9IjEiIHN0b3AtY29sb3I9IiM4NkQ1RkYiLz4KPC9saW5lYXJHcmFkaWVudD4KPC9kZWZzPgo8L3N2Zz4K";
        },
        function(e, t) {
            e.exports = "data:image/svg+xml;base64,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";
        },
        function(e, t) {
            e.exports = "data:image/svg+xml;base64,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";
        },
        function(e, t) {
            e.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGNpcmNsZSBjeD0iMTIiIGN5PSIxMiIgcj0iMTIiIGZpbGw9ImJsYWNrIi8+CjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNNy41Mjg2MiA5Ljc1VjE1Ljk2NDZDNy41Mjg2MiAxNi40NzA2IDcuOTE5NjUgMTYuODU2NSA4LjQyNTQgMTYuODU2NUgxNS43NjIxQzE2LjI2NzkgMTYuODU2NSAxNi42NTg5IDE2LjQ3MDYgMTYuNjU4OSAxNS45NjQ2VjEwLjc1MjRIMTcuNjI1VjE1Ljk2NDZDMTcuNjI1IDE2Ljk5NTYgMTYuODA0NSAxNy44MTI1IDE1Ljc2MjEgMTcuODEyNUg4LjQyNTRDNy4zODMwNCAxNy44MTI1IDYuNTYyNSAxNi45OTU2IDYuNTYyNSAxNS45NjQ2VjkuNzVINy41Mjg2MloiIGZpbGw9IndoaXRlIi8+CjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNNi41NjI1IDguMjIyNTFDNi41NjI1IDcuMTkxNzYgNy4zODMwNCA2LjM3NSA4LjQyNTQgNi4zNzVIMTUuOTA4NlY4LjY0NjU3SDE2LjEzMjNDMTYuOTcyNyA4LjY0NjU3IDE3LjYyNSA5LjI5NjMxIDE3LjYyNSAxMC4xMjY2VjEwLjg5NDlDMTcuNjI1IDExLjcyNTMgMTYuOTcyNyAxMi4zNzUgMTYuMTMyMyAxMi4zNzVIOC40MjU0QzcuMzgzMDQgMTIuMzc1IDYuNTYyNSAxMS41NTgyIDYuNTYyNSAxMC41Mjc1VjguMjIyNTFaTTE0Ljk0MjUgOC42NDY1N1Y3LjMzMDc3SDguNDI1NEM3LjkxOTY1IDcuMzMwNzcgNy41Mjg2MiA3LjcxNjYxIDcuNTI4NjIgOC4yMjI1MVYxMC41Mjc1QzcuNTI4NjIgMTEuMDMzNCA3LjkxOTY1IDExLjQxOTIgOC40MjU0IDExLjQxOTJIMTEuNjEwN1Y4LjY0NjU3SDE0Ljk0MjVaTTEyLjU3NjggMTEuNDE5MkgxNi4xMzIzQzE2LjQzNjEgMTEuNDE5MiAxNi42NTg5IDExLjIwMDQgMTYuNjU4OSAxMC44OTQ5VjEwLjEyNjZDMTYuNjU4OSA5LjgyMTE1IDE2LjQzNjEgOS42MDIzNSAxNi4xMzIzIDkuNjAyMzVIMTIuNTc2OFYxMS40MTkyWiIgZmlsbD0id2hpdGUiLz4KPC9zdmc+Cg==";
        },
        function(e, t) {
            e.exports = "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgNTEyIDUxMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTAgMTQwLjhDMCA5MS41MTU0IDAgNjYuODczMSA5LjU5MTQzIDQ4LjA0ODhDMTguMDI4MyAzMS40OTA2IDMxLjQ5MDYgMTguMDI4MyA0OC4wNDg4IDkuNTkxNDNDNjYuODczMSAwIDkxLjUxNTQgMCAxNDAuOCAwSDM3MS4yQzQyMC40ODUgMCA0NDUuMTI3IDAgNDYzLjk1MSA5LjU5MTQzQzQ4MC41MDkgMTguMDI4MyA0OTMuOTcyIDMxLjQ5MDYgNTAyLjQwOSA0OC4wNDg4QzUxMiA2Ni44NzMxIDUxMiA5MS41MTU0IDUxMiAxNDAuOFYzNzEuMkM1MTIgNDIwLjQ4NSA1MTIgNDQ1LjEyNyA1MDIuNDA5IDQ2My45NTFDNDkzLjk3MiA0ODAuNTA5IDQ4MC41MDkgNDkzLjk3MiA0NjMuOTUxIDUwMi40MDlDNDQ1LjEyNyA1MTIgNDIwLjQ4NSA1MTIgMzcxLjIgNTEySDE0MC44QzkxLjUxNTQgNTEyIDY2Ljg3MzEgNTEyIDQ4LjA0ODggNTAyLjQwOUMzMS40OTA2IDQ5My45NzIgMTguMDI4MyA0ODAuNTA5IDkuNTkxNDMgNDYzLjk1MUMwIDQ0NS4xMjcgMCA0MjAuNDg1IDAgMzcxLjJWMTQwLjhaIiBmaWxsPSIjMjk2MkVGIi8+CjxwYXRoIGQ9Ik0xMTEuMDQ4IDEyOEMxMDIuMjc0IDEyOCA5OC44OTMxIDEzOC44NSAxMDYuMjU2IDE0My4zODJMMjkwLjQ0MyAyNTQuNDQxQzI5NS4wMzQgMjU3LjI2NyAzMDEuMTU3IDI1Ni4xNSAzMDQuMzE5IDI1MS45MDlMMzg1LjMwMSAxNDUuNTk0QzM5MC44MDcgMTM4LjIwOCAzODUuMjQ0IDEyOCAzNzUuNzEzIDEyOEgxMTEuMDQ4WiIgZmlsbD0id2hpdGUiLz4KPHBhdGggZD0iTTQwMC41MzggMzg0QzQwOS4zMTEgMzg0IDQxMi43OCAzNzMuMDkyIDQwNS40MTkgMzY4LjU2MUwyMjEuMTc4IDI1Ny41MTZDMjE2LjU4NyAyNTQuNjkgMjEwLjYxMiAyNTUuOTQ4IDIwNy40NTIgMjYwLjE4OEwxMjYuMzEyIDM2Ni40ODJDMTIwLjgwOCAzNzMuODY2IDEyNi41NDUgMzg0IDEzNi4wNzQgMzg0SDQwMC41MzhaIiBmaWxsPSJ3aGl0ZSIvPgo8L3N2Zz4=";
        },
        function(e, t) {
            e.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTI4IiBoZWlnaHQ9IjEyOCIgdmlld0JveD0iMCAwIDEyOCAxMjgiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxjaXJjbGUgY3g9IjY0IiBjeT0iNjQiIHI9IjY0IiBmaWxsPSJ1cmwoI3BhaW50MF9saW5lYXIpIi8+CjxwYXRoIGQ9Ik0xMTAuNTg0IDY0LjkxNDJIOTkuMTQyQzk5LjE0MiA0MS43NjUxIDgwLjE3MyAyMyA1Ni43NzI0IDIzQzMzLjY2MTIgMjMgMTQuODcxNiA0MS4zMDU3IDE0LjQxMTggNjQuMDU4M0MxMy45MzYgODcuNTc3IDM2LjI0MSAxMDggNjAuMDE4NiAxMDhINjMuMDA5NEM4My45NzIzIDEwOCAxMTIuMDY5IDkxLjc2NjcgMTE2LjQ1OSA3MS45ODc0QzExNy4yNyA2OC4zNDEzIDExNC4zNTggNjQuOTE0MiAxMTAuNTg0IDY0LjkxNDJaTTM5Ljc2ODkgNjUuOTQ1NEMzOS43Njg5IDY5LjA0MTEgMzcuMjA5NSA3MS41NzI5IDM0LjA4MDIgNzEuNTcyOUMzMC45NTA5IDcxLjU3MjkgMjguMzkxNiA2OS4wMzk5IDI4LjM5MTYgNjUuOTQ1NFY1Ni44NDE0QzI4LjM5MTYgNTMuNzQ1NyAzMC45NTA5IDUxLjIxMzkgMzQuMDgwMiA1MS4yMTM5QzM3LjIwOTUgNTEuMjEzOSAzOS43Njg5IDUzLjc0NTcgMzkuNzY4OSA1Ni44NDE0VjY1Ljk0NTRaTTU5LjUyMjQgNjUuOTQ1NEM1OS41MjI0IDY5LjA0MTEgNTYuOTYzMSA3MS41NzI5IDUzLjgzMzggNzEuNTcyOUM1MC43MDQ1IDcxLjU3MjkgNDguMTQ1MSA2OS4wMzk5IDQ4LjE0NTEgNjUuOTQ1NFY1Ni44NDE0QzQ4LjE0NTEgNTMuNzQ1NyA1MC43MDU2IDUxLjIxMzkgNTMuODMzOCA1MS4yMTM5QzU2Ljk2MzEgNTEuMjEzOSA1OS41MjI0IDUzLjc0NTcgNTkuNTIyNCA1Ni44NDE0VjY1Ljk0NTRaIiBmaWxsPSJ1cmwoI3BhaW50MV9saW5lYXIpIi8+CjxkZWZzPgo8bGluZWFyR3JhZGllbnQgaWQ9InBhaW50MF9saW5lYXIiIHgxPSI2NCIgeTE9IjAiIHgyPSI2NCIgeTI9IjEyOCIgZ3JhZGllbnRVbml0cz0idXNlclNwYWNlT25Vc2UiPgo8c3RvcCBzdG9wLWNvbG9yPSIjNTM0QkIxIi8+CjxzdG9wIG9mZnNldD0iMSIgc3RvcC1jb2xvcj0iIzU1MUJGOSIvPgo8L2xpbmVhckdyYWRpZW50Pgo8bGluZWFyR3JhZGllbnQgaWQ9InBhaW50MV9saW5lYXIiIHgxPSI2NS40OTk4IiB5MT0iMjMiIHgyPSI2NS40OTk4IiB5Mj0iMTA4IiBncmFkaWVudFVuaXRzPSJ1c2VyU3BhY2VPblVzZSI+CjxzdG9wIHN0b3AtY29sb3I9IndoaXRlIi8+CjxzdG9wIG9mZnNldD0iMSIgc3RvcC1jb2xvcj0id2hpdGUiIHN0b3Atb3BhY2l0eT0iMC44MiIvPgo8L2xpbmVhckdyYWRpZW50Pgo8L2RlZnM+Cjwvc3ZnPgo=";
        },
        function(e, t) {
            e.exports = "data:image/svg+xml;base64,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";
        },
        function(e, t, n) {
            "use strict";
            Object.defineProperty(t, "__esModule", {
                value: !0
            }), t.STARZWALLET = t.BITKEEPWALLET = t.WEB3AUTH = t.OPERA = t.SEQUENCE = t.COINBASEWALLET = t.WALLETLINK = t.BINANCECHAINWALLET = t.FRAME = t.BITSKI = t.LEDGER = t.DCENT = t.MEWCONNECT = t.BURNERCONNECT = t.AUTHEREUM = t.VENLY = t.TORUS = t.FORTMATIC = t.PORTIS = t.WALLETCONNECT = void 0;
            var i = n(0), r = i.__importDefault(n(95)), M = i.__importDefault(n(96)), u = i.__importDefault(n(97)), o = i.__importDefault(n(98)), c = i.__importDefault(n(99)), a = i.__importDefault(n(100)), I = i.__importDefault(n(101)), l = i.__importDefault(n(102)), N = i.__importDefault(n(103)), j = i.__importDefault(n(104)), g = i.__importDefault(n(105)), s = i.__importDefault(n(13)), A = i.__importDefault(n(14)), D = i.__importDefault(n(106)), d = i.__importDefault(n(107)), T = i.__importDefault(n(108)), y = i.__importDefault(n(15)), z = i.__importDefault(n(16)), w = i.__importDefault(n(109));
            i.__exportStar(n(12), t), t.WALLETCONNECT = {
                id: "walletconnect",
                name: "WalletConnect",
                logo: r.default,
                type: "qrcode",
                check: "isWalletConnect",
                package: {
                    required: [
                        [
                            "infuraId",
                            "rpc"
                        ]
                    ]
                }
            }, t.PORTIS = {
                id: "portis",
                name: "Portis",
                logo: M.default,
                type: "web",
                check: "isPortis",
                package: {
                    required: [
                        "id"
                    ]
                }
            }, t.FORTMATIC = {
                id: "fortmatic",
                name: "Fortmatic",
                logo: u.default,
                type: "web",
                check: "isFortmatic",
                package: {
                    required: [
                        "key"
                    ]
                }
            }, t.TORUS = {
                id: "torus",
                name: "Torus",
                logo: c.default,
                type: "web",
                check: "isTorus"
            }, t.VENLY = {
                id: "venly",
                name: "Venly",
                logo: o.default,
                type: "web",
                check: "isVenly",
                package: {
                    required: [
                        "clientId"
                    ]
                }
            }, t.AUTHEREUM = {
                id: "authereum",
                name: "Authereum",
                logo: a.default,
                type: "web",
                check: "isAuthereum"
            }, t.BURNERCONNECT = {
                id: "burnerconnect",
                name: "Burner Connect",
                logo: I.default,
                type: "web",
                check: "isBurnerProvider"
            }, t.MEWCONNECT = {
                id: "mewconnect",
                name: "MEW wallet",
                logo: l.default,
                type: "qrcode",
                check: "isMEWconnect",
                package: {
                    required: [
                        [
                            "infuraId",
                            "rpc"
                        ]
                    ]
                }
            }, t.DCENT = {
                id: "dcentwallet",
                name: "D'CENT",
                logo: N.default,
                type: "hardware",
                check: "isDcentWallet",
                package: {
                    required: [
                        "rpcUrl"
                    ]
                }
            }, t.LEDGER = {
                id: "ledger",
                name: "Ledger",
                logo: j.default,
                type: "hardware",
                check: "isLedgerConnect"
            }, t.BITSKI = {
                id: "bitski",
                name: "Bitski",
                logo: g.default,
                type: "web",
                check: "isBitski",
                package: {
                    required: [
                        "clientId",
                        "callbackUrl"
                    ]
                }
            }, t.FRAME = {
                id: "frame",
                name: "Frame",
                logo: A.default,
                type: "web",
                check: "isFrameNative"
            }, t.BINANCECHAINWALLET = {
                id: "binancechainwallet",
                name: "Binance Chain",
                logo: D.default,
                type: "injected",
                check: "isBinanceChainWallet"
            }, t.WALLETLINK = {
                id: "walletlink",
                name: "Coinbase Wallet",
                logo: d.default,
                type: "qrcode",
                check: "isWalletLink",
                package: {
                    required: [
                        [
                            "appName",
                            "infuraId",
                            "rpc"
                        ]
                    ]
                }
            }, t.COINBASEWALLET = {
                id: "coinbasewallet",
                name: "Coinbase",
                logo: d.default,
                type: "injected",
                check: "isWalletLink",
                package: {
                    required: [
                        [
                            "appName",
                            "infuraId",
                            "rpc"
                        ]
                    ]
                }
            }, t.SEQUENCE = {
                id: "sequence",
                name: "Sequence",
                logo: y.default,
                type: "web",
                check: "isSequenceWeb"
            }, t.OPERA = {
                id: "opera",
                name: "Opera",
                logo: s.default,
                type: "injected",
                check: "isOpera"
            }, t.WEB3AUTH = {
                id: "web3auth",
                name: "Web3Auth",
                logo: T.default,
                type: "injected",
                check: "isWeb3Auth"
            }, t.BITKEEPWALLET = {
                id: "bitkeep",
                name: "Bitkeep Wallet",
                logo: z.default,
                type: "injected",
                check: "isBitKeep"
            }, t.STARZWALLET = {
                id: "starzwallet",
                name: "99Starz",
                logo: w.default,
                type: "injected",
                check: "isStarzWallet"
            };
        },
        function(e, t) {
            e.exports = "data:image/svg+xml;base64,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";
        },
        function(e, t) {
            e.exports = "data:image/svg+xml;base64,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";
        },
        function(e, t) {
            e.exports = "data:image/svg+xml;base64,PHN2ZyBmaWxsPSJub25lIiBoZWlnaHQ9IjYzIiB2aWV3Qm94PSIwIDAgNjMgNjMiIHdpZHRoPSI2MyIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Im0zMS42MzkzLjk4NDM3NWgxNS4zMjc0IDE1LjMyNzV2MTUuMjk5MDI1aC0xNS4zMjc1LTE1LjMyNzQtMTUuMzI3NXYxNS4yOTg5Ljk4MSAxNC4yMjg5LjA4OTEgMTUuMjA5OWgtMTUuMzI3NDI1di0xNS4yMDk5LS4wODkxLTE0LjIyODktLjk4MS0xNS4yOTg5LTE1LjI5OTAyNWgxNS4zMjc0MjV6bTE1LjMyNzQgNDUuODA4MzI1aC0xNS4yMzgxdi0xNS4yMDk4aDMwLjU1NjZ2MTUuNzQ0OWMwIDMuOTE0LTEuNTU3MSA3LjY2OC00LjMyOTEgMTAuNDM2NXMtNi41MzE5IDQuMzI1LTEwLjQ1MzMgNC4zMjc0aC0uNTM2MXoiIGZpbGw9IiM2MTdiZmYiIGZpbGwtcnVsZT0iZXZlbm9kZCIvPjwvc3ZnPg==";
        },
        function(e, t) {
            e.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTYwIiBoZWlnaHQ9IjUxNyIgdmlld0JveD0iMCAwIDU2MCA1MTciIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGQ9Ik01NTQuNTU1IDE2OS4yNzZMNDg1Ljg2NyAxOTUuMzY1QzQ4Mi45NzkgMTk2LjQxNSA0ODAuMTc5IDE5My42MTQgNDgxLjQwNCAxOTAuNzI1TDU1Ny45NjggNC44NjA4M0M1NTkuMTA1IDIuMDU5MyA1NTYuMzkzIC0wLjgyOTc3OCA1NTMuNTkzIDAuMjIwNzk1TDQwOC4wNzggNTEuMTczNkM0MDUuMjc4IDUyLjEzNjYgNDAzLjAwMyA1NC4zMjUzIDQwMS44NjYgNTcuMTI2OEwzMDMuMjUyIDMwNi4wMjVDMzAyLjAyNyAzMDkuMTc3IDMwNS4wODkgMzEyLjMyOSAzMDguMjM5IDMxMS4xOUwzNjkuODQgMjg4LjYwM0MzNzMuMjUzIDI4Ny4zNzcgMzc2LjQwMyAyOTEuMDU0IDM3NC41NjUgMjk0LjI5NEwyODQuMDg5IDQ0Ny45NEMyODIuMTY0IDQ1MS4yNjcgMjc3LjI2NCA0NTEuMjY3IDI3NS4zMzkgNDQ3Ljk0TDE4NC44NjMgMjk0LjIwNkMxODMuMDI1IDI5MS4wNTQgMTg2LjA4OCAyODcuMjkgMTg5LjU4OCAyODguNTE2TDI1MS4xODkgMzExLjEwM0MyNTQuMzM5IDMxMi4yNDEgMjU3LjQwMSAzMDkuMDg5IDI1Ni4xNzYgMzA1LjkzOEwxNTcuNDc1IDU3LjEyNjhDMTU2LjMzNyA1NC4zMjUzIDE1NC4xNSA1Mi4yMjQyIDE1MS4yNjIgNTEuMTczNkw1LjkyMjY3IDAuMjIwNzk1QzMuMDM1MTMgLTAuNzQyMjMgMC40MTAwOTIgMi4wNTkzIDEuNTQ3NjEgNC44NjA4M0w3OC4wMjM3IDE5MC43MjVDNzkuMTYxMiAxOTMuNTI2IDc2LjM2MTIgMTk2LjQxNSA3My41NjExIDE5NS4zNjVMNS4zMTAxNiAxNjkuMjc2QzEuODEwMTEgMTY3Ljk2MiAtMS4zMzk5MyAxNzEuNzI3IDAuNTg1MDk1IDE3NC45NjZMMjAzLjc2MyA1MTEuNUMyMDUuNzc1IDUxNC44MjYgMjA5LjM2MyA1MTYuODQgMjEzLjMwMSA1MTYuODRIMzQ2LjQ3N0MzNTAuMzI4IDUxNi44NCAzNTQuMDAzIDUxNC44MjYgMzU2LjAxNSA1MTEuNUw1NTkuNTQzIDE3NC45NjZDNTYxLjIwNSAxNzEuNzI3IDU1OC4wNTUgMTY3Ljk2MiA1NTQuNTU1IDE2OS4yNzZaIiBmaWxsPSIjNzkyN0ZGIi8+Cjwvc3ZnPgo=";
        },
        function(e, t) {
            e.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjU3IiBoZWlnaHQ9IjI3NyIgdmlld0JveD0iMCAwIDI1NyAyNzciIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICA8cmVjdCB3aWR0aD0iMTUzLjg4OSIgaGVpZ2h0PSI4Mi4wNzQxIiBmaWxsPSIjMDM2NEZGIiAvPgogICAgPHJlY3QgeD0iNzEuODEzNSIgd2lkdGg9IjgyLjA3NDEiIGhlaWdodD0iMjc3IiBmaWxsPSIjMDM2NEZGIiAvPgogICAgPHBhdGggZD0iTTIxNS40NDMgODIuMDc0MUMyMzguMTA3IDgyLjA3NDEgMjU2LjQ4IDYzLjcwMTIgMjU2LjQ4IDQxLjAzN0MyNTYuNDggMTguMzcyOSAyMzguMTA3IDAgMjE1LjQ0MyAwQzE5Mi43NzkgMCAxNzQuNDA2IDE4LjM3MjkgMTc0LjQwNiA0MS4wMzdDMTc0LjQwNiA2My43MDEyIDE5Mi43NzkgODIuMDc0MSAyMTUuNDQzIDgyLjA3NDFaIiBmaWxsPSIjMDM2NEZGIiAvPgo8L3N2Zz4=";
        },
        function(e, t) {
            e.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iMzgycHgiIGhlaWdodD0iNDcycHgiIHZpZXdCb3g9IjAgMCAzODIgNDcyIiB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiPgogICAgPCEtLSBHZW5lcmF0b3I6IFNrZXRjaCA1Mi42ICg2NzQ5MSkgLSBodHRwOi8vd3d3LmJvaGVtaWFuY29kaW5nLmNvbS9za2V0Y2ggLS0+CiAgICA8dGl0bGU+YXV0aGVyZXVtPC90aXRsZT4KICAgIDxkZXNjPkNyZWF0ZWQgd2l0aCBTa2V0Y2guPC9kZXNjPgogICAgPGcgaWQ9IlBhZ2UtMSIgc3Ryb2tlPSJub25lIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICAgICAgPGcgaWQ9ImF1dGhlcmV1bSIgZmlsbD0iI0ZGNEMyRiI+CiAgICAgICAgICAgIDxnIGlkPSJHcm91cCIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTkwLjk1MDAwMCwgMjM1LjkwMDAwMCkgc2NhbGUoLTEsIDEpIHJvdGF0ZSgtMTgwLjAwMDAwMCkgdHJhbnNsYXRlKC0xOTAuOTUwMDAwLCAtMjM1LjkwMDAwMCkgdHJhbnNsYXRlKC0wLjAwMDAwMCwgMC4xMDAwMDApIj4KICAgICAgICAgICAgICAgIDxwYXRoIGQ9Ik04MCw0NTQuMSBDNTAsNDQ0LjUgMTkuOCw0MzQuOSAxMi43LDQzMi43IEwwLDQyOC42IEwwLDM0MC40IEMwLDI4Ny42IDAuNCwyNDcuOCAxLDI0MS4yIEM1LjQsMTk1IDI1LjQsMTUxLjIgNTguOCwxMTQuOCBDNjYuNCwxMDYuNSAxODcsMS40IDE5MC40LDAuMSBDMTkxLjgsLTAuNCAyOTcuOCw5MCAzMTUuMiwxMDYuNiBDMzQ1LjQsMTM1LjMgMzY5LDE3Ny4zIDM3Ny40LDIxNy41IEMzODEuOCwyMzguNyAzODIuMSwyNDYuNiAzODEuOCwzNDAuNiBMMzgxLjUsNDI5IEwzMTMuNiw0NTAuNCBDMjc2LjMsNDYyLjEgMjQ1LjYsNDcxLjYgMjQ1LjQsNDcxLjUgQzI0NS4zLDQ3MS4zIDI1MC45LDQ2MC4yIDI1OCw0NDYuNyBMMjcwLjksNDIyLjIgTDI5MC4yLDQxNiBDMzAwLjgsNDEyLjYgMzE2LjgsNDA3LjUgMzI1LjgsNDA0LjcgTDM0Mi4xLDM5OS42IEwzNDEuNywzMTguNCBDMzQxLjQsMjQwLjQgMzQxLjMsMjM2LjggMzM5LjMsMjI3LjcgQzMzMS43LDE5My40IDMxNiwxNjQuMyAyOTEuOSwxMzkuNyBDMjg3LjMsMTM1IDI2My45LDExNC4zIDI0MCw5My44IEMyMTYuMSw3My4yIDE5NS4zLDU1LjMgMTkzLjgsNTMuOSBMMTkxLjIsNTEuNSBMMTQ1LjMsOTEgQzg5LjIsMTM5LjQgODAuOCwxNDcuNiA2Ny40LDE2OC4yIEM1Ny4xLDE4NC4xIDQ5LjUsMjAxLjIgNDQuOSwyMTguOSBDNDAuNCwyMzYuOSA0MCwyNDMuNiA0MCwzMjMuOCBMNDAsMzk5LjUgTDU0LjMsNDA0IEM2Mi4xLDQwNi41IDc4LjEsNDExLjYgODkuOCw0MTUuMyBDMTAxLjQsNDE5IDExMSw0MjIuNCAxMTEsNDIyLjcgQzExMSw0MjMgMTE2LjYsNDM0IDEyMy41LDQ0Ny4xIEMxMzAuNCw0NjAuMyAxMzYsNDcxLjIgMTM2LDQ3MS40IEMxMzYsNDcyIDEzNC44LDQ3MS42IDgwLDQ1NC4xIFoiIGlkPSJQYXRoIj48L3BhdGg+CiAgICAgICAgICAgICAgICA8cGF0aCBkPSJNMTg4LjQsNDY4LjUgQzE4Ny41LDQ2Ni43IDE2Mi4zLDQxOC42IDEzMi41LDM2MS43IEw3OC4zLDI1OC4yIEw3OS4xLDI0OS44IEM4MC45LDIzMi42IDg3LjMsMjE0LjQgOTcuNywxOTcuOSBDMTAxLjQsMTkxLjkgMTAyLjUsMTkwLjggMTAzLjUsMTkxLjkgQzEwNC4xLDE5Mi42IDEyMy45LDIzMCAxNDcuNSwyNzUgQzE3MSwzMTkuOSAxOTAuNSwzNTYuNyAxOTAuOSwzNTYuNyBDMTkxLjIsMzU2LjcgMjExLDMyMC4zIDIzNC44LDI3NS45IEMyNTguNiwyMzEuNSAyNzguNSwxOTQuNCAyNzkuMSwxOTMuNCBDMjgwLjEsMTkxLjcgMjgwLjMsMTkxLjggMjgxLjksMTkzLjkgQzI5Mi4yLDIwNy40IDMwMC43LDIyOS43IDMwMy4xLDI0OS40IEwzMDQuMywyNTkuNCBMMjQ3LjUsMzY1LjMgQzIxNi4zLDQyMy41IDE5MC42LDQ3MS40IDE5MC40LDQ3MS41IEMxOTAuMyw0NzEuNyAxODkuNCw0NzAuNCAxODguNCw0NjguNSBaIiBpZD0iUGF0aCI+PC9wYXRoPgogICAgICAgICAgICAgICAgPHBhdGggZD0iTTE2MywyMTMuOCBMMTM1LjUsMTU4LjkgTDE1MSwxNDUuNCBDMTU5LjUsMTM4IDE3MiwxMjcuMyAxNzguNywxMjEuNyBMMTkxLDExMS41IEwxOTMuNywxMTMuNyBDMTk1LjMsMTE0LjkgMjA3LjYsMTI1LjYgMjIxLjEsMTM3LjUgTDI0NS44LDE1OS4xIEwyMTguNCwyMTMuOSBDMjAzLjMsMjQ0IDE5MC45LDI2OC43IDE5MC43LDI2OC43IEMxOTAuNiwyNjguNyAxNzguMSwyNDQgMTYzLDIxMy44IFoiIGlkPSJQYXRoIj48L3BhdGg+CiAgICAgICAgICAgIDwvZz4KICAgICAgICA8L2c+CiAgICA8L2c+Cjwvc3ZnPg==";
        },
        function(e, t) {
            e.exports = "data:image/png;base64,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";
        },
        function(e, t) {
            e.exports = "data:image/png;base64,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";
        },
        function(e, t) {
            e.exports = "data:image/png;base64,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";
        },
        function(e, t) {
            e.exports = "data:image/png;base64,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";
        },
        function(e, t) {
            e.exports = "data:image/svg+xml;base64,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";
        },
        function(e, t) {
            e.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA0MCA0MCIgZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCI+PGcgZmlsbD0iI2YwYjkwYiI+PHBhdGggZD0iTTIwLjI0NSAwTDkuNjM0IDYuMTI1bDMuOTAxIDIuMjYyIDYuNzEtMy44NjIgNi43MSAzLjg2MiAzLjkwMi0yLjI2MkwyMC4yNDUgMHptNi43MTEgMTEuNTg2bDMuOSAyLjI2M3Y0LjUyNmwtNi43MSAzLjg2MnY3LjcyNGwtMy45IDIuMjYzLTMuOTAyLTIuMjYzdi03LjcyNGwtNi43MS0zLjg2MnYtNC41MjZsMy45MDEtMi4yNjMgNi43MSAzLjg2MyA2LjcxLTMuODYzaC4wMDF6Ii8+PHBhdGggZD0iTTMwLjg1NyAyMS41NzNWMjYuMWwtMy45MDEgMi4yNjJ2LTQuNTI1bDMuOS0yLjI2My4wMDEtLjAwMXoiLz48cGF0aCBkPSJNMjYuOTE2IDMxLjU2bDYuNzEtMy44NjJ2LTcuNzI0bDMuOTAyLTIuMjYzdjEyLjI1bC0xMC42MTEgNi4xMjVWMzEuNTZoLS4wMDF6bTYuNzExLTE5LjMxbC0zLjkwMi0yLjI2MyAzLjkwMi0yLjI2MyAzLjkgMi4yNjN2NC41MjVsLTMuOSAyLjI2M1YxMi4yNXpNMTYuMzQ0IDM3LjcyNFYzMy4ybDMuOTAxIDIuMjYzIDMuOTAyLTIuMjYzdjQuNTI1bC0zLjkwMiAyLjI2My0zLjktMi4yNjMtLjAwMS0uMDAxem0tMi44MDktOS4zNjNMOS42MzQgMjYuMXYtNC41MjZsMy45MDEgMi4yNjN2NC41MjUtLjAwMXptNi43MS0xNi4xMTFsLTMuOS0yLjI2MyAzLjktMi4yNjMgMy45MDIgMi4yNjMtMy45MDIgMi4yNjN6bS05LjQ4LTIuMjYzbC0zLjkgMi4yNjN2NC41MjVsLTMuOTAyLTIuMjYzVjkuOTg3bDMuOTAxLTIuMjYzIDMuOTAxIDIuMjYzeiIvPjxwYXRoIGQ9Ik0yLjk2MyAxNy43MTFsMy45MDEgMi4yNjN2Ny43MjRsNi43MSAzLjg2MnY0LjUyNkwyLjk2MyAyOS45NlYxNy43MXYuMDAxeiIvPjwvZz48L3N2Zz4=";
        },
        function(e, t) {
            e.exports = "data:image/svg+xml;base64,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";
        },
        function(e, t) {
            e.exports = "data:image/svg+xml;base64,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";
        },
        function(e, t) {
            e.exports = "data:image/svg+xml;base64,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";
        },
        function(e, t, n) {
            "use strict";
            Object.defineProperty(t, "__esModule", {
                value: !0
            });
        },
        function(e, t, n) {
            "use strict";
            Object.defineProperty(t, "__esModule", {
                value: !0
            }), t.Modal = void 0;
            var i, r, M, u, o = n(0), c = o.__importStar(n(1)), a = o.__importStar(n(112)), I = o.__importDefault(n(18)), l = n(19), N = n(2), j = I.default.div(i || (i = o.__makeTemplateObject([
                "\n  transition: opacity 0.1s ease-in-out;\n  text-align: center;\n  position: fixed;\n  width: 100%;\n  height: 100%;\n  margin-left: -50vw;\n  top: ",
                ";\n  left: 50%;\n  z-index: 2;\n  will-change: opacity;\n  background-color: ",
                ";\n  opacity: ",
                ";\n  visibility: ",
                ";\n  pointer-events: ",
                ";\n  display: flex;\n  justify-content: center;\n  align-items: center;\n\n  & * {\n    box-sizing: border-box !important;\n  }\n"
            ], [
                "\n  transition: opacity 0.1s ease-in-out;\n  text-align: center;\n  position: fixed;\n  width: 100%;\n  height: 100%;\n  margin-left: -50vw;\n  top: ",
                ";\n  left: 50%;\n  z-index: 2;\n  will-change: opacity;\n  background-color: ",
                ";\n  opacity: ",
                ";\n  visibility: ",
                ";\n  pointer-events: ",
                ";\n  display: flex;\n  justify-content: center;\n  align-items: center;\n\n  & * {\n    box-sizing: border-box !important;\n  }\n"
            ])), function(e) {
                var t = e.offset;
                return t ? "-" + t + "px" : 0;
            }, function(e) {
                var t = e.opacity, n = .4;
                return "number" == typeof t && (n = t), "rgba(0, 0, 0, " + n + ")";
            }, function(e) {
                return e.show ? 1 : 0;
            }, function(e) {
                return e.show ? "visible" : "hidden";
            }, function(e) {
                return e.show ? "auto" : "none";
            }), g = I.default.div(r || (r = o.__makeTemplateObject([
                "\n  position: relative;\n  width: 100%;\n  height: 100%;\n  padding: 15px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  opacity: ",
                ";\n  visibility: ",
                ";\n  pointer-events: ",
                ";\n"
            ], [
                "\n  position: relative;\n  width: 100%;\n  height: 100%;\n  padding: 15px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  opacity: ",
                ";\n  visibility: ",
                ";\n  pointer-events: ",
                ";\n"
            ])), function(e) {
                return e.show ? 1 : 0;
            }, function(e) {
                return e.show ? "visible" : "hidden";
            }, function(e) {
                return e.show ? "auto" : "none";
            }), s = I.default.div(M || (M = o.__makeTemplateObject([
                "\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n"
            ], [
                "\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n"
            ]))), A = I.default.div(u || (u = o.__makeTemplateObject([
                "\n  position: relative;\n  width: 100%;\n  background-color: ",
                ";\n  border-radius: 12px;\n  margin: 10px;\n  padding: 0;\n  opacity: ",
                ";\n  visibility: ",
                ";\n  pointer-events: ",
                ";\n\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(320px, 1fr));\n  max-width: ",
                ";\n  min-width: fit-content;\n  max-height: 100%;\n  overflow: auto;\n\n  @media screen and (max-width: 768px) {\n    max-width: ",
                ";\n    grid-template-columns: 1fr;\n  }\n"
            ], [
                "\n  position: relative;\n  width: 100%;\n  background-color: ",
                ";\n  border-radius: 12px;\n  margin: 10px;\n  padding: 0;\n  opacity: ",
                ";\n  visibility: ",
                ";\n  pointer-events: ",
                ";\n\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(320px, 1fr));\n  max-width: ",
                ";\n  min-width: fit-content;\n  max-height: 100%;\n  overflow: auto;\n\n  @media screen and (max-width: 768px) {\n    max-width: ",
                ";\n    grid-template-columns: 1fr;\n  }\n"
            ])), function(e) {
                return e.themeColors.background;
            }, function(e) {
                return e.show ? 1 : 0;
            }, function(e) {
                return e.show ? "visible" : "hidden";
            }, function(e) {
                return e.show ? "auto" : "none";
            }, function(e) {
                var t = e.maxWidth;
                return t ? t + "px" : "800px";
            }, function(e) {
                var t = e.maxWidth;
                return t ? t + "px" : "500px";
            }), D = {
                show: !1,
                lightboxOffset: 0
            }, d = function(e) {
                function t(t) {
                    var n = e.call(this, t) || this;
                    return n.state = o.__assign({}, D), n.render = function() {
                        var e = n.state, t = e.show, i = e.lightboxOffset, r = n.props, M = r.onClose, u = r.lightboxOpacity, o = r.userOptions, a = r.themeColors;
                        return c.createElement(j, {
                            className: N.MODAL_LIGHTBOX_CLASSNAME,
                            offset: i,
                            opacity: u,
                            ref: function(e) {
                                return n.lightboxRef = e;
                            },
                            show: t
                        }, c.createElement(g, {
                            className: N.MODAL_CONTAINER_CLASSNAME,
                            show: t
                        }, c.createElement(s, {
                            className: N.MODAL_HITBOX_CLASSNAME,
                            onClick: M
                        }), c.createElement(A, {
                            className: N.MODAL_CARD_CLASSNAME,
                            show: t,
                            themeColors: a,
                            maxWidth: o.length < 3 ? 500 : 800,
                            ref: function(e) {
                                return n.mainModalCard = e;
                            }
                        }, o.map(function(e) {
                            return e ? c.createElement(l.Provider, {
                                name: e.name,
                                logo: e.logo,
                                description: e.description,
                                themeColors: a,
                                onClick: e.onClick
                            }) : null;
                        }))));
                    }, window.updateWeb3Modal = function(e) {
                        return o.__awaiter(n, void 0, void 0, function() {
                            return o.__generator(this, function(t) {
                                return this.setState(e), [
                                    2
                                ];
                            });
                        });
                    }, n;
                }
                return o.__extends(t, e), t.prototype.componentDidUpdate = function(e, t) {
                    if (t.show && !this.state.show && this.props.resetState(), this.lightboxRef) {
                        var n = this.lightboxRef.getBoundingClientRect(), i = n.top > 0 ? n.top : 0;
                        i !== D.lightboxOffset && i !== this.state.lightboxOffset && this.setState({
                            lightboxOffset: i
                        });
                    }
                }, t.propTypes = {
                    userOptions: a.object.isRequired,
                    onClose: a.func.isRequired,
                    resetState: a.func.isRequired,
                    lightboxOpacity: a.number.isRequired
                }, t;
            }(c.Component);
            t.Modal = d;
        },
        function(e, t, n) {
            e.exports = n(113)();
        },
        function(e, t, n) {
            "use strict";
            var i = n(114);
            function r() {}
            function M() {}
            M.resetWarningCache = r, e.exports = function() {
                function e(e, t, n, r, M, u) {
                    if (u !== i) {
                        var o = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
                        throw o.name = "Invariant Violation", o;
                    }
                }
                function t() {
                    return e;
                }
                e.isRequired = e;
                var n = {
                    array: e,
                    bigint: e,
                    bool: e,
                    func: e,
                    number: e,
                    object: e,
                    string: e,
                    symbol: e,
                    any: e,
                    arrayOf: t,
                    element: e,
                    elementType: e,
                    instanceOf: t,
                    node: e,
                    objectOf: t,
                    oneOf: t,
                    oneOfType: t,
                    shape: t,
                    exact: t,
                    checkPropTypes: M,
                    resetWarningCache: r
                };
                return n.PropTypes = n, n;
            };
        },
        function(e, t, n) {
            "use strict";
            e.exports = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
        },
        function(e, t, n) {
            "use strict";
            /** @license React v17.0.2
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var i = 60103, r = 60106, M = 60107, u = 60108, o = 60114, c = 60109, a = 60110, I = 60112, l = 60113, N = 60120, j = 60115, g = 60116, s = 60121, A = 60122, D = 60117, d = 60129, T = 60131;
            if ("function" == typeof Symbol && Symbol.for) {
                var y = Symbol.for;
                i = y("react.element"), r = y("react.portal"), M = y("react.fragment"), u = y("react.strict_mode"), o = y("react.profiler"), c = y("react.provider"), a = y("react.context"), I = y("react.forward_ref"), l = y("react.suspense"), N = y("react.suspense_list"), j = y("react.memo"), g = y("react.lazy"), s = y("react.block"), A = y("react.server.block"), D = y("react.fundamental"), d = y("react.debug_trace_mode"), T = y("react.legacy_hidden");
            }
            function z(e) {
                if ("object" == typeof e && null !== e) {
                    var t = e.$$typeof;
                    switch(t){
                        case i:
                            switch(e = e.type){
                                case M:
                                case o:
                                case u:
                                case l:
                                case N:
                                    return e;
                                default:
                                    switch(e = e && e.$$typeof){
                                        case a:
                                        case I:
                                        case g:
                                        case j:
                                        case c:
                                            return e;
                                        default:
                                            return t;
                                    }
                            }
                        case r:
                            return t;
                    }
                }
            }
            var w = c, f = i, L = I, E = M, C = g, x = j, p = r, S = o, m = u, O = l;
            t.ContextConsumer = a, t.ContextProvider = w, t.Element = f, t.ForwardRef = L, t.Fragment = E, t.Lazy = C, t.Memo = x, t.Portal = p, t.Profiler = S, t.StrictMode = m, t.Suspense = O, t.isAsyncMode = function() {
                return !1;
            }, t.isConcurrentMode = function() {
                return !1;
            }, t.isContextConsumer = function(e) {
                return z(e) === a;
            }, t.isContextProvider = function(e) {
                return z(e) === c;
            }, t.isElement = function(e) {
                return "object" == typeof e && null !== e && e.$$typeof === i;
            }, t.isForwardRef = function(e) {
                return z(e) === I;
            }, t.isFragment = function(e) {
                return z(e) === M;
            }, t.isLazy = function(e) {
                return z(e) === g;
            }, t.isMemo = function(e) {
                return z(e) === j;
            }, t.isPortal = function(e) {
                return z(e) === r;
            }, t.isProfiler = function(e) {
                return z(e) === o;
            }, t.isStrictMode = function(e) {
                return z(e) === u;
            }, t.isSuspense = function(e) {
                return z(e) === l;
            }, t.isValidElementType = function(e) {
                return "string" == typeof e || "function" == typeof e || e === M || e === o || e === d || e === u || e === l || e === N || e === T || "object" == typeof e && null !== e && (e.$$typeof === g || e.$$typeof === j || e.$$typeof === c || e.$$typeof === a || e.$$typeof === I || e.$$typeof === D || e.$$typeof === s || e[0] === A);
            }, t.typeOf = z;
        },
        function(e, t, n) {
            "use strict";
            e.exports = n(117);
        },
        function(e, t, n) {
            "use strict";
            /** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var i = "function" == typeof Symbol && Symbol.for, r = i ? Symbol.for("react.element") : 60103, M = i ? Symbol.for("react.portal") : 60106, u = i ? Symbol.for("react.fragment") : 60107, o = i ? Symbol.for("react.strict_mode") : 60108, c = i ? Symbol.for("react.profiler") : 60114, a = i ? Symbol.for("react.provider") : 60109, I = i ? Symbol.for("react.context") : 60110, l = i ? Symbol.for("react.async_mode") : 60111, N = i ? Symbol.for("react.concurrent_mode") : 60111, j = i ? Symbol.for("react.forward_ref") : 60112, g = i ? Symbol.for("react.suspense") : 60113, s = i ? Symbol.for("react.suspense_list") : 60120, A = i ? Symbol.for("react.memo") : 60115, D = i ? Symbol.for("react.lazy") : 60116, d = i ? Symbol.for("react.block") : 60121, T = i ? Symbol.for("react.fundamental") : 60117, y = i ? Symbol.for("react.responder") : 60118, z = i ? Symbol.for("react.scope") : 60119;
            function w(e) {
                if ("object" == typeof e && null !== e) {
                    var t = e.$$typeof;
                    switch(t){
                        case r:
                            switch(e = e.type){
                                case l:
                                case N:
                                case u:
                                case c:
                                case o:
                                case g:
                                    return e;
                                default:
                                    switch(e = e && e.$$typeof){
                                        case I:
                                        case j:
                                        case D:
                                        case A:
                                        case a:
                                            return e;
                                        default:
                                            return t;
                                    }
                            }
                        case M:
                            return t;
                    }
                }
            }
            function f(e) {
                return w(e) === N;
            }
            t.AsyncMode = l, t.ConcurrentMode = N, t.ContextConsumer = I, t.ContextProvider = a, t.Element = r, t.ForwardRef = j, t.Fragment = u, t.Lazy = D, t.Memo = A, t.Portal = M, t.Profiler = c, t.StrictMode = o, t.Suspense = g, t.isAsyncMode = function(e) {
                return f(e) || w(e) === l;
            }, t.isConcurrentMode = f, t.isContextConsumer = function(e) {
                return w(e) === I;
            }, t.isContextProvider = function(e) {
                return w(e) === a;
            }, t.isElement = function(e) {
                return "object" == typeof e && null !== e && e.$$typeof === r;
            }, t.isForwardRef = function(e) {
                return w(e) === j;
            }, t.isFragment = function(e) {
                return w(e) === u;
            }, t.isLazy = function(e) {
                return w(e) === D;
            }, t.isMemo = function(e) {
                return w(e) === A;
            }, t.isPortal = function(e) {
                return w(e) === M;
            }, t.isProfiler = function(e) {
                return w(e) === c;
            }, t.isStrictMode = function(e) {
                return w(e) === o;
            }, t.isSuspense = function(e) {
                return w(e) === g;
            }, t.isValidElementType = function(e) {
                return "string" == typeof e || "function" == typeof e || e === u || e === N || e === c || e === o || e === g || e === s || "object" == typeof e && null !== e && (e.$$typeof === D || e.$$typeof === A || e.$$typeof === a || e.$$typeof === I || e.$$typeof === j || e.$$typeof === T || e.$$typeof === y || e.$$typeof === z || e.$$typeof === d);
            }, t.typeOf = w;
        },
        function(e, t, n) {
            "use strict";
            Object.defineProperty(t, "__esModule", {
                value: !0
            }), t.ProviderController = void 0;
            var i = n(0), r = i.__importStar(n(5)), M = n(2), u = n(3), o = n(21), c = function() {
                function e(e) {
                    var t = this;
                    this.cachedProvider = "", this.shouldCacheProvider = !1, this.disableInjectedProvider = !1, this.eventController = new o.EventController, this.injectedProvider = null, this.providers = [], this.network = "", this.getUserOptions = function() {
                        var e = u.isMobile(), n = t.providers.map(function(e) {
                            return e.id;
                        }), i = !!t.injectedProvider && !t.disableInjectedProvider, r = [];
                        i && e ? r.push(M.INJECTED_PROVIDER_ID) : (i && r.push(M.INJECTED_PROVIDER_ID), n.forEach(function(e) {
                            e !== M.INJECTED_PROVIDER_ID && t.shouldDisplayProvider(e) && r.push(e);
                        }));
                        var o = [];
                        return r.forEach(function(e) {
                            var n = t.getProvider(e);
                            if (void 0 !== n) {
                                var i = n.id, r = n.name, M = n.logo, c = n.connector;
                                o.push({
                                    id: i,
                                    name: r,
                                    logo: M,
                                    description: u.getProviderDescription(n),
                                    onClick: function() {
                                        return t.connectTo(i, c);
                                    }
                                });
                            }
                        }), o;
                    }, this.connectTo = function(e, n) {
                        return i.__awaiter(t, void 0, void 0, function() {
                            var t, r, u, o, c;
                            return i.__generator(this, function(a) {
                                switch(a.label){
                                    case 0:
                                        return a.trys.push([
                                            0,
                                            2,
                                            ,
                                            3
                                        ]), this.eventController.trigger(M.SELECT_EVENT, e), t = this.getProviderOption(e, "package"), r = this.getProviderOption(e, "options"), u = i.__assign({
                                            network: this.network || void 0
                                        }, r), [
                                            4,
                                            n(t, u)
                                        ];
                                    case 1:
                                        return o = a.sent(), this.eventController.trigger(M.CONNECT_EVENT, o), this.shouldCacheProvider && this.cachedProvider !== e && this.setCachedProvider(e), [
                                            3,
                                            3
                                        ];
                                    case 2:
                                        return c = a.sent(), this.eventController.trigger(M.ERROR_EVENT, c), [
                                            3,
                                            3
                                        ];
                                    case 3:
                                        return [
                                            2
                                        ];
                                }
                            });
                        });
                    }, this.cachedProvider = u.getLocal(M.CACHED_PROVIDER_KEY) || "", this.disableInjectedProvider = e.disableInjectedProvider, this.shouldCacheProvider = e.cacheProvider, this.providerOptions = e.providerOptions, this.network = e.network, this.injectedProvider = u.getInjectedProvider(), this.providers = Object.keys(r.connectors).map(function(e) {
                        var n;
                        (n = e === M.INJECTED_PROVIDER_ID ? t.injectedProvider || r.providers.FALLBACK : u.getProviderInfoById(e), t.providerOptions[e]) && void 0 !== t.providerOptions[e].display && (n = i.__assign(i.__assign({}, n), t.providerOptions[e].display));
                        return i.__assign(i.__assign({}, n), {
                            connector: r.connectors[e],
                            package: n.package
                        });
                    }), Object.keys(this.providerOptions).filter(function(e) {
                        return e.startsWith("custom-");
                    }).map(function(e) {
                        if (e && t.providerOptions[e]) {
                            var n = t.providerOptions[e];
                            void 0 !== n.display && void 0 !== n.connector && t.providers.push(i.__assign(i.__assign(i.__assign(i.__assign({}, r.providers.FALLBACK), {
                                id: e
                            }), n.display), {
                                connector: n.connector
                            }));
                        }
                    });
                }
                return e.prototype.shouldDisplayProvider = function(e) {
                    var t = this.getProvider(e);
                    if (void 0 !== t) {
                        var n = this.providerOptions[e];
                        if (n) {
                            if (!!n.package) {
                                var i = t.package ? t.package.required : void 0;
                                if (!i || !i.length) return !0;
                                var r = n.options;
                                if (r && Object.keys(r).length) {
                                    var M = u.findMatchingRequiredOptions(i, r);
                                    if (i.length === M.length) return !0;
                                }
                            }
                        }
                    }
                    return !1;
                }, e.prototype.getProvider = function(e) {
                    return u.filterMatches(this.providers, function(t) {
                        return t.id === e;
                    }, void 0);
                }, e.prototype.getProviderOption = function(e, t) {
                    return this.providerOptions && this.providerOptions[e] && this.providerOptions[e][t] ? this.providerOptions[e][t] : {};
                }, e.prototype.clearCachedProvider = function() {
                    this.cachedProvider = "", u.removeLocal(M.CACHED_PROVIDER_KEY);
                }, e.prototype.setCachedProvider = function(e) {
                    this.cachedProvider = e, u.setLocal(M.CACHED_PROVIDER_KEY, e);
                }, e.prototype.connectToCachedProvider = function() {
                    return i.__awaiter(this, void 0, void 0, function() {
                        var e;
                        return i.__generator(this, function(t) {
                            switch(t.label){
                                case 0:
                                    return void 0 === (e = this.getProvider(this.cachedProvider)) ? [
                                        3,
                                        2
                                    ] : [
                                        4,
                                        this.connectTo(e.id, e.connector)
                                    ];
                                case 1:
                                    t.sent(), t.label = 2;
                                case 2:
                                    return [
                                        2
                                    ];
                            }
                        });
                    });
                }, e.prototype.on = function(e, t) {
                    var n = this;
                    return this.eventController.on({
                        event: e,
                        callback: t
                    }), function() {
                        return n.eventController.off({
                            event: e,
                            callback: t
                        });
                    };
                }, e.prototype.off = function(e, t) {
                    this.eventController.off({
                        event: e,
                        callback: t
                    });
                }, e;
            }();
            t.ProviderController = c;
        }
    ]);
});

},{}],"fzWh4":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _client = require("@walletconnect/client");
var _clientDefault = parcelHelpers.interopDefault(_client);
var _qrcodeModal = require("@walletconnect/qrcode-modal");
var _qrcodeModalDefault = parcelHelpers.interopDefault(_qrcodeModal);
var _httpConnection = require("@walletconnect/http-connection");
var _httpConnectionDefault = parcelHelpers.interopDefault(_httpConnection);
var _utils = require("@walletconnect/utils");
const ProviderEngine = require("b80bbe8b0fbe31cb");
const CacheSubprovider = require("af24006f6943c7c3");
const FixtureSubprovider = require("e036dee8d54164be");
const FilterSubprovider = require("7f082979dcab662c");
const HookedWalletSubprovider = require("8bec61bf0c08ae71");
const NonceSubprovider = require("fb6560ed77323097");
const SubscriptionsSubprovider = require("573a71e1346cbad2");
class WalletConnectProvider extends ProviderEngine {
    constructor(opts){
        super({
            pollingInterval: opts.pollingInterval || 8000
        });
        this.bridge = "https://bridge.walletconnect.org";
        this.qrcode = true;
        this.qrcodeModal = (0, _qrcodeModalDefault.default);
        this.qrcodeModalOptions = undefined;
        this.rpc = null;
        this.infuraId = "";
        this.http = null;
        this.isConnecting = false;
        this.connected = false;
        this.connectCallbacks = [];
        this.accounts = [];
        this.chainId = 1;
        this.rpcUrl = "";
        this.enable = async ()=>{
            const wc = await this.getWalletConnector();
            if (wc) {
                this.start();
                this.subscribeWalletConnector();
                return wc.accounts;
            } else throw new Error("Failed to connect to WalleConnect");
        };
        this.request = async (payload)=>{
            return this.send(payload);
        };
        this.send = async (payload, callback)=>{
            var _a;
            if (typeof payload === "string") {
                const method = payload;
                let params = callback;
                if (method === "personal_sign") params = (0, _utils.parsePersonalSign)(params);
                return this.sendAsyncPromise(method, params);
            }
            payload = Object.assign({
                id: (0, _utils.payloadId)(),
                jsonrpc: "2.0"
            }, payload);
            if (payload.method === "personal_sign") payload.params = (0, _utils.parsePersonalSign)(payload.params);
            if (callback) {
                this.sendAsync(payload, callback);
                return;
            }
            if (payload.method === "eth_signTypedData_v4" && ((_a = this.walletMeta) === null || _a === void 0 ? void 0 : _a.name) === "MetaMask") {
                const { result } = await this.handleOtherRequests(payload);
                return result;
            } else return this.sendAsyncPromise(payload.method, payload.params);
        };
        this.onConnect = (callback)=>{
            this.connectCallbacks.push(callback);
        };
        this.triggerConnect = (result)=>{
            if (this.connectCallbacks && this.connectCallbacks.length) this.connectCallbacks.forEach((callback)=>callback(result));
        };
        this.bridge = opts.connector ? opts.connector.bridge : opts.bridge || "https://bridge.walletconnect.org";
        this.qrcode = typeof opts.qrcode === "undefined" || opts.qrcode !== false;
        this.qrcodeModal = opts.qrcodeModal || this.qrcodeModal;
        this.qrcodeModalOptions = opts.qrcodeModalOptions;
        this.wc = opts.connector || new (0, _clientDefault.default)({
            bridge: this.bridge,
            qrcodeModal: this.qrcode ? this.qrcodeModal : undefined,
            qrcodeModalOptions: this.qrcodeModalOptions,
            storageId: opts === null || opts === void 0 ? void 0 : opts.storageId,
            signingMethods: opts === null || opts === void 0 ? void 0 : opts.signingMethods,
            clientMeta: opts === null || opts === void 0 ? void 0 : opts.clientMeta
        });
        this.rpc = opts.rpc || null;
        if (!this.rpc && (!opts.infuraId || typeof opts.infuraId !== "string" || !opts.infuraId.trim())) throw new Error("Missing one of the required parameters: rpc or infuraId");
        this.infuraId = opts.infuraId || "";
        this.chainId = (opts === null || opts === void 0 ? void 0 : opts.chainId) || this.chainId;
        this.initialize();
    }
    get isWalletConnect() {
        return true;
    }
    get connector() {
        return this.wc;
    }
    get walletMeta() {
        return this.wc.peerMeta;
    }
    async disconnect() {
        this.close();
    }
    async close() {
        const wc = await this.getWalletConnector({
            disableSessionCreation: true
        });
        await wc.killSession();
        await this.onDisconnect();
    }
    async handleRequest(payload) {
        try {
            let response;
            let result = null;
            const wc = await this.getWalletConnector();
            switch(payload.method){
                case "wc_killSession":
                    await this.close();
                    result = null;
                    break;
                case "eth_accounts":
                    result = wc.accounts;
                    break;
                case "eth_coinbase":
                    result = wc.accounts[0];
                    break;
                case "eth_chainId":
                    result = wc.chainId;
                    break;
                case "net_version":
                    result = wc.chainId;
                    break;
                case "eth_uninstallFilter":
                    this.sendAsync(payload, (_)=>_);
                    result = true;
                    break;
                default:
                    response = await this.handleOtherRequests(payload);
            }
            if (response) return response;
            return this.formatResponse(payload, result);
        } catch (error) {
            this.emit("error", error);
            throw error;
        }
    }
    async handleOtherRequests(payload) {
        if (!(0, _utils.signingMethods).includes(payload.method) && payload.method.startsWith("eth_")) return this.handleReadRequests(payload);
        const wc = await this.getWalletConnector();
        const result = await wc.sendCustomRequest(payload);
        return this.formatResponse(payload, result);
    }
    async handleReadRequests(payload) {
        if (!this.http) {
            const error = new Error("HTTP Connection not available");
            this.emit("error", error);
            throw error;
        }
        return this.http.send(payload);
    }
    formatResponse(payload, result) {
        return {
            id: payload.id,
            jsonrpc: payload.jsonrpc,
            result: result
        };
    }
    getWalletConnector(opts = {}) {
        const { disableSessionCreation = false } = opts;
        return new Promise((resolve, reject)=>{
            const wc = this.wc;
            if (this.isConnecting) this.onConnect((x)=>resolve(x));
            else if (!wc.connected && !disableSessionCreation) {
                this.isConnecting = true;
                wc.on("modal_closed", ()=>{
                    reject(new Error("User closed modal"));
                });
                wc.createSession({
                    chainId: this.chainId
                }).then(()=>{
                    wc.on("connect", (error, payload)=>{
                        if (error) {
                            this.isConnecting = false;
                            return reject(error);
                        }
                        this.isConnecting = false;
                        this.connected = true;
                        if (payload) this.updateState(payload.params[0]);
                        this.emit("connect");
                        this.triggerConnect(wc);
                        resolve(wc);
                    });
                }).catch((error)=>{
                    this.isConnecting = false;
                    reject(error);
                });
            } else {
                if (!this.connected) {
                    this.connected = true;
                    this.updateState(wc.session);
                }
                resolve(wc);
            }
        });
    }
    async subscribeWalletConnector() {
        const wc = await this.getWalletConnector();
        wc.on("disconnect", (error)=>{
            if (error) {
                this.emit("error", error);
                return;
            }
            this.onDisconnect();
        });
        wc.on("session_update", (error, payload)=>{
            if (error) {
                this.emit("error", error);
                return;
            }
            this.updateState(payload.params[0]);
        });
    }
    async onDisconnect() {
        await this.stop();
        this.emit("close", 1000, "Connection closed");
        this.emit("disconnect", 1000, "Connection disconnected");
        this.connected = false;
    }
    async updateState(sessionParams) {
        const { accounts, chainId, networkId, rpcUrl } = sessionParams;
        if (!this.accounts || accounts && this.accounts !== accounts) {
            this.accounts = accounts;
            this.emit("accountsChanged", accounts);
        }
        if (!this.chainId || chainId && this.chainId !== chainId) {
            this.chainId = chainId;
            this.emit("chainChanged", chainId);
        }
        if (!this.networkId || networkId && this.networkId !== networkId) {
            this.networkId = networkId;
            this.emit("networkChanged", networkId);
        }
        this.updateRpcUrl(this.chainId, rpcUrl || "");
    }
    updateRpcUrl(chainId, rpcUrl = "") {
        const rpc = {
            infuraId: this.infuraId,
            custom: this.rpc || undefined
        };
        rpcUrl = rpcUrl || (0, _utils.getRpcUrl)(chainId, rpc);
        if (rpcUrl) {
            this.rpcUrl = rpcUrl;
            this.updateHttpConnection();
        } else this.emit("error", new Error(`No RPC Url available for chainId: ${chainId}`));
    }
    updateHttpConnection() {
        if (this.rpcUrl) {
            this.http = new (0, _httpConnectionDefault.default)(this.rpcUrl);
            this.http.on("payload", (payload)=>this.emit("payload", payload));
            this.http.on("error", (error)=>this.emit("error", error));
        }
    }
    sendAsyncPromise(method, params) {
        return new Promise((resolve, reject)=>{
            this.sendAsync({
                id: (0, _utils.payloadId)(),
                jsonrpc: "2.0",
                method,
                params: params || []
            }, (error, response)=>{
                if (error) {
                    reject(error);
                    return;
                }
                resolve(response.result);
            });
        });
    }
    initialize() {
        this.updateRpcUrl(this.chainId);
        this.addProvider(new FixtureSubprovider({
            eth_hashrate: "0x00",
            eth_mining: false,
            eth_syncing: true,
            net_listening: true,
            web3_clientVersion: `WalletConnect/v1.x.x/javascript`
        }));
        this.addProvider(new CacheSubprovider());
        this.addProvider(new SubscriptionsSubprovider());
        this.addProvider(new FilterSubprovider());
        this.addProvider(new NonceSubprovider());
        this.addProvider(new HookedWalletSubprovider(this.configWallet()));
        this.addProvider({
            handleRequest: async (payload, next, end)=>{
                try {
                    const { error, result } = await this.handleRequest(payload);
                    end(error, result);
                } catch (error) {
                    end(error);
                }
            },
            setEngine: (_)=>_
        });
    }
    configWallet() {
        return {
            getAccounts: async (cb)=>{
                try {
                    const wc = await this.getWalletConnector();
                    const accounts = wc.accounts;
                    if (accounts && accounts.length) cb(null, accounts);
                    else cb(new Error("Failed to get accounts"));
                } catch (error) {
                    cb(error);
                }
            },
            processMessage: async (msgParams, cb)=>{
                try {
                    const wc = await this.getWalletConnector();
                    const result = await wc.signMessage([
                        msgParams.from,
                        msgParams.data
                    ]);
                    cb(null, result);
                } catch (error) {
                    cb(error);
                }
            },
            processPersonalMessage: async (msgParams, cb)=>{
                try {
                    const wc = await this.getWalletConnector();
                    const result = await wc.signPersonalMessage([
                        msgParams.data,
                        msgParams.from
                    ]);
                    cb(null, result);
                } catch (error) {
                    cb(error);
                }
            },
            processSignTransaction: async (txParams, cb)=>{
                try {
                    const wc = await this.getWalletConnector();
                    const result = await wc.signTransaction(txParams);
                    cb(null, result);
                } catch (error) {
                    cb(error);
                }
            },
            processTransaction: async (txParams, cb)=>{
                try {
                    const wc = await this.getWalletConnector();
                    const result = await wc.sendTransaction(txParams);
                    cb(null, result);
                } catch (error) {
                    cb(error);
                }
            },
            processTypedMessage: async (msgParams, cb)=>{
                try {
                    const wc = await this.getWalletConnector();
                    const result = await wc.signTypedData([
                        msgParams.from,
                        msgParams.data
                    ]);
                    cb(null, result);
                } catch (error) {
                    cb(error);
                }
            }
        };
    }
}
exports.default = WalletConnectProvider;

},{"@walletconnect/client":"iB41D","@walletconnect/qrcode-modal":"Wz2Iq","@walletconnect/http-connection":"dANEb","@walletconnect/utils":"bFQqa","b80bbe8b0fbe31cb":"2acpv","af24006f6943c7c3":"lNrGT","e036dee8d54164be":"5JTn0","7f082979dcab662c":"aYYa1","8bec61bf0c08ae71":"eJsBr","fb6560ed77323097":"cKtcd","573a71e1346cbad2":"eLZic","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"iB41D":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _core = require("@walletconnect/core");
var _coreDefault = parcelHelpers.interopDefault(_core);
var _isoCrypto = require("@walletconnect/iso-crypto");
class WalletConnect extends (0, _coreDefault.default) {
    constructor(connectorOpts, pushServerOpts){
        super({
            cryptoLib: _isoCrypto,
            connectorOpts,
            pushServerOpts
        });
    }
}
exports.default = WalletConnect;

},{"@walletconnect/core":"1zxcH","@walletconnect/iso-crypto":"2pBwP","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"1zxcH":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _utils = require("@walletconnect/utils");
var _socketTransport = require("@walletconnect/socket-transport");
var _socketTransportDefault = parcelHelpers.interopDefault(_socketTransport);
var _errors = require("./errors");
var _events = require("./events");
var _eventsDefault = parcelHelpers.interopDefault(_events);
var _storage = require("./storage");
var _storageDefault = parcelHelpers.interopDefault(_storage);
var _url = require("./url");
class Connector {
    constructor(opts){
        this.protocol = "wc";
        this.version = 1;
        this._bridge = "";
        this._key = null;
        this._clientId = "";
        this._clientMeta = null;
        this._peerId = "";
        this._peerMeta = null;
        this._handshakeId = 0;
        this._handshakeTopic = "";
        this._connected = false;
        this._accounts = [];
        this._chainId = 0;
        this._networkId = 0;
        this._rpcUrl = "";
        this._eventManager = new (0, _eventsDefault.default)();
        this._clientMeta = (0, _utils.getClientMeta)() || opts.connectorOpts.clientMeta || null;
        this._cryptoLib = opts.cryptoLib;
        this._sessionStorage = opts.sessionStorage || new (0, _storageDefault.default)(opts.connectorOpts.storageId);
        this._qrcodeModal = opts.connectorOpts.qrcodeModal;
        this._qrcodeModalOptions = opts.connectorOpts.qrcodeModalOptions;
        this._signingMethods = [
            ...(0, _utils.signingMethods),
            ...opts.connectorOpts.signingMethods || []
        ];
        if (!opts.connectorOpts.bridge && !opts.connectorOpts.uri && !opts.connectorOpts.session) throw new Error((0, _errors.ERROR_MISSING_REQUIRED));
        if (opts.connectorOpts.bridge) this.bridge = (0, _url.getBridgeUrl)(opts.connectorOpts.bridge);
        if (opts.connectorOpts.uri) this.uri = opts.connectorOpts.uri;
        const session = opts.connectorOpts.session || this._getStorageSession();
        if (session) this.session = session;
        if (this.handshakeId) this._subscribeToSessionResponse(this.handshakeId, "Session request rejected");
        this._transport = opts.transport || new (0, _socketTransportDefault.default)({
            protocol: this.protocol,
            version: this.version,
            url: this.bridge,
            subscriptions: [
                this.clientId
            ]
        });
        this._subscribeToInternalEvents();
        this._initTransport();
        if (opts.connectorOpts.uri) this._subscribeToSessionRequest();
        if (opts.pushServerOpts) this._registerPushServer(opts.pushServerOpts);
    }
    set bridge(value) {
        if (!value) return;
        this._bridge = value;
    }
    get bridge() {
        return this._bridge;
    }
    set key(value) {
        if (!value) return;
        const key = (0, _utils.convertHexToArrayBuffer)(value);
        this._key = key;
    }
    get key() {
        if (this._key) {
            const key = (0, _utils.convertArrayBufferToHex)(this._key, true);
            return key;
        }
        return "";
    }
    set clientId(value) {
        if (!value) return;
        this._clientId = value;
    }
    get clientId() {
        let clientId = this._clientId;
        if (!clientId) clientId = this._clientId = (0, _utils.uuid)();
        return this._clientId;
    }
    set peerId(value) {
        if (!value) return;
        this._peerId = value;
    }
    get peerId() {
        return this._peerId;
    }
    set clientMeta(value) {}
    get clientMeta() {
        let clientMeta = this._clientMeta;
        if (!clientMeta) clientMeta = this._clientMeta = (0, _utils.getClientMeta)();
        return clientMeta;
    }
    set peerMeta(value) {
        this._peerMeta = value;
    }
    get peerMeta() {
        const peerMeta = this._peerMeta;
        return peerMeta;
    }
    set handshakeTopic(value) {
        if (!value) return;
        this._handshakeTopic = value;
    }
    get handshakeTopic() {
        return this._handshakeTopic;
    }
    set handshakeId(value) {
        if (!value) return;
        this._handshakeId = value;
    }
    get handshakeId() {
        return this._handshakeId;
    }
    get uri() {
        const _uri = this._formatUri();
        return _uri;
    }
    set uri(value) {
        if (!value) return;
        const { handshakeTopic, bridge, key } = this._parseUri(value);
        this.handshakeTopic = handshakeTopic;
        this.bridge = bridge;
        this.key = key;
    }
    set chainId(value) {
        this._chainId = value;
    }
    get chainId() {
        const chainId = this._chainId;
        return chainId;
    }
    set networkId(value) {
        this._networkId = value;
    }
    get networkId() {
        const networkId = this._networkId;
        return networkId;
    }
    set accounts(value) {
        this._accounts = value;
    }
    get accounts() {
        const accounts = this._accounts;
        return accounts;
    }
    set rpcUrl(value) {
        this._rpcUrl = value;
    }
    get rpcUrl() {
        const rpcUrl = this._rpcUrl;
        return rpcUrl;
    }
    set connected(value) {}
    get connected() {
        return this._connected;
    }
    set pending(value) {}
    get pending() {
        return !!this._handshakeTopic;
    }
    get session() {
        return {
            connected: this.connected,
            accounts: this.accounts,
            chainId: this.chainId,
            bridge: this.bridge,
            key: this.key,
            clientId: this.clientId,
            clientMeta: this.clientMeta,
            peerId: this.peerId,
            peerMeta: this.peerMeta,
            handshakeId: this.handshakeId,
            handshakeTopic: this.handshakeTopic
        };
    }
    set session(value) {
        if (!value) return;
        this._connected = value.connected;
        this.accounts = value.accounts;
        this.chainId = value.chainId;
        this.bridge = value.bridge;
        this.key = value.key;
        this.clientId = value.clientId;
        this.clientMeta = value.clientMeta;
        this.peerId = value.peerId;
        this.peerMeta = value.peerMeta;
        this.handshakeId = value.handshakeId;
        this.handshakeTopic = value.handshakeTopic;
    }
    on(event, callback) {
        const eventEmitter = {
            event,
            callback
        };
        this._eventManager.subscribe(eventEmitter);
    }
    off(event) {
        this._eventManager.unsubscribe(event);
    }
    async createInstantRequest(instantRequest) {
        this._key = await this._generateKey();
        const request = this._formatRequest({
            method: "wc_instantRequest",
            params: [
                {
                    peerId: this.clientId,
                    peerMeta: this.clientMeta,
                    request: this._formatRequest(instantRequest)
                }
            ]
        });
        this.handshakeId = request.id;
        this.handshakeTopic = (0, _utils.uuid)();
        this._eventManager.trigger({
            event: "display_uri",
            params: [
                this.uri
            ]
        });
        this.on("modal_closed", ()=>{
            throw new Error((0, _errors.ERROR_QRCODE_MODAL_USER_CLOSED));
        });
        const endInstantRequest = ()=>{
            this.killSession();
        };
        try {
            const result = await this._sendCallRequest(request);
            if (result) endInstantRequest();
            return result;
        } catch (error) {
            endInstantRequest();
            throw error;
        }
    }
    async connect(opts) {
        if (!this._qrcodeModal) throw new Error((0, _errors.ERROR_QRCODE_MODAL_NOT_PROVIDED));
        if (this.connected) return {
            chainId: this.chainId,
            accounts: this.accounts
        };
        await this.createSession(opts);
        return new Promise(async (resolve, reject)=>{
            this.on("modal_closed", ()=>reject(new Error((0, _errors.ERROR_QRCODE_MODAL_USER_CLOSED))));
            this.on("connect", (error, payload)=>{
                if (error) return reject(error);
                resolve(payload.params[0]);
            });
        });
    }
    async createSession(opts) {
        if (this._connected) throw new Error((0, _errors.ERROR_SESSION_CONNECTED));
        if (this.pending) return;
        this._key = await this._generateKey();
        const request = this._formatRequest({
            method: "wc_sessionRequest",
            params: [
                {
                    peerId: this.clientId,
                    peerMeta: this.clientMeta,
                    chainId: opts && opts.chainId ? opts.chainId : null
                }
            ]
        });
        this.handshakeId = request.id;
        this.handshakeTopic = (0, _utils.uuid)();
        this._sendSessionRequest(request, "Session update rejected", {
            topic: this.handshakeTopic
        });
        this._eventManager.trigger({
            event: "display_uri",
            params: [
                this.uri
            ]
        });
    }
    approveSession(sessionStatus) {
        if (this._connected) throw new Error((0, _errors.ERROR_SESSION_CONNECTED));
        this.chainId = sessionStatus.chainId;
        this.accounts = sessionStatus.accounts;
        this.networkId = sessionStatus.networkId || 0;
        this.rpcUrl = sessionStatus.rpcUrl || "";
        const sessionParams = {
            approved: true,
            chainId: this.chainId,
            networkId: this.networkId,
            accounts: this.accounts,
            rpcUrl: this.rpcUrl,
            peerId: this.clientId,
            peerMeta: this.clientMeta
        };
        const response = {
            id: this.handshakeId,
            jsonrpc: "2.0",
            result: sessionParams
        };
        this._sendResponse(response);
        this._connected = true;
        this._setStorageSession();
        this._eventManager.trigger({
            event: "connect",
            params: [
                {
                    peerId: this.peerId,
                    peerMeta: this.peerMeta,
                    chainId: this.chainId,
                    accounts: this.accounts
                }
            ]
        });
    }
    rejectSession(sessionError) {
        if (this._connected) throw new Error((0, _errors.ERROR_SESSION_CONNECTED));
        const message = sessionError && sessionError.message ? sessionError.message : (0, _errors.ERROR_SESSION_REJECTED);
        const response = this._formatResponse({
            id: this.handshakeId,
            error: {
                message
            }
        });
        this._sendResponse(response);
        this._connected = false;
        this._eventManager.trigger({
            event: "disconnect",
            params: [
                {
                    message
                }
            ]
        });
        this._removeStorageSession();
    }
    updateSession(sessionStatus) {
        if (!this._connected) throw new Error((0, _errors.ERROR_SESSION_DISCONNECTED));
        this.chainId = sessionStatus.chainId;
        this.accounts = sessionStatus.accounts;
        this.networkId = sessionStatus.networkId || 0;
        this.rpcUrl = sessionStatus.rpcUrl || "";
        const sessionParams = {
            approved: true,
            chainId: this.chainId,
            networkId: this.networkId,
            accounts: this.accounts,
            rpcUrl: this.rpcUrl
        };
        const request = this._formatRequest({
            method: "wc_sessionUpdate",
            params: [
                sessionParams
            ]
        });
        this._sendSessionRequest(request, "Session update rejected");
        this._eventManager.trigger({
            event: "session_update",
            params: [
                {
                    chainId: this.chainId,
                    accounts: this.accounts
                }
            ]
        });
        this._manageStorageSession();
    }
    async killSession(sessionError) {
        const message = sessionError ? sessionError.message : "Session Disconnected";
        const sessionParams = {
            approved: false,
            chainId: null,
            networkId: null,
            accounts: null
        };
        const request = this._formatRequest({
            method: "wc_sessionUpdate",
            params: [
                sessionParams
            ]
        });
        await this._sendRequest(request);
        this._handleSessionDisconnect(message);
    }
    async sendTransaction(tx) {
        if (!this._connected) throw new Error((0, _errors.ERROR_SESSION_DISCONNECTED));
        const parsedTx = (0, _utils.parseTransactionData)(tx);
        const request = this._formatRequest({
            method: "eth_sendTransaction",
            params: [
                parsedTx
            ]
        });
        const result = await this._sendCallRequest(request);
        return result;
    }
    async signTransaction(tx) {
        if (!this._connected) throw new Error((0, _errors.ERROR_SESSION_DISCONNECTED));
        const parsedTx = (0, _utils.parseTransactionData)(tx);
        const request = this._formatRequest({
            method: "eth_signTransaction",
            params: [
                parsedTx
            ]
        });
        const result = await this._sendCallRequest(request);
        return result;
    }
    async signMessage(params) {
        if (!this._connected) throw new Error((0, _errors.ERROR_SESSION_DISCONNECTED));
        const request = this._formatRequest({
            method: "eth_sign",
            params
        });
        const result = await this._sendCallRequest(request);
        return result;
    }
    async signPersonalMessage(params) {
        if (!this._connected) throw new Error((0, _errors.ERROR_SESSION_DISCONNECTED));
        params = (0, _utils.parsePersonalSign)(params);
        const request = this._formatRequest({
            method: "personal_sign",
            params
        });
        const result = await this._sendCallRequest(request);
        return result;
    }
    async signTypedData(params) {
        if (!this._connected) throw new Error((0, _errors.ERROR_SESSION_DISCONNECTED));
        const request = this._formatRequest({
            method: "eth_signTypedData",
            params
        });
        const result = await this._sendCallRequest(request);
        return result;
    }
    async updateChain(chainParams) {
        if (!this._connected) throw new Error("Session currently disconnected");
        const request = this._formatRequest({
            method: "wallet_updateChain",
            params: [
                chainParams
            ]
        });
        const result = await this._sendCallRequest(request);
        return result;
    }
    unsafeSend(request, options) {
        this._sendRequest(request, options);
        this._eventManager.trigger({
            event: "call_request_sent",
            params: [
                {
                    request,
                    options
                }
            ]
        });
        return new Promise((resolve, reject)=>{
            this._subscribeToResponse(request.id, (error, payload)=>{
                if (error) {
                    reject(error);
                    return;
                }
                if (!payload) throw new Error((0, _errors.ERROR_MISSING_JSON_RPC));
                resolve(payload);
            });
        });
    }
    async sendCustomRequest(request, options) {
        if (!this._connected) throw new Error((0, _errors.ERROR_SESSION_DISCONNECTED));
        switch(request.method){
            case "eth_accounts":
                return this.accounts;
            case "eth_chainId":
                return (0, _utils.convertNumberToHex)(this.chainId);
            case "eth_sendTransaction":
            case "eth_signTransaction":
                if (request.params) request.params[0] = (0, _utils.parseTransactionData)(request.params[0]);
                break;
            case "personal_sign":
                if (request.params) request.params = (0, _utils.parsePersonalSign)(request.params);
                break;
            default:
                break;
        }
        const formattedRequest = this._formatRequest(request);
        const result = await this._sendCallRequest(formattedRequest, options);
        return result;
    }
    approveRequest(response) {
        if ((0, _utils.isJsonRpcResponseSuccess)(response)) {
            const formattedResponse = this._formatResponse(response);
            this._sendResponse(formattedResponse);
        } else throw new Error((0, _errors.ERROR_MISSING_RESULT));
    }
    rejectRequest(response) {
        if ((0, _utils.isJsonRpcResponseError)(response)) {
            const formattedResponse = this._formatResponse(response);
            this._sendResponse(formattedResponse);
        } else throw new Error((0, _errors.ERROR_MISSING_ERROR));
    }
    transportClose() {
        this._transport.close();
    }
    async _sendRequest(request, options) {
        const callRequest = this._formatRequest(request);
        const encryptionPayload = await this._encrypt(callRequest);
        const topic = typeof (options === null || options === void 0 ? void 0 : options.topic) !== "undefined" ? options.topic : this.peerId;
        const payload = JSON.stringify(encryptionPayload);
        const silent = typeof (options === null || options === void 0 ? void 0 : options.forcePushNotification) !== "undefined" ? !options.forcePushNotification : (0, _utils.isSilentPayload)(callRequest);
        this._transport.send(payload, topic, silent);
    }
    async _sendResponse(response) {
        const encryptionPayload = await this._encrypt(response);
        const topic = this.peerId;
        const payload = JSON.stringify(encryptionPayload);
        const silent = true;
        this._transport.send(payload, topic, silent);
    }
    async _sendSessionRequest(request, errorMsg, options) {
        this._sendRequest(request, options);
        this._subscribeToSessionResponse(request.id, errorMsg);
    }
    _sendCallRequest(request, options) {
        this._sendRequest(request, options);
        this._eventManager.trigger({
            event: "call_request_sent",
            params: [
                {
                    request,
                    options
                }
            ]
        });
        return this._subscribeToCallResponse(request.id);
    }
    _formatRequest(request) {
        if (typeof request.method === "undefined") throw new Error((0, _errors.ERROR_MISSING_METHOD));
        const formattedRequest = {
            id: typeof request.id === "undefined" ? (0, _utils.payloadId)() : request.id,
            jsonrpc: "2.0",
            method: request.method,
            params: typeof request.params === "undefined" ? [] : request.params
        };
        return formattedRequest;
    }
    _formatResponse(response) {
        if (typeof response.id === "undefined") throw new Error((0, _errors.ERROR_MISSING_ID));
        const baseResponse = {
            id: response.id,
            jsonrpc: "2.0"
        };
        if ((0, _utils.isJsonRpcResponseError)(response)) {
            const error = (0, _utils.formatRpcError)(response.error);
            const errorResponse = Object.assign(Object.assign(Object.assign({}, baseResponse), response), {
                error
            });
            return errorResponse;
        } else if ((0, _utils.isJsonRpcResponseSuccess)(response)) {
            const successResponse = Object.assign(Object.assign({}, baseResponse), response);
            return successResponse;
        }
        throw new Error((0, _errors.ERROR_INVALID_RESPONSE));
    }
    _handleSessionDisconnect(errorMsg) {
        const message = errorMsg || "Session Disconnected";
        if (!this._connected) {
            if (this._qrcodeModal) this._qrcodeModal.close();
            (0, _utils.removeLocal)((0, _utils.mobileLinkChoiceKey));
        }
        if (this._connected) this._connected = false;
        if (this._handshakeId) this._handshakeId = 0;
        if (this._handshakeTopic) this._handshakeTopic = "";
        if (this._peerId) this._peerId = "";
        this._eventManager.trigger({
            event: "disconnect",
            params: [
                {
                    message
                }
            ]
        });
        this._removeStorageSession();
        this.transportClose();
    }
    _handleSessionResponse(errorMsg, sessionParams) {
        if (sessionParams) {
            if (sessionParams.approved) {
                if (!this._connected) {
                    this._connected = true;
                    if (sessionParams.chainId) this.chainId = sessionParams.chainId;
                    if (sessionParams.accounts) this.accounts = sessionParams.accounts;
                    if (sessionParams.peerId && !this.peerId) this.peerId = sessionParams.peerId;
                    if (sessionParams.peerMeta && !this.peerMeta) this.peerMeta = sessionParams.peerMeta;
                    this._eventManager.trigger({
                        event: "connect",
                        params: [
                            {
                                peerId: this.peerId,
                                peerMeta: this.peerMeta,
                                chainId: this.chainId,
                                accounts: this.accounts
                            }
                        ]
                    });
                } else {
                    if (sessionParams.chainId) this.chainId = sessionParams.chainId;
                    if (sessionParams.accounts) this.accounts = sessionParams.accounts;
                    this._eventManager.trigger({
                        event: "session_update",
                        params: [
                            {
                                chainId: this.chainId,
                                accounts: this.accounts
                            }
                        ]
                    });
                }
                this._manageStorageSession();
            } else this._handleSessionDisconnect(errorMsg);
        } else this._handleSessionDisconnect(errorMsg);
    }
    async _handleIncomingMessages(socketMessage) {
        const activeTopics = [
            this.clientId,
            this.handshakeTopic
        ];
        if (!activeTopics.includes(socketMessage.topic)) return;
        let encryptionPayload;
        try {
            encryptionPayload = JSON.parse(socketMessage.payload);
        } catch (error) {
            return;
        }
        const payload = await this._decrypt(encryptionPayload);
        if (payload) this._eventManager.trigger(payload);
    }
    _subscribeToSessionRequest() {
        this._transport.subscribe(this.handshakeTopic);
    }
    _subscribeToResponse(id, callback) {
        this.on(`response:${id}`, callback);
    }
    _subscribeToSessionResponse(id, errorMsg) {
        this._subscribeToResponse(id, (error, payload)=>{
            if (error) {
                this._handleSessionResponse(error.message);
                return;
            }
            if ((0, _utils.isJsonRpcResponseSuccess)(payload)) this._handleSessionResponse(errorMsg, payload.result);
            else if (payload.error && payload.error.message) this._handleSessionResponse(payload.error.message);
            else this._handleSessionResponse(errorMsg);
        });
    }
    _subscribeToCallResponse(id) {
        return new Promise((resolve, reject)=>{
            this._subscribeToResponse(id, (error, payload)=>{
                if (error) {
                    reject(error);
                    return;
                }
                if ((0, _utils.isJsonRpcResponseSuccess)(payload)) resolve(payload.result);
                else if (payload.error && payload.error.message) reject(payload.error);
                else reject(new Error((0, _errors.ERROR_INVALID_RESPONSE)));
            });
        });
    }
    _subscribeToInternalEvents() {
        this.on("display_uri", ()=>{
            if (this._qrcodeModal) this._qrcodeModal.open(this.uri, ()=>{
                this._eventManager.trigger({
                    event: "modal_closed",
                    params: []
                });
            }, this._qrcodeModalOptions);
        });
        this.on("connect", ()=>{
            if (this._qrcodeModal) this._qrcodeModal.close();
        });
        this.on("call_request_sent", (error, payload)=>{
            const { request } = payload.params[0];
            if ((0, _utils.isMobile)() && this._signingMethods.includes(request.method)) {
                const mobileLinkUrl = (0, _utils.getLocal)((0, _utils.mobileLinkChoiceKey));
                if (mobileLinkUrl) window.location.href = mobileLinkUrl.href;
            }
        });
        this.on("wc_sessionRequest", (error, payload)=>{
            if (error) this._eventManager.trigger({
                event: "error",
                params: [
                    {
                        code: "SESSION_REQUEST_ERROR",
                        message: error.toString()
                    }
                ]
            });
            this.handshakeId = payload.id;
            this.peerId = payload.params[0].peerId;
            this.peerMeta = payload.params[0].peerMeta;
            const internalPayload = Object.assign(Object.assign({}, payload), {
                method: "session_request"
            });
            this._eventManager.trigger(internalPayload);
        });
        this.on("wc_sessionUpdate", (error, payload)=>{
            if (error) this._handleSessionResponse(error.message);
            this._handleSessionResponse("Session disconnected", payload.params[0]);
        });
    }
    _initTransport() {
        this._transport.on("message", (socketMessage)=>this._handleIncomingMessages(socketMessage));
        this._transport.on("open", ()=>this._eventManager.trigger({
                event: "transport_open",
                params: []
            }));
        this._transport.on("close", ()=>this._eventManager.trigger({
                event: "transport_close",
                params: []
            }));
        this._transport.on("error", ()=>this._eventManager.trigger({
                event: "transport_error",
                params: [
                    "Websocket connection failed"
                ]
            }));
        this._transport.open();
    }
    _formatUri() {
        const protocol = this.protocol;
        const handshakeTopic = this.handshakeTopic;
        const version = this.version;
        const bridge = encodeURIComponent(this.bridge);
        const key = this.key;
        const uri = `${protocol}:${handshakeTopic}@${version}?bridge=${bridge}&key=${key}`;
        return uri;
    }
    _parseUri(uri) {
        const result = (0, _utils.parseWalletConnectUri)(uri);
        if (result.protocol === this.protocol) {
            if (!result.handshakeTopic) throw Error("Invalid or missing handshakeTopic parameter value");
            const handshakeTopic = result.handshakeTopic;
            if (!result.bridge) throw Error("Invalid or missing bridge url parameter value");
            const bridge = decodeURIComponent(result.bridge);
            if (!result.key) throw Error("Invalid or missing key parameter value");
            const key = result.key;
            return {
                handshakeTopic,
                bridge,
                key
            };
        } else throw new Error((0, _errors.ERROR_INVALID_URI));
    }
    async _generateKey() {
        if (this._cryptoLib) {
            const result = await this._cryptoLib.generateKey();
            return result;
        }
        return null;
    }
    async _encrypt(data) {
        const key = this._key;
        if (this._cryptoLib && key) {
            const result = await this._cryptoLib.encrypt(data, key);
            return result;
        }
        return null;
    }
    async _decrypt(payload) {
        const key = this._key;
        if (this._cryptoLib && key) {
            const result = await this._cryptoLib.decrypt(payload, key);
            return result;
        }
        return null;
    }
    _getStorageSession() {
        let result = null;
        if (this._sessionStorage) result = this._sessionStorage.getSession();
        return result;
    }
    _setStorageSession() {
        if (this._sessionStorage) this._sessionStorage.setSession(this.session);
    }
    _removeStorageSession() {
        if (this._sessionStorage) this._sessionStorage.removeSession();
    }
    _manageStorageSession() {
        if (this._connected) this._setStorageSession();
        else this._removeStorageSession();
    }
    _registerPushServer(pushServerOpts) {
        if (!pushServerOpts.url || typeof pushServerOpts.url !== "string") throw Error("Invalid or missing pushServerOpts.url parameter value");
        if (!pushServerOpts.type || typeof pushServerOpts.type !== "string") throw Error("Invalid or missing pushServerOpts.type parameter value");
        if (!pushServerOpts.token || typeof pushServerOpts.token !== "string") throw Error("Invalid or missing pushServerOpts.token parameter value");
        const pushSubscription = {
            bridge: this.bridge,
            topic: this.clientId,
            type: pushServerOpts.type,
            token: pushServerOpts.token,
            peerName: "",
            language: pushServerOpts.language || ""
        };
        this.on("connect", async (error, payload)=>{
            if (error) throw error;
            if (pushServerOpts.peerMeta) {
                const peerName = payload.params[0].peerMeta.name;
                pushSubscription.peerName = peerName;
            }
            try {
                const response = await fetch(`${pushServerOpts.url}/new`, {
                    method: "POST",
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "application/json"
                    },
                    body: JSON.stringify(pushSubscription)
                });
                const json = await response.json();
                if (!json.success) throw Error("Failed to register in Push Server");
            } catch (error) {
                throw Error("Failed to register in Push Server");
            }
        });
    }
}
exports.default = Connector;

},{"@walletconnect/utils":"bFQqa","@walletconnect/socket-transport":"gJV9X","./errors":"4WfNb","./events":"j47yZ","./storage":"lpAt8","./url":"k2XH2","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"bFQqa":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _browserUtils = require("@walletconnect/browser-utils");
parcelHelpers.exportAll(_browserUtils, exports);
var _constants = require("./constants");
parcelHelpers.exportAll(_constants, exports);
var _encoding = require("./encoding");
parcelHelpers.exportAll(_encoding, exports);
var _ethereum = require("./ethereum");
parcelHelpers.exportAll(_ethereum, exports);
var _misc = require("./misc");
parcelHelpers.exportAll(_misc, exports);
var _payload = require("./payload");
parcelHelpers.exportAll(_payload, exports);
var _session = require("./session");
parcelHelpers.exportAll(_session, exports);
var _url = require("./url");
parcelHelpers.exportAll(_url, exports);
var _validators = require("./validators");
parcelHelpers.exportAll(_validators, exports);

},{"@walletconnect/browser-utils":"5uxh8","./constants":"dx6md","./encoding":"2rdaL","./ethereum":"9dyAP","./misc":"6tzxQ","./payload":"i6C0L","./session":"f7wDl","./url":"1cGmR","./validators":"lkbI7","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"5uxh8":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _browser = require("./browser");
parcelHelpers.exportAll(_browser, exports);
var _json = require("./json");
parcelHelpers.exportAll(_json, exports);
var _local = require("./local");
parcelHelpers.exportAll(_local, exports);
var _mobile = require("./mobile");
parcelHelpers.exportAll(_mobile, exports);
var _registry = require("./registry");
parcelHelpers.exportAll(_registry, exports);

},{"./browser":"4hf14","./json":"l26Iq","./local":"dxA7J","./mobile":"k0rpd","./registry":"3s2kY","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4hf14":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "detectEnv", ()=>detectEnv);
parcelHelpers.export(exports, "detectOS", ()=>detectOS);
parcelHelpers.export(exports, "isAndroid", ()=>isAndroid);
parcelHelpers.export(exports, "isIOS", ()=>isIOS);
parcelHelpers.export(exports, "isMobile", ()=>isMobile);
parcelHelpers.export(exports, "isNode", ()=>isNode);
parcelHelpers.export(exports, "isBrowser", ()=>isBrowser);
parcelHelpers.export(exports, "getFromWindow", ()=>getFromWindow);
parcelHelpers.export(exports, "getFromWindowOrThrow", ()=>getFromWindowOrThrow);
parcelHelpers.export(exports, "getDocumentOrThrow", ()=>getDocumentOrThrow);
parcelHelpers.export(exports, "getDocument", ()=>getDocument);
parcelHelpers.export(exports, "getNavigatorOrThrow", ()=>getNavigatorOrThrow);
parcelHelpers.export(exports, "getNavigator", ()=>getNavigator);
parcelHelpers.export(exports, "getLocationOrThrow", ()=>getLocationOrThrow);
parcelHelpers.export(exports, "getLocation", ()=>getLocation);
parcelHelpers.export(exports, "getCryptoOrThrow", ()=>getCryptoOrThrow);
parcelHelpers.export(exports, "getCrypto", ()=>getCrypto);
parcelHelpers.export(exports, "getLocalStorageOrThrow", ()=>getLocalStorageOrThrow);
parcelHelpers.export(exports, "getLocalStorage", ()=>getLocalStorage);
parcelHelpers.export(exports, "getClientMeta", ()=>getClientMeta);
var _windowMetadata = require("@walletconnect/window-metadata");
var _windowGetters = require("@walletconnect/window-getters");
var _detectBrowser = require("detect-browser");
function detectEnv(userAgent) {
    return (0, _detectBrowser.detect)(userAgent);
}
function detectOS() {
    const env = detectEnv();
    return env && env.os ? env.os : undefined;
}
function isAndroid() {
    const os = detectOS();
    return os ? os.toLowerCase().includes("android") : false;
}
function isIOS() {
    const os = detectOS();
    return os ? os.toLowerCase().includes("ios") || os.toLowerCase().includes("mac") && navigator.maxTouchPoints > 1 : false;
}
function isMobile() {
    const os = detectOS();
    return os ? isAndroid() || isIOS() : false;
}
function isNode() {
    const env = detectEnv();
    const result = env && env.name ? env.name.toLowerCase() === "node" : false;
    return result;
}
function isBrowser() {
    const result = !isNode() && !!getNavigator();
    return result;
}
const getFromWindow = _windowGetters.getFromWindow;
const getFromWindowOrThrow = _windowGetters.getFromWindowOrThrow;
const getDocumentOrThrow = _windowGetters.getDocumentOrThrow;
const getDocument = _windowGetters.getDocument;
const getNavigatorOrThrow = _windowGetters.getNavigatorOrThrow;
const getNavigator = _windowGetters.getNavigator;
const getLocationOrThrow = _windowGetters.getLocationOrThrow;
const getLocation = _windowGetters.getLocation;
const getCryptoOrThrow = _windowGetters.getCryptoOrThrow;
const getCrypto = _windowGetters.getCrypto;
const getLocalStorageOrThrow = _windowGetters.getLocalStorageOrThrow;
const getLocalStorage = _windowGetters.getLocalStorage;
function getClientMeta() {
    return _windowMetadata.getWindowMetadata();
}

},{"@walletconnect/window-metadata":"5mGkl","@walletconnect/window-getters":"igbNt","detect-browser":"CIp0q","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"5mGkl":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getWindowMetadata = void 0;
const window_getters_1 = require("17ee693c665ef3c1");
function getWindowMetadata() {
    let doc;
    let loc;
    try {
        doc = window_getters_1.getDocumentOrThrow();
        loc = window_getters_1.getLocationOrThrow();
    } catch (e) {
        return null;
    }
    function getIcons() {
        const links = doc.getElementsByTagName("link");
        const icons = [];
        for(let i = 0; i < links.length; i++){
            const link = links[i];
            const rel = link.getAttribute("rel");
            if (rel) {
                if (rel.toLowerCase().indexOf("icon") > -1) {
                    const href = link.getAttribute("href");
                    if (href) {
                        if (href.toLowerCase().indexOf("https:") === -1 && href.toLowerCase().indexOf("http:") === -1 && href.indexOf("//") !== 0) {
                            let absoluteHref = loc.protocol + "//" + loc.host;
                            if (href.indexOf("/") === 0) absoluteHref += href;
                            else {
                                const path = loc.pathname.split("/");
                                path.pop();
                                const finalPath = path.join("/");
                                absoluteHref += finalPath + "/" + href;
                            }
                            icons.push(absoluteHref);
                        } else if (href.indexOf("//") === 0) {
                            const absoluteUrl = loc.protocol + href;
                            icons.push(absoluteUrl);
                        } else icons.push(href);
                    }
                }
            }
        }
        return icons;
    }
    function getWindowMetadataOfAny(...args) {
        const metaTags = doc.getElementsByTagName("meta");
        for(let i = 0; i < metaTags.length; i++){
            const tag = metaTags[i];
            const attributes = [
                "itemprop",
                "property",
                "name"
            ].map((target)=>tag.getAttribute(target)).filter((attr)=>{
                if (attr) return args.includes(attr);
                return false;
            });
            if (attributes.length && attributes) {
                const content = tag.getAttribute("content");
                if (content) return content;
            }
        }
        return "";
    }
    function getName() {
        let name = getWindowMetadataOfAny("name", "og:site_name", "og:title", "twitter:title");
        if (!name) name = doc.title;
        return name;
    }
    function getDescription() {
        const description = getWindowMetadataOfAny("description", "og:description", "twitter:description", "keywords");
        return description;
    }
    const name = getName();
    const description = getDescription();
    const url = loc.origin;
    const icons = getIcons();
    const meta = {
        description,
        url,
        icons,
        name
    };
    return meta;
}
exports.getWindowMetadata = getWindowMetadata;

},{"17ee693c665ef3c1":"igbNt"}],"igbNt":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getLocalStorage = exports.getLocalStorageOrThrow = exports.getCrypto = exports.getCryptoOrThrow = exports.getLocation = exports.getLocationOrThrow = exports.getNavigator = exports.getNavigatorOrThrow = exports.getDocument = exports.getDocumentOrThrow = exports.getFromWindowOrThrow = exports.getFromWindow = void 0;
function getFromWindow(name) {
    let res = undefined;
    if (typeof window !== "undefined" && typeof window[name] !== "undefined") res = window[name];
    return res;
}
exports.getFromWindow = getFromWindow;
function getFromWindowOrThrow(name) {
    const res = getFromWindow(name);
    if (!res) throw new Error(`${name} is not defined in Window`);
    return res;
}
exports.getFromWindowOrThrow = getFromWindowOrThrow;
function getDocumentOrThrow() {
    return getFromWindowOrThrow("document");
}
exports.getDocumentOrThrow = getDocumentOrThrow;
function getDocument() {
    return getFromWindow("document");
}
exports.getDocument = getDocument;
function getNavigatorOrThrow() {
    return getFromWindowOrThrow("navigator");
}
exports.getNavigatorOrThrow = getNavigatorOrThrow;
function getNavigator() {
    return getFromWindow("navigator");
}
exports.getNavigator = getNavigator;
function getLocationOrThrow() {
    return getFromWindowOrThrow("location");
}
exports.getLocationOrThrow = getLocationOrThrow;
function getLocation() {
    return getFromWindow("location");
}
exports.getLocation = getLocation;
function getCryptoOrThrow() {
    return getFromWindowOrThrow("crypto");
}
exports.getCryptoOrThrow = getCryptoOrThrow;
function getCrypto() {
    return getFromWindow("crypto");
}
exports.getCrypto = getCrypto;
function getLocalStorageOrThrow() {
    return getFromWindowOrThrow("localStorage");
}
exports.getLocalStorageOrThrow = getLocalStorageOrThrow;
function getLocalStorage() {
    return getFromWindow("localStorage");
}
exports.getLocalStorage = getLocalStorage;

},{}],"CIp0q":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BrowserInfo", ()=>BrowserInfo);
parcelHelpers.export(exports, "NodeInfo", ()=>NodeInfo);
parcelHelpers.export(exports, "SearchBotDeviceInfo", ()=>SearchBotDeviceInfo);
parcelHelpers.export(exports, "BotInfo", ()=>BotInfo);
parcelHelpers.export(exports, "ReactNativeInfo", ()=>ReactNativeInfo);
parcelHelpers.export(exports, "detect", ()=>detect);
parcelHelpers.export(exports, "browserName", ()=>browserName);
parcelHelpers.export(exports, "parseUserAgent", ()=>parseUserAgent);
parcelHelpers.export(exports, "detectOS", ()=>detectOS);
parcelHelpers.export(exports, "getNodeVersion", ()=>getNodeVersion);
var process = require("333d4e2381a056a9");
var __spreadArrays = undefined && undefined.__spreadArrays || function() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
};
var BrowserInfo = /** @class */ function() {
    function BrowserInfo(name, version, os) {
        this.name = name;
        this.version = version;
        this.os = os;
        this.type = "browser";
    }
    return BrowserInfo;
}();
var NodeInfo = /** @class */ function() {
    function NodeInfo(version) {
        this.version = version;
        this.type = "node";
        this.name = "node";
        this.os = process.platform;
    }
    return NodeInfo;
}();
var SearchBotDeviceInfo = /** @class */ function() {
    function SearchBotDeviceInfo(name, version, os, bot) {
        this.name = name;
        this.version = version;
        this.os = os;
        this.bot = bot;
        this.type = "bot-device";
    }
    return SearchBotDeviceInfo;
}();
var BotInfo = /** @class */ function() {
    function BotInfo() {
        this.type = "bot";
        this.bot = true; // NOTE: deprecated test name instead
        this.name = "bot";
        this.version = null;
        this.os = null;
    }
    return BotInfo;
}();
var ReactNativeInfo = /** @class */ function() {
    function ReactNativeInfo() {
        this.type = "react-native";
        this.name = "react-native";
        this.version = null;
        this.os = null;
    }
    return ReactNativeInfo;
}();
// tslint:disable-next-line:max-line-length
var SEARCHBOX_UA_REGEX = /alexa|bot|crawl(er|ing)|facebookexternalhit|feedburner|google web preview|nagios|postrank|pingdom|slurp|spider|yahoo!|yandex/;
var SEARCHBOT_OS_REGEX = /(nuhk|Googlebot|Yammybot|Openbot|Slurp|MSNBot|Ask\ Jeeves\/Teoma|ia_archiver)/;
var REQUIRED_VERSION_PARTS = 3;
var userAgentRules = [
    [
        "aol",
        /AOLShield\/([0-9\._]+)/
    ],
    [
        "edge",
        /Edge\/([0-9\._]+)/
    ],
    [
        "edge-ios",
        /EdgiOS\/([0-9\._]+)/
    ],
    [
        "yandexbrowser",
        /YaBrowser\/([0-9\._]+)/
    ],
    [
        "kakaotalk",
        /KAKAOTALK\s([0-9\.]+)/
    ],
    [
        "samsung",
        /SamsungBrowser\/([0-9\.]+)/
    ],
    [
        "silk",
        /\bSilk\/([0-9._-]+)\b/
    ],
    [
        "miui",
        /MiuiBrowser\/([0-9\.]+)$/
    ],
    [
        "beaker",
        /BeakerBrowser\/([0-9\.]+)/
    ],
    [
        "edge-chromium",
        /EdgA?\/([0-9\.]+)/
    ],
    [
        "chromium-webview",
        /(?!Chrom.*OPR)wv\).*Chrom(?:e|ium)\/([0-9\.]+)(:?\s|$)/
    ],
    [
        "chrome",
        /(?!Chrom.*OPR)Chrom(?:e|ium)\/([0-9\.]+)(:?\s|$)/
    ],
    [
        "phantomjs",
        /PhantomJS\/([0-9\.]+)(:?\s|$)/
    ],
    [
        "crios",
        /CriOS\/([0-9\.]+)(:?\s|$)/
    ],
    [
        "firefox",
        /Firefox\/([0-9\.]+)(?:\s|$)/
    ],
    [
        "fxios",
        /FxiOS\/([0-9\.]+)/
    ],
    [
        "opera-mini",
        /Opera Mini.*Version\/([0-9\.]+)/
    ],
    [
        "opera",
        /Opera\/([0-9\.]+)(?:\s|$)/
    ],
    [
        "opera",
        /OPR\/([0-9\.]+)(:?\s|$)/
    ],
    [
        "ie",
        /Trident\/7\.0.*rv\:([0-9\.]+).*\).*Gecko$/
    ],
    [
        "ie",
        /MSIE\s([0-9\.]+);.*Trident\/[4-7].0/
    ],
    [
        "ie",
        /MSIE\s(7\.0)/
    ],
    [
        "bb10",
        /BB10;\sTouch.*Version\/([0-9\.]+)/
    ],
    [
        "android",
        /Android\s([0-9\.]+)/
    ],
    [
        "ios",
        /Version\/([0-9\._]+).*Mobile.*Safari.*/
    ],
    [
        "safari",
        /Version\/([0-9\._]+).*Safari/
    ],
    [
        "facebook",
        /FBAV\/([0-9\.]+)/
    ],
    [
        "instagram",
        /Instagram\s([0-9\.]+)/
    ],
    [
        "ios-webview",
        /AppleWebKit\/([0-9\.]+).*Mobile/
    ],
    [
        "ios-webview",
        /AppleWebKit\/([0-9\.]+).*Gecko\)$/
    ],
    [
        "searchbot",
        SEARCHBOX_UA_REGEX
    ]
];
var operatingSystemRules = [
    [
        "iOS",
        /iP(hone|od|ad)/
    ],
    [
        "Android OS",
        /Android/
    ],
    [
        "BlackBerry OS",
        /BlackBerry|BB10/
    ],
    [
        "Windows Mobile",
        /IEMobile/
    ],
    [
        "Amazon OS",
        /Kindle/
    ],
    [
        "Windows 3.11",
        /Win16/
    ],
    [
        "Windows 95",
        /(Windows 95)|(Win95)|(Windows_95)/
    ],
    [
        "Windows 98",
        /(Windows 98)|(Win98)/
    ],
    [
        "Windows 2000",
        /(Windows NT 5.0)|(Windows 2000)/
    ],
    [
        "Windows XP",
        /(Windows NT 5.1)|(Windows XP)/
    ],
    [
        "Windows Server 2003",
        /(Windows NT 5.2)/
    ],
    [
        "Windows Vista",
        /(Windows NT 6.0)/
    ],
    [
        "Windows 7",
        /(Windows NT 6.1)/
    ],
    [
        "Windows 8",
        /(Windows NT 6.2)/
    ],
    [
        "Windows 8.1",
        /(Windows NT 6.3)/
    ],
    [
        "Windows 10",
        /(Windows NT 10.0)/
    ],
    [
        "Windows ME",
        /Windows ME/
    ],
    [
        "Open BSD",
        /OpenBSD/
    ],
    [
        "Sun OS",
        /SunOS/
    ],
    [
        "Chrome OS",
        /CrOS/
    ],
    [
        "Linux",
        /(Linux)|(X11)/
    ],
    [
        "Mac OS",
        /(Mac_PowerPC)|(Macintosh)/
    ],
    [
        "QNX",
        /QNX/
    ],
    [
        "BeOS",
        /BeOS/
    ],
    [
        "OS/2",
        /OS\/2/
    ]
];
function detect(userAgent) {
    if (!!userAgent) return parseUserAgent(userAgent);
    if (typeof document === "undefined" && typeof navigator !== "undefined" && navigator.product === "ReactNative") return new ReactNativeInfo();
    if (typeof navigator !== "undefined") return parseUserAgent(navigator.userAgent);
    return getNodeVersion();
}
function matchUserAgent(ua) {
    // opted for using reduce here rather than Array#first with a regex.test call
    // this is primarily because using the reduce we only perform the regex
    // execution once rather than once for the test and for the exec again below
    // probably something that needs to be benchmarked though
    return ua !== "" && userAgentRules.reduce(function(matched, _a) {
        var browser = _a[0], regex = _a[1];
        if (matched) return matched;
        var uaMatch = regex.exec(ua);
        return !!uaMatch && [
            browser,
            uaMatch
        ];
    }, false);
}
function browserName(ua) {
    var data = matchUserAgent(ua);
    return data ? data[0] : null;
}
function parseUserAgent(ua) {
    var matchedRule = matchUserAgent(ua);
    if (!matchedRule) return null;
    var name = matchedRule[0], match = matchedRule[1];
    if (name === "searchbot") return new BotInfo();
    var versionParts = match[1] && match[1].split(/[._]/).slice(0, 3);
    if (versionParts) {
        if (versionParts.length < REQUIRED_VERSION_PARTS) versionParts = __spreadArrays(versionParts, createVersionParts(REQUIRED_VERSION_PARTS - versionParts.length));
    } else versionParts = [];
    var version = versionParts.join(".");
    var os = detectOS(ua);
    var searchBotMatch = SEARCHBOT_OS_REGEX.exec(ua);
    if (searchBotMatch && searchBotMatch[1]) return new SearchBotDeviceInfo(name, version, os, searchBotMatch[1]);
    return new BrowserInfo(name, version, os);
}
function detectOS(ua) {
    for(var ii = 0, count = operatingSystemRules.length; ii < count; ii++){
        var _a = operatingSystemRules[ii], os = _a[0], regex = _a[1];
        var match = regex.exec(ua);
        if (match) return os;
    }
    return null;
}
function getNodeVersion() {
    var isNode = typeof process !== "undefined" && process.version;
    return isNode ? new NodeInfo(process.version.slice(1)) : null;
}
function createVersionParts(count) {
    var output = [];
    for(var ii = 0; ii < count; ii++)output.push("0");
    return output;
}

},{"333d4e2381a056a9":"5QIF0","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"l26Iq":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "safeJsonParse", ()=>safeJsonParse);
parcelHelpers.export(exports, "safeJsonStringify", ()=>safeJsonStringify);
var _safeJson = require("@walletconnect/safe-json");
const safeJsonParse = _safeJson.safeJsonParse;
const safeJsonStringify = _safeJson.safeJsonStringify;

},{"@walletconnect/safe-json":"gaejp","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"gaejp":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "safeJsonParse", ()=>safeJsonParse);
parcelHelpers.export(exports, "safeJsonStringify", ()=>safeJsonStringify);
function safeJsonParse(value) {
    if (typeof value !== "string") throw new Error(`Cannot safe json parse value of type ${typeof value}`);
    try {
        return JSON.parse(value);
    } catch (_a) {
        return value;
    }
}
function safeJsonStringify(value) {
    return typeof value === "string" ? value : JSON.stringify(value);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"dxA7J":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "setLocal", ()=>setLocal);
parcelHelpers.export(exports, "getLocal", ()=>getLocal);
parcelHelpers.export(exports, "removeLocal", ()=>removeLocal);
var _json = require("./json");
var _browser = require("./browser");
function setLocal(key, data) {
    const raw = (0, _json.safeJsonStringify)(data);
    const local = (0, _browser.getLocalStorage)();
    if (local) local.setItem(key, raw);
}
function getLocal(key) {
    let data = null;
    let raw = null;
    const local = (0, _browser.getLocalStorage)();
    if (local) raw = local.getItem(key);
    data = raw ? (0, _json.safeJsonParse)(raw) : raw;
    return data;
}
function removeLocal(key) {
    const local = (0, _browser.getLocalStorage)();
    if (local) local.removeItem(key);
}

},{"./json":"l26Iq","./browser":"4hf14","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"k0rpd":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "mobileLinkChoiceKey", ()=>mobileLinkChoiceKey);
parcelHelpers.export(exports, "formatIOSMobile", ()=>formatIOSMobile);
parcelHelpers.export(exports, "saveMobileLinkInfo", ()=>saveMobileLinkInfo);
parcelHelpers.export(exports, "getMobileRegistryEntry", ()=>getMobileRegistryEntry);
parcelHelpers.export(exports, "getMobileLinkRegistry", ()=>getMobileLinkRegistry);
var _local = require("./local");
const mobileLinkChoiceKey = "WALLETCONNECT_DEEPLINK_CHOICE";
function formatIOSMobile(uri, entry) {
    const encodedUri = encodeURIComponent(uri);
    return entry.universalLink ? `${entry.universalLink}/wc?uri=${encodedUri}` : entry.deepLink ? `${entry.deepLink}${entry.deepLink.endsWith(":") ? "//" : "/"}wc?uri=${encodedUri}` : "";
}
function saveMobileLinkInfo(data) {
    const focusUri = data.href.split("?")[0];
    (0, _local.setLocal)(mobileLinkChoiceKey, Object.assign(Object.assign({}, data), {
        href: focusUri
    }));
}
function getMobileRegistryEntry(registry, name) {
    return registry.filter((entry)=>entry.name.toLowerCase().includes(name.toLowerCase()))[0];
}
function getMobileLinkRegistry(registry, whitelist) {
    let links = registry;
    if (whitelist) links = whitelist.map((name)=>getMobileRegistryEntry(registry, name)).filter(Boolean);
    return links;
}

},{"./local":"dxA7J","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"3s2kY":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getWalletRegistryUrl", ()=>getWalletRegistryUrl);
parcelHelpers.export(exports, "getDappRegistryUrl", ()=>getDappRegistryUrl);
parcelHelpers.export(exports, "formatMobileRegistryEntry", ()=>formatMobileRegistryEntry);
parcelHelpers.export(exports, "formatMobileRegistry", ()=>formatMobileRegistry);
const API_URL = "https://registry.walletconnect.com";
function getWalletRegistryUrl() {
    return API_URL + "/api/v2/wallets";
}
function getDappRegistryUrl() {
    return API_URL + "/api/v2/dapps";
}
function formatMobileRegistryEntry(entry, platform = "mobile") {
    var _a;
    return {
        name: entry.name || "",
        shortName: entry.metadata.shortName || "",
        color: entry.metadata.colors.primary || "",
        logo: (_a = entry.image_url.sm) !== null && _a !== void 0 ? _a : "",
        universalLink: entry[platform].universal || "",
        deepLink: entry[platform].native || ""
    };
}
function formatMobileRegistry(registry, platform = "mobile") {
    return Object.values(registry).filter((entry)=>!!entry[platform].universal || !!entry[platform].native).map((entry)=>formatMobileRegistryEntry(entry, platform));
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"dx6md":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "reservedEvents", ()=>reservedEvents);
parcelHelpers.export(exports, "signingMethods", ()=>signingMethods);
parcelHelpers.export(exports, "stateMethods", ()=>stateMethods);
parcelHelpers.export(exports, "infuraNetworks", ()=>infuraNetworks);
const reservedEvents = [
    "session_request",
    "session_update",
    "exchange_key",
    "connect",
    "disconnect",
    "display_uri",
    "modal_closed",
    "transport_open",
    "transport_close",
    "transport_error"
];
const signingMethods = [
    "eth_sendTransaction",
    "eth_signTransaction",
    "eth_sign",
    "eth_signTypedData",
    "eth_signTypedData_v1",
    "eth_signTypedData_v2",
    "eth_signTypedData_v3",
    "eth_signTypedData_v4",
    "personal_sign",
    "wallet_addEthereumChain",
    "wallet_switchEthereumChain",
    "wallet_getPermissions",
    "wallet_requestPermissions",
    "wallet_registerOnboarding",
    "wallet_watchAsset",
    "wallet_scanQRCode"
];
const stateMethods = [
    "eth_accounts",
    "eth_chainId",
    "net_version"
];
const infuraNetworks = {
    1: "mainnet",
    3: "ropsten",
    4: "rinkeby",
    5: "goerli",
    42: "kovan"
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2rdaL":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "convertArrayBufferToBuffer", ()=>convertArrayBufferToBuffer);
parcelHelpers.export(exports, "convertArrayBufferToUtf8", ()=>convertArrayBufferToUtf8);
parcelHelpers.export(exports, "convertArrayBufferToHex", ()=>convertArrayBufferToHex);
parcelHelpers.export(exports, "convertArrayBufferToNumber", ()=>convertArrayBufferToNumber);
parcelHelpers.export(exports, "concatArrayBuffers", ()=>concatArrayBuffers);
parcelHelpers.export(exports, "convertBufferToArrayBuffer", ()=>convertBufferToArrayBuffer);
parcelHelpers.export(exports, "convertBufferToUtf8", ()=>convertBufferToUtf8);
parcelHelpers.export(exports, "convertBufferToHex", ()=>convertBufferToHex);
parcelHelpers.export(exports, "convertBufferToNumber", ()=>convertBufferToNumber);
parcelHelpers.export(exports, "concatBuffers", ()=>concatBuffers);
parcelHelpers.export(exports, "convertUtf8ToArrayBuffer", ()=>convertUtf8ToArrayBuffer);
parcelHelpers.export(exports, "convertUtf8ToBuffer", ()=>convertUtf8ToBuffer);
parcelHelpers.export(exports, "convertUtf8ToHex", ()=>convertUtf8ToHex);
parcelHelpers.export(exports, "convertUtf8ToNumber", ()=>convertUtf8ToNumber);
parcelHelpers.export(exports, "convertHexToBuffer", ()=>convertHexToBuffer);
parcelHelpers.export(exports, "convertHexToArrayBuffer", ()=>convertHexToArrayBuffer);
parcelHelpers.export(exports, "convertHexToUtf8", ()=>convertHexToUtf8);
parcelHelpers.export(exports, "convertHexToNumber", ()=>convertHexToNumber);
parcelHelpers.export(exports, "convertNumberToBuffer", ()=>convertNumberToBuffer);
parcelHelpers.export(exports, "convertNumberToArrayBuffer", ()=>convertNumberToArrayBuffer);
parcelHelpers.export(exports, "convertNumberToUtf8", ()=>convertNumberToUtf8);
parcelHelpers.export(exports, "convertNumberToHex", ()=>convertNumberToHex);
var _bnJs = require("bn.js");
var _bnJsDefault = parcelHelpers.interopDefault(_bnJs);
var _encoding = require("@walletconnect/encoding");
function convertArrayBufferToBuffer(arrBuf) {
    return _encoding.arrayToBuffer(new Uint8Array(arrBuf));
}
function convertArrayBufferToUtf8(arrBuf) {
    return _encoding.arrayToUtf8(new Uint8Array(arrBuf));
}
function convertArrayBufferToHex(arrBuf, noPrefix) {
    return _encoding.arrayToHex(new Uint8Array(arrBuf), !noPrefix);
}
function convertArrayBufferToNumber(arrBuf) {
    return _encoding.arrayToNumber(new Uint8Array(arrBuf));
}
function concatArrayBuffers(...args) {
    return _encoding.hexToArray(args.map((b)=>_encoding.arrayToHex(new Uint8Array(b))).join("")).buffer;
}
function convertBufferToArrayBuffer(buf) {
    return _encoding.bufferToArray(buf).buffer;
}
function convertBufferToUtf8(buf) {
    return _encoding.bufferToUtf8(buf);
}
function convertBufferToHex(buf, noPrefix) {
    return _encoding.bufferToHex(buf, !noPrefix);
}
function convertBufferToNumber(buf) {
    return _encoding.bufferToNumber(buf);
}
function concatBuffers(...args) {
    return _encoding.concatBuffers(...args);
}
function convertUtf8ToArrayBuffer(utf8) {
    return _encoding.utf8ToArray(utf8).buffer;
}
function convertUtf8ToBuffer(utf8) {
    return _encoding.utf8ToBuffer(utf8);
}
function convertUtf8ToHex(utf8, noPrefix) {
    return _encoding.utf8ToHex(utf8, !noPrefix);
}
function convertUtf8ToNumber(utf8) {
    return new (0, _bnJsDefault.default)(utf8, 10).toNumber();
}
function convertHexToBuffer(hex) {
    return _encoding.hexToBuffer(hex);
}
function convertHexToArrayBuffer(hex) {
    return _encoding.hexToArray(hex).buffer;
}
function convertHexToUtf8(hex) {
    return _encoding.hexToUtf8(hex);
}
function convertHexToNumber(hex) {
    return new (0, _bnJsDefault.default)(_encoding.removeHexPrefix(hex), "hex").toNumber();
}
function convertNumberToBuffer(num) {
    return _encoding.numberToBuffer(num);
}
function convertNumberToArrayBuffer(num) {
    return _encoding.numberToArray(num).buffer;
}
function convertNumberToUtf8(num) {
    return new (0, _bnJsDefault.default)(num).toString();
}
function convertNumberToHex(num, noPrefix) {
    const hex = _encoding.removeHexPrefix(_encoding.sanitizeHex(new (0, _bnJsDefault.default)(num).toString(16)));
    return noPrefix ? hex : _encoding.addHexPrefix(hex);
}

},{"bn.js":"x4ItY","@walletconnect/encoding":"hIv0Z","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"x4ItY":[function(require,module,exports) {
(function(module1, exports) {
    "use strict";
    // Utils
    function assert(val, msg) {
        if (!val) throw new Error(msg || "Assertion failed");
    }
    // Could use `inherits` module, but don't want to move from single file
    // architecture yet.
    function inherits(ctor, superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
    // BN
    function BN(number, base, endian) {
        if (BN.isBN(number)) return number;
        this.negative = 0;
        this.words = null;
        this.length = 0;
        // Reduction context
        this.red = null;
        if (number !== null) {
            if (base === "le" || base === "be") {
                endian = base;
                base = 10;
            }
            this._init(number || 0, base || 10, endian || "be");
        }
    }
    if (typeof module1 === "object") module1.exports = BN;
    else exports.BN = BN;
    BN.BN = BN;
    BN.wordSize = 26;
    var Buffer;
    try {
        Buffer = require("bd440367abe2ded7").Buffer;
    } catch (e) {}
    BN.isBN = function isBN(num) {
        if (num instanceof BN) return true;
        return num !== null && typeof num === "object" && num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
    };
    BN.max = function max(left, right) {
        if (left.cmp(right) > 0) return left;
        return right;
    };
    BN.min = function min(left, right) {
        if (left.cmp(right) < 0) return left;
        return right;
    };
    BN.prototype._init = function init(number, base, endian) {
        if (typeof number === "number") return this._initNumber(number, base, endian);
        if (typeof number === "object") return this._initArray(number, base, endian);
        if (base === "hex") base = 16;
        assert(base === (base | 0) && base >= 2 && base <= 36);
        number = number.toString().replace(/\s+/g, "");
        var start = 0;
        if (number[0] === "-") start++;
        if (base === 16) this._parseHex(number, start);
        else this._parseBase(number, base, start);
        if (number[0] === "-") this.negative = 1;
        this.strip();
        if (endian !== "le") return;
        this._initArray(this.toArray(), base, endian);
    };
    BN.prototype._initNumber = function _initNumber(number, base, endian) {
        if (number < 0) {
            this.negative = 1;
            number = -number;
        }
        if (number < 0x4000000) {
            this.words = [
                number & 0x3ffffff
            ];
            this.length = 1;
        } else if (number < 0x10000000000000) {
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff
            ];
            this.length = 2;
        } else {
            assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff,
                1
            ];
            this.length = 3;
        }
        if (endian !== "le") return;
        // Reverse the bytes
        this._initArray(this.toArray(), base, endian);
    };
    BN.prototype._initArray = function _initArray(number, base, endian) {
        // Perhaps a Uint8Array
        assert(typeof number.length === "number");
        if (number.length <= 0) {
            this.words = [
                0
            ];
            this.length = 1;
            return this;
        }
        this.length = Math.ceil(number.length / 3);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        var j, w;
        var off = 0;
        if (endian === "be") for(i = number.length - 1, j = 0; i >= 0; i -= 3){
            w = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        else if (endian === "le") for(i = 0, j = 0; i < number.length; i += 3){
            w = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        return this.strip();
    };
    function parseHex(str, start, end) {
        var r = 0;
        var len = Math.min(str.length, end);
        for(var i = start; i < len; i++){
            var c = str.charCodeAt(i) - 48;
            r <<= 4;
            // 'a' - 'f'
            if (c >= 49 && c <= 54) r |= c - 49 + 0xa;
            else if (c >= 17 && c <= 22) r |= c - 17 + 0xa;
            else r |= c & 0xf;
        }
        return r;
    }
    BN.prototype._parseHex = function _parseHex(number, start) {
        // Create possibly bigger array to ensure that it fits the number
        this.length = Math.ceil((number.length - start) / 6);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        var j, w;
        // Scan 24-bit chunks and add them to the number
        var off = 0;
        for(i = number.length - 6, j = 0; i >= start; i -= 6){
            w = parseHex(number, i, i + 6);
            this.words[j] |= w << off & 0x3ffffff;
            // NOTE: `0x3fffff` is intentional here, 26bits max shift + 24bit hex limb
            this.words[j + 1] |= w >>> 26 - off & 0x3fffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        if (i + 6 !== start) {
            w = parseHex(number, start, i + 6);
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] |= w >>> 26 - off & 0x3fffff;
        }
        this.strip();
    };
    function parseBase(str, start, end, mul) {
        var r = 0;
        var len = Math.min(str.length, end);
        for(var i = start; i < len; i++){
            var c = str.charCodeAt(i) - 48;
            r *= mul;
            // 'a'
            if (c >= 49) r += c - 49 + 0xa;
            else if (c >= 17) r += c - 17 + 0xa;
            else r += c;
        }
        return r;
    }
    BN.prototype._parseBase = function _parseBase(number, base, start) {
        // Initialize as zero
        this.words = [
            0
        ];
        this.length = 1;
        // Find length of limb in base
        for(var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base)limbLen++;
        limbLen--;
        limbPow = limbPow / base | 0;
        var total = number.length - start;
        var mod = total % limbLen;
        var end = Math.min(total, total - mod) + start;
        var word = 0;
        for(var i = start; i < end; i += limbLen){
            word = parseBase(number, i, i + limbLen, base);
            this.imuln(limbPow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        if (mod !== 0) {
            var pow = 1;
            word = parseBase(number, i, number.length, base);
            for(i = 0; i < mod; i++)pow *= base;
            this.imuln(pow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
    };
    BN.prototype.copy = function copy(dest) {
        dest.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)dest.words[i] = this.words[i];
        dest.length = this.length;
        dest.negative = this.negative;
        dest.red = this.red;
    };
    BN.prototype.clone = function clone() {
        var r = new BN(null);
        this.copy(r);
        return r;
    };
    BN.prototype._expand = function _expand(size) {
        while(this.length < size)this.words[this.length++] = 0;
        return this;
    };
    // Remove leading `0` from `this`
    BN.prototype.strip = function strip() {
        while(this.length > 1 && this.words[this.length - 1] === 0)this.length--;
        return this._normSign();
    };
    BN.prototype._normSign = function _normSign() {
        // -0 = 0
        if (this.length === 1 && this.words[0] === 0) this.negative = 0;
        return this;
    };
    BN.prototype.inspect = function inspect() {
        return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
    };
    /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */ var zeros = [
        "",
        "0",
        "00",
        "000",
        "0000",
        "00000",
        "000000",
        "0000000",
        "00000000",
        "000000000",
        "0000000000",
        "00000000000",
        "000000000000",
        "0000000000000",
        "00000000000000",
        "000000000000000",
        "0000000000000000",
        "00000000000000000",
        "000000000000000000",
        "0000000000000000000",
        "00000000000000000000",
        "000000000000000000000",
        "0000000000000000000000",
        "00000000000000000000000",
        "000000000000000000000000",
        "0000000000000000000000000"
    ];
    var groupSizes = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
    ];
    var groupBases = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        10000000,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64000000,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        24300000,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
    ];
    BN.prototype.toString = function toString(base, padding) {
        base = base || 10;
        padding = padding | 0 || 1;
        var out;
        if (base === 16 || base === "hex") {
            out = "";
            var off = 0;
            var carry = 0;
            for(var i = 0; i < this.length; i++){
                var w = this.words[i];
                var word = ((w << off | carry) & 0xffffff).toString(16);
                carry = w >>> 24 - off & 0xffffff;
                if (carry !== 0 || i !== this.length - 1) out = zeros[6 - word.length] + word + out;
                else out = word + out;
                off += 2;
                if (off >= 26) {
                    off -= 26;
                    i--;
                }
            }
            if (carry !== 0) out = carry.toString(16) + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        if (base === (base | 0) && base >= 2 && base <= 36) {
            // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
            var groupSize = groupSizes[base];
            // var groupBase = Math.pow(base, groupSize);
            var groupBase = groupBases[base];
            out = "";
            var c = this.clone();
            c.negative = 0;
            while(!c.isZero()){
                var r = c.modn(groupBase).toString(base);
                c = c.idivn(groupBase);
                if (!c.isZero()) out = zeros[groupSize - r.length] + r + out;
                else out = r + out;
            }
            if (this.isZero()) out = "0" + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        assert(false, "Base should be between 2 and 36");
    };
    BN.prototype.toNumber = function toNumber() {
        var ret = this.words[0];
        if (this.length === 2) ret += this.words[1] * 0x4000000;
        else if (this.length === 3 && this.words[2] === 0x01) // NOTE: at this stage it is known that the top bit is set
        ret += 0x10000000000000 + this.words[1] * 0x4000000;
        else if (this.length > 2) assert(false, "Number can only safely store up to 53 bits");
        return this.negative !== 0 ? -ret : ret;
    };
    BN.prototype.toJSON = function toJSON() {
        return this.toString(16);
    };
    BN.prototype.toBuffer = function toBuffer(endian, length) {
        assert(typeof Buffer !== "undefined");
        return this.toArrayLike(Buffer, endian, length);
    };
    BN.prototype.toArray = function toArray(endian, length) {
        return this.toArrayLike(Array, endian, length);
    };
    BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
        var byteLength = this.byteLength();
        var reqLength = length || Math.max(1, byteLength);
        assert(byteLength <= reqLength, "byte array longer than desired length");
        assert(reqLength > 0, "Requested array length <= 0");
        this.strip();
        var littleEndian = endian === "le";
        var res = new ArrayType(reqLength);
        var b, i;
        var q = this.clone();
        if (!littleEndian) {
            // Assume big-endian
            for(i = 0; i < reqLength - byteLength; i++)res[i] = 0;
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[reqLength - i - 1] = b;
            }
        } else {
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[i] = b;
            }
            for(; i < reqLength; i++)res[i] = 0;
        }
        return res;
    };
    if (Math.clz32) BN.prototype._countBits = function _countBits(w) {
        return 32 - Math.clz32(w);
    };
    else BN.prototype._countBits = function _countBits(w) {
        var t = w;
        var r = 0;
        if (t >= 0x1000) {
            r += 13;
            t >>>= 13;
        }
        if (t >= 0x40) {
            r += 7;
            t >>>= 7;
        }
        if (t >= 0x8) {
            r += 4;
            t >>>= 4;
        }
        if (t >= 0x02) {
            r += 2;
            t >>>= 2;
        }
        return r + t;
    };
    BN.prototype._zeroBits = function _zeroBits(w) {
        // Short-cut
        if (w === 0) return 26;
        var t = w;
        var r = 0;
        if ((t & 0x1fff) === 0) {
            r += 13;
            t >>>= 13;
        }
        if ((t & 0x7f) === 0) {
            r += 7;
            t >>>= 7;
        }
        if ((t & 0xf) === 0) {
            r += 4;
            t >>>= 4;
        }
        if ((t & 0x3) === 0) {
            r += 2;
            t >>>= 2;
        }
        if ((t & 0x1) === 0) r++;
        return r;
    };
    // Return number of used bits in a BN
    BN.prototype.bitLength = function bitLength() {
        var w = this.words[this.length - 1];
        var hi = this._countBits(w);
        return (this.length - 1) * 26 + hi;
    };
    function toBitArray(num) {
        var w = new Array(num.bitLength());
        for(var bit = 0; bit < w.length; bit++){
            var off = bit / 26 | 0;
            var wbit = bit % 26;
            w[bit] = (num.words[off] & 1 << wbit) >>> wbit;
        }
        return w;
    }
    // Number of trailing zero bits
    BN.prototype.zeroBits = function zeroBits() {
        if (this.isZero()) return 0;
        var r = 0;
        for(var i = 0; i < this.length; i++){
            var b = this._zeroBits(this.words[i]);
            r += b;
            if (b !== 26) break;
        }
        return r;
    };
    BN.prototype.byteLength = function byteLength() {
        return Math.ceil(this.bitLength() / 8);
    };
    BN.prototype.toTwos = function toTwos(width) {
        if (this.negative !== 0) return this.abs().inotn(width).iaddn(1);
        return this.clone();
    };
    BN.prototype.fromTwos = function fromTwos(width) {
        if (this.testn(width - 1)) return this.notn(width).iaddn(1).ineg();
        return this.clone();
    };
    BN.prototype.isNeg = function isNeg() {
        return this.negative !== 0;
    };
    // Return negative clone of `this`
    BN.prototype.neg = function neg() {
        return this.clone().ineg();
    };
    BN.prototype.ineg = function ineg() {
        if (!this.isZero()) this.negative ^= 1;
        return this;
    };
    // Or `num` with `this` in-place
    BN.prototype.iuor = function iuor(num) {
        while(this.length < num.length)this.words[this.length++] = 0;
        for(var i = 0; i < num.length; i++)this.words[i] = this.words[i] | num.words[i];
        return this.strip();
    };
    BN.prototype.ior = function ior(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuor(num);
    };
    // Or `num` with `this`
    BN.prototype.or = function or(num) {
        if (this.length > num.length) return this.clone().ior(num);
        return num.clone().ior(this);
    };
    BN.prototype.uor = function uor(num) {
        if (this.length > num.length) return this.clone().iuor(num);
        return num.clone().iuor(this);
    };
    // And `num` with `this` in-place
    BN.prototype.iuand = function iuand(num) {
        // b = min-length(num, this)
        var b;
        if (this.length > num.length) b = num;
        else b = this;
        for(var i = 0; i < b.length; i++)this.words[i] = this.words[i] & num.words[i];
        this.length = b.length;
        return this.strip();
    };
    BN.prototype.iand = function iand(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuand(num);
    };
    // And `num` with `this`
    BN.prototype.and = function and(num) {
        if (this.length > num.length) return this.clone().iand(num);
        return num.clone().iand(this);
    };
    BN.prototype.uand = function uand(num) {
        if (this.length > num.length) return this.clone().iuand(num);
        return num.clone().iuand(this);
    };
    // Xor `num` with `this` in-place
    BN.prototype.iuxor = function iuxor(num) {
        // a.length > b.length
        var a;
        var b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        for(var i = 0; i < b.length; i++)this.words[i] = a.words[i] ^ b.words[i];
        if (this !== a) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = a.length;
        return this.strip();
    };
    BN.prototype.ixor = function ixor(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuxor(num);
    };
    // Xor `num` with `this`
    BN.prototype.xor = function xor(num) {
        if (this.length > num.length) return this.clone().ixor(num);
        return num.clone().ixor(this);
    };
    BN.prototype.uxor = function uxor(num) {
        if (this.length > num.length) return this.clone().iuxor(num);
        return num.clone().iuxor(this);
    };
    // Not ``this`` with ``width`` bitwidth
    BN.prototype.inotn = function inotn(width) {
        assert(typeof width === "number" && width >= 0);
        var bytesNeeded = Math.ceil(width / 26) | 0;
        var bitsLeft = width % 26;
        // Extend the buffer with leading zeroes
        this._expand(bytesNeeded);
        if (bitsLeft > 0) bytesNeeded--;
        // Handle complete words
        for(var i = 0; i < bytesNeeded; i++)this.words[i] = ~this.words[i] & 0x3ffffff;
        // Handle the residue
        if (bitsLeft > 0) this.words[i] = ~this.words[i] & 0x3ffffff >> 26 - bitsLeft;
        // And remove leading zeroes
        return this.strip();
    };
    BN.prototype.notn = function notn(width) {
        return this.clone().inotn(width);
    };
    // Set `bit` of `this`
    BN.prototype.setn = function setn(bit, val) {
        assert(typeof bit === "number" && bit >= 0);
        var off = bit / 26 | 0;
        var wbit = bit % 26;
        this._expand(off + 1);
        if (val) this.words[off] = this.words[off] | 1 << wbit;
        else this.words[off] = this.words[off] & ~(1 << wbit);
        return this.strip();
    };
    // Add `num` to `this` in-place
    BN.prototype.iadd = function iadd(num) {
        var r;
        // negative + positive
        if (this.negative !== 0 && num.negative === 0) {
            this.negative = 0;
            r = this.isub(num);
            this.negative ^= 1;
            return this._normSign();
        // positive + negative
        } else if (this.negative === 0 && num.negative !== 0) {
            num.negative = 0;
            r = this.isub(num);
            num.negative = 1;
            return r._normSign();
        }
        // a.length > b.length
        var a, b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        this.length = a.length;
        if (carry !== 0) {
            this.words[this.length] = carry;
            this.length++;
        // Copy the rest of the words
        } else if (a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        return this;
    };
    // Add `num` to `this`
    BN.prototype.add = function add(num) {
        var res;
        if (num.negative !== 0 && this.negative === 0) {
            num.negative = 0;
            res = this.sub(num);
            num.negative ^= 1;
            return res;
        } else if (num.negative === 0 && this.negative !== 0) {
            this.negative = 0;
            res = num.sub(this);
            this.negative = 1;
            return res;
        }
        if (this.length > num.length) return this.clone().iadd(num);
        return num.clone().iadd(this);
    };
    // Subtract `num` from `this` in-place
    BN.prototype.isub = function isub(num) {
        // this - (-num) = this + num
        if (num.negative !== 0) {
            num.negative = 0;
            var r = this.iadd(num);
            num.negative = 1;
            return r._normSign();
        // -this - num = -(this + num)
        } else if (this.negative !== 0) {
            this.negative = 0;
            this.iadd(num);
            this.negative = 1;
            return this._normSign();
        }
        // At this point both numbers are positive
        var cmp = this.cmp(num);
        // Optimization - zeroify
        if (cmp === 0) {
            this.negative = 0;
            this.length = 1;
            this.words[0] = 0;
            return this;
        }
        // a > b
        var a, b;
        if (cmp > 0) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        // Copy rest of the words
        if (carry === 0 && i < a.length && a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = Math.max(this.length, i);
        if (a !== this) this.negative = 1;
        return this.strip();
    };
    // Subtract `num` from `this`
    BN.prototype.sub = function sub(num) {
        return this.clone().isub(num);
    };
    function smallMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        var len = self.length + num.length | 0;
        out.length = len;
        len = len - 1 | 0;
        // Peel one iteration (compiler can't do it, because of code complexity)
        var a = self.words[0] | 0;
        var b = num.words[0] | 0;
        var r = a * b;
        var lo = r & 0x3ffffff;
        var carry = r / 0x4000000 | 0;
        out.words[0] = lo;
        for(var k = 1; k < len; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = carry >>> 26;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j | 0;
                a = self.words[i] | 0;
                b = num.words[j] | 0;
                r = a * b + rword;
                ncarry += r / 0x4000000 | 0;
                rword = r & 0x3ffffff;
            }
            out.words[k] = rword | 0;
            carry = ncarry | 0;
        }
        if (carry !== 0) out.words[k] = carry | 0;
        else out.length--;
        return out.strip();
    }
    // TODO(indutny): it may be reasonable to omit it for users who don't need
    // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
    // multiplication (like elliptic secp256k1).
    var comb10MulTo = function comb10MulTo(self, num, out) {
        var a = self.words;
        var b = num.words;
        var o = out.words;
        var c = 0;
        var lo;
        var mid;
        var hi;
        var a0 = a[0] | 0;
        var al0 = a0 & 0x1fff;
        var ah0 = a0 >>> 13;
        var a1 = a[1] | 0;
        var al1 = a1 & 0x1fff;
        var ah1 = a1 >>> 13;
        var a2 = a[2] | 0;
        var al2 = a2 & 0x1fff;
        var ah2 = a2 >>> 13;
        var a3 = a[3] | 0;
        var al3 = a3 & 0x1fff;
        var ah3 = a3 >>> 13;
        var a4 = a[4] | 0;
        var al4 = a4 & 0x1fff;
        var ah4 = a4 >>> 13;
        var a5 = a[5] | 0;
        var al5 = a5 & 0x1fff;
        var ah5 = a5 >>> 13;
        var a6 = a[6] | 0;
        var al6 = a6 & 0x1fff;
        var ah6 = a6 >>> 13;
        var a7 = a[7] | 0;
        var al7 = a7 & 0x1fff;
        var ah7 = a7 >>> 13;
        var a8 = a[8] | 0;
        var al8 = a8 & 0x1fff;
        var ah8 = a8 >>> 13;
        var a9 = a[9] | 0;
        var al9 = a9 & 0x1fff;
        var ah9 = a9 >>> 13;
        var b0 = b[0] | 0;
        var bl0 = b0 & 0x1fff;
        var bh0 = b0 >>> 13;
        var b1 = b[1] | 0;
        var bl1 = b1 & 0x1fff;
        var bh1 = b1 >>> 13;
        var b2 = b[2] | 0;
        var bl2 = b2 & 0x1fff;
        var bh2 = b2 >>> 13;
        var b3 = b[3] | 0;
        var bl3 = b3 & 0x1fff;
        var bh3 = b3 >>> 13;
        var b4 = b[4] | 0;
        var bl4 = b4 & 0x1fff;
        var bh4 = b4 >>> 13;
        var b5 = b[5] | 0;
        var bl5 = b5 & 0x1fff;
        var bh5 = b5 >>> 13;
        var b6 = b[6] | 0;
        var bl6 = b6 & 0x1fff;
        var bh6 = b6 >>> 13;
        var b7 = b[7] | 0;
        var bl7 = b7 & 0x1fff;
        var bh7 = b7 >>> 13;
        var b8 = b[8] | 0;
        var bl8 = b8 & 0x1fff;
        var bh8 = b8 >>> 13;
        var b9 = b[9] | 0;
        var bl9 = b9 & 0x1fff;
        var bh9 = b9 >>> 13;
        out.negative = self.negative ^ num.negative;
        out.length = 19;
        /* k = 0 */ lo = Math.imul(al0, bl0);
        mid = Math.imul(al0, bh0);
        mid = mid + Math.imul(ah0, bl0) | 0;
        hi = Math.imul(ah0, bh0);
        var w0 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
        w0 &= 0x3ffffff;
        /* k = 1 */ lo = Math.imul(al1, bl0);
        mid = Math.imul(al1, bh0);
        mid = mid + Math.imul(ah1, bl0) | 0;
        hi = Math.imul(ah1, bh0);
        lo = lo + Math.imul(al0, bl1) | 0;
        mid = mid + Math.imul(al0, bh1) | 0;
        mid = mid + Math.imul(ah0, bl1) | 0;
        hi = hi + Math.imul(ah0, bh1) | 0;
        var w1 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
        w1 &= 0x3ffffff;
        /* k = 2 */ lo = Math.imul(al2, bl0);
        mid = Math.imul(al2, bh0);
        mid = mid + Math.imul(ah2, bl0) | 0;
        hi = Math.imul(ah2, bh0);
        lo = lo + Math.imul(al1, bl1) | 0;
        mid = mid + Math.imul(al1, bh1) | 0;
        mid = mid + Math.imul(ah1, bl1) | 0;
        hi = hi + Math.imul(ah1, bh1) | 0;
        lo = lo + Math.imul(al0, bl2) | 0;
        mid = mid + Math.imul(al0, bh2) | 0;
        mid = mid + Math.imul(ah0, bl2) | 0;
        hi = hi + Math.imul(ah0, bh2) | 0;
        var w2 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
        w2 &= 0x3ffffff;
        /* k = 3 */ lo = Math.imul(al3, bl0);
        mid = Math.imul(al3, bh0);
        mid = mid + Math.imul(ah3, bl0) | 0;
        hi = Math.imul(ah3, bh0);
        lo = lo + Math.imul(al2, bl1) | 0;
        mid = mid + Math.imul(al2, bh1) | 0;
        mid = mid + Math.imul(ah2, bl1) | 0;
        hi = hi + Math.imul(ah2, bh1) | 0;
        lo = lo + Math.imul(al1, bl2) | 0;
        mid = mid + Math.imul(al1, bh2) | 0;
        mid = mid + Math.imul(ah1, bl2) | 0;
        hi = hi + Math.imul(ah1, bh2) | 0;
        lo = lo + Math.imul(al0, bl3) | 0;
        mid = mid + Math.imul(al0, bh3) | 0;
        mid = mid + Math.imul(ah0, bl3) | 0;
        hi = hi + Math.imul(ah0, bh3) | 0;
        var w3 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
        w3 &= 0x3ffffff;
        /* k = 4 */ lo = Math.imul(al4, bl0);
        mid = Math.imul(al4, bh0);
        mid = mid + Math.imul(ah4, bl0) | 0;
        hi = Math.imul(ah4, bh0);
        lo = lo + Math.imul(al3, bl1) | 0;
        mid = mid + Math.imul(al3, bh1) | 0;
        mid = mid + Math.imul(ah3, bl1) | 0;
        hi = hi + Math.imul(ah3, bh1) | 0;
        lo = lo + Math.imul(al2, bl2) | 0;
        mid = mid + Math.imul(al2, bh2) | 0;
        mid = mid + Math.imul(ah2, bl2) | 0;
        hi = hi + Math.imul(ah2, bh2) | 0;
        lo = lo + Math.imul(al1, bl3) | 0;
        mid = mid + Math.imul(al1, bh3) | 0;
        mid = mid + Math.imul(ah1, bl3) | 0;
        hi = hi + Math.imul(ah1, bh3) | 0;
        lo = lo + Math.imul(al0, bl4) | 0;
        mid = mid + Math.imul(al0, bh4) | 0;
        mid = mid + Math.imul(ah0, bl4) | 0;
        hi = hi + Math.imul(ah0, bh4) | 0;
        var w4 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
        w4 &= 0x3ffffff;
        /* k = 5 */ lo = Math.imul(al5, bl0);
        mid = Math.imul(al5, bh0);
        mid = mid + Math.imul(ah5, bl0) | 0;
        hi = Math.imul(ah5, bh0);
        lo = lo + Math.imul(al4, bl1) | 0;
        mid = mid + Math.imul(al4, bh1) | 0;
        mid = mid + Math.imul(ah4, bl1) | 0;
        hi = hi + Math.imul(ah4, bh1) | 0;
        lo = lo + Math.imul(al3, bl2) | 0;
        mid = mid + Math.imul(al3, bh2) | 0;
        mid = mid + Math.imul(ah3, bl2) | 0;
        hi = hi + Math.imul(ah3, bh2) | 0;
        lo = lo + Math.imul(al2, bl3) | 0;
        mid = mid + Math.imul(al2, bh3) | 0;
        mid = mid + Math.imul(ah2, bl3) | 0;
        hi = hi + Math.imul(ah2, bh3) | 0;
        lo = lo + Math.imul(al1, bl4) | 0;
        mid = mid + Math.imul(al1, bh4) | 0;
        mid = mid + Math.imul(ah1, bl4) | 0;
        hi = hi + Math.imul(ah1, bh4) | 0;
        lo = lo + Math.imul(al0, bl5) | 0;
        mid = mid + Math.imul(al0, bh5) | 0;
        mid = mid + Math.imul(ah0, bl5) | 0;
        hi = hi + Math.imul(ah0, bh5) | 0;
        var w5 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
        w5 &= 0x3ffffff;
        /* k = 6 */ lo = Math.imul(al6, bl0);
        mid = Math.imul(al6, bh0);
        mid = mid + Math.imul(ah6, bl0) | 0;
        hi = Math.imul(ah6, bh0);
        lo = lo + Math.imul(al5, bl1) | 0;
        mid = mid + Math.imul(al5, bh1) | 0;
        mid = mid + Math.imul(ah5, bl1) | 0;
        hi = hi + Math.imul(ah5, bh1) | 0;
        lo = lo + Math.imul(al4, bl2) | 0;
        mid = mid + Math.imul(al4, bh2) | 0;
        mid = mid + Math.imul(ah4, bl2) | 0;
        hi = hi + Math.imul(ah4, bh2) | 0;
        lo = lo + Math.imul(al3, bl3) | 0;
        mid = mid + Math.imul(al3, bh3) | 0;
        mid = mid + Math.imul(ah3, bl3) | 0;
        hi = hi + Math.imul(ah3, bh3) | 0;
        lo = lo + Math.imul(al2, bl4) | 0;
        mid = mid + Math.imul(al2, bh4) | 0;
        mid = mid + Math.imul(ah2, bl4) | 0;
        hi = hi + Math.imul(ah2, bh4) | 0;
        lo = lo + Math.imul(al1, bl5) | 0;
        mid = mid + Math.imul(al1, bh5) | 0;
        mid = mid + Math.imul(ah1, bl5) | 0;
        hi = hi + Math.imul(ah1, bh5) | 0;
        lo = lo + Math.imul(al0, bl6) | 0;
        mid = mid + Math.imul(al0, bh6) | 0;
        mid = mid + Math.imul(ah0, bl6) | 0;
        hi = hi + Math.imul(ah0, bh6) | 0;
        var w6 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
        w6 &= 0x3ffffff;
        /* k = 7 */ lo = Math.imul(al7, bl0);
        mid = Math.imul(al7, bh0);
        mid = mid + Math.imul(ah7, bl0) | 0;
        hi = Math.imul(ah7, bh0);
        lo = lo + Math.imul(al6, bl1) | 0;
        mid = mid + Math.imul(al6, bh1) | 0;
        mid = mid + Math.imul(ah6, bl1) | 0;
        hi = hi + Math.imul(ah6, bh1) | 0;
        lo = lo + Math.imul(al5, bl2) | 0;
        mid = mid + Math.imul(al5, bh2) | 0;
        mid = mid + Math.imul(ah5, bl2) | 0;
        hi = hi + Math.imul(ah5, bh2) | 0;
        lo = lo + Math.imul(al4, bl3) | 0;
        mid = mid + Math.imul(al4, bh3) | 0;
        mid = mid + Math.imul(ah4, bl3) | 0;
        hi = hi + Math.imul(ah4, bh3) | 0;
        lo = lo + Math.imul(al3, bl4) | 0;
        mid = mid + Math.imul(al3, bh4) | 0;
        mid = mid + Math.imul(ah3, bl4) | 0;
        hi = hi + Math.imul(ah3, bh4) | 0;
        lo = lo + Math.imul(al2, bl5) | 0;
        mid = mid + Math.imul(al2, bh5) | 0;
        mid = mid + Math.imul(ah2, bl5) | 0;
        hi = hi + Math.imul(ah2, bh5) | 0;
        lo = lo + Math.imul(al1, bl6) | 0;
        mid = mid + Math.imul(al1, bh6) | 0;
        mid = mid + Math.imul(ah1, bl6) | 0;
        hi = hi + Math.imul(ah1, bh6) | 0;
        lo = lo + Math.imul(al0, bl7) | 0;
        mid = mid + Math.imul(al0, bh7) | 0;
        mid = mid + Math.imul(ah0, bl7) | 0;
        hi = hi + Math.imul(ah0, bh7) | 0;
        var w7 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
        w7 &= 0x3ffffff;
        /* k = 8 */ lo = Math.imul(al8, bl0);
        mid = Math.imul(al8, bh0);
        mid = mid + Math.imul(ah8, bl0) | 0;
        hi = Math.imul(ah8, bh0);
        lo = lo + Math.imul(al7, bl1) | 0;
        mid = mid + Math.imul(al7, bh1) | 0;
        mid = mid + Math.imul(ah7, bl1) | 0;
        hi = hi + Math.imul(ah7, bh1) | 0;
        lo = lo + Math.imul(al6, bl2) | 0;
        mid = mid + Math.imul(al6, bh2) | 0;
        mid = mid + Math.imul(ah6, bl2) | 0;
        hi = hi + Math.imul(ah6, bh2) | 0;
        lo = lo + Math.imul(al5, bl3) | 0;
        mid = mid + Math.imul(al5, bh3) | 0;
        mid = mid + Math.imul(ah5, bl3) | 0;
        hi = hi + Math.imul(ah5, bh3) | 0;
        lo = lo + Math.imul(al4, bl4) | 0;
        mid = mid + Math.imul(al4, bh4) | 0;
        mid = mid + Math.imul(ah4, bl4) | 0;
        hi = hi + Math.imul(ah4, bh4) | 0;
        lo = lo + Math.imul(al3, bl5) | 0;
        mid = mid + Math.imul(al3, bh5) | 0;
        mid = mid + Math.imul(ah3, bl5) | 0;
        hi = hi + Math.imul(ah3, bh5) | 0;
        lo = lo + Math.imul(al2, bl6) | 0;
        mid = mid + Math.imul(al2, bh6) | 0;
        mid = mid + Math.imul(ah2, bl6) | 0;
        hi = hi + Math.imul(ah2, bh6) | 0;
        lo = lo + Math.imul(al1, bl7) | 0;
        mid = mid + Math.imul(al1, bh7) | 0;
        mid = mid + Math.imul(ah1, bl7) | 0;
        hi = hi + Math.imul(ah1, bh7) | 0;
        lo = lo + Math.imul(al0, bl8) | 0;
        mid = mid + Math.imul(al0, bh8) | 0;
        mid = mid + Math.imul(ah0, bl8) | 0;
        hi = hi + Math.imul(ah0, bh8) | 0;
        var w8 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
        w8 &= 0x3ffffff;
        /* k = 9 */ lo = Math.imul(al9, bl0);
        mid = Math.imul(al9, bh0);
        mid = mid + Math.imul(ah9, bl0) | 0;
        hi = Math.imul(ah9, bh0);
        lo = lo + Math.imul(al8, bl1) | 0;
        mid = mid + Math.imul(al8, bh1) | 0;
        mid = mid + Math.imul(ah8, bl1) | 0;
        hi = hi + Math.imul(ah8, bh1) | 0;
        lo = lo + Math.imul(al7, bl2) | 0;
        mid = mid + Math.imul(al7, bh2) | 0;
        mid = mid + Math.imul(ah7, bl2) | 0;
        hi = hi + Math.imul(ah7, bh2) | 0;
        lo = lo + Math.imul(al6, bl3) | 0;
        mid = mid + Math.imul(al6, bh3) | 0;
        mid = mid + Math.imul(ah6, bl3) | 0;
        hi = hi + Math.imul(ah6, bh3) | 0;
        lo = lo + Math.imul(al5, bl4) | 0;
        mid = mid + Math.imul(al5, bh4) | 0;
        mid = mid + Math.imul(ah5, bl4) | 0;
        hi = hi + Math.imul(ah5, bh4) | 0;
        lo = lo + Math.imul(al4, bl5) | 0;
        mid = mid + Math.imul(al4, bh5) | 0;
        mid = mid + Math.imul(ah4, bl5) | 0;
        hi = hi + Math.imul(ah4, bh5) | 0;
        lo = lo + Math.imul(al3, bl6) | 0;
        mid = mid + Math.imul(al3, bh6) | 0;
        mid = mid + Math.imul(ah3, bl6) | 0;
        hi = hi + Math.imul(ah3, bh6) | 0;
        lo = lo + Math.imul(al2, bl7) | 0;
        mid = mid + Math.imul(al2, bh7) | 0;
        mid = mid + Math.imul(ah2, bl7) | 0;
        hi = hi + Math.imul(ah2, bh7) | 0;
        lo = lo + Math.imul(al1, bl8) | 0;
        mid = mid + Math.imul(al1, bh8) | 0;
        mid = mid + Math.imul(ah1, bl8) | 0;
        hi = hi + Math.imul(ah1, bh8) | 0;
        lo = lo + Math.imul(al0, bl9) | 0;
        mid = mid + Math.imul(al0, bh9) | 0;
        mid = mid + Math.imul(ah0, bl9) | 0;
        hi = hi + Math.imul(ah0, bh9) | 0;
        var w9 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
        w9 &= 0x3ffffff;
        /* k = 10 */ lo = Math.imul(al9, bl1);
        mid = Math.imul(al9, bh1);
        mid = mid + Math.imul(ah9, bl1) | 0;
        hi = Math.imul(ah9, bh1);
        lo = lo + Math.imul(al8, bl2) | 0;
        mid = mid + Math.imul(al8, bh2) | 0;
        mid = mid + Math.imul(ah8, bl2) | 0;
        hi = hi + Math.imul(ah8, bh2) | 0;
        lo = lo + Math.imul(al7, bl3) | 0;
        mid = mid + Math.imul(al7, bh3) | 0;
        mid = mid + Math.imul(ah7, bl3) | 0;
        hi = hi + Math.imul(ah7, bh3) | 0;
        lo = lo + Math.imul(al6, bl4) | 0;
        mid = mid + Math.imul(al6, bh4) | 0;
        mid = mid + Math.imul(ah6, bl4) | 0;
        hi = hi + Math.imul(ah6, bh4) | 0;
        lo = lo + Math.imul(al5, bl5) | 0;
        mid = mid + Math.imul(al5, bh5) | 0;
        mid = mid + Math.imul(ah5, bl5) | 0;
        hi = hi + Math.imul(ah5, bh5) | 0;
        lo = lo + Math.imul(al4, bl6) | 0;
        mid = mid + Math.imul(al4, bh6) | 0;
        mid = mid + Math.imul(ah4, bl6) | 0;
        hi = hi + Math.imul(ah4, bh6) | 0;
        lo = lo + Math.imul(al3, bl7) | 0;
        mid = mid + Math.imul(al3, bh7) | 0;
        mid = mid + Math.imul(ah3, bl7) | 0;
        hi = hi + Math.imul(ah3, bh7) | 0;
        lo = lo + Math.imul(al2, bl8) | 0;
        mid = mid + Math.imul(al2, bh8) | 0;
        mid = mid + Math.imul(ah2, bl8) | 0;
        hi = hi + Math.imul(ah2, bh8) | 0;
        lo = lo + Math.imul(al1, bl9) | 0;
        mid = mid + Math.imul(al1, bh9) | 0;
        mid = mid + Math.imul(ah1, bl9) | 0;
        hi = hi + Math.imul(ah1, bh9) | 0;
        var w10 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
        w10 &= 0x3ffffff;
        /* k = 11 */ lo = Math.imul(al9, bl2);
        mid = Math.imul(al9, bh2);
        mid = mid + Math.imul(ah9, bl2) | 0;
        hi = Math.imul(ah9, bh2);
        lo = lo + Math.imul(al8, bl3) | 0;
        mid = mid + Math.imul(al8, bh3) | 0;
        mid = mid + Math.imul(ah8, bl3) | 0;
        hi = hi + Math.imul(ah8, bh3) | 0;
        lo = lo + Math.imul(al7, bl4) | 0;
        mid = mid + Math.imul(al7, bh4) | 0;
        mid = mid + Math.imul(ah7, bl4) | 0;
        hi = hi + Math.imul(ah7, bh4) | 0;
        lo = lo + Math.imul(al6, bl5) | 0;
        mid = mid + Math.imul(al6, bh5) | 0;
        mid = mid + Math.imul(ah6, bl5) | 0;
        hi = hi + Math.imul(ah6, bh5) | 0;
        lo = lo + Math.imul(al5, bl6) | 0;
        mid = mid + Math.imul(al5, bh6) | 0;
        mid = mid + Math.imul(ah5, bl6) | 0;
        hi = hi + Math.imul(ah5, bh6) | 0;
        lo = lo + Math.imul(al4, bl7) | 0;
        mid = mid + Math.imul(al4, bh7) | 0;
        mid = mid + Math.imul(ah4, bl7) | 0;
        hi = hi + Math.imul(ah4, bh7) | 0;
        lo = lo + Math.imul(al3, bl8) | 0;
        mid = mid + Math.imul(al3, bh8) | 0;
        mid = mid + Math.imul(ah3, bl8) | 0;
        hi = hi + Math.imul(ah3, bh8) | 0;
        lo = lo + Math.imul(al2, bl9) | 0;
        mid = mid + Math.imul(al2, bh9) | 0;
        mid = mid + Math.imul(ah2, bl9) | 0;
        hi = hi + Math.imul(ah2, bh9) | 0;
        var w11 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
        w11 &= 0x3ffffff;
        /* k = 12 */ lo = Math.imul(al9, bl3);
        mid = Math.imul(al9, bh3);
        mid = mid + Math.imul(ah9, bl3) | 0;
        hi = Math.imul(ah9, bh3);
        lo = lo + Math.imul(al8, bl4) | 0;
        mid = mid + Math.imul(al8, bh4) | 0;
        mid = mid + Math.imul(ah8, bl4) | 0;
        hi = hi + Math.imul(ah8, bh4) | 0;
        lo = lo + Math.imul(al7, bl5) | 0;
        mid = mid + Math.imul(al7, bh5) | 0;
        mid = mid + Math.imul(ah7, bl5) | 0;
        hi = hi + Math.imul(ah7, bh5) | 0;
        lo = lo + Math.imul(al6, bl6) | 0;
        mid = mid + Math.imul(al6, bh6) | 0;
        mid = mid + Math.imul(ah6, bl6) | 0;
        hi = hi + Math.imul(ah6, bh6) | 0;
        lo = lo + Math.imul(al5, bl7) | 0;
        mid = mid + Math.imul(al5, bh7) | 0;
        mid = mid + Math.imul(ah5, bl7) | 0;
        hi = hi + Math.imul(ah5, bh7) | 0;
        lo = lo + Math.imul(al4, bl8) | 0;
        mid = mid + Math.imul(al4, bh8) | 0;
        mid = mid + Math.imul(ah4, bl8) | 0;
        hi = hi + Math.imul(ah4, bh8) | 0;
        lo = lo + Math.imul(al3, bl9) | 0;
        mid = mid + Math.imul(al3, bh9) | 0;
        mid = mid + Math.imul(ah3, bl9) | 0;
        hi = hi + Math.imul(ah3, bh9) | 0;
        var w12 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
        w12 &= 0x3ffffff;
        /* k = 13 */ lo = Math.imul(al9, bl4);
        mid = Math.imul(al9, bh4);
        mid = mid + Math.imul(ah9, bl4) | 0;
        hi = Math.imul(ah9, bh4);
        lo = lo + Math.imul(al8, bl5) | 0;
        mid = mid + Math.imul(al8, bh5) | 0;
        mid = mid + Math.imul(ah8, bl5) | 0;
        hi = hi + Math.imul(ah8, bh5) | 0;
        lo = lo + Math.imul(al7, bl6) | 0;
        mid = mid + Math.imul(al7, bh6) | 0;
        mid = mid + Math.imul(ah7, bl6) | 0;
        hi = hi + Math.imul(ah7, bh6) | 0;
        lo = lo + Math.imul(al6, bl7) | 0;
        mid = mid + Math.imul(al6, bh7) | 0;
        mid = mid + Math.imul(ah6, bl7) | 0;
        hi = hi + Math.imul(ah6, bh7) | 0;
        lo = lo + Math.imul(al5, bl8) | 0;
        mid = mid + Math.imul(al5, bh8) | 0;
        mid = mid + Math.imul(ah5, bl8) | 0;
        hi = hi + Math.imul(ah5, bh8) | 0;
        lo = lo + Math.imul(al4, bl9) | 0;
        mid = mid + Math.imul(al4, bh9) | 0;
        mid = mid + Math.imul(ah4, bl9) | 0;
        hi = hi + Math.imul(ah4, bh9) | 0;
        var w13 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
        w13 &= 0x3ffffff;
        /* k = 14 */ lo = Math.imul(al9, bl5);
        mid = Math.imul(al9, bh5);
        mid = mid + Math.imul(ah9, bl5) | 0;
        hi = Math.imul(ah9, bh5);
        lo = lo + Math.imul(al8, bl6) | 0;
        mid = mid + Math.imul(al8, bh6) | 0;
        mid = mid + Math.imul(ah8, bl6) | 0;
        hi = hi + Math.imul(ah8, bh6) | 0;
        lo = lo + Math.imul(al7, bl7) | 0;
        mid = mid + Math.imul(al7, bh7) | 0;
        mid = mid + Math.imul(ah7, bl7) | 0;
        hi = hi + Math.imul(ah7, bh7) | 0;
        lo = lo + Math.imul(al6, bl8) | 0;
        mid = mid + Math.imul(al6, bh8) | 0;
        mid = mid + Math.imul(ah6, bl8) | 0;
        hi = hi + Math.imul(ah6, bh8) | 0;
        lo = lo + Math.imul(al5, bl9) | 0;
        mid = mid + Math.imul(al5, bh9) | 0;
        mid = mid + Math.imul(ah5, bl9) | 0;
        hi = hi + Math.imul(ah5, bh9) | 0;
        var w14 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
        w14 &= 0x3ffffff;
        /* k = 15 */ lo = Math.imul(al9, bl6);
        mid = Math.imul(al9, bh6);
        mid = mid + Math.imul(ah9, bl6) | 0;
        hi = Math.imul(ah9, bh6);
        lo = lo + Math.imul(al8, bl7) | 0;
        mid = mid + Math.imul(al8, bh7) | 0;
        mid = mid + Math.imul(ah8, bl7) | 0;
        hi = hi + Math.imul(ah8, bh7) | 0;
        lo = lo + Math.imul(al7, bl8) | 0;
        mid = mid + Math.imul(al7, bh8) | 0;
        mid = mid + Math.imul(ah7, bl8) | 0;
        hi = hi + Math.imul(ah7, bh8) | 0;
        lo = lo + Math.imul(al6, bl9) | 0;
        mid = mid + Math.imul(al6, bh9) | 0;
        mid = mid + Math.imul(ah6, bl9) | 0;
        hi = hi + Math.imul(ah6, bh9) | 0;
        var w15 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
        w15 &= 0x3ffffff;
        /* k = 16 */ lo = Math.imul(al9, bl7);
        mid = Math.imul(al9, bh7);
        mid = mid + Math.imul(ah9, bl7) | 0;
        hi = Math.imul(ah9, bh7);
        lo = lo + Math.imul(al8, bl8) | 0;
        mid = mid + Math.imul(al8, bh8) | 0;
        mid = mid + Math.imul(ah8, bl8) | 0;
        hi = hi + Math.imul(ah8, bh8) | 0;
        lo = lo + Math.imul(al7, bl9) | 0;
        mid = mid + Math.imul(al7, bh9) | 0;
        mid = mid + Math.imul(ah7, bl9) | 0;
        hi = hi + Math.imul(ah7, bh9) | 0;
        var w16 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
        w16 &= 0x3ffffff;
        /* k = 17 */ lo = Math.imul(al9, bl8);
        mid = Math.imul(al9, bh8);
        mid = mid + Math.imul(ah9, bl8) | 0;
        hi = Math.imul(ah9, bh8);
        lo = lo + Math.imul(al8, bl9) | 0;
        mid = mid + Math.imul(al8, bh9) | 0;
        mid = mid + Math.imul(ah8, bl9) | 0;
        hi = hi + Math.imul(ah8, bh9) | 0;
        var w17 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
        w17 &= 0x3ffffff;
        /* k = 18 */ lo = Math.imul(al9, bl9);
        mid = Math.imul(al9, bh9);
        mid = mid + Math.imul(ah9, bl9) | 0;
        hi = Math.imul(ah9, bh9);
        var w18 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
        w18 &= 0x3ffffff;
        o[0] = w0;
        o[1] = w1;
        o[2] = w2;
        o[3] = w3;
        o[4] = w4;
        o[5] = w5;
        o[6] = w6;
        o[7] = w7;
        o[8] = w8;
        o[9] = w9;
        o[10] = w10;
        o[11] = w11;
        o[12] = w12;
        o[13] = w13;
        o[14] = w14;
        o[15] = w15;
        o[16] = w16;
        o[17] = w17;
        o[18] = w18;
        if (c !== 0) {
            o[19] = c;
            out.length++;
        }
        return out;
    };
    // Polyfill comb
    if (!Math.imul) comb10MulTo = smallMulTo;
    function bigMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        out.length = self.length + num.length;
        var carry = 0;
        var hncarry = 0;
        for(var k = 0; k < out.length - 1; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = hncarry;
            hncarry = 0;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j;
                var a = self.words[i] | 0;
                var b = num.words[j] | 0;
                var r = a * b;
                var lo = r & 0x3ffffff;
                ncarry = ncarry + (r / 0x4000000 | 0) | 0;
                lo = lo + rword | 0;
                rword = lo & 0x3ffffff;
                ncarry = ncarry + (lo >>> 26) | 0;
                hncarry += ncarry >>> 26;
                ncarry &= 0x3ffffff;
            }
            out.words[k] = rword;
            carry = ncarry;
            ncarry = hncarry;
        }
        if (carry !== 0) out.words[k] = carry;
        else out.length--;
        return out.strip();
    }
    function jumboMulTo(self, num, out) {
        var fftm = new FFTM();
        return fftm.mulp(self, num, out);
    }
    BN.prototype.mulTo = function mulTo(num, out) {
        var res;
        var len = this.length + num.length;
        if (this.length === 10 && num.length === 10) res = comb10MulTo(this, num, out);
        else if (len < 63) res = smallMulTo(this, num, out);
        else if (len < 1024) res = bigMulTo(this, num, out);
        else res = jumboMulTo(this, num, out);
        return res;
    };
    // Cooley-Tukey algorithm for FFT
    // slightly revisited to rely on looping instead of recursion
    function FFTM(x, y) {
        this.x = x;
        this.y = y;
    }
    FFTM.prototype.makeRBT = function makeRBT(N) {
        var t = new Array(N);
        var l = BN.prototype._countBits(N) - 1;
        for(var i = 0; i < N; i++)t[i] = this.revBin(i, l, N);
        return t;
    };
    // Returns binary-reversed representation of `x`
    FFTM.prototype.revBin = function revBin(x, l, N) {
        if (x === 0 || x === N - 1) return x;
        var rb = 0;
        for(var i = 0; i < l; i++){
            rb |= (x & 1) << l - i - 1;
            x >>= 1;
        }
        return rb;
    };
    // Performs "tweedling" phase, therefore 'emulating'
    // behaviour of the recursive algorithm
    FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
        for(var i = 0; i < N; i++){
            rtws[i] = rws[rbt[i]];
            itws[i] = iws[rbt[i]];
        }
    };
    FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
        this.permute(rbt, rws, iws, rtws, itws, N);
        for(var s = 1; s < N; s <<= 1){
            var l = s << 1;
            var rtwdf = Math.cos(2 * Math.PI / l);
            var itwdf = Math.sin(2 * Math.PI / l);
            for(var p = 0; p < N; p += l){
                var rtwdf_ = rtwdf;
                var itwdf_ = itwdf;
                for(var j = 0; j < s; j++){
                    var re = rtws[p + j];
                    var ie = itws[p + j];
                    var ro = rtws[p + j + s];
                    var io = itws[p + j + s];
                    var rx = rtwdf_ * ro - itwdf_ * io;
                    io = rtwdf_ * io + itwdf_ * ro;
                    ro = rx;
                    rtws[p + j] = re + ro;
                    itws[p + j] = ie + io;
                    rtws[p + j + s] = re - ro;
                    itws[p + j + s] = ie - io;
                    /* jshint maxdepth : false */ if (j !== l) {
                        rx = rtwdf * rtwdf_ - itwdf * itwdf_;
                        itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                        rtwdf_ = rx;
                    }
                }
            }
        }
    };
    FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
        var N = Math.max(m, n) | 1;
        var odd = N & 1;
        var i = 0;
        for(N = N / 2 | 0; N; N = N >>> 1)i++;
        return 1 << i + 1 + odd;
    };
    FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
        if (N <= 1) return;
        for(var i = 0; i < N / 2; i++){
            var t = rws[i];
            rws[i] = rws[N - i - 1];
            rws[N - i - 1] = t;
            t = iws[i];
            iws[i] = -iws[N - i - 1];
            iws[N - i - 1] = -t;
        }
    };
    FFTM.prototype.normalize13b = function normalize13b(ws, N) {
        var carry = 0;
        for(var i = 0; i < N / 2; i++){
            var w = Math.round(ws[2 * i + 1] / N) * 0x2000 + Math.round(ws[2 * i] / N) + carry;
            ws[i] = w & 0x3ffffff;
            if (w < 0x4000000) carry = 0;
            else carry = w / 0x4000000 | 0;
        }
        return ws;
    };
    FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
        var carry = 0;
        for(var i = 0; i < len; i++){
            carry = carry + (ws[i] | 0);
            rws[2 * i] = carry & 0x1fff;
            carry = carry >>> 13;
            rws[2 * i + 1] = carry & 0x1fff;
            carry = carry >>> 13;
        }
        // Pad with zeroes
        for(i = 2 * len; i < N; ++i)rws[i] = 0;
        assert(carry === 0);
        assert((carry & -8192) === 0);
    };
    FFTM.prototype.stub = function stub(N) {
        var ph = new Array(N);
        for(var i = 0; i < N; i++)ph[i] = 0;
        return ph;
    };
    FFTM.prototype.mulp = function mulp(x, y, out) {
        var N = 2 * this.guessLen13b(x.length, y.length);
        var rbt = this.makeRBT(N);
        var _ = this.stub(N);
        var rws = new Array(N);
        var rwst = new Array(N);
        var iwst = new Array(N);
        var nrws = new Array(N);
        var nrwst = new Array(N);
        var niwst = new Array(N);
        var rmws = out.words;
        rmws.length = N;
        this.convert13b(x.words, x.length, rws, N);
        this.convert13b(y.words, y.length, nrws, N);
        this.transform(rws, _, rwst, iwst, N, rbt);
        this.transform(nrws, _, nrwst, niwst, N, rbt);
        for(var i = 0; i < N; i++){
            var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
            iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
            rwst[i] = rx;
        }
        this.conjugate(rwst, iwst, N);
        this.transform(rwst, iwst, rmws, _, N, rbt);
        this.conjugate(rmws, _, N);
        this.normalize13b(rmws, N);
        out.negative = x.negative ^ y.negative;
        out.length = x.length + y.length;
        return out.strip();
    };
    // Multiply `this` by `num`
    BN.prototype.mul = function mul(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return this.mulTo(num, out);
    };
    // Multiply employing FFT
    BN.prototype.mulf = function mulf(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return jumboMulTo(this, num, out);
    };
    // In-place Multiplication
    BN.prototype.imul = function imul(num) {
        return this.clone().mulTo(num, this);
    };
    BN.prototype.imuln = function imuln(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        // Carry
        var carry = 0;
        for(var i = 0; i < this.length; i++){
            var w = (this.words[i] | 0) * num;
            var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
            carry >>= 26;
            carry += w / 0x4000000 | 0;
            // NOTE: lo is 27bit maximum
            carry += lo >>> 26;
            this.words[i] = lo & 0x3ffffff;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.muln = function muln(num) {
        return this.clone().imuln(num);
    };
    // `this` * `this`
    BN.prototype.sqr = function sqr() {
        return this.mul(this);
    };
    // `this` * `this` in-place
    BN.prototype.isqr = function isqr() {
        return this.imul(this.clone());
    };
    // Math.pow(`this`, `num`)
    BN.prototype.pow = function pow(num) {
        var w = toBitArray(num);
        if (w.length === 0) return new BN(1);
        // Skip leading zeroes
        var res = this;
        for(var i = 0; i < w.length; i++, res = res.sqr()){
            if (w[i] !== 0) break;
        }
        if (++i < w.length) for(var q = res.sqr(); i < w.length; i++, q = q.sqr()){
            if (w[i] === 0) continue;
            res = res.mul(q);
        }
        return res;
    };
    // Shift-left in-place
    BN.prototype.iushln = function iushln(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        var carryMask = 0x3ffffff >>> 26 - r << 26 - r;
        var i;
        if (r !== 0) {
            var carry = 0;
            for(i = 0; i < this.length; i++){
                var newCarry = this.words[i] & carryMask;
                var c = (this.words[i] | 0) - newCarry << r;
                this.words[i] = c | carry;
                carry = newCarry >>> 26 - r;
            }
            if (carry) {
                this.words[i] = carry;
                this.length++;
            }
        }
        if (s !== 0) {
            for(i = this.length - 1; i >= 0; i--)this.words[i + s] = this.words[i];
            for(i = 0; i < s; i++)this.words[i] = 0;
            this.length += s;
        }
        return this.strip();
    };
    BN.prototype.ishln = function ishln(bits) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushln(bits);
    };
    // Shift-right in-place
    // NOTE: `hint` is a lowest bit before trailing zeroes
    // NOTE: if `extended` is present - it will be filled with destroyed bits
    BN.prototype.iushrn = function iushrn(bits, hint, extended) {
        assert(typeof bits === "number" && bits >= 0);
        var h;
        if (hint) h = (hint - hint % 26) / 26;
        else h = 0;
        var r = bits % 26;
        var s = Math.min((bits - r) / 26, this.length);
        var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
        var maskedWords = extended;
        h -= s;
        h = Math.max(0, h);
        // Extended mode, copy masked part
        if (maskedWords) {
            for(var i = 0; i < s; i++)maskedWords.words[i] = this.words[i];
            maskedWords.length = s;
        }
        if (s === 0) ;
        else if (this.length > s) {
            this.length -= s;
            for(i = 0; i < this.length; i++)this.words[i] = this.words[i + s];
        } else {
            this.words[0] = 0;
            this.length = 1;
        }
        var carry = 0;
        for(i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--){
            var word = this.words[i] | 0;
            this.words[i] = carry << 26 - r | word >>> r;
            carry = word & mask;
        }
        // Push carried bits as a mask
        if (maskedWords && carry !== 0) maskedWords.words[maskedWords.length++] = carry;
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this.strip();
    };
    BN.prototype.ishrn = function ishrn(bits, hint, extended) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushrn(bits, hint, extended);
    };
    // Shift-left
    BN.prototype.shln = function shln(bits) {
        return this.clone().ishln(bits);
    };
    BN.prototype.ushln = function ushln(bits) {
        return this.clone().iushln(bits);
    };
    // Shift-right
    BN.prototype.shrn = function shrn(bits) {
        return this.clone().ishrn(bits);
    };
    BN.prototype.ushrn = function ushrn(bits) {
        return this.clone().iushrn(bits);
    };
    // Test if n bit is set
    BN.prototype.testn = function testn(bit) {
        assert(typeof bit === "number" && bit >= 0);
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) return false;
        // Check bit and return
        var w = this.words[s];
        return !!(w & q);
    };
    // Return only lowers bits of number (in-place)
    BN.prototype.imaskn = function imaskn(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        assert(this.negative === 0, "imaskn works only with positive numbers");
        if (this.length <= s) return this;
        if (r !== 0) s++;
        this.length = Math.min(s, this.length);
        if (r !== 0) {
            var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
            this.words[this.length - 1] &= mask;
        }
        return this.strip();
    };
    // Return only lowers bits of number
    BN.prototype.maskn = function maskn(bits) {
        return this.clone().imaskn(bits);
    };
    // Add plain number `num` to `this`
    BN.prototype.iaddn = function iaddn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.isubn(-num);
        // Possible sign change
        if (this.negative !== 0) {
            if (this.length === 1 && (this.words[0] | 0) < num) {
                this.words[0] = num - (this.words[0] | 0);
                this.negative = 0;
                return this;
            }
            this.negative = 0;
            this.isubn(num);
            this.negative = 1;
            return this;
        }
        // Add without checks
        return this._iaddn(num);
    };
    BN.prototype._iaddn = function _iaddn(num) {
        this.words[0] += num;
        // Carry
        for(var i = 0; i < this.length && this.words[i] >= 0x4000000; i++){
            this.words[i] -= 0x4000000;
            if (i === this.length - 1) this.words[i + 1] = 1;
            else this.words[i + 1]++;
        }
        this.length = Math.max(this.length, i + 1);
        return this;
    };
    // Subtract plain number `num` from `this`
    BN.prototype.isubn = function isubn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.iaddn(-num);
        if (this.negative !== 0) {
            this.negative = 0;
            this.iaddn(num);
            this.negative = 1;
            return this;
        }
        this.words[0] -= num;
        if (this.length === 1 && this.words[0] < 0) {
            this.words[0] = -this.words[0];
            this.negative = 1;
        } else // Carry
        for(var i = 0; i < this.length && this.words[i] < 0; i++){
            this.words[i] += 0x4000000;
            this.words[i + 1] -= 1;
        }
        return this.strip();
    };
    BN.prototype.addn = function addn(num) {
        return this.clone().iaddn(num);
    };
    BN.prototype.subn = function subn(num) {
        return this.clone().isubn(num);
    };
    BN.prototype.iabs = function iabs() {
        this.negative = 0;
        return this;
    };
    BN.prototype.abs = function abs() {
        return this.clone().iabs();
    };
    BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
        var len = num.length + shift;
        var i;
        this._expand(len);
        var w;
        var carry = 0;
        for(i = 0; i < num.length; i++){
            w = (this.words[i + shift] | 0) + carry;
            var right = (num.words[i] | 0) * mul;
            w -= right & 0x3ffffff;
            carry = (w >> 26) - (right / 0x4000000 | 0);
            this.words[i + shift] = w & 0x3ffffff;
        }
        for(; i < this.length - shift; i++){
            w = (this.words[i + shift] | 0) + carry;
            carry = w >> 26;
            this.words[i + shift] = w & 0x3ffffff;
        }
        if (carry === 0) return this.strip();
        // Subtraction overflow
        assert(carry === -1);
        carry = 0;
        for(i = 0; i < this.length; i++){
            w = -(this.words[i] | 0) + carry;
            carry = w >> 26;
            this.words[i] = w & 0x3ffffff;
        }
        this.negative = 1;
        return this.strip();
    };
    BN.prototype._wordDiv = function _wordDiv(num, mode) {
        var shift = this.length - num.length;
        var a = this.clone();
        var b = num;
        // Normalize
        var bhi = b.words[b.length - 1] | 0;
        var bhiBits = this._countBits(bhi);
        shift = 26 - bhiBits;
        if (shift !== 0) {
            b = b.ushln(shift);
            a.iushln(shift);
            bhi = b.words[b.length - 1] | 0;
        }
        // Initialize quotient
        var m = a.length - b.length;
        var q;
        if (mode !== "mod") {
            q = new BN(null);
            q.length = m + 1;
            q.words = new Array(q.length);
            for(var i = 0; i < q.length; i++)q.words[i] = 0;
        }
        var diff = a.clone()._ishlnsubmul(b, 1, m);
        if (diff.negative === 0) {
            a = diff;
            if (q) q.words[m] = 1;
        }
        for(var j = m - 1; j >= 0; j--){
            var qj = (a.words[b.length + j] | 0) * 0x4000000 + (a.words[b.length + j - 1] | 0);
            // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
            // (0x7ffffff)
            qj = Math.min(qj / bhi | 0, 0x3ffffff);
            a._ishlnsubmul(b, qj, j);
            while(a.negative !== 0){
                qj--;
                a.negative = 0;
                a._ishlnsubmul(b, 1, j);
                if (!a.isZero()) a.negative ^= 1;
            }
            if (q) q.words[j] = qj;
        }
        if (q) q.strip();
        a.strip();
        // Denormalize
        if (mode !== "div" && shift !== 0) a.iushrn(shift);
        return {
            div: q || null,
            mod: a
        };
    };
    // NOTE: 1) `mode` can be set to `mod` to request mod only,
    //       to `div` to request div only, or be absent to
    //       request both div & mod
    //       2) `positive` is true if unsigned mod is requested
    BN.prototype.divmod = function divmod(num, mode, positive) {
        assert(!num.isZero());
        if (this.isZero()) return {
            div: new BN(0),
            mod: new BN(0)
        };
        var div, mod, res;
        if (this.negative !== 0 && num.negative === 0) {
            res = this.neg().divmod(num, mode);
            if (mode !== "mod") div = res.div.neg();
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.iadd(num);
            }
            return {
                div: div,
                mod: mod
            };
        }
        if (this.negative === 0 && num.negative !== 0) {
            res = this.divmod(num.neg(), mode);
            if (mode !== "mod") div = res.div.neg();
            return {
                div: div,
                mod: res.mod
            };
        }
        if ((this.negative & num.negative) !== 0) {
            res = this.neg().divmod(num.neg(), mode);
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.isub(num);
            }
            return {
                div: res.div,
                mod: mod
            };
        }
        // Both numbers are positive at this point
        // Strip both numbers to approximate shift value
        if (num.length > this.length || this.cmp(num) < 0) return {
            div: new BN(0),
            mod: this
        };
        // Very short reduction
        if (num.length === 1) {
            if (mode === "div") return {
                div: this.divn(num.words[0]),
                mod: null
            };
            if (mode === "mod") return {
                div: null,
                mod: new BN(this.modn(num.words[0]))
            };
            return {
                div: this.divn(num.words[0]),
                mod: new BN(this.modn(num.words[0]))
            };
        }
        return this._wordDiv(num, mode);
    };
    // Find `this` / `num`
    BN.prototype.div = function div(num) {
        return this.divmod(num, "div", false).div;
    };
    // Find `this` % `num`
    BN.prototype.mod = function mod(num) {
        return this.divmod(num, "mod", false).mod;
    };
    BN.prototype.umod = function umod(num) {
        return this.divmod(num, "mod", true).mod;
    };
    // Find Round(`this` / `num`)
    BN.prototype.divRound = function divRound(num) {
        var dm = this.divmod(num);
        // Fast case - exact division
        if (dm.mod.isZero()) return dm.div;
        var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;
        var half = num.ushrn(1);
        var r2 = num.andln(1);
        var cmp = mod.cmp(half);
        // Round down
        if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
        // Round up
        return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
    };
    BN.prototype.modn = function modn(num) {
        assert(num <= 0x3ffffff);
        var p = 67108864 % num;
        var acc = 0;
        for(var i = this.length - 1; i >= 0; i--)acc = (p * acc + (this.words[i] | 0)) % num;
        return acc;
    };
    // In-place division by number
    BN.prototype.idivn = function idivn(num) {
        assert(num <= 0x3ffffff);
        var carry = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var w = (this.words[i] | 0) + carry * 0x4000000;
            this.words[i] = w / num | 0;
            carry = w % num;
        }
        return this.strip();
    };
    BN.prototype.divn = function divn(num) {
        return this.clone().idivn(num);
    };
    BN.prototype.egcd = function egcd(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var x = this;
        var y = p.clone();
        if (x.negative !== 0) x = x.umod(p);
        else x = x.clone();
        // A * x + B * y = x
        var A = new BN(1);
        var B = new BN(0);
        // C * x + D * y = y
        var C = new BN(0);
        var D = new BN(1);
        var g = 0;
        while(x.isEven() && y.isEven()){
            x.iushrn(1);
            y.iushrn(1);
            ++g;
        }
        var yp = y.clone();
        var xp = x.clone();
        while(!x.isZero()){
            for(var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                x.iushrn(i);
                while(i-- > 0){
                    if (A.isOdd() || B.isOdd()) {
                        A.iadd(yp);
                        B.isub(xp);
                    }
                    A.iushrn(1);
                    B.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                y.iushrn(j);
                while(j-- > 0){
                    if (C.isOdd() || D.isOdd()) {
                        C.iadd(yp);
                        D.isub(xp);
                    }
                    C.iushrn(1);
                    D.iushrn(1);
                }
            }
            if (x.cmp(y) >= 0) {
                x.isub(y);
                A.isub(C);
                B.isub(D);
            } else {
                y.isub(x);
                C.isub(A);
                D.isub(B);
            }
        }
        return {
            a: C,
            b: D,
            gcd: y.iushln(g)
        };
    };
    // This is reduced incarnation of the binary EEA
    // above, designated to invert members of the
    // _prime_ fields F(p) at a maximal speed
    BN.prototype._invmp = function _invmp(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var a = this;
        var b = p.clone();
        if (a.negative !== 0) a = a.umod(p);
        else a = a.clone();
        var x1 = new BN(1);
        var x2 = new BN(0);
        var delta = b.clone();
        while(a.cmpn(1) > 0 && b.cmpn(1) > 0){
            for(var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                a.iushrn(i);
                while(i-- > 0){
                    if (x1.isOdd()) x1.iadd(delta);
                    x1.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                b.iushrn(j);
                while(j-- > 0){
                    if (x2.isOdd()) x2.iadd(delta);
                    x2.iushrn(1);
                }
            }
            if (a.cmp(b) >= 0) {
                a.isub(b);
                x1.isub(x2);
            } else {
                b.isub(a);
                x2.isub(x1);
            }
        }
        var res;
        if (a.cmpn(1) === 0) res = x1;
        else res = x2;
        if (res.cmpn(0) < 0) res.iadd(p);
        return res;
    };
    BN.prototype.gcd = function gcd(num) {
        if (this.isZero()) return num.abs();
        if (num.isZero()) return this.abs();
        var a = this.clone();
        var b = num.clone();
        a.negative = 0;
        b.negative = 0;
        // Remove common factor of two
        for(var shift = 0; a.isEven() && b.isEven(); shift++){
            a.iushrn(1);
            b.iushrn(1);
        }
        do {
            while(a.isEven())a.iushrn(1);
            while(b.isEven())b.iushrn(1);
            var r = a.cmp(b);
            if (r < 0) {
                // Swap `a` and `b` to make `a` always bigger than `b`
                var t = a;
                a = b;
                b = t;
            } else if (r === 0 || b.cmpn(1) === 0) break;
            a.isub(b);
        }while (true);
        return b.iushln(shift);
    };
    // Invert number in the field F(num)
    BN.prototype.invm = function invm(num) {
        return this.egcd(num).a.umod(num);
    };
    BN.prototype.isEven = function isEven() {
        return (this.words[0] & 1) === 0;
    };
    BN.prototype.isOdd = function isOdd() {
        return (this.words[0] & 1) === 1;
    };
    // And first word and num
    BN.prototype.andln = function andln(num) {
        return this.words[0] & num;
    };
    // Increment at the bit position in-line
    BN.prototype.bincn = function bincn(bit) {
        assert(typeof bit === "number");
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) {
            this._expand(s + 1);
            this.words[s] |= q;
            return this;
        }
        // Add bit and propagate, if needed
        var carry = q;
        for(var i = s; carry !== 0 && i < this.length; i++){
            var w = this.words[i] | 0;
            w += carry;
            carry = w >>> 26;
            w &= 0x3ffffff;
            this.words[i] = w;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.isZero = function isZero() {
        return this.length === 1 && this.words[0] === 0;
    };
    BN.prototype.cmpn = function cmpn(num) {
        var negative = num < 0;
        if (this.negative !== 0 && !negative) return -1;
        if (this.negative === 0 && negative) return 1;
        this.strip();
        var res;
        if (this.length > 1) res = 1;
        else {
            if (negative) num = -num;
            assert(num <= 0x3ffffff, "Number is too big");
            var w = this.words[0] | 0;
            res = w === num ? 0 : w < num ? -1 : 1;
        }
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Compare two numbers and return:
    // 1 - if `this` > `num`
    // 0 - if `this` == `num`
    // -1 - if `this` < `num`
    BN.prototype.cmp = function cmp(num) {
        if (this.negative !== 0 && num.negative === 0) return -1;
        if (this.negative === 0 && num.negative !== 0) return 1;
        var res = this.ucmp(num);
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Unsigned comparison
    BN.prototype.ucmp = function ucmp(num) {
        // At this point both numbers have the same sign
        if (this.length > num.length) return 1;
        if (this.length < num.length) return -1;
        var res = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var a = this.words[i] | 0;
            var b = num.words[i] | 0;
            if (a === b) continue;
            if (a < b) res = -1;
            else if (a > b) res = 1;
            break;
        }
        return res;
    };
    BN.prototype.gtn = function gtn(num) {
        return this.cmpn(num) === 1;
    };
    BN.prototype.gt = function gt(num) {
        return this.cmp(num) === 1;
    };
    BN.prototype.gten = function gten(num) {
        return this.cmpn(num) >= 0;
    };
    BN.prototype.gte = function gte(num) {
        return this.cmp(num) >= 0;
    };
    BN.prototype.ltn = function ltn(num) {
        return this.cmpn(num) === -1;
    };
    BN.prototype.lt = function lt(num) {
        return this.cmp(num) === -1;
    };
    BN.prototype.lten = function lten(num) {
        return this.cmpn(num) <= 0;
    };
    BN.prototype.lte = function lte(num) {
        return this.cmp(num) <= 0;
    };
    BN.prototype.eqn = function eqn(num) {
        return this.cmpn(num) === 0;
    };
    BN.prototype.eq = function eq(num) {
        return this.cmp(num) === 0;
    };
    //
    // A reduce context, could be using montgomery or something better, depending
    // on the `m` itself.
    //
    BN.red = function red(num) {
        return new Red(num);
    };
    BN.prototype.toRed = function toRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        assert(this.negative === 0, "red works only with positives");
        return ctx.convertTo(this)._forceRed(ctx);
    };
    BN.prototype.fromRed = function fromRed() {
        assert(this.red, "fromRed works only with numbers in reduction context");
        return this.red.convertFrom(this);
    };
    BN.prototype._forceRed = function _forceRed(ctx) {
        this.red = ctx;
        return this;
    };
    BN.prototype.forceRed = function forceRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        return this._forceRed(ctx);
    };
    BN.prototype.redAdd = function redAdd(num) {
        assert(this.red, "redAdd works only with red numbers");
        return this.red.add(this, num);
    };
    BN.prototype.redIAdd = function redIAdd(num) {
        assert(this.red, "redIAdd works only with red numbers");
        return this.red.iadd(this, num);
    };
    BN.prototype.redSub = function redSub(num) {
        assert(this.red, "redSub works only with red numbers");
        return this.red.sub(this, num);
    };
    BN.prototype.redISub = function redISub(num) {
        assert(this.red, "redISub works only with red numbers");
        return this.red.isub(this, num);
    };
    BN.prototype.redShl = function redShl(num) {
        assert(this.red, "redShl works only with red numbers");
        return this.red.shl(this, num);
    };
    BN.prototype.redMul = function redMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.mul(this, num);
    };
    BN.prototype.redIMul = function redIMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.imul(this, num);
    };
    BN.prototype.redSqr = function redSqr() {
        assert(this.red, "redSqr works only with red numbers");
        this.red._verify1(this);
        return this.red.sqr(this);
    };
    BN.prototype.redISqr = function redISqr() {
        assert(this.red, "redISqr works only with red numbers");
        this.red._verify1(this);
        return this.red.isqr(this);
    };
    // Square root over p
    BN.prototype.redSqrt = function redSqrt() {
        assert(this.red, "redSqrt works only with red numbers");
        this.red._verify1(this);
        return this.red.sqrt(this);
    };
    BN.prototype.redInvm = function redInvm() {
        assert(this.red, "redInvm works only with red numbers");
        this.red._verify1(this);
        return this.red.invm(this);
    };
    // Return negative clone of `this` % `red modulo`
    BN.prototype.redNeg = function redNeg() {
        assert(this.red, "redNeg works only with red numbers");
        this.red._verify1(this);
        return this.red.neg(this);
    };
    BN.prototype.redPow = function redPow(num) {
        assert(this.red && !num.red, "redPow(normalNum)");
        this.red._verify1(this);
        return this.red.pow(this, num);
    };
    // Prime numbers with efficient reduction
    var primes = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
    };
    // Pseudo-Mersenne prime
    function MPrime(name, p) {
        // P = 2 ^ N - K
        this.name = name;
        this.p = new BN(p, 16);
        this.n = this.p.bitLength();
        this.k = new BN(1).iushln(this.n).isub(this.p);
        this.tmp = this._tmp();
    }
    MPrime.prototype._tmp = function _tmp() {
        var tmp = new BN(null);
        tmp.words = new Array(Math.ceil(this.n / 13));
        return tmp;
    };
    MPrime.prototype.ireduce = function ireduce(num) {
        // Assumes that `num` is less than `P^2`
        // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
        var r = num;
        var rlen;
        do {
            this.split(r, this.tmp);
            r = this.imulK(r);
            r = r.iadd(this.tmp);
            rlen = r.bitLength();
        }while (rlen > this.n);
        var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
        if (cmp === 0) {
            r.words[0] = 0;
            r.length = 1;
        } else if (cmp > 0) r.isub(this.p);
        else r.strip();
        return r;
    };
    MPrime.prototype.split = function split(input, out) {
        input.iushrn(this.n, 0, out);
    };
    MPrime.prototype.imulK = function imulK(num) {
        return num.imul(this.k);
    };
    function K256() {
        MPrime.call(this, "k256", "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f");
    }
    inherits(K256, MPrime);
    K256.prototype.split = function split(input, output) {
        // 256 = 9 * 26 + 22
        var mask = 0x3fffff;
        var outLen = Math.min(input.length, 9);
        for(var i = 0; i < outLen; i++)output.words[i] = input.words[i];
        output.length = outLen;
        if (input.length <= 9) {
            input.words[0] = 0;
            input.length = 1;
            return;
        }
        // Shift by 9 limbs
        var prev = input.words[9];
        output.words[output.length++] = prev & mask;
        for(i = 10; i < input.length; i++){
            var next = input.words[i] | 0;
            input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
            prev = next;
        }
        prev >>>= 22;
        input.words[i - 10] = prev;
        if (prev === 0 && input.length > 10) input.length -= 10;
        else input.length -= 9;
    };
    K256.prototype.imulK = function imulK(num) {
        // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
        num.words[num.length] = 0;
        num.words[num.length + 1] = 0;
        num.length += 2;
        // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
        var lo = 0;
        for(var i = 0; i < num.length; i++){
            var w = num.words[i] | 0;
            lo += w * 0x3d1;
            num.words[i] = lo & 0x3ffffff;
            lo = w * 0x40 + (lo / 0x4000000 | 0);
        }
        // Fast length reduction
        if (num.words[num.length - 1] === 0) {
            num.length--;
            if (num.words[num.length - 1] === 0) num.length--;
        }
        return num;
    };
    function P224() {
        MPrime.call(this, "p224", "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001");
    }
    inherits(P224, MPrime);
    function P192() {
        MPrime.call(this, "p192", "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff");
    }
    inherits(P192, MPrime);
    function P25519() {
        // 2 ^ 255 - 19
        MPrime.call(this, "25519", "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed");
    }
    inherits(P25519, MPrime);
    P25519.prototype.imulK = function imulK(num) {
        // K = 0x13
        var carry = 0;
        for(var i = 0; i < num.length; i++){
            var hi = (num.words[i] | 0) * 0x13 + carry;
            var lo = hi & 0x3ffffff;
            hi >>>= 26;
            num.words[i] = lo;
            carry = hi;
        }
        if (carry !== 0) num.words[num.length++] = carry;
        return num;
    };
    // Exported mostly for testing purposes, use plain name instead
    BN._prime = function prime(name) {
        // Cached version of prime
        if (primes[name]) return primes[name];
        var prime;
        if (name === "k256") prime = new K256();
        else if (name === "p224") prime = new P224();
        else if (name === "p192") prime = new P192();
        else if (name === "p25519") prime = new P25519();
        else throw new Error("Unknown prime " + name);
        primes[name] = prime;
        return prime;
    };
    //
    // Base reduction engine
    //
    function Red(m) {
        if (typeof m === "string") {
            var prime = BN._prime(m);
            this.m = prime.p;
            this.prime = prime;
        } else {
            assert(m.gtn(1), "modulus must be greater than 1");
            this.m = m;
            this.prime = null;
        }
    }
    Red.prototype._verify1 = function _verify1(a) {
        assert(a.negative === 0, "red works only with positives");
        assert(a.red, "red works only with red numbers");
    };
    Red.prototype._verify2 = function _verify2(a, b) {
        assert((a.negative | b.negative) === 0, "red works only with positives");
        assert(a.red && a.red === b.red, "red works only with red numbers");
    };
    Red.prototype.imod = function imod(a) {
        if (this.prime) return this.prime.ireduce(a)._forceRed(this);
        return a.umod(this.m)._forceRed(this);
    };
    Red.prototype.neg = function neg(a) {
        if (a.isZero()) return a.clone();
        return this.m.sub(a)._forceRed(this);
    };
    Red.prototype.add = function add(a, b) {
        this._verify2(a, b);
        var res = a.add(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res._forceRed(this);
    };
    Red.prototype.iadd = function iadd(a, b) {
        this._verify2(a, b);
        var res = a.iadd(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res;
    };
    Red.prototype.sub = function sub(a, b) {
        this._verify2(a, b);
        var res = a.sub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res._forceRed(this);
    };
    Red.prototype.isub = function isub(a, b) {
        this._verify2(a, b);
        var res = a.isub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res;
    };
    Red.prototype.shl = function shl(a, num) {
        this._verify1(a);
        return this.imod(a.ushln(num));
    };
    Red.prototype.imul = function imul(a, b) {
        this._verify2(a, b);
        return this.imod(a.imul(b));
    };
    Red.prototype.mul = function mul(a, b) {
        this._verify2(a, b);
        return this.imod(a.mul(b));
    };
    Red.prototype.isqr = function isqr(a) {
        return this.imul(a, a.clone());
    };
    Red.prototype.sqr = function sqr(a) {
        return this.mul(a, a);
    };
    Red.prototype.sqrt = function sqrt(a) {
        if (a.isZero()) return a.clone();
        var mod3 = this.m.andln(3);
        assert(mod3 % 2 === 1);
        // Fast case
        if (mod3 === 3) {
            var pow = this.m.add(new BN(1)).iushrn(2);
            return this.pow(a, pow);
        }
        // Tonelli-Shanks algorithm (Totally unoptimized and slow)
        //
        // Find Q and S, that Q * 2 ^ S = (P - 1)
        var q = this.m.subn(1);
        var s = 0;
        while(!q.isZero() && q.andln(1) === 0){
            s++;
            q.iushrn(1);
        }
        assert(!q.isZero());
        var one = new BN(1).toRed(this);
        var nOne = one.redNeg();
        // Find quadratic non-residue
        // NOTE: Max is such because of generalized Riemann hypothesis.
        var lpow = this.m.subn(1).iushrn(1);
        var z = this.m.bitLength();
        z = new BN(2 * z * z).toRed(this);
        while(this.pow(z, lpow).cmp(nOne) !== 0)z.redIAdd(nOne);
        var c = this.pow(z, q);
        var r = this.pow(a, q.addn(1).iushrn(1));
        var t = this.pow(a, q);
        var m = s;
        while(t.cmp(one) !== 0){
            var tmp = t;
            for(var i = 0; tmp.cmp(one) !== 0; i++)tmp = tmp.redSqr();
            assert(i < m);
            var b = this.pow(c, new BN(1).iushln(m - i - 1));
            r = r.redMul(b);
            c = b.redSqr();
            t = t.redMul(c);
            m = i;
        }
        return r;
    };
    Red.prototype.invm = function invm(a) {
        var inv = a._invmp(this.m);
        if (inv.negative !== 0) {
            inv.negative = 0;
            return this.imod(inv).redNeg();
        } else return this.imod(inv);
    };
    Red.prototype.pow = function pow(a, num) {
        if (num.isZero()) return new BN(1).toRed(this);
        if (num.cmpn(1) === 0) return a.clone();
        var windowSize = 4;
        var wnd = new Array(1 << windowSize);
        wnd[0] = new BN(1).toRed(this);
        wnd[1] = a;
        for(var i = 2; i < wnd.length; i++)wnd[i] = this.mul(wnd[i - 1], a);
        var res = wnd[0];
        var current = 0;
        var currentLen = 0;
        var start = num.bitLength() % 26;
        if (start === 0) start = 26;
        for(i = num.length - 1; i >= 0; i--){
            var word = num.words[i];
            for(var j = start - 1; j >= 0; j--){
                var bit = word >> j & 1;
                if (res !== wnd[0]) res = this.sqr(res);
                if (bit === 0 && current === 0) {
                    currentLen = 0;
                    continue;
                }
                current <<= 1;
                current |= bit;
                currentLen++;
                if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
                res = this.mul(res, wnd[current]);
                currentLen = 0;
                current = 0;
            }
            start = 26;
        }
        return res;
    };
    Red.prototype.convertTo = function convertTo(num) {
        var r = num.umod(this.m);
        return r === num ? r.clone() : r;
    };
    Red.prototype.convertFrom = function convertFrom(num) {
        var res = num.clone();
        res.red = null;
        return res;
    };
    //
    // Montgomery method engine
    //
    BN.mont = function mont(num) {
        return new Mont(num);
    };
    function Mont(m) {
        Red.call(this, m);
        this.shift = this.m.bitLength();
        if (this.shift % 26 !== 0) this.shift += 26 - this.shift % 26;
        this.r = new BN(1).iushln(this.shift);
        this.r2 = this.imod(this.r.sqr());
        this.rinv = this.r._invmp(this.m);
        this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
        this.minv = this.minv.umod(this.r);
        this.minv = this.r.sub(this.minv);
    }
    inherits(Mont, Red);
    Mont.prototype.convertTo = function convertTo(num) {
        return this.imod(num.ushln(this.shift));
    };
    Mont.prototype.convertFrom = function convertFrom(num) {
        var r = this.imod(num.mul(this.rinv));
        r.red = null;
        return r;
    };
    Mont.prototype.imul = function imul(a, b) {
        if (a.isZero() || b.isZero()) {
            a.words[0] = 0;
            a.length = 1;
            return a;
        }
        var t = a.imul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.mul = function mul(a, b) {
        if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
        var t = a.mul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.invm = function invm(a) {
        // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
        var res = this.imod(a._invmp(this.m).mul(this.r2));
        return res._forceRed(this);
    };
})(module, this);

},{"bd440367abe2ded7":"13Pcp"}],"hIv0Z":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "bufferToArray", ()=>bufferToArray);
parcelHelpers.export(exports, "bufferToHex", ()=>bufferToHex);
parcelHelpers.export(exports, "bufferToUtf8", ()=>bufferToUtf8);
parcelHelpers.export(exports, "bufferToNumber", ()=>bufferToNumber);
parcelHelpers.export(exports, "bufferToBinary", ()=>bufferToBinary);
parcelHelpers.export(exports, "arrayToBuffer", ()=>arrayToBuffer);
parcelHelpers.export(exports, "arrayToHex", ()=>arrayToHex);
parcelHelpers.export(exports, "arrayToUtf8", ()=>arrayToUtf8);
parcelHelpers.export(exports, "arrayToNumber", ()=>arrayToNumber);
parcelHelpers.export(exports, "arrayToBinary", ()=>arrayToBinary);
parcelHelpers.export(exports, "hexToBuffer", ()=>hexToBuffer);
parcelHelpers.export(exports, "hexToArray", ()=>hexToArray);
parcelHelpers.export(exports, "hexToUtf8", ()=>hexToUtf8);
parcelHelpers.export(exports, "hexToNumber", ()=>hexToNumber);
parcelHelpers.export(exports, "hexToBinary", ()=>hexToBinary);
parcelHelpers.export(exports, "utf8ToBuffer", ()=>utf8ToBuffer);
parcelHelpers.export(exports, "utf8ToArray", ()=>utf8ToArray);
parcelHelpers.export(exports, "utf8ToHex", ()=>utf8ToHex);
parcelHelpers.export(exports, "utf8ToNumber", ()=>utf8ToNumber);
parcelHelpers.export(exports, "utf8ToBinary", ()=>utf8ToBinary);
parcelHelpers.export(exports, "numberToBuffer", ()=>numberToBuffer);
parcelHelpers.export(exports, "numberToArray", ()=>numberToArray);
parcelHelpers.export(exports, "numberToHex", ()=>numberToHex);
parcelHelpers.export(exports, "numberToUtf8", ()=>numberToUtf8);
parcelHelpers.export(exports, "numberToBinary", ()=>numberToBinary);
parcelHelpers.export(exports, "binaryToBuffer", ()=>binaryToBuffer);
parcelHelpers.export(exports, "binaryToArray", ()=>binaryToArray);
parcelHelpers.export(exports, "binaryToHex", ()=>binaryToHex);
parcelHelpers.export(exports, "binaryToUtf8", ()=>binaryToUtf8);
parcelHelpers.export(exports, "binaryToNumber", ()=>binaryToNumber);
parcelHelpers.export(exports, "isBinaryString", ()=>isBinaryString);
parcelHelpers.export(exports, "isHexString", ()=>isHexString);
parcelHelpers.export(exports, "isBuffer", ()=>isBuffer);
parcelHelpers.export(exports, "isTypedArray", ()=>isTypedArray);
parcelHelpers.export(exports, "isArrayBuffer", ()=>isArrayBuffer);
parcelHelpers.export(exports, "getType", ()=>getType);
parcelHelpers.export(exports, "getEncoding", ()=>getEncoding);
parcelHelpers.export(exports, "concatBuffers", ()=>concatBuffers);
parcelHelpers.export(exports, "concatArrays", ()=>concatArrays);
parcelHelpers.export(exports, "trimLeft", ()=>trimLeft);
parcelHelpers.export(exports, "trimRight", ()=>trimRight);
parcelHelpers.export(exports, "calcByteLength", ()=>calcByteLength);
parcelHelpers.export(exports, "splitBytes", ()=>splitBytes);
parcelHelpers.export(exports, "swapBytes", ()=>swapBytes);
parcelHelpers.export(exports, "swapHex", ()=>swapHex);
parcelHelpers.export(exports, "sanitizeBytes", ()=>sanitizeBytes);
parcelHelpers.export(exports, "padLeft", ()=>padLeft);
parcelHelpers.export(exports, "padRight", ()=>padRight);
parcelHelpers.export(exports, "removeHexPrefix", ()=>removeHexPrefix);
parcelHelpers.export(exports, "addHexPrefix", ()=>addHexPrefix);
parcelHelpers.export(exports, "sanitizeHex", ()=>sanitizeHex);
parcelHelpers.export(exports, "removeHexLeadingZeros", ()=>removeHexLeadingZeros);
var _isTypedarray = require("is-typedarray");
var _isTypedarrayDefault = parcelHelpers.interopDefault(_isTypedarray);
var _typedarrayToBuffer = require("typedarray-to-buffer");
var _typedarrayToBufferDefault = parcelHelpers.interopDefault(_typedarrayToBuffer);
var Buffer = require("79ef0aad0414f771").Buffer;
const ENC_HEX = "hex";
const ENC_UTF8 = "utf8";
const ENC_BIN = "binary";
const TYPE_BUFFER = "buffer";
const TYPE_ARRAY = "array";
const TYPE_TYPED_ARRAY = "typed-array";
const TYPE_ARRAY_BUFFER = "array-buffer";
const STRING_ZERO = "0";
function bufferToArray(buf) {
    return new Uint8Array(buf);
}
function bufferToHex(buf, prefixed = false) {
    const hex = buf.toString(ENC_HEX);
    return prefixed ? addHexPrefix(hex) : hex;
}
function bufferToUtf8(buf) {
    return buf.toString(ENC_UTF8);
}
function bufferToNumber(buf) {
    return buf.readUIntBE(0, buf.length);
}
function bufferToBinary(buf) {
    return arrayToBinary(bufferToArray(buf));
}
function arrayToBuffer(arr) {
    return (0, _typedarrayToBufferDefault.default)(arr);
}
function arrayToHex(arr, prefixed = false) {
    return bufferToHex(arrayToBuffer(arr), prefixed);
}
function arrayToUtf8(arr) {
    return bufferToUtf8(arrayToBuffer(arr));
}
function arrayToNumber(arr) {
    return bufferToNumber(arrayToBuffer(arr));
}
function arrayToBinary(arr) {
    return Array.from(arr).map(numberToBinary).join("");
}
function hexToBuffer(hex) {
    return Buffer.from(removeHexPrefix(hex), ENC_HEX);
}
function hexToArray(hex) {
    return bufferToArray(hexToBuffer(hex));
}
function hexToUtf8(hex) {
    return bufferToUtf8(hexToBuffer(hex));
}
function hexToNumber(hex) {
    return arrayToNumber(hexToArray(hex));
}
function hexToBinary(hex) {
    return arrayToBinary(hexToArray(hex));
}
function utf8ToBuffer(utf8) {
    return Buffer.from(utf8, ENC_UTF8);
}
function utf8ToArray(utf8) {
    return bufferToArray(utf8ToBuffer(utf8));
}
function utf8ToHex(utf8, prefixed = false) {
    return bufferToHex(utf8ToBuffer(utf8), prefixed);
}
function utf8ToNumber(utf8) {
    const num = parseInt(utf8, 10);
    assert(isDefined(num), "Number can only safely store up to 53 bits");
    return num;
}
function utf8ToBinary(utf8) {
    return arrayToBinary(utf8ToArray(utf8));
}
function numberToBuffer(num) {
    return binaryToBuffer(numberToBinary(num));
}
function numberToArray(num) {
    return binaryToArray(numberToBinary(num));
}
function numberToHex(num, prefixed) {
    return binaryToHex(numberToBinary(num), prefixed);
}
function numberToUtf8(num) {
    return `${num}`;
}
function numberToBinary(num) {
    const bin = (num >>> 0).toString(2);
    return sanitizeBytes(bin);
}
function binaryToBuffer(bin) {
    return arrayToBuffer(binaryToArray(bin));
}
function binaryToArray(bin) {
    return new Uint8Array(splitBytes(bin).map((x)=>parseInt(x, 2)));
}
function binaryToHex(bin, prefixed) {
    return arrayToHex(binaryToArray(bin), prefixed);
}
function binaryToUtf8(bin) {
    return arrayToUtf8(binaryToArray(bin));
}
function binaryToNumber(bin) {
    return arrayToNumber(binaryToArray(bin));
}
function isBinaryString(str) {
    if (typeof str !== "string" || !new RegExp(/^[01]+$/).test(str)) return false;
    if (str.length % 8 !== 0) return false;
    return true;
}
function isHexString(str, length) {
    if (typeof str !== "string" || !str.match(/^0x[0-9A-Fa-f]*$/)) return false;
    if (length && str.length !== 2 + 2 * length) return false;
    return true;
}
function isBuffer(val) {
    return Buffer.isBuffer(val);
}
function isTypedArray(val) {
    return (0, _isTypedarrayDefault.default).strict(val) && !isBuffer(val);
}
function isArrayBuffer(val) {
    return !isTypedArray(val) && !isBuffer(val) && typeof val.byteLength !== "undefined";
}
function getType(val) {
    if (isBuffer(val)) return TYPE_BUFFER;
    else if (isTypedArray(val)) return TYPE_TYPED_ARRAY;
    else if (isArrayBuffer(val)) return TYPE_ARRAY_BUFFER;
    else if (Array.isArray(val)) return TYPE_ARRAY;
    else return typeof val;
}
function getEncoding(str) {
    if (isBinaryString(str)) return ENC_BIN;
    if (isHexString(str)) return ENC_HEX;
    return ENC_UTF8;
}
function concatBuffers(...args) {
    const result = Buffer.concat(args);
    return result;
}
function concatArrays(...args) {
    let result = [];
    args.forEach((arg)=>result = result.concat(Array.from(arg)));
    return new Uint8Array([
        ...result
    ]);
}
function trimLeft(data, length) {
    const diff = data.length - length;
    if (diff > 0) data = data.slice(diff);
    return data;
}
function trimRight(data, length) {
    return data.slice(0, length);
}
function calcByteLength(length, byteSize = 8) {
    const remainder = length % byteSize;
    return remainder ? (length - remainder) / byteSize * byteSize + byteSize : length;
}
function splitBytes(str, byteSize = 8) {
    const bytes = sanitizeBytes(str).match(new RegExp(`.{${byteSize}}`, "gi"));
    return Array.from(bytes || []);
}
function swapBytes(str) {
    return splitBytes(str).map(reverseString).join("");
}
function swapHex(str) {
    return binaryToHex(swapBytes(hexToBinary(str)));
}
function sanitizeBytes(str, byteSize = 8, padding = STRING_ZERO) {
    return padLeft(str, calcByteLength(str.length, byteSize), padding);
}
function padLeft(str, length, padding = STRING_ZERO) {
    return padString(str, length, true, padding);
}
function padRight(str, length, padding = STRING_ZERO) {
    return padString(str, length, false, padding);
}
function removeHexPrefix(hex) {
    return hex.replace(/^0x/, "");
}
function addHexPrefix(hex) {
    return hex.startsWith("0x") ? hex : `0x${hex}`;
}
function sanitizeHex(hex) {
    hex = removeHexPrefix(hex);
    hex = sanitizeBytes(hex, 2);
    if (hex) hex = addHexPrefix(hex);
    return hex;
}
function removeHexLeadingZeros(hex) {
    const prefixed = hex.startsWith("0x");
    hex = removeHexPrefix(hex);
    hex = hex.startsWith(STRING_ZERO) ? hex.substring(1) : hex;
    return prefixed ? addHexPrefix(hex) : hex;
}
function isUndefined(value) {
    return typeof value === "undefined";
}
function isDefined(value) {
    return !isUndefined(value);
}
function assert(assertion, errorMessage) {
    if (!assertion) throw new Error(errorMessage);
}
function reverseString(str) {
    return str.split("").reverse().join("");
}
function padString(str, length, left, padding = STRING_ZERO) {
    const diff = length - str.length;
    let result = str;
    if (diff > 0) {
        const pad = padding.repeat(diff);
        result = left ? pad + str : str + pad;
    }
    return result;
}

},{"79ef0aad0414f771":"l5Twm","is-typedarray":"gGOie","typedarray-to-buffer":"cEFLQ","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"gGOie":[function(require,module,exports) {
module.exports = isTypedArray;
isTypedArray.strict = isStrictTypedArray;
isTypedArray.loose = isLooseTypedArray;
var toString = Object.prototype.toString;
var names = {
    "[object Int8Array]": true,
    "[object Int16Array]": true,
    "[object Int32Array]": true,
    "[object Uint8Array]": true,
    "[object Uint8ClampedArray]": true,
    "[object Uint16Array]": true,
    "[object Uint32Array]": true,
    "[object Float32Array]": true,
    "[object Float64Array]": true
};
function isTypedArray(arr) {
    return isStrictTypedArray(arr) || isLooseTypedArray(arr);
}
function isStrictTypedArray(arr) {
    return arr instanceof Int8Array || arr instanceof Int16Array || arr instanceof Int32Array || arr instanceof Uint8Array || arr instanceof Uint8ClampedArray || arr instanceof Uint16Array || arr instanceof Uint32Array || arr instanceof Float32Array || arr instanceof Float64Array;
}
function isLooseTypedArray(arr) {
    return names[toString.call(arr)];
}

},{}],"cEFLQ":[function(require,module,exports) {
/**
 * Convert a typed array to a Buffer without a copy
 *
 * Author:   Feross Aboukhadijeh <https://feross.org>
 * License:  MIT
 *
 * `npm install typedarray-to-buffer`
 */ var Buffer = require("1a78dd7d8c10fe5c").Buffer;
var isTypedArray = require("dfcbed822b77bad7").strict;
module.exports = function typedarrayToBuffer(arr) {
    if (isTypedArray(arr)) {
        // To avoid a copy, use the typed array's underlying ArrayBuffer to back new Buffer
        var buf = Buffer.from(arr.buffer);
        if (arr.byteLength !== arr.buffer.byteLength) // Respect the "view", i.e. byteOffset and byteLength, without doing a copy
        buf = buf.slice(arr.byteOffset, arr.byteOffset + arr.byteLength);
        return buf;
    } else // Pass through all other types to `Buffer.from`
    return Buffer.from(arr);
};

},{"1a78dd7d8c10fe5c":"l5Twm","dfcbed822b77bad7":"gGOie"}],"9dyAP":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "toChecksumAddress", ()=>toChecksumAddress);
parcelHelpers.export(exports, "isValidAddress", ()=>isValidAddress);
parcelHelpers.export(exports, "parsePersonalSign", ()=>parsePersonalSign);
parcelHelpers.export(exports, "parseTransactionData", ()=>parseTransactionData);
var _jsSha3 = require("js-sha3");
var _encoding = require("@walletconnect/encoding");
var _encoding1 = require("./encoding");
var _misc = require("./misc");
var _validators = require("./validators");
function toChecksumAddress(address) {
    address = (0, _encoding.removeHexPrefix)(address.toLowerCase());
    const hash = (0, _encoding.removeHexPrefix)((0, _jsSha3.keccak_256)((0, _encoding1.convertUtf8ToBuffer)(address)));
    let checksum = "";
    for(let i = 0; i < address.length; i++)if (parseInt(hash[i], 16) > 7) checksum += address[i].toUpperCase();
    else checksum += address[i];
    return (0, _encoding.addHexPrefix)(checksum);
}
const isValidAddress = (address)=>{
    if (!address) return false;
    else if (address.toLowerCase().substring(0, 2) !== "0x") return false;
    else if (!/^(0x)?[0-9a-f]{40}$/i.test(address)) return false;
    else if (/^(0x)?[0-9a-f]{40}$/.test(address) || /^(0x)?[0-9A-F]{40}$/.test(address)) return true;
    else return address === toChecksumAddress(address);
};
function parsePersonalSign(params) {
    if (!(0, _validators.isEmptyArray)(params) && !(0, _validators.isHexString)(params[0])) params[0] = (0, _encoding1.convertUtf8ToHex)(params[0]);
    return params;
}
function parseTransactionData(txData) {
    if (typeof txData.type !== "undefined" && txData.type !== "0") return txData;
    if (typeof txData.from === "undefined" || !isValidAddress(txData.from)) throw new Error(`Transaction object must include a valid 'from' value.`);
    function parseHexValues(value) {
        let result = value;
        if (typeof value === "number" || typeof value === "string" && !(0, _validators.isEmptyString)(value)) {
            if (!(0, _validators.isHexString)(value)) result = (0, _encoding1.convertNumberToHex)(value);
            else if (typeof value === "string") result = (0, _misc.sanitizeHex)(value);
        }
        if (typeof result === "string") result = (0, _misc.removeHexLeadingZeros)(result);
        return result;
    }
    const txDataRPC = {
        from: (0, _misc.sanitizeHex)(txData.from),
        to: typeof txData.to === "undefined" ? undefined : (0, _misc.sanitizeHex)(txData.to),
        gasPrice: typeof txData.gasPrice === "undefined" ? "" : parseHexValues(txData.gasPrice),
        gas: typeof txData.gas === "undefined" ? typeof txData.gasLimit === "undefined" ? "" : parseHexValues(txData.gasLimit) : parseHexValues(txData.gas),
        value: typeof txData.value === "undefined" ? "" : parseHexValues(txData.value),
        nonce: typeof txData.nonce === "undefined" ? "" : parseHexValues(txData.nonce),
        data: typeof txData.data === "undefined" ? "" : (0, _misc.sanitizeHex)(txData.data) || "0x"
    };
    const prunable = [
        "gasPrice",
        "gas",
        "value",
        "nonce"
    ];
    Object.keys(txDataRPC).forEach((key)=>{
        if ((typeof txDataRPC[key] === "undefined" || typeof txDataRPC[key] === "string" && !txDataRPC[key].trim().length) && prunable.includes(key)) delete txDataRPC[key];
    });
    return txDataRPC;
}

},{"js-sha3":"hqGBR","@walletconnect/encoding":"hIv0Z","./encoding":"2rdaL","./misc":"6tzxQ","./validators":"lkbI7","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"6tzxQ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "sanitizeHex", ()=>sanitizeHex);
parcelHelpers.export(exports, "addHexPrefix", ()=>addHexPrefix);
parcelHelpers.export(exports, "removeHexPrefix", ()=>removeHexPrefix);
parcelHelpers.export(exports, "removeHexLeadingZeros", ()=>removeHexLeadingZeros);
parcelHelpers.export(exports, "payloadId", ()=>payloadId);
parcelHelpers.export(exports, "uuid", ()=>uuid);
parcelHelpers.export(exports, "logDeprecationWarning", ()=>logDeprecationWarning);
parcelHelpers.export(exports, "getInfuraRpcUrl", ()=>getInfuraRpcUrl);
parcelHelpers.export(exports, "getRpcUrl", ()=>getRpcUrl);
var _encoding = require("@walletconnect/encoding");
var _jsonrpcUtils = require("@walletconnect/jsonrpc-utils");
var _constants = require("./constants");
function sanitizeHex(hex) {
    return _encoding.sanitizeHex(hex);
}
function addHexPrefix(hex) {
    return _encoding.addHexPrefix(hex);
}
function removeHexPrefix(hex) {
    return _encoding.removeHexPrefix(hex);
}
function removeHexLeadingZeros(hex) {
    return _encoding.removeHexLeadingZeros(_encoding.addHexPrefix(hex));
}
const payloadId = _jsonrpcUtils.payloadId;
function uuid() {
    const result = ((a, b)=>{
        for(b = a = ""; a++ < 36; b += a * 51 & 52 ? (a ^ 15 ? 8 ^ Math.random() * (a ^ 20 ? 16 : 4) : 4).toString(16) : "-");
        return b;
    })();
    return result;
}
function logDeprecationWarning() {
    console.warn("DEPRECATION WARNING: This WalletConnect client library will be deprecated in favor of @walletconnect/client. Please check docs.walletconnect.org to learn more about this migration!");
}
function getInfuraRpcUrl(chainId, infuraId) {
    let rpcUrl;
    const network = (0, _constants.infuraNetworks)[chainId];
    if (network) rpcUrl = `https://${network}.infura.io/v3/${infuraId}`;
    return rpcUrl;
}
function getRpcUrl(chainId, rpc) {
    let rpcUrl;
    const infuraUrl = getInfuraRpcUrl(chainId, rpc.infuraId);
    if (rpc.custom && rpc.custom[chainId]) rpcUrl = rpc.custom[chainId];
    else if (infuraUrl) rpcUrl = infuraUrl;
    return rpcUrl;
}

},{"@walletconnect/encoding":"hIv0Z","@walletconnect/jsonrpc-utils":"dUcPw","./constants":"dx6md","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"dUcPw":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _constants = require("./constants");
parcelHelpers.exportAll(_constants, exports);
var _error = require("./error");
parcelHelpers.exportAll(_error, exports);
var _env = require("./env");
parcelHelpers.exportAll(_env, exports);
var _format = require("./format");
parcelHelpers.exportAll(_format, exports);
var _routing = require("./routing");
parcelHelpers.exportAll(_routing, exports);
var _types = require("./types");
parcelHelpers.exportAll(_types, exports);
var _url = require("./url");
parcelHelpers.exportAll(_url, exports);
var _validators = require("./validators");
parcelHelpers.exportAll(_validators, exports);

},{"./constants":"dic9X","./error":"lpnqm","./env":"3Rucj","./format":"jPgVJ","./routing":"fXfep","./types":"UuYNN","./url":"lT9DQ","./validators":"bqcdC","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"dic9X":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PARSE_ERROR", ()=>PARSE_ERROR);
parcelHelpers.export(exports, "INVALID_REQUEST", ()=>INVALID_REQUEST);
parcelHelpers.export(exports, "METHOD_NOT_FOUND", ()=>METHOD_NOT_FOUND);
parcelHelpers.export(exports, "INVALID_PARAMS", ()=>INVALID_PARAMS);
parcelHelpers.export(exports, "INTERNAL_ERROR", ()=>INTERNAL_ERROR);
parcelHelpers.export(exports, "SERVER_ERROR", ()=>SERVER_ERROR);
parcelHelpers.export(exports, "RESERVED_ERROR_CODES", ()=>RESERVED_ERROR_CODES);
parcelHelpers.export(exports, "SERVER_ERROR_CODE_RANGE", ()=>SERVER_ERROR_CODE_RANGE);
parcelHelpers.export(exports, "STANDARD_ERROR_MAP", ()=>STANDARD_ERROR_MAP);
parcelHelpers.export(exports, "DEFAULT_ERROR", ()=>DEFAULT_ERROR);
const PARSE_ERROR = "PARSE_ERROR";
const INVALID_REQUEST = "INVALID_REQUEST";
const METHOD_NOT_FOUND = "METHOD_NOT_FOUND";
const INVALID_PARAMS = "INVALID_PARAMS";
const INTERNAL_ERROR = "INTERNAL_ERROR";
const SERVER_ERROR = "SERVER_ERROR";
const RESERVED_ERROR_CODES = [
    -32700,
    -32600,
    -32601,
    -32602,
    -32603
];
const SERVER_ERROR_CODE_RANGE = [
    -32000,
    -32099
];
const STANDARD_ERROR_MAP = {
    [PARSE_ERROR]: {
        code: -32700,
        message: "Parse error"
    },
    [INVALID_REQUEST]: {
        code: -32600,
        message: "Invalid Request"
    },
    [METHOD_NOT_FOUND]: {
        code: -32601,
        message: "Method not found"
    },
    [INVALID_PARAMS]: {
        code: -32602,
        message: "Invalid params"
    },
    [INTERNAL_ERROR]: {
        code: -32603,
        message: "Internal error"
    },
    [SERVER_ERROR]: {
        code: -32000,
        message: "Server error"
    }
};
const DEFAULT_ERROR = SERVER_ERROR;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"lpnqm":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isServerErrorCode", ()=>isServerErrorCode);
parcelHelpers.export(exports, "isReservedErrorCode", ()=>isReservedErrorCode);
parcelHelpers.export(exports, "isValidErrorCode", ()=>isValidErrorCode);
parcelHelpers.export(exports, "getError", ()=>getError);
parcelHelpers.export(exports, "getErrorByCode", ()=>getErrorByCode);
parcelHelpers.export(exports, "validateJsonRpcError", ()=>validateJsonRpcError);
parcelHelpers.export(exports, "parseConnectionError", ()=>parseConnectionError);
var _constants = require("./constants");
function isServerErrorCode(code) {
    return code <= (0, _constants.SERVER_ERROR_CODE_RANGE)[0] && code >= (0, _constants.SERVER_ERROR_CODE_RANGE)[1];
}
function isReservedErrorCode(code) {
    return (0, _constants.RESERVED_ERROR_CODES).includes(code);
}
function isValidErrorCode(code) {
    return typeof code === "number";
}
function getError(type) {
    if (!Object.keys((0, _constants.STANDARD_ERROR_MAP)).includes(type)) return (0, _constants.STANDARD_ERROR_MAP)[0, _constants.DEFAULT_ERROR];
    return (0, _constants.STANDARD_ERROR_MAP)[type];
}
function getErrorByCode(code) {
    const match = Object.values((0, _constants.STANDARD_ERROR_MAP)).find((e)=>e.code === code);
    if (!match) return (0, _constants.STANDARD_ERROR_MAP)[0, _constants.DEFAULT_ERROR];
    return match;
}
function validateJsonRpcError(response) {
    if (typeof response.error.code === "undefined") return {
        valid: false,
        error: "Missing code for JSON-RPC error"
    };
    if (typeof response.error.message === "undefined") return {
        valid: false,
        error: "Missing message for JSON-RPC error"
    };
    if (!isValidErrorCode(response.error.code)) return {
        valid: false,
        error: `Invalid error code type for JSON-RPC: ${response.error.code}`
    };
    if (isReservedErrorCode(response.error.code)) {
        const error = getErrorByCode(response.error.code);
        if (error.message !== (0, _constants.STANDARD_ERROR_MAP)[0, _constants.DEFAULT_ERROR].message && response.error.message === error.message) return {
            valid: false,
            error: `Invalid error code message for JSON-RPC: ${response.error.code}`
        };
    }
    return {
        valid: true
    };
}
function parseConnectionError(e, url, type) {
    return e.message.includes("getaddrinfo ENOTFOUND") || e.message.includes("connect ECONNREFUSED") ? new Error(`Unavailable ${type} RPC url at ${url}`) : e;
}

},{"./constants":"dic9X","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"3Rucj":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isNodeJs", ()=>isNodeJs);
var _environment = require("@walletconnect/environment");
parcelHelpers.exportAll(_environment, exports);
const isNodeJs = (0, _environment.isNode);

},{"@walletconnect/environment":"ljiRg","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"ljiRg":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
const tslib_1 = require("7ea7787f9cb444bc");
tslib_1.__exportStar(require("224c4ee8cc5fb5e6"), exports);
tslib_1.__exportStar(require("ca369212861f50d2"), exports);

},{"7ea7787f9cb444bc":"i5Jlw","224c4ee8cc5fb5e6":"9qgYL","ca369212861f50d2":"21TsA"}],"i5Jlw":[function(require,module,exports) {
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__extends", ()=>__extends);
parcelHelpers.export(exports, "__assign", ()=>__assign);
parcelHelpers.export(exports, "__rest", ()=>__rest);
parcelHelpers.export(exports, "__decorate", ()=>__decorate);
parcelHelpers.export(exports, "__param", ()=>__param);
parcelHelpers.export(exports, "__metadata", ()=>__metadata);
parcelHelpers.export(exports, "__awaiter", ()=>__awaiter);
parcelHelpers.export(exports, "__generator", ()=>__generator);
parcelHelpers.export(exports, "__createBinding", ()=>__createBinding);
parcelHelpers.export(exports, "__exportStar", ()=>__exportStar);
parcelHelpers.export(exports, "__values", ()=>__values);
parcelHelpers.export(exports, "__read", ()=>__read);
parcelHelpers.export(exports, "__spread", ()=>__spread);
parcelHelpers.export(exports, "__spreadArrays", ()=>__spreadArrays);
parcelHelpers.export(exports, "__await", ()=>__await);
parcelHelpers.export(exports, "__asyncGenerator", ()=>__asyncGenerator);
parcelHelpers.export(exports, "__asyncDelegator", ()=>__asyncDelegator);
parcelHelpers.export(exports, "__asyncValues", ()=>__asyncValues);
parcelHelpers.export(exports, "__makeTemplateObject", ()=>__makeTemplateObject);
parcelHelpers.export(exports, "__importStar", ()=>__importStar);
parcelHelpers.export(exports, "__importDefault", ()=>__importDefault);
parcelHelpers.export(exports, "__classPrivateFieldGet", ()=>__classPrivateFieldGet);
parcelHelpers.export(exports, "__classPrivateFieldSet", ()=>__classPrivateFieldSet);
var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return extendStatics(d, b);
};
function __extends(d, b) {
    extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
function __rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function __param(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function __generator(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function __createBinding(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function __exportStar(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function __spread() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat(__read(arguments[i]));
    return ar;
}
function __spreadArrays() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}
function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: __await(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function __importDefault(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function __classPrivateFieldGet(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function __classPrivateFieldSet(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9qgYL":[function(require,module,exports) {
var global = arguments[3];
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.isBrowserCryptoAvailable = exports.getSubtleCrypto = exports.getBrowerCrypto = void 0;
function getBrowerCrypto() {
    return (global === null || global === void 0 ? void 0 : global.crypto) || (global === null || global === void 0 ? void 0 : global.msCrypto) || {};
}
exports.getBrowerCrypto = getBrowerCrypto;
function getSubtleCrypto() {
    const browserCrypto = getBrowerCrypto();
    return browserCrypto.subtle || browserCrypto.webkitSubtle;
}
exports.getSubtleCrypto = getSubtleCrypto;
function isBrowserCryptoAvailable() {
    return !!getBrowerCrypto() && !!getSubtleCrypto();
}
exports.isBrowserCryptoAvailable = isBrowserCryptoAvailable;

},{}],"21TsA":[function(require,module,exports) {
var process = require("6ccfe05cfad71fdb");
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.isBrowser = exports.isNode = exports.isReactNative = void 0;
function isReactNative() {
    return typeof document === "undefined" && typeof navigator !== "undefined" && navigator.product === "ReactNative";
}
exports.isReactNative = isReactNative;
function isNode() {
    return typeof process !== "undefined" && typeof process.versions !== "undefined" && typeof process.versions.node !== "undefined";
}
exports.isNode = isNode;
function isBrowser() {
    return !isReactNative() && !isNode();
}
exports.isBrowser = isBrowser;

},{"6ccfe05cfad71fdb":"5QIF0"}],"jPgVJ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "payloadId", ()=>payloadId);
parcelHelpers.export(exports, "getBigIntRpcId", ()=>getBigIntRpcId);
parcelHelpers.export(exports, "formatJsonRpcRequest", ()=>formatJsonRpcRequest);
parcelHelpers.export(exports, "formatJsonRpcResult", ()=>formatJsonRpcResult);
parcelHelpers.export(exports, "formatJsonRpcError", ()=>formatJsonRpcError);
parcelHelpers.export(exports, "formatErrorMessage", ()=>formatErrorMessage);
var _error = require("./error");
var _constants = require("./constants");
function payloadId(entropy = 3) {
    const date = Date.now() * Math.pow(10, entropy);
    const extra = Math.floor(Math.random() * Math.pow(10, entropy));
    return date + extra;
}
function getBigIntRpcId(entropy = 6) {
    return BigInt(payloadId(entropy));
}
function formatJsonRpcRequest(method, params, id) {
    return {
        id: id || payloadId(),
        jsonrpc: "2.0",
        method,
        params
    };
}
function formatJsonRpcResult(id, result) {
    return {
        id,
        jsonrpc: "2.0",
        result
    };
}
function formatJsonRpcError(id, error, data) {
    return {
        id,
        jsonrpc: "2.0",
        error: formatErrorMessage(error, data)
    };
}
function formatErrorMessage(error, data) {
    if (typeof error === "undefined") return (0, _error.getError)((0, _constants.INTERNAL_ERROR));
    if (typeof error === "string") error = Object.assign(Object.assign({}, (0, _error.getError)((0, _constants.SERVER_ERROR))), {
        message: error
    });
    if (typeof data !== "undefined") error.data = data;
    if ((0, _error.isReservedErrorCode)(error.code)) error = (0, _error.getErrorByCode)(error.code);
    return error;
}

},{"./error":"lpnqm","./constants":"dic9X","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"fXfep":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isValidRoute", ()=>isValidRoute);
parcelHelpers.export(exports, "isValidDefaultRoute", ()=>isValidDefaultRoute);
parcelHelpers.export(exports, "isValidWildcardRoute", ()=>isValidWildcardRoute);
parcelHelpers.export(exports, "isValidLeadingWildcardRoute", ()=>isValidLeadingWildcardRoute);
parcelHelpers.export(exports, "isValidTrailingWildcardRoute", ()=>isValidTrailingWildcardRoute);
function isValidRoute(route) {
    if (route.includes("*")) return isValidWildcardRoute(route);
    if (/\W/g.test(route)) return false;
    return true;
}
function isValidDefaultRoute(route) {
    return route === "*";
}
function isValidWildcardRoute(route) {
    if (isValidDefaultRoute(route)) return true;
    if (!route.includes("*")) return false;
    if (route.split("*").length !== 2) return false;
    if (route.split("*").filter((x)=>x.trim() === "").length !== 1) return false;
    return true;
}
function isValidLeadingWildcardRoute(route) {
    return !isValidDefaultRoute(route) && isValidWildcardRoute(route) && !route.split("*")[0].trim();
}
function isValidTrailingWildcardRoute(route) {
    return !isValidDefaultRoute(route) && isValidWildcardRoute(route) && !route.split("*")[1].trim();
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"UuYNN":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsonrpcTypes = require("@walletconnect/jsonrpc-types");
parcelHelpers.exportAll(_jsonrpcTypes, exports);

},{"@walletconnect/jsonrpc-types":"gOSt2","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"gOSt2":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "IBaseJsonRpcProvider", ()=>n);
parcelHelpers.export(exports, "IEvents", ()=>e);
parcelHelpers.export(exports, "IJsonRpcConnection", ()=>o);
parcelHelpers.export(exports, "IJsonRpcProvider", ()=>r);
class e {
}
class o extends e {
    constructor(c){
        super();
    }
}
class n extends e {
    constructor(){
        super();
    }
}
class r extends n {
    constructor(c){
        super();
    }
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"lT9DQ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isHttpUrl", ()=>isHttpUrl);
parcelHelpers.export(exports, "isWsUrl", ()=>isWsUrl);
parcelHelpers.export(exports, "isLocalhostUrl", ()=>isLocalhostUrl);
const HTTP_REGEX = "^https?:";
const WS_REGEX = "^wss?:";
function getUrlProtocol(url) {
    const matches = url.match(new RegExp(/^\w+:/, "gi"));
    if (!matches || !matches.length) return;
    return matches[0];
}
function matchRegexProtocol(url, regex) {
    const protocol = getUrlProtocol(url);
    if (typeof protocol === "undefined") return false;
    return new RegExp(regex).test(protocol);
}
function isHttpUrl(url) {
    return matchRegexProtocol(url, HTTP_REGEX);
}
function isWsUrl(url) {
    return matchRegexProtocol(url, WS_REGEX);
}
function isLocalhostUrl(url) {
    return new RegExp("wss?://localhost(:d{2,5})?").test(url);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"bqcdC":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isJsonRpcPayload", ()=>isJsonRpcPayload);
parcelHelpers.export(exports, "isJsonRpcRequest", ()=>isJsonRpcRequest);
parcelHelpers.export(exports, "isJsonRpcResponse", ()=>isJsonRpcResponse);
parcelHelpers.export(exports, "isJsonRpcResult", ()=>isJsonRpcResult);
parcelHelpers.export(exports, "isJsonRpcError", ()=>isJsonRpcError);
parcelHelpers.export(exports, "isJsonRpcValidationInvalid", ()=>isJsonRpcValidationInvalid);
function isJsonRpcPayload(payload) {
    return typeof payload === "object" && "id" in payload && "jsonrpc" in payload && payload.jsonrpc === "2.0";
}
function isJsonRpcRequest(payload) {
    return isJsonRpcPayload(payload) && "method" in payload;
}
function isJsonRpcResponse(payload) {
    return isJsonRpcPayload(payload) && (isJsonRpcResult(payload) || isJsonRpcError(payload));
}
function isJsonRpcResult(payload) {
    return "result" in payload;
}
function isJsonRpcError(payload) {
    return "error" in payload;
}
function isJsonRpcValidationInvalid(validation) {
    return "error" in validation && validation.valid === false;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"lkbI7":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isEmptyString", ()=>isEmptyString);
parcelHelpers.export(exports, "isEmptyArray", ()=>isEmptyArray);
parcelHelpers.export(exports, "isBuffer", ()=>isBuffer);
parcelHelpers.export(exports, "isTypedArray", ()=>isTypedArray);
parcelHelpers.export(exports, "isArrayBuffer", ()=>isArrayBuffer);
parcelHelpers.export(exports, "getType", ()=>getType);
parcelHelpers.export(exports, "getEncoding", ()=>getEncoding);
parcelHelpers.export(exports, "isHexString", ()=>isHexString);
parcelHelpers.export(exports, "isJsonRpcSubscription", ()=>isJsonRpcSubscription);
parcelHelpers.export(exports, "isJsonRpcRequest", ()=>isJsonRpcRequest);
parcelHelpers.export(exports, "isJsonRpcResponseSuccess", ()=>isJsonRpcResponseSuccess);
parcelHelpers.export(exports, "isJsonRpcResponseError", ()=>isJsonRpcResponseError);
parcelHelpers.export(exports, "isInternalEvent", ()=>isInternalEvent);
parcelHelpers.export(exports, "isReservedEvent", ()=>isReservedEvent);
parcelHelpers.export(exports, "isSilentPayload", ()=>isSilentPayload);
var _encoding = require("@walletconnect/encoding");
var _constants = require("./constants");
function isEmptyString(value) {
    return value === "" || typeof value === "string" && value.trim() === "";
}
function isEmptyArray(array) {
    return !(array && array.length);
}
function isBuffer(val) {
    return _encoding.isBuffer(val);
}
function isTypedArray(val) {
    return _encoding.isTypedArray(val);
}
function isArrayBuffer(val) {
    return _encoding.isArrayBuffer(val);
}
function getType(val) {
    return _encoding.getType(val);
}
function getEncoding(val) {
    return _encoding.getEncoding(val);
}
function isHexString(value, length) {
    return _encoding.isHexString(value, length);
}
function isJsonRpcSubscription(object) {
    return typeof object.params === "object";
}
function isJsonRpcRequest(object) {
    return typeof object.method !== "undefined";
}
function isJsonRpcResponseSuccess(object) {
    return typeof object.result !== "undefined";
}
function isJsonRpcResponseError(object) {
    return typeof object.error !== "undefined";
}
function isInternalEvent(object) {
    return typeof object.event !== "undefined";
}
function isReservedEvent(event) {
    return (0, _constants.reservedEvents).includes(event) || event.startsWith("wc_");
}
function isSilentPayload(request) {
    if (request.method.startsWith("wc_")) return true;
    if ((0, _constants.signingMethods).includes(request.method)) return false;
    return true;
}

},{"@walletconnect/encoding":"hIv0Z","./constants":"dx6md","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"i6C0L":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "promisify", ()=>promisify);
parcelHelpers.export(exports, "formatRpcError", ()=>formatRpcError);
function promisify(originalFn, thisArg) {
    const promisifiedFunction = async (...callArgs)=>{
        return new Promise((resolve, reject)=>{
            const callback = (err, data)=>{
                if (err === null || typeof err === "undefined") reject(err);
                resolve(data);
            };
            originalFn.apply(thisArg, [
                ...callArgs,
                callback
            ]);
        });
    };
    return promisifiedFunction;
}
function formatRpcError(error) {
    const message = error.message || "Failed or Rejected Request";
    let code = -32000;
    if (error && !error.code) switch(message){
        case "Parse error":
            code = -32700;
            break;
        case "Invalid request":
            code = -32600;
            break;
        case "Method not found":
            code = -32601;
            break;
        case "Invalid params":
            code = -32602;
            break;
        case "Internal error":
            code = -32603;
            break;
        default:
            code = -32000;
            break;
    }
    const result = {
        code,
        message
    };
    if (error.data) result.data = error.data;
    return result;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"f7wDl":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isWalletConnectSession", ()=>isWalletConnectSession);
parcelHelpers.export(exports, "parseWalletConnectUri", ()=>parseWalletConnectUri);
var _url = require("./url");
function isWalletConnectSession(object) {
    return typeof object.bridge !== "undefined";
}
function parseWalletConnectUri(str) {
    const pathStart = str.indexOf(":");
    const pathEnd = str.indexOf("?") !== -1 ? str.indexOf("?") : undefined;
    const protocol = str.substring(0, pathStart);
    const path = str.substring(pathStart + 1, pathEnd);
    function parseRequiredParams(path) {
        const separator = "@";
        const values = path.split(separator);
        const requiredParams = {
            handshakeTopic: values[0],
            version: parseInt(values[1], 10)
        };
        return requiredParams;
    }
    const requiredParams = parseRequiredParams(path);
    const queryString = typeof pathEnd !== "undefined" ? str.substr(pathEnd) : "";
    function parseQueryParams(queryString) {
        const result = (0, _url.parseQueryString)(queryString);
        const parameters = {
            key: result.key || "",
            bridge: result.bridge || ""
        };
        return parameters;
    }
    const queryParams = parseQueryParams(queryString);
    const result = Object.assign(Object.assign({
        protocol
    }, requiredParams), queryParams);
    return result;
}

},{"./url":"1cGmR","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"1cGmR":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getQueryString", ()=>getQueryString);
parcelHelpers.export(exports, "appendToQueryString", ()=>appendToQueryString);
parcelHelpers.export(exports, "parseQueryString", ()=>parseQueryString);
parcelHelpers.export(exports, "formatQueryString", ()=>formatQueryString);
var _queryString = require("query-string");
function getQueryString(url) {
    const pathEnd = url.indexOf("?") !== -1 ? url.indexOf("?") : undefined;
    const queryString = typeof pathEnd !== "undefined" ? url.substr(pathEnd) : "";
    return queryString;
}
function appendToQueryString(queryString, newQueryParams) {
    let queryParams = parseQueryString(queryString);
    queryParams = Object.assign(Object.assign({}, queryParams), newQueryParams);
    queryString = formatQueryString(queryParams);
    return queryString;
}
function parseQueryString(queryString) {
    return _queryString.parse(queryString);
}
function formatQueryString(queryParams) {
    return _queryString.stringify(queryParams);
}

},{"query-string":"klvAV","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"klvAV":[function(require,module,exports) {
"use strict";
const strictUriEncode = require("5752d3663915398f");
const decodeComponent = require("4cbbda34882b91a3");
const splitOnFirst = require("53494decacb36d1b");
const isNullOrUndefined = (value)=>value === null || value === undefined;
function encoderForArrayFormat(options) {
    switch(options.arrayFormat){
        case "index":
            return (key)=>(result, value)=>{
                    const index = result.length;
                    if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === "") return result;
                    if (value === null) return [
                        ...result,
                        [
                            encode(key, options),
                            "[",
                            index,
                            "]"
                        ].join("")
                    ];
                    return [
                        ...result,
                        [
                            encode(key, options),
                            "[",
                            encode(index, options),
                            "]=",
                            encode(value, options)
                        ].join("")
                    ];
                };
        case "bracket":
            return (key)=>(result, value)=>{
                    if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === "") return result;
                    if (value === null) return [
                        ...result,
                        [
                            encode(key, options),
                            "[]"
                        ].join("")
                    ];
                    return [
                        ...result,
                        [
                            encode(key, options),
                            "[]=",
                            encode(value, options)
                        ].join("")
                    ];
                };
        case "comma":
        case "separator":
            return (key)=>(result, value)=>{
                    if (value === null || value === undefined || value.length === 0) return result;
                    if (result.length === 0) return [
                        [
                            encode(key, options),
                            "=",
                            encode(value, options)
                        ].join("")
                    ];
                    return [
                        [
                            result,
                            encode(value, options)
                        ].join(options.arrayFormatSeparator)
                    ];
                };
        default:
            return (key)=>(result, value)=>{
                    if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === "") return result;
                    if (value === null) return [
                        ...result,
                        encode(key, options)
                    ];
                    return [
                        ...result,
                        [
                            encode(key, options),
                            "=",
                            encode(value, options)
                        ].join("")
                    ];
                };
    }
}
function parserForArrayFormat(options) {
    let result;
    switch(options.arrayFormat){
        case "index":
            return (key, value, accumulator)=>{
                result = /\[(\d*)\]$/.exec(key);
                key = key.replace(/\[\d*\]$/, "");
                if (!result) {
                    accumulator[key] = value;
                    return;
                }
                if (accumulator[key] === undefined) accumulator[key] = {};
                accumulator[key][result[1]] = value;
            };
        case "bracket":
            return (key, value, accumulator)=>{
                result = /(\[\])$/.exec(key);
                key = key.replace(/\[\]$/, "");
                if (!result) {
                    accumulator[key] = value;
                    return;
                }
                if (accumulator[key] === undefined) {
                    accumulator[key] = [
                        value
                    ];
                    return;
                }
                accumulator[key] = [].concat(accumulator[key], value);
            };
        case "comma":
        case "separator":
            return (key, value, accumulator)=>{
                const isArray = typeof value === "string" && value.split("").indexOf(options.arrayFormatSeparator) > -1;
                const newValue = isArray ? value.split(options.arrayFormatSeparator).map((item)=>decode(item, options)) : value === null ? value : decode(value, options);
                accumulator[key] = newValue;
            };
        default:
            return (key, value, accumulator)=>{
                if (accumulator[key] === undefined) {
                    accumulator[key] = value;
                    return;
                }
                accumulator[key] = [].concat(accumulator[key], value);
            };
    }
}
function validateArrayFormatSeparator(value) {
    if (typeof value !== "string" || value.length !== 1) throw new TypeError("arrayFormatSeparator must be single character string");
}
function encode(value, options) {
    if (options.encode) return options.strict ? strictUriEncode(value) : encodeURIComponent(value);
    return value;
}
function decode(value, options) {
    if (options.decode) return decodeComponent(value);
    return value;
}
function keysSorter(input) {
    if (Array.isArray(input)) return input.sort();
    if (typeof input === "object") return keysSorter(Object.keys(input)).sort((a, b)=>Number(a) - Number(b)).map((key)=>input[key]);
    return input;
}
function removeHash(input) {
    const hashStart = input.indexOf("#");
    if (hashStart !== -1) input = input.slice(0, hashStart);
    return input;
}
function getHash(url) {
    let hash = "";
    const hashStart = url.indexOf("#");
    if (hashStart !== -1) hash = url.slice(hashStart);
    return hash;
}
function extract(input) {
    input = removeHash(input);
    const queryStart = input.indexOf("?");
    if (queryStart === -1) return "";
    return input.slice(queryStart + 1);
}
function parseValue(value, options) {
    if (options.parseNumbers && !Number.isNaN(Number(value)) && typeof value === "string" && value.trim() !== "") value = Number(value);
    else if (options.parseBooleans && value !== null && (value.toLowerCase() === "true" || value.toLowerCase() === "false")) value = value.toLowerCase() === "true";
    return value;
}
function parse(input, options) {
    options = Object.assign({
        decode: true,
        sort: true,
        arrayFormat: "none",
        arrayFormatSeparator: ",",
        parseNumbers: false,
        parseBooleans: false
    }, options);
    validateArrayFormatSeparator(options.arrayFormatSeparator);
    const formatter = parserForArrayFormat(options);
    // Create an object with no prototype
    const ret = Object.create(null);
    if (typeof input !== "string") return ret;
    input = input.trim().replace(/^[?#&]/, "");
    if (!input) return ret;
    for (const param of input.split("&")){
        let [key, value] = splitOnFirst(options.decode ? param.replace(/\+/g, " ") : param, "=");
        // Missing `=` should be `null`:
        // http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
        value = value === undefined ? null : [
            "comma",
            "separator"
        ].includes(options.arrayFormat) ? value : decode(value, options);
        formatter(decode(key, options), value, ret);
    }
    for (const key of Object.keys(ret)){
        const value = ret[key];
        if (typeof value === "object" && value !== null) for (const k of Object.keys(value))value[k] = parseValue(value[k], options);
        else ret[key] = parseValue(value, options);
    }
    if (options.sort === false) return ret;
    return (options.sort === true ? Object.keys(ret).sort() : Object.keys(ret).sort(options.sort)).reduce((result, key)=>{
        const value = ret[key];
        if (Boolean(value) && typeof value === "object" && !Array.isArray(value)) // Sort object keys, not values
        result[key] = keysSorter(value);
        else result[key] = value;
        return result;
    }, Object.create(null));
}
exports.extract = extract;
exports.parse = parse;
exports.stringify = (object, options)=>{
    if (!object) return "";
    options = Object.assign({
        encode: true,
        strict: true,
        arrayFormat: "none",
        arrayFormatSeparator: ","
    }, options);
    validateArrayFormatSeparator(options.arrayFormatSeparator);
    const shouldFilter = (key)=>options.skipNull && isNullOrUndefined(object[key]) || options.skipEmptyString && object[key] === "";
    const formatter = encoderForArrayFormat(options);
    const objectCopy = {};
    for (const key of Object.keys(object))if (!shouldFilter(key)) objectCopy[key] = object[key];
    const keys = Object.keys(objectCopy);
    if (options.sort !== false) keys.sort(options.sort);
    return keys.map((key)=>{
        const value = object[key];
        if (value === undefined) return "";
        if (value === null) return encode(key, options);
        if (Array.isArray(value)) return value.reduce(formatter(key), []).join("&");
        return encode(key, options) + "=" + encode(value, options);
    }).filter((x)=>x.length > 0).join("&");
};
exports.parseUrl = (input, options)=>{
    options = Object.assign({
        decode: true
    }, options);
    const [url, hash] = splitOnFirst(input, "#");
    return Object.assign({
        url: url.split("?")[0] || "",
        query: parse(extract(input), options)
    }, options && options.parseFragmentIdentifier && hash ? {
        fragmentIdentifier: decode(hash, options)
    } : {});
};
exports.stringifyUrl = (input, options)=>{
    options = Object.assign({
        encode: true,
        strict: true
    }, options);
    const url = removeHash(input.url).split("?")[0] || "";
    const queryFromUrl = exports.extract(input.url);
    const parsedQueryFromUrl = exports.parse(queryFromUrl, {
        sort: false
    });
    const query = Object.assign(parsedQueryFromUrl, input.query);
    let queryString = exports.stringify(query, options);
    if (queryString) queryString = `?${queryString}`;
    let hash = getHash(input.url);
    if (input.fragmentIdentifier) hash = `#${encode(input.fragmentIdentifier, options)}`;
    return `${url}${queryString}${hash}`;
};

},{"5752d3663915398f":"kO7zY","4cbbda34882b91a3":"5LMgi","53494decacb36d1b":"fCebu"}],"kO7zY":[function(require,module,exports) {
"use strict";
module.exports = (str)=>encodeURIComponent(str).replace(/[!'()*]/g, (x)=>`%${x.charCodeAt(0).toString(16).toUpperCase()}`);

},{}],"5LMgi":[function(require,module,exports) {
"use strict";
var token = "%[a-f0-9]{2}";
var singleMatcher = new RegExp("(" + token + ")|([^%]+?)", "gi");
var multiMatcher = new RegExp("(" + token + ")+", "gi");
function decodeComponents(components, split) {
    try {
        // Try to decode the entire string first
        return [
            decodeURIComponent(components.join(""))
        ];
    } catch (err) {
    // Do nothing
    }
    if (components.length === 1) return components;
    split = split || 1;
    // Split the array in 2 parts
    var left = components.slice(0, split);
    var right = components.slice(split);
    return Array.prototype.concat.call([], decodeComponents(left), decodeComponents(right));
}
function decode(input) {
    try {
        return decodeURIComponent(input);
    } catch (err) {
        var tokens = input.match(singleMatcher) || [];
        for(var i = 1; i < tokens.length; i++){
            input = decodeComponents(tokens, i).join("");
            tokens = input.match(singleMatcher) || [];
        }
        return input;
    }
}
function customDecodeURIComponent(input) {
    // Keep track of all the replacements and prefill the map with the `BOM`
    var replaceMap = {
        "%FE%FF": "\uFFFD\uFFFD",
        "%FF%FE": "\uFFFD\uFFFD"
    };
    var match = multiMatcher.exec(input);
    while(match){
        try {
            // Decode as big chunks as possible
            replaceMap[match[0]] = decodeURIComponent(match[0]);
        } catch (err) {
            var result = decode(match[0]);
            if (result !== match[0]) replaceMap[match[0]] = result;
        }
        match = multiMatcher.exec(input);
    }
    // Add `%C2` at the end of the map to make sure it does not replace the combinator before everything else
    replaceMap["%C2"] = "\uFFFD";
    var entries = Object.keys(replaceMap);
    for(var i = 0; i < entries.length; i++){
        // Replace all decoded components
        var key = entries[i];
        input = input.replace(new RegExp(key, "g"), replaceMap[key]);
    }
    return input;
}
module.exports = function(encodedURI) {
    if (typeof encodedURI !== "string") throw new TypeError("Expected `encodedURI` to be of type `string`, got `" + typeof encodedURI + "`");
    try {
        encodedURI = encodedURI.replace(/\+/g, " ");
        // Try the built in decoder first
        return decodeURIComponent(encodedURI);
    } catch (err) {
        // Fallback to a more advanced decoder
        return customDecodeURIComponent(encodedURI);
    }
};

},{}],"fCebu":[function(require,module,exports) {
"use strict";
module.exports = (string, separator)=>{
    if (!(typeof string === "string" && typeof separator === "string")) throw new TypeError("Expected the arguments to be of type `string`");
    if (separator === "") return [
        string
    ];
    const separatorIndex = string.indexOf(separator);
    if (separatorIndex === -1) return [
        string
    ];
    return [
        string.slice(0, separatorIndex),
        string.slice(separatorIndex + separator.length)
    ];
};

},{}],"gJV9X":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _utils = require("@walletconnect/utils");
var _network = require("./network");
var _networkDefault = parcelHelpers.interopDefault(_network);
var global = arguments[3];
const WS = typeof global.WebSocket !== "undefined" ? global.WebSocket : require("e984abbfe49d252d");
class SocketTransport {
    constructor(opts){
        this.opts = opts;
        this._queue = [];
        this._events = [];
        this._subscriptions = [];
        this._protocol = opts.protocol;
        this._version = opts.version;
        this._url = "";
        this._netMonitor = null;
        this._socket = null;
        this._nextSocket = null;
        this._subscriptions = opts.subscriptions || [];
        this._netMonitor = opts.netMonitor || new (0, _networkDefault.default)();
        if (!opts.url || typeof opts.url !== "string") throw new Error("Missing or invalid WebSocket url");
        this._url = opts.url;
        this._netMonitor.on("online", ()=>this._socketCreate());
    }
    set readyState(value) {}
    get readyState() {
        return this._socket ? this._socket.readyState : -1;
    }
    set connecting(value) {}
    get connecting() {
        return this.readyState === 0;
    }
    set connected(value) {}
    get connected() {
        return this.readyState === 1;
    }
    set closing(value) {}
    get closing() {
        return this.readyState === 2;
    }
    set closed(value) {}
    get closed() {
        return this.readyState === 3;
    }
    open() {
        this._socketCreate();
    }
    close() {
        this._socketClose();
    }
    send(message, topic, silent) {
        if (!topic || typeof topic !== "string") throw new Error("Missing or invalid topic field");
        this._socketSend({
            topic: topic,
            type: "pub",
            payload: message,
            silent: !!silent
        });
    }
    subscribe(topic) {
        this._socketSend({
            topic: topic,
            type: "sub",
            payload: "",
            silent: true
        });
    }
    on(event, callback) {
        this._events.push({
            event,
            callback
        });
    }
    _socketCreate() {
        if (this._nextSocket) return;
        const url = getWebSocketUrl(this._url, this._protocol, this._version);
        this._nextSocket = new WS(url);
        if (!this._nextSocket) throw new Error("Failed to create socket");
        this._nextSocket.onmessage = (event)=>this._socketReceive(event);
        this._nextSocket.onopen = ()=>this._socketOpen();
        this._nextSocket.onerror = (event)=>this._socketError(event);
        this._nextSocket.onclose = ()=>{
            setTimeout(()=>{
                this._nextSocket = null;
                this._socketCreate();
            }, 1000);
        };
    }
    _socketOpen() {
        this._socketClose();
        this._socket = this._nextSocket;
        this._nextSocket = null;
        this._queueSubscriptions();
        this._pushQueue();
    }
    _socketClose() {
        if (this._socket) {
            this._socket.onclose = ()=>{};
            this._socket.close();
        }
    }
    _socketSend(socketMessage) {
        const message = JSON.stringify(socketMessage);
        if (this._socket && this._socket.readyState === 1) this._socket.send(message);
        else {
            this._setToQueue(socketMessage);
            this._socketCreate();
        }
    }
    async _socketReceive(event) {
        let socketMessage;
        try {
            socketMessage = JSON.parse(event.data);
        } catch (error) {
            return;
        }
        this._socketSend({
            topic: socketMessage.topic,
            type: "ack",
            payload: "",
            silent: true
        });
        if (this._socket && this._socket.readyState === 1) {
            const events = this._events.filter((event)=>event.event === "message");
            if (events && events.length) events.forEach((event)=>event.callback(socketMessage));
        }
    }
    _socketError(e) {
        const events = this._events.filter((event)=>event.event === "error");
        if (events && events.length) events.forEach((event)=>event.callback(e));
    }
    _queueSubscriptions() {
        const subscriptions = this._subscriptions;
        subscriptions.forEach((topic)=>this._queue.push({
                topic: topic,
                type: "sub",
                payload: "",
                silent: true
            }));
        this._subscriptions = this.opts.subscriptions || [];
    }
    _setToQueue(socketMessage) {
        this._queue.push(socketMessage);
    }
    _pushQueue() {
        const queue = this._queue;
        queue.forEach((socketMessage)=>this._socketSend(socketMessage));
        this._queue = [];
    }
}
function getWebSocketUrl(_url, protocol, version) {
    var _a, _b;
    const url = _url.startsWith("https") ? _url.replace("https", "wss") : _url.startsWith("http") ? _url.replace("http", "ws") : _url;
    const splitUrl = url.split("?");
    const params = (0, _utils.isBrowser)() ? {
        protocol,
        version,
        env: "browser",
        host: ((_a = (0, _utils.getLocation)()) === null || _a === void 0 ? void 0 : _a.host) || ""
    } : {
        protocol,
        version,
        env: ((_b = (0, _utils.detectEnv)()) === null || _b === void 0 ? void 0 : _b.name) || ""
    };
    const queryString = (0, _utils.appendToQueryString)((0, _utils.getQueryString)(splitUrl[1] || ""), params);
    return splitUrl[0] + "?" + queryString;
}
exports.default = SocketTransport;

},{"@walletconnect/utils":"bFQqa","./network":"bNnFG","e984abbfe49d252d":"26vSj","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"bNnFG":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
class NetworkMonitor {
    constructor(){
        this._eventEmitters = [];
        if (typeof window !== "undefined" && typeof window.addEventListener !== "undefined") {
            window.addEventListener("online", ()=>this.trigger("online"));
            window.addEventListener("offline", ()=>this.trigger("offline"));
        }
    }
    on(event, callback) {
        this._eventEmitters.push({
            event,
            callback
        });
    }
    trigger(event) {
        let eventEmitters = [];
        if (event) eventEmitters = this._eventEmitters.filter((eventEmitter)=>eventEmitter.event === event);
        eventEmitters.forEach((eventEmitter)=>{
            eventEmitter.callback();
        });
    }
}
exports.default = NetworkMonitor;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"26vSj":[function(require,module,exports) {
"use strict";
module.exports = function() {
    throw new Error("ws does not work in the browser. Browser clients must use the native WebSocket object");
};

},{}],"4WfNb":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ERROR_SESSION_CONNECTED", ()=>ERROR_SESSION_CONNECTED);
parcelHelpers.export(exports, "ERROR_SESSION_DISCONNECTED", ()=>ERROR_SESSION_DISCONNECTED);
parcelHelpers.export(exports, "ERROR_SESSION_REJECTED", ()=>ERROR_SESSION_REJECTED);
parcelHelpers.export(exports, "ERROR_MISSING_JSON_RPC", ()=>ERROR_MISSING_JSON_RPC);
parcelHelpers.export(exports, "ERROR_MISSING_RESULT", ()=>ERROR_MISSING_RESULT);
parcelHelpers.export(exports, "ERROR_MISSING_ERROR", ()=>ERROR_MISSING_ERROR);
parcelHelpers.export(exports, "ERROR_MISSING_METHOD", ()=>ERROR_MISSING_METHOD);
parcelHelpers.export(exports, "ERROR_MISSING_ID", ()=>ERROR_MISSING_ID);
parcelHelpers.export(exports, "ERROR_MISSING_REQUIRED", ()=>ERROR_MISSING_REQUIRED);
parcelHelpers.export(exports, "ERROR_INVALID_RESPONSE", ()=>ERROR_INVALID_RESPONSE);
parcelHelpers.export(exports, "ERROR_INVALID_URI", ()=>ERROR_INVALID_URI);
parcelHelpers.export(exports, "ERROR_QRCODE_MODAL_NOT_PROVIDED", ()=>ERROR_QRCODE_MODAL_NOT_PROVIDED);
parcelHelpers.export(exports, "ERROR_QRCODE_MODAL_USER_CLOSED", ()=>ERROR_QRCODE_MODAL_USER_CLOSED);
const ERROR_SESSION_CONNECTED = "Session currently connected";
const ERROR_SESSION_DISCONNECTED = "Session currently disconnected";
const ERROR_SESSION_REJECTED = "Session Rejected";
const ERROR_MISSING_JSON_RPC = "Missing JSON RPC response";
const ERROR_MISSING_RESULT = `JSON-RPC success response must include "result" field`;
const ERROR_MISSING_ERROR = `JSON-RPC error response must include "error" field`;
const ERROR_MISSING_METHOD = `JSON RPC request must have valid "method" value`;
const ERROR_MISSING_ID = `JSON RPC request must have valid "id" value`;
const ERROR_MISSING_REQUIRED = "Missing one of the required parameters: bridge / uri / session";
const ERROR_INVALID_RESPONSE = "JSON RPC response format is invalid";
const ERROR_INVALID_URI = "URI format is invalid";
const ERROR_QRCODE_MODAL_NOT_PROVIDED = "QRCode Modal not provided";
const ERROR_QRCODE_MODAL_USER_CLOSED = "User close QRCode Modal";

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"j47yZ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _utils = require("@walletconnect/utils");
class EventManager {
    constructor(){
        this._eventEmitters = [];
    }
    subscribe(eventEmitter) {
        this._eventEmitters.push(eventEmitter);
    }
    unsubscribe(event) {
        this._eventEmitters = this._eventEmitters.filter((x)=>x.event !== event);
    }
    trigger(payload) {
        let eventEmitters = [];
        let event;
        if ((0, _utils.isJsonRpcRequest)(payload)) event = payload.method;
        else if ((0, _utils.isJsonRpcResponseSuccess)(payload) || (0, _utils.isJsonRpcResponseError)(payload)) event = `response:${payload.id}`;
        else if ((0, _utils.isInternalEvent)(payload)) event = payload.event;
        else event = "";
        if (event) eventEmitters = this._eventEmitters.filter((eventEmitter)=>eventEmitter.event === event);
        if ((!eventEmitters || !eventEmitters.length) && !(0, _utils.isReservedEvent)(event) && !(0, _utils.isInternalEvent)(event)) eventEmitters = this._eventEmitters.filter((eventEmitter)=>eventEmitter.event === "call_request");
        eventEmitters.forEach((eventEmitter)=>{
            if ((0, _utils.isJsonRpcResponseError)(payload)) {
                const error = new Error(payload.error.message);
                eventEmitter.callback(error, null);
            } else eventEmitter.callback(null, payload);
        });
    }
}
exports.default = EventManager;

},{"@walletconnect/utils":"bFQqa","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"lpAt8":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _utils = require("@walletconnect/utils");
class SessionStorage {
    constructor(storageId = "walletconnect"){
        this.storageId = storageId;
    }
    getSession() {
        let session = null;
        const json = (0, _utils.getLocal)(this.storageId);
        if (json && (0, _utils.isWalletConnectSession)(json)) session = json;
        return session;
    }
    setSession(session) {
        (0, _utils.setLocal)(this.storageId, session);
        return session;
    }
    removeSession() {
        (0, _utils.removeLocal)(this.storageId);
    }
}
exports.default = SessionStorage;

},{"@walletconnect/utils":"bFQqa","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"k2XH2":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "extractHostname", ()=>extractHostname);
parcelHelpers.export(exports, "extractRootDomain", ()=>extractRootDomain);
parcelHelpers.export(exports, "randomBridgeIndex", ()=>randomBridgeIndex);
parcelHelpers.export(exports, "selectRandomBridgeUrl", ()=>selectRandomBridgeUrl);
parcelHelpers.export(exports, "shouldSelectRandomly", ()=>shouldSelectRandomly);
parcelHelpers.export(exports, "getBridgeUrl", ()=>getBridgeUrl);
const domain = "walletconnect.org";
const alphanumerical = "abcdefghijklmnopqrstuvwxyz0123456789";
const bridges = alphanumerical.split("").map((char)=>`https://${char}.bridge.walletconnect.org`);
function extractHostname(url) {
    let hostname = url.indexOf("//") > -1 ? url.split("/")[2] : url.split("/")[0];
    hostname = hostname.split(":")[0];
    hostname = hostname.split("?")[0];
    return hostname;
}
function extractRootDomain(url) {
    return extractHostname(url).split(".").slice(-2).join(".");
}
function randomBridgeIndex() {
    return Math.floor(Math.random() * bridges.length);
}
function selectRandomBridgeUrl() {
    return bridges[randomBridgeIndex()];
}
function shouldSelectRandomly(url) {
    return extractRootDomain(url) === domain;
}
function getBridgeUrl(url) {
    if (shouldSelectRandomly(url)) return selectRandomBridgeUrl();
    return url;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2pBwP":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "generateKey", ()=>generateKey);
parcelHelpers.export(exports, "verifyHmac", ()=>verifyHmac);
parcelHelpers.export(exports, "encrypt", ()=>encrypt);
parcelHelpers.export(exports, "decrypt", ()=>decrypt);
var _crypto = require("@walletconnect/crypto");
var _encoding = require("@walletconnect/encoding");
var _utils = require("@walletconnect/utils");
async function generateKey(length) {
    const _length = (length || 256) / 8;
    const bytes = _crypto.randomBytes(_length);
    const result = (0, _utils.convertBufferToArrayBuffer)(_encoding.arrayToBuffer(bytes));
    return result;
}
async function verifyHmac(payload, key) {
    const cipherText = _encoding.hexToArray(payload.data);
    const iv = _encoding.hexToArray(payload.iv);
    const hmac = _encoding.hexToArray(payload.hmac);
    const hmacHex = _encoding.arrayToHex(hmac, false);
    const unsigned = _encoding.concatArrays(cipherText, iv);
    const chmac = await _crypto.hmacSha256Sign(key, unsigned);
    const chmacHex = _encoding.arrayToHex(chmac, false);
    if (_encoding.removeHexPrefix(hmacHex) === _encoding.removeHexPrefix(chmacHex)) return true;
    return false;
}
async function encrypt(data, key, providedIv) {
    const _key = _encoding.bufferToArray((0, _utils.convertArrayBufferToBuffer)(key));
    const ivArrayBuffer = providedIv || await generateKey(128);
    const iv = _encoding.bufferToArray((0, _utils.convertArrayBufferToBuffer)(ivArrayBuffer));
    const ivHex = _encoding.arrayToHex(iv, false);
    const contentString = JSON.stringify(data);
    const content = _encoding.utf8ToArray(contentString);
    const cipherText = await _crypto.aesCbcEncrypt(iv, _key, content);
    const cipherTextHex = _encoding.arrayToHex(cipherText, false);
    const unsigned = _encoding.concatArrays(cipherText, iv);
    const hmac = await _crypto.hmacSha256Sign(_key, unsigned);
    const hmacHex = _encoding.arrayToHex(hmac, false);
    return {
        data: cipherTextHex,
        hmac: hmacHex,
        iv: ivHex
    };
}
async function decrypt(payload, key) {
    const _key = _encoding.bufferToArray((0, _utils.convertArrayBufferToBuffer)(key));
    if (!_key) throw new Error("Missing key: required for decryption");
    const verified = await verifyHmac(payload, _key);
    if (!verified) return null;
    const cipherText = _encoding.hexToArray(payload.data);
    const iv = _encoding.hexToArray(payload.iv);
    const buffer = await _crypto.aesCbcDecrypt(iv, _key, cipherText);
    const utf8 = _encoding.arrayToUtf8(buffer);
    let data;
    try {
        data = JSON.parse(utf8);
    } catch (error) {
        return null;
    }
    return data;
}

},{"@walletconnect/crypto":"lqwVi","@walletconnect/encoding":"hIv0Z","@walletconnect/utils":"bFQqa","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"lqwVi":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _randombytes = require("@walletconnect/randombytes");
parcelHelpers.exportAll(_randombytes, exports);
var _aes = require("./aes");
parcelHelpers.exportAll(_aes, exports);
var _hmac = require("./hmac");
parcelHelpers.exportAll(_hmac, exports);
var _sha2 = require("./sha2");
parcelHelpers.exportAll(_sha2, exports);
var _helpers = require("../helpers");
parcelHelpers.exportAll(_helpers, exports);
var _constants = require("../constants");
parcelHelpers.exportAll(_constants, exports);

},{"@walletconnect/randombytes":"3XMds","./aes":"e0ecp","./hmac":"8Pt3b","./sha2":"71NKK","../helpers":"3yn5C","../constants":"lPzSJ","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"3XMds":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "randomBytes", ()=>randomBytes);
var _environment = require("@walletconnect/environment");
function randomBytes(length) {
    const browserCrypto = _environment.getBrowerCrypto();
    return browserCrypto.getRandomValues(new Uint8Array(length));
}

},{"@walletconnect/environment":"ljiRg","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"e0ecp":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "aesCbcEncrypt", ()=>aesCbcEncrypt);
parcelHelpers.export(exports, "aesCbcDecrypt", ()=>aesCbcDecrypt);
var _browser = require("../lib/browser");
function aesCbcEncrypt(iv, key, data) {
    return (0, _browser.browserAesEncrypt)(iv, key, data);
}
function aesCbcDecrypt(iv, key, data) {
    return (0, _browser.browserAesDecrypt)(iv, key, data);
}

},{"../lib/browser":"hfrPc","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"hfrPc":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getAlgo", ()=>getAlgo);
parcelHelpers.export(exports, "getOps", ()=>getOps);
parcelHelpers.export(exports, "browserExportKey", ()=>browserExportKey);
parcelHelpers.export(exports, "browserImportKey", ()=>browserImportKey);
parcelHelpers.export(exports, "browserAesEncrypt", ()=>browserAesEncrypt);
parcelHelpers.export(exports, "browserAesDecrypt", ()=>browserAesDecrypt);
parcelHelpers.export(exports, "browserHmacSha256Sign", ()=>browserHmacSha256Sign);
parcelHelpers.export(exports, "browserHmacSha512Sign", ()=>browserHmacSha512Sign);
parcelHelpers.export(exports, "browserSha256", ()=>browserSha256);
parcelHelpers.export(exports, "browserSha512", ()=>browserSha512);
var _environment = require("@walletconnect/environment");
var _constants = require("../constants");
function getAlgo(type) {
    return type === (0, _constants.AES_BROWSER_ALGO) ? {
        length: (0, _constants.AES_LENGTH),
        name: (0, _constants.AES_BROWSER_ALGO)
    } : {
        hash: {
            name: (0, _constants.HMAC_BROWSER_ALGO)
        },
        name: (0, _constants.HMAC_BROWSER)
    };
}
function getOps(type) {
    return type === (0, _constants.AES_BROWSER_ALGO) ? [
        (0, _constants.ENCRYPT_OP),
        (0, _constants.DECRYPT_OP)
    ] : [
        (0, _constants.SIGN_OP),
        (0, _constants.VERIFY_OP)
    ];
}
async function browserExportKey(cryptoKey, type = (0, _constants.AES_BROWSER_ALGO)) {
    const subtle = _environment.getSubtleCrypto();
    return new Uint8Array(await subtle.exportKey("raw", cryptoKey));
}
async function browserImportKey(buffer, type = (0, _constants.AES_BROWSER_ALGO)) {
    return _environment.getSubtleCrypto().importKey("raw", buffer, getAlgo(type), true, getOps(type));
}
async function browserAesEncrypt(iv, key, data) {
    const subtle = _environment.getSubtleCrypto();
    const cryptoKey = await browserImportKey(key, (0, _constants.AES_BROWSER_ALGO));
    const result = await subtle.encrypt({
        iv,
        name: (0, _constants.AES_BROWSER_ALGO)
    }, cryptoKey, data);
    return new Uint8Array(result);
}
async function browserAesDecrypt(iv, key, data) {
    const subtle = _environment.getSubtleCrypto();
    const cryptoKey = await browserImportKey(key, (0, _constants.AES_BROWSER_ALGO));
    const result = await subtle.decrypt({
        iv,
        name: (0, _constants.AES_BROWSER_ALGO)
    }, cryptoKey, data);
    return new Uint8Array(result);
}
async function browserHmacSha256Sign(key, data) {
    const subtle = _environment.getSubtleCrypto();
    const cryptoKey = await browserImportKey(key, (0, _constants.HMAC_BROWSER));
    const signature = await subtle.sign({
        length: (0, _constants.HMAC_LENGTH),
        name: (0, _constants.HMAC_BROWSER)
    }, cryptoKey, data);
    return new Uint8Array(signature);
}
async function browserHmacSha512Sign(key, data) {
    const subtle = _environment.getSubtleCrypto();
    const cryptoKey = await browserImportKey(key, (0, _constants.HMAC_BROWSER));
    const signature = await subtle.sign({
        length: (0, _constants.LENGTH_512),
        name: (0, _constants.HMAC_BROWSER)
    }, cryptoKey, data);
    return new Uint8Array(signature);
}
async function browserSha256(data) {
    const subtle = _environment.getSubtleCrypto();
    const result = await subtle.digest({
        name: (0, _constants.SHA256_BROWSER_ALGO)
    }, data);
    return new Uint8Array(result);
}
async function browserSha512(data) {
    const subtle = _environment.getSubtleCrypto();
    const result = await subtle.digest({
        name: (0, _constants.SHA512_BROWSER_ALGO)
    }, data);
    return new Uint8Array(result);
}

},{"@walletconnect/environment":"ljiRg","../constants":"lPzSJ","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"lPzSJ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _default = require("./default");
parcelHelpers.exportAll(_default, exports);
var _encoding = require("./encoding");
parcelHelpers.exportAll(_encoding, exports);
var _error = require("./error");
parcelHelpers.exportAll(_error, exports);
var _length = require("./length");
parcelHelpers.exportAll(_length, exports);
var _operations = require("./operations");
parcelHelpers.exportAll(_operations, exports);

},{"./default":"33Kaw","./encoding":"8ZKPZ","./error":"l4I2w","./length":"dJGKm","./operations":"8PVdx","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"33Kaw":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AES_LENGTH", ()=>AES_LENGTH);
parcelHelpers.export(exports, "HMAC_LENGTH", ()=>HMAC_LENGTH);
parcelHelpers.export(exports, "AES_BROWSER_ALGO", ()=>AES_BROWSER_ALGO);
parcelHelpers.export(exports, "HMAC_BROWSER_ALGO", ()=>HMAC_BROWSER_ALGO);
parcelHelpers.export(exports, "HMAC_BROWSER", ()=>HMAC_BROWSER);
parcelHelpers.export(exports, "SHA256_BROWSER_ALGO", ()=>SHA256_BROWSER_ALGO);
parcelHelpers.export(exports, "SHA512_BROWSER_ALGO", ()=>SHA512_BROWSER_ALGO);
parcelHelpers.export(exports, "AES_NODE_ALGO", ()=>AES_NODE_ALGO);
parcelHelpers.export(exports, "HMAC_NODE_ALGO", ()=>HMAC_NODE_ALGO);
parcelHelpers.export(exports, "SHA256_NODE_ALGO", ()=>SHA256_NODE_ALGO);
parcelHelpers.export(exports, "SHA512_NODE_ALGO", ()=>SHA512_NODE_ALGO);
parcelHelpers.export(exports, "RIPEMD160_NODE_ALGO", ()=>RIPEMD160_NODE_ALGO);
parcelHelpers.export(exports, "PREFIX_LENGTH", ()=>PREFIX_LENGTH);
parcelHelpers.export(exports, "KEY_LENGTH", ()=>KEY_LENGTH);
parcelHelpers.export(exports, "IV_LENGTH", ()=>IV_LENGTH);
parcelHelpers.export(exports, "MAC_LENGTH", ()=>MAC_LENGTH);
var _length = require("./length");
const AES_LENGTH = (0, _length.LENGTH_256);
const HMAC_LENGTH = (0, _length.LENGTH_256);
const AES_BROWSER_ALGO = "AES-CBC";
const HMAC_BROWSER_ALGO = `SHA-${AES_LENGTH}`;
const HMAC_BROWSER = "HMAC";
const SHA256_BROWSER_ALGO = "SHA-256";
const SHA512_BROWSER_ALGO = "SHA-512";
const AES_NODE_ALGO = `aes-${AES_LENGTH}-cbc`;
const HMAC_NODE_ALGO = `sha${HMAC_LENGTH}`;
const SHA256_NODE_ALGO = "sha256";
const SHA512_NODE_ALGO = "sha512";
const RIPEMD160_NODE_ALGO = "ripemd160";
const PREFIX_LENGTH = (0, _length.LENGTH_1);
const KEY_LENGTH = (0, _length.LENGTH_32);
const IV_LENGTH = (0, _length.LENGTH_16);
const MAC_LENGTH = (0, _length.LENGTH_32);

},{"./length":"dJGKm","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"dJGKm":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LENGTH_0", ()=>LENGTH_0);
parcelHelpers.export(exports, "LENGTH_1", ()=>LENGTH_1);
parcelHelpers.export(exports, "LENGTH_16", ()=>LENGTH_16);
parcelHelpers.export(exports, "LENGTH_32", ()=>LENGTH_32);
parcelHelpers.export(exports, "LENGTH_64", ()=>LENGTH_64);
parcelHelpers.export(exports, "LENGTH_128", ()=>LENGTH_128);
parcelHelpers.export(exports, "LENGTH_256", ()=>LENGTH_256);
parcelHelpers.export(exports, "LENGTH_512", ()=>LENGTH_512);
parcelHelpers.export(exports, "LENGTH_1024", ()=>LENGTH_1024);
const LENGTH_0 = 0;
const LENGTH_1 = 1;
const LENGTH_16 = 16;
const LENGTH_32 = 32;
const LENGTH_64 = 64;
const LENGTH_128 = 128;
const LENGTH_256 = 256;
const LENGTH_512 = 512;
const LENGTH_1024 = 1024;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8ZKPZ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "HEX_ENC", ()=>HEX_ENC);
parcelHelpers.export(exports, "UTF8_ENC", ()=>UTF8_ENC);
const HEX_ENC = "hex";
const UTF8_ENC = "utf8";

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"l4I2w":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ERROR_BAD_MAC", ()=>ERROR_BAD_MAC);
const ERROR_BAD_MAC = "Bad MAC";

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8PVdx":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ENCRYPT_OP", ()=>ENCRYPT_OP);
parcelHelpers.export(exports, "DECRYPT_OP", ()=>DECRYPT_OP);
parcelHelpers.export(exports, "SIGN_OP", ()=>SIGN_OP);
parcelHelpers.export(exports, "VERIFY_OP", ()=>VERIFY_OP);
const ENCRYPT_OP = "encrypt";
const DECRYPT_OP = "decrypt";
const SIGN_OP = "sign";
const VERIFY_OP = "verify";

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8Pt3b":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "hmacSha256Sign", ()=>hmacSha256Sign);
parcelHelpers.export(exports, "hmacSha256Verify", ()=>hmacSha256Verify);
parcelHelpers.export(exports, "hmacSha512Sign", ()=>hmacSha512Sign);
parcelHelpers.export(exports, "hmacSha512Verify", ()=>hmacSha512Verify);
var _browser = require("../lib/browser");
var _helpers = require("../helpers");
async function hmacSha256Sign(key, msg) {
    const result = await (0, _browser.browserHmacSha256Sign)(key, msg);
    return result;
}
async function hmacSha256Verify(key, msg, sig) {
    const expectedSig = await (0, _browser.browserHmacSha256Sign)(key, msg);
    const result = (0, _helpers.isConstantTime)(expectedSig, sig);
    return result;
}
async function hmacSha512Sign(key, msg) {
    const result = await (0, _browser.browserHmacSha512Sign)(key, msg);
    return result;
}
async function hmacSha512Verify(key, msg, sig) {
    const expectedSig = await (0, _browser.browserHmacSha512Sign)(key, msg);
    const result = (0, _helpers.isConstantTime)(expectedSig, sig);
    return result;
}

},{"../lib/browser":"hfrPc","../helpers":"3yn5C","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"3yn5C":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _env = require("./env");
parcelHelpers.exportAll(_env, exports);
var _pkcs7 = require("./pkcs7");
parcelHelpers.exportAll(_pkcs7, exports);
var _types = require("./types");
parcelHelpers.exportAll(_types, exports);
var _validators = require("./validators");
parcelHelpers.exportAll(_validators, exports);

},{"./env":"gre6M","./pkcs7":"c46It","./types":"7UEWa","./validators":"kTOfb","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"gre6M":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _environment = require("@walletconnect/environment");
parcelHelpers.exportAll(_environment, exports);

},{"@walletconnect/environment":"ljiRg","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"c46It":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "pkcs7", ()=>pkcs7);
const PADDING = [
    [
        16,
        16,
        16,
        16,
        16,
        16,
        16,
        16,
        16,
        16,
        16,
        16,
        16,
        16,
        16,
        16
    ],
    [
        15,
        15,
        15,
        15,
        15,
        15,
        15,
        15,
        15,
        15,
        15,
        15,
        15,
        15,
        15
    ],
    [
        14,
        14,
        14,
        14,
        14,
        14,
        14,
        14,
        14,
        14,
        14,
        14,
        14,
        14
    ],
    [
        13,
        13,
        13,
        13,
        13,
        13,
        13,
        13,
        13,
        13,
        13,
        13,
        13
    ],
    [
        12,
        12,
        12,
        12,
        12,
        12,
        12,
        12,
        12,
        12,
        12,
        12
    ],
    [
        11,
        11,
        11,
        11,
        11,
        11,
        11,
        11,
        11,
        11,
        11
    ],
    [
        10,
        10,
        10,
        10,
        10,
        10,
        10,
        10,
        10,
        10
    ],
    [
        9,
        9,
        9,
        9,
        9,
        9,
        9,
        9,
        9
    ],
    [
        8,
        8,
        8,
        8,
        8,
        8,
        8,
        8
    ],
    [
        7,
        7,
        7,
        7,
        7,
        7,
        7
    ],
    [
        6,
        6,
        6,
        6,
        6,
        6
    ],
    [
        5,
        5,
        5,
        5,
        5
    ],
    [
        4,
        4,
        4,
        4
    ],
    [
        3,
        3,
        3
    ],
    [
        2,
        2
    ],
    [
        1
    ]
];
const pkcs7 = {
    pad (plaintext) {
        const padding = PADDING[plaintext.byteLength % 16 || 0];
        const result = new Uint8Array(plaintext.byteLength + padding.length);
        result.set(plaintext);
        result.set(padding, plaintext.byteLength);
        return result;
    },
    unpad (padded) {
        return padded.subarray(0, padded.byteLength - padded[padded.byteLength - 1]);
    }
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7UEWa":[function(require,module,exports) {

},{}],"kTOfb":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "assert", ()=>assert);
parcelHelpers.export(exports, "isConstantTime", ()=>isConstantTime);
function assert(condition, message) {
    if (!condition) throw new Error(message || "Assertion failed");
}
function isConstantTime(arr1, arr2) {
    if (arr1.length !== arr2.length) return false;
    let res = 0;
    for(let i = 0; i < arr1.length; i++)res |= arr1[i] ^ arr2[i];
    return res === 0;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"71NKK":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "sha256", ()=>sha256);
parcelHelpers.export(exports, "sha512", ()=>sha512);
parcelHelpers.export(exports, "ripemd160", ()=>ripemd160);
var _browser = require("../lib/browser");
async function sha256(msg) {
    const result = await (0, _browser.browserSha256)(msg);
    return result;
}
async function sha512(msg) {
    const result = await (0, _browser.browserSha512)(msg);
    return result;
}
async function ripemd160(msg) {
    throw new Error("Not supported for Browser async methods, use sync instead!");
}

},{"../lib/browser":"hfrPc","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"Wz2Iq":[function(require,module,exports) {
var process = require("b4374c35fea42e9e");
function _interopDefault(ex) {
    return ex && typeof ex === "object" && "default" in ex ? ex["default"] : ex;
}
var browserUtils = require("1d1bf013c1507dad");
var QRCode = _interopDefault(require("512c6fb1e5cc3a43"));
var copy = _interopDefault(require("7579aa92c82de8c4"));
var React = require("edb24cc120086e21");
function open(uri) {
    QRCode.toString(uri, {
        type: "terminal"
    }).then(console.log);
}
var WALLETCONNECT_STYLE_SHEET = ':root {\n  --animation-duration: 300ms;\n}\n\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n\n@keyframes fadeOut {\n  from {\n    opacity: 1;\n  }\n  to {\n    opacity: 0;\n  }\n}\n\n.animated {\n  animation-duration: var(--animation-duration);\n  animation-fill-mode: both;\n}\n\n.fadeIn {\n  animation-name: fadeIn;\n}\n\n.fadeOut {\n  animation-name: fadeOut;\n}\n\n#walletconnect-wrapper {\n  -webkit-user-select: none;\n  align-items: center;\n  display: flex;\n  height: 100%;\n  justify-content: center;\n  left: 0;\n  pointer-events: none;\n  position: fixed;\n  top: 0;\n  user-select: none;\n  width: 100%;\n  z-index: 99999999999999;\n}\n\n.walletconnect-modal__headerLogo {\n  height: 21px;\n}\n\n.walletconnect-modal__header p {\n  color: #ffffff;\n  font-size: 20px;\n  font-weight: 600;\n  margin: 0;\n  align-items: flex-start;\n  display: flex;\n  flex: 1;\n  margin-left: 5px;\n}\n\n.walletconnect-modal__close__wrapper {\n  position: absolute;\n  top: 0px;\n  right: 0px;\n  z-index: 10000;\n  background: white;\n  border-radius: 26px;\n  padding: 6px;\n  box-sizing: border-box;\n  width: 26px;\n  height: 26px;\n  cursor: pointer;\n}\n\n.walletconnect-modal__close__icon {\n  position: relative;\n  top: 7px;\n  right: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transform: rotate(45deg);\n}\n\n.walletconnect-modal__close__line1 {\n  position: absolute;\n  width: 100%;\n  border: 1px solid rgb(48, 52, 59);\n}\n\n.walletconnect-modal__close__line2 {\n  position: absolute;\n  width: 100%;\n  border: 1px solid rgb(48, 52, 59);\n  transform: rotate(90deg);\n}\n\n.walletconnect-qrcode__base {\n  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n  background: rgba(37, 41, 46, 0.95);\n  height: 100%;\n  left: 0;\n  pointer-events: auto;\n  position: fixed;\n  top: 0;\n  transition: 0.4s cubic-bezier(0.19, 1, 0.22, 1);\n  width: 100%;\n  will-change: opacity;\n  padding: 40px;\n  box-sizing: border-box;\n}\n\n.walletconnect-qrcode__text {\n  color: rgba(60, 66, 82, 0.6);\n  font-size: 16px;\n  font-weight: 600;\n  letter-spacing: 0;\n  line-height: 1.1875em;\n  margin: 10px 0 20px 0;\n  text-align: center;\n  width: 100%;\n}\n\n@media only screen and (max-width: 768px) {\n  .walletconnect-qrcode__text {\n    font-size: 4vw;\n  }\n}\n\n@media only screen and (max-width: 320px) {\n  .walletconnect-qrcode__text {\n    font-size: 14px;\n  }\n}\n\n.walletconnect-qrcode__image {\n  width: calc(100% - 30px);\n  box-sizing: border-box;\n  cursor: none;\n  margin: 0 auto;\n}\n\n.walletconnect-qrcode__notification {\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  font-size: 16px;\n  padding: 16px 20px;\n  border-radius: 16px;\n  text-align: center;\n  transition: all 0.1s ease-in-out;\n  background: white;\n  color: black;\n  margin-bottom: -60px;\n  opacity: 0;\n}\n\n.walletconnect-qrcode__notification.notification__show {\n  opacity: 1;\n}\n\n@media only screen and (max-width: 768px) {\n  .walletconnect-modal__header {\n    height: 130px;\n  }\n  .walletconnect-modal__base {\n    overflow: auto;\n  }\n}\n\n@media only screen and (min-device-width: 415px) and (max-width: 768px) {\n  #content {\n    max-width: 768px;\n    box-sizing: border-box;\n  }\n}\n\n@media only screen and (min-width: 375px) and (max-width: 415px) {\n  #content {\n    max-width: 414px;\n    box-sizing: border-box;\n  }\n}\n\n@media only screen and (min-width: 320px) and (max-width: 375px) {\n  #content {\n    max-width: 375px;\n    box-sizing: border-box;\n  }\n}\n\n@media only screen and (max-width: 320px) {\n  #content {\n    max-width: 320px;\n    box-sizing: border-box;\n  }\n}\n\n.walletconnect-modal__base {\n  -webkit-font-smoothing: antialiased;\n  background: #ffffff;\n  border-radius: 24px;\n  box-shadow: 0 10px 50px 5px rgba(0, 0, 0, 0.4);\n  font-family: ui-rounded, "SF Pro Rounded", "SF Pro Text", medium-content-sans-serif-font,\n    -apple-system, BlinkMacSystemFont, ui-sans-serif, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell,\n    "Open Sans", "Helvetica Neue", sans-serif;\n  margin-top: 41px;\n  padding: 24px 24px 22px;\n  pointer-events: auto;\n  position: relative;\n  text-align: center;\n  transition: 0.4s cubic-bezier(0.19, 1, 0.22, 1);\n  will-change: transform;\n  overflow: visible;\n  transform: translateY(-50%);\n  top: 50%;\n  max-width: 500px;\n  margin: auto;\n}\n\n@media only screen and (max-width: 320px) {\n  .walletconnect-modal__base {\n    padding: 24px 12px;\n  }\n}\n\n.walletconnect-modal__base .hidden {\n  transform: translateY(150%);\n  transition: 0.125s cubic-bezier(0.4, 0, 1, 1);\n}\n\n.walletconnect-modal__header {\n  align-items: center;\n  display: flex;\n  height: 26px;\n  left: 0;\n  justify-content: space-between;\n  position: absolute;\n  top: -42px;\n  width: 100%;\n}\n\n.walletconnect-modal__base .wc-logo {\n  align-items: center;\n  display: flex;\n  height: 26px;\n  margin-top: 15px;\n  padding-bottom: 15px;\n  pointer-events: auto;\n}\n\n.walletconnect-modal__base .wc-logo div {\n  background-color: #3399ff;\n  height: 21px;\n  margin-right: 5px;\n  mask-image: url("images/wc-logo.svg") center no-repeat;\n  width: 32px;\n}\n\n.walletconnect-modal__base .wc-logo p {\n  color: #ffffff;\n  font-size: 20px;\n  font-weight: 600;\n  margin: 0;\n}\n\n.walletconnect-modal__base h2 {\n  color: rgba(60, 66, 82, 0.6);\n  font-size: 16px;\n  font-weight: 600;\n  letter-spacing: 0;\n  line-height: 1.1875em;\n  margin: 0 0 19px 0;\n  text-align: center;\n  width: 100%;\n}\n\n.walletconnect-modal__base__row {\n  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n  align-items: center;\n  border-radius: 20px;\n  cursor: pointer;\n  display: flex;\n  height: 56px;\n  justify-content: space-between;\n  padding: 0 15px;\n  position: relative;\n  margin: 0px 0px 8px;\n  text-align: left;\n  transition: 0.15s cubic-bezier(0.25, 0.46, 0.45, 0.94);\n  will-change: transform;\n  text-decoration: none;\n}\n\n.walletconnect-modal__base__row:hover {\n  background: rgba(60, 66, 82, 0.06);\n}\n\n.walletconnect-modal__base__row:active {\n  background: rgba(60, 66, 82, 0.06);\n  transform: scale(0.975);\n  transition: 0.1s cubic-bezier(0.25, 0.46, 0.45, 0.94);\n}\n\n.walletconnect-modal__base__row__h3 {\n  color: #25292e;\n  font-size: 20px;\n  font-weight: 700;\n  margin: 0;\n  padding-bottom: 3px;\n}\n\n.walletconnect-modal__base__row__right {\n  align-items: center;\n  display: flex;\n  justify-content: center;\n}\n\n.walletconnect-modal__base__row__right__app-icon {\n  border-radius: 8px;\n  height: 34px;\n  margin: 0 11px 2px 0;\n  width: 34px;\n  background-size: 100%;\n  box-shadow: 0 4px 12px 0 rgba(37, 41, 46, 0.25);\n}\n\n.walletconnect-modal__base__row__right__caret {\n  height: 18px;\n  opacity: 0.3;\n  transition: 0.1s cubic-bezier(0.25, 0.46, 0.45, 0.94);\n  width: 8px;\n  will-change: opacity;\n}\n\n.walletconnect-modal__base__row:hover .caret,\n.walletconnect-modal__base__row:active .caret {\n  opacity: 0.6;\n}\n\n.walletconnect-modal__mobile__toggle {\n  width: 80%;\n  display: flex;\n  margin: 0 auto;\n  position: relative;\n  overflow: hidden;\n  border-radius: 8px;\n  margin-bottom: 18px;\n  background: #d4d5d9;\n}\n\n.walletconnect-modal__single_wallet {\n  display: flex;\n  justify-content: center;\n  margin-top: 7px;\n  margin-bottom: 18px;\n}\n\n.walletconnect-modal__single_wallet a {\n  cursor: pointer;\n  color: rgb(64, 153, 255);\n  font-size: 21px;\n  font-weight: 800;\n  text-decoration: none !important;\n  margin: 0 auto;\n}\n\n.walletconnect-modal__mobile__toggle_selector {\n  width: calc(50% - 8px);\n  background: white;\n  position: absolute;\n  border-radius: 5px;\n  height: calc(100% - 8px);\n  top: 4px;\n  transition: all 0.2s ease-in-out;\n  transform: translate3d(4px, 0, 0);\n}\n\n.walletconnect-modal__mobile__toggle.right__selected .walletconnect-modal__mobile__toggle_selector {\n  transform: translate3d(calc(100% + 12px), 0, 0);\n}\n\n.walletconnect-modal__mobile__toggle a {\n  font-size: 12px;\n  width: 50%;\n  text-align: center;\n  padding: 8px;\n  margin: 0;\n  font-weight: 600;\n  z-index: 1;\n}\n\n.walletconnect-modal__footer {\n  display: flex;\n  justify-content: center;\n  margin-top: 20px;\n}\n\n@media only screen and (max-width: 768px) {\n  .walletconnect-modal__footer {\n    margin-top: 5vw;\n  }\n}\n\n.walletconnect-modal__footer a {\n  cursor: pointer;\n  color: #898d97;\n  font-size: 15px;\n  margin: 0 auto;\n}\n\n@media only screen and (max-width: 320px) {\n  .walletconnect-modal__footer a {\n    font-size: 14px;\n  }\n}\n\n.walletconnect-connect__buttons__wrapper {\n  max-height: 44vh;\n}\n\n.walletconnect-connect__buttons__wrapper__android {\n  margin: 50% 0;\n}\n\n.walletconnect-connect__buttons__wrapper__wrap {\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  margin: 10px 0;\n}\n\n@media only screen and (min-width: 768px) {\n  .walletconnect-connect__buttons__wrapper__wrap {\n    margin-top: 40px;\n  }\n}\n\n.walletconnect-connect__button {\n  background-color: rgb(64, 153, 255);\n  padding: 12px;\n  border-radius: 8px;\n  text-decoration: none;\n  color: rgb(255, 255, 255);\n  font-weight: 500;\n}\n\n.walletconnect-connect__button__icon_anchor {\n  cursor: pointer;\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n  margin: 8px;\n  width: 42px;\n  justify-self: center;\n  flex-direction: column;\n  text-decoration: none !important;\n}\n\n@media only screen and (max-width: 320px) {\n  .walletconnect-connect__button__icon_anchor {\n    margin: 4px;\n  }\n}\n\n.walletconnect-connect__button__icon {\n  border-radius: 10px;\n  height: 42px;\n  margin: 0;\n  width: 42px;\n  background-size: cover !important;\n  box-shadow: 0 4px 12px 0 rgba(37, 41, 46, 0.25);\n}\n\n.walletconnect-connect__button__text {\n  color: #424952;\n  font-size: 2.7vw;\n  text-decoration: none !important;\n  padding: 0;\n  margin-top: 1.8vw;\n  font-weight: 600;\n}\n\n@media only screen and (min-width: 768px) {\n  .walletconnect-connect__button__text {\n    font-size: 16px;\n    margin-top: 12px;\n  }\n}\n\n.walletconnect-search__input {\n  border: none;\n  background: #d4d5d9;\n  border-style: none;\n  padding: 8px 16px;\n  outline: none;\n  font-style: normal;\n  font-stretch: normal;\n  font-size: 16px;\n  font-style: normal;\n  font-stretch: normal;\n  line-height: normal;\n  letter-spacing: normal;\n  text-align: left;\n  border-radius: 8px;\n  width: calc(100% - 16px);\n  margin: 0;\n  margin-bottom: 8px;\n}\n';
// A type of promise-like that resolves synchronously and supports only one observer
var _iteratorSymbol = /*#__PURE__*/ typeof Symbol !== "undefined" ? Symbol.iterator || (Symbol.iterator = Symbol("Symbol.iterator")) : "@@iterator"; // Asynchronously iterate through an object's values
var _asyncIteratorSymbol = /*#__PURE__*/ typeof Symbol !== "undefined" ? Symbol.asyncIterator || (Symbol.asyncIterator = Symbol("Symbol.asyncIterator")) : "@@asyncIterator"; // Asynchronously iterate on a value using it's async iterator if present, or its synchronous iterator if missing
function _catch(body, recover) {
    try {
        var result = body();
    } catch (e) {
        return recover(e);
    }
    if (result && result.then) return result.then(void 0, recover);
    return result;
} // Asynchronously await a promise and pass the result to a finally continuation
var WALLETCONNECT_LOGO_SVG_URL = "data:image/svg+xml,%3Csvg height='185' viewBox='0 0 300 185' width='300' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='m61.4385429 36.2562612c48.9112241-47.8881663 128.2119871-47.8881663 177.1232091 0l5.886545 5.7634174c2.445561 2.3944081 2.445561 6.2765112 0 8.6709204l-20.136695 19.715503c-1.222781 1.1972051-3.2053 1.1972051-4.428081 0l-8.100584-7.9311479c-34.121692-33.4079817-89.443886-33.4079817-123.5655788 0l-8.6750562 8.4936051c-1.2227816 1.1972041-3.205301 1.1972041-4.4280806 0l-20.1366949-19.7155031c-2.4455612-2.3944092-2.4455612-6.2765122 0-8.6709204zm218.7677961 40.7737449 17.921697 17.546897c2.445549 2.3943969 2.445563 6.2764769.000031 8.6708899l-80.810171 79.121134c-2.445544 2.394426-6.410582 2.394453-8.85616.000062-.00001-.00001-.000022-.000022-.000032-.000032l-57.354143-56.154572c-.61139-.598602-1.60265-.598602-2.21404 0-.000004.000004-.000007.000008-.000011.000011l-57.3529212 56.154531c-2.4455368 2.394432-6.4105755 2.394472-8.8561612.000087-.0000143-.000014-.0000296-.000028-.0000449-.000044l-80.81241943-79.122185c-2.44556021-2.394408-2.44556021-6.2765115 0-8.6709197l17.92172963-17.5468673c2.4455602-2.3944082 6.4105989-2.3944082 8.8561602 0l57.3549775 56.155357c.6113908.598602 1.602649.598602 2.2140398 0 .0000092-.000009.0000174-.000017.0000265-.000024l57.3521031-56.155333c2.445505-2.3944633 6.410544-2.3945531 8.856161-.0002.000034.0000336.000068.0000673.000101.000101l57.354902 56.155432c.61139.598601 1.60265.598601 2.21404 0l57.353975-56.1543249c2.445561-2.3944092 6.410599-2.3944092 8.85616 0z' fill='%233b99fc'/%3E%3C/svg%3E";
var WALLETCONNECT_HEADER_TEXT = "WalletConnect";
var ANIMATION_DURATION = 300;
var DEFAULT_BUTTON_COLOR = "rgb(64, 153, 255)";
var WALLETCONNECT_WRAPPER_ID = "walletconnect-wrapper";
var WALLETCONNECT_STYLE_ID = "walletconnect-style-sheet";
var WALLETCONNECT_MODAL_ID = "walletconnect-qrcode-modal";
var WALLETCONNECT_CLOSE_BUTTON_ID = "walletconnect-qrcode-close";
var WALLETCONNECT_CTA_TEXT_ID = "walletconnect-qrcode-text";
var WALLETCONNECT_CONNECT_BUTTON_ID = "walletconnect-connect-button";
function Header(props) {
    return React.createElement("div", {
        className: "walletconnect-modal__header"
    }, React.createElement("img", {
        src: WALLETCONNECT_LOGO_SVG_URL,
        className: "walletconnect-modal__headerLogo"
    }), React.createElement("p", null, WALLETCONNECT_HEADER_TEXT), React.createElement("div", {
        className: "walletconnect-modal__close__wrapper",
        onClick: props.onClose
    }, React.createElement("div", {
        id: WALLETCONNECT_CLOSE_BUTTON_ID,
        className: "walletconnect-modal__close__icon"
    }, React.createElement("div", {
        className: "walletconnect-modal__close__line1"
    }), React.createElement("div", {
        className: "walletconnect-modal__close__line2"
    }))));
}
function ConnectButton(props) {
    return React.createElement("a", {
        className: "walletconnect-connect__button",
        href: props.href,
        id: WALLETCONNECT_CONNECT_BUTTON_ID + "-" + props.name,
        onClick: props.onClick,
        rel: "noopener noreferrer",
        style: {
            backgroundColor: props.color
        },
        target: "_blank"
    }, props.name);
}
var CARET_SVG_URL = "data:image/svg+xml,%3Csvg fill='none' height='18' viewBox='0 0 8 18' width='8' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath clip-rule='evenodd' d='m.586301.213898c-.435947.33907-.5144813.967342-.175411 1.403292l4.87831 6.27212c.28087.36111.28087.86677 0 1.22788l-4.878311 6.27211c-.33907.436-.260536 1.0642.175412 1.4033.435949.3391 1.064219.2605 1.403289-.1754l4.87832-6.2721c.84259-1.08336.84259-2.60034 0-3.68367l-4.87832-6.27212c-.33907-.4359474-.96734-.514482-1.403289-.175412z' fill='%233c4252' fill-rule='evenodd'/%3E%3C/svg%3E";
function WalletButton(props) {
    var color = props.color;
    var href = props.href;
    var name = props.name;
    var logo = props.logo;
    var onClick = props.onClick;
    return React.createElement("a", {
        className: "walletconnect-modal__base__row",
        href: href,
        onClick: onClick,
        rel: "noopener noreferrer",
        target: "_blank"
    }, React.createElement("h3", {
        className: "walletconnect-modal__base__row__h3"
    }, name), React.createElement("div", {
        className: "walletconnect-modal__base__row__right"
    }, React.createElement("div", {
        className: "walletconnect-modal__base__row__right__app-icon",
        style: {
            background: "url('" + logo + "') " + color,
            backgroundSize: "100%"
        }
    }), React.createElement("img", {
        src: CARET_SVG_URL,
        className: "walletconnect-modal__base__row__right__caret"
    })));
}
function WalletIcon(props) {
    var color = props.color;
    var href = props.href;
    var name = props.name;
    var logo = props.logo;
    var onClick = props.onClick;
    var fontSize = window.innerWidth < 768 ? (name.length > 8 ? 2.5 : 2.7) + "vw" : "inherit";
    return React.createElement("a", {
        className: "walletconnect-connect__button__icon_anchor",
        href: href,
        onClick: onClick,
        rel: "noopener noreferrer",
        target: "_blank"
    }, React.createElement("div", {
        className: "walletconnect-connect__button__icon",
        style: {
            background: "url('" + logo + "') " + color,
            backgroundSize: "100%"
        }
    }), React.createElement("div", {
        style: {
            fontSize: fontSize
        },
        className: "walletconnect-connect__button__text"
    }, name));
}
var GRID_MIN_COUNT = 5;
var LINKS_PER_PAGE = 12;
function LinkDisplay(props) {
    var android = browserUtils.isAndroid();
    var ref = React.useState("");
    var input = ref[0];
    var setInput = ref[1];
    var ref$1 = React.useState("");
    var filter = ref$1[0];
    var setFilter = ref$1[1];
    var ref$2 = React.useState(1);
    var page = ref$2[0];
    var setPage = ref$2[1];
    var links = filter ? props.links.filter(function(link) {
        return link.name.toLowerCase().includes(filter.toLowerCase());
    }) : props.links;
    var errorMessage = props.errorMessage;
    var grid = filter || links.length > GRID_MIN_COUNT;
    var pages = Math.ceil(links.length / LINKS_PER_PAGE);
    var range = [
        (page - 1) * LINKS_PER_PAGE + 1,
        page * LINKS_PER_PAGE
    ];
    var pageLinks = links.length ? links.filter(function(_, index) {
        return index + 1 >= range[0] && index + 1 <= range[1];
    }) : [];
    var hasPaging = !!(!android && pages > 1);
    var filterTimeout = undefined;
    function handleInput(e) {
        setInput(e.target.value);
        clearTimeout(filterTimeout);
        if (e.target.value) filterTimeout = setTimeout(function() {
            setFilter(e.target.value);
            setPage(1);
        }, 1000);
        else {
            setInput("");
            setFilter("");
            setPage(1);
        }
    }
    return React.createElement("div", null, React.createElement("p", {
        id: WALLETCONNECT_CTA_TEXT_ID,
        className: "walletconnect-qrcode__text"
    }, android ? props.text.connect_mobile_wallet : props.text.choose_preferred_wallet), !android && React.createElement("input", {
        className: "walletconnect-search__input",
        placeholder: "Search",
        value: input,
        onChange: handleInput
    }), React.createElement("div", {
        className: "walletconnect-connect__buttons__wrapper" + (android ? "__android" : grid && links.length ? "__wrap" : "")
    }, !android ? pageLinks.length ? pageLinks.map(function(entry) {
        var color = entry.color;
        var name = entry.name;
        var shortName = entry.shortName;
        var logo = entry.logo;
        var href = browserUtils.formatIOSMobile(props.uri, entry);
        var handleClickIOS = React.useCallback(function() {
            browserUtils.saveMobileLinkInfo({
                name: name,
                href: href
            });
        }, [
            pageLinks
        ]);
        return !grid ? React.createElement(WalletButton, {
            color: color,
            href: href,
            name: name,
            logo: logo,
            onClick: handleClickIOS
        }) : React.createElement(WalletIcon, {
            color: color,
            href: href,
            name: shortName || name,
            logo: logo,
            onClick: handleClickIOS
        });
    }) : React.createElement(React.Fragment, null, React.createElement("p", null, errorMessage.length ? props.errorMessage : !!props.links.length && !links.length ? props.text.no_wallets_found : props.text.loading)) : React.createElement(ConnectButton, {
        name: props.text.connect,
        color: DEFAULT_BUTTON_COLOR,
        href: props.uri,
        onClick: React.useCallback(function() {
            browserUtils.saveMobileLinkInfo({
                name: "Unknown",
                href: props.uri
            });
        }, [])
    })), hasPaging && React.createElement("div", {
        className: "walletconnect-modal__footer"
    }, Array(pages).fill(0).map(function(_, index) {
        var pageNumber = index + 1;
        var selected = page === pageNumber;
        return React.createElement("a", {
            style: {
                margin: "auto 10px",
                fontWeight: selected ? "bold" : "normal"
            },
            onClick: function() {
                return setPage(pageNumber);
            }
        }, pageNumber);
    })));
}
function Notification(props) {
    var show = !!props.message.trim();
    return React.createElement("div", {
        className: "walletconnect-qrcode__notification" + (show ? " notification__show" : "")
    }, props.message);
}
var formatQRCodeImage = function(data) {
    try {
        var result = "";
        return Promise.resolve(QRCode.toString(data, {
            margin: 0,
            type: "svg"
        })).then(function(dataString) {
            if (typeof dataString === "string") result = dataString.replace("<svg", '<svg class="walletconnect-qrcode__image"');
            return result;
        });
    } catch (e) {
        return Promise.reject(e);
    }
};
function QRCodeDisplay(props) {
    var ref = React.useState("");
    var notification = ref[0];
    var setNotification = ref[1];
    var ref$1 = React.useState("");
    var svg = ref$1[0];
    var setSvg = ref$1[1];
    React.useEffect(function() {
        try {
            return Promise.resolve(formatQRCodeImage(props.uri)).then(function(_formatQRCodeImage) {
                setSvg(_formatQRCodeImage);
            });
        } catch (e) {
            Promise.reject(e);
        }
    }, []);
    var copyToClipboard = function() {
        var success = copy(props.uri);
        if (success) {
            setNotification(props.text.copied_to_clipboard);
            setInterval(function() {
                return setNotification("");
            }, 1200);
        } else {
            setNotification("Error");
            setInterval(function() {
                return setNotification("");
            }, 1200);
        }
    };
    return React.createElement("div", null, React.createElement("p", {
        id: WALLETCONNECT_CTA_TEXT_ID,
        className: "walletconnect-qrcode__text"
    }, props.text.scan_qrcode_with_wallet), React.createElement("div", {
        dangerouslySetInnerHTML: {
            __html: svg
        }
    }), React.createElement("div", {
        className: "walletconnect-modal__footer"
    }, React.createElement("a", {
        onClick: copyToClipboard
    }, props.text.copy_to_clipboard)), React.createElement(Notification, {
        message: notification
    }));
}
function Modal(props) {
    var android = browserUtils.isAndroid();
    var mobile = browserUtils.isMobile();
    var whitelist = mobile ? props.qrcodeModalOptions && props.qrcodeModalOptions.mobileLinks ? props.qrcodeModalOptions.mobileLinks : undefined : props.qrcodeModalOptions && props.qrcodeModalOptions.desktopLinks ? props.qrcodeModalOptions.desktopLinks : undefined;
    var ref = React.useState(false);
    var loading = ref[0];
    var setLoading = ref[1];
    var ref$1 = React.useState(false);
    var fetched = ref$1[0];
    var setFetched = ref$1[1];
    var ref$2 = React.useState(!mobile);
    var displayQRCode = ref$2[0];
    var setDisplayQRCode = ref$2[1];
    var displayProps = {
        mobile: mobile,
        text: props.text,
        uri: props.uri,
        qrcodeModalOptions: props.qrcodeModalOptions
    };
    var ref$3 = React.useState("");
    var singleLinkHref = ref$3[0];
    var setSingleLinkHref = ref$3[1];
    var ref$4 = React.useState(false);
    var hasSingleLink = ref$4[0];
    var setHasSingleLink = ref$4[1];
    var ref$5 = React.useState([]);
    var links = ref$5[0];
    var setLinks = ref$5[1];
    var ref$6 = React.useState("");
    var errorMessage = ref$6[0];
    var setErrorMessage = ref$6[1];
    var getLinksIfNeeded = function() {
        if (fetched || loading || whitelist && !whitelist.length || links.length > 0) return;
        React.useEffect(function() {
            var initLinks = function() {
                try {
                    if (android) return Promise.resolve();
                    setLoading(true);
                    var _temp = _catch(function() {
                        var url = props.qrcodeModalOptions && props.qrcodeModalOptions.registryUrl ? props.qrcodeModalOptions.registryUrl : browserUtils.getWalletRegistryUrl();
                        return Promise.resolve(fetch(url)).then(function(registryResponse) {
                            return Promise.resolve(registryResponse.json()).then(function(_registryResponse$jso) {
                                var registry = _registryResponse$jso.listings;
                                var platform = mobile ? "mobile" : "desktop";
                                var _links = browserUtils.getMobileLinkRegistry(browserUtils.formatMobileRegistry(registry, platform), whitelist);
                                setLoading(false);
                                setFetched(true);
                                setErrorMessage(!_links.length ? props.text.no_supported_wallets : "");
                                setLinks(_links);
                                var hasSingleLink = _links.length === 1;
                                if (hasSingleLink) {
                                    setSingleLinkHref(browserUtils.formatIOSMobile(props.uri, _links[0]));
                                    setDisplayQRCode(true);
                                }
                                setHasSingleLink(hasSingleLink);
                            });
                        });
                    }, function(e) {
                        setLoading(false);
                        setFetched(true);
                        setErrorMessage(props.text.something_went_wrong);
                        console.error(e);
                    });
                    return Promise.resolve(_temp && _temp.then ? _temp.then(function() {}) : void 0);
                } catch (e) {
                    return Promise.reject(e);
                }
            };
            initLinks();
        });
    };
    getLinksIfNeeded();
    var rightSelected = mobile ? displayQRCode : !displayQRCode;
    return React.createElement("div", {
        id: WALLETCONNECT_MODAL_ID,
        className: "walletconnect-qrcode__base animated fadeIn"
    }, React.createElement("div", {
        className: "walletconnect-modal__base"
    }, React.createElement(Header, {
        onClose: props.onClose
    }), hasSingleLink && displayQRCode ? React.createElement("div", {
        className: "walletconnect-modal__single_wallet"
    }, React.createElement("a", {
        onClick: function() {
            return browserUtils.saveMobileLinkInfo({
                name: links[0].name,
                href: singleLinkHref
            });
        },
        href: singleLinkHref,
        rel: "noopener noreferrer",
        target: "_blank"
    }, props.text.connect_with + " " + (hasSingleLink ? links[0].name : "") + " \u203A")) : android || loading || !loading && links.length ? React.createElement("div", {
        className: "walletconnect-modal__mobile__toggle" + (rightSelected ? " right__selected" : "")
    }, React.createElement("div", {
        className: "walletconnect-modal__mobile__toggle_selector"
    }), mobile ? React.createElement(React.Fragment, null, React.createElement("a", {
        onClick: function() {
            return setDisplayQRCode(false), getLinksIfNeeded();
        }
    }, props.text.mobile), React.createElement("a", {
        onClick: function() {
            return setDisplayQRCode(true);
        }
    }, props.text.qrcode)) : React.createElement(React.Fragment, null, React.createElement("a", {
        onClick: function() {
            return setDisplayQRCode(true);
        }
    }, props.text.qrcode), React.createElement("a", {
        onClick: function() {
            return setDisplayQRCode(false), getLinksIfNeeded();
        }
    }, props.text.desktop))) : null, React.createElement("div", null, displayQRCode || !android && !loading && !links.length ? React.createElement(QRCodeDisplay, Object.assign({}, displayProps)) : React.createElement(LinkDisplay, Object.assign({}, displayProps, {
        links: links,
        errorMessage: errorMessage
    })))));
}
var de = {
    choose_preferred_wallet: "W\xe4hle bevorzugte Wallet",
    connect_mobile_wallet: "Verbinde mit Mobile Wallet",
    scan_qrcode_with_wallet: "Scanne den QR-code mit einer WalletConnect kompatiblen Wallet",
    connect: "Verbinden",
    qrcode: "QR-Code",
    mobile: "Mobile",
    desktop: "Desktop",
    copy_to_clipboard: "In die Zwischenablage kopieren",
    copied_to_clipboard: "In die Zwischenablage kopiert!",
    connect_with: "Verbinden mit Hilfe von",
    loading: "Laden...",
    something_went_wrong: "Etwas ist schief gelaufen",
    no_supported_wallets: "Es gibt noch keine unterst\xfctzten Wallet",
    no_wallets_found: "keine Wallet gefunden"
};
var en = {
    choose_preferred_wallet: "Choose your preferred wallet",
    connect_mobile_wallet: "Connect to Mobile Wallet",
    scan_qrcode_with_wallet: "Scan QR code with a WalletConnect-compatible wallet",
    connect: "Connect",
    qrcode: "QR Code",
    mobile: "Mobile",
    desktop: "Desktop",
    copy_to_clipboard: "Copy to clipboard",
    copied_to_clipboard: "Copied to clipboard!",
    connect_with: "Connect with",
    loading: "Loading...",
    something_went_wrong: "Something went wrong",
    no_supported_wallets: "There are no supported wallets yet",
    no_wallets_found: "No wallets found"
};
var es = {
    choose_preferred_wallet: "Elige tu billetera preferida",
    connect_mobile_wallet: "Conectar a billetera m\xf3vil",
    scan_qrcode_with_wallet: "Escanea el c\xf3digo QR con una billetera compatible con WalletConnect",
    connect: "Conectar",
    qrcode: "C\xf3digo QR",
    mobile: "M\xf3vil",
    desktop: "Desktop",
    copy_to_clipboard: "Copiar",
    copied_to_clipboard: "Copiado!",
    connect_with: "Conectar mediante",
    loading: "Cargando...",
    something_went_wrong: "Algo sali\xf3 mal",
    no_supported_wallets: "Todav\xeda no hay billeteras compatibles",
    no_wallets_found: "No se encontraron billeteras"
};
var fr = {
    choose_preferred_wallet: "Choisissez votre portefeuille pr\xe9f\xe9r\xe9",
    connect_mobile_wallet: "Se connecter au portefeuille mobile",
    scan_qrcode_with_wallet: "Scannez le QR code avec un portefeuille compatible WalletConnect",
    connect: "Se connecter",
    qrcode: "QR Code",
    mobile: "Mobile",
    desktop: "Desktop",
    copy_to_clipboard: "Copier",
    copied_to_clipboard: "Copi\xe9!",
    connect_with: "Connectez-vous \xe0 l'aide de",
    loading: "Chargement...",
    something_went_wrong: "Quelque chose a mal tourn\xe9",
    no_supported_wallets: "Il n'y a pas encore de portefeuilles pris en charge",
    no_wallets_found: "Aucun portefeuille trouv\xe9"
};
var ko = {
    choose_preferred_wallet: "\uC6D0\uD558\uB294 \uC9C0\uAC11\uC744 \uC120\uD0DD\uD558\uC138\uC694",
    connect_mobile_wallet: "\uBAA8\uBC14\uC77C \uC9C0\uAC11\uACFC \uC5F0\uACB0",
    scan_qrcode_with_wallet: "WalletConnect \uC9C0\uC6D0 \uC9C0\uAC11\uC5D0\uC11C QR\uCF54\uB4DC\uB97C \uC2A4\uCE94\uD558\uC138\uC694",
    connect: "\uC5F0\uACB0",
    qrcode: "QR \uCF54\uB4DC",
    mobile: "\uBAA8\uBC14\uC77C",
    desktop: "\uB370\uC2A4\uD06C\uD0D1",
    copy_to_clipboard: "\uD074\uB9BD\uBCF4\uB4DC\uC5D0 \uBCF5\uC0AC",
    copied_to_clipboard: "\uD074\uB9BD\uBCF4\uB4DC\uC5D0 \uBCF5\uC0AC\uB418\uC5C8\uC2B5\uB2C8\uB2E4!",
    connect_with: "\uC640 \uC5F0\uACB0\uD558\uB2E4",
    loading: "\uB85C\uB4DC \uC911...",
    something_went_wrong: "\uBB38\uC81C\uAC00 \uBC1C\uC0DD\uD588\uC2B5\uB2C8\uB2E4.",
    no_supported_wallets: "\uC544\uC9C1 \uC9C0\uC6D0\uB418\uB294 \uC9C0\uAC11\uC774 \uC5C6\uC2B5\uB2C8\uB2E4",
    no_wallets_found: "\uC9C0\uAC11\uC744 \uCC3E\uC744 \uC218 \uC5C6\uC2B5\uB2C8\uB2E4"
};
var pt = {
    choose_preferred_wallet: "Escolha sua carteira preferida",
    connect_mobile_wallet: "Conectar-se \xe0 carteira m\xf3vel",
    scan_qrcode_with_wallet: "Ler o c\xf3digo QR com uma carteira compat\xedvel com WalletConnect",
    connect: "Conectar",
    qrcode: "C\xf3digo QR",
    mobile: "M\xf3vel",
    desktop: "Desktop",
    copy_to_clipboard: "Copiar",
    copied_to_clipboard: "Copiado!",
    connect_with: "Ligar por meio de",
    loading: "Carregamento...",
    something_went_wrong: "Algo correu mal",
    no_supported_wallets: "Ainda n\xe3o h\xe1 carteiras suportadas",
    no_wallets_found: "Nenhuma carteira encontrada"
};
var zh = {
    choose_preferred_wallet: "\u9009\u62E9\u4F60\u7684\u94B1\u5305",
    connect_mobile_wallet: "\u8FDE\u63A5\u81F3\u79FB\u52A8\u7AEF\u94B1\u5305",
    scan_qrcode_with_wallet: "\u4F7F\u7528\u517C\u5BB9 WalletConnect \u7684\u94B1\u5305\u626B\u63CF\u4E8C\u7EF4\u7801",
    connect: "\u8FDE\u63A5",
    qrcode: "\u4E8C\u7EF4\u7801",
    mobile: "\u79FB\u52A8",
    desktop: "\u684C\u9762",
    copy_to_clipboard: "\u590D\u5236\u5230\u526A\u8D34\u677F",
    copied_to_clipboard: "\u590D\u5236\u5230\u526A\u8D34\u677F\u6210\u529F\uFF01",
    connect_with: "\u901A\u8FC7\u4EE5\u4E0B\u65B9\u5F0F\u8FDE\u63A5",
    loading: "\u6B63\u5728\u52A0\u8F7D...",
    something_went_wrong: "\u51FA\u4E86\u95EE\u9898",
    no_supported_wallets: "\u76EE\u524D\u8FD8\u6CA1\u6709\u652F\u6301\u7684\u94B1\u5305",
    no_wallets_found: "\u6CA1\u6709\u627E\u5230\u94B1\u5305"
};
var fa = {
    choose_preferred_wallet: "\u06A9\u06CC\u0641 \u067E\u0648\u0644 \u0645\u0648\u0631\u062F \u0646\u0638\u0631 \u062E\u0648\u062F \u0631\u0627 \u0627\u0646\u062A\u062E\u0627\u0628 \u06A9\u0646\u06CC\u062F",
    connect_mobile_wallet: "\u0628\u0647 \u06A9\u06CC\u0641 \u067E\u0648\u0644 \u0645\u0648\u0628\u0627\u06CC\u0644 \u0648\u0635\u0644 \u0634\u0648\u06CC\u062F",
    scan_qrcode_with_wallet: "\u06A9\u062F QR \u0631\u0627 \u0628\u0627 \u06CC\u06A9 \u06A9\u06CC\u0641 \u067E\u0648\u0644 \u0633\u0627\u0632\u06AF\u0627\u0631 \u0628\u0627 WalletConnect \u0627\u0633\u06A9\u0646 \u06A9\u0646\u06CC\u062F",
    connect: "\u0627\u062A\u0635\u0627\u0644",
    qrcode: "\u06A9\u062F QR",
    mobile: "\u0633\u06CC\u0627\u0631",
    desktop: "\u062F\u0633\u06A9\u062A\u0627\u067E",
    copy_to_clipboard: "\u06A9\u067E\u06CC \u0628\u0647 \u06A9\u0644\u06CC\u067E \u0628\u0648\u0631\u062F",
    copied_to_clipboard: "\u062F\u0631 \u06A9\u0644\u06CC\u067E \u0628\u0648\u0631\u062F \u06A9\u067E\u06CC \u0634\u062F!",
    connect_with: "\u0627\u0631\u062A\u0628\u0627\u0637 \u0628\u0627",
    loading: "...\u0628\u0627\u0631\u06AF\u0630\u0627\u0631\u06CC",
    something_went_wrong: "\u0645\u0634\u06A9\u0644\u06CC \u067E\u06CC\u0634 \u0622\u0645\u062F",
    no_supported_wallets: "\u0647\u0646\u0648\u0632 \u0647\u06CC\u0686 \u06A9\u06CC\u0641 \u067E\u0648\u0644 \u067E\u0634\u062A\u06CC\u0628\u0627\u0646\u06CC \u0634\u062F\u0647 \u0627\u06CC \u0648\u062C\u0648\u062F \u0646\u062F\u0627\u0631\u062F",
    no_wallets_found: "\u0647\u06CC\u0686 \u06A9\u06CC\u0641 \u067E\u0648\u0644\u06CC \u067E\u06CC\u062F\u0627 \u0646\u0634\u062F"
};
var languages = {
    de: de,
    en: en,
    es: es,
    fr: fr,
    ko: ko,
    pt: pt,
    zh: zh,
    fa: fa
};
function injectStyleSheet() {
    var doc = browserUtils.getDocumentOrThrow();
    var prev = doc.getElementById(WALLETCONNECT_STYLE_ID);
    if (prev) doc.head.removeChild(prev);
    var style = doc.createElement("style");
    style.setAttribute("id", WALLETCONNECT_STYLE_ID);
    style.innerText = WALLETCONNECT_STYLE_SHEET;
    doc.head.appendChild(style);
}
function renderWrapper() {
    var doc = browserUtils.getDocumentOrThrow();
    var wrapper = doc.createElement("div");
    wrapper.setAttribute("id", WALLETCONNECT_WRAPPER_ID);
    doc.body.appendChild(wrapper);
    return wrapper;
}
function triggerCloseAnimation() {
    var doc = browserUtils.getDocumentOrThrow();
    var modal = doc.getElementById(WALLETCONNECT_MODAL_ID);
    if (modal) {
        modal.className = modal.className.replace("fadeIn", "fadeOut");
        setTimeout(function() {
            var wrapper = doc.getElementById(WALLETCONNECT_WRAPPER_ID);
            if (wrapper) doc.body.removeChild(wrapper);
        }, ANIMATION_DURATION);
    }
}
function getWrappedCallback(cb) {
    return function() {
        triggerCloseAnimation();
        if (cb) cb();
    };
}
function getText() {
    var lang = browserUtils.getNavigatorOrThrow().language.split("-")[0] || "en";
    return languages[lang] || languages["en"];
}
function open$1(uri, cb, qrcodeModalOptions) {
    injectStyleSheet();
    var wrapper = renderWrapper();
    React.render(React.createElement(Modal, {
        text: getText(),
        uri: uri,
        onClose: getWrappedCallback(cb),
        qrcodeModalOptions: qrcodeModalOptions
    }), wrapper);
}
function close$1() {
    triggerCloseAnimation();
}
var isNode = function() {
    return typeof process !== "undefined" && typeof process.versions !== "undefined" && typeof process.versions.node !== "undefined";
};
function open$2(uri, cb, qrcodeModalOptions) {
    console.log(uri);
    if (isNode()) open(uri);
    else open$1(uri, cb, qrcodeModalOptions);
}
function close$2() {
    if (isNode()) ;
    else close$1();
}
var index = {
    open: open$2,
    close: close$2
};
module.exports = index;

},{"b4374c35fea42e9e":"5QIF0","1d1bf013c1507dad":"5uxh8","512c6fb1e5cc3a43":"g0s0G","7579aa92c82de8c4":"h8Sci","edb24cc120086e21":"7Rky7"}],"g0s0G":[function(require,module,exports) {
var canPromise = require("da1f68cc1fc16077");
var QRCode = require("8c6cf49ef2287430");
var CanvasRenderer = require("8a60cf7722cc14ce");
var SvgRenderer = require("f6fcc816b915ba37");
function renderCanvas(renderFunc, canvas, text, opts, cb) {
    var args = [].slice.call(arguments, 1);
    var argsNum = args.length;
    var isLastArgCb = typeof args[argsNum - 1] === "function";
    if (!isLastArgCb && !canPromise()) throw new Error("Callback required as last argument");
    if (isLastArgCb) {
        if (argsNum < 2) throw new Error("Too few arguments provided");
        if (argsNum === 2) {
            cb = text;
            text = canvas;
            canvas = opts = undefined;
        } else if (argsNum === 3) {
            if (canvas.getContext && typeof cb === "undefined") {
                cb = opts;
                opts = undefined;
            } else {
                cb = opts;
                opts = text;
                text = canvas;
                canvas = undefined;
            }
        }
    } else {
        if (argsNum < 1) throw new Error("Too few arguments provided");
        if (argsNum === 1) {
            text = canvas;
            canvas = opts = undefined;
        } else if (argsNum === 2 && !canvas.getContext) {
            opts = text;
            text = canvas;
            canvas = undefined;
        }
        return new Promise(function(resolve, reject) {
            try {
                var data = QRCode.create(text, opts);
                resolve(renderFunc(data, canvas, opts));
            } catch (e) {
                reject(e);
            }
        });
    }
    try {
        var data = QRCode.create(text, opts);
        cb(null, renderFunc(data, canvas, opts));
    } catch (e) {
        cb(e);
    }
}
exports.create = QRCode.create;
exports.toCanvas = renderCanvas.bind(null, CanvasRenderer.render);
exports.toDataURL = renderCanvas.bind(null, CanvasRenderer.renderToDataURL);
// only svg for now.
exports.toString = renderCanvas.bind(null, function(data, _, opts) {
    return SvgRenderer.render(data, opts);
});

},{"da1f68cc1fc16077":"7NevM","8c6cf49ef2287430":"2Ifk2","8a60cf7722cc14ce":"53FZc","f6fcc816b915ba37":"cM6dr"}],"7NevM":[function(require,module,exports) {
// can-promise has a crash in some versions of react native that dont have
// standard global objects
// https://github.com/soldair/node-qrcode/issues/157
module.exports = function() {
    return typeof Promise === "function" && Promise.prototype && Promise.prototype.then;
};

},{}],"2Ifk2":[function(require,module,exports) {
var BufferUtil = require("2c584ad4fdedd124");
var Utils = require("4cf6a8173d9f3a2");
var ECLevel = require("2ad62f61c352884c");
var BitBuffer = require("87d5a6270eb1dc26");
var BitMatrix = require("91abc94f777368cc");
var AlignmentPattern = require("9737c3939ab85d95");
var FinderPattern = require("cee3d371e219e45e");
var MaskPattern = require("8700c8c682afabf3");
var ECCode = require("65ad903a6ba3e");
var ReedSolomonEncoder = require("1e8e447afb4d169c");
var Version = require("8a4a19af97836d80");
var FormatInfo = require("26720f9d94c9e268");
var Mode = require("7b6429a248ecc51f");
var Segments = require("1368d0fa14524351");
var isArray = require("d50aa727d0f2adb8");
/**
 * QRCode for JavaScript
 *
 * modified by Ryan Day for nodejs support
 * Copyright (c) 2011 Ryan Day
 *
 * Licensed under the MIT license:
 *   http://www.opensource.org/licenses/mit-license.php
 *
//---------------------------------------------------------------------
// QRCode for JavaScript
//
// Copyright (c) 2009 Kazuhiko Arase
//
// URL: http://www.d-project.com/
//
// Licensed under the MIT license:
//   http://www.opensource.org/licenses/mit-license.php
//
// The word "QR Code" is registered trademark of
// DENSO WAVE INCORPORATED
//   http://www.denso-wave.com/qrcode/faqpatent-e.html
//
//---------------------------------------------------------------------
*/ /**
 * Add finder patterns bits to matrix
 *
 * @param  {BitMatrix} matrix  Modules matrix
 * @param  {Number}    version QR Code version
 */ function setupFinderPattern(matrix, version) {
    var size = matrix.size;
    var pos = FinderPattern.getPositions(version);
    for(var i = 0; i < pos.length; i++){
        var row = pos[i][0];
        var col = pos[i][1];
        for(var r = -1; r <= 7; r++){
            if (row + r <= -1 || size <= row + r) continue;
            for(var c = -1; c <= 7; c++){
                if (col + c <= -1 || size <= col + c) continue;
                if (r >= 0 && r <= 6 && (c === 0 || c === 6) || c >= 0 && c <= 6 && (r === 0 || r === 6) || r >= 2 && r <= 4 && c >= 2 && c <= 4) matrix.set(row + r, col + c, true, true);
                else matrix.set(row + r, col + c, false, true);
            }
        }
    }
}
/**
 * Add timing pattern bits to matrix
 *
 * Note: this function must be called before {@link setupAlignmentPattern}
 *
 * @param  {BitMatrix} matrix Modules matrix
 */ function setupTimingPattern(matrix) {
    var size = matrix.size;
    for(var r = 8; r < size - 8; r++){
        var value = r % 2 === 0;
        matrix.set(r, 6, value, true);
        matrix.set(6, r, value, true);
    }
}
/**
 * Add alignment patterns bits to matrix
 *
 * Note: this function must be called after {@link setupTimingPattern}
 *
 * @param  {BitMatrix} matrix  Modules matrix
 * @param  {Number}    version QR Code version
 */ function setupAlignmentPattern(matrix, version) {
    var pos = AlignmentPattern.getPositions(version);
    for(var i = 0; i < pos.length; i++){
        var row = pos[i][0];
        var col = pos[i][1];
        for(var r = -2; r <= 2; r++){
            for(var c = -2; c <= 2; c++)if (r === -2 || r === 2 || c === -2 || c === 2 || r === 0 && c === 0) matrix.set(row + r, col + c, true, true);
            else matrix.set(row + r, col + c, false, true);
        }
    }
}
/**
 * Add version info bits to matrix
 *
 * @param  {BitMatrix} matrix  Modules matrix
 * @param  {Number}    version QR Code version
 */ function setupVersionInfo(matrix, version) {
    var size = matrix.size;
    var bits = Version.getEncodedBits(version);
    var row, col, mod;
    for(var i = 0; i < 18; i++){
        row = Math.floor(i / 3);
        col = i % 3 + size - 8 - 3;
        mod = (bits >> i & 1) === 1;
        matrix.set(row, col, mod, true);
        matrix.set(col, row, mod, true);
    }
}
/**
 * Add format info bits to matrix
 *
 * @param  {BitMatrix} matrix               Modules matrix
 * @param  {ErrorCorrectionLevel}    errorCorrectionLevel Error correction level
 * @param  {Number}    maskPattern          Mask pattern reference value
 */ function setupFormatInfo(matrix, errorCorrectionLevel, maskPattern) {
    var size = matrix.size;
    var bits = FormatInfo.getEncodedBits(errorCorrectionLevel, maskPattern);
    var i, mod;
    for(i = 0; i < 15; i++){
        mod = (bits >> i & 1) === 1;
        // vertical
        if (i < 6) matrix.set(i, 8, mod, true);
        else if (i < 8) matrix.set(i + 1, 8, mod, true);
        else matrix.set(size - 15 + i, 8, mod, true);
        // horizontal
        if (i < 8) matrix.set(8, size - i - 1, mod, true);
        else if (i < 9) matrix.set(8, 15 - i - 1 + 1, mod, true);
        else matrix.set(8, 15 - i - 1, mod, true);
    }
    // fixed module
    matrix.set(size - 8, 8, 1, true);
}
/**
 * Add encoded data bits to matrix
 *
 * @param  {BitMatrix} matrix Modules matrix
 * @param  {Buffer}    data   Data codewords
 */ function setupData(matrix, data) {
    var size = matrix.size;
    var inc = -1;
    var row = size - 1;
    var bitIndex = 7;
    var byteIndex = 0;
    for(var col = size - 1; col > 0; col -= 2){
        if (col === 6) col--;
        while(true){
            for(var c = 0; c < 2; c++)if (!matrix.isReserved(row, col - c)) {
                var dark = false;
                if (byteIndex < data.length) dark = (data[byteIndex] >>> bitIndex & 1) === 1;
                matrix.set(row, col - c, dark);
                bitIndex--;
                if (bitIndex === -1) {
                    byteIndex++;
                    bitIndex = 7;
                }
            }
            row += inc;
            if (row < 0 || size <= row) {
                row -= inc;
                inc = -inc;
                break;
            }
        }
    }
}
/**
 * Create encoded codewords from data input
 *
 * @param  {Number}   version              QR Code version
 * @param  {ErrorCorrectionLevel}   errorCorrectionLevel Error correction level
 * @param  {ByteData} data                 Data input
 * @return {Buffer}                        Buffer containing encoded codewords
 */ function createData(version, errorCorrectionLevel, segments) {
    // Prepare data buffer
    var buffer = new BitBuffer();
    segments.forEach(function(data) {
        // prefix data with mode indicator (4 bits)
        buffer.put(data.mode.bit, 4);
        // Prefix data with character count indicator.
        // The character count indicator is a string of bits that represents the
        // number of characters that are being encoded.
        // The character count indicator must be placed after the mode indicator
        // and must be a certain number of bits long, depending on the QR version
        // and data mode
        // @see {@link Mode.getCharCountIndicator}.
        buffer.put(data.getLength(), Mode.getCharCountIndicator(data.mode, version));
        // add binary data sequence to buffer
        data.write(buffer);
    });
    // Calculate required number of bits
    var totalCodewords = Utils.getSymbolTotalCodewords(version);
    var ecTotalCodewords = ECCode.getTotalCodewordsCount(version, errorCorrectionLevel);
    var dataTotalCodewordsBits = (totalCodewords - ecTotalCodewords) * 8;
    // Add a terminator.
    // If the bit string is shorter than the total number of required bits,
    // a terminator of up to four 0s must be added to the right side of the string.
    // If the bit string is more than four bits shorter than the required number of bits,
    // add four 0s to the end.
    if (buffer.getLengthInBits() + 4 <= dataTotalCodewordsBits) buffer.put(0, 4);
    // If the bit string is fewer than four bits shorter, add only the number of 0s that
    // are needed to reach the required number of bits.
    // After adding the terminator, if the number of bits in the string is not a multiple of 8,
    // pad the string on the right with 0s to make the string's length a multiple of 8.
    while(buffer.getLengthInBits() % 8 !== 0)buffer.putBit(0);
    // Add pad bytes if the string is still shorter than the total number of required bits.
    // Extend the buffer to fill the data capacity of the symbol corresponding to
    // the Version and Error Correction Level by adding the Pad Codewords 11101100 (0xEC)
    // and 00010001 (0x11) alternately.
    var remainingByte = (dataTotalCodewordsBits - buffer.getLengthInBits()) / 8;
    for(var i = 0; i < remainingByte; i++)buffer.put(i % 2 ? 0x11 : 0xEC, 8);
    return createCodewords(buffer, version, errorCorrectionLevel);
}
/**
 * Encode input data with Reed-Solomon and return codewords with
 * relative error correction bits
 *
 * @param  {BitBuffer} bitBuffer            Data to encode
 * @param  {Number}    version              QR Code version
 * @param  {ErrorCorrectionLevel} errorCorrectionLevel Error correction level
 * @return {Buffer}                         Buffer containing encoded codewords
 */ function createCodewords(bitBuffer, version, errorCorrectionLevel) {
    // Total codewords for this QR code version (Data + Error correction)
    var totalCodewords = Utils.getSymbolTotalCodewords(version);
    // Total number of error correction codewords
    var ecTotalCodewords = ECCode.getTotalCodewordsCount(version, errorCorrectionLevel);
    // Total number of data codewords
    var dataTotalCodewords = totalCodewords - ecTotalCodewords;
    // Total number of blocks
    var ecTotalBlocks = ECCode.getBlocksCount(version, errorCorrectionLevel);
    // Calculate how many blocks each group should contain
    var blocksInGroup2 = totalCodewords % ecTotalBlocks;
    var blocksInGroup1 = ecTotalBlocks - blocksInGroup2;
    var totalCodewordsInGroup1 = Math.floor(totalCodewords / ecTotalBlocks);
    var dataCodewordsInGroup1 = Math.floor(dataTotalCodewords / ecTotalBlocks);
    var dataCodewordsInGroup2 = dataCodewordsInGroup1 + 1;
    // Number of EC codewords is the same for both groups
    var ecCount = totalCodewordsInGroup1 - dataCodewordsInGroup1;
    // Initialize a Reed-Solomon encoder with a generator polynomial of degree ecCount
    var rs = new ReedSolomonEncoder(ecCount);
    var offset = 0;
    var dcData = new Array(ecTotalBlocks);
    var ecData = new Array(ecTotalBlocks);
    var maxDataSize = 0;
    var buffer = BufferUtil.from(bitBuffer.buffer);
    // Divide the buffer into the required number of blocks
    for(var b = 0; b < ecTotalBlocks; b++){
        var dataSize = b < blocksInGroup1 ? dataCodewordsInGroup1 : dataCodewordsInGroup2;
        // extract a block of data from buffer
        dcData[b] = buffer.slice(offset, offset + dataSize);
        // Calculate EC codewords for this data block
        ecData[b] = rs.encode(dcData[b]);
        offset += dataSize;
        maxDataSize = Math.max(maxDataSize, dataSize);
    }
    // Create final data
    // Interleave the data and error correction codewords from each block
    var data = BufferUtil.alloc(totalCodewords);
    var index = 0;
    var i, r;
    // Add data codewords
    for(i = 0; i < maxDataSize; i++){
        for(r = 0; r < ecTotalBlocks; r++)if (i < dcData[r].length) data[index++] = dcData[r][i];
    }
    // Apped EC codewords
    for(i = 0; i < ecCount; i++)for(r = 0; r < ecTotalBlocks; r++)data[index++] = ecData[r][i];
    return data;
}
/**
 * Build QR Code symbol
 *
 * @param  {String} data                 Input string
 * @param  {Number} version              QR Code version
 * @param  {ErrorCorretionLevel} errorCorrectionLevel Error level
 * @param  {MaskPattern} maskPattern     Mask pattern
 * @return {Object}                      Object containing symbol data
 */ function createSymbol(data, version, errorCorrectionLevel, maskPattern) {
    var segments;
    if (isArray(data)) segments = Segments.fromArray(data);
    else if (typeof data === "string") {
        var estimatedVersion = version;
        if (!estimatedVersion) {
            var rawSegments = Segments.rawSplit(data);
            // Estimate best version that can contain raw splitted segments
            estimatedVersion = Version.getBestVersionForData(rawSegments, errorCorrectionLevel);
        }
        // Build optimized segments
        // If estimated version is undefined, try with the highest version
        segments = Segments.fromString(data, estimatedVersion || 40);
    } else throw new Error("Invalid data");
    // Get the min version that can contain data
    var bestVersion = Version.getBestVersionForData(segments, errorCorrectionLevel);
    // If no version is found, data cannot be stored
    if (!bestVersion) throw new Error("The amount of data is too big to be stored in a QR Code");
    // If not specified, use min version as default
    if (!version) version = bestVersion;
    else if (version < bestVersion) throw new Error("\nThe chosen QR Code version cannot contain this amount of data.\nMinimum version required to store current data is: " + bestVersion + ".\n");
    var dataBits = createData(version, errorCorrectionLevel, segments);
    // Allocate matrix buffer
    var moduleCount = Utils.getSymbolSize(version);
    var modules = new BitMatrix(moduleCount);
    // Add function modules
    setupFinderPattern(modules, version);
    setupTimingPattern(modules);
    setupAlignmentPattern(modules, version);
    // Add temporary dummy bits for format info just to set them as reserved.
    // This is needed to prevent these bits from being masked by {@link MaskPattern.applyMask}
    // since the masking operation must be performed only on the encoding region.
    // These blocks will be replaced with correct values later in code.
    setupFormatInfo(modules, errorCorrectionLevel, 0);
    if (version >= 7) setupVersionInfo(modules, version);
    // Add data codewords
    setupData(modules, dataBits);
    if (isNaN(maskPattern)) // Find best mask pattern
    maskPattern = MaskPattern.getBestMask(modules, setupFormatInfo.bind(null, modules, errorCorrectionLevel));
    // Apply mask pattern
    MaskPattern.applyMask(maskPattern, modules);
    // Replace format info bits with correct values
    setupFormatInfo(modules, errorCorrectionLevel, maskPattern);
    return {
        modules: modules,
        version: version,
        errorCorrectionLevel: errorCorrectionLevel,
        maskPattern: maskPattern,
        segments: segments
    };
}
/**
 * QR Code
 *
 * @param {String | Array} data                 Input data
 * @param {Object} options                      Optional configurations
 * @param {Number} options.version              QR Code version
 * @param {String} options.errorCorrectionLevel Error correction level
 * @param {Function} options.toSJISFunc         Helper func to convert utf8 to sjis
 */ exports.create = function create(data, options) {
    if (typeof data === "undefined" || data === "") throw new Error("No input text");
    var errorCorrectionLevel = ECLevel.M;
    var version;
    var mask;
    if (typeof options !== "undefined") {
        // Use higher error correction level as default
        errorCorrectionLevel = ECLevel.from(options.errorCorrectionLevel, ECLevel.M);
        version = Version.from(options.version);
        mask = MaskPattern.from(options.maskPattern);
        if (options.toSJISFunc) Utils.setToSJISFunction(options.toSJISFunc);
    }
    return createSymbol(data, version, errorCorrectionLevel, mask);
};

},{"2c584ad4fdedd124":"9Bo5k","4cf6a8173d9f3a2":"bCvEH","2ad62f61c352884c":"fnt1n","87d5a6270eb1dc26":"2giyh","91abc94f777368cc":"4ozmv","9737c3939ab85d95":"jgRzo","cee3d371e219e45e":"1Qw2I","8700c8c682afabf3":"1BUGW","65ad903a6ba3e":"itXks","1e8e447afb4d169c":"42cTS","8a4a19af97836d80":"2m4It","26720f9d94c9e268":"yj4S4","7b6429a248ecc51f":"epPN6","1368d0fa14524351":"6yArI","d50aa727d0f2adb8":"grrgb"}],"9Bo5k":[function(require,module,exports) {
/**
 * Implementation of a subset of node.js Buffer methods for the browser.
 * Based on https://github.com/feross/buffer
 */ /* eslint-disable no-proto */ "use strict";
var isArray = require("68dd619d064bfca2");
function typedArraySupport() {
    // Can typed array instances be augmented?
    try {
        var arr = new Uint8Array(1);
        arr.__proto__ = {
            __proto__: Uint8Array.prototype,
            foo: function() {
                return 42;
            }
        };
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Buffer.TYPED_ARRAY_SUPPORT = typedArraySupport();
var K_MAX_LENGTH = Buffer.TYPED_ARRAY_SUPPORT ? 0x7fffffff : 0x3fffffff;
function Buffer(arg, offset, length) {
    if (!Buffer.TYPED_ARRAY_SUPPORT && !(this instanceof Buffer)) return new Buffer(arg, offset, length);
    if (typeof arg === "number") return allocUnsafe(this, arg);
    return from(this, arg, offset, length);
}
if (Buffer.TYPED_ARRAY_SUPPORT) {
    Buffer.prototype.__proto__ = Uint8Array.prototype;
    Buffer.__proto__ = Uint8Array;
    // Fix subarray() in ES2016. See: https://github.com/feross/buffer/pull/97
    if (typeof Symbol !== "undefined" && Symbol.species && Buffer[Symbol.species] === Buffer) Object.defineProperty(Buffer, Symbol.species, {
        value: null,
        configurable: true,
        enumerable: false,
        writable: false
    });
}
function checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + K_MAX_LENGTH.toString(16) + " bytes");
    return length | 0;
}
function isnan(val) {
    return val !== val // eslint-disable-line no-self-compare
    ;
}
function createBuffer(that, length) {
    var buf;
    if (Buffer.TYPED_ARRAY_SUPPORT) {
        buf = new Uint8Array(length);
        buf.__proto__ = Buffer.prototype;
    } else {
        // Fallback: Return an object instance of the Buffer class
        buf = that;
        if (buf === null) buf = new Buffer(length);
        buf.length = length;
    }
    return buf;
}
function allocUnsafe(that, size) {
    var buf = createBuffer(that, size < 0 ? 0 : checked(size) | 0);
    if (!Buffer.TYPED_ARRAY_SUPPORT) for(var i = 0; i < size; ++i)buf[i] = 0;
    return buf;
}
function fromString(that, string) {
    var length = byteLength(string) | 0;
    var buf = createBuffer(that, length);
    var actual = buf.write(string);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function fromArrayLike(that, array) {
    var length = array.length < 0 ? 0 : checked(array.length) | 0;
    var buf = createBuffer(that, length);
    for(var i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function fromArrayBuffer(that, array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError("'offset' is out of bounds");
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError("'length' is out of bounds");
    var buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    if (Buffer.TYPED_ARRAY_SUPPORT) // Return an augmented `Uint8Array` instance, for best performance
    buf.__proto__ = Buffer.prototype;
    else // Fallback: Return an object instance of the Buffer class
    buf = fromArrayLike(that, buf);
    return buf;
}
function fromObject(that, obj) {
    if (Buffer.isBuffer(obj)) {
        var len = checked(obj.length) | 0;
        var buf = createBuffer(that, len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj) {
        if (typeof ArrayBuffer !== "undefined" && obj.buffer instanceof ArrayBuffer || "length" in obj) {
            if (typeof obj.length !== "number" || isnan(obj.length)) return createBuffer(that, 0);
            return fromArrayLike(that, obj);
        }
        if (obj.type === "Buffer" && Array.isArray(obj.data)) return fromArrayLike(that, obj.data);
    }
    throw new TypeError("First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.");
}
function utf8ToBytes(string, units) {
    units = units || Infinity;
    var codePoint;
    var length = string.length;
    var leadSurrogate = null;
    var bytes = [];
    for(var i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error("Invalid code point");
    }
    return bytes;
}
function byteLength(string) {
    if (Buffer.isBuffer(string)) return string.length;
    if (typeof ArrayBuffer !== "undefined" && typeof ArrayBuffer.isView === "function" && (ArrayBuffer.isView(string) || string instanceof ArrayBuffer)) return string.byteLength;
    if (typeof string !== "string") string = "" + string;
    var len = string.length;
    if (len === 0) return 0;
    return utf8ToBytes(string).length;
}
function blitBuffer(src, dst, offset, length) {
    for(var i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
function utf8Write(buf, string, offset, length) {
    return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function from(that, value, offset, length) {
    if (typeof value === "number") throw new TypeError('"value" argument must not be a number');
    if (typeof ArrayBuffer !== "undefined" && value instanceof ArrayBuffer) return fromArrayBuffer(that, value, offset, length);
    if (typeof value === "string") return fromString(that, value, offset);
    return fromObject(that, value);
}
Buffer.prototype.write = function write(string, offset, length) {
    // Buffer#write(string)
    if (offset === undefined) {
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === "string") {
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length])
    } else if (isFinite(offset)) {
        offset = offset | 0;
        if (isFinite(length)) length = length | 0;
        else length = undefined;
    }
    var remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError("Attempt to write outside buffer bounds");
    return utf8Write(this, string, offset, length);
};
Buffer.prototype.slice = function slice(start, end) {
    var len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    var newBuf;
    if (Buffer.TYPED_ARRAY_SUPPORT) {
        newBuf = this.subarray(start, end);
        // Return an augmented `Uint8Array` instance
        newBuf.__proto__ = Buffer.prototype;
    } else {
        var sliceLen = end - start;
        newBuf = new Buffer(sliceLen, undefined);
        for(var i = 0; i < sliceLen; ++i)newBuf[i] = this[i + start];
    }
    return newBuf;
};
Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError("targetStart out of bounds");
    if (start < 0 || start >= this.length) throw new RangeError("sourceStart out of bounds");
    if (end < 0) throw new RangeError("sourceEnd out of bounds");
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    var len = end - start;
    var i;
    if (this === target && start < targetStart && targetStart < end) // descending copy from end
    for(i = len - 1; i >= 0; --i)target[i + targetStart] = this[i + start];
    else if (len < 1000 || !Buffer.TYPED_ARRAY_SUPPORT) // ascending copy from start
    for(i = 0; i < len; ++i)target[i + targetStart] = this[i + start];
    else Uint8Array.prototype.set.call(target, this.subarray(start, start + len), targetStart);
    return len;
};
Buffer.prototype.fill = function fill(val, start, end) {
    // Handle string cases:
    if (typeof val === "string") {
        if (typeof start === "string") {
            start = 0;
            end = this.length;
        } else if (typeof end === "string") end = this.length;
        if (val.length === 1) {
            var code = val.charCodeAt(0);
            if (code < 256) val = code;
        }
    } else if (typeof val === "number") val = val & 255;
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError("Out of range index");
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    var i;
    if (typeof val === "number") for(i = start; i < end; ++i)this[i] = val;
    else {
        var bytes = Buffer.isBuffer(val) ? val : new Buffer(val);
        var len = bytes.length;
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
Buffer.concat = function concat(list, length) {
    if (!isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return createBuffer(null, 0);
    var i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    var buffer = allocUnsafe(null, length);
    var pos = 0;
    for(i = 0; i < list.length; ++i){
        var buf = list[i];
        if (!Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
Buffer.byteLength = byteLength;
Buffer.prototype._isBuffer = true;
Buffer.isBuffer = function isBuffer(b) {
    return !!(b != null && b._isBuffer);
};
module.exports.alloc = function(size) {
    var buffer = new Buffer(size);
    buffer.fill(0);
    return buffer;
};
module.exports.from = function(data) {
    return new Buffer(data);
};

},{"68dd619d064bfca2":"grrgb"}],"grrgb":[function(require,module,exports) {
var toString = {}.toString;
module.exports = Array.isArray || function(arr) {
    return toString.call(arr) == "[object Array]";
};

},{}],"bCvEH":[function(require,module,exports) {
var toSJISFunction;
var CODEWORDS_COUNT = [
    0,
    26,
    44,
    70,
    100,
    134,
    172,
    196,
    242,
    292,
    346,
    404,
    466,
    532,
    581,
    655,
    733,
    815,
    901,
    991,
    1085,
    1156,
    1258,
    1364,
    1474,
    1588,
    1706,
    1828,
    1921,
    2051,
    2185,
    2323,
    2465,
    2611,
    2761,
    2876,
    3034,
    3196,
    3362,
    3532,
    3706
];
/**
 * Returns the QR Code size for the specified version
 *
 * @param  {Number} version QR Code version
 * @return {Number}         size of QR code
 */ exports.getSymbolSize = function getSymbolSize(version) {
    if (!version) throw new Error('"version" cannot be null or undefined');
    if (version < 1 || version > 40) throw new Error('"version" should be in range from 1 to 40');
    return version * 4 + 17;
};
/**
 * Returns the total number of codewords used to store data and EC information.
 *
 * @param  {Number} version QR Code version
 * @return {Number}         Data length in bits
 */ exports.getSymbolTotalCodewords = function getSymbolTotalCodewords(version) {
    return CODEWORDS_COUNT[version];
};
/**
 * Encode data with Bose-Chaudhuri-Hocquenghem
 *
 * @param  {Number} data Value to encode
 * @return {Number}      Encoded value
 */ exports.getBCHDigit = function(data) {
    var digit = 0;
    while(data !== 0){
        digit++;
        data >>>= 1;
    }
    return digit;
};
exports.setToSJISFunction = function setToSJISFunction(f) {
    if (typeof f !== "function") throw new Error('"toSJISFunc" is not a valid function.');
    toSJISFunction = f;
};
exports.isKanjiModeEnabled = function() {
    return typeof toSJISFunction !== "undefined";
};
exports.toSJIS = function toSJIS(kanji) {
    return toSJISFunction(kanji);
};

},{}],"fnt1n":[function(require,module,exports) {
exports.L = {
    bit: 1
};
exports.M = {
    bit: 0
};
exports.Q = {
    bit: 3
};
exports.H = {
    bit: 2
};
function fromString(string) {
    if (typeof string !== "string") throw new Error("Param is not a string");
    var lcStr = string.toLowerCase();
    switch(lcStr){
        case "l":
        case "low":
            return exports.L;
        case "m":
        case "medium":
            return exports.M;
        case "q":
        case "quartile":
            return exports.Q;
        case "h":
        case "high":
            return exports.H;
        default:
            throw new Error("Unknown EC Level: " + string);
    }
}
exports.isValid = function isValid(level) {
    return level && typeof level.bit !== "undefined" && level.bit >= 0 && level.bit < 4;
};
exports.from = function from(value, defaultValue) {
    if (exports.isValid(value)) return value;
    try {
        return fromString(value);
    } catch (e) {
        return defaultValue;
    }
};

},{}],"2giyh":[function(require,module,exports) {
function BitBuffer() {
    this.buffer = [];
    this.length = 0;
}
BitBuffer.prototype = {
    get: function(index) {
        var bufIndex = Math.floor(index / 8);
        return (this.buffer[bufIndex] >>> 7 - index % 8 & 1) === 1;
    },
    put: function(num, length) {
        for(var i = 0; i < length; i++)this.putBit((num >>> length - i - 1 & 1) === 1);
    },
    getLengthInBits: function() {
        return this.length;
    },
    putBit: function(bit) {
        var bufIndex = Math.floor(this.length / 8);
        if (this.buffer.length <= bufIndex) this.buffer.push(0);
        if (bit) this.buffer[bufIndex] |= 0x80 >>> this.length % 8;
        this.length++;
    }
};
module.exports = BitBuffer;

},{}],"4ozmv":[function(require,module,exports) {
var BufferUtil = require("f334bd59b9babd0f");
/**
 * Helper class to handle QR Code symbol modules
 *
 * @param {Number} size Symbol size
 */ function BitMatrix(size) {
    if (!size || size < 1) throw new Error("BitMatrix size must be defined and greater than 0");
    this.size = size;
    this.data = BufferUtil.alloc(size * size);
    this.reservedBit = BufferUtil.alloc(size * size);
}
/**
 * Set bit value at specified location
 * If reserved flag is set, this bit will be ignored during masking process
 *
 * @param {Number}  row
 * @param {Number}  col
 * @param {Boolean} value
 * @param {Boolean} reserved
 */ BitMatrix.prototype.set = function(row, col, value, reserved) {
    var index = row * this.size + col;
    this.data[index] = value;
    if (reserved) this.reservedBit[index] = true;
};
/**
 * Returns bit value at specified location
 *
 * @param  {Number}  row
 * @param  {Number}  col
 * @return {Boolean}
 */ BitMatrix.prototype.get = function(row, col) {
    return this.data[row * this.size + col];
};
/**
 * Applies xor operator at specified location
 * (used during masking process)
 *
 * @param {Number}  row
 * @param {Number}  col
 * @param {Boolean} value
 */ BitMatrix.prototype.xor = function(row, col, value) {
    this.data[row * this.size + col] ^= value;
};
/**
 * Check if bit at specified location is reserved
 *
 * @param {Number}   row
 * @param {Number}   col
 * @return {Boolean}
 */ BitMatrix.prototype.isReserved = function(row, col) {
    return this.reservedBit[row * this.size + col];
};
module.exports = BitMatrix;

},{"f334bd59b9babd0f":"9Bo5k"}],"jgRzo":[function(require,module,exports) {
/**
 * Alignment pattern are fixed reference pattern in defined positions
 * in a matrix symbology, which enables the decode software to re-synchronise
 * the coordinate mapping of the image modules in the event of moderate amounts
 * of distortion of the image.
 *
 * Alignment patterns are present only in QR Code symbols of version 2 or larger
 * and their number depends on the symbol version.
 */ var getSymbolSize = require("3fa093180e62a22a").getSymbolSize;
/**
 * Calculate the row/column coordinates of the center module of each alignment pattern
 * for the specified QR Code version.
 *
 * The alignment patterns are positioned symmetrically on either side of the diagonal
 * running from the top left corner of the symbol to the bottom right corner.
 *
 * Since positions are simmetrical only half of the coordinates are returned.
 * Each item of the array will represent in turn the x and y coordinate.
 * @see {@link getPositions}
 *
 * @param  {Number} version QR Code version
 * @return {Array}          Array of coordinate
 */ exports.getRowColCoords = function getRowColCoords(version) {
    if (version === 1) return [];
    var posCount = Math.floor(version / 7) + 2;
    var size = getSymbolSize(version);
    var intervals = size === 145 ? 26 : Math.ceil((size - 13) / (2 * posCount - 2)) * 2;
    var positions = [
        size - 7
    ] // Last coord is always (size - 7)
    ;
    for(var i = 1; i < posCount - 1; i++)positions[i] = positions[i - 1] - intervals;
    positions.push(6) // First coord is always 6
    ;
    return positions.reverse();
};
/**
 * Returns an array containing the positions of each alignment pattern.
 * Each array's element represent the center point of the pattern as (x, y) coordinates
 *
 * Coordinates are calculated expanding the row/column coordinates returned by {@link getRowColCoords}
 * and filtering out the items that overlaps with finder pattern
 *
 * @example
 * For a Version 7 symbol {@link getRowColCoords} returns values 6, 22 and 38.
 * The alignment patterns, therefore, are to be centered on (row, column)
 * positions (6,22), (22,6), (22,22), (22,38), (38,22), (38,38).
 * Note that the coordinates (6,6), (6,38), (38,6) are occupied by finder patterns
 * and are not therefore used for alignment patterns.
 *
 * var pos = getPositions(7)
 * // [[6,22], [22,6], [22,22], [22,38], [38,22], [38,38]]
 *
 * @param  {Number} version QR Code version
 * @return {Array}          Array of coordinates
 */ exports.getPositions = function getPositions(version) {
    var coords = [];
    var pos = exports.getRowColCoords(version);
    var posLength = pos.length;
    for(var i = 0; i < posLength; i++)for(var j = 0; j < posLength; j++){
        // Skip if position is occupied by finder patterns
        if (i === 0 && j === 0 || // top-left
        i === 0 && j === posLength - 1 || // bottom-left
        i === posLength - 1 && j === 0) continue;
        coords.push([
            pos[i],
            pos[j]
        ]);
    }
    return coords;
};

},{"3fa093180e62a22a":"bCvEH"}],"1Qw2I":[function(require,module,exports) {
var getSymbolSize = require("6ec9ae5660047293").getSymbolSize;
var FINDER_PATTERN_SIZE = 7;
/**
 * Returns an array containing the positions of each finder pattern.
 * Each array's element represent the top-left point of the pattern as (x, y) coordinates
 *
 * @param  {Number} version QR Code version
 * @return {Array}          Array of coordinates
 */ exports.getPositions = function getPositions(version) {
    var size = getSymbolSize(version);
    return [
        // top-left
        [
            0,
            0
        ],
        // top-right
        [
            size - FINDER_PATTERN_SIZE,
            0
        ],
        // bottom-left
        [
            0,
            size - FINDER_PATTERN_SIZE
        ]
    ];
};

},{"6ec9ae5660047293":"bCvEH"}],"1BUGW":[function(require,module,exports) {
/**
 * Data mask pattern reference
 * @type {Object}
 */ exports.Patterns = {
    PATTERN000: 0,
    PATTERN001: 1,
    PATTERN010: 2,
    PATTERN011: 3,
    PATTERN100: 4,
    PATTERN101: 5,
    PATTERN110: 6,
    PATTERN111: 7
};
/**
 * Weighted penalty scores for the undesirable features
 * @type {Object}
 */ var PenaltyScores = {
    N1: 3,
    N2: 3,
    N3: 40,
    N4: 10
};
/**
 * Check if mask pattern value is valid
 *
 * @param  {Number}  mask    Mask pattern
 * @return {Boolean}         true if valid, false otherwise
 */ exports.isValid = function isValid(mask) {
    return mask != null && mask !== "" && !isNaN(mask) && mask >= 0 && mask <= 7;
};
/**
 * Returns mask pattern from a value.
 * If value is not valid, returns undefined
 *
 * @param  {Number|String} value        Mask pattern value
 * @return {Number}                     Valid mask pattern or undefined
 */ exports.from = function from(value) {
    return exports.isValid(value) ? parseInt(value, 10) : undefined;
};
/**
* Find adjacent modules in row/column with the same color
* and assign a penalty value.
*
* Points: N1 + i
* i is the amount by which the number of adjacent modules of the same color exceeds 5
*/ exports.getPenaltyN1 = function getPenaltyN1(data) {
    var size = data.size;
    var points = 0;
    var sameCountCol = 0;
    var sameCountRow = 0;
    var lastCol = null;
    var lastRow = null;
    for(var row = 0; row < size; row++){
        sameCountCol = sameCountRow = 0;
        lastCol = lastRow = null;
        for(var col = 0; col < size; col++){
            var module = data.get(row, col);
            if (module === lastCol) sameCountCol++;
            else {
                if (sameCountCol >= 5) points += PenaltyScores.N1 + (sameCountCol - 5);
                lastCol = module;
                sameCountCol = 1;
            }
            module = data.get(col, row);
            if (module === lastRow) sameCountRow++;
            else {
                if (sameCountRow >= 5) points += PenaltyScores.N1 + (sameCountRow - 5);
                lastRow = module;
                sameCountRow = 1;
            }
        }
        if (sameCountCol >= 5) points += PenaltyScores.N1 + (sameCountCol - 5);
        if (sameCountRow >= 5) points += PenaltyScores.N1 + (sameCountRow - 5);
    }
    return points;
};
/**
 * Find 2x2 blocks with the same color and assign a penalty value
 *
 * Points: N2 * (m - 1) * (n - 1)
 */ exports.getPenaltyN2 = function getPenaltyN2(data) {
    var size = data.size;
    var points = 0;
    for(var row = 0; row < size - 1; row++)for(var col = 0; col < size - 1; col++){
        var last = data.get(row, col) + data.get(row, col + 1) + data.get(row + 1, col) + data.get(row + 1, col + 1);
        if (last === 4 || last === 0) points++;
    }
    return points * PenaltyScores.N2;
};
/**
 * Find 1:1:3:1:1 ratio (dark:light:dark:light:dark) pattern in row/column,
 * preceded or followed by light area 4 modules wide
 *
 * Points: N3 * number of pattern found
 */ exports.getPenaltyN3 = function getPenaltyN3(data) {
    var size = data.size;
    var points = 0;
    var bitsCol = 0;
    var bitsRow = 0;
    for(var row = 0; row < size; row++){
        bitsCol = bitsRow = 0;
        for(var col = 0; col < size; col++){
            bitsCol = bitsCol << 1 & 0x7FF | data.get(row, col);
            if (col >= 10 && (bitsCol === 0x5D0 || bitsCol === 0x05D)) points++;
            bitsRow = bitsRow << 1 & 0x7FF | data.get(col, row);
            if (col >= 10 && (bitsRow === 0x5D0 || bitsRow === 0x05D)) points++;
        }
    }
    return points * PenaltyScores.N3;
};
/**
 * Calculate proportion of dark modules in entire symbol
 *
 * Points: N4 * k
 *
 * k is the rating of the deviation of the proportion of dark modules
 * in the symbol from 50% in steps of 5%
 */ exports.getPenaltyN4 = function getPenaltyN4(data) {
    var darkCount = 0;
    var modulesCount = data.data.length;
    for(var i = 0; i < modulesCount; i++)darkCount += data.data[i];
    var k = Math.abs(Math.ceil(darkCount * 100 / modulesCount / 5) - 10);
    return k * PenaltyScores.N4;
};
/**
 * Return mask value at given position
 *
 * @param  {Number} maskPattern Pattern reference value
 * @param  {Number} i           Row
 * @param  {Number} j           Column
 * @return {Boolean}            Mask value
 */ function getMaskAt(maskPattern, i, j) {
    switch(maskPattern){
        case exports.Patterns.PATTERN000:
            return (i + j) % 2 === 0;
        case exports.Patterns.PATTERN001:
            return i % 2 === 0;
        case exports.Patterns.PATTERN010:
            return j % 3 === 0;
        case exports.Patterns.PATTERN011:
            return (i + j) % 3 === 0;
        case exports.Patterns.PATTERN100:
            return (Math.floor(i / 2) + Math.floor(j / 3)) % 2 === 0;
        case exports.Patterns.PATTERN101:
            return i * j % 2 + i * j % 3 === 0;
        case exports.Patterns.PATTERN110:
            return (i * j % 2 + i * j % 3) % 2 === 0;
        case exports.Patterns.PATTERN111:
            return (i * j % 3 + (i + j) % 2) % 2 === 0;
        default:
            throw new Error("bad maskPattern:" + maskPattern);
    }
}
/**
 * Apply a mask pattern to a BitMatrix
 *
 * @param  {Number}    pattern Pattern reference number
 * @param  {BitMatrix} data    BitMatrix data
 */ exports.applyMask = function applyMask(pattern, data) {
    var size = data.size;
    for(var col = 0; col < size; col++)for(var row = 0; row < size; row++){
        if (data.isReserved(row, col)) continue;
        data.xor(row, col, getMaskAt(pattern, row, col));
    }
};
/**
 * Returns the best mask pattern for data
 *
 * @param  {BitMatrix} data
 * @return {Number} Mask pattern reference number
 */ exports.getBestMask = function getBestMask(data, setupFormatFunc) {
    var numPatterns = Object.keys(exports.Patterns).length;
    var bestPattern = 0;
    var lowerPenalty = Infinity;
    for(var p = 0; p < numPatterns; p++){
        setupFormatFunc(p);
        exports.applyMask(p, data);
        // Calculate penalty
        var penalty = exports.getPenaltyN1(data) + exports.getPenaltyN2(data) + exports.getPenaltyN3(data) + exports.getPenaltyN4(data);
        // Undo previously applied mask
        exports.applyMask(p, data);
        if (penalty < lowerPenalty) {
            lowerPenalty = penalty;
            bestPattern = p;
        }
    }
    return bestPattern;
};

},{}],"itXks":[function(require,module,exports) {
var ECLevel = require("7baaa530584d1bc4");
var EC_BLOCKS_TABLE = [
    // L  M  Q  H
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    2,
    2,
    1,
    2,
    2,
    4,
    1,
    2,
    4,
    4,
    2,
    4,
    4,
    4,
    2,
    4,
    6,
    5,
    2,
    4,
    6,
    6,
    2,
    5,
    8,
    8,
    4,
    5,
    8,
    8,
    4,
    5,
    8,
    11,
    4,
    8,
    10,
    11,
    4,
    9,
    12,
    16,
    4,
    9,
    16,
    16,
    6,
    10,
    12,
    18,
    6,
    10,
    17,
    16,
    6,
    11,
    16,
    19,
    6,
    13,
    18,
    21,
    7,
    14,
    21,
    25,
    8,
    16,
    20,
    25,
    8,
    17,
    23,
    25,
    9,
    17,
    23,
    34,
    9,
    18,
    25,
    30,
    10,
    20,
    27,
    32,
    12,
    21,
    29,
    35,
    12,
    23,
    34,
    37,
    12,
    25,
    34,
    40,
    13,
    26,
    35,
    42,
    14,
    28,
    38,
    45,
    15,
    29,
    40,
    48,
    16,
    31,
    43,
    51,
    17,
    33,
    45,
    54,
    18,
    35,
    48,
    57,
    19,
    37,
    51,
    60,
    19,
    38,
    53,
    63,
    20,
    40,
    56,
    66,
    21,
    43,
    59,
    70,
    22,
    45,
    62,
    74,
    24,
    47,
    65,
    77,
    25,
    49,
    68,
    81
];
var EC_CODEWORDS_TABLE = [
    // L  M  Q  H
    7,
    10,
    13,
    17,
    10,
    16,
    22,
    28,
    15,
    26,
    36,
    44,
    20,
    36,
    52,
    64,
    26,
    48,
    72,
    88,
    36,
    64,
    96,
    112,
    40,
    72,
    108,
    130,
    48,
    88,
    132,
    156,
    60,
    110,
    160,
    192,
    72,
    130,
    192,
    224,
    80,
    150,
    224,
    264,
    96,
    176,
    260,
    308,
    104,
    198,
    288,
    352,
    120,
    216,
    320,
    384,
    132,
    240,
    360,
    432,
    144,
    280,
    408,
    480,
    168,
    308,
    448,
    532,
    180,
    338,
    504,
    588,
    196,
    364,
    546,
    650,
    224,
    416,
    600,
    700,
    224,
    442,
    644,
    750,
    252,
    476,
    690,
    816,
    270,
    504,
    750,
    900,
    300,
    560,
    810,
    960,
    312,
    588,
    870,
    1050,
    336,
    644,
    952,
    1110,
    360,
    700,
    1020,
    1200,
    390,
    728,
    1050,
    1260,
    420,
    784,
    1140,
    1350,
    450,
    812,
    1200,
    1440,
    480,
    868,
    1290,
    1530,
    510,
    924,
    1350,
    1620,
    540,
    980,
    1440,
    1710,
    570,
    1036,
    1530,
    1800,
    570,
    1064,
    1590,
    1890,
    600,
    1120,
    1680,
    1980,
    630,
    1204,
    1770,
    2100,
    660,
    1260,
    1860,
    2220,
    720,
    1316,
    1950,
    2310,
    750,
    1372,
    2040,
    2430
];
/**
 * Returns the number of error correction block that the QR Code should contain
 * for the specified version and error correction level.
 *
 * @param  {Number} version              QR Code version
 * @param  {Number} errorCorrectionLevel Error correction level
 * @return {Number}                      Number of error correction blocks
 */ exports.getBlocksCount = function getBlocksCount(version, errorCorrectionLevel) {
    switch(errorCorrectionLevel){
        case ECLevel.L:
            return EC_BLOCKS_TABLE[(version - 1) * 4 + 0];
        case ECLevel.M:
            return EC_BLOCKS_TABLE[(version - 1) * 4 + 1];
        case ECLevel.Q:
            return EC_BLOCKS_TABLE[(version - 1) * 4 + 2];
        case ECLevel.H:
            return EC_BLOCKS_TABLE[(version - 1) * 4 + 3];
        default:
            return undefined;
    }
};
/**
 * Returns the number of error correction codewords to use for the specified
 * version and error correction level.
 *
 * @param  {Number} version              QR Code version
 * @param  {Number} errorCorrectionLevel Error correction level
 * @return {Number}                      Number of error correction codewords
 */ exports.getTotalCodewordsCount = function getTotalCodewordsCount(version, errorCorrectionLevel) {
    switch(errorCorrectionLevel){
        case ECLevel.L:
            return EC_CODEWORDS_TABLE[(version - 1) * 4 + 0];
        case ECLevel.M:
            return EC_CODEWORDS_TABLE[(version - 1) * 4 + 1];
        case ECLevel.Q:
            return EC_CODEWORDS_TABLE[(version - 1) * 4 + 2];
        case ECLevel.H:
            return EC_CODEWORDS_TABLE[(version - 1) * 4 + 3];
        default:
            return undefined;
    }
};

},{"7baaa530584d1bc4":"fnt1n"}],"42cTS":[function(require,module,exports) {
var BufferUtil = require("9f7ddce3d4344eb5");
var Polynomial = require("742a7ee6d6a2d145");
var Buffer = require("7fd2d51dcfce04d5").Buffer;
function ReedSolomonEncoder(degree) {
    this.genPoly = undefined;
    this.degree = degree;
    if (this.degree) this.initialize(this.degree);
}
/**
 * Initialize the encoder.
 * The input param should correspond to the number of error correction codewords.
 *
 * @param  {Number} degree
 */ ReedSolomonEncoder.prototype.initialize = function initialize(degree) {
    // create an irreducible generator polynomial
    this.degree = degree;
    this.genPoly = Polynomial.generateECPolynomial(this.degree);
};
/**
 * Encodes a chunk of data
 *
 * @param  {Buffer} data Buffer containing input data
 * @return {Buffer}      Buffer containing encoded data
 */ ReedSolomonEncoder.prototype.encode = function encode(data) {
    if (!this.genPoly) throw new Error("Encoder not initialized");
    // Calculate EC for this data block
    // extends data size to data+genPoly size
    var pad = BufferUtil.alloc(this.degree);
    var paddedData = Buffer.concat([
        data,
        pad
    ], data.length + this.degree);
    // The error correction codewords are the remainder after dividing the data codewords
    // by a generator polynomial
    var remainder = Polynomial.mod(paddedData, this.genPoly);
    // return EC data blocks (last n byte, where n is the degree of genPoly)
    // If coefficients number in remainder are less than genPoly degree,
    // pad with 0s to the left to reach the needed number of coefficients
    var start = this.degree - remainder.length;
    if (start > 0) {
        var buff = BufferUtil.alloc(this.degree);
        remainder.copy(buff, start);
        return buff;
    }
    return remainder;
};
module.exports = ReedSolomonEncoder;

},{"9f7ddce3d4344eb5":"9Bo5k","742a7ee6d6a2d145":"gZ2nu","7fd2d51dcfce04d5":"7sF06"}],"gZ2nu":[function(require,module,exports) {
var BufferUtil = require("238ca0bf1cae0aff");
var GF = require("780c74029318268c");
/**
 * Multiplies two polynomials inside Galois Field
 *
 * @param  {Buffer} p1 Polynomial
 * @param  {Buffer} p2 Polynomial
 * @return {Buffer}    Product of p1 and p2
 */ exports.mul = function mul(p1, p2) {
    var coeff = BufferUtil.alloc(p1.length + p2.length - 1);
    for(var i = 0; i < p1.length; i++)for(var j = 0; j < p2.length; j++)coeff[i + j] ^= GF.mul(p1[i], p2[j]);
    return coeff;
};
/**
 * Calculate the remainder of polynomials division
 *
 * @param  {Buffer} divident Polynomial
 * @param  {Buffer} divisor  Polynomial
 * @return {Buffer}          Remainder
 */ exports.mod = function mod(divident, divisor) {
    var result = BufferUtil.from(divident);
    while(result.length - divisor.length >= 0){
        var coeff = result[0];
        for(var i = 0; i < divisor.length; i++)result[i] ^= GF.mul(divisor[i], coeff);
        // remove all zeros from buffer head
        var offset = 0;
        while(offset < result.length && result[offset] === 0)offset++;
        result = result.slice(offset);
    }
    return result;
};
/**
 * Generate an irreducible generator polynomial of specified degree
 * (used by Reed-Solomon encoder)
 *
 * @param  {Number} degree Degree of the generator polynomial
 * @return {Buffer}        Buffer containing polynomial coefficients
 */ exports.generateECPolynomial = function generateECPolynomial(degree) {
    var poly = BufferUtil.from([
        1
    ]);
    for(var i = 0; i < degree; i++)poly = exports.mul(poly, [
        1,
        GF.exp(i)
    ]);
    return poly;
};

},{"238ca0bf1cae0aff":"9Bo5k","780c74029318268c":"dLsI5"}],"dLsI5":[function(require,module,exports) {
var BufferUtil = require("312c74d968429500");
var EXP_TABLE = BufferUtil.alloc(512);
var LOG_TABLE = BufferUtil.alloc(256) /**
 * Precompute the log and anti-log tables for faster computation later
 *
 * For each possible value in the galois field 2^8, we will pre-compute
 * the logarithm and anti-logarithm (exponential) of this value
 *
 * ref {@link https://en.wikiversity.org/wiki/Reed%E2%80%93Solomon_codes_for_coders#Introduction_to_mathematical_fields}
 */ ;
(function initTables() {
    var x = 1;
    for(var i = 0; i < 255; i++){
        EXP_TABLE[i] = x;
        LOG_TABLE[x] = i;
        x <<= 1 // multiply by 2
        ;
        // The QR code specification says to use byte-wise modulo 100011101 arithmetic.
        // This means that when a number is 256 or larger, it should be XORed with 0x11D.
        if (x & 0x100) x ^= 0x11D;
    }
    // Optimization: double the size of the anti-log table so that we don't need to mod 255 to
    // stay inside the bounds (because we will mainly use this table for the multiplication of
    // two GF numbers, no more).
    // @see {@link mul}
    for(i = 255; i < 512; i++)EXP_TABLE[i] = EXP_TABLE[i - 255];
})();
/**
 * Returns log value of n inside Galois Field
 *
 * @param  {Number} n
 * @return {Number}
 */ exports.log = function log(n) {
    if (n < 1) throw new Error("log(" + n + ")");
    return LOG_TABLE[n];
};
/**
 * Returns anti-log value of n inside Galois Field
 *
 * @param  {Number} n
 * @return {Number}
 */ exports.exp = function exp(n) {
    return EXP_TABLE[n];
};
/**
 * Multiplies two number inside Galois Field
 *
 * @param  {Number} x
 * @param  {Number} y
 * @return {Number}
 */ exports.mul = function mul(x, y) {
    if (x === 0 || y === 0) return 0;
    // should be EXP_TABLE[(LOG_TABLE[x] + LOG_TABLE[y]) % 255] if EXP_TABLE wasn't oversized
    // @see {@link initTables}
    return EXP_TABLE[LOG_TABLE[x] + LOG_TABLE[y]];
};

},{"312c74d968429500":"9Bo5k"}],"7sF06":[function(require,module,exports) {
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ "use strict";
var base64 = require("f201c59517675e58");
var ieee754 = require("bf37355d142c22ae");
var customInspectSymbol = typeof Symbol === "function" && typeof Symbol["for"] === "function" // eslint-disable-line dot-notation
 ? Symbol["for"]("nodejs.util.inspect.custom") // eslint-disable-line dot-notation
 : null;
exports.Buffer = Buffer;
exports.SlowBuffer = SlowBuffer;
exports.INSPECT_MAX_BYTES = 50;
var K_MAX_LENGTH = 0x7fffffff;
exports.kMaxLength = K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ Buffer.TYPED_ARRAY_SUPPORT = typedArraySupport();
if (!Buffer.TYPED_ARRAY_SUPPORT && typeof console !== "undefined" && typeof console.error === "function") console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        var arr = new Uint8Array(1);
        var proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty(Buffer.prototype, "parent", {
    enumerable: true,
    get: function() {
        if (!Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty(Buffer.prototype, "offset", {
    enumerable: true,
    get: function() {
        if (!Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function createBuffer(length) {
    if (length > K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    var buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === "number") {
        if (typeof encodingOrOffset === "string") throw new TypeError('The "string" argument must be of type string. Received type number');
        return allocUnsafe(arg);
    }
    return from(arg, encodingOrOffset, length);
}
Buffer.poolSize = 8192 // not used by this implementation
;
function from(value, encodingOrOffset, length) {
    if (typeof value === "string") return fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if (isInstance(value, ArrayBuffer) || value && isInstance(value.buffer, ArrayBuffer)) return fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== "undefined" && (isInstance(value, SharedArrayBuffer) || value && isInstance(value.buffer, SharedArrayBuffer))) return fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === "number") throw new TypeError('The "value" argument must not be of type number. Received type number');
    var valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return Buffer.from(valueOf, encodingOrOffset, length);
    var b = fromObject(value);
    if (b) return b;
    if (typeof Symbol !== "undefined" && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === "function") return Buffer.from(value[Symbol.toPrimitive]("string"), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ Buffer.from = function(value, encodingOrOffset, length) {
    return from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf(Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf(Buffer, Uint8Array);
function assertSize(size) {
    if (typeof size !== "number") throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function alloc(size, fill, encoding) {
    assertSize(size);
    if (size <= 0) return createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === "string" ? createBuffer(size).fill(fill, encoding) : createBuffer(size).fill(fill);
    return createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ Buffer.alloc = function(size, fill, encoding) {
    return alloc(size, fill, encoding);
};
function allocUnsafe(size) {
    assertSize(size);
    return createBuffer(size < 0 ? 0 : checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ Buffer.allocUnsafe = function(size) {
    return allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ Buffer.allocUnsafeSlow = function(size) {
    return allocUnsafe(size);
};
function fromString(string, encoding) {
    if (typeof encoding !== "string" || encoding === "") encoding = "utf8";
    if (!Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
    var length = byteLength(string, encoding) | 0;
    var buf = createBuffer(length);
    var actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function fromArrayLike(array) {
    var length = array.length < 0 ? 0 : checked(array.length) | 0;
    var buf = createBuffer(length);
    for(var i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function fromArrayView(arrayView) {
    if (isInstance(arrayView, Uint8Array)) {
        var copy = new Uint8Array(arrayView);
        return fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return fromArrayLike(arrayView);
}
function fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    var buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, Buffer.prototype);
    return buf;
}
function fromObject(obj) {
    if (Buffer.isBuffer(obj)) {
        var len = checked(obj.length) | 0;
        var buf = createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== "number" || numberIsNaN(obj.length)) return createBuffer(0);
        return fromArrayLike(obj);
    }
    if (obj.type === "Buffer" && Array.isArray(obj.data)) return fromArrayLike(obj.data);
}
function checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + K_MAX_LENGTH.toString(16) + " bytes");
    return length | 0;
}
function SlowBuffer(length) {
    if (+length != length) length = 0;
    return Buffer.alloc(+length);
}
Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
Buffer.compare = function compare(a, b) {
    if (isInstance(a, Uint8Array)) a = Buffer.from(a, a.offset, a.byteLength);
    if (isInstance(b, Uint8Array)) b = Buffer.from(b, b.offset, b.byteLength);
    if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    var x = a.length;
    var y = b.length;
    for(var i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case "hex":
        case "utf8":
        case "utf-8":
        case "ascii":
        case "latin1":
        case "binary":
        case "base64":
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return true;
        default:
            return false;
    }
};
Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return Buffer.alloc(0);
    var i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    var buffer = Buffer.allocUnsafe(length);
    var pos = 0;
    for(i = 0; i < list.length; ++i){
        var buf = list[i];
        if (isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) Buffer.from(buf).copy(buffer, pos);
            else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function byteLength(string, encoding) {
    if (Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== "string") throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    var len = string.length;
    var mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    var loweredCase = false;
    for(;;)switch(encoding){
        case "ascii":
        case "latin1":
        case "binary":
            return len;
        case "utf8":
        case "utf-8":
            return utf8ToBytes(string).length;
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return len * 2;
        case "hex":
            return len >>> 1;
        case "base64":
            return base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : utf8ToBytes(string).length // assume utf8
            ;
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
}
Buffer.byteLength = byteLength;
function slowToString(encoding, start, end) {
    var loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return "";
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return "";
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return "";
    if (!encoding) encoding = "utf8";
    while(true)switch(encoding){
        case "hex":
            return hexSlice(this, start, end);
        case "utf8":
        case "utf-8":
            return utf8Slice(this, start, end);
        case "ascii":
            return asciiSlice(this, start, end);
        case "latin1":
        case "binary":
            return latin1Slice(this, start, end);
        case "base64":
            return base64Slice(this, start, end);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = (encoding + "").toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
Buffer.prototype._isBuffer = true;
function swap(b, n, m) {
    var i = b[n];
    b[n] = b[m];
    b[m] = i;
}
Buffer.prototype.swap16 = function swap16() {
    var len = this.length;
    if (len % 2 !== 0) throw new RangeError("Buffer size must be a multiple of 16-bits");
    for(var i = 0; i < len; i += 2)swap(this, i, i + 1);
    return this;
};
Buffer.prototype.swap32 = function swap32() {
    var len = this.length;
    if (len % 4 !== 0) throw new RangeError("Buffer size must be a multiple of 32-bits");
    for(var i = 0; i < len; i += 4){
        swap(this, i, i + 3);
        swap(this, i + 1, i + 2);
    }
    return this;
};
Buffer.prototype.swap64 = function swap64() {
    var len = this.length;
    if (len % 8 !== 0) throw new RangeError("Buffer size must be a multiple of 64-bits");
    for(var i = 0; i < len; i += 8){
        swap(this, i, i + 7);
        swap(this, i + 1, i + 6);
        swap(this, i + 2, i + 5);
        swap(this, i + 3, i + 4);
    }
    return this;
};
Buffer.prototype.toString = function toString() {
    var length = this.length;
    if (length === 0) return "";
    if (arguments.length === 0) return utf8Slice(this, 0, length);
    return slowToString.apply(this, arguments);
};
Buffer.prototype.toLocaleString = Buffer.prototype.toString;
Buffer.prototype.equals = function equals(b) {
    if (!Buffer.isBuffer(b)) throw new TypeError("Argument must be a Buffer");
    if (this === b) return true;
    return Buffer.compare(this, b) === 0;
};
Buffer.prototype.inspect = function inspect() {
    var str = "";
    var max = exports.INSPECT_MAX_BYTES;
    str = this.toString("hex", 0, max).replace(/(.{2})/g, "$1 ").trim();
    if (this.length > max) str += " ... ";
    return "<Buffer " + str + ">";
};
if (customInspectSymbol) Buffer.prototype[customInspectSymbol] = Buffer.prototype.inspect;
Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if (isInstance(target, Uint8Array)) target = Buffer.from(target, target.offset, target.byteLength);
    if (!Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError("out of range index");
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    var x = thisEnd - thisStart;
    var y = end - start;
    var len = Math.min(x, y);
    var thisCopy = this.slice(thisStart, thisEnd);
    var targetCopy = target.slice(start, end);
    for(var i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === "string") {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if (numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === "string") val = Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if (Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === "number") {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === "function") {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError("val must be string, number or Buffer");
}
function arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    var indexSize = 1;
    var arrLength = arr.length;
    var valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === "ucs2" || encoding === "ucs-2" || encoding === "utf16le" || encoding === "utf-16le") {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    var i;
    if (dir) {
        var foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            var found = true;
            for(var j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    var remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    var strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    for(var i = 0; i < length; ++i){
        var parsed = parseInt(string.substr(i * 2, 2), 16);
        if (numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function utf8Write(buf, string, offset, length) {
    return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function asciiWrite(buf, string, offset, length) {
    return blitBuffer(asciiToBytes(string), buf, offset, length);
}
function base64Write(buf, string, offset, length) {
    return blitBuffer(base64ToBytes(string), buf, offset, length);
}
function ucs2Write(buf, string, offset, length) {
    return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = "utf8";
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === "string") {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = "utf8";
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
    var remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError("Attempt to write outside buffer bounds");
    if (!encoding) encoding = "utf8";
    var loweredCase = false;
    for(;;)switch(encoding){
        case "hex":
            return hexWrite(this, string, offset, length);
        case "utf8":
        case "utf-8":
            return utf8Write(this, string, offset, length);
        case "ascii":
        case "latin1":
        case "binary":
            return asciiWrite(this, string, offset, length);
        case "base64":
            // Warning: maxLength not taken into account in base64Write
            return base64Write(this, string, offset, length);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
};
Buffer.prototype.toJSON = function toJSON() {
    return {
        type: "Buffer",
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return base64.fromByteArray(buf);
    else return base64.fromByteArray(buf.slice(start, end));
}
function utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    var res = [];
    var i = start;
    while(i < end){
        var firstByte = buf[i];
        var codePoint = null;
        var bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            var secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var MAX_ARGUMENTS_LENGTH = 0x1000;
function decodeCodePointsArray(codePoints) {
    var len = codePoints.length;
    if (len <= MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    var res = "";
    var i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH));
    return res;
}
function asciiSlice(buf, start, end) {
    var ret = "";
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function latin1Slice(buf, start, end) {
    var ret = "";
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function hexSlice(buf, start, end) {
    var len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    var out = "";
    for(var i = start; i < end; ++i)out += hexSliceLookupTable[buf[i]];
    return out;
}
function utf16leSlice(buf, start, end) {
    var bytes = buf.slice(start, end);
    var res = "";
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(var i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
Buffer.prototype.slice = function slice(start, end) {
    var len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    var newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError("offset is not uint");
    if (offset + ext > length) throw new RangeError("Trying to access beyond buffer length");
}
Buffer.prototype.readUintLE = Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
Buffer.prototype.readUintBE = Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) checkOffset(offset, byteLength, this.length);
    var val = this[offset + --byteLength];
    var mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
Buffer.prototype.readUint8 = Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 1, this.length);
    return this[offset];
};
Buffer.prototype.readUint16LE = Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
Buffer.prototype.readUint16BE = Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
Buffer.prototype.readUint32LE = Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
Buffer.prototype.readUint32BE = Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) checkOffset(offset, byteLength, this.length);
    var i = byteLength;
    var mul = 1;
    var val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 2, this.length);
    var val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 2, this.length);
    var val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 4, this.length);
    return ieee754.read(this, offset, true, 23, 4);
};
Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 4, this.length);
    return ieee754.read(this, offset, false, 23, 4);
};
Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 8, this.length);
    return ieee754.read(this, offset, true, 52, 8);
};
Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 8, this.length);
    return ieee754.read(this, offset, false, 52, 8);
};
function checkInt(buf, value, offset, ext, max, min) {
    if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
}
Buffer.prototype.writeUintLE = Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var mul = 1;
    var i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
Buffer.prototype.writeUintBE = Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var i = byteLength - 1;
    var mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
Buffer.prototype.writeUint8 = Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
Buffer.prototype.writeUint16LE = Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
Buffer.prototype.writeUint16BE = Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
Buffer.prototype.writeUint32LE = Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
Buffer.prototype.writeUint32BE = Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = 0;
    var mul = 1;
    var sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = byteLength - 1;
    var mul = 1;
    var sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
    if (offset < 0) throw new RangeError("Index out of range");
}
function writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    ieee754.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return writeFloat(this, value, offset, true, noAssert);
};
Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return writeFloat(this, value, offset, false, noAssert);
};
function writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    ieee754.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return writeDouble(this, value, offset, true, noAssert);
};
Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!Buffer.isBuffer(target)) throw new TypeError("argument should be a Buffer");
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError("targetStart out of bounds");
    if (start < 0 || start >= this.length) throw new RangeError("Index out of range");
    if (end < 0) throw new RangeError("sourceEnd out of bounds");
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    var len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === "function") // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === "string") {
        if (typeof start === "string") {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === "string") {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== "string") throw new TypeError("encoding must be a string");
        if (typeof encoding === "string" && !Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
        if (val.length === 1) {
            var code = val.charCodeAt(0);
            if (encoding === "utf8" && code < 128 || encoding === "latin1") // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === "number") val = val & 255;
    else if (typeof val === "boolean") val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError("Out of range index");
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    var i;
    if (typeof val === "number") for(i = start; i < end; ++i)this[i] = val;
    else {
        var bytes = Buffer.isBuffer(val) ? val : Buffer.from(val, encoding);
        var len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// HELPER FUNCTIONS
// ================
var INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split("=")[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace(INVALID_BASE64_RE, "");
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return "";
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + "=";
    return str;
}
function utf8ToBytes(string, units) {
    units = units || Infinity;
    var codePoint;
    var length = string.length;
    var leadSurrogate = null;
    var bytes = [];
    for(var i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error("Invalid code point");
    }
    return bytes;
}
function asciiToBytes(str) {
    var byteArray = [];
    for(var i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function utf16leToBytes(str, units) {
    var c, hi, lo;
    var byteArray = [];
    for(var i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function base64ToBytes(str) {
    return base64.toByteArray(base64clean(str));
}
function blitBuffer(src, dst, offset, length) {
    for(var i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
var hexSliceLookupTable = function() {
    var alphabet = "0123456789abcdef";
    var table = new Array(256);
    for(var i = 0; i < 16; ++i){
        var i16 = i * 16;
        for(var j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();

},{"f201c59517675e58":"6Pb1S","bf37355d142c22ae":"6ifNR"}],"2m4It":[function(require,module,exports) {
var Utils = require("f67b02cdf61cb7c6");
var ECCode = require("777da0d92c463f2e");
var ECLevel = require("acd5b4fcd696edf3");
var Mode = require("5303c314c4a688d7");
var VersionCheck = require("663d0e03da8b2897");
var isArray = require("f78c6f1197d3edb3");
// Generator polynomial used to encode version information
var G18 = 7973;
var G18_BCH = Utils.getBCHDigit(G18);
function getBestVersionForDataLength(mode, length, errorCorrectionLevel) {
    for(var currentVersion = 1; currentVersion <= 40; currentVersion++){
        if (length <= exports.getCapacity(currentVersion, errorCorrectionLevel, mode)) return currentVersion;
    }
    return undefined;
}
function getReservedBitsCount(mode, version) {
    // Character count indicator + mode indicator bits
    return Mode.getCharCountIndicator(mode, version) + 4;
}
function getTotalBitsFromDataArray(segments, version) {
    var totalBits = 0;
    segments.forEach(function(data) {
        var reservedBits = getReservedBitsCount(data.mode, version);
        totalBits += reservedBits + data.getBitsLength();
    });
    return totalBits;
}
function getBestVersionForMixedData(segments, errorCorrectionLevel) {
    for(var currentVersion = 1; currentVersion <= 40; currentVersion++){
        var length = getTotalBitsFromDataArray(segments, currentVersion);
        if (length <= exports.getCapacity(currentVersion, errorCorrectionLevel, Mode.MIXED)) return currentVersion;
    }
    return undefined;
}
/**
 * Returns version number from a value.
 * If value is not a valid version, returns defaultValue
 *
 * @param  {Number|String} value        QR Code version
 * @param  {Number}        defaultValue Fallback value
 * @return {Number}                     QR Code version number
 */ exports.from = function from(value, defaultValue) {
    if (VersionCheck.isValid(value)) return parseInt(value, 10);
    return defaultValue;
};
/**
 * Returns how much data can be stored with the specified QR code version
 * and error correction level
 *
 * @param  {Number} version              QR Code version (1-40)
 * @param  {Number} errorCorrectionLevel Error correction level
 * @param  {Mode}   mode                 Data mode
 * @return {Number}                      Quantity of storable data
 */ exports.getCapacity = function getCapacity(version, errorCorrectionLevel, mode) {
    if (!VersionCheck.isValid(version)) throw new Error("Invalid QR Code version");
    // Use Byte mode as default
    if (typeof mode === "undefined") mode = Mode.BYTE;
    // Total codewords for this QR code version (Data + Error correction)
    var totalCodewords = Utils.getSymbolTotalCodewords(version);
    // Total number of error correction codewords
    var ecTotalCodewords = ECCode.getTotalCodewordsCount(version, errorCorrectionLevel);
    // Total number of data codewords
    var dataTotalCodewordsBits = (totalCodewords - ecTotalCodewords) * 8;
    if (mode === Mode.MIXED) return dataTotalCodewordsBits;
    var usableBits = dataTotalCodewordsBits - getReservedBitsCount(mode, version);
    // Return max number of storable codewords
    switch(mode){
        case Mode.NUMERIC:
            return Math.floor(usableBits / 10 * 3);
        case Mode.ALPHANUMERIC:
            return Math.floor(usableBits / 11 * 2);
        case Mode.KANJI:
            return Math.floor(usableBits / 13);
        case Mode.BYTE:
        default:
            return Math.floor(usableBits / 8);
    }
};
/**
 * Returns the minimum version needed to contain the amount of data
 *
 * @param  {Segment} data                    Segment of data
 * @param  {Number} [errorCorrectionLevel=H] Error correction level
 * @param  {Mode} mode                       Data mode
 * @return {Number}                          QR Code version
 */ exports.getBestVersionForData = function getBestVersionForData(data, errorCorrectionLevel) {
    var seg;
    var ecl = ECLevel.from(errorCorrectionLevel, ECLevel.M);
    if (isArray(data)) {
        if (data.length > 1) return getBestVersionForMixedData(data, ecl);
        if (data.length === 0) return 1;
        seg = data[0];
    } else seg = data;
    return getBestVersionForDataLength(seg.mode, seg.getLength(), ecl);
};
/**
 * Returns version information with relative error correction bits
 *
 * The version information is included in QR Code symbols of version 7 or larger.
 * It consists of an 18-bit sequence containing 6 data bits,
 * with 12 error correction bits calculated using the (18, 6) Golay code.
 *
 * @param  {Number} version QR Code version
 * @return {Number}         Encoded version info bits
 */ exports.getEncodedBits = function getEncodedBits(version) {
    if (!VersionCheck.isValid(version) || version < 7) throw new Error("Invalid QR Code version");
    var d = version << 12;
    while(Utils.getBCHDigit(d) - G18_BCH >= 0)d ^= G18 << Utils.getBCHDigit(d) - G18_BCH;
    return version << 12 | d;
};

},{"f67b02cdf61cb7c6":"bCvEH","777da0d92c463f2e":"itXks","acd5b4fcd696edf3":"fnt1n","5303c314c4a688d7":"epPN6","663d0e03da8b2897":"i5bYU","f78c6f1197d3edb3":"grrgb"}],"epPN6":[function(require,module,exports) {
var VersionCheck = require("488660fac9162579");
var Regex = require("a23fd227d32f3622");
/**
 * Numeric mode encodes data from the decimal digit set (0 - 9)
 * (byte values 30HEX to 39HEX).
 * Normally, 3 data characters are represented by 10 bits.
 *
 * @type {Object}
 */ exports.NUMERIC = {
    id: "Numeric",
    bit: 1,
    ccBits: [
        10,
        12,
        14
    ]
};
/**
 * Alphanumeric mode encodes data from a set of 45 characters,
 * i.e. 10 numeric digits (0 - 9),
 *      26 alphabetic characters (A - Z),
 *   and 9 symbols (SP, $, %, *, +, -, ., /, :).
 * Normally, two input characters are represented by 11 bits.
 *
 * @type {Object}
 */ exports.ALPHANUMERIC = {
    id: "Alphanumeric",
    bit: 2,
    ccBits: [
        9,
        11,
        13
    ]
};
/**
 * In byte mode, data is encoded at 8 bits per character.
 *
 * @type {Object}
 */ exports.BYTE = {
    id: "Byte",
    bit: 4,
    ccBits: [
        8,
        16,
        16
    ]
};
/**
 * The Kanji mode efficiently encodes Kanji characters in accordance with
 * the Shift JIS system based on JIS X 0208.
 * The Shift JIS values are shifted from the JIS X 0208 values.
 * JIS X 0208 gives details of the shift coded representation.
 * Each two-byte character value is compacted to a 13-bit binary codeword.
 *
 * @type {Object}
 */ exports.KANJI = {
    id: "Kanji",
    bit: 8,
    ccBits: [
        8,
        10,
        12
    ]
};
/**
 * Mixed mode will contain a sequences of data in a combination of any of
 * the modes described above
 *
 * @type {Object}
 */ exports.MIXED = {
    bit: -1
};
/**
 * Returns the number of bits needed to store the data length
 * according to QR Code specifications.
 *
 * @param  {Mode}   mode    Data mode
 * @param  {Number} version QR Code version
 * @return {Number}         Number of bits
 */ exports.getCharCountIndicator = function getCharCountIndicator(mode, version) {
    if (!mode.ccBits) throw new Error("Invalid mode: " + mode);
    if (!VersionCheck.isValid(version)) throw new Error("Invalid version: " + version);
    if (version >= 1 && version < 10) return mode.ccBits[0];
    else if (version < 27) return mode.ccBits[1];
    return mode.ccBits[2];
};
/**
 * Returns the most efficient mode to store the specified data
 *
 * @param  {String} dataStr Input data string
 * @return {Mode}           Best mode
 */ exports.getBestModeForData = function getBestModeForData(dataStr) {
    if (Regex.testNumeric(dataStr)) return exports.NUMERIC;
    else if (Regex.testAlphanumeric(dataStr)) return exports.ALPHANUMERIC;
    else if (Regex.testKanji(dataStr)) return exports.KANJI;
    else return exports.BYTE;
};
/**
 * Return mode name as string
 *
 * @param {Mode} mode Mode object
 * @returns {String}  Mode name
 */ exports.toString = function toString(mode) {
    if (mode && mode.id) return mode.id;
    throw new Error("Invalid mode");
};
/**
 * Check if input param is a valid mode object
 *
 * @param   {Mode}    mode Mode object
 * @returns {Boolean} True if valid mode, false otherwise
 */ exports.isValid = function isValid(mode) {
    return mode && mode.bit && mode.ccBits;
};
/**
 * Get mode object from its name
 *
 * @param   {String} string Mode name
 * @returns {Mode}          Mode object
 */ function fromString(string) {
    if (typeof string !== "string") throw new Error("Param is not a string");
    var lcStr = string.toLowerCase();
    switch(lcStr){
        case "numeric":
            return exports.NUMERIC;
        case "alphanumeric":
            return exports.ALPHANUMERIC;
        case "kanji":
            return exports.KANJI;
        case "byte":
            return exports.BYTE;
        default:
            throw new Error("Unknown mode: " + string);
    }
}
/**
 * Returns mode from a value.
 * If value is not a valid mode, returns defaultValue
 *
 * @param  {Mode|String} value        Encoding mode
 * @param  {Mode}        defaultValue Fallback value
 * @return {Mode}                     Encoding mode
 */ exports.from = function from(value, defaultValue) {
    if (exports.isValid(value)) return value;
    try {
        return fromString(value);
    } catch (e) {
        return defaultValue;
    }
};

},{"488660fac9162579":"i5bYU","a23fd227d32f3622":"dbM7x"}],"i5bYU":[function(require,module,exports) {
/**
 * Check if QR Code version is valid
 *
 * @param  {Number}  version QR Code version
 * @return {Boolean}         true if valid version, false otherwise
 */ exports.isValid = function isValid(version) {
    return !isNaN(version) && version >= 1 && version <= 40;
};

},{}],"dbM7x":[function(require,module,exports) {
var numeric = "[0-9]+";
var alphanumeric = "[A-Z $%*+\\-./:]+";
var kanji = "(?:[u3000-u303F]|[u3040-u309F]|[u30A0-u30FF]|[uFF00-uFFEF]|[u4E00-u9FAF]|[u2605-u2606]|[u2190-u2195]|u203B|[u2010u2015u2018u2019u2025u2026u201Cu201Du2225u2260]|[u0391-u0451]|[u00A7u00A8u00B1u00B4u00D7u00F7])+";
kanji = kanji.replace(/u/g, "\\u");
var byte = "(?:(?![A-Z0-9 $%*+\\-./:]|" + kanji + ")(?:.|[\r\n]))+";
exports.KANJI = new RegExp(kanji, "g");
exports.BYTE_KANJI = new RegExp("[^A-Z0-9 $%*+\\-./:]+", "g");
exports.BYTE = new RegExp(byte, "g");
exports.NUMERIC = new RegExp(numeric, "g");
exports.ALPHANUMERIC = new RegExp(alphanumeric, "g");
var TEST_KANJI = new RegExp("^" + kanji + "$");
var TEST_NUMERIC = new RegExp("^" + numeric + "$");
var TEST_ALPHANUMERIC = new RegExp("^[A-Z0-9 $%*+\\-./:]+$");
exports.testKanji = function testKanji(str) {
    return TEST_KANJI.test(str);
};
exports.testNumeric = function testNumeric(str) {
    return TEST_NUMERIC.test(str);
};
exports.testAlphanumeric = function testAlphanumeric(str) {
    return TEST_ALPHANUMERIC.test(str);
};

},{}],"yj4S4":[function(require,module,exports) {
var Utils = require("eeca831a42e85d6c");
var G15 = 1335;
var G15_MASK = 21522;
var G15_BCH = Utils.getBCHDigit(G15);
/**
 * Returns format information with relative error correction bits
 *
 * The format information is a 15-bit sequence containing 5 data bits,
 * with 10 error correction bits calculated using the (15, 5) BCH code.
 *
 * @param  {Number} errorCorrectionLevel Error correction level
 * @param  {Number} mask                 Mask pattern
 * @return {Number}                      Encoded format information bits
 */ exports.getEncodedBits = function getEncodedBits(errorCorrectionLevel, mask) {
    var data = errorCorrectionLevel.bit << 3 | mask;
    var d = data << 10;
    while(Utils.getBCHDigit(d) - G15_BCH >= 0)d ^= G15 << Utils.getBCHDigit(d) - G15_BCH;
    // xor final data with mask pattern in order to ensure that
    // no combination of Error Correction Level and data mask pattern
    // will result in an all-zero data string
    return (data << 10 | d) ^ G15_MASK;
};

},{"eeca831a42e85d6c":"bCvEH"}],"6yArI":[function(require,module,exports) {
var Mode = require("45f6d4bff9d2fc72");
var NumericData = require("73109cbf4f3c309d");
var AlphanumericData = require("5320016e34c30467");
var ByteData = require("fd16f8f25b581951");
var KanjiData = require("8a7b84039f1cf0d2");
var Regex = require("79379a3a8f3c26bb");
var Utils = require("66903ca51bd2ea1d");
var dijkstra = require("3b9f47d541e7d71f");
/**
 * Returns UTF8 byte length
 *
 * @param  {String} str Input string
 * @return {Number}     Number of byte
 */ function getStringByteLength(str) {
    return unescape(encodeURIComponent(str)).length;
}
/**
 * Get a list of segments of the specified mode
 * from a string
 *
 * @param  {Mode}   mode Segment mode
 * @param  {String} str  String to process
 * @return {Array}       Array of object with segments data
 */ function getSegments(regex, mode, str) {
    var segments = [];
    var result;
    while((result = regex.exec(str)) !== null)segments.push({
        data: result[0],
        index: result.index,
        mode: mode,
        length: result[0].length
    });
    return segments;
}
/**
 * Extracts a series of segments with the appropriate
 * modes from a string
 *
 * @param  {String} dataStr Input string
 * @return {Array}          Array of object with segments data
 */ function getSegmentsFromString(dataStr) {
    var numSegs = getSegments(Regex.NUMERIC, Mode.NUMERIC, dataStr);
    var alphaNumSegs = getSegments(Regex.ALPHANUMERIC, Mode.ALPHANUMERIC, dataStr);
    var byteSegs;
    var kanjiSegs;
    if (Utils.isKanjiModeEnabled()) {
        byteSegs = getSegments(Regex.BYTE, Mode.BYTE, dataStr);
        kanjiSegs = getSegments(Regex.KANJI, Mode.KANJI, dataStr);
    } else {
        byteSegs = getSegments(Regex.BYTE_KANJI, Mode.BYTE, dataStr);
        kanjiSegs = [];
    }
    var segs = numSegs.concat(alphaNumSegs, byteSegs, kanjiSegs);
    return segs.sort(function(s1, s2) {
        return s1.index - s2.index;
    }).map(function(obj) {
        return {
            data: obj.data,
            mode: obj.mode,
            length: obj.length
        };
    });
}
/**
 * Returns how many bits are needed to encode a string of
 * specified length with the specified mode
 *
 * @param  {Number} length String length
 * @param  {Mode} mode     Segment mode
 * @return {Number}        Bit length
 */ function getSegmentBitsLength(length, mode) {
    switch(mode){
        case Mode.NUMERIC:
            return NumericData.getBitsLength(length);
        case Mode.ALPHANUMERIC:
            return AlphanumericData.getBitsLength(length);
        case Mode.KANJI:
            return KanjiData.getBitsLength(length);
        case Mode.BYTE:
            return ByteData.getBitsLength(length);
    }
}
/**
 * Merges adjacent segments which have the same mode
 *
 * @param  {Array} segs Array of object with segments data
 * @return {Array}      Array of object with segments data
 */ function mergeSegments(segs) {
    return segs.reduce(function(acc, curr) {
        var prevSeg = acc.length - 1 >= 0 ? acc[acc.length - 1] : null;
        if (prevSeg && prevSeg.mode === curr.mode) {
            acc[acc.length - 1].data += curr.data;
            return acc;
        }
        acc.push(curr);
        return acc;
    }, []);
}
/**
 * Generates a list of all possible nodes combination which
 * will be used to build a segments graph.
 *
 * Nodes are divided by groups. Each group will contain a list of all the modes
 * in which is possible to encode the given text.
 *
 * For example the text '12345' can be encoded as Numeric, Alphanumeric or Byte.
 * The group for '12345' will contain then 3 objects, one for each
 * possible encoding mode.
 *
 * Each node represents a possible segment.
 *
 * @param  {Array} segs Array of object with segments data
 * @return {Array}      Array of object with segments data
 */ function buildNodes(segs) {
    var nodes = [];
    for(var i = 0; i < segs.length; i++){
        var seg = segs[i];
        switch(seg.mode){
            case Mode.NUMERIC:
                nodes.push([
                    seg,
                    {
                        data: seg.data,
                        mode: Mode.ALPHANUMERIC,
                        length: seg.length
                    },
                    {
                        data: seg.data,
                        mode: Mode.BYTE,
                        length: seg.length
                    }
                ]);
                break;
            case Mode.ALPHANUMERIC:
                nodes.push([
                    seg,
                    {
                        data: seg.data,
                        mode: Mode.BYTE,
                        length: seg.length
                    }
                ]);
                break;
            case Mode.KANJI:
                nodes.push([
                    seg,
                    {
                        data: seg.data,
                        mode: Mode.BYTE,
                        length: getStringByteLength(seg.data)
                    }
                ]);
                break;
            case Mode.BYTE:
                nodes.push([
                    {
                        data: seg.data,
                        mode: Mode.BYTE,
                        length: getStringByteLength(seg.data)
                    }
                ]);
        }
    }
    return nodes;
}
/**
 * Builds a graph from a list of nodes.
 * All segments in each node group will be connected with all the segments of
 * the next group and so on.
 *
 * At each connection will be assigned a weight depending on the
 * segment's byte length.
 *
 * @param  {Array} nodes    Array of object with segments data
 * @param  {Number} version QR Code version
 * @return {Object}         Graph of all possible segments
 */ function buildGraph(nodes, version) {
    var table = {};
    var graph = {
        "start": {}
    };
    var prevNodeIds = [
        "start"
    ];
    for(var i = 0; i < nodes.length; i++){
        var nodeGroup = nodes[i];
        var currentNodeIds = [];
        for(var j = 0; j < nodeGroup.length; j++){
            var node = nodeGroup[j];
            var key = "" + i + j;
            currentNodeIds.push(key);
            table[key] = {
                node: node,
                lastCount: 0
            };
            graph[key] = {};
            for(var n = 0; n < prevNodeIds.length; n++){
                var prevNodeId = prevNodeIds[n];
                if (table[prevNodeId] && table[prevNodeId].node.mode === node.mode) {
                    graph[prevNodeId][key] = getSegmentBitsLength(table[prevNodeId].lastCount + node.length, node.mode) - getSegmentBitsLength(table[prevNodeId].lastCount, node.mode);
                    table[prevNodeId].lastCount += node.length;
                } else {
                    if (table[prevNodeId]) table[prevNodeId].lastCount = node.length;
                    graph[prevNodeId][key] = getSegmentBitsLength(node.length, node.mode) + 4 + Mode.getCharCountIndicator(node.mode, version) // switch cost
                    ;
                }
            }
        }
        prevNodeIds = currentNodeIds;
    }
    for(n = 0; n < prevNodeIds.length; n++)graph[prevNodeIds[n]]["end"] = 0;
    return {
        map: graph,
        table: table
    };
}
/**
 * Builds a segment from a specified data and mode.
 * If a mode is not specified, the more suitable will be used.
 *
 * @param  {String} data             Input data
 * @param  {Mode | String} modesHint Data mode
 * @return {Segment}                 Segment
 */ function buildSingleSegment(data, modesHint) {
    var mode;
    var bestMode = Mode.getBestModeForData(data);
    mode = Mode.from(modesHint, bestMode);
    // Make sure data can be encoded
    if (mode !== Mode.BYTE && mode.bit < bestMode.bit) throw new Error('"' + data + '"' + " cannot be encoded with mode " + Mode.toString(mode) + ".\n Suggested mode is: " + Mode.toString(bestMode));
    // Use Mode.BYTE if Kanji support is disabled
    if (mode === Mode.KANJI && !Utils.isKanjiModeEnabled()) mode = Mode.BYTE;
    switch(mode){
        case Mode.NUMERIC:
            return new NumericData(data);
        case Mode.ALPHANUMERIC:
            return new AlphanumericData(data);
        case Mode.KANJI:
            return new KanjiData(data);
        case Mode.BYTE:
            return new ByteData(data);
    }
}
/**
 * Builds a list of segments from an array.
 * Array can contain Strings or Objects with segment's info.
 *
 * For each item which is a string, will be generated a segment with the given
 * string and the more appropriate encoding mode.
 *
 * For each item which is an object, will be generated a segment with the given
 * data and mode.
 * Objects must contain at least the property "data".
 * If property "mode" is not present, the more suitable mode will be used.
 *
 * @param  {Array} array Array of objects with segments data
 * @return {Array}       Array of Segments
 */ exports.fromArray = function fromArray(array) {
    return array.reduce(function(acc, seg) {
        if (typeof seg === "string") acc.push(buildSingleSegment(seg, null));
        else if (seg.data) acc.push(buildSingleSegment(seg.data, seg.mode));
        return acc;
    }, []);
};
/**
 * Builds an optimized sequence of segments from a string,
 * which will produce the shortest possible bitstream.
 *
 * @param  {String} data    Input string
 * @param  {Number} version QR Code version
 * @return {Array}          Array of segments
 */ exports.fromString = function fromString(data, version) {
    var segs = getSegmentsFromString(data, Utils.isKanjiModeEnabled());
    var nodes = buildNodes(segs);
    var graph = buildGraph(nodes, version);
    var path = dijkstra.find_path(graph.map, "start", "end");
    var optimizedSegs = [];
    for(var i = 1; i < path.length - 1; i++)optimizedSegs.push(graph.table[path[i]].node);
    return exports.fromArray(mergeSegments(optimizedSegs));
};
/**
 * Splits a string in various segments with the modes which
 * best represent their content.
 * The produced segments are far from being optimized.
 * The output of this function is only used to estimate a QR Code version
 * which may contain the data.
 *
 * @param  {string} data Input string
 * @return {Array}       Array of segments
 */ exports.rawSplit = function rawSplit(data) {
    return exports.fromArray(getSegmentsFromString(data, Utils.isKanjiModeEnabled()));
};

},{"45f6d4bff9d2fc72":"epPN6","73109cbf4f3c309d":"aUlLG","5320016e34c30467":"Ar6x0","fd16f8f25b581951":"hRx4f","8a7b84039f1cf0d2":"1og6T","79379a3a8f3c26bb":"dbM7x","66903ca51bd2ea1d":"bCvEH","3b9f47d541e7d71f":"dhJUA"}],"aUlLG":[function(require,module,exports) {
var Mode = require("29134b0b0820b091");
function NumericData(data) {
    this.mode = Mode.NUMERIC;
    this.data = data.toString();
}
NumericData.getBitsLength = function getBitsLength(length) {
    return 10 * Math.floor(length / 3) + (length % 3 ? length % 3 * 3 + 1 : 0);
};
NumericData.prototype.getLength = function getLength() {
    return this.data.length;
};
NumericData.prototype.getBitsLength = function getBitsLength() {
    return NumericData.getBitsLength(this.data.length);
};
NumericData.prototype.write = function write(bitBuffer) {
    var i, group, value;
    // The input data string is divided into groups of three digits,
    // and each group is converted to its 10-bit binary equivalent.
    for(i = 0; i + 3 <= this.data.length; i += 3){
        group = this.data.substr(i, 3);
        value = parseInt(group, 10);
        bitBuffer.put(value, 10);
    }
    // If the number of input digits is not an exact multiple of three,
    // the final one or two digits are converted to 4 or 7 bits respectively.
    var remainingNum = this.data.length - i;
    if (remainingNum > 0) {
        group = this.data.substr(i);
        value = parseInt(group, 10);
        bitBuffer.put(value, remainingNum * 3 + 1);
    }
};
module.exports = NumericData;

},{"29134b0b0820b091":"epPN6"}],"Ar6x0":[function(require,module,exports) {
var Mode = require("9c7c9b869570f846");
/**
 * Array of characters available in alphanumeric mode
 *
 * As per QR Code specification, to each character
 * is assigned a value from 0 to 44 which in this case coincides
 * with the array index
 *
 * @type {Array}
 */ var ALPHA_NUM_CHARS = [
    "0",
    "1",
    "2",
    "3",
    "4",
    "5",
    "6",
    "7",
    "8",
    "9",
    "A",
    "B",
    "C",
    "D",
    "E",
    "F",
    "G",
    "H",
    "I",
    "J",
    "K",
    "L",
    "M",
    "N",
    "O",
    "P",
    "Q",
    "R",
    "S",
    "T",
    "U",
    "V",
    "W",
    "X",
    "Y",
    "Z",
    " ",
    "$",
    "%",
    "*",
    "+",
    "-",
    ".",
    "/",
    ":"
];
function AlphanumericData(data) {
    this.mode = Mode.ALPHANUMERIC;
    this.data = data;
}
AlphanumericData.getBitsLength = function getBitsLength(length) {
    return 11 * Math.floor(length / 2) + 6 * (length % 2);
};
AlphanumericData.prototype.getLength = function getLength() {
    return this.data.length;
};
AlphanumericData.prototype.getBitsLength = function getBitsLength() {
    return AlphanumericData.getBitsLength(this.data.length);
};
AlphanumericData.prototype.write = function write(bitBuffer) {
    var i;
    // Input data characters are divided into groups of two characters
    // and encoded as 11-bit binary codes.
    for(i = 0; i + 2 <= this.data.length; i += 2){
        // The character value of the first character is multiplied by 45
        var value = ALPHA_NUM_CHARS.indexOf(this.data[i]) * 45;
        // The character value of the second digit is added to the product
        value += ALPHA_NUM_CHARS.indexOf(this.data[i + 1]);
        // The sum is then stored as 11-bit binary number
        bitBuffer.put(value, 11);
    }
    // If the number of input data characters is not a multiple of two,
    // the character value of the final character is encoded as a 6-bit binary number.
    if (this.data.length % 2) bitBuffer.put(ALPHA_NUM_CHARS.indexOf(this.data[i]), 6);
};
module.exports = AlphanumericData;

},{"9c7c9b869570f846":"epPN6"}],"hRx4f":[function(require,module,exports) {
var BufferUtil = require("782eaeb09a93d376");
var Mode = require("a20a51f6cd184253");
function ByteData(data) {
    this.mode = Mode.BYTE;
    this.data = BufferUtil.from(data);
}
ByteData.getBitsLength = function getBitsLength(length) {
    return length * 8;
};
ByteData.prototype.getLength = function getLength() {
    return this.data.length;
};
ByteData.prototype.getBitsLength = function getBitsLength() {
    return ByteData.getBitsLength(this.data.length);
};
ByteData.prototype.write = function(bitBuffer) {
    for(var i = 0, l = this.data.length; i < l; i++)bitBuffer.put(this.data[i], 8);
};
module.exports = ByteData;

},{"782eaeb09a93d376":"9Bo5k","a20a51f6cd184253":"epPN6"}],"1og6T":[function(require,module,exports) {
var Mode = require("b935cfd1cd03a1f6");
var Utils = require("ca4944585cc8d12d");
function KanjiData(data) {
    this.mode = Mode.KANJI;
    this.data = data;
}
KanjiData.getBitsLength = function getBitsLength(length) {
    return length * 13;
};
KanjiData.prototype.getLength = function getLength() {
    return this.data.length;
};
KanjiData.prototype.getBitsLength = function getBitsLength() {
    return KanjiData.getBitsLength(this.data.length);
};
KanjiData.prototype.write = function(bitBuffer) {
    var i;
    // In the Shift JIS system, Kanji characters are represented by a two byte combination.
    // These byte values are shifted from the JIS X 0208 values.
    // JIS X 0208 gives details of the shift coded representation.
    for(i = 0; i < this.data.length; i++){
        var value = Utils.toSJIS(this.data[i]);
        // For characters with Shift JIS values from 0x8140 to 0x9FFC:
        if (value >= 0x8140 && value <= 0x9FFC) // Subtract 0x8140 from Shift JIS value
        value -= 0x8140;
        else if (value >= 0xE040 && value <= 0xEBBF) // Subtract 0xC140 from Shift JIS value
        value -= 0xC140;
        else throw new Error("Invalid SJIS character: " + this.data[i] + "\n" + "Make sure your charset is UTF-8");
        // Multiply most significant byte of result by 0xC0
        // and add least significant byte to product
        value = (value >>> 8 & 0xff) * 0xC0 + (value & 0xff);
        // Convert result to a 13-bit binary string
        bitBuffer.put(value, 13);
    }
};
module.exports = KanjiData;

},{"b935cfd1cd03a1f6":"epPN6","ca4944585cc8d12d":"bCvEH"}],"dhJUA":[function(require,module,exports) {
"use strict";
/******************************************************************************
 * Created 2008-08-19.
 *
 * Dijkstra path-finding functions. Adapted from the Dijkstar Python project.
 *
 * Copyright (C) 2008
 *   Wyatt Baldwin <self@wyattbaldwin.com>
 *   All rights reserved
 *
 * Licensed under the MIT license.
 *
 *   http://www.opensource.org/licenses/mit-license.php
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 *****************************************************************************/ var dijkstra = {
    single_source_shortest_paths: function(graph, s, d) {
        // Predecessor map for each node that has been encountered.
        // node ID => predecessor node ID
        var predecessors = {};
        // Costs of shortest paths from s to all nodes encountered.
        // node ID => cost
        var costs = {};
        costs[s] = 0;
        // Costs of shortest paths from s to all nodes encountered; differs from
        // `costs` in that it provides easy access to the node that currently has
        // the known shortest path from s.
        // XXX: Do we actually need both `costs` and `open`?
        var open = dijkstra.PriorityQueue.make();
        open.push(s, 0);
        var closest, u, v, cost_of_s_to_u, adjacent_nodes, cost_of_e, cost_of_s_to_u_plus_cost_of_e, cost_of_s_to_v, first_visit;
        while(!open.empty()){
            // In the nodes remaining in graph that have a known cost from s,
            // find the node, u, that currently has the shortest path from s.
            closest = open.pop();
            u = closest.value;
            cost_of_s_to_u = closest.cost;
            // Get nodes adjacent to u...
            adjacent_nodes = graph[u] || {};
            // ...and explore the edges that connect u to those nodes, updating
            // the cost of the shortest paths to any or all of those nodes as
            // necessary. v is the node across the current edge from u.
            for(v in adjacent_nodes)if (adjacent_nodes.hasOwnProperty(v)) {
                // Get the cost of the edge running from u to v.
                cost_of_e = adjacent_nodes[v];
                // Cost of s to u plus the cost of u to v across e--this is *a*
                // cost from s to v that may or may not be less than the current
                // known cost to v.
                cost_of_s_to_u_plus_cost_of_e = cost_of_s_to_u + cost_of_e;
                // If we haven't visited v yet OR if the current known cost from s to
                // v is greater than the new cost we just found (cost of s to u plus
                // cost of u to v across e), update v's cost in the cost list and
                // update v's predecessor in the predecessor list (it's now u).
                cost_of_s_to_v = costs[v];
                first_visit = typeof costs[v] === "undefined";
                if (first_visit || cost_of_s_to_v > cost_of_s_to_u_plus_cost_of_e) {
                    costs[v] = cost_of_s_to_u_plus_cost_of_e;
                    open.push(v, cost_of_s_to_u_plus_cost_of_e);
                    predecessors[v] = u;
                }
            }
        }
        if (typeof d !== "undefined" && typeof costs[d] === "undefined") {
            var msg = [
                "Could not find a path from ",
                s,
                " to ",
                d,
                "."
            ].join("");
            throw new Error(msg);
        }
        return predecessors;
    },
    extract_shortest_path_from_predecessor_list: function(predecessors, d) {
        var nodes = [];
        var u = d;
        var predecessor;
        while(u){
            nodes.push(u);
            predecessor = predecessors[u];
            u = predecessors[u];
        }
        nodes.reverse();
        return nodes;
    },
    find_path: function(graph, s, d) {
        var predecessors = dijkstra.single_source_shortest_paths(graph, s, d);
        return dijkstra.extract_shortest_path_from_predecessor_list(predecessors, d);
    },
    /**
   * A very naive priority queue implementation.
   */ PriorityQueue: {
        make: function(opts) {
            var T = dijkstra.PriorityQueue, t = {}, key;
            opts = opts || {};
            for(key in T)if (T.hasOwnProperty(key)) t[key] = T[key];
            t.queue = [];
            t.sorter = opts.sorter || T.default_sorter;
            return t;
        },
        default_sorter: function(a, b) {
            return a.cost - b.cost;
        },
        /**
     * Add a new item to the queue and ensure the highest priority element
     * is at the front of the queue.
     */ push: function(value, cost) {
            var item = {
                value: value,
                cost: cost
            };
            this.queue.push(item);
            this.queue.sort(this.sorter);
        },
        /**
     * Return the highest priority element in the queue.
     */ pop: function() {
            return this.queue.shift();
        },
        empty: function() {
            return this.queue.length === 0;
        }
    }
};
module.exports = dijkstra;

},{}],"53FZc":[function(require,module,exports) {
var Utils = require("5b3f7c513802d6c7");
function clearCanvas(ctx, canvas, size) {
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    if (!canvas.style) canvas.style = {};
    canvas.height = size;
    canvas.width = size;
    canvas.style.height = size + "px";
    canvas.style.width = size + "px";
}
function getCanvasElement() {
    try {
        return document.createElement("canvas");
    } catch (e) {
        throw new Error("You need to specify a canvas element");
    }
}
exports.render = function render(qrData, canvas, options) {
    var opts = options;
    var canvasEl = canvas;
    if (typeof opts === "undefined" && (!canvas || !canvas.getContext)) {
        opts = canvas;
        canvas = undefined;
    }
    if (!canvas) canvasEl = getCanvasElement();
    opts = Utils.getOptions(opts);
    var size = Utils.getImageWidth(qrData.modules.size, opts);
    var ctx = canvasEl.getContext("2d");
    var image = ctx.createImageData(size, size);
    Utils.qrToImageData(image.data, qrData, opts);
    clearCanvas(ctx, canvasEl, size);
    ctx.putImageData(image, 0, 0);
    return canvasEl;
};
exports.renderToDataURL = function renderToDataURL(qrData, canvas, options) {
    var opts = options;
    if (typeof opts === "undefined" && (!canvas || !canvas.getContext)) {
        opts = canvas;
        canvas = undefined;
    }
    if (!opts) opts = {};
    var canvasEl = exports.render(qrData, canvas, opts);
    var type = opts.type || "image/png";
    var rendererOpts = opts.rendererOpts || {};
    return canvasEl.toDataURL(type, rendererOpts.quality);
};

},{"5b3f7c513802d6c7":"hOTXA"}],"hOTXA":[function(require,module,exports) {
function hex2rgba(hex) {
    if (typeof hex === "number") hex = hex.toString();
    if (typeof hex !== "string") throw new Error("Color should be defined as hex string");
    var hexCode = hex.slice().replace("#", "").split("");
    if (hexCode.length < 3 || hexCode.length === 5 || hexCode.length > 8) throw new Error("Invalid hex color: " + hex);
    // Convert from short to long form (fff -> ffffff)
    if (hexCode.length === 3 || hexCode.length === 4) hexCode = Array.prototype.concat.apply([], hexCode.map(function(c) {
        return [
            c,
            c
        ];
    }));
    // Add default alpha value
    if (hexCode.length === 6) hexCode.push("F", "F");
    var hexValue = parseInt(hexCode.join(""), 16);
    return {
        r: hexValue >> 24 & 255,
        g: hexValue >> 16 & 255,
        b: hexValue >> 8 & 255,
        a: hexValue & 255,
        hex: "#" + hexCode.slice(0, 6).join("")
    };
}
exports.getOptions = function getOptions(options) {
    if (!options) options = {};
    if (!options.color) options.color = {};
    var margin = typeof options.margin === "undefined" || options.margin === null || options.margin < 0 ? 4 : options.margin;
    var width = options.width && options.width >= 21 ? options.width : undefined;
    var scale = options.scale || 4;
    return {
        width: width,
        scale: width ? 4 : scale,
        margin: margin,
        color: {
            dark: hex2rgba(options.color.dark || "#000000ff"),
            light: hex2rgba(options.color.light || "#ffffffff")
        },
        type: options.type,
        rendererOpts: options.rendererOpts || {}
    };
};
exports.getScale = function getScale(qrSize, opts) {
    return opts.width && opts.width >= qrSize + opts.margin * 2 ? opts.width / (qrSize + opts.margin * 2) : opts.scale;
};
exports.getImageWidth = function getImageWidth(qrSize, opts) {
    var scale = exports.getScale(qrSize, opts);
    return Math.floor((qrSize + opts.margin * 2) * scale);
};
exports.qrToImageData = function qrToImageData(imgData, qr, opts) {
    var size = qr.modules.size;
    var data = qr.modules.data;
    var scale = exports.getScale(size, opts);
    var symbolSize = Math.floor((size + opts.margin * 2) * scale);
    var scaledMargin = opts.margin * scale;
    var palette = [
        opts.color.light,
        opts.color.dark
    ];
    for(var i = 0; i < symbolSize; i++)for(var j = 0; j < symbolSize; j++){
        var posDst = (i * symbolSize + j) * 4;
        var pxColor = opts.color.light;
        if (i >= scaledMargin && j >= scaledMargin && i < symbolSize - scaledMargin && j < symbolSize - scaledMargin) {
            var iSrc = Math.floor((i - scaledMargin) / scale);
            var jSrc = Math.floor((j - scaledMargin) / scale);
            pxColor = palette[data[iSrc * size + jSrc] ? 1 : 0];
        }
        imgData[posDst++] = pxColor.r;
        imgData[posDst++] = pxColor.g;
        imgData[posDst++] = pxColor.b;
        imgData[posDst] = pxColor.a;
    }
};

},{}],"cM6dr":[function(require,module,exports) {
var Utils = require("c36bbcf663291acc");
function getColorAttrib(color, attrib) {
    var alpha = color.a / 255;
    var str = attrib + '="' + color.hex + '"';
    return alpha < 1 ? str + " " + attrib + '-opacity="' + alpha.toFixed(2).slice(1) + '"' : str;
}
function svgCmd(cmd, x, y) {
    var str = cmd + x;
    if (typeof y !== "undefined") str += " " + y;
    return str;
}
function qrToPath(data, size, margin) {
    var path = "";
    var moveBy = 0;
    var newRow = false;
    var lineLength = 0;
    for(var i = 0; i < data.length; i++){
        var col = Math.floor(i % size);
        var row = Math.floor(i / size);
        if (!col && !newRow) newRow = true;
        if (data[i]) {
            lineLength++;
            if (!(i > 0 && col > 0 && data[i - 1])) {
                path += newRow ? svgCmd("M", col + margin, 0.5 + row + margin) : svgCmd("m", moveBy, 0);
                moveBy = 0;
                newRow = false;
            }
            if (!(col + 1 < size && data[i + 1])) {
                path += svgCmd("h", lineLength);
                lineLength = 0;
            }
        } else moveBy++;
    }
    return path;
}
exports.render = function render(qrData, options, cb) {
    var opts = Utils.getOptions(options);
    var size = qrData.modules.size;
    var data = qrData.modules.data;
    var qrcodesize = size + opts.margin * 2;
    var bg = !opts.color.light.a ? "" : "<path " + getColorAttrib(opts.color.light, "fill") + ' d="M0 0h' + qrcodesize + "v" + qrcodesize + 'H0z"/>';
    var path = "<path " + getColorAttrib(opts.color.dark, "stroke") + ' d="' + qrToPath(data, size, opts.margin) + '"/>';
    var viewBox = 'viewBox="0 0 ' + qrcodesize + " " + qrcodesize + '"';
    var width = !opts.width ? "" : 'width="' + opts.width + '" height="' + opts.width + '" ';
    var svgTag = '<svg xmlns="http://www.w3.org/2000/svg" ' + width + viewBox + ' shape-rendering="crispEdges">' + bg + path + "</svg>\n";
    if (typeof cb === "function") cb(null, svgTag);
    return svgTag;
};

},{"c36bbcf663291acc":"hOTXA"}],"h8Sci":[function(require,module,exports) {
"use strict";
var deselectCurrent = require("b270149f26797c52");
var clipboardToIE11Formatting = {
    "text/plain": "Text",
    "text/html": "Url",
    "default": "Text"
};
var defaultMessage = "Copy to clipboard: #{key}, Enter";
function format(message) {
    var copyKey = (/mac os x/i.test(navigator.userAgent) ? "\u2318" : "Ctrl") + "+C";
    return message.replace(/#{\s*key\s*}/g, copyKey);
}
function copy(text, options) {
    var debug, message, reselectPrevious, range, selection, mark, success = false;
    if (!options) options = {};
    debug = options.debug || false;
    try {
        reselectPrevious = deselectCurrent();
        range = document.createRange();
        selection = document.getSelection();
        mark = document.createElement("span");
        mark.textContent = text;
        // avoid screen readers from reading out loud the text
        mark.ariaHidden = "true";
        // reset user styles for span element
        mark.style.all = "unset";
        // prevents scrolling to the end of the page
        mark.style.position = "fixed";
        mark.style.top = 0;
        mark.style.clip = "rect(0, 0, 0, 0)";
        // used to preserve spaces and line breaks
        mark.style.whiteSpace = "pre";
        // do not inherit user-select (it may be `none`)
        mark.style.webkitUserSelect = "text";
        mark.style.MozUserSelect = "text";
        mark.style.msUserSelect = "text";
        mark.style.userSelect = "text";
        mark.addEventListener("copy", function(e) {
            e.stopPropagation();
            if (options.format) {
                e.preventDefault();
                if (typeof e.clipboardData === "undefined") {
                    debug && console.warn("unable to use e.clipboardData");
                    debug && console.warn("trying IE specific stuff");
                    window.clipboardData.clearData();
                    var format = clipboardToIE11Formatting[options.format] || clipboardToIE11Formatting["default"];
                    window.clipboardData.setData(format, text);
                } else {
                    e.clipboardData.clearData();
                    e.clipboardData.setData(options.format, text);
                }
            }
            if (options.onCopy) {
                e.preventDefault();
                options.onCopy(e.clipboardData);
            }
        });
        document.body.appendChild(mark);
        range.selectNodeContents(mark);
        selection.addRange(range);
        var successful = document.execCommand("copy");
        if (!successful) throw new Error("copy command was unsuccessful");
        success = true;
    } catch (err) {
        debug && console.error("unable to copy using execCommand: ", err);
        debug && console.warn("trying IE specific stuff");
        try {
            window.clipboardData.setData(options.format || "text", text);
            options.onCopy && options.onCopy(window.clipboardData);
            success = true;
        } catch (err) {
            debug && console.error("unable to copy using clipboardData: ", err);
            debug && console.error("falling back to prompt");
            message = format("message" in options ? options.message : defaultMessage);
            window.prompt(message, text);
        }
    } finally{
        if (selection) {
            if (typeof selection.removeRange == "function") selection.removeRange(range);
            else selection.removeAllRanges();
        }
        if (mark) document.body.removeChild(mark);
        reselectPrevious();
    }
    return success;
}
module.exports = copy;

},{"b270149f26797c52":"1aJ1w"}],"1aJ1w":[function(require,module,exports) {
module.exports = function() {
    var selection = document.getSelection();
    if (!selection.rangeCount) return function() {};
    var active = document.activeElement;
    var ranges = [];
    for(var i = 0; i < selection.rangeCount; i++)ranges.push(selection.getRangeAt(i));
    switch(active.tagName.toUpperCase()){
        case "INPUT":
        case "TEXTAREA":
            active.blur();
            break;
        default:
            active = null;
            break;
    }
    selection.removeAllRanges();
    return function() {
        selection.type === "Caret" && selection.removeAllRanges();
        if (!selection.rangeCount) ranges.forEach(function(range) {
            selection.addRange(range);
        });
        active && active.focus();
    };
};

},{}],"7Rky7":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createElement", ()=>(0, _preact.createElement));
parcelHelpers.export(exports, "createContext", ()=>(0, _preact.createContext));
parcelHelpers.export(exports, "createRef", ()=>(0, _preact.createRef));
parcelHelpers.export(exports, "Fragment", ()=>(0, _preact.Fragment));
parcelHelpers.export(exports, "Component", ()=>(0, _preact.Component));
parcelHelpers.export(exports, "version", ()=>B);
parcelHelpers.export(exports, "Children", ()=>R);
parcelHelpers.export(exports, "render", ()=>T);
parcelHelpers.export(exports, "hydrate", ()=>V);
parcelHelpers.export(exports, "unmountComponentAtNode", ()=>Q);
parcelHelpers.export(exports, "createPortal", ()=>z);
parcelHelpers.export(exports, "createFactory", ()=>G);
parcelHelpers.export(exports, "cloneElement", ()=>K);
parcelHelpers.export(exports, "isValidElement", ()=>J);
parcelHelpers.export(exports, "findDOMNode", ()=>X);
parcelHelpers.export(exports, "PureComponent", ()=>C);
parcelHelpers.export(exports, "memo", ()=>_);
parcelHelpers.export(exports, "forwardRef", ()=>S);
parcelHelpers.export(exports, "unstable_batchedUpdates", ()=>Y);
parcelHelpers.export(exports, "Suspense", ()=>U);
parcelHelpers.export(exports, "SuspenseList", ()=>O);
parcelHelpers.export(exports, "lazy", ()=>L);
var _hooks = require("preact/hooks");
parcelHelpers.exportAll(_hooks, exports);
var _preact = require("preact");
function E(n, t) {
    for(var e in t)n[e] = t[e];
    return n;
}
function w(n, t) {
    for(var e in n)if ("__source" !== e && !(e in t)) return !0;
    for(var r in t)if ("__source" !== r && n[r] !== t[r]) return !0;
    return !1;
}
var C = function(n) {
    var t, e;
    function r(t) {
        var e;
        return (e = n.call(this, t) || this).isPureReactComponent = !0, e;
    }
    return e = n, (t = r).prototype = Object.create(e.prototype), t.prototype.constructor = t, t.__proto__ = e, r.prototype.shouldComponentUpdate = function(n, t) {
        return w(this.props, n) || w(this.state, t);
    }, r;
}((0, _preact.Component));
function _(n, t) {
    function e(n) {
        var e = this.props.ref, r = e == n.ref;
        return !r && e && (e.call ? e(null) : e.current = null), t ? !t(this.props, n) || !r : w(this.props, n);
    }
    function r(t) {
        return this.shouldComponentUpdate = e, (0, _preact.createElement)(n, E({}, t));
    }
    return r.prototype.isReactComponent = !0, r.displayName = "Memo(" + (n.displayName || n.name) + ")", r.t = !0, r;
}
var A = (0, _preact.options).__b;
function S(n) {
    function t(t) {
        var e = E({}, t);
        return delete e.ref, n(e, t.ref);
    }
    return t.prototype.isReactComponent = t.t = !0, t.displayName = "ForwardRef(" + (n.displayName || n.name) + ")", t;
}
(0, _preact.options).__b = function(n) {
    n.type && n.type.t && n.ref && (n.props.ref = n.ref, n.ref = null), A && A(n);
};
var k = function(n, t) {
    return n ? (0, _preact.toChildArray)(n).reduce(function(n, e, r) {
        return n.concat(t(e, r));
    }, []) : null;
}, R = {
    map: k,
    forEach: k,
    count: function(n) {
        return n ? (0, _preact.toChildArray)(n).length : 0;
    },
    only: function(n) {
        if (1 !== (n = (0, _preact.toChildArray)(n)).length) throw new Error("Children.only() expects only one child.");
        return n[0];
    },
    toArray: (0, _preact.toChildArray)
}, F = (0, _preact.options).__e;
function N(n) {
    return n && ((n = E({}, n)).__c = null, n.__k = n.__k && n.__k.map(N)), n;
}
function U() {
    this.__u = 0, this.o = null, this.__b = null;
}
function M(n) {
    var t = n.__.__c;
    return t && t.u && t.u(n);
}
function L(n) {
    var t, e, r;
    function o(o) {
        if (t || (t = n()).then(function(n) {
            e = n.default || n;
        }, function(n) {
            r = n;
        }), r) throw r;
        if (!e) throw t;
        return (0, _preact.createElement)(e, o);
    }
    return o.displayName = "Lazy", o.t = !0, o;
}
function O() {
    this.i = null, this.l = null;
}
(0, _preact.options).__e = function(n, t, e) {
    if (n.then) {
        for(var r, o = t; o = o.__;)if ((r = o.__c) && r.__c) return r.__c(n, t.__c);
    }
    F(n, t, e);
}, (U.prototype = new (0, _preact.Component)).__c = function(n, t) {
    var e = this;
    null == e.o && (e.o = []), e.o.push(t);
    var r = M(e.__v), o = !1, u = function() {
        o || (o = !0, r ? r(i) : i());
    };
    t.__c = t.componentWillUnmount, t.componentWillUnmount = function() {
        u(), t.__c && t.__c();
    };
    var i = function() {
        var n;
        if (!--e.__u) for(e.__v.__k[0] = e.state.u, e.setState({
            u: e.__b = null
        }); n = e.o.pop();)n.forceUpdate();
    };
    e.__u++ || e.setState({
        u: e.__b = e.__v.__k[0]
    }), n.then(u, u);
}, U.prototype.render = function(n, t) {
    return this.__b && (this.__v.__k[0] = N(this.__b), this.__b = null), [
        (0, _preact.createElement)((0, _preact.Component), null, t.u ? null : n.children),
        t.u && n.fallback
    ];
};
var P = function(n, t, e) {
    if (++e[1] === e[0] && n.l.delete(t), n.props.revealOrder && ("t" !== n.props.revealOrder[0] || !n.l.size)) for(e = n.i; e;){
        for(; e.length > 3;)e.pop()();
        if (e[1] < e[0]) break;
        n.i = e = e[2];
    }
};
(O.prototype = new (0, _preact.Component)).u = function(n) {
    var t = this, e = M(t.__v), r = t.l.get(n);
    return r[0]++, function(o) {
        var u = function() {
            t.props.revealOrder ? (r.push(o), P(t, n, r)) : o();
        };
        e ? e(u) : u();
    };
}, O.prototype.render = function(n) {
    this.i = null, this.l = new Map;
    var t = (0, _preact.toChildArray)(n.children);
    n.revealOrder && "b" === n.revealOrder[0] && t.reverse();
    for(var e = t.length; e--;)this.l.set(t[e], this.i = [
        1,
        0,
        this.i
    ]);
    return n.children;
}, O.prototype.componentDidUpdate = O.prototype.componentDidMount = function() {
    var n = this;
    n.l.forEach(function(t, e) {
        P(n, e, t);
    });
};
var W = function() {
    function n() {}
    var t = n.prototype;
    return t.getChildContext = function() {
        return this.props.context;
    }, t.render = function(n) {
        return n.children;
    }, n;
}();
function j(n) {
    var t = this, e = n.container, r = (0, _preact.createElement)(W, {
        context: t.context
    }, n.vnode);
    return t.s && t.s !== e && (t.v.parentNode && t.s.removeChild(t.v), (0, _preact._unmount)(t.h), t.p = !1), n.vnode ? t.p ? (e.__k = t.__k, (0, _preact.render)(r, e), t.__k = e.__k) : (t.v = document.createTextNode(""), (0, _preact.hydrate)("", e), e.appendChild(t.v), t.p = !0, t.s = e, (0, _preact.render)(r, e, t.v), t.__k = t.v.__k) : t.p && (t.v.parentNode && t.s.removeChild(t.v), (0, _preact._unmount)(t.h)), t.h = r, t.componentWillUnmount = function() {
        t.v.parentNode && t.s.removeChild(t.v), (0, _preact._unmount)(t.h);
    }, null;
}
function z(n, t) {
    return (0, _preact.createElement)(j, {
        vnode: n,
        container: t
    });
}
var D = /^(?:accent|alignment|arabic|baseline|cap|clip(?!PathU)|color|fill|flood|font|glyph(?!R)|horiz|marker(?!H|W|U)|overline|paint|stop|strikethrough|stroke|text(?!L)|underline|unicode|units|v|vector|vert|word|writing|x(?!C))[A-Z]/;
(0, _preact.Component).prototype.isReactComponent = {};
var H = "undefined" != typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103;
function T(n, t, e) {
    if (null == t.__k) for(; t.firstChild;)t.removeChild(t.firstChild);
    return (0, _preact.render)(n, t), "function" == typeof e && e(), n ? n.__c : null;
}
function V(n, t, e) {
    return (0, _preact.hydrate)(n, t), "function" == typeof e && e(), n ? n.__c : null;
}
var Z = (0, _preact.options).event;
function I(n, t) {
    n["UNSAFE_" + t] && !n[t] && Object.defineProperty(n, t, {
        configurable: !1,
        get: function() {
            return this["UNSAFE_" + t];
        },
        set: function(n) {
            this["UNSAFE_" + t] = n;
        }
    });
}
(0, _preact.options).event = function(n) {
    Z && (n = Z(n)), n.persist = function() {};
    var t = !1, e = !1, r = n.stopPropagation;
    n.stopPropagation = function() {
        r.call(n), t = !0;
    };
    var o = n.preventDefault;
    return n.preventDefault = function() {
        o.call(n), e = !0;
    }, n.isPropagationStopped = function() {
        return t;
    }, n.isDefaultPrevented = function() {
        return e;
    }, n.nativeEvent = n;
};
var $ = {
    configurable: !0,
    get: function() {
        return this.class;
    }
}, q = (0, _preact.options).vnode;
(0, _preact.options).vnode = function(n) {
    n.$$typeof = H;
    var t = n.type, e = n.props;
    if (t) {
        if (e.class != e.className && ($.enumerable = "className" in e, null != e.className && (e.class = e.className), Object.defineProperty(e, "className", $)), "function" != typeof t) {
            var r, o, u;
            for(u in e.defaultValue && void 0 !== e.value && (e.value || 0 === e.value || (e.value = e.defaultValue), delete e.defaultValue), Array.isArray(e.value) && e.multiple && "select" === t && ((0, _preact.toChildArray)(e.children).forEach(function(n) {
                -1 != e.value.indexOf(n.props.value) && (n.props.selected = !0);
            }), delete e.value), e)if (r = D.test(u)) break;
            if (r) for(u in o = n.props = {}, e)o[D.test(u) ? u.replace(/[A-Z0-9]/, "-$&").toLowerCase() : u] = e[u];
        }
        !function(t) {
            var e = n.type, r = n.props;
            if (r && "string" == typeof e) {
                var o = {};
                for(var u in r)/^on(Ani|Tra|Tou)/.test(u) && (r[u.toLowerCase()] = r[u], delete r[u]), o[u.toLowerCase()] = u;
                if (o.ondoubleclick && (r.ondblclick = r[o.ondoubleclick], delete r[o.ondoubleclick]), o.onbeforeinput && (r.onbeforeinput = r[o.onbeforeinput], delete r[o.onbeforeinput]), o.onchange && ("textarea" === e || "input" === e.toLowerCase() && !/^fil|che|ra/i.test(r.type))) {
                    var i = o.oninput || "oninput";
                    r[i] || (r[i] = r[o.onchange], delete r[o.onchange]);
                }
            }
        }(), "function" == typeof t && !t.m && t.prototype && (I(t.prototype, "componentWillMount"), I(t.prototype, "componentWillReceiveProps"), I(t.prototype, "componentWillUpdate"), t.m = !0);
    }
    q && q(n);
};
var B = "16.8.0";
function G(n) {
    return (0, _preact.createElement).bind(null, n);
}
function J(n) {
    return !!n && n.$$typeof === H;
}
function K(n) {
    return J(n) ? (0, _preact.cloneElement).apply(null, arguments) : n;
}
function Q(n) {
    return !!n.__k && ((0, _preact.render)(null, n), !0);
}
function X(n) {
    return n && (n.base || 1 === n.nodeType && n) || null;
}
var Y = function(n, t) {
    return n(t);
};
exports.default = {
    useState: (0, _hooks.useState),
    useReducer: (0, _hooks.useReducer),
    useEffect: (0, _hooks.useEffect),
    useLayoutEffect: (0, _hooks.useLayoutEffect),
    useRef: (0, _hooks.useRef),
    useImperativeHandle: (0, _hooks.useImperativeHandle),
    useMemo: (0, _hooks.useMemo),
    useCallback: (0, _hooks.useCallback),
    useContext: (0, _hooks.useContext),
    useDebugValue: (0, _hooks.useDebugValue),
    version: "16.8.0",
    Children: R,
    render: T,
    hydrate: T,
    unmountComponentAtNode: Q,
    createPortal: z,
    createElement: (0, _preact.createElement),
    createContext: (0, _preact.createContext),
    createFactory: G,
    cloneElement: K,
    createRef: (0, _preact.createRef),
    Fragment: (0, _preact.Fragment),
    isValidElement: J,
    findDOMNode: X,
    Component: (0, _preact.Component),
    PureComponent: C,
    memo: _,
    forwardRef: S,
    unstable_batchedUpdates: Y,
    Suspense: U,
    SuspenseList: O,
    lazy: L
};

},{"preact/hooks":"2TRXI","preact":"hvsRZ","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2TRXI":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useState", ()=>m);
parcelHelpers.export(exports, "useReducer", ()=>p);
parcelHelpers.export(exports, "useEffect", ()=>l);
parcelHelpers.export(exports, "useLayoutEffect", ()=>y);
parcelHelpers.export(exports, "useRef", ()=>d);
parcelHelpers.export(exports, "useImperativeHandle", ()=>s);
parcelHelpers.export(exports, "useMemo", ()=>h);
parcelHelpers.export(exports, "useCallback", ()=>T);
parcelHelpers.export(exports, "useContext", ()=>w);
parcelHelpers.export(exports, "useDebugValue", ()=>A);
parcelHelpers.export(exports, "useErrorBoundary", ()=>F);
var _preact = require("preact");
var t, u, r, i = 0, o = [], c = (0, _preact.options).__r, f = (0, _preact.options).diffed, e = (0, _preact.options).__c, a = (0, _preact.options).unmount;
function v(t, r) {
    (0, _preact.options).__h && (0, _preact.options).__h(u, t, i || r), i = 0;
    var o = u.__H || (u.__H = {
        __: [],
        __h: []
    });
    return t >= o.__.length && o.__.push({}), o.__[t];
}
function m(n) {
    return i = 1, p(E, n);
}
function p(n, r, i) {
    var o = v(t++, 2);
    return o.__c || (o.__c = u, o.__ = [
        i ? i(r) : E(void 0, r),
        function(t) {
            var u = n(o.__[0], t);
            o.__[0] !== u && (o.__[0] = u, o.__c.setState({}));
        }
    ]), o.__;
}
function l(r, i) {
    var o = v(t++, 3);
    !(0, _preact.options).__s && x(o.__H, i) && (o.__ = r, o.__H = i, u.__H.__h.push(o));
}
function y(r, i) {
    var o = v(t++, 4);
    !(0, _preact.options).__s && x(o.__H, i) && (o.__ = r, o.__H = i, u.__h.push(o));
}
function d(n) {
    return i = 5, h(function() {
        return {
            current: n
        };
    }, []);
}
function s(n, t, u) {
    i = 6, y(function() {
        "function" == typeof n ? n(t()) : n && (n.current = t());
    }, null == u ? u : u.concat(n));
}
function h(n, u) {
    var r = v(t++, 7);
    return x(r.__H, u) ? (r.__H = u, r.__h = n, r.__ = n()) : r.__;
}
function T(n, t) {
    return i = 8, h(function() {
        return n;
    }, t);
}
function w(n) {
    var r = u.context[n.__c], i = v(t++, 9);
    return i.__c = n, r ? (null == i.__ && (i.__ = !0, r.sub(u)), r.props.value) : n.__;
}
function A(t, u) {
    (0, _preact.options).useDebugValue && (0, _preact.options).useDebugValue(u ? u(t) : t);
}
function F(n) {
    var r = v(t++, 10), i = m();
    return r.__ = n, u.componentDidCatch || (u.componentDidCatch = function(n) {
        r.__ && r.__(n), i[1](n);
    }), [
        i[0],
        function() {
            i[1](void 0);
        }
    ];
}
function _() {
    o.some(function(t) {
        if (t.__P) try {
            t.__H.__h.forEach(g), t.__H.__h.forEach(q), t.__H.__h = [];
        } catch (u) {
            return t.__H.__h = [], (0, _preact.options).__e(u, t.__v), !0;
        }
    }), o = [];
}
function g(n) {
    n.t && n.t();
}
function q(n) {
    var t = n.__();
    "function" == typeof t && (n.t = t);
}
function x(n, t) {
    return !n || t.some(function(t, u) {
        return t !== n[u];
    });
}
function E(n, t) {
    return "function" == typeof t ? t(n) : t;
}
(0, _preact.options).__r = function(n) {
    c && c(n), t = 0, (u = n.__c).__H && (u.__H.__h.forEach(g), u.__H.__h.forEach(q), u.__H.__h = []);
}, (0, _preact.options).diffed = function(t) {
    f && f(t);
    var u = t.__c;
    if (u) {
        var i = u.__H;
        i && i.__h.length && (1 !== o.push(u) && r === (0, _preact.options).requestAnimationFrame || ((r = (0, _preact.options).requestAnimationFrame) || function(n) {
            var t, u = function() {
                clearTimeout(r), cancelAnimationFrame(t), setTimeout(n);
            }, r = setTimeout(u, 100);
            "undefined" != typeof window && (t = requestAnimationFrame(u));
        })(_));
    }
}, (0, _preact.options).__c = function(t, u) {
    u.some(function(t) {
        try {
            t.__h.forEach(g), t.__h = t.__h.filter(function(n) {
                return !n.__ || q(n);
            });
        } catch (r) {
            u.some(function(n) {
                n.__h && (n.__h = []);
            }), u = [], (0, _preact.options).__e(r, t.__v);
        }
    }), e && e(t, u);
}, (0, _preact.options).unmount = function(t) {
    a && a(t);
    var u = t.__c;
    if (u) {
        var r = u.__H;
        if (r) try {
            r.__.forEach(function(n) {
                return n.t && n.t();
            });
        } catch (t) {
            (0, _preact.options).__e(t, u.__v);
        }
    }
};

},{"preact":"hvsRZ","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"hvsRZ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "render", ()=>H);
parcelHelpers.export(exports, "hydrate", ()=>I);
parcelHelpers.export(exports, "createElement", ()=>h);
parcelHelpers.export(exports, "h", ()=>h);
parcelHelpers.export(exports, "Fragment", ()=>d);
parcelHelpers.export(exports, "createRef", ()=>y);
parcelHelpers.export(exports, "isValidElement", ()=>l);
parcelHelpers.export(exports, "Component", ()=>m);
parcelHelpers.export(exports, "cloneElement", ()=>L);
parcelHelpers.export(exports, "createContext", ()=>M);
parcelHelpers.export(exports, "toChildArray", ()=>x);
parcelHelpers.export(exports, "_unmount", ()=>D);
parcelHelpers.export(exports, "options", ()=>n);
var n, l, u, i, t, r, o, f, e = {}, c = [], s = /acit|ex(?:s|g|n|p|$)|rph|grid|ows|mnc|ntw|ine[ch]|zoo|^ord/i;
function a(n, l) {
    for(var u in l)n[u] = l[u];
    return n;
}
function v(n) {
    var l = n.parentNode;
    l && l.removeChild(n);
}
function h(n, l, u) {
    var i, t = arguments, r = {};
    for(i in l)"key" !== i && "ref" !== i && (r[i] = l[i]);
    if (arguments.length > 3) for(u = [
        u
    ], i = 3; i < arguments.length; i++)u.push(t[i]);
    if (null != u && (r.children = u), "function" == typeof n && null != n.defaultProps) for(i in n.defaultProps)void 0 === r[i] && (r[i] = n.defaultProps[i]);
    return p(n, r, l && l.key, l && l.ref, null);
}
function p(l, u, i, t, r) {
    var o = {
        type: l,
        props: u,
        key: i,
        ref: t,
        __k: null,
        __: null,
        __b: 0,
        __e: null,
        __d: void 0,
        __c: null,
        constructor: void 0,
        __v: r
    };
    return null == r && (o.__v = o), n.vnode && n.vnode(o), o;
}
function y() {
    return {};
}
function d(n) {
    return n.children;
}
function m(n, l) {
    this.props = n, this.context = l;
}
function w(n, l) {
    if (null == l) return n.__ ? w(n.__, n.__.__k.indexOf(n) + 1) : null;
    for(var u; l < n.__k.length; l++)if (null != (u = n.__k[l]) && null != u.__e) return u.__e;
    return "function" == typeof n.type ? w(n) : null;
}
function k(n) {
    var l, u;
    if (null != (n = n.__) && null != n.__c) {
        for(n.__e = n.__c.base = null, l = 0; l < n.__k.length; l++)if (null != (u = n.__k[l]) && null != u.__e) {
            n.__e = n.__c.base = u.__e;
            break;
        }
        return k(n);
    }
}
function g(l) {
    (!l.__d && (l.__d = !0) && u.push(l) && !i++ || r !== n.debounceRendering) && ((r = n.debounceRendering) || t)(_);
}
function _() {
    for(var n; i = u.length;)n = u.sort(function(n, l) {
        return n.__v.__b - l.__v.__b;
    }), u = [], n.some(function(n) {
        var l, u, i, t, r, o, f;
        n.__d && (o = (r = (l = n).__v).__e, (f = l.__P) && (u = [], (i = a({}, r)).__v = i, t = A(f, r, i, l.__n, void 0 !== f.ownerSVGElement, null, u, null == o ? w(r) : o), T(u, r), t != o && k(r)));
    });
}
function b(n, l, u, i, t, r, o, f, s) {
    var a, h, p, y, d, m, k, g = u && u.__k || c, _ = g.length;
    if (f == e && (f = null != r ? r[0] : _ ? w(u, 0) : null), a = 0, l.__k = x(l.__k, function(u) {
        if (null != u) {
            if (u.__ = l, u.__b = l.__b + 1, null === (p = g[a]) || p && u.key == p.key && u.type === p.type) g[a] = void 0;
            else for(h = 0; h < _; h++){
                if ((p = g[h]) && u.key == p.key && u.type === p.type) {
                    g[h] = void 0;
                    break;
                }
                p = null;
            }
            if (y = A(n, u, p = p || e, i, t, r, o, f, s), (h = u.ref) && p.ref != h && (k || (k = []), p.ref && k.push(p.ref, null, u), k.push(h, u.__c || y, u)), null != y) {
                var c;
                if (null == m && (m = y), void 0 !== u.__d) c = u.__d, u.__d = void 0;
                else if (r == p || y != f || null == y.parentNode) {
                    n: if (null == f || f.parentNode !== n) n.appendChild(y), c = null;
                    else {
                        for(d = f, h = 0; (d = d.nextSibling) && h < _; h += 2)if (d == y) break n;
                        n.insertBefore(y, f), c = f;
                    }
                    "option" == l.type && (n.value = "");
                }
                f = void 0 !== c ? c : y.nextSibling, "function" == typeof l.type && (l.__d = f);
            } else f && p.__e == f && f.parentNode != n && (f = w(p));
        }
        return a++, u;
    }), l.__e = m, null != r && "function" != typeof l.type) for(a = r.length; a--;)null != r[a] && v(r[a]);
    for(a = _; a--;)null != g[a] && D(g[a], g[a]);
    if (k) for(a = 0; a < k.length; a++)j(k[a], k[++a], k[++a]);
}
function x(n, l, u) {
    if (null == u && (u = []), null == n || "boolean" == typeof n) l && u.push(l(null));
    else if (Array.isArray(n)) for(var i = 0; i < n.length; i++)x(n[i], l, u);
    else u.push(l ? l("string" == typeof n || "number" == typeof n ? p(null, n, null, null, n) : null != n.__e || null != n.__c ? p(n.type, n.props, n.key, null, n.__v) : n) : n);
    return u;
}
function P(n, l, u, i, t) {
    var r;
    for(r in u)"children" === r || "key" === r || r in l || N(n, r, null, u[r], i);
    for(r in l)t && "function" != typeof l[r] || "children" === r || "key" === r || "value" === r || "checked" === r || u[r] === l[r] || N(n, r, l[r], u[r], i);
}
function C(n, l, u) {
    "-" === l[0] ? n.setProperty(l, u) : n[l] = "number" == typeof u && !1 === s.test(l) ? u + "px" : null == u ? "" : u;
}
function N(n, l, u, i, t) {
    var r, o, f, e, c;
    if (t ? "className" === l && (l = "class") : "class" === l && (l = "className"), "style" === l) {
        if (r = n.style, "string" == typeof u) r.cssText = u;
        else {
            if ("string" == typeof i && (r.cssText = "", i = null), i) for(e in i)u && e in u || C(r, e, "");
            if (u) for(c in u)i && u[c] === i[c] || C(r, c, u[c]);
        }
    } else "o" === l[0] && "n" === l[1] ? (o = l !== (l = l.replace(/Capture$/, "")), f = l.toLowerCase(), l = (f in n ? f : l).slice(2), u ? (i || n.addEventListener(l, z, o), (n.l || (n.l = {}))[l] = u) : n.removeEventListener(l, z, o)) : "list" !== l && "tagName" !== l && "form" !== l && "type" !== l && "size" !== l && !t && l in n ? n[l] = null == u ? "" : u : "function" != typeof u && "dangerouslySetInnerHTML" !== l && (l !== (l = l.replace(/^xlink:?/, "")) ? null == u || !1 === u ? n.removeAttributeNS("http://www.w3.org/1999/xlink", l.toLowerCase()) : n.setAttributeNS("http://www.w3.org/1999/xlink", l.toLowerCase(), u) : null == u || !1 === u && !/^ar/.test(l) ? n.removeAttribute(l) : n.setAttribute(l, u));
}
function z(l) {
    this.l[l.type](n.event ? n.event(l) : l);
}
function A(l, u, i, t, r, o, f, e, c) {
    var s, v, h, p, y, w, k, g, _, x, P = u.type;
    if (void 0 !== u.constructor) return null;
    (s = n.__b) && s(u);
    try {
        n: if ("function" == typeof P) {
            if (g = u.props, _ = (s = P.contextType) && t[s.__c], x = s ? _ ? _.props.value : s.__ : t, i.__c ? k = (v = u.__c = i.__c).__ = v.__E : ("prototype" in P && P.prototype.render ? u.__c = v = new P(g, x) : (u.__c = v = new m(g, x), v.constructor = P, v.render = E), _ && _.sub(v), v.props = g, v.state || (v.state = {}), v.context = x, v.__n = t, h = v.__d = !0, v.__h = []), null == v.__s && (v.__s = v.state), null != P.getDerivedStateFromProps && (v.__s == v.state && (v.__s = a({}, v.__s)), a(v.__s, P.getDerivedStateFromProps(g, v.__s))), p = v.props, y = v.state, h) null == P.getDerivedStateFromProps && null != v.componentWillMount && v.componentWillMount(), null != v.componentDidMount && v.__h.push(v.componentDidMount);
            else {
                if (null == P.getDerivedStateFromProps && g !== p && null != v.componentWillReceiveProps && v.componentWillReceiveProps(g, x), !v.__e && null != v.shouldComponentUpdate && !1 === v.shouldComponentUpdate(g, v.__s, x) || u.__v === i.__v && !v.__) {
                    for(v.props = g, v.state = v.__s, u.__v !== i.__v && (v.__d = !1), v.__v = u, u.__e = i.__e, u.__k = i.__k, v.__h.length && f.push(v), s = 0; s < u.__k.length; s++)u.__k[s] && (u.__k[s].__ = u);
                    break n;
                }
                null != v.componentWillUpdate && v.componentWillUpdate(g, v.__s, x), null != v.componentDidUpdate && v.__h.push(function() {
                    v.componentDidUpdate(p, y, w);
                });
            }
            v.context = x, v.props = g, v.state = v.__s, (s = n.__r) && s(u), v.__d = !1, v.__v = u, v.__P = l, s = v.render(v.props, v.state, v.context), u.__k = null != s && s.type == d && null == s.key ? s.props.children : Array.isArray(s) ? s : [
                s
            ], null != v.getChildContext && (t = a(a({}, t), v.getChildContext())), h || null == v.getSnapshotBeforeUpdate || (w = v.getSnapshotBeforeUpdate(p, y)), b(l, u, i, t, r, o, f, e, c), v.base = u.__e, v.__h.length && f.push(v), k && (v.__E = v.__ = null), v.__e = !1;
        } else null == o && u.__v === i.__v ? (u.__k = i.__k, u.__e = i.__e) : u.__e = $(i.__e, u, i, t, r, o, f, c);
        (s = n.diffed) && s(u);
    } catch (l) {
        u.__v = null, n.__e(l, u, i);
    }
    return u.__e;
}
function T(l, u) {
    n.__c && n.__c(u, l), l.some(function(u) {
        try {
            l = u.__h, u.__h = [], l.some(function(n) {
                n.call(u);
            });
        } catch (l) {
            n.__e(l, u.__v);
        }
    });
}
function $(n, l, u, i, t, r, o, f) {
    var s, a, v, h, p, y = u.props, d = l.props;
    if (t = "svg" === l.type || t, null != r) {
        for(s = 0; s < r.length; s++)if (null != (a = r[s]) && ((null === l.type ? 3 === a.nodeType : a.localName === l.type) || n == a)) {
            n = a, r[s] = null;
            break;
        }
    }
    if (null == n) {
        if (null === l.type) return document.createTextNode(d);
        n = t ? document.createElementNS("http://www.w3.org/2000/svg", l.type) : document.createElement(l.type, d.is && {
            is: d.is
        }), r = null, f = !1;
    }
    if (null === l.type) y !== d && n.data != d && (n.data = d);
    else {
        if (null != r && (r = c.slice.call(n.childNodes)), v = (y = u.props || e).dangerouslySetInnerHTML, h = d.dangerouslySetInnerHTML, !f) {
            if (y === e) for(y = {}, p = 0; p < n.attributes.length; p++)y[n.attributes[p].name] = n.attributes[p].value;
            (h || v) && (h && v && h.__html == v.__html || (n.innerHTML = h && h.__html || ""));
        }
        P(n, d, y, t, f), h ? l.__k = [] : (l.__k = l.props.children, b(n, l, u, i, "foreignObject" !== l.type && t, r, o, e, f)), f || ("value" in d && void 0 !== (s = d.value) && s !== n.value && N(n, "value", s, y.value, !1), "checked" in d && void 0 !== (s = d.checked) && s !== n.checked && N(n, "checked", s, y.checked, !1));
    }
    return n;
}
function j(l, u, i) {
    try {
        "function" == typeof l ? l(u) : l.current = u;
    } catch (l) {
        n.__e(l, i);
    }
}
function D(l, u, i) {
    var t, r, o;
    if (n.unmount && n.unmount(l), (t = l.ref) && (t.current && t.current !== l.__e || j(t, null, u)), i || "function" == typeof l.type || (i = null != (r = l.__e)), l.__e = l.__d = void 0, null != (t = l.__c)) {
        if (t.componentWillUnmount) try {
            t.componentWillUnmount();
        } catch (l) {
            n.__e(l, u);
        }
        t.base = t.__P = null;
    }
    if (t = l.__k) for(o = 0; o < t.length; o++)t[o] && D(t[o], u, i);
    null != r && v(r);
}
function E(n, l, u) {
    return this.constructor(n, u);
}
function H(l, u, i) {
    var t, r, f;
    n.__ && n.__(l, u), r = (t = i === o) ? null : i && i.__k || u.__k, l = h(d, null, [
        l
    ]), f = [], A(u, (t ? u : i || u).__k = l, r || e, e, void 0 !== u.ownerSVGElement, i && !t ? [
        i
    ] : r ? null : c.slice.call(u.childNodes), f, i || e, t), T(f, l);
}
function I(n, l) {
    H(n, l, o);
}
function L(n, l) {
    var u, i;
    for(i in l = a(a({}, n.props), l), arguments.length > 2 && (l.children = c.slice.call(arguments, 2)), u = {}, l)"key" !== i && "ref" !== i && (u[i] = l[i]);
    return p(n.type, u, l.key || n.key, l.ref || n.ref, null);
}
function M(n) {
    var l = {}, u = {
        __c: "__cC" + f++,
        __: n,
        Consumer: function(n, l) {
            return n.children(l);
        },
        Provider: function(n) {
            var i, t = this;
            return this.getChildContext || (i = [], this.getChildContext = function() {
                return l[u.__c] = t, l;
            }, this.shouldComponentUpdate = function(n) {
                t.props.value !== n.value && i.some(function(l) {
                    l.context = n.value, g(l);
                });
            }, this.sub = function(n) {
                i.push(n);
                var l = n.componentWillUnmount;
                n.componentWillUnmount = function() {
                    i.splice(i.indexOf(n), 1), l && l.call(n);
                };
            }), n.children;
        }
    };
    return u.Consumer.contextType = u, u.Provider.__ = u, u;
}
n = {
    __e: function(n, l) {
        for(var u, i; l = l.__;)if ((u = l.__c) && !u.__) try {
            if (u.constructor && null != u.constructor.getDerivedStateFromError && (i = !0, u.setState(u.constructor.getDerivedStateFromError(n))), null != u.componentDidCatch && (i = !0, u.componentDidCatch(n)), i) return g(u.__E = u);
        } catch (l) {
            n = l;
        }
        throw n;
    }
}, l = function(n) {
    return null != n && void 0 === n.constructor;
}, m.prototype.setState = function(n, l) {
    var u;
    u = this.__s !== this.state ? this.__s : this.__s = a({}, this.state), "function" == typeof n && (n = n(u, this.props)), n && a(u, n), null != n && this.__v && (l && this.__h.push(l), g(this));
}, m.prototype.forceUpdate = function(n) {
    this.__v && (this.__e = !0, n && this.__h.push(n), g(this));
}, m.prototype.render = d, u = [], i = 0, t = "function" == typeof Promise ? Promise.prototype.then.bind(Promise.resolve()) : setTimeout, o = e, f = 0;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"dANEb":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _eventemitter3 = require("eventemitter3");
var _eventemitter3Default = parcelHelpers.interopDefault(_eventemitter3);
var _xhr2Cookies = require("xhr2-cookies");
var _utils = require("@walletconnect/utils");
const XHR = (0, _utils.getFromWindow)("XMLHttpRequest") || (0, _xhr2Cookies.XMLHttpRequest);
class HTTPConnection extends (0, _eventemitter3Default.default) {
    constructor(url){
        super();
        this.url = url;
    }
    formatError(payload, message, code = -1) {
        return {
            error: {
                message,
                code
            },
            id: payload.id,
            jsonrpc: payload.jsonrpc
        };
    }
    send(payload, internal) {
        return new Promise((resolve)=>{
            if (payload.method === "eth_subscribe") {
                const error = this.formatError(payload, "Subscriptions are not supported by this HTTP endpoint");
                this.emit("error", error);
                return resolve(error);
            }
            const xhr = new XHR();
            let responded = false;
            const res = (err, result)=>{
                if (!responded) {
                    xhr.abort();
                    responded = true;
                    if (internal) internal(err, result);
                    else {
                        const { id, jsonrpc } = payload;
                        const response = err ? {
                            id,
                            jsonrpc,
                            error: {
                                message: err.message,
                                code: err.code
                            }
                        } : {
                            id,
                            jsonrpc,
                            result
                        };
                        this.emit("payload", response);
                        resolve(response);
                    }
                }
            };
            xhr.open("POST", this.url, true);
            xhr.setRequestHeader("Content-Type", "application/json");
            xhr.timeout = 60000;
            xhr.onerror = res;
            xhr.ontimeout = res;
            xhr.onreadystatechange = ()=>{
                if (xhr.readyState === 4) try {
                    const response = JSON.parse(xhr.responseText);
                    res(response.error, response.result);
                } catch (e) {
                    res(e);
                }
            };
            xhr.send(JSON.stringify(payload));
        });
    }
}
exports.default = HTTPConnection;

},{"eventemitter3":"b6Sxq","xhr2-cookies":"bEaxu","@walletconnect/utils":"bFQqa","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"b6Sxq":[function(require,module,exports) {
"use strict";
var has = Object.prototype.hasOwnProperty, prefix = "~";
/**
 * Constructor to create a storage for our `EE` objects.
 * An `Events` instance is a plain object whose properties are event names.
 *
 * @constructor
 * @private
 */ function Events() {}
//
// We try to not inherit from `Object.prototype`. In some engines creating an
// instance in this way is faster than calling `Object.create(null)` directly.
// If `Object.create(null)` is not supported we prefix the event names with a
// character to make sure that the built-in object properties are not
// overridden or used as an attack vector.
//
if (Object.create) {
    Events.prototype = Object.create(null);
    //
    // This hack is needed because the `__proto__` property is still inherited in
    // some old browsers like Android 4, iPhone 5.1, Opera 11 and Safari 5.
    //
    if (!new Events().__proto__) prefix = false;
}
/**
 * Representation of a single event listener.
 *
 * @param {Function} fn The listener function.
 * @param {*} context The context to invoke the listener with.
 * @param {Boolean} [once=false] Specify if the listener is a one-time listener.
 * @constructor
 * @private
 */ function EE(fn, context, once) {
    this.fn = fn;
    this.context = context;
    this.once = once || false;
}
/**
 * Add a listener for a given event.
 *
 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} context The context to invoke the listener with.
 * @param {Boolean} once Specify if the listener is a one-time listener.
 * @returns {EventEmitter}
 * @private
 */ function addListener(emitter, event, fn, context, once) {
    if (typeof fn !== "function") throw new TypeError("The listener must be a function");
    var listener = new EE(fn, context || emitter, once), evt = prefix ? prefix + event : event;
    if (!emitter._events[evt]) emitter._events[evt] = listener, emitter._eventsCount++;
    else if (!emitter._events[evt].fn) emitter._events[evt].push(listener);
    else emitter._events[evt] = [
        emitter._events[evt],
        listener
    ];
    return emitter;
}
/**
 * Clear event by name.
 *
 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
 * @param {(String|Symbol)} evt The Event name.
 * @private
 */ function clearEvent(emitter, evt) {
    if (--emitter._eventsCount === 0) emitter._events = new Events();
    else delete emitter._events[evt];
}
/**
 * Minimal `EventEmitter` interface that is molded against the Node.js
 * `EventEmitter` interface.
 *
 * @constructor
 * @public
 */ function EventEmitter() {
    this._events = new Events();
    this._eventsCount = 0;
}
/**
 * Return an array listing the events for which the emitter has registered
 * listeners.
 *
 * @returns {Array}
 * @public
 */ EventEmitter.prototype.eventNames = function eventNames() {
    var names = [], events, name;
    if (this._eventsCount === 0) return names;
    for(name in events = this._events)if (has.call(events, name)) names.push(prefix ? name.slice(1) : name);
    if (Object.getOwnPropertySymbols) return names.concat(Object.getOwnPropertySymbols(events));
    return names;
};
/**
 * Return the listeners registered for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Array} The registered listeners.
 * @public
 */ EventEmitter.prototype.listeners = function listeners(event) {
    var evt = prefix ? prefix + event : event, handlers = this._events[evt];
    if (!handlers) return [];
    if (handlers.fn) return [
        handlers.fn
    ];
    for(var i = 0, l = handlers.length, ee = new Array(l); i < l; i++)ee[i] = handlers[i].fn;
    return ee;
};
/**
 * Return the number of listeners listening to a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Number} The number of listeners.
 * @public
 */ EventEmitter.prototype.listenerCount = function listenerCount(event) {
    var evt = prefix ? prefix + event : event, listeners = this._events[evt];
    if (!listeners) return 0;
    if (listeners.fn) return 1;
    return listeners.length;
};
/**
 * Calls each of the listeners registered for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Boolean} `true` if the event had listeners, else `false`.
 * @public
 */ EventEmitter.prototype.emit = function emit(event, a1, a2, a3, a4, a5) {
    var evt = prefix ? prefix + event : event;
    if (!this._events[evt]) return false;
    var listeners = this._events[evt], len = arguments.length, args, i;
    if (listeners.fn) {
        if (listeners.once) this.removeListener(event, listeners.fn, undefined, true);
        switch(len){
            case 1:
                return listeners.fn.call(listeners.context), true;
            case 2:
                return listeners.fn.call(listeners.context, a1), true;
            case 3:
                return listeners.fn.call(listeners.context, a1, a2), true;
            case 4:
                return listeners.fn.call(listeners.context, a1, a2, a3), true;
            case 5:
                return listeners.fn.call(listeners.context, a1, a2, a3, a4), true;
            case 6:
                return listeners.fn.call(listeners.context, a1, a2, a3, a4, a5), true;
        }
        for(i = 1, args = new Array(len - 1); i < len; i++)args[i - 1] = arguments[i];
        listeners.fn.apply(listeners.context, args);
    } else {
        var length = listeners.length, j;
        for(i = 0; i < length; i++){
            if (listeners[i].once) this.removeListener(event, listeners[i].fn, undefined, true);
            switch(len){
                case 1:
                    listeners[i].fn.call(listeners[i].context);
                    break;
                case 2:
                    listeners[i].fn.call(listeners[i].context, a1);
                    break;
                case 3:
                    listeners[i].fn.call(listeners[i].context, a1, a2);
                    break;
                case 4:
                    listeners[i].fn.call(listeners[i].context, a1, a2, a3);
                    break;
                default:
                    if (!args) for(j = 1, args = new Array(len - 1); j < len; j++)args[j - 1] = arguments[j];
                    listeners[i].fn.apply(listeners[i].context, args);
            }
        }
    }
    return true;
};
/**
 * Add a listener for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @public
 */ EventEmitter.prototype.on = function on(event, fn, context) {
    return addListener(this, event, fn, context, false);
};
/**
 * Add a one-time listener for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @public
 */ EventEmitter.prototype.once = function once(event, fn, context) {
    return addListener(this, event, fn, context, true);
};
/**
 * Remove the listeners of a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn Only remove the listeners that match this function.
 * @param {*} context Only remove the listeners that have this context.
 * @param {Boolean} once Only remove one-time listeners.
 * @returns {EventEmitter} `this`.
 * @public
 */ EventEmitter.prototype.removeListener = function removeListener(event, fn, context, once) {
    var evt = prefix ? prefix + event : event;
    if (!this._events[evt]) return this;
    if (!fn) {
        clearEvent(this, evt);
        return this;
    }
    var listeners = this._events[evt];
    if (listeners.fn) {
        if (listeners.fn === fn && (!once || listeners.once) && (!context || listeners.context === context)) clearEvent(this, evt);
    } else {
        for(var i = 0, events = [], length = listeners.length; i < length; i++)if (listeners[i].fn !== fn || once && !listeners[i].once || context && listeners[i].context !== context) events.push(listeners[i]);
        //
        // Reset the array, or remove it completely if we have no more listeners.
        //
        if (events.length) this._events[evt] = events.length === 1 ? events[0] : events;
        else clearEvent(this, evt);
    }
    return this;
};
/**
 * Remove all listeners, or those of the specified event.
 *
 * @param {(String|Symbol)} [event] The event name.
 * @returns {EventEmitter} `this`.
 * @public
 */ EventEmitter.prototype.removeAllListeners = function removeAllListeners(event) {
    var evt;
    if (event) {
        evt = prefix ? prefix + event : event;
        if (this._events[evt]) clearEvent(this, evt);
    } else {
        this._events = new Events();
        this._eventsCount = 0;
    }
    return this;
};
//
// Alias methods names because people roll like that.
//
EventEmitter.prototype.off = EventEmitter.prototype.removeListener;
EventEmitter.prototype.addListener = EventEmitter.prototype.on;
//
// Expose the prefix.
//
EventEmitter.prefixed = prefix;
//
// Allow `EventEmitter` to be imported as module namespace.
//
EventEmitter.EventEmitter = EventEmitter;
module.exports = EventEmitter;

},{}],"bEaxu":[function(require,module,exports) {
"use strict";
function __export(m) {
    for(var p in m)if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", {
    value: true
});
__export(require("aa0fb69cefa637e6"));
var xml_http_request_event_target_1 = require("ad08dbfddc05dec5");
exports.XMLHttpRequestEventTarget = xml_http_request_event_target_1.XMLHttpRequestEventTarget;

},{"aa0fb69cefa637e6":"azIIa","ad08dbfddc05dec5":"lxN39"}],"azIIa":[function(require,module,exports) {
var process = require("bbae9bebbc2dc8d7");
var Buffer = require("6f88cb76a21cd66").Buffer;
"use strict";
var __extends = this && this.__extends || function() {
    var extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var __assign = this && this.__assign || Object.assign || function(t) {
    for(var s, i = 1, n = arguments.length; i < n; i++){
        s = arguments[i];
        for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", {
    value: true
});
var http = require("da3ed69ca65b1849");
var https = require("3cc5090dbe91f9bf");
var os = require("94f09bf8c29cafaf");
var url = require("199aab2322d593b1");
var progress_event_1 = require("2199eed71b8980ed");
var errors_1 = require("65d1765f2f249c0d");
var xml_http_request_event_target_1 = require("4448db7cf1b03c4c");
var xml_http_request_upload_1 = require("fbfe3be773dd3ae4");
var Cookie = require("dad0edbd70d44de6");
var XMLHttpRequest = /** @class */ function(_super) {
    __extends(XMLHttpRequest, _super);
    function XMLHttpRequest(options) {
        if (options === void 0) options = {};
        var _this = _super.call(this) || this;
        _this.UNSENT = XMLHttpRequest.UNSENT;
        _this.OPENED = XMLHttpRequest.OPENED;
        _this.HEADERS_RECEIVED = XMLHttpRequest.HEADERS_RECEIVED;
        _this.LOADING = XMLHttpRequest.LOADING;
        _this.DONE = XMLHttpRequest.DONE;
        _this.onreadystatechange = null;
        _this.readyState = XMLHttpRequest.UNSENT;
        _this.response = null;
        _this.responseText = "";
        _this.responseType = "";
        _this.status = 0; // TODO: UNSENT?
        _this.statusText = "";
        _this.timeout = 0;
        _this.upload = new xml_http_request_upload_1.XMLHttpRequestUpload();
        _this.responseUrl = "";
        _this.withCredentials = false;
        _this._method = null;
        _this._url = null;
        _this._sync = false;
        _this._headers = {};
        _this._loweredHeaders = {};
        _this._mimeOverride = null; // TODO: is type right?
        _this._request = null;
        _this._response = null;
        _this._responseParts = null;
        _this._responseHeaders = null;
        _this._aborting = null; // TODO: type?
        _this._error = null; // TODO: type?
        _this._loadedBytes = 0;
        _this._totalBytes = 0;
        _this._lengthComputable = false;
        _this._restrictedMethods = {
            CONNECT: true,
            TRACE: true,
            TRACK: true
        };
        _this._restrictedHeaders = {
            "accept-charset": true,
            "accept-encoding": true,
            "access-control-request-headers": true,
            "access-control-request-method": true,
            connection: true,
            "content-length": true,
            cookie: true,
            cookie2: true,
            date: true,
            dnt: true,
            expect: true,
            host: true,
            "keep-alive": true,
            origin: true,
            referer: true,
            te: true,
            trailer: true,
            "transfer-encoding": true,
            upgrade: true,
            "user-agent": true,
            via: true
        };
        _this._privateHeaders = {
            "set-cookie": true,
            "set-cookie2": true
        };
        _this._userAgent = "Mozilla/5.0 (" + os.type() + " " + os.arch() + ") node.js/" + process.versions.node + " v8/" + process.versions.v8;
        _this._anonymous = options.anon || false;
        return _this;
    }
    XMLHttpRequest.prototype.open = function(method, url, async, user, password) {
        if (async === void 0) async = true;
        method = method.toUpperCase();
        if (this._restrictedMethods[method]) throw new XMLHttpRequest.SecurityError("HTTP method " + method + " is not allowed in XHR");
        var xhrUrl = this._parseUrl(url, user, password);
        this.readyState === XMLHttpRequest.HEADERS_RECEIVED || (this.readyState, XMLHttpRequest.LOADING);
        this._method = method;
        this._url = xhrUrl;
        this._sync = !async;
        this._headers = {};
        this._loweredHeaders = {};
        this._mimeOverride = null;
        this._setReadyState(XMLHttpRequest.OPENED);
        this._request = null;
        this._response = null;
        this.status = 0;
        this.statusText = "";
        this._responseParts = [];
        this._responseHeaders = null;
        this._loadedBytes = 0;
        this._totalBytes = 0;
        this._lengthComputable = false;
    };
    XMLHttpRequest.prototype.setRequestHeader = function(name, value) {
        if (this.readyState !== XMLHttpRequest.OPENED) throw new XMLHttpRequest.InvalidStateError("XHR readyState must be OPENED");
        var loweredName = name.toLowerCase();
        if (this._restrictedHeaders[loweredName] || /^sec-/.test(loweredName) || /^proxy-/.test(loweredName)) {
            console.warn('Refused to set unsafe header "' + name + '"');
            return;
        }
        value = value.toString();
        if (this._loweredHeaders[loweredName] != null) {
            name = this._loweredHeaders[loweredName];
            this._headers[name] = this._headers[name] + ", " + value;
        } else {
            this._loweredHeaders[loweredName] = name;
            this._headers[name] = value;
        }
    };
    XMLHttpRequest.prototype.send = function(data) {
        if (this.readyState !== XMLHttpRequest.OPENED) throw new XMLHttpRequest.InvalidStateError("XHR readyState must be OPENED");
        if (this._request) throw new XMLHttpRequest.InvalidStateError("send() already called");
        switch(this._url.protocol){
            case "file:":
                return this._sendFile(data);
            case "http:":
            case "https:":
                return this._sendHttp(data);
            default:
                throw new XMLHttpRequest.NetworkError("Unsupported protocol " + this._url.protocol);
        }
    };
    XMLHttpRequest.prototype.abort = function() {
        if (this._request == null) return;
        this._request.abort();
        this._setError();
        this._dispatchProgress("abort");
        this._dispatchProgress("loadend");
    };
    XMLHttpRequest.prototype.getResponseHeader = function(name) {
        if (this._responseHeaders == null || name == null) return null;
        var loweredName = name.toLowerCase();
        return this._responseHeaders.hasOwnProperty(loweredName) ? this._responseHeaders[name.toLowerCase()] : null;
    };
    XMLHttpRequest.prototype.getAllResponseHeaders = function() {
        var _this = this;
        if (this._responseHeaders == null) return "";
        return Object.keys(this._responseHeaders).map(function(key) {
            return key + ": " + _this._responseHeaders[key];
        }).join("\r\n");
    };
    XMLHttpRequest.prototype.overrideMimeType = function(mimeType) {
        if (this.readyState === XMLHttpRequest.LOADING || this.readyState === XMLHttpRequest.DONE) throw new XMLHttpRequest.InvalidStateError("overrideMimeType() not allowed in LOADING or DONE");
        this._mimeOverride = mimeType.toLowerCase();
    };
    XMLHttpRequest.prototype.nodejsSet = function(options) {
        this.nodejsHttpAgent = options.httpAgent || this.nodejsHttpAgent;
        this.nodejsHttpsAgent = options.httpsAgent || this.nodejsHttpsAgent;
        if (options.hasOwnProperty("baseUrl")) {
            if (options.baseUrl != null) {
                var parsedUrl = url.parse(options.baseUrl, false, true);
                if (!parsedUrl.protocol) throw new XMLHttpRequest.SyntaxError("baseUrl must be an absolute URL");
            }
            this.nodejsBaseUrl = options.baseUrl;
        }
    };
    XMLHttpRequest.nodejsSet = function(options) {
        XMLHttpRequest.prototype.nodejsSet(options);
    };
    XMLHttpRequest.prototype._setReadyState = function(readyState) {
        this.readyState = readyState;
        this.dispatchEvent(new progress_event_1.ProgressEvent("readystatechange"));
    };
    XMLHttpRequest.prototype._sendFile = function(data) {
        // TODO
        throw new Error("Protocol file: not implemented");
    };
    XMLHttpRequest.prototype._sendHttp = function(data) {
        if (this._sync) throw new Error("Synchronous XHR processing not implemented");
        if (data && (this._method === "GET" || this._method === "HEAD")) {
            console.warn("Discarding entity body for " + this._method + " requests");
            data = null;
        } else data = data || "";
        this.upload._setData(data);
        this._finalizeHeaders();
        this._sendHxxpRequest();
    };
    XMLHttpRequest.prototype._sendHxxpRequest = function() {
        var _this = this;
        if (this.withCredentials) {
            var cookie = XMLHttpRequest.cookieJar.getCookies(Cookie.CookieAccessInfo(this._url.hostname, this._url.pathname, this._url.protocol === "https:")).toValueString();
            this._headers.cookie = this._headers.cookie2 = cookie;
        }
        var _a = this._url.protocol === "http:" ? [
            http,
            this.nodejsHttpAgent
        ] : [
            https,
            this.nodejsHttpsAgent
        ], hxxp = _a[0], agent = _a[1];
        var requestMethod = hxxp.request.bind(hxxp);
        var request = requestMethod({
            hostname: this._url.hostname,
            port: +this._url.port,
            path: this._url.path,
            auth: this._url.auth,
            method: this._method,
            headers: this._headers,
            agent: agent
        });
        this._request = request;
        if (this.timeout) request.setTimeout(this.timeout, function() {
            return _this._onHttpTimeout(request);
        });
        request.on("response", function(response) {
            return _this._onHttpResponse(request, response);
        });
        request.on("error", function(error) {
            return _this._onHttpRequestError(request, error);
        });
        this.upload._startUpload(request);
        if (this._request === request) this._dispatchProgress("loadstart");
    };
    XMLHttpRequest.prototype._finalizeHeaders = function() {
        this._headers = __assign({}, this._headers, {
            Connection: "keep-alive",
            Host: this._url.host,
            "User-Agent": this._userAgent
        }, this._anonymous ? {
            Referer: "about:blank"
        } : {});
        this.upload._finalizeHeaders(this._headers, this._loweredHeaders);
    };
    XMLHttpRequest.prototype._onHttpResponse = function(request, response) {
        var _this = this;
        if (this._request !== request) return;
        if (this.withCredentials && (response.headers["set-cookie"] || response.headers["set-cookie2"])) XMLHttpRequest.cookieJar.setCookies(response.headers["set-cookie"] || response.headers["set-cookie2"]);
        if ([
            301,
            302,
            303,
            307,
            308
        ].indexOf(response.statusCode) >= 0) {
            this._url = this._parseUrl(response.headers.location);
            this._method = "GET";
            if (this._loweredHeaders["content-type"]) {
                delete this._headers[this._loweredHeaders["content-type"]];
                delete this._loweredHeaders["content-type"];
            }
            if (this._headers["Content-Type"] != null) delete this._headers["Content-Type"];
            delete this._headers["Content-Length"];
            this.upload._reset();
            this._finalizeHeaders();
            this._sendHxxpRequest();
            return;
        }
        this._response = response;
        this._response.on("data", function(data) {
            return _this._onHttpResponseData(response, data);
        });
        this._response.on("end", function() {
            return _this._onHttpResponseEnd(response);
        });
        this._response.on("close", function() {
            return _this._onHttpResponseClose(response);
        });
        this.responseUrl = this._url.href.split("#")[0];
        this.status = response.statusCode;
        this.statusText = http.STATUS_CODES[this.status];
        this._parseResponseHeaders(response);
        var lengthString = this._responseHeaders["content-length"] || "";
        this._totalBytes = +lengthString;
        this._lengthComputable = !!lengthString;
        this._setReadyState(XMLHttpRequest.HEADERS_RECEIVED);
    };
    XMLHttpRequest.prototype._onHttpResponseData = function(response, data) {
        if (this._response !== response) return;
        this._responseParts.push(new Buffer(data));
        this._loadedBytes += data.length;
        if (this.readyState !== XMLHttpRequest.LOADING) this._setReadyState(XMLHttpRequest.LOADING);
        this._dispatchProgress("progress");
    };
    XMLHttpRequest.prototype._onHttpResponseEnd = function(response) {
        if (this._response !== response) return;
        this._parseResponse();
        this._request = null;
        this._response = null;
        this._setReadyState(XMLHttpRequest.DONE);
        this._dispatchProgress("load");
        this._dispatchProgress("loadend");
    };
    XMLHttpRequest.prototype._onHttpResponseClose = function(response) {
        if (this._response !== response) return;
        var request = this._request;
        this._setError();
        request.abort();
        this._setReadyState(XMLHttpRequest.DONE);
        this._dispatchProgress("error");
        this._dispatchProgress("loadend");
    };
    XMLHttpRequest.prototype._onHttpTimeout = function(request) {
        if (this._request !== request) return;
        this._setError();
        request.abort();
        this._setReadyState(XMLHttpRequest.DONE);
        this._dispatchProgress("timeout");
        this._dispatchProgress("loadend");
    };
    XMLHttpRequest.prototype._onHttpRequestError = function(request, error) {
        if (this._request !== request) return;
        this._setError();
        request.abort();
        this._setReadyState(XMLHttpRequest.DONE);
        this._dispatchProgress("error");
        this._dispatchProgress("loadend");
    };
    XMLHttpRequest.prototype._dispatchProgress = function(eventType) {
        var event = new XMLHttpRequest.ProgressEvent(eventType);
        event.lengthComputable = this._lengthComputable;
        event.loaded = this._loadedBytes;
        event.total = this._totalBytes;
        this.dispatchEvent(event);
    };
    XMLHttpRequest.prototype._setError = function() {
        this._request = null;
        this._response = null;
        this._responseHeaders = null;
        this._responseParts = null;
    };
    XMLHttpRequest.prototype._parseUrl = function(urlString, user, password) {
        var absoluteUrl = this.nodejsBaseUrl == null ? urlString : url.resolve(this.nodejsBaseUrl, urlString);
        var xhrUrl = url.parse(absoluteUrl, false, true);
        xhrUrl.hash = null;
        var _a = (xhrUrl.auth || "").split(":"), xhrUser = _a[0], xhrPassword = _a[1];
        if (xhrUser || xhrPassword || user || password) xhrUrl.auth = (user || xhrUser || "") + ":" + (password || xhrPassword || "");
        return xhrUrl;
    };
    XMLHttpRequest.prototype._parseResponseHeaders = function(response) {
        this._responseHeaders = {};
        for(var name_1 in response.headers){
            var loweredName = name_1.toLowerCase();
            if (this._privateHeaders[loweredName]) continue;
            this._responseHeaders[loweredName] = response.headers[name_1];
        }
        if (this._mimeOverride != null) this._responseHeaders["content-type"] = this._mimeOverride;
    };
    XMLHttpRequest.prototype._parseResponse = function() {
        var buffer = Buffer.concat(this._responseParts);
        this._responseParts = null;
        switch(this.responseType){
            case "json":
                this.responseText = null;
                try {
                    this.response = JSON.parse(buffer.toString("utf-8"));
                } catch (_a) {
                    this.response = null;
                }
                return;
            case "buffer":
                this.responseText = null;
                this.response = buffer;
                return;
            case "arraybuffer":
                this.responseText = null;
                var arrayBuffer = new ArrayBuffer(buffer.length);
                var view = new Uint8Array(arrayBuffer);
                for(var i = 0; i < buffer.length; i++)view[i] = buffer[i];
                this.response = arrayBuffer;
                return;
            case "text":
            default:
                try {
                    this.responseText = buffer.toString(this._parseResponseEncoding());
                } catch (_b) {
                    this.responseText = buffer.toString("binary");
                }
                this.response = this.responseText;
        }
    };
    XMLHttpRequest.prototype._parseResponseEncoding = function() {
        return /;\s*charset=(.*)$/.exec(this._responseHeaders["content-type"] || "")[1] || "utf-8";
    };
    XMLHttpRequest.ProgressEvent = progress_event_1.ProgressEvent;
    XMLHttpRequest.InvalidStateError = errors_1.InvalidStateError;
    XMLHttpRequest.NetworkError = errors_1.NetworkError;
    XMLHttpRequest.SecurityError = errors_1.SecurityError;
    XMLHttpRequest.SyntaxError = errors_1.SyntaxError;
    XMLHttpRequest.XMLHttpRequestUpload = xml_http_request_upload_1.XMLHttpRequestUpload;
    XMLHttpRequest.UNSENT = 0;
    XMLHttpRequest.OPENED = 1;
    XMLHttpRequest.HEADERS_RECEIVED = 2;
    XMLHttpRequest.LOADING = 3;
    XMLHttpRequest.DONE = 4;
    XMLHttpRequest.cookieJar = Cookie.CookieJar();
    return XMLHttpRequest;
}(xml_http_request_event_target_1.XMLHttpRequestEventTarget);
exports.XMLHttpRequest = XMLHttpRequest;
XMLHttpRequest.prototype.nodejsHttpAgent = http.globalAgent;
XMLHttpRequest.prototype.nodejsHttpsAgent = https.globalAgent;
XMLHttpRequest.prototype.nodejsBaseUrl = null;

},{"bbae9bebbc2dc8d7":"5QIF0","6f88cb76a21cd66":"l5Twm","da3ed69ca65b1849":"biwe9","3cc5090dbe91f9bf":"h9uDr","94f09bf8c29cafaf":"fPoZl","199aab2322d593b1":"280SV","2199eed71b8980ed":"gGD80","65d1765f2f249c0d":"9qLS8","4448db7cf1b03c4c":"lxN39","fbfe3be773dd3ae4":"cgJQY","dad0edbd70d44de6":"8WKZ6"}],"fPoZl":[function(require,module,exports) {
exports.endianness = function() {
    return "LE";
};
exports.hostname = function() {
    if (typeof location !== "undefined") return location.hostname;
    else return "";
};
exports.loadavg = function() {
    return [];
};
exports.uptime = function() {
    return 0;
};
exports.freemem = function() {
    return Number.MAX_VALUE;
};
exports.totalmem = function() {
    return Number.MAX_VALUE;
};
exports.cpus = function() {
    return [];
};
exports.type = function() {
    return "Browser";
};
exports.release = function() {
    if (typeof navigator !== "undefined") return navigator.appVersion;
    return "";
};
exports.networkInterfaces = exports.getNetworkInterfaces = function() {
    return {};
};
exports.arch = function() {
    return "javascript";
};
exports.platform = function() {
    return "browser";
};
exports.tmpdir = exports.tmpDir = function() {
    return "/tmp";
};
exports.EOL = "\n";
exports.homedir = function() {
    return "/";
};

},{}],"gGD80":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
var ProgressEvent = /** @class */ function() {
    function ProgressEvent(type) {
        this.type = type;
        this.bubbles = false;
        this.cancelable = false;
        this.loaded = 0;
        this.lengthComputable = false;
        this.total = 0;
    }
    return ProgressEvent;
}();
exports.ProgressEvent = ProgressEvent;

},{}],"9qLS8":[function(require,module,exports) {
"use strict";
var __extends = this && this.__extends || function() {
    var extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(exports, "__esModule", {
    value: true
});
var SecurityError = /** @class */ function(_super) {
    __extends(SecurityError, _super);
    function SecurityError() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return SecurityError;
}(Error);
exports.SecurityError = SecurityError;
var InvalidStateError = /** @class */ function(_super) {
    __extends(InvalidStateError, _super);
    function InvalidStateError() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return InvalidStateError;
}(Error);
exports.InvalidStateError = InvalidStateError;
var NetworkError = /** @class */ function(_super) {
    __extends(NetworkError, _super);
    function NetworkError() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return NetworkError;
}(Error);
exports.NetworkError = NetworkError;
var SyntaxError = /** @class */ function(_super) {
    __extends(SyntaxError, _super);
    function SyntaxError() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return SyntaxError;
}(Error);
exports.SyntaxError = SyntaxError;

},{}],"lxN39":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
var XMLHttpRequestEventTarget = /** @class */ function() {
    function XMLHttpRequestEventTarget() {
        this.listeners = {};
    }
    XMLHttpRequestEventTarget.prototype.addEventListener = function(eventType, listener) {
        eventType = eventType.toLowerCase();
        this.listeners[eventType] = this.listeners[eventType] || [];
        this.listeners[eventType].push(listener.handleEvent || listener);
    };
    XMLHttpRequestEventTarget.prototype.removeEventListener = function(eventType, listener) {
        eventType = eventType.toLowerCase();
        if (!this.listeners[eventType]) return;
        var index = this.listeners[eventType].indexOf(listener.handleEvent || listener);
        if (index < 0) return;
        this.listeners[eventType].splice(index, 1);
    };
    XMLHttpRequestEventTarget.prototype.dispatchEvent = function(event) {
        var eventType = event.type.toLowerCase();
        event.target = this; // TODO: set event.currentTarget?
        if (this.listeners[eventType]) for(var _i = 0, _a = this.listeners[eventType]; _i < _a.length; _i++){
            var listener_1 = _a[_i];
            listener_1.call(this, event);
        }
        var listener = this["on" + eventType];
        if (listener) listener.call(this, event);
        return true;
    };
    return XMLHttpRequestEventTarget;
}();
exports.XMLHttpRequestEventTarget = XMLHttpRequestEventTarget;

},{}],"cgJQY":[function(require,module,exports) {
var Buffer = require("9ead4e936dcd9659").Buffer;
"use strict";
var __extends = this && this.__extends || function() {
    var extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(exports, "__esModule", {
    value: true
});
var xml_http_request_event_target_1 = require("a703cc5b855e399d");
var XMLHttpRequestUpload = /** @class */ function(_super) {
    __extends(XMLHttpRequestUpload, _super);
    function XMLHttpRequestUpload() {
        var _this = _super.call(this) || this;
        _this._contentType = null;
        _this._body = null;
        _this._reset();
        return _this;
    }
    XMLHttpRequestUpload.prototype._reset = function() {
        this._contentType = null;
        this._body = null;
    };
    XMLHttpRequestUpload.prototype._setData = function(data) {
        if (data == null) return;
        if (typeof data === "string") {
            if (data.length !== 0) this._contentType = "text/plain;charset=UTF-8";
            this._body = new Buffer(data, "utf-8");
        } else if (Buffer.isBuffer(data)) this._body = data;
        else if (data instanceof ArrayBuffer) {
            var body = new Buffer(data.byteLength);
            var view = new Uint8Array(data);
            for(var i = 0; i < data.byteLength; i++)body[i] = view[i];
            this._body = body;
        } else if (data.buffer && data.buffer instanceof ArrayBuffer) {
            var body = new Buffer(data.byteLength);
            var offset = data.byteOffset;
            var view = new Uint8Array(data.buffer);
            for(var i = 0; i < data.byteLength; i++)body[i] = view[i + offset];
            this._body = body;
        } else throw new Error("Unsupported send() data " + data);
    };
    XMLHttpRequestUpload.prototype._finalizeHeaders = function(headers, loweredHeaders) {
        if (this._contentType && !loweredHeaders["content-type"]) headers["Content-Type"] = this._contentType;
        if (this._body) headers["Content-Length"] = this._body.length.toString();
    };
    XMLHttpRequestUpload.prototype._startUpload = function(request) {
        if (this._body) request.write(this._body);
        request.end();
    };
    return XMLHttpRequestUpload;
}(xml_http_request_event_target_1.XMLHttpRequestEventTarget);
exports.XMLHttpRequestUpload = XMLHttpRequestUpload;

},{"9ead4e936dcd9659":"l5Twm","a703cc5b855e399d":"lxN39"}],"8WKZ6":[function(require,module,exports) {
/* jshint node: true */ (function() {
    "use strict";
    function CookieAccessInfo(domain, path, secure, script) {
        if (this instanceof CookieAccessInfo) {
            this.domain = domain || undefined;
            this.path = path || "/";
            this.secure = !!secure;
            this.script = !!script;
            return this;
        }
        return new CookieAccessInfo(domain, path, secure, script);
    }
    CookieAccessInfo.All = Object.freeze(Object.create(null));
    exports.CookieAccessInfo = CookieAccessInfo;
    function Cookie(cookiestr, request_domain, request_path) {
        if (cookiestr instanceof Cookie) return cookiestr;
        if (this instanceof Cookie) {
            this.name = null;
            this.value = null;
            this.expiration_date = Infinity;
            this.path = String(request_path || "/");
            this.explicit_path = false;
            this.domain = request_domain || null;
            this.explicit_domain = false;
            this.secure = false; //how to define default?
            this.noscript = false; //httponly
            if (cookiestr) this.parse(cookiestr, request_domain, request_path);
            return this;
        }
        return new Cookie(cookiestr, request_domain, request_path);
    }
    exports.Cookie = Cookie;
    Cookie.prototype.toString = function toString() {
        var str = [
            this.name + "=" + this.value
        ];
        if (this.expiration_date !== Infinity) str.push("expires=" + new Date(this.expiration_date).toGMTString());
        if (this.domain) str.push("domain=" + this.domain);
        if (this.path) str.push("path=" + this.path);
        if (this.secure) str.push("secure");
        if (this.noscript) str.push("httponly");
        return str.join("; ");
    };
    Cookie.prototype.toValueString = function toValueString() {
        return this.name + "=" + this.value;
    };
    var cookie_str_splitter = /[:](?=\s*[a-zA-Z0-9_\-]+\s*[=])/g;
    Cookie.prototype.parse = function parse(str, request_domain, request_path) {
        if (this instanceof Cookie) {
            if (str.length > 32768) {
                console.warn("Cookie too long for parsing (>32768 characters)");
                return;
            }
            var parts = str.split(";").filter(function(value) {
                return !!value;
            });
            var i;
            var pair = parts[0].match(/([^=]+)=([\s\S]*)/);
            if (!pair) {
                console.warn("Invalid cookie header encountered. Header: '" + str + "'");
                return;
            }
            var key = pair[1];
            var value = pair[2];
            if (typeof key !== "string" || key.length === 0 || typeof value !== "string") {
                console.warn("Unable to extract values from cookie header. Cookie: '" + str + "'");
                return;
            }
            this.name = key;
            this.value = value;
            for(i = 1; i < parts.length; i += 1){
                pair = parts[i].match(/([^=]+)(?:=([\s\S]*))?/);
                key = pair[1].trim().toLowerCase();
                value = pair[2];
                switch(key){
                    case "httponly":
                        this.noscript = true;
                        break;
                    case "expires":
                        this.expiration_date = value ? Number(Date.parse(value)) : Infinity;
                        break;
                    case "path":
                        this.path = value ? value.trim() : "";
                        this.explicit_path = true;
                        break;
                    case "domain":
                        this.domain = value ? value.trim() : "";
                        this.explicit_domain = !!this.domain;
                        break;
                    case "secure":
                        this.secure = true;
                        break;
                }
            }
            if (!this.explicit_path) this.path = request_path || "/";
            if (!this.explicit_domain) this.domain = request_domain;
            return this;
        }
        return new Cookie().parse(str, request_domain, request_path);
    };
    Cookie.prototype.matches = function matches(access_info) {
        if (access_info === CookieAccessInfo.All) return true;
        if (this.noscript && access_info.script || this.secure && !access_info.secure || !this.collidesWith(access_info)) return false;
        return true;
    };
    Cookie.prototype.collidesWith = function collidesWith(access_info) {
        if (this.path && !access_info.path || this.domain && !access_info.domain) return false;
        if (this.path && access_info.path.indexOf(this.path) !== 0) return false;
        if (this.explicit_path && access_info.path.indexOf(this.path) !== 0) return false;
        var access_domain = access_info.domain && access_info.domain.replace(/^[\.]/, "");
        var cookie_domain = this.domain && this.domain.replace(/^[\.]/, "");
        if (cookie_domain === access_domain) return true;
        if (cookie_domain) {
            if (!this.explicit_domain) return false; // we already checked if the domains were exactly the same
            var wildcard = access_domain.indexOf(cookie_domain);
            if (wildcard === -1 || wildcard !== access_domain.length - cookie_domain.length) return false;
            return true;
        }
        return true;
    };
    function CookieJar() {
        var cookies, cookies_list, collidable_cookie;
        if (this instanceof CookieJar) {
            cookies = Object.create(null); //name: [Cookie]
            this.setCookie = function setCookie(cookie, request_domain, request_path) {
                var remove, i;
                cookie = new Cookie(cookie, request_domain, request_path);
                //Delete the cookie if the set is past the current time
                remove = cookie.expiration_date <= Date.now();
                if (cookies[cookie.name] !== undefined) {
                    cookies_list = cookies[cookie.name];
                    for(i = 0; i < cookies_list.length; i += 1){
                        collidable_cookie = cookies_list[i];
                        if (collidable_cookie.collidesWith(cookie)) {
                            if (remove) {
                                cookies_list.splice(i, 1);
                                if (cookies_list.length === 0) delete cookies[cookie.name];
                                return false;
                            }
                            cookies_list[i] = cookie;
                            return cookie;
                        }
                    }
                    if (remove) return false;
                    cookies_list.push(cookie);
                    return cookie;
                }
                if (remove) return false;
                cookies[cookie.name] = [
                    cookie
                ];
                return cookies[cookie.name];
            };
            //returns a cookie
            this.getCookie = function getCookie(cookie_name, access_info) {
                var cookie, i;
                cookies_list = cookies[cookie_name];
                if (!cookies_list) return;
                for(i = 0; i < cookies_list.length; i += 1){
                    cookie = cookies_list[i];
                    if (cookie.expiration_date <= Date.now()) {
                        if (cookies_list.length === 0) delete cookies[cookie.name];
                        continue;
                    }
                    if (cookie.matches(access_info)) return cookie;
                }
            };
            //returns a list of cookies
            this.getCookies = function getCookies(access_info) {
                var matches = [], cookie_name, cookie;
                for(cookie_name in cookies){
                    cookie = this.getCookie(cookie_name, access_info);
                    if (cookie) matches.push(cookie);
                }
                matches.toString = function toString() {
                    return matches.join(":");
                };
                matches.toValueString = function toValueString() {
                    return matches.map(function(c) {
                        return c.toValueString();
                    }).join("; ");
                };
                return matches;
            };
            return this;
        }
        return new CookieJar();
    }
    exports.CookieJar = CookieJar;
    //returns list of cookies that were set correctly. Cookies that are expired and removed are not returned.
    CookieJar.prototype.setCookies = function setCookies(cookies, request_domain, request_path) {
        cookies = Array.isArray(cookies) ? cookies : cookies.split(cookie_str_splitter);
        var successful = [], i, cookie;
        cookies = cookies.map(function(item) {
            return new Cookie(item, request_domain, request_path);
        });
        for(i = 0; i < cookies.length; i += 1){
            cookie = cookies[i];
            if (this.setCookie(cookie, request_domain, request_path)) successful.push(cookie);
        }
        return successful;
    };
})();

},{}],"2acpv":[function(require,module,exports) {
const EventEmitter = require("83101eac9a001954").EventEmitter;
const inherits = require("a547469c803232d5").inherits;
const ethUtil = require("a087fdd0ab7c21a1");
const EthBlockTracker = require("8cb6f3f6041fd70d");
const map = require("ad524fc64e4480cd");
const eachSeries = require("4218910345f76435");
const Stoplight = require("c56d2efd9087dbe7");
const cacheUtils = require("2ee3600bc4013b2b");
const createPayload = require("6c09bb679b54ad40");
const noop = function() {};
module.exports = Web3ProviderEngine;
inherits(Web3ProviderEngine, EventEmitter);
function Web3ProviderEngine(opts) {
    const self = this;
    EventEmitter.call(self);
    self.setMaxListeners(30);
    // parse options
    opts = opts || {};
    // block polling
    const directProvider = {
        sendAsync: self._handleAsync.bind(self)
    };
    const blockTrackerProvider = opts.blockTrackerProvider || directProvider;
    self._blockTracker = opts.blockTracker || new EthBlockTracker({
        provider: blockTrackerProvider,
        pollingInterval: opts.pollingInterval || 4000,
        setSkipCacheFlag: true
    });
    // set initialization blocker
    self._ready = new Stoplight();
    // local state
    self.currentBlock = null;
    self._providers = [];
}
// public
Web3ProviderEngine.prototype.start = function(cb = noop) {
    const self = this;
    // trigger start
    self._ready.go();
    // on new block, request block body and emit as events
    self._blockTracker.on("latest", (blockNumber)=>{
        // get block body
        self._getBlockByNumberWithRetry(blockNumber, (err, block)=>{
            if (err) {
                this.emit("error", err);
                return;
            }
            if (!block) {
                console.log(block);
                this.emit("error", new Error("Could not find block"));
                return;
            }
            const bufferBlock = toBufferBlock(block);
            // set current + emit "block" event
            self._setCurrentBlock(bufferBlock);
            // emit other events
            self.emit("rawBlock", block);
            self.emit("latest", block);
        });
    });
    // forward other events
    self._blockTracker.on("sync", self.emit.bind(self, "sync"));
    self._blockTracker.on("error", self.emit.bind(self, "error"));
    // update state
    self._running = true;
    // signal that we started
    self.emit("start");
};
Web3ProviderEngine.prototype.stop = function() {
    const self = this;
    // stop block polling by removing event listeners
    self._blockTracker.removeAllListeners();
    // update state
    self._running = false;
    // signal that we stopped
    self.emit("stop");
};
Web3ProviderEngine.prototype.isRunning = function() {
    const self = this;
    return self._running;
};
Web3ProviderEngine.prototype.addProvider = function(source, index) {
    const self = this;
    if (typeof index === "number") self._providers.splice(index, 0, source);
    else self._providers.push(source);
    source.setEngine(this);
};
Web3ProviderEngine.prototype.removeProvider = function(source) {
    const self = this;
    const index = self._providers.indexOf(source);
    if (index < 0) throw new Error("Provider not found.");
    self._providers.splice(index, 1);
};
Web3ProviderEngine.prototype.send = function(payload) {
    throw new Error("Web3ProviderEngine does not support synchronous requests.");
};
Web3ProviderEngine.prototype.sendAsync = function(payload, cb) {
    const self = this;
    self._ready.await(function() {
        if (Array.isArray(payload)) // handle batch
        map(payload, self._handleAsync.bind(self), cb);
        else // handle single
        self._handleAsync(payload, cb);
    });
};
// private
Web3ProviderEngine.prototype._getBlockByNumberWithRetry = function(blockNumber, cb) {
    const self = this;
    let retriesRemaining = 5;
    attemptRequest();
    return;
    function attemptRequest() {
        self._getBlockByNumber(blockNumber, afterRequest);
    }
    function afterRequest(err, block) {
        // anomalous error occurred
        if (err) return cb(err);
        // block not ready yet
        if (!block) {
            if (retriesRemaining > 0) {
                // wait 1s then try again
                retriesRemaining--;
                setTimeout(function() {
                    attemptRequest();
                }, 1000);
                return;
            } else {
                // give up, return a null block
                cb(null, null);
                return;
            }
        }
        // otherwise return result
        cb(null, block);
        return;
    }
};
Web3ProviderEngine.prototype._getBlockByNumber = function(blockNumber, cb) {
    const req = createPayload({
        method: "eth_getBlockByNumber",
        params: [
            blockNumber,
            false
        ],
        skipCache: true
    });
    this._handleAsync(req, (err, res)=>{
        if (err) return cb(err);
        return cb(null, res.result);
    });
};
Web3ProviderEngine.prototype._handleAsync = function(payload, finished) {
    var self = this;
    var currentProvider = -1;
    var result = null;
    var error = null;
    var stack = [];
    next();
    function next(after) {
        currentProvider += 1;
        stack.unshift(after);
        // Bubbled down as far as we could go, and the request wasn't
        // handled. Return an error.
        if (currentProvider >= self._providers.length) end(new Error('Request for method "' + payload.method + '" not handled by any subprovider. Please check your subprovider configuration to ensure this method is handled.'));
        else try {
            var provider = self._providers[currentProvider];
            provider.handleRequest(payload, next, end);
        } catch (e) {
            end(e);
        }
    }
    function end(_error, _result) {
        error = _error;
        result = _result;
        eachSeries(stack, function(fn, callback) {
            if (fn) fn(error, result, callback);
            else callback();
        }, function() {
            var resultObj = {
                id: payload.id,
                jsonrpc: payload.jsonrpc,
                result: result
            };
            if (error != null) {
                resultObj.error = {
                    message: error.stack || error.message || error,
                    code: -32000
                };
                // respond with both error formats
                finished(error, resultObj);
            } else finished(null, resultObj);
        });
    }
};
//
// from remote-data
//
Web3ProviderEngine.prototype._setCurrentBlock = function(block) {
    const self = this;
    self.currentBlock = block;
    self.emit("block", block);
};
// util
function toBufferBlock(jsonBlock) {
    return {
        number: ethUtil.toBuffer(jsonBlock.number),
        hash: ethUtil.toBuffer(jsonBlock.hash),
        parentHash: ethUtil.toBuffer(jsonBlock.parentHash),
        nonce: ethUtil.toBuffer(jsonBlock.nonce),
        mixHash: ethUtil.toBuffer(jsonBlock.mixHash),
        sha3Uncles: ethUtil.toBuffer(jsonBlock.sha3Uncles),
        logsBloom: ethUtil.toBuffer(jsonBlock.logsBloom),
        transactionsRoot: ethUtil.toBuffer(jsonBlock.transactionsRoot),
        stateRoot: ethUtil.toBuffer(jsonBlock.stateRoot),
        receiptsRoot: ethUtil.toBuffer(jsonBlock.receiptRoot || jsonBlock.receiptsRoot),
        miner: ethUtil.toBuffer(jsonBlock.miner),
        difficulty: ethUtil.toBuffer(jsonBlock.difficulty),
        totalDifficulty: ethUtil.toBuffer(jsonBlock.totalDifficulty),
        size: ethUtil.toBuffer(jsonBlock.size),
        extraData: ethUtil.toBuffer(jsonBlock.extraData),
        gasLimit: ethUtil.toBuffer(jsonBlock.gasLimit),
        gasUsed: ethUtil.toBuffer(jsonBlock.gasUsed),
        timestamp: ethUtil.toBuffer(jsonBlock.timestamp),
        transactions: jsonBlock.transactions
    };
}

},{"83101eac9a001954":"fqTtD","a547469c803232d5":"jInrX","a087fdd0ab7c21a1":"8JOz2","8cb6f3f6041fd70d":"56qDa","ad524fc64e4480cd":"jC3PU","4218910345f76435":"cQuNM","c56d2efd9087dbe7":"dRfgC","2ee3600bc4013b2b":"hrGw9","6c09bb679b54ad40":"i0Ehs"}],"8JOz2":[function(require,module,exports) {
"use strict";
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
    return typeof obj;
} : function(obj) {
    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};
var _require = require("fc42acae2629c1d7"), keccak224 = _require.keccak224, keccak384 = _require.keccak384, k256 = _require.keccak256, keccak512 = _require.keccak512;
var secp256k1 = require("7d45b08db53edfb2");
var assert = require("e3df4fe109b8bb7e");
var rlp = require("9b6f4465ea618b3e");
var BN = require("63dbbf74f2340387");
var createHash = require("21a8a85619a20fc");
var Buffer = require("3624badcff0b5c25").Buffer;
Object.assign(exports, require("fecd2fded143ad17"));
/**
 * the max integer that this VM can handle (a ```BN```)
 * @var {BN} MAX_INTEGER
 */ exports.MAX_INTEGER = new BN("ffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff", 16);
/**
 * 2^256 (a ```BN```)
 * @var {BN} TWO_POW256
 */ exports.TWO_POW256 = new BN("10000000000000000000000000000000000000000000000000000000000000000", 16);
/**
 * Keccak-256 hash of null (a ```String```)
 * @var {String} KECCAK256_NULL_S
 */ exports.KECCAK256_NULL_S = "c5d2460186f7233c927e7db2dcc703c0e500b653ca82273b7bfad8045d85a470";
exports.SHA3_NULL_S = exports.KECCAK256_NULL_S;
/**
 * Keccak-256 hash of null (a ```Buffer```)
 * @var {Buffer} KECCAK256_NULL
 */ exports.KECCAK256_NULL = Buffer.from(exports.KECCAK256_NULL_S, "hex");
exports.SHA3_NULL = exports.KECCAK256_NULL;
/**
 * Keccak-256 of an RLP of an empty array (a ```String```)
 * @var {String} KECCAK256_RLP_ARRAY_S
 */ exports.KECCAK256_RLP_ARRAY_S = "1dcc4de8dec75d7aab85b567b6ccd41ad312451b948a7413f0a142fd40d49347";
exports.SHA3_RLP_ARRAY_S = exports.KECCAK256_RLP_ARRAY_S;
/**
 * Keccak-256 of an RLP of an empty array (a ```Buffer```)
 * @var {Buffer} KECCAK256_RLP_ARRAY
 */ exports.KECCAK256_RLP_ARRAY = Buffer.from(exports.KECCAK256_RLP_ARRAY_S, "hex");
exports.SHA3_RLP_ARRAY = exports.KECCAK256_RLP_ARRAY;
/**
 * Keccak-256 hash of the RLP of null  (a ```String```)
 * @var {String} KECCAK256_RLP_S
 */ exports.KECCAK256_RLP_S = "56e81f171bcc55a6ff8345e692c0f86e5b48e01b996cadc001622fb5e363b421";
exports.SHA3_RLP_S = exports.KECCAK256_RLP_S;
/**
 * Keccak-256 hash of the RLP of null (a ```Buffer```)
 * @var {Buffer} KECCAK256_RLP
 */ exports.KECCAK256_RLP = Buffer.from(exports.KECCAK256_RLP_S, "hex");
exports.SHA3_RLP = exports.KECCAK256_RLP;
/**
 * [`BN`](https://github.com/indutny/bn.js)
 * @var {Function}
 */ exports.BN = BN;
/**
 * [`rlp`](https://github.com/ethereumjs/rlp)
 * @var {Function}
 */ exports.rlp = rlp;
/**
 * [`secp256k1`](https://github.com/cryptocoinjs/secp256k1-node/)
 * @var {Object}
 */ exports.secp256k1 = secp256k1;
/**
 * Returns a buffer filled with 0s
 * @method zeros
 * @param {Number} bytes  the number of bytes the buffer should be
 * @return {Buffer}
 */ exports.zeros = function(bytes) {
    return Buffer.allocUnsafe(bytes).fill(0);
};
/**
  * Returns a zero address
  * @method zeroAddress
  * @return {String}
  */ exports.zeroAddress = function() {
    var addressLength = 20;
    var zeroAddress = exports.zeros(addressLength);
    return exports.bufferToHex(zeroAddress);
};
/**
 * Left Pads an `Array` or `Buffer` with leading zeros till it has `length` bytes.
 * Or it truncates the beginning if it exceeds.
 * @method lsetLength
 * @param {Buffer|Array} msg the value to pad
 * @param {Number} length the number of bytes the output should be
 * @param {Boolean} [right=false] whether to start padding form the left or right
 * @return {Buffer|Array}
 */ exports.setLengthLeft = exports.setLength = function(msg, length, right) {
    var buf = exports.zeros(length);
    msg = exports.toBuffer(msg);
    if (right) {
        if (msg.length < length) {
            msg.copy(buf);
            return buf;
        }
        return msg.slice(0, length);
    } else {
        if (msg.length < length) {
            msg.copy(buf, length - msg.length);
            return buf;
        }
        return msg.slice(-length);
    }
};
/**
 * Right Pads an `Array` or `Buffer` with leading zeros till it has `length` bytes.
 * Or it truncates the beginning if it exceeds.
 * @param {Buffer|Array} msg the value to pad
 * @param {Number} length the number of bytes the output should be
 * @return {Buffer|Array}
 */ exports.setLengthRight = function(msg, length) {
    return exports.setLength(msg, length, true);
};
/**
 * Trims leading zeros from a `Buffer` or an `Array`
 * @param {Buffer|Array|String} a
 * @return {Buffer|Array|String}
 */ exports.unpad = exports.stripZeros = function(a) {
    a = exports.stripHexPrefix(a);
    var first = a[0];
    while(a.length > 0 && first.toString() === "0"){
        a = a.slice(1);
        first = a[0];
    }
    return a;
};
/**
 * Attempts to turn a value into a `Buffer`. As input it supports `Buffer`, `String`, `Number`, null/undefined, `BN` and other objects with a `toArray()` method.
 * @param {*} v the value
 */ exports.toBuffer = function(v) {
    if (!Buffer.isBuffer(v)) {
        if (Array.isArray(v)) v = Buffer.from(v);
        else if (typeof v === "string") {
            if (exports.isHexString(v)) v = Buffer.from(exports.padToEven(exports.stripHexPrefix(v)), "hex");
            else v = Buffer.from(v);
        } else if (typeof v === "number") v = exports.intToBuffer(v);
        else if (v === null || v === undefined) v = Buffer.allocUnsafe(0);
        else if (BN.isBN(v)) v = v.toArrayLike(Buffer);
        else if (v.toArray) // converts a BN to a Buffer
        v = Buffer.from(v.toArray());
        else throw new Error("invalid type");
    }
    return v;
};
/**
 * Converts a `Buffer` to a `Number`
 * @param {Buffer} buf
 * @return {Number}
 * @throws If the input number exceeds 53 bits.
 */ exports.bufferToInt = function(buf) {
    return new BN(exports.toBuffer(buf)).toNumber();
};
/**
 * Converts a `Buffer` into a hex `String`
 * @param {Buffer} buf
 * @return {String}
 */ exports.bufferToHex = function(buf) {
    buf = exports.toBuffer(buf);
    return "0x" + buf.toString("hex");
};
/**
 * Interprets a `Buffer` as a signed integer and returns a `BN`. Assumes 256-bit numbers.
 * @param {Buffer} num
 * @return {BN}
 */ exports.fromSigned = function(num) {
    return new BN(num).fromTwos(256);
};
/**
 * Converts a `BN` to an unsigned integer and returns it as a `Buffer`. Assumes 256-bit numbers.
 * @param {BN} num
 * @return {Buffer}
 */ exports.toUnsigned = function(num) {
    return Buffer.from(num.toTwos(256).toArray());
};
/**
 * Creates Keccak hash of the input
 * @param {Buffer|Array|String|Number} a the input data
 * @param {Number} [bits=256] the Keccak width
 * @return {Buffer}
 */ exports.keccak = function(a, bits) {
    a = exports.toBuffer(a);
    if (!bits) bits = 256;
    switch(bits){
        case 224:
            return keccak224(a);
        case 256:
            return k256(a);
        case 384:
            return keccak384(a);
        case 512:
            return keccak512(a);
        default:
            throw new Error("Invald algorithm: keccak" + bits);
    }
};
/**
 * Creates Keccak-256 hash of the input, alias for keccak(a, 256)
 * @param {Buffer|Array|String|Number} a the input data
 * @return {Buffer}
 */ exports.keccak256 = function(a) {
    return exports.keccak(a);
};
/**
 * Creates SHA-3 (Keccak) hash of the input [OBSOLETE]
 * @param {Buffer|Array|String|Number} a the input data
 * @param {Number} [bits=256] the SHA-3 width
 * @return {Buffer}
 */ exports.sha3 = exports.keccak;
/**
 * Creates SHA256 hash of the input
 * @param {Buffer|Array|String|Number} a the input data
 * @return {Buffer}
 */ exports.sha256 = function(a) {
    a = exports.toBuffer(a);
    return createHash("sha256").update(a).digest();
};
/**
 * Creates RIPEMD160 hash of the input
 * @param {Buffer|Array|String|Number} a the input data
 * @param {Boolean} padded whether it should be padded to 256 bits or not
 * @return {Buffer}
 */ exports.ripemd160 = function(a, padded) {
    a = exports.toBuffer(a);
    var hash = createHash("rmd160").update(a).digest();
    if (padded === true) return exports.setLength(hash, 32);
    else return hash;
};
/**
 * Creates SHA-3 hash of the RLP encoded version of the input
 * @param {Buffer|Array|String|Number} a the input data
 * @return {Buffer}
 */ exports.rlphash = function(a) {
    return exports.keccak(rlp.encode(a));
};
/**
 * Checks if the private key satisfies the rules of the curve secp256k1.
 * @param {Buffer} privateKey
 * @return {Boolean}
 */ exports.isValidPrivate = function(privateKey) {
    return secp256k1.privateKeyVerify(privateKey);
};
/**
 * Checks if the public key satisfies the rules of the curve secp256k1
 * and the requirements of Ethereum.
 * @param {Buffer} publicKey The two points of an uncompressed key, unless sanitize is enabled
 * @param {Boolean} [sanitize=false] Accept public keys in other formats
 * @return {Boolean}
 */ exports.isValidPublic = function(publicKey, sanitize) {
    if (publicKey.length === 64) // Convert to SEC1 for secp256k1
    return secp256k1.publicKeyVerify(Buffer.concat([
        Buffer.from([
            4
        ]),
        publicKey
    ]));
    if (!sanitize) return false;
    return secp256k1.publicKeyVerify(publicKey);
};
/**
 * Returns the ethereum address of a given public key.
 * Accepts "Ethereum public keys" and SEC1 encoded keys.
 * @param {Buffer} pubKey The two points of an uncompressed key, unless sanitize is enabled
 * @param {Boolean} [sanitize=false] Accept public keys in other formats
 * @return {Buffer}
 */ exports.pubToAddress = exports.publicToAddress = function(pubKey, sanitize) {
    pubKey = exports.toBuffer(pubKey);
    if (sanitize && pubKey.length !== 64) pubKey = secp256k1.publicKeyConvert(pubKey, false).slice(1);
    assert(pubKey.length === 64);
    // Only take the lower 160bits of the hash
    return exports.keccak(pubKey).slice(-20);
};
/**
 * Returns the ethereum public key of a given private key
 * @param {Buffer} privateKey A private key must be 256 bits wide
 * @return {Buffer}
 */ var privateToPublic = exports.privateToPublic = function(privateKey) {
    privateKey = exports.toBuffer(privateKey);
    // skip the type flag and use the X, Y points
    return secp256k1.publicKeyCreate(privateKey, false).slice(1);
};
/**
 * Converts a public key to the Ethereum format.
 * @param {Buffer} publicKey
 * @return {Buffer}
 */ exports.importPublic = function(publicKey) {
    publicKey = exports.toBuffer(publicKey);
    if (publicKey.length !== 64) publicKey = secp256k1.publicKeyConvert(publicKey, false).slice(1);
    return publicKey;
};
/**
 * ECDSA sign
 * @param {Buffer} msgHash
 * @param {Buffer} privateKey
 * @return {Object}
 */ exports.ecsign = function(msgHash, privateKey) {
    var sig = secp256k1.sign(msgHash, privateKey);
    var ret = {};
    ret.r = sig.signature.slice(0, 32);
    ret.s = sig.signature.slice(32, 64);
    ret.v = sig.recovery + 27;
    return ret;
};
/**
 * Returns the keccak-256 hash of `message`, prefixed with the header used by the `eth_sign` RPC call.
 * The output of this function can be fed into `ecsign` to produce the same signature as the `eth_sign`
 * call for a given `message`, or fed to `ecrecover` along with a signature to recover the public key
 * used to produce the signature.
 * @param message
 * @returns {Buffer} hash
 */ exports.hashPersonalMessage = function(message) {
    var prefix = exports.toBuffer("\x19Ethereum Signed Message:\n" + message.length.toString());
    return exports.keccak(Buffer.concat([
        prefix,
        message
    ]));
};
/**
 * ECDSA public key recovery from signature
 * @param {Buffer} msgHash
 * @param {Number} v
 * @param {Buffer} r
 * @param {Buffer} s
 * @return {Buffer} publicKey
 */ exports.ecrecover = function(msgHash, v, r, s) {
    var signature = Buffer.concat([
        exports.setLength(r, 32),
        exports.setLength(s, 32)
    ], 64);
    var recovery = v - 27;
    if (recovery !== 0 && recovery !== 1) throw new Error("Invalid signature v value");
    var senderPubKey = secp256k1.recover(msgHash, signature, recovery);
    return secp256k1.publicKeyConvert(senderPubKey, false).slice(1);
};
/**
 * Convert signature parameters into the format of `eth_sign` RPC method
 * @param {Number} v
 * @param {Buffer} r
 * @param {Buffer} s
 * @return {String} sig
 */ exports.toRpcSig = function(v, r, s) {
    // NOTE: with potential introduction of chainId this might need to be updated
    if (v !== 27 && v !== 28) throw new Error("Invalid recovery id");
    // geth (and the RPC eth_sign method) uses the 65 byte format used by Bitcoin
    // FIXME: this might change in the future - https://github.com/ethereum/go-ethereum/issues/2053
    return exports.bufferToHex(Buffer.concat([
        exports.setLengthLeft(r, 32),
        exports.setLengthLeft(s, 32),
        exports.toBuffer(v - 27)
    ]));
};
/**
 * Convert signature format of the `eth_sign` RPC method to signature parameters
 * NOTE: all because of a bug in geth: https://github.com/ethereum/go-ethereum/issues/2053
 * @param {String} sig
 * @return {Object}
 */ exports.fromRpcSig = function(sig) {
    sig = exports.toBuffer(sig);
    // NOTE: with potential introduction of chainId this might need to be updated
    if (sig.length !== 65) throw new Error("Invalid signature length");
    var v = sig[64];
    // support both versions of `eth_sign` responses
    if (v < 27) v += 27;
    return {
        v: v,
        r: sig.slice(0, 32),
        s: sig.slice(32, 64)
    };
};
/**
 * Returns the ethereum address of a given private key
 * @param {Buffer} privateKey A private key must be 256 bits wide
 * @return {Buffer}
 */ exports.privateToAddress = function(privateKey) {
    return exports.publicToAddress(privateToPublic(privateKey));
};
/**
 * Checks if the address is a valid. Accepts checksummed addresses too
 * @param {String} address
 * @return {Boolean}
 */ exports.isValidAddress = function(address) {
    return /^0x[0-9a-fA-F]{40}$/.test(address);
};
/**
  * Checks if a given address is a zero address
  * @method isZeroAddress
  * @param {String} address
  * @return {Boolean}
  */ exports.isZeroAddress = function(address) {
    var zeroAddress = exports.zeroAddress();
    return zeroAddress === exports.addHexPrefix(address);
};
/**
 * Returns a checksummed address
 * @param {String} address
 * @return {String}
 */ exports.toChecksumAddress = function(address) {
    address = exports.stripHexPrefix(address).toLowerCase();
    var hash = exports.keccak(address).toString("hex");
    var ret = "0x";
    for(var i = 0; i < address.length; i++)if (parseInt(hash[i], 16) >= 8) ret += address[i].toUpperCase();
    else ret += address[i];
    return ret;
};
/**
 * Checks if the address is a valid checksummed address
 * @param {Buffer} address
 * @return {Boolean}
 */ exports.isValidChecksumAddress = function(address) {
    return exports.isValidAddress(address) && exports.toChecksumAddress(address) === address;
};
/**
 * Generates an address of a newly created contract
 * @param {Buffer} from the address which is creating this new address
 * @param {Buffer} nonce the nonce of the from account
 * @return {Buffer}
 */ exports.generateAddress = function(from, nonce) {
    from = exports.toBuffer(from);
    nonce = new BN(nonce);
    if (nonce.isZero()) // in RLP we want to encode null in the case of zero nonce
    // read the RLP documentation for an answer if you dare
    nonce = null;
    else nonce = Buffer.from(nonce.toArray());
    // Only take the lower 160bits of the hash
    return exports.rlphash([
        from,
        nonce
    ]).slice(-20);
};
/**
 * Returns true if the supplied address belongs to a precompiled account (Byzantium)
 * @param {Buffer|String} address
 * @return {Boolean}
 */ exports.isPrecompiled = function(address) {
    var a = exports.unpad(address);
    return a.length === 1 && a[0] >= 1 && a[0] <= 8;
};
/**
 * Adds "0x" to a given `String` if it does not already start with "0x"
 * @param {String} str
 * @return {String}
 */ exports.addHexPrefix = function(str) {
    if (typeof str !== "string") return str;
    return exports.isHexPrefixed(str) ? str : "0x" + str;
};
/**
 * Validate ECDSA signature
 * @method isValidSignature
 * @param {Buffer} v
 * @param {Buffer} r
 * @param {Buffer} s
 * @param {Boolean} [homestead=true]
 * @return {Boolean}
 */ exports.isValidSignature = function(v, r, s, homestead) {
    var SECP256K1_N_DIV_2 = new BN("7fffffffffffffffffffffffffffffff5d576e7357a4501ddfe92f46681b20a0", 16);
    var SECP256K1_N = new BN("fffffffffffffffffffffffffffffffebaaedce6af48a03bbfd25e8cd0364141", 16);
    if (r.length !== 32 || s.length !== 32) return false;
    if (v !== 27 && v !== 28) return false;
    r = new BN(r);
    s = new BN(s);
    if (r.isZero() || r.gt(SECP256K1_N) || s.isZero() || s.gt(SECP256K1_N)) return false;
    if (homestead === false && new BN(s).cmp(SECP256K1_N_DIV_2) === 1) return false;
    return true;
};
/**
 * Converts a `Buffer` or `Array` to JSON
 * @param {Buffer|Array} ba
 * @return {Array|String|null}
 */ exports.baToJSON = function(ba) {
    if (Buffer.isBuffer(ba)) return "0x" + ba.toString("hex");
    else if (ba instanceof Array) {
        var array = [];
        for(var i = 0; i < ba.length; i++)array.push(exports.baToJSON(ba[i]));
        return array;
    }
};
/**
 * Defines properties on a `Object`. It make the assumption that underlying data is binary.
 * @param {Object} self the `Object` to define properties on
 * @param {Array} fields an array fields to define. Fields can contain:
 * * `name` - the name of the properties
 * * `length` - the number of bytes the field can have
 * * `allowLess` - if the field can be less than the length
 * * `allowEmpty`
 * @param {*} data data to be validated against the definitions
 */ exports.defineProperties = function(self, fields, data) {
    self.raw = [];
    self._fields = [];
    // attach the `toJSON`
    self.toJSON = function(label) {
        if (label) {
            var obj = {};
            self._fields.forEach(function(field) {
                obj[field] = "0x" + self[field].toString("hex");
            });
            return obj;
        }
        return exports.baToJSON(this.raw);
    };
    self.serialize = function serialize() {
        return rlp.encode(self.raw);
    };
    fields.forEach(function(field, i) {
        self._fields.push(field.name);
        function getter() {
            return self.raw[i];
        }
        function setter(v) {
            v = exports.toBuffer(v);
            if (v.toString("hex") === "00" && !field.allowZero) v = Buffer.allocUnsafe(0);
            if (field.allowLess && field.length) {
                v = exports.stripZeros(v);
                assert(field.length >= v.length, "The field " + field.name + " must not have more " + field.length + " bytes");
            } else if (!(field.allowZero && v.length === 0) && field.length) assert(field.length === v.length, "The field " + field.name + " must have byte length of " + field.length);
            self.raw[i] = v;
        }
        Object.defineProperty(self, field.name, {
            enumerable: true,
            configurable: true,
            get: getter,
            set: setter
        });
        if (field.default) self[field.name] = field.default;
        // attach alias
        if (field.alias) Object.defineProperty(self, field.alias, {
            enumerable: false,
            configurable: true,
            set: setter,
            get: getter
        });
    });
    // if the constuctor is passed data
    if (data) {
        if (typeof data === "string") data = Buffer.from(exports.stripHexPrefix(data), "hex");
        if (Buffer.isBuffer(data)) data = rlp.decode(data);
        if (Array.isArray(data)) {
            if (data.length > self._fields.length) throw new Error("wrong number of fields in data");
            // make sure all the items are buffers
            data.forEach(function(d, i) {
                self[self._fields[i]] = exports.toBuffer(d);
            });
        } else if ((typeof data === "undefined" ? "undefined" : _typeof(data)) === "object") {
            var keys = Object.keys(data);
            fields.forEach(function(field) {
                if (keys.indexOf(field.name) !== -1) self[field.name] = data[field.name];
                if (keys.indexOf(field.alias) !== -1) self[field.alias] = data[field.alias];
            });
        } else throw new Error("invalid data");
    }
};

},{"fc42acae2629c1d7":"5TnJC","7d45b08db53edfb2":"c2WWl","e3df4fe109b8bb7e":"jRkR3","9b6f4465ea618b3e":"iee6k","63dbbf74f2340387":"x4ItY","21a8a85619a20fc":"iwHvk","3624badcff0b5c25":"6hBQU","fecd2fded143ad17":"4yJO4"}],"5TnJC":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
var hash_utils_1 = require("63a4b06cc622796f");
var createKeccakHash = require("cbd437b9a34f8945");
exports.keccak224 = hash_utils_1.createHashFunction(function() {
    return createKeccakHash("keccak224");
});
exports.keccak256 = hash_utils_1.createHashFunction(function() {
    return createKeccakHash("keccak256");
});
exports.keccak384 = hash_utils_1.createHashFunction(function() {
    return createKeccakHash("keccak384");
});
exports.keccak512 = hash_utils_1.createHashFunction(function() {
    return createKeccakHash("keccak512");
});

},{"63a4b06cc622796f":"6dP1T","cbd437b9a34f8945":"a11wB"}],"6dP1T":[function(require,module,exports) {
var Buffer = require("bb9a509956781478").Buffer;
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function createHashFunction(hashConstructor) {
    return function(msg) {
        var hash = hashConstructor();
        hash.update(msg);
        return Buffer.from(hash.digest());
    };
}
exports.createHashFunction = createHashFunction;

},{"bb9a509956781478":"l5Twm"}],"c2WWl":[function(require,module,exports) {
var Buffer = require("8b7ca09b511c78a2").Buffer;
"use strict";
var secp256k1 = require("cb04187a5900198f");
var secp256k1v3 = require("85ebcc4e73ed6155");
var der = require("4ad52bae9b137bef");
/**
 * Verify an ECDSA privateKey
 * @method privateKeyVerify
 * @param {Buffer} privateKey
 * @return {boolean}
 */ var privateKeyVerify = function privateKeyVerify(privateKey) {
    // secp256k1 v4 version throws when privateKey length is not 32
    if (privateKey.length !== 32) return false;
    return secp256k1.privateKeyVerify(Uint8Array.from(privateKey));
};
/**
 * Export a privateKey in DER format
 * @method privateKeyExport
 * @param {Buffer} privateKey
 * @param {boolean} compressed
 * @return {boolean}
 */ var privateKeyExport = function privateKeyExport(privateKey, compressed) {
    // privateKeyExport method is not part of secp256k1 v4 package
    // this implementation is based on v3
    if (privateKey.length !== 32) throw new RangeError("private key length is invalid");
    var publicKey = secp256k1v3.privateKeyExport(privateKey, compressed);
    return der.privateKeyExport(privateKey, publicKey, compressed);
};
/**
 * Import a privateKey in DER format
 * @method privateKeyImport
 * @param {Buffer} privateKey
 * @return {Buffer}
 */ var privateKeyImport = function privateKeyImport(privateKey) {
    // privateKeyImport method is not part of secp256k1 v4 package
    // this implementation is based on v3
    privateKey = der.privateKeyImport(privateKey);
    if (privateKey !== null && privateKey.length === 32 && privateKeyVerify(privateKey)) return privateKey;
    throw new Error("couldn't import from DER format");
};
/**
 * Negate a privateKey by subtracting it from the order of the curve's base point
 * @method privateKeyNegate
 * @param {Buffer} privateKey
 * @return {Buffer}
 */ var privateKeyNegate = function privateKeyNegate(privateKey) {
    return Buffer.from(secp256k1.privateKeyNegate(Uint8Array.from(privateKey)));
};
/**
 * Compute the inverse of a privateKey (modulo the order of the curve's base point).
 * @method privateKeyModInverse
 * @param {Buffer} privateKey
 * @return {Buffer}
 */ var privateKeyModInverse = function privateKeyModInverse(privateKey) {
    if (privateKey.length !== 32) throw new Error("private key length is invalid");
    return Buffer.from(secp256k1v3.privateKeyModInverse(Uint8Array.from(privateKey)));
};
/**
 * Tweak a privateKey by adding tweak to it.
 * @method privateKeyTweakAdd
 * @param {Buffer} privateKey
 * @param {Buffer} tweak
 * @return {Buffer}
 */ var privateKeyTweakAdd = function privateKeyTweakAdd(privateKey, tweak) {
    return Buffer.from(secp256k1.privateKeyTweakAdd(Uint8Array.from(privateKey), tweak));
};
/**
 * Tweak a privateKey by multiplying it by a tweak.
 * @method privateKeyTweakMul
 * @param {Buffer} privateKey
 * @param {Buffer} tweak
 * @return {Buffer}
 */ var privateKeyTweakMul = function privateKeyTweakMul(privateKey, tweak) {
    return Buffer.from(secp256k1.privateKeyTweakMul(Uint8Array.from(privateKey), Uint8Array.from(tweak)));
};
/**
 * Compute the public key for a privateKey.
 * @method publicKeyCreate
 * @param {Buffer} privateKey
 * @param {boolean} compressed
 * @return {Buffer}
 */ var publicKeyCreate = function publicKeyCreate(privateKey, compressed) {
    return Buffer.from(secp256k1.publicKeyCreate(Uint8Array.from(privateKey), compressed));
};
/**
 * Convert a publicKey to compressed or uncompressed form.
 * @method publicKeyConvert
 * @param {Buffer} publicKey
 * @param {boolean} compressed
 * @return {Buffer}
 */ var publicKeyConvert = function publicKeyConvert(publicKey, compressed) {
    return Buffer.from(secp256k1.publicKeyConvert(Uint8Array.from(publicKey), compressed));
};
/**
 * Verify an ECDSA publicKey.
 * @method publicKeyVerify
 * @param {Buffer} publicKey
 * @return {boolean}
 */ var publicKeyVerify = function publicKeyVerify(publicKey) {
    // secp256k1 v4 version throws when publicKey length is not 33 or 65
    if (publicKey.length !== 33 && publicKey.length !== 65) return false;
    return secp256k1.publicKeyVerify(Uint8Array.from(publicKey));
};
/**
 * Tweak a publicKey by adding tweak times the generator to it.
 * @method publicKeyTweakAdd
 * @param {Buffer} publicKey
 * @param {Buffer} tweak
 * @param {boolean} compressed
 * @return {Buffer}
 */ var publicKeyTweakAdd = function publicKeyTweakAdd(publicKey, tweak, compressed) {
    return Buffer.from(secp256k1.publicKeyTweakAdd(Uint8Array.from(publicKey), Uint8Array.from(tweak), compressed));
};
/**
 * Tweak a publicKey by multiplying it by a tweak value
 * @method publicKeyTweakMul
 * @param {Buffer} publicKey
 * @param {Buffer} tweak
 * @param {boolean} compressed
 * @return {Buffer}
 */ var publicKeyTweakMul = function publicKeyTweakMul(publicKey, tweak, compressed) {
    return Buffer.from(secp256k1.publicKeyTweakMul(Uint8Array.from(publicKey), Uint8Array.from(tweak), compressed));
};
/**
 * Add a given publicKeys together.
 * @method publicKeyCombine
 * @param {Array<Buffer>} publicKeys
 * @param {boolean} compressed
 * @return {Buffer}
 */ var publicKeyCombine = function publicKeyCombine(publicKeys, compressed) {
    var keys = [];
    publicKeys.forEach(function(publicKey) {
        keys.push(Uint8Array.from(publicKey));
    });
    return Buffer.from(secp256k1.publicKeyCombine(keys, compressed));
};
/**
 * Convert a signature to a normalized lower-S form.
 * @method signatureNormalize
 * @param {Buffer} signature
 * @return {Buffer}
 */ var signatureNormalize = function signatureNormalize(signature) {
    return Buffer.from(secp256k1.signatureNormalize(Uint8Array.from(signature)));
};
/**
 * Serialize an ECDSA signature in DER format.
 * @method signatureExport
 * @param {Buffer} signature
 * @return {Buffer}
 */ var signatureExport = function signatureExport(signature) {
    return Buffer.from(secp256k1.signatureExport(Uint8Array.from(signature)));
};
/**
 * Parse a DER ECDSA signature (follow by [BIP66](https://github.com/bitcoin/bips/blob/master/bip-0066.mediawiki)).
 * @method signatureImport
 * @param {Buffer} signature
 * @return {Buffer}
 */ var signatureImport = function signatureImport(signature) {
    return Buffer.from(secp256k1.signatureImport(Uint8Array.from(signature)));
};
/**
 * Parse a DER ECDSA signature (not follow by [BIP66](https://github.com/bitcoin/bips/blob/master/bip-0066.mediawiki)).
 * @method signatureImportLax
 * @param {Buffer} signature
 * @return {Buffer}
 */ var signatureImportLax = function signatureImportLax(signature) {
    // signatureImportLax method is not part of secp256k1 v4 package
    // this implementation is based on v3
    // ensure that signature is greater than 0
    if (signature.length === 0) throw new RangeError("signature length is invalid");
    var sigObj = der.signatureImportLax(signature);
    if (sigObj === null) throw new Error("couldn't parse DER signature");
    return secp256k1v3.signatureImport(sigObj);
};
/**
 * Create an ECDSA signature. Always return low-S signature.
 * @method sign
 * @param {Buffer} message
 * @param {Buffer} privateKey
 * @param {Object} options
 * @return {Buffer}
 */ var sign = function sign(message, privateKey, options) {
    if (options === null) throw new TypeError("options should be an Object");
    var signOptions = void 0;
    if (options) {
        signOptions = {};
        if (options.data === null) throw new TypeError("options.data should be a Buffer");
        if (options.data) {
            // validate option.data length
            if (options.data.length !== 32) throw new RangeError("options.data length is invalid");
            signOptions.data = new Uint8Array(options.data);
        }
        if (options.noncefn === null) throw new TypeError("options.noncefn should be a Function");
        if (options.noncefn) //  convert option.noncefn function signature
        signOptions.noncefn = function(message, privateKey, algo, data, attempt) {
            var bufferAlgo = algo != null ? Buffer.from(algo) : null;
            var bufferData = data != null ? Buffer.from(data) : null;
            var buffer = Buffer.from("");
            if (options.noncefn) buffer = options.noncefn(Buffer.from(message), Buffer.from(privateKey), bufferAlgo, bufferData, attempt);
            return Uint8Array.from(buffer);
        };
    }
    var sig = secp256k1.ecdsaSign(Uint8Array.from(message), Uint8Array.from(privateKey), signOptions);
    return {
        signature: Buffer.from(sig.signature),
        recovery: sig.recid
    };
};
/**
 * Verify an ECDSA signature.
 * @method verify
 * @param {Buffer} message
 * @param {Buffer} signature
 * @param {Buffer} publicKey
 * @return {boolean}
 */ var verify = function verify(message, signature, publicKey) {
    // note: secp256k1 v4 verify method has a different argument order
    return secp256k1.ecdsaVerify(Uint8Array.from(signature), Uint8Array.from(message), publicKey);
};
/**
 * Recover an ECDSA public key from a signature.
 * @method recover
 * @param {Buffer} message
 * @param {Buffer} signature
 * @param {Number} recid
 * @param {boolean} compressed
 * @return {Buffer}
 */ var recover = function recover(message, signature, recid, compressed) {
    // note: secp256k1 v4 recover method has a different argument order
    return Buffer.from(secp256k1.ecdsaRecover(Uint8Array.from(signature), recid, Uint8Array.from(message), compressed));
};
/**
 * Compute an EC Diffie-Hellman secret and applied sha256 to compressed public key.
 * @method ecdh
 * @param {Buffer} publicKey
 * @param {Buffer} privateKey
 * @return {Buffer}
 */ var ecdh = function ecdh(publicKey, privateKey) {
    // note: secp256k1 v3 doesn't allow optional parameter
    return Buffer.from(secp256k1.ecdh(Uint8Array.from(publicKey), Uint8Array.from(privateKey), {}));
};
/**
 * Compute an EC Diffie-Hellman secret and return public key as result
 * @method ecdhUnsafe
 * @param {Buffer} publicKey
 * @param {Buffer} privateKey
 * @param {boolean} compressed
 * @return {Buffer}
 */ var ecdhUnsafe = function ecdhUnsafe(publicKey, privateKey, compressed) {
    // ecdhUnsafe method is not part of secp256k1 v4 package
    // this implementation is based on v3
    // ensure valid publicKey length
    if (publicKey.length !== 33 && publicKey.length !== 65) throw new RangeError("public key length is invalid");
    // ensure valid privateKey length
    if (privateKey.length !== 32) throw new RangeError("private key length is invalid");
    return Buffer.from(secp256k1v3.ecdhUnsafe(Uint8Array.from(publicKey), Uint8Array.from(privateKey), compressed));
};
module.exports = {
    privateKeyVerify: privateKeyVerify,
    privateKeyExport: privateKeyExport,
    privateKeyImport: privateKeyImport,
    privateKeyNegate: privateKeyNegate,
    privateKeyModInverse: privateKeyModInverse,
    privateKeyTweakAdd: privateKeyTweakAdd,
    privateKeyTweakMul: privateKeyTweakMul,
    publicKeyCreate: publicKeyCreate,
    publicKeyConvert: publicKeyConvert,
    publicKeyVerify: publicKeyVerify,
    publicKeyTweakAdd: publicKeyTweakAdd,
    publicKeyTweakMul: publicKeyTweakMul,
    publicKeyCombine: publicKeyCombine,
    signatureNormalize: signatureNormalize,
    signatureExport: signatureExport,
    signatureImport: signatureImport,
    signatureImportLax: signatureImportLax,
    sign: sign,
    verify: verify,
    recover: recover,
    ecdh: ecdh,
    ecdhUnsafe: ecdhUnsafe
};

},{"8b7ca09b511c78a2":"l5Twm","cb04187a5900198f":"2QBD2","85ebcc4e73ed6155":"48TrQ","4ad52bae9b137bef":"8TOSa"}],"2QBD2":[function(require,module,exports) {
"use strict";
var __awaiter = this && this.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = this && this.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
function __export(m) {
    for(var p in m)if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", {
    value: true
});
var secp256k1_1 = require("f1436a9a0d0b5114");
var random_1 = require("19b86b95deedc266");
var SECP256K1_PRIVATE_KEY_SIZE = 32;
function createPrivateKey() {
    return __awaiter(this, void 0, void 0, function() {
        var pk;
        return __generator(this, function(_a) {
            switch(_a.label){
                case 0:
                    return [
                        4 /*yield*/ ,
                        random_1.getRandomBytes(SECP256K1_PRIVATE_KEY_SIZE)
                    ];
                case 1:
                    pk = _a.sent();
                    if (secp256k1_1.privateKeyVerify(pk)) return [
                        2 /*return*/ ,
                        pk
                    ];
                    return [
                        3 /*break*/ ,
                        0
                    ];
                case 2:
                    return [
                        2 /*return*/ 
                    ];
            }
        });
    });
}
exports.createPrivateKey = createPrivateKey;
function createPrivateKeySync() {
    while(true){
        var pk = random_1.getRandomBytesSync(SECP256K1_PRIVATE_KEY_SIZE);
        if (secp256k1_1.privateKeyVerify(pk)) return pk;
    }
}
exports.createPrivateKeySync = createPrivateKeySync;
__export(require("f1436a9a0d0b5114"));

},{"f1436a9a0d0b5114":"7ynPs","19b86b95deedc266":"lfTzm"}],"7ynPs":[function(require,module,exports) {
module.exports = require("1d3e12b7735ca1d0")(require("e1f68c3df0b8a294"));

},{"1d3e12b7735ca1d0":"ublpV","e1f68c3df0b8a294":"6jZ0R"}],"ublpV":[function(require,module,exports) {
const errors = {
    IMPOSSIBLE_CASE: "Impossible case. Please create issue.",
    TWEAK_ADD: "The tweak was out of range or the resulted private key is invalid",
    TWEAK_MUL: "The tweak was out of range or equal to zero",
    CONTEXT_RANDOMIZE_UNKNOW: "Unknow error on context randomization",
    SECKEY_INVALID: "Private Key is invalid",
    PUBKEY_PARSE: "Public Key could not be parsed",
    PUBKEY_SERIALIZE: "Public Key serialization error",
    PUBKEY_COMBINE: "The sum of the public keys is not valid",
    SIG_PARSE: "Signature could not be parsed",
    SIGN: "The nonce generation function failed, or the private key was invalid",
    RECOVER: "Public key could not be recover",
    ECDH: "Scalar was invalid (zero or overflow)"
};
function assert(cond, msg) {
    if (!cond) throw new Error(msg);
}
function isUint8Array(name, value, length) {
    assert(value instanceof Uint8Array, `Expected ${name} to be an Uint8Array`);
    if (length !== undefined) {
        if (Array.isArray(length)) {
            const numbers = length.join(", ");
            const msg = `Expected ${name} to be an Uint8Array with length [${numbers}]`;
            assert(length.includes(value.length), msg);
        } else {
            const msg = `Expected ${name} to be an Uint8Array with length ${length}`;
            assert(value.length === length, msg);
        }
    }
}
function isCompressed(value) {
    assert(toTypeString(value) === "Boolean", "Expected compressed to be a Boolean");
}
function getAssertedOutput(output = (len)=>new Uint8Array(len), length) {
    if (typeof output === "function") output = output(length);
    isUint8Array("output", output, length);
    return output;
}
function toTypeString(value) {
    return Object.prototype.toString.call(value).slice(8, -1);
}
module.exports = (secp256k1)=>{
    return {
        contextRandomize (seed) {
            assert(seed === null || seed instanceof Uint8Array, "Expected seed to be an Uint8Array or null");
            if (seed !== null) isUint8Array("seed", seed, 32);
            switch(secp256k1.contextRandomize(seed)){
                case 1:
                    throw new Error(errors.CONTEXT_RANDOMIZE_UNKNOW);
            }
        },
        privateKeyVerify (seckey) {
            isUint8Array("private key", seckey, 32);
            return secp256k1.privateKeyVerify(seckey) === 0;
        },
        privateKeyNegate (seckey) {
            isUint8Array("private key", seckey, 32);
            switch(secp256k1.privateKeyNegate(seckey)){
                case 0:
                    return seckey;
                case 1:
                    throw new Error(errors.IMPOSSIBLE_CASE);
            }
        },
        privateKeyTweakAdd (seckey, tweak) {
            isUint8Array("private key", seckey, 32);
            isUint8Array("tweak", tweak, 32);
            switch(secp256k1.privateKeyTweakAdd(seckey, tweak)){
                case 0:
                    return seckey;
                case 1:
                    throw new Error(errors.TWEAK_ADD);
            }
        },
        privateKeyTweakMul (seckey, tweak) {
            isUint8Array("private key", seckey, 32);
            isUint8Array("tweak", tweak, 32);
            switch(secp256k1.privateKeyTweakMul(seckey, tweak)){
                case 0:
                    return seckey;
                case 1:
                    throw new Error(errors.TWEAK_MUL);
            }
        },
        publicKeyVerify (pubkey) {
            isUint8Array("public key", pubkey, [
                33,
                65
            ]);
            return secp256k1.publicKeyVerify(pubkey) === 0;
        },
        publicKeyCreate (seckey, compressed = true, output) {
            isUint8Array("private key", seckey, 32);
            isCompressed(compressed);
            output = getAssertedOutput(output, compressed ? 33 : 65);
            switch(secp256k1.publicKeyCreate(output, seckey)){
                case 0:
                    return output;
                case 1:
                    throw new Error(errors.SECKEY_INVALID);
                case 2:
                    throw new Error(errors.PUBKEY_SERIALIZE);
            }
        },
        publicKeyConvert (pubkey, compressed = true, output) {
            isUint8Array("public key", pubkey, [
                33,
                65
            ]);
            isCompressed(compressed);
            output = getAssertedOutput(output, compressed ? 33 : 65);
            switch(secp256k1.publicKeyConvert(output, pubkey)){
                case 0:
                    return output;
                case 1:
                    throw new Error(errors.PUBKEY_PARSE);
                case 2:
                    throw new Error(errors.PUBKEY_SERIALIZE);
            }
        },
        publicKeyNegate (pubkey, compressed = true, output) {
            isUint8Array("public key", pubkey, [
                33,
                65
            ]);
            isCompressed(compressed);
            output = getAssertedOutput(output, compressed ? 33 : 65);
            switch(secp256k1.publicKeyNegate(output, pubkey)){
                case 0:
                    return output;
                case 1:
                    throw new Error(errors.PUBKEY_PARSE);
                case 2:
                    throw new Error(errors.IMPOSSIBLE_CASE);
                case 3:
                    throw new Error(errors.PUBKEY_SERIALIZE);
            }
        },
        publicKeyCombine (pubkeys, compressed = true, output) {
            assert(Array.isArray(pubkeys), "Expected public keys to be an Array");
            assert(pubkeys.length > 0, "Expected public keys array will have more than zero items");
            for (const pubkey of pubkeys)isUint8Array("public key", pubkey, [
                33,
                65
            ]);
            isCompressed(compressed);
            output = getAssertedOutput(output, compressed ? 33 : 65);
            switch(secp256k1.publicKeyCombine(output, pubkeys)){
                case 0:
                    return output;
                case 1:
                    throw new Error(errors.PUBKEY_PARSE);
                case 2:
                    throw new Error(errors.PUBKEY_COMBINE);
                case 3:
                    throw new Error(errors.PUBKEY_SERIALIZE);
            }
        },
        publicKeyTweakAdd (pubkey, tweak, compressed = true, output) {
            isUint8Array("public key", pubkey, [
                33,
                65
            ]);
            isUint8Array("tweak", tweak, 32);
            isCompressed(compressed);
            output = getAssertedOutput(output, compressed ? 33 : 65);
            switch(secp256k1.publicKeyTweakAdd(output, pubkey, tweak)){
                case 0:
                    return output;
                case 1:
                    throw new Error(errors.PUBKEY_PARSE);
                case 2:
                    throw new Error(errors.TWEAK_ADD);
            }
        },
        publicKeyTweakMul (pubkey, tweak, compressed = true, output) {
            isUint8Array("public key", pubkey, [
                33,
                65
            ]);
            isUint8Array("tweak", tweak, 32);
            isCompressed(compressed);
            output = getAssertedOutput(output, compressed ? 33 : 65);
            switch(secp256k1.publicKeyTweakMul(output, pubkey, tweak)){
                case 0:
                    return output;
                case 1:
                    throw new Error(errors.PUBKEY_PARSE);
                case 2:
                    throw new Error(errors.TWEAK_MUL);
            }
        },
        signatureNormalize (sig) {
            isUint8Array("signature", sig, 64);
            switch(secp256k1.signatureNormalize(sig)){
                case 0:
                    return sig;
                case 1:
                    throw new Error(errors.SIG_PARSE);
            }
        },
        signatureExport (sig, output) {
            isUint8Array("signature", sig, 64);
            output = getAssertedOutput(output, 72);
            const obj = {
                output,
                outputlen: 72
            };
            switch(secp256k1.signatureExport(obj, sig)){
                case 0:
                    return output.slice(0, obj.outputlen);
                case 1:
                    throw new Error(errors.SIG_PARSE);
                case 2:
                    throw new Error(errors.IMPOSSIBLE_CASE);
            }
        },
        signatureImport (sig, output) {
            isUint8Array("signature", sig);
            output = getAssertedOutput(output, 64);
            switch(secp256k1.signatureImport(output, sig)){
                case 0:
                    return output;
                case 1:
                    throw new Error(errors.SIG_PARSE);
                case 2:
                    throw new Error(errors.IMPOSSIBLE_CASE);
            }
        },
        ecdsaSign (msg32, seckey, options = {}, output) {
            isUint8Array("message", msg32, 32);
            isUint8Array("private key", seckey, 32);
            assert(toTypeString(options) === "Object", "Expected options to be an Object");
            if (options.data !== undefined) isUint8Array("options.data", options.data);
            if (options.noncefn !== undefined) assert(toTypeString(options.noncefn) === "Function", "Expected options.noncefn to be a Function");
            output = getAssertedOutput(output, 64);
            const obj = {
                signature: output,
                recid: null
            };
            switch(secp256k1.ecdsaSign(obj, msg32, seckey, options.data, options.noncefn)){
                case 0:
                    return obj;
                case 1:
                    throw new Error(errors.SIGN);
                case 2:
                    throw new Error(errors.IMPOSSIBLE_CASE);
            }
        },
        ecdsaVerify (sig, msg32, pubkey) {
            isUint8Array("signature", sig, 64);
            isUint8Array("message", msg32, 32);
            isUint8Array("public key", pubkey, [
                33,
                65
            ]);
            switch(secp256k1.ecdsaVerify(sig, msg32, pubkey)){
                case 0:
                    return true;
                case 3:
                    return false;
                case 1:
                    throw new Error(errors.SIG_PARSE);
                case 2:
                    throw new Error(errors.PUBKEY_PARSE);
            }
        },
        ecdsaRecover (sig, recid, msg32, compressed = true, output) {
            isUint8Array("signature", sig, 64);
            assert(toTypeString(recid) === "Number" && recid >= 0 && recid <= 3, "Expected recovery id to be a Number within interval [0, 3]");
            isUint8Array("message", msg32, 32);
            isCompressed(compressed);
            output = getAssertedOutput(output, compressed ? 33 : 65);
            switch(secp256k1.ecdsaRecover(output, sig, recid, msg32)){
                case 0:
                    return output;
                case 1:
                    throw new Error(errors.SIG_PARSE);
                case 2:
                    throw new Error(errors.RECOVER);
                case 3:
                    throw new Error(errors.IMPOSSIBLE_CASE);
            }
        },
        ecdh (pubkey, seckey, options = {}, output) {
            isUint8Array("public key", pubkey, [
                33,
                65
            ]);
            isUint8Array("private key", seckey, 32);
            assert(toTypeString(options) === "Object", "Expected options to be an Object");
            if (options.data !== undefined) isUint8Array("options.data", options.data);
            if (options.hashfn !== undefined) {
                assert(toTypeString(options.hashfn) === "Function", "Expected options.hashfn to be a Function");
                if (options.xbuf !== undefined) isUint8Array("options.xbuf", options.xbuf, 32);
                if (options.ybuf !== undefined) isUint8Array("options.ybuf", options.ybuf, 32);
                isUint8Array("output", output);
            } else output = getAssertedOutput(output, 32);
            switch(secp256k1.ecdh(output, pubkey, seckey, options.data, options.hashfn, options.xbuf, options.ybuf)){
                case 0:
                    return output;
                case 1:
                    throw new Error(errors.PUBKEY_PARSE);
                case 2:
                    throw new Error(errors.ECDH);
            }
        }
    };
};

},{}],"6jZ0R":[function(require,module,exports) {
const EC = require("3ab9749d2e756678").ec;
const ec = new EC("secp256k1");
const ecparams = ec.curve;
// Hack, we can not use bn.js@5, while elliptic uses bn.js@4
// See https://github.com/indutny/elliptic/issues/191#issuecomment-569888758
const BN = ecparams.n.constructor;
function loadCompressedPublicKey(first, xbuf) {
    let x = new BN(xbuf);
    // overflow
    if (x.cmp(ecparams.p) >= 0) return null;
    x = x.toRed(ecparams.red);
    // compute corresponding Y
    let y = x.redSqr().redIMul(x).redIAdd(ecparams.b).redSqrt();
    if (first === 0x03 !== y.isOdd()) y = y.redNeg();
    return ec.keyPair({
        pub: {
            x: x,
            y: y
        }
    });
}
function loadUncompressedPublicKey(first, xbuf, ybuf) {
    let x = new BN(xbuf);
    let y = new BN(ybuf);
    // overflow
    if (x.cmp(ecparams.p) >= 0 || y.cmp(ecparams.p) >= 0) return null;
    x = x.toRed(ecparams.red);
    y = y.toRed(ecparams.red);
    // is odd flag
    if ((first === 0x06 || first === 0x07) && y.isOdd() !== (first === 0x07)) return null;
    // x*x*x + b = y*y
    const x3 = x.redSqr().redIMul(x);
    if (!y.redSqr().redISub(x3.redIAdd(ecparams.b)).isZero()) return null;
    return ec.keyPair({
        pub: {
            x: x,
            y: y
        }
    });
}
function loadPublicKey(pubkey) {
    // length should be validated in interface
    const first = pubkey[0];
    switch(first){
        case 0x02:
        case 0x03:
            if (pubkey.length !== 33) return null;
            return loadCompressedPublicKey(first, pubkey.subarray(1, 33));
        case 0x04:
        case 0x06:
        case 0x07:
            if (pubkey.length !== 65) return null;
            return loadUncompressedPublicKey(first, pubkey.subarray(1, 33), pubkey.subarray(33, 65));
        default:
            return null;
    }
}
function savePublicKey(output, point) {
    const pubkey = point.encode(null, output.length === 33);
    // Loop should be faster because we do not need create extra Uint8Array
    // output.set(new Uint8Array(pubkey))
    for(let i = 0; i < output.length; ++i)output[i] = pubkey[i];
}
module.exports = {
    contextRandomize () {
        return 0;
    },
    privateKeyVerify (seckey) {
        const bn = new BN(seckey);
        return bn.cmp(ecparams.n) < 0 && !bn.isZero() ? 0 : 1;
    },
    privateKeyNegate (seckey) {
        const bn = new BN(seckey);
        const negate = ecparams.n.sub(bn).umod(ecparams.n).toArrayLike(Uint8Array, "be", 32);
        seckey.set(negate);
        return 0;
    },
    privateKeyTweakAdd (seckey, tweak) {
        const bn = new BN(tweak);
        if (bn.cmp(ecparams.n) >= 0) return 1;
        bn.iadd(new BN(seckey));
        if (bn.cmp(ecparams.n) >= 0) bn.isub(ecparams.n);
        if (bn.isZero()) return 1;
        const tweaked = bn.toArrayLike(Uint8Array, "be", 32);
        seckey.set(tweaked);
        return 0;
    },
    privateKeyTweakMul (seckey, tweak) {
        let bn = new BN(tweak);
        if (bn.cmp(ecparams.n) >= 0 || bn.isZero()) return 1;
        bn.imul(new BN(seckey));
        if (bn.cmp(ecparams.n) >= 0) bn = bn.umod(ecparams.n);
        const tweaked = bn.toArrayLike(Uint8Array, "be", 32);
        seckey.set(tweaked);
        return 0;
    },
    publicKeyVerify (pubkey) {
        const pair = loadPublicKey(pubkey);
        return pair === null ? 1 : 0;
    },
    publicKeyCreate (output, seckey) {
        const bn = new BN(seckey);
        if (bn.cmp(ecparams.n) >= 0 || bn.isZero()) return 1;
        const point = ec.keyFromPrivate(seckey).getPublic();
        savePublicKey(output, point);
        return 0;
    },
    publicKeyConvert (output, pubkey) {
        const pair = loadPublicKey(pubkey);
        if (pair === null) return 1;
        const point = pair.getPublic();
        savePublicKey(output, point);
        return 0;
    },
    publicKeyNegate (output, pubkey) {
        const pair = loadPublicKey(pubkey);
        if (pair === null) return 1;
        const point = pair.getPublic();
        point.y = point.y.redNeg();
        savePublicKey(output, point);
        return 0;
    },
    publicKeyCombine (output, pubkeys) {
        const pairs = new Array(pubkeys.length);
        for(let i = 0; i < pubkeys.length; ++i){
            pairs[i] = loadPublicKey(pubkeys[i]);
            if (pairs[i] === null) return 1;
        }
        let point = pairs[0].getPublic();
        for(let i = 1; i < pairs.length; ++i)point = point.add(pairs[i].pub);
        if (point.isInfinity()) return 2;
        savePublicKey(output, point);
        return 0;
    },
    publicKeyTweakAdd (output, pubkey, tweak) {
        const pair = loadPublicKey(pubkey);
        if (pair === null) return 1;
        tweak = new BN(tweak);
        if (tweak.cmp(ecparams.n) >= 0) return 2;
        const point = pair.getPublic().add(ecparams.g.mul(tweak));
        if (point.isInfinity()) return 2;
        savePublicKey(output, point);
        return 0;
    },
    publicKeyTweakMul (output, pubkey, tweak) {
        const pair = loadPublicKey(pubkey);
        if (pair === null) return 1;
        tweak = new BN(tweak);
        if (tweak.cmp(ecparams.n) >= 0 || tweak.isZero()) return 2;
        const point = pair.getPublic().mul(tweak);
        savePublicKey(output, point);
        return 0;
    },
    signatureNormalize (sig) {
        const r = new BN(sig.subarray(0, 32));
        const s = new BN(sig.subarray(32, 64));
        if (r.cmp(ecparams.n) >= 0 || s.cmp(ecparams.n) >= 0) return 1;
        if (s.cmp(ec.nh) === 1) sig.set(ecparams.n.sub(s).toArrayLike(Uint8Array, "be", 32), 32);
        return 0;
    },
    // Copied 1-to-1 from https://github.com/bitcoinjs/bip66/blob/master/index.js
    // Adapted for Uint8Array instead Buffer
    signatureExport (obj, sig) {
        const sigR = sig.subarray(0, 32);
        const sigS = sig.subarray(32, 64);
        if (new BN(sigR).cmp(ecparams.n) >= 0) return 1;
        if (new BN(sigS).cmp(ecparams.n) >= 0) return 1;
        const { output } = obj;
        // Prepare R
        let r = output.subarray(4, 37);
        r[0] = 0x00;
        r.set(sigR, 1);
        let lenR = 33;
        let posR = 0;
        for(; lenR > 1 && r[posR] === 0x00 && !(r[posR + 1] & 0x80); --lenR, ++posR);
        r = r.subarray(posR);
        if (r[0] & 0x80) return 1;
        if (lenR > 1 && r[0] === 0x00 && !(r[1] & 0x80)) return 1;
        // Prepare S
        let s = output.subarray(39, 72);
        s[0] = 0x00;
        s.set(sigS, 1);
        let lenS = 33;
        let posS = 0;
        for(; lenS > 1 && s[posS] === 0x00 && !(s[posS + 1] & 0x80); --lenS, ++posS);
        s = s.subarray(posS);
        if (s[0] & 0x80) return 1;
        if (lenS > 1 && s[0] === 0x00 && !(s[1] & 0x80)) return 1;
        // Set output length for return
        obj.outputlen = 6 + lenR + lenS;
        // Output in specified format
        // 0x30 [total-length] 0x02 [R-length] [R] 0x02 [S-length] [S]
        output[0] = 0x30;
        output[1] = obj.outputlen - 2;
        output[2] = 0x02;
        output[3] = r.length;
        output.set(r, 4);
        output[4 + lenR] = 0x02;
        output[5 + lenR] = s.length;
        output.set(s, 6 + lenR);
        return 0;
    },
    // Copied 1-to-1 from https://github.com/bitcoinjs/bip66/blob/master/index.js
    // Adapted for Uint8Array instead Buffer
    signatureImport (output, sig) {
        if (sig.length < 8) return 1;
        if (sig.length > 72) return 1;
        if (sig[0] !== 0x30) return 1;
        if (sig[1] !== sig.length - 2) return 1;
        if (sig[2] !== 0x02) return 1;
        const lenR = sig[3];
        if (lenR === 0) return 1;
        if (5 + lenR >= sig.length) return 1;
        if (sig[4 + lenR] !== 0x02) return 1;
        const lenS = sig[5 + lenR];
        if (lenS === 0) return 1;
        if (6 + lenR + lenS !== sig.length) return 1;
        if (sig[4] & 0x80) return 1;
        if (lenR > 1 && sig[4] === 0x00 && !(sig[5] & 0x80)) return 1;
        if (sig[lenR + 6] & 0x80) return 1;
        if (lenS > 1 && sig[lenR + 6] === 0x00 && !(sig[lenR + 7] & 0x80)) return 1;
        let sigR = sig.subarray(4, 4 + lenR);
        if (sigR.length === 33 && sigR[0] === 0x00) sigR = sigR.subarray(1);
        if (sigR.length > 32) return 1;
        let sigS = sig.subarray(6 + lenR);
        if (sigS.length === 33 && sigS[0] === 0x00) sigS = sigS.slice(1);
        if (sigS.length > 32) throw new Error("S length is too long");
        let r = new BN(sigR);
        if (r.cmp(ecparams.n) >= 0) r = new BN(0);
        let s = new BN(sig.subarray(6 + lenR));
        if (s.cmp(ecparams.n) >= 0) s = new BN(0);
        output.set(r.toArrayLike(Uint8Array, "be", 32), 0);
        output.set(s.toArrayLike(Uint8Array, "be", 32), 32);
        return 0;
    },
    ecdsaSign (obj, message, seckey, data, noncefn) {
        if (noncefn) {
            const _noncefn = noncefn;
            noncefn = (counter)=>{
                const nonce = _noncefn(message, seckey, null, data, counter);
                const isValid = nonce instanceof Uint8Array && nonce.length === 32;
                if (!isValid) throw new Error("This is the way");
                return new BN(nonce);
            };
        }
        const d = new BN(seckey);
        if (d.cmp(ecparams.n) >= 0 || d.isZero()) return 1;
        let sig;
        try {
            sig = ec.sign(message, seckey, {
                canonical: true,
                k: noncefn,
                pers: data
            });
        } catch (err) {
            return 1;
        }
        obj.signature.set(sig.r.toArrayLike(Uint8Array, "be", 32), 0);
        obj.signature.set(sig.s.toArrayLike(Uint8Array, "be", 32), 32);
        obj.recid = sig.recoveryParam;
        return 0;
    },
    ecdsaVerify (sig, msg32, pubkey) {
        const sigObj = {
            r: sig.subarray(0, 32),
            s: sig.subarray(32, 64)
        };
        const sigr = new BN(sigObj.r);
        const sigs = new BN(sigObj.s);
        if (sigr.cmp(ecparams.n) >= 0 || sigs.cmp(ecparams.n) >= 0) return 1;
        if (sigs.cmp(ec.nh) === 1 || sigr.isZero() || sigs.isZero()) return 3;
        const pair = loadPublicKey(pubkey);
        if (pair === null) return 2;
        const point = pair.getPublic();
        const isValid = ec.verify(msg32, sigObj, point);
        return isValid ? 0 : 3;
    },
    ecdsaRecover (output, sig, recid, msg32) {
        const sigObj = {
            r: sig.slice(0, 32),
            s: sig.slice(32, 64)
        };
        const sigr = new BN(sigObj.r);
        const sigs = new BN(sigObj.s);
        if (sigr.cmp(ecparams.n) >= 0 || sigs.cmp(ecparams.n) >= 0) return 1;
        if (sigr.isZero() || sigs.isZero()) return 2;
        // Can throw `throw new Error('Unable to find sencond key candinate');`
        let point;
        try {
            point = ec.recoverPubKey(msg32, sigObj, recid);
        } catch (err) {
            return 2;
        }
        savePublicKey(output, point);
        return 0;
    },
    ecdh (output, pubkey, seckey, data, hashfn, xbuf, ybuf) {
        const pair = loadPublicKey(pubkey);
        if (pair === null) return 1;
        const scalar = new BN(seckey);
        if (scalar.cmp(ecparams.n) >= 0 || scalar.isZero()) return 2;
        const point = pair.getPublic().mul(scalar);
        if (hashfn === undefined) {
            const data = point.encode(null, true);
            const sha256 = ec.hash().update(data).digest();
            for(let i = 0; i < 32; ++i)output[i] = sha256[i];
        } else {
            if (!xbuf) xbuf = new Uint8Array(32);
            const x = point.getX().toArray("be", 32);
            for(let i = 0; i < 32; ++i)xbuf[i] = x[i];
            if (!ybuf) ybuf = new Uint8Array(32);
            const y = point.getY().toArray("be", 32);
            for(let i = 0; i < 32; ++i)ybuf[i] = y[i];
            const hash = hashfn(xbuf, ybuf, data);
            const isValid = hash instanceof Uint8Array && hash.length === output.length;
            if (!isValid) return 2;
            output.set(hash);
        }
        return 0;
    }
};

},{"3ab9749d2e756678":"e8UEU"}],"e8UEU":[function(require,module,exports) {
"use strict";
var elliptic = exports;
elliptic.version = require("e6672bc3ba1c9961").version;
elliptic.utils = require("5bc72f89931ad0f5");
elliptic.rand = require("7f90d752a36f35cf");
elliptic.curve = require("d11da69c91421223");
elliptic.curves = require("6845bad4ed92c3e4");
// Protocols
elliptic.ec = require("b5f2e1f615acc4b");
elliptic.eddsa = require("79ae761761517980");

},{"e6672bc3ba1c9961":"3u0Xw","5bc72f89931ad0f5":"7PLUP","7f90d752a36f35cf":"dzcfb","d11da69c91421223":"3ZY1v","6845bad4ed92c3e4":"ab7Cj","b5f2e1f615acc4b":"6GXut","79ae761761517980":"7YIGW"}],"3u0Xw":[function(require,module,exports) {
module.exports = JSON.parse('{"name":"elliptic","version":"6.5.7","description":"EC cryptography","main":"lib/elliptic.js","files":["lib"],"scripts":{"lint":"eslint lib test","lint:fix":"npm run lint -- --fix","unit":"istanbul test _mocha --reporter=spec test/index.js","test":"npm run lint && npm run unit","version":"grunt dist && git add dist/"},"repository":{"type":"git","url":"git@github.com:indutny/elliptic"},"keywords":["EC","Elliptic","curve","Cryptography"],"author":"Fedor Indutny <fedor@indutny.com>","license":"MIT","bugs":{"url":"https://github.com/indutny/elliptic/issues"},"homepage":"https://github.com/indutny/elliptic","devDependencies":{"brfs":"^2.0.2","coveralls":"^3.1.0","eslint":"^7.6.0","grunt":"^1.2.1","grunt-browserify":"^5.3.0","grunt-cli":"^1.3.2","grunt-contrib-connect":"^3.0.0","grunt-contrib-copy":"^1.0.0","grunt-contrib-uglify":"^5.0.0","grunt-mocha-istanbul":"^5.0.2","grunt-saucelabs":"^9.0.1","istanbul":"^0.4.5","mocha":"^8.0.1"},"dependencies":{"bn.js":"^4.11.9","brorand":"^1.1.0","hash.js":"^1.0.0","hmac-drbg":"^1.0.1","inherits":"^2.0.4","minimalistic-assert":"^1.0.1","minimalistic-crypto-utils":"^1.0.1"}}');

},{}],"7PLUP":[function(require,module,exports) {
"use strict";
var utils = exports;
var BN = require("f4cbcf6f6eb25ca0");
var minAssert = require("d8ee30463f95a0fd");
var minUtils = require("997429d6bbd82d59");
utils.assert = minAssert;
utils.toArray = minUtils.toArray;
utils.zero2 = minUtils.zero2;
utils.toHex = minUtils.toHex;
utils.encode = minUtils.encode;
// Represent num in a w-NAF form
function getNAF(num, w, bits) {
    var naf = new Array(Math.max(num.bitLength(), bits) + 1);
    var i;
    for(i = 0; i < naf.length; i += 1)naf[i] = 0;
    var ws = 1 << w + 1;
    var k = num.clone();
    for(i = 0; i < naf.length; i++){
        var z;
        var mod = k.andln(ws - 1);
        if (k.isOdd()) {
            if (mod > (ws >> 1) - 1) z = (ws >> 1) - mod;
            else z = mod;
            k.isubn(z);
        } else z = 0;
        naf[i] = z;
        k.iushrn(1);
    }
    return naf;
}
utils.getNAF = getNAF;
// Represent k1, k2 in a Joint Sparse Form
function getJSF(k1, k2) {
    var jsf = [
        [],
        []
    ];
    k1 = k1.clone();
    k2 = k2.clone();
    var d1 = 0;
    var d2 = 0;
    var m8;
    while(k1.cmpn(-d1) > 0 || k2.cmpn(-d2) > 0){
        // First phase
        var m14 = k1.andln(3) + d1 & 3;
        var m24 = k2.andln(3) + d2 & 3;
        if (m14 === 3) m14 = -1;
        if (m24 === 3) m24 = -1;
        var u1;
        if ((m14 & 1) === 0) u1 = 0;
        else {
            m8 = k1.andln(7) + d1 & 7;
            if ((m8 === 3 || m8 === 5) && m24 === 2) u1 = -m14;
            else u1 = m14;
        }
        jsf[0].push(u1);
        var u2;
        if ((m24 & 1) === 0) u2 = 0;
        else {
            m8 = k2.andln(7) + d2 & 7;
            if ((m8 === 3 || m8 === 5) && m14 === 2) u2 = -m24;
            else u2 = m24;
        }
        jsf[1].push(u2);
        // Second phase
        if (2 * d1 === u1 + 1) d1 = 1 - d1;
        if (2 * d2 === u2 + 1) d2 = 1 - d2;
        k1.iushrn(1);
        k2.iushrn(1);
    }
    return jsf;
}
utils.getJSF = getJSF;
function cachedProperty(obj, name, computer) {
    var key = "_" + name;
    obj.prototype[name] = function cachedProperty() {
        return this[key] !== undefined ? this[key] : this[key] = computer.call(this);
    };
}
utils.cachedProperty = cachedProperty;
function parseBytes(bytes) {
    return typeof bytes === "string" ? utils.toArray(bytes, "hex") : bytes;
}
utils.parseBytes = parseBytes;
function intFromLE(bytes) {
    return new BN(bytes, "hex", "le");
}
utils.intFromLE = intFromLE;

},{"f4cbcf6f6eb25ca0":"kRh32","d8ee30463f95a0fd":"cKbUa","997429d6bbd82d59":"1KIes"}],"kRh32":[function(require,module,exports) {
(function(module1, exports) {
    "use strict";
    // Utils
    function assert(val, msg) {
        if (!val) throw new Error(msg || "Assertion failed");
    }
    // Could use `inherits` module, but don't want to move from single file
    // architecture yet.
    function inherits(ctor, superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
    // BN
    function BN(number, base, endian) {
        if (BN.isBN(number)) return number;
        this.negative = 0;
        this.words = null;
        this.length = 0;
        // Reduction context
        this.red = null;
        if (number !== null) {
            if (base === "le" || base === "be") {
                endian = base;
                base = 10;
            }
            this._init(number || 0, base || 10, endian || "be");
        }
    }
    if (typeof module1 === "object") module1.exports = BN;
    else exports.BN = BN;
    BN.BN = BN;
    BN.wordSize = 26;
    var Buffer;
    try {
        if (typeof window !== "undefined" && typeof window.Buffer !== "undefined") Buffer = window.Buffer;
        else Buffer = require("1cf9b8cfa268aab5").Buffer;
    } catch (e) {}
    BN.isBN = function isBN(num) {
        if (num instanceof BN) return true;
        return num !== null && typeof num === "object" && num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
    };
    BN.max = function max(left, right) {
        if (left.cmp(right) > 0) return left;
        return right;
    };
    BN.min = function min(left, right) {
        if (left.cmp(right) < 0) return left;
        return right;
    };
    BN.prototype._init = function init(number, base, endian) {
        if (typeof number === "number") return this._initNumber(number, base, endian);
        if (typeof number === "object") return this._initArray(number, base, endian);
        if (base === "hex") base = 16;
        assert(base === (base | 0) && base >= 2 && base <= 36);
        number = number.toString().replace(/\s+/g, "");
        var start = 0;
        if (number[0] === "-") {
            start++;
            this.negative = 1;
        }
        if (start < number.length) {
            if (base === 16) this._parseHex(number, start, endian);
            else {
                this._parseBase(number, base, start);
                if (endian === "le") this._initArray(this.toArray(), base, endian);
            }
        }
    };
    BN.prototype._initNumber = function _initNumber(number, base, endian) {
        if (number < 0) {
            this.negative = 1;
            number = -number;
        }
        if (number < 0x4000000) {
            this.words = [
                number & 0x3ffffff
            ];
            this.length = 1;
        } else if (number < 0x10000000000000) {
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff
            ];
            this.length = 2;
        } else {
            assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff,
                1
            ];
            this.length = 3;
        }
        if (endian !== "le") return;
        // Reverse the bytes
        this._initArray(this.toArray(), base, endian);
    };
    BN.prototype._initArray = function _initArray(number, base, endian) {
        // Perhaps a Uint8Array
        assert(typeof number.length === "number");
        if (number.length <= 0) {
            this.words = [
                0
            ];
            this.length = 1;
            return this;
        }
        this.length = Math.ceil(number.length / 3);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        var j, w;
        var off = 0;
        if (endian === "be") for(i = number.length - 1, j = 0; i >= 0; i -= 3){
            w = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        else if (endian === "le") for(i = 0, j = 0; i < number.length; i += 3){
            w = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        return this.strip();
    };
    function parseHex4Bits(string, index) {
        var c = string.charCodeAt(index);
        // 'A' - 'F'
        if (c >= 65 && c <= 70) return c - 55;
        else if (c >= 97 && c <= 102) return c - 87;
        else return c - 48 & 0xf;
    }
    function parseHexByte(string, lowerBound, index) {
        var r = parseHex4Bits(string, index);
        if (index - 1 >= lowerBound) r |= parseHex4Bits(string, index - 1) << 4;
        return r;
    }
    BN.prototype._parseHex = function _parseHex(number, start, endian) {
        // Create possibly bigger array to ensure that it fits the number
        this.length = Math.ceil((number.length - start) / 6);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        // 24-bits chunks
        var off = 0;
        var j = 0;
        var w;
        if (endian === "be") for(i = number.length - 1; i >= start; i -= 2){
            w = parseHexByte(number, start, i) << off;
            this.words[j] |= w & 0x3ffffff;
            if (off >= 18) {
                off -= 18;
                j += 1;
                this.words[j] |= w >>> 26;
            } else off += 8;
        }
        else {
            var parseLength = number.length - start;
            for(i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2){
                w = parseHexByte(number, start, i) << off;
                this.words[j] |= w & 0x3ffffff;
                if (off >= 18) {
                    off -= 18;
                    j += 1;
                    this.words[j] |= w >>> 26;
                } else off += 8;
            }
        }
        this.strip();
    };
    function parseBase(str, start, end, mul) {
        var r = 0;
        var len = Math.min(str.length, end);
        for(var i = start; i < len; i++){
            var c = str.charCodeAt(i) - 48;
            r *= mul;
            // 'a'
            if (c >= 49) r += c - 49 + 0xa;
            else if (c >= 17) r += c - 17 + 0xa;
            else r += c;
        }
        return r;
    }
    BN.prototype._parseBase = function _parseBase(number, base, start) {
        // Initialize as zero
        this.words = [
            0
        ];
        this.length = 1;
        // Find length of limb in base
        for(var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base)limbLen++;
        limbLen--;
        limbPow = limbPow / base | 0;
        var total = number.length - start;
        var mod = total % limbLen;
        var end = Math.min(total, total - mod) + start;
        var word = 0;
        for(var i = start; i < end; i += limbLen){
            word = parseBase(number, i, i + limbLen, base);
            this.imuln(limbPow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        if (mod !== 0) {
            var pow = 1;
            word = parseBase(number, i, number.length, base);
            for(i = 0; i < mod; i++)pow *= base;
            this.imuln(pow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        this.strip();
    };
    BN.prototype.copy = function copy(dest) {
        dest.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)dest.words[i] = this.words[i];
        dest.length = this.length;
        dest.negative = this.negative;
        dest.red = this.red;
    };
    BN.prototype.clone = function clone() {
        var r = new BN(null);
        this.copy(r);
        return r;
    };
    BN.prototype._expand = function _expand(size) {
        while(this.length < size)this.words[this.length++] = 0;
        return this;
    };
    // Remove leading `0` from `this`
    BN.prototype.strip = function strip() {
        while(this.length > 1 && this.words[this.length - 1] === 0)this.length--;
        return this._normSign();
    };
    BN.prototype._normSign = function _normSign() {
        // -0 = 0
        if (this.length === 1 && this.words[0] === 0) this.negative = 0;
        return this;
    };
    BN.prototype.inspect = function inspect() {
        return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
    };
    /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */ var zeros = [
        "",
        "0",
        "00",
        "000",
        "0000",
        "00000",
        "000000",
        "0000000",
        "00000000",
        "000000000",
        "0000000000",
        "00000000000",
        "000000000000",
        "0000000000000",
        "00000000000000",
        "000000000000000",
        "0000000000000000",
        "00000000000000000",
        "000000000000000000",
        "0000000000000000000",
        "00000000000000000000",
        "000000000000000000000",
        "0000000000000000000000",
        "00000000000000000000000",
        "000000000000000000000000",
        "0000000000000000000000000"
    ];
    var groupSizes = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
    ];
    var groupBases = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        10000000,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64000000,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        24300000,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
    ];
    BN.prototype.toString = function toString(base, padding) {
        base = base || 10;
        padding = padding | 0 || 1;
        var out;
        if (base === 16 || base === "hex") {
            out = "";
            var off = 0;
            var carry = 0;
            for(var i = 0; i < this.length; i++){
                var w = this.words[i];
                var word = ((w << off | carry) & 0xffffff).toString(16);
                carry = w >>> 24 - off & 0xffffff;
                if (carry !== 0 || i !== this.length - 1) out = zeros[6 - word.length] + word + out;
                else out = word + out;
                off += 2;
                if (off >= 26) {
                    off -= 26;
                    i--;
                }
            }
            if (carry !== 0) out = carry.toString(16) + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        if (base === (base | 0) && base >= 2 && base <= 36) {
            // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
            var groupSize = groupSizes[base];
            // var groupBase = Math.pow(base, groupSize);
            var groupBase = groupBases[base];
            out = "";
            var c = this.clone();
            c.negative = 0;
            while(!c.isZero()){
                var r = c.modn(groupBase).toString(base);
                c = c.idivn(groupBase);
                if (!c.isZero()) out = zeros[groupSize - r.length] + r + out;
                else out = r + out;
            }
            if (this.isZero()) out = "0" + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        assert(false, "Base should be between 2 and 36");
    };
    BN.prototype.toNumber = function toNumber() {
        var ret = this.words[0];
        if (this.length === 2) ret += this.words[1] * 0x4000000;
        else if (this.length === 3 && this.words[2] === 0x01) // NOTE: at this stage it is known that the top bit is set
        ret += 0x10000000000000 + this.words[1] * 0x4000000;
        else if (this.length > 2) assert(false, "Number can only safely store up to 53 bits");
        return this.negative !== 0 ? -ret : ret;
    };
    BN.prototype.toJSON = function toJSON() {
        return this.toString(16);
    };
    BN.prototype.toBuffer = function toBuffer(endian, length) {
        assert(typeof Buffer !== "undefined");
        return this.toArrayLike(Buffer, endian, length);
    };
    BN.prototype.toArray = function toArray(endian, length) {
        return this.toArrayLike(Array, endian, length);
    };
    BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
        var byteLength = this.byteLength();
        var reqLength = length || Math.max(1, byteLength);
        assert(byteLength <= reqLength, "byte array longer than desired length");
        assert(reqLength > 0, "Requested array length <= 0");
        this.strip();
        var littleEndian = endian === "le";
        var res = new ArrayType(reqLength);
        var b, i;
        var q = this.clone();
        if (!littleEndian) {
            // Assume big-endian
            for(i = 0; i < reqLength - byteLength; i++)res[i] = 0;
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[reqLength - i - 1] = b;
            }
        } else {
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[i] = b;
            }
            for(; i < reqLength; i++)res[i] = 0;
        }
        return res;
    };
    if (Math.clz32) BN.prototype._countBits = function _countBits(w) {
        return 32 - Math.clz32(w);
    };
    else BN.prototype._countBits = function _countBits(w) {
        var t = w;
        var r = 0;
        if (t >= 0x1000) {
            r += 13;
            t >>>= 13;
        }
        if (t >= 0x40) {
            r += 7;
            t >>>= 7;
        }
        if (t >= 0x8) {
            r += 4;
            t >>>= 4;
        }
        if (t >= 0x02) {
            r += 2;
            t >>>= 2;
        }
        return r + t;
    };
    BN.prototype._zeroBits = function _zeroBits(w) {
        // Short-cut
        if (w === 0) return 26;
        var t = w;
        var r = 0;
        if ((t & 0x1fff) === 0) {
            r += 13;
            t >>>= 13;
        }
        if ((t & 0x7f) === 0) {
            r += 7;
            t >>>= 7;
        }
        if ((t & 0xf) === 0) {
            r += 4;
            t >>>= 4;
        }
        if ((t & 0x3) === 0) {
            r += 2;
            t >>>= 2;
        }
        if ((t & 0x1) === 0) r++;
        return r;
    };
    // Return number of used bits in a BN
    BN.prototype.bitLength = function bitLength() {
        var w = this.words[this.length - 1];
        var hi = this._countBits(w);
        return (this.length - 1) * 26 + hi;
    };
    function toBitArray(num) {
        var w = new Array(num.bitLength());
        for(var bit = 0; bit < w.length; bit++){
            var off = bit / 26 | 0;
            var wbit = bit % 26;
            w[bit] = (num.words[off] & 1 << wbit) >>> wbit;
        }
        return w;
    }
    // Number of trailing zero bits
    BN.prototype.zeroBits = function zeroBits() {
        if (this.isZero()) return 0;
        var r = 0;
        for(var i = 0; i < this.length; i++){
            var b = this._zeroBits(this.words[i]);
            r += b;
            if (b !== 26) break;
        }
        return r;
    };
    BN.prototype.byteLength = function byteLength() {
        return Math.ceil(this.bitLength() / 8);
    };
    BN.prototype.toTwos = function toTwos(width) {
        if (this.negative !== 0) return this.abs().inotn(width).iaddn(1);
        return this.clone();
    };
    BN.prototype.fromTwos = function fromTwos(width) {
        if (this.testn(width - 1)) return this.notn(width).iaddn(1).ineg();
        return this.clone();
    };
    BN.prototype.isNeg = function isNeg() {
        return this.negative !== 0;
    };
    // Return negative clone of `this`
    BN.prototype.neg = function neg() {
        return this.clone().ineg();
    };
    BN.prototype.ineg = function ineg() {
        if (!this.isZero()) this.negative ^= 1;
        return this;
    };
    // Or `num` with `this` in-place
    BN.prototype.iuor = function iuor(num) {
        while(this.length < num.length)this.words[this.length++] = 0;
        for(var i = 0; i < num.length; i++)this.words[i] = this.words[i] | num.words[i];
        return this.strip();
    };
    BN.prototype.ior = function ior(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuor(num);
    };
    // Or `num` with `this`
    BN.prototype.or = function or(num) {
        if (this.length > num.length) return this.clone().ior(num);
        return num.clone().ior(this);
    };
    BN.prototype.uor = function uor(num) {
        if (this.length > num.length) return this.clone().iuor(num);
        return num.clone().iuor(this);
    };
    // And `num` with `this` in-place
    BN.prototype.iuand = function iuand(num) {
        // b = min-length(num, this)
        var b;
        if (this.length > num.length) b = num;
        else b = this;
        for(var i = 0; i < b.length; i++)this.words[i] = this.words[i] & num.words[i];
        this.length = b.length;
        return this.strip();
    };
    BN.prototype.iand = function iand(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuand(num);
    };
    // And `num` with `this`
    BN.prototype.and = function and(num) {
        if (this.length > num.length) return this.clone().iand(num);
        return num.clone().iand(this);
    };
    BN.prototype.uand = function uand(num) {
        if (this.length > num.length) return this.clone().iuand(num);
        return num.clone().iuand(this);
    };
    // Xor `num` with `this` in-place
    BN.prototype.iuxor = function iuxor(num) {
        // a.length > b.length
        var a;
        var b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        for(var i = 0; i < b.length; i++)this.words[i] = a.words[i] ^ b.words[i];
        if (this !== a) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = a.length;
        return this.strip();
    };
    BN.prototype.ixor = function ixor(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuxor(num);
    };
    // Xor `num` with `this`
    BN.prototype.xor = function xor(num) {
        if (this.length > num.length) return this.clone().ixor(num);
        return num.clone().ixor(this);
    };
    BN.prototype.uxor = function uxor(num) {
        if (this.length > num.length) return this.clone().iuxor(num);
        return num.clone().iuxor(this);
    };
    // Not ``this`` with ``width`` bitwidth
    BN.prototype.inotn = function inotn(width) {
        assert(typeof width === "number" && width >= 0);
        var bytesNeeded = Math.ceil(width / 26) | 0;
        var bitsLeft = width % 26;
        // Extend the buffer with leading zeroes
        this._expand(bytesNeeded);
        if (bitsLeft > 0) bytesNeeded--;
        // Handle complete words
        for(var i = 0; i < bytesNeeded; i++)this.words[i] = ~this.words[i] & 0x3ffffff;
        // Handle the residue
        if (bitsLeft > 0) this.words[i] = ~this.words[i] & 0x3ffffff >> 26 - bitsLeft;
        // And remove leading zeroes
        return this.strip();
    };
    BN.prototype.notn = function notn(width) {
        return this.clone().inotn(width);
    };
    // Set `bit` of `this`
    BN.prototype.setn = function setn(bit, val) {
        assert(typeof bit === "number" && bit >= 0);
        var off = bit / 26 | 0;
        var wbit = bit % 26;
        this._expand(off + 1);
        if (val) this.words[off] = this.words[off] | 1 << wbit;
        else this.words[off] = this.words[off] & ~(1 << wbit);
        return this.strip();
    };
    // Add `num` to `this` in-place
    BN.prototype.iadd = function iadd(num) {
        var r;
        // negative + positive
        if (this.negative !== 0 && num.negative === 0) {
            this.negative = 0;
            r = this.isub(num);
            this.negative ^= 1;
            return this._normSign();
        // positive + negative
        } else if (this.negative === 0 && num.negative !== 0) {
            num.negative = 0;
            r = this.isub(num);
            num.negative = 1;
            return r._normSign();
        }
        // a.length > b.length
        var a, b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        this.length = a.length;
        if (carry !== 0) {
            this.words[this.length] = carry;
            this.length++;
        // Copy the rest of the words
        } else if (a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        return this;
    };
    // Add `num` to `this`
    BN.prototype.add = function add(num) {
        var res;
        if (num.negative !== 0 && this.negative === 0) {
            num.negative = 0;
            res = this.sub(num);
            num.negative ^= 1;
            return res;
        } else if (num.negative === 0 && this.negative !== 0) {
            this.negative = 0;
            res = num.sub(this);
            this.negative = 1;
            return res;
        }
        if (this.length > num.length) return this.clone().iadd(num);
        return num.clone().iadd(this);
    };
    // Subtract `num` from `this` in-place
    BN.prototype.isub = function isub(num) {
        // this - (-num) = this + num
        if (num.negative !== 0) {
            num.negative = 0;
            var r = this.iadd(num);
            num.negative = 1;
            return r._normSign();
        // -this - num = -(this + num)
        } else if (this.negative !== 0) {
            this.negative = 0;
            this.iadd(num);
            this.negative = 1;
            return this._normSign();
        }
        // At this point both numbers are positive
        var cmp = this.cmp(num);
        // Optimization - zeroify
        if (cmp === 0) {
            this.negative = 0;
            this.length = 1;
            this.words[0] = 0;
            return this;
        }
        // a > b
        var a, b;
        if (cmp > 0) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        // Copy rest of the words
        if (carry === 0 && i < a.length && a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = Math.max(this.length, i);
        if (a !== this) this.negative = 1;
        return this.strip();
    };
    // Subtract `num` from `this`
    BN.prototype.sub = function sub(num) {
        return this.clone().isub(num);
    };
    function smallMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        var len = self.length + num.length | 0;
        out.length = len;
        len = len - 1 | 0;
        // Peel one iteration (compiler can't do it, because of code complexity)
        var a = self.words[0] | 0;
        var b = num.words[0] | 0;
        var r = a * b;
        var lo = r & 0x3ffffff;
        var carry = r / 0x4000000 | 0;
        out.words[0] = lo;
        for(var k = 1; k < len; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = carry >>> 26;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j | 0;
                a = self.words[i] | 0;
                b = num.words[j] | 0;
                r = a * b + rword;
                ncarry += r / 0x4000000 | 0;
                rword = r & 0x3ffffff;
            }
            out.words[k] = rword | 0;
            carry = ncarry | 0;
        }
        if (carry !== 0) out.words[k] = carry | 0;
        else out.length--;
        return out.strip();
    }
    // TODO(indutny): it may be reasonable to omit it for users who don't need
    // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
    // multiplication (like elliptic secp256k1).
    var comb10MulTo = function comb10MulTo(self, num, out) {
        var a = self.words;
        var b = num.words;
        var o = out.words;
        var c = 0;
        var lo;
        var mid;
        var hi;
        var a0 = a[0] | 0;
        var al0 = a0 & 0x1fff;
        var ah0 = a0 >>> 13;
        var a1 = a[1] | 0;
        var al1 = a1 & 0x1fff;
        var ah1 = a1 >>> 13;
        var a2 = a[2] | 0;
        var al2 = a2 & 0x1fff;
        var ah2 = a2 >>> 13;
        var a3 = a[3] | 0;
        var al3 = a3 & 0x1fff;
        var ah3 = a3 >>> 13;
        var a4 = a[4] | 0;
        var al4 = a4 & 0x1fff;
        var ah4 = a4 >>> 13;
        var a5 = a[5] | 0;
        var al5 = a5 & 0x1fff;
        var ah5 = a5 >>> 13;
        var a6 = a[6] | 0;
        var al6 = a6 & 0x1fff;
        var ah6 = a6 >>> 13;
        var a7 = a[7] | 0;
        var al7 = a7 & 0x1fff;
        var ah7 = a7 >>> 13;
        var a8 = a[8] | 0;
        var al8 = a8 & 0x1fff;
        var ah8 = a8 >>> 13;
        var a9 = a[9] | 0;
        var al9 = a9 & 0x1fff;
        var ah9 = a9 >>> 13;
        var b0 = b[0] | 0;
        var bl0 = b0 & 0x1fff;
        var bh0 = b0 >>> 13;
        var b1 = b[1] | 0;
        var bl1 = b1 & 0x1fff;
        var bh1 = b1 >>> 13;
        var b2 = b[2] | 0;
        var bl2 = b2 & 0x1fff;
        var bh2 = b2 >>> 13;
        var b3 = b[3] | 0;
        var bl3 = b3 & 0x1fff;
        var bh3 = b3 >>> 13;
        var b4 = b[4] | 0;
        var bl4 = b4 & 0x1fff;
        var bh4 = b4 >>> 13;
        var b5 = b[5] | 0;
        var bl5 = b5 & 0x1fff;
        var bh5 = b5 >>> 13;
        var b6 = b[6] | 0;
        var bl6 = b6 & 0x1fff;
        var bh6 = b6 >>> 13;
        var b7 = b[7] | 0;
        var bl7 = b7 & 0x1fff;
        var bh7 = b7 >>> 13;
        var b8 = b[8] | 0;
        var bl8 = b8 & 0x1fff;
        var bh8 = b8 >>> 13;
        var b9 = b[9] | 0;
        var bl9 = b9 & 0x1fff;
        var bh9 = b9 >>> 13;
        out.negative = self.negative ^ num.negative;
        out.length = 19;
        /* k = 0 */ lo = Math.imul(al0, bl0);
        mid = Math.imul(al0, bh0);
        mid = mid + Math.imul(ah0, bl0) | 0;
        hi = Math.imul(ah0, bh0);
        var w0 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
        w0 &= 0x3ffffff;
        /* k = 1 */ lo = Math.imul(al1, bl0);
        mid = Math.imul(al1, bh0);
        mid = mid + Math.imul(ah1, bl0) | 0;
        hi = Math.imul(ah1, bh0);
        lo = lo + Math.imul(al0, bl1) | 0;
        mid = mid + Math.imul(al0, bh1) | 0;
        mid = mid + Math.imul(ah0, bl1) | 0;
        hi = hi + Math.imul(ah0, bh1) | 0;
        var w1 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
        w1 &= 0x3ffffff;
        /* k = 2 */ lo = Math.imul(al2, bl0);
        mid = Math.imul(al2, bh0);
        mid = mid + Math.imul(ah2, bl0) | 0;
        hi = Math.imul(ah2, bh0);
        lo = lo + Math.imul(al1, bl1) | 0;
        mid = mid + Math.imul(al1, bh1) | 0;
        mid = mid + Math.imul(ah1, bl1) | 0;
        hi = hi + Math.imul(ah1, bh1) | 0;
        lo = lo + Math.imul(al0, bl2) | 0;
        mid = mid + Math.imul(al0, bh2) | 0;
        mid = mid + Math.imul(ah0, bl2) | 0;
        hi = hi + Math.imul(ah0, bh2) | 0;
        var w2 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
        w2 &= 0x3ffffff;
        /* k = 3 */ lo = Math.imul(al3, bl0);
        mid = Math.imul(al3, bh0);
        mid = mid + Math.imul(ah3, bl0) | 0;
        hi = Math.imul(ah3, bh0);
        lo = lo + Math.imul(al2, bl1) | 0;
        mid = mid + Math.imul(al2, bh1) | 0;
        mid = mid + Math.imul(ah2, bl1) | 0;
        hi = hi + Math.imul(ah2, bh1) | 0;
        lo = lo + Math.imul(al1, bl2) | 0;
        mid = mid + Math.imul(al1, bh2) | 0;
        mid = mid + Math.imul(ah1, bl2) | 0;
        hi = hi + Math.imul(ah1, bh2) | 0;
        lo = lo + Math.imul(al0, bl3) | 0;
        mid = mid + Math.imul(al0, bh3) | 0;
        mid = mid + Math.imul(ah0, bl3) | 0;
        hi = hi + Math.imul(ah0, bh3) | 0;
        var w3 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
        w3 &= 0x3ffffff;
        /* k = 4 */ lo = Math.imul(al4, bl0);
        mid = Math.imul(al4, bh0);
        mid = mid + Math.imul(ah4, bl0) | 0;
        hi = Math.imul(ah4, bh0);
        lo = lo + Math.imul(al3, bl1) | 0;
        mid = mid + Math.imul(al3, bh1) | 0;
        mid = mid + Math.imul(ah3, bl1) | 0;
        hi = hi + Math.imul(ah3, bh1) | 0;
        lo = lo + Math.imul(al2, bl2) | 0;
        mid = mid + Math.imul(al2, bh2) | 0;
        mid = mid + Math.imul(ah2, bl2) | 0;
        hi = hi + Math.imul(ah2, bh2) | 0;
        lo = lo + Math.imul(al1, bl3) | 0;
        mid = mid + Math.imul(al1, bh3) | 0;
        mid = mid + Math.imul(ah1, bl3) | 0;
        hi = hi + Math.imul(ah1, bh3) | 0;
        lo = lo + Math.imul(al0, bl4) | 0;
        mid = mid + Math.imul(al0, bh4) | 0;
        mid = mid + Math.imul(ah0, bl4) | 0;
        hi = hi + Math.imul(ah0, bh4) | 0;
        var w4 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
        w4 &= 0x3ffffff;
        /* k = 5 */ lo = Math.imul(al5, bl0);
        mid = Math.imul(al5, bh0);
        mid = mid + Math.imul(ah5, bl0) | 0;
        hi = Math.imul(ah5, bh0);
        lo = lo + Math.imul(al4, bl1) | 0;
        mid = mid + Math.imul(al4, bh1) | 0;
        mid = mid + Math.imul(ah4, bl1) | 0;
        hi = hi + Math.imul(ah4, bh1) | 0;
        lo = lo + Math.imul(al3, bl2) | 0;
        mid = mid + Math.imul(al3, bh2) | 0;
        mid = mid + Math.imul(ah3, bl2) | 0;
        hi = hi + Math.imul(ah3, bh2) | 0;
        lo = lo + Math.imul(al2, bl3) | 0;
        mid = mid + Math.imul(al2, bh3) | 0;
        mid = mid + Math.imul(ah2, bl3) | 0;
        hi = hi + Math.imul(ah2, bh3) | 0;
        lo = lo + Math.imul(al1, bl4) | 0;
        mid = mid + Math.imul(al1, bh4) | 0;
        mid = mid + Math.imul(ah1, bl4) | 0;
        hi = hi + Math.imul(ah1, bh4) | 0;
        lo = lo + Math.imul(al0, bl5) | 0;
        mid = mid + Math.imul(al0, bh5) | 0;
        mid = mid + Math.imul(ah0, bl5) | 0;
        hi = hi + Math.imul(ah0, bh5) | 0;
        var w5 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
        w5 &= 0x3ffffff;
        /* k = 6 */ lo = Math.imul(al6, bl0);
        mid = Math.imul(al6, bh0);
        mid = mid + Math.imul(ah6, bl0) | 0;
        hi = Math.imul(ah6, bh0);
        lo = lo + Math.imul(al5, bl1) | 0;
        mid = mid + Math.imul(al5, bh1) | 0;
        mid = mid + Math.imul(ah5, bl1) | 0;
        hi = hi + Math.imul(ah5, bh1) | 0;
        lo = lo + Math.imul(al4, bl2) | 0;
        mid = mid + Math.imul(al4, bh2) | 0;
        mid = mid + Math.imul(ah4, bl2) | 0;
        hi = hi + Math.imul(ah4, bh2) | 0;
        lo = lo + Math.imul(al3, bl3) | 0;
        mid = mid + Math.imul(al3, bh3) | 0;
        mid = mid + Math.imul(ah3, bl3) | 0;
        hi = hi + Math.imul(ah3, bh3) | 0;
        lo = lo + Math.imul(al2, bl4) | 0;
        mid = mid + Math.imul(al2, bh4) | 0;
        mid = mid + Math.imul(ah2, bl4) | 0;
        hi = hi + Math.imul(ah2, bh4) | 0;
        lo = lo + Math.imul(al1, bl5) | 0;
        mid = mid + Math.imul(al1, bh5) | 0;
        mid = mid + Math.imul(ah1, bl5) | 0;
        hi = hi + Math.imul(ah1, bh5) | 0;
        lo = lo + Math.imul(al0, bl6) | 0;
        mid = mid + Math.imul(al0, bh6) | 0;
        mid = mid + Math.imul(ah0, bl6) | 0;
        hi = hi + Math.imul(ah0, bh6) | 0;
        var w6 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
        w6 &= 0x3ffffff;
        /* k = 7 */ lo = Math.imul(al7, bl0);
        mid = Math.imul(al7, bh0);
        mid = mid + Math.imul(ah7, bl0) | 0;
        hi = Math.imul(ah7, bh0);
        lo = lo + Math.imul(al6, bl1) | 0;
        mid = mid + Math.imul(al6, bh1) | 0;
        mid = mid + Math.imul(ah6, bl1) | 0;
        hi = hi + Math.imul(ah6, bh1) | 0;
        lo = lo + Math.imul(al5, bl2) | 0;
        mid = mid + Math.imul(al5, bh2) | 0;
        mid = mid + Math.imul(ah5, bl2) | 0;
        hi = hi + Math.imul(ah5, bh2) | 0;
        lo = lo + Math.imul(al4, bl3) | 0;
        mid = mid + Math.imul(al4, bh3) | 0;
        mid = mid + Math.imul(ah4, bl3) | 0;
        hi = hi + Math.imul(ah4, bh3) | 0;
        lo = lo + Math.imul(al3, bl4) | 0;
        mid = mid + Math.imul(al3, bh4) | 0;
        mid = mid + Math.imul(ah3, bl4) | 0;
        hi = hi + Math.imul(ah3, bh4) | 0;
        lo = lo + Math.imul(al2, bl5) | 0;
        mid = mid + Math.imul(al2, bh5) | 0;
        mid = mid + Math.imul(ah2, bl5) | 0;
        hi = hi + Math.imul(ah2, bh5) | 0;
        lo = lo + Math.imul(al1, bl6) | 0;
        mid = mid + Math.imul(al1, bh6) | 0;
        mid = mid + Math.imul(ah1, bl6) | 0;
        hi = hi + Math.imul(ah1, bh6) | 0;
        lo = lo + Math.imul(al0, bl7) | 0;
        mid = mid + Math.imul(al0, bh7) | 0;
        mid = mid + Math.imul(ah0, bl7) | 0;
        hi = hi + Math.imul(ah0, bh7) | 0;
        var w7 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
        w7 &= 0x3ffffff;
        /* k = 8 */ lo = Math.imul(al8, bl0);
        mid = Math.imul(al8, bh0);
        mid = mid + Math.imul(ah8, bl0) | 0;
        hi = Math.imul(ah8, bh0);
        lo = lo + Math.imul(al7, bl1) | 0;
        mid = mid + Math.imul(al7, bh1) | 0;
        mid = mid + Math.imul(ah7, bl1) | 0;
        hi = hi + Math.imul(ah7, bh1) | 0;
        lo = lo + Math.imul(al6, bl2) | 0;
        mid = mid + Math.imul(al6, bh2) | 0;
        mid = mid + Math.imul(ah6, bl2) | 0;
        hi = hi + Math.imul(ah6, bh2) | 0;
        lo = lo + Math.imul(al5, bl3) | 0;
        mid = mid + Math.imul(al5, bh3) | 0;
        mid = mid + Math.imul(ah5, bl3) | 0;
        hi = hi + Math.imul(ah5, bh3) | 0;
        lo = lo + Math.imul(al4, bl4) | 0;
        mid = mid + Math.imul(al4, bh4) | 0;
        mid = mid + Math.imul(ah4, bl4) | 0;
        hi = hi + Math.imul(ah4, bh4) | 0;
        lo = lo + Math.imul(al3, bl5) | 0;
        mid = mid + Math.imul(al3, bh5) | 0;
        mid = mid + Math.imul(ah3, bl5) | 0;
        hi = hi + Math.imul(ah3, bh5) | 0;
        lo = lo + Math.imul(al2, bl6) | 0;
        mid = mid + Math.imul(al2, bh6) | 0;
        mid = mid + Math.imul(ah2, bl6) | 0;
        hi = hi + Math.imul(ah2, bh6) | 0;
        lo = lo + Math.imul(al1, bl7) | 0;
        mid = mid + Math.imul(al1, bh7) | 0;
        mid = mid + Math.imul(ah1, bl7) | 0;
        hi = hi + Math.imul(ah1, bh7) | 0;
        lo = lo + Math.imul(al0, bl8) | 0;
        mid = mid + Math.imul(al0, bh8) | 0;
        mid = mid + Math.imul(ah0, bl8) | 0;
        hi = hi + Math.imul(ah0, bh8) | 0;
        var w8 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
        w8 &= 0x3ffffff;
        /* k = 9 */ lo = Math.imul(al9, bl0);
        mid = Math.imul(al9, bh0);
        mid = mid + Math.imul(ah9, bl0) | 0;
        hi = Math.imul(ah9, bh0);
        lo = lo + Math.imul(al8, bl1) | 0;
        mid = mid + Math.imul(al8, bh1) | 0;
        mid = mid + Math.imul(ah8, bl1) | 0;
        hi = hi + Math.imul(ah8, bh1) | 0;
        lo = lo + Math.imul(al7, bl2) | 0;
        mid = mid + Math.imul(al7, bh2) | 0;
        mid = mid + Math.imul(ah7, bl2) | 0;
        hi = hi + Math.imul(ah7, bh2) | 0;
        lo = lo + Math.imul(al6, bl3) | 0;
        mid = mid + Math.imul(al6, bh3) | 0;
        mid = mid + Math.imul(ah6, bl3) | 0;
        hi = hi + Math.imul(ah6, bh3) | 0;
        lo = lo + Math.imul(al5, bl4) | 0;
        mid = mid + Math.imul(al5, bh4) | 0;
        mid = mid + Math.imul(ah5, bl4) | 0;
        hi = hi + Math.imul(ah5, bh4) | 0;
        lo = lo + Math.imul(al4, bl5) | 0;
        mid = mid + Math.imul(al4, bh5) | 0;
        mid = mid + Math.imul(ah4, bl5) | 0;
        hi = hi + Math.imul(ah4, bh5) | 0;
        lo = lo + Math.imul(al3, bl6) | 0;
        mid = mid + Math.imul(al3, bh6) | 0;
        mid = mid + Math.imul(ah3, bl6) | 0;
        hi = hi + Math.imul(ah3, bh6) | 0;
        lo = lo + Math.imul(al2, bl7) | 0;
        mid = mid + Math.imul(al2, bh7) | 0;
        mid = mid + Math.imul(ah2, bl7) | 0;
        hi = hi + Math.imul(ah2, bh7) | 0;
        lo = lo + Math.imul(al1, bl8) | 0;
        mid = mid + Math.imul(al1, bh8) | 0;
        mid = mid + Math.imul(ah1, bl8) | 0;
        hi = hi + Math.imul(ah1, bh8) | 0;
        lo = lo + Math.imul(al0, bl9) | 0;
        mid = mid + Math.imul(al0, bh9) | 0;
        mid = mid + Math.imul(ah0, bl9) | 0;
        hi = hi + Math.imul(ah0, bh9) | 0;
        var w9 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
        w9 &= 0x3ffffff;
        /* k = 10 */ lo = Math.imul(al9, bl1);
        mid = Math.imul(al9, bh1);
        mid = mid + Math.imul(ah9, bl1) | 0;
        hi = Math.imul(ah9, bh1);
        lo = lo + Math.imul(al8, bl2) | 0;
        mid = mid + Math.imul(al8, bh2) | 0;
        mid = mid + Math.imul(ah8, bl2) | 0;
        hi = hi + Math.imul(ah8, bh2) | 0;
        lo = lo + Math.imul(al7, bl3) | 0;
        mid = mid + Math.imul(al7, bh3) | 0;
        mid = mid + Math.imul(ah7, bl3) | 0;
        hi = hi + Math.imul(ah7, bh3) | 0;
        lo = lo + Math.imul(al6, bl4) | 0;
        mid = mid + Math.imul(al6, bh4) | 0;
        mid = mid + Math.imul(ah6, bl4) | 0;
        hi = hi + Math.imul(ah6, bh4) | 0;
        lo = lo + Math.imul(al5, bl5) | 0;
        mid = mid + Math.imul(al5, bh5) | 0;
        mid = mid + Math.imul(ah5, bl5) | 0;
        hi = hi + Math.imul(ah5, bh5) | 0;
        lo = lo + Math.imul(al4, bl6) | 0;
        mid = mid + Math.imul(al4, bh6) | 0;
        mid = mid + Math.imul(ah4, bl6) | 0;
        hi = hi + Math.imul(ah4, bh6) | 0;
        lo = lo + Math.imul(al3, bl7) | 0;
        mid = mid + Math.imul(al3, bh7) | 0;
        mid = mid + Math.imul(ah3, bl7) | 0;
        hi = hi + Math.imul(ah3, bh7) | 0;
        lo = lo + Math.imul(al2, bl8) | 0;
        mid = mid + Math.imul(al2, bh8) | 0;
        mid = mid + Math.imul(ah2, bl8) | 0;
        hi = hi + Math.imul(ah2, bh8) | 0;
        lo = lo + Math.imul(al1, bl9) | 0;
        mid = mid + Math.imul(al1, bh9) | 0;
        mid = mid + Math.imul(ah1, bl9) | 0;
        hi = hi + Math.imul(ah1, bh9) | 0;
        var w10 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
        w10 &= 0x3ffffff;
        /* k = 11 */ lo = Math.imul(al9, bl2);
        mid = Math.imul(al9, bh2);
        mid = mid + Math.imul(ah9, bl2) | 0;
        hi = Math.imul(ah9, bh2);
        lo = lo + Math.imul(al8, bl3) | 0;
        mid = mid + Math.imul(al8, bh3) | 0;
        mid = mid + Math.imul(ah8, bl3) | 0;
        hi = hi + Math.imul(ah8, bh3) | 0;
        lo = lo + Math.imul(al7, bl4) | 0;
        mid = mid + Math.imul(al7, bh4) | 0;
        mid = mid + Math.imul(ah7, bl4) | 0;
        hi = hi + Math.imul(ah7, bh4) | 0;
        lo = lo + Math.imul(al6, bl5) | 0;
        mid = mid + Math.imul(al6, bh5) | 0;
        mid = mid + Math.imul(ah6, bl5) | 0;
        hi = hi + Math.imul(ah6, bh5) | 0;
        lo = lo + Math.imul(al5, bl6) | 0;
        mid = mid + Math.imul(al5, bh6) | 0;
        mid = mid + Math.imul(ah5, bl6) | 0;
        hi = hi + Math.imul(ah5, bh6) | 0;
        lo = lo + Math.imul(al4, bl7) | 0;
        mid = mid + Math.imul(al4, bh7) | 0;
        mid = mid + Math.imul(ah4, bl7) | 0;
        hi = hi + Math.imul(ah4, bh7) | 0;
        lo = lo + Math.imul(al3, bl8) | 0;
        mid = mid + Math.imul(al3, bh8) | 0;
        mid = mid + Math.imul(ah3, bl8) | 0;
        hi = hi + Math.imul(ah3, bh8) | 0;
        lo = lo + Math.imul(al2, bl9) | 0;
        mid = mid + Math.imul(al2, bh9) | 0;
        mid = mid + Math.imul(ah2, bl9) | 0;
        hi = hi + Math.imul(ah2, bh9) | 0;
        var w11 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
        w11 &= 0x3ffffff;
        /* k = 12 */ lo = Math.imul(al9, bl3);
        mid = Math.imul(al9, bh3);
        mid = mid + Math.imul(ah9, bl3) | 0;
        hi = Math.imul(ah9, bh3);
        lo = lo + Math.imul(al8, bl4) | 0;
        mid = mid + Math.imul(al8, bh4) | 0;
        mid = mid + Math.imul(ah8, bl4) | 0;
        hi = hi + Math.imul(ah8, bh4) | 0;
        lo = lo + Math.imul(al7, bl5) | 0;
        mid = mid + Math.imul(al7, bh5) | 0;
        mid = mid + Math.imul(ah7, bl5) | 0;
        hi = hi + Math.imul(ah7, bh5) | 0;
        lo = lo + Math.imul(al6, bl6) | 0;
        mid = mid + Math.imul(al6, bh6) | 0;
        mid = mid + Math.imul(ah6, bl6) | 0;
        hi = hi + Math.imul(ah6, bh6) | 0;
        lo = lo + Math.imul(al5, bl7) | 0;
        mid = mid + Math.imul(al5, bh7) | 0;
        mid = mid + Math.imul(ah5, bl7) | 0;
        hi = hi + Math.imul(ah5, bh7) | 0;
        lo = lo + Math.imul(al4, bl8) | 0;
        mid = mid + Math.imul(al4, bh8) | 0;
        mid = mid + Math.imul(ah4, bl8) | 0;
        hi = hi + Math.imul(ah4, bh8) | 0;
        lo = lo + Math.imul(al3, bl9) | 0;
        mid = mid + Math.imul(al3, bh9) | 0;
        mid = mid + Math.imul(ah3, bl9) | 0;
        hi = hi + Math.imul(ah3, bh9) | 0;
        var w12 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
        w12 &= 0x3ffffff;
        /* k = 13 */ lo = Math.imul(al9, bl4);
        mid = Math.imul(al9, bh4);
        mid = mid + Math.imul(ah9, bl4) | 0;
        hi = Math.imul(ah9, bh4);
        lo = lo + Math.imul(al8, bl5) | 0;
        mid = mid + Math.imul(al8, bh5) | 0;
        mid = mid + Math.imul(ah8, bl5) | 0;
        hi = hi + Math.imul(ah8, bh5) | 0;
        lo = lo + Math.imul(al7, bl6) | 0;
        mid = mid + Math.imul(al7, bh6) | 0;
        mid = mid + Math.imul(ah7, bl6) | 0;
        hi = hi + Math.imul(ah7, bh6) | 0;
        lo = lo + Math.imul(al6, bl7) | 0;
        mid = mid + Math.imul(al6, bh7) | 0;
        mid = mid + Math.imul(ah6, bl7) | 0;
        hi = hi + Math.imul(ah6, bh7) | 0;
        lo = lo + Math.imul(al5, bl8) | 0;
        mid = mid + Math.imul(al5, bh8) | 0;
        mid = mid + Math.imul(ah5, bl8) | 0;
        hi = hi + Math.imul(ah5, bh8) | 0;
        lo = lo + Math.imul(al4, bl9) | 0;
        mid = mid + Math.imul(al4, bh9) | 0;
        mid = mid + Math.imul(ah4, bl9) | 0;
        hi = hi + Math.imul(ah4, bh9) | 0;
        var w13 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
        w13 &= 0x3ffffff;
        /* k = 14 */ lo = Math.imul(al9, bl5);
        mid = Math.imul(al9, bh5);
        mid = mid + Math.imul(ah9, bl5) | 0;
        hi = Math.imul(ah9, bh5);
        lo = lo + Math.imul(al8, bl6) | 0;
        mid = mid + Math.imul(al8, bh6) | 0;
        mid = mid + Math.imul(ah8, bl6) | 0;
        hi = hi + Math.imul(ah8, bh6) | 0;
        lo = lo + Math.imul(al7, bl7) | 0;
        mid = mid + Math.imul(al7, bh7) | 0;
        mid = mid + Math.imul(ah7, bl7) | 0;
        hi = hi + Math.imul(ah7, bh7) | 0;
        lo = lo + Math.imul(al6, bl8) | 0;
        mid = mid + Math.imul(al6, bh8) | 0;
        mid = mid + Math.imul(ah6, bl8) | 0;
        hi = hi + Math.imul(ah6, bh8) | 0;
        lo = lo + Math.imul(al5, bl9) | 0;
        mid = mid + Math.imul(al5, bh9) | 0;
        mid = mid + Math.imul(ah5, bl9) | 0;
        hi = hi + Math.imul(ah5, bh9) | 0;
        var w14 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
        w14 &= 0x3ffffff;
        /* k = 15 */ lo = Math.imul(al9, bl6);
        mid = Math.imul(al9, bh6);
        mid = mid + Math.imul(ah9, bl6) | 0;
        hi = Math.imul(ah9, bh6);
        lo = lo + Math.imul(al8, bl7) | 0;
        mid = mid + Math.imul(al8, bh7) | 0;
        mid = mid + Math.imul(ah8, bl7) | 0;
        hi = hi + Math.imul(ah8, bh7) | 0;
        lo = lo + Math.imul(al7, bl8) | 0;
        mid = mid + Math.imul(al7, bh8) | 0;
        mid = mid + Math.imul(ah7, bl8) | 0;
        hi = hi + Math.imul(ah7, bh8) | 0;
        lo = lo + Math.imul(al6, bl9) | 0;
        mid = mid + Math.imul(al6, bh9) | 0;
        mid = mid + Math.imul(ah6, bl9) | 0;
        hi = hi + Math.imul(ah6, bh9) | 0;
        var w15 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
        w15 &= 0x3ffffff;
        /* k = 16 */ lo = Math.imul(al9, bl7);
        mid = Math.imul(al9, bh7);
        mid = mid + Math.imul(ah9, bl7) | 0;
        hi = Math.imul(ah9, bh7);
        lo = lo + Math.imul(al8, bl8) | 0;
        mid = mid + Math.imul(al8, bh8) | 0;
        mid = mid + Math.imul(ah8, bl8) | 0;
        hi = hi + Math.imul(ah8, bh8) | 0;
        lo = lo + Math.imul(al7, bl9) | 0;
        mid = mid + Math.imul(al7, bh9) | 0;
        mid = mid + Math.imul(ah7, bl9) | 0;
        hi = hi + Math.imul(ah7, bh9) | 0;
        var w16 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
        w16 &= 0x3ffffff;
        /* k = 17 */ lo = Math.imul(al9, bl8);
        mid = Math.imul(al9, bh8);
        mid = mid + Math.imul(ah9, bl8) | 0;
        hi = Math.imul(ah9, bh8);
        lo = lo + Math.imul(al8, bl9) | 0;
        mid = mid + Math.imul(al8, bh9) | 0;
        mid = mid + Math.imul(ah8, bl9) | 0;
        hi = hi + Math.imul(ah8, bh9) | 0;
        var w17 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
        w17 &= 0x3ffffff;
        /* k = 18 */ lo = Math.imul(al9, bl9);
        mid = Math.imul(al9, bh9);
        mid = mid + Math.imul(ah9, bl9) | 0;
        hi = Math.imul(ah9, bh9);
        var w18 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
        w18 &= 0x3ffffff;
        o[0] = w0;
        o[1] = w1;
        o[2] = w2;
        o[3] = w3;
        o[4] = w4;
        o[5] = w5;
        o[6] = w6;
        o[7] = w7;
        o[8] = w8;
        o[9] = w9;
        o[10] = w10;
        o[11] = w11;
        o[12] = w12;
        o[13] = w13;
        o[14] = w14;
        o[15] = w15;
        o[16] = w16;
        o[17] = w17;
        o[18] = w18;
        if (c !== 0) {
            o[19] = c;
            out.length++;
        }
        return out;
    };
    // Polyfill comb
    if (!Math.imul) comb10MulTo = smallMulTo;
    function bigMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        out.length = self.length + num.length;
        var carry = 0;
        var hncarry = 0;
        for(var k = 0; k < out.length - 1; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = hncarry;
            hncarry = 0;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j;
                var a = self.words[i] | 0;
                var b = num.words[j] | 0;
                var r = a * b;
                var lo = r & 0x3ffffff;
                ncarry = ncarry + (r / 0x4000000 | 0) | 0;
                lo = lo + rword | 0;
                rword = lo & 0x3ffffff;
                ncarry = ncarry + (lo >>> 26) | 0;
                hncarry += ncarry >>> 26;
                ncarry &= 0x3ffffff;
            }
            out.words[k] = rword;
            carry = ncarry;
            ncarry = hncarry;
        }
        if (carry !== 0) out.words[k] = carry;
        else out.length--;
        return out.strip();
    }
    function jumboMulTo(self, num, out) {
        var fftm = new FFTM();
        return fftm.mulp(self, num, out);
    }
    BN.prototype.mulTo = function mulTo(num, out) {
        var res;
        var len = this.length + num.length;
        if (this.length === 10 && num.length === 10) res = comb10MulTo(this, num, out);
        else if (len < 63) res = smallMulTo(this, num, out);
        else if (len < 1024) res = bigMulTo(this, num, out);
        else res = jumboMulTo(this, num, out);
        return res;
    };
    // Cooley-Tukey algorithm for FFT
    // slightly revisited to rely on looping instead of recursion
    function FFTM(x, y) {
        this.x = x;
        this.y = y;
    }
    FFTM.prototype.makeRBT = function makeRBT(N) {
        var t = new Array(N);
        var l = BN.prototype._countBits(N) - 1;
        for(var i = 0; i < N; i++)t[i] = this.revBin(i, l, N);
        return t;
    };
    // Returns binary-reversed representation of `x`
    FFTM.prototype.revBin = function revBin(x, l, N) {
        if (x === 0 || x === N - 1) return x;
        var rb = 0;
        for(var i = 0; i < l; i++){
            rb |= (x & 1) << l - i - 1;
            x >>= 1;
        }
        return rb;
    };
    // Performs "tweedling" phase, therefore 'emulating'
    // behaviour of the recursive algorithm
    FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
        for(var i = 0; i < N; i++){
            rtws[i] = rws[rbt[i]];
            itws[i] = iws[rbt[i]];
        }
    };
    FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
        this.permute(rbt, rws, iws, rtws, itws, N);
        for(var s = 1; s < N; s <<= 1){
            var l = s << 1;
            var rtwdf = Math.cos(2 * Math.PI / l);
            var itwdf = Math.sin(2 * Math.PI / l);
            for(var p = 0; p < N; p += l){
                var rtwdf_ = rtwdf;
                var itwdf_ = itwdf;
                for(var j = 0; j < s; j++){
                    var re = rtws[p + j];
                    var ie = itws[p + j];
                    var ro = rtws[p + j + s];
                    var io = itws[p + j + s];
                    var rx = rtwdf_ * ro - itwdf_ * io;
                    io = rtwdf_ * io + itwdf_ * ro;
                    ro = rx;
                    rtws[p + j] = re + ro;
                    itws[p + j] = ie + io;
                    rtws[p + j + s] = re - ro;
                    itws[p + j + s] = ie - io;
                    /* jshint maxdepth : false */ if (j !== l) {
                        rx = rtwdf * rtwdf_ - itwdf * itwdf_;
                        itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                        rtwdf_ = rx;
                    }
                }
            }
        }
    };
    FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
        var N = Math.max(m, n) | 1;
        var odd = N & 1;
        var i = 0;
        for(N = N / 2 | 0; N; N = N >>> 1)i++;
        return 1 << i + 1 + odd;
    };
    FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
        if (N <= 1) return;
        for(var i = 0; i < N / 2; i++){
            var t = rws[i];
            rws[i] = rws[N - i - 1];
            rws[N - i - 1] = t;
            t = iws[i];
            iws[i] = -iws[N - i - 1];
            iws[N - i - 1] = -t;
        }
    };
    FFTM.prototype.normalize13b = function normalize13b(ws, N) {
        var carry = 0;
        for(var i = 0; i < N / 2; i++){
            var w = Math.round(ws[2 * i + 1] / N) * 0x2000 + Math.round(ws[2 * i] / N) + carry;
            ws[i] = w & 0x3ffffff;
            if (w < 0x4000000) carry = 0;
            else carry = w / 0x4000000 | 0;
        }
        return ws;
    };
    FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
        var carry = 0;
        for(var i = 0; i < len; i++){
            carry = carry + (ws[i] | 0);
            rws[2 * i] = carry & 0x1fff;
            carry = carry >>> 13;
            rws[2 * i + 1] = carry & 0x1fff;
            carry = carry >>> 13;
        }
        // Pad with zeroes
        for(i = 2 * len; i < N; ++i)rws[i] = 0;
        assert(carry === 0);
        assert((carry & -8192) === 0);
    };
    FFTM.prototype.stub = function stub(N) {
        var ph = new Array(N);
        for(var i = 0; i < N; i++)ph[i] = 0;
        return ph;
    };
    FFTM.prototype.mulp = function mulp(x, y, out) {
        var N = 2 * this.guessLen13b(x.length, y.length);
        var rbt = this.makeRBT(N);
        var _ = this.stub(N);
        var rws = new Array(N);
        var rwst = new Array(N);
        var iwst = new Array(N);
        var nrws = new Array(N);
        var nrwst = new Array(N);
        var niwst = new Array(N);
        var rmws = out.words;
        rmws.length = N;
        this.convert13b(x.words, x.length, rws, N);
        this.convert13b(y.words, y.length, nrws, N);
        this.transform(rws, _, rwst, iwst, N, rbt);
        this.transform(nrws, _, nrwst, niwst, N, rbt);
        for(var i = 0; i < N; i++){
            var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
            iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
            rwst[i] = rx;
        }
        this.conjugate(rwst, iwst, N);
        this.transform(rwst, iwst, rmws, _, N, rbt);
        this.conjugate(rmws, _, N);
        this.normalize13b(rmws, N);
        out.negative = x.negative ^ y.negative;
        out.length = x.length + y.length;
        return out.strip();
    };
    // Multiply `this` by `num`
    BN.prototype.mul = function mul(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return this.mulTo(num, out);
    };
    // Multiply employing FFT
    BN.prototype.mulf = function mulf(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return jumboMulTo(this, num, out);
    };
    // In-place Multiplication
    BN.prototype.imul = function imul(num) {
        return this.clone().mulTo(num, this);
    };
    BN.prototype.imuln = function imuln(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        // Carry
        var carry = 0;
        for(var i = 0; i < this.length; i++){
            var w = (this.words[i] | 0) * num;
            var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
            carry >>= 26;
            carry += w / 0x4000000 | 0;
            // NOTE: lo is 27bit maximum
            carry += lo >>> 26;
            this.words[i] = lo & 0x3ffffff;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.muln = function muln(num) {
        return this.clone().imuln(num);
    };
    // `this` * `this`
    BN.prototype.sqr = function sqr() {
        return this.mul(this);
    };
    // `this` * `this` in-place
    BN.prototype.isqr = function isqr() {
        return this.imul(this.clone());
    };
    // Math.pow(`this`, `num`)
    BN.prototype.pow = function pow(num) {
        var w = toBitArray(num);
        if (w.length === 0) return new BN(1);
        // Skip leading zeroes
        var res = this;
        for(var i = 0; i < w.length; i++, res = res.sqr()){
            if (w[i] !== 0) break;
        }
        if (++i < w.length) for(var q = res.sqr(); i < w.length; i++, q = q.sqr()){
            if (w[i] === 0) continue;
            res = res.mul(q);
        }
        return res;
    };
    // Shift-left in-place
    BN.prototype.iushln = function iushln(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        var carryMask = 0x3ffffff >>> 26 - r << 26 - r;
        var i;
        if (r !== 0) {
            var carry = 0;
            for(i = 0; i < this.length; i++){
                var newCarry = this.words[i] & carryMask;
                var c = (this.words[i] | 0) - newCarry << r;
                this.words[i] = c | carry;
                carry = newCarry >>> 26 - r;
            }
            if (carry) {
                this.words[i] = carry;
                this.length++;
            }
        }
        if (s !== 0) {
            for(i = this.length - 1; i >= 0; i--)this.words[i + s] = this.words[i];
            for(i = 0; i < s; i++)this.words[i] = 0;
            this.length += s;
        }
        return this.strip();
    };
    BN.prototype.ishln = function ishln(bits) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushln(bits);
    };
    // Shift-right in-place
    // NOTE: `hint` is a lowest bit before trailing zeroes
    // NOTE: if `extended` is present - it will be filled with destroyed bits
    BN.prototype.iushrn = function iushrn(bits, hint, extended) {
        assert(typeof bits === "number" && bits >= 0);
        var h;
        if (hint) h = (hint - hint % 26) / 26;
        else h = 0;
        var r = bits % 26;
        var s = Math.min((bits - r) / 26, this.length);
        var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
        var maskedWords = extended;
        h -= s;
        h = Math.max(0, h);
        // Extended mode, copy masked part
        if (maskedWords) {
            for(var i = 0; i < s; i++)maskedWords.words[i] = this.words[i];
            maskedWords.length = s;
        }
        if (s === 0) ;
        else if (this.length > s) {
            this.length -= s;
            for(i = 0; i < this.length; i++)this.words[i] = this.words[i + s];
        } else {
            this.words[0] = 0;
            this.length = 1;
        }
        var carry = 0;
        for(i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--){
            var word = this.words[i] | 0;
            this.words[i] = carry << 26 - r | word >>> r;
            carry = word & mask;
        }
        // Push carried bits as a mask
        if (maskedWords && carry !== 0) maskedWords.words[maskedWords.length++] = carry;
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this.strip();
    };
    BN.prototype.ishrn = function ishrn(bits, hint, extended) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushrn(bits, hint, extended);
    };
    // Shift-left
    BN.prototype.shln = function shln(bits) {
        return this.clone().ishln(bits);
    };
    BN.prototype.ushln = function ushln(bits) {
        return this.clone().iushln(bits);
    };
    // Shift-right
    BN.prototype.shrn = function shrn(bits) {
        return this.clone().ishrn(bits);
    };
    BN.prototype.ushrn = function ushrn(bits) {
        return this.clone().iushrn(bits);
    };
    // Test if n bit is set
    BN.prototype.testn = function testn(bit) {
        assert(typeof bit === "number" && bit >= 0);
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) return false;
        // Check bit and return
        var w = this.words[s];
        return !!(w & q);
    };
    // Return only lowers bits of number (in-place)
    BN.prototype.imaskn = function imaskn(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        assert(this.negative === 0, "imaskn works only with positive numbers");
        if (this.length <= s) return this;
        if (r !== 0) s++;
        this.length = Math.min(s, this.length);
        if (r !== 0) {
            var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
            this.words[this.length - 1] &= mask;
        }
        return this.strip();
    };
    // Return only lowers bits of number
    BN.prototype.maskn = function maskn(bits) {
        return this.clone().imaskn(bits);
    };
    // Add plain number `num` to `this`
    BN.prototype.iaddn = function iaddn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.isubn(-num);
        // Possible sign change
        if (this.negative !== 0) {
            if (this.length === 1 && (this.words[0] | 0) < num) {
                this.words[0] = num - (this.words[0] | 0);
                this.negative = 0;
                return this;
            }
            this.negative = 0;
            this.isubn(num);
            this.negative = 1;
            return this;
        }
        // Add without checks
        return this._iaddn(num);
    };
    BN.prototype._iaddn = function _iaddn(num) {
        this.words[0] += num;
        // Carry
        for(var i = 0; i < this.length && this.words[i] >= 0x4000000; i++){
            this.words[i] -= 0x4000000;
            if (i === this.length - 1) this.words[i + 1] = 1;
            else this.words[i + 1]++;
        }
        this.length = Math.max(this.length, i + 1);
        return this;
    };
    // Subtract plain number `num` from `this`
    BN.prototype.isubn = function isubn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.iaddn(-num);
        if (this.negative !== 0) {
            this.negative = 0;
            this.iaddn(num);
            this.negative = 1;
            return this;
        }
        this.words[0] -= num;
        if (this.length === 1 && this.words[0] < 0) {
            this.words[0] = -this.words[0];
            this.negative = 1;
        } else // Carry
        for(var i = 0; i < this.length && this.words[i] < 0; i++){
            this.words[i] += 0x4000000;
            this.words[i + 1] -= 1;
        }
        return this.strip();
    };
    BN.prototype.addn = function addn(num) {
        return this.clone().iaddn(num);
    };
    BN.prototype.subn = function subn(num) {
        return this.clone().isubn(num);
    };
    BN.prototype.iabs = function iabs() {
        this.negative = 0;
        return this;
    };
    BN.prototype.abs = function abs() {
        return this.clone().iabs();
    };
    BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
        var len = num.length + shift;
        var i;
        this._expand(len);
        var w;
        var carry = 0;
        for(i = 0; i < num.length; i++){
            w = (this.words[i + shift] | 0) + carry;
            var right = (num.words[i] | 0) * mul;
            w -= right & 0x3ffffff;
            carry = (w >> 26) - (right / 0x4000000 | 0);
            this.words[i + shift] = w & 0x3ffffff;
        }
        for(; i < this.length - shift; i++){
            w = (this.words[i + shift] | 0) + carry;
            carry = w >> 26;
            this.words[i + shift] = w & 0x3ffffff;
        }
        if (carry === 0) return this.strip();
        // Subtraction overflow
        assert(carry === -1);
        carry = 0;
        for(i = 0; i < this.length; i++){
            w = -(this.words[i] | 0) + carry;
            carry = w >> 26;
            this.words[i] = w & 0x3ffffff;
        }
        this.negative = 1;
        return this.strip();
    };
    BN.prototype._wordDiv = function _wordDiv(num, mode) {
        var shift = this.length - num.length;
        var a = this.clone();
        var b = num;
        // Normalize
        var bhi = b.words[b.length - 1] | 0;
        var bhiBits = this._countBits(bhi);
        shift = 26 - bhiBits;
        if (shift !== 0) {
            b = b.ushln(shift);
            a.iushln(shift);
            bhi = b.words[b.length - 1] | 0;
        }
        // Initialize quotient
        var m = a.length - b.length;
        var q;
        if (mode !== "mod") {
            q = new BN(null);
            q.length = m + 1;
            q.words = new Array(q.length);
            for(var i = 0; i < q.length; i++)q.words[i] = 0;
        }
        var diff = a.clone()._ishlnsubmul(b, 1, m);
        if (diff.negative === 0) {
            a = diff;
            if (q) q.words[m] = 1;
        }
        for(var j = m - 1; j >= 0; j--){
            var qj = (a.words[b.length + j] | 0) * 0x4000000 + (a.words[b.length + j - 1] | 0);
            // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
            // (0x7ffffff)
            qj = Math.min(qj / bhi | 0, 0x3ffffff);
            a._ishlnsubmul(b, qj, j);
            while(a.negative !== 0){
                qj--;
                a.negative = 0;
                a._ishlnsubmul(b, 1, j);
                if (!a.isZero()) a.negative ^= 1;
            }
            if (q) q.words[j] = qj;
        }
        if (q) q.strip();
        a.strip();
        // Denormalize
        if (mode !== "div" && shift !== 0) a.iushrn(shift);
        return {
            div: q || null,
            mod: a
        };
    };
    // NOTE: 1) `mode` can be set to `mod` to request mod only,
    //       to `div` to request div only, or be absent to
    //       request both div & mod
    //       2) `positive` is true if unsigned mod is requested
    BN.prototype.divmod = function divmod(num, mode, positive) {
        assert(!num.isZero());
        if (this.isZero()) return {
            div: new BN(0),
            mod: new BN(0)
        };
        var div, mod, res;
        if (this.negative !== 0 && num.negative === 0) {
            res = this.neg().divmod(num, mode);
            if (mode !== "mod") div = res.div.neg();
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.iadd(num);
            }
            return {
                div: div,
                mod: mod
            };
        }
        if (this.negative === 0 && num.negative !== 0) {
            res = this.divmod(num.neg(), mode);
            if (mode !== "mod") div = res.div.neg();
            return {
                div: div,
                mod: res.mod
            };
        }
        if ((this.negative & num.negative) !== 0) {
            res = this.neg().divmod(num.neg(), mode);
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.isub(num);
            }
            return {
                div: res.div,
                mod: mod
            };
        }
        // Both numbers are positive at this point
        // Strip both numbers to approximate shift value
        if (num.length > this.length || this.cmp(num) < 0) return {
            div: new BN(0),
            mod: this
        };
        // Very short reduction
        if (num.length === 1) {
            if (mode === "div") return {
                div: this.divn(num.words[0]),
                mod: null
            };
            if (mode === "mod") return {
                div: null,
                mod: new BN(this.modn(num.words[0]))
            };
            return {
                div: this.divn(num.words[0]),
                mod: new BN(this.modn(num.words[0]))
            };
        }
        return this._wordDiv(num, mode);
    };
    // Find `this` / `num`
    BN.prototype.div = function div(num) {
        return this.divmod(num, "div", false).div;
    };
    // Find `this` % `num`
    BN.prototype.mod = function mod(num) {
        return this.divmod(num, "mod", false).mod;
    };
    BN.prototype.umod = function umod(num) {
        return this.divmod(num, "mod", true).mod;
    };
    // Find Round(`this` / `num`)
    BN.prototype.divRound = function divRound(num) {
        var dm = this.divmod(num);
        // Fast case - exact division
        if (dm.mod.isZero()) return dm.div;
        var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;
        var half = num.ushrn(1);
        var r2 = num.andln(1);
        var cmp = mod.cmp(half);
        // Round down
        if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
        // Round up
        return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
    };
    BN.prototype.modn = function modn(num) {
        assert(num <= 0x3ffffff);
        var p = 67108864 % num;
        var acc = 0;
        for(var i = this.length - 1; i >= 0; i--)acc = (p * acc + (this.words[i] | 0)) % num;
        return acc;
    };
    // In-place division by number
    BN.prototype.idivn = function idivn(num) {
        assert(num <= 0x3ffffff);
        var carry = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var w = (this.words[i] | 0) + carry * 0x4000000;
            this.words[i] = w / num | 0;
            carry = w % num;
        }
        return this.strip();
    };
    BN.prototype.divn = function divn(num) {
        return this.clone().idivn(num);
    };
    BN.prototype.egcd = function egcd(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var x = this;
        var y = p.clone();
        if (x.negative !== 0) x = x.umod(p);
        else x = x.clone();
        // A * x + B * y = x
        var A = new BN(1);
        var B = new BN(0);
        // C * x + D * y = y
        var C = new BN(0);
        var D = new BN(1);
        var g = 0;
        while(x.isEven() && y.isEven()){
            x.iushrn(1);
            y.iushrn(1);
            ++g;
        }
        var yp = y.clone();
        var xp = x.clone();
        while(!x.isZero()){
            for(var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                x.iushrn(i);
                while(i-- > 0){
                    if (A.isOdd() || B.isOdd()) {
                        A.iadd(yp);
                        B.isub(xp);
                    }
                    A.iushrn(1);
                    B.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                y.iushrn(j);
                while(j-- > 0){
                    if (C.isOdd() || D.isOdd()) {
                        C.iadd(yp);
                        D.isub(xp);
                    }
                    C.iushrn(1);
                    D.iushrn(1);
                }
            }
            if (x.cmp(y) >= 0) {
                x.isub(y);
                A.isub(C);
                B.isub(D);
            } else {
                y.isub(x);
                C.isub(A);
                D.isub(B);
            }
        }
        return {
            a: C,
            b: D,
            gcd: y.iushln(g)
        };
    };
    // This is reduced incarnation of the binary EEA
    // above, designated to invert members of the
    // _prime_ fields F(p) at a maximal speed
    BN.prototype._invmp = function _invmp(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var a = this;
        var b = p.clone();
        if (a.negative !== 0) a = a.umod(p);
        else a = a.clone();
        var x1 = new BN(1);
        var x2 = new BN(0);
        var delta = b.clone();
        while(a.cmpn(1) > 0 && b.cmpn(1) > 0){
            for(var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                a.iushrn(i);
                while(i-- > 0){
                    if (x1.isOdd()) x1.iadd(delta);
                    x1.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                b.iushrn(j);
                while(j-- > 0){
                    if (x2.isOdd()) x2.iadd(delta);
                    x2.iushrn(1);
                }
            }
            if (a.cmp(b) >= 0) {
                a.isub(b);
                x1.isub(x2);
            } else {
                b.isub(a);
                x2.isub(x1);
            }
        }
        var res;
        if (a.cmpn(1) === 0) res = x1;
        else res = x2;
        if (res.cmpn(0) < 0) res.iadd(p);
        return res;
    };
    BN.prototype.gcd = function gcd(num) {
        if (this.isZero()) return num.abs();
        if (num.isZero()) return this.abs();
        var a = this.clone();
        var b = num.clone();
        a.negative = 0;
        b.negative = 0;
        // Remove common factor of two
        for(var shift = 0; a.isEven() && b.isEven(); shift++){
            a.iushrn(1);
            b.iushrn(1);
        }
        do {
            while(a.isEven())a.iushrn(1);
            while(b.isEven())b.iushrn(1);
            var r = a.cmp(b);
            if (r < 0) {
                // Swap `a` and `b` to make `a` always bigger than `b`
                var t = a;
                a = b;
                b = t;
            } else if (r === 0 || b.cmpn(1) === 0) break;
            a.isub(b);
        }while (true);
        return b.iushln(shift);
    };
    // Invert number in the field F(num)
    BN.prototype.invm = function invm(num) {
        return this.egcd(num).a.umod(num);
    };
    BN.prototype.isEven = function isEven() {
        return (this.words[0] & 1) === 0;
    };
    BN.prototype.isOdd = function isOdd() {
        return (this.words[0] & 1) === 1;
    };
    // And first word and num
    BN.prototype.andln = function andln(num) {
        return this.words[0] & num;
    };
    // Increment at the bit position in-line
    BN.prototype.bincn = function bincn(bit) {
        assert(typeof bit === "number");
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) {
            this._expand(s + 1);
            this.words[s] |= q;
            return this;
        }
        // Add bit and propagate, if needed
        var carry = q;
        for(var i = s; carry !== 0 && i < this.length; i++){
            var w = this.words[i] | 0;
            w += carry;
            carry = w >>> 26;
            w &= 0x3ffffff;
            this.words[i] = w;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.isZero = function isZero() {
        return this.length === 1 && this.words[0] === 0;
    };
    BN.prototype.cmpn = function cmpn(num) {
        var negative = num < 0;
        if (this.negative !== 0 && !negative) return -1;
        if (this.negative === 0 && negative) return 1;
        this.strip();
        var res;
        if (this.length > 1) res = 1;
        else {
            if (negative) num = -num;
            assert(num <= 0x3ffffff, "Number is too big");
            var w = this.words[0] | 0;
            res = w === num ? 0 : w < num ? -1 : 1;
        }
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Compare two numbers and return:
    // 1 - if `this` > `num`
    // 0 - if `this` == `num`
    // -1 - if `this` < `num`
    BN.prototype.cmp = function cmp(num) {
        if (this.negative !== 0 && num.negative === 0) return -1;
        if (this.negative === 0 && num.negative !== 0) return 1;
        var res = this.ucmp(num);
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Unsigned comparison
    BN.prototype.ucmp = function ucmp(num) {
        // At this point both numbers have the same sign
        if (this.length > num.length) return 1;
        if (this.length < num.length) return -1;
        var res = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var a = this.words[i] | 0;
            var b = num.words[i] | 0;
            if (a === b) continue;
            if (a < b) res = -1;
            else if (a > b) res = 1;
            break;
        }
        return res;
    };
    BN.prototype.gtn = function gtn(num) {
        return this.cmpn(num) === 1;
    };
    BN.prototype.gt = function gt(num) {
        return this.cmp(num) === 1;
    };
    BN.prototype.gten = function gten(num) {
        return this.cmpn(num) >= 0;
    };
    BN.prototype.gte = function gte(num) {
        return this.cmp(num) >= 0;
    };
    BN.prototype.ltn = function ltn(num) {
        return this.cmpn(num) === -1;
    };
    BN.prototype.lt = function lt(num) {
        return this.cmp(num) === -1;
    };
    BN.prototype.lten = function lten(num) {
        return this.cmpn(num) <= 0;
    };
    BN.prototype.lte = function lte(num) {
        return this.cmp(num) <= 0;
    };
    BN.prototype.eqn = function eqn(num) {
        return this.cmpn(num) === 0;
    };
    BN.prototype.eq = function eq(num) {
        return this.cmp(num) === 0;
    };
    //
    // A reduce context, could be using montgomery or something better, depending
    // on the `m` itself.
    //
    BN.red = function red(num) {
        return new Red(num);
    };
    BN.prototype.toRed = function toRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        assert(this.negative === 0, "red works only with positives");
        return ctx.convertTo(this)._forceRed(ctx);
    };
    BN.prototype.fromRed = function fromRed() {
        assert(this.red, "fromRed works only with numbers in reduction context");
        return this.red.convertFrom(this);
    };
    BN.prototype._forceRed = function _forceRed(ctx) {
        this.red = ctx;
        return this;
    };
    BN.prototype.forceRed = function forceRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        return this._forceRed(ctx);
    };
    BN.prototype.redAdd = function redAdd(num) {
        assert(this.red, "redAdd works only with red numbers");
        return this.red.add(this, num);
    };
    BN.prototype.redIAdd = function redIAdd(num) {
        assert(this.red, "redIAdd works only with red numbers");
        return this.red.iadd(this, num);
    };
    BN.prototype.redSub = function redSub(num) {
        assert(this.red, "redSub works only with red numbers");
        return this.red.sub(this, num);
    };
    BN.prototype.redISub = function redISub(num) {
        assert(this.red, "redISub works only with red numbers");
        return this.red.isub(this, num);
    };
    BN.prototype.redShl = function redShl(num) {
        assert(this.red, "redShl works only with red numbers");
        return this.red.shl(this, num);
    };
    BN.prototype.redMul = function redMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.mul(this, num);
    };
    BN.prototype.redIMul = function redIMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.imul(this, num);
    };
    BN.prototype.redSqr = function redSqr() {
        assert(this.red, "redSqr works only with red numbers");
        this.red._verify1(this);
        return this.red.sqr(this);
    };
    BN.prototype.redISqr = function redISqr() {
        assert(this.red, "redISqr works only with red numbers");
        this.red._verify1(this);
        return this.red.isqr(this);
    };
    // Square root over p
    BN.prototype.redSqrt = function redSqrt() {
        assert(this.red, "redSqrt works only with red numbers");
        this.red._verify1(this);
        return this.red.sqrt(this);
    };
    BN.prototype.redInvm = function redInvm() {
        assert(this.red, "redInvm works only with red numbers");
        this.red._verify1(this);
        return this.red.invm(this);
    };
    // Return negative clone of `this` % `red modulo`
    BN.prototype.redNeg = function redNeg() {
        assert(this.red, "redNeg works only with red numbers");
        this.red._verify1(this);
        return this.red.neg(this);
    };
    BN.prototype.redPow = function redPow(num) {
        assert(this.red && !num.red, "redPow(normalNum)");
        this.red._verify1(this);
        return this.red.pow(this, num);
    };
    // Prime numbers with efficient reduction
    var primes = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
    };
    // Pseudo-Mersenne prime
    function MPrime(name, p) {
        // P = 2 ^ N - K
        this.name = name;
        this.p = new BN(p, 16);
        this.n = this.p.bitLength();
        this.k = new BN(1).iushln(this.n).isub(this.p);
        this.tmp = this._tmp();
    }
    MPrime.prototype._tmp = function _tmp() {
        var tmp = new BN(null);
        tmp.words = new Array(Math.ceil(this.n / 13));
        return tmp;
    };
    MPrime.prototype.ireduce = function ireduce(num) {
        // Assumes that `num` is less than `P^2`
        // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
        var r = num;
        var rlen;
        do {
            this.split(r, this.tmp);
            r = this.imulK(r);
            r = r.iadd(this.tmp);
            rlen = r.bitLength();
        }while (rlen > this.n);
        var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
        if (cmp === 0) {
            r.words[0] = 0;
            r.length = 1;
        } else if (cmp > 0) r.isub(this.p);
        else if (r.strip !== undefined) // r is BN v4 instance
        r.strip();
        else // r is BN v5 instance
        r._strip();
        return r;
    };
    MPrime.prototype.split = function split(input, out) {
        input.iushrn(this.n, 0, out);
    };
    MPrime.prototype.imulK = function imulK(num) {
        return num.imul(this.k);
    };
    function K256() {
        MPrime.call(this, "k256", "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f");
    }
    inherits(K256, MPrime);
    K256.prototype.split = function split(input, output) {
        // 256 = 9 * 26 + 22
        var mask = 0x3fffff;
        var outLen = Math.min(input.length, 9);
        for(var i = 0; i < outLen; i++)output.words[i] = input.words[i];
        output.length = outLen;
        if (input.length <= 9) {
            input.words[0] = 0;
            input.length = 1;
            return;
        }
        // Shift by 9 limbs
        var prev = input.words[9];
        output.words[output.length++] = prev & mask;
        for(i = 10; i < input.length; i++){
            var next = input.words[i] | 0;
            input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
            prev = next;
        }
        prev >>>= 22;
        input.words[i - 10] = prev;
        if (prev === 0 && input.length > 10) input.length -= 10;
        else input.length -= 9;
    };
    K256.prototype.imulK = function imulK(num) {
        // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
        num.words[num.length] = 0;
        num.words[num.length + 1] = 0;
        num.length += 2;
        // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
        var lo = 0;
        for(var i = 0; i < num.length; i++){
            var w = num.words[i] | 0;
            lo += w * 0x3d1;
            num.words[i] = lo & 0x3ffffff;
            lo = w * 0x40 + (lo / 0x4000000 | 0);
        }
        // Fast length reduction
        if (num.words[num.length - 1] === 0) {
            num.length--;
            if (num.words[num.length - 1] === 0) num.length--;
        }
        return num;
    };
    function P224() {
        MPrime.call(this, "p224", "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001");
    }
    inherits(P224, MPrime);
    function P192() {
        MPrime.call(this, "p192", "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff");
    }
    inherits(P192, MPrime);
    function P25519() {
        // 2 ^ 255 - 19
        MPrime.call(this, "25519", "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed");
    }
    inherits(P25519, MPrime);
    P25519.prototype.imulK = function imulK(num) {
        // K = 0x13
        var carry = 0;
        for(var i = 0; i < num.length; i++){
            var hi = (num.words[i] | 0) * 0x13 + carry;
            var lo = hi & 0x3ffffff;
            hi >>>= 26;
            num.words[i] = lo;
            carry = hi;
        }
        if (carry !== 0) num.words[num.length++] = carry;
        return num;
    };
    // Exported mostly for testing purposes, use plain name instead
    BN._prime = function prime(name) {
        // Cached version of prime
        if (primes[name]) return primes[name];
        var prime;
        if (name === "k256") prime = new K256();
        else if (name === "p224") prime = new P224();
        else if (name === "p192") prime = new P192();
        else if (name === "p25519") prime = new P25519();
        else throw new Error("Unknown prime " + name);
        primes[name] = prime;
        return prime;
    };
    //
    // Base reduction engine
    //
    function Red(m) {
        if (typeof m === "string") {
            var prime = BN._prime(m);
            this.m = prime.p;
            this.prime = prime;
        } else {
            assert(m.gtn(1), "modulus must be greater than 1");
            this.m = m;
            this.prime = null;
        }
    }
    Red.prototype._verify1 = function _verify1(a) {
        assert(a.negative === 0, "red works only with positives");
        assert(a.red, "red works only with red numbers");
    };
    Red.prototype._verify2 = function _verify2(a, b) {
        assert((a.negative | b.negative) === 0, "red works only with positives");
        assert(a.red && a.red === b.red, "red works only with red numbers");
    };
    Red.prototype.imod = function imod(a) {
        if (this.prime) return this.prime.ireduce(a)._forceRed(this);
        return a.umod(this.m)._forceRed(this);
    };
    Red.prototype.neg = function neg(a) {
        if (a.isZero()) return a.clone();
        return this.m.sub(a)._forceRed(this);
    };
    Red.prototype.add = function add(a, b) {
        this._verify2(a, b);
        var res = a.add(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res._forceRed(this);
    };
    Red.prototype.iadd = function iadd(a, b) {
        this._verify2(a, b);
        var res = a.iadd(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res;
    };
    Red.prototype.sub = function sub(a, b) {
        this._verify2(a, b);
        var res = a.sub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res._forceRed(this);
    };
    Red.prototype.isub = function isub(a, b) {
        this._verify2(a, b);
        var res = a.isub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res;
    };
    Red.prototype.shl = function shl(a, num) {
        this._verify1(a);
        return this.imod(a.ushln(num));
    };
    Red.prototype.imul = function imul(a, b) {
        this._verify2(a, b);
        return this.imod(a.imul(b));
    };
    Red.prototype.mul = function mul(a, b) {
        this._verify2(a, b);
        return this.imod(a.mul(b));
    };
    Red.prototype.isqr = function isqr(a) {
        return this.imul(a, a.clone());
    };
    Red.prototype.sqr = function sqr(a) {
        return this.mul(a, a);
    };
    Red.prototype.sqrt = function sqrt(a) {
        if (a.isZero()) return a.clone();
        var mod3 = this.m.andln(3);
        assert(mod3 % 2 === 1);
        // Fast case
        if (mod3 === 3) {
            var pow = this.m.add(new BN(1)).iushrn(2);
            return this.pow(a, pow);
        }
        // Tonelli-Shanks algorithm (Totally unoptimized and slow)
        //
        // Find Q and S, that Q * 2 ^ S = (P - 1)
        var q = this.m.subn(1);
        var s = 0;
        while(!q.isZero() && q.andln(1) === 0){
            s++;
            q.iushrn(1);
        }
        assert(!q.isZero());
        var one = new BN(1).toRed(this);
        var nOne = one.redNeg();
        // Find quadratic non-residue
        // NOTE: Max is such because of generalized Riemann hypothesis.
        var lpow = this.m.subn(1).iushrn(1);
        var z = this.m.bitLength();
        z = new BN(2 * z * z).toRed(this);
        while(this.pow(z, lpow).cmp(nOne) !== 0)z.redIAdd(nOne);
        var c = this.pow(z, q);
        var r = this.pow(a, q.addn(1).iushrn(1));
        var t = this.pow(a, q);
        var m = s;
        while(t.cmp(one) !== 0){
            var tmp = t;
            for(var i = 0; tmp.cmp(one) !== 0; i++)tmp = tmp.redSqr();
            assert(i < m);
            var b = this.pow(c, new BN(1).iushln(m - i - 1));
            r = r.redMul(b);
            c = b.redSqr();
            t = t.redMul(c);
            m = i;
        }
        return r;
    };
    Red.prototype.invm = function invm(a) {
        var inv = a._invmp(this.m);
        if (inv.negative !== 0) {
            inv.negative = 0;
            return this.imod(inv).redNeg();
        } else return this.imod(inv);
    };
    Red.prototype.pow = function pow(a, num) {
        if (num.isZero()) return new BN(1).toRed(this);
        if (num.cmpn(1) === 0) return a.clone();
        var windowSize = 4;
        var wnd = new Array(1 << windowSize);
        wnd[0] = new BN(1).toRed(this);
        wnd[1] = a;
        for(var i = 2; i < wnd.length; i++)wnd[i] = this.mul(wnd[i - 1], a);
        var res = wnd[0];
        var current = 0;
        var currentLen = 0;
        var start = num.bitLength() % 26;
        if (start === 0) start = 26;
        for(i = num.length - 1; i >= 0; i--){
            var word = num.words[i];
            for(var j = start - 1; j >= 0; j--){
                var bit = word >> j & 1;
                if (res !== wnd[0]) res = this.sqr(res);
                if (bit === 0 && current === 0) {
                    currentLen = 0;
                    continue;
                }
                current <<= 1;
                current |= bit;
                currentLen++;
                if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
                res = this.mul(res, wnd[current]);
                currentLen = 0;
                current = 0;
            }
            start = 26;
        }
        return res;
    };
    Red.prototype.convertTo = function convertTo(num) {
        var r = num.umod(this.m);
        return r === num ? r.clone() : r;
    };
    Red.prototype.convertFrom = function convertFrom(num) {
        var res = num.clone();
        res.red = null;
        return res;
    };
    //
    // Montgomery method engine
    //
    BN.mont = function mont(num) {
        return new Mont(num);
    };
    function Mont(m) {
        Red.call(this, m);
        this.shift = this.m.bitLength();
        if (this.shift % 26 !== 0) this.shift += 26 - this.shift % 26;
        this.r = new BN(1).iushln(this.shift);
        this.r2 = this.imod(this.r.sqr());
        this.rinv = this.r._invmp(this.m);
        this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
        this.minv = this.minv.umod(this.r);
        this.minv = this.r.sub(this.minv);
    }
    inherits(Mont, Red);
    Mont.prototype.convertTo = function convertTo(num) {
        return this.imod(num.ushln(this.shift));
    };
    Mont.prototype.convertFrom = function convertFrom(num) {
        var r = this.imod(num.mul(this.rinv));
        r.red = null;
        return r;
    };
    Mont.prototype.imul = function imul(a, b) {
        if (a.isZero() || b.isZero()) {
            a.words[0] = 0;
            a.length = 1;
            return a;
        }
        var t = a.imul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.mul = function mul(a, b) {
        if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
        var t = a.mul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.invm = function invm(a) {
        // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
        var res = this.imod(a._invmp(this.m).mul(this.r2));
        return res._forceRed(this);
    };
})(module, this);

},{"1cf9b8cfa268aab5":"13Pcp"}],"1KIes":[function(require,module,exports) {
"use strict";
var utils = exports;
function toArray(msg, enc) {
    if (Array.isArray(msg)) return msg.slice();
    if (!msg) return [];
    var res = [];
    if (typeof msg !== "string") {
        for(var i = 0; i < msg.length; i++)res[i] = msg[i] | 0;
        return res;
    }
    if (enc === "hex") {
        msg = msg.replace(/[^a-z0-9]+/ig, "");
        if (msg.length % 2 !== 0) msg = "0" + msg;
        for(var i = 0; i < msg.length; i += 2)res.push(parseInt(msg[i] + msg[i + 1], 16));
    } else for(var i = 0; i < msg.length; i++){
        var c = msg.charCodeAt(i);
        var hi = c >> 8;
        var lo = c & 0xff;
        if (hi) res.push(hi, lo);
        else res.push(lo);
    }
    return res;
}
utils.toArray = toArray;
function zero2(word) {
    if (word.length === 1) return "0" + word;
    else return word;
}
utils.zero2 = zero2;
function toHex(msg) {
    var res = "";
    for(var i = 0; i < msg.length; i++)res += zero2(msg[i].toString(16));
    return res;
}
utils.toHex = toHex;
utils.encode = function encode(arr, enc) {
    if (enc === "hex") return toHex(arr);
    else return arr;
};

},{}],"dzcfb":[function(require,module,exports) {
var r;
module.exports = function rand(len) {
    if (!r) r = new Rand(null);
    return r.generate(len);
};
function Rand(rand) {
    this.rand = rand;
}
module.exports.Rand = Rand;
Rand.prototype.generate = function generate(len) {
    return this._rand(len);
};
// Emulate crypto API using randy
Rand.prototype._rand = function _rand(n) {
    if (this.rand.getBytes) return this.rand.getBytes(n);
    var res = new Uint8Array(n);
    for(var i = 0; i < res.length; i++)res[i] = this.rand.getByte();
    return res;
};
if (typeof self === "object") {
    if (self.crypto && self.crypto.getRandomValues) // Modern browsers
    Rand.prototype._rand = function _rand(n) {
        var arr = new Uint8Array(n);
        self.crypto.getRandomValues(arr);
        return arr;
    };
    else if (self.msCrypto && self.msCrypto.getRandomValues) // IE
    Rand.prototype._rand = function _rand(n) {
        var arr = new Uint8Array(n);
        self.msCrypto.getRandomValues(arr);
        return arr;
    };
    else if (typeof window === "object") // Old junk
    Rand.prototype._rand = function() {
        throw new Error("Not implemented yet");
    };
} else // Node.js or Web worker with no crypto support
try {
    var crypto = require("e8ad0674730919a8");
    if (typeof crypto.randomBytes !== "function") throw new Error("Not supported");
    Rand.prototype._rand = function _rand(n) {
        return crypto.randomBytes(n);
    };
} catch (e) {}

},{"e8ad0674730919a8":"13Pcp"}],"3ZY1v":[function(require,module,exports) {
"use strict";
var curve = exports;
curve.base = require("59d486bd2037506a");
curve.short = require("eb37617ef6927580");
curve.mont = require("be9c662572da2183");
curve.edwards = require("60763dd06fe64e8d");

},{"59d486bd2037506a":"49Ytv","eb37617ef6927580":"kMHPS","be9c662572da2183":"24Z2p","60763dd06fe64e8d":"4i3b7"}],"49Ytv":[function(require,module,exports) {
"use strict";
var BN = require("70865a568c61cc60");
var utils = require("fb5111a3810a8235");
var getNAF = utils.getNAF;
var getJSF = utils.getJSF;
var assert = utils.assert;
function BaseCurve(type, conf) {
    this.type = type;
    this.p = new BN(conf.p, 16);
    // Use Montgomery, when there is no fast reduction for the prime
    this.red = conf.prime ? BN.red(conf.prime) : BN.mont(this.p);
    // Useful for many curves
    this.zero = new BN(0).toRed(this.red);
    this.one = new BN(1).toRed(this.red);
    this.two = new BN(2).toRed(this.red);
    // Curve configuration, optional
    this.n = conf.n && new BN(conf.n, 16);
    this.g = conf.g && this.pointFromJSON(conf.g, conf.gRed);
    // Temporary arrays
    this._wnafT1 = new Array(4);
    this._wnafT2 = new Array(4);
    this._wnafT3 = new Array(4);
    this._wnafT4 = new Array(4);
    this._bitLength = this.n ? this.n.bitLength() : 0;
    // Generalized Greg Maxwell's trick
    var adjustCount = this.n && this.p.div(this.n);
    if (!adjustCount || adjustCount.cmpn(100) > 0) this.redN = null;
    else {
        this._maxwellTrick = true;
        this.redN = this.n.toRed(this.red);
    }
}
module.exports = BaseCurve;
BaseCurve.prototype.point = function point() {
    throw new Error("Not implemented");
};
BaseCurve.prototype.validate = function validate() {
    throw new Error("Not implemented");
};
BaseCurve.prototype._fixedNafMul = function _fixedNafMul(p, k) {
    assert(p.precomputed);
    var doubles = p._getDoubles();
    var naf = getNAF(k, 1, this._bitLength);
    var I = (1 << doubles.step + 1) - (doubles.step % 2 === 0 ? 2 : 1);
    I /= 3;
    // Translate into more windowed form
    var repr = [];
    var j;
    var nafW;
    for(j = 0; j < naf.length; j += doubles.step){
        nafW = 0;
        for(var l = j + doubles.step - 1; l >= j; l--)nafW = (nafW << 1) + naf[l];
        repr.push(nafW);
    }
    var a = this.jpoint(null, null, null);
    var b = this.jpoint(null, null, null);
    for(var i = I; i > 0; i--){
        for(j = 0; j < repr.length; j++){
            nafW = repr[j];
            if (nafW === i) b = b.mixedAdd(doubles.points[j]);
            else if (nafW === -i) b = b.mixedAdd(doubles.points[j].neg());
        }
        a = a.add(b);
    }
    return a.toP();
};
BaseCurve.prototype._wnafMul = function _wnafMul(p, k) {
    var w = 4;
    // Precompute window
    var nafPoints = p._getNAFPoints(w);
    w = nafPoints.wnd;
    var wnd = nafPoints.points;
    // Get NAF form
    var naf = getNAF(k, w, this._bitLength);
    // Add `this`*(N+1) for every w-NAF index
    var acc = this.jpoint(null, null, null);
    for(var i = naf.length - 1; i >= 0; i--){
        // Count zeroes
        for(var l = 0; i >= 0 && naf[i] === 0; i--)l++;
        if (i >= 0) l++;
        acc = acc.dblp(l);
        if (i < 0) break;
        var z = naf[i];
        assert(z !== 0);
        if (p.type === "affine") {
            // J +- P
            if (z > 0) acc = acc.mixedAdd(wnd[z - 1 >> 1]);
            else acc = acc.mixedAdd(wnd[-z - 1 >> 1].neg());
        } else // J +- J
        if (z > 0) acc = acc.add(wnd[z - 1 >> 1]);
        else acc = acc.add(wnd[-z - 1 >> 1].neg());
    }
    return p.type === "affine" ? acc.toP() : acc;
};
BaseCurve.prototype._wnafMulAdd = function _wnafMulAdd(defW, points, coeffs, len, jacobianResult) {
    var wndWidth = this._wnafT1;
    var wnd = this._wnafT2;
    var naf = this._wnafT3;
    // Fill all arrays
    var max = 0;
    var i;
    var j;
    var p;
    for(i = 0; i < len; i++){
        p = points[i];
        var nafPoints = p._getNAFPoints(defW);
        wndWidth[i] = nafPoints.wnd;
        wnd[i] = nafPoints.points;
    }
    // Comb small window NAFs
    for(i = len - 1; i >= 1; i -= 2){
        var a = i - 1;
        var b = i;
        if (wndWidth[a] !== 1 || wndWidth[b] !== 1) {
            naf[a] = getNAF(coeffs[a], wndWidth[a], this._bitLength);
            naf[b] = getNAF(coeffs[b], wndWidth[b], this._bitLength);
            max = Math.max(naf[a].length, max);
            max = Math.max(naf[b].length, max);
            continue;
        }
        var comb = [
            points[a],
            /* 1 */ null,
            /* 3 */ null,
            /* 5 */ points[b]
        ];
        // Try to avoid Projective points, if possible
        if (points[a].y.cmp(points[b].y) === 0) {
            comb[1] = points[a].add(points[b]);
            comb[2] = points[a].toJ().mixedAdd(points[b].neg());
        } else if (points[a].y.cmp(points[b].y.redNeg()) === 0) {
            comb[1] = points[a].toJ().mixedAdd(points[b]);
            comb[2] = points[a].add(points[b].neg());
        } else {
            comb[1] = points[a].toJ().mixedAdd(points[b]);
            comb[2] = points[a].toJ().mixedAdd(points[b].neg());
        }
        var index = [
            -3,
            /* -1 -1 */ -1,
            /* -1 0 */ -5,
            /* -1 1 */ -7,
            /* 0 -1 */ 0,
            /* 0 0 */ 7,
            /* 0 1 */ 5,
            /* 1 -1 */ 1,
            /* 1 0 */ 3
        ];
        var jsf = getJSF(coeffs[a], coeffs[b]);
        max = Math.max(jsf[0].length, max);
        naf[a] = new Array(max);
        naf[b] = new Array(max);
        for(j = 0; j < max; j++){
            var ja = jsf[0][j] | 0;
            var jb = jsf[1][j] | 0;
            naf[a][j] = index[(ja + 1) * 3 + (jb + 1)];
            naf[b][j] = 0;
            wnd[a] = comb;
        }
    }
    var acc = this.jpoint(null, null, null);
    var tmp = this._wnafT4;
    for(i = max; i >= 0; i--){
        var k = 0;
        while(i >= 0){
            var zero = true;
            for(j = 0; j < len; j++){
                tmp[j] = naf[j][i] | 0;
                if (tmp[j] !== 0) zero = false;
            }
            if (!zero) break;
            k++;
            i--;
        }
        if (i >= 0) k++;
        acc = acc.dblp(k);
        if (i < 0) break;
        for(j = 0; j < len; j++){
            var z = tmp[j];
            p;
            if (z === 0) continue;
            else if (z > 0) p = wnd[j][z - 1 >> 1];
            else if (z < 0) p = wnd[j][-z - 1 >> 1].neg();
            if (p.type === "affine") acc = acc.mixedAdd(p);
            else acc = acc.add(p);
        }
    }
    // Zeroify references
    for(i = 0; i < len; i++)wnd[i] = null;
    if (jacobianResult) return acc;
    else return acc.toP();
};
function BasePoint(curve, type) {
    this.curve = curve;
    this.type = type;
    this.precomputed = null;
}
BaseCurve.BasePoint = BasePoint;
BasePoint.prototype.eq = function eq() {
    throw new Error("Not implemented");
};
BasePoint.prototype.validate = function validate() {
    return this.curve.validate(this);
};
BaseCurve.prototype.decodePoint = function decodePoint(bytes, enc) {
    bytes = utils.toArray(bytes, enc);
    var len = this.p.byteLength();
    // uncompressed, hybrid-odd, hybrid-even
    if ((bytes[0] === 0x04 || bytes[0] === 0x06 || bytes[0] === 0x07) && bytes.length - 1 === 2 * len) {
        if (bytes[0] === 0x06) assert(bytes[bytes.length - 1] % 2 === 0);
        else if (bytes[0] === 0x07) assert(bytes[bytes.length - 1] % 2 === 1);
        var res = this.point(bytes.slice(1, 1 + len), bytes.slice(1 + len, 1 + 2 * len));
        return res;
    } else if ((bytes[0] === 0x02 || bytes[0] === 0x03) && bytes.length - 1 === len) return this.pointFromX(bytes.slice(1, 1 + len), bytes[0] === 0x03);
    throw new Error("Unknown point format");
};
BasePoint.prototype.encodeCompressed = function encodeCompressed(enc) {
    return this.encode(enc, true);
};
BasePoint.prototype._encode = function _encode(compact) {
    var len = this.curve.p.byteLength();
    var x = this.getX().toArray("be", len);
    if (compact) return [
        this.getY().isEven() ? 0x02 : 0x03
    ].concat(x);
    return [
        0x04
    ].concat(x, this.getY().toArray("be", len));
};
BasePoint.prototype.encode = function encode(enc, compact) {
    return utils.encode(this._encode(compact), enc);
};
BasePoint.prototype.precompute = function precompute(power) {
    if (this.precomputed) return this;
    var precomputed = {
        doubles: null,
        naf: null,
        beta: null
    };
    precomputed.naf = this._getNAFPoints(8);
    precomputed.doubles = this._getDoubles(4, power);
    precomputed.beta = this._getBeta();
    this.precomputed = precomputed;
    return this;
};
BasePoint.prototype._hasDoubles = function _hasDoubles(k) {
    if (!this.precomputed) return false;
    var doubles = this.precomputed.doubles;
    if (!doubles) return false;
    return doubles.points.length >= Math.ceil((k.bitLength() + 1) / doubles.step);
};
BasePoint.prototype._getDoubles = function _getDoubles(step, power) {
    if (this.precomputed && this.precomputed.doubles) return this.precomputed.doubles;
    var doubles = [
        this
    ];
    var acc = this;
    for(var i = 0; i < power; i += step){
        for(var j = 0; j < step; j++)acc = acc.dbl();
        doubles.push(acc);
    }
    return {
        step: step,
        points: doubles
    };
};
BasePoint.prototype._getNAFPoints = function _getNAFPoints(wnd) {
    if (this.precomputed && this.precomputed.naf) return this.precomputed.naf;
    var res = [
        this
    ];
    var max = (1 << wnd) - 1;
    var dbl = max === 1 ? null : this.dbl();
    for(var i = 1; i < max; i++)res[i] = res[i - 1].add(dbl);
    return {
        wnd: wnd,
        points: res
    };
};
BasePoint.prototype._getBeta = function _getBeta() {
    return null;
};
BasePoint.prototype.dblp = function dblp(k) {
    var r = this;
    for(var i = 0; i < k; i++)r = r.dbl();
    return r;
};

},{"70865a568c61cc60":"kRh32","fb5111a3810a8235":"7PLUP"}],"kMHPS":[function(require,module,exports) {
"use strict";
var utils = require("89f794ef417dc31c");
var BN = require("c314b0ac30b69c4a");
var inherits = require("6ac4d7c73f24ab9c");
var Base = require("6e622edb7498c94");
var assert = utils.assert;
function ShortCurve(conf) {
    Base.call(this, "short", conf);
    this.a = new BN(conf.a, 16).toRed(this.red);
    this.b = new BN(conf.b, 16).toRed(this.red);
    this.tinv = this.two.redInvm();
    this.zeroA = this.a.fromRed().cmpn(0) === 0;
    this.threeA = this.a.fromRed().sub(this.p).cmpn(-3) === 0;
    // If the curve is endomorphic, precalculate beta and lambda
    this.endo = this._getEndomorphism(conf);
    this._endoWnafT1 = new Array(4);
    this._endoWnafT2 = new Array(4);
}
inherits(ShortCurve, Base);
module.exports = ShortCurve;
ShortCurve.prototype._getEndomorphism = function _getEndomorphism(conf) {
    // No efficient endomorphism
    if (!this.zeroA || !this.g || !this.n || this.p.modn(3) !== 1) return;
    // Compute beta and lambda, that lambda * P = (beta * Px; Py)
    var beta;
    var lambda;
    if (conf.beta) beta = new BN(conf.beta, 16).toRed(this.red);
    else {
        var betas = this._getEndoRoots(this.p);
        // Choose the smallest beta
        beta = betas[0].cmp(betas[1]) < 0 ? betas[0] : betas[1];
        beta = beta.toRed(this.red);
    }
    if (conf.lambda) lambda = new BN(conf.lambda, 16);
    else {
        // Choose the lambda that is matching selected beta
        var lambdas = this._getEndoRoots(this.n);
        if (this.g.mul(lambdas[0]).x.cmp(this.g.x.redMul(beta)) === 0) lambda = lambdas[0];
        else {
            lambda = lambdas[1];
            assert(this.g.mul(lambda).x.cmp(this.g.x.redMul(beta)) === 0);
        }
    }
    // Get basis vectors, used for balanced length-two representation
    var basis;
    if (conf.basis) basis = conf.basis.map(function(vec) {
        return {
            a: new BN(vec.a, 16),
            b: new BN(vec.b, 16)
        };
    });
    else basis = this._getEndoBasis(lambda);
    return {
        beta: beta,
        lambda: lambda,
        basis: basis
    };
};
ShortCurve.prototype._getEndoRoots = function _getEndoRoots(num) {
    // Find roots of for x^2 + x + 1 in F
    // Root = (-1 +- Sqrt(-3)) / 2
    //
    var red = num === this.p ? this.red : BN.mont(num);
    var tinv = new BN(2).toRed(red).redInvm();
    var ntinv = tinv.redNeg();
    var s = new BN(3).toRed(red).redNeg().redSqrt().redMul(tinv);
    var l1 = ntinv.redAdd(s).fromRed();
    var l2 = ntinv.redSub(s).fromRed();
    return [
        l1,
        l2
    ];
};
ShortCurve.prototype._getEndoBasis = function _getEndoBasis(lambda) {
    // aprxSqrt >= sqrt(this.n)
    var aprxSqrt = this.n.ushrn(Math.floor(this.n.bitLength() / 2));
    // 3.74
    // Run EGCD, until r(L + 1) < aprxSqrt
    var u = lambda;
    var v = this.n.clone();
    var x1 = new BN(1);
    var y1 = new BN(0);
    var x2 = new BN(0);
    var y2 = new BN(1);
    // NOTE: all vectors are roots of: a + b * lambda = 0 (mod n)
    var a0;
    var b0;
    // First vector
    var a1;
    var b1;
    // Second vector
    var a2;
    var b2;
    var prevR;
    var i = 0;
    var r;
    var x;
    while(u.cmpn(0) !== 0){
        var q = v.div(u);
        r = v.sub(q.mul(u));
        x = x2.sub(q.mul(x1));
        var y = y2.sub(q.mul(y1));
        if (!a1 && r.cmp(aprxSqrt) < 0) {
            a0 = prevR.neg();
            b0 = x1;
            a1 = r.neg();
            b1 = x;
        } else if (a1 && ++i === 2) break;
        prevR = r;
        v = u;
        u = r;
        x2 = x1;
        x1 = x;
        y2 = y1;
        y1 = y;
    }
    a2 = r.neg();
    b2 = x;
    var len1 = a1.sqr().add(b1.sqr());
    var len2 = a2.sqr().add(b2.sqr());
    if (len2.cmp(len1) >= 0) {
        a2 = a0;
        b2 = b0;
    }
    // Normalize signs
    if (a1.negative) {
        a1 = a1.neg();
        b1 = b1.neg();
    }
    if (a2.negative) {
        a2 = a2.neg();
        b2 = b2.neg();
    }
    return [
        {
            a: a1,
            b: b1
        },
        {
            a: a2,
            b: b2
        }
    ];
};
ShortCurve.prototype._endoSplit = function _endoSplit(k) {
    var basis = this.endo.basis;
    var v1 = basis[0];
    var v2 = basis[1];
    var c1 = v2.b.mul(k).divRound(this.n);
    var c2 = v1.b.neg().mul(k).divRound(this.n);
    var p1 = c1.mul(v1.a);
    var p2 = c2.mul(v2.a);
    var q1 = c1.mul(v1.b);
    var q2 = c2.mul(v2.b);
    // Calculate answer
    var k1 = k.sub(p1).sub(p2);
    var k2 = q1.add(q2).neg();
    return {
        k1: k1,
        k2: k2
    };
};
ShortCurve.prototype.pointFromX = function pointFromX(x, odd) {
    x = new BN(x, 16);
    if (!x.red) x = x.toRed(this.red);
    var y2 = x.redSqr().redMul(x).redIAdd(x.redMul(this.a)).redIAdd(this.b);
    var y = y2.redSqrt();
    if (y.redSqr().redSub(y2).cmp(this.zero) !== 0) throw new Error("invalid point");
    // XXX Is there any way to tell if the number is odd without converting it
    // to non-red form?
    var isOdd = y.fromRed().isOdd();
    if (odd && !isOdd || !odd && isOdd) y = y.redNeg();
    return this.point(x, y);
};
ShortCurve.prototype.validate = function validate(point) {
    if (point.inf) return true;
    var x = point.x;
    var y = point.y;
    var ax = this.a.redMul(x);
    var rhs = x.redSqr().redMul(x).redIAdd(ax).redIAdd(this.b);
    return y.redSqr().redISub(rhs).cmpn(0) === 0;
};
ShortCurve.prototype._endoWnafMulAdd = function _endoWnafMulAdd(points, coeffs, jacobianResult) {
    var npoints = this._endoWnafT1;
    var ncoeffs = this._endoWnafT2;
    for(var i = 0; i < points.length; i++){
        var split = this._endoSplit(coeffs[i]);
        var p = points[i];
        var beta = p._getBeta();
        if (split.k1.negative) {
            split.k1.ineg();
            p = p.neg(true);
        }
        if (split.k2.negative) {
            split.k2.ineg();
            beta = beta.neg(true);
        }
        npoints[i * 2] = p;
        npoints[i * 2 + 1] = beta;
        ncoeffs[i * 2] = split.k1;
        ncoeffs[i * 2 + 1] = split.k2;
    }
    var res = this._wnafMulAdd(1, npoints, ncoeffs, i * 2, jacobianResult);
    // Clean-up references to points and coefficients
    for(var j = 0; j < i * 2; j++){
        npoints[j] = null;
        ncoeffs[j] = null;
    }
    return res;
};
function Point(curve, x, y, isRed) {
    Base.BasePoint.call(this, curve, "affine");
    if (x === null && y === null) {
        this.x = null;
        this.y = null;
        this.inf = true;
    } else {
        this.x = new BN(x, 16);
        this.y = new BN(y, 16);
        // Force redgomery representation when loading from JSON
        if (isRed) {
            this.x.forceRed(this.curve.red);
            this.y.forceRed(this.curve.red);
        }
        if (!this.x.red) this.x = this.x.toRed(this.curve.red);
        if (!this.y.red) this.y = this.y.toRed(this.curve.red);
        this.inf = false;
    }
}
inherits(Point, Base.BasePoint);
ShortCurve.prototype.point = function point(x, y, isRed) {
    return new Point(this, x, y, isRed);
};
ShortCurve.prototype.pointFromJSON = function pointFromJSON(obj, red) {
    return Point.fromJSON(this, obj, red);
};
Point.prototype._getBeta = function _getBeta() {
    if (!this.curve.endo) return;
    var pre = this.precomputed;
    if (pre && pre.beta) return pre.beta;
    var beta = this.curve.point(this.x.redMul(this.curve.endo.beta), this.y);
    if (pre) {
        var curve = this.curve;
        var endoMul = function(p) {
            return curve.point(p.x.redMul(curve.endo.beta), p.y);
        };
        pre.beta = beta;
        beta.precomputed = {
            beta: null,
            naf: pre.naf && {
                wnd: pre.naf.wnd,
                points: pre.naf.points.map(endoMul)
            },
            doubles: pre.doubles && {
                step: pre.doubles.step,
                points: pre.doubles.points.map(endoMul)
            }
        };
    }
    return beta;
};
Point.prototype.toJSON = function toJSON() {
    if (!this.precomputed) return [
        this.x,
        this.y
    ];
    return [
        this.x,
        this.y,
        this.precomputed && {
            doubles: this.precomputed.doubles && {
                step: this.precomputed.doubles.step,
                points: this.precomputed.doubles.points.slice(1)
            },
            naf: this.precomputed.naf && {
                wnd: this.precomputed.naf.wnd,
                points: this.precomputed.naf.points.slice(1)
            }
        }
    ];
};
Point.fromJSON = function fromJSON(curve, obj, red) {
    if (typeof obj === "string") obj = JSON.parse(obj);
    var res = curve.point(obj[0], obj[1], red);
    if (!obj[2]) return res;
    function obj2point(obj) {
        return curve.point(obj[0], obj[1], red);
    }
    var pre = obj[2];
    res.precomputed = {
        beta: null,
        doubles: pre.doubles && {
            step: pre.doubles.step,
            points: [
                res
            ].concat(pre.doubles.points.map(obj2point))
        },
        naf: pre.naf && {
            wnd: pre.naf.wnd,
            points: [
                res
            ].concat(pre.naf.points.map(obj2point))
        }
    };
    return res;
};
Point.prototype.inspect = function inspect() {
    if (this.isInfinity()) return "<EC Point Infinity>";
    return "<EC Point x: " + this.x.fromRed().toString(16, 2) + " y: " + this.y.fromRed().toString(16, 2) + ">";
};
Point.prototype.isInfinity = function isInfinity() {
    return this.inf;
};
Point.prototype.add = function add(p) {
    // O + P = P
    if (this.inf) return p;
    // P + O = P
    if (p.inf) return this;
    // P + P = 2P
    if (this.eq(p)) return this.dbl();
    // P + (-P) = O
    if (this.neg().eq(p)) return this.curve.point(null, null);
    // P + Q = O
    if (this.x.cmp(p.x) === 0) return this.curve.point(null, null);
    var c = this.y.redSub(p.y);
    if (c.cmpn(0) !== 0) c = c.redMul(this.x.redSub(p.x).redInvm());
    var nx = c.redSqr().redISub(this.x).redISub(p.x);
    var ny = c.redMul(this.x.redSub(nx)).redISub(this.y);
    return this.curve.point(nx, ny);
};
Point.prototype.dbl = function dbl() {
    if (this.inf) return this;
    // 2P = O
    var ys1 = this.y.redAdd(this.y);
    if (ys1.cmpn(0) === 0) return this.curve.point(null, null);
    var a = this.curve.a;
    var x2 = this.x.redSqr();
    var dyinv = ys1.redInvm();
    var c = x2.redAdd(x2).redIAdd(x2).redIAdd(a).redMul(dyinv);
    var nx = c.redSqr().redISub(this.x.redAdd(this.x));
    var ny = c.redMul(this.x.redSub(nx)).redISub(this.y);
    return this.curve.point(nx, ny);
};
Point.prototype.getX = function getX() {
    return this.x.fromRed();
};
Point.prototype.getY = function getY() {
    return this.y.fromRed();
};
Point.prototype.mul = function mul(k) {
    k = new BN(k, 16);
    if (this.isInfinity()) return this;
    else if (this._hasDoubles(k)) return this.curve._fixedNafMul(this, k);
    else if (this.curve.endo) return this.curve._endoWnafMulAdd([
        this
    ], [
        k
    ]);
    else return this.curve._wnafMul(this, k);
};
Point.prototype.mulAdd = function mulAdd(k1, p2, k2) {
    var points = [
        this,
        p2
    ];
    var coeffs = [
        k1,
        k2
    ];
    if (this.curve.endo) return this.curve._endoWnafMulAdd(points, coeffs);
    else return this.curve._wnafMulAdd(1, points, coeffs, 2);
};
Point.prototype.jmulAdd = function jmulAdd(k1, p2, k2) {
    var points = [
        this,
        p2
    ];
    var coeffs = [
        k1,
        k2
    ];
    if (this.curve.endo) return this.curve._endoWnafMulAdd(points, coeffs, true);
    else return this.curve._wnafMulAdd(1, points, coeffs, 2, true);
};
Point.prototype.eq = function eq(p) {
    return this === p || this.inf === p.inf && (this.inf || this.x.cmp(p.x) === 0 && this.y.cmp(p.y) === 0);
};
Point.prototype.neg = function neg(_precompute) {
    if (this.inf) return this;
    var res = this.curve.point(this.x, this.y.redNeg());
    if (_precompute && this.precomputed) {
        var pre = this.precomputed;
        var negate = function(p) {
            return p.neg();
        };
        res.precomputed = {
            naf: pre.naf && {
                wnd: pre.naf.wnd,
                points: pre.naf.points.map(negate)
            },
            doubles: pre.doubles && {
                step: pre.doubles.step,
                points: pre.doubles.points.map(negate)
            }
        };
    }
    return res;
};
Point.prototype.toJ = function toJ() {
    if (this.inf) return this.curve.jpoint(null, null, null);
    var res = this.curve.jpoint(this.x, this.y, this.curve.one);
    return res;
};
function JPoint(curve, x, y, z) {
    Base.BasePoint.call(this, curve, "jacobian");
    if (x === null && y === null && z === null) {
        this.x = this.curve.one;
        this.y = this.curve.one;
        this.z = new BN(0);
    } else {
        this.x = new BN(x, 16);
        this.y = new BN(y, 16);
        this.z = new BN(z, 16);
    }
    if (!this.x.red) this.x = this.x.toRed(this.curve.red);
    if (!this.y.red) this.y = this.y.toRed(this.curve.red);
    if (!this.z.red) this.z = this.z.toRed(this.curve.red);
    this.zOne = this.z === this.curve.one;
}
inherits(JPoint, Base.BasePoint);
ShortCurve.prototype.jpoint = function jpoint(x, y, z) {
    return new JPoint(this, x, y, z);
};
JPoint.prototype.toP = function toP() {
    if (this.isInfinity()) return this.curve.point(null, null);
    var zinv = this.z.redInvm();
    var zinv2 = zinv.redSqr();
    var ax = this.x.redMul(zinv2);
    var ay = this.y.redMul(zinv2).redMul(zinv);
    return this.curve.point(ax, ay);
};
JPoint.prototype.neg = function neg() {
    return this.curve.jpoint(this.x, this.y.redNeg(), this.z);
};
JPoint.prototype.add = function add(p) {
    // O + P = P
    if (this.isInfinity()) return p;
    // P + O = P
    if (p.isInfinity()) return this;
    // 12M + 4S + 7A
    var pz2 = p.z.redSqr();
    var z2 = this.z.redSqr();
    var u1 = this.x.redMul(pz2);
    var u2 = p.x.redMul(z2);
    var s1 = this.y.redMul(pz2.redMul(p.z));
    var s2 = p.y.redMul(z2.redMul(this.z));
    var h = u1.redSub(u2);
    var r = s1.redSub(s2);
    if (h.cmpn(0) === 0) {
        if (r.cmpn(0) !== 0) return this.curve.jpoint(null, null, null);
        else return this.dbl();
    }
    var h2 = h.redSqr();
    var h3 = h2.redMul(h);
    var v = u1.redMul(h2);
    var nx = r.redSqr().redIAdd(h3).redISub(v).redISub(v);
    var ny = r.redMul(v.redISub(nx)).redISub(s1.redMul(h3));
    var nz = this.z.redMul(p.z).redMul(h);
    return this.curve.jpoint(nx, ny, nz);
};
JPoint.prototype.mixedAdd = function mixedAdd(p) {
    // O + P = P
    if (this.isInfinity()) return p.toJ();
    // P + O = P
    if (p.isInfinity()) return this;
    // 8M + 3S + 7A
    var z2 = this.z.redSqr();
    var u1 = this.x;
    var u2 = p.x.redMul(z2);
    var s1 = this.y;
    var s2 = p.y.redMul(z2).redMul(this.z);
    var h = u1.redSub(u2);
    var r = s1.redSub(s2);
    if (h.cmpn(0) === 0) {
        if (r.cmpn(0) !== 0) return this.curve.jpoint(null, null, null);
        else return this.dbl();
    }
    var h2 = h.redSqr();
    var h3 = h2.redMul(h);
    var v = u1.redMul(h2);
    var nx = r.redSqr().redIAdd(h3).redISub(v).redISub(v);
    var ny = r.redMul(v.redISub(nx)).redISub(s1.redMul(h3));
    var nz = this.z.redMul(h);
    return this.curve.jpoint(nx, ny, nz);
};
JPoint.prototype.dblp = function dblp(pow) {
    if (pow === 0) return this;
    if (this.isInfinity()) return this;
    if (!pow) return this.dbl();
    var i;
    if (this.curve.zeroA || this.curve.threeA) {
        var r = this;
        for(i = 0; i < pow; i++)r = r.dbl();
        return r;
    }
    // 1M + 2S + 1A + N * (4S + 5M + 8A)
    // N = 1 => 6M + 6S + 9A
    var a = this.curve.a;
    var tinv = this.curve.tinv;
    var jx = this.x;
    var jy = this.y;
    var jz = this.z;
    var jz4 = jz.redSqr().redSqr();
    // Reuse results
    var jyd = jy.redAdd(jy);
    for(i = 0; i < pow; i++){
        var jx2 = jx.redSqr();
        var jyd2 = jyd.redSqr();
        var jyd4 = jyd2.redSqr();
        var c = jx2.redAdd(jx2).redIAdd(jx2).redIAdd(a.redMul(jz4));
        var t1 = jx.redMul(jyd2);
        var nx = c.redSqr().redISub(t1.redAdd(t1));
        var t2 = t1.redISub(nx);
        var dny = c.redMul(t2);
        dny = dny.redIAdd(dny).redISub(jyd4);
        var nz = jyd.redMul(jz);
        if (i + 1 < pow) jz4 = jz4.redMul(jyd4);
        jx = nx;
        jz = nz;
        jyd = dny;
    }
    return this.curve.jpoint(jx, jyd.redMul(tinv), jz);
};
JPoint.prototype.dbl = function dbl() {
    if (this.isInfinity()) return this;
    if (this.curve.zeroA) return this._zeroDbl();
    else if (this.curve.threeA) return this._threeDbl();
    else return this._dbl();
};
JPoint.prototype._zeroDbl = function _zeroDbl() {
    var nx;
    var ny;
    var nz;
    // Z = 1
    if (this.zOne) {
        // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-0.html
        //     #doubling-mdbl-2007-bl
        // 1M + 5S + 14A
        // XX = X1^2
        var xx = this.x.redSqr();
        // YY = Y1^2
        var yy = this.y.redSqr();
        // YYYY = YY^2
        var yyyy = yy.redSqr();
        // S = 2 * ((X1 + YY)^2 - XX - YYYY)
        var s = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
        s = s.redIAdd(s);
        // M = 3 * XX + a; a = 0
        var m = xx.redAdd(xx).redIAdd(xx);
        // T = M ^ 2 - 2*S
        var t = m.redSqr().redISub(s).redISub(s);
        // 8 * YYYY
        var yyyy8 = yyyy.redIAdd(yyyy);
        yyyy8 = yyyy8.redIAdd(yyyy8);
        yyyy8 = yyyy8.redIAdd(yyyy8);
        // X3 = T
        nx = t;
        // Y3 = M * (S - T) - 8 * YYYY
        ny = m.redMul(s.redISub(t)).redISub(yyyy8);
        // Z3 = 2*Y1
        nz = this.y.redAdd(this.y);
    } else {
        // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-0.html
        //     #doubling-dbl-2009-l
        // 2M + 5S + 13A
        // A = X1^2
        var a = this.x.redSqr();
        // B = Y1^2
        var b = this.y.redSqr();
        // C = B^2
        var c = b.redSqr();
        // D = 2 * ((X1 + B)^2 - A - C)
        var d = this.x.redAdd(b).redSqr().redISub(a).redISub(c);
        d = d.redIAdd(d);
        // E = 3 * A
        var e = a.redAdd(a).redIAdd(a);
        // F = E^2
        var f = e.redSqr();
        // 8 * C
        var c8 = c.redIAdd(c);
        c8 = c8.redIAdd(c8);
        c8 = c8.redIAdd(c8);
        // X3 = F - 2 * D
        nx = f.redISub(d).redISub(d);
        // Y3 = E * (D - X3) - 8 * C
        ny = e.redMul(d.redISub(nx)).redISub(c8);
        // Z3 = 2 * Y1 * Z1
        nz = this.y.redMul(this.z);
        nz = nz.redIAdd(nz);
    }
    return this.curve.jpoint(nx, ny, nz);
};
JPoint.prototype._threeDbl = function _threeDbl() {
    var nx;
    var ny;
    var nz;
    // Z = 1
    if (this.zOne) {
        // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-3.html
        //     #doubling-mdbl-2007-bl
        // 1M + 5S + 15A
        // XX = X1^2
        var xx = this.x.redSqr();
        // YY = Y1^2
        var yy = this.y.redSqr();
        // YYYY = YY^2
        var yyyy = yy.redSqr();
        // S = 2 * ((X1 + YY)^2 - XX - YYYY)
        var s = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
        s = s.redIAdd(s);
        // M = 3 * XX + a
        var m = xx.redAdd(xx).redIAdd(xx).redIAdd(this.curve.a);
        // T = M^2 - 2 * S
        var t = m.redSqr().redISub(s).redISub(s);
        // X3 = T
        nx = t;
        // Y3 = M * (S - T) - 8 * YYYY
        var yyyy8 = yyyy.redIAdd(yyyy);
        yyyy8 = yyyy8.redIAdd(yyyy8);
        yyyy8 = yyyy8.redIAdd(yyyy8);
        ny = m.redMul(s.redISub(t)).redISub(yyyy8);
        // Z3 = 2 * Y1
        nz = this.y.redAdd(this.y);
    } else {
        // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-3.html#doubling-dbl-2001-b
        // 3M + 5S
        // delta = Z1^2
        var delta = this.z.redSqr();
        // gamma = Y1^2
        var gamma = this.y.redSqr();
        // beta = X1 * gamma
        var beta = this.x.redMul(gamma);
        // alpha = 3 * (X1 - delta) * (X1 + delta)
        var alpha = this.x.redSub(delta).redMul(this.x.redAdd(delta));
        alpha = alpha.redAdd(alpha).redIAdd(alpha);
        // X3 = alpha^2 - 8 * beta
        var beta4 = beta.redIAdd(beta);
        beta4 = beta4.redIAdd(beta4);
        var beta8 = beta4.redAdd(beta4);
        nx = alpha.redSqr().redISub(beta8);
        // Z3 = (Y1 + Z1)^2 - gamma - delta
        nz = this.y.redAdd(this.z).redSqr().redISub(gamma).redISub(delta);
        // Y3 = alpha * (4 * beta - X3) - 8 * gamma^2
        var ggamma8 = gamma.redSqr();
        ggamma8 = ggamma8.redIAdd(ggamma8);
        ggamma8 = ggamma8.redIAdd(ggamma8);
        ggamma8 = ggamma8.redIAdd(ggamma8);
        ny = alpha.redMul(beta4.redISub(nx)).redISub(ggamma8);
    }
    return this.curve.jpoint(nx, ny, nz);
};
JPoint.prototype._dbl = function _dbl() {
    var a = this.curve.a;
    // 4M + 6S + 10A
    var jx = this.x;
    var jy = this.y;
    var jz = this.z;
    var jz4 = jz.redSqr().redSqr();
    var jx2 = jx.redSqr();
    var jy2 = jy.redSqr();
    var c = jx2.redAdd(jx2).redIAdd(jx2).redIAdd(a.redMul(jz4));
    var jxd4 = jx.redAdd(jx);
    jxd4 = jxd4.redIAdd(jxd4);
    var t1 = jxd4.redMul(jy2);
    var nx = c.redSqr().redISub(t1.redAdd(t1));
    var t2 = t1.redISub(nx);
    var jyd8 = jy2.redSqr();
    jyd8 = jyd8.redIAdd(jyd8);
    jyd8 = jyd8.redIAdd(jyd8);
    jyd8 = jyd8.redIAdd(jyd8);
    var ny = c.redMul(t2).redISub(jyd8);
    var nz = jy.redAdd(jy).redMul(jz);
    return this.curve.jpoint(nx, ny, nz);
};
JPoint.prototype.trpl = function trpl() {
    if (!this.curve.zeroA) return this.dbl().add(this);
    // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-0.html#tripling-tpl-2007-bl
    // 5M + 10S + ...
    // XX = X1^2
    var xx = this.x.redSqr();
    // YY = Y1^2
    var yy = this.y.redSqr();
    // ZZ = Z1^2
    var zz = this.z.redSqr();
    // YYYY = YY^2
    var yyyy = yy.redSqr();
    // M = 3 * XX + a * ZZ2; a = 0
    var m = xx.redAdd(xx).redIAdd(xx);
    // MM = M^2
    var mm = m.redSqr();
    // E = 6 * ((X1 + YY)^2 - XX - YYYY) - MM
    var e = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
    e = e.redIAdd(e);
    e = e.redAdd(e).redIAdd(e);
    e = e.redISub(mm);
    // EE = E^2
    var ee = e.redSqr();
    // T = 16*YYYY
    var t = yyyy.redIAdd(yyyy);
    t = t.redIAdd(t);
    t = t.redIAdd(t);
    t = t.redIAdd(t);
    // U = (M + E)^2 - MM - EE - T
    var u = m.redIAdd(e).redSqr().redISub(mm).redISub(ee).redISub(t);
    // X3 = 4 * (X1 * EE - 4 * YY * U)
    var yyu4 = yy.redMul(u);
    yyu4 = yyu4.redIAdd(yyu4);
    yyu4 = yyu4.redIAdd(yyu4);
    var nx = this.x.redMul(ee).redISub(yyu4);
    nx = nx.redIAdd(nx);
    nx = nx.redIAdd(nx);
    // Y3 = 8 * Y1 * (U * (T - U) - E * EE)
    var ny = this.y.redMul(u.redMul(t.redISub(u)).redISub(e.redMul(ee)));
    ny = ny.redIAdd(ny);
    ny = ny.redIAdd(ny);
    ny = ny.redIAdd(ny);
    // Z3 = (Z1 + E)^2 - ZZ - EE
    var nz = this.z.redAdd(e).redSqr().redISub(zz).redISub(ee);
    return this.curve.jpoint(nx, ny, nz);
};
JPoint.prototype.mul = function mul(k, kbase) {
    k = new BN(k, kbase);
    return this.curve._wnafMul(this, k);
};
JPoint.prototype.eq = function eq(p) {
    if (p.type === "affine") return this.eq(p.toJ());
    if (this === p) return true;
    // x1 * z2^2 == x2 * z1^2
    var z2 = this.z.redSqr();
    var pz2 = p.z.redSqr();
    if (this.x.redMul(pz2).redISub(p.x.redMul(z2)).cmpn(0) !== 0) return false;
    // y1 * z2^3 == y2 * z1^3
    var z3 = z2.redMul(this.z);
    var pz3 = pz2.redMul(p.z);
    return this.y.redMul(pz3).redISub(p.y.redMul(z3)).cmpn(0) === 0;
};
JPoint.prototype.eqXToP = function eqXToP(x) {
    var zs = this.z.redSqr();
    var rx = x.toRed(this.curve.red).redMul(zs);
    if (this.x.cmp(rx) === 0) return true;
    var xc = x.clone();
    var t = this.curve.redN.redMul(zs);
    for(;;){
        xc.iadd(this.curve.n);
        if (xc.cmp(this.curve.p) >= 0) return false;
        rx.redIAdd(t);
        if (this.x.cmp(rx) === 0) return true;
    }
};
JPoint.prototype.inspect = function inspect() {
    if (this.isInfinity()) return "<EC JPoint Infinity>";
    return "<EC JPoint x: " + this.x.toString(16, 2) + " y: " + this.y.toString(16, 2) + " z: " + this.z.toString(16, 2) + ">";
};
JPoint.prototype.isInfinity = function isInfinity() {
    // XXX This code assumes that zero is always zero in red
    return this.z.cmpn(0) === 0;
};

},{"89f794ef417dc31c":"7PLUP","c314b0ac30b69c4a":"kRh32","6ac4d7c73f24ab9c":"8LxVj","6e622edb7498c94":"49Ytv"}],"24Z2p":[function(require,module,exports) {
"use strict";
var BN = require("ebdf19f04f3ed250");
var inherits = require("cb5bb4841a749f68");
var Base = require("51280941230b3f98");
var utils = require("ea7949a80be00261");
function MontCurve(conf) {
    Base.call(this, "mont", conf);
    this.a = new BN(conf.a, 16).toRed(this.red);
    this.b = new BN(conf.b, 16).toRed(this.red);
    this.i4 = new BN(4).toRed(this.red).redInvm();
    this.two = new BN(2).toRed(this.red);
    this.a24 = this.i4.redMul(this.a.redAdd(this.two));
}
inherits(MontCurve, Base);
module.exports = MontCurve;
MontCurve.prototype.validate = function validate(point) {
    var x = point.normalize().x;
    var x2 = x.redSqr();
    var rhs = x2.redMul(x).redAdd(x2.redMul(this.a)).redAdd(x);
    var y = rhs.redSqrt();
    return y.redSqr().cmp(rhs) === 0;
};
function Point(curve, x, z) {
    Base.BasePoint.call(this, curve, "projective");
    if (x === null && z === null) {
        this.x = this.curve.one;
        this.z = this.curve.zero;
    } else {
        this.x = new BN(x, 16);
        this.z = new BN(z, 16);
        if (!this.x.red) this.x = this.x.toRed(this.curve.red);
        if (!this.z.red) this.z = this.z.toRed(this.curve.red);
    }
}
inherits(Point, Base.BasePoint);
MontCurve.prototype.decodePoint = function decodePoint(bytes, enc) {
    return this.point(utils.toArray(bytes, enc), 1);
};
MontCurve.prototype.point = function point(x, z) {
    return new Point(this, x, z);
};
MontCurve.prototype.pointFromJSON = function pointFromJSON(obj) {
    return Point.fromJSON(this, obj);
};
Point.prototype.precompute = function precompute() {
// No-op
};
Point.prototype._encode = function _encode() {
    return this.getX().toArray("be", this.curve.p.byteLength());
};
Point.fromJSON = function fromJSON(curve, obj) {
    return new Point(curve, obj[0], obj[1] || curve.one);
};
Point.prototype.inspect = function inspect() {
    if (this.isInfinity()) return "<EC Point Infinity>";
    return "<EC Point x: " + this.x.fromRed().toString(16, 2) + " z: " + this.z.fromRed().toString(16, 2) + ">";
};
Point.prototype.isInfinity = function isInfinity() {
    // XXX This code assumes that zero is always zero in red
    return this.z.cmpn(0) === 0;
};
Point.prototype.dbl = function dbl() {
    // http://hyperelliptic.org/EFD/g1p/auto-montgom-xz.html#doubling-dbl-1987-m-3
    // 2M + 2S + 4A
    // A = X1 + Z1
    var a = this.x.redAdd(this.z);
    // AA = A^2
    var aa = a.redSqr();
    // B = X1 - Z1
    var b = this.x.redSub(this.z);
    // BB = B^2
    var bb = b.redSqr();
    // C = AA - BB
    var c = aa.redSub(bb);
    // X3 = AA * BB
    var nx = aa.redMul(bb);
    // Z3 = C * (BB + A24 * C)
    var nz = c.redMul(bb.redAdd(this.curve.a24.redMul(c)));
    return this.curve.point(nx, nz);
};
Point.prototype.add = function add() {
    throw new Error("Not supported on Montgomery curve");
};
Point.prototype.diffAdd = function diffAdd(p, diff) {
    // http://hyperelliptic.org/EFD/g1p/auto-montgom-xz.html#diffadd-dadd-1987-m-3
    // 4M + 2S + 6A
    // A = X2 + Z2
    var a = this.x.redAdd(this.z);
    // B = X2 - Z2
    var b = this.x.redSub(this.z);
    // C = X3 + Z3
    var c = p.x.redAdd(p.z);
    // D = X3 - Z3
    var d = p.x.redSub(p.z);
    // DA = D * A
    var da = d.redMul(a);
    // CB = C * B
    var cb = c.redMul(b);
    // X5 = Z1 * (DA + CB)^2
    var nx = diff.z.redMul(da.redAdd(cb).redSqr());
    // Z5 = X1 * (DA - CB)^2
    var nz = diff.x.redMul(da.redISub(cb).redSqr());
    return this.curve.point(nx, nz);
};
Point.prototype.mul = function mul(k) {
    var t = k.clone();
    var a = this; // (N / 2) * Q + Q
    var b = this.curve.point(null, null); // (N / 2) * Q
    var c = this; // Q
    for(var bits = []; t.cmpn(0) !== 0; t.iushrn(1))bits.push(t.andln(1));
    for(var i = bits.length - 1; i >= 0; i--)if (bits[i] === 0) {
        // N * Q + Q = ((N / 2) * Q + Q)) + (N / 2) * Q
        a = a.diffAdd(b, c);
        // N * Q = 2 * ((N / 2) * Q + Q))
        b = b.dbl();
    } else {
        // N * Q = ((N / 2) * Q + Q) + ((N / 2) * Q)
        b = a.diffAdd(b, c);
        // N * Q + Q = 2 * ((N / 2) * Q + Q)
        a = a.dbl();
    }
    return b;
};
Point.prototype.mulAdd = function mulAdd() {
    throw new Error("Not supported on Montgomery curve");
};
Point.prototype.jumlAdd = function jumlAdd() {
    throw new Error("Not supported on Montgomery curve");
};
Point.prototype.eq = function eq(other) {
    return this.getX().cmp(other.getX()) === 0;
};
Point.prototype.normalize = function normalize() {
    this.x = this.x.redMul(this.z.redInvm());
    this.z = this.curve.one;
    return this;
};
Point.prototype.getX = function getX() {
    // Normalize coordinates
    this.normalize();
    return this.x.fromRed();
};

},{"ebdf19f04f3ed250":"kRh32","cb5bb4841a749f68":"8LxVj","51280941230b3f98":"49Ytv","ea7949a80be00261":"7PLUP"}],"4i3b7":[function(require,module,exports) {
"use strict";
var utils = require("7bd66a4710450b08");
var BN = require("ccef46dcf03d45c6");
var inherits = require("19937272cbe23c92");
var Base = require("108c8ead5f54502b");
var assert = utils.assert;
function EdwardsCurve(conf) {
    // NOTE: Important as we are creating point in Base.call()
    this.twisted = (conf.a | 0) !== 1;
    this.mOneA = this.twisted && (conf.a | 0) === -1;
    this.extended = this.mOneA;
    Base.call(this, "edwards", conf);
    this.a = new BN(conf.a, 16).umod(this.red.m);
    this.a = this.a.toRed(this.red);
    this.c = new BN(conf.c, 16).toRed(this.red);
    this.c2 = this.c.redSqr();
    this.d = new BN(conf.d, 16).toRed(this.red);
    this.dd = this.d.redAdd(this.d);
    assert(!this.twisted || this.c.fromRed().cmpn(1) === 0);
    this.oneC = (conf.c | 0) === 1;
}
inherits(EdwardsCurve, Base);
module.exports = EdwardsCurve;
EdwardsCurve.prototype._mulA = function _mulA(num) {
    if (this.mOneA) return num.redNeg();
    else return this.a.redMul(num);
};
EdwardsCurve.prototype._mulC = function _mulC(num) {
    if (this.oneC) return num;
    else return this.c.redMul(num);
};
// Just for compatibility with Short curve
EdwardsCurve.prototype.jpoint = function jpoint(x, y, z, t) {
    return this.point(x, y, z, t);
};
EdwardsCurve.prototype.pointFromX = function pointFromX(x, odd) {
    x = new BN(x, 16);
    if (!x.red) x = x.toRed(this.red);
    var x2 = x.redSqr();
    var rhs = this.c2.redSub(this.a.redMul(x2));
    var lhs = this.one.redSub(this.c2.redMul(this.d).redMul(x2));
    var y2 = rhs.redMul(lhs.redInvm());
    var y = y2.redSqrt();
    if (y.redSqr().redSub(y2).cmp(this.zero) !== 0) throw new Error("invalid point");
    var isOdd = y.fromRed().isOdd();
    if (odd && !isOdd || !odd && isOdd) y = y.redNeg();
    return this.point(x, y);
};
EdwardsCurve.prototype.pointFromY = function pointFromY(y, odd) {
    y = new BN(y, 16);
    if (!y.red) y = y.toRed(this.red);
    // x^2 = (y^2 - c^2) / (c^2 d y^2 - a)
    var y2 = y.redSqr();
    var lhs = y2.redSub(this.c2);
    var rhs = y2.redMul(this.d).redMul(this.c2).redSub(this.a);
    var x2 = lhs.redMul(rhs.redInvm());
    if (x2.cmp(this.zero) === 0) {
        if (odd) throw new Error("invalid point");
        else return this.point(this.zero, y);
    }
    var x = x2.redSqrt();
    if (x.redSqr().redSub(x2).cmp(this.zero) !== 0) throw new Error("invalid point");
    if (x.fromRed().isOdd() !== odd) x = x.redNeg();
    return this.point(x, y);
};
EdwardsCurve.prototype.validate = function validate(point) {
    if (point.isInfinity()) return true;
    // Curve: A * X^2 + Y^2 = C^2 * (1 + D * X^2 * Y^2)
    point.normalize();
    var x2 = point.x.redSqr();
    var y2 = point.y.redSqr();
    var lhs = x2.redMul(this.a).redAdd(y2);
    var rhs = this.c2.redMul(this.one.redAdd(this.d.redMul(x2).redMul(y2)));
    return lhs.cmp(rhs) === 0;
};
function Point(curve, x, y, z, t) {
    Base.BasePoint.call(this, curve, "projective");
    if (x === null && y === null && z === null) {
        this.x = this.curve.zero;
        this.y = this.curve.one;
        this.z = this.curve.one;
        this.t = this.curve.zero;
        this.zOne = true;
    } else {
        this.x = new BN(x, 16);
        this.y = new BN(y, 16);
        this.z = z ? new BN(z, 16) : this.curve.one;
        this.t = t && new BN(t, 16);
        if (!this.x.red) this.x = this.x.toRed(this.curve.red);
        if (!this.y.red) this.y = this.y.toRed(this.curve.red);
        if (!this.z.red) this.z = this.z.toRed(this.curve.red);
        if (this.t && !this.t.red) this.t = this.t.toRed(this.curve.red);
        this.zOne = this.z === this.curve.one;
        // Use extended coordinates
        if (this.curve.extended && !this.t) {
            this.t = this.x.redMul(this.y);
            if (!this.zOne) this.t = this.t.redMul(this.z.redInvm());
        }
    }
}
inherits(Point, Base.BasePoint);
EdwardsCurve.prototype.pointFromJSON = function pointFromJSON(obj) {
    return Point.fromJSON(this, obj);
};
EdwardsCurve.prototype.point = function point(x, y, z, t) {
    return new Point(this, x, y, z, t);
};
Point.fromJSON = function fromJSON(curve, obj) {
    return new Point(curve, obj[0], obj[1], obj[2]);
};
Point.prototype.inspect = function inspect() {
    if (this.isInfinity()) return "<EC Point Infinity>";
    return "<EC Point x: " + this.x.fromRed().toString(16, 2) + " y: " + this.y.fromRed().toString(16, 2) + " z: " + this.z.fromRed().toString(16, 2) + ">";
};
Point.prototype.isInfinity = function isInfinity() {
    // XXX This code assumes that zero is always zero in red
    return this.x.cmpn(0) === 0 && (this.y.cmp(this.z) === 0 || this.zOne && this.y.cmp(this.curve.c) === 0);
};
Point.prototype._extDbl = function _extDbl() {
    // hyperelliptic.org/EFD/g1p/auto-twisted-extended-1.html
    //     #doubling-dbl-2008-hwcd
    // 4M + 4S
    // A = X1^2
    var a = this.x.redSqr();
    // B = Y1^2
    var b = this.y.redSqr();
    // C = 2 * Z1^2
    var c = this.z.redSqr();
    c = c.redIAdd(c);
    // D = a * A
    var d = this.curve._mulA(a);
    // E = (X1 + Y1)^2 - A - B
    var e = this.x.redAdd(this.y).redSqr().redISub(a).redISub(b);
    // G = D + B
    var g = d.redAdd(b);
    // F = G - C
    var f = g.redSub(c);
    // H = D - B
    var h = d.redSub(b);
    // X3 = E * F
    var nx = e.redMul(f);
    // Y3 = G * H
    var ny = g.redMul(h);
    // T3 = E * H
    var nt = e.redMul(h);
    // Z3 = F * G
    var nz = f.redMul(g);
    return this.curve.point(nx, ny, nz, nt);
};
Point.prototype._projDbl = function _projDbl() {
    // hyperelliptic.org/EFD/g1p/auto-twisted-projective.html
    //     #doubling-dbl-2008-bbjlp
    //     #doubling-dbl-2007-bl
    // and others
    // Generally 3M + 4S or 2M + 4S
    // B = (X1 + Y1)^2
    var b = this.x.redAdd(this.y).redSqr();
    // C = X1^2
    var c = this.x.redSqr();
    // D = Y1^2
    var d = this.y.redSqr();
    var nx;
    var ny;
    var nz;
    var e;
    var h;
    var j;
    if (this.curve.twisted) {
        // E = a * C
        e = this.curve._mulA(c);
        // F = E + D
        var f = e.redAdd(d);
        if (this.zOne) {
            // X3 = (B - C - D) * (F - 2)
            nx = b.redSub(c).redSub(d).redMul(f.redSub(this.curve.two));
            // Y3 = F * (E - D)
            ny = f.redMul(e.redSub(d));
            // Z3 = F^2 - 2 * F
            nz = f.redSqr().redSub(f).redSub(f);
        } else {
            // H = Z1^2
            h = this.z.redSqr();
            // J = F - 2 * H
            j = f.redSub(h).redISub(h);
            // X3 = (B-C-D)*J
            nx = b.redSub(c).redISub(d).redMul(j);
            // Y3 = F * (E - D)
            ny = f.redMul(e.redSub(d));
            // Z3 = F * J
            nz = f.redMul(j);
        }
    } else {
        // E = C + D
        e = c.redAdd(d);
        // H = (c * Z1)^2
        h = this.curve._mulC(this.z).redSqr();
        // J = E - 2 * H
        j = e.redSub(h).redSub(h);
        // X3 = c * (B - E) * J
        nx = this.curve._mulC(b.redISub(e)).redMul(j);
        // Y3 = c * E * (C - D)
        ny = this.curve._mulC(e).redMul(c.redISub(d));
        // Z3 = E * J
        nz = e.redMul(j);
    }
    return this.curve.point(nx, ny, nz);
};
Point.prototype.dbl = function dbl() {
    if (this.isInfinity()) return this;
    // Double in extended coordinates
    if (this.curve.extended) return this._extDbl();
    else return this._projDbl();
};
Point.prototype._extAdd = function _extAdd(p) {
    // hyperelliptic.org/EFD/g1p/auto-twisted-extended-1.html
    //     #addition-add-2008-hwcd-3
    // 8M
    // A = (Y1 - X1) * (Y2 - X2)
    var a = this.y.redSub(this.x).redMul(p.y.redSub(p.x));
    // B = (Y1 + X1) * (Y2 + X2)
    var b = this.y.redAdd(this.x).redMul(p.y.redAdd(p.x));
    // C = T1 * k * T2
    var c = this.t.redMul(this.curve.dd).redMul(p.t);
    // D = Z1 * 2 * Z2
    var d = this.z.redMul(p.z.redAdd(p.z));
    // E = B - A
    var e = b.redSub(a);
    // F = D - C
    var f = d.redSub(c);
    // G = D + C
    var g = d.redAdd(c);
    // H = B + A
    var h = b.redAdd(a);
    // X3 = E * F
    var nx = e.redMul(f);
    // Y3 = G * H
    var ny = g.redMul(h);
    // T3 = E * H
    var nt = e.redMul(h);
    // Z3 = F * G
    var nz = f.redMul(g);
    return this.curve.point(nx, ny, nz, nt);
};
Point.prototype._projAdd = function _projAdd(p) {
    // hyperelliptic.org/EFD/g1p/auto-twisted-projective.html
    //     #addition-add-2008-bbjlp
    //     #addition-add-2007-bl
    // 10M + 1S
    // A = Z1 * Z2
    var a = this.z.redMul(p.z);
    // B = A^2
    var b = a.redSqr();
    // C = X1 * X2
    var c = this.x.redMul(p.x);
    // D = Y1 * Y2
    var d = this.y.redMul(p.y);
    // E = d * C * D
    var e = this.curve.d.redMul(c).redMul(d);
    // F = B - E
    var f = b.redSub(e);
    // G = B + E
    var g = b.redAdd(e);
    // X3 = A * F * ((X1 + Y1) * (X2 + Y2) - C - D)
    var tmp = this.x.redAdd(this.y).redMul(p.x.redAdd(p.y)).redISub(c).redISub(d);
    var nx = a.redMul(f).redMul(tmp);
    var ny;
    var nz;
    if (this.curve.twisted) {
        // Y3 = A * G * (D - a * C)
        ny = a.redMul(g).redMul(d.redSub(this.curve._mulA(c)));
        // Z3 = F * G
        nz = f.redMul(g);
    } else {
        // Y3 = A * G * (D - C)
        ny = a.redMul(g).redMul(d.redSub(c));
        // Z3 = c * F * G
        nz = this.curve._mulC(f).redMul(g);
    }
    return this.curve.point(nx, ny, nz);
};
Point.prototype.add = function add(p) {
    if (this.isInfinity()) return p;
    if (p.isInfinity()) return this;
    if (this.curve.extended) return this._extAdd(p);
    else return this._projAdd(p);
};
Point.prototype.mul = function mul(k) {
    if (this._hasDoubles(k)) return this.curve._fixedNafMul(this, k);
    else return this.curve._wnafMul(this, k);
};
Point.prototype.mulAdd = function mulAdd(k1, p, k2) {
    return this.curve._wnafMulAdd(1, [
        this,
        p
    ], [
        k1,
        k2
    ], 2, false);
};
Point.prototype.jmulAdd = function jmulAdd(k1, p, k2) {
    return this.curve._wnafMulAdd(1, [
        this,
        p
    ], [
        k1,
        k2
    ], 2, true);
};
Point.prototype.normalize = function normalize() {
    if (this.zOne) return this;
    // Normalize coordinates
    var zi = this.z.redInvm();
    this.x = this.x.redMul(zi);
    this.y = this.y.redMul(zi);
    if (this.t) this.t = this.t.redMul(zi);
    this.z = this.curve.one;
    this.zOne = true;
    return this;
};
Point.prototype.neg = function neg() {
    return this.curve.point(this.x.redNeg(), this.y, this.z, this.t && this.t.redNeg());
};
Point.prototype.getX = function getX() {
    this.normalize();
    return this.x.fromRed();
};
Point.prototype.getY = function getY() {
    this.normalize();
    return this.y.fromRed();
};
Point.prototype.eq = function eq(other) {
    return this === other || this.getX().cmp(other.getX()) === 0 && this.getY().cmp(other.getY()) === 0;
};
Point.prototype.eqXToP = function eqXToP(x) {
    var rx = x.toRed(this.curve.red).redMul(this.z);
    if (this.x.cmp(rx) === 0) return true;
    var xc = x.clone();
    var t = this.curve.redN.redMul(this.z);
    for(;;){
        xc.iadd(this.curve.n);
        if (xc.cmp(this.curve.p) >= 0) return false;
        rx.redIAdd(t);
        if (this.x.cmp(rx) === 0) return true;
    }
};
// Compatibility with BaseCurve
Point.prototype.toP = Point.prototype.normalize;
Point.prototype.mixedAdd = Point.prototype.add;

},{"7bd66a4710450b08":"7PLUP","ccef46dcf03d45c6":"kRh32","19937272cbe23c92":"8LxVj","108c8ead5f54502b":"49Ytv"}],"ab7Cj":[function(require,module,exports) {
"use strict";
var curves = exports;
var hash = require("1c9db357c0845afa");
var curve = require("47ec78745540f875");
var utils = require("e30b16e4a47a5405");
var assert = utils.assert;
function PresetCurve(options) {
    if (options.type === "short") this.curve = new curve.short(options);
    else if (options.type === "edwards") this.curve = new curve.edwards(options);
    else this.curve = new curve.mont(options);
    this.g = this.curve.g;
    this.n = this.curve.n;
    this.hash = options.hash;
    assert(this.g.validate(), "Invalid curve");
    assert(this.g.mul(this.n).isInfinity(), "Invalid curve, G*N != O");
}
curves.PresetCurve = PresetCurve;
function defineCurve(name, options) {
    Object.defineProperty(curves, name, {
        configurable: true,
        enumerable: true,
        get: function() {
            var curve = new PresetCurve(options);
            Object.defineProperty(curves, name, {
                configurable: true,
                enumerable: true,
                value: curve
            });
            return curve;
        }
    });
}
defineCurve("p192", {
    type: "short",
    prime: "p192",
    p: "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff",
    a: "ffffffff ffffffff ffffffff fffffffe ffffffff fffffffc",
    b: "64210519 e59c80e7 0fa7e9ab 72243049 feb8deec c146b9b1",
    n: "ffffffff ffffffff ffffffff 99def836 146bc9b1 b4d22831",
    hash: hash.sha256,
    gRed: false,
    g: [
        "188da80e b03090f6 7cbf20eb 43a18800 f4ff0afd 82ff1012",
        "07192b95 ffc8da78 631011ed 6b24cdd5 73f977a1 1e794811"
    ]
});
defineCurve("p224", {
    type: "short",
    prime: "p224",
    p: "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001",
    a: "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff fffffffe",
    b: "b4050a85 0c04b3ab f5413256 5044b0b7 d7bfd8ba 270b3943 2355ffb4",
    n: "ffffffff ffffffff ffffffff ffff16a2 e0b8f03e 13dd2945 5c5c2a3d",
    hash: hash.sha256,
    gRed: false,
    g: [
        "b70e0cbd 6bb4bf7f 321390b9 4a03c1d3 56c21122 343280d6 115c1d21",
        "bd376388 b5f723fb 4c22dfe6 cd4375a0 5a074764 44d58199 85007e34"
    ]
});
defineCurve("p256", {
    type: "short",
    prime: null,
    p: "ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff ffffffff",
    a: "ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff fffffffc",
    b: "5ac635d8 aa3a93e7 b3ebbd55 769886bc 651d06b0 cc53b0f6 3bce3c3e 27d2604b",
    n: "ffffffff 00000000 ffffffff ffffffff bce6faad a7179e84 f3b9cac2 fc632551",
    hash: hash.sha256,
    gRed: false,
    g: [
        "6b17d1f2 e12c4247 f8bce6e5 63a440f2 77037d81 2deb33a0 f4a13945 d898c296",
        "4fe342e2 fe1a7f9b 8ee7eb4a 7c0f9e16 2bce3357 6b315ece cbb64068 37bf51f5"
    ]
});
defineCurve("p384", {
    type: "short",
    prime: null,
    p: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe ffffffff 00000000 00000000 ffffffff",
    a: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe ffffffff 00000000 00000000 fffffffc",
    b: "b3312fa7 e23ee7e4 988e056b e3f82d19 181d9c6e fe814112 0314088f 5013875a c656398d 8a2ed19d 2a85c8ed d3ec2aef",
    n: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff c7634d81 f4372ddf 581a0db2 48b0a77a ecec196a ccc52973",
    hash: hash.sha384,
    gRed: false,
    g: [
        "aa87ca22 be8b0537 8eb1c71e f320ad74 6e1d3b62 8ba79b98 59f741e0 82542a38 5502f25d bf55296c 3a545e38 72760ab7",
        "3617de4a 96262c6f 5d9e98bf 9292dc29 f8f41dbd 289a147c e9da3113 b5f0b8c0 0a60b1ce 1d7e819d 7a431d7c 90ea0e5f"
    ]
});
defineCurve("p521", {
    type: "short",
    prime: null,
    p: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff",
    a: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffc",
    b: "00000051 953eb961 8e1c9a1f 929a21a0 b68540ee a2da725b 99b315f3 b8b48991 8ef109e1 56193951 ec7e937b 1652c0bd 3bb1bf07 3573df88 3d2c34f1 ef451fd4 6b503f00",
    n: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffa 51868783 bf2f966b 7fcc0148 f709a5d0 3bb5c9b8 899c47ae bb6fb71e 91386409",
    hash: hash.sha512,
    gRed: false,
    g: [
        "000000c6 858e06b7 0404e9cd 9e3ecb66 2395b442 9c648139 053fb521 f828af60 6b4d3dba a14b5e77 efe75928 fe1dc127 a2ffa8de 3348b3c1 856a429b f97e7e31 c2e5bd66",
        "00000118 39296a78 9a3bc004 5c8a5fb4 2c7d1bd9 98f54449 579b4468 17afbd17 273e662c 97ee7299 5ef42640 c550b901 3fad0761 353c7086 a272c240 88be9476 9fd16650"
    ]
});
defineCurve("curve25519", {
    type: "mont",
    prime: "p25519",
    p: "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed",
    a: "76d06",
    b: "1",
    n: "1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed",
    hash: hash.sha256,
    gRed: false,
    g: [
        "9"
    ]
});
defineCurve("ed25519", {
    type: "edwards",
    prime: "p25519",
    p: "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed",
    a: "-1",
    c: "1",
    // -121665 * (121666^(-1)) (mod P)
    d: "52036cee2b6ffe73 8cc740797779e898 00700a4d4141d8ab 75eb4dca135978a3",
    n: "1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed",
    hash: hash.sha256,
    gRed: false,
    g: [
        "216936d3cd6e53fec0a4e231fdd6dc5c692cc7609525a7b2c9562d608f25d51a",
        // 4/5
        "6666666666666666666666666666666666666666666666666666666666666658"
    ]
});
var pre;
try {
    pre = require("9eada5f7049e7dfd");
} catch (e) {
    pre = undefined;
}
defineCurve("secp256k1", {
    type: "short",
    prime: "k256",
    p: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f",
    a: "0",
    b: "7",
    n: "ffffffff ffffffff ffffffff fffffffe baaedce6 af48a03b bfd25e8c d0364141",
    h: "1",
    hash: hash.sha256,
    // Precomputed endomorphism
    beta: "7ae96a2b657c07106e64479eac3434e99cf0497512f58995c1396c28719501ee",
    lambda: "5363ad4cc05c30e0a5261c028812645a122e22ea20816678df02967c1b23bd72",
    basis: [
        {
            a: "3086d221a7d46bcde86c90e49284eb15",
            b: "-e4437ed6010e88286f547fa90abfe4c3"
        },
        {
            a: "114ca50f7a8e2f3f657c1108d9d44cfd8",
            b: "3086d221a7d46bcde86c90e49284eb15"
        }
    ],
    gRed: false,
    g: [
        "79be667ef9dcbbac55a06295ce870b07029bfcdb2dce28d959f2815b16f81798",
        "483ada7726a3c4655da4fbfc0e1108a8fd17b448a68554199c47d08ffb10d4b8",
        pre
    ]
});

},{"1c9db357c0845afa":"dElqS","47ec78745540f875":"3ZY1v","e30b16e4a47a5405":"7PLUP","9eada5f7049e7dfd":"iM2eR"}],"iM2eR":[function(require,module,exports) {
module.exports = {
    doubles: {
        step: 4,
        points: [
            [
                "e60fce93b59e9ec53011aabc21c23e97b2a31369b87a5ae9c44ee89e2a6dec0a",
                "f7e3507399e595929db99f34f57937101296891e44d23f0be1f32cce69616821"
            ],
            [
                "8282263212c609d9ea2a6e3e172de238d8c39cabd5ac1ca10646e23fd5f51508",
                "11f8a8098557dfe45e8256e830b60ace62d613ac2f7b17bed31b6eaff6e26caf"
            ],
            [
                "175e159f728b865a72f99cc6c6fc846de0b93833fd2222ed73fce5b551e5b739",
                "d3506e0d9e3c79eba4ef97a51ff71f5eacb5955add24345c6efa6ffee9fed695"
            ],
            [
                "363d90d447b00c9c99ceac05b6262ee053441c7e55552ffe526bad8f83ff4640",
                "4e273adfc732221953b445397f3363145b9a89008199ecb62003c7f3bee9de9"
            ],
            [
                "8b4b5f165df3c2be8c6244b5b745638843e4a781a15bcd1b69f79a55dffdf80c",
                "4aad0a6f68d308b4b3fbd7813ab0da04f9e336546162ee56b3eff0c65fd4fd36"
            ],
            [
                "723cbaa6e5db996d6bf771c00bd548c7b700dbffa6c0e77bcb6115925232fcda",
                "96e867b5595cc498a921137488824d6e2660a0653779494801dc069d9eb39f5f"
            ],
            [
                "eebfa4d493bebf98ba5feec812c2d3b50947961237a919839a533eca0e7dd7fa",
                "5d9a8ca3970ef0f269ee7edaf178089d9ae4cdc3a711f712ddfd4fdae1de8999"
            ],
            [
                "100f44da696e71672791d0a09b7bde459f1215a29b3c03bfefd7835b39a48db0",
                "cdd9e13192a00b772ec8f3300c090666b7ff4a18ff5195ac0fbd5cd62bc65a09"
            ],
            [
                "e1031be262c7ed1b1dc9227a4a04c017a77f8d4464f3b3852c8acde6e534fd2d",
                "9d7061928940405e6bb6a4176597535af292dd419e1ced79a44f18f29456a00d"
            ],
            [
                "feea6cae46d55b530ac2839f143bd7ec5cf8b266a41d6af52d5e688d9094696d",
                "e57c6b6c97dce1bab06e4e12bf3ecd5c981c8957cc41442d3155debf18090088"
            ],
            [
                "da67a91d91049cdcb367be4be6ffca3cfeed657d808583de33fa978bc1ec6cb1",
                "9bacaa35481642bc41f463f7ec9780e5dec7adc508f740a17e9ea8e27a68be1d"
            ],
            [
                "53904faa0b334cdda6e000935ef22151ec08d0f7bb11069f57545ccc1a37b7c0",
                "5bc087d0bc80106d88c9eccac20d3c1c13999981e14434699dcb096b022771c8"
            ],
            [
                "8e7bcd0bd35983a7719cca7764ca906779b53a043a9b8bcaeff959f43ad86047",
                "10b7770b2a3da4b3940310420ca9514579e88e2e47fd68b3ea10047e8460372a"
            ],
            [
                "385eed34c1cdff21e6d0818689b81bde71a7f4f18397e6690a841e1599c43862",
                "283bebc3e8ea23f56701de19e9ebf4576b304eec2086dc8cc0458fe5542e5453"
            ],
            [
                "6f9d9b803ecf191637c73a4413dfa180fddf84a5947fbc9c606ed86c3fac3a7",
                "7c80c68e603059ba69b8e2a30e45c4d47ea4dd2f5c281002d86890603a842160"
            ],
            [
                "3322d401243c4e2582a2147c104d6ecbf774d163db0f5e5313b7e0e742d0e6bd",
                "56e70797e9664ef5bfb019bc4ddaf9b72805f63ea2873af624f3a2e96c28b2a0"
            ],
            [
                "85672c7d2de0b7da2bd1770d89665868741b3f9af7643397721d74d28134ab83",
                "7c481b9b5b43b2eb6374049bfa62c2e5e77f17fcc5298f44c8e3094f790313a6"
            ],
            [
                "948bf809b1988a46b06c9f1919413b10f9226c60f668832ffd959af60c82a0a",
                "53a562856dcb6646dc6b74c5d1c3418c6d4dff08c97cd2bed4cb7f88d8c8e589"
            ],
            [
                "6260ce7f461801c34f067ce0f02873a8f1b0e44dfc69752accecd819f38fd8e8",
                "bc2da82b6fa5b571a7f09049776a1ef7ecd292238051c198c1a84e95b2b4ae17"
            ],
            [
                "e5037de0afc1d8d43d8348414bbf4103043ec8f575bfdc432953cc8d2037fa2d",
                "4571534baa94d3b5f9f98d09fb990bddbd5f5b03ec481f10e0e5dc841d755bda"
            ],
            [
                "e06372b0f4a207adf5ea905e8f1771b4e7e8dbd1c6a6c5b725866a0ae4fce725",
                "7a908974bce18cfe12a27bb2ad5a488cd7484a7787104870b27034f94eee31dd"
            ],
            [
                "213c7a715cd5d45358d0bbf9dc0ce02204b10bdde2a3f58540ad6908d0559754",
                "4b6dad0b5ae462507013ad06245ba190bb4850f5f36a7eeddff2c27534b458f2"
            ],
            [
                "4e7c272a7af4b34e8dbb9352a5419a87e2838c70adc62cddf0cc3a3b08fbd53c",
                "17749c766c9d0b18e16fd09f6def681b530b9614bff7dd33e0b3941817dcaae6"
            ],
            [
                "fea74e3dbe778b1b10f238ad61686aa5c76e3db2be43057632427e2840fb27b6",
                "6e0568db9b0b13297cf674deccb6af93126b596b973f7b77701d3db7f23cb96f"
            ],
            [
                "76e64113f677cf0e10a2570d599968d31544e179b760432952c02a4417bdde39",
                "c90ddf8dee4e95cf577066d70681f0d35e2a33d2b56d2032b4b1752d1901ac01"
            ],
            [
                "c738c56b03b2abe1e8281baa743f8f9a8f7cc643df26cbee3ab150242bcbb891",
                "893fb578951ad2537f718f2eacbfbbbb82314eef7880cfe917e735d9699a84c3"
            ],
            [
                "d895626548b65b81e264c7637c972877d1d72e5f3a925014372e9f6588f6c14b",
                "febfaa38f2bc7eae728ec60818c340eb03428d632bb067e179363ed75d7d991f"
            ],
            [
                "b8da94032a957518eb0f6433571e8761ceffc73693e84edd49150a564f676e03",
                "2804dfa44805a1e4d7c99cc9762808b092cc584d95ff3b511488e4e74efdf6e7"
            ],
            [
                "e80fea14441fb33a7d8adab9475d7fab2019effb5156a792f1a11778e3c0df5d",
                "eed1de7f638e00771e89768ca3ca94472d155e80af322ea9fcb4291b6ac9ec78"
            ],
            [
                "a301697bdfcd704313ba48e51d567543f2a182031efd6915ddc07bbcc4e16070",
                "7370f91cfb67e4f5081809fa25d40f9b1735dbf7c0a11a130c0d1a041e177ea1"
            ],
            [
                "90ad85b389d6b936463f9d0512678de208cc330b11307fffab7ac63e3fb04ed4",
                "e507a3620a38261affdcbd9427222b839aefabe1582894d991d4d48cb6ef150"
            ],
            [
                "8f68b9d2f63b5f339239c1ad981f162ee88c5678723ea3351b7b444c9ec4c0da",
                "662a9f2dba063986de1d90c2b6be215dbbea2cfe95510bfdf23cbf79501fff82"
            ],
            [
                "e4f3fb0176af85d65ff99ff9198c36091f48e86503681e3e6686fd5053231e11",
                "1e63633ad0ef4f1c1661a6d0ea02b7286cc7e74ec951d1c9822c38576feb73bc"
            ],
            [
                "8c00fa9b18ebf331eb961537a45a4266c7034f2f0d4e1d0716fb6eae20eae29e",
                "efa47267fea521a1a9dc343a3736c974c2fadafa81e36c54e7d2a4c66702414b"
            ],
            [
                "e7a26ce69dd4829f3e10cec0a9e98ed3143d084f308b92c0997fddfc60cb3e41",
                "2a758e300fa7984b471b006a1aafbb18d0a6b2c0420e83e20e8a9421cf2cfd51"
            ],
            [
                "b6459e0ee3662ec8d23540c223bcbdc571cbcb967d79424f3cf29eb3de6b80ef",
                "67c876d06f3e06de1dadf16e5661db3c4b3ae6d48e35b2ff30bf0b61a71ba45"
            ],
            [
                "d68a80c8280bb840793234aa118f06231d6f1fc67e73c5a5deda0f5b496943e8",
                "db8ba9fff4b586d00c4b1f9177b0e28b5b0e7b8f7845295a294c84266b133120"
            ],
            [
                "324aed7df65c804252dc0270907a30b09612aeb973449cea4095980fc28d3d5d",
                "648a365774b61f2ff130c0c35aec1f4f19213b0c7e332843967224af96ab7c84"
            ],
            [
                "4df9c14919cde61f6d51dfdbe5fee5dceec4143ba8d1ca888e8bd373fd054c96",
                "35ec51092d8728050974c23a1d85d4b5d506cdc288490192ebac06cad10d5d"
            ],
            [
                "9c3919a84a474870faed8a9c1cc66021523489054d7f0308cbfc99c8ac1f98cd",
                "ddb84f0f4a4ddd57584f044bf260e641905326f76c64c8e6be7e5e03d4fc599d"
            ],
            [
                "6057170b1dd12fdf8de05f281d8e06bb91e1493a8b91d4cc5a21382120a959e5",
                "9a1af0b26a6a4807add9a2daf71df262465152bc3ee24c65e899be932385a2a8"
            ],
            [
                "a576df8e23a08411421439a4518da31880cef0fba7d4df12b1a6973eecb94266",
                "40a6bf20e76640b2c92b97afe58cd82c432e10a7f514d9f3ee8be11ae1b28ec8"
            ],
            [
                "7778a78c28dec3e30a05fe9629de8c38bb30d1f5cf9a3a208f763889be58ad71",
                "34626d9ab5a5b22ff7098e12f2ff580087b38411ff24ac563b513fc1fd9f43ac"
            ],
            [
                "928955ee637a84463729fd30e7afd2ed5f96274e5ad7e5cb09eda9c06d903ac",
                "c25621003d3f42a827b78a13093a95eeac3d26efa8a8d83fc5180e935bcd091f"
            ],
            [
                "85d0fef3ec6db109399064f3a0e3b2855645b4a907ad354527aae75163d82751",
                "1f03648413a38c0be29d496e582cf5663e8751e96877331582c237a24eb1f962"
            ],
            [
                "ff2b0dce97eece97c1c9b6041798b85dfdfb6d8882da20308f5404824526087e",
                "493d13fef524ba188af4c4dc54d07936c7b7ed6fb90e2ceb2c951e01f0c29907"
            ],
            [
                "827fbbe4b1e880ea9ed2b2e6301b212b57f1ee148cd6dd28780e5e2cf856e241",
                "c60f9c923c727b0b71bef2c67d1d12687ff7a63186903166d605b68baec293ec"
            ],
            [
                "eaa649f21f51bdbae7be4ae34ce6e5217a58fdce7f47f9aa7f3b58fa2120e2b3",
                "be3279ed5bbbb03ac69a80f89879aa5a01a6b965f13f7e59d47a5305ba5ad93d"
            ],
            [
                "e4a42d43c5cf169d9391df6decf42ee541b6d8f0c9a137401e23632dda34d24f",
                "4d9f92e716d1c73526fc99ccfb8ad34ce886eedfa8d8e4f13a7f7131deba9414"
            ],
            [
                "1ec80fef360cbdd954160fadab352b6b92b53576a88fea4947173b9d4300bf19",
                "aeefe93756b5340d2f3a4958a7abbf5e0146e77f6295a07b671cdc1cc107cefd"
            ],
            [
                "146a778c04670c2f91b00af4680dfa8bce3490717d58ba889ddb5928366642be",
                "b318e0ec3354028add669827f9d4b2870aaa971d2f7e5ed1d0b297483d83efd0"
            ],
            [
                "fa50c0f61d22e5f07e3acebb1aa07b128d0012209a28b9776d76a8793180eef9",
                "6b84c6922397eba9b72cd2872281a68a5e683293a57a213b38cd8d7d3f4f2811"
            ],
            [
                "da1d61d0ca721a11b1a5bf6b7d88e8421a288ab5d5bba5220e53d32b5f067ec2",
                "8157f55a7c99306c79c0766161c91e2966a73899d279b48a655fba0f1ad836f1"
            ],
            [
                "a8e282ff0c9706907215ff98e8fd416615311de0446f1e062a73b0610d064e13",
                "7f97355b8db81c09abfb7f3c5b2515888b679a3e50dd6bd6cef7c73111f4cc0c"
            ],
            [
                "174a53b9c9a285872d39e56e6913cab15d59b1fa512508c022f382de8319497c",
                "ccc9dc37abfc9c1657b4155f2c47f9e6646b3a1d8cb9854383da13ac079afa73"
            ],
            [
                "959396981943785c3d3e57edf5018cdbe039e730e4918b3d884fdff09475b7ba",
                "2e7e552888c331dd8ba0386a4b9cd6849c653f64c8709385e9b8abf87524f2fd"
            ],
            [
                "d2a63a50ae401e56d645a1153b109a8fcca0a43d561fba2dbb51340c9d82b151",
                "e82d86fb6443fcb7565aee58b2948220a70f750af484ca52d4142174dcf89405"
            ],
            [
                "64587e2335471eb890ee7896d7cfdc866bacbdbd3839317b3436f9b45617e073",
                "d99fcdd5bf6902e2ae96dd6447c299a185b90a39133aeab358299e5e9faf6589"
            ],
            [
                "8481bde0e4e4d885b3a546d3e549de042f0aa6cea250e7fd358d6c86dd45e458",
                "38ee7b8cba5404dd84a25bf39cecb2ca900a79c42b262e556d64b1b59779057e"
            ],
            [
                "13464a57a78102aa62b6979ae817f4637ffcfed3c4b1ce30bcd6303f6caf666b",
                "69be159004614580ef7e433453ccb0ca48f300a81d0942e13f495a907f6ecc27"
            ],
            [
                "bc4a9df5b713fe2e9aef430bcc1dc97a0cd9ccede2f28588cada3a0d2d83f366",
                "d3a81ca6e785c06383937adf4b798caa6e8a9fbfa547b16d758d666581f33c1"
            ],
            [
                "8c28a97bf8298bc0d23d8c749452a32e694b65e30a9472a3954ab30fe5324caa",
                "40a30463a3305193378fedf31f7cc0eb7ae784f0451cb9459e71dc73cbef9482"
            ],
            [
                "8ea9666139527a8c1dd94ce4f071fd23c8b350c5a4bb33748c4ba111faccae0",
                "620efabbc8ee2782e24e7c0cfb95c5d735b783be9cf0f8e955af34a30e62b945"
            ],
            [
                "dd3625faef5ba06074669716bbd3788d89bdde815959968092f76cc4eb9a9787",
                "7a188fa3520e30d461da2501045731ca941461982883395937f68d00c644a573"
            ],
            [
                "f710d79d9eb962297e4f6232b40e8f7feb2bc63814614d692c12de752408221e",
                "ea98e67232d3b3295d3b535532115ccac8612c721851617526ae47a9c77bfc82"
            ]
        ]
    },
    naf: {
        wnd: 7,
        points: [
            [
                "f9308a019258c31049344f85f89d5229b531c845836f99b08601f113bce036f9",
                "388f7b0f632de8140fe337e62a37f3566500a99934c2231b6cb9fd7584b8e672"
            ],
            [
                "2f8bde4d1a07209355b4a7250a5c5128e88b84bddc619ab7cba8d569b240efe4",
                "d8ac222636e5e3d6d4dba9dda6c9c426f788271bab0d6840dca87d3aa6ac62d6"
            ],
            [
                "5cbdf0646e5db4eaa398f365f2ea7a0e3d419b7e0330e39ce92bddedcac4f9bc",
                "6aebca40ba255960a3178d6d861a54dba813d0b813fde7b5a5082628087264da"
            ],
            [
                "acd484e2f0c7f65309ad178a9f559abde09796974c57e714c35f110dfc27ccbe",
                "cc338921b0a7d9fd64380971763b61e9add888a4375f8e0f05cc262ac64f9c37"
            ],
            [
                "774ae7f858a9411e5ef4246b70c65aac5649980be5c17891bbec17895da008cb",
                "d984a032eb6b5e190243dd56d7b7b365372db1e2dff9d6a8301d74c9c953c61b"
            ],
            [
                "f28773c2d975288bc7d1d205c3748651b075fbc6610e58cddeeddf8f19405aa8",
                "ab0902e8d880a89758212eb65cdaf473a1a06da521fa91f29b5cb52db03ed81"
            ],
            [
                "d7924d4f7d43ea965a465ae3095ff41131e5946f3c85f79e44adbcf8e27e080e",
                "581e2872a86c72a683842ec228cc6defea40af2bd896d3a5c504dc9ff6a26b58"
            ],
            [
                "defdea4cdb677750a420fee807eacf21eb9898ae79b9768766e4faa04a2d4a34",
                "4211ab0694635168e997b0ead2a93daeced1f4a04a95c0f6cfb199f69e56eb77"
            ],
            [
                "2b4ea0a797a443d293ef5cff444f4979f06acfebd7e86d277475656138385b6c",
                "85e89bc037945d93b343083b5a1c86131a01f60c50269763b570c854e5c09b7a"
            ],
            [
                "352bbf4a4cdd12564f93fa332ce333301d9ad40271f8107181340aef25be59d5",
                "321eb4075348f534d59c18259dda3e1f4a1b3b2e71b1039c67bd3d8bcf81998c"
            ],
            [
                "2fa2104d6b38d11b0230010559879124e42ab8dfeff5ff29dc9cdadd4ecacc3f",
                "2de1068295dd865b64569335bd5dd80181d70ecfc882648423ba76b532b7d67"
            ],
            [
                "9248279b09b4d68dab21a9b066edda83263c3d84e09572e269ca0cd7f5453714",
                "73016f7bf234aade5d1aa71bdea2b1ff3fc0de2a887912ffe54a32ce97cb3402"
            ],
            [
                "daed4f2be3a8bf278e70132fb0beb7522f570e144bf615c07e996d443dee8729",
                "a69dce4a7d6c98e8d4a1aca87ef8d7003f83c230f3afa726ab40e52290be1c55"
            ],
            [
                "c44d12c7065d812e8acf28d7cbb19f9011ecd9e9fdf281b0e6a3b5e87d22e7db",
                "2119a460ce326cdc76c45926c982fdac0e106e861edf61c5a039063f0e0e6482"
            ],
            [
                "6a245bf6dc698504c89a20cfded60853152b695336c28063b61c65cbd269e6b4",
                "e022cf42c2bd4a708b3f5126f16a24ad8b33ba48d0423b6efd5e6348100d8a82"
            ],
            [
                "1697ffa6fd9de627c077e3d2fe541084ce13300b0bec1146f95ae57f0d0bd6a5",
                "b9c398f186806f5d27561506e4557433a2cf15009e498ae7adee9d63d01b2396"
            ],
            [
                "605bdb019981718b986d0f07e834cb0d9deb8360ffb7f61df982345ef27a7479",
                "2972d2de4f8d20681a78d93ec96fe23c26bfae84fb14db43b01e1e9056b8c49"
            ],
            [
                "62d14dab4150bf497402fdc45a215e10dcb01c354959b10cfe31c7e9d87ff33d",
                "80fc06bd8cc5b01098088a1950eed0db01aa132967ab472235f5642483b25eaf"
            ],
            [
                "80c60ad0040f27dade5b4b06c408e56b2c50e9f56b9b8b425e555c2f86308b6f",
                "1c38303f1cc5c30f26e66bad7fe72f70a65eed4cbe7024eb1aa01f56430bd57a"
            ],
            [
                "7a9375ad6167ad54aa74c6348cc54d344cc5dc9487d847049d5eabb0fa03c8fb",
                "d0e3fa9eca8726909559e0d79269046bdc59ea10c70ce2b02d499ec224dc7f7"
            ],
            [
                "d528ecd9b696b54c907a9ed045447a79bb408ec39b68df504bb51f459bc3ffc9",
                "eecf41253136e5f99966f21881fd656ebc4345405c520dbc063465b521409933"
            ],
            [
                "49370a4b5f43412ea25f514e8ecdad05266115e4a7ecb1387231808f8b45963",
                "758f3f41afd6ed428b3081b0512fd62a54c3f3afbb5b6764b653052a12949c9a"
            ],
            [
                "77f230936ee88cbbd73df930d64702ef881d811e0e1498e2f1c13eb1fc345d74",
                "958ef42a7886b6400a08266e9ba1b37896c95330d97077cbbe8eb3c7671c60d6"
            ],
            [
                "f2dac991cc4ce4b9ea44887e5c7c0bce58c80074ab9d4dbaeb28531b7739f530",
                "e0dedc9b3b2f8dad4da1f32dec2531df9eb5fbeb0598e4fd1a117dba703a3c37"
            ],
            [
                "463b3d9f662621fb1b4be8fbbe2520125a216cdfc9dae3debcba4850c690d45b",
                "5ed430d78c296c3543114306dd8622d7c622e27c970a1de31cb377b01af7307e"
            ],
            [
                "f16f804244e46e2a09232d4aff3b59976b98fac14328a2d1a32496b49998f247",
                "cedabd9b82203f7e13d206fcdf4e33d92a6c53c26e5cce26d6579962c4e31df6"
            ],
            [
                "caf754272dc84563b0352b7a14311af55d245315ace27c65369e15f7151d41d1",
                "cb474660ef35f5f2a41b643fa5e460575f4fa9b7962232a5c32f908318a04476"
            ],
            [
                "2600ca4b282cb986f85d0f1709979d8b44a09c07cb86d7c124497bc86f082120",
                "4119b88753c15bd6a693b03fcddbb45d5ac6be74ab5f0ef44b0be9475a7e4b40"
            ],
            [
                "7635ca72d7e8432c338ec53cd12220bc01c48685e24f7dc8c602a7746998e435",
                "91b649609489d613d1d5e590f78e6d74ecfc061d57048bad9e76f302c5b9c61"
            ],
            [
                "754e3239f325570cdbbf4a87deee8a66b7f2b33479d468fbc1a50743bf56cc18",
                "673fb86e5bda30fb3cd0ed304ea49a023ee33d0197a695d0c5d98093c536683"
            ],
            [
                "e3e6bd1071a1e96aff57859c82d570f0330800661d1c952f9fe2694691d9b9e8",
                "59c9e0bba394e76f40c0aa58379a3cb6a5a2283993e90c4167002af4920e37f5"
            ],
            [
                "186b483d056a033826ae73d88f732985c4ccb1f32ba35f4b4cc47fdcf04aa6eb",
                "3b952d32c67cf77e2e17446e204180ab21fb8090895138b4a4a797f86e80888b"
            ],
            [
                "df9d70a6b9876ce544c98561f4be4f725442e6d2b737d9c91a8321724ce0963f",
                "55eb2dafd84d6ccd5f862b785dc39d4ab157222720ef9da217b8c45cf2ba2417"
            ],
            [
                "5edd5cc23c51e87a497ca815d5dce0f8ab52554f849ed8995de64c5f34ce7143",
                "efae9c8dbc14130661e8cec030c89ad0c13c66c0d17a2905cdc706ab7399a868"
            ],
            [
                "290798c2b6476830da12fe02287e9e777aa3fba1c355b17a722d362f84614fba",
                "e38da76dcd440621988d00bcf79af25d5b29c094db2a23146d003afd41943e7a"
            ],
            [
                "af3c423a95d9f5b3054754efa150ac39cd29552fe360257362dfdecef4053b45",
                "f98a3fd831eb2b749a93b0e6f35cfb40c8cd5aa667a15581bc2feded498fd9c6"
            ],
            [
                "766dbb24d134e745cccaa28c99bf274906bb66b26dcf98df8d2fed50d884249a",
                "744b1152eacbe5e38dcc887980da38b897584a65fa06cedd2c924f97cbac5996"
            ],
            [
                "59dbf46f8c94759ba21277c33784f41645f7b44f6c596a58ce92e666191abe3e",
                "c534ad44175fbc300f4ea6ce648309a042ce739a7919798cd85e216c4a307f6e"
            ],
            [
                "f13ada95103c4537305e691e74e9a4a8dd647e711a95e73cb62dc6018cfd87b8",
                "e13817b44ee14de663bf4bc808341f326949e21a6a75c2570778419bdaf5733d"
            ],
            [
                "7754b4fa0e8aced06d4167a2c59cca4cda1869c06ebadfb6488550015a88522c",
                "30e93e864e669d82224b967c3020b8fa8d1e4e350b6cbcc537a48b57841163a2"
            ],
            [
                "948dcadf5990e048aa3874d46abef9d701858f95de8041d2a6828c99e2262519",
                "e491a42537f6e597d5d28a3224b1bc25df9154efbd2ef1d2cbba2cae5347d57e"
            ],
            [
                "7962414450c76c1689c7b48f8202ec37fb224cf5ac0bfa1570328a8a3d7c77ab",
                "100b610ec4ffb4760d5c1fc133ef6f6b12507a051f04ac5760afa5b29db83437"
            ],
            [
                "3514087834964b54b15b160644d915485a16977225b8847bb0dd085137ec47ca",
                "ef0afbb2056205448e1652c48e8127fc6039e77c15c2378b7e7d15a0de293311"
            ],
            [
                "d3cc30ad6b483e4bc79ce2c9dd8bc54993e947eb8df787b442943d3f7b527eaf",
                "8b378a22d827278d89c5e9be8f9508ae3c2ad46290358630afb34db04eede0a4"
            ],
            [
                "1624d84780732860ce1c78fcbfefe08b2b29823db913f6493975ba0ff4847610",
                "68651cf9b6da903e0914448c6cd9d4ca896878f5282be4c8cc06e2a404078575"
            ],
            [
                "733ce80da955a8a26902c95633e62a985192474b5af207da6df7b4fd5fc61cd4",
                "f5435a2bd2badf7d485a4d8b8db9fcce3e1ef8e0201e4578c54673bc1dc5ea1d"
            ],
            [
                "15d9441254945064cf1a1c33bbd3b49f8966c5092171e699ef258dfab81c045c",
                "d56eb30b69463e7234f5137b73b84177434800bacebfc685fc37bbe9efe4070d"
            ],
            [
                "a1d0fcf2ec9de675b612136e5ce70d271c21417c9d2b8aaaac138599d0717940",
                "edd77f50bcb5a3cab2e90737309667f2641462a54070f3d519212d39c197a629"
            ],
            [
                "e22fbe15c0af8ccc5780c0735f84dbe9a790badee8245c06c7ca37331cb36980",
                "a855babad5cd60c88b430a69f53a1a7a38289154964799be43d06d77d31da06"
            ],
            [
                "311091dd9860e8e20ee13473c1155f5f69635e394704eaa74009452246cfa9b3",
                "66db656f87d1f04fffd1f04788c06830871ec5a64feee685bd80f0b1286d8374"
            ],
            [
                "34c1fd04d301be89b31c0442d3e6ac24883928b45a9340781867d4232ec2dbdf",
                "9414685e97b1b5954bd46f730174136d57f1ceeb487443dc5321857ba73abee"
            ],
            [
                "f219ea5d6b54701c1c14de5b557eb42a8d13f3abbcd08affcc2a5e6b049b8d63",
                "4cb95957e83d40b0f73af4544cccf6b1f4b08d3c07b27fb8d8c2962a400766d1"
            ],
            [
                "d7b8740f74a8fbaab1f683db8f45de26543a5490bca627087236912469a0b448",
                "fa77968128d9c92ee1010f337ad4717eff15db5ed3c049b3411e0315eaa4593b"
            ],
            [
                "32d31c222f8f6f0ef86f7c98d3a3335ead5bcd32abdd94289fe4d3091aa824bf",
                "5f3032f5892156e39ccd3d7915b9e1da2e6dac9e6f26e961118d14b8462e1661"
            ],
            [
                "7461f371914ab32671045a155d9831ea8793d77cd59592c4340f86cbc18347b5",
                "8ec0ba238b96bec0cbdddcae0aa442542eee1ff50c986ea6b39847b3cc092ff6"
            ],
            [
                "ee079adb1df1860074356a25aa38206a6d716b2c3e67453d287698bad7b2b2d6",
                "8dc2412aafe3be5c4c5f37e0ecc5f9f6a446989af04c4e25ebaac479ec1c8c1e"
            ],
            [
                "16ec93e447ec83f0467b18302ee620f7e65de331874c9dc72bfd8616ba9da6b5",
                "5e4631150e62fb40d0e8c2a7ca5804a39d58186a50e497139626778e25b0674d"
            ],
            [
                "eaa5f980c245f6f038978290afa70b6bd8855897f98b6aa485b96065d537bd99",
                "f65f5d3e292c2e0819a528391c994624d784869d7e6ea67fb18041024edc07dc"
            ],
            [
                "78c9407544ac132692ee1910a02439958ae04877151342ea96c4b6b35a49f51",
                "f3e0319169eb9b85d5404795539a5e68fa1fbd583c064d2462b675f194a3ddb4"
            ],
            [
                "494f4be219a1a77016dcd838431aea0001cdc8ae7a6fc688726578d9702857a5",
                "42242a969283a5f339ba7f075e36ba2af925ce30d767ed6e55f4b031880d562c"
            ],
            [
                "a598a8030da6d86c6bc7f2f5144ea549d28211ea58faa70ebf4c1e665c1fe9b5",
                "204b5d6f84822c307e4b4a7140737aec23fc63b65b35f86a10026dbd2d864e6b"
            ],
            [
                "c41916365abb2b5d09192f5f2dbeafec208f020f12570a184dbadc3e58595997",
                "4f14351d0087efa49d245b328984989d5caf9450f34bfc0ed16e96b58fa9913"
            ],
            [
                "841d6063a586fa475a724604da03bc5b92a2e0d2e0a36acfe4c73a5514742881",
                "73867f59c0659e81904f9a1c7543698e62562d6744c169ce7a36de01a8d6154"
            ],
            [
                "5e95bb399a6971d376026947f89bde2f282b33810928be4ded112ac4d70e20d5",
                "39f23f366809085beebfc71181313775a99c9aed7d8ba38b161384c746012865"
            ],
            [
                "36e4641a53948fd476c39f8a99fd974e5ec07564b5315d8bf99471bca0ef2f66",
                "d2424b1b1abe4eb8164227b085c9aa9456ea13493fd563e06fd51cf5694c78fc"
            ],
            [
                "336581ea7bfbbb290c191a2f507a41cf5643842170e914faeab27c2c579f726",
                "ead12168595fe1be99252129b6e56b3391f7ab1410cd1e0ef3dcdcabd2fda224"
            ],
            [
                "8ab89816dadfd6b6a1f2634fcf00ec8403781025ed6890c4849742706bd43ede",
                "6fdcef09f2f6d0a044e654aef624136f503d459c3e89845858a47a9129cdd24e"
            ],
            [
                "1e33f1a746c9c5778133344d9299fcaa20b0938e8acff2544bb40284b8c5fb94",
                "60660257dd11b3aa9c8ed618d24edff2306d320f1d03010e33a7d2057f3b3b6"
            ],
            [
                "85b7c1dcb3cec1b7ee7f30ded79dd20a0ed1f4cc18cbcfcfa410361fd8f08f31",
                "3d98a9cdd026dd43f39048f25a8847f4fcafad1895d7a633c6fed3c35e999511"
            ],
            [
                "29df9fbd8d9e46509275f4b125d6d45d7fbe9a3b878a7af872a2800661ac5f51",
                "b4c4fe99c775a606e2d8862179139ffda61dc861c019e55cd2876eb2a27d84b"
            ],
            [
                "a0b1cae06b0a847a3fea6e671aaf8adfdfe58ca2f768105c8082b2e449fce252",
                "ae434102edde0958ec4b19d917a6a28e6b72da1834aff0e650f049503a296cf2"
            ],
            [
                "4e8ceafb9b3e9a136dc7ff67e840295b499dfb3b2133e4ba113f2e4c0e121e5",
                "cf2174118c8b6d7a4b48f6d534ce5c79422c086a63460502b827ce62a326683c"
            ],
            [
                "d24a44e047e19b6f5afb81c7ca2f69080a5076689a010919f42725c2b789a33b",
                "6fb8d5591b466f8fc63db50f1c0f1c69013f996887b8244d2cdec417afea8fa3"
            ],
            [
                "ea01606a7a6c9cdd249fdfcfacb99584001edd28abbab77b5104e98e8e3b35d4",
                "322af4908c7312b0cfbfe369f7a7b3cdb7d4494bc2823700cfd652188a3ea98d"
            ],
            [
                "af8addbf2b661c8a6c6328655eb96651252007d8c5ea31be4ad196de8ce2131f",
                "6749e67c029b85f52a034eafd096836b2520818680e26ac8f3dfbcdb71749700"
            ],
            [
                "e3ae1974566ca06cc516d47e0fb165a674a3dabcfca15e722f0e3450f45889",
                "2aeabe7e4531510116217f07bf4d07300de97e4874f81f533420a72eeb0bd6a4"
            ],
            [
                "591ee355313d99721cf6993ffed1e3e301993ff3ed258802075ea8ced397e246",
                "b0ea558a113c30bea60fc4775460c7901ff0b053d25ca2bdeee98f1a4be5d196"
            ],
            [
                "11396d55fda54c49f19aa97318d8da61fa8584e47b084945077cf03255b52984",
                "998c74a8cd45ac01289d5833a7beb4744ff536b01b257be4c5767bea93ea57a4"
            ],
            [
                "3c5d2a1ba39c5a1790000738c9e0c40b8dcdfd5468754b6405540157e017aa7a",
                "b2284279995a34e2f9d4de7396fc18b80f9b8b9fdd270f6661f79ca4c81bd257"
            ],
            [
                "cc8704b8a60a0defa3a99a7299f2e9c3fbc395afb04ac078425ef8a1793cc030",
                "bdd46039feed17881d1e0862db347f8cf395b74fc4bcdc4e940b74e3ac1f1b13"
            ],
            [
                "c533e4f7ea8555aacd9777ac5cad29b97dd4defccc53ee7ea204119b2889b197",
                "6f0a256bc5efdf429a2fb6242f1a43a2d9b925bb4a4b3a26bb8e0f45eb596096"
            ],
            [
                "c14f8f2ccb27d6f109f6d08d03cc96a69ba8c34eec07bbcf566d48e33da6593",
                "c359d6923bb398f7fd4473e16fe1c28475b740dd098075e6c0e8649113dc3a38"
            ],
            [
                "a6cbc3046bc6a450bac24789fa17115a4c9739ed75f8f21ce441f72e0b90e6ef",
                "21ae7f4680e889bb130619e2c0f95a360ceb573c70603139862afd617fa9b9f"
            ],
            [
                "347d6d9a02c48927ebfb86c1359b1caf130a3c0267d11ce6344b39f99d43cc38",
                "60ea7f61a353524d1c987f6ecec92f086d565ab687870cb12689ff1e31c74448"
            ],
            [
                "da6545d2181db8d983f7dcb375ef5866d47c67b1bf31c8cf855ef7437b72656a",
                "49b96715ab6878a79e78f07ce5680c5d6673051b4935bd897fea824b77dc208a"
            ],
            [
                "c40747cc9d012cb1a13b8148309c6de7ec25d6945d657146b9d5994b8feb1111",
                "5ca560753be2a12fc6de6caf2cb489565db936156b9514e1bb5e83037e0fa2d4"
            ],
            [
                "4e42c8ec82c99798ccf3a610be870e78338c7f713348bd34c8203ef4037f3502",
                "7571d74ee5e0fb92a7a8b33a07783341a5492144cc54bcc40a94473693606437"
            ],
            [
                "3775ab7089bc6af823aba2e1af70b236d251cadb0c86743287522a1b3b0dedea",
                "be52d107bcfa09d8bcb9736a828cfa7fac8db17bf7a76a2c42ad961409018cf7"
            ],
            [
                "cee31cbf7e34ec379d94fb814d3d775ad954595d1314ba8846959e3e82f74e26",
                "8fd64a14c06b589c26b947ae2bcf6bfa0149ef0be14ed4d80f448a01c43b1c6d"
            ],
            [
                "b4f9eaea09b6917619f6ea6a4eb5464efddb58fd45b1ebefcdc1a01d08b47986",
                "39e5c9925b5a54b07433a4f18c61726f8bb131c012ca542eb24a8ac07200682a"
            ],
            [
                "d4263dfc3d2df923a0179a48966d30ce84e2515afc3dccc1b77907792ebcc60e",
                "62dfaf07a0f78feb30e30d6295853ce189e127760ad6cf7fae164e122a208d54"
            ],
            [
                "48457524820fa65a4f8d35eb6930857c0032acc0a4a2de422233eeda897612c4",
                "25a748ab367979d98733c38a1fa1c2e7dc6cc07db2d60a9ae7a76aaa49bd0f77"
            ],
            [
                "dfeeef1881101f2cb11644f3a2afdfc2045e19919152923f367a1767c11cceda",
                "ecfb7056cf1de042f9420bab396793c0c390bde74b4bbdff16a83ae09a9a7517"
            ],
            [
                "6d7ef6b17543f8373c573f44e1f389835d89bcbc6062ced36c82df83b8fae859",
                "cd450ec335438986dfefa10c57fea9bcc521a0959b2d80bbf74b190dca712d10"
            ],
            [
                "e75605d59102a5a2684500d3b991f2e3f3c88b93225547035af25af66e04541f",
                "f5c54754a8f71ee540b9b48728473e314f729ac5308b06938360990e2bfad125"
            ],
            [
                "eb98660f4c4dfaa06a2be453d5020bc99a0c2e60abe388457dd43fefb1ed620c",
                "6cb9a8876d9cb8520609af3add26cd20a0a7cd8a9411131ce85f44100099223e"
            ],
            [
                "13e87b027d8514d35939f2e6892b19922154596941888336dc3563e3b8dba942",
                "fef5a3c68059a6dec5d624114bf1e91aac2b9da568d6abeb2570d55646b8adf1"
            ],
            [
                "ee163026e9fd6fe017c38f06a5be6fc125424b371ce2708e7bf4491691e5764a",
                "1acb250f255dd61c43d94ccc670d0f58f49ae3fa15b96623e5430da0ad6c62b2"
            ],
            [
                "b268f5ef9ad51e4d78de3a750c2dc89b1e626d43505867999932e5db33af3d80",
                "5f310d4b3c99b9ebb19f77d41c1dee018cf0d34fd4191614003e945a1216e423"
            ],
            [
                "ff07f3118a9df035e9fad85eb6c7bfe42b02f01ca99ceea3bf7ffdba93c4750d",
                "438136d603e858a3a5c440c38eccbaddc1d2942114e2eddd4740d098ced1f0d8"
            ],
            [
                "8d8b9855c7c052a34146fd20ffb658bea4b9f69e0d825ebec16e8c3ce2b526a1",
                "cdb559eedc2d79f926baf44fb84ea4d44bcf50fee51d7ceb30e2e7f463036758"
            ],
            [
                "52db0b5384dfbf05bfa9d472d7ae26dfe4b851ceca91b1eba54263180da32b63",
                "c3b997d050ee5d423ebaf66a6db9f57b3180c902875679de924b69d84a7b375"
            ],
            [
                "e62f9490d3d51da6395efd24e80919cc7d0f29c3f3fa48c6fff543becbd43352",
                "6d89ad7ba4876b0b22c2ca280c682862f342c8591f1daf5170e07bfd9ccafa7d"
            ],
            [
                "7f30ea2476b399b4957509c88f77d0191afa2ff5cb7b14fd6d8e7d65aaab1193",
                "ca5ef7d4b231c94c3b15389a5f6311e9daff7bb67b103e9880ef4bff637acaec"
            ],
            [
                "5098ff1e1d9f14fb46a210fada6c903fef0fb7b4a1dd1d9ac60a0361800b7a00",
                "9731141d81fc8f8084d37c6e7542006b3ee1b40d60dfe5362a5b132fd17ddc0"
            ],
            [
                "32b78c7de9ee512a72895be6b9cbefa6e2f3c4ccce445c96b9f2c81e2778ad58",
                "ee1849f513df71e32efc3896ee28260c73bb80547ae2275ba497237794c8753c"
            ],
            [
                "e2cb74fddc8e9fbcd076eef2a7c72b0ce37d50f08269dfc074b581550547a4f7",
                "d3aa2ed71c9dd2247a62df062736eb0baddea9e36122d2be8641abcb005cc4a4"
            ],
            [
                "8438447566d4d7bedadc299496ab357426009a35f235cb141be0d99cd10ae3a8",
                "c4e1020916980a4da5d01ac5e6ad330734ef0d7906631c4f2390426b2edd791f"
            ],
            [
                "4162d488b89402039b584c6fc6c308870587d9c46f660b878ab65c82c711d67e",
                "67163e903236289f776f22c25fb8a3afc1732f2b84b4e95dbda47ae5a0852649"
            ],
            [
                "3fad3fa84caf0f34f0f89bfd2dcf54fc175d767aec3e50684f3ba4a4bf5f683d",
                "cd1bc7cb6cc407bb2f0ca647c718a730cf71872e7d0d2a53fa20efcdfe61826"
            ],
            [
                "674f2600a3007a00568c1a7ce05d0816c1fb84bf1370798f1c69532faeb1a86b",
                "299d21f9413f33b3edf43b257004580b70db57da0b182259e09eecc69e0d38a5"
            ],
            [
                "d32f4da54ade74abb81b815ad1fb3b263d82d6c692714bcff87d29bd5ee9f08f",
                "f9429e738b8e53b968e99016c059707782e14f4535359d582fc416910b3eea87"
            ],
            [
                "30e4e670435385556e593657135845d36fbb6931f72b08cb1ed954f1e3ce3ff6",
                "462f9bce619898638499350113bbc9b10a878d35da70740dc695a559eb88db7b"
            ],
            [
                "be2062003c51cc3004682904330e4dee7f3dcd10b01e580bf1971b04d4cad297",
                "62188bc49d61e5428573d48a74e1c655b1c61090905682a0d5558ed72dccb9bc"
            ],
            [
                "93144423ace3451ed29e0fb9ac2af211cb6e84a601df5993c419859fff5df04a",
                "7c10dfb164c3425f5c71a3f9d7992038f1065224f72bb9d1d902a6d13037b47c"
            ],
            [
                "b015f8044f5fcbdcf21ca26d6c34fb8197829205c7b7d2a7cb66418c157b112c",
                "ab8c1e086d04e813744a655b2df8d5f83b3cdc6faa3088c1d3aea1454e3a1d5f"
            ],
            [
                "d5e9e1da649d97d89e4868117a465a3a4f8a18de57a140d36b3f2af341a21b52",
                "4cb04437f391ed73111a13cc1d4dd0db1693465c2240480d8955e8592f27447a"
            ],
            [
                "d3ae41047dd7ca065dbf8ed77b992439983005cd72e16d6f996a5316d36966bb",
                "bd1aeb21ad22ebb22a10f0303417c6d964f8cdd7df0aca614b10dc14d125ac46"
            ],
            [
                "463e2763d885f958fc66cdd22800f0a487197d0a82e377b49f80af87c897b065",
                "bfefacdb0e5d0fd7df3a311a94de062b26b80c61fbc97508b79992671ef7ca7f"
            ],
            [
                "7985fdfd127c0567c6f53ec1bb63ec3158e597c40bfe747c83cddfc910641917",
                "603c12daf3d9862ef2b25fe1de289aed24ed291e0ec6708703a5bd567f32ed03"
            ],
            [
                "74a1ad6b5f76e39db2dd249410eac7f99e74c59cb83d2d0ed5ff1543da7703e9",
                "cc6157ef18c9c63cd6193d83631bbea0093e0968942e8c33d5737fd790e0db08"
            ],
            [
                "30682a50703375f602d416664ba19b7fc9bab42c72747463a71d0896b22f6da3",
                "553e04f6b018b4fa6c8f39e7f311d3176290d0e0f19ca73f17714d9977a22ff8"
            ],
            [
                "9e2158f0d7c0d5f26c3791efefa79597654e7a2b2464f52b1ee6c1347769ef57",
                "712fcdd1b9053f09003a3481fa7762e9ffd7c8ef35a38509e2fbf2629008373"
            ],
            [
                "176e26989a43c9cfeba4029c202538c28172e566e3c4fce7322857f3be327d66",
                "ed8cc9d04b29eb877d270b4878dc43c19aefd31f4eee09ee7b47834c1fa4b1c3"
            ],
            [
                "75d46efea3771e6e68abb89a13ad747ecf1892393dfc4f1b7004788c50374da8",
                "9852390a99507679fd0b86fd2b39a868d7efc22151346e1a3ca4726586a6bed8"
            ],
            [
                "809a20c67d64900ffb698c4c825f6d5f2310fb0451c869345b7319f645605721",
                "9e994980d9917e22b76b061927fa04143d096ccc54963e6a5ebfa5f3f8e286c1"
            ],
            [
                "1b38903a43f7f114ed4500b4eac7083fdefece1cf29c63528d563446f972c180",
                "4036edc931a60ae889353f77fd53de4a2708b26b6f5da72ad3394119daf408f9"
            ]
        ]
    }
};

},{}],"6GXut":[function(require,module,exports) {
"use strict";
var BN = require("2e69183faf5285a1");
var HmacDRBG = require("b0cb641292e4911d");
var utils = require("eab3e45147b180ba");
var curves = require("a5ce61d26ce01c4c");
var rand = require("f6342f89ac472937");
var assert = utils.assert;
var KeyPair = require("eb5ba559e423f6e9");
var Signature = require("7c5e2c76c574ce41");
function EC(options) {
    if (!(this instanceof EC)) return new EC(options);
    // Shortcut `elliptic.ec(curve-name)`
    if (typeof options === "string") {
        assert(Object.prototype.hasOwnProperty.call(curves, options), "Unknown curve " + options);
        options = curves[options];
    }
    // Shortcut for `elliptic.ec(elliptic.curves.curveName)`
    if (options instanceof curves.PresetCurve) options = {
        curve: options
    };
    this.curve = options.curve.curve;
    this.n = this.curve.n;
    this.nh = this.n.ushrn(1);
    this.g = this.curve.g;
    // Point on curve
    this.g = options.curve.g;
    this.g.precompute(options.curve.n.bitLength() + 1);
    // Hash for function for DRBG
    this.hash = options.hash || options.curve.hash;
}
module.exports = EC;
EC.prototype.keyPair = function keyPair(options) {
    return new KeyPair(this, options);
};
EC.prototype.keyFromPrivate = function keyFromPrivate(priv, enc) {
    return KeyPair.fromPrivate(this, priv, enc);
};
EC.prototype.keyFromPublic = function keyFromPublic(pub, enc) {
    return KeyPair.fromPublic(this, pub, enc);
};
EC.prototype.genKeyPair = function genKeyPair(options) {
    if (!options) options = {};
    // Instantiate Hmac_DRBG
    var drbg = new HmacDRBG({
        hash: this.hash,
        pers: options.pers,
        persEnc: options.persEnc || "utf8",
        entropy: options.entropy || rand(this.hash.hmacStrength),
        entropyEnc: options.entropy && options.entropyEnc || "utf8",
        nonce: this.n.toArray()
    });
    var bytes = this.n.byteLength();
    var ns2 = this.n.sub(new BN(2));
    for(;;){
        var priv = new BN(drbg.generate(bytes));
        if (priv.cmp(ns2) > 0) continue;
        priv.iaddn(1);
        return this.keyFromPrivate(priv);
    }
};
EC.prototype._truncateToN = function _truncateToN(msg, truncOnly) {
    var delta = msg.byteLength() * 8 - this.n.bitLength();
    if (delta > 0) msg = msg.ushrn(delta);
    if (!truncOnly && msg.cmp(this.n) >= 0) return msg.sub(this.n);
    else return msg;
};
EC.prototype.sign = function sign(msg, key, enc, options) {
    if (typeof enc === "object") {
        options = enc;
        enc = null;
    }
    if (!options) options = {};
    key = this.keyFromPrivate(key, enc);
    msg = this._truncateToN(new BN(msg, 16));
    // Zero-extend key to provide enough entropy
    var bytes = this.n.byteLength();
    var bkey = key.getPrivate().toArray("be", bytes);
    // Zero-extend nonce to have the same byte size as N
    var nonce = msg.toArray("be", bytes);
    // Instantiate Hmac_DRBG
    var drbg = new HmacDRBG({
        hash: this.hash,
        entropy: bkey,
        nonce: nonce,
        pers: options.pers,
        persEnc: options.persEnc || "utf8"
    });
    // Number of bytes to generate
    var ns1 = this.n.sub(new BN(1));
    for(var iter = 0;; iter++){
        var k = options.k ? options.k(iter) : new BN(drbg.generate(this.n.byteLength()));
        k = this._truncateToN(k, true);
        if (k.cmpn(1) <= 0 || k.cmp(ns1) >= 0) continue;
        var kp = this.g.mul(k);
        if (kp.isInfinity()) continue;
        var kpX = kp.getX();
        var r = kpX.umod(this.n);
        if (r.cmpn(0) === 0) continue;
        var s = k.invm(this.n).mul(r.mul(key.getPrivate()).iadd(msg));
        s = s.umod(this.n);
        if (s.cmpn(0) === 0) continue;
        var recoveryParam = (kp.getY().isOdd() ? 1 : 0) | (kpX.cmp(r) !== 0 ? 2 : 0);
        // Use complement of `s`, if it is > `n / 2`
        if (options.canonical && s.cmp(this.nh) > 0) {
            s = this.n.sub(s);
            recoveryParam ^= 1;
        }
        return new Signature({
            r: r,
            s: s,
            recoveryParam: recoveryParam
        });
    }
};
EC.prototype.verify = function verify(msg, signature, key, enc) {
    msg = this._truncateToN(new BN(msg, 16));
    key = this.keyFromPublic(key, enc);
    signature = new Signature(signature, "hex");
    // Perform primitive values validation
    var r = signature.r;
    var s = signature.s;
    if (r.cmpn(1) < 0 || r.cmp(this.n) >= 0) return false;
    if (s.cmpn(1) < 0 || s.cmp(this.n) >= 0) return false;
    // Validate signature
    var sinv = s.invm(this.n);
    var u1 = sinv.mul(msg).umod(this.n);
    var u2 = sinv.mul(r).umod(this.n);
    var p;
    if (!this.curve._maxwellTrick) {
        p = this.g.mulAdd(u1, key.getPublic(), u2);
        if (p.isInfinity()) return false;
        return p.getX().umod(this.n).cmp(r) === 0;
    }
    // NOTE: Greg Maxwell's trick, inspired by:
    // https://git.io/vad3K
    p = this.g.jmulAdd(u1, key.getPublic(), u2);
    if (p.isInfinity()) return false;
    // Compare `p.x` of Jacobian point with `r`,
    // this will do `p.x == r * p.z^2` instead of multiplying `p.x` by the
    // inverse of `p.z^2`
    return p.eqXToP(r);
};
EC.prototype.recoverPubKey = function(msg, signature, j, enc) {
    assert((3 & j) === j, "The recovery param is more than two bits");
    signature = new Signature(signature, enc);
    var n = this.n;
    var e = new BN(msg);
    var r = signature.r;
    var s = signature.s;
    // A set LSB signifies that the y-coordinate is odd
    var isYOdd = j & 1;
    var isSecondKey = j >> 1;
    if (r.cmp(this.curve.p.umod(this.curve.n)) >= 0 && isSecondKey) throw new Error("Unable to find sencond key candinate");
    // 1.1. Let x = r + jn.
    if (isSecondKey) r = this.curve.pointFromX(r.add(this.curve.n), isYOdd);
    else r = this.curve.pointFromX(r, isYOdd);
    var rInv = signature.r.invm(n);
    var s1 = n.sub(e).mul(rInv).umod(n);
    var s2 = s.mul(rInv).umod(n);
    // 1.6.1 Compute Q = r^-1 (sR -  eG)
    //               Q = r^-1 (sR + -eG)
    return this.g.mulAdd(s1, r, s2);
};
EC.prototype.getKeyRecoveryParam = function(e, signature, Q, enc) {
    signature = new Signature(signature, enc);
    if (signature.recoveryParam !== null) return signature.recoveryParam;
    for(var i = 0; i < 4; i++){
        var Qprime;
        try {
            Qprime = this.recoverPubKey(e, signature, i);
        } catch (e) {
            continue;
        }
        if (Qprime.eq(Q)) return i;
    }
    throw new Error("Unable to find valid recovery factor");
};

},{"2e69183faf5285a1":"kRh32","b0cb641292e4911d":"alGiF","eab3e45147b180ba":"7PLUP","a5ce61d26ce01c4c":"ab7Cj","f6342f89ac472937":"dzcfb","eb5ba559e423f6e9":"jG59z","7c5e2c76c574ce41":"59s4p"}],"alGiF":[function(require,module,exports) {
"use strict";
var hash = require("629972fec592198f");
var utils = require("c20531edfb274a2c");
var assert = require("43ff1863ab3fce20");
function HmacDRBG(options) {
    if (!(this instanceof HmacDRBG)) return new HmacDRBG(options);
    this.hash = options.hash;
    this.predResist = !!options.predResist;
    this.outLen = this.hash.outSize;
    this.minEntropy = options.minEntropy || this.hash.hmacStrength;
    this._reseed = null;
    this.reseedInterval = null;
    this.K = null;
    this.V = null;
    var entropy = utils.toArray(options.entropy, options.entropyEnc || "hex");
    var nonce = utils.toArray(options.nonce, options.nonceEnc || "hex");
    var pers = utils.toArray(options.pers, options.persEnc || "hex");
    assert(entropy.length >= this.minEntropy / 8, "Not enough entropy. Minimum is: " + this.minEntropy + " bits");
    this._init(entropy, nonce, pers);
}
module.exports = HmacDRBG;
HmacDRBG.prototype._init = function init(entropy, nonce, pers) {
    var seed = entropy.concat(nonce).concat(pers);
    this.K = new Array(this.outLen / 8);
    this.V = new Array(this.outLen / 8);
    for(var i = 0; i < this.V.length; i++){
        this.K[i] = 0x00;
        this.V[i] = 0x01;
    }
    this._update(seed);
    this._reseed = 1;
    this.reseedInterval = 0x1000000000000; // 2^48
};
HmacDRBG.prototype._hmac = function hmac() {
    return new hash.hmac(this.hash, this.K);
};
HmacDRBG.prototype._update = function update(seed) {
    var kmac = this._hmac().update(this.V).update([
        0x00
    ]);
    if (seed) kmac = kmac.update(seed);
    this.K = kmac.digest();
    this.V = this._hmac().update(this.V).digest();
    if (!seed) return;
    this.K = this._hmac().update(this.V).update([
        0x01
    ]).update(seed).digest();
    this.V = this._hmac().update(this.V).digest();
};
HmacDRBG.prototype.reseed = function reseed(entropy, entropyEnc, add, addEnc) {
    // Optional entropy enc
    if (typeof entropyEnc !== "string") {
        addEnc = add;
        add = entropyEnc;
        entropyEnc = null;
    }
    entropy = utils.toArray(entropy, entropyEnc);
    add = utils.toArray(add, addEnc);
    assert(entropy.length >= this.minEntropy / 8, "Not enough entropy. Minimum is: " + this.minEntropy + " bits");
    this._update(entropy.concat(add || []));
    this._reseed = 1;
};
HmacDRBG.prototype.generate = function generate(len, enc, add, addEnc) {
    if (this._reseed > this.reseedInterval) throw new Error("Reseed is required");
    // Optional encoding
    if (typeof enc !== "string") {
        addEnc = add;
        add = enc;
        enc = null;
    }
    // Optional additional data
    if (add) {
        add = utils.toArray(add, addEnc || "hex");
        this._update(add);
    }
    var temp = [];
    while(temp.length < len){
        this.V = this._hmac().update(this.V).digest();
        temp = temp.concat(this.V);
    }
    var res = temp.slice(0, len);
    this._update(add);
    this._reseed++;
    return utils.encode(res, enc);
};

},{"629972fec592198f":"dElqS","c20531edfb274a2c":"1KIes","43ff1863ab3fce20":"cKbUa"}],"jG59z":[function(require,module,exports) {
"use strict";
var BN = require("55cc33a33cda153d");
var utils = require("bda8b1ff480a7f3");
var assert = utils.assert;
function KeyPair(ec, options) {
    this.ec = ec;
    this.priv = null;
    this.pub = null;
    // KeyPair(ec, { priv: ..., pub: ... })
    if (options.priv) this._importPrivate(options.priv, options.privEnc);
    if (options.pub) this._importPublic(options.pub, options.pubEnc);
}
module.exports = KeyPair;
KeyPair.fromPublic = function fromPublic(ec, pub, enc) {
    if (pub instanceof KeyPair) return pub;
    return new KeyPair(ec, {
        pub: pub,
        pubEnc: enc
    });
};
KeyPair.fromPrivate = function fromPrivate(ec, priv, enc) {
    if (priv instanceof KeyPair) return priv;
    return new KeyPair(ec, {
        priv: priv,
        privEnc: enc
    });
};
KeyPair.prototype.validate = function validate() {
    var pub = this.getPublic();
    if (pub.isInfinity()) return {
        result: false,
        reason: "Invalid public key"
    };
    if (!pub.validate()) return {
        result: false,
        reason: "Public key is not a point"
    };
    if (!pub.mul(this.ec.curve.n).isInfinity()) return {
        result: false,
        reason: "Public key * N != O"
    };
    return {
        result: true,
        reason: null
    };
};
KeyPair.prototype.getPublic = function getPublic(compact, enc) {
    // compact is optional argument
    if (typeof compact === "string") {
        enc = compact;
        compact = null;
    }
    if (!this.pub) this.pub = this.ec.g.mul(this.priv);
    if (!enc) return this.pub;
    return this.pub.encode(enc, compact);
};
KeyPair.prototype.getPrivate = function getPrivate(enc) {
    if (enc === "hex") return this.priv.toString(16, 2);
    else return this.priv;
};
KeyPair.prototype._importPrivate = function _importPrivate(key, enc) {
    this.priv = new BN(key, enc || 16);
    // Ensure that the priv won't be bigger than n, otherwise we may fail
    // in fixed multiplication method
    this.priv = this.priv.umod(this.ec.curve.n);
};
KeyPair.prototype._importPublic = function _importPublic(key, enc) {
    if (key.x || key.y) {
        // Montgomery points only have an `x` coordinate.
        // Weierstrass/Edwards points on the other hand have both `x` and
        // `y` coordinates.
        if (this.ec.curve.type === "mont") assert(key.x, "Need x coordinate");
        else if (this.ec.curve.type === "short" || this.ec.curve.type === "edwards") assert(key.x && key.y, "Need both x and y coordinate");
        this.pub = this.ec.curve.point(key.x, key.y);
        return;
    }
    this.pub = this.ec.curve.decodePoint(key, enc);
};
// ECDH
KeyPair.prototype.derive = function derive(pub) {
    if (!pub.validate()) assert(pub.validate(), "public point not validated");
    return pub.mul(this.priv).getX();
};
// ECDSA
KeyPair.prototype.sign = function sign(msg, enc, options) {
    return this.ec.sign(msg, this, enc, options);
};
KeyPair.prototype.verify = function verify(msg, signature) {
    return this.ec.verify(msg, signature, this);
};
KeyPair.prototype.inspect = function inspect() {
    return "<Key priv: " + (this.priv && this.priv.toString(16, 2)) + " pub: " + (this.pub && this.pub.inspect()) + " >";
};

},{"55cc33a33cda153d":"kRh32","bda8b1ff480a7f3":"7PLUP"}],"59s4p":[function(require,module,exports) {
"use strict";
var BN = require("a7ae8f0fe39990e7");
var utils = require("5df7da4811374387");
var assert = utils.assert;
function Signature(options, enc) {
    if (options instanceof Signature) return options;
    if (this._importDER(options, enc)) return;
    assert(options.r && options.s, "Signature without r or s");
    this.r = new BN(options.r, 16);
    this.s = new BN(options.s, 16);
    if (options.recoveryParam === undefined) this.recoveryParam = null;
    else this.recoveryParam = options.recoveryParam;
}
module.exports = Signature;
function Position() {
    this.place = 0;
}
function getLength(buf, p) {
    var initial = buf[p.place++];
    if (!(initial & 0x80)) return initial;
    var octetLen = initial & 0xf;
    // Indefinite length or overflow
    if (octetLen === 0 || octetLen > 4) return false;
    if (buf[p.place] === 0x00) return false;
    var val = 0;
    for(var i = 0, off = p.place; i < octetLen; i++, off++){
        val <<= 8;
        val |= buf[off];
        val >>>= 0;
    }
    // Leading zeroes
    if (val <= 0x7f) return false;
    p.place = off;
    return val;
}
function rmPadding(buf) {
    var i = 0;
    var len = buf.length - 1;
    while(!buf[i] && !(buf[i + 1] & 0x80) && i < len)i++;
    if (i === 0) return buf;
    return buf.slice(i);
}
Signature.prototype._importDER = function _importDER(data, enc) {
    data = utils.toArray(data, enc);
    var p = new Position();
    if (data[p.place++] !== 0x30) return false;
    var len = getLength(data, p);
    if (len === false) return false;
    if (len + p.place !== data.length) return false;
    if (data[p.place++] !== 0x02) return false;
    var rlen = getLength(data, p);
    if (rlen === false) return false;
    if ((data[p.place] & 128) !== 0) return false;
    var r = data.slice(p.place, rlen + p.place);
    p.place += rlen;
    if (data[p.place++] !== 0x02) return false;
    var slen = getLength(data, p);
    if (slen === false) return false;
    if (data.length !== slen + p.place) return false;
    if ((data[p.place] & 128) !== 0) return false;
    var s = data.slice(p.place, slen + p.place);
    if (r[0] === 0) {
        if (r[1] & 0x80) r = r.slice(1);
        else // Leading zeroes
        return false;
    }
    if (s[0] === 0) {
        if (s[1] & 0x80) s = s.slice(1);
        else // Leading zeroes
        return false;
    }
    this.r = new BN(r);
    this.s = new BN(s);
    this.recoveryParam = null;
    return true;
};
function constructLength(arr, len) {
    if (len < 0x80) {
        arr.push(len);
        return;
    }
    var octets = 1 + (Math.log(len) / Math.LN2 >>> 3);
    arr.push(octets | 0x80);
    while(--octets)arr.push(len >>> (octets << 3) & 0xff);
    arr.push(len);
}
Signature.prototype.toDER = function toDER(enc) {
    var r = this.r.toArray();
    var s = this.s.toArray();
    // Pad values
    if (r[0] & 0x80) r = [
        0
    ].concat(r);
    // Pad values
    if (s[0] & 0x80) s = [
        0
    ].concat(s);
    r = rmPadding(r);
    s = rmPadding(s);
    while(!s[0] && !(s[1] & 0x80))s = s.slice(1);
    var arr = [
        0x02
    ];
    constructLength(arr, r.length);
    arr = arr.concat(r);
    arr.push(0x02);
    constructLength(arr, s.length);
    var backHalf = arr.concat(s);
    var res = [
        0x30
    ];
    constructLength(res, backHalf.length);
    res = res.concat(backHalf);
    return utils.encode(res, enc);
};

},{"a7ae8f0fe39990e7":"kRh32","5df7da4811374387":"7PLUP"}],"7YIGW":[function(require,module,exports) {
"use strict";
var hash = require("50f9bfa8a484d5d8");
var curves = require("68956d27442d6321");
var utils = require("99ec52641eff141d");
var assert = utils.assert;
var parseBytes = utils.parseBytes;
var KeyPair = require("2ad2982d76b37f15");
var Signature = require("76c25a1d63d10c1b");
function EDDSA(curve) {
    assert(curve === "ed25519", "only tested with ed25519 so far");
    if (!(this instanceof EDDSA)) return new EDDSA(curve);
    curve = curves[curve].curve;
    this.curve = curve;
    this.g = curve.g;
    this.g.precompute(curve.n.bitLength() + 1);
    this.pointClass = curve.point().constructor;
    this.encodingLength = Math.ceil(curve.n.bitLength() / 8);
    this.hash = hash.sha512;
}
module.exports = EDDSA;
/**
* @param {Array|String} message - message bytes
* @param {Array|String|KeyPair} secret - secret bytes or a keypair
* @returns {Signature} - signature
*/ EDDSA.prototype.sign = function sign(message, secret) {
    message = parseBytes(message);
    var key = this.keyFromSecret(secret);
    var r = this.hashInt(key.messagePrefix(), message);
    var R = this.g.mul(r);
    var Rencoded = this.encodePoint(R);
    var s_ = this.hashInt(Rencoded, key.pubBytes(), message).mul(key.priv());
    var S = r.add(s_).umod(this.curve.n);
    return this.makeSignature({
        R: R,
        S: S,
        Rencoded: Rencoded
    });
};
/**
* @param {Array} message - message bytes
* @param {Array|String|Signature} sig - sig bytes
* @param {Array|String|Point|KeyPair} pub - public key
* @returns {Boolean} - true if public key matches sig of message
*/ EDDSA.prototype.verify = function verify(message, sig, pub) {
    message = parseBytes(message);
    sig = this.makeSignature(sig);
    if (sig.S().gte(sig.eddsa.curve.n) || sig.S().isNeg()) return false;
    var key = this.keyFromPublic(pub);
    var h = this.hashInt(sig.Rencoded(), key.pubBytes(), message);
    var SG = this.g.mul(sig.S());
    var RplusAh = sig.R().add(key.pub().mul(h));
    return RplusAh.eq(SG);
};
EDDSA.prototype.hashInt = function hashInt() {
    var hash = this.hash();
    for(var i = 0; i < arguments.length; i++)hash.update(arguments[i]);
    return utils.intFromLE(hash.digest()).umod(this.curve.n);
};
EDDSA.prototype.keyFromPublic = function keyFromPublic(pub) {
    return KeyPair.fromPublic(this, pub);
};
EDDSA.prototype.keyFromSecret = function keyFromSecret(secret) {
    return KeyPair.fromSecret(this, secret);
};
EDDSA.prototype.makeSignature = function makeSignature(sig) {
    if (sig instanceof Signature) return sig;
    return new Signature(this, sig);
};
/**
* * https://tools.ietf.org/html/draft-josefsson-eddsa-ed25519-03#section-5.2
*
* EDDSA defines methods for encoding and decoding points and integers. These are
* helper convenience methods, that pass along to utility functions implied
* parameters.
*
*/ EDDSA.prototype.encodePoint = function encodePoint(point) {
    var enc = point.getY().toArray("le", this.encodingLength);
    enc[this.encodingLength - 1] |= point.getX().isOdd() ? 0x80 : 0;
    return enc;
};
EDDSA.prototype.decodePoint = function decodePoint(bytes) {
    bytes = utils.parseBytes(bytes);
    var lastIx = bytes.length - 1;
    var normed = bytes.slice(0, lastIx).concat(bytes[lastIx] & -129);
    var xIsOdd = (bytes[lastIx] & 0x80) !== 0;
    var y = utils.intFromLE(normed);
    return this.curve.pointFromY(y, xIsOdd);
};
EDDSA.prototype.encodeInt = function encodeInt(num) {
    return num.toArray("le", this.encodingLength);
};
EDDSA.prototype.decodeInt = function decodeInt(bytes) {
    return utils.intFromLE(bytes);
};
EDDSA.prototype.isPoint = function isPoint(val) {
    return val instanceof this.pointClass;
};

},{"50f9bfa8a484d5d8":"dElqS","68956d27442d6321":"ab7Cj","99ec52641eff141d":"7PLUP","2ad2982d76b37f15":"grnAU","76c25a1d63d10c1b":"9awGI"}],"grnAU":[function(require,module,exports) {
"use strict";
var utils = require("387ffb9c0bf065ab");
var assert = utils.assert;
var parseBytes = utils.parseBytes;
var cachedProperty = utils.cachedProperty;
/**
* @param {EDDSA} eddsa - instance
* @param {Object} params - public/private key parameters
*
* @param {Array<Byte>} [params.secret] - secret seed bytes
* @param {Point} [params.pub] - public key point (aka `A` in eddsa terms)
* @param {Array<Byte>} [params.pub] - public key point encoded as bytes
*
*/ function KeyPair(eddsa, params) {
    this.eddsa = eddsa;
    this._secret = parseBytes(params.secret);
    if (eddsa.isPoint(params.pub)) this._pub = params.pub;
    else this._pubBytes = parseBytes(params.pub);
}
KeyPair.fromPublic = function fromPublic(eddsa, pub) {
    if (pub instanceof KeyPair) return pub;
    return new KeyPair(eddsa, {
        pub: pub
    });
};
KeyPair.fromSecret = function fromSecret(eddsa, secret) {
    if (secret instanceof KeyPair) return secret;
    return new KeyPair(eddsa, {
        secret: secret
    });
};
KeyPair.prototype.secret = function secret() {
    return this._secret;
};
cachedProperty(KeyPair, "pubBytes", function pubBytes() {
    return this.eddsa.encodePoint(this.pub());
});
cachedProperty(KeyPair, "pub", function pub() {
    if (this._pubBytes) return this.eddsa.decodePoint(this._pubBytes);
    return this.eddsa.g.mul(this.priv());
});
cachedProperty(KeyPair, "privBytes", function privBytes() {
    var eddsa = this.eddsa;
    var hash = this.hash();
    var lastIx = eddsa.encodingLength - 1;
    var a = hash.slice(0, eddsa.encodingLength);
    a[0] &= 248;
    a[lastIx] &= 127;
    a[lastIx] |= 64;
    return a;
});
cachedProperty(KeyPair, "priv", function priv() {
    return this.eddsa.decodeInt(this.privBytes());
});
cachedProperty(KeyPair, "hash", function hash() {
    return this.eddsa.hash().update(this.secret()).digest();
});
cachedProperty(KeyPair, "messagePrefix", function messagePrefix() {
    return this.hash().slice(this.eddsa.encodingLength);
});
KeyPair.prototype.sign = function sign(message) {
    assert(this._secret, "KeyPair can only verify");
    return this.eddsa.sign(message, this);
};
KeyPair.prototype.verify = function verify(message, sig) {
    return this.eddsa.verify(message, sig, this);
};
KeyPair.prototype.getSecret = function getSecret(enc) {
    assert(this._secret, "KeyPair is public only");
    return utils.encode(this.secret(), enc);
};
KeyPair.prototype.getPublic = function getPublic(enc) {
    return utils.encode(this.pubBytes(), enc);
};
module.exports = KeyPair;

},{"387ffb9c0bf065ab":"7PLUP"}],"9awGI":[function(require,module,exports) {
"use strict";
var BN = require("696e2c87f819d166");
var utils = require("51b94bcac1dcb2b2");
var assert = utils.assert;
var cachedProperty = utils.cachedProperty;
var parseBytes = utils.parseBytes;
/**
* @param {EDDSA} eddsa - eddsa instance
* @param {Array<Bytes>|Object} sig -
* @param {Array<Bytes>|Point} [sig.R] - R point as Point or bytes
* @param {Array<Bytes>|bn} [sig.S] - S scalar as bn or bytes
* @param {Array<Bytes>} [sig.Rencoded] - R point encoded
* @param {Array<Bytes>} [sig.Sencoded] - S scalar encoded
*/ function Signature(eddsa, sig) {
    this.eddsa = eddsa;
    if (typeof sig !== "object") sig = parseBytes(sig);
    if (Array.isArray(sig)) {
        assert(sig.length === eddsa.encodingLength * 2, "Signature has invalid size");
        sig = {
            R: sig.slice(0, eddsa.encodingLength),
            S: sig.slice(eddsa.encodingLength)
        };
    }
    assert(sig.R && sig.S, "Signature without R or S");
    if (eddsa.isPoint(sig.R)) this._R = sig.R;
    if (sig.S instanceof BN) this._S = sig.S;
    this._Rencoded = Array.isArray(sig.R) ? sig.R : sig.Rencoded;
    this._Sencoded = Array.isArray(sig.S) ? sig.S : sig.Sencoded;
}
cachedProperty(Signature, "S", function S() {
    return this.eddsa.decodeInt(this.Sencoded());
});
cachedProperty(Signature, "R", function R() {
    return this.eddsa.decodePoint(this.Rencoded());
});
cachedProperty(Signature, "Rencoded", function Rencoded() {
    return this.eddsa.encodePoint(this.R());
});
cachedProperty(Signature, "Sencoded", function Sencoded() {
    return this.eddsa.encodeInt(this.S());
});
Signature.prototype.toBytes = function toBytes() {
    return this.Rencoded().concat(this.Sencoded());
};
Signature.prototype.toHex = function toHex() {
    return utils.encode(this.toBytes(), "hex").toUpperCase();
};
module.exports = Signature;

},{"696e2c87f819d166":"kRh32","51b94bcac1dcb2b2":"7PLUP"}],"lfTzm":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
var randombytes = require("cd93974d66bb0f8c");
function getRandomBytes(bytes) {
    return new Promise(function(resolve, reject) {
        randombytes(bytes, function(err, resp) {
            if (err) {
                reject(err);
                return;
            }
            resolve(resp);
        });
    });
}
exports.getRandomBytes = getRandomBytes;
function getRandomBytesSync(bytes) {
    return randombytes(bytes);
}
exports.getRandomBytesSync = getRandomBytesSync;

},{"cd93974d66bb0f8c":"c6z4K"}],"48TrQ":[function(require,module,exports) {
var Buffer = require("52f6a7e0a924e85b").Buffer;
"use strict";
// This file is imported from secp256k1 v3
// https://github.com/cryptocoinjs/secp256k1-node/blob/master/LICENSE
var BN = require("e9aa948a7d6dcf62");
var EC = require("867c25b7fbb4a1da").ec;
var ec = new EC("secp256k1");
var ecparams = ec.curve;
exports.privateKeyExport = function(privateKey, compressed) {
    var d = new BN(privateKey);
    if (d.ucmp(ecparams.n) >= 0) throw new Error("couldn't export to DER format");
    var point = ec.g.mul(d);
    return toPublicKey(point.getX(), point.getY(), compressed);
};
exports.privateKeyModInverse = function(privateKey) {
    var bn = new BN(privateKey);
    if (bn.ucmp(ecparams.n) >= 0 || bn.isZero()) throw new Error("private key range is invalid");
    return bn.invm(ecparams.n).toArrayLike(Buffer, "be", 32);
};
exports.signatureImport = function(sigObj) {
    var r = new BN(sigObj.r);
    if (r.ucmp(ecparams.n) >= 0) r = new BN(0);
    var s = new BN(sigObj.s);
    if (s.ucmp(ecparams.n) >= 0) s = new BN(0);
    return Buffer.concat([
        r.toArrayLike(Buffer, "be", 32),
        s.toArrayLike(Buffer, "be", 32)
    ]);
};
exports.ecdhUnsafe = function(publicKey, privateKey, compressed) {
    var point = ec.keyFromPublic(publicKey);
    var scalar = new BN(privateKey);
    if (scalar.ucmp(ecparams.n) >= 0 || scalar.isZero()) throw new Error("scalar was invalid (zero or overflow)");
    var shared = point.pub.mul(scalar);
    return toPublicKey(shared.getX(), shared.getY(), compressed);
};
var toPublicKey = function toPublicKey(x, y, compressed) {
    var publicKey = void 0;
    if (compressed) {
        publicKey = Buffer.alloc(33);
        publicKey[0] = y.isOdd() ? 0x03 : 0x02;
        x.toArrayLike(Buffer, "be", 32).copy(publicKey, 1);
    } else {
        publicKey = Buffer.alloc(65);
        publicKey[0] = 0x04;
        x.toArrayLike(Buffer, "be", 32).copy(publicKey, 1);
        y.toArrayLike(Buffer, "be", 32).copy(publicKey, 33);
    }
    return publicKey;
};

},{"52f6a7e0a924e85b":"l5Twm","e9aa948a7d6dcf62":"x4ItY","867c25b7fbb4a1da":"e8UEU"}],"8TOSa":[function(require,module,exports) {
var Buffer = require("cf16b9606982469f").Buffer;
"use strict";
// This file is imported from secp256k1 v3
// https://github.com/cryptocoinjs/secp256k1-node/blob/master/LICENSE
var EC_PRIVKEY_EXPORT_DER_COMPRESSED = Buffer.from([
    // begin
    0x30,
    0x81,
    0xd3,
    0x02,
    0x01,
    0x01,
    0x04,
    0x20,
    // private key
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    // middle
    0xa0,
    0x81,
    0x85,
    0x30,
    0x81,
    0x82,
    0x02,
    0x01,
    0x01,
    0x30,
    0x2c,
    0x06,
    0x07,
    0x2a,
    0x86,
    0x48,
    0xce,
    0x3d,
    0x01,
    0x01,
    0x02,
    0x21,
    0x00,
    0xff,
    0xff,
    0xff,
    0xff,
    0xff,
    0xff,
    0xff,
    0xff,
    0xff,
    0xff,
    0xff,
    0xff,
    0xff,
    0xff,
    0xff,
    0xff,
    0xff,
    0xff,
    0xff,
    0xff,
    0xff,
    0xff,
    0xff,
    0xff,
    0xff,
    0xff,
    0xff,
    0xfe,
    0xff,
    0xff,
    0xfc,
    0x2f,
    0x30,
    0x06,
    0x04,
    0x01,
    0x00,
    0x04,
    0x01,
    0x07,
    0x04,
    0x21,
    0x02,
    0x79,
    0xbe,
    0x66,
    0x7e,
    0xf9,
    0xdc,
    0xbb,
    0xac,
    0x55,
    0xa0,
    0x62,
    0x95,
    0xce,
    0x87,
    0x0b,
    0x07,
    0x02,
    0x9b,
    0xfc,
    0xdb,
    0x2d,
    0xce,
    0x28,
    0xd9,
    0x59,
    0xf2,
    0x81,
    0x5b,
    0x16,
    0xf8,
    0x17,
    0x98,
    0x02,
    0x21,
    0x00,
    0xff,
    0xff,
    0xff,
    0xff,
    0xff,
    0xff,
    0xff,
    0xff,
    0xff,
    0xff,
    0xff,
    0xff,
    0xff,
    0xff,
    0xff,
    0xfe,
    0xba,
    0xae,
    0xdc,
    0xe6,
    0xaf,
    0x48,
    0xa0,
    0x3b,
    0xbf,
    0xd2,
    0x5e,
    0x8c,
    0xd0,
    0x36,
    0x41,
    0x41,
    0x02,
    0x01,
    0x01,
    0xa1,
    0x24,
    0x03,
    0x22,
    0x00,
    // public key
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00
]);
var EC_PRIVKEY_EXPORT_DER_UNCOMPRESSED = Buffer.from([
    // begin
    0x30,
    0x82,
    0x01,
    0x13,
    0x02,
    0x01,
    0x01,
    0x04,
    0x20,
    // private key
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    // middle
    0xa0,
    0x81,
    0xa5,
    0x30,
    0x81,
    0xa2,
    0x02,
    0x01,
    0x01,
    0x30,
    0x2c,
    0x06,
    0x07,
    0x2a,
    0x86,
    0x48,
    0xce,
    0x3d,
    0x01,
    0x01,
    0x02,
    0x21,
    0x00,
    0xff,
    0xff,
    0xff,
    0xff,
    0xff,
    0xff,
    0xff,
    0xff,
    0xff,
    0xff,
    0xff,
    0xff,
    0xff,
    0xff,
    0xff,
    0xff,
    0xff,
    0xff,
    0xff,
    0xff,
    0xff,
    0xff,
    0xff,
    0xff,
    0xff,
    0xff,
    0xff,
    0xfe,
    0xff,
    0xff,
    0xfc,
    0x2f,
    0x30,
    0x06,
    0x04,
    0x01,
    0x00,
    0x04,
    0x01,
    0x07,
    0x04,
    0x41,
    0x04,
    0x79,
    0xbe,
    0x66,
    0x7e,
    0xf9,
    0xdc,
    0xbb,
    0xac,
    0x55,
    0xa0,
    0x62,
    0x95,
    0xce,
    0x87,
    0x0b,
    0x07,
    0x02,
    0x9b,
    0xfc,
    0xdb,
    0x2d,
    0xce,
    0x28,
    0xd9,
    0x59,
    0xf2,
    0x81,
    0x5b,
    0x16,
    0xf8,
    0x17,
    0x98,
    0x48,
    0x3a,
    0xda,
    0x77,
    0x26,
    0xa3,
    0xc4,
    0x65,
    0x5d,
    0xa4,
    0xfb,
    0xfc,
    0x0e,
    0x11,
    0x08,
    0xa8,
    0xfd,
    0x17,
    0xb4,
    0x48,
    0xa6,
    0x85,
    0x54,
    0x19,
    0x9c,
    0x47,
    0xd0,
    0x8f,
    0xfb,
    0x10,
    0xd4,
    0xb8,
    0x02,
    0x21,
    0x00,
    0xff,
    0xff,
    0xff,
    0xff,
    0xff,
    0xff,
    0xff,
    0xff,
    0xff,
    0xff,
    0xff,
    0xff,
    0xff,
    0xff,
    0xff,
    0xfe,
    0xba,
    0xae,
    0xdc,
    0xe6,
    0xaf,
    0x48,
    0xa0,
    0x3b,
    0xbf,
    0xd2,
    0x5e,
    0x8c,
    0xd0,
    0x36,
    0x41,
    0x41,
    0x02,
    0x01,
    0x01,
    0xa1,
    0x44,
    0x03,
    0x42,
    0x00,
    // public key
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00
]);
exports.privateKeyExport = function(privateKey, publicKey, compressed) {
    var result = Buffer.from(compressed ? EC_PRIVKEY_EXPORT_DER_COMPRESSED : EC_PRIVKEY_EXPORT_DER_UNCOMPRESSED);
    privateKey.copy(result, compressed ? 8 : 9);
    publicKey.copy(result, compressed ? 181 : 214);
    return result;
};
exports.privateKeyImport = function(privateKey) {
    var length = privateKey.length;
    // sequence header
    var index = 0;
    if (length < index + 1 || privateKey[index] !== 0x30) return null;
    index += 1;
    // sequence length constructor
    if (length < index + 1 || !(privateKey[index] & 0x80)) return null;
    var lenb = privateKey[index] & 0x7f;
    index += 1;
    if (lenb < 1 || lenb > 2) return null;
    if (length < index + lenb) return null;
    // sequence length
    var len = privateKey[index + lenb - 1] | (lenb > 1 ? privateKey[index + lenb - 2] << 8 : 0);
    index += lenb;
    if (length < index + len) return null;
    // sequence element 0: version number (=1)
    if (length < index + 3 || privateKey[index] !== 0x02 || privateKey[index + 1] !== 0x01 || privateKey[index + 2] !== 0x01) return null;
    index += 3;
    // sequence element 1: octet string, up to 32 bytes
    if (length < index + 2 || privateKey[index] !== 0x04 || privateKey[index + 1] > 0x20 || length < index + 2 + privateKey[index + 1]) return null;
    return privateKey.slice(index + 2, index + 2 + privateKey[index + 1]);
};
exports.signatureImportLax = function(signature) {
    var r = Buffer.alloc(32, 0);
    var s = Buffer.alloc(32, 0);
    var length = signature.length;
    var index = 0;
    // sequence tag byte
    if (signature[index++] !== 0x30) return null;
    // sequence length byte
    var lenbyte = signature[index++];
    if (lenbyte & 0x80) {
        index += lenbyte - 0x80;
        if (index > length) return null;
    }
    // sequence tag byte for r
    if (signature[index++] !== 0x02) return null;
    // length for r
    var rlen = signature[index++];
    if (rlen & 0x80) {
        lenbyte = rlen - 0x80;
        if (index + lenbyte > length) return null;
        for(; lenbyte > 0 && signature[index] === 0x00; index += 1, lenbyte -= 1);
        for(rlen = 0; lenbyte > 0; index += 1, lenbyte -= 1)rlen = (rlen << 8) + signature[index];
    }
    if (rlen > length - index) return null;
    var rindex = index;
    index += rlen;
    // sequence tag byte for s
    if (signature[index++] !== 0x02) return null;
    // length for s
    var slen = signature[index++];
    if (slen & 0x80) {
        lenbyte = slen - 0x80;
        if (index + lenbyte > length) return null;
        for(; lenbyte > 0 && signature[index] === 0x00; index += 1, lenbyte -= 1);
        for(slen = 0; lenbyte > 0; index += 1, lenbyte -= 1)slen = (slen << 8) + signature[index];
    }
    if (slen > length - index) return null;
    var sindex = index;
    index += slen;
    // ignore leading zeros in r
    for(; rlen > 0 && signature[rindex] === 0x00; rlen -= 1, rindex += 1);
    // copy r value
    if (rlen > 32) return null;
    var rvalue = signature.slice(rindex, rindex + rlen);
    rvalue.copy(r, 32 - rvalue.length);
    // ignore leading zeros in s
    for(; slen > 0 && signature[sindex] === 0x00; slen -= 1, sindex += 1);
    // copy s value
    if (slen > 32) return null;
    var svalue = signature.slice(sindex, sindex + slen);
    svalue.copy(s, 32 - svalue.length);
    return {
        r: r,
        s: s
    };
};

},{"cf16b9606982469f":"l5Twm"}],"iee6k":[function(require,module,exports) {
var Buffer = require("c4f3522d609e2bb4").Buffer;
"use strict";
var __importDefault = this && this.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getLength = exports.decode = exports.encode = void 0;
var bn_js_1 = __importDefault(require("f2de64fac014d334"));
/**
 * RLP Encoding based on: https://github.com/ethereum/wiki/wiki/%5BEnglish%5D-RLP
 * This function takes in a data, convert it to buffer if not, and a length for recursion
 * @param input - will be converted to buffer
 * @returns returns buffer of encoded data
 **/ function encode(input) {
    if (Array.isArray(input)) {
        var output = [];
        for(var i = 0; i < input.length; i++)output.push(encode(input[i]));
        var buf = Buffer.concat(output);
        return Buffer.concat([
            encodeLength(buf.length, 192),
            buf
        ]);
    } else {
        var inputBuf = toBuffer(input);
        return inputBuf.length === 1 && inputBuf[0] < 128 ? inputBuf : Buffer.concat([
            encodeLength(inputBuf.length, 128),
            inputBuf
        ]);
    }
}
exports.encode = encode;
/**
 * Parse integers. Check if there is no leading zeros
 * @param v The value to parse
 * @param base The base to parse the integer into
 */ function safeParseInt(v, base) {
    if (v[0] === "0" && v[1] === "0") throw new Error("invalid RLP: extra zeros");
    return parseInt(v, base);
}
function encodeLength(len, offset) {
    if (len < 56) return Buffer.from([
        len + offset
    ]);
    else {
        var hexLength = intToHex(len);
        var lLength = hexLength.length / 2;
        var firstByte = intToHex(offset + 55 + lLength);
        return Buffer.from(firstByte + hexLength, "hex");
    }
}
function decode(input, stream) {
    if (stream === void 0) stream = false;
    if (!input || input.length === 0) return Buffer.from([]);
    var inputBuffer = toBuffer(input);
    var decoded = _decode(inputBuffer);
    if (stream) return decoded;
    if (decoded.remainder.length !== 0) throw new Error("invalid remainder");
    return decoded.data;
}
exports.decode = decode;
/**
 * Get the length of the RLP input
 * @param input
 * @returns The length of the input or an empty Buffer if no input
 */ function getLength(input) {
    if (!input || input.length === 0) return Buffer.from([]);
    var inputBuffer = toBuffer(input);
    var firstByte = inputBuffer[0];
    if (firstByte <= 0x7f) return inputBuffer.length;
    else if (firstByte <= 0xb7) return firstByte - 0x7f;
    else if (firstByte <= 0xbf) return firstByte - 0xb6;
    else if (firstByte <= 0xf7) // a list between  0-55 bytes long
    return firstByte - 0xbf;
    else {
        // a list  over 55 bytes long
        var llength = firstByte - 0xf6;
        var length_1 = safeParseInt(inputBuffer.slice(1, llength).toString("hex"), 16);
        return llength + length_1;
    }
}
exports.getLength = getLength;
/** Decode an input with RLP */ function _decode(input) {
    var length, llength, data, innerRemainder, d;
    var decoded = [];
    var firstByte = input[0];
    if (firstByte <= 0x7f) // a single byte whose value is in the [0x00, 0x7f] range, that byte is its own RLP encoding.
    return {
        data: input.slice(0, 1),
        remainder: input.slice(1)
    };
    else if (firstByte <= 0xb7) {
        // string is 0-55 bytes long. A single byte with value 0x80 plus the length of the string followed by the string
        // The range of the first byte is [0x80, 0xb7]
        length = firstByte - 0x7f;
        // set 0x80 null to 0
        if (firstByte === 0x80) data = Buffer.from([]);
        else data = input.slice(1, length);
        if (length === 2 && data[0] < 0x80) throw new Error("invalid rlp encoding: byte must be less 0x80");
        return {
            data: data,
            remainder: input.slice(length)
        };
    } else if (firstByte <= 0xbf) {
        // string is greater than 55 bytes long. A single byte with the value (0xb7 plus the length of the length),
        // followed by the length, followed by the string
        llength = firstByte - 0xb6;
        if (input.length - 1 < llength) throw new Error("invalid RLP: not enough bytes for string length");
        length = safeParseInt(input.slice(1, llength).toString("hex"), 16);
        if (length <= 55) throw new Error("invalid RLP: expected string length to be greater than 55");
        data = input.slice(llength, length + llength);
        if (data.length < length) throw new Error("invalid RLP: not enough bytes for string");
        return {
            data: data,
            remainder: input.slice(length + llength)
        };
    } else if (firstByte <= 0xf7) {
        // a list between  0-55 bytes long
        length = firstByte - 0xbf;
        innerRemainder = input.slice(1, length);
        while(innerRemainder.length){
            d = _decode(innerRemainder);
            decoded.push(d.data);
            innerRemainder = d.remainder;
        }
        return {
            data: decoded,
            remainder: input.slice(length)
        };
    } else {
        // a list  over 55 bytes long
        llength = firstByte - 0xf6;
        length = safeParseInt(input.slice(1, llength).toString("hex"), 16);
        var totalLength = llength + length;
        if (totalLength > input.length) throw new Error("invalid rlp: total length is larger than the data");
        innerRemainder = input.slice(llength, totalLength);
        if (innerRemainder.length === 0) throw new Error("invalid rlp, List has a invalid length");
        while(innerRemainder.length){
            d = _decode(innerRemainder);
            decoded.push(d.data);
            innerRemainder = d.remainder;
        }
        return {
            data: decoded,
            remainder: input.slice(totalLength)
        };
    }
}
/** Check if a string is prefixed by 0x */ function isHexPrefixed(str) {
    return str.slice(0, 2) === "0x";
}
/** Removes 0x from a given String */ function stripHexPrefix(str) {
    if (typeof str !== "string") return str;
    return isHexPrefixed(str) ? str.slice(2) : str;
}
/** Transform an integer into its hexadecimal value */ function intToHex(integer) {
    if (integer < 0) throw new Error("Invalid integer as argument, must be unsigned!");
    var hex = integer.toString(16);
    return hex.length % 2 ? "0" + hex : hex;
}
/** Pad a string to be even */ function padToEven(a) {
    return a.length % 2 ? "0" + a : a;
}
/** Transform an integer into a Buffer */ function intToBuffer(integer) {
    var hex = intToHex(integer);
    return Buffer.from(hex, "hex");
}
/** Transform anything into a Buffer */ function toBuffer(v) {
    if (!Buffer.isBuffer(v)) {
        if (typeof v === "string") {
            if (isHexPrefixed(v)) return Buffer.from(padToEven(stripHexPrefix(v)), "hex");
            else return Buffer.from(v);
        } else if (typeof v === "number" || typeof v === "bigint") {
            if (!v) return Buffer.from([]);
            else return intToBuffer(v);
        } else if (v === null || v === undefined) return Buffer.from([]);
        else if (v instanceof Uint8Array) return Buffer.from(v);
        else if (bn_js_1.default.isBN(v)) // converts a BN to a Buffer
        return Buffer.from(v.toArray());
        else throw new Error("invalid type");
    }
    return v;
}

},{"c4f3522d609e2bb4":"l5Twm","f2de64fac014d334":"6h2hR"}],"6h2hR":[function(require,module,exports) {
(function(module1, exports) {
    "use strict";
    // Utils
    function assert(val, msg) {
        if (!val) throw new Error(msg || "Assertion failed");
    }
    // Could use `inherits` module, but don't want to move from single file
    // architecture yet.
    function inherits(ctor, superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
    // BN
    function BN(number, base, endian) {
        if (BN.isBN(number)) return number;
        this.negative = 0;
        this.words = null;
        this.length = 0;
        // Reduction context
        this.red = null;
        if (number !== null) {
            if (base === "le" || base === "be") {
                endian = base;
                base = 10;
            }
            this._init(number || 0, base || 10, endian || "be");
        }
    }
    if (typeof module1 === "object") module1.exports = BN;
    else exports.BN = BN;
    BN.BN = BN;
    BN.wordSize = 26;
    var Buffer;
    try {
        if (typeof window !== "undefined" && typeof window.Buffer !== "undefined") Buffer = window.Buffer;
        else Buffer = require("5c17eeb63b5cdfb8").Buffer;
    } catch (e) {}
    BN.isBN = function isBN(num) {
        if (num instanceof BN) return true;
        return num !== null && typeof num === "object" && num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
    };
    BN.max = function max(left, right) {
        if (left.cmp(right) > 0) return left;
        return right;
    };
    BN.min = function min(left, right) {
        if (left.cmp(right) < 0) return left;
        return right;
    };
    BN.prototype._init = function init(number, base, endian) {
        if (typeof number === "number") return this._initNumber(number, base, endian);
        if (typeof number === "object") return this._initArray(number, base, endian);
        if (base === "hex") base = 16;
        assert(base === (base | 0) && base >= 2 && base <= 36);
        number = number.toString().replace(/\s+/g, "");
        var start = 0;
        if (number[0] === "-") {
            start++;
            this.negative = 1;
        }
        if (start < number.length) {
            if (base === 16) this._parseHex(number, start, endian);
            else {
                this._parseBase(number, base, start);
                if (endian === "le") this._initArray(this.toArray(), base, endian);
            }
        }
    };
    BN.prototype._initNumber = function _initNumber(number, base, endian) {
        if (number < 0) {
            this.negative = 1;
            number = -number;
        }
        if (number < 0x4000000) {
            this.words = [
                number & 0x3ffffff
            ];
            this.length = 1;
        } else if (number < 0x10000000000000) {
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff
            ];
            this.length = 2;
        } else {
            assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff,
                1
            ];
            this.length = 3;
        }
        if (endian !== "le") return;
        // Reverse the bytes
        this._initArray(this.toArray(), base, endian);
    };
    BN.prototype._initArray = function _initArray(number, base, endian) {
        // Perhaps a Uint8Array
        assert(typeof number.length === "number");
        if (number.length <= 0) {
            this.words = [
                0
            ];
            this.length = 1;
            return this;
        }
        this.length = Math.ceil(number.length / 3);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        var j, w;
        var off = 0;
        if (endian === "be") for(i = number.length - 1, j = 0; i >= 0; i -= 3){
            w = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        else if (endian === "le") for(i = 0, j = 0; i < number.length; i += 3){
            w = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        return this._strip();
    };
    function parseHex4Bits(string, index) {
        var c = string.charCodeAt(index);
        // '0' - '9'
        if (c >= 48 && c <= 57) return c - 48;
        else if (c >= 65 && c <= 70) return c - 55;
        else if (c >= 97 && c <= 102) return c - 87;
        else assert(false, "Invalid character in " + string);
    }
    function parseHexByte(string, lowerBound, index) {
        var r = parseHex4Bits(string, index);
        if (index - 1 >= lowerBound) r |= parseHex4Bits(string, index - 1) << 4;
        return r;
    }
    BN.prototype._parseHex = function _parseHex(number, start, endian) {
        // Create possibly bigger array to ensure that it fits the number
        this.length = Math.ceil((number.length - start) / 6);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        // 24-bits chunks
        var off = 0;
        var j = 0;
        var w;
        if (endian === "be") for(i = number.length - 1; i >= start; i -= 2){
            w = parseHexByte(number, start, i) << off;
            this.words[j] |= w & 0x3ffffff;
            if (off >= 18) {
                off -= 18;
                j += 1;
                this.words[j] |= w >>> 26;
            } else off += 8;
        }
        else {
            var parseLength = number.length - start;
            for(i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2){
                w = parseHexByte(number, start, i) << off;
                this.words[j] |= w & 0x3ffffff;
                if (off >= 18) {
                    off -= 18;
                    j += 1;
                    this.words[j] |= w >>> 26;
                } else off += 8;
            }
        }
        this._strip();
    };
    function parseBase(str, start, end, mul) {
        var r = 0;
        var b = 0;
        var len = Math.min(str.length, end);
        for(var i = start; i < len; i++){
            var c = str.charCodeAt(i) - 48;
            r *= mul;
            // 'a'
            if (c >= 49) b = c - 49 + 0xa;
            else if (c >= 17) b = c - 17 + 0xa;
            else b = c;
            assert(c >= 0 && b < mul, "Invalid character");
            r += b;
        }
        return r;
    }
    BN.prototype._parseBase = function _parseBase(number, base, start) {
        // Initialize as zero
        this.words = [
            0
        ];
        this.length = 1;
        // Find length of limb in base
        for(var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base)limbLen++;
        limbLen--;
        limbPow = limbPow / base | 0;
        var total = number.length - start;
        var mod = total % limbLen;
        var end = Math.min(total, total - mod) + start;
        var word = 0;
        for(var i = start; i < end; i += limbLen){
            word = parseBase(number, i, i + limbLen, base);
            this.imuln(limbPow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        if (mod !== 0) {
            var pow = 1;
            word = parseBase(number, i, number.length, base);
            for(i = 0; i < mod; i++)pow *= base;
            this.imuln(pow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        this._strip();
    };
    BN.prototype.copy = function copy(dest) {
        dest.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)dest.words[i] = this.words[i];
        dest.length = this.length;
        dest.negative = this.negative;
        dest.red = this.red;
    };
    function move(dest, src) {
        dest.words = src.words;
        dest.length = src.length;
        dest.negative = src.negative;
        dest.red = src.red;
    }
    BN.prototype._move = function _move(dest) {
        move(dest, this);
    };
    BN.prototype.clone = function clone() {
        var r = new BN(null);
        this.copy(r);
        return r;
    };
    BN.prototype._expand = function _expand(size) {
        while(this.length < size)this.words[this.length++] = 0;
        return this;
    };
    // Remove leading `0` from `this`
    BN.prototype._strip = function strip() {
        while(this.length > 1 && this.words[this.length - 1] === 0)this.length--;
        return this._normSign();
    };
    BN.prototype._normSign = function _normSign() {
        // -0 = 0
        if (this.length === 1 && this.words[0] === 0) this.negative = 0;
        return this;
    };
    // Check Symbol.for because not everywhere where Symbol defined
    // See https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Symbol#Browser_compatibility
    if (typeof Symbol !== "undefined" && typeof Symbol.for === "function") try {
        BN.prototype[Symbol.for("nodejs.util.inspect.custom")] = inspect;
    } catch (e) {
        BN.prototype.inspect = inspect;
    }
    else BN.prototype.inspect = inspect;
    function inspect() {
        return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
    }
    /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */ var zeros = [
        "",
        "0",
        "00",
        "000",
        "0000",
        "00000",
        "000000",
        "0000000",
        "00000000",
        "000000000",
        "0000000000",
        "00000000000",
        "000000000000",
        "0000000000000",
        "00000000000000",
        "000000000000000",
        "0000000000000000",
        "00000000000000000",
        "000000000000000000",
        "0000000000000000000",
        "00000000000000000000",
        "000000000000000000000",
        "0000000000000000000000",
        "00000000000000000000000",
        "000000000000000000000000",
        "0000000000000000000000000"
    ];
    var groupSizes = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
    ];
    var groupBases = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        10000000,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64000000,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        24300000,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
    ];
    BN.prototype.toString = function toString(base, padding) {
        base = base || 10;
        padding = padding | 0 || 1;
        var out;
        if (base === 16 || base === "hex") {
            out = "";
            var off = 0;
            var carry = 0;
            for(var i = 0; i < this.length; i++){
                var w = this.words[i];
                var word = ((w << off | carry) & 0xffffff).toString(16);
                carry = w >>> 24 - off & 0xffffff;
                off += 2;
                if (off >= 26) {
                    off -= 26;
                    i--;
                }
                if (carry !== 0 || i !== this.length - 1) out = zeros[6 - word.length] + word + out;
                else out = word + out;
            }
            if (carry !== 0) out = carry.toString(16) + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        if (base === (base | 0) && base >= 2 && base <= 36) {
            // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
            var groupSize = groupSizes[base];
            // var groupBase = Math.pow(base, groupSize);
            var groupBase = groupBases[base];
            out = "";
            var c = this.clone();
            c.negative = 0;
            while(!c.isZero()){
                var r = c.modrn(groupBase).toString(base);
                c = c.idivn(groupBase);
                if (!c.isZero()) out = zeros[groupSize - r.length] + r + out;
                else out = r + out;
            }
            if (this.isZero()) out = "0" + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        assert(false, "Base should be between 2 and 36");
    };
    BN.prototype.toNumber = function toNumber() {
        var ret = this.words[0];
        if (this.length === 2) ret += this.words[1] * 0x4000000;
        else if (this.length === 3 && this.words[2] === 0x01) // NOTE: at this stage it is known that the top bit is set
        ret += 0x10000000000000 + this.words[1] * 0x4000000;
        else if (this.length > 2) assert(false, "Number can only safely store up to 53 bits");
        return this.negative !== 0 ? -ret : ret;
    };
    BN.prototype.toJSON = function toJSON() {
        return this.toString(16, 2);
    };
    if (Buffer) BN.prototype.toBuffer = function toBuffer(endian, length) {
        return this.toArrayLike(Buffer, endian, length);
    };
    BN.prototype.toArray = function toArray(endian, length) {
        return this.toArrayLike(Array, endian, length);
    };
    var allocate = function allocate(ArrayType, size) {
        if (ArrayType.allocUnsafe) return ArrayType.allocUnsafe(size);
        return new ArrayType(size);
    };
    BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
        this._strip();
        var byteLength = this.byteLength();
        var reqLength = length || Math.max(1, byteLength);
        assert(byteLength <= reqLength, "byte array longer than desired length");
        assert(reqLength > 0, "Requested array length <= 0");
        var res = allocate(ArrayType, reqLength);
        var postfix = endian === "le" ? "LE" : "BE";
        this["_toArrayLike" + postfix](res, byteLength);
        return res;
    };
    BN.prototype._toArrayLikeLE = function _toArrayLikeLE(res, byteLength) {
        var position = 0;
        var carry = 0;
        for(var i = 0, shift = 0; i < this.length; i++){
            var word = this.words[i] << shift | carry;
            res[position++] = word & 0xff;
            if (position < res.length) res[position++] = word >> 8 & 0xff;
            if (position < res.length) res[position++] = word >> 16 & 0xff;
            if (shift === 6) {
                if (position < res.length) res[position++] = word >> 24 & 0xff;
                carry = 0;
                shift = 0;
            } else {
                carry = word >>> 24;
                shift += 2;
            }
        }
        if (position < res.length) {
            res[position++] = carry;
            while(position < res.length)res[position++] = 0;
        }
    };
    BN.prototype._toArrayLikeBE = function _toArrayLikeBE(res, byteLength) {
        var position = res.length - 1;
        var carry = 0;
        for(var i = 0, shift = 0; i < this.length; i++){
            var word = this.words[i] << shift | carry;
            res[position--] = word & 0xff;
            if (position >= 0) res[position--] = word >> 8 & 0xff;
            if (position >= 0) res[position--] = word >> 16 & 0xff;
            if (shift === 6) {
                if (position >= 0) res[position--] = word >> 24 & 0xff;
                carry = 0;
                shift = 0;
            } else {
                carry = word >>> 24;
                shift += 2;
            }
        }
        if (position >= 0) {
            res[position--] = carry;
            while(position >= 0)res[position--] = 0;
        }
    };
    if (Math.clz32) BN.prototype._countBits = function _countBits(w) {
        return 32 - Math.clz32(w);
    };
    else BN.prototype._countBits = function _countBits(w) {
        var t = w;
        var r = 0;
        if (t >= 0x1000) {
            r += 13;
            t >>>= 13;
        }
        if (t >= 0x40) {
            r += 7;
            t >>>= 7;
        }
        if (t >= 0x8) {
            r += 4;
            t >>>= 4;
        }
        if (t >= 0x02) {
            r += 2;
            t >>>= 2;
        }
        return r + t;
    };
    BN.prototype._zeroBits = function _zeroBits(w) {
        // Short-cut
        if (w === 0) return 26;
        var t = w;
        var r = 0;
        if ((t & 0x1fff) === 0) {
            r += 13;
            t >>>= 13;
        }
        if ((t & 0x7f) === 0) {
            r += 7;
            t >>>= 7;
        }
        if ((t & 0xf) === 0) {
            r += 4;
            t >>>= 4;
        }
        if ((t & 0x3) === 0) {
            r += 2;
            t >>>= 2;
        }
        if ((t & 0x1) === 0) r++;
        return r;
    };
    // Return number of used bits in a BN
    BN.prototype.bitLength = function bitLength() {
        var w = this.words[this.length - 1];
        var hi = this._countBits(w);
        return (this.length - 1) * 26 + hi;
    };
    function toBitArray(num) {
        var w = new Array(num.bitLength());
        for(var bit = 0; bit < w.length; bit++){
            var off = bit / 26 | 0;
            var wbit = bit % 26;
            w[bit] = num.words[off] >>> wbit & 0x01;
        }
        return w;
    }
    // Number of trailing zero bits
    BN.prototype.zeroBits = function zeroBits() {
        if (this.isZero()) return 0;
        var r = 0;
        for(var i = 0; i < this.length; i++){
            var b = this._zeroBits(this.words[i]);
            r += b;
            if (b !== 26) break;
        }
        return r;
    };
    BN.prototype.byteLength = function byteLength() {
        return Math.ceil(this.bitLength() / 8);
    };
    BN.prototype.toTwos = function toTwos(width) {
        if (this.negative !== 0) return this.abs().inotn(width).iaddn(1);
        return this.clone();
    };
    BN.prototype.fromTwos = function fromTwos(width) {
        if (this.testn(width - 1)) return this.notn(width).iaddn(1).ineg();
        return this.clone();
    };
    BN.prototype.isNeg = function isNeg() {
        return this.negative !== 0;
    };
    // Return negative clone of `this`
    BN.prototype.neg = function neg() {
        return this.clone().ineg();
    };
    BN.prototype.ineg = function ineg() {
        if (!this.isZero()) this.negative ^= 1;
        return this;
    };
    // Or `num` with `this` in-place
    BN.prototype.iuor = function iuor(num) {
        while(this.length < num.length)this.words[this.length++] = 0;
        for(var i = 0; i < num.length; i++)this.words[i] = this.words[i] | num.words[i];
        return this._strip();
    };
    BN.prototype.ior = function ior(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuor(num);
    };
    // Or `num` with `this`
    BN.prototype.or = function or(num) {
        if (this.length > num.length) return this.clone().ior(num);
        return num.clone().ior(this);
    };
    BN.prototype.uor = function uor(num) {
        if (this.length > num.length) return this.clone().iuor(num);
        return num.clone().iuor(this);
    };
    // And `num` with `this` in-place
    BN.prototype.iuand = function iuand(num) {
        // b = min-length(num, this)
        var b;
        if (this.length > num.length) b = num;
        else b = this;
        for(var i = 0; i < b.length; i++)this.words[i] = this.words[i] & num.words[i];
        this.length = b.length;
        return this._strip();
    };
    BN.prototype.iand = function iand(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuand(num);
    };
    // And `num` with `this`
    BN.prototype.and = function and(num) {
        if (this.length > num.length) return this.clone().iand(num);
        return num.clone().iand(this);
    };
    BN.prototype.uand = function uand(num) {
        if (this.length > num.length) return this.clone().iuand(num);
        return num.clone().iuand(this);
    };
    // Xor `num` with `this` in-place
    BN.prototype.iuxor = function iuxor(num) {
        // a.length > b.length
        var a;
        var b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        for(var i = 0; i < b.length; i++)this.words[i] = a.words[i] ^ b.words[i];
        if (this !== a) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = a.length;
        return this._strip();
    };
    BN.prototype.ixor = function ixor(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuxor(num);
    };
    // Xor `num` with `this`
    BN.prototype.xor = function xor(num) {
        if (this.length > num.length) return this.clone().ixor(num);
        return num.clone().ixor(this);
    };
    BN.prototype.uxor = function uxor(num) {
        if (this.length > num.length) return this.clone().iuxor(num);
        return num.clone().iuxor(this);
    };
    // Not ``this`` with ``width`` bitwidth
    BN.prototype.inotn = function inotn(width) {
        assert(typeof width === "number" && width >= 0);
        var bytesNeeded = Math.ceil(width / 26) | 0;
        var bitsLeft = width % 26;
        // Extend the buffer with leading zeroes
        this._expand(bytesNeeded);
        if (bitsLeft > 0) bytesNeeded--;
        // Handle complete words
        for(var i = 0; i < bytesNeeded; i++)this.words[i] = ~this.words[i] & 0x3ffffff;
        // Handle the residue
        if (bitsLeft > 0) this.words[i] = ~this.words[i] & 0x3ffffff >> 26 - bitsLeft;
        // And remove leading zeroes
        return this._strip();
    };
    BN.prototype.notn = function notn(width) {
        return this.clone().inotn(width);
    };
    // Set `bit` of `this`
    BN.prototype.setn = function setn(bit, val) {
        assert(typeof bit === "number" && bit >= 0);
        var off = bit / 26 | 0;
        var wbit = bit % 26;
        this._expand(off + 1);
        if (val) this.words[off] = this.words[off] | 1 << wbit;
        else this.words[off] = this.words[off] & ~(1 << wbit);
        return this._strip();
    };
    // Add `num` to `this` in-place
    BN.prototype.iadd = function iadd(num) {
        var r;
        // negative + positive
        if (this.negative !== 0 && num.negative === 0) {
            this.negative = 0;
            r = this.isub(num);
            this.negative ^= 1;
            return this._normSign();
        // positive + negative
        } else if (this.negative === 0 && num.negative !== 0) {
            num.negative = 0;
            r = this.isub(num);
            num.negative = 1;
            return r._normSign();
        }
        // a.length > b.length
        var a, b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        this.length = a.length;
        if (carry !== 0) {
            this.words[this.length] = carry;
            this.length++;
        // Copy the rest of the words
        } else if (a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        return this;
    };
    // Add `num` to `this`
    BN.prototype.add = function add(num) {
        var res;
        if (num.negative !== 0 && this.negative === 0) {
            num.negative = 0;
            res = this.sub(num);
            num.negative ^= 1;
            return res;
        } else if (num.negative === 0 && this.negative !== 0) {
            this.negative = 0;
            res = num.sub(this);
            this.negative = 1;
            return res;
        }
        if (this.length > num.length) return this.clone().iadd(num);
        return num.clone().iadd(this);
    };
    // Subtract `num` from `this` in-place
    BN.prototype.isub = function isub(num) {
        // this - (-num) = this + num
        if (num.negative !== 0) {
            num.negative = 0;
            var r = this.iadd(num);
            num.negative = 1;
            return r._normSign();
        // -this - num = -(this + num)
        } else if (this.negative !== 0) {
            this.negative = 0;
            this.iadd(num);
            this.negative = 1;
            return this._normSign();
        }
        // At this point both numbers are positive
        var cmp = this.cmp(num);
        // Optimization - zeroify
        if (cmp === 0) {
            this.negative = 0;
            this.length = 1;
            this.words[0] = 0;
            return this;
        }
        // a > b
        var a, b;
        if (cmp > 0) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        // Copy rest of the words
        if (carry === 0 && i < a.length && a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = Math.max(this.length, i);
        if (a !== this) this.negative = 1;
        return this._strip();
    };
    // Subtract `num` from `this`
    BN.prototype.sub = function sub(num) {
        return this.clone().isub(num);
    };
    function smallMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        var len = self.length + num.length | 0;
        out.length = len;
        len = len - 1 | 0;
        // Peel one iteration (compiler can't do it, because of code complexity)
        var a = self.words[0] | 0;
        var b = num.words[0] | 0;
        var r = a * b;
        var lo = r & 0x3ffffff;
        var carry = r / 0x4000000 | 0;
        out.words[0] = lo;
        for(var k = 1; k < len; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = carry >>> 26;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j | 0;
                a = self.words[i] | 0;
                b = num.words[j] | 0;
                r = a * b + rword;
                ncarry += r / 0x4000000 | 0;
                rword = r & 0x3ffffff;
            }
            out.words[k] = rword | 0;
            carry = ncarry | 0;
        }
        if (carry !== 0) out.words[k] = carry | 0;
        else out.length--;
        return out._strip();
    }
    // TODO(indutny): it may be reasonable to omit it for users who don't need
    // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
    // multiplication (like elliptic secp256k1).
    var comb10MulTo = function comb10MulTo(self, num, out) {
        var a = self.words;
        var b = num.words;
        var o = out.words;
        var c = 0;
        var lo;
        var mid;
        var hi;
        var a0 = a[0] | 0;
        var al0 = a0 & 0x1fff;
        var ah0 = a0 >>> 13;
        var a1 = a[1] | 0;
        var al1 = a1 & 0x1fff;
        var ah1 = a1 >>> 13;
        var a2 = a[2] | 0;
        var al2 = a2 & 0x1fff;
        var ah2 = a2 >>> 13;
        var a3 = a[3] | 0;
        var al3 = a3 & 0x1fff;
        var ah3 = a3 >>> 13;
        var a4 = a[4] | 0;
        var al4 = a4 & 0x1fff;
        var ah4 = a4 >>> 13;
        var a5 = a[5] | 0;
        var al5 = a5 & 0x1fff;
        var ah5 = a5 >>> 13;
        var a6 = a[6] | 0;
        var al6 = a6 & 0x1fff;
        var ah6 = a6 >>> 13;
        var a7 = a[7] | 0;
        var al7 = a7 & 0x1fff;
        var ah7 = a7 >>> 13;
        var a8 = a[8] | 0;
        var al8 = a8 & 0x1fff;
        var ah8 = a8 >>> 13;
        var a9 = a[9] | 0;
        var al9 = a9 & 0x1fff;
        var ah9 = a9 >>> 13;
        var b0 = b[0] | 0;
        var bl0 = b0 & 0x1fff;
        var bh0 = b0 >>> 13;
        var b1 = b[1] | 0;
        var bl1 = b1 & 0x1fff;
        var bh1 = b1 >>> 13;
        var b2 = b[2] | 0;
        var bl2 = b2 & 0x1fff;
        var bh2 = b2 >>> 13;
        var b3 = b[3] | 0;
        var bl3 = b3 & 0x1fff;
        var bh3 = b3 >>> 13;
        var b4 = b[4] | 0;
        var bl4 = b4 & 0x1fff;
        var bh4 = b4 >>> 13;
        var b5 = b[5] | 0;
        var bl5 = b5 & 0x1fff;
        var bh5 = b5 >>> 13;
        var b6 = b[6] | 0;
        var bl6 = b6 & 0x1fff;
        var bh6 = b6 >>> 13;
        var b7 = b[7] | 0;
        var bl7 = b7 & 0x1fff;
        var bh7 = b7 >>> 13;
        var b8 = b[8] | 0;
        var bl8 = b8 & 0x1fff;
        var bh8 = b8 >>> 13;
        var b9 = b[9] | 0;
        var bl9 = b9 & 0x1fff;
        var bh9 = b9 >>> 13;
        out.negative = self.negative ^ num.negative;
        out.length = 19;
        /* k = 0 */ lo = Math.imul(al0, bl0);
        mid = Math.imul(al0, bh0);
        mid = mid + Math.imul(ah0, bl0) | 0;
        hi = Math.imul(ah0, bh0);
        var w0 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
        w0 &= 0x3ffffff;
        /* k = 1 */ lo = Math.imul(al1, bl0);
        mid = Math.imul(al1, bh0);
        mid = mid + Math.imul(ah1, bl0) | 0;
        hi = Math.imul(ah1, bh0);
        lo = lo + Math.imul(al0, bl1) | 0;
        mid = mid + Math.imul(al0, bh1) | 0;
        mid = mid + Math.imul(ah0, bl1) | 0;
        hi = hi + Math.imul(ah0, bh1) | 0;
        var w1 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
        w1 &= 0x3ffffff;
        /* k = 2 */ lo = Math.imul(al2, bl0);
        mid = Math.imul(al2, bh0);
        mid = mid + Math.imul(ah2, bl0) | 0;
        hi = Math.imul(ah2, bh0);
        lo = lo + Math.imul(al1, bl1) | 0;
        mid = mid + Math.imul(al1, bh1) | 0;
        mid = mid + Math.imul(ah1, bl1) | 0;
        hi = hi + Math.imul(ah1, bh1) | 0;
        lo = lo + Math.imul(al0, bl2) | 0;
        mid = mid + Math.imul(al0, bh2) | 0;
        mid = mid + Math.imul(ah0, bl2) | 0;
        hi = hi + Math.imul(ah0, bh2) | 0;
        var w2 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
        w2 &= 0x3ffffff;
        /* k = 3 */ lo = Math.imul(al3, bl0);
        mid = Math.imul(al3, bh0);
        mid = mid + Math.imul(ah3, bl0) | 0;
        hi = Math.imul(ah3, bh0);
        lo = lo + Math.imul(al2, bl1) | 0;
        mid = mid + Math.imul(al2, bh1) | 0;
        mid = mid + Math.imul(ah2, bl1) | 0;
        hi = hi + Math.imul(ah2, bh1) | 0;
        lo = lo + Math.imul(al1, bl2) | 0;
        mid = mid + Math.imul(al1, bh2) | 0;
        mid = mid + Math.imul(ah1, bl2) | 0;
        hi = hi + Math.imul(ah1, bh2) | 0;
        lo = lo + Math.imul(al0, bl3) | 0;
        mid = mid + Math.imul(al0, bh3) | 0;
        mid = mid + Math.imul(ah0, bl3) | 0;
        hi = hi + Math.imul(ah0, bh3) | 0;
        var w3 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
        w3 &= 0x3ffffff;
        /* k = 4 */ lo = Math.imul(al4, bl0);
        mid = Math.imul(al4, bh0);
        mid = mid + Math.imul(ah4, bl0) | 0;
        hi = Math.imul(ah4, bh0);
        lo = lo + Math.imul(al3, bl1) | 0;
        mid = mid + Math.imul(al3, bh1) | 0;
        mid = mid + Math.imul(ah3, bl1) | 0;
        hi = hi + Math.imul(ah3, bh1) | 0;
        lo = lo + Math.imul(al2, bl2) | 0;
        mid = mid + Math.imul(al2, bh2) | 0;
        mid = mid + Math.imul(ah2, bl2) | 0;
        hi = hi + Math.imul(ah2, bh2) | 0;
        lo = lo + Math.imul(al1, bl3) | 0;
        mid = mid + Math.imul(al1, bh3) | 0;
        mid = mid + Math.imul(ah1, bl3) | 0;
        hi = hi + Math.imul(ah1, bh3) | 0;
        lo = lo + Math.imul(al0, bl4) | 0;
        mid = mid + Math.imul(al0, bh4) | 0;
        mid = mid + Math.imul(ah0, bl4) | 0;
        hi = hi + Math.imul(ah0, bh4) | 0;
        var w4 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
        w4 &= 0x3ffffff;
        /* k = 5 */ lo = Math.imul(al5, bl0);
        mid = Math.imul(al5, bh0);
        mid = mid + Math.imul(ah5, bl0) | 0;
        hi = Math.imul(ah5, bh0);
        lo = lo + Math.imul(al4, bl1) | 0;
        mid = mid + Math.imul(al4, bh1) | 0;
        mid = mid + Math.imul(ah4, bl1) | 0;
        hi = hi + Math.imul(ah4, bh1) | 0;
        lo = lo + Math.imul(al3, bl2) | 0;
        mid = mid + Math.imul(al3, bh2) | 0;
        mid = mid + Math.imul(ah3, bl2) | 0;
        hi = hi + Math.imul(ah3, bh2) | 0;
        lo = lo + Math.imul(al2, bl3) | 0;
        mid = mid + Math.imul(al2, bh3) | 0;
        mid = mid + Math.imul(ah2, bl3) | 0;
        hi = hi + Math.imul(ah2, bh3) | 0;
        lo = lo + Math.imul(al1, bl4) | 0;
        mid = mid + Math.imul(al1, bh4) | 0;
        mid = mid + Math.imul(ah1, bl4) | 0;
        hi = hi + Math.imul(ah1, bh4) | 0;
        lo = lo + Math.imul(al0, bl5) | 0;
        mid = mid + Math.imul(al0, bh5) | 0;
        mid = mid + Math.imul(ah0, bl5) | 0;
        hi = hi + Math.imul(ah0, bh5) | 0;
        var w5 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
        w5 &= 0x3ffffff;
        /* k = 6 */ lo = Math.imul(al6, bl0);
        mid = Math.imul(al6, bh0);
        mid = mid + Math.imul(ah6, bl0) | 0;
        hi = Math.imul(ah6, bh0);
        lo = lo + Math.imul(al5, bl1) | 0;
        mid = mid + Math.imul(al5, bh1) | 0;
        mid = mid + Math.imul(ah5, bl1) | 0;
        hi = hi + Math.imul(ah5, bh1) | 0;
        lo = lo + Math.imul(al4, bl2) | 0;
        mid = mid + Math.imul(al4, bh2) | 0;
        mid = mid + Math.imul(ah4, bl2) | 0;
        hi = hi + Math.imul(ah4, bh2) | 0;
        lo = lo + Math.imul(al3, bl3) | 0;
        mid = mid + Math.imul(al3, bh3) | 0;
        mid = mid + Math.imul(ah3, bl3) | 0;
        hi = hi + Math.imul(ah3, bh3) | 0;
        lo = lo + Math.imul(al2, bl4) | 0;
        mid = mid + Math.imul(al2, bh4) | 0;
        mid = mid + Math.imul(ah2, bl4) | 0;
        hi = hi + Math.imul(ah2, bh4) | 0;
        lo = lo + Math.imul(al1, bl5) | 0;
        mid = mid + Math.imul(al1, bh5) | 0;
        mid = mid + Math.imul(ah1, bl5) | 0;
        hi = hi + Math.imul(ah1, bh5) | 0;
        lo = lo + Math.imul(al0, bl6) | 0;
        mid = mid + Math.imul(al0, bh6) | 0;
        mid = mid + Math.imul(ah0, bl6) | 0;
        hi = hi + Math.imul(ah0, bh6) | 0;
        var w6 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
        w6 &= 0x3ffffff;
        /* k = 7 */ lo = Math.imul(al7, bl0);
        mid = Math.imul(al7, bh0);
        mid = mid + Math.imul(ah7, bl0) | 0;
        hi = Math.imul(ah7, bh0);
        lo = lo + Math.imul(al6, bl1) | 0;
        mid = mid + Math.imul(al6, bh1) | 0;
        mid = mid + Math.imul(ah6, bl1) | 0;
        hi = hi + Math.imul(ah6, bh1) | 0;
        lo = lo + Math.imul(al5, bl2) | 0;
        mid = mid + Math.imul(al5, bh2) | 0;
        mid = mid + Math.imul(ah5, bl2) | 0;
        hi = hi + Math.imul(ah5, bh2) | 0;
        lo = lo + Math.imul(al4, bl3) | 0;
        mid = mid + Math.imul(al4, bh3) | 0;
        mid = mid + Math.imul(ah4, bl3) | 0;
        hi = hi + Math.imul(ah4, bh3) | 0;
        lo = lo + Math.imul(al3, bl4) | 0;
        mid = mid + Math.imul(al3, bh4) | 0;
        mid = mid + Math.imul(ah3, bl4) | 0;
        hi = hi + Math.imul(ah3, bh4) | 0;
        lo = lo + Math.imul(al2, bl5) | 0;
        mid = mid + Math.imul(al2, bh5) | 0;
        mid = mid + Math.imul(ah2, bl5) | 0;
        hi = hi + Math.imul(ah2, bh5) | 0;
        lo = lo + Math.imul(al1, bl6) | 0;
        mid = mid + Math.imul(al1, bh6) | 0;
        mid = mid + Math.imul(ah1, bl6) | 0;
        hi = hi + Math.imul(ah1, bh6) | 0;
        lo = lo + Math.imul(al0, bl7) | 0;
        mid = mid + Math.imul(al0, bh7) | 0;
        mid = mid + Math.imul(ah0, bl7) | 0;
        hi = hi + Math.imul(ah0, bh7) | 0;
        var w7 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
        w7 &= 0x3ffffff;
        /* k = 8 */ lo = Math.imul(al8, bl0);
        mid = Math.imul(al8, bh0);
        mid = mid + Math.imul(ah8, bl0) | 0;
        hi = Math.imul(ah8, bh0);
        lo = lo + Math.imul(al7, bl1) | 0;
        mid = mid + Math.imul(al7, bh1) | 0;
        mid = mid + Math.imul(ah7, bl1) | 0;
        hi = hi + Math.imul(ah7, bh1) | 0;
        lo = lo + Math.imul(al6, bl2) | 0;
        mid = mid + Math.imul(al6, bh2) | 0;
        mid = mid + Math.imul(ah6, bl2) | 0;
        hi = hi + Math.imul(ah6, bh2) | 0;
        lo = lo + Math.imul(al5, bl3) | 0;
        mid = mid + Math.imul(al5, bh3) | 0;
        mid = mid + Math.imul(ah5, bl3) | 0;
        hi = hi + Math.imul(ah5, bh3) | 0;
        lo = lo + Math.imul(al4, bl4) | 0;
        mid = mid + Math.imul(al4, bh4) | 0;
        mid = mid + Math.imul(ah4, bl4) | 0;
        hi = hi + Math.imul(ah4, bh4) | 0;
        lo = lo + Math.imul(al3, bl5) | 0;
        mid = mid + Math.imul(al3, bh5) | 0;
        mid = mid + Math.imul(ah3, bl5) | 0;
        hi = hi + Math.imul(ah3, bh5) | 0;
        lo = lo + Math.imul(al2, bl6) | 0;
        mid = mid + Math.imul(al2, bh6) | 0;
        mid = mid + Math.imul(ah2, bl6) | 0;
        hi = hi + Math.imul(ah2, bh6) | 0;
        lo = lo + Math.imul(al1, bl7) | 0;
        mid = mid + Math.imul(al1, bh7) | 0;
        mid = mid + Math.imul(ah1, bl7) | 0;
        hi = hi + Math.imul(ah1, bh7) | 0;
        lo = lo + Math.imul(al0, bl8) | 0;
        mid = mid + Math.imul(al0, bh8) | 0;
        mid = mid + Math.imul(ah0, bl8) | 0;
        hi = hi + Math.imul(ah0, bh8) | 0;
        var w8 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
        w8 &= 0x3ffffff;
        /* k = 9 */ lo = Math.imul(al9, bl0);
        mid = Math.imul(al9, bh0);
        mid = mid + Math.imul(ah9, bl0) | 0;
        hi = Math.imul(ah9, bh0);
        lo = lo + Math.imul(al8, bl1) | 0;
        mid = mid + Math.imul(al8, bh1) | 0;
        mid = mid + Math.imul(ah8, bl1) | 0;
        hi = hi + Math.imul(ah8, bh1) | 0;
        lo = lo + Math.imul(al7, bl2) | 0;
        mid = mid + Math.imul(al7, bh2) | 0;
        mid = mid + Math.imul(ah7, bl2) | 0;
        hi = hi + Math.imul(ah7, bh2) | 0;
        lo = lo + Math.imul(al6, bl3) | 0;
        mid = mid + Math.imul(al6, bh3) | 0;
        mid = mid + Math.imul(ah6, bl3) | 0;
        hi = hi + Math.imul(ah6, bh3) | 0;
        lo = lo + Math.imul(al5, bl4) | 0;
        mid = mid + Math.imul(al5, bh4) | 0;
        mid = mid + Math.imul(ah5, bl4) | 0;
        hi = hi + Math.imul(ah5, bh4) | 0;
        lo = lo + Math.imul(al4, bl5) | 0;
        mid = mid + Math.imul(al4, bh5) | 0;
        mid = mid + Math.imul(ah4, bl5) | 0;
        hi = hi + Math.imul(ah4, bh5) | 0;
        lo = lo + Math.imul(al3, bl6) | 0;
        mid = mid + Math.imul(al3, bh6) | 0;
        mid = mid + Math.imul(ah3, bl6) | 0;
        hi = hi + Math.imul(ah3, bh6) | 0;
        lo = lo + Math.imul(al2, bl7) | 0;
        mid = mid + Math.imul(al2, bh7) | 0;
        mid = mid + Math.imul(ah2, bl7) | 0;
        hi = hi + Math.imul(ah2, bh7) | 0;
        lo = lo + Math.imul(al1, bl8) | 0;
        mid = mid + Math.imul(al1, bh8) | 0;
        mid = mid + Math.imul(ah1, bl8) | 0;
        hi = hi + Math.imul(ah1, bh8) | 0;
        lo = lo + Math.imul(al0, bl9) | 0;
        mid = mid + Math.imul(al0, bh9) | 0;
        mid = mid + Math.imul(ah0, bl9) | 0;
        hi = hi + Math.imul(ah0, bh9) | 0;
        var w9 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
        w9 &= 0x3ffffff;
        /* k = 10 */ lo = Math.imul(al9, bl1);
        mid = Math.imul(al9, bh1);
        mid = mid + Math.imul(ah9, bl1) | 0;
        hi = Math.imul(ah9, bh1);
        lo = lo + Math.imul(al8, bl2) | 0;
        mid = mid + Math.imul(al8, bh2) | 0;
        mid = mid + Math.imul(ah8, bl2) | 0;
        hi = hi + Math.imul(ah8, bh2) | 0;
        lo = lo + Math.imul(al7, bl3) | 0;
        mid = mid + Math.imul(al7, bh3) | 0;
        mid = mid + Math.imul(ah7, bl3) | 0;
        hi = hi + Math.imul(ah7, bh3) | 0;
        lo = lo + Math.imul(al6, bl4) | 0;
        mid = mid + Math.imul(al6, bh4) | 0;
        mid = mid + Math.imul(ah6, bl4) | 0;
        hi = hi + Math.imul(ah6, bh4) | 0;
        lo = lo + Math.imul(al5, bl5) | 0;
        mid = mid + Math.imul(al5, bh5) | 0;
        mid = mid + Math.imul(ah5, bl5) | 0;
        hi = hi + Math.imul(ah5, bh5) | 0;
        lo = lo + Math.imul(al4, bl6) | 0;
        mid = mid + Math.imul(al4, bh6) | 0;
        mid = mid + Math.imul(ah4, bl6) | 0;
        hi = hi + Math.imul(ah4, bh6) | 0;
        lo = lo + Math.imul(al3, bl7) | 0;
        mid = mid + Math.imul(al3, bh7) | 0;
        mid = mid + Math.imul(ah3, bl7) | 0;
        hi = hi + Math.imul(ah3, bh7) | 0;
        lo = lo + Math.imul(al2, bl8) | 0;
        mid = mid + Math.imul(al2, bh8) | 0;
        mid = mid + Math.imul(ah2, bl8) | 0;
        hi = hi + Math.imul(ah2, bh8) | 0;
        lo = lo + Math.imul(al1, bl9) | 0;
        mid = mid + Math.imul(al1, bh9) | 0;
        mid = mid + Math.imul(ah1, bl9) | 0;
        hi = hi + Math.imul(ah1, bh9) | 0;
        var w10 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
        w10 &= 0x3ffffff;
        /* k = 11 */ lo = Math.imul(al9, bl2);
        mid = Math.imul(al9, bh2);
        mid = mid + Math.imul(ah9, bl2) | 0;
        hi = Math.imul(ah9, bh2);
        lo = lo + Math.imul(al8, bl3) | 0;
        mid = mid + Math.imul(al8, bh3) | 0;
        mid = mid + Math.imul(ah8, bl3) | 0;
        hi = hi + Math.imul(ah8, bh3) | 0;
        lo = lo + Math.imul(al7, bl4) | 0;
        mid = mid + Math.imul(al7, bh4) | 0;
        mid = mid + Math.imul(ah7, bl4) | 0;
        hi = hi + Math.imul(ah7, bh4) | 0;
        lo = lo + Math.imul(al6, bl5) | 0;
        mid = mid + Math.imul(al6, bh5) | 0;
        mid = mid + Math.imul(ah6, bl5) | 0;
        hi = hi + Math.imul(ah6, bh5) | 0;
        lo = lo + Math.imul(al5, bl6) | 0;
        mid = mid + Math.imul(al5, bh6) | 0;
        mid = mid + Math.imul(ah5, bl6) | 0;
        hi = hi + Math.imul(ah5, bh6) | 0;
        lo = lo + Math.imul(al4, bl7) | 0;
        mid = mid + Math.imul(al4, bh7) | 0;
        mid = mid + Math.imul(ah4, bl7) | 0;
        hi = hi + Math.imul(ah4, bh7) | 0;
        lo = lo + Math.imul(al3, bl8) | 0;
        mid = mid + Math.imul(al3, bh8) | 0;
        mid = mid + Math.imul(ah3, bl8) | 0;
        hi = hi + Math.imul(ah3, bh8) | 0;
        lo = lo + Math.imul(al2, bl9) | 0;
        mid = mid + Math.imul(al2, bh9) | 0;
        mid = mid + Math.imul(ah2, bl9) | 0;
        hi = hi + Math.imul(ah2, bh9) | 0;
        var w11 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
        w11 &= 0x3ffffff;
        /* k = 12 */ lo = Math.imul(al9, bl3);
        mid = Math.imul(al9, bh3);
        mid = mid + Math.imul(ah9, bl3) | 0;
        hi = Math.imul(ah9, bh3);
        lo = lo + Math.imul(al8, bl4) | 0;
        mid = mid + Math.imul(al8, bh4) | 0;
        mid = mid + Math.imul(ah8, bl4) | 0;
        hi = hi + Math.imul(ah8, bh4) | 0;
        lo = lo + Math.imul(al7, bl5) | 0;
        mid = mid + Math.imul(al7, bh5) | 0;
        mid = mid + Math.imul(ah7, bl5) | 0;
        hi = hi + Math.imul(ah7, bh5) | 0;
        lo = lo + Math.imul(al6, bl6) | 0;
        mid = mid + Math.imul(al6, bh6) | 0;
        mid = mid + Math.imul(ah6, bl6) | 0;
        hi = hi + Math.imul(ah6, bh6) | 0;
        lo = lo + Math.imul(al5, bl7) | 0;
        mid = mid + Math.imul(al5, bh7) | 0;
        mid = mid + Math.imul(ah5, bl7) | 0;
        hi = hi + Math.imul(ah5, bh7) | 0;
        lo = lo + Math.imul(al4, bl8) | 0;
        mid = mid + Math.imul(al4, bh8) | 0;
        mid = mid + Math.imul(ah4, bl8) | 0;
        hi = hi + Math.imul(ah4, bh8) | 0;
        lo = lo + Math.imul(al3, bl9) | 0;
        mid = mid + Math.imul(al3, bh9) | 0;
        mid = mid + Math.imul(ah3, bl9) | 0;
        hi = hi + Math.imul(ah3, bh9) | 0;
        var w12 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
        w12 &= 0x3ffffff;
        /* k = 13 */ lo = Math.imul(al9, bl4);
        mid = Math.imul(al9, bh4);
        mid = mid + Math.imul(ah9, bl4) | 0;
        hi = Math.imul(ah9, bh4);
        lo = lo + Math.imul(al8, bl5) | 0;
        mid = mid + Math.imul(al8, bh5) | 0;
        mid = mid + Math.imul(ah8, bl5) | 0;
        hi = hi + Math.imul(ah8, bh5) | 0;
        lo = lo + Math.imul(al7, bl6) | 0;
        mid = mid + Math.imul(al7, bh6) | 0;
        mid = mid + Math.imul(ah7, bl6) | 0;
        hi = hi + Math.imul(ah7, bh6) | 0;
        lo = lo + Math.imul(al6, bl7) | 0;
        mid = mid + Math.imul(al6, bh7) | 0;
        mid = mid + Math.imul(ah6, bl7) | 0;
        hi = hi + Math.imul(ah6, bh7) | 0;
        lo = lo + Math.imul(al5, bl8) | 0;
        mid = mid + Math.imul(al5, bh8) | 0;
        mid = mid + Math.imul(ah5, bl8) | 0;
        hi = hi + Math.imul(ah5, bh8) | 0;
        lo = lo + Math.imul(al4, bl9) | 0;
        mid = mid + Math.imul(al4, bh9) | 0;
        mid = mid + Math.imul(ah4, bl9) | 0;
        hi = hi + Math.imul(ah4, bh9) | 0;
        var w13 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
        w13 &= 0x3ffffff;
        /* k = 14 */ lo = Math.imul(al9, bl5);
        mid = Math.imul(al9, bh5);
        mid = mid + Math.imul(ah9, bl5) | 0;
        hi = Math.imul(ah9, bh5);
        lo = lo + Math.imul(al8, bl6) | 0;
        mid = mid + Math.imul(al8, bh6) | 0;
        mid = mid + Math.imul(ah8, bl6) | 0;
        hi = hi + Math.imul(ah8, bh6) | 0;
        lo = lo + Math.imul(al7, bl7) | 0;
        mid = mid + Math.imul(al7, bh7) | 0;
        mid = mid + Math.imul(ah7, bl7) | 0;
        hi = hi + Math.imul(ah7, bh7) | 0;
        lo = lo + Math.imul(al6, bl8) | 0;
        mid = mid + Math.imul(al6, bh8) | 0;
        mid = mid + Math.imul(ah6, bl8) | 0;
        hi = hi + Math.imul(ah6, bh8) | 0;
        lo = lo + Math.imul(al5, bl9) | 0;
        mid = mid + Math.imul(al5, bh9) | 0;
        mid = mid + Math.imul(ah5, bl9) | 0;
        hi = hi + Math.imul(ah5, bh9) | 0;
        var w14 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
        w14 &= 0x3ffffff;
        /* k = 15 */ lo = Math.imul(al9, bl6);
        mid = Math.imul(al9, bh6);
        mid = mid + Math.imul(ah9, bl6) | 0;
        hi = Math.imul(ah9, bh6);
        lo = lo + Math.imul(al8, bl7) | 0;
        mid = mid + Math.imul(al8, bh7) | 0;
        mid = mid + Math.imul(ah8, bl7) | 0;
        hi = hi + Math.imul(ah8, bh7) | 0;
        lo = lo + Math.imul(al7, bl8) | 0;
        mid = mid + Math.imul(al7, bh8) | 0;
        mid = mid + Math.imul(ah7, bl8) | 0;
        hi = hi + Math.imul(ah7, bh8) | 0;
        lo = lo + Math.imul(al6, bl9) | 0;
        mid = mid + Math.imul(al6, bh9) | 0;
        mid = mid + Math.imul(ah6, bl9) | 0;
        hi = hi + Math.imul(ah6, bh9) | 0;
        var w15 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
        w15 &= 0x3ffffff;
        /* k = 16 */ lo = Math.imul(al9, bl7);
        mid = Math.imul(al9, bh7);
        mid = mid + Math.imul(ah9, bl7) | 0;
        hi = Math.imul(ah9, bh7);
        lo = lo + Math.imul(al8, bl8) | 0;
        mid = mid + Math.imul(al8, bh8) | 0;
        mid = mid + Math.imul(ah8, bl8) | 0;
        hi = hi + Math.imul(ah8, bh8) | 0;
        lo = lo + Math.imul(al7, bl9) | 0;
        mid = mid + Math.imul(al7, bh9) | 0;
        mid = mid + Math.imul(ah7, bl9) | 0;
        hi = hi + Math.imul(ah7, bh9) | 0;
        var w16 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
        w16 &= 0x3ffffff;
        /* k = 17 */ lo = Math.imul(al9, bl8);
        mid = Math.imul(al9, bh8);
        mid = mid + Math.imul(ah9, bl8) | 0;
        hi = Math.imul(ah9, bh8);
        lo = lo + Math.imul(al8, bl9) | 0;
        mid = mid + Math.imul(al8, bh9) | 0;
        mid = mid + Math.imul(ah8, bl9) | 0;
        hi = hi + Math.imul(ah8, bh9) | 0;
        var w17 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
        w17 &= 0x3ffffff;
        /* k = 18 */ lo = Math.imul(al9, bl9);
        mid = Math.imul(al9, bh9);
        mid = mid + Math.imul(ah9, bl9) | 0;
        hi = Math.imul(ah9, bh9);
        var w18 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
        w18 &= 0x3ffffff;
        o[0] = w0;
        o[1] = w1;
        o[2] = w2;
        o[3] = w3;
        o[4] = w4;
        o[5] = w5;
        o[6] = w6;
        o[7] = w7;
        o[8] = w8;
        o[9] = w9;
        o[10] = w10;
        o[11] = w11;
        o[12] = w12;
        o[13] = w13;
        o[14] = w14;
        o[15] = w15;
        o[16] = w16;
        o[17] = w17;
        o[18] = w18;
        if (c !== 0) {
            o[19] = c;
            out.length++;
        }
        return out;
    };
    // Polyfill comb
    if (!Math.imul) comb10MulTo = smallMulTo;
    function bigMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        out.length = self.length + num.length;
        var carry = 0;
        var hncarry = 0;
        for(var k = 0; k < out.length - 1; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = hncarry;
            hncarry = 0;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j;
                var a = self.words[i] | 0;
                var b = num.words[j] | 0;
                var r = a * b;
                var lo = r & 0x3ffffff;
                ncarry = ncarry + (r / 0x4000000 | 0) | 0;
                lo = lo + rword | 0;
                rword = lo & 0x3ffffff;
                ncarry = ncarry + (lo >>> 26) | 0;
                hncarry += ncarry >>> 26;
                ncarry &= 0x3ffffff;
            }
            out.words[k] = rword;
            carry = ncarry;
            ncarry = hncarry;
        }
        if (carry !== 0) out.words[k] = carry;
        else out.length--;
        return out._strip();
    }
    function jumboMulTo(self, num, out) {
        // Temporary disable, see https://github.com/indutny/bn.js/issues/211
        // var fftm = new FFTM();
        // return fftm.mulp(self, num, out);
        return bigMulTo(self, num, out);
    }
    BN.prototype.mulTo = function mulTo(num, out) {
        var res;
        var len = this.length + num.length;
        if (this.length === 10 && num.length === 10) res = comb10MulTo(this, num, out);
        else if (len < 63) res = smallMulTo(this, num, out);
        else if (len < 1024) res = bigMulTo(this, num, out);
        else res = jumboMulTo(this, num, out);
        return res;
    };
    // Cooley-Tukey algorithm for FFT
    // slightly revisited to rely on looping instead of recursion
    function FFTM(x, y) {
        this.x = x;
        this.y = y;
    }
    FFTM.prototype.makeRBT = function makeRBT(N) {
        var t = new Array(N);
        var l = BN.prototype._countBits(N) - 1;
        for(var i = 0; i < N; i++)t[i] = this.revBin(i, l, N);
        return t;
    };
    // Returns binary-reversed representation of `x`
    FFTM.prototype.revBin = function revBin(x, l, N) {
        if (x === 0 || x === N - 1) return x;
        var rb = 0;
        for(var i = 0; i < l; i++){
            rb |= (x & 1) << l - i - 1;
            x >>= 1;
        }
        return rb;
    };
    // Performs "tweedling" phase, therefore 'emulating'
    // behaviour of the recursive algorithm
    FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
        for(var i = 0; i < N; i++){
            rtws[i] = rws[rbt[i]];
            itws[i] = iws[rbt[i]];
        }
    };
    FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
        this.permute(rbt, rws, iws, rtws, itws, N);
        for(var s = 1; s < N; s <<= 1){
            var l = s << 1;
            var rtwdf = Math.cos(2 * Math.PI / l);
            var itwdf = Math.sin(2 * Math.PI / l);
            for(var p = 0; p < N; p += l){
                var rtwdf_ = rtwdf;
                var itwdf_ = itwdf;
                for(var j = 0; j < s; j++){
                    var re = rtws[p + j];
                    var ie = itws[p + j];
                    var ro = rtws[p + j + s];
                    var io = itws[p + j + s];
                    var rx = rtwdf_ * ro - itwdf_ * io;
                    io = rtwdf_ * io + itwdf_ * ro;
                    ro = rx;
                    rtws[p + j] = re + ro;
                    itws[p + j] = ie + io;
                    rtws[p + j + s] = re - ro;
                    itws[p + j + s] = ie - io;
                    /* jshint maxdepth : false */ if (j !== l) {
                        rx = rtwdf * rtwdf_ - itwdf * itwdf_;
                        itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                        rtwdf_ = rx;
                    }
                }
            }
        }
    };
    FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
        var N = Math.max(m, n) | 1;
        var odd = N & 1;
        var i = 0;
        for(N = N / 2 | 0; N; N = N >>> 1)i++;
        return 1 << i + 1 + odd;
    };
    FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
        if (N <= 1) return;
        for(var i = 0; i < N / 2; i++){
            var t = rws[i];
            rws[i] = rws[N - i - 1];
            rws[N - i - 1] = t;
            t = iws[i];
            iws[i] = -iws[N - i - 1];
            iws[N - i - 1] = -t;
        }
    };
    FFTM.prototype.normalize13b = function normalize13b(ws, N) {
        var carry = 0;
        for(var i = 0; i < N / 2; i++){
            var w = Math.round(ws[2 * i + 1] / N) * 0x2000 + Math.round(ws[2 * i] / N) + carry;
            ws[i] = w & 0x3ffffff;
            if (w < 0x4000000) carry = 0;
            else carry = w / 0x4000000 | 0;
        }
        return ws;
    };
    FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
        var carry = 0;
        for(var i = 0; i < len; i++){
            carry = carry + (ws[i] | 0);
            rws[2 * i] = carry & 0x1fff;
            carry = carry >>> 13;
            rws[2 * i + 1] = carry & 0x1fff;
            carry = carry >>> 13;
        }
        // Pad with zeroes
        for(i = 2 * len; i < N; ++i)rws[i] = 0;
        assert(carry === 0);
        assert((carry & -8192) === 0);
    };
    FFTM.prototype.stub = function stub(N) {
        var ph = new Array(N);
        for(var i = 0; i < N; i++)ph[i] = 0;
        return ph;
    };
    FFTM.prototype.mulp = function mulp(x, y, out) {
        var N = 2 * this.guessLen13b(x.length, y.length);
        var rbt = this.makeRBT(N);
        var _ = this.stub(N);
        var rws = new Array(N);
        var rwst = new Array(N);
        var iwst = new Array(N);
        var nrws = new Array(N);
        var nrwst = new Array(N);
        var niwst = new Array(N);
        var rmws = out.words;
        rmws.length = N;
        this.convert13b(x.words, x.length, rws, N);
        this.convert13b(y.words, y.length, nrws, N);
        this.transform(rws, _, rwst, iwst, N, rbt);
        this.transform(nrws, _, nrwst, niwst, N, rbt);
        for(var i = 0; i < N; i++){
            var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
            iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
            rwst[i] = rx;
        }
        this.conjugate(rwst, iwst, N);
        this.transform(rwst, iwst, rmws, _, N, rbt);
        this.conjugate(rmws, _, N);
        this.normalize13b(rmws, N);
        out.negative = x.negative ^ y.negative;
        out.length = x.length + y.length;
        return out._strip();
    };
    // Multiply `this` by `num`
    BN.prototype.mul = function mul(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return this.mulTo(num, out);
    };
    // Multiply employing FFT
    BN.prototype.mulf = function mulf(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return jumboMulTo(this, num, out);
    };
    // In-place Multiplication
    BN.prototype.imul = function imul(num) {
        return this.clone().mulTo(num, this);
    };
    BN.prototype.imuln = function imuln(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(typeof num === "number");
        assert(num < 0x4000000);
        // Carry
        var carry = 0;
        for(var i = 0; i < this.length; i++){
            var w = (this.words[i] | 0) * num;
            var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
            carry >>= 26;
            carry += w / 0x4000000 | 0;
            // NOTE: lo is 27bit maximum
            carry += lo >>> 26;
            this.words[i] = lo & 0x3ffffff;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return isNegNum ? this.ineg() : this;
    };
    BN.prototype.muln = function muln(num) {
        return this.clone().imuln(num);
    };
    // `this` * `this`
    BN.prototype.sqr = function sqr() {
        return this.mul(this);
    };
    // `this` * `this` in-place
    BN.prototype.isqr = function isqr() {
        return this.imul(this.clone());
    };
    // Math.pow(`this`, `num`)
    BN.prototype.pow = function pow(num) {
        var w = toBitArray(num);
        if (w.length === 0) return new BN(1);
        // Skip leading zeroes
        var res = this;
        for(var i = 0; i < w.length; i++, res = res.sqr()){
            if (w[i] !== 0) break;
        }
        if (++i < w.length) for(var q = res.sqr(); i < w.length; i++, q = q.sqr()){
            if (w[i] === 0) continue;
            res = res.mul(q);
        }
        return res;
    };
    // Shift-left in-place
    BN.prototype.iushln = function iushln(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        var carryMask = 0x3ffffff >>> 26 - r << 26 - r;
        var i;
        if (r !== 0) {
            var carry = 0;
            for(i = 0; i < this.length; i++){
                var newCarry = this.words[i] & carryMask;
                var c = (this.words[i] | 0) - newCarry << r;
                this.words[i] = c | carry;
                carry = newCarry >>> 26 - r;
            }
            if (carry) {
                this.words[i] = carry;
                this.length++;
            }
        }
        if (s !== 0) {
            for(i = this.length - 1; i >= 0; i--)this.words[i + s] = this.words[i];
            for(i = 0; i < s; i++)this.words[i] = 0;
            this.length += s;
        }
        return this._strip();
    };
    BN.prototype.ishln = function ishln(bits) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushln(bits);
    };
    // Shift-right in-place
    // NOTE: `hint` is a lowest bit before trailing zeroes
    // NOTE: if `extended` is present - it will be filled with destroyed bits
    BN.prototype.iushrn = function iushrn(bits, hint, extended) {
        assert(typeof bits === "number" && bits >= 0);
        var h;
        if (hint) h = (hint - hint % 26) / 26;
        else h = 0;
        var r = bits % 26;
        var s = Math.min((bits - r) / 26, this.length);
        var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
        var maskedWords = extended;
        h -= s;
        h = Math.max(0, h);
        // Extended mode, copy masked part
        if (maskedWords) {
            for(var i = 0; i < s; i++)maskedWords.words[i] = this.words[i];
            maskedWords.length = s;
        }
        if (s === 0) ;
        else if (this.length > s) {
            this.length -= s;
            for(i = 0; i < this.length; i++)this.words[i] = this.words[i + s];
        } else {
            this.words[0] = 0;
            this.length = 1;
        }
        var carry = 0;
        for(i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--){
            var word = this.words[i] | 0;
            this.words[i] = carry << 26 - r | word >>> r;
            carry = word & mask;
        }
        // Push carried bits as a mask
        if (maskedWords && carry !== 0) maskedWords.words[maskedWords.length++] = carry;
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this._strip();
    };
    BN.prototype.ishrn = function ishrn(bits, hint, extended) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushrn(bits, hint, extended);
    };
    // Shift-left
    BN.prototype.shln = function shln(bits) {
        return this.clone().ishln(bits);
    };
    BN.prototype.ushln = function ushln(bits) {
        return this.clone().iushln(bits);
    };
    // Shift-right
    BN.prototype.shrn = function shrn(bits) {
        return this.clone().ishrn(bits);
    };
    BN.prototype.ushrn = function ushrn(bits) {
        return this.clone().iushrn(bits);
    };
    // Test if n bit is set
    BN.prototype.testn = function testn(bit) {
        assert(typeof bit === "number" && bit >= 0);
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) return false;
        // Check bit and return
        var w = this.words[s];
        return !!(w & q);
    };
    // Return only lowers bits of number (in-place)
    BN.prototype.imaskn = function imaskn(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        assert(this.negative === 0, "imaskn works only with positive numbers");
        if (this.length <= s) return this;
        if (r !== 0) s++;
        this.length = Math.min(s, this.length);
        if (r !== 0) {
            var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
            this.words[this.length - 1] &= mask;
        }
        return this._strip();
    };
    // Return only lowers bits of number
    BN.prototype.maskn = function maskn(bits) {
        return this.clone().imaskn(bits);
    };
    // Add plain number `num` to `this`
    BN.prototype.iaddn = function iaddn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.isubn(-num);
        // Possible sign change
        if (this.negative !== 0) {
            if (this.length === 1 && (this.words[0] | 0) <= num) {
                this.words[0] = num - (this.words[0] | 0);
                this.negative = 0;
                return this;
            }
            this.negative = 0;
            this.isubn(num);
            this.negative = 1;
            return this;
        }
        // Add without checks
        return this._iaddn(num);
    };
    BN.prototype._iaddn = function _iaddn(num) {
        this.words[0] += num;
        // Carry
        for(var i = 0; i < this.length && this.words[i] >= 0x4000000; i++){
            this.words[i] -= 0x4000000;
            if (i === this.length - 1) this.words[i + 1] = 1;
            else this.words[i + 1]++;
        }
        this.length = Math.max(this.length, i + 1);
        return this;
    };
    // Subtract plain number `num` from `this`
    BN.prototype.isubn = function isubn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.iaddn(-num);
        if (this.negative !== 0) {
            this.negative = 0;
            this.iaddn(num);
            this.negative = 1;
            return this;
        }
        this.words[0] -= num;
        if (this.length === 1 && this.words[0] < 0) {
            this.words[0] = -this.words[0];
            this.negative = 1;
        } else // Carry
        for(var i = 0; i < this.length && this.words[i] < 0; i++){
            this.words[i] += 0x4000000;
            this.words[i + 1] -= 1;
        }
        return this._strip();
    };
    BN.prototype.addn = function addn(num) {
        return this.clone().iaddn(num);
    };
    BN.prototype.subn = function subn(num) {
        return this.clone().isubn(num);
    };
    BN.prototype.iabs = function iabs() {
        this.negative = 0;
        return this;
    };
    BN.prototype.abs = function abs() {
        return this.clone().iabs();
    };
    BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
        var len = num.length + shift;
        var i;
        this._expand(len);
        var w;
        var carry = 0;
        for(i = 0; i < num.length; i++){
            w = (this.words[i + shift] | 0) + carry;
            var right = (num.words[i] | 0) * mul;
            w -= right & 0x3ffffff;
            carry = (w >> 26) - (right / 0x4000000 | 0);
            this.words[i + shift] = w & 0x3ffffff;
        }
        for(; i < this.length - shift; i++){
            w = (this.words[i + shift] | 0) + carry;
            carry = w >> 26;
            this.words[i + shift] = w & 0x3ffffff;
        }
        if (carry === 0) return this._strip();
        // Subtraction overflow
        assert(carry === -1);
        carry = 0;
        for(i = 0; i < this.length; i++){
            w = -(this.words[i] | 0) + carry;
            carry = w >> 26;
            this.words[i] = w & 0x3ffffff;
        }
        this.negative = 1;
        return this._strip();
    };
    BN.prototype._wordDiv = function _wordDiv(num, mode) {
        var shift = this.length - num.length;
        var a = this.clone();
        var b = num;
        // Normalize
        var bhi = b.words[b.length - 1] | 0;
        var bhiBits = this._countBits(bhi);
        shift = 26 - bhiBits;
        if (shift !== 0) {
            b = b.ushln(shift);
            a.iushln(shift);
            bhi = b.words[b.length - 1] | 0;
        }
        // Initialize quotient
        var m = a.length - b.length;
        var q;
        if (mode !== "mod") {
            q = new BN(null);
            q.length = m + 1;
            q.words = new Array(q.length);
            for(var i = 0; i < q.length; i++)q.words[i] = 0;
        }
        var diff = a.clone()._ishlnsubmul(b, 1, m);
        if (diff.negative === 0) {
            a = diff;
            if (q) q.words[m] = 1;
        }
        for(var j = m - 1; j >= 0; j--){
            var qj = (a.words[b.length + j] | 0) * 0x4000000 + (a.words[b.length + j - 1] | 0);
            // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
            // (0x7ffffff)
            qj = Math.min(qj / bhi | 0, 0x3ffffff);
            a._ishlnsubmul(b, qj, j);
            while(a.negative !== 0){
                qj--;
                a.negative = 0;
                a._ishlnsubmul(b, 1, j);
                if (!a.isZero()) a.negative ^= 1;
            }
            if (q) q.words[j] = qj;
        }
        if (q) q._strip();
        a._strip();
        // Denormalize
        if (mode !== "div" && shift !== 0) a.iushrn(shift);
        return {
            div: q || null,
            mod: a
        };
    };
    // NOTE: 1) `mode` can be set to `mod` to request mod only,
    //       to `div` to request div only, or be absent to
    //       request both div & mod
    //       2) `positive` is true if unsigned mod is requested
    BN.prototype.divmod = function divmod(num, mode, positive) {
        assert(!num.isZero());
        if (this.isZero()) return {
            div: new BN(0),
            mod: new BN(0)
        };
        var div, mod, res;
        if (this.negative !== 0 && num.negative === 0) {
            res = this.neg().divmod(num, mode);
            if (mode !== "mod") div = res.div.neg();
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.iadd(num);
            }
            return {
                div: div,
                mod: mod
            };
        }
        if (this.negative === 0 && num.negative !== 0) {
            res = this.divmod(num.neg(), mode);
            if (mode !== "mod") div = res.div.neg();
            return {
                div: div,
                mod: res.mod
            };
        }
        if ((this.negative & num.negative) !== 0) {
            res = this.neg().divmod(num.neg(), mode);
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.isub(num);
            }
            return {
                div: res.div,
                mod: mod
            };
        }
        // Both numbers are positive at this point
        // Strip both numbers to approximate shift value
        if (num.length > this.length || this.cmp(num) < 0) return {
            div: new BN(0),
            mod: this
        };
        // Very short reduction
        if (num.length === 1) {
            if (mode === "div") return {
                div: this.divn(num.words[0]),
                mod: null
            };
            if (mode === "mod") return {
                div: null,
                mod: new BN(this.modrn(num.words[0]))
            };
            return {
                div: this.divn(num.words[0]),
                mod: new BN(this.modrn(num.words[0]))
            };
        }
        return this._wordDiv(num, mode);
    };
    // Find `this` / `num`
    BN.prototype.div = function div(num) {
        return this.divmod(num, "div", false).div;
    };
    // Find `this` % `num`
    BN.prototype.mod = function mod(num) {
        return this.divmod(num, "mod", false).mod;
    };
    BN.prototype.umod = function umod(num) {
        return this.divmod(num, "mod", true).mod;
    };
    // Find Round(`this` / `num`)
    BN.prototype.divRound = function divRound(num) {
        var dm = this.divmod(num);
        // Fast case - exact division
        if (dm.mod.isZero()) return dm.div;
        var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;
        var half = num.ushrn(1);
        var r2 = num.andln(1);
        var cmp = mod.cmp(half);
        // Round down
        if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
        // Round up
        return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
    };
    BN.prototype.modrn = function modrn(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(num <= 0x3ffffff);
        var p = 67108864 % num;
        var acc = 0;
        for(var i = this.length - 1; i >= 0; i--)acc = (p * acc + (this.words[i] | 0)) % num;
        return isNegNum ? -acc : acc;
    };
    // WARNING: DEPRECATED
    BN.prototype.modn = function modn(num) {
        return this.modrn(num);
    };
    // In-place division by number
    BN.prototype.idivn = function idivn(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(num <= 0x3ffffff);
        var carry = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var w = (this.words[i] | 0) + carry * 0x4000000;
            this.words[i] = w / num | 0;
            carry = w % num;
        }
        this._strip();
        return isNegNum ? this.ineg() : this;
    };
    BN.prototype.divn = function divn(num) {
        return this.clone().idivn(num);
    };
    BN.prototype.egcd = function egcd(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var x = this;
        var y = p.clone();
        if (x.negative !== 0) x = x.umod(p);
        else x = x.clone();
        // A * x + B * y = x
        var A = new BN(1);
        var B = new BN(0);
        // C * x + D * y = y
        var C = new BN(0);
        var D = new BN(1);
        var g = 0;
        while(x.isEven() && y.isEven()){
            x.iushrn(1);
            y.iushrn(1);
            ++g;
        }
        var yp = y.clone();
        var xp = x.clone();
        while(!x.isZero()){
            for(var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                x.iushrn(i);
                while(i-- > 0){
                    if (A.isOdd() || B.isOdd()) {
                        A.iadd(yp);
                        B.isub(xp);
                    }
                    A.iushrn(1);
                    B.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                y.iushrn(j);
                while(j-- > 0){
                    if (C.isOdd() || D.isOdd()) {
                        C.iadd(yp);
                        D.isub(xp);
                    }
                    C.iushrn(1);
                    D.iushrn(1);
                }
            }
            if (x.cmp(y) >= 0) {
                x.isub(y);
                A.isub(C);
                B.isub(D);
            } else {
                y.isub(x);
                C.isub(A);
                D.isub(B);
            }
        }
        return {
            a: C,
            b: D,
            gcd: y.iushln(g)
        };
    };
    // This is reduced incarnation of the binary EEA
    // above, designated to invert members of the
    // _prime_ fields F(p) at a maximal speed
    BN.prototype._invmp = function _invmp(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var a = this;
        var b = p.clone();
        if (a.negative !== 0) a = a.umod(p);
        else a = a.clone();
        var x1 = new BN(1);
        var x2 = new BN(0);
        var delta = b.clone();
        while(a.cmpn(1) > 0 && b.cmpn(1) > 0){
            for(var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                a.iushrn(i);
                while(i-- > 0){
                    if (x1.isOdd()) x1.iadd(delta);
                    x1.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                b.iushrn(j);
                while(j-- > 0){
                    if (x2.isOdd()) x2.iadd(delta);
                    x2.iushrn(1);
                }
            }
            if (a.cmp(b) >= 0) {
                a.isub(b);
                x1.isub(x2);
            } else {
                b.isub(a);
                x2.isub(x1);
            }
        }
        var res;
        if (a.cmpn(1) === 0) res = x1;
        else res = x2;
        if (res.cmpn(0) < 0) res.iadd(p);
        return res;
    };
    BN.prototype.gcd = function gcd(num) {
        if (this.isZero()) return num.abs();
        if (num.isZero()) return this.abs();
        var a = this.clone();
        var b = num.clone();
        a.negative = 0;
        b.negative = 0;
        // Remove common factor of two
        for(var shift = 0; a.isEven() && b.isEven(); shift++){
            a.iushrn(1);
            b.iushrn(1);
        }
        do {
            while(a.isEven())a.iushrn(1);
            while(b.isEven())b.iushrn(1);
            var r = a.cmp(b);
            if (r < 0) {
                // Swap `a` and `b` to make `a` always bigger than `b`
                var t = a;
                a = b;
                b = t;
            } else if (r === 0 || b.cmpn(1) === 0) break;
            a.isub(b);
        }while (true);
        return b.iushln(shift);
    };
    // Invert number in the field F(num)
    BN.prototype.invm = function invm(num) {
        return this.egcd(num).a.umod(num);
    };
    BN.prototype.isEven = function isEven() {
        return (this.words[0] & 1) === 0;
    };
    BN.prototype.isOdd = function isOdd() {
        return (this.words[0] & 1) === 1;
    };
    // And first word and num
    BN.prototype.andln = function andln(num) {
        return this.words[0] & num;
    };
    // Increment at the bit position in-line
    BN.prototype.bincn = function bincn(bit) {
        assert(typeof bit === "number");
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) {
            this._expand(s + 1);
            this.words[s] |= q;
            return this;
        }
        // Add bit and propagate, if needed
        var carry = q;
        for(var i = s; carry !== 0 && i < this.length; i++){
            var w = this.words[i] | 0;
            w += carry;
            carry = w >>> 26;
            w &= 0x3ffffff;
            this.words[i] = w;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.isZero = function isZero() {
        return this.length === 1 && this.words[0] === 0;
    };
    BN.prototype.cmpn = function cmpn(num) {
        var negative = num < 0;
        if (this.negative !== 0 && !negative) return -1;
        if (this.negative === 0 && negative) return 1;
        this._strip();
        var res;
        if (this.length > 1) res = 1;
        else {
            if (negative) num = -num;
            assert(num <= 0x3ffffff, "Number is too big");
            var w = this.words[0] | 0;
            res = w === num ? 0 : w < num ? -1 : 1;
        }
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Compare two numbers and return:
    // 1 - if `this` > `num`
    // 0 - if `this` == `num`
    // -1 - if `this` < `num`
    BN.prototype.cmp = function cmp(num) {
        if (this.negative !== 0 && num.negative === 0) return -1;
        if (this.negative === 0 && num.negative !== 0) return 1;
        var res = this.ucmp(num);
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Unsigned comparison
    BN.prototype.ucmp = function ucmp(num) {
        // At this point both numbers have the same sign
        if (this.length > num.length) return 1;
        if (this.length < num.length) return -1;
        var res = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var a = this.words[i] | 0;
            var b = num.words[i] | 0;
            if (a === b) continue;
            if (a < b) res = -1;
            else if (a > b) res = 1;
            break;
        }
        return res;
    };
    BN.prototype.gtn = function gtn(num) {
        return this.cmpn(num) === 1;
    };
    BN.prototype.gt = function gt(num) {
        return this.cmp(num) === 1;
    };
    BN.prototype.gten = function gten(num) {
        return this.cmpn(num) >= 0;
    };
    BN.prototype.gte = function gte(num) {
        return this.cmp(num) >= 0;
    };
    BN.prototype.ltn = function ltn(num) {
        return this.cmpn(num) === -1;
    };
    BN.prototype.lt = function lt(num) {
        return this.cmp(num) === -1;
    };
    BN.prototype.lten = function lten(num) {
        return this.cmpn(num) <= 0;
    };
    BN.prototype.lte = function lte(num) {
        return this.cmp(num) <= 0;
    };
    BN.prototype.eqn = function eqn(num) {
        return this.cmpn(num) === 0;
    };
    BN.prototype.eq = function eq(num) {
        return this.cmp(num) === 0;
    };
    //
    // A reduce context, could be using montgomery or something better, depending
    // on the `m` itself.
    //
    BN.red = function red(num) {
        return new Red(num);
    };
    BN.prototype.toRed = function toRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        assert(this.negative === 0, "red works only with positives");
        return ctx.convertTo(this)._forceRed(ctx);
    };
    BN.prototype.fromRed = function fromRed() {
        assert(this.red, "fromRed works only with numbers in reduction context");
        return this.red.convertFrom(this);
    };
    BN.prototype._forceRed = function _forceRed(ctx) {
        this.red = ctx;
        return this;
    };
    BN.prototype.forceRed = function forceRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        return this._forceRed(ctx);
    };
    BN.prototype.redAdd = function redAdd(num) {
        assert(this.red, "redAdd works only with red numbers");
        return this.red.add(this, num);
    };
    BN.prototype.redIAdd = function redIAdd(num) {
        assert(this.red, "redIAdd works only with red numbers");
        return this.red.iadd(this, num);
    };
    BN.prototype.redSub = function redSub(num) {
        assert(this.red, "redSub works only with red numbers");
        return this.red.sub(this, num);
    };
    BN.prototype.redISub = function redISub(num) {
        assert(this.red, "redISub works only with red numbers");
        return this.red.isub(this, num);
    };
    BN.prototype.redShl = function redShl(num) {
        assert(this.red, "redShl works only with red numbers");
        return this.red.shl(this, num);
    };
    BN.prototype.redMul = function redMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.mul(this, num);
    };
    BN.prototype.redIMul = function redIMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.imul(this, num);
    };
    BN.prototype.redSqr = function redSqr() {
        assert(this.red, "redSqr works only with red numbers");
        this.red._verify1(this);
        return this.red.sqr(this);
    };
    BN.prototype.redISqr = function redISqr() {
        assert(this.red, "redISqr works only with red numbers");
        this.red._verify1(this);
        return this.red.isqr(this);
    };
    // Square root over p
    BN.prototype.redSqrt = function redSqrt() {
        assert(this.red, "redSqrt works only with red numbers");
        this.red._verify1(this);
        return this.red.sqrt(this);
    };
    BN.prototype.redInvm = function redInvm() {
        assert(this.red, "redInvm works only with red numbers");
        this.red._verify1(this);
        return this.red.invm(this);
    };
    // Return negative clone of `this` % `red modulo`
    BN.prototype.redNeg = function redNeg() {
        assert(this.red, "redNeg works only with red numbers");
        this.red._verify1(this);
        return this.red.neg(this);
    };
    BN.prototype.redPow = function redPow(num) {
        assert(this.red && !num.red, "redPow(normalNum)");
        this.red._verify1(this);
        return this.red.pow(this, num);
    };
    // Prime numbers with efficient reduction
    var primes = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
    };
    // Pseudo-Mersenne prime
    function MPrime(name, p) {
        // P = 2 ^ N - K
        this.name = name;
        this.p = new BN(p, 16);
        this.n = this.p.bitLength();
        this.k = new BN(1).iushln(this.n).isub(this.p);
        this.tmp = this._tmp();
    }
    MPrime.prototype._tmp = function _tmp() {
        var tmp = new BN(null);
        tmp.words = new Array(Math.ceil(this.n / 13));
        return tmp;
    };
    MPrime.prototype.ireduce = function ireduce(num) {
        // Assumes that `num` is less than `P^2`
        // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
        var r = num;
        var rlen;
        do {
            this.split(r, this.tmp);
            r = this.imulK(r);
            r = r.iadd(this.tmp);
            rlen = r.bitLength();
        }while (rlen > this.n);
        var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
        if (cmp === 0) {
            r.words[0] = 0;
            r.length = 1;
        } else if (cmp > 0) r.isub(this.p);
        else if (r.strip !== undefined) // r is a BN v4 instance
        r.strip();
        else // r is a BN v5 instance
        r._strip();
        return r;
    };
    MPrime.prototype.split = function split(input, out) {
        input.iushrn(this.n, 0, out);
    };
    MPrime.prototype.imulK = function imulK(num) {
        return num.imul(this.k);
    };
    function K256() {
        MPrime.call(this, "k256", "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f");
    }
    inherits(K256, MPrime);
    K256.prototype.split = function split(input, output) {
        // 256 = 9 * 26 + 22
        var mask = 0x3fffff;
        var outLen = Math.min(input.length, 9);
        for(var i = 0; i < outLen; i++)output.words[i] = input.words[i];
        output.length = outLen;
        if (input.length <= 9) {
            input.words[0] = 0;
            input.length = 1;
            return;
        }
        // Shift by 9 limbs
        var prev = input.words[9];
        output.words[output.length++] = prev & mask;
        for(i = 10; i < input.length; i++){
            var next = input.words[i] | 0;
            input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
            prev = next;
        }
        prev >>>= 22;
        input.words[i - 10] = prev;
        if (prev === 0 && input.length > 10) input.length -= 10;
        else input.length -= 9;
    };
    K256.prototype.imulK = function imulK(num) {
        // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
        num.words[num.length] = 0;
        num.words[num.length + 1] = 0;
        num.length += 2;
        // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
        var lo = 0;
        for(var i = 0; i < num.length; i++){
            var w = num.words[i] | 0;
            lo += w * 0x3d1;
            num.words[i] = lo & 0x3ffffff;
            lo = w * 0x40 + (lo / 0x4000000 | 0);
        }
        // Fast length reduction
        if (num.words[num.length - 1] === 0) {
            num.length--;
            if (num.words[num.length - 1] === 0) num.length--;
        }
        return num;
    };
    function P224() {
        MPrime.call(this, "p224", "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001");
    }
    inherits(P224, MPrime);
    function P192() {
        MPrime.call(this, "p192", "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff");
    }
    inherits(P192, MPrime);
    function P25519() {
        // 2 ^ 255 - 19
        MPrime.call(this, "25519", "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed");
    }
    inherits(P25519, MPrime);
    P25519.prototype.imulK = function imulK(num) {
        // K = 0x13
        var carry = 0;
        for(var i = 0; i < num.length; i++){
            var hi = (num.words[i] | 0) * 0x13 + carry;
            var lo = hi & 0x3ffffff;
            hi >>>= 26;
            num.words[i] = lo;
            carry = hi;
        }
        if (carry !== 0) num.words[num.length++] = carry;
        return num;
    };
    // Exported mostly for testing purposes, use plain name instead
    BN._prime = function prime(name) {
        // Cached version of prime
        if (primes[name]) return primes[name];
        var prime;
        if (name === "k256") prime = new K256();
        else if (name === "p224") prime = new P224();
        else if (name === "p192") prime = new P192();
        else if (name === "p25519") prime = new P25519();
        else throw new Error("Unknown prime " + name);
        primes[name] = prime;
        return prime;
    };
    //
    // Base reduction engine
    //
    function Red(m) {
        if (typeof m === "string") {
            var prime = BN._prime(m);
            this.m = prime.p;
            this.prime = prime;
        } else {
            assert(m.gtn(1), "modulus must be greater than 1");
            this.m = m;
            this.prime = null;
        }
    }
    Red.prototype._verify1 = function _verify1(a) {
        assert(a.negative === 0, "red works only with positives");
        assert(a.red, "red works only with red numbers");
    };
    Red.prototype._verify2 = function _verify2(a, b) {
        assert((a.negative | b.negative) === 0, "red works only with positives");
        assert(a.red && a.red === b.red, "red works only with red numbers");
    };
    Red.prototype.imod = function imod(a) {
        if (this.prime) return this.prime.ireduce(a)._forceRed(this);
        move(a, a.umod(this.m)._forceRed(this));
        return a;
    };
    Red.prototype.neg = function neg(a) {
        if (a.isZero()) return a.clone();
        return this.m.sub(a)._forceRed(this);
    };
    Red.prototype.add = function add(a, b) {
        this._verify2(a, b);
        var res = a.add(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res._forceRed(this);
    };
    Red.prototype.iadd = function iadd(a, b) {
        this._verify2(a, b);
        var res = a.iadd(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res;
    };
    Red.prototype.sub = function sub(a, b) {
        this._verify2(a, b);
        var res = a.sub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res._forceRed(this);
    };
    Red.prototype.isub = function isub(a, b) {
        this._verify2(a, b);
        var res = a.isub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res;
    };
    Red.prototype.shl = function shl(a, num) {
        this._verify1(a);
        return this.imod(a.ushln(num));
    };
    Red.prototype.imul = function imul(a, b) {
        this._verify2(a, b);
        return this.imod(a.imul(b));
    };
    Red.prototype.mul = function mul(a, b) {
        this._verify2(a, b);
        return this.imod(a.mul(b));
    };
    Red.prototype.isqr = function isqr(a) {
        return this.imul(a, a.clone());
    };
    Red.prototype.sqr = function sqr(a) {
        return this.mul(a, a);
    };
    Red.prototype.sqrt = function sqrt(a) {
        if (a.isZero()) return a.clone();
        var mod3 = this.m.andln(3);
        assert(mod3 % 2 === 1);
        // Fast case
        if (mod3 === 3) {
            var pow = this.m.add(new BN(1)).iushrn(2);
            return this.pow(a, pow);
        }
        // Tonelli-Shanks algorithm (Totally unoptimized and slow)
        //
        // Find Q and S, that Q * 2 ^ S = (P - 1)
        var q = this.m.subn(1);
        var s = 0;
        while(!q.isZero() && q.andln(1) === 0){
            s++;
            q.iushrn(1);
        }
        assert(!q.isZero());
        var one = new BN(1).toRed(this);
        var nOne = one.redNeg();
        // Find quadratic non-residue
        // NOTE: Max is such because of generalized Riemann hypothesis.
        var lpow = this.m.subn(1).iushrn(1);
        var z = this.m.bitLength();
        z = new BN(2 * z * z).toRed(this);
        while(this.pow(z, lpow).cmp(nOne) !== 0)z.redIAdd(nOne);
        var c = this.pow(z, q);
        var r = this.pow(a, q.addn(1).iushrn(1));
        var t = this.pow(a, q);
        var m = s;
        while(t.cmp(one) !== 0){
            var tmp = t;
            for(var i = 0; tmp.cmp(one) !== 0; i++)tmp = tmp.redSqr();
            assert(i < m);
            var b = this.pow(c, new BN(1).iushln(m - i - 1));
            r = r.redMul(b);
            c = b.redSqr();
            t = t.redMul(c);
            m = i;
        }
        return r;
    };
    Red.prototype.invm = function invm(a) {
        var inv = a._invmp(this.m);
        if (inv.negative !== 0) {
            inv.negative = 0;
            return this.imod(inv).redNeg();
        } else return this.imod(inv);
    };
    Red.prototype.pow = function pow(a, num) {
        if (num.isZero()) return new BN(1).toRed(this);
        if (num.cmpn(1) === 0) return a.clone();
        var windowSize = 4;
        var wnd = new Array(1 << windowSize);
        wnd[0] = new BN(1).toRed(this);
        wnd[1] = a;
        for(var i = 2; i < wnd.length; i++)wnd[i] = this.mul(wnd[i - 1], a);
        var res = wnd[0];
        var current = 0;
        var currentLen = 0;
        var start = num.bitLength() % 26;
        if (start === 0) start = 26;
        for(i = num.length - 1; i >= 0; i--){
            var word = num.words[i];
            for(var j = start - 1; j >= 0; j--){
                var bit = word >> j & 1;
                if (res !== wnd[0]) res = this.sqr(res);
                if (bit === 0 && current === 0) {
                    currentLen = 0;
                    continue;
                }
                current <<= 1;
                current |= bit;
                currentLen++;
                if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
                res = this.mul(res, wnd[current]);
                currentLen = 0;
                current = 0;
            }
            start = 26;
        }
        return res;
    };
    Red.prototype.convertTo = function convertTo(num) {
        var r = num.umod(this.m);
        return r === num ? r.clone() : r;
    };
    Red.prototype.convertFrom = function convertFrom(num) {
        var res = num.clone();
        res.red = null;
        return res;
    };
    //
    // Montgomery method engine
    //
    BN.mont = function mont(num) {
        return new Mont(num);
    };
    function Mont(m) {
        Red.call(this, m);
        this.shift = this.m.bitLength();
        if (this.shift % 26 !== 0) this.shift += 26 - this.shift % 26;
        this.r = new BN(1).iushln(this.shift);
        this.r2 = this.imod(this.r.sqr());
        this.rinv = this.r._invmp(this.m);
        this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
        this.minv = this.minv.umod(this.r);
        this.minv = this.r.sub(this.minv);
    }
    inherits(Mont, Red);
    Mont.prototype.convertTo = function convertTo(num) {
        return this.imod(num.ushln(this.shift));
    };
    Mont.prototype.convertFrom = function convertFrom(num) {
        var r = this.imod(num.mul(this.rinv));
        r.red = null;
        return r;
    };
    Mont.prototype.imul = function imul(a, b) {
        if (a.isZero() || b.isZero()) {
            a.words[0] = 0;
            a.length = 1;
            return a;
        }
        var t = a.imul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.mul = function mul(a, b) {
        if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
        var t = a.mul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.invm = function invm(a) {
        // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
        var res = this.imod(a._invmp(this.m).mul(this.r2));
        return res._forceRed(this);
    };
})(module, this);

},{"5c17eeb63b5cdfb8":"13Pcp"}],"iwHvk":[function(require,module,exports) {
"use strict";
var inherits = require("45ce174cec337471");
var MD5 = require("4170b0039f3b4aab");
var RIPEMD160 = require("efcc6ede1fda4d98");
var sha = require("65b1a51ddac82548");
var Base = require("ac5a46c0f3b4d769");
function Hash(hash) {
    Base.call(this, "digest");
    this._hash = hash;
}
inherits(Hash, Base);
Hash.prototype._update = function(data) {
    this._hash.update(data);
};
Hash.prototype._final = function() {
    return this._hash.digest();
};
module.exports = function createHash(alg) {
    alg = alg.toLowerCase();
    if (alg === "md5") return new MD5();
    if (alg === "rmd160" || alg === "ripemd160") return new RIPEMD160();
    return new Hash(sha(alg));
};

},{"45ce174cec337471":"8LxVj","4170b0039f3b4aab":"i9uFm","efcc6ede1fda4d98":"iRD8I","65b1a51ddac82548":"7ZUZ8","ac5a46c0f3b4d769":"7VZSW"}],"i9uFm":[function(require,module,exports) {
"use strict";
var inherits = require("634114d48656c754");
var HashBase = require("4b170874b4cb8d4e");
var Buffer = require("72d4e45c6a42a2da").Buffer;
var ARRAY16 = new Array(16);
function MD5() {
    HashBase.call(this, 64);
    // state
    this._a = 0x67452301;
    this._b = 0xefcdab89;
    this._c = 0x98badcfe;
    this._d = 0x10325476;
}
inherits(MD5, HashBase);
MD5.prototype._update = function() {
    var M = ARRAY16;
    for(var i = 0; i < 16; ++i)M[i] = this._block.readInt32LE(i * 4);
    var a = this._a;
    var b = this._b;
    var c = this._c;
    var d = this._d;
    a = fnF(a, b, c, d, M[0], 0xd76aa478, 7);
    d = fnF(d, a, b, c, M[1], 0xe8c7b756, 12);
    c = fnF(c, d, a, b, M[2], 0x242070db, 17);
    b = fnF(b, c, d, a, M[3], 0xc1bdceee, 22);
    a = fnF(a, b, c, d, M[4], 0xf57c0faf, 7);
    d = fnF(d, a, b, c, M[5], 0x4787c62a, 12);
    c = fnF(c, d, a, b, M[6], 0xa8304613, 17);
    b = fnF(b, c, d, a, M[7], 0xfd469501, 22);
    a = fnF(a, b, c, d, M[8], 0x698098d8, 7);
    d = fnF(d, a, b, c, M[9], 0x8b44f7af, 12);
    c = fnF(c, d, a, b, M[10], 0xffff5bb1, 17);
    b = fnF(b, c, d, a, M[11], 0x895cd7be, 22);
    a = fnF(a, b, c, d, M[12], 0x6b901122, 7);
    d = fnF(d, a, b, c, M[13], 0xfd987193, 12);
    c = fnF(c, d, a, b, M[14], 0xa679438e, 17);
    b = fnF(b, c, d, a, M[15], 0x49b40821, 22);
    a = fnG(a, b, c, d, M[1], 0xf61e2562, 5);
    d = fnG(d, a, b, c, M[6], 0xc040b340, 9);
    c = fnG(c, d, a, b, M[11], 0x265e5a51, 14);
    b = fnG(b, c, d, a, M[0], 0xe9b6c7aa, 20);
    a = fnG(a, b, c, d, M[5], 0xd62f105d, 5);
    d = fnG(d, a, b, c, M[10], 0x02441453, 9);
    c = fnG(c, d, a, b, M[15], 0xd8a1e681, 14);
    b = fnG(b, c, d, a, M[4], 0xe7d3fbc8, 20);
    a = fnG(a, b, c, d, M[9], 0x21e1cde6, 5);
    d = fnG(d, a, b, c, M[14], 0xc33707d6, 9);
    c = fnG(c, d, a, b, M[3], 0xf4d50d87, 14);
    b = fnG(b, c, d, a, M[8], 0x455a14ed, 20);
    a = fnG(a, b, c, d, M[13], 0xa9e3e905, 5);
    d = fnG(d, a, b, c, M[2], 0xfcefa3f8, 9);
    c = fnG(c, d, a, b, M[7], 0x676f02d9, 14);
    b = fnG(b, c, d, a, M[12], 0x8d2a4c8a, 20);
    a = fnH(a, b, c, d, M[5], 0xfffa3942, 4);
    d = fnH(d, a, b, c, M[8], 0x8771f681, 11);
    c = fnH(c, d, a, b, M[11], 0x6d9d6122, 16);
    b = fnH(b, c, d, a, M[14], 0xfde5380c, 23);
    a = fnH(a, b, c, d, M[1], 0xa4beea44, 4);
    d = fnH(d, a, b, c, M[4], 0x4bdecfa9, 11);
    c = fnH(c, d, a, b, M[7], 0xf6bb4b60, 16);
    b = fnH(b, c, d, a, M[10], 0xbebfbc70, 23);
    a = fnH(a, b, c, d, M[13], 0x289b7ec6, 4);
    d = fnH(d, a, b, c, M[0], 0xeaa127fa, 11);
    c = fnH(c, d, a, b, M[3], 0xd4ef3085, 16);
    b = fnH(b, c, d, a, M[6], 0x04881d05, 23);
    a = fnH(a, b, c, d, M[9], 0xd9d4d039, 4);
    d = fnH(d, a, b, c, M[12], 0xe6db99e5, 11);
    c = fnH(c, d, a, b, M[15], 0x1fa27cf8, 16);
    b = fnH(b, c, d, a, M[2], 0xc4ac5665, 23);
    a = fnI(a, b, c, d, M[0], 0xf4292244, 6);
    d = fnI(d, a, b, c, M[7], 0x432aff97, 10);
    c = fnI(c, d, a, b, M[14], 0xab9423a7, 15);
    b = fnI(b, c, d, a, M[5], 0xfc93a039, 21);
    a = fnI(a, b, c, d, M[12], 0x655b59c3, 6);
    d = fnI(d, a, b, c, M[3], 0x8f0ccc92, 10);
    c = fnI(c, d, a, b, M[10], 0xffeff47d, 15);
    b = fnI(b, c, d, a, M[1], 0x85845dd1, 21);
    a = fnI(a, b, c, d, M[8], 0x6fa87e4f, 6);
    d = fnI(d, a, b, c, M[15], 0xfe2ce6e0, 10);
    c = fnI(c, d, a, b, M[6], 0xa3014314, 15);
    b = fnI(b, c, d, a, M[13], 0x4e0811a1, 21);
    a = fnI(a, b, c, d, M[4], 0xf7537e82, 6);
    d = fnI(d, a, b, c, M[11], 0xbd3af235, 10);
    c = fnI(c, d, a, b, M[2], 0x2ad7d2bb, 15);
    b = fnI(b, c, d, a, M[9], 0xeb86d391, 21);
    this._a = this._a + a | 0;
    this._b = this._b + b | 0;
    this._c = this._c + c | 0;
    this._d = this._d + d | 0;
};
MD5.prototype._digest = function() {
    // create padding and handle blocks
    this._block[this._blockOffset++] = 0x80;
    if (this._blockOffset > 56) {
        this._block.fill(0, this._blockOffset, 64);
        this._update();
        this._blockOffset = 0;
    }
    this._block.fill(0, this._blockOffset, 56);
    this._block.writeUInt32LE(this._length[0], 56);
    this._block.writeUInt32LE(this._length[1], 60);
    this._update();
    // produce result
    var buffer = Buffer.allocUnsafe(16);
    buffer.writeInt32LE(this._a, 0);
    buffer.writeInt32LE(this._b, 4);
    buffer.writeInt32LE(this._c, 8);
    buffer.writeInt32LE(this._d, 12);
    return buffer;
};
function rotl(x, n) {
    return x << n | x >>> 32 - n;
}
function fnF(a, b, c, d, m, k, s) {
    return rotl(a + (b & c | ~b & d) + m + k | 0, s) + b | 0;
}
function fnG(a, b, c, d, m, k, s) {
    return rotl(a + (b & d | c & ~d) + m + k | 0, s) + b | 0;
}
function fnH(a, b, c, d, m, k, s) {
    return rotl(a + (b ^ c ^ d) + m + k | 0, s) + b | 0;
}
function fnI(a, b, c, d, m, k, s) {
    return rotl(a + (c ^ (b | ~d)) + m + k | 0, s) + b | 0;
}
module.exports = MD5;

},{"634114d48656c754":"8LxVj","4b170874b4cb8d4e":"bkj8g","72d4e45c6a42a2da":"6hBQU"}],"bkj8g":[function(require,module,exports) {
"use strict";
var Buffer = require("27eaec8a721206a5").Buffer;
var Transform = require("c5aab47d8f1d340a").Transform;
var inherits = require("91e9fa68d440541e");
function throwIfNotStringOrBuffer(val, prefix) {
    if (!Buffer.isBuffer(val) && typeof val !== "string") throw new TypeError(prefix + " must be a string or a buffer");
}
function HashBase(blockSize) {
    Transform.call(this);
    this._block = Buffer.allocUnsafe(blockSize);
    this._blockSize = blockSize;
    this._blockOffset = 0;
    this._length = [
        0,
        0,
        0,
        0
    ];
    this._finalized = false;
}
inherits(HashBase, Transform);
HashBase.prototype._transform = function(chunk, encoding, callback) {
    var error = null;
    try {
        this.update(chunk, encoding);
    } catch (err) {
        error = err;
    }
    callback(error);
};
HashBase.prototype._flush = function(callback) {
    var error = null;
    try {
        this.push(this.digest());
    } catch (err) {
        error = err;
    }
    callback(error);
};
HashBase.prototype.update = function(data, encoding) {
    throwIfNotStringOrBuffer(data, "Data");
    if (this._finalized) throw new Error("Digest already called");
    if (!Buffer.isBuffer(data)) data = Buffer.from(data, encoding);
    // consume data
    var block = this._block;
    var offset = 0;
    while(this._blockOffset + data.length - offset >= this._blockSize){
        for(var i = this._blockOffset; i < this._blockSize;)block[i++] = data[offset++];
        this._update();
        this._blockOffset = 0;
    }
    while(offset < data.length)block[this._blockOffset++] = data[offset++];
    // update length
    for(var j = 0, carry = data.length * 8; carry > 0; ++j){
        this._length[j] += carry;
        carry = this._length[j] / 0x0100000000 | 0;
        if (carry > 0) this._length[j] -= 0x0100000000 * carry;
    }
    return this;
};
HashBase.prototype._update = function() {
    throw new Error("_update is not implemented");
};
HashBase.prototype.digest = function(encoding) {
    if (this._finalized) throw new Error("Digest already called");
    this._finalized = true;
    var digest = this._digest();
    if (encoding !== undefined) digest = digest.toString(encoding);
    // reset state
    this._block.fill(0);
    this._blockOffset = 0;
    for(var i = 0; i < 4; ++i)this._length[i] = 0;
    return digest;
};
HashBase.prototype._digest = function() {
    throw new Error("_digest is not implemented");
};
module.exports = HashBase;

},{"27eaec8a721206a5":"6hBQU","c5aab47d8f1d340a":"k5khq","91e9fa68d440541e":"8LxVj"}],"iRD8I":[function(require,module,exports) {
"use strict";
var Buffer = require("c813c8075bcf823e").Buffer;
var inherits = require("84928993e7c3934b");
var HashBase = require("4b3519823770a56d");
var ARRAY16 = new Array(16);
var zl = [
    0,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12,
    13,
    14,
    15,
    7,
    4,
    13,
    1,
    10,
    6,
    15,
    3,
    12,
    0,
    9,
    5,
    2,
    14,
    11,
    8,
    3,
    10,
    14,
    4,
    9,
    15,
    8,
    1,
    2,
    7,
    0,
    6,
    13,
    11,
    5,
    12,
    1,
    9,
    11,
    10,
    0,
    8,
    12,
    4,
    13,
    3,
    7,
    15,
    14,
    5,
    6,
    2,
    4,
    0,
    5,
    9,
    7,
    12,
    2,
    10,
    14,
    1,
    3,
    8,
    11,
    6,
    15,
    13
];
var zr = [
    5,
    14,
    7,
    0,
    9,
    2,
    11,
    4,
    13,
    6,
    15,
    8,
    1,
    10,
    3,
    12,
    6,
    11,
    3,
    7,
    0,
    13,
    5,
    10,
    14,
    15,
    8,
    12,
    4,
    9,
    1,
    2,
    15,
    5,
    1,
    3,
    7,
    14,
    6,
    9,
    11,
    8,
    12,
    2,
    10,
    0,
    4,
    13,
    8,
    6,
    4,
    1,
    3,
    11,
    15,
    0,
    5,
    12,
    2,
    13,
    9,
    7,
    10,
    14,
    12,
    15,
    10,
    4,
    1,
    5,
    8,
    7,
    6,
    2,
    13,
    14,
    0,
    3,
    9,
    11
];
var sl = [
    11,
    14,
    15,
    12,
    5,
    8,
    7,
    9,
    11,
    13,
    14,
    15,
    6,
    7,
    9,
    8,
    7,
    6,
    8,
    13,
    11,
    9,
    7,
    15,
    7,
    12,
    15,
    9,
    11,
    7,
    13,
    12,
    11,
    13,
    6,
    7,
    14,
    9,
    13,
    15,
    14,
    8,
    13,
    6,
    5,
    12,
    7,
    5,
    11,
    12,
    14,
    15,
    14,
    15,
    9,
    8,
    9,
    14,
    5,
    6,
    8,
    6,
    5,
    12,
    9,
    15,
    5,
    11,
    6,
    8,
    13,
    12,
    5,
    12,
    13,
    14,
    11,
    8,
    5,
    6
];
var sr = [
    8,
    9,
    9,
    11,
    13,
    15,
    15,
    5,
    7,
    7,
    8,
    11,
    14,
    14,
    12,
    6,
    9,
    13,
    15,
    7,
    12,
    8,
    9,
    11,
    7,
    7,
    12,
    7,
    6,
    15,
    13,
    11,
    9,
    7,
    15,
    11,
    8,
    6,
    6,
    14,
    12,
    13,
    5,
    14,
    13,
    13,
    7,
    5,
    15,
    5,
    8,
    11,
    14,
    14,
    6,
    14,
    6,
    9,
    12,
    9,
    12,
    5,
    15,
    8,
    8,
    5,
    12,
    9,
    12,
    5,
    14,
    6,
    8,
    13,
    6,
    5,
    15,
    13,
    11,
    11
];
var hl = [
    0x00000000,
    0x5a827999,
    0x6ed9eba1,
    0x8f1bbcdc,
    0xa953fd4e
];
var hr = [
    0x50a28be6,
    0x5c4dd124,
    0x6d703ef3,
    0x7a6d76e9,
    0x00000000
];
function RIPEMD160() {
    HashBase.call(this, 64);
    // state
    this._a = 0x67452301;
    this._b = 0xefcdab89;
    this._c = 0x98badcfe;
    this._d = 0x10325476;
    this._e = 0xc3d2e1f0;
}
inherits(RIPEMD160, HashBase);
RIPEMD160.prototype._update = function() {
    var words = ARRAY16;
    for(var j = 0; j < 16; ++j)words[j] = this._block.readInt32LE(j * 4);
    var al = this._a | 0;
    var bl = this._b | 0;
    var cl = this._c | 0;
    var dl = this._d | 0;
    var el = this._e | 0;
    var ar = this._a | 0;
    var br = this._b | 0;
    var cr = this._c | 0;
    var dr = this._d | 0;
    var er = this._e | 0;
    // computation
    for(var i = 0; i < 80; i += 1){
        var tl;
        var tr;
        if (i < 16) {
            tl = fn1(al, bl, cl, dl, el, words[zl[i]], hl[0], sl[i]);
            tr = fn5(ar, br, cr, dr, er, words[zr[i]], hr[0], sr[i]);
        } else if (i < 32) {
            tl = fn2(al, bl, cl, dl, el, words[zl[i]], hl[1], sl[i]);
            tr = fn4(ar, br, cr, dr, er, words[zr[i]], hr[1], sr[i]);
        } else if (i < 48) {
            tl = fn3(al, bl, cl, dl, el, words[zl[i]], hl[2], sl[i]);
            tr = fn3(ar, br, cr, dr, er, words[zr[i]], hr[2], sr[i]);
        } else if (i < 64) {
            tl = fn4(al, bl, cl, dl, el, words[zl[i]], hl[3], sl[i]);
            tr = fn2(ar, br, cr, dr, er, words[zr[i]], hr[3], sr[i]);
        } else {
            tl = fn5(al, bl, cl, dl, el, words[zl[i]], hl[4], sl[i]);
            tr = fn1(ar, br, cr, dr, er, words[zr[i]], hr[4], sr[i]);
        }
        al = el;
        el = dl;
        dl = rotl(cl, 10);
        cl = bl;
        bl = tl;
        ar = er;
        er = dr;
        dr = rotl(cr, 10);
        cr = br;
        br = tr;
    }
    // update state
    var t = this._b + cl + dr | 0;
    this._b = this._c + dl + er | 0;
    this._c = this._d + el + ar | 0;
    this._d = this._e + al + br | 0;
    this._e = this._a + bl + cr | 0;
    this._a = t;
};
RIPEMD160.prototype._digest = function() {
    // create padding and handle blocks
    this._block[this._blockOffset++] = 0x80;
    if (this._blockOffset > 56) {
        this._block.fill(0, this._blockOffset, 64);
        this._update();
        this._blockOffset = 0;
    }
    this._block.fill(0, this._blockOffset, 56);
    this._block.writeUInt32LE(this._length[0], 56);
    this._block.writeUInt32LE(this._length[1], 60);
    this._update();
    // produce result
    var buffer = Buffer.alloc ? Buffer.alloc(20) : new Buffer(20);
    buffer.writeInt32LE(this._a, 0);
    buffer.writeInt32LE(this._b, 4);
    buffer.writeInt32LE(this._c, 8);
    buffer.writeInt32LE(this._d, 12);
    buffer.writeInt32LE(this._e, 16);
    return buffer;
};
function rotl(x, n) {
    return x << n | x >>> 32 - n;
}
function fn1(a, b, c, d, e, m, k, s) {
    return rotl(a + (b ^ c ^ d) + m + k | 0, s) + e | 0;
}
function fn2(a, b, c, d, e, m, k, s) {
    return rotl(a + (b & c | ~b & d) + m + k | 0, s) + e | 0;
}
function fn3(a, b, c, d, e, m, k, s) {
    return rotl(a + ((b | ~c) ^ d) + m + k | 0, s) + e | 0;
}
function fn4(a, b, c, d, e, m, k, s) {
    return rotl(a + (b & d | c & ~d) + m + k | 0, s) + e | 0;
}
function fn5(a, b, c, d, e, m, k, s) {
    return rotl(a + (b ^ (c | ~d)) + m + k | 0, s) + e | 0;
}
module.exports = RIPEMD160;

},{"c813c8075bcf823e":"l5Twm","84928993e7c3934b":"8LxVj","4b3519823770a56d":"bkj8g"}],"7ZUZ8":[function(require,module,exports) {
var exports = module.exports = function SHA(algorithm) {
    algorithm = algorithm.toLowerCase();
    var Algorithm = exports[algorithm];
    if (!Algorithm) throw new Error(algorithm + " is not supported (we accept pull requests)");
    return new Algorithm();
};
exports.sha = require("54c9313943368ce2");
exports.sha1 = require("6e6f42e0b6fe29ef");
exports.sha224 = require("cefe70c6f9f68940");
exports.sha256 = require("3b4e2aa73bc3fef5");
exports.sha384 = require("be7da8b8e5a0fd78");
exports.sha512 = require("25610a4ba83316a4");

},{"54c9313943368ce2":"dg5QZ","6e6f42e0b6fe29ef":"dR4ik","cefe70c6f9f68940":"6FRTV","3b4e2aa73bc3fef5":"dDAtH","be7da8b8e5a0fd78":"fRcHf","25610a4ba83316a4":"fJVVX"}],"dg5QZ":[function(require,module,exports) {
/*
 * A JavaScript implementation of the Secure Hash Algorithm, SHA-0, as defined
 * in FIPS PUB 180-1
 * This source code is derived from sha1.js of the same repository.
 * The difference between SHA-0 and SHA-1 is just a bitwise rotate left
 * operation was added.
 */ var inherits = require("55404b425acd1c6f");
var Hash = require("457bc9c7737d761f");
var Buffer = require("44759e57eb2992a").Buffer;
var K = [
    0x5a827999,
    0x6ed9eba1,
    -1894007588,
    -899497514
];
var W = new Array(80);
function Sha() {
    this.init();
    this._w = W;
    Hash.call(this, 64, 56);
}
inherits(Sha, Hash);
Sha.prototype.init = function() {
    this._a = 0x67452301;
    this._b = 0xefcdab89;
    this._c = 0x98badcfe;
    this._d = 0x10325476;
    this._e = 0xc3d2e1f0;
    return this;
};
function rotl5(num) {
    return num << 5 | num >>> 27;
}
function rotl30(num) {
    return num << 30 | num >>> 2;
}
function ft(s, b, c, d) {
    if (s === 0) return b & c | ~b & d;
    if (s === 2) return b & c | b & d | c & d;
    return b ^ c ^ d;
}
Sha.prototype._update = function(M) {
    var W = this._w;
    var a = this._a | 0;
    var b = this._b | 0;
    var c = this._c | 0;
    var d = this._d | 0;
    var e = this._e | 0;
    for(var i = 0; i < 16; ++i)W[i] = M.readInt32BE(i * 4);
    for(; i < 80; ++i)W[i] = W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16];
    for(var j = 0; j < 80; ++j){
        var s = ~~(j / 20);
        var t = rotl5(a) + ft(s, b, c, d) + e + W[j] + K[s] | 0;
        e = d;
        d = c;
        c = rotl30(b);
        b = a;
        a = t;
    }
    this._a = a + this._a | 0;
    this._b = b + this._b | 0;
    this._c = c + this._c | 0;
    this._d = d + this._d | 0;
    this._e = e + this._e | 0;
};
Sha.prototype._hash = function() {
    var H = Buffer.allocUnsafe(20);
    H.writeInt32BE(this._a | 0, 0);
    H.writeInt32BE(this._b | 0, 4);
    H.writeInt32BE(this._c | 0, 8);
    H.writeInt32BE(this._d | 0, 12);
    H.writeInt32BE(this._e | 0, 16);
    return H;
};
module.exports = Sha;

},{"55404b425acd1c6f":"8LxVj","457bc9c7737d761f":"abN2o","44759e57eb2992a":"6hBQU"}],"abN2o":[function(require,module,exports) {
var Buffer = require("fe67468afd3c1b91").Buffer;
// prototype class for hash functions
function Hash(blockSize, finalSize) {
    this._block = Buffer.alloc(blockSize);
    this._finalSize = finalSize;
    this._blockSize = blockSize;
    this._len = 0;
}
Hash.prototype.update = function(data, enc) {
    if (typeof data === "string") {
        enc = enc || "utf8";
        data = Buffer.from(data, enc);
    }
    var block = this._block;
    var blockSize = this._blockSize;
    var length = data.length;
    var accum = this._len;
    for(var offset = 0; offset < length;){
        var assigned = accum % blockSize;
        var remainder = Math.min(length - offset, blockSize - assigned);
        for(var i = 0; i < remainder; i++)block[assigned + i] = data[offset + i];
        accum += remainder;
        offset += remainder;
        if (accum % blockSize === 0) this._update(block);
    }
    this._len += length;
    return this;
};
Hash.prototype.digest = function(enc) {
    var rem = this._len % this._blockSize;
    this._block[rem] = 0x80;
    // zero (rem + 1) trailing bits, where (rem + 1) is the smallest
    // non-negative solution to the equation (length + 1 + (rem + 1)) === finalSize mod blockSize
    this._block.fill(0, rem + 1);
    if (rem >= this._finalSize) {
        this._update(this._block);
        this._block.fill(0);
    }
    var bits = this._len * 8;
    // uint32
    if (bits <= 0xffffffff) this._block.writeUInt32BE(bits, this._blockSize - 4);
    else {
        var lowBits = (bits & 0xffffffff) >>> 0;
        var highBits = (bits - lowBits) / 0x100000000;
        this._block.writeUInt32BE(highBits, this._blockSize - 8);
        this._block.writeUInt32BE(lowBits, this._blockSize - 4);
    }
    this._update(this._block);
    var hash = this._hash();
    return enc ? hash.toString(enc) : hash;
};
Hash.prototype._update = function() {
    throw new Error("_update must be implemented by subclass");
};
module.exports = Hash;

},{"fe67468afd3c1b91":"6hBQU"}],"dR4ik":[function(require,module,exports) {
/*
 * A JavaScript implementation of the Secure Hash Algorithm, SHA-1, as defined
 * in FIPS PUB 180-1
 * Version 2.1a Copyright Paul Johnston 2000 - 2002.
 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
 * Distributed under the BSD License
 * See http://pajhome.org.uk/crypt/md5 for details.
 */ var inherits = require("bf0dcaa2121c06d3");
var Hash = require("788f05b1f9753762");
var Buffer = require("ee7c2a3e649d259f").Buffer;
var K = [
    0x5a827999,
    0x6ed9eba1,
    -1894007588,
    -899497514
];
var W = new Array(80);
function Sha1() {
    this.init();
    this._w = W;
    Hash.call(this, 64, 56);
}
inherits(Sha1, Hash);
Sha1.prototype.init = function() {
    this._a = 0x67452301;
    this._b = 0xefcdab89;
    this._c = 0x98badcfe;
    this._d = 0x10325476;
    this._e = 0xc3d2e1f0;
    return this;
};
function rotl1(num) {
    return num << 1 | num >>> 31;
}
function rotl5(num) {
    return num << 5 | num >>> 27;
}
function rotl30(num) {
    return num << 30 | num >>> 2;
}
function ft(s, b, c, d) {
    if (s === 0) return b & c | ~b & d;
    if (s === 2) return b & c | b & d | c & d;
    return b ^ c ^ d;
}
Sha1.prototype._update = function(M) {
    var W = this._w;
    var a = this._a | 0;
    var b = this._b | 0;
    var c = this._c | 0;
    var d = this._d | 0;
    var e = this._e | 0;
    for(var i = 0; i < 16; ++i)W[i] = M.readInt32BE(i * 4);
    for(; i < 80; ++i)W[i] = rotl1(W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16]);
    for(var j = 0; j < 80; ++j){
        var s = ~~(j / 20);
        var t = rotl5(a) + ft(s, b, c, d) + e + W[j] + K[s] | 0;
        e = d;
        d = c;
        c = rotl30(b);
        b = a;
        a = t;
    }
    this._a = a + this._a | 0;
    this._b = b + this._b | 0;
    this._c = c + this._c | 0;
    this._d = d + this._d | 0;
    this._e = e + this._e | 0;
};
Sha1.prototype._hash = function() {
    var H = Buffer.allocUnsafe(20);
    H.writeInt32BE(this._a | 0, 0);
    H.writeInt32BE(this._b | 0, 4);
    H.writeInt32BE(this._c | 0, 8);
    H.writeInt32BE(this._d | 0, 12);
    H.writeInt32BE(this._e | 0, 16);
    return H;
};
module.exports = Sha1;

},{"bf0dcaa2121c06d3":"8LxVj","788f05b1f9753762":"abN2o","ee7c2a3e649d259f":"6hBQU"}],"6FRTV":[function(require,module,exports) {
/**
 * A JavaScript implementation of the Secure Hash Algorithm, SHA-256, as defined
 * in FIPS 180-2
 * Version 2.2-beta Copyright Angel Marin, Paul Johnston 2000 - 2009.
 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
 *
 */ var inherits = require("1759318dd61b32af");
var Sha256 = require("5a24a8ff4dc414f6");
var Hash = require("377596dd27739a66");
var Buffer = require("381289f917f16a20").Buffer;
var W = new Array(64);
function Sha224() {
    this.init();
    this._w = W // new Array(64)
    ;
    Hash.call(this, 64, 56);
}
inherits(Sha224, Sha256);
Sha224.prototype.init = function() {
    this._a = 0xc1059ed8;
    this._b = 0x367cd507;
    this._c = 0x3070dd17;
    this._d = 0xf70e5939;
    this._e = 0xffc00b31;
    this._f = 0x68581511;
    this._g = 0x64f98fa7;
    this._h = 0xbefa4fa4;
    return this;
};
Sha224.prototype._hash = function() {
    var H = Buffer.allocUnsafe(28);
    H.writeInt32BE(this._a, 0);
    H.writeInt32BE(this._b, 4);
    H.writeInt32BE(this._c, 8);
    H.writeInt32BE(this._d, 12);
    H.writeInt32BE(this._e, 16);
    H.writeInt32BE(this._f, 20);
    H.writeInt32BE(this._g, 24);
    return H;
};
module.exports = Sha224;

},{"1759318dd61b32af":"8LxVj","5a24a8ff4dc414f6":"dDAtH","377596dd27739a66":"abN2o","381289f917f16a20":"6hBQU"}],"dDAtH":[function(require,module,exports) {
/**
 * A JavaScript implementation of the Secure Hash Algorithm, SHA-256, as defined
 * in FIPS 180-2
 * Version 2.2-beta Copyright Angel Marin, Paul Johnston 2000 - 2009.
 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
 *
 */ var inherits = require("682a6716eeab42dd");
var Hash = require("f062bd789841a9ce");
var Buffer = require("1d47643a8adb8c1b").Buffer;
var K = [
    0x428A2F98,
    0x71374491,
    0xB5C0FBCF,
    0xE9B5DBA5,
    0x3956C25B,
    0x59F111F1,
    0x923F82A4,
    0xAB1C5ED5,
    0xD807AA98,
    0x12835B01,
    0x243185BE,
    0x550C7DC3,
    0x72BE5D74,
    0x80DEB1FE,
    0x9BDC06A7,
    0xC19BF174,
    0xE49B69C1,
    0xEFBE4786,
    0x0FC19DC6,
    0x240CA1CC,
    0x2DE92C6F,
    0x4A7484AA,
    0x5CB0A9DC,
    0x76F988DA,
    0x983E5152,
    0xA831C66D,
    0xB00327C8,
    0xBF597FC7,
    0xC6E00BF3,
    0xD5A79147,
    0x06CA6351,
    0x14292967,
    0x27B70A85,
    0x2E1B2138,
    0x4D2C6DFC,
    0x53380D13,
    0x650A7354,
    0x766A0ABB,
    0x81C2C92E,
    0x92722C85,
    0xA2BFE8A1,
    0xA81A664B,
    0xC24B8B70,
    0xC76C51A3,
    0xD192E819,
    0xD6990624,
    0xF40E3585,
    0x106AA070,
    0x19A4C116,
    0x1E376C08,
    0x2748774C,
    0x34B0BCB5,
    0x391C0CB3,
    0x4ED8AA4A,
    0x5B9CCA4F,
    0x682E6FF3,
    0x748F82EE,
    0x78A5636F,
    0x84C87814,
    0x8CC70208,
    0x90BEFFFA,
    0xA4506CEB,
    0xBEF9A3F7,
    0xC67178F2
];
var W = new Array(64);
function Sha256() {
    this.init();
    this._w = W // new Array(64)
    ;
    Hash.call(this, 64, 56);
}
inherits(Sha256, Hash);
Sha256.prototype.init = function() {
    this._a = 0x6a09e667;
    this._b = 0xbb67ae85;
    this._c = 0x3c6ef372;
    this._d = 0xa54ff53a;
    this._e = 0x510e527f;
    this._f = 0x9b05688c;
    this._g = 0x1f83d9ab;
    this._h = 0x5be0cd19;
    return this;
};
function ch(x, y, z) {
    return z ^ x & (y ^ z);
}
function maj(x, y, z) {
    return x & y | z & (x | y);
}
function sigma0(x) {
    return (x >>> 2 | x << 30) ^ (x >>> 13 | x << 19) ^ (x >>> 22 | x << 10);
}
function sigma1(x) {
    return (x >>> 6 | x << 26) ^ (x >>> 11 | x << 21) ^ (x >>> 25 | x << 7);
}
function gamma0(x) {
    return (x >>> 7 | x << 25) ^ (x >>> 18 | x << 14) ^ x >>> 3;
}
function gamma1(x) {
    return (x >>> 17 | x << 15) ^ (x >>> 19 | x << 13) ^ x >>> 10;
}
Sha256.prototype._update = function(M) {
    var W = this._w;
    var a = this._a | 0;
    var b = this._b | 0;
    var c = this._c | 0;
    var d = this._d | 0;
    var e = this._e | 0;
    var f = this._f | 0;
    var g = this._g | 0;
    var h = this._h | 0;
    for(var i = 0; i < 16; ++i)W[i] = M.readInt32BE(i * 4);
    for(; i < 64; ++i)W[i] = gamma1(W[i - 2]) + W[i - 7] + gamma0(W[i - 15]) + W[i - 16] | 0;
    for(var j = 0; j < 64; ++j){
        var T1 = h + sigma1(e) + ch(e, f, g) + K[j] + W[j] | 0;
        var T2 = sigma0(a) + maj(a, b, c) | 0;
        h = g;
        g = f;
        f = e;
        e = d + T1 | 0;
        d = c;
        c = b;
        b = a;
        a = T1 + T2 | 0;
    }
    this._a = a + this._a | 0;
    this._b = b + this._b | 0;
    this._c = c + this._c | 0;
    this._d = d + this._d | 0;
    this._e = e + this._e | 0;
    this._f = f + this._f | 0;
    this._g = g + this._g | 0;
    this._h = h + this._h | 0;
};
Sha256.prototype._hash = function() {
    var H = Buffer.allocUnsafe(32);
    H.writeInt32BE(this._a, 0);
    H.writeInt32BE(this._b, 4);
    H.writeInt32BE(this._c, 8);
    H.writeInt32BE(this._d, 12);
    H.writeInt32BE(this._e, 16);
    H.writeInt32BE(this._f, 20);
    H.writeInt32BE(this._g, 24);
    H.writeInt32BE(this._h, 28);
    return H;
};
module.exports = Sha256;

},{"682a6716eeab42dd":"8LxVj","f062bd789841a9ce":"abN2o","1d47643a8adb8c1b":"6hBQU"}],"fRcHf":[function(require,module,exports) {
var inherits = require("2a5cbb73fedd61b");
var SHA512 = require("fdb4d0946b31cdb5");
var Hash = require("50aa04d4bd2df0e1");
var Buffer = require("3d3bcc84ec383b74").Buffer;
var W = new Array(160);
function Sha384() {
    this.init();
    this._w = W;
    Hash.call(this, 128, 112);
}
inherits(Sha384, SHA512);
Sha384.prototype.init = function() {
    this._ah = 0xcbbb9d5d;
    this._bh = 0x629a292a;
    this._ch = 0x9159015a;
    this._dh = 0x152fecd8;
    this._eh = 0x67332667;
    this._fh = 0x8eb44a87;
    this._gh = 0xdb0c2e0d;
    this._hh = 0x47b5481d;
    this._al = 0xc1059ed8;
    this._bl = 0x367cd507;
    this._cl = 0x3070dd17;
    this._dl = 0xf70e5939;
    this._el = 0xffc00b31;
    this._fl = 0x68581511;
    this._gl = 0x64f98fa7;
    this._hl = 0xbefa4fa4;
    return this;
};
Sha384.prototype._hash = function() {
    var H = Buffer.allocUnsafe(48);
    function writeInt64BE(h, l, offset) {
        H.writeInt32BE(h, offset);
        H.writeInt32BE(l, offset + 4);
    }
    writeInt64BE(this._ah, this._al, 0);
    writeInt64BE(this._bh, this._bl, 8);
    writeInt64BE(this._ch, this._cl, 16);
    writeInt64BE(this._dh, this._dl, 24);
    writeInt64BE(this._eh, this._el, 32);
    writeInt64BE(this._fh, this._fl, 40);
    return H;
};
module.exports = Sha384;

},{"2a5cbb73fedd61b":"8LxVj","fdb4d0946b31cdb5":"fJVVX","50aa04d4bd2df0e1":"abN2o","3d3bcc84ec383b74":"6hBQU"}],"fJVVX":[function(require,module,exports) {
var inherits = require("8d87c82d5ce5743");
var Hash = require("27d0146c4419ba93");
var Buffer = require("602d9c7256ca6bf7").Buffer;
var K = [
    0x428a2f98,
    0xd728ae22,
    0x71374491,
    0x23ef65cd,
    0xb5c0fbcf,
    0xec4d3b2f,
    0xe9b5dba5,
    0x8189dbbc,
    0x3956c25b,
    0xf348b538,
    0x59f111f1,
    0xb605d019,
    0x923f82a4,
    0xaf194f9b,
    0xab1c5ed5,
    0xda6d8118,
    0xd807aa98,
    0xa3030242,
    0x12835b01,
    0x45706fbe,
    0x243185be,
    0x4ee4b28c,
    0x550c7dc3,
    0xd5ffb4e2,
    0x72be5d74,
    0xf27b896f,
    0x80deb1fe,
    0x3b1696b1,
    0x9bdc06a7,
    0x25c71235,
    0xc19bf174,
    0xcf692694,
    0xe49b69c1,
    0x9ef14ad2,
    0xefbe4786,
    0x384f25e3,
    0x0fc19dc6,
    0x8b8cd5b5,
    0x240ca1cc,
    0x77ac9c65,
    0x2de92c6f,
    0x592b0275,
    0x4a7484aa,
    0x6ea6e483,
    0x5cb0a9dc,
    0xbd41fbd4,
    0x76f988da,
    0x831153b5,
    0x983e5152,
    0xee66dfab,
    0xa831c66d,
    0x2db43210,
    0xb00327c8,
    0x98fb213f,
    0xbf597fc7,
    0xbeef0ee4,
    0xc6e00bf3,
    0x3da88fc2,
    0xd5a79147,
    0x930aa725,
    0x06ca6351,
    0xe003826f,
    0x14292967,
    0x0a0e6e70,
    0x27b70a85,
    0x46d22ffc,
    0x2e1b2138,
    0x5c26c926,
    0x4d2c6dfc,
    0x5ac42aed,
    0x53380d13,
    0x9d95b3df,
    0x650a7354,
    0x8baf63de,
    0x766a0abb,
    0x3c77b2a8,
    0x81c2c92e,
    0x47edaee6,
    0x92722c85,
    0x1482353b,
    0xa2bfe8a1,
    0x4cf10364,
    0xa81a664b,
    0xbc423001,
    0xc24b8b70,
    0xd0f89791,
    0xc76c51a3,
    0x0654be30,
    0xd192e819,
    0xd6ef5218,
    0xd6990624,
    0x5565a910,
    0xf40e3585,
    0x5771202a,
    0x106aa070,
    0x32bbd1b8,
    0x19a4c116,
    0xb8d2d0c8,
    0x1e376c08,
    0x5141ab53,
    0x2748774c,
    0xdf8eeb99,
    0x34b0bcb5,
    0xe19b48a8,
    0x391c0cb3,
    0xc5c95a63,
    0x4ed8aa4a,
    0xe3418acb,
    0x5b9cca4f,
    0x7763e373,
    0x682e6ff3,
    0xd6b2b8a3,
    0x748f82ee,
    0x5defb2fc,
    0x78a5636f,
    0x43172f60,
    0x84c87814,
    0xa1f0ab72,
    0x8cc70208,
    0x1a6439ec,
    0x90befffa,
    0x23631e28,
    0xa4506ceb,
    0xde82bde9,
    0xbef9a3f7,
    0xb2c67915,
    0xc67178f2,
    0xe372532b,
    0xca273ece,
    0xea26619c,
    0xd186b8c7,
    0x21c0c207,
    0xeada7dd6,
    0xcde0eb1e,
    0xf57d4f7f,
    0xee6ed178,
    0x06f067aa,
    0x72176fba,
    0x0a637dc5,
    0xa2c898a6,
    0x113f9804,
    0xbef90dae,
    0x1b710b35,
    0x131c471b,
    0x28db77f5,
    0x23047d84,
    0x32caab7b,
    0x40c72493,
    0x3c9ebe0a,
    0x15c9bebc,
    0x431d67c4,
    0x9c100d4c,
    0x4cc5d4be,
    0xcb3e42b6,
    0x597f299c,
    0xfc657e2a,
    0x5fcb6fab,
    0x3ad6faec,
    0x6c44198c,
    0x4a475817
];
var W = new Array(160);
function Sha512() {
    this.init();
    this._w = W;
    Hash.call(this, 128, 112);
}
inherits(Sha512, Hash);
Sha512.prototype.init = function() {
    this._ah = 0x6a09e667;
    this._bh = 0xbb67ae85;
    this._ch = 0x3c6ef372;
    this._dh = 0xa54ff53a;
    this._eh = 0x510e527f;
    this._fh = 0x9b05688c;
    this._gh = 0x1f83d9ab;
    this._hh = 0x5be0cd19;
    this._al = 0xf3bcc908;
    this._bl = 0x84caa73b;
    this._cl = 0xfe94f82b;
    this._dl = 0x5f1d36f1;
    this._el = 0xade682d1;
    this._fl = 0x2b3e6c1f;
    this._gl = 0xfb41bd6b;
    this._hl = 0x137e2179;
    return this;
};
function Ch(x, y, z) {
    return z ^ x & (y ^ z);
}
function maj(x, y, z) {
    return x & y | z & (x | y);
}
function sigma0(x, xl) {
    return (x >>> 28 | xl << 4) ^ (xl >>> 2 | x << 30) ^ (xl >>> 7 | x << 25);
}
function sigma1(x, xl) {
    return (x >>> 14 | xl << 18) ^ (x >>> 18 | xl << 14) ^ (xl >>> 9 | x << 23);
}
function Gamma0(x, xl) {
    return (x >>> 1 | xl << 31) ^ (x >>> 8 | xl << 24) ^ x >>> 7;
}
function Gamma0l(x, xl) {
    return (x >>> 1 | xl << 31) ^ (x >>> 8 | xl << 24) ^ (x >>> 7 | xl << 25);
}
function Gamma1(x, xl) {
    return (x >>> 19 | xl << 13) ^ (xl >>> 29 | x << 3) ^ x >>> 6;
}
function Gamma1l(x, xl) {
    return (x >>> 19 | xl << 13) ^ (xl >>> 29 | x << 3) ^ (x >>> 6 | xl << 26);
}
function getCarry(a, b) {
    return a >>> 0 < b >>> 0 ? 1 : 0;
}
Sha512.prototype._update = function(M) {
    var W = this._w;
    var ah = this._ah | 0;
    var bh = this._bh | 0;
    var ch = this._ch | 0;
    var dh = this._dh | 0;
    var eh = this._eh | 0;
    var fh = this._fh | 0;
    var gh = this._gh | 0;
    var hh = this._hh | 0;
    var al = this._al | 0;
    var bl = this._bl | 0;
    var cl = this._cl | 0;
    var dl = this._dl | 0;
    var el = this._el | 0;
    var fl = this._fl | 0;
    var gl = this._gl | 0;
    var hl = this._hl | 0;
    for(var i = 0; i < 32; i += 2){
        W[i] = M.readInt32BE(i * 4);
        W[i + 1] = M.readInt32BE(i * 4 + 4);
    }
    for(; i < 160; i += 2){
        var xh = W[i - 30];
        var xl = W[i - 30 + 1];
        var gamma0 = Gamma0(xh, xl);
        var gamma0l = Gamma0l(xl, xh);
        xh = W[i - 4];
        xl = W[i - 4 + 1];
        var gamma1 = Gamma1(xh, xl);
        var gamma1l = Gamma1l(xl, xh);
        // W[i] = gamma0 + W[i - 7] + gamma1 + W[i - 16]
        var Wi7h = W[i - 14];
        var Wi7l = W[i - 14 + 1];
        var Wi16h = W[i - 32];
        var Wi16l = W[i - 32 + 1];
        var Wil = gamma0l + Wi7l | 0;
        var Wih = gamma0 + Wi7h + getCarry(Wil, gamma0l) | 0;
        Wil = Wil + gamma1l | 0;
        Wih = Wih + gamma1 + getCarry(Wil, gamma1l) | 0;
        Wil = Wil + Wi16l | 0;
        Wih = Wih + Wi16h + getCarry(Wil, Wi16l) | 0;
        W[i] = Wih;
        W[i + 1] = Wil;
    }
    for(var j = 0; j < 160; j += 2){
        Wih = W[j];
        Wil = W[j + 1];
        var majh = maj(ah, bh, ch);
        var majl = maj(al, bl, cl);
        var sigma0h = sigma0(ah, al);
        var sigma0l = sigma0(al, ah);
        var sigma1h = sigma1(eh, el);
        var sigma1l = sigma1(el, eh);
        // t1 = h + sigma1 + ch + K[j] + W[j]
        var Kih = K[j];
        var Kil = K[j + 1];
        var chh = Ch(eh, fh, gh);
        var chl = Ch(el, fl, gl);
        var t1l = hl + sigma1l | 0;
        var t1h = hh + sigma1h + getCarry(t1l, hl) | 0;
        t1l = t1l + chl | 0;
        t1h = t1h + chh + getCarry(t1l, chl) | 0;
        t1l = t1l + Kil | 0;
        t1h = t1h + Kih + getCarry(t1l, Kil) | 0;
        t1l = t1l + Wil | 0;
        t1h = t1h + Wih + getCarry(t1l, Wil) | 0;
        // t2 = sigma0 + maj
        var t2l = sigma0l + majl | 0;
        var t2h = sigma0h + majh + getCarry(t2l, sigma0l) | 0;
        hh = gh;
        hl = gl;
        gh = fh;
        gl = fl;
        fh = eh;
        fl = el;
        el = dl + t1l | 0;
        eh = dh + t1h + getCarry(el, dl) | 0;
        dh = ch;
        dl = cl;
        ch = bh;
        cl = bl;
        bh = ah;
        bl = al;
        al = t1l + t2l | 0;
        ah = t1h + t2h + getCarry(al, t1l) | 0;
    }
    this._al = this._al + al | 0;
    this._bl = this._bl + bl | 0;
    this._cl = this._cl + cl | 0;
    this._dl = this._dl + dl | 0;
    this._el = this._el + el | 0;
    this._fl = this._fl + fl | 0;
    this._gl = this._gl + gl | 0;
    this._hl = this._hl + hl | 0;
    this._ah = this._ah + ah + getCarry(this._al, al) | 0;
    this._bh = this._bh + bh + getCarry(this._bl, bl) | 0;
    this._ch = this._ch + ch + getCarry(this._cl, cl) | 0;
    this._dh = this._dh + dh + getCarry(this._dl, dl) | 0;
    this._eh = this._eh + eh + getCarry(this._el, el) | 0;
    this._fh = this._fh + fh + getCarry(this._fl, fl) | 0;
    this._gh = this._gh + gh + getCarry(this._gl, gl) | 0;
    this._hh = this._hh + hh + getCarry(this._hl, hl) | 0;
};
Sha512.prototype._hash = function() {
    var H = Buffer.allocUnsafe(64);
    function writeInt64BE(h, l, offset) {
        H.writeInt32BE(h, offset);
        H.writeInt32BE(l, offset + 4);
    }
    writeInt64BE(this._ah, this._al, 0);
    writeInt64BE(this._bh, this._bl, 8);
    writeInt64BE(this._ch, this._cl, 16);
    writeInt64BE(this._dh, this._dl, 24);
    writeInt64BE(this._eh, this._el, 32);
    writeInt64BE(this._fh, this._fl, 40);
    writeInt64BE(this._gh, this._gl, 48);
    writeInt64BE(this._hh, this._hl, 56);
    return H;
};
module.exports = Sha512;

},{"8d87c82d5ce5743":"8LxVj","27d0146c4419ba93":"abN2o","602d9c7256ca6bf7":"6hBQU"}],"7VZSW":[function(require,module,exports) {
var Buffer = require("631f7eb12d35b579").Buffer;
var Transform = require("5b378a2a05398c5").Transform;
var StringDecoder = require("d42da7de127e1c4b").StringDecoder;
var inherits = require("7a0f2f27fe0a389b");
function CipherBase(hashMode) {
    Transform.call(this);
    this.hashMode = typeof hashMode === "string";
    if (this.hashMode) this[hashMode] = this._finalOrDigest;
    else this.final = this._finalOrDigest;
    if (this._final) {
        this.__final = this._final;
        this._final = null;
    }
    this._decoder = null;
    this._encoding = null;
}
inherits(CipherBase, Transform);
CipherBase.prototype.update = function(data, inputEnc, outputEnc) {
    if (typeof data === "string") data = Buffer.from(data, inputEnc);
    var outData = this._update(data);
    if (this.hashMode) return this;
    if (outputEnc) outData = this._toString(outData, outputEnc);
    return outData;
};
CipherBase.prototype.setAutoPadding = function() {};
CipherBase.prototype.getAuthTag = function() {
    throw new Error("trying to get auth tag in unsupported state");
};
CipherBase.prototype.setAuthTag = function() {
    throw new Error("trying to set auth tag in unsupported state");
};
CipherBase.prototype.setAAD = function() {
    throw new Error("trying to set aad in unsupported state");
};
CipherBase.prototype._transform = function(data, _, next) {
    var err;
    try {
        if (this.hashMode) this._update(data);
        else this.push(this._update(data));
    } catch (e) {
        err = e;
    } finally{
        next(err);
    }
};
CipherBase.prototype._flush = function(done) {
    var err;
    try {
        this.push(this.__final());
    } catch (e) {
        err = e;
    }
    done(err);
};
CipherBase.prototype._finalOrDigest = function(outputEnc) {
    var outData = this.__final() || Buffer.alloc(0);
    if (outputEnc) outData = this._toString(outData, outputEnc, true);
    return outData;
};
CipherBase.prototype._toString = function(value, enc, fin) {
    if (!this._decoder) {
        this._decoder = new StringDecoder(enc);
        this._encoding = enc;
    }
    if (this._encoding !== enc) throw new Error("can't switch encodings");
    var out = this._decoder.write(value);
    if (fin) out += this._decoder.end();
    return out;
};
module.exports = CipherBase;

},{"631f7eb12d35b579":"6hBQU","5b378a2a05398c5":"gHHLM","d42da7de127e1c4b":"dr7zb","7a0f2f27fe0a389b":"8LxVj"}],"4yJO4":[function(require,module,exports) {
var Buffer = require("d2d4c065bb1dbea2").Buffer;
"use strict";
var isHexPrefixed = require("7861ed997497c9d6");
var stripHexPrefix = require("35c1800b397f93f9");
/**
 * Pads a `String` to have an even length
 * @param {String} value
 * @return {String} output
 */ function padToEven(value) {
    var a = value; // eslint-disable-line
    if (typeof a !== "string") throw new Error("[ethjs-util] while padding to even, value must be string, is currently " + typeof a + ", while padToEven.");
    if (a.length % 2) a = "0" + a;
    return a;
}
/**
 * Converts a `Number` into a hex `String`
 * @param {Number} i
 * @return {String}
 */ function intToHex(i) {
    var hex = i.toString(16); // eslint-disable-line
    return "0x" + hex;
}
/**
 * Converts an `Number` to a `Buffer`
 * @param {Number} i
 * @return {Buffer}
 */ function intToBuffer(i) {
    var hex = intToHex(i);
    return new Buffer(padToEven(hex.slice(2)), "hex");
}
/**
 * Get the binary size of a string
 * @param {String} str
 * @return {Number}
 */ function getBinarySize(str) {
    if (typeof str !== "string") throw new Error("[ethjs-util] while getting binary size, method getBinarySize requires input 'str' to be type String, got '" + typeof str + "'.");
    return Buffer.byteLength(str, "utf8");
}
/**
 * Returns TRUE if the first specified array contains all elements
 * from the second one. FALSE otherwise.
 *
 * @param {array} superset
 * @param {array} subset
 *
 * @returns {boolean}
 */ function arrayContainsArray(superset, subset, some) {
    if (Array.isArray(superset) !== true) throw new Error("[ethjs-util] method arrayContainsArray requires input 'superset' to be an array got type '" + typeof superset + "'");
    if (Array.isArray(subset) !== true) throw new Error("[ethjs-util] method arrayContainsArray requires input 'subset' to be an array got type '" + typeof subset + "'");
    return subset[Boolean(some) && "some" || "every"](function(value) {
        return superset.indexOf(value) >= 0;
    });
}
/**
 * Should be called to get utf8 from it's hex representation
 *
 * @method toUtf8
 * @param {String} string in hex
 * @returns {String} ascii string representation of hex value
 */ function toUtf8(hex) {
    var bufferValue = new Buffer(padToEven(stripHexPrefix(hex).replace(/^0+|0+$/g, "")), "hex");
    return bufferValue.toString("utf8");
}
/**
 * Should be called to get ascii from it's hex representation
 *
 * @method toAscii
 * @param {String} string in hex
 * @returns {String} ascii string representation of hex value
 */ function toAscii(hex) {
    var str = ""; // eslint-disable-line
    var i = 0, l = hex.length; // eslint-disable-line
    if (hex.substring(0, 2) === "0x") i = 2;
    for(; i < l; i += 2){
        var code = parseInt(hex.substr(i, 2), 16);
        str += String.fromCharCode(code);
    }
    return str;
}
/**
 * Should be called to get hex representation (prefixed by 0x) of utf8 string
 *
 * @method fromUtf8
 * @param {String} string
 * @param {Number} optional padding
 * @returns {String} hex representation of input string
 */ function fromUtf8(stringValue) {
    var str = new Buffer(stringValue, "utf8");
    return "0x" + padToEven(str.toString("hex")).replace(/^0+|0+$/g, "");
}
/**
 * Should be called to get hex representation (prefixed by 0x) of ascii string
 *
 * @method fromAscii
 * @param {String} string
 * @param {Number} optional padding
 * @returns {String} hex representation of input string
 */ function fromAscii(stringValue) {
    var hex = ""; // eslint-disable-line
    for(var i = 0; i < stringValue.length; i++){
        // eslint-disable-line
        var code = stringValue.charCodeAt(i);
        var n = code.toString(16);
        hex += n.length < 2 ? "0" + n : n;
    }
    return "0x" + hex;
}
/**
 * getKeys([{a: 1, b: 2}, {a: 3, b: 4}], 'a') => [1, 3]
 *
 * @method getKeys get specific key from inner object array of objects
 * @param {String} params
 * @param {String} key
 * @param {Boolean} allowEmpty
 * @returns {Array} output just a simple array of output keys
 */ function getKeys(params, key, allowEmpty) {
    if (!Array.isArray(params)) throw new Error("[ethjs-util] method getKeys expecting type Array as 'params' input, got '" + typeof params + "'");
    if (typeof key !== "string") throw new Error("[ethjs-util] method getKeys expecting type String for input 'key' got '" + typeof key + "'.");
    var result = []; // eslint-disable-line
    for(var i = 0; i < params.length; i++){
        // eslint-disable-line
        var value = params[i][key]; // eslint-disable-line
        if (allowEmpty && !value) value = "";
        else if (typeof value !== "string") throw new Error("invalid abi");
        result.push(value);
    }
    return result;
}
/**
 * Is the string a hex string.
 *
 * @method check if string is hex string of specific length
 * @param {String} value
 * @param {Number} length
 * @returns {Boolean} output the string is a hex string
 */ function isHexString(value, length) {
    if (typeof value !== "string" || !value.match(/^0x[0-9A-Fa-f]*$/)) return false;
    if (length && value.length !== 2 + 2 * length) return false;
    return true;
}
module.exports = {
    arrayContainsArray: arrayContainsArray,
    intToBuffer: intToBuffer,
    getBinarySize: getBinarySize,
    isHexPrefixed: isHexPrefixed,
    stripHexPrefix: stripHexPrefix,
    padToEven: padToEven,
    intToHex: intToHex,
    fromAscii: fromAscii,
    fromUtf8: fromUtf8,
    toAscii: toAscii,
    toUtf8: toUtf8,
    getKeys: getKeys,
    isHexString: isHexString
};

},{"d2d4c065bb1dbea2":"l5Twm","7861ed997497c9d6":"c2tRb","35c1800b397f93f9":"8BYNv"}],"56qDa":[function(require,module,exports) {
const pify = require("267cf5f68d798fc");
const BaseBlockTracker = require("49d15f859cdcbc70");
const sec = 1000;
class PollingBlockTracker extends BaseBlockTracker {
    constructor(opts = {}){
        // parse + validate args
        if (!opts.provider) throw new Error("PollingBlockTracker - no provider specified.");
        const pollingInterval = opts.pollingInterval || 20 * sec;
        const retryTimeout = opts.retryTimeout || pollingInterval / 10;
        const keepEventLoopActive = opts.keepEventLoopActive !== undefined ? opts.keepEventLoopActive : true;
        const setSkipCacheFlag = opts.setSkipCacheFlag || false;
        // BaseBlockTracker constructor
        super(Object.assign({
            blockResetDuration: pollingInterval
        }, opts));
        // config
        this._provider = opts.provider;
        this._pollingInterval = pollingInterval;
        this._retryTimeout = retryTimeout;
        this._keepEventLoopActive = keepEventLoopActive;
        this._setSkipCacheFlag = setSkipCacheFlag;
    }
    //
    // public
    //
    // trigger block polling
    async checkForLatestBlock() {
        await this._updateLatestBlock();
        return await this.getLatestBlock();
    }
    //
    // private
    //
    _start() {
        this._performSync().catch((err)=>this.emit("error", err));
    }
    async _performSync() {
        while(this._isRunning)try {
            await this._updateLatestBlock();
            await timeout(this._pollingInterval, !this._keepEventLoopActive);
        } catch (err) {
            const newErr = new Error(`PollingBlockTracker - encountered an error while attempting to update latest block:\n${err.stack}`);
            try {
                this.emit("error", newErr);
            } catch (emitErr) {
                console.error(newErr);
            }
            await timeout(this._retryTimeout, !this._keepEventLoopActive);
        }
    }
    async _updateLatestBlock() {
        // fetch + set latest block
        const latestBlock = await this._fetchLatestBlock();
        this._newPotentialLatest(latestBlock);
    }
    async _fetchLatestBlock() {
        const req = {
            jsonrpc: "2.0",
            id: 1,
            method: "eth_blockNumber",
            params: []
        };
        if (this._setSkipCacheFlag) req.skipCache = true;
        const res = await pify((cb)=>this._provider.sendAsync(req, cb))();
        if (res.error) throw new Error(`PollingBlockTracker - encountered error fetching block:\n${res.error}`);
        return res.result;
    }
}
module.exports = PollingBlockTracker;
function timeout(duration, unref) {
    return new Promise((resolve)=>{
        const timoutRef = setTimeout(resolve, duration);
        // don't keep process open
        if (timoutRef.unref && unref) timoutRef.unref();
    });
}

},{"267cf5f68d798fc":"gGRAD","49d15f859cdcbc70":"5xilw"}],"gGRAD":[function(require,module,exports) {
"use strict";
const processFn = (fn, opts)=>function() {
        const P = opts.promiseModule;
        const args = new Array(arguments.length);
        for(let i = 0; i < arguments.length; i++)args[i] = arguments[i];
        return new P((resolve, reject)=>{
            if (opts.errorFirst) args.push(function(err, result) {
                if (opts.multiArgs) {
                    const results = new Array(arguments.length - 1);
                    for(let i = 1; i < arguments.length; i++)results[i - 1] = arguments[i];
                    if (err) {
                        results.unshift(err);
                        reject(results);
                    } else resolve(results);
                } else if (err) reject(err);
                else resolve(result);
            });
            else args.push(function(result) {
                if (opts.multiArgs) {
                    const results = new Array(arguments.length - 1);
                    for(let i = 0; i < arguments.length; i++)results[i] = arguments[i];
                    resolve(results);
                } else resolve(result);
            });
            fn.apply(this, args);
        });
    };
module.exports = (obj, opts)=>{
    opts = Object.assign({
        exclude: [
            /.+(Sync|Stream)$/
        ],
        errorFirst: true,
        promiseModule: Promise
    }, opts);
    const filter = (key)=>{
        const match = (pattern)=>typeof pattern === "string" ? key === pattern : pattern.test(key);
        return opts.include ? opts.include.some(match) : !opts.exclude.some(match);
    };
    let ret;
    if (typeof obj === "function") ret = function() {
        if (opts.excludeMain) return obj.apply(this, arguments);
        return processFn(obj, opts).apply(this, arguments);
    };
    else ret = Object.create(Object.getPrototypeOf(obj));
    for(const key in obj){
        const x = obj[key];
        ret[key] = typeof x === "function" && filter(key) ? processFn(x, opts) : x;
    }
    return ret;
};

},{}],"5xilw":[function(require,module,exports) {
const EthQuery = require("fe3ce0fb0efb2a5f");
const pify = require("edcba81eddad369f");
const SafeEventEmitter = require("18f7d841adc5a67c");
const sec = 1000;
const calculateSum = (accumulator, currentValue)=>accumulator + currentValue;
const blockTrackerEvents = [
    "sync",
    "latest"
];
class BaseBlockTracker extends SafeEventEmitter {
    //
    // public
    //
    constructor(opts = {}){
        super();
        // config
        this._blockResetDuration = opts.blockResetDuration || 20 * sec;
        // state
        this._blockResetTimeout;
        this._currentBlock = null;
        this._isRunning = false;
        // bind functions for internal use
        this._onNewListener = this._onNewListener.bind(this);
        this._onRemoveListener = this._onRemoveListener.bind(this);
        this._resetCurrentBlock = this._resetCurrentBlock.bind(this);
        // listen for handler changes
        this._setupInternalEvents();
    }
    isRunning() {
        return this._isRunning;
    }
    getCurrentBlock() {
        return this._currentBlock;
    }
    async getLatestBlock() {
        // return if available
        if (this._currentBlock) return this._currentBlock;
        // wait for a new latest block
        const latestBlock = await new Promise((resolve)=>this.once("latest", resolve));
        // return newly set current block
        return latestBlock;
    }
    // dont allow module consumer to remove our internal event listeners
    removeAllListeners(eventName) {
        // perform default behavior, preserve fn arity
        if (eventName) super.removeAllListeners(eventName);
        else super.removeAllListeners();
        // re-add internal events
        this._setupInternalEvents();
        // trigger stop check just in case
        this._onRemoveListener();
    }
    //
    // to be implemented in subclass
    //
    _start() {
    // default behavior is noop
    }
    _end() {
    // default behavior is noop
    }
    //
    // private
    //
    _setupInternalEvents() {
        // first remove listeners for idempotence
        this.removeListener("newListener", this._onNewListener);
        this.removeListener("removeListener", this._onRemoveListener);
        // then add them
        this.on("newListener", this._onNewListener);
        this.on("removeListener", this._onRemoveListener);
    }
    _onNewListener(eventName, handler) {
        // `newListener` is called *before* the listener is added
        if (!blockTrackerEvents.includes(eventName)) return;
        this._maybeStart();
    }
    _onRemoveListener(eventName, handler) {
        // `removeListener` is called *after* the listener is removed
        if (this._getBlockTrackerEventCount() > 0) return;
        this._maybeEnd();
    }
    _maybeStart() {
        if (this._isRunning) return;
        this._isRunning = true;
        // cancel setting latest block to stale
        this._cancelBlockResetTimeout();
        this._start();
    }
    _maybeEnd() {
        if (!this._isRunning) return;
        this._isRunning = false;
        this._setupBlockResetTimeout();
        this._end();
    }
    _getBlockTrackerEventCount() {
        return blockTrackerEvents.map((eventName)=>this.listenerCount(eventName)).reduce(calculateSum);
    }
    _newPotentialLatest(newBlock) {
        const currentBlock = this._currentBlock;
        // only update if blok number is higher
        if (currentBlock && hexToInt(newBlock) <= hexToInt(currentBlock)) return;
        this._setCurrentBlock(newBlock);
    }
    _setCurrentBlock(newBlock) {
        const oldBlock = this._currentBlock;
        this._currentBlock = newBlock;
        this.emit("latest", newBlock);
        this.emit("sync", {
            oldBlock,
            newBlock
        });
    }
    _setupBlockResetTimeout() {
        // clear any existing timeout
        this._cancelBlockResetTimeout();
        // clear latest block when stale
        this._blockResetTimeout = setTimeout(this._resetCurrentBlock, this._blockResetDuration);
        // nodejs - dont hold process open
        if (this._blockResetTimeout.unref) this._blockResetTimeout.unref();
    }
    _cancelBlockResetTimeout() {
        clearTimeout(this._blockResetTimeout);
    }
    _resetCurrentBlock() {
        this._currentBlock = null;
    }
}
module.exports = BaseBlockTracker;
function hexToInt(hexInt) {
    return Number.parseInt(hexInt, 16);
}

},{"fe3ce0fb0efb2a5f":"hM2Xv","edcba81eddad369f":"gGRAD","18f7d841adc5a67c":"bbZBH"}],"hM2Xv":[function(require,module,exports) {
const extend = require("63158d80aab98463");
const createRandomId = require("1fe9b38c0825c01")();
module.exports = EthQuery;
function EthQuery(provider) {
    const self = this;
    self.currentProvider = provider;
}
//
// base queries
//
// default block
EthQuery.prototype.getBalance = generateFnWithDefaultBlockFor(2, "eth_getBalance");
EthQuery.prototype.getCode = generateFnWithDefaultBlockFor(2, "eth_getCode");
EthQuery.prototype.getTransactionCount = generateFnWithDefaultBlockFor(2, "eth_getTransactionCount");
EthQuery.prototype.getStorageAt = generateFnWithDefaultBlockFor(3, "eth_getStorageAt");
EthQuery.prototype.call = generateFnWithDefaultBlockFor(2, "eth_call");
// standard
EthQuery.prototype.protocolVersion = generateFnFor("eth_protocolVersion");
EthQuery.prototype.syncing = generateFnFor("eth_syncing");
EthQuery.prototype.coinbase = generateFnFor("eth_coinbase");
EthQuery.prototype.mining = generateFnFor("eth_mining");
EthQuery.prototype.hashrate = generateFnFor("eth_hashrate");
EthQuery.prototype.gasPrice = generateFnFor("eth_gasPrice");
EthQuery.prototype.accounts = generateFnFor("eth_accounts");
EthQuery.prototype.blockNumber = generateFnFor("eth_blockNumber");
EthQuery.prototype.getBlockTransactionCountByHash = generateFnFor("eth_getBlockTransactionCountByHash");
EthQuery.prototype.getBlockTransactionCountByNumber = generateFnFor("eth_getBlockTransactionCountByNumber");
EthQuery.prototype.getUncleCountByBlockHash = generateFnFor("eth_getUncleCountByBlockHash");
EthQuery.prototype.getUncleCountByBlockNumber = generateFnFor("eth_getUncleCountByBlockNumber");
EthQuery.prototype.sign = generateFnFor("eth_sign");
EthQuery.prototype.sendTransaction = generateFnFor("eth_sendTransaction");
EthQuery.prototype.sendRawTransaction = generateFnFor("eth_sendRawTransaction");
EthQuery.prototype.estimateGas = generateFnFor("eth_estimateGas");
EthQuery.prototype.getBlockByHash = generateFnFor("eth_getBlockByHash");
EthQuery.prototype.getBlockByNumber = generateFnFor("eth_getBlockByNumber");
EthQuery.prototype.getTransactionByHash = generateFnFor("eth_getTransactionByHash");
EthQuery.prototype.getTransactionByBlockHashAndIndex = generateFnFor("eth_getTransactionByBlockHashAndIndex");
EthQuery.prototype.getTransactionByBlockNumberAndIndex = generateFnFor("eth_getTransactionByBlockNumberAndIndex");
EthQuery.prototype.getTransactionReceipt = generateFnFor("eth_getTransactionReceipt");
EthQuery.prototype.getUncleByBlockHashAndIndex = generateFnFor("eth_getUncleByBlockHashAndIndex");
EthQuery.prototype.getUncleByBlockNumberAndIndex = generateFnFor("eth_getUncleByBlockNumberAndIndex");
EthQuery.prototype.getCompilers = generateFnFor("eth_getCompilers");
EthQuery.prototype.compileLLL = generateFnFor("eth_compileLLL");
EthQuery.prototype.compileSolidity = generateFnFor("eth_compileSolidity");
EthQuery.prototype.compileSerpent = generateFnFor("eth_compileSerpent");
EthQuery.prototype.newFilter = generateFnFor("eth_newFilter");
EthQuery.prototype.newBlockFilter = generateFnFor("eth_newBlockFilter");
EthQuery.prototype.newPendingTransactionFilter = generateFnFor("eth_newPendingTransactionFilter");
EthQuery.prototype.uninstallFilter = generateFnFor("eth_uninstallFilter");
EthQuery.prototype.getFilterChanges = generateFnFor("eth_getFilterChanges");
EthQuery.prototype.getFilterLogs = generateFnFor("eth_getFilterLogs");
EthQuery.prototype.getLogs = generateFnFor("eth_getLogs");
EthQuery.prototype.getWork = generateFnFor("eth_getWork");
EthQuery.prototype.submitWork = generateFnFor("eth_submitWork");
EthQuery.prototype.submitHashrate = generateFnFor("eth_submitHashrate");
// network level
EthQuery.prototype.sendAsync = function(opts, cb) {
    const self = this;
    self.currentProvider.sendAsync(createPayload(opts), function(err, response) {
        if (!err && response.error) err = new Error("EthQuery - RPC Error - " + response.error.message);
        if (err) return cb(err);
        cb(null, response.result);
    });
};
// util
function generateFnFor(methodName) {
    return function() {
        const self = this;
        var args = [].slice.call(arguments);
        var cb = args.pop();
        self.sendAsync({
            method: methodName,
            params: args
        }, cb);
    };
}
function generateFnWithDefaultBlockFor(argCount, methodName) {
    return function() {
        const self = this;
        var args = [].slice.call(arguments);
        var cb = args.pop();
        // set optional default block param
        if (args.length < argCount) args.push("latest");
        self.sendAsync({
            method: methodName,
            params: args
        }, cb);
    };
}
function createPayload(data) {
    return extend({
        // defaults
        id: createRandomId(),
        jsonrpc: "2.0",
        params: []
    }, data);
}

},{"63158d80aab98463":"7rqcZ","1fe9b38c0825c01":"6XivR"}],"6XivR":[function(require,module,exports) {
module.exports = IdIterator;
function IdIterator(opts) {
    opts = opts || {};
    var max = opts.max || Number.MAX_SAFE_INTEGER;
    var idCounter = typeof opts.start !== "undefined" ? opts.start : Math.floor(Math.random() * max);
    return function createRandomId() {
        idCounter = idCounter % max;
        return idCounter++;
    };
}

},{}],"bbZBH":[function(require,module,exports) {
const util = require("2a8a31287181231b");
const EventEmitter = require("40d11809827e37c7");
var R = typeof Reflect === "object" ? Reflect : null;
var ReflectApply = R && typeof R.apply === "function" ? R.apply : function ReflectApply(target, receiver, args) {
    return Function.prototype.apply.call(target, receiver, args);
};
module.exports = SafeEventEmitter;
function SafeEventEmitter() {
    EventEmitter.call(this);
}
util.inherits(SafeEventEmitter, EventEmitter);
SafeEventEmitter.prototype.emit = function(type) {
    // copied from https://github.com/Gozala/events/blob/master/events.js
    // modified lines are commented with "edited:"
    var args = [];
    for(var i = 1; i < arguments.length; i++)args.push(arguments[i]);
    var doError = type === "error";
    var events = this._events;
    if (events !== undefined) doError = doError && events.error === undefined;
    else if (!doError) return false;
    // If there is no 'error' event listener then throw.
    if (doError) {
        var er;
        if (args.length > 0) er = args[0];
        if (er instanceof Error) // Note: The comments on the `throw` lines are intentional, they show
        // up in Node's output if this results in an unhandled exception.
        throw er; // Unhandled 'error' event
        // At least give some kind of context to the user
        var err = new Error("Unhandled error." + (er ? " (" + er.message + ")" : ""));
        err.context = er;
        throw err; // Unhandled 'error' event
    }
    var handler = events[type];
    if (handler === undefined) return false;
    if (typeof handler === "function") // edited: using safeApply
    safeApply(handler, this, args);
    else {
        var len = handler.length;
        var listeners = arrayClone(handler, len);
        for(var i = 0; i < len; ++i)// edited: using safeApply
        safeApply(listeners[i], this, args);
    }
    return true;
};
function safeApply(handler, context, args) {
    try {
        ReflectApply(handler, context, args);
    } catch (err) {
        // throw error after timeout so as not to interupt the stack
        setTimeout(()=>{
            throw err;
        });
    }
}
function arrayClone(arr, n) {
    var copy = new Array(n);
    for(var i = 0; i < n; ++i)copy[i] = arr[i];
    return copy;
}

},{"2a8a31287181231b":"jInrX","40d11809827e37c7":"fqTtD"}],"jC3PU":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _doParallel = require("e88f175c946c891c");
var _doParallel2 = _interopRequireDefault(_doParallel);
var _map = require("b9e1e798993c5a4");
var _map2 = _interopRequireDefault(_map);
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * Produces a new collection of values by mapping each value in `coll` through
 * the `iteratee` function. The `iteratee` is called with an item from `coll`
 * and a callback for when it has finished processing. Each of these callback
 * takes 2 arguments: an `error`, and the transformed item from `coll`. If
 * `iteratee` passes an error to its callback, the main `callback` (for the
 * `map` function) is immediately called with the error.
 *
 * Note, that since this function applies the `iteratee` to each item in
 * parallel, there is no guarantee that the `iteratee` functions will complete
 * in order. However, the results array will be in the same order as the
 * original `coll`.
 *
 * If `map` is passed an Object, the results will be an Array.  The results
 * will roughly be in the order of the original Objects' keys (but this can
 * vary across JavaScript engines).
 *
 * @name map
 * @static
 * @memberOf module:Collections
 * @method
 * @category Collection
 * @param {Array|Iterable|Object} coll - A collection to iterate over.
 * @param {AsyncFunction} iteratee - An async function to apply to each item in
 * `coll`.
 * The iteratee should complete with the transformed item.
 * Invoked with (item, callback).
 * @param {Function} [callback] - A callback which is called when all `iteratee`
 * functions have finished, or an error occurs. Results is an Array of the
 * transformed items from the `coll`. Invoked with (err, results).
 * @example
 *
 * async.map(['file1','file2','file3'], fs.stat, function(err, results) {
 *     // results is now an array of stats for each file
 * });
 */ exports.default = (0, _doParallel2.default)(_map2.default);
module.exports = exports["default"];

},{"e88f175c946c891c":"arRBo","b9e1e798993c5a4":"cIsCe"}],"arRBo":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = doParallel;
var _eachOf = require("4f22b13a1ad0d367");
var _eachOf2 = _interopRequireDefault(_eachOf);
var _wrapAsync = require("2b94bb1ec36249f0");
var _wrapAsync2 = _interopRequireDefault(_wrapAsync);
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function doParallel(fn) {
    return function(obj, iteratee, callback) {
        return fn(_eachOf2.default, obj, (0, _wrapAsync2.default)(iteratee), callback);
    };
}
module.exports = exports["default"];

},{"4f22b13a1ad0d367":"bRXKs","2b94bb1ec36249f0":"jj6ne"}],"bRXKs":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = function(coll, iteratee, callback) {
    var eachOfImplementation = (0, _isArrayLike2.default)(coll) ? eachOfArrayLike : eachOfGeneric;
    eachOfImplementation(coll, (0, _wrapAsync2.default)(iteratee), callback);
};
var _isArrayLike = require("51a43d60a50752e5");
var _isArrayLike2 = _interopRequireDefault(_isArrayLike);
var _breakLoop = require("2e32100436f00f4c");
var _breakLoop2 = _interopRequireDefault(_breakLoop);
var _eachOfLimit = require("2c437fd313c0ef17");
var _eachOfLimit2 = _interopRequireDefault(_eachOfLimit);
var _doLimit = require("fcac50b9bbaa62c");
var _doLimit2 = _interopRequireDefault(_doLimit);
var _noop = require("da3bbba7b10ec97c");
var _noop2 = _interopRequireDefault(_noop);
var _once = require("c04bacf71b6f2ebe");
var _once2 = _interopRequireDefault(_once);
var _onlyOnce = require("8a097e38bc4a17f7");
var _onlyOnce2 = _interopRequireDefault(_onlyOnce);
var _wrapAsync = require("c25de735c7dc76ee");
var _wrapAsync2 = _interopRequireDefault(_wrapAsync);
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
// eachOf implementation optimized for array-likes
function eachOfArrayLike(coll, iteratee, callback) {
    callback = (0, _once2.default)(callback || _noop2.default);
    var index = 0, completed = 0, length = coll.length;
    if (length === 0) callback(null);
    function iteratorCallback(err, value) {
        if (err) callback(err);
        else if (++completed === length || value === _breakLoop2.default) callback(null);
    }
    for(; index < length; index++)iteratee(coll[index], index, (0, _onlyOnce2.default)(iteratorCallback));
}
// a generic version of eachOf which can handle array, object, and iterator cases.
var eachOfGeneric = (0, _doLimit2.default)(_eachOfLimit2.default, Infinity);
/**
 * Like [`each`]{@link module:Collections.each}, except that it passes the key (or index) as the second argument
 * to the iteratee.
 *
 * @name eachOf
 * @static
 * @memberOf module:Collections
 * @method
 * @alias forEachOf
 * @category Collection
 * @see [async.each]{@link module:Collections.each}
 * @param {Array|Iterable|Object} coll - A collection to iterate over.
 * @param {AsyncFunction} iteratee - A function to apply to each
 * item in `coll`.
 * The `key` is the item's key, or index in the case of an array.
 * Invoked with (item, key, callback).
 * @param {Function} [callback] - A callback which is called when all
 * `iteratee` functions have finished, or an error occurs. Invoked with (err).
 * @example
 *
 * var obj = {dev: "/dev.json", test: "/test.json", prod: "/prod.json"};
 * var configs = {};
 *
 * async.forEachOf(obj, function (value, key, callback) {
 *     fs.readFile(__dirname + value, "utf8", function (err, data) {
 *         if (err) return callback(err);
 *         try {
 *             configs[key] = JSON.parse(data);
 *         } catch (e) {
 *             return callback(e);
 *         }
 *         callback();
 *     });
 * }, function (err) {
 *     if (err) console.error(err.message);
 *     // configs is now a map of JSON data
 *     doSomethingWith(configs);
 * });
 */ module.exports = exports["default"];

},{"51a43d60a50752e5":"5uWOF","2e32100436f00f4c":"3nC3j","2c437fd313c0ef17":"e39xx","fcac50b9bbaa62c":"5uRAp","da3bbba7b10ec97c":"8qs1l","c04bacf71b6f2ebe":"bBLnu","8a097e38bc4a17f7":"e2khU","c25de735c7dc76ee":"jj6ne"}],"5uWOF":[function(require,module,exports) {
var isFunction = require("bb060d4356645330"), isLength = require("f3db08d4d1110aaf");
/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */ function isArrayLike(value) {
    return value != null && isLength(value.length) && !isFunction(value);
}
module.exports = isArrayLike;

},{"bb060d4356645330":"i4ymb","f3db08d4d1110aaf":"g5LO3"}],"i4ymb":[function(require,module,exports) {
var baseGetTag = require("5419308bd9194e11"), isObject = require("3cba3c966459d528");
/** `Object#toString` result references. */ var asyncTag = "[object AsyncFunction]", funcTag = "[object Function]", genTag = "[object GeneratorFunction]", proxyTag = "[object Proxy]";
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function isFunction(value) {
    if (!isObject(value)) return false;
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 9 which returns 'object' for typed arrays and other constructors.
    var tag = baseGetTag(value);
    return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}
module.exports = isFunction;

},{"5419308bd9194e11":"fQG2h","3cba3c966459d528":"3TlAp"}],"fQG2h":[function(require,module,exports) {
var Symbol = require("68a84eb98c5d3fa2"), getRawTag = require("9b2aaf31b7bdd837"), objectToString = require("46d5beb3375f8a28");
/** `Object#toString` result references. */ var nullTag = "[object Null]", undefinedTag = "[object Undefined]";
/** Built-in value references. */ var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function baseGetTag(value) {
    if (value == null) return value === undefined ? undefinedTag : nullTag;
    return symToStringTag && symToStringTag in Object(value) ? getRawTag(value) : objectToString(value);
}
module.exports = baseGetTag;

},{"68a84eb98c5d3fa2":"e0ngr","9b2aaf31b7bdd837":"5XmKh","46d5beb3375f8a28":"fT5CU"}],"e0ngr":[function(require,module,exports) {
var root = require("9ff1abd51ad45ac0");
/** Built-in value references. */ var Symbol = root.Symbol;
module.exports = Symbol;

},{"9ff1abd51ad45ac0":"iGWPT"}],"iGWPT":[function(require,module,exports) {
var freeGlobal = require("cd92e8811deaabf5");
/** Detect free variable `self`. */ var freeSelf = typeof self == "object" && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var root = freeGlobal || freeSelf || Function("return this")();
module.exports = root;

},{"cd92e8811deaabf5":"hw1wy"}],"hw1wy":[function(require,module,exports) {
/** Detect free variable `global` from Node.js. */ var global = arguments[3];
var freeGlobal = typeof global == "object" && global && global.Object === Object && global;
module.exports = freeGlobal;

},{}],"5XmKh":[function(require,module,exports) {
var Symbol = require("e9b4533b2a68f814");
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var nativeObjectToString = objectProto.toString;
/** Built-in value references. */ var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function getRawTag(value) {
    var isOwn = hasOwnProperty.call(value, symToStringTag), tag = value[symToStringTag];
    try {
        value[symToStringTag] = undefined;
        var unmasked = true;
    } catch (e) {}
    var result = nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) value[symToStringTag] = tag;
        else delete value[symToStringTag];
    }
    return result;
}
module.exports = getRawTag;

},{"e9b4533b2a68f814":"e0ngr"}],"fT5CU":[function(require,module,exports) {
/** Used for built-in method references. */ var objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var nativeObjectToString = objectProto.toString;
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function objectToString(value) {
    return nativeObjectToString.call(value);
}
module.exports = objectToString;

},{}],"3TlAp":[function(require,module,exports) {
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function isObject(value) {
    var type = typeof value;
    return value != null && (type == "object" || type == "function");
}
module.exports = isObject;

},{}],"g5LO3":[function(require,module,exports) {
/** Used as references for various `Number` constants. */ var MAX_SAFE_INTEGER = 9007199254740991;
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */ function isLength(value) {
    return typeof value == "number" && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}
module.exports = isLength;

},{}],"3nC3j":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
// A temporary value used to identify if the loop should be broken.
// See #1064, #1293
exports.default = {};
module.exports = exports["default"];

},{}],"e39xx":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = eachOfLimit;
var _eachOfLimit2 = require("9980cac92570fe1a");
var _eachOfLimit3 = _interopRequireDefault(_eachOfLimit2);
var _wrapAsync = require("6cbff50f07f739cd");
var _wrapAsync2 = _interopRequireDefault(_wrapAsync);
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * The same as [`eachOf`]{@link module:Collections.eachOf} but runs a maximum of `limit` async operations at a
 * time.
 *
 * @name eachOfLimit
 * @static
 * @memberOf module:Collections
 * @method
 * @see [async.eachOf]{@link module:Collections.eachOf}
 * @alias forEachOfLimit
 * @category Collection
 * @param {Array|Iterable|Object} coll - A collection to iterate over.
 * @param {number} limit - The maximum number of async operations at a time.
 * @param {AsyncFunction} iteratee - An async function to apply to each
 * item in `coll`. The `key` is the item's key, or index in the case of an
 * array.
 * Invoked with (item, key, callback).
 * @param {Function} [callback] - A callback which is called when all
 * `iteratee` functions have finished, or an error occurs. Invoked with (err).
 */ function eachOfLimit(coll, limit, iteratee, callback) {
    (0, _eachOfLimit3.default)(limit)(coll, (0, _wrapAsync2.default)(iteratee), callback);
}
module.exports = exports["default"];

},{"9980cac92570fe1a":"cMWZp","6cbff50f07f739cd":"jj6ne"}],"cMWZp":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = _eachOfLimit;
var _noop = require("71cfc341403ecc5");
var _noop2 = _interopRequireDefault(_noop);
var _once = require("e40b4c5b0ddecffa");
var _once2 = _interopRequireDefault(_once);
var _iterator = require("d86c360360b8d197");
var _iterator2 = _interopRequireDefault(_iterator);
var _onlyOnce = require("1caee0305e2f3b97");
var _onlyOnce2 = _interopRequireDefault(_onlyOnce);
var _breakLoop = require("25dfe787d7e50ee1");
var _breakLoop2 = _interopRequireDefault(_breakLoop);
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _eachOfLimit(limit) {
    return function(obj, iteratee, callback) {
        callback = (0, _once2.default)(callback || _noop2.default);
        if (limit <= 0 || !obj) return callback(null);
        var nextElem = (0, _iterator2.default)(obj);
        var done = false;
        var running = 0;
        var looping = false;
        function iterateeCallback(err, value) {
            running -= 1;
            if (err) {
                done = true;
                callback(err);
            } else if (value === _breakLoop2.default || done && running <= 0) {
                done = true;
                return callback(null);
            } else if (!looping) replenish();
        }
        function replenish() {
            looping = true;
            while(running < limit && !done){
                var elem = nextElem();
                if (elem === null) {
                    done = true;
                    if (running <= 0) callback(null);
                    return;
                }
                running += 1;
                iteratee(elem.value, elem.key, (0, _onlyOnce2.default)(iterateeCallback));
            }
            looping = false;
        }
        replenish();
    };
}
module.exports = exports["default"];

},{"71cfc341403ecc5":"8qs1l","e40b4c5b0ddecffa":"bBLnu","d86c360360b8d197":"eo5oy","1caee0305e2f3b97":"e2khU","25dfe787d7e50ee1":"3nC3j"}],"8qs1l":[function(require,module,exports) {
/**
 * This method returns `undefined`.
 *
 * @static
 * @memberOf _
 * @since 2.3.0
 * @category Util
 * @example
 *
 * _.times(2, _.noop);
 * // => [undefined, undefined]
 */ function noop() {
// No operation performed.
}
module.exports = noop;

},{}],"bBLnu":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = once;
function once(fn) {
    return function() {
        if (fn === null) return;
        var callFn = fn;
        fn = null;
        callFn.apply(this, arguments);
    };
}
module.exports = exports["default"];

},{}],"eo5oy":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = iterator;
var _isArrayLike = require("1c8c2682822c69d6");
var _isArrayLike2 = _interopRequireDefault(_isArrayLike);
var _getIterator = require("9812784126b5e869");
var _getIterator2 = _interopRequireDefault(_getIterator);
var _keys = require("5ac7884ab5a09160");
var _keys2 = _interopRequireDefault(_keys);
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function createArrayIterator(coll) {
    var i = -1;
    var len = coll.length;
    return function next() {
        return ++i < len ? {
            value: coll[i],
            key: i
        } : null;
    };
}
function createES2015Iterator(iterator) {
    var i = -1;
    return function next() {
        var item = iterator.next();
        if (item.done) return null;
        i++;
        return {
            value: item.value,
            key: i
        };
    };
}
function createObjectIterator(obj) {
    var okeys = (0, _keys2.default)(obj);
    var i = -1;
    var len = okeys.length;
    return function next() {
        var key = okeys[++i];
        if (key === "__proto__") return next();
        return i < len ? {
            value: obj[key],
            key: key
        } : null;
    };
}
function iterator(coll) {
    if ((0, _isArrayLike2.default)(coll)) return createArrayIterator(coll);
    var iterator = (0, _getIterator2.default)(coll);
    return iterator ? createES2015Iterator(iterator) : createObjectIterator(coll);
}
module.exports = exports["default"];

},{"1c8c2682822c69d6":"5uWOF","9812784126b5e869":"ak1f6","5ac7884ab5a09160":"cu4o9"}],"ak1f6":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = function(coll) {
    return iteratorSymbol && coll[iteratorSymbol] && coll[iteratorSymbol]();
};
var iteratorSymbol = typeof Symbol === "function" && Symbol.iterator;
module.exports = exports["default"];

},{}],"cu4o9":[function(require,module,exports) {
var arrayLikeKeys = require("4c73ca42c789e5ab"), baseKeys = require("e8453365fdacc8da"), isArrayLike = require("7760b47b02971dfa");
/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */ function keys(object) {
    return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}
module.exports = keys;

},{"4c73ca42c789e5ab":"2dYEW","e8453365fdacc8da":"cUzQF","7760b47b02971dfa":"5uWOF"}],"2dYEW":[function(require,module,exports) {
var baseTimes = require("7ed875a0e67be76f"), isArguments = require("9cdb51ffa56f149b"), isArray = require("38cd49f1e493b3d7"), isBuffer = require("b379831fe1873fed"), isIndex = require("f362a34cd8321bb7"), isTypedArray = require("c019db5297494469");
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */ function arrayLikeKeys(value, inherited) {
    var isArr = isArray(value), isArg = !isArr && isArguments(value), isBuff = !isArr && !isArg && isBuffer(value), isType = !isArr && !isArg && !isBuff && isTypedArray(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? baseTimes(value.length, String) : [], length = result.length;
    for(var key in value)if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
    (key == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    isBuff && (key == "offset" || key == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    isType && (key == "buffer" || key == "byteLength" || key == "byteOffset") || // Skip index properties.
    isIndex(key, length)))) result.push(key);
    return result;
}
module.exports = arrayLikeKeys;

},{"7ed875a0e67be76f":"gWKTt","9cdb51ffa56f149b":"asnYU","38cd49f1e493b3d7":"2VsjV","b379831fe1873fed":"kfeDT","f362a34cd8321bb7":"9uPJ6","c019db5297494469":"hUF8Z"}],"gWKTt":[function(require,module,exports) {
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */ function baseTimes(n, iteratee) {
    var index = -1, result = Array(n);
    while(++index < n)result[index] = iteratee(index);
    return result;
}
module.exports = baseTimes;

},{}],"asnYU":[function(require,module,exports) {
var baseIsArguments = require("b56e5b7d86069686"), isObjectLike = require("bead821d6af018b5");
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/** Built-in value references. */ var propertyIsEnumerable = objectProto.propertyIsEnumerable;
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */ var isArguments = baseIsArguments(function() {
    return arguments;
}()) ? baseIsArguments : function(value) {
    return isObjectLike(value) && hasOwnProperty.call(value, "callee") && !propertyIsEnumerable.call(value, "callee");
};
module.exports = isArguments;

},{"b56e5b7d86069686":"crxEa","bead821d6af018b5":"5TH1N"}],"crxEa":[function(require,module,exports) {
var baseGetTag = require("7e8612a4a451f2cc"), isObjectLike = require("b6cdbe52dcf709f8");
/** `Object#toString` result references. */ var argsTag = "[object Arguments]";
/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */ function baseIsArguments(value) {
    return isObjectLike(value) && baseGetTag(value) == argsTag;
}
module.exports = baseIsArguments;

},{"7e8612a4a451f2cc":"fQG2h","b6cdbe52dcf709f8":"5TH1N"}],"5TH1N":[function(require,module,exports) {
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function isObjectLike(value) {
    return value != null && typeof value == "object";
}
module.exports = isObjectLike;

},{}],"2VsjV":[function(require,module,exports) {
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var isArray = Array.isArray;
module.exports = isArray;

},{}],"kfeDT":[function(require,module,exports) {
var root = require("cef5ec6f0da1ab00"), stubFalse = require("a1e87b138cf75d1d");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */ var Buffer = moduleExports ? root.Buffer : undefined;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;
/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */ var isBuffer = nativeIsBuffer || stubFalse;
module.exports = isBuffer;

},{"cef5ec6f0da1ab00":"iGWPT","a1e87b138cf75d1d":"9OHNT"}],"9OHNT":[function(require,module,exports) {
/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */ function stubFalse() {
    return false;
}
module.exports = stubFalse;

},{}],"9uPJ6":[function(require,module,exports) {
/** Used as references for various `Number` constants. */ var MAX_SAFE_INTEGER = 9007199254740991;
/** Used to detect unsigned integer values. */ var reIsUint = /^(?:0|[1-9]\d*)$/;
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */ function isIndex(value, length) {
    var type = typeof value;
    length = length == null ? MAX_SAFE_INTEGER : length;
    return !!length && (type == "number" || type != "symbol" && reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}
module.exports = isIndex;

},{}],"hUF8Z":[function(require,module,exports) {
var baseIsTypedArray = require("75a26f037e65be61"), baseUnary = require("903f50eb1c16d257"), nodeUtil = require("fa49853a82034c30");
/* Node.js helper references. */ var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */ var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
module.exports = isTypedArray;

},{"75a26f037e65be61":"9IaoX","903f50eb1c16d257":"993qv","fa49853a82034c30":"ihImP"}],"9IaoX":[function(require,module,exports) {
var baseGetTag = require("67544c3df364a802"), isLength = require("f661b3a120d7a4cb"), isObjectLike = require("cdd86c83797c0618");
/** `Object#toString` result references. */ var argsTag = "[object Arguments]", arrayTag = "[object Array]", boolTag = "[object Boolean]", dateTag = "[object Date]", errorTag = "[object Error]", funcTag = "[object Function]", mapTag = "[object Map]", numberTag = "[object Number]", objectTag = "[object Object]", regexpTag = "[object RegExp]", setTag = "[object Set]", stringTag = "[object String]", weakMapTag = "[object WeakMap]";
var arrayBufferTag = "[object ArrayBuffer]", dataViewTag = "[object DataView]", float32Tag = "[object Float32Array]", float64Tag = "[object Float64Array]", int8Tag = "[object Int8Array]", int16Tag = "[object Int16Array]", int32Tag = "[object Int32Array]", uint8Tag = "[object Uint8Array]", uint8ClampedTag = "[object Uint8ClampedArray]", uint16Tag = "[object Uint16Array]", uint32Tag = "[object Uint32Array]";
/** Used to identify `toStringTag` values of typed arrays. */ var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */ function baseIsTypedArray(value) {
    return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}
module.exports = baseIsTypedArray;

},{"67544c3df364a802":"fQG2h","f661b3a120d7a4cb":"g5LO3","cdd86c83797c0618":"5TH1N"}],"993qv":[function(require,module,exports) {
/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */ function baseUnary(func) {
    return function(value) {
        return func(value);
    };
}
module.exports = baseUnary;

},{}],"ihImP":[function(require,module,exports) {
var freeGlobal = require("94e753dfbe54816e");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && freeGlobal.process;
/** Used to access faster Node.js helpers. */ var nodeUtil = function() {
    try {
        // Use `util.types` for Node.js 10+.
        var types = freeModule && freeModule.require && freeModule.require("util").types;
        if (types) return types;
        // Legacy `process.binding('util')` for Node.js < 10.
        return freeProcess && freeProcess.binding && freeProcess.binding("util");
    } catch (e) {}
}();
module.exports = nodeUtil;

},{"94e753dfbe54816e":"hw1wy"}],"cUzQF":[function(require,module,exports) {
var isPrototype = require("7da6298814f9bd95"), nativeKeys = require("3ec652610d8dd5d3");
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function baseKeys(object) {
    if (!isPrototype(object)) return nativeKeys(object);
    var result = [];
    for(var key in Object(object))if (hasOwnProperty.call(object, key) && key != "constructor") result.push(key);
    return result;
}
module.exports = baseKeys;

},{"7da6298814f9bd95":"hcjX5","3ec652610d8dd5d3":"2HmXG"}],"hcjX5":[function(require,module,exports) {
/** Used for built-in method references. */ var objectProto = Object.prototype;
/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */ function isPrototype(value) {
    var Ctor = value && value.constructor, proto = typeof Ctor == "function" && Ctor.prototype || objectProto;
    return value === proto;
}
module.exports = isPrototype;

},{}],"2HmXG":[function(require,module,exports) {
var overArg = require("aa3357c7a3889df");
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeKeys = overArg(Object.keys, Object);
module.exports = nativeKeys;

},{"aa3357c7a3889df":"5rEQb"}],"5rEQb":[function(require,module,exports) {
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
module.exports = overArg;

},{}],"e2khU":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = onlyOnce;
function onlyOnce(fn) {
    return function() {
        if (fn === null) throw new Error("Callback was already called.");
        var callFn = fn;
        fn = null;
        callFn.apply(this, arguments);
    };
}
module.exports = exports["default"];

},{}],"jj6ne":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.isAsync = undefined;
var _asyncify = require("52e7aaff592746f6");
var _asyncify2 = _interopRequireDefault(_asyncify);
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var supportsSymbol = typeof Symbol === "function";
function isAsync(fn) {
    return supportsSymbol && fn[Symbol.toStringTag] === "AsyncFunction";
}
function wrapAsync(asyncFn) {
    return isAsync(asyncFn) ? (0, _asyncify2.default)(asyncFn) : asyncFn;
}
exports.default = wrapAsync;
exports.isAsync = isAsync;

},{"52e7aaff592746f6":"lT2Yo"}],"lT2Yo":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = asyncify;
var _isObject = require("9449b5bf292523f7");
var _isObject2 = _interopRequireDefault(_isObject);
var _initialParams = require("1048983bf30e7d26");
var _initialParams2 = _interopRequireDefault(_initialParams);
var _setImmediate = require("c3b92c411cdfb54f");
var _setImmediate2 = _interopRequireDefault(_setImmediate);
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * Take a sync function and make it async, passing its return value to a
 * callback. This is useful for plugging sync functions into a waterfall,
 * series, or other async functions. Any arguments passed to the generated
 * function will be passed to the wrapped function (except for the final
 * callback argument). Errors thrown will be passed to the callback.
 *
 * If the function passed to `asyncify` returns a Promise, that promises's
 * resolved/rejected state will be used to call the callback, rather than simply
 * the synchronous return value.
 *
 * This also means you can asyncify ES2017 `async` functions.
 *
 * @name asyncify
 * @static
 * @memberOf module:Utils
 * @method
 * @alias wrapSync
 * @category Util
 * @param {Function} func - The synchronous function, or Promise-returning
 * function to convert to an {@link AsyncFunction}.
 * @returns {AsyncFunction} An asynchronous wrapper of the `func`. To be
 * invoked with `(args..., callback)`.
 * @example
 *
 * // passing a regular synchronous function
 * async.waterfall([
 *     async.apply(fs.readFile, filename, "utf8"),
 *     async.asyncify(JSON.parse),
 *     function (data, next) {
 *         // data is the result of parsing the text.
 *         // If there was a parsing error, it would have been caught.
 *     }
 * ], callback);
 *
 * // passing a function returning a promise
 * async.waterfall([
 *     async.apply(fs.readFile, filename, "utf8"),
 *     async.asyncify(function (contents) {
 *         return db.model.create(contents);
 *     }),
 *     function (model, next) {
 *         // `model` is the instantiated model object.
 *         // If there was an error, this function would be skipped.
 *     }
 * ], callback);
 *
 * // es2017 example, though `asyncify` is not needed if your JS environment
 * // supports async functions out of the box
 * var q = async.queue(async.asyncify(async function(file) {
 *     var intermediateStep = await processFile(file);
 *     return await somePromise(intermediateStep)
 * }));
 *
 * q.push(files);
 */ function asyncify(func) {
    return (0, _initialParams2.default)(function(args, callback) {
        var result;
        try {
            result = func.apply(this, args);
        } catch (e) {
            return callback(e);
        }
        // if result is Promise object
        if ((0, _isObject2.default)(result) && typeof result.then === "function") result.then(function(value) {
            invokeCallback(callback, null, value);
        }, function(err) {
            invokeCallback(callback, err.message ? err : new Error(err));
        });
        else callback(null, result);
    });
}
function invokeCallback(callback, error, value) {
    try {
        callback(error, value);
    } catch (e) {
        (0, _setImmediate2.default)(rethrow, e);
    }
}
function rethrow(error) {
    throw error;
}
module.exports = exports["default"];

},{"9449b5bf292523f7":"3TlAp","1048983bf30e7d26":"jeAcA","c3b92c411cdfb54f":"k7au1"}],"jeAcA":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = function(fn) {
    return function() /*...args, callback*/ {
        var args = (0, _slice2.default)(arguments);
        var callback = args.pop();
        fn.call(this, args, callback);
    };
};
var _slice = require("bf550e203bfe0f3f");
var _slice2 = _interopRequireDefault(_slice);
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
module.exports = exports["default"];

},{"bf550e203bfe0f3f":"2vgdt"}],"2vgdt":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = slice;
function slice(arrayLike, start) {
    start = start | 0;
    var newLen = Math.max(arrayLike.length - start, 0);
    var newArr = Array(newLen);
    for(var idx = 0; idx < newLen; idx++)newArr[idx] = arrayLike[start + idx];
    return newArr;
}
module.exports = exports["default"];

},{}],"k7au1":[function(require,module,exports) {
var process = require("c27d459d95cfc2a");
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.hasNextTick = exports.hasSetImmediate = undefined;
exports.fallback = fallback;
exports.wrap = wrap;
var _slice = require("50d48240285294a3");
var _slice2 = _interopRequireDefault(_slice);
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var hasSetImmediate = exports.hasSetImmediate = typeof setImmediate === "function" && setImmediate;
var hasNextTick = exports.hasNextTick = typeof process === "object" && typeof process.nextTick === "function";
function fallback(fn) {
    setTimeout(fn, 0);
}
function wrap(defer) {
    return function(fn /*, ...args*/ ) {
        var args = (0, _slice2.default)(arguments, 1);
        defer(function() {
            fn.apply(null, args);
        });
    };
}
var _defer;
if (hasSetImmediate) _defer = setImmediate;
else if (hasNextTick) _defer = process.nextTick;
else _defer = fallback;
exports.default = wrap(_defer);

},{"c27d459d95cfc2a":"5QIF0","50d48240285294a3":"2vgdt"}],"5uRAp":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = doLimit;
function doLimit(fn, limit) {
    return function(iterable, iteratee, callback) {
        return fn(iterable, limit, iteratee, callback);
    };
}
module.exports = exports["default"];

},{}],"cIsCe":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = _asyncMap;
var _noop = require("27cd63ee0fb2ef4c");
var _noop2 = _interopRequireDefault(_noop);
var _wrapAsync = require("e654e72593520865");
var _wrapAsync2 = _interopRequireDefault(_wrapAsync);
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _asyncMap(eachfn, arr, iteratee, callback) {
    callback = callback || _noop2.default;
    arr = arr || [];
    var results = [];
    var counter = 0;
    var _iteratee = (0, _wrapAsync2.default)(iteratee);
    eachfn(arr, function(value, _, callback) {
        var index = counter++;
        _iteratee(value, function(err, v) {
            results[index] = v;
            callback(err);
        });
    }, function(err) {
        callback(err, results);
    });
}
module.exports = exports["default"];

},{"27cd63ee0fb2ef4c":"8qs1l","e654e72593520865":"jj6ne"}],"cQuNM":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _eachLimit = require("dda2d3c9a295a48b");
var _eachLimit2 = _interopRequireDefault(_eachLimit);
var _doLimit = require("3186e7dfeb6cb393");
var _doLimit2 = _interopRequireDefault(_doLimit);
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * The same as [`each`]{@link module:Collections.each} but runs only a single async operation at a time.
 *
 * @name eachSeries
 * @static
 * @memberOf module:Collections
 * @method
 * @see [async.each]{@link module:Collections.each}
 * @alias forEachSeries
 * @category Collection
 * @param {Array|Iterable|Object} coll - A collection to iterate over.
 * @param {AsyncFunction} iteratee - An async function to apply to each
 * item in `coll`.
 * The array index is not passed to the iteratee.
 * If you need the index, use `eachOfSeries`.
 * Invoked with (item, callback).
 * @param {Function} [callback] - A callback which is called when all
 * `iteratee` functions have finished, or an error occurs. Invoked with (err).
 */ exports.default = (0, _doLimit2.default)(_eachLimit2.default, 1);
module.exports = exports["default"];

},{"dda2d3c9a295a48b":"5aG1z","3186e7dfeb6cb393":"5uRAp"}],"5aG1z":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = eachLimit;
var _eachOfLimit = require("65e070badb542f6e");
var _eachOfLimit2 = _interopRequireDefault(_eachOfLimit);
var _withoutIndex = require("38df64ba7b3d80fe");
var _withoutIndex2 = _interopRequireDefault(_withoutIndex);
var _wrapAsync = require("299a772ea39a2ca3");
var _wrapAsync2 = _interopRequireDefault(_wrapAsync);
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * The same as [`each`]{@link module:Collections.each} but runs a maximum of `limit` async operations at a time.
 *
 * @name eachLimit
 * @static
 * @memberOf module:Collections
 * @method
 * @see [async.each]{@link module:Collections.each}
 * @alias forEachLimit
 * @category Collection
 * @param {Array|Iterable|Object} coll - A collection to iterate over.
 * @param {number} limit - The maximum number of async operations at a time.
 * @param {AsyncFunction} iteratee - An async function to apply to each item in
 * `coll`.
 * The array index is not passed to the iteratee.
 * If you need the index, use `eachOfLimit`.
 * Invoked with (item, callback).
 * @param {Function} [callback] - A callback which is called when all
 * `iteratee` functions have finished, or an error occurs. Invoked with (err).
 */ function eachLimit(coll, limit, iteratee, callback) {
    (0, _eachOfLimit2.default)(limit)(coll, (0, _withoutIndex2.default)((0, _wrapAsync2.default)(iteratee)), callback);
}
module.exports = exports["default"];

},{"65e070badb542f6e":"cMWZp","38df64ba7b3d80fe":"f0kWZ","299a772ea39a2ca3":"jj6ne"}],"f0kWZ":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = _withoutIndex;
function _withoutIndex(iteratee) {
    return function(value, index, callback) {
        return iteratee(value, callback);
    };
}
module.exports = exports["default"];

},{}],"dRfgC":[function(require,module,exports) {
const EventEmitter = require("862b637f799aa043").EventEmitter;
const inherits = require("4c2571f10b2aee14").inherits;
module.exports = Stoplight;
inherits(Stoplight, EventEmitter);
function Stoplight() {
    const self = this;
    EventEmitter.call(self);
    self.isLocked = true;
}
Stoplight.prototype.go = function() {
    const self = this;
    self.isLocked = false;
    self.emit("unlock");
};
Stoplight.prototype.stop = function() {
    const self = this;
    self.isLocked = true;
    self.emit("lock");
};
Stoplight.prototype.await = function(fn) {
    const self = this;
    if (self.isLocked) self.once("unlock", fn);
    else setTimeout(fn);
};

},{"862b637f799aa043":"fqTtD","4c2571f10b2aee14":"jInrX"}],"hrGw9":[function(require,module,exports) {
const stringify = require("ca326db62a8fae10");
module.exports = {
    cacheIdentifierForPayload: cacheIdentifierForPayload,
    canCache: canCache,
    blockTagForPayload: blockTagForPayload,
    paramsWithoutBlockTag: paramsWithoutBlockTag,
    blockTagParamIndex: blockTagParamIndex,
    cacheTypeForPayload: cacheTypeForPayload
};
function cacheIdentifierForPayload(payload, opts = {}) {
    if (!canCache(payload)) return null;
    const { includeBlockRef } = opts;
    const params = includeBlockRef ? payload.params : paramsWithoutBlockTag(payload);
    return payload.method + ":" + stringify(params);
}
function canCache(payload) {
    return cacheTypeForPayload(payload) !== "never";
}
function blockTagForPayload(payload) {
    var index = blockTagParamIndex(payload);
    // Block tag param not passed.
    if (index >= payload.params.length) return null;
    return payload.params[index];
}
function paramsWithoutBlockTag(payload) {
    var index = blockTagParamIndex(payload);
    // Block tag param not passed.
    if (index >= payload.params.length) return payload.params;
    // eth_getBlockByNumber has the block tag first, then the optional includeTx? param
    if (payload.method === "eth_getBlockByNumber") return payload.params.slice(1);
    return payload.params.slice(0, index);
}
function blockTagParamIndex(payload) {
    switch(payload.method){
        // blockTag is third param
        case "eth_getStorageAt":
            return 2;
        // blockTag is second param
        case "eth_getBalance":
        case "eth_getCode":
        case "eth_getTransactionCount":
        case "eth_call":
        case "eth_estimateGas":
            return 1;
        // blockTag is first param
        case "eth_getBlockByNumber":
            return 0;
        // there is no blockTag
        default:
            return undefined;
    }
}
function cacheTypeForPayload(payload) {
    switch(payload.method){
        // cache permanently
        case "web3_clientVersion":
        case "web3_sha3":
        case "eth_protocolVersion":
        case "eth_getBlockTransactionCountByHash":
        case "eth_getUncleCountByBlockHash":
        case "eth_getCode":
        case "eth_getBlockByHash":
        case "eth_getTransactionByHash":
        case "eth_getTransactionByBlockHashAndIndex":
        case "eth_getTransactionReceipt":
        case "eth_getUncleByBlockHashAndIndex":
        case "eth_getCompilers":
        case "eth_compileLLL":
        case "eth_compileSolidity":
        case "eth_compileSerpent":
        case "shh_version":
            return "perma";
        // cache until fork
        case "eth_getBlockByNumber":
        case "eth_getBlockTransactionCountByNumber":
        case "eth_getUncleCountByBlockNumber":
        case "eth_getTransactionByBlockNumberAndIndex":
        case "eth_getUncleByBlockNumberAndIndex":
            return "fork";
        // cache for block
        case "eth_gasPrice":
        case "eth_getBalance":
        case "eth_getStorageAt":
        case "eth_getTransactionCount":
        case "eth_call":
        case "eth_estimateGas":
        case "eth_getFilterLogs":
        case "eth_getLogs":
        case "eth_blockNumber":
            return "block";
        // never cache
        case "net_version":
        case "net_peerCount":
        case "net_listening":
        case "eth_syncing":
        case "eth_sign":
        case "eth_coinbase":
        case "eth_mining":
        case "eth_hashrate":
        case "eth_accounts":
        case "eth_sendTransaction":
        case "eth_sendRawTransaction":
        case "eth_newFilter":
        case "eth_newBlockFilter":
        case "eth_newPendingTransactionFilter":
        case "eth_uninstallFilter":
        case "eth_getFilterChanges":
        case "eth_getWork":
        case "eth_submitWork":
        case "eth_submitHashrate":
        case "db_putString":
        case "db_getString":
        case "db_putHex":
        case "db_getHex":
        case "shh_post":
        case "shh_newIdentity":
        case "shh_hasIdentity":
        case "shh_newGroup":
        case "shh_addToGroup":
        case "shh_newFilter":
        case "shh_uninstallFilter":
        case "shh_getFilterChanges":
        case "shh_getMessages":
            return "never";
    }
}

},{"ca326db62a8fae10":"j4ohj"}],"j4ohj":[function(require,module,exports) {
"use strict";
var jsonStringify = (typeof JSON !== "undefined" ? JSON : require("b07ff500bdee2e90")).stringify;
var isArray = require("ebfe9bb75fd84371");
var objectKeys = require("1191eb5a6b8ba970");
var callBind = require("2fd6ec668a98050b");
var callBound = require("18d6eac28b97f5ec");
var $join = callBound("Array.prototype.join");
var $push = callBound("Array.prototype.push");
var strRepeat = function repeat(n, char) {
    var str = "";
    for(var i = 0; i < n; i += 1)str += char;
    return str;
};
var defaultReplacer = function(parent, key, value) {
    return value;
};
module.exports = function stableStringify(obj) {
    var opts = arguments.length > 1 ? arguments[1] : void 0;
    var space = opts && opts.space || "";
    if (typeof space === "number") space = strRepeat(space, " ");
    var cycles = !!opts && typeof opts.cycles === "boolean" && opts.cycles;
    var replacer = opts && opts.replacer ? callBind(opts.replacer) : defaultReplacer;
    var cmpOpt = typeof opts === "function" ? opts : opts && opts.cmp;
    var cmp = cmpOpt && function(node) {
        var get = cmpOpt.length > 2 && function get(k) {
            return node[k];
        };
        return function(a, b) {
            return cmpOpt({
                key: a,
                value: node[a]
            }, {
                key: b,
                value: node[b]
            }, get ? {
                __proto__: null,
                get: get
            } : void 0);
        };
    };
    var seen = [];
    return function stringify(parent, key, node, level) {
        var indent = space ? "\n" + strRepeat(level, space) : "";
        var colonSeparator = space ? ": " : ":";
        if (node && node.toJSON && typeof node.toJSON === "function") node = node.toJSON();
        node = replacer(parent, key, node);
        if (node === undefined) return;
        if (typeof node !== "object" || node === null) return jsonStringify(node);
        if (isArray(node)) {
            var out = [];
            for(var i = 0; i < node.length; i++){
                var item = stringify(node, i, node[i], level + 1) || jsonStringify(null);
                $push(out, indent + space + item);
            }
            return "[" + $join(out, ",") + indent + "]";
        }
        if (seen.indexOf(node) !== -1) {
            if (cycles) return jsonStringify("__cycle__");
            throw new TypeError("Converting circular structure to JSON");
        } else $push(seen, node);
        var keys = objectKeys(node).sort(cmp && cmp(node));
        var out = [];
        for(var i = 0; i < keys.length; i++){
            var key = keys[i];
            var value = stringify(node, key, node[key], level + 1);
            if (!value) continue;
            var keyValue = jsonStringify(key) + colonSeparator + value;
            $push(out, indent + space + keyValue);
        }
        seen.splice(seen.indexOf(node), 1);
        return "{" + $join(out, ",") + indent + "}";
    }({
        "": obj
    }, "", obj, 0);
};

},{"b07ff500bdee2e90":"kCJof","ebfe9bb75fd84371":"grrgb","1191eb5a6b8ba970":"3gfZs","2fd6ec668a98050b":"8iKie","18d6eac28b97f5ec":"eK6wT"}],"kCJof":[function(require,module,exports) {
"use strict";
exports.parse = require("688d4b84effe92d1");
exports.stringify = require("9a760f11b23b3862");

},{"688d4b84effe92d1":"aK3ZL","9a760f11b23b3862":"kHsFJ"}],"aK3ZL":[function(require,module,exports) {
"use strict";
var at; // The index of the current character
var ch; // The current character
var escapee = {
    '"': '"',
    "\\": "\\",
    "/": "/",
    b: "\b",
    f: "\f",
    n: "\n",
    r: "\r",
    t: "	"
};
var text;
// Call error when something is wrong.
function error(m) {
    throw {
        name: "SyntaxError",
        message: m,
        at: at,
        text: text
    };
}
function next(c) {
    // If a c parameter is provided, verify that it matches the current character.
    if (c && c !== ch) error("Expected '" + c + "' instead of '" + ch + "'");
    // Get the next character. When there are no more characters, return the empty string.
    ch = text.charAt(at);
    at += 1;
    return ch;
}
function number() {
    // Parse a number value.
    var num;
    var str = "";
    if (ch === "-") {
        str = "-";
        next("-");
    }
    while(ch >= "0" && ch <= "9"){
        str += ch;
        next();
    }
    if (ch === ".") {
        str += ".";
        while(next() && ch >= "0" && ch <= "9")str += ch;
    }
    if (ch === "e" || ch === "E") {
        str += ch;
        next();
        if (ch === "-" || ch === "+") {
            str += ch;
            next();
        }
        while(ch >= "0" && ch <= "9"){
            str += ch;
            next();
        }
    }
    num = Number(str);
    if (!isFinite(num)) error("Bad number");
    return num;
}
function string() {
    // Parse a string value.
    var hex;
    var i;
    var str = "";
    var uffff;
    // When parsing for string values, we must look for " and \ characters.
    if (ch === '"') while(next()){
        if (ch === '"') {
            next();
            return str;
        } else if (ch === "\\") {
            next();
            if (ch === "u") {
                uffff = 0;
                for(i = 0; i < 4; i += 1){
                    hex = parseInt(next(), 16);
                    if (!isFinite(hex)) break;
                    uffff = uffff * 16 + hex;
                }
                str += String.fromCharCode(uffff);
            } else if (typeof escapee[ch] === "string") str += escapee[ch];
            else break;
        } else str += ch;
    }
    error("Bad string");
}
// Skip whitespace.
function white() {
    while(ch && ch <= " ")next();
}
// true, false, or null.
function word() {
    switch(ch){
        case "t":
            next("t");
            next("r");
            next("u");
            next("e");
            return true;
        case "f":
            next("f");
            next("a");
            next("l");
            next("s");
            next("e");
            return false;
        case "n":
            next("n");
            next("u");
            next("l");
            next("l");
            return null;
        default:
            error("Unexpected '" + ch + "'");
    }
}
// Parse an array value.
function array() {
    var arr = [];
    if (ch === "[") {
        next("[");
        white();
        if (ch === "]") {
            next("]");
            return arr; // empty array
        }
        while(ch){
            arr.push(value()); // eslint-disable-line no-use-before-define
            white();
            if (ch === "]") {
                next("]");
                return arr;
            }
            next(",");
            white();
        }
    }
    error("Bad array");
}
// Parse an object value.
function object() {
    var key;
    var obj = {};
    if (ch === "{") {
        next("{");
        white();
        if (ch === "}") {
            next("}");
            return obj; // empty object
        }
        while(ch){
            key = string();
            white();
            next(":");
            if (Object.prototype.hasOwnProperty.call(obj, key)) error('Duplicate key "' + key + '"');
            obj[key] = value(); // eslint-disable-line no-use-before-define
            white();
            if (ch === "}") {
                next("}");
                return obj;
            }
            next(",");
            white();
        }
    }
    error("Bad object");
}
// Parse a JSON value. It could be an object, an array, a string, a number, or a word.
function value() {
    white();
    switch(ch){
        case "{":
            return object();
        case "[":
            return array();
        case '"':
            return string();
        case "-":
            return number();
        default:
            return ch >= "0" && ch <= "9" ? number() : word();
    }
}
// Return the json_parse function. It will have access to all of the above functions and variables.
module.exports = function(source, reviver) {
    var result;
    text = source;
    at = 0;
    ch = " ";
    result = value();
    white();
    if (ch) error("Syntax error");
    // If there is a reviver function, we recursively walk the new structure,
    // passing each name/value pair to the reviver function for possible
    // transformation, starting with a temporary root object that holds the result
    // in an empty key. If there is not a reviver function, we simply return the
    // result.
    return typeof reviver === "function" ? function walk(holder, key) {
        var k;
        var v;
        var val = holder[key];
        if (val && typeof val === "object") {
            for(k in value)if (Object.prototype.hasOwnProperty.call(val, k)) {
                v = walk(val, k);
                if (typeof v === "undefined") delete val[k];
                else val[k] = v;
            }
        }
        return reviver.call(holder, key, val);
    }({
        "": result
    }, "") : result;
};

},{}],"kHsFJ":[function(require,module,exports) {
"use strict";
var escapable = /[\\"\x00-\x1f\x7f-\x9f\u00ad\u0600-\u0604\u070f\u17b4\u17b5\u200c-\u200f\u2028-\u202f\u2060-\u206f\ufeff\ufff0-\uffff]/g;
var gap;
var indent;
var meta = {
    "\b": "\\b",
    "	": "\\t",
    "\n": "\\n",
    "\f": "\\f",
    "\r": "\\r",
    '"': '\\"',
    "\\": "\\\\"
};
var rep;
function quote(string) {
    // If the string contains no control characters, no quote characters, and no
    // backslash characters, then we can safely slap some quotes around it.
    // Otherwise we must also replace the offending characters with safe escape sequences.
    escapable.lastIndex = 0;
    return escapable.test(string) ? '"' + string.replace(escapable, function(a) {
        var c = meta[a];
        return typeof c === "string" ? c : "\\u" + ("0000" + a.charCodeAt(0).toString(16)).slice(-4);
    }) + '"' : '"' + string + '"';
}
function str(key, holder) {
    // Produce a string from holder[key].
    var i; // The loop counter.
    var k; // The member key.
    var v; // The member value.
    var length;
    var mind = gap;
    var partial;
    var value = holder[key];
    // If the value has a toJSON method, call it to obtain a replacement value.
    if (value && typeof value === "object" && typeof value.toJSON === "function") value = value.toJSON(key);
    // If we were called with a replacer function, then call the replacer to obtain a replacement value.
    if (typeof rep === "function") value = rep.call(holder, key, value);
    // What happens next depends on the value's type.
    switch(typeof value){
        case "string":
            return quote(value);
        case "number":
            // JSON numbers must be finite. Encode non-finite numbers as null.
            return isFinite(value) ? String(value) : "null";
        case "boolean":
        case "null":
            // If the value is a boolean or null, convert it to a string. Note:
            // typeof null does not produce 'null'. The case is included here in
            // the remote chance that this gets fixed someday.
            return String(value);
        case "object":
            if (!value) return "null";
            gap += indent;
            partial = [];
            // Array.isArray
            if (Object.prototype.toString.apply(value) === "[object Array]") {
                length = value.length;
                for(i = 0; i < length; i += 1)partial[i] = str(i, value) || "null";
                // Join all of the elements together, separated with commas, and wrap them in brackets.
                v = partial.length === 0 ? "[]" : gap ? "[\n" + gap + partial.join(",\n" + gap) + "\n" + mind + "]" : "[" + partial.join(",") + "]";
                gap = mind;
                return v;
            }
            // If the replacer is an array, use it to select the members to be stringified.
            if (rep && typeof rep === "object") {
                length = rep.length;
                for(i = 0; i < length; i += 1){
                    k = rep[i];
                    if (typeof k === "string") {
                        v = str(k, value);
                        if (v) partial.push(quote(k) + (gap ? ": " : ":") + v);
                    }
                }
            } else {
                // Otherwise, iterate through all of the keys in the object.
                for(k in value)if (Object.prototype.hasOwnProperty.call(value, k)) {
                    v = str(k, value);
                    if (v) partial.push(quote(k) + (gap ? ": " : ":") + v);
                }
            }
            // Join all of the member texts together, separated with commas, and wrap them in braces.
            v = partial.length === 0 ? "{}" : gap ? "{\n" + gap + partial.join(",\n" + gap) + "\n" + mind + "}" : "{" + partial.join(",") + "}";
            gap = mind;
            return v;
        default:
    }
}
module.exports = function(value, replacer, space) {
    var i;
    gap = "";
    indent = "";
    // If the space parameter is a number, make an indent string containing that many spaces.
    if (typeof space === "number") for(i = 0; i < space; i += 1)indent += " ";
    else if (typeof space === "string") // If the space parameter is a string, it will be used as the indent string.
    indent = space;
    // If there is a replacer, it must be a function or an array. Otherwise, throw an error.
    rep = replacer;
    if (replacer && typeof replacer !== "function" && (typeof replacer !== "object" || typeof replacer.length !== "number")) throw new Error("JSON.stringify");
    // Make a fake root object containing our value under the key of ''.
    // Return the result of stringifying the value.
    return str("", {
        "": value
    });
};

},{}],"i0Ehs":[function(require,module,exports) {
const getRandomId = require("d8f15869bfeb4226");
const extend = require("7bf88ab46e8ad67e");
module.exports = createPayload;
function createPayload(data) {
    return extend({
        // defaults
        id: getRandomId(),
        jsonrpc: "2.0",
        params: []
    }, data);
}

},{"d8f15869bfeb4226":"cE7js","7bf88ab46e8ad67e":"7rqcZ"}],"cE7js":[function(require,module,exports) {
module.exports = createRandomId;
function createRandomId() {
    // random id
    return Math.floor(Number.MAX_SAFE_INTEGER * Math.random());
}

},{}],"lNrGT":[function(require,module,exports) {
const ProviderSubprovider = require("60f7ff2aa00b12a4");
const createBlockCacheMiddleware = require("3cf4e9fae61e2965");
class BlockCacheSubprovider extends ProviderSubprovider {
    constructor(opts){
        super(({ blockTracker })=>createBlockCacheMiddleware(Object.assign({
                blockTracker
            }, opts)));
    }
}
module.exports = BlockCacheSubprovider;

},{"60f7ff2aa00b12a4":"6YH9w","3cf4e9fae61e2965":"8TtI7"}],"6YH9w":[function(require,module,exports) {
const Subprovider = require("744ce53766632c43");
// wraps a json-rpc-engine middleware in a subprovider interface
class JsonRpcEngineMiddlewareSubprovider extends Subprovider {
    // take a constructorFn to call once we have a reference to the engine
    constructor(constructorFn){
        super();
        if (!constructorFn) throw new Error("JsonRpcEngineMiddlewareSubprovider - no constructorFn specified");
        this._constructorFn = constructorFn;
    }
    // this is called once the subprovider has been added to the provider engine
    setEngine(engine) {
        if (this.middleware) throw new Error("JsonRpcEngineMiddlewareSubprovider - subprovider added to engine twice");
        const blockTracker = engine._blockTracker;
        const middleware = this._constructorFn({
            engine,
            provider: engine,
            blockTracker
        });
        if (!middleware) throw new Error("JsonRpcEngineMiddlewareSubprovider - _constructorFn did not return middleware");
        if (typeof middleware !== "function") throw new Error("JsonRpcEngineMiddlewareSubprovider - specified middleware is not a function");
        this.middleware = middleware;
    }
    handleRequest(req, provEngNext, provEngEnd) {
        const res = {
            id: req.id
        };
        this.middleware(req, res, middlewareNext, middlewareEnd);
        function middlewareNext(handler) {
            provEngNext((err, result, cb)=>{
                // update response object with result or error
                if (err) {
                    delete res.result;
                    res.error = {
                        message: err.message || err
                    };
                } else res.result = result;
                // call middleware's next handler (even if error)
                if (handler) handler(cb);
                else cb();
            });
        }
        function middlewareEnd(err) {
            if (err) return provEngEnd(err);
            provEngEnd(null, res.result);
        }
    }
}
module.exports = JsonRpcEngineMiddlewareSubprovider;

},{"744ce53766632c43":"4Q1cC"}],"4Q1cC":[function(require,module,exports) {
const createPayload = require("df55c6146254b5de");
module.exports = SubProvider;
// this is the base class for a subprovider -- mostly helpers
function SubProvider() {}
SubProvider.prototype.setEngine = function(engine) {
    const self = this;
    if (self.engine) return;
    self.engine = engine;
    engine.on("block", function(block) {
        self.currentBlock = block;
    });
    engine.on("start", function() {
        self.start();
    });
    engine.on("stop", function() {
        self.stop();
    });
};
SubProvider.prototype.handleRequest = function(payload, next, end) {
    throw new Error("Subproviders should override `handleRequest`.");
};
SubProvider.prototype.emitPayload = function(payload, cb) {
    const self = this;
    self.engine.sendAsync(createPayload(payload), cb);
};
// dummies for overriding
SubProvider.prototype.stop = function() {};
SubProvider.prototype.start = function() {};

},{"df55c6146254b5de":"i0Ehs"}],"8TtI7":[function(require,module,exports) {
const cacheUtils = require("5cb4e62e757539e7");
const createAsyncMiddleware = require("2b8547ec1bbf55a3");
// `<nil>` comes from https://github.com/ethereum/go-ethereum/issues/16925
const emptyValues = [
    undefined,
    null,
    "<nil>"
];
module.exports = createBlockCacheMiddleware;
function createBlockCacheMiddleware(opts = {}) {
    // validate options
    const { blockTracker } = opts;
    if (!blockTracker) throw new Error("createBlockCacheMiddleware - No BlockTracker specified");
    // create caching strategies
    const blockCache = new BlockCacheStrategy();
    const strategies = {
        perma: blockCache,
        block: blockCache,
        fork: blockCache
    };
    return createAsyncMiddleware(async (req, res, next)=>{
        // allow cach to be skipped if so specified
        if (req.skipCache) return next();
        // check type and matching strategy
        const type = cacheUtils.cacheTypeForPayload(req);
        const strategy = strategies[type];
        // If there's no strategy in place, pass it down the chain.
        if (!strategy) return next();
        // If the strategy can't cache this request, ignore it.
        if (!strategy.canCacheRequest(req)) return next();
        // get block reference (number or keyword)
        let blockTag = cacheUtils.blockTagForPayload(req);
        if (!blockTag) blockTag = "latest";
        // get exact block number
        let requestedBlockNumber;
        if (blockTag === "earliest") // this just exists for symmetry with "latest"
        requestedBlockNumber = "0x00";
        else if (blockTag === "latest") {
            // fetch latest block number
            const latestBlockNumber = await blockTracker.getLatestBlock();
            // clear all cache before latest block
            blockCache.clearBefore(latestBlockNumber);
            requestedBlockNumber = latestBlockNumber;
        } else // We have a hex number
        requestedBlockNumber = blockTag;
        // end on a hit, continue on a miss
        const cacheResult = await strategy.get(req, requestedBlockNumber);
        if (cacheResult === undefined) {
            // cache miss
            // wait for other middleware to handle request
            await next();
            // add result to cache
            await strategy.set(req, requestedBlockNumber, res.result);
        } else // fill in result from cache
        res.result = cacheResult;
    });
}
//
// Cache Strategies
//
class BlockCacheStrategy {
    constructor(){
        this.cache = {};
    }
    getBlockCacheForPayload(payload, blockNumberHex) {
        const blockNumber = Number.parseInt(blockNumberHex, 16);
        let blockCache = this.cache[blockNumber];
        // create new cache if necesary
        if (!blockCache) {
            const newCache = {};
            this.cache[blockNumber] = newCache;
            blockCache = newCache;
        }
        return blockCache;
    }
    async get(payload, requestedBlockNumber) {
        // lookup block cache
        const blockCache = this.getBlockCacheForPayload(payload, requestedBlockNumber);
        if (!blockCache) return;
        // lookup payload in block cache
        const identifier = cacheUtils.cacheIdentifierForPayload(payload, true);
        const cached = blockCache[identifier];
        // may be undefined
        return cached;
    }
    async set(payload, requestedBlockNumber, result) {
        // check if we can cached this result
        const canCache = this.canCacheResult(payload, result);
        if (!canCache) return;
        // set the value in the cache
        const blockCache = this.getBlockCacheForPayload(payload, requestedBlockNumber);
        const identifier = cacheUtils.cacheIdentifierForPayload(payload, true);
        blockCache[identifier] = result;
    }
    canCacheRequest(payload) {
        // check request method
        if (!cacheUtils.canCache(payload)) return false;
        // check blockTag
        const blockTag = cacheUtils.blockTagForPayload(payload);
        if (blockTag === "pending") return false;
        // can be cached
        return true;
    }
    canCacheResult(payload, result) {
        // never cache empty values (e.g. undefined)
        if (emptyValues.includes(result)) return;
        // check if transactions have block reference before caching
        if ([
            "eth_getTransactionByHash",
            "eth_getTransactionReceipt"
        ].includes(payload.method)) {
            if (!result || !result.blockHash || result.blockHash === "0x0000000000000000000000000000000000000000000000000000000000000000") return false;
        }
        // otherwise true
        return true;
    }
    // removes all block caches with block number lower than `oldBlockHex`
    clearBefore(oldBlockHex) {
        const self = this;
        const oldBlockNumber = Number.parseInt(oldBlockHex, 16);
        // clear old caches
        Object.keys(self.cache).map(Number).filter((num)=>num < oldBlockNumber).forEach((num)=>delete self.cache[num]);
    }
}

},{"5cb4e62e757539e7":"7y0wF","2b8547ec1bbf55a3":"lrxgd"}],"7y0wF":[function(require,module,exports) {
const stringify = require("e5850ebee44df584");
module.exports = {
    cacheIdentifierForPayload: cacheIdentifierForPayload,
    canCache: canCache,
    blockTagForPayload: blockTagForPayload,
    paramsWithoutBlockTag: paramsWithoutBlockTag,
    blockTagParamIndex: blockTagParamIndex,
    cacheTypeForPayload: cacheTypeForPayload
};
function cacheIdentifierForPayload(payload, skipBlockRef) {
    const simpleParams = skipBlockRef ? paramsWithoutBlockTag(payload) : payload.params;
    if (canCache(payload)) return payload.method + ":" + stringify(simpleParams);
    else return null;
}
function canCache(payload) {
    return cacheTypeForPayload(payload) !== "never";
}
function blockTagForPayload(payload) {
    let index = blockTagParamIndex(payload);
    // Block tag param not passed.
    if (index >= payload.params.length) return null;
    return payload.params[index];
}
function paramsWithoutBlockTag(payload) {
    const index = blockTagParamIndex(payload);
    // Block tag param not passed.
    if (index >= payload.params.length) return payload.params;
    // eth_getBlockByNumber has the block tag first, then the optional includeTx? param
    if (payload.method === "eth_getBlockByNumber") return payload.params.slice(1);
    return payload.params.slice(0, index);
}
function blockTagParamIndex(payload) {
    switch(payload.method){
        // blockTag is at index 2
        case "eth_getStorageAt":
            return 2;
        // blockTag is at index 1
        case "eth_getBalance":
        case "eth_getCode":
        case "eth_getTransactionCount":
        case "eth_call":
            return 1;
        // blockTag is at index 0
        case "eth_getBlockByNumber":
            return 0;
        // there is no blockTag
        default:
            return undefined;
    }
}
function cacheTypeForPayload(payload) {
    switch(payload.method){
        // cache permanently
        case "web3_clientVersion":
        case "web3_sha3":
        case "eth_protocolVersion":
        case "eth_getBlockTransactionCountByHash":
        case "eth_getUncleCountByBlockHash":
        case "eth_getCode":
        case "eth_getBlockByHash":
        case "eth_getTransactionByHash":
        case "eth_getTransactionByBlockHashAndIndex":
        case "eth_getTransactionReceipt":
        case "eth_getUncleByBlockHashAndIndex":
        case "eth_getCompilers":
        case "eth_compileLLL":
        case "eth_compileSolidity":
        case "eth_compileSerpent":
        case "shh_version":
        case "test_permaCache":
            return "perma";
        // cache until fork
        case "eth_getBlockByNumber":
        case "eth_getBlockTransactionCountByNumber":
        case "eth_getUncleCountByBlockNumber":
        case "eth_getTransactionByBlockNumberAndIndex":
        case "eth_getUncleByBlockNumberAndIndex":
        case "test_forkCache":
            return "fork";
        // cache for block
        case "eth_gasPrice":
        case "eth_blockNumber":
        case "eth_getBalance":
        case "eth_getStorageAt":
        case "eth_getTransactionCount":
        case "eth_call":
        case "eth_estimateGas":
        case "eth_getFilterLogs":
        case "eth_getLogs":
        case "test_blockCache":
            return "block";
        // never cache
        case "net_version":
        case "net_peerCount":
        case "net_listening":
        case "eth_syncing":
        case "eth_sign":
        case "eth_coinbase":
        case "eth_mining":
        case "eth_hashrate":
        case "eth_accounts":
        case "eth_sendTransaction":
        case "eth_sendRawTransaction":
        case "eth_newFilter":
        case "eth_newBlockFilter":
        case "eth_newPendingTransactionFilter":
        case "eth_uninstallFilter":
        case "eth_getFilterChanges":
        case "eth_getWork":
        case "eth_submitWork":
        case "eth_submitHashrate":
        case "db_putString":
        case "db_getString":
        case "db_putHex":
        case "db_getHex":
        case "shh_post":
        case "shh_newIdentity":
        case "shh_hasIdentity":
        case "shh_newGroup":
        case "shh_addToGroup":
        case "shh_newFilter":
        case "shh_uninstallFilter":
        case "shh_getFilterChanges":
        case "shh_getMessages":
        case "test_neverCache":
            return "never";
    }
}

},{"e5850ebee44df584":"j4ohj"}],"lrxgd":[function(require,module,exports) {
/**
 * JsonRpcEngine only accepts callback-based middleware directly.
 * createAsyncMiddleware exists to enable consumers to pass in async middleware
 * functions.
 *
 * Async middleware have no "end" function. Instead, they "end" if they return
 * without calling "next". Rather than passing in explicit return handlers,
 * async middleware can simply await "next", and perform operations on the
 * response object when execution resumes.
 *
 * To accomplish this, createAsyncMiddleware passes the async middleware a
 * wrapped "next" function. That function calls the internal JsonRpcEngine
 * "next" function with a return handler that resolves a promise when called.
 *
 * The return handler will always be called. Its resolution of the promise
 * enables the control flow described above.
 */ module.exports = function createAsyncMiddleware(asyncMiddleware) {
    return (req, res, next, end)=>{
        // nextPromise is the key to the implementation
        // it is resolved by the return handler passed to the
        // "next" function
        let resolveNextPromise;
        const nextPromise = new Promise((resolve)=>{
            resolveNextPromise = resolve;
        });
        let returnHandlerCallback, nextWasCalled;
        const asyncNext = async ()=>{
            nextWasCalled = true;
            next((callback)=>{
                returnHandlerCallback = callback;
                resolveNextPromise();
            });
            await nextPromise;
        };
        asyncMiddleware(req, res, asyncNext).then(async ()=>{
            if (nextWasCalled) {
                await nextPromise // we must wait until the return handler is called
                ;
                returnHandlerCallback(null);
            } else end(null);
        }).catch((error)=>{
            if (returnHandlerCallback) returnHandlerCallback(error);
            else end(error);
        });
    };
};

},{}],"5JTn0":[function(require,module,exports) {
const inherits = require("a25da6828c903696").inherits;
const Subprovider = require("64a325826edd9366");
module.exports = FixtureProvider;
inherits(FixtureProvider, Subprovider);
function FixtureProvider(staticResponses) {
    const self = this;
    staticResponses = staticResponses || {};
    self.staticResponses = staticResponses;
}
FixtureProvider.prototype.handleRequest = function(payload, next, end) {
    const self = this;
    var staticResponse = self.staticResponses[payload.method];
    // async function
    if ("function" === typeof staticResponse) staticResponse(payload, next, end);
    else if (staticResponse !== undefined) // return result asynchronously
    setTimeout(()=>end(null, staticResponse));
    else next();
};

},{"a25da6828c903696":"jInrX","64a325826edd9366":"4Q1cC"}],"aYYa1":[function(require,module,exports) {
const ProviderSubprovider = require("5f3ba5db21836ea7");
const createFilterMiddleware = require("8f3c2fce8c5bd5a1");
class SubscriptionsSubprovider extends ProviderSubprovider {
    constructor(){
        super(({ blockTracker, provider, engine })=>{
            return createFilterMiddleware({
                blockTracker,
                provider
            });
        });
    }
}
module.exports = SubscriptionsSubprovider;

},{"5f3ba5db21836ea7":"6YH9w","8f3c2fce8c5bd5a1":"am7WO"}],"am7WO":[function(require,module,exports) {
const Mutex = require("db616d5ae9a4626e").Mutex;
const { createAsyncMiddleware } = require("bb5b2127c543072b");
const createJsonRpcMiddleware = require("f37a57e20cb8ec87");
const LogFilter = require("fe6474435fcf555f");
const BlockFilter = require("c32702d3cb710bb2");
const TxFilter = require("26031e1e64c7c946");
const { intToHex, hexToInt } = require("90d19337fdfe398");
module.exports = createEthFilterMiddleware;
function createEthFilterMiddleware({ blockTracker, provider }) {
    // create filter collection
    let filterIndex = 0;
    let filters = {};
    // create update mutex
    const mutex = new Mutex();
    const waitForFree = mutexMiddlewareWrapper({
        mutex
    });
    const middleware = createJsonRpcMiddleware({
        // install filters
        eth_newFilter: waitForFree(toFilterCreationMiddleware(newLogFilter)),
        eth_newBlockFilter: waitForFree(toFilterCreationMiddleware(newBlockFilter)),
        eth_newPendingTransactionFilter: waitForFree(toFilterCreationMiddleware(newPendingTransactionFilter)),
        // uninstall filters
        eth_uninstallFilter: waitForFree(toAsyncRpcMiddleware(uninstallFilterHandler)),
        // checking filter changes
        eth_getFilterChanges: waitForFree(toAsyncRpcMiddleware(getFilterChanges)),
        eth_getFilterLogs: waitForFree(toAsyncRpcMiddleware(getFilterLogs))
    });
    // setup filter updating and destroy handler
    const filterUpdater = async ({ oldBlock, newBlock })=>{
        if (filters.length === 0) return;
        // lock update reads
        const releaseLock = await mutex.acquire();
        try {
            // process all filters in parallel
            await Promise.all(objValues(filters).map(async (filter)=>{
                try {
                    await filter.update({
                        oldBlock,
                        newBlock
                    });
                } catch (err) {
                    // handle each error individually so filter update errors don't affect other filters
                    console.error(err);
                }
            }));
        } catch (err) {
            // log error so we don't skip the releaseLock
            console.error(err);
        }
        // unlock update reads
        releaseLock();
    };
    // expose filter methods directly
    middleware.newLogFilter = newLogFilter;
    middleware.newBlockFilter = newBlockFilter;
    middleware.newPendingTransactionFilter = newPendingTransactionFilter;
    middleware.uninstallFilter = uninstallFilterHandler;
    middleware.getFilterChanges = getFilterChanges;
    middleware.getFilterLogs = getFilterLogs;
    // expose destroy method for cleanup
    middleware.destroy = ()=>{
        uninstallAllFilters();
    };
    return middleware;
    //
    // new filters
    //
    async function newLogFilter(params) {
        const filter = new LogFilter({
            provider,
            params
        });
        const filterIndex = await installFilter(filter);
        return filter;
    }
    async function newBlockFilter() {
        const filter = new BlockFilter({
            provider
        });
        const filterIndex = await installFilter(filter);
        return filter;
    }
    async function newPendingTransactionFilter() {
        const filter = new TxFilter({
            provider
        });
        const filterIndex = await installFilter(filter);
        return filter;
    }
    //
    // get filter changes
    //
    async function getFilterChanges(filterIndexHex) {
        const filterIndex = hexToInt(filterIndexHex);
        const filter = filters[filterIndex];
        if (!filter) throw new Error(`No filter for index "${filterIndex}"`);
        const results1 = filter.getChangesAndClear();
        return results1;
    }
    async function getFilterLogs(filterIndexHex) {
        const filterIndex = hexToInt(filterIndexHex);
        const filter = filters[filterIndex];
        if (!filter) throw new Error(`No filter for index "${filterIndex}"`);
        // only return results for log filters
        if (filter.type === "log") results = filter.getAllResults();
        else results = [];
        return results;
    }
    //
    // remove filters
    //
    async function uninstallFilterHandler(filterIndexHex) {
        // check filter exists
        const filterIndex = hexToInt(filterIndexHex);
        const filter = filters[filterIndex];
        const result = Boolean(filter);
        // uninstall filter
        if (result) await uninstallFilter(filterIndex);
        return result;
    }
    //
    // utils
    //
    async function installFilter(filter) {
        const prevFilterCount = objValues(filters).length;
        // install filter
        const currentBlock = await blockTracker.getLatestBlock();
        await filter.initialize({
            currentBlock
        });
        filterIndex++;
        filters[filterIndex] = filter;
        filter.id = filterIndex;
        filter.idHex = intToHex(filterIndex);
        // update block tracker subs
        const newFilterCount = objValues(filters).length;
        updateBlockTrackerSubs({
            prevFilterCount,
            newFilterCount
        });
        return filterIndex;
    }
    async function uninstallFilter(filterIndex) {
        const prevFilterCount = objValues(filters).length;
        delete filters[filterIndex];
        // update block tracker subs
        const newFilterCount = objValues(filters).length;
        updateBlockTrackerSubs({
            prevFilterCount,
            newFilterCount
        });
    }
    async function uninstallAllFilters() {
        const prevFilterCount = objValues(filters).length;
        filters = {};
        // update block tracker subs
        updateBlockTrackerSubs({
            prevFilterCount,
            newFilterCount: 0
        });
    }
    function updateBlockTrackerSubs({ prevFilterCount, newFilterCount }) {
        // subscribe
        if (prevFilterCount === 0 && newFilterCount > 0) {
            blockTracker.on("sync", filterUpdater);
            return;
        }
        // unsubscribe
        if (prevFilterCount > 0 && newFilterCount === 0) {
            blockTracker.removeListener("sync", filterUpdater);
            return;
        }
    }
}
// helper for turning filter constructors into rpc middleware
function toFilterCreationMiddleware(createFilterFn) {
    return toAsyncRpcMiddleware(async (...args)=>{
        const filter = await createFilterFn(...args);
        const result = intToHex(filter.id);
        return result;
    });
}
// helper for pulling out req.params and setting res.result
function toAsyncRpcMiddleware(asyncFn) {
    return createAsyncMiddleware(async (req, res)=>{
        const result = await asyncFn.apply(null, req.params);
        res.result = result;
    });
}
function mutexMiddlewareWrapper({ mutex }) {
    return (middleware)=>{
        return async (req, res, next, end)=>{
            // wait for mutex available
            // we can release immediately because
            // we just need to make sure updates aren't active
            const releaseLock = await mutex.acquire();
            releaseLock();
            middleware(req, res, next, end);
        };
    };
}
function objValues(obj, fn) {
    const values = [];
    for(let key in obj)values.push(obj[key]);
    return values;
}

},{"db616d5ae9a4626e":"aSkno","bb5b2127c543072b":"8DCJu","f37a57e20cb8ec87":"aQIcb","fe6474435fcf555f":"lFlf4","c32702d3cb710bb2":"eyUAx","26031e1e64c7c946":"e6IBC","90d19337fdfe398":"iZD0U"}],"aSkno":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Mutex", ()=>(0, _mutexDefault.default));
parcelHelpers.export(exports, "Semaphore", ()=>(0, _semaphoreDefault.default));
parcelHelpers.export(exports, "withTimeout", ()=>(0, _withTimeout.withTimeout));
var _mutex = require("./Mutex");
var _mutexDefault = parcelHelpers.interopDefault(_mutex);
var _semaphore = require("./Semaphore");
var _semaphoreDefault = parcelHelpers.interopDefault(_semaphore);
var _withTimeout = require("./withTimeout");

},{"./Mutex":"ijUsm","./Semaphore":"7x7Wy","./withTimeout":"2A0mx","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"ijUsm":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _tslib = require("tslib");
var _semaphore = require("./Semaphore");
var _semaphoreDefault = parcelHelpers.interopDefault(_semaphore);
var Mutex = /** @class */ function() {
    function Mutex() {
        this._semaphore = new (0, _semaphoreDefault.default)(1);
    }
    Mutex.prototype.acquire = function() {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var _a, releaser;
            return (0, _tslib.__generator)(this, function(_b) {
                switch(_b.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this._semaphore.acquire()
                        ];
                    case 1:
                        _a = _b.sent(), releaser = _a[1];
                        return [
                            2 /*return*/ ,
                            releaser
                        ];
                }
            });
        });
    };
    Mutex.prototype.runExclusive = function(callback) {
        return this._semaphore.runExclusive(function() {
            return callback();
        });
    };
    Mutex.prototype.isLocked = function() {
        return this._semaphore.isLocked();
    };
    Mutex.prototype.release = function() {
        this._semaphore.release();
    };
    return Mutex;
}();
exports.default = Mutex;

},{"tslib":"gBS4y","./Semaphore":"7x7Wy","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7x7Wy":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _tslib = require("tslib");
var Semaphore = /** @class */ function() {
    function Semaphore(_maxConcurrency) {
        this._maxConcurrency = _maxConcurrency;
        this._queue = [];
        if (_maxConcurrency <= 0) throw new Error("semaphore must be initialized to a positive value");
        this._value = _maxConcurrency;
    }
    Semaphore.prototype.acquire = function() {
        var _this = this;
        var locked = this.isLocked();
        var ticket = new Promise(function(r) {
            return _this._queue.push(r);
        });
        if (!locked) this._dispatch();
        return ticket;
    };
    Semaphore.prototype.runExclusive = function(callback) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var _a, value, release;
            return (0, _tslib.__generator)(this, function(_b) {
                switch(_b.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.acquire()
                        ];
                    case 1:
                        _a = _b.sent(), value = _a[0], release = _a[1];
                        _b.label = 2;
                    case 2:
                        _b.trys.push([
                            2,
                            ,
                            4,
                            5
                        ]);
                        return [
                            4 /*yield*/ ,
                            callback(value)
                        ];
                    case 3:
                        return [
                            2 /*return*/ ,
                            _b.sent()
                        ];
                    case 4:
                        release();
                        return [
                            7 /*endfinally*/ 
                        ];
                    case 5:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    Semaphore.prototype.isLocked = function() {
        return this._value <= 0;
    };
    Semaphore.prototype.release = function() {
        if (this._maxConcurrency > 1) throw new Error("this method is unavailabel on semaphores with concurrency > 1; use the scoped release returned by acquire instead");
        if (this._currentReleaser) {
            var releaser = this._currentReleaser;
            this._currentReleaser = undefined;
            releaser();
        }
    };
    Semaphore.prototype._dispatch = function() {
        var _this = this;
        var nextConsumer = this._queue.shift();
        if (!nextConsumer) return;
        var released = false;
        this._currentReleaser = function() {
            if (released) return;
            released = true;
            _this._value++;
            _this._dispatch();
        };
        nextConsumer([
            this._value--,
            this._currentReleaser
        ]);
    };
    return Semaphore;
}();
exports.default = Semaphore;

},{"tslib":"gBS4y","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2A0mx":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
parcelHelpers.export(exports, "withTimeout", ()=>withTimeout);
var _tslib = require("tslib");
function withTimeout(sync, timeout, timeoutError) {
    var _this = this;
    if (timeoutError === void 0) timeoutError = new Error("timeout");
    return {
        acquire: function() {
            return new Promise(function(resolve, reject) {
                return (0, _tslib.__awaiter)(_this, void 0, void 0, function() {
                    var isTimeout, ticket, release;
                    return (0, _tslib.__generator)(this, function(_a) {
                        switch(_a.label){
                            case 0:
                                isTimeout = false;
                                setTimeout(function() {
                                    isTimeout = true;
                                    reject(timeoutError);
                                }, timeout);
                                return [
                                    4 /*yield*/ ,
                                    sync.acquire()
                                ];
                            case 1:
                                ticket = _a.sent();
                                if (isTimeout) {
                                    release = Array.isArray(ticket) ? ticket[1] : ticket;
                                    release();
                                } else resolve(ticket);
                                return [
                                    2 /*return*/ 
                                ];
                        }
                    });
                });
            });
        },
        runExclusive: function(callback) {
            return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
                var release, ticket;
                return (0, _tslib.__generator)(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            release = function() {
                                return undefined;
                            };
                            _a.label = 1;
                        case 1:
                            _a.trys.push([
                                1,
                                ,
                                7,
                                8
                            ]);
                            return [
                                4 /*yield*/ ,
                                this.acquire()
                            ];
                        case 2:
                            ticket = _a.sent();
                            if (!Array.isArray(ticket)) return [
                                3 /*break*/ ,
                                4
                            ];
                            release = ticket[1];
                            return [
                                4 /*yield*/ ,
                                callback(ticket[0])
                            ];
                        case 3:
                            return [
                                2 /*return*/ ,
                                _a.sent()
                            ];
                        case 4:
                            release = ticket;
                            return [
                                4 /*yield*/ ,
                                callback()
                            ];
                        case 5:
                            return [
                                2 /*return*/ ,
                                _a.sent()
                            ];
                        case 6:
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case 7:
                            release();
                            return [
                                7 /*endfinally*/ 
                            ];
                        case 8:
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        },
        release: function() {
            sync.release();
        },
        isLocked: function() {
            return sync.isLocked();
        }
    };
}

},{"tslib":"gBS4y","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8DCJu":[function(require,module,exports) {
"use strict";
var __createBinding = this && this.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, {
        enumerable: true,
        get: function() {
            return m[k];
        }
    });
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var __exportStar = this && this.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) __createBinding(exports1, m, p);
};
Object.defineProperty(exports, "__esModule", {
    value: true
});
__exportStar(require("18149ee0ae316f6b"), exports);
__exportStar(require("fe1a6a9bd5243426"), exports);
__exportStar(require("5b80faebe0b579b9"), exports);
__exportStar(require("7ab782bf9e31db2b"), exports);
__exportStar(require("b23f9566c2fb69c2"), exports);
__exportStar(require("6b9f4e8e0ab755fa"), exports);

},{"18149ee0ae316f6b":"jjzrU","fe1a6a9bd5243426":"eaTns","5b80faebe0b579b9":"6yECg","7ab782bf9e31db2b":"eKSFu","b23f9566c2fb69c2":"gNWEe","6b9f4e8e0ab755fa":"iUrxp"}],"jjzrU":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.createIdRemapMiddleware = void 0;
const getUniqueId_1 = require("686cf2bc17ca41b");
function createIdRemapMiddleware() {
    return (req, res, next, _end)=>{
        const originalId = req.id;
        const newId = getUniqueId_1.getUniqueId();
        req.id = newId;
        res.id = newId;
        next((done)=>{
            req.id = originalId;
            res.id = originalId;
            done();
        });
    };
}
exports.createIdRemapMiddleware = createIdRemapMiddleware;

},{"686cf2bc17ca41b":"eKSFu"}],"eKSFu":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getUniqueId = void 0;
// uint32 (two's complement) max
// more conservative than Number.MAX_SAFE_INTEGER
const MAX = 4294967295;
let idCounter = Math.floor(Math.random() * MAX);
function getUniqueId() {
    idCounter = (idCounter + 1) % MAX;
    return idCounter;
}
exports.getUniqueId = getUniqueId;

},{}],"eaTns":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.createAsyncMiddleware = void 0;
/**
 * JsonRpcEngine only accepts callback-based middleware directly.
 * createAsyncMiddleware exists to enable consumers to pass in async middleware
 * functions.
 *
 * Async middleware have no "end" function. Instead, they "end" if they return
 * without calling "next". Rather than passing in explicit return handlers,
 * async middleware can simply await "next", and perform operations on the
 * response object when execution resumes.
 *
 * To accomplish this, createAsyncMiddleware passes the async middleware a
 * wrapped "next" function. That function calls the internal JsonRpcEngine
 * "next" function with a return handler that resolves a promise when called.
 *
 * The return handler will always be called. Its resolution of the promise
 * enables the control flow described above.
 */ function createAsyncMiddleware(asyncMiddleware) {
    return async (req, res, next, end)=>{
        // nextPromise is the key to the implementation
        // it is resolved by the return handler passed to the
        // "next" function
        let resolveNextPromise;
        const nextPromise = new Promise((resolve)=>{
            resolveNextPromise = resolve;
        });
        let returnHandlerCallback = null;
        let nextWasCalled = false;
        // This will be called by the consumer's async middleware.
        const asyncNext = async ()=>{
            nextWasCalled = true;
            // We pass a return handler to next(). When it is called by the engine,
            // the consumer's async middleware will resume executing.
            // eslint-disable-next-line node/callback-return
            next((runReturnHandlersCallback)=>{
                // This callback comes from JsonRpcEngine._runReturnHandlers
                returnHandlerCallback = runReturnHandlersCallback;
                resolveNextPromise();
            });
            await nextPromise;
        };
        try {
            await asyncMiddleware(req, res, asyncNext);
            if (nextWasCalled) {
                await nextPromise; // we must wait until the return handler is called
                returnHandlerCallback(null);
            } else end(null);
        } catch (error) {
            if (returnHandlerCallback) returnHandlerCallback(error);
            else end(error);
        }
    };
}
exports.createAsyncMiddleware = createAsyncMiddleware;

},{}],"6yECg":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.createScaffoldMiddleware = void 0;
function createScaffoldMiddleware(handlers) {
    return (req, res, next, end)=>{
        const handler = handlers[req.method];
        // if no handler, return
        if (handler === undefined) return next();
        // if handler is fn, call as middleware
        if (typeof handler === "function") return handler(req, res, next, end);
        // if handler is some other value, use as result
        res.result = handler;
        return end();
    };
}
exports.createScaffoldMiddleware = createScaffoldMiddleware;

},{}],"gNWEe":[function(require,module,exports) {
"use strict";
var __importDefault = this && this.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.JsonRpcEngine = void 0;
const safe_event_emitter_1 = __importDefault(require("9bf6a357a52e0af4"));
const eth_rpc_errors_1 = require("64305a0a39d22d79");
/**
 * A JSON-RPC request and response processor.
 * Give it a stack of middleware, pass it requests, and get back responses.
 */ class JsonRpcEngine extends safe_event_emitter_1.default {
    constructor(){
        super();
        this._middleware = [];
    }
    /**
     * Add a middleware function to the engine's middleware stack.
     *
     * @param middleware - The middleware function to add.
     */ push(middleware) {
        this._middleware.push(middleware);
    }
    handle(req, cb) {
        if (cb && typeof cb !== "function") throw new Error('"callback" must be a function if provided.');
        if (Array.isArray(req)) {
            if (cb) return this._handleBatch(req, cb);
            return this._handleBatch(req);
        }
        if (cb) return this._handle(req, cb);
        return this._promiseHandle(req);
    }
    /**
     * Returns this engine as a middleware function that can be pushed to other
     * engines.
     *
     * @returns This engine as a middleware function.
     */ asMiddleware() {
        return async (req, res, next, end)=>{
            try {
                const [middlewareError, isComplete, returnHandlers] = await JsonRpcEngine._runAllMiddleware(req, res, this._middleware);
                if (isComplete) {
                    await JsonRpcEngine._runReturnHandlers(returnHandlers);
                    return end(middlewareError);
                }
                return next(async (handlerCallback)=>{
                    try {
                        await JsonRpcEngine._runReturnHandlers(returnHandlers);
                    } catch (error) {
                        return handlerCallback(error);
                    }
                    return handlerCallback();
                });
            } catch (error) {
                return end(error);
            }
        };
    }
    async _handleBatch(reqs, cb) {
        // The order here is important
        try {
            // 2. Wait for all requests to finish, or throw on some kind of fatal
            // error
            const responses = await Promise.all(// 1. Begin executing each request in the order received
            reqs.map(this._promiseHandle.bind(this)));
            // 3. Return batch response
            if (cb) return cb(null, responses);
            return responses;
        } catch (error) {
            if (cb) return cb(error);
            throw error;
        }
    }
    /**
     * A promise-wrapped _handle.
     */ _promiseHandle(req) {
        return new Promise((resolve)=>{
            this._handle(req, (_err, res)=>{
                // There will always be a response, and it will always have any error
                // that is caught and propagated.
                resolve(res);
            });
        });
    }
    /**
     * Ensures that the request object is valid, processes it, and passes any
     * error and the response object to the given callback.
     *
     * Does not reject.
     */ async _handle(callerReq, cb) {
        if (!callerReq || Array.isArray(callerReq) || typeof callerReq !== "object") {
            const error = new eth_rpc_errors_1.EthereumRpcError(eth_rpc_errors_1.errorCodes.rpc.invalidRequest, `Requests must be plain objects. Received: ${typeof callerReq}`, {
                request: callerReq
            });
            return cb(error, {
                id: undefined,
                jsonrpc: "2.0",
                error
            });
        }
        if (typeof callerReq.method !== "string") {
            const error = new eth_rpc_errors_1.EthereumRpcError(eth_rpc_errors_1.errorCodes.rpc.invalidRequest, `Must specify a string method. Received: ${typeof callerReq.method}`, {
                request: callerReq
            });
            return cb(error, {
                id: callerReq.id,
                jsonrpc: "2.0",
                error
            });
        }
        const req = Object.assign({}, callerReq);
        const res = {
            id: req.id,
            jsonrpc: req.jsonrpc
        };
        let error = null;
        try {
            await this._processRequest(req, res);
        } catch (_error) {
            // A request handler error, a re-thrown middleware error, or something
            // unexpected.
            error = _error;
        }
        if (error) {
            // Ensure no result is present on an errored response
            delete res.result;
            if (!res.error) res.error = eth_rpc_errors_1.serializeError(error);
        }
        return cb(error, res);
    }
    /**
     * For the given request and response, runs all middleware and their return
     * handlers, if any, and ensures that internal request processing semantics
     * are satisfied.
     */ async _processRequest(req, res) {
        const [error, isComplete, returnHandlers] = await JsonRpcEngine._runAllMiddleware(req, res, this._middleware);
        // Throw if "end" was not called, or if the response has neither a result
        // nor an error.
        JsonRpcEngine._checkForCompletion(req, res, isComplete);
        // The return handlers should run even if an error was encountered during
        // middleware processing.
        await JsonRpcEngine._runReturnHandlers(returnHandlers);
        // Now we re-throw the middleware processing error, if any, to catch it
        // further up the call chain.
        if (error) throw error;
    }
    /**
     * Serially executes the given stack of middleware.
     *
     * @returns An array of any error encountered during middleware execution,
     * a boolean indicating whether the request was completed, and an array of
     * middleware-defined return handlers.
     */ static async _runAllMiddleware(req, res, middlewareStack) {
        const returnHandlers = [];
        let error = null;
        let isComplete = false;
        // Go down stack of middleware, call and collect optional returnHandlers
        for (const middleware of middlewareStack){
            [error, isComplete] = await JsonRpcEngine._runMiddleware(req, res, middleware, returnHandlers);
            if (isComplete) break;
        }
        return [
            error,
            isComplete,
            returnHandlers.reverse()
        ];
    }
    /**
     * Runs an individual middleware.
     *
     * @returns An array of any error encountered during middleware exection,
     * and a boolean indicating whether the request should end.
     */ static _runMiddleware(req, res, middleware, returnHandlers) {
        return new Promise((resolve)=>{
            const end = (err)=>{
                const error = err || res.error;
                if (error) res.error = eth_rpc_errors_1.serializeError(error);
                // True indicates that the request should end
                resolve([
                    error,
                    true
                ]);
            };
            const next = (returnHandler)=>{
                if (res.error) end(res.error);
                else {
                    if (returnHandler) {
                        if (typeof returnHandler !== "function") end(new eth_rpc_errors_1.EthereumRpcError(eth_rpc_errors_1.errorCodes.rpc.internal, `JsonRpcEngine: "next" return handlers must be functions. ` + `Received "${typeof returnHandler}" for request:\n${jsonify(req)}`, {
                            request: req
                        }));
                        returnHandlers.push(returnHandler);
                    }
                    // False indicates that the request should not end
                    resolve([
                        null,
                        false
                    ]);
                }
            };
            try {
                middleware(req, res, next, end);
            } catch (error) {
                end(error);
            }
        });
    }
    /**
     * Serially executes array of return handlers. The request and response are
     * assumed to be in their scope.
     */ static async _runReturnHandlers(handlers) {
        for (const handler of handlers)await new Promise((resolve, reject)=>{
            handler((err)=>err ? reject(err) : resolve());
        });
    }
    /**
     * Throws an error if the response has neither a result nor an error, or if
     * the "isComplete" flag is falsy.
     */ static _checkForCompletion(req, res, isComplete) {
        if (!("result" in res) && !("error" in res)) throw new eth_rpc_errors_1.EthereumRpcError(eth_rpc_errors_1.errorCodes.rpc.internal, `JsonRpcEngine: Response has no error or result for request:\n${jsonify(req)}`, {
            request: req
        });
        if (!isComplete) throw new eth_rpc_errors_1.EthereumRpcError(eth_rpc_errors_1.errorCodes.rpc.internal, `JsonRpcEngine: Nothing ended request:\n${jsonify(req)}`, {
            request: req
        });
    }
}
exports.JsonRpcEngine = JsonRpcEngine;
function jsonify(request) {
    return JSON.stringify(request, null, 2);
}

},{"9bf6a357a52e0af4":"9zLtp","64305a0a39d22d79":"9cATh"}],"9zLtp":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
const events_1 = require("4ab50ccb1b820575");
function safeApply(handler, context, args) {
    try {
        Reflect.apply(handler, context, args);
    } catch (err) {
        // Throw error after timeout so as not to interrupt the stack
        setTimeout(()=>{
            throw err;
        });
    }
}
function arrayClone(arr) {
    const n = arr.length;
    const copy = new Array(n);
    for(let i = 0; i < n; i += 1)copy[i] = arr[i];
    return copy;
}
class SafeEventEmitter extends events_1.EventEmitter {
    emit(type, ...args) {
        let doError = type === "error";
        const events = this._events;
        if (events !== undefined) doError = doError && events.error === undefined;
        else if (!doError) return false;
        // If there is no 'error' event listener then throw.
        if (doError) {
            let er;
            if (args.length > 0) [er] = args;
            if (er instanceof Error) // Note: The comments on the `throw` lines are intentional, they show
            // up in Node's output if this results in an unhandled exception.
            throw er; // Unhandled 'error' event
            // At least give some kind of context to the user
            const err = new Error(`Unhandled error.${er ? ` (${er.message})` : ""}`);
            err.context = er;
            throw err; // Unhandled 'error' event
        }
        const handler = events[type];
        if (handler === undefined) return false;
        if (typeof handler === "function") safeApply(handler, this, args);
        else {
            const len = handler.length;
            const listeners = arrayClone(handler);
            for(let i = 0; i < len; i += 1)safeApply(listeners[i], this, args);
        }
        return true;
    }
}
exports.default = SafeEventEmitter;

},{"4ab50ccb1b820575":"fqTtD"}],"9cATh":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getMessageFromCode = exports.serializeError = exports.EthereumProviderError = exports.EthereumRpcError = exports.ethErrors = exports.errorCodes = void 0;
const classes_1 = require("1ad0e636b7d1d0a8");
Object.defineProperty(exports, "EthereumRpcError", {
    enumerable: true,
    get: function() {
        return classes_1.EthereumRpcError;
    }
});
Object.defineProperty(exports, "EthereumProviderError", {
    enumerable: true,
    get: function() {
        return classes_1.EthereumProviderError;
    }
});
const utils_1 = require("eee94fc09e823891");
Object.defineProperty(exports, "serializeError", {
    enumerable: true,
    get: function() {
        return utils_1.serializeError;
    }
});
Object.defineProperty(exports, "getMessageFromCode", {
    enumerable: true,
    get: function() {
        return utils_1.getMessageFromCode;
    }
});
const errors_1 = require("54a9cdce47bf8314");
Object.defineProperty(exports, "ethErrors", {
    enumerable: true,
    get: function() {
        return errors_1.ethErrors;
    }
});
const error_constants_1 = require("f60f0b5326f8da6e");
Object.defineProperty(exports, "errorCodes", {
    enumerable: true,
    get: function() {
        return error_constants_1.errorCodes;
    }
});

},{"1ad0e636b7d1d0a8":"ilozG","eee94fc09e823891":"3C7hA","54a9cdce47bf8314":"2lsKZ","f60f0b5326f8da6e":"f2fCJ"}],"ilozG":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.EthereumProviderError = exports.EthereumRpcError = void 0;
const fast_safe_stringify_1 = require("775495418d3880ed");
/**
 * Error subclass implementing JSON RPC 2.0 errors and Ethereum RPC errors
 * per EIP-1474.
 * Permits any integer error code.
 */ class EthereumRpcError extends Error {
    constructor(code, message, data){
        if (!Number.isInteger(code)) throw new Error('"code" must be an integer.');
        if (!message || typeof message !== "string") throw new Error('"message" must be a nonempty string.');
        super(message);
        this.code = code;
        if (data !== undefined) this.data = data;
    }
    /**
     * Returns a plain object with all public class properties.
     */ serialize() {
        const serialized = {
            code: this.code,
            message: this.message
        };
        if (this.data !== undefined) serialized.data = this.data;
        if (this.stack) serialized.stack = this.stack;
        return serialized;
    }
    /**
     * Return a string representation of the serialized error, omitting
     * any circular references.
     */ toString() {
        return fast_safe_stringify_1.default(this.serialize(), stringifyReplacer, 2);
    }
}
exports.EthereumRpcError = EthereumRpcError;
/**
 * Error subclass implementing Ethereum Provider errors per EIP-1193.
 * Permits integer error codes in the [ 1000 <= 4999 ] range.
 */ class EthereumProviderError extends EthereumRpcError {
    /**
     * Create an Ethereum Provider JSON-RPC error.
     * `code` must be an integer in the 1000 <= 4999 range.
     */ constructor(code, message, data){
        if (!isValidEthProviderCode(code)) throw new Error('"code" must be an integer such that: 1000 <= code <= 4999');
        super(code, message, data);
    }
}
exports.EthereumProviderError = EthereumProviderError;
// Internal
function isValidEthProviderCode(code) {
    return Number.isInteger(code) && code >= 1000 && code <= 4999;
}
function stringifyReplacer(_, value) {
    if (value === "[Circular]") return undefined;
    return value;
}

},{"775495418d3880ed":"ugAim"}],"ugAim":[function(require,module,exports) {
module.exports = stringify;
stringify.default = stringify;
stringify.stable = deterministicStringify;
stringify.stableStringify = deterministicStringify;
var LIMIT_REPLACE_NODE = "[...]";
var CIRCULAR_REPLACE_NODE = "[Circular]";
var arr = [];
var replacerStack = [];
function defaultOptions() {
    return {
        depthLimit: Number.MAX_SAFE_INTEGER,
        edgesLimit: Number.MAX_SAFE_INTEGER
    };
}
// Regular stringify
function stringify(obj, replacer, spacer, options) {
    if (typeof options === "undefined") options = defaultOptions();
    decirc(obj, "", 0, [], undefined, 0, options);
    var res;
    try {
        if (replacerStack.length === 0) res = JSON.stringify(obj, replacer, spacer);
        else res = JSON.stringify(obj, replaceGetterValues(replacer), spacer);
    } catch (_) {
        return JSON.stringify("[unable to serialize, circular reference is too complex to analyze]");
    } finally{
        while(arr.length !== 0){
            var part = arr.pop();
            if (part.length === 4) Object.defineProperty(part[0], part[1], part[3]);
            else part[0][part[1]] = part[2];
        }
    }
    return res;
}
function setReplace(replace, val, k, parent) {
    var propertyDescriptor = Object.getOwnPropertyDescriptor(parent, k);
    if (propertyDescriptor.get !== undefined) {
        if (propertyDescriptor.configurable) {
            Object.defineProperty(parent, k, {
                value: replace
            });
            arr.push([
                parent,
                k,
                val,
                propertyDescriptor
            ]);
        } else replacerStack.push([
            val,
            k,
            replace
        ]);
    } else {
        parent[k] = replace;
        arr.push([
            parent,
            k,
            val
        ]);
    }
}
function decirc(val, k, edgeIndex, stack, parent, depth, options) {
    depth += 1;
    var i;
    if (typeof val === "object" && val !== null) {
        for(i = 0; i < stack.length; i++)if (stack[i] === val) {
            setReplace(CIRCULAR_REPLACE_NODE, val, k, parent);
            return;
        }
        if (typeof options.depthLimit !== "undefined" && depth > options.depthLimit) {
            setReplace(LIMIT_REPLACE_NODE, val, k, parent);
            return;
        }
        if (typeof options.edgesLimit !== "undefined" && edgeIndex + 1 > options.edgesLimit) {
            setReplace(LIMIT_REPLACE_NODE, val, k, parent);
            return;
        }
        stack.push(val);
        // Optimize for Arrays. Big arrays could kill the performance otherwise!
        if (Array.isArray(val)) for(i = 0; i < val.length; i++)decirc(val[i], i, i, stack, val, depth, options);
        else {
            var keys = Object.keys(val);
            for(i = 0; i < keys.length; i++){
                var key = keys[i];
                decirc(val[key], key, i, stack, val, depth, options);
            }
        }
        stack.pop();
    }
}
// Stable-stringify
function compareFunction(a, b) {
    if (a < b) return -1;
    if (a > b) return 1;
    return 0;
}
function deterministicStringify(obj, replacer, spacer, options) {
    if (typeof options === "undefined") options = defaultOptions();
    var tmp = deterministicDecirc(obj, "", 0, [], undefined, 0, options) || obj;
    var res;
    try {
        if (replacerStack.length === 0) res = JSON.stringify(tmp, replacer, spacer);
        else res = JSON.stringify(tmp, replaceGetterValues(replacer), spacer);
    } catch (_) {
        return JSON.stringify("[unable to serialize, circular reference is too complex to analyze]");
    } finally{
        // Ensure that we restore the object as it was.
        while(arr.length !== 0){
            var part = arr.pop();
            if (part.length === 4) Object.defineProperty(part[0], part[1], part[3]);
            else part[0][part[1]] = part[2];
        }
    }
    return res;
}
function deterministicDecirc(val, k, edgeIndex, stack, parent, depth, options) {
    depth += 1;
    var i;
    if (typeof val === "object" && val !== null) {
        for(i = 0; i < stack.length; i++)if (stack[i] === val) {
            setReplace(CIRCULAR_REPLACE_NODE, val, k, parent);
            return;
        }
        try {
            if (typeof val.toJSON === "function") return;
        } catch (_) {
            return;
        }
        if (typeof options.depthLimit !== "undefined" && depth > options.depthLimit) {
            setReplace(LIMIT_REPLACE_NODE, val, k, parent);
            return;
        }
        if (typeof options.edgesLimit !== "undefined" && edgeIndex + 1 > options.edgesLimit) {
            setReplace(LIMIT_REPLACE_NODE, val, k, parent);
            return;
        }
        stack.push(val);
        // Optimize for Arrays. Big arrays could kill the performance otherwise!
        if (Array.isArray(val)) for(i = 0; i < val.length; i++)deterministicDecirc(val[i], i, i, stack, val, depth, options);
        else {
            // Create a temporary object in the required way
            var tmp = {};
            var keys = Object.keys(val).sort(compareFunction);
            for(i = 0; i < keys.length; i++){
                var key = keys[i];
                deterministicDecirc(val[key], key, i, stack, val, depth, options);
                tmp[key] = val[key];
            }
            if (typeof parent !== "undefined") {
                arr.push([
                    parent,
                    k,
                    val
                ]);
                parent[k] = tmp;
            } else return tmp;
        }
        stack.pop();
    }
}
// wraps replacer function to handle values we couldn't replace
// and mark them as replaced value
function replaceGetterValues(replacer) {
    replacer = typeof replacer !== "undefined" ? replacer : function(k, v) {
        return v;
    };
    return function(key, val) {
        if (replacerStack.length > 0) for(var i = 0; i < replacerStack.length; i++){
            var part = replacerStack[i];
            if (part[1] === key && part[0] === val) {
                val = part[2];
                replacerStack.splice(i, 1);
                break;
            }
        }
        return replacer.call(this, key, val);
    };
}

},{}],"3C7hA":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.serializeError = exports.isValidCode = exports.getMessageFromCode = exports.JSON_RPC_SERVER_ERROR_MESSAGE = void 0;
const error_constants_1 = require("d18a50beb2c7155a");
const classes_1 = require("fe1d095b2bcb27a6");
const FALLBACK_ERROR_CODE = error_constants_1.errorCodes.rpc.internal;
const FALLBACK_MESSAGE = "Unspecified error message. This is a bug, please report it.";
const FALLBACK_ERROR = {
    code: FALLBACK_ERROR_CODE,
    message: getMessageFromCode(FALLBACK_ERROR_CODE)
};
exports.JSON_RPC_SERVER_ERROR_MESSAGE = "Unspecified server error.";
/**
 * Gets the message for a given code, or a fallback message if the code has
 * no corresponding message.
 */ function getMessageFromCode(code, fallbackMessage = FALLBACK_MESSAGE) {
    if (Number.isInteger(code)) {
        const codeString = code.toString();
        if (hasKey(error_constants_1.errorValues, codeString)) return error_constants_1.errorValues[codeString].message;
        if (isJsonRpcServerError(code)) return exports.JSON_RPC_SERVER_ERROR_MESSAGE;
    }
    return fallbackMessage;
}
exports.getMessageFromCode = getMessageFromCode;
/**
 * Returns whether the given code is valid.
 * A code is only valid if it has a message.
 */ function isValidCode(code) {
    if (!Number.isInteger(code)) return false;
    const codeString = code.toString();
    if (error_constants_1.errorValues[codeString]) return true;
    if (isJsonRpcServerError(code)) return true;
    return false;
}
exports.isValidCode = isValidCode;
/**
 * Serializes the given error to an Ethereum JSON RPC-compatible error object.
 * Merely copies the given error's values if it is already compatible.
 * If the given error is not fully compatible, it will be preserved on the
 * returned object's data.originalError property.
 */ function serializeError(error, { fallbackError = FALLBACK_ERROR, shouldIncludeStack = false } = {}) {
    var _a, _b;
    if (!fallbackError || !Number.isInteger(fallbackError.code) || typeof fallbackError.message !== "string") throw new Error("Must provide fallback error with integer number code and string message.");
    if (error instanceof classes_1.EthereumRpcError) return error.serialize();
    const serialized = {};
    if (error && typeof error === "object" && !Array.isArray(error) && hasKey(error, "code") && isValidCode(error.code)) {
        const _error = error;
        serialized.code = _error.code;
        if (_error.message && typeof _error.message === "string") {
            serialized.message = _error.message;
            if (hasKey(_error, "data")) serialized.data = _error.data;
        } else {
            serialized.message = getMessageFromCode(serialized.code);
            serialized.data = {
                originalError: assignOriginalError(error)
            };
        }
    } else {
        serialized.code = fallbackError.code;
        const message = (_a = error) === null || _a === void 0 ? void 0 : _a.message;
        serialized.message = message && typeof message === "string" ? message : fallbackError.message;
        serialized.data = {
            originalError: assignOriginalError(error)
        };
    }
    const stack = (_b = error) === null || _b === void 0 ? void 0 : _b.stack;
    if (shouldIncludeStack && error && stack && typeof stack === "string") serialized.stack = stack;
    return serialized;
}
exports.serializeError = serializeError;
// Internal
function isJsonRpcServerError(code) {
    return code >= -32099 && code <= -32000;
}
function assignOriginalError(error) {
    if (error && typeof error === "object" && !Array.isArray(error)) return Object.assign({}, error);
    return error;
}
function hasKey(obj, key) {
    return Object.prototype.hasOwnProperty.call(obj, key);
}

},{"d18a50beb2c7155a":"f2fCJ","fe1d095b2bcb27a6":"ilozG"}],"f2fCJ":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.errorValues = exports.errorCodes = void 0;
exports.errorCodes = {
    rpc: {
        invalidInput: -32000,
        resourceNotFound: -32001,
        resourceUnavailable: -32002,
        transactionRejected: -32003,
        methodNotSupported: -32004,
        limitExceeded: -32005,
        parse: -32700,
        invalidRequest: -32600,
        methodNotFound: -32601,
        invalidParams: -32602,
        internal: -32603
    },
    provider: {
        userRejectedRequest: 4001,
        unauthorized: 4100,
        unsupportedMethod: 4200,
        disconnected: 4900,
        chainDisconnected: 4901
    }
};
exports.errorValues = {
    "-32700": {
        standard: "JSON RPC 2.0",
        message: "Invalid JSON was received by the server. An error occurred on the server while parsing the JSON text."
    },
    "-32600": {
        standard: "JSON RPC 2.0",
        message: "The JSON sent is not a valid Request object."
    },
    "-32601": {
        standard: "JSON RPC 2.0",
        message: "The method does not exist / is not available."
    },
    "-32602": {
        standard: "JSON RPC 2.0",
        message: "Invalid method parameter(s)."
    },
    "-32603": {
        standard: "JSON RPC 2.0",
        message: "Internal JSON-RPC error."
    },
    "-32000": {
        standard: "EIP-1474",
        message: "Invalid input."
    },
    "-32001": {
        standard: "EIP-1474",
        message: "Resource not found."
    },
    "-32002": {
        standard: "EIP-1474",
        message: "Resource unavailable."
    },
    "-32003": {
        standard: "EIP-1474",
        message: "Transaction rejected."
    },
    "-32004": {
        standard: "EIP-1474",
        message: "Method not supported."
    },
    "-32005": {
        standard: "EIP-1474",
        message: "Request limit exceeded."
    },
    "4001": {
        standard: "EIP-1193",
        message: "User rejected the request."
    },
    "4100": {
        standard: "EIP-1193",
        message: "The requested account and/or method has not been authorized by the user."
    },
    "4200": {
        standard: "EIP-1193",
        message: "The requested method is not supported by this Ethereum provider."
    },
    "4900": {
        standard: "EIP-1193",
        message: "The provider is disconnected from all chains."
    },
    "4901": {
        standard: "EIP-1193",
        message: "The provider is disconnected from the specified chain."
    }
};

},{}],"2lsKZ":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ethErrors = void 0;
const classes_1 = require("3d57a743a4c7dc08");
const utils_1 = require("3869a0e2ab8b003");
const error_constants_1 = require("ee76af047c940b96");
exports.ethErrors = {
    rpc: {
        /**
         * Get a JSON RPC 2.0 Parse (-32700) error.
         */ parse: (arg)=>getEthJsonRpcError(error_constants_1.errorCodes.rpc.parse, arg),
        /**
         * Get a JSON RPC 2.0 Invalid Request (-32600) error.
         */ invalidRequest: (arg)=>getEthJsonRpcError(error_constants_1.errorCodes.rpc.invalidRequest, arg),
        /**
         * Get a JSON RPC 2.0 Invalid Params (-32602) error.
         */ invalidParams: (arg)=>getEthJsonRpcError(error_constants_1.errorCodes.rpc.invalidParams, arg),
        /**
         * Get a JSON RPC 2.0 Method Not Found (-32601) error.
         */ methodNotFound: (arg)=>getEthJsonRpcError(error_constants_1.errorCodes.rpc.methodNotFound, arg),
        /**
         * Get a JSON RPC 2.0 Internal (-32603) error.
         */ internal: (arg)=>getEthJsonRpcError(error_constants_1.errorCodes.rpc.internal, arg),
        /**
         * Get a JSON RPC 2.0 Server error.
         * Permits integer error codes in the [ -32099 <= -32005 ] range.
         * Codes -32000 through -32004 are reserved by EIP-1474.
         */ server: (opts)=>{
            if (!opts || typeof opts !== "object" || Array.isArray(opts)) throw new Error("Ethereum RPC Server errors must provide single object argument.");
            const { code } = opts;
            if (!Number.isInteger(code) || code > -32005 || code < -32099) throw new Error('"code" must be an integer such that: -32099 <= code <= -32005');
            return getEthJsonRpcError(code, opts);
        },
        /**
         * Get an Ethereum JSON RPC Invalid Input (-32000) error.
         */ invalidInput: (arg)=>getEthJsonRpcError(error_constants_1.errorCodes.rpc.invalidInput, arg),
        /**
         * Get an Ethereum JSON RPC Resource Not Found (-32001) error.
         */ resourceNotFound: (arg)=>getEthJsonRpcError(error_constants_1.errorCodes.rpc.resourceNotFound, arg),
        /**
         * Get an Ethereum JSON RPC Resource Unavailable (-32002) error.
         */ resourceUnavailable: (arg)=>getEthJsonRpcError(error_constants_1.errorCodes.rpc.resourceUnavailable, arg),
        /**
         * Get an Ethereum JSON RPC Transaction Rejected (-32003) error.
         */ transactionRejected: (arg)=>getEthJsonRpcError(error_constants_1.errorCodes.rpc.transactionRejected, arg),
        /**
         * Get an Ethereum JSON RPC Method Not Supported (-32004) error.
         */ methodNotSupported: (arg)=>getEthJsonRpcError(error_constants_1.errorCodes.rpc.methodNotSupported, arg),
        /**
         * Get an Ethereum JSON RPC Limit Exceeded (-32005) error.
         */ limitExceeded: (arg)=>getEthJsonRpcError(error_constants_1.errorCodes.rpc.limitExceeded, arg)
    },
    provider: {
        /**
         * Get an Ethereum Provider User Rejected Request (4001) error.
         */ userRejectedRequest: (arg)=>{
            return getEthProviderError(error_constants_1.errorCodes.provider.userRejectedRequest, arg);
        },
        /**
         * Get an Ethereum Provider Unauthorized (4100) error.
         */ unauthorized: (arg)=>{
            return getEthProviderError(error_constants_1.errorCodes.provider.unauthorized, arg);
        },
        /**
         * Get an Ethereum Provider Unsupported Method (4200) error.
         */ unsupportedMethod: (arg)=>{
            return getEthProviderError(error_constants_1.errorCodes.provider.unsupportedMethod, arg);
        },
        /**
         * Get an Ethereum Provider Not Connected (4900) error.
         */ disconnected: (arg)=>{
            return getEthProviderError(error_constants_1.errorCodes.provider.disconnected, arg);
        },
        /**
         * Get an Ethereum Provider Chain Not Connected (4901) error.
         */ chainDisconnected: (arg)=>{
            return getEthProviderError(error_constants_1.errorCodes.provider.chainDisconnected, arg);
        },
        /**
         * Get a custom Ethereum Provider error.
         */ custom: (opts)=>{
            if (!opts || typeof opts !== "object" || Array.isArray(opts)) throw new Error("Ethereum Provider custom errors must provide single object argument.");
            const { code, message, data } = opts;
            if (!message || typeof message !== "string") throw new Error('"message" must be a nonempty string');
            return new classes_1.EthereumProviderError(code, message, data);
        }
    }
};
// Internal
function getEthJsonRpcError(code, arg) {
    const [message, data] = parseOpts(arg);
    return new classes_1.EthereumRpcError(code, message || utils_1.getMessageFromCode(code), data);
}
function getEthProviderError(code, arg) {
    const [message, data] = parseOpts(arg);
    return new classes_1.EthereumProviderError(code, message || utils_1.getMessageFromCode(code), data);
}
function parseOpts(arg) {
    if (arg) {
        if (typeof arg === "string") return [
            arg
        ];
        else if (typeof arg === "object" && !Array.isArray(arg)) {
            const { message, data } = arg;
            if (message && typeof message !== "string") throw new Error("Must specify string message.");
            return [
                message || undefined,
                data
            ];
        }
    }
    return [];
}

},{"3d57a743a4c7dc08":"ilozG","3869a0e2ab8b003":"3C7hA","ee76af047c940b96":"f2fCJ"}],"iUrxp":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.mergeMiddleware = void 0;
const JsonRpcEngine_1 = require("920cc0619a3d5fa3");
function mergeMiddleware(middlewareStack) {
    const engine = new JsonRpcEngine_1.JsonRpcEngine();
    middlewareStack.forEach((middleware)=>engine.push(middleware));
    return engine.asMiddleware();
}
exports.mergeMiddleware = mergeMiddleware;

},{"920cc0619a3d5fa3":"gNWEe"}],"aQIcb":[function(require,module,exports) {
// for backwards compat
module.exports = require("b0623368fcc19370");

},{"b0623368fcc19370":"1FqK1"}],"1FqK1":[function(require,module,exports) {
module.exports = function createScaffoldMiddleware(handlers) {
    return (req, res, next, end)=>{
        const handler = handlers[req.method];
        // if no handler, return
        if (handler === undefined) return next();
        // if handler is fn, call as middleware
        if (typeof handler === "function") return handler(req, res, next, end);
        // if handler is some other value, use as result
        res.result = handler;
        return end();
    };
};

},{}],"lFlf4":[function(require,module,exports) {
const EthQuery = require("fae489022c4dbebf");
const pify = require("dbeb59e8dc7ae960");
const BaseFilterWithHistory = require("375c7456d8831d1a");
const { bnToHex, hexToInt, incrementHexInt, minBlockRef, blockRefIsNumber } = require("c898be362b37f126");
class LogFilter extends BaseFilterWithHistory {
    constructor({ provider, params }){
        super();
        this.type = "log";
        this.ethQuery = new EthQuery(provider);
        this.params = Object.assign({
            fromBlock: "latest",
            toBlock: "latest",
            address: undefined,
            topics: []
        }, params);
        // normalize address parameter
        if (this.params.address) {
            // ensure array
            if (!Array.isArray(this.params.address)) this.params.address = [
                this.params.address
            ];
            // ensure lowercase
            this.params.address = this.params.address.map((address)=>address.toLowerCase());
        }
    }
    async initialize({ currentBlock }) {
        // resolve params.fromBlock
        let fromBlock = this.params.fromBlock;
        if ([
            "latest",
            "pending"
        ].includes(fromBlock)) fromBlock = currentBlock;
        if ("earliest" === fromBlock) fromBlock = "0x0";
        this.params.fromBlock = fromBlock;
        // set toBlock for initial lookup
        const toBlock = minBlockRef(this.params.toBlock, currentBlock);
        const params = Object.assign({}, this.params, {
            toBlock
        });
        // fetch logs and add to results
        const newLogs = await this._fetchLogs(params);
        this.addInitialResults(newLogs);
    }
    async update({ oldBlock, newBlock }) {
        // configure params for this update
        const toBlock = newBlock;
        let fromBlock;
        // oldBlock is empty on first sync
        if (oldBlock) fromBlock = incrementHexInt(oldBlock);
        else fromBlock = newBlock;
        // fetch logs
        const params = Object.assign({}, this.params, {
            fromBlock,
            toBlock
        });
        const newLogs = await this._fetchLogs(params);
        const matchingLogs = newLogs.filter((log)=>this.matchLog(log));
        // add to results
        this.addResults(matchingLogs);
    }
    async _fetchLogs(params) {
        const newLogs = await pify((cb)=>this.ethQuery.getLogs(params, cb))();
        // add to results
        return newLogs;
    }
    matchLog(log) {
        // check if block number in bounds:
        if (hexToInt(this.params.fromBlock) >= hexToInt(log.blockNumber)) return false;
        if (blockRefIsNumber(this.params.toBlock) && hexToInt(this.params.toBlock) <= hexToInt(log.blockNumber)) return false;
        // address is correct:
        const normalizedLogAddress = log.address && log.address.toLowerCase();
        if (this.params.address && normalizedLogAddress && !this.params.address.includes(normalizedLogAddress)) return false;
        // topics match:
        // topics are position-dependant
        // topics can be nested to represent `or` [[a || b], c]
        // topics can be null, representing a wild card for that position
        const topicsMatch = this.params.topics.every((topicPattern, index)=>{
            // pattern is longer than actual topics
            let logTopic = log.topics[index];
            if (!logTopic) return false;
            logTopic = logTopic.toLowerCase();
            // normalize subTopics
            let subtopicsToMatch = Array.isArray(topicPattern) ? topicPattern : [
                topicPattern
            ];
            // check for wild card
            const subtopicsIncludeWildcard = subtopicsToMatch.includes(null);
            if (subtopicsIncludeWildcard) return true;
            subtopicsToMatch = subtopicsToMatch.map((topic)=>topic.toLowerCase());
            // check each possible matching topic
            const topicDoesMatch = subtopicsToMatch.includes(logTopic);
            return topicDoesMatch;
        });
        return topicsMatch;
    }
}
module.exports = LogFilter;

},{"fae489022c4dbebf":"hM2Xv","dbeb59e8dc7ae960":"fnsDR","375c7456d8831d1a":"kUBkF","c898be362b37f126":"iZD0U"}],"fnsDR":[function(require,module,exports) {
"use strict";
const processFn = (fn, options, proxy, unwrapped)=>function(...arguments_) {
        const P = options.promiseModule;
        return new P((resolve, reject)=>{
            if (options.multiArgs) arguments_.push((...result)=>{
                if (options.errorFirst) {
                    if (result[0]) reject(result);
                    else {
                        result.shift();
                        resolve(result);
                    }
                } else resolve(result);
            });
            else if (options.errorFirst) arguments_.push((error, result)=>{
                if (error) reject(error);
                else resolve(result);
            });
            else arguments_.push(resolve);
            const self = this === proxy ? unwrapped : this;
            Reflect.apply(fn, self, arguments_);
        });
    };
const filterCache = new WeakMap();
module.exports = (input, options)=>{
    options = {
        exclude: [
            /.+(?:Sync|Stream)$/
        ],
        errorFirst: true,
        promiseModule: Promise,
        ...options
    };
    const objectType = typeof input;
    if (!(input !== null && (objectType === "object" || objectType === "function"))) throw new TypeError(`Expected \`input\` to be a \`Function\` or \`Object\`, got \`${input === null ? "null" : objectType}\``);
    const filter = (target, key)=>{
        let cached = filterCache.get(target);
        if (!cached) {
            cached = {};
            filterCache.set(target, cached);
        }
        if (key in cached) return cached[key];
        const match = (pattern)=>typeof pattern === "string" || typeof key === "symbol" ? key === pattern : pattern.test(key);
        const desc = Reflect.getOwnPropertyDescriptor(target, key);
        const writableOrConfigurableOwn = desc === undefined || desc.writable || desc.configurable;
        const included = options.include ? options.include.some(match) : !options.exclude.some(match);
        const shouldFilter = included && writableOrConfigurableOwn;
        cached[key] = shouldFilter;
        return shouldFilter;
    };
    const cache = new WeakMap();
    const proxy = new Proxy(input, {
        apply (target, thisArg, args) {
            const cached = cache.get(target);
            if (cached) return Reflect.apply(cached, thisArg, args);
            const pified = options.excludeMain ? target : processFn(target, options, proxy, target);
            cache.set(target, pified);
            return Reflect.apply(pified, thisArg, args);
        },
        get (target, key) {
            const property = target[key];
            // eslint-disable-next-line no-use-extend-native/no-use-extend-native
            if (!filter(target, key) || property === Function.prototype[key]) return property;
            const cached = cache.get(property);
            if (cached) return cached;
            if (typeof property === "function") {
                const pified = processFn(property, options, proxy, target);
                cache.set(property, pified);
                return pified;
            }
            return property;
        }
    });
    return proxy;
};

},{}],"kUBkF":[function(require,module,exports) {
const BaseFilter = require("cb9d89e694206885");
// tracks all results ever recorded
class BaseFilterWithHistory extends BaseFilter {
    constructor(){
        super();
        this.allResults = [];
    }
    async update() {
        throw new Error("BaseFilterWithHistory - no update method specified");
    }
    addResults(newResults) {
        this.allResults = this.allResults.concat(newResults);
        super.addResults(newResults);
    }
    addInitialResults(newResults) {
        this.allResults = this.allResults.concat(newResults);
        super.addInitialResults(newResults);
    }
    getAllResults() {
        return this.allResults;
    }
}
module.exports = BaseFilterWithHistory;

},{"cb9d89e694206885":"2aiOx"}],"2aiOx":[function(require,module,exports) {
const SafeEventEmitter = require("8745a6e81545c1bd").default;
class BaseFilter extends SafeEventEmitter {
    constructor(){
        super();
        this.updates = [];
    }
    async initialize() {}
    async update() {
        throw new Error("BaseFilter - no update method specified");
    }
    addResults(newResults) {
        this.updates = this.updates.concat(newResults);
        newResults.forEach((result)=>this.emit("update", result));
    }
    addInitialResults(newResults) {}
    getChangesAndClear() {
        const updates = this.updates;
        this.updates = [];
        return updates;
    }
}
module.exports = BaseFilter;

},{"8745a6e81545c1bd":"9zLtp"}],"iZD0U":[function(require,module,exports) {
module.exports = {
    minBlockRef,
    maxBlockRef,
    sortBlockRefs,
    bnToHex,
    blockRefIsNumber,
    hexToInt,
    incrementHexInt,
    intToHex,
    unsafeRandomBytes
};
function minBlockRef(...refs) {
    const sortedRefs = sortBlockRefs(refs);
    return sortedRefs[0];
}
function maxBlockRef(...refs) {
    const sortedRefs = sortBlockRefs(refs);
    return sortedRefs[sortedRefs.length - 1];
}
function sortBlockRefs(refs) {
    return refs.sort((refA, refB)=>{
        if (refA === "latest" || refB === "earliest") return 1;
        if (refB === "latest" || refA === "earliest") return -1;
        return hexToInt(refA) - hexToInt(refB);
    });
}
function bnToHex(bn) {
    return "0x" + bn.toString(16);
}
function blockRefIsNumber(blockRef) {
    return blockRef && ![
        "earliest",
        "latest",
        "pending"
    ].includes(blockRef);
}
function hexToInt(hexString) {
    if (hexString === undefined || hexString === null) return hexString;
    return Number.parseInt(hexString, 16);
}
function incrementHexInt(hexString) {
    if (hexString === undefined || hexString === null) return hexString;
    const value = hexToInt(hexString);
    return intToHex(value + 1);
}
function intToHex(int) {
    if (int === undefined || int === null) return int;
    let hexString = int.toString(16);
    const needsLeftPad = hexString.length % 2;
    if (needsLeftPad) hexString = "0" + hexString;
    return "0x" + hexString;
}
function unsafeRandomBytes(byteCount) {
    let result = "0x";
    for(let i = 0; i < byteCount; i++){
        result += unsafeRandomNibble();
        result += unsafeRandomNibble();
    }
    return result;
}
function unsafeRandomNibble() {
    return Math.floor(Math.random() * 16).toString(16);
}

},{}],"eyUAx":[function(require,module,exports) {
const BaseFilter = require("5c955b9246ae45a2");
const getBlocksForRange = require("699535a95cc4b531");
const { incrementHexInt } = require("ab262f98d3f9ef88");
class BlockFilter extends BaseFilter {
    constructor({ provider, params }){
        super();
        this.type = "block";
        this.provider = provider;
    }
    async update({ oldBlock, newBlock }) {
        const toBlock = newBlock;
        const fromBlock = incrementHexInt(oldBlock);
        const blockBodies = await getBlocksForRange({
            provider: this.provider,
            fromBlock,
            toBlock
        });
        const blockHashes = blockBodies.map((block)=>block.hash);
        this.addResults(blockHashes);
    }
}
module.exports = BlockFilter;

},{"5c955b9246ae45a2":"2aiOx","699535a95cc4b531":"8Sk1d","ab262f98d3f9ef88":"iZD0U"}],"8Sk1d":[function(require,module,exports) {
module.exports = getBlocksForRange;
async function getBlocksForRange({ provider, fromBlock, toBlock }) {
    if (!fromBlock) fromBlock = toBlock;
    const fromBlockNumber = hexToInt(fromBlock);
    const toBlockNumber = hexToInt(toBlock);
    const blockCountToQuery = toBlockNumber - fromBlockNumber + 1;
    // load all blocks from old to new (inclusive)
    const missingBlockNumbers = Array(blockCountToQuery).fill().map((_, index)=>fromBlockNumber + index).map(intToHex);
    const blockBodies = await Promise.all(missingBlockNumbers.map((blockNum)=>query(provider, "eth_getBlockByNumber", [
            blockNum,
            false
        ])));
    return blockBodies;
}
function hexToInt(hexString) {
    if (hexString === undefined || hexString === null) return hexString;
    return Number.parseInt(hexString, 16);
}
function incrementHexInt(hexString) {
    if (hexString === undefined || hexString === null) return hexString;
    const value = hexToInt(hexString);
    return intToHex(value + 1);
}
function intToHex(int) {
    if (int === undefined || int === null) return int;
    const hexString = int.toString(16);
    return "0x" + hexString;
}
function query(provider, method, params) {
    return new Promise((resolve, reject)=>{
        provider.sendAsync({
            id: 1,
            jsonrpc: "2.0",
            method,
            params
        }, (err, res)=>{
            if (err) return reject(err);
            resolve(res.result);
        });
    });
}

},{}],"e6IBC":[function(require,module,exports) {
const BaseFilter = require("c13babcb4b1f8c85");
const getBlocksForRange = require("e55577e784a531a9");
const { incrementHexInt } = require("4e3b8b8eccae36f9");
class TxFilter extends BaseFilter {
    constructor({ provider }){
        super();
        this.type = "tx";
        this.provider = provider;
    }
    async update({ oldBlock }) {
        const toBlock = oldBlock;
        const fromBlock = incrementHexInt(oldBlock);
        const blocks = await getBlocksForRange({
            provider: this.provider,
            fromBlock,
            toBlock
        });
        const blockTxHashes = [];
        for (const block of blocks)blockTxHashes.push(...block.transactions);
        // add to results
        this.addResults(blockTxHashes);
    }
}
module.exports = TxFilter;

},{"c13babcb4b1f8c85":"2aiOx","e55577e784a531a9":"8Sk1d","4e3b8b8eccae36f9":"iZD0U"}],"eJsBr":[function(require,module,exports) {
/*
 * Emulate 'eth_accounts' / 'eth_sendTransaction' using 'eth_sendRawTransaction'
 *
 * The two callbacks a user needs to implement are:
 * - getAccounts() -- array of addresses supported
 * - signTransaction(tx) -- sign a raw transaction object
 */ const waterfall = require("ae562c5810984549");
const parallel = require("9728f09272f0bd93");
const inherits = require("5bb58f4f1113ab9f").inherits;
const ethUtil = require("1d9f010ea8b370b3");
const sigUtil = require("5203e671dc3495f3");
const extend = require("3071ecb5c1976065");
const Semaphore = require("ede6cd9409df70f9");
const Subprovider = require("c35e0c01f2af0217");
const estimateGas = require("1ba10fc0f02b8669");
const hexRegex = /^[0-9A-Fa-f]+$/g;
module.exports = HookedWalletSubprovider;
// handles the following RPC methods:
//   eth_coinbase
//   eth_accounts
//   eth_sendTransaction
//   eth_sign
//   eth_signTypedData
//   eth_signTypedData_v3
//   eth_signTypedData_v4
//   personal_sign
//   eth_decryptMessage
//   encryption_public_key
//   personal_ecRecover
//   parity_postTransaction
//   parity_checkRequest
//   parity_defaultAccount
//
// Tx Signature Flow
//
// handleRequest: eth_sendTransaction
//   validateTransaction (basic validity check)
//     validateSender (checks that sender is in accounts)
//   processTransaction (sign tx and submit to network)
//     approveTransaction (UI approval hook)
//     checkApproval
//     finalizeAndSubmitTx (tx signing)
//       nonceLock.take (bottle neck to ensure atomic nonce)
//         fillInTxExtras (set fallback gasPrice, nonce, etc)
//         signTransaction (perform the signature)
//         publishTransaction (publish signed tx to network)
//
inherits(HookedWalletSubprovider, Subprovider);
function HookedWalletSubprovider(opts) {
    const self = this;
    // control flow
    self.nonceLock = Semaphore(1);
    // data lookup
    if (opts.getAccounts) self.getAccounts = opts.getAccounts;
    // high level override
    if (opts.processTransaction) self.processTransaction = opts.processTransaction;
    if (opts.processMessage) self.processMessage = opts.processMessage;
    if (opts.processPersonalMessage) self.processPersonalMessage = opts.processPersonalMessage;
    if (opts.processTypedMessage) self.processTypedMessage = opts.processTypedMessage;
    // approval hooks
    self.approveTransaction = opts.approveTransaction || self.autoApprove;
    self.approveMessage = opts.approveMessage || self.autoApprove;
    self.approvePersonalMessage = opts.approvePersonalMessage || self.autoApprove;
    self.approveDecryptMessage = opts.approveDecryptMessage || self.autoApprove;
    self.approveEncryptionPublicKey = opts.approveEncryptionPublicKey || self.autoApprove;
    self.approveTypedMessage = opts.approveTypedMessage || self.autoApprove;
    // actually perform the signature
    if (opts.signTransaction) self.signTransaction = opts.signTransaction || mustProvideInConstructor("signTransaction");
    if (opts.signMessage) self.signMessage = opts.signMessage || mustProvideInConstructor("signMessage");
    if (opts.signPersonalMessage) self.signPersonalMessage = opts.signPersonalMessage || mustProvideInConstructor("signPersonalMessage");
    if (opts.decryptMessage) self.decryptMessage = opts.decryptMessage || mustProvideInConstructor("decryptMessage");
    if (opts.encryptionPublicKey) self.encryptionPublicKey = opts.encryptionPublicKey || mustProvideInConstructor("encryptionPublicKey");
    if (opts.signTypedMessage) self.signTypedMessage = opts.signTypedMessage || mustProvideInConstructor("signTypedMessage");
    if (opts.recoverPersonalSignature) self.recoverPersonalSignature = opts.recoverPersonalSignature;
    // publish to network
    if (opts.publishTransaction) self.publishTransaction = opts.publishTransaction;
    // gas options
    self.estimateGas = opts.estimateGas || self.estimateGas;
    self.getGasPrice = opts.getGasPrice || self.getGasPrice;
}
HookedWalletSubprovider.prototype.handleRequest = function(payload, next, end) {
    const self = this;
    self._parityRequests = {};
    self._parityRequestCount = 0;
    // switch statement is not block scoped
    // sp we cant repeat var declarations
    let txParams, msgParams, extraParams;
    let message, address;
    switch(payload.method){
        case "eth_coinbase":
            // process normally
            self.getAccounts(function(err, accounts) {
                if (err) return end(err);
                let result = accounts[0] || null;
                end(null, result);
            });
            return;
        case "eth_accounts":
            // process normally
            self.getAccounts(function(err, accounts) {
                if (err) return end(err);
                end(null, accounts);
            });
            return;
        case "eth_sendTransaction":
            txParams = payload.params[0];
            waterfall([
                (cb)=>self.validateTransaction(txParams, cb),
                (cb)=>self.processTransaction(txParams, cb)
            ], end);
            return;
        case "eth_signTransaction":
            txParams = payload.params[0];
            waterfall([
                (cb)=>self.validateTransaction(txParams, cb),
                (cb)=>self.processSignTransaction(txParams, cb)
            ], end);
            return;
        case "eth_sign":
            // process normally
            address = payload.params[0];
            message = payload.params[1];
            // non-standard "extraParams" to be appended to our "msgParams" obj
            // good place for metadata
            extraParams = payload.params[2] || {};
            msgParams = extend(extraParams, {
                from: address,
                data: message
            });
            waterfall([
                (cb)=>self.validateMessage(msgParams, cb),
                (cb)=>self.processMessage(msgParams, cb)
            ], end);
            return;
        case "personal_sign":
            return function() {
                // process normally
                const first = payload.params[0];
                const second = payload.params[1];
                // We initially incorrectly ordered these parameters.
                // To gracefully respect users who adopted this API early,
                // we are currently gracefully recovering from the wrong param order
                // when it is clearly identifiable.
                //
                // That means when the first param is definitely an address,
                // and the second param is definitely not, but is hex.
                if (resemblesData(second) && resemblesAddress(first)) {
                    let warning = `The eth_personalSign method requires params ordered `;
                    warning += `[message, address]. This was previously handled incorrectly, `;
                    warning += `and has been corrected automatically. `;
                    warning += `Please switch this param order for smooth behavior in the future.`;
                    console.warn(warning);
                    address = payload.params[0];
                    message = payload.params[1];
                } else {
                    message = payload.params[0];
                    address = payload.params[1];
                }
                // non-standard "extraParams" to be appended to our "msgParams" obj
                // good place for metadata
                extraParams = payload.params[2] || {};
                msgParams = extend(extraParams, {
                    from: address,
                    data: message
                });
                waterfall([
                    (cb)=>self.validatePersonalMessage(msgParams, cb),
                    (cb)=>self.processPersonalMessage(msgParams, cb)
                ], end);
            }();
        case "eth_decryptMessage":
            return function() {
                // process normally
                const first = payload.params[0];
                const second = payload.params[1];
                // We initially incorrectly ordered these parameters.
                // To gracefully respect users who adopted this API early,
                // we are currently gracefully recovering from the wrong param order
                // when it is clearly identifiable.
                //
                // That means when the first param is definitely an address,
                // and the second param is definitely not, but is hex.
                if (resemblesData(second) && resemblesAddress(first)) {
                    let warning = `The eth_decryptMessage method requires params ordered `;
                    warning += `[message, address]. This was previously handled incorrectly, `;
                    warning += `and has been corrected automatically. `;
                    warning += `Please switch this param order for smooth behavior in the future.`;
                    console.warn(warning);
                    address = payload.params[0];
                    message = payload.params[1];
                } else {
                    message = payload.params[0];
                    address = payload.params[1];
                }
                // non-standard "extraParams" to be appended to our "msgParams" obj
                // good place for metadata
                extraParams = payload.params[2] || {};
                msgParams = extend(extraParams, {
                    from: address,
                    data: message
                });
                waterfall([
                    (cb)=>self.validateDecryptMessage(msgParams, cb),
                    (cb)=>self.processDecryptMessage(msgParams, cb)
                ], end);
            }();
        case "encryption_public_key":
            return function() {
                const address = payload.params[0];
                waterfall([
                    (cb)=>self.validateEncryptionPublicKey(address, cb),
                    (cb)=>self.processEncryptionPublicKey(address, cb)
                ], end);
            }();
        case "personal_ecRecover":
            return function() {
                message = payload.params[0];
                let signature = payload.params[1];
                // non-standard "extraParams" to be appended to our "msgParams" obj
                // good place for metadata
                extraParams = payload.params[2] || {};
                msgParams = extend(extraParams, {
                    sig: signature,
                    data: message
                });
                self.recoverPersonalSignature(msgParams, end);
            }();
        case "eth_signTypedData":
        case "eth_signTypedData_v3":
        case "eth_signTypedData_v4":
            return function() {
                // process normally
                const first = payload.params[0];
                const second = payload.params[1];
                if (resemblesAddress(first)) {
                    address = first;
                    message = second;
                } else {
                    message = first;
                    address = second;
                }
                extraParams = payload.params[2] || {};
                msgParams = extend(extraParams, {
                    from: address,
                    data: message
                });
                waterfall([
                    (cb)=>self.validateTypedMessage(msgParams, cb),
                    (cb)=>self.processTypedMessage(msgParams, cb)
                ], end);
            }();
        case "parity_postTransaction":
            txParams = payload.params[0];
            self.parityPostTransaction(txParams, end);
            return;
        case "parity_postSign":
            address = payload.params[0];
            message = payload.params[1];
            self.parityPostSign(address, message, end);
            return;
        case "parity_checkRequest":
            return function() {
                const requestId = payload.params[0];
                self.parityCheckRequest(requestId, end);
            }();
        case "parity_defaultAccount":
            self.getAccounts(function(err, accounts) {
                if (err) return end(err);
                const account = accounts[0] || null;
                end(null, account);
            });
            return;
        default:
            next();
            return;
    }
};
//
// data lookup
//
HookedWalletSubprovider.prototype.getAccounts = function(cb) {
    cb(null, []);
};
//
// "process" high level flow
//
HookedWalletSubprovider.prototype.processTransaction = function(txParams, cb) {
    const self = this;
    waterfall([
        (cb)=>self.approveTransaction(txParams, cb),
        (didApprove, cb)=>self.checkApproval("transaction", didApprove, cb),
        (cb)=>self.finalizeAndSubmitTx(txParams, cb)
    ], cb);
};
HookedWalletSubprovider.prototype.processSignTransaction = function(txParams, cb) {
    const self = this;
    waterfall([
        (cb)=>self.approveTransaction(txParams, cb),
        (didApprove, cb)=>self.checkApproval("transaction", didApprove, cb),
        (cb)=>self.finalizeTx(txParams, cb)
    ], cb);
};
HookedWalletSubprovider.prototype.processMessage = function(msgParams, cb) {
    const self = this;
    waterfall([
        (cb)=>self.approveMessage(msgParams, cb),
        (didApprove, cb)=>self.checkApproval("message", didApprove, cb),
        (cb)=>self.signMessage(msgParams, cb)
    ], cb);
};
HookedWalletSubprovider.prototype.processPersonalMessage = function(msgParams, cb) {
    const self = this;
    waterfall([
        (cb)=>self.approvePersonalMessage(msgParams, cb),
        (didApprove, cb)=>self.checkApproval("message", didApprove, cb),
        (cb)=>self.signPersonalMessage(msgParams, cb)
    ], cb);
};
HookedWalletSubprovider.prototype.processDecryptMessage = function(msgParams, cb) {
    const self = this;
    waterfall([
        (cb)=>self.approveDecryptMessage(msgParams, cb),
        (didApprove, cb)=>self.checkApproval("decryptMessage", didApprove, cb),
        (cb)=>self.decryptMessage(msgParams, cb)
    ], cb);
};
HookedWalletSubprovider.prototype.processEncryptionPublicKey = function(msgParams, cb) {
    const self = this;
    waterfall([
        (cb)=>self.approveEncryptionPublicKey(msgParams, cb),
        (didApprove, cb)=>self.checkApproval("encryptionPublicKey", didApprove, cb),
        (cb)=>self.encryptionPublicKey(msgParams, cb)
    ], cb);
};
HookedWalletSubprovider.prototype.processTypedMessage = function(msgParams, cb) {
    const self = this;
    waterfall([
        (cb)=>self.approveTypedMessage(msgParams, cb),
        (didApprove, cb)=>self.checkApproval("message", didApprove, cb),
        (cb)=>self.signTypedMessage(msgParams, cb)
    ], cb);
};
//
// approval
//
HookedWalletSubprovider.prototype.autoApprove = function(txParams, cb) {
    cb(null, true);
};
HookedWalletSubprovider.prototype.checkApproval = function(type, didApprove, cb) {
    cb(didApprove ? null : new Error("User denied " + type + " signature."));
};
//
// parity
//
HookedWalletSubprovider.prototype.parityPostTransaction = function(txParams, cb) {
    const self = this;
    // get next id
    const count = self._parityRequestCount;
    const reqId = `0x${count.toString(16)}`;
    self._parityRequestCount++;
    self.emitPayload({
        method: "eth_sendTransaction",
        params: [
            txParams
        ]
    }, function(error, res) {
        if (error) {
            self._parityRequests[reqId] = {
                error
            };
            return;
        }
        const txHash = res.result;
        self._parityRequests[reqId] = txHash;
    });
    cb(null, reqId);
};
HookedWalletSubprovider.prototype.parityPostSign = function(address, message, cb) {
    const self = this;
    // get next id
    const count = self._parityRequestCount;
    const reqId = `0x${count.toString(16)}`;
    self._parityRequestCount++;
    self.emitPayload({
        method: "eth_sign",
        params: [
            address,
            message
        ]
    }, function(error, res) {
        if (error) {
            self._parityRequests[reqId] = {
                error
            };
            return;
        }
        const result = res.result;
        self._parityRequests[reqId] = result;
    });
    cb(null, reqId);
};
HookedWalletSubprovider.prototype.parityCheckRequest = function(reqId, cb) {
    const self = this;
    const result = self._parityRequests[reqId] || null;
    // tx not handled yet
    if (!result) return cb(null, null);
    // tx was rejected (or other error)
    if (result.error) return cb(result.error);
    // tx sent
    cb(null, result);
};
//
// signature and recovery
//
HookedWalletSubprovider.prototype.recoverPersonalSignature = function(msgParams, cb) {
    let senderHex;
    try {
        senderHex = sigUtil.recoverPersonalSignature(msgParams);
    } catch (err) {
        return cb(err);
    }
    cb(null, senderHex);
};
//
// validation
//
HookedWalletSubprovider.prototype.validateTransaction = function(txParams, cb) {
    const self = this;
    // shortcut: undefined sender is invalid
    if (txParams.from === undefined) return cb(new Error(`Undefined address - from address required to sign transaction.`));
    self.validateSender(txParams.from, function(err, senderIsValid) {
        if (err) return cb(err);
        if (!senderIsValid) return cb(new Error(`Unknown address - unable to sign transaction for this address: "${txParams.from}"`));
        cb();
    });
};
HookedWalletSubprovider.prototype.validateMessage = function(msgParams, cb) {
    const self = this;
    if (msgParams.from === undefined) return cb(new Error(`Undefined address - from address required to sign message.`));
    self.validateSender(msgParams.from, function(err, senderIsValid) {
        if (err) return cb(err);
        if (!senderIsValid) return cb(new Error(`Unknown address - unable to sign message for this address: "${msgParams.from}"`));
        cb();
    });
};
HookedWalletSubprovider.prototype.validatePersonalMessage = function(msgParams, cb) {
    const self = this;
    if (msgParams.from === undefined) return cb(new Error(`Undefined address - from address required to sign personal message.`));
    if (msgParams.data === undefined) return cb(new Error(`Undefined message - message required to sign personal message.`));
    if (!isValidHex(msgParams.data)) return cb(new Error(`HookedWalletSubprovider - validateMessage - message was not encoded as hex.`));
    self.validateSender(msgParams.from, function(err, senderIsValid) {
        if (err) return cb(err);
        if (!senderIsValid) return cb(new Error(`Unknown address - unable to sign message for this address: "${msgParams.from}"`));
        cb();
    });
};
HookedWalletSubprovider.prototype.validateDecryptMessage = function(msgParams, cb) {
    const self = this;
    if (msgParams.from === undefined) return cb(new Error(`Undefined address - from address required to decrypt message.`));
    if (msgParams.data === undefined) return cb(new Error(`Undefined message - message required to decrypt message.`));
    if (!isValidHex(msgParams.data)) return cb(new Error(`HookedWalletSubprovider - validateDecryptMessage - message was not encoded as hex.`));
    self.validateSender(msgParams.from, function(err, senderIsValid) {
        if (err) return cb(err);
        if (!senderIsValid) return cb(new Error(`Unknown address - unable to decrypt message for this address: "${msgParams.from}"`));
        cb();
    });
};
HookedWalletSubprovider.prototype.validateEncryptionPublicKey = function(address, cb) {
    const self = this;
    self.validateSender(address, function(err, senderIsValid) {
        if (err) return cb(err);
        if (!senderIsValid) return cb(new Error(`Unknown address - unable to obtain encryption public key for this address: "${address}"`));
        cb();
    });
};
HookedWalletSubprovider.prototype.validateTypedMessage = function(msgParams, cb) {
    if (msgParams.from === undefined) return cb(new Error(`Undefined address - from address required to sign typed data.`));
    if (msgParams.data === undefined) return cb(new Error(`Undefined data - message required to sign typed data.`));
    this.validateSender(msgParams.from, function(err, senderIsValid) {
        if (err) return cb(err);
        if (!senderIsValid) return cb(new Error(`Unknown address - unable to sign message for this address: "${msgParams.from}"`));
        cb();
    });
};
HookedWalletSubprovider.prototype.validateSender = function(senderAddress, cb) {
    const self = this;
    // shortcut: undefined sender is invalid
    if (!senderAddress) return cb(null, false);
    self.getAccounts(function(err, accounts) {
        if (err) return cb(err);
        const senderIsValid = accounts.map(toLowerCase).indexOf(senderAddress.toLowerCase()) !== -1;
        cb(null, senderIsValid);
    });
};
//
// tx helpers
//
HookedWalletSubprovider.prototype.finalizeAndSubmitTx = function(txParams, cb) {
    const self = this;
    // can only allow one tx to pass through this flow at a time
    // so we can atomically consume a nonce
    self.nonceLock.take(function() {
        waterfall([
            self.fillInTxExtras.bind(self, txParams),
            self.signTransaction.bind(self),
            self.publishTransaction.bind(self)
        ], function(err, txHash) {
            self.nonceLock.leave();
            if (err) return cb(err);
            cb(null, txHash);
        });
    });
};
HookedWalletSubprovider.prototype.finalizeTx = function(txParams, cb) {
    const self = this;
    // can only allow one tx to pass through this flow at a time
    // so we can atomically consume a nonce
    self.nonceLock.take(function() {
        waterfall([
            self.fillInTxExtras.bind(self, txParams),
            self.signTransaction.bind(self)
        ], function(err, signedTx) {
            self.nonceLock.leave();
            if (err) return cb(err);
            cb(null, {
                raw: signedTx,
                tx: txParams
            });
        });
    });
};
HookedWalletSubprovider.prototype.publishTransaction = function(rawTx, cb) {
    const self = this;
    self.emitPayload({
        method: "eth_sendRawTransaction",
        params: [
            rawTx
        ]
    }, function(err, res) {
        if (err) return cb(err);
        cb(null, res.result);
    });
};
HookedWalletSubprovider.prototype.estimateGas = function(txParams, cb) {
    const self = this;
    estimateGas(self.engine, txParams, cb);
};
HookedWalletSubprovider.prototype.getGasPrice = function(cb) {
    const self = this;
    self.emitPayload({
        method: "eth_gasPrice",
        params: []
    }, function(err, res) {
        if (err) return cb(err);
        cb(null, res.result);
    });
};
HookedWalletSubprovider.prototype.fillInTxExtras = function(txParams, cb) {
    const self = this;
    const address = txParams.from;
    // console.log('fillInTxExtras - address:', address)
    const tasks = {};
    if (txParams.gasPrice === undefined) // console.log("need to get gasprice")
    tasks.gasPrice = self.getGasPrice.bind(self);
    if (txParams.nonce === undefined) // console.log("need to get nonce")
    tasks.nonce = self.emitPayload.bind(self, {
        method: "eth_getTransactionCount",
        params: [
            address,
            "pending"
        ]
    });
    if (txParams.gas === undefined) // console.log("need to get gas")
    tasks.gas = self.estimateGas.bind(self, cloneTxParams(txParams));
    parallel(tasks, function(err, taskResults) {
        if (err) return cb(err);
        const result = {};
        if (taskResults.gasPrice) result.gasPrice = taskResults.gasPrice;
        if (taskResults.nonce) result.nonce = taskResults.nonce.result;
        if (taskResults.gas) result.gas = taskResults.gas;
        cb(null, extend(txParams, result));
    });
};
// util
// we use this to clean any custom params from the txParams
function cloneTxParams(txParams) {
    return {
        from: txParams.from,
        to: txParams.to,
        value: txParams.value,
        data: txParams.data,
        gas: txParams.gas,
        gasPrice: txParams.gasPrice,
        nonce: txParams.nonce
    };
}
function toLowerCase(string) {
    return string.toLowerCase();
}
function resemblesAddress(string) {
    const fixed = ethUtil.addHexPrefix(string);
    const isValid = ethUtil.isValidAddress(fixed);
    return isValid;
}
// Returns true if resembles hex data
// but definitely not a valid address.
function resemblesData(string) {
    const fixed = ethUtil.addHexPrefix(string);
    const isValidAddress = ethUtil.isValidAddress(fixed);
    return !isValidAddress && isValidHex(string);
}
function isValidHex(data) {
    const isString = typeof data === "string";
    if (!isString) return false;
    const isHexPrefixed = data.slice(0, 2) === "0x";
    if (!isHexPrefixed) return false;
    const nonPrefixed = data.slice(2);
    const isValid = nonPrefixed.match(hexRegex);
    return isValid;
}
function mustProvideInConstructor(methodName) {
    return function(params, cb) {
        cb(new Error('ProviderEngine - HookedWalletSubprovider - Must provide "' + methodName + '" fn in constructor options'));
    };
}

},{"ae562c5810984549":"3y4Df","9728f09272f0bd93":"l1ckv","5bb58f4f1113ab9f":"jInrX","1d9f010ea8b370b3":"8JOz2","5203e671dc3495f3":"4Aoqj","3071ecb5c1976065":"7rqcZ","ede6cd9409df70f9":"57rXc","c35e0c01f2af0217":"4Q1cC","1ba10fc0f02b8669":"LLff4"}],"3y4Df":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = function(tasks, callback) {
    callback = (0, _once2.default)(callback || _noop2.default);
    if (!(0, _isArray2.default)(tasks)) return callback(new Error("First argument to waterfall must be an array of functions"));
    if (!tasks.length) return callback();
    var taskIndex = 0;
    function nextTask(args) {
        var task = (0, _wrapAsync2.default)(tasks[taskIndex++]);
        args.push((0, _onlyOnce2.default)(next));
        task.apply(null, args);
    }
    function next(err /*, ...args*/ ) {
        if (err || taskIndex === tasks.length) return callback.apply(null, arguments);
        nextTask((0, _slice2.default)(arguments, 1));
    }
    nextTask([]);
};
var _isArray = require("635f277528151c2c");
var _isArray2 = _interopRequireDefault(_isArray);
var _noop = require("370b6329ad939324");
var _noop2 = _interopRequireDefault(_noop);
var _once = require("1b800b5a144e474f");
var _once2 = _interopRequireDefault(_once);
var _slice = require("8bddbdb5f57827ef");
var _slice2 = _interopRequireDefault(_slice);
var _onlyOnce = require("eb8177fad87f2a2b");
var _onlyOnce2 = _interopRequireDefault(_onlyOnce);
var _wrapAsync = require("f1ce61e93ddcb524");
var _wrapAsync2 = _interopRequireDefault(_wrapAsync);
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
module.exports = exports["default"]; /**
 * Runs the `tasks` array of functions in series, each passing their results to
 * the next in the array. However, if any of the `tasks` pass an error to their
 * own callback, the next function is not executed, and the main `callback` is
 * immediately called with the error.
 *
 * @name waterfall
 * @static
 * @memberOf module:ControlFlow
 * @method
 * @category Control Flow
 * @param {Array} tasks - An array of [async functions]{@link AsyncFunction}
 * to run.
 * Each function should complete with any number of `result` values.
 * The `result` values will be passed as arguments, in order, to the next task.
 * @param {Function} [callback] - An optional callback to run once all the
 * functions have completed. This will be passed the results of the last task's
 * callback. Invoked with (err, [results]).
 * @returns undefined
 * @example
 *
 * async.waterfall([
 *     function(callback) {
 *         callback(null, 'one', 'two');
 *     },
 *     function(arg1, arg2, callback) {
 *         // arg1 now equals 'one' and arg2 now equals 'two'
 *         callback(null, 'three');
 *     },
 *     function(arg1, callback) {
 *         // arg1 now equals 'three'
 *         callback(null, 'done');
 *     }
 * ], function (err, result) {
 *     // result now equals 'done'
 * });
 *
 * // Or, with named functions:
 * async.waterfall([
 *     myFirstFunction,
 *     mySecondFunction,
 *     myLastFunction,
 * ], function (err, result) {
 *     // result now equals 'done'
 * });
 * function myFirstFunction(callback) {
 *     callback(null, 'one', 'two');
 * }
 * function mySecondFunction(arg1, arg2, callback) {
 *     // arg1 now equals 'one' and arg2 now equals 'two'
 *     callback(null, 'three');
 * }
 * function myLastFunction(arg1, callback) {
 *     // arg1 now equals 'three'
 *     callback(null, 'done');
 * }
 */ 

},{"635f277528151c2c":"2VsjV","370b6329ad939324":"8qs1l","1b800b5a144e474f":"bBLnu","8bddbdb5f57827ef":"2vgdt","eb8177fad87f2a2b":"e2khU","f1ce61e93ddcb524":"jj6ne"}],"l1ckv":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = parallelLimit;
var _eachOf = require("b408528473d3574");
var _eachOf2 = _interopRequireDefault(_eachOf);
var _parallel = require("cad61c8ddc01fa00");
var _parallel2 = _interopRequireDefault(_parallel);
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * Run the `tasks` collection of functions in parallel, without waiting until
 * the previous function has completed. If any of the functions pass an error to
 * its callback, the main `callback` is immediately called with the value of the
 * error. Once the `tasks` have completed, the results are passed to the final
 * `callback` as an array.
 *
 * **Note:** `parallel` is about kicking-off I/O tasks in parallel, not about
 * parallel execution of code.  If your tasks do not use any timers or perform
 * any I/O, they will actually be executed in series.  Any synchronous setup
 * sections for each task will happen one after the other.  JavaScript remains
 * single-threaded.
 *
 * **Hint:** Use [`reflect`]{@link module:Utils.reflect} to continue the
 * execution of other tasks when a task fails.
 *
 * It is also possible to use an object instead of an array. Each property will
 * be run as a function and the results will be passed to the final `callback`
 * as an object instead of an array. This can be a more readable way of handling
 * results from {@link async.parallel}.
 *
 * @name parallel
 * @static
 * @memberOf module:ControlFlow
 * @method
 * @category Control Flow
 * @param {Array|Iterable|Object} tasks - A collection of
 * [async functions]{@link AsyncFunction} to run.
 * Each async function can complete with any number of optional `result` values.
 * @param {Function} [callback] - An optional callback to run once all the
 * functions have completed successfully. This function gets a results array
 * (or object) containing all the result arguments passed to the task callbacks.
 * Invoked with (err, results).
 *
 * @example
 * async.parallel([
 *     function(callback) {
 *         setTimeout(function() {
 *             callback(null, 'one');
 *         }, 200);
 *     },
 *     function(callback) {
 *         setTimeout(function() {
 *             callback(null, 'two');
 *         }, 100);
 *     }
 * ],
 * // optional callback
 * function(err, results) {
 *     // the results array will equal ['one','two'] even though
 *     // the second function had a shorter timeout.
 * });
 *
 * // an example using an object instead of an array
 * async.parallel({
 *     one: function(callback) {
 *         setTimeout(function() {
 *             callback(null, 1);
 *         }, 200);
 *     },
 *     two: function(callback) {
 *         setTimeout(function() {
 *             callback(null, 2);
 *         }, 100);
 *     }
 * }, function(err, results) {
 *     // results is now equals to: {one: 1, two: 2}
 * });
 */ function parallelLimit(tasks, callback) {
    (0, _parallel2.default)(_eachOf2.default, tasks, callback);
}
module.exports = exports["default"];

},{"b408528473d3574":"bRXKs","cad61c8ddc01fa00":"1oyIR"}],"1oyIR":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = _parallel;
var _noop = require("998b14812f5c599c");
var _noop2 = _interopRequireDefault(_noop);
var _isArrayLike = require("c826cc8eaba49eae");
var _isArrayLike2 = _interopRequireDefault(_isArrayLike);
var _slice = require("f7f39bc06c05149f");
var _slice2 = _interopRequireDefault(_slice);
var _wrapAsync = require("823a54c778f12327");
var _wrapAsync2 = _interopRequireDefault(_wrapAsync);
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _parallel(eachfn, tasks, callback) {
    callback = callback || _noop2.default;
    var results = (0, _isArrayLike2.default)(tasks) ? [] : {};
    eachfn(tasks, function(task, key, callback) {
        (0, _wrapAsync2.default)(task)(function(err, result) {
            if (arguments.length > 2) result = (0, _slice2.default)(arguments, 1);
            results[key] = result;
            callback(err);
        });
    }, function(err) {
        callback(err, results);
    });
}
module.exports = exports["default"];

},{"998b14812f5c599c":"8qs1l","c826cc8eaba49eae":"5uWOF","f7f39bc06c05149f":"2vgdt","823a54c778f12327":"jj6ne"}],"4Aoqj":[function(require,module,exports) {
const ethUtil = require("c9f628234abf00fa");
const ethAbi = require("c5729f007934365a");
module.exports = {
    concatSig: function(v, r, s) {
        const rSig = ethUtil.fromSigned(r);
        const sSig = ethUtil.fromSigned(s);
        const vSig = ethUtil.bufferToInt(v);
        const rStr = padWithZeroes(ethUtil.toUnsigned(rSig).toString("hex"), 64);
        const sStr = padWithZeroes(ethUtil.toUnsigned(sSig).toString("hex"), 64);
        const vStr = ethUtil.stripHexPrefix(ethUtil.intToHex(vSig));
        return ethUtil.addHexPrefix(rStr.concat(sStr, vStr)).toString("hex");
    },
    normalize: function(input) {
        if (!input) return;
        if (typeof input === "number") {
            const buffer = ethUtil.toBuffer(input);
            input = ethUtil.bufferToHex(buffer);
        }
        if (typeof input !== "string") {
            var msg = "eth-sig-util.normalize() requires hex string or integer input.";
            msg += " received " + typeof input + ": " + input;
            throw new Error(msg);
        }
        return ethUtil.addHexPrefix(input.toLowerCase());
    },
    personalSign: function(privateKey, msgParams) {
        var message = ethUtil.toBuffer(msgParams.data);
        var msgHash = ethUtil.hashPersonalMessage(message);
        var sig = ethUtil.ecsign(msgHash, privateKey);
        var serialized = ethUtil.bufferToHex(this.concatSig(sig.v, sig.r, sig.s));
        return serialized;
    },
    recoverPersonalSignature: function(msgParams) {
        const publicKey = getPublicKeyFor(msgParams);
        const sender = ethUtil.publicToAddress(publicKey);
        const senderHex = ethUtil.bufferToHex(sender);
        return senderHex;
    },
    extractPublicKey: function(msgParams) {
        const publicKey = getPublicKeyFor(msgParams);
        return "0x" + publicKey.toString("hex");
    },
    typedSignatureHash: function(typedData) {
        const hashBuffer = typedSignatureHash(typedData);
        return ethUtil.bufferToHex(hashBuffer);
    },
    signTypedData: function(privateKey, msgParams) {
        const msgHash = typedSignatureHash(msgParams.data);
        const sig = ethUtil.ecsign(msgHash, privateKey);
        return ethUtil.bufferToHex(this.concatSig(sig.v, sig.r, sig.s));
    },
    recoverTypedSignature: function(msgParams) {
        const msgHash = typedSignatureHash(msgParams.data);
        const publicKey = recoverPublicKey(msgHash, msgParams.sig);
        const sender = ethUtil.publicToAddress(publicKey);
        return ethUtil.bufferToHex(sender);
    }
};
/**
 * @param typedData - Array of data along with types, as per EIP712.
 * @returns Buffer
 */ function typedSignatureHash(typedData) {
    const error = new Error("Expect argument to be non-empty array");
    if (typeof typedData !== "object" || !typedData.length) throw error;
    const data = typedData.map(function(e) {
        return e.type === "bytes" ? ethUtil.toBuffer(e.value) : e.value;
    });
    const types = typedData.map(function(e) {
        return e.type;
    });
    const schema = typedData.map(function(e) {
        if (!e.name) throw error;
        return e.type + " " + e.name;
    });
    return ethAbi.soliditySHA3([
        "bytes32",
        "bytes32"
    ], [
        ethAbi.soliditySHA3(new Array(typedData.length).fill("string"), schema),
        ethAbi.soliditySHA3(types, data)
    ]);
}
function recoverPublicKey(hash, sig) {
    const signature = ethUtil.toBuffer(sig);
    const sigParams = ethUtil.fromRpcSig(signature);
    return ethUtil.ecrecover(hash, sigParams.v, sigParams.r, sigParams.s);
}
function getPublicKeyFor(msgParams) {
    const message = ethUtil.toBuffer(msgParams.data);
    const msgHash = ethUtil.hashPersonalMessage(message);
    return recoverPublicKey(msgHash, msgParams.sig);
}
function padWithZeroes(number, length) {
    var myString = "" + number;
    while(myString.length < length)myString = "0" + myString;
    return myString;
}

},{"c9f628234abf00fa":"8JOz2","c5729f007934365a":"qMoT5"}],"qMoT5":[function(require,module,exports) {
module.exports = require("cd1af8544a7d2ba2");

},{"cd1af8544a7d2ba2":"b3aJw"}],"b3aJw":[function(require,module,exports) {
/* eslint-disable no-useless-escape */ var Buffer = require("88dc16a580e19326").Buffer;
const utils = require("69f162c10eb96eb0");
const BN = require("83e7123182496efe");
var ABI = function() {};
// Convert from short to canonical names
// FIXME: optimise or make this nicer?
function elementaryName(name) {
    if (name.startsWith("int[")) return "int256" + name.slice(3);
    else if (name === "int") return "int256";
    else if (name.startsWith("uint[")) return "uint256" + name.slice(4);
    else if (name === "uint") return "uint256";
    else if (name.startsWith("fixed[")) return "fixed128x128" + name.slice(5);
    else if (name === "fixed") return "fixed128x128";
    else if (name.startsWith("ufixed[")) return "ufixed128x128" + name.slice(6);
    else if (name === "ufixed") return "ufixed128x128";
    return name;
}
ABI.eventID = function(name, types) {
    // FIXME: use node.js util.format?
    var sig = name + "(" + types.map(elementaryName).join(",") + ")";
    return utils.keccak256(Buffer.from(sig));
};
ABI.methodID = function(name, types) {
    return ABI.eventID(name, types).slice(0, 4);
};
// Parse N from type<N>
function parseTypeN(type) {
    return parseInt(/^\D+(\d+)$/.exec(type)[1], 10);
}
// Parse N,M from type<N>x<M>
function parseTypeNxM(type) {
    var tmp = /^\D+(\d+)x(\d+)$/.exec(type);
    return [
        parseInt(tmp[1], 10),
        parseInt(tmp[2], 10)
    ];
}
// Parse N in type[<N>] where "type" can itself be an array type.
function parseTypeArray(type) {
    var tmp = type.match(/(.*)\[(.*?)\]$/);
    if (tmp) return tmp[2] === "" ? "dynamic" : parseInt(tmp[2], 10);
    return null;
}
function parseNumber(arg) {
    var type = typeof arg;
    if (type === "string") {
        if (utils.isHexPrefixed(arg)) return new BN(utils.stripHexPrefix(arg), 16);
        else return new BN(arg, 10);
    } else if (type === "number") return new BN(arg);
    else if (arg.toArray) // assume this is a BN for the moment, replace with BN.isBN soon
    return arg;
    else throw new Error("Argument is not a number");
}
// someMethod(bytes,uint)
// someMethod(bytes,uint):(boolean)
function parseSignature(sig) {
    var tmp = /^(\w+)\((.*)\)$/.exec(sig);
    if (tmp.length !== 3) throw new Error("Invalid method signature");
    var args = /^(.+)\):\((.+)$/.exec(tmp[2]);
    if (args !== null && args.length === 3) return {
        method: tmp[1],
        args: args[1].split(","),
        retargs: args[2].split(",")
    };
    else {
        var params = tmp[2].split(",");
        if (params.length === 1 && params[0] === "") // Special-case (possibly naive) fixup for functions that take no arguments.
        // TODO: special cases are always bad, but this makes the function return
        // match what the calling functions expect
        params = [];
        return {
            method: tmp[1],
            args: params
        };
    }
}
// Encodes a single item (can be dynamic array)
// @returns: Buffer
function encodeSingle(type, arg) {
    var size, num, ret, i;
    if (type === "address") return encodeSingle("uint160", parseNumber(arg));
    else if (type === "bool") return encodeSingle("uint8", arg ? 1 : 0);
    else if (type === "string") return encodeSingle("bytes", Buffer.from(arg, "utf8"));
    else if (isArray(type)) {
        // this part handles fixed-length ([2]) and variable length ([]) arrays
        // NOTE: we catch here all calls to arrays, that simplifies the rest
        if (typeof arg.length === "undefined") throw new Error("Not an array?");
        size = parseTypeArray(type);
        if (size !== "dynamic" && size !== 0 && arg.length > size) throw new Error("Elements exceed array size: " + size);
        ret = [];
        type = type.slice(0, type.lastIndexOf("["));
        if (typeof arg === "string") arg = JSON.parse(arg);
        for(i in arg)ret.push(encodeSingle(type, arg[i]));
        if (size === "dynamic") {
            var length = encodeSingle("uint256", arg.length);
            ret.unshift(length);
        }
        return Buffer.concat(ret);
    } else if (type === "bytes") {
        arg = Buffer.from(arg);
        ret = Buffer.concat([
            encodeSingle("uint256", arg.length),
            arg
        ]);
        if (arg.length % 32 !== 0) ret = Buffer.concat([
            ret,
            utils.zeros(32 - arg.length % 32)
        ]);
        return ret;
    } else if (type.startsWith("bytes")) {
        size = parseTypeN(type);
        if (size < 1 || size > 32) throw new Error("Invalid bytes<N> width: " + size);
        return utils.setLengthRight(arg, 32);
    } else if (type.startsWith("uint")) {
        size = parseTypeN(type);
        if (size % 8 || size < 8 || size > 256) throw new Error("Invalid uint<N> width: " + size);
        num = parseNumber(arg);
        if (num.bitLength() > size) throw new Error("Supplied uint exceeds width: " + size + " vs " + num.bitLength());
        if (num < 0) throw new Error("Supplied uint is negative");
        return num.toArrayLike(Buffer, "be", 32);
    } else if (type.startsWith("int")) {
        size = parseTypeN(type);
        if (size % 8 || size < 8 || size > 256) throw new Error("Invalid int<N> width: " + size);
        num = parseNumber(arg);
        if (num.bitLength() > size) throw new Error("Supplied int exceeds width: " + size + " vs " + num.bitLength());
        return num.toTwos(256).toArrayLike(Buffer, "be", 32);
    } else if (type.startsWith("ufixed")) {
        size = parseTypeNxM(type);
        num = parseNumber(arg);
        if (num < 0) throw new Error("Supplied ufixed is negative");
        return encodeSingle("uint256", num.mul(new BN(2).pow(new BN(size[1]))));
    } else if (type.startsWith("fixed")) {
        size = parseTypeNxM(type);
        return encodeSingle("int256", parseNumber(arg).mul(new BN(2).pow(new BN(size[1]))));
    }
    throw new Error("Unsupported or invalid type: " + type);
}
// Decodes a single item (can be dynamic array)
// @returns: array
// FIXME: this method will need a lot of attention at checking limits and validation
function decodeSingle(parsedType, data, offset) {
    if (typeof parsedType === "string") parsedType = parseType(parsedType);
    var size, num, ret, i;
    if (parsedType.name === "address") return decodeSingle(parsedType.rawType, data, offset).toArrayLike(Buffer, "be", 20).toString("hex");
    else if (parsedType.name === "bool") return decodeSingle(parsedType.rawType, data, offset).toString() === new BN(1).toString();
    else if (parsedType.name === "string") {
        var bytes = decodeSingle(parsedType.rawType, data, offset);
        return Buffer.from(bytes, "utf8").toString();
    } else if (parsedType.isArray) {
        // this part handles fixed-length arrays ([2]) and variable length ([]) arrays
        // NOTE: we catch here all calls to arrays, that simplifies the rest
        ret = [];
        size = parsedType.size;
        if (parsedType.size === "dynamic") {
            offset = decodeSingle("uint256", data, offset).toNumber();
            size = decodeSingle("uint256", data, offset).toNumber();
            offset = offset + 32;
        }
        for(i = 0; i < size; i++){
            var decoded = decodeSingle(parsedType.subArray, data, offset);
            ret.push(decoded);
            offset += parsedType.subArray.memoryUsage;
        }
        return ret;
    } else if (parsedType.name === "bytes") {
        offset = decodeSingle("uint256", data, offset).toNumber();
        size = decodeSingle("uint256", data, offset).toNumber();
        return data.slice(offset + 32, offset + 32 + size);
    } else if (parsedType.name.startsWith("bytes")) return data.slice(offset, offset + parsedType.size);
    else if (parsedType.name.startsWith("uint")) {
        num = new BN(data.slice(offset, offset + 32), 16, "be");
        if (num.bitLength() > parsedType.size) throw new Error("Decoded int exceeds width: " + parsedType.size + " vs " + num.bitLength());
        return num;
    } else if (parsedType.name.startsWith("int")) {
        num = new BN(data.slice(offset, offset + 32), 16, "be").fromTwos(256);
        if (num.bitLength() > parsedType.size) throw new Error("Decoded uint exceeds width: " + parsedType.size + " vs " + num.bitLength());
        return num;
    } else if (parsedType.name.startsWith("ufixed")) {
        size = new BN(2).pow(new BN(parsedType.size[1]));
        num = decodeSingle("uint256", data, offset);
        if (!num.mod(size).isZero()) throw new Error("Decimals not supported yet");
        return num.div(size);
    } else if (parsedType.name.startsWith("fixed")) {
        size = new BN(2).pow(new BN(parsedType.size[1]));
        num = decodeSingle("int256", data, offset);
        if (!num.mod(size).isZero()) throw new Error("Decimals not supported yet");
        return num.div(size);
    }
    throw new Error("Unsupported or invalid type: " + parsedType.name);
}
// Parse the given type
// @returns: {} containing the type itself, memory usage and (including size and subArray if applicable)
function parseType(type) {
    var size;
    var ret;
    if (isArray(type)) {
        size = parseTypeArray(type);
        var subArray = type.slice(0, type.lastIndexOf("["));
        subArray = parseType(subArray);
        ret = {
            isArray: true,
            name: type,
            size: size,
            memoryUsage: size === "dynamic" ? 32 : subArray.memoryUsage * size,
            subArray: subArray
        };
        return ret;
    } else {
        var rawType;
        switch(type){
            case "address":
                rawType = "uint160";
                break;
            case "bool":
                rawType = "uint8";
                break;
            case "string":
                rawType = "bytes";
                break;
        }
        ret = {
            rawType: rawType,
            name: type,
            memoryUsage: 32
        };
        if (type.startsWith("bytes") && type !== "bytes" || type.startsWith("uint") || type.startsWith("int")) ret.size = parseTypeN(type);
        else if (type.startsWith("ufixed") || type.startsWith("fixed")) ret.size = parseTypeNxM(type);
        if (type.startsWith("bytes") && type !== "bytes" && (ret.size < 1 || ret.size > 32)) throw new Error("Invalid bytes<N> width: " + ret.size);
        if ((type.startsWith("uint") || type.startsWith("int")) && (ret.size % 8 || ret.size < 8 || ret.size > 256)) throw new Error("Invalid int/uint<N> width: " + ret.size);
        return ret;
    }
}
// Is a type dynamic?
function isDynamic(type) {
    // FIXME: handle all types? I don't think anything is missing now
    return type === "string" || type === "bytes" || parseTypeArray(type) === "dynamic";
}
// Is a type an array?
function isArray(type) {
    return type.lastIndexOf("]") === type.length - 1;
}
// Encode a method/event with arguments
// @types an array of string type names
// @args  an array of the appropriate values
ABI.rawEncode = function(types, values) {
    var output = [];
    var data = [];
    var headLength = 0;
    types.forEach(function(type) {
        if (isArray(type)) {
            var size = parseTypeArray(type);
            if (size !== "dynamic") headLength += 32 * size;
            else headLength += 32;
        } else headLength += 32;
    });
    for(var i = 0; i < types.length; i++){
        var type = elementaryName(types[i]);
        var value = values[i];
        var cur = encodeSingle(type, value);
        // Use the head/tail method for storing dynamic data
        if (isDynamic(type)) {
            output.push(encodeSingle("uint256", headLength));
            data.push(cur);
            headLength += cur.length;
        } else output.push(cur);
    }
    return Buffer.concat(output.concat(data));
};
ABI.rawDecode = function(types, data) {
    var ret = [];
    data = Buffer.from(data);
    var offset = 0;
    for(var i = 0; i < types.length; i++){
        var type = elementaryName(types[i]);
        var parsed = parseType(type, data, offset);
        var decoded = decodeSingle(parsed, data, offset);
        offset += parsed.memoryUsage;
        ret.push(decoded);
    }
    return ret;
};
ABI.simpleEncode = function(method) {
    var args = Array.prototype.slice.call(arguments).slice(1);
    var sig = parseSignature(method);
    // FIXME: validate/convert arguments
    if (args.length !== sig.args.length) throw new Error("Argument count mismatch");
    return Buffer.concat([
        ABI.methodID(sig.method, sig.args),
        ABI.rawEncode(sig.args, args)
    ]);
};
ABI.simpleDecode = function(method, data) {
    var sig = parseSignature(method);
    // FIXME: validate/convert arguments
    if (!sig.retargs) throw new Error("No return values in method");
    return ABI.rawDecode(sig.retargs, data);
};
function stringify(type, value) {
    if (type.startsWith("address") || type.startsWith("bytes")) return "0x" + value.toString("hex");
    else return value.toString();
}
ABI.stringify = function(types, values) {
    var ret = [];
    for(var i in types){
        var type = types[i];
        var value = values[i];
        // if it is an array type, concat the items
        if (/^[^\[]+\[.*\]$/.test(type)) value = value.map(function(item) {
            return stringify(type, item);
        }).join(", ");
        else value = stringify(type, value);
        ret.push(value);
    }
    return ret;
};
ABI.solidityHexValue = function(type, value, bitsize) {
    // pass in bitsize = null if use default bitsize
    var size, num;
    if (isArray(type)) {
        var subType = type.replace(/\[.*?\]/, "");
        if (!isArray(subType)) {
            var arraySize = parseTypeArray(type);
            if (arraySize !== "dynamic" && arraySize !== 0 && value.length > arraySize) throw new Error("Elements exceed array size: " + arraySize);
        }
        var arrayValues = value.map(function(v) {
            return ABI.solidityHexValue(subType, v, 256);
        });
        return Buffer.concat(arrayValues);
    } else if (type === "bytes") return value;
    else if (type === "string") return Buffer.from(value, "utf8");
    else if (type === "bool") {
        bitsize = bitsize || 8;
        var padding = Array(bitsize / 4).join("0");
        return Buffer.from(value ? padding + "1" : padding + "0", "hex");
    } else if (type === "address") {
        var bytesize = 20;
        if (bitsize) bytesize = bitsize / 8;
        return utils.setLengthLeft(value, bytesize);
    } else if (type.startsWith("bytes")) {
        size = parseTypeN(type);
        if (size < 1 || size > 32) throw new Error("Invalid bytes<N> width: " + size);
        return utils.setLengthRight(value, size);
    } else if (type.startsWith("uint")) {
        size = parseTypeN(type);
        if (size % 8 || size < 8 || size > 256) throw new Error("Invalid uint<N> width: " + size);
        num = parseNumber(value);
        if (num.bitLength() > size) throw new Error("Supplied uint exceeds width: " + size + " vs " + num.bitLength());
        bitsize = bitsize || size;
        return num.toArrayLike(Buffer, "be", bitsize / 8);
    } else if (type.startsWith("int")) {
        size = parseTypeN(type);
        if (size % 8 || size < 8 || size > 256) throw new Error("Invalid int<N> width: " + size);
        num = parseNumber(value);
        if (num.bitLength() > size) throw new Error("Supplied int exceeds width: " + size + " vs " + num.bitLength());
        bitsize = bitsize || size;
        return num.toTwos(size).toArrayLike(Buffer, "be", bitsize / 8);
    } else // FIXME: support all other types
    throw new Error("Unsupported or invalid type: " + type);
};
ABI.solidityPack = function(types, values) {
    if (types.length !== values.length) throw new Error("Number of types are not matching the values");
    var ret = [];
    for(var i = 0; i < types.length; i++){
        var type = elementaryName(types[i]);
        var value = values[i];
        ret.push(ABI.solidityHexValue(type, value, null));
    }
    return Buffer.concat(ret);
};
ABI.soliditySHA3 = function(types, values) {
    return utils.keccak256(ABI.solidityPack(types, values));
};
ABI.soliditySHA256 = function(types, values) {
    return utils.sha256(ABI.solidityPack(types, values));
};
ABI.solidityRIPEMD160 = function(types, values) {
    return utils.ripemd160(ABI.solidityPack(types, values), true);
};
// Serpent's users are familiar with this encoding
// - s: string
// - b: bytes
// - b<N>: bytes<N>
// - i: int256
// - a: int256[]
function isNumeric(c) {
    // FIXME: is this correct? Seems to work
    return c >= "0" && c <= "9";
}
// For a "documentation" refer to https://github.com/ethereum/serpent/blob/develop/preprocess.cpp
ABI.fromSerpent = function(sig) {
    var ret = [];
    for(var i = 0; i < sig.length; i++){
        var type = sig[i];
        if (type === "s") ret.push("bytes");
        else if (type === "b") {
            var tmp = "bytes";
            var j = i + 1;
            while(j < sig.length && isNumeric(sig[j])){
                tmp += sig[j] - "0";
                j++;
            }
            i = j - 1;
            ret.push(tmp);
        } else if (type === "i") ret.push("int256");
        else if (type === "a") ret.push("int256[]");
        else throw new Error("Unsupported or invalid type: " + type);
    }
    return ret;
};
ABI.toSerpent = function(types) {
    var ret = [];
    for(var i = 0; i < types.length; i++){
        var type = types[i];
        if (type === "bytes") ret.push("s");
        else if (type.startsWith("bytes")) ret.push("b" + parseTypeN(type));
        else if (type === "int256") ret.push("i");
        else if (type === "int256[]") ret.push("a");
        else throw new Error("Unsupported or invalid type: " + type);
    }
    return ret.join("");
};
module.exports = ABI;

},{"88dc16a580e19326":"l5Twm","69f162c10eb96eb0":"cz70Q","83e7123182496efe":"x4ItY"}],"cz70Q":[function(require,module,exports) {
"use strict";
var __createBinding = this && this.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, {
        enumerable: true,
        get: function() {
            return m[k];
        }
    });
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var __exportStar = this && this.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !exports1.hasOwnProperty(p)) __createBinding(exports1, m, p);
};
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.secp256k1 = exports.rlp = exports.BN = void 0;
var secp256k1 = require("d48b95aad63abbab");
exports.secp256k1 = secp256k1;
var ethjsUtil = require("43ebed257b84c4ec");
var BN = require("23948300db75201");
exports.BN = BN;
var rlp = require("6009363e39fa70ee");
exports.rlp = rlp;
Object.assign(exports, ethjsUtil);
/**
 * Constants
 */ __exportStar(require("ad16739a745f76ee"), exports);
/**
 * Public-key cryptography (secp256k1) and addresses
 */ __exportStar(require("2df003d5b4fe946c"), exports);
/**
 * Hash functions
 */ __exportStar(require("b1131ffa4fc0cd65"), exports);
/**
 * ECDSA signature
 */ __exportStar(require("25d0ecf0cdbf4487"), exports);
/**
 * Utilities for manipulating Buffers, byte arrays, etc.
 */ __exportStar(require("f29b6ff9326c5034"), exports);
/**
 * Function for definining properties on an object
 */ __exportStar(require("346aea66b20da299"), exports);

},{"d48b95aad63abbab":"gEjJU","43ebed257b84c4ec":"4yJO4","23948300db75201":"x4ItY","6009363e39fa70ee":"iee6k","ad16739a745f76ee":"9Udav","2df003d5b4fe946c":"9FfwN","b1131ffa4fc0cd65":"hfyb4","25d0ecf0cdbf4487":"i0fkn","f29b6ff9326c5034":"2QBIO","346aea66b20da299":"1twJ5"}],"gEjJU":[function(require,module,exports) {
var Buffer = require("d46998b15bd8f5cd").Buffer;
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ecdhUnsafe = exports.ecdh = exports.recover = exports.verify = exports.sign = exports.signatureImportLax = exports.signatureImport = exports.signatureExport = exports.signatureNormalize = exports.publicKeyCombine = exports.publicKeyTweakMul = exports.publicKeyTweakAdd = exports.publicKeyVerify = exports.publicKeyConvert = exports.publicKeyCreate = exports.privateKeyTweakMul = exports.privateKeyTweakAdd = exports.privateKeyModInverse = exports.privateKeyNegate = exports.privateKeyImport = exports.privateKeyExport = exports.privateKeyVerify = void 0;
var secp256k1 = require("b2a9e3baef874aea");
var secp256k1v3 = require("5ade837d5d1e4935");
var der = require("e4dae22a89b547b9");
/**
 * Verify an ECDSA privateKey
 * @method privateKeyVerify
 * @param {Buffer} privateKey
 * @return {boolean}
 */ exports.privateKeyVerify = function(privateKey) {
    // secp256k1 v4 version throws when privateKey length is not 32
    if (privateKey.length !== 32) return false;
    return secp256k1.privateKeyVerify(Uint8Array.from(privateKey));
};
/**
 * Export a privateKey in DER format
 * @method privateKeyExport
 * @param {Buffer} privateKey
 * @param {boolean} compressed
 * @return {boolean}
 */ exports.privateKeyExport = function(privateKey, compressed) {
    // secp256k1 v4 version throws when privateKey length is not 32
    if (privateKey.length !== 32) throw new RangeError("private key length is invalid");
    var publicKey = secp256k1v3.privateKeyExport(privateKey, compressed);
    return der.privateKeyExport(privateKey, publicKey, compressed);
};
/**
 * Import a privateKey in DER format
 * @method privateKeyImport
 * @param {Buffer} privateKey
 * @return {Buffer}
 */ exports.privateKeyImport = function(privateKey) {
    // privateKeyImport method is not part of secp256k1 v4 package
    // this implementation is based on v3
    privateKey = der.privateKeyImport(privateKey);
    if (privateKey !== null && privateKey.length === 32 && exports.privateKeyVerify(privateKey)) return privateKey;
    throw new Error("couldn't import from DER format");
};
/**
 * Negate a privateKey by subtracting it from the order of the curve's base point
 * @method privateKeyNegate
 * @param {Buffer} privateKey
 * @return {Buffer}
 */ exports.privateKeyNegate = function(privateKey) {
    return Buffer.from(secp256k1.privateKeyNegate(Uint8Array.from(privateKey)));
};
/**
 * Compute the inverse of a privateKey (modulo the order of the curve's base point).
 * @method privateKeyModInverse
 * @param {Buffer} privateKey
 * @return {Buffer}
 */ exports.privateKeyModInverse = function(privateKey) {
    if (privateKey.length !== 32) throw new Error("private key length is invalid");
    return Buffer.from(secp256k1v3.privateKeyModInverse(Uint8Array.from(privateKey)));
};
/**
 * Tweak a privateKey by adding tweak to it.
 * @method privateKeyTweakAdd
 * @param {Buffer} privateKey
 * @param {Buffer} tweak
 * @return {Buffer}
 */ exports.privateKeyTweakAdd = function(privateKey, tweak) {
    return Buffer.from(secp256k1.privateKeyTweakAdd(Uint8Array.from(privateKey), tweak));
};
/**
 * Tweak a privateKey by multiplying it by a tweak.
 * @method privateKeyTweakMul
 * @param {Buffer} privateKey
 * @param {Buffer} tweak
 * @return {Buffer}
 */ exports.privateKeyTweakMul = function(privateKey, tweak) {
    return Buffer.from(secp256k1.privateKeyTweakMul(Uint8Array.from(privateKey), Uint8Array.from(tweak)));
};
/**
 * Compute the public key for a privateKey.
 * @method publicKeyCreate
 * @param {Buffer} privateKey
 * @param {boolean} compressed
 * @return {Buffer}
 */ exports.publicKeyCreate = function(privateKey, compressed) {
    return Buffer.from(secp256k1.publicKeyCreate(Uint8Array.from(privateKey), compressed));
};
/**
 * Convert a publicKey to compressed or uncompressed form.
 * @method publicKeyConvert
 * @param {Buffer} publicKey
 * @param {boolean} compressed
 * @return {Buffer}
 */ exports.publicKeyConvert = function(publicKey, compressed) {
    return Buffer.from(secp256k1.publicKeyConvert(Uint8Array.from(publicKey), compressed));
};
/**
 * Verify an ECDSA publicKey.
 * @method publicKeyVerify
 * @param {Buffer} publicKey
 * @return {boolean}
 */ exports.publicKeyVerify = function(publicKey) {
    // secp256k1 v4 version throws when publicKey length is not 33 or 65
    if (publicKey.length !== 33 && publicKey.length !== 65) return false;
    return secp256k1.publicKeyVerify(Uint8Array.from(publicKey));
};
/**
 * Tweak a publicKey by adding tweak times the generator to it.
 * @method publicKeyTweakAdd
 * @param {Buffer} publicKey
 * @param {Buffer} tweak
 * @param {boolean} compressed
 * @return {Buffer}
 */ exports.publicKeyTweakAdd = function(publicKey, tweak, compressed) {
    return Buffer.from(secp256k1.publicKeyTweakAdd(Uint8Array.from(publicKey), Uint8Array.from(tweak), compressed));
};
/**
 * Tweak a publicKey by multiplying it by a tweak value
 * @method publicKeyTweakMul
 * @param {Buffer} publicKey
 * @param {Buffer} tweak
 * @param {boolean} compressed
 * @return {Buffer}
 */ exports.publicKeyTweakMul = function(publicKey, tweak, compressed) {
    return Buffer.from(secp256k1.publicKeyTweakMul(Uint8Array.from(publicKey), Uint8Array.from(tweak), compressed));
};
/**
 * Add a given publicKeys together.
 * @method publicKeyCombine
 * @param {Array<Buffer>} publicKeys
 * @param {boolean} compressed
 * @return {Buffer}
 */ exports.publicKeyCombine = function(publicKeys, compressed) {
    var keys = [];
    publicKeys.forEach(function(publicKey) {
        keys.push(Uint8Array.from(publicKey));
    });
    return Buffer.from(secp256k1.publicKeyCombine(keys, compressed));
};
/**
 * Convert a signature to a normalized lower-S form.
 * @method signatureNormalize
 * @param {Buffer} signature
 * @return {Buffer}
 */ exports.signatureNormalize = function(signature) {
    return Buffer.from(secp256k1.signatureNormalize(Uint8Array.from(signature)));
};
/**
 * Serialize an ECDSA signature in DER format.
 * @method signatureExport
 * @param {Buffer} signature
 * @return {Buffer}
 */ exports.signatureExport = function(signature) {
    return Buffer.from(secp256k1.signatureExport(Uint8Array.from(signature)));
};
/**
 * Parse a DER ECDSA signature (follow by [BIP66](https://github.com/bitcoin/bips/blob/master/bip-0066.mediawiki)).
 * @method signatureImport
 * @param {Buffer} signature
 * @return {Buffer}
 */ exports.signatureImport = function(signature) {
    return Buffer.from(secp256k1.signatureImport(Uint8Array.from(signature)));
};
/**
 * Parse a DER ECDSA signature (not follow by [BIP66](https://github.com/bitcoin/bips/blob/master/bip-0066.mediawiki)).
 * @method signatureImportLax
 * @param {Buffer} signature
 * @return {Buffer}
 */ exports.signatureImportLax = function(signature) {
    // signatureImportLax method is not part of secp256k1 v4 package
    // this implementation is based on v3
    // ensure that signature is greater than 0
    if (signature.length === 0) throw new RangeError("signature length is invalid");
    var sigObj = der.signatureImportLax(signature);
    if (sigObj === null) throw new Error("couldn't parse DER signature");
    return secp256k1v3.signatureImport(sigObj);
};
/**
 * Create an ECDSA signature. Always return low-S signature.
 * @method sign
 * @param {Buffer} message
 * @param {Buffer} privateKey
 * @param {Object} options
 * @return {Buffer}
 */ exports.sign = function(message, privateKey, options) {
    if (options === null) throw new TypeError("options should be an Object");
    var signOptions = undefined;
    if (options) {
        signOptions = {};
        if (options.data === null) // validate option.data length
        throw new TypeError("options.data should be a Buffer");
        if (options.data) {
            if (options.data.length != 32) throw new RangeError("options.data length is invalid");
            signOptions.data = new Uint8Array(options.data);
        }
        if (options.noncefn === null) throw new TypeError("options.noncefn should be a Function");
        if (options.noncefn) // convert option.noncefn function signature
        signOptions.noncefn = function(message, privateKey, algo, data, attempt) {
            var bufferAlgo = algo != null ? Buffer.from(algo) : null;
            var bufferData = data != null ? Buffer.from(data) : null;
            var buffer = Buffer.from("");
            if (options.noncefn) buffer = options.noncefn(Buffer.from(message), Buffer.from(privateKey), bufferAlgo, bufferData, attempt);
            return new Uint8Array(buffer);
        };
    }
    var sig = secp256k1.ecdsaSign(Uint8Array.from(message), Uint8Array.from(privateKey), signOptions);
    return {
        signature: Buffer.from(sig.signature),
        recovery: sig.recid
    };
};
/**
 * Verify an ECDSA signature.
 * @method verify
 * @param {Buffer} message
 * @param {Buffer} signature
 * @param {Buffer} publicKey
 * @return {boolean}
 */ exports.verify = function(message, signature, publicKey) {
    return secp256k1.ecdsaVerify(Uint8Array.from(signature), Uint8Array.from(message), publicKey);
};
/**
 * Recover an ECDSA public key from a signature.
 * @method recover
 * @param {Buffer} message
 * @param {Buffer} signature
 * @param {Number} recid
 * @param {boolean} compressed
 * @return {Buffer}
 */ exports.recover = function(message, signature, recid, compressed) {
    return Buffer.from(secp256k1.ecdsaRecover(Uint8Array.from(signature), recid, Uint8Array.from(message), compressed));
};
/**
 * Compute an EC Diffie-Hellman secret and applied sha256 to compressed public key.
 * @method ecdh
 * @param {Buffer} publicKey
 * @param {Buffer} privateKey
 * @return {Buffer}
 */ exports.ecdh = function(publicKey, privateKey) {
    // note: secp256k1 v3 doesn't allow optional parameter
    return Buffer.from(secp256k1.ecdh(Uint8Array.from(publicKey), Uint8Array.from(privateKey), {}));
};
exports.ecdhUnsafe = function(publicKey, privateKey, compressed) {
    // ecdhUnsafe method is not part of secp256k1 v4 package
    // this implementation is based on v3
    // ensure valid publicKey length
    if (publicKey.length !== 33 && publicKey.length !== 65) throw new RangeError("public key length is invalid");
    // ensure valid privateKey length
    if (privateKey.length !== 32) throw new RangeError("private key length is invalid");
    return Buffer.from(secp256k1v3.ecdhUnsafe(Uint8Array.from(publicKey), Uint8Array.from(privateKey), compressed));
};

},{"d46998b15bd8f5cd":"l5Twm","b2a9e3baef874aea":"2QBD2","5ade837d5d1e4935":"65WQ6","e4dae22a89b547b9":"dDLxJ"}],"65WQ6":[function(require,module,exports) {
var Buffer = require("433bf096d14feeb7").Buffer;
"use strict";
// This file is imported from secp256k1 v3
// https://github.com/cryptocoinjs/secp256k1-node/blob/master/LICENSE
Object.defineProperty(exports, "__esModule", {
    value: true
});
var BN = require("dfbd2cf12f58256");
var EC = require("72e7c203ae1e29f7").ec;
var ec = new EC("secp256k1");
var ecparams = ec.curve;
exports.privateKeyExport = function(privateKey, compressed) {
    if (compressed === void 0) compressed = true;
    var d = new BN(privateKey);
    if (d.ucmp(ecparams.n) >= 0) throw new Error("couldn't export to DER format");
    var point = ec.g.mul(d);
    return toPublicKey(point.getX(), point.getY(), compressed);
};
exports.privateKeyModInverse = function(privateKey) {
    var bn = new BN(privateKey);
    if (bn.ucmp(ecparams.n) >= 0 || bn.isZero()) throw new Error("private key range is invalid");
    return bn.invm(ecparams.n).toArrayLike(Buffer, "be", 32);
};
exports.signatureImport = function(sigObj) {
    var r = new BN(sigObj.r);
    if (r.ucmp(ecparams.n) >= 0) r = new BN(0);
    var s = new BN(sigObj.s);
    if (s.ucmp(ecparams.n) >= 0) s = new BN(0);
    return Buffer.concat([
        r.toArrayLike(Buffer, "be", 32),
        s.toArrayLike(Buffer, "be", 32)
    ]);
};
exports.ecdhUnsafe = function(publicKey, privateKey, compressed) {
    if (compressed === void 0) compressed = true;
    var point = ec.keyFromPublic(publicKey);
    var scalar = new BN(privateKey);
    if (scalar.ucmp(ecparams.n) >= 0 || scalar.isZero()) throw new Error("scalar was invalid (zero or overflow)");
    var shared = point.pub.mul(scalar);
    return toPublicKey(shared.getX(), shared.getY(), compressed);
};
var toPublicKey = function(x, y, compressed) {
    var publicKey;
    if (compressed) {
        publicKey = Buffer.alloc(33);
        publicKey[0] = y.isOdd() ? 0x03 : 0x02;
        x.toArrayLike(Buffer, "be", 32).copy(publicKey, 1);
    } else {
        publicKey = Buffer.alloc(65);
        publicKey[0] = 0x04;
        x.toArrayLike(Buffer, "be", 32).copy(publicKey, 1);
        y.toArrayLike(Buffer, "be", 32).copy(publicKey, 33);
    }
    return publicKey;
};

},{"433bf096d14feeb7":"l5Twm","dfbd2cf12f58256":"x4ItY","72e7c203ae1e29f7":"e8UEU"}],"dDLxJ":[function(require,module,exports) {
var Buffer = require("2ecae0b89c8c8b02").Buffer;
"use strict";
// This file is imported from secp256k1 v3
// https://github.com/cryptocoinjs/secp256k1-node/blob/master/LICENSE
Object.defineProperty(exports, "__esModule", {
    value: true
});
var EC_PRIVKEY_EXPORT_DER_COMPRESSED = Buffer.from([
    // begin
    0x30,
    0x81,
    0xd3,
    0x02,
    0x01,
    0x01,
    0x04,
    0x20,
    // private key
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    // middle
    0xa0,
    0x81,
    0x85,
    0x30,
    0x81,
    0x82,
    0x02,
    0x01,
    0x01,
    0x30,
    0x2c,
    0x06,
    0x07,
    0x2a,
    0x86,
    0x48,
    0xce,
    0x3d,
    0x01,
    0x01,
    0x02,
    0x21,
    0x00,
    0xff,
    0xff,
    0xff,
    0xff,
    0xff,
    0xff,
    0xff,
    0xff,
    0xff,
    0xff,
    0xff,
    0xff,
    0xff,
    0xff,
    0xff,
    0xff,
    0xff,
    0xff,
    0xff,
    0xff,
    0xff,
    0xff,
    0xff,
    0xff,
    0xff,
    0xff,
    0xff,
    0xfe,
    0xff,
    0xff,
    0xfc,
    0x2f,
    0x30,
    0x06,
    0x04,
    0x01,
    0x00,
    0x04,
    0x01,
    0x07,
    0x04,
    0x21,
    0x02,
    0x79,
    0xbe,
    0x66,
    0x7e,
    0xf9,
    0xdc,
    0xbb,
    0xac,
    0x55,
    0xa0,
    0x62,
    0x95,
    0xce,
    0x87,
    0x0b,
    0x07,
    0x02,
    0x9b,
    0xfc,
    0xdb,
    0x2d,
    0xce,
    0x28,
    0xd9,
    0x59,
    0xf2,
    0x81,
    0x5b,
    0x16,
    0xf8,
    0x17,
    0x98,
    0x02,
    0x21,
    0x00,
    0xff,
    0xff,
    0xff,
    0xff,
    0xff,
    0xff,
    0xff,
    0xff,
    0xff,
    0xff,
    0xff,
    0xff,
    0xff,
    0xff,
    0xff,
    0xfe,
    0xba,
    0xae,
    0xdc,
    0xe6,
    0xaf,
    0x48,
    0xa0,
    0x3b,
    0xbf,
    0xd2,
    0x5e,
    0x8c,
    0xd0,
    0x36,
    0x41,
    0x41,
    0x02,
    0x01,
    0x01,
    0xa1,
    0x24,
    0x03,
    0x22,
    0x00,
    // public key
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00
]);
var EC_PRIVKEY_EXPORT_DER_UNCOMPRESSED = Buffer.from([
    // begin
    0x30,
    0x82,
    0x01,
    0x13,
    0x02,
    0x01,
    0x01,
    0x04,
    0x20,
    // private key
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    // middle
    0xa0,
    0x81,
    0xa5,
    0x30,
    0x81,
    0xa2,
    0x02,
    0x01,
    0x01,
    0x30,
    0x2c,
    0x06,
    0x07,
    0x2a,
    0x86,
    0x48,
    0xce,
    0x3d,
    0x01,
    0x01,
    0x02,
    0x21,
    0x00,
    0xff,
    0xff,
    0xff,
    0xff,
    0xff,
    0xff,
    0xff,
    0xff,
    0xff,
    0xff,
    0xff,
    0xff,
    0xff,
    0xff,
    0xff,
    0xff,
    0xff,
    0xff,
    0xff,
    0xff,
    0xff,
    0xff,
    0xff,
    0xff,
    0xff,
    0xff,
    0xff,
    0xfe,
    0xff,
    0xff,
    0xfc,
    0x2f,
    0x30,
    0x06,
    0x04,
    0x01,
    0x00,
    0x04,
    0x01,
    0x07,
    0x04,
    0x41,
    0x04,
    0x79,
    0xbe,
    0x66,
    0x7e,
    0xf9,
    0xdc,
    0xbb,
    0xac,
    0x55,
    0xa0,
    0x62,
    0x95,
    0xce,
    0x87,
    0x0b,
    0x07,
    0x02,
    0x9b,
    0xfc,
    0xdb,
    0x2d,
    0xce,
    0x28,
    0xd9,
    0x59,
    0xf2,
    0x81,
    0x5b,
    0x16,
    0xf8,
    0x17,
    0x98,
    0x48,
    0x3a,
    0xda,
    0x77,
    0x26,
    0xa3,
    0xc4,
    0x65,
    0x5d,
    0xa4,
    0xfb,
    0xfc,
    0x0e,
    0x11,
    0x08,
    0xa8,
    0xfd,
    0x17,
    0xb4,
    0x48,
    0xa6,
    0x85,
    0x54,
    0x19,
    0x9c,
    0x47,
    0xd0,
    0x8f,
    0xfb,
    0x10,
    0xd4,
    0xb8,
    0x02,
    0x21,
    0x00,
    0xff,
    0xff,
    0xff,
    0xff,
    0xff,
    0xff,
    0xff,
    0xff,
    0xff,
    0xff,
    0xff,
    0xff,
    0xff,
    0xff,
    0xff,
    0xfe,
    0xba,
    0xae,
    0xdc,
    0xe6,
    0xaf,
    0x48,
    0xa0,
    0x3b,
    0xbf,
    0xd2,
    0x5e,
    0x8c,
    0xd0,
    0x36,
    0x41,
    0x41,
    0x02,
    0x01,
    0x01,
    0xa1,
    0x44,
    0x03,
    0x42,
    0x00,
    // public key
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00
]);
exports.privateKeyExport = function(privateKey, publicKey, compressed) {
    if (compressed === void 0) compressed = true;
    var result = Buffer.from(compressed ? EC_PRIVKEY_EXPORT_DER_COMPRESSED : EC_PRIVKEY_EXPORT_DER_UNCOMPRESSED);
    privateKey.copy(result, compressed ? 8 : 9);
    publicKey.copy(result, compressed ? 181 : 214);
    return result;
};
exports.privateKeyImport = function(privateKey) {
    var length = privateKey.length;
    // sequence header
    var index = 0;
    if (length < index + 1 || privateKey[index] !== 0x30) return null;
    index += 1;
    // sequence length constructor
    if (length < index + 1 || !(privateKey[index] & 0x80)) return null;
    var lenb = privateKey[index] & 0x7f;
    index += 1;
    if (lenb < 1 || lenb > 2) return null;
    if (length < index + lenb) return null;
    // sequence length
    var len = privateKey[index + lenb - 1] | (lenb > 1 ? privateKey[index + lenb - 2] << 8 : 0);
    index += lenb;
    if (length < index + len) return null;
    // sequence element 0: version number (=1)
    if (length < index + 3 || privateKey[index] !== 0x02 || privateKey[index + 1] !== 0x01 || privateKey[index + 2] !== 0x01) return null;
    index += 3;
    // sequence element 1: octet string, up to 32 bytes
    if (length < index + 2 || privateKey[index] !== 0x04 || privateKey[index + 1] > 0x20 || length < index + 2 + privateKey[index + 1]) return null;
    return privateKey.slice(index + 2, index + 2 + privateKey[index + 1]);
};
exports.signatureImportLax = function(signature) {
    var r = Buffer.alloc(32, 0);
    var s = Buffer.alloc(32, 0);
    var length = signature.length;
    var index = 0;
    // sequence tag byte
    if (signature[index++] !== 0x30) return null;
    // sequence length byte
    var lenbyte = signature[index++];
    if (lenbyte & 0x80) {
        index += lenbyte - 0x80;
        if (index > length) return null;
    }
    // sequence tag byte for r
    if (signature[index++] !== 0x02) return null;
    // length for r
    var rlen = signature[index++];
    if (rlen & 0x80) {
        lenbyte = rlen - 0x80;
        if (index + lenbyte > length) return null;
        for(; lenbyte > 0 && signature[index] === 0x00; index += 1, lenbyte -= 1);
        for(rlen = 0; lenbyte > 0; index += 1, lenbyte -= 1)rlen = (rlen << 8) + signature[index];
    }
    if (rlen > length - index) return null;
    var rindex = index;
    index += rlen;
    // sequence tag byte for s
    if (signature[index++] !== 0x02) return null;
    // length for s
    var slen = signature[index++];
    if (slen & 0x80) {
        lenbyte = slen - 0x80;
        if (index + lenbyte > length) return null;
        for(; lenbyte > 0 && signature[index] === 0x00; index += 1, lenbyte -= 1);
        for(slen = 0; lenbyte > 0; index += 1, lenbyte -= 1)slen = (slen << 8) + signature[index];
    }
    if (slen > length - index) return null;
    var sindex = index;
    index += slen;
    // ignore leading zeros in r
    for(; rlen > 0 && signature[rindex] === 0x00; rlen -= 1, rindex += 1);
    // copy r value
    if (rlen > 32) return null;
    var rvalue = signature.slice(rindex, rindex + rlen);
    rvalue.copy(r, 32 - rvalue.length);
    // ignore leading zeros in s
    for(; slen > 0 && signature[sindex] === 0x00; slen -= 1, sindex += 1);
    // copy s value
    if (slen > 32) return null;
    var svalue = signature.slice(sindex, sindex + slen);
    svalue.copy(s, 32 - svalue.length);
    return {
        r: r,
        s: s
    };
};

},{"2ecae0b89c8c8b02":"l5Twm"}],"9Udav":[function(require,module,exports) {
var Buffer = require("9df5893d06a389").Buffer;
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.KECCAK256_RLP = exports.KECCAK256_RLP_S = exports.KECCAK256_RLP_ARRAY = exports.KECCAK256_RLP_ARRAY_S = exports.KECCAK256_NULL = exports.KECCAK256_NULL_S = exports.TWO_POW256 = exports.MAX_INTEGER = void 0;
var BN = require("4f09662138c90d45");
/**
 * The max integer that this VM can handle
 */ exports.MAX_INTEGER = new BN("ffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff", 16);
/**
 * 2^256
 */ exports.TWO_POW256 = new BN("10000000000000000000000000000000000000000000000000000000000000000", 16);
/**
 * Keccak-256 hash of null
 */ exports.KECCAK256_NULL_S = "c5d2460186f7233c927e7db2dcc703c0e500b653ca82273b7bfad8045d85a470";
/**
 * Keccak-256 hash of null
 */ exports.KECCAK256_NULL = Buffer.from(exports.KECCAK256_NULL_S, "hex");
/**
 * Keccak-256 of an RLP of an empty array
 */ exports.KECCAK256_RLP_ARRAY_S = "1dcc4de8dec75d7aab85b567b6ccd41ad312451b948a7413f0a142fd40d49347";
/**
 * Keccak-256 of an RLP of an empty array
 */ exports.KECCAK256_RLP_ARRAY = Buffer.from(exports.KECCAK256_RLP_ARRAY_S, "hex");
/**
 * Keccak-256 hash of the RLP of null
 */ exports.KECCAK256_RLP_S = "56e81f171bcc55a6ff8345e692c0f86e5b48e01b996cadc001622fb5e363b421";
/**
 * Keccak-256 hash of the RLP of null
 */ exports.KECCAK256_RLP = Buffer.from(exports.KECCAK256_RLP_S, "hex");

},{"9df5893d06a389":"l5Twm","4f09662138c90d45":"x4ItY"}],"9FfwN":[function(require,module,exports) {
var Buffer = require("3c536b65da5a001f").Buffer;
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.importPublic = exports.privateToPublic = exports.privateToAddress = exports.publicToAddress = exports.pubToAddress = exports.isValidPublic = exports.isValidPrivate = exports.isPrecompiled = exports.generateAddress2 = exports.generateAddress = exports.isValidChecksumAddress = exports.toChecksumAddress = exports.isZeroAddress = exports.isValidAddress = exports.zeroAddress = void 0;
var assert = require("b3a30c006a03d930");
var ethjsUtil = require("de69eaa8bfdb7e26");
var secp256k1 = require("14569cad8609ccee");
var BN = require("4b223fbf118b91df");
var bytes_1 = require("5c3879b7f9d60b84");
var hash_1 = require("f831afda047afc4b");
/**
 * Returns a zero address.
 */ exports.zeroAddress = function() {
    var addressLength = 20;
    var addr = bytes_1.zeros(addressLength);
    return bytes_1.bufferToHex(addr);
};
/**
 * Checks if the address is a valid. Accepts checksummed addresses too.
 */ exports.isValidAddress = function(address) {
    return /^0x[0-9a-fA-F]{40}$/.test(address);
};
/**
 * Checks if a given address is a zero address.
 */ exports.isZeroAddress = function(address) {
    var zeroAddr = exports.zeroAddress();
    return zeroAddr === bytes_1.addHexPrefix(address);
};
/**
 * Returns a checksummed address.
 *
 * If a eip1191ChainId is provided, the chainId will be included in the checksum calculation. This
 * has the effect of checksummed addresses for one chain having invalid checksums for others.
 * For more details, consult EIP-1191.
 *
 * WARNING: Checksums with and without the chainId will differ. As of 2019-06-26, the most commonly
 * used variation in Ethereum was without the chainId. This may change in the future.
 */ exports.toChecksumAddress = function(address, eip1191ChainId) {
    address = ethjsUtil.stripHexPrefix(address).toLowerCase();
    var prefix = eip1191ChainId !== undefined ? eip1191ChainId.toString() + "0x" : "";
    var hash = hash_1.keccak(prefix + address).toString("hex");
    var ret = "0x";
    for(var i = 0; i < address.length; i++)if (parseInt(hash[i], 16) >= 8) ret += address[i].toUpperCase();
    else ret += address[i];
    return ret;
};
/**
 * Checks if the address is a valid checksummed address.
 *
 * See toChecksumAddress' documentation for details about the eip1191ChainId parameter.
 */ exports.isValidChecksumAddress = function(address, eip1191ChainId) {
    return exports.isValidAddress(address) && exports.toChecksumAddress(address, eip1191ChainId) === address;
};
/**
 * Generates an address of a newly created contract.
 * @param from The address which is creating this new address
 * @param nonce The nonce of the from account
 */ exports.generateAddress = function(from, nonce) {
    from = bytes_1.toBuffer(from);
    var nonceBN = new BN(nonce);
    if (nonceBN.isZero()) // in RLP we want to encode null in the case of zero nonce
    // read the RLP documentation for an answer if you dare
    return hash_1.rlphash([
        from,
        null
    ]).slice(-20);
    // Only take the lower 160bits of the hash
    return hash_1.rlphash([
        from,
        Buffer.from(nonceBN.toArray())
    ]).slice(-20);
};
/**
 * Generates an address for a contract created using CREATE2.
 * @param from The address which is creating this new address
 * @param salt A salt
 * @param initCode The init code of the contract being created
 */ exports.generateAddress2 = function(from, salt, initCode) {
    var fromBuf = bytes_1.toBuffer(from);
    var saltBuf = bytes_1.toBuffer(salt);
    var initCodeBuf = bytes_1.toBuffer(initCode);
    assert(fromBuf.length === 20);
    assert(saltBuf.length === 32);
    var address = hash_1.keccak256(Buffer.concat([
        Buffer.from("ff", "hex"),
        fromBuf,
        saltBuf,
        hash_1.keccak256(initCodeBuf)
    ]));
    return address.slice(-20);
};
/**
 * Returns true if the supplied address belongs to a precompiled account (Byzantium).
 */ exports.isPrecompiled = function(address) {
    var a = bytes_1.unpad(address);
    return a.length === 1 && a[0] >= 1 && a[0] <= 8;
};
/**
 * Checks if the private key satisfies the rules of the curve secp256k1.
 */ exports.isValidPrivate = function(privateKey) {
    return secp256k1.privateKeyVerify(privateKey);
};
/**
 * Checks if the public key satisfies the rules of the curve secp256k1
 * and the requirements of Ethereum.
 * @param publicKey The two points of an uncompressed key, unless sanitize is enabled
 * @param sanitize Accept public keys in other formats
 */ exports.isValidPublic = function(publicKey, sanitize) {
    if (sanitize === void 0) sanitize = false;
    if (publicKey.length === 64) // Convert to SEC1 for secp256k1
    return secp256k1.publicKeyVerify(Buffer.concat([
        Buffer.from([
            4
        ]),
        publicKey
    ]));
    if (!sanitize) return false;
    return secp256k1.publicKeyVerify(publicKey);
};
/**
 * Returns the ethereum address of a given public key.
 * Accepts "Ethereum public keys" and SEC1 encoded keys.
 * @param pubKey The two points of an uncompressed key, unless sanitize is enabled
 * @param sanitize Accept public keys in other formats
 */ exports.pubToAddress = function(pubKey, sanitize) {
    if (sanitize === void 0) sanitize = false;
    pubKey = bytes_1.toBuffer(pubKey);
    if (sanitize && pubKey.length !== 64) pubKey = secp256k1.publicKeyConvert(pubKey, false).slice(1);
    assert(pubKey.length === 64);
    // Only take the lower 160bits of the hash
    return hash_1.keccak(pubKey).slice(-20);
};
exports.publicToAddress = exports.pubToAddress;
/**
 * Returns the ethereum address of a given private key.
 * @param privateKey A private key must be 256 bits wide
 */ exports.privateToAddress = function(privateKey) {
    return exports.publicToAddress(exports.privateToPublic(privateKey));
};
/**
 * Returns the ethereum public key of a given private key.
 * @param privateKey A private key must be 256 bits wide
 */ exports.privateToPublic = function(privateKey) {
    privateKey = bytes_1.toBuffer(privateKey);
    // skip the type flag and use the X, Y points
    return secp256k1.publicKeyCreate(privateKey, false).slice(1);
};
/**
 * Converts a public key to the Ethereum format.
 */ exports.importPublic = function(publicKey) {
    publicKey = bytes_1.toBuffer(publicKey);
    if (publicKey.length !== 64) publicKey = secp256k1.publicKeyConvert(publicKey, false).slice(1);
    return publicKey;
};

},{"3c536b65da5a001f":"l5Twm","b3a30c006a03d930":"jRkR3","de69eaa8bfdb7e26":"4yJO4","14569cad8609ccee":"gEjJU","4b223fbf118b91df":"x4ItY","5c3879b7f9d60b84":"2QBIO","f831afda047afc4b":"hfyb4"}],"2QBIO":[function(require,module,exports) {
var Buffer = require("9a058508231a31dd").Buffer;
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.baToJSON = exports.addHexPrefix = exports.toUnsigned = exports.fromSigned = exports.bufferToHex = exports.bufferToInt = exports.toBuffer = exports.stripZeros = exports.unpad = exports.setLengthRight = exports.setLength = exports.setLengthLeft = exports.zeros = void 0;
var ethjsUtil = require("6ef8313941b3659f");
var BN = require("6c8fe0198b2faa69");
/**
 * Returns a buffer filled with 0s.
 * @param bytes the number of bytes the buffer should be
 */ exports.zeros = function(bytes) {
    return Buffer.allocUnsafe(bytes).fill(0);
};
/**
 * Left Pads an `Array` or `Buffer` with leading zeros till it has `length` bytes.
 * Or it truncates the beginning if it exceeds.
 * @param msg the value to pad (Buffer|Array)
 * @param length the number of bytes the output should be
 * @param right whether to start padding form the left or right
 * @return (Buffer|Array)
 */ exports.setLengthLeft = function(msg, length, right) {
    if (right === void 0) right = false;
    var buf = exports.zeros(length);
    msg = exports.toBuffer(msg);
    if (right) {
        if (msg.length < length) {
            msg.copy(buf);
            return buf;
        }
        return msg.slice(0, length);
    } else {
        if (msg.length < length) {
            msg.copy(buf, length - msg.length);
            return buf;
        }
        return msg.slice(-length);
    }
};
exports.setLength = exports.setLengthLeft;
/**
 * Right Pads an `Array` or `Buffer` with leading zeros till it has `length` bytes.
 * Or it truncates the beginning if it exceeds.
 * @param msg the value to pad (Buffer|Array)
 * @param length the number of bytes the output should be
 * @return (Buffer|Array)
 */ exports.setLengthRight = function(msg, length) {
    return exports.setLength(msg, length, true);
};
/**
 * Trims leading zeros from a `Buffer` or an `Array`.
 * @param a (Buffer|Array|String)
 * @return (Buffer|Array|String)
 */ exports.unpad = function(a) {
    a = ethjsUtil.stripHexPrefix(a);
    var first = a[0];
    while(a.length > 0 && first.toString() === "0"){
        a = a.slice(1);
        first = a[0];
    }
    return a;
};
exports.stripZeros = exports.unpad;
/**
 * Attempts to turn a value into a `Buffer`. As input it supports `Buffer`, `String`, `Number`, null/undefined, `BN` and other objects with a `toArray()` method.
 * @param v the value
 */ exports.toBuffer = function(v) {
    if (!Buffer.isBuffer(v)) {
        if (Array.isArray(v)) v = Buffer.from(v);
        else if (typeof v === "string") {
            if (ethjsUtil.isHexString(v)) v = Buffer.from(ethjsUtil.padToEven(ethjsUtil.stripHexPrefix(v)), "hex");
            else throw new Error("Cannot convert string to buffer. toBuffer only supports 0x-prefixed hex strings and this string was given: " + v);
        } else if (typeof v === "number") v = ethjsUtil.intToBuffer(v);
        else if (v === null || v === undefined) v = Buffer.allocUnsafe(0);
        else if (BN.isBN(v)) v = v.toArrayLike(Buffer);
        else if (v.toArray) // converts a BN to a Buffer
        v = Buffer.from(v.toArray());
        else throw new Error("invalid type");
    }
    return v;
};
/**
 * Converts a `Buffer` to a `Number`.
 * @param buf `Buffer` object to convert
 * @throws If the input number exceeds 53 bits.
 */ exports.bufferToInt = function(buf) {
    return new BN(exports.toBuffer(buf)).toNumber();
};
/**
 * Converts a `Buffer` into a `0x`-prefixed hex `String`.
 * @param buf `Buffer` object to convert
 */ exports.bufferToHex = function(buf) {
    buf = exports.toBuffer(buf);
    return "0x" + buf.toString("hex");
};
/**
 * Interprets a `Buffer` as a signed integer and returns a `BN`. Assumes 256-bit numbers.
 * @param num Signed integer value
 */ exports.fromSigned = function(num) {
    return new BN(num).fromTwos(256);
};
/**
 * Converts a `BN` to an unsigned integer and returns it as a `Buffer`. Assumes 256-bit numbers.
 * @param num
 */ exports.toUnsigned = function(num) {
    return Buffer.from(num.toTwos(256).toArray());
};
/**
 * Adds "0x" to a given `String` if it does not already start with "0x".
 */ exports.addHexPrefix = function(str) {
    if (typeof str !== "string") return str;
    return ethjsUtil.isHexPrefixed(str) ? str : "0x" + str;
};
/**
 * Converts a `Buffer` or `Array` to JSON.
 * @param ba (Buffer|Array)
 * @return (Array|String|null)
 */ exports.baToJSON = function(ba) {
    if (Buffer.isBuffer(ba)) return "0x" + ba.toString("hex");
    else if (ba instanceof Array) {
        var array = [];
        for(var i = 0; i < ba.length; i++)array.push(exports.baToJSON(ba[i]));
        return array;
    }
};

},{"9a058508231a31dd":"l5Twm","6ef8313941b3659f":"4yJO4","6c8fe0198b2faa69":"x4ItY"}],"hfyb4":[function(require,module,exports) {
var Buffer = require("36ccc0ffe5795b82").Buffer;
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.rlphash = exports.ripemd160 = exports.sha256 = exports.keccak256 = exports.keccak = void 0;
var _a = require("70b6ba1692bcd937"), keccak224 = _a.keccak224, keccak384 = _a.keccak384, k256 = _a.keccak256, keccak512 = _a.keccak512;
var createHash = require("499bcc46fca1cae7");
var ethjsUtil = require("9ff721fd94d62634");
var rlp = require("bd150625b070154a");
var bytes_1 = require("a802f51e560195c7");
/**
 * Creates Keccak hash of the input
 * @param a The input data (Buffer|Array|String|Number) If the string is a 0x-prefixed hex value
 * it's interpreted as hexadecimal, otherwise as utf8.
 * @param bits The Keccak width
 */ exports.keccak = function(a, bits) {
    if (bits === void 0) bits = 256;
    if (typeof a === "string" && !ethjsUtil.isHexString(a)) a = Buffer.from(a, "utf8");
    else a = bytes_1.toBuffer(a);
    if (!bits) bits = 256;
    switch(bits){
        case 224:
            return keccak224(a);
        case 256:
            return k256(a);
        case 384:
            return keccak384(a);
        case 512:
            return keccak512(a);
        default:
            throw new Error("Invald algorithm: keccak" + bits);
    }
};
/**
 * Creates Keccak-256 hash of the input, alias for keccak(a, 256).
 * @param a The input data (Buffer|Array|String|Number)
 */ exports.keccak256 = function(a) {
    return exports.keccak(a);
};
/**
 * Creates SHA256 hash of the input.
 * @param a The input data (Buffer|Array|String|Number)
 */ exports.sha256 = function(a) {
    a = bytes_1.toBuffer(a);
    return createHash("sha256").update(a).digest();
};
/**
 * Creates RIPEMD160 hash of the input.
 * @param a The input data (Buffer|Array|String|Number)
 * @param padded Whether it should be padded to 256 bits or not
 */ exports.ripemd160 = function(a, padded) {
    a = bytes_1.toBuffer(a);
    var hash = createHash("rmd160").update(a).digest();
    if (padded === true) return bytes_1.setLength(hash, 32);
    else return hash;
};
/**
 * Creates SHA-3 hash of the RLP encoded version of the input.
 * @param a The input data
 */ exports.rlphash = function(a) {
    return exports.keccak(rlp.encode(a));
};

},{"36ccc0ffe5795b82":"l5Twm","70b6ba1692bcd937":"5TnJC","499bcc46fca1cae7":"iwHvk","9ff721fd94d62634":"4yJO4","bd150625b070154a":"iee6k","a802f51e560195c7":"2QBIO"}],"i0fkn":[function(require,module,exports) {
var Buffer = require("3fdd78cbd8fedcb5").Buffer;
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.hashPersonalMessage = exports.isValidSignature = exports.fromRpcSig = exports.toRpcSig = exports.ecrecover = exports.ecsign = void 0;
var secp256k1 = require("f7569b2c668e0c06");
var BN = require("19d72ada92d2c20f");
var bytes_1 = require("fd1eab96d44571e9");
var hash_1 = require("58e9d68cc6bd7878");
/**
 * Returns the ECDSA signature of a message hash.
 */ exports.ecsign = function(msgHash, privateKey, chainId) {
    var sig = secp256k1.sign(msgHash, privateKey);
    var recovery = sig.recovery;
    var ret = {
        r: sig.signature.slice(0, 32),
        s: sig.signature.slice(32, 64),
        v: chainId ? recovery + (chainId * 2 + 35) : recovery + 27
    };
    return ret;
};
/**
 * ECDSA public key recovery from signature.
 * @returns Recovered public key
 */ exports.ecrecover = function(msgHash, v, r, s, chainId) {
    var signature = Buffer.concat([
        bytes_1.setLength(r, 32),
        bytes_1.setLength(s, 32)
    ], 64);
    var recovery = calculateSigRecovery(v, chainId);
    if (!isValidSigRecovery(recovery)) throw new Error("Invalid signature v value");
    var senderPubKey = secp256k1.recover(msgHash, signature, recovery);
    return secp256k1.publicKeyConvert(senderPubKey, false).slice(1);
};
/**
 * Convert signature parameters into the format of `eth_sign` RPC method.
 * @returns Signature
 */ exports.toRpcSig = function(v, r, s, chainId) {
    var recovery = calculateSigRecovery(v, chainId);
    if (!isValidSigRecovery(recovery)) throw new Error("Invalid signature v value");
    // geth (and the RPC eth_sign method) uses the 65 byte format used by Bitcoin
    return bytes_1.bufferToHex(Buffer.concat([
        bytes_1.setLengthLeft(r, 32),
        bytes_1.setLengthLeft(s, 32),
        bytes_1.toBuffer(v)
    ]));
};
/**
 * Convert signature format of the `eth_sign` RPC method to signature parameters
 * NOTE: all because of a bug in geth: https://github.com/ethereum/go-ethereum/issues/2053
 */ exports.fromRpcSig = function(sig) {
    var buf = bytes_1.toBuffer(sig);
    // NOTE: with potential introduction of chainId this might need to be updated
    if (buf.length !== 65) throw new Error("Invalid signature length");
    var v = buf[64];
    // support both versions of `eth_sign` responses
    if (v < 27) v += 27;
    return {
        v: v,
        r: buf.slice(0, 32),
        s: buf.slice(32, 64)
    };
};
/**
 * Validate a ECDSA signature.
 * @param homesteadOrLater Indicates whether this is being used on either the homestead hardfork or a later one
 */ exports.isValidSignature = function(v, r, s, homesteadOrLater, chainId) {
    if (homesteadOrLater === void 0) homesteadOrLater = true;
    var SECP256K1_N_DIV_2 = new BN("7fffffffffffffffffffffffffffffff5d576e7357a4501ddfe92f46681b20a0", 16);
    var SECP256K1_N = new BN("fffffffffffffffffffffffffffffffebaaedce6af48a03bbfd25e8cd0364141", 16);
    if (r.length !== 32 || s.length !== 32) return false;
    if (!isValidSigRecovery(calculateSigRecovery(v, chainId))) return false;
    var rBN = new BN(r);
    var sBN = new BN(s);
    if (rBN.isZero() || rBN.gt(SECP256K1_N) || sBN.isZero() || sBN.gt(SECP256K1_N)) return false;
    if (homesteadOrLater && sBN.cmp(SECP256K1_N_DIV_2) === 1) return false;
    return true;
};
/**
 * Returns the keccak-256 hash of `message`, prefixed with the header used by the `eth_sign` RPC call.
 * The output of this function can be fed into `ecsign` to produce the same signature as the `eth_sign`
 * call for a given `message`, or fed to `ecrecover` along with a signature to recover the public key
 * used to produce the signature.
 */ exports.hashPersonalMessage = function(message) {
    var prefix = Buffer.from("\x19Ethereum Signed Message:\n" + message.length.toString(), "utf-8");
    return hash_1.keccak(Buffer.concat([
        prefix,
        message
    ]));
};
function calculateSigRecovery(v, chainId) {
    return chainId ? v - (2 * chainId + 35) : v - 27;
}
function isValidSigRecovery(recovery) {
    return recovery === 0 || recovery === 1;
}

},{"3fdd78cbd8fedcb5":"l5Twm","f7569b2c668e0c06":"gEjJU","19d72ada92d2c20f":"x4ItY","fd1eab96d44571e9":"2QBIO","58e9d68cc6bd7878":"hfyb4"}],"1twJ5":[function(require,module,exports) {
var Buffer = require("7ca9530db70b71a1").Buffer;
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.defineProperties = void 0;
var assert = require("6092321f6f8c3990");
var ethjsUtil = require("de752d8872d2bf6b");
var rlp = require("f1705319b847c664");
var bytes_1 = require("e0e23ed80cb061a7");
/**
 * Defines properties on a `Object`. It make the assumption that underlying data is binary.
 * @param self the `Object` to define properties on
 * @param fields an array fields to define. Fields can contain:
 * * `name` - the name of the properties
 * * `length` - the number of bytes the field can have
 * * `allowLess` - if the field can be less than the length
 * * `allowEmpty`
 * @param data data to be validated against the definitions
 * @deprecated
 */ exports.defineProperties = function(self, fields, data) {
    self.raw = [];
    self._fields = [];
    // attach the `toJSON`
    self.toJSON = function(label) {
        if (label === void 0) label = false;
        if (label) {
            var obj_1 = {};
            self._fields.forEach(function(field) {
                obj_1[field] = "0x" + self[field].toString("hex");
            });
            return obj_1;
        }
        return bytes_1.baToJSON(self.raw);
    };
    self.serialize = function serialize() {
        return rlp.encode(self.raw);
    };
    fields.forEach(function(field, i) {
        self._fields.push(field.name);
        function getter() {
            return self.raw[i];
        }
        function setter(v) {
            v = bytes_1.toBuffer(v);
            if (v.toString("hex") === "00" && !field.allowZero) v = Buffer.allocUnsafe(0);
            if (field.allowLess && field.length) {
                v = bytes_1.stripZeros(v);
                assert(field.length >= v.length, "The field " + field.name + " must not have more " + field.length + " bytes");
            } else if (!(field.allowZero && v.length === 0) && field.length) assert(field.length === v.length, "The field " + field.name + " must have byte length of " + field.length);
            self.raw[i] = v;
        }
        Object.defineProperty(self, field.name, {
            enumerable: true,
            configurable: true,
            get: getter,
            set: setter
        });
        if (field.default) self[field.name] = field.default;
        // attach alias
        if (field.alias) Object.defineProperty(self, field.alias, {
            enumerable: false,
            configurable: true,
            set: setter,
            get: getter
        });
    });
    // if the constuctor is passed data
    if (data) {
        if (typeof data === "string") data = Buffer.from(ethjsUtil.stripHexPrefix(data), "hex");
        if (Buffer.isBuffer(data)) data = rlp.decode(data);
        if (Array.isArray(data)) {
            if (data.length > self._fields.length) throw new Error("wrong number of fields in data");
            // make sure all the items are buffers
            data.forEach(function(d, i) {
                self[self._fields[i]] = bytes_1.toBuffer(d);
            });
        } else if (typeof data === "object") {
            var keys_1 = Object.keys(data);
            fields.forEach(function(field) {
                if (keys_1.indexOf(field.name) !== -1) self[field.name] = data[field.name];
                if (keys_1.indexOf(field.alias) !== -1) self[field.alias] = data[field.alias];
            });
        } else throw new Error("invalid data");
    }
};

},{"7ca9530db70b71a1":"l5Twm","6092321f6f8c3990":"jRkR3","de752d8872d2bf6b":"4yJO4","f1705319b847c664":"iee6k","e0e23ed80cb061a7":"2QBIO"}],"57rXc":[function(require,module,exports) {
var process = require("6e1311aa7f5e924f");
(function(global) {
    "use strict";
    var nextTick = function(fn) {
        setTimeout(fn, 0);
    };
    if (typeof process != "undefined" && process && typeof process.nextTick == "function") // node.js and the like
    nextTick = process.nextTick;
    function semaphore(capacity) {
        var semaphore = {
            capacity: capacity || 1,
            current: 0,
            queue: [],
            firstHere: false,
            take: function() {
                if (semaphore.firstHere === false) {
                    semaphore.current++;
                    semaphore.firstHere = true;
                    var isFirst = 1;
                } else var isFirst = 0;
                var item = {
                    n: 1
                };
                if (typeof arguments[0] == "function") item.task = arguments[0];
                else item.n = arguments[0];
                if (arguments.length >= 2) {
                    if (typeof arguments[1] == "function") item.task = arguments[1];
                    else item.n = arguments[1];
                }
                var task = item.task;
                item.task = function() {
                    task(semaphore.leave);
                };
                if (semaphore.current + item.n - isFirst > semaphore.capacity) {
                    if (isFirst === 1) {
                        semaphore.current--;
                        semaphore.firstHere = false;
                    }
                    return semaphore.queue.push(item);
                }
                semaphore.current += item.n - isFirst;
                item.task(semaphore.leave);
                if (isFirst === 1) semaphore.firstHere = false;
            },
            leave: function(n) {
                n = n || 1;
                semaphore.current -= n;
                if (!semaphore.queue.length) {
                    if (semaphore.current < 0) throw new Error("leave called too many times.");
                    return;
                }
                var item = semaphore.queue[0];
                if (item.n + semaphore.current > semaphore.capacity) return;
                semaphore.queue.shift();
                semaphore.current += item.n;
                nextTick(item.task);
            },
            available: function(n) {
                n = n || 1;
                return semaphore.current + n <= semaphore.capacity;
            }
        };
        return semaphore;
    }
    // node export
    module.exports = semaphore;
})(this);

},{"6e1311aa7f5e924f":"5QIF0"}],"LLff4":[function(require,module,exports) {
const createPayload = require("e768eb830812ab72");
module.exports = estimateGas;
/*

This is a work around for https://github.com/ethereum/go-ethereum/issues/2577

*/ function estimateGas(provider, txParams, cb) {
    provider.sendAsync(createPayload({
        method: "eth_estimateGas",
        params: [
            txParams
        ]
    }), function(err, res) {
        if (err) {
            // handle simple value transfer case
            if (err.message === "no contract code at given address") return cb(null, "0xcf08");
            else return cb(err);
        }
        cb(null, res.result);
    });
}

},{"e768eb830812ab72":"i0Ehs"}],"cKtcd":[function(require,module,exports) {
var Buffer = require("8f44e0b08c7cc9").Buffer;
const inherits = require("d4baadcf9faf8098").inherits;
const Transaction = require("d2ad73c72bb9cb6d");
const ethUtil = require("1343c5f817e71683");
const Subprovider = require("92ce64999264c751");
const blockTagForPayload = require("f5678e79b9844681").blockTagForPayload;
module.exports = NonceTrackerSubprovider;
// handles the following RPC methods:
//   eth_getTransactionCount (pending only)
//
// observes the following RPC methods:
//   eth_sendRawTransaction
//   evm_revert (to clear the nonce cache)
inherits(NonceTrackerSubprovider, Subprovider);
function NonceTrackerSubprovider(opts) {
    const self = this;
    self.nonceCache = {};
}
NonceTrackerSubprovider.prototype.handleRequest = function(payload, next, end) {
    const self = this;
    switch(payload.method){
        case "eth_getTransactionCount":
            var blockTag = blockTagForPayload(payload);
            var address = payload.params[0].toLowerCase();
            var cachedResult = self.nonceCache[address];
            // only handle requests against the 'pending' blockTag
            if (blockTag === "pending") {
                // has a result
                if (cachedResult) end(null, cachedResult);
                else next(function(err, result, cb) {
                    if (err) return cb();
                    if (self.nonceCache[address] === undefined) self.nonceCache[address] = result;
                    cb();
                });
            } else next();
            return;
        case "eth_sendRawTransaction":
            // allow the request to continue normally
            next(function(err, result, cb) {
                // only update local nonce if tx was submitted correctly
                if (err) return cb();
                // parse raw tx
                var rawTx = payload.params[0];
                var stripped = ethUtil.stripHexPrefix(rawTx);
                var rawData = Buffer.from(ethUtil.stripHexPrefix(rawTx), "hex");
                var tx = new Transaction(Buffer.from(ethUtil.stripHexPrefix(rawTx), "hex"));
                // extract address
                var address = "0x" + tx.getSenderAddress().toString("hex").toLowerCase();
                // extract nonce and increment
                var nonce = ethUtil.bufferToInt(tx.nonce);
                nonce++;
                // hexify and normalize
                var hexNonce = nonce.toString(16);
                if (hexNonce.length % 2) hexNonce = "0" + hexNonce;
                hexNonce = "0x" + hexNonce;
                // dont update our record on the nonce until the submit was successful
                // update cache
                self.nonceCache[address] = hexNonce;
                cb();
            });
            return;
        // Clear cache on a testrpc revert
        case "evm_revert":
            self.nonceCache = {};
            next();
            return;
        default:
            next();
            return;
    }
};

},{"8f44e0b08c7cc9":"l5Twm","d4baadcf9faf8098":"jInrX","d2ad73c72bb9cb6d":"2aR6G","1343c5f817e71683":"8JOz2","92ce64999264c751":"4Q1cC","f5678e79b9844681":"hrGw9"}],"2aR6G":[function(require,module,exports) {
var Buffer = require("1d1a5af706db62c").Buffer;
"use strict";
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
var ethUtil = require("5b0d31e37273e559");
var fees = require("32567011e8b27ea8");
var BN = ethUtil.BN;
// secp256k1n/2
var N_DIV_2 = new BN("7fffffffffffffffffffffffffffffff5d576e7357a4501ddfe92f46681b20a0", 16);
/**
 * Creates a new transaction object.
 *
 * @example
 * var rawTx = {
 *   nonce: '00',
 *   gasPrice: '09184e72a000',
 *   gasLimit: '2710',
 *   to: '0000000000000000000000000000000000000000',
 *   value: '00',
 *   data: '7f7465737432000000000000000000000000000000000000000000000000000000600057',
 *   v: '1c',
 *   r: '5e1d3a76fbf824220eafc8c79ad578ad2b67d01b0c2425eb1f1347e8f50882ab',
 *   s: '5bd428537f05f9830e93792f90ea6a3e2d1ee84952dd96edbae9f658f831ab13'
 * };
 * var tx = new Transaction(rawTx);
 *
 * @class
 * @param {Buffer | Array | Object} data a transaction can be initiailized with either a buffer containing the RLP serialized transaction or an array of buffers relating to each of the tx Properties, listed in order below in the exmple.
 *
 * Or lastly an Object containing the Properties of the transaction like in the Usage example.
 *
 * For Object and Arrays each of the elements can either be a Buffer, a hex-prefixed (0x) String , Number, or an object with a toBuffer method such as Bignum
 *
 * @property {Buffer} raw The raw rlp encoded transaction
 * @param {Buffer} data.nonce nonce number
 * @param {Buffer} data.gasLimit transaction gas limit
 * @param {Buffer} data.gasPrice transaction gas price
 * @param {Buffer} data.to to the to address
 * @param {Buffer} data.value the amount of ether sent
 * @param {Buffer} data.data this will contain the data of the message or the init of a contract
 * @param {Buffer} data.v EC signature parameter
 * @param {Buffer} data.r EC signature parameter
 * @param {Buffer} data.s EC recovery ID
 * @param {Number} data.chainId EIP 155 chainId - mainnet: 1, ropsten: 3
 * */ var Transaction = function() {
    function Transaction(data) {
        _classCallCheck(this, Transaction);
        data = data || {};
        // Define Properties
        var fields = [
            {
                name: "nonce",
                length: 32,
                allowLess: true,
                default: new Buffer([])
            },
            {
                name: "gasPrice",
                length: 32,
                allowLess: true,
                default: new Buffer([])
            },
            {
                name: "gasLimit",
                alias: "gas",
                length: 32,
                allowLess: true,
                default: new Buffer([])
            },
            {
                name: "to",
                allowZero: true,
                length: 20,
                default: new Buffer([])
            },
            {
                name: "value",
                length: 32,
                allowLess: true,
                default: new Buffer([])
            },
            {
                name: "data",
                alias: "input",
                allowZero: true,
                default: new Buffer([])
            },
            {
                name: "v",
                allowZero: true,
                default: new Buffer([
                    0x1c
                ])
            },
            {
                name: "r",
                length: 32,
                allowZero: true,
                allowLess: true,
                default: new Buffer([])
            },
            {
                name: "s",
                length: 32,
                allowZero: true,
                allowLess: true,
                default: new Buffer([])
            }
        ];
        /**
     * Returns the rlp encoding of the transaction
     * @method serialize
     * @return {Buffer}
     * @memberof Transaction
     * @name serialize
     */ // attached serialize
        ethUtil.defineProperties(this, fields, data);
        /**
     * @property {Buffer} from (read only) sender address of this transaction, mathematically derived from other parameters.
     * @name from
     * @memberof Transaction
     */ Object.defineProperty(this, "from", {
            enumerable: true,
            configurable: true,
            get: this.getSenderAddress.bind(this)
        });
        // calculate chainId from signature
        var sigV = ethUtil.bufferToInt(this.v);
        var chainId = Math.floor((sigV - 35) / 2);
        if (chainId < 0) chainId = 0;
        // set chainId
        this._chainId = chainId || data.chainId || 0;
        this._homestead = true;
    }
    /**
   * If the tx's `to` is to the creation address
   * @return {Boolean}
   */ Transaction.prototype.toCreationAddress = function toCreationAddress() {
        return this.to.toString("hex") === "";
    };
    /**
   * Computes a sha3-256 hash of the serialized tx
   * @param {Boolean} [includeSignature=true] whether or not to inculde the signature
   * @return {Buffer}
   */ Transaction.prototype.hash = function hash(includeSignature) {
        if (includeSignature === undefined) includeSignature = true;
        // EIP155 spec:
        // when computing the hash of a transaction for purposes of signing or recovering,
        // instead of hashing only the first six elements (ie. nonce, gasprice, startgas, to, value, data),
        // hash nine elements, with v replaced by CHAIN_ID, r = 0 and s = 0
        var items = void 0;
        if (includeSignature) items = this.raw;
        else if (this._chainId > 0) {
            var raw = this.raw.slice();
            this.v = this._chainId;
            this.r = 0;
            this.s = 0;
            items = this.raw;
            this.raw = raw;
        } else items = this.raw.slice(0, 6);
        // create hash
        return ethUtil.rlphash(items);
    };
    /**
   * returns the public key of the sender
   * @return {Buffer}
   */ Transaction.prototype.getChainId = function getChainId() {
        return this._chainId;
    };
    /**
   * returns the sender's address
   * @return {Buffer}
   */ Transaction.prototype.getSenderAddress = function getSenderAddress() {
        if (this._from) return this._from;
        var pubkey = this.getSenderPublicKey();
        this._from = ethUtil.publicToAddress(pubkey);
        return this._from;
    };
    /**
   * returns the public key of the sender
   * @return {Buffer}
   */ Transaction.prototype.getSenderPublicKey = function getSenderPublicKey() {
        if (!this._senderPubKey || !this._senderPubKey.length) {
            if (!this.verifySignature()) throw new Error("Invalid Signature");
        }
        return this._senderPubKey;
    };
    /**
   * Determines if the signature is valid
   * @return {Boolean}
   */ Transaction.prototype.verifySignature = function verifySignature() {
        var msgHash = this.hash(false);
        // All transaction signatures whose s-value is greater than secp256k1n/2 are considered invalid.
        if (this._homestead && new BN(this.s).cmp(N_DIV_2) === 1) return false;
        try {
            var v = ethUtil.bufferToInt(this.v);
            if (this._chainId > 0) v -= this._chainId * 2 + 8;
            this._senderPubKey = ethUtil.ecrecover(msgHash, v, this.r, this.s);
        } catch (e) {
            return false;
        }
        return !!this._senderPubKey;
    };
    /**
   * sign a transaction with a given a private key
   * @param {Buffer} privateKey
   */ Transaction.prototype.sign = function sign(privateKey) {
        var msgHash = this.hash(false);
        var sig = ethUtil.ecsign(msgHash, privateKey);
        if (this._chainId > 0) sig.v += this._chainId * 2 + 8;
        Object.assign(this, sig);
    };
    /**
   * The amount of gas paid for the data in this tx
   * @return {BN}
   */ Transaction.prototype.getDataFee = function getDataFee() {
        var data = this.raw[5];
        var cost = new BN(0);
        for(var i = 0; i < data.length; i++)data[i] === 0 ? cost.iaddn(fees.txDataZeroGas.v) : cost.iaddn(fees.txDataNonZeroGas.v);
        return cost;
    };
    /**
   * the minimum amount of gas the tx must have (DataFee + TxFee + Creation Fee)
   * @return {BN}
   */ Transaction.prototype.getBaseFee = function getBaseFee() {
        var fee = this.getDataFee().iaddn(fees.txGas.v);
        if (this._homestead && this.toCreationAddress()) fee.iaddn(fees.txCreation.v);
        return fee;
    };
    /**
   * the up front amount that an account must have for this transaction to be valid
   * @return {BN}
   */ Transaction.prototype.getUpfrontCost = function getUpfrontCost() {
        return new BN(this.gasLimit).imul(new BN(this.gasPrice)).iadd(new BN(this.value));
    };
    /**
   * validates the signature and checks to see if it has enough gas
   * @param {Boolean} [stringError=false] whether to return a string with a dscription of why the validation failed or return a Bloolean
   * @return {Boolean|String}
   */ Transaction.prototype.validate = function validate(stringError) {
        var errors = [];
        if (!this.verifySignature()) errors.push("Invalid Signature");
        if (this.getBaseFee().cmp(new BN(this.gasLimit)) > 0) errors.push([
            "gas limit is too low. Need at least " + this.getBaseFee()
        ]);
        if (stringError === undefined || stringError === false) return errors.length === 0;
        else return errors.join(" ");
    };
    return Transaction;
}();
module.exports = Transaction;

},{"1d1a5af706db62c":"l5Twm","5b0d31e37273e559":"8JOz2","32567011e8b27ea8":"arjrG"}],"arjrG":[function(require,module,exports) {
module.exports = JSON.parse('{"genesisGasLimit":{"v":5000,"d":"Gas limit of the Genesis block."},"genesisDifficulty":{"v":17179869184,"d":"Difficulty of the Genesis block."},"genesisNonce":{"v":"0x0000000000000042","d":"the geneis nonce"},"genesisExtraData":{"v":"0x11bbe8db4e347b4e8c937c1c8370e4b5ed33adb3db69cbdb7a38e1e50b1b82fa","d":"extra data "},"genesisHash":{"v":"0xd4e56740f876aef8c010b86a40d5f56745a118d0906a34e69aec8c0db1cb8fa3","d":"genesis hash"},"genesisStateRoot":{"v":"0xd7f8974fb5ac78d9ac099b9ad5018bedc2ce0a72dad1827a1709da30580f0544","d":"the genesis state root"},"minGasLimit":{"v":5000,"d":"Minimum the gas limit may ever be."},"gasLimitBoundDivisor":{"v":1024,"d":"The bound divisor of the gas limit, used in update calculations."},"minimumDifficulty":{"v":131072,"d":"The minimum that the difficulty may ever be."},"difficultyBoundDivisor":{"v":2048,"d":"The bound divisor of the difficulty, used in the update calculations."},"durationLimit":{"v":13,"d":"The decision boundary on the blocktime duration used to determine whether difficulty should go up or not."},"maximumExtraDataSize":{"v":32,"d":"Maximum size extra data may be after Genesis."},"epochDuration":{"v":30000,"d":"Duration between proof-of-work epochs."},"stackLimit":{"v":1024,"d":"Maximum size of VM stack allowed."},"callCreateDepth":{"v":1024,"d":"Maximum depth of call/create stack."},"tierStepGas":{"v":[0,2,3,5,8,10,20],"d":"Once per operation, for a selection of them."},"expGas":{"v":10,"d":"Once per EXP instuction."},"expByteGas":{"v":10,"d":"Times ceil(log256(exponent)) for the EXP instruction."},"sha3Gas":{"v":30,"d":"Once per SHA3 operation."},"sha3WordGas":{"v":6,"d":"Once per word of the SHA3 operation\'s data."},"sloadGas":{"v":50,"d":"Once per SLOAD operation."},"sstoreSetGas":{"v":20000,"d":"Once per SSTORE operation if the zeroness changes from zero."},"sstoreResetGas":{"v":5000,"d":"Once per SSTORE operation if the zeroness does not change from zero."},"sstoreRefundGas":{"v":15000,"d":"Once per SSTORE operation if the zeroness changes to zero."},"jumpdestGas":{"v":1,"d":"Refunded gas, once per SSTORE operation if the zeroness changes to zero."},"logGas":{"v":375,"d":"Per LOG* operation."},"logDataGas":{"v":8,"d":"Per byte in a LOG* operation\'s data."},"logTopicGas":{"v":375,"d":"Multiplied by the * of the LOG*, per LOG transaction. e.g. LOG0 incurs 0 * c_txLogTopicGas, LOG4 incurs 4 * c_txLogTopicGas."},"createGas":{"v":32000,"d":"Once per CREATE operation & contract-creation transaction."},"callGas":{"v":40,"d":"Once per CALL operation & message call transaction."},"callStipend":{"v":2300,"d":"Free gas given at beginning of call."},"callValueTransferGas":{"v":9000,"d":"Paid for CALL when the value transfor is non-zero."},"callNewAccountGas":{"v":25000,"d":"Paid for CALL when the destination address didn\'t exist prior."},"suicideRefundGas":{"v":24000,"d":"Refunded following a suicide operation."},"memoryGas":{"v":3,"d":"Times the address of the (highest referenced byte in memory + 1). NOTE: referencing happens on read, write and in instructions such as RETURN and CALL."},"quadCoeffDiv":{"v":512,"d":"Divisor for the quadratic particle of the memory cost equation."},"createDataGas":{"v":200,"d":""},"txGas":{"v":21000,"d":"Per transaction. NOTE: Not payable on data of calls between transactions."},"txCreation":{"v":32000,"d":"the cost of creating a contract via tx"},"txDataZeroGas":{"v":4,"d":"Per byte of data attached to a transaction that equals zero. NOTE: Not payable on data of calls between transactions."},"txDataNonZeroGas":{"v":68,"d":"Per byte of data attached to a transaction that is not equal to zero. NOTE: Not payable on data of calls between transactions."},"copyGas":{"v":3,"d":"Multiplied by the number of 32-byte words that are copied (round up) for any *COPY operation and added."},"ecrecoverGas":{"v":3000,"d":""},"sha256Gas":{"v":60,"d":""},"sha256WordGas":{"v":12,"d":""},"ripemd160Gas":{"v":600,"d":""},"ripemd160WordGas":{"v":120,"d":""},"identityGas":{"v":15,"d":""},"identityWordGas":{"v":3,"d":""},"minerReward":{"v":"5000000000000000000","d":"the amount a miner get rewarded for mining a block"},"ommerReward":{"v":"625000000000000000","d":"The amount of wei a miner of an uncle block gets for being inculded in the blockchain"},"niblingReward":{"v":"156250000000000000","d":"the amount a miner gets for inculding a uncle"},"homeSteadForkNumber":{"v":1150000,"d":"the block that the Homestead fork started at"},"homesteadRepriceForkNumber":{"v":2463000,"d":"the block that the Homestead Reprice (EIP150) fork started at"},"timebombPeriod":{"v":100000,"d":"Exponential difficulty timebomb period"},"freeBlockPeriod":{"v":2}}');

},{}],"eLZic":[function(require,module,exports) {
const ProviderSubprovider = require("97876a942be03ff6");
const createSubscriptionManager = require("f106456c0abf29ed");
class SubscriptionsSubprovider extends ProviderSubprovider {
    constructor(){
        super(({ blockTracker, provider, engine })=>{
            const { events, middleware } = createSubscriptionManager({
                blockTracker,
                provider
            });
            // forward subscription events on the engine
            events.on("notification", (data)=>engine.emit("data", null, data));
            // return the subscription install/remove middleware
            return middleware;
        });
    }
}
module.exports = SubscriptionsSubprovider;

},{"97876a942be03ff6":"6YH9w","f106456c0abf29ed":"hGF6x"}],"hGF6x":[function(require,module,exports) {
const SafeEventEmitter = require("e05d9813ea02395f").default;
const createScaffoldMiddleware = require("f415c71dd41c30d0");
const { createAsyncMiddleware } = require("bea40549fdf10d86");
const createFilterMiddleware = require("d00b1c660a757361");
const { unsafeRandomBytes, incrementHexInt } = require("cedb16e69ffe9de2");
const getBlocksForRange = require("b88382872db9bc1c");
module.exports = createSubscriptionMiddleware;
function createSubscriptionMiddleware({ blockTracker, provider }) {
    // state and utilities for handling subscriptions
    const subscriptions = {};
    const filterManager = createFilterMiddleware({
        blockTracker,
        provider
    });
    // internal flag
    let isDestroyed = false;
    // create subscriptionManager api object
    const events = new SafeEventEmitter();
    const middleware = createScaffoldMiddleware({
        eth_subscribe: createAsyncMiddleware(subscribe),
        eth_unsubscribe: createAsyncMiddleware(unsubscribe)
    });
    middleware.destroy = destroy;
    return {
        events,
        middleware
    };
    async function subscribe(req, res) {
        if (isDestroyed) throw new Error("SubscriptionManager - attempting to use after destroying");
        const subscriptionType = req.params[0];
        // subId is 16 byte hex string
        const subId = unsafeRandomBytes(16);
        // create sub
        let sub;
        switch(subscriptionType){
            case "newHeads":
                sub = createSubNewHeads({
                    subId
                });
                break;
            case "logs":
                const filterParams = req.params[1];
                const filter = await filterManager.newLogFilter(filterParams);
                sub = createSubFromFilter({
                    subId,
                    filter
                });
                break;
            default:
                throw new Error(`SubscriptionManager - unsupported subscription type "${subscriptionType}"`);
        }
        subscriptions[subId] = sub;
        res.result = subId;
        return;
        function createSubNewHeads({ subId }) {
            const sub = {
                type: subscriptionType,
                destroy: async ()=>{
                    blockTracker.removeListener("sync", sub.update);
                },
                update: async ({ oldBlock, newBlock })=>{
                    // for newHeads
                    const toBlock = newBlock;
                    const fromBlock = incrementHexInt(oldBlock);
                    const rawBlocks = await getBlocksForRange({
                        provider,
                        fromBlock,
                        toBlock
                    });
                    const results = rawBlocks.map(normalizeBlock);
                    results.forEach((value)=>{
                        _emitSubscriptionResult(subId, value);
                    });
                }
            };
            // check for subscription updates on new block
            blockTracker.on("sync", sub.update);
            return sub;
        }
        function createSubFromFilter({ subId, filter }) {
            filter.on("update", (result)=>_emitSubscriptionResult(subId, result));
            const sub = {
                type: subscriptionType,
                destroy: async ()=>{
                    return await filterManager.uninstallFilter(filter.idHex);
                }
            };
            return sub;
        }
    }
    async function unsubscribe(req, res) {
        if (isDestroyed) throw new Error("SubscriptionManager - attempting to use after destroying");
        const id = req.params[0];
        const subscription = subscriptions[id];
        // if missing, return "false" to indicate it was not removed
        if (!subscription) {
            res.result = false;
            return;
        }
        // cleanup subscription
        delete subscriptions[id];
        await subscription.destroy();
        res.result = true;
    }
    function _emitSubscriptionResult(filterIdHex, value) {
        events.emit("notification", {
            jsonrpc: "2.0",
            method: "eth_subscription",
            params: {
                subscription: filterIdHex,
                result: value
            }
        });
    }
    function destroy() {
        events.removeAllListeners();
        for(const id in subscriptions){
            subscriptions[id].destroy();
            delete subscriptions[id];
        }
        isDestroyed = true;
    }
}
function normalizeBlock(block) {
    return {
        hash: block.hash,
        parentHash: block.parentHash,
        sha3Uncles: block.sha3Uncles,
        miner: block.miner,
        stateRoot: block.stateRoot,
        transactionsRoot: block.transactionsRoot,
        receiptsRoot: block.receiptsRoot,
        logsBloom: block.logsBloom,
        difficulty: block.difficulty,
        number: block.number,
        gasLimit: block.gasLimit,
        gasUsed: block.gasUsed,
        nonce: block.nonce,
        mixHash: block.mixHash,
        timestamp: block.timestamp,
        extraData: block.extraData
    };
}

},{"e05d9813ea02395f":"9zLtp","f415c71dd41c30d0":"aQIcb","bea40549fdf10d86":"8DCJu","d00b1c660a757361":"am7WO","cedb16e69ffe9de2":"iZD0U","b88382872db9bc1c":"8Sk1d"}],"lIFqn":[function(require,module,exports) {
"use strict";
// Copyright (c) 2018-2020 WalletLink.org <https://www.walletlink.org/>
// Copyright (c) 2018-2020 Coinbase, Inc. <https://www.coinbase.com/>
// Licensed under the Apache License, version 2.0
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.WalletLink = exports.WalletLinkProvider = void 0;
const WalletLinkProvider_1 = require("8de716aecaa8a28d");
const WalletLink_1 = require("ecfac82d017260ce");
var WalletLinkProvider_2 = require("8de716aecaa8a28d");
Object.defineProperty(exports, "WalletLinkProvider", {
    enumerable: true,
    get: function() {
        return WalletLinkProvider_2.WalletLinkProvider;
    }
});
var WalletLink_2 = require("ecfac82d017260ce");
Object.defineProperty(exports, "WalletLink", {
    enumerable: true,
    get: function() {
        return WalletLink_2.WalletLink;
    }
});
exports.default = WalletLink_1.WalletLink;
if (typeof window !== "undefined") {
    window.WalletLink = WalletLink_1.WalletLink;
    window.WalletLinkProvider = WalletLinkProvider_1.WalletLinkProvider;
}

},{"8de716aecaa8a28d":"eI393","ecfac82d017260ce":"jk7GX"}],"eI393":[function(require,module,exports) {
var Buffer = require("2a72f53464b53dc0").Buffer;
"use strict";
// Copyright (c) 2018-2020 WalletLink.org <https://www.walletlink.org/>
// Copyright (c) 2018-2020 Coinbase, Inc. <https://www.coinbase.com/>
// Licensed under the Apache License, version 2.0
var __importDefault = this && this.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.WalletLinkProvider = void 0;
const safe_event_emitter_1 = __importDefault(require("1876e74c7a927bbc"));
const bn_js_1 = __importDefault(require("808063b4b4b4f2ad"));
const eth_rpc_errors_1 = require("5f5307c3bfe3eeaf");
const WalletLinkAnalytics_1 = require("eded4bae36bfaa01");
const init_1 = require("4b1506f4f0a17848");
const Session_1 = require("25fe29c718b9f425");
const WalletLinkRelayAbstract_1 = require("38f0a2ad9df8b11d");
const util_1 = require("c812befdd1591345");
const eth_eip712_util_1 = __importDefault(require("7d6adac58c164f55"));
const FilterPolyfill_1 = require("a91fd0d60cf75168");
const JSONRPC_1 = require("f9d6eef3ca741a83");
const SubscriptionManager_1 = require("66392b70889594a5");
const DEFAULT_CHAIN_ID_KEY = "DefaultChainId";
const DEFAULT_JSON_RPC_URL = "DefaultJsonRpcUrl";
// Indicates chain has been switched by switchEthereumChain or addEthereumChain request
const HAS_CHAIN_BEEN_SWITCHED_KEY = "HasChainBeenSwitched";
const HAS_CHAIN_OVERRIDDEN_FROM_RELAY = "HasChainOverriddenFromRelay";
class WalletLinkProvider extends safe_event_emitter_1.default {
    constructor(options){
        var _a;
        super();
        this._filterPolyfill = new FilterPolyfill_1.FilterPolyfill(this);
        this._subscriptionManager = new SubscriptionManager_1.SubscriptionManager(this);
        this._relay = null;
        this._addresses = [];
        this.hasMadeFirstChainChangedEmission = false;
        this._send = this.send.bind(this);
        this._sendAsync = this.sendAsync.bind(this);
        this.setProviderInfo = this.setProviderInfo.bind(this);
        this.updateProviderInfo = this.updateProviderInfo.bind(this);
        this.getChainId = this.getChainId.bind(this);
        this.setAppInfo = this.setAppInfo.bind(this);
        this.enable = this.enable.bind(this);
        this.close = this.close.bind(this);
        this.send = this.send.bind(this);
        this.sendAsync = this.sendAsync.bind(this);
        this.request = this.request.bind(this);
        this._setAddresses = this._setAddresses.bind(this);
        this.scanQRCode = this.scanQRCode.bind(this);
        this.genericRequest = this.genericRequest.bind(this);
        this._jsonRpcUrlFromOpts = options.jsonRpcUrl;
        this._overrideIsMetaMask = options.overrideIsMetaMask;
        this._relayProvider = options.relayProvider;
        this._storage = options.storage;
        this._relayEventManager = options.relayEventManager;
        this._walletLinkAnalytics = options.walletLinkAnalytics ? options.walletLinkAnalytics : new WalletLinkAnalytics_1.WalletLinkAnalytics();
        this.isCoinbaseWallet = (_a = options.overrideIsCoinbaseWallet) !== null && _a !== void 0 ? _a : true;
        const chainId = this.getChainId();
        const chainIdStr = (0, util_1.prepend0x)(chainId.toString(16));
        // indicate that we've connected, for EIP-1193 compliance
        this.emit("connect", {
            chainIdStr
        });
        const cachedAddresses = this._storage.getItem(WalletLinkRelayAbstract_1.LOCAL_STORAGE_ADDRESSES_KEY);
        if (cachedAddresses) {
            const addresses = cachedAddresses.split(" ");
            if (addresses[0] !== "") {
                this._addresses = addresses.map((address)=>(0, util_1.ensureAddressString)(address));
                this.emit("accountsChanged", addresses);
            }
        }
        this._subscriptionManager.events.on("notification", (notification)=>{
            this.emit("message", {
                type: notification.method,
                data: notification.params
            });
        });
        if (this._addresses.length > 0) this.initializeRelay();
        window.addEventListener("message", (event)=>{
            var _a;
            if (event.data.type !== "walletLinkMessage") return;
            if (event.data.data.action === "defaultChainChanged") {
                const _chainId = event.data.data.chainId;
                const jsonRpcUrl = (_a = event.data.data.jsonRpcUrl) !== null && _a !== void 0 ? _a : this.jsonRpcUrl;
                this.updateProviderInfo(jsonRpcUrl, Number(_chainId), true);
            }
        });
    }
    get selectedAddress() {
        return this._addresses[0] || undefined;
    }
    get networkVersion() {
        return this.getChainId().toString(10);
    }
    get chainId() {
        return (0, util_1.prepend0x)(this.getChainId().toString(16));
    }
    get isWalletLink() {
        return true;
    }
    /**
     * Some DApps (i.e. Alpha Homora) seem to require the window.ethereum object return
     * true for this method.
     */ get isMetaMask() {
        return this._overrideIsMetaMask;
    }
    get host() {
        return this.jsonRpcUrl;
    }
    get connected() {
        return true;
    }
    isConnected() {
        return true;
    }
    get jsonRpcUrl() {
        var _a;
        return (_a = this._storage.getItem(DEFAULT_JSON_RPC_URL)) !== null && _a !== void 0 ? _a : this._jsonRpcUrlFromOpts;
    }
    set jsonRpcUrl(value) {
        this._storage.setItem(DEFAULT_JSON_RPC_URL, value);
    }
    get isChainOverridden() {
        return this._storage.getItem(HAS_CHAIN_OVERRIDDEN_FROM_RELAY) === "true";
    }
    set isChainOverridden(value) {
        this._storage.setItem(HAS_CHAIN_OVERRIDDEN_FROM_RELAY, value.toString());
    }
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    setProviderInfo(jsonRpcUrl, chainId) {
        if (this.isChainOverridden) return;
        this.updateProviderInfo(jsonRpcUrl, this.getChainId(), false);
    }
    updateProviderInfo(jsonRpcUrl, chainId, fromRelay) {
        const hasChainSwitched = this._storage.getItem(HAS_CHAIN_BEEN_SWITCHED_KEY) === "true";
        if (hasChainSwitched && fromRelay) return;
        if (fromRelay) this.isChainOverridden = true;
        this.jsonRpcUrl = jsonRpcUrl;
        // emit chainChanged event if necessary
        const originalChainId = this.getChainId();
        this._storage.setItem(DEFAULT_CHAIN_ID_KEY, chainId.toString(10));
        const chainChanged = (0, util_1.ensureIntNumber)(chainId) !== originalChainId;
        if (chainChanged || !this.hasMadeFirstChainChangedEmission) {
            this.emit("chainChanged", this.getChainId());
            this.hasMadeFirstChainChangedEmission = true;
        }
    }
    async watchAsset(type, address, symbol, decimals, image) {
        const relay = await this.initializeRelay();
        const result = await relay.watchAsset(type, address, symbol, decimals, image).promise;
        return !!result.result;
    }
    async addEthereumChain(chainId, rpcUrls, blockExplorerUrls, chainName, iconUrls, nativeCurrency) {
        var _a, _b;
        if ((0, util_1.ensureIntNumber)(chainId) === this.getChainId()) return false;
        const relay = await this.initializeRelay();
        const res = await relay.addEthereumChain(chainId.toString(), rpcUrls, iconUrls, blockExplorerUrls, chainName, nativeCurrency).promise;
        if (((_a = res.result) === null || _a === void 0 ? void 0 : _a.isApproved) === true) {
            this._storage.setItem(HAS_CHAIN_BEEN_SWITCHED_KEY, "true");
            this.updateProviderInfo(rpcUrls[0], chainId, false);
        }
        return ((_b = res.result) === null || _b === void 0 ? void 0 : _b.isApproved) === true;
    }
    async switchEthereumChain(chainId) {
        if ((0, util_1.ensureIntNumber)(chainId) === this.getChainId()) return;
        const relay = await this.initializeRelay();
        const res = await relay.switchEthereumChain(chainId.toString(10)).promise;
        if (res.errorCode) throw eth_rpc_errors_1.ethErrors.provider.custom({
            code: res.errorCode
        });
        const switchResponse = res.result;
        if (switchResponse.isApproved && switchResponse.rpcUrl.length > 0) {
            this._storage.setItem(HAS_CHAIN_BEEN_SWITCHED_KEY, "true");
            this.updateProviderInfo(switchResponse.rpcUrl, chainId, false);
        }
    }
    setAppInfo(appName, appLogoUrl) {
        this.initializeRelay().then((relay)=>relay.setAppInfo(appName, appLogoUrl));
    }
    async enable() {
        this._walletLinkAnalytics.sendEvent(init_1.EVENTS.ETH_ACCOUNTS_STATE, {
            method: "provider::enable",
            addresses_length: this._addresses.length,
            sessionIdHash: this._relay ? Session_1.Session.hash(this._relay.session.id) : null
        });
        if (this._addresses.length > 0) return [
            ...this._addresses
        ];
        return await this._send(JSONRPC_1.JSONRPCMethod.eth_requestAccounts);
    }
    close() {
        this.initializeRelay().then((relay)=>relay.resetAndReload());
    }
    send(requestOrMethod, callbackOrParams) {
        // send<T>(method, params): Promise<T>
        if (typeof requestOrMethod === "string") {
            const method = requestOrMethod;
            const params = Array.isArray(callbackOrParams) ? callbackOrParams : callbackOrParams !== undefined ? [
                callbackOrParams
            ] : [];
            const request = {
                jsonrpc: "2.0",
                id: 0,
                method,
                params
            };
            return this._sendRequestAsync(request).then((res)=>res.result);
        }
        // send(JSONRPCRequest | JSONRPCRequest[], callback): void
        if (typeof callbackOrParams === "function") {
            const request = requestOrMethod;
            const callback = callbackOrParams;
            return this._sendAsync(request, callback);
        }
        // send(JSONRPCRequest[]): JSONRPCResponse[]
        if (Array.isArray(requestOrMethod)) {
            const requests = requestOrMethod;
            return requests.map((r)=>this._sendRequest(r));
        }
        // send(JSONRPCRequest): JSONRPCResponse
        const req = requestOrMethod;
        return this._sendRequest(req);
    }
    sendAsync(request, callback) {
        if (typeof callback !== "function") throw new Error("callback is required");
        // send(JSONRPCRequest[], callback): void
        if (Array.isArray(request)) {
            const arrayCb = callback;
            this._sendMultipleRequestsAsync(request).then((responses)=>arrayCb(null, responses)).catch((err)=>arrayCb(err, null));
            return;
        }
        // send(JSONRPCRequest, callback): void
        const cb = callback;
        this._sendRequestAsync(request).then((response)=>cb(null, response)).catch((err)=>cb(err, null));
    }
    async request(args) {
        if (!args || typeof args !== "object" || Array.isArray(args)) throw eth_rpc_errors_1.ethErrors.rpc.invalidRequest({
            message: "Expected a single, non-array, object argument.",
            data: args
        });
        const { method, params } = args;
        if (typeof method !== "string" || method.length === 0) throw eth_rpc_errors_1.ethErrors.rpc.invalidRequest({
            message: "'args.method' must be a non-empty string.",
            data: args
        });
        if (params !== undefined && !Array.isArray(params) && (typeof params !== "object" || params === null)) throw eth_rpc_errors_1.ethErrors.rpc.invalidRequest({
            message: "'args.params' must be an object or array if provided.",
            data: args
        });
        const newParams = params === undefined ? [] : params;
        // WalletLink Requests
        const id = this._relayEventManager.makeRequestId();
        const result = await this._sendRequestAsync({
            method,
            params: newParams,
            jsonrpc: "2.0",
            id
        });
        return result.result;
    }
    async scanQRCode(match) {
        const relay = await this.initializeRelay();
        const res = await relay.scanQRCode((0, util_1.ensureRegExpString)(match)).promise;
        if (typeof res.result !== "string") throw new Error("result was not a string");
        return res.result;
    }
    async genericRequest(data, action) {
        const relay = await this.initializeRelay();
        const res = await relay.genericRequest(data, action).promise;
        if (typeof res.result !== "string") throw new Error("result was not a string");
        return res.result;
    }
    supportsSubscriptions() {
        return false;
    }
    subscribe() {
        throw new Error("Subscriptions are not supported");
    }
    unsubscribe() {
        throw new Error("Subscriptions are not supported");
    }
    disconnect() {
        return true;
    }
    _sendRequest(request) {
        const response = {
            jsonrpc: "2.0",
            id: request.id
        };
        const { method } = request;
        response.result = this._handleSynchronousMethods(request);
        if (response.result === undefined) throw new Error(`WalletLink does not support calling ${method} synchronously without ` + `a callback. Please provide a callback parameter to call ${method} ` + `asynchronously.`);
        return response;
    }
    _setAddresses(addresses) {
        if (!Array.isArray(addresses)) throw new Error("addresses is not an array");
        const newAddresses = addresses.map((address)=>(0, util_1.ensureAddressString)(address));
        if (JSON.stringify(newAddresses) === JSON.stringify(this._addresses)) return;
        this._addresses = newAddresses;
        this.emit("accountsChanged", this._addresses);
        this._storage.setItem(WalletLinkRelayAbstract_1.LOCAL_STORAGE_ADDRESSES_KEY, newAddresses.join(" "));
        window.dispatchEvent(new CustomEvent("walletlink:addresses", {
            detail: this._addresses
        }));
    }
    _sendRequestAsync(request) {
        return new Promise((resolve, reject)=>{
            try {
                const syncResult = this._handleSynchronousMethods(request);
                if (syncResult !== undefined) return resolve({
                    jsonrpc: "2.0",
                    id: request.id,
                    result: syncResult
                });
                const filterPromise = this._handleAsynchronousFilterMethods(request);
                if (filterPromise !== undefined) {
                    filterPromise.then((res)=>resolve(Object.assign(Object.assign({}, res), {
                            id: request.id
                        }))).catch((err)=>reject(err));
                    return;
                }
                const subscriptionPromise = this._handleSubscriptionMethods(request);
                if (subscriptionPromise !== undefined) {
                    subscriptionPromise.then((res)=>resolve({
                            jsonrpc: "2.0",
                            id: request.id,
                            result: res.result
                        })).catch((err)=>reject(err));
                    return;
                }
            } catch (err) {
                return reject(err);
            }
            this._handleAsynchronousMethods(request).then((res)=>res && resolve(Object.assign(Object.assign({}, res), {
                    id: request.id
                }))).catch((err)=>reject(err));
        });
    }
    _sendMultipleRequestsAsync(requests) {
        return Promise.all(requests.map((r)=>this._sendRequestAsync(r)));
    }
    _handleSynchronousMethods(request) {
        const { method } = request;
        const params = request.params || [];
        switch(method){
            case JSONRPC_1.JSONRPCMethod.eth_accounts:
                return this._eth_accounts();
            case JSONRPC_1.JSONRPCMethod.eth_coinbase:
                return this._eth_coinbase();
            case JSONRPC_1.JSONRPCMethod.eth_uninstallFilter:
                return this._eth_uninstallFilter(params);
            case JSONRPC_1.JSONRPCMethod.net_version:
                return this._net_version();
            case JSONRPC_1.JSONRPCMethod.eth_chainId:
                return this._eth_chainId();
            default:
                return undefined;
        }
    }
    async _handleAsynchronousMethods(request) {
        const { method } = request;
        const params = request.params || [];
        switch(method){
            case JSONRPC_1.JSONRPCMethod.eth_requestAccounts:
                return this._eth_requestAccounts();
            case JSONRPC_1.JSONRPCMethod.eth_sign:
                return this._eth_sign(params);
            case JSONRPC_1.JSONRPCMethod.eth_ecRecover:
                return this._eth_ecRecover(params);
            case JSONRPC_1.JSONRPCMethod.personal_sign:
                return this._personal_sign(params);
            case JSONRPC_1.JSONRPCMethod.personal_ecRecover:
                return this._personal_ecRecover(params);
            case JSONRPC_1.JSONRPCMethod.eth_signTransaction:
                return this._eth_signTransaction(params);
            case JSONRPC_1.JSONRPCMethod.eth_sendRawTransaction:
                return this._eth_sendRawTransaction(params);
            case JSONRPC_1.JSONRPCMethod.eth_sendTransaction:
                return this._eth_sendTransaction(params);
            case JSONRPC_1.JSONRPCMethod.eth_signTypedData_v1:
                return this._eth_signTypedData_v1(params);
            case JSONRPC_1.JSONRPCMethod.eth_signTypedData_v2:
                return this._throwUnsupportedMethodError();
            case JSONRPC_1.JSONRPCMethod.eth_signTypedData_v3:
                return this._eth_signTypedData_v3(params);
            case JSONRPC_1.JSONRPCMethod.eth_signTypedData_v4:
            case JSONRPC_1.JSONRPCMethod.eth_signTypedData:
                return this._eth_signTypedData_v4(params);
            case JSONRPC_1.JSONRPCMethod.walletlink_arbitrary:
                return this._walletlink_arbitrary(params);
            case JSONRPC_1.JSONRPCMethod.wallet_addEthereumChain:
                return this._wallet_addEthereumChain(params);
            case JSONRPC_1.JSONRPCMethod.wallet_switchEthereumChain:
                return this._wallet_switchEthereumChain(params);
            case JSONRPC_1.JSONRPCMethod.wallet_watchAsset:
                return this._wallet_watchAsset(params);
        }
        const relay = await this.initializeRelay();
        return relay.makeEthereumJSONRPCRequest(request, this.jsonRpcUrl);
    }
    _handleAsynchronousFilterMethods(request) {
        const { method } = request;
        const params = request.params || [];
        switch(method){
            case JSONRPC_1.JSONRPCMethod.eth_newFilter:
                return this._eth_newFilter(params);
            case JSONRPC_1.JSONRPCMethod.eth_newBlockFilter:
                return this._eth_newBlockFilter();
            case JSONRPC_1.JSONRPCMethod.eth_newPendingTransactionFilter:
                return this._eth_newPendingTransactionFilter();
            case JSONRPC_1.JSONRPCMethod.eth_getFilterChanges:
                return this._eth_getFilterChanges(params);
            case JSONRPC_1.JSONRPCMethod.eth_getFilterLogs:
                return this._eth_getFilterLogs(params);
        }
        return undefined;
    }
    _handleSubscriptionMethods(request) {
        switch(request.method){
            case JSONRPC_1.JSONRPCMethod.eth_subscribe:
            case JSONRPC_1.JSONRPCMethod.eth_unsubscribe:
                return this._subscriptionManager.handleRequest(request);
        }
        return undefined;
    }
    _isKnownAddress(addressString) {
        try {
            const address = (0, util_1.ensureAddressString)(addressString);
            const lowercaseAddresses = this._addresses.map((address)=>(0, util_1.ensureAddressString)(address));
            return lowercaseAddresses.includes(address);
        } catch (_a) {}
        return false;
    }
    _ensureKnownAddress(addressString) {
        if (!this._isKnownAddress(addressString)) {
            this._walletLinkAnalytics.sendEvent(init_1.EVENTS.UNKNOWN_ADDRESS_ENCOUNTERED);
            throw new Error("Unknown Ethereum address");
        }
    }
    _prepareTransactionParams(tx) {
        const fromAddress = tx.from ? (0, util_1.ensureAddressString)(tx.from) : this.selectedAddress;
        if (!fromAddress) throw new Error("Ethereum address is unavailable");
        this._ensureKnownAddress(fromAddress);
        const toAddress = tx.to ? (0, util_1.ensureAddressString)(tx.to) : null;
        const weiValue = tx.value != null ? (0, util_1.ensureBN)(tx.value) : new bn_js_1.default(0);
        const data = tx.data ? (0, util_1.ensureBuffer)(tx.data) : Buffer.alloc(0);
        const nonce = tx.nonce != null ? (0, util_1.ensureIntNumber)(tx.nonce) : null;
        const gasPriceInWei = tx.gasPrice != null ? (0, util_1.ensureBN)(tx.gasPrice) : null;
        const maxFeePerGas = tx.maxFeePerGas != null ? (0, util_1.ensureBN)(tx.maxFeePerGas) : null;
        const maxPriorityFeePerGas = tx.maxPriorityFeePerGas != null ? (0, util_1.ensureBN)(tx.maxPriorityFeePerGas) : null;
        const gasLimit = tx.gas != null ? (0, util_1.ensureBN)(tx.gas) : null;
        const chainId = this.getChainId();
        return {
            fromAddress,
            toAddress,
            weiValue,
            data,
            nonce,
            gasPriceInWei,
            maxFeePerGas,
            maxPriorityFeePerGas,
            gasLimit,
            chainId
        };
    }
    _requireAuthorization() {
        if (this._addresses.length === 0) throw eth_rpc_errors_1.ethErrors.provider.unauthorized({});
    }
    _throwUnsupportedMethodError() {
        throw eth_rpc_errors_1.ethErrors.provider.unsupportedMethod({});
    }
    async _signEthereumMessage(message, address, addPrefix, typedDataJson) {
        this._ensureKnownAddress(address);
        try {
            const relay = await this.initializeRelay();
            const res = await relay.signEthereumMessage(message, address, addPrefix, typedDataJson).promise;
            return {
                jsonrpc: "2.0",
                id: 0,
                result: res.result
            };
        } catch (err) {
            if (typeof err.message === "string" && err.message.match(/(denied|rejected)/i)) throw eth_rpc_errors_1.ethErrors.provider.userRejectedRequest("User denied message signature");
            throw err;
        }
    }
    async _ethereumAddressFromSignedMessage(message, signature, addPrefix) {
        const relay = await this.initializeRelay();
        const res = await relay.ethereumAddressFromSignedMessage(message, signature, addPrefix).promise;
        return {
            jsonrpc: "2.0",
            id: 0,
            result: res.result
        };
    }
    _eth_accounts() {
        return [
            ...this._addresses
        ];
    }
    _eth_coinbase() {
        return this.selectedAddress || null;
    }
    _net_version() {
        return this.getChainId().toString(10);
    }
    _eth_chainId() {
        return (0, util_1.hexStringFromIntNumber)(this.getChainId());
    }
    getChainId() {
        const chainIdStr = this._storage.getItem(DEFAULT_CHAIN_ID_KEY) || "1";
        const chainId = parseInt(chainIdStr, 10);
        return (0, util_1.ensureIntNumber)(chainId);
    }
    async _eth_requestAccounts() {
        this._walletLinkAnalytics.sendEvent(init_1.EVENTS.ETH_ACCOUNTS_STATE, {
            method: "provider::_eth_requestAccounts",
            addresses_length: this._addresses.length,
            sessionIdHash: this._relay ? Session_1.Session.hash(this._relay.session.id) : null
        });
        if (this._addresses.length > 0) return Promise.resolve({
            jsonrpc: "2.0",
            id: 0,
            result: this._addresses
        });
        let res;
        try {
            const relay = await this.initializeRelay();
            res = await relay.requestEthereumAccounts().promise;
        } catch (err) {
            if (typeof err.message === "string" && err.message.match(/(denied|rejected)/i)) throw eth_rpc_errors_1.ethErrors.provider.userRejectedRequest("User denied account authorization");
            throw err;
        }
        if (!res.result) throw new Error("accounts received is empty");
        this._setAddresses(res.result);
        return {
            jsonrpc: "2.0",
            id: 0,
            result: this._addresses
        };
    }
    _eth_sign(params) {
        this._requireAuthorization();
        const address = (0, util_1.ensureAddressString)(params[0]);
        const message = (0, util_1.ensureBuffer)(params[1]);
        return this._signEthereumMessage(message, address, false);
    }
    _eth_ecRecover(params) {
        const message = (0, util_1.ensureBuffer)(params[0]);
        const signature = (0, util_1.ensureBuffer)(params[1]);
        return this._ethereumAddressFromSignedMessage(message, signature, false);
    }
    _personal_sign(params) {
        this._requireAuthorization();
        const message = (0, util_1.ensureBuffer)(params[0]);
        const address = (0, util_1.ensureAddressString)(params[1]);
        return this._signEthereumMessage(message, address, true);
    }
    _personal_ecRecover(params) {
        const message = (0, util_1.ensureBuffer)(params[0]);
        const signature = (0, util_1.ensureBuffer)(params[1]);
        return this._ethereumAddressFromSignedMessage(message, signature, true);
    }
    async _eth_signTransaction(params) {
        this._requireAuthorization();
        const tx = this._prepareTransactionParams(params[0] || {});
        try {
            const relay = await this.initializeRelay();
            const res = await relay.signEthereumTransaction(tx).promise;
            return {
                jsonrpc: "2.0",
                id: 0,
                result: res.result
            };
        } catch (err) {
            if (typeof err.message === "string" && err.message.match(/(denied|rejected)/i)) throw eth_rpc_errors_1.ethErrors.provider.userRejectedRequest("User denied transaction signature");
            throw err;
        }
    }
    async _eth_sendRawTransaction(params) {
        const signedTransaction = (0, util_1.ensureBuffer)(params[0]);
        const relay = await this.initializeRelay();
        const res = await relay.submitEthereumTransaction(signedTransaction, this.getChainId()).promise;
        return {
            jsonrpc: "2.0",
            id: 0,
            result: res.result
        };
    }
    async _eth_sendTransaction(params) {
        this._requireAuthorization();
        const tx = this._prepareTransactionParams(params[0] || {});
        try {
            const relay = await this.initializeRelay();
            const res = await relay.signAndSubmitEthereumTransaction(tx).promise;
            return {
                jsonrpc: "2.0",
                id: 0,
                result: res.result
            };
        } catch (err) {
            if (typeof err.message === "string" && err.message.match(/(denied|rejected)/i)) throw eth_rpc_errors_1.ethErrors.provider.userRejectedRequest("User denied transaction signature");
            throw err;
        }
    }
    async _eth_signTypedData_v1(params) {
        this._requireAuthorization();
        const typedData = (0, util_1.ensureParsedJSONObject)(params[0]);
        const address = (0, util_1.ensureAddressString)(params[1]);
        this._ensureKnownAddress(address);
        const message = eth_eip712_util_1.default.hashForSignTypedDataLegacy({
            data: typedData
        });
        const typedDataJSON = JSON.stringify(typedData, null, 2);
        return this._signEthereumMessage(message, address, false, typedDataJSON);
    }
    async _eth_signTypedData_v3(params) {
        this._requireAuthorization();
        const address = (0, util_1.ensureAddressString)(params[0]);
        const typedData = (0, util_1.ensureParsedJSONObject)(params[1]);
        this._ensureKnownAddress(address);
        const message = eth_eip712_util_1.default.hashForSignTypedData_v3({
            data: typedData
        });
        const typedDataJSON = JSON.stringify(typedData, null, 2);
        return this._signEthereumMessage(message, address, false, typedDataJSON);
    }
    async _eth_signTypedData_v4(params) {
        this._requireAuthorization();
        const address = (0, util_1.ensureAddressString)(params[0]);
        const typedData = (0, util_1.ensureParsedJSONObject)(params[1]);
        this._ensureKnownAddress(address);
        const message = eth_eip712_util_1.default.hashForSignTypedData_v4({
            data: typedData
        });
        const typedDataJSON = JSON.stringify(typedData, null, 2);
        return this._signEthereumMessage(message, address, false, typedDataJSON);
    }
    async _walletlink_arbitrary(params) {
        const action = params[0];
        const data = params[1];
        if (typeof data !== "string") throw new Error("parameter must be a string");
        if (typeof action !== "object" || action === null) throw new Error("parameter must be an object");
        const result = await this.genericRequest(action, data);
        return {
            jsonrpc: "2.0",
            id: 0,
            result
        };
    }
    async _wallet_addEthereumChain(params) {
        var _a, _b, _c, _d;
        const request = params[0];
        if (((_a = request.rpcUrls) === null || _a === void 0 ? void 0 : _a.length) === 0) return {
            jsonrpc: "2.0",
            id: 0,
            error: {
                code: 2,
                message: `please pass in at least 1 rpcUrl`
            }
        };
        if (!request.chainName || request.chainName.trim() === "") throw eth_rpc_errors_1.ethErrors.provider.custom({
            code: 0,
            message: "chainName is a required field"
        });
        if (!request.nativeCurrency) throw eth_rpc_errors_1.ethErrors.provider.custom({
            code: 0,
            message: "nativeCurrency is a required field"
        });
        const chainIdNumber = parseInt(request.chainId, 16);
        const success = await this.addEthereumChain(chainIdNumber, (_b = request.rpcUrls) !== null && _b !== void 0 ? _b : [], (_c = request.blockExplorerUrls) !== null && _c !== void 0 ? _c : [], request.chainName, (_d = request.iconUrls) !== null && _d !== void 0 ? _d : [], request.nativeCurrency);
        if (success) return {
            jsonrpc: "2.0",
            id: 0,
            result: null
        };
        else return {
            jsonrpc: "2.0",
            id: 0,
            error: {
                code: 2,
                message: `unable to add ethereum chain`
            }
        };
    }
    async _wallet_switchEthereumChain(params) {
        const request = params[0];
        await this.switchEthereumChain(parseInt(request.chainId, 16));
        return {
            jsonrpc: "2.0",
            id: 0,
            result: null
        };
    }
    async _wallet_watchAsset(params) {
        var _a;
        const request = Array.isArray(params) ? params[0] : params;
        if (((_a = request.type) === null || _a === void 0 ? void 0 : _a.length) === 0) throw eth_rpc_errors_1.ethErrors.rpc.invalidParams({
            message: "type is a required field"
        });
        if (request.type !== "ERC20") throw eth_rpc_errors_1.ethErrors.rpc.invalidParams({
            message: `Asset of type '${request.type}' not supported`
        });
        if (!(request === null || request === void 0 ? void 0 : request.options)) throw eth_rpc_errors_1.ethErrors.rpc.invalidParams({
            message: "options is a required field"
        });
        if (!request.options.address) throw eth_rpc_errors_1.ethErrors.rpc.invalidParams({
            message: "option address is a required option"
        });
        const { address, symbol, image, decimals } = request.options;
        const res = await this.watchAsset(request.type, address, symbol, decimals, image);
        return {
            jsonrpc: "2.0",
            id: 0,
            result: res
        };
    }
    _eth_uninstallFilter(params) {
        const filterId = (0, util_1.ensureHexString)(params[0]);
        return this._filterPolyfill.uninstallFilter(filterId);
    }
    async _eth_newFilter(params) {
        const param = params[0];
        const filterId = await this._filterPolyfill.newFilter(param);
        return {
            jsonrpc: "2.0",
            id: 0,
            result: filterId
        };
    }
    async _eth_newBlockFilter() {
        const filterId = await this._filterPolyfill.newBlockFilter();
        return {
            jsonrpc: "2.0",
            id: 0,
            result: filterId
        };
    }
    async _eth_newPendingTransactionFilter() {
        const filterId = await this._filterPolyfill.newPendingTransactionFilter();
        return {
            jsonrpc: "2.0",
            id: 0,
            result: filterId
        };
    }
    _eth_getFilterChanges(params) {
        const filterId = (0, util_1.ensureHexString)(params[0]);
        return this._filterPolyfill.getFilterChanges(filterId);
    }
    _eth_getFilterLogs(params) {
        const filterId = (0, util_1.ensureHexString)(params[0]);
        return this._filterPolyfill.getFilterLogs(filterId);
    }
    initializeRelay() {
        if (this._relay) return Promise.resolve(this._relay);
        return this._relayProvider().then((relay)=>{
            relay.setAccountsCallback((accounts)=>this._setAddresses(accounts));
            relay.setChainCallback((chainId, jsonRpcUrl)=>{
                this.updateProviderInfo(jsonRpcUrl, parseInt(chainId, 10), true);
            });
            this._relay = relay;
            return relay;
        });
    }
}
exports.WalletLinkProvider = WalletLinkProvider;

},{"2a72f53464b53dc0":"l5Twm","1876e74c7a927bbc":"9zLtp","808063b4b4b4f2ad":"4AVaT","5f5307c3bfe3eeaf":"9cATh","eded4bae36bfaa01":"2871R","4b1506f4f0a17848":"eB23X","25fe29c718b9f425":"isBWC","38f0a2ad9df8b11d":"djqpq","c812befdd1591345":"9zvgH","7d6adac58c164f55":"dBZmV","a91fd0d60cf75168":"ltLuj","f9d6eef3ca741a83":"JiY2L","66392b70889594a5":"bpQA1"}],"4AVaT":[function(require,module,exports) {
(function(module1, exports) {
    "use strict";
    // Utils
    function assert(val, msg) {
        if (!val) throw new Error(msg || "Assertion failed");
    }
    // Could use `inherits` module, but don't want to move from single file
    // architecture yet.
    function inherits(ctor, superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
    // BN
    function BN(number, base, endian) {
        if (BN.isBN(number)) return number;
        this.negative = 0;
        this.words = null;
        this.length = 0;
        // Reduction context
        this.red = null;
        if (number !== null) {
            if (base === "le" || base === "be") {
                endian = base;
                base = 10;
            }
            this._init(number || 0, base || 10, endian || "be");
        }
    }
    if (typeof module1 === "object") module1.exports = BN;
    else exports.BN = BN;
    BN.BN = BN;
    BN.wordSize = 26;
    var Buffer;
    try {
        if (typeof window !== "undefined" && typeof window.Buffer !== "undefined") Buffer = window.Buffer;
        else Buffer = require("5a29d00af494ef3a").Buffer;
    } catch (e) {}
    BN.isBN = function isBN(num) {
        if (num instanceof BN) return true;
        return num !== null && typeof num === "object" && num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
    };
    BN.max = function max(left, right) {
        if (left.cmp(right) > 0) return left;
        return right;
    };
    BN.min = function min(left, right) {
        if (left.cmp(right) < 0) return left;
        return right;
    };
    BN.prototype._init = function init(number, base, endian) {
        if (typeof number === "number") return this._initNumber(number, base, endian);
        if (typeof number === "object") return this._initArray(number, base, endian);
        if (base === "hex") base = 16;
        assert(base === (base | 0) && base >= 2 && base <= 36);
        number = number.toString().replace(/\s+/g, "");
        var start = 0;
        if (number[0] === "-") {
            start++;
            this.negative = 1;
        }
        if (start < number.length) {
            if (base === 16) this._parseHex(number, start, endian);
            else {
                this._parseBase(number, base, start);
                if (endian === "le") this._initArray(this.toArray(), base, endian);
            }
        }
    };
    BN.prototype._initNumber = function _initNumber(number, base, endian) {
        if (number < 0) {
            this.negative = 1;
            number = -number;
        }
        if (number < 0x4000000) {
            this.words = [
                number & 0x3ffffff
            ];
            this.length = 1;
        } else if (number < 0x10000000000000) {
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff
            ];
            this.length = 2;
        } else {
            assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff,
                1
            ];
            this.length = 3;
        }
        if (endian !== "le") return;
        // Reverse the bytes
        this._initArray(this.toArray(), base, endian);
    };
    BN.prototype._initArray = function _initArray(number, base, endian) {
        // Perhaps a Uint8Array
        assert(typeof number.length === "number");
        if (number.length <= 0) {
            this.words = [
                0
            ];
            this.length = 1;
            return this;
        }
        this.length = Math.ceil(number.length / 3);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        var j, w;
        var off = 0;
        if (endian === "be") for(i = number.length - 1, j = 0; i >= 0; i -= 3){
            w = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        else if (endian === "le") for(i = 0, j = 0; i < number.length; i += 3){
            w = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        return this._strip();
    };
    function parseHex4Bits(string, index) {
        var c = string.charCodeAt(index);
        // '0' - '9'
        if (c >= 48 && c <= 57) return c - 48;
        else if (c >= 65 && c <= 70) return c - 55;
        else if (c >= 97 && c <= 102) return c - 87;
        else assert(false, "Invalid character in " + string);
    }
    function parseHexByte(string, lowerBound, index) {
        var r = parseHex4Bits(string, index);
        if (index - 1 >= lowerBound) r |= parseHex4Bits(string, index - 1) << 4;
        return r;
    }
    BN.prototype._parseHex = function _parseHex(number, start, endian) {
        // Create possibly bigger array to ensure that it fits the number
        this.length = Math.ceil((number.length - start) / 6);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        // 24-bits chunks
        var off = 0;
        var j = 0;
        var w;
        if (endian === "be") for(i = number.length - 1; i >= start; i -= 2){
            w = parseHexByte(number, start, i) << off;
            this.words[j] |= w & 0x3ffffff;
            if (off >= 18) {
                off -= 18;
                j += 1;
                this.words[j] |= w >>> 26;
            } else off += 8;
        }
        else {
            var parseLength = number.length - start;
            for(i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2){
                w = parseHexByte(number, start, i) << off;
                this.words[j] |= w & 0x3ffffff;
                if (off >= 18) {
                    off -= 18;
                    j += 1;
                    this.words[j] |= w >>> 26;
                } else off += 8;
            }
        }
        this._strip();
    };
    function parseBase(str, start, end, mul) {
        var r = 0;
        var b = 0;
        var len = Math.min(str.length, end);
        for(var i = start; i < len; i++){
            var c = str.charCodeAt(i) - 48;
            r *= mul;
            // 'a'
            if (c >= 49) b = c - 49 + 0xa;
            else if (c >= 17) b = c - 17 + 0xa;
            else b = c;
            assert(c >= 0 && b < mul, "Invalid character");
            r += b;
        }
        return r;
    }
    BN.prototype._parseBase = function _parseBase(number, base, start) {
        // Initialize as zero
        this.words = [
            0
        ];
        this.length = 1;
        // Find length of limb in base
        for(var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base)limbLen++;
        limbLen--;
        limbPow = limbPow / base | 0;
        var total = number.length - start;
        var mod = total % limbLen;
        var end = Math.min(total, total - mod) + start;
        var word = 0;
        for(var i = start; i < end; i += limbLen){
            word = parseBase(number, i, i + limbLen, base);
            this.imuln(limbPow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        if (mod !== 0) {
            var pow = 1;
            word = parseBase(number, i, number.length, base);
            for(i = 0; i < mod; i++)pow *= base;
            this.imuln(pow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        this._strip();
    };
    BN.prototype.copy = function copy(dest) {
        dest.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)dest.words[i] = this.words[i];
        dest.length = this.length;
        dest.negative = this.negative;
        dest.red = this.red;
    };
    function move(dest, src) {
        dest.words = src.words;
        dest.length = src.length;
        dest.negative = src.negative;
        dest.red = src.red;
    }
    BN.prototype._move = function _move(dest) {
        move(dest, this);
    };
    BN.prototype.clone = function clone() {
        var r = new BN(null);
        this.copy(r);
        return r;
    };
    BN.prototype._expand = function _expand(size) {
        while(this.length < size)this.words[this.length++] = 0;
        return this;
    };
    // Remove leading `0` from `this`
    BN.prototype._strip = function strip() {
        while(this.length > 1 && this.words[this.length - 1] === 0)this.length--;
        return this._normSign();
    };
    BN.prototype._normSign = function _normSign() {
        // -0 = 0
        if (this.length === 1 && this.words[0] === 0) this.negative = 0;
        return this;
    };
    // Check Symbol.for because not everywhere where Symbol defined
    // See https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Symbol#Browser_compatibility
    if (typeof Symbol !== "undefined" && typeof Symbol.for === "function") try {
        BN.prototype[Symbol.for("nodejs.util.inspect.custom")] = inspect;
    } catch (e) {
        BN.prototype.inspect = inspect;
    }
    else BN.prototype.inspect = inspect;
    function inspect() {
        return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
    }
    /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */ var zeros = [
        "",
        "0",
        "00",
        "000",
        "0000",
        "00000",
        "000000",
        "0000000",
        "00000000",
        "000000000",
        "0000000000",
        "00000000000",
        "000000000000",
        "0000000000000",
        "00000000000000",
        "000000000000000",
        "0000000000000000",
        "00000000000000000",
        "000000000000000000",
        "0000000000000000000",
        "00000000000000000000",
        "000000000000000000000",
        "0000000000000000000000",
        "00000000000000000000000",
        "000000000000000000000000",
        "0000000000000000000000000"
    ];
    var groupSizes = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
    ];
    var groupBases = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        10000000,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64000000,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        24300000,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
    ];
    BN.prototype.toString = function toString(base, padding) {
        base = base || 10;
        padding = padding | 0 || 1;
        var out;
        if (base === 16 || base === "hex") {
            out = "";
            var off = 0;
            var carry = 0;
            for(var i = 0; i < this.length; i++){
                var w = this.words[i];
                var word = ((w << off | carry) & 0xffffff).toString(16);
                carry = w >>> 24 - off & 0xffffff;
                off += 2;
                if (off >= 26) {
                    off -= 26;
                    i--;
                }
                if (carry !== 0 || i !== this.length - 1) out = zeros[6 - word.length] + word + out;
                else out = word + out;
            }
            if (carry !== 0) out = carry.toString(16) + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        if (base === (base | 0) && base >= 2 && base <= 36) {
            // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
            var groupSize = groupSizes[base];
            // var groupBase = Math.pow(base, groupSize);
            var groupBase = groupBases[base];
            out = "";
            var c = this.clone();
            c.negative = 0;
            while(!c.isZero()){
                var r = c.modrn(groupBase).toString(base);
                c = c.idivn(groupBase);
                if (!c.isZero()) out = zeros[groupSize - r.length] + r + out;
                else out = r + out;
            }
            if (this.isZero()) out = "0" + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        assert(false, "Base should be between 2 and 36");
    };
    BN.prototype.toNumber = function toNumber() {
        var ret = this.words[0];
        if (this.length === 2) ret += this.words[1] * 0x4000000;
        else if (this.length === 3 && this.words[2] === 0x01) // NOTE: at this stage it is known that the top bit is set
        ret += 0x10000000000000 + this.words[1] * 0x4000000;
        else if (this.length > 2) assert(false, "Number can only safely store up to 53 bits");
        return this.negative !== 0 ? -ret : ret;
    };
    BN.prototype.toJSON = function toJSON() {
        return this.toString(16, 2);
    };
    if (Buffer) BN.prototype.toBuffer = function toBuffer(endian, length) {
        return this.toArrayLike(Buffer, endian, length);
    };
    BN.prototype.toArray = function toArray(endian, length) {
        return this.toArrayLike(Array, endian, length);
    };
    var allocate = function allocate(ArrayType, size) {
        if (ArrayType.allocUnsafe) return ArrayType.allocUnsafe(size);
        return new ArrayType(size);
    };
    BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
        this._strip();
        var byteLength = this.byteLength();
        var reqLength = length || Math.max(1, byteLength);
        assert(byteLength <= reqLength, "byte array longer than desired length");
        assert(reqLength > 0, "Requested array length <= 0");
        var res = allocate(ArrayType, reqLength);
        var postfix = endian === "le" ? "LE" : "BE";
        this["_toArrayLike" + postfix](res, byteLength);
        return res;
    };
    BN.prototype._toArrayLikeLE = function _toArrayLikeLE(res, byteLength) {
        var position = 0;
        var carry = 0;
        for(var i = 0, shift = 0; i < this.length; i++){
            var word = this.words[i] << shift | carry;
            res[position++] = word & 0xff;
            if (position < res.length) res[position++] = word >> 8 & 0xff;
            if (position < res.length) res[position++] = word >> 16 & 0xff;
            if (shift === 6) {
                if (position < res.length) res[position++] = word >> 24 & 0xff;
                carry = 0;
                shift = 0;
            } else {
                carry = word >>> 24;
                shift += 2;
            }
        }
        if (position < res.length) {
            res[position++] = carry;
            while(position < res.length)res[position++] = 0;
        }
    };
    BN.prototype._toArrayLikeBE = function _toArrayLikeBE(res, byteLength) {
        var position = res.length - 1;
        var carry = 0;
        for(var i = 0, shift = 0; i < this.length; i++){
            var word = this.words[i] << shift | carry;
            res[position--] = word & 0xff;
            if (position >= 0) res[position--] = word >> 8 & 0xff;
            if (position >= 0) res[position--] = word >> 16 & 0xff;
            if (shift === 6) {
                if (position >= 0) res[position--] = word >> 24 & 0xff;
                carry = 0;
                shift = 0;
            } else {
                carry = word >>> 24;
                shift += 2;
            }
        }
        if (position >= 0) {
            res[position--] = carry;
            while(position >= 0)res[position--] = 0;
        }
    };
    if (Math.clz32) BN.prototype._countBits = function _countBits(w) {
        return 32 - Math.clz32(w);
    };
    else BN.prototype._countBits = function _countBits(w) {
        var t = w;
        var r = 0;
        if (t >= 0x1000) {
            r += 13;
            t >>>= 13;
        }
        if (t >= 0x40) {
            r += 7;
            t >>>= 7;
        }
        if (t >= 0x8) {
            r += 4;
            t >>>= 4;
        }
        if (t >= 0x02) {
            r += 2;
            t >>>= 2;
        }
        return r + t;
    };
    BN.prototype._zeroBits = function _zeroBits(w) {
        // Short-cut
        if (w === 0) return 26;
        var t = w;
        var r = 0;
        if ((t & 0x1fff) === 0) {
            r += 13;
            t >>>= 13;
        }
        if ((t & 0x7f) === 0) {
            r += 7;
            t >>>= 7;
        }
        if ((t & 0xf) === 0) {
            r += 4;
            t >>>= 4;
        }
        if ((t & 0x3) === 0) {
            r += 2;
            t >>>= 2;
        }
        if ((t & 0x1) === 0) r++;
        return r;
    };
    // Return number of used bits in a BN
    BN.prototype.bitLength = function bitLength() {
        var w = this.words[this.length - 1];
        var hi = this._countBits(w);
        return (this.length - 1) * 26 + hi;
    };
    function toBitArray(num) {
        var w = new Array(num.bitLength());
        for(var bit = 0; bit < w.length; bit++){
            var off = bit / 26 | 0;
            var wbit = bit % 26;
            w[bit] = num.words[off] >>> wbit & 0x01;
        }
        return w;
    }
    // Number of trailing zero bits
    BN.prototype.zeroBits = function zeroBits() {
        if (this.isZero()) return 0;
        var r = 0;
        for(var i = 0; i < this.length; i++){
            var b = this._zeroBits(this.words[i]);
            r += b;
            if (b !== 26) break;
        }
        return r;
    };
    BN.prototype.byteLength = function byteLength() {
        return Math.ceil(this.bitLength() / 8);
    };
    BN.prototype.toTwos = function toTwos(width) {
        if (this.negative !== 0) return this.abs().inotn(width).iaddn(1);
        return this.clone();
    };
    BN.prototype.fromTwos = function fromTwos(width) {
        if (this.testn(width - 1)) return this.notn(width).iaddn(1).ineg();
        return this.clone();
    };
    BN.prototype.isNeg = function isNeg() {
        return this.negative !== 0;
    };
    // Return negative clone of `this`
    BN.prototype.neg = function neg() {
        return this.clone().ineg();
    };
    BN.prototype.ineg = function ineg() {
        if (!this.isZero()) this.negative ^= 1;
        return this;
    };
    // Or `num` with `this` in-place
    BN.prototype.iuor = function iuor(num) {
        while(this.length < num.length)this.words[this.length++] = 0;
        for(var i = 0; i < num.length; i++)this.words[i] = this.words[i] | num.words[i];
        return this._strip();
    };
    BN.prototype.ior = function ior(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuor(num);
    };
    // Or `num` with `this`
    BN.prototype.or = function or(num) {
        if (this.length > num.length) return this.clone().ior(num);
        return num.clone().ior(this);
    };
    BN.prototype.uor = function uor(num) {
        if (this.length > num.length) return this.clone().iuor(num);
        return num.clone().iuor(this);
    };
    // And `num` with `this` in-place
    BN.prototype.iuand = function iuand(num) {
        // b = min-length(num, this)
        var b;
        if (this.length > num.length) b = num;
        else b = this;
        for(var i = 0; i < b.length; i++)this.words[i] = this.words[i] & num.words[i];
        this.length = b.length;
        return this._strip();
    };
    BN.prototype.iand = function iand(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuand(num);
    };
    // And `num` with `this`
    BN.prototype.and = function and(num) {
        if (this.length > num.length) return this.clone().iand(num);
        return num.clone().iand(this);
    };
    BN.prototype.uand = function uand(num) {
        if (this.length > num.length) return this.clone().iuand(num);
        return num.clone().iuand(this);
    };
    // Xor `num` with `this` in-place
    BN.prototype.iuxor = function iuxor(num) {
        // a.length > b.length
        var a;
        var b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        for(var i = 0; i < b.length; i++)this.words[i] = a.words[i] ^ b.words[i];
        if (this !== a) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = a.length;
        return this._strip();
    };
    BN.prototype.ixor = function ixor(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuxor(num);
    };
    // Xor `num` with `this`
    BN.prototype.xor = function xor(num) {
        if (this.length > num.length) return this.clone().ixor(num);
        return num.clone().ixor(this);
    };
    BN.prototype.uxor = function uxor(num) {
        if (this.length > num.length) return this.clone().iuxor(num);
        return num.clone().iuxor(this);
    };
    // Not ``this`` with ``width`` bitwidth
    BN.prototype.inotn = function inotn(width) {
        assert(typeof width === "number" && width >= 0);
        var bytesNeeded = Math.ceil(width / 26) | 0;
        var bitsLeft = width % 26;
        // Extend the buffer with leading zeroes
        this._expand(bytesNeeded);
        if (bitsLeft > 0) bytesNeeded--;
        // Handle complete words
        for(var i = 0; i < bytesNeeded; i++)this.words[i] = ~this.words[i] & 0x3ffffff;
        // Handle the residue
        if (bitsLeft > 0) this.words[i] = ~this.words[i] & 0x3ffffff >> 26 - bitsLeft;
        // And remove leading zeroes
        return this._strip();
    };
    BN.prototype.notn = function notn(width) {
        return this.clone().inotn(width);
    };
    // Set `bit` of `this`
    BN.prototype.setn = function setn(bit, val) {
        assert(typeof bit === "number" && bit >= 0);
        var off = bit / 26 | 0;
        var wbit = bit % 26;
        this._expand(off + 1);
        if (val) this.words[off] = this.words[off] | 1 << wbit;
        else this.words[off] = this.words[off] & ~(1 << wbit);
        return this._strip();
    };
    // Add `num` to `this` in-place
    BN.prototype.iadd = function iadd(num) {
        var r;
        // negative + positive
        if (this.negative !== 0 && num.negative === 0) {
            this.negative = 0;
            r = this.isub(num);
            this.negative ^= 1;
            return this._normSign();
        // positive + negative
        } else if (this.negative === 0 && num.negative !== 0) {
            num.negative = 0;
            r = this.isub(num);
            num.negative = 1;
            return r._normSign();
        }
        // a.length > b.length
        var a, b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        this.length = a.length;
        if (carry !== 0) {
            this.words[this.length] = carry;
            this.length++;
        // Copy the rest of the words
        } else if (a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        return this;
    };
    // Add `num` to `this`
    BN.prototype.add = function add(num) {
        var res;
        if (num.negative !== 0 && this.negative === 0) {
            num.negative = 0;
            res = this.sub(num);
            num.negative ^= 1;
            return res;
        } else if (num.negative === 0 && this.negative !== 0) {
            this.negative = 0;
            res = num.sub(this);
            this.negative = 1;
            return res;
        }
        if (this.length > num.length) return this.clone().iadd(num);
        return num.clone().iadd(this);
    };
    // Subtract `num` from `this` in-place
    BN.prototype.isub = function isub(num) {
        // this - (-num) = this + num
        if (num.negative !== 0) {
            num.negative = 0;
            var r = this.iadd(num);
            num.negative = 1;
            return r._normSign();
        // -this - num = -(this + num)
        } else if (this.negative !== 0) {
            this.negative = 0;
            this.iadd(num);
            this.negative = 1;
            return this._normSign();
        }
        // At this point both numbers are positive
        var cmp = this.cmp(num);
        // Optimization - zeroify
        if (cmp === 0) {
            this.negative = 0;
            this.length = 1;
            this.words[0] = 0;
            return this;
        }
        // a > b
        var a, b;
        if (cmp > 0) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        // Copy rest of the words
        if (carry === 0 && i < a.length && a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = Math.max(this.length, i);
        if (a !== this) this.negative = 1;
        return this._strip();
    };
    // Subtract `num` from `this`
    BN.prototype.sub = function sub(num) {
        return this.clone().isub(num);
    };
    function smallMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        var len = self.length + num.length | 0;
        out.length = len;
        len = len - 1 | 0;
        // Peel one iteration (compiler can't do it, because of code complexity)
        var a = self.words[0] | 0;
        var b = num.words[0] | 0;
        var r = a * b;
        var lo = r & 0x3ffffff;
        var carry = r / 0x4000000 | 0;
        out.words[0] = lo;
        for(var k = 1; k < len; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = carry >>> 26;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j | 0;
                a = self.words[i] | 0;
                b = num.words[j] | 0;
                r = a * b + rword;
                ncarry += r / 0x4000000 | 0;
                rword = r & 0x3ffffff;
            }
            out.words[k] = rword | 0;
            carry = ncarry | 0;
        }
        if (carry !== 0) out.words[k] = carry | 0;
        else out.length--;
        return out._strip();
    }
    // TODO(indutny): it may be reasonable to omit it for users who don't need
    // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
    // multiplication (like elliptic secp256k1).
    var comb10MulTo = function comb10MulTo(self, num, out) {
        var a = self.words;
        var b = num.words;
        var o = out.words;
        var c = 0;
        var lo;
        var mid;
        var hi;
        var a0 = a[0] | 0;
        var al0 = a0 & 0x1fff;
        var ah0 = a0 >>> 13;
        var a1 = a[1] | 0;
        var al1 = a1 & 0x1fff;
        var ah1 = a1 >>> 13;
        var a2 = a[2] | 0;
        var al2 = a2 & 0x1fff;
        var ah2 = a2 >>> 13;
        var a3 = a[3] | 0;
        var al3 = a3 & 0x1fff;
        var ah3 = a3 >>> 13;
        var a4 = a[4] | 0;
        var al4 = a4 & 0x1fff;
        var ah4 = a4 >>> 13;
        var a5 = a[5] | 0;
        var al5 = a5 & 0x1fff;
        var ah5 = a5 >>> 13;
        var a6 = a[6] | 0;
        var al6 = a6 & 0x1fff;
        var ah6 = a6 >>> 13;
        var a7 = a[7] | 0;
        var al7 = a7 & 0x1fff;
        var ah7 = a7 >>> 13;
        var a8 = a[8] | 0;
        var al8 = a8 & 0x1fff;
        var ah8 = a8 >>> 13;
        var a9 = a[9] | 0;
        var al9 = a9 & 0x1fff;
        var ah9 = a9 >>> 13;
        var b0 = b[0] | 0;
        var bl0 = b0 & 0x1fff;
        var bh0 = b0 >>> 13;
        var b1 = b[1] | 0;
        var bl1 = b1 & 0x1fff;
        var bh1 = b1 >>> 13;
        var b2 = b[2] | 0;
        var bl2 = b2 & 0x1fff;
        var bh2 = b2 >>> 13;
        var b3 = b[3] | 0;
        var bl3 = b3 & 0x1fff;
        var bh3 = b3 >>> 13;
        var b4 = b[4] | 0;
        var bl4 = b4 & 0x1fff;
        var bh4 = b4 >>> 13;
        var b5 = b[5] | 0;
        var bl5 = b5 & 0x1fff;
        var bh5 = b5 >>> 13;
        var b6 = b[6] | 0;
        var bl6 = b6 & 0x1fff;
        var bh6 = b6 >>> 13;
        var b7 = b[7] | 0;
        var bl7 = b7 & 0x1fff;
        var bh7 = b7 >>> 13;
        var b8 = b[8] | 0;
        var bl8 = b8 & 0x1fff;
        var bh8 = b8 >>> 13;
        var b9 = b[9] | 0;
        var bl9 = b9 & 0x1fff;
        var bh9 = b9 >>> 13;
        out.negative = self.negative ^ num.negative;
        out.length = 19;
        /* k = 0 */ lo = Math.imul(al0, bl0);
        mid = Math.imul(al0, bh0);
        mid = mid + Math.imul(ah0, bl0) | 0;
        hi = Math.imul(ah0, bh0);
        var w0 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
        w0 &= 0x3ffffff;
        /* k = 1 */ lo = Math.imul(al1, bl0);
        mid = Math.imul(al1, bh0);
        mid = mid + Math.imul(ah1, bl0) | 0;
        hi = Math.imul(ah1, bh0);
        lo = lo + Math.imul(al0, bl1) | 0;
        mid = mid + Math.imul(al0, bh1) | 0;
        mid = mid + Math.imul(ah0, bl1) | 0;
        hi = hi + Math.imul(ah0, bh1) | 0;
        var w1 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
        w1 &= 0x3ffffff;
        /* k = 2 */ lo = Math.imul(al2, bl0);
        mid = Math.imul(al2, bh0);
        mid = mid + Math.imul(ah2, bl0) | 0;
        hi = Math.imul(ah2, bh0);
        lo = lo + Math.imul(al1, bl1) | 0;
        mid = mid + Math.imul(al1, bh1) | 0;
        mid = mid + Math.imul(ah1, bl1) | 0;
        hi = hi + Math.imul(ah1, bh1) | 0;
        lo = lo + Math.imul(al0, bl2) | 0;
        mid = mid + Math.imul(al0, bh2) | 0;
        mid = mid + Math.imul(ah0, bl2) | 0;
        hi = hi + Math.imul(ah0, bh2) | 0;
        var w2 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
        w2 &= 0x3ffffff;
        /* k = 3 */ lo = Math.imul(al3, bl0);
        mid = Math.imul(al3, bh0);
        mid = mid + Math.imul(ah3, bl0) | 0;
        hi = Math.imul(ah3, bh0);
        lo = lo + Math.imul(al2, bl1) | 0;
        mid = mid + Math.imul(al2, bh1) | 0;
        mid = mid + Math.imul(ah2, bl1) | 0;
        hi = hi + Math.imul(ah2, bh1) | 0;
        lo = lo + Math.imul(al1, bl2) | 0;
        mid = mid + Math.imul(al1, bh2) | 0;
        mid = mid + Math.imul(ah1, bl2) | 0;
        hi = hi + Math.imul(ah1, bh2) | 0;
        lo = lo + Math.imul(al0, bl3) | 0;
        mid = mid + Math.imul(al0, bh3) | 0;
        mid = mid + Math.imul(ah0, bl3) | 0;
        hi = hi + Math.imul(ah0, bh3) | 0;
        var w3 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
        w3 &= 0x3ffffff;
        /* k = 4 */ lo = Math.imul(al4, bl0);
        mid = Math.imul(al4, bh0);
        mid = mid + Math.imul(ah4, bl0) | 0;
        hi = Math.imul(ah4, bh0);
        lo = lo + Math.imul(al3, bl1) | 0;
        mid = mid + Math.imul(al3, bh1) | 0;
        mid = mid + Math.imul(ah3, bl1) | 0;
        hi = hi + Math.imul(ah3, bh1) | 0;
        lo = lo + Math.imul(al2, bl2) | 0;
        mid = mid + Math.imul(al2, bh2) | 0;
        mid = mid + Math.imul(ah2, bl2) | 0;
        hi = hi + Math.imul(ah2, bh2) | 0;
        lo = lo + Math.imul(al1, bl3) | 0;
        mid = mid + Math.imul(al1, bh3) | 0;
        mid = mid + Math.imul(ah1, bl3) | 0;
        hi = hi + Math.imul(ah1, bh3) | 0;
        lo = lo + Math.imul(al0, bl4) | 0;
        mid = mid + Math.imul(al0, bh4) | 0;
        mid = mid + Math.imul(ah0, bl4) | 0;
        hi = hi + Math.imul(ah0, bh4) | 0;
        var w4 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
        w4 &= 0x3ffffff;
        /* k = 5 */ lo = Math.imul(al5, bl0);
        mid = Math.imul(al5, bh0);
        mid = mid + Math.imul(ah5, bl0) | 0;
        hi = Math.imul(ah5, bh0);
        lo = lo + Math.imul(al4, bl1) | 0;
        mid = mid + Math.imul(al4, bh1) | 0;
        mid = mid + Math.imul(ah4, bl1) | 0;
        hi = hi + Math.imul(ah4, bh1) | 0;
        lo = lo + Math.imul(al3, bl2) | 0;
        mid = mid + Math.imul(al3, bh2) | 0;
        mid = mid + Math.imul(ah3, bl2) | 0;
        hi = hi + Math.imul(ah3, bh2) | 0;
        lo = lo + Math.imul(al2, bl3) | 0;
        mid = mid + Math.imul(al2, bh3) | 0;
        mid = mid + Math.imul(ah2, bl3) | 0;
        hi = hi + Math.imul(ah2, bh3) | 0;
        lo = lo + Math.imul(al1, bl4) | 0;
        mid = mid + Math.imul(al1, bh4) | 0;
        mid = mid + Math.imul(ah1, bl4) | 0;
        hi = hi + Math.imul(ah1, bh4) | 0;
        lo = lo + Math.imul(al0, bl5) | 0;
        mid = mid + Math.imul(al0, bh5) | 0;
        mid = mid + Math.imul(ah0, bl5) | 0;
        hi = hi + Math.imul(ah0, bh5) | 0;
        var w5 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
        w5 &= 0x3ffffff;
        /* k = 6 */ lo = Math.imul(al6, bl0);
        mid = Math.imul(al6, bh0);
        mid = mid + Math.imul(ah6, bl0) | 0;
        hi = Math.imul(ah6, bh0);
        lo = lo + Math.imul(al5, bl1) | 0;
        mid = mid + Math.imul(al5, bh1) | 0;
        mid = mid + Math.imul(ah5, bl1) | 0;
        hi = hi + Math.imul(ah5, bh1) | 0;
        lo = lo + Math.imul(al4, bl2) | 0;
        mid = mid + Math.imul(al4, bh2) | 0;
        mid = mid + Math.imul(ah4, bl2) | 0;
        hi = hi + Math.imul(ah4, bh2) | 0;
        lo = lo + Math.imul(al3, bl3) | 0;
        mid = mid + Math.imul(al3, bh3) | 0;
        mid = mid + Math.imul(ah3, bl3) | 0;
        hi = hi + Math.imul(ah3, bh3) | 0;
        lo = lo + Math.imul(al2, bl4) | 0;
        mid = mid + Math.imul(al2, bh4) | 0;
        mid = mid + Math.imul(ah2, bl4) | 0;
        hi = hi + Math.imul(ah2, bh4) | 0;
        lo = lo + Math.imul(al1, bl5) | 0;
        mid = mid + Math.imul(al1, bh5) | 0;
        mid = mid + Math.imul(ah1, bl5) | 0;
        hi = hi + Math.imul(ah1, bh5) | 0;
        lo = lo + Math.imul(al0, bl6) | 0;
        mid = mid + Math.imul(al0, bh6) | 0;
        mid = mid + Math.imul(ah0, bl6) | 0;
        hi = hi + Math.imul(ah0, bh6) | 0;
        var w6 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
        w6 &= 0x3ffffff;
        /* k = 7 */ lo = Math.imul(al7, bl0);
        mid = Math.imul(al7, bh0);
        mid = mid + Math.imul(ah7, bl0) | 0;
        hi = Math.imul(ah7, bh0);
        lo = lo + Math.imul(al6, bl1) | 0;
        mid = mid + Math.imul(al6, bh1) | 0;
        mid = mid + Math.imul(ah6, bl1) | 0;
        hi = hi + Math.imul(ah6, bh1) | 0;
        lo = lo + Math.imul(al5, bl2) | 0;
        mid = mid + Math.imul(al5, bh2) | 0;
        mid = mid + Math.imul(ah5, bl2) | 0;
        hi = hi + Math.imul(ah5, bh2) | 0;
        lo = lo + Math.imul(al4, bl3) | 0;
        mid = mid + Math.imul(al4, bh3) | 0;
        mid = mid + Math.imul(ah4, bl3) | 0;
        hi = hi + Math.imul(ah4, bh3) | 0;
        lo = lo + Math.imul(al3, bl4) | 0;
        mid = mid + Math.imul(al3, bh4) | 0;
        mid = mid + Math.imul(ah3, bl4) | 0;
        hi = hi + Math.imul(ah3, bh4) | 0;
        lo = lo + Math.imul(al2, bl5) | 0;
        mid = mid + Math.imul(al2, bh5) | 0;
        mid = mid + Math.imul(ah2, bl5) | 0;
        hi = hi + Math.imul(ah2, bh5) | 0;
        lo = lo + Math.imul(al1, bl6) | 0;
        mid = mid + Math.imul(al1, bh6) | 0;
        mid = mid + Math.imul(ah1, bl6) | 0;
        hi = hi + Math.imul(ah1, bh6) | 0;
        lo = lo + Math.imul(al0, bl7) | 0;
        mid = mid + Math.imul(al0, bh7) | 0;
        mid = mid + Math.imul(ah0, bl7) | 0;
        hi = hi + Math.imul(ah0, bh7) | 0;
        var w7 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
        w7 &= 0x3ffffff;
        /* k = 8 */ lo = Math.imul(al8, bl0);
        mid = Math.imul(al8, bh0);
        mid = mid + Math.imul(ah8, bl0) | 0;
        hi = Math.imul(ah8, bh0);
        lo = lo + Math.imul(al7, bl1) | 0;
        mid = mid + Math.imul(al7, bh1) | 0;
        mid = mid + Math.imul(ah7, bl1) | 0;
        hi = hi + Math.imul(ah7, bh1) | 0;
        lo = lo + Math.imul(al6, bl2) | 0;
        mid = mid + Math.imul(al6, bh2) | 0;
        mid = mid + Math.imul(ah6, bl2) | 0;
        hi = hi + Math.imul(ah6, bh2) | 0;
        lo = lo + Math.imul(al5, bl3) | 0;
        mid = mid + Math.imul(al5, bh3) | 0;
        mid = mid + Math.imul(ah5, bl3) | 0;
        hi = hi + Math.imul(ah5, bh3) | 0;
        lo = lo + Math.imul(al4, bl4) | 0;
        mid = mid + Math.imul(al4, bh4) | 0;
        mid = mid + Math.imul(ah4, bl4) | 0;
        hi = hi + Math.imul(ah4, bh4) | 0;
        lo = lo + Math.imul(al3, bl5) | 0;
        mid = mid + Math.imul(al3, bh5) | 0;
        mid = mid + Math.imul(ah3, bl5) | 0;
        hi = hi + Math.imul(ah3, bh5) | 0;
        lo = lo + Math.imul(al2, bl6) | 0;
        mid = mid + Math.imul(al2, bh6) | 0;
        mid = mid + Math.imul(ah2, bl6) | 0;
        hi = hi + Math.imul(ah2, bh6) | 0;
        lo = lo + Math.imul(al1, bl7) | 0;
        mid = mid + Math.imul(al1, bh7) | 0;
        mid = mid + Math.imul(ah1, bl7) | 0;
        hi = hi + Math.imul(ah1, bh7) | 0;
        lo = lo + Math.imul(al0, bl8) | 0;
        mid = mid + Math.imul(al0, bh8) | 0;
        mid = mid + Math.imul(ah0, bl8) | 0;
        hi = hi + Math.imul(ah0, bh8) | 0;
        var w8 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
        w8 &= 0x3ffffff;
        /* k = 9 */ lo = Math.imul(al9, bl0);
        mid = Math.imul(al9, bh0);
        mid = mid + Math.imul(ah9, bl0) | 0;
        hi = Math.imul(ah9, bh0);
        lo = lo + Math.imul(al8, bl1) | 0;
        mid = mid + Math.imul(al8, bh1) | 0;
        mid = mid + Math.imul(ah8, bl1) | 0;
        hi = hi + Math.imul(ah8, bh1) | 0;
        lo = lo + Math.imul(al7, bl2) | 0;
        mid = mid + Math.imul(al7, bh2) | 0;
        mid = mid + Math.imul(ah7, bl2) | 0;
        hi = hi + Math.imul(ah7, bh2) | 0;
        lo = lo + Math.imul(al6, bl3) | 0;
        mid = mid + Math.imul(al6, bh3) | 0;
        mid = mid + Math.imul(ah6, bl3) | 0;
        hi = hi + Math.imul(ah6, bh3) | 0;
        lo = lo + Math.imul(al5, bl4) | 0;
        mid = mid + Math.imul(al5, bh4) | 0;
        mid = mid + Math.imul(ah5, bl4) | 0;
        hi = hi + Math.imul(ah5, bh4) | 0;
        lo = lo + Math.imul(al4, bl5) | 0;
        mid = mid + Math.imul(al4, bh5) | 0;
        mid = mid + Math.imul(ah4, bl5) | 0;
        hi = hi + Math.imul(ah4, bh5) | 0;
        lo = lo + Math.imul(al3, bl6) | 0;
        mid = mid + Math.imul(al3, bh6) | 0;
        mid = mid + Math.imul(ah3, bl6) | 0;
        hi = hi + Math.imul(ah3, bh6) | 0;
        lo = lo + Math.imul(al2, bl7) | 0;
        mid = mid + Math.imul(al2, bh7) | 0;
        mid = mid + Math.imul(ah2, bl7) | 0;
        hi = hi + Math.imul(ah2, bh7) | 0;
        lo = lo + Math.imul(al1, bl8) | 0;
        mid = mid + Math.imul(al1, bh8) | 0;
        mid = mid + Math.imul(ah1, bl8) | 0;
        hi = hi + Math.imul(ah1, bh8) | 0;
        lo = lo + Math.imul(al0, bl9) | 0;
        mid = mid + Math.imul(al0, bh9) | 0;
        mid = mid + Math.imul(ah0, bl9) | 0;
        hi = hi + Math.imul(ah0, bh9) | 0;
        var w9 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
        w9 &= 0x3ffffff;
        /* k = 10 */ lo = Math.imul(al9, bl1);
        mid = Math.imul(al9, bh1);
        mid = mid + Math.imul(ah9, bl1) | 0;
        hi = Math.imul(ah9, bh1);
        lo = lo + Math.imul(al8, bl2) | 0;
        mid = mid + Math.imul(al8, bh2) | 0;
        mid = mid + Math.imul(ah8, bl2) | 0;
        hi = hi + Math.imul(ah8, bh2) | 0;
        lo = lo + Math.imul(al7, bl3) | 0;
        mid = mid + Math.imul(al7, bh3) | 0;
        mid = mid + Math.imul(ah7, bl3) | 0;
        hi = hi + Math.imul(ah7, bh3) | 0;
        lo = lo + Math.imul(al6, bl4) | 0;
        mid = mid + Math.imul(al6, bh4) | 0;
        mid = mid + Math.imul(ah6, bl4) | 0;
        hi = hi + Math.imul(ah6, bh4) | 0;
        lo = lo + Math.imul(al5, bl5) | 0;
        mid = mid + Math.imul(al5, bh5) | 0;
        mid = mid + Math.imul(ah5, bl5) | 0;
        hi = hi + Math.imul(ah5, bh5) | 0;
        lo = lo + Math.imul(al4, bl6) | 0;
        mid = mid + Math.imul(al4, bh6) | 0;
        mid = mid + Math.imul(ah4, bl6) | 0;
        hi = hi + Math.imul(ah4, bh6) | 0;
        lo = lo + Math.imul(al3, bl7) | 0;
        mid = mid + Math.imul(al3, bh7) | 0;
        mid = mid + Math.imul(ah3, bl7) | 0;
        hi = hi + Math.imul(ah3, bh7) | 0;
        lo = lo + Math.imul(al2, bl8) | 0;
        mid = mid + Math.imul(al2, bh8) | 0;
        mid = mid + Math.imul(ah2, bl8) | 0;
        hi = hi + Math.imul(ah2, bh8) | 0;
        lo = lo + Math.imul(al1, bl9) | 0;
        mid = mid + Math.imul(al1, bh9) | 0;
        mid = mid + Math.imul(ah1, bl9) | 0;
        hi = hi + Math.imul(ah1, bh9) | 0;
        var w10 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
        w10 &= 0x3ffffff;
        /* k = 11 */ lo = Math.imul(al9, bl2);
        mid = Math.imul(al9, bh2);
        mid = mid + Math.imul(ah9, bl2) | 0;
        hi = Math.imul(ah9, bh2);
        lo = lo + Math.imul(al8, bl3) | 0;
        mid = mid + Math.imul(al8, bh3) | 0;
        mid = mid + Math.imul(ah8, bl3) | 0;
        hi = hi + Math.imul(ah8, bh3) | 0;
        lo = lo + Math.imul(al7, bl4) | 0;
        mid = mid + Math.imul(al7, bh4) | 0;
        mid = mid + Math.imul(ah7, bl4) | 0;
        hi = hi + Math.imul(ah7, bh4) | 0;
        lo = lo + Math.imul(al6, bl5) | 0;
        mid = mid + Math.imul(al6, bh5) | 0;
        mid = mid + Math.imul(ah6, bl5) | 0;
        hi = hi + Math.imul(ah6, bh5) | 0;
        lo = lo + Math.imul(al5, bl6) | 0;
        mid = mid + Math.imul(al5, bh6) | 0;
        mid = mid + Math.imul(ah5, bl6) | 0;
        hi = hi + Math.imul(ah5, bh6) | 0;
        lo = lo + Math.imul(al4, bl7) | 0;
        mid = mid + Math.imul(al4, bh7) | 0;
        mid = mid + Math.imul(ah4, bl7) | 0;
        hi = hi + Math.imul(ah4, bh7) | 0;
        lo = lo + Math.imul(al3, bl8) | 0;
        mid = mid + Math.imul(al3, bh8) | 0;
        mid = mid + Math.imul(ah3, bl8) | 0;
        hi = hi + Math.imul(ah3, bh8) | 0;
        lo = lo + Math.imul(al2, bl9) | 0;
        mid = mid + Math.imul(al2, bh9) | 0;
        mid = mid + Math.imul(ah2, bl9) | 0;
        hi = hi + Math.imul(ah2, bh9) | 0;
        var w11 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
        w11 &= 0x3ffffff;
        /* k = 12 */ lo = Math.imul(al9, bl3);
        mid = Math.imul(al9, bh3);
        mid = mid + Math.imul(ah9, bl3) | 0;
        hi = Math.imul(ah9, bh3);
        lo = lo + Math.imul(al8, bl4) | 0;
        mid = mid + Math.imul(al8, bh4) | 0;
        mid = mid + Math.imul(ah8, bl4) | 0;
        hi = hi + Math.imul(ah8, bh4) | 0;
        lo = lo + Math.imul(al7, bl5) | 0;
        mid = mid + Math.imul(al7, bh5) | 0;
        mid = mid + Math.imul(ah7, bl5) | 0;
        hi = hi + Math.imul(ah7, bh5) | 0;
        lo = lo + Math.imul(al6, bl6) | 0;
        mid = mid + Math.imul(al6, bh6) | 0;
        mid = mid + Math.imul(ah6, bl6) | 0;
        hi = hi + Math.imul(ah6, bh6) | 0;
        lo = lo + Math.imul(al5, bl7) | 0;
        mid = mid + Math.imul(al5, bh7) | 0;
        mid = mid + Math.imul(ah5, bl7) | 0;
        hi = hi + Math.imul(ah5, bh7) | 0;
        lo = lo + Math.imul(al4, bl8) | 0;
        mid = mid + Math.imul(al4, bh8) | 0;
        mid = mid + Math.imul(ah4, bl8) | 0;
        hi = hi + Math.imul(ah4, bh8) | 0;
        lo = lo + Math.imul(al3, bl9) | 0;
        mid = mid + Math.imul(al3, bh9) | 0;
        mid = mid + Math.imul(ah3, bl9) | 0;
        hi = hi + Math.imul(ah3, bh9) | 0;
        var w12 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
        w12 &= 0x3ffffff;
        /* k = 13 */ lo = Math.imul(al9, bl4);
        mid = Math.imul(al9, bh4);
        mid = mid + Math.imul(ah9, bl4) | 0;
        hi = Math.imul(ah9, bh4);
        lo = lo + Math.imul(al8, bl5) | 0;
        mid = mid + Math.imul(al8, bh5) | 0;
        mid = mid + Math.imul(ah8, bl5) | 0;
        hi = hi + Math.imul(ah8, bh5) | 0;
        lo = lo + Math.imul(al7, bl6) | 0;
        mid = mid + Math.imul(al7, bh6) | 0;
        mid = mid + Math.imul(ah7, bl6) | 0;
        hi = hi + Math.imul(ah7, bh6) | 0;
        lo = lo + Math.imul(al6, bl7) | 0;
        mid = mid + Math.imul(al6, bh7) | 0;
        mid = mid + Math.imul(ah6, bl7) | 0;
        hi = hi + Math.imul(ah6, bh7) | 0;
        lo = lo + Math.imul(al5, bl8) | 0;
        mid = mid + Math.imul(al5, bh8) | 0;
        mid = mid + Math.imul(ah5, bl8) | 0;
        hi = hi + Math.imul(ah5, bh8) | 0;
        lo = lo + Math.imul(al4, bl9) | 0;
        mid = mid + Math.imul(al4, bh9) | 0;
        mid = mid + Math.imul(ah4, bl9) | 0;
        hi = hi + Math.imul(ah4, bh9) | 0;
        var w13 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
        w13 &= 0x3ffffff;
        /* k = 14 */ lo = Math.imul(al9, bl5);
        mid = Math.imul(al9, bh5);
        mid = mid + Math.imul(ah9, bl5) | 0;
        hi = Math.imul(ah9, bh5);
        lo = lo + Math.imul(al8, bl6) | 0;
        mid = mid + Math.imul(al8, bh6) | 0;
        mid = mid + Math.imul(ah8, bl6) | 0;
        hi = hi + Math.imul(ah8, bh6) | 0;
        lo = lo + Math.imul(al7, bl7) | 0;
        mid = mid + Math.imul(al7, bh7) | 0;
        mid = mid + Math.imul(ah7, bl7) | 0;
        hi = hi + Math.imul(ah7, bh7) | 0;
        lo = lo + Math.imul(al6, bl8) | 0;
        mid = mid + Math.imul(al6, bh8) | 0;
        mid = mid + Math.imul(ah6, bl8) | 0;
        hi = hi + Math.imul(ah6, bh8) | 0;
        lo = lo + Math.imul(al5, bl9) | 0;
        mid = mid + Math.imul(al5, bh9) | 0;
        mid = mid + Math.imul(ah5, bl9) | 0;
        hi = hi + Math.imul(ah5, bh9) | 0;
        var w14 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
        w14 &= 0x3ffffff;
        /* k = 15 */ lo = Math.imul(al9, bl6);
        mid = Math.imul(al9, bh6);
        mid = mid + Math.imul(ah9, bl6) | 0;
        hi = Math.imul(ah9, bh6);
        lo = lo + Math.imul(al8, bl7) | 0;
        mid = mid + Math.imul(al8, bh7) | 0;
        mid = mid + Math.imul(ah8, bl7) | 0;
        hi = hi + Math.imul(ah8, bh7) | 0;
        lo = lo + Math.imul(al7, bl8) | 0;
        mid = mid + Math.imul(al7, bh8) | 0;
        mid = mid + Math.imul(ah7, bl8) | 0;
        hi = hi + Math.imul(ah7, bh8) | 0;
        lo = lo + Math.imul(al6, bl9) | 0;
        mid = mid + Math.imul(al6, bh9) | 0;
        mid = mid + Math.imul(ah6, bl9) | 0;
        hi = hi + Math.imul(ah6, bh9) | 0;
        var w15 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
        w15 &= 0x3ffffff;
        /* k = 16 */ lo = Math.imul(al9, bl7);
        mid = Math.imul(al9, bh7);
        mid = mid + Math.imul(ah9, bl7) | 0;
        hi = Math.imul(ah9, bh7);
        lo = lo + Math.imul(al8, bl8) | 0;
        mid = mid + Math.imul(al8, bh8) | 0;
        mid = mid + Math.imul(ah8, bl8) | 0;
        hi = hi + Math.imul(ah8, bh8) | 0;
        lo = lo + Math.imul(al7, bl9) | 0;
        mid = mid + Math.imul(al7, bh9) | 0;
        mid = mid + Math.imul(ah7, bl9) | 0;
        hi = hi + Math.imul(ah7, bh9) | 0;
        var w16 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
        w16 &= 0x3ffffff;
        /* k = 17 */ lo = Math.imul(al9, bl8);
        mid = Math.imul(al9, bh8);
        mid = mid + Math.imul(ah9, bl8) | 0;
        hi = Math.imul(ah9, bh8);
        lo = lo + Math.imul(al8, bl9) | 0;
        mid = mid + Math.imul(al8, bh9) | 0;
        mid = mid + Math.imul(ah8, bl9) | 0;
        hi = hi + Math.imul(ah8, bh9) | 0;
        var w17 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
        w17 &= 0x3ffffff;
        /* k = 18 */ lo = Math.imul(al9, bl9);
        mid = Math.imul(al9, bh9);
        mid = mid + Math.imul(ah9, bl9) | 0;
        hi = Math.imul(ah9, bh9);
        var w18 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
        w18 &= 0x3ffffff;
        o[0] = w0;
        o[1] = w1;
        o[2] = w2;
        o[3] = w3;
        o[4] = w4;
        o[5] = w5;
        o[6] = w6;
        o[7] = w7;
        o[8] = w8;
        o[9] = w9;
        o[10] = w10;
        o[11] = w11;
        o[12] = w12;
        o[13] = w13;
        o[14] = w14;
        o[15] = w15;
        o[16] = w16;
        o[17] = w17;
        o[18] = w18;
        if (c !== 0) {
            o[19] = c;
            out.length++;
        }
        return out;
    };
    // Polyfill comb
    if (!Math.imul) comb10MulTo = smallMulTo;
    function bigMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        out.length = self.length + num.length;
        var carry = 0;
        var hncarry = 0;
        for(var k = 0; k < out.length - 1; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = hncarry;
            hncarry = 0;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j;
                var a = self.words[i] | 0;
                var b = num.words[j] | 0;
                var r = a * b;
                var lo = r & 0x3ffffff;
                ncarry = ncarry + (r / 0x4000000 | 0) | 0;
                lo = lo + rword | 0;
                rword = lo & 0x3ffffff;
                ncarry = ncarry + (lo >>> 26) | 0;
                hncarry += ncarry >>> 26;
                ncarry &= 0x3ffffff;
            }
            out.words[k] = rword;
            carry = ncarry;
            ncarry = hncarry;
        }
        if (carry !== 0) out.words[k] = carry;
        else out.length--;
        return out._strip();
    }
    function jumboMulTo(self, num, out) {
        // Temporary disable, see https://github.com/indutny/bn.js/issues/211
        // var fftm = new FFTM();
        // return fftm.mulp(self, num, out);
        return bigMulTo(self, num, out);
    }
    BN.prototype.mulTo = function mulTo(num, out) {
        var res;
        var len = this.length + num.length;
        if (this.length === 10 && num.length === 10) res = comb10MulTo(this, num, out);
        else if (len < 63) res = smallMulTo(this, num, out);
        else if (len < 1024) res = bigMulTo(this, num, out);
        else res = jumboMulTo(this, num, out);
        return res;
    };
    // Cooley-Tukey algorithm for FFT
    // slightly revisited to rely on looping instead of recursion
    function FFTM(x, y) {
        this.x = x;
        this.y = y;
    }
    FFTM.prototype.makeRBT = function makeRBT(N) {
        var t = new Array(N);
        var l = BN.prototype._countBits(N) - 1;
        for(var i = 0; i < N; i++)t[i] = this.revBin(i, l, N);
        return t;
    };
    // Returns binary-reversed representation of `x`
    FFTM.prototype.revBin = function revBin(x, l, N) {
        if (x === 0 || x === N - 1) return x;
        var rb = 0;
        for(var i = 0; i < l; i++){
            rb |= (x & 1) << l - i - 1;
            x >>= 1;
        }
        return rb;
    };
    // Performs "tweedling" phase, therefore 'emulating'
    // behaviour of the recursive algorithm
    FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
        for(var i = 0; i < N; i++){
            rtws[i] = rws[rbt[i]];
            itws[i] = iws[rbt[i]];
        }
    };
    FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
        this.permute(rbt, rws, iws, rtws, itws, N);
        for(var s = 1; s < N; s <<= 1){
            var l = s << 1;
            var rtwdf = Math.cos(2 * Math.PI / l);
            var itwdf = Math.sin(2 * Math.PI / l);
            for(var p = 0; p < N; p += l){
                var rtwdf_ = rtwdf;
                var itwdf_ = itwdf;
                for(var j = 0; j < s; j++){
                    var re = rtws[p + j];
                    var ie = itws[p + j];
                    var ro = rtws[p + j + s];
                    var io = itws[p + j + s];
                    var rx = rtwdf_ * ro - itwdf_ * io;
                    io = rtwdf_ * io + itwdf_ * ro;
                    ro = rx;
                    rtws[p + j] = re + ro;
                    itws[p + j] = ie + io;
                    rtws[p + j + s] = re - ro;
                    itws[p + j + s] = ie - io;
                    /* jshint maxdepth : false */ if (j !== l) {
                        rx = rtwdf * rtwdf_ - itwdf * itwdf_;
                        itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                        rtwdf_ = rx;
                    }
                }
            }
        }
    };
    FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
        var N = Math.max(m, n) | 1;
        var odd = N & 1;
        var i = 0;
        for(N = N / 2 | 0; N; N = N >>> 1)i++;
        return 1 << i + 1 + odd;
    };
    FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
        if (N <= 1) return;
        for(var i = 0; i < N / 2; i++){
            var t = rws[i];
            rws[i] = rws[N - i - 1];
            rws[N - i - 1] = t;
            t = iws[i];
            iws[i] = -iws[N - i - 1];
            iws[N - i - 1] = -t;
        }
    };
    FFTM.prototype.normalize13b = function normalize13b(ws, N) {
        var carry = 0;
        for(var i = 0; i < N / 2; i++){
            var w = Math.round(ws[2 * i + 1] / N) * 0x2000 + Math.round(ws[2 * i] / N) + carry;
            ws[i] = w & 0x3ffffff;
            if (w < 0x4000000) carry = 0;
            else carry = w / 0x4000000 | 0;
        }
        return ws;
    };
    FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
        var carry = 0;
        for(var i = 0; i < len; i++){
            carry = carry + (ws[i] | 0);
            rws[2 * i] = carry & 0x1fff;
            carry = carry >>> 13;
            rws[2 * i + 1] = carry & 0x1fff;
            carry = carry >>> 13;
        }
        // Pad with zeroes
        for(i = 2 * len; i < N; ++i)rws[i] = 0;
        assert(carry === 0);
        assert((carry & -8192) === 0);
    };
    FFTM.prototype.stub = function stub(N) {
        var ph = new Array(N);
        for(var i = 0; i < N; i++)ph[i] = 0;
        return ph;
    };
    FFTM.prototype.mulp = function mulp(x, y, out) {
        var N = 2 * this.guessLen13b(x.length, y.length);
        var rbt = this.makeRBT(N);
        var _ = this.stub(N);
        var rws = new Array(N);
        var rwst = new Array(N);
        var iwst = new Array(N);
        var nrws = new Array(N);
        var nrwst = new Array(N);
        var niwst = new Array(N);
        var rmws = out.words;
        rmws.length = N;
        this.convert13b(x.words, x.length, rws, N);
        this.convert13b(y.words, y.length, nrws, N);
        this.transform(rws, _, rwst, iwst, N, rbt);
        this.transform(nrws, _, nrwst, niwst, N, rbt);
        for(var i = 0; i < N; i++){
            var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
            iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
            rwst[i] = rx;
        }
        this.conjugate(rwst, iwst, N);
        this.transform(rwst, iwst, rmws, _, N, rbt);
        this.conjugate(rmws, _, N);
        this.normalize13b(rmws, N);
        out.negative = x.negative ^ y.negative;
        out.length = x.length + y.length;
        return out._strip();
    };
    // Multiply `this` by `num`
    BN.prototype.mul = function mul(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return this.mulTo(num, out);
    };
    // Multiply employing FFT
    BN.prototype.mulf = function mulf(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return jumboMulTo(this, num, out);
    };
    // In-place Multiplication
    BN.prototype.imul = function imul(num) {
        return this.clone().mulTo(num, this);
    };
    BN.prototype.imuln = function imuln(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(typeof num === "number");
        assert(num < 0x4000000);
        // Carry
        var carry = 0;
        for(var i = 0; i < this.length; i++){
            var w = (this.words[i] | 0) * num;
            var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
            carry >>= 26;
            carry += w / 0x4000000 | 0;
            // NOTE: lo is 27bit maximum
            carry += lo >>> 26;
            this.words[i] = lo & 0x3ffffff;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return isNegNum ? this.ineg() : this;
    };
    BN.prototype.muln = function muln(num) {
        return this.clone().imuln(num);
    };
    // `this` * `this`
    BN.prototype.sqr = function sqr() {
        return this.mul(this);
    };
    // `this` * `this` in-place
    BN.prototype.isqr = function isqr() {
        return this.imul(this.clone());
    };
    // Math.pow(`this`, `num`)
    BN.prototype.pow = function pow(num) {
        var w = toBitArray(num);
        if (w.length === 0) return new BN(1);
        // Skip leading zeroes
        var res = this;
        for(var i = 0; i < w.length; i++, res = res.sqr()){
            if (w[i] !== 0) break;
        }
        if (++i < w.length) for(var q = res.sqr(); i < w.length; i++, q = q.sqr()){
            if (w[i] === 0) continue;
            res = res.mul(q);
        }
        return res;
    };
    // Shift-left in-place
    BN.prototype.iushln = function iushln(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        var carryMask = 0x3ffffff >>> 26 - r << 26 - r;
        var i;
        if (r !== 0) {
            var carry = 0;
            for(i = 0; i < this.length; i++){
                var newCarry = this.words[i] & carryMask;
                var c = (this.words[i] | 0) - newCarry << r;
                this.words[i] = c | carry;
                carry = newCarry >>> 26 - r;
            }
            if (carry) {
                this.words[i] = carry;
                this.length++;
            }
        }
        if (s !== 0) {
            for(i = this.length - 1; i >= 0; i--)this.words[i + s] = this.words[i];
            for(i = 0; i < s; i++)this.words[i] = 0;
            this.length += s;
        }
        return this._strip();
    };
    BN.prototype.ishln = function ishln(bits) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushln(bits);
    };
    // Shift-right in-place
    // NOTE: `hint` is a lowest bit before trailing zeroes
    // NOTE: if `extended` is present - it will be filled with destroyed bits
    BN.prototype.iushrn = function iushrn(bits, hint, extended) {
        assert(typeof bits === "number" && bits >= 0);
        var h;
        if (hint) h = (hint - hint % 26) / 26;
        else h = 0;
        var r = bits % 26;
        var s = Math.min((bits - r) / 26, this.length);
        var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
        var maskedWords = extended;
        h -= s;
        h = Math.max(0, h);
        // Extended mode, copy masked part
        if (maskedWords) {
            for(var i = 0; i < s; i++)maskedWords.words[i] = this.words[i];
            maskedWords.length = s;
        }
        if (s === 0) ;
        else if (this.length > s) {
            this.length -= s;
            for(i = 0; i < this.length; i++)this.words[i] = this.words[i + s];
        } else {
            this.words[0] = 0;
            this.length = 1;
        }
        var carry = 0;
        for(i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--){
            var word = this.words[i] | 0;
            this.words[i] = carry << 26 - r | word >>> r;
            carry = word & mask;
        }
        // Push carried bits as a mask
        if (maskedWords && carry !== 0) maskedWords.words[maskedWords.length++] = carry;
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this._strip();
    };
    BN.prototype.ishrn = function ishrn(bits, hint, extended) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushrn(bits, hint, extended);
    };
    // Shift-left
    BN.prototype.shln = function shln(bits) {
        return this.clone().ishln(bits);
    };
    BN.prototype.ushln = function ushln(bits) {
        return this.clone().iushln(bits);
    };
    // Shift-right
    BN.prototype.shrn = function shrn(bits) {
        return this.clone().ishrn(bits);
    };
    BN.prototype.ushrn = function ushrn(bits) {
        return this.clone().iushrn(bits);
    };
    // Test if n bit is set
    BN.prototype.testn = function testn(bit) {
        assert(typeof bit === "number" && bit >= 0);
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) return false;
        // Check bit and return
        var w = this.words[s];
        return !!(w & q);
    };
    // Return only lowers bits of number (in-place)
    BN.prototype.imaskn = function imaskn(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        assert(this.negative === 0, "imaskn works only with positive numbers");
        if (this.length <= s) return this;
        if (r !== 0) s++;
        this.length = Math.min(s, this.length);
        if (r !== 0) {
            var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
            this.words[this.length - 1] &= mask;
        }
        return this._strip();
    };
    // Return only lowers bits of number
    BN.prototype.maskn = function maskn(bits) {
        return this.clone().imaskn(bits);
    };
    // Add plain number `num` to `this`
    BN.prototype.iaddn = function iaddn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.isubn(-num);
        // Possible sign change
        if (this.negative !== 0) {
            if (this.length === 1 && (this.words[0] | 0) <= num) {
                this.words[0] = num - (this.words[0] | 0);
                this.negative = 0;
                return this;
            }
            this.negative = 0;
            this.isubn(num);
            this.negative = 1;
            return this;
        }
        // Add without checks
        return this._iaddn(num);
    };
    BN.prototype._iaddn = function _iaddn(num) {
        this.words[0] += num;
        // Carry
        for(var i = 0; i < this.length && this.words[i] >= 0x4000000; i++){
            this.words[i] -= 0x4000000;
            if (i === this.length - 1) this.words[i + 1] = 1;
            else this.words[i + 1]++;
        }
        this.length = Math.max(this.length, i + 1);
        return this;
    };
    // Subtract plain number `num` from `this`
    BN.prototype.isubn = function isubn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.iaddn(-num);
        if (this.negative !== 0) {
            this.negative = 0;
            this.iaddn(num);
            this.negative = 1;
            return this;
        }
        this.words[0] -= num;
        if (this.length === 1 && this.words[0] < 0) {
            this.words[0] = -this.words[0];
            this.negative = 1;
        } else // Carry
        for(var i = 0; i < this.length && this.words[i] < 0; i++){
            this.words[i] += 0x4000000;
            this.words[i + 1] -= 1;
        }
        return this._strip();
    };
    BN.prototype.addn = function addn(num) {
        return this.clone().iaddn(num);
    };
    BN.prototype.subn = function subn(num) {
        return this.clone().isubn(num);
    };
    BN.prototype.iabs = function iabs() {
        this.negative = 0;
        return this;
    };
    BN.prototype.abs = function abs() {
        return this.clone().iabs();
    };
    BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
        var len = num.length + shift;
        var i;
        this._expand(len);
        var w;
        var carry = 0;
        for(i = 0; i < num.length; i++){
            w = (this.words[i + shift] | 0) + carry;
            var right = (num.words[i] | 0) * mul;
            w -= right & 0x3ffffff;
            carry = (w >> 26) - (right / 0x4000000 | 0);
            this.words[i + shift] = w & 0x3ffffff;
        }
        for(; i < this.length - shift; i++){
            w = (this.words[i + shift] | 0) + carry;
            carry = w >> 26;
            this.words[i + shift] = w & 0x3ffffff;
        }
        if (carry === 0) return this._strip();
        // Subtraction overflow
        assert(carry === -1);
        carry = 0;
        for(i = 0; i < this.length; i++){
            w = -(this.words[i] | 0) + carry;
            carry = w >> 26;
            this.words[i] = w & 0x3ffffff;
        }
        this.negative = 1;
        return this._strip();
    };
    BN.prototype._wordDiv = function _wordDiv(num, mode) {
        var shift = this.length - num.length;
        var a = this.clone();
        var b = num;
        // Normalize
        var bhi = b.words[b.length - 1] | 0;
        var bhiBits = this._countBits(bhi);
        shift = 26 - bhiBits;
        if (shift !== 0) {
            b = b.ushln(shift);
            a.iushln(shift);
            bhi = b.words[b.length - 1] | 0;
        }
        // Initialize quotient
        var m = a.length - b.length;
        var q;
        if (mode !== "mod") {
            q = new BN(null);
            q.length = m + 1;
            q.words = new Array(q.length);
            for(var i = 0; i < q.length; i++)q.words[i] = 0;
        }
        var diff = a.clone()._ishlnsubmul(b, 1, m);
        if (diff.negative === 0) {
            a = diff;
            if (q) q.words[m] = 1;
        }
        for(var j = m - 1; j >= 0; j--){
            var qj = (a.words[b.length + j] | 0) * 0x4000000 + (a.words[b.length + j - 1] | 0);
            // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
            // (0x7ffffff)
            qj = Math.min(qj / bhi | 0, 0x3ffffff);
            a._ishlnsubmul(b, qj, j);
            while(a.negative !== 0){
                qj--;
                a.negative = 0;
                a._ishlnsubmul(b, 1, j);
                if (!a.isZero()) a.negative ^= 1;
            }
            if (q) q.words[j] = qj;
        }
        if (q) q._strip();
        a._strip();
        // Denormalize
        if (mode !== "div" && shift !== 0) a.iushrn(shift);
        return {
            div: q || null,
            mod: a
        };
    };
    // NOTE: 1) `mode` can be set to `mod` to request mod only,
    //       to `div` to request div only, or be absent to
    //       request both div & mod
    //       2) `positive` is true if unsigned mod is requested
    BN.prototype.divmod = function divmod(num, mode, positive) {
        assert(!num.isZero());
        if (this.isZero()) return {
            div: new BN(0),
            mod: new BN(0)
        };
        var div, mod, res;
        if (this.negative !== 0 && num.negative === 0) {
            res = this.neg().divmod(num, mode);
            if (mode !== "mod") div = res.div.neg();
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.iadd(num);
            }
            return {
                div: div,
                mod: mod
            };
        }
        if (this.negative === 0 && num.negative !== 0) {
            res = this.divmod(num.neg(), mode);
            if (mode !== "mod") div = res.div.neg();
            return {
                div: div,
                mod: res.mod
            };
        }
        if ((this.negative & num.negative) !== 0) {
            res = this.neg().divmod(num.neg(), mode);
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.isub(num);
            }
            return {
                div: res.div,
                mod: mod
            };
        }
        // Both numbers are positive at this point
        // Strip both numbers to approximate shift value
        if (num.length > this.length || this.cmp(num) < 0) return {
            div: new BN(0),
            mod: this
        };
        // Very short reduction
        if (num.length === 1) {
            if (mode === "div") return {
                div: this.divn(num.words[0]),
                mod: null
            };
            if (mode === "mod") return {
                div: null,
                mod: new BN(this.modrn(num.words[0]))
            };
            return {
                div: this.divn(num.words[0]),
                mod: new BN(this.modrn(num.words[0]))
            };
        }
        return this._wordDiv(num, mode);
    };
    // Find `this` / `num`
    BN.prototype.div = function div(num) {
        return this.divmod(num, "div", false).div;
    };
    // Find `this` % `num`
    BN.prototype.mod = function mod(num) {
        return this.divmod(num, "mod", false).mod;
    };
    BN.prototype.umod = function umod(num) {
        return this.divmod(num, "mod", true).mod;
    };
    // Find Round(`this` / `num`)
    BN.prototype.divRound = function divRound(num) {
        var dm = this.divmod(num);
        // Fast case - exact division
        if (dm.mod.isZero()) return dm.div;
        var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;
        var half = num.ushrn(1);
        var r2 = num.andln(1);
        var cmp = mod.cmp(half);
        // Round down
        if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
        // Round up
        return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
    };
    BN.prototype.modrn = function modrn(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(num <= 0x3ffffff);
        var p = 67108864 % num;
        var acc = 0;
        for(var i = this.length - 1; i >= 0; i--)acc = (p * acc + (this.words[i] | 0)) % num;
        return isNegNum ? -acc : acc;
    };
    // WARNING: DEPRECATED
    BN.prototype.modn = function modn(num) {
        return this.modrn(num);
    };
    // In-place division by number
    BN.prototype.idivn = function idivn(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(num <= 0x3ffffff);
        var carry = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var w = (this.words[i] | 0) + carry * 0x4000000;
            this.words[i] = w / num | 0;
            carry = w % num;
        }
        this._strip();
        return isNegNum ? this.ineg() : this;
    };
    BN.prototype.divn = function divn(num) {
        return this.clone().idivn(num);
    };
    BN.prototype.egcd = function egcd(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var x = this;
        var y = p.clone();
        if (x.negative !== 0) x = x.umod(p);
        else x = x.clone();
        // A * x + B * y = x
        var A = new BN(1);
        var B = new BN(0);
        // C * x + D * y = y
        var C = new BN(0);
        var D = new BN(1);
        var g = 0;
        while(x.isEven() && y.isEven()){
            x.iushrn(1);
            y.iushrn(1);
            ++g;
        }
        var yp = y.clone();
        var xp = x.clone();
        while(!x.isZero()){
            for(var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                x.iushrn(i);
                while(i-- > 0){
                    if (A.isOdd() || B.isOdd()) {
                        A.iadd(yp);
                        B.isub(xp);
                    }
                    A.iushrn(1);
                    B.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                y.iushrn(j);
                while(j-- > 0){
                    if (C.isOdd() || D.isOdd()) {
                        C.iadd(yp);
                        D.isub(xp);
                    }
                    C.iushrn(1);
                    D.iushrn(1);
                }
            }
            if (x.cmp(y) >= 0) {
                x.isub(y);
                A.isub(C);
                B.isub(D);
            } else {
                y.isub(x);
                C.isub(A);
                D.isub(B);
            }
        }
        return {
            a: C,
            b: D,
            gcd: y.iushln(g)
        };
    };
    // This is reduced incarnation of the binary EEA
    // above, designated to invert members of the
    // _prime_ fields F(p) at a maximal speed
    BN.prototype._invmp = function _invmp(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var a = this;
        var b = p.clone();
        if (a.negative !== 0) a = a.umod(p);
        else a = a.clone();
        var x1 = new BN(1);
        var x2 = new BN(0);
        var delta = b.clone();
        while(a.cmpn(1) > 0 && b.cmpn(1) > 0){
            for(var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                a.iushrn(i);
                while(i-- > 0){
                    if (x1.isOdd()) x1.iadd(delta);
                    x1.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                b.iushrn(j);
                while(j-- > 0){
                    if (x2.isOdd()) x2.iadd(delta);
                    x2.iushrn(1);
                }
            }
            if (a.cmp(b) >= 0) {
                a.isub(b);
                x1.isub(x2);
            } else {
                b.isub(a);
                x2.isub(x1);
            }
        }
        var res;
        if (a.cmpn(1) === 0) res = x1;
        else res = x2;
        if (res.cmpn(0) < 0) res.iadd(p);
        return res;
    };
    BN.prototype.gcd = function gcd(num) {
        if (this.isZero()) return num.abs();
        if (num.isZero()) return this.abs();
        var a = this.clone();
        var b = num.clone();
        a.negative = 0;
        b.negative = 0;
        // Remove common factor of two
        for(var shift = 0; a.isEven() && b.isEven(); shift++){
            a.iushrn(1);
            b.iushrn(1);
        }
        do {
            while(a.isEven())a.iushrn(1);
            while(b.isEven())b.iushrn(1);
            var r = a.cmp(b);
            if (r < 0) {
                // Swap `a` and `b` to make `a` always bigger than `b`
                var t = a;
                a = b;
                b = t;
            } else if (r === 0 || b.cmpn(1) === 0) break;
            a.isub(b);
        }while (true);
        return b.iushln(shift);
    };
    // Invert number in the field F(num)
    BN.prototype.invm = function invm(num) {
        return this.egcd(num).a.umod(num);
    };
    BN.prototype.isEven = function isEven() {
        return (this.words[0] & 1) === 0;
    };
    BN.prototype.isOdd = function isOdd() {
        return (this.words[0] & 1) === 1;
    };
    // And first word and num
    BN.prototype.andln = function andln(num) {
        return this.words[0] & num;
    };
    // Increment at the bit position in-line
    BN.prototype.bincn = function bincn(bit) {
        assert(typeof bit === "number");
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) {
            this._expand(s + 1);
            this.words[s] |= q;
            return this;
        }
        // Add bit and propagate, if needed
        var carry = q;
        for(var i = s; carry !== 0 && i < this.length; i++){
            var w = this.words[i] | 0;
            w += carry;
            carry = w >>> 26;
            w &= 0x3ffffff;
            this.words[i] = w;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.isZero = function isZero() {
        return this.length === 1 && this.words[0] === 0;
    };
    BN.prototype.cmpn = function cmpn(num) {
        var negative = num < 0;
        if (this.negative !== 0 && !negative) return -1;
        if (this.negative === 0 && negative) return 1;
        this._strip();
        var res;
        if (this.length > 1) res = 1;
        else {
            if (negative) num = -num;
            assert(num <= 0x3ffffff, "Number is too big");
            var w = this.words[0] | 0;
            res = w === num ? 0 : w < num ? -1 : 1;
        }
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Compare two numbers and return:
    // 1 - if `this` > `num`
    // 0 - if `this` == `num`
    // -1 - if `this` < `num`
    BN.prototype.cmp = function cmp(num) {
        if (this.negative !== 0 && num.negative === 0) return -1;
        if (this.negative === 0 && num.negative !== 0) return 1;
        var res = this.ucmp(num);
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Unsigned comparison
    BN.prototype.ucmp = function ucmp(num) {
        // At this point both numbers have the same sign
        if (this.length > num.length) return 1;
        if (this.length < num.length) return -1;
        var res = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var a = this.words[i] | 0;
            var b = num.words[i] | 0;
            if (a === b) continue;
            if (a < b) res = -1;
            else if (a > b) res = 1;
            break;
        }
        return res;
    };
    BN.prototype.gtn = function gtn(num) {
        return this.cmpn(num) === 1;
    };
    BN.prototype.gt = function gt(num) {
        return this.cmp(num) === 1;
    };
    BN.prototype.gten = function gten(num) {
        return this.cmpn(num) >= 0;
    };
    BN.prototype.gte = function gte(num) {
        return this.cmp(num) >= 0;
    };
    BN.prototype.ltn = function ltn(num) {
        return this.cmpn(num) === -1;
    };
    BN.prototype.lt = function lt(num) {
        return this.cmp(num) === -1;
    };
    BN.prototype.lten = function lten(num) {
        return this.cmpn(num) <= 0;
    };
    BN.prototype.lte = function lte(num) {
        return this.cmp(num) <= 0;
    };
    BN.prototype.eqn = function eqn(num) {
        return this.cmpn(num) === 0;
    };
    BN.prototype.eq = function eq(num) {
        return this.cmp(num) === 0;
    };
    //
    // A reduce context, could be using montgomery or something better, depending
    // on the `m` itself.
    //
    BN.red = function red(num) {
        return new Red(num);
    };
    BN.prototype.toRed = function toRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        assert(this.negative === 0, "red works only with positives");
        return ctx.convertTo(this)._forceRed(ctx);
    };
    BN.prototype.fromRed = function fromRed() {
        assert(this.red, "fromRed works only with numbers in reduction context");
        return this.red.convertFrom(this);
    };
    BN.prototype._forceRed = function _forceRed(ctx) {
        this.red = ctx;
        return this;
    };
    BN.prototype.forceRed = function forceRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        return this._forceRed(ctx);
    };
    BN.prototype.redAdd = function redAdd(num) {
        assert(this.red, "redAdd works only with red numbers");
        return this.red.add(this, num);
    };
    BN.prototype.redIAdd = function redIAdd(num) {
        assert(this.red, "redIAdd works only with red numbers");
        return this.red.iadd(this, num);
    };
    BN.prototype.redSub = function redSub(num) {
        assert(this.red, "redSub works only with red numbers");
        return this.red.sub(this, num);
    };
    BN.prototype.redISub = function redISub(num) {
        assert(this.red, "redISub works only with red numbers");
        return this.red.isub(this, num);
    };
    BN.prototype.redShl = function redShl(num) {
        assert(this.red, "redShl works only with red numbers");
        return this.red.shl(this, num);
    };
    BN.prototype.redMul = function redMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.mul(this, num);
    };
    BN.prototype.redIMul = function redIMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.imul(this, num);
    };
    BN.prototype.redSqr = function redSqr() {
        assert(this.red, "redSqr works only with red numbers");
        this.red._verify1(this);
        return this.red.sqr(this);
    };
    BN.prototype.redISqr = function redISqr() {
        assert(this.red, "redISqr works only with red numbers");
        this.red._verify1(this);
        return this.red.isqr(this);
    };
    // Square root over p
    BN.prototype.redSqrt = function redSqrt() {
        assert(this.red, "redSqrt works only with red numbers");
        this.red._verify1(this);
        return this.red.sqrt(this);
    };
    BN.prototype.redInvm = function redInvm() {
        assert(this.red, "redInvm works only with red numbers");
        this.red._verify1(this);
        return this.red.invm(this);
    };
    // Return negative clone of `this` % `red modulo`
    BN.prototype.redNeg = function redNeg() {
        assert(this.red, "redNeg works only with red numbers");
        this.red._verify1(this);
        return this.red.neg(this);
    };
    BN.prototype.redPow = function redPow(num) {
        assert(this.red && !num.red, "redPow(normalNum)");
        this.red._verify1(this);
        return this.red.pow(this, num);
    };
    // Prime numbers with efficient reduction
    var primes = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
    };
    // Pseudo-Mersenne prime
    function MPrime(name, p) {
        // P = 2 ^ N - K
        this.name = name;
        this.p = new BN(p, 16);
        this.n = this.p.bitLength();
        this.k = new BN(1).iushln(this.n).isub(this.p);
        this.tmp = this._tmp();
    }
    MPrime.prototype._tmp = function _tmp() {
        var tmp = new BN(null);
        tmp.words = new Array(Math.ceil(this.n / 13));
        return tmp;
    };
    MPrime.prototype.ireduce = function ireduce(num) {
        // Assumes that `num` is less than `P^2`
        // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
        var r = num;
        var rlen;
        do {
            this.split(r, this.tmp);
            r = this.imulK(r);
            r = r.iadd(this.tmp);
            rlen = r.bitLength();
        }while (rlen > this.n);
        var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
        if (cmp === 0) {
            r.words[0] = 0;
            r.length = 1;
        } else if (cmp > 0) r.isub(this.p);
        else if (r.strip !== undefined) // r is a BN v4 instance
        r.strip();
        else // r is a BN v5 instance
        r._strip();
        return r;
    };
    MPrime.prototype.split = function split(input, out) {
        input.iushrn(this.n, 0, out);
    };
    MPrime.prototype.imulK = function imulK(num) {
        return num.imul(this.k);
    };
    function K256() {
        MPrime.call(this, "k256", "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f");
    }
    inherits(K256, MPrime);
    K256.prototype.split = function split(input, output) {
        // 256 = 9 * 26 + 22
        var mask = 0x3fffff;
        var outLen = Math.min(input.length, 9);
        for(var i = 0; i < outLen; i++)output.words[i] = input.words[i];
        output.length = outLen;
        if (input.length <= 9) {
            input.words[0] = 0;
            input.length = 1;
            return;
        }
        // Shift by 9 limbs
        var prev = input.words[9];
        output.words[output.length++] = prev & mask;
        for(i = 10; i < input.length; i++){
            var next = input.words[i] | 0;
            input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
            prev = next;
        }
        prev >>>= 22;
        input.words[i - 10] = prev;
        if (prev === 0 && input.length > 10) input.length -= 10;
        else input.length -= 9;
    };
    K256.prototype.imulK = function imulK(num) {
        // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
        num.words[num.length] = 0;
        num.words[num.length + 1] = 0;
        num.length += 2;
        // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
        var lo = 0;
        for(var i = 0; i < num.length; i++){
            var w = num.words[i] | 0;
            lo += w * 0x3d1;
            num.words[i] = lo & 0x3ffffff;
            lo = w * 0x40 + (lo / 0x4000000 | 0);
        }
        // Fast length reduction
        if (num.words[num.length - 1] === 0) {
            num.length--;
            if (num.words[num.length - 1] === 0) num.length--;
        }
        return num;
    };
    function P224() {
        MPrime.call(this, "p224", "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001");
    }
    inherits(P224, MPrime);
    function P192() {
        MPrime.call(this, "p192", "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff");
    }
    inherits(P192, MPrime);
    function P25519() {
        // 2 ^ 255 - 19
        MPrime.call(this, "25519", "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed");
    }
    inherits(P25519, MPrime);
    P25519.prototype.imulK = function imulK(num) {
        // K = 0x13
        var carry = 0;
        for(var i = 0; i < num.length; i++){
            var hi = (num.words[i] | 0) * 0x13 + carry;
            var lo = hi & 0x3ffffff;
            hi >>>= 26;
            num.words[i] = lo;
            carry = hi;
        }
        if (carry !== 0) num.words[num.length++] = carry;
        return num;
    };
    // Exported mostly for testing purposes, use plain name instead
    BN._prime = function prime(name) {
        // Cached version of prime
        if (primes[name]) return primes[name];
        var prime;
        if (name === "k256") prime = new K256();
        else if (name === "p224") prime = new P224();
        else if (name === "p192") prime = new P192();
        else if (name === "p25519") prime = new P25519();
        else throw new Error("Unknown prime " + name);
        primes[name] = prime;
        return prime;
    };
    //
    // Base reduction engine
    //
    function Red(m) {
        if (typeof m === "string") {
            var prime = BN._prime(m);
            this.m = prime.p;
            this.prime = prime;
        } else {
            assert(m.gtn(1), "modulus must be greater than 1");
            this.m = m;
            this.prime = null;
        }
    }
    Red.prototype._verify1 = function _verify1(a) {
        assert(a.negative === 0, "red works only with positives");
        assert(a.red, "red works only with red numbers");
    };
    Red.prototype._verify2 = function _verify2(a, b) {
        assert((a.negative | b.negative) === 0, "red works only with positives");
        assert(a.red && a.red === b.red, "red works only with red numbers");
    };
    Red.prototype.imod = function imod(a) {
        if (this.prime) return this.prime.ireduce(a)._forceRed(this);
        move(a, a.umod(this.m)._forceRed(this));
        return a;
    };
    Red.prototype.neg = function neg(a) {
        if (a.isZero()) return a.clone();
        return this.m.sub(a)._forceRed(this);
    };
    Red.prototype.add = function add(a, b) {
        this._verify2(a, b);
        var res = a.add(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res._forceRed(this);
    };
    Red.prototype.iadd = function iadd(a, b) {
        this._verify2(a, b);
        var res = a.iadd(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res;
    };
    Red.prototype.sub = function sub(a, b) {
        this._verify2(a, b);
        var res = a.sub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res._forceRed(this);
    };
    Red.prototype.isub = function isub(a, b) {
        this._verify2(a, b);
        var res = a.isub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res;
    };
    Red.prototype.shl = function shl(a, num) {
        this._verify1(a);
        return this.imod(a.ushln(num));
    };
    Red.prototype.imul = function imul(a, b) {
        this._verify2(a, b);
        return this.imod(a.imul(b));
    };
    Red.prototype.mul = function mul(a, b) {
        this._verify2(a, b);
        return this.imod(a.mul(b));
    };
    Red.prototype.isqr = function isqr(a) {
        return this.imul(a, a.clone());
    };
    Red.prototype.sqr = function sqr(a) {
        return this.mul(a, a);
    };
    Red.prototype.sqrt = function sqrt(a) {
        if (a.isZero()) return a.clone();
        var mod3 = this.m.andln(3);
        assert(mod3 % 2 === 1);
        // Fast case
        if (mod3 === 3) {
            var pow = this.m.add(new BN(1)).iushrn(2);
            return this.pow(a, pow);
        }
        // Tonelli-Shanks algorithm (Totally unoptimized and slow)
        //
        // Find Q and S, that Q * 2 ^ S = (P - 1)
        var q = this.m.subn(1);
        var s = 0;
        while(!q.isZero() && q.andln(1) === 0){
            s++;
            q.iushrn(1);
        }
        assert(!q.isZero());
        var one = new BN(1).toRed(this);
        var nOne = one.redNeg();
        // Find quadratic non-residue
        // NOTE: Max is such because of generalized Riemann hypothesis.
        var lpow = this.m.subn(1).iushrn(1);
        var z = this.m.bitLength();
        z = new BN(2 * z * z).toRed(this);
        while(this.pow(z, lpow).cmp(nOne) !== 0)z.redIAdd(nOne);
        var c = this.pow(z, q);
        var r = this.pow(a, q.addn(1).iushrn(1));
        var t = this.pow(a, q);
        var m = s;
        while(t.cmp(one) !== 0){
            var tmp = t;
            for(var i = 0; tmp.cmp(one) !== 0; i++)tmp = tmp.redSqr();
            assert(i < m);
            var b = this.pow(c, new BN(1).iushln(m - i - 1));
            r = r.redMul(b);
            c = b.redSqr();
            t = t.redMul(c);
            m = i;
        }
        return r;
    };
    Red.prototype.invm = function invm(a) {
        var inv = a._invmp(this.m);
        if (inv.negative !== 0) {
            inv.negative = 0;
            return this.imod(inv).redNeg();
        } else return this.imod(inv);
    };
    Red.prototype.pow = function pow(a, num) {
        if (num.isZero()) return new BN(1).toRed(this);
        if (num.cmpn(1) === 0) return a.clone();
        var windowSize = 4;
        var wnd = new Array(1 << windowSize);
        wnd[0] = new BN(1).toRed(this);
        wnd[1] = a;
        for(var i = 2; i < wnd.length; i++)wnd[i] = this.mul(wnd[i - 1], a);
        var res = wnd[0];
        var current = 0;
        var currentLen = 0;
        var start = num.bitLength() % 26;
        if (start === 0) start = 26;
        for(i = num.length - 1; i >= 0; i--){
            var word = num.words[i];
            for(var j = start - 1; j >= 0; j--){
                var bit = word >> j & 1;
                if (res !== wnd[0]) res = this.sqr(res);
                if (bit === 0 && current === 0) {
                    currentLen = 0;
                    continue;
                }
                current <<= 1;
                current |= bit;
                currentLen++;
                if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
                res = this.mul(res, wnd[current]);
                currentLen = 0;
                current = 0;
            }
            start = 26;
        }
        return res;
    };
    Red.prototype.convertTo = function convertTo(num) {
        var r = num.umod(this.m);
        return r === num ? r.clone() : r;
    };
    Red.prototype.convertFrom = function convertFrom(num) {
        var res = num.clone();
        res.red = null;
        return res;
    };
    //
    // Montgomery method engine
    //
    BN.mont = function mont(num) {
        return new Mont(num);
    };
    function Mont(m) {
        Red.call(this, m);
        this.shift = this.m.bitLength();
        if (this.shift % 26 !== 0) this.shift += 26 - this.shift % 26;
        this.r = new BN(1).iushln(this.shift);
        this.r2 = this.imod(this.r.sqr());
        this.rinv = this.r._invmp(this.m);
        this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
        this.minv = this.minv.umod(this.r);
        this.minv = this.r.sub(this.minv);
    }
    inherits(Mont, Red);
    Mont.prototype.convertTo = function convertTo(num) {
        return this.imod(num.ushln(this.shift));
    };
    Mont.prototype.convertFrom = function convertFrom(num) {
        var r = this.imod(num.mul(this.rinv));
        r.red = null;
        return r;
    };
    Mont.prototype.imul = function imul(a, b) {
        if (a.isZero() || b.isZero()) {
            a.words[0] = 0;
            a.length = 1;
            return a;
        }
        var t = a.imul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.mul = function mul(a, b) {
        if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
        var t = a.mul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.invm = function invm(a) {
        // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
        var res = this.imod(a._invmp(this.m).mul(this.r2));
        return res._forceRed(this);
    };
})(module, this);

},{"5a29d00af494ef3a":"13Pcp"}],"2871R":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.WalletLinkAnalytics = void 0;
class WalletLinkAnalytics {
    sendEvent(_eventType, _eventProperties) {
    // no-op
    }
}
exports.WalletLinkAnalytics = WalletLinkAnalytics;

},{}],"eB23X":[function(require,module,exports) {
"use strict";
var __createBinding = this && this.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, {
        enumerable: true,
        get: function() {
            return m[k];
        }
    });
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var __exportStar = this && this.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) __createBinding(exports1, m, p);
};
Object.defineProperty(exports, "__esModule", {
    value: true
});
__exportStar(require("969f29adec8a7c69"), exports);
__exportStar(require("292b36d1a7240ba4"), exports);

},{"969f29adec8a7c69":"3Jesk","292b36d1a7240ba4":"6pc83"}],"3Jesk":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.EVENTS = void 0;
exports.EVENTS = {
    REQUEST_CHILD_ETHEREUM_ACCOUNTS_START: "walletlink_sdk.request_child_ethereum_accounts.start",
    REQUEST_CHILD_ETHEREUM_ACCOUNTS_RESPONSE: "walletlink_sdk.request_child_ethereum_accounts.response",
    STARTED_CONNECTING: "walletlink_sdk.started.connecting",
    CONNECTED_STATE_CHANGE: "walletlink_sdk.connected",
    DISCONNECTED: "walletlink_sdk.disconnected",
    METADATA_DESTROYED: "walletlink_sdk_metadata_destroyed",
    LINKED: "walletlink_sdk.linked",
    FAILURE: "walletlink_sdk.generic_failure",
    SESSION_CONFIG_RECEIVED: "walletlink_sdk.session_config_event_received",
    ETH_ACCOUNTS_STATE: "walletlink_sdk.eth_accounts_state",
    SESSION_STATE_CHANGE: "walletlink_sdk.session_state_change",
    UNLINKED_ERROR_STATE: "walletlink_sdk.unlinked_error_state",
    SKIPPED_CLEARING_SESSION: "walletlink_sdk.skipped_clearing_session",
    GENERAL_ERROR: "walletlink_sdk.general_error",
    WEB3_REQUEST: "walletlink_sdk.web3.request",
    WEB3_REQUEST_PUBLISHED: "walletlink_sdk.web3.request_published",
    WEB3_RESPONSE: "walletlink_sdk.web3.response",
    UNKNOWN_ADDRESS_ENCOUNTERED: "walletlink_sdk.unknown_address_encountered"
};

},{}],"6pc83":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.WalletLinkAnalyticsAbstract = void 0;
/**
 * An abstract class used to send events to track metrics / analytics
 */ class WalletLinkAnalyticsAbstract {
}
exports.WalletLinkAnalyticsAbstract = WalletLinkAnalyticsAbstract;

},{}],"isBWC":[function(require,module,exports) {
"use strict";
// Copyright (c) 2018-2020 WalletLink.org <https://www.walletlink.org/>
// Copyright (c) 2018-2020 Coinbase, Inc. <https://www.coinbase.com/>
// Licensed under the Apache License, version 2.0
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Session = void 0;
const js_sha256_1 = require("ed5b36ce33e9c48d");
const rxjs_1 = require("861bef6ad2505891");
const operators_1 = require("7d54b1aae3038fdf");
const util_1 = require("5d90c93c38200fd3");
const STORAGE_KEY_SESSION_ID = "session:id";
const STORAGE_KEY_SESSION_SECRET = "session:secret";
const STORAGE_KEY_SESSION_LINKED = "session:linked";
class Session {
    constructor(storage, id, secret, linked){
        this._storage = storage;
        this._id = id || (0, util_1.randomBytesHex)(16);
        this._secret = secret || (0, util_1.randomBytesHex)(32);
        const hash = js_sha256_1.sha256.create();
        hash.update(`${this._id}, ${this._secret} WalletLink`);
        this._key = hash.hex();
        this._linked = !!linked;
    }
    static load(storage) {
        const id = storage.getItem(STORAGE_KEY_SESSION_ID);
        const linked = storage.getItem(STORAGE_KEY_SESSION_LINKED);
        const secret = storage.getItem(STORAGE_KEY_SESSION_SECRET);
        if (id && secret) return new Session(storage, id, secret, linked === "1");
        return null;
    }
    static get persistedSessionIdChange$() {
        return (0, rxjs_1.fromEvent)(window, "storage").pipe((0, operators_1.filter)((evt)=>evt.key === STORAGE_KEY_SESSION_ID), (0, operators_1.map)((evt)=>({
                oldValue: evt.oldValue || null,
                newValue: evt.newValue || null
            })));
    }
    /**
     * Takes in a session ID and returns the sha256 hash of it.
     * @param sessionId session ID
     */ static hash(sessionId) {
        const hash = js_sha256_1.sha256.create();
        return hash.update(sessionId).hex();
    }
    get id() {
        return this._id;
    }
    get secret() {
        return this._secret;
    }
    get key() {
        return this._key;
    }
    get linked() {
        return this._linked;
    }
    set linked(val) {
        this._linked = val;
        this.persistLinked();
    }
    save() {
        this._storage.setItem(STORAGE_KEY_SESSION_ID, this._id);
        this._storage.setItem(STORAGE_KEY_SESSION_SECRET, this._secret);
        this.persistLinked();
        return this;
    }
    persistLinked() {
        this._storage.setItem(STORAGE_KEY_SESSION_LINKED, this._linked ? "1" : "0");
    }
}
exports.Session = Session;

},{"ed5b36ce33e9c48d":"d6UjZ","861bef6ad2505891":"gxhPq","7d54b1aae3038fdf":"ggrIi","5d90c93c38200fd3":"9zvgH"}],"d6UjZ":[function(require,module,exports) {
var process = require("ee5fedc79f66d021");
var global = arguments[3];
/**
 * [js-sha256]{@link https://github.com/emn178/js-sha256}
 *
 * @version 0.9.0
 * @author Chen, Yi-Cyuan [emn178@gmail.com]
 * @copyright Chen, Yi-Cyuan 2014-2017
 * @license MIT
 */ /*jslint bitwise: true */ (function() {
    "use strict";
    var ERROR = "input is invalid type";
    var WINDOW = typeof window === "object";
    var root = WINDOW ? window : {};
    if (root.JS_SHA256_NO_WINDOW) WINDOW = false;
    var WEB_WORKER = !WINDOW && typeof self === "object";
    var NODE_JS = !root.JS_SHA256_NO_NODE_JS && typeof process === "object" && process.versions && process.versions.node;
    if (NODE_JS) root = global;
    else if (WEB_WORKER) root = self;
    var COMMON_JS = !root.JS_SHA256_NO_COMMON_JS && true && module.exports;
    var AMD = typeof define === "function" && define.amd;
    var ARRAY_BUFFER = !root.JS_SHA256_NO_ARRAY_BUFFER && typeof ArrayBuffer !== "undefined";
    var HEX_CHARS = "0123456789abcdef".split("");
    var EXTRA = [
        -2147483648,
        8388608,
        32768,
        128
    ];
    var SHIFT = [
        24,
        16,
        8,
        0
    ];
    var K = [
        0x428a2f98,
        0x71374491,
        0xb5c0fbcf,
        0xe9b5dba5,
        0x3956c25b,
        0x59f111f1,
        0x923f82a4,
        0xab1c5ed5,
        0xd807aa98,
        0x12835b01,
        0x243185be,
        0x550c7dc3,
        0x72be5d74,
        0x80deb1fe,
        0x9bdc06a7,
        0xc19bf174,
        0xe49b69c1,
        0xefbe4786,
        0x0fc19dc6,
        0x240ca1cc,
        0x2de92c6f,
        0x4a7484aa,
        0x5cb0a9dc,
        0x76f988da,
        0x983e5152,
        0xa831c66d,
        0xb00327c8,
        0xbf597fc7,
        0xc6e00bf3,
        0xd5a79147,
        0x06ca6351,
        0x14292967,
        0x27b70a85,
        0x2e1b2138,
        0x4d2c6dfc,
        0x53380d13,
        0x650a7354,
        0x766a0abb,
        0x81c2c92e,
        0x92722c85,
        0xa2bfe8a1,
        0xa81a664b,
        0xc24b8b70,
        0xc76c51a3,
        0xd192e819,
        0xd6990624,
        0xf40e3585,
        0x106aa070,
        0x19a4c116,
        0x1e376c08,
        0x2748774c,
        0x34b0bcb5,
        0x391c0cb3,
        0x4ed8aa4a,
        0x5b9cca4f,
        0x682e6ff3,
        0x748f82ee,
        0x78a5636f,
        0x84c87814,
        0x8cc70208,
        0x90befffa,
        0xa4506ceb,
        0xbef9a3f7,
        0xc67178f2
    ];
    var OUTPUT_TYPES = [
        "hex",
        "array",
        "digest",
        "arrayBuffer"
    ];
    var blocks = [];
    if (root.JS_SHA256_NO_NODE_JS || !Array.isArray) Array.isArray = function(obj) {
        return Object.prototype.toString.call(obj) === "[object Array]";
    };
    if (ARRAY_BUFFER && (root.JS_SHA256_NO_ARRAY_BUFFER_IS_VIEW || !ArrayBuffer.isView)) ArrayBuffer.isView = function(obj) {
        return typeof obj === "object" && obj.buffer && obj.buffer.constructor === ArrayBuffer;
    };
    var createOutputMethod = function(outputType, is224) {
        return function(message) {
            return new Sha256(is224, true).update(message)[outputType]();
        };
    };
    var createMethod = function(is224) {
        var method = createOutputMethod("hex", is224);
        if (NODE_JS) method = nodeWrap(method, is224);
        method.create = function() {
            return new Sha256(is224);
        };
        method.update = function(message) {
            return method.create().update(message);
        };
        for(var i = 0; i < OUTPUT_TYPES.length; ++i){
            var type = OUTPUT_TYPES[i];
            method[type] = createOutputMethod(type, is224);
        }
        return method;
    };
    var nodeWrap = function(method, is224) {
        var crypto = eval("require('crypto')");
        var Buffer = eval("require('buffer').Buffer");
        var algorithm = is224 ? "sha224" : "sha256";
        var nodeMethod = function(message) {
            if (typeof message === "string") return crypto.createHash(algorithm).update(message, "utf8").digest("hex");
            else {
                if (message === null || message === undefined) throw new Error(ERROR);
                else if (message.constructor === ArrayBuffer) message = new Uint8Array(message);
            }
            if (Array.isArray(message) || ArrayBuffer.isView(message) || message.constructor === Buffer) return crypto.createHash(algorithm).update(new Buffer(message)).digest("hex");
            else return method(message);
        };
        return nodeMethod;
    };
    var createHmacOutputMethod = function(outputType, is224) {
        return function(key, message) {
            return new HmacSha256(key, is224, true).update(message)[outputType]();
        };
    };
    var createHmacMethod = function(is224) {
        var method = createHmacOutputMethod("hex", is224);
        method.create = function(key) {
            return new HmacSha256(key, is224);
        };
        method.update = function(key, message) {
            return method.create(key).update(message);
        };
        for(var i = 0; i < OUTPUT_TYPES.length; ++i){
            var type = OUTPUT_TYPES[i];
            method[type] = createHmacOutputMethod(type, is224);
        }
        return method;
    };
    function Sha256(is224, sharedMemory) {
        if (sharedMemory) {
            blocks[0] = blocks[16] = blocks[1] = blocks[2] = blocks[3] = blocks[4] = blocks[5] = blocks[6] = blocks[7] = blocks[8] = blocks[9] = blocks[10] = blocks[11] = blocks[12] = blocks[13] = blocks[14] = blocks[15] = 0;
            this.blocks = blocks;
        } else this.blocks = [
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ];
        if (is224) {
            this.h0 = 0xc1059ed8;
            this.h1 = 0x367cd507;
            this.h2 = 0x3070dd17;
            this.h3 = 0xf70e5939;
            this.h4 = 0xffc00b31;
            this.h5 = 0x68581511;
            this.h6 = 0x64f98fa7;
            this.h7 = 0xbefa4fa4;
        } else {
            this.h0 = 0x6a09e667;
            this.h1 = 0xbb67ae85;
            this.h2 = 0x3c6ef372;
            this.h3 = 0xa54ff53a;
            this.h4 = 0x510e527f;
            this.h5 = 0x9b05688c;
            this.h6 = 0x1f83d9ab;
            this.h7 = 0x5be0cd19;
        }
        this.block = this.start = this.bytes = this.hBytes = 0;
        this.finalized = this.hashed = false;
        this.first = true;
        this.is224 = is224;
    }
    Sha256.prototype.update = function(message) {
        if (this.finalized) return;
        var notString, type = typeof message;
        if (type !== "string") {
            if (type === "object") {
                if (message === null) throw new Error(ERROR);
                else if (ARRAY_BUFFER && message.constructor === ArrayBuffer) message = new Uint8Array(message);
                else if (!Array.isArray(message)) {
                    if (!ARRAY_BUFFER || !ArrayBuffer.isView(message)) throw new Error(ERROR);
                }
            } else throw new Error(ERROR);
            notString = true;
        }
        var code, index = 0, i, length = message.length, blocks = this.blocks;
        while(index < length){
            if (this.hashed) {
                this.hashed = false;
                blocks[0] = this.block;
                blocks[16] = blocks[1] = blocks[2] = blocks[3] = blocks[4] = blocks[5] = blocks[6] = blocks[7] = blocks[8] = blocks[9] = blocks[10] = blocks[11] = blocks[12] = blocks[13] = blocks[14] = blocks[15] = 0;
            }
            if (notString) for(i = this.start; index < length && i < 64; ++index)blocks[i >> 2] |= message[index] << SHIFT[i++ & 3];
            else for(i = this.start; index < length && i < 64; ++index){
                code = message.charCodeAt(index);
                if (code < 0x80) blocks[i >> 2] |= code << SHIFT[i++ & 3];
                else if (code < 0x800) {
                    blocks[i >> 2] |= (0xc0 | code >> 6) << SHIFT[i++ & 3];
                    blocks[i >> 2] |= (0x80 | code & 0x3f) << SHIFT[i++ & 3];
                } else if (code < 0xd800 || code >= 0xe000) {
                    blocks[i >> 2] |= (0xe0 | code >> 12) << SHIFT[i++ & 3];
                    blocks[i >> 2] |= (0x80 | code >> 6 & 0x3f) << SHIFT[i++ & 3];
                    blocks[i >> 2] |= (0x80 | code & 0x3f) << SHIFT[i++ & 3];
                } else {
                    code = 0x10000 + ((code & 0x3ff) << 10 | message.charCodeAt(++index) & 0x3ff);
                    blocks[i >> 2] |= (0xf0 | code >> 18) << SHIFT[i++ & 3];
                    blocks[i >> 2] |= (0x80 | code >> 12 & 0x3f) << SHIFT[i++ & 3];
                    blocks[i >> 2] |= (0x80 | code >> 6 & 0x3f) << SHIFT[i++ & 3];
                    blocks[i >> 2] |= (0x80 | code & 0x3f) << SHIFT[i++ & 3];
                }
            }
            this.lastByteIndex = i;
            this.bytes += i - this.start;
            if (i >= 64) {
                this.block = blocks[16];
                this.start = i - 64;
                this.hash();
                this.hashed = true;
            } else this.start = i;
        }
        if (this.bytes > 4294967295) {
            this.hBytes += this.bytes / 4294967296 << 0;
            this.bytes = this.bytes % 4294967296;
        }
        return this;
    };
    Sha256.prototype.finalize = function() {
        if (this.finalized) return;
        this.finalized = true;
        var blocks = this.blocks, i = this.lastByteIndex;
        blocks[16] = this.block;
        blocks[i >> 2] |= EXTRA[i & 3];
        this.block = blocks[16];
        if (i >= 56) {
            if (!this.hashed) this.hash();
            blocks[0] = this.block;
            blocks[16] = blocks[1] = blocks[2] = blocks[3] = blocks[4] = blocks[5] = blocks[6] = blocks[7] = blocks[8] = blocks[9] = blocks[10] = blocks[11] = blocks[12] = blocks[13] = blocks[14] = blocks[15] = 0;
        }
        blocks[14] = this.hBytes << 3 | this.bytes >>> 29;
        blocks[15] = this.bytes << 3;
        this.hash();
    };
    Sha256.prototype.hash = function() {
        var a = this.h0, b = this.h1, c = this.h2, d = this.h3, e = this.h4, f = this.h5, g = this.h6, h = this.h7, blocks = this.blocks, j, s0, s1, maj, t1, t2, ch, ab, da, cd, bc;
        for(j = 16; j < 64; ++j){
            // rightrotate
            t1 = blocks[j - 15];
            s0 = (t1 >>> 7 | t1 << 25) ^ (t1 >>> 18 | t1 << 14) ^ t1 >>> 3;
            t1 = blocks[j - 2];
            s1 = (t1 >>> 17 | t1 << 15) ^ (t1 >>> 19 | t1 << 13) ^ t1 >>> 10;
            blocks[j] = blocks[j - 16] + s0 + blocks[j - 7] + s1 << 0;
        }
        bc = b & c;
        for(j = 0; j < 64; j += 4){
            if (this.first) {
                if (this.is224) {
                    ab = 300032;
                    t1 = blocks[0] - 1413257819;
                    h = t1 - 150054599 << 0;
                    d = t1 + 24177077 << 0;
                } else {
                    ab = 704751109;
                    t1 = blocks[0] - 210244248;
                    h = t1 - 1521486534 << 0;
                    d = t1 + 143694565 << 0;
                }
                this.first = false;
            } else {
                s0 = (a >>> 2 | a << 30) ^ (a >>> 13 | a << 19) ^ (a >>> 22 | a << 10);
                s1 = (e >>> 6 | e << 26) ^ (e >>> 11 | e << 21) ^ (e >>> 25 | e << 7);
                ab = a & b;
                maj = ab ^ a & c ^ bc;
                ch = e & f ^ ~e & g;
                t1 = h + s1 + ch + K[j] + blocks[j];
                t2 = s0 + maj;
                h = d + t1 << 0;
                d = t1 + t2 << 0;
            }
            s0 = (d >>> 2 | d << 30) ^ (d >>> 13 | d << 19) ^ (d >>> 22 | d << 10);
            s1 = (h >>> 6 | h << 26) ^ (h >>> 11 | h << 21) ^ (h >>> 25 | h << 7);
            da = d & a;
            maj = da ^ d & b ^ ab;
            ch = h & e ^ ~h & f;
            t1 = g + s1 + ch + K[j + 1] + blocks[j + 1];
            t2 = s0 + maj;
            g = c + t1 << 0;
            c = t1 + t2 << 0;
            s0 = (c >>> 2 | c << 30) ^ (c >>> 13 | c << 19) ^ (c >>> 22 | c << 10);
            s1 = (g >>> 6 | g << 26) ^ (g >>> 11 | g << 21) ^ (g >>> 25 | g << 7);
            cd = c & d;
            maj = cd ^ c & a ^ da;
            ch = g & h ^ ~g & e;
            t1 = f + s1 + ch + K[j + 2] + blocks[j + 2];
            t2 = s0 + maj;
            f = b + t1 << 0;
            b = t1 + t2 << 0;
            s0 = (b >>> 2 | b << 30) ^ (b >>> 13 | b << 19) ^ (b >>> 22 | b << 10);
            s1 = (f >>> 6 | f << 26) ^ (f >>> 11 | f << 21) ^ (f >>> 25 | f << 7);
            bc = b & c;
            maj = bc ^ b & d ^ cd;
            ch = f & g ^ ~f & h;
            t1 = e + s1 + ch + K[j + 3] + blocks[j + 3];
            t2 = s0 + maj;
            e = a + t1 << 0;
            a = t1 + t2 << 0;
        }
        this.h0 = this.h0 + a << 0;
        this.h1 = this.h1 + b << 0;
        this.h2 = this.h2 + c << 0;
        this.h3 = this.h3 + d << 0;
        this.h4 = this.h4 + e << 0;
        this.h5 = this.h5 + f << 0;
        this.h6 = this.h6 + g << 0;
        this.h7 = this.h7 + h << 0;
    };
    Sha256.prototype.hex = function() {
        this.finalize();
        var h0 = this.h0, h1 = this.h1, h2 = this.h2, h3 = this.h3, h4 = this.h4, h5 = this.h5, h6 = this.h6, h7 = this.h7;
        var hex = HEX_CHARS[h0 >> 28 & 0x0F] + HEX_CHARS[h0 >> 24 & 0x0F] + HEX_CHARS[h0 >> 20 & 0x0F] + HEX_CHARS[h0 >> 16 & 0x0F] + HEX_CHARS[h0 >> 12 & 0x0F] + HEX_CHARS[h0 >> 8 & 0x0F] + HEX_CHARS[h0 >> 4 & 0x0F] + HEX_CHARS[h0 & 0x0F] + HEX_CHARS[h1 >> 28 & 0x0F] + HEX_CHARS[h1 >> 24 & 0x0F] + HEX_CHARS[h1 >> 20 & 0x0F] + HEX_CHARS[h1 >> 16 & 0x0F] + HEX_CHARS[h1 >> 12 & 0x0F] + HEX_CHARS[h1 >> 8 & 0x0F] + HEX_CHARS[h1 >> 4 & 0x0F] + HEX_CHARS[h1 & 0x0F] + HEX_CHARS[h2 >> 28 & 0x0F] + HEX_CHARS[h2 >> 24 & 0x0F] + HEX_CHARS[h2 >> 20 & 0x0F] + HEX_CHARS[h2 >> 16 & 0x0F] + HEX_CHARS[h2 >> 12 & 0x0F] + HEX_CHARS[h2 >> 8 & 0x0F] + HEX_CHARS[h2 >> 4 & 0x0F] + HEX_CHARS[h2 & 0x0F] + HEX_CHARS[h3 >> 28 & 0x0F] + HEX_CHARS[h3 >> 24 & 0x0F] + HEX_CHARS[h3 >> 20 & 0x0F] + HEX_CHARS[h3 >> 16 & 0x0F] + HEX_CHARS[h3 >> 12 & 0x0F] + HEX_CHARS[h3 >> 8 & 0x0F] + HEX_CHARS[h3 >> 4 & 0x0F] + HEX_CHARS[h3 & 0x0F] + HEX_CHARS[h4 >> 28 & 0x0F] + HEX_CHARS[h4 >> 24 & 0x0F] + HEX_CHARS[h4 >> 20 & 0x0F] + HEX_CHARS[h4 >> 16 & 0x0F] + HEX_CHARS[h4 >> 12 & 0x0F] + HEX_CHARS[h4 >> 8 & 0x0F] + HEX_CHARS[h4 >> 4 & 0x0F] + HEX_CHARS[h4 & 0x0F] + HEX_CHARS[h5 >> 28 & 0x0F] + HEX_CHARS[h5 >> 24 & 0x0F] + HEX_CHARS[h5 >> 20 & 0x0F] + HEX_CHARS[h5 >> 16 & 0x0F] + HEX_CHARS[h5 >> 12 & 0x0F] + HEX_CHARS[h5 >> 8 & 0x0F] + HEX_CHARS[h5 >> 4 & 0x0F] + HEX_CHARS[h5 & 0x0F] + HEX_CHARS[h6 >> 28 & 0x0F] + HEX_CHARS[h6 >> 24 & 0x0F] + HEX_CHARS[h6 >> 20 & 0x0F] + HEX_CHARS[h6 >> 16 & 0x0F] + HEX_CHARS[h6 >> 12 & 0x0F] + HEX_CHARS[h6 >> 8 & 0x0F] + HEX_CHARS[h6 >> 4 & 0x0F] + HEX_CHARS[h6 & 0x0F];
        if (!this.is224) hex += HEX_CHARS[h7 >> 28 & 0x0F] + HEX_CHARS[h7 >> 24 & 0x0F] + HEX_CHARS[h7 >> 20 & 0x0F] + HEX_CHARS[h7 >> 16 & 0x0F] + HEX_CHARS[h7 >> 12 & 0x0F] + HEX_CHARS[h7 >> 8 & 0x0F] + HEX_CHARS[h7 >> 4 & 0x0F] + HEX_CHARS[h7 & 0x0F];
        return hex;
    };
    Sha256.prototype.toString = Sha256.prototype.hex;
    Sha256.prototype.digest = function() {
        this.finalize();
        var h0 = this.h0, h1 = this.h1, h2 = this.h2, h3 = this.h3, h4 = this.h4, h5 = this.h5, h6 = this.h6, h7 = this.h7;
        var arr = [
            h0 >> 24 & 0xFF,
            h0 >> 16 & 0xFF,
            h0 >> 8 & 0xFF,
            h0 & 0xFF,
            h1 >> 24 & 0xFF,
            h1 >> 16 & 0xFF,
            h1 >> 8 & 0xFF,
            h1 & 0xFF,
            h2 >> 24 & 0xFF,
            h2 >> 16 & 0xFF,
            h2 >> 8 & 0xFF,
            h2 & 0xFF,
            h3 >> 24 & 0xFF,
            h3 >> 16 & 0xFF,
            h3 >> 8 & 0xFF,
            h3 & 0xFF,
            h4 >> 24 & 0xFF,
            h4 >> 16 & 0xFF,
            h4 >> 8 & 0xFF,
            h4 & 0xFF,
            h5 >> 24 & 0xFF,
            h5 >> 16 & 0xFF,
            h5 >> 8 & 0xFF,
            h5 & 0xFF,
            h6 >> 24 & 0xFF,
            h6 >> 16 & 0xFF,
            h6 >> 8 & 0xFF,
            h6 & 0xFF
        ];
        if (!this.is224) arr.push(h7 >> 24 & 0xFF, h7 >> 16 & 0xFF, h7 >> 8 & 0xFF, h7 & 0xFF);
        return arr;
    };
    Sha256.prototype.array = Sha256.prototype.digest;
    Sha256.prototype.arrayBuffer = function() {
        this.finalize();
        var buffer = new ArrayBuffer(this.is224 ? 28 : 32);
        var dataView = new DataView(buffer);
        dataView.setUint32(0, this.h0);
        dataView.setUint32(4, this.h1);
        dataView.setUint32(8, this.h2);
        dataView.setUint32(12, this.h3);
        dataView.setUint32(16, this.h4);
        dataView.setUint32(20, this.h5);
        dataView.setUint32(24, this.h6);
        if (!this.is224) dataView.setUint32(28, this.h7);
        return buffer;
    };
    function HmacSha256(key, is224, sharedMemory) {
        var i, type = typeof key;
        if (type === "string") {
            var bytes = [], length = key.length, index = 0, code;
            for(i = 0; i < length; ++i){
                code = key.charCodeAt(i);
                if (code < 0x80) bytes[index++] = code;
                else if (code < 0x800) {
                    bytes[index++] = 0xc0 | code >> 6;
                    bytes[index++] = 0x80 | code & 0x3f;
                } else if (code < 0xd800 || code >= 0xe000) {
                    bytes[index++] = 0xe0 | code >> 12;
                    bytes[index++] = 0x80 | code >> 6 & 0x3f;
                    bytes[index++] = 0x80 | code & 0x3f;
                } else {
                    code = 0x10000 + ((code & 0x3ff) << 10 | key.charCodeAt(++i) & 0x3ff);
                    bytes[index++] = 0xf0 | code >> 18;
                    bytes[index++] = 0x80 | code >> 12 & 0x3f;
                    bytes[index++] = 0x80 | code >> 6 & 0x3f;
                    bytes[index++] = 0x80 | code & 0x3f;
                }
            }
            key = bytes;
        } else {
            if (type === "object") {
                if (key === null) throw new Error(ERROR);
                else if (ARRAY_BUFFER && key.constructor === ArrayBuffer) key = new Uint8Array(key);
                else if (!Array.isArray(key)) {
                    if (!ARRAY_BUFFER || !ArrayBuffer.isView(key)) throw new Error(ERROR);
                }
            } else throw new Error(ERROR);
        }
        if (key.length > 64) key = new Sha256(is224, true).update(key).array();
        var oKeyPad = [], iKeyPad = [];
        for(i = 0; i < 64; ++i){
            var b = key[i] || 0;
            oKeyPad[i] = 0x5c ^ b;
            iKeyPad[i] = 0x36 ^ b;
        }
        Sha256.call(this, is224, sharedMemory);
        this.update(iKeyPad);
        this.oKeyPad = oKeyPad;
        this.inner = true;
        this.sharedMemory = sharedMemory;
    }
    HmacSha256.prototype = new Sha256();
    HmacSha256.prototype.finalize = function() {
        Sha256.prototype.finalize.call(this);
        if (this.inner) {
            this.inner = false;
            var innerHash = this.array();
            Sha256.call(this, this.is224, this.sharedMemory);
            this.update(this.oKeyPad);
            this.update(innerHash);
            Sha256.prototype.finalize.call(this);
        }
    };
    var exports = createMethod();
    exports.sha256 = exports;
    exports.sha224 = createMethod(true);
    exports.sha256.hmac = createHmacMethod();
    exports.sha224.hmac = createHmacMethod(true);
    if (COMMON_JS) module.exports = exports;
    else {
        root.sha256 = exports.sha256;
        root.sha224 = exports.sha224;
        if (AMD) define(function() {
            return exports;
        });
    }
})();

},{"ee5fedc79f66d021":"5QIF0"}],"gxhPq":[function(require,module,exports) {
/** PURE_IMPORTS_START  PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Observable", ()=>(0, _observable.Observable));
parcelHelpers.export(exports, "ConnectableObservable", ()=>(0, _connectableObservable.ConnectableObservable));
parcelHelpers.export(exports, "GroupedObservable", ()=>(0, _groupBy.GroupedObservable));
parcelHelpers.export(exports, "observable", ()=>(0, _observable1.observable));
parcelHelpers.export(exports, "Subject", ()=>(0, _subject.Subject));
parcelHelpers.export(exports, "BehaviorSubject", ()=>(0, _behaviorSubject.BehaviorSubject));
parcelHelpers.export(exports, "ReplaySubject", ()=>(0, _replaySubject.ReplaySubject));
parcelHelpers.export(exports, "AsyncSubject", ()=>(0, _asyncSubject.AsyncSubject));
parcelHelpers.export(exports, "asap", ()=>(0, _asap.asap));
parcelHelpers.export(exports, "asapScheduler", ()=>(0, _asap.asapScheduler));
parcelHelpers.export(exports, "async", ()=>(0, _async.async));
parcelHelpers.export(exports, "asyncScheduler", ()=>(0, _async.asyncScheduler));
parcelHelpers.export(exports, "queue", ()=>(0, _queue.queue));
parcelHelpers.export(exports, "queueScheduler", ()=>(0, _queue.queueScheduler));
parcelHelpers.export(exports, "animationFrame", ()=>(0, _animationFrame.animationFrame));
parcelHelpers.export(exports, "animationFrameScheduler", ()=>(0, _animationFrame.animationFrameScheduler));
parcelHelpers.export(exports, "VirtualTimeScheduler", ()=>(0, _virtualTimeScheduler.VirtualTimeScheduler));
parcelHelpers.export(exports, "VirtualAction", ()=>(0, _virtualTimeScheduler.VirtualAction));
parcelHelpers.export(exports, "Scheduler", ()=>(0, _scheduler.Scheduler));
parcelHelpers.export(exports, "Subscription", ()=>(0, _subscription.Subscription));
parcelHelpers.export(exports, "Subscriber", ()=>(0, _subscriber.Subscriber));
parcelHelpers.export(exports, "Notification", ()=>(0, _notification.Notification));
parcelHelpers.export(exports, "NotificationKind", ()=>(0, _notification.NotificationKind));
parcelHelpers.export(exports, "pipe", ()=>(0, _pipe.pipe));
parcelHelpers.export(exports, "noop", ()=>(0, _noop.noop));
parcelHelpers.export(exports, "identity", ()=>(0, _identity.identity));
parcelHelpers.export(exports, "isObservable", ()=>(0, _isObservable.isObservable));
parcelHelpers.export(exports, "ArgumentOutOfRangeError", ()=>(0, _argumentOutOfRangeError.ArgumentOutOfRangeError));
parcelHelpers.export(exports, "EmptyError", ()=>(0, _emptyError.EmptyError));
parcelHelpers.export(exports, "ObjectUnsubscribedError", ()=>(0, _objectUnsubscribedError.ObjectUnsubscribedError));
parcelHelpers.export(exports, "UnsubscriptionError", ()=>(0, _unsubscriptionError.UnsubscriptionError));
parcelHelpers.export(exports, "TimeoutError", ()=>(0, _timeoutError.TimeoutError));
parcelHelpers.export(exports, "bindCallback", ()=>(0, _bindCallback.bindCallback));
parcelHelpers.export(exports, "bindNodeCallback", ()=>(0, _bindNodeCallback.bindNodeCallback));
parcelHelpers.export(exports, "combineLatest", ()=>(0, _combineLatest.combineLatest));
parcelHelpers.export(exports, "concat", ()=>(0, _concat.concat));
parcelHelpers.export(exports, "defer", ()=>(0, _defer.defer));
parcelHelpers.export(exports, "empty", ()=>(0, _empty.empty));
parcelHelpers.export(exports, "forkJoin", ()=>(0, _forkJoin.forkJoin));
parcelHelpers.export(exports, "from", ()=>(0, _from.from));
parcelHelpers.export(exports, "fromEvent", ()=>(0, _fromEvent.fromEvent));
parcelHelpers.export(exports, "fromEventPattern", ()=>(0, _fromEventPattern.fromEventPattern));
parcelHelpers.export(exports, "generate", ()=>(0, _generate.generate));
parcelHelpers.export(exports, "iif", ()=>(0, _iif.iif));
parcelHelpers.export(exports, "interval", ()=>(0, _interval.interval));
parcelHelpers.export(exports, "merge", ()=>(0, _merge.merge));
parcelHelpers.export(exports, "never", ()=>(0, _never.never));
parcelHelpers.export(exports, "of", ()=>(0, _of.of));
parcelHelpers.export(exports, "onErrorResumeNext", ()=>(0, _onErrorResumeNext.onErrorResumeNext));
parcelHelpers.export(exports, "pairs", ()=>(0, _pairs.pairs));
parcelHelpers.export(exports, "partition", ()=>(0, _partition.partition));
parcelHelpers.export(exports, "race", ()=>(0, _race.race));
parcelHelpers.export(exports, "range", ()=>(0, _range.range));
parcelHelpers.export(exports, "throwError", ()=>(0, _throwError.throwError));
parcelHelpers.export(exports, "timer", ()=>(0, _timer.timer));
parcelHelpers.export(exports, "using", ()=>(0, _using.using));
parcelHelpers.export(exports, "zip", ()=>(0, _zip.zip));
parcelHelpers.export(exports, "scheduled", ()=>(0, _scheduled.scheduled));
parcelHelpers.export(exports, "EMPTY", ()=>(0, _empty.EMPTY));
parcelHelpers.export(exports, "NEVER", ()=>(0, _never.NEVER));
parcelHelpers.export(exports, "config", ()=>(0, _config.config));
var _observable = require("./internal/Observable");
var _connectableObservable = require("./internal/observable/ConnectableObservable");
var _groupBy = require("./internal/operators/groupBy");
var _observable1 = require("./internal/symbol/observable");
var _subject = require("./internal/Subject");
var _behaviorSubject = require("./internal/BehaviorSubject");
var _replaySubject = require("./internal/ReplaySubject");
var _asyncSubject = require("./internal/AsyncSubject");
var _asap = require("./internal/scheduler/asap");
var _async = require("./internal/scheduler/async");
var _queue = require("./internal/scheduler/queue");
var _animationFrame = require("./internal/scheduler/animationFrame");
var _virtualTimeScheduler = require("./internal/scheduler/VirtualTimeScheduler");
var _scheduler = require("./internal/Scheduler");
var _subscription = require("./internal/Subscription");
var _subscriber = require("./internal/Subscriber");
var _notification = require("./internal/Notification");
var _pipe = require("./internal/util/pipe");
var _noop = require("./internal/util/noop");
var _identity = require("./internal/util/identity");
var _isObservable = require("./internal/util/isObservable");
var _argumentOutOfRangeError = require("./internal/util/ArgumentOutOfRangeError");
var _emptyError = require("./internal/util/EmptyError");
var _objectUnsubscribedError = require("./internal/util/ObjectUnsubscribedError");
var _unsubscriptionError = require("./internal/util/UnsubscriptionError");
var _timeoutError = require("./internal/util/TimeoutError");
var _bindCallback = require("./internal/observable/bindCallback");
var _bindNodeCallback = require("./internal/observable/bindNodeCallback");
var _combineLatest = require("./internal/observable/combineLatest");
var _concat = require("./internal/observable/concat");
var _defer = require("./internal/observable/defer");
var _empty = require("./internal/observable/empty");
var _forkJoin = require("./internal/observable/forkJoin");
var _from = require("./internal/observable/from");
var _fromEvent = require("./internal/observable/fromEvent");
var _fromEventPattern = require("./internal/observable/fromEventPattern");
var _generate = require("./internal/observable/generate");
var _iif = require("./internal/observable/iif");
var _interval = require("./internal/observable/interval");
var _merge = require("./internal/observable/merge");
var _never = require("./internal/observable/never");
var _of = require("./internal/observable/of");
var _onErrorResumeNext = require("./internal/observable/onErrorResumeNext");
var _pairs = require("./internal/observable/pairs");
var _partition = require("./internal/observable/partition");
var _race = require("./internal/observable/race");
var _range = require("./internal/observable/range");
var _throwError = require("./internal/observable/throwError");
var _timer = require("./internal/observable/timer");
var _using = require("./internal/observable/using");
var _zip = require("./internal/observable/zip");
var _scheduled = require("./internal/scheduled/scheduled");
var _config = require("./internal/config");

},{"./internal/Observable":"9oc0x","./internal/observable/ConnectableObservable":"f4mOY","./internal/operators/groupBy":"g6z19","./internal/symbol/observable":"9l5a7","./internal/Subject":"84bef","./internal/BehaviorSubject":"anOW9","./internal/ReplaySubject":"gRMu9","./internal/AsyncSubject":"6P7LP","./internal/scheduler/asap":"5Pp9f","./internal/scheduler/async":"l1cmn","./internal/scheduler/queue":"9CC3u","./internal/scheduler/animationFrame":"5JNHq","./internal/scheduler/VirtualTimeScheduler":"5SGjm","./internal/Scheduler":"7PKfs","./internal/Subscription":"ahthJ","./internal/Subscriber":"jGx8F","./internal/Notification":"3c26n","./internal/util/pipe":"4asJs","./internal/util/noop":"4s4qZ","./internal/util/identity":"kDT9y","./internal/util/isObservable":"6AlwM","./internal/util/ArgumentOutOfRangeError":"38Gbx","./internal/util/EmptyError":"7a4tA","./internal/util/ObjectUnsubscribedError":"xtsCl","./internal/util/UnsubscriptionError":"byliX","./internal/util/TimeoutError":"iA33G","./internal/observable/bindCallback":"28HCa","./internal/observable/bindNodeCallback":"aiFEB","./internal/observable/combineLatest":"wg3KP","./internal/observable/concat":"2cXL0","./internal/observable/defer":"1uvAg","./internal/observable/empty":"J4JDz","./internal/observable/forkJoin":"37dhH","./internal/observable/from":"6aqs0","./internal/observable/fromEvent":"7pSEN","./internal/observable/fromEventPattern":"fxxhB","./internal/observable/generate":"fBVaJ","./internal/observable/iif":"17pPY","./internal/observable/interval":"fMFuc","./internal/observable/merge":"38GKY","./internal/observable/never":"3FrL8","./internal/observable/of":"alTvf","./internal/observable/onErrorResumeNext":"hm3A5","./internal/observable/pairs":"iTEBj","./internal/observable/partition":"8Djd6","./internal/observable/race":"6YL9k","./internal/observable/range":"cuk43","./internal/observable/throwError":"4BUNm","./internal/observable/timer":"jufOf","./internal/observable/using":"jpgyo","./internal/observable/zip":"57TWv","./internal/scheduled/scheduled":"3d02Q","./internal/config":"aKksQ","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9oc0x":[function(require,module,exports) {
/** PURE_IMPORTS_START _util_canReportError,_util_toSubscriber,_symbol_observable,_util_pipe,_config PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Observable", ()=>Observable);
var _canReportError = require("./util/canReportError");
var _toSubscriber = require("./util/toSubscriber");
var _observable = require("./symbol/observable");
var _pipe = require("./util/pipe");
var _config = require("./config");
var Observable = /*@__PURE__*/ function() {
    function Observable(subscribe) {
        this._isScalar = false;
        if (subscribe) this._subscribe = subscribe;
    }
    Observable.prototype.lift = function(operator) {
        var observable = new Observable();
        observable.source = this;
        observable.operator = operator;
        return observable;
    };
    Observable.prototype.subscribe = function(observerOrNext, error, complete) {
        var operator = this.operator;
        var sink = (0, _toSubscriber.toSubscriber)(observerOrNext, error, complete);
        if (operator) sink.add(operator.call(sink, this.source));
        else sink.add(this.source || (0, _config.config).useDeprecatedSynchronousErrorHandling && !sink.syncErrorThrowable ? this._subscribe(sink) : this._trySubscribe(sink));
        if ((0, _config.config).useDeprecatedSynchronousErrorHandling) {
            if (sink.syncErrorThrowable) {
                sink.syncErrorThrowable = false;
                if (sink.syncErrorThrown) throw sink.syncErrorValue;
            }
        }
        return sink;
    };
    Observable.prototype._trySubscribe = function(sink) {
        try {
            return this._subscribe(sink);
        } catch (err) {
            if ((0, _config.config).useDeprecatedSynchronousErrorHandling) {
                sink.syncErrorThrown = true;
                sink.syncErrorValue = err;
            }
            if ((0, _canReportError.canReportError)(sink)) sink.error(err);
            else console.warn(err);
        }
    };
    Observable.prototype.forEach = function(next, promiseCtor) {
        var _this = this;
        promiseCtor = getPromiseCtor(promiseCtor);
        return new promiseCtor(function(resolve, reject) {
            var subscription;
            subscription = _this.subscribe(function(value) {
                try {
                    next(value);
                } catch (err) {
                    reject(err);
                    if (subscription) subscription.unsubscribe();
                }
            }, reject, resolve);
        });
    };
    Observable.prototype._subscribe = function(subscriber) {
        var source = this.source;
        return source && source.subscribe(subscriber);
    };
    Observable.prototype[0, _observable.observable] = function() {
        return this;
    };
    Observable.prototype.pipe = function() {
        var operations = [];
        for(var _i = 0; _i < arguments.length; _i++)operations[_i] = arguments[_i];
        if (operations.length === 0) return this;
        return (0, _pipe.pipeFromArray)(operations)(this);
    };
    Observable.prototype.toPromise = function(promiseCtor) {
        var _this = this;
        promiseCtor = getPromiseCtor(promiseCtor);
        return new promiseCtor(function(resolve, reject) {
            var value;
            _this.subscribe(function(x) {
                return value = x;
            }, function(err) {
                return reject(err);
            }, function() {
                return resolve(value);
            });
        });
    };
    Observable.create = function(subscribe) {
        return new Observable(subscribe);
    };
    return Observable;
}();
function getPromiseCtor(promiseCtor) {
    if (!promiseCtor) promiseCtor = (0, _config.config).Promise || Promise;
    if (!promiseCtor) throw new Error("no Promise impl found");
    return promiseCtor;
}

},{"./util/canReportError":"keo8s","./util/toSubscriber":"8Nysp","./symbol/observable":"9l5a7","./util/pipe":"4asJs","./config":"aKksQ","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"keo8s":[function(require,module,exports) {
/** PURE_IMPORTS_START _Subscriber PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "canReportError", ()=>canReportError);
var _subscriber = require("../Subscriber");
function canReportError(observer) {
    while(observer){
        var _a = observer, closed_1 = _a.closed, destination = _a.destination, isStopped = _a.isStopped;
        if (closed_1 || isStopped) return false;
        else if (destination && destination instanceof (0, _subscriber.Subscriber)) observer = destination;
        else observer = null;
    }
    return true;
}

},{"../Subscriber":"jGx8F","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"jGx8F":[function(require,module,exports) {
/** PURE_IMPORTS_START tslib,_util_isFunction,_Observer,_Subscription,_internal_symbol_rxSubscriber,_config,_util_hostReportError PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Subscriber", ()=>Subscriber);
parcelHelpers.export(exports, "SafeSubscriber", ()=>SafeSubscriber);
var _tslib = require("tslib");
var _isFunction = require("./util/isFunction");
var _observer = require("./Observer");
var _subscription = require("./Subscription");
var _rxSubscriber = require("../internal/symbol/rxSubscriber");
var _config = require("./config");
var _hostReportError = require("./util/hostReportError");
var Subscriber = /*@__PURE__*/ function(_super) {
    _tslib.__extends(Subscriber, _super);
    function Subscriber(destinationOrNext, error, complete) {
        var _this = _super.call(this) || this;
        _this.syncErrorValue = null;
        _this.syncErrorThrown = false;
        _this.syncErrorThrowable = false;
        _this.isStopped = false;
        switch(arguments.length){
            case 0:
                _this.destination = (0, _observer.empty);
                break;
            case 1:
                if (!destinationOrNext) {
                    _this.destination = (0, _observer.empty);
                    break;
                }
                if (typeof destinationOrNext === "object") {
                    if (destinationOrNext instanceof Subscriber) {
                        _this.syncErrorThrowable = destinationOrNext.syncErrorThrowable;
                        _this.destination = destinationOrNext;
                        destinationOrNext.add(_this);
                    } else {
                        _this.syncErrorThrowable = true;
                        _this.destination = new SafeSubscriber(_this, destinationOrNext);
                    }
                    break;
                }
            default:
                _this.syncErrorThrowable = true;
                _this.destination = new SafeSubscriber(_this, destinationOrNext, error, complete);
                break;
        }
        return _this;
    }
    Subscriber.prototype[0, _rxSubscriber.rxSubscriber] = function() {
        return this;
    };
    Subscriber.create = function(next, error, complete) {
        var subscriber = new Subscriber(next, error, complete);
        subscriber.syncErrorThrowable = false;
        return subscriber;
    };
    Subscriber.prototype.next = function(value) {
        if (!this.isStopped) this._next(value);
    };
    Subscriber.prototype.error = function(err) {
        if (!this.isStopped) {
            this.isStopped = true;
            this._error(err);
        }
    };
    Subscriber.prototype.complete = function() {
        if (!this.isStopped) {
            this.isStopped = true;
            this._complete();
        }
    };
    Subscriber.prototype.unsubscribe = function() {
        if (this.closed) return;
        this.isStopped = true;
        _super.prototype.unsubscribe.call(this);
    };
    Subscriber.prototype._next = function(value) {
        this.destination.next(value);
    };
    Subscriber.prototype._error = function(err) {
        this.destination.error(err);
        this.unsubscribe();
    };
    Subscriber.prototype._complete = function() {
        this.destination.complete();
        this.unsubscribe();
    };
    Subscriber.prototype._unsubscribeAndRecycle = function() {
        var _parentOrParents = this._parentOrParents;
        this._parentOrParents = null;
        this.unsubscribe();
        this.closed = false;
        this.isStopped = false;
        this._parentOrParents = _parentOrParents;
        return this;
    };
    return Subscriber;
}((0, _subscription.Subscription));
var SafeSubscriber = /*@__PURE__*/ function(_super) {
    _tslib.__extends(SafeSubscriber, _super);
    function SafeSubscriber(_parentSubscriber, observerOrNext, error, complete) {
        var _this = _super.call(this) || this;
        _this._parentSubscriber = _parentSubscriber;
        var next;
        var context = _this;
        if ((0, _isFunction.isFunction)(observerOrNext)) next = observerOrNext;
        else if (observerOrNext) {
            next = observerOrNext.next;
            error = observerOrNext.error;
            complete = observerOrNext.complete;
            if (observerOrNext !== (0, _observer.empty)) {
                context = Object.create(observerOrNext);
                if ((0, _isFunction.isFunction)(context.unsubscribe)) _this.add(context.unsubscribe.bind(context));
                context.unsubscribe = _this.unsubscribe.bind(_this);
            }
        }
        _this._context = context;
        _this._next = next;
        _this._error = error;
        _this._complete = complete;
        return _this;
    }
    SafeSubscriber.prototype.next = function(value) {
        if (!this.isStopped && this._next) {
            var _parentSubscriber = this._parentSubscriber;
            if (!(0, _config.config).useDeprecatedSynchronousErrorHandling || !_parentSubscriber.syncErrorThrowable) this.__tryOrUnsub(this._next, value);
            else if (this.__tryOrSetError(_parentSubscriber, this._next, value)) this.unsubscribe();
        }
    };
    SafeSubscriber.prototype.error = function(err) {
        if (!this.isStopped) {
            var _parentSubscriber = this._parentSubscriber;
            var useDeprecatedSynchronousErrorHandling = (0, _config.config).useDeprecatedSynchronousErrorHandling;
            if (this._error) {
                if (!useDeprecatedSynchronousErrorHandling || !_parentSubscriber.syncErrorThrowable) {
                    this.__tryOrUnsub(this._error, err);
                    this.unsubscribe();
                } else {
                    this.__tryOrSetError(_parentSubscriber, this._error, err);
                    this.unsubscribe();
                }
            } else if (!_parentSubscriber.syncErrorThrowable) {
                this.unsubscribe();
                if (useDeprecatedSynchronousErrorHandling) throw err;
                (0, _hostReportError.hostReportError)(err);
            } else {
                if (useDeprecatedSynchronousErrorHandling) {
                    _parentSubscriber.syncErrorValue = err;
                    _parentSubscriber.syncErrorThrown = true;
                } else (0, _hostReportError.hostReportError)(err);
                this.unsubscribe();
            }
        }
    };
    SafeSubscriber.prototype.complete = function() {
        var _this = this;
        if (!this.isStopped) {
            var _parentSubscriber = this._parentSubscriber;
            if (this._complete) {
                var wrappedComplete = function() {
                    return _this._complete.call(_this._context);
                };
                if (!(0, _config.config).useDeprecatedSynchronousErrorHandling || !_parentSubscriber.syncErrorThrowable) {
                    this.__tryOrUnsub(wrappedComplete);
                    this.unsubscribe();
                } else {
                    this.__tryOrSetError(_parentSubscriber, wrappedComplete);
                    this.unsubscribe();
                }
            } else this.unsubscribe();
        }
    };
    SafeSubscriber.prototype.__tryOrUnsub = function(fn, value) {
        try {
            fn.call(this._context, value);
        } catch (err) {
            this.unsubscribe();
            if ((0, _config.config).useDeprecatedSynchronousErrorHandling) throw err;
            else (0, _hostReportError.hostReportError)(err);
        }
    };
    SafeSubscriber.prototype.__tryOrSetError = function(parent, fn, value) {
        if (!(0, _config.config).useDeprecatedSynchronousErrorHandling) throw new Error("bad call");
        try {
            fn.call(this._context, value);
        } catch (err) {
            if ((0, _config.config).useDeprecatedSynchronousErrorHandling) {
                parent.syncErrorValue = err;
                parent.syncErrorThrown = true;
                return true;
            } else {
                (0, _hostReportError.hostReportError)(err);
                return true;
            }
        }
        return false;
    };
    SafeSubscriber.prototype._unsubscribe = function() {
        var _parentSubscriber = this._parentSubscriber;
        this._context = null;
        this._parentSubscriber = null;
        _parentSubscriber.unsubscribe();
    };
    return SafeSubscriber;
}(Subscriber);

},{"tslib":"kcqwq","./util/isFunction":"atYNr","./Observer":"g4n0O","./Subscription":"ahthJ","../internal/symbol/rxSubscriber":"6DhWt","./config":"aKksQ","./util/hostReportError":"l3YZ5","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"kcqwq":[function(require,module,exports) {
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__extends", ()=>__extends);
parcelHelpers.export(exports, "__assign", ()=>__assign);
parcelHelpers.export(exports, "__rest", ()=>__rest);
parcelHelpers.export(exports, "__decorate", ()=>__decorate);
parcelHelpers.export(exports, "__param", ()=>__param);
parcelHelpers.export(exports, "__metadata", ()=>__metadata);
parcelHelpers.export(exports, "__awaiter", ()=>__awaiter);
parcelHelpers.export(exports, "__generator", ()=>__generator);
parcelHelpers.export(exports, "__createBinding", ()=>__createBinding);
parcelHelpers.export(exports, "__exportStar", ()=>__exportStar);
parcelHelpers.export(exports, "__values", ()=>__values);
parcelHelpers.export(exports, "__read", ()=>__read);
parcelHelpers.export(exports, "__spread", ()=>__spread);
parcelHelpers.export(exports, "__spreadArrays", ()=>__spreadArrays);
parcelHelpers.export(exports, "__await", ()=>__await);
parcelHelpers.export(exports, "__asyncGenerator", ()=>__asyncGenerator);
parcelHelpers.export(exports, "__asyncDelegator", ()=>__asyncDelegator);
parcelHelpers.export(exports, "__asyncValues", ()=>__asyncValues);
parcelHelpers.export(exports, "__makeTemplateObject", ()=>__makeTemplateObject);
parcelHelpers.export(exports, "__importStar", ()=>__importStar);
parcelHelpers.export(exports, "__importDefault", ()=>__importDefault);
parcelHelpers.export(exports, "__classPrivateFieldGet", ()=>__classPrivateFieldGet);
parcelHelpers.export(exports, "__classPrivateFieldSet", ()=>__classPrivateFieldSet);
var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return extendStatics(d, b);
};
function __extends(d, b) {
    extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
function __rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function __param(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function __generator(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function __createBinding(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function __exportStar(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function __spread() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat(__read(arguments[i]));
    return ar;
}
function __spreadArrays() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}
function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: __await(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function __importDefault(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function __classPrivateFieldGet(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function __classPrivateFieldSet(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"atYNr":[function(require,module,exports) {
/** PURE_IMPORTS_START  PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isFunction", ()=>isFunction);
function isFunction(x) {
    return typeof x === "function";
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"g4n0O":[function(require,module,exports) {
/** PURE_IMPORTS_START _config,_util_hostReportError PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "empty", ()=>empty);
var _config = require("./config");
var _hostReportError = require("./util/hostReportError");
var empty = {
    closed: true,
    next: function(value) {},
    error: function(err) {
        if ((0, _config.config).useDeprecatedSynchronousErrorHandling) throw err;
        else (0, _hostReportError.hostReportError)(err);
    },
    complete: function() {}
};

},{"./config":"aKksQ","./util/hostReportError":"l3YZ5","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"aKksQ":[function(require,module,exports) {
/** PURE_IMPORTS_START  PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "config", ()=>config);
var _enable_super_gross_mode_that_will_cause_bad_things = false;
var config = {
    Promise: undefined,
    set useDeprecatedSynchronousErrorHandling (value){
        if (value) {
            var error = /*@__PURE__*/ new Error();
            /*@__PURE__*/ console.warn("DEPRECATED! RxJS was set to use deprecated synchronous error handling behavior by code at: \n" + error.stack);
        } else if (_enable_super_gross_mode_that_will_cause_bad_things) /*@__PURE__*/ console.log("RxJS: Back to a better error behavior. Thank you. <3");
        _enable_super_gross_mode_that_will_cause_bad_things = value;
    },
    get useDeprecatedSynchronousErrorHandling () {
        return _enable_super_gross_mode_that_will_cause_bad_things;
    }
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"l3YZ5":[function(require,module,exports) {
/** PURE_IMPORTS_START  PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "hostReportError", ()=>hostReportError);
function hostReportError(err) {
    setTimeout(function() {
        throw err;
    }, 0);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"ahthJ":[function(require,module,exports) {
/** PURE_IMPORTS_START _util_isArray,_util_isObject,_util_isFunction,_util_UnsubscriptionError PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Subscription", ()=>Subscription);
var _isArray = require("./util/isArray");
var _isObject = require("./util/isObject");
var _isFunction = require("./util/isFunction");
var _unsubscriptionError = require("./util/UnsubscriptionError");
var Subscription = /*@__PURE__*/ function() {
    function Subscription(unsubscribe) {
        this.closed = false;
        this._parentOrParents = null;
        this._subscriptions = null;
        if (unsubscribe) {
            this._ctorUnsubscribe = true;
            this._unsubscribe = unsubscribe;
        }
    }
    Subscription.prototype.unsubscribe = function() {
        var errors;
        if (this.closed) return;
        var _a = this, _parentOrParents = _a._parentOrParents, _ctorUnsubscribe = _a._ctorUnsubscribe, _unsubscribe = _a._unsubscribe, _subscriptions = _a._subscriptions;
        this.closed = true;
        this._parentOrParents = null;
        this._subscriptions = null;
        if (_parentOrParents instanceof Subscription) _parentOrParents.remove(this);
        else if (_parentOrParents !== null) for(var index = 0; index < _parentOrParents.length; ++index){
            var parent_1 = _parentOrParents[index];
            parent_1.remove(this);
        }
        if ((0, _isFunction.isFunction)(_unsubscribe)) {
            if (_ctorUnsubscribe) this._unsubscribe = undefined;
            try {
                _unsubscribe.call(this);
            } catch (e) {
                errors = e instanceof (0, _unsubscriptionError.UnsubscriptionError) ? flattenUnsubscriptionErrors(e.errors) : [
                    e
                ];
            }
        }
        if ((0, _isArray.isArray)(_subscriptions)) {
            var index = -1;
            var len = _subscriptions.length;
            while(++index < len){
                var sub = _subscriptions[index];
                if ((0, _isObject.isObject)(sub)) try {
                    sub.unsubscribe();
                } catch (e) {
                    errors = errors || [];
                    if (e instanceof (0, _unsubscriptionError.UnsubscriptionError)) errors = errors.concat(flattenUnsubscriptionErrors(e.errors));
                    else errors.push(e);
                }
            }
        }
        if (errors) throw new (0, _unsubscriptionError.UnsubscriptionError)(errors);
    };
    Subscription.prototype.add = function(teardown) {
        var subscription = teardown;
        if (!teardown) return Subscription.EMPTY;
        switch(typeof teardown){
            case "function":
                subscription = new Subscription(teardown);
            case "object":
                if (subscription === this || subscription.closed || typeof subscription.unsubscribe !== "function") return subscription;
                else if (this.closed) {
                    subscription.unsubscribe();
                    return subscription;
                } else if (!(subscription instanceof Subscription)) {
                    var tmp = subscription;
                    subscription = new Subscription();
                    subscription._subscriptions = [
                        tmp
                    ];
                }
                break;
            default:
                throw new Error("unrecognized teardown " + teardown + " added to Subscription.");
        }
        var _parentOrParents = subscription._parentOrParents;
        if (_parentOrParents === null) subscription._parentOrParents = this;
        else if (_parentOrParents instanceof Subscription) {
            if (_parentOrParents === this) return subscription;
            subscription._parentOrParents = [
                _parentOrParents,
                this
            ];
        } else if (_parentOrParents.indexOf(this) === -1) _parentOrParents.push(this);
        else return subscription;
        var subscriptions = this._subscriptions;
        if (subscriptions === null) this._subscriptions = [
            subscription
        ];
        else subscriptions.push(subscription);
        return subscription;
    };
    Subscription.prototype.remove = function(subscription) {
        var subscriptions = this._subscriptions;
        if (subscriptions) {
            var subscriptionIndex = subscriptions.indexOf(subscription);
            if (subscriptionIndex !== -1) subscriptions.splice(subscriptionIndex, 1);
        }
    };
    Subscription.EMPTY = function(empty) {
        empty.closed = true;
        return empty;
    }(new Subscription());
    return Subscription;
}();
function flattenUnsubscriptionErrors(errors) {
    return errors.reduce(function(errs, err) {
        return errs.concat(err instanceof (0, _unsubscriptionError.UnsubscriptionError) ? err.errors : err);
    }, []);
}

},{"./util/isArray":"2HaTi","./util/isObject":"6Fmw6","./util/isFunction":"atYNr","./util/UnsubscriptionError":"byliX","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2HaTi":[function(require,module,exports) {
/** PURE_IMPORTS_START  PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isArray", ()=>isArray);
var isArray = /*@__PURE__*/ function() {
    return Array.isArray || function(x) {
        return x && typeof x.length === "number";
    };
}();

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"6Fmw6":[function(require,module,exports) {
/** PURE_IMPORTS_START  PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isObject", ()=>isObject);
function isObject(x) {
    return x !== null && typeof x === "object";
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"byliX":[function(require,module,exports) {
/** PURE_IMPORTS_START  PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "UnsubscriptionError", ()=>UnsubscriptionError);
var UnsubscriptionErrorImpl = /*@__PURE__*/ function() {
    function UnsubscriptionErrorImpl(errors) {
        Error.call(this);
        this.message = errors ? errors.length + " errors occurred during unsubscription:\n" + errors.map(function(err, i) {
            return i + 1 + ") " + err.toString();
        }).join("\n  ") : "";
        this.name = "UnsubscriptionError";
        this.errors = errors;
        return this;
    }
    UnsubscriptionErrorImpl.prototype = /*@__PURE__*/ Object.create(Error.prototype);
    return UnsubscriptionErrorImpl;
}();
var UnsubscriptionError = UnsubscriptionErrorImpl;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"6DhWt":[function(require,module,exports) {
/** PURE_IMPORTS_START  PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "rxSubscriber", ()=>rxSubscriber);
parcelHelpers.export(exports, "$$rxSubscriber", ()=>$$rxSubscriber);
var rxSubscriber = /*@__PURE__*/ function() {
    return typeof Symbol === "function" ? /*@__PURE__*/ Symbol("rxSubscriber") : "@@rxSubscriber_" + /*@__PURE__*/ Math.random();
}();
var $$rxSubscriber = rxSubscriber;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8Nysp":[function(require,module,exports) {
/** PURE_IMPORTS_START _Subscriber,_symbol_rxSubscriber,_Observer PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "toSubscriber", ()=>toSubscriber);
var _subscriber = require("../Subscriber");
var _rxSubscriber = require("../symbol/rxSubscriber");
var _observer = require("../Observer");
function toSubscriber(nextOrObserver, error, complete) {
    if (nextOrObserver) {
        if (nextOrObserver instanceof (0, _subscriber.Subscriber)) return nextOrObserver;
        if (nextOrObserver[0, _rxSubscriber.rxSubscriber]) return nextOrObserver[0, _rxSubscriber.rxSubscriber]();
    }
    if (!nextOrObserver && !error && !complete) return new (0, _subscriber.Subscriber)((0, _observer.empty));
    return new (0, _subscriber.Subscriber)(nextOrObserver, error, complete);
}

},{"../Subscriber":"jGx8F","../symbol/rxSubscriber":"6DhWt","../Observer":"g4n0O","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9l5a7":[function(require,module,exports) {
/** PURE_IMPORTS_START  PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "observable", ()=>observable);
var observable = /*@__PURE__*/ function() {
    return typeof Symbol === "function" && Symbol.observable || "@@observable";
}();

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4asJs":[function(require,module,exports) {
/** PURE_IMPORTS_START _identity PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "pipe", ()=>pipe);
parcelHelpers.export(exports, "pipeFromArray", ()=>pipeFromArray);
var _identity = require("./identity");
function pipe() {
    var fns = [];
    for(var _i = 0; _i < arguments.length; _i++)fns[_i] = arguments[_i];
    return pipeFromArray(fns);
}
function pipeFromArray(fns) {
    if (fns.length === 0) return 0, _identity.identity;
    if (fns.length === 1) return fns[0];
    return function piped(input) {
        return fns.reduce(function(prev, fn) {
            return fn(prev);
        }, input);
    };
}

},{"./identity":"kDT9y","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"kDT9y":[function(require,module,exports) {
/** PURE_IMPORTS_START  PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "identity", ()=>identity);
function identity(x) {
    return x;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"f4mOY":[function(require,module,exports) {
/** PURE_IMPORTS_START tslib,_Subject,_Observable,_Subscriber,_Subscription,_operators_refCount PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ConnectableObservable", ()=>ConnectableObservable);
parcelHelpers.export(exports, "connectableObservableDescriptor", ()=>connectableObservableDescriptor);
var _tslib = require("tslib");
var _subject = require("../Subject");
var _observable = require("../Observable");
var _subscriber = require("../Subscriber");
var _subscription = require("../Subscription");
var _refCount = require("../operators/refCount");
var ConnectableObservable = /*@__PURE__*/ function(_super) {
    _tslib.__extends(ConnectableObservable, _super);
    function ConnectableObservable(source, subjectFactory) {
        var _this = _super.call(this) || this;
        _this.source = source;
        _this.subjectFactory = subjectFactory;
        _this._refCount = 0;
        _this._isComplete = false;
        return _this;
    }
    ConnectableObservable.prototype._subscribe = function(subscriber) {
        return this.getSubject().subscribe(subscriber);
    };
    ConnectableObservable.prototype.getSubject = function() {
        var subject = this._subject;
        if (!subject || subject.isStopped) this._subject = this.subjectFactory();
        return this._subject;
    };
    ConnectableObservable.prototype.connect = function() {
        var connection = this._connection;
        if (!connection) {
            this._isComplete = false;
            connection = this._connection = new (0, _subscription.Subscription)();
            connection.add(this.source.subscribe(new ConnectableSubscriber(this.getSubject(), this)));
            if (connection.closed) {
                this._connection = null;
                connection = (0, _subscription.Subscription).EMPTY;
            }
        }
        return connection;
    };
    ConnectableObservable.prototype.refCount = function() {
        return (0, _refCount.refCount)()(this);
    };
    return ConnectableObservable;
}((0, _observable.Observable));
var connectableObservableDescriptor = /*@__PURE__*/ function() {
    var connectableProto = ConnectableObservable.prototype;
    return {
        operator: {
            value: null
        },
        _refCount: {
            value: 0,
            writable: true
        },
        _subject: {
            value: null,
            writable: true
        },
        _connection: {
            value: null,
            writable: true
        },
        _subscribe: {
            value: connectableProto._subscribe
        },
        _isComplete: {
            value: connectableProto._isComplete,
            writable: true
        },
        getSubject: {
            value: connectableProto.getSubject
        },
        connect: {
            value: connectableProto.connect
        },
        refCount: {
            value: connectableProto.refCount
        }
    };
}();
var ConnectableSubscriber = /*@__PURE__*/ function(_super) {
    _tslib.__extends(ConnectableSubscriber, _super);
    function ConnectableSubscriber(destination, connectable) {
        var _this = _super.call(this, destination) || this;
        _this.connectable = connectable;
        return _this;
    }
    ConnectableSubscriber.prototype._error = function(err) {
        this._unsubscribe();
        _super.prototype._error.call(this, err);
    };
    ConnectableSubscriber.prototype._complete = function() {
        this.connectable._isComplete = true;
        this._unsubscribe();
        _super.prototype._complete.call(this);
    };
    ConnectableSubscriber.prototype._unsubscribe = function() {
        var connectable = this.connectable;
        if (connectable) {
            this.connectable = null;
            var connection = connectable._connection;
            connectable._refCount = 0;
            connectable._subject = null;
            connectable._connection = null;
            if (connection) connection.unsubscribe();
        }
    };
    return ConnectableSubscriber;
}((0, _subject.SubjectSubscriber));
var RefCountOperator = /*@__PURE__*/ function() {
    function RefCountOperator(connectable) {
        this.connectable = connectable;
    }
    RefCountOperator.prototype.call = function(subscriber, source) {
        var connectable = this.connectable;
        connectable._refCount++;
        var refCounter = new RefCountSubscriber(subscriber, connectable);
        var subscription = source.subscribe(refCounter);
        if (!refCounter.closed) refCounter.connection = connectable.connect();
        return subscription;
    };
    return RefCountOperator;
}();
var RefCountSubscriber = /*@__PURE__*/ function(_super) {
    _tslib.__extends(RefCountSubscriber, _super);
    function RefCountSubscriber(destination, connectable) {
        var _this = _super.call(this, destination) || this;
        _this.connectable = connectable;
        return _this;
    }
    RefCountSubscriber.prototype._unsubscribe = function() {
        var connectable = this.connectable;
        if (!connectable) {
            this.connection = null;
            return;
        }
        this.connectable = null;
        var refCount = connectable._refCount;
        if (refCount <= 0) {
            this.connection = null;
            return;
        }
        connectable._refCount = refCount - 1;
        if (refCount > 1) {
            this.connection = null;
            return;
        }
        var connection = this.connection;
        var sharedConnection = connectable._connection;
        this.connection = null;
        if (sharedConnection && (!connection || sharedConnection === connection)) sharedConnection.unsubscribe();
    };
    return RefCountSubscriber;
}((0, _subscriber.Subscriber));

},{"tslib":"kcqwq","../Subject":"84bef","../Observable":"9oc0x","../Subscriber":"jGx8F","../Subscription":"ahthJ","../operators/refCount":"ihxKV","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"84bef":[function(require,module,exports) {
/** PURE_IMPORTS_START tslib,_Observable,_Subscriber,_Subscription,_util_ObjectUnsubscribedError,_SubjectSubscription,_internal_symbol_rxSubscriber PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SubjectSubscriber", ()=>SubjectSubscriber);
parcelHelpers.export(exports, "Subject", ()=>Subject);
parcelHelpers.export(exports, "AnonymousSubject", ()=>AnonymousSubject);
var _tslib = require("tslib");
var _observable = require("./Observable");
var _subscriber = require("./Subscriber");
var _subscription = require("./Subscription");
var _objectUnsubscribedError = require("./util/ObjectUnsubscribedError");
var _subjectSubscription = require("./SubjectSubscription");
var _rxSubscriber = require("../internal/symbol/rxSubscriber");
var SubjectSubscriber = /*@__PURE__*/ function(_super) {
    _tslib.__extends(SubjectSubscriber, _super);
    function SubjectSubscriber(destination) {
        var _this = _super.call(this, destination) || this;
        _this.destination = destination;
        return _this;
    }
    return SubjectSubscriber;
}((0, _subscriber.Subscriber));
var Subject = /*@__PURE__*/ function(_super) {
    _tslib.__extends(Subject, _super);
    function Subject() {
        var _this = _super.call(this) || this;
        _this.observers = [];
        _this.closed = false;
        _this.isStopped = false;
        _this.hasError = false;
        _this.thrownError = null;
        return _this;
    }
    Subject.prototype[0, _rxSubscriber.rxSubscriber] = function() {
        return new SubjectSubscriber(this);
    };
    Subject.prototype.lift = function(operator) {
        var subject = new AnonymousSubject(this, this);
        subject.operator = operator;
        return subject;
    };
    Subject.prototype.next = function(value) {
        if (this.closed) throw new (0, _objectUnsubscribedError.ObjectUnsubscribedError)();
        if (!this.isStopped) {
            var observers = this.observers;
            var len = observers.length;
            var copy = observers.slice();
            for(var i = 0; i < len; i++)copy[i].next(value);
        }
    };
    Subject.prototype.error = function(err) {
        if (this.closed) throw new (0, _objectUnsubscribedError.ObjectUnsubscribedError)();
        this.hasError = true;
        this.thrownError = err;
        this.isStopped = true;
        var observers = this.observers;
        var len = observers.length;
        var copy = observers.slice();
        for(var i = 0; i < len; i++)copy[i].error(err);
        this.observers.length = 0;
    };
    Subject.prototype.complete = function() {
        if (this.closed) throw new (0, _objectUnsubscribedError.ObjectUnsubscribedError)();
        this.isStopped = true;
        var observers = this.observers;
        var len = observers.length;
        var copy = observers.slice();
        for(var i = 0; i < len; i++)copy[i].complete();
        this.observers.length = 0;
    };
    Subject.prototype.unsubscribe = function() {
        this.isStopped = true;
        this.closed = true;
        this.observers = null;
    };
    Subject.prototype._trySubscribe = function(subscriber) {
        if (this.closed) throw new (0, _objectUnsubscribedError.ObjectUnsubscribedError)();
        else return _super.prototype._trySubscribe.call(this, subscriber);
    };
    Subject.prototype._subscribe = function(subscriber) {
        if (this.closed) throw new (0, _objectUnsubscribedError.ObjectUnsubscribedError)();
        else if (this.hasError) {
            subscriber.error(this.thrownError);
            return (0, _subscription.Subscription).EMPTY;
        } else if (this.isStopped) {
            subscriber.complete();
            return (0, _subscription.Subscription).EMPTY;
        } else {
            this.observers.push(subscriber);
            return new (0, _subjectSubscription.SubjectSubscription)(this, subscriber);
        }
    };
    Subject.prototype.asObservable = function() {
        var observable = new (0, _observable.Observable)();
        observable.source = this;
        return observable;
    };
    Subject.create = function(destination, source) {
        return new AnonymousSubject(destination, source);
    };
    return Subject;
}((0, _observable.Observable));
var AnonymousSubject = /*@__PURE__*/ function(_super) {
    _tslib.__extends(AnonymousSubject, _super);
    function AnonymousSubject(destination, source) {
        var _this = _super.call(this) || this;
        _this.destination = destination;
        _this.source = source;
        return _this;
    }
    AnonymousSubject.prototype.next = function(value) {
        var destination = this.destination;
        if (destination && destination.next) destination.next(value);
    };
    AnonymousSubject.prototype.error = function(err) {
        var destination = this.destination;
        if (destination && destination.error) this.destination.error(err);
    };
    AnonymousSubject.prototype.complete = function() {
        var destination = this.destination;
        if (destination && destination.complete) this.destination.complete();
    };
    AnonymousSubject.prototype._subscribe = function(subscriber) {
        var source = this.source;
        if (source) return this.source.subscribe(subscriber);
        else return (0, _subscription.Subscription).EMPTY;
    };
    return AnonymousSubject;
}(Subject);

},{"tslib":"kcqwq","./Observable":"9oc0x","./Subscriber":"jGx8F","./Subscription":"ahthJ","./util/ObjectUnsubscribedError":"xtsCl","./SubjectSubscription":"9Q6jX","../internal/symbol/rxSubscriber":"6DhWt","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"xtsCl":[function(require,module,exports) {
/** PURE_IMPORTS_START  PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ObjectUnsubscribedError", ()=>ObjectUnsubscribedError);
var ObjectUnsubscribedErrorImpl = /*@__PURE__*/ function() {
    function ObjectUnsubscribedErrorImpl() {
        Error.call(this);
        this.message = "object unsubscribed";
        this.name = "ObjectUnsubscribedError";
        return this;
    }
    ObjectUnsubscribedErrorImpl.prototype = /*@__PURE__*/ Object.create(Error.prototype);
    return ObjectUnsubscribedErrorImpl;
}();
var ObjectUnsubscribedError = ObjectUnsubscribedErrorImpl;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9Q6jX":[function(require,module,exports) {
/** PURE_IMPORTS_START tslib,_Subscription PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SubjectSubscription", ()=>SubjectSubscription);
var _tslib = require("tslib");
var _subscription = require("./Subscription");
var SubjectSubscription = /*@__PURE__*/ function(_super) {
    _tslib.__extends(SubjectSubscription, _super);
    function SubjectSubscription(subject, subscriber) {
        var _this = _super.call(this) || this;
        _this.subject = subject;
        _this.subscriber = subscriber;
        _this.closed = false;
        return _this;
    }
    SubjectSubscription.prototype.unsubscribe = function() {
        if (this.closed) return;
        this.closed = true;
        var subject = this.subject;
        var observers = subject.observers;
        this.subject = null;
        if (!observers || observers.length === 0 || subject.isStopped || subject.closed) return;
        var subscriberIndex = observers.indexOf(this.subscriber);
        if (subscriberIndex !== -1) observers.splice(subscriberIndex, 1);
    };
    return SubjectSubscription;
}((0, _subscription.Subscription));

},{"tslib":"kcqwq","./Subscription":"ahthJ","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"ihxKV":[function(require,module,exports) {
/** PURE_IMPORTS_START tslib,_Subscriber PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "refCount", ()=>refCount);
var _tslib = require("tslib");
var _subscriber = require("../Subscriber");
function refCount() {
    return function refCountOperatorFunction(source) {
        return source.lift(new RefCountOperator(source));
    };
}
var RefCountOperator = /*@__PURE__*/ function() {
    function RefCountOperator(connectable) {
        this.connectable = connectable;
    }
    RefCountOperator.prototype.call = function(subscriber, source) {
        var connectable = this.connectable;
        connectable._refCount++;
        var refCounter = new RefCountSubscriber(subscriber, connectable);
        var subscription = source.subscribe(refCounter);
        if (!refCounter.closed) refCounter.connection = connectable.connect();
        return subscription;
    };
    return RefCountOperator;
}();
var RefCountSubscriber = /*@__PURE__*/ function(_super) {
    _tslib.__extends(RefCountSubscriber, _super);
    function RefCountSubscriber(destination, connectable) {
        var _this = _super.call(this, destination) || this;
        _this.connectable = connectable;
        return _this;
    }
    RefCountSubscriber.prototype._unsubscribe = function() {
        var connectable = this.connectable;
        if (!connectable) {
            this.connection = null;
            return;
        }
        this.connectable = null;
        var refCount = connectable._refCount;
        if (refCount <= 0) {
            this.connection = null;
            return;
        }
        connectable._refCount = refCount - 1;
        if (refCount > 1) {
            this.connection = null;
            return;
        }
        var connection = this.connection;
        var sharedConnection = connectable._connection;
        this.connection = null;
        if (sharedConnection && (!connection || sharedConnection === connection)) sharedConnection.unsubscribe();
    };
    return RefCountSubscriber;
}((0, _subscriber.Subscriber));

},{"tslib":"kcqwq","../Subscriber":"jGx8F","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"g6z19":[function(require,module,exports) {
/** PURE_IMPORTS_START tslib,_Subscriber,_Subscription,_Observable,_Subject PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "groupBy", ()=>groupBy);
parcelHelpers.export(exports, "GroupedObservable", ()=>GroupedObservable);
var _tslib = require("tslib");
var _subscriber = require("../Subscriber");
var _subscription = require("../Subscription");
var _observable = require("../Observable");
var _subject = require("../Subject");
function groupBy(keySelector, elementSelector, durationSelector, subjectSelector) {
    return function(source) {
        return source.lift(new GroupByOperator(keySelector, elementSelector, durationSelector, subjectSelector));
    };
}
var GroupByOperator = /*@__PURE__*/ function() {
    function GroupByOperator(keySelector, elementSelector, durationSelector, subjectSelector) {
        this.keySelector = keySelector;
        this.elementSelector = elementSelector;
        this.durationSelector = durationSelector;
        this.subjectSelector = subjectSelector;
    }
    GroupByOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new GroupBySubscriber(subscriber, this.keySelector, this.elementSelector, this.durationSelector, this.subjectSelector));
    };
    return GroupByOperator;
}();
var GroupBySubscriber = /*@__PURE__*/ function(_super) {
    _tslib.__extends(GroupBySubscriber, _super);
    function GroupBySubscriber(destination, keySelector, elementSelector, durationSelector, subjectSelector) {
        var _this = _super.call(this, destination) || this;
        _this.keySelector = keySelector;
        _this.elementSelector = elementSelector;
        _this.durationSelector = durationSelector;
        _this.subjectSelector = subjectSelector;
        _this.groups = null;
        _this.attemptedToUnsubscribe = false;
        _this.count = 0;
        return _this;
    }
    GroupBySubscriber.prototype._next = function(value) {
        var key;
        try {
            key = this.keySelector(value);
        } catch (err) {
            this.error(err);
            return;
        }
        this._group(value, key);
    };
    GroupBySubscriber.prototype._group = function(value, key) {
        var groups = this.groups;
        if (!groups) groups = this.groups = new Map();
        var group = groups.get(key);
        var element;
        if (this.elementSelector) try {
            element = this.elementSelector(value);
        } catch (err) {
            this.error(err);
        }
        else element = value;
        if (!group) {
            group = this.subjectSelector ? this.subjectSelector() : new (0, _subject.Subject)();
            groups.set(key, group);
            var groupedObservable = new GroupedObservable(key, group, this);
            this.destination.next(groupedObservable);
            if (this.durationSelector) {
                var duration = void 0;
                try {
                    duration = this.durationSelector(new GroupedObservable(key, group));
                } catch (err) {
                    this.error(err);
                    return;
                }
                this.add(duration.subscribe(new GroupDurationSubscriber(key, group, this)));
            }
        }
        if (!group.closed) group.next(element);
    };
    GroupBySubscriber.prototype._error = function(err) {
        var groups = this.groups;
        if (groups) {
            groups.forEach(function(group, key) {
                group.error(err);
            });
            groups.clear();
        }
        this.destination.error(err);
    };
    GroupBySubscriber.prototype._complete = function() {
        var groups = this.groups;
        if (groups) {
            groups.forEach(function(group, key) {
                group.complete();
            });
            groups.clear();
        }
        this.destination.complete();
    };
    GroupBySubscriber.prototype.removeGroup = function(key) {
        this.groups.delete(key);
    };
    GroupBySubscriber.prototype.unsubscribe = function() {
        if (!this.closed) {
            this.attemptedToUnsubscribe = true;
            if (this.count === 0) _super.prototype.unsubscribe.call(this);
        }
    };
    return GroupBySubscriber;
}((0, _subscriber.Subscriber));
var GroupDurationSubscriber = /*@__PURE__*/ function(_super) {
    _tslib.__extends(GroupDurationSubscriber, _super);
    function GroupDurationSubscriber(key, group, parent) {
        var _this = _super.call(this, group) || this;
        _this.key = key;
        _this.group = group;
        _this.parent = parent;
        return _this;
    }
    GroupDurationSubscriber.prototype._next = function(value) {
        this.complete();
    };
    GroupDurationSubscriber.prototype._unsubscribe = function() {
        var _a = this, parent = _a.parent, key = _a.key;
        this.key = this.parent = null;
        if (parent) parent.removeGroup(key);
    };
    return GroupDurationSubscriber;
}((0, _subscriber.Subscriber));
var GroupedObservable = /*@__PURE__*/ function(_super) {
    _tslib.__extends(GroupedObservable, _super);
    function GroupedObservable(key, groupSubject, refCountSubscription) {
        var _this = _super.call(this) || this;
        _this.key = key;
        _this.groupSubject = groupSubject;
        _this.refCountSubscription = refCountSubscription;
        return _this;
    }
    GroupedObservable.prototype._subscribe = function(subscriber) {
        var subscription = new (0, _subscription.Subscription)();
        var _a = this, refCountSubscription = _a.refCountSubscription, groupSubject = _a.groupSubject;
        if (refCountSubscription && !refCountSubscription.closed) subscription.add(new InnerRefCountSubscription(refCountSubscription));
        subscription.add(groupSubject.subscribe(subscriber));
        return subscription;
    };
    return GroupedObservable;
}((0, _observable.Observable));
var InnerRefCountSubscription = /*@__PURE__*/ function(_super) {
    _tslib.__extends(InnerRefCountSubscription, _super);
    function InnerRefCountSubscription(parent) {
        var _this = _super.call(this) || this;
        _this.parent = parent;
        parent.count++;
        return _this;
    }
    InnerRefCountSubscription.prototype.unsubscribe = function() {
        var parent = this.parent;
        if (!parent.closed && !this.closed) {
            _super.prototype.unsubscribe.call(this);
            parent.count -= 1;
            if (parent.count === 0 && parent.attemptedToUnsubscribe) parent.unsubscribe();
        }
    };
    return InnerRefCountSubscription;
}((0, _subscription.Subscription));

},{"tslib":"kcqwq","../Subscriber":"jGx8F","../Subscription":"ahthJ","../Observable":"9oc0x","../Subject":"84bef","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"anOW9":[function(require,module,exports) {
/** PURE_IMPORTS_START tslib,_Subject,_util_ObjectUnsubscribedError PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BehaviorSubject", ()=>BehaviorSubject);
var _tslib = require("tslib");
var _subject = require("./Subject");
var _objectUnsubscribedError = require("./util/ObjectUnsubscribedError");
var BehaviorSubject = /*@__PURE__*/ function(_super) {
    _tslib.__extends(BehaviorSubject, _super);
    function BehaviorSubject(_value) {
        var _this = _super.call(this) || this;
        _this._value = _value;
        return _this;
    }
    Object.defineProperty(BehaviorSubject.prototype, "value", {
        get: function() {
            return this.getValue();
        },
        enumerable: true,
        configurable: true
    });
    BehaviorSubject.prototype._subscribe = function(subscriber) {
        var subscription = _super.prototype._subscribe.call(this, subscriber);
        if (subscription && !subscription.closed) subscriber.next(this._value);
        return subscription;
    };
    BehaviorSubject.prototype.getValue = function() {
        if (this.hasError) throw this.thrownError;
        else if (this.closed) throw new (0, _objectUnsubscribedError.ObjectUnsubscribedError)();
        else return this._value;
    };
    BehaviorSubject.prototype.next = function(value) {
        _super.prototype.next.call(this, this._value = value);
    };
    return BehaviorSubject;
}((0, _subject.Subject));

},{"tslib":"kcqwq","./Subject":"84bef","./util/ObjectUnsubscribedError":"xtsCl","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"gRMu9":[function(require,module,exports) {
/** PURE_IMPORTS_START tslib,_Subject,_scheduler_queue,_Subscription,_operators_observeOn,_util_ObjectUnsubscribedError,_SubjectSubscription PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReplaySubject", ()=>ReplaySubject);
var _tslib = require("tslib");
var _subject = require("./Subject");
var _queue = require("./scheduler/queue");
var _subscription = require("./Subscription");
var _observeOn = require("./operators/observeOn");
var _objectUnsubscribedError = require("./util/ObjectUnsubscribedError");
var _subjectSubscription = require("./SubjectSubscription");
var ReplaySubject = /*@__PURE__*/ function(_super) {
    _tslib.__extends(ReplaySubject, _super);
    function ReplaySubject(bufferSize, windowTime, scheduler) {
        if (bufferSize === void 0) bufferSize = Number.POSITIVE_INFINITY;
        if (windowTime === void 0) windowTime = Number.POSITIVE_INFINITY;
        var _this = _super.call(this) || this;
        _this.scheduler = scheduler;
        _this._events = [];
        _this._infiniteTimeWindow = false;
        _this._bufferSize = bufferSize < 1 ? 1 : bufferSize;
        _this._windowTime = windowTime < 1 ? 1 : windowTime;
        if (windowTime === Number.POSITIVE_INFINITY) {
            _this._infiniteTimeWindow = true;
            _this.next = _this.nextInfiniteTimeWindow;
        } else _this.next = _this.nextTimeWindow;
        return _this;
    }
    ReplaySubject.prototype.nextInfiniteTimeWindow = function(value) {
        if (!this.isStopped) {
            var _events = this._events;
            _events.push(value);
            if (_events.length > this._bufferSize) _events.shift();
        }
        _super.prototype.next.call(this, value);
    };
    ReplaySubject.prototype.nextTimeWindow = function(value) {
        if (!this.isStopped) {
            this._events.push(new ReplayEvent(this._getNow(), value));
            this._trimBufferThenGetEvents();
        }
        _super.prototype.next.call(this, value);
    };
    ReplaySubject.prototype._subscribe = function(subscriber) {
        var _infiniteTimeWindow = this._infiniteTimeWindow;
        var _events = _infiniteTimeWindow ? this._events : this._trimBufferThenGetEvents();
        var scheduler = this.scheduler;
        var len = _events.length;
        var subscription;
        if (this.closed) throw new (0, _objectUnsubscribedError.ObjectUnsubscribedError)();
        else if (this.isStopped || this.hasError) subscription = (0, _subscription.Subscription).EMPTY;
        else {
            this.observers.push(subscriber);
            subscription = new (0, _subjectSubscription.SubjectSubscription)(this, subscriber);
        }
        if (scheduler) subscriber.add(subscriber = new (0, _observeOn.ObserveOnSubscriber)(subscriber, scheduler));
        if (_infiniteTimeWindow) for(var i = 0; i < len && !subscriber.closed; i++)subscriber.next(_events[i]);
        else for(var i = 0; i < len && !subscriber.closed; i++)subscriber.next(_events[i].value);
        if (this.hasError) subscriber.error(this.thrownError);
        else if (this.isStopped) subscriber.complete();
        return subscription;
    };
    ReplaySubject.prototype._getNow = function() {
        return (this.scheduler || (0, _queue.queue)).now();
    };
    ReplaySubject.prototype._trimBufferThenGetEvents = function() {
        var now = this._getNow();
        var _bufferSize = this._bufferSize;
        var _windowTime = this._windowTime;
        var _events = this._events;
        var eventsCount = _events.length;
        var spliceCount = 0;
        while(spliceCount < eventsCount){
            if (now - _events[spliceCount].time < _windowTime) break;
            spliceCount++;
        }
        if (eventsCount > _bufferSize) spliceCount = Math.max(spliceCount, eventsCount - _bufferSize);
        if (spliceCount > 0) _events.splice(0, spliceCount);
        return _events;
    };
    return ReplaySubject;
}((0, _subject.Subject));
var ReplayEvent = /*@__PURE__*/ function() {
    function ReplayEvent(time, value) {
        this.time = time;
        this.value = value;
    }
    return ReplayEvent;
}();

},{"tslib":"kcqwq","./Subject":"84bef","./scheduler/queue":"9CC3u","./Subscription":"ahthJ","./operators/observeOn":"8iKY0","./util/ObjectUnsubscribedError":"xtsCl","./SubjectSubscription":"9Q6jX","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9CC3u":[function(require,module,exports) {
/** PURE_IMPORTS_START _QueueAction,_QueueScheduler PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "queueScheduler", ()=>queueScheduler);
parcelHelpers.export(exports, "queue", ()=>queue);
var _queueAction = require("./QueueAction");
var _queueScheduler = require("./QueueScheduler");
var queueScheduler = /*@__PURE__*/ new (0, _queueScheduler.QueueScheduler)((0, _queueAction.QueueAction));
var queue = queueScheduler;

},{"./QueueAction":"5ysZC","./QueueScheduler":"hVNPQ","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"5ysZC":[function(require,module,exports) {
/** PURE_IMPORTS_START tslib,_AsyncAction PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "QueueAction", ()=>QueueAction);
var _tslib = require("tslib");
var _asyncAction = require("./AsyncAction");
var QueueAction = /*@__PURE__*/ function(_super) {
    _tslib.__extends(QueueAction, _super);
    function QueueAction(scheduler, work) {
        var _this = _super.call(this, scheduler, work) || this;
        _this.scheduler = scheduler;
        _this.work = work;
        return _this;
    }
    QueueAction.prototype.schedule = function(state, delay) {
        if (delay === void 0) delay = 0;
        if (delay > 0) return _super.prototype.schedule.call(this, state, delay);
        this.delay = delay;
        this.state = state;
        this.scheduler.flush(this);
        return this;
    };
    QueueAction.prototype.execute = function(state, delay) {
        return delay > 0 || this.closed ? _super.prototype.execute.call(this, state, delay) : this._execute(state, delay);
    };
    QueueAction.prototype.requestAsyncId = function(scheduler, id, delay) {
        if (delay === void 0) delay = 0;
        if (delay !== null && delay > 0 || delay === null && this.delay > 0) return _super.prototype.requestAsyncId.call(this, scheduler, id, delay);
        return scheduler.flush(this);
    };
    return QueueAction;
}((0, _asyncAction.AsyncAction));

},{"tslib":"kcqwq","./AsyncAction":"5Tduw","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"5Tduw":[function(require,module,exports) {
/** PURE_IMPORTS_START tslib,_Action PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AsyncAction", ()=>AsyncAction);
var _tslib = require("tslib");
var _action = require("./Action");
var AsyncAction = /*@__PURE__*/ function(_super) {
    _tslib.__extends(AsyncAction, _super);
    function AsyncAction(scheduler, work) {
        var _this = _super.call(this, scheduler, work) || this;
        _this.scheduler = scheduler;
        _this.work = work;
        _this.pending = false;
        return _this;
    }
    AsyncAction.prototype.schedule = function(state, delay) {
        if (delay === void 0) delay = 0;
        if (this.closed) return this;
        this.state = state;
        var id = this.id;
        var scheduler = this.scheduler;
        if (id != null) this.id = this.recycleAsyncId(scheduler, id, delay);
        this.pending = true;
        this.delay = delay;
        this.id = this.id || this.requestAsyncId(scheduler, this.id, delay);
        return this;
    };
    AsyncAction.prototype.requestAsyncId = function(scheduler, id, delay) {
        if (delay === void 0) delay = 0;
        return setInterval(scheduler.flush.bind(scheduler, this), delay);
    };
    AsyncAction.prototype.recycleAsyncId = function(scheduler, id, delay) {
        if (delay === void 0) delay = 0;
        if (delay !== null && this.delay === delay && this.pending === false) return id;
        clearInterval(id);
        return undefined;
    };
    AsyncAction.prototype.execute = function(state, delay) {
        if (this.closed) return new Error("executing a cancelled action");
        this.pending = false;
        var error = this._execute(state, delay);
        if (error) return error;
        else if (this.pending === false && this.id != null) this.id = this.recycleAsyncId(this.scheduler, this.id, null);
    };
    AsyncAction.prototype._execute = function(state, delay) {
        var errored = false;
        var errorValue = undefined;
        try {
            this.work(state);
        } catch (e) {
            errored = true;
            errorValue = !!e && e || new Error(e);
        }
        if (errored) {
            this.unsubscribe();
            return errorValue;
        }
    };
    AsyncAction.prototype._unsubscribe = function() {
        var id = this.id;
        var scheduler = this.scheduler;
        var actions = scheduler.actions;
        var index = actions.indexOf(this);
        this.work = null;
        this.state = null;
        this.pending = false;
        this.scheduler = null;
        if (index !== -1) actions.splice(index, 1);
        if (id != null) this.id = this.recycleAsyncId(scheduler, id, null);
        this.delay = null;
    };
    return AsyncAction;
}((0, _action.Action));

},{"tslib":"kcqwq","./Action":"4kx73","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4kx73":[function(require,module,exports) {
/** PURE_IMPORTS_START tslib,_Subscription PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Action", ()=>Action);
var _tslib = require("tslib");
var _subscription = require("../Subscription");
var Action = /*@__PURE__*/ function(_super) {
    _tslib.__extends(Action, _super);
    function Action(scheduler, work) {
        return _super.call(this) || this;
    }
    Action.prototype.schedule = function(state, delay) {
        if (delay === void 0) delay = 0;
        return this;
    };
    return Action;
}((0, _subscription.Subscription));

},{"tslib":"kcqwq","../Subscription":"ahthJ","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"hVNPQ":[function(require,module,exports) {
/** PURE_IMPORTS_START tslib,_AsyncScheduler PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "QueueScheduler", ()=>QueueScheduler);
var _tslib = require("tslib");
var _asyncScheduler = require("./AsyncScheduler");
var QueueScheduler = /*@__PURE__*/ function(_super) {
    _tslib.__extends(QueueScheduler, _super);
    function QueueScheduler() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return QueueScheduler;
}((0, _asyncScheduler.AsyncScheduler));

},{"tslib":"kcqwq","./AsyncScheduler":"l4ot2","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"l4ot2":[function(require,module,exports) {
/** PURE_IMPORTS_START tslib,_Scheduler PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AsyncScheduler", ()=>AsyncScheduler);
var _tslib = require("tslib");
var _scheduler = require("../Scheduler");
var AsyncScheduler = /*@__PURE__*/ function(_super) {
    _tslib.__extends(AsyncScheduler, _super);
    function AsyncScheduler(SchedulerAction, now) {
        if (now === void 0) now = (0, _scheduler.Scheduler).now;
        var _this = _super.call(this, SchedulerAction, function() {
            if (AsyncScheduler.delegate && AsyncScheduler.delegate !== _this) return AsyncScheduler.delegate.now();
            else return now();
        }) || this;
        _this.actions = [];
        _this.active = false;
        _this.scheduled = undefined;
        return _this;
    }
    AsyncScheduler.prototype.schedule = function(work, delay, state) {
        if (delay === void 0) delay = 0;
        if (AsyncScheduler.delegate && AsyncScheduler.delegate !== this) return AsyncScheduler.delegate.schedule(work, delay, state);
        else return _super.prototype.schedule.call(this, work, delay, state);
    };
    AsyncScheduler.prototype.flush = function(action) {
        var actions = this.actions;
        if (this.active) {
            actions.push(action);
            return;
        }
        var error;
        this.active = true;
        do {
            if (error = action.execute(action.state, action.delay)) break;
        }while (action = actions.shift());
        this.active = false;
        if (error) {
            while(action = actions.shift())action.unsubscribe();
            throw error;
        }
    };
    return AsyncScheduler;
}((0, _scheduler.Scheduler));

},{"tslib":"kcqwq","../Scheduler":"7PKfs","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7PKfs":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Scheduler", ()=>Scheduler);
var Scheduler = /*@__PURE__*/ function() {
    function Scheduler(SchedulerAction, now) {
        if (now === void 0) now = Scheduler.now;
        this.SchedulerAction = SchedulerAction;
        this.now = now;
    }
    Scheduler.prototype.schedule = function(work, delay, state) {
        if (delay === void 0) delay = 0;
        return new this.SchedulerAction(this, work).schedule(state, delay);
    };
    Scheduler.now = function() {
        return Date.now();
    };
    return Scheduler;
}();

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8iKY0":[function(require,module,exports) {
/** PURE_IMPORTS_START tslib,_Subscriber,_Notification PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "observeOn", ()=>observeOn);
parcelHelpers.export(exports, "ObserveOnOperator", ()=>ObserveOnOperator);
parcelHelpers.export(exports, "ObserveOnSubscriber", ()=>ObserveOnSubscriber);
parcelHelpers.export(exports, "ObserveOnMessage", ()=>ObserveOnMessage);
var _tslib = require("tslib");
var _subscriber = require("../Subscriber");
var _notification = require("../Notification");
function observeOn(scheduler, delay) {
    if (delay === void 0) delay = 0;
    return function observeOnOperatorFunction(source) {
        return source.lift(new ObserveOnOperator(scheduler, delay));
    };
}
var ObserveOnOperator = /*@__PURE__*/ function() {
    function ObserveOnOperator(scheduler, delay) {
        if (delay === void 0) delay = 0;
        this.scheduler = scheduler;
        this.delay = delay;
    }
    ObserveOnOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new ObserveOnSubscriber(subscriber, this.scheduler, this.delay));
    };
    return ObserveOnOperator;
}();
var ObserveOnSubscriber = /*@__PURE__*/ function(_super) {
    _tslib.__extends(ObserveOnSubscriber, _super);
    function ObserveOnSubscriber(destination, scheduler, delay) {
        if (delay === void 0) delay = 0;
        var _this = _super.call(this, destination) || this;
        _this.scheduler = scheduler;
        _this.delay = delay;
        return _this;
    }
    ObserveOnSubscriber.dispatch = function(arg) {
        var notification = arg.notification, destination = arg.destination;
        notification.observe(destination);
        this.unsubscribe();
    };
    ObserveOnSubscriber.prototype.scheduleMessage = function(notification) {
        var destination = this.destination;
        destination.add(this.scheduler.schedule(ObserveOnSubscriber.dispatch, this.delay, new ObserveOnMessage(notification, this.destination)));
    };
    ObserveOnSubscriber.prototype._next = function(value) {
        this.scheduleMessage((0, _notification.Notification).createNext(value));
    };
    ObserveOnSubscriber.prototype._error = function(err) {
        this.scheduleMessage((0, _notification.Notification).createError(err));
        this.unsubscribe();
    };
    ObserveOnSubscriber.prototype._complete = function() {
        this.scheduleMessage((0, _notification.Notification).createComplete());
        this.unsubscribe();
    };
    return ObserveOnSubscriber;
}((0, _subscriber.Subscriber));
var ObserveOnMessage = /*@__PURE__*/ function() {
    function ObserveOnMessage(notification, destination) {
        this.notification = notification;
        this.destination = destination;
    }
    return ObserveOnMessage;
}();

},{"tslib":"kcqwq","../Subscriber":"jGx8F","../Notification":"3c26n","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"3c26n":[function(require,module,exports) {
/** PURE_IMPORTS_START _observable_empty,_observable_of,_observable_throwError PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "NotificationKind", ()=>NotificationKind);
parcelHelpers.export(exports, "Notification", ()=>Notification);
var _empty = require("./observable/empty");
var _of = require("./observable/of");
var _throwError = require("./observable/throwError");
var NotificationKind;
/*@__PURE__*/ (function(NotificationKind) {
    NotificationKind["NEXT"] = "N";
    NotificationKind["ERROR"] = "E";
    NotificationKind["COMPLETE"] = "C";
})(NotificationKind || (NotificationKind = {}));
var Notification = /*@__PURE__*/ function() {
    function Notification(kind, value, error) {
        this.kind = kind;
        this.value = value;
        this.error = error;
        this.hasValue = kind === "N";
    }
    Notification.prototype.observe = function(observer) {
        switch(this.kind){
            case "N":
                return observer.next && observer.next(this.value);
            case "E":
                return observer.error && observer.error(this.error);
            case "C":
                return observer.complete && observer.complete();
        }
    };
    Notification.prototype.do = function(next, error, complete) {
        var kind = this.kind;
        switch(kind){
            case "N":
                return next && next(this.value);
            case "E":
                return error && error(this.error);
            case "C":
                return complete && complete();
        }
    };
    Notification.prototype.accept = function(nextOrObserver, error, complete) {
        if (nextOrObserver && typeof nextOrObserver.next === "function") return this.observe(nextOrObserver);
        else return this.do(nextOrObserver, error, complete);
    };
    Notification.prototype.toObservable = function() {
        var kind = this.kind;
        switch(kind){
            case "N":
                return (0, _of.of)(this.value);
            case "E":
                return (0, _throwError.throwError)(this.error);
            case "C":
                return (0, _empty.empty)();
        }
        throw new Error("unexpected notification kind value");
    };
    Notification.createNext = function(value) {
        if (typeof value !== "undefined") return new Notification("N", value);
        return Notification.undefinedValueNotification;
    };
    Notification.createError = function(err) {
        return new Notification("E", undefined, err);
    };
    Notification.createComplete = function() {
        return Notification.completeNotification;
    };
    Notification.completeNotification = new Notification("C");
    Notification.undefinedValueNotification = new Notification("N", undefined);
    return Notification;
}();

},{"./observable/empty":"J4JDz","./observable/of":"alTvf","./observable/throwError":"4BUNm","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"J4JDz":[function(require,module,exports) {
/** PURE_IMPORTS_START _Observable PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "EMPTY", ()=>EMPTY);
parcelHelpers.export(exports, "empty", ()=>empty);
var _observable = require("../Observable");
var EMPTY = /*@__PURE__*/ new (0, _observable.Observable)(function(subscriber) {
    return subscriber.complete();
});
function empty(scheduler) {
    return scheduler ? emptyScheduled(scheduler) : EMPTY;
}
function emptyScheduled(scheduler) {
    return new (0, _observable.Observable)(function(subscriber) {
        return scheduler.schedule(function() {
            return subscriber.complete();
        });
    });
}

},{"../Observable":"9oc0x","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"alTvf":[function(require,module,exports) {
/** PURE_IMPORTS_START _util_isScheduler,_fromArray,_scheduled_scheduleArray PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "of", ()=>of);
var _isScheduler = require("../util/isScheduler");
var _fromArray = require("./fromArray");
var _scheduleArray = require("../scheduled/scheduleArray");
function of() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    var scheduler = args[args.length - 1];
    if ((0, _isScheduler.isScheduler)(scheduler)) {
        args.pop();
        return (0, _scheduleArray.scheduleArray)(args, scheduler);
    } else return (0, _fromArray.fromArray)(args);
}

},{"../util/isScheduler":"4iYg4","./fromArray":"b1aUF","../scheduled/scheduleArray":"7CQYE","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4iYg4":[function(require,module,exports) {
/** PURE_IMPORTS_START  PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isScheduler", ()=>isScheduler);
function isScheduler(value) {
    return value && typeof value.schedule === "function";
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"b1aUF":[function(require,module,exports) {
/** PURE_IMPORTS_START _Observable,_util_subscribeToArray,_scheduled_scheduleArray PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "fromArray", ()=>fromArray);
var _observable = require("../Observable");
var _subscribeToArray = require("../util/subscribeToArray");
var _scheduleArray = require("../scheduled/scheduleArray");
function fromArray(input, scheduler) {
    if (!scheduler) return new (0, _observable.Observable)((0, _subscribeToArray.subscribeToArray)(input));
    else return (0, _scheduleArray.scheduleArray)(input, scheduler);
}

},{"../Observable":"9oc0x","../util/subscribeToArray":"av2hi","../scheduled/scheduleArray":"7CQYE","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"av2hi":[function(require,module,exports) {
/** PURE_IMPORTS_START  PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "subscribeToArray", ()=>subscribeToArray);
var subscribeToArray = function(array) {
    return function(subscriber) {
        for(var i = 0, len = array.length; i < len && !subscriber.closed; i++)subscriber.next(array[i]);
        subscriber.complete();
    };
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7CQYE":[function(require,module,exports) {
/** PURE_IMPORTS_START _Observable,_Subscription PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "scheduleArray", ()=>scheduleArray);
var _observable = require("../Observable");
var _subscription = require("../Subscription");
function scheduleArray(input, scheduler) {
    return new (0, _observable.Observable)(function(subscriber) {
        var sub = new (0, _subscription.Subscription)();
        var i = 0;
        sub.add(scheduler.schedule(function() {
            if (i === input.length) {
                subscriber.complete();
                return;
            }
            subscriber.next(input[i++]);
            if (!subscriber.closed) sub.add(this.schedule());
        }));
        return sub;
    });
}

},{"../Observable":"9oc0x","../Subscription":"ahthJ","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4BUNm":[function(require,module,exports) {
/** PURE_IMPORTS_START _Observable PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "throwError", ()=>throwError);
var _observable = require("../Observable");
function throwError(error, scheduler) {
    if (!scheduler) return new (0, _observable.Observable)(function(subscriber) {
        return subscriber.error(error);
    });
    else return new (0, _observable.Observable)(function(subscriber) {
        return scheduler.schedule(dispatch, 0, {
            error: error,
            subscriber: subscriber
        });
    });
}
function dispatch(_a) {
    var error = _a.error, subscriber = _a.subscriber;
    subscriber.error(error);
}

},{"../Observable":"9oc0x","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"6P7LP":[function(require,module,exports) {
/** PURE_IMPORTS_START tslib,_Subject,_Subscription PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AsyncSubject", ()=>AsyncSubject);
var _tslib = require("tslib");
var _subject = require("./Subject");
var _subscription = require("./Subscription");
var AsyncSubject = /*@__PURE__*/ function(_super) {
    _tslib.__extends(AsyncSubject, _super);
    function AsyncSubject() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.value = null;
        _this.hasNext = false;
        _this.hasCompleted = false;
        return _this;
    }
    AsyncSubject.prototype._subscribe = function(subscriber) {
        if (this.hasError) {
            subscriber.error(this.thrownError);
            return (0, _subscription.Subscription).EMPTY;
        } else if (this.hasCompleted && this.hasNext) {
            subscriber.next(this.value);
            subscriber.complete();
            return (0, _subscription.Subscription).EMPTY;
        }
        return _super.prototype._subscribe.call(this, subscriber);
    };
    AsyncSubject.prototype.next = function(value) {
        if (!this.hasCompleted) {
            this.value = value;
            this.hasNext = true;
        }
    };
    AsyncSubject.prototype.error = function(error) {
        if (!this.hasCompleted) _super.prototype.error.call(this, error);
    };
    AsyncSubject.prototype.complete = function() {
        this.hasCompleted = true;
        if (this.hasNext) _super.prototype.next.call(this, this.value);
        _super.prototype.complete.call(this);
    };
    return AsyncSubject;
}((0, _subject.Subject));

},{"tslib":"kcqwq","./Subject":"84bef","./Subscription":"ahthJ","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"5Pp9f":[function(require,module,exports) {
/** PURE_IMPORTS_START _AsapAction,_AsapScheduler PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "asapScheduler", ()=>asapScheduler);
parcelHelpers.export(exports, "asap", ()=>asap);
var _asapAction = require("./AsapAction");
var _asapScheduler = require("./AsapScheduler");
var asapScheduler = /*@__PURE__*/ new (0, _asapScheduler.AsapScheduler)((0, _asapAction.AsapAction));
var asap = asapScheduler;

},{"./AsapAction":"dfAb5","./AsapScheduler":"iCzDz","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"dfAb5":[function(require,module,exports) {
/** PURE_IMPORTS_START tslib,_util_Immediate,_AsyncAction PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AsapAction", ()=>AsapAction);
var _tslib = require("tslib");
var _immediate = require("../util/Immediate");
var _asyncAction = require("./AsyncAction");
var AsapAction = /*@__PURE__*/ function(_super) {
    _tslib.__extends(AsapAction, _super);
    function AsapAction(scheduler, work) {
        var _this = _super.call(this, scheduler, work) || this;
        _this.scheduler = scheduler;
        _this.work = work;
        return _this;
    }
    AsapAction.prototype.requestAsyncId = function(scheduler, id, delay) {
        if (delay === void 0) delay = 0;
        if (delay !== null && delay > 0) return _super.prototype.requestAsyncId.call(this, scheduler, id, delay);
        scheduler.actions.push(this);
        return scheduler.scheduled || (scheduler.scheduled = (0, _immediate.Immediate).setImmediate(scheduler.flush.bind(scheduler, null)));
    };
    AsapAction.prototype.recycleAsyncId = function(scheduler, id, delay) {
        if (delay === void 0) delay = 0;
        if (delay !== null && delay > 0 || delay === null && this.delay > 0) return _super.prototype.recycleAsyncId.call(this, scheduler, id, delay);
        if (scheduler.actions.length === 0) {
            (0, _immediate.Immediate).clearImmediate(id);
            scheduler.scheduled = undefined;
        }
        return undefined;
    };
    return AsapAction;
}((0, _asyncAction.AsyncAction));

},{"tslib":"kcqwq","../util/Immediate":"8ngek","./AsyncAction":"5Tduw","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8ngek":[function(require,module,exports) {
/** PURE_IMPORTS_START  PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Immediate", ()=>Immediate);
parcelHelpers.export(exports, "TestTools", ()=>TestTools);
var nextHandle = 1;
var RESOLVED = /*@__PURE__*/ function() {
    return /*@__PURE__*/ Promise.resolve();
}();
var activeHandles = {};
function findAndClearHandle(handle) {
    if (handle in activeHandles) {
        delete activeHandles[handle];
        return true;
    }
    return false;
}
var Immediate = {
    setImmediate: function(cb) {
        var handle = nextHandle++;
        activeHandles[handle] = true;
        RESOLVED.then(function() {
            return findAndClearHandle(handle) && cb();
        });
        return handle;
    },
    clearImmediate: function(handle) {
        findAndClearHandle(handle);
    }
};
var TestTools = {
    pending: function() {
        return Object.keys(activeHandles).length;
    }
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"iCzDz":[function(require,module,exports) {
/** PURE_IMPORTS_START tslib,_AsyncScheduler PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AsapScheduler", ()=>AsapScheduler);
var _tslib = require("tslib");
var _asyncScheduler = require("./AsyncScheduler");
var AsapScheduler = /*@__PURE__*/ function(_super) {
    _tslib.__extends(AsapScheduler, _super);
    function AsapScheduler() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AsapScheduler.prototype.flush = function(action) {
        this.active = true;
        this.scheduled = undefined;
        var actions = this.actions;
        var error;
        var index = -1;
        var count = actions.length;
        action = action || actions.shift();
        do {
            if (error = action.execute(action.state, action.delay)) break;
        }while (++index < count && (action = actions.shift()));
        this.active = false;
        if (error) {
            while(++index < count && (action = actions.shift()))action.unsubscribe();
            throw error;
        }
    };
    return AsapScheduler;
}((0, _asyncScheduler.AsyncScheduler));

},{"tslib":"kcqwq","./AsyncScheduler":"l4ot2","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"l1cmn":[function(require,module,exports) {
/** PURE_IMPORTS_START _AsyncAction,_AsyncScheduler PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "asyncScheduler", ()=>asyncScheduler);
parcelHelpers.export(exports, "async", ()=>async);
var _asyncAction = require("./AsyncAction");
var _asyncScheduler = require("./AsyncScheduler");
var asyncScheduler = /*@__PURE__*/ new (0, _asyncScheduler.AsyncScheduler)((0, _asyncAction.AsyncAction));
var async = asyncScheduler;

},{"./AsyncAction":"5Tduw","./AsyncScheduler":"l4ot2","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"5JNHq":[function(require,module,exports) {
/** PURE_IMPORTS_START _AnimationFrameAction,_AnimationFrameScheduler PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "animationFrameScheduler", ()=>animationFrameScheduler);
parcelHelpers.export(exports, "animationFrame", ()=>animationFrame);
var _animationFrameAction = require("./AnimationFrameAction");
var _animationFrameScheduler = require("./AnimationFrameScheduler");
var animationFrameScheduler = /*@__PURE__*/ new (0, _animationFrameScheduler.AnimationFrameScheduler)((0, _animationFrameAction.AnimationFrameAction));
var animationFrame = animationFrameScheduler;

},{"./AnimationFrameAction":"IJG8Q","./AnimationFrameScheduler":"hxiBN","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"IJG8Q":[function(require,module,exports) {
/** PURE_IMPORTS_START tslib,_AsyncAction PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AnimationFrameAction", ()=>AnimationFrameAction);
var _tslib = require("tslib");
var _asyncAction = require("./AsyncAction");
var AnimationFrameAction = /*@__PURE__*/ function(_super) {
    _tslib.__extends(AnimationFrameAction, _super);
    function AnimationFrameAction(scheduler, work) {
        var _this = _super.call(this, scheduler, work) || this;
        _this.scheduler = scheduler;
        _this.work = work;
        return _this;
    }
    AnimationFrameAction.prototype.requestAsyncId = function(scheduler, id, delay) {
        if (delay === void 0) delay = 0;
        if (delay !== null && delay > 0) return _super.prototype.requestAsyncId.call(this, scheduler, id, delay);
        scheduler.actions.push(this);
        return scheduler.scheduled || (scheduler.scheduled = requestAnimationFrame(function() {
            return scheduler.flush(null);
        }));
    };
    AnimationFrameAction.prototype.recycleAsyncId = function(scheduler, id, delay) {
        if (delay === void 0) delay = 0;
        if (delay !== null && delay > 0 || delay === null && this.delay > 0) return _super.prototype.recycleAsyncId.call(this, scheduler, id, delay);
        if (scheduler.actions.length === 0) {
            cancelAnimationFrame(id);
            scheduler.scheduled = undefined;
        }
        return undefined;
    };
    return AnimationFrameAction;
}((0, _asyncAction.AsyncAction));

},{"tslib":"kcqwq","./AsyncAction":"5Tduw","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"hxiBN":[function(require,module,exports) {
/** PURE_IMPORTS_START tslib,_AsyncScheduler PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AnimationFrameScheduler", ()=>AnimationFrameScheduler);
var _tslib = require("tslib");
var _asyncScheduler = require("./AsyncScheduler");
var AnimationFrameScheduler = /*@__PURE__*/ function(_super) {
    _tslib.__extends(AnimationFrameScheduler, _super);
    function AnimationFrameScheduler() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AnimationFrameScheduler.prototype.flush = function(action) {
        this.active = true;
        this.scheduled = undefined;
        var actions = this.actions;
        var error;
        var index = -1;
        var count = actions.length;
        action = action || actions.shift();
        do {
            if (error = action.execute(action.state, action.delay)) break;
        }while (++index < count && (action = actions.shift()));
        this.active = false;
        if (error) {
            while(++index < count && (action = actions.shift()))action.unsubscribe();
            throw error;
        }
    };
    return AnimationFrameScheduler;
}((0, _asyncScheduler.AsyncScheduler));

},{"tslib":"kcqwq","./AsyncScheduler":"l4ot2","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"5SGjm":[function(require,module,exports) {
/** PURE_IMPORTS_START tslib,_AsyncAction,_AsyncScheduler PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "VirtualTimeScheduler", ()=>VirtualTimeScheduler);
parcelHelpers.export(exports, "VirtualAction", ()=>VirtualAction);
var _tslib = require("tslib");
var _asyncAction = require("./AsyncAction");
var _asyncScheduler = require("./AsyncScheduler");
var VirtualTimeScheduler = /*@__PURE__*/ function(_super) {
    _tslib.__extends(VirtualTimeScheduler, _super);
    function VirtualTimeScheduler(SchedulerAction, maxFrames) {
        if (SchedulerAction === void 0) SchedulerAction = VirtualAction;
        if (maxFrames === void 0) maxFrames = Number.POSITIVE_INFINITY;
        var _this = _super.call(this, SchedulerAction, function() {
            return _this.frame;
        }) || this;
        _this.maxFrames = maxFrames;
        _this.frame = 0;
        _this.index = -1;
        return _this;
    }
    VirtualTimeScheduler.prototype.flush = function() {
        var _a = this, actions = _a.actions, maxFrames = _a.maxFrames;
        var error, action;
        while((action = actions[0]) && action.delay <= maxFrames){
            actions.shift();
            this.frame = action.delay;
            if (error = action.execute(action.state, action.delay)) break;
        }
        if (error) {
            while(action = actions.shift())action.unsubscribe();
            throw error;
        }
    };
    VirtualTimeScheduler.frameTimeFactor = 10;
    return VirtualTimeScheduler;
}((0, _asyncScheduler.AsyncScheduler));
var VirtualAction = /*@__PURE__*/ function(_super) {
    _tslib.__extends(VirtualAction, _super);
    function VirtualAction(scheduler, work, index) {
        if (index === void 0) index = scheduler.index += 1;
        var _this = _super.call(this, scheduler, work) || this;
        _this.scheduler = scheduler;
        _this.work = work;
        _this.index = index;
        _this.active = true;
        _this.index = scheduler.index = index;
        return _this;
    }
    VirtualAction.prototype.schedule = function(state, delay) {
        if (delay === void 0) delay = 0;
        if (!this.id) return _super.prototype.schedule.call(this, state, delay);
        this.active = false;
        var action = new VirtualAction(this.scheduler, this.work);
        this.add(action);
        return action.schedule(state, delay);
    };
    VirtualAction.prototype.requestAsyncId = function(scheduler, id, delay) {
        if (delay === void 0) delay = 0;
        this.delay = scheduler.frame + delay;
        var actions = scheduler.actions;
        actions.push(this);
        actions.sort(VirtualAction.sortActions);
        return true;
    };
    VirtualAction.prototype.recycleAsyncId = function(scheduler, id, delay) {
        if (delay === void 0) delay = 0;
        return undefined;
    };
    VirtualAction.prototype._execute = function(state, delay) {
        if (this.active === true) return _super.prototype._execute.call(this, state, delay);
    };
    VirtualAction.sortActions = function(a, b) {
        if (a.delay === b.delay) {
            if (a.index === b.index) return 0;
            else if (a.index > b.index) return 1;
            else return -1;
        } else if (a.delay > b.delay) return 1;
        else return -1;
    };
    return VirtualAction;
}((0, _asyncAction.AsyncAction));

},{"tslib":"kcqwq","./AsyncAction":"5Tduw","./AsyncScheduler":"l4ot2","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4s4qZ":[function(require,module,exports) {
/** PURE_IMPORTS_START  PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "noop", ()=>noop);
function noop() {}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"6AlwM":[function(require,module,exports) {
/** PURE_IMPORTS_START _Observable PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isObservable", ()=>isObservable);
var _observable = require("../Observable");
function isObservable(obj) {
    return !!obj && (obj instanceof (0, _observable.Observable) || typeof obj.lift === "function" && typeof obj.subscribe === "function");
}

},{"../Observable":"9oc0x","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"38Gbx":[function(require,module,exports) {
/** PURE_IMPORTS_START  PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ArgumentOutOfRangeError", ()=>ArgumentOutOfRangeError);
var ArgumentOutOfRangeErrorImpl = /*@__PURE__*/ function() {
    function ArgumentOutOfRangeErrorImpl() {
        Error.call(this);
        this.message = "argument out of range";
        this.name = "ArgumentOutOfRangeError";
        return this;
    }
    ArgumentOutOfRangeErrorImpl.prototype = /*@__PURE__*/ Object.create(Error.prototype);
    return ArgumentOutOfRangeErrorImpl;
}();
var ArgumentOutOfRangeError = ArgumentOutOfRangeErrorImpl;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7a4tA":[function(require,module,exports) {
/** PURE_IMPORTS_START  PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "EmptyError", ()=>EmptyError);
var EmptyErrorImpl = /*@__PURE__*/ function() {
    function EmptyErrorImpl() {
        Error.call(this);
        this.message = "no elements in sequence";
        this.name = "EmptyError";
        return this;
    }
    EmptyErrorImpl.prototype = /*@__PURE__*/ Object.create(Error.prototype);
    return EmptyErrorImpl;
}();
var EmptyError = EmptyErrorImpl;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"iA33G":[function(require,module,exports) {
/** PURE_IMPORTS_START  PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TimeoutError", ()=>TimeoutError);
var TimeoutErrorImpl = /*@__PURE__*/ function() {
    function TimeoutErrorImpl() {
        Error.call(this);
        this.message = "Timeout has occurred";
        this.name = "TimeoutError";
        return this;
    }
    TimeoutErrorImpl.prototype = /*@__PURE__*/ Object.create(Error.prototype);
    return TimeoutErrorImpl;
}();
var TimeoutError = TimeoutErrorImpl;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"28HCa":[function(require,module,exports) {
/** PURE_IMPORTS_START _Observable,_AsyncSubject,_operators_map,_util_canReportError,_util_isArray,_util_isScheduler PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "bindCallback", ()=>bindCallback);
var _observable = require("../Observable");
var _asyncSubject = require("../AsyncSubject");
var _map = require("../operators/map");
var _canReportError = require("../util/canReportError");
var _isArray = require("../util/isArray");
var _isScheduler = require("../util/isScheduler");
function bindCallback(callbackFunc, resultSelector, scheduler) {
    if (resultSelector) {
        if ((0, _isScheduler.isScheduler)(resultSelector)) scheduler = resultSelector;
        else return function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return bindCallback(callbackFunc, scheduler).apply(void 0, args).pipe((0, _map.map)(function(args) {
                return (0, _isArray.isArray)(args) ? resultSelector.apply(void 0, args) : resultSelector(args);
            }));
        };
    }
    return function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        var context = this;
        var subject;
        var params = {
            context: context,
            subject: subject,
            callbackFunc: callbackFunc,
            scheduler: scheduler
        };
        return new (0, _observable.Observable)(function(subscriber) {
            if (!scheduler) {
                if (!subject) {
                    subject = new (0, _asyncSubject.AsyncSubject)();
                    var handler = function() {
                        var innerArgs = [];
                        for(var _i = 0; _i < arguments.length; _i++)innerArgs[_i] = arguments[_i];
                        subject.next(innerArgs.length <= 1 ? innerArgs[0] : innerArgs);
                        subject.complete();
                    };
                    try {
                        callbackFunc.apply(context, args.concat([
                            handler
                        ]));
                    } catch (err) {
                        if ((0, _canReportError.canReportError)(subject)) subject.error(err);
                        else console.warn(err);
                    }
                }
                return subject.subscribe(subscriber);
            } else {
                var state = {
                    args: args,
                    subscriber: subscriber,
                    params: params
                };
                return scheduler.schedule(dispatch, 0, state);
            }
        });
    };
}
function dispatch(state) {
    var _this = this;
    var self = this;
    var args = state.args, subscriber = state.subscriber, params = state.params;
    var callbackFunc = params.callbackFunc, context = params.context, scheduler = params.scheduler;
    var subject = params.subject;
    if (!subject) {
        subject = params.subject = new (0, _asyncSubject.AsyncSubject)();
        var handler = function() {
            var innerArgs = [];
            for(var _i = 0; _i < arguments.length; _i++)innerArgs[_i] = arguments[_i];
            var value = innerArgs.length <= 1 ? innerArgs[0] : innerArgs;
            _this.add(scheduler.schedule(dispatchNext, 0, {
                value: value,
                subject: subject
            }));
        };
        try {
            callbackFunc.apply(context, args.concat([
                handler
            ]));
        } catch (err) {
            subject.error(err);
        }
    }
    this.add(subject.subscribe(subscriber));
}
function dispatchNext(state) {
    var value = state.value, subject = state.subject;
    subject.next(value);
    subject.complete();
}
function dispatchError(state) {
    var err = state.err, subject = state.subject;
    subject.error(err);
}

},{"../Observable":"9oc0x","../AsyncSubject":"6P7LP","../operators/map":"cvzfg","../util/canReportError":"keo8s","../util/isArray":"2HaTi","../util/isScheduler":"4iYg4","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"cvzfg":[function(require,module,exports) {
/** PURE_IMPORTS_START tslib,_Subscriber PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "map", ()=>map);
parcelHelpers.export(exports, "MapOperator", ()=>MapOperator);
var _tslib = require("tslib");
var _subscriber = require("../Subscriber");
function map(project, thisArg) {
    return function mapOperation(source) {
        if (typeof project !== "function") throw new TypeError("argument is not a function. Are you looking for `mapTo()`?");
        return source.lift(new MapOperator(project, thisArg));
    };
}
var MapOperator = /*@__PURE__*/ function() {
    function MapOperator(project, thisArg) {
        this.project = project;
        this.thisArg = thisArg;
    }
    MapOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new MapSubscriber(subscriber, this.project, this.thisArg));
    };
    return MapOperator;
}();
var MapSubscriber = /*@__PURE__*/ function(_super) {
    _tslib.__extends(MapSubscriber, _super);
    function MapSubscriber(destination, project, thisArg) {
        var _this = _super.call(this, destination) || this;
        _this.project = project;
        _this.count = 0;
        _this.thisArg = thisArg || _this;
        return _this;
    }
    MapSubscriber.prototype._next = function(value) {
        var result;
        try {
            result = this.project.call(this.thisArg, value, this.count++);
        } catch (err) {
            this.destination.error(err);
            return;
        }
        this.destination.next(result);
    };
    return MapSubscriber;
}((0, _subscriber.Subscriber));

},{"tslib":"kcqwq","../Subscriber":"jGx8F","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"aiFEB":[function(require,module,exports) {
/** PURE_IMPORTS_START _Observable,_AsyncSubject,_operators_map,_util_canReportError,_util_isScheduler,_util_isArray PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "bindNodeCallback", ()=>bindNodeCallback);
var _observable = require("../Observable");
var _asyncSubject = require("../AsyncSubject");
var _map = require("../operators/map");
var _canReportError = require("../util/canReportError");
var _isScheduler = require("../util/isScheduler");
var _isArray = require("../util/isArray");
function bindNodeCallback(callbackFunc, resultSelector, scheduler) {
    if (resultSelector) {
        if ((0, _isScheduler.isScheduler)(resultSelector)) scheduler = resultSelector;
        else return function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return bindNodeCallback(callbackFunc, scheduler).apply(void 0, args).pipe((0, _map.map)(function(args) {
                return (0, _isArray.isArray)(args) ? resultSelector.apply(void 0, args) : resultSelector(args);
            }));
        };
    }
    return function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        var params = {
            subject: undefined,
            args: args,
            callbackFunc: callbackFunc,
            scheduler: scheduler,
            context: this
        };
        return new (0, _observable.Observable)(function(subscriber) {
            var context = params.context;
            var subject = params.subject;
            if (!scheduler) {
                if (!subject) {
                    subject = params.subject = new (0, _asyncSubject.AsyncSubject)();
                    var handler = function() {
                        var innerArgs = [];
                        for(var _i = 0; _i < arguments.length; _i++)innerArgs[_i] = arguments[_i];
                        var err = innerArgs.shift();
                        if (err) {
                            subject.error(err);
                            return;
                        }
                        subject.next(innerArgs.length <= 1 ? innerArgs[0] : innerArgs);
                        subject.complete();
                    };
                    try {
                        callbackFunc.apply(context, args.concat([
                            handler
                        ]));
                    } catch (err) {
                        if ((0, _canReportError.canReportError)(subject)) subject.error(err);
                        else console.warn(err);
                    }
                }
                return subject.subscribe(subscriber);
            } else return scheduler.schedule(dispatch, 0, {
                params: params,
                subscriber: subscriber,
                context: context
            });
        });
    };
}
function dispatch(state) {
    var _this = this;
    var params = state.params, subscriber = state.subscriber, context = state.context;
    var callbackFunc = params.callbackFunc, args = params.args, scheduler = params.scheduler;
    var subject = params.subject;
    if (!subject) {
        subject = params.subject = new (0, _asyncSubject.AsyncSubject)();
        var handler = function() {
            var innerArgs = [];
            for(var _i = 0; _i < arguments.length; _i++)innerArgs[_i] = arguments[_i];
            var err = innerArgs.shift();
            if (err) _this.add(scheduler.schedule(dispatchError, 0, {
                err: err,
                subject: subject
            }));
            else {
                var value = innerArgs.length <= 1 ? innerArgs[0] : innerArgs;
                _this.add(scheduler.schedule(dispatchNext, 0, {
                    value: value,
                    subject: subject
                }));
            }
        };
        try {
            callbackFunc.apply(context, args.concat([
                handler
            ]));
        } catch (err) {
            this.add(scheduler.schedule(dispatchError, 0, {
                err: err,
                subject: subject
            }));
        }
    }
    this.add(subject.subscribe(subscriber));
}
function dispatchNext(arg) {
    var value = arg.value, subject = arg.subject;
    subject.next(value);
    subject.complete();
}
function dispatchError(arg) {
    var err = arg.err, subject = arg.subject;
    subject.error(err);
}

},{"../Observable":"9oc0x","../AsyncSubject":"6P7LP","../operators/map":"cvzfg","../util/canReportError":"keo8s","../util/isScheduler":"4iYg4","../util/isArray":"2HaTi","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"wg3KP":[function(require,module,exports) {
/** PURE_IMPORTS_START tslib,_util_isScheduler,_util_isArray,_OuterSubscriber,_util_subscribeToResult,_fromArray PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "combineLatest", ()=>combineLatest);
parcelHelpers.export(exports, "CombineLatestOperator", ()=>CombineLatestOperator);
parcelHelpers.export(exports, "CombineLatestSubscriber", ()=>CombineLatestSubscriber);
var _tslib = require("tslib");
var _isScheduler = require("../util/isScheduler");
var _isArray = require("../util/isArray");
var _outerSubscriber = require("../OuterSubscriber");
var _subscribeToResult = require("../util/subscribeToResult");
var _fromArray = require("./fromArray");
var NONE = {};
function combineLatest() {
    var observables = [];
    for(var _i = 0; _i < arguments.length; _i++)observables[_i] = arguments[_i];
    var resultSelector = undefined;
    var scheduler = undefined;
    if ((0, _isScheduler.isScheduler)(observables[observables.length - 1])) scheduler = observables.pop();
    if (typeof observables[observables.length - 1] === "function") resultSelector = observables.pop();
    if (observables.length === 1 && (0, _isArray.isArray)(observables[0])) observables = observables[0];
    return (0, _fromArray.fromArray)(observables, scheduler).lift(new CombineLatestOperator(resultSelector));
}
var CombineLatestOperator = /*@__PURE__*/ function() {
    function CombineLatestOperator(resultSelector) {
        this.resultSelector = resultSelector;
    }
    CombineLatestOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new CombineLatestSubscriber(subscriber, this.resultSelector));
    };
    return CombineLatestOperator;
}();
var CombineLatestSubscriber = /*@__PURE__*/ function(_super) {
    _tslib.__extends(CombineLatestSubscriber, _super);
    function CombineLatestSubscriber(destination, resultSelector) {
        var _this = _super.call(this, destination) || this;
        _this.resultSelector = resultSelector;
        _this.active = 0;
        _this.values = [];
        _this.observables = [];
        return _this;
    }
    CombineLatestSubscriber.prototype._next = function(observable) {
        this.values.push(NONE);
        this.observables.push(observable);
    };
    CombineLatestSubscriber.prototype._complete = function() {
        var observables = this.observables;
        var len = observables.length;
        if (len === 0) this.destination.complete();
        else {
            this.active = len;
            this.toRespond = len;
            for(var i = 0; i < len; i++){
                var observable = observables[i];
                this.add((0, _subscribeToResult.subscribeToResult)(this, observable, undefined, i));
            }
        }
    };
    CombineLatestSubscriber.prototype.notifyComplete = function(unused) {
        if ((this.active -= 1) === 0) this.destination.complete();
    };
    CombineLatestSubscriber.prototype.notifyNext = function(_outerValue, innerValue, outerIndex) {
        var values = this.values;
        var oldVal = values[outerIndex];
        var toRespond = !this.toRespond ? 0 : oldVal === NONE ? --this.toRespond : this.toRespond;
        values[outerIndex] = innerValue;
        if (toRespond === 0) {
            if (this.resultSelector) this._tryResultSelector(values);
            else this.destination.next(values.slice());
        }
    };
    CombineLatestSubscriber.prototype._tryResultSelector = function(values) {
        var result;
        try {
            result = this.resultSelector.apply(this, values);
        } catch (err) {
            this.destination.error(err);
            return;
        }
        this.destination.next(result);
    };
    return CombineLatestSubscriber;
}((0, _outerSubscriber.OuterSubscriber));

},{"tslib":"kcqwq","../util/isScheduler":"4iYg4","../util/isArray":"2HaTi","../OuterSubscriber":"fECUl","../util/subscribeToResult":"4ctqX","./fromArray":"b1aUF","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"fECUl":[function(require,module,exports) {
/** PURE_IMPORTS_START tslib,_Subscriber PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "OuterSubscriber", ()=>OuterSubscriber);
var _tslib = require("tslib");
var _subscriber = require("./Subscriber");
var OuterSubscriber = /*@__PURE__*/ function(_super) {
    _tslib.__extends(OuterSubscriber, _super);
    function OuterSubscriber() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    OuterSubscriber.prototype.notifyNext = function(outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        this.destination.next(innerValue);
    };
    OuterSubscriber.prototype.notifyError = function(error, innerSub) {
        this.destination.error(error);
    };
    OuterSubscriber.prototype.notifyComplete = function(innerSub) {
        this.destination.complete();
    };
    return OuterSubscriber;
}((0, _subscriber.Subscriber));

},{"tslib":"kcqwq","./Subscriber":"jGx8F","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4ctqX":[function(require,module,exports) {
/** PURE_IMPORTS_START _InnerSubscriber,_subscribeTo,_Observable PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "subscribeToResult", ()=>subscribeToResult);
var _innerSubscriber = require("../InnerSubscriber");
var _subscribeTo = require("./subscribeTo");
var _observable = require("../Observable");
function subscribeToResult(outerSubscriber, result, outerValue, outerIndex, innerSubscriber) {
    if (innerSubscriber === void 0) innerSubscriber = new (0, _innerSubscriber.InnerSubscriber)(outerSubscriber, outerValue, outerIndex);
    if (innerSubscriber.closed) return undefined;
    if (result instanceof (0, _observable.Observable)) return result.subscribe(innerSubscriber);
    return (0, _subscribeTo.subscribeTo)(result)(innerSubscriber);
}

},{"../InnerSubscriber":"93bks","./subscribeTo":"fU69c","../Observable":"9oc0x","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"93bks":[function(require,module,exports) {
/** PURE_IMPORTS_START tslib,_Subscriber PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "InnerSubscriber", ()=>InnerSubscriber);
var _tslib = require("tslib");
var _subscriber = require("./Subscriber");
var InnerSubscriber = /*@__PURE__*/ function(_super) {
    _tslib.__extends(InnerSubscriber, _super);
    function InnerSubscriber(parent, outerValue, outerIndex) {
        var _this = _super.call(this) || this;
        _this.parent = parent;
        _this.outerValue = outerValue;
        _this.outerIndex = outerIndex;
        _this.index = 0;
        return _this;
    }
    InnerSubscriber.prototype._next = function(value) {
        this.parent.notifyNext(this.outerValue, value, this.outerIndex, this.index++, this);
    };
    InnerSubscriber.prototype._error = function(error) {
        this.parent.notifyError(error, this);
        this.unsubscribe();
    };
    InnerSubscriber.prototype._complete = function() {
        this.parent.notifyComplete(this);
        this.unsubscribe();
    };
    return InnerSubscriber;
}((0, _subscriber.Subscriber));

},{"tslib":"kcqwq","./Subscriber":"jGx8F","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"fU69c":[function(require,module,exports) {
/** PURE_IMPORTS_START _subscribeToArray,_subscribeToPromise,_subscribeToIterable,_subscribeToObservable,_isArrayLike,_isPromise,_isObject,_symbol_iterator,_symbol_observable PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "subscribeTo", ()=>subscribeTo);
var _subscribeToArray = require("./subscribeToArray");
var _subscribeToPromise = require("./subscribeToPromise");
var _subscribeToIterable = require("./subscribeToIterable");
var _subscribeToObservable = require("./subscribeToObservable");
var _isArrayLike = require("./isArrayLike");
var _isPromise = require("./isPromise");
var _isObject = require("./isObject");
var _iterator = require("../symbol/iterator");
var _observable = require("../symbol/observable");
var subscribeTo = function(result) {
    if (!!result && typeof result[0, _observable.observable] === "function") return (0, _subscribeToObservable.subscribeToObservable)(result);
    else if ((0, _isArrayLike.isArrayLike)(result)) return (0, _subscribeToArray.subscribeToArray)(result);
    else if ((0, _isPromise.isPromise)(result)) return (0, _subscribeToPromise.subscribeToPromise)(result);
    else if (!!result && typeof result[0, _iterator.iterator] === "function") return (0, _subscribeToIterable.subscribeToIterable)(result);
    else {
        var value = (0, _isObject.isObject)(result) ? "an invalid object" : "'" + result + "'";
        var msg = "You provided " + value + " where a stream was expected." + " You can provide an Observable, Promise, Array, or Iterable.";
        throw new TypeError(msg);
    }
};

},{"./subscribeToArray":"av2hi","./subscribeToPromise":"4BxHE","./subscribeToIterable":"04UeX","./subscribeToObservable":"dZiTJ","./isArrayLike":"go7hX","./isPromise":"9CjT0","./isObject":"6Fmw6","../symbol/iterator":"jShcT","../symbol/observable":"9l5a7","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4BxHE":[function(require,module,exports) {
/** PURE_IMPORTS_START _hostReportError PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "subscribeToPromise", ()=>subscribeToPromise);
var _hostReportError = require("./hostReportError");
var subscribeToPromise = function(promise) {
    return function(subscriber) {
        promise.then(function(value) {
            if (!subscriber.closed) {
                subscriber.next(value);
                subscriber.complete();
            }
        }, function(err) {
            return subscriber.error(err);
        }).then(null, (0, _hostReportError.hostReportError));
        return subscriber;
    };
};

},{"./hostReportError":"l3YZ5","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"04UeX":[function(require,module,exports) {
/** PURE_IMPORTS_START _symbol_iterator PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "subscribeToIterable", ()=>subscribeToIterable);
var _iterator = require("../symbol/iterator");
var subscribeToIterable = function(iterable) {
    return function(subscriber) {
        var iterator = iterable[0, _iterator.iterator]();
        do {
            var item = void 0;
            try {
                item = iterator.next();
            } catch (err) {
                subscriber.error(err);
                return subscriber;
            }
            if (item.done) {
                subscriber.complete();
                break;
            }
            subscriber.next(item.value);
            if (subscriber.closed) break;
        }while (true);
        if (typeof iterator.return === "function") subscriber.add(function() {
            if (iterator.return) iterator.return();
        });
        return subscriber;
    };
};

},{"../symbol/iterator":"jShcT","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"jShcT":[function(require,module,exports) {
/** PURE_IMPORTS_START  PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getSymbolIterator", ()=>getSymbolIterator);
parcelHelpers.export(exports, "iterator", ()=>iterator);
parcelHelpers.export(exports, "$$iterator", ()=>$$iterator);
function getSymbolIterator() {
    if (typeof Symbol !== "function" || !Symbol.iterator) return "@@iterator";
    return Symbol.iterator;
}
var iterator = /*@__PURE__*/ getSymbolIterator();
var $$iterator = iterator;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"dZiTJ":[function(require,module,exports) {
/** PURE_IMPORTS_START _symbol_observable PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "subscribeToObservable", ()=>subscribeToObservable);
var _observable = require("../symbol/observable");
var subscribeToObservable = function(obj) {
    return function(subscriber) {
        var obs = obj[0, _observable.observable]();
        if (typeof obs.subscribe !== "function") throw new TypeError("Provided object does not correctly implement Symbol.observable");
        else return obs.subscribe(subscriber);
    };
};

},{"../symbol/observable":"9l5a7","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"go7hX":[function(require,module,exports) {
/** PURE_IMPORTS_START  PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isArrayLike", ()=>isArrayLike);
var isArrayLike = function(x) {
    return x && typeof x.length === "number" && typeof x !== "function";
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9CjT0":[function(require,module,exports) {
/** PURE_IMPORTS_START  PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isPromise", ()=>isPromise);
function isPromise(value) {
    return !!value && typeof value.subscribe !== "function" && typeof value.then === "function";
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2cXL0":[function(require,module,exports) {
/** PURE_IMPORTS_START _of,_operators_concatAll PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "concat", ()=>concat);
var _of = require("./of");
var _concatAll = require("../operators/concatAll");
function concat() {
    var observables = [];
    for(var _i = 0; _i < arguments.length; _i++)observables[_i] = arguments[_i];
    return (0, _concatAll.concatAll)()((0, _of.of).apply(void 0, observables));
}

},{"./of":"alTvf","../operators/concatAll":"8bdTP","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8bdTP":[function(require,module,exports) {
/** PURE_IMPORTS_START _mergeAll PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "concatAll", ()=>concatAll);
var _mergeAll = require("./mergeAll");
function concatAll() {
    return (0, _mergeAll.mergeAll)(1);
}

},{"./mergeAll":"jXE8c","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"jXE8c":[function(require,module,exports) {
/** PURE_IMPORTS_START _mergeMap,_util_identity PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "mergeAll", ()=>mergeAll);
var _mergeMap = require("./mergeMap");
var _identity = require("../util/identity");
function mergeAll(concurrent) {
    if (concurrent === void 0) concurrent = Number.POSITIVE_INFINITY;
    return (0, _mergeMap.mergeMap)((0, _identity.identity), concurrent);
}

},{"./mergeMap":"7NAZz","../util/identity":"kDT9y","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7NAZz":[function(require,module,exports) {
/** PURE_IMPORTS_START tslib,_map,_observable_from,_innerSubscribe PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "mergeMap", ()=>mergeMap);
parcelHelpers.export(exports, "MergeMapOperator", ()=>MergeMapOperator);
parcelHelpers.export(exports, "MergeMapSubscriber", ()=>MergeMapSubscriber);
parcelHelpers.export(exports, "flatMap", ()=>flatMap);
var _tslib = require("tslib");
var _map = require("./map");
var _from = require("../observable/from");
var _innerSubscribe = require("../innerSubscribe");
function mergeMap(project, resultSelector, concurrent) {
    if (concurrent === void 0) concurrent = Number.POSITIVE_INFINITY;
    if (typeof resultSelector === "function") return function(source) {
        return source.pipe(mergeMap(function(a, i) {
            return (0, _from.from)(project(a, i)).pipe((0, _map.map)(function(b, ii) {
                return resultSelector(a, b, i, ii);
            }));
        }, concurrent));
    };
    else if (typeof resultSelector === "number") concurrent = resultSelector;
    return function(source) {
        return source.lift(new MergeMapOperator(project, concurrent));
    };
}
var MergeMapOperator = /*@__PURE__*/ function() {
    function MergeMapOperator(project, concurrent) {
        if (concurrent === void 0) concurrent = Number.POSITIVE_INFINITY;
        this.project = project;
        this.concurrent = concurrent;
    }
    MergeMapOperator.prototype.call = function(observer, source) {
        return source.subscribe(new MergeMapSubscriber(observer, this.project, this.concurrent));
    };
    return MergeMapOperator;
}();
var MergeMapSubscriber = /*@__PURE__*/ function(_super) {
    _tslib.__extends(MergeMapSubscriber, _super);
    function MergeMapSubscriber(destination, project, concurrent) {
        if (concurrent === void 0) concurrent = Number.POSITIVE_INFINITY;
        var _this = _super.call(this, destination) || this;
        _this.project = project;
        _this.concurrent = concurrent;
        _this.hasCompleted = false;
        _this.buffer = [];
        _this.active = 0;
        _this.index = 0;
        return _this;
    }
    MergeMapSubscriber.prototype._next = function(value) {
        if (this.active < this.concurrent) this._tryNext(value);
        else this.buffer.push(value);
    };
    MergeMapSubscriber.prototype._tryNext = function(value) {
        var result;
        var index = this.index++;
        try {
            result = this.project(value, index);
        } catch (err) {
            this.destination.error(err);
            return;
        }
        this.active++;
        this._innerSub(result);
    };
    MergeMapSubscriber.prototype._innerSub = function(ish) {
        var innerSubscriber = new (0, _innerSubscribe.SimpleInnerSubscriber)(this);
        var destination = this.destination;
        destination.add(innerSubscriber);
        var innerSubscription = (0, _innerSubscribe.innerSubscribe)(ish, innerSubscriber);
        if (innerSubscription !== innerSubscriber) destination.add(innerSubscription);
    };
    MergeMapSubscriber.prototype._complete = function() {
        this.hasCompleted = true;
        if (this.active === 0 && this.buffer.length === 0) this.destination.complete();
        this.unsubscribe();
    };
    MergeMapSubscriber.prototype.notifyNext = function(innerValue) {
        this.destination.next(innerValue);
    };
    MergeMapSubscriber.prototype.notifyComplete = function() {
        var buffer = this.buffer;
        this.active--;
        if (buffer.length > 0) this._next(buffer.shift());
        else if (this.active === 0 && this.hasCompleted) this.destination.complete();
    };
    return MergeMapSubscriber;
}((0, _innerSubscribe.SimpleOuterSubscriber));
var flatMap = mergeMap;

},{"tslib":"kcqwq","./map":"cvzfg","../observable/from":"6aqs0","../innerSubscribe":"73frt","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"6aqs0":[function(require,module,exports) {
/** PURE_IMPORTS_START _Observable,_util_subscribeTo,_scheduled_scheduled PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "from", ()=>from);
var _observable = require("../Observable");
var _subscribeTo = require("../util/subscribeTo");
var _scheduled = require("../scheduled/scheduled");
function from(input, scheduler) {
    if (!scheduler) {
        if (input instanceof (0, _observable.Observable)) return input;
        return new (0, _observable.Observable)((0, _subscribeTo.subscribeTo)(input));
    } else return (0, _scheduled.scheduled)(input, scheduler);
}

},{"../Observable":"9oc0x","../util/subscribeTo":"fU69c","../scheduled/scheduled":"3d02Q","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"3d02Q":[function(require,module,exports) {
/** PURE_IMPORTS_START _scheduleObservable,_schedulePromise,_scheduleArray,_scheduleIterable,_util_isInteropObservable,_util_isPromise,_util_isArrayLike,_util_isIterable PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "scheduled", ()=>scheduled);
var _scheduleObservable = require("./scheduleObservable");
var _schedulePromise = require("./schedulePromise");
var _scheduleArray = require("./scheduleArray");
var _scheduleIterable = require("./scheduleIterable");
var _isInteropObservable = require("../util/isInteropObservable");
var _isPromise = require("../util/isPromise");
var _isArrayLike = require("../util/isArrayLike");
var _isIterable = require("../util/isIterable");
function scheduled(input, scheduler) {
    if (input != null) {
        if ((0, _isInteropObservable.isInteropObservable)(input)) return (0, _scheduleObservable.scheduleObservable)(input, scheduler);
        else if ((0, _isPromise.isPromise)(input)) return (0, _schedulePromise.schedulePromise)(input, scheduler);
        else if ((0, _isArrayLike.isArrayLike)(input)) return (0, _scheduleArray.scheduleArray)(input, scheduler);
        else if ((0, _isIterable.isIterable)(input) || typeof input === "string") return (0, _scheduleIterable.scheduleIterable)(input, scheduler);
    }
    throw new TypeError((input !== null && typeof input || input) + " is not observable");
}

},{"./scheduleObservable":"hGPHf","./schedulePromise":"4mYM9","./scheduleArray":"7CQYE","./scheduleIterable":"601jO","../util/isInteropObservable":"ivPHI","../util/isPromise":"9CjT0","../util/isArrayLike":"go7hX","../util/isIterable":"7bSqA","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"hGPHf":[function(require,module,exports) {
/** PURE_IMPORTS_START _Observable,_Subscription,_symbol_observable PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "scheduleObservable", ()=>scheduleObservable);
var _observable = require("../Observable");
var _subscription = require("../Subscription");
var _observable1 = require("../symbol/observable");
function scheduleObservable(input, scheduler) {
    return new (0, _observable.Observable)(function(subscriber) {
        var sub = new (0, _subscription.Subscription)();
        sub.add(scheduler.schedule(function() {
            var observable = input[0, _observable1.observable]();
            sub.add(observable.subscribe({
                next: function(value) {
                    sub.add(scheduler.schedule(function() {
                        return subscriber.next(value);
                    }));
                },
                error: function(err) {
                    sub.add(scheduler.schedule(function() {
                        return subscriber.error(err);
                    }));
                },
                complete: function() {
                    sub.add(scheduler.schedule(function() {
                        return subscriber.complete();
                    }));
                }
            }));
        }));
        return sub;
    });
}

},{"../Observable":"9oc0x","../Subscription":"ahthJ","../symbol/observable":"9l5a7","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4mYM9":[function(require,module,exports) {
/** PURE_IMPORTS_START _Observable,_Subscription PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "schedulePromise", ()=>schedulePromise);
var _observable = require("../Observable");
var _subscription = require("../Subscription");
function schedulePromise(input, scheduler) {
    return new (0, _observable.Observable)(function(subscriber) {
        var sub = new (0, _subscription.Subscription)();
        sub.add(scheduler.schedule(function() {
            return input.then(function(value) {
                sub.add(scheduler.schedule(function() {
                    subscriber.next(value);
                    sub.add(scheduler.schedule(function() {
                        return subscriber.complete();
                    }));
                }));
            }, function(err) {
                sub.add(scheduler.schedule(function() {
                    return subscriber.error(err);
                }));
            });
        }));
        return sub;
    });
}

},{"../Observable":"9oc0x","../Subscription":"ahthJ","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"601jO":[function(require,module,exports) {
/** PURE_IMPORTS_START _Observable,_Subscription,_symbol_iterator PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "scheduleIterable", ()=>scheduleIterable);
var _observable = require("../Observable");
var _subscription = require("../Subscription");
var _iterator = require("../symbol/iterator");
function scheduleIterable(input, scheduler) {
    if (!input) throw new Error("Iterable cannot be null");
    return new (0, _observable.Observable)(function(subscriber) {
        var sub = new (0, _subscription.Subscription)();
        var iterator;
        sub.add(function() {
            if (iterator && typeof iterator.return === "function") iterator.return();
        });
        sub.add(scheduler.schedule(function() {
            iterator = input[0, _iterator.iterator]();
            sub.add(scheduler.schedule(function() {
                if (subscriber.closed) return;
                var value;
                var done;
                try {
                    var result = iterator.next();
                    value = result.value;
                    done = result.done;
                } catch (err) {
                    subscriber.error(err);
                    return;
                }
                if (done) subscriber.complete();
                else {
                    subscriber.next(value);
                    this.schedule();
                }
            }));
        }));
        return sub;
    });
}

},{"../Observable":"9oc0x","../Subscription":"ahthJ","../symbol/iterator":"jShcT","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"ivPHI":[function(require,module,exports) {
/** PURE_IMPORTS_START _symbol_observable PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isInteropObservable", ()=>isInteropObservable);
var _observable = require("../symbol/observable");
function isInteropObservable(input) {
    return input && typeof input[0, _observable.observable] === "function";
}

},{"../symbol/observable":"9l5a7","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7bSqA":[function(require,module,exports) {
/** PURE_IMPORTS_START _symbol_iterator PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isIterable", ()=>isIterable);
var _iterator = require("../symbol/iterator");
function isIterable(input) {
    return input && typeof input[0, _iterator.iterator] === "function";
}

},{"../symbol/iterator":"jShcT","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"73frt":[function(require,module,exports) {
/** PURE_IMPORTS_START tslib,_Subscriber,_Observable,_util_subscribeTo PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SimpleInnerSubscriber", ()=>SimpleInnerSubscriber);
parcelHelpers.export(exports, "ComplexInnerSubscriber", ()=>ComplexInnerSubscriber);
parcelHelpers.export(exports, "SimpleOuterSubscriber", ()=>SimpleOuterSubscriber);
parcelHelpers.export(exports, "ComplexOuterSubscriber", ()=>ComplexOuterSubscriber);
parcelHelpers.export(exports, "innerSubscribe", ()=>innerSubscribe);
var _tslib = require("tslib");
var _subscriber = require("./Subscriber");
var _observable = require("./Observable");
var _subscribeTo = require("./util/subscribeTo");
var SimpleInnerSubscriber = /*@__PURE__*/ function(_super) {
    _tslib.__extends(SimpleInnerSubscriber, _super);
    function SimpleInnerSubscriber(parent) {
        var _this = _super.call(this) || this;
        _this.parent = parent;
        return _this;
    }
    SimpleInnerSubscriber.prototype._next = function(value) {
        this.parent.notifyNext(value);
    };
    SimpleInnerSubscriber.prototype._error = function(error) {
        this.parent.notifyError(error);
        this.unsubscribe();
    };
    SimpleInnerSubscriber.prototype._complete = function() {
        this.parent.notifyComplete();
        this.unsubscribe();
    };
    return SimpleInnerSubscriber;
}((0, _subscriber.Subscriber));
var ComplexInnerSubscriber = /*@__PURE__*/ function(_super) {
    _tslib.__extends(ComplexInnerSubscriber, _super);
    function ComplexInnerSubscriber(parent, outerValue, outerIndex) {
        var _this = _super.call(this) || this;
        _this.parent = parent;
        _this.outerValue = outerValue;
        _this.outerIndex = outerIndex;
        return _this;
    }
    ComplexInnerSubscriber.prototype._next = function(value) {
        this.parent.notifyNext(this.outerValue, value, this.outerIndex, this);
    };
    ComplexInnerSubscriber.prototype._error = function(error) {
        this.parent.notifyError(error);
        this.unsubscribe();
    };
    ComplexInnerSubscriber.prototype._complete = function() {
        this.parent.notifyComplete(this);
        this.unsubscribe();
    };
    return ComplexInnerSubscriber;
}((0, _subscriber.Subscriber));
var SimpleOuterSubscriber = /*@__PURE__*/ function(_super) {
    _tslib.__extends(SimpleOuterSubscriber, _super);
    function SimpleOuterSubscriber() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SimpleOuterSubscriber.prototype.notifyNext = function(innerValue) {
        this.destination.next(innerValue);
    };
    SimpleOuterSubscriber.prototype.notifyError = function(err) {
        this.destination.error(err);
    };
    SimpleOuterSubscriber.prototype.notifyComplete = function() {
        this.destination.complete();
    };
    return SimpleOuterSubscriber;
}((0, _subscriber.Subscriber));
var ComplexOuterSubscriber = /*@__PURE__*/ function(_super) {
    _tslib.__extends(ComplexOuterSubscriber, _super);
    function ComplexOuterSubscriber() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ComplexOuterSubscriber.prototype.notifyNext = function(_outerValue, innerValue, _outerIndex, _innerSub) {
        this.destination.next(innerValue);
    };
    ComplexOuterSubscriber.prototype.notifyError = function(error) {
        this.destination.error(error);
    };
    ComplexOuterSubscriber.prototype.notifyComplete = function(_innerSub) {
        this.destination.complete();
    };
    return ComplexOuterSubscriber;
}((0, _subscriber.Subscriber));
function innerSubscribe(result, innerSubscriber) {
    if (innerSubscriber.closed) return undefined;
    if (result instanceof (0, _observable.Observable)) return result.subscribe(innerSubscriber);
    var subscription;
    try {
        subscription = (0, _subscribeTo.subscribeTo)(result)(innerSubscriber);
    } catch (error) {
        innerSubscriber.error(error);
    }
    return subscription;
}

},{"tslib":"kcqwq","./Subscriber":"jGx8F","./Observable":"9oc0x","./util/subscribeTo":"fU69c","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"1uvAg":[function(require,module,exports) {
/** PURE_IMPORTS_START _Observable,_from,_empty PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "defer", ()=>defer);
var _observable = require("../Observable");
var _from = require("./from");
var _empty = require("./empty");
function defer(observableFactory) {
    return new (0, _observable.Observable)(function(subscriber) {
        var input;
        try {
            input = observableFactory();
        } catch (err) {
            subscriber.error(err);
            return undefined;
        }
        var source = input ? (0, _from.from)(input) : (0, _empty.empty)();
        return source.subscribe(subscriber);
    });
}

},{"../Observable":"9oc0x","./from":"6aqs0","./empty":"J4JDz","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"37dhH":[function(require,module,exports) {
/** PURE_IMPORTS_START _Observable,_util_isArray,_operators_map,_util_isObject,_from PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "forkJoin", ()=>forkJoin);
var _observable = require("../Observable");
var _isArray = require("../util/isArray");
var _map = require("../operators/map");
var _isObject = require("../util/isObject");
var _from = require("./from");
function forkJoin() {
    var sources = [];
    for(var _i = 0; _i < arguments.length; _i++)sources[_i] = arguments[_i];
    if (sources.length === 1) {
        var first_1 = sources[0];
        if ((0, _isArray.isArray)(first_1)) return forkJoinInternal(first_1, null);
        if ((0, _isObject.isObject)(first_1) && Object.getPrototypeOf(first_1) === Object.prototype) {
            var keys = Object.keys(first_1);
            return forkJoinInternal(keys.map(function(key) {
                return first_1[key];
            }), keys);
        }
    }
    if (typeof sources[sources.length - 1] === "function") {
        var resultSelector_1 = sources.pop();
        sources = sources.length === 1 && (0, _isArray.isArray)(sources[0]) ? sources[0] : sources;
        return forkJoinInternal(sources, null).pipe((0, _map.map)(function(args) {
            return resultSelector_1.apply(void 0, args);
        }));
    }
    return forkJoinInternal(sources, null);
}
function forkJoinInternal(sources, keys) {
    return new (0, _observable.Observable)(function(subscriber) {
        var len = sources.length;
        if (len === 0) {
            subscriber.complete();
            return;
        }
        var values = new Array(len);
        var completed = 0;
        var emitted = 0;
        var _loop_1 = function(i) {
            var source = (0, _from.from)(sources[i]);
            var hasValue = false;
            subscriber.add(source.subscribe({
                next: function(value) {
                    if (!hasValue) {
                        hasValue = true;
                        emitted++;
                    }
                    values[i] = value;
                },
                error: function(err) {
                    return subscriber.error(err);
                },
                complete: function() {
                    completed++;
                    if (completed === len || !hasValue) {
                        if (emitted === len) subscriber.next(keys ? keys.reduce(function(result, key, i) {
                            return result[key] = values[i], result;
                        }, {}) : values);
                        subscriber.complete();
                    }
                }
            }));
        };
        for(var i = 0; i < len; i++)_loop_1(i);
    });
}

},{"../Observable":"9oc0x","../util/isArray":"2HaTi","../operators/map":"cvzfg","../util/isObject":"6Fmw6","./from":"6aqs0","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7pSEN":[function(require,module,exports) {
/** PURE_IMPORTS_START _Observable,_util_isArray,_util_isFunction,_operators_map PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "fromEvent", ()=>fromEvent);
var _observable = require("../Observable");
var _isArray = require("../util/isArray");
var _isFunction = require("../util/isFunction");
var _map = require("../operators/map");
var toString = /*@__PURE__*/ function() {
    return Object.prototype.toString;
}();
function fromEvent(target, eventName, options, resultSelector) {
    if ((0, _isFunction.isFunction)(options)) {
        resultSelector = options;
        options = undefined;
    }
    if (resultSelector) return fromEvent(target, eventName, options).pipe((0, _map.map)(function(args) {
        return (0, _isArray.isArray)(args) ? resultSelector.apply(void 0, args) : resultSelector(args);
    }));
    return new (0, _observable.Observable)(function(subscriber) {
        function handler(e) {
            if (arguments.length > 1) subscriber.next(Array.prototype.slice.call(arguments));
            else subscriber.next(e);
        }
        setupSubscription(target, eventName, handler, subscriber, options);
    });
}
function setupSubscription(sourceObj, eventName, handler, subscriber, options) {
    var unsubscribe;
    if (isEventTarget(sourceObj)) {
        var source_1 = sourceObj;
        sourceObj.addEventListener(eventName, handler, options);
        unsubscribe = function() {
            return source_1.removeEventListener(eventName, handler, options);
        };
    } else if (isJQueryStyleEventEmitter(sourceObj)) {
        var source_2 = sourceObj;
        sourceObj.on(eventName, handler);
        unsubscribe = function() {
            return source_2.off(eventName, handler);
        };
    } else if (isNodeStyleEventEmitter(sourceObj)) {
        var source_3 = sourceObj;
        sourceObj.addListener(eventName, handler);
        unsubscribe = function() {
            return source_3.removeListener(eventName, handler);
        };
    } else if (sourceObj && sourceObj.length) for(var i = 0, len = sourceObj.length; i < len; i++)setupSubscription(sourceObj[i], eventName, handler, subscriber, options);
    else throw new TypeError("Invalid event target");
    subscriber.add(unsubscribe);
}
function isNodeStyleEventEmitter(sourceObj) {
    return sourceObj && typeof sourceObj.addListener === "function" && typeof sourceObj.removeListener === "function";
}
function isJQueryStyleEventEmitter(sourceObj) {
    return sourceObj && typeof sourceObj.on === "function" && typeof sourceObj.off === "function";
}
function isEventTarget(sourceObj) {
    return sourceObj && typeof sourceObj.addEventListener === "function" && typeof sourceObj.removeEventListener === "function";
}

},{"../Observable":"9oc0x","../util/isArray":"2HaTi","../util/isFunction":"atYNr","../operators/map":"cvzfg","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"fxxhB":[function(require,module,exports) {
/** PURE_IMPORTS_START _Observable,_util_isArray,_util_isFunction,_operators_map PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "fromEventPattern", ()=>fromEventPattern);
var _observable = require("../Observable");
var _isArray = require("../util/isArray");
var _isFunction = require("../util/isFunction");
var _map = require("../operators/map");
function fromEventPattern(addHandler, removeHandler, resultSelector) {
    if (resultSelector) return fromEventPattern(addHandler, removeHandler).pipe((0, _map.map)(function(args) {
        return (0, _isArray.isArray)(args) ? resultSelector.apply(void 0, args) : resultSelector(args);
    }));
    return new (0, _observable.Observable)(function(subscriber) {
        var handler = function() {
            var e = [];
            for(var _i = 0; _i < arguments.length; _i++)e[_i] = arguments[_i];
            return subscriber.next(e.length === 1 ? e[0] : e);
        };
        var retValue;
        try {
            retValue = addHandler(handler);
        } catch (err) {
            subscriber.error(err);
            return undefined;
        }
        if (!(0, _isFunction.isFunction)(removeHandler)) return undefined;
        return function() {
            return removeHandler(handler, retValue);
        };
    });
}

},{"../Observable":"9oc0x","../util/isArray":"2HaTi","../util/isFunction":"atYNr","../operators/map":"cvzfg","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"fBVaJ":[function(require,module,exports) {
/** PURE_IMPORTS_START _Observable,_util_identity,_util_isScheduler PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "generate", ()=>generate);
var _observable = require("../Observable");
var _identity = require("../util/identity");
var _isScheduler = require("../util/isScheduler");
function generate(initialStateOrOptions, condition, iterate, resultSelectorOrObservable, scheduler) {
    var resultSelector;
    var initialState;
    if (arguments.length == 1) {
        var options = initialStateOrOptions;
        initialState = options.initialState;
        condition = options.condition;
        iterate = options.iterate;
        resultSelector = options.resultSelector || (0, _identity.identity);
        scheduler = options.scheduler;
    } else if (resultSelectorOrObservable === undefined || (0, _isScheduler.isScheduler)(resultSelectorOrObservable)) {
        initialState = initialStateOrOptions;
        resultSelector = (0, _identity.identity);
        scheduler = resultSelectorOrObservable;
    } else {
        initialState = initialStateOrOptions;
        resultSelector = resultSelectorOrObservable;
    }
    return new (0, _observable.Observable)(function(subscriber) {
        var state = initialState;
        if (scheduler) return scheduler.schedule(dispatch, 0, {
            subscriber: subscriber,
            iterate: iterate,
            condition: condition,
            resultSelector: resultSelector,
            state: state
        });
        do {
            if (condition) {
                var conditionResult = void 0;
                try {
                    conditionResult = condition(state);
                } catch (err) {
                    subscriber.error(err);
                    return undefined;
                }
                if (!conditionResult) {
                    subscriber.complete();
                    break;
                }
            }
            var value = void 0;
            try {
                value = resultSelector(state);
            } catch (err) {
                subscriber.error(err);
                return undefined;
            }
            subscriber.next(value);
            if (subscriber.closed) break;
            try {
                state = iterate(state);
            } catch (err) {
                subscriber.error(err);
                return undefined;
            }
        }while (true);
        return undefined;
    });
}
function dispatch(state) {
    var subscriber = state.subscriber, condition = state.condition;
    if (subscriber.closed) return undefined;
    if (state.needIterate) try {
        state.state = state.iterate(state.state);
    } catch (err) {
        subscriber.error(err);
        return undefined;
    }
    else state.needIterate = true;
    if (condition) {
        var conditionResult = void 0;
        try {
            conditionResult = condition(state.state);
        } catch (err) {
            subscriber.error(err);
            return undefined;
        }
        if (!conditionResult) {
            subscriber.complete();
            return undefined;
        }
        if (subscriber.closed) return undefined;
    }
    var value;
    try {
        value = state.resultSelector(state.state);
    } catch (err) {
        subscriber.error(err);
        return undefined;
    }
    if (subscriber.closed) return undefined;
    subscriber.next(value);
    if (subscriber.closed) return undefined;
    return this.schedule(state);
}

},{"../Observable":"9oc0x","../util/identity":"kDT9y","../util/isScheduler":"4iYg4","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"17pPY":[function(require,module,exports) {
/** PURE_IMPORTS_START _defer,_empty PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "iif", ()=>iif);
var _defer = require("./defer");
var _empty = require("./empty");
function iif(condition, trueResult, falseResult) {
    if (trueResult === void 0) trueResult = (0, _empty.EMPTY);
    if (falseResult === void 0) falseResult = (0, _empty.EMPTY);
    return (0, _defer.defer)(function() {
        return condition() ? trueResult : falseResult;
    });
}

},{"./defer":"1uvAg","./empty":"J4JDz","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"fMFuc":[function(require,module,exports) {
/** PURE_IMPORTS_START _Observable,_scheduler_async,_util_isNumeric PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "interval", ()=>interval);
var _observable = require("../Observable");
var _async = require("../scheduler/async");
var _isNumeric = require("../util/isNumeric");
function interval(period, scheduler) {
    if (period === void 0) period = 0;
    if (scheduler === void 0) scheduler = (0, _async.async);
    if (!(0, _isNumeric.isNumeric)(period) || period < 0) period = 0;
    if (!scheduler || typeof scheduler.schedule !== "function") scheduler = (0, _async.async);
    return new (0, _observable.Observable)(function(subscriber) {
        subscriber.add(scheduler.schedule(dispatch, period, {
            subscriber: subscriber,
            counter: 0,
            period: period
        }));
        return subscriber;
    });
}
function dispatch(state) {
    var subscriber = state.subscriber, counter = state.counter, period = state.period;
    subscriber.next(counter);
    this.schedule({
        subscriber: subscriber,
        counter: counter + 1,
        period: period
    }, period);
}

},{"../Observable":"9oc0x","../scheduler/async":"l1cmn","../util/isNumeric":"i95aV","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"i95aV":[function(require,module,exports) {
/** PURE_IMPORTS_START _isArray PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isNumeric", ()=>isNumeric);
var _isArray = require("./isArray");
function isNumeric(val) {
    return !(0, _isArray.isArray)(val) && val - parseFloat(val) + 1 >= 0;
}

},{"./isArray":"2HaTi","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"38GKY":[function(require,module,exports) {
/** PURE_IMPORTS_START _Observable,_util_isScheduler,_operators_mergeAll,_fromArray PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "merge", ()=>merge);
var _observable = require("../Observable");
var _isScheduler = require("../util/isScheduler");
var _mergeAll = require("../operators/mergeAll");
var _fromArray = require("./fromArray");
function merge() {
    var observables = [];
    for(var _i = 0; _i < arguments.length; _i++)observables[_i] = arguments[_i];
    var concurrent = Number.POSITIVE_INFINITY;
    var scheduler = null;
    var last = observables[observables.length - 1];
    if ((0, _isScheduler.isScheduler)(last)) {
        scheduler = observables.pop();
        if (observables.length > 1 && typeof observables[observables.length - 1] === "number") concurrent = observables.pop();
    } else if (typeof last === "number") concurrent = observables.pop();
    if (scheduler === null && observables.length === 1 && observables[0] instanceof (0, _observable.Observable)) return observables[0];
    return (0, _mergeAll.mergeAll)(concurrent)((0, _fromArray.fromArray)(observables, scheduler));
}

},{"../Observable":"9oc0x","../util/isScheduler":"4iYg4","../operators/mergeAll":"jXE8c","./fromArray":"b1aUF","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"3FrL8":[function(require,module,exports) {
/** PURE_IMPORTS_START _Observable,_util_noop PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "NEVER", ()=>NEVER);
parcelHelpers.export(exports, "never", ()=>never);
var _observable = require("../Observable");
var _noop = require("../util/noop");
var NEVER = /*@__PURE__*/ new (0, _observable.Observable)((0, _noop.noop));
function never() {
    return NEVER;
}

},{"../Observable":"9oc0x","../util/noop":"4s4qZ","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"hm3A5":[function(require,module,exports) {
/** PURE_IMPORTS_START _Observable,_from,_util_isArray,_empty PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "onErrorResumeNext", ()=>onErrorResumeNext);
var _observable = require("../Observable");
var _from = require("./from");
var _isArray = require("../util/isArray");
var _empty = require("./empty");
function onErrorResumeNext() {
    var sources = [];
    for(var _i = 0; _i < arguments.length; _i++)sources[_i] = arguments[_i];
    if (sources.length === 0) return 0, _empty.EMPTY;
    var first = sources[0], remainder = sources.slice(1);
    if (sources.length === 1 && (0, _isArray.isArray)(first)) return onErrorResumeNext.apply(void 0, first);
    return new (0, _observable.Observable)(function(subscriber) {
        var subNext = function() {
            return subscriber.add(onErrorResumeNext.apply(void 0, remainder).subscribe(subscriber));
        };
        return (0, _from.from)(first).subscribe({
            next: function(value) {
                subscriber.next(value);
            },
            error: subNext,
            complete: subNext
        });
    });
}

},{"../Observable":"9oc0x","./from":"6aqs0","../util/isArray":"2HaTi","./empty":"J4JDz","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"iTEBj":[function(require,module,exports) {
/** PURE_IMPORTS_START _Observable,_Subscription PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "pairs", ()=>pairs);
parcelHelpers.export(exports, "dispatch", ()=>dispatch);
var _observable = require("../Observable");
var _subscription = require("../Subscription");
function pairs(obj, scheduler) {
    if (!scheduler) return new (0, _observable.Observable)(function(subscriber) {
        var keys = Object.keys(obj);
        for(var i = 0; i < keys.length && !subscriber.closed; i++){
            var key = keys[i];
            if (obj.hasOwnProperty(key)) subscriber.next([
                key,
                obj[key]
            ]);
        }
        subscriber.complete();
    });
    else return new (0, _observable.Observable)(function(subscriber) {
        var keys = Object.keys(obj);
        var subscription = new (0, _subscription.Subscription)();
        subscription.add(scheduler.schedule(dispatch, 0, {
            keys: keys,
            index: 0,
            subscriber: subscriber,
            subscription: subscription,
            obj: obj
        }));
        return subscription;
    });
}
function dispatch(state) {
    var keys = state.keys, index = state.index, subscriber = state.subscriber, subscription = state.subscription, obj = state.obj;
    if (!subscriber.closed) {
        if (index < keys.length) {
            var key = keys[index];
            subscriber.next([
                key,
                obj[key]
            ]);
            subscription.add(this.schedule({
                keys: keys,
                index: index + 1,
                subscriber: subscriber,
                subscription: subscription,
                obj: obj
            }));
        } else subscriber.complete();
    }
}

},{"../Observable":"9oc0x","../Subscription":"ahthJ","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8Djd6":[function(require,module,exports) {
/** PURE_IMPORTS_START _util_not,_util_subscribeTo,_operators_filter,_Observable PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "partition", ()=>partition);
var _not = require("../util/not");
var _subscribeTo = require("../util/subscribeTo");
var _filter = require("../operators/filter");
var _observable = require("../Observable");
function partition(source, predicate, thisArg) {
    return [
        (0, _filter.filter)(predicate, thisArg)(new (0, _observable.Observable)((0, _subscribeTo.subscribeTo)(source))),
        (0, _filter.filter)((0, _not.not)(predicate, thisArg))(new (0, _observable.Observable)((0, _subscribeTo.subscribeTo)(source)))
    ];
}

},{"../util/not":"6oUZX","../util/subscribeTo":"fU69c","../operators/filter":"1uwXV","../Observable":"9oc0x","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"6oUZX":[function(require,module,exports) {
/** PURE_IMPORTS_START  PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "not", ()=>not);
function not(pred, thisArg) {
    function notPred() {
        return !notPred.pred.apply(notPred.thisArg, arguments);
    }
    notPred.pred = pred;
    notPred.thisArg = thisArg;
    return notPred;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"1uwXV":[function(require,module,exports) {
/** PURE_IMPORTS_START tslib,_Subscriber PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "filter", ()=>filter);
var _tslib = require("tslib");
var _subscriber = require("../Subscriber");
function filter(predicate, thisArg) {
    return function filterOperatorFunction(source) {
        return source.lift(new FilterOperator(predicate, thisArg));
    };
}
var FilterOperator = /*@__PURE__*/ function() {
    function FilterOperator(predicate, thisArg) {
        this.predicate = predicate;
        this.thisArg = thisArg;
    }
    FilterOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new FilterSubscriber(subscriber, this.predicate, this.thisArg));
    };
    return FilterOperator;
}();
var FilterSubscriber = /*@__PURE__*/ function(_super) {
    _tslib.__extends(FilterSubscriber, _super);
    function FilterSubscriber(destination, predicate, thisArg) {
        var _this = _super.call(this, destination) || this;
        _this.predicate = predicate;
        _this.thisArg = thisArg;
        _this.count = 0;
        return _this;
    }
    FilterSubscriber.prototype._next = function(value) {
        var result;
        try {
            result = this.predicate.call(this.thisArg, value, this.count++);
        } catch (err) {
            this.destination.error(err);
            return;
        }
        if (result) this.destination.next(value);
    };
    return FilterSubscriber;
}((0, _subscriber.Subscriber));

},{"tslib":"kcqwq","../Subscriber":"jGx8F","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"6YL9k":[function(require,module,exports) {
/** PURE_IMPORTS_START tslib,_util_isArray,_fromArray,_OuterSubscriber,_util_subscribeToResult PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "race", ()=>race);
parcelHelpers.export(exports, "RaceOperator", ()=>RaceOperator);
parcelHelpers.export(exports, "RaceSubscriber", ()=>RaceSubscriber);
var _tslib = require("tslib");
var _isArray = require("../util/isArray");
var _fromArray = require("./fromArray");
var _outerSubscriber = require("../OuterSubscriber");
var _subscribeToResult = require("../util/subscribeToResult");
function race() {
    var observables = [];
    for(var _i = 0; _i < arguments.length; _i++)observables[_i] = arguments[_i];
    if (observables.length === 1) {
        if ((0, _isArray.isArray)(observables[0])) observables = observables[0];
        else return observables[0];
    }
    return (0, _fromArray.fromArray)(observables, undefined).lift(new RaceOperator());
}
var RaceOperator = /*@__PURE__*/ function() {
    function RaceOperator() {}
    RaceOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new RaceSubscriber(subscriber));
    };
    return RaceOperator;
}();
var RaceSubscriber = /*@__PURE__*/ function(_super) {
    _tslib.__extends(RaceSubscriber, _super);
    function RaceSubscriber(destination) {
        var _this = _super.call(this, destination) || this;
        _this.hasFirst = false;
        _this.observables = [];
        _this.subscriptions = [];
        return _this;
    }
    RaceSubscriber.prototype._next = function(observable) {
        this.observables.push(observable);
    };
    RaceSubscriber.prototype._complete = function() {
        var observables = this.observables;
        var len = observables.length;
        if (len === 0) this.destination.complete();
        else {
            for(var i = 0; i < len && !this.hasFirst; i++){
                var observable = observables[i];
                var subscription = (0, _subscribeToResult.subscribeToResult)(this, observable, undefined, i);
                if (this.subscriptions) this.subscriptions.push(subscription);
                this.add(subscription);
            }
            this.observables = null;
        }
    };
    RaceSubscriber.prototype.notifyNext = function(_outerValue, innerValue, outerIndex) {
        if (!this.hasFirst) {
            this.hasFirst = true;
            for(var i = 0; i < this.subscriptions.length; i++)if (i !== outerIndex) {
                var subscription = this.subscriptions[i];
                subscription.unsubscribe();
                this.remove(subscription);
            }
            this.subscriptions = null;
        }
        this.destination.next(innerValue);
    };
    return RaceSubscriber;
}((0, _outerSubscriber.OuterSubscriber));

},{"tslib":"kcqwq","../util/isArray":"2HaTi","./fromArray":"b1aUF","../OuterSubscriber":"fECUl","../util/subscribeToResult":"4ctqX","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"cuk43":[function(require,module,exports) {
/** PURE_IMPORTS_START _Observable PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "range", ()=>range);
parcelHelpers.export(exports, "dispatch", ()=>dispatch);
var _observable = require("../Observable");
function range(start, count, scheduler) {
    if (start === void 0) start = 0;
    return new (0, _observable.Observable)(function(subscriber) {
        if (count === undefined) {
            count = start;
            start = 0;
        }
        var index = 0;
        var current = start;
        if (scheduler) return scheduler.schedule(dispatch, 0, {
            index: index,
            count: count,
            start: start,
            subscriber: subscriber
        });
        else do {
            if (index++ >= count) {
                subscriber.complete();
                break;
            }
            subscriber.next(current++);
            if (subscriber.closed) break;
        }while (true);
        return undefined;
    });
}
function dispatch(state) {
    var start = state.start, index = state.index, count = state.count, subscriber = state.subscriber;
    if (index >= count) {
        subscriber.complete();
        return;
    }
    subscriber.next(start);
    if (subscriber.closed) return;
    state.index = index + 1;
    state.start = start + 1;
    this.schedule(state);
}

},{"../Observable":"9oc0x","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"jufOf":[function(require,module,exports) {
/** PURE_IMPORTS_START _Observable,_scheduler_async,_util_isNumeric,_util_isScheduler PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "timer", ()=>timer);
var _observable = require("../Observable");
var _async = require("../scheduler/async");
var _isNumeric = require("../util/isNumeric");
var _isScheduler = require("../util/isScheduler");
function timer(dueTime, periodOrScheduler, scheduler) {
    if (dueTime === void 0) dueTime = 0;
    var period = -1;
    if ((0, _isNumeric.isNumeric)(periodOrScheduler)) period = Number(periodOrScheduler) < 1 && 1 || Number(periodOrScheduler);
    else if ((0, _isScheduler.isScheduler)(periodOrScheduler)) scheduler = periodOrScheduler;
    if (!(0, _isScheduler.isScheduler)(scheduler)) scheduler = (0, _async.async);
    return new (0, _observable.Observable)(function(subscriber) {
        var due = (0, _isNumeric.isNumeric)(dueTime) ? dueTime : +dueTime - scheduler.now();
        return scheduler.schedule(dispatch, due, {
            index: 0,
            period: period,
            subscriber: subscriber
        });
    });
}
function dispatch(state) {
    var index = state.index, period = state.period, subscriber = state.subscriber;
    subscriber.next(index);
    if (subscriber.closed) return;
    else if (period === -1) return subscriber.complete();
    state.index = index + 1;
    this.schedule(state, period);
}

},{"../Observable":"9oc0x","../scheduler/async":"l1cmn","../util/isNumeric":"i95aV","../util/isScheduler":"4iYg4","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"jpgyo":[function(require,module,exports) {
/** PURE_IMPORTS_START _Observable,_from,_empty PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "using", ()=>using);
var _observable = require("../Observable");
var _from = require("./from");
var _empty = require("./empty");
function using(resourceFactory, observableFactory) {
    return new (0, _observable.Observable)(function(subscriber) {
        var resource;
        try {
            resource = resourceFactory();
        } catch (err) {
            subscriber.error(err);
            return undefined;
        }
        var result;
        try {
            result = observableFactory(resource);
        } catch (err) {
            subscriber.error(err);
            return undefined;
        }
        var source = result ? (0, _from.from)(result) : (0, _empty.EMPTY);
        var subscription = source.subscribe(subscriber);
        return function() {
            subscription.unsubscribe();
            if (resource) resource.unsubscribe();
        };
    });
}

},{"../Observable":"9oc0x","./from":"6aqs0","./empty":"J4JDz","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"57TWv":[function(require,module,exports) {
/** PURE_IMPORTS_START tslib,_fromArray,_util_isArray,_Subscriber,_.._internal_symbol_iterator,_innerSubscribe PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "zip", ()=>zip);
parcelHelpers.export(exports, "ZipOperator", ()=>ZipOperator);
parcelHelpers.export(exports, "ZipSubscriber", ()=>ZipSubscriber);
var _tslib = require("tslib");
var _fromArray = require("./fromArray");
var _isArray = require("../util/isArray");
var _subscriber = require("../Subscriber");
var _iterator = require("../../internal/symbol/iterator");
var _innerSubscribe = require("../innerSubscribe");
function zip() {
    var observables = [];
    for(var _i = 0; _i < arguments.length; _i++)observables[_i] = arguments[_i];
    var resultSelector = observables[observables.length - 1];
    if (typeof resultSelector === "function") observables.pop();
    return (0, _fromArray.fromArray)(observables, undefined).lift(new ZipOperator(resultSelector));
}
var ZipOperator = /*@__PURE__*/ function() {
    function ZipOperator(resultSelector) {
        this.resultSelector = resultSelector;
    }
    ZipOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new ZipSubscriber(subscriber, this.resultSelector));
    };
    return ZipOperator;
}();
var ZipSubscriber = /*@__PURE__*/ function(_super) {
    _tslib.__extends(ZipSubscriber, _super);
    function ZipSubscriber(destination, resultSelector, values) {
        if (values === void 0) values = Object.create(null);
        var _this = _super.call(this, destination) || this;
        _this.resultSelector = resultSelector;
        _this.iterators = [];
        _this.active = 0;
        _this.resultSelector = typeof resultSelector === "function" ? resultSelector : undefined;
        return _this;
    }
    ZipSubscriber.prototype._next = function(value) {
        var iterators = this.iterators;
        if ((0, _isArray.isArray)(value)) iterators.push(new StaticArrayIterator(value));
        else if (typeof value[0, _iterator.iterator] === "function") iterators.push(new StaticIterator(value[0, _iterator.iterator]()));
        else iterators.push(new ZipBufferIterator(this.destination, this, value));
    };
    ZipSubscriber.prototype._complete = function() {
        var iterators = this.iterators;
        var len = iterators.length;
        this.unsubscribe();
        if (len === 0) {
            this.destination.complete();
            return;
        }
        this.active = len;
        for(var i = 0; i < len; i++){
            var iterator = iterators[i];
            if (iterator.stillUnsubscribed) {
                var destination = this.destination;
                destination.add(iterator.subscribe());
            } else this.active--;
        }
    };
    ZipSubscriber.prototype.notifyInactive = function() {
        this.active--;
        if (this.active === 0) this.destination.complete();
    };
    ZipSubscriber.prototype.checkIterators = function() {
        var iterators = this.iterators;
        var len = iterators.length;
        var destination = this.destination;
        for(var i = 0; i < len; i++){
            var iterator = iterators[i];
            if (typeof iterator.hasValue === "function" && !iterator.hasValue()) return;
        }
        var shouldComplete = false;
        var args = [];
        for(var i = 0; i < len; i++){
            var iterator = iterators[i];
            var result = iterator.next();
            if (iterator.hasCompleted()) shouldComplete = true;
            if (result.done) {
                destination.complete();
                return;
            }
            args.push(result.value);
        }
        if (this.resultSelector) this._tryresultSelector(args);
        else destination.next(args);
        if (shouldComplete) destination.complete();
    };
    ZipSubscriber.prototype._tryresultSelector = function(args) {
        var result;
        try {
            result = this.resultSelector.apply(this, args);
        } catch (err) {
            this.destination.error(err);
            return;
        }
        this.destination.next(result);
    };
    return ZipSubscriber;
}((0, _subscriber.Subscriber));
var StaticIterator = /*@__PURE__*/ function() {
    function StaticIterator(iterator) {
        this.iterator = iterator;
        this.nextResult = iterator.next();
    }
    StaticIterator.prototype.hasValue = function() {
        return true;
    };
    StaticIterator.prototype.next = function() {
        var result = this.nextResult;
        this.nextResult = this.iterator.next();
        return result;
    };
    StaticIterator.prototype.hasCompleted = function() {
        var nextResult = this.nextResult;
        return Boolean(nextResult && nextResult.done);
    };
    return StaticIterator;
}();
var StaticArrayIterator = /*@__PURE__*/ function() {
    function StaticArrayIterator(array) {
        this.array = array;
        this.index = 0;
        this.length = 0;
        this.length = array.length;
    }
    StaticArrayIterator.prototype[0, _iterator.iterator] = function() {
        return this;
    };
    StaticArrayIterator.prototype.next = function(value) {
        var i = this.index++;
        var array = this.array;
        return i < this.length ? {
            value: array[i],
            done: false
        } : {
            value: null,
            done: true
        };
    };
    StaticArrayIterator.prototype.hasValue = function() {
        return this.array.length > this.index;
    };
    StaticArrayIterator.prototype.hasCompleted = function() {
        return this.array.length === this.index;
    };
    return StaticArrayIterator;
}();
var ZipBufferIterator = /*@__PURE__*/ function(_super) {
    _tslib.__extends(ZipBufferIterator, _super);
    function ZipBufferIterator(destination, parent, observable) {
        var _this = _super.call(this, destination) || this;
        _this.parent = parent;
        _this.observable = observable;
        _this.stillUnsubscribed = true;
        _this.buffer = [];
        _this.isComplete = false;
        return _this;
    }
    ZipBufferIterator.prototype[0, _iterator.iterator] = function() {
        return this;
    };
    ZipBufferIterator.prototype.next = function() {
        var buffer = this.buffer;
        if (buffer.length === 0 && this.isComplete) return {
            value: null,
            done: true
        };
        else return {
            value: buffer.shift(),
            done: false
        };
    };
    ZipBufferIterator.prototype.hasValue = function() {
        return this.buffer.length > 0;
    };
    ZipBufferIterator.prototype.hasCompleted = function() {
        return this.buffer.length === 0 && this.isComplete;
    };
    ZipBufferIterator.prototype.notifyComplete = function() {
        if (this.buffer.length > 0) {
            this.isComplete = true;
            this.parent.notifyInactive();
        } else this.destination.complete();
    };
    ZipBufferIterator.prototype.notifyNext = function(innerValue) {
        this.buffer.push(innerValue);
        this.parent.checkIterators();
    };
    ZipBufferIterator.prototype.subscribe = function() {
        return (0, _innerSubscribe.innerSubscribe)(this.observable, new (0, _innerSubscribe.SimpleInnerSubscriber)(this));
    };
    return ZipBufferIterator;
}((0, _innerSubscribe.SimpleOuterSubscriber));

},{"tslib":"kcqwq","./fromArray":"b1aUF","../util/isArray":"2HaTi","../Subscriber":"jGx8F","../../internal/symbol/iterator":"jShcT","../innerSubscribe":"73frt","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"ggrIi":[function(require,module,exports) {
/** PURE_IMPORTS_START  PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "audit", ()=>(0, _audit.audit));
parcelHelpers.export(exports, "auditTime", ()=>(0, _auditTime.auditTime));
parcelHelpers.export(exports, "buffer", ()=>(0, _buffer.buffer));
parcelHelpers.export(exports, "bufferCount", ()=>(0, _bufferCount.bufferCount));
parcelHelpers.export(exports, "bufferTime", ()=>(0, _bufferTime.bufferTime));
parcelHelpers.export(exports, "bufferToggle", ()=>(0, _bufferToggle.bufferToggle));
parcelHelpers.export(exports, "bufferWhen", ()=>(0, _bufferWhen.bufferWhen));
parcelHelpers.export(exports, "catchError", ()=>(0, _catchError.catchError));
parcelHelpers.export(exports, "combineAll", ()=>(0, _combineAll.combineAll));
parcelHelpers.export(exports, "combineLatest", ()=>(0, _combineLatest.combineLatest));
parcelHelpers.export(exports, "concat", ()=>(0, _concat.concat));
parcelHelpers.export(exports, "concatAll", ()=>(0, _concatAll.concatAll));
parcelHelpers.export(exports, "concatMap", ()=>(0, _concatMap.concatMap));
parcelHelpers.export(exports, "concatMapTo", ()=>(0, _concatMapTo.concatMapTo));
parcelHelpers.export(exports, "count", ()=>(0, _count.count));
parcelHelpers.export(exports, "debounce", ()=>(0, _debounce.debounce));
parcelHelpers.export(exports, "debounceTime", ()=>(0, _debounceTime.debounceTime));
parcelHelpers.export(exports, "defaultIfEmpty", ()=>(0, _defaultIfEmpty.defaultIfEmpty));
parcelHelpers.export(exports, "delay", ()=>(0, _delay.delay));
parcelHelpers.export(exports, "delayWhen", ()=>(0, _delayWhen.delayWhen));
parcelHelpers.export(exports, "dematerialize", ()=>(0, _dematerialize.dematerialize));
parcelHelpers.export(exports, "distinct", ()=>(0, _distinct.distinct));
parcelHelpers.export(exports, "distinctUntilChanged", ()=>(0, _distinctUntilChanged.distinctUntilChanged));
parcelHelpers.export(exports, "distinctUntilKeyChanged", ()=>(0, _distinctUntilKeyChanged.distinctUntilKeyChanged));
parcelHelpers.export(exports, "elementAt", ()=>(0, _elementAt.elementAt));
parcelHelpers.export(exports, "endWith", ()=>(0, _endWith.endWith));
parcelHelpers.export(exports, "every", ()=>(0, _every.every));
parcelHelpers.export(exports, "exhaust", ()=>(0, _exhaust.exhaust));
parcelHelpers.export(exports, "exhaustMap", ()=>(0, _exhaustMap.exhaustMap));
parcelHelpers.export(exports, "expand", ()=>(0, _expand.expand));
parcelHelpers.export(exports, "filter", ()=>(0, _filter.filter));
parcelHelpers.export(exports, "finalize", ()=>(0, _finalize.finalize));
parcelHelpers.export(exports, "find", ()=>(0, _find.find));
parcelHelpers.export(exports, "findIndex", ()=>(0, _findIndex.findIndex));
parcelHelpers.export(exports, "first", ()=>(0, _first.first));
parcelHelpers.export(exports, "groupBy", ()=>(0, _groupBy.groupBy));
parcelHelpers.export(exports, "ignoreElements", ()=>(0, _ignoreElements.ignoreElements));
parcelHelpers.export(exports, "isEmpty", ()=>(0, _isEmpty.isEmpty));
parcelHelpers.export(exports, "last", ()=>(0, _last.last));
parcelHelpers.export(exports, "map", ()=>(0, _map.map));
parcelHelpers.export(exports, "mapTo", ()=>(0, _mapTo.mapTo));
parcelHelpers.export(exports, "materialize", ()=>(0, _materialize.materialize));
parcelHelpers.export(exports, "max", ()=>(0, _max.max));
parcelHelpers.export(exports, "merge", ()=>(0, _merge.merge));
parcelHelpers.export(exports, "mergeAll", ()=>(0, _mergeAll.mergeAll));
parcelHelpers.export(exports, "mergeMap", ()=>(0, _mergeMap.mergeMap));
parcelHelpers.export(exports, "flatMap", ()=>(0, _mergeMap.flatMap));
parcelHelpers.export(exports, "mergeMapTo", ()=>(0, _mergeMapTo.mergeMapTo));
parcelHelpers.export(exports, "mergeScan", ()=>(0, _mergeScan.mergeScan));
parcelHelpers.export(exports, "min", ()=>(0, _min.min));
parcelHelpers.export(exports, "multicast", ()=>(0, _multicast.multicast));
parcelHelpers.export(exports, "observeOn", ()=>(0, _observeOn.observeOn));
parcelHelpers.export(exports, "onErrorResumeNext", ()=>(0, _onErrorResumeNext.onErrorResumeNext));
parcelHelpers.export(exports, "pairwise", ()=>(0, _pairwise.pairwise));
parcelHelpers.export(exports, "partition", ()=>(0, _partition.partition));
parcelHelpers.export(exports, "pluck", ()=>(0, _pluck.pluck));
parcelHelpers.export(exports, "publish", ()=>(0, _publish.publish));
parcelHelpers.export(exports, "publishBehavior", ()=>(0, _publishBehavior.publishBehavior));
parcelHelpers.export(exports, "publishLast", ()=>(0, _publishLast.publishLast));
parcelHelpers.export(exports, "publishReplay", ()=>(0, _publishReplay.publishReplay));
parcelHelpers.export(exports, "race", ()=>(0, _race.race));
parcelHelpers.export(exports, "reduce", ()=>(0, _reduce.reduce));
parcelHelpers.export(exports, "repeat", ()=>(0, _repeat.repeat));
parcelHelpers.export(exports, "repeatWhen", ()=>(0, _repeatWhen.repeatWhen));
parcelHelpers.export(exports, "retry", ()=>(0, _retry.retry));
parcelHelpers.export(exports, "retryWhen", ()=>(0, _retryWhen.retryWhen));
parcelHelpers.export(exports, "refCount", ()=>(0, _refCount.refCount));
parcelHelpers.export(exports, "sample", ()=>(0, _sample.sample));
parcelHelpers.export(exports, "sampleTime", ()=>(0, _sampleTime.sampleTime));
parcelHelpers.export(exports, "scan", ()=>(0, _scan.scan));
parcelHelpers.export(exports, "sequenceEqual", ()=>(0, _sequenceEqual.sequenceEqual));
parcelHelpers.export(exports, "share", ()=>(0, _share.share));
parcelHelpers.export(exports, "shareReplay", ()=>(0, _shareReplay.shareReplay));
parcelHelpers.export(exports, "single", ()=>(0, _single.single));
parcelHelpers.export(exports, "skip", ()=>(0, _skip.skip));
parcelHelpers.export(exports, "skipLast", ()=>(0, _skipLast.skipLast));
parcelHelpers.export(exports, "skipUntil", ()=>(0, _skipUntil.skipUntil));
parcelHelpers.export(exports, "skipWhile", ()=>(0, _skipWhile.skipWhile));
parcelHelpers.export(exports, "startWith", ()=>(0, _startWith.startWith));
parcelHelpers.export(exports, "subscribeOn", ()=>(0, _subscribeOn.subscribeOn));
parcelHelpers.export(exports, "switchAll", ()=>(0, _switchAll.switchAll));
parcelHelpers.export(exports, "switchMap", ()=>(0, _switchMap.switchMap));
parcelHelpers.export(exports, "switchMapTo", ()=>(0, _switchMapTo.switchMapTo));
parcelHelpers.export(exports, "take", ()=>(0, _take.take));
parcelHelpers.export(exports, "takeLast", ()=>(0, _takeLast.takeLast));
parcelHelpers.export(exports, "takeUntil", ()=>(0, _takeUntil.takeUntil));
parcelHelpers.export(exports, "takeWhile", ()=>(0, _takeWhile.takeWhile));
parcelHelpers.export(exports, "tap", ()=>(0, _tap.tap));
parcelHelpers.export(exports, "throttle", ()=>(0, _throttle.throttle));
parcelHelpers.export(exports, "throttleTime", ()=>(0, _throttleTime.throttleTime));
parcelHelpers.export(exports, "throwIfEmpty", ()=>(0, _throwIfEmpty.throwIfEmpty));
parcelHelpers.export(exports, "timeInterval", ()=>(0, _timeInterval.timeInterval));
parcelHelpers.export(exports, "timeout", ()=>(0, _timeout.timeout));
parcelHelpers.export(exports, "timeoutWith", ()=>(0, _timeoutWith.timeoutWith));
parcelHelpers.export(exports, "timestamp", ()=>(0, _timestamp.timestamp));
parcelHelpers.export(exports, "toArray", ()=>(0, _toArray.toArray));
parcelHelpers.export(exports, "window", ()=>(0, _window.window));
parcelHelpers.export(exports, "windowCount", ()=>(0, _windowCount.windowCount));
parcelHelpers.export(exports, "windowTime", ()=>(0, _windowTime.windowTime));
parcelHelpers.export(exports, "windowToggle", ()=>(0, _windowToggle.windowToggle));
parcelHelpers.export(exports, "windowWhen", ()=>(0, _windowWhen.windowWhen));
parcelHelpers.export(exports, "withLatestFrom", ()=>(0, _withLatestFrom.withLatestFrom));
parcelHelpers.export(exports, "zip", ()=>(0, _zip.zip));
parcelHelpers.export(exports, "zipAll", ()=>(0, _zipAll.zipAll));
var _audit = require("../internal/operators/audit");
var _auditTime = require("../internal/operators/auditTime");
var _buffer = require("../internal/operators/buffer");
var _bufferCount = require("../internal/operators/bufferCount");
var _bufferTime = require("../internal/operators/bufferTime");
var _bufferToggle = require("../internal/operators/bufferToggle");
var _bufferWhen = require("../internal/operators/bufferWhen");
var _catchError = require("../internal/operators/catchError");
var _combineAll = require("../internal/operators/combineAll");
var _combineLatest = require("../internal/operators/combineLatest");
var _concat = require("../internal/operators/concat");
var _concatAll = require("../internal/operators/concatAll");
var _concatMap = require("../internal/operators/concatMap");
var _concatMapTo = require("../internal/operators/concatMapTo");
var _count = require("../internal/operators/count");
var _debounce = require("../internal/operators/debounce");
var _debounceTime = require("../internal/operators/debounceTime");
var _defaultIfEmpty = require("../internal/operators/defaultIfEmpty");
var _delay = require("../internal/operators/delay");
var _delayWhen = require("../internal/operators/delayWhen");
var _dematerialize = require("../internal/operators/dematerialize");
var _distinct = require("../internal/operators/distinct");
var _distinctUntilChanged = require("../internal/operators/distinctUntilChanged");
var _distinctUntilKeyChanged = require("../internal/operators/distinctUntilKeyChanged");
var _elementAt = require("../internal/operators/elementAt");
var _endWith = require("../internal/operators/endWith");
var _every = require("../internal/operators/every");
var _exhaust = require("../internal/operators/exhaust");
var _exhaustMap = require("../internal/operators/exhaustMap");
var _expand = require("../internal/operators/expand");
var _filter = require("../internal/operators/filter");
var _finalize = require("../internal/operators/finalize");
var _find = require("../internal/operators/find");
var _findIndex = require("../internal/operators/findIndex");
var _first = require("../internal/operators/first");
var _groupBy = require("../internal/operators/groupBy");
var _ignoreElements = require("../internal/operators/ignoreElements");
var _isEmpty = require("../internal/operators/isEmpty");
var _last = require("../internal/operators/last");
var _map = require("../internal/operators/map");
var _mapTo = require("../internal/operators/mapTo");
var _materialize = require("../internal/operators/materialize");
var _max = require("../internal/operators/max");
var _merge = require("../internal/operators/merge");
var _mergeAll = require("../internal/operators/mergeAll");
var _mergeMap = require("../internal/operators/mergeMap");
var _mergeMapTo = require("../internal/operators/mergeMapTo");
var _mergeScan = require("../internal/operators/mergeScan");
var _min = require("../internal/operators/min");
var _multicast = require("../internal/operators/multicast");
var _observeOn = require("../internal/operators/observeOn");
var _onErrorResumeNext = require("../internal/operators/onErrorResumeNext");
var _pairwise = require("../internal/operators/pairwise");
var _partition = require("../internal/operators/partition");
var _pluck = require("../internal/operators/pluck");
var _publish = require("../internal/operators/publish");
var _publishBehavior = require("../internal/operators/publishBehavior");
var _publishLast = require("../internal/operators/publishLast");
var _publishReplay = require("../internal/operators/publishReplay");
var _race = require("../internal/operators/race");
var _reduce = require("../internal/operators/reduce");
var _repeat = require("../internal/operators/repeat");
var _repeatWhen = require("../internal/operators/repeatWhen");
var _retry = require("../internal/operators/retry");
var _retryWhen = require("../internal/operators/retryWhen");
var _refCount = require("../internal/operators/refCount");
var _sample = require("../internal/operators/sample");
var _sampleTime = require("../internal/operators/sampleTime");
var _scan = require("../internal/operators/scan");
var _sequenceEqual = require("../internal/operators/sequenceEqual");
var _share = require("../internal/operators/share");
var _shareReplay = require("../internal/operators/shareReplay");
var _single = require("../internal/operators/single");
var _skip = require("../internal/operators/skip");
var _skipLast = require("../internal/operators/skipLast");
var _skipUntil = require("../internal/operators/skipUntil");
var _skipWhile = require("../internal/operators/skipWhile");
var _startWith = require("../internal/operators/startWith");
var _subscribeOn = require("../internal/operators/subscribeOn");
var _switchAll = require("../internal/operators/switchAll");
var _switchMap = require("../internal/operators/switchMap");
var _switchMapTo = require("../internal/operators/switchMapTo");
var _take = require("../internal/operators/take");
var _takeLast = require("../internal/operators/takeLast");
var _takeUntil = require("../internal/operators/takeUntil");
var _takeWhile = require("../internal/operators/takeWhile");
var _tap = require("../internal/operators/tap");
var _throttle = require("../internal/operators/throttle");
var _throttleTime = require("../internal/operators/throttleTime");
var _throwIfEmpty = require("../internal/operators/throwIfEmpty");
var _timeInterval = require("../internal/operators/timeInterval");
var _timeout = require("../internal/operators/timeout");
var _timeoutWith = require("../internal/operators/timeoutWith");
var _timestamp = require("../internal/operators/timestamp");
var _toArray = require("../internal/operators/toArray");
var _window = require("../internal/operators/window");
var _windowCount = require("../internal/operators/windowCount");
var _windowTime = require("../internal/operators/windowTime");
var _windowToggle = require("../internal/operators/windowToggle");
var _windowWhen = require("../internal/operators/windowWhen");
var _withLatestFrom = require("../internal/operators/withLatestFrom");
var _zip = require("../internal/operators/zip");
var _zipAll = require("../internal/operators/zipAll");

},{"../internal/operators/audit":"4qWW6","../internal/operators/auditTime":"8RvbG","../internal/operators/buffer":"2S6EL","../internal/operators/bufferCount":"gmiQw","../internal/operators/bufferTime":"7jBeD","../internal/operators/bufferToggle":"3I58S","../internal/operators/bufferWhen":"eAxGr","../internal/operators/catchError":"7rF1H","../internal/operators/combineAll":"3gD1U","../internal/operators/combineLatest":"3N35f","../internal/operators/concat":"8pRKh","../internal/operators/concatAll":"8bdTP","../internal/operators/concatMap":"4nwZ8","../internal/operators/concatMapTo":"dqNGp","../internal/operators/count":"2Fibo","../internal/operators/debounce":"6qDC7","../internal/operators/debounceTime":"c8BHO","../internal/operators/defaultIfEmpty":"1eMdN","../internal/operators/delay":"64BbM","../internal/operators/delayWhen":"lDbXG","../internal/operators/dematerialize":"1bYYn","../internal/operators/distinct":"gWe8h","../internal/operators/distinctUntilChanged":"98B5v","../internal/operators/distinctUntilKeyChanged":"hd3Vz","../internal/operators/elementAt":"92xaa","../internal/operators/endWith":"4VxEc","../internal/operators/every":"dXibX","../internal/operators/exhaust":"4Ehtr","../internal/operators/exhaustMap":"2Xdls","../internal/operators/expand":"3i3MM","../internal/operators/filter":"1uwXV","../internal/operators/finalize":"757w3","../internal/operators/find":"7WaV6","../internal/operators/findIndex":"9qcAF","../internal/operators/first":"eGELz","../internal/operators/groupBy":"g6z19","../internal/operators/ignoreElements":"ckr01","../internal/operators/isEmpty":"b6CBY","../internal/operators/last":"2oVKC","../internal/operators/map":"cvzfg","../internal/operators/mapTo":"39msm","../internal/operators/materialize":"aXm7q","../internal/operators/max":"9VIwB","../internal/operators/merge":"9GXnX","../internal/operators/mergeAll":"jXE8c","../internal/operators/mergeMap":"7NAZz","../internal/operators/mergeMapTo":"lm8sA","../internal/operators/mergeScan":"8odnE","../internal/operators/min":"eIMaq","../internal/operators/multicast":"GLY7l","../internal/operators/observeOn":"8iKY0","../internal/operators/onErrorResumeNext":"1lwYl","../internal/operators/pairwise":"hAUti","../internal/operators/partition":"51UVV","../internal/operators/pluck":"enRwh","../internal/operators/publish":"eqLc5","../internal/operators/publishBehavior":"aC28n","../internal/operators/publishLast":"aqjv1","../internal/operators/publishReplay":"2pe5R","../internal/operators/race":"3Gd59","../internal/operators/reduce":"8LzQg","../internal/operators/repeat":"7VXQV","../internal/operators/repeatWhen":"2wa5h","../internal/operators/retry":"jiZ39","../internal/operators/retryWhen":"4F6hS","../internal/operators/refCount":"ihxKV","../internal/operators/sample":"awQoL","../internal/operators/sampleTime":"10Tw1","../internal/operators/scan":"hX6nA","../internal/operators/sequenceEqual":"81se8","../internal/operators/share":"diIIU","../internal/operators/shareReplay":"1ysaZ","../internal/operators/single":"3kbFw","../internal/operators/skip":"6Y7P6","../internal/operators/skipLast":"dehzH","../internal/operators/skipUntil":"8Gc8j","../internal/operators/skipWhile":"brJq3","../internal/operators/startWith":"dBObJ","../internal/operators/subscribeOn":"33YTz","../internal/operators/switchAll":"kcfvT","../internal/operators/switchMap":"5lH3R","../internal/operators/switchMapTo":"b6eN6","../internal/operators/take":"jMzpW","../internal/operators/takeLast":"21udE","../internal/operators/takeUntil":"8NfQ5","../internal/operators/takeWhile":"dcbUw","../internal/operators/tap":"1LiLi","../internal/operators/throttle":"jinO2","../internal/operators/throttleTime":"6lj6f","../internal/operators/throwIfEmpty":"3A9HT","../internal/operators/timeInterval":"7omle","../internal/operators/timeout":"5TIfU","../internal/operators/timeoutWith":"d8OMJ","../internal/operators/timestamp":"cuNU1","../internal/operators/toArray":"ajufK","../internal/operators/window":"kAG83","../internal/operators/windowCount":"c5rVO","../internal/operators/windowTime":"1eYrc","../internal/operators/windowToggle":"iNHIA","../internal/operators/windowWhen":"iz1YG","../internal/operators/withLatestFrom":"fqcM0","../internal/operators/zip":"dfA7f","../internal/operators/zipAll":"1bLGR","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4qWW6":[function(require,module,exports) {
/** PURE_IMPORTS_START tslib,_innerSubscribe PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "audit", ()=>audit);
var _tslib = require("tslib");
var _innerSubscribe = require("../innerSubscribe");
function audit(durationSelector) {
    return function auditOperatorFunction(source) {
        return source.lift(new AuditOperator(durationSelector));
    };
}
var AuditOperator = /*@__PURE__*/ function() {
    function AuditOperator(durationSelector) {
        this.durationSelector = durationSelector;
    }
    AuditOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new AuditSubscriber(subscriber, this.durationSelector));
    };
    return AuditOperator;
}();
var AuditSubscriber = /*@__PURE__*/ function(_super) {
    _tslib.__extends(AuditSubscriber, _super);
    function AuditSubscriber(destination, durationSelector) {
        var _this = _super.call(this, destination) || this;
        _this.durationSelector = durationSelector;
        _this.hasValue = false;
        return _this;
    }
    AuditSubscriber.prototype._next = function(value) {
        this.value = value;
        this.hasValue = true;
        if (!this.throttled) {
            var duration = void 0;
            try {
                var durationSelector = this.durationSelector;
                duration = durationSelector(value);
            } catch (err) {
                return this.destination.error(err);
            }
            var innerSubscription = (0, _innerSubscribe.innerSubscribe)(duration, new (0, _innerSubscribe.SimpleInnerSubscriber)(this));
            if (!innerSubscription || innerSubscription.closed) this.clearThrottle();
            else this.add(this.throttled = innerSubscription);
        }
    };
    AuditSubscriber.prototype.clearThrottle = function() {
        var _a = this, value = _a.value, hasValue = _a.hasValue, throttled = _a.throttled;
        if (throttled) {
            this.remove(throttled);
            this.throttled = undefined;
            throttled.unsubscribe();
        }
        if (hasValue) {
            this.value = undefined;
            this.hasValue = false;
            this.destination.next(value);
        }
    };
    AuditSubscriber.prototype.notifyNext = function() {
        this.clearThrottle();
    };
    AuditSubscriber.prototype.notifyComplete = function() {
        this.clearThrottle();
    };
    return AuditSubscriber;
}((0, _innerSubscribe.SimpleOuterSubscriber));

},{"tslib":"kcqwq","../innerSubscribe":"73frt","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8RvbG":[function(require,module,exports) {
/** PURE_IMPORTS_START _scheduler_async,_audit,_observable_timer PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "auditTime", ()=>auditTime);
var _async = require("../scheduler/async");
var _audit = require("./audit");
var _timer = require("../observable/timer");
function auditTime(duration, scheduler) {
    if (scheduler === void 0) scheduler = (0, _async.async);
    return (0, _audit.audit)(function() {
        return (0, _timer.timer)(duration, scheduler);
    });
}

},{"../scheduler/async":"l1cmn","./audit":"4qWW6","../observable/timer":"jufOf","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2S6EL":[function(require,module,exports) {
/** PURE_IMPORTS_START tslib,_innerSubscribe PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "buffer", ()=>buffer);
var _tslib = require("tslib");
var _innerSubscribe = require("../innerSubscribe");
function buffer(closingNotifier) {
    return function bufferOperatorFunction(source) {
        return source.lift(new BufferOperator(closingNotifier));
    };
}
var BufferOperator = /*@__PURE__*/ function() {
    function BufferOperator(closingNotifier) {
        this.closingNotifier = closingNotifier;
    }
    BufferOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new BufferSubscriber(subscriber, this.closingNotifier));
    };
    return BufferOperator;
}();
var BufferSubscriber = /*@__PURE__*/ function(_super) {
    _tslib.__extends(BufferSubscriber, _super);
    function BufferSubscriber(destination, closingNotifier) {
        var _this = _super.call(this, destination) || this;
        _this.buffer = [];
        _this.add((0, _innerSubscribe.innerSubscribe)(closingNotifier, new (0, _innerSubscribe.SimpleInnerSubscriber)(_this)));
        return _this;
    }
    BufferSubscriber.prototype._next = function(value) {
        this.buffer.push(value);
    };
    BufferSubscriber.prototype.notifyNext = function() {
        var buffer = this.buffer;
        this.buffer = [];
        this.destination.next(buffer);
    };
    return BufferSubscriber;
}((0, _innerSubscribe.SimpleOuterSubscriber));

},{"tslib":"kcqwq","../innerSubscribe":"73frt","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"gmiQw":[function(require,module,exports) {
/** PURE_IMPORTS_START tslib,_Subscriber PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "bufferCount", ()=>bufferCount);
var _tslib = require("tslib");
var _subscriber = require("../Subscriber");
function bufferCount(bufferSize, startBufferEvery) {
    if (startBufferEvery === void 0) startBufferEvery = null;
    return function bufferCountOperatorFunction(source) {
        return source.lift(new BufferCountOperator(bufferSize, startBufferEvery));
    };
}
var BufferCountOperator = /*@__PURE__*/ function() {
    function BufferCountOperator(bufferSize, startBufferEvery) {
        this.bufferSize = bufferSize;
        this.startBufferEvery = startBufferEvery;
        if (!startBufferEvery || bufferSize === startBufferEvery) this.subscriberClass = BufferCountSubscriber;
        else this.subscriberClass = BufferSkipCountSubscriber;
    }
    BufferCountOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new this.subscriberClass(subscriber, this.bufferSize, this.startBufferEvery));
    };
    return BufferCountOperator;
}();
var BufferCountSubscriber = /*@__PURE__*/ function(_super) {
    _tslib.__extends(BufferCountSubscriber, _super);
    function BufferCountSubscriber(destination, bufferSize) {
        var _this = _super.call(this, destination) || this;
        _this.bufferSize = bufferSize;
        _this.buffer = [];
        return _this;
    }
    BufferCountSubscriber.prototype._next = function(value) {
        var buffer = this.buffer;
        buffer.push(value);
        if (buffer.length == this.bufferSize) {
            this.destination.next(buffer);
            this.buffer = [];
        }
    };
    BufferCountSubscriber.prototype._complete = function() {
        var buffer = this.buffer;
        if (buffer.length > 0) this.destination.next(buffer);
        _super.prototype._complete.call(this);
    };
    return BufferCountSubscriber;
}((0, _subscriber.Subscriber));
var BufferSkipCountSubscriber = /*@__PURE__*/ function(_super) {
    _tslib.__extends(BufferSkipCountSubscriber, _super);
    function BufferSkipCountSubscriber(destination, bufferSize, startBufferEvery) {
        var _this = _super.call(this, destination) || this;
        _this.bufferSize = bufferSize;
        _this.startBufferEvery = startBufferEvery;
        _this.buffers = [];
        _this.count = 0;
        return _this;
    }
    BufferSkipCountSubscriber.prototype._next = function(value) {
        var _a = this, bufferSize = _a.bufferSize, startBufferEvery = _a.startBufferEvery, buffers = _a.buffers, count = _a.count;
        this.count++;
        if (count % startBufferEvery === 0) buffers.push([]);
        for(var i = buffers.length; i--;){
            var buffer = buffers[i];
            buffer.push(value);
            if (buffer.length === bufferSize) {
                buffers.splice(i, 1);
                this.destination.next(buffer);
            }
        }
    };
    BufferSkipCountSubscriber.prototype._complete = function() {
        var _a = this, buffers = _a.buffers, destination = _a.destination;
        while(buffers.length > 0){
            var buffer = buffers.shift();
            if (buffer.length > 0) destination.next(buffer);
        }
        _super.prototype._complete.call(this);
    };
    return BufferSkipCountSubscriber;
}((0, _subscriber.Subscriber));

},{"tslib":"kcqwq","../Subscriber":"jGx8F","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7jBeD":[function(require,module,exports) {
/** PURE_IMPORTS_START tslib,_scheduler_async,_Subscriber,_util_isScheduler PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "bufferTime", ()=>bufferTime);
var _tslib = require("tslib");
var _async = require("../scheduler/async");
var _subscriber = require("../Subscriber");
var _isScheduler = require("../util/isScheduler");
function bufferTime(bufferTimeSpan) {
    var length = arguments.length;
    var scheduler = (0, _async.async);
    if ((0, _isScheduler.isScheduler)(arguments[arguments.length - 1])) {
        scheduler = arguments[arguments.length - 1];
        length--;
    }
    var bufferCreationInterval = null;
    if (length >= 2) bufferCreationInterval = arguments[1];
    var maxBufferSize = Number.POSITIVE_INFINITY;
    if (length >= 3) maxBufferSize = arguments[2];
    return function bufferTimeOperatorFunction(source) {
        return source.lift(new BufferTimeOperator(bufferTimeSpan, bufferCreationInterval, maxBufferSize, scheduler));
    };
}
var BufferTimeOperator = /*@__PURE__*/ function() {
    function BufferTimeOperator(bufferTimeSpan, bufferCreationInterval, maxBufferSize, scheduler) {
        this.bufferTimeSpan = bufferTimeSpan;
        this.bufferCreationInterval = bufferCreationInterval;
        this.maxBufferSize = maxBufferSize;
        this.scheduler = scheduler;
    }
    BufferTimeOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new BufferTimeSubscriber(subscriber, this.bufferTimeSpan, this.bufferCreationInterval, this.maxBufferSize, this.scheduler));
    };
    return BufferTimeOperator;
}();
var Context = /*@__PURE__*/ function() {
    function Context() {
        this.buffer = [];
    }
    return Context;
}();
var BufferTimeSubscriber = /*@__PURE__*/ function(_super) {
    _tslib.__extends(BufferTimeSubscriber, _super);
    function BufferTimeSubscriber(destination, bufferTimeSpan, bufferCreationInterval, maxBufferSize, scheduler) {
        var _this = _super.call(this, destination) || this;
        _this.bufferTimeSpan = bufferTimeSpan;
        _this.bufferCreationInterval = bufferCreationInterval;
        _this.maxBufferSize = maxBufferSize;
        _this.scheduler = scheduler;
        _this.contexts = [];
        var context = _this.openContext();
        _this.timespanOnly = bufferCreationInterval == null || bufferCreationInterval < 0;
        if (_this.timespanOnly) {
            var timeSpanOnlyState = {
                subscriber: _this,
                context: context,
                bufferTimeSpan: bufferTimeSpan
            };
            _this.add(context.closeAction = scheduler.schedule(dispatchBufferTimeSpanOnly, bufferTimeSpan, timeSpanOnlyState));
        } else {
            var closeState = {
                subscriber: _this,
                context: context
            };
            var creationState = {
                bufferTimeSpan: bufferTimeSpan,
                bufferCreationInterval: bufferCreationInterval,
                subscriber: _this,
                scheduler: scheduler
            };
            _this.add(context.closeAction = scheduler.schedule(dispatchBufferClose, bufferTimeSpan, closeState));
            _this.add(scheduler.schedule(dispatchBufferCreation, bufferCreationInterval, creationState));
        }
        return _this;
    }
    BufferTimeSubscriber.prototype._next = function(value) {
        var contexts = this.contexts;
        var len = contexts.length;
        var filledBufferContext;
        for(var i = 0; i < len; i++){
            var context_1 = contexts[i];
            var buffer = context_1.buffer;
            buffer.push(value);
            if (buffer.length == this.maxBufferSize) filledBufferContext = context_1;
        }
        if (filledBufferContext) this.onBufferFull(filledBufferContext);
    };
    BufferTimeSubscriber.prototype._error = function(err) {
        this.contexts.length = 0;
        _super.prototype._error.call(this, err);
    };
    BufferTimeSubscriber.prototype._complete = function() {
        var _a = this, contexts = _a.contexts, destination = _a.destination;
        while(contexts.length > 0){
            var context_2 = contexts.shift();
            destination.next(context_2.buffer);
        }
        _super.prototype._complete.call(this);
    };
    BufferTimeSubscriber.prototype._unsubscribe = function() {
        this.contexts = null;
    };
    BufferTimeSubscriber.prototype.onBufferFull = function(context) {
        this.closeContext(context);
        var closeAction = context.closeAction;
        closeAction.unsubscribe();
        this.remove(closeAction);
        if (!this.closed && this.timespanOnly) {
            context = this.openContext();
            var bufferTimeSpan = this.bufferTimeSpan;
            var timeSpanOnlyState = {
                subscriber: this,
                context: context,
                bufferTimeSpan: bufferTimeSpan
            };
            this.add(context.closeAction = this.scheduler.schedule(dispatchBufferTimeSpanOnly, bufferTimeSpan, timeSpanOnlyState));
        }
    };
    BufferTimeSubscriber.prototype.openContext = function() {
        var context = new Context();
        this.contexts.push(context);
        return context;
    };
    BufferTimeSubscriber.prototype.closeContext = function(context) {
        this.destination.next(context.buffer);
        var contexts = this.contexts;
        var spliceIndex = contexts ? contexts.indexOf(context) : -1;
        if (spliceIndex >= 0) contexts.splice(contexts.indexOf(context), 1);
    };
    return BufferTimeSubscriber;
}((0, _subscriber.Subscriber));
function dispatchBufferTimeSpanOnly(state) {
    var subscriber = state.subscriber;
    var prevContext = state.context;
    if (prevContext) subscriber.closeContext(prevContext);
    if (!subscriber.closed) {
        state.context = subscriber.openContext();
        state.context.closeAction = this.schedule(state, state.bufferTimeSpan);
    }
}
function dispatchBufferCreation(state) {
    var bufferCreationInterval = state.bufferCreationInterval, bufferTimeSpan = state.bufferTimeSpan, subscriber = state.subscriber, scheduler = state.scheduler;
    var context = subscriber.openContext();
    var action = this;
    if (!subscriber.closed) {
        subscriber.add(context.closeAction = scheduler.schedule(dispatchBufferClose, bufferTimeSpan, {
            subscriber: subscriber,
            context: context
        }));
        action.schedule(state, bufferCreationInterval);
    }
}
function dispatchBufferClose(arg) {
    var subscriber = arg.subscriber, context = arg.context;
    subscriber.closeContext(context);
}

},{"tslib":"kcqwq","../scheduler/async":"l1cmn","../Subscriber":"jGx8F","../util/isScheduler":"4iYg4","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"3I58S":[function(require,module,exports) {
/** PURE_IMPORTS_START tslib,_Subscription,_util_subscribeToResult,_OuterSubscriber PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "bufferToggle", ()=>bufferToggle);
var _tslib = require("tslib");
var _subscription = require("../Subscription");
var _subscribeToResult = require("../util/subscribeToResult");
var _outerSubscriber = require("../OuterSubscriber");
function bufferToggle(openings, closingSelector) {
    return function bufferToggleOperatorFunction(source) {
        return source.lift(new BufferToggleOperator(openings, closingSelector));
    };
}
var BufferToggleOperator = /*@__PURE__*/ function() {
    function BufferToggleOperator(openings, closingSelector) {
        this.openings = openings;
        this.closingSelector = closingSelector;
    }
    BufferToggleOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new BufferToggleSubscriber(subscriber, this.openings, this.closingSelector));
    };
    return BufferToggleOperator;
}();
var BufferToggleSubscriber = /*@__PURE__*/ function(_super) {
    _tslib.__extends(BufferToggleSubscriber, _super);
    function BufferToggleSubscriber(destination, openings, closingSelector) {
        var _this = _super.call(this, destination) || this;
        _this.closingSelector = closingSelector;
        _this.contexts = [];
        _this.add((0, _subscribeToResult.subscribeToResult)(_this, openings));
        return _this;
    }
    BufferToggleSubscriber.prototype._next = function(value) {
        var contexts = this.contexts;
        var len = contexts.length;
        for(var i = 0; i < len; i++)contexts[i].buffer.push(value);
    };
    BufferToggleSubscriber.prototype._error = function(err) {
        var contexts = this.contexts;
        while(contexts.length > 0){
            var context_1 = contexts.shift();
            context_1.subscription.unsubscribe();
            context_1.buffer = null;
            context_1.subscription = null;
        }
        this.contexts = null;
        _super.prototype._error.call(this, err);
    };
    BufferToggleSubscriber.prototype._complete = function() {
        var contexts = this.contexts;
        while(contexts.length > 0){
            var context_2 = contexts.shift();
            this.destination.next(context_2.buffer);
            context_2.subscription.unsubscribe();
            context_2.buffer = null;
            context_2.subscription = null;
        }
        this.contexts = null;
        _super.prototype._complete.call(this);
    };
    BufferToggleSubscriber.prototype.notifyNext = function(outerValue, innerValue) {
        outerValue ? this.closeBuffer(outerValue) : this.openBuffer(innerValue);
    };
    BufferToggleSubscriber.prototype.notifyComplete = function(innerSub) {
        this.closeBuffer(innerSub.context);
    };
    BufferToggleSubscriber.prototype.openBuffer = function(value) {
        try {
            var closingSelector = this.closingSelector;
            var closingNotifier = closingSelector.call(this, value);
            if (closingNotifier) this.trySubscribe(closingNotifier);
        } catch (err) {
            this._error(err);
        }
    };
    BufferToggleSubscriber.prototype.closeBuffer = function(context) {
        var contexts = this.contexts;
        if (contexts && context) {
            var buffer = context.buffer, subscription = context.subscription;
            this.destination.next(buffer);
            contexts.splice(contexts.indexOf(context), 1);
            this.remove(subscription);
            subscription.unsubscribe();
        }
    };
    BufferToggleSubscriber.prototype.trySubscribe = function(closingNotifier) {
        var contexts = this.contexts;
        var buffer = [];
        var subscription = new (0, _subscription.Subscription)();
        var context = {
            buffer: buffer,
            subscription: subscription
        };
        contexts.push(context);
        var innerSubscription = (0, _subscribeToResult.subscribeToResult)(this, closingNotifier, context);
        if (!innerSubscription || innerSubscription.closed) this.closeBuffer(context);
        else {
            innerSubscription.context = context;
            this.add(innerSubscription);
            subscription.add(innerSubscription);
        }
    };
    return BufferToggleSubscriber;
}((0, _outerSubscriber.OuterSubscriber));

},{"tslib":"kcqwq","../Subscription":"ahthJ","../util/subscribeToResult":"4ctqX","../OuterSubscriber":"fECUl","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"eAxGr":[function(require,module,exports) {
/** PURE_IMPORTS_START tslib,_Subscription,_innerSubscribe PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "bufferWhen", ()=>bufferWhen);
var _tslib = require("tslib");
var _subscription = require("../Subscription");
var _innerSubscribe = require("../innerSubscribe");
function bufferWhen(closingSelector) {
    return function(source) {
        return source.lift(new BufferWhenOperator(closingSelector));
    };
}
var BufferWhenOperator = /*@__PURE__*/ function() {
    function BufferWhenOperator(closingSelector) {
        this.closingSelector = closingSelector;
    }
    BufferWhenOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new BufferWhenSubscriber(subscriber, this.closingSelector));
    };
    return BufferWhenOperator;
}();
var BufferWhenSubscriber = /*@__PURE__*/ function(_super) {
    _tslib.__extends(BufferWhenSubscriber, _super);
    function BufferWhenSubscriber(destination, closingSelector) {
        var _this = _super.call(this, destination) || this;
        _this.closingSelector = closingSelector;
        _this.subscribing = false;
        _this.openBuffer();
        return _this;
    }
    BufferWhenSubscriber.prototype._next = function(value) {
        this.buffer.push(value);
    };
    BufferWhenSubscriber.prototype._complete = function() {
        var buffer = this.buffer;
        if (buffer) this.destination.next(buffer);
        _super.prototype._complete.call(this);
    };
    BufferWhenSubscriber.prototype._unsubscribe = function() {
        this.buffer = undefined;
        this.subscribing = false;
    };
    BufferWhenSubscriber.prototype.notifyNext = function() {
        this.openBuffer();
    };
    BufferWhenSubscriber.prototype.notifyComplete = function() {
        if (this.subscribing) this.complete();
        else this.openBuffer();
    };
    BufferWhenSubscriber.prototype.openBuffer = function() {
        var closingSubscription = this.closingSubscription;
        if (closingSubscription) {
            this.remove(closingSubscription);
            closingSubscription.unsubscribe();
        }
        var buffer = this.buffer;
        if (this.buffer) this.destination.next(buffer);
        this.buffer = [];
        var closingNotifier;
        try {
            var closingSelector = this.closingSelector;
            closingNotifier = closingSelector();
        } catch (err) {
            return this.error(err);
        }
        closingSubscription = new (0, _subscription.Subscription)();
        this.closingSubscription = closingSubscription;
        this.add(closingSubscription);
        this.subscribing = true;
        closingSubscription.add((0, _innerSubscribe.innerSubscribe)(closingNotifier, new (0, _innerSubscribe.SimpleInnerSubscriber)(this)));
        this.subscribing = false;
    };
    return BufferWhenSubscriber;
}((0, _innerSubscribe.SimpleOuterSubscriber));

},{"tslib":"kcqwq","../Subscription":"ahthJ","../innerSubscribe":"73frt","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7rF1H":[function(require,module,exports) {
/** PURE_IMPORTS_START tslib,_innerSubscribe PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "catchError", ()=>catchError);
var _tslib = require("tslib");
var _innerSubscribe = require("../innerSubscribe");
function catchError(selector) {
    return function catchErrorOperatorFunction(source) {
        var operator = new CatchOperator(selector);
        var caught = source.lift(operator);
        return operator.caught = caught;
    };
}
var CatchOperator = /*@__PURE__*/ function() {
    function CatchOperator(selector) {
        this.selector = selector;
    }
    CatchOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new CatchSubscriber(subscriber, this.selector, this.caught));
    };
    return CatchOperator;
}();
var CatchSubscriber = /*@__PURE__*/ function(_super) {
    _tslib.__extends(CatchSubscriber, _super);
    function CatchSubscriber(destination, selector, caught) {
        var _this = _super.call(this, destination) || this;
        _this.selector = selector;
        _this.caught = caught;
        return _this;
    }
    CatchSubscriber.prototype.error = function(err) {
        if (!this.isStopped) {
            var result = void 0;
            try {
                result = this.selector(err, this.caught);
            } catch (err2) {
                _super.prototype.error.call(this, err2);
                return;
            }
            this._unsubscribeAndRecycle();
            var innerSubscriber = new (0, _innerSubscribe.SimpleInnerSubscriber)(this);
            this.add(innerSubscriber);
            var innerSubscription = (0, _innerSubscribe.innerSubscribe)(result, innerSubscriber);
            if (innerSubscription !== innerSubscriber) this.add(innerSubscription);
        }
    };
    return CatchSubscriber;
}((0, _innerSubscribe.SimpleOuterSubscriber));

},{"tslib":"kcqwq","../innerSubscribe":"73frt","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"3gD1U":[function(require,module,exports) {
/** PURE_IMPORTS_START _observable_combineLatest PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "combineAll", ()=>combineAll);
var _combineLatest = require("../observable/combineLatest");
function combineAll(project) {
    return function(source) {
        return source.lift(new (0, _combineLatest.CombineLatestOperator)(project));
    };
}

},{"../observable/combineLatest":"wg3KP","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"3N35f":[function(require,module,exports) {
/** PURE_IMPORTS_START _util_isArray,_observable_combineLatest,_observable_from PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "combineLatest", ()=>combineLatest);
var _isArray = require("../util/isArray");
var _combineLatest = require("../observable/combineLatest");
var _from = require("../observable/from");
var none = {};
function combineLatest() {
    var observables = [];
    for(var _i = 0; _i < arguments.length; _i++)observables[_i] = arguments[_i];
    var project = null;
    if (typeof observables[observables.length - 1] === "function") project = observables.pop();
    if (observables.length === 1 && (0, _isArray.isArray)(observables[0])) observables = observables[0].slice();
    return function(source) {
        return source.lift.call((0, _from.from)([
            source
        ].concat(observables)), new (0, _combineLatest.CombineLatestOperator)(project));
    };
}

},{"../util/isArray":"2HaTi","../observable/combineLatest":"wg3KP","../observable/from":"6aqs0","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8pRKh":[function(require,module,exports) {
/** PURE_IMPORTS_START _observable_concat PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "concat", ()=>concat);
var _concat = require("../observable/concat");
function concat() {
    var observables = [];
    for(var _i = 0; _i < arguments.length; _i++)observables[_i] = arguments[_i];
    return function(source) {
        return source.lift.call((0, _concat.concat).apply(void 0, [
            source
        ].concat(observables)));
    };
}

},{"../observable/concat":"2cXL0","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4nwZ8":[function(require,module,exports) {
/** PURE_IMPORTS_START _mergeMap PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "concatMap", ()=>concatMap);
var _mergeMap = require("./mergeMap");
function concatMap(project, resultSelector) {
    return (0, _mergeMap.mergeMap)(project, resultSelector, 1);
}

},{"./mergeMap":"7NAZz","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"dqNGp":[function(require,module,exports) {
/** PURE_IMPORTS_START _concatMap PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "concatMapTo", ()=>concatMapTo);
var _concatMap = require("./concatMap");
function concatMapTo(innerObservable, resultSelector) {
    return (0, _concatMap.concatMap)(function() {
        return innerObservable;
    }, resultSelector);
}

},{"./concatMap":"4nwZ8","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2Fibo":[function(require,module,exports) {
/** PURE_IMPORTS_START tslib,_Subscriber PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "count", ()=>count);
var _tslib = require("tslib");
var _subscriber = require("../Subscriber");
function count(predicate) {
    return function(source) {
        return source.lift(new CountOperator(predicate, source));
    };
}
var CountOperator = /*@__PURE__*/ function() {
    function CountOperator(predicate, source) {
        this.predicate = predicate;
        this.source = source;
    }
    CountOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new CountSubscriber(subscriber, this.predicate, this.source));
    };
    return CountOperator;
}();
var CountSubscriber = /*@__PURE__*/ function(_super) {
    _tslib.__extends(CountSubscriber, _super);
    function CountSubscriber(destination, predicate, source) {
        var _this = _super.call(this, destination) || this;
        _this.predicate = predicate;
        _this.source = source;
        _this.count = 0;
        _this.index = 0;
        return _this;
    }
    CountSubscriber.prototype._next = function(value) {
        if (this.predicate) this._tryPredicate(value);
        else this.count++;
    };
    CountSubscriber.prototype._tryPredicate = function(value) {
        var result;
        try {
            result = this.predicate(value, this.index++, this.source);
        } catch (err) {
            this.destination.error(err);
            return;
        }
        if (result) this.count++;
    };
    CountSubscriber.prototype._complete = function() {
        this.destination.next(this.count);
        this.destination.complete();
    };
    return CountSubscriber;
}((0, _subscriber.Subscriber));

},{"tslib":"kcqwq","../Subscriber":"jGx8F","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"6qDC7":[function(require,module,exports) {
/** PURE_IMPORTS_START tslib,_innerSubscribe PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "debounce", ()=>debounce);
var _tslib = require("tslib");
var _innerSubscribe = require("../innerSubscribe");
function debounce(durationSelector) {
    return function(source) {
        return source.lift(new DebounceOperator(durationSelector));
    };
}
var DebounceOperator = /*@__PURE__*/ function() {
    function DebounceOperator(durationSelector) {
        this.durationSelector = durationSelector;
    }
    DebounceOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new DebounceSubscriber(subscriber, this.durationSelector));
    };
    return DebounceOperator;
}();
var DebounceSubscriber = /*@__PURE__*/ function(_super) {
    _tslib.__extends(DebounceSubscriber, _super);
    function DebounceSubscriber(destination, durationSelector) {
        var _this = _super.call(this, destination) || this;
        _this.durationSelector = durationSelector;
        _this.hasValue = false;
        return _this;
    }
    DebounceSubscriber.prototype._next = function(value) {
        try {
            var result = this.durationSelector.call(this, value);
            if (result) this._tryNext(value, result);
        } catch (err) {
            this.destination.error(err);
        }
    };
    DebounceSubscriber.prototype._complete = function() {
        this.emitValue();
        this.destination.complete();
    };
    DebounceSubscriber.prototype._tryNext = function(value, duration) {
        var subscription = this.durationSubscription;
        this.value = value;
        this.hasValue = true;
        if (subscription) {
            subscription.unsubscribe();
            this.remove(subscription);
        }
        subscription = (0, _innerSubscribe.innerSubscribe)(duration, new (0, _innerSubscribe.SimpleInnerSubscriber)(this));
        if (subscription && !subscription.closed) this.add(this.durationSubscription = subscription);
    };
    DebounceSubscriber.prototype.notifyNext = function() {
        this.emitValue();
    };
    DebounceSubscriber.prototype.notifyComplete = function() {
        this.emitValue();
    };
    DebounceSubscriber.prototype.emitValue = function() {
        if (this.hasValue) {
            var value = this.value;
            var subscription = this.durationSubscription;
            if (subscription) {
                this.durationSubscription = undefined;
                subscription.unsubscribe();
                this.remove(subscription);
            }
            this.value = undefined;
            this.hasValue = false;
            _super.prototype._next.call(this, value);
        }
    };
    return DebounceSubscriber;
}((0, _innerSubscribe.SimpleOuterSubscriber));

},{"tslib":"kcqwq","../innerSubscribe":"73frt","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"c8BHO":[function(require,module,exports) {
/** PURE_IMPORTS_START tslib,_Subscriber,_scheduler_async PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "debounceTime", ()=>debounceTime);
var _tslib = require("tslib");
var _subscriber = require("../Subscriber");
var _async = require("../scheduler/async");
function debounceTime(dueTime, scheduler) {
    if (scheduler === void 0) scheduler = (0, _async.async);
    return function(source) {
        return source.lift(new DebounceTimeOperator(dueTime, scheduler));
    };
}
var DebounceTimeOperator = /*@__PURE__*/ function() {
    function DebounceTimeOperator(dueTime, scheduler) {
        this.dueTime = dueTime;
        this.scheduler = scheduler;
    }
    DebounceTimeOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new DebounceTimeSubscriber(subscriber, this.dueTime, this.scheduler));
    };
    return DebounceTimeOperator;
}();
var DebounceTimeSubscriber = /*@__PURE__*/ function(_super) {
    _tslib.__extends(DebounceTimeSubscriber, _super);
    function DebounceTimeSubscriber(destination, dueTime, scheduler) {
        var _this = _super.call(this, destination) || this;
        _this.dueTime = dueTime;
        _this.scheduler = scheduler;
        _this.debouncedSubscription = null;
        _this.lastValue = null;
        _this.hasValue = false;
        return _this;
    }
    DebounceTimeSubscriber.prototype._next = function(value) {
        this.clearDebounce();
        this.lastValue = value;
        this.hasValue = true;
        this.add(this.debouncedSubscription = this.scheduler.schedule(dispatchNext, this.dueTime, this));
    };
    DebounceTimeSubscriber.prototype._complete = function() {
        this.debouncedNext();
        this.destination.complete();
    };
    DebounceTimeSubscriber.prototype.debouncedNext = function() {
        this.clearDebounce();
        if (this.hasValue) {
            var lastValue = this.lastValue;
            this.lastValue = null;
            this.hasValue = false;
            this.destination.next(lastValue);
        }
    };
    DebounceTimeSubscriber.prototype.clearDebounce = function() {
        var debouncedSubscription = this.debouncedSubscription;
        if (debouncedSubscription !== null) {
            this.remove(debouncedSubscription);
            debouncedSubscription.unsubscribe();
            this.debouncedSubscription = null;
        }
    };
    return DebounceTimeSubscriber;
}((0, _subscriber.Subscriber));
function dispatchNext(subscriber) {
    subscriber.debouncedNext();
}

},{"tslib":"kcqwq","../Subscriber":"jGx8F","../scheduler/async":"l1cmn","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"1eMdN":[function(require,module,exports) {
/** PURE_IMPORTS_START tslib,_Subscriber PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "defaultIfEmpty", ()=>defaultIfEmpty);
var _tslib = require("tslib");
var _subscriber = require("../Subscriber");
function defaultIfEmpty(defaultValue) {
    if (defaultValue === void 0) defaultValue = null;
    return function(source) {
        return source.lift(new DefaultIfEmptyOperator(defaultValue));
    };
}
var DefaultIfEmptyOperator = /*@__PURE__*/ function() {
    function DefaultIfEmptyOperator(defaultValue) {
        this.defaultValue = defaultValue;
    }
    DefaultIfEmptyOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new DefaultIfEmptySubscriber(subscriber, this.defaultValue));
    };
    return DefaultIfEmptyOperator;
}();
var DefaultIfEmptySubscriber = /*@__PURE__*/ function(_super) {
    _tslib.__extends(DefaultIfEmptySubscriber, _super);
    function DefaultIfEmptySubscriber(destination, defaultValue) {
        var _this = _super.call(this, destination) || this;
        _this.defaultValue = defaultValue;
        _this.isEmpty = true;
        return _this;
    }
    DefaultIfEmptySubscriber.prototype._next = function(value) {
        this.isEmpty = false;
        this.destination.next(value);
    };
    DefaultIfEmptySubscriber.prototype._complete = function() {
        if (this.isEmpty) this.destination.next(this.defaultValue);
        this.destination.complete();
    };
    return DefaultIfEmptySubscriber;
}((0, _subscriber.Subscriber));

},{"tslib":"kcqwq","../Subscriber":"jGx8F","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"64BbM":[function(require,module,exports) {
/** PURE_IMPORTS_START tslib,_scheduler_async,_util_isDate,_Subscriber,_Notification PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "delay", ()=>delay);
var _tslib = require("tslib");
var _async = require("../scheduler/async");
var _isDate = require("../util/isDate");
var _subscriber = require("../Subscriber");
var _notification = require("../Notification");
function delay(delay, scheduler) {
    if (scheduler === void 0) scheduler = (0, _async.async);
    var absoluteDelay = (0, _isDate.isDate)(delay);
    var delayFor = absoluteDelay ? +delay - scheduler.now() : Math.abs(delay);
    return function(source) {
        return source.lift(new DelayOperator(delayFor, scheduler));
    };
}
var DelayOperator = /*@__PURE__*/ function() {
    function DelayOperator(delay, scheduler) {
        this.delay = delay;
        this.scheduler = scheduler;
    }
    DelayOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new DelaySubscriber(subscriber, this.delay, this.scheduler));
    };
    return DelayOperator;
}();
var DelaySubscriber = /*@__PURE__*/ function(_super) {
    _tslib.__extends(DelaySubscriber, _super);
    function DelaySubscriber(destination, delay, scheduler) {
        var _this = _super.call(this, destination) || this;
        _this.delay = delay;
        _this.scheduler = scheduler;
        _this.queue = [];
        _this.active = false;
        _this.errored = false;
        return _this;
    }
    DelaySubscriber.dispatch = function(state) {
        var source = state.source;
        var queue = source.queue;
        var scheduler = state.scheduler;
        var destination = state.destination;
        while(queue.length > 0 && queue[0].time - scheduler.now() <= 0)queue.shift().notification.observe(destination);
        if (queue.length > 0) {
            var delay_1 = Math.max(0, queue[0].time - scheduler.now());
            this.schedule(state, delay_1);
        } else {
            this.unsubscribe();
            source.active = false;
        }
    };
    DelaySubscriber.prototype._schedule = function(scheduler) {
        this.active = true;
        var destination = this.destination;
        destination.add(scheduler.schedule(DelaySubscriber.dispatch, this.delay, {
            source: this,
            destination: this.destination,
            scheduler: scheduler
        }));
    };
    DelaySubscriber.prototype.scheduleNotification = function(notification) {
        if (this.errored === true) return;
        var scheduler = this.scheduler;
        var message = new DelayMessage(scheduler.now() + this.delay, notification);
        this.queue.push(message);
        if (this.active === false) this._schedule(scheduler);
    };
    DelaySubscriber.prototype._next = function(value) {
        this.scheduleNotification((0, _notification.Notification).createNext(value));
    };
    DelaySubscriber.prototype._error = function(err) {
        this.errored = true;
        this.queue = [];
        this.destination.error(err);
        this.unsubscribe();
    };
    DelaySubscriber.prototype._complete = function() {
        this.scheduleNotification((0, _notification.Notification).createComplete());
        this.unsubscribe();
    };
    return DelaySubscriber;
}((0, _subscriber.Subscriber));
var DelayMessage = /*@__PURE__*/ function() {
    function DelayMessage(time, notification) {
        this.time = time;
        this.notification = notification;
    }
    return DelayMessage;
}();

},{"tslib":"kcqwq","../scheduler/async":"l1cmn","../util/isDate":"g98jK","../Subscriber":"jGx8F","../Notification":"3c26n","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"g98jK":[function(require,module,exports) {
/** PURE_IMPORTS_START  PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isDate", ()=>isDate);
function isDate(value) {
    return value instanceof Date && !isNaN(+value);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"lDbXG":[function(require,module,exports) {
/** PURE_IMPORTS_START tslib,_Subscriber,_Observable,_OuterSubscriber,_util_subscribeToResult PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "delayWhen", ()=>delayWhen);
var _tslib = require("tslib");
var _subscriber = require("../Subscriber");
var _observable = require("../Observable");
var _outerSubscriber = require("../OuterSubscriber");
var _subscribeToResult = require("../util/subscribeToResult");
function delayWhen(delayDurationSelector, subscriptionDelay) {
    if (subscriptionDelay) return function(source) {
        return new SubscriptionDelayObservable(source, subscriptionDelay).lift(new DelayWhenOperator(delayDurationSelector));
    };
    return function(source) {
        return source.lift(new DelayWhenOperator(delayDurationSelector));
    };
}
var DelayWhenOperator = /*@__PURE__*/ function() {
    function DelayWhenOperator(delayDurationSelector) {
        this.delayDurationSelector = delayDurationSelector;
    }
    DelayWhenOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new DelayWhenSubscriber(subscriber, this.delayDurationSelector));
    };
    return DelayWhenOperator;
}();
var DelayWhenSubscriber = /*@__PURE__*/ function(_super) {
    _tslib.__extends(DelayWhenSubscriber, _super);
    function DelayWhenSubscriber(destination, delayDurationSelector) {
        var _this = _super.call(this, destination) || this;
        _this.delayDurationSelector = delayDurationSelector;
        _this.completed = false;
        _this.delayNotifierSubscriptions = [];
        _this.index = 0;
        return _this;
    }
    DelayWhenSubscriber.prototype.notifyNext = function(outerValue, _innerValue, _outerIndex, _innerIndex, innerSub) {
        this.destination.next(outerValue);
        this.removeSubscription(innerSub);
        this.tryComplete();
    };
    DelayWhenSubscriber.prototype.notifyError = function(error, innerSub) {
        this._error(error);
    };
    DelayWhenSubscriber.prototype.notifyComplete = function(innerSub) {
        var value = this.removeSubscription(innerSub);
        if (value) this.destination.next(value);
        this.tryComplete();
    };
    DelayWhenSubscriber.prototype._next = function(value) {
        var index = this.index++;
        try {
            var delayNotifier = this.delayDurationSelector(value, index);
            if (delayNotifier) this.tryDelay(delayNotifier, value);
        } catch (err) {
            this.destination.error(err);
        }
    };
    DelayWhenSubscriber.prototype._complete = function() {
        this.completed = true;
        this.tryComplete();
        this.unsubscribe();
    };
    DelayWhenSubscriber.prototype.removeSubscription = function(subscription) {
        subscription.unsubscribe();
        var subscriptionIdx = this.delayNotifierSubscriptions.indexOf(subscription);
        if (subscriptionIdx !== -1) this.delayNotifierSubscriptions.splice(subscriptionIdx, 1);
        return subscription.outerValue;
    };
    DelayWhenSubscriber.prototype.tryDelay = function(delayNotifier, value) {
        var notifierSubscription = (0, _subscribeToResult.subscribeToResult)(this, delayNotifier, value);
        if (notifierSubscription && !notifierSubscription.closed) {
            var destination = this.destination;
            destination.add(notifierSubscription);
            this.delayNotifierSubscriptions.push(notifierSubscription);
        }
    };
    DelayWhenSubscriber.prototype.tryComplete = function() {
        if (this.completed && this.delayNotifierSubscriptions.length === 0) this.destination.complete();
    };
    return DelayWhenSubscriber;
}((0, _outerSubscriber.OuterSubscriber));
var SubscriptionDelayObservable = /*@__PURE__*/ function(_super) {
    _tslib.__extends(SubscriptionDelayObservable, _super);
    function SubscriptionDelayObservable(source, subscriptionDelay) {
        var _this = _super.call(this) || this;
        _this.source = source;
        _this.subscriptionDelay = subscriptionDelay;
        return _this;
    }
    SubscriptionDelayObservable.prototype._subscribe = function(subscriber) {
        this.subscriptionDelay.subscribe(new SubscriptionDelaySubscriber(subscriber, this.source));
    };
    return SubscriptionDelayObservable;
}((0, _observable.Observable));
var SubscriptionDelaySubscriber = /*@__PURE__*/ function(_super) {
    _tslib.__extends(SubscriptionDelaySubscriber, _super);
    function SubscriptionDelaySubscriber(parent, source) {
        var _this = _super.call(this) || this;
        _this.parent = parent;
        _this.source = source;
        _this.sourceSubscribed = false;
        return _this;
    }
    SubscriptionDelaySubscriber.prototype._next = function(unused) {
        this.subscribeToSource();
    };
    SubscriptionDelaySubscriber.prototype._error = function(err) {
        this.unsubscribe();
        this.parent.error(err);
    };
    SubscriptionDelaySubscriber.prototype._complete = function() {
        this.unsubscribe();
        this.subscribeToSource();
    };
    SubscriptionDelaySubscriber.prototype.subscribeToSource = function() {
        if (!this.sourceSubscribed) {
            this.sourceSubscribed = true;
            this.unsubscribe();
            this.source.subscribe(this.parent);
        }
    };
    return SubscriptionDelaySubscriber;
}((0, _subscriber.Subscriber));

},{"tslib":"kcqwq","../Subscriber":"jGx8F","../Observable":"9oc0x","../OuterSubscriber":"fECUl","../util/subscribeToResult":"4ctqX","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"1bYYn":[function(require,module,exports) {
/** PURE_IMPORTS_START tslib,_Subscriber PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "dematerialize", ()=>dematerialize);
var _tslib = require("tslib");
var _subscriber = require("../Subscriber");
function dematerialize() {
    return function dematerializeOperatorFunction(source) {
        return source.lift(new DeMaterializeOperator());
    };
}
var DeMaterializeOperator = /*@__PURE__*/ function() {
    function DeMaterializeOperator() {}
    DeMaterializeOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new DeMaterializeSubscriber(subscriber));
    };
    return DeMaterializeOperator;
}();
var DeMaterializeSubscriber = /*@__PURE__*/ function(_super) {
    _tslib.__extends(DeMaterializeSubscriber, _super);
    function DeMaterializeSubscriber(destination) {
        return _super.call(this, destination) || this;
    }
    DeMaterializeSubscriber.prototype._next = function(value) {
        value.observe(this.destination);
    };
    return DeMaterializeSubscriber;
}((0, _subscriber.Subscriber));

},{"tslib":"kcqwq","../Subscriber":"jGx8F","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"gWe8h":[function(require,module,exports) {
/** PURE_IMPORTS_START tslib,_innerSubscribe PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "distinct", ()=>distinct);
parcelHelpers.export(exports, "DistinctSubscriber", ()=>DistinctSubscriber);
var _tslib = require("tslib");
var _innerSubscribe = require("../innerSubscribe");
function distinct(keySelector, flushes) {
    return function(source) {
        return source.lift(new DistinctOperator(keySelector, flushes));
    };
}
var DistinctOperator = /*@__PURE__*/ function() {
    function DistinctOperator(keySelector, flushes) {
        this.keySelector = keySelector;
        this.flushes = flushes;
    }
    DistinctOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new DistinctSubscriber(subscriber, this.keySelector, this.flushes));
    };
    return DistinctOperator;
}();
var DistinctSubscriber = /*@__PURE__*/ function(_super) {
    _tslib.__extends(DistinctSubscriber, _super);
    function DistinctSubscriber(destination, keySelector, flushes) {
        var _this = _super.call(this, destination) || this;
        _this.keySelector = keySelector;
        _this.values = new Set();
        if (flushes) _this.add((0, _innerSubscribe.innerSubscribe)(flushes, new (0, _innerSubscribe.SimpleInnerSubscriber)(_this)));
        return _this;
    }
    DistinctSubscriber.prototype.notifyNext = function() {
        this.values.clear();
    };
    DistinctSubscriber.prototype.notifyError = function(error) {
        this._error(error);
    };
    DistinctSubscriber.prototype._next = function(value) {
        if (this.keySelector) this._useKeySelector(value);
        else this._finalizeNext(value, value);
    };
    DistinctSubscriber.prototype._useKeySelector = function(value) {
        var key;
        var destination = this.destination;
        try {
            key = this.keySelector(value);
        } catch (err) {
            destination.error(err);
            return;
        }
        this._finalizeNext(key, value);
    };
    DistinctSubscriber.prototype._finalizeNext = function(key, value) {
        var values = this.values;
        if (!values.has(key)) {
            values.add(key);
            this.destination.next(value);
        }
    };
    return DistinctSubscriber;
}((0, _innerSubscribe.SimpleOuterSubscriber));

},{"tslib":"kcqwq","../innerSubscribe":"73frt","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"98B5v":[function(require,module,exports) {
/** PURE_IMPORTS_START tslib,_Subscriber PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "distinctUntilChanged", ()=>distinctUntilChanged);
var _tslib = require("tslib");
var _subscriber = require("../Subscriber");
function distinctUntilChanged(compare, keySelector) {
    return function(source) {
        return source.lift(new DistinctUntilChangedOperator(compare, keySelector));
    };
}
var DistinctUntilChangedOperator = /*@__PURE__*/ function() {
    function DistinctUntilChangedOperator(compare, keySelector) {
        this.compare = compare;
        this.keySelector = keySelector;
    }
    DistinctUntilChangedOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new DistinctUntilChangedSubscriber(subscriber, this.compare, this.keySelector));
    };
    return DistinctUntilChangedOperator;
}();
var DistinctUntilChangedSubscriber = /*@__PURE__*/ function(_super) {
    _tslib.__extends(DistinctUntilChangedSubscriber, _super);
    function DistinctUntilChangedSubscriber(destination, compare, keySelector) {
        var _this = _super.call(this, destination) || this;
        _this.keySelector = keySelector;
        _this.hasKey = false;
        if (typeof compare === "function") _this.compare = compare;
        return _this;
    }
    DistinctUntilChangedSubscriber.prototype.compare = function(x, y) {
        return x === y;
    };
    DistinctUntilChangedSubscriber.prototype._next = function(value) {
        var key;
        try {
            var keySelector = this.keySelector;
            key = keySelector ? keySelector(value) : value;
        } catch (err) {
            return this.destination.error(err);
        }
        var result = false;
        if (this.hasKey) try {
            var compare = this.compare;
            result = compare(this.key, key);
        } catch (err) {
            return this.destination.error(err);
        }
        else this.hasKey = true;
        if (!result) {
            this.key = key;
            this.destination.next(value);
        }
    };
    return DistinctUntilChangedSubscriber;
}((0, _subscriber.Subscriber));

},{"tslib":"kcqwq","../Subscriber":"jGx8F","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"hd3Vz":[function(require,module,exports) {
/** PURE_IMPORTS_START _distinctUntilChanged PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "distinctUntilKeyChanged", ()=>distinctUntilKeyChanged);
var _distinctUntilChanged = require("./distinctUntilChanged");
function distinctUntilKeyChanged(key, compare) {
    return (0, _distinctUntilChanged.distinctUntilChanged)(function(x, y) {
        return compare ? compare(x[key], y[key]) : x[key] === y[key];
    });
}

},{"./distinctUntilChanged":"98B5v","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"92xaa":[function(require,module,exports) {
/** PURE_IMPORTS_START _util_ArgumentOutOfRangeError,_filter,_throwIfEmpty,_defaultIfEmpty,_take PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "elementAt", ()=>elementAt);
var _argumentOutOfRangeError = require("../util/ArgumentOutOfRangeError");
var _filter = require("./filter");
var _throwIfEmpty = require("./throwIfEmpty");
var _defaultIfEmpty = require("./defaultIfEmpty");
var _take = require("./take");
function elementAt(index, defaultValue) {
    if (index < 0) throw new (0, _argumentOutOfRangeError.ArgumentOutOfRangeError)();
    var hasDefaultValue = arguments.length >= 2;
    return function(source) {
        return source.pipe((0, _filter.filter)(function(v, i) {
            return i === index;
        }), (0, _take.take)(1), hasDefaultValue ? (0, _defaultIfEmpty.defaultIfEmpty)(defaultValue) : (0, _throwIfEmpty.throwIfEmpty)(function() {
            return new (0, _argumentOutOfRangeError.ArgumentOutOfRangeError)();
        }));
    };
}

},{"../util/ArgumentOutOfRangeError":"38Gbx","./filter":"1uwXV","./throwIfEmpty":"3A9HT","./defaultIfEmpty":"1eMdN","./take":"jMzpW","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"3A9HT":[function(require,module,exports) {
/** PURE_IMPORTS_START tslib,_util_EmptyError,_Subscriber PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "throwIfEmpty", ()=>throwIfEmpty);
var _tslib = require("tslib");
var _emptyError = require("../util/EmptyError");
var _subscriber = require("../Subscriber");
function throwIfEmpty(errorFactory) {
    if (errorFactory === void 0) errorFactory = defaultErrorFactory;
    return function(source) {
        return source.lift(new ThrowIfEmptyOperator(errorFactory));
    };
}
var ThrowIfEmptyOperator = /*@__PURE__*/ function() {
    function ThrowIfEmptyOperator(errorFactory) {
        this.errorFactory = errorFactory;
    }
    ThrowIfEmptyOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new ThrowIfEmptySubscriber(subscriber, this.errorFactory));
    };
    return ThrowIfEmptyOperator;
}();
var ThrowIfEmptySubscriber = /*@__PURE__*/ function(_super) {
    _tslib.__extends(ThrowIfEmptySubscriber, _super);
    function ThrowIfEmptySubscriber(destination, errorFactory) {
        var _this = _super.call(this, destination) || this;
        _this.errorFactory = errorFactory;
        _this.hasValue = false;
        return _this;
    }
    ThrowIfEmptySubscriber.prototype._next = function(value) {
        this.hasValue = true;
        this.destination.next(value);
    };
    ThrowIfEmptySubscriber.prototype._complete = function() {
        if (!this.hasValue) {
            var err = void 0;
            try {
                err = this.errorFactory();
            } catch (e) {
                err = e;
            }
            this.destination.error(err);
        } else return this.destination.complete();
    };
    return ThrowIfEmptySubscriber;
}((0, _subscriber.Subscriber));
function defaultErrorFactory() {
    return new (0, _emptyError.EmptyError)();
}

},{"tslib":"kcqwq","../util/EmptyError":"7a4tA","../Subscriber":"jGx8F","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"jMzpW":[function(require,module,exports) {
/** PURE_IMPORTS_START tslib,_Subscriber,_util_ArgumentOutOfRangeError,_observable_empty PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "take", ()=>take);
var _tslib = require("tslib");
var _subscriber = require("../Subscriber");
var _argumentOutOfRangeError = require("../util/ArgumentOutOfRangeError");
var _empty = require("../observable/empty");
function take(count) {
    return function(source) {
        if (count === 0) return (0, _empty.empty)();
        else return source.lift(new TakeOperator(count));
    };
}
var TakeOperator = /*@__PURE__*/ function() {
    function TakeOperator(total) {
        this.total = total;
        if (this.total < 0) throw new (0, _argumentOutOfRangeError.ArgumentOutOfRangeError);
    }
    TakeOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new TakeSubscriber(subscriber, this.total));
    };
    return TakeOperator;
}();
var TakeSubscriber = /*@__PURE__*/ function(_super) {
    _tslib.__extends(TakeSubscriber, _super);
    function TakeSubscriber(destination, total) {
        var _this = _super.call(this, destination) || this;
        _this.total = total;
        _this.count = 0;
        return _this;
    }
    TakeSubscriber.prototype._next = function(value) {
        var total = this.total;
        var count = ++this.count;
        if (count <= total) {
            this.destination.next(value);
            if (count === total) {
                this.destination.complete();
                this.unsubscribe();
            }
        }
    };
    return TakeSubscriber;
}((0, _subscriber.Subscriber));

},{"tslib":"kcqwq","../Subscriber":"jGx8F","../util/ArgumentOutOfRangeError":"38Gbx","../observable/empty":"J4JDz","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4VxEc":[function(require,module,exports) {
/** PURE_IMPORTS_START _observable_concat,_observable_of PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "endWith", ()=>endWith);
var _concat = require("../observable/concat");
var _of = require("../observable/of");
function endWith() {
    var array = [];
    for(var _i = 0; _i < arguments.length; _i++)array[_i] = arguments[_i];
    return function(source) {
        return (0, _concat.concat)(source, (0, _of.of).apply(void 0, array));
    };
}

},{"../observable/concat":"2cXL0","../observable/of":"alTvf","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"dXibX":[function(require,module,exports) {
/** PURE_IMPORTS_START tslib,_Subscriber PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "every", ()=>every);
var _tslib = require("tslib");
var _subscriber = require("../Subscriber");
function every(predicate, thisArg) {
    return function(source) {
        return source.lift(new EveryOperator(predicate, thisArg, source));
    };
}
var EveryOperator = /*@__PURE__*/ function() {
    function EveryOperator(predicate, thisArg, source) {
        this.predicate = predicate;
        this.thisArg = thisArg;
        this.source = source;
    }
    EveryOperator.prototype.call = function(observer, source) {
        return source.subscribe(new EverySubscriber(observer, this.predicate, this.thisArg, this.source));
    };
    return EveryOperator;
}();
var EverySubscriber = /*@__PURE__*/ function(_super) {
    _tslib.__extends(EverySubscriber, _super);
    function EverySubscriber(destination, predicate, thisArg, source) {
        var _this = _super.call(this, destination) || this;
        _this.predicate = predicate;
        _this.thisArg = thisArg;
        _this.source = source;
        _this.index = 0;
        _this.thisArg = thisArg || _this;
        return _this;
    }
    EverySubscriber.prototype.notifyComplete = function(everyValueMatch) {
        this.destination.next(everyValueMatch);
        this.destination.complete();
    };
    EverySubscriber.prototype._next = function(value) {
        var result = false;
        try {
            result = this.predicate.call(this.thisArg, value, this.index++, this.source);
        } catch (err) {
            this.destination.error(err);
            return;
        }
        if (!result) this.notifyComplete(false);
    };
    EverySubscriber.prototype._complete = function() {
        this.notifyComplete(true);
    };
    return EverySubscriber;
}((0, _subscriber.Subscriber));

},{"tslib":"kcqwq","../Subscriber":"jGx8F","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4Ehtr":[function(require,module,exports) {
/** PURE_IMPORTS_START tslib,_innerSubscribe PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "exhaust", ()=>exhaust);
var _tslib = require("tslib");
var _innerSubscribe = require("../innerSubscribe");
function exhaust() {
    return function(source) {
        return source.lift(new SwitchFirstOperator());
    };
}
var SwitchFirstOperator = /*@__PURE__*/ function() {
    function SwitchFirstOperator() {}
    SwitchFirstOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new SwitchFirstSubscriber(subscriber));
    };
    return SwitchFirstOperator;
}();
var SwitchFirstSubscriber = /*@__PURE__*/ function(_super) {
    _tslib.__extends(SwitchFirstSubscriber, _super);
    function SwitchFirstSubscriber(destination) {
        var _this = _super.call(this, destination) || this;
        _this.hasCompleted = false;
        _this.hasSubscription = false;
        return _this;
    }
    SwitchFirstSubscriber.prototype._next = function(value) {
        if (!this.hasSubscription) {
            this.hasSubscription = true;
            this.add((0, _innerSubscribe.innerSubscribe)(value, new (0, _innerSubscribe.SimpleInnerSubscriber)(this)));
        }
    };
    SwitchFirstSubscriber.prototype._complete = function() {
        this.hasCompleted = true;
        if (!this.hasSubscription) this.destination.complete();
    };
    SwitchFirstSubscriber.prototype.notifyComplete = function() {
        this.hasSubscription = false;
        if (this.hasCompleted) this.destination.complete();
    };
    return SwitchFirstSubscriber;
}((0, _innerSubscribe.SimpleOuterSubscriber));

},{"tslib":"kcqwq","../innerSubscribe":"73frt","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2Xdls":[function(require,module,exports) {
/** PURE_IMPORTS_START tslib,_map,_observable_from,_innerSubscribe PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "exhaustMap", ()=>exhaustMap);
var _tslib = require("tslib");
var _map = require("./map");
var _from = require("../observable/from");
var _innerSubscribe = require("../innerSubscribe");
function exhaustMap(project, resultSelector) {
    if (resultSelector) return function(source) {
        return source.pipe(exhaustMap(function(a, i) {
            return (0, _from.from)(project(a, i)).pipe((0, _map.map)(function(b, ii) {
                return resultSelector(a, b, i, ii);
            }));
        }));
    };
    return function(source) {
        return source.lift(new ExhaustMapOperator(project));
    };
}
var ExhaustMapOperator = /*@__PURE__*/ function() {
    function ExhaustMapOperator(project) {
        this.project = project;
    }
    ExhaustMapOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new ExhaustMapSubscriber(subscriber, this.project));
    };
    return ExhaustMapOperator;
}();
var ExhaustMapSubscriber = /*@__PURE__*/ function(_super) {
    _tslib.__extends(ExhaustMapSubscriber, _super);
    function ExhaustMapSubscriber(destination, project) {
        var _this = _super.call(this, destination) || this;
        _this.project = project;
        _this.hasSubscription = false;
        _this.hasCompleted = false;
        _this.index = 0;
        return _this;
    }
    ExhaustMapSubscriber.prototype._next = function(value) {
        if (!this.hasSubscription) this.tryNext(value);
    };
    ExhaustMapSubscriber.prototype.tryNext = function(value) {
        var result;
        var index = this.index++;
        try {
            result = this.project(value, index);
        } catch (err) {
            this.destination.error(err);
            return;
        }
        this.hasSubscription = true;
        this._innerSub(result);
    };
    ExhaustMapSubscriber.prototype._innerSub = function(result) {
        var innerSubscriber = new (0, _innerSubscribe.SimpleInnerSubscriber)(this);
        var destination = this.destination;
        destination.add(innerSubscriber);
        var innerSubscription = (0, _innerSubscribe.innerSubscribe)(result, innerSubscriber);
        if (innerSubscription !== innerSubscriber) destination.add(innerSubscription);
    };
    ExhaustMapSubscriber.prototype._complete = function() {
        this.hasCompleted = true;
        if (!this.hasSubscription) this.destination.complete();
        this.unsubscribe();
    };
    ExhaustMapSubscriber.prototype.notifyNext = function(innerValue) {
        this.destination.next(innerValue);
    };
    ExhaustMapSubscriber.prototype.notifyError = function(err) {
        this.destination.error(err);
    };
    ExhaustMapSubscriber.prototype.notifyComplete = function() {
        this.hasSubscription = false;
        if (this.hasCompleted) this.destination.complete();
    };
    return ExhaustMapSubscriber;
}((0, _innerSubscribe.SimpleOuterSubscriber));

},{"tslib":"kcqwq","./map":"cvzfg","../observable/from":"6aqs0","../innerSubscribe":"73frt","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"3i3MM":[function(require,module,exports) {
/** PURE_IMPORTS_START tslib,_innerSubscribe PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "expand", ()=>expand);
parcelHelpers.export(exports, "ExpandOperator", ()=>ExpandOperator);
parcelHelpers.export(exports, "ExpandSubscriber", ()=>ExpandSubscriber);
var _tslib = require("tslib");
var _innerSubscribe = require("../innerSubscribe");
function expand(project, concurrent, scheduler) {
    if (concurrent === void 0) concurrent = Number.POSITIVE_INFINITY;
    concurrent = (concurrent || 0) < 1 ? Number.POSITIVE_INFINITY : concurrent;
    return function(source) {
        return source.lift(new ExpandOperator(project, concurrent, scheduler));
    };
}
var ExpandOperator = /*@__PURE__*/ function() {
    function ExpandOperator(project, concurrent, scheduler) {
        this.project = project;
        this.concurrent = concurrent;
        this.scheduler = scheduler;
    }
    ExpandOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new ExpandSubscriber(subscriber, this.project, this.concurrent, this.scheduler));
    };
    return ExpandOperator;
}();
var ExpandSubscriber = /*@__PURE__*/ function(_super) {
    _tslib.__extends(ExpandSubscriber, _super);
    function ExpandSubscriber(destination, project, concurrent, scheduler) {
        var _this = _super.call(this, destination) || this;
        _this.project = project;
        _this.concurrent = concurrent;
        _this.scheduler = scheduler;
        _this.index = 0;
        _this.active = 0;
        _this.hasCompleted = false;
        if (concurrent < Number.POSITIVE_INFINITY) _this.buffer = [];
        return _this;
    }
    ExpandSubscriber.dispatch = function(arg) {
        var subscriber = arg.subscriber, result = arg.result, value = arg.value, index = arg.index;
        subscriber.subscribeToProjection(result, value, index);
    };
    ExpandSubscriber.prototype._next = function(value) {
        var destination = this.destination;
        if (destination.closed) {
            this._complete();
            return;
        }
        var index = this.index++;
        if (this.active < this.concurrent) {
            destination.next(value);
            try {
                var project = this.project;
                var result = project(value, index);
                if (!this.scheduler) this.subscribeToProjection(result, value, index);
                else {
                    var state = {
                        subscriber: this,
                        result: result,
                        value: value,
                        index: index
                    };
                    var destination_1 = this.destination;
                    destination_1.add(this.scheduler.schedule(ExpandSubscriber.dispatch, 0, state));
                }
            } catch (e) {
                destination.error(e);
            }
        } else this.buffer.push(value);
    };
    ExpandSubscriber.prototype.subscribeToProjection = function(result, value, index) {
        this.active++;
        var destination = this.destination;
        destination.add((0, _innerSubscribe.innerSubscribe)(result, new (0, _innerSubscribe.SimpleInnerSubscriber)(this)));
    };
    ExpandSubscriber.prototype._complete = function() {
        this.hasCompleted = true;
        if (this.hasCompleted && this.active === 0) this.destination.complete();
        this.unsubscribe();
    };
    ExpandSubscriber.prototype.notifyNext = function(innerValue) {
        this._next(innerValue);
    };
    ExpandSubscriber.prototype.notifyComplete = function() {
        var buffer = this.buffer;
        this.active--;
        if (buffer && buffer.length > 0) this._next(buffer.shift());
        if (this.hasCompleted && this.active === 0) this.destination.complete();
    };
    return ExpandSubscriber;
}((0, _innerSubscribe.SimpleOuterSubscriber));

},{"tslib":"kcqwq","../innerSubscribe":"73frt","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"757w3":[function(require,module,exports) {
/** PURE_IMPORTS_START tslib,_Subscriber,_Subscription PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "finalize", ()=>finalize);
var _tslib = require("tslib");
var _subscriber = require("../Subscriber");
var _subscription = require("../Subscription");
function finalize(callback) {
    return function(source) {
        return source.lift(new FinallyOperator(callback));
    };
}
var FinallyOperator = /*@__PURE__*/ function() {
    function FinallyOperator(callback) {
        this.callback = callback;
    }
    FinallyOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new FinallySubscriber(subscriber, this.callback));
    };
    return FinallyOperator;
}();
var FinallySubscriber = /*@__PURE__*/ function(_super) {
    _tslib.__extends(FinallySubscriber, _super);
    function FinallySubscriber(destination, callback) {
        var _this = _super.call(this, destination) || this;
        _this.add(new (0, _subscription.Subscription)(callback));
        return _this;
    }
    return FinallySubscriber;
}((0, _subscriber.Subscriber));

},{"tslib":"kcqwq","../Subscriber":"jGx8F","../Subscription":"ahthJ","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7WaV6":[function(require,module,exports) {
/** PURE_IMPORTS_START tslib,_Subscriber PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "find", ()=>find);
parcelHelpers.export(exports, "FindValueOperator", ()=>FindValueOperator);
parcelHelpers.export(exports, "FindValueSubscriber", ()=>FindValueSubscriber);
var _tslib = require("tslib");
var _subscriber = require("../Subscriber");
function find(predicate, thisArg) {
    if (typeof predicate !== "function") throw new TypeError("predicate is not a function");
    return function(source) {
        return source.lift(new FindValueOperator(predicate, source, false, thisArg));
    };
}
var FindValueOperator = /*@__PURE__*/ function() {
    function FindValueOperator(predicate, source, yieldIndex, thisArg) {
        this.predicate = predicate;
        this.source = source;
        this.yieldIndex = yieldIndex;
        this.thisArg = thisArg;
    }
    FindValueOperator.prototype.call = function(observer, source) {
        return source.subscribe(new FindValueSubscriber(observer, this.predicate, this.source, this.yieldIndex, this.thisArg));
    };
    return FindValueOperator;
}();
var FindValueSubscriber = /*@__PURE__*/ function(_super) {
    _tslib.__extends(FindValueSubscriber, _super);
    function FindValueSubscriber(destination, predicate, source, yieldIndex, thisArg) {
        var _this = _super.call(this, destination) || this;
        _this.predicate = predicate;
        _this.source = source;
        _this.yieldIndex = yieldIndex;
        _this.thisArg = thisArg;
        _this.index = 0;
        return _this;
    }
    FindValueSubscriber.prototype.notifyComplete = function(value) {
        var destination = this.destination;
        destination.next(value);
        destination.complete();
        this.unsubscribe();
    };
    FindValueSubscriber.prototype._next = function(value) {
        var _a = this, predicate = _a.predicate, thisArg = _a.thisArg;
        var index = this.index++;
        try {
            var result = predicate.call(thisArg || this, value, index, this.source);
            if (result) this.notifyComplete(this.yieldIndex ? index : value);
        } catch (err) {
            this.destination.error(err);
        }
    };
    FindValueSubscriber.prototype._complete = function() {
        this.notifyComplete(this.yieldIndex ? -1 : undefined);
    };
    return FindValueSubscriber;
}((0, _subscriber.Subscriber));

},{"tslib":"kcqwq","../Subscriber":"jGx8F","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9qcAF":[function(require,module,exports) {
/** PURE_IMPORTS_START _operators_find PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "findIndex", ()=>findIndex);
var _find = require("../operators/find");
function findIndex(predicate, thisArg) {
    return function(source) {
        return source.lift(new (0, _find.FindValueOperator)(predicate, source, true, thisArg));
    };
}

},{"../operators/find":"7WaV6","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"eGELz":[function(require,module,exports) {
/** PURE_IMPORTS_START _util_EmptyError,_filter,_take,_defaultIfEmpty,_throwIfEmpty,_util_identity PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "first", ()=>first);
var _emptyError = require("../util/EmptyError");
var _filter = require("./filter");
var _take = require("./take");
var _defaultIfEmpty = require("./defaultIfEmpty");
var _throwIfEmpty = require("./throwIfEmpty");
var _identity = require("../util/identity");
function first(predicate, defaultValue) {
    var hasDefaultValue = arguments.length >= 2;
    return function(source) {
        return source.pipe(predicate ? (0, _filter.filter)(function(v, i) {
            return predicate(v, i, source);
        }) : (0, _identity.identity), (0, _take.take)(1), hasDefaultValue ? (0, _defaultIfEmpty.defaultIfEmpty)(defaultValue) : (0, _throwIfEmpty.throwIfEmpty)(function() {
            return new (0, _emptyError.EmptyError)();
        }));
    };
}

},{"../util/EmptyError":"7a4tA","./filter":"1uwXV","./take":"jMzpW","./defaultIfEmpty":"1eMdN","./throwIfEmpty":"3A9HT","../util/identity":"kDT9y","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"ckr01":[function(require,module,exports) {
/** PURE_IMPORTS_START tslib,_Subscriber PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ignoreElements", ()=>ignoreElements);
var _tslib = require("tslib");
var _subscriber = require("../Subscriber");
function ignoreElements() {
    return function ignoreElementsOperatorFunction(source) {
        return source.lift(new IgnoreElementsOperator());
    };
}
var IgnoreElementsOperator = /*@__PURE__*/ function() {
    function IgnoreElementsOperator() {}
    IgnoreElementsOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new IgnoreElementsSubscriber(subscriber));
    };
    return IgnoreElementsOperator;
}();
var IgnoreElementsSubscriber = /*@__PURE__*/ function(_super) {
    _tslib.__extends(IgnoreElementsSubscriber, _super);
    function IgnoreElementsSubscriber() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    IgnoreElementsSubscriber.prototype._next = function(unused) {};
    return IgnoreElementsSubscriber;
}((0, _subscriber.Subscriber));

},{"tslib":"kcqwq","../Subscriber":"jGx8F","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"b6CBY":[function(require,module,exports) {
/** PURE_IMPORTS_START tslib,_Subscriber PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isEmpty", ()=>isEmpty);
var _tslib = require("tslib");
var _subscriber = require("../Subscriber");
function isEmpty() {
    return function(source) {
        return source.lift(new IsEmptyOperator());
    };
}
var IsEmptyOperator = /*@__PURE__*/ function() {
    function IsEmptyOperator() {}
    IsEmptyOperator.prototype.call = function(observer, source) {
        return source.subscribe(new IsEmptySubscriber(observer));
    };
    return IsEmptyOperator;
}();
var IsEmptySubscriber = /*@__PURE__*/ function(_super) {
    _tslib.__extends(IsEmptySubscriber, _super);
    function IsEmptySubscriber(destination) {
        return _super.call(this, destination) || this;
    }
    IsEmptySubscriber.prototype.notifyComplete = function(isEmpty) {
        var destination = this.destination;
        destination.next(isEmpty);
        destination.complete();
    };
    IsEmptySubscriber.prototype._next = function(value) {
        this.notifyComplete(false);
    };
    IsEmptySubscriber.prototype._complete = function() {
        this.notifyComplete(true);
    };
    return IsEmptySubscriber;
}((0, _subscriber.Subscriber));

},{"tslib":"kcqwq","../Subscriber":"jGx8F","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2oVKC":[function(require,module,exports) {
/** PURE_IMPORTS_START _util_EmptyError,_filter,_takeLast,_throwIfEmpty,_defaultIfEmpty,_util_identity PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "last", ()=>last);
var _emptyError = require("../util/EmptyError");
var _filter = require("./filter");
var _takeLast = require("./takeLast");
var _throwIfEmpty = require("./throwIfEmpty");
var _defaultIfEmpty = require("./defaultIfEmpty");
var _identity = require("../util/identity");
function last(predicate, defaultValue) {
    var hasDefaultValue = arguments.length >= 2;
    return function(source) {
        return source.pipe(predicate ? (0, _filter.filter)(function(v, i) {
            return predicate(v, i, source);
        }) : (0, _identity.identity), (0, _takeLast.takeLast)(1), hasDefaultValue ? (0, _defaultIfEmpty.defaultIfEmpty)(defaultValue) : (0, _throwIfEmpty.throwIfEmpty)(function() {
            return new (0, _emptyError.EmptyError)();
        }));
    };
}

},{"../util/EmptyError":"7a4tA","./filter":"1uwXV","./takeLast":"21udE","./throwIfEmpty":"3A9HT","./defaultIfEmpty":"1eMdN","../util/identity":"kDT9y","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"21udE":[function(require,module,exports) {
/** PURE_IMPORTS_START tslib,_Subscriber,_util_ArgumentOutOfRangeError,_observable_empty PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "takeLast", ()=>takeLast);
var _tslib = require("tslib");
var _subscriber = require("../Subscriber");
var _argumentOutOfRangeError = require("../util/ArgumentOutOfRangeError");
var _empty = require("../observable/empty");
function takeLast(count) {
    return function takeLastOperatorFunction(source) {
        if (count === 0) return (0, _empty.empty)();
        else return source.lift(new TakeLastOperator(count));
    };
}
var TakeLastOperator = /*@__PURE__*/ function() {
    function TakeLastOperator(total) {
        this.total = total;
        if (this.total < 0) throw new (0, _argumentOutOfRangeError.ArgumentOutOfRangeError);
    }
    TakeLastOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new TakeLastSubscriber(subscriber, this.total));
    };
    return TakeLastOperator;
}();
var TakeLastSubscriber = /*@__PURE__*/ function(_super) {
    _tslib.__extends(TakeLastSubscriber, _super);
    function TakeLastSubscriber(destination, total) {
        var _this = _super.call(this, destination) || this;
        _this.total = total;
        _this.ring = new Array();
        _this.count = 0;
        return _this;
    }
    TakeLastSubscriber.prototype._next = function(value) {
        var ring = this.ring;
        var total = this.total;
        var count = this.count++;
        if (ring.length < total) ring.push(value);
        else {
            var index = count % total;
            ring[index] = value;
        }
    };
    TakeLastSubscriber.prototype._complete = function() {
        var destination = this.destination;
        var count = this.count;
        if (count > 0) {
            var total = this.count >= this.total ? this.total : this.count;
            var ring = this.ring;
            for(var i = 0; i < total; i++){
                var idx = count++ % total;
                destination.next(ring[idx]);
            }
        }
        destination.complete();
    };
    return TakeLastSubscriber;
}((0, _subscriber.Subscriber));

},{"tslib":"kcqwq","../Subscriber":"jGx8F","../util/ArgumentOutOfRangeError":"38Gbx","../observable/empty":"J4JDz","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"39msm":[function(require,module,exports) {
/** PURE_IMPORTS_START tslib,_Subscriber PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "mapTo", ()=>mapTo);
var _tslib = require("tslib");
var _subscriber = require("../Subscriber");
function mapTo(value) {
    return function(source) {
        return source.lift(new MapToOperator(value));
    };
}
var MapToOperator = /*@__PURE__*/ function() {
    function MapToOperator(value) {
        this.value = value;
    }
    MapToOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new MapToSubscriber(subscriber, this.value));
    };
    return MapToOperator;
}();
var MapToSubscriber = /*@__PURE__*/ function(_super) {
    _tslib.__extends(MapToSubscriber, _super);
    function MapToSubscriber(destination, value) {
        var _this = _super.call(this, destination) || this;
        _this.value = value;
        return _this;
    }
    MapToSubscriber.prototype._next = function(x) {
        this.destination.next(this.value);
    };
    return MapToSubscriber;
}((0, _subscriber.Subscriber));

},{"tslib":"kcqwq","../Subscriber":"jGx8F","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"aXm7q":[function(require,module,exports) {
/** PURE_IMPORTS_START tslib,_Subscriber,_Notification PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "materialize", ()=>materialize);
var _tslib = require("tslib");
var _subscriber = require("../Subscriber");
var _notification = require("../Notification");
function materialize() {
    return function materializeOperatorFunction(source) {
        return source.lift(new MaterializeOperator());
    };
}
var MaterializeOperator = /*@__PURE__*/ function() {
    function MaterializeOperator() {}
    MaterializeOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new MaterializeSubscriber(subscriber));
    };
    return MaterializeOperator;
}();
var MaterializeSubscriber = /*@__PURE__*/ function(_super) {
    _tslib.__extends(MaterializeSubscriber, _super);
    function MaterializeSubscriber(destination) {
        return _super.call(this, destination) || this;
    }
    MaterializeSubscriber.prototype._next = function(value) {
        this.destination.next((0, _notification.Notification).createNext(value));
    };
    MaterializeSubscriber.prototype._error = function(err) {
        var destination = this.destination;
        destination.next((0, _notification.Notification).createError(err));
        destination.complete();
    };
    MaterializeSubscriber.prototype._complete = function() {
        var destination = this.destination;
        destination.next((0, _notification.Notification).createComplete());
        destination.complete();
    };
    return MaterializeSubscriber;
}((0, _subscriber.Subscriber));

},{"tslib":"kcqwq","../Subscriber":"jGx8F","../Notification":"3c26n","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9VIwB":[function(require,module,exports) {
/** PURE_IMPORTS_START _reduce PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "max", ()=>max);
var _reduce = require("./reduce");
function max(comparer) {
    var max = typeof comparer === "function" ? function(x, y) {
        return comparer(x, y) > 0 ? x : y;
    } : function(x, y) {
        return x > y ? x : y;
    };
    return (0, _reduce.reduce)(max);
}

},{"./reduce":"8LzQg","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8LzQg":[function(require,module,exports) {
/** PURE_IMPORTS_START _scan,_takeLast,_defaultIfEmpty,_util_pipe PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "reduce", ()=>reduce);
var _scan = require("./scan");
var _takeLast = require("./takeLast");
var _defaultIfEmpty = require("./defaultIfEmpty");
var _pipe = require("../util/pipe");
function reduce(accumulator, seed) {
    if (arguments.length >= 2) return function reduceOperatorFunctionWithSeed(source) {
        return (0, _pipe.pipe)((0, _scan.scan)(accumulator, seed), (0, _takeLast.takeLast)(1), (0, _defaultIfEmpty.defaultIfEmpty)(seed))(source);
    };
    return function reduceOperatorFunction(source) {
        return (0, _pipe.pipe)((0, _scan.scan)(function(acc, value, index) {
            return accumulator(acc, value, index + 1);
        }), (0, _takeLast.takeLast)(1))(source);
    };
}

},{"./scan":"hX6nA","./takeLast":"21udE","./defaultIfEmpty":"1eMdN","../util/pipe":"4asJs","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"hX6nA":[function(require,module,exports) {
/** PURE_IMPORTS_START tslib,_Subscriber PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "scan", ()=>scan);
var _tslib = require("tslib");
var _subscriber = require("../Subscriber");
function scan(accumulator, seed) {
    var hasSeed = false;
    if (arguments.length >= 2) hasSeed = true;
    return function scanOperatorFunction(source) {
        return source.lift(new ScanOperator(accumulator, seed, hasSeed));
    };
}
var ScanOperator = /*@__PURE__*/ function() {
    function ScanOperator(accumulator, seed, hasSeed) {
        if (hasSeed === void 0) hasSeed = false;
        this.accumulator = accumulator;
        this.seed = seed;
        this.hasSeed = hasSeed;
    }
    ScanOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new ScanSubscriber(subscriber, this.accumulator, this.seed, this.hasSeed));
    };
    return ScanOperator;
}();
var ScanSubscriber = /*@__PURE__*/ function(_super) {
    _tslib.__extends(ScanSubscriber, _super);
    function ScanSubscriber(destination, accumulator, _seed, hasSeed) {
        var _this = _super.call(this, destination) || this;
        _this.accumulator = accumulator;
        _this._seed = _seed;
        _this.hasSeed = hasSeed;
        _this.index = 0;
        return _this;
    }
    Object.defineProperty(ScanSubscriber.prototype, "seed", {
        get: function() {
            return this._seed;
        },
        set: function(value) {
            this.hasSeed = true;
            this._seed = value;
        },
        enumerable: true,
        configurable: true
    });
    ScanSubscriber.prototype._next = function(value) {
        if (!this.hasSeed) {
            this.seed = value;
            this.destination.next(value);
        } else return this._tryNext(value);
    };
    ScanSubscriber.prototype._tryNext = function(value) {
        var index = this.index++;
        var result;
        try {
            result = this.accumulator(this.seed, value, index);
        } catch (err) {
            this.destination.error(err);
        }
        this.seed = result;
        this.destination.next(result);
    };
    return ScanSubscriber;
}((0, _subscriber.Subscriber));

},{"tslib":"kcqwq","../Subscriber":"jGx8F","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9GXnX":[function(require,module,exports) {
/** PURE_IMPORTS_START _observable_merge PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "merge", ()=>merge);
var _merge = require("../observable/merge");
function merge() {
    var observables = [];
    for(var _i = 0; _i < arguments.length; _i++)observables[_i] = arguments[_i];
    return function(source) {
        return source.lift.call((0, _merge.merge).apply(void 0, [
            source
        ].concat(observables)));
    };
}

},{"../observable/merge":"38GKY","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"lm8sA":[function(require,module,exports) {
/** PURE_IMPORTS_START _mergeMap PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "mergeMapTo", ()=>mergeMapTo);
var _mergeMap = require("./mergeMap");
function mergeMapTo(innerObservable, resultSelector, concurrent) {
    if (concurrent === void 0) concurrent = Number.POSITIVE_INFINITY;
    if (typeof resultSelector === "function") return (0, _mergeMap.mergeMap)(function() {
        return innerObservable;
    }, resultSelector, concurrent);
    if (typeof resultSelector === "number") concurrent = resultSelector;
    return (0, _mergeMap.mergeMap)(function() {
        return innerObservable;
    }, concurrent);
}

},{"./mergeMap":"7NAZz","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8odnE":[function(require,module,exports) {
/** PURE_IMPORTS_START tslib,_innerSubscribe PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "mergeScan", ()=>mergeScan);
parcelHelpers.export(exports, "MergeScanOperator", ()=>MergeScanOperator);
parcelHelpers.export(exports, "MergeScanSubscriber", ()=>MergeScanSubscriber);
var _tslib = require("tslib");
var _innerSubscribe = require("../innerSubscribe");
function mergeScan(accumulator, seed, concurrent) {
    if (concurrent === void 0) concurrent = Number.POSITIVE_INFINITY;
    return function(source) {
        return source.lift(new MergeScanOperator(accumulator, seed, concurrent));
    };
}
var MergeScanOperator = /*@__PURE__*/ function() {
    function MergeScanOperator(accumulator, seed, concurrent) {
        this.accumulator = accumulator;
        this.seed = seed;
        this.concurrent = concurrent;
    }
    MergeScanOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new MergeScanSubscriber(subscriber, this.accumulator, this.seed, this.concurrent));
    };
    return MergeScanOperator;
}();
var MergeScanSubscriber = /*@__PURE__*/ function(_super) {
    _tslib.__extends(MergeScanSubscriber, _super);
    function MergeScanSubscriber(destination, accumulator, acc, concurrent) {
        var _this = _super.call(this, destination) || this;
        _this.accumulator = accumulator;
        _this.acc = acc;
        _this.concurrent = concurrent;
        _this.hasValue = false;
        _this.hasCompleted = false;
        _this.buffer = [];
        _this.active = 0;
        _this.index = 0;
        return _this;
    }
    MergeScanSubscriber.prototype._next = function(value) {
        if (this.active < this.concurrent) {
            var index = this.index++;
            var destination = this.destination;
            var ish = void 0;
            try {
                var accumulator = this.accumulator;
                ish = accumulator(this.acc, value, index);
            } catch (e) {
                return destination.error(e);
            }
            this.active++;
            this._innerSub(ish);
        } else this.buffer.push(value);
    };
    MergeScanSubscriber.prototype._innerSub = function(ish) {
        var innerSubscriber = new (0, _innerSubscribe.SimpleInnerSubscriber)(this);
        var destination = this.destination;
        destination.add(innerSubscriber);
        var innerSubscription = (0, _innerSubscribe.innerSubscribe)(ish, innerSubscriber);
        if (innerSubscription !== innerSubscriber) destination.add(innerSubscription);
    };
    MergeScanSubscriber.prototype._complete = function() {
        this.hasCompleted = true;
        if (this.active === 0 && this.buffer.length === 0) {
            if (this.hasValue === false) this.destination.next(this.acc);
            this.destination.complete();
        }
        this.unsubscribe();
    };
    MergeScanSubscriber.prototype.notifyNext = function(innerValue) {
        var destination = this.destination;
        this.acc = innerValue;
        this.hasValue = true;
        destination.next(innerValue);
    };
    MergeScanSubscriber.prototype.notifyComplete = function() {
        var buffer = this.buffer;
        this.active--;
        if (buffer.length > 0) this._next(buffer.shift());
        else if (this.active === 0 && this.hasCompleted) {
            if (this.hasValue === false) this.destination.next(this.acc);
            this.destination.complete();
        }
    };
    return MergeScanSubscriber;
}((0, _innerSubscribe.SimpleOuterSubscriber));

},{"tslib":"kcqwq","../innerSubscribe":"73frt","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"eIMaq":[function(require,module,exports) {
/** PURE_IMPORTS_START _reduce PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "min", ()=>min);
var _reduce = require("./reduce");
function min(comparer) {
    var min = typeof comparer === "function" ? function(x, y) {
        return comparer(x, y) < 0 ? x : y;
    } : function(x, y) {
        return x < y ? x : y;
    };
    return (0, _reduce.reduce)(min);
}

},{"./reduce":"8LzQg","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"GLY7l":[function(require,module,exports) {
/** PURE_IMPORTS_START _observable_ConnectableObservable PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "multicast", ()=>multicast);
parcelHelpers.export(exports, "MulticastOperator", ()=>MulticastOperator);
var _connectableObservable = require("../observable/ConnectableObservable");
function multicast(subjectOrSubjectFactory, selector) {
    return function multicastOperatorFunction(source) {
        var subjectFactory;
        if (typeof subjectOrSubjectFactory === "function") subjectFactory = subjectOrSubjectFactory;
        else subjectFactory = function subjectFactory() {
            return subjectOrSubjectFactory;
        };
        if (typeof selector === "function") return source.lift(new MulticastOperator(subjectFactory, selector));
        var connectable = Object.create(source, (0, _connectableObservable.connectableObservableDescriptor));
        connectable.source = source;
        connectable.subjectFactory = subjectFactory;
        return connectable;
    };
}
var MulticastOperator = /*@__PURE__*/ function() {
    function MulticastOperator(subjectFactory, selector) {
        this.subjectFactory = subjectFactory;
        this.selector = selector;
    }
    MulticastOperator.prototype.call = function(subscriber, source) {
        var selector = this.selector;
        var subject = this.subjectFactory();
        var subscription = selector(subject).subscribe(subscriber);
        subscription.add(source.subscribe(subject));
        return subscription;
    };
    return MulticastOperator;
}();

},{"../observable/ConnectableObservable":"f4mOY","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"1lwYl":[function(require,module,exports) {
/** PURE_IMPORTS_START tslib,_observable_from,_util_isArray,_innerSubscribe PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "onErrorResumeNext", ()=>onErrorResumeNext);
parcelHelpers.export(exports, "onErrorResumeNextStatic", ()=>onErrorResumeNextStatic);
var _tslib = require("tslib");
var _from = require("../observable/from");
var _isArray = require("../util/isArray");
var _innerSubscribe = require("../innerSubscribe");
function onErrorResumeNext() {
    var nextSources = [];
    for(var _i = 0; _i < arguments.length; _i++)nextSources[_i] = arguments[_i];
    if (nextSources.length === 1 && (0, _isArray.isArray)(nextSources[0])) nextSources = nextSources[0];
    return function(source) {
        return source.lift(new OnErrorResumeNextOperator(nextSources));
    };
}
function onErrorResumeNextStatic() {
    var nextSources = [];
    for(var _i = 0; _i < arguments.length; _i++)nextSources[_i] = arguments[_i];
    var source = undefined;
    if (nextSources.length === 1 && (0, _isArray.isArray)(nextSources[0])) nextSources = nextSources[0];
    source = nextSources.shift();
    return (0, _from.from)(source).lift(new OnErrorResumeNextOperator(nextSources));
}
var OnErrorResumeNextOperator = /*@__PURE__*/ function() {
    function OnErrorResumeNextOperator(nextSources) {
        this.nextSources = nextSources;
    }
    OnErrorResumeNextOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new OnErrorResumeNextSubscriber(subscriber, this.nextSources));
    };
    return OnErrorResumeNextOperator;
}();
var OnErrorResumeNextSubscriber = /*@__PURE__*/ function(_super) {
    _tslib.__extends(OnErrorResumeNextSubscriber, _super);
    function OnErrorResumeNextSubscriber(destination, nextSources) {
        var _this = _super.call(this, destination) || this;
        _this.destination = destination;
        _this.nextSources = nextSources;
        return _this;
    }
    OnErrorResumeNextSubscriber.prototype.notifyError = function() {
        this.subscribeToNextSource();
    };
    OnErrorResumeNextSubscriber.prototype.notifyComplete = function() {
        this.subscribeToNextSource();
    };
    OnErrorResumeNextSubscriber.prototype._error = function(err) {
        this.subscribeToNextSource();
        this.unsubscribe();
    };
    OnErrorResumeNextSubscriber.prototype._complete = function() {
        this.subscribeToNextSource();
        this.unsubscribe();
    };
    OnErrorResumeNextSubscriber.prototype.subscribeToNextSource = function() {
        var next = this.nextSources.shift();
        if (!!next) {
            var innerSubscriber = new (0, _innerSubscribe.SimpleInnerSubscriber)(this);
            var destination = this.destination;
            destination.add(innerSubscriber);
            var innerSubscription = (0, _innerSubscribe.innerSubscribe)(next, innerSubscriber);
            if (innerSubscription !== innerSubscriber) destination.add(innerSubscription);
        } else this.destination.complete();
    };
    return OnErrorResumeNextSubscriber;
}((0, _innerSubscribe.SimpleOuterSubscriber));

},{"tslib":"kcqwq","../observable/from":"6aqs0","../util/isArray":"2HaTi","../innerSubscribe":"73frt","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"hAUti":[function(require,module,exports) {
/** PURE_IMPORTS_START tslib,_Subscriber PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "pairwise", ()=>pairwise);
var _tslib = require("tslib");
var _subscriber = require("../Subscriber");
function pairwise() {
    return function(source) {
        return source.lift(new PairwiseOperator());
    };
}
var PairwiseOperator = /*@__PURE__*/ function() {
    function PairwiseOperator() {}
    PairwiseOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new PairwiseSubscriber(subscriber));
    };
    return PairwiseOperator;
}();
var PairwiseSubscriber = /*@__PURE__*/ function(_super) {
    _tslib.__extends(PairwiseSubscriber, _super);
    function PairwiseSubscriber(destination) {
        var _this = _super.call(this, destination) || this;
        _this.hasPrev = false;
        return _this;
    }
    PairwiseSubscriber.prototype._next = function(value) {
        var pair;
        if (this.hasPrev) pair = [
            this.prev,
            value
        ];
        else this.hasPrev = true;
        this.prev = value;
        if (pair) this.destination.next(pair);
    };
    return PairwiseSubscriber;
}((0, _subscriber.Subscriber));

},{"tslib":"kcqwq","../Subscriber":"jGx8F","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"51UVV":[function(require,module,exports) {
/** PURE_IMPORTS_START _util_not,_filter PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "partition", ()=>partition);
var _not = require("../util/not");
var _filter = require("./filter");
function partition(predicate, thisArg) {
    return function(source) {
        return [
            (0, _filter.filter)(predicate, thisArg)(source),
            (0, _filter.filter)((0, _not.not)(predicate, thisArg))(source)
        ];
    };
}

},{"../util/not":"6oUZX","./filter":"1uwXV","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"enRwh":[function(require,module,exports) {
/** PURE_IMPORTS_START _map PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "pluck", ()=>pluck);
var _map = require("./map");
function pluck() {
    var properties = [];
    for(var _i = 0; _i < arguments.length; _i++)properties[_i] = arguments[_i];
    var length = properties.length;
    if (length === 0) throw new Error("list of properties cannot be empty.");
    return function(source) {
        return (0, _map.map)(plucker(properties, length))(source);
    };
}
function plucker(props, length) {
    var mapper = function(x) {
        var currentProp = x;
        for(var i = 0; i < length; i++){
            var p = currentProp != null ? currentProp[props[i]] : undefined;
            if (p !== void 0) currentProp = p;
            else return undefined;
        }
        return currentProp;
    };
    return mapper;
}

},{"./map":"cvzfg","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"eqLc5":[function(require,module,exports) {
/** PURE_IMPORTS_START _Subject,_multicast PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "publish", ()=>publish);
var _subject = require("../Subject");
var _multicast = require("./multicast");
function publish(selector) {
    return selector ? (0, _multicast.multicast)(function() {
        return new (0, _subject.Subject)();
    }, selector) : (0, _multicast.multicast)(new (0, _subject.Subject)());
}

},{"../Subject":"84bef","./multicast":"GLY7l","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"aC28n":[function(require,module,exports) {
/** PURE_IMPORTS_START _BehaviorSubject,_multicast PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "publishBehavior", ()=>publishBehavior);
var _behaviorSubject = require("../BehaviorSubject");
var _multicast = require("./multicast");
function publishBehavior(value) {
    return function(source) {
        return (0, _multicast.multicast)(new (0, _behaviorSubject.BehaviorSubject)(value))(source);
    };
}

},{"../BehaviorSubject":"anOW9","./multicast":"GLY7l","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"aqjv1":[function(require,module,exports) {
/** PURE_IMPORTS_START _AsyncSubject,_multicast PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "publishLast", ()=>publishLast);
var _asyncSubject = require("../AsyncSubject");
var _multicast = require("./multicast");
function publishLast() {
    return function(source) {
        return (0, _multicast.multicast)(new (0, _asyncSubject.AsyncSubject)())(source);
    };
}

},{"../AsyncSubject":"6P7LP","./multicast":"GLY7l","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2pe5R":[function(require,module,exports) {
/** PURE_IMPORTS_START _ReplaySubject,_multicast PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "publishReplay", ()=>publishReplay);
var _replaySubject = require("../ReplaySubject");
var _multicast = require("./multicast");
function publishReplay(bufferSize, windowTime, selectorOrScheduler, scheduler) {
    if (selectorOrScheduler && typeof selectorOrScheduler !== "function") scheduler = selectorOrScheduler;
    var selector = typeof selectorOrScheduler === "function" ? selectorOrScheduler : undefined;
    var subject = new (0, _replaySubject.ReplaySubject)(bufferSize, windowTime, scheduler);
    return function(source) {
        return (0, _multicast.multicast)(function() {
            return subject;
        }, selector)(source);
    };
}

},{"../ReplaySubject":"gRMu9","./multicast":"GLY7l","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"3Gd59":[function(require,module,exports) {
/** PURE_IMPORTS_START _util_isArray,_observable_race PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "race", ()=>race);
var _isArray = require("../util/isArray");
var _race = require("../observable/race");
function race() {
    var observables = [];
    for(var _i = 0; _i < arguments.length; _i++)observables[_i] = arguments[_i];
    return function raceOperatorFunction(source) {
        if (observables.length === 1 && (0, _isArray.isArray)(observables[0])) observables = observables[0];
        return source.lift.call((0, _race.race).apply(void 0, [
            source
        ].concat(observables)));
    };
}

},{"../util/isArray":"2HaTi","../observable/race":"6YL9k","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7VXQV":[function(require,module,exports) {
/** PURE_IMPORTS_START tslib,_Subscriber,_observable_empty PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "repeat", ()=>repeat);
var _tslib = require("tslib");
var _subscriber = require("../Subscriber");
var _empty = require("../observable/empty");
function repeat(count) {
    if (count === void 0) count = -1;
    return function(source) {
        if (count === 0) return (0, _empty.empty)();
        else if (count < 0) return source.lift(new RepeatOperator(-1, source));
        else return source.lift(new RepeatOperator(count - 1, source));
    };
}
var RepeatOperator = /*@__PURE__*/ function() {
    function RepeatOperator(count, source) {
        this.count = count;
        this.source = source;
    }
    RepeatOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new RepeatSubscriber(subscriber, this.count, this.source));
    };
    return RepeatOperator;
}();
var RepeatSubscriber = /*@__PURE__*/ function(_super) {
    _tslib.__extends(RepeatSubscriber, _super);
    function RepeatSubscriber(destination, count, source) {
        var _this = _super.call(this, destination) || this;
        _this.count = count;
        _this.source = source;
        return _this;
    }
    RepeatSubscriber.prototype.complete = function() {
        if (!this.isStopped) {
            var _a = this, source = _a.source, count = _a.count;
            if (count === 0) return _super.prototype.complete.call(this);
            else if (count > -1) this.count = count - 1;
            source.subscribe(this._unsubscribeAndRecycle());
        }
    };
    return RepeatSubscriber;
}((0, _subscriber.Subscriber));

},{"tslib":"kcqwq","../Subscriber":"jGx8F","../observable/empty":"J4JDz","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2wa5h":[function(require,module,exports) {
/** PURE_IMPORTS_START tslib,_Subject,_innerSubscribe PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "repeatWhen", ()=>repeatWhen);
var _tslib = require("tslib");
var _subject = require("../Subject");
var _innerSubscribe = require("../innerSubscribe");
function repeatWhen(notifier) {
    return function(source) {
        return source.lift(new RepeatWhenOperator(notifier));
    };
}
var RepeatWhenOperator = /*@__PURE__*/ function() {
    function RepeatWhenOperator(notifier) {
        this.notifier = notifier;
    }
    RepeatWhenOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new RepeatWhenSubscriber(subscriber, this.notifier, source));
    };
    return RepeatWhenOperator;
}();
var RepeatWhenSubscriber = /*@__PURE__*/ function(_super) {
    _tslib.__extends(RepeatWhenSubscriber, _super);
    function RepeatWhenSubscriber(destination, notifier, source) {
        var _this = _super.call(this, destination) || this;
        _this.notifier = notifier;
        _this.source = source;
        _this.sourceIsBeingSubscribedTo = true;
        return _this;
    }
    RepeatWhenSubscriber.prototype.notifyNext = function() {
        this.sourceIsBeingSubscribedTo = true;
        this.source.subscribe(this);
    };
    RepeatWhenSubscriber.prototype.notifyComplete = function() {
        if (this.sourceIsBeingSubscribedTo === false) return _super.prototype.complete.call(this);
    };
    RepeatWhenSubscriber.prototype.complete = function() {
        this.sourceIsBeingSubscribedTo = false;
        if (!this.isStopped) {
            if (!this.retries) this.subscribeToRetries();
            if (!this.retriesSubscription || this.retriesSubscription.closed) return _super.prototype.complete.call(this);
            this._unsubscribeAndRecycle();
            this.notifications.next(undefined);
        }
    };
    RepeatWhenSubscriber.prototype._unsubscribe = function() {
        var _a = this, notifications = _a.notifications, retriesSubscription = _a.retriesSubscription;
        if (notifications) {
            notifications.unsubscribe();
            this.notifications = undefined;
        }
        if (retriesSubscription) {
            retriesSubscription.unsubscribe();
            this.retriesSubscription = undefined;
        }
        this.retries = undefined;
    };
    RepeatWhenSubscriber.prototype._unsubscribeAndRecycle = function() {
        var _unsubscribe = this._unsubscribe;
        this._unsubscribe = null;
        _super.prototype._unsubscribeAndRecycle.call(this);
        this._unsubscribe = _unsubscribe;
        return this;
    };
    RepeatWhenSubscriber.prototype.subscribeToRetries = function() {
        this.notifications = new (0, _subject.Subject)();
        var retries;
        try {
            var notifier = this.notifier;
            retries = notifier(this.notifications);
        } catch (e) {
            return _super.prototype.complete.call(this);
        }
        this.retries = retries;
        this.retriesSubscription = (0, _innerSubscribe.innerSubscribe)(retries, new (0, _innerSubscribe.SimpleInnerSubscriber)(this));
    };
    return RepeatWhenSubscriber;
}((0, _innerSubscribe.SimpleOuterSubscriber));

},{"tslib":"kcqwq","../Subject":"84bef","../innerSubscribe":"73frt","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"jiZ39":[function(require,module,exports) {
/** PURE_IMPORTS_START tslib,_Subscriber PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "retry", ()=>retry);
var _tslib = require("tslib");
var _subscriber = require("../Subscriber");
function retry(count) {
    if (count === void 0) count = -1;
    return function(source) {
        return source.lift(new RetryOperator(count, source));
    };
}
var RetryOperator = /*@__PURE__*/ function() {
    function RetryOperator(count, source) {
        this.count = count;
        this.source = source;
    }
    RetryOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new RetrySubscriber(subscriber, this.count, this.source));
    };
    return RetryOperator;
}();
var RetrySubscriber = /*@__PURE__*/ function(_super) {
    _tslib.__extends(RetrySubscriber, _super);
    function RetrySubscriber(destination, count, source) {
        var _this = _super.call(this, destination) || this;
        _this.count = count;
        _this.source = source;
        return _this;
    }
    RetrySubscriber.prototype.error = function(err) {
        if (!this.isStopped) {
            var _a = this, source = _a.source, count = _a.count;
            if (count === 0) return _super.prototype.error.call(this, err);
            else if (count > -1) this.count = count - 1;
            source.subscribe(this._unsubscribeAndRecycle());
        }
    };
    return RetrySubscriber;
}((0, _subscriber.Subscriber));

},{"tslib":"kcqwq","../Subscriber":"jGx8F","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4F6hS":[function(require,module,exports) {
/** PURE_IMPORTS_START tslib,_Subject,_innerSubscribe PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "retryWhen", ()=>retryWhen);
var _tslib = require("tslib");
var _subject = require("../Subject");
var _innerSubscribe = require("../innerSubscribe");
function retryWhen(notifier) {
    return function(source) {
        return source.lift(new RetryWhenOperator(notifier, source));
    };
}
var RetryWhenOperator = /*@__PURE__*/ function() {
    function RetryWhenOperator(notifier, source) {
        this.notifier = notifier;
        this.source = source;
    }
    RetryWhenOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new RetryWhenSubscriber(subscriber, this.notifier, this.source));
    };
    return RetryWhenOperator;
}();
var RetryWhenSubscriber = /*@__PURE__*/ function(_super) {
    _tslib.__extends(RetryWhenSubscriber, _super);
    function RetryWhenSubscriber(destination, notifier, source) {
        var _this = _super.call(this, destination) || this;
        _this.notifier = notifier;
        _this.source = source;
        return _this;
    }
    RetryWhenSubscriber.prototype.error = function(err) {
        if (!this.isStopped) {
            var errors = this.errors;
            var retries = this.retries;
            var retriesSubscription = this.retriesSubscription;
            if (!retries) {
                errors = new (0, _subject.Subject)();
                try {
                    var notifier = this.notifier;
                    retries = notifier(errors);
                } catch (e) {
                    return _super.prototype.error.call(this, e);
                }
                retriesSubscription = (0, _innerSubscribe.innerSubscribe)(retries, new (0, _innerSubscribe.SimpleInnerSubscriber)(this));
            } else {
                this.errors = undefined;
                this.retriesSubscription = undefined;
            }
            this._unsubscribeAndRecycle();
            this.errors = errors;
            this.retries = retries;
            this.retriesSubscription = retriesSubscription;
            errors.next(err);
        }
    };
    RetryWhenSubscriber.prototype._unsubscribe = function() {
        var _a = this, errors = _a.errors, retriesSubscription = _a.retriesSubscription;
        if (errors) {
            errors.unsubscribe();
            this.errors = undefined;
        }
        if (retriesSubscription) {
            retriesSubscription.unsubscribe();
            this.retriesSubscription = undefined;
        }
        this.retries = undefined;
    };
    RetryWhenSubscriber.prototype.notifyNext = function() {
        var _unsubscribe = this._unsubscribe;
        this._unsubscribe = null;
        this._unsubscribeAndRecycle();
        this._unsubscribe = _unsubscribe;
        this.source.subscribe(this);
    };
    return RetryWhenSubscriber;
}((0, _innerSubscribe.SimpleOuterSubscriber));

},{"tslib":"kcqwq","../Subject":"84bef","../innerSubscribe":"73frt","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"awQoL":[function(require,module,exports) {
/** PURE_IMPORTS_START tslib,_innerSubscribe PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "sample", ()=>sample);
var _tslib = require("tslib");
var _innerSubscribe = require("../innerSubscribe");
function sample(notifier) {
    return function(source) {
        return source.lift(new SampleOperator(notifier));
    };
}
var SampleOperator = /*@__PURE__*/ function() {
    function SampleOperator(notifier) {
        this.notifier = notifier;
    }
    SampleOperator.prototype.call = function(subscriber, source) {
        var sampleSubscriber = new SampleSubscriber(subscriber);
        var subscription = source.subscribe(sampleSubscriber);
        subscription.add((0, _innerSubscribe.innerSubscribe)(this.notifier, new (0, _innerSubscribe.SimpleInnerSubscriber)(sampleSubscriber)));
        return subscription;
    };
    return SampleOperator;
}();
var SampleSubscriber = /*@__PURE__*/ function(_super) {
    _tslib.__extends(SampleSubscriber, _super);
    function SampleSubscriber() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.hasValue = false;
        return _this;
    }
    SampleSubscriber.prototype._next = function(value) {
        this.value = value;
        this.hasValue = true;
    };
    SampleSubscriber.prototype.notifyNext = function() {
        this.emitValue();
    };
    SampleSubscriber.prototype.notifyComplete = function() {
        this.emitValue();
    };
    SampleSubscriber.prototype.emitValue = function() {
        if (this.hasValue) {
            this.hasValue = false;
            this.destination.next(this.value);
        }
    };
    return SampleSubscriber;
}((0, _innerSubscribe.SimpleOuterSubscriber));

},{"tslib":"kcqwq","../innerSubscribe":"73frt","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"10Tw1":[function(require,module,exports) {
/** PURE_IMPORTS_START tslib,_Subscriber,_scheduler_async PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "sampleTime", ()=>sampleTime);
var _tslib = require("tslib");
var _subscriber = require("../Subscriber");
var _async = require("../scheduler/async");
function sampleTime(period, scheduler) {
    if (scheduler === void 0) scheduler = (0, _async.async);
    return function(source) {
        return source.lift(new SampleTimeOperator(period, scheduler));
    };
}
var SampleTimeOperator = /*@__PURE__*/ function() {
    function SampleTimeOperator(period, scheduler) {
        this.period = period;
        this.scheduler = scheduler;
    }
    SampleTimeOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new SampleTimeSubscriber(subscriber, this.period, this.scheduler));
    };
    return SampleTimeOperator;
}();
var SampleTimeSubscriber = /*@__PURE__*/ function(_super) {
    _tslib.__extends(SampleTimeSubscriber, _super);
    function SampleTimeSubscriber(destination, period, scheduler) {
        var _this = _super.call(this, destination) || this;
        _this.period = period;
        _this.scheduler = scheduler;
        _this.hasValue = false;
        _this.add(scheduler.schedule(dispatchNotification, period, {
            subscriber: _this,
            period: period
        }));
        return _this;
    }
    SampleTimeSubscriber.prototype._next = function(value) {
        this.lastValue = value;
        this.hasValue = true;
    };
    SampleTimeSubscriber.prototype.notifyNext = function() {
        if (this.hasValue) {
            this.hasValue = false;
            this.destination.next(this.lastValue);
        }
    };
    return SampleTimeSubscriber;
}((0, _subscriber.Subscriber));
function dispatchNotification(state) {
    var subscriber = state.subscriber, period = state.period;
    subscriber.notifyNext();
    this.schedule(state, period);
}

},{"tslib":"kcqwq","../Subscriber":"jGx8F","../scheduler/async":"l1cmn","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"81se8":[function(require,module,exports) {
/** PURE_IMPORTS_START tslib,_Subscriber PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "sequenceEqual", ()=>sequenceEqual);
parcelHelpers.export(exports, "SequenceEqualOperator", ()=>SequenceEqualOperator);
parcelHelpers.export(exports, "SequenceEqualSubscriber", ()=>SequenceEqualSubscriber);
var _tslib = require("tslib");
var _subscriber = require("../Subscriber");
function sequenceEqual(compareTo, comparator) {
    return function(source) {
        return source.lift(new SequenceEqualOperator(compareTo, comparator));
    };
}
var SequenceEqualOperator = /*@__PURE__*/ function() {
    function SequenceEqualOperator(compareTo, comparator) {
        this.compareTo = compareTo;
        this.comparator = comparator;
    }
    SequenceEqualOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new SequenceEqualSubscriber(subscriber, this.compareTo, this.comparator));
    };
    return SequenceEqualOperator;
}();
var SequenceEqualSubscriber = /*@__PURE__*/ function(_super) {
    _tslib.__extends(SequenceEqualSubscriber, _super);
    function SequenceEqualSubscriber(destination, compareTo, comparator) {
        var _this = _super.call(this, destination) || this;
        _this.compareTo = compareTo;
        _this.comparator = comparator;
        _this._a = [];
        _this._b = [];
        _this._oneComplete = false;
        _this.destination.add(compareTo.subscribe(new SequenceEqualCompareToSubscriber(destination, _this)));
        return _this;
    }
    SequenceEqualSubscriber.prototype._next = function(value) {
        if (this._oneComplete && this._b.length === 0) this.emit(false);
        else {
            this._a.push(value);
            this.checkValues();
        }
    };
    SequenceEqualSubscriber.prototype._complete = function() {
        if (this._oneComplete) this.emit(this._a.length === 0 && this._b.length === 0);
        else this._oneComplete = true;
        this.unsubscribe();
    };
    SequenceEqualSubscriber.prototype.checkValues = function() {
        var _c = this, _a = _c._a, _b = _c._b, comparator = _c.comparator;
        while(_a.length > 0 && _b.length > 0){
            var a = _a.shift();
            var b = _b.shift();
            var areEqual = false;
            try {
                areEqual = comparator ? comparator(a, b) : a === b;
            } catch (e) {
                this.destination.error(e);
            }
            if (!areEqual) this.emit(false);
        }
    };
    SequenceEqualSubscriber.prototype.emit = function(value) {
        var destination = this.destination;
        destination.next(value);
        destination.complete();
    };
    SequenceEqualSubscriber.prototype.nextB = function(value) {
        if (this._oneComplete && this._a.length === 0) this.emit(false);
        else {
            this._b.push(value);
            this.checkValues();
        }
    };
    SequenceEqualSubscriber.prototype.completeB = function() {
        if (this._oneComplete) this.emit(this._a.length === 0 && this._b.length === 0);
        else this._oneComplete = true;
    };
    return SequenceEqualSubscriber;
}((0, _subscriber.Subscriber));
var SequenceEqualCompareToSubscriber = /*@__PURE__*/ function(_super) {
    _tslib.__extends(SequenceEqualCompareToSubscriber, _super);
    function SequenceEqualCompareToSubscriber(destination, parent) {
        var _this = _super.call(this, destination) || this;
        _this.parent = parent;
        return _this;
    }
    SequenceEqualCompareToSubscriber.prototype._next = function(value) {
        this.parent.nextB(value);
    };
    SequenceEqualCompareToSubscriber.prototype._error = function(err) {
        this.parent.error(err);
        this.unsubscribe();
    };
    SequenceEqualCompareToSubscriber.prototype._complete = function() {
        this.parent.completeB();
        this.unsubscribe();
    };
    return SequenceEqualCompareToSubscriber;
}((0, _subscriber.Subscriber));

},{"tslib":"kcqwq","../Subscriber":"jGx8F","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"diIIU":[function(require,module,exports) {
/** PURE_IMPORTS_START _multicast,_refCount,_Subject PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "share", ()=>share);
var _multicast = require("./multicast");
var _refCount = require("./refCount");
var _subject = require("../Subject");
function shareSubjectFactory() {
    return new (0, _subject.Subject)();
}
function share() {
    return function(source) {
        return (0, _refCount.refCount)()((0, _multicast.multicast)(shareSubjectFactory)(source));
    };
}

},{"./multicast":"GLY7l","./refCount":"ihxKV","../Subject":"84bef","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"1ysaZ":[function(require,module,exports) {
/** PURE_IMPORTS_START _ReplaySubject PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "shareReplay", ()=>shareReplay);
var _replaySubject = require("../ReplaySubject");
function shareReplay(configOrBufferSize, windowTime, scheduler) {
    var config;
    if (configOrBufferSize && typeof configOrBufferSize === "object") config = configOrBufferSize;
    else config = {
        bufferSize: configOrBufferSize,
        windowTime: windowTime,
        refCount: false,
        scheduler: scheduler
    };
    return function(source) {
        return source.lift(shareReplayOperator(config));
    };
}
function shareReplayOperator(_a) {
    var _b = _a.bufferSize, bufferSize = _b === void 0 ? Number.POSITIVE_INFINITY : _b, _c = _a.windowTime, windowTime = _c === void 0 ? Number.POSITIVE_INFINITY : _c, useRefCount = _a.refCount, scheduler = _a.scheduler;
    var subject;
    var refCount = 0;
    var subscription;
    var hasError = false;
    var isComplete = false;
    return function shareReplayOperation(source) {
        refCount++;
        var innerSub;
        if (!subject || hasError) {
            hasError = false;
            subject = new (0, _replaySubject.ReplaySubject)(bufferSize, windowTime, scheduler);
            innerSub = subject.subscribe(this);
            subscription = source.subscribe({
                next: function(value) {
                    subject.next(value);
                },
                error: function(err) {
                    hasError = true;
                    subject.error(err);
                },
                complete: function() {
                    isComplete = true;
                    subscription = undefined;
                    subject.complete();
                }
            });
            if (isComplete) subscription = undefined;
        } else innerSub = subject.subscribe(this);
        this.add(function() {
            refCount--;
            innerSub.unsubscribe();
            innerSub = undefined;
            if (subscription && !isComplete && useRefCount && refCount === 0) {
                subscription.unsubscribe();
                subscription = undefined;
                subject = undefined;
            }
        });
    };
}

},{"../ReplaySubject":"gRMu9","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"3kbFw":[function(require,module,exports) {
/** PURE_IMPORTS_START tslib,_Subscriber,_util_EmptyError PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "single", ()=>single);
var _tslib = require("tslib");
var _subscriber = require("../Subscriber");
var _emptyError = require("../util/EmptyError");
function single(predicate) {
    return function(source) {
        return source.lift(new SingleOperator(predicate, source));
    };
}
var SingleOperator = /*@__PURE__*/ function() {
    function SingleOperator(predicate, source) {
        this.predicate = predicate;
        this.source = source;
    }
    SingleOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new SingleSubscriber(subscriber, this.predicate, this.source));
    };
    return SingleOperator;
}();
var SingleSubscriber = /*@__PURE__*/ function(_super) {
    _tslib.__extends(SingleSubscriber, _super);
    function SingleSubscriber(destination, predicate, source) {
        var _this = _super.call(this, destination) || this;
        _this.predicate = predicate;
        _this.source = source;
        _this.seenValue = false;
        _this.index = 0;
        return _this;
    }
    SingleSubscriber.prototype.applySingleValue = function(value) {
        if (this.seenValue) this.destination.error("Sequence contains more than one element");
        else {
            this.seenValue = true;
            this.singleValue = value;
        }
    };
    SingleSubscriber.prototype._next = function(value) {
        var index = this.index++;
        if (this.predicate) this.tryNext(value, index);
        else this.applySingleValue(value);
    };
    SingleSubscriber.prototype.tryNext = function(value, index) {
        try {
            if (this.predicate(value, index, this.source)) this.applySingleValue(value);
        } catch (err) {
            this.destination.error(err);
        }
    };
    SingleSubscriber.prototype._complete = function() {
        var destination = this.destination;
        if (this.index > 0) {
            destination.next(this.seenValue ? this.singleValue : undefined);
            destination.complete();
        } else destination.error(new (0, _emptyError.EmptyError));
    };
    return SingleSubscriber;
}((0, _subscriber.Subscriber));

},{"tslib":"kcqwq","../Subscriber":"jGx8F","../util/EmptyError":"7a4tA","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"6Y7P6":[function(require,module,exports) {
/** PURE_IMPORTS_START tslib,_Subscriber PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "skip", ()=>skip);
var _tslib = require("tslib");
var _subscriber = require("../Subscriber");
function skip(count) {
    return function(source) {
        return source.lift(new SkipOperator(count));
    };
}
var SkipOperator = /*@__PURE__*/ function() {
    function SkipOperator(total) {
        this.total = total;
    }
    SkipOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new SkipSubscriber(subscriber, this.total));
    };
    return SkipOperator;
}();
var SkipSubscriber = /*@__PURE__*/ function(_super) {
    _tslib.__extends(SkipSubscriber, _super);
    function SkipSubscriber(destination, total) {
        var _this = _super.call(this, destination) || this;
        _this.total = total;
        _this.count = 0;
        return _this;
    }
    SkipSubscriber.prototype._next = function(x) {
        if (++this.count > this.total) this.destination.next(x);
    };
    return SkipSubscriber;
}((0, _subscriber.Subscriber));

},{"tslib":"kcqwq","../Subscriber":"jGx8F","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"dehzH":[function(require,module,exports) {
/** PURE_IMPORTS_START tslib,_Subscriber,_util_ArgumentOutOfRangeError PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "skipLast", ()=>skipLast);
var _tslib = require("tslib");
var _subscriber = require("../Subscriber");
var _argumentOutOfRangeError = require("../util/ArgumentOutOfRangeError");
function skipLast(count) {
    return function(source) {
        return source.lift(new SkipLastOperator(count));
    };
}
var SkipLastOperator = /*@__PURE__*/ function() {
    function SkipLastOperator(_skipCount) {
        this._skipCount = _skipCount;
        if (this._skipCount < 0) throw new (0, _argumentOutOfRangeError.ArgumentOutOfRangeError);
    }
    SkipLastOperator.prototype.call = function(subscriber, source) {
        if (this._skipCount === 0) return source.subscribe(new (0, _subscriber.Subscriber)(subscriber));
        else return source.subscribe(new SkipLastSubscriber(subscriber, this._skipCount));
    };
    return SkipLastOperator;
}();
var SkipLastSubscriber = /*@__PURE__*/ function(_super) {
    _tslib.__extends(SkipLastSubscriber, _super);
    function SkipLastSubscriber(destination, _skipCount) {
        var _this = _super.call(this, destination) || this;
        _this._skipCount = _skipCount;
        _this._count = 0;
        _this._ring = new Array(_skipCount);
        return _this;
    }
    SkipLastSubscriber.prototype._next = function(value) {
        var skipCount = this._skipCount;
        var count = this._count++;
        if (count < skipCount) this._ring[count] = value;
        else {
            var currentIndex = count % skipCount;
            var ring = this._ring;
            var oldValue = ring[currentIndex];
            ring[currentIndex] = value;
            this.destination.next(oldValue);
        }
    };
    return SkipLastSubscriber;
}((0, _subscriber.Subscriber));

},{"tslib":"kcqwq","../Subscriber":"jGx8F","../util/ArgumentOutOfRangeError":"38Gbx","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8Gc8j":[function(require,module,exports) {
/** PURE_IMPORTS_START tslib,_innerSubscribe PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "skipUntil", ()=>skipUntil);
var _tslib = require("tslib");
var _innerSubscribe = require("../innerSubscribe");
function skipUntil(notifier) {
    return function(source) {
        return source.lift(new SkipUntilOperator(notifier));
    };
}
var SkipUntilOperator = /*@__PURE__*/ function() {
    function SkipUntilOperator(notifier) {
        this.notifier = notifier;
    }
    SkipUntilOperator.prototype.call = function(destination, source) {
        return source.subscribe(new SkipUntilSubscriber(destination, this.notifier));
    };
    return SkipUntilOperator;
}();
var SkipUntilSubscriber = /*@__PURE__*/ function(_super) {
    _tslib.__extends(SkipUntilSubscriber, _super);
    function SkipUntilSubscriber(destination, notifier) {
        var _this = _super.call(this, destination) || this;
        _this.hasValue = false;
        var innerSubscriber = new (0, _innerSubscribe.SimpleInnerSubscriber)(_this);
        _this.add(innerSubscriber);
        _this.innerSubscription = innerSubscriber;
        var innerSubscription = (0, _innerSubscribe.innerSubscribe)(notifier, innerSubscriber);
        if (innerSubscription !== innerSubscriber) {
            _this.add(innerSubscription);
            _this.innerSubscription = innerSubscription;
        }
        return _this;
    }
    SkipUntilSubscriber.prototype._next = function(value) {
        if (this.hasValue) _super.prototype._next.call(this, value);
    };
    SkipUntilSubscriber.prototype.notifyNext = function() {
        this.hasValue = true;
        if (this.innerSubscription) this.innerSubscription.unsubscribe();
    };
    SkipUntilSubscriber.prototype.notifyComplete = function() {};
    return SkipUntilSubscriber;
}((0, _innerSubscribe.SimpleOuterSubscriber));

},{"tslib":"kcqwq","../innerSubscribe":"73frt","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"brJq3":[function(require,module,exports) {
/** PURE_IMPORTS_START tslib,_Subscriber PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "skipWhile", ()=>skipWhile);
var _tslib = require("tslib");
var _subscriber = require("../Subscriber");
function skipWhile(predicate) {
    return function(source) {
        return source.lift(new SkipWhileOperator(predicate));
    };
}
var SkipWhileOperator = /*@__PURE__*/ function() {
    function SkipWhileOperator(predicate) {
        this.predicate = predicate;
    }
    SkipWhileOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new SkipWhileSubscriber(subscriber, this.predicate));
    };
    return SkipWhileOperator;
}();
var SkipWhileSubscriber = /*@__PURE__*/ function(_super) {
    _tslib.__extends(SkipWhileSubscriber, _super);
    function SkipWhileSubscriber(destination, predicate) {
        var _this = _super.call(this, destination) || this;
        _this.predicate = predicate;
        _this.skipping = true;
        _this.index = 0;
        return _this;
    }
    SkipWhileSubscriber.prototype._next = function(value) {
        var destination = this.destination;
        if (this.skipping) this.tryCallPredicate(value);
        if (!this.skipping) destination.next(value);
    };
    SkipWhileSubscriber.prototype.tryCallPredicate = function(value) {
        try {
            var result = this.predicate(value, this.index++);
            this.skipping = Boolean(result);
        } catch (err) {
            this.destination.error(err);
        }
    };
    return SkipWhileSubscriber;
}((0, _subscriber.Subscriber));

},{"tslib":"kcqwq","../Subscriber":"jGx8F","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"dBObJ":[function(require,module,exports) {
/** PURE_IMPORTS_START _observable_concat,_util_isScheduler PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "startWith", ()=>startWith);
var _concat = require("../observable/concat");
var _isScheduler = require("../util/isScheduler");
function startWith() {
    var array = [];
    for(var _i = 0; _i < arguments.length; _i++)array[_i] = arguments[_i];
    var scheduler = array[array.length - 1];
    if ((0, _isScheduler.isScheduler)(scheduler)) {
        array.pop();
        return function(source) {
            return (0, _concat.concat)(array, source, scheduler);
        };
    } else return function(source) {
        return (0, _concat.concat)(array, source);
    };
}

},{"../observable/concat":"2cXL0","../util/isScheduler":"4iYg4","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"33YTz":[function(require,module,exports) {
/** PURE_IMPORTS_START _observable_SubscribeOnObservable PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "subscribeOn", ()=>subscribeOn);
var _subscribeOnObservable = require("../observable/SubscribeOnObservable");
function subscribeOn(scheduler, delay) {
    if (delay === void 0) delay = 0;
    return function subscribeOnOperatorFunction(source) {
        return source.lift(new SubscribeOnOperator(scheduler, delay));
    };
}
var SubscribeOnOperator = /*@__PURE__*/ function() {
    function SubscribeOnOperator(scheduler, delay) {
        this.scheduler = scheduler;
        this.delay = delay;
    }
    SubscribeOnOperator.prototype.call = function(subscriber, source) {
        return new (0, _subscribeOnObservable.SubscribeOnObservable)(source, this.delay, this.scheduler).subscribe(subscriber);
    };
    return SubscribeOnOperator;
}();

},{"../observable/SubscribeOnObservable":"1XZn2","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"1XZn2":[function(require,module,exports) {
/** PURE_IMPORTS_START tslib,_Observable,_scheduler_asap,_util_isNumeric PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SubscribeOnObservable", ()=>SubscribeOnObservable);
var _tslib = require("tslib");
var _observable = require("../Observable");
var _asap = require("../scheduler/asap");
var _isNumeric = require("../util/isNumeric");
var SubscribeOnObservable = /*@__PURE__*/ function(_super) {
    _tslib.__extends(SubscribeOnObservable, _super);
    function SubscribeOnObservable(source, delayTime, scheduler) {
        if (delayTime === void 0) delayTime = 0;
        if (scheduler === void 0) scheduler = (0, _asap.asap);
        var _this = _super.call(this) || this;
        _this.source = source;
        _this.delayTime = delayTime;
        _this.scheduler = scheduler;
        if (!(0, _isNumeric.isNumeric)(delayTime) || delayTime < 0) _this.delayTime = 0;
        if (!scheduler || typeof scheduler.schedule !== "function") _this.scheduler = (0, _asap.asap);
        return _this;
    }
    SubscribeOnObservable.create = function(source, delay, scheduler) {
        if (delay === void 0) delay = 0;
        if (scheduler === void 0) scheduler = (0, _asap.asap);
        return new SubscribeOnObservable(source, delay, scheduler);
    };
    SubscribeOnObservable.dispatch = function(arg) {
        var source = arg.source, subscriber = arg.subscriber;
        return this.add(source.subscribe(subscriber));
    };
    SubscribeOnObservable.prototype._subscribe = function(subscriber) {
        var delay = this.delayTime;
        var source = this.source;
        var scheduler = this.scheduler;
        return scheduler.schedule(SubscribeOnObservable.dispatch, delay, {
            source: source,
            subscriber: subscriber
        });
    };
    return SubscribeOnObservable;
}((0, _observable.Observable));

},{"tslib":"kcqwq","../Observable":"9oc0x","../scheduler/asap":"5Pp9f","../util/isNumeric":"i95aV","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"kcfvT":[function(require,module,exports) {
/** PURE_IMPORTS_START _switchMap,_util_identity PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "switchAll", ()=>switchAll);
var _switchMap = require("./switchMap");
var _identity = require("../util/identity");
function switchAll() {
    return (0, _switchMap.switchMap)((0, _identity.identity));
}

},{"./switchMap":"5lH3R","../util/identity":"kDT9y","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"5lH3R":[function(require,module,exports) {
/** PURE_IMPORTS_START tslib,_map,_observable_from,_innerSubscribe PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "switchMap", ()=>switchMap);
var _tslib = require("tslib");
var _map = require("./map");
var _from = require("../observable/from");
var _innerSubscribe = require("../innerSubscribe");
function switchMap(project, resultSelector) {
    if (typeof resultSelector === "function") return function(source) {
        return source.pipe(switchMap(function(a, i) {
            return (0, _from.from)(project(a, i)).pipe((0, _map.map)(function(b, ii) {
                return resultSelector(a, b, i, ii);
            }));
        }));
    };
    return function(source) {
        return source.lift(new SwitchMapOperator(project));
    };
}
var SwitchMapOperator = /*@__PURE__*/ function() {
    function SwitchMapOperator(project) {
        this.project = project;
    }
    SwitchMapOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new SwitchMapSubscriber(subscriber, this.project));
    };
    return SwitchMapOperator;
}();
var SwitchMapSubscriber = /*@__PURE__*/ function(_super) {
    _tslib.__extends(SwitchMapSubscriber, _super);
    function SwitchMapSubscriber(destination, project) {
        var _this = _super.call(this, destination) || this;
        _this.project = project;
        _this.index = 0;
        return _this;
    }
    SwitchMapSubscriber.prototype._next = function(value) {
        var result;
        var index = this.index++;
        try {
            result = this.project(value, index);
        } catch (error) {
            this.destination.error(error);
            return;
        }
        this._innerSub(result);
    };
    SwitchMapSubscriber.prototype._innerSub = function(result) {
        var innerSubscription = this.innerSubscription;
        if (innerSubscription) innerSubscription.unsubscribe();
        var innerSubscriber = new (0, _innerSubscribe.SimpleInnerSubscriber)(this);
        var destination = this.destination;
        destination.add(innerSubscriber);
        this.innerSubscription = (0, _innerSubscribe.innerSubscribe)(result, innerSubscriber);
        if (this.innerSubscription !== innerSubscriber) destination.add(this.innerSubscription);
    };
    SwitchMapSubscriber.prototype._complete = function() {
        var innerSubscription = this.innerSubscription;
        if (!innerSubscription || innerSubscription.closed) _super.prototype._complete.call(this);
        this.unsubscribe();
    };
    SwitchMapSubscriber.prototype._unsubscribe = function() {
        this.innerSubscription = undefined;
    };
    SwitchMapSubscriber.prototype.notifyComplete = function() {
        this.innerSubscription = undefined;
        if (this.isStopped) _super.prototype._complete.call(this);
    };
    SwitchMapSubscriber.prototype.notifyNext = function(innerValue) {
        this.destination.next(innerValue);
    };
    return SwitchMapSubscriber;
}((0, _innerSubscribe.SimpleOuterSubscriber));

},{"tslib":"kcqwq","./map":"cvzfg","../observable/from":"6aqs0","../innerSubscribe":"73frt","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"b6eN6":[function(require,module,exports) {
/** PURE_IMPORTS_START _switchMap PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "switchMapTo", ()=>switchMapTo);
var _switchMap = require("./switchMap");
function switchMapTo(innerObservable, resultSelector) {
    return resultSelector ? (0, _switchMap.switchMap)(function() {
        return innerObservable;
    }, resultSelector) : (0, _switchMap.switchMap)(function() {
        return innerObservable;
    });
}

},{"./switchMap":"5lH3R","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8NfQ5":[function(require,module,exports) {
/** PURE_IMPORTS_START tslib,_innerSubscribe PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "takeUntil", ()=>takeUntil);
var _tslib = require("tslib");
var _innerSubscribe = require("../innerSubscribe");
function takeUntil(notifier) {
    return function(source) {
        return source.lift(new TakeUntilOperator(notifier));
    };
}
var TakeUntilOperator = /*@__PURE__*/ function() {
    function TakeUntilOperator(notifier) {
        this.notifier = notifier;
    }
    TakeUntilOperator.prototype.call = function(subscriber, source) {
        var takeUntilSubscriber = new TakeUntilSubscriber(subscriber);
        var notifierSubscription = (0, _innerSubscribe.innerSubscribe)(this.notifier, new (0, _innerSubscribe.SimpleInnerSubscriber)(takeUntilSubscriber));
        if (notifierSubscription && !takeUntilSubscriber.seenValue) {
            takeUntilSubscriber.add(notifierSubscription);
            return source.subscribe(takeUntilSubscriber);
        }
        return takeUntilSubscriber;
    };
    return TakeUntilOperator;
}();
var TakeUntilSubscriber = /*@__PURE__*/ function(_super) {
    _tslib.__extends(TakeUntilSubscriber, _super);
    function TakeUntilSubscriber(destination) {
        var _this = _super.call(this, destination) || this;
        _this.seenValue = false;
        return _this;
    }
    TakeUntilSubscriber.prototype.notifyNext = function() {
        this.seenValue = true;
        this.complete();
    };
    TakeUntilSubscriber.prototype.notifyComplete = function() {};
    return TakeUntilSubscriber;
}((0, _innerSubscribe.SimpleOuterSubscriber));

},{"tslib":"kcqwq","../innerSubscribe":"73frt","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"dcbUw":[function(require,module,exports) {
/** PURE_IMPORTS_START tslib,_Subscriber PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "takeWhile", ()=>takeWhile);
var _tslib = require("tslib");
var _subscriber = require("../Subscriber");
function takeWhile(predicate, inclusive) {
    if (inclusive === void 0) inclusive = false;
    return function(source) {
        return source.lift(new TakeWhileOperator(predicate, inclusive));
    };
}
var TakeWhileOperator = /*@__PURE__*/ function() {
    function TakeWhileOperator(predicate, inclusive) {
        this.predicate = predicate;
        this.inclusive = inclusive;
    }
    TakeWhileOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new TakeWhileSubscriber(subscriber, this.predicate, this.inclusive));
    };
    return TakeWhileOperator;
}();
var TakeWhileSubscriber = /*@__PURE__*/ function(_super) {
    _tslib.__extends(TakeWhileSubscriber, _super);
    function TakeWhileSubscriber(destination, predicate, inclusive) {
        var _this = _super.call(this, destination) || this;
        _this.predicate = predicate;
        _this.inclusive = inclusive;
        _this.index = 0;
        return _this;
    }
    TakeWhileSubscriber.prototype._next = function(value) {
        var destination = this.destination;
        var result;
        try {
            result = this.predicate(value, this.index++);
        } catch (err) {
            destination.error(err);
            return;
        }
        this.nextOrComplete(value, result);
    };
    TakeWhileSubscriber.prototype.nextOrComplete = function(value, predicateResult) {
        var destination = this.destination;
        if (Boolean(predicateResult)) destination.next(value);
        else {
            if (this.inclusive) destination.next(value);
            destination.complete();
        }
    };
    return TakeWhileSubscriber;
}((0, _subscriber.Subscriber));

},{"tslib":"kcqwq","../Subscriber":"jGx8F","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"1LiLi":[function(require,module,exports) {
/** PURE_IMPORTS_START tslib,_Subscriber,_util_noop,_util_isFunction PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "tap", ()=>tap);
var _tslib = require("tslib");
var _subscriber = require("../Subscriber");
var _noop = require("../util/noop");
var _isFunction = require("../util/isFunction");
function tap(nextOrObserver, error, complete) {
    return function tapOperatorFunction(source) {
        return source.lift(new DoOperator(nextOrObserver, error, complete));
    };
}
var DoOperator = /*@__PURE__*/ function() {
    function DoOperator(nextOrObserver, error, complete) {
        this.nextOrObserver = nextOrObserver;
        this.error = error;
        this.complete = complete;
    }
    DoOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new TapSubscriber(subscriber, this.nextOrObserver, this.error, this.complete));
    };
    return DoOperator;
}();
var TapSubscriber = /*@__PURE__*/ function(_super) {
    _tslib.__extends(TapSubscriber, _super);
    function TapSubscriber(destination, observerOrNext, error, complete) {
        var _this = _super.call(this, destination) || this;
        _this._tapNext = (0, _noop.noop);
        _this._tapError = (0, _noop.noop);
        _this._tapComplete = (0, _noop.noop);
        _this._tapError = error || (0, _noop.noop);
        _this._tapComplete = complete || (0, _noop.noop);
        if ((0, _isFunction.isFunction)(observerOrNext)) {
            _this._context = _this;
            _this._tapNext = observerOrNext;
        } else if (observerOrNext) {
            _this._context = observerOrNext;
            _this._tapNext = observerOrNext.next || (0, _noop.noop);
            _this._tapError = observerOrNext.error || (0, _noop.noop);
            _this._tapComplete = observerOrNext.complete || (0, _noop.noop);
        }
        return _this;
    }
    TapSubscriber.prototype._next = function(value) {
        try {
            this._tapNext.call(this._context, value);
        } catch (err) {
            this.destination.error(err);
            return;
        }
        this.destination.next(value);
    };
    TapSubscriber.prototype._error = function(err) {
        try {
            this._tapError.call(this._context, err);
        } catch (err) {
            this.destination.error(err);
            return;
        }
        this.destination.error(err);
    };
    TapSubscriber.prototype._complete = function() {
        try {
            this._tapComplete.call(this._context);
        } catch (err) {
            this.destination.error(err);
            return;
        }
        return this.destination.complete();
    };
    return TapSubscriber;
}((0, _subscriber.Subscriber));

},{"tslib":"kcqwq","../Subscriber":"jGx8F","../util/noop":"4s4qZ","../util/isFunction":"atYNr","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"jinO2":[function(require,module,exports) {
/** PURE_IMPORTS_START tslib,_innerSubscribe PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "defaultThrottleConfig", ()=>defaultThrottleConfig);
parcelHelpers.export(exports, "throttle", ()=>throttle);
var _tslib = require("tslib");
var _innerSubscribe = require("../innerSubscribe");
var defaultThrottleConfig = {
    leading: true,
    trailing: false
};
function throttle(durationSelector, config) {
    if (config === void 0) config = defaultThrottleConfig;
    return function(source) {
        return source.lift(new ThrottleOperator(durationSelector, !!config.leading, !!config.trailing));
    };
}
var ThrottleOperator = /*@__PURE__*/ function() {
    function ThrottleOperator(durationSelector, leading, trailing) {
        this.durationSelector = durationSelector;
        this.leading = leading;
        this.trailing = trailing;
    }
    ThrottleOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new ThrottleSubscriber(subscriber, this.durationSelector, this.leading, this.trailing));
    };
    return ThrottleOperator;
}();
var ThrottleSubscriber = /*@__PURE__*/ function(_super) {
    _tslib.__extends(ThrottleSubscriber, _super);
    function ThrottleSubscriber(destination, durationSelector, _leading, _trailing) {
        var _this = _super.call(this, destination) || this;
        _this.destination = destination;
        _this.durationSelector = durationSelector;
        _this._leading = _leading;
        _this._trailing = _trailing;
        _this._hasValue = false;
        return _this;
    }
    ThrottleSubscriber.prototype._next = function(value) {
        this._hasValue = true;
        this._sendValue = value;
        if (!this._throttled) {
            if (this._leading) this.send();
            else this.throttle(value);
        }
    };
    ThrottleSubscriber.prototype.send = function() {
        var _a = this, _hasValue = _a._hasValue, _sendValue = _a._sendValue;
        if (_hasValue) {
            this.destination.next(_sendValue);
            this.throttle(_sendValue);
        }
        this._hasValue = false;
        this._sendValue = undefined;
    };
    ThrottleSubscriber.prototype.throttle = function(value) {
        var duration = this.tryDurationSelector(value);
        if (!!duration) this.add(this._throttled = (0, _innerSubscribe.innerSubscribe)(duration, new (0, _innerSubscribe.SimpleInnerSubscriber)(this)));
    };
    ThrottleSubscriber.prototype.tryDurationSelector = function(value) {
        try {
            return this.durationSelector(value);
        } catch (err) {
            this.destination.error(err);
            return null;
        }
    };
    ThrottleSubscriber.prototype.throttlingDone = function() {
        var _a = this, _throttled = _a._throttled, _trailing = _a._trailing;
        if (_throttled) _throttled.unsubscribe();
        this._throttled = undefined;
        if (_trailing) this.send();
    };
    ThrottleSubscriber.prototype.notifyNext = function() {
        this.throttlingDone();
    };
    ThrottleSubscriber.prototype.notifyComplete = function() {
        this.throttlingDone();
    };
    return ThrottleSubscriber;
}((0, _innerSubscribe.SimpleOuterSubscriber));

},{"tslib":"kcqwq","../innerSubscribe":"73frt","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"6lj6f":[function(require,module,exports) {
/** PURE_IMPORTS_START tslib,_Subscriber,_scheduler_async,_throttle PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "throttleTime", ()=>throttleTime);
var _tslib = require("tslib");
var _subscriber = require("../Subscriber");
var _async = require("../scheduler/async");
var _throttle = require("./throttle");
function throttleTime(duration, scheduler, config) {
    if (scheduler === void 0) scheduler = (0, _async.async);
    if (config === void 0) config = (0, _throttle.defaultThrottleConfig);
    return function(source) {
        return source.lift(new ThrottleTimeOperator(duration, scheduler, config.leading, config.trailing));
    };
}
var ThrottleTimeOperator = /*@__PURE__*/ function() {
    function ThrottleTimeOperator(duration, scheduler, leading, trailing) {
        this.duration = duration;
        this.scheduler = scheduler;
        this.leading = leading;
        this.trailing = trailing;
    }
    ThrottleTimeOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new ThrottleTimeSubscriber(subscriber, this.duration, this.scheduler, this.leading, this.trailing));
    };
    return ThrottleTimeOperator;
}();
var ThrottleTimeSubscriber = /*@__PURE__*/ function(_super) {
    _tslib.__extends(ThrottleTimeSubscriber, _super);
    function ThrottleTimeSubscriber(destination, duration, scheduler, leading, trailing) {
        var _this = _super.call(this, destination) || this;
        _this.duration = duration;
        _this.scheduler = scheduler;
        _this.leading = leading;
        _this.trailing = trailing;
        _this._hasTrailingValue = false;
        _this._trailingValue = null;
        return _this;
    }
    ThrottleTimeSubscriber.prototype._next = function(value) {
        if (this.throttled) {
            if (this.trailing) {
                this._trailingValue = value;
                this._hasTrailingValue = true;
            }
        } else {
            this.add(this.throttled = this.scheduler.schedule(dispatchNext, this.duration, {
                subscriber: this
            }));
            if (this.leading) this.destination.next(value);
            else if (this.trailing) {
                this._trailingValue = value;
                this._hasTrailingValue = true;
            }
        }
    };
    ThrottleTimeSubscriber.prototype._complete = function() {
        if (this._hasTrailingValue) {
            this.destination.next(this._trailingValue);
            this.destination.complete();
        } else this.destination.complete();
    };
    ThrottleTimeSubscriber.prototype.clearThrottle = function() {
        var throttled = this.throttled;
        if (throttled) {
            if (this.trailing && this._hasTrailingValue) {
                this.destination.next(this._trailingValue);
                this._trailingValue = null;
                this._hasTrailingValue = false;
            }
            throttled.unsubscribe();
            this.remove(throttled);
            this.throttled = null;
        }
    };
    return ThrottleTimeSubscriber;
}((0, _subscriber.Subscriber));
function dispatchNext(arg) {
    var subscriber = arg.subscriber;
    subscriber.clearThrottle();
}

},{"tslib":"kcqwq","../Subscriber":"jGx8F","../scheduler/async":"l1cmn","./throttle":"jinO2","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7omle":[function(require,module,exports) {
/** PURE_IMPORTS_START _scheduler_async,_scan,_observable_defer,_map PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "timeInterval", ()=>timeInterval);
parcelHelpers.export(exports, "TimeInterval", ()=>TimeInterval);
var _async = require("../scheduler/async");
var _scan = require("./scan");
var _defer = require("../observable/defer");
var _map = require("./map");
function timeInterval(scheduler) {
    if (scheduler === void 0) scheduler = (0, _async.async);
    return function(source) {
        return (0, _defer.defer)(function() {
            return source.pipe((0, _scan.scan)(function(_a, value) {
                var current = _a.current;
                return {
                    value: value,
                    current: scheduler.now(),
                    last: current
                };
            }, {
                current: scheduler.now(),
                value: undefined,
                last: undefined
            }), (0, _map.map)(function(_a) {
                var current = _a.current, last = _a.last, value = _a.value;
                return new TimeInterval(value, current - last);
            }));
        });
    };
}
var TimeInterval = /*@__PURE__*/ function() {
    function TimeInterval(value, interval) {
        this.value = value;
        this.interval = interval;
    }
    return TimeInterval;
}();

},{"../scheduler/async":"l1cmn","./scan":"hX6nA","../observable/defer":"1uvAg","./map":"cvzfg","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"5TIfU":[function(require,module,exports) {
/** PURE_IMPORTS_START _scheduler_async,_util_TimeoutError,_timeoutWith,_observable_throwError PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "timeout", ()=>timeout);
var _async = require("../scheduler/async");
var _timeoutError = require("../util/TimeoutError");
var _timeoutWith = require("./timeoutWith");
var _throwError = require("../observable/throwError");
function timeout(due, scheduler) {
    if (scheduler === void 0) scheduler = (0, _async.async);
    return (0, _timeoutWith.timeoutWith)(due, (0, _throwError.throwError)(new (0, _timeoutError.TimeoutError)()), scheduler);
}

},{"../scheduler/async":"l1cmn","../util/TimeoutError":"iA33G","./timeoutWith":"d8OMJ","../observable/throwError":"4BUNm","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"d8OMJ":[function(require,module,exports) {
/** PURE_IMPORTS_START tslib,_scheduler_async,_util_isDate,_innerSubscribe PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "timeoutWith", ()=>timeoutWith);
var _tslib = require("tslib");
var _async = require("../scheduler/async");
var _isDate = require("../util/isDate");
var _innerSubscribe = require("../innerSubscribe");
function timeoutWith(due, withObservable, scheduler) {
    if (scheduler === void 0) scheduler = (0, _async.async);
    return function(source) {
        var absoluteTimeout = (0, _isDate.isDate)(due);
        var waitFor = absoluteTimeout ? +due - scheduler.now() : Math.abs(due);
        return source.lift(new TimeoutWithOperator(waitFor, absoluteTimeout, withObservable, scheduler));
    };
}
var TimeoutWithOperator = /*@__PURE__*/ function() {
    function TimeoutWithOperator(waitFor, absoluteTimeout, withObservable, scheduler) {
        this.waitFor = waitFor;
        this.absoluteTimeout = absoluteTimeout;
        this.withObservable = withObservable;
        this.scheduler = scheduler;
    }
    TimeoutWithOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new TimeoutWithSubscriber(subscriber, this.absoluteTimeout, this.waitFor, this.withObservable, this.scheduler));
    };
    return TimeoutWithOperator;
}();
var TimeoutWithSubscriber = /*@__PURE__*/ function(_super) {
    _tslib.__extends(TimeoutWithSubscriber, _super);
    function TimeoutWithSubscriber(destination, absoluteTimeout, waitFor, withObservable, scheduler) {
        var _this = _super.call(this, destination) || this;
        _this.absoluteTimeout = absoluteTimeout;
        _this.waitFor = waitFor;
        _this.withObservable = withObservable;
        _this.scheduler = scheduler;
        _this.scheduleTimeout();
        return _this;
    }
    TimeoutWithSubscriber.dispatchTimeout = function(subscriber) {
        var withObservable = subscriber.withObservable;
        subscriber._unsubscribeAndRecycle();
        subscriber.add((0, _innerSubscribe.innerSubscribe)(withObservable, new (0, _innerSubscribe.SimpleInnerSubscriber)(subscriber)));
    };
    TimeoutWithSubscriber.prototype.scheduleTimeout = function() {
        var action = this.action;
        if (action) this.action = action.schedule(this, this.waitFor);
        else this.add(this.action = this.scheduler.schedule(TimeoutWithSubscriber.dispatchTimeout, this.waitFor, this));
    };
    TimeoutWithSubscriber.prototype._next = function(value) {
        if (!this.absoluteTimeout) this.scheduleTimeout();
        _super.prototype._next.call(this, value);
    };
    TimeoutWithSubscriber.prototype._unsubscribe = function() {
        this.action = undefined;
        this.scheduler = null;
        this.withObservable = null;
    };
    return TimeoutWithSubscriber;
}((0, _innerSubscribe.SimpleOuterSubscriber));

},{"tslib":"kcqwq","../scheduler/async":"l1cmn","../util/isDate":"g98jK","../innerSubscribe":"73frt","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"cuNU1":[function(require,module,exports) {
/** PURE_IMPORTS_START _scheduler_async,_map PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "timestamp", ()=>timestamp);
parcelHelpers.export(exports, "Timestamp", ()=>Timestamp);
var _async = require("../scheduler/async");
var _map = require("./map");
function timestamp(scheduler) {
    if (scheduler === void 0) scheduler = (0, _async.async);
    return (0, _map.map)(function(value) {
        return new Timestamp(value, scheduler.now());
    });
}
var Timestamp = /*@__PURE__*/ function() {
    function Timestamp(value, timestamp) {
        this.value = value;
        this.timestamp = timestamp;
    }
    return Timestamp;
}();

},{"../scheduler/async":"l1cmn","./map":"cvzfg","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"ajufK":[function(require,module,exports) {
/** PURE_IMPORTS_START _reduce PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "toArray", ()=>toArray);
var _reduce = require("./reduce");
function toArrayReducer(arr, item, index) {
    if (index === 0) return [
        item
    ];
    arr.push(item);
    return arr;
}
function toArray() {
    return (0, _reduce.reduce)(toArrayReducer, []);
}

},{"./reduce":"8LzQg","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"kAG83":[function(require,module,exports) {
/** PURE_IMPORTS_START tslib,_Subject,_innerSubscribe PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "window", ()=>window);
var _tslib = require("tslib");
var _subject = require("../Subject");
var _innerSubscribe = require("../innerSubscribe");
function window(windowBoundaries) {
    return function windowOperatorFunction(source) {
        return source.lift(new WindowOperator(windowBoundaries));
    };
}
var WindowOperator = /*@__PURE__*/ function() {
    function WindowOperator(windowBoundaries) {
        this.windowBoundaries = windowBoundaries;
    }
    WindowOperator.prototype.call = function(subscriber, source) {
        var windowSubscriber = new WindowSubscriber(subscriber);
        var sourceSubscription = source.subscribe(windowSubscriber);
        if (!sourceSubscription.closed) windowSubscriber.add((0, _innerSubscribe.innerSubscribe)(this.windowBoundaries, new (0, _innerSubscribe.SimpleInnerSubscriber)(windowSubscriber)));
        return sourceSubscription;
    };
    return WindowOperator;
}();
var WindowSubscriber = /*@__PURE__*/ function(_super) {
    _tslib.__extends(WindowSubscriber, _super);
    function WindowSubscriber(destination) {
        var _this = _super.call(this, destination) || this;
        _this.window = new (0, _subject.Subject)();
        destination.next(_this.window);
        return _this;
    }
    WindowSubscriber.prototype.notifyNext = function() {
        this.openWindow();
    };
    WindowSubscriber.prototype.notifyError = function(error) {
        this._error(error);
    };
    WindowSubscriber.prototype.notifyComplete = function() {
        this._complete();
    };
    WindowSubscriber.prototype._next = function(value) {
        this.window.next(value);
    };
    WindowSubscriber.prototype._error = function(err) {
        this.window.error(err);
        this.destination.error(err);
    };
    WindowSubscriber.prototype._complete = function() {
        this.window.complete();
        this.destination.complete();
    };
    WindowSubscriber.prototype._unsubscribe = function() {
        this.window = null;
    };
    WindowSubscriber.prototype.openWindow = function() {
        var prevWindow = this.window;
        if (prevWindow) prevWindow.complete();
        var destination = this.destination;
        var newWindow = this.window = new (0, _subject.Subject)();
        destination.next(newWindow);
    };
    return WindowSubscriber;
}((0, _innerSubscribe.SimpleOuterSubscriber));

},{"tslib":"kcqwq","../Subject":"84bef","../innerSubscribe":"73frt","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"c5rVO":[function(require,module,exports) {
/** PURE_IMPORTS_START tslib,_Subscriber,_Subject PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "windowCount", ()=>windowCount);
var _tslib = require("tslib");
var _subscriber = require("../Subscriber");
var _subject = require("../Subject");
function windowCount(windowSize, startWindowEvery) {
    if (startWindowEvery === void 0) startWindowEvery = 0;
    return function windowCountOperatorFunction(source) {
        return source.lift(new WindowCountOperator(windowSize, startWindowEvery));
    };
}
var WindowCountOperator = /*@__PURE__*/ function() {
    function WindowCountOperator(windowSize, startWindowEvery) {
        this.windowSize = windowSize;
        this.startWindowEvery = startWindowEvery;
    }
    WindowCountOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new WindowCountSubscriber(subscriber, this.windowSize, this.startWindowEvery));
    };
    return WindowCountOperator;
}();
var WindowCountSubscriber = /*@__PURE__*/ function(_super) {
    _tslib.__extends(WindowCountSubscriber, _super);
    function WindowCountSubscriber(destination, windowSize, startWindowEvery) {
        var _this = _super.call(this, destination) || this;
        _this.destination = destination;
        _this.windowSize = windowSize;
        _this.startWindowEvery = startWindowEvery;
        _this.windows = [
            new (0, _subject.Subject)()
        ];
        _this.count = 0;
        destination.next(_this.windows[0]);
        return _this;
    }
    WindowCountSubscriber.prototype._next = function(value) {
        var startWindowEvery = this.startWindowEvery > 0 ? this.startWindowEvery : this.windowSize;
        var destination = this.destination;
        var windowSize = this.windowSize;
        var windows = this.windows;
        var len = windows.length;
        for(var i = 0; i < len && !this.closed; i++)windows[i].next(value);
        var c = this.count - windowSize + 1;
        if (c >= 0 && c % startWindowEvery === 0 && !this.closed) windows.shift().complete();
        if (++this.count % startWindowEvery === 0 && !this.closed) {
            var window_1 = new (0, _subject.Subject)();
            windows.push(window_1);
            destination.next(window_1);
        }
    };
    WindowCountSubscriber.prototype._error = function(err) {
        var windows = this.windows;
        if (windows) while(windows.length > 0 && !this.closed)windows.shift().error(err);
        this.destination.error(err);
    };
    WindowCountSubscriber.prototype._complete = function() {
        var windows = this.windows;
        if (windows) while(windows.length > 0 && !this.closed)windows.shift().complete();
        this.destination.complete();
    };
    WindowCountSubscriber.prototype._unsubscribe = function() {
        this.count = 0;
        this.windows = null;
    };
    return WindowCountSubscriber;
}((0, _subscriber.Subscriber));

},{"tslib":"kcqwq","../Subscriber":"jGx8F","../Subject":"84bef","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"1eYrc":[function(require,module,exports) {
/** PURE_IMPORTS_START tslib,_Subject,_scheduler_async,_Subscriber,_util_isNumeric,_util_isScheduler PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "windowTime", ()=>windowTime);
var _tslib = require("tslib");
var _subject = require("../Subject");
var _async = require("../scheduler/async");
var _subscriber = require("../Subscriber");
var _isNumeric = require("../util/isNumeric");
var _isScheduler = require("../util/isScheduler");
function windowTime(windowTimeSpan) {
    var scheduler = (0, _async.async);
    var windowCreationInterval = null;
    var maxWindowSize = Number.POSITIVE_INFINITY;
    if ((0, _isScheduler.isScheduler)(arguments[3])) scheduler = arguments[3];
    if ((0, _isScheduler.isScheduler)(arguments[2])) scheduler = arguments[2];
    else if ((0, _isNumeric.isNumeric)(arguments[2])) maxWindowSize = Number(arguments[2]);
    if ((0, _isScheduler.isScheduler)(arguments[1])) scheduler = arguments[1];
    else if ((0, _isNumeric.isNumeric)(arguments[1])) windowCreationInterval = Number(arguments[1]);
    return function windowTimeOperatorFunction(source) {
        return source.lift(new WindowTimeOperator(windowTimeSpan, windowCreationInterval, maxWindowSize, scheduler));
    };
}
var WindowTimeOperator = /*@__PURE__*/ function() {
    function WindowTimeOperator(windowTimeSpan, windowCreationInterval, maxWindowSize, scheduler) {
        this.windowTimeSpan = windowTimeSpan;
        this.windowCreationInterval = windowCreationInterval;
        this.maxWindowSize = maxWindowSize;
        this.scheduler = scheduler;
    }
    WindowTimeOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new WindowTimeSubscriber(subscriber, this.windowTimeSpan, this.windowCreationInterval, this.maxWindowSize, this.scheduler));
    };
    return WindowTimeOperator;
}();
var CountedSubject = /*@__PURE__*/ function(_super) {
    _tslib.__extends(CountedSubject, _super);
    function CountedSubject() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._numberOfNextedValues = 0;
        return _this;
    }
    CountedSubject.prototype.next = function(value) {
        this._numberOfNextedValues++;
        _super.prototype.next.call(this, value);
    };
    Object.defineProperty(CountedSubject.prototype, "numberOfNextedValues", {
        get: function() {
            return this._numberOfNextedValues;
        },
        enumerable: true,
        configurable: true
    });
    return CountedSubject;
}((0, _subject.Subject));
var WindowTimeSubscriber = /*@__PURE__*/ function(_super) {
    _tslib.__extends(WindowTimeSubscriber, _super);
    function WindowTimeSubscriber(destination, windowTimeSpan, windowCreationInterval, maxWindowSize, scheduler) {
        var _this = _super.call(this, destination) || this;
        _this.destination = destination;
        _this.windowTimeSpan = windowTimeSpan;
        _this.windowCreationInterval = windowCreationInterval;
        _this.maxWindowSize = maxWindowSize;
        _this.scheduler = scheduler;
        _this.windows = [];
        var window = _this.openWindow();
        if (windowCreationInterval !== null && windowCreationInterval >= 0) {
            var closeState = {
                subscriber: _this,
                window: window,
                context: null
            };
            var creationState = {
                windowTimeSpan: windowTimeSpan,
                windowCreationInterval: windowCreationInterval,
                subscriber: _this,
                scheduler: scheduler
            };
            _this.add(scheduler.schedule(dispatchWindowClose, windowTimeSpan, closeState));
            _this.add(scheduler.schedule(dispatchWindowCreation, windowCreationInterval, creationState));
        } else {
            var timeSpanOnlyState = {
                subscriber: _this,
                window: window,
                windowTimeSpan: windowTimeSpan
            };
            _this.add(scheduler.schedule(dispatchWindowTimeSpanOnly, windowTimeSpan, timeSpanOnlyState));
        }
        return _this;
    }
    WindowTimeSubscriber.prototype._next = function(value) {
        var windows = this.windows;
        var len = windows.length;
        for(var i = 0; i < len; i++){
            var window_1 = windows[i];
            if (!window_1.closed) {
                window_1.next(value);
                if (window_1.numberOfNextedValues >= this.maxWindowSize) this.closeWindow(window_1);
            }
        }
    };
    WindowTimeSubscriber.prototype._error = function(err) {
        var windows = this.windows;
        while(windows.length > 0)windows.shift().error(err);
        this.destination.error(err);
    };
    WindowTimeSubscriber.prototype._complete = function() {
        var windows = this.windows;
        while(windows.length > 0){
            var window_2 = windows.shift();
            if (!window_2.closed) window_2.complete();
        }
        this.destination.complete();
    };
    WindowTimeSubscriber.prototype.openWindow = function() {
        var window = new CountedSubject();
        this.windows.push(window);
        var destination = this.destination;
        destination.next(window);
        return window;
    };
    WindowTimeSubscriber.prototype.closeWindow = function(window) {
        window.complete();
        var windows = this.windows;
        windows.splice(windows.indexOf(window), 1);
    };
    return WindowTimeSubscriber;
}((0, _subscriber.Subscriber));
function dispatchWindowTimeSpanOnly(state) {
    var subscriber = state.subscriber, windowTimeSpan = state.windowTimeSpan, window = state.window;
    if (window) subscriber.closeWindow(window);
    state.window = subscriber.openWindow();
    this.schedule(state, windowTimeSpan);
}
function dispatchWindowCreation(state) {
    var windowTimeSpan = state.windowTimeSpan, subscriber = state.subscriber, scheduler = state.scheduler, windowCreationInterval = state.windowCreationInterval;
    var window = subscriber.openWindow();
    var action = this;
    var context = {
        action: action,
        subscription: null
    };
    var timeSpanState = {
        subscriber: subscriber,
        window: window,
        context: context
    };
    context.subscription = scheduler.schedule(dispatchWindowClose, windowTimeSpan, timeSpanState);
    action.add(context.subscription);
    action.schedule(state, windowCreationInterval);
}
function dispatchWindowClose(state) {
    var subscriber = state.subscriber, window = state.window, context = state.context;
    if (context && context.action && context.subscription) context.action.remove(context.subscription);
    subscriber.closeWindow(window);
}

},{"tslib":"kcqwq","../Subject":"84bef","../scheduler/async":"l1cmn","../Subscriber":"jGx8F","../util/isNumeric":"i95aV","../util/isScheduler":"4iYg4","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"iNHIA":[function(require,module,exports) {
/** PURE_IMPORTS_START tslib,_Subject,_Subscription,_OuterSubscriber,_util_subscribeToResult PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "windowToggle", ()=>windowToggle);
var _tslib = require("tslib");
var _subject = require("../Subject");
var _subscription = require("../Subscription");
var _outerSubscriber = require("../OuterSubscriber");
var _subscribeToResult = require("../util/subscribeToResult");
function windowToggle(openings, closingSelector) {
    return function(source) {
        return source.lift(new WindowToggleOperator(openings, closingSelector));
    };
}
var WindowToggleOperator = /*@__PURE__*/ function() {
    function WindowToggleOperator(openings, closingSelector) {
        this.openings = openings;
        this.closingSelector = closingSelector;
    }
    WindowToggleOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new WindowToggleSubscriber(subscriber, this.openings, this.closingSelector));
    };
    return WindowToggleOperator;
}();
var WindowToggleSubscriber = /*@__PURE__*/ function(_super) {
    _tslib.__extends(WindowToggleSubscriber, _super);
    function WindowToggleSubscriber(destination, openings, closingSelector) {
        var _this = _super.call(this, destination) || this;
        _this.openings = openings;
        _this.closingSelector = closingSelector;
        _this.contexts = [];
        _this.add(_this.openSubscription = (0, _subscribeToResult.subscribeToResult)(_this, openings, openings));
        return _this;
    }
    WindowToggleSubscriber.prototype._next = function(value) {
        var contexts = this.contexts;
        if (contexts) {
            var len = contexts.length;
            for(var i = 0; i < len; i++)contexts[i].window.next(value);
        }
    };
    WindowToggleSubscriber.prototype._error = function(err) {
        var contexts = this.contexts;
        this.contexts = null;
        if (contexts) {
            var len = contexts.length;
            var index = -1;
            while(++index < len){
                var context_1 = contexts[index];
                context_1.window.error(err);
                context_1.subscription.unsubscribe();
            }
        }
        _super.prototype._error.call(this, err);
    };
    WindowToggleSubscriber.prototype._complete = function() {
        var contexts = this.contexts;
        this.contexts = null;
        if (contexts) {
            var len = contexts.length;
            var index = -1;
            while(++index < len){
                var context_2 = contexts[index];
                context_2.window.complete();
                context_2.subscription.unsubscribe();
            }
        }
        _super.prototype._complete.call(this);
    };
    WindowToggleSubscriber.prototype._unsubscribe = function() {
        var contexts = this.contexts;
        this.contexts = null;
        if (contexts) {
            var len = contexts.length;
            var index = -1;
            while(++index < len){
                var context_3 = contexts[index];
                context_3.window.unsubscribe();
                context_3.subscription.unsubscribe();
            }
        }
    };
    WindowToggleSubscriber.prototype.notifyNext = function(outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        if (outerValue === this.openings) {
            var closingNotifier = void 0;
            try {
                var closingSelector = this.closingSelector;
                closingNotifier = closingSelector(innerValue);
            } catch (e) {
                return this.error(e);
            }
            var window_1 = new (0, _subject.Subject)();
            var subscription = new (0, _subscription.Subscription)();
            var context_4 = {
                window: window_1,
                subscription: subscription
            };
            this.contexts.push(context_4);
            var innerSubscription = (0, _subscribeToResult.subscribeToResult)(this, closingNotifier, context_4);
            if (innerSubscription.closed) this.closeWindow(this.contexts.length - 1);
            else {
                innerSubscription.context = context_4;
                subscription.add(innerSubscription);
            }
            this.destination.next(window_1);
        } else this.closeWindow(this.contexts.indexOf(outerValue));
    };
    WindowToggleSubscriber.prototype.notifyError = function(err) {
        this.error(err);
    };
    WindowToggleSubscriber.prototype.notifyComplete = function(inner) {
        if (inner !== this.openSubscription) this.closeWindow(this.contexts.indexOf(inner.context));
    };
    WindowToggleSubscriber.prototype.closeWindow = function(index) {
        if (index === -1) return;
        var contexts = this.contexts;
        var context = contexts[index];
        var window = context.window, subscription = context.subscription;
        contexts.splice(index, 1);
        window.complete();
        subscription.unsubscribe();
    };
    return WindowToggleSubscriber;
}((0, _outerSubscriber.OuterSubscriber));

},{"tslib":"kcqwq","../Subject":"84bef","../Subscription":"ahthJ","../OuterSubscriber":"fECUl","../util/subscribeToResult":"4ctqX","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"iz1YG":[function(require,module,exports) {
/** PURE_IMPORTS_START tslib,_Subject,_OuterSubscriber,_util_subscribeToResult PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "windowWhen", ()=>windowWhen);
var _tslib = require("tslib");
var _subject = require("../Subject");
var _outerSubscriber = require("../OuterSubscriber");
var _subscribeToResult = require("../util/subscribeToResult");
function windowWhen(closingSelector) {
    return function windowWhenOperatorFunction(source) {
        return source.lift(new WindowOperator(closingSelector));
    };
}
var WindowOperator = /*@__PURE__*/ function() {
    function WindowOperator(closingSelector) {
        this.closingSelector = closingSelector;
    }
    WindowOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new WindowSubscriber(subscriber, this.closingSelector));
    };
    return WindowOperator;
}();
var WindowSubscriber = /*@__PURE__*/ function(_super) {
    _tslib.__extends(WindowSubscriber, _super);
    function WindowSubscriber(destination, closingSelector) {
        var _this = _super.call(this, destination) || this;
        _this.destination = destination;
        _this.closingSelector = closingSelector;
        _this.openWindow();
        return _this;
    }
    WindowSubscriber.prototype.notifyNext = function(_outerValue, _innerValue, _outerIndex, _innerIndex, innerSub) {
        this.openWindow(innerSub);
    };
    WindowSubscriber.prototype.notifyError = function(error) {
        this._error(error);
    };
    WindowSubscriber.prototype.notifyComplete = function(innerSub) {
        this.openWindow(innerSub);
    };
    WindowSubscriber.prototype._next = function(value) {
        this.window.next(value);
    };
    WindowSubscriber.prototype._error = function(err) {
        this.window.error(err);
        this.destination.error(err);
        this.unsubscribeClosingNotification();
    };
    WindowSubscriber.prototype._complete = function() {
        this.window.complete();
        this.destination.complete();
        this.unsubscribeClosingNotification();
    };
    WindowSubscriber.prototype.unsubscribeClosingNotification = function() {
        if (this.closingNotification) this.closingNotification.unsubscribe();
    };
    WindowSubscriber.prototype.openWindow = function(innerSub) {
        if (innerSub === void 0) innerSub = null;
        if (innerSub) {
            this.remove(innerSub);
            innerSub.unsubscribe();
        }
        var prevWindow = this.window;
        if (prevWindow) prevWindow.complete();
        var window = this.window = new (0, _subject.Subject)();
        this.destination.next(window);
        var closingNotifier;
        try {
            var closingSelector = this.closingSelector;
            closingNotifier = closingSelector();
        } catch (e) {
            this.destination.error(e);
            this.window.error(e);
            return;
        }
        this.add(this.closingNotification = (0, _subscribeToResult.subscribeToResult)(this, closingNotifier));
    };
    return WindowSubscriber;
}((0, _outerSubscriber.OuterSubscriber));

},{"tslib":"kcqwq","../Subject":"84bef","../OuterSubscriber":"fECUl","../util/subscribeToResult":"4ctqX","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"fqcM0":[function(require,module,exports) {
/** PURE_IMPORTS_START tslib,_OuterSubscriber,_util_subscribeToResult PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "withLatestFrom", ()=>withLatestFrom);
var _tslib = require("tslib");
var _outerSubscriber = require("../OuterSubscriber");
var _subscribeToResult = require("../util/subscribeToResult");
function withLatestFrom() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    return function(source) {
        var project;
        if (typeof args[args.length - 1] === "function") project = args.pop();
        var observables = args;
        return source.lift(new WithLatestFromOperator(observables, project));
    };
}
var WithLatestFromOperator = /*@__PURE__*/ function() {
    function WithLatestFromOperator(observables, project) {
        this.observables = observables;
        this.project = project;
    }
    WithLatestFromOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new WithLatestFromSubscriber(subscriber, this.observables, this.project));
    };
    return WithLatestFromOperator;
}();
var WithLatestFromSubscriber = /*@__PURE__*/ function(_super) {
    _tslib.__extends(WithLatestFromSubscriber, _super);
    function WithLatestFromSubscriber(destination, observables, project) {
        var _this = _super.call(this, destination) || this;
        _this.observables = observables;
        _this.project = project;
        _this.toRespond = [];
        var len = observables.length;
        _this.values = new Array(len);
        for(var i = 0; i < len; i++)_this.toRespond.push(i);
        for(var i = 0; i < len; i++){
            var observable = observables[i];
            _this.add((0, _subscribeToResult.subscribeToResult)(_this, observable, undefined, i));
        }
        return _this;
    }
    WithLatestFromSubscriber.prototype.notifyNext = function(_outerValue, innerValue, outerIndex) {
        this.values[outerIndex] = innerValue;
        var toRespond = this.toRespond;
        if (toRespond.length > 0) {
            var found = toRespond.indexOf(outerIndex);
            if (found !== -1) toRespond.splice(found, 1);
        }
    };
    WithLatestFromSubscriber.prototype.notifyComplete = function() {};
    WithLatestFromSubscriber.prototype._next = function(value) {
        if (this.toRespond.length === 0) {
            var args = [
                value
            ].concat(this.values);
            if (this.project) this._tryProject(args);
            else this.destination.next(args);
        }
    };
    WithLatestFromSubscriber.prototype._tryProject = function(args) {
        var result;
        try {
            result = this.project.apply(this, args);
        } catch (err) {
            this.destination.error(err);
            return;
        }
        this.destination.next(result);
    };
    return WithLatestFromSubscriber;
}((0, _outerSubscriber.OuterSubscriber));

},{"tslib":"kcqwq","../OuterSubscriber":"fECUl","../util/subscribeToResult":"4ctqX","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"dfA7f":[function(require,module,exports) {
/** PURE_IMPORTS_START _observable_zip PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "zip", ()=>zip);
var _zip = require("../observable/zip");
function zip() {
    var observables = [];
    for(var _i = 0; _i < arguments.length; _i++)observables[_i] = arguments[_i];
    return function zipOperatorFunction(source) {
        return source.lift.call((0, _zip.zip).apply(void 0, [
            source
        ].concat(observables)));
    };
}

},{"../observable/zip":"57TWv","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"1bLGR":[function(require,module,exports) {
/** PURE_IMPORTS_START _observable_zip PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "zipAll", ()=>zipAll);
var _zip = require("../observable/zip");
function zipAll(project) {
    return function(source) {
        return source.lift(new (0, _zip.ZipOperator)(project));
    };
}

},{"../observable/zip":"57TWv","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9zvgH":[function(require,module,exports) {
var Buffer = require("9b2f506563f7a51c").Buffer;
"use strict";
// Copyright (c) 2018-2020 WalletLink.org <https://www.walletlink.org/>
// Copyright (c) 2018-2020 Coinbase, Inc. <https://www.coinbase.com/>
// Licensed under the Apache License, version 2.0
var __importDefault = this && this.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getFavicon = exports.range = exports.isBigNumber = exports.ensureParsedJSONObject = exports.ensureBN = exports.ensureRegExpString = exports.ensureIntNumber = exports.ensureBuffer = exports.ensureAddressString = exports.ensureEvenLengthHexString = exports.ensureHexString = exports.isHexString = exports.prepend0x = exports.strip0x = exports.has0xPrefix = exports.hexStringFromIntNumber = exports.intNumberFromHexString = exports.bigIntStringFromBN = exports.hexStringFromBuffer = exports.hexStringToUint8Array = exports.uint8ArrayToHex = exports.randomBytesHex = void 0;
const bn_js_1 = __importDefault(require("eb1095d5bb355c04"));
const types_1 = require("f5747abc3ab7a639");
const INT_STRING_REGEX = /^[0-9]*$/;
const HEXADECIMAL_STRING_REGEX = /^[a-f0-9]*$/;
/**
 * @param length number of bytes
 */ function randomBytesHex(length) {
    return uint8ArrayToHex(crypto.getRandomValues(new Uint8Array(length)));
}
exports.randomBytesHex = randomBytesHex;
function uint8ArrayToHex(value) {
    return [
        ...value
    ].map((b)=>b.toString(16).padStart(2, "0")).join("");
}
exports.uint8ArrayToHex = uint8ArrayToHex;
function hexStringToUint8Array(hexString) {
    return new Uint8Array(hexString.match(/.{1,2}/g).map((byte)=>parseInt(byte, 16)));
}
exports.hexStringToUint8Array = hexStringToUint8Array;
function hexStringFromBuffer(buf, includePrefix = false) {
    const hex = buf.toString("hex");
    return (0, types_1.HexString)(includePrefix ? "0x" + hex : hex);
}
exports.hexStringFromBuffer = hexStringFromBuffer;
function bigIntStringFromBN(bn) {
    return (0, types_1.BigIntString)(bn.toString(10));
}
exports.bigIntStringFromBN = bigIntStringFromBN;
function intNumberFromHexString(hex) {
    return (0, types_1.IntNumber)(new bn_js_1.default(ensureEvenLengthHexString(hex, false), 16).toNumber());
}
exports.intNumberFromHexString = intNumberFromHexString;
function hexStringFromIntNumber(num) {
    return (0, types_1.HexString)("0x" + new bn_js_1.default(num).toString(16));
}
exports.hexStringFromIntNumber = hexStringFromIntNumber;
function has0xPrefix(str) {
    return str.startsWith("0x") || str.startsWith("0X");
}
exports.has0xPrefix = has0xPrefix;
function strip0x(hex) {
    if (has0xPrefix(hex)) return hex.slice(2);
    return hex;
}
exports.strip0x = strip0x;
function prepend0x(hex) {
    if (has0xPrefix(hex)) return "0x" + hex.slice(2);
    return "0x" + hex;
}
exports.prepend0x = prepend0x;
function isHexString(hex) {
    if (typeof hex !== "string") return false;
    const s = strip0x(hex).toLowerCase();
    return HEXADECIMAL_STRING_REGEX.test(s);
}
exports.isHexString = isHexString;
function ensureHexString(hex, includePrefix = false) {
    if (typeof hex === "string") {
        const s = strip0x(hex).toLowerCase();
        if (HEXADECIMAL_STRING_REGEX.test(s)) return (0, types_1.HexString)(includePrefix ? "0x" + s : s);
    }
    throw new Error(`"${String(hex)}" is not a hexadecimal string`);
}
exports.ensureHexString = ensureHexString;
function ensureEvenLengthHexString(hex, includePrefix = false) {
    let h = ensureHexString(hex, false);
    if (h.length % 2 === 1) h = (0, types_1.HexString)("0" + h);
    return includePrefix ? (0, types_1.HexString)("0x" + h) : h;
}
exports.ensureEvenLengthHexString = ensureEvenLengthHexString;
function ensureAddressString(str) {
    if (typeof str === "string") {
        const s = strip0x(str).toLowerCase();
        if (isHexString(s) && s.length === 40) return (0, types_1.AddressString)(prepend0x(s));
    }
    throw new Error(`Invalid Ethereum address: ${String(str)}`);
}
exports.ensureAddressString = ensureAddressString;
function ensureBuffer(str) {
    if (Buffer.isBuffer(str)) return str;
    if (typeof str === "string") {
        if (isHexString(str)) {
            const s = ensureEvenLengthHexString(str, false);
            return Buffer.from(s, "hex");
        } else return Buffer.from(str, "utf8");
    }
    throw new Error(`Not binary data: ${String(str)}`);
}
exports.ensureBuffer = ensureBuffer;
function ensureIntNumber(num) {
    if (typeof num === "number" && Number.isInteger(num)) return (0, types_1.IntNumber)(num);
    if (typeof num === "string") {
        if (INT_STRING_REGEX.test(num)) return (0, types_1.IntNumber)(Number(num));
        if (isHexString(num)) return (0, types_1.IntNumber)(new bn_js_1.default(ensureEvenLengthHexString(num, false), 16).toNumber());
    }
    throw new Error(`Not an integer: ${String(num)}`);
}
exports.ensureIntNumber = ensureIntNumber;
function ensureRegExpString(regExp) {
    if (regExp instanceof RegExp) return (0, types_1.RegExpString)(regExp.toString());
    throw new Error(`Not a RegExp: ${String(regExp)}`);
}
exports.ensureRegExpString = ensureRegExpString;
function ensureBN(val) {
    if (val !== null && (bn_js_1.default.isBN(val) || isBigNumber(val))) return new bn_js_1.default(val.toString(10), 10);
    if (typeof val === "number") return new bn_js_1.default(ensureIntNumber(val));
    if (typeof val === "string") {
        if (INT_STRING_REGEX.test(val)) return new bn_js_1.default(val, 10);
        if (isHexString(val)) return new bn_js_1.default(ensureEvenLengthHexString(val, false), 16);
    }
    throw new Error(`Not an integer: ${String(val)}`);
}
exports.ensureBN = ensureBN;
function ensureParsedJSONObject(val) {
    if (typeof val === "string") return JSON.parse(val);
    if (typeof val === "object") return val;
    throw new Error(`Not a JSON string or an object: ${String(val)}`);
}
exports.ensureParsedJSONObject = ensureParsedJSONObject;
function isBigNumber(val) {
    if (val == null || typeof val.constructor !== "function") return false;
    const { constructor } = val;
    return typeof constructor.config === "function" && typeof constructor.EUCLID === "number";
}
exports.isBigNumber = isBigNumber;
function range(start, stop) {
    return Array.from({
        length: stop - start
    }, (_, i)=>start + i);
}
exports.range = range;
function getFavicon() {
    const el = document.querySelector('link[sizes="192x192"]') || document.querySelector('link[sizes="180x180"]') || document.querySelector('link[rel="icon"]') || document.querySelector('link[rel="shortcut icon"]');
    const { protocol, host } = document.location;
    const href = el ? el.getAttribute("href") : null;
    if (!href || href.startsWith("javascript:")) return null;
    if (href.startsWith("http://") || href.startsWith("https://") || href.startsWith("data:")) return href;
    if (href.startsWith("//")) return protocol + href;
    return `${protocol}//${host}${href}`;
}
exports.getFavicon = getFavicon;

},{"9b2f506563f7a51c":"l5Twm","eb1095d5bb355c04":"4AVaT","f5747abc3ab7a639":"hGqkR"}],"hGqkR":[function(require,module,exports) {
"use strict";
// Copyright (c) 2018-2020 WalletLink.org <https://www.walletlink.org/>
// Copyright (c) 2018-2020 Coinbase, Inc. <https://www.coinbase.com/>
// Licensed under the Apache License, version 2.0
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.RegExpString = exports.IntNumber = exports.BigIntString = exports.AddressString = exports.HexString = exports.OpaqueType = void 0;
function OpaqueType() {
    return (value)=>value;
}
exports.OpaqueType = OpaqueType;
exports.HexString = OpaqueType();
exports.AddressString = OpaqueType();
exports.BigIntString = OpaqueType();
function IntNumber(num) {
    return Math.floor(num);
}
exports.IntNumber = IntNumber;
exports.RegExpString = OpaqueType();

},{}],"djqpq":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.WalletLinkRelayAbstract = exports.APP_VERSION_KEY = exports.LOCAL_STORAGE_ADDRESSES_KEY = exports.WALLET_USER_NAME_KEY = void 0;
const eth_rpc_errors_1 = require("ece0daee49f1fd2d");
exports.WALLET_USER_NAME_KEY = "walletUsername";
exports.LOCAL_STORAGE_ADDRESSES_KEY = "Addresses";
exports.APP_VERSION_KEY = "AppVersion";
class WalletLinkRelayAbstract {
    async makeEthereumJSONRPCRequest(request, jsonRpcUrl) {
        if (!jsonRpcUrl) throw new Error("Error: No jsonRpcUrl provided");
        return window.fetch(jsonRpcUrl, {
            method: "POST",
            body: JSON.stringify(request),
            mode: "cors",
            headers: {
                "Content-Type": "application/json"
            }
        }).then((res)=>res.json()).then((json)=>{
            if (!json) throw eth_rpc_errors_1.ethErrors.rpc.parse({});
            const response = json;
            const { error } = response;
            if (error) throw (0, eth_rpc_errors_1.serializeError)(error);
            return response;
        });
    }
}
exports.WalletLinkRelayAbstract = WalletLinkRelayAbstract;

},{"ece0daee49f1fd2d":"9cATh"}],"dBZmV":[function(require,module,exports) {
var Buffer = require("8c9179f976064c5d").Buffer;
const util = require("b8c03d464496db4a");
const abi = require("ae0fa2be8f45f24c");
const TYPED_MESSAGE_SCHEMA = {
    type: "object",
    properties: {
        types: {
            type: "object",
            additionalProperties: {
                type: "array",
                items: {
                    type: "object",
                    properties: {
                        name: {
                            type: "string"
                        },
                        type: {
                            type: "string"
                        }
                    },
                    required: [
                        "name",
                        "type"
                    ]
                }
            }
        },
        primaryType: {
            type: "string"
        },
        domain: {
            type: "object"
        },
        message: {
            type: "object"
        }
    },
    required: [
        "types",
        "primaryType",
        "domain",
        "message"
    ]
};
/**
 * A collection of utility functions used for signing typed data
 */ const TypedDataUtils = {
    /**
   * Encodes an object by encoding and concatenating each of its members
   *
   * @param {string} primaryType - Root type
   * @param {Object} data - Object to encode
   * @param {Object} types - Type definitions
   * @returns {string} - Encoded representation of an object
   */ encodeData (primaryType, data, types, useV4 = true) {
        const encodedTypes = [
            "bytes32"
        ];
        const encodedValues = [
            this.hashType(primaryType, types)
        ];
        if (useV4) {
            const encodeField = (name, type, value)=>{
                if (types[type] !== undefined) return [
                    "bytes32",
                    value == null ? "0x0000000000000000000000000000000000000000000000000000000000000000" : util.keccak(this.encodeData(type, value, types, useV4))
                ];
                if (value === undefined) throw new Error(`missing value for field ${name} of type ${type}`);
                if (type === "bytes") return [
                    "bytes32",
                    util.keccak(value)
                ];
                if (type === "string") {
                    // convert string to buffer - prevents ethUtil from interpreting strings like '0xabcd' as hex
                    if (typeof value === "string") value = Buffer.from(value, "utf8");
                    return [
                        "bytes32",
                        util.keccak(value)
                    ];
                }
                if (type.lastIndexOf("]") === type.length - 1) {
                    const parsedType = type.slice(0, type.lastIndexOf("["));
                    const typeValuePairs = value.map((item)=>encodeField(name, parsedType, item));
                    return [
                        "bytes32",
                        util.keccak(abi.rawEncode(typeValuePairs.map(([type])=>type), typeValuePairs.map(([, value])=>value)))
                    ];
                }
                return [
                    type,
                    value
                ];
            };
            for (const field of types[primaryType]){
                const [type, value] = encodeField(field.name, field.type, data[field.name]);
                encodedTypes.push(type);
                encodedValues.push(value);
            }
        } else for (const field of types[primaryType]){
            let value = data[field.name];
            if (value !== undefined) {
                if (field.type === "bytes") {
                    encodedTypes.push("bytes32");
                    value = util.keccak(value);
                    encodedValues.push(value);
                } else if (field.type === "string") {
                    encodedTypes.push("bytes32");
                    // convert string to buffer - prevents ethUtil from interpreting strings like '0xabcd' as hex
                    if (typeof value === "string") value = Buffer.from(value, "utf8");
                    value = util.keccak(value);
                    encodedValues.push(value);
                } else if (types[field.type] !== undefined) {
                    encodedTypes.push("bytes32");
                    value = util.keccak(this.encodeData(field.type, value, types, useV4));
                    encodedValues.push(value);
                } else if (field.type.lastIndexOf("]") === field.type.length - 1) throw new Error("Arrays currently unimplemented in encodeData");
                else {
                    encodedTypes.push(field.type);
                    encodedValues.push(value);
                }
            }
        }
        return abi.rawEncode(encodedTypes, encodedValues);
    },
    /**
   * Encodes the type of an object by encoding a comma delimited list of its members
   *
   * @param {string} primaryType - Root type to encode
   * @param {Object} types - Type definitions
   * @returns {string} - Encoded representation of the type of an object
   */ encodeType (primaryType, types) {
        let result = "";
        let deps = this.findTypeDependencies(primaryType, types).filter((dep)=>dep !== primaryType);
        deps = [
            primaryType
        ].concat(deps.sort());
        for (const type of deps){
            const children = types[type];
            if (!children) throw new Error("No type definition specified: " + type);
            result += type + "(" + types[type].map(({ name, type })=>type + " " + name).join(",") + ")";
        }
        return result;
    },
    /**
   * Finds all types within a type defintion object
   *
   * @param {string} primaryType - Root type
   * @param {Object} types - Type definitions
   * @param {Array} results - current set of accumulated types
   * @returns {Array} - Set of all types found in the type definition
   */ findTypeDependencies (primaryType, types, results = []) {
        primaryType = primaryType.match(/^\w*/)[0];
        if (results.includes(primaryType) || types[primaryType] === undefined) return results;
        results.push(primaryType);
        for (const field of types[primaryType])for (const dep of this.findTypeDependencies(field.type, types, results))!results.includes(dep) && results.push(dep);
        return results;
    },
    /**
   * Hashes an object
   *
   * @param {string} primaryType - Root type
   * @param {Object} data - Object to hash
   * @param {Object} types - Type definitions
   * @returns {string} - Hash of an object
   */ hashStruct (primaryType, data, types, useV4 = true) {
        return util.keccak(this.encodeData(primaryType, data, types, useV4));
    },
    /**
   * Hashes the type of an object
   *
   * @param {string} primaryType - Root type to hash
   * @param {Object} types - Type definitions
   * @returns {string} - Hash of an object
   */ hashType (primaryType, types) {
        return util.keccak(this.encodeType(primaryType, types));
    },
    /**
   * Removes properties from a message object that are not defined per EIP-712
   *
   * @param {Object} data - typed message object
   * @returns {Object} - typed message object with only allowed fields
   */ sanitizeData (data) {
        const sanitizedData = {};
        for(const key in TYPED_MESSAGE_SCHEMA.properties)data[key] && (sanitizedData[key] = data[key]);
        if (sanitizedData.types) sanitizedData.types = Object.assign({
            EIP712Domain: []
        }, sanitizedData.types);
        return sanitizedData;
    },
    /**
   * Returns the hash of a typed message as per EIP-712 for signing
   *
   * @param {Object} typedData - Types message data to sign
   * @returns {string} - sha3 hash for signing
   */ hash (typedData, useV4 = true) {
        const sanitizedData = this.sanitizeData(typedData);
        const parts = [
            Buffer.from("1901", "hex")
        ];
        parts.push(this.hashStruct("EIP712Domain", sanitizedData.domain, sanitizedData.types, useV4));
        if (sanitizedData.primaryType !== "EIP712Domain") parts.push(this.hashStruct(sanitizedData.primaryType, sanitizedData.message, sanitizedData.types, useV4));
        return util.keccak(Buffer.concat(parts));
    }
};
module.exports = {
    TYPED_MESSAGE_SCHEMA,
    TypedDataUtils,
    hashForSignTypedDataLegacy: function(msgParams) {
        return typedSignatureHashLegacy(msgParams.data);
    },
    hashForSignTypedData_v3: function(msgParams) {
        return TypedDataUtils.hash(msgParams.data, false);
    },
    hashForSignTypedData_v4: function(msgParams) {
        return TypedDataUtils.hash(msgParams.data);
    }
};
/**
 * @param typedData - Array of data along with types, as per EIP712.
 * @returns Buffer
 */ function typedSignatureHashLegacy(typedData) {
    const error = new Error("Expect argument to be non-empty array");
    if (typeof typedData !== "object" || !typedData.length) throw error;
    const data = typedData.map(function(e) {
        return e.type === "bytes" ? util.toBuffer(e.value) : e.value;
    });
    const types = typedData.map(function(e) {
        return e.type;
    });
    const schema = typedData.map(function(e) {
        if (!e.name) throw error;
        return e.type + " " + e.name;
    });
    return abi.soliditySHA3([
        "bytes32",
        "bytes32"
    ], [
        abi.soliditySHA3(new Array(typedData.length).fill("string"), schema),
        abi.soliditySHA3(types, data)
    ]);
}

},{"8c9179f976064c5d":"l5Twm","b8c03d464496db4a":"lTqVn","ae0fa2be8f45f24c":"PGhuW"}],"lTqVn":[function(require,module,exports) {
// Extracted from https://github.com/ethereumjs/ethereumjs-util and stripped out irrelevant code
// Original code licensed under the Mozilla Public License Version 2.0
var Buffer = require("737ff4b40e5e6ef0").Buffer;
const createKeccakHash = require("2441f35b3b95e5d5");
const BN = require("9298dd1d5be5ccc6");
/**
 * Returns a buffer filled with 0s
 * @method zeros
 * @param {Number} bytes  the number of bytes the buffer should be
 * @return {Buffer}
 */ function zeros(bytes) {
    return Buffer.allocUnsafe(bytes).fill(0);
}
/**
 * Left Pads an `Array` or `Buffer` with leading zeros till it has `length` bytes.
 * Or it truncates the beginning if it exceeds.
 * @method setLength
 * @param {Buffer|Array} msg the value to pad
 * @param {Number} length the number of bytes the output should be
 * @param {Boolean} [right=false] whether to start padding form the left or right
 * @return {Buffer|Array}
 */ function setLength(msg, length, right) {
    const buf = zeros(length);
    msg = toBuffer(msg);
    if (right) {
        if (msg.length < length) {
            msg.copy(buf);
            return buf;
        }
        return msg.slice(0, length);
    } else {
        if (msg.length < length) {
            msg.copy(buf, length - msg.length);
            return buf;
        }
        return msg.slice(-length);
    }
}
/**
 * Right Pads an `Array` or `Buffer` with leading zeros till it has `length` bytes.
 * Or it truncates the beginning if it exceeds.
 * @param {Buffer|Array} msg the value to pad
 * @param {Number} length the number of bytes the output should be
 * @return {Buffer|Array}
 */ function setLengthRight(msg, length) {
    return setLength(msg, length, true);
}
/**
 * Attempts to turn a value into a `Buffer`. As input it supports `Buffer`, `String`, `Number`, null/undefined, `BN` and other objects with a `toArray()` method.
 * @param {*} v the value
 */ function toBuffer(v) {
    if (!Buffer.isBuffer(v)) {
        if (Array.isArray(v)) v = Buffer.from(v);
        else if (typeof v === "string") {
            if (isHexString(v)) v = Buffer.from(padToEven(stripHexPrefix(v)), "hex");
            else v = Buffer.from(v);
        } else if (typeof v === "number") v = intToBuffer(v);
        else if (v === null || v === undefined) v = Buffer.allocUnsafe(0);
        else if (BN.isBN(v)) v = v.toArrayLike(Buffer);
        else if (v.toArray) // converts a BN to a Buffer
        v = Buffer.from(v.toArray());
        else throw new Error("invalid type");
    }
    return v;
}
/**
 * Converts a `Buffer` into a hex `String`
 * @param {Buffer} buf
 * @return {String}
 */ function bufferToHex(buf) {
    buf = toBuffer(buf);
    return "0x" + buf.toString("hex");
}
/**
 * Creates Keccak hash of the input
 * @param {Buffer|Array|String|Number} a the input data
 * @param {Number} [bits=256] the Keccak width
 * @return {Buffer}
 */ function keccak(a, bits) {
    a = toBuffer(a);
    if (!bits) bits = 256;
    return createKeccakHash("keccak" + bits).update(a).digest();
}
function padToEven(str) {
    return str.length % 2 ? "0" + str : str;
}
function isHexString(str) {
    return typeof str === "string" && str.match(/^0x[0-9A-Fa-f]*$/);
}
function stripHexPrefix(str) {
    if (typeof str === "string" && str.startsWith("0x")) return str.slice(2);
    return str;
}
module.exports = {
    zeros,
    setLength,
    setLengthRight,
    isHexString,
    stripHexPrefix,
    toBuffer,
    bufferToHex,
    keccak
};

},{"737ff4b40e5e6ef0":"l5Twm","2441f35b3b95e5d5":"a11wB","9298dd1d5be5ccc6":"4AVaT"}],"PGhuW":[function(require,module,exports) {
// Extracted from https://github.com/ethereumjs/ethereumjs-abi and stripped out irrelevant code
// Original code licensed under the MIT License - Copyright (c) 2015 Alex Beregszaszi
var Buffer = require("16d3fec8ff88125b").Buffer;
const util = require("a95a012dbbba3413");
const BN = require("8b756ad5ff752432");
// Convert from short to canonical names
// FIXME: optimise or make this nicer?
function elementaryName(name) {
    if (name.startsWith("int[")) return "int256" + name.slice(3);
    else if (name === "int") return "int256";
    else if (name.startsWith("uint[")) return "uint256" + name.slice(4);
    else if (name === "uint") return "uint256";
    else if (name.startsWith("fixed[")) return "fixed128x128" + name.slice(5);
    else if (name === "fixed") return "fixed128x128";
    else if (name.startsWith("ufixed[")) return "ufixed128x128" + name.slice(6);
    else if (name === "ufixed") return "ufixed128x128";
    return name;
}
// Parse N from type<N>
function parseTypeN(type) {
    return parseInt(/^\D+(\d+)$/.exec(type)[1], 10);
}
// Parse N,M from type<N>x<M>
function parseTypeNxM(type) {
    var tmp = /^\D+(\d+)x(\d+)$/.exec(type);
    return [
        parseInt(tmp[1], 10),
        parseInt(tmp[2], 10)
    ];
}
// Parse N in type[<N>] where "type" can itself be an array type.
function parseTypeArray(type) {
    var tmp = type.match(/(.*)\[(.*?)\]$/);
    if (tmp) return tmp[2] === "" ? "dynamic" : parseInt(tmp[2], 10);
    return null;
}
function parseNumber(arg) {
    var type = typeof arg;
    if (type === "string") {
        if (util.isHexString(arg)) return new BN(util.stripHexPrefix(arg), 16);
        else return new BN(arg, 10);
    } else if (type === "number") return new BN(arg);
    else if (arg.toArray) // assume this is a BN for the moment, replace with BN.isBN soon
    return arg;
    else throw new Error("Argument is not a number");
}
// Encodes a single item (can be dynamic array)
// @returns: Buffer
function encodeSingle(type, arg) {
    var size, num, ret, i;
    if (type === "address") return encodeSingle("uint160", parseNumber(arg));
    else if (type === "bool") return encodeSingle("uint8", arg ? 1 : 0);
    else if (type === "string") return encodeSingle("bytes", new Buffer(arg, "utf8"));
    else if (isArray(type)) {
        // this part handles fixed-length ([2]) and variable length ([]) arrays
        // NOTE: we catch here all calls to arrays, that simplifies the rest
        if (typeof arg.length === "undefined") throw new Error("Not an array?");
        size = parseTypeArray(type);
        if (size !== "dynamic" && size !== 0 && arg.length > size) throw new Error("Elements exceed array size: " + size);
        ret = [];
        type = type.slice(0, type.lastIndexOf("["));
        if (typeof arg === "string") arg = JSON.parse(arg);
        for(i in arg)ret.push(encodeSingle(type, arg[i]));
        if (size === "dynamic") {
            var length = encodeSingle("uint256", arg.length);
            ret.unshift(length);
        }
        return Buffer.concat(ret);
    } else if (type === "bytes") {
        arg = new Buffer(arg);
        ret = Buffer.concat([
            encodeSingle("uint256", arg.length),
            arg
        ]);
        if (arg.length % 32 !== 0) ret = Buffer.concat([
            ret,
            util.zeros(32 - arg.length % 32)
        ]);
        return ret;
    } else if (type.startsWith("bytes")) {
        size = parseTypeN(type);
        if (size < 1 || size > 32) throw new Error("Invalid bytes<N> width: " + size);
        return util.setLengthRight(arg, 32);
    } else if (type.startsWith("uint")) {
        size = parseTypeN(type);
        if (size % 8 || size < 8 || size > 256) throw new Error("Invalid uint<N> width: " + size);
        num = parseNumber(arg);
        if (num.bitLength() > size) throw new Error("Supplied uint exceeds width: " + size + " vs " + num.bitLength());
        if (num < 0) throw new Error("Supplied uint is negative");
        return num.toArrayLike(Buffer, "be", 32);
    } else if (type.startsWith("int")) {
        size = parseTypeN(type);
        if (size % 8 || size < 8 || size > 256) throw new Error("Invalid int<N> width: " + size);
        num = parseNumber(arg);
        if (num.bitLength() > size) throw new Error("Supplied int exceeds width: " + size + " vs " + num.bitLength());
        return num.toTwos(256).toArrayLike(Buffer, "be", 32);
    } else if (type.startsWith("ufixed")) {
        size = parseTypeNxM(type);
        num = parseNumber(arg);
        if (num < 0) throw new Error("Supplied ufixed is negative");
        return encodeSingle("uint256", num.mul(new BN(2).pow(new BN(size[1]))));
    } else if (type.startsWith("fixed")) {
        size = parseTypeNxM(type);
        return encodeSingle("int256", parseNumber(arg).mul(new BN(2).pow(new BN(size[1]))));
    }
    throw new Error("Unsupported or invalid type: " + type);
}
// Is a type dynamic?
function isDynamic(type) {
    // FIXME: handle all types? I don't think anything is missing now
    return type === "string" || type === "bytes" || parseTypeArray(type) === "dynamic";
}
// Is a type an array?
function isArray(type) {
    return type.lastIndexOf("]") === type.length - 1;
}
// Encode a method/event with arguments
// @types an array of string type names
// @args  an array of the appropriate values
function rawEncode(types, values) {
    var output = [];
    var data = [];
    var headLength = 32 * types.length;
    for(var i in types){
        var type = elementaryName(types[i]);
        var value = values[i];
        var cur = encodeSingle(type, value);
        // Use the head/tail method for storing dynamic data
        if (isDynamic(type)) {
            output.push(encodeSingle("uint256", headLength));
            data.push(cur);
            headLength += cur.length;
        } else output.push(cur);
    }
    return Buffer.concat(output.concat(data));
}
function solidityPack(types, values) {
    if (types.length !== values.length) throw new Error("Number of types are not matching the values");
    var size, num;
    var ret = [];
    for(var i = 0; i < types.length; i++){
        var type = elementaryName(types[i]);
        var value = values[i];
        if (type === "bytes") ret.push(value);
        else if (type === "string") ret.push(new Buffer(value, "utf8"));
        else if (type === "bool") ret.push(new Buffer(value ? "01" : "00", "hex"));
        else if (type === "address") ret.push(util.setLength(value, 20));
        else if (type.startsWith("bytes")) {
            size = parseTypeN(type);
            if (size < 1 || size > 32) throw new Error("Invalid bytes<N> width: " + size);
            ret.push(util.setLengthRight(value, size));
        } else if (type.startsWith("uint")) {
            size = parseTypeN(type);
            if (size % 8 || size < 8 || size > 256) throw new Error("Invalid uint<N> width: " + size);
            num = parseNumber(value);
            if (num.bitLength() > size) throw new Error("Supplied uint exceeds width: " + size + " vs " + num.bitLength());
            ret.push(num.toArrayLike(Buffer, "be", size / 8));
        } else if (type.startsWith("int")) {
            size = parseTypeN(type);
            if (size % 8 || size < 8 || size > 256) throw new Error("Invalid int<N> width: " + size);
            num = parseNumber(value);
            if (num.bitLength() > size) throw new Error("Supplied int exceeds width: " + size + " vs " + num.bitLength());
            ret.push(num.toTwos(size).toArrayLike(Buffer, "be", size / 8));
        } else // FIXME: support all other types
        throw new Error("Unsupported or invalid type: " + type);
    }
    return Buffer.concat(ret);
}
function soliditySHA3(types, values) {
    return util.keccak(solidityPack(types, values));
}
module.exports = {
    rawEncode,
    solidityPack,
    soliditySHA3
};

},{"16d3fec8ff88125b":"l5Twm","a95a012dbbba3413":"lTqVn","8b756ad5ff752432":"4AVaT"}],"ltLuj":[function(require,module,exports) {
"use strict";
// Copyright (c) 2018-2020 WalletLink.org <https://www.walletlink.org/>
// Copyright (c) 2018-2020 Coinbase, Inc. <https://www.coinbase.com/>
// Licensed under the Apache License, version 2.0
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.filterFromParam = exports.FilterPolyfill = void 0;
const types_1 = require("7c499ef62fe51b81");
const util_1 = require("707b646b9dc66f46");
const TIMEOUT = 300000; // 5 minutes
const JSONRPC_TEMPLATE = {
    jsonrpc: "2.0",
    id: 0
};
class FilterPolyfill {
    constructor(provider){
        this.logFilters = new Map(); // <id, filter>
        this.blockFilters = new Set(); // <id>
        this.pendingTransactionFilters = new Set(); // <id, true>
        this.cursors = new Map(); // <id, cursor>
        this.timeouts = new Map(); // <id, setTimeout id>
        this.nextFilterId = (0, types_1.IntNumber)(1);
        this.provider = provider;
    }
    async newFilter(param) {
        const filter = filterFromParam(param);
        const id = this.makeFilterId();
        const cursor = await this.setInitialCursorPosition(id, filter.fromBlock);
        console.log(`Installing new log filter(${id}):`, filter, "initial cursor position:", cursor);
        this.logFilters.set(id, filter);
        this.setFilterTimeout(id);
        return (0, util_1.hexStringFromIntNumber)(id);
    }
    async newBlockFilter() {
        const id = this.makeFilterId();
        const cursor = await this.setInitialCursorPosition(id, "latest");
        console.log(`Installing new block filter (${id}) with initial cursor position:`, cursor);
        this.blockFilters.add(id);
        this.setFilterTimeout(id);
        return (0, util_1.hexStringFromIntNumber)(id);
    }
    async newPendingTransactionFilter() {
        const id = this.makeFilterId();
        const cursor = await this.setInitialCursorPosition(id, "latest");
        console.log(`Installing new block filter (${id}) with initial cursor position:`, cursor);
        this.pendingTransactionFilters.add(id);
        this.setFilterTimeout(id);
        return (0, util_1.hexStringFromIntNumber)(id);
    }
    uninstallFilter(filterId) {
        const id = (0, util_1.intNumberFromHexString)(filterId);
        console.log(`Uninstalling filter (${id})`);
        this.deleteFilter(id);
        return true;
    }
    getFilterChanges(filterId) {
        const id = (0, util_1.intNumberFromHexString)(filterId);
        if (this.timeouts.has(id)) // extend timeout
        this.setFilterTimeout(id);
        if (this.logFilters.has(id)) return this.getLogFilterChanges(id);
        else if (this.blockFilters.has(id)) return this.getBlockFilterChanges(id);
        else if (this.pendingTransactionFilters.has(id)) return this.getPendingTransactionFilterChanges(id);
        return Promise.resolve(filterNotFoundError());
    }
    async getFilterLogs(filterId) {
        const id = (0, util_1.intNumberFromHexString)(filterId);
        const filter = this.logFilters.get(id);
        if (!filter) return filterNotFoundError();
        return this.sendAsyncPromise(Object.assign(Object.assign({}, JSONRPC_TEMPLATE), {
            method: "eth_getLogs",
            params: [
                paramFromFilter(filter)
            ]
        }));
    }
    makeFilterId() {
        return (0, types_1.IntNumber)(++this.nextFilterId);
    }
    sendAsyncPromise(request) {
        return new Promise((resolve, reject)=>{
            this.provider.sendAsync(request, (err, response)=>{
                if (err) return reject(err);
                if (Array.isArray(response) || response == null) return reject(new Error(`unexpected response received: ${JSON.stringify(response)}`));
                resolve(response);
            });
        });
    }
    deleteFilter(id) {
        console.log(`Deleting filter (${id})`);
        this.logFilters.delete(id);
        this.blockFilters.delete(id);
        this.pendingTransactionFilters.delete(id);
        this.cursors.delete(id);
        this.timeouts.delete(id);
    }
    async getLogFilterChanges(id) {
        const filter = this.logFilters.get(id);
        const cursorPosition = this.cursors.get(id);
        if (!cursorPosition || !filter) return filterNotFoundError();
        const currentBlockHeight = await this.getCurrentBlockHeight();
        const toBlock = filter.toBlock === "latest" ? currentBlockHeight : filter.toBlock;
        if (cursorPosition > currentBlockHeight) return emptyResult();
        if (cursorPosition > filter.toBlock) return emptyResult();
        console.log(`Fetching logs from ${cursorPosition} to ${toBlock} for filter ${id}`);
        const response = await this.sendAsyncPromise(Object.assign(Object.assign({}, JSONRPC_TEMPLATE), {
            method: "eth_getLogs",
            params: [
                paramFromFilter(Object.assign(Object.assign({}, filter), {
                    fromBlock: cursorPosition,
                    toBlock
                }))
            ]
        }));
        if (Array.isArray(response.result)) {
            const blocks = response.result.map((log)=>(0, util_1.intNumberFromHexString)(log.blockNumber || "0x0"));
            const highestBlock = Math.max(...blocks);
            if (highestBlock && highestBlock > cursorPosition) {
                const newCursorPosition = (0, types_1.IntNumber)(highestBlock + 1);
                console.log(`Moving cursor position for filter (${id}) from ${cursorPosition} to ${newCursorPosition}`);
                this.cursors.set(id, newCursorPosition);
            }
        }
        return response;
    }
    async getBlockFilterChanges(id) {
        const cursorPosition = this.cursors.get(id);
        if (!cursorPosition) return filterNotFoundError();
        const currentBlockHeight = await this.getCurrentBlockHeight();
        if (cursorPosition > currentBlockHeight) return emptyResult();
        console.log(`Fetching blocks from ${cursorPosition} to ${currentBlockHeight} for filter (${id})`);
        const blocks = (await Promise.all(// eslint-disable-next-line @typescript-eslint/restrict-plus-operands
        (0, util_1.range)(cursorPosition, currentBlockHeight + 1).map((i)=>this.getBlockHashByNumber((0, types_1.IntNumber)(i))))).filter((hash)=>!!hash);
        // eslint-disable-next-line @typescript-eslint/restrict-plus-operands
        const newCursorPosition = (0, types_1.IntNumber)(cursorPosition + blocks.length);
        console.log(`Moving cursor position for filter (${id}) from ${cursorPosition} to ${newCursorPosition}`);
        this.cursors.set(id, newCursorPosition);
        return Object.assign(Object.assign({}, JSONRPC_TEMPLATE), {
            result: blocks
        });
    }
    async getPendingTransactionFilterChanges(_id) {
        // pending transaction filters are not supported
        return Promise.resolve(emptyResult());
    }
    async setInitialCursorPosition(id, startBlock) {
        const currentBlockHeight = await this.getCurrentBlockHeight();
        const initialCursorPosition = typeof startBlock === "number" && startBlock > currentBlockHeight ? startBlock : currentBlockHeight;
        this.cursors.set(id, initialCursorPosition);
        return initialCursorPosition;
    }
    setFilterTimeout(id) {
        const existing = this.timeouts.get(id);
        if (existing) window.clearTimeout(existing);
        const timeout = window.setTimeout(()=>{
            console.log(`Filter (${id}) timed out`);
            this.deleteFilter(id);
        }, TIMEOUT);
        this.timeouts.set(id, timeout);
    }
    async getCurrentBlockHeight() {
        const { result } = await this.sendAsyncPromise(Object.assign(Object.assign({}, JSONRPC_TEMPLATE), {
            method: "eth_blockNumber",
            params: []
        }));
        return (0, util_1.intNumberFromHexString)((0, util_1.ensureHexString)(result));
    }
    async getBlockHashByNumber(blockNumber) {
        const response = await this.sendAsyncPromise(Object.assign(Object.assign({}, JSONRPC_TEMPLATE), {
            method: "eth_getBlockByNumber",
            params: [
                (0, util_1.hexStringFromIntNumber)(blockNumber),
                false
            ]
        }));
        if (response.result && typeof response.result.hash === "string") return (0, util_1.ensureHexString)(response.result.hash);
        return null;
    }
}
exports.FilterPolyfill = FilterPolyfill;
function filterFromParam(param) {
    return {
        fromBlock: intBlockHeightFromHexBlockHeight(param.fromBlock),
        toBlock: intBlockHeightFromHexBlockHeight(param.toBlock),
        addresses: param.address === undefined ? null : Array.isArray(param.address) ? param.address : [
            param.address
        ],
        topics: param.topics || []
    };
}
exports.filterFromParam = filterFromParam;
function paramFromFilter(filter) {
    const param = {
        fromBlock: hexBlockHeightFromIntBlockHeight(filter.fromBlock),
        toBlock: hexBlockHeightFromIntBlockHeight(filter.toBlock),
        topics: filter.topics
    };
    if (filter.addresses !== null) param.address = filter.addresses;
    return param;
}
function intBlockHeightFromHexBlockHeight(value) {
    if (value === undefined || value === "latest" || value === "pending") return "latest";
    else if (value === "earliest") return (0, types_1.IntNumber)(0);
    else if ((0, util_1.isHexString)(value)) return (0, util_1.intNumberFromHexString)(value);
    throw new Error(`Invalid block option: ${String(value)}`);
}
function hexBlockHeightFromIntBlockHeight(value) {
    if (value === "latest") return value;
    return (0, util_1.hexStringFromIntNumber)(value);
}
function filterNotFoundError() {
    return Object.assign(Object.assign({}, JSONRPC_TEMPLATE), {
        error: {
            code: -32000,
            message: "filter not found"
        }
    });
}
function emptyResult() {
    return Object.assign(Object.assign({}, JSONRPC_TEMPLATE), {
        result: []
    });
}

},{"7c499ef62fe51b81":"hGqkR","707b646b9dc66f46":"9zvgH"}],"JiY2L":[function(require,module,exports) {
"use strict";
// Copyright (c) 2018-2020 WalletLink.org <https://www.walletlink.org/>
// Copyright (c) 2018-2020 Coinbase, Inc. <https://www.coinbase.com/>
// Licensed under the Apache License, version 2.0
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.JSONRPCMethod = void 0;
var JSONRPCMethod;
(function(JSONRPCMethod) {
    // synchronous or asynchronous
    JSONRPCMethod["eth_accounts"] = "eth_accounts";
    JSONRPCMethod["eth_coinbase"] = "eth_coinbase";
    JSONRPCMethod["net_version"] = "net_version";
    JSONRPCMethod["eth_chainId"] = "eth_chainId";
    JSONRPCMethod["eth_uninstallFilter"] = "eth_uninstallFilter";
    // asynchronous only
    JSONRPCMethod["eth_requestAccounts"] = "eth_requestAccounts";
    JSONRPCMethod["eth_sign"] = "eth_sign";
    JSONRPCMethod["eth_ecRecover"] = "eth_ecRecover";
    JSONRPCMethod["personal_sign"] = "personal_sign";
    JSONRPCMethod["personal_ecRecover"] = "personal_ecRecover";
    JSONRPCMethod["eth_signTransaction"] = "eth_signTransaction";
    JSONRPCMethod["eth_sendRawTransaction"] = "eth_sendRawTransaction";
    JSONRPCMethod["eth_sendTransaction"] = "eth_sendTransaction";
    JSONRPCMethod["eth_signTypedData_v1"] = "eth_signTypedData_v1";
    JSONRPCMethod["eth_signTypedData_v2"] = "eth_signTypedData_v2";
    JSONRPCMethod["eth_signTypedData_v3"] = "eth_signTypedData_v3";
    JSONRPCMethod["eth_signTypedData_v4"] = "eth_signTypedData_v4";
    JSONRPCMethod["eth_signTypedData"] = "eth_signTypedData";
    JSONRPCMethod["walletlink_arbitrary"] = "walletlink_arbitrary";
    JSONRPCMethod["wallet_addEthereumChain"] = "wallet_addEthereumChain";
    JSONRPCMethod["wallet_switchEthereumChain"] = "wallet_switchEthereumChain";
    JSONRPCMethod["wallet_watchAsset"] = "wallet_watchAsset";
    // asynchronous pub/sub
    JSONRPCMethod["eth_subscribe"] = "eth_subscribe";
    JSONRPCMethod["eth_unsubscribe"] = "eth_unsubscribe";
    // asynchronous filter methods
    JSONRPCMethod["eth_newFilter"] = "eth_newFilter";
    JSONRPCMethod["eth_newBlockFilter"] = "eth_newBlockFilter";
    JSONRPCMethod["eth_newPendingTransactionFilter"] = "eth_newPendingTransactionFilter";
    JSONRPCMethod["eth_getFilterChanges"] = "eth_getFilterChanges";
    JSONRPCMethod["eth_getFilterLogs"] = "eth_getFilterLogs";
})(JSONRPCMethod = exports.JSONRPCMethod || (exports.JSONRPCMethod = {}));

},{}],"bpQA1":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.SubscriptionManager = void 0;
const PollingBlockTracker = require("e339f9e2a28aca79");
const createSubscriptionManager = require("513337e44acedb30");
const noop = ()=>{};
class SubscriptionManager {
    constructor(provider){
        const blockTracker = new PollingBlockTracker({
            provider,
            pollingInterval: 15000,
            setSkipCacheFlag: true
        });
        const { events, middleware } = createSubscriptionManager({
            blockTracker,
            provider
        });
        this.events = events;
        this.subscriptionMiddleware = middleware;
    }
    async handleRequest(request) {
        const result = {};
        await this.subscriptionMiddleware(request, result, noop, noop);
        return result;
    }
    destroy() {
        this.subscriptionMiddleware.destroy();
    }
}
exports.SubscriptionManager = SubscriptionManager;

},{"e339f9e2a28aca79":"56qDa","513337e44acedb30":"hGF6x"}],"jk7GX":[function(require,module,exports) {
"use strict";
// Copyright (c) 2018-2020 WalletLink.org <https://www.walletlink.org/>
// Copyright (c) 2018-2020 Coinbase, Inc. <https://www.coinbase.com/>
// Licensed under the Apache License, version 2.0
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.WalletLink = void 0;
const WalletLinkAnalytics_1 = require("d4ebb74d735c22c7");
const ScopedLocalStorage_1 = require("7cd321d79365c267");
const WalletLinkProvider_1 = require("999f73cd6101a382");
const WalletLinkSdkUI_1 = require("7747eb4755ab6e2b");
const WalletLinkRelay_1 = require("c5ba472ba81b0786");
const WalletLinkRelayEventManager_1 = require("be6ac23380a74255");
const util_1 = require("8187555598559210");
const WALLETLINK_URL = "https://www.walletlink.org";
const WALLETLINK_VERSION = (0, require("469146b38b4bfff9").version) || "unknown";
class WalletLink {
    /**
     * Constructor
     * @param options WalletLink options object
     */ constructor(options){
        var _a;
        this._appName = "";
        this._appLogoUrl = null;
        this._relay = null;
        this._relayEventManager = null;
        const walletLinkUrl = options.walletLinkUrl || WALLETLINK_URL;
        let walletLinkUIConstructor;
        if (!options.walletLinkUIConstructor) walletLinkUIConstructor = (opts)=>new WalletLinkSdkUI_1.WalletLinkSdkUI(opts);
        else walletLinkUIConstructor = options.walletLinkUIConstructor;
        if (typeof options.overrideIsMetaMask === "undefined") this._overrideIsMetaMask = false;
        else this._overrideIsMetaMask = options.overrideIsMetaMask;
        this._overrideIsCoinbaseWallet = (_a = options.overrideIsCoinbaseWallet) !== null && _a !== void 0 ? _a : true;
        this._walletLinkAnalytics = options.walletLinkAnalytics ? options.walletLinkAnalytics : new WalletLinkAnalytics_1.WalletLinkAnalytics();
        const u = new URL(walletLinkUrl);
        const walletLinkOrigin = `${u.protocol}//${u.host}`;
        this._storage = new ScopedLocalStorage_1.ScopedLocalStorage(`-walletlink:${walletLinkOrigin}`);
        this._storage.setItem("version", WalletLink.VERSION);
        if (typeof window.walletLinkExtension !== "undefined") return;
        this._relayEventManager = new WalletLinkRelayEventManager_1.WalletLinkRelayEventManager();
        this._relay = new WalletLinkRelay_1.WalletLinkRelay({
            walletLinkUrl,
            version: WALLETLINK_VERSION,
            darkMode: !!options.darkMode,
            walletLinkUIConstructor,
            storage: this._storage,
            relayEventManager: this._relayEventManager,
            walletLinkAnalytics: this._walletLinkAnalytics
        });
        this.setAppInfo(options.appName, options.appLogoUrl);
        this._relay.attachUI();
    }
    /**
     * Create a Web3 Provider object
     * @param jsonRpcUrl Ethereum JSON RPC URL (Default: "")
     * @param chainId Ethereum Chain ID (Default: 1)
     * @returns A Web3 Provider
     */ makeWeb3Provider(jsonRpcUrl = "", chainId = 1) {
        if (typeof window.walletLinkExtension !== "undefined") {
            if (/* eslint-disable @typescript-eslint/ban-ts-comment */ // @ts-ignore
            typeof window.walletLinkExtension.isCipher !== "boolean" || // @ts-ignore
            !window.walletLinkExtension.isCipher) window.walletLinkExtension.setProviderInfo(jsonRpcUrl, chainId);
            return window.walletLinkExtension;
        }
        const relay = this._relay;
        if (!relay || !this._relayEventManager || !this._storage) throw new Error("Relay not initialized, should never happen");
        if (!jsonRpcUrl) relay.setConnectDisabled(true);
        return new WalletLinkProvider_1.WalletLinkProvider({
            relayProvider: ()=>Promise.resolve(relay),
            relayEventManager: this._relayEventManager,
            storage: this._storage,
            jsonRpcUrl,
            chainId,
            walletLinkAnalytics: this._walletLinkAnalytics,
            overrideIsMetaMask: this._overrideIsMetaMask,
            overrideIsCoinbaseWallet: this._overrideIsCoinbaseWallet
        });
    }
    /**
     * Set application information
     * @param appName Application name
     * @param appLogoUrl Application logo image URL
     */ setAppInfo(appName, appLogoUrl) {
        var _a;
        this._appName = appName || "DApp";
        this._appLogoUrl = appLogoUrl || (0, util_1.getFavicon)();
        if (typeof window.walletLinkExtension !== "undefined") {
            if (/* eslint-disable @typescript-eslint/ban-ts-comment */ // @ts-ignore
            typeof window.walletLinkExtension.isCipher !== "boolean" || // @ts-ignore
            !window.walletLinkExtension.isCipher) window.walletLinkExtension.setAppInfo(this._appName, this._appLogoUrl);
        } else (_a = this._relay) === null || _a === void 0 || _a.setAppInfo(this._appName, this._appLogoUrl);
    }
    /**
     * Disconnect. After disconnecting, this will reload the web page to ensure
     * all potential stale state is cleared.
     */ disconnect() {
        var _a;
        if (typeof window.walletLinkExtension !== "undefined") window.walletLinkExtension.close();
        else (_a = this._relay) === null || _a === void 0 || _a.resetAndReload();
    }
}
exports.WalletLink = WalletLink;
/**
 * WalletLink version
 */ WalletLink.VERSION = WALLETLINK_VERSION;

},{"d4ebb74d735c22c7":"2871R","7cd321d79365c267":"eURv1","999f73cd6101a382":"eI393","7747eb4755ab6e2b":"6WOQW","c5ba472ba81b0786":"kAxZC","be6ac23380a74255":"fqvtu","8187555598559210":"9zvgH","469146b38b4bfff9":"gQCRm"}],"eURv1":[function(require,module,exports) {
"use strict";
// Copyright (c) 2018-2020 WalletLink.org <https://www.walletlink.org/>
// Copyright (c) 2018-2020 Coinbase, Inc. <https://www.coinbase.com/>
// Licensed under the Apache License, version 2.0
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ScopedLocalStorage = void 0;
class ScopedLocalStorage {
    constructor(scope){
        this.scope = scope;
    }
    setItem(key, value) {
        localStorage.setItem(this.scopedKey(key), value);
    }
    getItem(key) {
        return localStorage.getItem(this.scopedKey(key));
    }
    removeItem(key) {
        localStorage.removeItem(this.scopedKey(key));
    }
    clear() {
        const prefix = this.scopedKey("");
        const keysToRemove = [];
        for(let i = 0; i < localStorage.length; i++){
            const key = localStorage.key(i);
            if (typeof key === "string" && key.startsWith(prefix)) keysToRemove.push(key);
        }
        keysToRemove.forEach((key)=>localStorage.removeItem(key));
    }
    scopedKey(key) {
        return `${this.scope}:${key}`;
    }
}
exports.ScopedLocalStorage = ScopedLocalStorage;

},{}],"6WOQW":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.WalletLinkSdkUI = void 0;
const LinkFlow_1 = require("db582f54d1712ed6");
const Snackbar_1 = require("843931baef119ca3");
const cssReset_1 = require("2e7aced6afb2d04f");
const WalletLinkUI_1 = require("44694af1d34ab7f2");
class WalletLinkSdkUI extends WalletLinkUI_1.WalletLinkUI {
    constructor(options){
        super(options);
        this.attached = false;
        this.snackbar = new Snackbar_1.Snackbar({
            darkMode: options.darkMode
        });
        this.linkFlow = new LinkFlow_1.LinkFlow({
            darkMode: options.darkMode,
            version: options.version,
            sessionId: options.session.id,
            sessionSecret: options.session.secret,
            walletLinkUrl: options.walletLinkUrl,
            connected$: options.connected$,
            isParentConnection: false
        });
    }
    attach() {
        if (this.attached) throw new Error("WalletLinkUI is already attached");
        const el = document.documentElement;
        const container = document.createElement("div");
        container.className = "-walletlink-css-reset";
        el.appendChild(container);
        this.linkFlow.attach(container);
        this.snackbar.attach(container);
        this.attached = true;
        (0, cssReset_1.injectCssReset)();
    }
    setConnectDisabled(connectDisabled) {
        this.linkFlow.setConnectDisabled(connectDisabled);
    }
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    addEthereumChain(options) {
    // no-op
    }
    // @ts-ignore
    watchAsset(options) {
    // no-op
    }
    // @ts-ignore
    switchEthereumChain(options) {
    // no-op
    }
    requestEthereumAccounts(options) {
        this.linkFlow.open({
            onCancel: options.onCancel
        });
    }
    hideRequestEthereumAccounts() {
        this.linkFlow.close();
    }
    signEthereumMessage(_) {
    // No-op
    }
    signEthereumTransaction(_) {
    // No-op
    }
    submitEthereumTransaction(_) {
    // No-op
    }
    ethereumAddressFromSignedMessage(_) {
    // No-op
    }
    showConnecting(options) {
        let snackbarProps;
        if (options.isUnlinkedErrorState) snackbarProps = {
            autoExpand: true,
            message: "Connection lost",
            menuItems: [
                {
                    isRed: false,
                    info: "Reset connection",
                    svgWidth: "10",
                    svgHeight: "11",
                    path: "M5.00008 0.96875C6.73133 0.96875 8.23758 1.94375 9.00008 3.375L10.0001 2.375V5.5H9.53133H7.96883H6.87508L7.80633 4.56875C7.41258 3.3875 6.31258 2.53125 5.00008 2.53125C3.76258 2.53125 2.70633 3.2875 2.25633 4.36875L0.812576 3.76875C1.50008 2.125 3.11258 0.96875 5.00008 0.96875ZM2.19375 6.43125C2.5875 7.6125 3.6875 8.46875 5 8.46875C6.2375 8.46875 7.29375 7.7125 7.74375 6.63125L9.1875 7.23125C8.5 8.875 6.8875 10.0312 5 10.0312C3.26875 10.0312 1.7625 9.05625 1 7.625L0 8.625V5.5H0.46875H2.03125H3.125L2.19375 6.43125Z",
                    defaultFillRule: "evenodd",
                    defaultClipRule: "evenodd",
                    onClick: options.onResetConnection
                }
            ]
        };
        else snackbarProps = {
            message: "Confirm on phone",
            menuItems: [
                {
                    isRed: true,
                    info: "Cancel transaction",
                    svgWidth: "11",
                    svgHeight: "11",
                    path: "M10.3711 1.52346L9.21775 0.370117L5.37109 4.21022L1.52444 0.370117L0.371094 1.52346L4.2112 5.37012L0.371094 9.21677L1.52444 10.3701L5.37109 6.53001L9.21775 10.3701L10.3711 9.21677L6.53099 5.37012L10.3711 1.52346Z",
                    defaultFillRule: "inherit",
                    defaultClipRule: "inherit",
                    onClick: options.onCancel
                },
                {
                    isRed: false,
                    info: "Reset connection",
                    svgWidth: "10",
                    svgHeight: "11",
                    path: "M5.00008 0.96875C6.73133 0.96875 8.23758 1.94375 9.00008 3.375L10.0001 2.375V5.5H9.53133H7.96883H6.87508L7.80633 4.56875C7.41258 3.3875 6.31258 2.53125 5.00008 2.53125C3.76258 2.53125 2.70633 3.2875 2.25633 4.36875L0.812576 3.76875C1.50008 2.125 3.11258 0.96875 5.00008 0.96875ZM2.19375 6.43125C2.5875 7.6125 3.6875 8.46875 5 8.46875C6.2375 8.46875 7.29375 7.7125 7.74375 6.63125L9.1875 7.23125C8.5 8.875 6.8875 10.0312 5 10.0312C3.26875 10.0312 1.7625 9.05625 1 7.625L0 8.625V5.5H0.46875H2.03125H3.125L2.19375 6.43125Z",
                    defaultFillRule: "evenodd",
                    defaultClipRule: "evenodd",
                    onClick: options.onResetConnection
                }
            ]
        };
        return this.snackbar.presentItem(snackbarProps);
    }
    reloadUI() {
        document.location.reload();
    }
    inlineAccountsResponse() {
        return false;
    }
    // @ts-ignore
    inlineAddEthereumChain(chainId) {
        return false;
    }
    inlineWatchAsset() {
        return false;
    }
    inlineSwitchEthereumChain() {
        return false;
    }
    isStandalone() {
        return false;
    }
}
exports.WalletLinkSdkUI = WalletLinkSdkUI;

},{"db582f54d1712ed6":"cm2al","843931baef119ca3":"3VnBl","2e7aced6afb2d04f":"6TNS2","44694af1d34ab7f2":"dyHrq"}],"cm2al":[function(require,module,exports) {
"use strict";
// Copyright (c) 2018-2020 WalletLink.org <https://www.walletlink.org/>
// Copyright (c) 2018-2020 Coinbase, Inc. <https://www.coinbase.com/>
// Licensed under the Apache License, version 2.0
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.LinkFlow = void 0;
const preact_1 = require("6a75a3ed16605d8e");
const rxjs_1 = require("8c51b9fc30a6a2ea");
const operators_1 = require("f5337dfe4d66d384");
const LinkDialog_1 = require("e6a1fcb5f1a29141");
const TryExtensionLinkDialog_1 = require("aad261a1fe459d05");
class LinkFlow {
    constructor(options){
        this.extensionUI$ = new rxjs_1.BehaviorSubject({});
        this.subscriptions = new rxjs_1.Subscription();
        this.isConnected = false;
        this.isOpen = false;
        this.onCancel = null;
        this.root = null;
        // if true, hide QR code in LinkFlow (which happens if no jsonRpcUrl is provided)
        this.connectDisabled = false;
        this.darkMode = options.darkMode;
        this.version = options.version;
        this.sessionId = options.sessionId;
        this.sessionSecret = options.sessionSecret;
        this.walletLinkUrl = options.walletLinkUrl;
        this.isParentConnection = options.isParentConnection;
        this.connected$ = options.connected$;
        // Check if extension UI is enabled
        fetch("https://api.wallet.coinbase.com/rpc/v2/getFeatureFlags").then((res)=>res.json()).then((json)=>{
            const enabled = json.result.desktop.extension_ui;
            if (typeof enabled === "undefined") this.extensionUI$.next({
                value: false
            });
            else this.extensionUI$.next({
                value: enabled
            });
        }).catch((err)=>{
            console.error("Couldn't fetch feature flags - ", err);
            this.extensionUI$.next({
                value: false
            });
        });
    }
    attach(el) {
        this.root = document.createElement("div");
        this.root.className = "-walletlink-link-flow-root";
        el.appendChild(this.root);
        this.render();
        this.subscriptions.add(this.connected$.subscribe((v)=>{
            if (this.isConnected !== v) {
                this.isConnected = v;
                this.render();
            }
        }));
    }
    detach() {
        var _a;
        if (!this.root) return;
        this.subscriptions.unsubscribe();
        (0, preact_1.render)(null, this.root);
        (_a = this.root.parentElement) === null || _a === void 0 || _a.removeChild(this.root);
    }
    setConnectDisabled(connectDisabled) {
        this.connectDisabled = connectDisabled;
    }
    open(options) {
        this.isOpen = true;
        this.onCancel = options.onCancel;
        this.render();
    }
    close() {
        this.isOpen = false;
        this.onCancel = null;
        this.render();
    }
    render() {
        if (!this.root) return;
        const subscription = this.extensionUI$.pipe((0, operators_1.first)((enabled)=>enabled.value !== undefined)) // wait for a valid value before rendering
        .subscribe((enabled)=>{
            if (!this.root) return;
            (0, preact_1.render)(enabled.value ? (0, preact_1.h)(TryExtensionLinkDialog_1.TryExtensionLinkDialog, {
                darkMode: this.darkMode,
                version: this.version,
                sessionId: this.sessionId,
                sessionSecret: this.sessionSecret,
                walletLinkUrl: this.walletLinkUrl,
                isOpen: this.isOpen,
                isConnected: this.isConnected,
                isParentConnection: this.isParentConnection,
                onCancel: this.onCancel,
                connectDisabled: this.connectDisabled
            }) : (0, preact_1.h)(LinkDialog_1.LinkDialog, {
                darkMode: this.darkMode,
                version: this.version,
                sessionId: this.sessionId,
                sessionSecret: this.sessionSecret,
                walletLinkUrl: this.walletLinkUrl,
                isOpen: this.isOpen,
                isConnected: this.isConnected,
                isParentConnection: this.isParentConnection,
                onCancel: this.onCancel
            }), this.root);
        });
        this.subscriptions.add(subscription);
    }
}
exports.LinkFlow = LinkFlow;

},{"6a75a3ed16605d8e":"213JP","8c51b9fc30a6a2ea":"gxhPq","f5337dfe4d66d384":"ggrIi","e6a1fcb5f1a29141":"1E58p","aad261a1fe459d05":"haWDe"}],"213JP":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Component", ()=>b);
parcelHelpers.export(exports, "Fragment", ()=>k);
parcelHelpers.export(exports, "cloneElement", ()=>E);
parcelHelpers.export(exports, "createContext", ()=>G);
parcelHelpers.export(exports, "createElement", ()=>_);
parcelHelpers.export(exports, "createRef", ()=>m);
parcelHelpers.export(exports, "h", ()=>_);
parcelHelpers.export(exports, "hydrate", ()=>D);
parcelHelpers.export(exports, "isValidElement", ()=>t);
parcelHelpers.export(exports, "options", ()=>l);
parcelHelpers.export(exports, "render", ()=>B);
parcelHelpers.export(exports, "toChildArray", ()=>H);
var n, l, u, t, i, o, r, f, e, c, s, a, h = {}, p = [], v = /acit|ex(?:s|g|n|p|$)|rph|grid|ows|mnc|ntw|ine[ch]|zoo|^ord|itera/i, y = Array.isArray;
function d(n, l) {
    for(var u in l)n[u] = l[u];
    return n;
}
function w(n) {
    var l = n.parentNode;
    l && l.removeChild(n);
}
function _(l, u, t) {
    var i, o, r, f = {};
    for(r in u)"key" == r ? i = u[r] : "ref" == r ? o = u[r] : f[r] = u[r];
    if (arguments.length > 2 && (f.children = arguments.length > 3 ? n.call(arguments, 2) : t), "function" == typeof l && null != l.defaultProps) for(r in l.defaultProps)void 0 === f[r] && (f[r] = l.defaultProps[r]);
    return g(l, f, i, o, null);
}
function g(n, t, i, o, r) {
    var f = {
        type: n,
        props: t,
        key: i,
        ref: o,
        __k: null,
        __: null,
        __b: 0,
        __e: null,
        __d: void 0,
        __c: null,
        constructor: void 0,
        __v: null == r ? ++u : r,
        __i: -1,
        __u: 0
    };
    return null == r && null != l.vnode && l.vnode(f), f;
}
function m() {
    return {
        current: null
    };
}
function k(n) {
    return n.children;
}
function b(n, l) {
    this.props = n, this.context = l;
}
function x(n, l) {
    if (null == l) return n.__ ? x(n.__, n.__i + 1) : null;
    for(var u; l < n.__k.length; l++)if (null != (u = n.__k[l]) && null != u.__e) return u.__e;
    return "function" == typeof n.type ? x(n) : null;
}
function C(n) {
    var l, u;
    if (null != (n = n.__) && null != n.__c) {
        for(n.__e = n.__c.base = null, l = 0; l < n.__k.length; l++)if (null != (u = n.__k[l]) && null != u.__e) {
            n.__e = n.__c.base = u.__e;
            break;
        }
        return C(n);
    }
}
function M(n) {
    (!n.__d && (n.__d = !0) && i.push(n) && !P.__r++ || o !== l.debounceRendering) && ((o = l.debounceRendering) || r)(P);
}
function P() {
    var n, u, t, o, r, e, c, s;
    for(i.sort(f); n = i.shift();)n.__d && (u = i.length, o = void 0, e = (r = (t = n).__v).__e, c = [], s = [], t.__P && ((o = d({}, r)).__v = r.__v + 1, l.vnode && l.vnode(o), O(t.__P, o, r, t.__n, t.__P.namespaceURI, 32 & r.__u ? [
        e
    ] : null, c, null == e ? x(r) : e, !!(32 & r.__u), s), o.__v = r.__v, o.__.__k[o.__i] = o, j(c, o, s), o.__e != e && C(o)), i.length > u && i.sort(f));
    P.__r = 0;
}
function S(n, l, u, t, i, o, r, f, e, c, s) {
    var a, v, y, d, w, _ = t && t.__k || p, g = l.length;
    for(u.__d = e, $(u, l, _), e = u.__d, a = 0; a < g; a++)null != (y = u.__k[a]) && "boolean" != typeof y && "function" != typeof y && (v = -1 === y.__i ? h : _[y.__i] || h, y.__i = a, O(n, y, v, i, o, r, f, e, c, s), d = y.__e, y.ref && v.ref != y.ref && (v.ref && N(v.ref, null, y), s.push(y.ref, y.__c || d, y)), null == w && null != d && (w = d), 65536 & y.__u || v.__k === y.__k ? e = I(y, e, n) : "function" == typeof y.type && void 0 !== y.__d ? e = y.__d : d && (e = d.nextSibling), y.__d = void 0, y.__u &= -196609);
    u.__d = e, u.__e = w;
}
function $(n, l, u) {
    var t, i, o, r, f, e = l.length, c = u.length, s = c, a = 0;
    for(n.__k = [], t = 0; t < e; t++)r = t + a, null != (i = n.__k[t] = null == (i = l[t]) || "boolean" == typeof i || "function" == typeof i ? null : "string" == typeof i || "number" == typeof i || "bigint" == typeof i || i.constructor == String ? g(null, i, null, null, null) : y(i) ? g(k, {
        children: i
    }, null, null, null) : void 0 === i.constructor && i.__b > 0 ? g(i.type, i.props, i.key, i.ref ? i.ref : null, i.__v) : i) ? (i.__ = n, i.__b = n.__b + 1, f = L(i, u, r, s), i.__i = f, o = null, -1 !== f && (s--, (o = u[f]) && (o.__u |= 131072)), null == o || null === o.__v ? (-1 == f && a--, "function" != typeof i.type && (i.__u |= 65536)) : f !== r && (f == r - 1 ? a-- : f == r + 1 ? a++ : f > r ? s > e - r ? a += f - r : a-- : f < r && (f == r - a ? a -= f - r : a++), f !== t + a && (i.__u |= 65536))) : (o = u[r]) && null == o.key && o.__e && 0 == (131072 & o.__u) && (o.__e == n.__d && (n.__d = x(o)), V(o, o, !1), u[r] = null, s--);
    if (s) for(t = 0; t < c; t++)null != (o = u[t]) && 0 == (131072 & o.__u) && (o.__e == n.__d && (n.__d = x(o)), V(o, o));
}
function I(n, l, u) {
    var t, i;
    if ("function" == typeof n.type) {
        for(t = n.__k, i = 0; t && i < t.length; i++)t[i] && (t[i].__ = n, l = I(t[i], l, u));
        return l;
    }
    n.__e != l && (l && n.type && !u.contains(l) && (l = x(n)), u.insertBefore(n.__e, l || null), l = n.__e);
    do l = l && l.nextSibling;
    while (null != l && 8 === l.nodeType);
    return l;
}
function H(n, l) {
    return l = l || [], null == n || "boolean" == typeof n || (y(n) ? n.some(function(n) {
        H(n, l);
    }) : l.push(n)), l;
}
function L(n, l, u, t) {
    var i = n.key, o = n.type, r = u - 1, f = u + 1, e = l[u];
    if (null === e || e && i == e.key && o === e.type && 0 == (131072 & e.__u)) return u;
    if (t > (null != e && 0 == (131072 & e.__u) ? 1 : 0)) for(; r >= 0 || f < l.length;){
        if (r >= 0) {
            if ((e = l[r]) && 0 == (131072 & e.__u) && i == e.key && o === e.type) return r;
            r--;
        }
        if (f < l.length) {
            if ((e = l[f]) && 0 == (131072 & e.__u) && i == e.key && o === e.type) return f;
            f++;
        }
    }
    return -1;
}
function T(n, l, u) {
    "-" === l[0] ? n.setProperty(l, null == u ? "" : u) : n[l] = null == u ? "" : "number" != typeof u || v.test(l) ? u : u + "px";
}
function A(n, l, u, t, i) {
    var o;
    n: if ("style" === l) {
        if ("string" == typeof u) n.style.cssText = u;
        else {
            if ("string" == typeof t && (n.style.cssText = t = ""), t) for(l in t)u && l in u || T(n.style, l, "");
            if (u) for(l in u)t && u[l] === t[l] || T(n.style, l, u[l]);
        }
    } else if ("o" === l[0] && "n" === l[1]) o = l !== (l = l.replace(/(PointerCapture)$|Capture$/i, "$1")), l = l.toLowerCase() in n || "onFocusOut" === l || "onFocusIn" === l ? l.toLowerCase().slice(2) : l.slice(2), n.l || (n.l = {}), n.l[l + o] = u, u ? t ? u.u = t.u : (u.u = e, n.addEventListener(l, o ? s : c, o)) : n.removeEventListener(l, o ? s : c, o);
    else {
        if ("http://www.w3.org/2000/svg" == i) l = l.replace(/xlink(H|:h)/, "h").replace(/sName$/, "s");
        else if ("width" != l && "height" != l && "href" != l && "list" != l && "form" != l && "tabIndex" != l && "download" != l && "rowSpan" != l && "colSpan" != l && "role" != l && "popover" != l && l in n) try {
            n[l] = null == u ? "" : u;
            break n;
        } catch (n) {}
        "function" == typeof u || (null == u || !1 === u && "-" !== l[4] ? n.removeAttribute(l) : n.setAttribute(l, "popover" == l && 1 == u ? "" : u));
    }
}
function F(n) {
    return function(u) {
        if (this.l) {
            var t = this.l[u.type + n];
            if (null == u.t) u.t = e++;
            else if (u.t < t.u) return;
            return t(l.event ? l.event(u) : u);
        }
    };
}
function O(n, u, t, i, o, r, f, e, c, s) {
    var a, h, p, v, w, _, g, m, x, C, M, P, $, I, H, L, T = u.type;
    if (void 0 !== u.constructor) return null;
    128 & t.__u && (c = !!(32 & t.__u), r = [
        e = u.__e = t.__e
    ]), (a = l.__b) && a(u);
    n: if ("function" == typeof T) try {
        if (m = u.props, x = "prototype" in T && T.prototype.render, C = (a = T.contextType) && i[a.__c], M = a ? C ? C.props.value : a.__ : i, t.__c ? g = (h = u.__c = t.__c).__ = h.__E : (x ? u.__c = h = new T(m, M) : (u.__c = h = new b(m, M), h.constructor = T, h.render = q), C && C.sub(h), h.props = m, h.state || (h.state = {}), h.context = M, h.__n = i, p = h.__d = !0, h.__h = [], h._sb = []), x && null == h.__s && (h.__s = h.state), x && null != T.getDerivedStateFromProps && (h.__s == h.state && (h.__s = d({}, h.__s)), d(h.__s, T.getDerivedStateFromProps(m, h.__s))), v = h.props, w = h.state, h.__v = u, p) x && null == T.getDerivedStateFromProps && null != h.componentWillMount && h.componentWillMount(), x && null != h.componentDidMount && h.__h.push(h.componentDidMount);
        else {
            if (x && null == T.getDerivedStateFromProps && m !== v && null != h.componentWillReceiveProps && h.componentWillReceiveProps(m, M), !h.__e && (null != h.shouldComponentUpdate && !1 === h.shouldComponentUpdate(m, h.__s, M) || u.__v === t.__v)) {
                for(u.__v !== t.__v && (h.props = m, h.state = h.__s, h.__d = !1), u.__e = t.__e, u.__k = t.__k, u.__k.forEach(function(n) {
                    n && (n.__ = u);
                }), P = 0; P < h._sb.length; P++)h.__h.push(h._sb[P]);
                h._sb = [], h.__h.length && f.push(h);
                break n;
            }
            null != h.componentWillUpdate && h.componentWillUpdate(m, h.__s, M), x && null != h.componentDidUpdate && h.__h.push(function() {
                h.componentDidUpdate(v, w, _);
            });
        }
        if (h.context = M, h.props = m, h.__P = n, h.__e = !1, $ = l.__r, I = 0, x) {
            for(h.state = h.__s, h.__d = !1, $ && $(u), a = h.render(h.props, h.state, h.context), H = 0; H < h._sb.length; H++)h.__h.push(h._sb[H]);
            h._sb = [];
        } else do h.__d = !1, $ && $(u), a = h.render(h.props, h.state, h.context), h.state = h.__s;
        while (h.__d && ++I < 25);
        h.state = h.__s, null != h.getChildContext && (i = d(d({}, i), h.getChildContext())), x && !p && null != h.getSnapshotBeforeUpdate && (_ = h.getSnapshotBeforeUpdate(v, w)), S(n, y(L = null != a && a.type === k && null == a.key ? a.props.children : a) ? L : [
            L
        ], u, t, i, o, r, f, e, c, s), h.base = u.__e, u.__u &= -161, h.__h.length && f.push(h), g && (h.__E = h.__ = null);
    } catch (n) {
        if (u.__v = null, c || null != r) {
            for(u.__u |= c ? 160 : 32; e && 8 === e.nodeType && e.nextSibling;)e = e.nextSibling;
            r[r.indexOf(e)] = null, u.__e = e;
        } else u.__e = t.__e, u.__k = t.__k;
        l.__e(n, u, t);
    }
    else null == r && u.__v === t.__v ? (u.__k = t.__k, u.__e = t.__e) : u.__e = z(t.__e, u, t, i, o, r, f, c, s);
    (a = l.diffed) && a(u);
}
function j(n, u, t) {
    u.__d = void 0;
    for(var i = 0; i < t.length; i++)N(t[i], t[++i], t[++i]);
    l.__c && l.__c(u, n), n.some(function(u) {
        try {
            n = u.__h, u.__h = [], n.some(function(n) {
                n.call(u);
            });
        } catch (n) {
            l.__e(n, u.__v);
        }
    });
}
function z(l, u, t, i, o, r, f, e, c) {
    var s, a, p, v, d, _, g, m = t.props, k = u.props, b = u.type;
    if ("svg" === b ? o = "http://www.w3.org/2000/svg" : "math" === b ? o = "http://www.w3.org/1998/Math/MathML" : o || (o = "http://www.w3.org/1999/xhtml"), null != r) {
        for(s = 0; s < r.length; s++)if ((d = r[s]) && "setAttribute" in d == !!b && (b ? d.localName === b : 3 === d.nodeType)) {
            l = d, r[s] = null;
            break;
        }
    }
    if (null == l) {
        if (null === b) return document.createTextNode(k);
        l = document.createElementNS(o, b, k.is && k), r = null, e = !1;
    }
    if (null === b) m === k || e && l.data === k || (l.data = k);
    else {
        if (r = r && n.call(l.childNodes), m = t.props || h, !e && null != r) for(m = {}, s = 0; s < l.attributes.length; s++)m[(d = l.attributes[s]).name] = d.value;
        for(s in m)if (d = m[s], "children" == s) ;
        else if ("dangerouslySetInnerHTML" == s) p = d;
        else if ("key" !== s && !(s in k)) {
            if ("value" == s && "defaultValue" in k || "checked" == s && "defaultChecked" in k) continue;
            A(l, s, null, d, o);
        }
        for(s in k)d = k[s], "children" == s ? v = d : "dangerouslySetInnerHTML" == s ? a = d : "value" == s ? _ = d : "checked" == s ? g = d : "key" === s || e && "function" != typeof d || m[s] === d || A(l, s, d, m[s], o);
        if (a) e || p && (a.__html === p.__html || a.__html === l.innerHTML) || (l.innerHTML = a.__html), u.__k = [];
        else if (p && (l.innerHTML = ""), S(l, y(v) ? v : [
            v
        ], u, t, i, "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : o, r, f, r ? r[0] : t.__k && x(t, 0), e, c), null != r) for(s = r.length; s--;)null != r[s] && w(r[s]);
        e || (s = "value", void 0 !== _ && (_ !== l[s] || "progress" === b && !_ || "option" === b && _ !== m[s]) && A(l, s, _, m[s], o), s = "checked", void 0 !== g && g !== l[s] && A(l, s, g, m[s], o));
    }
    return l;
}
function N(n, u, t) {
    try {
        if ("function" == typeof n) {
            var i = "function" == typeof n.__u;
            i && n.__u(), i && null == u || (n.__u = n(u));
        } else n.current = u;
    } catch (n) {
        l.__e(n, t);
    }
}
function V(n, u, t) {
    var i, o;
    if (l.unmount && l.unmount(n), (i = n.ref) && (i.current && i.current !== n.__e || N(i, null, u)), null != (i = n.__c)) {
        if (i.componentWillUnmount) try {
            i.componentWillUnmount();
        } catch (n) {
            l.__e(n, u);
        }
        i.base = i.__P = null;
    }
    if (i = n.__k) for(o = 0; o < i.length; o++)i[o] && V(i[o], u, t || "function" != typeof n.type);
    t || null == n.__e || w(n.__e), n.__c = n.__ = n.__e = n.__d = void 0;
}
function q(n, l, u) {
    return this.constructor(n, u);
}
function B(u, t, i) {
    var o, r, f, e;
    l.__ && l.__(u, t), r = (o = "function" == typeof i) ? null : i && i.__k || t.__k, f = [], e = [], O(t, u = (!o && i || t).__k = _(k, null, [
        u
    ]), r || h, h, t.namespaceURI, !o && i ? [
        i
    ] : r ? null : t.firstChild ? n.call(t.childNodes) : null, f, !o && i ? i : r ? r.__e : t.firstChild, o, e), j(f, u, e);
}
function D(n, l) {
    B(n, l, D);
}
function E(l, u, t) {
    var i, o, r, f, e = d({}, l.props);
    for(r in l.type && l.type.defaultProps && (f = l.type.defaultProps), u)"key" == r ? i = u[r] : "ref" == r ? o = u[r] : e[r] = void 0 === u[r] && void 0 !== f ? f[r] : u[r];
    return arguments.length > 2 && (e.children = arguments.length > 3 ? n.call(arguments, 2) : t), g(l.type, e, i || l.key, o || l.ref, null);
}
function G(n, l) {
    var u = {
        __c: l = "__cC" + a++,
        __: n,
        Consumer: function(n, l) {
            return n.children(l);
        },
        Provider: function(n) {
            var u, t;
            return this.getChildContext || (u = [], (t = {})[l] = this, this.getChildContext = function() {
                return t;
            }, this.componentWillUnmount = function() {
                u = null;
            }, this.shouldComponentUpdate = function(n) {
                this.props.value !== n.value && u.some(function(n) {
                    n.__e = !0, M(n);
                });
            }, this.sub = function(n) {
                u.push(n);
                var l = n.componentWillUnmount;
                n.componentWillUnmount = function() {
                    u && u.splice(u.indexOf(n), 1), l && l.call(n);
                };
            }), n.children;
        }
    };
    return u.Provider.__ = u.Consumer.contextType = u;
}
n = p.slice, l = {
    __e: function(n, l, u, t) {
        for(var i, o, r; l = l.__;)if ((i = l.__c) && !i.__) try {
            if ((o = i.constructor) && null != o.getDerivedStateFromError && (i.setState(o.getDerivedStateFromError(n)), r = i.__d), null != i.componentDidCatch && (i.componentDidCatch(n, t || {}), r = i.__d), r) return i.__E = i;
        } catch (l) {
            n = l;
        }
        throw n;
    }
}, u = 0, t = function(n) {
    return null != n && null == n.constructor;
}, b.prototype.setState = function(n, l) {
    var u;
    u = null != this.__s && this.__s !== this.state ? this.__s : this.__s = d({}, this.state), "function" == typeof n && (n = n(d({}, u), this.props)), n && d(u, n), null != n && this.__v && (l && this._sb.push(l), M(this));
}, b.prototype.forceUpdate = function(n) {
    this.__v && (this.__e = !0, n && this.__h.push(n), M(this));
}, b.prototype.render = k, i = [], r = "function" == typeof Promise ? Promise.prototype.then.bind(Promise.resolve()) : setTimeout, f = function(n, l) {
    return n.__v.__b - l.__v.__b;
}, P.__r = 0, e = 0, c = F(!1), s = F(!0), a = 0;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"1E58p":[function(require,module,exports) {
"use strict";
// Copyright (c) 2018-2020 WalletLink.org <https://www.walletlink.org/>
// Copyright (c) 2018-2020 Coinbase, Inc. <https://www.coinbase.com/>
// Licensed under the Apache License, version 2.0
var __importDefault = this && this.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.LinkDialog = void 0;
const clsx_1 = __importDefault(require("f4d31c461a434d86"));
const preact_1 = require("4225833cc03d3c52");
const hooks_1 = require("dd2ea481bd7dfda8");
const LinkDialog_css_1 = __importDefault(require("77abd2a05fec9308"));
const QRCode_1 = require("c32ee2c57530c206");
const Spinner_1 = require("cf1c85e171edc15e");
const version_1 = require("c52a84a156bef770");
const LinkDialog = (props)=>{
    const [isContainerHidden, setContainerHidden] = (0, hooks_1.useState)(!props.isOpen);
    const [isDialogHidden, setDialogHidden] = (0, hooks_1.useState)(!props.isOpen);
    (0, hooks_1.useEffect)(()=>{
        const { isOpen } = props;
        const timers = [
            window.setTimeout(()=>{
                setDialogHidden(!isOpen);
            }, 10)
        ];
        if (isOpen) setContainerHidden(false);
        else timers.push(window.setTimeout(()=>{
            setContainerHidden(true);
        }, 360));
        return ()=>{
            timers.forEach(window.clearTimeout);
        };
    }, [
        props.isOpen
    ]);
    return (0, preact_1.h)("div", {
        class: (0, clsx_1.default)("-walletlink-link-dialog-container", props.darkMode && "-walletlink-link-dialog-container-dark", isContainerHidden && "-walletlink-link-dialog-container-hidden")
    }, (0, preact_1.h)("style", null, LinkDialog_css_1.default), (0, preact_1.h)("div", {
        class: (0, clsx_1.default)("-walletlink-link-dialog-backdrop", isDialogHidden && "-walletlink-link-dialog-backdrop-hidden")
    }), (0, preact_1.h)("div", {
        class: "-walletlink-link-dialog"
    }, (0, preact_1.h)("div", {
        class: (0, clsx_1.default)("-walletlink-link-dialog-box", isDialogHidden && "-walletlink-link-dialog-box-hidden")
    }, (0, preact_1.h)(ScanQRCode, {
        darkMode: props.darkMode,
        version: props.version,
        sessionId: props.sessionId,
        sessionSecret: props.sessionSecret,
        walletLinkUrl: props.walletLinkUrl,
        isConnected: props.isConnected,
        isParentConnection: props.isParentConnection
    }), props.onCancel && (0, preact_1.h)(CancelButton, {
        onClick: props.onCancel
    }))));
};
exports.LinkDialog = LinkDialog;
const ScanQRCode = (props)=>{
    const serverUrl = window.encodeURIComponent(props.walletLinkUrl);
    const sessionIdKey = props.isParentConnection ? "parent-id" : "id";
    const qrUrl = `${props.walletLinkUrl}/#/link?${sessionIdKey}=${props.sessionId}&secret=${props.sessionSecret}&server=${serverUrl}&v=1`;
    return (0, preact_1.h)("div", {
        class: "-walletlink-link-dialog-box-content"
    }, (0, preact_1.h)("h3", null, "Scan to", (0, preact_1.h)("br", null), " Connect"), (0, preact_1.h)("div", {
        class: "-walletlink-link-dialog-box-content-qrcode"
    }, (0, preact_1.h)("div", {
        class: "-walletlink-link-dialog-box-content-qrcode-wrapper"
    }, (0, preact_1.h)(QRCode_1.QRCode, {
        content: qrUrl,
        width: 224,
        height: 224,
        fgColor: "#000",
        bgColor: "transparent"
    })), (0, preact_1.h)("input", {
        type: "hidden",
        name: "walletlink-version",
        value: version_1.LIB_VERSION
    }), (0, preact_1.h)("input", {
        type: "hidden",
        value: qrUrl
    }), !props.isConnected && (0, preact_1.h)("div", {
        class: "-walletlink-link-dialog-box-content-qrcode-connecting"
    }, (0, preact_1.h)(Spinner_1.Spinner, {
        size: 128,
        color: props.darkMode ? "#fff" : "#000"
    }), (0, preact_1.h)("p", null, "Connecting...")), (0, preact_1.h)("p", {
        title: `WalletLink v${props.version}`
    }, "Powered by WalletLink")), (0, preact_1.h)("a", {
        href: `${props.walletLinkUrl}/#/wallets`,
        target: "_blank",
        rel: "noopener"
    }, "Don\u2019t have a wallet app?"));
};
const CancelButton = (props)=>(0, preact_1.h)("button", {
        class: "-walletlink-link-dialog-box-cancel",
        onClick: props.onClick
    }, (0, preact_1.h)("div", {
        class: "-walletlink-link-dialog-box-cancel-x"
    }));

},{"f4d31c461a434d86":"7UQcB","4225833cc03d3c52":"213JP","dd2ea481bd7dfda8":"MIejN","77abd2a05fec9308":"dBV8P","c32ee2c57530c206":"fLwXv","cf1c85e171edc15e":"ceD7a","c52a84a156bef770":"a0bQk"}],"7UQcB":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "clsx", ()=>clsx);
function r(e) {
    var t, f, n = "";
    if ("string" == typeof e || "number" == typeof e) n += e;
    else if ("object" == typeof e) {
        if (Array.isArray(e)) for(t = 0; t < e.length; t++)e[t] && (f = r(e[t])) && (n && (n += " "), n += f);
        else for(t in e)e[t] && (n && (n += " "), n += t);
    }
    return n;
}
function clsx() {
    for(var e, t, f = 0, n = ""; f < arguments.length;)(e = arguments[f++]) && (t = r(e)) && (n && (n += " "), n += t);
    return n;
}
exports.default = clsx;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"MIejN":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useCallback", ()=>q);
parcelHelpers.export(exports, "useContext", ()=>x);
parcelHelpers.export(exports, "useDebugValue", ()=>P);
parcelHelpers.export(exports, "useEffect", ()=>y);
parcelHelpers.export(exports, "useErrorBoundary", ()=>b);
parcelHelpers.export(exports, "useId", ()=>g);
parcelHelpers.export(exports, "useImperativeHandle", ()=>F);
parcelHelpers.export(exports, "useLayoutEffect", ()=>_);
parcelHelpers.export(exports, "useMemo", ()=>T);
parcelHelpers.export(exports, "useReducer", ()=>p);
parcelHelpers.export(exports, "useRef", ()=>A);
parcelHelpers.export(exports, "useState", ()=>h);
var _preact = require("preact");
var t, r, u, i, o = 0, f = [], c = (0, _preact.options), e = c.__b, a = c.__r, v = c.diffed, l = c.__c, m = c.unmount, s = c.__;
function d(n, t) {
    c.__h && c.__h(r, n, o || t), o = 0;
    var u = r.__H || (r.__H = {
        __: [],
        __h: []
    });
    return n >= u.__.length && u.__.push({}), u.__[n];
}
function h(n) {
    return o = 1, p(D, n);
}
function p(n, u, i) {
    var o = d(t++, 2);
    if (o.t = n, !o.__c && (o.__ = [
        i ? i(u) : D(void 0, u),
        function(n) {
            var t = o.__N ? o.__N[0] : o.__[0], r = o.t(t, n);
            t !== r && (o.__N = [
                r,
                o.__[1]
            ], o.__c.setState({}));
        }
    ], o.__c = r, !r.u)) {
        var f = function(n, t, r) {
            if (!o.__c.__H) return !0;
            var u = o.__c.__H.__.filter(function(n) {
                return !!n.__c;
            });
            if (u.every(function(n) {
                return !n.__N;
            })) return !c || c.call(this, n, t, r);
            var i = !1;
            return u.forEach(function(n) {
                if (n.__N) {
                    var t = n.__[0];
                    n.__ = n.__N, n.__N = void 0, t !== n.__[0] && (i = !0);
                }
            }), !(!i && o.__c.props === n) && (!c || c.call(this, n, t, r));
        };
        r.u = !0;
        var c = r.shouldComponentUpdate, e = r.componentWillUpdate;
        r.componentWillUpdate = function(n, t, r) {
            if (this.__e) {
                var u = c;
                c = void 0, f(n, t, r), c = u;
            }
            e && e.call(this, n, t, r);
        }, r.shouldComponentUpdate = f;
    }
    return o.__N || o.__;
}
function y(n, u) {
    var i = d(t++, 3);
    !c.__s && C(i.__H, u) && (i.__ = n, i.i = u, r.__H.__h.push(i));
}
function _(n, u) {
    var i = d(t++, 4);
    !c.__s && C(i.__H, u) && (i.__ = n, i.i = u, r.__h.push(i));
}
function A(n) {
    return o = 5, T(function() {
        return {
            current: n
        };
    }, []);
}
function F(n, t, r) {
    o = 6, _(function() {
        return "function" == typeof n ? (n(t()), function() {
            return n(null);
        }) : n ? (n.current = t(), function() {
            return n.current = null;
        }) : void 0;
    }, null == r ? r : r.concat(n));
}
function T(n, r) {
    var u = d(t++, 7);
    return C(u.__H, r) && (u.__ = n(), u.__H = r, u.__h = n), u.__;
}
function q(n, t) {
    return o = 8, T(function() {
        return n;
    }, t);
}
function x(n) {
    var u = r.context[n.__c], i = d(t++, 9);
    return i.c = n, u ? (null == i.__ && (i.__ = !0, u.sub(r)), u.props.value) : n.__;
}
function P(n, t) {
    c.useDebugValue && c.useDebugValue(t ? t(n) : n);
}
function b(n) {
    var u = d(t++, 10), i = h();
    return u.__ = n, r.componentDidCatch || (r.componentDidCatch = function(n, t) {
        u.__ && u.__(n, t), i[1](n);
    }), [
        i[0],
        function() {
            i[1](void 0);
        }
    ];
}
function g() {
    var n = d(t++, 11);
    if (!n.__) {
        for(var u = r.__v; null !== u && !u.__m && null !== u.__;)u = u.__;
        var i = u.__m || (u.__m = [
            0,
            0
        ]);
        n.__ = "P" + i[0] + "-" + i[1]++;
    }
    return n.__;
}
function j() {
    for(var n; n = f.shift();)if (n.__P && n.__H) try {
        n.__H.__h.forEach(z), n.__H.__h.forEach(B), n.__H.__h = [];
    } catch (t) {
        n.__H.__h = [], c.__e(t, n.__v);
    }
}
c.__b = function(n) {
    r = null, e && e(n);
}, c.__ = function(n, t) {
    n && t.__k && t.__k.__m && (n.__m = t.__k.__m), s && s(n, t);
}, c.__r = function(n) {
    a && a(n), t = 0;
    var i = (r = n.__c).__H;
    i && (u === r ? (i.__h = [], r.__h = [], i.__.forEach(function(n) {
        n.__N && (n.__ = n.__N), n.i = n.__N = void 0;
    })) : (i.__h.forEach(z), i.__h.forEach(B), i.__h = [], t = 0)), u = r;
}, c.diffed = function(n) {
    v && v(n);
    var t = n.__c;
    t && t.__H && (t.__H.__h.length && (1 !== f.push(t) && i === c.requestAnimationFrame || ((i = c.requestAnimationFrame) || w)(j)), t.__H.__.forEach(function(n) {
        n.i && (n.__H = n.i), n.i = void 0;
    })), u = r = null;
}, c.__c = function(n, t) {
    t.some(function(n) {
        try {
            n.__h.forEach(z), n.__h = n.__h.filter(function(n) {
                return !n.__ || B(n);
            });
        } catch (r) {
            t.some(function(n) {
                n.__h && (n.__h = []);
            }), t = [], c.__e(r, n.__v);
        }
    }), l && l(n, t);
}, c.unmount = function(n) {
    m && m(n);
    var t, r = n.__c;
    r && r.__H && (r.__H.__.forEach(function(n) {
        try {
            z(n);
        } catch (n) {
            t = n;
        }
    }), r.__H = void 0, t && c.__e(t, r.__v));
};
var k = "function" == typeof requestAnimationFrame;
function w(n) {
    var t, r = function() {
        clearTimeout(u), k && cancelAnimationFrame(t), setTimeout(n);
    }, u = setTimeout(r, 100);
    k && (t = requestAnimationFrame(r));
}
function z(n) {
    var t = r, u = n.__c;
    "function" == typeof u && (n.__c = void 0, u()), r = t;
}
function B(n) {
    var t = r;
    n.__c = n.__(), r = t;
}
function C(n, t) {
    return !n || n.length !== t.length || t.some(function(t, r) {
        return t !== n[r];
    });
}
function D(n, t) {
    return "function" == typeof t ? t(n) : t;
}

},{"preact":"213JP","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"dBV8P":[function(require,module,exports) {
"use strict";
// Copyright (c) 2018-2021 WalletLink.org <https://www.walletlink.org/>
// Copyright (c) 2018-2021 Coinbase, Inc. <https://www.coinbase.com/>
// Licensed under the Apache License, version 2.0
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = `.-walletlink-css-reset .-walletlink-link-dialog{z-index:2147483647;position:fixed;top:0;left:0;right:0;bottom:0;display:flex;align-items:center;justify-content:center}.-walletlink-css-reset .-walletlink-link-dialog-backdrop{z-index:2147483647;position:fixed;top:0;left:0;right:0;bottom:0;background-color:rgba(0,0,0,.33);transition:opacity .25s}.-walletlink-css-reset .-walletlink-link-dialog-backdrop-hidden{opacity:0}.-walletlink-css-reset .-walletlink-link-dialog-box{display:flex;position:relative;flex-direction:column;background-color:#f6f6f6;border-radius:16px;box-shadow:0px 16px 24px rgba(0,0,0,.1),0px 0px 8px rgba(0,0,0,.05);transform:scale(1);transition:opacity .25s,transform .25s;overflow:hidden}.-walletlink-css-reset .-walletlink-link-dialog-box-hidden{opacity:0;transform:scale(0.85)}.-walletlink-css-reset .-walletlink-link-dialog-box-content{padding:24px;text-align:center}.-walletlink-css-reset .-walletlink-link-dialog-box-content h3{display:block;margin-bottom:24px;text-align:left;text-transform:uppercase;font-size:22px;font-weight:bold;line-height:1.2;color:#000}.-walletlink-css-reset .-walletlink-link-dialog-box-content-qrcode{position:relative;display:block;margin-bottom:24px;background-color:#f6f6f6;padding:16px;border-radius:16px;box-shadow:4px 4px 8px rgba(0,0,0,.15),-8px -8px 8px #fff;overflow:hidden}.-walletlink-css-reset .-walletlink-link-dialog-box-content-qrcode-wrapper{display:block;width:232px;height:232px;padding:4px;border-radius:4px;background:#f4f4f4;margin-bottom:16px}.-walletlink-css-reset .-walletlink-link-dialog-box-content-qrcode-wrapper img{display:block;width:224px;height:224px}.-walletlink-css-reset .-walletlink-link-dialog-box-content-qrcode>p{display:block;color:gray;font-weight:bold;font-size:12px;text-align:center}.-walletlink-css-reset .-walletlink-link-dialog-box-content-qrcode-connecting{position:absolute;top:0;left:0;right:0;bottom:0;display:flex;flex-direction:column;align-items:center;justify-content:center;background:rgba(246,246,246,.98)}.-walletlink-css-reset .-walletlink-link-dialog-box-content-qrcode-connecting p{margin-top:16px;color:#333;font-size:12px;font-weight:bold}.-walletlink-css-reset .-walletlink-link-dialog-box-content a{text-align:center;cursor:pointer;transition:color .1s;font-size:14px}.-walletlink-css-reset .-walletlink-link-dialog-box-content a,.-walletlink-css-reset .-walletlink-link-dialog-box-content a:link,.-walletlink-css-reset .-walletlink-link-dialog-box-content a:visited{color:#999}.-walletlink-css-reset .-walletlink-link-dialog-box-content a:hover,.-walletlink-css-reset .-walletlink-link-dialog-box-content a:active{color:#666;text-decoration:underline}.-walletlink-css-reset .-walletlink-link-dialog-box-cancel{position:absolute;-webkit-appearance:none;display:flex;align-items:center;justify-content:center;top:24px;right:24px;width:24px;height:24px;border-radius:12px;background-color:#e7e7e7;cursor:pointer}.-walletlink-css-reset .-walletlink-link-dialog-box-cancel-x{position:relative;display:block}.-walletlink-css-reset .-walletlink-link-dialog-box-cancel-x::before,.-walletlink-css-reset .-walletlink-link-dialog-box-cancel-x::after{content:"";position:absolute;display:block;top:-1px;left:-7px;width:14px;height:2px;background-color:#999;transition:background-color .2s}.-walletlink-css-reset .-walletlink-link-dialog-box-cancel-x::before{transform:rotate(45deg)}.-walletlink-css-reset .-walletlink-link-dialog-box-cancel-x::after{transform:rotate(135deg)}.-walletlink-css-reset .-walletlink-link-dialog-box-cancel:hover .-walletlink-link-dialog-box-cancel-x-a,.-walletlink-css-reset .-walletlink-link-dialog-box-cancel:hover .-walletlink-link-dialog-box-cancel-x-b{background-color:#000}.-walletlink-css-reset .-walletlink-link-dialog-container{display:block}.-walletlink-css-reset .-walletlink-link-dialog-container-hidden{display:none}.-walletlink-css-reset .-walletlink-link-dialog-container-dark .-walletlink-link-dialog-box{background-color:#2a2a2a}.-walletlink-css-reset .-walletlink-link-dialog-container-dark .-walletlink-link-dialog-box-content h3{color:#ccc}.-walletlink-css-reset .-walletlink-link-dialog-container-dark .-walletlink-link-dialog-box-content-qrcode{background-color:#2a2a2a;box-shadow:4px 4px 8px rgba(0,0,0,.5),-8px -8px 8px #343434}.-walletlink-css-reset .-walletlink-link-dialog-container-dark .-walletlink-link-dialog-box-content-qrcode>p{color:#999}.-walletlink-css-reset .-walletlink-link-dialog-container-dark .-walletlink-link-dialog-box-content-qrcode-connecting{background:rgba(42,42,42,.98)}.-walletlink-css-reset .-walletlink-link-dialog-container-dark .-walletlink-link-dialog-box-content-qrcode-connecting p{color:#ddd}.-walletlink-css-reset .-walletlink-link-dialog-container-dark .-walletlink-link-dialog-box-content a,.-walletlink-css-reset .-walletlink-link-dialog-container-dark .-walletlink-link-dialog-box-content a:link,.-walletlink-css-reset .-walletlink-link-dialog-container-dark .-walletlink-link-dialog-box-content a:visited{color:#888}.-walletlink-css-reset .-walletlink-link-dialog-container-dark .-walletlink-link-dialog-box-content a:hover,.-walletlink-css-reset .-walletlink-link-dialog-container-dark .-walletlink-link-dialog-box-content a:active{color:#aaa}.-walletlink-css-reset .-walletlink-link-dialog-container-dark .-walletlink-link-dialog-box-cancel{background-color:#333}.-walletlink-css-reset .-walletlink-link-dialog-container-dark .-walletlink-link-dialog-box-cancel-x::before,.-walletlink-css-reset .-walletlink-link-dialog-container-dark .-walletlink-link-dialog-box-cancel-x::after{background-color:#aaa}.-walletlink-css-reset .-walletlink-link-dialog-container-dark .-walletlink-link-dialog-box-cancel:hover .-walletlink-link-dialog-box-cancel-x::before,.-walletlink-css-reset .-walletlink-link-dialog-container-dark .-walletlink-link-dialog-box-cancel:hover .-walletlink-link-dialog-box-cancel-x::after{background-color:#eee}`;

},{}],"fLwXv":[function(require,module,exports) {
var Buffer = require("5edf7a78cb4ed086").Buffer;
"use strict";
// Copyright (c) 2018-2020 WalletLink.org <https://www.walletlink.org/>
// Copyright (c) 2018-2020 Coinbase, Inc. <https://www.coinbase.com/>
// Licensed under the Apache License, version 2.0
var __importDefault = this && this.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.QRCode = void 0;
const preact_1 = require("f734a0226a4717ed");
const hooks_1 = require("36a263e8b9401662");
const qrcode_svg_1 = __importDefault(require("a3d2c007dad66f98"));
const QRCode = (props)=>{
    const [svg, setSvg] = (0, hooks_1.useState)("");
    (0, hooks_1.useEffect)(()=>{
        var _a, _b;
        const qrcode = new qrcode_svg_1.default({
            content: props.content,
            background: props.bgColor || "#ffffff",
            color: props.fgColor || "#000000",
            container: "svg",
            ecl: "M",
            width: (_a = props.width) !== null && _a !== void 0 ? _a : 256,
            height: (_b = props.height) !== null && _b !== void 0 ? _b : 256,
            padding: 0,
            image: props.image
        });
        const base64 = Buffer.from(qrcode.svg(), "utf8").toString("base64");
        setSvg(`data:image/svg+xml;base64,${base64}`);
    });
    return svg ? (0, preact_1.h)("img", {
        src: svg,
        alt: "QR Code"
    }) : null;
};
exports.QRCode = QRCode;

},{"5edf7a78cb4ed086":"l5Twm","f734a0226a4717ed":"213JP","36a263e8b9401662":"MIejN","a3d2c007dad66f98":"e7o2r"}],"e7o2r":[function(require,module,exports) {
/**
 * @fileoverview
 * - modified davidshimjs/qrcodejs library for use in node.js
 * - Using the 'QRCode for Javascript library'
 * - Fixed dataset of 'QRCode for Javascript library' for support full-spec.
 * - this library has no dependencies.
 *
 * @version 0.9.1 (2016-02-12)
 * @author davidshimjs, papnkukn
 * @see <a href="http://www.d-project.com/" target="_blank">http://www.d-project.com/</a>
 * @see <a href="http://jeromeetienne.github.com/jquery-qrcode/" target="_blank">http://jeromeetienne.github.com/jquery-qrcode/</a>
 * @see <a href="https://github.com/davidshimjs/qrcodejs" target="_blank">https://github.com/davidshimjs/qrcodejs</a>
 */ //---------------------------------------------------------------------
// QRCode for JavaScript
//
// Copyright (c) 2009 Kazuhiko Arase
//
// URL: http://www.d-project.com/
//
// Licensed under the MIT license:
//   http://www.opensource.org/licenses/mit-license.php
//
// The word "QR Code" is registered trademark of
// DENSO WAVE INCORPORATED
//   http://www.denso-wave.com/qrcode/faqpatent-e.html
//
//---------------------------------------------------------------------
function QR8bitByte(data) {
    this.mode = QRMode.MODE_8BIT_BYTE;
    this.data = data;
    this.parsedData = [];
    // Added to support UTF-8 Characters
    for(var i = 0, l = this.data.length; i < l; i++){
        var byteArray = [];
        var code = this.data.charCodeAt(i);
        if (code > 0x10000) {
            byteArray[0] = 0xF0 | (code & 0x1C0000) >>> 18;
            byteArray[1] = 0x80 | (code & 0x3F000) >>> 12;
            byteArray[2] = 0x80 | (code & 0xFC0) >>> 6;
            byteArray[3] = 0x80 | code & 0x3F;
        } else if (code > 0x800) {
            byteArray[0] = 0xE0 | (code & 0xF000) >>> 12;
            byteArray[1] = 0x80 | (code & 0xFC0) >>> 6;
            byteArray[2] = 0x80 | code & 0x3F;
        } else if (code > 0x80) {
            byteArray[0] = 0xC0 | (code & 0x7C0) >>> 6;
            byteArray[1] = 0x80 | code & 0x3F;
        } else byteArray[0] = code;
        this.parsedData.push(byteArray);
    }
    this.parsedData = Array.prototype.concat.apply([], this.parsedData);
    if (this.parsedData.length != this.data.length) {
        this.parsedData.unshift(191);
        this.parsedData.unshift(187);
        this.parsedData.unshift(239);
    }
}
QR8bitByte.prototype = {
    getLength: function(buffer) {
        return this.parsedData.length;
    },
    write: function(buffer) {
        for(var i = 0, l = this.parsedData.length; i < l; i++)buffer.put(this.parsedData[i], 8);
    }
};
function QRCodeModel(typeNumber, errorCorrectLevel) {
    this.typeNumber = typeNumber;
    this.errorCorrectLevel = errorCorrectLevel;
    this.modules = null;
    this.moduleCount = 0;
    this.dataCache = null;
    this.dataList = [];
}
QRCodeModel.prototype = {
    addData: function(data) {
        var newData = new QR8bitByte(data);
        this.dataList.push(newData);
        this.dataCache = null;
    },
    isDark: function(row, col) {
        if (row < 0 || this.moduleCount <= row || col < 0 || this.moduleCount <= col) throw new Error(row + "," + col);
        return this.modules[row][col];
    },
    getModuleCount: function() {
        return this.moduleCount;
    },
    make: function() {
        this.makeImpl(false, this.getBestMaskPattern());
    },
    makeImpl: function(test, maskPattern) {
        this.moduleCount = this.typeNumber * 4 + 17;
        this.modules = new Array(this.moduleCount);
        for(var row = 0; row < this.moduleCount; row++){
            this.modules[row] = new Array(this.moduleCount);
            for(var col = 0; col < this.moduleCount; col++)this.modules[row][col] = null;
        }
        this.setupPositionProbePattern(0, 0);
        this.setupPositionProbePattern(this.moduleCount - 7, 0);
        this.setupPositionProbePattern(0, this.moduleCount - 7);
        this.setupPositionAdjustPattern();
        this.setupTimingPattern();
        this.setupTypeInfo(test, maskPattern);
        if (this.typeNumber >= 7) this.setupTypeNumber(test);
        if (this.dataCache == null) this.dataCache = QRCodeModel.createData(this.typeNumber, this.errorCorrectLevel, this.dataList);
        this.mapData(this.dataCache, maskPattern);
    },
    setupPositionProbePattern: function(row, col) {
        for(var r = -1; r <= 7; r++){
            if (row + r <= -1 || this.moduleCount <= row + r) continue;
            for(var c = -1; c <= 7; c++){
                if (col + c <= -1 || this.moduleCount <= col + c) continue;
                if (0 <= r && r <= 6 && (c == 0 || c == 6) || 0 <= c && c <= 6 && (r == 0 || r == 6) || 2 <= r && r <= 4 && 2 <= c && c <= 4) this.modules[row + r][col + c] = true;
                else this.modules[row + r][col + c] = false;
            }
        }
    },
    getBestMaskPattern: function() {
        var minLostPoint = 0;
        var pattern = 0;
        for(var i = 0; i < 8; i++){
            this.makeImpl(true, i);
            var lostPoint = QRUtil.getLostPoint(this);
            if (i == 0 || minLostPoint > lostPoint) {
                minLostPoint = lostPoint;
                pattern = i;
            }
        }
        return pattern;
    },
    createMovieClip: function(target_mc, instance_name, depth) {
        var qr_mc = target_mc.createEmptyMovieClip(instance_name, depth);
        var cs = 1;
        this.make();
        for(var row = 0; row < this.modules.length; row++){
            var y = row * cs;
            for(var col = 0; col < this.modules[row].length; col++){
                var x = col * cs;
                var dark = this.modules[row][col];
                if (dark) {
                    qr_mc.beginFill(0, 100);
                    qr_mc.moveTo(x, y);
                    qr_mc.lineTo(x + cs, y);
                    qr_mc.lineTo(x + cs, y + cs);
                    qr_mc.lineTo(x, y + cs);
                    qr_mc.endFill();
                }
            }
        }
        return qr_mc;
    },
    setupTimingPattern: function() {
        for(var r = 8; r < this.moduleCount - 8; r++){
            if (this.modules[r][6] != null) continue;
            this.modules[r][6] = r % 2 == 0;
        }
        for(var c = 8; c < this.moduleCount - 8; c++){
            if (this.modules[6][c] != null) continue;
            this.modules[6][c] = c % 2 == 0;
        }
    },
    setupPositionAdjustPattern: function() {
        var pos = QRUtil.getPatternPosition(this.typeNumber);
        for(var i = 0; i < pos.length; i++)for(var j = 0; j < pos.length; j++){
            var row = pos[i];
            var col = pos[j];
            if (this.modules[row][col] != null) continue;
            for(var r = -2; r <= 2; r++){
                for(var c = -2; c <= 2; c++)if (r == -2 || r == 2 || c == -2 || c == 2 || r == 0 && c == 0) this.modules[row + r][col + c] = true;
                else this.modules[row + r][col + c] = false;
            }
        }
    },
    setupTypeNumber: function(test) {
        var bits = QRUtil.getBCHTypeNumber(this.typeNumber);
        for(var i = 0; i < 18; i++){
            var mod = !test && (bits >> i & 1) == 1;
            this.modules[Math.floor(i / 3)][i % 3 + this.moduleCount - 8 - 3] = mod;
        }
        for(var i = 0; i < 18; i++){
            var mod = !test && (bits >> i & 1) == 1;
            this.modules[i % 3 + this.moduleCount - 8 - 3][Math.floor(i / 3)] = mod;
        }
    },
    setupTypeInfo: function(test, maskPattern) {
        var data = this.errorCorrectLevel << 3 | maskPattern;
        var bits = QRUtil.getBCHTypeInfo(data);
        for(var i = 0; i < 15; i++){
            var mod = !test && (bits >> i & 1) == 1;
            if (i < 6) this.modules[i][8] = mod;
            else if (i < 8) this.modules[i + 1][8] = mod;
            else this.modules[this.moduleCount - 15 + i][8] = mod;
        }
        for(var i = 0; i < 15; i++){
            var mod = !test && (bits >> i & 1) == 1;
            if (i < 8) this.modules[8][this.moduleCount - i - 1] = mod;
            else if (i < 9) this.modules[8][15 - i - 1 + 1] = mod;
            else this.modules[8][15 - i - 1] = mod;
        }
        this.modules[this.moduleCount - 8][8] = !test;
    },
    mapData: function(data, maskPattern) {
        var inc = -1;
        var row = this.moduleCount - 1;
        var bitIndex = 7;
        var byteIndex = 0;
        for(var col = this.moduleCount - 1; col > 0; col -= 2){
            if (col == 6) col--;
            while(true){
                for(var c = 0; c < 2; c++)if (this.modules[row][col - c] == null) {
                    var dark = false;
                    if (byteIndex < data.length) dark = (data[byteIndex] >>> bitIndex & 1) == 1;
                    var mask = QRUtil.getMask(maskPattern, row, col - c);
                    if (mask) dark = !dark;
                    this.modules[row][col - c] = dark;
                    bitIndex--;
                    if (bitIndex == -1) {
                        byteIndex++;
                        bitIndex = 7;
                    }
                }
                row += inc;
                if (row < 0 || this.moduleCount <= row) {
                    row -= inc;
                    inc = -inc;
                    break;
                }
            }
        }
    }
};
QRCodeModel.PAD0 = 0xEC;
QRCodeModel.PAD1 = 0x11;
QRCodeModel.createData = function(typeNumber, errorCorrectLevel, dataList) {
    var rsBlocks = QRRSBlock.getRSBlocks(typeNumber, errorCorrectLevel);
    var buffer = new QRBitBuffer();
    for(var i = 0; i < dataList.length; i++){
        var data = dataList[i];
        buffer.put(data.mode, 4);
        buffer.put(data.getLength(), QRUtil.getLengthInBits(data.mode, typeNumber));
        data.write(buffer);
    }
    var totalDataCount = 0;
    for(var i = 0; i < rsBlocks.length; i++)totalDataCount += rsBlocks[i].dataCount;
    if (buffer.getLengthInBits() > totalDataCount * 8) throw new Error("code length overflow. (" + buffer.getLengthInBits() + ">" + totalDataCount * 8 + ")");
    if (buffer.getLengthInBits() + 4 <= totalDataCount * 8) buffer.put(0, 4);
    while(buffer.getLengthInBits() % 8 != 0)buffer.putBit(false);
    while(true){
        if (buffer.getLengthInBits() >= totalDataCount * 8) break;
        buffer.put(QRCodeModel.PAD0, 8);
        if (buffer.getLengthInBits() >= totalDataCount * 8) break;
        buffer.put(QRCodeModel.PAD1, 8);
    }
    return QRCodeModel.createBytes(buffer, rsBlocks);
};
QRCodeModel.createBytes = function(buffer, rsBlocks) {
    var offset = 0;
    var maxDcCount = 0;
    var maxEcCount = 0;
    var dcdata = new Array(rsBlocks.length);
    var ecdata = new Array(rsBlocks.length);
    for(var r = 0; r < rsBlocks.length; r++){
        var dcCount = rsBlocks[r].dataCount;
        var ecCount = rsBlocks[r].totalCount - dcCount;
        maxDcCount = Math.max(maxDcCount, dcCount);
        maxEcCount = Math.max(maxEcCount, ecCount);
        dcdata[r] = new Array(dcCount);
        for(var i = 0; i < dcdata[r].length; i++)dcdata[r][i] = 0xff & buffer.buffer[i + offset];
        offset += dcCount;
        var rsPoly = QRUtil.getErrorCorrectPolynomial(ecCount);
        var rawPoly = new QRPolynomial(dcdata[r], rsPoly.getLength() - 1);
        var modPoly = rawPoly.mod(rsPoly);
        ecdata[r] = new Array(rsPoly.getLength() - 1);
        for(var i = 0; i < ecdata[r].length; i++){
            var modIndex = i + modPoly.getLength() - ecdata[r].length;
            ecdata[r][i] = modIndex >= 0 ? modPoly.get(modIndex) : 0;
        }
    }
    var totalCodeCount = 0;
    for(var i = 0; i < rsBlocks.length; i++)totalCodeCount += rsBlocks[i].totalCount;
    var data = new Array(totalCodeCount);
    var index = 0;
    for(var i = 0; i < maxDcCount; i++){
        for(var r = 0; r < rsBlocks.length; r++)if (i < dcdata[r].length) data[index++] = dcdata[r][i];
    }
    for(var i = 0; i < maxEcCount; i++){
        for(var r = 0; r < rsBlocks.length; r++)if (i < ecdata[r].length) data[index++] = ecdata[r][i];
    }
    return data;
};
var QRMode = {
    MODE_NUMBER: 1,
    MODE_ALPHA_NUM: 2,
    MODE_8BIT_BYTE: 4,
    MODE_KANJI: 8
};
var QRErrorCorrectLevel = {
    L: 1,
    M: 0,
    Q: 3,
    H: 2
};
var QRMaskPattern = {
    PATTERN000: 0,
    PATTERN001: 1,
    PATTERN010: 2,
    PATTERN011: 3,
    PATTERN100: 4,
    PATTERN101: 5,
    PATTERN110: 6,
    PATTERN111: 7
};
var QRUtil = {
    PATTERN_POSITION_TABLE: [
        [],
        [
            6,
            18
        ],
        [
            6,
            22
        ],
        [
            6,
            26
        ],
        [
            6,
            30
        ],
        [
            6,
            34
        ],
        [
            6,
            22,
            38
        ],
        [
            6,
            24,
            42
        ],
        [
            6,
            26,
            46
        ],
        [
            6,
            28,
            50
        ],
        [
            6,
            30,
            54
        ],
        [
            6,
            32,
            58
        ],
        [
            6,
            34,
            62
        ],
        [
            6,
            26,
            46,
            66
        ],
        [
            6,
            26,
            48,
            70
        ],
        [
            6,
            26,
            50,
            74
        ],
        [
            6,
            30,
            54,
            78
        ],
        [
            6,
            30,
            56,
            82
        ],
        [
            6,
            30,
            58,
            86
        ],
        [
            6,
            34,
            62,
            90
        ],
        [
            6,
            28,
            50,
            72,
            94
        ],
        [
            6,
            26,
            50,
            74,
            98
        ],
        [
            6,
            30,
            54,
            78,
            102
        ],
        [
            6,
            28,
            54,
            80,
            106
        ],
        [
            6,
            32,
            58,
            84,
            110
        ],
        [
            6,
            30,
            58,
            86,
            114
        ],
        [
            6,
            34,
            62,
            90,
            118
        ],
        [
            6,
            26,
            50,
            74,
            98,
            122
        ],
        [
            6,
            30,
            54,
            78,
            102,
            126
        ],
        [
            6,
            26,
            52,
            78,
            104,
            130
        ],
        [
            6,
            30,
            56,
            82,
            108,
            134
        ],
        [
            6,
            34,
            60,
            86,
            112,
            138
        ],
        [
            6,
            30,
            58,
            86,
            114,
            142
        ],
        [
            6,
            34,
            62,
            90,
            118,
            146
        ],
        [
            6,
            30,
            54,
            78,
            102,
            126,
            150
        ],
        [
            6,
            24,
            50,
            76,
            102,
            128,
            154
        ],
        [
            6,
            28,
            54,
            80,
            106,
            132,
            158
        ],
        [
            6,
            32,
            58,
            84,
            110,
            136,
            162
        ],
        [
            6,
            26,
            54,
            82,
            110,
            138,
            166
        ],
        [
            6,
            30,
            58,
            86,
            114,
            142,
            170
        ]
    ],
    G15: 1335,
    G18: 7973,
    G15_MASK: 21522,
    getBCHTypeInfo: function(data) {
        var d = data << 10;
        while(QRUtil.getBCHDigit(d) - QRUtil.getBCHDigit(QRUtil.G15) >= 0)d ^= QRUtil.G15 << QRUtil.getBCHDigit(d) - QRUtil.getBCHDigit(QRUtil.G15);
        return (data << 10 | d) ^ QRUtil.G15_MASK;
    },
    getBCHTypeNumber: function(data) {
        var d = data << 12;
        while(QRUtil.getBCHDigit(d) - QRUtil.getBCHDigit(QRUtil.G18) >= 0)d ^= QRUtil.G18 << QRUtil.getBCHDigit(d) - QRUtil.getBCHDigit(QRUtil.G18);
        return data << 12 | d;
    },
    getBCHDigit: function(data) {
        var digit = 0;
        while(data != 0){
            digit++;
            data >>>= 1;
        }
        return digit;
    },
    getPatternPosition: function(typeNumber) {
        return QRUtil.PATTERN_POSITION_TABLE[typeNumber - 1];
    },
    getMask: function(maskPattern, i, j) {
        switch(maskPattern){
            case QRMaskPattern.PATTERN000:
                return (i + j) % 2 == 0;
            case QRMaskPattern.PATTERN001:
                return i % 2 == 0;
            case QRMaskPattern.PATTERN010:
                return j % 3 == 0;
            case QRMaskPattern.PATTERN011:
                return (i + j) % 3 == 0;
            case QRMaskPattern.PATTERN100:
                return (Math.floor(i / 2) + Math.floor(j / 3)) % 2 == 0;
            case QRMaskPattern.PATTERN101:
                return i * j % 2 + i * j % 3 == 0;
            case QRMaskPattern.PATTERN110:
                return (i * j % 2 + i * j % 3) % 2 == 0;
            case QRMaskPattern.PATTERN111:
                return (i * j % 3 + (i + j) % 2) % 2 == 0;
            default:
                throw new Error("bad maskPattern:" + maskPattern);
        }
    },
    getErrorCorrectPolynomial: function(errorCorrectLength) {
        var a = new QRPolynomial([
            1
        ], 0);
        for(var i = 0; i < errorCorrectLength; i++)a = a.multiply(new QRPolynomial([
            1,
            QRMath.gexp(i)
        ], 0));
        return a;
    },
    getLengthInBits: function(mode, type) {
        if (1 <= type && type < 10) switch(mode){
            case QRMode.MODE_NUMBER:
                return 10;
            case QRMode.MODE_ALPHA_NUM:
                return 9;
            case QRMode.MODE_8BIT_BYTE:
                return 8;
            case QRMode.MODE_KANJI:
                return 8;
            default:
                throw new Error("mode:" + mode);
        }
        else if (type < 27) switch(mode){
            case QRMode.MODE_NUMBER:
                return 12;
            case QRMode.MODE_ALPHA_NUM:
                return 11;
            case QRMode.MODE_8BIT_BYTE:
                return 16;
            case QRMode.MODE_KANJI:
                return 10;
            default:
                throw new Error("mode:" + mode);
        }
        else if (type < 41) switch(mode){
            case QRMode.MODE_NUMBER:
                return 14;
            case QRMode.MODE_ALPHA_NUM:
                return 13;
            case QRMode.MODE_8BIT_BYTE:
                return 16;
            case QRMode.MODE_KANJI:
                return 12;
            default:
                throw new Error("mode:" + mode);
        }
        else throw new Error("type:" + type);
    },
    getLostPoint: function(qrCode) {
        var moduleCount = qrCode.getModuleCount();
        var lostPoint = 0;
        for(var row = 0; row < moduleCount; row++)for(var col = 0; col < moduleCount; col++){
            var sameCount = 0;
            var dark = qrCode.isDark(row, col);
            for(var r = -1; r <= 1; r++){
                if (row + r < 0 || moduleCount <= row + r) continue;
                for(var c = -1; c <= 1; c++){
                    if (col + c < 0 || moduleCount <= col + c) continue;
                    if (r == 0 && c == 0) continue;
                    if (dark == qrCode.isDark(row + r, col + c)) sameCount++;
                }
            }
            if (sameCount > 5) lostPoint += 3 + sameCount - 5;
        }
        for(var row = 0; row < moduleCount - 1; row++)for(var col = 0; col < moduleCount - 1; col++){
            var count = 0;
            if (qrCode.isDark(row, col)) count++;
            if (qrCode.isDark(row + 1, col)) count++;
            if (qrCode.isDark(row, col + 1)) count++;
            if (qrCode.isDark(row + 1, col + 1)) count++;
            if (count == 0 || count == 4) lostPoint += 3;
        }
        for(var row = 0; row < moduleCount; row++){
            for(var col = 0; col < moduleCount - 6; col++)if (qrCode.isDark(row, col) && !qrCode.isDark(row, col + 1) && qrCode.isDark(row, col + 2) && qrCode.isDark(row, col + 3) && qrCode.isDark(row, col + 4) && !qrCode.isDark(row, col + 5) && qrCode.isDark(row, col + 6)) lostPoint += 40;
        }
        for(var col = 0; col < moduleCount; col++){
            for(var row = 0; row < moduleCount - 6; row++)if (qrCode.isDark(row, col) && !qrCode.isDark(row + 1, col) && qrCode.isDark(row + 2, col) && qrCode.isDark(row + 3, col) && qrCode.isDark(row + 4, col) && !qrCode.isDark(row + 5, col) && qrCode.isDark(row + 6, col)) lostPoint += 40;
        }
        var darkCount = 0;
        for(var col = 0; col < moduleCount; col++){
            for(var row = 0; row < moduleCount; row++)if (qrCode.isDark(row, col)) darkCount++;
        }
        var ratio = Math.abs(100 * darkCount / moduleCount / moduleCount - 50) / 5;
        lostPoint += ratio * 10;
        return lostPoint;
    }
};
var QRMath = {
    glog: function(n) {
        if (n < 1) throw new Error("glog(" + n + ")");
        return QRMath.LOG_TABLE[n];
    },
    gexp: function(n) {
        while(n < 0)n += 255;
        while(n >= 256)n -= 255;
        return QRMath.EXP_TABLE[n];
    },
    EXP_TABLE: new Array(256),
    LOG_TABLE: new Array(256)
};
for(var i = 0; i < 8; i++)QRMath.EXP_TABLE[i] = 1 << i;
for(var i = 8; i < 256; i++)QRMath.EXP_TABLE[i] = QRMath.EXP_TABLE[i - 4] ^ QRMath.EXP_TABLE[i - 5] ^ QRMath.EXP_TABLE[i - 6] ^ QRMath.EXP_TABLE[i - 8];
for(var i = 0; i < 255; i++)QRMath.LOG_TABLE[QRMath.EXP_TABLE[i]] = i;
function QRPolynomial(num, shift) {
    if (num.length == undefined) throw new Error(num.length + "/" + shift);
    var offset = 0;
    while(offset < num.length && num[offset] == 0)offset++;
    this.num = new Array(num.length - offset + shift);
    for(var i = 0; i < num.length - offset; i++)this.num[i] = num[i + offset];
}
QRPolynomial.prototype = {
    get: function(index) {
        return this.num[index];
    },
    getLength: function() {
        return this.num.length;
    },
    multiply: function(e) {
        var num = new Array(this.getLength() + e.getLength() - 1);
        for(var i = 0; i < this.getLength(); i++)for(var j = 0; j < e.getLength(); j++)num[i + j] ^= QRMath.gexp(QRMath.glog(this.get(i)) + QRMath.glog(e.get(j)));
        return new QRPolynomial(num, 0);
    },
    mod: function(e) {
        if (this.getLength() - e.getLength() < 0) return this;
        var ratio = QRMath.glog(this.get(0)) - QRMath.glog(e.get(0));
        var num = new Array(this.getLength());
        for(var i = 0; i < this.getLength(); i++)num[i] = this.get(i);
        for(var i = 0; i < e.getLength(); i++)num[i] ^= QRMath.gexp(QRMath.glog(e.get(i)) + ratio);
        return new QRPolynomial(num, 0).mod(e);
    }
};
function QRRSBlock(totalCount, dataCount) {
    this.totalCount = totalCount;
    this.dataCount = dataCount;
}
QRRSBlock.RS_BLOCK_TABLE = [
    [
        1,
        26,
        19
    ],
    [
        1,
        26,
        16
    ],
    [
        1,
        26,
        13
    ],
    [
        1,
        26,
        9
    ],
    [
        1,
        44,
        34
    ],
    [
        1,
        44,
        28
    ],
    [
        1,
        44,
        22
    ],
    [
        1,
        44,
        16
    ],
    [
        1,
        70,
        55
    ],
    [
        1,
        70,
        44
    ],
    [
        2,
        35,
        17
    ],
    [
        2,
        35,
        13
    ],
    [
        1,
        100,
        80
    ],
    [
        2,
        50,
        32
    ],
    [
        2,
        50,
        24
    ],
    [
        4,
        25,
        9
    ],
    [
        1,
        134,
        108
    ],
    [
        2,
        67,
        43
    ],
    [
        2,
        33,
        15,
        2,
        34,
        16
    ],
    [
        2,
        33,
        11,
        2,
        34,
        12
    ],
    [
        2,
        86,
        68
    ],
    [
        4,
        43,
        27
    ],
    [
        4,
        43,
        19
    ],
    [
        4,
        43,
        15
    ],
    [
        2,
        98,
        78
    ],
    [
        4,
        49,
        31
    ],
    [
        2,
        32,
        14,
        4,
        33,
        15
    ],
    [
        4,
        39,
        13,
        1,
        40,
        14
    ],
    [
        2,
        121,
        97
    ],
    [
        2,
        60,
        38,
        2,
        61,
        39
    ],
    [
        4,
        40,
        18,
        2,
        41,
        19
    ],
    [
        4,
        40,
        14,
        2,
        41,
        15
    ],
    [
        2,
        146,
        116
    ],
    [
        3,
        58,
        36,
        2,
        59,
        37
    ],
    [
        4,
        36,
        16,
        4,
        37,
        17
    ],
    [
        4,
        36,
        12,
        4,
        37,
        13
    ],
    [
        2,
        86,
        68,
        2,
        87,
        69
    ],
    [
        4,
        69,
        43,
        1,
        70,
        44
    ],
    [
        6,
        43,
        19,
        2,
        44,
        20
    ],
    [
        6,
        43,
        15,
        2,
        44,
        16
    ],
    [
        4,
        101,
        81
    ],
    [
        1,
        80,
        50,
        4,
        81,
        51
    ],
    [
        4,
        50,
        22,
        4,
        51,
        23
    ],
    [
        3,
        36,
        12,
        8,
        37,
        13
    ],
    [
        2,
        116,
        92,
        2,
        117,
        93
    ],
    [
        6,
        58,
        36,
        2,
        59,
        37
    ],
    [
        4,
        46,
        20,
        6,
        47,
        21
    ],
    [
        7,
        42,
        14,
        4,
        43,
        15
    ],
    [
        4,
        133,
        107
    ],
    [
        8,
        59,
        37,
        1,
        60,
        38
    ],
    [
        8,
        44,
        20,
        4,
        45,
        21
    ],
    [
        12,
        33,
        11,
        4,
        34,
        12
    ],
    [
        3,
        145,
        115,
        1,
        146,
        116
    ],
    [
        4,
        64,
        40,
        5,
        65,
        41
    ],
    [
        11,
        36,
        16,
        5,
        37,
        17
    ],
    [
        11,
        36,
        12,
        5,
        37,
        13
    ],
    [
        5,
        109,
        87,
        1,
        110,
        88
    ],
    [
        5,
        65,
        41,
        5,
        66,
        42
    ],
    [
        5,
        54,
        24,
        7,
        55,
        25
    ],
    [
        11,
        36,
        12
    ],
    [
        5,
        122,
        98,
        1,
        123,
        99
    ],
    [
        7,
        73,
        45,
        3,
        74,
        46
    ],
    [
        15,
        43,
        19,
        2,
        44,
        20
    ],
    [
        3,
        45,
        15,
        13,
        46,
        16
    ],
    [
        1,
        135,
        107,
        5,
        136,
        108
    ],
    [
        10,
        74,
        46,
        1,
        75,
        47
    ],
    [
        1,
        50,
        22,
        15,
        51,
        23
    ],
    [
        2,
        42,
        14,
        17,
        43,
        15
    ],
    [
        5,
        150,
        120,
        1,
        151,
        121
    ],
    [
        9,
        69,
        43,
        4,
        70,
        44
    ],
    [
        17,
        50,
        22,
        1,
        51,
        23
    ],
    [
        2,
        42,
        14,
        19,
        43,
        15
    ],
    [
        3,
        141,
        113,
        4,
        142,
        114
    ],
    [
        3,
        70,
        44,
        11,
        71,
        45
    ],
    [
        17,
        47,
        21,
        4,
        48,
        22
    ],
    [
        9,
        39,
        13,
        16,
        40,
        14
    ],
    [
        3,
        135,
        107,
        5,
        136,
        108
    ],
    [
        3,
        67,
        41,
        13,
        68,
        42
    ],
    [
        15,
        54,
        24,
        5,
        55,
        25
    ],
    [
        15,
        43,
        15,
        10,
        44,
        16
    ],
    [
        4,
        144,
        116,
        4,
        145,
        117
    ],
    [
        17,
        68,
        42
    ],
    [
        17,
        50,
        22,
        6,
        51,
        23
    ],
    [
        19,
        46,
        16,
        6,
        47,
        17
    ],
    [
        2,
        139,
        111,
        7,
        140,
        112
    ],
    [
        17,
        74,
        46
    ],
    [
        7,
        54,
        24,
        16,
        55,
        25
    ],
    [
        34,
        37,
        13
    ],
    [
        4,
        151,
        121,
        5,
        152,
        122
    ],
    [
        4,
        75,
        47,
        14,
        76,
        48
    ],
    [
        11,
        54,
        24,
        14,
        55,
        25
    ],
    [
        16,
        45,
        15,
        14,
        46,
        16
    ],
    [
        6,
        147,
        117,
        4,
        148,
        118
    ],
    [
        6,
        73,
        45,
        14,
        74,
        46
    ],
    [
        11,
        54,
        24,
        16,
        55,
        25
    ],
    [
        30,
        46,
        16,
        2,
        47,
        17
    ],
    [
        8,
        132,
        106,
        4,
        133,
        107
    ],
    [
        8,
        75,
        47,
        13,
        76,
        48
    ],
    [
        7,
        54,
        24,
        22,
        55,
        25
    ],
    [
        22,
        45,
        15,
        13,
        46,
        16
    ],
    [
        10,
        142,
        114,
        2,
        143,
        115
    ],
    [
        19,
        74,
        46,
        4,
        75,
        47
    ],
    [
        28,
        50,
        22,
        6,
        51,
        23
    ],
    [
        33,
        46,
        16,
        4,
        47,
        17
    ],
    [
        8,
        152,
        122,
        4,
        153,
        123
    ],
    [
        22,
        73,
        45,
        3,
        74,
        46
    ],
    [
        8,
        53,
        23,
        26,
        54,
        24
    ],
    [
        12,
        45,
        15,
        28,
        46,
        16
    ],
    [
        3,
        147,
        117,
        10,
        148,
        118
    ],
    [
        3,
        73,
        45,
        23,
        74,
        46
    ],
    [
        4,
        54,
        24,
        31,
        55,
        25
    ],
    [
        11,
        45,
        15,
        31,
        46,
        16
    ],
    [
        7,
        146,
        116,
        7,
        147,
        117
    ],
    [
        21,
        73,
        45,
        7,
        74,
        46
    ],
    [
        1,
        53,
        23,
        37,
        54,
        24
    ],
    [
        19,
        45,
        15,
        26,
        46,
        16
    ],
    [
        5,
        145,
        115,
        10,
        146,
        116
    ],
    [
        19,
        75,
        47,
        10,
        76,
        48
    ],
    [
        15,
        54,
        24,
        25,
        55,
        25
    ],
    [
        23,
        45,
        15,
        25,
        46,
        16
    ],
    [
        13,
        145,
        115,
        3,
        146,
        116
    ],
    [
        2,
        74,
        46,
        29,
        75,
        47
    ],
    [
        42,
        54,
        24,
        1,
        55,
        25
    ],
    [
        23,
        45,
        15,
        28,
        46,
        16
    ],
    [
        17,
        145,
        115
    ],
    [
        10,
        74,
        46,
        23,
        75,
        47
    ],
    [
        10,
        54,
        24,
        35,
        55,
        25
    ],
    [
        19,
        45,
        15,
        35,
        46,
        16
    ],
    [
        17,
        145,
        115,
        1,
        146,
        116
    ],
    [
        14,
        74,
        46,
        21,
        75,
        47
    ],
    [
        29,
        54,
        24,
        19,
        55,
        25
    ],
    [
        11,
        45,
        15,
        46,
        46,
        16
    ],
    [
        13,
        145,
        115,
        6,
        146,
        116
    ],
    [
        14,
        74,
        46,
        23,
        75,
        47
    ],
    [
        44,
        54,
        24,
        7,
        55,
        25
    ],
    [
        59,
        46,
        16,
        1,
        47,
        17
    ],
    [
        12,
        151,
        121,
        7,
        152,
        122
    ],
    [
        12,
        75,
        47,
        26,
        76,
        48
    ],
    [
        39,
        54,
        24,
        14,
        55,
        25
    ],
    [
        22,
        45,
        15,
        41,
        46,
        16
    ],
    [
        6,
        151,
        121,
        14,
        152,
        122
    ],
    [
        6,
        75,
        47,
        34,
        76,
        48
    ],
    [
        46,
        54,
        24,
        10,
        55,
        25
    ],
    [
        2,
        45,
        15,
        64,
        46,
        16
    ],
    [
        17,
        152,
        122,
        4,
        153,
        123
    ],
    [
        29,
        74,
        46,
        14,
        75,
        47
    ],
    [
        49,
        54,
        24,
        10,
        55,
        25
    ],
    [
        24,
        45,
        15,
        46,
        46,
        16
    ],
    [
        4,
        152,
        122,
        18,
        153,
        123
    ],
    [
        13,
        74,
        46,
        32,
        75,
        47
    ],
    [
        48,
        54,
        24,
        14,
        55,
        25
    ],
    [
        42,
        45,
        15,
        32,
        46,
        16
    ],
    [
        20,
        147,
        117,
        4,
        148,
        118
    ],
    [
        40,
        75,
        47,
        7,
        76,
        48
    ],
    [
        43,
        54,
        24,
        22,
        55,
        25
    ],
    [
        10,
        45,
        15,
        67,
        46,
        16
    ],
    [
        19,
        148,
        118,
        6,
        149,
        119
    ],
    [
        18,
        75,
        47,
        31,
        76,
        48
    ],
    [
        34,
        54,
        24,
        34,
        55,
        25
    ],
    [
        20,
        45,
        15,
        61,
        46,
        16
    ]
];
QRRSBlock.getRSBlocks = function(typeNumber, errorCorrectLevel) {
    var rsBlock = QRRSBlock.getRsBlockTable(typeNumber, errorCorrectLevel);
    if (rsBlock == undefined) throw new Error("bad rs block @ typeNumber:" + typeNumber + "/errorCorrectLevel:" + errorCorrectLevel);
    var length = rsBlock.length / 3;
    var list = [];
    for(var i = 0; i < length; i++){
        var count = rsBlock[i * 3 + 0];
        var totalCount = rsBlock[i * 3 + 1];
        var dataCount = rsBlock[i * 3 + 2];
        for(var j = 0; j < count; j++)list.push(new QRRSBlock(totalCount, dataCount));
    }
    return list;
};
QRRSBlock.getRsBlockTable = function(typeNumber, errorCorrectLevel) {
    switch(errorCorrectLevel){
        case QRErrorCorrectLevel.L:
            return QRRSBlock.RS_BLOCK_TABLE[(typeNumber - 1) * 4 + 0];
        case QRErrorCorrectLevel.M:
            return QRRSBlock.RS_BLOCK_TABLE[(typeNumber - 1) * 4 + 1];
        case QRErrorCorrectLevel.Q:
            return QRRSBlock.RS_BLOCK_TABLE[(typeNumber - 1) * 4 + 2];
        case QRErrorCorrectLevel.H:
            return QRRSBlock.RS_BLOCK_TABLE[(typeNumber - 1) * 4 + 3];
        default:
            return undefined;
    }
};
function QRBitBuffer() {
    this.buffer = [];
    this.length = 0;
}
QRBitBuffer.prototype = {
    get: function(index) {
        var bufIndex = Math.floor(index / 8);
        return (this.buffer[bufIndex] >>> 7 - index % 8 & 1) == 1;
    },
    put: function(num, length) {
        for(var i = 0; i < length; i++)this.putBit((num >>> length - i - 1 & 1) == 1);
    },
    getLengthInBits: function() {
        return this.length;
    },
    putBit: function(bit) {
        var bufIndex = Math.floor(this.length / 8);
        if (this.buffer.length <= bufIndex) this.buffer.push(0);
        if (bit) this.buffer[bufIndex] |= 0x80 >>> this.length % 8;
        this.length++;
    }
};
var QRCodeLimitLength = [
    [
        17,
        14,
        11,
        7
    ],
    [
        32,
        26,
        20,
        14
    ],
    [
        53,
        42,
        32,
        24
    ],
    [
        78,
        62,
        46,
        34
    ],
    [
        106,
        84,
        60,
        44
    ],
    [
        134,
        106,
        74,
        58
    ],
    [
        154,
        122,
        86,
        64
    ],
    [
        192,
        152,
        108,
        84
    ],
    [
        230,
        180,
        130,
        98
    ],
    [
        271,
        213,
        151,
        119
    ],
    [
        321,
        251,
        177,
        137
    ],
    [
        367,
        287,
        203,
        155
    ],
    [
        425,
        331,
        241,
        177
    ],
    [
        458,
        362,
        258,
        194
    ],
    [
        520,
        412,
        292,
        220
    ],
    [
        586,
        450,
        322,
        250
    ],
    [
        644,
        504,
        364,
        280
    ],
    [
        718,
        560,
        394,
        310
    ],
    [
        792,
        624,
        442,
        338
    ],
    [
        858,
        666,
        482,
        382
    ],
    [
        929,
        711,
        509,
        403
    ],
    [
        1003,
        779,
        565,
        439
    ],
    [
        1091,
        857,
        611,
        461
    ],
    [
        1171,
        911,
        661,
        511
    ],
    [
        1273,
        997,
        715,
        535
    ],
    [
        1367,
        1059,
        751,
        593
    ],
    [
        1465,
        1125,
        805,
        625
    ],
    [
        1528,
        1190,
        868,
        658
    ],
    [
        1628,
        1264,
        908,
        698
    ],
    [
        1732,
        1370,
        982,
        742
    ],
    [
        1840,
        1452,
        1030,
        790
    ],
    [
        1952,
        1538,
        1112,
        842
    ],
    [
        2068,
        1628,
        1168,
        898
    ],
    [
        2188,
        1722,
        1228,
        958
    ],
    [
        2303,
        1809,
        1283,
        983
    ],
    [
        2431,
        1911,
        1351,
        1051
    ],
    [
        2563,
        1989,
        1423,
        1093
    ],
    [
        2699,
        2099,
        1499,
        1139
    ],
    [
        2809,
        2213,
        1579,
        1219
    ],
    [
        2953,
        2331,
        1663,
        1273
    ]
];
/** Constructor */ function QRCode(options) {
    var instance = this;
    //Default options
    this.options = {
        padding: 4,
        width: 256,
        height: 256,
        typeNumber: 4,
        color: "#000000",
        background: "#ffffff",
        ecl: "M",
        image: {
            svg: "",
            width: 0,
            height: 0
        }
    };
    //In case the options is string
    if (typeof options === "string") options = {
        content: options
    };
    //Merge options
    if (options) for(var i in options)this.options[i] = options[i];
    if (typeof this.options.content !== "string") throw new Error("Expected 'content' as string!");
    if (this.options.content.length === 0 /* || this.options.content.length > 7089 */ ) throw new Error("Expected 'content' to be non-empty!");
    if (!(this.options.padding >= 0)) throw new Error("Expected 'padding' value to be non-negative!");
    if (!(this.options.width > 0) || !(this.options.height > 0)) throw new Error("Expected 'width' or 'height' value to be higher than zero!");
    //Gets the error correction level
    function _getErrorCorrectLevel(ecl) {
        switch(ecl){
            case "L":
                return QRErrorCorrectLevel.L;
            case "M":
                return QRErrorCorrectLevel.M;
            case "Q":
                return QRErrorCorrectLevel.Q;
            case "H":
                return QRErrorCorrectLevel.H;
            default:
                throw new Error("Unknwon error correction level: " + ecl);
        }
    }
    //Get type number
    function _getTypeNumber(content, ecl) {
        var length = _getUTF8Length(content);
        var type = 1;
        var limit = 0;
        for(var i = 0, len = QRCodeLimitLength.length; i <= len; i++){
            var table = QRCodeLimitLength[i];
            if (!table) throw new Error("Content too long: expected " + limit + " but got " + length);
            switch(ecl){
                case "L":
                    limit = table[0];
                    break;
                case "M":
                    limit = table[1];
                    break;
                case "Q":
                    limit = table[2];
                    break;
                case "H":
                    limit = table[3];
                    break;
                default:
                    throw new Error("Unknwon error correction level: " + ecl);
            }
            if (length <= limit) break;
            type++;
        }
        if (type > QRCodeLimitLength.length) throw new Error("Content too long");
        return type;
    }
    //Gets text length
    function _getUTF8Length(content) {
        var result = encodeURI(content).toString().replace(/\%[0-9a-fA-F]{2}/g, "a");
        return result.length + (result.length != content ? 3 : 0);
    }
    //Generate QR Code matrix
    var content = this.options.content;
    var type = _getTypeNumber(content, this.options.ecl);
    var ecl = _getErrorCorrectLevel(this.options.ecl);
    this.qrcode = new QRCodeModel(type, ecl);
    this.qrcode.addData(content);
    this.qrcode.make();
}
/** Generates QR Code as SVG image */ QRCode.prototype.svg = function(opt) {
    var options = this.options || {};
    var modules = this.qrcode.modules;
    if (typeof opt == "undefined") opt = {
        container: options.container || "svg"
    };
    //Apply new lines and indents in SVG?
    var pretty = typeof options.pretty != "undefined" ? !!options.pretty : true;
    var indent = pretty ? "  " : "";
    var EOL = pretty ? "\r\n" : "";
    var width = options.width;
    var height = options.height;
    var length = modules.length;
    var xsize = width / (length + 2 * options.padding);
    var ysize = height / (length + 2 * options.padding);
    //Join (union, merge) rectangles into one shape?
    var join = typeof options.join != "undefined" ? !!options.join : false;
    //Swap the X and Y modules, pull request #2
    var swap = typeof options.swap != "undefined" ? !!options.swap : false;
    //Apply <?xml...?> declaration in SVG?
    var xmlDeclaration = typeof options.xmlDeclaration != "undefined" ? !!options.xmlDeclaration : true;
    //Populate with predefined shape instead of "rect" elements, thanks to @kkocdko
    var predefined = typeof options.predefined != "undefined" ? !!options.predefined : false;
    var defs = predefined ? indent + '<defs><path id="qrmodule" d="M0 0 h' + ysize + " v" + xsize + ' H0 z" style="fill:' + options.color + ';shape-rendering:crispEdges;" /></defs>' + EOL : "";
    //Background rectangle
    var bgrect = indent + '<rect x="0" y="0" width="' + width + '" height="' + height + '" style="fill:' + options.background + ';shape-rendering:crispEdges;"/>' + EOL;
    //Rectangles representing modules
    var modrect = "";
    var pathdata = "";
    for(var y = 0; y < length; y++)for(var x = 0; x < length; x++){
        var module1 = modules[x][y];
        if (module1) {
            var px = x * xsize + options.padding * xsize;
            var py = y * ysize + options.padding * ysize;
            //Some users have had issues with the QR Code, thanks to @danioso for the solution
            if (swap) {
                var t = px;
                px = py;
                py = t;
            }
            if (join) {
                //Module as a part of svg path data, thanks to @danioso
                var w = xsize + px;
                var h = ysize + py;
                px = Number.isInteger(px) ? Number(px) : px.toFixed(2);
                py = Number.isInteger(py) ? Number(py) : py.toFixed(2);
                w = Number.isInteger(w) ? Number(w) : w.toFixed(2);
                h = Number.isInteger(h) ? Number(h) : h.toFixed(2);
                pathdata += "M" + px + "," + py + " V" + h + " H" + w + " V" + py + " H" + px + " Z ";
            } else if (predefined) //Module as a predefined shape, thanks to @kkocdko
            modrect += indent + '<use x="' + px.toString() + '" y="' + py.toString() + '" href="#qrmodule" />' + EOL;
            else //Module as rectangle element
            modrect += indent + '<rect x="' + px.toString() + '" y="' + py.toString() + '" width="' + xsize + '" height="' + ysize + '" style="fill:' + options.color + ';shape-rendering:crispEdges;"/>' + EOL;
        }
    }
    if (join) modrect = indent + '<path x="0" y="0" style="fill:' + options.color + ';shape-rendering:crispEdges;" d="' + pathdata + '" />';
    let imgSvg = "";
    if (this.options.image !== undefined && this.options.image.svg) {
        const imgWidth = width * this.options.image.width / 100;
        const imgHeight = height * this.options.image.height / 100;
        const imgX = width / 2 - imgWidth / 2;
        const imgY = height / 2 - imgHeight / 2;
        imgSvg += `<svg x="${imgX}" y="${imgY}" width="${imgWidth}" height="${imgHeight}" viewBox="0 0 100 100" preserveAspectRatio="xMinYMin meet">`;
        imgSvg += this.options.image.svg + EOL;
        imgSvg += "</svg>";
    }
    var svg = "";
    switch(opt.container){
        //Wrapped in SVG document
        case "svg":
            if (xmlDeclaration) svg += '<?xml version="1.0" standalone="yes"?>' + EOL;
            svg += '<svg xmlns="http://www.w3.org/2000/svg" version="1.1" width="' + width + '" height="' + height + '">' + EOL;
            svg += defs + bgrect + modrect;
            svg += imgSvg;
            svg += "</svg>";
            break;
        //Viewbox for responsive use in a browser, thanks to @danioso
        case "svg-viewbox":
            if (xmlDeclaration) svg += '<?xml version="1.0" standalone="yes"?>' + EOL;
            svg += '<svg xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 ' + width + " " + height + '">' + EOL;
            svg += defs + bgrect + modrect;
            svg += imgSvg;
            svg += "</svg>";
            break;
        //Wrapped in group element
        case "g":
            svg += '<g width="' + width + '" height="' + height + '">' + EOL;
            svg += defs + bgrect + modrect;
            svg += imgSvg;
            svg += "</g>";
            break;
        //Without a container
        default:
            svg += (defs + bgrect + modrect + imgSvg).replace(/^\s+/, ""); //Clear indents on each line
            break;
    }
    return svg;
};
module.exports = QRCode;

},{}],"ceD7a":[function(require,module,exports) {
"use strict";
// Copyright (c) 2018-2020 WalletLink.org <https://www.walletlink.org/>
// Copyright (c) 2018-2020 Coinbase, Inc. <https://www.coinbase.com/>
// Licensed under the Apache License, version 2.0
var __importDefault = this && this.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Spinner = void 0;
const preact_1 = require("e9e3f53ee4615a24");
const Spinner_css_1 = __importDefault(require("e5cabbb67da175bf"));
const Spinner = (props)=>{
    var _a;
    const size = (_a = props.size) !== null && _a !== void 0 ? _a : 64;
    const color = props.color || "#000";
    return (0, preact_1.h)("div", {
        class: "-walletlink-spinner"
    }, (0, preact_1.h)("style", null, Spinner_css_1.default), (0, preact_1.h)("svg", {
        viewBox: "0 0 100 100",
        xmlns: "http://www.w3.org/2000/svg",
        style: {
            width: size,
            height: size
        }
    }, (0, preact_1.h)("circle", {
        style: {
            cx: 50,
            cy: 50,
            r: 45,
            stroke: color
        }
    })));
};
exports.Spinner = Spinner;

},{"e9e3f53ee4615a24":"213JP","e5cabbb67da175bf":"lNH3B"}],"lNH3B":[function(require,module,exports) {
"use strict";
// Copyright (c) 2018-2021 WalletLink.org <https://www.walletlink.org/>
// Copyright (c) 2018-2021 Coinbase, Inc. <https://www.coinbase.com/>
// Licensed under the Apache License, version 2.0
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = `.-walletlink-css-reset .-walletlink-spinner{display:inline-block}.-walletlink-css-reset .-walletlink-spinner svg{display:inline-block;animation:2s linear infinite -walletlink-spinner-svg}.-walletlink-css-reset .-walletlink-spinner svg circle{animation:1.9s ease-in-out infinite both -walletlink-spinner-circle;display:block;fill:transparent;stroke-dasharray:283;stroke-dashoffset:280;stroke-linecap:round;stroke-width:10px;transform-origin:50% 50%}@keyframes -walletlink-spinner-svg{0%{transform:rotateZ(0deg)}100%{transform:rotateZ(360deg)}}@keyframes -walletlink-spinner-circle{0%,25%{stroke-dashoffset:280;transform:rotate(0)}50%,75%{stroke-dashoffset:75;transform:rotate(45deg)}100%{stroke-dashoffset:280;transform:rotate(360deg)}}`;

},{}],"a0bQk":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.LIB_VERSION = void 0;
exports.LIB_VERSION = "2.5.0";

},{}],"haWDe":[function(require,module,exports) {
"use strict";
var __importDefault = this && this.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.TryExtensionLinkDialog = void 0;
const clsx_1 = __importDefault(require("b3f44f2e2a29eef0"));
const preact_1 = require("620b8ca6b4de3151");
const hooks_1 = require("48fa797160918909");
const globe_icon_svg_1 = __importDefault(require("3f80eea60349e78c"));
const link_icon_svg_1 = __importDefault(require("fc44d7e1cdd02c72"));
const lock_icon_svg_1 = __importDefault(require("14801412fb14a501"));
const QRLogo_1 = __importDefault(require("dfc7c1a5feadc430"));
const QRCode_1 = require("bbe0205445a2fed0");
const Spinner_1 = require("cb3c8c4824738c2e");
const TryExtensionLinkDialog_css_1 = __importDefault(require("ac8d2fa9aa732720"));
const version_1 = require("b231e014a491ce32");
const TryExtensionLinkDialog = (props)=>{
    const [isContainerHidden, setContainerHidden] = (0, hooks_1.useState)(!props.isOpen);
    const [isDialogHidden, setDialogHidden] = (0, hooks_1.useState)(!props.isOpen);
    (0, hooks_1.useEffect)(()=>{
        const { isOpen } = props;
        const timers = [
            window.setTimeout(()=>{
                setDialogHidden(!isOpen);
            }, 10)
        ];
        if (isOpen) setContainerHidden(false);
        else timers.push(window.setTimeout(()=>{
            setContainerHidden(true);
        }, 360));
        return ()=>{
            timers.forEach(window.clearTimeout);
        };
    }, [
        props.isOpen
    ]);
    return (0, preact_1.h)("div", {
        class: (0, clsx_1.default)("-walletlink-extension-dialog-container", isContainerHidden && "-walletlink-extension-dialog-container-hidden")
    }, (0, preact_1.h)("style", null, TryExtensionLinkDialog_css_1.default), (0, preact_1.h)("div", {
        class: (0, clsx_1.default)("-walletlink-extension-dialog-backdrop", isDialogHidden && "-walletlink-extension-dialog-backdrop-hidden")
    }), (0, preact_1.h)("div", {
        class: "-walletlink-extension-dialog"
    }, (0, preact_1.h)("div", {
        class: (0, clsx_1.default)("-walletlink-extension-dialog-box", isDialogHidden && "-walletlink-extension-dialog-box-hidden")
    }, (0, preact_1.h)(TryExtensionBox, {
        onInstallClick: ()=>{
            window.open("https://api.wallet.coinbase.com/rpc/v2/desktop/chrome", "_blank");
        }
    }), !props.connectDisabled ? (0, preact_1.h)(ScanQRBox, {
        darkMode: props.darkMode,
        version: props.version,
        sessionId: props.sessionId,
        sessionSecret: props.sessionSecret,
        walletLinkUrl: props.walletLinkUrl,
        isConnected: props.isConnected,
        isParentConnection: props.isParentConnection
    }) : null, props.onCancel && (0, preact_1.h)(CancelButton, {
        onClick: props.onCancel
    }))));
};
exports.TryExtensionLinkDialog = TryExtensionLinkDialog;
const TryExtensionBox = (props)=>{
    return (0, preact_1.h)("div", {
        class: "-walletlink-extension-dialog-box-top"
    }, (0, preact_1.h)("div", {
        class: "-walletlink-extension-dialog-box-top-install-region"
    }, (0, preact_1.h)("h2", null, "Try the Coinbase Wallet extension"), (0, preact_1.h)("button", {
        onClick: props.onInstallClick
    }, "Install")), (0, preact_1.h)("div", {
        class: "-walletlink-extension-dialog-box-top-info-region"
    }, (0, preact_1.h)(DescriptionItem, {
        icon: link_icon_svg_1.default,
        text: "Connect to crypto apps with one click"
    }), (0, preact_1.h)(DescriptionItem, {
        icon: lock_icon_svg_1.default,
        text: "Your private key is stored securely"
    }), (0, preact_1.h)(DescriptionItem, {
        icon: globe_icon_svg_1.default,
        text: "Works with Ethereum, Polygon, and more"
    })));
};
const ScanQRBox = (props)=>{
    const serverUrl = window.encodeURIComponent(props.walletLinkUrl);
    const sessionIdKey = props.isParentConnection ? "parent-id" : "id";
    const qrUrl = `${props.walletLinkUrl}/#/link?${sessionIdKey}=${props.sessionId}&secret=${props.sessionSecret}&server=${serverUrl}&v=1`;
    return (0, preact_1.h)("div", {
        class: "-walletlink-extension-dialog-box-bottom"
    }, (0, preact_1.h)("div", {
        class: "-walletlink-extension-dialog-box-bottom-description-region"
    }, (0, preact_1.h)("h2", null, "Or scan to connect"), (0, preact_1.h)("body", {
        class: "-walletlink-extension-dialog-box-bottom-description"
    }, "Open ", (0, preact_1.h)("a", {
        href: "https://wallet.coinbase.com/"
    }, "Coinbase Wallet"), " on your mobile phone and scan")), (0, preact_1.h)("div", {
        class: "-walletlink-extension-dialog-box-bottom-qr-region"
    }, (0, preact_1.h)("div", {
        class: "-walletlink-extension-dialog-box-bottom-qr-wrapper"
    }, (0, preact_1.h)(QRCode_1.QRCode, {
        content: qrUrl,
        width: 150,
        height: 150,
        fgColor: "#000",
        bgColor: "transparent",
        image: {
            svg: QRLogo_1.default,
            width: 34,
            height: 34
        }
    })), (0, preact_1.h)("input", {
        type: "hidden",
        name: "walletlink-version",
        value: version_1.LIB_VERSION
    }), (0, preact_1.h)("input", {
        type: "hidden",
        value: qrUrl
    }), !props.isConnected && (0, preact_1.h)("div", {
        class: "-walletlink-extension-dialog-box-bottom-qr-connecting"
    }, (0, preact_1.h)(Spinner_1.Spinner, {
        size: 36,
        color: "#000"
    }), (0, preact_1.h)("p", null, "Connecting..."))));
};
const DescriptionItem = (props)=>{
    return (0, preact_1.h)("div", {
        class: "-walletlink-extension-dialog-box-top-description"
    }, (0, preact_1.h)("div", {
        class: "-walletlink-extension-dialog-box-top-description-icon-wrapper"
    }, (0, preact_1.h)("img", {
        src: props.icon
    })), (0, preact_1.h)("body", {
        class: "-walletlink-extension-dialog-box-top-description-text"
    }, props.text));
};
const CancelButton = (props)=>(0, preact_1.h)("button", {
        class: "-walletlink-extension-dialog-box-cancel",
        onClick: props.onClick
    }, (0, preact_1.h)("div", {
        class: "-walletlink-extension-dialog-box-cancel-x"
    }));

},{"b3f44f2e2a29eef0":"7UQcB","620b8ca6b4de3151":"213JP","48fa797160918909":"MIejN","3f80eea60349e78c":"7nrBn","fc44d7e1cdd02c72":"dvJEY","14801412fb14a501":"8A5Lm","dfc7c1a5feadc430":"f7mDS","bbe0205445a2fed0":"fLwXv","cb3c8c4824738c2e":"ceD7a","ac8d2fa9aa732720":"7CVGm","b231e014a491ce32":"a0bQk"}],"7nrBn":[function(require,module,exports) {
"use strict";
// Copyright (c) 2018-2021 WalletLink.org <https://www.walletlink.org/>
// Copyright (c) 2018-2021 Coinbase, Inc. <https://www.coinbase.com/>
// Licensed under the Apache License, version 2.0
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = `data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTggMEMzLjU4IDAgMCAzLjU4IDAgOHMzLjU4IDggOCA4IDgtMy41OCA4LTgtMy41OC04LTgtOFptNS45MSA3aC0xLjk0Yy0uMS0xLjU3LS40Mi0zLS45MS00LjE1IDEuNDguODggMi41NSAyLjM4IDIuODUgNC4xNVpNOCAxNGMtLjQ1IDAtMS43Mi0xLjc3LTEuOTUtNWgzLjljLS4yMyAzLjIzLTEuNSA1LTEuOTUgNVpNNi4wNSA3QzYuMjggMy43NyA3LjU1IDIgOCAyYy40NSAwIDEuNzIgMS43NyAxLjk1IDVoLTMuOVpNNC45NCAyLjg1QzQuNDYgNCA0LjEzIDUuNDMgNC4wMyA3SDIuMDljLjMtMS43NyAxLjM3LTMuMjcgMi44NS00LjE1Wk0yLjA5IDloMS45NGMuMSAxLjU3LjQyIDMgLjkxIDQuMTVBNS45OTggNS45OTggMCAwIDEgMi4wOSA5Wm04Ljk3IDQuMTVjLjQ4LTEuMTUuODEtMi41OC45MS00LjE1aDEuOTRhNS45OTggNS45OTggMCAwIDEtMi44NSA0LjE1WiIgZmlsbD0iIzE2NTJGMCIvPjwvc3ZnPg==`;

},{}],"dvJEY":[function(require,module,exports) {
"use strict";
// Copyright (c) 2018-2021 WalletLink.org <https://www.walletlink.org/>
// Copyright (c) 2018-2021 Coinbase, Inc. <https://www.coinbase.com/>
// Licensed under the Apache License, version 2.0
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = `data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTciIGhlaWdodD0iMTciIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTE1LjYzNSAyLjExN2EzLjg4OSAzLjg4OSAwIDAgMC01LjUyMSAwTDYuODkgNS4zMzVBMy44OTQgMy44OTQgMCAwIDAgNS44IDguNzM5Yy4wODMuNTA2LjI2OCAxLjAxMS41NTMgMS40NjYuMTUxLjI1My4zMzYuNDcyLjUzNy42OTFsLjYyMS42MjQgMS4xNDEtMS4xNDYtLjYyLS42MjRhMi4xMDUgMi4xMDUgMCAwIDEtLjQ4Ny0uNzQxIDIuMzQgMi4zNCAwIDAgMSAuNTAzLTIuNTFsMy4yMDYtMy4yMmEyLjI5MyAyLjI5MyAwIDAgMSAzLjIzOSAwYy44OS44OTQuODkgMi4zNDMgMCAzLjI1M2wtMS41MjcgMS41MzNjLjIzNC42NC4zMzUgMS4zMzEuMzAyIDIuMDA1bDIuMzgzLTIuMzkyYzEuNTEtMS41MzQgMS40OTMtNC4wMjgtLjAxNy01LjU2MVoiIGZpbGw9IiMxNjUyRjAiLz48cGF0aCBkPSJNMTEuMjcxIDcuNzQ1YTMuMTMgMy4xMyAwIDAgMC0uNTU0LS42OWwtLjYyLS42MjQtMS4xNDIgMS4xNDYuNjIxLjYyM2MuMjE4LjIyLjM4Ni40ODkuNDg3Ljc1OC4zMzUuODI2LjE2NyAxLjgyLS41MDQgMi40OTRsLTMuMjA1IDMuMjE5YTIuMjkzIDIuMjkzIDAgMCAxLTMuMjQgMCAyLjMxNiAyLjMxNiAwIDAgMSAwLTMuMjUybDEuNTI4LTEuNTM0YTQuODE1IDQuODE1IDAgMCAxLS4yODUtMi4wMDVsLTIuMzgzIDIuMzkzYTMuOTI3IDMuOTI3IDAgMCAwIDAgNS41NDQgMy45MDkgMy45MDkgMCAwIDAgNS41MzggMGwzLjIwNS0zLjIxOWEzLjk1OCAzLjk1OCAwIDAgMCAxLjA5MS0zLjQwNCA0LjIxMSA0LjIxMSAwIDAgMC0uNTM3LTEuNDQ5WiIgZmlsbD0iIzE2NTJGMCIvPjwvc3ZnPg==`;

},{}],"8A5Lm":[function(require,module,exports) {
"use strict";
// Copyright (c) 2018-2021 WalletLink.org <https://www.walletlink.org/>
// Copyright (c) 2018-2021 Coinbase, Inc. <https://www.coinbase.com/>
// Licensed under the Apache License, version 2.0
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = `data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTEgN3Y5aDE0VjdIMVptNy41IDQuMzlWMTRoLTF2LTIuNjFjLS40NC0uMTktLjc1LS42My0uNzUtMS4xNGExLjI1IDEuMjUgMCAwIDEgMi41IDBjMCAuNTEtLjMxLjk1LS43NSAxLjE0Wk01LjY3IDZWNC4zM0M1LjY3IDMuMDUgNi43MSAyIDggMnMyLjMzIDEuMDUgMi4zMyAyLjMzVjZoMlY0LjMzQzEyLjMzIDEuOTQgMTAuMzkgMCA4IDBTMy42NyAxLjk0IDMuNjcgNC4zM1Y2aDJaIiBmaWxsPSIjMTY1MkYwIi8+PC9zdmc+`;

},{}],"f7mDS":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = `<svg width="100" height="100" viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
<circle cx="50" cy="50" r="50" fill="white"/>
<circle cx="49.9996" cy="49.9996" r="43.6363" fill="#1B53E4"/>
<circle cx="49.9996" cy="49.9996" r="43.6363" stroke="white"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M19.3379 49.9484C19.3379 66.8508 33.04 80.553 49.9425 80.553C66.8449 80.553 80.5471 66.8508 80.5471 49.9484C80.5471 33.0459 66.8449 19.3438 49.9425 19.3438C33.04 19.3438 19.3379 33.0459 19.3379 49.9484ZM44.0817 40.0799C41.8725 40.0799 40.0817 41.8708 40.0817 44.0799V55.8029C40.0817 58.012 41.8725 59.8029 44.0817 59.8029H55.8046C58.0138 59.8029 59.8046 58.012 59.8046 55.8029V44.0799C59.8046 41.8708 58.0138 40.0799 55.8046 40.0799H44.0817Z" fill="white"/>
</svg>

`;

},{}],"7CVGm":[function(require,module,exports) {
"use strict";
// Copyright (c) 2018-2021 WalletLink.org <https://www.walletlink.org/>
// Copyright (c) 2018-2021 Coinbase, Inc. <https://www.coinbase.com/>
// Licensed under the Apache License, version 2.0
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = `.-walletlink-css-reset .-walletlink-extension-dialog{z-index:2147483647;position:fixed;top:0;left:0;right:0;bottom:0;display:flex;align-items:center;justify-content:center}.-walletlink-css-reset .-walletlink-extension-dialog-backdrop{z-index:2147483647;position:fixed;top:0;left:0;right:0;bottom:0;background-color:rgba(0,0,0,.5);transition:opacity .25s}.-walletlink-css-reset .-walletlink-extension-dialog-backdrop-hidden{opacity:0}.-walletlink-css-reset .-walletlink-extension-dialog-box{display:flex;position:relative;max-width:500px;flex-direction:column;transform:scale(1);transition:opacity .25s,transform .25s}.-walletlink-css-reset .-walletlink-extension-dialog-box-hidden{opacity:0;transform:scale(0.85)}.-walletlink-css-reset .-walletlink-extension-dialog-box-top{display:flex;flex-direction:row;background-color:#fff;border-radius:8px;overflow:hidden;min-height:300px}.-walletlink-css-reset .-walletlink-extension-dialog-box-top-install-region{display:flex;flex-basis:50%;flex-direction:column;justify-content:center;padding:32px}.-walletlink-css-reset .-walletlink-extension-dialog-box-top-install-region button{display:block;border-radius:8px;background-color:#1652f0;color:#fff;width:90%;min-width:fit-content;height:44px;margin-top:16px;font-size:16px;padding-left:16px;padding-right:16px;cursor:pointer;font-weight:500;text-align:center}.-walletlink-css-reset .-walletlink-extension-dialog-box-top-info-region{display:flex;flex-basis:50%;flex-direction:column;justify-content:center;background-color:#fafbfc}.-walletlink-css-reset .-walletlink-extension-dialog-box-top-description{display:flex;flex-direction:row;align-items:center;padding-top:14px;padding-bottom:14px;padding-left:24px;padding-right:32px}.-walletlink-css-reset .-walletlink-extension-dialog-box-top-description-icon-wrapper{display:block;position:relative;width:40px;height:40px;flex-shrink:0;flex-grow:0;border-radius:20px;background-color:#fff;box-shadow:0px 0px 8px rgba(0,0,0,.04),0px 16px 24px rgba(0,0,0,.06)}.-walletlink-css-reset .-walletlink-extension-dialog-box-top-description-icon-wrapper img{position:absolute;top:0;bottom:0;left:0;right:0;margin:auto}.-walletlink-css-reset .-walletlink-extension-dialog-box-top-description-text{margin-left:16px;flex-grow:1;font-size:13px;line-height:19px;color:#000;align-self:center}.-walletlink-css-reset .-walletlink-extension-dialog-box-bottom{display:flex;flex-direction:row;overflow:hidden;border-radius:8px;background-color:#fff;margin-top:8px}.-walletlink-css-reset .-walletlink-extension-dialog-box-bottom-description-region{display:flex;flex-direction:column;justify-content:center;padding:32px;flex-grow:1}.-walletlink-css-reset .-walletlink-extension-dialog-box-bottom-description{font-size:13px;line-height:19px;margin-top:12px;color:#aaa}.-walletlink-css-reset .-walletlink-extension-dialog-box-bottom-description a{font-size:inherit;line-height:inherit;color:#1652f0;cursor:pointer}.-walletlink-css-reset .-walletlink-extension-dialog-box-bottom-qr-region{position:relative;flex-shrink:0;display:flex;flex-direction:column;justify-content:center;padding-left:24px;padding-right:24px;padding-top:16px;padding-bottom:16px}.-walletlink-css-reset .-walletlink-extension-dialog-box-bottom-qr-wrapper{position:relative;display:block;padding:8px;border-radius:8px;box-shadow:0px 4px 12px rgba(0,0,0,.1)}.-walletlink-css-reset .-walletlink-extension-dialog-box-bottom-qr-wrapper img{display:block}.-walletlink-css-reset .-walletlink-extension-dialog-box-bottom-qr-connecting{position:absolute;top:0;bottom:0;left:0;right:0;display:flex;flex-direction:column;align-items:center;justify-content:center;background-color:rgba(255,255,255,.95)}.-walletlink-css-reset .-walletlink-extension-dialog-box-bottom-qr-connecting>p{font-size:12px;font-weight:bold;color:#000;margin-top:16px}.-walletlink-css-reset .-walletlink-extension-dialog-box-cancel{position:absolute;-webkit-appearance:none;display:flex;align-items:center;justify-content:center;top:16px;right:16px;width:24px;height:24px;border-radius:12px;background-color:#fafbfc;cursor:pointer}.-walletlink-css-reset .-walletlink-extension-dialog-box-cancel-x{position:relative;display:block;cursor:pointer}.-walletlink-css-reset .-walletlink-extension-dialog-box-cancel-x::before,.-walletlink-css-reset .-walletlink-extension-dialog-box-cancel-x::after{content:"";position:absolute;display:block;top:-1px;left:-7px;width:14px;height:1px;background-color:#000;transition:background-color .2s}.-walletlink-css-reset .-walletlink-extension-dialog-box-cancel-x::before{transform:rotate(45deg)}.-walletlink-css-reset .-walletlink-extension-dialog-box-cancel-x::after{transform:rotate(135deg)}.-walletlink-css-reset .-walletlink-extension-dialog-box-cancel:hover .-walletlink-link-dialog-box-cancel-x-a,.-walletlink-css-reset .-walletlink-extension-dialog-box-cancel:hover .-walletlink-link-dialog-box-cancel-x-b{background-color:#000}.-walletlink-css-reset .-walletlink-extension-dialog-container{display:block}.-walletlink-css-reset .-walletlink-extension-dialog-container-hidden{display:none}.-walletlink-css-reset .-walletlink-extension-dialog h2{display:block;text-align:left;font-size:22px;font-weight:600;line-height:28px;color:#000}`;

},{}],"3VnBl":[function(require,module,exports) {
"use strict";
// Copyright (c) 2018-2020 WalletLink.org <https://www.walletlink.org/>
// Copyright (c) 2018-2020 Coinbase, Inc. <https://www.coinbase.com/>
// Licensed under the Apache License, version 2.0
var __importDefault = this && this.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Snackbar = void 0;
const clsx_1 = __importDefault(require("b940b2d79d39e9ff"));
const preact_1 = require("a3cede665a1d8d53");
const hooks_1 = require("9360a246f663a88f");
const Snackbar_css_1 = __importDefault(require("e2261abf6a7297df"));
const cblogo = `data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzIiIGhlaWdodD0iMzIiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTEuNDkyIDEwLjQxOWE4LjkzIDguOTMgMCAwMTguOTMtOC45M2gxMS4xNjNhOC45MyA4LjkzIDAgMDE4LjkzIDguOTN2MTEuMTYzYTguOTMgOC45MyAwIDAxLTguOTMgOC45M0gxMC40MjJhOC45MyA4LjkzIDAgMDEtOC45My04LjkzVjEwLjQxOXoiIGZpbGw9IiMxNjUyRjAiLz48cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTEwLjQxOSAwSDIxLjU4QzI3LjMzNSAwIDMyIDQuNjY1IDMyIDEwLjQxOVYyMS41OEMzMiAyNy4zMzUgMjcuMzM1IDMyIDIxLjU4MSAzMkgxMC40MkM0LjY2NSAzMiAwIDI3LjMzNSAwIDIxLjU4MVYxMC40MkMwIDQuNjY1IDQuNjY1IDAgMTAuNDE5IDB6bTAgMS40ODhhOC45MyA4LjkzIDAgMDAtOC45MyA4LjkzdjExLjE2M2E4LjkzIDguOTMgMCAwMDguOTMgOC45M0gyMS41OGE4LjkzIDguOTMgMCAwMDguOTMtOC45M1YxMC40MmE4LjkzIDguOTMgMCAwMC04LjkzLTguOTNIMTAuNDJ6IiBmaWxsPSIjZmZmIi8+PHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xNS45OTggMjYuMDQ5Yy01LjU0OSAwLTEwLjA0Ny00LjQ5OC0xMC4wNDctMTAuMDQ3IDAtNS41NDggNC40OTgtMTAuMDQ2IDEwLjA0Ny0xMC4wNDYgNS41NDggMCAxMC4wNDYgNC40OTggMTAuMDQ2IDEwLjA0NiAwIDUuNTQ5LTQuNDk4IDEwLjA0Ny0xMC4wNDYgMTAuMDQ3eiIgZmlsbD0iI2ZmZiIvPjxwYXRoIGQ9Ik0xMi43NjIgMTQuMjU0YzAtLjgyMi42NjctMS40ODkgMS40ODktMS40ODloMy40OTdjLjgyMiAwIDEuNDg4LjY2NiAxLjQ4OCAxLjQ4OXYzLjQ5N2MwIC44MjItLjY2NiAxLjQ4OC0xLjQ4OCAxLjQ4OGgtMy40OTdhMS40ODggMS40ODggMCAwMS0xLjQ4OS0xLjQ4OHYtMy40OTh6IiBmaWxsPSIjMTY1MkYwIi8+PC9zdmc+`;
const gearIcon = `data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIiIGhlaWdodD0iMTIiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTEyIDYuNzV2LTEuNWwtMS43Mi0uNTdjLS4wOC0uMjctLjE5LS41Mi0uMzItLjc3bC44MS0xLjYyLTEuMDYtMS4wNi0xLjYyLjgxYy0uMjQtLjEzLS41LS4yNC0uNzctLjMyTDYuNzUgMGgtMS41bC0uNTcgMS43MmMtLjI3LjA4LS41My4xOS0uNzcuMzJsLTEuNjItLjgxLTEuMDYgMS4wNi44MSAxLjYyYy0uMTMuMjQtLjI0LjUtLjMyLjc3TDAgNS4yNXYxLjVsMS43Mi41N2MuMDguMjcuMTkuNTMuMzIuNzdsLS44MSAxLjYyIDEuMDYgMS4wNiAxLjYyLS44MWMuMjQuMTMuNS4yMy43Ny4zMkw1LjI1IDEyaDEuNWwuNTctMS43MmMuMjctLjA4LjUyLS4xOS43Ny0uMzJsMS42Mi44MSAxLjA2LTEuMDYtLjgxLTEuNjJjLjEzLS4yNC4yMy0uNS4zMi0uNzdMMTIgNi43NXpNNiA4LjVhMi41IDIuNSAwIDAxMC01IDIuNSAyLjUgMCAwMTAgNXoiIGZpbGw9IiMwNTBGMTkiLz48L3N2Zz4=`;
class Snackbar {
    constructor(options){
        this.items = new Map();
        this.nextItemKey = 0;
        this.root = null;
        this.darkMode = options.darkMode;
    }
    attach(el) {
        this.root = document.createElement("div");
        this.root.className = "-walletlink-snackbar-root";
        el.appendChild(this.root);
        this.render();
    }
    presentItem(itemProps) {
        const key = this.nextItemKey++;
        this.items.set(key, itemProps);
        this.render();
        return ()=>{
            this.items.delete(key);
            this.render();
        };
    }
    clear() {
        this.items.clear();
        this.render();
    }
    render() {
        if (!this.root) return;
        (0, preact_1.render)((0, preact_1.h)("div", null, (0, preact_1.h)(SnackbarContainer, {
            darkMode: this.darkMode
        }, Array.from(this.items.entries()).map(([key, itemProps])=>(0, preact_1.h)(SnackbarInstance, Object.assign({}, itemProps, {
                key: key
            }))))), this.root);
    }
}
exports.Snackbar = Snackbar;
const SnackbarContainer = (props)=>(0, preact_1.h)("div", {
        class: (0, clsx_1.default)("-walletlink-snackbar-container")
    }, (0, preact_1.h)("style", null, Snackbar_css_1.default), (0, preact_1.h)("div", {
        class: "-walletlink-snackbar"
    }, props.children));
const SnackbarInstance = ({ autoExpand, message, menuItems })=>{
    const [hidden, setHidden] = (0, hooks_1.useState)(true);
    const [expanded, setExpanded] = (0, hooks_1.useState)(autoExpand !== null && autoExpand !== void 0 ? autoExpand : false);
    (0, hooks_1.useEffect)(()=>{
        const timers = [
            window.setTimeout(()=>{
                setHidden(false);
            }, 1),
            window.setTimeout(()=>{
                setExpanded(true);
            }, 10000)
        ];
        return ()=>{
            timers.forEach(window.clearTimeout);
        };
    });
    const toggleExpanded = ()=>{
        setExpanded(!expanded);
    };
    return (0, preact_1.h)("div", {
        class: (0, clsx_1.default)("-walletlink-snackbar-instance", hidden && "-walletlink-snackbar-instance-hidden", expanded && "-walletlink-snackbar-instance-expanded")
    }, (0, preact_1.h)("div", {
        class: "-walletlink-snackbar-instance-header",
        onClick: toggleExpanded
    }, (0, preact_1.h)("img", {
        src: cblogo,
        class: "-walletlink-snackbar-instance-header-cblogo"
    }), (0, preact_1.h)("div", {
        class: "-walletlink-snackbar-instance-header-message"
    }, message), (0, preact_1.h)("div", {
        class: "-gear-container"
    }, !expanded && (0, preact_1.h)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, (0, preact_1.h)("circle", {
        cx: "12",
        cy: "12",
        r: "12",
        fill: "#F5F7F8"
    })), (0, preact_1.h)("img", {
        src: gearIcon,
        class: "-gear-icon",
        title: "Expand"
    }))), menuItems && menuItems.length > 0 && (0, preact_1.h)("div", {
        class: "-walletlink-snackbar-instance-menu"
    }, menuItems.map((action, i)=>(0, preact_1.h)("div", {
            class: (0, clsx_1.default)("-walletlink-snackbar-instance-menu-item", action.isRed && "-walletlink-snackbar-instance-menu-item-is-red"),
            onClick: action.onClick,
            key: i
        }, (0, preact_1.h)("svg", {
            width: action.svgWidth,
            height: action.svgHeight,
            viewBox: "0 0 10 11",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg"
        }, (0, preact_1.h)("path", {
            "fill-rule": action.defaultFillRule,
            "clip-rule": action.defaultClipRule,
            d: action.path,
            fill: "#AAAAAA"
        })), (0, preact_1.h)("span", {
            class: (0, clsx_1.default)("-walletlink-snackbar-instance-menu-item-info", action.isRed && "-walletlink-snackbar-instance-menu-item-info-is-red")
        }, action.info)))));
};

},{"b940b2d79d39e9ff":"7UQcB","a3cede665a1d8d53":"213JP","9360a246f663a88f":"MIejN","e2261abf6a7297df":"5u3wK"}],"5u3wK":[function(require,module,exports) {
"use strict";
// Copyright (c) 2018-2021 WalletLink.org <https://www.walletlink.org/>
// Copyright (c) 2018-2021 Coinbase, Inc. <https://www.coinbase.com/>
// Licensed under the Apache License, version 2.0
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = `.-walletlink-css-reset .-gear-container{margin-left:16px !important;margin-right:9px !important;display:flex;align-items:center;justify-content:center;width:24px;height:24px;transition:opacity .25s}.-walletlink-css-reset .-gear-container *{user-select:none}.-walletlink-css-reset .-gear-container svg{opacity:0;position:absolute}.-walletlink-css-reset .-gear-icon{height:12px;width:12px;z-index:10000}.-walletlink-css-reset .-walletlink-snackbar{align-items:flex-end;display:flex;flex-direction:column;position:fixed;right:0;top:0;z-index:2147483647}.-walletlink-css-reset .-walletlink-snackbar *{user-select:none}.-walletlink-css-reset .-walletlink-snackbar-instance{display:flex;flex-direction:column;margin:8px 16px 0 16px;overflow:visible;text-align:left;transform:translateX(0);transition:opacity .25s,transform .25s}.-walletlink-css-reset .-walletlink-snackbar-instance-header:hover .-gear-container svg{opacity:1}.-walletlink-css-reset .-walletlink-snackbar-instance-header{display:flex;align-items:center;background:#fff;overflow:hidden;border:1px solid #e7ebee;box-sizing:border-box;border-radius:8px;cursor:pointer}.-walletlink-css-reset .-walletlink-snackbar-instance-header-cblogo{margin:8px 8px 8px 8px}.-walletlink-css-reset .-walletlink-snackbar-instance-header *{cursor:pointer}.-walletlink-css-reset .-walletlink-snackbar-instance-header-message{color:#000;font-size:13px;line-height:1.5;user-select:none}.-walletlink-css-reset .-walletlink-snackbar-instance-menu{background:#fff;transition:opacity .25s ease-in-out,transform .25s linear,visibility 0s;visibility:hidden;border:1px solid #e7ebee;box-sizing:border-box;border-radius:8px;opacity:0;flex-direction:column;padding-left:8px;padding-right:8px}.-walletlink-css-reset .-walletlink-snackbar-instance-menu-item:last-child{margin-bottom:8px !important}.-walletlink-css-reset .-walletlink-snackbar-instance-menu-item:hover{background:#f5f7f8;border-radius:6px;transition:background .25s}.-walletlink-css-reset .-walletlink-snackbar-instance-menu-item:hover span{color:#050f19;transition:color .25s}.-walletlink-css-reset .-walletlink-snackbar-instance-menu-item:hover svg path{fill:#000;transition:fill .25s}.-walletlink-css-reset .-walletlink-snackbar-instance-menu-item{visibility:inherit;height:35px;margin-top:8px;margin-bottom:0;display:flex;flex-direction:row;align-items:center;padding:8px;cursor:pointer}.-walletlink-css-reset .-walletlink-snackbar-instance-menu-item *{visibility:inherit;cursor:pointer}.-walletlink-css-reset .-walletlink-snackbar-instance-menu-item-is-red:hover{background:rgba(223,95,103,.2);transition:background .25s}.-walletlink-css-reset .-walletlink-snackbar-instance-menu-item-is-red:hover *{cursor:pointer}.-walletlink-css-reset .-walletlink-snackbar-instance-menu-item-is-red:hover svg path{fill:#df5f67;transition:fill .25s}.-walletlink-css-reset .-walletlink-snackbar-instance-menu-item-is-red:hover span{color:#df5f67;transition:color .25s}.-walletlink-css-reset .-walletlink-snackbar-instance-menu-item-info{color:#aaa;font-size:13px;margin:0 8px 0 32px;position:absolute}.-walletlink-css-reset .-walletlink-snackbar-instance-hidden{opacity:0;text-align:left;transform:translateX(25%);transition:opacity .5s linear}.-walletlink-css-reset .-walletlink-snackbar-instance-expanded .-walletlink-snackbar-instance-menu{opacity:1;display:flex;transform:translateY(8px);visibility:visible}`;

},{}],"6TNS2":[function(require,module,exports) {
"use strict";
// Copyright (c) 2018-2020 WalletLink.org <https://www.walletlink.org/>
// Copyright (c) 2018-2020 Coinbase, Inc. <https://www.coinbase.com/>
// Licensed under the Apache License, version 2.0
var __importDefault = this && this.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.injectCssReset = void 0;
const cssReset_css_1 = __importDefault(require("9614e5c6e041e684"));
function injectCssReset() {
    const styleEl = document.createElement("style");
    styleEl.type = "text/css";
    styleEl.appendChild(document.createTextNode(cssReset_css_1.default));
    document.documentElement.appendChild(styleEl);
}
exports.injectCssReset = injectCssReset;

},{"9614e5c6e041e684":"f5KAK"}],"f5KAK":[function(require,module,exports) {
"use strict";
// Copyright (c) 2018-2021 WalletLink.org <https://www.walletlink.org/>
// Copyright (c) 2018-2021 Coinbase, Inc. <https://www.coinbase.com/>
// Licensed under the Apache License, version 2.0
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = `@namespace svg "http://www.w3.org/2000/svg";.-walletlink-css-reset,.-walletlink-css-reset *{animation:none;animation-delay:0;animation-direction:normal;animation-duration:0;animation-fill-mode:none;animation-iteration-count:1;animation-name:none;animation-play-state:running;animation-timing-function:ease;backface-visibility:visible;background:0;background-attachment:scroll;background-clip:border-box;background-color:transparent;background-image:none;background-origin:padding-box;background-position:0 0;background-position-x:0;background-position-y:0;background-repeat:repeat;background-size:auto auto;border:0;border-style:none;border-width:medium;border-color:inherit;border-bottom:0;border-bottom-color:inherit;border-bottom-left-radius:0;border-bottom-right-radius:0;border-bottom-style:none;border-bottom-width:medium;border-collapse:separate;border-image:none;border-left:0;border-left-color:inherit;border-left-style:none;border-left-width:medium;border-radius:0;border-right:0;border-right-color:inherit;border-right-style:none;border-right-width:medium;border-spacing:0;border-top:0;border-top-color:inherit;border-top-left-radius:0;border-top-right-radius:0;border-top-style:none;border-top-width:medium;bottom:auto;box-shadow:none;box-sizing:border-box;caption-side:top;clear:none;clip:auto;color:inherit;columns:auto;column-count:auto;column-fill:balance;column-gap:normal;column-rule:medium none currentColor;column-rule-color:currentColor;column-rule-style:none;column-rule-width:none;column-span:1;column-width:auto;content:normal;counter-increment:none;counter-reset:none;cursor:auto;direction:ltr;display:block;empty-cells:show;float:none;font:normal;font-family:-apple-system,BlinkMacSystemFont,"Segoe UI","Helvetica Neue",Arial,sans-serif;font-size:medium;font-style:normal;font-variant:normal;font-weight:normal;height:auto;hyphens:none;left:auto;letter-spacing:normal;line-height:normal;list-style:none;list-style-image:none;list-style-position:outside;list-style-type:disc;margin:0;margin-bottom:0;margin-left:0;margin-right:0;margin-top:0;max-height:none;max-width:none;min-height:0;min-width:0;opacity:1;orphans:0;outline:0;outline-color:invert;outline-style:none;outline-width:medium;overflow:visible;overflow-x:visible;overflow-y:visible;padding:0;padding-bottom:0;padding-left:0;padding-right:0;padding-top:0;page-break-after:auto;page-break-before:auto;page-break-inside:auto;perspective:none;perspective-origin:50% 50%;pointer-events:auto;position:static;quotes:"\\201C" "\\201D" "\\2018" "\\2019";right:auto;tab-size:8;table-layout:auto;text-align:inherit;text-align-last:auto;text-decoration:none;text-decoration-color:inherit;text-decoration-line:none;text-decoration-style:solid;text-indent:0;text-shadow:none;text-transform:none;top:auto;transform:none;transform-style:flat;transition:none;transition-delay:0s;transition-duration:0s;transition-property:none;transition-timing-function:ease;unicode-bidi:normal;vertical-align:baseline;visibility:visible;white-space:normal;widows:0;width:auto;word-spacing:normal;z-index:auto}.-walletlink-css-reset *{box-sizing:border-box;display:initial;font-family:-apple-system,BlinkMacSystemFont,"Segoe UI","Helvetica Neue",Arial,sans-serif;line-height:1}.-walletlink-css-reset [class*=container]{margin:0;padding:0}.-walletlink-css-reset style{display:none}`;

},{}],"dyHrq":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.WalletLinkUI = void 0;
class WalletLinkUI {
    constructor(_){}
    /**
     * We want to disable showing the qr code for in-page walletlink if the dapp hasn't provided a json rpc url
     */ setConnectDisabled(_) {}
}
exports.WalletLinkUI = WalletLinkUI;

},{}],"kAxZC":[function(require,module,exports) {
"use strict";
// Copyright (c) 2018-2020 WalletLink.org <https://www.walletlink.org/>
// Copyright (c) 2018-2020 Coinbase, Inc. <https://www.coinbase.com/>
// Licensed under the Apache License, version 2.0
var __createBinding = this && this.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, {
        enumerable: true,
        get: function() {
            return m[k];
        }
    });
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var __decorate = this && this.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = this && this.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    }
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = this && this.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.WalletLinkRelay = void 0;
const bind_decorator_1 = __importDefault(require("15d6d2e5faf61da0"));
const eth_rpc_errors_1 = require("bda984db4468de90");
const rxjs_1 = require("c4ea2dcfbb8f23b5");
const operators_1 = require("12e0231d07e121f4");
const WalletLinkAnalytics_1 = require("3c356ed16f835532");
const WalletLinkConnection_1 = require("7700163124ffe243");
const init_1 = require("d927c2f668b02591");
const util_1 = require("10c8e18bab69cde1");
const aes256gcm = __importStar(require("884a6ded3d86837a"));
const Session_1 = require("4642af8d5c70b580");
const WalletLinkRelayAbstract_1 = require("b00da9e1ed36347f");
const Web3Method_1 = require("c397b4129a853dde");
const Web3RequestCanceledMessage_1 = require("5d1ab8c2e65e513f");
const Web3RequestMessage_1 = require("cbc676cde1309902");
const Web3Response_1 = require("a9065e1afdf35f6");
const Web3ResponseMessage_1 = require("9a6fc3ce3871978b");
class WalletLinkRelay extends WalletLinkRelayAbstract_1.WalletLinkRelayAbstract {
    constructor(options){
        super();
        this.accountsCallback = null;
        this.chainCallback = null;
        this.appName = "";
        this.appLogoUrl = null;
        this.subscriptions = new rxjs_1.Subscription();
        this.walletLinkUrl = options.walletLinkUrl;
        this.storage = options.storage;
        this._session = Session_1.Session.load(options.storage) || new Session_1.Session(options.storage).save();
        this.relayEventManager = options.relayEventManager;
        this.walletLinkAnalytics = options.walletLinkAnalytics ? options.walletLinkAnalytics : new WalletLinkAnalytics_1.WalletLinkAnalytics();
        this.connection = new WalletLinkConnection_1.WalletLinkConnection(this._session.id, this._session.key, this.walletLinkUrl, this.walletLinkAnalytics);
        this.subscriptions.add(this.connection.incomingEvent$.pipe((0, operators_1.filter)((m)=>m.event === "Web3Response")).subscribe({
            next: this.handleIncomingEvent
        }) // eslint-disable-line @typescript-eslint/unbound-method
        );
        this.subscriptions.add(this.connection.linked$.pipe((0, operators_1.skip)(1), (0, operators_1.tap)((linked)=>{
            var _a;
            this.isLinked = linked;
            const cachedAddresses = this.storage.getItem(WalletLinkRelayAbstract_1.LOCAL_STORAGE_ADDRESSES_KEY);
            if (linked) // Only set linked session variable one way
            this.session.linked = linked;
            this.isUnlinkedErrorState = false;
            if (cachedAddresses) {
                const addresses = cachedAddresses.split(" ");
                const wasConnectedViaStandalone = this.storage.getItem("IsStandaloneSigning") === "true";
                if (addresses[0] !== "" && !linked && this.session.linked && !wasConnectedViaStandalone) {
                    this.isUnlinkedErrorState = true;
                    const sessionIdHash = this.getSessionIdHash();
                    (_a = this.walletLinkAnalytics) === null || _a === void 0 || _a.sendEvent(init_1.EVENTS.UNLINKED_ERROR_STATE, {
                        sessionIdHash,
                        origin: location.origin
                    });
                }
            }
        })).subscribe());
        // if session is marked destroyed, reset and reload
        this.subscriptions.add(this.connection.sessionConfig$.pipe((0, operators_1.filter)((c)=>!!c.metadata && c.metadata.__destroyed === "1")).subscribe(()=>{
            var _a;
            const alreadyDestroyed = this.connection.isDestroyed;
            (_a = this.walletLinkAnalytics) === null || _a === void 0 || _a.sendEvent(init_1.EVENTS.METADATA_DESTROYED, {
                alreadyDestroyed,
                sessionIdHash: this.getSessionIdHash(),
                origin: location.origin
            });
            return this.resetAndReload();
        }));
        this.subscriptions.add(this.connection.sessionConfig$.pipe((0, operators_1.filter)((c)=>c.metadata && c.metadata.WalletUsername !== undefined)).pipe((0, operators_1.mergeMap)((c)=>aes256gcm.decrypt(c.metadata.WalletUsername, this._session.secret))).subscribe({
            next: (walletUsername)=>{
                this.storage.setItem(WalletLinkRelayAbstract_1.WALLET_USER_NAME_KEY, walletUsername);
            },
            error: ()=>{
                var _a;
                (_a = this.walletLinkAnalytics) === null || _a === void 0 || _a.sendEvent(init_1.EVENTS.GENERAL_ERROR, {
                    message: "Had error decrypting",
                    value: "username"
                });
            }
        }));
        this.subscriptions.add(this.connection.sessionConfig$.pipe((0, operators_1.filter)((c)=>c.metadata && c.metadata.AppVersion !== undefined)).pipe((0, operators_1.mergeMap)((c)=>aes256gcm.decrypt(c.metadata.AppVersion, this._session.secret))).subscribe({
            next: (appVersion)=>{
                this.storage.setItem(WalletLinkRelayAbstract_1.APP_VERSION_KEY, appVersion);
            },
            error: ()=>{
                var _a;
                (_a = this.walletLinkAnalytics) === null || _a === void 0 || _a.sendEvent(init_1.EVENTS.GENERAL_ERROR, {
                    message: "Had error decrypting",
                    value: "appversion"
                });
            }
        }));
        this.subscriptions.add(this.connection.sessionConfig$.pipe((0, operators_1.filter)((c)=>c.metadata && c.metadata.ChainId !== undefined && c.metadata.JsonRpcUrl !== undefined)).pipe((0, operators_1.mergeMap)((c)=>(0, rxjs_1.zip)(aes256gcm.decrypt(c.metadata.ChainId, this._session.secret), aes256gcm.decrypt(c.metadata.JsonRpcUrl, this._session.secret)))).pipe((0, operators_1.distinctUntilChanged)()).subscribe({
            next: ([chainId, jsonRpcUrl])=>{
                if (this.chainCallback) this.chainCallback(chainId, jsonRpcUrl);
            },
            error: ()=>{
                var _a;
                (_a = this.walletLinkAnalytics) === null || _a === void 0 || _a.sendEvent(init_1.EVENTS.GENERAL_ERROR, {
                    message: "Had error decrypting",
                    value: "chainId|jsonRpcUrl"
                });
            }
        }));
        this.subscriptions.add(this.connection.sessionConfig$.pipe((0, operators_1.filter)((c)=>c.metadata && c.metadata.EthereumAddress !== undefined)).pipe((0, operators_1.mergeMap)((c)=>aes256gcm.decrypt(c.metadata.EthereumAddress, this._session.secret))).subscribe({
            next: (selectedAddress)=>{
                if (this.accountsCallback) this.accountsCallback([
                    selectedAddress
                ]);
                if (WalletLinkRelay.accountRequestCallbackIds.size > 0) {
                    // We get the ethereum address from the metadata.  If for whatever
                    // reason we don't get a response via an explicit web3 message
                    // we can still fulfill the eip1102 request.
                    Array.from(WalletLinkRelay.accountRequestCallbackIds.values()).forEach((id)=>{
                        const message = (0, Web3ResponseMessage_1.Web3ResponseMessage)({
                            id,
                            response: (0, Web3Response_1.RequestEthereumAccountsResponse)([
                                selectedAddress
                            ])
                        });
                        this.invokeCallback(Object.assign(Object.assign({}, message), {
                            id
                        }));
                    });
                    WalletLinkRelay.accountRequestCallbackIds.clear();
                }
            },
            error: ()=>{
                var _a;
                (_a = this.walletLinkAnalytics) === null || _a === void 0 || _a.sendEvent(init_1.EVENTS.GENERAL_ERROR, {
                    message: "Had error decrypting",
                    value: "selectedAddress"
                });
            }
        }));
        this.ui = options.walletLinkUIConstructor({
            walletLinkUrl: options.walletLinkUrl,
            version: options.version,
            darkMode: options.darkMode,
            session: this._session,
            connected$: this.connection.connected$
        });
        this.connection.connect();
    }
    attachUI() {
        this.ui.attach();
    }
    resetAndReload() {
        this.connection.setSessionMetadata("__destroyed", "1").pipe((0, operators_1.timeout)(1000), (0, operators_1.catchError)((_)=>(0, rxjs_1.of)(null))).subscribe((_)=>{
            var _a, _b, _c;
            try {
                this.subscriptions.unsubscribe();
            } catch (err) {
                (_a = this.walletLinkAnalytics) === null || _a === void 0 || _a.sendEvent(init_1.EVENTS.GENERAL_ERROR, {
                    message: "Had error unsubscribing"
                });
            }
            (_b = this.walletLinkAnalytics) === null || _b === void 0 || _b.sendEvent(init_1.EVENTS.SESSION_STATE_CHANGE, {
                method: "relay::resetAndReload",
                sessionMetadataChange: "__destroyed, 1",
                sessionIdHash: this.getSessionIdHash(),
                origin: location.origin
            });
            this.connection.destroy();
            /**
             * Only clear storage if the session id we have in memory matches the one on disk
             * Otherwise, in the case where we have 2 tabs, another tab might have cleared
             * storage already.  In that case if we clear storage again, the user will be in
             * a state where the first tab allows the user to connect but the session that
             * was used isn't persisted.  This leaves the user in a state where they aren't
             * connected to the mobile app.
             */ const storedSession = Session_1.Session.load(this.storage);
            if ((storedSession === null || storedSession === void 0 ? void 0 : storedSession.id) === this._session.id) this.storage.clear();
            else if (storedSession) (_c = this.walletLinkAnalytics) === null || _c === void 0 || _c.sendEvent(init_1.EVENTS.SKIPPED_CLEARING_SESSION, {
                sessionIdHash: this.getSessionIdHash(),
                storedSessionIdHash: Session_1.Session.hash(storedSession.id),
                origin: location.origin
            });
            this.ui.reloadUI();
        }, (err)=>{
            var _a;
            (_a = this.walletLinkAnalytics) === null || _a === void 0 || _a.sendEvent(init_1.EVENTS.FAILURE, {
                method: "relay::resetAndReload",
                message: `failed to reset and reload with ${err}`,
                sessionIdHash: this.getSessionIdHash()
            });
        });
    }
    setAppInfo(appName, appLogoUrl) {
        this.appName = appName;
        this.appLogoUrl = appLogoUrl;
    }
    getStorageItem(key) {
        return this.storage.getItem(key);
    }
    get session() {
        return this._session;
    }
    setStorageItem(key, value) {
        this.storage.setItem(key, value);
    }
    signEthereumMessage(message, address, addPrefix, typedDataJson) {
        return this.sendRequest({
            method: Web3Method_1.Web3Method.signEthereumMessage,
            params: {
                message: (0, util_1.hexStringFromBuffer)(message, true),
                address,
                addPrefix,
                typedDataJson: typedDataJson || null
            }
        });
    }
    ethereumAddressFromSignedMessage(message, signature, addPrefix) {
        return this.sendRequest({
            method: Web3Method_1.Web3Method.ethereumAddressFromSignedMessage,
            params: {
                message: (0, util_1.hexStringFromBuffer)(message, true),
                signature: (0, util_1.hexStringFromBuffer)(signature, true),
                addPrefix
            }
        });
    }
    signEthereumTransaction(params) {
        return this.sendRequest({
            method: Web3Method_1.Web3Method.signEthereumTransaction,
            params: {
                fromAddress: params.fromAddress,
                toAddress: params.toAddress,
                weiValue: (0, util_1.bigIntStringFromBN)(params.weiValue),
                data: (0, util_1.hexStringFromBuffer)(params.data, true),
                nonce: params.nonce,
                gasPriceInWei: params.gasPriceInWei ? (0, util_1.bigIntStringFromBN)(params.gasPriceInWei) : null,
                maxFeePerGas: params.gasPriceInWei ? (0, util_1.bigIntStringFromBN)(params.gasPriceInWei) : null,
                maxPriorityFeePerGas: params.gasPriceInWei ? (0, util_1.bigIntStringFromBN)(params.gasPriceInWei) : null,
                gasLimit: params.gasLimit ? (0, util_1.bigIntStringFromBN)(params.gasLimit) : null,
                chainId: params.chainId,
                shouldSubmit: false
            }
        });
    }
    signAndSubmitEthereumTransaction(params) {
        return this.sendRequest({
            method: Web3Method_1.Web3Method.signEthereumTransaction,
            params: {
                fromAddress: params.fromAddress,
                toAddress: params.toAddress,
                weiValue: (0, util_1.bigIntStringFromBN)(params.weiValue),
                data: (0, util_1.hexStringFromBuffer)(params.data, true),
                nonce: params.nonce,
                gasPriceInWei: params.gasPriceInWei ? (0, util_1.bigIntStringFromBN)(params.gasPriceInWei) : null,
                maxFeePerGas: params.maxFeePerGas ? (0, util_1.bigIntStringFromBN)(params.maxFeePerGas) : null,
                maxPriorityFeePerGas: params.maxPriorityFeePerGas ? (0, util_1.bigIntStringFromBN)(params.maxPriorityFeePerGas) : null,
                gasLimit: params.gasLimit ? (0, util_1.bigIntStringFromBN)(params.gasLimit) : null,
                chainId: params.chainId,
                shouldSubmit: true
            }
        });
    }
    submitEthereumTransaction(signedTransaction, chainId) {
        return this.sendRequest({
            method: Web3Method_1.Web3Method.submitEthereumTransaction,
            params: {
                signedTransaction: (0, util_1.hexStringFromBuffer)(signedTransaction, true),
                chainId
            }
        });
    }
    scanQRCode(regExp) {
        return this.sendRequest({
            method: Web3Method_1.Web3Method.scanQRCode,
            params: {
                regExp
            }
        });
    }
    genericRequest(data, action) {
        return this.sendRequest({
            method: Web3Method_1.Web3Method.generic,
            params: {
                action,
                data
            }
        });
    }
    sendGenericMessage(request) {
        return this.sendRequest(request);
    }
    sendRequest(request) {
        let hideSnackbarItem = null;
        const id = (0, util_1.randomBytesHex)(8);
        const cancel = ()=>{
            this.publishWeb3RequestCanceledEvent(id);
            this.handleWeb3ResponseMessage((0, Web3ResponseMessage_1.Web3ResponseMessage)({
                id,
                response: (0, Web3Response_1.ErrorResponse)(request.method, "User rejected request")
            }));
            hideSnackbarItem === null || hideSnackbarItem === void 0 || hideSnackbarItem();
        };
        const promise = new Promise((resolve, reject)=>{
            if (!this.ui.isStandalone()) hideSnackbarItem = this.ui.showConnecting({
                isUnlinkedErrorState: this.isUnlinkedErrorState,
                onCancel: cancel,
                onResetConnection: this.resetAndReload // eslint-disable-line @typescript-eslint/unbound-method
            });
            this.relayEventManager.callbacks.set(id, (response)=>{
                hideSnackbarItem === null || hideSnackbarItem === void 0 || hideSnackbarItem();
                if (response.errorMessage) return reject(new Error(response.errorMessage));
                resolve(response);
            });
            if (this.ui.isStandalone()) this.sendRequestStandalone(id, request);
            else this.publishWeb3RequestEvent(id, request);
        });
        return {
            promise,
            cancel
        };
    }
    setConnectDisabled(disabled) {
        this.ui.setConnectDisabled(disabled);
    }
    setAccountsCallback(accountsCallback) {
        this.accountsCallback = accountsCallback;
    }
    setChainCallback(chainCallback) {
        this.chainCallback = chainCallback;
    }
    publishWeb3RequestEvent(id, request) {
        var _a;
        const message = (0, Web3RequestMessage_1.Web3RequestMessage)({
            id,
            request
        });
        const storedSession = Session_1.Session.load(this.storage);
        (_a = this.walletLinkAnalytics) === null || _a === void 0 || _a.sendEvent(init_1.EVENTS.WEB3_REQUEST, {
            eventId: message.id,
            method: `relay::${message.request.method}`,
            sessionIdHash: this.getSessionIdHash(),
            storedSessionIdHash: storedSession ? Session_1.Session.hash(storedSession.id) : "",
            isSessionMismatched: ((storedSession === null || storedSession === void 0 ? void 0 : storedSession.id) !== this._session.id).toString(),
            origin: location.origin
        });
        this.subscriptions.add(this.publishEvent("Web3Request", message, true).subscribe({
            next: (_)=>{
                var _a;
                (_a = this.walletLinkAnalytics) === null || _a === void 0 || _a.sendEvent(init_1.EVENTS.WEB3_REQUEST_PUBLISHED, {
                    eventId: message.id,
                    method: `relay::${message.request.method}`,
                    sessionIdHash: this.getSessionIdHash(),
                    storedSessionIdHash: storedSession ? Session_1.Session.hash(storedSession.id) : "",
                    isSessionMismatched: ((storedSession === null || storedSession === void 0 ? void 0 : storedSession.id) !== this._session.id).toString(),
                    origin: location.origin
                });
            },
            error: (err)=>{
                this.handleWeb3ResponseMessage((0, Web3ResponseMessage_1.Web3ResponseMessage)({
                    id: message.id,
                    response: {
                        method: message.request.method,
                        errorMessage: err.message
                    }
                }));
            }
        }));
    }
    publishWeb3RequestCanceledEvent(id) {
        const message = (0, Web3RequestCanceledMessage_1.Web3RequestCanceledMessage)(id);
        this.subscriptions.add(this.publishEvent("Web3RequestCanceled", message, false).subscribe());
    }
    publishEvent(event, message, callWebhook) {
        const secret = this.session.secret;
        return new rxjs_1.Observable((subscriber)=>{
            aes256gcm.encrypt(JSON.stringify(Object.assign(Object.assign({}, message), {
                origin: location.origin
            })), secret).then((encrypted)=>{
                subscriber.next(encrypted);
                subscriber.complete();
            });
        }).pipe((0, operators_1.mergeMap)((encrypted)=>{
            return this.connection.publishEvent(event, encrypted, callWebhook);
        }));
    }
    handleIncomingEvent(event) {
        try {
            this.subscriptions.add(aes256gcm.decrypt(event.data, this.session.secret).pipe((0, operators_1.map)((c)=>JSON.parse(c))).subscribe({
                next: (json)=>{
                    const message = (0, Web3ResponseMessage_1.isWeb3ResponseMessage)(json) ? json : null;
                    if (!message) return;
                    this.handleWeb3ResponseMessage(message);
                },
                error: ()=>{
                    var _a;
                    (_a = this.walletLinkAnalytics) === null || _a === void 0 || _a.sendEvent(init_1.EVENTS.GENERAL_ERROR, {
                        message: "Had error decrypting",
                        value: "incomingEvent"
                    });
                }
            }));
        } catch (_a) {
            return;
        }
    }
    handleWeb3ResponseMessage(message) {
        var _a;
        const { response } = message;
        (_a = this.walletLinkAnalytics) === null || _a === void 0 || _a.sendEvent(init_1.EVENTS.WEB3_RESPONSE, {
            eventId: message.id,
            method: `relay::${response.method}`,
            sessionIdHash: this.getSessionIdHash(),
            origin: location.origin
        });
        if ((0, Web3Response_1.isRequestEthereumAccountsResponse)(response)) {
            Array.from(WalletLinkRelay.accountRequestCallbackIds.values()).forEach((id)=>this.invokeCallback(Object.assign(Object.assign({}, message), {
                    id
                })));
            WalletLinkRelay.accountRequestCallbackIds.clear();
            return;
        }
        this.invokeCallback(message);
    }
    invokeCallback(message) {
        const callback = this.relayEventManager.callbacks.get(message.id);
        if (callback) {
            callback(message.response);
            this.relayEventManager.callbacks.delete(message.id);
        }
    }
    requestEthereumAccounts() {
        let request = {
            method: Web3Method_1.Web3Method.requestEthereumAccounts,
            params: {
                appName: this.appName,
                appLogoUrl: this.appLogoUrl || null
            }
        };
        let hideSnackbarItem = null;
        const id = (0, util_1.randomBytesHex)(8);
        const cancel = ()=>{
            this.publishWeb3RequestCanceledEvent(id);
            this.handleWeb3ResponseMessage((0, Web3ResponseMessage_1.Web3ResponseMessage)({
                id,
                response: (0, Web3Response_1.ErrorResponse)(request.method, "User rejected request")
            }));
            hideSnackbarItem === null || hideSnackbarItem === void 0 || hideSnackbarItem();
        };
        const promise = new Promise((resolve, reject)=>{
            var _a;
            this.relayEventManager.callbacks.set(id, (response)=>{
                this.ui.hideRequestEthereumAccounts();
                hideSnackbarItem === null || hideSnackbarItem === void 0 || hideSnackbarItem();
                if (response.errorMessage) return reject(new Error(response.errorMessage));
                resolve(response);
            });
            const userAgent = ((_a = window === null || window === void 0 ? void 0 : window.navigator) === null || _a === void 0 ? void 0 : _a.userAgent) || null;
            if (userAgent && /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(userAgent)) {
                window.location.href = `https://go.cb-w.com/xoXnYwQimhb?cb_url=${encodeURIComponent(window.location.href)}`;
                return;
            }
            if (this.ui.inlineAccountsResponse()) {
                const onAccounts = (accounts)=>{
                    this.handleWeb3ResponseMessage((0, Web3ResponseMessage_1.Web3ResponseMessage)({
                        id,
                        response: (0, Web3Response_1.RequestEthereumAccountsResponse)(accounts)
                    }));
                };
                this.ui.requestEthereumAccounts({
                    onCancel: cancel,
                    onAccounts
                });
            } else this.ui.requestEthereumAccounts({
                onCancel: cancel
            });
            WalletLinkRelay.accountRequestCallbackIds.add(id);
            if (!this.ui.inlineAccountsResponse() && !this.ui.isStandalone()) this.publishWeb3RequestEvent(id, request);
        });
        return {
            promise,
            cancel
        };
    }
    watchAsset(type, address, symbol, decimals, image) {
        const request = {
            method: Web3Method_1.Web3Method.watchAsset,
            params: {
                type,
                options: {
                    address,
                    symbol,
                    decimals,
                    image
                }
            }
        };
        let hideSnackbarItem = null;
        const id = (0, util_1.randomBytesHex)(8);
        const cancel = ()=>{
            this.publishWeb3RequestCanceledEvent(id);
            this.handleWeb3ResponseMessage((0, Web3ResponseMessage_1.Web3ResponseMessage)({
                id,
                response: (0, Web3Response_1.ErrorResponse)(request.method, "User rejected request")
            }));
            hideSnackbarItem === null || hideSnackbarItem === void 0 || hideSnackbarItem();
        };
        if (!this.ui.inlineWatchAsset()) hideSnackbarItem = this.ui.showConnecting({
            isUnlinkedErrorState: this.isUnlinkedErrorState,
            onCancel: cancel,
            onResetConnection: this.resetAndReload // eslint-disable-line @typescript-eslint/unbound-method
        });
        const promise = new Promise((resolve, reject)=>{
            this.relayEventManager.callbacks.set(id, (response)=>{
                hideSnackbarItem === null || hideSnackbarItem === void 0 || hideSnackbarItem();
                if (response.errorMessage) return reject(new Error(response.errorMessage));
                resolve(response);
            });
            const _cancel = ()=>{
                this.handleWeb3ResponseMessage((0, Web3ResponseMessage_1.Web3ResponseMessage)({
                    id,
                    response: (0, Web3Response_1.WatchAssetReponse)(false)
                }));
            };
            const approve = ()=>{
                this.handleWeb3ResponseMessage((0, Web3ResponseMessage_1.Web3ResponseMessage)({
                    id,
                    response: (0, Web3Response_1.WatchAssetReponse)(true)
                }));
            };
            if (this.ui.inlineWatchAsset()) this.ui.watchAsset({
                onApprove: approve,
                onCancel: _cancel,
                type,
                address,
                symbol,
                decimals,
                image
            });
            if (!this.ui.inlineWatchAsset() && !this.ui.isStandalone()) this.publishWeb3RequestEvent(id, request);
        });
        return {
            cancel,
            promise
        };
    }
    addEthereumChain(chainId, rpcUrls, iconUrls, blockExplorerUrls, chainName, nativeCurrency) {
        let request = {
            method: Web3Method_1.Web3Method.addEthereumChain,
            params: {
                chainId,
                rpcUrls,
                blockExplorerUrls,
                chainName,
                iconUrls,
                nativeCurrency
            }
        };
        let hideSnackbarItem = null;
        const id = (0, util_1.randomBytesHex)(8);
        const cancel = ()=>{
            this.publishWeb3RequestCanceledEvent(id);
            this.handleWeb3ResponseMessage((0, Web3ResponseMessage_1.Web3ResponseMessage)({
                id,
                response: (0, Web3Response_1.ErrorResponse)(request.method, "User rejected request")
            }));
            hideSnackbarItem === null || hideSnackbarItem === void 0 || hideSnackbarItem();
        };
        if (!this.ui.inlineAddEthereumChain(chainId)) hideSnackbarItem = this.ui.showConnecting({
            isUnlinkedErrorState: this.isUnlinkedErrorState,
            onCancel: cancel,
            onResetConnection: this.resetAndReload // eslint-disable-line @typescript-eslint/unbound-method
        });
        const promise = new Promise((resolve, reject)=>{
            this.relayEventManager.callbacks.set(id, (response)=>{
                hideSnackbarItem === null || hideSnackbarItem === void 0 || hideSnackbarItem();
                if (response.errorMessage) return reject(new Error(response.errorMessage));
                resolve(response);
            });
            const _cancel = ()=>{
                this.handleWeb3ResponseMessage((0, Web3ResponseMessage_1.Web3ResponseMessage)({
                    id,
                    response: (0, Web3Response_1.AddEthereumChainResponse)({
                        isApproved: false,
                        rpcUrl: ""
                    })
                }));
            };
            const approve = (rpcUrl)=>{
                this.handleWeb3ResponseMessage((0, Web3ResponseMessage_1.Web3ResponseMessage)({
                    id,
                    response: (0, Web3Response_1.AddEthereumChainResponse)({
                        isApproved: true,
                        rpcUrl
                    })
                }));
            };
            if (this.ui.inlineAddEthereumChain(chainId)) this.ui.addEthereumChain({
                onCancel: _cancel,
                onApprove: approve,
                chainId: request.params.chainId,
                rpcUrls: request.params.rpcUrls,
                blockExplorerUrls: request.params.blockExplorerUrls,
                chainName: request.params.chainName,
                iconUrls: request.params.iconUrls,
                nativeCurrency: request.params.nativeCurrency
            });
            if (!this.ui.inlineAddEthereumChain(chainId) && !this.ui.isStandalone()) this.publishWeb3RequestEvent(id, request);
        });
        return {
            promise,
            cancel
        };
    }
    switchEthereumChain(chainId) {
        let request = {
            method: Web3Method_1.Web3Method.switchEthereumChain,
            params: {
                chainId
            }
        };
        let hideSnackbarItem = null;
        const id = (0, util_1.randomBytesHex)(8);
        const cancel = ()=>{
            this.publishWeb3RequestCanceledEvent(id);
            this.handleWeb3ResponseMessage((0, Web3ResponseMessage_1.Web3ResponseMessage)({
                id,
                response: (0, Web3Response_1.ErrorResponse)(request.method, "User rejected request")
            }));
            hideSnackbarItem === null || hideSnackbarItem === void 0 || hideSnackbarItem();
        };
        if (!this.ui.inlineSwitchEthereumChain()) hideSnackbarItem = this.ui.showConnecting({
            isUnlinkedErrorState: this.isUnlinkedErrorState,
            onCancel: cancel,
            onResetConnection: this.resetAndReload // eslint-disable-line @typescript-eslint/unbound-method
        });
        const promise = new Promise((resolve, reject)=>{
            this.relayEventManager.callbacks.set(id, (response)=>{
                hideSnackbarItem === null || hideSnackbarItem === void 0 || hideSnackbarItem();
                if (response.errorMessage && response.errorCode) return reject(eth_rpc_errors_1.ethErrors.provider.custom({
                    code: response.errorCode,
                    message: `Unrecognized chain ID. Try adding the chain using addEthereumChain first.`
                }));
                else if (response.errorMessage) return reject(new Error(response.errorMessage));
                resolve(response);
            });
            const _cancel = (errorCode)=>{
                if (errorCode) this.handleWeb3ResponseMessage((0, Web3ResponseMessage_1.Web3ResponseMessage)({
                    id,
                    response: (0, Web3Response_1.ErrorResponse)(Web3Method_1.Web3Method.switchEthereumChain, "unsupported chainId", errorCode)
                }));
                else this.handleWeb3ResponseMessage((0, Web3ResponseMessage_1.Web3ResponseMessage)({
                    id,
                    response: (0, Web3Response_1.SwitchEthereumChainResponse)({
                        isApproved: false,
                        rpcUrl: ""
                    })
                }));
            };
            const approve = (rpcUrl)=>{
                this.handleWeb3ResponseMessage((0, Web3ResponseMessage_1.Web3ResponseMessage)({
                    id,
                    response: (0, Web3Response_1.SwitchEthereumChainResponse)({
                        isApproved: true,
                        rpcUrl
                    })
                }));
            };
            this.ui.switchEthereumChain({
                onCancel: _cancel,
                onApprove: approve,
                chainId: request.params.chainId
            });
            if (!this.ui.inlineSwitchEthereumChain() && !this.ui.isStandalone()) this.publishWeb3RequestEvent(id, request);
        });
        return {
            promise,
            cancel
        };
    }
    getSessionIdHash() {
        return Session_1.Session.hash(this._session.id);
    }
    sendRequestStandalone(id, request) {
        const _cancel = ()=>{
            this.handleWeb3ResponseMessage((0, Web3ResponseMessage_1.Web3ResponseMessage)({
                id,
                response: (0, Web3Response_1.ErrorResponse)(request.method, "User rejected request")
            }));
        };
        const onSuccess = (response)=>{
            this.handleWeb3ResponseMessage((0, Web3ResponseMessage_1.Web3ResponseMessage)({
                id,
                response
            }));
        };
        switch(request.method){
            case Web3Method_1.Web3Method.signEthereumMessage:
                this.ui.signEthereumMessage({
                    request,
                    onSuccess,
                    onCancel: _cancel
                });
                break;
            case Web3Method_1.Web3Method.signEthereumTransaction:
                this.ui.signEthereumTransaction({
                    request,
                    onSuccess,
                    onCancel: _cancel
                });
                break;
            case Web3Method_1.Web3Method.submitEthereumTransaction:
                this.ui.submitEthereumTransaction({
                    request,
                    onSuccess,
                    onCancel: _cancel
                });
                break;
            case Web3Method_1.Web3Method.ethereumAddressFromSignedMessage:
                this.ui.ethereumAddressFromSignedMessage({
                    request,
                    onSuccess
                });
                break;
            default:
                _cancel();
                break;
        }
    }
}
WalletLinkRelay.accountRequestCallbackIds = new Set();
__decorate([
    bind_decorator_1.default
], WalletLinkRelay.prototype, "resetAndReload", null);
__decorate([
    bind_decorator_1.default
], WalletLinkRelay.prototype, "handleIncomingEvent", null);
exports.WalletLinkRelay = WalletLinkRelay;

},{"15d6d2e5faf61da0":"8ceve","bda984db4468de90":"9cATh","c4ea2dcfbb8f23b5":"gxhPq","12e0231d07e121f4":"ggrIi","3c356ed16f835532":"2871R","7700163124ffe243":"9fPaP","d927c2f668b02591":"eB23X","10c8e18bab69cde1":"9zvgH","884a6ded3d86837a":"5iTSS","4642af8d5c70b580":"isBWC","b00da9e1ed36347f":"djqpq","c397b4129a853dde":"jEEMW","5d1ab8c2e65e513f":"6q7Tw","cbc676cde1309902":"6zytr","a9065e1afdf35f6":"5WhAv","9a6fc3ce3871978b":"3d5iW"}],"8ceve":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
var constants;
(function(constants) {
    constants.typeOfFunction = "function";
    constants.boolTrue = true;
})(constants || (constants = {}));
function bind(target, propertyKey, descriptor) {
    if (!descriptor || typeof descriptor.value !== constants.typeOfFunction) throw new TypeError("Only methods can be decorated with @bind. <" + propertyKey + "> is not a method!");
    return {
        configurable: constants.boolTrue,
        get: function() {
            var bound = descriptor.value.bind(this);
            // Credits to https://github.com/andreypopp/autobind-decorator for memoizing the result of bind against a symbol on the instance.
            Object.defineProperty(this, propertyKey, {
                value: bound,
                configurable: constants.boolTrue,
                writable: constants.boolTrue
            });
            return bound;
        }
    };
}
exports.bind = bind;
exports.default = bind;

},{}],"9fPaP":[function(require,module,exports) {
"use strict";
// Copyright (c) 2018-2020 WalletLink.org <https://www.walletlink.org/>
// Copyright (c) 2018-2020 Coinbase, Inc. <https://www.coinbase.com/>
// Licensed under the Apache License, version 2.0
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.WalletLinkConnection = void 0;
const rxjs_1 = require("5c7e2acdf5af6e68");
const operators_1 = require("2b4b72e9f4754a1a");
const init_1 = require("75b6b8f528b66b00");
const Session_1 = require("eec7cc86d1724320");
const types_1 = require("bddf8fa5fbce8562");
const ClientMessage_1 = require("c7842567aaa11574");
const RxWebSocket_1 = require("eb5c8d594a6d73d2");
const ServerMessage_1 = require("e9ee7a98bbcb060f");
const HEARTBEAT_INTERVAL = 10000;
const REQUEST_TIMEOUT = 60000;
/**
 * WalletLink Connection
 */ class WalletLinkConnection {
    /**
     * Constructor
     * @param sessionId Session ID
     * @param sessionKey Session Key
     * @param serverUrl Walletlinkd RPC URL
     * @param [WebSocketClass] Custom WebSocket implementation
     */ constructor(sessionId, sessionKey, serverUrl, walletLinkAnalytics, WebSocketClass = WebSocket){
        this.sessionId = sessionId;
        this.sessionKey = sessionKey;
        this.subscriptions = new rxjs_1.Subscription();
        this.destroyed = false;
        this.lastHeartbeatResponse = 0;
        this.nextReqId = (0, types_1.IntNumber)(1);
        this.connectedSubject = new rxjs_1.BehaviorSubject(false);
        this.linkedSubject = new rxjs_1.BehaviorSubject(false);
        this.sessionConfigSubject = new rxjs_1.ReplaySubject(1);
        const ws = new RxWebSocket_1.RxWebSocket(serverUrl + "/rpc", WebSocketClass);
        this.ws = ws;
        this.walletLinkAnalytics = walletLinkAnalytics;
        // attempt to reconnect every 5 seconds when disconnected
        this.subscriptions.add(ws.connectionState$.pipe((0, operators_1.tap)((state)=>this.walletLinkAnalytics.sendEvent(init_1.EVENTS.CONNECTED_STATE_CHANGE, {
                state,
                sessionIdHash: Session_1.Session.hash(sessionId)
            })), // ignore initial DISCONNECTED state
        (0, operators_1.skip)(1), // if DISCONNECTED and not destroyed
        (0, operators_1.filter)((cs)=>cs === RxWebSocket_1.ConnectionState.DISCONNECTED && !this.destroyed), // wait 5 seconds
        (0, operators_1.delay)(5000), // check whether it's destroyed again
        (0, operators_1.filter)((_)=>!this.destroyed), // reconnect
        (0, operators_1.flatMap)((_)=>ws.connect()), (0, operators_1.retry)()).subscribe());
        // perform authentication upon connection
        this.subscriptions.add(ws.connectionState$.pipe(// ignore initial DISCONNECTED and CONNECTING states
        (0, operators_1.skip)(2), (0, operators_1.switchMap)((cs)=>(0, rxjs_1.iif)(()=>cs === RxWebSocket_1.ConnectionState.CONNECTED, // if CONNECTED, authenticate, and then check link status
            this.authenticate().pipe((0, operators_1.tap)((_)=>this.sendIsLinked()), (0, operators_1.tap)((_)=>this.sendGetSessionConfig()), (0, operators_1.map)((_)=>true)), // if not CONNECTED, emit false immediately
            (0, rxjs_1.of)(false))), (0, operators_1.distinctUntilChanged)(), (0, operators_1.catchError)((_)=>(0, rxjs_1.of)(false))).subscribe((connected)=>this.connectedSubject.next(connected)));
        // send heartbeat every n seconds while connected
        this.subscriptions.add(ws.connectionState$.pipe(// ignore initial DISCONNECTED state
        (0, operators_1.skip)(1), (0, operators_1.switchMap)((cs)=>(0, rxjs_1.iif)(()=>cs === RxWebSocket_1.ConnectionState.CONNECTED, // if CONNECTED, start the heartbeat timer
            (0, rxjs_1.timer)(0, HEARTBEAT_INTERVAL)))).subscribe((i)=>// first timer event updates lastHeartbeat timestamp
            // subsequent calls send heartbeat message
            i === 0 ? this.updateLastHeartbeat() : this.heartbeat()));
        // handle server's heartbeat responses
        this.subscriptions.add(ws.incomingData$.pipe((0, operators_1.filter)((m)=>m === "h")).subscribe((_)=>this.updateLastHeartbeat()));
        // handle link status updates
        this.subscriptions.add(ws.incomingJSONData$.pipe((0, operators_1.filter)((m)=>[
                "IsLinkedOK",
                "Linked"
            ].includes(m.type))).subscribe((m)=>{
            const msg = m;
            this.walletLinkAnalytics.sendEvent(init_1.EVENTS.LINKED, {
                sessionIdHash: Session_1.Session.hash(sessionId),
                linked: msg.linked,
                type: m.type,
                onlineGuests: msg.onlineGuests
            });
            this.linkedSubject.next(msg.linked || msg.onlineGuests > 0);
        }));
        // handle session config updates
        this.subscriptions.add(ws.incomingJSONData$.pipe((0, operators_1.filter)((m)=>[
                "GetSessionConfigOK",
                "SessionConfigUpdated"
            ].includes(m.type))).subscribe((m)=>{
            const msg = m;
            this.walletLinkAnalytics.sendEvent(init_1.EVENTS.SESSION_CONFIG_RECEIVED, {
                sessionIdHash: Session_1.Session.hash(sessionId),
                metadata_keys: msg && msg.metadata ? Object.keys(msg.metadata) : undefined
            });
            this.sessionConfigSubject.next({
                webhookId: msg.webhookId,
                webhookUrl: msg.webhookUrl,
                metadata: msg.metadata
            });
        }));
    }
    /**
     * Make a connection to the server
     */ connect() {
        if (this.destroyed) throw new Error("instance is destroyed");
        this.walletLinkAnalytics.sendEvent(init_1.EVENTS.STARTED_CONNECTING, {
            sessionIdHash: Session_1.Session.hash(this.sessionId)
        });
        this.ws.connect().subscribe();
    }
    /**
     * Terminate connection, and mark as destroyed. To reconnect, create a new
     * instance of WalletLinkConnection
     */ destroy() {
        this.subscriptions.unsubscribe();
        this.ws.disconnect();
        this.walletLinkAnalytics.sendEvent(init_1.EVENTS.DISCONNECTED, {
            sessionIdHash: Session_1.Session.hash(this.sessionId)
        });
        this.destroyed = true;
    }
    get isDestroyed() {
        return this.destroyed;
    }
    /**
     * Emit true if connected and authenticated, else false
     * @returns an Observable
     */ get connected$() {
        return this.connectedSubject.asObservable();
    }
    /**
     * Emit once connected
     * @returns an Observable
     */ get onceConnected$() {
        return this.connected$.pipe((0, operators_1.filter)((v)=>v), (0, operators_1.take)(1), (0, operators_1.map)(()=>void 0));
    }
    /**
     * Emit true if linked (a guest has joined before)
     * @returns an Observable
     */ get linked$() {
        return this.linkedSubject.asObservable();
    }
    /**
     * Emit once when linked
     * @returns an Observable
     */ get onceLinked$() {
        return this.linked$.pipe((0, operators_1.filter)((v)=>v), (0, operators_1.take)(1), (0, operators_1.map)(()=>void 0));
    }
    /**
     * Emit current session config if available, and subsequent updates
     * @returns an Observable for the session config
     */ get sessionConfig$() {
        return this.sessionConfigSubject.asObservable();
    }
    /**
     * Emit incoming Event messages
     * @returns an Observable for the messages
     */ get incomingEvent$() {
        return this.ws.incomingJSONData$.pipe((0, operators_1.filter)((m)=>{
            if (m.type !== "Event") return false;
            const sme = m;
            return typeof sme.sessionId === "string" && typeof sme.eventId === "string" && typeof sme.event === "string" && typeof sme.data === "string";
        }), (0, operators_1.map)((m)=>m));
    }
    /**
     * Set session metadata in SessionConfig object
     * @param key
     * @param value
     * @returns an Observable that completes when successful
     */ setSessionMetadata(key, value) {
        const message = (0, ClientMessage_1.ClientMessageSetSessionConfig)({
            id: (0, types_1.IntNumber)(this.nextReqId++),
            sessionId: this.sessionId,
            metadata: {
                [key]: value
            }
        });
        return this.onceConnected$.pipe((0, operators_1.flatMap)((_)=>this.makeRequest(message)), (0, operators_1.map)((res)=>{
            if ((0, ServerMessage_1.isServerMessageFail)(res)) throw new Error(res.error || "failed to set session metadata");
        }));
    }
    /**
     * Publish an event and emit event ID when successful
     * @param event event name
     * @param data event data
     * @param callWebhook whether the webhook should be invoked
     * @returns an Observable that emits event ID when successful
     */ publishEvent(event, data, callWebhook = false) {
        const message = (0, ClientMessage_1.ClientMessagePublishEvent)({
            id: (0, types_1.IntNumber)(this.nextReqId++),
            sessionId: this.sessionId,
            event,
            data,
            callWebhook
        });
        return this.onceLinked$.pipe((0, operators_1.flatMap)((_)=>this.makeRequest(message)), (0, operators_1.map)((res)=>{
            if ((0, ServerMessage_1.isServerMessageFail)(res)) throw new Error(res.error || "failed to publish event");
            return res.eventId;
        }));
    }
    sendData(message) {
        this.ws.sendData(JSON.stringify(message));
    }
    updateLastHeartbeat() {
        this.lastHeartbeatResponse = Date.now();
    }
    heartbeat() {
        if (Date.now() - this.lastHeartbeatResponse > HEARTBEAT_INTERVAL * 2) {
            this.ws.disconnect();
            return;
        }
        try {
            this.ws.sendData("h");
        } catch (_a) {}
    }
    makeRequest(message, timeout = REQUEST_TIMEOUT) {
        const reqId = message.id;
        try {
            this.sendData(message);
        } catch (err) {
            return (0, rxjs_1.throwError)(err);
        }
        // await server message with corresponding id
        return this.ws.incomingJSONData$.pipe((0, operators_1.timeoutWith)(timeout, (0, rxjs_1.throwError)(new Error(`request ${reqId} timed out`))), (0, operators_1.filter)((m)=>m.id === reqId), (0, operators_1.take)(1));
    }
    authenticate() {
        const msg = (0, ClientMessage_1.ClientMessageHostSession)({
            id: (0, types_1.IntNumber)(this.nextReqId++),
            sessionId: this.sessionId,
            sessionKey: this.sessionKey
        });
        return this.makeRequest(msg).pipe((0, operators_1.map)((res)=>{
            if ((0, ServerMessage_1.isServerMessageFail)(res)) throw new Error(res.error || "failed to authentcate");
        }));
    }
    sendIsLinked() {
        const msg = (0, ClientMessage_1.ClientMessageIsLinked)({
            id: (0, types_1.IntNumber)(this.nextReqId++),
            sessionId: this.sessionId
        });
        this.sendData(msg);
    }
    sendGetSessionConfig() {
        const msg = (0, ClientMessage_1.ClientMessageGetSessionConfig)({
            id: (0, types_1.IntNumber)(this.nextReqId++),
            sessionId: this.sessionId
        });
        this.sendData(msg);
    }
}
exports.WalletLinkConnection = WalletLinkConnection;

},{"5c7e2acdf5af6e68":"gxhPq","2b4b72e9f4754a1a":"ggrIi","75b6b8f528b66b00":"eB23X","eec7cc86d1724320":"isBWC","bddf8fa5fbce8562":"hGqkR","c7842567aaa11574":"fwaU4","eb5c8d594a6d73d2":"57AvH","e9ee7a98bbcb060f":"a5UqQ"}],"fwaU4":[function(require,module,exports) {
"use strict";
// Copyright (c) 2018-2020 WalletLink.org <https://www.walletlink.org/>
// Copyright (c) 2018-2020 Coinbase, Inc. <https://www.coinbase.com/>
// Licensed under the Apache License, version 2.0
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ClientMessagePublishEvent = exports.ClientMessageSetSessionConfig = exports.ClientMessageGetSessionConfig = exports.ClientMessageIsLinked = exports.ClientMessageHostSession = void 0;
function ClientMessageHostSession(params) {
    return Object.assign({
        type: "HostSession"
    }, params);
}
exports.ClientMessageHostSession = ClientMessageHostSession;
function ClientMessageIsLinked(params) {
    return Object.assign({
        type: "IsLinked"
    }, params);
}
exports.ClientMessageIsLinked = ClientMessageIsLinked;
function ClientMessageGetSessionConfig(params) {
    return Object.assign({
        type: "GetSessionConfig"
    }, params);
}
exports.ClientMessageGetSessionConfig = ClientMessageGetSessionConfig;
function ClientMessageSetSessionConfig(params) {
    return Object.assign({
        type: "SetSessionConfig"
    }, params);
}
exports.ClientMessageSetSessionConfig = ClientMessageSetSessionConfig;
function ClientMessagePublishEvent(params) {
    return Object.assign({
        type: "PublishEvent"
    }, params);
}
exports.ClientMessagePublishEvent = ClientMessagePublishEvent;

},{}],"57AvH":[function(require,module,exports) {
"use strict";
// Copyright (c) 2018-2020 WalletLink.org <https://www.walletlink.org/>
// Copyright (c) 2018-2020 Coinbase, Inc. <https://www.coinbase.com/>
// Licensed under the Apache License, version 2.0
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.RxWebSocket = exports.ConnectionState = void 0;
const rxjs_1 = require("9881d6bd7e2a250a");
const operators_1 = require("92a44be2a4dbba8e");
var ConnectionState;
(function(ConnectionState) {
    ConnectionState[ConnectionState["DISCONNECTED"] = 0] = "DISCONNECTED";
    ConnectionState[ConnectionState["CONNECTING"] = 1] = "CONNECTING";
    ConnectionState[ConnectionState["CONNECTED"] = 2] = "CONNECTED";
})(ConnectionState = exports.ConnectionState || (exports.ConnectionState = {}));
/**
 * Rx-ified WebSocket
 */ class RxWebSocket {
    /**
     * Constructor
     * @param url WebSocket server URL
     * @param [WebSocketClass] Custom WebSocket implementation
     */ constructor(url, WebSocketClass = WebSocket){
        this.WebSocketClass = WebSocketClass;
        this.webSocket = null;
        this.connectionStateSubject = new rxjs_1.BehaviorSubject(ConnectionState.DISCONNECTED);
        this.incomingDataSubject = new rxjs_1.Subject();
        this.url = url.replace(/^http/, "ws");
    }
    /**
     * Make a websocket connection
     * @returns an Observable that completes when connected
     */ connect() {
        if (this.webSocket) return (0, rxjs_1.throwError)(new Error("webSocket object is not null"));
        return new rxjs_1.Observable((obs)=>{
            let webSocket;
            try {
                this.webSocket = webSocket = new this.WebSocketClass(this.url);
            } catch (err) {
                obs.error(err);
                return;
            }
            this.connectionStateSubject.next(ConnectionState.CONNECTING);
            webSocket.onclose = (evt)=>{
                this.clearWebSocket();
                obs.error(new Error(`websocket error ${evt.code}: ${evt.reason}`));
                this.connectionStateSubject.next(ConnectionState.DISCONNECTED);
            };
            webSocket.onopen = (_)=>{
                obs.next();
                obs.complete();
                this.connectionStateSubject.next(ConnectionState.CONNECTED);
            };
            webSocket.onmessage = (evt)=>{
                this.incomingDataSubject.next(evt.data);
            };
        }).pipe((0, operators_1.take)(1));
    }
    /**
     * Disconnect from server
     */ disconnect() {
        const { webSocket } = this;
        if (!webSocket) return;
        this.clearWebSocket();
        this.connectionStateSubject.next(ConnectionState.DISCONNECTED);
        try {
            webSocket.close();
        } catch (_a) {}
    }
    /**
     * Emit current connection state and subsequent changes
     * @returns an Observable for the connection state
     */ get connectionState$() {
        return this.connectionStateSubject.asObservable();
    }
    /**
     * Emit incoming data from server
     * @returns an Observable for the data received
     */ get incomingData$() {
        return this.incomingDataSubject.asObservable();
    }
    /**
     * Emit incoming JSON data from server. non-JSON data are ignored
     * @returns an Observable for parsed JSON data
     */ get incomingJSONData$() {
        return this.incomingData$.pipe((0, operators_1.flatMap)((m)=>{
            let j;
            try {
                j = JSON.parse(m);
            } catch (err) {
                return (0, rxjs_1.empty)();
            }
            return (0, rxjs_1.of)(j);
        }));
    }
    /**
     * Send data to server
     * @param data text to send
     */ sendData(data) {
        const { webSocket } = this;
        if (!webSocket) throw new Error("websocket is not connected");
        webSocket.send(data);
    }
    clearWebSocket() {
        const { webSocket } = this;
        if (!webSocket) return;
        this.webSocket = null;
        webSocket.onclose = null;
        webSocket.onerror = null;
        webSocket.onmessage = null;
        webSocket.onopen = null;
    }
}
exports.RxWebSocket = RxWebSocket;

},{"9881d6bd7e2a250a":"gxhPq","92a44be2a4dbba8e":"ggrIi"}],"a5UqQ":[function(require,module,exports) {
"use strict";
// Copyright (c) 2018-2020 WalletLink.org <https://www.walletlink.org/>
// Copyright (c) 2018-2020 Coinbase, Inc. <https://www.coinbase.com/>
// Licensed under the Apache License, version 2.0
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.isServerMessageFail = void 0;
function isServerMessageFail(msg) {
    return msg && msg.type === "Fail" && typeof msg.id === "number" && typeof msg.sessionId === "string" && typeof msg.error === "string";
}
exports.isServerMessageFail = isServerMessageFail;

},{}],"5iTSS":[function(require,module,exports) {
"use strict";
// Copyright (c) 2018-2020 WalletLink.org <https://www.walletlink.org/>
// Copyright (c) 2018-2020 Coinbase, Inc. <https://www.coinbase.com/>
// Licensed under the Apache License, version 2.0
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.decrypt = exports.encrypt = void 0;
const rxjs_1 = require("5e30235807c766e");
const util_1 = require("4ec33c9b911bfd66");
/**
 *
 * @param plainText string to be encrypted
 * @param secret hex representation of 32-byte secret
 * returns hex string representation of bytes in the order: initialization vector (iv),
 * auth tag, encrypted plaintext. IV is 12 bytes. Auth tag is 16 bytes. Remaining bytes are the
 * encrypted plainText.
 */ async function encrypt(plainText, secret) {
    if (secret.length !== 64) throw Error(`secret must be 256 bits`);
    const ivBytes = crypto.getRandomValues(new Uint8Array(12));
    const secretKey = await crypto.subtle.importKey("raw", (0, util_1.hexStringToUint8Array)(secret), {
        "name": "aes-gcm"
    }, false, [
        "encrypt",
        "decrypt"
    ]);
    const enc = new TextEncoder();
    // Will return encrypted plainText with auth tag (ie MAC or checksum) appended at the end
    const encryptedResult = await window.crypto.subtle.encrypt({
        name: "AES-GCM",
        iv: ivBytes
    }, secretKey, enc.encode(plainText));
    const tagLength = 16;
    const authTag = encryptedResult.slice(encryptedResult.byteLength - tagLength);
    const encryptedPlaintext = encryptedResult.slice(0, encryptedResult.byteLength - tagLength);
    const authTagBytes = new Uint8Array(authTag);
    const encryptedPlaintextBytes = new Uint8Array(encryptedPlaintext);
    const concatted = new Uint8Array([
        ...ivBytes,
        ...authTagBytes,
        ...encryptedPlaintextBytes
    ]);
    return (0, util_1.uint8ArrayToHex)(concatted);
}
exports.encrypt = encrypt;
/**
 *
 * @param cipherText hex string representation of bytes in the order: initialization vector (iv),
 * auth tag, encrypted plaintext. IV is 12 bytes. Auth tag is 16 bytes.
 * @param secret hex string representation of 32-byte secret
 */ function decrypt(cipherText, secret) {
    if (secret.length !== 64) throw Error(`secret must be 256 bits`);
    return new rxjs_1.Observable((subscriber)=>{
        (async function() {
            const secretKey = await crypto.subtle.importKey("raw", (0, util_1.hexStringToUint8Array)(secret), {
                "name": "aes-gcm"
            }, false, [
                "encrypt",
                "decrypt"
            ]);
            const encrypted = (0, util_1.hexStringToUint8Array)(cipherText);
            const ivBytes = encrypted.slice(0, 12);
            const authTagBytes = encrypted.slice(12, 28);
            const encryptedPlaintextBytes = encrypted.slice(28);
            const concattedBytes = new Uint8Array([
                ...encryptedPlaintextBytes,
                ...authTagBytes
            ]);
            const algo = {
                name: "AES-GCM",
                iv: new Uint8Array(ivBytes)
            };
            try {
                const decrypted = await window.crypto.subtle.decrypt(algo, secretKey, concattedBytes);
                const decoder = new TextDecoder();
                subscriber.next(decoder.decode(decrypted));
                subscriber.complete();
            } catch (err) {
                subscriber.error(err);
            }
        })();
    });
}
exports.decrypt = decrypt;

},{"5e30235807c766e":"gxhPq","4ec33c9b911bfd66":"9zvgH"}],"jEEMW":[function(require,module,exports) {
"use strict";
// Copyright (c) 2018-2020 WalletLink.org <https://www.walletlink.org/>
// Copyright (c) 2018-2020 Coinbase, Inc. <https://www.coinbase.com/>
// Licensed under the Apache License, version 2.0
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Web3Method = void 0;
var Web3Method;
(function(Web3Method) {
    Web3Method["requestEthereumAccounts"] = "requestEthereumAccounts";
    Web3Method["signEthereumMessage"] = "signEthereumMessage";
    Web3Method["signEthereumTransaction"] = "signEthereumTransaction";
    Web3Method["submitEthereumTransaction"] = "submitEthereumTransaction";
    Web3Method["ethereumAddressFromSignedMessage"] = "ethereumAddressFromSignedMessage";
    Web3Method["scanQRCode"] = "scanQRCode";
    Web3Method["generic"] = "generic";
    Web3Method["childRequestEthereumAccounts"] = "childRequestEthereumAccounts";
    Web3Method["addEthereumChain"] = "addEthereumChain";
    Web3Method["switchEthereumChain"] = "switchEthereumChain";
    Web3Method["makeEthereumJSONRPCRequest"] = "makeEthereumJSONRPCRequest";
    Web3Method["watchAsset"] = "watchAsset";
})(Web3Method = exports.Web3Method || (exports.Web3Method = {}));

},{}],"6q7Tw":[function(require,module,exports) {
"use strict";
// Copyright (c) 2018-2020 WalletLink.org <https://www.walletlink.org/>
// Copyright (c) 2018-2020 Coinbase, Inc. <https://www.coinbase.com/>
// Licensed under the Apache License, version 2.0
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Web3RequestCanceledMessage = void 0;
const RelayMessage_1 = require("c04dfe72e2b06dff");
function Web3RequestCanceledMessage(id) {
    return {
        type: RelayMessage_1.RelayMessageType.WEB3_REQUEST_CANCELED,
        id
    };
}
exports.Web3RequestCanceledMessage = Web3RequestCanceledMessage;

},{"c04dfe72e2b06dff":"8wBJq"}],"8wBJq":[function(require,module,exports) {
"use strict";
// Copyright (c) 2018-2020 WalletLink.org <https://www.walletlink.org/>
// Copyright (c) 2018-2020 Coinbase, Inc. <https://www.coinbase.com/>
// Licensed under the Apache License, version 2.0
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.RelayMessageType = void 0;
var RelayMessageType;
(function(RelayMessageType) {
    RelayMessageType["SESSION_ID_REQUEST"] = "SESSION_ID_REQUEST";
    RelayMessageType["SESSION_ID_RESPONSE"] = "SESSION_ID_RESPONSE";
    RelayMessageType["LINKED"] = "LINKED";
    RelayMessageType["UNLINKED"] = "UNLINKED";
    RelayMessageType["WEB3_REQUEST"] = "WEB3_REQUEST";
    RelayMessageType["WEB3_REQUEST_CANCELED"] = "WEB3_REQUEST_CANCELED";
    RelayMessageType["WEB3_RESPONSE"] = "WEB3_RESPONSE";
})(RelayMessageType = exports.RelayMessageType || (exports.RelayMessageType = {}));

},{}],"6zytr":[function(require,module,exports) {
"use strict";
// Copyright (c) 2018-2020 WalletLink.org <https://www.walletlink.org/>
// Copyright (c) 2018-2020 Coinbase, Inc. <https://www.coinbase.com/>
// Licensed under the Apache License, version 2.0
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Web3RequestMessage = void 0;
const RelayMessage_1 = require("82678d839934eca9");
function Web3RequestMessage(params) {
    return Object.assign({
        type: RelayMessage_1.RelayMessageType.WEB3_REQUEST
    }, params);
}
exports.Web3RequestMessage = Web3RequestMessage;

},{"82678d839934eca9":"8wBJq"}],"5WhAv":[function(require,module,exports) {
"use strict";
// Copyright (c) 2018-2020 WalletLink.org <https://www.walletlink.org/>
// Copyright (c) 2018-2020 Coinbase, Inc. <https://www.coinbase.com/>
// Licensed under the Apache License, version 2.0
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.EthereumAddressFromSignedMessageResponse = exports.SubmitEthereumTransactionResponse = exports.SignEthereumTransactionResponse = exports.SignEthereumMessageResponse = exports.isRequestEthereumAccountsResponse = exports.WatchAssetReponse = exports.RequestEthereumAccountsResponse = exports.SwitchEthereumChainResponse = exports.AddEthereumChainResponse = exports.ErrorResponse = void 0;
const Web3Method_1 = require("88405a39b5a368f5");
function ErrorResponse(method, errorMessage, errorCode) {
    return {
        method,
        errorMessage,
        errorCode
    };
}
exports.ErrorResponse = ErrorResponse;
function AddEthereumChainResponse(addResponse) {
    return {
        method: Web3Method_1.Web3Method.addEthereumChain,
        result: addResponse
    };
}
exports.AddEthereumChainResponse = AddEthereumChainResponse;
function SwitchEthereumChainResponse(switchResponse) {
    return {
        method: Web3Method_1.Web3Method.switchEthereumChain,
        result: switchResponse
    };
}
exports.SwitchEthereumChainResponse = SwitchEthereumChainResponse;
function RequestEthereumAccountsResponse(addresses) {
    return {
        method: Web3Method_1.Web3Method.requestEthereumAccounts,
        result: addresses
    };
}
exports.RequestEthereumAccountsResponse = RequestEthereumAccountsResponse;
function WatchAssetReponse(success) {
    return {
        method: Web3Method_1.Web3Method.watchAsset,
        result: success
    };
}
exports.WatchAssetReponse = WatchAssetReponse;
function isRequestEthereumAccountsResponse(res) {
    return res && res.method === Web3Method_1.Web3Method.requestEthereumAccounts;
}
exports.isRequestEthereumAccountsResponse = isRequestEthereumAccountsResponse;
function SignEthereumMessageResponse(signature) {
    return {
        method: Web3Method_1.Web3Method.signEthereumMessage,
        result: signature
    };
}
exports.SignEthereumMessageResponse = SignEthereumMessageResponse;
function SignEthereumTransactionResponse(signedData) {
    return {
        method: Web3Method_1.Web3Method.signEthereumTransaction,
        result: signedData
    };
}
exports.SignEthereumTransactionResponse = SignEthereumTransactionResponse;
function SubmitEthereumTransactionResponse(txHash) {
    return {
        method: Web3Method_1.Web3Method.submitEthereumTransaction,
        result: txHash
    };
}
exports.SubmitEthereumTransactionResponse = SubmitEthereumTransactionResponse;
function EthereumAddressFromSignedMessageResponse(address) {
    return {
        method: Web3Method_1.Web3Method.ethereumAddressFromSignedMessage,
        result: address
    };
}
exports.EthereumAddressFromSignedMessageResponse = EthereumAddressFromSignedMessageResponse;

},{"88405a39b5a368f5":"jEEMW"}],"3d5iW":[function(require,module,exports) {
"use strict";
// Copyright (c) 2018-2020 WalletLink.org <https://www.walletlink.org/>
// Copyright (c) 2018-2020 Coinbase, Inc. <https://www.coinbase.com/>
// Licensed under the Apache License, version 2.0
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.isWeb3ResponseMessage = exports.Web3ResponseMessage = void 0;
const RelayMessage_1 = require("d915ccacd883818f");
function Web3ResponseMessage(params) {
    return Object.assign({
        type: RelayMessage_1.RelayMessageType.WEB3_RESPONSE
    }, params);
}
exports.Web3ResponseMessage = Web3ResponseMessage;
function isWeb3ResponseMessage(msg) {
    return msg && msg.type === RelayMessage_1.RelayMessageType.WEB3_RESPONSE;
}
exports.isWeb3ResponseMessage = isWeb3ResponseMessage;

},{"d915ccacd883818f":"8wBJq"}],"fqvtu":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.WalletLinkRelayEventManager = void 0;
const util_1 = require("66cacc484b03f1c3");
class WalletLinkRelayEventManager {
    constructor(){
        this._nextRequestId = 0;
        this.callbacks = new Map();
    }
    makeRequestId() {
        // max nextId == max int32 for compatibility with mobile
        this._nextRequestId = (this._nextRequestId + 1) % 0x7fffffff;
        const id = this._nextRequestId;
        const idStr = (0, util_1.prepend0x)(id.toString(16));
        // unlikely that this will ever be an issue, but just to be safe
        const callback = this.callbacks.get(idStr);
        if (callback) this.callbacks.delete(idStr);
        return id;
    }
}
exports.WalletLinkRelayEventManager = WalletLinkRelayEventManager;

},{"66cacc484b03f1c3":"9zvgH"}],"gQCRm":[function(require,module,exports) {
module.exports = JSON.parse('{"name":"walletlink","version":"2.5.0","description":"WalletLink JavaScript SDK","keywords":["cipher","cipherbrowser","coinbase","coinbasewallet","eth","ether","ethereum","etherium","injection","toshi","wallet","walletlink","web3"],"main":"dist/index.js","types":"dist/index.d.ts","repository":"https://github.com/walletlink/walletlink.git","author":"Coinbase, Inc.","license":"Apache-2.0","scripts":{"tsc":"tsc --noEmit --pretty","test":"yarn build-npm && karma start","prebuild":"node -p \\"\'export const LIB_VERSION = \' + JSON.stringify(require(\'./package.json\').version) + \';\'\\" > src/version.ts","build":"node compile-assets.js && webpack --config webpack.config.js","build-chrome":"webpack --config webpack.config.chrome.js","build-npm":"tsc -p ./tsconfig.build.json","build:dev":"export WALLETLINK_URL=\'http://localhost:3000\'; yarn build && yarn build-chrome","build:dev:watch":"nodemon -e \'ts,tsx,js,json,css,scss,svg\' --ignore \'src/**/*-css.ts\' --ignore \'src/**/*-svg.ts\' --watch src/ --watch chrome/ --exec \'yarn build:dev\'","build:prod":"yarn prebuild && yarn build && yarn build-chrome && yarn build-npm && cp ./package.json ./README.md ./LICENSE build/npm && cp -a src/vendor-js build/npm/dist && sed -i.bak \'s|  \\"private\\": true,||g\' build/npm/package.json && rm -f build/npm/package.json.bak","lint":"eslint ./src --ext .ts,.tsx","lint:watch":"nodemon -e ts,tsx,js,json,css,scss,svg --watch src/ --exec \'yarn tsc && yarn lint\'"},"dependencies":{"@metamask/safe-event-emitter":"2.0.0","bind-decorator":"^1.0.11","bn.js":"^5.1.1","clsx":"^1.1.0","eth-block-tracker":"4.4.3","eth-json-rpc-filters":"4.2.2","eth-rpc-errors":"4.0.2","js-sha256":"0.9.0","json-rpc-engine":"6.1.0","keccak":"^3.0.1","preact":"^10.5.9","rxjs":"^6.6.3","stream-browserify":"^3.0.0"},"devDependencies":{"@types/bn.js":"^4.11.6","@types/node":"^14.14.20","@typescript-eslint/eslint-plugin":"^5.7.0","@typescript-eslint/eslint-plugin-tslint":"^5.7.0","@typescript-eslint/parser":"^5.7.0","browserify":"17.0.0","copy-webpack-plugin":"^6.4.1","core-js":"^3.8.2","eslint":"^8.4.1","eslint-config-prettier":"^8.3.0","eslint-plugin-import":"^2.25.3","eslint-plugin-preact":"^0.1.0","eslint-plugin-prettier":"^4.0.0","eslint-plugin-simple-import-sort":"^7.0.0","jasmine":"3.8.0","karma":"^6.3.15","karma-browserify":"8.1.0","karma-chrome-launcher":"^3.1.0","karma-jasmine":"^4.0.1","nodemon":"^2.0.6","prettier":"^2.5.1","raw-loader":"^4.0.2","regenerator-runtime":"^0.13.7","sass":"^1.32.0","svgo":"^2.8.0","ts-jest":"^26.4.4","ts-loader":"^8.0.13","tslib":"^2.0.3","typescript":"^4.1.3","watchify":"4.0.0","webpack":"^5.49.0","webpack-cli":"^3.3.12","whatwg-fetch":"^3.5.0"},"engines":{"node":">= 10.0.0"},"jest":{"transform":{"^.+\\\\.tsx?$":"ts-jest"},"testEnvironment":"node","testPathIgnorePatterns":["<rootDir>/dist/","<rootDir>/node_modules/"],"testRegex":"(/__tests__/.*|\\\\.(test|spec))\\\\.(ts|tsx|js)$","moduleFileExtensions":["ts","js","json"]}}');

},{}],"7DBr2":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _loader = require("./Loader");
var _loaderDefault = parcelHelpers.interopDefault(_loader);
var _styles = require("./styles");
const SIcon = (0, _styledComponentsDefault.default).div`
  position: absolute;
  height: 15px;
  width: 15px;
  margin: 0 8px;
  top: calc((100% - 15px) / 2);
`;
const SHoverLayer = (0, _styledComponentsDefault.default).div`
  transition: ${(0, _styles.transitions).button};
  position: absolute;
  height: 100%;
  width: 100%;
  background-color: rgb(${(0, _styles.colors).white}, 0.1);
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  pointer-events: none;
  opacity: 0;
  visibility: hidden;
`;
const SButton = (0, _styledComponentsDefault.default).button`
  transition: ${(0, _styles.transitions).button};
  position: relative;
  border: none;
  border-style: none;
  box-sizing: border-box;
  background-color: ${({ outline, color })=>outline ? "transparent" : `rgb(${(0, _styles.colors)[color]})`};
  border: ${({ outline, color })=>outline ? `1px solid rgb(${(0, _styles.colors)[color]})` : "none"};
  color: ${({ outline, color })=>outline ? `rgb(${(0, _styles.colors)[color]})` : `rgb(${(0, _styles.colors).white})`};
  box-shadow: ${({ outline })=>outline ? "none" : `${(0, _styles.shadows).soft}`};
  border-radius: 8px;
  font-size: ${(0, _styles.fonts).size.medium};
  font-weight: ${(0, _styles.fonts).weight.semibold};
  padding: ${({ icon, left })=>icon ? left ? "7px 12px 8px 28px" : "7px 28px 8px 12px" : "8px 12px"};
  cursor: ${({ disabled })=>disabled ? "auto" : "pointer"};
  will-change: transform;

  &:disabled {
    opacity: 0.6;
    box-shadow: ${({ outline })=>outline ? "none" : `${(0, _styles.shadows).soft}`};
  }

  @media (hover: hover) {
    &:hover {
      transform: ${({ disabled })=>!disabled ? "translateY(-1px)" : "none"};
      box-shadow: ${({ disabled, outline })=>!disabled ? outline ? "none" : `${(0, _styles.shadows).hover}` : `${(0, _styles.shadows).soft}`};
    }

    &:hover ${SHoverLayer} {
      opacity: 1;
      visibility: visible;
    }
  }

  &:active {
    transform: ${({ disabled })=>!disabled ? "translateY(1px)" : "none"};
    box-shadow: ${({ outline })=>outline ? "none" : `${(0, _styles.shadows).soft}`};
    color: ${({ outline, color })=>outline ? `rgb(${(0, _styles.colors)[color]})` : `rgba(${(0, _styles.colors).white}, 0.24)`};

    & ${SIcon} {
      opacity: 0.8;
    }
  }

  & ${SIcon} {
    right: ${({ left })=>left ? "auto" : "0"};
    left: ${({ left })=>left ? "0" : "auto"};
    display: ${({ icon })=>icon ? "block" : "none"};
    mask: ${({ icon })=>icon ? `url(${icon}) center no-repeat` : "none"};
    background-color: ${({ outline, color })=>outline ? `rgb(${(0, _styles.colors)[color]})` : `rgb(${(0, _styles.colors).white})`};
    transition: 0.15s ease;
  }
`;
const Button = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)(SButton, {
        ...props,
        type: props.type,
        outline: props.outline,
        color: props.color,
        disabled: props.disabled,
        icon: props.icon,
        left: props.left,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(SHoverLayer, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(SIcon, {}),
            props.fetching ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _loaderDefault.default), {
                size: 20,
                color: "white"
            }) : props.children
        ]
    });
Button.defaultProps = {
    fetching: false,
    outline: false,
    type: "button",
    color: "lightBlue",
    disabled: false,
    icon: null,
    left: false
};
exports.default = Button;

},{"react/jsx-runtime":"gaGEj","react":"6uln9","styled-components":"byVI1","./Loader":"iL7xa","./styles":"iCPVY","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"iL7xa":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _propTypes = require("prop-types");
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _styles = require("./styles");
const load = (0, _styledComponents.keyframes)`
  0% {
    transform: scale(1.0);
  }
  5% {
    transform: scale(1.0);
  }
  50% {
    transform: scale(0.8);
  }
  95% {
    transform: scale(1.0);
  }
  100% {
    transform: scale(1.0);
  }
`;
const SLoader = (0, _styledComponentsDefault.default).svg`
  width: ${({ size })=>`${size}px`};
  height: ${({ size })=>`${size}px`};
  animation: ${load} 1s infinite cubic-bezier(0.25, 0, 0.75, 1);
  transform: translateZ(0);
`;
const Loader = (props)=>{
    const { size, color } = props;
    const rgb = `rgb(${(0, _styles.colors)[color]})`;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(SLoader, {
        viewBox: "0 0 186 187",
        size: size,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    d: "M60,10.34375 C32.3857625,10.34375 10,32.7295125 10,60.34375 L10,126.34375 C10,153.957987 32.3857625,176.34375 60,176.34375 L126,176.34375 C153.614237,176.34375 176,153.957987 176,126.34375 L176,60.34375 C176,32.7295125 153.614237,10.34375 126,10.34375 L60,10.34375 Z M60,0.34375 L126,0.34375 C159.137085,0.34375 186,27.206665 186,60.34375 L186,126.34375 C186,159.480835 159.137085,186.34375 126,186.34375 L60,186.34375 C26.862915,186.34375 0,159.480835 0,126.34375 L0,60.34375 C0,27.206665 26.862915,0.34375 60,0.34375 Z",
                    id: "Rectangle-Copy",
                    fill: rgb,
                    fillRule: "nonzero"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                    id: "Rectangle",
                    fill: rgb,
                    x: "44",
                    y: "44.34375",
                    width: "98",
                    height: "98",
                    rx: "35"
                })
            ]
        })
    });
};
Loader.propTypes = {
    size: _propTypes.number,
    color: _propTypes.string
};
Loader.defaultProps = {
    size: 40,
    color: "lightBlue"
};
exports.default = Loader;

},{"react/jsx-runtime":"gaGEj","react":"6uln9","prop-types":"6FKs7","styled-components":"byVI1","./styles":"iCPVY","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"iCPVY":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "colors", ()=>colors);
parcelHelpers.export(exports, "fonts", ()=>fonts);
parcelHelpers.export(exports, "transitions", ()=>transitions);
parcelHelpers.export(exports, "shadows", ()=>shadows);
parcelHelpers.export(exports, "responsive", ()=>responsive);
parcelHelpers.export(exports, "globalStyle", ()=>globalStyle);
const colors = {
    white: "255, 255, 255",
    black: "0, 0, 0",
    dark: "0, 0, 0",
    grey: "169, 169, 188",
    darkGrey: "113, 119, 138",
    lightGrey: "212, 212, 212, .50",
    blue: "101, 127, 230",
    lightBlue: "64, 153, 255",
    yellow: "250, 188, 45",
    orange: "246, 133, 27",
    green: "84, 209, 146",
    pink: "255, 51, 102",
    red: "214, 75, 71",
    purple: "110, 107, 233"
};
const fonts = {
    size: {
        tiny: "10px",
        small: "14px",
        medium: "16px",
        large: "18px",
        h1: "60px",
        h2: "50px",
        h3: "40px",
        h4: "32px",
        h5: "24px",
        h6: "20px"
    },
    weight: {
        normal: 400,
        medium: 500,
        semibold: 600,
        bold: 700,
        extrabold: 800
    },
    family: {
        OpenSans: '"Open Sans", sans-serif',
        Oswald: "oswald-extralight,oswald,sans-serif",
        Montserrat: "Montserrat",
        Helvetica: "Helvetica"
    }
};
const transitions = {
    short: "all 0.1s ease-in-out",
    base: "all 0.2s ease-in-out",
    long: "all 0.3s ease-in-out",
    button: "all 0.15s ease-in-out"
};
const shadows = {
    soft: "0 4px 6px 0 rgba(50, 50, 93, 0.11), 0 1px 3px 0 rgba(0, 0, 0, 0.08), inset 0 0 1px 0 rgba(0, 0, 0, 0.06)",
    medium: "0 3px 6px 0 rgba(0, 0, 0, 0.06), 0 0 1px 0 rgba(50, 50, 93, 0.02), 0 5px 10px 0 rgba(59, 59, 92, 0.08)",
    big: "0 15px 35px 0 rgba(50, 50, 93, 0.06), 0 5px 15px 0 rgba(50, 50, 93, 0.15)",
    hover: "0 7px 14px 0 rgba(50, 50, 93, 0.1), 0 3px 6px 0 rgba(0, 0, 0, 0.08), inset 0 0 1px 0 rgba(0, 0, 0, 0.06)"
};
const responsive = {
    xs: {
        min: "min-width: 467px",
        max: "max-width: 468px"
    },
    sm: {
        min: "min-width: 639px",
        max: "max-width: 640px"
    },
    md: {
        min: "min-width: 959px",
        max: "max-width: 960px"
    },
    lg: {
        min: "min-width: 1023px",
        max: "max-width: 1024px"
    },
    xl: {
        min: "min-width: 1399px",
        max: "max-width: 1400px"
    }
};
const globalStyle = `
  @import url('https://fonts.googleapis.com/css?family=${fonts.family.Helvetica}');

  html, body, #root {
    height: 100%;
    width: 100%;
    margin: 0;
    padding: 0;
  }

  body {
    font-family: ${fonts.family.Helvetica};
    font-style: normal;
    font-stretch: normal;
    font-weight: ${fonts.weight.normal};
    font-size: ${fonts.size.medium};
    background-color: #050A17;
    color: rgb(${colors.white});
    overflow-y:auto;
    text-rendering: optimizeLegibility;
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  	-webkit-text-size-adjust: 100%;
    -webkit-overflow-scrolling: touch;
    -ms-text-size-adjust: 100%;
    -webkit-text-size-adjust: 100%;  
  }

  button {
    border-style: none;
    line-height: 1em;
    background-image: none;
    outline: 0;
    -webkit-box-shadow: none;
            box-shadow: none;
  }

  [tabindex] {
    outline: none;
    width: 100%;
    height: 100%;
  }

  a, p, h1, h2, h3, h4, h5, h6 {
  	text-decoration: none;
  	margin: 0;
    padding: 0;
    margin: 0.7em 0;
  }

  h1 {
    font-size: ${fonts.size.h1}
  }
  h2 {
    font-size: ${fonts.size.h2}
  }
  h3 {
    font-size: ${fonts.size.h3}
  }
  h4 {
    font-size: ${fonts.size.h4}
  }
  h5 {
    font-size: ${fonts.size.h5}
  }
  h6 {
    font-size: ${fonts.size.h6}
  }

  a {
    background-color: transparent;
    -webkit-text-decoration-skip: objects;  
    text-decoration: none;
    color: inherit;
    outline: none;
  }

  b,
  strong {
    font-weight: inherit;
    font-weight: bolder;
  }

  ul, li {
  	list-style: none;
  	margin: 0;
  	padding: 0;
  }

  * {
    box-sizing: border-box !important;
  }


  input {
    -webkit-appearance: none;
  }

  article,
  aside,
  details,
  figcaption,
  figure,
  footer,
  header,
  main,
  menu,
  nav,
  section,
  summary {
    display: block;
  }
  audio,
  canvas,
  progress,
  video {
    display: inline-block;
  }

  input[type="color"],
  input[type="date"],
  input[type="datetime"],
  input[type="datetime-local"],
  input[type="email"],
  input[type="month"],
  input[type="number"],
  input[type="password"],
  input[type="search"],
  input[type="tel"],
  input[type="text"],
  input[type="time"],
  input[type="url"],
  input[type="week"],
  select:focus,
  textarea {
    font-size: 16px;
  }
`;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"cDB44":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _propTypes = require("prop-types");
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
const SColumn = (0, _styledComponentsDefault.default).div`
  position: relative;
  width: 100%;
  height: ${({ spanHeight })=>spanHeight ? "100%" : "auto"};
  max-width: ${({ maxWidth })=>`${maxWidth}px`};
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: ${({ center })=>center ? "center" : "flex-start"};
`;
const Column = (props)=>{
    const { children, spanHeight, maxWidth, center } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(SColumn, {
        ...props,
        spanHeight: spanHeight,
        maxWidth: maxWidth,
        center: center,
        children: children
    });
};
Column.propTypes = {
    children: _propTypes.node.isRequired,
    spanHeight: _propTypes.bool,
    maxWidth: _propTypes.number,
    center: _propTypes.bool
};
Column.defaultProps = {
    spanHeight: false,
    maxWidth: 600,
    center: false
};
exports.default = Column;

},{"react/jsx-runtime":"gaGEj","react":"6uln9","prop-types":"6FKs7","styled-components":"byVI1","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2ZHss":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _propTypes = require("prop-types");
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
const fadeIn = (0, _styledComponents.keyframes)`
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
`;
const SWrapper = (0, _styledComponentsDefault.default).div`
  will-change: transform, opacity;
  animation: ${fadeIn} 0.7s ease 0s normal 1;
  min-height: 200px;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: ${({ center })=>center ? `center` : `flex-start`};
`;
const Wrapper = (props)=>{
    const { children, center } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(SWrapper, {
        ...props,
        center: center,
        children: children
    });
};
Wrapper.propTypes = {
    children: _propTypes.node.isRequired,
    center: _propTypes.bool
};
Wrapper.defaultProps = {
    center: false
};
exports.default = Wrapper;

},{"react/jsx-runtime":"gaGEj","react":"6uln9","prop-types":"6FKs7","styled-components":"byVI1","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"ijSqB":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _propTypes = require("prop-types");
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _styles = require("./styles");
const SLightbox = (0, _styledComponentsDefault.default).div`
  transition: opacity 0.1s ease-in-out;
  text-align: center;
  position: fixed;
  width: 100vw;
  height: 100vh;
  margin-left: -50vw;
  top: ${({ offset })=>offset ? `-${offset}px` : 0};
  left: 50%;
  z-index: 2;
  will-change: opacity;
  background-color: ${({ opacity })=>{
    let alpha = 0.4;
    if (typeof opacity === "number") alpha = opacity;
    return `rgba(255, 255, 255, .85)`;
}};
  opacity: ${({ show })=>show ? 1 : 0};
  visibility: ${({ show })=>show ? "visible" : "hidden"};
  pointer-events: ${({ show })=>show ? "auto" : "none"};
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: 'Indie Flower', cursive;
  font-size: 40px;
`;
const SModalContainer = (0, _styledComponentsDefault.default).div`
  position: relative;
  width: 100%;
  height: 100%;
  padding: 15px;
  display: flex;
  align-items: center;
  justify-content: center;

`;
const SHitbox = (0, _styledComponentsDefault.default).div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;

`;
const SCloseButton = (0, _styledComponentsDefault.default).div`
  transition: ${(0, _styles.transitions).short};
  position: absolute;
  width: ${({ size })=>`${size}px`};
  height: ${({ size })=>`${size}px`};
  right: ${({ size })=>`${size / 1.6667}px`};
  top: ${({ size })=>`${size / 1.6667}px`};
  opacity: 0.5;
  cursor: pointer;
  &:hover {
    opacity: 1;
  }
  &:before,
  &:after {
    position: absolute;
    content: " ";
    height: ${({ size })=>`${size}px`};
    width: 2px;
    background: ${({ color })=>`rgb(${(0, _styles.colors)[color]})`};
  }
  &:before {
    transform: rotate(45deg);
  }
  &:after {
    transform: rotate(-45deg);
  }
`;
const SCard = (0, _styledComponentsDefault.default).div`
  position: relative;
  width: 100%;
  max-width: 500px;
  padding: 25px;
  border-radius: 6px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;
const BModal = (0, _styledComponentsDefault.default).div`
background-color: #e8e8e8;
position: relative;
width: 100%;
max-width: 500px;
padding: 25px;
border-radius: 20px;
border: 2px solid #111111;
display: flex;
flex-direction: column;
justify-content: center;
align-items: center;

`;
const SModalContent = (0, _styledComponentsDefault.default).div`
  position: relative;
  width: 100%;
  position: relative;
  word-wrap: break-word;


`;
const INITIAL_STATE = {
    offset: 0
};
class Modal extends _react.Component {
    static{
        this.propTypes = {
            children: _propTypes.node.isRequired,
            show: _propTypes.bool.isRequired,
            toggleModal: _propTypes.func.isRequired,
            opacity: _propTypes.number
        };
    }
    render() {
        const { offset } = this.state;
        const { children, show, opacity } = this.props;
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)(SLightbox, {
            show: show,
            offset: offset,
            opacity: opacity,
            ref: (c)=>this.lightbox = c,
            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)(SModalContainer, {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(SHitbox, {
                        onClick: this.toggleModal
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(SCard, {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)(BModal, {
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)(SCloseButton, {
                                    size: 25,
                                    color: "dark",
                                    onClick: this.toggleModal
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)(SModalContent, {
                                    children: children
                                })
                            ]
                        })
                    })
                ]
            })
        });
    }
    constructor(...args){
        super(...args);
        this.state = {
            ...INITIAL_STATE
        };
        // public componentDidUpdate() {
        //   if (this.lightbox) {
        //     const lightboxRect = this.lightbox.getBoundingClientRect();
        //     const offset = lightboxRect.top > 0 ? lightboxRect.top : 0;
        //     if (offset !== INITIAL_STATE.offset && offset !== this.state.offset) {
        //       console.log("Modal -> componentDidUpdate - offset = ", offset);
        //       this.setState({ offset });
        //     }
        //   }
        // }
        this.toggleModal = async ()=>{
            const d = typeof window !== "undefined" ? document : "";
            const body = d ? d.body || d.getElementsByTagName("body")[0] : "";
            if (body) {
                if (this.props.show) body.style.position = "";
                else body.style.position = "fixed";
            }
            this.props.toggleModal();
        };
    }
}
exports.default = Modal;

},{"react/jsx-runtime":"gaGEj","react":"6uln9","prop-types":"6FKs7","styled-components":"byVI1","./styles":"iCPVY","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4UgH2":[function(require,module,exports) {
// import * as ethUtil from "ethereumjs-util";
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// import { getContract } from "./web3";
parcelHelpers.export(exports, "capitalize", ()=>capitalize);
parcelHelpers.export(exports, "ellipseAddress", ()=>ellipseAddress);
parcelHelpers.export(exports, "padLeft", ()=>padLeft);
parcelHelpers.export(exports, "sanitizeHex", ()=>sanitizeHex);
parcelHelpers.export(exports, "removeHexPrefix", ()=>removeHexPrefix);
parcelHelpers.export(exports, "getDataString", ()=>getDataString);
parcelHelpers.export(exports, "isMobile", ()=>isMobile);
parcelHelpers.export(exports, "getChainData", ()=>getChainData);
parcelHelpers.export(exports, "formatMintTransaction", ()=>formatMintTransaction);
parcelHelpers.export(exports, "formatPresaleMintTransaction", ()=>formatPresaleMintTransaction);
parcelHelpers.export(exports, "isObject", ()=>isObject);
var _chains = require("./chains");
var _chainsDefault = parcelHelpers.interopDefault(_chains);
// import { apiGetGasPrices, apiGetAccountNonce } from "./api";
var _bignumber = require("./bignumber");
var _constants = require("../constants");
function capitalize(string) {
    return string.split(" ").map((word)=>word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()).join(" ");
}
function ellipseAddress(address = "", width = 10) {
    return `${address.slice(0, 6)}...${address.slice(-4)}`;
}
function padLeft(n, width, z) {
    z = z || "0";
    n = n + "";
    return n.length >= width ? n : new Array(width - n.length + 1).join(z) + n;
}
function sanitizeHex(hex) {
    hex = hex.substring(0, 2) === "0x" ? hex.substring(2) : hex;
    if (hex === "") return "";
    hex = hex.length % 2 !== 0 ? "0" + hex : hex;
    return "0x" + hex;
}
function removeHexPrefix(hex) {
    return hex.toLowerCase().replace("0x", "");
}
function getDataString(func, arrVals) {
    let val = "";
    for(let i = 0; i < arrVals.length; i++)val += padLeft(arrVals[i], 64);
    const data = func + val;
    return data;
}
function isMobile() {
    let mobile = false;
    function hasTouchEvent() {
        try {
            document.createEvent("TouchEvent");
            return true;
        } catch (e) {
            return false;
        }
    }
    function hasMobileUserAgent() {
        if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(navigator.userAgent) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw-(n|u)|c55\/|capi|ccwa|cdm-|cell|chtm|cldc|cmd-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc-s|devi|dica|dmob|do(c|p)o|ds(12|-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(-|_)|g1 u|g560|gene|gf-5|g-mo|go(.w|od)|gr(ad|un)|haie|hcit|hd-(m|p|t)|hei-|hi(pt|ta)|hp( i|ip)|hs-c|ht(c(-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i-(20|go|ma)|i230|iac( |-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|-[a-w])|libw|lynx|m1-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|-([1-8]|c))|phil|pire|pl(ay|uc)|pn-2|po(ck|rt|se)|prox|psio|pt-g|qa-a|qc(07|12|21|32|60|-[2-7]|i-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h-|oo|p-)|sdk\/|se(c(-|0|1)|47|mc|nd|ri)|sgh-|shar|sie(-|m)|sk-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h-|v-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl-|tdg-|tel(i|m)|tim-|t-mo|to(pl|sh)|ts(70|-|m3|m5)|tx-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas-|your|zeto|zte-/i.test(navigator.userAgent.substr(0, 4))) return true;
        else if (hasTouchEvent()) return true;
        return false;
    }
    mobile = hasMobileUserAgent();
    return mobile;
}
function getChainData(chainId) {
    const chainData = (0, _chainsDefault.default).filter((chain)=>chain.chain_id === chainId)[0];
    if (!chainData) throw new Error("ChainId missing or not supported");
    const API_KEY = undefined;
    if (chainData.rpc_url.includes("infura.io") && chainData.rpc_url.includes("%API_KEY%") && API_KEY) {
        const rpcUrl = chainData.rpc_url.replace("%API_KEY%", API_KEY);
        return {
            ...chainData,
            rpc_url: rpcUrl
        };
    }
    return chainData;
}
async function formatMintTransaction(address, chainId, mintQty, web3, cost, nftContract, extraMint, merkleProof) {
    // from
    const from = address;
    // to
    const to = (0, _constants.NFT_CONTRACT)[chainId].address;
    // value
    const _value = 1000000000000000000 * mintQty * cost //.0333
    ;
    const value = sanitizeHex((0, _bignumber.convertStringToHex)(_value));
    // data
    // const zevi = getContract(chainId, web3)
    var data;
    if (extraMint) console.log("doing extra mint...");
    data = extraMint ? nftContract.methods.mferEarlyMintGift(mintQty, merkleProof).encodeABI() : nftContract.methods.mint(mintQty).encodeABI();
    // test transaction
    const tx = {
        from,
        to,
        // nonce,
        // gasPrice,
        // gasLimit,
        value,
        data
    };
    // gasLimit
    try {
        var _gasLimit = await web3.eth.estimateGas(tx);
    } catch (error) {
        console.log("gas error", error);
        _gasLimit = 170000;
    }
    // console.log("estimated gas: ", _gasLimit)
    var gasLimit = sanitizeHex((0, _bignumber.convertStringToHex)(_gasLimit));
    const tx2 = {
        from,
        to,
        // nonce,
        value,
        data,
        gas: gasLimit
    };
    // console.log("mintQty: ", mintQty)
    console.log("Transaction for mint: ", tx2);
    return tx2;
}
async function formatPresaleMintTransaction(address, chainId, mintQty, web3, cost, nftContract, extraMint, merkleProof) {
    // from
    const from = address;
    // to
    const to = (0, _constants.NFT_CONTRACT)[chainId].address;
    // value
    const _value = 1000000000000000000 * mintQty * cost //.0333
    ;
    const value = sanitizeHex((0, _bignumber.convertStringToHex)(_value));
    // data
    // const zevi = getContract(chainId, web3)
    var data;
    console.log("doing presale mint...");
    if (extraMint) console.log("doing presale extra mint...");
     /*mferEarlyMintGift*/ 
    data = extraMint ? nftContract.methods.mferEarlyMintGift(mintQty, merkleProof).encodeABI() : nftContract.methods.mferEarlyMint(mintQty, merkleProof).encodeABI();
    // test transaction
    const tx = {
        from,
        to,
        // nonce,
        // gasPrice,
        // gasLimit,
        value,
        data
    };
    // gasLimit
    try {
        var _gasLimit = await web3.eth.estimateGas(tx);
    } catch (error) {
        console.log("gas error", error);
        _gasLimit = 170000;
    }
    // console.log("estimated gas: ", _gasLimit)
    var gasLimit = sanitizeHex((0, _bignumber.convertStringToHex)(_gasLimit));
    const tx2 = {
        from,
        to,
        // nonce,
        value,
        data,
        gas: gasLimit
    };
    // console.log("mintQty: ", mintQty)
    console.log("Transaction for mint: ", tx2);
    return tx2;
}
function isObject(obj) {
    return typeof obj === "object" && !!Object.keys(obj).length;
}

},{"./chains":"a69yu","./bignumber":"j63Xl","../constants":"cvMPI","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"a69yu":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
const supportedChains = [
    {
        name: "Ethereum Mainnet",
        short_name: "eth",
        chain: "ETH",
        network: "mainnet",
        chain_id: 1,
        network_id: 1,
        rpc_url: "https://mainnet.infura.io/v3/%API_KEY%",
        native_currency: {
            symbol: "ETH",
            name: "Ethereum",
            decimals: "18",
            contractAddress: "",
            balance: ""
        }
    },
    {
        name: "Ethereum Ropsten",
        short_name: "rop",
        chain: "ETH",
        network: "ropsten",
        chain_id: 3,
        network_id: 3,
        rpc_url: "https://ropsten.infura.io/v3/%API_KEY%",
        native_currency: {
            symbol: "ETH",
            name: "Ethereum",
            decimals: "18",
            contractAddress: "",
            balance: ""
        }
    },
    {
        name: "Ethereum Rinkeby",
        short_name: "rin",
        chain: "ETH",
        network: "rinkeby",
        chain_id: 4,
        network_id: 4,
        rpc_url: "https://rinkeby.infura.io/v3/%API_KEY%",
        native_currency: {
            symbol: "ETH",
            name: "Ethereum",
            decimals: "18",
            contractAddress: "",
            balance: ""
        }
    },
    {
        name: "Ethereum G\xf6rli",
        short_name: "gor",
        chain: "ETH",
        network: "goerli",
        chain_id: 5,
        network_id: 5,
        rpc_url: "https://goerli.infura.io/v3/%API_KEY%",
        native_currency: {
            symbol: "ETH",
            name: "Ethereum",
            decimals: "18",
            contractAddress: "",
            balance: ""
        }
    },
    {
        name: "RSK Mainnet",
        short_name: "rsk",
        chain: "RSK",
        network: "mainnet",
        chain_id: 30,
        network_id: 30,
        rpc_url: "https://public-node.rsk.co",
        native_currency: {
            symbol: "RSK",
            name: "RSK",
            decimals: "18",
            contractAddress: "",
            balance: ""
        }
    },
    {
        name: "Ethereum Kovan",
        short_name: "kov",
        chain: "ETH",
        network: "kovan",
        chain_id: 42,
        network_id: 42,
        rpc_url: "https://kovan.infura.io/v3/%API_KEY%",
        native_currency: {
            symbol: "ETH",
            name: "Ethereum",
            decimals: "18",
            contractAddress: "",
            balance: ""
        }
    },
    {
        name: "Ethereum Classic Mainnet",
        short_name: "etc",
        chain: "ETC",
        network: "mainnet",
        chain_id: 61,
        network_id: 1,
        rpc_url: "https://ethereumclassic.network",
        native_currency: {
            symbol: "ETH",
            name: "Ethereum",
            decimals: "18",
            contractAddress: "",
            balance: ""
        }
    },
    {
        name: "POA Network Sokol",
        short_name: "poa",
        chain: "POA",
        network: "sokol",
        chain_id: 77,
        network_id: 77,
        rpc_url: "https://sokol.poa.network",
        native_currency: {
            symbol: "POA",
            name: "POA",
            decimals: "18",
            contractAddress: "",
            balance: ""
        }
    },
    {
        name: "POA Network Core",
        short_name: "skl",
        chain: "POA",
        network: "core",
        chain_id: 99,
        network_id: 99,
        rpc_url: "https://core.poa.network",
        native_currency: {
            symbol: "POA",
            name: "POA",
            decimals: "18",
            contractAddress: "",
            balance: ""
        }
    },
    {
        name: "xDAI Chain",
        short_name: "xdai",
        chain: "POA",
        network: "dai",
        chain_id: 100,
        network_id: 100,
        rpc_url: "https://dai.poa.network",
        native_currency: {
            symbol: "xDAI",
            name: "xDAI",
            decimals: "18",
            contractAddress: "",
            balance: ""
        }
    },
    {
        name: "Callisto Mainnet",
        short_name: "clo",
        chain: "callisto",
        network: "mainnet",
        chain_id: 820,
        network_id: 1,
        rpc_url: "https://clo-geth.0xinfra.com/",
        native_currency: {
            symbol: "CLO",
            name: "CLO",
            decimals: "18",
            contractAddress: "",
            balance: ""
        }
    },
    {
        name: "Binance Smart Chain",
        short_name: "bsc",
        chain: "smartchain",
        network: "mainnet",
        chain_id: 56,
        network_id: 56,
        rpc_url: "https://bsc-dataseed1.defibit.io/",
        native_currency: {
            symbol: "BNB",
            name: "BNB",
            decimals: "18",
            contractAddress: "",
            balance: ""
        }
    },
    {
        name: "Celo Mainnet",
        short_name: "celo",
        chain: "celo",
        network: "mainnet",
        chain_id: 42220,
        network_id: 42220,
        rpc_url: "https://forno.celo.org",
        native_currency: {
            symbol: "CELO",
            name: "CELO",
            decimals: "18",
            contractAddress: "",
            balance: ""
        }
    },
    {
        name: "Celo Alfajores Testnet",
        short_name: "celo",
        chain: "celo",
        network: "alfajores",
        chain_id: 44787,
        network_id: 44787,
        rpc_url: "https://alfajores-forno.celo-testnet.org",
        native_currency: {
            symbol: "CELO",
            name: "CELO",
            decimals: "18",
            contractAddress: "",
            balance: ""
        }
    },
    {
        name: "Celo Baklava Testnet",
        short_name: "celo",
        chain: "celo",
        network: "baklava",
        chain_id: 62320,
        network_id: 62320,
        rpc_url: "https://baklava-forno.celo-testnet.org",
        native_currency: {
            symbol: "CELO",
            name: "CELO",
            decimals: "18",
            contractAddress: "",
            balance: ""
        }
    }
];
exports.default = supportedChains;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"j63Xl":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isNaN", ()=>isNaN);
parcelHelpers.export(exports, "isNumber", ()=>isNumber);
parcelHelpers.export(exports, "isInteger", ()=>isInteger);
parcelHelpers.export(exports, "isPositive", ()=>isPositive);
parcelHelpers.export(exports, "isNegative", ()=>isNegative);
parcelHelpers.export(exports, "isZero", ()=>isZero);
parcelHelpers.export(exports, "countDecimalPlaces", ()=>countDecimalPlaces);
parcelHelpers.export(exports, "convertNumberToString", ()=>convertNumberToString);
parcelHelpers.export(exports, "convertStringToNumber", ()=>convertStringToNumber);
parcelHelpers.export(exports, "convertHexToString", ()=>convertHexToString);
parcelHelpers.export(exports, "convertStringToHex", ()=>convertStringToHex);
parcelHelpers.export(exports, "greaterThan", ()=>greaterThan);
parcelHelpers.export(exports, "greaterThanOrEqual", ()=>greaterThanOrEqual);
parcelHelpers.export(exports, "smallerThan", ()=>smallerThan);
parcelHelpers.export(exports, "smallerThanOrEqual", ()=>smallerThanOrEqual);
parcelHelpers.export(exports, "multiply", ()=>multiply);
parcelHelpers.export(exports, "divide", ()=>divide);
parcelHelpers.export(exports, "floorDivide", ()=>floorDivide);
parcelHelpers.export(exports, "mod", ()=>mod);
parcelHelpers.export(exports, "add", ()=>add);
parcelHelpers.export(exports, "subtract", ()=>subtract);
parcelHelpers.export(exports, "convertAmountToRawNumber", ()=>convertAmountToRawNumber);
parcelHelpers.export(exports, "convertAmountFromRawNumber", ()=>convertAmountFromRawNumber);
parcelHelpers.export(exports, "handleSignificantDecimals", ()=>handleSignificantDecimals);
parcelHelpers.export(exports, "formatFixedDecimals", ()=>formatFixedDecimals);
parcelHelpers.export(exports, "formatInputDecimals", ()=>formatInputDecimals);
var _bignumberJs = require("bignumber.js");
var _bignumberJsDefault = parcelHelpers.interopDefault(_bignumberJs);
function isNaN(value) {
    return new (0, _bignumberJsDefault.default)(`${value}`).isNaN();
}
function isNumber(value) {
    const isNaNResult = isNaN(value);
    return !isNaNResult;
}
function isInteger(value) {
    return new (0, _bignumberJsDefault.default)(`${value}`).isInteger();
}
function isPositive(value) {
    return new (0, _bignumberJsDefault.default)(`${value}`).isPositive();
}
function isNegative(value) {
    return new (0, _bignumberJsDefault.default)(`${value}`).isNegative();
}
function isZero(value) {
    return new (0, _bignumberJsDefault.default)(`${value}`).isZero();
}
function countDecimalPlaces(value) {
    return new (0, _bignumberJsDefault.default)(`${value}`).dp();
}
function convertNumberToString(value) {
    return new (0, _bignumberJsDefault.default)(`${value}`).toString();
}
function convertStringToNumber(value) {
    return new (0, _bignumberJsDefault.default)(`${value}`).toNumber();
}
function convertHexToString(hex) {
    return new (0, _bignumberJsDefault.default)(`${hex}`).toString();
}
function convertStringToHex(value) {
    return new (0, _bignumberJsDefault.default)(`${value}`).toString(16);
}
function greaterThan(numberOne, numberTwo) {
    return new (0, _bignumberJsDefault.default)(`${numberOne}`).comparedTo(new (0, _bignumberJsDefault.default)(`${numberTwo}`)) === 1;
}
function greaterThanOrEqual(numberOne, numberTwo) {
    return new (0, _bignumberJsDefault.default)(`${numberOne}`).comparedTo(new (0, _bignumberJsDefault.default)(`${numberTwo}`)) >= 0;
}
function smallerThan(numberOne, numberTwo) {
    return new (0, _bignumberJsDefault.default)(`${numberOne}`).comparedTo(new (0, _bignumberJsDefault.default)(`${numberTwo}`)) === -1;
}
function smallerThanOrEqual(numberOne, numberTwo) {
    return new (0, _bignumberJsDefault.default)(`${numberOne}`).comparedTo(new (0, _bignumberJsDefault.default)(`${numberTwo}`)) <= 0;
}
function multiply(numberOne, numberTwo) {
    return new (0, _bignumberJsDefault.default)(`${numberOne}`).times(new (0, _bignumberJsDefault.default)(`${numberTwo}`)).toString();
}
function divide(numberOne, numberTwo) {
    return new (0, _bignumberJsDefault.default)(`${numberOne}`).dividedBy(new (0, _bignumberJsDefault.default)(`${numberTwo}`)).toString();
}
function floorDivide(numberOne, numberTwo) {
    return new (0, _bignumberJsDefault.default)(`${numberOne}`).dividedToIntegerBy(new (0, _bignumberJsDefault.default)(`${numberTwo}`)).toString();
}
function mod(numberOne, numberTwo) {
    return new (0, _bignumberJsDefault.default)(`${numberOne}`).mod(new (0, _bignumberJsDefault.default)(`${numberTwo}`)).toString();
}
function add(numberOne, numberTwo) {
    return new (0, _bignumberJsDefault.default)(`${numberOne}`).plus(new (0, _bignumberJsDefault.default)(`${numberTwo}`)).toString();
}
function subtract(numberOne, numberTwo) {
    return new (0, _bignumberJsDefault.default)(`${numberOne}`).minus(new (0, _bignumberJsDefault.default)(`${numberTwo}`)).toString();
}
function convertAmountToRawNumber(value, decimals = 18) {
    return new (0, _bignumberJsDefault.default)(`${value}`).times(new (0, _bignumberJsDefault.default)("10").pow(decimals)).toString();
}
function convertAmountFromRawNumber(value, decimals = 18) {
    return new (0, _bignumberJsDefault.default)(`${value}`).dividedBy(new (0, _bignumberJsDefault.default)("10").pow(decimals)).toString();
}
function handleSignificantDecimals(value, decimals, buffer) {
    if (!new (0, _bignumberJsDefault.default)(`${decimals}`).isInteger() || buffer && !new (0, _bignumberJsDefault.default)(`${buffer}`).isInteger()) return null;
    buffer = buffer ? convertStringToNumber(buffer) : 3;
    decimals = convertStringToNumber(decimals);
    const absolute = new (0, _bignumberJsDefault.default)(`${value}`).abs().toNumber();
    if (smallerThan(absolute, 1)) {
        decimals = value.slice(2).search(/[^0]/g) + buffer;
        decimals = decimals < 8 ? decimals : 8;
    } else decimals = decimals < buffer ? decimals : buffer;
    let result = new (0, _bignumberJsDefault.default)(`${value}`).toFixed(decimals);
    result = new (0, _bignumberJsDefault.default)(`${result}`).toString();
    return new (0, _bignumberJsDefault.default)(`${result}`).dp() <= 2 ? new (0, _bignumberJsDefault.default)(`${result}`).toFormat(2) : new (0, _bignumberJsDefault.default)(`${result}`).toFormat();
}
function formatFixedDecimals(value, decimals) {
    const _value = convertNumberToString(value);
    const _decimals = convertStringToNumber(decimals);
    const result = new (0, _bignumberJsDefault.default)(new (0, _bignumberJsDefault.default)(_value).toFixed(_decimals)).toString();
    return result;
}
function formatInputDecimals(inputOne, inputTwo) {
    const _nativeAmountDecimalPlaces = countDecimalPlaces(inputTwo);
    const decimals = _nativeAmountDecimalPlaces > 8 ? _nativeAmountDecimalPlaces : 8;
    const result = new (0, _bignumberJsDefault.default)(formatFixedDecimals(inputOne, decimals)).toFormat().replace(/,/g, "");
    return result;
}

},{"bignumber.js":"2fTAY","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2fTAY":[function(require,module,exports) {
(function(globalObject) {
    "use strict";
    /*
 *      bignumber.js v9.1.2
 *      A JavaScript library for arbitrary-precision arithmetic.
 *      https://github.com/MikeMcl/bignumber.js
 *      Copyright (c) 2022 Michael Mclaughlin <M8ch88l@gmail.com>
 *      MIT Licensed.
 *
 *      BigNumber.prototype methods     |  BigNumber methods
 *                                      |
 *      absoluteValue            abs    |  clone
 *      comparedTo                      |  config               set
 *      decimalPlaces            dp     |      DECIMAL_PLACES
 *      dividedBy                div    |      ROUNDING_MODE
 *      dividedToIntegerBy       idiv   |      EXPONENTIAL_AT
 *      exponentiatedBy          pow    |      RANGE
 *      integerValue                    |      CRYPTO
 *      isEqualTo                eq     |      MODULO_MODE
 *      isFinite                        |      POW_PRECISION
 *      isGreaterThan            gt     |      FORMAT
 *      isGreaterThanOrEqualTo   gte    |      ALPHABET
 *      isInteger                       |  isBigNumber
 *      isLessThan               lt     |  maximum              max
 *      isLessThanOrEqualTo      lte    |  minimum              min
 *      isNaN                           |  random
 *      isNegative                      |  sum
 *      isPositive                      |
 *      isZero                          |
 *      minus                           |
 *      modulo                   mod    |
 *      multipliedBy             times  |
 *      negated                         |
 *      plus                            |
 *      precision                sd     |
 *      shiftedBy                       |
 *      squareRoot               sqrt   |
 *      toExponential                   |
 *      toFixed                         |
 *      toFormat                        |
 *      toFraction                      |
 *      toJSON                          |
 *      toNumber                        |
 *      toPrecision                     |
 *      toString                        |
 *      valueOf                         |
 *
 */ var BigNumber, isNumeric = /^-?(?:\d+(?:\.\d*)?|\.\d+)(?:e[+-]?\d+)?$/i, mathceil = Math.ceil, mathfloor = Math.floor, bignumberError = "[BigNumber Error] ", tooManyDigits = bignumberError + "Number primitive has more than 15 significant digits: ", BASE = 1e14, LOG_BASE = 14, MAX_SAFE_INTEGER = 0x1fffffffffffff, // MAX_INT32 = 0x7fffffff,                   // 2^31 - 1
    POWS_TEN = [
        1,
        10,
        100,
        1e3,
        1e4,
        1e5,
        1e6,
        1e7,
        1e8,
        1e9,
        1e10,
        1e11,
        1e12,
        1e13
    ], SQRT_BASE = 1e7, // EDITABLE
    // The limit on the value of DECIMAL_PLACES, TO_EXP_NEG, TO_EXP_POS, MIN_EXP, MAX_EXP, and
    // the arguments to toExponential, toFixed, toFormat, and toPrecision.
    MAX = 1E9; // 0 to MAX_INT32
    /*
   * Create and return a BigNumber constructor.
   */ function clone(configObject) {
        var div, convertBase, parseNumeric, P = BigNumber.prototype = {
            constructor: BigNumber,
            toString: null,
            valueOf: null
        }, ONE = new BigNumber(1), //----------------------------- EDITABLE CONFIG DEFAULTS -------------------------------
        // The default values below must be integers within the inclusive ranges stated.
        // The values can also be changed at run-time using BigNumber.set.
        // The maximum number of decimal places for operations involving division.
        DECIMAL_PLACES = 20, // The rounding mode used when rounding to the above decimal places, and when using
        // toExponential, toFixed, toFormat and toPrecision, and round (default value).
        // UP         0 Away from zero.
        // DOWN       1 Towards zero.
        // CEIL       2 Towards +Infinity.
        // FLOOR      3 Towards -Infinity.
        // HALF_UP    4 Towards nearest neighbour. If equidistant, up.
        // HALF_DOWN  5 Towards nearest neighbour. If equidistant, down.
        // HALF_EVEN  6 Towards nearest neighbour. If equidistant, towards even neighbour.
        // HALF_CEIL  7 Towards nearest neighbour. If equidistant, towards +Infinity.
        // HALF_FLOOR 8 Towards nearest neighbour. If equidistant, towards -Infinity.
        ROUNDING_MODE = 4, // EXPONENTIAL_AT : [TO_EXP_NEG , TO_EXP_POS]
        // The exponent value at and beneath which toString returns exponential notation.
        // Number type: -7
        TO_EXP_NEG = -7, // The exponent value at and above which toString returns exponential notation.
        // Number type: 21
        TO_EXP_POS = 21, // RANGE : [MIN_EXP, MAX_EXP]
        // The minimum exponent value, beneath which underflow to zero occurs.
        // Number type: -324  (5e-324)
        MIN_EXP = -10000000, // The maximum exponent value, above which overflow to Infinity occurs.
        // Number type:  308  (1.7976931348623157e+308)
        // For MAX_EXP > 1e7, e.g. new BigNumber('1e100000000').plus(1) may be slow.
        MAX_EXP = 1e7, // Whether to use cryptographically-secure random number generation, if available.
        CRYPTO = false, // The modulo mode used when calculating the modulus: a mod n.
        // The quotient (q = a / n) is calculated according to the corresponding rounding mode.
        // The remainder (r) is calculated as: r = a - n * q.
        //
        // UP        0 The remainder is positive if the dividend is negative, else is negative.
        // DOWN      1 The remainder has the same sign as the dividend.
        //             This modulo mode is commonly known as 'truncated division' and is
        //             equivalent to (a % n) in JavaScript.
        // FLOOR     3 The remainder has the same sign as the divisor (Python %).
        // HALF_EVEN 6 This modulo mode implements the IEEE 754 remainder function.
        // EUCLID    9 Euclidian division. q = sign(n) * floor(a / abs(n)).
        //             The remainder is always positive.
        //
        // The truncated division, floored division, Euclidian division and IEEE 754 remainder
        // modes are commonly used for the modulus operation.
        // Although the other rounding modes can also be used, they may not give useful results.
        MODULO_MODE = 1, // The maximum number of significant digits of the result of the exponentiatedBy operation.
        // If POW_PRECISION is 0, there will be unlimited significant digits.
        POW_PRECISION = 0, // The format specification used by the BigNumber.prototype.toFormat method.
        FORMAT = {
            prefix: "",
            groupSize: 3,
            secondaryGroupSize: 0,
            groupSeparator: ",",
            decimalSeparator: ".",
            fractionGroupSize: 0,
            fractionGroupSeparator: "\xa0",
            suffix: ""
        }, // The alphabet used for base conversion. It must be at least 2 characters long, with no '+',
        // '-', '.', whitespace, or repeated character.
        // '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ$_'
        ALPHABET = "0123456789abcdefghijklmnopqrstuvwxyz", alphabetHasNormalDecimalDigits = true;
        //------------------------------------------------------------------------------------------
        // CONSTRUCTOR
        /*
     * The BigNumber constructor and exported function.
     * Create and return a new instance of a BigNumber object.
     *
     * v {number|string|BigNumber} A numeric value.
     * [b] {number} The base of v. Integer, 2 to ALPHABET.length inclusive.
     */ function BigNumber(v, b) {
            var alphabet, c, caseChanged, e, i, isNum, len, str, x = this;
            // Enable constructor call without `new`.
            if (!(x instanceof BigNumber)) return new BigNumber(v, b);
            if (b == null) {
                if (v && v._isBigNumber === true) {
                    x.s = v.s;
                    if (!v.c || v.e > MAX_EXP) x.c = x.e = null;
                    else if (v.e < MIN_EXP) x.c = [
                        x.e = 0
                    ];
                    else {
                        x.e = v.e;
                        x.c = v.c.slice();
                    }
                    return;
                }
                if ((isNum = typeof v == "number") && v * 0 == 0) {
                    // Use `1 / n` to handle minus zero also.
                    x.s = 1 / v < 0 ? (v = -v, -1) : 1;
                    // Fast path for integers, where n < 2147483648 (2**31).
                    if (v === ~~v) {
                        for(e = 0, i = v; i >= 10; i /= 10, e++);
                        if (e > MAX_EXP) x.c = x.e = null;
                        else {
                            x.e = e;
                            x.c = [
                                v
                            ];
                        }
                        return;
                    }
                    str = String(v);
                } else {
                    if (!isNumeric.test(str = String(v))) return parseNumeric(x, str, isNum);
                    x.s = str.charCodeAt(0) == 45 ? (str = str.slice(1), -1) : 1;
                }
                // Decimal point?
                if ((e = str.indexOf(".")) > -1) str = str.replace(".", "");
                // Exponential form?
                if ((i = str.search(/e/i)) > 0) {
                    // Determine exponent.
                    if (e < 0) e = i;
                    e += +str.slice(i + 1);
                    str = str.substring(0, i);
                } else if (e < 0) // Integer.
                e = str.length;
            } else {
                // '[BigNumber Error] Base {not a primitive number|not an integer|out of range}: {b}'
                intCheck(b, 2, ALPHABET.length, "Base");
                // Allow exponential notation to be used with base 10 argument, while
                // also rounding to DECIMAL_PLACES as with other bases.
                if (b == 10 && alphabetHasNormalDecimalDigits) {
                    x = new BigNumber(v);
                    return round(x, DECIMAL_PLACES + x.e + 1, ROUNDING_MODE);
                }
                str = String(v);
                if (isNum = typeof v == "number") {
                    // Avoid potential interpretation of Infinity and NaN as base 44+ values.
                    if (v * 0 != 0) return parseNumeric(x, str, isNum, b);
                    x.s = 1 / v < 0 ? (str = str.slice(1), -1) : 1;
                    // '[BigNumber Error] Number primitive has more than 15 significant digits: {n}'
                    if (BigNumber.DEBUG && str.replace(/^0\.0*|\./, "").length > 15) throw Error(tooManyDigits + v);
                } else x.s = str.charCodeAt(0) === 45 ? (str = str.slice(1), -1) : 1;
                alphabet = ALPHABET.slice(0, b);
                e = i = 0;
                // Check that str is a valid base b number.
                // Don't use RegExp, so alphabet can contain special characters.
                for(len = str.length; i < len; i++)if (alphabet.indexOf(c = str.charAt(i)) < 0) {
                    if (c == ".") // If '.' is not the first character and it has not be found before.
                    {
                        if (i > e) {
                            e = len;
                            continue;
                        }
                    } else if (!caseChanged) // Allow e.g. hexadecimal 'FF' as well as 'ff'.
                    {
                        if (str == str.toUpperCase() && (str = str.toLowerCase()) || str == str.toLowerCase() && (str = str.toUpperCase())) {
                            caseChanged = true;
                            i = -1;
                            e = 0;
                            continue;
                        }
                    }
                    return parseNumeric(x, String(v), isNum, b);
                }
                // Prevent later check for length on converted number.
                isNum = false;
                str = convertBase(str, b, 10, x.s);
                // Decimal point?
                if ((e = str.indexOf(".")) > -1) str = str.replace(".", "");
                else e = str.length;
            }
            // Determine leading zeros.
            for(i = 0; str.charCodeAt(i) === 48; i++);
            // Determine trailing zeros.
            for(len = str.length; str.charCodeAt(--len) === 48;);
            if (str = str.slice(i, ++len)) {
                len -= i;
                // '[BigNumber Error] Number primitive has more than 15 significant digits: {n}'
                if (isNum && BigNumber.DEBUG && len > 15 && (v > MAX_SAFE_INTEGER || v !== mathfloor(v))) throw Error(tooManyDigits + x.s * v);
                // Overflow?
                if ((e = e - i - 1) > MAX_EXP) // Infinity.
                x.c = x.e = null;
                else if (e < MIN_EXP) // Zero.
                x.c = [
                    x.e = 0
                ];
                else {
                    x.e = e;
                    x.c = [];
                    // Transform base
                    // e is the base 10 exponent.
                    // i is where to slice str to get the first element of the coefficient array.
                    i = (e + 1) % LOG_BASE;
                    if (e < 0) i += LOG_BASE; // i < 1
                    if (i < len) {
                        if (i) x.c.push(+str.slice(0, i));
                        for(len -= LOG_BASE; i < len;)x.c.push(+str.slice(i, i += LOG_BASE));
                        i = LOG_BASE - (str = str.slice(i)).length;
                    } else i -= len;
                    for(; i--; str += "0");
                    x.c.push(+str);
                }
            } else // Zero.
            x.c = [
                x.e = 0
            ];
        }
        // CONSTRUCTOR PROPERTIES
        BigNumber.clone = clone;
        BigNumber.ROUND_UP = 0;
        BigNumber.ROUND_DOWN = 1;
        BigNumber.ROUND_CEIL = 2;
        BigNumber.ROUND_FLOOR = 3;
        BigNumber.ROUND_HALF_UP = 4;
        BigNumber.ROUND_HALF_DOWN = 5;
        BigNumber.ROUND_HALF_EVEN = 6;
        BigNumber.ROUND_HALF_CEIL = 7;
        BigNumber.ROUND_HALF_FLOOR = 8;
        BigNumber.EUCLID = 9;
        /*
     * Configure infrequently-changing library-wide settings.
     *
     * Accept an object with the following optional properties (if the value of a property is
     * a number, it must be an integer within the inclusive range stated):
     *
     *   DECIMAL_PLACES   {number}           0 to MAX
     *   ROUNDING_MODE    {number}           0 to 8
     *   EXPONENTIAL_AT   {number|number[]}  -MAX to MAX  or  [-MAX to 0, 0 to MAX]
     *   RANGE            {number|number[]}  -MAX to MAX (not zero)  or  [-MAX to -1, 1 to MAX]
     *   CRYPTO           {boolean}          true or false
     *   MODULO_MODE      {number}           0 to 9
     *   POW_PRECISION       {number}           0 to MAX
     *   ALPHABET         {string}           A string of two or more unique characters which does
     *                                       not contain '.'.
     *   FORMAT           {object}           An object with some of the following properties:
     *     prefix                 {string}
     *     groupSize              {number}
     *     secondaryGroupSize     {number}
     *     groupSeparator         {string}
     *     decimalSeparator       {string}
     *     fractionGroupSize      {number}
     *     fractionGroupSeparator {string}
     *     suffix                 {string}
     *
     * (The values assigned to the above FORMAT object properties are not checked for validity.)
     *
     * E.g.
     * BigNumber.config({ DECIMAL_PLACES : 20, ROUNDING_MODE : 4 })
     *
     * Ignore properties/parameters set to null or undefined, except for ALPHABET.
     *
     * Return an object with the properties current values.
     */ BigNumber.config = BigNumber.set = function(obj) {
            var p, v;
            if (obj != null) {
                if (typeof obj == "object") {
                    // DECIMAL_PLACES {number} Integer, 0 to MAX inclusive.
                    // '[BigNumber Error] DECIMAL_PLACES {not a primitive number|not an integer|out of range}: {v}'
                    if (obj.hasOwnProperty(p = "DECIMAL_PLACES")) {
                        v = obj[p];
                        intCheck(v, 0, MAX, p);
                        DECIMAL_PLACES = v;
                    }
                    // ROUNDING_MODE {number} Integer, 0 to 8 inclusive.
                    // '[BigNumber Error] ROUNDING_MODE {not a primitive number|not an integer|out of range}: {v}'
                    if (obj.hasOwnProperty(p = "ROUNDING_MODE")) {
                        v = obj[p];
                        intCheck(v, 0, 8, p);
                        ROUNDING_MODE = v;
                    }
                    // EXPONENTIAL_AT {number|number[]}
                    // Integer, -MAX to MAX inclusive or
                    // [integer -MAX to 0 inclusive, 0 to MAX inclusive].
                    // '[BigNumber Error] EXPONENTIAL_AT {not a primitive number|not an integer|out of range}: {v}'
                    if (obj.hasOwnProperty(p = "EXPONENTIAL_AT")) {
                        v = obj[p];
                        if (v && v.pop) {
                            intCheck(v[0], -MAX, 0, p);
                            intCheck(v[1], 0, MAX, p);
                            TO_EXP_NEG = v[0];
                            TO_EXP_POS = v[1];
                        } else {
                            intCheck(v, -MAX, MAX, p);
                            TO_EXP_NEG = -(TO_EXP_POS = v < 0 ? -v : v);
                        }
                    }
                    // RANGE {number|number[]} Non-zero integer, -MAX to MAX inclusive or
                    // [integer -MAX to -1 inclusive, integer 1 to MAX inclusive].
                    // '[BigNumber Error] RANGE {not a primitive number|not an integer|out of range|cannot be zero}: {v}'
                    if (obj.hasOwnProperty(p = "RANGE")) {
                        v = obj[p];
                        if (v && v.pop) {
                            intCheck(v[0], -MAX, -1, p);
                            intCheck(v[1], 1, MAX, p);
                            MIN_EXP = v[0];
                            MAX_EXP = v[1];
                        } else {
                            intCheck(v, -MAX, MAX, p);
                            if (v) MIN_EXP = -(MAX_EXP = v < 0 ? -v : v);
                            else throw Error(bignumberError + p + " cannot be zero: " + v);
                        }
                    }
                    // CRYPTO {boolean} true or false.
                    // '[BigNumber Error] CRYPTO not true or false: {v}'
                    // '[BigNumber Error] crypto unavailable'
                    if (obj.hasOwnProperty(p = "CRYPTO")) {
                        v = obj[p];
                        if (v === !!v) {
                            if (v) {
                                if (typeof crypto != "undefined" && crypto && (crypto.getRandomValues || crypto.randomBytes)) CRYPTO = v;
                                else {
                                    CRYPTO = !v;
                                    throw Error(bignumberError + "crypto unavailable");
                                }
                            } else CRYPTO = v;
                        } else throw Error(bignumberError + p + " not true or false: " + v);
                    }
                    // MODULO_MODE {number} Integer, 0 to 9 inclusive.
                    // '[BigNumber Error] MODULO_MODE {not a primitive number|not an integer|out of range}: {v}'
                    if (obj.hasOwnProperty(p = "MODULO_MODE")) {
                        v = obj[p];
                        intCheck(v, 0, 9, p);
                        MODULO_MODE = v;
                    }
                    // POW_PRECISION {number} Integer, 0 to MAX inclusive.
                    // '[BigNumber Error] POW_PRECISION {not a primitive number|not an integer|out of range}: {v}'
                    if (obj.hasOwnProperty(p = "POW_PRECISION")) {
                        v = obj[p];
                        intCheck(v, 0, MAX, p);
                        POW_PRECISION = v;
                    }
                    // FORMAT {object}
                    // '[BigNumber Error] FORMAT not an object: {v}'
                    if (obj.hasOwnProperty(p = "FORMAT")) {
                        v = obj[p];
                        if (typeof v == "object") FORMAT = v;
                        else throw Error(bignumberError + p + " not an object: " + v);
                    }
                    // ALPHABET {string}
                    // '[BigNumber Error] ALPHABET invalid: {v}'
                    if (obj.hasOwnProperty(p = "ALPHABET")) {
                        v = obj[p];
                        // Disallow if less than two characters,
                        // or if it contains '+', '-', '.', whitespace, or a repeated character.
                        if (typeof v == "string" && !/^.?$|[+\-.\s]|(.).*\1/.test(v)) {
                            alphabetHasNormalDecimalDigits = v.slice(0, 10) == "0123456789";
                            ALPHABET = v;
                        } else throw Error(bignumberError + p + " invalid: " + v);
                    }
                } else // '[BigNumber Error] Object expected: {v}'
                throw Error(bignumberError + "Object expected: " + obj);
            }
            return {
                DECIMAL_PLACES: DECIMAL_PLACES,
                ROUNDING_MODE: ROUNDING_MODE,
                EXPONENTIAL_AT: [
                    TO_EXP_NEG,
                    TO_EXP_POS
                ],
                RANGE: [
                    MIN_EXP,
                    MAX_EXP
                ],
                CRYPTO: CRYPTO,
                MODULO_MODE: MODULO_MODE,
                POW_PRECISION: POW_PRECISION,
                FORMAT: FORMAT,
                ALPHABET: ALPHABET
            };
        };
        /*
     * Return true if v is a BigNumber instance, otherwise return false.
     *
     * If BigNumber.DEBUG is true, throw if a BigNumber instance is not well-formed.
     *
     * v {any}
     *
     * '[BigNumber Error] Invalid BigNumber: {v}'
     */ BigNumber.isBigNumber = function(v) {
            if (!v || v._isBigNumber !== true) return false;
            if (!BigNumber.DEBUG) return true;
            var i, n, c = v.c, e = v.e, s = v.s;
            out: if (({}).toString.call(c) == "[object Array]") {
                if ((s === 1 || s === -1) && e >= -MAX && e <= MAX && e === mathfloor(e)) {
                    // If the first element is zero, the BigNumber value must be zero.
                    if (c[0] === 0) {
                        if (e === 0 && c.length === 1) return true;
                        break out;
                    }
                    // Calculate number of digits that c[0] should have, based on the exponent.
                    i = (e + 1) % LOG_BASE;
                    if (i < 1) i += LOG_BASE;
                    // Calculate number of digits of c[0].
                    //if (Math.ceil(Math.log(c[0] + 1) / Math.LN10) == i) {
                    if (String(c[0]).length == i) {
                        for(i = 0; i < c.length; i++){
                            n = c[i];
                            if (n < 0 || n >= BASE || n !== mathfloor(n)) break out;
                        }
                        // Last element cannot be zero, unless it is the only element.
                        if (n !== 0) return true;
                    }
                }
            } else if (c === null && e === null && (s === null || s === 1 || s === -1)) return true;
            throw Error(bignumberError + "Invalid BigNumber: " + v);
        };
        /*
     * Return a new BigNumber whose value is the maximum of the arguments.
     *
     * arguments {number|string|BigNumber}
     */ BigNumber.maximum = BigNumber.max = function() {
            return maxOrMin(arguments, -1);
        };
        /*
     * Return a new BigNumber whose value is the minimum of the arguments.
     *
     * arguments {number|string|BigNumber}
     */ BigNumber.minimum = BigNumber.min = function() {
            return maxOrMin(arguments, 1);
        };
        /*
     * Return a new BigNumber with a random value equal to or greater than 0 and less than 1,
     * and with dp, or DECIMAL_PLACES if dp is omitted, decimal places (or less if trailing
     * zeros are produced).
     *
     * [dp] {number} Decimal places. Integer, 0 to MAX inclusive.
     *
     * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {dp}'
     * '[BigNumber Error] crypto unavailable'
     */ BigNumber.random = function() {
            var pow2_53 = 0x20000000000000;
            // Return a 53 bit integer n, where 0 <= n < 9007199254740992.
            // Check if Math.random() produces more than 32 bits of randomness.
            // If it does, assume at least 53 bits are produced, otherwise assume at least 30 bits.
            // 0x40000000 is 2^30, 0x800000 is 2^23, 0x1fffff is 2^21 - 1.
            var random53bitInt = Math.random() * pow2_53 & 0x1fffff ? function() {
                return mathfloor(Math.random() * pow2_53);
            } : function() {
                return (Math.random() * 0x40000000 | 0) * 0x800000 + (Math.random() * 0x800000 | 0);
            };
            return function(dp) {
                var a, b, e, k, v, i = 0, c = [], rand = new BigNumber(ONE);
                if (dp == null) dp = DECIMAL_PLACES;
                else intCheck(dp, 0, MAX);
                k = mathceil(dp / LOG_BASE);
                if (CRYPTO) {
                    // Browsers supporting crypto.getRandomValues.
                    if (crypto.getRandomValues) {
                        a = crypto.getRandomValues(new Uint32Array(k *= 2));
                        for(; i < k;){
                            // 53 bits:
                            // ((Math.pow(2, 32) - 1) * Math.pow(2, 21)).toString(2)
                            // 11111 11111111 11111111 11111111 11100000 00000000 00000000
                            // ((Math.pow(2, 32) - 1) >>> 11).toString(2)
                            //                                     11111 11111111 11111111
                            // 0x20000 is 2^21.
                            v = a[i] * 0x20000 + (a[i + 1] >>> 11);
                            // Rejection sampling:
                            // 0 <= v < 9007199254740992
                            // Probability that v >= 9e15, is
                            // 7199254740992 / 9007199254740992 ~= 0.0008, i.e. 1 in 1251
                            if (v >= 9e15) {
                                b = crypto.getRandomValues(new Uint32Array(2));
                                a[i] = b[0];
                                a[i + 1] = b[1];
                            } else {
                                // 0 <= v <= 8999999999999999
                                // 0 <= (v % 1e14) <= 99999999999999
                                c.push(v % 1e14);
                                i += 2;
                            }
                        }
                        i = k / 2;
                    // Node.js supporting crypto.randomBytes.
                    } else if (crypto.randomBytes) {
                        // buffer
                        a = crypto.randomBytes(k *= 7);
                        for(; i < k;){
                            // 0x1000000000000 is 2^48, 0x10000000000 is 2^40
                            // 0x100000000 is 2^32, 0x1000000 is 2^24
                            // 11111 11111111 11111111 11111111 11111111 11111111 11111111
                            // 0 <= v < 9007199254740992
                            v = (a[i] & 31) * 0x1000000000000 + a[i + 1] * 0x10000000000 + a[i + 2] * 0x100000000 + a[i + 3] * 0x1000000 + (a[i + 4] << 16) + (a[i + 5] << 8) + a[i + 6];
                            if (v >= 9e15) crypto.randomBytes(7).copy(a, i);
                            else {
                                // 0 <= (v % 1e14) <= 99999999999999
                                c.push(v % 1e14);
                                i += 7;
                            }
                        }
                        i = k / 7;
                    } else {
                        CRYPTO = false;
                        throw Error(bignumberError + "crypto unavailable");
                    }
                }
                // Use Math.random.
                if (!CRYPTO) for(; i < k;){
                    v = random53bitInt();
                    if (v < 9e15) c[i++] = v % 1e14;
                }
                k = c[--i];
                dp %= LOG_BASE;
                // Convert trailing digits to zeros according to dp.
                if (k && dp) {
                    v = POWS_TEN[LOG_BASE - dp];
                    c[i] = mathfloor(k / v) * v;
                }
                // Remove trailing elements which are zero.
                for(; c[i] === 0; c.pop(), i--);
                // Zero?
                if (i < 0) c = [
                    e = 0
                ];
                else {
                    // Remove leading elements which are zero and adjust exponent accordingly.
                    for(e = -1; c[0] === 0; c.splice(0, 1), e -= LOG_BASE);
                    // Count the digits of the first element of c to determine leading zeros, and...
                    for(i = 1, v = c[0]; v >= 10; v /= 10, i++);
                    // adjust the exponent accordingly.
                    if (i < LOG_BASE) e -= LOG_BASE - i;
                }
                rand.e = e;
                rand.c = c;
                return rand;
            };
        }();
        /*
     * Return a BigNumber whose value is the sum of the arguments.
     *
     * arguments {number|string|BigNumber}
     */ BigNumber.sum = function() {
            var i = 1, args = arguments, sum = new BigNumber(args[0]);
            for(; i < args.length;)sum = sum.plus(args[i++]);
            return sum;
        };
        // PRIVATE FUNCTIONS
        // Called by BigNumber and BigNumber.prototype.toString.
        convertBase = function() {
            var decimal = "0123456789";
            /*
       * Convert string of baseIn to an array of numbers of baseOut.
       * Eg. toBaseOut('255', 10, 16) returns [15, 15].
       * Eg. toBaseOut('ff', 16, 10) returns [2, 5, 5].
       */ function toBaseOut(str, baseIn, baseOut, alphabet) {
                var j, arr = [
                    0
                ], arrL, i = 0, len = str.length;
                for(; i < len;){
                    for(arrL = arr.length; arrL--; arr[arrL] *= baseIn);
                    arr[0] += alphabet.indexOf(str.charAt(i++));
                    for(j = 0; j < arr.length; j++)if (arr[j] > baseOut - 1) {
                        if (arr[j + 1] == null) arr[j + 1] = 0;
                        arr[j + 1] += arr[j] / baseOut | 0;
                        arr[j] %= baseOut;
                    }
                }
                return arr.reverse();
            }
            // Convert a numeric string of baseIn to a numeric string of baseOut.
            // If the caller is toString, we are converting from base 10 to baseOut.
            // If the caller is BigNumber, we are converting from baseIn to base 10.
            return function(str, baseIn, baseOut, sign, callerIsToString) {
                var alphabet, d, e, k, r, x, xc, y, i = str.indexOf("."), dp = DECIMAL_PLACES, rm = ROUNDING_MODE;
                // Non-integer.
                if (i >= 0) {
                    k = POW_PRECISION;
                    // Unlimited precision.
                    POW_PRECISION = 0;
                    str = str.replace(".", "");
                    y = new BigNumber(baseIn);
                    x = y.pow(str.length - i);
                    POW_PRECISION = k;
                    // Convert str as if an integer, then restore the fraction part by dividing the
                    // result by its base raised to a power.
                    y.c = toBaseOut(toFixedPoint(coeffToString(x.c), x.e, "0"), 10, baseOut, decimal);
                    y.e = y.c.length;
                }
                // Convert the number as integer.
                xc = toBaseOut(str, baseIn, baseOut, callerIsToString ? (alphabet = ALPHABET, decimal) : (alphabet = decimal, ALPHABET));
                // xc now represents str as an integer and converted to baseOut. e is the exponent.
                e = k = xc.length;
                // Remove trailing zeros.
                for(; xc[--k] == 0; xc.pop());
                // Zero?
                if (!xc[0]) return alphabet.charAt(0);
                // Does str represent an integer? If so, no need for the division.
                if (i < 0) --e;
                else {
                    x.c = xc;
                    x.e = e;
                    // The sign is needed for correct rounding.
                    x.s = sign;
                    x = div(x, y, dp, rm, baseOut);
                    xc = x.c;
                    r = x.r;
                    e = x.e;
                }
                // xc now represents str converted to baseOut.
                // THe index of the rounding digit.
                d = e + dp + 1;
                // The rounding digit: the digit to the right of the digit that may be rounded up.
                i = xc[d];
                // Look at the rounding digits and mode to determine whether to round up.
                k = baseOut / 2;
                r = r || d < 0 || xc[d + 1] != null;
                r = rm < 4 ? (i != null || r) && (rm == 0 || rm == (x.s < 0 ? 3 : 2)) : i > k || i == k && (rm == 4 || r || rm == 6 && xc[d - 1] & 1 || rm == (x.s < 0 ? 8 : 7));
                // If the index of the rounding digit is not greater than zero, or xc represents
                // zero, then the result of the base conversion is zero or, if rounding up, a value
                // such as 0.00001.
                if (d < 1 || !xc[0]) // 1^-dp or 0
                str = r ? toFixedPoint(alphabet.charAt(1), -dp, alphabet.charAt(0)) : alphabet.charAt(0);
                else {
                    // Truncate xc to the required number of decimal places.
                    xc.length = d;
                    // Round up?
                    if (r) // Rounding up may mean the previous digit has to be rounded up and so on.
                    for(--baseOut; ++xc[--d] > baseOut;){
                        xc[d] = 0;
                        if (!d) {
                            ++e;
                            xc = [
                                1
                            ].concat(xc);
                        }
                    }
                    // Determine trailing zeros.
                    for(k = xc.length; !xc[--k];);
                    // E.g. [4, 11, 15] becomes 4bf.
                    for(i = 0, str = ""; i <= k; str += alphabet.charAt(xc[i++]));
                    // Add leading zeros, decimal point and trailing zeros as required.
                    str = toFixedPoint(str, e, alphabet.charAt(0));
                }
                // The caller will add the sign.
                return str;
            };
        }();
        // Perform division in the specified base. Called by div and convertBase.
        div = function() {
            // Assume non-zero x and k.
            function multiply(x, k, base) {
                var m, temp, xlo, xhi, carry = 0, i = x.length, klo = k % SQRT_BASE, khi = k / SQRT_BASE | 0;
                for(x = x.slice(); i--;){
                    xlo = x[i] % SQRT_BASE;
                    xhi = x[i] / SQRT_BASE | 0;
                    m = khi * xlo + xhi * klo;
                    temp = klo * xlo + m % SQRT_BASE * SQRT_BASE + carry;
                    carry = (temp / base | 0) + (m / SQRT_BASE | 0) + khi * xhi;
                    x[i] = temp % base;
                }
                if (carry) x = [
                    carry
                ].concat(x);
                return x;
            }
            function compare(a, b, aL, bL) {
                var i, cmp;
                if (aL != bL) cmp = aL > bL ? 1 : -1;
                else {
                    for(i = cmp = 0; i < aL; i++)if (a[i] != b[i]) {
                        cmp = a[i] > b[i] ? 1 : -1;
                        break;
                    }
                }
                return cmp;
            }
            function subtract(a, b, aL, base) {
                var i = 0;
                // Subtract b from a.
                for(; aL--;){
                    a[aL] -= i;
                    i = a[aL] < b[aL] ? 1 : 0;
                    a[aL] = i * base + a[aL] - b[aL];
                }
                // Remove leading zeros.
                for(; !a[0] && a.length > 1; a.splice(0, 1));
            }
            // x: dividend, y: divisor.
            return function(x, y, dp, rm, base) {
                var cmp, e, i, more, n, prod, prodL, q, qc, rem, remL, rem0, xi, xL, yc0, yL, yz, s = x.s == y.s ? 1 : -1, xc = x.c, yc = y.c;
                // Either NaN, Infinity or 0?
                if (!xc || !xc[0] || !yc || !yc[0]) return new BigNumber(// Return NaN if either NaN, or both Infinity or 0.
                !x.s || !y.s || (xc ? yc && xc[0] == yc[0] : !yc) ? NaN : // Return ±0 if x is ±0 or y is ±Infinity, or return ±Infinity as y is ±0.
                xc && xc[0] == 0 || !yc ? s * 0 : s / 0);
                q = new BigNumber(s);
                qc = q.c = [];
                e = x.e - y.e;
                s = dp + e + 1;
                if (!base) {
                    base = BASE;
                    e = bitFloor(x.e / LOG_BASE) - bitFloor(y.e / LOG_BASE);
                    s = s / LOG_BASE | 0;
                }
                // Result exponent may be one less then the current value of e.
                // The coefficients of the BigNumbers from convertBase may have trailing zeros.
                for(i = 0; yc[i] == (xc[i] || 0); i++);
                if (yc[i] > (xc[i] || 0)) e--;
                if (s < 0) {
                    qc.push(1);
                    more = true;
                } else {
                    xL = xc.length;
                    yL = yc.length;
                    i = 0;
                    s += 2;
                    // Normalise xc and yc so highest order digit of yc is >= base / 2.
                    n = mathfloor(base / (yc[0] + 1));
                    // Not necessary, but to handle odd bases where yc[0] == (base / 2) - 1.
                    // if (n > 1 || n++ == 1 && yc[0] < base / 2) {
                    if (n > 1) {
                        yc = multiply(yc, n, base);
                        xc = multiply(xc, n, base);
                        yL = yc.length;
                        xL = xc.length;
                    }
                    xi = yL;
                    rem = xc.slice(0, yL);
                    remL = rem.length;
                    // Add zeros to make remainder as long as divisor.
                    for(; remL < yL; rem[remL++] = 0);
                    yz = yc.slice();
                    yz = [
                        0
                    ].concat(yz);
                    yc0 = yc[0];
                    if (yc[1] >= base / 2) yc0++;
                    // Not necessary, but to prevent trial digit n > base, when using base 3.
                    // else if (base == 3 && yc0 == 1) yc0 = 1 + 1e-15;
                    do {
                        n = 0;
                        // Compare divisor and remainder.
                        cmp = compare(yc, rem, yL, remL);
                        // If divisor < remainder.
                        if (cmp < 0) {
                            // Calculate trial digit, n.
                            rem0 = rem[0];
                            if (yL != remL) rem0 = rem0 * base + (rem[1] || 0);
                            // n is how many times the divisor goes into the current remainder.
                            n = mathfloor(rem0 / yc0);
                            //  Algorithm:
                            //  product = divisor multiplied by trial digit (n).
                            //  Compare product and remainder.
                            //  If product is greater than remainder:
                            //    Subtract divisor from product, decrement trial digit.
                            //  Subtract product from remainder.
                            //  If product was less than remainder at the last compare:
                            //    Compare new remainder and divisor.
                            //    If remainder is greater than divisor:
                            //      Subtract divisor from remainder, increment trial digit.
                            if (n > 1) {
                                // n may be > base only when base is 3.
                                if (n >= base) n = base - 1;
                                // product = divisor * trial digit.
                                prod = multiply(yc, n, base);
                                prodL = prod.length;
                                remL = rem.length;
                                // Compare product and remainder.
                                // If product > remainder then trial digit n too high.
                                // n is 1 too high about 5% of the time, and is not known to have
                                // ever been more than 1 too high.
                                while(compare(prod, rem, prodL, remL) == 1){
                                    n--;
                                    // Subtract divisor from product.
                                    subtract(prod, yL < prodL ? yz : yc, prodL, base);
                                    prodL = prod.length;
                                    cmp = 1;
                                }
                            } else {
                                // n is 0 or 1, cmp is -1.
                                // If n is 0, there is no need to compare yc and rem again below,
                                // so change cmp to 1 to avoid it.
                                // If n is 1, leave cmp as -1, so yc and rem are compared again.
                                if (n == 0) // divisor < remainder, so n must be at least 1.
                                cmp = n = 1;
                                // product = divisor
                                prod = yc.slice();
                                prodL = prod.length;
                            }
                            if (prodL < remL) prod = [
                                0
                            ].concat(prod);
                            // Subtract product from remainder.
                            subtract(rem, prod, remL, base);
                            remL = rem.length;
                            // If product was < remainder.
                            if (cmp == -1) // Compare divisor and new remainder.
                            // If divisor < new remainder, subtract divisor from remainder.
                            // Trial digit n too low.
                            // n is 1 too low about 5% of the time, and very rarely 2 too low.
                            while(compare(yc, rem, yL, remL) < 1){
                                n++;
                                // Subtract divisor from remainder.
                                subtract(rem, yL < remL ? yz : yc, remL, base);
                                remL = rem.length;
                            }
                        } else if (cmp === 0) {
                            n++;
                            rem = [
                                0
                            ];
                        } // else cmp === 1 and n will be 0
                        // Add the next digit, n, to the result array.
                        qc[i++] = n;
                        // Update the remainder.
                        if (rem[0]) rem[remL++] = xc[xi] || 0;
                        else {
                            rem = [
                                xc[xi]
                            ];
                            remL = 1;
                        }
                    }while ((xi++ < xL || rem[0] != null) && s--);
                    more = rem[0] != null;
                    // Leading zero?
                    if (!qc[0]) qc.splice(0, 1);
                }
                if (base == BASE) {
                    // To calculate q.e, first get the number of digits of qc[0].
                    for(i = 1, s = qc[0]; s >= 10; s /= 10, i++);
                    round(q, dp + (q.e = i + e * LOG_BASE - 1) + 1, rm, more);
                // Caller is convertBase.
                } else {
                    q.e = e;
                    q.r = +more;
                }
                return q;
            };
        }();
        /*
     * Return a string representing the value of BigNumber n in fixed-point or exponential
     * notation rounded to the specified decimal places or significant digits.
     *
     * n: a BigNumber.
     * i: the index of the last digit required (i.e. the digit that may be rounded up).
     * rm: the rounding mode.
     * id: 1 (toExponential) or 2 (toPrecision).
     */ function format(n, i, rm, id) {
            var c0, e, ne, len, str;
            if (rm == null) rm = ROUNDING_MODE;
            else intCheck(rm, 0, 8);
            if (!n.c) return n.toString();
            c0 = n.c[0];
            ne = n.e;
            if (i == null) {
                str = coeffToString(n.c);
                str = id == 1 || id == 2 && (ne <= TO_EXP_NEG || ne >= TO_EXP_POS) ? toExponential(str, ne) : toFixedPoint(str, ne, "0");
            } else {
                n = round(new BigNumber(n), i, rm);
                // n.e may have changed if the value was rounded up.
                e = n.e;
                str = coeffToString(n.c);
                len = str.length;
                // toPrecision returns exponential notation if the number of significant digits
                // specified is less than the number of digits necessary to represent the integer
                // part of the value in fixed-point notation.
                // Exponential notation.
                if (id == 1 || id == 2 && (i <= e || e <= TO_EXP_NEG)) {
                    // Append zeros?
                    for(; len < i; str += "0", len++);
                    str = toExponential(str, e);
                // Fixed-point notation.
                } else {
                    i -= ne;
                    str = toFixedPoint(str, e, "0");
                    // Append zeros?
                    if (e + 1 > len) {
                        if (--i > 0) for(str += "."; i--; str += "0");
                    } else {
                        i += e - len;
                        if (i > 0) {
                            if (e + 1 == len) str += ".";
                            for(; i--; str += "0");
                        }
                    }
                }
            }
            return n.s < 0 && c0 ? "-" + str : str;
        }
        // Handle BigNumber.max and BigNumber.min.
        // If any number is NaN, return NaN.
        function maxOrMin(args, n) {
            var k, y, i = 1, x = new BigNumber(args[0]);
            for(; i < args.length; i++){
                y = new BigNumber(args[i]);
                if (!y.s || (k = compare(x, y)) === n || k === 0 && x.s === n) x = y;
            }
            return x;
        }
        /*
     * Strip trailing zeros, calculate base 10 exponent and check against MIN_EXP and MAX_EXP.
     * Called by minus, plus and times.
     */ function normalise(n, c, e) {
            var i = 1, j = c.length;
            // Remove trailing zeros.
            for(; !c[--j]; c.pop());
            // Calculate the base 10 exponent. First get the number of digits of c[0].
            for(j = c[0]; j >= 10; j /= 10, i++);
            // Overflow?
            if ((e = i + e * LOG_BASE - 1) > MAX_EXP) // Infinity.
            n.c = n.e = null;
            else if (e < MIN_EXP) // Zero.
            n.c = [
                n.e = 0
            ];
            else {
                n.e = e;
                n.c = c;
            }
            return n;
        }
        // Handle values that fail the validity test in BigNumber.
        parseNumeric = function() {
            var basePrefix = /^(-?)0([xbo])(?=\w[\w.]*$)/i, dotAfter = /^([^.]+)\.$/, dotBefore = /^\.([^.]+)$/, isInfinityOrNaN = /^-?(Infinity|NaN)$/, whitespaceOrPlus = /^\s*\+(?=[\w.])|^\s+|\s+$/g;
            return function(x, str, isNum, b) {
                var base, s = isNum ? str : str.replace(whitespaceOrPlus, "");
                // No exception on ±Infinity or NaN.
                if (isInfinityOrNaN.test(s)) x.s = isNaN(s) ? null : s < 0 ? -1 : 1;
                else {
                    if (!isNum) {
                        // basePrefix = /^(-?)0([xbo])(?=\w[\w.]*$)/i
                        s = s.replace(basePrefix, function(m, p1, p2) {
                            base = (p2 = p2.toLowerCase()) == "x" ? 16 : p2 == "b" ? 2 : 8;
                            return !b || b == base ? p1 : m;
                        });
                        if (b) {
                            base = b;
                            // E.g. '1.' to '1', '.1' to '0.1'
                            s = s.replace(dotAfter, "$1").replace(dotBefore, "0.$1");
                        }
                        if (str != s) return new BigNumber(s, base);
                    }
                    // '[BigNumber Error] Not a number: {n}'
                    // '[BigNumber Error] Not a base {b} number: {n}'
                    if (BigNumber.DEBUG) throw Error(bignumberError + "Not a" + (b ? " base " + b : "") + " number: " + str);
                    // NaN
                    x.s = null;
                }
                x.c = x.e = null;
            };
        }();
        /*
     * Round x to sd significant digits using rounding mode rm. Check for over/under-flow.
     * If r is truthy, it is known that there are more digits after the rounding digit.
     */ function round(x, sd, rm, r) {
            var d, i, j, k, n, ni, rd, xc = x.c, pows10 = POWS_TEN;
            // if x is not Infinity or NaN...
            if (xc) {
                // rd is the rounding digit, i.e. the digit after the digit that may be rounded up.
                // n is a base 1e14 number, the value of the element of array x.c containing rd.
                // ni is the index of n within x.c.
                // d is the number of digits of n.
                // i is the index of rd within n including leading zeros.
                // j is the actual index of rd within n (if < 0, rd is a leading zero).
                out: {
                    // Get the number of digits of the first element of xc.
                    for(d = 1, k = xc[0]; k >= 10; k /= 10, d++);
                    i = sd - d;
                    // If the rounding digit is in the first element of xc...
                    if (i < 0) {
                        i += LOG_BASE;
                        j = sd;
                        n = xc[ni = 0];
                        // Get the rounding digit at index j of n.
                        rd = mathfloor(n / pows10[d - j - 1] % 10);
                    } else {
                        ni = mathceil((i + 1) / LOG_BASE);
                        if (ni >= xc.length) {
                            if (r) {
                                // Needed by sqrt.
                                for(; xc.length <= ni; xc.push(0));
                                n = rd = 0;
                                d = 1;
                                i %= LOG_BASE;
                                j = i - LOG_BASE + 1;
                            } else break out;
                        } else {
                            n = k = xc[ni];
                            // Get the number of digits of n.
                            for(d = 1; k >= 10; k /= 10, d++);
                            // Get the index of rd within n.
                            i %= LOG_BASE;
                            // Get the index of rd within n, adjusted for leading zeros.
                            // The number of leading zeros of n is given by LOG_BASE - d.
                            j = i - LOG_BASE + d;
                            // Get the rounding digit at index j of n.
                            rd = j < 0 ? 0 : mathfloor(n / pows10[d - j - 1] % 10);
                        }
                    }
                    r = r || sd < 0 || // Are there any non-zero digits after the rounding digit?
                    // The expression  n % pows10[d - j - 1]  returns all digits of n to the right
                    // of the digit at j, e.g. if n is 908714 and j is 2, the expression gives 714.
                    xc[ni + 1] != null || (j < 0 ? n : n % pows10[d - j - 1]);
                    r = rm < 4 ? (rd || r) && (rm == 0 || rm == (x.s < 0 ? 3 : 2)) : rd > 5 || rd == 5 && (rm == 4 || r || rm == 6 && (i > 0 ? j > 0 ? n / pows10[d - j] : 0 : xc[ni - 1]) % 10 & 1 || rm == (x.s < 0 ? 8 : 7));
                    if (sd < 1 || !xc[0]) {
                        xc.length = 0;
                        if (r) {
                            // Convert sd to decimal places.
                            sd -= x.e + 1;
                            // 1, 0.1, 0.01, 0.001, 0.0001 etc.
                            xc[0] = pows10[(LOG_BASE - sd % LOG_BASE) % LOG_BASE];
                            x.e = -sd || 0;
                        } else // Zero.
                        xc[0] = x.e = 0;
                        return x;
                    }
                    // Remove excess digits.
                    if (i == 0) {
                        xc.length = ni;
                        k = 1;
                        ni--;
                    } else {
                        xc.length = ni + 1;
                        k = pows10[LOG_BASE - i];
                        // E.g. 56700 becomes 56000 if 7 is the rounding digit.
                        // j > 0 means i > number of leading zeros of n.
                        xc[ni] = j > 0 ? mathfloor(n / pows10[d - j] % pows10[j]) * k : 0;
                    }
                    // Round up?
                    if (r) {
                        for(;;)// If the digit to be rounded up is in the first element of xc...
                        if (ni == 0) {
                            // i will be the length of xc[0] before k is added.
                            for(i = 1, j = xc[0]; j >= 10; j /= 10, i++);
                            j = xc[0] += k;
                            for(k = 1; j >= 10; j /= 10, k++);
                            // if i != k the length has increased.
                            if (i != k) {
                                x.e++;
                                if (xc[0] == BASE) xc[0] = 1;
                            }
                            break;
                        } else {
                            xc[ni] += k;
                            if (xc[ni] != BASE) break;
                            xc[ni--] = 0;
                            k = 1;
                        }
                    }
                    // Remove trailing zeros.
                    for(i = xc.length; xc[--i] === 0; xc.pop());
                }
                // Overflow? Infinity.
                if (x.e > MAX_EXP) x.c = x.e = null;
                else if (x.e < MIN_EXP) x.c = [
                    x.e = 0
                ];
            }
            return x;
        }
        function valueOf(n) {
            var str, e = n.e;
            if (e === null) return n.toString();
            str = coeffToString(n.c);
            str = e <= TO_EXP_NEG || e >= TO_EXP_POS ? toExponential(str, e) : toFixedPoint(str, e, "0");
            return n.s < 0 ? "-" + str : str;
        }
        // PROTOTYPE/INSTANCE METHODS
        /*
     * Return a new BigNumber whose value is the absolute value of this BigNumber.
     */ P.absoluteValue = P.abs = function() {
            var x = new BigNumber(this);
            if (x.s < 0) x.s = 1;
            return x;
        };
        /*
     * Return
     *   1 if the value of this BigNumber is greater than the value of BigNumber(y, b),
     *   -1 if the value of this BigNumber is less than the value of BigNumber(y, b),
     *   0 if they have the same value,
     *   or null if the value of either is NaN.
     */ P.comparedTo = function(y, b) {
            return compare(this, new BigNumber(y, b));
        };
        /*
     * If dp is undefined or null or true or false, return the number of decimal places of the
     * value of this BigNumber, or null if the value of this BigNumber is ±Infinity or NaN.
     *
     * Otherwise, if dp is a number, return a new BigNumber whose value is the value of this
     * BigNumber rounded to a maximum of dp decimal places using rounding mode rm, or
     * ROUNDING_MODE if rm is omitted.
     *
     * [dp] {number} Decimal places: integer, 0 to MAX inclusive.
     * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
     *
     * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {dp|rm}'
     */ P.decimalPlaces = P.dp = function(dp, rm) {
            var c, n, v, x = this;
            if (dp != null) {
                intCheck(dp, 0, MAX);
                if (rm == null) rm = ROUNDING_MODE;
                else intCheck(rm, 0, 8);
                return round(new BigNumber(x), dp + x.e + 1, rm);
            }
            if (!(c = x.c)) return null;
            n = ((v = c.length - 1) - bitFloor(this.e / LOG_BASE)) * LOG_BASE;
            // Subtract the number of trailing zeros of the last number.
            if (v = c[v]) for(; v % 10 == 0; v /= 10, n--);
            if (n < 0) n = 0;
            return n;
        };
        /*
     *  n / 0 = I
     *  n / N = N
     *  n / I = 0
     *  0 / n = 0
     *  0 / 0 = N
     *  0 / N = N
     *  0 / I = 0
     *  N / n = N
     *  N / 0 = N
     *  N / N = N
     *  N / I = N
     *  I / n = I
     *  I / 0 = I
     *  I / N = N
     *  I / I = N
     *
     * Return a new BigNumber whose value is the value of this BigNumber divided by the value of
     * BigNumber(y, b), rounded according to DECIMAL_PLACES and ROUNDING_MODE.
     */ P.dividedBy = P.div = function(y, b) {
            return div(this, new BigNumber(y, b), DECIMAL_PLACES, ROUNDING_MODE);
        };
        /*
     * Return a new BigNumber whose value is the integer part of dividing the value of this
     * BigNumber by the value of BigNumber(y, b).
     */ P.dividedToIntegerBy = P.idiv = function(y, b) {
            return div(this, new BigNumber(y, b), 0, 1);
        };
        /*
     * Return a BigNumber whose value is the value of this BigNumber exponentiated by n.
     *
     * If m is present, return the result modulo m.
     * If n is negative round according to DECIMAL_PLACES and ROUNDING_MODE.
     * If POW_PRECISION is non-zero and m is not present, round to POW_PRECISION using ROUNDING_MODE.
     *
     * The modular power operation works efficiently when x, n, and m are integers, otherwise it
     * is equivalent to calculating x.exponentiatedBy(n).modulo(m) with a POW_PRECISION of 0.
     *
     * n {number|string|BigNumber} The exponent. An integer.
     * [m] {number|string|BigNumber} The modulus.
     *
     * '[BigNumber Error] Exponent not an integer: {n}'
     */ P.exponentiatedBy = P.pow = function(n, m) {
            var half, isModExp, i, k, more, nIsBig, nIsNeg, nIsOdd, y, x = this;
            n = new BigNumber(n);
            // Allow NaN and ±Infinity, but not other non-integers.
            if (n.c && !n.isInteger()) throw Error(bignumberError + "Exponent not an integer: " + valueOf(n));
            if (m != null) m = new BigNumber(m);
            // Exponent of MAX_SAFE_INTEGER is 15.
            nIsBig = n.e > 14;
            // If x is NaN, ±Infinity, ±0 or ±1, or n is ±Infinity, NaN or ±0.
            if (!x.c || !x.c[0] || x.c[0] == 1 && !x.e && x.c.length == 1 || !n.c || !n.c[0]) {
                // The sign of the result of pow when x is negative depends on the evenness of n.
                // If +n overflows to ±Infinity, the evenness of n would be not be known.
                y = new BigNumber(Math.pow(+valueOf(x), nIsBig ? n.s * (2 - isOdd(n)) : +valueOf(n)));
                return m ? y.mod(m) : y;
            }
            nIsNeg = n.s < 0;
            if (m) {
                // x % m returns NaN if abs(m) is zero, or m is NaN.
                if (m.c ? !m.c[0] : !m.s) return new BigNumber(NaN);
                isModExp = !nIsNeg && x.isInteger() && m.isInteger();
                if (isModExp) x = x.mod(m);
            // Overflow to ±Infinity: >=2**1e10 or >=1.0000024**1e15.
            // Underflow to ±0: <=0.79**1e10 or <=0.9999975**1e15.
            } else if (n.e > 9 && (x.e > 0 || x.e < -1 || (x.e == 0 ? x.c[0] > 1 || nIsBig && x.c[1] >= 24e7 : x.c[0] < 8e13 || nIsBig && x.c[0] <= 9999975e7))) {
                // If x is negative and n is odd, k = -0, else k = 0.
                k = x.s < 0 && isOdd(n) ? -0 : 0;
                // If x >= 1, k = ±Infinity.
                if (x.e > -1) k = 1 / k;
                // If n is negative return ±0, else return ±Infinity.
                return new BigNumber(nIsNeg ? 1 / k : k);
            } else if (POW_PRECISION) // Truncating each coefficient array to a length of k after each multiplication
            // equates to truncating significant digits to POW_PRECISION + [28, 41],
            // i.e. there will be a minimum of 28 guard digits retained.
            k = mathceil(POW_PRECISION / LOG_BASE + 2);
            if (nIsBig) {
                half = new BigNumber(0.5);
                if (nIsNeg) n.s = 1;
                nIsOdd = isOdd(n);
            } else {
                i = Math.abs(+valueOf(n));
                nIsOdd = i % 2;
            }
            y = new BigNumber(ONE);
            // Performs 54 loop iterations for n of 9007199254740991.
            for(;;){
                if (nIsOdd) {
                    y = y.times(x);
                    if (!y.c) break;
                    if (k) {
                        if (y.c.length > k) y.c.length = k;
                    } else if (isModExp) y = y.mod(m); //y = y.minus(div(y, m, 0, MODULO_MODE).times(m));
                }
                if (i) {
                    i = mathfloor(i / 2);
                    if (i === 0) break;
                    nIsOdd = i % 2;
                } else {
                    n = n.times(half);
                    round(n, n.e + 1, 1);
                    if (n.e > 14) nIsOdd = isOdd(n);
                    else {
                        i = +valueOf(n);
                        if (i === 0) break;
                        nIsOdd = i % 2;
                    }
                }
                x = x.times(x);
                if (k) {
                    if (x.c && x.c.length > k) x.c.length = k;
                } else if (isModExp) x = x.mod(m); //x = x.minus(div(x, m, 0, MODULO_MODE).times(m));
            }
            if (isModExp) return y;
            if (nIsNeg) y = ONE.div(y);
            return m ? y.mod(m) : k ? round(y, POW_PRECISION, ROUNDING_MODE, more) : y;
        };
        /*
     * Return a new BigNumber whose value is the value of this BigNumber rounded to an integer
     * using rounding mode rm, or ROUNDING_MODE if rm is omitted.
     *
     * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
     *
     * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {rm}'
     */ P.integerValue = function(rm) {
            var n = new BigNumber(this);
            if (rm == null) rm = ROUNDING_MODE;
            else intCheck(rm, 0, 8);
            return round(n, n.e + 1, rm);
        };
        /*
     * Return true if the value of this BigNumber is equal to the value of BigNumber(y, b),
     * otherwise return false.
     */ P.isEqualTo = P.eq = function(y, b) {
            return compare(this, new BigNumber(y, b)) === 0;
        };
        /*
     * Return true if the value of this BigNumber is a finite number, otherwise return false.
     */ P.isFinite = function() {
            return !!this.c;
        };
        /*
     * Return true if the value of this BigNumber is greater than the value of BigNumber(y, b),
     * otherwise return false.
     */ P.isGreaterThan = P.gt = function(y, b) {
            return compare(this, new BigNumber(y, b)) > 0;
        };
        /*
     * Return true if the value of this BigNumber is greater than or equal to the value of
     * BigNumber(y, b), otherwise return false.
     */ P.isGreaterThanOrEqualTo = P.gte = function(y, b) {
            return (b = compare(this, new BigNumber(y, b))) === 1 || b === 0;
        };
        /*
     * Return true if the value of this BigNumber is an integer, otherwise return false.
     */ P.isInteger = function() {
            return !!this.c && bitFloor(this.e / LOG_BASE) > this.c.length - 2;
        };
        /*
     * Return true if the value of this BigNumber is less than the value of BigNumber(y, b),
     * otherwise return false.
     */ P.isLessThan = P.lt = function(y, b) {
            return compare(this, new BigNumber(y, b)) < 0;
        };
        /*
     * Return true if the value of this BigNumber is less than or equal to the value of
     * BigNumber(y, b), otherwise return false.
     */ P.isLessThanOrEqualTo = P.lte = function(y, b) {
            return (b = compare(this, new BigNumber(y, b))) === -1 || b === 0;
        };
        /*
     * Return true if the value of this BigNumber is NaN, otherwise return false.
     */ P.isNaN = function() {
            return !this.s;
        };
        /*
     * Return true if the value of this BigNumber is negative, otherwise return false.
     */ P.isNegative = function() {
            return this.s < 0;
        };
        /*
     * Return true if the value of this BigNumber is positive, otherwise return false.
     */ P.isPositive = function() {
            return this.s > 0;
        };
        /*
     * Return true if the value of this BigNumber is 0 or -0, otherwise return false.
     */ P.isZero = function() {
            return !!this.c && this.c[0] == 0;
        };
        /*
     *  n - 0 = n
     *  n - N = N
     *  n - I = -I
     *  0 - n = -n
     *  0 - 0 = 0
     *  0 - N = N
     *  0 - I = -I
     *  N - n = N
     *  N - 0 = N
     *  N - N = N
     *  N - I = N
     *  I - n = I
     *  I - 0 = I
     *  I - N = N
     *  I - I = N
     *
     * Return a new BigNumber whose value is the value of this BigNumber minus the value of
     * BigNumber(y, b).
     */ P.minus = function(y, b) {
            var i, j, t, xLTy, x = this, a = x.s;
            y = new BigNumber(y, b);
            b = y.s;
            // Either NaN?
            if (!a || !b) return new BigNumber(NaN);
            // Signs differ?
            if (a != b) {
                y.s = -b;
                return x.plus(y);
            }
            var xe = x.e / LOG_BASE, ye = y.e / LOG_BASE, xc = x.c, yc = y.c;
            if (!xe || !ye) {
                // Either Infinity?
                if (!xc || !yc) return xc ? (y.s = -b, y) : new BigNumber(yc ? x : NaN);
                // Either zero?
                if (!xc[0] || !yc[0]) // Return y if y is non-zero, x if x is non-zero, or zero if both are zero.
                return yc[0] ? (y.s = -b, y) : new BigNumber(xc[0] ? x : // IEEE 754 (2008) 6.3: n - n = -0 when rounding to -Infinity
                ROUNDING_MODE == 3 ? -0 : 0);
            }
            xe = bitFloor(xe);
            ye = bitFloor(ye);
            xc = xc.slice();
            // Determine which is the bigger number.
            if (a = xe - ye) {
                if (xLTy = a < 0) {
                    a = -a;
                    t = xc;
                } else {
                    ye = xe;
                    t = yc;
                }
                t.reverse();
                // Prepend zeros to equalise exponents.
                for(b = a; b--; t.push(0));
                t.reverse();
            } else {
                // Exponents equal. Check digit by digit.
                j = (xLTy = (a = xc.length) < (b = yc.length)) ? a : b;
                for(a = b = 0; b < j; b++)if (xc[b] != yc[b]) {
                    xLTy = xc[b] < yc[b];
                    break;
                }
            }
            // x < y? Point xc to the array of the bigger number.
            if (xLTy) {
                t = xc;
                xc = yc;
                yc = t;
                y.s = -y.s;
            }
            b = (j = yc.length) - (i = xc.length);
            // Append zeros to xc if shorter.
            // No need to add zeros to yc if shorter as subtract only needs to start at yc.length.
            if (b > 0) for(; b--; xc[i++] = 0);
            b = BASE - 1;
            // Subtract yc from xc.
            for(; j > a;){
                if (xc[--j] < yc[j]) {
                    for(i = j; i && !xc[--i]; xc[i] = b);
                    --xc[i];
                    xc[j] += BASE;
                }
                xc[j] -= yc[j];
            }
            // Remove leading zeros and adjust exponent accordingly.
            for(; xc[0] == 0; xc.splice(0, 1), --ye);
            // Zero?
            if (!xc[0]) {
                // Following IEEE 754 (2008) 6.3,
                // n - n = +0  but  n - n = -0  when rounding towards -Infinity.
                y.s = ROUNDING_MODE == 3 ? -1 : 1;
                y.c = [
                    y.e = 0
                ];
                return y;
            }
            // No need to check for Infinity as +x - +y != Infinity && -x - -y != Infinity
            // for finite x and y.
            return normalise(y, xc, ye);
        };
        /*
     *   n % 0 =  N
     *   n % N =  N
     *   n % I =  n
     *   0 % n =  0
     *  -0 % n = -0
     *   0 % 0 =  N
     *   0 % N =  N
     *   0 % I =  0
     *   N % n =  N
     *   N % 0 =  N
     *   N % N =  N
     *   N % I =  N
     *   I % n =  N
     *   I % 0 =  N
     *   I % N =  N
     *   I % I =  N
     *
     * Return a new BigNumber whose value is the value of this BigNumber modulo the value of
     * BigNumber(y, b). The result depends on the value of MODULO_MODE.
     */ P.modulo = P.mod = function(y, b) {
            var q, s, x = this;
            y = new BigNumber(y, b);
            // Return NaN if x is Infinity or NaN, or y is NaN or zero.
            if (!x.c || !y.s || y.c && !y.c[0]) return new BigNumber(NaN);
            else if (!y.c || x.c && !x.c[0]) return new BigNumber(x);
            if (MODULO_MODE == 9) {
                // Euclidian division: q = sign(y) * floor(x / abs(y))
                // r = x - qy    where  0 <= r < abs(y)
                s = y.s;
                y.s = 1;
                q = div(x, y, 0, 3);
                y.s = s;
                q.s *= s;
            } else q = div(x, y, 0, MODULO_MODE);
            y = x.minus(q.times(y));
            // To match JavaScript %, ensure sign of zero is sign of dividend.
            if (!y.c[0] && MODULO_MODE == 1) y.s = x.s;
            return y;
        };
        /*
     *  n * 0 = 0
     *  n * N = N
     *  n * I = I
     *  0 * n = 0
     *  0 * 0 = 0
     *  0 * N = N
     *  0 * I = N
     *  N * n = N
     *  N * 0 = N
     *  N * N = N
     *  N * I = N
     *  I * n = I
     *  I * 0 = N
     *  I * N = N
     *  I * I = I
     *
     * Return a new BigNumber whose value is the value of this BigNumber multiplied by the value
     * of BigNumber(y, b).
     */ P.multipliedBy = P.times = function(y, b) {
            var c, e, i, j, k, m, xcL, xlo, xhi, ycL, ylo, yhi, zc, base, sqrtBase, x = this, xc = x.c, yc = (y = new BigNumber(y, b)).c;
            // Either NaN, ±Infinity or ±0?
            if (!xc || !yc || !xc[0] || !yc[0]) {
                // Return NaN if either is NaN, or one is 0 and the other is Infinity.
                if (!x.s || !y.s || xc && !xc[0] && !yc || yc && !yc[0] && !xc) y.c = y.e = y.s = null;
                else {
                    y.s *= x.s;
                    // Return ±Infinity if either is ±Infinity.
                    if (!xc || !yc) y.c = y.e = null;
                    else {
                        y.c = [
                            0
                        ];
                        y.e = 0;
                    }
                }
                return y;
            }
            e = bitFloor(x.e / LOG_BASE) + bitFloor(y.e / LOG_BASE);
            y.s *= x.s;
            xcL = xc.length;
            ycL = yc.length;
            // Ensure xc points to longer array and xcL to its length.
            if (xcL < ycL) {
                zc = xc;
                xc = yc;
                yc = zc;
                i = xcL;
                xcL = ycL;
                ycL = i;
            }
            // Initialise the result array with zeros.
            for(i = xcL + ycL, zc = []; i--; zc.push(0));
            base = BASE;
            sqrtBase = SQRT_BASE;
            for(i = ycL; --i >= 0;){
                c = 0;
                ylo = yc[i] % sqrtBase;
                yhi = yc[i] / sqrtBase | 0;
                for(k = xcL, j = i + k; j > i;){
                    xlo = xc[--k] % sqrtBase;
                    xhi = xc[k] / sqrtBase | 0;
                    m = yhi * xlo + xhi * ylo;
                    xlo = ylo * xlo + m % sqrtBase * sqrtBase + zc[j] + c;
                    c = (xlo / base | 0) + (m / sqrtBase | 0) + yhi * xhi;
                    zc[j--] = xlo % base;
                }
                zc[j] = c;
            }
            if (c) ++e;
            else zc.splice(0, 1);
            return normalise(y, zc, e);
        };
        /*
     * Return a new BigNumber whose value is the value of this BigNumber negated,
     * i.e. multiplied by -1.
     */ P.negated = function() {
            var x = new BigNumber(this);
            x.s = -x.s || null;
            return x;
        };
        /*
     *  n + 0 = n
     *  n + N = N
     *  n + I = I
     *  0 + n = n
     *  0 + 0 = 0
     *  0 + N = N
     *  0 + I = I
     *  N + n = N
     *  N + 0 = N
     *  N + N = N
     *  N + I = N
     *  I + n = I
     *  I + 0 = I
     *  I + N = N
     *  I + I = I
     *
     * Return a new BigNumber whose value is the value of this BigNumber plus the value of
     * BigNumber(y, b).
     */ P.plus = function(y, b) {
            var t, x = this, a = x.s;
            y = new BigNumber(y, b);
            b = y.s;
            // Either NaN?
            if (!a || !b) return new BigNumber(NaN);
            // Signs differ?
            if (a != b) {
                y.s = -b;
                return x.minus(y);
            }
            var xe = x.e / LOG_BASE, ye = y.e / LOG_BASE, xc = x.c, yc = y.c;
            if (!xe || !ye) {
                // Return ±Infinity if either ±Infinity.
                if (!xc || !yc) return new BigNumber(a / 0);
                // Either zero?
                // Return y if y is non-zero, x if x is non-zero, or zero if both are zero.
                if (!xc[0] || !yc[0]) return yc[0] ? y : new BigNumber(xc[0] ? x : a * 0);
            }
            xe = bitFloor(xe);
            ye = bitFloor(ye);
            xc = xc.slice();
            // Prepend zeros to equalise exponents. Faster to use reverse then do unshifts.
            if (a = xe - ye) {
                if (a > 0) {
                    ye = xe;
                    t = yc;
                } else {
                    a = -a;
                    t = xc;
                }
                t.reverse();
                for(; a--; t.push(0));
                t.reverse();
            }
            a = xc.length;
            b = yc.length;
            // Point xc to the longer array, and b to the shorter length.
            if (a - b < 0) {
                t = yc;
                yc = xc;
                xc = t;
                b = a;
            }
            // Only start adding at yc.length - 1 as the further digits of xc can be ignored.
            for(a = 0; b;){
                a = (xc[--b] = xc[b] + yc[b] + a) / BASE | 0;
                xc[b] = BASE === xc[b] ? 0 : xc[b] % BASE;
            }
            if (a) {
                xc = [
                    a
                ].concat(xc);
                ++ye;
            }
            // No need to check for zero, as +x + +y != 0 && -x + -y != 0
            // ye = MAX_EXP + 1 possible
            return normalise(y, xc, ye);
        };
        /*
     * If sd is undefined or null or true or false, return the number of significant digits of
     * the value of this BigNumber, or null if the value of this BigNumber is ±Infinity or NaN.
     * If sd is true include integer-part trailing zeros in the count.
     *
     * Otherwise, if sd is a number, return a new BigNumber whose value is the value of this
     * BigNumber rounded to a maximum of sd significant digits using rounding mode rm, or
     * ROUNDING_MODE if rm is omitted.
     *
     * sd {number|boolean} number: significant digits: integer, 1 to MAX inclusive.
     *                     boolean: whether to count integer-part trailing zeros: true or false.
     * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
     *
     * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {sd|rm}'
     */ P.precision = P.sd = function(sd, rm) {
            var c, n, v, x = this;
            if (sd != null && sd !== !!sd) {
                intCheck(sd, 1, MAX);
                if (rm == null) rm = ROUNDING_MODE;
                else intCheck(rm, 0, 8);
                return round(new BigNumber(x), sd, rm);
            }
            if (!(c = x.c)) return null;
            v = c.length - 1;
            n = v * LOG_BASE + 1;
            if (v = c[v]) {
                // Subtract the number of trailing zeros of the last element.
                for(; v % 10 == 0; v /= 10, n--);
                // Add the number of digits of the first element.
                for(v = c[0]; v >= 10; v /= 10, n++);
            }
            if (sd && x.e + 1 > n) n = x.e + 1;
            return n;
        };
        /*
     * Return a new BigNumber whose value is the value of this BigNumber shifted by k places
     * (powers of 10). Shift to the right if n > 0, and to the left if n < 0.
     *
     * k {number} Integer, -MAX_SAFE_INTEGER to MAX_SAFE_INTEGER inclusive.
     *
     * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {k}'
     */ P.shiftedBy = function(k) {
            intCheck(k, -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER);
            return this.times("1e" + k);
        };
        /*
     *  sqrt(-n) =  N
     *  sqrt(N) =  N
     *  sqrt(-I) =  N
     *  sqrt(I) =  I
     *  sqrt(0) =  0
     *  sqrt(-0) = -0
     *
     * Return a new BigNumber whose value is the square root of the value of this BigNumber,
     * rounded according to DECIMAL_PLACES and ROUNDING_MODE.
     */ P.squareRoot = P.sqrt = function() {
            var m, n, r, rep, t, x = this, c = x.c, s = x.s, e = x.e, dp = DECIMAL_PLACES + 4, half = new BigNumber("0.5");
            // Negative/NaN/Infinity/zero?
            if (s !== 1 || !c || !c[0]) return new BigNumber(!s || s < 0 && (!c || c[0]) ? NaN : c ? x : 1 / 0);
            // Initial estimate.
            s = Math.sqrt(+valueOf(x));
            // Math.sqrt underflow/overflow?
            // Pass x to Math.sqrt as integer, then adjust the exponent of the result.
            if (s == 0 || s == 1 / 0) {
                n = coeffToString(c);
                if ((n.length + e) % 2 == 0) n += "0";
                s = Math.sqrt(+n);
                e = bitFloor((e + 1) / 2) - (e < 0 || e % 2);
                if (s == 1 / 0) n = "5e" + e;
                else {
                    n = s.toExponential();
                    n = n.slice(0, n.indexOf("e") + 1) + e;
                }
                r = new BigNumber(n);
            } else r = new BigNumber(s + "");
            // Check for zero.
            // r could be zero if MIN_EXP is changed after the this value was created.
            // This would cause a division by zero (x/t) and hence Infinity below, which would cause
            // coeffToString to throw.
            if (r.c[0]) {
                e = r.e;
                s = e + dp;
                if (s < 3) s = 0;
                // Newton-Raphson iteration.
                for(;;){
                    t = r;
                    r = half.times(t.plus(div(x, t, dp, 1)));
                    if (coeffToString(t.c).slice(0, s) === (n = coeffToString(r.c)).slice(0, s)) {
                        // The exponent of r may here be one less than the final result exponent,
                        // e.g 0.0009999 (e-4) --> 0.001 (e-3), so adjust s so the rounding digits
                        // are indexed correctly.
                        if (r.e < e) --s;
                        n = n.slice(s - 3, s + 1);
                        // The 4th rounding digit may be in error by -1 so if the 4 rounding digits
                        // are 9999 or 4999 (i.e. approaching a rounding boundary) continue the
                        // iteration.
                        if (n == "9999" || !rep && n == "4999") {
                            // On the first iteration only, check to see if rounding up gives the
                            // exact result as the nines may infinitely repeat.
                            if (!rep) {
                                round(t, t.e + DECIMAL_PLACES + 2, 0);
                                if (t.times(t).eq(x)) {
                                    r = t;
                                    break;
                                }
                            }
                            dp += 4;
                            s += 4;
                            rep = 1;
                        } else {
                            // If rounding digits are null, 0{0,4} or 50{0,3}, check for exact
                            // result. If not, then there are further digits and m will be truthy.
                            if (!+n || !+n.slice(1) && n.charAt(0) == "5") {
                                // Truncate to the first rounding digit.
                                round(r, r.e + DECIMAL_PLACES + 2, 1);
                                m = !r.times(r).eq(x);
                            }
                            break;
                        }
                    }
                }
            }
            return round(r, r.e + DECIMAL_PLACES + 1, ROUNDING_MODE, m);
        };
        /*
     * Return a string representing the value of this BigNumber in exponential notation and
     * rounded using ROUNDING_MODE to dp fixed decimal places.
     *
     * [dp] {number} Decimal places. Integer, 0 to MAX inclusive.
     * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
     *
     * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {dp|rm}'
     */ P.toExponential = function(dp, rm) {
            if (dp != null) {
                intCheck(dp, 0, MAX);
                dp++;
            }
            return format(this, dp, rm, 1);
        };
        /*
     * Return a string representing the value of this BigNumber in fixed-point notation rounding
     * to dp fixed decimal places using rounding mode rm, or ROUNDING_MODE if rm is omitted.
     *
     * Note: as with JavaScript's number type, (-0).toFixed(0) is '0',
     * but e.g. (-0.00001).toFixed(0) is '-0'.
     *
     * [dp] {number} Decimal places. Integer, 0 to MAX inclusive.
     * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
     *
     * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {dp|rm}'
     */ P.toFixed = function(dp, rm) {
            if (dp != null) {
                intCheck(dp, 0, MAX);
                dp = dp + this.e + 1;
            }
            return format(this, dp, rm);
        };
        /*
     * Return a string representing the value of this BigNumber in fixed-point notation rounded
     * using rm or ROUNDING_MODE to dp decimal places, and formatted according to the properties
     * of the format or FORMAT object (see BigNumber.set).
     *
     * The formatting object may contain some or all of the properties shown below.
     *
     * FORMAT = {
     *   prefix: '',
     *   groupSize: 3,
     *   secondaryGroupSize: 0,
     *   groupSeparator: ',',
     *   decimalSeparator: '.',
     *   fractionGroupSize: 0,
     *   fractionGroupSeparator: '\xA0',      // non-breaking space
     *   suffix: ''
     * };
     *
     * [dp] {number} Decimal places. Integer, 0 to MAX inclusive.
     * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
     * [format] {object} Formatting options. See FORMAT pbject above.
     *
     * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {dp|rm}'
     * '[BigNumber Error] Argument not an object: {format}'
     */ P.toFormat = function(dp, rm, format) {
            var str, x = this;
            if (format == null) {
                if (dp != null && rm && typeof rm == "object") {
                    format = rm;
                    rm = null;
                } else if (dp && typeof dp == "object") {
                    format = dp;
                    dp = rm = null;
                } else format = FORMAT;
            } else if (typeof format != "object") throw Error(bignumberError + "Argument not an object: " + format);
            str = x.toFixed(dp, rm);
            if (x.c) {
                var i, arr = str.split("."), g1 = +format.groupSize, g2 = +format.secondaryGroupSize, groupSeparator = format.groupSeparator || "", intPart = arr[0], fractionPart = arr[1], isNeg = x.s < 0, intDigits = isNeg ? intPart.slice(1) : intPart, len = intDigits.length;
                if (g2) {
                    i = g1;
                    g1 = g2;
                    g2 = i;
                    len -= i;
                }
                if (g1 > 0 && len > 0) {
                    i = len % g1 || g1;
                    intPart = intDigits.substr(0, i);
                    for(; i < len; i += g1)intPart += groupSeparator + intDigits.substr(i, g1);
                    if (g2 > 0) intPart += groupSeparator + intDigits.slice(i);
                    if (isNeg) intPart = "-" + intPart;
                }
                str = fractionPart ? intPart + (format.decimalSeparator || "") + ((g2 = +format.fractionGroupSize) ? fractionPart.replace(new RegExp("\\d{" + g2 + "}\\B", "g"), "$&" + (format.fractionGroupSeparator || "")) : fractionPart) : intPart;
            }
            return (format.prefix || "") + str + (format.suffix || "");
        };
        /*
     * Return an array of two BigNumbers representing the value of this BigNumber as a simple
     * fraction with an integer numerator and an integer denominator.
     * The denominator will be a positive non-zero value less than or equal to the specified
     * maximum denominator. If a maximum denominator is not specified, the denominator will be
     * the lowest value necessary to represent the number exactly.
     *
     * [md] {number|string|BigNumber} Integer >= 1, or Infinity. The maximum denominator.
     *
     * '[BigNumber Error] Argument {not an integer|out of range} : {md}'
     */ P.toFraction = function(md) {
            var d, d0, d1, d2, e, exp, n, n0, n1, q, r, s, x = this, xc = x.c;
            if (md != null) {
                n = new BigNumber(md);
                // Throw if md is less than one or is not an integer, unless it is Infinity.
                if (!n.isInteger() && (n.c || n.s !== 1) || n.lt(ONE)) throw Error(bignumberError + "Argument " + (n.isInteger() ? "out of range: " : "not an integer: ") + valueOf(n));
            }
            if (!xc) return new BigNumber(x);
            d = new BigNumber(ONE);
            n1 = d0 = new BigNumber(ONE);
            d1 = n0 = new BigNumber(ONE);
            s = coeffToString(xc);
            // Determine initial denominator.
            // d is a power of 10 and the minimum max denominator that specifies the value exactly.
            e = d.e = s.length - x.e - 1;
            d.c[0] = POWS_TEN[(exp = e % LOG_BASE) < 0 ? LOG_BASE + exp : exp];
            md = !md || n.comparedTo(d) > 0 ? e > 0 ? d : n1 : n;
            exp = MAX_EXP;
            MAX_EXP = 1 / 0;
            n = new BigNumber(s);
            // n0 = d1 = 0
            n0.c[0] = 0;
            for(;;){
                q = div(n, d, 0, 1);
                d2 = d0.plus(q.times(d1));
                if (d2.comparedTo(md) == 1) break;
                d0 = d1;
                d1 = d2;
                n1 = n0.plus(q.times(d2 = n1));
                n0 = d2;
                d = n.minus(q.times(d2 = d));
                n = d2;
            }
            d2 = div(md.minus(d0), d1, 0, 1);
            n0 = n0.plus(d2.times(n1));
            d0 = d0.plus(d2.times(d1));
            n0.s = n1.s = x.s;
            e = e * 2;
            // Determine which fraction is closer to x, n0/d0 or n1/d1
            r = div(n1, d1, e, ROUNDING_MODE).minus(x).abs().comparedTo(div(n0, d0, e, ROUNDING_MODE).minus(x).abs()) < 1 ? [
                n1,
                d1
            ] : [
                n0,
                d0
            ];
            MAX_EXP = exp;
            return r;
        };
        /*
     * Return the value of this BigNumber converted to a number primitive.
     */ P.toNumber = function() {
            return +valueOf(this);
        };
        /*
     * Return a string representing the value of this BigNumber rounded to sd significant digits
     * using rounding mode rm or ROUNDING_MODE. If sd is less than the number of digits
     * necessary to represent the integer part of the value in fixed-point notation, then use
     * exponential notation.
     *
     * [sd] {number} Significant digits. Integer, 1 to MAX inclusive.
     * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
     *
     * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {sd|rm}'
     */ P.toPrecision = function(sd, rm) {
            if (sd != null) intCheck(sd, 1, MAX);
            return format(this, sd, rm, 2);
        };
        /*
     * Return a string representing the value of this BigNumber in base b, or base 10 if b is
     * omitted. If a base is specified, including base 10, round according to DECIMAL_PLACES and
     * ROUNDING_MODE. If a base is not specified, and this BigNumber has a positive exponent
     * that is equal to or greater than TO_EXP_POS, or a negative exponent equal to or less than
     * TO_EXP_NEG, return exponential notation.
     *
     * [b] {number} Integer, 2 to ALPHABET.length inclusive.
     *
     * '[BigNumber Error] Base {not a primitive number|not an integer|out of range}: {b}'
     */ P.toString = function(b) {
            var str, n = this, s = n.s, e = n.e;
            // Infinity or NaN?
            if (e === null) {
                if (s) {
                    str = "Infinity";
                    if (s < 0) str = "-" + str;
                } else str = "NaN";
            } else {
                if (b == null) str = e <= TO_EXP_NEG || e >= TO_EXP_POS ? toExponential(coeffToString(n.c), e) : toFixedPoint(coeffToString(n.c), e, "0");
                else if (b === 10 && alphabetHasNormalDecimalDigits) {
                    n = round(new BigNumber(n), DECIMAL_PLACES + e + 1, ROUNDING_MODE);
                    str = toFixedPoint(coeffToString(n.c), n.e, "0");
                } else {
                    intCheck(b, 2, ALPHABET.length, "Base");
                    str = convertBase(toFixedPoint(coeffToString(n.c), e, "0"), 10, b, s, true);
                }
                if (s < 0 && n.c[0]) str = "-" + str;
            }
            return str;
        };
        /*
     * Return as toString, but do not accept a base argument, and include the minus sign for
     * negative zero.
     */ P.valueOf = P.toJSON = function() {
            return valueOf(this);
        };
        P._isBigNumber = true;
        if (configObject != null) BigNumber.set(configObject);
        return BigNumber;
    }
    // PRIVATE HELPER FUNCTIONS
    // These functions don't need access to variables,
    // e.g. DECIMAL_PLACES, in the scope of the `clone` function above.
    function bitFloor(n) {
        var i = n | 0;
        return n > 0 || n === i ? i : i - 1;
    }
    // Return a coefficient array as a string of base 10 digits.
    function coeffToString(a) {
        var s, z, i = 1, j = a.length, r = a[0] + "";
        for(; i < j;){
            s = a[i++] + "";
            z = LOG_BASE - s.length;
            for(; z--; s = "0" + s);
            r += s;
        }
        // Determine trailing zeros.
        for(j = r.length; r.charCodeAt(--j) === 48;);
        return r.slice(0, j + 1 || 1);
    }
    // Compare the value of BigNumbers x and y.
    function compare(x, y) {
        var a, b, xc = x.c, yc = y.c, i = x.s, j = y.s, k = x.e, l = y.e;
        // Either NaN?
        if (!i || !j) return null;
        a = xc && !xc[0];
        b = yc && !yc[0];
        // Either zero?
        if (a || b) return a ? b ? 0 : -j : i;
        // Signs differ?
        if (i != j) return i;
        a = i < 0;
        b = k == l;
        // Either Infinity?
        if (!xc || !yc) return b ? 0 : !xc ^ a ? 1 : -1;
        // Compare exponents.
        if (!b) return k > l ^ a ? 1 : -1;
        j = (k = xc.length) < (l = yc.length) ? k : l;
        // Compare digit by digit.
        for(i = 0; i < j; i++)if (xc[i] != yc[i]) return xc[i] > yc[i] ^ a ? 1 : -1;
        // Compare lengths.
        return k == l ? 0 : k > l ^ a ? 1 : -1;
    }
    /*
   * Check that n is a primitive number, an integer, and in range, otherwise throw.
   */ function intCheck(n, min, max, name) {
        if (n < min || n > max || n !== mathfloor(n)) throw Error(bignumberError + (name || "Argument") + (typeof n == "number" ? n < min || n > max ? " out of range: " : " not an integer: " : " not a primitive number: ") + String(n));
    }
    // Assumes finite n.
    function isOdd(n) {
        var k = n.c.length - 1;
        return bitFloor(n.e / LOG_BASE) == k && n.c[k] % 2 != 0;
    }
    function toExponential(str, e) {
        return (str.length > 1 ? str.charAt(0) + "." + str.slice(1) : str) + (e < 0 ? "e" : "e+") + e;
    }
    function toFixedPoint(str, e, z) {
        var len, zs;
        // Negative exponent?
        if (e < 0) {
            // Prepend zeros.
            for(zs = z + "."; ++e; zs += z);
            str = zs + str;
        // Positive exponent
        } else {
            len = str.length;
            // Append zeros.
            if (++e > len) {
                for(zs = z, e -= len; --e; zs += z);
                str += zs;
            } else if (e < len) str = str.slice(0, e) + "." + str.slice(e);
        }
        return str;
    }
    // EXPORT
    BigNumber = clone();
    BigNumber["default"] = BigNumber.BigNumber = BigNumber;
    // AMD.
    if (typeof define == "function" && define.amd) define(function() {
        return BigNumber;
    });
    else if (0, module.exports) module.exports = BigNumber;
    else {
        if (!globalObject) globalObject = typeof self != "undefined" && self ? self : window;
        globalObject.BigNumber = BigNumber;
    }
})(this);

},{}],"cvMPI":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _actions = require("./actions");
parcelHelpers.exportAll(_actions, exports);
var _contracts = require("./contracts"); // export * from './functions'
parcelHelpers.exportAll(_contracts, exports);

},{"./actions":"6RVYi","./contracts":"jSKnb","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"6RVYi":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ETH_SEND_TRANSACTION", ()=>ETH_SEND_TRANSACTION);
parcelHelpers.export(exports, "ETH_SIGN", ()=>ETH_SIGN);
parcelHelpers.export(exports, "PERSONAL_SIGN", ()=>PERSONAL_SIGN);
parcelHelpers.export(exports, "DAI_BALANCE_OF", ()=>DAI_BALANCE_OF);
parcelHelpers.export(exports, "DAI_TRANSFER", ()=>DAI_TRANSFER);
parcelHelpers.export(exports, "MINT_ACTION", ()=>MINT_ACTION);
const ETH_SEND_TRANSACTION = "eth.sendTransaction()";
const ETH_SIGN = "eth.sign()";
const PERSONAL_SIGN = "personal.sign()";
const DAI_BALANCE_OF = "dai.balanceOf()";
const DAI_TRANSFER = "dai.transfer()";
const MINT_ACTION = "mint";

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"jSKnb":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "NFT_CONTRACT", ()=>NFT_CONTRACT);
const NFT_CONTRACT = {
    1: {
        abi: [
            {
                "inputs": [
                    {
                        "internalType": "string",
                        "name": "_name",
                        "type": "string"
                    },
                    {
                        "internalType": "string",
                        "name": "_symbol",
                        "type": "string"
                    }
                ],
                "stateMutability": "nonpayable",
                "type": "constructor"
            },
            {
                "inputs": [],
                "name": "AccessDenied",
                "type": "error"
            },
            {
                "inputs": [],
                "name": "ApprovalCallerNotOwnerNorApproved",
                "type": "error"
            },
            {
                "inputs": [],
                "name": "ApprovalQueryForNonexistentToken",
                "type": "error"
            },
            {
                "inputs": [],
                "name": "BadInput",
                "type": "error"
            },
            {
                "inputs": [],
                "name": "BalanceQueryForZeroAddress",
                "type": "error"
            },
            {
                "inputs": [],
                "name": "EthValue",
                "type": "error"
            },
            {
                "inputs": [],
                "name": "MaxSupply",
                "type": "error"
            },
            {
                "inputs": [],
                "name": "MintERC2309QuantityExceedsLimit",
                "type": "error"
            },
            {
                "inputs": [],
                "name": "MintLimit",
                "type": "error"
            },
            {
                "inputs": [],
                "name": "MintToZeroAddress",
                "type": "error"
            },
            {
                "inputs": [],
                "name": "MintZeroQuantity",
                "type": "error"
            },
            {
                "inputs": [],
                "name": "OwnerQueryForNonexistentToken",
                "type": "error"
            },
            {
                "inputs": [],
                "name": "OwnershipNotInitializedForExtraData",
                "type": "error"
            },
            {
                "inputs": [],
                "name": "Paused",
                "type": "error"
            },
            {
                "inputs": [],
                "name": "TransferCallerNotOwnerNorApproved",
                "type": "error"
            },
            {
                "inputs": [],
                "name": "TransferFromIncorrectOwner",
                "type": "error"
            },
            {
                "inputs": [],
                "name": "TransferToNonERC721ReceiverImplementer",
                "type": "error"
            },
            {
                "inputs": [],
                "name": "TransferToZeroAddress",
                "type": "error"
            },
            {
                "inputs": [],
                "name": "URIQueryForNonexistentToken",
                "type": "error"
            },
            {
                "anonymous": false,
                "inputs": [
                    {
                        "indexed": true,
                        "internalType": "address",
                        "name": "owner",
                        "type": "address"
                    },
                    {
                        "indexed": true,
                        "internalType": "address",
                        "name": "approved",
                        "type": "address"
                    },
                    {
                        "indexed": true,
                        "internalType": "uint256",
                        "name": "tokenId",
                        "type": "uint256"
                    }
                ],
                "name": "Approval",
                "type": "event"
            },
            {
                "anonymous": false,
                "inputs": [
                    {
                        "indexed": true,
                        "internalType": "address",
                        "name": "owner",
                        "type": "address"
                    },
                    {
                        "indexed": true,
                        "internalType": "address",
                        "name": "operator",
                        "type": "address"
                    },
                    {
                        "indexed": false,
                        "internalType": "bool",
                        "name": "approved",
                        "type": "bool"
                    }
                ],
                "name": "ApprovalForAll",
                "type": "event"
            },
            {
                "anonymous": false,
                "inputs": [
                    {
                        "indexed": true,
                        "internalType": "uint256",
                        "name": "fromTokenId",
                        "type": "uint256"
                    },
                    {
                        "indexed": false,
                        "internalType": "uint256",
                        "name": "toTokenId",
                        "type": "uint256"
                    },
                    {
                        "indexed": true,
                        "internalType": "address",
                        "name": "from",
                        "type": "address"
                    },
                    {
                        "indexed": true,
                        "internalType": "address",
                        "name": "to",
                        "type": "address"
                    }
                ],
                "name": "ConsecutiveTransfer",
                "type": "event"
            },
            {
                "anonymous": false,
                "inputs": [
                    {
                        "indexed": true,
                        "internalType": "address",
                        "name": "from",
                        "type": "address"
                    },
                    {
                        "indexed": true,
                        "internalType": "address",
                        "name": "to",
                        "type": "address"
                    },
                    {
                        "indexed": true,
                        "internalType": "uint256",
                        "name": "tokenId",
                        "type": "uint256"
                    }
                ],
                "name": "Transfer",
                "type": "event"
            },
            {
                "stateMutability": "payable",
                "type": "fallback"
            },
            {
                "inputs": [],
                "name": "admin",
                "outputs": [
                    {
                        "internalType": "address",
                        "name": "",
                        "type": "address"
                    }
                ],
                "stateMutability": "view",
                "type": "function"
            },
            {
                "inputs": [],
                "name": "adminAccess",
                "outputs": [
                    {
                        "internalType": "bool",
                        "name": "",
                        "type": "bool"
                    }
                ],
                "stateMutability": "view",
                "type": "function"
            },
            {
                "inputs": [
                    {
                        "internalType": "address",
                        "name": "to",
                        "type": "address"
                    },
                    {
                        "internalType": "uint256",
                        "name": "tokenId",
                        "type": "uint256"
                    }
                ],
                "name": "approve",
                "outputs": [],
                "stateMutability": "payable",
                "type": "function"
            },
            {
                "inputs": [
                    {
                        "internalType": "address",
                        "name": "owner",
                        "type": "address"
                    }
                ],
                "name": "balanceOf",
                "outputs": [
                    {
                        "internalType": "uint256",
                        "name": "",
                        "type": "uint256"
                    }
                ],
                "stateMutability": "view",
                "type": "function"
            },
            {
                "inputs": [],
                "name": "baseURI",
                "outputs": [
                    {
                        "internalType": "string",
                        "name": "",
                        "type": "string"
                    }
                ],
                "stateMutability": "view",
                "type": "function"
            },
            {
                "inputs": [],
                "name": "cost",
                "outputs": [
                    {
                        "internalType": "uint256",
                        "name": "",
                        "type": "uint256"
                    }
                ],
                "stateMutability": "view",
                "type": "function"
            },
            {
                "inputs": [
                    {
                        "internalType": "uint256",
                        "name": "mintQty",
                        "type": "uint256"
                    },
                    {
                        "internalType": "address",
                        "name": "recipient",
                        "type": "address"
                    }
                ],
                "name": "devMint",
                "outputs": [],
                "stateMutability": "nonpayable",
                "type": "function"
            },
            {
                "inputs": [
                    {
                        "internalType": "uint256[]",
                        "name": "quantity",
                        "type": "uint256[]"
                    },
                    {
                        "internalType": "address[]",
                        "name": "recipient",
                        "type": "address[]"
                    }
                ],
                "name": "devMint",
                "outputs": [],
                "stateMutability": "nonpayable",
                "type": "function"
            },
            {
                "inputs": [],
                "name": "freezeMetadata",
                "outputs": [],
                "stateMutability": "nonpayable",
                "type": "function"
            },
            {
                "inputs": [],
                "name": "frozen",
                "outputs": [
                    {
                        "internalType": "bool",
                        "name": "",
                        "type": "bool"
                    }
                ],
                "stateMutability": "view",
                "type": "function"
            },
            {
                "inputs": [
                    {
                        "internalType": "uint256",
                        "name": "tokenId",
                        "type": "uint256"
                    }
                ],
                "name": "getApproved",
                "outputs": [
                    {
                        "internalType": "address",
                        "name": "",
                        "type": "address"
                    }
                ],
                "stateMutability": "view",
                "type": "function"
            },
            {
                "inputs": [
                    {
                        "internalType": "address",
                        "name": "",
                        "type": "address"
                    }
                ],
                "name": "giftClaimed",
                "outputs": [
                    {
                        "internalType": "bool",
                        "name": "",
                        "type": "bool"
                    }
                ],
                "stateMutability": "view",
                "type": "function"
            },
            {
                "inputs": [
                    {
                        "internalType": "address",
                        "name": "owner",
                        "type": "address"
                    },
                    {
                        "internalType": "address",
                        "name": "operator",
                        "type": "address"
                    }
                ],
                "name": "isApprovedForAll",
                "outputs": [
                    {
                        "internalType": "bool",
                        "name": "",
                        "type": "bool"
                    }
                ],
                "stateMutability": "view",
                "type": "function"
            },
            {
                "inputs": [],
                "name": "maxSupply",
                "outputs": [
                    {
                        "internalType": "uint256",
                        "name": "",
                        "type": "uint256"
                    }
                ],
                "stateMutability": "view",
                "type": "function"
            },
            {
                "inputs": [
                    {
                        "internalType": "uint256",
                        "name": "mintQty",
                        "type": "uint256"
                    },
                    {
                        "internalType": "bytes32[]",
                        "name": "_merkleProof",
                        "type": "bytes32[]"
                    }
                ],
                "name": "mferEarlyMint",
                "outputs": [],
                "stateMutability": "payable",
                "type": "function"
            },
            {
                "inputs": [
                    {
                        "internalType": "uint256",
                        "name": "mintQty",
                        "type": "uint256"
                    },
                    {
                        "internalType": "bytes32[]",
                        "name": "_merkleProof",
                        "type": "bytes32[]"
                    }
                ],
                "name": "mferEarlyMintGift",
                "outputs": [],
                "stateMutability": "payable",
                "type": "function"
            },
            {
                "inputs": [],
                "name": "mferMerkleRoot",
                "outputs": [
                    {
                        "internalType": "bytes32",
                        "name": "",
                        "type": "bytes32"
                    }
                ],
                "stateMutability": "view",
                "type": "function"
            },
            {
                "inputs": [
                    {
                        "internalType": "uint256",
                        "name": "mintQty",
                        "type": "uint256"
                    }
                ],
                "name": "mint",
                "outputs": [],
                "stateMutability": "payable",
                "type": "function"
            },
            {
                "inputs": [
                    {
                        "internalType": "uint256",
                        "name": "mintQty",
                        "type": "uint256"
                    },
                    {
                        "internalType": "bytes32[]",
                        "name": "_merkleProof",
                        "type": "bytes32[]"
                    }
                ],
                "name": "mintMferGift",
                "outputs": [],
                "stateMutability": "payable",
                "type": "function"
            },
            {
                "inputs": [],
                "name": "name",
                "outputs": [
                    {
                        "internalType": "string",
                        "name": "",
                        "type": "string"
                    }
                ],
                "stateMutability": "view",
                "type": "function"
            },
            {
                "inputs": [],
                "name": "owner",
                "outputs": [
                    {
                        "internalType": "address",
                        "name": "",
                        "type": "address"
                    }
                ],
                "stateMutability": "view",
                "type": "function"
            },
            {
                "inputs": [
                    {
                        "internalType": "uint256",
                        "name": "tokenId",
                        "type": "uint256"
                    }
                ],
                "name": "ownerOf",
                "outputs": [
                    {
                        "internalType": "address",
                        "name": "",
                        "type": "address"
                    }
                ],
                "stateMutability": "view",
                "type": "function"
            },
            {
                "inputs": [],
                "name": "presale",
                "outputs": [
                    {
                        "internalType": "bool",
                        "name": "",
                        "type": "bool"
                    }
                ],
                "stateMutability": "view",
                "type": "function"
            },
            {
                "inputs": [
                    {
                        "internalType": "uint256",
                        "name": "newSupply",
                        "type": "uint256"
                    }
                ],
                "name": "reduceMaxSupply",
                "outputs": [],
                "stateMutability": "nonpayable",
                "type": "function"
            },
            {
                "inputs": [
                    {
                        "internalType": "address",
                        "name": "from",
                        "type": "address"
                    },
                    {
                        "internalType": "address",
                        "name": "to",
                        "type": "address"
                    },
                    {
                        "internalType": "uint256",
                        "name": "tokenId",
                        "type": "uint256"
                    }
                ],
                "name": "safeTransferFrom",
                "outputs": [],
                "stateMutability": "payable",
                "type": "function"
            },
            {
                "inputs": [
                    {
                        "internalType": "address",
                        "name": "from",
                        "type": "address"
                    },
                    {
                        "internalType": "address",
                        "name": "to",
                        "type": "address"
                    },
                    {
                        "internalType": "uint256",
                        "name": "tokenId",
                        "type": "uint256"
                    },
                    {
                        "internalType": "bytes",
                        "name": "_data",
                        "type": "bytes"
                    }
                ],
                "name": "safeTransferFrom",
                "outputs": [],
                "stateMutability": "payable",
                "type": "function"
            },
            {
                "inputs": [],
                "name": "sale",
                "outputs": [
                    {
                        "internalType": "bool",
                        "name": "",
                        "type": "bool"
                    }
                ],
                "stateMutability": "view",
                "type": "function"
            },
            {
                "inputs": [
                    {
                        "internalType": "address",
                        "name": "operator",
                        "type": "address"
                    },
                    {
                        "internalType": "bool",
                        "name": "approved",
                        "type": "bool"
                    }
                ],
                "name": "setApprovalForAll",
                "outputs": [],
                "stateMutability": "nonpayable",
                "type": "function"
            },
            {
                "inputs": [
                    {
                        "internalType": "string",
                        "name": "_newBaseURI",
                        "type": "string"
                    }
                ],
                "name": "setBaseURI",
                "outputs": [],
                "stateMutability": "nonpayable",
                "type": "function"
            },
            {
                "inputs": [
                    {
                        "internalType": "uint256",
                        "name": "_cost",
                        "type": "uint256"
                    }
                ],
                "name": "setCost",
                "outputs": [],
                "stateMutability": "nonpayable",
                "type": "function"
            },
            {
                "inputs": [
                    {
                        "internalType": "bytes32",
                        "name": "root",
                        "type": "bytes32"
                    }
                ],
                "name": "setMerkleRoot",
                "outputs": [],
                "stateMutability": "nonpayable",
                "type": "function"
            },
            {
                "inputs": [
                    {
                        "internalType": "bytes4",
                        "name": "interfaceId",
                        "type": "bytes4"
                    }
                ],
                "name": "supportsInterface",
                "outputs": [
                    {
                        "internalType": "bool",
                        "name": "",
                        "type": "bool"
                    }
                ],
                "stateMutability": "view",
                "type": "function"
            },
            {
                "inputs": [],
                "name": "symbol",
                "outputs": [
                    {
                        "internalType": "string",
                        "name": "",
                        "type": "string"
                    }
                ],
                "stateMutability": "view",
                "type": "function"
            },
            {
                "inputs": [],
                "name": "toggleAdminAccess",
                "outputs": [],
                "stateMutability": "nonpayable",
                "type": "function"
            },
            {
                "inputs": [],
                "name": "togglePresale",
                "outputs": [],
                "stateMutability": "nonpayable",
                "type": "function"
            },
            {
                "inputs": [],
                "name": "toggleSale",
                "outputs": [],
                "stateMutability": "nonpayable",
                "type": "function"
            },
            {
                "inputs": [
                    {
                        "internalType": "uint256",
                        "name": "tokenId",
                        "type": "uint256"
                    }
                ],
                "name": "tokenURI",
                "outputs": [
                    {
                        "internalType": "string",
                        "name": "",
                        "type": "string"
                    }
                ],
                "stateMutability": "view",
                "type": "function"
            },
            {
                "inputs": [],
                "name": "totalSupply",
                "outputs": [
                    {
                        "internalType": "uint256",
                        "name": "",
                        "type": "uint256"
                    }
                ],
                "stateMutability": "view",
                "type": "function"
            },
            {
                "inputs": [
                    {
                        "internalType": "address",
                        "name": "from",
                        "type": "address"
                    },
                    {
                        "internalType": "address",
                        "name": "to",
                        "type": "address"
                    },
                    {
                        "internalType": "uint256",
                        "name": "tokenId",
                        "type": "uint256"
                    }
                ],
                "name": "transferFrom",
                "outputs": [],
                "stateMutability": "payable",
                "type": "function"
            },
            {
                "inputs": [],
                "name": "withdraw",
                "outputs": [],
                "stateMutability": "nonpayable",
                "type": "function"
            },
            {
                "stateMutability": "payable",
                "type": "receive"
            }
        ],
        address: "0xF0031782d37819F8E209C4421C774eD1f6163052"
    },
    5: {
        abi: [
            {
                "inputs": [
                    {
                        "internalType": "string",
                        "name": "_name",
                        "type": "string"
                    },
                    {
                        "internalType": "string",
                        "name": "_symbol",
                        "type": "string"
                    }
                ],
                "stateMutability": "nonpayable",
                "type": "constructor"
            },
            {
                "inputs": [],
                "name": "AccessDenied",
                "type": "error"
            },
            {
                "inputs": [],
                "name": "ApprovalCallerNotOwnerNorApproved",
                "type": "error"
            },
            {
                "inputs": [],
                "name": "ApprovalQueryForNonexistentToken",
                "type": "error"
            },
            {
                "inputs": [],
                "name": "BadInput",
                "type": "error"
            },
            {
                "inputs": [],
                "name": "BalanceQueryForZeroAddress",
                "type": "error"
            },
            {
                "inputs": [],
                "name": "EthValue",
                "type": "error"
            },
            {
                "inputs": [],
                "name": "MaxSupply",
                "type": "error"
            },
            {
                "inputs": [],
                "name": "MintERC2309QuantityExceedsLimit",
                "type": "error"
            },
            {
                "inputs": [],
                "name": "MintLimit",
                "type": "error"
            },
            {
                "inputs": [],
                "name": "MintToZeroAddress",
                "type": "error"
            },
            {
                "inputs": [],
                "name": "MintZeroQuantity",
                "type": "error"
            },
            {
                "inputs": [],
                "name": "OwnerQueryForNonexistentToken",
                "type": "error"
            },
            {
                "inputs": [],
                "name": "OwnershipNotInitializedForExtraData",
                "type": "error"
            },
            {
                "inputs": [],
                "name": "Paused",
                "type": "error"
            },
            {
                "inputs": [],
                "name": "TransferCallerNotOwnerNorApproved",
                "type": "error"
            },
            {
                "inputs": [],
                "name": "TransferFromIncorrectOwner",
                "type": "error"
            },
            {
                "inputs": [],
                "name": "TransferToNonERC721ReceiverImplementer",
                "type": "error"
            },
            {
                "inputs": [],
                "name": "TransferToZeroAddress",
                "type": "error"
            },
            {
                "inputs": [],
                "name": "URIQueryForNonexistentToken",
                "type": "error"
            },
            {
                "anonymous": false,
                "inputs": [
                    {
                        "indexed": true,
                        "internalType": "address",
                        "name": "owner",
                        "type": "address"
                    },
                    {
                        "indexed": true,
                        "internalType": "address",
                        "name": "approved",
                        "type": "address"
                    },
                    {
                        "indexed": true,
                        "internalType": "uint256",
                        "name": "tokenId",
                        "type": "uint256"
                    }
                ],
                "name": "Approval",
                "type": "event"
            },
            {
                "anonymous": false,
                "inputs": [
                    {
                        "indexed": true,
                        "internalType": "address",
                        "name": "owner",
                        "type": "address"
                    },
                    {
                        "indexed": true,
                        "internalType": "address",
                        "name": "operator",
                        "type": "address"
                    },
                    {
                        "indexed": false,
                        "internalType": "bool",
                        "name": "approved",
                        "type": "bool"
                    }
                ],
                "name": "ApprovalForAll",
                "type": "event"
            },
            {
                "anonymous": false,
                "inputs": [
                    {
                        "indexed": true,
                        "internalType": "uint256",
                        "name": "fromTokenId",
                        "type": "uint256"
                    },
                    {
                        "indexed": false,
                        "internalType": "uint256",
                        "name": "toTokenId",
                        "type": "uint256"
                    },
                    {
                        "indexed": true,
                        "internalType": "address",
                        "name": "from",
                        "type": "address"
                    },
                    {
                        "indexed": true,
                        "internalType": "address",
                        "name": "to",
                        "type": "address"
                    }
                ],
                "name": "ConsecutiveTransfer",
                "type": "event"
            },
            {
                "anonymous": false,
                "inputs": [
                    {
                        "indexed": true,
                        "internalType": "address",
                        "name": "from",
                        "type": "address"
                    },
                    {
                        "indexed": true,
                        "internalType": "address",
                        "name": "to",
                        "type": "address"
                    },
                    {
                        "indexed": true,
                        "internalType": "uint256",
                        "name": "tokenId",
                        "type": "uint256"
                    }
                ],
                "name": "Transfer",
                "type": "event"
            },
            {
                "stateMutability": "payable",
                "type": "fallback"
            },
            {
                "inputs": [],
                "name": "admin",
                "outputs": [
                    {
                        "internalType": "address",
                        "name": "",
                        "type": "address"
                    }
                ],
                "stateMutability": "view",
                "type": "function"
            },
            {
                "inputs": [],
                "name": "adminAccess",
                "outputs": [
                    {
                        "internalType": "bool",
                        "name": "",
                        "type": "bool"
                    }
                ],
                "stateMutability": "view",
                "type": "function"
            },
            {
                "inputs": [
                    {
                        "internalType": "address",
                        "name": "to",
                        "type": "address"
                    },
                    {
                        "internalType": "uint256",
                        "name": "tokenId",
                        "type": "uint256"
                    }
                ],
                "name": "approve",
                "outputs": [],
                "stateMutability": "payable",
                "type": "function"
            },
            {
                "inputs": [
                    {
                        "internalType": "address",
                        "name": "owner",
                        "type": "address"
                    }
                ],
                "name": "balanceOf",
                "outputs": [
                    {
                        "internalType": "uint256",
                        "name": "",
                        "type": "uint256"
                    }
                ],
                "stateMutability": "view",
                "type": "function"
            },
            {
                "inputs": [],
                "name": "baseURI",
                "outputs": [
                    {
                        "internalType": "string",
                        "name": "",
                        "type": "string"
                    }
                ],
                "stateMutability": "view",
                "type": "function"
            },
            {
                "inputs": [],
                "name": "cost",
                "outputs": [
                    {
                        "internalType": "uint256",
                        "name": "",
                        "type": "uint256"
                    }
                ],
                "stateMutability": "view",
                "type": "function"
            },
            {
                "inputs": [
                    {
                        "internalType": "uint256",
                        "name": "mintQty",
                        "type": "uint256"
                    },
                    {
                        "internalType": "address",
                        "name": "recipient",
                        "type": "address"
                    }
                ],
                "name": "devMint",
                "outputs": [],
                "stateMutability": "nonpayable",
                "type": "function"
            },
            {
                "inputs": [
                    {
                        "internalType": "uint256[]",
                        "name": "quantity",
                        "type": "uint256[]"
                    },
                    {
                        "internalType": "address[]",
                        "name": "recipient",
                        "type": "address[]"
                    }
                ],
                "name": "devMint",
                "outputs": [],
                "stateMutability": "nonpayable",
                "type": "function"
            },
            {
                "inputs": [],
                "name": "freezeMetadata",
                "outputs": [],
                "stateMutability": "nonpayable",
                "type": "function"
            },
            {
                "inputs": [],
                "name": "frozen",
                "outputs": [
                    {
                        "internalType": "bool",
                        "name": "",
                        "type": "bool"
                    }
                ],
                "stateMutability": "view",
                "type": "function"
            },
            {
                "inputs": [
                    {
                        "internalType": "uint256",
                        "name": "tokenId",
                        "type": "uint256"
                    }
                ],
                "name": "getApproved",
                "outputs": [
                    {
                        "internalType": "address",
                        "name": "",
                        "type": "address"
                    }
                ],
                "stateMutability": "view",
                "type": "function"
            },
            {
                "inputs": [
                    {
                        "internalType": "address",
                        "name": "",
                        "type": "address"
                    }
                ],
                "name": "giftClaimed",
                "outputs": [
                    {
                        "internalType": "bool",
                        "name": "",
                        "type": "bool"
                    }
                ],
                "stateMutability": "view",
                "type": "function"
            },
            {
                "inputs": [
                    {
                        "internalType": "address",
                        "name": "owner",
                        "type": "address"
                    },
                    {
                        "internalType": "address",
                        "name": "operator",
                        "type": "address"
                    }
                ],
                "name": "isApprovedForAll",
                "outputs": [
                    {
                        "internalType": "bool",
                        "name": "",
                        "type": "bool"
                    }
                ],
                "stateMutability": "view",
                "type": "function"
            },
            {
                "inputs": [],
                "name": "maxSupply",
                "outputs": [
                    {
                        "internalType": "uint256",
                        "name": "",
                        "type": "uint256"
                    }
                ],
                "stateMutability": "view",
                "type": "function"
            },
            {
                "inputs": [
                    {
                        "internalType": "uint256",
                        "name": "mintQty",
                        "type": "uint256"
                    },
                    {
                        "internalType": "bytes32[]",
                        "name": "_merkleProof",
                        "type": "bytes32[]"
                    }
                ],
                "name": "mferEarlyMint",
                "outputs": [],
                "stateMutability": "payable",
                "type": "function"
            },
            {
                "inputs": [
                    {
                        "internalType": "uint256",
                        "name": "mintQty",
                        "type": "uint256"
                    },
                    {
                        "internalType": "bytes32[]",
                        "name": "_merkleProof",
                        "type": "bytes32[]"
                    }
                ],
                "name": "mferEarlyMintGift",
                "outputs": [],
                "stateMutability": "payable",
                "type": "function"
            },
            {
                "inputs": [],
                "name": "mferMerkleRoot",
                "outputs": [
                    {
                        "internalType": "bytes32",
                        "name": "",
                        "type": "bytes32"
                    }
                ],
                "stateMutability": "view",
                "type": "function"
            },
            {
                "inputs": [
                    {
                        "internalType": "uint256",
                        "name": "mintQty",
                        "type": "uint256"
                    }
                ],
                "name": "mint",
                "outputs": [],
                "stateMutability": "payable",
                "type": "function"
            },
            {
                "inputs": [
                    {
                        "internalType": "uint256",
                        "name": "mintQty",
                        "type": "uint256"
                    },
                    {
                        "internalType": "bytes32[]",
                        "name": "_merkleProof",
                        "type": "bytes32[]"
                    }
                ],
                "name": "mintMferGift",
                "outputs": [],
                "stateMutability": "payable",
                "type": "function"
            },
            {
                "inputs": [],
                "name": "name",
                "outputs": [
                    {
                        "internalType": "string",
                        "name": "",
                        "type": "string"
                    }
                ],
                "stateMutability": "view",
                "type": "function"
            },
            {
                "inputs": [],
                "name": "owner",
                "outputs": [
                    {
                        "internalType": "address",
                        "name": "",
                        "type": "address"
                    }
                ],
                "stateMutability": "view",
                "type": "function"
            },
            {
                "inputs": [
                    {
                        "internalType": "uint256",
                        "name": "tokenId",
                        "type": "uint256"
                    }
                ],
                "name": "ownerOf",
                "outputs": [
                    {
                        "internalType": "address",
                        "name": "",
                        "type": "address"
                    }
                ],
                "stateMutability": "view",
                "type": "function"
            },
            {
                "inputs": [],
                "name": "presale",
                "outputs": [
                    {
                        "internalType": "bool",
                        "name": "",
                        "type": "bool"
                    }
                ],
                "stateMutability": "view",
                "type": "function"
            },
            {
                "inputs": [
                    {
                        "internalType": "uint256",
                        "name": "newSupply",
                        "type": "uint256"
                    }
                ],
                "name": "reduceMaxSupply",
                "outputs": [],
                "stateMutability": "nonpayable",
                "type": "function"
            },
            {
                "inputs": [
                    {
                        "internalType": "address",
                        "name": "from",
                        "type": "address"
                    },
                    {
                        "internalType": "address",
                        "name": "to",
                        "type": "address"
                    },
                    {
                        "internalType": "uint256",
                        "name": "tokenId",
                        "type": "uint256"
                    }
                ],
                "name": "safeTransferFrom",
                "outputs": [],
                "stateMutability": "payable",
                "type": "function"
            },
            {
                "inputs": [
                    {
                        "internalType": "address",
                        "name": "from",
                        "type": "address"
                    },
                    {
                        "internalType": "address",
                        "name": "to",
                        "type": "address"
                    },
                    {
                        "internalType": "uint256",
                        "name": "tokenId",
                        "type": "uint256"
                    },
                    {
                        "internalType": "bytes",
                        "name": "_data",
                        "type": "bytes"
                    }
                ],
                "name": "safeTransferFrom",
                "outputs": [],
                "stateMutability": "payable",
                "type": "function"
            },
            {
                "inputs": [],
                "name": "sale",
                "outputs": [
                    {
                        "internalType": "bool",
                        "name": "",
                        "type": "bool"
                    }
                ],
                "stateMutability": "view",
                "type": "function"
            },
            {
                "inputs": [
                    {
                        "internalType": "address",
                        "name": "operator",
                        "type": "address"
                    },
                    {
                        "internalType": "bool",
                        "name": "approved",
                        "type": "bool"
                    }
                ],
                "name": "setApprovalForAll",
                "outputs": [],
                "stateMutability": "nonpayable",
                "type": "function"
            },
            {
                "inputs": [
                    {
                        "internalType": "string",
                        "name": "_newBaseURI",
                        "type": "string"
                    }
                ],
                "name": "setBaseURI",
                "outputs": [],
                "stateMutability": "nonpayable",
                "type": "function"
            },
            {
                "inputs": [
                    {
                        "internalType": "uint256",
                        "name": "_cost",
                        "type": "uint256"
                    }
                ],
                "name": "setCost",
                "outputs": [],
                "stateMutability": "nonpayable",
                "type": "function"
            },
            {
                "inputs": [
                    {
                        "internalType": "bytes32",
                        "name": "root",
                        "type": "bytes32"
                    }
                ],
                "name": "setMerkleRoot",
                "outputs": [],
                "stateMutability": "nonpayable",
                "type": "function"
            },
            {
                "inputs": [
                    {
                        "internalType": "bytes4",
                        "name": "interfaceId",
                        "type": "bytes4"
                    }
                ],
                "name": "supportsInterface",
                "outputs": [
                    {
                        "internalType": "bool",
                        "name": "",
                        "type": "bool"
                    }
                ],
                "stateMutability": "view",
                "type": "function"
            },
            {
                "inputs": [],
                "name": "symbol",
                "outputs": [
                    {
                        "internalType": "string",
                        "name": "",
                        "type": "string"
                    }
                ],
                "stateMutability": "view",
                "type": "function"
            },
            {
                "inputs": [],
                "name": "toggleAdminAccess",
                "outputs": [],
                "stateMutability": "nonpayable",
                "type": "function"
            },
            {
                "inputs": [],
                "name": "togglePresale",
                "outputs": [],
                "stateMutability": "nonpayable",
                "type": "function"
            },
            {
                "inputs": [],
                "name": "toggleSale",
                "outputs": [],
                "stateMutability": "nonpayable",
                "type": "function"
            },
            {
                "inputs": [
                    {
                        "internalType": "uint256",
                        "name": "tokenId",
                        "type": "uint256"
                    }
                ],
                "name": "tokenURI",
                "outputs": [
                    {
                        "internalType": "string",
                        "name": "",
                        "type": "string"
                    }
                ],
                "stateMutability": "view",
                "type": "function"
            },
            {
                "inputs": [],
                "name": "totalSupply",
                "outputs": [
                    {
                        "internalType": "uint256",
                        "name": "",
                        "type": "uint256"
                    }
                ],
                "stateMutability": "view",
                "type": "function"
            },
            {
                "inputs": [
                    {
                        "internalType": "address",
                        "name": "from",
                        "type": "address"
                    },
                    {
                        "internalType": "address",
                        "name": "to",
                        "type": "address"
                    },
                    {
                        "internalType": "uint256",
                        "name": "tokenId",
                        "type": "uint256"
                    }
                ],
                "name": "transferFrom",
                "outputs": [],
                "stateMutability": "payable",
                "type": "function"
            },
            {
                "inputs": [],
                "name": "withdraw",
                "outputs": [],
                "stateMutability": "nonpayable",
                "type": "function"
            },
            {
                "stateMutability": "payable",
                "type": "receive"
            }
        ],
        address: "0xF0031782d37819F8E209C4421C774eD1f6163052"
    }
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"5mho7":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// import * as list from "../../../src/controllers/providers";
parcelHelpers.export(exports, "getContract", ()=>getContract);
parcelHelpers.export(exports, "callMint", ()=>callMint);
parcelHelpers.export(exports, "callPresaleMint", ()=>callPresaleMint);
var _constants = require("../constants");
// import { convertStringToHex } from './bignumber'
var _utilities = require("./utilities");
function getContract(chainId, web3) {
    const zevi = new web3.eth.Contract((0, _constants.NFT_CONTRACT)[chainId].abi, (0, _constants.NFT_CONTRACT)[chainId].address);
    return zevi;
}
async function callMint(address, chainId, web3, mintQty, cost, nftContract, extraMint, merkleProof) {
    // console.log(address, mintQty, chainId, web3)
    const tx = await (0, _utilities.formatMintTransaction)(address, chainId, mintQty, web3, cost, nftContract, extraMint, merkleProof);
    if (!tx) {
        alert("Fatal error please try again");
        return;
    }
    const txHash = await web3._provider.request({
        method: "eth_sendTransaction",
        params: [
            tx
        ]
    });
    return txHash;
}
async function callPresaleMint(address, chainId, web3, mintQty, cost, nftContract, extraMint, merkleProof) {
    // console.log(address, mintQty, chainId, web3)
    // console.log("calling formatPresaleMintTx...", merkleProof)
    if (!merkleProof) {
        alert("Sorr you aren't on the presale list. Check back soon!");
        return;
    }
    const tx = await (0, _utilities.formatPresaleMintTransaction)(address, chainId, mintQty, web3, cost, nftContract, extraMint, merkleProof);
    if (!tx) {
        alert("Fatal error please try again");
        return;
    }
    const txHash = await web3._provider.request({
        method: "eth_sendTransaction",
        params: [
            tx
        ]
    });
    return txHash;
}

},{"../constants":"cvMPI","./utilities":"4UgH2","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"bQ7Gx":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getMintCount", ()=>getMintCount);
var _alchemyWeb3 = require("@alch/alchemy-web3");
const alchemyKey = "https://eth-mainnet.g.alchemy.com/v2/06TjEVJYYTgNryGP7Awp9F9HqnccVp0z" //"wss://eth-mainnet.alchemyapi.io/v2/In6C-YVZsYFUibOHLK-YGd_PXtKR9RVd"
;
const contractAddress = "0xF0031782d37819F8E209C4421C774eD1f6163052";
const web3 = (0, _alchemyWeb3.createAlchemyWeb3)(alchemyKey);
const contractABI = [
    {
        "inputs": [
            {
                "internalType": "string",
                "name": "_name",
                "type": "string"
            },
            {
                "internalType": "string",
                "name": "_symbol",
                "type": "string"
            }
        ],
        "stateMutability": "nonpayable",
        "type": "constructor"
    },
    {
        "inputs": [],
        "name": "AccessDenied",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "ApprovalCallerNotOwnerNorApproved",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "ApprovalQueryForNonexistentToken",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "BadInput",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "BalanceQueryForZeroAddress",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "EthValue",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "MaxSupply",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "MintERC2309QuantityExceedsLimit",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "MintLimit",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "MintToZeroAddress",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "MintZeroQuantity",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "OwnerQueryForNonexistentToken",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "OwnershipNotInitializedForExtraData",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "Paused",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "TransferCallerNotOwnerNorApproved",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "TransferFromIncorrectOwner",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "TransferToNonERC721ReceiverImplementer",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "TransferToZeroAddress",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "URIQueryForNonexistentToken",
        "type": "error"
    },
    {
        "anonymous": false,
        "inputs": [
            {
                "indexed": true,
                "internalType": "address",
                "name": "owner",
                "type": "address"
            },
            {
                "indexed": true,
                "internalType": "address",
                "name": "approved",
                "type": "address"
            },
            {
                "indexed": true,
                "internalType": "uint256",
                "name": "tokenId",
                "type": "uint256"
            }
        ],
        "name": "Approval",
        "type": "event"
    },
    {
        "anonymous": false,
        "inputs": [
            {
                "indexed": true,
                "internalType": "address",
                "name": "owner",
                "type": "address"
            },
            {
                "indexed": true,
                "internalType": "address",
                "name": "operator",
                "type": "address"
            },
            {
                "indexed": false,
                "internalType": "bool",
                "name": "approved",
                "type": "bool"
            }
        ],
        "name": "ApprovalForAll",
        "type": "event"
    },
    {
        "anonymous": false,
        "inputs": [
            {
                "indexed": true,
                "internalType": "uint256",
                "name": "fromTokenId",
                "type": "uint256"
            },
            {
                "indexed": false,
                "internalType": "uint256",
                "name": "toTokenId",
                "type": "uint256"
            },
            {
                "indexed": true,
                "internalType": "address",
                "name": "from",
                "type": "address"
            },
            {
                "indexed": true,
                "internalType": "address",
                "name": "to",
                "type": "address"
            }
        ],
        "name": "ConsecutiveTransfer",
        "type": "event"
    },
    {
        "anonymous": false,
        "inputs": [
            {
                "indexed": true,
                "internalType": "address",
                "name": "from",
                "type": "address"
            },
            {
                "indexed": true,
                "internalType": "address",
                "name": "to",
                "type": "address"
            },
            {
                "indexed": true,
                "internalType": "uint256",
                "name": "tokenId",
                "type": "uint256"
            }
        ],
        "name": "Transfer",
        "type": "event"
    },
    {
        "stateMutability": "payable",
        "type": "fallback"
    },
    {
        "inputs": [],
        "name": "admin",
        "outputs": [
            {
                "internalType": "address",
                "name": "",
                "type": "address"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    },
    {
        "inputs": [],
        "name": "adminAccess",
        "outputs": [
            {
                "internalType": "bool",
                "name": "",
                "type": "bool"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    },
    {
        "inputs": [
            {
                "internalType": "address",
                "name": "to",
                "type": "address"
            },
            {
                "internalType": "uint256",
                "name": "tokenId",
                "type": "uint256"
            }
        ],
        "name": "approve",
        "outputs": [],
        "stateMutability": "payable",
        "type": "function"
    },
    {
        "inputs": [
            {
                "internalType": "address",
                "name": "owner",
                "type": "address"
            }
        ],
        "name": "balanceOf",
        "outputs": [
            {
                "internalType": "uint256",
                "name": "",
                "type": "uint256"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    },
    {
        "inputs": [],
        "name": "baseURI",
        "outputs": [
            {
                "internalType": "string",
                "name": "",
                "type": "string"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    },
    {
        "inputs": [],
        "name": "cost",
        "outputs": [
            {
                "internalType": "uint256",
                "name": "",
                "type": "uint256"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    },
    {
        "inputs": [
            {
                "internalType": "uint256",
                "name": "mintQty",
                "type": "uint256"
            },
            {
                "internalType": "address",
                "name": "recipient",
                "type": "address"
            }
        ],
        "name": "devMint",
        "outputs": [],
        "stateMutability": "nonpayable",
        "type": "function"
    },
    {
        "inputs": [
            {
                "internalType": "uint256[]",
                "name": "quantity",
                "type": "uint256[]"
            },
            {
                "internalType": "address[]",
                "name": "recipient",
                "type": "address[]"
            }
        ],
        "name": "devMint",
        "outputs": [],
        "stateMutability": "nonpayable",
        "type": "function"
    },
    {
        "inputs": [],
        "name": "freezeMetadata",
        "outputs": [],
        "stateMutability": "nonpayable",
        "type": "function"
    },
    {
        "inputs": [],
        "name": "frozen",
        "outputs": [
            {
                "internalType": "bool",
                "name": "",
                "type": "bool"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    },
    {
        "inputs": [
            {
                "internalType": "uint256",
                "name": "tokenId",
                "type": "uint256"
            }
        ],
        "name": "getApproved",
        "outputs": [
            {
                "internalType": "address",
                "name": "",
                "type": "address"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    },
    {
        "inputs": [
            {
                "internalType": "address",
                "name": "",
                "type": "address"
            }
        ],
        "name": "giftClaimed",
        "outputs": [
            {
                "internalType": "bool",
                "name": "",
                "type": "bool"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    },
    {
        "inputs": [
            {
                "internalType": "address",
                "name": "owner",
                "type": "address"
            },
            {
                "internalType": "address",
                "name": "operator",
                "type": "address"
            }
        ],
        "name": "isApprovedForAll",
        "outputs": [
            {
                "internalType": "bool",
                "name": "",
                "type": "bool"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    },
    {
        "inputs": [],
        "name": "maxSupply",
        "outputs": [
            {
                "internalType": "uint256",
                "name": "",
                "type": "uint256"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    },
    {
        "inputs": [
            {
                "internalType": "uint256",
                "name": "mintQty",
                "type": "uint256"
            },
            {
                "internalType": "bytes32[]",
                "name": "_merkleProof",
                "type": "bytes32[]"
            }
        ],
        "name": "mferEarlyMint",
        "outputs": [],
        "stateMutability": "payable",
        "type": "function"
    },
    {
        "inputs": [
            {
                "internalType": "uint256",
                "name": "mintQty",
                "type": "uint256"
            },
            {
                "internalType": "bytes32[]",
                "name": "_merkleProof",
                "type": "bytes32[]"
            }
        ],
        "name": "mferEarlyMintGift",
        "outputs": [],
        "stateMutability": "payable",
        "type": "function"
    },
    {
        "inputs": [],
        "name": "mferMerkleRoot",
        "outputs": [
            {
                "internalType": "bytes32",
                "name": "",
                "type": "bytes32"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    },
    {
        "inputs": [
            {
                "internalType": "uint256",
                "name": "mintQty",
                "type": "uint256"
            }
        ],
        "name": "mint",
        "outputs": [],
        "stateMutability": "payable",
        "type": "function"
    },
    {
        "inputs": [
            {
                "internalType": "uint256",
                "name": "mintQty",
                "type": "uint256"
            },
            {
                "internalType": "bytes32[]",
                "name": "_merkleProof",
                "type": "bytes32[]"
            }
        ],
        "name": "mintMferGift",
        "outputs": [],
        "stateMutability": "payable",
        "type": "function"
    },
    {
        "inputs": [],
        "name": "name",
        "outputs": [
            {
                "internalType": "string",
                "name": "",
                "type": "string"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    },
    {
        "inputs": [],
        "name": "owner",
        "outputs": [
            {
                "internalType": "address",
                "name": "",
                "type": "address"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    },
    {
        "inputs": [
            {
                "internalType": "uint256",
                "name": "tokenId",
                "type": "uint256"
            }
        ],
        "name": "ownerOf",
        "outputs": [
            {
                "internalType": "address",
                "name": "",
                "type": "address"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    },
    {
        "inputs": [],
        "name": "presale",
        "outputs": [
            {
                "internalType": "bool",
                "name": "",
                "type": "bool"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    },
    {
        "inputs": [
            {
                "internalType": "uint256",
                "name": "newSupply",
                "type": "uint256"
            }
        ],
        "name": "reduceMaxSupply",
        "outputs": [],
        "stateMutability": "nonpayable",
        "type": "function"
    },
    {
        "inputs": [
            {
                "internalType": "address",
                "name": "from",
                "type": "address"
            },
            {
                "internalType": "address",
                "name": "to",
                "type": "address"
            },
            {
                "internalType": "uint256",
                "name": "tokenId",
                "type": "uint256"
            }
        ],
        "name": "safeTransferFrom",
        "outputs": [],
        "stateMutability": "payable",
        "type": "function"
    },
    {
        "inputs": [
            {
                "internalType": "address",
                "name": "from",
                "type": "address"
            },
            {
                "internalType": "address",
                "name": "to",
                "type": "address"
            },
            {
                "internalType": "uint256",
                "name": "tokenId",
                "type": "uint256"
            },
            {
                "internalType": "bytes",
                "name": "_data",
                "type": "bytes"
            }
        ],
        "name": "safeTransferFrom",
        "outputs": [],
        "stateMutability": "payable",
        "type": "function"
    },
    {
        "inputs": [],
        "name": "sale",
        "outputs": [
            {
                "internalType": "bool",
                "name": "",
                "type": "bool"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    },
    {
        "inputs": [
            {
                "internalType": "address",
                "name": "operator",
                "type": "address"
            },
            {
                "internalType": "bool",
                "name": "approved",
                "type": "bool"
            }
        ],
        "name": "setApprovalForAll",
        "outputs": [],
        "stateMutability": "nonpayable",
        "type": "function"
    },
    {
        "inputs": [
            {
                "internalType": "string",
                "name": "_newBaseURI",
                "type": "string"
            }
        ],
        "name": "setBaseURI",
        "outputs": [],
        "stateMutability": "nonpayable",
        "type": "function"
    },
    {
        "inputs": [
            {
                "internalType": "uint256",
                "name": "_cost",
                "type": "uint256"
            }
        ],
        "name": "setCost",
        "outputs": [],
        "stateMutability": "nonpayable",
        "type": "function"
    },
    {
        "inputs": [
            {
                "internalType": "bytes32",
                "name": "root",
                "type": "bytes32"
            }
        ],
        "name": "setMerkleRoot",
        "outputs": [],
        "stateMutability": "nonpayable",
        "type": "function"
    },
    {
        "inputs": [
            {
                "internalType": "bytes4",
                "name": "interfaceId",
                "type": "bytes4"
            }
        ],
        "name": "supportsInterface",
        "outputs": [
            {
                "internalType": "bool",
                "name": "",
                "type": "bool"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    },
    {
        "inputs": [],
        "name": "symbol",
        "outputs": [
            {
                "internalType": "string",
                "name": "",
                "type": "string"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    },
    {
        "inputs": [],
        "name": "toggleAdminAccess",
        "outputs": [],
        "stateMutability": "nonpayable",
        "type": "function"
    },
    {
        "inputs": [],
        "name": "togglePresale",
        "outputs": [],
        "stateMutability": "nonpayable",
        "type": "function"
    },
    {
        "inputs": [],
        "name": "toggleSale",
        "outputs": [],
        "stateMutability": "nonpayable",
        "type": "function"
    },
    {
        "inputs": [
            {
                "internalType": "uint256",
                "name": "tokenId",
                "type": "uint256"
            }
        ],
        "name": "tokenURI",
        "outputs": [
            {
                "internalType": "string",
                "name": "",
                "type": "string"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    },
    {
        "inputs": [],
        "name": "totalSupply",
        "outputs": [
            {
                "internalType": "uint256",
                "name": "",
                "type": "uint256"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    },
    {
        "inputs": [
            {
                "internalType": "address",
                "name": "from",
                "type": "address"
            },
            {
                "internalType": "address",
                "name": "to",
                "type": "address"
            },
            {
                "internalType": "uint256",
                "name": "tokenId",
                "type": "uint256"
            }
        ],
        "name": "transferFrom",
        "outputs": [],
        "stateMutability": "payable",
        "type": "function"
    },
    {
        "inputs": [],
        "name": "withdraw",
        "outputs": [],
        "stateMutability": "nonpayable",
        "type": "function"
    },
    {
        "stateMutability": "payable",
        "type": "receive"
    }
];
const nftContract = new web3.eth.Contract(contractABI, contractAddress);
const getMintCount = async ()=>{
    // console.log("get count...")
    const tokenID = await nftContract.methods.totalSupply().call();
    // console.log(tokenID)
    var countMessage = document.getElementById("current-count");
    if (countMessage) ;
    else {
        setTimeout(()=>{
            var countMessage = document.getElementById("current-count");
            countMessage;
        }, 500);
        setTimeout(()=>{
            var countMessage = document.getElementById("current-count");
            countMessage;
        }, 4000);
    }
    return tokenID;
// const count =  await nftContract.methods.totalSupply.call()
// console.log("count = ", count)
};

},{"@alch/alchemy-web3":"be8H8","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"24iJU":[function() {},{}],"hr2w2":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
const whitelist = [
    "0xC7C6DCe540024173c64453Ab4470a25D34dE3FBb",
    "0xf2450D1E606117ED6F149A63E908149E6Bfe6355",
    "0x6e21b422aC130E4f78991d89FcA78CDf54c802f5",
    "0x011c23b3AadAf3D4991f3aBeE262A34d18e9fdb5",
    "0x895E43360cB14BDbCCeb4B2eF06761b30b666a9A",
    "0x7FF17FA91Fb9272C8a293d9668Dea218844bF316",
    "0xDF7A2593A70fF1e69b5a20644Ae848558A2F7C86",
    "0x47110EF346DFa4DA0f0EF6ECe047632e2D7C771b",
    "0xC76EaaE92d01525798C1c590fE68A73d28e8bB34",
    "0x052564eB0fd8b340803dF55dEf89c25C432f43f4",
    "0x486fB5796da5743A25703C585558295A06a01B5F",
    "0xf3478Bf2d1120590fbF4cF4544C70d20237037d8",
    "0x680b0Aa2fF11091472E2E49c8dC346A4eBEC2340",
    "0x6027B4c9Ad98ad5Dc9Ee984Ed699a2079d401416",
    "0xC15753ae3b6099B8a3366b836433d6542645b876",
    "0xaFaC92864611c564e7fa1A6C6d07B45807536943",
    "0x4b4C13434aaC5e99645A4D9E59Fe497B3318f50f",
    "0x81974C1a09E53c5129c6e4f74E547fDa0Adf4D2D",
    "0x7C9Dc3FBc46b8fC15019Ce431b5c392b1D3E27d9",
    "0xB81a0e6c38c3Fec8A171cFE9631F60127a0C5bfD",
    "0xeB1Ee5D57d52a97f009a2B765Cf2E32eF937e759",
    "0xe5FCCBBC11E4A36a77E9d8E47A9b28eC44E2E2ff",
    "0x8929CF8b9acFb5f1a6156E67ea573A79F16be090",
    "0x84C625dd08e849ceEd8951431c986628C74fE89F",
    "0x0793886aBCc2E243D890df1E76E1B84220f25615",
    "0x7E2d7A51320731253a6b21c0F7459Fb0E98Fa87A",
    "0x646eF8E3c8E79a10dAF8f32621a3e468501cC3E4",
    "0x93243Bf5f577C1e325987862267d0314f72E0050",
    "0xeAADb89FC91b55D11d5a341c4748A488a90ec68D",
    "0xDB6CFfF6c0955676Bfa8ce795d5bEFfbAB793298",
    "0xe553fe5B71a236A8D6B03cBDDDe8bE48c5fC5402",
    "0x287509Eea1bda423ea32DF6f04fd473c469B6DBa",
    "0x4d116Fc9650e1360365071669198f8e8739Bc5ad",
    "0x57081166Ff4A1f68E66a79cdf52333d27E2E47E5",
    "0x3E3bb6dF1911FB29A885b9FB06296aaDd89d31CB",
    "0x8e19A6fB8aA477Daf05b239ebE7600443B5E5506",
    "0x8eeA79f9C6Da7e8a8a41EFdBBFd947F4326A901E",
    "0xc6400A5584db71e41B0E5dFbdC769b54B91256CD",
    "0xf7DD30418613EA2c892d58371a0a0c28fA511ccD",
    "0x36DeB67EB0e0dfa91A222249783c612f26673d49",
    "0xe2CE82CC0176f84d9d94fc37E157E4EC44880E07",
    "0x3f6d888B0d357A2Ae3100EC5fD8AEa00dc852386",
    "0x28Ef0AB6595f0C38FB476d125ec6175fD3Eeaf6D",
    "0x5b5f7E1E6D6DCF8386D91e0Cc15741Ff2a0a94B5",
    "0xA6245c53Afeea2136443D51483B8d53AC5c673bd",
    "0xD17BA9686C53A663996e68F5f77054172ea95940",
    "0x186baD94057591918c3265C4Ddb12874324BE8Ac",
    "0xD013A8079B138f2806c05e4A86bfb8112A5BCe2c",
    "0xaB5ECE3916628BCd972F35E865f4eBda3dD6F520",
    "0xC63A5aD9e61b64f18492CB1619c9C1941b4dF3E3",
    "0xDB8CFb34de60d7e416408b8f18EB3Cb9C638f8a9",
    "0x629Ec4737cC3197DaD07ECe6001B31CDdc776f43",
    "0xCf1BfD19B1AB67a251Ed749C7084e68778B9405b",
    "0xf901905D61D4927b029160527bA5c1C88C277373",
    "0x3496f3600070CC01d9665d1057F6F39afC0fe149",
    "0x59a5493513bA2378Ed57aE5ecfB8A027E9D80365",
    "0xAB80782F46FBBD18C1345BC2B244c5874E661b52",
    "0xBc781F61AD0dBFb695A03B9d74bAfEa3A0A6aeB2",
    "0xdf1CF9E3DebfEFd56286eF4024646f49cc540e37",
    "0xF40B3d16AE26262db9B19e0Ec80d8a490c40Bdcb",
    "0x1fBBd0e6d42d6c54104D03B9A39Bbd68DAFcB485",
    "0x77297AB28bc330C345B5D41146c504bC2A2A54E4",
    "0x868CDE43E6D3215CBfA0042D3a105b85ea98A4fd",
    "0x95Ee3fd02Ac5E17Dcd0726E1e536025cA0a984A6",
    "0xDa33d5A9720d482C5aF1E9A481498019C9B8e0cC",
    "0xE8ec6F729ADbE61E7EF3b48C4F490E2DdA1AaDEa",
    "0x1098406Ba70219457898BFc0B4ce3d195d74e914",
    "0x125aB65B8746D07a875d0Eb3De791A65a2926B4E",
    "0x463239F51f8d0AE447F65ba34b2E93c0C9f428d9",
    "0x5F0F16efc0BfA75EDa3f6b4e02C38E2bDD566506",
    "0x7A3C2954AC417fa87686c2e63F3dE71ff1675daa",
    "0x7e72F1c0C90e489Ce05344580186f1FC79270030",
    "0x80981F8275434C7feFDb3F2b74E27A2BD5b823BA",
    "0x931D724D31f04D85D00569830AFD9d97104778E7",
    "0xa96B4fCAcae1d4284774dDF3692101E5411e9137",
    "0xd1D88dBD886907BD9b9d99705f6667a0F9046cf5",
    "0xdA687389cc30272EfE218808c398ac2585F31498",
    "0xf667C9645e89E98943D510ae48865850C7978E79",
    "0xfE7be7372aD1c36a6E3e9ccFC473fe460586A550",
    "0x3C68319b15Bc0145ce111636f6d8043ACF4D59f6",
    "0x3c7Cb82ef3AD5fff10176Fd372dE8BEe547Fb537",
    "0x56Db1558D7Dc2E760B4f016B4A8365B4d58fe66D",
    "0xA6f4fa9840Aa6825446c820aF6d5eCcf9f78BA05",
    "0xE971e45dB57Eb8CA8AA2BB2dC6604aFd5EA1A1D6",
    "0xEe8eEeC3E7a5ad82827480A9E00D01B1EC0a9F3B",
    "0x22472D5919e01B0BFaAD650058AEB718c217d605",
    "0x246a0d293d83c9aD916e123bD2A6496F8f652D0D",
    "0x28473085Ba4aa761Eb541914F50A75Dd685cD47b",
    "0x3869eB5735251De3feF4f339E6EFeaD3dA700C5B",
    "0x4fc9e9094330Ba64BDb4F8295e33809e63b5940a",
    "0x6665a5A00ef3388328cB0713c008099e3E7B7092",
    "0x688399dd07Cc1A8C5b1243b90F03C70941a9fEb6",
    "0x88a66fD0C5D8CBac251f95381a032748341E7FC3",
    "0x92890034a3dCB1c38C1184775788bA0f95C23f03",
    "0x99A53b9dA4920e9Bc4ec63E7Cf28d68aa1153ab9",
    "0x9F7764056df891105a4F11C416354b8ED0570D91",
    "0xA96D8F49AD18a4293a7AC0F998ba586842aAafFC",
    "0xAA73a497398395f1203C291399d72E4530E9Ea3E",
    "0xB12f1F37767D19d63cA5a9889Da95cb396c957eB",
    "0xBA2E80144fE3eF8881fc5A816bbC607768e91321",
    "0xF2aBa42dCfF6f912A2A6B4a52c279ad3246b17B9",
    "0xf797310F77c551F64F5493baA0Eab153cD4D550D",
    "0xf84408070B4dE16D6bB0AB2FD8B19d37e3fd1422",
    "0xFaE4D2B23C2CFBd3CacD8f21a64845B08C0f980c",
    "0xFe2e6A8C8290dD2cD20A5460e3E3f5dD972AaC86",
    "0x007dA30d8349f5341Fd4B8257E0735cbACdF8e32",
    "0x07c2af75788814BA7e5225b2F5c951eD161cB589",
    "0x1189929328EA3Ce2144b31Ccc45c3b090D5D0065",
    "0x29824B424eC65BBDBe2b550c5b734204EE295308",
    "0x2cC5f1CAf422CeC5F6Fb9e19019E0D8a1FD8118B",
    "0x326b1b397464fB3aDD08Df12C470A6Ba022500FC",
    "0x43bbFA2821B4dBc2528796D8EC48E46541FF8a6F",
    "0x55dcCC2254C44B37093E26a8Cf1AbEd75494Dcd6",
    "0x58D2b53172eE43bBE12A35D68c9F73A5480e262d",
    "0x844289f123E2284a57Bc18264115548d91CC7597",
    "0x9B4e84706eE5b00B19FD3630c148C9A40db0565E",
    "0xB4460Bdf3Fe5Ba4e25f96135A76BDCb9E45AB010",
    "0xCdA73f6a6C249C080281853c6795604331c3430f",
    "0xD623AB65Bc56A67e63EA15e723403dB5dfe7b11B",
    "0xd9C5834B17C3Ab0A6fECE2D54586aDC8D0eFEFeB",
    "0xF0C11838870ca444F5DC0BA0271a36bb9D9F81eC",
    "0xf7A8f04C7fE7C8A6ED692Bdf5EE1658559cbE7Dc",
    "0x0Ac4423868f07df156826E0349C3F62b95ccACF1",
    "0x12e08b091A8b6419502449Bbb369709C1E4A60e0",
    "0x1d6bD644Bf98b718E260Ae53ea224465c7a72B40",
    "0x22e53c423E1D27C837C1032c01d4845C5C03E6bc",
    "0x315DaC5E567AC4b581D3Da95A867BBC3f3205015",
    "0x35CbEdc3412D3C93Dec4AFA60dDf38c2A9C38865",
    "0x443f2D31Ad2036212b2c4ca83CEdF87dE886b40f",
    "0x4a905D9987EeC20B2d3543Eef6798EB0Ea3bF964",
    "0x4c85ece5Bbf191d3e1b76934c8372d4Ae3Bf6927",
    "0x7448D055d16C088b7170A8947Ad29eD87010169d",
    "0x7972bC68FaB9b552963977077B4CdE82Da1722e0",
    "0x7B75b539c0C8E34cb17FD91680ce0c3Ef656f5EE",
    "0x862F01e6b2711677c12fE4cc4F3863FFb2E735Cb",
    "0x91279670955bE9608ec640E13B010629c6D90f76",
    "0x9BE89Aa1857e2567aa899142dBcC2A4e67212b2C",
    "0x9Fc7EEACD27d38a436462BB43AD97E49106820D7",
    "0xA16B50D06F5C32A33944f3EDdF4966c51A81E806",
    "0xAdF71973eD86704d06edCE48C3CeAB738d3604f8",
    "0xae1788699D4C34808d1d56479C618F2c024A5B52",
    "0xB3543A0a7786d72B89A4B2BAA8Ff9A2eb73ee0e5",
    "0xb66e39960aA3E1f0e3Ca4A7Fb1214641358e7694",
    "0xC5a4f1dD0510aF58FbcDC15acf9Ad3748076d9b6",
    "0xd493698ce1452Ec17b4Bb30131f550deDe91F08C",
    "0xD5079b0CC508f10ec6c1D64fD9Ae12619fc9B31e",
    "0xD722a299D14a19b56CDdaEaE0E1d5a5786424570",
    "0xDaf3f7f611eFA83033155D23C3EbC5B52dDBAeBb",
    "0xe14Bbcfa554dccC590576D7a691Ff50a3e917118",
    "0xE6EF1843DbC51C5f15fB6e6db7168ACFe84F34f1",
    "0xF9c7F88e12d710a949f89Fe878a667D949D0547e",
    "0xfDeD90A3B1348425577688866f798f94d77A0D02",
    "0x01A5639e13497c3E4f6819e54E0288CDc9F43d8c",
    "0x097B9f8eF542F0638B48cDc07b8D04AB31340eF8",
    "0x0b212B30871f282c32D46DFF1a7fB11Ca5B56692",
    "0x11Ad632cf28ee4559BdDF3D4dc2019e78EB7EC3c",
    "0x129B043520711c7BC94025b09bed6AF74d35a372",
    "0x165D48F121e2D0404485f32E63aBaD3867A0Ed9e",
    "0x16825261f0466FF1c69eB7c0fAa1CB268E3a5310",
    "0x1Bf1BAAC1E98ADe5dF093e015e0f783cc4b81b36",
    "0x22C8247ce664d6d739a2772ec2974B1e39c397D0",
    "0x237B1E9231c7c09D7c752951BD8159D29CCd7Fc7",
    "0x24F7a5f344287A56C5A3cccA5dac6E0D3bAbC8b2",
    "0x256B75EC25A552Fa63E148d2826268b953918c6C",
    "0x25D2E7509fE39A25819fAd4a31A1512e206fCc1B",
    "0x28A520f2049F65166e6Bb21571513429841B3914",
    "0x2bf7A0F0710a291d888c613E278bd2cB0e862470",
    "0x2C07C169551934a24ADB34A7194fa234309700BA",
    "0x304d06d318bae93170f692ee2b434B9ef5f99842",
    "0x361a84cc51179262EcE6F973e72A3783754d7117",
    "0x37fA73721A520cb70a9eAcB6e9f39705AB5bAec1",
    "0x38273f6874F3Ca41da5cB70754d46EEf926DB949",
    "0x3B25d7ACbe1b599F3aD4254569e98ABEcFe39a77",
    "0x403f3cC91702F344009614Dc41443696549F5d56",
    "0x46f42d8EB1eb8E53E07555Fb7141D48d4bd2ADf9",
    "0x4c4cEcF5C90EEBCdB3350e097F6eFB62186b5Ee9",
    "0x4f26bf8079C0f6faAE43F77055941b0D417Cd6DE",
    "0x4Fe8Ba98Bc8c06896c99794D0e347b2526CEf244",
    "0x5089b9C218fA2E1Bd136f8346eACed72Dcb662dF",
    "0x54D3834B4c5c5e7a96531f22453b0e035503F866",
    "0x594CDbD7A6b5Dc3265E34D7EF322eF29dD96770B",
    "0x5B6F36473aEA942C3DbCEdE8fB2a9C645fe75fD1",
    "0x5C251c9C4a1eA95104e020873cE70C07Fa6d8A20",
    "0x5ea9681C3Ab9B5739810F8b91aE65EC47de62119",
    "0x6E4862597Ea7Ac3d4316fecfa618ba0E8c24CDB9",
    "0x73697342C223450F87c3E63fE2e06bbD1155DcFA",
    "0x74faF5E70F9b7771948c5368F063D034B090AC70",
    "0x7611cef5948dd3C59F737725aA6B0D67c3633a6A",
    "0x76b588e62f9Ce0496861711832567f129959Eb19",
    "0x77f80700F974ca52CF52bdc87efCB3b0E0c4F78b",
    "0x7aE99a913c2fEdC2092111714263FE33241693D2",
    "0x8900C07836B148520e4d4962A2d155d659BdEa41",
    "0x8EE8610d45968bDF2fa3061FFba5c823c2044616",
    "0x908dAF37371f703FA3e1cB6aa1E8E4cb02a55795",
    "0x93091fD134f939cF81e0588C4442a5E162985E1F",
    "0x94C08eb6cFCb1a3C1e06e702c9DB77E213426B04",
    "0x957126433A407dD1900F8a0c6C2CE940fDb21395",
    "0x98c367Bed07b69bc83dC1e351470b06Bf844a71d",
    "0xA1eeDd41Ee9cEB88B3ccDAEefAfaB96bee890Ef6",
    "0xA7C43b31CB5fF1F24E9d77704c60e1d7bf566871",
    "0xADd72E24A9E9117Aa16d253cB421CB93b00240E3",
    "0xB1872d20Bd54ce7798df73F2a8ef1a3d8568eBfE",
    "0xBCEc39c26464732b40a3221D96E5FDc07f854171",
    "0xbEAe3e55b64dEEA7410b3cf7Ba3b9d7fcafe917f",
    "0xC2e0ccfD52326d9dB2Ca7fe8ef11018953244E97",
    "0xc3a08e18DEb5C8369df7b131E1E2C139989fC611",
    "0xC56eb092B1ED018f093B72E29bB49c6fD53D8bCD",
    "0xCdf734d1AC2464399eb9eBEC7f4B4f2f81d36fE4",
    "0xcEb78aBFad166C11e350156fd671b385265a6C87",
    "0xCf2b7c6Bc98bfE0D6138A25a3b6162B51F75e05d",
    "0xd001C5e594e27e782Fec571c67DfD3226B9294A6",
    "0xD170fFecC42Ed18Ce1a163C5ce6087A4C2A68BEe",
    "0xd53eBE4CeDa2FAC1252D917D4Fa37c5b87776eDD",
    "0xDA63e1d016C42Dce279d3e81f4BD4D685082cde8",
    "0xe2121CE0E8d51BF9D8A8e5E1DEf653115e76B97A",
    "0xe43274d83D95f599f130e747537729930DF7d792",
    "0xE5110E73cC510cB6Aec9A71eef74d27bf4f9bb38",
    "0xE8498f76149e2138cC943f9e5fc3281F97b7cc25",
    "0xE8b1aCAda69ccF8b5109CE7AFC8a580873825c46",
    "0xEB2B769f1aeFf7b89a4B7aca07f257Cf612cED7C",
    "0xEB8A171dB1A54553AbCBb78f956A0a100cE34C3f",
    "0xeE3766e4F996DC0e0F8c929954EAAFef3441de87",
    "0xee61fbfB300648ba04d28ae6E60D4496119BE658",
    "0xf6F001BF6844C178962177784d583cAC782a950C",
    "0xfB1D56db797F343831889900F2773fE288Bf36e5",
    "0xfeEDC4F156fd25C3fe9Ff6402DBF3b99EbeD3195",
    "0xffF4EaEfC1f8Dc8cd4ea12A90eb3f942E2d0bBFF",
    "0x022a7B3270Fd313Fb01a2421983A67fD382eEA57",
    "0x0296EdF4eb266dce6E3CBF44565beEb4a500BA78",
    "0x037ac7Fa0039DA18D9bDa7fA946c684358be4b52",
    "0x044F3C4d87A68D7E31284A63213F02396fF177ee",
    "0x065EF7139A121a27Dad041977CbddfB6dDB8B3fA",
    "0x0666028D0C4eB0ad6257b63e697590eD130fc1A0",
    "0x067107Af3512A78eABb735D8BF011DAC2e6e096A",
    "0x083fc10cE7e97CaFBaE0fE332a9c4384c5f54E45",
    "0x09202adcc6240D813F82E4Cf0D33732A9A863074",
    "0x0Ae2A25F329C946B6e1a8745b40EC4d463E8f955",
    "0x0B4E61A4a03e833900b209F2E3D1BC299Ba4531b",
    "0x0B82c2eA9Fe5372D01777EF1CEf5A22bCFE4d320",
    "0x0d231979a292317C102E0E8C38638b10E47E4326",
    "0x0DA6df9F5710cb24De6Cf018E4294d8B82DBaA02",
    "0x0Df7b3D545aaa5Ba2E6669e9bf34d25b5E314398",
    "0x0e3E474aD2a029C51E99972aFc245A4d4843345E",
    "0x0F2F9D729E00DD4653e1045006e1eF644AF42BaF",
    "0x12C12C3Ad9D1d5c68364A0015bF7f391DB1ccd96",
    "0x146D745139d417B8b5A1190cC73b34D7D37A9bBa",
    "0x15c69E9b03bEeB7b24f976D33aDe9027Fa27ca09",
    "0x180C27Ee48367a85EA88d45412E6ce2146EeDc53",
    "0x1Ab14911A1F736eB37C6Ac2790EC325d4EAB1F8E",
    "0x1B50d7e4a64558b82BB7f69D961e37eA3f76668f",
    "0x1ecf1df11252EaDe412A6E961c2DA1805d685f55",
    "0x1f6546B45424353963C67227b3C78cC6bb99EceE",
    "0x271c6f480Aeb26672B915A7b33159cE8f1e97fd3",
    "0x2C26821E4a2e9d1ac9328b4E2510C635ecdf8f68",
    "0x2DbD9b95c185C8E40dF7Ffb5B0ea8E62c85d3BD3",
    "0x2ED7d62a610B9A9EBf5e200759f2f947AC611C34",
    "0x2fea2af86f4DbE1b41cA24fa2A790a37C8f1EC66",
    "0x31aD05d24A99892064007a712005aE5FBAb174F7",
    "0x352AD108278007f464661491a849d08d8622cDD7",
    "0x375Fb99F3aC98029E40EF3B0667032924B8bD070",
    "0x37eCd3816f77B0a6E21f491B15ADA9C32ee9439f",
    "0x38bE0feEeB9d13A10Cc5217Efb08F163d06aB60e",
    "0x3A027234499E3Ad928B40ffede0f964C6e4bec8d",
    "0x3dD38521DDd6c73D2652d013f4aAc691d8f50BB9",
    "0x4839f0a75edE31d26613c7CdcCBa89bE774e9856",
    "0x49185F385b83332bda127B46e48d186083Ab4988",
    "0x4A01325d7f1880ee2f786B634dBd755D854A80F6",
    "0x4B02F386b76C53Bb722a4a8020e297910C7b8964",
    "0x4beAcDf61a7322738595840326f9E4Dda62dA86e",
    "0x4C21bE2b54AECB2AC307D850719947a8fc8981CF",
    "0x530e57269C33f4De780bD5820B85911695969D28",
    "0x551a6344576837333f6C2c27936D7BDDa1B27283",
    "0x55f25aE016e2CD04ec3191594d43Dc5A08102378",
    "0x573EFb51f83D4265763f530295d4afB25A487Bb7",
    "0x58611b3Cba4929b03da30285442cc861D949790e",
    "0x58e2726ee01747b37185c3F810c6d48D508353D5",
    "0x5bcA80feA5bd8A5DE4C4fD8C9127909117b891F2",
    "0x5D080b5D2718bd65678c9582519EB876c3042511",
    "0x5Fc8BdA8887786C579ba20C28e7B0FC0055114a2",
    "0x63452484Ede33876EA5e18F7C549cf183E31d352",
    "0x63A76211A1b7dCEF14C51A20446406Deba7c9196",
    "0x65Cfa7d7cea1Db7a07DA9b058f403BE5f511CE5c",
    "0x71672Cabe7674675Dd08Fc2132cfAcf411F5f79E",
    "0x7462b0cEB40c37dA9E93718a4215881c9A8a797a",
    "0x74fB827A4F2b9D08E72A14047f8011B503611E76",
    "0x78d9f7747BfB3B06e10e2fa7a99c0209955eDa1b",
    "0x7c3894Fd7052FE0987DE8fA9BF9407317b619084",
    "0x7c901D78bA68B5be8368c2305f3b270Bf93C4CED",
    "0x7db3E3f10faD9DB3a2DA202Ddfe62e6A05b86087",
    "0x7Dd53a7272A76684156509853C729e960D251910",
    "0x7F959d5aA2877E86ff38CC3ED11DA46279658b8F",
    "0x82059C75AA0a88687bCbde02486B64129915c27b",
    "0x83A7F4Fea9B39F8c2aCA2393331620d0144811D1",
    "0x8481CA35C51260A7b1289356855C82349381fC34",
    "0x87BC2f2ba8C83F412feD5c3151de0ffBDC959984",
    "0x89aB08A93a7E0931E3940b93DEf76416B9E26cD1",
    "0x8aCbb55F8C1e4fb7057e2C38a1C07269e448762e",
    "0x8e5daC173898242cb90F9d6c3bF5D9c88121025A",
    "0x94a081cDB111f2B9c7192e712bAeF7de17866d63",
    "0x94de7E2c73529EbF3206Aa3459e699fbCdfCD49b",
    "0x969fA39f580AA68e72959FA279c8576DA34e56D9",
    "0x9b0D1ecC2e15580Ac47EF7fDaD0443B16784402F",
    "0x9B9Af01DA8316745F7391C1B8dD86E1bE220C42a",
    "0x9ba58Eea1Ea9ABDEA25BA83603D54F6D9A01E506",
    "0x9CDA37e0411CF9293bE06D5E62f89C0Bb745CAbe",
    "0x9e82b8BfaB6744acAd8A3576190307F52A4bEc60",
    "0x9FBf872B185d9E940C9D71cC936e44dfAD008cBF",
    "0xA0AB440d4FCB1210a5787B6b94F2581580950d4F",
    "0xA1830E8d9F019FEB448478a171Bb37Cc6C4c0482",
    "0xA6A7F3255C9775b1be0a23D710eac09ad816172B",
    "0xAB01d16135273aFa6729bD6f9Fa8B061F8fA2674",
    "0xB2e1515Dfe9BdE106299C33529C582e5388D195D",
    "0xb3ebDFdF5f8a691b01518d4C4e21ba95fD12cE17",
    "0xB5964eb06E25734bE1C83eEe839d926da0EfeD05",
    "0xb65893E83bbD9FA5326446251E32Cab8eCC01544",
    "0xb70DaFB3f78312CD35C6EB2a1228a9eEbF484E0F",
    "0xb7693d3f040d66ab89ab86E7f8688C01feBbC77C",
    "0xB8F5855b2dBbE6c5CD9dea25571f945F14B99Bb4",
    "0xBA051AFd06C00b400479F0fad7939b7b290b396c",
    "0xBDd45d1fa368d5e9333D8Dd85118dF1d86209d17",
    "0xBe98cE5dFD38F505e5525A49a1c593C687B0365d",
    "0xc224E63a4f17af617c1e9CB54F18B94b02A8eCAF",
    "0xc37016F3023d0218718cA22A423D9dD00eB58275",
    "0xC5C450F79B1F0f600b5bEE6D258CE679c4500fB4",
    "0xC924c02a7ADB0DBA2Ca0327B8A224544d962313F",
    "0xcbc992E42ACbB0B8A6E43b2f283CA4b3dBC6e1E1",
    "0xd095E0f8C72E22319846b643c4bac0caC1f67006",
    "0xD7A259c8a99B5CbD3B23222Cf1768C90448044b6",
    "0xDC0D28F3D09b292D41b836DB991b157D641aD64F",
    "0xE001045D0F5afA9728c88f48eBE274647dB6c7e2",
    "0xE052113bd7D7700d623414a0a4585BCaE754E9d5",
    "0xe83120C1D336896De42dEa2f5fD58Fef1b6b9934",
    "0xE9Dda398EA9cBBB3D851592f07a9951d8c03F8E4",
    "0xED6A750DBF1b462C030401C54F0DA598265447a7",
    "0xefD393F91C713bb713E3F5e00A8b1d3656Eff0B7",
    "0xf01E60Ac88C906Ab8553ef6c6AfD78d6f96a4dF1",
    "0xF09aab7003a3B82c421002D1f9fFdDBA151BdF32",
    "0xf3fF88faf8d1dE643631581d8fDFd8D3370d19AC",
    "0xF4449d93F17a57f789053c5EfD837F21b1E4C76e",
    "0xF797770E8f4758d056430d5eaCcFFc2021051a49",
    "0xF7BFe4048B066a98b4FAC93A1392DdF90061aBF2",
    "0x000000002e4254F818F89051778f423219dE1626",
    "0x00cCD93055FBfbD797A637c0058869bB7cB9b35a",
    "0x01B590B256dCb6300fe43FA2c629Dd9fD2838eD4",
    "0x020cA66C30beC2c4Fe3861a94E4DB4A498A35872",
    "0x02458318d32E9A1dc9Fc4017Bd53888aD5BFA1d2",
    "0x024A88896b6a85BdacB2DE0F23e7fDFCa7091f5c",
    "0x02864be954583456c866130f845595Ed70F955b2",
    "0x02a328Fe5B967E079B63c6e3D34d718914DAF7bd",
    "0x05f9469dB4530d9492Af07fB064DE2aF8C48554a",
    "0x083DFB623Ae37C6DD7302AE9e4E33da62aE4d2a7",
    "0x09D390e78FAa3ECA8C6e3c0bB3C6CbCAF679a44c",
    "0x0beAF25a1De14FAF9DB5BA0bad13B70267e3D01e",
    "0x0Bf61B1C2555ba947C3D6998728C88fEF2251780",
    "0x0Cee7f0fBEA8D1238b114107C03902c33286844E",
    "0x111bce709d028F21dbf9b2dbF5A40c9d32cC8198",
    "0x12671F2E0aa7C3d6392f1e7b22Dd3419838c63f5",
    "0x12842151d19C14a845CA685511C8d93AD2fdc021",
    "0x13533EDE370394d85bf02243a9eD0C58b7856579",
    "0x1439b4d5a72343b68F12398C649dF99d76b2AF53",
    "0x14e35026c979a8cD8F2c6229FEe855F4E6bB0338",
    "0x1695609ECf81d10F9b1227CED1a84eB36cffD57A",
    "0x175df70833652ebe593f224a97879F3b4D07e8F4",
    "0x19e7A132bD4B42F580f546197f42e19c42Cdfe6c",
    "0x1B144b2BE0309185163146041A8D4BEc8fC7C536",
    "0x1B5FA309B47A945Eb4a9fd7250D9ec72a92D5DC8",
    "0x1b8B3E3e778F6A75DA0c44a097CAEA3c7afE4f19",
    "0x1BD330dd2cd274166B9eeC79ea7A8A0Faa729889",
    "0x1E059b769707F187d387BaFF50f059BD7bfA042F",
    "0x1EC5858f161fa17F148626ABcFAC12381F97D34B",
    "0x1eCc365aC0300A9aB023aEBa623cF9730a1455f3",
    "0x1efEd205cAeDe27dA1135cd37A4192861a51100e",
    "0x1fd146a5e6152c5ACd3A013fBC42A243e4DfCe63",
    "0x20357EB5Dc98da197C332D9FdD2a38ef58C91Fb3",
    "0x21981d217d21855786907b7cCC5F8bB849A0230e",
    "0x22fbAa2Dd20B848084545515fB04b9C846942779",
    "0x234E486279dC07733E5dB157277910Bd6002D3f0",
    "0x261812F2b755A272d6705f080eD63F02573adEB8",
    "0x271adFa12DE6894EA3f38e1148Aa07d0f21fb9A8",
    "0x2819373BA8fFDC64a433Bce5C075B212381BF90e",
    "0x28B581562f4A2CeCeA191f0e5A6C87b3a631FB6E",
    "0x295A1b716712b5dE1Af2656e1F62F17E89Cf18B9",
    "0x296132E19aE5737400ca45bCc8c8555982d41d53",
    "0x29E5f2b2f0F05dC05eE300fCd6b0435651864e71",
    "0x2b9a7034C6f118175A05A9A39c459390b1067a5A",
    "0x2c2Ca5c78fb30B0aA07BDe659B24D281f3EbE2D2",
    "0x2c4BdF527a73876b24E5e7A1D0F1a76Ba0e73954",
    "0x2c9aEee0D862232371FB74a817eb3D275C21d358",
    "0x2d2D2f3710c600b1f6f53Fba2870F3664E899466",
    "0x2d9037c11A3F238bb8844F281aD263042aef2ba8",
    "0x2D92F5248EBE49D1f72851F48690E5eB25235df1",
    "0x2e8Ea9c0926811E1c68bf10753B841c759166253",
    "0x2Ee35ff1002FEa5471732bCC7DA54A9b3B97F367",
    "0x2F4AdA7EFe6b1fDe3f02d79753C0852De2d49A4b",
    "0x31791a3A5Ab1e29A284ce2a943Ede95132B36BF5",
    "0x327f9649e515b78AEac8f02b9b479C1e30c886C8",
    "0x32DCC9247adB40AEcEB43a67B814AFf21129DC42",
    "0x3312CCd51C8A02f478a5B58B8A116dbf984a7E14",
    "0x33a4F6Eca4b47a41Bb8DB427f205aeAA3263C038",
    "0x33bF10b2b4a57bC20d955C00B2f735897124785c",
    "0x346a019cb37e38E6eA8C5ffd4E396aa77Ae7bB49",
    "0x346dFecbC8CaEB0881b6773392Fa3aC7A317f0Cf",
    "0x378d34a1f967B85b15d40d2812916D07B012D9Ce",
    "0x38c37CDD992112c2bdb70fe6bc460BEb288Af27A",
    "0x3B611B264a2E8fA21A2bF071bf0c24933e602535",
    "0x3d5134Fea579B33BD916349612de5ff940A24002",
    "0x3d6aA4A242264F40A78E7447334F222ea40cD323",
    "0x3d79d25c2Ca7959375D4a1dec4E78bD3F669a15b",
    "0x3d90502Ed8C27E2d0479a1d32697DFe361576218",
    "0x3E3567EB03521aeD1047951620CdeF6353F763bf",
    "0x3eD165F81394A2c7032Cb2Ba9ab7B376e5EF4180",
    "0x3F4F0cFAd68528D958884Eab70009241e3729f0e",
    "0x4074Bc05A89f1b97B51413b06F7e44F46Eae6880",
    "0x407a30Af48d6523873C5027610a57F5D02B6252C",
    "0x45584Dceb17FA7Ff7C182F1cB3D324751a3D427E",
    "0x465D86899a82A1Bcb79D0C657CF495C9af9781D3",
    "0x46DE1A837bD940F7Ec5Fc38607C1b67Ef013aAA4",
    "0x47E482ca22f52c243c7B11e2d2e28bFb7699214b",
    "0x483493Ad0A0f0BbEE0dC5E1358806c40dDfe0EB2",
    "0x4876Ee6fB20E3EA861CA9E05AA0789CA848DC2fC",
    "0x48AAe1669D4cf7988A227b3D68d9d6E9F02840ee",
    "0x4907911cf8911510B89Bc7147a25700b2d260F36",
    "0x4B1e684d5143eb7435E5D78385FA8cbdCcD8f7EC",
    "0x4BD49374BcbE3704c7b482173049B1002eed3B2E",
    "0x4c6039F68E0bAC8979a4e1196832E4D50f9B6CF6",
    "0x4e4dD48cAA33DE239D7D901cc1204710570e734a",
    "0x50596ca578471407f631d5AA222330408CC629FC",
    "0x52BB2207f9842A77B1A2AeECF43A64b5a9A4911c",
    "0x54e9AEf3f2Ef547F7F5447BeB5E99bb6ce3C2379",
    "0x54F35e5464222ddecE6e7230AC26fD51fA82f0f2",
    "0x5548c00fcFdaF9a01B344387EdE4eF1595A94Eda",
    "0x580bb63D47242964fA5fe9E69C5eb5423B7A50D2",
    "0x581E2463E67059523e7DF3777203687D090a6794",
    "0x5BfEBa3D61D902e86417C6CD94DFd2795F8AAB7E",
    "0x5C3097E7Fd3B97d9fdeEC6D378884c892Ff0545F",
    "0x63989a803b61581683B54AB6188ffa0F4bAAdf28",
    "0x63B135a7dfFd00dd92FE4bD58378Cf4b0110f362",
    "0x63F39b7d06d1A0279C28F1D15675F757c953f19c",
    "0x64c5BEaED6213aF491c7B5F22fe29bf1860688C4",
    "0x653eb356F518e8B7469C4d3b3AE56908A1D7fAad",
    "0x67F530146229bC69cE7937d1D7E2098D3eD64cC3",
    "0x684bd243b42c5a169e67A5474E82b5E861b92668",
    "0x6897625C2Da7E985e9c22E0d7B27A960Fc81D1D2",
    "0x6937a767422c879A90Ccb1765c0370431A87f70a",
    "0x69946C9cC87EB524D0dc3a9D40837cD35A6C02C6",
    "0x6Aa80bCA0e8047eac7AF3D47c6983a6611F0DB4C",
    "0x6c33D7e838B83d99d3364694b0e66Eb32C3bFcd0",
    "0x6f536801668A575D7CD07666215eEd1BC701B922",
    "0x705B3320dDFC2cA46E4249BCb7A2D0E2FdE5386a",
    "0x70eCe45cDc64A768f936Ccb8aC851578251363e3",
    "0x71D105Df20828163f93B3Ce87BBcE1DD567DFC8B",
    "0x720D9d8A42a7390C4E063f317F50F1858A8Aad1B",
    "0x7298B668ffcbF2043ff2dd3e31d9BB3e447C19D1",
    "0x74A186Cd4dCD3E1bF53ab1D072eBcE38173fb8d5",
    "0x74E7bdf51a338aDB142627d16fA9473E9a81870a",
    "0x75a28547AC8eB72c2035AaD5e146CB775604a05f",
    "0x76AE62825BEec790e7107981074b7040EB07E32b",
    "0x7821da4F804F4CbFa5ce1d88A0CdDF33C4aCDFf6",
    "0x790aa4A07E454BDa1CdFB408EdBf1CC9547faaB5",
    "0x7Af6ECd8c7BFE0039AcAdDD76CBb99B11afe426B",
    "0x7B70EfC4BCA9Cc0733c1B615cf480E33f19119f2",
    "0x7C05C0B0c886a5cc7f4Cffba05983FEAbfE801fF",
    "0x7C5afE60EB8B6b57E856DeCaB71BFa4929855150",
    "0x7C7b64F69cBD43525A63B2234E084Aa9430B9Fe0",
    "0x7d65bBA2e829FdAAF3a185a3f5596ced9bC6b462",
    "0x7eE553b1F5855bF1f5165a9E5e554A2F089229Df",
    "0x7F83AA115983b95690bB86Cb2949C1BA4BE7FF47",
    "0x80224bABa8cb19dF5104650D6225E251f6e327f3",
    "0x80a03DBf383c6FDD96FB95D1A24d63C7b6d02b08",
    "0x810E096DDa9ae3Ae2b55a9c45068F9FE8eeea6db",
    "0x8450DC9630511500bE6BC9C44F928444B3919231",
    "0x852bE9a14Da06426B95De6EfC9ed972DA2df933f",
    "0x86Dc971B161bd1E8dD37369Be3520691c0Ea06c2",
    "0x87594ab3C705bf6B10921F79Ca98521F7ab1CB78",
    "0x88F09Bdc8e99272588242a808052eb32702f88D0",
    "0x8d2c76d83af250EE7FCb16307A2adDC87E91Fd3f",
    "0x90238A0A150C47e326A19AD38f05700021fCfa62",
    "0x9112BdcbAD48E7603e8d79f67C6fB4692858F5f9",
    "0x9141Cc5C2aC9Bd4a65Fe09dae6Bb7F8AC0C78bD7",
    "0x943A48498c9D622273e214C1757e436F76a113ce",
    "0x946dA8D6AD072D50DEa77C9b2511D1581C3d6e54",
    "0x94afF46a5C4dA2e5920c945fC76eb786330579eF",
    "0x98dB427092018b71b10a712988B4510669Eb0eC9",
    "0x999999B2173a81c2b20E202c3d22E0473f6517b6",
    "0x99Eb1e8FE62459B5Ea1bBbE2c9d900EDf6e9e0a5",
    "0x9BE72D5c0B1639679ce43739BD0107554F815c24",
    "0x9D30bF612dA81d5737c81E3664bCF8B9f2355b5F",
    "0x9EdDCa5e80bF94d3b8d3Aca4F3f4CC54922c74e6",
    "0xA07CBD0708a470AB1f333E216D2775CB5Ee14700",
    "0xA0df120104cC8796Af1377b931b30279B2a01aE8",
    "0xA1a3524e1bD29F71d11E787d36BAEBB91bfc20Da",
    "0xA4626Db81a978a644d28D8a9D8436B587A0A5333",
    "0xa551424f18c9B7536d64A48122fD58C619b7Ca2a",
    "0xA6C6085eEdd2841c52686E2df8250978f3A40ab8",
    "0xA7550955baCc71CFd5ca3B7752299544f92D4266",
    "0xa76C6940BF090B429654B010cD130B02E8f83884",
    "0xA9ddBF3d289D0417b821bb3B0D7e987375183Aa3",
    "0xAC03E420d64657A806411A871d74cFcCeA5143bA",
    "0xace196A456D536C360B44137384e7eCBDe05A8D6",
    "0xAd991426A767fa52460c353f9B991B4DDC8bfdFa",
    "0xaF2E919B59734B8d99F6Bc1f62Dc63d6519d14BC",
    "0xb25d13220974927ED4c38e7bB91A170840a3D99f",
    "0xb388378967A5B202aC4B8a474655C5137faff269",
    "0xb533f24cf34eB009f97b73Ef22c6F0a4B0438307",
    "0xb63633d726A54a29bFBA0B12F57D6f847e306d9D",
    "0xb7b70c2be01400eb89c9f7cfF667Ae5685AeDE71",
    "0xba3DF058E02bd84dDdD7d854BA9f622eA8543285",
    "0xBA9F8f95481Cd383868721a856C00B8a8F35A3D3",
    "0xBC2A21A50d88E0A48B75C0a5516ae51BFa45Ce6E",
    "0xBC9A8EdB52171777a239397a0A6212f2A63c987a",
    "0xBfd8cba6a1E10e1Ab4Fa11A0062F4e52e13D260f",
    "0xbFe8270D85cAE24420Af050FF74C735c0F218a29",
    "0xbfe8D80aDa3Ba571d37cCecDAa58E952C2b0BE30",
    "0xc03219bF0393CD3A4755436Bc51C308e59dDaA20",
    "0xC14baeFd5631eC25c9e4d02f3253b1e59D848911",
    "0xc4E9c8E2a5fcEb75610E25C217774A03Da461875",
    "0xc567Ac610508dc26e129D9C6194b01ce399f44b3",
    "0xc5b042Fd881555e9B9004Cbc4FCc9581512348F8",
    "0xc70084445C4d24809C72b91e62B1168c727508CA",
    "0xC8dD40Ba1Bdb6A3f956904f02B14Db24013b8B5d",
    "0xc92eACf9Fc23f5562b110890EFAd74aF97E68281",
    "0xcC0Ba34FfE6107D4119FCa34dde7B09386bC8166",
    "0xCefB3Ff344a0680B59896D8f273C473184C69281",
    "0xcf031E325F14f7D8953d68dBDf4a769Fca82716e",
    "0xd00aE6F9eb43E90E2C6468Ab9A9faA7E4e9ec6d2",
    "0xD00D434dA36F38756EFCc6D85b8Fb39072082D3c",
    "0xD0998773fa85ef7E01ceb392D60683F5FA68afEc",
    "0xD0ba6cF912F0cf6248fe951A063635CF9F108C31",
    "0xd4100a2E1aacdEB18BcdA92A280124a7111A12B6",
    "0xD5202733009631EA8ABF7cC218D50d4227E96D11",
    "0xD57Bb61abadE7a99FD42D813D47177097d4C73DF",
    "0xd59f74e988261683530F2e31E2994019906CD633",
    "0xD5b809F1e97f5343D15E6891B528F4B4DeA5Fcf2",
    "0xd61af1ddCaCcB4502368396D7101947A64b0d85c",
    "0xd677728f8CE1FC3b295bd5F9C8f6EdC2dF3Aa8F6",
    "0xD72CF23146eC9A9eF1A9DB0DBB21f30eF7a76615",
    "0xD8f8738fa84Af31c877AA13221588082a6Fc1132",
    "0xD96fc4E4aBf1e50c9572A51c796b2E59ff4bbb64",
    "0xd9a0994576159135Dab8B7727eBb196bCA8f4148",
    "0xd9C819752dEF1C636e894bE3FF9A18E6De09c7F8",
    "0xdBba4f80B7385e72f50a8BEc598d64bf6135758E",
    "0xdceFd7f01d32041CDC88D00296363BcC78658d10",
    "0xDDC08d2495E0DC63B5C0D8E7f0EeFb58140C55DA",
    "0xE0340BCD657a03037b7FFc2AB8F5C6C804E63a85",
    "0xE1ea82Ef81A6D7dB87A8eb1108DC1754997C5a99",
    "0xE2c1a36f6d39F3D1698078e6579fCAbb779B5a32",
    "0xe3182E0EF507589B142606aD78748ebF3849B228",
    "0xe358bd655af72d2A313AD4aD1CAfBE80fec6715C",
    "0xE51e7d4898406396de410ed88f417433c66060dd",
    "0xe5ca73f6dda4c634102Dea8225D185b0A5DA465c",
    "0xE660D78B6f2606E996c7860d860Ab4183706C8b0",
    "0xE76313C3BF4F36CcAfD545Ec851b77d525Ca0B90",
    "0xE855F2Fb565eD70DD14Dc278a0834FA7814a62f0",
    "0xE9fEcd6CbB3A2AAE27D0e718Cc09d1BE3c606260",
    "0xea0895A4ED3820A2aA43f160E7D3167eDAeabCc7",
    "0xed8730c7dCCDEf0f30D232c018ba39c41a7cd1EB",
    "0xEE171CF606d5B31A4E9e816c7a7bDb859cB42BC5",
    "0xF07F1EED5252ec9679F755E64F9f70ee9bf1bB2d",
    "0xf1995A4D99af77E51f5F455E6554a1D42f04Fee6",
    "0xf1b1cF1a44CadE3d7a0962d61abDC475f1f3D093",
    "0xF1fCfFBA10de3Cd282baf4b6E49393Ba03DD3Be7",
    "0xF224837e13B1a745574Ef68A73427B0063F266F1",
    "0xf2658F5F05c33C0194138134ca4bB37DcfBC494C",
    "0xf346ceB133a879edf47465A4b17CcB426af5Fe85",
    "0xF4363De08EEfF1ec9F8D74395e6B362eAc339B5b",
    "0xF8298fCFA36981DD5aE401fD1d880B16464C5860",
    "0xf896527c49b44aAb3Cf22aE356Fa3AF8E331F280",
    "0xF90E718487913eaD0b17ebb757cb662Cb76854dD",
    "0xfA7A50aB11552e55e8ccb6912f3084c5c6B37115",
    "0xFC920639b9671EFC35eb277ea1797F5Fc9D95f0a",
    "0xfCb11F4f6749dd517aAA9f38035FECC1Fd91291d",
    "0xFddbD16C471878D179992A491438d9bC0A162A17",
    "0xff0aF2a0d45Be96Ea3bc31eb29D3F85D2d176216",
    "0x0055e7959628c0221Aa967F2CC61180692E5D921",
    "0x00d6ab90C14F3deEB709b840ea6613Fb0d023e7E",
    "0x00d7ea1eDC07D057fcA5e1cc80ba3716A2008560",
    "0x01124B458BD46fc1EbDFBe8592408Ca2ABbb4262",
    "0x017b19C62A5464f1ebB9f991D5502Ee1EE07aa8b",
    "0x01832F1d7fbAbEFb1F11775188322F5301e5e810",
    "0x018eDC98B3190DbB261E6Ff3858c4BA59c71Ba94",
    "0x0206a769cdd1763797ee6Ef9eb4138fcAE4B43ae",
    "0x0234B1ad3bd877ED01E534D4bfa017EDcf15484e",
    "0x029Acd49d3AaBc08402C84367c050DFd52b6c566",
    "0x0308fC9F5D74d3DbF7444286c70a9F7192fd0FBD",
    "0x033b6C45Ac083a2470b4Ce05E56c1D9B79f313BE",
    "0x0387876a09a45581109EeCAB2FF4Ac049E76Ba37",
    "0x043154e487A73A0d9868890490c6c9C9605311e8",
    "0x04555AEd72bc5B8e480212E6855f3a071dbb34C2",
    "0x04d0c64d8b303586Af5CF6Bb37db16bd7b78c43d",
    "0x060414C382b1B2c61EEC01b0BC033e94cd1AAAc4",
    "0x06a98460440BA3cF7283E783A94520EB63fea38C",
    "0x06a992201c2b6F496D6c901406a7fA88566547A8",
    "0x071B1B83540Bcf209BdE6Ef497318cDcc03C75C2",
    "0x0728f8F9239757a9BD891408B4ffeCA59293c263",
    "0x07587c046d4d4BD97C2d64EDBfAB1c1fE28A10E5",
    "0x07a26C3b040b8455f6F34dDd1554916Eb8762f65",
    "0x07BC94C8F963C7C80ff6Da1f1de74D82858854E2",
    "0x07C73Af8440b6A35A271f146B137521DB6E19Df9",
    "0x08464c9dC31e92122d4df6c0FE18E46C6cA2064b",
    "0x085d07D65b41158a1545EeCf05316eDb5D163b54",
    "0x08D816526BdC9d077DD685Bd9FA49F58A5Ab8e48",
    "0x0924a53Bc62bE63c512596BCfd31449c429f77bA",
    "0x098b1c2A2F36e3Db6D61899378ecdaf6fBfF6dc8",
    "0x09d92c0a62BC5ae6c82d5B165334BF4Ad9F374D1",
    "0x0A605F26A5B6C37B27fdDB155CCB495fd4F128c0",
    "0x0a9516F079f55bBfeB3980eCbaf31f6e7ED169b4",
    "0x0AA568cfc61041Aa215cCE4a39b883004276A0BE",
    "0x0B096d1f0ba7Ef2b3C7ecB8d4a5848043CdeBD50",
    "0x0bB71223a36253F9Cb704a065099d2FFE187F85d",
    "0x0C54a765C77A88D9CdA0BD7ad9B10422848D92Ef",
    "0x0C8061076b6D0585a3E1835f6b9487FFd39FfB7F",
    "0x0C830A9806AF3EF3762b21E98Ca6818e373Cf985",
    "0x0c9C90Ef4cD148f4e7C17b9AF3dd21BEeA679c31",
    "0x0Ca9e30D8744b8E2C1d15F45201914E0440Afc3a",
    "0x0CC763ae3d7D3AEadBB5Ba96A9d2aA8454F3b14E",
    "0x0dE50c0e0df8E7E5e7c31Ad0b49B62623D613490",
    "0x0E3ADfd4e006fC82331338FEDCea68246088F5Ed",
    "0x0E926d11b8F7Cca0F4A58b270bBF4aa553B694Bd",
    "0x0fFC46b6e8c7Fc11Ce4B276eFA560Dee70b1677e",
    "0x1020A435816b2D335E36347CA86fb8bD99Be9cd5",
    "0x10383b03E989fCf2844c0687128c9c1932366fB3",
    "0x109E400d2245322c56EC593d69dcd1f98bB6de14",
    "0x10E5C504cE23c14a55cF265B0b69a31D5ab0b04D",
    "0x112b9bfE210FB34f0FB264669A70f0D7Bf39B0E9",
    "0x113Ee41d97416D0afb2915e9c4Ed6D4a4E9c299B",
    "0x126e1f5B3AC45820d618E78d48a45337f33c97Af",
    "0x129cfe876FcC7F8bb8901268d69d4C678FdeC8e6",
    "0x13003d2D8050780A28FBE9D818809BBc04aa4B88",
    "0x1310BB8FeDbD21c21a2311c989e100E29d12154E",
    "0x1336324033D47cFFd50D66a3BC077E29852E08Ec",
    "0x146600615F7Dbb9fD7d7Ae4Cea50422a5C273Fd6",
    "0x146B24973975C87053c035b128ef92D19c413dD0",
    "0x149B85D173F6318315A7b528672B846948fBd4D2",
    "0x165E1805d77E64C4A399e82D01D376f2D2e68AA1",
    "0x16e34FE8efB8b55D0C228ddE510fdC97C8DA3b95",
    "0x16eCdCc9E58A9464f433B5683cd4D1e8E9713Ca4",
    "0x17203b9555261DD980C8134913286d27A9219b10",
    "0x1726439C2dEaf8717b974B75aDcB748F0BE01748",
    "0x17A65D83B2EbCA3a35e8f7Cffc55052046686985",
    "0x1821f4c3d20C28daC9BCA886180e46de8987ecf5",
    "0x188Bd32F4c3b5FfAee22C2ec653f5d32Ed27d844",
    "0x18b5BE29483b436b991A974098DA1832332B21D7",
    "0x1949e267f185763D87c7bED4b59f7C6fC48e0acF",
    "0x197794928B72B5c6C8B3129342C2cf8eb8B6C92C",
    "0x19e1444846dB53861d0d78Dc19786b3bd8cd681B",
    "0x19fd14Fd2546BDFbd54fa4E9C159D2F29B720c17",
    "0x19fE2524c51A46f8876843e0aeEf528129365B01",
    "0x1a1EAc252749F40a68312f17931A9832e0B1Ab6e",
    "0x1AB9a94B8B7966165A0b8405f86Bb83e28e01cA9",
    "0x1aF65Ccd809656819A386F85E6d8DC9508477646",
    "0x1b89Cd273791CB463f75C4973f60d5D68e75f0c5",
    "0x1D9e4c5C74eDC87F3F42b9A48e1945a58D40c237",
    "0x1dDFbC13E290f2A2a5b5Cc535DD6B6B67Af0F043",
    "0x1e32895D4345b1ed4fE03343852fA3764BbC654A",
    "0x1e341Aa44c293d95d13d778492D417D1BE4E63D5",
    "0x1eb322c016815EE5b29c071586C1B75Be5934576",
    "0x1eDC7a95513aeFD09Df8310d410dbBBF2d0bb36F",
    "0x1F110a0455812387621A693D2cdEbD26e783F546",
    "0x205B9ea06fEDb4f38b0D59a9Ecc5bD75d8E8CFa9",
    "0x206f0A159F8BbbD502ED8D8c2D112855A05F75b9",
    "0x2139950c1b0381F9f45d5D93530a36201fbC02c3",
    "0x215d89b417bA6Fb0b7328484829670Bc446e4B24",
    "0x21b9004663a89f028ECAee675DA6C792564D6579",
    "0x21CDf0974d53a6e96eF05d7B324a9803735fFd3B",
    "0x222769160bE9bC567333766E5a53660F658e8501",
    "0x2234F2115ea27abE6276f56145f699ea5EA7d1F8",
    "0x22B67fa006Ee398319D8Eea178565E7389203b74",
    "0x22cA506Dc852331664EA52F28704a1bD0a6d084f",
    "0x23555A23FA797beD61b8393B91b266Da7632A627",
    "0x237A86EaeD0df656d8bc4ae619760ADE5B4705F7",
    "0x23fdcdCd0892Ac89E2a6DF115c6B6124e24b4c38",
    "0x2491225a28dc8FE57d349F9AA3Deaec98320Ee29",
    "0x24aC005adCBb3d9551474B43f855191e12e8A4Ec",
    "0x24Ee3Cfc053D13F1c2A395471Cc305b3Ba831d8C",
    "0x25320eD802583713613fb62ebAaf85CdBc47987a",
    "0x25d9d6f36Fb3773B98284624E2A58c0CB3C98Cd4",
    "0x25fbE873eafE8Af1C3341b98c5011331bb3A25D7",
    "0x263aB80489C5f2C1E777F0366B501F2675bd9526",
    "0x26b13e3924897C03715489361459b869Af949640",
    "0x271e2F118585f2B20efF198E09c0746378DC12ae",
    "0x27DE37D8aD67133ce0e25C1B082c53a2b0b08963",
    "0x27e88A965FD9365da85A02C8f8abd536776e6b5F",
    "0x286627B48141289bb3Ab56559C9e964d2D9cD07a",
    "0x2935C4D9CFE50413870A592D1EC368bB691De2D7",
    "0x29485ba80E4ddc26759b49983be81D04930B715E",
    "0x2978F0E4475C32996eeEBa4d0e69777f6c8E5AE0",
    "0x2B6607bF41d2295fe51df244B42e4D8db094edF3",
    "0x2b853ED06Dd2d60AF712b8Eb2d12d4eA4DA2F69A",
    "0x2C2FA8ad5924814a89D3d9E8D2A568977b5FBb61",
    "0x2C6597eca8F92273631bcc6226171B3589225D81",
    "0x2D1Bcd598D559e2ce85A34ff6369E93D616147c8",
    "0x2D1Cd37a2B652c6Df48D42301809631630560703",
    "0x2d20653c0c4e736f653643040312780EdBAd54f2",
    "0x2De025527Eb62a4730f02B3087b2A8d0dAeeDbC1",
    "0x2Debdf4427CcBcfDbC7f29D63964499a0ec184F6",
    "0x2e8F8C6c0FE663D37896f18cF7366e02d3490684",
    "0x2eB6A0a495e21139f3b831812028Dac03f9543E4",
    "0x2eD849173c7a54F45f849675A71B62c0c83246D9",
    "0x2F2D8d26A2Eb43b37000c3B0Dd565705d19B4833",
    "0x2f463642fa60CB1f1fd1c57af25B34b7a9A99586",
    "0x2f700dEeD41639E1ae24D193f7d67453c4002Ee3",
    "0x2FDcCA65899346aF3a93a8dAA6128BDBCB1CE3b3",
    "0x2fE3176ef0F614DcB273e9017cF57b8391337ADc",
    "0x2Ff398960c86099b07335a37b6FA7aA9DA03809e",
    "0x304b739eBf7ccd2beD1650cd495a91c3D4ef0286",
    "0x30904e1Ef9866EB32D5b440ed750E848D770B9dE",
    "0x310f07ab89d58Ba9E254fF4Adb5Cd7EDaeA3aF16",
    "0x318Aa48056577E213018c6552f954294b9158e54",
    "0x31Cd4492F926F3Ba9DF29d5fC5e2Cdc5870250C1",
    "0x32337DBf7b59d0fb8217786e1abf6e57E7383Cd8",
    "0x32379456F3146b3F780d7F6e73cF9E73633f03EF",
    "0x32644c4050D7a1bd7c2304DbB98204e229f9B7c4",
    "0x330BAb385492b88CE5BBa93b581ed808b00e6189",
    "0x331f3fBD0a83ed74480EC5262219F8b5aCbC3Dc2",
    "0x33632E2F9Dd846f5Cd6038e4415cb875ED19D87F",
    "0x33be6ff11f5FDcd851Cf3C47e8411B8fCD9fB93B",
    "0x343E85Ac3009AC01538d4251900ce1A2b7D7fFEc",
    "0x3446031D4F0c92F46302Bd5213051c0B95D18567",
    "0x3479e322663B501EcF1ba9444Fb20C7fD68331d6",
    "0x34C678197d155A06d1B1F213BCDe23aFb3b35E2B",
    "0x35080cDA95A7A6959EFfc293f4A4274110B77777",
    "0x35104Ccb65dacf838A9D9c4fbB3922B3e85aBD61",
    "0x3562c0bccE3A009bB9505B05E1eDB3Dd7C6DD418",
    "0x356c938a1d889D87999c75dC4e7aF1263b93e45D",
    "0x35AdAC3DAF410Ca4D4ef98fe19a06Af25FB05055",
    "0x363F85f9114D424712997Ce695A031DC224f47D8",
    "0x367c78D58C09c34968fffc397975a6d934dbFF86",
    "0x372b27bc13409F26d864b9d89ea958403EE003c5",
    "0x379E297ef2d0330f2F60A2290367c0d4DDfBa4d6",
    "0x37BA996DD7EB738aF38Af7839a17AD19cAd5f155",
    "0x38cD52a93Ec2b13280644e3bE18859Ea93288BdB",
    "0x38f9E9Fb4Aca338dDc016ae61e196b2D6301aE50",
    "0x38FBC35416344dAa9b9A9120dc9f1eD9010c0AdA",
    "0x397f9120c0Deb003e0e8735Ea3a39a258d9D02a7",
    "0x39974e437255C4A2f888CA4F18109ea5Fa8eA74E",
    "0x399f9eEf2582ca5e72eA6a5e8b0DA6b62B562704",
    "0x3A1a4e4028Af9b8f1279D453302e76ACFEFfbd96",
    "0x3A1eDE31a670413daad1006107aa591CBfCC093e",
    "0x3AED0eF9164CF90255B85D5c785A164446B17B66",
    "0x3bbF608c8FD9eFf3F310979FAb20D2ea58dEE0d1",
    "0x3bE6e1D171e36C0fa42B4954DFa86248555E7d3E",
    "0x3Cf44AF54009613A62a541124aD67876e9e69C61",
    "0x3d221fbB2f1C1aD37DF5F44261A3f1598802A04A",
    "0x3d280fDe2Ddb59323C891CF30995E1862510342f",
    "0x3D4714E10f17A17BC4d2dE4c5eE0cBDF07DE351d",
    "0x3E2dAba02b8b09879ed9b517bF4603a3DD9C410F",
    "0x3e6B98Ddf72bbF9d9E4a8e0C1fa0136fc24c6E0B",
    "0x3eC131d37456cB311e5B31CdFc148D50C00ff45B",
    "0x3eCBD327432a1418Eed49C7e281B45f4D31a047A",
    "0x3f2a90e0EBF817650F52119f1b1eBBd2C1867bed",
    "0x3f873E3d9849254d501BacC89a4804fbF1B24D6A",
    "0x405020c797A64f155c9966C88e5C677B2dbca5AB",
    "0x4178670A1426ffB13D2687CFEfA390080F7De909",
    "0x41b68202Dc64904E09D2E4F0A94879C741F27dB2",
    "0x425E0aF80A463B85470A96CD32039F97Ccfc34EB",
    "0x42C5aD864DCD9ABd9012D5B918D3d22842d180B1",
    "0x42D38ED60a64D0B8C36f190e185D17Db3617A091",
    "0x430467c860a94991160ae40Dbaa02C48b3499cfd",
    "0x430E11D5730115386b8606878BEF093601707B03",
    "0x43161126187De18EEDD97d7CF1d1048f2721C5b7",
    "0x43202CcD9E78434B13575c0B62AF5BE91e759641",
    "0x432Bbc3810692e6baab69CbEa162bed134dCb87c",
    "0x43d5DbdABeBEfC5eBC040D4328979d51338f5616",
    "0x43E4Ca0baa6b8169CE778a7a32e6D0dC12e3CB06",
    "0x442157fedD700E96a81eaB0f3c5B8ba7eeA008Ff",
    "0x44A8CE92754c2E180743b43A0926D7f22DD1b92E",
    "0x452F438aAD8B675232C1fD7Ff8E940D72d8A9F45",
    "0x453b2267024761f81a90a813d51e3C412189b833",
    "0x454908004F88436F46eFAC5578b4984fE1375206",
    "0x4568590d65b34EAcC6c8177Fc99431e0F60d9Cb9",
    "0x4621381eebe933557A9F7934361562c5253f4a65",
    "0x468BfdE05aae3C08Ad8D17080694EeA973dC15b9",
    "0x471B24a188053B4EFAF17f7526DCFa4771884888",
    "0x47e054a8FCf3e27a4beD979c33AB65A5883FE437",
    "0x485B8AC36535FAE56B2910780245DD69ddA270Bc",
    "0x48c0b0d8C6E24F08381fCF0454C3a7c55065a517",
    "0x492a99E65FA764a0Cd96F0983a987d2246503e3e",
    "0x49B75E4EE327476ceD61C36fd10E09668b20f260",
    "0x49c6fB6CBe27Ce0E773B85840Cb072791368e5Bb",
    "0x4a36d0CAFE9a052493725B99AeF80A70C25598cD",
    "0x4Abdee62acE445e9A1B95663C952e1B056b2efF0",
    "0x4aE50051b8dc10d8501041e2EEa93341DB29B52c",
    "0x4b15636f1416c0FD032BFabB8058C7B13FC8D110",
    "0x4b1859cD3a1f91dEc726f23491Da614a44eB83bD",
    "0x4b1E2626b042fc1AA9812f0AdaD7ddc03a311B32",
    "0x4b2df59Cf9B571E352503E7E1ecc862Edc1Ac3BE",
    "0x4b33887d2647dBE37D777934AcBD252550EAbE9a",
    "0x4B377F4C8a7b9A73037353B4DAd844831B8a5066",
    "0x4B725e4CA093156850fcd86eA11A516a8362F85A",
    "0x4B7701b2a97ba4569266A00809b653448A0007d1",
    "0x4ba910d9E85AebB052cfa0836C9Fcee543DDF125",
    "0x4c20988927A061Be1bF4F50F73ea55Ca5bb5c0A6",
    "0x4C2799939C883fD4042117E5585f030Bba8237a9",
    "0x4c893d72A9eA4FE047A488cFA5A7792B64bBCbE4",
    "0x4Cc1477210F2FA02c851165af7DF7b53f8e6eDfA",
    "0x4d984F7E5b8a9132289e7FB75633B198a9D860E8",
    "0x4DD43Dda4785c8bbF47fd3583d8B83f5e6A68962",
    "0x4Dd5A4D1fcb6F8938aa8AD070aEFE1B19e8F9c0C",
    "0x4dE89162f766eeb2B0ed7DEc561F91f87DD50dc9",
    "0x4e2e67836d10B02B1DCe78591af6DFd1e2d7BCBA",
    "0x4e8074647E774CAc41e62FD207D2dfdf918D8D73",
    "0x4EA2F491bCFf5aECaD85c280f8F2D03190709b05",
    "0x4Ea45f648ab590A6040EF487b56960880A88Fd0F",
    "0x4Eb2C56dC750B0eA0e3D7cA5F9B6230bf6dF2D10",
    "0x4f389f9208633cA0924D8A7bDe6F4A6fDBA1B537",
    "0x4f6505F78DbaC4A235f775e5a89EFc2cCb882A11",
    "0x4Fb1ee8c6182345D33bBEb1AC1618Da08DB3Be48",
    "0x4Fc557214aa25FEc149e2Bfab4E0180B81630A57",
    "0x506B19aA6d40Ea68a8B2aE27CaB1807E0e23bA1F",
    "0x5075641Af8c017C3f0F01581C76Af12f1Fdd4b72",
    "0x50A879029f433E7743eBEA8eCb47a29Ed458E083",
    "0x50d5599387c21a87d614db2717C744EB596A920b",
    "0x50deEFC1fd366D42846B1c0a23965Abc01261b38",
    "0x510d7D24aA11B47A1598826740978bF457C08e62",
    "0x51BdFa2Cbb25591AF58b202aCdcdB33325a325c2",
    "0x53562e8eCeE54356dc89Ad263A444528B34D6c80",
    "0x53EE32D0bD98F69826d2853C3c6aebC7c4c8eF14",
    "0x5455108fd39520DFb63BaB4040f4EE362e135392",
    "0x545Fe5914418fdFF836cA163241a9E141D84F5c3",
    "0x547112a0a5450Ea3E64a1D778AfCa2A18e0523a3",
    "0x54cE45e220b9F63F16c6B1DE7BfDC2e02427CCb9",
    "0x550cfB8Eb4d96D519DE53459C2B9Ed590560aa1f",
    "0x559235e6c3692698DF15D5Dd3503fBdBB472a43b",
    "0x55A8b4Ff72c6f5e2Dc384D2bC0F864149834b9B0",
    "0x55b9bFa9B40497b94b6D7430489f9B6cfA4B0A7b",
    "0x5690515f0B141AF2fE188b2CDf38C32F8071BE70",
    "0x56C72C1B10750D9Ebdf1C5074a1f7d99b1683Ed1",
    "0x56E094616618E5275E04CA9339E0Df1c2Aa77Cf4",
    "0x57E53A8C7833b7c13B22e2767648eF61db63076c",
    "0x58417F8418e1B3b9B7037071dBA6aB09Bb4Ef9ea",
    "0x58847353d941840F261366561daB73bcce277b6C",
    "0x58f7e5f42857fFBeE8f5C2Cd65f28Cc0bBD7B277",
    "0x58fE671eF819cC761D5C9124097C3EBFc6FE4b3b",
    "0x598fDd699C874440EbD31fdCF5cFfc1500735a9f",
    "0x59C76C664eA5e3703507a04a63f7655d8cbf84BE",
    "0x5A6fA88a66fdAFc7d313DD93bbA16F2683eEfA86",
    "0x5a7749f83b81B301cAb5f48EB8516B986DAef23D",
    "0x5AEEdbc6b655C13950F32E5E8a0760D15Bbe0Afb",
    "0x5B7513610B6AcA9426cEa94AF32112e2841241D5",
    "0x5C055c05126b8bd0A16596e79f76308098eF46f3",
    "0x5c353E2dfe83EAF24B34B106e586B16450c4EB21",
    "0x5c54672f46f05270C60f8dEcA6A01C2E2C2d746c",
    "0x5cd69D3E3B92c2cF99Fa2A89d4A8acEee29683AD",
    "0x5D30027eC28a859EA5F652745CEe2916Afc68312",
    "0x5D643470e14a0c09ff0d88AF6A5503dcbc3667D0",
    "0x5D999A7dCF597169a7F8Dfb03C7935da39C163a7",
    "0x5E54279aF83AD9F56bba947204D1CeF617c689Dc",
    "0x5e608aA19e83A66C13dCa124aFc4FD9482Ee0ec9",
    "0x5e6684c5E5A5b1ee161Dc2aB4F3bde5a8a7cB2bC",
    "0x5E803D4CA760d64aE504a689B6e73D6d61CF8103",
    "0x5ed86506FF1244bb3aC0C309D5Fc5AE6C0375464",
    "0x5F49841BC3e1AEDCE12A654a11029b6400b4b090",
    "0x5f578A06068F13Dd1a72917890D36B97988b03B4",
    "0x5f64c699eE899604936fC17972DD8B4669bC0eAC",
    "0x6004df4a6440d89643cc8C37871D5c79745Ab711",
    "0x6018C495Ae3776081ce130dd0a49C3020bC6336C",
    "0x60393EC8de5064056270FC45Bae418dE8694338C",
    "0x605Fb0A088f192427BE62D59F374915b7d7E1579",
    "0x60c65813f73Cb306690f610B65394D40608F36e7",
    "0x6196EbbF13bb7c3a175f6c440caCF9002b5d2B87",
    "0x6221d0cf95Db2141621D21D0c1F55a24DAc80b39",
    "0x6266dB517a8D1E2b4c61eCb48Cde4d05A5e44990",
    "0x631fDCe8937aCDd22a97097558Cf0EE9a70c33f7",
    "0x6356624291C2Cb4915062965159cD562BfF17569",
    "0x63b0edf2705a94E990f1678647e98f41e99b1883",
    "0x63F4c36bD548C3Ad3DD18364C987E9a062a330cE",
    "0x6479f7157f06e6610174b1029388B8D4193c00A0",
    "0x659dbD5089A5b6E3747b8C33D24385E8663181e0",
    "0x65A11Af94476D245dfc7E2C5c91cd0e40CdC1f3b",
    "0x65D66B6FAf411Ce9eB24f78375715AD5f0133e62",
    "0x65fDaa0Eb1D6753305e5812FdaBF157069e2668D",
    "0x669D54E068c50567F9D234076086cC8FdFb8B072",
    "0x66A11631e8fd3f3DD0a1209CA2D1e238640Ed916",
    "0x66a26Df5C37aBC383E59522Ab21f9E794Ec37aF6",
    "0x66Db2F6fDEb4d597B63f52dA5Be9D645906f13f3",
    "0x67122b59157ef6EEc12b318A57CB4ffC063D2d4B",
    "0x672B251834E1616ab8269096bD06840875DEB4CF",
    "0x6749edD685F68135Ed629FA5CDE1269BA18d6ae9",
    "0x6767a8152D0564b679c87Aee2d76f86a437c7781",
    "0x6785b789E45aA121AaB8154D4C4398CCc54d2B29",
    "0x6792ED1f7e5A22B9403bB389156c742d5F2d9D6f",
    "0x67E1e0cA2fB369f26889E56C38d490b63d75656e",
    "0x689b395222A5E3EEf17f2D1BE82a7472b9BFde9E",
    "0x689DaBE061AFfc7a9E09D97B7AeCAfa1054A916f",
    "0x69dBC4DbA165eb1cf834088851f2641C787a8706",
    "0x6a29F68C29f84905748c366375e1E3c1C6e9b893",
    "0x6a8b990801daDe9077acB0eA8948D023C72D7060",
    "0x6aE1aE70a74d6fAFeaC2A766E52215d83eBf30F2",
    "0x6B6aE848F555f70944Bc99D736fe29fcAeCF8b23",
    "0x6BFa79714544F2FCe72a5CaAD853C45aF6c352F8",
    "0x6Cf3F3e7d31B992ECaC93496F23BF66884E4d9D8",
    "0x6d5aE7aC4AcC121D53D68e9287bEC272f9221b0d",
    "0x6dd9EDb70ED2684D9fd6E5fE492B0143a18aC71A",
    "0x6EE02A67CB171A9a3a53FDFC4953a3B5f8ca8553",
    "0x6F53F4Ed7f907bc51a3900332C5D594FF962D331",
    "0x7006DAc31BE7459e3a17e183D8a1c71668cD99cB",
    "0x704E885deB583eF6fC9Dc7d25266699fba759c44",
    "0x70a7bf5CA6829c31A7dD8131fB5aB4c54be82569",
    "0x70b30BE4e3E0406E016dA4b2ed8BE62cbc43bee0",
    "0x71083D0293735398436f3E0FC59fC385c1564AAe",
    "0x71A5c15A7DCd86b3f314284D1D1e956d10903999",
    "0x71eC1F58656B583F14aA2D7c628Aea8f4e1C1CD4",
    "0x72622E7f25c687758d577061B2a5f93609927efB",
    "0x72703B554A7089F93Ff1fC6CC6c0e623900a7b80",
    "0x729330EF0fE13e294e268a030F934819e95520dc",
    "0x72971F6F324a4F3160076218339b9038D2cCc5af",
    "0x72fF7BF2E3c7A2ae3686BF9AEa9F965E0e9281b4",
    "0x7303A2cB9a811db09b3CAE30f38E292e9C084fAE",
    "0x7512C6A03b4c29E95b4786a5C2045ACA94eaf05E",
    "0x75ab8B00dE5cDeF5D57189827070CC150F16d6A1",
    "0x75b41D90281F8Dcc624067763D7281E3086ACAe9",
    "0x76f344B38Ad727E237c0D53758Cb5214EBc570C3",
    "0x77039399801F462B4ed13444A266b16355C471bF",
    "0x774a34DA2eE2e2D242180819F1Ee88783215f7B9",
    "0x7779bdf791d8961DBCd7aac5A0Af7798D88e8fCE",
    "0x782a7c10E7918A366757d0B7b036BA3E6e841f39",
    "0x7990eB65E43F9648B37c15d544862a5964DA91e3",
    "0x79B5259dc0Fcb44f9751Bf9f78f5ef46A7958460",
    "0x79f246f3482B618EFd6e07C5F98dDC652633C2Fd",
    "0x7a31E727F32AAAfCfDA4BbE29dD385E04ee48ad3",
    "0x7A44D904E5372F64db51436fcDf4024A8144c383",
    "0x7A5C8077D9a37f3667547a19E645255eC2E0A3d7",
    "0x7a7ACaae660eFABA1DE68Fd18e06De39447AF4bD",
    "0x7aF061A6Ec9616135231Cb8DE2eD2a0a4140E90b",
    "0x7B97a02a3A2922742590Eda6E8e927ce71a677fa",
    "0x7bb055240B4cF366c42d2D5bDd3E731F6132dF44",
    "0x7C00c9F0E7AeD440c0C730a9bD9Ee4F49de20D5C",
    "0x7C1d519987443ee89c986AC0EAc3688218f1573E",
    "0x7C3652fD197e2e9806CcEf8b48C0502DAA9c28D8",
    "0x7CbD34f7F522962c20564792F81DDff0aBE393D4",
    "0x7eaaFd601977D0F1Aae82E05461d23c0701BB6a5",
    "0x7eDb57005f037FA5Dc16f5F530b9cB09d35ca1C9",
    "0x7F31A366CD7B23a0ee01c2FC2b1C9F8bb56FD4Cb",
    "0x7f31C8bDf50f0374D01Cdc47492fCDe998bB3204",
    "0x7F692a71fC0dAF40c1EF1FA4d42a1b8ED59e06bD",
    "0x7F7c864dac139B5a36550481180b834Ef283E056",
    "0x7FEA276B23dAcf027691B51Bc341173Cc41Dc918",
    "0x7fF8EB786B62d9B1754cc5d9e8817486953da2e1",
    "0x800De00a07bd6E7fc9E9528F0EdF6d6540986297",
    "0x80473FCAb05239759CD2706E990dab1ED7129D74",
    "0x80c9AF2Db8b6870e0FFABe70e1bD79D3b546fE6c",
    "0x81FfF106dc34fD3cF6f7Eb0Cf3D2310dFD5417De",
    "0x824395E6fe025E99858f7ECA95ca3dAe2803B802",
    "0x8307B66BDb6dC19Ae6B185249D601A09488f130F",
    "0x83134d7b230Dc6065e54766DC3D1b7DC8e4C5AFA",
    "0x8316941e4B91D3e0763355a6804Ed0C0aC844F37",
    "0x837fb22e3A68900D8d11d69255131cb8aF03DC5F",
    "0x839869f27DDf564995726a32c15a56aae85a354A",
    "0x83E91b0c2B308b43BD1419afdf831134f0617a46",
    "0x84De2998C88e0A181B7dCC38178de456d3b77090",
    "0x84E6855f450F00bB1F3704671F0861867D469acB",
    "0x852f5Dbc286991bEF45c0F5a9bfa2efB48F8aE47",
    "0x8611bF824EfDf0e0F675D7Fc26a8745342a77Ee5",
    "0x870455aD6a2C8e05C13Ca2964163358aF58faaD5",
    "0x870A88cf81C39c8e0a6582402355Cd3fa2fC27eD",
    "0x87a802755Bb26E8c744D6EaB46c80310f68bB8eA",
    "0x87b873C131b60153811654a827F29Dd70BC1e9d3",
    "0x87DA297a832706B5115ee1FEb47B7FdB7c476261",
    "0x883FEc6eEeF9b0746cfd69f2b5c8b772E40F25DF",
    "0x8862B669FA74d3E9c36C18228eB94B2F06891420",
    "0x8958c4BEb8BA062e96B1a230903b4dee53347202",
    "0x895d49ea015B1e9da4af776239d0f8b029d660B2",
    "0x89AD55797CC8e511e569E8719e53012F341bAf15",
    "0x8A033Cd82f4855084d670477FEaD695F7E2A4A44",
    "0x8B1397d956750f7dD6A04E06B9d001f9a58dd7b6",
    "0x8B5B9A7a17BC143913f29Dd40A07F0B2962653f7",
    "0x8c00dD32B3f6E0D6d8C2c22D2aecad0b55743e1D",
    "0x8C316E56BCb940bA4C2Def05e02943789858F60B",
    "0x8CAd83Ca37D004c7F29433fc49D3aCAA6659EB9b",
    "0x8d8e56510b047fD9E8ea25cEfA54e512C2E39732",
    "0x8D8eCD8A7111abbB32222139cCf89544bc3196C2",
    "0x8Dbbca57Ea56290Efa14D835bBfd34fAF1d89753",
    "0x8defa10ca93db441393D24E23D714258D6829140",
    "0x8E611b4f46A353aAe8Fa55AF10B5CEC24F5f1Db8",
    "0x8E8cC5ec972Ad428274b2B2b26D6a72d7BE3D27f",
    "0x8eb2A1EFe86309c89d831Bdd33B4E19FFE903aD3",
    "0x8F48bAd5B155EC7d7Ee617cA78627c0b622F7836",
    "0x8fA0c118eB7c46dFf73178A2A17a4B20A6f7a340",
    "0x8Fa153E2d93713e4Ce2633bdf8B4286F1d880E9F",
    "0x8FcdfF1c8A5f19D56e9959ED72419aED8f7E2E44",
    "0x901648073264dB52846Bfdedb4E98B96b48Ae3E9",
    "0x90288121Aeb294eD88bd709BF6De58a476ad7808",
    "0x9043B01797042c79Db0eCfc51EAC2981005ae130",
    "0x90F16133331e4e0b25db21051Ff29408242C0173",
    "0x91064050a8ea8cecF3405CF7Cb0BCe0e2eE2fe1f",
    "0x91F790057a6960fdd54Ae0a274Ebff1384d168Af",
    "0x92090b4db1038a3DC45091Dc2Cbd71d3ddE39A34",
    "0x921a091A0F2D3a0450a30997061Aba598D86be25",
    "0x926832c306D1d31F09C9518Fd663657a202683C4",
    "0x92c095a206e0E5bef4831b3f36b5f51cfb3A90a0",
    "0x92d9fC25373900A25723e86D270F5A269769B2F4",
    "0x92E9Ca19FD44eD10d8183090b04eB72453EA22AC",
    "0x92Ea9EfCa8251Ad18A565f5a0fBE365e34a2817e",
    "0x93044f2eE1a0c6fB0263802D59380AeA61d5ce72",
    "0x93EB95Dad68De034fef03dA64FFb3a70DF563A29",
    "0x93F5242003420373844339653687c1A6AEf501D2",
    "0x944A5f150826EC055e75277aF9912F5f5C11a49A",
    "0x94B8A2337cf511Fd75145D971ed4EAA1c01a4B19",
    "0x94E66b3b35B499F4CEdA19bC9627bD63c68daE72",
    "0x950Cab0bf5B6ae2fC1224d13FE3d7De40b113634",
    "0x951328F40a549Bc6fD9B3f3adf5d4B6E6720f981",
    "0x952A3641a890232309CA5aCACcA03D8a7fA7ecfd",
    "0x95724798d703E87196375Be5f8FBf136D862f033",
    "0x95aFF87EF60d5166858dF825eAD163A6626E03AB",
    "0x963256b76D87959f57763d1Ca4022e406b8d9f46",
    "0x968693ae34C0cF0f24dFc5eA4d8c32F1C5E530D7",
    "0x96cEEd8be02C2f346c8fef7d830A24b5ee2A435a",
    "0x974Ac03905f7c923C4435372E55F2FB1eA9D4a39",
    "0x97dBAF149B476050bA4c9ae7894303aEC503D11f",
    "0x97dC59dbA243322A488B718F8e08DFc8F898ffeE",
    "0x97E7124bBCe0baF75A7c4688b98a0C1DDFAfB3F5",
    "0x98E2Ab7934A8039978559Ad901539a200E11BE2f",
    "0x98F1e320dC68915C8d5552549079183e589Db8E9",
    "0x999339Fc1dD71475Db6965eaf09d0FffDe8F7840",
    "0x99a5762b15920c9c6382bB1d1db71ea28a250A63",
    "0x99Cb75aa08F6F94e4209A5C7a87B85cFC0B7d857",
    "0x99cD7edf3a6C90A0168C213f22935358bbEa8c38",
    "0x9A34C5D07f258323F2184C6599E6bD0325E9BE41",
    "0x9A564EeD8fACbaE1440321BBff1E87259EDF483D",
    "0x9a6c353abD6236CeeC791092035b36E5fe6EaD63",
    "0x9AaFBD399B42c5cE73B30B840CE5F5c66aFd00e5",
    "0x9b3c1aB774B82B6E9caf39a1D29Dc8A4615Dc609",
    "0x9B416427514F489A4997e31Ad8c20d466E9b4292",
    "0x9B9487CD74B8f9211AD50850d5DC8976CF9Bf9a1",
    "0x9B9513c6a4226F209433638De4b7B1060eDEDa08",
    "0x9Ba48f6604f4855F0070c8B6eBdd9B81752c81AA",
    "0x9c19503C62b533B690aA4928c0dD75D4C0B02590",
    "0x9c4eD8e840b010aE430B513c119b3ff054801461",
    "0x9cCf3055EB4D238A8c7B879cf94Ef57bF6796110",
    "0x9D61110D0d0E456581f7ed06d5E48d9B3F0f153C",
    "0x9D7Fa65552609eDF74417485D80613da5eC09Fe5",
    "0x9Dd631574502AD9409B3Acd167Af3125b1D98874",
    "0x9df947CD8a9810964473339c38a95201ECbE112d",
    "0x9ec60b1557f9B66fC23f6e6A76988c866A812c39",
    "0x9Ee2d7418001953AB72cCac136D80D38a1b3b6c7",
    "0x9eEdfCecb0aCB757C0E7547a4C38cfbFD0f743e8",
    "0x9eF3Aefd10616EB92eCDf5547825275929BdFa98",
    "0xA0326754b524b980cC5cc48b6F18f494D95270f8",
    "0xA076101336d7241b5C74131C3633158B67583Dca",
    "0xa07834f67A3633d94eD5e937868AEf5AE4997090",
    "0xa0C1BCA2DA31d84180114965d2f80E37B63030Ec",
    "0xA0cfECE7CB870c0964fd881EB8ee024321A89Bd5",
    "0xA0f2d7dB52E36C2401e23c12f7D967C94Be412a1",
    "0xa0f936A1ed2C3D90C0dACFA9730eB81F65B61708",
    "0xA19c1f5225687FE3F85d0BE4a8Dd1797aC3E99db",
    "0xa1A18c3558365C098ad1306075d8AC9b9aB78219",
    "0xA2576208b8d1de9654c67E9c74d0Dc9D3fE340d6",
    "0xA2ad6fa0eba0DD5011755bcB64F90690F4d30839",
    "0xA2b6296ed37F702437d2d571EaD7E25ae8CbCDfB",
    "0xa2d917811698d92D7FF80ed988775F274a51b435",
    "0xA2Eae178F372220FF6C6D8CACD63EfE4e4b44525",
    "0xa2fA9b652C26316f2b10C450a6021C33C947af5C",
    "0xA32fCC1B3d4E2b597CF626f98228e68b63ef46F0",
    "0xa36686c1DC37d7A4191bFB36e4c7fD40a00dcA89",
    "0xa36F3c6219485d4C779e58f32E4f6f6Ac8DB33e8",
    "0xA38e82f9b1A078fD964e206431aC8b0E722B4F81",
    "0xa444ff839Da8d60550e45DBE954ce34B83917619",
    "0xA46425571F389Ce2aE50e24CC7efAA074adb972f",
    "0xa46cF2db18Eaa7F3eBEc2fC08798494CCB82Bda0",
    "0xa4Af2E445F46dc9c88d9d76C580917163a896034",
    "0xA4cb937Bc5eC481fc2674794d4146206ecC71b15",
    "0xa56819Ce56d6d5B19712CF8178b3877fBa4Ae807",
    "0xa77F774378c93d83604E6e35893A52A66247a01e",
    "0xa824A96e9A39b1DBB897E8e7133011ed29DcbD33",
    "0xA85E32a8583a30c62b4F7cD909229Fe205119d40",
    "0xA8C5115c8e44351B2bc2d401A1f033BB45129dC5",
    "0xA90183d333442D93E601B2efced493C9aD2b0a63",
    "0xA95aea385130718be87B380B419eEac8Da40de55",
    "0xa9e4A56A252359D0aA166c2955463d437eF692b0",
    "0xAaB889e0184A5354e48a4E6A9BA05766240a7575",
    "0xaaf3c82bbD30D08D06fC8d16c4186E8692784DA1",
    "0xAB0e2f3C3C29DeAa7C3ca0DaceC97a33d5C26708",
    "0xab2056903a7b62BAc46F45A3D7a70AC799CA88CB",
    "0xAB5c03Be3F4b1E2D972489617D022382C710d480",
    "0xaBD866B6f116eDb5188f5a651A273ad8403DF0be",
    "0xAc2Bf8f8f6Cd71385943Cdb691D89c694fC7D7F1",
    "0xaC721445ACcd6b4502bf0205A06d1e1DeF2AD394",
    "0xaceA8fD5D58e1124D367F314ce49A298bD17f353",
    "0xad2620C60885f00afb64B961c9f9E8590612812F",
    "0xAd2D6387a191586ae552756ba3506747eE877fBB",
    "0xad387592c2De9645c3F42B5732B93833e312bD0C",
    "0xAd797AcF61b9b6051f030e919c53892B8d85b04d",
    "0xaDb70cc8A8f1A7A68Db90372308184C501B575e1",
    "0xAf751f153503D726FdAce94558FF4974CC688bDc",
    "0xAF9c2BF928cC4B0ea734D44B380d22269168e668",
    "0xaFf42573Bc515b878513e945E246d0F1B8Ff01Cc",
    "0xAff5f08202b6D3EFA87257e22577beCE2e96fC11",
    "0xB01C6885f178708f4BC9DDb9B9BaD92CC3992A7a",
    "0xb073565F2aF3C7B6525e30B0b563D6638B11Aa62",
    "0xB087e31fbF617B25035Ddc77186a365b6385b746",
    "0xB0FB74061D3030A5A7e6a761911fAdE6cbA9B513",
    "0xB1c6FD6297d0605553eD12206dC8C0fD58D9446C",
    "0xb28cc91dcB8cCa69c59333C44A53F5B8f8Da852c",
    "0xb2c22C50a4e0e80549946908597A9407d1732Cf1",
    "0xB378f046E34544e9C524d8EF5A6619d02D93D3B6",
    "0xb3af57ac61FC0e66839C8bC951a7a6Bf24b8b082",
    "0xb3b9E54Ca93195bfD7cF8945Db13709D9E64516e",
    "0xb3F0771103120F80eE3F2FDeDF9c856a3Af683b1",
    "0xB3F3582D16079d8916B580A398b03624c98f6004",
    "0xB4079f1e529309Eff78F634CB1A82397547E9D30",
    "0xB4374bd294601a2b69dc6C0de1243F047eBE6E29",
    "0xb44d3dF4fa349906188a49aAF324491B3B808B8C",
    "0xb4A6794CED2aEb7491b3E4cF8565559b2171d316",
    "0xb5425EbeD48D8C859a19A34463B6df9437974D1B",
    "0xb54760A5400d190cbB84045E6731E031070Ba892",
    "0xB700D4B34D5C501f732C4411a7b2969d1F0fA6d7",
    "0xb75ECd59A2251C738D90E2410cC755cDA4A69312",
    "0xB80eEc99D467cA6F1b8B982c76D0651e1a971370",
    "0xB9B1d4251416066afF6c06E4ab7A8eE4D2312E29",
    "0xBa305585E47fC8778592e12bcC5dEC8ab0E1673D",
    "0xbA69b2b19A251B59D13F4752924fad1426D648Bf",
    "0xba77A777F2b9B7926909E431188bFCFBBA10C957",
    "0xBA8DB35DaE41465a45Ab494a5A841c73Ed1C047E",
    "0xbAA3a18b8E45F9C37b70E4c5c0ecCD905875c30E",
    "0xbaC42c9b32e574f41B86e20FBA0cf479A5a1cA58",
    "0xBaD3bf0E52B5d3F91BdCACc5Cfa94a97cb9aAad3",
    "0xBaE1B94df2349058D793E6C16e3C97d06Bca75Eb",
    "0xBb1B620196f8431da5D34F1773127A523359F307",
    "0xbb1eC73938b9Df4baaB4F5c43AF96385A862811E",
    "0xBb5BF95a3aB59277FC8de4C8a90273BFfe542019",
    "0xbb771C5A3DcB9633A3bbfb850A66c51a7aD88442",
    "0xbC1Fe69De2aa26E2daE7Edb1799AefB239De0d3b",
    "0xBC637C16aAc0e4E8074C393601d3Aef6810B4Ee2",
    "0xbC8159917e892E0911E9F167c9e3AF221fEcfFAE",
    "0xbCef0C37b295526B666c8303e10D8AcA8Cf17890",
    "0xbE2e8f09729cfe365B19CBBac2bdC6E3B4d74a96",
    "0xBe56976463a12c783B1C18a9d75eB75d8cE62D8f",
    "0xBE7D2b4D72E60533cd75Cf30F7cD04528e744775",
    "0xBEa81280e41D70A5DDfd6E2df54A57bC08a2aEb9",
    "0xBf5d7EBDFB9e79A42F40252B103DD88AFBbBFd98",
    "0xbFADFF92855cBb45495Df33E45D91170E478B2B5",
    "0xBfEDf1E4956d8c81CE29244F70947D1Ea9284b83",
    "0xC26B78d31403261Fb563298492047FC4a8210656",
    "0xC2b100553BB8eC0Dc981413b86464621692c8050",
    "0xC2f43F2EDcdf95b0f3eC0EDFa25669b377A509b5",
    "0xC30559a69C2654cdB7F1e04200037F026D941313",
    "0xc316d8946BD7b66335921a7e4C676B99861273f4",
    "0xC32Ba9452cb2bCFa2462686F7a2b62811E3a4058",
    "0xc33D1C3b30e09E62fcBB9da9eE886c8BD3b4879c",
    "0xc3C0465798ce9071513E21Ef244df6AD5f1B2eAB",
    "0xc44AcB0fd43D6e74733e105C3890C41A55F8Bb27",
    "0xC474E843be98b9950602b49AeB556713d8Ac7837",
    "0xc475c0Af0B199239f8162bB5EA71B80d0687ecc1",
    "0xc48919DB16aD29af3Ce5DCeAe83BE3CF1836e52E",
    "0xc4E1597AdbdC7fD9473E33FdBAC6DE14118d0234",
    "0xc509f0Fea445Ca77534BBc3fA459D20F0F68A1b2",
    "0xc5EB2e0556F9C3adFE2B9Eb784E7F5f3930A8F9c",
    "0xc65E089505dceb59Fe3b88D305068D8107554c3c",
    "0xC66A710430D4720A869372AdBEdd4c6283008949",
    "0xc6769b74A68c1A6bC7E6e7BC561Ab92B39877311",
    "0xC67edd8A075A2A96682Be1A9F3f5865c24F8a70A",
    "0xC683915268E712F9960Ce59736a32119165Cc962",
    "0xc6c278C433719d28D8Fc25D6BBF315E206B1A84D",
    "0xc744f2FB363078f23e128a494A68720eC8a4fE79",
    "0xC74BD5BcC436BE6EaAFF11B49009836842EAbc1c",
    "0xC7574113B04a7D44872831205020739680FA1A6f",
    "0xc7D2a419f8f2eAa06B3811cF7faAa7440DCf96b7",
    "0xc8374AD9481E8158A250FF79E3859dbCFF14B018",
    "0xC8942C4Ba83067c08f133AD41867A13bf23425c6",
    "0xC92d265C63F12a35d77eabF8935b261e5CaB4Ba1",
    "0xC97958ff5370c56B7E0e6fB58437F00702714D49",
    "0xC999Ac531D77cb6dC1F88D1a1e2EF76B2310121A",
    "0xcA360BC5A9140E0a7c575B7B0Aa3d074894F4EaE",
    "0xCaa6D5AAb7a180A30ceb146D7F7b399547a163e6",
    "0xcb23668D97B5C771d78cC505Fcd4C0dBD8343065",
    "0xCB4de7DB08B4dD0A9954fcFA0A09762F58436df0",
    "0xcB5D52Ca0f8AC885B826145CE1bF8EdD87B8aC89",
    "0xCbbE8eEF60Ac140B4C4144C49DE984bf97b0FC8e",
    "0xcC0788dD749183B6E67B14D1084C8209c02D2EF4",
    "0xcc43176a30234F7419D451Fa2906381e9f6aEb9B",
    "0xcD1D61e5ca822aE47Dabca328DA705E2Ef940F83",
    "0xcda24CD9D4f65Cf639550046Aec450f2c2c63128",
    "0xCdb21dF1551d3fa3c8119eDde8A09F0A234Fa81D",
    "0xCddE08B6b248832984Cd8ABc87689b2245E911f9",
    "0xCDE6a9aAF0303917c802A1208E104599Af7CCD13",
    "0xCe4D4bF74cf639d99C26803F6Dbc0A8054329C16",
    "0xcFA1a6945A89f7ccF5B672ef7BA539111DE5e8e3",
    "0xCFe1Cb9655942a9beAf3d13Dce1294f6A772D0e3",
    "0xd0635fD27CaA1B15EF52D75c9Fd70eC099398536",
    "0xd1Afbe4dA2A5aDC6fAf30fCBeA9E4EEa0Ba8C70a",
    "0xd1EDeCf17bcA98D7EE615eEb36A4d8e6fc2DD06C",
    "0xd2248a036B3960Ee6FD61c149203B1805216D0d1",
    "0xd27C42e99ebA4215f43386DB13334105328f0716",
    "0xD2ea8c9440b63fA16e0E82AE96b80ceD580Bd8ab",
    "0xD3C3E751429efDCca23aCe6bBB3d50cF16579023",
    "0xd407ad6b7879E0357C502aA5064914dF76aA0D26",
    "0xD480E91db69F946B5EE5788a52181F3cf0De1B79",
    "0xD48340d5400EcC1Fb5363D13E515973a4a4632a6",
    "0xD51599F1f089dD5Db5ACCF17E869Ef34e961C92a",
    "0xd5485A2EB45951B668dEA5d50708bBe823570E31",
    "0xd6CD5611E6B841419072eD1b8a8d7Ab1161a26Af",
    "0xd70Bc4C03154A1BABfCC55D792f4C6dDE4272063",
    "0xd760E86F67966e34D3d6061D2d26c9C7720Cf705",
    "0xD76F585b6B94202430875aE748fF8C038Dc64111",
    "0xd7B07560999fD2E6D8308fff786bc7F1B916D5AA",
    "0xD7C256E6c3dE3B68443eff4858465B9988d2c0ed",
    "0xD89D73DFfABB2d574c1854D3f836857Fb043Bfa3",
    "0xd8FDd6031fa27194f93E1A877f8BF5bFC9b47E1E",
    "0xdaC499E8cf1EaA43B52D32e38AF9E3720957CaB1",
    "0xdb0BE8e442Fe527E909238fB902D20F68D9C2B2C",
    "0xDB12cB7627906f36C70Bc03C9588DB68A47a5bA4",
    "0xdC6babb7e90B27e3F6BE77D35Eb03AA612B92EFD",
    "0xdCF52aBCe10a42eD7A03415198d7bd1C3f22f24f",
    "0xDcf752b5B1dc8F78E12a0cD27f4ca46D27044420",
    "0xdD213f6932a986D30a5d8e063C35796BeF697434",
    "0xDDeBBB91A845d7252789A704646f242d9159cd4a",
    "0xDdf4Db435c6918a8389deEBeD67Ae973E04cD408",
    "0xde056F5C771bfbcC28bA370A689a936e2B695158",
    "0xdE27E6262646cd2937fF9A57A527b7b405cEA174",
    "0xde31B36631c7Bd5883722CC8B7F11DC8Fb061DC3",
    "0xdE83129646CD841970FF44c922Bf9b5A50980c6b",
    "0xDeDC5bE40bbf1898785cc09737F86A356325aA95",
    "0xDEE6D0d142bFF87CCf218C35c039a25D0c9bbA00",
    "0xDEF3d987131791b2712297F17654dA42FD63f6B0",
    "0xDf1535673cB68BC7a579DA0AD491e21625899F30",
    "0xDf69fd28e519Bdb1783E5D731ae6f144751f9942",
    "0xdf9c897C9bd83eD49C162aD32C10336901eb1AA3",
    "0xe042FF17D4c3924aB6d53993699dBAc1DD2f80eA",
    "0xe0CdBfDd695EEFf1850cE5d3ec5a9527De93497E",
    "0xe14D6A8BCD8f2f452699fD4c3B88C368b2BC2582",
    "0xE2091e56274f7822819619E2dE8Ef5Bd8B4DaCf9",
    "0xe230828c87A6EB5c12af99222B94dCBF26058553",
    "0xE2f11BBC2c12Ad18a01A61a7805671c369DF7F34",
    "0xe2f9753b3f52cE09FEC12577c92C78573E113F2B",
    "0xe328Bac3266Da6Be02f73A173bDbC4211AD61d09",
    "0xE35cD816A3052507a366D2f576A5d9341879522e",
    "0xE373a16A02e920839196942D422E6A1C223adCcC",
    "0xE3916f1DD2B564F1fCbD0d28b86992120a896A58",
    "0xe44358E670e5084Ca16a5eA41e24d81e66a1F14a",
    "0xE4dd0e60184bBf595Ce1B55D9f3E308dDd8f2884",
    "0xE50074856d95f6011Ac34D7088273a2A02E2FfE7",
    "0xe55492BbA4b0CF759971d952c34f5b9FFE7e57F9",
    "0xE5881d7339e2885203E1D061d740f268737A4bF8",
    "0xe5CC37B25e4A223797D9Bf07884B858b5dBe5152",
    "0xE61ACB8Df38ADfA69207E258998fB9749346e00F",
    "0xE6E8302cf22D0Aa1C6D68d5B36C575e1396e3eEF",
    "0xe77A08d1513974F9cC89fd2Eb043eb68355EEd20",
    "0xe79EB6cE66353cd38E5a9dC67C97c836c86C6912",
    "0xe7E0810f5A0252a916ae91AC4F48F65B178cEcf4",
    "0xe82bAB520bc6624b06aD0Ba914D3A2e1CE14bF1f",
    "0xe88fa1221378D988B39F54288f4149FD2E7CEa79",
    "0xE8A3518817702630dFcC32728253497fCf4233B6",
    "0xe99C33Ad90cbCE0b858e652Bd3F41d26e3afA302",
    "0xE9A1A7e90A740B8a5f8Bd305F9FE682764664626",
    "0xEA40582889366eC85A2A49eEcF4FaE066a2D1C1C",
    "0xea5ABc1a1689984EbFDC41130886BdAEB5c24078",
    "0xeA7d3818a3b736fBa40852CD90471dF33c6D6821",
    "0xeb2Eb5C68156250C368914761bB8F1208d56AcD0",
    "0xeb5806FFcF9A1E9b24876b68dAB80c4dD7ef42EC",
    "0xEB7aDe9b31f67690F168B4C4228f84645a82Ee30",
    "0xEb8414bd5F2EE602775b6AAc2C7E5605Bd599A2E",
    "0xeBAA7E59C05F2f02d93b6D203E51a8c32088d832",
    "0xeBAEdb897FC974f35Bf36f075D60cD75E46d2D4c",
    "0xebb1441fea64C6e3986fE22f3Cea378a6384de2c",
    "0xeC798Ddd48B0961d17ABc3f8879b355D46317F48",
    "0xeCD22c00E94B2eCC32Cae03007711b4233c22e95",
    "0xECD32dF43Fa755168E22cbb1f7200D79c890E4E5",
    "0xecD65A351ef0F78E4145B7C406936abD248691F9",
    "0xED038B63D6DDdF6fd38c15f3AEF5eB022c318DD6",
    "0xEd13CF939dB2f112a5D9a18E57d07c5404b14765",
    "0xeD54AA06eCf1DD2439De259c07510938809730bE",
    "0xed6b5eD47163c7eF807E09C9dA9b50a1783BC59C",
    "0xEDcF12b46f57207Ec537Eb73C4E2C103A32B233A",
    "0xeE1A4667C02CF143F79e8F3F4a62645BCFb1ADa0",
    "0xeE8f9bA6e5fB8C45c52bE07b0536F46aC4Fc7907",
    "0xEf019334Fb1712a89352C36367275c9Cc0E2cd64",
    "0xEf57d6a9893467e570276332462fC747416ED303",
    "0xef86EC9b9c6304EFde21b3224f651aA726d1F793",
    "0xEfb447B074EFbafe2A15315E40663020287Ff02b",
    "0xf069f94448510d575ba31A29C25379A2E58238a8",
    "0xf08755720FFeE568D320c7DAA9f5822B82c4f7a8",
    "0xf0F8Dd3109Ad1Eb20700496928cCe88aA2d7733D",
    "0xF142D7bAFF0986B50ae24e694419C65e7091f52c",
    "0xF16323dB45ffDA53ADC9EEB30632009041069699",
    "0xf23F750A9Ed3C83844faC52cE3E1A2e2a064B2C0",
    "0xF25041497082F71223e89D40EFB75c66aF87e408",
    "0xf28CA190F941eE9F38F34Bda4eE236cB6977b539",
    "0xf29BA6E59378bfCD1Ff433cE2389eCCe8D167d87",
    "0xF2c5F1FD977dbD6de9D04BC4e62dff722d4bB1a1",
    "0xF2ca6b7dd925834C87B7030620BE2637dFEe15a4",
    "0xf33ae083Ad3ca993E5ca6aC8ce8e2c399dE7a7B8",
    "0xF3A687742e2fdBcf4bBEF81254F4a764ce2011C3",
    "0xF3A6ed6466D1Dc8cFe414C1A0AF314C7C3332Fe6",
    "0xf3EDda205799DeCB1651B22610350fb0c747f457",
    "0xF452a861dd80e19cAB35e1252946D1b7C22F99bB",
    "0xf4698eE4f8969EA513C3d15AB3b7E4814767c9ed",
    "0xF4F9F066a79D38fc25c845f2Fa042f61E04d5CEE",
    "0xF5929E2B57d1a13F7EAB1169e979829f9E084299",
    "0xf60cBa21973AE333410138A7AfC37f099831035C",
    "0xf61e452c5F25259dEeb3a3D31C4A0695188F8653",
    "0xf696Fa8493c95E04f9423AC6Bd7e17Be529f1e25",
    "0xf6E965B7234de3FC00e309597D42203dd5b5e13b",
    "0xF788f330684a90Ef8c74aFC165A996d378b6d045",
    "0xf7E9929560FEd850C9c8b28d7c528196009ebc7f",
    "0xF851b5B8C342d8d270a6f51972D74c048e670133",
    "0xF8dDf3f33cAca5f44a44Fe809fda45e08E370F71",
    "0xF92a1AdeBAe35eE06354b2c8D16Bf40270898e79",
    "0xF93a8b0F95C2cd42f6e9c8Df38171D03546d1403",
    "0xf95FFB4b5cdF67e0aE354B36838d0A5a6e78Eaf8",
    "0xF9639a07bbeb912f489110Ce6cB7378008Be80B2",
    "0xf9B2b433Fc953C209957D754A5e4334f2C8676Cf",
    "0xf9bb1fe3dBcBA49F7Ab71485FA944eAE6605eD1f",
    "0xF9ce666dfD77AC1e1323BC8E8d371DA4dF354bce",
    "0xf9f7f07617191c75466FEBEc2907019872bA3C1e",
    "0xfA53D837B5dDd616007F91487F041d27edb683A0",
    "0xfA8568cca1Ce6Af4a3479B1707091A92CcEF62Db",
    "0xFA8C7f5A4566E121a2F052B11A156E578aB50F0E",
    "0xFA9E18C40806fc683868Fef5c810Fa5AA247f517",
    "0xfaCFE479a1f50469a90269E63f38D1B0Cf6d8001",
    "0xfaD832824C1F20d908d763b0510AadD675b1f522",
    "0xFb33A1b117e03D2171af9AC35243369617109A2B",
    "0xFC4315692753C9f4b8CC701B75F5FD0D53B0A9E0",
    "0xFc90Eebdc974ae1a7b18B0d8002826D6d9FEE5F9",
    "0xFc9e2CF27dAd13B149dD476eeEd2B46E061A1a6d",
    "0xFcc36d581B6AAED660549Ac0E66DE0b0B8b8831e",
    "0xfcdd164e3c7177058b7475Dc7b1C7C43b261f820",
    "0xfDa07093aFc7936aA23B2caa69AabCd922D48335",
    "0xfdB34956C089a9F37621481a07016E2FcEFc9bEF",
    "0xfDD6cC8F6849e82f5e0102057FA74941024D11b6",
    "0xFdF1DF2CbF1f33834E0d730ff61F29056069d49c",
    "0xfE0858b5B32703e256C4D78c384BB979416d83Bf",
    "0xfe19Ecf16E76Ff537c9b8C910Dfaa08F700A48A6",
    "0xfe2037C5D1D078C23fD3412D369b8158246ab71A",
    "0xff6C513B59c79e0D68D89a5905F7eE4c2507CF87",
    "0xFfD342277743d7579eE015C96567C06B0FE30eA4",
    "0x0005c8e9f55a42b5Ed64D6931038A1D8C50A3ea4",
    "0x00063dDB30be7Bc2292583D5f143E9d6E6228440",
    "0x0013C382001DF4022FE14814a865cEF7Fb814e14",
    "0x0022F267eb8A8463C241e3bd23184e0C7DC783F3",
    "0x002495E672778C6189Ff9A88653977805b8C9cf2",
    "0x002E8D554400DEB8Ce11019E72e30Cd99c5dce55",
    "0x00362e6F9FB93b776456d664B2c2e967467EffCa",
    "0x003732c40E3b62a6508B3AF68b8dadF84234427c",
    "0x003F6b20BFA4B5cAb701960eCF73859Cb3c095Fc",
    "0x00584363400c0b874277eDD8cB16BC58b4b00aE2",
    "0x006C650B27941A9a4db37755d2E0C45290a3fe75",
    "0x007dA51601FFa3aDE61876C0858F778F4d727595",
    "0x008e669D3f7880E24329aEbABe1f6e18A282503A",
    "0x009231593D780d3dEA09AA185B0317E516E458EC",
    "0x0096dE908BabE0C94114Da6f5D2Cb47f7DC1B665",
    "0x00977F3AC25d9CE72BE474900D8dc1DAfd48BB0e",
    "0x0099E92adCa2876afC2ce0686B35864b48BC1743",
    "0x009A969CA70de90BB910FD5400008ff6D93C423c",
    "0x00adc1683B1C662304383f9cc917A5eb7F1dF793",
    "0x00b58770b74675042F38154388722EaB77aD3F97",
    "0x00C60d2741efC44d229024712A59f5649c2b0e4B",
    "0x00cDa37BfC3Dd20349Aa901Fe8646688218d8772",
    "0x00Ec14b2fB6FAaB7013bDAa12584e21A009CD8D4",
    "0x0103a4966daba5a947df52b0B892d8b3fdEF5A4F",
    "0x010D1aE300eBbfe8E31E53ef8BebD59a8169a3f5",
    "0x0112040Adee9A7984957bc3Ed77A15a8072baF35",
    "0x012046119941c75a3c1145885A023b2c5b69A69c",
    "0x01225AC47572978cbDBFD7A6E181bFB3C2257843",
    "0x0136a80FeE9e379d9F0c042Daaa99C99234a82Ae",
    "0x016CC36D675d3360aD007e89cDD570f4f00C54a7",
    "0x0173f04d46027eeB4ea00B734292d0F54A965122",
    "0x017aF4481E13023209F6C15F6cFdEffF3c695534",
    "0x0184fB271EB5CEf5aE3f1e2b3828D029d786Bc5D",
    "0x018f680FF270c8338e16581dA828f7c3F0870BC0",
    "0x019D370adA720786cdA2C4f78F0F4657af2fF92e",
    "0x019E0b2c06303F7228F2bFF8D378681B6f5bA81c",
    "0x01A9B7c7165a64eA44A6B85DBF9542ed504A0feD",
    "0x01bA9FBBc2E13a14a68a19FE2d8638D65a63D9f8",
    "0x01DF74546Ee1077c0547358bFda8852Be7bcbCcE",
    "0x01Ef37E27235c2D25616972e1a579a6594932827",
    "0x01f3C2bCf2AB910dcf2d3DAA0c5c3591DfE08579",
    "0x0211325D0632A8867d5D8AC8196610fd296e4065",
    "0x021AfDa9886DCe1cCa8cEcD130e4f2891b2B91d1",
    "0x021b927e87B8b1a8426761BcCA700B47a56ED3C6",
    "0x0221c3cdB3dc4ffdDb0564227D205b7F0CbAc1cf",
    "0x022885692db44c78C4AF5088A37ce811937b1934",
    "0x023367F713780aC6E123e5C461623377A2F82EE6",
    "0x0239a456Bfd1FAC6049BC1F1BEa9f606Fc51244e",
    "0x024D8152A99F77A042865Ee5429f2AF7Ddd228cC",
    "0x0257e6B21bEc8A689769C5495F4564fa3e738fA4",
    "0x0264c4CaBEcafA630Bf082155bD394EB6a48e7b8",
    "0x0266a6e1CbDc8220d5108cbD5260E3Ce83896688",
    "0x026c2Ce6EF53e7EE15e8ff752587587f907be359",
    "0x0279aECa65287F677857C91dAa29B678A041DDe8",
    "0x027a9cE347D6964F9a9452299B04288E94c3b201",
    "0x0288b3C8d49Cb47169228275FF0aB98EA7496dBe",
    "0x02943a285B2d597dA8e7673EB325Ee1d5F59A9F6",
    "0x02a78cF4Ee4BB60bB127e4777945b424FE5e48aF",
    "0x02c928FFa29F25A0E40D81d2787b6e1B0EaD5c92",
    "0x02d4d2971B694CF9cA981f4Af5f6c18de66A2bb4",
    "0x02d68207622D9BDC557B8cC101862442Eeb872e6",
    "0x02e030F6975CC1CbDa531b11Ae4Fd7EC698600c7",
    "0x02e4e2F85e51A51AEB594515844E6ab214883104",
    "0x02e5A81f9B18b52AA0EED218Ad585c889cf228A9",
    "0x02f95f134C8E4EED62b6C3718270CcF6671782A3",
    "0x031904c5bEe1a54d06E42f59429fa49d3f9bc392",
    "0x0328c8b74fC29943b1c6BE6CBa3f94119366e9B7",
    "0x034DE8458c9229Ebf8Cc72864f51AAFda1E175B3",
    "0x0358d8E372251106e4FC01B4F3712D9B27FF75De",
    "0x035e3cDa2d96636D973ee4bF6eb50a917ee7276f",
    "0x03757f2b37e67481f33b24C12cfE60e773472869",
    "0x037a8da64bdAC2fb83aE28a3745Ccc097c48978b",
    "0x037Ca848F2d7Efe94A2134Aa6648a5Fae097e19c",
    "0x0381f5523e6Aa7E142979bd83c1A02f316F0e8C1",
    "0x0395ED8151455465b5b41d278F911d282225D62B",
    "0x0396e41347F6A8CA45b4A3eFa82c436786dD44b5",
    "0x03a025afad1e656b9Df32f2620717875a48e6B1A",
    "0x03aAE3FC74c4006BA9C20bFec0bA1A4DBbC9b0CD",
    "0x03b1Cc4158777E68EdC5DF6d4d656802774771df",
    "0x03cFB89864448F2839bc58C45B3E055e46829e7F",
    "0x03Ecf76F0607Ec754F3074c441bcC1857cceCa19",
    "0x03F6015bD7DBc71AEa7f0fA8D4Db971E61874A2c",
    "0x03F847E8DA5b006Eb5717Ec65233ddC96E0FfaAE",
    "0x0408B9d5BA204Fbad2BACd0efCc86E503Cdbd1bA",
    "0x040b8c2f9FD280e6fEea3D8BD264AcBdCc915C0f",
    "0x04173063C0C491470B735954790f94ed307aae9D",
    "0x043A66df87B499EDb28E93378502641f29589309",
    "0x043E15eD845Ffb10cc11E55bA08B547D2d841b33",
    "0x04490dc0f52A97ef2d6EA0C4d9eDbCde8c8546CC",
    "0x044D2451768A56b6e77C01692d1545702Ea2Fab8",
    "0x045729217e92D5f9b87214240fFAcDC76e72657D",
    "0x0459E2d7afE282b43D6acaD5B010C066aFc1cC1e",
    "0x046ea922F6AbA8E4689bC775A56fd30Cc21e5fE9",
    "0x047C4d7Af709ae19D3BBbD5F9E10461d2554dA00",
    "0x0489726421f3b7B3Eb2Ff98b29C6cFc5aA54F3E2",
    "0x048CA60D4Dc3Dd639D5d0564a161200D3c4723eE",
    "0x04B5eaAFc9C6fbAeF1D9851B902Bbb527E76171E",
    "0x04dFa69384AB2A523b37823175DDCa4D430FDD6B",
    "0x04F9B91Feb9d2eE2ee333f016c4482672d931af8",
    "0x04fFf013fe245A05BEA8Ab918bAE936FE45256e1",
    "0x051DaBE857681c972BF2d463D15B4A4EB4B6d33f",
    "0x053dA52E0857697B876588e8e4ba6a9c25AC6093",
    "0x053f4Ab1ec5A48C7003fD8A11FfD01769aC2dE05",
    "0x054Aa4C45aA5ee1B9daee51cBe05b51c1Ae6bEff",
    "0x05a64fC3398b49b1DcBb45109Ff6deBF2Ea3dc24",
    "0x05B736fEC3AcDbf023fe556A0C16Ae206453Ec9a",
    "0x05CDe88B0F03E7434BE09d2Bb19789e56Dc8E2F6",
    "0x05e24D1DC18216DfeF0A3dF9853093564d4C520A",
    "0x05E2e507E53261F59a3597c984368D1018A872B3",
    "0x05e9D0F019088A440731F368beD47e3B89e5FE8b",
    "0x05eFa071701773131d00F01f408669D6492B84ec",
    "0x0603Df18aD272bE9e042803bCA337A0412FF0eDe",
    "0x0607b0c69cc062781829446A3c2EBEd9BffEc7f2",
    "0x060a082C900948A786B64ACE1713FB0dC8D8EfC7",
    "0x06175B039FA78c1E82D9bDa349726eaA918Db45C",
    "0x062e2AaA9ec2DA2340Cc49c76Be1604047eA0892",
    "0x066a79F89D4F76aAb8159249f3Dc02bC5fafd832",
    "0x06701aaFDDF1050e01182e82fB8C6eecFc70c592",
    "0x0676d673A2a0A13fe37A3EC7812A8cCC571cA07B",
    "0x067fc0faB235979CB615F46336631288c6e5aD75",
    "0x068565c1F5bDe10D4230A8157Da12a4C0A825613",
    "0x068848A875FC633a9514CCf5379949d85Bb11966",
    "0x06D56E3Cc5127aBa2F0553281aA60A16D3405131",
    "0x06e28C3c956D47eb163C8462F77CF52e3E00C2F8",
    "0x06E54A1Da420A9162cfB33399DB2B8185989f8E9",
    "0x06e7e70C354E9093e340A63A86C92e5a9e1e3964",
    "0x071489B287C20C413f28A17729B1c954bC01D5b8",
    "0x0737EC6b2C85746363f3B8cB27a3fbf6fEf802ef",
    "0x073cb183498c995187E13DC08C860f16c8d7833D",
    "0x074d580e66aB075bdCa4b87f838c8aB8e5fE6D75",
    "0x075b2Aded57F8F997C015852ACe28f9a7ead7306",
    "0x075Bc364fd2DCB1f57bBeF75853Ce2d14915F2f0",
    "0x076097cF460E3b5FC3a94c43d9A598164bB29168",
    "0x076B09c3B87352b91cA75CE1cAA156E854c0b0b6",
    "0x077777F53544C2B2EF753c19E8fc048049c5FF95",
    "0x07781960A5d4E92F5903e9B88eCde7c17928a3CB",
    "0x0786c200979febAC7f56849D6EA6a21cF3a31BF4",
    "0x0787456B28deD8787b46C030ccd4A0c7eb09Ea77",
    "0x079Eb89b202651953A04F3700b1b3b590f49A03C",
    "0x07a2F2d9bD389939572662130AE9020B401BCDF9",
    "0x07B957db0167D0401E5001D7e3C7A6b3b628eE7C",
    "0x07bB14B7A39144c9dcb3EC191D72475436c0c3CD",
    "0x07beD27e5097C986B4e958559B9fCb5fdFC352eE",
    "0x07cFa90652e67a6e2b570eC752C569d3D1450207",
    "0x07dbC9423BC7e4315fE6224996A1d6A93931CD55",
    "0x07E86959A71E1D1A909F89101080B7b9caa1832a",
    "0x07Fa70F8666CCCebfF280f17940A2BdCaBa2c59a",
    "0x081A75EC25F50C9264F49bb262846259c2730CEa",
    "0x0834e0aDb7147d2E60800d7661f7BC2404653a52",
    "0x083BdBAA68acD8cBFDbE5502ea8a27e9322E9baE",
    "0x085028557597d0A929CF6f694D6A4363Bd86451a",
    "0x08522c34Fb5B61943E4e02B4c7d333D412883E97",
    "0x0869C8e4E33aC2A145F8CED467CF7f0735745710",
    "0x086A951C6dabEb2Df77907A9597CD2c4107aD95d",
    "0x086fbc170332292cc864290230ab4DF3De9d40d0",
    "0x08756EB68e2e3496Ba34EFA3c5025e4454E1a8B9",
    "0x088227eE56B17E69C4E6865DC480D0A19d5156F4",
    "0x0886A3B935DE1A05dd5067821d5a753656a607A2",
    "0x089660619d26b6CA62EaCD74e2DdD6089024fcCc",
    "0x08d98978cfce600384a022ABecf2bA80640B1B7B",
    "0x08e3416447222EcE005e7cc4cf956c46eB36042C",
    "0x08E3AD15459F88fAc76c302Ed74D66067EfF21Fa",
    "0x08F0b0fE10616652573Ee13489a0589A5A38e7c1",
    "0x08f950816358F4306B70fB319E4F35c592d1B8a8",
    "0x091eC87E2dDF994082dC3a0f3A8447535a54194B",
    "0x09566716532CDaf133693940bE8808838920D47a",
    "0x095f4C926278601025130ac49bF298039FA5FD04",
    "0x0969E5A983F1C527A4090bc0e7957f3029f7eB09",
    "0x09708Df2912302A9Bd99F1ca56803dF65CFDD93e",
    "0x0974FF7E79d93C462421f23520c0e6BA300DcB97",
    "0x09876c87BA11c8fD4d87E00507cBdD0636CEFd63",
    "0x098E454F399ba952c225FbfF53AAe37C810Cbe35",
    "0x099B939c9ABe0c146a3C915EF065161607e75AC2",
    "0x09CD83f858d67955f9F5B64F599F9Df702278975",
    "0x09FD7587DED0013205992aA7bfa8B546b785bB81",
    "0x0a185C0ac966B882811fA25B02840701e8603B21",
    "0x0A2f9FCb7F7A82656eaa53923940521146170612",
    "0x0a36F1bd6c8b2D0C5768d35f1ef7611a525Fc0Ae",
    "0x0a5D7C86C6bC7cEA7ef713BF2f10E9C21110C08B",
    "0x0a5F919cA9132bf2eF97CAC8852B3956162c1478",
    "0x0a62C82C48f2Cb138f8076D4dAAcE3B4A685a787",
    "0x0A8EF9FE39E0EA0a33F75C164Cd58434fB5f5c27",
    "0x0aAcf5D8A327dc048055BA928ae79744863fC033",
    "0x0AC2185374664768Ac7C44f9674a3c82ab31Ce67",
    "0x0aCD2D2288F84E1E2b250Df1B7fd1A1AbDa11D49",
    "0x0AceBed7719793ceb7B5ec46393e341bD91217DA",
    "0x0aD2631d5F224999F9f69bB901C6c8d60f67b400",
    "0x0aE01F5d8D4E0051a0dA3A3CA4ad32b043499Dd8",
    "0x0Ae2Be35Bfe08F000a1081e14c9e9653c33a6A7a",
    "0x0aE63abf7F2200308924Cd3604FdB52bB5925C73",
    "0x0Af325Ae0c8f165c9ec84e2D00E994D1C86d1E98",
    "0x0aFc9A8aCd804a333B6d713C23a76330Aa7a8Aaa",
    "0x0AFE4322173F9914888D89d55Fd069cEcC7dd79A",
    "0x0b13f13c0E99F24b96A835B787D1347B33d87776",
    "0x0B358EDD6E7eB4b38Af3ddD7FCEA775254602532",
    "0x0B38978C6e7cd9c9cE35eE0434d14b8149797c1f",
    "0x0b44Fbb992B7516B7cCe5EBe2f042630aACB3A1E",
    "0x0b8202F0e0F992A6B8FCa17628349583De1F7c78",
    "0x0b853F6A5eB5a897A083C4f1c841a4351f6f2399",
    "0x0B9F898921b2Bb8cd2d7d30fAFfEC2C90200cC8C",
    "0x0BCb035b6643D333DD360A488313232921678edD",
    "0x0bdcf33394e6FF57Eec28E3FAC572222d5648351",
    "0x0BEFbF66F8Ba73aaDD38501b54F63014a2A7897E",
    "0x0bf8897eE519FbFC60E70300c1Eb51Dd439BA5A5",
    "0x0C1D244C3b60070B92D5F199A5b5575A34eE408A",
    "0x0C322B943B934D90df8deaBb71BED6a687241D94",
    "0x0C391ABB8ED8d0CeE77fDf843110E1037B300D71",
    "0x0C3Dcd3053891421A5E3c07F5c4234932bcd4EcE",
    "0x0c3f7F32c12724F3477dDfF318321DEE01660355",
    "0x0c6a9be92ee1333fD1492E9ACB356514562b0502",
    "0x0C83210A10438E7797579A37A50Aa4E36a9fb1DA",
    "0x0CaCF8CacFc31b3Ac12143b03065317696Bda974",
    "0x0Cb2aBd05020E9513085564b4907940Ac6C5cD39",
    "0x0CBF1F6B4a6D48D3434E387439aabdD81344A0A9",
    "0x0cC3CcaD8fe80c58c96a760748bEF960FBD72E14",
    "0x0Cc901998f14e88B7669e7a01863Acc8F64905F7",
    "0x0cE10eB5640705DB40aB406F8d7EC2387909a040",
    "0x0cFD4d7a65daD4034f23FD6c8A75db0661d89416",
    "0x0cfF91F0706f293e7E2900C4F547ae03067D3E4D",
    "0x0D0DdEa176f30fBb787b2D39F2C37645e3b4DD50",
    "0x0D28b61DBE1675AAb23408E44407623124C9D3a8",
    "0x0d2e83712ec165b90F3316D5441D7deE55B5794a",
    "0x0d3E604A9b3DBd7BA98274a2BB540c7b61E0EFdB",
    "0x0D4178564cBF36e7eb7166bd9292080D2f7484c2",
    "0x0D819FA78217de449A1A0B4460487D62aF8af5dd",
    "0x0Da07e67c2cA3A3cfCB58aF115e1C0ed64f69f96",
    "0x0da652642B43Cb6F3D22F8ad374D48ADEFFc58EF",
    "0x0Dc1C0Cf5bC0791D9cABC9404ba7F0cca4176285",
    "0x0DD26737cc20021521dF1279a3d3002c0761eEb0",
    "0x0Dd273b85E5578c488559107Ac98a1Ab98F208AA",
    "0x0DeEAab5d6B065C71f6d3CeF275F3B9b68ea0496",
    "0x0dF463bd07b4ec5739e595f3024513d57Dc63441",
    "0x0E03381Bedf8C6A55CC0c5Be844e0D24a7e5f54F",
    "0x0e039f8f094badf228285Df17bB042379967c090",
    "0x0E0808A10f42C618AA666B83447aA80f0217028F",
    "0x0E182Ba3173102c558502b93c87D2798ef45CD15",
    "0x0E200F7Db06d8063a7012193698aE43146B8d3f9",
    "0x0e442C7D7db830276EcC7292Bc57456309Fe1522",
    "0x0e53dbb8d5d58D957480FE522258353408D1d2a6",
    "0x0e63d7E489363028E23a6da417D5767F9E399246",
    "0x0e6c79cE2cD7F3aB2A2d512979974a4A7707Ffa4",
    "0x0e7EF1465f3a2CBB5D6c2170153323aDe52FDF7b",
    "0x0E85Db0eD9e3663215638E5b095FD05eA66759b7",
    "0x0E8CA4cdB2Aa03864f1389A70e79e12CaCe51F7c",
    "0x0E928b9C579828C7CAD7D8eEB36Ea9fa49E8dB7a",
    "0x0E95a1820a60beC58028BfAE23eC830Ac8ade0cF",
    "0x0eA770824779b7BBC4f530705E64B291f5c43Af1",
    "0x0eB05684c7b3326a30Bae7cdC1aedC41Ca9Cbd86",
    "0x0ed9A9C12DEe067d6f069a62304699561ef33361",
    "0x0EEf6D21fbdE2d6c46c24C97D1B6977E822ec1Fc",
    "0x0F18C529B51851079b348BcFfD1A45C9426Fa65D",
    "0x0F54A7f462c78ca55979b91fF5195e8dDd97899A",
    "0x0F588b67b7CceefD90b6A2482E003E6278641181",
    "0x0f5dB66CD28BAB7a5959145e20b2A775C284F948",
    "0x0F7b88188f2cD8867CC1e1536ac6D8e0E9Fe13C6",
    "0x0f856Ef337Ad2D260d048543b66E601a1f6F6c6C",
    "0x0F9a1C09A96926E69eD8e2172f6E32F8fD8Bf6BA",
    "0x0F9C63BBE463126bAf1FF6DA0398dA4CbEA7156D",
    "0x0Fb11DD6CC3e434565D20D1AAda1469D3fe0D8CE",
    "0x0fb50833a90281FA40E2E33279C8338C9272F4BD",
    "0x0FF24Bc09FEE1AdCFfC8c929A23F39dFe0a213F5",
    "0x100405af886d14B03a96F1B2Fc2f80Cc56667dbC",
    "0x100c991fDe49fCa127c8CFaC6AE7D9Acd356E16D",
    "0x1011eac53412a7740d708c0CF4DcF0E732bF7084",
    "0x10147b9797861749956c11FD08E9e592f27983FF",
    "0x10229a132Bf529DefD6F4965782e2038bEE8747C",
    "0x1028f9DA525A2386315C9262ae08E4B2342735A4",
    "0x10366dc9cF940Af98C5b15958869a88f7F425606",
    "0x1039e20Ee47d04D6A3b108D123de1F34E803ecD1",
    "0x10436aeaFCE12D10c9b984d987f093C45AaE7550",
    "0x104611d6939EDB4835399519Eb6cC31D4760b538",
    "0x106bd9152bcfbAfeCadD50BF22Af7d623cF3c62e",
    "0x108D6e9c1111aeD0fB9A0792C3D738C4694570D6",
    "0x10d0Fac263C25557E337D7C8992C4e50c5B55042",
    "0x10E0D0de44f460744307937E3d1F3ec59daE4B93",
    "0x10E5fDFc4f07b9747A99AA2aA0E154011c84A9c2",
    "0x10Fd209D65676baa553E8B59C6e4AC87FFdAb0bf",
    "0x1110472b3749e9aC0deD81769A854AedD5b5cebE",
    "0x111A21981273412Dcdad2812de9e3b90948BB741",
    "0x11200294645Ea56f0aa0b897B338Ad73711e570d",
    "0x112CbB066bB5697DF0fa6F6D715CDD65bB6247d8",
    "0x112E372bb5EC17c1ea6b1d679EA72aFBD2A94404",
    "0x113224CFfB35f64B0c80aD489d068c44FC32b149",
    "0x1145840e7F202ad2974f9B806536aDCD1d175C49",
    "0x114837eA03eD4e5BDbD6471CFa4DD80d68563Dc5",
    "0x11515588A7E5332522f8052efF11279b9187Ae0E",
    "0x11584D6AaeBFdbF48Cd5A11599BF40b5bC386837",
    "0x117A5f1DE92C83981929220fAc521F495d6Be7bE",
    "0x11897a1dB160E5b2fb2334F3fBFBC199D1B0C59a",
    "0x118984Dd419932F31246EFfA2c90366298b030C1",
    "0x118Bf0693d1f51541E28253E67bB1D88AB24B7B8",
    "0x11978256f49145D266bb7AFbADEaC2Ce61193F61",
    "0x119De855b8C21250D41A0D13C5044D9e68A1bD6f",
    "0x11C34Ad455D3fBA05c532b47e17FB3a4B4c7289b",
    "0x11D34649817BcACEC3EaD630C582B15FFc3146CB",
    "0x11D68a123255afeD8C8D229250A7f0AEd4683422",
    "0x11eB1325EBaBcd9630A71E4C312E3a53Ce3BF71e",
    "0x1203F19ACd5709C9a5049A101704B59B7415C3b4",
    "0x12248FFfB45a20a3B8030572feE038eCBC3D1D32",
    "0x1231d09557646694D64aC0791Cd7DFCDE0E72dAe",
    "0x123Be94bCA3e5aE858039112D14C1c740a3989f9",
    "0x123E49f9B11f73b0fB712275a08922440818048a",
    "0x1257fCD239CC104D19Eb668Ac358Ac4284D24eAA",
    "0x1259A5C3D6a30a18eE1E04daA2c6E43d4C442632",
    "0x126dB8ba1b4Ef74d5bea7c6Afc13B9273CDe7419",
    "0x12909009D651D40D6ae00B150db3107BC5654603",
    "0x129376CA458092591D05ce549c670519D8d7E68b",
    "0x12A9bd0B7563F686EDf745502e6B594aB6048c80",
    "0x12Aaf646C2865ab3f99091aDf0AE3Ae0cf50832e",
    "0x12bC061F01Ce2CE82a1A5d986Affe4dfb79261F6",
    "0x12bEFB51255ADb2De7E790b12D79F33351EE70c2",
    "0x12e8123822485229EfaA08Cd244e27E533eb1F4B",
    "0x12F949EE9E1BD26801F6d3618eA7fd253AD49ec8",
    "0x1307Fb8595538aE66C3c2Be59128a6D97CC7E0e1",
    "0x131E54D54264d149c889dB21542A21eF81dA8D60",
    "0x132Ee3678e0333dDa798E91F51a16873A414008a",
    "0x1342F46CB8c7860e5Ee9dE0E6A31E91433990431",
    "0x134FD89319F1fd0C8f2B5ab6e03Ec5B9D55A8946",
    "0x13655956ca31E4708db4FE9B5C507D2C2E0dB522",
    "0x137c92212f76B3bD0F0cCb3C8d21D66ABcdAaB21",
    "0x137Cb586081778a40b901e37eb33B838Ce43c57F",
    "0x13a9cF094C4F51fBE37665509B03e96C4C6993A0",
    "0x13ae71DB307648B7726513a98F50e1b9C88EF922",
    "0x13C55F3F0DBecbac5F47Df390293C97B8CaCd48d",
    "0x13e3Ff3789BcDF0E8E5Cb42F342bec7A093daeBb",
    "0x13e7313541C9E421522e4E71042BD09Cc4ad058d",
    "0x13EEe41d67b8d99E11174161D72cF8cCD194458C",
    "0x13F0288590f6575F776fB6B5e7922FC315Bc8513",
    "0x1412e76992bE0AbcA1E1F27C018012d86a3Baa39",
    "0x141E96a0C999f28de607D79258737D8CbFAC1C07",
    "0x1428f05a7F94D9228b2A78293c99b337D7D2aF6a",
    "0x1432e37Cc88ae26343B04eCcAc60e2c728379375",
    "0x143541b6728Aa08174BC78e2Ae8c405eD1Aa3746",
    "0x1436DbFfBDde71d16A2c4d23f9116c3158c4d984",
    "0x1443b71e070C383Fc0e9E2f928197bD81F8B2b5F",
    "0x14483A6F963de871FBc693746e2fa54bFFA63715",
    "0x14487ed2303e6C131460c97417374F82B9D1C154",
    "0x1450cD95d73aa440D62D6132E5efd9E6a055508A",
    "0x1452073cb11CB6b66b8D30E4E8aA48d4aDf20B8C",
    "0x1456751e7Dad1da7beE988B4606d322dD6af4074",
    "0x146169afE9a44332784881a9DE6f1aB2a2C4c2Aa",
    "0x147A689478Cdd24B5452271972e18EEF05eF359B",
    "0x147fa5E9C88596B787A5c392C88639B35c0Be5C5",
    "0x14Ab7AE4fa2820BE8Bc32044Fe5279b56cCBcC34",
    "0x14c00e6690a3aFB593adDb7CF0a92310B3B6230e",
    "0x14c7B1C740576a4Fb163E5339A0F0DDd84De5E36",
    "0x14ec3c75b6B68f59Af5Bc328a4AAb494B5b7B735",
    "0x14f1d835AeCf747ACAd839B23fd1B7f2d8791D42",
    "0x14f5dD9c6fe54872D9dE3242F82C59f079BeE169",
    "0x14F8c1f8e31CAC72E3026700AB61DFadB31f44B9",
    "0x14F9F9d840135cFa2F8deF6De56CFDE423662b7e",
    "0x14FD5d97D9bb44E345769B676954d1319eAa44bD",
    "0x150234B21a5F612D9c7FD1FaCF32722249FCc0c7",
    "0x1519E84999d6dbdE35b00f2E73B18AA83B27290A",
    "0x1521A41240C40Cf441cc68dD7E0EED06e3dC72fF",
    "0x152aD2c855A5b8a8cBb39927101840108049a3cD",
    "0x1564ea8e18df6D997Bee5Ed0B93FFAD3F169F8d2",
    "0x157Aa4E1f5780894a3C6641849091F619e390A99",
    "0x15815e4b4C65FD015e340ceD7CB71D0e325a6C28",
    "0x158b0a1231b91C2C2E7a6e048913b71549B894a3",
    "0x159bF3aDC4C32E8f17713d3015224667B6239ac0",
    "0x159C0f8281b7Fc7BB99d74Cd69fFd4c5eb82464A",
    "0x15BA1D172639311327dA703fB1280Ba6DB7e4D0F",
    "0x15BC5B5B4ff4aCc246C651e29bFC858A8195f18C",
    "0x15Ec761833A32A90db1a0457974BE6DC10C29036",
    "0x15F3B7d84AE370b3F2E7Fa0bD204Fa3C70FABc06",
    "0x15F7320adb990020956D29Edb6ba17f3D468001e",
    "0x160722FEf6d98093E060B6b26068b8458bB078ce",
    "0x1610c19191b6634E9CE889afCADB691801727B05",
    "0x161f0b634FE0B446795436A337c5f35dFd0a2C94",
    "0x163c1D864E91900f1993f57f5EafEE36f14b9cD2",
    "0x16458D6563e02eE371544096cEB89Dc32316C3dD",
    "0x1663c5B7AfCC943c4384dFeF7085F1A2dAa41933",
    "0x166Db75A68347e9837a4a7C7f7f6cdC979BB817D",
    "0x1674BF0498D726e034e893eC6da8Fa3D0db503D6",
    "0x16829BC28d454A41466bB420A3a83340b5515313",
    "0x168C76D401A6bF9dAB7E5eE7485cFaB1cBAe47C5",
    "0x168F312221F871Fd35B8EA73f6305C6982AF9E48",
    "0x169B5435907769af082A0787eB49Ba6872e0F20d",
    "0x16aafE2f78010c77ceD6E8C3097C4FB4863C5e8f",
    "0x16c1eb144FdeD06C42d6cB726bD8f8bEDFADf475",
    "0x16CcEdD50d9EAB1Aeabf84657547278c229D2211",
    "0x16d287E2874b6C4D03cCF41F4A1d63981c2AC751",
    "0x16d375f1D36b2B4A328e6B9b5701D613f5600217",
    "0x16de9a0d10EFc67EF575e72E40FD4a2A826fdEA7",
    "0x16e7D6B992A493A14a916BeB65a182603684b8e6",
    "0x16ea504C9Eddf8bB04516dc1fd34dfD404e7C369",
    "0x16F19374c15945e59Be4F2259892a9B94FbC542A",
    "0x16F60a7493dfB39aA3CC6f4F6556874d55aa9558",
    "0x16FC712DF32D34778b037b81dEC2800Cdb1291A0",
    "0x170fC08b2c94c293d3Dd8941132d0bBa0632BBf0",
    "0x17189591D8E85cffD4825E6901bE50474663CB6e",
    "0x1726510192461c6D9Df244fa3420fD66ab5Aec95",
    "0x17357B1002AB1804657885a60a3d9B114C79019e",
    "0x173B79083F510F522f2a7D73cE233d1f4F7973Ef",
    "0x17483a88242f13198Ec6a4a9F1D92665676a3e95",
    "0x176D08eCd7E639bbE668bd29Fa1b3Cd85Ddab4A6",
    "0x1770E3F4c5201E58f31cffBF02449A21aE4017fa",
    "0x1771E7021E282A384D62bad246424c8bc3a0F187",
    "0x17724588397A483379535bF0e64A92Ae548aF828",
    "0x177d1395575822b29509648448A95d0E2530232F",
    "0x178249F0267612d85AB22335D5f7fF225D032034",
    "0x1783AFcBDaD44d9d624f783826e04B6fbF411496",
    "0x179504149C675376952500c65BD2f83052952541",
    "0x17acCf90bA294Df3bC2f12818d18a48C756A90D5",
    "0x17aF00BC4424757EEDcE0ccd98b0612c0A23a53e",
    "0x17b0fE9dcd5546051cE41E893eA0a4f139208Fe5",
    "0x17Be2881d37f878520E46082fF3d0AF739aE392B",
    "0x17D29F5cB1384b48B04e11B24bD847678D91CAc8",
    "0x17DC2C8b9AC2514E590b9033274bF70bfF3AC79b",
    "0x17e1d485f2f3e313d74f9dF9c0e486b4b9101C00",
    "0x17f4B3342c9bf8B3aCC4F85Daac75D49516c29b4",
    "0x17fa7a58221730075a60A585B3662b8c5a6eCeB6",
    "0x18011BCC6B1743509237878C786859d2E0d28a89",
    "0x180383C391d1878497DE8FBe6d99a21d2DE54d0d",
    "0x180669310D089fafCbeE40479ee719752d680d4E",
    "0x181194A1091bA7001351F3BF0b444818a051ee15",
    "0x18138214e48aA957B995C9B97AA266C22Fdd9bcE",
    "0x18175088558795c90466257D23A7E112Fe0F8f2a",
    "0x182ff9Ab824f102D826813f9C4C569B4FAF3d019",
    "0x18302A9b14D7340F770FB85Ca623F5a9A2269484",
    "0x18386181bCD9F939B15c1aCF4a5525a82e398c3e",
    "0x1839a156044a3688F157c8D1a0cD9D3266732AEf",
    "0x183E19d8CD70fE64Ca7741A86CB45a736784217E",
    "0x185277f53Aa548aC654a7fAdbdEF831149874a90",
    "0x186c05D28aAe9cEC95aB4e789Edc2AC625Bb367f",
    "0x187685EDE6487945f1402CDF47b33fC388f302D2",
    "0x18803AC8254E5E3353cCD30456C605da89591847",
    "0x188c2DD0Ff245472DA8EC1Dd1Cf8Fd1b6aB5d5E2",
    "0x188C30E9A6527F5F0c3f7fe59B72ac7253C62F28",
    "0x189854694b708Af7b70676820BE66951C60EaAfa",
    "0x189F533Cb62077864e0C1000D3bf9feA9870ba5b",
    "0x18bc4293DD7f72d9DCcac45E207093Df3C23cd17",
    "0x190008cDb7C28Df6d3500db4b8E8775bc026aF3e",
    "0x191D5f14102486a18a7Dde9E3F0EA428Dc031f88",
    "0x1920F9ba992BCf3782FBa6aB7116EfCE3949DBcA",
    "0x197052461D259C4A6ba3875BE1D5235A236149fc",
    "0x197810222C14De5F759163Be9ab819459F8544de",
    "0x199A3A4B87cD0f8AC24b29399cd6aEF0D11458da",
    "0x199FAeB870F3ED8c96CAf35ebA6D43d10c3E2478",
    "0x19A02Cf028ECeBCb9102746afF95BFF088833BD4",
    "0x19b27c04cA3E75aCbB515B49c0d6180c2b4CdF1a",
    "0x19b319cc3ee582336F4ad74EA0FF85BB26f8c6f3",
    "0x19c4dda575e6938635f8A4ad77Ad8fb320525bAf",
    "0x19c715ed45f743db3e899f722E497Ffb97F3172b",
    "0x19D739eAf2bC23a6e775F21D43de7e0944C8F906",
    "0x19EAed98F0017B1124b7adaC88534979223775Cf",
    "0x19fBAc6a862eD3e02a099e58c3d0E3Fa6853e27a",
    "0x1A03D3c77A277b59bd94c3cF8439cad14902E98c",
    "0x1a0c3156Eb071C0A96cfe957278365d3eFacf964",
    "0x1A256c53291A71624044C8dd84BF07Ed9737D927",
    "0x1a2e1EdEB8928EdBB416F095F183ac719797729C",
    "0x1a3e14Aa59fb3aCCA05035f675D75B907b659f4B",
    "0x1A4370fdd7173d0a41FF7C63a8e0249479BA0225",
    "0x1A4Cb2CCA74476F8e8d25447FE5E2328B5DD577e",
    "0x1a775079Fde189642ec93829e298148813274Bff",
    "0x1A7861a39E74D93c8EB883d774f168BE46f81228",
    "0x1a81EC53721568Bc029Dc56E187d078A06FC75AA",
    "0x1aa4e5d423186a6099b6D5a02857400B39871c35",
    "0x1aCD07f8bDb36dC813e714D8D53E3CCbc656FA2f",
    "0x1ae82ba5e7BF3012c8435FFfCE06146E8E4FEee2",
    "0x1AF331dc34dD7C5C62AF28B5685328318b61888a",
    "0x1B12DA8e49Cf00a7727ADa47468B3d77A66d2C6e",
    "0x1b21A4287CBfA8F81753de2A17028Bf2fA231034",
    "0x1B294Cb2c98AE15fFd53cFAD1914EaFf80a7F070",
    "0x1b2f6378b95eBaea01Dc5EBE050Eb7577988BDab",
    "0x1B441639D48b605589cFf494A01abfc15CE0561D",
    "0x1b4bb0E4890fc4BE20DA7efB7F61b3aa2BEb0652",
    "0x1b5A5Aa8ca1B3f4d55ccAAb0eADab56C52d0374d",
    "0x1b6265A40839a331acE2D81bc82b6104703C0426",
    "0x1b7CCd294384A5bD5873b0Db0876cc0931ED4cAa",
    "0x1b7Dae8BE5A1C21D94a61a9d91D17ecf66eB4cc7",
    "0x1B95E1CFD4a3f8aF6E45B881DB75b2d5939d0424",
    "0x1bd365FaCCFD93A2bf6c3159fbB48f7Cc7941106",
    "0x1be73203a8045ca3e09713cE37400c44104322f7",
    "0x1be8214A3E0528623E0E10AF349936b642Bd3767",
    "0x1beA07249Ff245c3c7662D3e69a1036fb5A07EBF",
    "0x1BeDF678eA91476731Ee1b32Ff8111bB1e822251",
    "0x1BF8DEC03C10188B1D948a4A28b4a73b5180BcC7",
    "0x1c2Ca609CB72b05A23d1539acba6C594c87E304e",
    "0x1C2Daf532804c0CD1ec272Fe41446790064a86ce",
    "0x1c47E805eE910E1da6Ab13CB02f3A5C517feDe13",
    "0x1c6BfeD0576757534cf5216947e85986Cc877Bce",
    "0x1c97c52900f2f724BbF4a428C447541D725f7945",
    "0x1C9A12b42571Cfa3315881133bB6c4f85C451A40",
    "0x1cAF58b1B745C5296539e9491D4b6d9143CD1294",
    "0x1cB65B78C71606090917E425dadA70E976f28fc7",
    "0x1CB672bD49EB10A95A62B424CfB136AB3DF0B32C",
    "0x1Ce14D5a89c4D13Ba8282A12CfEB6caFcE469235",
    "0x1cE20135FadDeC6C9D60148328385faee4F90133",
    "0x1cE3C5487DaDEF77eade6eA5C56fE958C3fC7c07",
    "0x1Cf577Ae3118FF26EbAad28d9cd5E8883A1464C2",
    "0x1CfFB4B2C6Db9746423245116DEdC05303c63f80",
    "0x1d00ff1416cF4eD1CEAAe24Bfddf8e4997bC3507",
    "0x1D04a5d1f4F2dA366C51E5F1888Ca9B2826f2e08",
    "0x1d11397646a6655600e15f0d39a0333895F433a9",
    "0x1D182535A587BcFCF064765f30ACeB78e481a7F3",
    "0x1d1D21b9418EC94d114c69C5d915834cd7FBad07",
    "0x1D3d8Ed0aef78B89651A75756F9B230d61Fe04AD",
    "0x1D45f16967A6b5C485524E67868105e6145846e3",
    "0x1D4752Ec4Aaaf60D0d6817FED1d2784fE2080218",
    "0x1d4B9b250B1Bd41DAA35d94BF9204Ec1b0494eE3",
    "0x1d5AB228C171aBF3D15f0dFe667b60ebdE061258",
    "0x1D65b96D931c1612D16D155AF0037e61b6B2E662",
    "0x1d8A9Dab39193504b363AD472a91701d1a828413",
    "0x1db8b36b3588cc0978D4Ae2655c1d194FF5064a0",
    "0x1DB94687b3EAFC285fFBb8aff7C974d665dE9216",
    "0x1dc973bbe0CDd9F2CbB6fB0b001110e0c26a827e",
    "0x1DD51528CA5b61A3f74153Ef8006e3ce600f6649",
    "0x1dE4d49959EAfA01aB3706Aa20707a3f1dbE2424",
    "0x1E2306fB9949e61938B70e6C576Cde92Bb35bb6f",
    "0x1e238AcC6777A6B5Cad23297436a301DA53AB24A",
    "0x1e24BAB057a9F8ccFE9eaD0635f72d30CF194A4F",
    "0x1e24C4Be9517c4819008D6b73c166dFdB6D7eF43",
    "0x1E288Ca6023515120Fc97388e83318E2f14C9cDC",
    "0x1e3a634344cAB3FF7a3A72394B3a594A58D36EE5",
    "0x1e3CFb2a9171822B4B7E63b04422e759241eE562",
    "0x1e4f6EC8163D83C23bAD7ff0E9A9FF5c0dd38bf7",
    "0x1E6223C7317Fb33c1005535D8A5f9e3Bc3671C35",
    "0x1E7C0910Bac8C4E308f0C509852C535fEA80F51b",
    "0x1e7D6B88c0aFf66d8F1D6B649Bd3B369E71aD527",
    "0x1e7D6fdecA57d5Fb389180BCBe7B902343cF338b",
    "0x1e8220799ADA6F258107C1c6A24A1092Aa039bd4",
    "0x1e8527693FBc4d956209A72b96DEfD23034F61e2",
    "0x1E887283AdC01CaCca30Dd0ED80AE2D5dDC5D847",
    "0x1e99D831BE20CC107D96953C10BBFC1016745BD9",
    "0x1E9Cfa122efB5Ac3519De72103Be8379405ad847",
    "0x1E9cfB04e1050723C5C443EE08EF65a8d2D0f8c7",
    "0x1Eb1fE371cfD35D56E4660ECd93B825669b1d4b3",
    "0x1ec9503BbdaD721EF3aD485b4B14Ce0671Dc9925",
    "0x1eCDED4519a9688ef4BFb5f15811C52f048bA1a6",
    "0x1Ed2955829294abFF32aAa9aD378d6ea19feE1FE",
    "0x1ef83AA28cBEB005db0E76A88b2d6665653B526f",
    "0x1efd625a79d3Fb8fd649b5D1453eeEc35D6831B5",
    "0x1efD85E40c389Ee8b75580cE944e96711Da0b89e",
    "0x1F18B926E21B7C73253107d94049EF0eED4ecf04",
    "0x1f22B451f5eb59Ca78eC2f7f1D8598535210Cd06",
    "0x1F2a9CA494a1f29a8dD736ff8f589b1f2e9f3A07",
    "0x1F360C8c55fa79f80c7aF7887576729b02d66f17",
    "0x1f4Dff5a5C4d8a96E2A599ac4a95267f3797873c",
    "0x1F77687dF949341a0fD8f69A3b557A26e13EFC8f",
    "0x1f90466bf8e5EB334e02aFd9dBcff0d295b4287E",
    "0x1F92fC15bCbEB4dD24EeFbead8d7aeE409f891DC",
    "0x1FBe7279DA134C53Fa521f5EE65891948e775e17",
    "0x1Fc444e3E4C60e864BfBaA25953B42Fa73695Cf8",
    "0x1FEfBBC803b62085d91827F14b37859058Af00C1",
    "0x1FF4e10CbBe4ee6233394B6d029DAEBA2C812e0B",
    "0x2009010385d4527BcDe85C0707eC97E086370f19",
    "0x200Bc6694e92270cBDDd940b5CfD7A94e7616667",
    "0x200d38f3cdC58d0D4C9FC8f1Cca84804340f5e59",
    "0x2019a6bBcc42B6b79A9E42b13BF77Cf7b7225Ac8",
    "0x201dC9ff81F72ffc3aD58D37EA3267EB19e1c006",
    "0x2020C853Aa89FB64f05c50Ea0383233C6FdBAd26",
    "0x2029c02c87714BC52dbbb14E84AA04A0a6638839",
    "0x203Bc267a4657ae5EE774Eb35cec32FAa2C0bC1f",
    "0x2045A0b2Ae6b20033EFdA432a2471aa20676f16e",
    "0x2046baEdd705D9E3e4De7c09e5613Ab5682223fD",
    "0x204b7e36443B35C00a7a85aCA19494852c4E67b3",
    "0x2067609a2311ce7683cb2c3A67cF1D111E561eC6",
    "0x206c172CbB57309E3a6455117fb0BF876B57D8f4",
    "0x206D30A83efC55681C811cF4F7A4D9a4f8b6359a",
    "0x20770f6af7cC287Ca1fA3ACbD8D3BA032C200A3F",
    "0x20793b0042448eE50a7208FD287792C6823cC695",
    "0x207f6dB2F9F4e1903E14C29e76585cc6428446c5",
    "0x20990889F16b8836DEe20e6D2c0B90018Cf1B994",
    "0x20a61B6E34Dd773945C89687A804b79ba8d4eD18",
    "0x20AC2e9b69467826eeF99e64a78Fac7AE9BF6FFb",
    "0x20bCF46a41A187d8e38a22308c801BfC3bf4714D",
    "0x20BD3FEaF2e3AE69CE05b531c968476dA087Fe0C",
    "0x20C1Ee597A8633188757Ec6eE2F7743445C95829",
    "0x20E39F002bA523ACeed5fd9cd5e738b76CAf1982",
    "0x210555f2d9321b272230De7759a25449825D6eF5",
    "0x210Cc70445B214F69EE4bE85A8743640e892469F",
    "0x21110c9FeAaaA1723D413BaF9638F8200a8E1402",
    "0x211F32470977Ed038C79F9FFD473271C70589C7b",
    "0x2120930162210085838314eFa84c0e7539d41A06",
    "0x213E6829E8d6f0709de49d241Eb7D50a92f38A81",
    "0x215fc4d12967DDC2432A7b8936F2849740Edb7bD",
    "0x216D414094Dc081B0875941d53Cda6d410Ec9697",
    "0x21810C59EcFB4331441E6BD0d517C4afB09Ba5A4",
    "0x21Ab8EA22B67c4920B47b19d0b3908518f3dBbf3",
    "0x21C0C07b75527C7278fF132d09958859fDb1892E",
    "0x21CA0b4bB5F799BbA81430f68575Ba19bf9bd116",
    "0x21cDc1262b732554c0cE6AC5b8C45C1ed9150263",
    "0x21f221a4baE8565Ebc21F8eE93130D8019da91c7",
    "0x220242F3C2aDf102b5a6c55858c6865A832eb434",
    "0x2218e854019D3Ac7989333470E8CF7BDA8b930F3",
    "0x221A17604dC932d292BC6e1fA2a376D360D51285",
    "0x221a4c60e3b30Af3A2fBb5bc93289587A7d778a5",
    "0x221D5137947D80822686B8394B6793FB5426b91A",
    "0x22204F13489B373CC0A591d5639e30fdE2A44aE9",
    "0x22239Bd1DE00C4f13868AdA1Dc86AD9a81F844fc",
    "0x22286E7aD07A25C39117963A21330E3eCE36002e",
    "0x225D7280ecdB9F1F993bfF2F887228974c72093A",
    "0x2269b44dba8e4E0F732E783871D08CB7edaCC630",
    "0x227D9989b4aF975258DC8193685f8fF0caD10804",
    "0x227e10D298C38A1a828962Ecd96495b47bBA4481",
    "0x2282e0c88eB4760C226F0e21E497CaEa939281c0",
    "0x22C29bB8A44F71770F555612630f35ae636c4CD1",
    "0x22CbE0fDb6B7CB2A89935325ba150eCf5c3B8076",
    "0x22CE16891E058fdb98De90a568b2177c962fE472",
    "0x22dfB5110938a6088451aAF8A94c18591d55403a",
    "0x22e2ef078ef1CcF0a75D113a8B8389CccF746ff9",
    "0x22e8Efe40dDB7F13B17b4c10F768967fc7a9F875",
    "0x230545308fE17bA6CF1B5802e57047C9D0511AFa",
    "0x2309913700E5C01366a2028BCD4425ACF32f9C1F",
    "0x231420a3116Ee1cfA0d9f73093BC598a4e63d391",
    "0x23150CAB964Aa87E190E001F5e5A165c7f48C4F4",
    "0x2315e82DDe3fE4c921C0e3dC4b2978A424019812",
    "0x232ce45742913FFB2575fFC92389FeDC1B9fCC39",
    "0x2347008dDa24f2514341e54e4D1790900cAC7Ac5",
    "0x234a7b4af07505160e7e875eF4D2850ec10605b3",
    "0x23546240efFa073e8E23caaA7b41a6C525a7DA5a",
    "0x2366695010fa71c8353134DE1D5Ab33536fB5471",
    "0x237f7A16AB7F1c68EFC56006391D1Fc20D393657",
    "0x2380cF20736958fFdF3665388f318dC86B3C7BBD",
    "0x239EeC9EC218f71cEf5CC14D88b142ed4fF44110",
    "0x23a37F0de6A39DE702213dd63A7735D4B32dc8D8",
    "0x23A823f4A965eEDe0fA9b9670fb7cd5060A1b73A",
    "0x23b4C7C29E1490D323Ce50F447f80586a53Fc47d",
    "0x23C80F0286D65BeBF484a7E021E29Ee8fCE4B58F",
    "0x23eEd648cd7B92C9b9EdeEa8685310eAE6dc8605",
    "0x23fed2634fDC629C1a82Eb6Ed3391efad2a58670",
    "0x2402780b6Ad0332f2cB46Fea8423649c288eB73E",
    "0x2405004Ba06b624dE572b444A8EBde1894AA91b2",
    "0x24261bD67CC320Ca5e4458D70C79e5a53090C4F6",
    "0x2433342B2c6184c3943E0F9d4F5Ea703Bbe42814",
    "0x2434594F32f072d69e93E3bADb572B88409f692e",
    "0x243b982adFd4C5428b9Df2601201aF1dcfcE3dcC",
    "0x2442498c4Bc0Add9F5b908E7f98EA44F6be73c12",
    "0x2448904e34D66ac3FA3E745E35ad9d84db7B6845",
    "0x244BeF5aF19D7969280706f37327D01f7cA28d81",
    "0x245965Dde366932880315E668ed5278948501478",
    "0x245980D45641d7Ee78e65da6f24Bf4C6c9d232aB",
    "0x245e4cC32A57E3b9bd7c50EAe8fC90FdDd6c127b",
    "0x246E210187433dd7faDe45492B12b08500F458b7",
    "0x247d06591Eb9927b80763E2Db5d0e07bd7b0361a",
    "0x247ecBA56852a98E36B306cf52a375a61f5a63de",
    "0x248388148Ad1FDD1D4f97F7bf79ec271f4a621D1",
    "0x2492C9BB1f1a646220c3Be9c93f60dd78F880761",
    "0x2495Ce5284Ee1D75223dC2F33F791e81E32d52c6",
    "0x249C9F85b2A8d293F532Ec98d80B1D2Db3f1b3Cf",
    "0x24a35c90067AcD020ea2839dF9aC49659CcE3acD",
    "0x24acfb5DD795B35F7687F3c0FE965E92cff56c4D",
    "0x24B1502A3DF1d97BE5B72CdDD1DB04FCe596CD47",
    "0x24B2F35DbaaA8DaE7AE567fbF62Fa0BB5C9a801C",
    "0x24FBaDCCd6684106E24065694aC87B0e98819235",
    "0x24fE1c47D5BbD45690A303056c27A72C81130ab1",
    "0x252765a2A674a1140CC66e722D5458e6bfaf7FDB",
    "0x252a71E3F30Eeb30203A418B774Ed9fe5562401B",
    "0x252BD5DCF0AAf25F3754b65BAC25a891321F02c6",
    "0x25428d29a6FA3629ff401c6DADe418B19CB2D615",
    "0x2570b9e77270AC2C34FbeC00B082073916Cdc253",
    "0x2573AE262eb85227B2F98880DC41C58dDAb24EbB",
    "0x2599d168B3Eb1AB4e7E2e4c67C6DbC64CbB10979",
    "0x25d85001AF41a24c882Bb3bcbca7F756903C43ee",
    "0x265346582C492e098E072E12c2051ec641c33a15",
    "0x266a09907e4e944cFcC1818C074B2Aa69BAde2e7",
    "0x267749CF2e3fABE40b9761d5bf3745d98Dbae084",
    "0x268221eff4DE4d9Ca8943F9e143c076DD2C1DD54",
    "0x268c0f22Fc8325a5ebbde2EF9D3438d57550e8D8",
    "0x268E8206b05162A790BE1D8195855D0c6D050373",
    "0x26982613Bc9F0f0Ce9CccD20e3Cec312aC3f2f01",
    "0x269c2D0badfF4e365AC2a0dA8C8e3F186b6adAbA",
    "0x26C56a79286D95b641551492c013861C4DafaB8B",
    "0x26c7Ec9DD866A8Cc41fC3187EaF6Fb9D0839e49A",
    "0x26D7B4fe67f4601643304b5023b3CAF3A72E8504",
    "0x26d8766A243790cD9b224CaBdaa5Be8E95a81AC6",
    "0x26da646aD1178D1C5be4F5D7b266c4b674e3fE0F",
    "0x26e964382E2cfEaC459F34eD10d365D6362b22B1",
    "0x26F555a7db47C651952afbC28146841eA7393710",
    "0x270052E46FC5e56c7e2539c885aA9144D1ff9924",
    "0x2701B2eCdAc42C26a89C748282CD1829A5Ff7DCa",
    "0x27280D1AD781A151fc423090d5af147Bad84069a",
    "0x2730bd7b669e2B5fC6abcDBdf048f0D8e5b0fBE6",
    "0x27381553F517C08ac1f91958AfABbd42dD538888",
    "0x273Dc0347CB3AbA026F8A4704B1E1a81a3647Cf3",
    "0x275010BFcED581894058907BC4762Ab4f7182c04",
    "0x2768c43A919b7D017DfB3bb171145a097B4Dd01a",
    "0x277238513aa94c7FBC52Fe5000da62e577466015",
    "0x278172ba1D0e4f8bf2Bdf01DC20D3c2fabBa83d0",
    "0x279280725854fb95aAaDaad62097A5f4fcdB84C1",
    "0x279775d31FbBFA8e589631ef49c6b3D0913803E1",
    "0x279C668d9f764e9FD5b5A2B633b10AaDB64bb804",
    "0x27a5dfB8eCA8bFcC6B0725c48c233764dF858Dab",
    "0x27A97da43f5a9C594B75ebE53f66D8a9DDe3562d",
    "0x27Aa6f899167706481A235fD24bE22B2855498Ff",
    "0x27adfe8457bc9BeDEAb962F5509BA303DA0e2f17",
    "0x27cCfC2217e632a81198D1dcAb53e0c36C55a5C8",
    "0x27d1CD941F2489bEEF86cA338EB1EdAaB6A1eDBc",
    "0x27E5d93a40C25f0099b4a1B7a60F9Ad8b70b4600",
    "0x27E832f46148e089d1529D1bA5087dbF1cCc29f2",
    "0x27F0d16060185a173a60Fd3B798C4352Ab1fe333",
    "0x2801DC73a6dCeFb364B959606E0c61234105FD5A",
    "0x281975BF5D79C1e26b431a28d2059a1E750393C9",
    "0x2823f3a9DF2e8Da4876A994E85170a908a3A84fE",
    "0x28396937D8f2bb64BeBaC2e20557bEc69a830Ffe",
    "0x283D37E46f7817610fA03fE8ecE875a2897A8df9",
    "0x28400C2EDF5A23C0559bc3F96E6f3f6F6b4A7a66",
    "0x286053FB4B6EA10Be4FA9D69675F6142b8B28F03",
    "0x286c940D715Ad5d20812D89713F6382063Cdd43A",
    "0x287204E865668543fC5B9574274bF811a848ca9d",
    "0x2879707EC9B6c9c84D9C2512b64cD6ab36882cBc",
    "0x288731E4D30bfDAdBEdB5A106c39dC2b7cABA1C8",
    "0x288C744D370Bfd3223feD9876E0Cd7288bDa2A85",
    "0x2892e375837a87596DDa06DD9c31A102be0F568b",
    "0x28A8E6441f7d9fd324fB13B477748b9C30d34F0A",
    "0x28b5C843eBdb7b5BBF3dd236693b0AC00844D6cE",
    "0x28d5129748669334a9a73D642Dd02562a9dD85C1",
    "0x28d9dB422FD3fc40635FD469aB105a24a3f9DE6b",
    "0x28E5184Cc62E42EC148d8E8609572BE9E04342b3",
    "0x28fe1C8886B82E3A1bf2fB510A24134310f7a5e5",
    "0x290f081082015720B5f99b3cbf3aC94A2132C813",
    "0x29257cc3165Db1bfdcE897cC4eE614f2E08d1D6A",
    "0x293317d105301497efb6C059dAb23267cB8Dc506",
    "0x2961c5AB0fAD89b31e7cb632a832F32a99cEe2e3",
    "0x29632884Ca371a85845A6c755819149445F4b446",
    "0x29660879e18C094D4F059F71E32Cf8ac56AE2186",
    "0x29a5730624d874B0911d6969661cB77968c09831",
    "0x29BD7D9beD3028e72208f94E696b526d32b20EFE",
    "0x29cAE2c24bd589F9D39D3CC8b0e1f9bf003ca6df",
    "0x29cCf6547BA65Bfc3E114d607D7dDb596edaeB44",
    "0x29d1d3bb0a0D8a6A99566366111574DBBFCbD04B",
    "0x29E3fcB9F4aaD6225f359DE66F3e81E643Ac1DcB",
    "0x29ee3F8e0dD9e36aEB2aF36CA61AEa93B5Dea377",
    "0x2a39632F0D6e62A9457b6c33d5Ac927781f311Bb",
    "0x2a59f7D6ac28e31715a76e949a805b7c1AE3AcE5",
    "0x2A85588803A93283970bB6bDF6DE64DF9114d7Fd",
    "0x2A8e6A695441752325F4dbA04203BdD95bDb967b",
    "0x2a9135cb333dAf6eb2Fe9A8f165a982381BB8e29",
    "0x2ab46295b5BC93d255DdC11D1A8a472B845930cC",
    "0x2ac3b47e7bC9d42822c1dB3E6948c1a47051e805",
    "0x2Aca962A240D126cbA75C71489b43C27c8e34b21",
    "0x2aCAD65D3Bd48fe034F3459c9F9eB3099df13C89",
    "0x2B0f947acc17413e0DcF3db7176DE8Fac130B6F9",
    "0x2B2a94561026a5c5C1a715C5D25384A4056650D0",
    "0x2B2c462f20D6236CF7CB44908cf8613E22075082",
    "0x2b3583b244AB852fbBd2d5cE93a3Fb4d22Baa332",
    "0x2B448aff584FC1e9f6205B9491C3b4743029F525",
    "0x2b5258B1Fe1B429F404b1f295A5349195f1a0D30",
    "0x2b564D9017d578b8fF6C4043DAfDfE8b86ccAF94",
    "0x2B6A429CF1BC0bd38947c007d00Eb19Ae5DC80f1",
    "0x2B744D83ac092D6e92CDa649c02b282830806493",
    "0x2B80DfEf4B12e34b421edFA02377d059E2D733ff",
    "0x2B983242bC719372eba51c5FF36fc4c7bf8DC139",
    "0x2Be21793155E0D5B3Dd715c348f7E712471E0873",
    "0x2bE2517c818399e3faFf4AE37E432F1d7917f204",
    "0x2be8fF7bAbC744f1074d0eA87Fc44faaacDeC3a0",
    "0x2beb72D8D54C72f4e1d5eFfE446b614B5D411197",
    "0x2BeFb4C92c3Af21107165CA4B7C230A3615201eB",
    "0x2bf0DF7fcF1E8271ab075019DD0585ADC09A46df",
    "0x2BFA254e60fFD0c28344CDfC4a3B1ABcB4230533",
    "0x2c013c1581AfDc50aCBdbD6D0cB28A8b5bBa271e",
    "0x2c0E8f48ac45DF1C19452390C9d8a05EC91533bE",
    "0x2c1CbF23B22427f76b2905F61647cF8e1b447492",
    "0x2C2DBFee5C237De97DB1e284e734D80af90F71FD",
    "0x2C3585d4296F19573091bE4358eB253237B08fC4",
    "0x2C4090A54Bd6EFF78BCbC0B49eD17E0F152389C8",
    "0x2c419C8b207b10B39673482d83cAa3e11f3604C5",
    "0x2c43f35B203611aC70141BE3179F680c05257EA3",
    "0x2c49b9AeDf814d7F9CCcc694bd7C9e2EeC2112e8",
    "0x2C5CE493Acce48d8860d385f05C10c5178a574Aa",
    "0x2C677B4414F293b170E1c1f5503Dc4cEF83Ff9B7",
    "0x2c6d0f1f0C1dfC395238822AC75B45B1E58fD257",
    "0x2C71773418E10EAC776271C10aeDAe18D39E39f6",
    "0x2C82523d71d2d6085FF99cCfDba88Cfc3E806D1D",
    "0x2c8D6f3bBfacf5675D07395389862b541b0C3CC4",
    "0x2Ca0a108684B2D5c6c4aC1b709B4f9E490BFebC6",
    "0x2cA8DDb3e87b0d4c2E8197E0C73CF2d6AD23b92A",
    "0x2cAa3893ED4300186671265727b90ae0B518114b",
    "0x2caEE49D269fDfF8A5d98a020e28dDF3b1dd3258",
    "0x2CF6bA6332B5B0528845F8727acF14148e4581f8",
    "0x2D1202707Ca889E48794E5b30673FFc0537EaAdF",
    "0x2d1C0d03EfeBd916346927E465D38556c832EB81",
    "0x2d27AFA625eDDADf7082A797243d50704DB76f76",
    "0x2d6F8CBA63144fFb9F684D01764E0d5C97E01F75",
    "0x2D70ff2a708394971989eD3237631e28c13009C0",
    "0x2d7b7a127c2eACD972876DA90731ee3F32720141",
    "0x2d94EF86f8842726f7829beBD76b0b0EC2b6163D",
    "0x2D970C4557ca036880Dcb1541Dca9F4D6522e94C",
    "0x2D9ED8AC199B4d0Cdb08ffDFB208137926C8b63A",
    "0x2DA39EA644AB75E42e3bAc7B019D9D83B81Fa2Aa",
    "0x2Db229945A4989fD774241DF6c50eB0931ab3B59",
    "0x2e07ae562B6D18181490fBAb80aD8EB547bfF2f5",
    "0x2E0D63fFCB08eA20fF3AcDbB72dfEc97343885d2",
    "0x2e23243EC4a10E8C3EaF5Fb01F7f70ECAB07c2bC",
    "0x2E308721c6BA1b6f1382ea4AB6440B2Ff75230bf",
    "0x2e51C881CE464bB64b4cfc4247aAC30BA88FFDd7",
    "0x2e5dFd751Dd0bE58899648a4cd97455A62e31F7b",
    "0x2E66537CF3de3a87248607edA76acecBfead27B3",
    "0x2E7D93e2AdFC4a36E2B3a3e23dE7c35212471CfB",
    "0x2e89F8B69e755b0e6B36FdE2d06D98252E10036c",
    "0x2Ebeb7554D97101CE33f2e7B511b236661848faC",
    "0x2ec1A7a5E153c17E538Aa75dAD7f3147b9e73b8B",
    "0x2ecF51c3897F11Dcc4AEE79304098422F6e486c6",
    "0x2ED167Fca4C9958030A53fDDe9F08DcCC50373ff",
    "0x2ed2175669343c1Bc2cC0bb9abCbbE381860C43f",
    "0x2eDA29Efa089fbC64216E1E7ae13e9C71C51cc10",
    "0x2EFd16D48E02edFF28175bFdaE6aeD99D054D9A2",
    "0x2F272742a1884233bD83F1f643FA9F4e6d0CEfE9",
    "0x2F3425620Fd4aE35a576eE32042913e38e181638",
    "0x2f4155398cb4572e65d3Fe52448e6f1497AA7Dfa",
    "0x2F5555D3A010d74Ed5EDee4b14E4b93A5EeD40B3",
    "0x2F63c3f6Cc7ab18c497d767036ac7F18F2E11FdC",
    "0x2F768d077b37D75Eb7299f2846452c68746C278F",
    "0x2FA1085e261148d65D7FaEd12387bA031bA2d620",
    "0x2Fa2841dc1cDe1f80ecd0B16fB719C984c1a9243",
    "0x2fD6A5B40FE31949270d210469D732B6a50f901A",
    "0x2fe18163b50e699DbB601D86CB40a73A11176a62",
    "0x2FEaed2359705332d607b4353E6d67618F3F23a9",
    "0x2fEc5dbd1C658b4C013c616B8d6DF15B4E5c032b",
    "0x30009eb6Ad16213Ec0569f9690bf72f3a84D8b68",
    "0x300499606F2026f6A6D912d291EE43ab5E672a16",
    "0x301b0fA86305c93471957f619f2341bd0a3f6b9c",
    "0x30532D90d19d2B01DFeb9Bb5E9A0f9608ecdE1C6",
    "0x305894F73aa770f7f275F052B275a4Bb95Ca0882",
    "0x307EAd9d76B49390F9bFA9293BD5C6367798033b",
    "0x30859d1eC1DB60d2263a19d6e6c638a654a1b270",
    "0x3090afd9BD95D34B272A2c6E910Da478dD3ef10c",
    "0x30A0B1D1D0555620F1f789b338b431824095C23B",
    "0x30AbCC5C1bF9fa2Be608D7ea45Bc32EADecF9a0E",
    "0x30C27B745c1c6eB331E522ccCF742CEbFb0ed5a4",
    "0x30E633e2bac33267529ECEf49C24A4E56D42a7fF",
    "0x30Ecf1083D615859DA51fC161Aa39c9eE62155C6",
    "0x31045337a3a62Ac00cDe8527aFD5F49cA4cd773C",
    "0x310dA82a1D3D4D2D8f9B05Daf3b2965ff1bc761F",
    "0x31562D5959b37E39702c0F94D06EF155489d9359",
    "0x315bf0D36F826422323255DC66EfD17cC71e02d4",
    "0x31706048D3e892c259302d7131359E326E560Aa7",
    "0x3176202d2dDeE94C063e20174bFCC54af821E938",
    "0x3177069DCe23d2EBeDe026DD2FDdE5A77B66864C",
    "0x318073b9c5e6384B581adf0237F4C998D405dbF5",
    "0x31b415f5213d0c383d859e908C32882c807c4c32",
    "0x31be70d914fF582b1F10778912120770DfaE83f7",
    "0x31E46A88487D77Edd4cB1088dc685D0E306ae023",
    "0x31E5F0ea32B0a3Bd9Ea8F5aD202fC6FBe6866869",
    "0x31ECF745d93dFf69aCc7F0819324D38323E73491",
    "0x31ED92f6e7E9272aC7f2202ced8C61bB3c896D5e",
    "0x320F84ad46De8F610436087405bC66c86c636440",
    "0x324e6160E23B1a5fd812C766C80646FFdCDf79C6",
    "0x325D0F09FE7035548631217C5cc70b5A0ac5c952",
    "0x325E55A9e703a34df5A63778013e8089FfA41ba3",
    "0x3271f80F5161220996AD7B65b59c64413ab6e93f",
    "0x327Af9D0EC5851102D53326d1dD89ea0F43eC85c",
    "0x328809A567b87b6123462c3062e8438BBB75c1c5",
    "0x3295Cd36922d38bD8807951f7bEfF31e380D7898",
    "0x32B3747EB382B8143309ec44D6b1995BA65eE8F3",
    "0x32D53a21813DebFcB33a2b1ff2a396bd3a06f818",
    "0x32DaAB03B25BD46c4aCA820Bf06F220C319e1C0c",
    "0x32De12F13ee2D08f7d2D85676F05C18F652daF67",
    "0x32dE74dE110256fF4aCE064b8C682c20623b3Bb6",
    "0x32DF4704Ade11D47104183E09A04C2bE4965dCCD",
    "0x32e1594Df957252b07d4b1FD4584fEf4a70EAbEc",
    "0x3317AD9eDa6942b5a7BE5BA83346C0Ea82C3C26C",
    "0x33192F07e0136506e2aEd4F732c5184db0c32d45",
    "0x3341BCCEc138c9Ed0037e8DF20Ca3Eb538c1AD05",
    "0x334426d637cD339868F2e7dB8A7BD151A05eC2c7",
    "0x334511ded50530371d696748462F27C50AA253E5",
    "0x334f12F269213371fb59b328BB6e182C875e04B2",
    "0x335c8e29889d3C250939d2451b62EC151ce02D83",
    "0x335F1d1C205a0a72b173285D8D4D5900110506ff",
    "0x3378210501B3a5bFDf7515e664401C0f1505868B",
    "0x33802fc48aD846fDfb3260BAc497D0b5B2AC40e2",
    "0x33805CEEaf7CC233b363829d3e44dAF6c95A45da",
    "0x339389383241C107069E3BcE16edf88aEFf95EaC",
    "0x33962105D20FD3B6273327c70b9E9ee66181D0Ca",
    "0x33a26aD3197ff3dd85ABEC20a7a38d21a886Cd1D",
    "0x33c35aBF2D6ea472D3DE636ED0Ce24BF0d955d66",
    "0x33C651217792793cf868ffA13e81427cb9560406",
    "0x33Dbeb87CDbA574aE5718d35CE83584c58BCB546",
    "0x33f1644653cf813AA1C876Ad835bbEc5E77E11aB",
    "0x33F49EE42f4e500C8809a47297bBF078b5816463",
    "0x33fBBfd71A373971F39025687f03EF9479E805AD",
    "0x340AD5Aa84f834EF976f40527CA243af01d6Bf12",
    "0x341E17acBE018718dD20277414E3eB88921d1672",
    "0x34205f77dc15d9C83E0922652f58106C2ff2Ac5c",
    "0x342324001bCdc6C4d0ffAcBfEb44973f790A04d7",
    "0x3425Ddc7fb7388ce6402a1C0F43750710F441871",
    "0x342a80498143a18B4760EA7204fF99552Ef90a56",
    "0x342E30746c598BA31EFD8f8090576E4ac815e67D",
    "0x3439cCC6B6fbbF3D3DB4fB59F16e8c1c31fF142A",
    "0x343EE80f82440A498E48Ae186e066809750A055B",
    "0x344FE9F763cAaf65c7e2ef1add5f4E5C9C684e05",
    "0x34517eF24F4701058572e90E7e9CF19A15B5B388",
    "0x3452B1327364D1B5d19a172C437045CEa8982A07",
    "0x346B54cdF75cD6dd2F41F5557695F210253a6E94",
    "0x34ac4b90c0b891Dab4f88cdE1c243cB54345B09c",
    "0x34CdE3EBA2fDe05fA45598e7cf52C90D9D6CB461",
    "0x34e3dd91d506bb4Af2cd38607d8e52B499F7D049",
    "0x34e8C8c4dCE046A30e0844F492826c61578A3248",
    "0x350F66c15B22D34A00909c09ecf30A7BE6F2BF3f",
    "0x35163A38A32F7C942883123cC0145b6d0084A9DB",
    "0x35455f51Ec60Bc9a69909858cEc40eeCE9A3C004",
    "0x354a0Ebe16a2867C37C88872062347DB7A36218A",
    "0x3563B22BA6C109De251e67ed7DE77Cbc1d049E9c",
    "0x356e02b8937023b682f0902081A3730077aFb7c9",
    "0x35a747C860a030944F320B97be1D2860159aEb53",
    "0x35a777bCF3b03cb3a21f01893BEfE69b0D454FBd",
    "0x35B16335BCd91cc9C54aD317415351f66bF34c06",
    "0x35be6874b36e5e6207f6D715e603fBc317d172DF",
    "0x35BF0f9ade81B6ab11718CFfCB3E11Cf99a8Dd98",
    "0x35C78D498726fE65F8ec068167D5d3616990D5b1",
    "0x35e0D72752af7D004ED8226b822C4A4215B01Eb1",
    "0x35E2A262f9b0fa231cBF36F8A582590D5Fa0adC2",
    "0x3611373D439Fb0f78E73D01dE3Bd15c70A658Bff",
    "0x3612b2e93b49F6c797066cA8c38b7f522b32c7cb",
    "0x36132e314d27998bef087d87dc51070a2a4A546a",
    "0x3618c914A7C863cE50E57B9258327Fc804BC6A79",
    "0x3624c5D767C7BE168E9d9B3AB2F891587495dCC3",
    "0x363b36F274E63a63C5862d5Af867521f64015317",
    "0x36485E0b0f5a1d0e2D8Bff830987ef0464ecfb0E",
    "0x36542D8c30e1fe067Fb803bE8855cF9f35eA54C2",
    "0x36754f8047EA398aF8e5dDfcDcA157C4E6B4378d",
    "0x36863ffFbaB23da20098cd856E89Aef556ab3B5d",
    "0x368b7B723704402E3675aF47F018C12293B525aC",
    "0x36B1a29E0bbD47dFe9dcf7380F276e86da90c4c2",
    "0x36b5Ca730817CB74AFBb7D50AFD41b21c993E52E",
    "0x36BD061de34D98E2fdfc471cE4a5091f09Ef0f9a",
    "0x36Bd7bd358Dc6D5491eCAC54256341D0D447Fb99",
    "0x36C4C53bB6b0B8C59E98b35a1EABb5d43B5bC27F",
    "0x36c739E502d90E1C57DdD244bD46E204607ECd0A",
    "0x36CD733499819DC9123Ae4ECdc4AB58D157442e3",
    "0x36eeBC48da111B14b010A97AbecF8bb68D10095c",
    "0x36F237fC158881E4B37C8238F6cB9FD11B8683F3",
    "0x36F8709b65Ce33A5760203Be0Fe0Ce48aF41E2a5",
    "0x3701b0Bd69B71ffe298f3E226b5AD372b22f0f16",
    "0x3702205145fAC0FB99A9b8bc61e33486C126f155",
    "0x3704f93144b7ef6D6238b558934D8420399fA9eD",
    "0x370c0184c695ae0a365CBe955bea77dcD4c10edD",
    "0x3711d58D6f3D8ED419a9D8e5267a2082b1daF267",
    "0x3713A462CAFc9723Ee23829Deb67a78519B48b14",
    "0x371443e42985FbD65E7DC5cB5ff4653DCc2442d9",
    "0x371bC3d6AC0Ee16418225b3194eE93D3d107D442",
    "0x3728780322B8458159520a30127B912B61054a1f",
    "0x372E80163860928F5b80207990CffA1e69cF3b8e",
    "0x373A8504a1E0230e08Ce12dE0623526403988dC2",
    "0x373cD5AC87e472DdBC2A044Fb9e20D9fA36a5fDD",
    "0x3772acCe889C91bD5728908A5719d537DF9b37dA",
    "0x377742271e55516a57739409E4E6d1a4d8b70954",
    "0x377b59225EF9a706D196b936d6D8b682D24D0cef",
    "0x377c1075E5DB4BB13D53881C6eBC45b0278aF3A6",
    "0x378820228c7eB26B9BBAE6F2d6bbe44625939e85",
    "0x379971F93F47115Fa4AA18f9013C8551F8D377de",
    "0x379CAdAb8F98bF10121E2e9B7fc02CA802345E8b",
    "0x37aeA4165925186B9542f17F2156340a55915A46",
    "0x37cB7074687339D44F3952C3bDc7e03Ddb8b7831",
    "0x37eA6c993c5F42e1fc3455D5781e4A580760970a",
    "0x3805d1F0aCd90867ea6700Ce086145F31058b9bA",
    "0x380ADAA32F7927E050A18192A988e5ca373429bf",
    "0x3829538544DE6f424879Cc713884971E816E3017",
    "0x382EcB1c217cD0e92B5C4EFd6626854e055ce50D",
    "0x3833197D48c697455eeC36d82E9917c9cc8d0c55",
    "0x383320C12Ad98dF3D8594631C02fCd570F9a1EA5",
    "0x383bD7dB5De5B24A2bF1d555BF584D2840791d8D",
    "0x383f02f8FE03ab3C9f8D579183ad33BA8D54C1DB",
    "0x3852471D266d9e2222CA9Fdd922BAFC904Dc49e5",
    "0x3899A5F877e84F515d88ecF2A0aFc7E2d33E8B1D",
    "0x38c951B9c247726a4fD8E262B13718cb320247b2",
    "0x3904549C69D992FB31d0771D652362f401eaA4eC",
    "0x3918Fcd46664EE0FaD753d112f34a9314331661c",
    "0x393037aF55469549eCcdB6401F2e23E8e00DA1b9",
    "0x394e6B51737134ef776180e0Dc3c55C5009504Ed",
    "0x395549805cF83CF338AB06F0c4A73AD7CEfF8300",
    "0x396664dFc1E515682c2BC6c32b394d5734392FD5",
    "0x398526505F0a577A399871b41Fbe75eC8308bfc2",
    "0x39865f1a23f2FAdbF82DED62B7001D18a5C7f531",
    "0x399Bd406332DCE4373759306E64653484515097a",
    "0x39a254E94dE703438Dd84b6BF7D6E0bBcd61eb77",
    "0x39BBFC85f0b4bFFef053cf5Ef31c70B0C9B5Dc9b",
    "0x39cfC5eC1E8B76Cffc854B5560f468E8b20DFd49",
    "0x39D2A54da38d9AB8b57b4914fF684691B93d9eB0",
    "0x39DA8Fd657960CeF83f1ba795C6518Af45F49D90",
    "0x39EaE7Eb5fe8fbF22d00A9f440CF16a0990197ea",
    "0x3A3C0C993B5E659EEe700d41b0662966F773b813",
    "0x3A460c130B0AB264A86a2735Caf16850E458B5b0",
    "0x3A4c619284748869Eb3Ab16494b461256b72f875",
    "0x3a52Df22d34D576F92E2C049763D70e8b6267F9C",
    "0x3A5615B93A8C091ca9FC7f5B9842a781cE798265",
    "0x3A5937AbD337251df24EdAc6fCeDAE9997d381dA",
    "0x3A5E46250118952b7B2de836E04cD476d67ADd46",
    "0x3A63aFC862107Fc21bAf40A5025dB7c4062Ac2da",
    "0x3a76E79D76b9748a33fedCBCF8a8b28829920279",
    "0x3a8Ec68267B4448212b3c8FC561825A77d4Ef0c2",
    "0x3aab46d7FCFEf026372ABd3912dbcCf58c22B4EB",
    "0x3Ab82a3D7ce9a0bf1BdDE3e0E6e7014E15732349",
    "0x3AcAcDA217921e3E8ED9031CEeEbfA88aE9D0344",
    "0x3ad166A56aed667b1332d16c617d17929Dc7AF93",
    "0x3AD3030e9623E9e09AE21CD0632Aaa62446a5c97",
    "0x3AFC8b65331E5fB99c71d3990956ad3A3705266D",
    "0x3b13c2d95De500b90Cbef9c285a517B1E8bBdcEC",
    "0x3b2491C8911406b2f4490B409e31104Ee9A116e1",
    "0x3b3033cDdb6F9C19BDf1EB388E359738903f3d3a",
    "0x3B3136D269480017d8B7A050DEb0D7ED979B8075",
    "0x3B62E7C7353E9ECf3C2a2d5a0b9aB2faaA36De64",
    "0x3b74c3F17559E4CD937C5bcA4bC86C23a2B8A5f0",
    "0x3b799C5045784F2de467F9A65D8dcDE695c93026",
    "0x3B92e27Aa872Fd7149E29Fe6DF5625c644be8BF1",
    "0x3BC3a258fc6Dd9F6D3021a47b44706c656Faa6Da",
    "0x3bCe45a67DaAf8f7b588219869E5636e1a44cf82",
    "0x3c0A105650eff37fF5E3cF530B48594dA1a412dE",
    "0x3c14b967CDABE4c2AF2c19D684f0F047b3B15143",
    "0x3c1Cf8e31E7B6E46bAa9856c8d52F8f10562389f",
    "0x3c2027f90B087Ec509E533762A917e76e09b1D0c",
    "0x3C22D6C2D5b7c71C7a0E6334B0Cb6DA25e02876E",
    "0x3c4423C38FA780fac320c8858f8f2C43aE50A51b",
    "0x3C4549eb5b0EA13e7E9bD036F205Fe62Ea0Cd256",
    "0x3C5aA5D92CA96f6f8464F598d65A1D25e3ff8D9B",
    "0x3C6136F55aCA188001D02115583AB0fAF6f6520C",
    "0x3c637470C140aD6B39CE7BAd3DDB5A045FA8D574",
    "0x3C665b13b4B3ddB79Ce655b435bf7BFB57c01403",
    "0x3c6C8eF76f153d8b8199f3556c253BE57EdC2e0B",
    "0x3C7F52aE9607f5D3c4562530239d96c2D871aAc8",
    "0x3c822a4fE4E17930B33278E66857f951FEcb073d",
    "0x3c9887a80B7caB0A1Df0bD0b6944c1FF9969b276",
    "0x3C9d8d644b053F8A532B2ac46BE4ce4f71A53d74",
    "0x3c9F120bD78B84571b03687f24C615583bcE677a",
    "0x3cB63B82D778105e43f064Ed739b0655f1f0Fb87",
    "0x3CC8837cd778D12021a4E7baAbAb0e06D1d1fED2",
    "0x3cda8Ff22191933Aebeb58D6D47E418A1C82d5C8",
    "0x3CE316D3B3d9A20F3e48e9da4d95892773e29F8e",
    "0x3Cf74a81CE9ED2118Ac0d359AeE9BaEA00CE8053",
    "0x3CFF62B3706d7804c32069BCA329967aE7173ACA",
    "0x3D11BddCb2A91b24CB6A72e9d20f769d638c4AE9",
    "0x3d1df78367d956c4fAFC766cfeCb9Fb2a7Fc479c",
    "0x3D1f3113622b0469C204f24994F66Ed9c6Dfec55",
    "0x3D2357a87CBa70aee30F16DDf164219a7bB34fe9",
    "0x3D3CFFDA99793fD745aFB67E240f47966D452ce0",
    "0x3d4732Ede033BD44f2c2FC3bE8b325fD624004b2",
    "0x3D5430460D4DDF48629E188f3DF297CB2B2f9B0f",
    "0x3d68705A91FCE7d9C8ac04ADFd58d4884C3C8a7A",
    "0x3D826E692D336578BD4e1A4b7bA57aCA8668C79F",
    "0x3D8Dd3d55AEdDFBC48abCdCECb1A79efFb935a3c",
    "0x3DA3077DB1D2D2A5F0F8155aFeb2DdE3944dFDbC",
    "0x3Da7D21f1A06C7Ce19EE593f76148FAe6e952ca3",
    "0x3daA7B8F8F14113E3450d6CA603678700F3e27a2",
    "0x3db92e26837328C1300E3f818c5dA7Fc9A7D9648",
    "0x3dBC93AEcD50e485ecD2Dd6DBE73d1eC19A4d839",
    "0x3E1dE01b7FEdd44Eb928677cD7D793Cd2B801810",
    "0x3e1F596BEB8aC26E91F5c66D72388a3B0690Cb41",
    "0x3E30cCeB0c8Bda60D9a9Ced3a76E2CBCf24ea3aB",
    "0x3E350C44f4Dc2160a203573fc8fE3868375eecA6",
    "0x3E35Fe66e1A1a2F6E82755BadB34aA9cE22F2561",
    "0x3e3F9D54a8a2f8Cd369D771eD31348f9E3173A4E",
    "0x3e499Ae3D6650636869A4EFC80Ed64bAB20Ec534",
    "0x3E4FBAa149c7a03eC73bEf6e62B4FE3183A640ba",
    "0x3e6557CDCCF18a74Db22333cb127414d49054dE6",
    "0x3e9d12C54c93b6498395abe9dE081B3D06Be4f46",
    "0x3ea40fAF005CBDe3aB271b9C6faCc1861BADD1a6",
    "0x3eb429C6CF87AE18aB1E3e963021c1A64e54419c",
    "0x3EbEc8F145DE2D2C9783a117caB749247C4dF48C",
    "0x3EC2D5d28401e8a13d40360Feece3F848B63293d",
    "0x3EC63f463aB649F30241F2bB867C78ddd0043ad7",
    "0x3EC6cf4EFad6C90444C892f412498653Fa6e6E9d",
    "0x3Eca8BDFc02875e13e557C0d679D79F3eD15a711",
    "0x3EE2626765F086A6203B2FA4d23CD87FA81188A7",
    "0x3eF8855355B525c69B267Ed606d790aEB37f07a3",
    "0x3efb3BcAB112C7A4C8a82D26Cc948F15fD469234",
    "0x3EfEb40688dAc53961b6958968510ef1E98C44e3",
    "0x3EFfCABDDe27072a47f14ab98b8213863c5dA207",
    "0x3F06E15bB29cb3c277654C525c3823bef70a7452",
    "0x3F0709E3b35cf00B886bF09412b5a7890677D16c",
    "0x3F0FD022D4CfEa85dA07D00cD39701FfbFc8e0e9",
    "0x3F1e2953ec44A6D73ab54E5C6a07B099E7DAC7d2",
    "0x3F2dd316505749C193407D5D324C152fDD8Ecb73",
    "0x3f46680099cF623163C96747a8ADdB85a1dA1Cd1",
    "0x3F5F7B7cebA50A5a00E3ec4aB12e70F1e2f6b0e3",
    "0x3F7a3DF9c6F5574b6E67FB26955b75E52a4E2b7e",
    "0x3F7B90353eB110Ee4C11CC618A12e0Dec0006629",
    "0x3F7f735463127d04602361e110f3b305A7D4970e",
    "0x3F8238EeFB55eDFBE939cfF9299D3d5E27207b40",
    "0x3f97c7F8f6d9B1ec363a0B3312a904894fAef702",
    "0x3fb160A681806aCC91AED14c284C09A96ebC9dfc",
    "0x3fb53766072D62Db92ed857bBc560a1F63F1101A",
    "0x3fBF4E4E6A825Eccb191963A602689F4B4dD967c",
    "0x3FFBed9340a2ab0C157A61771D7cCfbD7790c9CD",
    "0x40042efc0A76206154e02428e9803ba124e1666C",
    "0x403AfDf9Ea925D3b48E719a44610da1679a57651",
    "0x4057D1092f242133Eb642a91Ea1C0874E1eC78B5",
    "0x405Aa7eC468c6a8FD1E3Cd39F7845caD0A6F519A",
    "0x4060d22091a82c7b8Ff13C7BAAd7873CB2127807",
    "0x4062Fd5159e0d96A32079E32e87a6B1d1884ed82",
    "0x4073B2a9b5d8C537e0D47E82ACB7289619ae0DA5",
    "0x407A6Ba13AddB1B6ae82C98875920d57e9bFcf15",
    "0x408606Aa4C1B53F01e25003115851BE76b231D7A",
    "0x409f2279F96Fd5e246e5d532EC67521A56cd0DAC",
    "0x40a49Bb5C91816f5DD1E2c639d73eaB50dc07559",
    "0x40B77dd68a1eE1065cE0bD9F639a2DA6Aee45814",
    "0x40cec2B42dDEC5EDFf10C7D26F83cB452358bFd2",
    "0x40eE80f4B97D2012FC25B19F8108CE4306aD529E",
    "0x40f2B465dE4A690D418eC52b0DaFA7bf0185a393",
    "0x40F845e583b188B91D75528E1D21fb23595f2951",
    "0x4109492bD815c3dA90d77594bAB505204E827AA7",
    "0x4122970dfeC75D6Ef9acc8054062FFcc611c2059",
    "0x414723d4f305F1DCD71D72BACbb9988f7625eBb7",
    "0x414e06Dc809318419AF8d0BFc0C3Fc2FF4B057A1",
    "0x41707a1782Ba821Fa82C24e032b3b009aab1500e",
    "0x41760c66CB384900bE62E0c2Bfe94c6021E98B48",
    "0x41834D101ab1a0339b3dd6cC0dc922A28c8d4f6d",
    "0x418Cd73Af8131DC641c7A79147fF41741317f9a3",
    "0x41a7276167b80dA8815dF5b0DDABA3BE29984250",
    "0x41A990a03EDF9050AAfdb7C65C5B24463824cbBd",
    "0x41B2a1fF4f77618b9BE7c87A3920CAC4625A73d5",
    "0x41b36636D4799e896c2CDb43d195e6F133C74cF4",
    "0x41c007A724731D1fcb14C7FF113aF0bc1D66FE9F",
    "0x41D01ac97beE5d2C399f4A835249A539B7B4084a",
    "0x41d28fAb44e98b47021196C8B5d90d258eEEa33B",
    "0x41E72D30C967A595cC2c7dBc9e1Ed98638f3b8c8",
    "0x41eEB1d16aF2982B2C78DA2aFeC84d7924ef28E8",
    "0x41f97Ec0B18B45bD84e127eAEE5C3B85075DfbEF",
    "0x420f253087044b8BCf028dd89F8fe83Ba6275E84",
    "0x422842113A7cb4e4182e6D9E62b0Dbdf8F4A4BfB",
    "0x425DF61fE9ffE06fD0fF31c5A098386D978E67A3",
    "0x426fd10a9D2cB7D898Cafe3dEbf61D3c2177fE49",
    "0x428bb2cFe7941f395dCf02E5bdc8F40eb051ED89",
    "0x428FC0cD221ce8853107B324C67b48dDF39A9D06",
    "0x42a63047a1cD8449e3E70aDEB7363C4Ca01DB528",
    "0x42CEF12222672E260d275B80a0ED0BC40896af67",
    "0x42e0a92C15136d2Fa21E4b7491ae3aEE7A77bd63",
    "0x42e55A58184f925048976e4626828A2500e2Bb62",
    "0x42eA8f7153F5378EACDc999e5495791200194ffF",
    "0x42FDa1397040d527410Bf7773Ce4431C4f753860",
    "0x43098F5C9ae90f5132E14F2901A67Ff9Ef38a67d",
    "0x43343BD0657133880f57A2777683FC78B96E30C0",
    "0x43399e0016597EA209DA23997Ff4fD20BD1940Ec",
    "0x4348e22d0C8537b1d1A45889358F3916B74da6D7",
    "0x434dC72c727325165D58621D3Bb5b069a4a85DD5",
    "0x434F5325DdcdbBfcCE64bE2617c72c4Aa33Ec3E7",
    "0x4360076B45bF475c31cDa132B25e2920CE237f32",
    "0x436C51958435f9ccb7c9c0d25bF4FDa55EAF65a3",
    "0x438eB5b02a3b9dd3c093e6B50f9F031841E6A29F",
    "0x438Ee34BE7C6DeEFBDf0AFc21c0d5375b912E0d8",
    "0x4393194C599929Cd7EF2fFa602bE06df277cF656",
    "0x43A032eD1923365D2A42D558165651538174b53A",
    "0x440c409781aC2d42492097c175AB84ef4a120F27",
    "0x440C8AB91bA7C8763B3D9b3357DC1C0D13A148aa",
    "0x44200f8b25B0785b5eA3B1374FC4311998962beF",
    "0x44264b208419FbCF8053f9cD9f087B7225ab6bb1",
    "0x442FA40d64Ed28758E84e69aF827b9B2608D44c7",
    "0x44340F7dc53bF90363E503350bbEDf69e2D7870c",
    "0x4443D7adD1c6106e355dcf3b52Fa0DED6e0e9470",
    "0x444D8c45f0b889278B68eBA40a8e51b2b5971E1f",
    "0x445A554F8aBD431404df709bcD1547d9185Ef43D",
    "0x447B0a83297017b4dBa9e2eEC0aDCA4eDad9854c",
    "0x4483Ec4e5EFC1ff8dF2C9814400424E97f9Ad38C",
    "0x44e1D69a00bA0983191542Bef2E2334b60B92631",
    "0x4509df32Be599d1429d9837Dd396C65C4fCFF8A5",
    "0x4518344525d32415F3ebdA186bDB2C375D9443d6",
    "0x451Bf3e9ca2Fe8c9C13b39851035512dC222A688",
    "0x452A8281853E412eAF9538826f48dE00E166408e",
    "0x452a9b6432CD228410f01A1Da754449C8bAfc85a",
    "0x452C305368e03986c3664932fEd5DB9F61A6C9b0",
    "0x4542c7f838aDF5E9A6E65dD16D15F07e3A5E8dCa",
    "0x4548D498460599286CE29BAf9e6B775C19385227",
    "0x45492C6Bc6aB97e4320e6f844c560BE62737a303",
    "0x455060EE9390d4Cd24c0Ba0df50d905f085A553b",
    "0x456580b040808A70cc320A477a47e6Bb793fdB5A",
    "0x458A960B12c5883c5AD34bdeD8deb1eAAE1eEAa2",
    "0x459aad507447e9837fc6890903B5b5426C27D6f7",
    "0x459b23D1157ac73749D32Bd1e34b2582A0f02647",
    "0x45bA71B71BEEd8b8Af692ae6c1Bb0b9FeB6C4F1c",
    "0x45bD9F74eD9B14Bdd813878B242d643F3d41E3De",
    "0x45c0511a259422c1359e29b7BF887EE26386057a",
    "0x45c8BFbad744b1aCfedd0B7b121F1203da4249af",
    "0x45F29b4d9d8a77b31C5bd8f181DFB064Dc44999E",
    "0x460016a4286BF190DeBF204224aEea21B48EcC6B",
    "0x461f77EDC28B9BeA0aE1A09825F4c56fCBbcA222",
    "0x4629D3d098518c91746BBA7b9e1c245d7fD55232",
    "0x4644999247C5343F69306173C1C873341FA8a1E8",
    "0x468a5525D82a4b45E350250b85F906c5A1a86660",
    "0x468e334c8A768D3577bB4ed513E238271a754C1f",
    "0x469a0cc3B3B62C892140018B7A46f0A4068A528b",
    "0x46b4F6A816A1f246dDD8f63fB89f374E0Df43c36",
    "0x46bC4aAE45fEbA36Eb29eE91527dd9615911EeD6",
    "0x46DA3935580f0f735848F2d55E49Bf4E64Ca7e44",
    "0x46DDcFDD80F93b95EE129A437d0509988d1495c3",
    "0x46e7d5462bC35208a2D56aEf07F216408725Eae5",
    "0x46EA6aB1102e7D58F087b231b2d4FB1e8D50Eb36",
    "0x46f374Ac4a4E6779973812e051e72d9d6379e756",
    "0x470a825d434996EE56edE2DE66c8e695f455ce84",
    "0x4713aAE48823370EDB61c9cc3cC3D4F0bF17f2e5",
    "0x47196DACAf732Ef3D6502ce01fdf9b1dCE8C4a81",
    "0x47296a9C30F235e8Bf4b8e8C35Cd91F0dEa7928D",
    "0x472A8b5d59F277B5B6BafDD7f02e85Eebe855653",
    "0x474823BC4adDcc47fAd269d034be6c7550ED7689",
    "0x475b5E9AF5a27f105bD6f4Fd647B640A7BC57ab7",
    "0x476B091b57A659bdBB873F0B12137099D901B848",
    "0x476E349FB903A2462086B9628Aa0f4E22a3cb77F",
    "0x477A1e084693B0D63cB2d6417FA16D45fE8c0c96",
    "0x477CaC5794DADd08AbB243f7B5331A5160d950ef",
    "0x477f73F2a009598c21963cE4e49B58b6C2147f99",
    "0x47847a41F3664db48C4aBB6a01e66bDc0773Ad08",
    "0x478e2E52Ef1ffCa06629a3E8350C636a9bAb7363",
    "0x479403bB4e4bdeE21c921DD1DbE828d474f9A8c0",
    "0x479a8C29972a95a033Afeb0cefD4FE2C7fe9c434",
    "0x47a5142cf912e36D581f3FaE64072F8C38A059c0",
    "0x47a5a0d96a0f64fB6FC3a9bFa85bbAc3b9297edF",
    "0x47aD77C5a4f5A8771C4b9B4BfC5171242cCF7A9c",
    "0x47b78ACC6D29428F128Eb04B467D316e548e4B89",
    "0x47c7d32E4394DEe0C342fDAa5E1FDa0fF5EA1857",
    "0x47f5F7729388201cA0cd2b3D0D3cB52a85641DaA",
    "0x481305138b5da49D7828cf74f2827f67292286f3",
    "0x481421D95Ab38A53bC4c413F6C4CD1d93ab7E3a2",
    "0x48238FAa9bD6d56FB44a32Dac6185f04eAbF2117",
    "0x48412724E47D06d1337284e7eCE14a211475440B",
    "0x48418FcFe6dcC2f13265dc199296ba6a7eB910d9",
    "0x4844BB1A4116eD1d9371C02dbe51EEa81A7eBf07",
    "0x4848Fb248438314881722Fde5c66e4aac94634c7",
    "0x484Cc6BB4B6f05deEcdcf6D4d875226f59D58b39",
    "0x48513224a50C339d23484c9cd4A95DaB5a9e8862",
    "0x4852AB13321191F9542Ed47EcF06A65fA0a865b6",
    "0x4855aB3793269D7A69018037152FcB5876Ee3C88",
    "0x487C019824814fECe1bc15fb05fcFC29eE8e0984",
    "0x48A14e4627c69Af41c54294dAB6A5D66EAc45f13",
    "0x48a986d9235AaEF9296b6eC30756719dD8dC5B94",
    "0x48bDaE8D5dDa49F55863aE852BCA1bCEE9F42CE7",
    "0x48c04390C99C9881f7166b0728A34C1C24E49D56",
    "0x48cb2253e3a83bB312d9AE7797A3FcBE835b7C26",
    "0x48CbF621b0a8aC768f87907F384882200eE0Fb72",
    "0x48d80b0E3878cb183D853CDE9585439C56678d5A",
    "0x48E2F33cA34bb58B31ABE1e38623bB63B5320024",
    "0x48e6B9b91278A01C6b9a71458eF9FF397e4C70fC",
    "0x490a4FDc7a1A35B5C2C3e9418dcE793fCe027bb2",
    "0x4923fd6fd2961FF94CeDCB3AbDAC5361fe11B924",
    "0x49278Bf51ead6BCBa7007C80ACc42757Cc14807A",
    "0x492A62ebf6fF9482a6dc4d2f2fD0410860063133",
    "0x493D46b7414035EE82d729b6868f672fBb1955bB",
    "0x493f8B2972C13181a82C3a2ceCc08ECF501a1554",
    "0x4950EEc04AE5ECc5de1aCbCbcAB8b3e2448e4FE8",
    "0x49519846D5D442B751eD78E46d7F8DA867Ccd07b",
    "0x4956D7d567dD724CE9A52CC3848410fABb2549DB",
    "0x49691b8A354055f14b0bEf9d842519140DFFbe2f",
    "0x4980609F4feA2990CE1E637a180Ab2C3a70FCd3b",
    "0x498dE87f620f9dB59604dCC2EDC5aB7E7639baa2",
    "0x499b38bf2bd273f49811558c0E1e63BE8Ef2dEDF",
    "0x49A3Cd0EEC5740707C8a2d5BAF40335EE2Da0b1E",
    "0x49A99651a06e2A2fD104668a95caD4e3C88ca5f6",
    "0x49DfE490C49b15625F98c543Fd55e8A2fE5fA5C2",
    "0x49E8C4Bd3A23890dC799151dF287BC053c98CC39",
    "0x49EEAf219A72493b4060debA1027C77F20090103",
    "0x49fa32B38B628Da76f5C9A12820cAfA01c2dbc1e",
    "0x4A0b1D10F2AEBc8B4a901e04280e9a22EDaB66eb",
    "0x4a287A601Cf17A817fd764348cB0190cac68fbD1",
    "0x4A2Bc6F59948174714657735Af944261ceDDf67A",
    "0x4A358b43b40D47d9e64f21930e203E2d555F323b",
    "0x4a47096E0dDD4EEd05eF00f0F081bc7700c6DD75",
    "0x4A4B5b9137ceEc2d41B45Cde142ECAaC6848d11E",
    "0x4A52d83c82C0fFd809aa2a24Fa9E1949033E14c5",
    "0x4A638eD6A062da65f853b88FA74A2e8FE44a3eAc",
    "0x4a73d88EdC19C37fb08C6014C6e83aCBeef3BeA9",
    "0x4A8a1D875587780aC11C21Dba479BcbDdA794b21",
    "0x4a8bB779AF30c867AF09b33E3C5CdE60Ce893597",
    "0x4A9A3c6fD50E90197945C28E7FbDdd02cD584579",
    "0x4aa537397A13b8b78efd358688c220727824f5B0",
    "0x4aB16A42C6d06AED8bF46911267c40aFc37e2270",
    "0x4ab7ab1332c11A20435ab044166089f09316aF5C",
    "0x4Ac33D1A4DE450D939CD10D3978679B71e1106B1",
    "0x4AC37Db1365235EBcAB7a904b209242b08046551",
    "0x4aCeB0ddcCbb7467A2b88716bCC194E617F17487",
    "0x4aeA936C8d7834931320ED1363f8689C12040Bdb",
    "0x4b038c047f79e0cFd3762b9e8b4cb017709315Fa",
    "0x4B096aBcE002e4019db2e6bd583212648A55E2a6",
    "0x4b1a8Cbc40C4729FA97AcD276502A846C6924Ae2",
    "0x4B1f0656A527D5164B968B86A6F30d6623aCc24f",
    "0x4B2C1Ce6A01981dC3Ee79825bdC3f3cD7932bF11",
    "0x4B2eb1cEca3c1Ed5f647fd53c58095BD5ecfdEDf",
    "0x4B434fA4Ed11Fc60d98d035302b4D06e2ADBe98c",
    "0x4b4a0721Fb34579c7C18AA6A41a449492392aF74",
    "0x4b4d75b8B0Fc7528EA2614b2Ca83555824C07867",
    "0x4B6760682191DE7e476b801b7AB42d8E8A5b041a",
    "0x4b7C7835f3758897e4DD6f7869E4A17168270535",
    "0x4b8474CE08aFCBF361f230e691347d70f0A01421",
    "0x4BC728C87E50DBAF98110A7ACA1D1c5F23a454f5",
    "0x4bD047CA72fa05F0B89ad08FE5Ba5ccdC07DFFBF",
    "0x4bD053E73964e0ec4A35333F3b11063b1a671354",
    "0x4BD30c1D2FD25ccf8fc0a539d8ca743a291dBbaC",
    "0x4BD9869c842e06B2F459fbd6b9C6f8BD5753a6ab",
    "0x4bdc1Cad2D045eC17955688D0FeFeb99A385C30f",
    "0x4BE25D7B12a5Ee2F06e94bc579D66C700a6bd7Ac",
    "0x4Be97cc17Cf50719fb1fde39c9eE062B16074226",
    "0x4BEbEe25eE72A33b850245119f068e2063253953",
    "0x4Bf09B973098514540B505fd2Af2AEB3aE01555f",
    "0x4bff9B3edE66c6dAf42D6DeaE4C784c520Ce5Ac1",
    "0x4c00f62943546975354d3460D1759189460B44E7",
    "0x4C081ffE5BbEc171AEE06C1aCB4d3D53D94Cd800",
    "0x4C0a04ec368DFCa5B0BE0EaCb30378F3eeD4fa07",
    "0x4C0D1Ea8a7F7BC2d74ca4E6cCBeFC97CAED8A2f5",
    "0x4C2301F1c755316cebfa24EA95c2eC3668f677D6",
    "0x4C500987d0a1229614E2e03045796Ed33f9F473d",
    "0x4c6644676912ef317c675BA9A1fCB9fd7D4C147E",
    "0x4C775fCDE221a18c82499CA73058E3055373ffb6",
    "0x4c89db12A2DBC077c41100df96f40DC858Ed82aB",
    "0x4C94079E64d1C6D6B8Fc5ee0Ce7DCc9B80204453",
    "0x4c9aE350170b2F86d42Ce90435C7B1b6a31BeD80",
    "0x4ca6753141D6a7FD5a4Dd388035C3A209e93482C",
    "0x4CD2c410884eE586A8E6418712613F3077aAE7b5",
    "0x4cD4Bc363458b52380d695b5c923b8994A245281",
    "0x4ce4fe1B35F11a428DD36A78C56Cb8Cc755f8847",
    "0x4Cea855bF56a1A9aBCB3cCAC6e940b8c0c792480",
    "0x4CeF296b64923D690f04AcA018FAC3228F2f71E8",
    "0x4cF23C44432Fc4a0A0aaAf75D33bC8e18266029B",
    "0x4cfcC0823cF6729d593c2316B9e43B967B38C835",
    "0x4CFe698F946d323C371fDa7072922AAd90684729",
    "0x4d03AC76391efFcA55Af8591fd15ca06F0Fc9d36",
    "0x4D1a68909DDf6B40D08a34F42375226e74891f39",
    "0x4D3f9F513FC366Aa075e53B592dCE9c14BF838A6",
    "0x4D438c2d71657F395EDb01F5a862fFA7a03E6a9d",
    "0x4d44058Cf7c05eDd65AAd6135cC5F58cC4eEf7E6",
    "0x4d6438d510A3CB3C8Ec5d068C01e6c032BD44580",
    "0x4d72Dbd59D76be47F1e9085842B7ECa875644858",
    "0x4d76A3344314437B67152Feabce42a7f87e21056",
    "0x4d7827cd0d10bf4cF4577D9Ede9Fbe7d668Ac2d3",
    "0x4D80EAd847473e1F35B394eBbA39d250ec1f198f",
    "0x4D91146723053ca2a68B4fa35d658e5424E9b1C2",
    "0x4DAF1f3e75D724ee09871A8464DC67e294997c53",
    "0x4Db20f4db88149604908cE397E27714D51515255",
    "0x4DE76C2fD006F3c9Ef7f69E5d6505509E79235AF",
    "0x4dEf29DA0614a4fB3155DeA7984f37c2b99b1d8D",
    "0x4df14bcE10A5eC2E051DF9088a88f8d69D67d5F4",
    "0x4DF7652d2cEBa7B83f0d7C42222B846cB7F77d31",
    "0x4e1829da30CD7ae2F3E9915cB8C9f3F203ac7D83",
    "0x4e1aE89A46DD4c053a67365BcDC982e3b0eB847a",
    "0x4e27Bd77cB1CbaA828183Aaa2b9199926BECFeA3",
    "0x4e2bAc070EAF8f33a16f820C09aCC0F5f78a53C0",
    "0x4E2D315F003Bf04034b25d7DD8ab696b4656b5BB",
    "0x4e3cc03eb2be6122f2316B84d1c7eDb900e90dba",
    "0x4e5408ec8568c0a8AE6D72Eb7a997B3c399E2ddC",
    "0x4E892CF677132A8E41082319755b82f4827baB1D",
    "0x4E8b57bd419606f6D4B278bb0320f7B87445564A",
    "0x4e8F1cf9a9dDCAdeE3340daDA2CbA5508D340B4E",
    "0x4E97390482B9C42e493D15766E05c6F0264cBCDd",
    "0x4eB8B1C77b90a228c8047Aa72297C7D63e977F85",
    "0x4eBaEbbdC8348AFd34FCFd03c0aAC3955dE378F7",
    "0x4EdAC4B8614d3E856C142Bdb4AEdA56e9e3B1702",
    "0x4ede990B824e882Ec3A6BacDDcb1442e5cda492b",
    "0x4eeCEd60EAAe5573D2638077ffc3cFe72916E980",
    "0x4eF82013e07Abb416c943Cb18fCF363EcB304307",
    "0x4f08620c53f2B92FCA61c78EE502Ad50CCecb10D",
    "0x4F0F30738f6d17aF9b6EAc991A7B090B22F3d58C",
    "0x4F44098Da72450AC90c9fDf99a64bd2282387715",
    "0x4F5be5965B760891523246A668cF86FD3648d19C",
    "0x4F5c18517BB0A4E5DF555F075F7c247a11c896Cc",
    "0x4f5C91F6829557F43FDe6b4f04Fc09a511edF254",
    "0x4f5d82931fe09cA1C1aC67C602C55e5FEDDF0E98",
    "0x4f6641870a64537cf0cFb65772907EA9fC23662c",
    "0x4f8824299193A01Eeb21fC611214154ebd08e220",
    "0x4fd53436b293d56C554Ab52B16C957D5960E3A08",
    "0x4fD7b6dBEd019E893c6cE90B0A5019Dd9e021954",
    "0x4Fd7dc99CE0d27549123056783E016C133398979",
    "0x4fF58aa474E17E7FCF0cFb1521DBa9aC2a49b660",
    "0x4fF7DA4453957e92214823DD6F2ca28e364E6Dd9",
    "0x4fF992F801A4B363BfF45961F87859777646638c",
    "0x4ff9a913506DBdd385a3dc7e79e0FD5B609395ed",
    "0x5002479748805Ce20A44De8d4D08386D6F7085Cf",
    "0x500E91aCA8cFe3e541Aa47fafcd85a65bCB860F8",
    "0x500f2E800003f7f33E1edc76E3AE89b591f432a6",
    "0x500F5902DE7037839c61e240549DdCfca55c657e",
    "0x501207997CFfb8066757c230fF50d459d91ad550",
    "0x501C7A84D077F35885018C4328C15915cE5d9EeB",
    "0x503fDA5d6E301441378E7975789c35E5CE510392",
    "0x505162805Ff4c3E4df28a55fE9D592DF9A3496DA",
    "0x50533d8B5363d84dBa0df228FBeE4346Ed2a5A7d",
    "0x505edA84325177bfD0f2cc1B8adE81863051574b",
    "0x506b613BB2FaD39107BA14cC86A46a4c1246A77d",
    "0x508aaBA361F7531ea048B6d8672D9e9918B96222",
    "0x5097127F35f22361cE7873304D20D14EBD78d2da",
    "0x50a9F0F42eCDe1df805B1BA6E885881aCcEf049e",
    "0x50C25A4f9D19C8F704F2e5d77C00f9cBE6dbb357",
    "0x50c9594912a58c5b89416B3Ab3f6f5Df1953B30C",
    "0x50D09f1c64308095c78B0cC08401F6b369Be5090",
    "0x50D2D7c34FB82d94502a2A7992376513C00C91ba",
    "0x50F296BA8331bf68ba84f55E4Ff31a0a78B53D61",
    "0x512EDd5e89ac95BFe02F328ce4792348318D5566",
    "0x5136e623126D3572933FBAfe59AE97f13DD9687A",
    "0x51409ae99b1A590DB3Da053Acf822F45F4D7684f",
    "0x514368a3dfB523Dd8E0E049d9b22E20eEc96eaF7",
    "0x5147d471643A0e5f47e4Cc8C3943b6d10B380740",
    "0x514b1861561Fddf86baF8462e001a1584e1b7b83",
    "0x514DE773287f7e875cdE5793f147d1F6EcA16e07",
    "0x51979aB051FbcD728c8778a2eD974e1608B16421",
    "0x51C2b596099D5A888c81A9067CC447258299aa19",
    "0x51e6f5560C7aC0ab63FA4E0f77375172D6775Ab5",
    "0x51Ec8BB228AF8Aed84d935e0CbED0FDb3Fc39114",
    "0x5239C74b6DBEA48D59C3ab064B0Aa07708491660",
    "0x525B8Ecd160B60A2A08C4880DFa2a4A3858c0b41",
    "0x525f4D5448983043DAabC08BBBAC56a82ae03D24",
    "0x52c3bB96451b97861f3CB89C6C86FF0A90170afc",
    "0x52d20CBb17DC2c4512a1811C08D1800295593298",
    "0x52d53E394a5FA689359dE855aA0ABcEe4D8921bb",
    "0x52d7e31678d712ee8C15Ca5Af10baBC257E5b61a",
    "0x52d95190b0fA453F9E7D348e9313EDE5B9B618e7",
    "0x52E3C3A6036C5f8752769E211F3f6A9377Ce0F9d",
    "0x52e5b829D93a0D37b47b737c562D9626c9B4c592",
    "0x53212897CFfCdF93d130b9B2d48e849Fa6366179",
    "0x532a2707D598d7Ae6B02eF0e0BA897DaF44b1603",
    "0x532c542c58063d0C5e6a1B5c9C2349A08f6260D1",
    "0x533Dee7F5e471B34ce9EC908F6c010dc2A160413",
    "0x536D83e66759cCeb0d3b5D6b70D61696404ead7d",
    "0x5396302DBEd6aFaC9E1F8666679bb2D0Ca1cb2ad",
    "0x539DbC6EdeA8a2395b6870432EE3bEc592833593",
    "0x53AA42F2B1965CB283F48dCeEb5647F53041Fd08",
    "0x53E12E3DfE5769A53d85955bDc12553255EfD4DC",
    "0x53f1E1B37CbB1e01c760d407ef3365E87bf58C4a",
    "0x54087B533Bd73faAb18e3a699197960c720B821D",
    "0x5415ff788e70432aB3b045e9494167A5e7f47Ee0",
    "0x5419c2900b238447848BfB16C6fAB7C3C7143518",
    "0x542Ab9cD75F8cAC70E5ae6aF1b8FcbeCaa4A26C0",
    "0x546F236713ffBA75C81EBF3CA3D8E77ef81be125",
    "0x5481032eCC006eBDDC39e478b9544bA04eD8C2af",
    "0x54913CC8EA17731d62589039dd0152f306473843",
    "0x549B95d1c457eD4F04B61a7F4a0d251606BD255c",
    "0x54BAe794b6dDa32A5379F091AfdF5bab0E37B664",
    "0x54BE3B98564f0A89237fF10D5c7A053EDf2aF10C",
    "0x54C21947379816A8A817019D8530BF6598B48447",
    "0x54c2FD49CDAc0B26422b9cb34Cc301D6b3cE549f",
    "0x54c3b55e28aCeFB7f138e11ea719065e02BB6859",
    "0x54Ca2155b9cd7f5937A6087A39C55682193E42E1",
    "0x54Cb5138bFE9E89445aCe9B6CDFf739f9e3dc2D0",
    "0x54dA2a70951d4ff732E3dBfeC1253A166f39D453",
    "0x54E3305977C2B06F16D820439b3727798CD7d928",
    "0x54Ef37d1A6Bb72749C02B78CC7bEd8E7302458Dd",
    "0x54F2DB65D9B24B140e80793a49752d57fe8ceb0E",
    "0x54FA5a1B8bf0692358625a8a2daFA506fEC2D41f",
    "0x550Ba6951D29D96ac74094C8aeeD395958d3A575",
    "0x550e970E31A45b06dF01a00b1C89A478D4d5e00A",
    "0x550f8023B2775fb04F1620ec051bc01e99506fD2",
    "0x5523337036e5610FC70B358D81Eb437DbFD6bcfd",
    "0x5539E1aec36818a37374DeE99B76E37381AFC1b5",
    "0x5541a76398948b3C67b134f33b7C359D30552120",
    "0x55aFD0eb88d70D323062195A927e5bC2Bd8182cD",
    "0x55Beb60BD04c8aFF031Ae80037DB9C45CEAf0702",
    "0x55d4a9e5cDE6Fbe40991e7570E01899891F6B0D2",
    "0x55d9A171Ffc88F39d45FFfD6893A2207493699a2",
    "0x55E9Bf66235fb1461e5D8D7216f1a4BdBE85824f",
    "0x55F1933BE884AC1db887977Ee8C21d3d25e7c437",
    "0x5600B5cBe337e90c2d5094e4cd10e60cbbEDB8f8",
    "0x56172E26Aee752157EE99a3732168942B7aeE956",
    "0x561bcaBEDeF2520a371CD0DDeAa388F4F88Aa628",
    "0x5629A1A7509162FC3C07C30cF5Cfe19b33920CA1",
    "0x56352e57670725458660d87bDb0CE7aEa763b224",
    "0x5637E119eE90f803744F03f00f30A71551805B60",
    "0x563A2B808897e9777a55f6c7E2a1F68638C00738",
    "0x564061CA75417B2d8895d86F9C2a646710537375",
    "0x5641519cc28DeF80D631BaA28b949F17A6A22AD1",
    "0x564cedCB979e2FdCB6659A1c8c61C585702654f0",
    "0x564DdBB3Db5AA039aB17474Dde937d22C98CE14F",
    "0x564E9cB9cc961E0CCE8fb0c8B67BcE212846B56f",
    "0x56662af7e6742b18f49bdAF630c2F02f642f8815",
    "0x56706F118e42AE069F20c5636141B844D1324AE1",
    "0x567B3e7d62c71b0c1E689e3219Dc5c7f4e127d23",
    "0x56A82d5Fe734f7F911159Cf3648049f765f3A79e",
    "0x56B5823cd02C37dcBA1F858035e7857C571aCbA1",
    "0x56C31C02e723277750739f04963610bDC53Ccde3",
    "0x56d90629aA29830e361E113e53a979F95AfE93c1",
    "0x57217aaD5b8245176729Dbf7527E51B429C91210",
    "0x57369b8f816FeE193A710AB71CEfA824D2E78676",
    "0x5747152D8ab1951a97BA4b8818dfA5292faFe576",
    "0x57506ec35182DB7C4EF3E982ddAA788d5BAac2D9",
    "0x57588d1FdA7C9D5e463b3b49CDc7bEC05D4Ad569",
    "0x5759089d0a7877b95C52990e27D1c820b2Ab4115",
    "0x575963f8770b87b058fD3C49652f05902b25C0E5",
    "0x575d39D1833F61251f7c797169a840D767B64ccF",
    "0x576fc18cd99B19a6a98C9A0690D5d56fA26AC2CE",
    "0x57731093B27990129f15b5E4E9ac2D7003C63e1F",
    "0x57890bA260FD74aE8a68fAFdd62d3FA6D2dA271F",
    "0x57931dfB66D7D6f9D326B8Ed8aA0d5B69C047c65",
    "0x5798ab8F2E53a2381937A2e5Ffb96111a6fd0342",
    "0x579CEC7ED45876C75BDEA68cbAA589137de79580",
    "0x57B1415c4aff6A4Aeba78875aB489aB4Dae32e4a",
    "0x57B2F2FcB39E5584962932d81B6BB4757Ab23D21",
    "0x57B2fFB827AEb96c115c27B18BcfD1d6f7832659",
    "0x57D10AbFc62660BC5F4d0EB19282C1fF8B5B47a3",
    "0x57F02141F2D91a024032536EC61c974bE76eB7c9",
    "0x5819b0C037c526C94bA2Ac65AA9A5995138957FB",
    "0x5823497fBb418A0734Ac71f555f82FF8025b5EBc",
    "0x583373671d78679679156b9dA1a0278dBcBfE5fa",
    "0x58400fD888d80121Bf172E3F0e6C3fcA75F75f06",
    "0x5840DA4d1167c7097333D72E8cBE5730bC3E93D2",
    "0x584d3EE5d789B013ea854D2AE67639DEAcc72E33",
    "0x58541D9BF7D750615421fc37d77721d8F9147771",
    "0x58578515d335599140b5aaE25DFc7f31a425537F",
    "0x5858dd0e9C74cace80268978A5DfcB16f08CbB7A",
    "0x5873cD2414Ed6F6998131bF2d0c3ab2E1B6B083e",
    "0x58866b1b9a57686E12C9C153A7C5E957512634fB",
    "0x588a10E447CDe87E3ccd5C3aF42C2E746745f97C",
    "0x58906aCB962b3FE294A282BeC15ba079BDa43aE6",
    "0x5897c15F308Eb2BC77612597fEeB59125e3EA21D",
    "0x58B3EB75B8390bAdC945312ab1d594AA947577aD",
    "0x58DF814eE01dBd0DA41893e7C64B6157273D6cBd",
    "0x5910b1e1086CF0B197278603Eee38E7fb21c190b",
    "0x59275149EE03AC34f8a94Ea9063359BaD5527a78",
    "0x5928b3F86c8B6d18481D1aaD7D82aB96bA057f93",
    "0x59432168f899D62aEa05ac53c654494C49f7B481",
    "0x5953d09760a45E876Ebf7075F1883A54a4Ee78Cb",
    "0x596f9EBf6d8BD9173217Ca8E63fe02d361305610",
    "0x598249E41AFBA9A8Ef39165C7d24a55Df258e363",
    "0x598BD1C00191df70071eD2DceAe04f818bee741D",
    "0x598E45f3a603e5eB4d4Da101ef972909987FCB56",
    "0x599013a9163eda3cf399f839c09a85e5EaAFb393",
    "0x59A4Ddf81c1C7624c57975B8861b89e4E8a5c65E",
    "0x59a6FebEafD5FAF543033377b879D0f9f513F52D",
    "0x59d56536f4bD5617f9EED7285c730c904C3f92E7",
    "0x59D9fFa5938f357cFEb36968dDfE1bc99cD3c64f",
    "0x59fc1c116dE336527302460f86d08E6c98Fc9076",
    "0x59Fd19aB7dACeB71aCe6088B6D8F01565d32552C",
    "0x5a0DCDC820576D3981DAD4845172FF9ab80ec1F4",
    "0x5a14bf00C0f9e0D689d3B683e7C3645eb74dc41c",
    "0x5a28b7c456Bbbfc72f5341805c0cb1c6cc9755Ec",
    "0x5a302906ce489e27eF16A3610F7F783a3d07f429",
    "0x5A3CA41b64a3fF6b6775699641f483B68acbFecB",
    "0x5a4bD20DE24DfF1172f234eeA547959B59555170",
    "0x5A580B35393cfDC34F98F01C4EdF70eF66502238",
    "0x5A5E7EAFCDCf7d225B8d5EC42E9b95E6ED6293F5",
    "0x5A6D5008034f0C2e243d5538D3B77AF1E0c021FC",
    "0x5a995a7797a3e9bE9EeB2d0CBe042873A58783c1",
    "0x5aa71418Ac6238c78eA9A032a768DBbbf86bFecA",
    "0x5aB3950ee70940e5b69E3ED7C093E30521aE35Ad",
    "0x5Ac1B39E020594d69148223d7C79962E8963A007",
    "0x5AE38235d4E6Fca3D874B297A8ce4d17F379B970",
    "0x5ae7d1C67Bb65751379c895E74ae9A8bdd71d8d2",
    "0x5AF175188c4D297c808D043749151D8B0878E2e7",
    "0x5b08aFeDE4459f01B1593eA06F8365f3b49a40dd",
    "0x5B1022D859A46f42fcF24BCD8F5Ab616e52B4800",
    "0x5B1E9298509Bb9d25dcb81Cc1E0E898d6C860A92",
    "0x5B22B6bCB70BBDC110B9F4039553f6F4d4b83F81",
    "0x5b2e99156f553d7A364DB873AfC81ba06c4d696c",
    "0x5B34D7917840fAC7E91973ABdD5647AE5EeCCbAA",
    "0x5b3C2035F87ECd710D363A8C9C982f53259c6edD",
    "0x5b40AfE0a6EEcb07e567F49b960f0a9D80120c9c",
    "0x5b4B3f47A9762bE825A565bBCf0FC72F089598FB",
    "0x5b58AEEbafE359fE5B19Ae3B41048Ab859f4Bc87",
    "0x5bB1396E3EC5E31E12DC7846c4c94eea25083f35",
    "0x5bb504E6f93E19C806d19083a8EC31d0D1e16856",
    "0x5bc80040Ac6ab2c108d10A0aa0b995cEE7BDA110",
    "0x5bc926e531431B5A1A0f26e2dD4A7aA8f322B1Ce",
    "0x5BcB19e354d0e59f7EC7393647F9317aBaE6F2b3",
    "0x5Bce6aa69D23Cc7955355bDa809fdBf1E96692f1",
    "0x5be51F8fe19aF2543828A241E7555889a2aC9532",
    "0x5bF064A666C833B9b82eaBCb5347eaE64508D686",
    "0x5C04C0acF5A182f8Fd189f7fA4E99b85980fBB4E",
    "0x5c3cF56bB0bDDE6Fbe9309cA2aDa7B58dba7bfF5",
    "0x5C49e7d1aEde9224853482E3D8296e21912F3DEa",
    "0x5c4A64aBD18C714BdE447BF32a8A34eDD3b63e25",
    "0x5c5880494cDB869489f1cF715FaD6036e38a8C6D",
    "0x5c62cFe64084Cb1e8B111002D91A05515f497123",
    "0x5C7fE032ABAa8980731cB088F9e12990dc6B43A7",
    "0x5CA37299a257fD577A580f00dfe3C8D27dC336AC",
    "0x5cA5BeBCAFBE6741e5439B431dA166423f8005D8",
    "0x5CAc404D11250cD241B719487f47e3D720873CFD",
    "0x5CAFe583E50f17Ba6b964ce41218b6d1B96814Ce",
    "0x5cbB7DFBA188b899Adb96025cCafd99344698256",
    "0x5CbcA85A8086031c47d69eEa21D0d0613E40631A",
    "0x5CbF4E79985AF4f11142e0Fe3a633DD0E89F7844",
    "0x5CD62f40F4Cf66B6ec9f5144ebd5263D2906d5d6",
    "0x5Ce1c68C6DE53436dBaA46CE62F2a0FfA704fa2D",
    "0x5cE65d8AfBbF2d8fFC86aDc1a4D55E76896D8E6a",
    "0x5cF3870CE4A79c792F721DE5c73e62321C166370",
    "0x5d054491bF455701D266Fc2088c7AfE3DB267b97",
    "0x5D0D6f4B0c2a7f8d912fAC16d4e16E9C92c93244",
    "0x5D1d88bd5f7FA853e9b6342AF4A73e763AaD672F",
    "0x5D2675cB3556C18e525482Fa66b32B33570e3b05",
    "0x5D278514aE4591F7ee747472116880497f4F63a4",
    "0x5d7AB9f48826d8720669513FaA02a8FDeE6347F9",
    "0x5d86E77C2921C577ec0aAD66A78B3FAF8a3B66Af",
    "0x5D89737E854c860d25E106C498c6DCA0B516eD7a",
    "0x5D904C98DF910e30516A3520D7Ef4B601B73Bf96",
    "0x5DbD17D94Ec5A92Eeb3ff62b6BD10E5792be562d",
    "0x5dD998D43F593820E88A6D0aA0a4d4F98A183FE9",
    "0x5dDDE47d3685362aaC7a0DbF3Bd79cFeF112E449",
    "0x5E1a08DA23585ED4957eE22c6FFF51a7d8A2262b",
    "0x5E1e61869762f480EDa6Eb7f98D7F1c2A8e9c646",
    "0x5E310971C4315FA0570f181CEBA2502c339708f3",
    "0x5e6Cd64D579a86a382F47F6035FB2D0F9a212CEb",
    "0x5E6D9885A453cfa57edDdAAE02f1e2f67edE6BD8",
    "0x5e7DA01B81644F9Ad8F7760EB13188a7b6BDb9Ff",
    "0x5E93781e8BAc02c42D1Efb9C80c7b9962ca66215",
    "0x5e97D7D8B1266Fb27220EEc60BFB342705585dBA",
    "0x5E9cD215CE51d819Cc8A27C52B02CaaE6F7F4965",
    "0x5eAd4912D565497607774FF2109C6E49eCbe145d",
    "0x5eb83a9cD7C34D8251A3D9be129002CF30706FFd",
    "0x5ec054B3dab5e84C851f2eaCBf9F58bb64dAAC01",
    "0x5eDA7c43F5Fc4Fd2fE3a3b957Eb2A7f8dE6970a7",
    "0x5ee8dB10ca8F35b8BD8720CF9001fE950114c0Ed",
    "0x5ef86dA9Ed0FC7B54D0cd96b767F2891373718A5",
    "0x5EfF35D620168bd496B39243FEe0aFdc593E972c",
    "0x5f04970308B174d5958aC72758f992522019604f",
    "0x5f0bD06A71E038206ef3e5090eB448E9a9773772",
    "0x5F1A4100cC68bbe706f37f39755C6e3a1CF999d6",
    "0x5f1CEb134b8C4eecb4020E3270f6D86ccf41006F",
    "0x5F23f3f76FDB9cb3Cd7BEfFA8a3e8387e9F217b0",
    "0x5f27528d9347F140bDd0314a9cf1236059f019D3",
    "0x5F2ada0a1CfC9dD8996CF4BE20B83edC9D88a5CF",
    "0x5f453EE6422c55eE6Bd59d38d9e470372F641470",
    "0x5f4934fC98EaE6061a01868A4700c53C1Ffb7d2E",
    "0x5F4973F3B49d42518e504dDA938BF71A791b5E48",
    "0x5f5b4905162157Cc51C9D14582003D9EC4fFc285",
    "0x5F9064158CdD8EF4Ae2dC745DD4E32b704006499",
    "0x5F93533F1D44ed10D2d420DCcc796844eB13d54c",
    "0x5f97d69976213A988Cc10135D62f257f4123E67d",
    "0x5FA9633B2b792aF58e8Cd1977Fa5E8BF7B861265",
    "0x5FCb81485BDFdEA5628C8BAD85771e4687185aE9",
    "0x5FcBd7aDe703F85DcE53a2D4c0287E36f8146bC7",
    "0x5fe9CFa5cFECDC333eb102d219B4e77EAcdE9828",
    "0x5FF25a3a6E25FE15EB62A251F177c11548633950",
    "0x6000A3D7B07dC0E8f6dCC60f5d9A2e9ca7609A57",
    "0x600c33790DF27499f094b181124DF8358C4d41aA",
    "0x60256530d074465406Df460B6f38424ab5dF6BED",
    "0x6038Eb97aE74BB37eEFBA2f01aaF548B3a77eE55",
    "0x606f1C2D1d21Db97615e7f6b9cE2bAb571226dDb",
    "0x607F80309a94Aec9bBB5A2F6Da2C1329BD68e33E",
    "0x60aCEFE9F2CBc74a30b331CFD6cBA5B84b2B9c0f",
    "0x60b313Fde908e253f5Ff47e77559610bA5731192",
    "0x60BaAd9a95237615cD839Da702C1A1c3e8eb0206",
    "0x60bf3d8Bf157AFD5e676993e1f49830cB340ba79",
    "0x60CEfED88d2C4ED372B1a7021a38f67fc064a089",
    "0x60DD3E47c9912ba1D1ceC3433854448909Aa8696",
    "0x60dE10aD37530AFf56ce767537e458B308a1F178",
    "0x60E87579EAeEAD5Cac2EC8092FE1986F96C89599",
    "0x60f55D4b354878205F15eB2804653C696f4Dc8bf",
    "0x6117F03a746a58653Dd3988d8b742A2008b58D50",
    "0x61273afB2465956d2509c94590d235548525Fe4A",
    "0x613e177Cbfa57216adf4e045a69C23F7192830A3",
    "0x61668574739133189b9925eE70A00a224ca23fCc",
    "0x616da26b323f8331381Db45b75Df509F3a1BF30D",
    "0x618be0C21D21dDFb660e0e3E1D90c5DdC3542a8f",
    "0x61947Dc508A76D275DEaC048f2C657e6C3db2214",
    "0x6199B45af9d33B3de4a63ee4d82DC9Ba2E1d6700",
    "0x61A2D5564905D04D3D426A8Ef11Cf3b5686ee08A",
    "0x61Ab0889964502593ecb221A607Caf9c6436EB96",
    "0x61bf1D383fa0B592A55F16712F35EDdCC8028953",
    "0x61Cb50A97330d9a659ba64D81eA753F9ba64320b",
    "0x61d840289bED0884BB7c440947c913482a949bee",
    "0x61DC881Df155Cc9Fd9ef72f39fA4E7cD3b8d7548",
    "0x61e2ee7D23446b5263D735f2Ad58d97904676720",
    "0x61e613F27b8B48144fbf93DFdBcC5B2BEa6eb7DD",
    "0x61F1EebEa0afeAf8E0BE485Adb1b88c2065bfB63",
    "0x61F3e2eBb6D62A2C659d1db83A33de84Ff143Abf",
    "0x61Fc0b93198247731c06f7c58cdCD1d925f4B1F4",
    "0x621B94D60d0fA4864d05B1375bAaFB44918377Ed",
    "0x62235d5023f9b80C800c67664a30c8E1eeDd7300",
    "0x6242BbbeB7c957375F7b1199279e321d6ea16d91",
    "0x62479DB01B770366E17F266C61801F77db55F20e",
    "0x624EbbE9e396CC412b30eE2aaf2f57E291F964e8",
    "0x624f0CA8b6f81e280B46433513995099853cae7F",
    "0x626627285b80BB964170089D7cB8387790c0d74D",
    "0x6288e5affd1506dFb79540d861D3292DdEf9aD31",
    "0x62957514004EA4b8cb6B291E62424652a52A79E6",
    "0x629EF815c885c7553006C92c2e99FAa87d803E57",
    "0x62a9Fa78Bb8C00Ee657E17c138A8724BB92E293D",
    "0x62Abb2D58C897B1C148C42355DEFb714efC34E45",
    "0x62ACc475F68254941e923958Fcad78e10A4CfF06",
    "0x62BD497eB497fb3816eDB2cb23A294B95e0f9bcc",
    "0x62cd642AC4784Cd51d9e6d7AC86CEa05ce99f0DD",
    "0x62D9B31F63a078042Eb9Ff236B5a02c6F6D07625",
    "0x62E1e7c35f951C07C7cF38a6D49f0Bb0B9D61207",
    "0x62FC4b48C9a62b0Ff41965C14dB8541194b1Dd98",
    "0x631cD42EB1063D1FE2b49A78744f3094702eDbaB",
    "0x632463e42b3bD9Be625F6008934Fc2770FCdE2C3",
    "0x633f6c7E25eE757d12643A32cE1586AC9e8542d5",
    "0x63422Bc74f9E63E634936C561fc71aB711CB6E0c",
    "0x6345AbDf2272674EA22184A99287088A0a2fb7cE",
    "0x6350eA26075220490324255CD8AE2d2538588796",
    "0x6359d66Fe2c49843D63B36fc26a62b0522f9a618",
    "0x6361875556e01fa0ED9c02783AfC525e94782Bb3",
    "0x63670Ad99a6C3cB016dC8018D94cb55e97872905",
    "0x6381A0e9B2a472bDEc08Bf4524E3C5Ef576925C0",
    "0x6382B30B9E7A5463f9922386C9F7f650EDd1c2B8",
    "0x63A408841957Ad506a480C62A34d88C451CC6f0e",
    "0x63a4418fb69a444dB3e92E74b2AE06CB25a51eb3",
    "0x63a9dbCe75413036B2B778E670aaBd4493aAF9F3",
    "0x63B809C503eEDA3144f4a387892ACd6592186E47",
    "0x63d9fFc4683DBD957cA16b7Ba4982338e9724060",
    "0x63e0E8A3A9C59141843Cc26E5433507B8A835999",
    "0x63ED3a494C64744404a1d779d2Ba55E18C6c4738",
    "0x6405724f9410dE624e7EEfb8FE80Dfc45d3c5545",
    "0x64243676d5022E420D6C81e4217EAc754303FC0d",
    "0x644a5f6a5608Fac1db358Ff711a14DB93f116984",
    "0x645A679107923Bb22CF81b5d585c091a73c24444",
    "0x646559d9BA63DcB4EE2a2F8289ddc8c84423Da56",
    "0x646c12379123c02504A0212D8A93dA85439d9fd0",
    "0x6478374cAFb5f6cBa4659468a69e3451276cbD74",
    "0x6485A372D2A05200a1563fE17e6E94EF386Ea3b9",
    "0x648D35f4EBA7e16E334608A2998590c13AAa63E6",
    "0x649f69CCd077Da03dFb11f4b1daAb4B625f5E9A3",
    "0x649Ff45A74d3FfB86A31fcD1E9c88F46E8BB38a0",
    "0x64A001a1B0833eB12A75f7566D519838E3825e12",
    "0x64a8e07bbc7Be60bF42A19ebb1E912D400c61B36",
    "0x64C18AB02e7a9F44403eff2c52F0895e7fd7fD6E",
    "0x64D1Cb399ac893FAd5414E9b6109Bf59AF05bDcA",
    "0x64ed2178bc37031140FA32c74c205Fb1428CC245",
    "0x64eef8D6b528D3725e0faD6F09D3e5027942098f",
    "0x64f5278f41e05d2b209fBf67224b649aB6A50Ce1",
    "0x64fBF8EA883d061d61130169aC9e54D410AE89F2",
    "0x650B0E3864aFa96877A2493B495FE2436f725adB",
    "0x651A40671212CdCcd45a2dCA5aB3112032F83d51",
    "0x6523b8763EA88313eBE29c5a15d7e6e44b2D6C12",
    "0x6527045A43D0B8c0cD0E0a42a7c491aA715074C7",
    "0x6529C7B979d11cFE7661588E55aD9745c01878f4",
    "0x652BA83092b9ed4f260666C492495228D726f5AC",
    "0x652bD0f868cbe896239008079190601d2B90FC2c",
    "0x6539980bed7Cec5eb879AA01c7e6AeE7d1b668e6",
    "0x654945F976A332764bd80CdEBC4A1fD832D0DdE6",
    "0x6565E9A2743669081F0F74FAc896801ab4416E98",
    "0x657EE6203137F73317533f839d64459472BF8b8E",
    "0x6590CEAf9227887C43c6b3eefFab08F326a1Aabe",
    "0x65920eEB0555E1d7Ab5Cde0698F78E7B80d3d446",
    "0x6595ee75bD123403a05b85611e50c51C2A0be3D5",
    "0x65A1375C134BA1E8031809C60b1eee183324EF10",
    "0x65a32B2DD77a39b3e2D441Ca63E5d314d7729A8b",
    "0x65b0372572EcD9f9Eaf75B7832e752BA93D0c2e4",
    "0x65b27BA7362ce3f241DAfDFC03Ef24D080e41413",
    "0x65E129AfFb17467Bb09C86845c259A5C90aD6974",
    "0x65f7f675CFC9edD1FaCdD2E3BE6a3D08C18c8386",
    "0x6622c1622F5f860A2475466bb4357Ec03C107650",
    "0x664eB9e45372832Ab1dd17Fe608d68E0ce8a6d49",
    "0x66533dd5CdE19B4A79b4d394F6272dC4612b1ABC",
    "0x6658b1652CCE178f4f6a435ae97d12ab76d3fC19",
    "0x6670421786CB9b4FB09181141EDD3AA1E5389975",
    "0x6683A0C847Bb6B01040A5Aa14f33f4b1FBb90f3E",
    "0x66A1b6e63AD5c056C74d2B1054868B3b13D39eE2",
    "0x66ba11e456C2Cd0a53a4BB7f0F12D331637E8Fdb",
    "0x66d393118F7BcA91005BCaA3ac41eb7a8dbc3aD3",
    "0x66dAb894A02d34d9e8b3f20558587636897e6D33",
    "0x66ECF6BE8C2fE4e2060da4884E475C94CBca42Dd",
    "0x66f9D91EAf3620B9356dBc65f4758DE78E28bd7E",
    "0x670a840848eBa22EB2A090FD65e1Ff60c3bA9e5b",
    "0x670BDC52A8984C044F17811D0BE78D2F886FB347",
    "0x6712Ad2943bfBb71Ad9E6E44B061E0a5A78bCfbE",
    "0x6716611E2CD3342a5000f9f26932792D7De3D936",
    "0x67393645EC79ad57f2F40F8bD3b9390Fd3d0363B",
    "0x6742DC28e16Fe31189EB111B1Ab6Bb953561b6B0",
    "0x6744d79392Eb4D47c49a92F03BcE87885fa0F3C7",
    "0x675333218CbAedAeCA76aA990389B4F1e2C14508",
    "0x67541323D8178571D68bd67aB0f80F5A38529344",
    "0x67640f8b24f0911DCD97f075c9c32381ABB110Fa",
    "0x6768F08FddaE87B9319002bd739019928e1aDbbF",
    "0x677D1626bcE75228F23DCc95e648f8156465d61B",
    "0x677eEe9C51328095ee201887cB06fc189C505080",
    "0x678f64E4251002a13Eb3610e897d007A2ee9Eba6",
    "0x67908205f12D29eCDA5BECaaf51291e78237F90a",
    "0x67A04B9670C5309E463fe768bdb58C4F9BD6f538",
    "0x67A6009424Cb2daeAAA9BcB414b48DeA4bEfc265",
    "0x67ADd88d5FceFC8E0f971d7646Ff5f39b869235C",
    "0x67b2D66965aECd02C4D8cE6Eeb6791D3dB72b589",
    "0x67BA5775A60b13254bf65eA67295dD47543BC5E1",
    "0x67c87c11250A3dD2c459d896d862b0C599dB4248",
    "0x67CfaAfa18621fce6EbB457d77Ac32B8e0E35A69",
    "0x67D54ef55438ccB8E1545bd310e315F977E35ac0",
    "0x67fE12E2313BE2A182835436d918f6ce8664b19e",
    "0x68054004024e88d1de42dc8aa5BcEa9aFadDdE61",
    "0x680912BAaE54570E02E8A2C1ba0087A41308DF52",
    "0x681A64617e1083C36cbebbd8AC9E64938d3C2591",
    "0x6837c97a63f5f46bb2CD65Ea22AB69b3D0Ea33Ae",
    "0x6842D9c9C94B0f5e428d03807AE7E80885455bc9",
    "0x684753D58d65b95c5a797317C50C467a0450845E",
    "0x6848A5D6A01B21431327581b6234DA3a1703ddf6",
    "0x684ad7247E25588fc1742F7dc3Ff783808C88A35",
    "0x686161dd2214BDB9c8396C18914b2475eb561222",
    "0x6879B74BdF13975bF365fc3e13795bF1F09b2D79",
    "0x6894CA49Bae635Af170910C063169fC22840634c",
    "0x68b4d591CB7eEcce537979cbc6E7426A38ac92Ae",
    "0x68b8A6aDA2749C4E280eC6Aca1252BF64427Ed48",
    "0x68bD2209Aa696d89e22FdDc8Acece77f7D289A56",
    "0x68c394C6DAA77c2E1F24F3bc0A10Ac65d94db746",
    "0x68C493780b59a5C5877CE9546d757566Ce6f7246",
    "0x68c6b46aE4d0C1C34fc6bc47898a5ee49107EFDb",
    "0x68dDc4e9c6daEFd31e349CBF7217226b000AECdD",
    "0x69270934F5e002A64C13278B4ece632935A63c4C",
    "0x692b128EB1d19174039Ec313D620FE8852315a90",
    "0x692f30a7c3A2562E336beF6f62eB9F3Ffd311f08",
    "0x693df4c2aBE221c7865b3823C1c1D88bC15C7537",
    "0x694A0cf945aE8ee9536c07cE6246D60A65F32f3c",
    "0x694A5A3FfC36D811839597437a73009b89BF97a9",
    "0x694bDEA5A665e2ce38497D4A2d942A4A85c21573",
    "0x6960fc641fA85f306693a0c7FE7F6D22463725EE",
    "0x6972AB424477AC48C36352ACc7c4694Cb9451f62",
    "0x69776C245634875544121C81ec5B70C540aF4ACa",
    "0x698539f8283D9427d47B4FC8E1D9d450C534ED3E",
    "0x698C1ae0f7e6D2434E929a22B95240167c1C11Bb",
    "0x699fE57573f418E9670fc84b30B3f7523f49af8B",
    "0x69a9f7B8d4f26C30bF7c7D3f57b4d67468C8be65",
    "0x69AEd7F9d3449A13905404e8cfbfEAC422e5e2b1",
    "0x69bAb6810fa99475854bca0A3DD72aE6a0728ECE",
    "0x69Cb3b1de24e08f1Cfc2994171b6c6930498F750",
    "0x69CEc7a07d52aFAA5c2fEE35Ee18346cC72F782B",
    "0x69cF7E9DAb7F202eb213B2EEDED0722207148a12",
    "0x69d45946E263d7a5dEb8737802C44BC2034E3627",
    "0x69DfC587589868716DbEd6667CdD50073EDc8F9c",
    "0x69E630c314Bb7c62307E6bEf8D53F96C2B5CB6Be",
    "0x69F3c8695CCC7c77EdaA9459d9Dbc9A444Cf3c5b",
    "0x6a03a048b65657FD316220b200da584e99053Ea6",
    "0x6A049B73A524311A310971086D3e8431E0713428",
    "0x6A068c009Cf5b8355993cfAd1328A82F030A8f34",
    "0x6a13c07E33d1e663823B71b7330821D0f070a74f",
    "0x6a17d3dD92A8d8fdF8A1f27c36a9e046121FC69c",
    "0x6A214d5e22789674b6c1d71B9a9B5e24969927Cf",
    "0x6a2412867C3EB8b4Da77a7885BF8f754E6FAf374",
    "0x6a29EA33aF9AEbf63C007AcDF46118c42ee34104",
    "0x6a2Fdf98D9d8Dd8B348FF7247Ae9899296674454",
    "0x6a31C61Ee3523AcA860B7fAbc54776e8b38e0fc0",
    "0x6a58b5965738bF9677f62fF4be731c7089F45DFF",
    "0x6a5D1e60E24f2B7B775E5bE430fdB2A1320c057c",
    "0x6a5F80593f6F5B5dae2df882a78A57756B6Ce616",
    "0x6a6181A8c4356cd855F6E1C728487836dE0f7778",
    "0x6A6743B85899cC2571C8034e209f74f5a92A0e9B",
    "0x6a8693856d25d5FA0405b91d73114Fa90881c724",
    "0x6a93946254899A34FdcB7fBf92dfd2e4eC1399e7",
    "0x6A9b682290DFd41f19a6211C0B219050AFfBfBcc",
    "0x6aa7eF6F4c812f9F5F60b8aC36562c8210AEA58d",
    "0x6AabB800CBF452dB2e3980AFcf9Bf7be1bAAd57b",
    "0x6aac8622a86Eff961f79B022d1e999e4dDd78B8E",
    "0x6Ac409590eae839d0C1AE8C1070d0Cf6Aa41e1B5",
    "0x6aE5a96C3D8197Dd3F0DeF5Bc1102FC97c4353A0",
    "0x6AF34C80822D7feAAa0a1A5A91c54d6D44A69D2F",
    "0x6b002f25646318c053aa1201F54C0b6f1268c077",
    "0x6B02Bb2d29a8D60A0dFdA3500ED6d43B485D4F24",
    "0x6B11e8355885246AE9198a23F20ce1bcdc6Af967",
    "0x6b2463da3dd0B8Bc474A712f13EdCb41F9C1865F",
    "0x6b4BD7B8fbD121E48fFE91De6df9388E7AF11B64",
    "0x6B5833bd6bCDC42B0d3BBa1a7c10b97b3f4DdDF7",
    "0x6b6504d24ede6bF513BB73b3C41dBDeb6c9C8Fc5",
    "0x6B6b373eF36602be48E1c7167F9285eDf3C75Df5",
    "0x6b911f3C28dfCf74760D4fEf7c52b3f82c710c15",
    "0x6b927c3cF024f73641011D496D908E9e3a35188a",
    "0x6B92CeaD2602DEcf90877945845C80d76F90B850",
    "0x6b9ff2DC17cee986f796CE9630F8AcdA75F82e7C",
    "0x6Bae6C87636799f4C28eFD0E426F4b0FA1cb436d",
    "0x6bc9640fc120e9A9a612597234d432eeeB9F5bCB",
    "0x6bD2382De684cd42D9cdDd717eA586B68751Df7A",
    "0x6bD80a5BE867e2EcDc6c717B98ff642D4bf321B6",
    "0x6BEa09D715E9b89e2A083937eA957C1E6AF6d3cf",
    "0x6BeA9407436310D7Ee138CB00Ffe5c15db26372b",
    "0x6BeE17209DbcAcDee3B44A56Dc3320D555Bedc10",
    "0x6bF0aF4D0A7a68d6A5DB527EaE6Af078dbA362f7",
    "0x6bFC5b4388acB91F4af8bEbD47d31f464F02C924",
    "0x6c1e581e4eA169c28B9cA03F17F7370E030548aC",
    "0x6c1FADE0e7B2586BCDEf6cA19Fb6D5eE4E5E3d17",
    "0x6C23c075f222D94D4a5e289CC6e15F731C4293d7",
    "0x6c3675c755c06B236cB10b5ACFa0445FD8AaD455",
    "0x6C3A249B6860E990DCfF1d52C4Ad8f1b72Cc63Cc",
    "0x6C3B3437E2073811e5Ad6D3084730252f1fDaCD0",
    "0x6c4fF1459cc4d95b9A7A7b20A3Bc09BC2404B9a7",
    "0x6c5A9739DB3Fc77F50b4DB0Edd7E38Cf99d9BEA4",
    "0x6C61E0F526e966C96B5aa81835903958F41c2ea2",
    "0x6C8A0D2D706B348D31Ad1D829F13195C1621d007",
    "0x6CA41Cc8dD586a472b5E3668Be719894E00c3368",
    "0x6ca6F533430adDbb76e274646119B8dA89a28E97",
    "0x6cb5E69aE00A6a31ff95A769473A699cC47d894c",
    "0x6cbb8ba9e93a295F6fa0f8eCa0000EA9Db083059",
    "0x6cC836b535eb9431F9Def82b71F80E449F29c821",
    "0x6cD1a4E69F093b78F9d1DE5b5D5CbC17aE965bCB",
    "0x6CdE6AE4bec6dbDcfb1196A24e3A828d591Ea9a4",
    "0x6CE117d8C4f940B9E212c291AF12b82F383a949F",
    "0x6ce7C5d9bb44a8F759c1320377813AD49E7757E7",
    "0x6d1db4A7e83dae0eEe7E95d421722d46D2A7e94B",
    "0x6d39d89acdE27D9F090853D50fB58CE0c51caBEA",
    "0x6D3FdEA3898Ad96Da5c5CC113426b50Beee87084",
    "0x6d84d6A959707A4b81bBf4e4015Ec2ce05cB2B1D",
    "0x6D8c09eA8d4223D27403659885B361449bdd7a45",
    "0x6DB4cA881096A52F87Ee89dB612f7e704c7CD353",
    "0x6DBf6c38A27Ea9Bc0EBeb57d33A09A438Db681F5",
    "0x6DE3e03a8dFfC4263589B667217887A6Bdd18911",
    "0x6dEa2b37104cB35DE11aCdd5e2068835eaA1F392",
    "0x6Df1E93a9858b68Ce575707355594dEc7108EFd9",
    "0x6Df2A60789ca9295732874F12AAdA2ceb7e5d1bc",
    "0x6dfc99cdefD0f2Da327b0f31fd0046D8096e955B",
    "0x6E01DECb50E666931775B6a4B59C47a80956fDe8",
    "0x6E096D5DcD8Ed88732b94dCc8A074546641f377c",
    "0x6E18e69AD6a71Be81b3a00303b1021a7E0021a3A",
    "0x6e1c42E919729f353A41A328d3d3f631d4CE2465",
    "0x6e5b0cCC05c7277691eeA4B41C569C48eB334D3f",
    "0x6E7304e5A90626208CEF51523120A136BeBC166b",
    "0x6E79E6E157f55F9C3e5e01E805c13E037d49C4Cf",
    "0x6E7D6b505deB2c67FB64ECe9995a26b8AD70678f",
    "0x6E7e1b80df0b6157Bda1e0A9CD1a271E77ce6A12",
    "0x6e80706D38Cfb0fc8e9e300abDdC27aF3D336aF4",
    "0x6e8dfb8093419258C1350D8Da940a8FAC610601b",
    "0x6e8FBf3F641C0C56Cf412f8AcFfDC0618ae5E71b",
    "0x6E9aEa35DD58ebEED4f5f6E7abD3C6600DaE5Cb3",
    "0x6E9dc51A8A84895BCffc4Aba444b4d03B8B79603",
    "0x6e9fe041e0bA8C2Af35215d900D188d53d7A9B41",
    "0x6eC0Be98328F40B900F7D91337cf97C01E925546",
    "0x6Ed25a635421F69ff50f4d46869a4589875D9168",
    "0x6EDb155D71bD1a3a181B8686cb25e5EB775C49c3",
    "0x6EDcAA2ca6bC79f66e4E81B648E6fC2a40FBfaFc",
    "0x6EdCEDE077148E1188CFB16382612C2B5d4489D2",
    "0x6ef8Fd2fFd39DF9E73eea701E17DB9cF51FFbB7e",
    "0x6efeF34e81FD201EdF18C7902948168E9eBb88aE",
    "0x6F0773463Fde6f05AE282d02416E27EF4cF53010",
    "0x6f0d24e84BDCd63bf236395e837E7b6c238c4906",
    "0x6f0d670B7a058e1E36ffE0E024B3d2f25C052a59",
    "0x6f3379166E074319F983fE4F4EA520C17f595Fa5",
    "0x6f46d90553141D464C000D76e41d0d5380Fc0B23",
    "0x6f472c2C04772B5457efeA237125B37921C82755",
    "0x6f4eacD47ffFbCb81973f6B1f330F95f8AF6d143",
    "0x6F6fe9e707B165b5629A374853b7b9d0718C5c9e",
    "0x6F7A49Da0F184509814039956137dadb9ccda4f8",
    "0x6F7Df2E44b122d3B4cC046DAA5147AC29B2660AD",
    "0x6F81904ddBa81a4b9499555eC191F3346a3435bB",
    "0x6faCf564dBaFcAF142CcE4fBEA8FCa108bB42408",
    "0x6faFd991989f2256A4b0932BB9f683173dcA451b",
    "0x6fD31AABE056c95a87158f1e69629702aD3FcBAF",
    "0x6fDA2b13a299db06dDf41B2F4E43078A9A315C74",
    "0x6fdf6524692eF7Bf426A6b6bcb4A54c86Ec75e81",
    "0x70338cdFd6899F92306BBd6B992bC47825fDb8Ae",
    "0x70367adCB2e46f9757209d65c170e92987e24096",
    "0x70395adEC9b88ABeb541f50AA46FaEe668D9f9F9",
    "0x703adE3D59A79a2261A818F5787cB2cC437D375b",
    "0x703e3Dc44B418Ec78bcbBf71d1B7F2097Bc3DaB5",
    "0x7056B6573f189A545B953907f76F31945e621055",
    "0x707061632e3c4800AD431A30D03609fF02Fe391f",
    "0x709ADE223af88864f86F0A7d56604509c6e55070",
    "0x70a1FD9d2Af72d9671E83b03E4cA421e986F2BcF",
    "0x70AB72349c33d376727e0Cee261e269127372670",
    "0x70Af58c8ad8989eC12d1CF461Cf3Fbc282C4F38A",
    "0x70B51857fA6Ac8Df9B070ed692FE0c9432403fCC",
    "0x70BCB02a559c4f669830Fa4a4a7e403d7CC42dde",
    "0x70E3C8cAD61E0850f553dB3646123007b26a026E",
    "0x70ee76816B7ACA98F70dcd20802aF98448B9156B",
    "0x70FB94A4CEf2aAAd5339ecDc552Ffe9aA4DBE107",
    "0x70FE68AD95896840069834dF0D4C6d0ADBd17A86",
    "0x7104292Ffd600dE4D48506872F9692Ee1a73e5D0",
    "0x7112341136A10e86076261161899D7A8a8929f6B",
    "0x7115C0d03CEc65d86D10a149C3139a81b5dCc1Eb",
    "0x7117fb4E85286c159EFa691a7699587Ccd01E26E",
    "0x71232EAd3BeC1AC03eCfE2556acd6c7D0bD349C7",
    "0x7126725031a8068b1Ac761636FEFaC4F2716a7fA",
    "0x7127d349A11D93C49D4E604167b1F7ff6aCfFFee",
    "0x71284DDCaBA20f2386c09B9CcD3Ad1d369Bf4E30",
    "0x712Aac0Ce24d4B117158C67D7E1dB2aFe03c6B6b",
    "0x7135715e3a75693CBC269E23ce2018CCb3875171",
    "0x7144a9303d5691a479A31250353A034734009823",
    "0x714B8B77cf976c15fb6F73a8CACbda324e635685",
    "0x7191124e9208CBC0A62dd3F78ec87d3f40c1bba2",
    "0x71B6D2CABC98B3c77E0cD6B8F30caC06d9c0285D",
    "0x71b6Db3a373681a1854F3C433F49c8604Ba41242",
    "0x71e9772a3B4754b8b3810417B750190851b89C5E",
    "0x71F631B8EFe9959F46Bcc5b409D74c52a3B67935",
    "0x72005E19120cF05eda67f44e3E1204D274C5529B",
    "0x72476E467dB577A4A82BaDFC076161a51844aCE6",
    "0x7248d89ED7137B2afA28eb76214Da36bbFbd14F3",
    "0x7255FE6f25ecaED72E85338c131D0daA60724Ecc",
    "0x72684f0a8F9750c0cd2aF9B249E1E09Cd68966D0",
    "0x727Aa4121a62b408118Ec8a608f28893606069AD",
    "0x7284F84efc0987b8EA885fF450445A49B498E22E",
    "0x7288ee99dAc4BD38e156c0A22CF78f0A74cC17AA",
    "0x729FcbB6E1289c88Ce5113Ec1C83a48A8E3C9F2F",
    "0x72a5FDde05b33Ecb013547895a92132B752a1278",
    "0x72Aa7371CD5113fb7f1b1452867A421B2A375353",
    "0x72Ab334FCfAc8C823907a3169cE48A7c8B58aFa8",
    "0x72C53e2496414345608fE066EF586BA0898BfBbc",
    "0x72c6FE8421FbDC20153301A9e5810Ac9B041a4A6",
    "0x72ce870Ca292bd92EcBcFc97DCB7295c6c4Da68F",
    "0x72d037F63a6c782f85C059Fc917a12E71B2e0C73",
    "0x72d87CB8fAB6442fb8E973381a1f1c108D5dB0ae",
    "0x72dF5c5019Ec1a75D04F361E2145D3749C0c004c",
    "0x72EE6282d39346CbbEB45288eEDEaD89C5323e12",
    "0x72efccdB51e386A6107CA199BD687F61953EF6fa",
    "0x72F711e517e8A7F67f6e44C1d5A19dBb31E96b53",
    "0x7305810e5F6E12fFcC4f18DC9D782aAf427dF176",
    "0x7309E85aE68377602747292358776Fda3DF70609",
    "0x7315F383f5cAA430DD55638724C031FB41E4f502",
    "0x7316bcE693B1D37D57B4B64e36c17336E85dc29c",
    "0x7319B1Ebd0b74eD094e1D494023eBb61Cf68de0c",
    "0x731d8852f80c453Cb282E1085c3725F4C420CA2D",
    "0x732233305E0D8550CD87C1126df23785840344B2",
    "0x73329C2737007a1B43bA19d501b10AfE5580f3FA",
    "0x735367D51B8b9ca3771C00bab6Fc1f4452253436",
    "0x73584c8916b3AF8210913496f817394ED49ad80d",
    "0x7376b927836243f21b327164055891Eb4290f213",
    "0x73777b55cA7c9Bac09232058B316A9603de3C6BE",
    "0x73938096772C22ff28F01060073536337cE61fd4",
    "0x73be3aeD9d56B60D340b678ea789C58654f8c837",
    "0x73cbf2ffcabCf8362b136424855e4B8cB999E827",
    "0x73fB71642d9189cf8EB197ddEAA46ca962AbF8Fc",
    "0x741e65cEE534965adDc3B765c6eD8D5683Fd81EC",
    "0x74526D798e3527bb5C8cbE6597E83aC0720D40Df",
    "0x745406B0620c28026BEd34356C2D928574D88f78",
    "0x746b3fD551088eD8f68EF5F5CC3A089ECac05e12",
    "0x7478742fFB2f1082D4c8F2039aF4161F97B3Bc2a",
    "0x7485ac6d8534691993348D51ab0F131a19FfF763",
    "0x7493a4390Fa9B1Cace07AB0E133462E3b928c8Bb",
    "0x749Afba78E4Dca55d0fCeC884FdD1A3748DA1Dfe",
    "0x749B28D1Ae23Cf7444AC6A37A80FE4A22C61601d",
    "0x74a04E69fA93A335074b4Cfa50B0eD9364406a4F",
    "0x74A5557b0126bD76595B5F69f3EeD8280dd5C865",
    "0x74Aa01d162E6dC6A657caC857418C403D48E2D77",
    "0x74C5c82D9952BD6373B1d264Ba02cCC02Fa0Ba25",
    "0x74d30596c0E16A9F0aD3d8E2e4Ecc795cC76E1FE",
    "0x74d92FAb35473cE7d728a7bc2E8C7E9E9250d5e1",
    "0x74e6E4ce4B57893C62dd996f0b4dee4Ee4B26fB4",
    "0x74Fc246e2eCa4AafE8d6d81175EE69c24AB13d97",
    "0x7501f8B147B0590cdDdEe51444e5BbBa72dBF809",
    "0x750d8dE6090414B632892Dd451af30Ceb815Cf0E",
    "0x7519e73AFD1e6718E69F1c5405e59C9295BC883e",
    "0x755bC5CB7c626290dc93B9cD1B96Fbd5fb60b523",
    "0x7562e37F4458f84FBFFa3F1BfFC4f0e8118F4CEC",
    "0x7567C49723f255a02e29a2A38C3400A70F5Fab26",
    "0x7577A232f7E33b15BbB0c0B3238995f499FBbbad",
    "0x757f0139192d62652Fb3AA3686f1FC425f383beb",
    "0x758fDa85920911b4315ba7114ed02e04878d3Cd0",
    "0x75a783E02634eEf427AAcF784894693eA8a48421",
    "0x75A89825b51E4ee9614de7E97Cf7D9B057a2EC62",
    "0x75ab95B675Cf60D80AF95eE8F8413Ff057E68b8c",
    "0x75b8740a4a89DEB46456e1fe18df94A4B629A0B3",
    "0x75c05c87cFc75A7754eC9Bb4b62cdE5A3d54a5b4",
    "0x75c1CDB27570dF5A246C79eF5FB9CA08b18a484b",
    "0x75cd3E8C5e457bcBd52a905771fD62043d9989C4",
    "0x75d605F15236592702677537f78F1F3940084526",
    "0x75daf11ADeb54B89d9A15EcC58f018f2C46ea332",
    "0x75DFD3A19E6499726C0CE05C6bb4D99EB74Ce6C0",
    "0x75F42B51EEc249a510909aA0F661dC9A90260159",
    "0x75F52aEf21c1692afa9bBE897a31dB3002BAF6c3",
    "0x760389865b0958F705C350bCCf8f14C5b2AA54c2",
    "0x76055B233940C7B76bC65004359A60ECb571b931",
    "0x76237DAF5E0227DBfb8f72eFC8Ca1a7FFEb04072",
    "0x7625c624B96ba061aCb3cD4dB407e2A94AC9a721",
    "0x7625E07EE9326d7E5dc688372f67aDD592e4eBF7",
    "0x762c8B9FfE6B8B34C8667717eC9Ba07e53af1f7b",
    "0x763226edfC5b972979EA40c3d65837485c0d0Ddb",
    "0x7636f96a3a5e4A0F2aA915b1D7e3b5420cDcAAB6",
    "0x763AD28bc4436590FD61998561730B0f7790E955",
    "0x763f71BEEAc7b99585bdCaFC7a25FEc8C4A82594",
    "0x7641d25fb6929d54d4d7B3DB0B929006e16Ce75f",
    "0x76567B23E592514B55b258b824d0fA62F30f935b",
    "0x7678A977A0fC118D80675074667615BD8d3f978d",
    "0x76807F3D69b1D38F9D597e902f18dAb0Af926B8B",
    "0x768c16b0C55933f52CAfe5E1Ef5957bD4d81E9cd",
    "0x769F6cd731925Cf7e2f734bdF721F1fb4e085aa2",
    "0x76aa1Fb8774752154Ff9208eB1569001534eECaA",
    "0x76DB02500F7631d57BC2DcDCa9d4cf782b99E119",
    "0x76efB5493b60a81a207c2cA5035D13ac6F7FD07A",
    "0x76F45B722995AC081d3430080f31Dd08B0C4EeB0",
    "0x77073786969EeceC631B2E9A2D4c9571eb189ed0",
    "0x771699E05Bb2E147DF732638D052b044DC16eeb6",
    "0x771c82DD5c6e1011adcF4372E77cf5E5587A9054",
    "0x7730378648cb4dE782bEe0cAbb43140248c9AF97",
    "0x7744cbbB7E1C758Bbd96A02c2e6e33A270d409A3",
    "0x7758E63Dcfe8D59E6f632a01Af8B1De96eF532E5",
    "0x776F65A36b77dbB3786905c4F6Ed62dbAF767920",
    "0x777db25185B52987701Be1333C4254bE9bef4cF2",
    "0x7792bF1aB8bBfc74078aFAC293acBeF2e00F8625",
    "0x77Ad5387d65796a72Ebb7B5613436015e165f8DD",
    "0x77B89e425c7c95bFd0B5945a780bFA3967e7e5f9",
    "0x77BCA6de657bc7F5B7005779AcE0055b00d4E865",
    "0x77e9E25fd9004e8aaEc2FAB0f9271c1eaF93119A",
    "0x77F756a5868FAeBCe41459EC4b3E2f5798590BE0",
    "0x77F9994403315776604E013E7569aEbF5bfa1000",
    "0x77fE2A5919dAa9f88fDFd11ca3973201480d53A6",
    "0x78089705ED807984cF3EDf9149c9369e8FABB9BE",
    "0x781B95d9ef56aB008C820435161D9C5c57A7D09B",
    "0x78215C31936cfA04b0DFaeB7DF420ADd98700f14",
    "0x7839F3c1805731Ea698B03Cc2b6c4c7D784D6b2a",
    "0x783BE85e7ee67e84b2475d188e247DdC5C68961C",
    "0x7840146Bc28B7Ef66C8D3A62f95B47fd9e5b28B0",
    "0x784235479aAee14632c1216Df6D5D30Cbc840947",
    "0x7858562e932A6b2906686058fB21B55e7126A33D",
    "0x78653A6dd35fab42CB560EDB0Aee746C68c7e12C",
    "0x7891818A00204fa1Ea52654a9ED4999EB2F43b1A",
    "0x7897b87E840e51709374eA6293c550340DA5f599",
    "0x78a1450692A739396475Ea201A312942F9fb0c2c",
    "0x78A81dabd0A5E42BA7bD0454682fBb947D8B82d9",
    "0x78A826a3301b1eA2B38d23201b3033605269EA94",
    "0x78bbe93D06833027CF074123796B403046D22523",
    "0x78C149A994032B2996ac7BD16cB98EF502F7e170",
    "0x78e5df610CD26aAA17D6D0d2aA1765fb3c36715a",
    "0x78f625A65Fc316D32d98d249b698fb509A6d98f2",
    "0x79017f49c27A573F156443AFB5AF2B5815807868",
    "0x79066aE1d08c5B32F1EE9a42597f1e8F0eb6e23b",
    "0x791804466E724C4b83842353e6d604887671a739",
    "0x792b31D5f8C536DDC89257E6515cd1E047B8CB6f",
    "0x792ef1Ea5082c5b7b55F30925a73063399fFCe02",
    "0x79304BF56fBe8002D157f5F8726484631DEf8415",
    "0x794316614B210Acd02F7c88085F2872A8D657d8F",
    "0x7944D4dC6dF4d77080c047775b9f60348AbA3CCd",
    "0x796a71327D4D40D989586719691ACBbFA15E9056",
    "0x7977B909D55a53F9c73140f7F611EaF0638238Ed",
    "0x79780627DD6D2C2c591304715a144500A69C6F09",
    "0x79857927de205e2A86e50bb3b02A497DFF5d5373",
    "0x7987cCB1E0C1256548E800bcFD165127F44152F5",
    "0x7999c02D6928582599e21102dc37d04C81BF3213",
    "0x79cCA1039968e74C090E7733f341A55184962d4d",
    "0x7A000e0FB9f25c03096bAA26577141b84eD01dA4",
    "0x7A02AA3bEb3560EB4F46862eBC6dc4cCf1Cd36A7",
    "0x7A13b558032296ACdcF8890F0fCf1f94d7d7a425",
    "0x7A17551898C6E898f2eFF9C4aC4ff00c01332D8F",
    "0x7A17824cc329d614c70f536432ECD516DAb318e5",
    "0x7A1c9847359358593c8a48Ce772F4a1Dbe958886",
    "0x7a207BC1948684BA8aed04F0Af018B11564DA0C1",
    "0x7a55b2d912EB8287E38109a83221EFA231725E2d",
    "0x7a7E3507Bf299fC72c6540cc622329ae52dcD2b4",
    "0x7A8feFf71b781cF0BF635cb520C4239f540fB5f5",
    "0x7A9b4d40e1a86d8DED76FD5568e6c15923c724c7",
    "0x7a9c3F8Ef15216F2991e00EBEF21cE5493bF6866",
    "0x7ABd0F274Ee0691DC9e574A431eC4eb777e2993c",
    "0x7AC40f45DaA539F0517354A8fD7d50Bdf8022431",
    "0x7ac95A2cE07e89292F11278f8AFAe70eF25b4B07",
    "0x7aD5650d5204670e3D44eC676fEdEB2f83f18Fb5",
    "0x7b12C46FD8C6938475A095E30BFcECcB8A417215",
    "0x7B1d4f3602F0FE16C4F611E124d3D7B307245Ba8",
    "0x7b3016d8f53a60c01dB6425F481a29F427333436",
    "0x7b35baEe7C73398F9251656b6D97C261f2DA5B47",
    "0x7B4f2A73994A581653C724F5E01b655f5aA72958",
    "0x7B57db50F91356AbE299605095775a6246742538",
    "0x7b5AF6790381F932AbAe790e8b0d0ff50E287f8e",
    "0x7B63Aa06C4b87E2973850f48E5ffB53e85a2Ac06",
    "0x7B93E9e12EA1a69927402C9E431A186dE2A0D9d4",
    "0x7Bb62c8FCc15011bF7B5D2aa24Bb8473D0DCbd85",
    "0x7bbae550A6faf4336fC44C7B578087E5f000e997",
    "0x7bC7481751d7Fcb76d08f596B03Ba1e42378ea27",
    "0x7BD5e7c1C866833E32A5Fb898845e85D1d1B2D7E",
    "0x7BE9A035Ca0056c465a5aCc7dC92bd1E7042CEf2",
    "0x7bF14d493520f20FAD2e326deC83509d1116C6b6",
    "0x7C4a6915EDAC639b56a5930D6509Ad9D039118B3",
    "0x7c4f9133852935CbC555d907CF981408cD2d4834",
    "0x7c54EFfe7BC3906B6fFe7390c8bF9aFd67089409",
    "0x7c63aE42a255d495a62618dC0AA2F5a966532196",
    "0x7c7263cC81441a986594C465B42D9FB1B12f2e42",
    "0x7c77AeE93d95887116a9d7bD73A452B2bb4229D9",
    "0x7cA00A09E3b431d48c30e3E6CCeaaEaF6385cC81",
    "0x7caAaa59ee2126984008FFAdD7AbDdE0ca0D5a0C",
    "0x7cacf6e3340D798Ee83E0cF55EE0a85a464103c3",
    "0x7ccaD45FCbbaeCd43f960c5af4E82ed2a0021d7C",
    "0x7cD42d4Ad4BbbE39ff70D47fBdd4b717fa83fcE6",
    "0x7cf90106BaFcf7716563f4Cf92430809853162cf",
    "0x7d0ddc336FC0CFb5a13EfE490de40dEcfe0900DF",
    "0x7D130a4b9247b19A311f7aBeDf3D2F462eFAB4B0",
    "0x7d2f7553df7a7F9d424Ff63F5fc4c0e9124d09D1",
    "0x7d3590537e0f6833d4dcC49944bD2eb4D4EAb3C9",
    "0x7d422CF705AF9ea93919B1A6e843B2F9F387562d",
    "0x7D45B0e61a79FD173339c751865013fa009ddE2f",
    "0x7D6A0725607fF2f4Ebf24Ce749617656435Dba44",
    "0x7D6e06695dbC745752AeaCDfdaBEd8346c6384Fe",
    "0x7d7a2741d10bA25cad97eeD172F7999Dab9203aF",
    "0x7Da1235b91D6308997d8E1BF6512e1A33726CaE5",
    "0x7daD2416d6F073B9879E8bb1a523Cc8d2A2609B2",
    "0x7db18fb703D7b76Ce008301001f74260015A6F41",
    "0x7dC1eDFBB5EE7d7C8f1a53b59DCb6E6901928401",
    "0x7Dc3926f545848BEDC2F4c60530D107866b5D135",
    "0x7Dd824c592352aea415C89FB501C18A303c0423a",
    "0x7dD9e0FF2e9034E76D0FF63f7Ad32B1Fb208244C",
    "0x7DECf7a31168778f311c57B9a948aBaa7321001E",
    "0x7e023390133398fEA29AB8Fa950C3D3e36939E08",
    "0x7E0273aceC6e5a7bD98431f4Cd24446Fbb59295F",
    "0x7e2C26274259917b4603968756e23BC738a30be2",
    "0x7E307e41B6D31b8591145Bd9625E3D1bcaB55d95",
    "0x7e3572c3d45F181Bab157992E9eE67Eafb363b05",
    "0x7E4B75656fCD075C729DcF5f930E05DEDaCC992F",
    "0x7E4Fec94462Aeba4f47128EB6E6dD5711239f553",
    "0x7E5507281F62C0f8d666beAEA212751cD88994b8",
    "0x7E5B90f42E23b84F755d32648f5B2aA85f5ACcEC",
    "0x7e6948f25855aCE05F2c22EbBFAe9BbB31070e91",
    "0x7E88854a5f2A5e6647FBe67F08A184dC0867a822",
    "0x7e92cBA972db9237776E4B51E90D50493B81f8b9",
    "0x7e9CA9FAfdFACEFC15922D99F2E4B6d8c0715670",
    "0x7Ec48E9AeF025c33AC0A59BB8a8bB18Fd02F1b33",
    "0x7eC6fFd8c5d5620903A22CE7A8B37D62E0E6559A",
    "0x7ED2B4B03E8f1F17771E847166Efb147cc9EBd4E",
    "0x7Ef27Df48deE083779C211e0fe6C311106Dd8Aa6",
    "0x7EF2e9BCE27AD6eD7E0cB4650577B21e202bDD58",
    "0x7eFaC69750cc933e7830829474F86149A7DD8e35",
    "0x7EFf7eeE42Dc0Bd27081A78fE23CFE2a72697f2B",
    "0x7F0A3970b2dC63E747d7DB00F400b4c0d0d96f80",
    "0x7f1796071EB91AEbdA10a03115fa3Cd95EFdB25f",
    "0x7f259F76e4A289fECf4cB35247565c818f521111",
    "0x7f297aA2aB0fc257834CA7E940e6887769B4dbC3",
    "0x7F2d44BC26367f65534368CEfbaEC4f6cDdaba3C",
    "0x7F495c24A4D893416011DB39452c5013d0DF90A9",
    "0x7f4EE0d054EEfbe291A303C3Aae6F06B59A7182C",
    "0x7F53a82E997A297155C924e171f13656bba86e4A",
    "0x7F5965ADadfE2AE6E851Fa37c187d195f31210D7",
    "0x7f6ca49D1e50671A586A76Bb082dD6b3F73feF17",
    "0x7f9d23ffb5db6532a991d348e64848f30b9AD844",
    "0x7fB1f91574E2D39C41a85395AFC7ac2E4C0E6B9d",
    "0x7fD4dD08954B961B218115d217aF6AB2e3253e4a",
    "0x7fE16C9E8017bb6B0Ba845569B19A4B1E934E690",
    "0x7FE36275bdFB4272b7Bd7b497758a32B66c1aFce",
    "0x80078C884C69a081E3CFB62BFb828155DaefeEcb",
    "0x80172FB4C47622aF9ABfcF730F627b177637Eb3B",
    "0x803e96717D25Ed306160D35aB0368DD595D0efB6",
    "0x804388A4c3f5C3f5FaddDE0822cFDcD521505318",
    "0x804837F8372161e4758B1E71C312018ce019284d",
    "0x80771B6DC16d2c8C291e84C8f6D820150567534C",
    "0x8077Ddd4F1D37ffD19749aCf5a3904e3aa5dfc1f",
    "0x807F7E7F698BEC5Ee077dE556eb064dC7edB5386",
    "0x80912CaC61261902247728872E87C7A89CA8Fa49",
    "0x8099DCB5d0FbE0C0b45F10C4EbA244428A4A725c",
    "0x809DED7Ba1eA15AE435E59AA9DF4510869E8Aebe",
    "0x80a349B884Abfe914B68D9cd0F96746Fa3fC2746",
    "0x80b743bAAF026A4e87BD92f3517eB875186Ac281",
    "0x8106f784c9c44a04e9E8A1525673d00E15ED75fB",
    "0x810c7E6FC6A14d4Bfbe3D5C1Fc7e476c544f5A86",
    "0x81139Fc8F91360C64FEC55974d7636bF5F1595B0",
    "0x81173FC0E51fcCD7dE90Df14B1C7f472B6E525BE",
    "0x812c20c1294927f50260e660b5d8F9407a06b43a",
    "0x812FD8df23cAfA49e0752539861fd6943aC1b697",
    "0x8130eD03DF6dF862F07E50Ab27B81290Fcc9394d",
    "0x81402F641D02D0523cE2ABfD69D4821173728360",
    "0x814d2793DBfE9c97f7015d1FDF16Cc1950a8dBb5",
    "0x81590c16B9d1495D133CF881AcF5cc0B56730b74",
    "0x8171Fcb6Ffaa8f3378eE9b3d82A266Db81e94fAb",
    "0x8175EacCa8Ba8Cf1E1F523ba97a0BA9fd356CAb6",
    "0x8178CD013fB959b252de4dF1b23E05ca4F8D9527",
    "0x818eB16fe070d319fe5B0B33a4552116Bd2e409D",
    "0x81a12D3B48cC398a409d2381458F0c8C43FAD96b",
    "0x81e43b25eb113eceAA41A30B35775903FF6fA4c6",
    "0x81F0149B54EaE9733beD99ED44529fac605B4E8F",
    "0x81F1520dceaebA0D867Dc05b115fd0fa32Bbc0A3",
    "0x821c9656815228A2Caac4314708d7A20e031d616",
    "0x822D5fd4Fee9F72cf904e6cBe860bF2F5cbd8804",
    "0x822ec855CC9f41b592622108E6F3565E976430C6",
    "0x8230a4CB486D9AE98710F4EfF9d94BBC2f26E771",
    "0x82332759C5dC2550d02195574f50D82E902a946D",
    "0x8234845C84e4Fc97b91302275988e9b4E59A939B",
    "0x824BBbac4dBB2660c4896eDCa4419B1490546861",
    "0x8250dd3Cd75Fe77482F83a331dac41382BCe582d",
    "0x8252Df1d8b29057d1Afe3062bf5a64D503152BC8",
    "0x82573660E3779263E5336797a6Fa94756E3F41fe",
    "0x826349a79e62A6bd0aaC2c44bb6eD18B2E0D0916",
    "0x8279915E196E1e6805b3aE6dfe924ebF9aA434d0",
    "0x829A0825115cfE200BA8f99F4a0b7A31d14625bb",
    "0x82B04Eb793777A10de5e54b6235396e60D0e4b5f",
    "0x82b15B78Ba9195732C33bFEd1B2267cBf3F56644",
    "0x82b62066750E1923480aC79B6E2f4B458D8d1A58",
    "0x82be59C8B195d85D263051102069C22380d1fa2e",
    "0x82c1B61dA09b5FDce098a212Bb8070210AB91049",
    "0x82d0E46eE66751C612C9CE1A4cD368DBf74dba22",
    "0x82d751c236Cb6c682A54196Ef6fc01021a101a1B",
    "0x82e133653E5069a61062b28795eF19A99A3D2C75",
    "0x82E61f5f53B94A3318B2272323898949d602dA1B",
    "0x82E9Cdc4C75CE4a14774504B3a88BcdfACFDc181",
    "0x82f22685eb23d0F64d2f0C7e204b7D47077D03e0",
    "0x83052fc58661EED51d7875460f50E7CB04f78976",
    "0x831bD442f18029d368D57691E3aC6eD51b0ADA6B",
    "0x832a3b2A939C44cF434A085224D157D33b3B2c1a",
    "0x832B6029c3A4A95a2dee7563730c92861C4085c1",
    "0x8332E69Cff9B084D3cFF0165a9F254cB2dcd98b9",
    "0x8380C6C816adD3F03B4c8eE456BabA4f122b5279",
    "0x8380CfA73F5023A240CDc1B7774d2a53BB2F4649",
    "0x8381B83c446f9311d7eE22697509C49A79D23940",
    "0x838A1c2F0CAe94072332c346533ACDc6C590971F",
    "0x8393DF6c1E06421AeE81024873D1ceD82A47588F",
    "0x83C0D1F4d35F95D4723644877da80873cE59f681",
    "0x83c1CF08b92bf3Ec32419F223d165D127FFa73fC",
    "0x83C9440dc34DA00c47A0d4dC2b598d7BDB1b53F7",
    "0x83D60639B032DACDA59F52E0d71D8B20c997CC92",
    "0x83fa6012e1C04F6cAB59deECf122dBdF91a81Aaf",
    "0x840De9986997435983F3D827dF933638F1eD23d7",
    "0x840de9a01779BcCA9b573422ccEc2E2d373AA171",
    "0x8410B86f3220631D5110a31f966f12C7A4309435",
    "0x84219D1f71E9c9ab1141EcF9EF9126B45EB97A90",
    "0x84309453D95db75bb5ac5d66C54AD7B2854C1192",
    "0x843933677d4d71C625B469b9Bf67d052eC79Be55",
    "0x8444B6a7D453b46e55D691D1D3EAc319A397ce96",
    "0x844Ae78315bc8aaEC6665B5D5DE1A565fe5bEc3a",
    "0x8456D11dC429428428911fa3eF192B40e281239C",
    "0x84590D8b7C4F89F0DbD186E12B1D2EaA92446e41",
    "0x845e1312Cd03226B5ac1b8d3A6B863161a5CB53e",
    "0x846976AdDe6f17aFD4590312781Dca81455C21d8",
    "0x8475aF5Df7A8Fdd7d50C7AEbC79880ACa4e67d23",
    "0x847AFFB5db7197fc6219CFb3D1B2404583978d75",
    "0x849FC24385Ea9990072f47660CC6c3e988fAc57e",
    "0x84bA38696f4F2dbCb88Ec2C5F82d24A074d2E6fe",
    "0x84cA79DED76700a1d3cF2a0F1C96D1CAF9dc6b5f",
    "0x84D1a64453718cC687c23532968Ec9b8E642F618",
    "0x84D34f4f83a87596Cd3FB6887cFf8F17Bf5A7B83",
    "0x84da37133a088Fbf4e21D80Aec2CC260B52eA116",
    "0x8503BD7d65DCC0A57fB48b2C20317493625A8854",
    "0x850604Ea8f20F600a80bB1063e5f14a0a2238028",
    "0x850D365d0E383cC09FD7DB733B4Df9B38a2Ff4fd",
    "0x851A3508F1085b994702685196ae65f3691e3Ca8",
    "0x851d535E65df02Faf9412267eADD372D7D356E6b",
    "0x853B28a4A0cFc0DBAf5349824063Eb5DB54775C1",
    "0x855024b6745Ef79b4F1d7fc5593B4A7e20a4364a",
    "0x8555cDe32171a5575c5b87Bb29E4681938874BB5",
    "0x856750961732CBEAd1E289e04c57027bB368fcC0",
    "0x857CD2c8B348237327661325d1D353af4f14Aa4d",
    "0x8580ca3A39d2b0aeF0553687f71D03Fef95d8d8e",
    "0x8585e5D7C3dfbbB794bfB0D60cb1176cb6f4dB3B",
    "0x859bB10C399Eaaa378a0e9Dd5069c4115c082c0d",
    "0x85A60b688A8057683fd4b46F42680D6F2fF832C1",
    "0x85dF0DEBB5758A2F282A1AACE604Ea0cD6337665",
    "0x85E37a42CDA7054E06d450e147a45aeF3dF1758c",
    "0x85E59a136696Fa544714eB32625F2f56F3B1C96D",
    "0x85E68943F497E1f338781687B2E3843A4510aaCd",
    "0x85ff92E4e461892aF0786399C0C8e6f775D47813",
    "0x8603B5e027C28A4B2004AaCAf376581a3924Ba76",
    "0x86146e14e44F4F6554eCDADfFE5cE0BA3BA7dEB4",
    "0x861553Ad4cFB82fb0dE7Bf1DCa113FA4cA87993b",
    "0x862022aCFbC64351dBab98De2E14e908A7270CD9",
    "0x8631259b876D0e5bE964d982968C688bb4912aeF",
    "0x863DdD1c07866C8270141387Af223c93B52c057E",
    "0x864B451aBc5ac84b728c52a8f277c7ec9df88dBD",
    "0x8665E6A5c02FF4fCbE83d998982E4c08791b54e5",
    "0x86702414c500455404164B097d5d8E31A7184701",
    "0x869C27B174C81589AA0250Eab9201C13da00ad12",
    "0x86Bb380114eB2137A73d8e6850400179d3Da0E15",
    "0x86Bf97A8356690456F4040Dd0172aa3d4d5315E2",
    "0x86c7de90e8Ac6EdD89a5180dCeE677A2986f8b5E",
    "0x86d3f82560dc274394868E9222DCeE2D61B43111",
    "0x86e8Aa1b763811833EF0695038a68A366216131c",
    "0x86Ee315331cb035056388f9E72305D1A2a685D32",
    "0x86F93000A5C817A4B8d04e54AF0D94c0656645a1",
    "0x8704ABeFd481486eeB77EA2403c0A319c7143443",
    "0x8712C3158c54C266646d7c4419D8C218EFdDeFC1",
    "0x871b67E9467e0768539f56e13d3020866c0d9738",
    "0x871cAEF9d39e05f76A3F6A3Bb7690168f0188925",
    "0x872DfA67E260fEdCaf5c4B410D47b587b5A71e82",
    "0x873fBa5E788eCF246fE23a66f541bff2B8B698eE",
    "0x8742fa292AFfB6e5eA88168539217f2e132294f9",
    "0x87794C24D564dE11BF0FC1be2dDb589b794AF6C6",
    "0x87ACCabBDEdce63379aF9D246bB979a3a481534C",
    "0x87ae3929744864734Cd009Ad3Be47D97FCcB54D5",
    "0x87AF909097BDe0B2b5FaC2658698FdfFeA9A3D30",
    "0x87D83ea617bC2f12EA0EA7760f8A82f2C5F19d2f",
    "0x87D96c3eD01D574D464a1d5E7748d01939108200",
    "0x87E135af686BE76cBfac5CE5f45876CAEc18cD41",
    "0x87f3838742e5FF8958D7ce92aFf4ecf07A1EdCC8",
    "0x87f8aAb14C483265B889B78AC45dBEfDeb78FD58",
    "0x8808254D89b3F1DBC97E9cfaA6Dab6c67e01AA65",
    "0x880db6C923D35231ef7B2E16B1b56481673c161a",
    "0x880e92526868aD0171284A0076070A816feD1A05",
    "0x881D232eaAfEc296200B725dF23b8efa7B86BB18",
    "0x882392B8ecF83338811A534e8a06Ed11B61D2c9d",
    "0x883B33c16dA60b930717170fe82012a30ccE6882",
    "0x884Befa765A966508cb0bd8Ca36e300A4529F380",
    "0x88745F69D14F9edbC682309D306180fD6b3A2ff1",
    "0x88770F4976Ceb7BB196Cc8Cc2de5be2E0f281D3a",
    "0x88849d548470a07B9516408778d55b66D701C808",
    "0x888801E8331d0d6098D53A5571E9444eC351d888",
    "0x88888e133e0E1F1ac61CB4325f4D43243DC3a84b",
    "0x8889EBB11295F456541901f50BCB5f382047cAaC",
    "0x888c1B86000BbBDb2223A0b89E3c82AEc9D94297",
    "0x889365dC5623Df3A008FB576F4b7d8DB31C4EebC",
    "0x889CBe93F419BfB5e7ed0a04AD89ae235D63516B",
    "0x889eB855D6A5D992D061B4D956ED6586a82992F8",
    "0x88a7063D83cc6a46636D7Ce8f64b05C5105A02B3",
    "0x88c73E669C8149bEbC07da6dCaEA6F53a381Ace8",
    "0x88EB7426278011c583938bE2007CF8E8F3ea1af2",
    "0x88fFB9B70eFe44cD73866148d9078A7E0eE30626",
    "0x8910A33230FE604Cfe43DDCdCc9CFCB577Cbb143",
    "0x891Ec75E31C147c010F04107c53ED1DC6F71ed2F",
    "0x892f3db9a6B014dB5C39F8926B0cfBC4Df907eaD",
    "0x893268106623A04C279804F936BA94bD2eDFa327",
    "0x89425dA431683A8DB2B6bCBf8a35411aDb104859",
    "0x89511B443c2f8d6C8359Ed7818da965e08B49b89",
    "0x8954d7A404d740526BBe284c2A502577548f5193",
    "0x895c5A67168ab29D5E8E96a55f933ad7C948C612",
    "0x896C84136Fe8970c42f156d84E08d8DC518308E3",
    "0x896e88D2556f3015819B62d479a8289EC3b1991e",
    "0x899079d843A1980d6eAeEEA10F690cF3FCC60F19",
    "0x8995c894412D3e50503A74263B770E53F7B0F87c",
    "0x89AB5c910013d35c6095c4b4a6d1c11E9CcB2FFc",
    "0x89b7a8a1F426FE510E622E7866AFD322d33c2940",
    "0x89e18ec5D983e7f92F7FaB7E0A259c5095427406",
    "0x89E420BD6bb23497b977eFEB98a5B5018f32ae09",
    "0x89f96533Ea727e2a0ADC59ba9d0D3973dC0C2Cbe",
    "0x8a0ba098C376e331D6fE74875Ce242c47D99a226",
    "0x8a484147a134cBb8E011a88149a15702c4c56825",
    "0x8A49C7779E8c51369f7bb9eaB3Ee9D52c37320c9",
    "0x8A4b899B6CE97FD6ee43FA41f81B3F0E096272fC",
    "0x8a52E278733780366A8F74a8e82A29e8A7D36d2b",
    "0x8A6004662C0B6475A505e874C2dd59bF22Ec23A3",
    "0x8a7b6726F3fcE0c04EAa84DDF02A77E4dcd6Ae1A",
    "0x8a80136735716B514beDa12827e085f86C19B9EC",
    "0x8a880890A98CE4e68ef6aC119930Bfed74F06FFe",
    "0x8A8b40082f77E281cAFB76c6fAd2f77a7717D11c",
    "0x8a957F2e4b6d88bdB40ecE52AaB7f204Dd1b8212",
    "0x8aA806f850aCDAE8ff82311c7586A7BC50398619",
    "0x8aB945Ae285aAe98c20B25632646CFdB87214C7c",
    "0x8abA11dC1Fc5CE97A14A02dD3cCdb687caB75C81",
    "0x8AD272Ac86c6C88683d9a60eb8ED57E6C304bB0C",
    "0x8aE57A027c63fcA8070D1Bf38622321dE8004c67",
    "0x8aE6422631292c31aeeB2efe154d6326f703F46b",
    "0x8aF9B98525D32c00d7a47502C276d7ea4133022c",
    "0x8B074dDF02591A143665A6933B2cd4b9fa23819a",
    "0x8B0C8071D8769754153A2F83d0D9EB8C49BEd0D7",
    "0x8b3477Ca7445ec524dd534fA4A596C993E93675a",
    "0x8b371d0683bF058D6569CF6A9d95f01Df9121A3d",
    "0x8B5Ba95f952844C5c66cb53FBFe1749c70327D70",
    "0x8B702421BF56Cc3886341b31FAD9b78F8C962A8A",
    "0x8b7a5B22175614EE194E9e02e9fE0A1B5414C75E",
    "0x8b8EA1f9231CEDC059fcFe8FC175d5dc8222BD6b",
    "0x8B918B3cDFCbfFd730fF135e8eA9CcAC143151aD",
    "0x8BA68CFe71550EfC8988D81d040473709B7F9218",
    "0x8BAE003c9f82E6369BB3ff30631d3C862174155A",
    "0x8BD695d267Ef5D5805BDb7C48c5985d9c0055E55",
    "0x8bFCE5381189Daf80ED6141C758dAf8cd1aFE804",
    "0x8C0A11eb047c1097c821C159b8e0C2C5f37F81Bf",
    "0x8C148C921963c7938BB825e17560D1ca1d9c881f",
    "0x8c179eA3334F99a8A8fff3691b3493dc514b7DfE",
    "0x8c22c5A9f4948f542CeF5b6D321Bdb44270dcb0F",
    "0x8C2Cd35Ec599199C1e8265C9A3D2fa213C6e2E05",
    "0x8C466c62B50F5524C1C3c0CF0a71681e66E18F84",
    "0x8C4Db3C9B22032c9E7e9F16DCE92f71DD27d7f20",
    "0x8C72e5133855C18e23FA3b942266945a89e85033",
    "0x8c7819768022e5F9ef54E239532a238dBaAc8C47",
    "0x8c7cdd7EDac1437c3402716aD27be3ff62517595",
    "0x8C913aEc7443FE2018639133398955e0E17FB0C1",
    "0x8ca57da8eA4d284b424A6d5492dFdeD2Cb553Cfd",
    "0x8cAb21f3260D82CF25B92F2a238d27891e4Bf054",
    "0x8cAb3b8133fF1E8B6C8eEf0A32614D823F36A096",
    "0x8caE1fDe44b0b0847Cbb75E8044E47dCCea616F7",
    "0x8cb06A5FcF7D8194BFf895Ad85aB25B9cecFD081",
    "0x8cBd2091a7Bf12Eb0466Ec361C4269e40C717699",
    "0x8cc1440425A7E771162AeBD8a88A585Aba43BF25",
    "0x8CDE3cAa8b8c77a3B032c9149717A7DB7fE41438",
    "0x8cE9C72F6bBaEbCD444Cbd3c2a72AA5436600d21",
    "0x8CF5c60A23E0229845CeE968935DAe56257a0abB",
    "0x8Cf8067026F588632a0ee99D7C99d196FA93F7E7",
    "0x8D1c7FEa1729759700b21E61Ab8b1c6FdC35Be65",
    "0x8D23cEa8a1FB47D003fA0c3de55cB5a55E92E9e7",
    "0x8d2Bc9d31c52828E9f96aa0AabdcaA462c0F538C",
    "0x8D40EfFf5167a73D58AAd2b7f21aDF0A5F21c515",
    "0x8D42c33F54f6F2e863F308B30Bee3fe4FD8b9372",
    "0x8d58EC594E07c476492676fA36c12C11D95E36B4",
    "0x8D5c7D8eb3858249BA51c2a43d1fA74E0396d5C4",
    "0x8d69A355117c12A74A15d58Bfb1303E6C110d518",
    "0x8d701BeD29770779f39A127Fa42C33ac4036fEbd",
    "0x8d803379dcb45b1cCd056da85b0cC11796690d58",
    "0x8D8e3C265e971976944444aa2896dD23D3D3486F",
    "0x8d8F3e5e8C77563a7020804f7EE1dF9f05359ddE",
    "0x8d9171DaA471FBA5aaF9e6F4aF46765ebDD13f9b",
    "0x8dA92990720D08C64F8528F0e0b45d2362a18BAA",
    "0x8daD44e4d388E355E75EB7B5Dcc49735e5b74090",
    "0x8Db2bA0ff09B994FeEC57Db10141c36F02440101",
    "0x8dc22F2E5d71EE3806CFE3DaB6919fdDe30bf802",
    "0x8DE37cbb2851a6185077b18C7Ea54d9670dE574B",
    "0x8deE0653dAA1484743400813630D79207f64FBB4",
    "0x8Df0c5415aB65ac4E555c263d1bB0814B75dc4E8",
    "0x8dF2f4E591b1DFdE6c8761F84a37A6a6701eFF7A",
    "0x8e059f6b103F7f92153c5430d998aA6829149e08",
    "0x8E3770041f0949F472cCD54d5BE351613A49014d",
    "0x8E57BF9684EF2c36fD01E8C67E34e94596bFb42b",
    "0x8e5f82F2B6222be6F8Db37C94Adb179Aa736c070",
    "0x8E6304Dca6b4C2A71a9E3D7B93dc2e6a1dA028fC",
    "0x8E64c927aC13a7453eAe313e6AA1d2691f7dceC2",
    "0x8E709be50bbdE1a1de66512dDE3Ae2879d4c4a31",
    "0x8E7136A748442964C07f68A37811ce59639FE311",
    "0x8e8D141Fd84d26C6743E9B02044a12B03d89426a",
    "0x8E981d6940d71746706AC0aaD0785A4A31c523E7",
    "0x8EbA867e62cA60a885C72444E0676641dd0b942f",
    "0x8EDDc48028E509d874C537fcc13bfE61Ff59DaCB",
    "0x8ee6924048724B930f3271512c531a285cB21a01",
    "0x8Ef786B01dF4bBEEc6CE0585eCc6a995E4CcB526",
    "0x8EFaAB510Df625bb9b6398d5FBB4416A22608363",
    "0x8F049F77f04B5ECDef56FE0dE2eD1d1C9019E83B",
    "0x8f052C835B71DF00882C9D677740691f3f57F13D",
    "0x8f10eFe9020de0eb16814AfBdE91b612e9BcfD3c",
    "0x8F1e1E8240c6CAaA69b33D7e7C433f9f06f326C1",
    "0x8f2509D26bAFb5101382bC858eFfc8e11557b69b",
    "0x8F3C6aaB1f3b29f61Bf860cB766ce0F6f2477935",
    "0x8f4015098E9d03724153Ea198902663E5EE5a07f",
    "0x8f411F92BfbdeFa52357f8D605368affA4fC15CC",
    "0x8f5A9FCd87Fd07fE6ce71eC53Aa621be2C6b7E3c",
    "0x8f6FDa4e538d26090aB38B5f04EBd958D3aC1C59",
    "0x8F72C3b6025CEbc89d58b357c9066D576cc3bBB9",
    "0x8F8a1e5113b11926950185D74567DBafb0AEce0b",
    "0x8F8E94983dF0FB0F22468Acde82A75Bdfc01bCE4",
    "0x8fA68Df5666e8C2390Bf7Feb453c00C60216b07A",
    "0x8fB583e71e0D05B063cF89a82997e90b0E26b7D5",
    "0x8fD0DFCaa906ebBAA9cD261764a4C51cE0Aa398c",
    "0x8Fd6D6c3585c3E64eb8F979cdDB9c49f1B4d969F",
    "0x8fE9169D1F693C7612029a941da88d2c5D6715a6",
    "0x8FEcb1b31C1168d14434d4F1850981cD764D6eC9",
    "0x8ff5bb3F1485218D2386244332A8bacdb90FaBD6",
    "0x9019b9Ce4563e98adf4E2E49f18828E2A66F4933",
    "0x902Ad2a4B62fF0597840eac1D0fe7Ff661fC04C3",
    "0x9036e214758D06286d2D144C23858b4CF54cd7db",
    "0x90482846f144C3f52A3ea36a3b70b79bA6d6C596",
    "0x904EE67b324Bb589dC40b95930F933214324Dc6B",
    "0x9054BCFf5e34326f8ad48eA1B8821734Ab345ACF",
    "0x906716Ab23949EA0Ca92703cE456Bb5b7B6AA9D1",
    "0x9097E3eab66f788bBDAb5d0f63ddD8d96FfF8F1E",
    "0x90A7D7a5abfa5096bCef8dE95dD44138704Ab3C8",
    "0x90B6b8BC266AB404fC863F4526e4E28b6d15C9C1",
    "0x90B8f4a87aBD2C05d7B5b8074119832010605070",
    "0x90dC1cD8da9858a8bEe4436cC9761c3C24ae77df",
    "0x90debCE0637Dd28B0b1800f66794D105eC24D5Ad",
    "0x90f666Db9111Bce1847e607f565e7592B7BFFcBE",
    "0x9109c5B9a5030532B4F116e055d3B1f1E74654CD",
    "0x910aEE682661cA4a4873A5b9426A87F833062e2f",
    "0x9115B05C877Ac8F2f8C02aEAEA35f58427790E66",
    "0x917acc81aDF4f8B20C625e0a38A5D8264dC608F9",
    "0x917B0aCbbED66a048BE5A78445843d7Af70D5751",
    "0x917FeC482C0B7aD5e54e0199E387F3DB46968a58",
    "0x91931fABc0BE8BD38d0E6784e98540a494aA815d",
    "0x91A5f631c8DB98011bA1F19AF2C3e3FcfeA7d0C3",
    "0x91C7B1c215F0b8b0139AC996efe9a43f0908D054",
    "0x91d1FEC86B794580D67Fe4Ba10AF8ADd43849bdC",
    "0x91f50b90632E33b70E295512a688DCef614Fdd71",
    "0x920D2E47A0A65B9927b1a8303637f1d2086faB78",
    "0x921D05c43736bF10C70f52BcB64199198Aa05a21",
    "0x9237bD75b6d58C9cAb428f131ec2f21b036d3aa4",
    "0x925ac57B5DdbE8238bb0Aac792A7d8b173Bf76c7",
    "0x925da450f4709dBB301b03fe27b6F6c5Ef2BE1ba",
    "0x9260f95898fD5426fD9Fe5d2e71adD9FC13aC9e9",
    "0x927705d26Bd2AACfd0eD7492e8e21a86fecB4D1B",
    "0x927c34bA85E813C4D26cDafDe939370087C373f6",
    "0x927EA8c249d33684e881174a1B53f1f41AD518b5",
    "0x9290745A459a476E5A73F0c49276139a5Aef2a84",
    "0x9299927d1B01a3f6aab7d9267F14Dc4135f167ed",
    "0x92a58ADF0a0a180f9aB806DeC93ff4a344ccE5f5",
    "0x92b1b677728e36734D59067A4Ce53E5BF1F3A2ab",
    "0x92b224ec3f99753f5b3f5E2Cc12C09a306D99FFa",
    "0x92B80127e2C7eF63778eB275a721308Caf181623",
    "0x92Bab965A44fdc21c315969374a1658228B8d2C4",
    "0x92C3f102E958e6C977bFC342e1223a27c80C5E5D",
    "0x92C4C28e0599b6BBe5ad11472510E2DD2D9c9f9F",
    "0x92CC05D09cf6b7Ce6178b5849778f7821cA52889",
    "0x92d07dA081da3603fCE208A29f40C22b8cc6A840",
    "0x92d29DaDC99Cf8F512c26E6779c96B6F320f1De9",
    "0x92D6D3DC53E657e22F2Ed3Ae34b1128d3b1Ec9a8",
    "0x92e28F52d4476f5506fB27cD6699CFB6687eb8E9",
    "0x92Ed9731D907bcbeE5E792eF3960E2612b1577a5",
    "0x9307547D686B2909b4c4EB932777A2d5615deCE0",
    "0x930fF081A134AF781d4B5a8314AcfBACe2C61799",
    "0x931bd858fd7BC2960F51a42489B84805881036cF",
    "0x933A2ca5cb48F1DaB0a0E517F667c240E42Ad6FC",
    "0x937793Ab079Ba9A6019E6239DB1593c0C4c2461d",
    "0x9378b6Ad152DD9dCaE0E065FAfb584b91ED38768",
    "0x937AF09Bd43bD2601b21D68f5A5b7fdaD45795Cc",
    "0x9390edE6592557AA1938715528706573BFE84814",
    "0x93a646E63c4e12F7D7D25C2fb91d4f48b0c45EC6",
    "0x93A781d6e6a8E8916Ea766A40c46eD2064b55141",
    "0x93b9544622e2fa303bae8Fbe4ee402B1Bef9154c",
    "0x93C838ADd3Ac72B42F65417408F900a7155E1bB8",
    "0x93D849A31aCeA594a116B760Bb6DD71BDE536970",
    "0x93F2a241EDB71128a362F647eF177dfC2d491EeE",
    "0x93F758c3A2a307027192eDa5544fB65A90236e3C",
    "0x93FAb492944A1F140eC6EeC82E2108e959DDC77B",
    "0x94020ea06109F487Ce45174CFA4da4513d38E098",
    "0x94042981fBe827237Acf0d49bbb51FA8c1c56AA1",
    "0x940dBD89E5E2fA0f0A4EBFddea8E5aAa37D6C96A",
    "0x9414D55BA4ab0a5D2ebE93d1421309C593159CA0",
    "0x9444e5F5733173501322C425309D511782E876f3",
    "0x9448e65344569e1C4cceDb02fC06473eC3741475",
    "0x9455634d4609acFfA5fe774AeB7EfE3Ba2790D34",
    "0x94644d2471AB7aa4667F6c3De21c5C9345B132C8",
    "0x9469c98Be5AFD94cD601E094bc401dDD37F480a3",
    "0x9476e312538a434050F0512C43Fc1eEf75f0d3A0",
    "0x9478620D6f20535e36418c99A6ca2c8e6D6927e2",
    "0x9481D8bC76Fb1b7D2F95733A6Ec0B40d0cB1FffC",
    "0x9485b52038b7D205B061856d6391D9218F76B31C",
    "0x94a0321182F95B4b54537a6Dd78dF5750dF3513c",
    "0x94a357294FCdD3D02428BF9C0b0402B65afE0544",
    "0x94af890352046Bd6bc6fD70c5834561cEbC499c6",
    "0x94B927B7D0459443BdEd588F09d6CFb3F71D19e3",
    "0x94D5FC4b9eA823a5AD9A9d478e35193ca7741209",
    "0x94e129eA7Bf1548E029ef768F2ffEFAc92EA0400",
    "0x94e8F6744265Cce1c9FD7D548Cd46f53c83bE096",
    "0x951caA28EAc03Fac390699a8516717C0836482f1",
    "0x952DD5887bD9a061768cEC90e2ac8F3C1ed21480",
    "0x9530d99bfc90Bc45131652B2D15f229CDfd72C5a",
    "0x953b0f8aFC70E0FCa9E2e43B0A4914be002c4e94",
    "0x95475e43f2F872529bd0b69E687b91085A01cDD5",
    "0x956E6a7B73910C58B1141E8376978AeEFa0271b2",
    "0x956eF353B36ffC3c34Bb8d8107996453AA560098",
    "0x958f5ee318e6CAf1Ec22d682A0f823dAAa70D758",
    "0x959b907BD69418EAf05C8103E181101e0A8B1D5c",
    "0x95CDfc7f37Ce3ec32e30c1B2A8cFb605ACAc00E6",
    "0x95e09Cb608D6333ff0904763851d548c25342739",
    "0x95EAFd15a40b321ab0E3c4634FdFd76a883B8445",
    "0x95f115B6bE37eCa114873F1528b0C5818E665EC9",
    "0x95f4B329E61e7158e19E0a157753f748ab0025C8",
    "0x95F84e30595B324f64Ae68Eb6Ab925f5C4b02ce5",
    "0x95f911aDbedFFBC6861ede1226E2a330eA6996EB",
    "0x9611837387070852F57f3Fd812A826E44b6B7422",
    "0x9620a37c8585F4f750FaC5Bcd5902589C5C97856",
    "0x962f20DB534227674c833896745ea819b8c033E9",
    "0x96457F561B850B807218CE3eF1d82e3B77B264f1",
    "0x964B97414B1564aF17bb153C924E81040C06B91A",
    "0x964Ef3218d8815eCfF89e0aF40098514D05bA1CE",
    "0x9652019B84Cf7ddc64aA4cEc191D9eE54C72Ec05",
    "0x967C26f060c991fc630B014901fd1eFb33B2c82A",
    "0x968794B44F79079B10CA33e5584CfF591e590461",
    "0x969613292595fF7ebe68bd89c2840b82c0E59d74",
    "0x969738b8fe2bE29af0f380c2A0F86d204F93acE8",
    "0x96A05F18a204DE549eBb2c21806934dA022452F1",
    "0x96c5fd56764A0a77CCA4978dBE0f53aD3EA4EE15",
    "0x96CF76Eaa90A79f8a69893de24f1cB7DD02d07fb",
    "0x96Cfc952e0a0630807dB61dFA16622380289DAbf",
    "0x96D6cb942BB01758812b7f20928f6bCf8fCB8F86",
    "0x96E99005a61c641150a5151B2B8Aa8d40b5Ffa11",
    "0x96FeEEe2B37C3308cCe6D3f580E60Ec44BC20878",
    "0x9722d3bB786b5a29C4F8b32fbbE8ED4a609843A5",
    "0x9731Aa8C1A2a84a9Eab610FeF770AE863681C90c",
    "0x9731B0c8436C63cb018A9D81465EdE49EcB0390E",
    "0x9732dC5BecE557f0F8b44696703Ee5ef9F0CCF99",
    "0x9754Bd3E34602C2b5eF0F23b1A4325427772Acc2",
    "0x97756a52dF833fFfF9D2FfD157Fd8c597126fb44",
    "0x978a6C3e3d07b69e73D805cAe28644395550CFf9",
    "0x978C54e840D37e0fBdbcf2E2CB241D68a92a950c",
    "0x97a4E84a0c1945B0162B2A92f9f566B7Fd815f70",
    "0x97aa098205CC4F50EeB2cdbfA095f4ab239Fd82b",
    "0x97c1E88cE4ea672F8B60D2447b86F692556f76B9",
    "0x97C28c835CE99b23F63414f8989ec410Ab41f52D",
    "0x97dA609B065776c0a7E533b9A328e1EA1BBAa462",
    "0x97Dfa8a7d0f5C29234bFC15569700C0d4fB5437F",
    "0x9801DE82890609bc5BDd304F90cd1D4234fB5fcF",
    "0x980B7D21C758b6e135cE2186c14264E686b2E840",
    "0x982cC5B3B81d3bB8896FFB85F0bA1120B711bd56",
    "0x98319d1e04423e75E3C2D652044cc815Ca9df597",
    "0x983dfE4AC5e827221eC2E1Cf271cf03159EDE482",
    "0x98480390883FfA534c6937faBbc17C9b499518Bb",
    "0x984b89aee23be4Eb1e6C1A83266cb6cA17B49F02",
    "0x986392F7E2F2366DB6faaBcd39f549E4515e35F7",
    "0x9887A462B2625da8B85b39DBDe7a47A9b0582F7A",
    "0x98B0eDeBf5fe7617b098127c445c64D914720858",
    "0x98b654E1bf5ea61136b8fec696615d952288DCA4",
    "0x98Ba0015074828387566fB8d6efd157Dfc0A9513",
    "0x98baC2424874fB647CE5F063b2F3215cE381FFff",
    "0x98bB8Ec8161C1Bd4F9F61b290Acd4852600fb870",
    "0x98BCFB12AC9F2FA7CB0Ec582B3ac04f7aC548A25",
    "0x98C6D2b6627b0388E15690381708961Fc4f5A4ab",
    "0x98c8C2b7151f420040817949435C7Ca6E988aFCA",
    "0x98d2a36205caac5F496D25e3E8C0eF4D737C9b5F",
    "0x98d3093fFd690E23bC1281241D292e1758081BCc",
    "0x98d87B33661c9A10f8c5d51E65146f02C68f59F2",
    "0x98DAcE6c4A0F4F73C60D2782B0808114DB12Af25",
    "0x98dC8d4a7baC744567426c651eD9Eb878b220354",
    "0x98E9c8c78597F6A2Ac32Cc0D4C4cfa4118875bF9",
    "0x98F8F5cE4CD902F20CcadF3b6F12905fBe361391",
    "0x98fcB40976f18BCe50d090efa0E284995E300242",
    "0x9906bF72A86d4f692aFf03881963918d4c1F4A8C",
    "0x9913adfD760358D870C4B52A0D4E04f2F303BD1f",
    "0x9926971445d984462862cB956Fa73442dC3bca1C",
    "0x9937b1688Ccc4A2362bA4071FAccCE8506907044",
    "0x993BB1B703e21B5d9111434D346067852Ee4f5F2",
    "0x9956923aa07796D66D5d88d185D92f8b84a17cae",
    "0x995CA5dd93A9929335774bD444611946591A026b",
    "0x996666De859b274CDc925eB890Ebb39aADBf3317",
    "0x996a254C865b8419C5BF6Dd219bc3f20dAbe5DAC",
    "0x99790C4E8Bb78eFE2B487E8D1fBA10e94Fde311D",
    "0x99AE1dF57515447EE6634044a16A59d02865a12B",
    "0x99CC08828dbafb9038E0bfFDe4Ed176b2c237019",
    "0x99d95Bf0a3effE362ce9D9cc20AC71AEf1E5fF1f",
    "0x99Eae968aef89c9C669cF00cCC6883765090EfD5",
    "0x99eBCa517FD9741118Cc206CB97863D0e46b1fbC",
    "0x99EC5FC2B35320ffB64B0ef55B231866b3Acd727",
    "0x9a0e493bEed115Af32C550A6B412CA421b3D1fbF",
    "0x9a1e10F7c001fFA131dd54dD7dD34D635ed71BD5",
    "0x9A39F3110d596dA22530A43780BEdB03a9405e3A",
    "0x9a3Acb42d506767f7d83C3b6F2EaD417adC1CDaf",
    "0x9a3C64F93f609083cB122273c99e0B99762a2EaC",
    "0x9A3Ff10Eb95c55D3b544D2bb535E8f81C7888888",
    "0x9A42F0327f99ee64BD662fE45d8239f2740100e2",
    "0x9A5323072ca95c3951C93099127cc9821b5b5E64",
    "0x9A55cCf605ff9D08C255D766b2DfBeaD74840053",
    "0x9A56BAcBB11283D60D3Cb0f4aba2b33083564972",
    "0x9A57ea4b1E64CC64B26E51291441ca1d9EEc045a",
    "0x9A78A4D0723a224d89374FE48C4FEB589e67c773",
    "0x9a7DC5307940fa170F9093Ca548bDa0EDB602767",
    "0x9A993cc3e239903D7b2C0C43aeEa8fb65391Ccdc",
    "0x9aaa2103eF53E8173F307C8cb9414Cd282C907ac",
    "0x9AD53944b52e271f1114028B918202CFaaeC0a3D",
    "0x9aF08fF9BCDF902260C41FBe372183159e8E8888",
    "0x9Af8Df64CF966aD71188fFE39466F0b4e1aDbDDB",
    "0x9af9faC4FE4fDa4D5B5330997BFd37603cCE4A10",
    "0x9B0C89b9E698Aa887Ee51AF06eF63DBfBDE2bADc",
    "0x9b18B7f514E3f9B8B4F41f51a1b03e55A9C8C890",
    "0x9B19bb152203CB9ee353ab092135C49C2eD013bf",
    "0x9B220C39d91CABB77132D1E7A4F30C6501aa3AAa",
    "0x9B4759E670848fdbA7A6b86D18788Fa808A9fb07",
    "0x9B4dfc94157F7F69f2125DC0A7DfD4753A8BDbF1",
    "0x9b6238a2957CB98BbA22532AA35D4Cd4132fe6e6",
    "0x9b6a5Eb4cD063936eEC1e1A0687793C4095E8790",
    "0x9B7c0814eB341E6A4CA673148e8b577b13E70787",
    "0x9B8e40d9d0E81f65D68d2f8E33E50B65E11B53eD",
    "0x9BA1e70DE2917243082404eEc8F6152916432d11",
    "0x9bb524bCccE50C6a3606CecD80CFaA38d7D4fc26",
    "0x9BBB24e8A2e475977929D053F4E53A090962F06D",
    "0x9Bc21bD0DA1701386c3fB3C4Cd70BA0d5dC16A46",
    "0x9bd81F731364468E539715B2E8E13CBF3ECaAC31",
    "0x9bE8b3aF14608801367075208FFd70d1b6b0F768",
    "0x9C1aAAE61d6d38BbEb79cC24fecca8279e434B19",
    "0x9C2EcD52e83A5fF9d0c981570A9C6eA044483410",
    "0x9c391a0CeEb28BD4416d5C3Ff41a12cf0287D75e",
    "0x9C43B8FC9585f2aeb9193429d57174915B742779",
    "0x9c5905A549FF345D2262FeD72A359cD41d9c748B",
    "0x9C677ef2B3Db2470fF15799fDa3E3b124169E80E",
    "0x9c6BC8F4c6bd63D0708Cb607B444B15973fC6108",
    "0x9c748a6b2fD26757f6D15b82f4bF7F7aEF66F4Bb",
    "0x9c74aE08Fd4337E14786f086D911E964df35e623",
    "0x9C7eFb0BcC09283861cD06eA5CFd1618989a4cFa",
    "0x9C8B6Eb4Ef93EB06246FFCf7F6696D28318B77a8",
    "0x9c8eA884f5706e77BC7EcA1a9584467D0d63D6b4",
    "0x9C9C45ce02fe2d66BfF2f2E6EB381D54c3a6616a",
    "0x9cAc513Cbe53Bf6fd8B3aeDAA0d9d095AB14F1fa",
    "0x9cD096C8aBe256DeDC71d7f50f90F2f7daD77dd6",
    "0x9cD72195423ED15ab6A1B1CF6a5A93BeA7049c40",
    "0x9CEd362e878a58f34b57EBFd8dF2d04E3b46ef13",
    "0x9CF466A3AB16c7127E046f0E7F7B5b020472295d",
    "0x9D0A3B3049F949EfA3Ca44660242c1E421Af0CBf",
    "0x9d1DfEFbc6A4aF8ee33B184Fa8a8cD14dd1d36d0",
    "0x9d1EC09DB84893FFa4E449A2117ed42129786bD1",
    "0x9D2E431A3010D9F3aC3C1f5aCe093Ac1f1d102b7",
    "0x9D31FDAc3f68ed23B523bd054Ccb3bb6F647AD98",
    "0x9d356F4f49CE1eC8094a55f918D6e5C1cb07D47d",
    "0x9D5Eb9a24e9AE397e1c001eb9F0c2FE5f6101eB7",
    "0x9D693e28fBf01799eFE33c1CdcB1Af3211fF6e51",
    "0x9D6c53eCCB0cDF4b09C9Bf42e99644cA6eFcF2D0",
    "0x9D8958DBF1072Dcfb43DC210c1717B188838dbFD",
    "0x9d8B59de3E39F9C45ec05854f2FC8225932fbC03",
    "0x9D8e00BB56Fa61C58926407334e0EAEE37B27d64",
    "0x9D9DE0F6410A89c5334d5221B4f2104AC87F16c0",
    "0x9dA0c6511a1fE6493c06Dbb5413a6AAFa1262012",
    "0x9DA41F486E8FdAb4Bbb36A6864Fba38B3C47f0B5",
    "0x9DA6eE86A54217dd3011F086C32250743e5b829d",
    "0x9Da7363E64180412b71AcDd533c380d2eb5fF78e",
    "0x9dB32b92a3026544c8d5Ec2222700bB0A4d5A901",
    "0x9Dd013a324f3088dc8C41Bc06700176A4203fe9E",
    "0x9de5Fb2e82681CbF0f9885b2E17c7aADAF7c6a32",
    "0x9e08B5dE4552f1909A5B47d85F64F536725d44CC",
    "0x9E0A7236f8d77b8215D4E901f09BEc78325F4948",
    "0x9E0a84E576F907fbEE9891970fD5f271BBF33475",
    "0x9e18B5825C79cda38F25e78DC36bC3373c21696d",
    "0x9E19bBC9bf96CA39Ab067e0ef21312B6c0ca47aF",
    "0x9e204f72815936822449Bf4aC0fF88c8428BEE07",
    "0x9e301190D0BDF64e287d6205d86c488Fbd37d4F8",
    "0x9e49b7869A5014d6778daE92e27f2281041cc30D",
    "0x9E640BADECB7C628c6188b74488823E879F42A1a",
    "0x9e69b631C6cD6f0FCDAD10909d82D75d56753C93",
    "0x9E97Ebb3BA5e751dcbD55260CE660cDc73dd3854",
    "0x9eA32b637C81eE3C56cac728FD71ec4bf3267dd5",
    "0x9ebE694188D3b16d2050E48fC21C846E3D929455",
    "0x9EC50d172B38466f16abEA5431387E079708bf8C",
    "0x9eD40f89f2201af94d498B60d3420122C9962de4",
    "0x9eE29D5162dc316861bc67c999f7BA66cbf15f59",
    "0x9EEA822800921Cd4425d86f0e797749B5220ce0f",
    "0x9EF95e0e162B153aA5B2D24d03846A09e712eFa9",
    "0x9EfAEF30d5742efaBb67C3bDAf77d3966FCB4a2f",
    "0x9EffAF1eBDe0852D2b8E45f9Bf561115dbE39466",
    "0x9f02CD48B13e68ba2a1B7a020Fb72b0FF83e451b",
    "0x9F2bFFFfeC3654bd813D98A7Ae8eDff8C15eFB7e",
    "0x9F2dee49af076Fddc50FFcdb9d7B5b69ba22F754",
    "0x9F35245a739e909cD79c4be31c1D8409A94841c4",
    "0x9F5dd816FfF0127E1961f8564A3B8deB23dF6bc8",
    "0x9F6101b9Bb3471c1787A149C37fe5D71cE099e5E",
    "0x9F679ef626b341afe058b40058e115Ce208A3d2B",
    "0x9F836913343C0B46771206De4018Fcdd0D76A271",
    "0x9f97aF7319Ad3c40d3e6ED2176F32fEd7DadB7Fa",
    "0xa02918549B8b61c687E0dAAa328962a8027b77C0",
    "0xa03f0E20a38359DA8bD844Cf850eEc14AC92E86E",
    "0xA046c5C959c9bA5CaD66EDC0bD69f2f26e4b76F7",
    "0xa04D55e917B04823f624B93cE2DFA31A6396facD",
    "0xA05989136B309ae4aC3C0c14CbFC5B725aA84aa9",
    "0xA06e3ecA46df7e71238ebD04fA627BFFC7d3EbDe",
    "0xA072be69651A568de4f9Eb6C6048e1f356d3F639",
    "0xA0864604c1ad0875C571104f05CB9c1d8FE7C7CB",
    "0xA097B835CBe0531D005B95930F76f8552ccF9924",
    "0xA0A3BB266507f3f20Ddf3746dAf2f989237af826",
    "0xA0b4C547aC117d16CA4E00e8ED930bBAB13194e4",
    "0xA0b8185Fea3bffd8670BB42960B793e2FE2091B9",
    "0xa0C151c2951723e2Cbae94239904B2299A18bC8c",
    "0xA0Cb05BddC1E7622aa93C4B8Fe3B3b5249C9D2bA",
    "0xA0e64Ce44447d1D1f38424d67e1C1fcF8770c0aF",
    "0xa0EC43568b4D667b10247d2FDAA3978a14414663",
    "0xA0Fd1BAdDF6BAF3b858B40f606E490DC0262E848",
    "0xA128923d3951eDC01d3f7C942DB802B6C3AcAFE0",
    "0xa14cBEe5c10801072005303617f7328b519de839",
    "0xA1529FF79918eDBf244a3D5d935d045F04408aC1",
    "0xa155bb0f8E90A6300C36Df6f6Ba5f5fd120744Ac",
    "0xA1A9bdE747B20b6512673C1851FA1A4E27921276",
    "0xa1B32581EC3bb4c85F47806Bfa8566aE08989870",
    "0xa1b9B33AA2C318EA67d280CFF079aAc2D4784A13",
    "0xa1c3dfA7e16b9C745D629182D5B4Da32e00204fc",
    "0xa1E4306004D3d4d79306e42F56db1B9381ed28BD",
    "0xA1ed22466308B1d4b2Eb583d4fE049d785f8b647",
    "0xa1F83b0817F8C4E66c0d6d4F2B43d705A51d96ED",
    "0xA207CDAf9b660960F819466BA69c28E7Cc8aEd18",
    "0xa208E50F14Aa6323BC66DD5088b34a1adD78b723",
    "0xA20979631bFa63ce322990aac509452145f51e54",
    "0xA2113f1E9A66c3B0A75BB466bbBfeEeC987ac92e",
    "0xA2209421aF5A52263d659e5AE72f5E2606e47725",
    "0xa224342d831E2EBE62b9ae8936e598f9A9877ff7",
    "0xA225Cc049e99556EE497bBe846DBA785A9bc1428",
    "0xA23a623F54b9688bB0941523cf3D821291d1442c",
    "0xa25475c9D7E33745556d022f20C2C4262238e900",
    "0xa2600e2517306649244Ac4dD8A56eCcdbd4c49A8",
    "0xa261B72692774A0d6B90bdBC6cbc3BbC836db2cb",
    "0xa26E30E5B7544c696A0c46178F55f271925d666e",
    "0xA2924f9cbb4d45E2D8E435272a4869b072bDff74",
    "0xA2b66c9Fbfd0e3aA9d474318a6B7D5eDA3103867",
    "0xA314761c664AcF68b9910f3602412cDa2c4291Cd",
    "0xA32F735FEe61c1707188588B7C08263E60f3D125",
    "0xA331bAb8231cdf93B1d8d510a7a5f61869F2E829",
    "0xa331CCDE92bF153BD207fCFFd34376824A4e960f",
    "0xA337Eee020A8F75F1B981312265DD93B87d4C6E9",
    "0xA34843914071b139c9E3CEE438534d46bFA97921",
    "0xa350633fe5d88Db553E0B4d7876a834FF7412aCa",
    "0xA351a4FffCeed60b6d4351e1B20C55E3A6fB5503",
    "0xa362DB5D39b6A509E669926d0C6d38B280dC7f0a",
    "0xA36A257BC70B23e829cAd200Ea2441b124933939",
    "0xa36D30fc6fD9B6E23E2285474CdCb9096A72840C",
    "0xA37271736c9d3E27a65d75b3839Bf3638191c1Fc",
    "0xA37D6f7285b55667348C5452dAe64Ec964B2BD1b",
    "0xA38b03e71F0E1C97F9a923680d55982225163599",
    "0xa3b39a8D46bCEf5C823584680883B79690dE933D",
    "0xA3b438E138c1b97024468A38fC2712eEec794713",
    "0xA3CA2BAFf1ae4a3927d4b6db2a2f8743F7e524AB",
    "0xa3d0cef56BaAeb68974a50b6fC4d344897AD82D9",
    "0xA3E49fEA82D17326636CeCE9C8C090edF013dccb",
    "0xa3eB41fe8E68F597E47824FaDCBEf1Daa09AcAe2",
    "0xa3Ee7fd776Fc436F0A4B464dE2A3B73EebFdC5BB",
    "0xa3EF697376bd277Fb325C5053F5a0791cD44E064",
    "0xA41D39a6bFEE305Ae6F2Cff06e8eD0796021BACE",
    "0xA42F02956cE6609923F320EcB89DcF052ad6849F",
    "0xa42F514f438775c212Fe8b46CDe00619B48B4939",
    "0xA437DadDc12e6852801b492B176B6e76f997E0F3",
    "0xA44F941b932Ecb18Ba34ec5EcA1C66221F7a4aA4",
    "0xa45EBb08426842DE626F586F019A9cA2D19880F5",
    "0xA464C0E98eA7C0B33096E420A7E2E1A67baeF032",
    "0xa482d2136807d7914EAeffc5e0277002DFA92613",
    "0xA490A0346808dDA91aea6698cB19e4697D9fc5cc",
    "0xA4A4391e36EA795760c06D32E4cB0B1968c87f35",
    "0xa4A7cfbfa7f0218A6552F921F95E4858994b8FE3",
    "0xA4a8422F64F60587E9C607042295cD2af592F812",
    "0xA4B321b3458673dC34620E355185813C1D415fF0",
    "0xa4b3e96ac90384A40814b9fdaa3a448ddBFEAF09",
    "0xa4bc1cB68c046D12bD4BFE20D76CE45408EB029c",
    "0xA4D3786210A59CC113eeDf5a30e1358Ed9BeFa2A",
    "0xA4Dd861806f3B881f927864d1FD57Ff2FEF5a5ba",
    "0xA4Fed5d0B6e9d49853b9b4c6d54D480FF56031a3",
    "0xa506c2020A4D6BD0fd849E6d47Af7936D3D605C4",
    "0xA51a48505b6F19130Df08B663b254124D095E9cf",
    "0xA51CC4578939370d3b680F145830b362585964D5",
    "0xA533a965863B6938Cf9A545dEe44653d2b2ebda4",
    "0xa54F1816bA6F939CC18a25Cbe5C51405E2c45b1A",
    "0xA5713439e7732e9b162eF5ba6A528f6935b6e6b3",
    "0xa57Be78da8235b01A575b0C309e0a3D47a071Fa3",
    "0xA57C500D853f892ab142E9172DC1CdBceAAC61cf",
    "0xA5924b2CEe99FFcBc1E1b690cf2a89fb4Ea8deA4",
    "0xa5b0E186e94982C439F32D6C65fa356958ff2e95",
    "0xA5c5B5941056590E9F95d6D76096A31cbB937cd5",
    "0xA5d1b1FeC92D2b0c76efee0ecC326d34Bf21390A",
    "0xA5D2d811272Ecfa8AcC5d3A6dc8412B41Ba53eEA",
    "0xA5E3c78E7B97B51DcBe9EBE7d6eDad78fc740CAC",
    "0xa601802E8A12e85B25D0664e72c99E58a691FD9A",
    "0xa6128171a2767bf6af3A071941D200eF9EeCC40c",
    "0xA6150B809a4FB7c2c62055b44Ee6800A84F7Ef0c",
    "0xA6202F6799A4F3198498Cc145Ad2C9c476d6EAb0",
    "0xa6227D1e10bA3aA39C0aaF2e124718B97c23DC68",
    "0xa62605c77f9807A88b8F9Ad675E3C3FCDb6D555C",
    "0xA63e03D63C6a10cBD9b6dbe76016202A72ee67A8",
    "0xA66e796B33016963BF6eaA062FA81d4254f33519",
    "0xA6a69A9978C95A47876E24f030b2Db40b6C24D38",
    "0xA6c5112a3EB52595Ddba5bB1eB5A3D1719D9aD63",
    "0xA6E8E71C4A20825377Ba359dc6E5aE3F66443e27",
    "0xA6ef5c4E1aAcC1932Cca66CB7B815B863bd8FE17",
    "0xA7170061016D10e393C6e37d774C0e661958e350",
    "0xa72bb7CeF1e4B2Cc144373d8dE0Add7CCc8DF4Ba",
    "0xa73574828268311091cf990Ae05D95eBF10F390b",
    "0xa73D695019457F9eE3Ec22AaE8dd277c07482AA9",
    "0xa7423efEc0C59015055f4c050173f92e4Fde2a30",
    "0xA75CC6a1Ca8F410E3FbdB2419Db5Bc8997D89AD4",
    "0xa782F94dFb200ceCEb9c2c350c6fbEb03CAd1c17",
    "0xA7962ad5bd59D85e7819D56d72d884C43263C629",
    "0xa79fd596FC4e1D3B406E0B23debf02dD8e9a8D06",
    "0xA7A2e2644A60AAb51A978bEd6a4e9956f1BEe4aF",
    "0xa7b5C02De6Ae3A0220DCb8081D778528020BE57f",
    "0xa7cC2E956D269D4BCD4d52711c498727B7597a0a",
    "0xa7cC956b044Fd760732CEB8a659f45f717fe88fE",
    "0xa7e00BE3502860762639D7E531aD1D35D79E78aF",
    "0xA7E0c7EdF9A81fdcd2c99A056AC42C60B1333D95",
    "0xa7Ef963a9FD90076Bb16601733038D0932b92D06",
    "0xa7fB80b759Ea191C19720f531398663b298455fD",
    "0xA817fDf9b769D2E74D12e8e28294eFa2c331B799",
    "0xa81Fb095a787cA2d81B3e16F1BD351bF03b46D69",
    "0xA8263388E47B9bFc214170C926c717A90F0f6554",
    "0xa82642A600cc4795390C353aE7C650bD3e22E059",
    "0xA8287cEfBf80C0fE480Ddc1757C5dBAB53B6e904",
    "0xa82b761ff7aA3Aa867445393d5d4111Dec569a81",
    "0xa845c6014F2e2c05C2f395147dd45c8e30D0cAaE",
    "0xA8539fE0f1115C987Ed98930f51756F99F4A4643",
    "0xA864454C1a35434a1a711E8948f28b59fdDec84F",
    "0xa874801C7E33A3f720a05fc61988A88222381Ed9",
    "0xa876F7D1b5c29CC8A86674987e80505E9De3d29f",
    "0xa87a65d8e4e81105b096C6ba4bb18EC9C849483F",
    "0xA892d9A0c80E1BF3573D92E0bF453930114345AA",
    "0xA89A9184063cB88189916D78b08582bbce5B377e",
    "0xA89d93F6AcbD8B8c9118967d849337ed5bd43257",
    "0xA8A384fCDA7B5ea26bC51e9c33AE77cDBc89ca14",
    "0xA8B6282D6655324f6CCF4f71c55f854375b79B04",
    "0xA8Eb80A0862B5A0e7E9225c3745411B8bD12Abed",
    "0xA8fA999ca9f68E3104800490029c28b3edE24331",
    "0xa9244CE7EFcee851df9d03280b7f9B4D7a08Fda7",
    "0xA929F1d8189e32cCd480aEf3b96DadA9331F124E",
    "0xa92ED7bdC687F434E952Dc4dc58f785A0153058A",
    "0xA94181f3fBC5Dc4c74F550B568318227d8A454A0",
    "0xa94804CE0489a5999D9B82307671082B6ad220C2",
    "0xa94A9c0E8f301ba5474E2Cf89C3D495b9A628b89",
    "0xA94f4c9bEb2c3241C70583dA5d9290Cd55604a39",
    "0xA9698dC18Ea7a83Cd73C1f229C036Ba2204b9FE6",
    "0xA96DE106162D3F368686769491A542F918F07a03",
    "0xA97a9534A6b9279EBB350BfDE06fF60aa6Eb039c",
    "0xA998cae58e36a01E9b51ce741E8e5b3CfAFDA148",
    "0xA99Cea65258F7937257DFb1793A89203cc7f2384",
    "0xa9A826958D4a8a96bA098060CA8B199E39AA8698",
    "0xA9aE9B0A71cf72e045F00044405335a5a7089082",
    "0xa9b2772A6065E7932FA50dC8f8fD7FbF4E28BF37",
    "0xA9bF4A4959893641031b206765E592ECD7a23aFF",
    "0xA9d2028fA0825134D1155bF41f17C04dc8D182FF",
    "0xA9dd09e434271224273A08a5342e88761E82FD07",
    "0xa9De020eFc3206332CE74e9897ee0eb9e9424935",
    "0xaA1a7E46eE261D561E873D55d515B76A9cc74B73",
    "0xaA27FcD8968C1C5C9324B04Bc4682cb3c83d4675",
    "0xAA3939e4142E2a6B866B9BdB59DECF7d578D7811",
    "0xAa4370FbBb4B498d57F6A19dEc9048d3a6c2aba3",
    "0xAa4c31888E1cE42A89e8e4C751D275E7e8d71ea2",
    "0xaa55ec46f915Ed53b18bD11EC824e85ee968cd61",
    "0xAA5b5f2D1d5BD7Dcbb36237813D42c80088D1bFe",
    "0xaa6B6bb8A39c2fB0581E5C92B8a906F584be13fB",
    "0xAa7dAD6B93F50629f3938294f46Aba53E6993dC3",
    "0xaA98B66EFf8267b0F4eab151B11BA4cDdA32620f",
    "0xaA9E27cb23231103ad94895a434d8840Ef842f15",
    "0xaaa63EC7898a7D52840AD38e58d3a0624db34800",
    "0xAaaa6a7175bBec7758A990189fb835B63605D351",
    "0xaAaC34d30d6938787c653AAfB922bc20bFa9C512",
    "0xAaC2F864496EcE614311cAF0A60f3Cd138934666",
    "0xaAc43C2e60A6e226260F47e83D6aE776629344a7",
    "0xaad8953D5e06fbA8bbAb2C2E509a009C71812268",
    "0xaaDEcd2fED3b9C1A48507B20446c65dE84e3a735",
    "0xAAE10b52aC4eF29370264f9414949e75bfCd7690",
    "0xAaeeA63e28e68126d80D5794eF1b5C5FEe64abF9",
    "0xab0e22A676BE07deC0d4b7953E1DD1661EA21dC1",
    "0xaB155bCB3571575501413D78263Dd5F913243A02",
    "0xAB531Ba201791867fabE20F23002e0f1F5F0b43F",
    "0xAb6075770b5215452D2f73C49Af759351955aADF",
    "0xAb748d8Fd1e9471091DDc16a7c6049734120d62d",
    "0xAB792E2937d0f5B3eB359539EDadA9D43BE58940",
    "0xAB87Eb50280a340b42F4eaB31db90714B39fe687",
    "0xaBa7B4ed77840eD8Fa58f48C38f35a5f9e192446",
    "0xAbee2F8873A99A836b5899775A87e7802354d67E",
    "0xac0a7C9fE59253f8cD3CFfF3eB33f938872b8749",
    "0xaC0C4CAF3C17c41D6EB01E593E0c92b51e018c4d",
    "0xac0d889B915535F0a6484e7A08B232ac0a86217c",
    "0xaC0f76A8c30E23bc197D26465e7bE319713c5224",
    "0xAc1C9149fd19d9365440F5B6a5A60f7ceE2ec213",
    "0xAc2b5067a9bF31429D6819cF5B995642c398abD0",
    "0xac2ef512d940f35E5d86d0Edf82AaBB62De8facd",
    "0xac612d61Bc481AbEFc5F32628Cf7FFa9E8D0af36",
    "0xAc719A23CBA46e30b3581b09102db85C71f392E2",
    "0xaC763161BaFca2FcC7a09620185D4bFF67f59264",
    "0xaC768d475E39fb9A3588ED342054c8007cc063C7",
    "0xAC8b275b9ce0Fee06aBFB98ef20471A9E9dA56c4",
    "0xac8b4dF711Ce34cC5BCe2a73DD5dd387F7F5f7a5",
    "0xAc8b9EEb3751BAad42362e9Ec41E253bDf2a9217",
    "0xacC8a1bD70FE05C57454108a5fDaf03269d23Def",
    "0xAcd58027b4cF764469a46F4c28Ea47FCda3B8C42",
    "0xACe1aFFC299fC7f7a835b9CB062A9CE462dDD763",
    "0xAcebb2DEcA12CF80107F34b3D179CbD1F52d90A5",
    "0xaCF4ba795d78fAb469fd602D98ab6f510F288A2b",
    "0xAd008Ad5F5C9a0405e095E7d58c6508071e03F48",
    "0xad1C87A64586e59074Fd7301713DD11368fa0f39",
    "0xAd2CF7184A5cADfE0379da6f531aDe8B3aB1980D",
    "0xad3f6797F849423730F8258bcd7e4e0fa10Bc894",
    "0xad40eB4807557B6B922f6e52CdFA2058f64Bbf46",
    "0xAd5786E241088De13FDDbC5508794017f4ea3656",
    "0xAD5ea0a1EB370BaA037C6F7708CF7BB31672Eb08",
    "0xAD6123696a42Cf1B1eF7150C7d6480b1D94Cd9bF",
    "0xad73BB169866ac5d9542AF250574A1C3D83C6295",
    "0xad7DAa3aDB8370d014c92aaFa19c47C68c054965",
    "0xAd964858f404D484DDdCc189df4890bF4298E930",
    "0xadA13FC7089745118D55468d8b384f2697c33e14",
    "0xAdaC515F964C6d48A80a1076E23750687bD030B0",
    "0xaDb8CdAa5B5920E86747413EF4BF7F9546c74Fe8",
    "0xadc28d10429D2DAbC08f0f664A7Ee28A6c882920",
    "0xAdC8ebD41f6F37C94aA69d9DF8642939F70F4b14",
    "0xAE00ed81B4A1246Bc6fcAe8c129376C2E14D242E",
    "0xae0D16586e5D60D334624c115216a52B9B1A0335",
    "0xaE235CcA56d4c715303ce00FD3ba124Deb28Ffa7",
    "0xaE29D39DeA562B5a438C534bEbD3916a3EB94A69",
    "0xAe42B13CF992FeB85eEEf0c8B91FDDbFe721C02c",
    "0xAe7C585Fa26840e58a6d010Eaf3dEAD86Ed0357f",
    "0xae8D6db8abC4215B8bD106046ee0d709b40c46f1",
    "0xAEA3E4bD4A5250ec413e31B95126F3f997493a8B",
    "0xAEaA6e6e640E9dB7447d9f064691796CaDf7f9F1",
    "0xAECb6F933242C687DB6509ac1107e75d00cAD5eC",
    "0xAeD3013E97118eAC7b7635fb32053f9490d2038C",
    "0xaEd960d3aAAF8F71897f3040148fd0EEf69A30d9",
    "0xaEF00600AE10cD7D19dA6B10F2E0A4bd5079cBbb",
    "0xaEfe83da2Ee48e92A194915f13A3046d6336CA0A",
    "0xaF14020D77E37634dc32D42006Fb88C891EC63cc",
    "0xAf38c872C313b8c09d9EA9585B5070e964927c46",
    "0xAf411321b458434bf1D1CC1556A09a9f54cECC82",
    "0xAF456F8802638a28DD1De67288e82EE14EDF4A13",
    "0xaf5D090ed0a925f987c08B07B1a0DFBe9E54aB26",
    "0xAf661962FA50fe0A5A1B0eB4F6485F6547de710A",
    "0xAf6e7C71a7c5CC7335263CE34B03D3849D02F52d",
    "0xaF78275fE7c3dD9FE1698963942F548a3cd32bE2",
    "0xAf7cF5910510B7Cf912c156f91244487632E5fB6",
    "0xaf8C40143c2c136D6CB11592D90A5eC957744ff9",
    "0xaf90670C538F9Fbe02a5a0C42fe6bCe124B4beFC",
    "0xaf91f3570F5c25C0899225Aae251A5eaeF286EE2",
    "0xAF923CB23E15E4da52B28728ae8964FFC909Eba0",
    "0xafa9057DEA4ab5E3e01F5526C6684a0BA409E818",
    "0xaFE6e36Ab8C048a24fE58078468c5b82989425F4",
    "0xAff4372a4ceD3bBA7858A7072066F363BE2be078",
    "0xaFf84080297f7F5c319642E8BB7C762E1Ea3A12E",
    "0xAffc71A42b00DFabfA7fc815536D07636DabD046",
    "0xB007C70FC157Dc7f30cC2bE46c9D74eAb93A8877",
    "0xB02ae6be01E1920798561C21eb26952Af7549e69",
    "0xB030E613f33c2AA5C0cfc20aA38153C0460CD337",
    "0xB053C45aD1d215A38488458C86D6a1Cf01726420",
    "0xB07F83E4843A05F00B794bA46B1942A5FC0c9710",
    "0xB08FBA55445e454AC3Db072c450a773DcB515085",
    "0xB09c4456f90F7a680429950cca7eDcC953c24c91",
    "0xb0B99dB093571720135DDC0249d41D165110DB88",
    "0xB0bb83a970b6E1294D670aCa170E955734F8e0Af",
    "0xB0bDD53b627d7e61cFC5C13EF110e47e210fAc6f",
    "0xB0d2659052f892AD4Ad3f9720257acD14865958f",
    "0xb0E14C90A3411a99C47c4CFa201a5272280929Da",
    "0xB0F9B0fE4Dc79542cDBb07CAD797Bc56F9978E9E",
    "0xB107E13e2757384D8ff9161a801A7D731484C717",
    "0xb114Db55f6e5037221b2483B53A47D996e1a0E6F",
    "0xb11F75F36ab531150DdD65a35f45E0174F69f730",
    "0xB135b48e52F2D34B51E7DeDefDe2c54Cef95cf98",
    "0xb139F7901a2921A15278196508c575B4f52cD150",
    "0xB15f55B848B56F80a08759C4064cb2e1957be6c0",
    "0xB17506D5F15faf2194c824b51282AdDeFcd4b894",
    "0xB1874aB8eDa4C6c97F3Efe929fc6d544F5c72a6F",
    "0xb19F19B900027fBA2672Bf56b680204f625D7a24",
    "0xB1A0D61b06393F4B1Bc93A5fDed8D5d3B21c3bee",
    "0xb1ab970C53943329CDBbed182b4E7549ECC5cACb",
    "0xb1ec36cc8dbd68f60cb018B1A57E9a12d0d37D4c",
    "0xB1EDB8cA0c036B4a9b789921Ce6e9ee2e0953522",
    "0xB201ED632810922B12A3A17F7abBd4F77C74cE5D",
    "0xb204a59d997eD3777693F03bc6F052bB82a92BB3",
    "0xB217967c62e1D5D7CcC080Db90B78378a1081389",
    "0xB21A9D7Ee58F13e7343AFD77D662b9Be6a9917F8",
    "0xb238cB525B96Bfd1BFfFBA6A26a510552a85AEc4",
    "0xb23AcD6bAb5C9A06375b3613560eA9F036077448",
    "0xb24138c3Ed5729802caea4e3Dcba95f32037309d",
    "0xb2514B4e05A93382ce488c05D48a10087196469d",
    "0xB25392dCDC4e91972C2257FEdfbD82E6A2e8613f",
    "0xB27C03F47F45d69231F94814CCB2dFeD1eC29204",
    "0xb281e92076AEB49F6be7CDAA4281640873C84D02",
    "0xB2887DCA5C0F760E889aF14065496B0730e8373b",
    "0xb28e6c7c68c10e626A6c2772e23e836eE15884fd",
    "0xB29c738240128eA576Be6ab5aDE629D9619FbeB0",
    "0xB2B371CD55cD30E0C84599ed474CfFaB95261B6f",
    "0xB2B37Ef49BeE774337D66F906d99a633bc63434a",
    "0xB2C59100ba9F3e2367796854bab2b1F654b5976B",
    "0xB2d0DcBE34d5A1D08f7641673DA4a67ca9c6105F",
    "0xb2Ec47c092Cd512EE1C01c23cFDc335BE1BB26EA",
    "0xB2f175154c52C611555BaE95c21ec3A9c2574961",
    "0xb2F754BFaCBea5D3FDf6c6b18932c518B13285bf",
    "0xB2Fe9f13392AC3143dff97E083BBdFdF68cf4F57",
    "0xb3063910072A574D7940eC30C0414A4042D5AF06",
    "0xB312564208D4911Cf484349785991aC93843b24D",
    "0xB31Ef912C68b1f52b693D7E23Dfa4a7f22F209bE",
    "0xB31f0AbaDFa100D9a27147e5f6504937eD3C4779",
    "0xB320C1724b25eDAf4a0F23471DA5c31147e873CF",
    "0xb32Bf0A9EA7DAa95492d71225ca757A4b3dd4BD3",
    "0xB341494a37D8e2579C31e9bd2F563dB3C1D8b937",
    "0xb38D8Bb9a86cDAa5D59C2975F6C0E66E1aFb662b",
    "0xb394F1aa30Ba874df3Ae6097bF4c2474b2d8F3AC",
    "0xb3b351E945751B4bc3846F05F6d7645D339A08E5",
    "0xB3DFBDC79bB73004F16459e9aD1177872cAd5E23",
    "0xb3e1EF38c290016dbfc3D13d1C91c32B6ec0C0C7",
    "0xB3E9b93aa838059A8A2Cc55eB0d75bDAf5367627",
    "0xb3F6972aCE0ceC4A614B5581a6bB715AdfC1D7eF",
    "0xb3f9BF5b8CB8D2A8DbD5DedfaF16681E19B1F152",
    "0xB3fB65f87b774C346f41b48882BAe1287182076a",
    "0xb3FECc0909B410B01E3c25E6f131bf31173532E8",
    "0xB3ffD0f321AbDE1740F6E13BE273348BAAd24291",
    "0xb4009f0234f80A0f37fF92dd924b76c49e4567C2",
    "0xB4112009Dc50e0AD18fdB58021f28A7BF75c2EEa",
    "0xB413eE173e07D7370f49d6dB28bC8c8C4e9a2ac9",
    "0xB42272247246547E4Fbd1E74a01118aB57eE143C",
    "0xb434014375040eAcCd4ebcb22ab84D5dBbA59360",
    "0xB4354fAe53823E690A48aA3a5abED56036ceC9f8",
    "0xb43c037A71dF804a8De3B51A7Cc486c15D99A4B8",
    "0xb44764008673C36BfD4507702BbEB9eF3df6815A",
    "0xb4496906D6EA2685E7A46A14BAEfae9fe3bF0D2f",
    "0xb46aF71a85dF721fb46174ba09c6Bbb719c77545",
    "0xb46d237c2Cb9162d0d9d94fbF3FFc6411d2505Da",
    "0xb49cC6494b75F84AcA36160E859FcE5c5dA16Cc6",
    "0xb4A4a4868B613BbDD2AA6E07c8769FAf7DD6b8a5",
    "0xB4Ae4311299C87Cec3F714F6B1a7F5af3C84FdE3",
    "0xB4B5810735AcB93CfaEB6aa24fcFd04D583f7593",
    "0xb4E4CAbe54956E2f109e7318542a210b66B9d907",
    "0xB50aCde64715Cce18ACA01A5A705350C44c5cA23",
    "0xb52c29D1Fe987E593f9dcA5873B6A2b08DC2a9a2",
    "0xb55586c502751d433c654CDE77791A3e5F9bb9ad",
    "0xB5776bC9A49f7840CA13EFee39cAe89F9F88D234",
    "0xB579160DB92B6E9F92791eD3003625D97A4951Cc",
    "0xB5A1BADD44595E166b304d01305be8729C7633f4",
    "0xB5B4681aaAF589Fc5f75f32bfe209b51EA1A74D8",
    "0xb5cE9F0158b02bbAD38Eb706bc3956d5b8B55288",
    "0xB5D7Cc8E25bC73aE70c0730b25607042253804c6",
    "0xB5Dbb489f49cCf34f6d5802617E9DBB4C92Da6E3",
    "0xb5DD722B87C129DD9e18bd53122C2E1D957CaE43",
    "0xb5E1Fc4aF4dd6aB3282D16499420954b192e1849",
    "0xB6045604A2ACee3c1dCEB23EE10D8CB3eEbc3c08",
    "0xb6049ac0a4690B38f8bcAb4B2784c7A70430220b",
    "0xB60C8EDd776E7755c086e8aA3d79eCBDB0e99eBd",
    "0xB6364f3B7FF0d096E1847FA6AdD469b5112DE2fa",
    "0xB645EA519d3bb18A03Eb0E059e5f6A70A793b4fC",
    "0xB6506571771934d92b6450E911bA4B821a4c8F1f",
    "0xb6520b7fF6E6fe4269Aa18df0184223e5756ACb4",
    "0xb6553e6a857c4d542E7b614d007D84357F5e23dd",
    "0xB664cCF0fB0990EacEDb5232f1f413C403b9cB23",
    "0xb680c4A08D30bD0F1d085D5fF48F075537964DBe",
    "0xB69C8F45dD141e2F04800f5704BEabFdAAea5025",
    "0xB69e7F59cB8bB0e1ba5487864A33572aCB5467f9",
    "0xB69F7D1461Cc3C57f20DB1fFD5b175BD621E0F2D",
    "0xB6a931B3Ca1c0A2347daC6b4c3A6630F56CF10AC",
    "0xB6C2bBEbc94a910e0fd37267DAB56fb2130dbb97",
    "0xB6D67E7aa69aED737883ef83416e5A694e09c7e3",
    "0xB6e7A7606A03588e9aAB4006194E09712A3822cA",
    "0xB6FDaa7cc67C8F566a36E0cc92AaC909f8D48824",
    "0xb70a862eC2fa86eF3f7e6301ad72A2a97b106834",
    "0xB71323d83f2BAD405a0EA53b0756B43954c48860",
    "0xb71842907f590451a0e5879085476Fd28F1e96de",
    "0xB7258a33849A686c25e2E4Ba0daD344181046A15",
    "0xB73a795F4b55dC779658E11037e373d66b3094c7",
    "0xB74489E07653a0b879060371068d36A3b731865b",
    "0xB75d83263aCB2e6d42dDe1D59Cb3623cc2fa3de0",
    "0xB7752f329b72E71a6066c7d944b0B69fEE970e4d",
    "0xb779168599D844577a62d13AfbD33c47f1E13B1D",
    "0xB77d9422Ff3c5EDBc8A2b1795A01eA4e1e1BFAd0",
    "0xB77e9aee78b39FB315af12A49ecd507099eeb467",
    "0xb786eF39c5f508EbeA55ad1247c9fA92E026E3C5",
    "0xb794A233221dEb25c347d0b8F5F0A0dAaD1B133c",
    "0xb7961099c613c79B8CC62Bdc06237948cB6b68E6",
    "0xb7ABE0f0A1c31a88FdCdEF71033cf7ae7d12f2d3",
    "0xb7BD40D2B33AE0D660bd5a418210601Fa5a80366",
    "0xB7e0DB61024d5fAd27007224D4a99b6B979cb794",
    "0xb81373B923ef0e24DbA61a36118B632Af8FaF882",
    "0xB8220a035997D105084771439EC5F5a75A8829eE",
    "0xB8372df9D06345eb96E27d0ec87341B10F23a6c7",
    "0xb841Bb73296304648eBB4014959107F09AbD1856",
    "0xB87f933275d731090344EAe0CC635163CE4040d0",
    "0xB886d1c4B2c2d9e11Ab5CE7fa3379880489207f6",
    "0xB88B85EE403BF06673B2E9A953aDc7F61dc4D769",
    "0xB892Cb4De18FD487672662a471aF25EEF53AA0a4",
    "0xb8ABc49CE1bA5FEea6de3a048FfB86dd1719E8A2",
    "0xB8B16Cf134c904c45FB437D55df712D64FF19f11",
    "0xb8BE6f5be927ae33b77cE2048aE155daDb131B13",
    "0xB8c77143492aB0314cFC390AEd3Cc8e56974DD7c",
    "0xB8D3fcd9e6154Bf53f5C7Ca8F3822C749641CE8A",
    "0xb8d6F735d89D49a5F7F629Bad790227454939471",
    "0xb8efFE4Cd13B9b269abA6BE8920fD235A555bCa2",
    "0xb8F0B59Aa99711ebBcBa08c6bE2A4910626227C4",
    "0xb90839d337d21c9BEf200937e567aDe303ff4790",
    "0xb917c85E98A7d3C0d55Dfdbf820Bac80C18c97D9",
    "0xB918e67E4d6cfFEA100b591AB8aaf6549F966247",
    "0xB93aE27ea581F5732b7E1A8bCC2Ad412EB70429B",
    "0xb93DB512D55FdbeDF438Ce79C98973dac6A9d5Fc",
    "0xB9462D01b04e54f39091662A7525C2BE7E8aA4e4",
    "0xb976163A6f251c208bCF3196b9c4Ddf927B63e72",
    "0xb99426903d812A09b8DE7DF6708c70F97D3dD0aE",
    "0xB9AA9aB0b4153c2669Fb63517056d9A4e3dEE750",
    "0xb9C5ED064288dc62ADB6e6a0d8106fD6e71AC2a2",
    "0xB9cdF2A04fFcbB84e813006bA1C5F23b0afEfc52",
    "0xB9d6C4aDA0f499904A224F389C48cc83cE9B733a",
    "0xb9Da169Dc7145B3C04FfD26D428b188A35963F5A",
    "0xB9DAB62204BC815976aec4d93883262D50710FcF",
    "0xb9e227255618840Da5d3B02dB44263946a6D0F05",
    "0xb9e2B6062798f4B710a9DB4aCC88Fe3ea64C7692",
    "0xB9E4e5Df4bd24D97A5AAB9386e32896add761436",
    "0xb9E6B8dE24Ea7668fC6e89726b6d165c04765Ae3",
    "0xB9ed3a2B35396E960AF7A812d330726678795d29",
    "0xB9Fd5431D92dFf32e2053E3E6906918Bf9125861",
    "0xbA304E6d2bBb7Bc84a247693E34Be1bed2e2cCc2",
    "0xba37E47506731a1648b74a16f565c73aE2ABBE70",
    "0xbA3df119299a11EA9cFeBC2801a8Bf0102A2bE3d",
    "0xBA4de72475Fd5daD9D67ae43669af6A54CeBD590",
    "0xBa5c36184BEAAFF8b8D1c5b56676e3D25Cb34774",
    "0xBa82f61f09aE5912e9107e7C6Ea7c2A85c525051",
    "0xba8C0A85B1be5b024e602140d23576D96F7b9b40",
    "0xBA905F16973f2efea5B149bc8E289F81ccfEEaba",
    "0xBA9193FE0768008D1928A23a31F1dDB0B1D2eC53",
    "0xBaa2F24785073D6ed013E08fD3CA32F390176343",
    "0xbaba65d064691f5Bb57b28C0cEa5A6D712cCDb99",
    "0xBaBc5Cd91ed0c6E5250F5F58807C4a452bF2462f",
    "0xbac0d5DadD4538B3089aa642DCaB3Fbf412aFC6e",
    "0xbAC8AaEAC1A1b6254Af96389291854E0247Bbb22",
    "0xbAd6a49fCed289665D1a3f7d7D342f0B1fF61241",
    "0xbad88B4a622209D7A92977D6DCb40cA6b739a511",
    "0xbAf725FBD18Ae95D3aF821f8f84d9290F48dbF50",
    "0xbB102b973d602bf0678a722bAAa596d664781f5F",
    "0xBb179f078BAC0FF4f181F6e01606cCAe883Ef74D",
    "0xBB19b62702fF69F471889091ED6E4B4Ab87C556d",
    "0xbB19f57D84A48b4c09da46666FeAb3c0B5D9B3da",
    "0xBb26126D04429E9D6D7575f0826977925A3007A7",
    "0xbB4Ce975094075bEd207BF5E815476E19aeD545c",
    "0xbb523c4aCe60a5844806C2ea480576E63915E0Dd",
    "0xbb6E2129d9B0bfA33DC9D581E45d0901D6E31978",
    "0xbB809218C220e2f48D1Aa0Eed296B92432fC50eB",
    "0xBb847ef91fB033d19C905E13CAfA77689567562E",
    "0xbB95270a54AfaCA861cbD8F48baa4D983fD6A97c",
    "0xbb9f90188D7A34B418BbA9209Eb16277cEBf9Bb1",
    "0xbBa8325ece6217167218355380854057070602c9",
    "0xbBBabdcD0F72CdA2f634ed911A021CF23071fac7",
    "0xbBc37f68E9876d64b2C55016081528aE0a85D8b2",
    "0xbbCAc414583a4aBcD0611D9fdF8a411Bc48c3Ab9",
    "0xbC08938BAF4d75f953FC44a6062F7DD8aC666c22",
    "0xBc348d5Ea9da16fe156c1dcA449bC89809867640",
    "0xBc6C413E112a4466bad82f5a63192426e9136Ae0",
    "0xBc9B5877F0b15408B2C15C0581a51a960c34bF01",
    "0xbC9D0175Bfd0d97d28929E754858Db43CfD615C1",
    "0xBC9D8C818b5928d46C8316C25A09280563fE6F45",
    "0xBCA427E4Fb0a8bef1fC324F9BBff8574D3bEB90C",
    "0xbcB05C141DeC4215D355d632E8b4F2fbB6e0dee0",
    "0xbCe152ed16975a14C7a647de583E5E83f1C120db",
    "0xBCe3c1d2f1ADdC77a76b0DFac1A53582ef00b956",
    "0xBCf489672C2eaf1F63883c4C4e15Aa25A8d48Ca4",
    "0xbd0D7F2115C73576464689883Ce7257A3b4D8eC4",
    "0xbd18c0b86E419C3f2BF9A4dF52AAc12EEEEf37E0",
    "0xBD1d28E866aA62f58C965C49B313A81Ab7d0B93B",
    "0xBd4108467c8657804303Ba5520497c3c00000000",
    "0xbD454e246d7311F31c8F15C5c5E9f332269Bcc36",
    "0xBd48F9270A8456b382B30ca623275Eb46F35D357",
    "0xBd5323Ea5B5Eb67b7b789C4361F0DFFE07950d11",
    "0xBD5c6AdB500694720D01957adC3F0B94F4607C38",
    "0xbD607cFB32a1ce7d7688A116021e4B2112eDd926",
    "0xBD67fEcb509DBCbD2216E5C60C63af8EB69225f4",
    "0xbd6c1f8d5692D49325fDf12dAA00DAC59224De08",
    "0xBDa8db10865d03751DeE17CfA6EC712ff00De046",
    "0xBdb45A4954958B40E23aBEAb1Dcc9acd264dF6D4",
    "0xbDcA355c8a7de13Fd93178ed9Bd8F883100c0F5F",
    "0xbdE1668dC41e0edDb253c03faF965ADc72BFd027",
    "0xbDfA4f4492dD7b7Cf211209C4791AF8d52BF5c50",
    "0xbDfc647076455eC9F9e86d858cC900346bCc1E18",
    "0xBE03aB0c13af2fD997B437425f0061c046F18f1A",
    "0xBE085179B88dE05756b8DA261E0BFDf643b93593",
    "0xbE0e6b8966f801a34cC22cd9100880BA932c66FC",
    "0xBE10324668C3EA65d5c582F78302e96B6C209Cb8",
    "0xbe1b723aCd1F47c1AACE1014d24F6e489D3bc47B",
    "0xbE25d2A9780Bcd5f3419440a378dDd75d26EaE2c",
    "0xBE3DA3fa80031B23Cd40aB0C230da668525D9236",
    "0xBe412Cb7DDdA866cD323ce34e63562811564a89B",
    "0xbE445589519222ec53F4E8a639ab5AF7EEE6889A",
    "0xbE527AA383C9979D0133D27b8ea1c43b694d6F9A",
    "0xbe559F49159EE2d0930493cD58667AE61CE7C51E",
    "0xbe5F930E0E35e00F9Aa684018b7A14bFEc1F39f8",
    "0xbE659a818Eb788490be750d799682CfFD66be518",
    "0xBeAC28E447f17c79411c2fB37c18AFc74759630f",
    "0xBecC3ea31EE6d12c81B01CDEdfb75bc3ddeD9F34",
    "0xbEd4308884405AAB39a78fD3C863076155bd4e5a",
    "0xbf1E8d8eFe9cDA7eB03B4CA5F67135831169b385",
    "0xBf24bb6cE53FE0fF68f08A24891cf40A4fE3DCF5",
    "0xBF25eF090f0c4DbA7AB5668d43285b5667efD650",
    "0xbf265Ca7C7aCE01469959aAD580171AD6D43d8F3",
    "0xbF37712F0C8b1698336dFf7ca2F7C9Fc1ddd18b4",
    "0xbf3CB13fe85203fa4BBf5ed83e7A21Bb7FBE384B",
    "0xBF7fc514D8f94d079a0e8c3cE59e3CDE4Eb02C72",
    "0xBF93D79C3731d6645bA704eccAe0AA1B4DF61ec6",
    "0xBFaa0172F5B711b30B7D74Ba4efa25Ff501d4F7D",
    "0xBFc007C6D7dEb895643bf457060519137BbD2C8C",
    "0xbfc801EfF227553C03C7C78867Ebee393fe8f7Bc",
    "0xbFCFeF131ACb735ef75AD64fd89518037BBBaFA3",
    "0xbfd119804c2b17149a20f553bD328bf691A0c533",
    "0xbfd212edE7d1a83c95eEc42ce1a26244b9Bff113",
    "0xbff15b83c12F48c178508f005dA604b93DE31AFf",
    "0xC0173243c55e359F8e708cE1697877246c3B727e",
    "0xC02435ba35d5566f24FF715d2114f21330847db7",
    "0xc02624Affa30299fA164e7176A37610835A923A7",
    "0xC02f6d78E6d1cD6522C57caa5Aa99070AA1DAF8B",
    "0xC051ff849a1A8fe225ca3032F01980caB90A5FFD",
    "0xC0537b2c576398cdb8158280e33c54616f71D9D2",
    "0xC06768Cc873C0219c1e8efF6A339C1a9f45F84Dc",
    "0xc06c85beEF659EF9971fe812Fda8A7790a47bdA3",
    "0xc07333D8Bcd28E0766592F193b0f6DEBf522d7ec",
    "0xc08630b15602a5040FC66c54372C08a3a5e3C913",
    "0xC0c1623A1C6d588ac02b9aa010ec441e5160dFec",
    "0xc0C2Ebc4095382fe0067e4c7DAf96188Be0D4958",
    "0xC0c6dbfcaefc96979845e8d73baf6081b50f6992",
    "0xC0Ca5782C72C88030E62ef6e4C15FeF8Ccd81627",
    "0xC11d42bb2F94481ef6d7825f1aEA122554227FBF",
    "0xc123011E6B9b72BeD1C5888da1d107bEA03f73A6",
    "0xc1281C3Dbd892A96C9ea5007F916b50b0e162185",
    "0xc13280BCfB2E63649F65a80D812C6ac1D84886EC",
    "0xc163521e31b934af091B8206E42235f51ca2c028",
    "0xC17e7Bc7e3Dfd514271d3dE935f0C82737642037",
    "0xc18120B4B22C78eA55f8A7acBD7D7082d3C73A2B",
    "0xC189aeD75A492FC5008E5B007D44B95803382C08",
    "0xc18E465c63971E4D7E5374E10990f25Ecd4aDB84",
    "0xC18ee6bF19aEccbC5985f68A4f10F4cB2D2BcB51",
    "0xc19Ca6CC85dE33Ec664Fef9595905b8e57Dae13D",
    "0xC1Bc9241e4e38F9cD2706130661b01928B13f897",
    "0xc1C1ebA0f6c91C2f0decF07EB791b217501aE908",
    "0xC1C32306104235f64096a68335497b55D7244732",
    "0xc1c4ffF0F9257366Ef9668DAF6c9FA145c51E2e7",
    "0xc1C772880d009D24C8098b8a2B4C91312966425D",
    "0xc1d34f3eFAC840D81435d77B2676C8D8e1Fd3f1C",
    "0xC1d5BBe33048ddC114AdE4f5058D598abea134c3",
    "0xc1fc8055129eFf78Dd73C9929aa8CE8982EB8B0F",
    "0xC1FD08b740B37AECF9F5E2aa4C5568dF5D2B11Cd",
    "0xc2080FaFB58e0df318a7d252376B2C1819D1cD01",
    "0xC2172a6315c1D7f6855768F843c420EbB36eDa97",
    "0xc23485Ae4315c409F0175A782841E0F10f12b0Ac",
    "0xC2618aDFB2121E1105EB45B369469C89d49F9f0C",
    "0xC27B05B73e35b6E57e4262686752d578b0F0B000",
    "0xC27F047DFe04fe3444e58a54dB8eef0e5eD66965",
    "0xc2863A92c4e1C260301bb32df3bDDd3781D7d5FE",
    "0xc28cB42c0c4153F2acbEe19E1Af431999D273bc4",
    "0xc29C546064E8fB5506C5e5Beaf1594866Df7177e",
    "0xC29fD191f864696E713252C280B20E7283a0e449",
    "0xc2ba77069899a2409440CF3Fe9fd246E1f7b75fA",
    "0xc2C73683d13924807a40C37CcD5EF616A7582024",
    "0xc2f063a8F9aC5E9E7ed1092238bde34df6f64E80",
    "0xc2f70D46E7bF71eE5967A819d528caa87C11776b",
    "0xC322E8Ec33e9b0a34c7cD185C616087D9842ad50",
    "0xc329C67338a17741Fe1f69982F97430271ea78c8",
    "0xc33298F7481983E62a7F4614dc90De9E24BF2108",
    "0xc3462CDbafa34e27901885E08931d659E3D3FfCF",
    "0xc38f5AAc5d5Bc883f66c62aDA1A9b9bEAFA1407B",
    "0xC3b8BBD76c78a0dFAf47b4454472DB35cEBD1A24",
    "0xC3c6DcDC973E3eFeB485DB835ae48A8DcDE0890f",
    "0xc3Cbf9cC946f260eBc7D9404006369e1EE0e71CA",
    "0xc3D517F88f40888992b3637F91FEFEb1369dAE63",
    "0xc3E6e003Ef17910DaE6DA46b9B45c0765C75a3a0",
    "0xC408D40bf360A361E5366e91e22A6E46d0d67831",
    "0xC40be8196FBbBe1b3A2A40E7D27f7548A313C71b",
    "0xC40dF87e16339f21fBB2E59FB38bF2A957A16FfD",
    "0xC438FC7FF0c3Cce806c60740818dfd39e88c9B97",
    "0xc44Aa185F750eABB627D40434d92C03e7580Dd2c",
    "0xc4518f351e115E7d44189c3B49b1bDFc7458cbd8",
    "0xC45e79F92661C799f6263E2CEd94e4b5E9439dc5",
    "0xC478cEbfB27404624a9aca961A8FC9ceB94D691e",
    "0xc489078Ebfc9f529EF8c719a0a17E96aa1515937",
    "0xC4BadB4F5c97295B0573bC9ba5F68Fa707C1aE96",
    "0xc4Cd57b06C9f735aBd6240A2683026E308f716C7",
    "0xc4dfCA8e5ef803feB8CFddc9a34389F192EC7F32",
    "0xC4e537FbC4841C51E3239e6D58e9585634FDd3A6",
    "0xC509Eb72bF9Df8073c17C9A7b2e21009C1b6b91B",
    "0xc50b3BF8CB3F9b4C65472C2f1ec0F39ea24Ab16E",
    "0xc52d2fcC7876af2334EdfA74ffb786871D65B944",
    "0xc52DC6555d422dB0295653CB3a8F9356ef12d80C",
    "0xC53A1682403BF4e00b8C6d8995953209F3C8Fe6D",
    "0xc552179F89B571F10217448F3fe66c58aE0f53Ea",
    "0xc5541192902f473D3a1F3ECfBb07C55e5E7a7b17",
    "0xC55f16540274f545b6dAD86eaDC5a480BdD89Ba8",
    "0xC571147a515a789eB23cbCBf92F86bc1485ab877",
    "0xc58C4a0f3ED94F4c99b17Cb75B7f54767bfF254e",
    "0xC5924Ab8AFD26156332918dD1457203106076C48",
    "0xc59Ac6404C719EC0191EadFD648957DB4bC88E35",
    "0xc5aC53B91D0a836c3AD5f53ea85f46f16aEe2BAE",
    "0xC5b8bA2a219A9574E9019332Af4D40d638D55666",
    "0xc5Bc9041BD0B0121cDc81642FD1Eb39860CE80aE",
    "0xC5C84134820491aC755385CdA1f1C78fC00b4459",
    "0xc5CF9F8A38B2176F1E8910b18c99641eEEF8b877",
    "0xC5CFb0CF6c9D7D15cFf2c3E0CCee4FDf8f3493Ea",
    "0xC5D5e6d514cFD45d462CC8738D3fD11838a4E8d8",
    "0xC5dF99E89f74B3f10F7A2aCd713bD14dDa334014",
    "0xC5E50396Ca1fa94BC89136D6d47aE71DB1eE78D5",
    "0xc5F59709974262c4AFacc5386287820bDBC7eB3A",
    "0xC60fc08f2e8Be330ABE707F672a323269938bF2B",
    "0xc611376086b5152a78070D89290D0a21e8D17C17",
    "0xC6297fB2F3E1D7EcE12C3fa78195b9F594172F04",
    "0xC62eF7Dc3e9C6596f53CA24ecd79c92CD7E45Fb6",
    "0xC63e6a57EF48DE8E0562d254360a4e391F79AF9a",
    "0xC64fF776E44379863bAE2dF4B96c78d5DfA379a9",
    "0xC665e963803ea297CE1899a9d6E5EE9e051e799E",
    "0xc673cc4d718C007470721BDe4676b6fA36d22523",
    "0xC698b147871D6f143ba79DE4C5BFC2446193092A",
    "0xC69d5f8376c360CE1E75e4d7ede1A6Ac273ed197",
    "0xc6a6226bED78829aD9E31c78d921689C6E24237a",
    "0xc6c3E15E33eFcF582E918D8bF348fecfeEe35f87",
    "0xC6e97963cc04BEFf0394F92ffFEEf6C50503E367",
    "0xC6F6c89F7f297b5230D2fD028Ac06f0677c1857b",
    "0xc700e16f61041fCf717f0930227E26948c746bC5",
    "0xc70B72A3fC4141F9D5bb166BfcB2CAabAE2cb2f1",
    "0xc72101984ecd00aC61Cd7e036BEbda3Dca0667C2",
    "0xc72566a346F518617CbcC1BDbE0BAafEF2Ea71dF",
    "0xc72668253D890E5FfD6EC0ffE6874D1CAa8b4C0e",
    "0xc75b143301cF47A3Ad096ED904f5E3f0831a57Fb",
    "0xC7A3f9c303da9Ef4130f231Ab6abd6e3f2BBaFaB",
    "0xC7A3FC4E2618CCcAB5e01963d7E2A8A208812F59",
    "0xC7BAFa602891D8AeDF318bF8534e05A9d1EAE365",
    "0xC7Bf1EA5aE1a48538C21722e004b65CDb395B82b",
    "0xC7C3983373599966942a081039e4213c42FB5793",
    "0xc7d685154aF7b1D6Bada69c8c9731885f9b66242",
    "0xc7d7AFC62e707D99017ae59AB6A6f43c81B52a25",
    "0xC836335efCA27A51EC4A7eeBBB0D990D95b22AaF",
    "0xc842848393cdD682714C241E08038827fcCAdf56",
    "0xc844f9C255BCC45c07ed5b0295BA188a94944fd3",
    "0xc855d03edb308080e70f0FBC4e2f3BE7c383782c",
    "0xC85C9339B01e847DF728a416b8CaBC5B42e82498",
    "0xc868453062C37cF481e65Ff001225086F3109bD4",
    "0xc86B12d850FdBBF3260a7BAAE862F85857aAdBBa",
    "0xC87158be3c28d725043291E42EA960EebaE681AF",
    "0xc8780853afd09061CD69734C58a0D32b1E9068dE",
    "0xc888686179e68d3116e5333E41Ee463882E9c0cd",
    "0xc8a0E19204767e130e1EAaA30425741DeCE41C8F",
    "0xc8A3584F96A55Ed9AB9d9F0Ff7987C11D4cFBddE",
    "0xc8BA28507aa7F1825dB28a7882402D616ad7F562",
    "0xc8d7E0ebcCB4588664B331CCAED087819976358b",
    "0xC95337F787Ce1eD9E1c0AE396857Eee430ca45F8",
    "0xc954A62A26f5DEE1Aa248eFbeb025e12f164Be75",
    "0xC9673C6D77564655421A9B23A3Fd2b9606bCeC2B",
    "0xc970d150e79Dfe672332d4AF0902ef23955A189b",
    "0xC9874b5ce5032DefF35CeB464cDFfFec97324E2A",
    "0xC98774a66fDd2aeFa15E32a5f24067B65BF7CfFb",
    "0xc98a194D958572368c683e601BF244f2c9009443",
    "0xc993420D0Eaf4dE88b6f6CbD4B6617EB6934382E",
    "0xc9950e9B8aD349dCCF9cB30028647480Fe05f4D6",
    "0xc99b0c6D89CA3109FEbd6395399d81D52Da3Eb5C",
    "0xC9a58D42CD64bf82f53fc6e0961c69ECE1Bda17A",
    "0xC9A693b5E1c8b3A46528be8E1ac912932bf2788c",
    "0xC9b1131C0f76D0a54D788fA580d80485CB0Fd153",
    "0xC9b21c97EA4908f3f7A3B6D49401C0Dd1de3bf7c",
    "0xc9BAF5e870b0B5CC867647F29F51A70d2E7b3c1b",
    "0xC9e72D3C95d1a4ADcAb2BaA805959ED5404f1b04",
    "0xc9Ea5742aAA6E5EA9eE34b7C1e62D6813c5c244D",
    "0xca09D690a8E1AB29DcA8f1f90Bf7Dc5F73568081",
    "0xca2F8d65485e8550F98195221A815c587526BC11",
    "0xcA3AC30eB2C931E034966dCEe23D2a9Ab7B43407",
    "0xca437Ebe79fFE2a62a1f52997568d60e29e7B95b",
    "0xCa456d71f0CC61Dc27Bd28A8e7F7B15BcE91Fa05",
    "0xca52008eB8Ba3EfD6C069a272946CB206F947cd8",
    "0xCa5C18921fA8Da307092636d43cB1BE29e0DF479",
    "0xCa5D69A687071cE06C3817443A79Cb3338bCbeF0",
    "0xCa6cea7F92ad633570A573146B61CF86a8C12655",
    "0xca768c37ba6EC3d67bE7B47bbE1F1C94CA216f46",
    "0xcA801986CBaCD95f449D455E5408Df0538135b4f",
    "0xCa888309D978CaAcD511bc553c1099722463C6E3",
    "0xCAbAAab135FA84f3A044872d734E723C4416759C",
    "0xCac5941F57FAc00c0a9d298FAb59a3C2EF5A9658",
    "0xcACdF56B33254925931947c231E4AF0525b7f14F",
    "0xcaCfc7Ee3208585619F76d8609d6A6f32B7fD5a6",
    "0xcAd1EAbA2C943ad482C72dFEdB8710a96520CB67",
    "0xCb110198Aa9F8C251b06F168CFF5998c9fE881B5",
    "0xcB197f1CCfBc7121cf6f73ccf88ba7dE8E31D25E",
    "0xCb2350C27bbBC662Fe731436EBc2662466269d4A",
    "0xcb2393c1A951a4388233D6e52425522F2c246FD4",
    "0xcb38691F43944425Cb616706EBc111cA91bd2076",
    "0xCb5bcE16a17F6229bf454405840a613a9932FEa1",
    "0xCb5e9d2B01d4C6AEAD4EF2E172DA1A0ba89EE3D7",
    "0xCb6Bf6645a5439D03C3D1C220BE496b8ad38CC35",
    "0xCB6c0eaF8f92121f7ff38DFE903d273A0E06dc4E",
    "0xcBA7f4f44473e32Dd01cD863622b2B8797681955",
    "0xcBa9054f1C063263F67FDf15BC868B1D7A3F31c1",
    "0xCbB28523892a7b0E53927569108e6281C7A26A01",
    "0xCbC8c7B976e5f7F4E8C94A621A62a18dbaa2953a",
    "0xCBD5F01aA070a2AfcabdBf952A06d6857de07d4C",
    "0xCbE177a88Aa89A4DBB25F7347368c87E43DbE02d",
    "0xcbe3bf6C2762faAE03b30C9B927A8e036136FED6",
    "0xCC0131a44bfa7b276839b4E4bd15B512d9E50aE2",
    "0xcc083C6eB6E9Fd44EfC0760b4A1e32b5BEA99226",
    "0xCC0B630C334C283458520B649c7ea5BEefd002D7",
    "0xCc228BA6D53f06d59404ECC5435d1399D3679A33",
    "0xCC39eDDA530F567a2Fb5e396687E03bc797F6C51",
    "0xCc437Ac5C397D7e6385FB20b142a120793499E2E",
    "0xcC684EEdaecbe4D805BbFEa3E112e76560DA88c5",
    "0xCC6Ed70b1c4a815F9Aa9D1FC0175854E8840B328",
    "0xcc6FbF71fEefBE60eb7EFd1634daDa65D8ab2dC9",
    "0xCc996717395C1a254245beeC7aaBe59eaDE7D66C",
    "0xccA02Dca1aAf3fa40d79df1d5C220D683e5068E8",
    "0xCCb61DfEeb3A9f0bc32ABD58959b8Db1cDfbD561",
    "0xCcB82565577E00542c2cBEBCEB3dF14b0915c0F8",
    "0xccC0229689Ac7918601a6DD819c3F70c5dCF9803",
    "0xccC4e8Ad313dF8150211B1b934725345924ab81D",
    "0xCcc9bdD130f0C03Fa5d12b9A85e9e66b087457eC",
    "0xCCCCC5ce1df3b4579ca4D03ffa20227D41Cb5F8b",
    "0xCcD32fe2D9Ca841679123f7acd82e04b89116975",
    "0xccFbE19D00151a738263dA32dc5cFa60C77a0Ac6",
    "0xcD04dc2D47dd0E06aDA28BF176F35c4ce54aa23b",
    "0xCD10C3c5C177B27d8c2f547C77Ea5b52a7989228",
    "0xcd23ABa7FbDA3a65F049015FF5dBEE14D187CE1E",
    "0xCd241563F7288b5eb2b9B715F736232889B62d8b",
    "0xCd2Bf6794A240A0126356d1FE6cc1F6ace3cD64B",
    "0xcD598B1B21C96A1B74cb2A8a87E256830E2b0F1E",
    "0xcD76BE8e31f3eb171B404B13C0D660A9463F633e",
    "0xcd85151D3B5D2762E63c97F7d4E74Ed4261E2a53",
    "0xcD9C934D6429aE182571E7f641F2859188117601",
    "0xCdC116B3749f0E272D337C6213D8EBFFe65D6E1E",
    "0xcdcAb66704a3e18D79e08F8102cB606b82539aA7",
    "0xCdd03A39690f1a8f63C05a90d114E9AC05A4C442",
    "0xCDDeE772926D631cAdd0AA8f8033421c4FE55F10",
    "0xCDe25ACa7277298b33eab3E954E9a9470B3342a9",
    "0xcDE4c0FfFBac72A9A94E2F24455B5339be3b3393",
    "0xCDE56aeBa72C90c2c6010C66DDB65D7D1A1BEB6d",
    "0xCDE934cC617165337927D49C73244FDCaC7D8D5C",
    "0xcE1066a40a18Ee7e3D465D2dDAD125cf54b62E9d",
    "0xce185E5BfF20263f210c9BB867f1B0EA1a718d3B",
    "0xCe1eB9636C412245C92352D6FdFEcA9f97a89A4a",
    "0xcE2aaACE56780D0b3e62fD3E3a43D396E4E01041",
    "0xce2d06B799ff861E6c19E73Cb5aAac243D50aE93",
    "0xcE4752074d68fddf215b403417baa90FeF31BBA8",
    "0xCe4c8A44881D290865598Efb51C1A05eCb8A8324",
    "0xce6404642bB08f897FCe5317C1349656ca44f2D8",
    "0xCe75A8A63E9E3F0DD4D81089cf11cf91Cc78cb49",
    "0xce7D17fE50d049cDBe848cd4AA29D34B23b13F73",
    "0xce8Ad80ce1a979381d209Ac230D02aDaFb9Fa897",
    "0xcE905feF61afB99e8A9d85BC3cd884b24a6cF041",
    "0xCe90a7949bb78892F159F428D0dC23a8E3584d75",
    "0xCe95a19D4ab41a53aD241630c2E4006F55a60F57",
    "0xcEb8237A1CBB5823E0739e98d8971CE300a83b96",
    "0xCEbaC4869eDf0ba8D75DeaB264E3A4c5117aacd5",
    "0xcEC6A35dC4A23B01CC31ca45b2cE0C7Db18d21A8",
    "0xceF3F69Ed43B5a35093dc49183f1de54261B030f",
    "0xcF16d05cFbDf29DC21A7a338BBE1d19F1d5f35e9",
    "0xcf23669a83047F4dCf2Ad3d2d8a87CbfCDA5bAc6",
    "0xcF372762FE08682528Cba6BfA367A768d7b0afB4",
    "0xcF6f5A68d94165081A634AdA997BE3A93426C467",
    "0xCF81649D46ce55007f6EfE33D107511C4B3c2b0b",
    "0xCFaa6BD6f4De08c289E24F0baA55E707CD14DdD0",
    "0xCfAeDB4D9A764FEfcA8126D2BcB2A7F233aADF9D",
    "0xcfC310d6B70777EDaC66117cB31fD14064C9f4Fa",
    "0xCFcf5BE056F483971358E5B5DD8c70837B53f87F",
    "0xd00222e1AA124252E7F602f89AB7e2e81b918Fb1",
    "0xd003d8C8177191AF3D85178C0908E32087ceF229",
    "0xd00878B7F49d0ec22031e3fb785713AE55078d7e",
    "0xd01A07247947fc50ec4d60a7ABD4B8122CC76a34",
    "0xd02Fc8Ba1b521A8737d5fc59cC3Ed840E89505B1",
    "0xD03546583B2C1e16cC049dC2027C07fB797400a4",
    "0xd03940d74481f291E074AdA70F6bE9C8C0DC2395",
    "0xd0488188Cb6B992BaC10568D4402EaC2d5EFC0A0",
    "0xd051b8FD12b9C6cDcF58218104341306D831A8F0",
    "0xD0695F478FA223ebc319b3402eD75Bb9E1C035C1",
    "0xd06dd4A6c58597704B39af9DD4A5AEe89D7ebE8d",
    "0xd075fbb331FD9fDAcECE3eecCa6BF46dd3eC83D6",
    "0xd082239E2592DD3ae19727FC25783f0Ad0bF69a7",
    "0xD08e349117601eF77358B2731a5CB273a5cD6E39",
    "0xd0AC2cD3F50B3b7b48A6E4fDA1dFea9A26085605",
    "0xd0b10333D7f1303de754A18fF37444b47b3478A1",
    "0xd0b4719fca122271BA7D49E52dF64B4486f01261",
    "0xd0CFDDF01F638bE6Df1411F7ecFf7cCa8Efe0BaA",
    "0xD0D9C3A7583d11F0bB75272a0566005FCFE8b1D6",
    "0xd0DF8c2de3aAEc232EC18408e2D41fbAe00ff197",
    "0xD0f0fa38579731FdaE4c7154D6edaB4C7D68D8AC",
    "0xD11b53CFEAB0e05d0a49F6DF7d4B3a469690218e",
    "0xd129bf4EC6DE5ee96Dd80f4308A3699B33A8f494",
    "0xd12E276F76A55af8558e149b5EfEb6aa3a64eE84",
    "0xD13297C1AD2220438989670a9680FA53c9347A2b",
    "0xD135C0fe8546b33C22e2b76183470472216d14FE",
    "0xD156Fc10A365991f476BDDD5b7A960F2D05BD782",
    "0xd162FfE75ebfff74769bbde79F0e1452376e5A43",
    "0xD16517D1c791F7c2bBA51E1d228f0eB47338b315",
    "0xd165EcDE7e7825923c8A53CC0ce8f0D75E200dD0",
    "0xd17609c59F86dCa59FB4e669E9528B30C464F94E",
    "0xd18A67f82bF9289cFa8067852026C1f93126F502",
    "0xD18C96b6Cd70987189b95e02B27d98e681BBA100",
    "0xd191441EfD409Fb3dDF1992B0AF2f9955d447C97",
    "0xd1938759bD2917cd8A7DE3D43e7C595cc58c5c85",
    "0xD1a8A3B3C608F654b3c7Ee13cd91bD4C375B0540",
    "0xD1AfC331e381E2eAf99dC91e278e623D987f0146",
    "0xD1BBC62eF368cfFe0ff0f9D3a6E99e6ab94bE114",
    "0xD1D547B26dBFDCA5019dfd70f0b239Ff745688ea",
    "0xD1D6eC879f0CF74d493C82770E35D9cC7a5dC962",
    "0xD2147e736Dd19Dec46531D3f8A7b12e6BC4AD802",
    "0xd225a3eda5BbA421677dFF1a078108737Ab1B8AD",
    "0xD2373c87102a22a9c9F9c99E5F117c91CA6B07A2",
    "0xd252f3F00db846fBE7716aDb5c0ca95388C1fE73",
    "0xD25f26dA2EA1b5B07b67fEe890294331376422C0",
    "0xd2615b2e79F4C4C8B7f853f86014C4EFBd5f324A",
    "0xd266c194E126D4FCFC85E8c665ED7f668f6aAe93",
    "0xD2705ca42808154Ed4f5E2f795f35a9f9DA90F52",
    "0xd276Af2A62cFFcd40591A0Ab66790ba5d43edc2F",
    "0xD28a4c5B3685e5948d8A57f124669eafB69F05Bb",
    "0xD29cB2381D094aa15319297c1d241E1caB804656",
    "0xD29cB5Bb3DC7420f16831B74aDfa64fB359992De",
    "0xd2B71144621F879151dD6C80A5eF0BE2eD79c535",
    "0xd2b8e55a27fa7b0530b3053080F4E21baf414aB1",
    "0xd2b9F9d1E6734F241b2a6eb64EF7F6e63AF0A97d",
    "0xd2BDAE1D307782dFf97bb8ae2c10d6977f770f4B",
    "0xd2DE94D56AE24491A3E58819EEDaD7A9287B0a94",
    "0xd2E87D93C13907c3B0f9026dcbD964470366f517",
    "0xD2Ea209EF71bd8D010756e01A4eBe5D0BCDc17eB",
    "0xD2Ee5E1381ce222DbA7a33EDF7EB5d2F31bB1db0",
    "0xd315D76D9bBfeC635A519611744889E56330F0b1",
    "0xD319186f633DAE3f62E9ef9059CA73aDB416D742",
    "0xd3283d3Fd0822903A447eF488519C74cE3bAffC0",
    "0xD328550Ae616D2E0C03027CFf32667116A87e11F",
    "0xd32c23181a4AF2e15bE18272C117799a166Bcb21",
    "0xD340035d759010DdefA3839beE22D324BE3FCeA1",
    "0xD34586fd34888DeBCce382efAA8bF7B1ce524620",
    "0xd34Cc49337AAc8C4Fa4d30Ab5dE03EA2fFeCBf22",
    "0xD360D021fCF2bDC9722DD13407Ce73Ffdb6fF462",
    "0xD361363a6401870FF8a23B7C77C004Aecb8C8b84",
    "0xd3675744Eb2A06020149f29F294507b66264D8Cb",
    "0xd36862D058f9E30f3152801dA2010e6eed2F7df4",
    "0xd3689e018d6A182d2806Fa75B7Bc580103f1B071",
    "0xd36d0aCe6B18f13760376751AF10741336131CE8",
    "0xD3723dB17950Fc8Ad87Ac62A3dCC54320e754BFe",
    "0xD3815D8f2d22EDCf6D42bC5585fbc19912870eF9",
    "0xd3838cdc2A673BA7FA28A42D4C0111F4CE6Bd4E3",
    "0xD393503d6BE38401054135780F57Cf308e230dd2",
    "0xD3B605dd135358cA50cDf59aF570Ea3ab717BD82",
    "0xD3d69445C5e1681B91F28c917b34dE38F3fEc7f0",
    "0xd3e9AF5B0C1FC2edD6A7907076cd9C79e67DE6aC",
    "0xD3EBEa185331db4cFAaA9840A6F0b7165D90B7D1",
    "0xD3f1e12B2634197e279d72c959585fe74abbca44",
    "0xd3F5d5cDe151643553a194FDD3aA7bFC048767F7",
    "0xd3faF3D3aB429436c035b895bE96Dc195e63E413",
    "0xd418758705502499Eda0Feb1e8cca75233C698B3",
    "0xd4216f97A6BbccfA1d4df94FbC2b201E315cAe97",
    "0xd4380860f47beeA16934b2a8f0C5Aa6c4e68a78E",
    "0xd44fE5724dD7aa35c96d51861f4ca33069FAC33a",
    "0xd45D61a7762Ed1236b275caDA5f1171D74E008ab",
    "0xd4630e7eb57B9076A21F3D8960F9197ae737330A",
    "0xd466CB0C19226CFBb3889DD1fcce07661EC3A160",
    "0xd4766f463046eA77EDb7a582661BAC6e81fE1435",
    "0xD479a3e49CeFbbC66B6dF4442F8D0c9e6f35aB0e",
    "0xD497BAeF95Caa1Dfe2235d40ECDC461FA7E8c970",
    "0xd4aa275776c8cE672590c7B00A6C1D78D649dFa1",
    "0xD4aC7896b13a3E6880541b084C1392883C3D48Ce",
    "0xD4B6FE66aBBa24871E893dAc99489a0f3CC293aC",
    "0xd4d3C85017CbCf26ca6C89ab5767227D7777196A",
    "0xD4D5ace43244d7Ea667f360d204e875CB02D9857",
    "0xD4fA8D783D9B72556B5cca55E5965C59B23129b7",
    "0xd5082E0bda558F2EFb5eC5Fcf9C39C93c17fFA8F",
    "0xD52556064661669f5Dc53C3384Ee0cE50F1D996D",
    "0xD52b58d3a0B9d19FBABC9a9Cf98ffCDcC9a8161E",
    "0xD533131e3CEEEfbC5b95Bb541C6A34bEdB09C9bE",
    "0xd57ab17ED3A5feB8bF4942326A651ba1E1BBef93",
    "0xD5930bBb762DDE3Ef24D4F27FaD72ce3dBbf326a",
    "0xD5959829ed3509aff590B99BDa00898010E87b92",
    "0xd59E33D70400dddBcb1DB391f7e3e934b21c6B2C",
    "0xd5A771Da32A392036a98f7DA6b11D46D6D1c61f9",
    "0xd5c26deF4E106814FfC623F0b0aaB2C396BcaF85",
    "0xd5E57e8dFee37a37b1684F3Ba0847F29697a414a",
    "0xd5EA4FdF0847484187f70D75826b249CB98972A3",
    "0xd5f20543784F105F93ec06e918ae2D5e195B4438",
    "0xd5F278478Bc58C2d7689cb1E6fe66BC6f1014825",
    "0xD5fab5D372081B4F20FD4636BDe96e9061aaA8a4",
    "0xD602EEeBbCe91E7B8d3BDA8fb281C124347b6CBF",
    "0xD60f499D1A45E9Aadf9633B460B2c96030EB827b",
    "0xd6338a01c388aB6a2c320eD3F5f57a838098dAD8",
    "0xD633fDaae55f4c224eF0c5FaB91a112Ef88CE46f",
    "0xD638E44Ef808e20bd05C10634089d38E514200a4",
    "0xd651b465e81178fB9fd3aA3679f06a16cCcCe302",
    "0xd66Bf38e7c704F0cD7910773f5c8Cc3098B6828D",
    "0xd6782b1Aac7a8d63344f2e2699039792646F2078",
    "0xD67eA3873228F72115d81De1a999B7edC95bFA2E",
    "0xD680ec73D85a3147A44814e36dBeB95333E2D71e",
    "0xd683095be95A86205A54140375723f9aD26BdD0F",
    "0xd683678594E7b41281B2736F1Beb13EBC5B06eC7",
    "0xd68a7D5851d7bC5E8Def809083b270542f6317e1",
    "0xD69F107E2AaD1Ac707013C3377a8b5f13E702Cf0",
    "0xd6a4eb571e6812d72F86076E9D2F902fef288278",
    "0xD6A7E275f6000C0D8Ef39B0ec6E70e3293589C36",
    "0xd6b18aBdC6b996D36DbAe500da342b3307A5f369",
    "0xd6bF6395d4e5b586aEccB34200E49CD5fe70DafB",
    "0xD6cC79aa3b87062Cedd4809f81878d35b35dcF74",
    "0xD6F6ADF60BBDd7b573cae0329EA85978cCB60448",
    "0xd6F724e42707B636233f8D0d2726c95dF0343242",
    "0xd7197F39bF805f9020617F8Fe2E882535684c5B9",
    "0xD71DDCF7C1700FFA456BFc4A7f42B27A389c026E",
    "0xD7310DF74A0b4C3968a06EAf9130ad9f34557893",
    "0xD73A9a578Ffd22c0BEF3d76e2ff70e25edEfFF22",
    "0xd73EF851F223ee7996007e4Ee184481EdA0bf5D6",
    "0xD74D4b30c39a9EFa7401F92d859C7b750B879677",
    "0xd7571d439B906833aA0aB7eD781574c517f02bc5",
    "0xd77f3Ac3C898ABfD62233B80e2734fCCf9ed1587",
    "0xd780B9DE6BE4cd865485092ecD4B19771D147B72",
    "0xd782fcbc3bba63a08828be5f4AA59Ce93aFf7697",
    "0xd7946c0F13dB5698D2d69050D7bA7ddFdE6e2bb4",
    "0xd795C77d6394d8A7555a9785E89C42478d7A6c94",
    "0xD7B483815DE199bC4920F65CFB3bfFe1B04862CD",
    "0xd7dcD65E11635EdC75C8275683c184B2d335f486",
    "0xd7e2A7714d89Af0eb249F9dC8A84dAa8bb2b8811",
    "0xD7E7bCA98ab9fB25e17ad73429e89A40B55708BE",
    "0xD8015579d04d3205c8a35244c7cE64B0Bd6DE822",
    "0xd80410157fAD3A81F74D408B644f003de6251Ea2",
    "0xD80421C7F161Bc8d8c06B6565C4f7307cA1AD575",
    "0xd82BD233B9e1A75DeE20dce1BA2441c93628C48b",
    "0xd845fEEf8dB38695f77293901D56F2A56c7Ddcb1",
    "0xd852E3A7a2abca6aecD0FA39147851Ae96eBA5D7",
    "0xd8676fcB6Fd0Fa2F6aA3455c5f2460F2b867571F",
    "0xD86851eB356Dd2D8d0C0C6e5c9A1a6D9c4Dd9f76",
    "0xd8986018984EE0FC3696ff76000fFC2654432719",
    "0xD89F16Db8003BE15939A5552BF695C8D65Fb6Ee4",
    "0xd8c9777EC44FC34b67F52b5596Fa33154B5d7778",
    "0xd90664D053873c8CdD492B21FCa3Ec98Ca923EdC",
    "0xd918252c46bf5D399Ce827151B422810388c79ec",
    "0xD9350bd6fa9232c105B38F012Ee3f803Ca85c358",
    "0xd94fAeE3aBe47dae9A6DCf2837B0afD843ecA95D",
    "0xD960b7516FfF154B9cA46f6192b1eFb37eDB386A",
    "0xD96923F7152C54223bfF90A615Ce3797034855Ab",
    "0xD9772845f93a4922e8f7EDe57a9497a24eD740d6",
    "0xd999d1c909aa37a13715fB7E4066445B6E55E18e",
    "0xD9AFf9f617b3262E2150f8ed9D9A4B64b6d18219",
    "0xD9c09e1DDAccE4EE6548b66773Bf4E6fE9dD0882",
    "0xd9c2F2416Fd3A1b70C84631cF6daD6aD29A8ea57",
    "0xd9c394487a79878EE20Fa1b23B8887b51e30Ba66",
    "0xd9C9d998580825E4fD0F2BDCe0eb1dFAc9A3C635",
    "0xd9d78CA93f829C724B8E9F0785aA80d7A7CF5134",
    "0xd9daF5E3bdC9326c94e0BC0413636538D4D6C45F",
    "0xD9e3118DEb1A8C7fFb4edfB8609A668712bdCb47",
    "0xd9e407c12bC10583691aa66e952a164442A746E5",
    "0xd9f2418d098F765C591048fe141fF8Cd88FD7B01",
    "0xd9f3E3E1Cf06575Ad5446A9F53308137013df752",
    "0xD9f5818381B446b9F5734fCD10a79a34a04ce6D5",
    "0xd9Fb810fBD1b3293d182D44527a2C9b385Eb8670",
    "0xda020cbC7a675CF3eCEba4e2a9FC11e5FC746055",
    "0xDa0a7f503b792D793bbAB43008F5C204eDeb123A",
    "0xDA1658b72f09c37a1d8760f9eaA47B475E688217",
    "0xda2284962797dA85d9ec783D8Cb0184a4744A863",
    "0xdA327740d72A7E92AaF9128b7EE8D1940d054e77",
    "0xDA482dDF91922e4ae66Fa1Aa82290E9B70a4693b",
    "0xda508D7aa1fC9AD252beD8BeF26aAc448b1c8E14",
    "0xdA5253d63c67b0A5AFB7F43FA1fA04A5E5192A95",
    "0xDA6E7d844a2b9b52E37272B76f48CFb7C8B0c70F",
    "0xdAac4D315441BE67b136f163060865FF0493674c",
    "0xdab1EBAb37C06E0b2088342b5F1d1fc7ec8De915",
    "0xDAb1f3e697E09C5E431daA002f48E92d56198216",
    "0xDaC679bbcD1B996c02fBc467C9648dc90503ab98",
    "0xdaDddEE3daaA02F854634c56067AeB658ff42b4F",
    "0xDaF6Fb5e014C868eccb5709050c15e8dA3e82856",
    "0xdAfbA80aDF54C6a67FdA035C5eb669b894306819",
    "0xDb089AffAf5fe914cE6634a2e821A9D688bfB5e3",
    "0xDB0ff814a02Ed7250BDDbdB83BA66eB1230245fB",
    "0xDB152426B30e1429C31c513fCC4DeE5CB484c80C",
    "0xDB166Dd4a0Ac1Caab9458c2649b4c1560E8624f7",
    "0xdB3f4aaC828d6B91D28173CDE758c6E1603ED27c",
    "0xDb4C48b528e5503d059237A4c85AB535BB6D7BeA",
    "0xDB5F93412670ca64914A764D2b0C12634a7e0322",
    "0xDb716D180Ff04DF99486743925900A94ea1BbF95",
    "0xdB881c8FeDD6B4c660905F9a41f6D577bE51b668",
    "0xDBB004449f307199c6AfAF16A6121B2a3E5E41c1",
    "0xDBb16435b3F5D904FbCd2FC98097aE217D851D69",
    "0xDBb643740Ce08Ad124Dd5ca747845FE798f12624",
    "0xdbBc5563C2511447Bb50ce27560BC3312e4200d9",
    "0xDBE003332e16D41d7ccf6Efc6e4845e976c98331",
    "0xdbe37b6Be9E4CD306b1aC5E6ec79Ff67032d69CB",
    "0xDc27755aa0269ce01E422A6667cAB4e5B267A20b",
    "0xdc2D12cDEFe1b3B9060692a5d47015d219286077",
    "0xDC6162690b08D9a96603c4A56F6a2B1761217586",
    "0xdC641A3290e850e2AdDBeEBa4cb6A5060e4f7FA4",
    "0xDC72c6D7cfbc965D46Bdb3125Ea8E244E383F5c5",
    "0xDC7c7b60Ae8b76E720F7a5e12CEB4cC6578EEAFc",
    "0xdC8c351c730E146e123FF86BFc15D7269ad3D41e",
    "0xDC9704A16e7B2b7261332E547d0b797dDB89D1Ff",
    "0xdCAd9e10bad70D5bcF87a2d3b3D72851Fdbc1a9E",
    "0xDcB7881A6568625B027a3E5b5d08821523F96612",
    "0xdCb926B9549B97c8c7a2A62400A7fb30fA11a1c6",
    "0xdCD6b0B9C039A485ed5B1789a7829ab4d7fe05CE",
    "0xDCeDA580731D9cF0B654fe2B7BD73b1DbC9DCf5b",
    "0xDcf6a42B9b7f0279dd2C2c1f84F1A91DEC99bDF5",
    "0xDd16c8F7e8ec1024610F7540C93EC761fC1DcC6C",
    "0xDd1e16e9B7dd8f047b982c771a30B526c35E1bF0",
    "0xdd3767ABcAB26f261e2508A1DA1914053c7DDa78",
    "0xDd53baF5c1EBBd93b4E957cfd5E88e60bD69151e",
    "0xdd6Cfb1E9d49332f9E345C1B9D56EA648d2BaDF2",
    "0xDd74a5f502167c1bdd88968D058834170175277B",
    "0xdD9962aA2Afdc842B3a09A344886E2309158c636",
    "0xDD9a27AfAd44b98E724c3037dc33D755eB82D146",
    "0xDDa5d3633614ce4c92B021736cedA4b766Fd139B",
    "0xddb80F2A4D19E6ce2E11fD51d14EB76e49f748a3",
    "0xdDcfcd0d38165d859Ba5b18C80A8b0e954CeB4E8",
    "0xdDd3a93458DE2ed6D7672212074c1368be8bc261",
    "0xddd78e837D16C78137bCFF64b7F9C9c92ba88bDc",
    "0xdddE80DE5CD2e071E0D482AbAc676dc71eAc9D29",
    "0xDdef227E4DF29a8C19952081e4017bc845C3537e",
    "0xDDf48f62E07C2E9f689AE903255D090E9Bb9D725",
    "0xDdf767f258adf0af89896621349cAdcf8722f771",
    "0xdE0099d1b16F054286B51AC5F84b752CD9F8cF43",
    "0xDe041EEB79237d066b7478b7e97B8eF4675fb8A4",
    "0xDe049d3B00ce73b4b76D6eA4212afA89AF892795",
    "0xDe095756C6AFd367311922478a3963030B32b581",
    "0xde0C8c6D57C79A016CFfA7CE345047f97dB05660",
    "0xdE0fac9eBE5Ae976f4c0E5eDF35F36D350346a6a",
    "0xde1B6dD59a147a5CBD584F5eC2E0954CfeCD2816",
    "0xDe37F4CbCe3C03E8D276dd968531cAF378cE0C3A",
    "0xdE3Af5dBF1A8e34af5555f8E834528da5719b4fC",
    "0xde3FaA27DD5daCA77115E3Af6A2077c111bB81a6",
    "0xDe47eB280f203Ca0087B73d16FdCadE4De3C3F3F",
    "0xDE5914bD516Be06a67D8d09E75Fad3780d18289E",
    "0xDE5eF415089f0966fB447B6c27976dfAFf100011",
    "0xDe88E6dFCa49628a4998b8136a8f2021d81d15C2",
    "0xde9DeE979af2714a8A7ADB4fc70F4F9568c4f7A7",
    "0xDE9EeC713C2FFD681A641f7455c5110113A39c64",
    "0xDEa4402398f2644143CFE1ed5DEbaaEfC5693812",
    "0xdeAe38389A9ec57c8810855AEE8A6927e5b93054",
    "0xDeFB4500439B52b9FBEc791f7c4c1F5ce9f4B81a",
    "0xDF10fDffCfC114C6309D73843858C743A1f61737",
    "0xdf331213DB297253c23f738068A06fDE4D19Ec61",
    "0xDF36065Dd835Df80fa007F78cAC7db910B676a10",
    "0xdf44Cb56916B7692Fb13a33CF9707CA840A11142",
    "0xDf494a34d94F4B26AeA0a80e1e2466AA3bE778Db",
    "0xdF63CD8B2D15c79A9cE5Bc021a90c806235Bc816",
    "0xDf749186b0A32D8017190160Ec9013872a0f2B7f",
    "0xdf7938f3D979AEB3DDf8bEd1204cb357c43D896B",
    "0xDF80CE337Ee02AeBc688fCAecb9ED5144f9cd4c9",
    "0xdf8Ef854071d6bA03Ca1d618f402be2ce62CCfbe",
    "0xDFb95aa0A8D40D9462841b07d3ef2175f139D6D2",
    "0xdfCdce56c884115172EcA935009e697603E467F7",
    "0xdFd17960BF6A6e5B661F502321370691920Eab45",
    "0xDFF4e623cCA25E674edb0A1f263fCF5aa458ACF8",
    "0xdFfDCF8A3830b0a8B40b06e117B7FC1FF4Db0287",
    "0xE00e0ddB66cc46F583584040BE721c704b6506B4",
    "0xE0138890d271C83e2828539734338526691AA305",
    "0xE02595BF712f704e0a9F2F1650F924C2c08b0B17",
    "0xe02931CfB9c8dEE8357E2A9E66053CefD516408D",
    "0xe0343E74729056258cEe1FaF51Bc33F91Df49fde",
    "0xE03E3F9aD56862184594F95811bD18cDC0Bab495",
    "0xe04F86d1Ffe77280741A9763c2A536C48B0735D3",
    "0xe0636157ECfFbcA03ab6aaA2BC69a0264AaBa81d",
    "0xe06D686A59A999A1bD1196fA25A7aEa56dbA9f5C",
    "0xE0753cfcAbB86c2828B79a3DDD4Faf6AF0db0EB4",
    "0xE08198A7726a95386117c40C637a3F375345911E",
    "0xE08833CEc320855e1a0e21Fb9310b03E653461B2",
    "0xE0B1E627f61666c75ACe5e7476a2411800Ff161a",
    "0xe0b9f315cf48a2b69950fBECb32006B638d582e5",
    "0xE0E65e2ff5920736dAA78c39341f1bF62225a73a",
    "0xe0F710b4969a13Bd24361c4af7516Fc08b6ac5a6",
    "0xE10C1E3f6835aBc46a28ABDF4D51f11A7AEfC388",
    "0xe12FE38e60A87d9543f6eeD273CD51730d5F7a0a",
    "0xe13340194473cf22C15d46eAF93dF0d7DE3A8150",
    "0xe139Aa3CEa52a6EE5A4219D0D2D7F9FC27A67Dc4",
    "0xe1590363B3C229CC324714FE76Fe5ff484aCE161",
    "0xe17a48B4B39cd09c755e8b54122583312013698A",
    "0xE19a2be3E5579d6aac52211E8C777D0C40f9e1cc",
    "0xe1A4A9FcCEbb2dff7156a0daeC54dCD68E735Fc8",
    "0xe1AB2FC3Fa943A7d237bEfbb898153F9A6f04971",
    "0xe1Ad83Db9AFFD419a4C0616B72Cb5bfe7B62f949",
    "0xE1b89c34BA683ecDAC5D96625427340ceeff771A",
    "0xe1bdFF947510a8e9623cF7f3c6cF6fE5e37C16b8",
    "0xE1C4AdB2D80D448DDA42Ab36deb8AaBcDC5b66F7",
    "0xE1D8963BEaD06Af2f756542B5bb673751A39bE5b",
    "0xe1d8AC6508d1ef3E4644A52d6AA8F1eAe8EF80Ab",
    "0xe1E0c813293DDbf0fBfDDB1025E8A35F160579C9",
    "0xE1eB9cF168DB37c31B4bDf73511Bf44E2B8027Ef",
    "0xe223cF83bFbcd7eB8A496c4A3d9808B9Ba26C235",
    "0xe22D046a4db925bCfB55773E791413b1E4F6FE7E",
    "0xE22e2B9A0D5a4935EcEaFdB96C8E072F6FeF98Fe",
    "0xE243C6e3bdd803c28D159e84Ca962079E80494eD",
    "0xE24D6a761B11DF9e547D10512E7fEcc20Ac553Df",
    "0xE26f1356bFE4AC2f433C62660759be952F498003",
    "0xE282CEE428B83AE5D7FD8E290585CdBf965214d8",
    "0xE28470253F0c9C7AfBAe7F61795d6b1ca4644b2f",
    "0xE2a11Ef13f571804CB455C20B92e6b8ed1b8B600",
    "0xE2A374484bEC68022Eb6da8B032BFcE0c7f74daF",
    "0xE2a51D3B9e20389C1347316a132237cA4c76eb50",
    "0xe2a89eF42dCF0bE96d610D3362cd525652CdC401",
    "0xe2B5942e014215EB42Ecd00d5779a039418cF51f",
    "0xE2C5FDc34Ae3E71E945050C752529293DB7AEdF5",
    "0xE2d6b30E63eCb93Fc0FFC1e9bc1327E8b16246c3",
    "0xE2E07551f6454B0812bce305aD223bcf65bDa254",
    "0xe31ca893B9e7D221eEc832416372A851BA5b0071",
    "0xe3262EeDe42a5EB5189B7A57443257D35F7FB5F7",
    "0xe3402C93ebd96f8c522b9A679f4Bc7bd0fFa15f9",
    "0xE359aB04cEC41AC8C62bc5016C10C749c7De5480",
    "0xe35b91C89c078F44524e81F208faF85847538f6F",
    "0xe35d4eC39b02B481AE0328202Be510f3D2E10180",
    "0xe3697Cb2b53cDDf3BB31e8767769a8A441bCdF51",
    "0xe37a06dA6765c29F35A23FF58Cdb35480AbC8778",
    "0xE3901c4308dC347D2AD30404dDD7f1e2dCa30F92",
    "0xe3b5177dbcee68c332f054Ed8007b918C8F7770d",
    "0xe3d11a7282C66780583666Fd706bd3933ca432AA",
    "0xe3E09d41a30603A68F7A6b548d87c394F63Ffb27",
    "0xe3f4093aa5e1728c890F1e1312f32A45155c05b8",
    "0xE407D650Db255A3F1509e6ABb2a254F28993526c",
    "0xe40e41299A5EaFF6776F36aE96421A76d056e364",
    "0xE442751433eB7d3Cb17B59CAad5edfe82053E59f",
    "0xE45b178819526D1b5AE56bB0dB182a9aA2fE5752",
    "0xE45B252B674D9d2adeb7DB833fb4d8f080Fa399f",
    "0xE471ba862DC0C5B86511fbF8054A45e60dB924De",
    "0xE47C2c402Ff5B91C5adaf684Afe5A2f853f0f896",
    "0xe47FEaD52E0b19bBEf5c990314BF4C81502958d5",
    "0xe4A53862e9194E2Af3e395D07c5c0c3DC3f61ab9",
    "0xE4A718104474dA81790A305bceC5Cf98C0359a10",
    "0xE4A9687F831128ca35eb7eD120c2Aba7B76AC0D0",
    "0xE4b42ADAbcAdF4CBdf796F3A5CC99A4804514BF5",
    "0xE4d1826da957f05cf8c196eF6D4D9023665c1c19",
    "0xE4E02d601A8B12c61Ce5F1A3751668336b629e1c",
    "0xE4fB69507Cfa7d0654E392E6C1e401918123a85a",
    "0xE508ca502aB7CEc51AaF87C6E5111935884d2bb1",
    "0xe50e3b956393BfbA0637E43A001f9D24D5089C81",
    "0xE51b225CCaB79B2D7A30F4Da15349EDac49973E5",
    "0xe52b9463d573E706fdcE0F23a17B47790032C36A",
    "0xe53085d26544dAF3BA8f66B2D1B108E285cc51f9",
    "0xe559f8bd9668CFCC7D139C9a4D42415719025819",
    "0xe5801d81FE202602FA852Cd81F2937dF5e2e2dCb",
    "0xe5973c229389E39566904Dd09f39d0b57c5a1fB5",
    "0xE5D45FA1B783aa011914486D01f07f724395cC22",
    "0xE5E0FB515B3638493a8De43B959020439dB717Ae",
    "0xE5E1373ac5628953D211c0047eD92BA4f9Fa03AB",
    "0xE5f5c9741D62746d2d0757228Da2761Af277D624",
    "0xe5f909aF08970a0d3AeeE58dA7C3D576ef5cbD68",
    "0xE6286CFFf85bee3982B45d643af54194c3c5D72a",
    "0xE6479473072EF2b7E4EbA937A354a9Fd7D82F07c",
    "0xE647Eb23cF7E3225a8d5B3BE363b3bE58b6BfC19",
    "0xE675C35eBb5715E00Dc5d5D47763D050Dcc6aDC5",
    "0xE6952504164c36734e3c54547a2A6eC48C992C7a",
    "0xE6bca7752D32A48f7d60c7d6129DA0C0b6d00E94",
    "0xe6d50Cb6e7423c742f409DB65f19518018B45968",
    "0xE6e27f75A13307C3fE4a8D45c09dE9c311eEA4a4",
    "0xE6ec5b1B6c7f73F0c55eE153734669f9F2BFd3bf",
    "0xE6F45376f64e1F568BD1404C155e5fFD2F80F7AD",
    "0xe6fC9423CC1386f5B725434f44bfaCc6aFAC2bBf",
    "0xe6Fe14a30631b22d3f78D9eC7869eB62d6e73dAA",
    "0xE715d37B790a16b2E50Ec112679149BdD94204BC",
    "0xE71879304f842bffB76194aA8618fAe87FBF90Fe",
    "0xE7363b9BaA2546fC7CBc66B3Ee42b6B5b000506C",
    "0xE76B556970A626c20B410C35A4F218CF47A91b4c",
    "0xE781fE7a6F65Ee6b3efe66ed8f7f5C1E9F01cC55",
    "0xe78b0AA223243DDC88CFebC2cEa7D58090bD9F3c",
    "0xE795b3C6a5691D50dcB155F4f49A7b7a9E030b31",
    "0xE7977266C0eD0D45894dA75C7148C4d722E8F916",
    "0xe7A7A51917ED55f4Cb3706Ec449cBEd178038a0d",
    "0xe7c84bb8B6f38177b01D4E573C2d0c73B33d11b5",
    "0xE7Cbf26A287A73317D31f381178b01fA5c05c209",
    "0xe7e09D48fa3e39e553e404fA82b068AED8d123F4",
    "0xe7E2D3A9B6BF82EFA164441f31dd017b24A21eC0",
    "0xE7e3dE4A0364bec19F295eeC4A807181dCe4719F",
    "0xe8001353445e28Ad76305C634557A0D09D58694b",
    "0xE816F69a8dab09dAC1E34ef7820733492a4CD391",
    "0xE831E57a808C0321DF5a3c6D3454641239eEdAd9",
    "0xE852C2189316eC5eEE9F36272962ade430f38531",
    "0xE85406F0f22271C973bCB2d60d09D4f22dCeAce4",
    "0xE87AC34A24E531336C7e467cCf4b62BdfEaAd3Ba",
    "0xe883bbD489D41E0301A88a035ba6c31CA3909bd8",
    "0xe887F13bfc9a33CA3de5a5CEb2fF3126f45b8100",
    "0xe88871d7dCEe1cf6658Eda56c60ae773801673a1",
    "0xE898908cbe1Aa10389F9BAE84A05A67e8F940122",
    "0xE8A1807534a6F5A6fDfC29e85C00dB55F2e165fB",
    "0xE8c420d06c0599b2FE663481612A8c23D1554ef9",
    "0xE8C7caB8d23f9023EEb597b63Dc9cFd7d2DBD2Bf",
    "0xE8E1bcb325f93aAaba5696d6c861f5Ff78944c1b",
    "0xe8EF5bcB1E478a941F554B7B90B4846D24C99620",
    "0xE8f37093E86e2E5cc56a58E6045aF19878169FC2",
    "0xe9032c600cA5DD59dc97597C9726340F9b898C7A",
    "0xE905529B9d7B2d6EE3aA09DEDb020048011d4B13",
    "0xe91565645Cf9BA3B7Ae4D2943f7967826eBE3387",
    "0xE91ed00C61f7D9382BaD92C3B20C3a4C29090Bc7",
    "0xE9572718a87A434B4F556Bf9BE2cf740d29A8B4b",
    "0xE9581fb58eB6fdcBD45fcBA793149bAb6B0e0c4B",
    "0xe9697Aab0EBa88AA15e59704224Ec5d9615Fc55B",
    "0xe96b4Cc1DC97DbCa6690c8eB0434181466d680e7",
    "0xE9802E2642A7E60929c083acB51bCfF62a9A3605",
    "0xe987408Df55bcCaDa83447cc1ECfbE5765655f4E",
    "0xe98B2E58baB4cF89C8d0f96B2745886b9B3c58f1",
    "0xe9a11e44D3E754ae95a121D0Da789c73b3Fdd602",
    "0xe9aF007819204ae349808A8C12C2c5134C6A1f33",
    "0xE9b3E3a1b11D2f4d84c7245AbFfB4D82BAfb1F12",
    "0xE9bf26077A050a19922f3F19c47d12855c8f3279",
    "0xE9c245293DAC615c11A5bF26FCec91C3617645E4",
    "0xE9C731f14de4512dEf20361234E0ecc76af0Eba4",
    "0xe9d2F04Ee329F9FA0801017467Aee58aE4ea07C6",
    "0xE9D38A5F874c1126B821650c9BA66A052bE56c72",
    "0xE9D412869c361c99797083505A298fcC0c6fE4cb",
    "0xea1728873E79FEB8071D96F3aE38097492020d35",
    "0xEa44b3f15DE97226388acDfAa14C8F1d16A858A4",
    "0xea5350D781552ea20D62735f81E9ACC8C1919b5A",
    "0xEA7Aa0431b5Eaa7E842784e7739BEE68Dd5258df",
    "0xEa876c8953025EC0cB0956d0E7b45944fc634CD1",
    "0xea87f8d95F6FDA6680189714dBE09BcF7ED1e154",
    "0xEa8d2658511583711333EE8f9c00aB3d4A2aaC77",
    "0xEa8e1d16624CBf0290AB887129bB70E5Cdb4b557",
    "0xeA9f330C930a04101ECE0e928ac0036620589446",
    "0xeA9F3a983d965E582C34EB852c18babAC52050D8",
    "0xEAba1c76c206d5E18D73E0f60B3b7F793838f16D",
    "0xEAD71ff7bCce7c3dD572B3CD6Fb7bC4C6359aF5f",
    "0xEAE7bb96F6e53Ed3aC1e7Ad522700c2fB0504924",
    "0xEAeaa1E30D62bEA880d5F38171bB32a2f91bfdCE",
    "0xeaFd92f81Cbd880C2c74Afb71778Bc2CFeA67872",
    "0xEb016b0b8976A8A9b56D0d48c98D2cFFb0459226",
    "0xeB12E79D4E2a510Bc2c135648DA56AfAfAD257Bf",
    "0xeB2AA52aD7cdd272DA8171B81D856299343c6FFA",
    "0xEb42Af34f5a5b51dC667Ec3E1EABB23C373CE481",
    "0xeB4c5c24468C3e666D01257B76A73326411b7928",
    "0xEB6E5DCF8e854c78d2f1C64dB0ca95fF0Bb86068",
    "0xeba9D7523C1842907587C92deDccBeFf49c9AD77",
    "0xebf7fAF63Fe771e7f0C2dF0a1d317E181879dD4a",
    "0xec1643c23168C078c7b2B391100cEBA68cdd7BD3",
    "0xEC1C5F91fF6Ca0351D0bE13C88B5d9553ebc03A6",
    "0xeC211BE0Eb9EC2b55526e8414E9b9Ca4A5003490",
    "0xEC245e638157256A60B5399F35Bc5f1f6AA72fEF",
    "0xEC276bae8e48eE0822cA86f6e1b89b84fDAdE373",
    "0xec45bca040A0FEb6c134F3606B92CcC4522A1f5c",
    "0xEC483DA7262051EB311Eb99f1c8cB1E0FCf99293",
    "0xec4E17Cd0892599A138c60aAaCA7C118ed54310B",
    "0xeC51874C842305ac63f7500F6e14e5791DAd07c5",
    "0xEC623f380Fc15993d47dAB43bB9109469491a0cD",
    "0xec660339837CB2C2536340018c591Eab5ee19279",
    "0xeC75Bc3f4484705Db39ACb202dd00e88CaBA2914",
    "0xECa588e75c8Eb0D2322f52c2c90Bd525C5a5d93D",
    "0xECb316ceea42CD154ddED4eA9944527Da44e7A04",
    "0xecBf9122F1a7489D560eA3596451e814f4f845E5",
    "0xEcC170057650cC17083D4eD9Fa9ef66c067D11Af",
    "0xECc4d57d6A38Fc99AA843B43279e0644cd1Ea896",
    "0xecc5Acc39f800F0e1c9Db3d9b351C4fd47Aab0c6",
    "0xeccc59f93F8CD9983b0e1ecc612218af4b43CDF4",
    "0xECf42c5A27057F27a514675dbf2215CC88Bf1B19",
    "0xED0555Ee287260af898d5e2a37De099B67Aa6A2A",
    "0xED0A128E12f9Ca2a7590B44A691e2f99faC11C25",
    "0xeD10b8791828bcFfBD829779aA1612A91ae741c3",
    "0xED149f3f99d715E1A37c2Ac41a19eB6Cc91a14f4",
    "0xed1C90e78743Fa89a59AeDbB5789Cfa95E9d767C",
    "0xeD3d7456997d9Af7d284230B5017B35d140dA798",
    "0xed3f868fa921974f4AdDbFc982b1298c82DC6CD5",
    "0xED4A96EC302c7588Bfe84c13888c79AC8A321DCa",
    "0xed5287C8cD520c10141Ec01A54f6232605a4d7F2",
    "0xED55657FaB632E609F349c8591E2b83775624aEd",
    "0xED5f89dC68496E345dA0fF8CdDB705F6737A5812",
    "0xed63dc065E048Ef503a72F437dB289bE7883981b",
    "0xED6ebc3489f13E35A25234810C70944aB4681D42",
    "0xed8f194F0a116575316e3F58FEBd40EcF6dcec13",
    "0xEDA2E1276Ce888AA142a51bA827D462156756c19",
    "0xEDbAD1542f53eF2B577bE6438f9cefAc227deB05",
    "0xedbBD9Ffb60739658BefbD2Ab2E21167285dd0da",
    "0xEdC5925caB7D4a9d89e9e318F3C05CD65FbfDba9",
    "0xeDe8D0b12D74a32A50FCEfc4601527843DcCe345",
    "0xEdEED0CBBFe1Af09BC1C86c10f89c97149Ed1caa",
    "0xedF909846810d15C27Fd80b7c782806A304A6d78",
    "0xEDFaeD62dB466ceb580a7804AFfcc65184A4Bc46",
    "0xee01560234F8fa4fdc909e247393Bf2d502CDc22",
    "0xeE07689Da6E666Ba0b18F09116AAA45B160AC80a",
    "0xEe259f691feF63723c5dCf1a0592be419792bb4d",
    "0xEe2f89Cd8513cfb9DD4F03ec36E4cE0B04412C47",
    "0xeE3439bDbA452c8DC7D4a612AE3bb74ce877815f",
    "0xee34Fa04F846220E91F38d2068BEE0535645FDbF",
    "0xEE404dc025564b09C2A72857af69D2C2e73a8636",
    "0xEE4A8f435692Ab65d0DBDDaac9ee5ca90f514274",
    "0xEE54e30B74cE9ABfAA03C0f2772fa3F738903947",
    "0xEE63001c0B591Bdf3ded155A48d74160Ee5a7324",
    "0xee81E57b01a3f88dF8c43678A0CD7B8291799044",
    "0xeE989dEECf3373211943eFbBF7FBdAbb8a923ad5",
    "0xEea34A0A4EABEF207e55f2126d869a247dcAC65f",
    "0xEeC7DdA500017C0234B32abD50134fab699380a1",
    "0xeED8b473f46C78AfA789f3C933f5D2c201E43fCe",
    "0xEee88484D1864dc3B8E5a443316c7789D7845999",
    "0xEef460Ee0A233E8bB74bD3CBc194A840E5E4efB1",
    "0xeEFD768e43fB54A496B665A6775f4321Ff0DbF61",
    "0xeF0246f603cA29bCD9a09a07D63aeA455DE715F7",
    "0xEF09461105Df84241323A2027Ed9723F00024937",
    "0xef11Ff64b7CB7621a99fFeE16FcE1227fA5dc7BA",
    "0xeF16A708b9FEEAa44aea2eae66b0a6df4951F5b6",
    "0xEf16b728583BEB78D40167f728A88486c6D337B4",
    "0xeF27C02656a00401B19Bc3F8451799Fe8Ffc919E",
    "0xeF3e454d38A7b7A9eCBE49cfecAa4F30bB31B60a",
    "0xeF442494C12103D16Ac7E911d02Ac7B72c0425a9",
    "0xeF4F6d043cCc6e37B2bEb376dB62C057CDd8c915",
    "0xEf6058C883653f21e994Ee4955428868350E617a",
    "0xEF76cf033F7feE8a75c7B0458f138122B38C0b68",
    "0xEF8a28B8A39FB292Afc471E21106eeef1985CE4c",
    "0xEf8b18eEb78AdBCea84c18bA193776f149790361",
    "0xEF940024a3412Dd964586c9F5260C8b116C4d58a",
    "0xEFAF22d5bf62124c827fe368200fF26c68b86E1B",
    "0xefbD0604d91919Dda0a3D64a50e0659DE93d417C",
    "0xEFcb35A72E5Bcf7B50bC739e92C38b9cCDEB2bd4",
    "0xEfD843aD07C702B96D15B90aff5A0c81027789Dd",
    "0xEFfb833A4a1edbDaeadaaa688151D2569A060A3e",
    "0xf01e85Cdf987f7566FDB36219A9ad0177FFc5E72",
    "0xF02ccC4d1eC9cA144EB1F47f4d3453B018C56372",
    "0xf054274dd74987395D28136e53f39eF4F7B19994",
    "0xF062fa9DB05a28d35FfB6A675A5EDFcdeAb9c246",
    "0xF0812A075d631C8AC57274Eb2E9C9876f5d0c731",
    "0xF09306e25661B1A0A026A607DbB4f63EBB9f3558",
    "0xF0A1ab0cb140d72d4c91bF4C8EC28Ed578BAB6f4",
    "0xF0Aae929Ef8Ebb9aAF15E47B9ACA7ea4a4877C7f",
    "0xF0c4EAC17e1af4535b4016C4B29d6EB848B57b5D",
    "0xF0ceACc4CAAD19F4E913b483cc99813D3cAAB5Bd",
    "0xf0D2f631735861FB7C2dC8fA4d0732B2e4b2EF7f",
    "0xf0D561cEB4453B1d74D5ac20B4214b65486707DC",
    "0xf0D6999725115E3EAd3D927Eb3329D63AFAEC09b",
    "0xf0E47dd364a899A9f02cffA2CB5E45dB092Eb002",
    "0xf0E569De368aDC35E3c928a2B3DA4C0871645E01",
    "0xf0E6D7a40Bb43C6cDeC11D5BBF1583561Cfc0C7a",
    "0xF0f1a04a214EFE01ac5E189e6D9f38cf5D98d84E",
    "0xF0f8fb7398243205FEea093d00367867ADc95FCA",
    "0xf110B384CA4f89b1377f16D10d47866487b63056",
    "0xf12744B45e3052abF229148707E34Ea61841F7d7",
    "0xf144B59c772a4CfCDB3D24a224fA4CaeC8859dB7",
    "0xf16062CE28C91Bbf869E73fd36779F5485cbaa1D",
    "0xf161972e4660E6b5a8dC3CDf85bf55346FE01762",
    "0xF163df709d8F5d0886f425e2Cc29D6784E437154",
    "0xF171e05bB1683599f9Eb308E6167342448FB3983",
    "0xf185E46356009f2ec0D5aedB1C64FD2d8C81Fcbc",
    "0xf19e6902BC5BF77b97eD5442eA4dcFea4Cca7457",
    "0xF1aA395896Cc85Cc1F21CE8520b51d2cfd567fB0",
    "0xf1BF86D442bf1C3bb474A8744820fb43A8B6986d",
    "0xf1D6fBa5c239beB43eb880c79795bd13C8a4B933",
    "0xF1dBF521F6CC7C8eDc61f24E0D85E1483814b2e1",
    "0xF1e1c701B49B1dC2405A9E8Ef40f9f88802B80Fa",
    "0xF1Ec313c0dA36b5dDAEA982bcE21D28E8Fe7DB79",
    "0xF222f74f262cf67955b14cC0Be0baDA8F79a1a0C",
    "0xf22cB833a12Ee0EF4Fa6F78Fe463784d7fd3b061",
    "0xf22dC27cdD64Fe160B0FFC221f0Eb94Df50e49D0",
    "0xf258E44B0d32CaA016c87c8Ea47AaeEe67fF1619",
    "0xF2626EaDce87913C29e63b95e39552E1bBe26b44",
    "0xf266F6777219B30f7a5E67C3D595F797888F226a",
    "0xF277E30333aDffD26a25E2A48Fa686adA7992F3E",
    "0xF27D53F6f9eD465d3ff206071519625C7D2166d1",
    "0xF27F34c97b3ea78988C7EAF9b658AdA3b152b38d",
    "0xf286a7fA290cb972FEE5840EcB21F53214Bf2edd",
    "0xf28D71614d27cf32F68384C3e154Da7653F804c4",
    "0xF296178d553C8Ec21A2fBD2c5dDa8CA9ac905A00",
    "0xf2964661F688e1DFA51b6804AFaeefccfb1A7027",
    "0xF2b7E8763704cc9a025BF46967c8389f937314bE",
    "0xF2be41ecA404C3E2acb834665807F9905653867e",
    "0xF2C16ae7887450CE0018CDbAd26cfDbab183Ffee",
    "0xF2D5724AeF47b7E071c31D387696620458D876D7",
    "0xF2dC9675fF54955716ADD76dcAC0f94C54577Fa3",
    "0xF2DE20332098bF0a4Fac005925ac6627F39118dA",
    "0xF326E3fAF675Fb22c3bE629Da250a8d43Ce0E1d9",
    "0xf34042a11781B65098Ea15a363298966a6452459",
    "0xF35761e84ABF8e3B4d42DbdB6D7cb052E5d46518",
    "0xF3719c77Da476a864c9178EC0F2C3d3F59a86d03",
    "0xF3798e81198ad96f7595C044CC30E9fD25cd0E95",
    "0xf37Bab188A985EaD55e84A6F115370FAce240E51",
    "0xF383D4Ffc60e81E9072887879eED8D475388Ac57",
    "0xf394e7823A2A7d703B221f167813be616539b303",
    "0xf3A132fA9A3f15e88Cb158B66bc495A3d280D184",
    "0xF3A1937DDAdA498e0F74E1de60613b98C4b8d81d",
    "0xF3B49e04528f2C9499dEAB77ee7371264eDc3948",
    "0xf3bDa98A1Be61D8C6fd7B2F757123AD7acc05Bb6",
    "0xF3C76c76FbB50cD4c7b07B07F8142a8B3bEAFEf6",
    "0xf3c7E9850d19F9559E1716D1082BcFd143B307D4",
    "0xf3CAD40f7f7b43ae2A4226A8c53420569458710C",
    "0xF3E06D2883706AC0810317756d055cf1997eb24b",
    "0xf3F83A455a09b9fE5852b7061a95d67730A8980e",
    "0xf413A0451d0479c0F0c1Bb469BbA2d94e6Cf79be",
    "0xF41A375d6D5B9835d9b2c3A214E0556503a0D6c0",
    "0xf41FA837908c0318A9A2b739C8fb990BfD4AC8A7",
    "0xF43c5d6d2786a6Ff916c619FeE1b63Bb34E03C96",
    "0xf43e2616C58983C7B8B0a55E6FAa37A1b5b980F5",
    "0xf446A9c73aa6D06810dC959E4104b6960A715822",
    "0xF44cB29e402593a3ed16A976bD007357dd4Ad2B9",
    "0xf46407b83435F971046E584aB65C172074Beb68c",
    "0xf46E25eb2459E2Ee29Ac4Bfc293241De0540532B",
    "0xF46Fa5604A6083a3931861258ef5061633Aa5A22",
    "0xF4837e3E9C8EE26D3358623f034A0a3278d503A6",
    "0xF48dE06387808e1Af9A6B76dD058824Ead5019B8",
    "0xf49113057738E8A400c7a6Ae744FDcae7a75A9c5",
    "0xf492B28cF8d43B42cA0bee2205F53bA1001c3237",
    "0xF498eE19EC955D01053c6CB738C555301C3366d9",
    "0xf49eC27F278295B94d7C3baDAaA954F0af278FE0",
    "0xF4A12bC4596E1c3e19D512F76325B52D72D375CF",
    "0xf4AC06201C1aEF8881BbEd49877cEED64364AE13",
    "0xf4B5DfC9Beb2FeE17f9f3Aa67D7D4fAb3E6B8e74",
    "0xf4C8d3d9e8EB86A8f3E709FEFbb7527F9F4ad097",
    "0xf4cf18c991eb852d0293A5fDf0302e1a77640A20",
    "0xF4D176848a02eb80b507E5301e6338accbdA4900",
    "0xF4ddB761035f0A8BaB16b4387477C9BE140E57B1",
    "0xF4e5C00287043C22199D238E9a8432A2e7414862",
    "0xf4F8743d35077BE7459Eb5D7eF20DB57De579192",
    "0xf5059522C8Ad92C6A1b1D93d7d88c8fedD1acf4C",
    "0xf5341BAefBbCc4145BA581E092E9cF3Af06A2E3e",
    "0xF537ce1342A248F21F7A42bfC30bf3160276fAaB",
    "0xf54AD07b2cc4cD3C31017128D2b2B9C78e168F93",
    "0xf56cF082cE102b5e694053cE7274ff18520046CE",
    "0xf596494CA4FF4518b50635257A7a2a90082bb1d5",
    "0xF5a6B235B00d56D583B908B6bbc6b71b6d036c60",
    "0xf5a6F7bb30F50F4B73F38B4a03e88Ad8d69b4412",
    "0xf5A74A49825FdDC6d331D4141C9A35f723709e08",
    "0xf5f0009469A093CC1e5Ce1FC89ec5AA18842fca3",
    "0xf606e9cfF2522366717E03b95bDfB59dC33C5f5b",
    "0xf61D734A5d4760B30e1B91DD418737bF2d4c4106",
    "0xf63D7a9644014b425919527643aD29B317D9450D",
    "0xf642B2F19f6c6E04aeE52BA68dA98dd13cFF4461",
    "0xF6505a101AdEBc358AecC00Ddc15380c87D02D4d",
    "0xf6598cA199dc739848d342Aef8Bb16578382a2f6",
    "0xF68AFADC033cF1881E3494A9eD548431fD96f2fA",
    "0xF690Ea2D970B4bDC91763a9777EDE121274210E4",
    "0xF6a6e4bFE9e10803b8FAF64eE6e32Dae2c825374",
    "0xF6aaAB8289486563Ae8620a78fC0ABD75D85A427",
    "0xF6b137075bdF7b8f169C79A5D4065A2EA4569c49",
    "0xF6Cd827D51ECAe00641DBAE59ad2acA4C83A3D9C",
    "0xf6D75ac29392976D538022dE2Fb14F8446Ab51aD",
    "0xf6E1f3f52f7F6CBB67cb5482E64abFb29d1E6f4a",
    "0xF6eb2f6D790b7571751e5803d86De376B248e11d",
    "0xf6F03be4f4C6058e8cf015cB8E6618FAa05b6610",
    "0xf6F1FB926d7dA20C29dF1830a6dDbA05e6f8b510",
    "0xf7198b19F1CCc6371884894f4Af84b8F2CF68CA0",
    "0xf7253A0E87E39d2cD6365919D4a3D56D431D0041",
    "0xF730c89FBD1F71aD35e82B8761F3BE0F0F8ce40A",
    "0xf75425740087f3C8705A4709fFFcC06d83dAF2ce",
    "0xF755556F009E1C66Ca32296D6f74444F37ECF1F1",
    "0xF75Ed978170dFa5ee3d71d95979a34C91CD7042e",
    "0xf77d407e44051D51FdF965242454Cfb717c103Eb",
    "0xF7a2Db6D1E16F36e03065c48A16f591C18BD8D53",
    "0xF7A6574fb1757a348fA1A44e5cC95a9D8e091C52",
    "0xF7C441844d16B9bBc7f5a83e52b2DFf6B7c58150",
    "0xF7e9b262BC34e6e13bdbcB4f2551eA7951E261a7",
    "0xF7EBe3C53BcA14b6D5A88634081BC07618f00668",
    "0xF7f0E26fB79Fc20420309758F803aD28314098C1",
    "0xF84555eD94Af8A266ddf23aF5D2Dfc9dA45B5A86",
    "0xf868a2DE45bc38844B16C9e63FdA5E1DE1d54A22",
    "0xf88C86725328b868BEfAb84a309b7D6e07c655d1",
    "0xF8b3eFb86939d06Ba2ea52Db73e93d16e1fDb712",
    "0xf8b62c0206eFCDE568d50e99A0365a8B1D683571",
    "0xF8cA8FfF328da76010CFDBea21d5742B87AF1974",
    "0xf8F1C5aa517B3496B19C3ADE3D09dd9Ca0F80903",
    "0xf8f43Ac4b22ce2CbAB12e2c3cB2a2d8b2f9ab056",
    "0xF9138Ee5e8f94bD723FdC716FcaDf34ce05873E8",
    "0xf92b7A518C0c6F0079679F1213D550A0fB19214A",
    "0xF93462Ca28b7242E1dAaE92912e854B540BaC44f",
    "0xF95FBBf2FcBAB485D80194BaD624CEfbCEE53B86",
    "0xf97146822887EAd324c4a53f5380Aa7FC70093Be",
    "0xF98c3c402f9db363d92E9bB15afaBfb9c0290114",
    "0xF98d78925E577DC5285417660044b94Ad3AEDc76",
    "0xf9A138C87CA8bF382913A54DDfA2D22E1F29c68B",
    "0xF9aD3e681Ff8007F5F1fB6B1D5203adC01D49d88",
    "0xF9be98374206ee5bD40Dc59c97B683A0d598778e",
    "0xF9C320F50118107eF06bcF7FDf91916746cEcfD7",
    "0xf9dCd7C5Cb97157F6249eE7960e9914443d88F74",
    "0xF9df5142559732B35891c1d29Ecb17E6f775190e",
    "0xf9f69cd0f3096dEBFB97e2F1c791e32D8A9cc136",
    "0xf9fc5f5E3d947EDDD32d168Ab00E4Dc2F08E05BB",
    "0xfa03E24fb66ba510f866d900fdEE7140Db501534",
    "0xfa077FD5AAb0F9e8cF2C08Bc8290F954CC9d0C26",
    "0xFa15Ce75fBa819eC9b2f6b589Edb18a81A3921e0",
    "0xfA31209EedAb830C08a8Ad0672EC9C2400ae86b0",
    "0xfa392dA6E5362a5BF73980D1D6a2AB47BeF2976f",
    "0xfa49a56e0E71903510CA66CeDC22A44CDCBadF0f",
    "0xFA4c65D08107Cf8DabE4C62fc72ee1498927571f",
    "0xfA4c8d511E8ef0bA85D07fa9F795408EfbCC212B",
    "0xfA4F169a045BD779dfb0B96534A2E3E077CC5fa8",
    "0xfA5655F0ABe388eAC5782c011b82156Aee42800B",
    "0xfa567946c76d7feD013bD8C66786775B44001F49",
    "0xfA5Ce7e0c0892a841AD402dEE23f95848Cc73759",
    "0xfa6b3297Cdf0ff9874200BC3001D6A9C353D7e46",
    "0xFA6e605dB1E0343c137837064f70bdFC90e976bA",
    "0xFa7338b968B10E91b57D256d9dAd05c4EF6e5841",
    "0xFA918Bba3128ff6EC891Ed4d74948dE50711Ac23",
    "0xfa98aFe34D343D0e63C4C801EBce01d9D4459ECa",
    "0xFad94eCD4D42C6948c3dE0E33cAC31AC268BE288",
    "0xfAff75f82500ceeA6177b0da8c5B416D10e66D53",
    "0xfB045ea4bEd248e99D5CCCbB6F237a6dbc54c74E",
    "0xFb09468DaC7F9305A96eb9c0F7E31406b72509CA",
    "0xfb16b00254adC3722cAFCa4F288A9BE5785B907d",
    "0xfB210A24b8553d04c6A1072a1D0215Ee154799cd",
    "0xFb239e0DF3a98F6B728200C14cB364CFC61dC4bC",
    "0xfB3214aEb47492164850576d9Ae0645C82DE9D0A",
    "0xFb5139b46ea75103F89a592cf6AD83b6512463c3",
    "0xfb51bb669BC1054c3c54d63d00fd9C78481e9cAb",
    "0xFB52d18D875Cd6d7C8A955E9EbEC4f935A6cAFA4",
    "0xFB571Ed0910b03FDf643347e5846F2A5dF63B743",
    "0xFb57F0e41eC52837de29D39A334280fD0a10B704",
    "0xfb5cAAe76af8D3CE730f3D62c6442744853d43Ef",
    "0xFB6a138aaFa9193be5fAd991B84eF5b98fF8640C",
    "0xFB756465e0fED28386073630B8996329048232F3",
    "0xFb8152057c397b6C6e14a84449Aa0E14CFC34F21",
    "0xFB86dc7f811409f704d4611Af5339065A35721f2",
    "0xfB8e9075E5682580a2661c8c6aBb844CeC2fCeC3",
    "0xFB99e2188891098132607cc07e34Df667B6cDE23",
    "0xfbaD3A2871f273a03f24fBa0bf7F9d60F0f460Fa",
    "0xFbD823AEfA42aeFFC61F53e72e9A361f96E14b58",
    "0xFbDEEEC0FaD5E2c18e9206E27d78039532594308",
    "0xfBEDEfe3BF9640DFDD4fbc38085c9ccA2df09EC2",
    "0xFbF4F544f26E85293e43d64375B82176847D198E",
    "0xfbf4fa7824FFD7d89585A2F860f94EB8128B03db",
    "0xfc00148AC71079c906D7D204DDdcFF00Bfd07999",
    "0xfc01E818bb7292D4f9Ba73e487Fe200F4289b81C",
    "0xfc0d4A66541dAC4D6858495Ebc79C8Eba7c524A5",
    "0xFc1EF5819D6CabD9E2198b27C171DD8CF44c30E2",
    "0xFc25a624BCe7e7F1A4fA8FEbc03025aB5535D37E",
    "0xFC2da59188Ef5717e23891c0613E8102615Bb84C",
    "0xFC48f79Ce93e407E13C058C0845Fc99430261fCE",
    "0xFC49524f4d0A1585E611bA478d225DC7831E2e7c",
    "0xFC549DDc9070BcA8ED3a249aa027959B8AE0Bc50",
    "0xFC60B11B370928368e6242Fa3b96996b0e04226D",
    "0xFc8884659855Ea70BB00BB515fa8938991e9c47b",
    "0xFCb85D4139123B1eC6746d1C487A2201045b9F72",
    "0xFCC71C59D541DfeF385AEf9bAdE861B1B96dF007",
    "0xFCD3715D0D22A781052533f06D4AaDF7E9502394",
    "0xFcD5c5b451Cf7A1BDf7020ff85b2cE0885Fa96ee",
    "0xFCdC3cf37E2856F13F82e5f1A7178FfFf79A4512",
    "0xfCdf3C2b2b6ba00e6Db59c70c424b27970Ff3974",
    "0xFCE3FFD04DE1ffDC60c1CC79a5127c5e4904c759",
    "0xfCE47DEdcB847449EC320E4cE9De1975E036fBd6",
    "0xfCE761b176cf360354C92b0eFA89cDE18cC00C7d",
    "0xFceEd4d2343BFDdFc612A3423dF1eA301a410D81",
    "0xfCF080D18E260a01246Fd5c6E8a893a7Def4D369",
    "0xFd098C76B24F66ea7478b76DeBeAbA03f398eEDE",
    "0xFD1128A32F751D7b3b57470Df9f907208A20D36B",
    "0xFd19276756130aAabD95DB2545Ac54c65A09B6C4",
    "0xFD36280f1157eCD0dC89db02979987617085Ce44",
    "0xfd4617981Dfdf01A8A098Bf2906d4B55Af801d20",
    "0xFd49B0054dedcc716aea9F8157f5372b86480463",
    "0xFD596015B962B03B6f7796b648b4b48AEc58BBaa",
    "0xFd845e07717B0329D3F19fc920C97FBA0bC4ee31",
    "0xfD85dd30e9c763b54A09A9198AA2c36Af917620A",
    "0xFDa10F33A989BE48909c4cb812a74Cb663144d8e",
    "0xFDa195157cFBA1c11871eCEAC1b8986eC441bAD9",
    "0xFDc4606687e663e5BC841B4eE61f884da4B0f302",
    "0xFdF2979cdfdA8fa7a19f7AA80177D7E9d245B90e",
    "0xFDfc9D56E716ec9D274010C593E93275F3C0Ff7A",
    "0xfe18EBF2d3E54AF293bB27b0BCe19e2857831708",
    "0xFe22a36fBfB8F797E5b39c061D522aDc8577C1F6",
    "0xFe5573C66273313034F7fF6050c54b5402553716",
    "0xFE64459ba83A0E5573F31C1C205f986eB7bCa46D",
    "0xfe6474CB60d7a3771cd436fc9893f78dA7B8D7Bc",
    "0xfe77bA27d972cdc6Bf1D3F2b38202F9A5eB10589",
    "0xFe9919569FEa41491750aE220F42058Ef0D2cE88",
    "0xFeaA09ba74cC380222880e26617124C7DB1FBf17",
    "0xfEBce17F4F23c0aB23A5216aacb48A4FA6ac3146",
    "0xfEf3427ccB8f70dae9930aE9F99650E36c9159E7",
    "0xfeF5fBaDA8FBdF8308535D69A791bCb4720Fa655",
    "0xfeF8Bf42F7658CFb496365CFb1D75F6e5B29EdFD",
    "0xFEFc2850B25FE1AA3e9Aa154DF61C6B9bC7AA374",
    "0xFf04Ad2bE522b6Af11A47cDD2dfDf7cD4346c432",
    "0xFf1e8f16A59D77c8C70a13fa183040fb1e2Fb2f6",
    "0xFF23c1390758f765a7CE28415DDADb1D128e5F58",
    "0xFF3b6d9E8cf63293f8706694d033a2D6D6aDb061",
    "0xff3bA4Bea4A58BF57d03643d9BCb2108BE494a5a",
    "0xFF44eacfdF3712dFC3A052dd4C0Ac6AE4FB7bCe4",
    "0xFF4baddb2c594Eab99Bd75a3795e21a4f93EEA22",
    "0xff56d36ff30751e43804DBB1b904aFbc115B3b53",
    "0xFf5A223EED941DA818D57bFe1A84A030b62DEa31",
    "0xff6554019DeFAcb7556c810756FA1107DAC99Dfb",
    "0xFf69Df6369c917664760804A2e6D827749b0639d",
    "0xff6fD8E63225cA5c9Aa4951A05d29e1d051A67E2",
    "0xff95C307253eED250886B6817239A4F7E90a05d0",
    "0xff9d63B034894a7519663878B80a00D2c9976CF4",
    "0xFFa7282B67f72eDd50E37b68d3599AA3FF3A9Fb8",
    "0xFFb33dD6F129E1829D44abdd7CEA613D19C7B81F",
    "0xfFb6af2202bDe4Bea385326395AfD94dd0D86b4f",
    "0xFfce09CA00041e196E10458d5f981C0a1a76FE98",
    "0xfFE69C3057d4947A14DFa1d0eD8d254220cFc05c",
    "0xAdC3EF5d0BA43564A88C1cB9fd4CeD1479bDfAf1",
    "0x190256bcD568768866ed408F2c25cF9404366Fd6",
    "0xD29EA96B4Ee96427d2688F68563353556d0E093D",
    "0x1C18c223acA0df834E0dA2797Ca275F056fB16c0",
    "0x467618E5b77f998bC2c253A5fDDCeA2d479F3381",
    "0x782F8686B40696C568dE700db2cDe9a708e606bf",
    "0xd2264cD172364a235cfE19845A6F3E1c9aba080a",
    "0xFa8ca29Acd1a27982F5a5669192A7048C0B990c8",
    "0xb1776C152080228214c2E84e39A93311fF3c03C1",
    "0x814D60499Bd401eCA426C86ee9B4167967dff8dD",
    "0xB36F7b24051E0bA01585F07C9a8D7e8EBF614F65",
    "0x0d2B2EdAa88b188018A6357d9DeE35575b8e3d3a",
    "0x2B8180cc492BdCe41F82438D2E05725101a043F9",
    "0x17E72A77A84C2705E77C686a3f756ce9d3637C58",
    "0xA58b4A80dE82b889FF40e487c58208A429c77f88",
    "0xdaaA80522efF9Ff677Ea2eD7b7Faaa3e0f825A62",
    "0x0F7A2Eb5DfE07f58B73F2a61094BBD3541D3c520",
    "0xa11f2694c030A00d020d2bc1BEe3BB6aA3076131",
    "0x2B5c09D4b96592CeaB26E8a6A4dc2f0C61B91E94",
    "0xeea89C8843E8BEb56e411bb4CAc6DBc2d937eE1d",
    "0x11f0C5E8C096733a1222a457A10a2471317D3487",
    "0xAAaE290a2E0a475F6A02e9A7775f0f1371637b8E",
    "0x035E8A0A57f24FD10D447c6cE44524513dd6e09C",
    "0x197c000D48a34051b6dA53083A935dA3306662Be",
    "0x3F2d363751A476CEE21553C307B3A47FD560aAC2",
    "0x4D256D52590C0758eFd7eb3fF0F2F9205BcF77F2",
    "0x5c4ff13fC1d3B104784AA04b85495d9fb61c7e64",
    "0x5f0eCCF374A199Be03f352E30ae2AB81ff203C36",
    "0x639c1F7B5449536f57b2F8c923F3F9F88FD40331",
    "0x6bB574d3ca6a24A74ab4112799Af1C13d676af6f",
    "0x708E0A418b0638eEF53e214AB7980Fb12E5FdE55",
    "0x715eE52bF47B8E32a05c961D2f9EB89fd4797C2E",
    "0x818822E5b31a03313A13573b638467Eb3774dDb0",
    "0xbC85Df2BD72D3b517EcA1Ab81A9c0384198b0f27",
    "0xbDbfE5F4D8775472b0398F88FC378ec2E5518558",
    "0xc07686AF7aEe9353D8E88febfbD72ec68411ccCd",
    "0xcd29E15dD7f89d855672c7DcCa5e8d3E2DE0b4a8",
    "0xdeDF4ee725CcDEb864757fAE2e7460655c8c9794",
    "0x1301A5a67ac6F7B48226Cd66883676f7D1aAB280",
    "0x5c480227aeE3433AcBC351241D49fb5acb454909",
    "0x8D819A4e694539A15399E10C3ee1DBaB065eFE43",
    "0xE1f68Fe1F86B18B6905aA83eda643406793ed85a",
    "0x21f42b6F96a1c8881955870EFE86003894882Cdf",
    "0x8DFdD0FF4661abd44B06b1204C6334eACc8575af",
    "0x9A9400413aAE1eD03fE40e5ABa5bEfB046AaF039",
    "0xc827D9D694A6ab7b4567FC9380662e5c2Ee368f6",
    "0xD1FC6C2c64268A854a766196cdAb99bc04Bf4e44",
    "0x1c738DA242630B2537ee97758149C3A9c8220d57",
    "0x57ef2a07b9e70cE289e3E6754fcf20512C8403b4",
    "0x695E63E22170f10Bc46a29722b724D60AE4c0b76",
    "0xA0d47D9d9cD9211b67029f92efbc7C2932c3C486",
    "0xDdefb6166643657187c587237C3868f0FB3E37De",
    "0xff4F2c41Af6BAc672164357677466Ded6B92dac0",
    "0x004C708F399Cab8d43C6994b01418D560aCad8A3",
    "0x34490AEA04D7e5754D2E03e208fEf7CE532fb02d",
    "0x468218136d1A25ab9EeB1e8fCfce789090855880",
    "0x46922fD37c463E9533C49aA633fbCE488A89ded6",
    "0x4c509e5E15CF08E93CfF1aFb62F888B11E827e65",
    "0x67829CE84c3ff466C3240837baEa122cbd067419",
    "0x6cDF12B6e5568683EA72960ce9125e2ab14B588c",
    "0x82f1e37Ef09B20d6b0354Ba30C36E1BF7BE6E559",
    "0xbcA9C9eC28706F4f0863D69ca4CDc9E65de801AE",
    "0xC7415e01a12f1E218ff35B8968F11182C3A3Ef3C",
    "0x08109a9be5Dd5387E9B3982C73dA41Cb1df1ce4a",
    "0x17b947811336764c0F0AE77011772a2ACD5bBa6B",
    "0x20D265ea7f638e76632857EbC7e0d5bfDd0FA4E5",
    "0x57Fc2006b44D9618Cc675494Dce94fac548Eb7B4",
    "0x5C3133922BC96d530b7aC5dfB79dFC7ED98665cF",
    "0x616F2EF297720E081eB69d4E4518f85572a6f8A1",
    "0x634C756520BBF085EDDf66Dc416CEc6Fd016dB01",
    "0x666af61d0215Bd9BEFf7275516DA64C372aEE0Da",
    "0x6d26E9c2f9DE0dCdeAdDAeBEc25FD1338678AcE0",
    "0x6ED7F81208839E31E11840049201201C469a7A56",
    "0x6Ee6805d588113c1a8B2737c348889f58279915f",
    "0x721030f47f80A76022966b02BEF3967A687BA004",
    "0x7fb6F52996ba02884Fd4Cd136bB2af3D8909c56C",
    "0xa3883b0fdE8F1420c2d462bcF20B98CdBE7F0956",
    "0xa59634bd45e22057d09D0B5778a6a919aD7EF32b",
    "0xB7D3A787a39f25457CA511dC3f0591b546f5e02f",
    "0xBe769b04627613C8F3b30aBE20E6458c1DCB239B",
    "0xc675dd20EafE6fEC8417cC8f8f5bf7AD11662b85",
    "0xc958362356E5881eC16B0bf681F22aEBbC895DaE",
    "0xCAE2c859148340705fF10C8Ef362274fdE9c1835",
    "0xD256c2324F3E36D06f5E645d309434b185C58E7F",
    "0xDD5E2D51630a01b56decf26C45c4B76bFC3fa880",
    "0xeA0e95671074c0B8fB9a699C2562932651021C32",
    "0xfbbD6e7d90C19b602B602731c9029119d89490FC",
    "0x06807D7E07290bE6AdbaCD6F209c4CEd6F183d74",
    "0x168148b70Ab69E4A1b12d591fAedcbE8a4226311",
    "0x21971b46Dce11084FE8ffCDFa59DA85Af91feFc6",
    "0x23C3BD1aac7F38371a3Eb8EF5F3Ef413d5896Cfa",
    "0x27012e1c3bCBc62325762aCe98E8e2eB8Ca6b90b",
    "0x34A94A458a536D3F62dc3167838F2fEc2AdfaCe3",
    "0x35c86a06d102B34767FD1EBaE75419b07f5Cc79E",
    "0x40Fb8a2652f6B8f41e03F7CD830C3CfFa46DFA1f",
    "0x4717a9459169A744b8114FE50bAD1E49E344bF13",
    "0x472666679f1261f504A454b49dA8AFEA22d093d8",
    "0x479746790d33D527C7f06fa67744c95D23482D3c",
    "0x50CD86868D9326d9ce433bD9aA16AEf91f6f461E",
    "0x520Fd8fAFb13f27F7c50FA962bC672599dfb34a3",
    "0x56888646DA93b28e92Fe2FED68Dfd082172a4faA",
    "0x6A092D806d731f65320c76647C5238600d2c3765",
    "0x6DE52B86c0f885187FF190C194086345e94b662e",
    "0x768c545669e6821E059473FFca7912D291078cFe",
    "0x8443626Fef5dF5F4D5E43Ee19bB2520142bbE823",
    "0x9821Aac07d0724C69835367D596352Aaf09C309c",
    "0xa2498aB7BB955e5FC8464330b3035E2395837524",
    "0xA2D2c79109117F046ce9f29D6C59023C994d13B2",
    "0xA6f4F0d0Fb25e0bfC8eB0e94ba595448Ae219116",
    "0xAa60a9dB71f01F88a7187d91B3B32EBc881c9C2f",
    "0xb12aA8282B00De547Fda518cfF984A375A61A29D",
    "0xCF040ef0Ca53514b1774539ec97e2698A8cC6169",
    "0xd230E2F09E09a20d69Bbb539092F9648cd22dF7c",
    "0xd63cf14D42F0aD2EA1B290fdD3E99de0C01a78EA",
    "0xDcf231d20d0061885DbAa310c9dB6F97A5bfD175",
    "0xdD97E26fd0042Ab3c2CEfb488894F50309864253",
    "0xf84F39554247723C757066b8fd7789462aC25894",
    "0xff6f09A3dD890D9Ff3DF2f4Be1E60716B0d83347",
    "0x0312B9E6627D9a49cf07a3B5aF1f18Ad8D8E39dB",
    "0x0db562EA15572FccF861Ac08D877F251eD8AD9C8",
    "0x0f5B2b1F108Fe0520AAb020C308e9C9Ab1f89aB2",
    "0x1325b85665DA4dC99835bCbBebD78Aa0c56Caae1",
    "0x132D9afdBCC0f8933a741f4bd065e314c16EfA9b",
    "0x1f81E2023B02a51458a70673E64411219ef7c62A",
    "0x2507e2F200fBbff420793585B2a10Ee4031845Ae",
    "0x2c3d0944c456C314a11E73Eb3067cEf892c6875a",
    "0x2C7896199760504E69f2c6eDd4D4e2c7E3bFe82f",
    "0x322Ac83477407Fd36B70933FFEfD5d90f838264C",
    "0x328E4554Ae3C8D9d64b19F3a18c176b6Bb33D437",
    "0x3a47e3A8e07AD39Ec191e169D4dd89D21586D406",
    "0x3A70e8C00f3bCf3eb845B6b6928AbA92b465C183",
    "0x3B3dE56a5D62da4645757Ab153E911Ce3e156ad0",
    "0x3bbCf2972299E6Da5eF830aF78791E3a7ed7278D",
    "0x3e370a6Ad0354769ce5A149c2943C0D0402fc20A",
    "0x4D21EE028e149A5B2Ec3D3D4C10D0Fa7Bdf381E6",
    "0x505205d921853C72AAAF07ADe150354D4EE483A1",
    "0x51E36a60585D55CF07f524f9432735147C14ab93",
    "0x591F9A727937932b2A8E16060Eb85B5013920528",
    "0x5a9DC3F62B089aC07718aD23a0311E1e8283ba72",
    "0x60882F5EA95feD716C44a228c7b340F54fccD512",
    "0x63297669983926FdccE1958Df4A0bf3Bb4cEdC1a",
    "0x660B8AafabC52d1312036cCB45DFcd1772C5994b",
    "0x67c86e5F32329E88de0c2e6c650b14f7a73f4DD5",
    "0x6B9645820fA2d7A0Cdf384a985621d6955AaB51e",
    "0x735Fb1B51D03B1230321693Aaf89e7D08476482e",
    "0x7AC38AF1cb54AE017bF88902AbECA4B69287383D",
    "0x7b2c7a4AC373C159C7d6009B036E7d7904579BAc",
    "0x7d03d2cF2C4329cc719C1654E400D05530A0F6d5",
    "0x8462E52D9a6a4A5A3AA85652D8c5591be86CB319",
    "0x90c19feA1eF7BEBA9274217431F148094795B074",
    "0x92D2D6e919e9c7BF06b7713Bc80815F028D08E1C",
    "0x996e1d4ce3e1e558889832832004B2466153adbe",
    "0x9B3011d6Db7512F5C379d83F73a3962A950385dA",
    "0xa6394b8029d83eD9568935c819C4980FA8C42906",
    "0xa7E26fb3C8aA677684E2e7FB08C589bCef7260cF",
    "0xb1EBB1c3ea2FF7A1ae9B83D735C2600D3911bbFB",
    "0xbDEd72aDD80598aFd9E2EC3C5e5fe6Aab48b0f89",
    "0xc1326B7C1Cd76994b5cc84379EFCd38E419DDAfF",
    "0xC6C97a110CbF83C22324e9259e0Be1d2742Be305",
    "0xcAdA38b3D2e3d8714E783ae8C420B4024817E3E8",
    "0xCDC7B4d44070632893f431DED29dE9f39969Fb1c",
    "0xd2a62076ccD4832Ea16E96f59eBE1D2b50630Df2",
    "0xD55454982A30E49cdFD6c8f00ac90FfE4B529456",
    "0xd7d126110624A753cD36A5Bbcc0345825EE428Ec",
    "0xE1267F4804e088bed3d6F59AF0785491755Aa6ED",
    "0xe288a00DF4b697606078876788e4D64633CD2e01",
    "0xe4CB1CD585120E76eB350dC62f569d9880683348",
    "0xE74b1ea522B9d558C8e8719c3b1C4A9050b531CA",
    "0xeCBe5f4D026ECDD8C90EDcb4a7b68E3aF5485cc4",
    "0xeEE130D5c7bfA2FB235eea6FF0F7E083f0392afc",
    "0x014f3A8BBCC20c17428A8EE9214F4923e30ba4eE",
    "0x01668b28f1F72685352612c69f2Af6AB4313f32a",
    "0x02f18eC13246b9C94E3Be42B4D55A7772f641092",
    "0x067D3E5459Fa588aA5a5001FC9608b314E7e4A01",
    "0x09Ee3a243463F3ad0A276db78176DE6cE28Dab0a",
    "0x0F5f7cC05bA191db71d48ce4c1DA316BDd10B544",
    "0x14EBD37B2d40f73d5d15FC1493459435186b3691",
    "0x1660207BF5681c9cDB8AFe3A16C03A497A438753",
    "0x17fCcdb83768b93299aF457a437E63e98404f7b9",
    "0x17FCceE77eA267079a3E3D83BF1AbCca104D4eDB",
    "0x190Df4b839de0f4213178d84809db7B27d984fd6",
    "0x1cccEAf45873e1A9464B493EE813315a8DE06707",
    "0x212c5AE33F8668B700C62EE90b146f043a1EAeE8",
    "0x2321eE6246999a80443F217066921EEA123e81E0",
    "0x272d68731F03a1BFF4516Dd7C176f64b134b7935",
    "0x291367ef58A969b63eD9115CdB53FF0374757Abc",
    "0x2bF4C5804B9290774889572bF76e31B223b73Cf3",
    "0x2c7f784aA22E13905A9C973099f913dC77614812",
    "0x353f6124e6316cC19f0f0c4335bDFa1B268071B3",
    "0x361d369877FD8Ce8592D190E71D56ACf892Eb9F1",
    "0x37F8623E9d526C18826089eFe35b22dAFfE29C29",
    "0x38c48591a1865E7824f9cE270c46d9cbD329c9F5",
    "0x3Cb91F78dfeE218f28611e2B2b67DA19DF500B4c",
    "0x3DEF9222166C1108295c2C8654B6F510d3E691A2",
    "0x3F2FaFf871985c765F01ae4Ff767cFC8E3e42d42",
    "0x3f75Ab85b1d19a3eBC74E9Ef7B010348D7007500",
    "0x452C012E55f7A27D3c25CAf15FDDFc5D63004cD5",
    "0x491D2504fC2dBBdb29137bc195D3B4b4aF6D49D7",
    "0x49871414426D6dA8A45138E78174852232E5972a",
    "0x4Bc32dCd65061C069FdbEF3f371C460e534Afd95",
    "0x4c1318568Dd2014aEAcf62f3e568386e89ead1c8",
    "0x4cdFa31261663f043A654DE188dD37092cd4d7A7",
    "0x4d79A69354188e04118722b665c558b2c75b6A47",
    "0x4e364a1a9A112ef49AF931e73Ec4F0454b12fBb4",
    "0x50126C94E46B3315DCe43F5cc902d4737585527B",
    "0x50181E4a6F1cdd451E6E0e410974CE956e0346B7",
    "0x501823888207998c53d3318eCBAc990E795137Ca",
    "0x526026039434039Ea966075F7bd0f4EBb3EBc6aF",
    "0x534F1F684d973646031f2Df2eF22C8682CAf42F9",
    "0x55Bd0878b1651a015d58Ae544BAc27defF50719A",
    "0x575f73ba38E0aE1338532108CfF9aFBFA48B8817",
    "0x5A23d67b69298f18d87Ef04B4E209af6Bf118c5D",
    "0x5c5184BD1c758c0aEC54FAF012e2491811801429",
    "0x613d2f6375189f73d802338f83ceF647c2b3b206",
    "0x6221b4B57f39B25Dd0433CB80cb218C37c200aCd",
    "0x65079ce963D5181D3e96a77f6499120660252Fc2",
    "0x70EBad820B1d70ff702B4E084CEd819d8f04568B",
    "0x73D0851c7Bf9DB0ca8A9463b4421c0d431D416f9",
    "0x73db4228FDd1d2595f85b23FD63de1abE901E259",
    "0x796688C9DC9fEbaC28311eac585f117858316385",
    "0x7C6A702f64e4D47a786dCE96527123Ec4D6E3343",
    "0x84430D05B1755aA95cEDB7fd2b57418BA021bB82",
    "0x8514067108E115D601A4100C5E7DA8A4B7b3Fd8b",
    "0x8637c0E4DC74ab7914e09A0d05613cb1f9732F01",
    "0x890892901c0B31aFA130CaF001e5b80A68FafbB8",
    "0x8981a87033Bc2344f2704Ce3F8f0c5d1Bf009DfB",
    "0x8cbAe006DB9936433961dDd274d0213ddd53222E",
    "0x8e88cBdc145E1fB8ea9F9A5E55C55CD7e04A9441",
    "0x9305A3a61dc1169845a543D4b4bcF09C0729bc83",
    "0x9401dE334Df0aE141D3397e27a9e712C1f42a0f7",
    "0x9a65627aEBeCb582FC9591506D9ab27eB1134e19",
    "0xa9080550F1b8fAE7f49cFA9CC063B99bF39C10e9",
    "0xaac92DcE0619d982DAF92FD89CEf4ed3807E68c9",
    "0xaB94AD159De7143e1a191770A9524a9d1011AF90",
    "0xAc06d32f100D50CA67f290307eC590443d639c8e",
    "0xAF37095812a4744e1534438f22845C200C718380",
    "0xB37BB47119775FaE9dfc77Bf1a8e54d77cdd7221",
    "0xB88E29F546b99C0a9aFD350414CE1054919B6e50",
    "0xba08122398B8AbCa2Fe55299b6F805f4cc361d7c",
    "0xC140E489e7EA253A8A7D5cCB91aeB0Be5f8Aa098",
    "0xc334aa4437d7C36c692F06fC14011fC35bC2Fa67",
    "0xc422e7F3d1Eef41FC46f15F2AaC99C75C9b0A28F",
    "0xC540E9A093b73380B99A5A9213c3a70845b863dd",
    "0xc56f60E4D776683B3bF186f83C9BbcD96B7d7EE2",
    "0xcA6cdE3D87C8b1628725896AA0F1FAc078c8cbe1",
    "0xcC0Af74c6a2a14734DadEe5FeaD9741Bb5A1b1Fe",
    "0xcC427c6C42F319Edb5a9757Df9e700826B4AFb69",
    "0xccEE88812Bea9Ba2820afA1737E25771988D57d1",
    "0xCe348898C067E1e268f1C4Ad517f6A04c15Ff4ba",
    "0xD13EaEB82c1bc7cdAa72359c1CCf956ebfD9b5c8",
    "0xd3dB9E59D7F8967455ba9347fB27Cc5C9CCFAc9A",
    "0xD743F433aa2FB6Ef78854aAe3Fde49efd4870F47",
    "0xda661BBB29B7C81b6e828353a933cfEF71Ac5772",
    "0xE35D1912f536f31DfDFFDcd69715411Ff2EA3c0c",
    "0xE414692a0762BcC209C879395285927ddB1Ed981",
    "0xE6341B4345805e21A4ea27a643B8280dd335fB1F",
    "0xE9C0778Def1CD8a7fBf14aa705b94626487E8a5d",
    "0xeB788C1E1dAa73903075C4324C38cC01B52a5544",
    "0xeebFd0aE2CE773dB3dADAd8D51Ad59eC11567F16",
    "0xF171A0d4d816C59d628a980a4a76A33C25452c10",
    "0xf1Eb395340cA96f196414fe3213731450DE478B3",
    "0xf24560D0c0e0914ce28b33E332dADB7718C85313",
    "0xF24A0018befb3D7503b46c110f83D927d64E727d",
    "0xf55914186a692a3335fF44ae107FA724b1074dDC",
    "0xf7713D6bD0d5055488f35885321B191b9CFa4b65",
    "0xf8DFDb95Ea8aCb8EAee9c092cE54d4A35Fe966fe",
    "0xFAfFC508Ef411e4A8cc6f54862D00Cbc7A3Ce73f",
    "0x012c78992D26225e0108099Aa9B5D1881947E4FD",
    "0x0193BdAb62C43337B806431c3fF861f97a532ce1",
    "0x01aafF4868Ff342e7260C02b110bd5b8C7749D29",
    "0x02bfA1dE8eDBCB6236921d04B71512bBFe1971A6",
    "0x02e6a976b1081102d423D16c0950717b75FF7C05",
    "0x0417E060dEB5d423F12D3cE2DD11Ea72E2B68E1C",
    "0x0601211b4F71bCF8bedC97beE2cDFc2392C5bb4f",
    "0x0692F3988745dB7a87609993296CCE60216fae9C",
    "0x080a0CF78C44A757e766Fe8B696B6A5c7d03A213",
    "0x089aD55045fe72f1f77eAAC7e166de9e277600A5",
    "0x090fA5DEb21aa2c60e3e80bCA80f15d67C1ed3f6",
    "0x0933Dad4354e5449d623d96Dcb20d45DcB990413",
    "0x099460639a7e0f7ad5221d7F02B22b920E48767c",
    "0x0a36F06FC5a28768ebe9715C787122995d80DeC0",
    "0x0b03a3766E89D1f648cb3B78458D0553A2c078A0",
    "0x0bDDDD31761CFF9150999E7357af4506F818eD17",
    "0x0d57B444a672D19CF8d6B123F3e68Ffc38A69ADA",
    "0x0D8b2B0B50172aba1F0F338364aacB235781a70b",
    "0x0E33A76161bC79C1Efb2D0040e4e2ADeAb09740D",
    "0x0E479f4419674D526998D1b2579b772d910c521B",
    "0x0F56DA5Ca9299C9AF367a65Cd130715b10A9cc88",
    "0x105e4a5AFC07f627B975f42c7dF90783cd3667AD",
    "0x10FdBff07AF3cd9aC8BAc848B850fE3EdBFAcB2f",
    "0x12EAF457f5535913DDeFDD3C3B595882C47B98a7",
    "0x137F41ca27F570D4c50E56D5c20AE2807225F09C",
    "0x149Cd83f40581e34701551035fc1cF3BDDEbcc25",
    "0x14bb4E5aee12c1A24a543873656D694B2Ad657bc",
    "0x1737df19317601eD39fDf477c736fBeEa0a46a76",
    "0x17A4e4AA1F87F677B6930F8c1Bc6D3449181Ad95",
    "0x197Ea63D275577321bf1049CA169420234F59415",
    "0x1b1Ed976669f4b33F436e22Cb9CD0e85B26Be5A0",
    "0x1D4d668d1E6a3bb6f8064B1DF2EdE9F3e118A5Fb",
    "0x1dC5af04e2CAc42D89848F69f968e970b73D8ef5",
    "0x1f886800256b7fEfB086Ce02b13B3434Ca1579A4",
    "0x1Fd2f34B8113d7619fCa5E501DC4378d615F5944",
    "0x2032d6Fa962f05b05a648d0492936DCf879b0646",
    "0x20FF683f1EfB32224528502A8C92284Dd4380eaC",
    "0x218ea92aa39959EEd5Ac1D6a7F3597912B8ce1F8",
    "0x2343a29437F25Cd120AB86e3096dDf6E4d2D20c2",
    "0x2349A1deC544F6eEbB87183E2512aDcD4033438f",
    "0x2373E15a0d1989c1E7bdbAF593b769eD6b007F09",
    "0x2383B19f9D40D008A5f3e7C4f2569D5Ff5e85015",
    "0x24a604b92DdEB9a90EB0CD1Ad25088433Cd0Cf8a",
    "0x273d6F310611d1fa990850A05d306d49796a1686",
    "0x27f4c24677976deD17302E3673DB2B5C2AcBBB42",
    "0x28beFbc9F205a3f0317F2f793f424957896D4470",
    "0x293A7Dd8b79723a8983AbCF5C7b0433755e64193",
    "0x2E37CD2b21dcaf026fedc9fe68eB89f17944c835",
    "0x2E602a8306F4cC144B8C433F093b16A36C6c4730",
    "0x31636c87d1844Bef0597a0C6DE9aD84B0B065815",
    "0x332d424DbAf2839e3cF3b53Dd0F4CBC2419fbf69",
    "0x350475188665909d5059E13fA65F2fF0fB0A508D",
    "0x35946F7931C2341F5beb86aC880c176A93797014",
    "0x3795B99806683036a4790c8F36b641cE6438141e",
    "0x3883ab3F24c7B34a5238ae7977a807e653b1a3FD",
    "0x3899E90747c83Fa17c319EfCCd15657Dae71e920",
    "0x3926fCF2FFB228be666250e8B900333f558641F8",
    "0x3a1aaa3AE4cDb1C23109B4a4BC732F8F8662a420",
    "0x3B0F627E5051c40Cf2787C9cd954E40a3d44E753",
    "0x3b1163fE419ADddA99E2baefF22ecAfb40528872",
    "0x3c061e4f94F198c80A7a78b345C4a1D5450f9544",
    "0x3C2550dDB9294C21d209999Bdaa15f8249d0c161",
    "0x3DB33CB795646BF1978CE76EbdEeb48e9F0a920d",
    "0x4077F22EB377C6822ba40c78C57668ea1d23E9D2",
    "0x41eF42Bb9cb016DeEb25D7cA99cfa2f464e3863f",
    "0x426A04b46e1052712b021213A63Fe40e5376F8Cf",
    "0x43A3c7dc1E24A648E1C2b8AfC7d7a6d3E2821530",
    "0x444233F092FCe8318E2FCb7B4b1FBcfcCE3b242f",
    "0x45F5c9141d68C6194195756C67Fc46c99d021EE8",
    "0x467B38956Ce4B511ff6C15B5a5Bd7694EDF922B8",
    "0x46968F62359Dbd17BC686182C8820fe2DF1f9c65",
    "0x470916F366eE9359EA6F4ADec3dd57EB804E6604",
    "0x47b093c50E6F5911240173919cfcd744B577989C",
    "0x48876F00A4Fb62947bba5073fE5e63724db0864E",
    "0x48F021f0711cf03e566fbe5752Cf4247098bF864",
    "0x497A66D8372d6a5a2e1243c6fc311A767e2E8da8",
    "0x4bE3d9a1c494f885212Ca6B89C4eb2Ca1d44B830",
    "0x4EF4AE5Bd4F95807EA247d81Be51658Ab77DaF39",
    "0x50a8d2Ca2C6911515ff88ee155f72fE3FDB6Ad76",
    "0x510ef8c08f4298999d2268DA474275Ea73EE6AFe",
    "0x5294afd3e020C1aB4FeC588ABFD559463C0E6b94",
    "0x52CdbC4878E990a782374F6387966d26Fc344D70",
    "0x52DA39325E7B4e185fA7b041082Ee11B9c823B34",
    "0x530B6FeBCF60Dd3B342A7Af981765Cbe56Dc1ffC",
    "0x56Bd3E16D39B3feB3310abd358E00600BF956Ae4",
    "0x56f39A055710fb915Ff84860eDD89Cb41aE5434d",
    "0x57F3793792D1541421ac3138Da3E818d108C35d7",
    "0x5A32E4D3247be4364D41F2240705bd4FCF2d7161",
    "0x5aAEf3CC9c1fb5CB3E771F77979D08b3440F2674",
    "0x5bfDAB4025B4F7338150161A348235F33640d96f",
    "0x6102fB7B72936d10d1029573461cC2409979F49d",
    "0x617Ed24CD137A30DBBE94b53de9ECf4b5Ed8E90f",
    "0x63f53742057a1f2C8322725E913CB26d9CA97867",
    "0x65Cda89Dd912DF3a5f0440b79C9b05Eb58098B30",
    "0x66Af9E0005166fD3631a5beAbb6C4eDdF3a65312",
    "0x66F3e8BEfA1a147567aA135a5b7d7AE5bE205F77",
    "0x674633c3b1820cA2a52FC41176Cc934c9A83dcCF",
    "0x6790Efc4F9b383d46CF6f6aDBA10916b1F739eA6",
    "0x67d49093F46e544Fbb8daa73d3B186d977e7aDcA",
    "0x687f868055eeE2ac0fAF551dD1BAEC00e760BE04",
    "0x692EF28bd5Da6AB68543DF4dd279bb430FF6C653",
    "0x6B8c6fafCa4E8BA7708C86160c9438008bFC3ae7",
    "0x6bE66782513FEf685f48F5e5f13f66aEe3e91DCE",
    "0x6be7A070f2AC6913a3DD3CcD4b0FB7f1CaC50287",
    "0x6C5d97f8629574E9bDCBe8Bb5af7A191b83a900D",
    "0x6D765f26E56384Ad21c5103995ad1c21FD239589",
    "0x6e4d87709d9f15C4C8b0572F7b60C308a604A7bA",
    "0x6ecc48550210eF12203d3e355d215a24FAfE71C1",
    "0x6fC93F54f95c63C917a98D03dE27302f078436A2",
    "0x7023e2668275143ea4Cbc3De311D7271DC46D64F",
    "0x7095D3ccF10fa52325006585226E4383268a8faB",
    "0x7222659adc246fd757B411d34E786F27E644708c",
    "0x726722eFce03BA4cA836485d4567B8114033D89E",
    "0x728E9080c0770710300919E62B7C308F518ca5d3",
    "0x72aF7665C65f61A4CC48D320210abD2C119a4190",
    "0x72D800e3dA8D42Fd76779180c8dD0449e8e53e09",
    "0x72f1b094B3D64fb6c3378a26A71A0972Fb65d1f8",
    "0x7303F43B9E47d0997f4126C9e094eee8FD8eb181",
    "0x73E55d8d63Dc7CfA52d10af0f826Ce41f5fD274b",
    "0x74C8c6Ce9766C5f77e3E1aD5c75FE7Da07199fC8",
    "0x76943740f05a7525d2FE79a0909a38FdCc2740EC",
    "0x76d1B95EF7B01F964D6f6AB28132ad0aD2799D6C",
    "0x78BacD44bFd671EB252B4c395C3Ba77862f2A412",
    "0x7912179A249300600256458dCfF0Bf2D63CE0fF2",
    "0x79d3C7FA7C6EB2A369Cf18bb3bC3eAF1A43B0Bd1",
    "0x7a47D8a490F9EA8B41379EA5C4DFe19688030fb8",
    "0x7Ff8be43A078134F9c8230e9B9303d342bC95D75",
    "0x806A613125Dc9c4bf6629d79ab25FdcD576002B2",
    "0x832d82f3B9A306d4A6FD0bdfeD528Dfdb32E8A79",
    "0x83Cc554926194956577d9e3408D60BA1212Ec15B",
    "0x84beE312e24dE23581388F85fD3a09b9f18B5093",
    "0x85123a875c202D04D21f834Ebca00A8277300C07",
    "0x8534B5E068E1ADB57CFe44554F4E65c914603f8A",
    "0x857bD8cE8265683d8562957C82FAEca318256984",
    "0x8599e6ea518487109f5cd70FC973443E85B2F5eD",
    "0x87C35beeAbc4A0434154D516dE89773fe53477Ce",
    "0x88958d9F8AC857302663cD2c496327C6956ed527",
    "0x88AEc9911A56797F1900F677cF428B9Fd61A54a8",
    "0x897284ee68E612301fc6A563CEA6942c312e383e",
    "0x8c31a1A2816C222cE52B8fb0E5c94A0C93420385",
    "0x8Da85C41c6ec05412aBf7444903438757bE76A51",
    "0x8E8081CEe9196e20DaB7b314AA8EaDBbf41816D8",
    "0x8f3A84fF458698de843064FF2c318975abcCc303",
    "0x9099dd630B7D279f3E14dBc08eE017CDdFce6D13",
    "0x92bAB5f0Bf66fCB2Bc0396D2997A1FBBF66Bb29C",
    "0x941b5433dA07376CbE0B9ea487F19102F0A9c528",
    "0x9433a650937374324c8905b22d9ab52B66544b24",
    "0x950bACe3Ee65e3c1148a1A07395E04f91fD49d76",
    "0x9582e15D63B961ba09Cba0410c99F4564910e6e3",
    "0x96746DDD14475e2d6d9C2fD921243AE7BC7C9f27",
    "0x98128b8AcAbF5FC3531Ff3E9e91f0E39F704dE85",
    "0x9A00c090aBcbF97b8F3fc5Da345282B37695dc98",
    "0x9Abc30F3fE9e2D8Fb49BD9d2376A22Da2DFd44f1",
    "0x9B1F5542C1A2557b12cA6Bac1F369143eDd08951",
    "0x9b23e0537E5758A8E608D7062952d02509bef0E6",
    "0x9D9068431b51D0bae694ee708Ee9B8f71E4Aa03B",
    "0x9E5434A1193EFD56BF17bC56796158862B3C5206",
    "0x9E9954Ce2Ad52BE9f2cc689321a0afbdc17926f0",
    "0xa58C4334EA5c684C59Ddb07751c6aeCd7B08Fd2f",
    "0xa5E296cA717E906926567Ab893BcE2c0DacdfA0d",
    "0xA83Db13e2AaB594040E35137578Cc693B420A2E8",
    "0xa928052965e5e989927CdBBb77E408033c8E6506",
    "0xa92CB2E3667973C8C766b913FeCd217D25b53FFc",
    "0xaA6FD0c3dd82e34B1A0ce7A526235336442fd678",
    "0xAaD21a4E83708284dD1127eA7415aB13C571Fd40",
    "0xAAd71f456F04d2F4Cf869312E1A9169c1Ea51BA0",
    "0xaC4109A00aF7d892bE8512E82a9C82CaE63DE88b",
    "0xAd77B519C6478916f50041fC4f67e61AF24791bD",
    "0xaea5e86d2F86103AAF811032A5bb4eC6b587C145",
    "0xAf46A2498a663E52c222de55AB7F3c6fe145eca7",
    "0xb02cCAEc92b8923EC3F54E0af94126b0C52Fd41D",
    "0xb0ec86a31F2410853Aa2f6D90b6F77A886F7F76D",
    "0xb3B2D17f868C327D80F63c00480B6A811C132a7C",
    "0xB618D796bD7eD78387C7dE0e08BB9868e98fcDCb",
    "0xB7B9A7Db7bD0393184Cf7aEB080dA45a8c0A02B5",
    "0xB8c63396cCD46C75A0E23F6818C97e5BD67f4ae4",
    "0xb9F515b5bfF00bD1d0279443DBF2d07fBefC568E",
    "0xbA0036d21294d4027E70Ece68bC33d2f117c8C25",
    "0xbA351b8E093c40dF954b9328484036fb271B4D86",
    "0xBCd131BC9D3a4Fd183142359edfe86a2121f51E4",
    "0xBD884ba7aB70Cc88b350dC79711b65A040D8Cae3",
    "0xBF50954FFc4Aad7Af162eB2634239d6a7D91823A",
    "0xbF8C72fC4406cb8C8463599F62e6F928b423B3b4",
    "0xc086B0C5d715ad52cf9e8926E15E1B88b1436263",
    "0xc2C48508C8271461424AFf4e069Dae12349D30d9",
    "0xC3eA80aF3D4dA5Dc27C0591988Bb45A581afb7F7",
    "0xc446536Fc75fc63c06682a8C66a83DC38f5F5296",
    "0xC4825b74C238910727400Ab2980dEcedAf1A0Cb7",
    "0xc4a5B26040c95186e37Fe8e1b262026d4F550c86",
    "0xc9100b789917214A6EADB06c36824540c57cE7CB",
    "0xc939a15e77825B48cF56a367A528b46A2EAE1a6F",
    "0xCAA4954431b6EafC5624a8cE2271dD702E44d302",
    "0xcb0B99284784d9e400b1020b01Fc40FF193D3540",
    "0xcD43c8a3A54B60b4d1196fBc5A5fbD5801E37b38",
    "0xce7cdCCA6E7557E05DE4F5d7355F89ec76480f50",
    "0xCf3925e6C643A8f75FB9d13da3fF47b9824d4004",
    "0xd0A53702A5065aE3f0376b9484a069fBF662a9F4",
    "0xd0E328a2beE2B484C3C7062299E09F6E80ffD7C5",
    "0xD1a2BfFa66A23b657ccB4e35425D9Db6f667B29F",
    "0xd57d64959E4A38b66fb3859281634E4614850526",
    "0xD7424b07B6f48989eaB8F3a0eFf8c256852b4a7d",
    "0xD93B12EC4a24e8d3433539307218D751F5650907",
    "0xDb740E0221F7255433e87d5a4EE8Dc0bBb12552D",
    "0xDbb1C4E1Bdf4Cfe7193144581cfa0D2Bd08FEC3e",
    "0xDc12bC5CB55eEdDdB4b28960009b63e1700c34A6",
    "0xDeC16184eACa4F62fFf3CaD52050438c7BBC0544",
    "0xdf4573148eb4ca34bE679f3Fa2B54a25f80f1F23",
    "0xE0022d2b65772eB0ED1feF2579272D63E8CA1A05",
    "0xe120e40cfC8734d0172376d1Ce9C276eff760d37",
    "0xE16E7a95aEF7D2391A5856056f26d7eDf7FEb1B9",
    "0xe4eC22e2e48b265F94E091b3588698e3B2D9208A",
    "0xE55a8A47E4fa55557A0CC2f535595BA4e5aEdD27",
    "0xe569da976d7954f5eb1484909D3E76b8dC1b37A2",
    "0xe571aE34a54F319Fc033ba606D7c901B3bB5fbbf",
    "0xe5AE336f3c5c8a222B243Fa0166555Eb27ea758C",
    "0xE6995433F80f242C887d184796e92CDC48E1b090",
    "0xe8d13D7242d95543a5B544f4d3c1f996558c9d17",
    "0xEB088Bd2C1644052DD07abE43B33F4bFD7f7760F",
    "0xEC33dAf08BF78255c92a58C87EEf0dDffA41B169",
    "0xeD02a0Abc9B81226b10a36DF4b70F0D186C41c20",
    "0xEd4F9274F5364286CD60a39602f2Ede2F767b06C",
    "0xee2C1a9559aE2A55aC2ab9cdCDB2d27BE85acd01",
    "0xF0713fE8fd952A464E68E6123d7FcA2675c3Dee5",
    "0xF0c0cc8d7A6c4D7bfED47c419E4f228384F16011",
    "0xf1b3722d6B88a034168d5dce2e45F004c3eEBFc7",
    "0xF1e50Dd0864a8A17Ed08023d033BBD4033e2DB6A",
    "0xF4617b57ad853f4Bc2Ce3f06C0D74958c240633c",
    "0xF53a550800DE2523c8AE1845dB20D385a4a83C56",
    "0xf5A3F562A132F40F44ABD401D603373dc36C77c5",
    "0xFA2f62906BfaCFA8c8EaC18E1ec1f7d45E4Ec135",
    "0xFa8b1a2D5Ab645463f7F3a98e9641a66e78d7b99",
    "0xfbf9F3838Cde1e10FEb5fc1C79f0De6920636895",
    "0xFdF1341B54288235CDd1e3aF300Dbd222Ed3615e",
    "0xFE53E594f981e234FCc5e33d3C37943C81766485",
    "0xFFaabb72c275d54DD3920819Eb74dbAFa5fF99Cc",
    "0x5a31496B40df50E4CEe9EEE03A5ea9249ad08eED",
    "0xd4b4FDa41B6c3B45e5c60DB35FE3ACC9e49CDB73",
    "0x675e19eBF696FAAA27aaa7531eDD51e2E75a5baa",
    "0x8403f9abC432Ea851E1e681605ee27aB2e2adDA1",
    "0x5a31496B40df50E4CEe9EEE03A5ea9249ad08eED",
    "0xd4b4FDa41B6c3B45e5c60DB35FE3ACC9e49CDB73",
    "0x675e19eBF696FAAA27aaa7531eDD51e2E75a5baa",
    "0x8403f9abC432Ea851E1e681605ee27aB2e2adDA1"
];
exports.default = whitelist;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"eQaWH":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>EnterArt);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _fa = require("react-icons/fa");
var _homepageCss = require("../../styles/Homepage.css");
var _enterPng = require("../../assets/images/enter.png");
var _enterPngDefault = parcelHelpers.interopDefault(_enterPng);
function EnterArt() {
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("main", {
        className: "MainContainer",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "EnterButton",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("a", {
                    href: "/Artpocalypse",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                        draggable: "false",
                        src: (0, _enterPngDefault.default)
                    })
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "background-container",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "AppContainer2"
                })
            })
        ]
    });
}

},{"react/jsx-runtime":"gaGEj","react":"6uln9","react-icons/fa":"4slQ2","../../styles/Homepage.css":"75gjJ","../../assets/images/enter.png":"i0aNL","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4slQ2":[function(require,module,exports) {
// THIS FILE IS AUTO GENERATED
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Fa500Px", ()=>Fa500Px);
parcelHelpers.export(exports, "FaAccessibleIcon", ()=>FaAccessibleIcon);
parcelHelpers.export(exports, "FaAccusoft", ()=>FaAccusoft);
parcelHelpers.export(exports, "FaAcquisitionsIncorporated", ()=>FaAcquisitionsIncorporated);
parcelHelpers.export(exports, "FaAdn", ()=>FaAdn);
parcelHelpers.export(exports, "FaAdversal", ()=>FaAdversal);
parcelHelpers.export(exports, "FaAffiliatetheme", ()=>FaAffiliatetheme);
parcelHelpers.export(exports, "FaAirbnb", ()=>FaAirbnb);
parcelHelpers.export(exports, "FaAlgolia", ()=>FaAlgolia);
parcelHelpers.export(exports, "FaAlipay", ()=>FaAlipay);
parcelHelpers.export(exports, "FaAmazonPay", ()=>FaAmazonPay);
parcelHelpers.export(exports, "FaAmazon", ()=>FaAmazon);
parcelHelpers.export(exports, "FaAmilia", ()=>FaAmilia);
parcelHelpers.export(exports, "FaAndroid", ()=>FaAndroid);
parcelHelpers.export(exports, "FaAngellist", ()=>FaAngellist);
parcelHelpers.export(exports, "FaAngrycreative", ()=>FaAngrycreative);
parcelHelpers.export(exports, "FaAngular", ()=>FaAngular);
parcelHelpers.export(exports, "FaAppStoreIos", ()=>FaAppStoreIos);
parcelHelpers.export(exports, "FaAppStore", ()=>FaAppStore);
parcelHelpers.export(exports, "FaApper", ()=>FaApper);
parcelHelpers.export(exports, "FaApplePay", ()=>FaApplePay);
parcelHelpers.export(exports, "FaApple", ()=>FaApple);
parcelHelpers.export(exports, "FaArtstation", ()=>FaArtstation);
parcelHelpers.export(exports, "FaAsymmetrik", ()=>FaAsymmetrik);
parcelHelpers.export(exports, "FaAtlassian", ()=>FaAtlassian);
parcelHelpers.export(exports, "FaAudible", ()=>FaAudible);
parcelHelpers.export(exports, "FaAutoprefixer", ()=>FaAutoprefixer);
parcelHelpers.export(exports, "FaAvianex", ()=>FaAvianex);
parcelHelpers.export(exports, "FaAviato", ()=>FaAviato);
parcelHelpers.export(exports, "FaAws", ()=>FaAws);
parcelHelpers.export(exports, "FaBandcamp", ()=>FaBandcamp);
parcelHelpers.export(exports, "FaBattleNet", ()=>FaBattleNet);
parcelHelpers.export(exports, "FaBehanceSquare", ()=>FaBehanceSquare);
parcelHelpers.export(exports, "FaBehance", ()=>FaBehance);
parcelHelpers.export(exports, "FaBimobject", ()=>FaBimobject);
parcelHelpers.export(exports, "FaBitbucket", ()=>FaBitbucket);
parcelHelpers.export(exports, "FaBitcoin", ()=>FaBitcoin);
parcelHelpers.export(exports, "FaBity", ()=>FaBity);
parcelHelpers.export(exports, "FaBlackTie", ()=>FaBlackTie);
parcelHelpers.export(exports, "FaBlackberry", ()=>FaBlackberry);
parcelHelpers.export(exports, "FaBloggerB", ()=>FaBloggerB);
parcelHelpers.export(exports, "FaBlogger", ()=>FaBlogger);
parcelHelpers.export(exports, "FaBluetoothB", ()=>FaBluetoothB);
parcelHelpers.export(exports, "FaBluetooth", ()=>FaBluetooth);
parcelHelpers.export(exports, "FaBootstrap", ()=>FaBootstrap);
parcelHelpers.export(exports, "FaBtc", ()=>FaBtc);
parcelHelpers.export(exports, "FaBuffer", ()=>FaBuffer);
parcelHelpers.export(exports, "FaBuromobelexperte", ()=>FaBuromobelexperte);
parcelHelpers.export(exports, "FaBuyNLarge", ()=>FaBuyNLarge);
parcelHelpers.export(exports, "FaBuysellads", ()=>FaBuysellads);
parcelHelpers.export(exports, "FaCanadianMapleLeaf", ()=>FaCanadianMapleLeaf);
parcelHelpers.export(exports, "FaCcAmazonPay", ()=>FaCcAmazonPay);
parcelHelpers.export(exports, "FaCcAmex", ()=>FaCcAmex);
parcelHelpers.export(exports, "FaCcApplePay", ()=>FaCcApplePay);
parcelHelpers.export(exports, "FaCcDinersClub", ()=>FaCcDinersClub);
parcelHelpers.export(exports, "FaCcDiscover", ()=>FaCcDiscover);
parcelHelpers.export(exports, "FaCcJcb", ()=>FaCcJcb);
parcelHelpers.export(exports, "FaCcMastercard", ()=>FaCcMastercard);
parcelHelpers.export(exports, "FaCcPaypal", ()=>FaCcPaypal);
parcelHelpers.export(exports, "FaCcStripe", ()=>FaCcStripe);
parcelHelpers.export(exports, "FaCcVisa", ()=>FaCcVisa);
parcelHelpers.export(exports, "FaCentercode", ()=>FaCentercode);
parcelHelpers.export(exports, "FaCentos", ()=>FaCentos);
parcelHelpers.export(exports, "FaChrome", ()=>FaChrome);
parcelHelpers.export(exports, "FaChromecast", ()=>FaChromecast);
parcelHelpers.export(exports, "FaCloudflare", ()=>FaCloudflare);
parcelHelpers.export(exports, "FaCloudscale", ()=>FaCloudscale);
parcelHelpers.export(exports, "FaCloudsmith", ()=>FaCloudsmith);
parcelHelpers.export(exports, "FaCloudversify", ()=>FaCloudversify);
parcelHelpers.export(exports, "FaCodepen", ()=>FaCodepen);
parcelHelpers.export(exports, "FaCodiepie", ()=>FaCodiepie);
parcelHelpers.export(exports, "FaConfluence", ()=>FaConfluence);
parcelHelpers.export(exports, "FaConnectdevelop", ()=>FaConnectdevelop);
parcelHelpers.export(exports, "FaContao", ()=>FaContao);
parcelHelpers.export(exports, "FaCottonBureau", ()=>FaCottonBureau);
parcelHelpers.export(exports, "FaCpanel", ()=>FaCpanel);
parcelHelpers.export(exports, "FaCreativeCommonsBy", ()=>FaCreativeCommonsBy);
parcelHelpers.export(exports, "FaCreativeCommonsNcEu", ()=>FaCreativeCommonsNcEu);
parcelHelpers.export(exports, "FaCreativeCommonsNcJp", ()=>FaCreativeCommonsNcJp);
parcelHelpers.export(exports, "FaCreativeCommonsNc", ()=>FaCreativeCommonsNc);
parcelHelpers.export(exports, "FaCreativeCommonsNd", ()=>FaCreativeCommonsNd);
parcelHelpers.export(exports, "FaCreativeCommonsPdAlt", ()=>FaCreativeCommonsPdAlt);
parcelHelpers.export(exports, "FaCreativeCommonsPd", ()=>FaCreativeCommonsPd);
parcelHelpers.export(exports, "FaCreativeCommonsRemix", ()=>FaCreativeCommonsRemix);
parcelHelpers.export(exports, "FaCreativeCommonsSa", ()=>FaCreativeCommonsSa);
parcelHelpers.export(exports, "FaCreativeCommonsSamplingPlus", ()=>FaCreativeCommonsSamplingPlus);
parcelHelpers.export(exports, "FaCreativeCommonsSampling", ()=>FaCreativeCommonsSampling);
parcelHelpers.export(exports, "FaCreativeCommonsShare", ()=>FaCreativeCommonsShare);
parcelHelpers.export(exports, "FaCreativeCommonsZero", ()=>FaCreativeCommonsZero);
parcelHelpers.export(exports, "FaCreativeCommons", ()=>FaCreativeCommons);
parcelHelpers.export(exports, "FaCriticalRole", ()=>FaCriticalRole);
parcelHelpers.export(exports, "FaCss3Alt", ()=>FaCss3Alt);
parcelHelpers.export(exports, "FaCss3", ()=>FaCss3);
parcelHelpers.export(exports, "FaCuttlefish", ()=>FaCuttlefish);
parcelHelpers.export(exports, "FaDAndDBeyond", ()=>FaDAndDBeyond);
parcelHelpers.export(exports, "FaDAndD", ()=>FaDAndD);
parcelHelpers.export(exports, "FaDailymotion", ()=>FaDailymotion);
parcelHelpers.export(exports, "FaDashcube", ()=>FaDashcube);
parcelHelpers.export(exports, "FaDeezer", ()=>FaDeezer);
parcelHelpers.export(exports, "FaDelicious", ()=>FaDelicious);
parcelHelpers.export(exports, "FaDeploydog", ()=>FaDeploydog);
parcelHelpers.export(exports, "FaDeskpro", ()=>FaDeskpro);
parcelHelpers.export(exports, "FaDev", ()=>FaDev);
parcelHelpers.export(exports, "FaDeviantart", ()=>FaDeviantart);
parcelHelpers.export(exports, "FaDhl", ()=>FaDhl);
parcelHelpers.export(exports, "FaDiaspora", ()=>FaDiaspora);
parcelHelpers.export(exports, "FaDigg", ()=>FaDigg);
parcelHelpers.export(exports, "FaDigitalOcean", ()=>FaDigitalOcean);
parcelHelpers.export(exports, "FaDiscord", ()=>FaDiscord);
parcelHelpers.export(exports, "FaDiscourse", ()=>FaDiscourse);
parcelHelpers.export(exports, "FaDochub", ()=>FaDochub);
parcelHelpers.export(exports, "FaDocker", ()=>FaDocker);
parcelHelpers.export(exports, "FaDraft2Digital", ()=>FaDraft2Digital);
parcelHelpers.export(exports, "FaDribbbleSquare", ()=>FaDribbbleSquare);
parcelHelpers.export(exports, "FaDribbble", ()=>FaDribbble);
parcelHelpers.export(exports, "FaDropbox", ()=>FaDropbox);
parcelHelpers.export(exports, "FaDrupal", ()=>FaDrupal);
parcelHelpers.export(exports, "FaDyalog", ()=>FaDyalog);
parcelHelpers.export(exports, "FaEarlybirds", ()=>FaEarlybirds);
parcelHelpers.export(exports, "FaEbay", ()=>FaEbay);
parcelHelpers.export(exports, "FaEdgeLegacy", ()=>FaEdgeLegacy);
parcelHelpers.export(exports, "FaEdge", ()=>FaEdge);
parcelHelpers.export(exports, "FaElementor", ()=>FaElementor);
parcelHelpers.export(exports, "FaEllo", ()=>FaEllo);
parcelHelpers.export(exports, "FaEmber", ()=>FaEmber);
parcelHelpers.export(exports, "FaEmpire", ()=>FaEmpire);
parcelHelpers.export(exports, "FaEnvira", ()=>FaEnvira);
parcelHelpers.export(exports, "FaErlang", ()=>FaErlang);
parcelHelpers.export(exports, "FaEthereum", ()=>FaEthereum);
parcelHelpers.export(exports, "FaEtsy", ()=>FaEtsy);
parcelHelpers.export(exports, "FaEvernote", ()=>FaEvernote);
parcelHelpers.export(exports, "FaExpeditedssl", ()=>FaExpeditedssl);
parcelHelpers.export(exports, "FaFacebookF", ()=>FaFacebookF);
parcelHelpers.export(exports, "FaFacebookMessenger", ()=>FaFacebookMessenger);
parcelHelpers.export(exports, "FaFacebookSquare", ()=>FaFacebookSquare);
parcelHelpers.export(exports, "FaFacebook", ()=>FaFacebook);
parcelHelpers.export(exports, "FaFantasyFlightGames", ()=>FaFantasyFlightGames);
parcelHelpers.export(exports, "FaFedex", ()=>FaFedex);
parcelHelpers.export(exports, "FaFedora", ()=>FaFedora);
parcelHelpers.export(exports, "FaFigma", ()=>FaFigma);
parcelHelpers.export(exports, "FaFirefoxBrowser", ()=>FaFirefoxBrowser);
parcelHelpers.export(exports, "FaFirefox", ()=>FaFirefox);
parcelHelpers.export(exports, "FaFirstOrderAlt", ()=>FaFirstOrderAlt);
parcelHelpers.export(exports, "FaFirstOrder", ()=>FaFirstOrder);
parcelHelpers.export(exports, "FaFirstdraft", ()=>FaFirstdraft);
parcelHelpers.export(exports, "FaFlickr", ()=>FaFlickr);
parcelHelpers.export(exports, "FaFlipboard", ()=>FaFlipboard);
parcelHelpers.export(exports, "FaFly", ()=>FaFly);
parcelHelpers.export(exports, "FaFontAwesomeAlt", ()=>FaFontAwesomeAlt);
parcelHelpers.export(exports, "FaFontAwesomeFlag", ()=>FaFontAwesomeFlag);
parcelHelpers.export(exports, "FaFontAwesomeLogoFull", ()=>FaFontAwesomeLogoFull);
parcelHelpers.export(exports, "FaFontAwesome", ()=>FaFontAwesome);
parcelHelpers.export(exports, "FaFonticonsFi", ()=>FaFonticonsFi);
parcelHelpers.export(exports, "FaFonticons", ()=>FaFonticons);
parcelHelpers.export(exports, "FaFortAwesomeAlt", ()=>FaFortAwesomeAlt);
parcelHelpers.export(exports, "FaFortAwesome", ()=>FaFortAwesome);
parcelHelpers.export(exports, "FaForumbee", ()=>FaForumbee);
parcelHelpers.export(exports, "FaFoursquare", ()=>FaFoursquare);
parcelHelpers.export(exports, "FaFreeCodeCamp", ()=>FaFreeCodeCamp);
parcelHelpers.export(exports, "FaFreebsd", ()=>FaFreebsd);
parcelHelpers.export(exports, "FaFulcrum", ()=>FaFulcrum);
parcelHelpers.export(exports, "FaGalacticRepublic", ()=>FaGalacticRepublic);
parcelHelpers.export(exports, "FaGalacticSenate", ()=>FaGalacticSenate);
parcelHelpers.export(exports, "FaGetPocket", ()=>FaGetPocket);
parcelHelpers.export(exports, "FaGgCircle", ()=>FaGgCircle);
parcelHelpers.export(exports, "FaGg", ()=>FaGg);
parcelHelpers.export(exports, "FaGitAlt", ()=>FaGitAlt);
parcelHelpers.export(exports, "FaGitSquare", ()=>FaGitSquare);
parcelHelpers.export(exports, "FaGit", ()=>FaGit);
parcelHelpers.export(exports, "FaGithubAlt", ()=>FaGithubAlt);
parcelHelpers.export(exports, "FaGithubSquare", ()=>FaGithubSquare);
parcelHelpers.export(exports, "FaGithub", ()=>FaGithub);
parcelHelpers.export(exports, "FaGitkraken", ()=>FaGitkraken);
parcelHelpers.export(exports, "FaGitlab", ()=>FaGitlab);
parcelHelpers.export(exports, "FaGitter", ()=>FaGitter);
parcelHelpers.export(exports, "FaGlideG", ()=>FaGlideG);
parcelHelpers.export(exports, "FaGlide", ()=>FaGlide);
parcelHelpers.export(exports, "FaGofore", ()=>FaGofore);
parcelHelpers.export(exports, "FaGoodreadsG", ()=>FaGoodreadsG);
parcelHelpers.export(exports, "FaGoodreads", ()=>FaGoodreads);
parcelHelpers.export(exports, "FaGoogleDrive", ()=>FaGoogleDrive);
parcelHelpers.export(exports, "FaGooglePay", ()=>FaGooglePay);
parcelHelpers.export(exports, "FaGooglePlay", ()=>FaGooglePlay);
parcelHelpers.export(exports, "FaGooglePlusG", ()=>FaGooglePlusG);
parcelHelpers.export(exports, "FaGooglePlusSquare", ()=>FaGooglePlusSquare);
parcelHelpers.export(exports, "FaGooglePlus", ()=>FaGooglePlus);
parcelHelpers.export(exports, "FaGoogleWallet", ()=>FaGoogleWallet);
parcelHelpers.export(exports, "FaGoogle", ()=>FaGoogle);
parcelHelpers.export(exports, "FaGratipay", ()=>FaGratipay);
parcelHelpers.export(exports, "FaGrav", ()=>FaGrav);
parcelHelpers.export(exports, "FaGripfire", ()=>FaGripfire);
parcelHelpers.export(exports, "FaGrunt", ()=>FaGrunt);
parcelHelpers.export(exports, "FaGuilded", ()=>FaGuilded);
parcelHelpers.export(exports, "FaGulp", ()=>FaGulp);
parcelHelpers.export(exports, "FaHackerNewsSquare", ()=>FaHackerNewsSquare);
parcelHelpers.export(exports, "FaHackerNews", ()=>FaHackerNews);
parcelHelpers.export(exports, "FaHackerrank", ()=>FaHackerrank);
parcelHelpers.export(exports, "FaHips", ()=>FaHips);
parcelHelpers.export(exports, "FaHireAHelper", ()=>FaHireAHelper);
parcelHelpers.export(exports, "FaHive", ()=>FaHive);
parcelHelpers.export(exports, "FaHooli", ()=>FaHooli);
parcelHelpers.export(exports, "FaHornbill", ()=>FaHornbill);
parcelHelpers.export(exports, "FaHotjar", ()=>FaHotjar);
parcelHelpers.export(exports, "FaHouzz", ()=>FaHouzz);
parcelHelpers.export(exports, "FaHtml5", ()=>FaHtml5);
parcelHelpers.export(exports, "FaHubspot", ()=>FaHubspot);
parcelHelpers.export(exports, "FaIdeal", ()=>FaIdeal);
parcelHelpers.export(exports, "FaImdb", ()=>FaImdb);
parcelHelpers.export(exports, "FaInnosoft", ()=>FaInnosoft);
parcelHelpers.export(exports, "FaInstagramSquare", ()=>FaInstagramSquare);
parcelHelpers.export(exports, "FaInstagram", ()=>FaInstagram);
parcelHelpers.export(exports, "FaInstalod", ()=>FaInstalod);
parcelHelpers.export(exports, "FaIntercom", ()=>FaIntercom);
parcelHelpers.export(exports, "FaInternetExplorer", ()=>FaInternetExplorer);
parcelHelpers.export(exports, "FaInvision", ()=>FaInvision);
parcelHelpers.export(exports, "FaIoxhost", ()=>FaIoxhost);
parcelHelpers.export(exports, "FaItchIo", ()=>FaItchIo);
parcelHelpers.export(exports, "FaItunesNote", ()=>FaItunesNote);
parcelHelpers.export(exports, "FaItunes", ()=>FaItunes);
parcelHelpers.export(exports, "FaJava", ()=>FaJava);
parcelHelpers.export(exports, "FaJediOrder", ()=>FaJediOrder);
parcelHelpers.export(exports, "FaJenkins", ()=>FaJenkins);
parcelHelpers.export(exports, "FaJira", ()=>FaJira);
parcelHelpers.export(exports, "FaJoget", ()=>FaJoget);
parcelHelpers.export(exports, "FaJoomla", ()=>FaJoomla);
parcelHelpers.export(exports, "FaJsSquare", ()=>FaJsSquare);
parcelHelpers.export(exports, "FaJs", ()=>FaJs);
parcelHelpers.export(exports, "FaJsfiddle", ()=>FaJsfiddle);
parcelHelpers.export(exports, "FaKaggle", ()=>FaKaggle);
parcelHelpers.export(exports, "FaKeybase", ()=>FaKeybase);
parcelHelpers.export(exports, "FaKeycdn", ()=>FaKeycdn);
parcelHelpers.export(exports, "FaKickstarterK", ()=>FaKickstarterK);
parcelHelpers.export(exports, "FaKickstarter", ()=>FaKickstarter);
parcelHelpers.export(exports, "FaKorvue", ()=>FaKorvue);
parcelHelpers.export(exports, "FaLaravel", ()=>FaLaravel);
parcelHelpers.export(exports, "FaLastfmSquare", ()=>FaLastfmSquare);
parcelHelpers.export(exports, "FaLastfm", ()=>FaLastfm);
parcelHelpers.export(exports, "FaLeanpub", ()=>FaLeanpub);
parcelHelpers.export(exports, "FaLess", ()=>FaLess);
parcelHelpers.export(exports, "FaLine", ()=>FaLine);
parcelHelpers.export(exports, "FaLinkedinIn", ()=>FaLinkedinIn);
parcelHelpers.export(exports, "FaLinkedin", ()=>FaLinkedin);
parcelHelpers.export(exports, "FaLinode", ()=>FaLinode);
parcelHelpers.export(exports, "FaLinux", ()=>FaLinux);
parcelHelpers.export(exports, "FaLyft", ()=>FaLyft);
parcelHelpers.export(exports, "FaMagento", ()=>FaMagento);
parcelHelpers.export(exports, "FaMailchimp", ()=>FaMailchimp);
parcelHelpers.export(exports, "FaMandalorian", ()=>FaMandalorian);
parcelHelpers.export(exports, "FaMarkdown", ()=>FaMarkdown);
parcelHelpers.export(exports, "FaMastodon", ()=>FaMastodon);
parcelHelpers.export(exports, "FaMaxcdn", ()=>FaMaxcdn);
parcelHelpers.export(exports, "FaMdb", ()=>FaMdb);
parcelHelpers.export(exports, "FaMedapps", ()=>FaMedapps);
parcelHelpers.export(exports, "FaMediumM", ()=>FaMediumM);
parcelHelpers.export(exports, "FaMedium", ()=>FaMedium);
parcelHelpers.export(exports, "FaMedrt", ()=>FaMedrt);
parcelHelpers.export(exports, "FaMeetup", ()=>FaMeetup);
parcelHelpers.export(exports, "FaMegaport", ()=>FaMegaport);
parcelHelpers.export(exports, "FaMendeley", ()=>FaMendeley);
parcelHelpers.export(exports, "FaMicroblog", ()=>FaMicroblog);
parcelHelpers.export(exports, "FaMicrosoft", ()=>FaMicrosoft);
parcelHelpers.export(exports, "FaMix", ()=>FaMix);
parcelHelpers.export(exports, "FaMixcloud", ()=>FaMixcloud);
parcelHelpers.export(exports, "FaMixer", ()=>FaMixer);
parcelHelpers.export(exports, "FaMizuni", ()=>FaMizuni);
parcelHelpers.export(exports, "FaModx", ()=>FaModx);
parcelHelpers.export(exports, "FaMonero", ()=>FaMonero);
parcelHelpers.export(exports, "FaNapster", ()=>FaNapster);
parcelHelpers.export(exports, "FaNeos", ()=>FaNeos);
parcelHelpers.export(exports, "FaNimblr", ()=>FaNimblr);
parcelHelpers.export(exports, "FaNodeJs", ()=>FaNodeJs);
parcelHelpers.export(exports, "FaNode", ()=>FaNode);
parcelHelpers.export(exports, "FaNpm", ()=>FaNpm);
parcelHelpers.export(exports, "FaNs8", ()=>FaNs8);
parcelHelpers.export(exports, "FaNutritionix", ()=>FaNutritionix);
parcelHelpers.export(exports, "FaOctopusDeploy", ()=>FaOctopusDeploy);
parcelHelpers.export(exports, "FaOdnoklassnikiSquare", ()=>FaOdnoklassnikiSquare);
parcelHelpers.export(exports, "FaOdnoklassniki", ()=>FaOdnoklassniki);
parcelHelpers.export(exports, "FaOldRepublic", ()=>FaOldRepublic);
parcelHelpers.export(exports, "FaOpencart", ()=>FaOpencart);
parcelHelpers.export(exports, "FaOpenid", ()=>FaOpenid);
parcelHelpers.export(exports, "FaOpera", ()=>FaOpera);
parcelHelpers.export(exports, "FaOptinMonster", ()=>FaOptinMonster);
parcelHelpers.export(exports, "FaOrcid", ()=>FaOrcid);
parcelHelpers.export(exports, "FaOsi", ()=>FaOsi);
parcelHelpers.export(exports, "FaPage4", ()=>FaPage4);
parcelHelpers.export(exports, "FaPagelines", ()=>FaPagelines);
parcelHelpers.export(exports, "FaPalfed", ()=>FaPalfed);
parcelHelpers.export(exports, "FaPatreon", ()=>FaPatreon);
parcelHelpers.export(exports, "FaPaypal", ()=>FaPaypal);
parcelHelpers.export(exports, "FaPennyArcade", ()=>FaPennyArcade);
parcelHelpers.export(exports, "FaPerbyte", ()=>FaPerbyte);
parcelHelpers.export(exports, "FaPeriscope", ()=>FaPeriscope);
parcelHelpers.export(exports, "FaPhabricator", ()=>FaPhabricator);
parcelHelpers.export(exports, "FaPhoenixFramework", ()=>FaPhoenixFramework);
parcelHelpers.export(exports, "FaPhoenixSquadron", ()=>FaPhoenixSquadron);
parcelHelpers.export(exports, "FaPhp", ()=>FaPhp);
parcelHelpers.export(exports, "FaPiedPiperAlt", ()=>FaPiedPiperAlt);
parcelHelpers.export(exports, "FaPiedPiperHat", ()=>FaPiedPiperHat);
parcelHelpers.export(exports, "FaPiedPiperPp", ()=>FaPiedPiperPp);
parcelHelpers.export(exports, "FaPiedPiperSquare", ()=>FaPiedPiperSquare);
parcelHelpers.export(exports, "FaPiedPiper", ()=>FaPiedPiper);
parcelHelpers.export(exports, "FaPinterestP", ()=>FaPinterestP);
parcelHelpers.export(exports, "FaPinterestSquare", ()=>FaPinterestSquare);
parcelHelpers.export(exports, "FaPinterest", ()=>FaPinterest);
parcelHelpers.export(exports, "FaPlaystation", ()=>FaPlaystation);
parcelHelpers.export(exports, "FaProductHunt", ()=>FaProductHunt);
parcelHelpers.export(exports, "FaPushed", ()=>FaPushed);
parcelHelpers.export(exports, "FaPython", ()=>FaPython);
parcelHelpers.export(exports, "FaQq", ()=>FaQq);
parcelHelpers.export(exports, "FaQuinscape", ()=>FaQuinscape);
parcelHelpers.export(exports, "FaQuora", ()=>FaQuora);
parcelHelpers.export(exports, "FaRProject", ()=>FaRProject);
parcelHelpers.export(exports, "FaRaspberryPi", ()=>FaRaspberryPi);
parcelHelpers.export(exports, "FaRavelry", ()=>FaRavelry);
parcelHelpers.export(exports, "FaReact", ()=>FaReact);
parcelHelpers.export(exports, "FaReacteurope", ()=>FaReacteurope);
parcelHelpers.export(exports, "FaReadme", ()=>FaReadme);
parcelHelpers.export(exports, "FaRebel", ()=>FaRebel);
parcelHelpers.export(exports, "FaRedRiver", ()=>FaRedRiver);
parcelHelpers.export(exports, "FaRedditAlien", ()=>FaRedditAlien);
parcelHelpers.export(exports, "FaRedditSquare", ()=>FaRedditSquare);
parcelHelpers.export(exports, "FaReddit", ()=>FaReddit);
parcelHelpers.export(exports, "FaRedhat", ()=>FaRedhat);
parcelHelpers.export(exports, "FaRenren", ()=>FaRenren);
parcelHelpers.export(exports, "FaReplyd", ()=>FaReplyd);
parcelHelpers.export(exports, "FaResearchgate", ()=>FaResearchgate);
parcelHelpers.export(exports, "FaResolving", ()=>FaResolving);
parcelHelpers.export(exports, "FaRev", ()=>FaRev);
parcelHelpers.export(exports, "FaRocketchat", ()=>FaRocketchat);
parcelHelpers.export(exports, "FaRockrms", ()=>FaRockrms);
parcelHelpers.export(exports, "FaRust", ()=>FaRust);
parcelHelpers.export(exports, "FaSafari", ()=>FaSafari);
parcelHelpers.export(exports, "FaSalesforce", ()=>FaSalesforce);
parcelHelpers.export(exports, "FaSass", ()=>FaSass);
parcelHelpers.export(exports, "FaSchlix", ()=>FaSchlix);
parcelHelpers.export(exports, "FaScribd", ()=>FaScribd);
parcelHelpers.export(exports, "FaSearchengin", ()=>FaSearchengin);
parcelHelpers.export(exports, "FaSellcast", ()=>FaSellcast);
parcelHelpers.export(exports, "FaSellsy", ()=>FaSellsy);
parcelHelpers.export(exports, "FaServicestack", ()=>FaServicestack);
parcelHelpers.export(exports, "FaShirtsinbulk", ()=>FaShirtsinbulk);
parcelHelpers.export(exports, "FaShopify", ()=>FaShopify);
parcelHelpers.export(exports, "FaShopware", ()=>FaShopware);
parcelHelpers.export(exports, "FaSimplybuilt", ()=>FaSimplybuilt);
parcelHelpers.export(exports, "FaSistrix", ()=>FaSistrix);
parcelHelpers.export(exports, "FaSith", ()=>FaSith);
parcelHelpers.export(exports, "FaSketch", ()=>FaSketch);
parcelHelpers.export(exports, "FaSkyatlas", ()=>FaSkyatlas);
parcelHelpers.export(exports, "FaSkype", ()=>FaSkype);
parcelHelpers.export(exports, "FaSlackHash", ()=>FaSlackHash);
parcelHelpers.export(exports, "FaSlack", ()=>FaSlack);
parcelHelpers.export(exports, "FaSlideshare", ()=>FaSlideshare);
parcelHelpers.export(exports, "FaSnapchatGhost", ()=>FaSnapchatGhost);
parcelHelpers.export(exports, "FaSnapchatSquare", ()=>FaSnapchatSquare);
parcelHelpers.export(exports, "FaSnapchat", ()=>FaSnapchat);
parcelHelpers.export(exports, "FaSoundcloud", ()=>FaSoundcloud);
parcelHelpers.export(exports, "FaSourcetree", ()=>FaSourcetree);
parcelHelpers.export(exports, "FaSpeakap", ()=>FaSpeakap);
parcelHelpers.export(exports, "FaSpeakerDeck", ()=>FaSpeakerDeck);
parcelHelpers.export(exports, "FaSpotify", ()=>FaSpotify);
parcelHelpers.export(exports, "FaSquarespace", ()=>FaSquarespace);
parcelHelpers.export(exports, "FaStackExchange", ()=>FaStackExchange);
parcelHelpers.export(exports, "FaStackOverflow", ()=>FaStackOverflow);
parcelHelpers.export(exports, "FaStackpath", ()=>FaStackpath);
parcelHelpers.export(exports, "FaStaylinked", ()=>FaStaylinked);
parcelHelpers.export(exports, "FaSteamSquare", ()=>FaSteamSquare);
parcelHelpers.export(exports, "FaSteamSymbol", ()=>FaSteamSymbol);
parcelHelpers.export(exports, "FaSteam", ()=>FaSteam);
parcelHelpers.export(exports, "FaStickerMule", ()=>FaStickerMule);
parcelHelpers.export(exports, "FaStrava", ()=>FaStrava);
parcelHelpers.export(exports, "FaStripeS", ()=>FaStripeS);
parcelHelpers.export(exports, "FaStripe", ()=>FaStripe);
parcelHelpers.export(exports, "FaStudiovinari", ()=>FaStudiovinari);
parcelHelpers.export(exports, "FaStumbleuponCircle", ()=>FaStumbleuponCircle);
parcelHelpers.export(exports, "FaStumbleupon", ()=>FaStumbleupon);
parcelHelpers.export(exports, "FaSuperpowers", ()=>FaSuperpowers);
parcelHelpers.export(exports, "FaSupple", ()=>FaSupple);
parcelHelpers.export(exports, "FaSuse", ()=>FaSuse);
parcelHelpers.export(exports, "FaSwift", ()=>FaSwift);
parcelHelpers.export(exports, "FaSymfony", ()=>FaSymfony);
parcelHelpers.export(exports, "FaTeamspeak", ()=>FaTeamspeak);
parcelHelpers.export(exports, "FaTelegramPlane", ()=>FaTelegramPlane);
parcelHelpers.export(exports, "FaTelegram", ()=>FaTelegram);
parcelHelpers.export(exports, "FaTencentWeibo", ()=>FaTencentWeibo);
parcelHelpers.export(exports, "FaTheRedYeti", ()=>FaTheRedYeti);
parcelHelpers.export(exports, "FaThemeco", ()=>FaThemeco);
parcelHelpers.export(exports, "FaThemeisle", ()=>FaThemeisle);
parcelHelpers.export(exports, "FaThinkPeaks", ()=>FaThinkPeaks);
parcelHelpers.export(exports, "FaTiktok", ()=>FaTiktok);
parcelHelpers.export(exports, "FaTradeFederation", ()=>FaTradeFederation);
parcelHelpers.export(exports, "FaTrello", ()=>FaTrello);
parcelHelpers.export(exports, "FaTripadvisor", ()=>FaTripadvisor);
parcelHelpers.export(exports, "FaTumblrSquare", ()=>FaTumblrSquare);
parcelHelpers.export(exports, "FaTumblr", ()=>FaTumblr);
parcelHelpers.export(exports, "FaTwitch", ()=>FaTwitch);
parcelHelpers.export(exports, "FaTwitterSquare", ()=>FaTwitterSquare);
parcelHelpers.export(exports, "FaTwitter", ()=>FaTwitter);
parcelHelpers.export(exports, "FaTypo3", ()=>FaTypo3);
parcelHelpers.export(exports, "FaUber", ()=>FaUber);
parcelHelpers.export(exports, "FaUbuntu", ()=>FaUbuntu);
parcelHelpers.export(exports, "FaUikit", ()=>FaUikit);
parcelHelpers.export(exports, "FaUmbraco", ()=>FaUmbraco);
parcelHelpers.export(exports, "FaUncharted", ()=>FaUncharted);
parcelHelpers.export(exports, "FaUniregistry", ()=>FaUniregistry);
parcelHelpers.export(exports, "FaUnity", ()=>FaUnity);
parcelHelpers.export(exports, "FaUnsplash", ()=>FaUnsplash);
parcelHelpers.export(exports, "FaUntappd", ()=>FaUntappd);
parcelHelpers.export(exports, "FaUps", ()=>FaUps);
parcelHelpers.export(exports, "FaUsb", ()=>FaUsb);
parcelHelpers.export(exports, "FaUsps", ()=>FaUsps);
parcelHelpers.export(exports, "FaUssunnah", ()=>FaUssunnah);
parcelHelpers.export(exports, "FaVaadin", ()=>FaVaadin);
parcelHelpers.export(exports, "FaViacoin", ()=>FaViacoin);
parcelHelpers.export(exports, "FaViadeoSquare", ()=>FaViadeoSquare);
parcelHelpers.export(exports, "FaViadeo", ()=>FaViadeo);
parcelHelpers.export(exports, "FaViber", ()=>FaViber);
parcelHelpers.export(exports, "FaVimeoSquare", ()=>FaVimeoSquare);
parcelHelpers.export(exports, "FaVimeoV", ()=>FaVimeoV);
parcelHelpers.export(exports, "FaVimeo", ()=>FaVimeo);
parcelHelpers.export(exports, "FaVine", ()=>FaVine);
parcelHelpers.export(exports, "FaVk", ()=>FaVk);
parcelHelpers.export(exports, "FaVnv", ()=>FaVnv);
parcelHelpers.export(exports, "FaVuejs", ()=>FaVuejs);
parcelHelpers.export(exports, "FaWatchmanMonitoring", ()=>FaWatchmanMonitoring);
parcelHelpers.export(exports, "FaWaze", ()=>FaWaze);
parcelHelpers.export(exports, "FaWeebly", ()=>FaWeebly);
parcelHelpers.export(exports, "FaWeibo", ()=>FaWeibo);
parcelHelpers.export(exports, "FaWeixin", ()=>FaWeixin);
parcelHelpers.export(exports, "FaWhatsappSquare", ()=>FaWhatsappSquare);
parcelHelpers.export(exports, "FaWhatsapp", ()=>FaWhatsapp);
parcelHelpers.export(exports, "FaWhmcs", ()=>FaWhmcs);
parcelHelpers.export(exports, "FaWikipediaW", ()=>FaWikipediaW);
parcelHelpers.export(exports, "FaWindows", ()=>FaWindows);
parcelHelpers.export(exports, "FaWix", ()=>FaWix);
parcelHelpers.export(exports, "FaWizardsOfTheCoast", ()=>FaWizardsOfTheCoast);
parcelHelpers.export(exports, "FaWodu", ()=>FaWodu);
parcelHelpers.export(exports, "FaWolfPackBattalion", ()=>FaWolfPackBattalion);
parcelHelpers.export(exports, "FaWordpressSimple", ()=>FaWordpressSimple);
parcelHelpers.export(exports, "FaWordpress", ()=>FaWordpress);
parcelHelpers.export(exports, "FaWpbeginner", ()=>FaWpbeginner);
parcelHelpers.export(exports, "FaWpexplorer", ()=>FaWpexplorer);
parcelHelpers.export(exports, "FaWpforms", ()=>FaWpforms);
parcelHelpers.export(exports, "FaWpressr", ()=>FaWpressr);
parcelHelpers.export(exports, "FaXbox", ()=>FaXbox);
parcelHelpers.export(exports, "FaXingSquare", ()=>FaXingSquare);
parcelHelpers.export(exports, "FaXing", ()=>FaXing);
parcelHelpers.export(exports, "FaYCombinator", ()=>FaYCombinator);
parcelHelpers.export(exports, "FaYahoo", ()=>FaYahoo);
parcelHelpers.export(exports, "FaYammer", ()=>FaYammer);
parcelHelpers.export(exports, "FaYandexInternational", ()=>FaYandexInternational);
parcelHelpers.export(exports, "FaYandex", ()=>FaYandex);
parcelHelpers.export(exports, "FaYarn", ()=>FaYarn);
parcelHelpers.export(exports, "FaYelp", ()=>FaYelp);
parcelHelpers.export(exports, "FaYoast", ()=>FaYoast);
parcelHelpers.export(exports, "FaYoutubeSquare", ()=>FaYoutubeSquare);
parcelHelpers.export(exports, "FaYoutube", ()=>FaYoutube);
parcelHelpers.export(exports, "FaZhihu", ()=>FaZhihu);
parcelHelpers.export(exports, "FaAd", ()=>FaAd);
parcelHelpers.export(exports, "FaAddressBook", ()=>FaAddressBook);
parcelHelpers.export(exports, "FaAddressCard", ()=>FaAddressCard);
parcelHelpers.export(exports, "FaAdjust", ()=>FaAdjust);
parcelHelpers.export(exports, "FaAirFreshener", ()=>FaAirFreshener);
parcelHelpers.export(exports, "FaAlignCenter", ()=>FaAlignCenter);
parcelHelpers.export(exports, "FaAlignJustify", ()=>FaAlignJustify);
parcelHelpers.export(exports, "FaAlignLeft", ()=>FaAlignLeft);
parcelHelpers.export(exports, "FaAlignRight", ()=>FaAlignRight);
parcelHelpers.export(exports, "FaAllergies", ()=>FaAllergies);
parcelHelpers.export(exports, "FaAmbulance", ()=>FaAmbulance);
parcelHelpers.export(exports, "FaAmericanSignLanguageInterpreting", ()=>FaAmericanSignLanguageInterpreting);
parcelHelpers.export(exports, "FaAnchor", ()=>FaAnchor);
parcelHelpers.export(exports, "FaAngleDoubleDown", ()=>FaAngleDoubleDown);
parcelHelpers.export(exports, "FaAngleDoubleLeft", ()=>FaAngleDoubleLeft);
parcelHelpers.export(exports, "FaAngleDoubleRight", ()=>FaAngleDoubleRight);
parcelHelpers.export(exports, "FaAngleDoubleUp", ()=>FaAngleDoubleUp);
parcelHelpers.export(exports, "FaAngleDown", ()=>FaAngleDown);
parcelHelpers.export(exports, "FaAngleLeft", ()=>FaAngleLeft);
parcelHelpers.export(exports, "FaAngleRight", ()=>FaAngleRight);
parcelHelpers.export(exports, "FaAngleUp", ()=>FaAngleUp);
parcelHelpers.export(exports, "FaAngry", ()=>FaAngry);
parcelHelpers.export(exports, "FaAnkh", ()=>FaAnkh);
parcelHelpers.export(exports, "FaAppleAlt", ()=>FaAppleAlt);
parcelHelpers.export(exports, "FaArchive", ()=>FaArchive);
parcelHelpers.export(exports, "FaArchway", ()=>FaArchway);
parcelHelpers.export(exports, "FaArrowAltCircleDown", ()=>FaArrowAltCircleDown);
parcelHelpers.export(exports, "FaArrowAltCircleLeft", ()=>FaArrowAltCircleLeft);
parcelHelpers.export(exports, "FaArrowAltCircleRight", ()=>FaArrowAltCircleRight);
parcelHelpers.export(exports, "FaArrowAltCircleUp", ()=>FaArrowAltCircleUp);
parcelHelpers.export(exports, "FaArrowCircleDown", ()=>FaArrowCircleDown);
parcelHelpers.export(exports, "FaArrowCircleLeft", ()=>FaArrowCircleLeft);
parcelHelpers.export(exports, "FaArrowCircleRight", ()=>FaArrowCircleRight);
parcelHelpers.export(exports, "FaArrowCircleUp", ()=>FaArrowCircleUp);
parcelHelpers.export(exports, "FaArrowDown", ()=>FaArrowDown);
parcelHelpers.export(exports, "FaArrowLeft", ()=>FaArrowLeft);
parcelHelpers.export(exports, "FaArrowRight", ()=>FaArrowRight);
parcelHelpers.export(exports, "FaArrowUp", ()=>FaArrowUp);
parcelHelpers.export(exports, "FaArrowsAltH", ()=>FaArrowsAltH);
parcelHelpers.export(exports, "FaArrowsAltV", ()=>FaArrowsAltV);
parcelHelpers.export(exports, "FaArrowsAlt", ()=>FaArrowsAlt);
parcelHelpers.export(exports, "FaAssistiveListeningSystems", ()=>FaAssistiveListeningSystems);
parcelHelpers.export(exports, "FaAsterisk", ()=>FaAsterisk);
parcelHelpers.export(exports, "FaAt", ()=>FaAt);
parcelHelpers.export(exports, "FaAtlas", ()=>FaAtlas);
parcelHelpers.export(exports, "FaAtom", ()=>FaAtom);
parcelHelpers.export(exports, "FaAudioDescription", ()=>FaAudioDescription);
parcelHelpers.export(exports, "FaAward", ()=>FaAward);
parcelHelpers.export(exports, "FaBabyCarriage", ()=>FaBabyCarriage);
parcelHelpers.export(exports, "FaBaby", ()=>FaBaby);
parcelHelpers.export(exports, "FaBackspace", ()=>FaBackspace);
parcelHelpers.export(exports, "FaBackward", ()=>FaBackward);
parcelHelpers.export(exports, "FaBacon", ()=>FaBacon);
parcelHelpers.export(exports, "FaBacteria", ()=>FaBacteria);
parcelHelpers.export(exports, "FaBacterium", ()=>FaBacterium);
parcelHelpers.export(exports, "FaBahai", ()=>FaBahai);
parcelHelpers.export(exports, "FaBalanceScaleLeft", ()=>FaBalanceScaleLeft);
parcelHelpers.export(exports, "FaBalanceScaleRight", ()=>FaBalanceScaleRight);
parcelHelpers.export(exports, "FaBalanceScale", ()=>FaBalanceScale);
parcelHelpers.export(exports, "FaBan", ()=>FaBan);
parcelHelpers.export(exports, "FaBandAid", ()=>FaBandAid);
parcelHelpers.export(exports, "FaBarcode", ()=>FaBarcode);
parcelHelpers.export(exports, "FaBars", ()=>FaBars);
parcelHelpers.export(exports, "FaBaseballBall", ()=>FaBaseballBall);
parcelHelpers.export(exports, "FaBasketballBall", ()=>FaBasketballBall);
parcelHelpers.export(exports, "FaBath", ()=>FaBath);
parcelHelpers.export(exports, "FaBatteryEmpty", ()=>FaBatteryEmpty);
parcelHelpers.export(exports, "FaBatteryFull", ()=>FaBatteryFull);
parcelHelpers.export(exports, "FaBatteryHalf", ()=>FaBatteryHalf);
parcelHelpers.export(exports, "FaBatteryQuarter", ()=>FaBatteryQuarter);
parcelHelpers.export(exports, "FaBatteryThreeQuarters", ()=>FaBatteryThreeQuarters);
parcelHelpers.export(exports, "FaBed", ()=>FaBed);
parcelHelpers.export(exports, "FaBeer", ()=>FaBeer);
parcelHelpers.export(exports, "FaBellSlash", ()=>FaBellSlash);
parcelHelpers.export(exports, "FaBell", ()=>FaBell);
parcelHelpers.export(exports, "FaBezierCurve", ()=>FaBezierCurve);
parcelHelpers.export(exports, "FaBible", ()=>FaBible);
parcelHelpers.export(exports, "FaBicycle", ()=>FaBicycle);
parcelHelpers.export(exports, "FaBiking", ()=>FaBiking);
parcelHelpers.export(exports, "FaBinoculars", ()=>FaBinoculars);
parcelHelpers.export(exports, "FaBiohazard", ()=>FaBiohazard);
parcelHelpers.export(exports, "FaBirthdayCake", ()=>FaBirthdayCake);
parcelHelpers.export(exports, "FaBlenderPhone", ()=>FaBlenderPhone);
parcelHelpers.export(exports, "FaBlender", ()=>FaBlender);
parcelHelpers.export(exports, "FaBlind", ()=>FaBlind);
parcelHelpers.export(exports, "FaBlog", ()=>FaBlog);
parcelHelpers.export(exports, "FaBold", ()=>FaBold);
parcelHelpers.export(exports, "FaBolt", ()=>FaBolt);
parcelHelpers.export(exports, "FaBomb", ()=>FaBomb);
parcelHelpers.export(exports, "FaBone", ()=>FaBone);
parcelHelpers.export(exports, "FaBong", ()=>FaBong);
parcelHelpers.export(exports, "FaBookDead", ()=>FaBookDead);
parcelHelpers.export(exports, "FaBookMedical", ()=>FaBookMedical);
parcelHelpers.export(exports, "FaBookOpen", ()=>FaBookOpen);
parcelHelpers.export(exports, "FaBookReader", ()=>FaBookReader);
parcelHelpers.export(exports, "FaBook", ()=>FaBook);
parcelHelpers.export(exports, "FaBookmark", ()=>FaBookmark);
parcelHelpers.export(exports, "FaBorderAll", ()=>FaBorderAll);
parcelHelpers.export(exports, "FaBorderNone", ()=>FaBorderNone);
parcelHelpers.export(exports, "FaBorderStyle", ()=>FaBorderStyle);
parcelHelpers.export(exports, "FaBowlingBall", ()=>FaBowlingBall);
parcelHelpers.export(exports, "FaBoxOpen", ()=>FaBoxOpen);
parcelHelpers.export(exports, "FaBoxTissue", ()=>FaBoxTissue);
parcelHelpers.export(exports, "FaBox", ()=>FaBox);
parcelHelpers.export(exports, "FaBoxes", ()=>FaBoxes);
parcelHelpers.export(exports, "FaBraille", ()=>FaBraille);
parcelHelpers.export(exports, "FaBrain", ()=>FaBrain);
parcelHelpers.export(exports, "FaBreadSlice", ()=>FaBreadSlice);
parcelHelpers.export(exports, "FaBriefcaseMedical", ()=>FaBriefcaseMedical);
parcelHelpers.export(exports, "FaBriefcase", ()=>FaBriefcase);
parcelHelpers.export(exports, "FaBroadcastTower", ()=>FaBroadcastTower);
parcelHelpers.export(exports, "FaBroom", ()=>FaBroom);
parcelHelpers.export(exports, "FaBrush", ()=>FaBrush);
parcelHelpers.export(exports, "FaBug", ()=>FaBug);
parcelHelpers.export(exports, "FaBuilding", ()=>FaBuilding);
parcelHelpers.export(exports, "FaBullhorn", ()=>FaBullhorn);
parcelHelpers.export(exports, "FaBullseye", ()=>FaBullseye);
parcelHelpers.export(exports, "FaBurn", ()=>FaBurn);
parcelHelpers.export(exports, "FaBusAlt", ()=>FaBusAlt);
parcelHelpers.export(exports, "FaBus", ()=>FaBus);
parcelHelpers.export(exports, "FaBusinessTime", ()=>FaBusinessTime);
parcelHelpers.export(exports, "FaCalculator", ()=>FaCalculator);
parcelHelpers.export(exports, "FaCalendarAlt", ()=>FaCalendarAlt);
parcelHelpers.export(exports, "FaCalendarCheck", ()=>FaCalendarCheck);
parcelHelpers.export(exports, "FaCalendarDay", ()=>FaCalendarDay);
parcelHelpers.export(exports, "FaCalendarMinus", ()=>FaCalendarMinus);
parcelHelpers.export(exports, "FaCalendarPlus", ()=>FaCalendarPlus);
parcelHelpers.export(exports, "FaCalendarTimes", ()=>FaCalendarTimes);
parcelHelpers.export(exports, "FaCalendarWeek", ()=>FaCalendarWeek);
parcelHelpers.export(exports, "FaCalendar", ()=>FaCalendar);
parcelHelpers.export(exports, "FaCameraRetro", ()=>FaCameraRetro);
parcelHelpers.export(exports, "FaCamera", ()=>FaCamera);
parcelHelpers.export(exports, "FaCampground", ()=>FaCampground);
parcelHelpers.export(exports, "FaCandyCane", ()=>FaCandyCane);
parcelHelpers.export(exports, "FaCannabis", ()=>FaCannabis);
parcelHelpers.export(exports, "FaCapsules", ()=>FaCapsules);
parcelHelpers.export(exports, "FaCarAlt", ()=>FaCarAlt);
parcelHelpers.export(exports, "FaCarBattery", ()=>FaCarBattery);
parcelHelpers.export(exports, "FaCarCrash", ()=>FaCarCrash);
parcelHelpers.export(exports, "FaCarSide", ()=>FaCarSide);
parcelHelpers.export(exports, "FaCar", ()=>FaCar);
parcelHelpers.export(exports, "FaCaravan", ()=>FaCaravan);
parcelHelpers.export(exports, "FaCaretDown", ()=>FaCaretDown);
parcelHelpers.export(exports, "FaCaretLeft", ()=>FaCaretLeft);
parcelHelpers.export(exports, "FaCaretRight", ()=>FaCaretRight);
parcelHelpers.export(exports, "FaCaretSquareDown", ()=>FaCaretSquareDown);
parcelHelpers.export(exports, "FaCaretSquareLeft", ()=>FaCaretSquareLeft);
parcelHelpers.export(exports, "FaCaretSquareRight", ()=>FaCaretSquareRight);
parcelHelpers.export(exports, "FaCaretSquareUp", ()=>FaCaretSquareUp);
parcelHelpers.export(exports, "FaCaretUp", ()=>FaCaretUp);
parcelHelpers.export(exports, "FaCarrot", ()=>FaCarrot);
parcelHelpers.export(exports, "FaCartArrowDown", ()=>FaCartArrowDown);
parcelHelpers.export(exports, "FaCartPlus", ()=>FaCartPlus);
parcelHelpers.export(exports, "FaCashRegister", ()=>FaCashRegister);
parcelHelpers.export(exports, "FaCat", ()=>FaCat);
parcelHelpers.export(exports, "FaCertificate", ()=>FaCertificate);
parcelHelpers.export(exports, "FaChair", ()=>FaChair);
parcelHelpers.export(exports, "FaChalkboardTeacher", ()=>FaChalkboardTeacher);
parcelHelpers.export(exports, "FaChalkboard", ()=>FaChalkboard);
parcelHelpers.export(exports, "FaChargingStation", ()=>FaChargingStation);
parcelHelpers.export(exports, "FaChartArea", ()=>FaChartArea);
parcelHelpers.export(exports, "FaChartBar", ()=>FaChartBar);
parcelHelpers.export(exports, "FaChartLine", ()=>FaChartLine);
parcelHelpers.export(exports, "FaChartPie", ()=>FaChartPie);
parcelHelpers.export(exports, "FaCheckCircle", ()=>FaCheckCircle);
parcelHelpers.export(exports, "FaCheckDouble", ()=>FaCheckDouble);
parcelHelpers.export(exports, "FaCheckSquare", ()=>FaCheckSquare);
parcelHelpers.export(exports, "FaCheck", ()=>FaCheck);
parcelHelpers.export(exports, "FaCheese", ()=>FaCheese);
parcelHelpers.export(exports, "FaChessBishop", ()=>FaChessBishop);
parcelHelpers.export(exports, "FaChessBoard", ()=>FaChessBoard);
parcelHelpers.export(exports, "FaChessKing", ()=>FaChessKing);
parcelHelpers.export(exports, "FaChessKnight", ()=>FaChessKnight);
parcelHelpers.export(exports, "FaChessPawn", ()=>FaChessPawn);
parcelHelpers.export(exports, "FaChessQueen", ()=>FaChessQueen);
parcelHelpers.export(exports, "FaChessRook", ()=>FaChessRook);
parcelHelpers.export(exports, "FaChess", ()=>FaChess);
parcelHelpers.export(exports, "FaChevronCircleDown", ()=>FaChevronCircleDown);
parcelHelpers.export(exports, "FaChevronCircleLeft", ()=>FaChevronCircleLeft);
parcelHelpers.export(exports, "FaChevronCircleRight", ()=>FaChevronCircleRight);
parcelHelpers.export(exports, "FaChevronCircleUp", ()=>FaChevronCircleUp);
parcelHelpers.export(exports, "FaChevronDown", ()=>FaChevronDown);
parcelHelpers.export(exports, "FaChevronLeft", ()=>FaChevronLeft);
parcelHelpers.export(exports, "FaChevronRight", ()=>FaChevronRight);
parcelHelpers.export(exports, "FaChevronUp", ()=>FaChevronUp);
parcelHelpers.export(exports, "FaChild", ()=>FaChild);
parcelHelpers.export(exports, "FaChurch", ()=>FaChurch);
parcelHelpers.export(exports, "FaCircleNotch", ()=>FaCircleNotch);
parcelHelpers.export(exports, "FaCircle", ()=>FaCircle);
parcelHelpers.export(exports, "FaCity", ()=>FaCity);
parcelHelpers.export(exports, "FaClinicMedical", ()=>FaClinicMedical);
parcelHelpers.export(exports, "FaClipboardCheck", ()=>FaClipboardCheck);
parcelHelpers.export(exports, "FaClipboardList", ()=>FaClipboardList);
parcelHelpers.export(exports, "FaClipboard", ()=>FaClipboard);
parcelHelpers.export(exports, "FaClock", ()=>FaClock);
parcelHelpers.export(exports, "FaClone", ()=>FaClone);
parcelHelpers.export(exports, "FaClosedCaptioning", ()=>FaClosedCaptioning);
parcelHelpers.export(exports, "FaCloudDownloadAlt", ()=>FaCloudDownloadAlt);
parcelHelpers.export(exports, "FaCloudMeatball", ()=>FaCloudMeatball);
parcelHelpers.export(exports, "FaCloudMoonRain", ()=>FaCloudMoonRain);
parcelHelpers.export(exports, "FaCloudMoon", ()=>FaCloudMoon);
parcelHelpers.export(exports, "FaCloudRain", ()=>FaCloudRain);
parcelHelpers.export(exports, "FaCloudShowersHeavy", ()=>FaCloudShowersHeavy);
parcelHelpers.export(exports, "FaCloudSunRain", ()=>FaCloudSunRain);
parcelHelpers.export(exports, "FaCloudSun", ()=>FaCloudSun);
parcelHelpers.export(exports, "FaCloudUploadAlt", ()=>FaCloudUploadAlt);
parcelHelpers.export(exports, "FaCloud", ()=>FaCloud);
parcelHelpers.export(exports, "FaCocktail", ()=>FaCocktail);
parcelHelpers.export(exports, "FaCodeBranch", ()=>FaCodeBranch);
parcelHelpers.export(exports, "FaCode", ()=>FaCode);
parcelHelpers.export(exports, "FaCoffee", ()=>FaCoffee);
parcelHelpers.export(exports, "FaCog", ()=>FaCog);
parcelHelpers.export(exports, "FaCogs", ()=>FaCogs);
parcelHelpers.export(exports, "FaCoins", ()=>FaCoins);
parcelHelpers.export(exports, "FaColumns", ()=>FaColumns);
parcelHelpers.export(exports, "FaCommentAlt", ()=>FaCommentAlt);
parcelHelpers.export(exports, "FaCommentDollar", ()=>FaCommentDollar);
parcelHelpers.export(exports, "FaCommentDots", ()=>FaCommentDots);
parcelHelpers.export(exports, "FaCommentMedical", ()=>FaCommentMedical);
parcelHelpers.export(exports, "FaCommentSlash", ()=>FaCommentSlash);
parcelHelpers.export(exports, "FaComment", ()=>FaComment);
parcelHelpers.export(exports, "FaCommentsDollar", ()=>FaCommentsDollar);
parcelHelpers.export(exports, "FaComments", ()=>FaComments);
parcelHelpers.export(exports, "FaCompactDisc", ()=>FaCompactDisc);
parcelHelpers.export(exports, "FaCompass", ()=>FaCompass);
parcelHelpers.export(exports, "FaCompressAlt", ()=>FaCompressAlt);
parcelHelpers.export(exports, "FaCompressArrowsAlt", ()=>FaCompressArrowsAlt);
parcelHelpers.export(exports, "FaCompress", ()=>FaCompress);
parcelHelpers.export(exports, "FaConciergeBell", ()=>FaConciergeBell);
parcelHelpers.export(exports, "FaCookieBite", ()=>FaCookieBite);
parcelHelpers.export(exports, "FaCookie", ()=>FaCookie);
parcelHelpers.export(exports, "FaCopy", ()=>FaCopy);
parcelHelpers.export(exports, "FaCopyright", ()=>FaCopyright);
parcelHelpers.export(exports, "FaCouch", ()=>FaCouch);
parcelHelpers.export(exports, "FaCreditCard", ()=>FaCreditCard);
parcelHelpers.export(exports, "FaCropAlt", ()=>FaCropAlt);
parcelHelpers.export(exports, "FaCrop", ()=>FaCrop);
parcelHelpers.export(exports, "FaCross", ()=>FaCross);
parcelHelpers.export(exports, "FaCrosshairs", ()=>FaCrosshairs);
parcelHelpers.export(exports, "FaCrow", ()=>FaCrow);
parcelHelpers.export(exports, "FaCrown", ()=>FaCrown);
parcelHelpers.export(exports, "FaCrutch", ()=>FaCrutch);
parcelHelpers.export(exports, "FaCube", ()=>FaCube);
parcelHelpers.export(exports, "FaCubes", ()=>FaCubes);
parcelHelpers.export(exports, "FaCut", ()=>FaCut);
parcelHelpers.export(exports, "FaDatabase", ()=>FaDatabase);
parcelHelpers.export(exports, "FaDeaf", ()=>FaDeaf);
parcelHelpers.export(exports, "FaDemocrat", ()=>FaDemocrat);
parcelHelpers.export(exports, "FaDesktop", ()=>FaDesktop);
parcelHelpers.export(exports, "FaDharmachakra", ()=>FaDharmachakra);
parcelHelpers.export(exports, "FaDiagnoses", ()=>FaDiagnoses);
parcelHelpers.export(exports, "FaDiceD20", ()=>FaDiceD20);
parcelHelpers.export(exports, "FaDiceD6", ()=>FaDiceD6);
parcelHelpers.export(exports, "FaDiceFive", ()=>FaDiceFive);
parcelHelpers.export(exports, "FaDiceFour", ()=>FaDiceFour);
parcelHelpers.export(exports, "FaDiceOne", ()=>FaDiceOne);
parcelHelpers.export(exports, "FaDiceSix", ()=>FaDiceSix);
parcelHelpers.export(exports, "FaDiceThree", ()=>FaDiceThree);
parcelHelpers.export(exports, "FaDiceTwo", ()=>FaDiceTwo);
parcelHelpers.export(exports, "FaDice", ()=>FaDice);
parcelHelpers.export(exports, "FaDigitalTachograph", ()=>FaDigitalTachograph);
parcelHelpers.export(exports, "FaDirections", ()=>FaDirections);
parcelHelpers.export(exports, "FaDisease", ()=>FaDisease);
parcelHelpers.export(exports, "FaDivide", ()=>FaDivide);
parcelHelpers.export(exports, "FaDizzy", ()=>FaDizzy);
parcelHelpers.export(exports, "FaDna", ()=>FaDna);
parcelHelpers.export(exports, "FaDog", ()=>FaDog);
parcelHelpers.export(exports, "FaDollarSign", ()=>FaDollarSign);
parcelHelpers.export(exports, "FaDollyFlatbed", ()=>FaDollyFlatbed);
parcelHelpers.export(exports, "FaDolly", ()=>FaDolly);
parcelHelpers.export(exports, "FaDonate", ()=>FaDonate);
parcelHelpers.export(exports, "FaDoorClosed", ()=>FaDoorClosed);
parcelHelpers.export(exports, "FaDoorOpen", ()=>FaDoorOpen);
parcelHelpers.export(exports, "FaDotCircle", ()=>FaDotCircle);
parcelHelpers.export(exports, "FaDove", ()=>FaDove);
parcelHelpers.export(exports, "FaDownload", ()=>FaDownload);
parcelHelpers.export(exports, "FaDraftingCompass", ()=>FaDraftingCompass);
parcelHelpers.export(exports, "FaDragon", ()=>FaDragon);
parcelHelpers.export(exports, "FaDrawPolygon", ()=>FaDrawPolygon);
parcelHelpers.export(exports, "FaDrumSteelpan", ()=>FaDrumSteelpan);
parcelHelpers.export(exports, "FaDrum", ()=>FaDrum);
parcelHelpers.export(exports, "FaDrumstickBite", ()=>FaDrumstickBite);
parcelHelpers.export(exports, "FaDumbbell", ()=>FaDumbbell);
parcelHelpers.export(exports, "FaDumpsterFire", ()=>FaDumpsterFire);
parcelHelpers.export(exports, "FaDumpster", ()=>FaDumpster);
parcelHelpers.export(exports, "FaDungeon", ()=>FaDungeon);
parcelHelpers.export(exports, "FaEdit", ()=>FaEdit);
parcelHelpers.export(exports, "FaEgg", ()=>FaEgg);
parcelHelpers.export(exports, "FaEject", ()=>FaEject);
parcelHelpers.export(exports, "FaEllipsisH", ()=>FaEllipsisH);
parcelHelpers.export(exports, "FaEllipsisV", ()=>FaEllipsisV);
parcelHelpers.export(exports, "FaEnvelopeOpenText", ()=>FaEnvelopeOpenText);
parcelHelpers.export(exports, "FaEnvelopeOpen", ()=>FaEnvelopeOpen);
parcelHelpers.export(exports, "FaEnvelopeSquare", ()=>FaEnvelopeSquare);
parcelHelpers.export(exports, "FaEnvelope", ()=>FaEnvelope);
parcelHelpers.export(exports, "FaEquals", ()=>FaEquals);
parcelHelpers.export(exports, "FaEraser", ()=>FaEraser);
parcelHelpers.export(exports, "FaEthernet", ()=>FaEthernet);
parcelHelpers.export(exports, "FaEuroSign", ()=>FaEuroSign);
parcelHelpers.export(exports, "FaExchangeAlt", ()=>FaExchangeAlt);
parcelHelpers.export(exports, "FaExclamationCircle", ()=>FaExclamationCircle);
parcelHelpers.export(exports, "FaExclamationTriangle", ()=>FaExclamationTriangle);
parcelHelpers.export(exports, "FaExclamation", ()=>FaExclamation);
parcelHelpers.export(exports, "FaExpandAlt", ()=>FaExpandAlt);
parcelHelpers.export(exports, "FaExpandArrowsAlt", ()=>FaExpandArrowsAlt);
parcelHelpers.export(exports, "FaExpand", ()=>FaExpand);
parcelHelpers.export(exports, "FaExternalLinkAlt", ()=>FaExternalLinkAlt);
parcelHelpers.export(exports, "FaExternalLinkSquareAlt", ()=>FaExternalLinkSquareAlt);
parcelHelpers.export(exports, "FaEyeDropper", ()=>FaEyeDropper);
parcelHelpers.export(exports, "FaEyeSlash", ()=>FaEyeSlash);
parcelHelpers.export(exports, "FaEye", ()=>FaEye);
parcelHelpers.export(exports, "FaFan", ()=>FaFan);
parcelHelpers.export(exports, "FaFastBackward", ()=>FaFastBackward);
parcelHelpers.export(exports, "FaFastForward", ()=>FaFastForward);
parcelHelpers.export(exports, "FaFaucet", ()=>FaFaucet);
parcelHelpers.export(exports, "FaFax", ()=>FaFax);
parcelHelpers.export(exports, "FaFeatherAlt", ()=>FaFeatherAlt);
parcelHelpers.export(exports, "FaFeather", ()=>FaFeather);
parcelHelpers.export(exports, "FaFemale", ()=>FaFemale);
parcelHelpers.export(exports, "FaFighterJet", ()=>FaFighterJet);
parcelHelpers.export(exports, "FaFileAlt", ()=>FaFileAlt);
parcelHelpers.export(exports, "FaFileArchive", ()=>FaFileArchive);
parcelHelpers.export(exports, "FaFileAudio", ()=>FaFileAudio);
parcelHelpers.export(exports, "FaFileCode", ()=>FaFileCode);
parcelHelpers.export(exports, "FaFileContract", ()=>FaFileContract);
parcelHelpers.export(exports, "FaFileCsv", ()=>FaFileCsv);
parcelHelpers.export(exports, "FaFileDownload", ()=>FaFileDownload);
parcelHelpers.export(exports, "FaFileExcel", ()=>FaFileExcel);
parcelHelpers.export(exports, "FaFileExport", ()=>FaFileExport);
parcelHelpers.export(exports, "FaFileImage", ()=>FaFileImage);
parcelHelpers.export(exports, "FaFileImport", ()=>FaFileImport);
parcelHelpers.export(exports, "FaFileInvoiceDollar", ()=>FaFileInvoiceDollar);
parcelHelpers.export(exports, "FaFileInvoice", ()=>FaFileInvoice);
parcelHelpers.export(exports, "FaFileMedicalAlt", ()=>FaFileMedicalAlt);
parcelHelpers.export(exports, "FaFileMedical", ()=>FaFileMedical);
parcelHelpers.export(exports, "FaFilePdf", ()=>FaFilePdf);
parcelHelpers.export(exports, "FaFilePowerpoint", ()=>FaFilePowerpoint);
parcelHelpers.export(exports, "FaFilePrescription", ()=>FaFilePrescription);
parcelHelpers.export(exports, "FaFileSignature", ()=>FaFileSignature);
parcelHelpers.export(exports, "FaFileUpload", ()=>FaFileUpload);
parcelHelpers.export(exports, "FaFileVideo", ()=>FaFileVideo);
parcelHelpers.export(exports, "FaFileWord", ()=>FaFileWord);
parcelHelpers.export(exports, "FaFile", ()=>FaFile);
parcelHelpers.export(exports, "FaFillDrip", ()=>FaFillDrip);
parcelHelpers.export(exports, "FaFill", ()=>FaFill);
parcelHelpers.export(exports, "FaFilm", ()=>FaFilm);
parcelHelpers.export(exports, "FaFilter", ()=>FaFilter);
parcelHelpers.export(exports, "FaFingerprint", ()=>FaFingerprint);
parcelHelpers.export(exports, "FaFireAlt", ()=>FaFireAlt);
parcelHelpers.export(exports, "FaFireExtinguisher", ()=>FaFireExtinguisher);
parcelHelpers.export(exports, "FaFire", ()=>FaFire);
parcelHelpers.export(exports, "FaFirstAid", ()=>FaFirstAid);
parcelHelpers.export(exports, "FaFish", ()=>FaFish);
parcelHelpers.export(exports, "FaFistRaised", ()=>FaFistRaised);
parcelHelpers.export(exports, "FaFlagCheckered", ()=>FaFlagCheckered);
parcelHelpers.export(exports, "FaFlagUsa", ()=>FaFlagUsa);
parcelHelpers.export(exports, "FaFlag", ()=>FaFlag);
parcelHelpers.export(exports, "FaFlask", ()=>FaFlask);
parcelHelpers.export(exports, "FaFlushed", ()=>FaFlushed);
parcelHelpers.export(exports, "FaFolderMinus", ()=>FaFolderMinus);
parcelHelpers.export(exports, "FaFolderOpen", ()=>FaFolderOpen);
parcelHelpers.export(exports, "FaFolderPlus", ()=>FaFolderPlus);
parcelHelpers.export(exports, "FaFolder", ()=>FaFolder);
parcelHelpers.export(exports, "FaFont", ()=>FaFont);
parcelHelpers.export(exports, "FaFootballBall", ()=>FaFootballBall);
parcelHelpers.export(exports, "FaForward", ()=>FaForward);
parcelHelpers.export(exports, "FaFrog", ()=>FaFrog);
parcelHelpers.export(exports, "FaFrownOpen", ()=>FaFrownOpen);
parcelHelpers.export(exports, "FaFrown", ()=>FaFrown);
parcelHelpers.export(exports, "FaFunnelDollar", ()=>FaFunnelDollar);
parcelHelpers.export(exports, "FaFutbol", ()=>FaFutbol);
parcelHelpers.export(exports, "FaGamepad", ()=>FaGamepad);
parcelHelpers.export(exports, "FaGasPump", ()=>FaGasPump);
parcelHelpers.export(exports, "FaGavel", ()=>FaGavel);
parcelHelpers.export(exports, "FaGem", ()=>FaGem);
parcelHelpers.export(exports, "FaGenderless", ()=>FaGenderless);
parcelHelpers.export(exports, "FaGhost", ()=>FaGhost);
parcelHelpers.export(exports, "FaGift", ()=>FaGift);
parcelHelpers.export(exports, "FaGifts", ()=>FaGifts);
parcelHelpers.export(exports, "FaGlassCheers", ()=>FaGlassCheers);
parcelHelpers.export(exports, "FaGlassMartiniAlt", ()=>FaGlassMartiniAlt);
parcelHelpers.export(exports, "FaGlassMartini", ()=>FaGlassMartini);
parcelHelpers.export(exports, "FaGlassWhiskey", ()=>FaGlassWhiskey);
parcelHelpers.export(exports, "FaGlasses", ()=>FaGlasses);
parcelHelpers.export(exports, "FaGlobeAfrica", ()=>FaGlobeAfrica);
parcelHelpers.export(exports, "FaGlobeAmericas", ()=>FaGlobeAmericas);
parcelHelpers.export(exports, "FaGlobeAsia", ()=>FaGlobeAsia);
parcelHelpers.export(exports, "FaGlobeEurope", ()=>FaGlobeEurope);
parcelHelpers.export(exports, "FaGlobe", ()=>FaGlobe);
parcelHelpers.export(exports, "FaGolfBall", ()=>FaGolfBall);
parcelHelpers.export(exports, "FaGopuram", ()=>FaGopuram);
parcelHelpers.export(exports, "FaGraduationCap", ()=>FaGraduationCap);
parcelHelpers.export(exports, "FaGreaterThanEqual", ()=>FaGreaterThanEqual);
parcelHelpers.export(exports, "FaGreaterThan", ()=>FaGreaterThan);
parcelHelpers.export(exports, "FaGrimace", ()=>FaGrimace);
parcelHelpers.export(exports, "FaGrinAlt", ()=>FaGrinAlt);
parcelHelpers.export(exports, "FaGrinBeamSweat", ()=>FaGrinBeamSweat);
parcelHelpers.export(exports, "FaGrinBeam", ()=>FaGrinBeam);
parcelHelpers.export(exports, "FaGrinHearts", ()=>FaGrinHearts);
parcelHelpers.export(exports, "FaGrinSquintTears", ()=>FaGrinSquintTears);
parcelHelpers.export(exports, "FaGrinSquint", ()=>FaGrinSquint);
parcelHelpers.export(exports, "FaGrinStars", ()=>FaGrinStars);
parcelHelpers.export(exports, "FaGrinTears", ()=>FaGrinTears);
parcelHelpers.export(exports, "FaGrinTongueSquint", ()=>FaGrinTongueSquint);
parcelHelpers.export(exports, "FaGrinTongueWink", ()=>FaGrinTongueWink);
parcelHelpers.export(exports, "FaGrinTongue", ()=>FaGrinTongue);
parcelHelpers.export(exports, "FaGrinWink", ()=>FaGrinWink);
parcelHelpers.export(exports, "FaGrin", ()=>FaGrin);
parcelHelpers.export(exports, "FaGripHorizontal", ()=>FaGripHorizontal);
parcelHelpers.export(exports, "FaGripLinesVertical", ()=>FaGripLinesVertical);
parcelHelpers.export(exports, "FaGripLines", ()=>FaGripLines);
parcelHelpers.export(exports, "FaGripVertical", ()=>FaGripVertical);
parcelHelpers.export(exports, "FaGuitar", ()=>FaGuitar);
parcelHelpers.export(exports, "FaHSquare", ()=>FaHSquare);
parcelHelpers.export(exports, "FaHamburger", ()=>FaHamburger);
parcelHelpers.export(exports, "FaHammer", ()=>FaHammer);
parcelHelpers.export(exports, "FaHamsa", ()=>FaHamsa);
parcelHelpers.export(exports, "FaHandHoldingHeart", ()=>FaHandHoldingHeart);
parcelHelpers.export(exports, "FaHandHoldingMedical", ()=>FaHandHoldingMedical);
parcelHelpers.export(exports, "FaHandHoldingUsd", ()=>FaHandHoldingUsd);
parcelHelpers.export(exports, "FaHandHoldingWater", ()=>FaHandHoldingWater);
parcelHelpers.export(exports, "FaHandHolding", ()=>FaHandHolding);
parcelHelpers.export(exports, "FaHandLizard", ()=>FaHandLizard);
parcelHelpers.export(exports, "FaHandMiddleFinger", ()=>FaHandMiddleFinger);
parcelHelpers.export(exports, "FaHandPaper", ()=>FaHandPaper);
parcelHelpers.export(exports, "FaHandPeace", ()=>FaHandPeace);
parcelHelpers.export(exports, "FaHandPointDown", ()=>FaHandPointDown);
parcelHelpers.export(exports, "FaHandPointLeft", ()=>FaHandPointLeft);
parcelHelpers.export(exports, "FaHandPointRight", ()=>FaHandPointRight);
parcelHelpers.export(exports, "FaHandPointUp", ()=>FaHandPointUp);
parcelHelpers.export(exports, "FaHandPointer", ()=>FaHandPointer);
parcelHelpers.export(exports, "FaHandRock", ()=>FaHandRock);
parcelHelpers.export(exports, "FaHandScissors", ()=>FaHandScissors);
parcelHelpers.export(exports, "FaHandSparkles", ()=>FaHandSparkles);
parcelHelpers.export(exports, "FaHandSpock", ()=>FaHandSpock);
parcelHelpers.export(exports, "FaHandsHelping", ()=>FaHandsHelping);
parcelHelpers.export(exports, "FaHandsWash", ()=>FaHandsWash);
parcelHelpers.export(exports, "FaHands", ()=>FaHands);
parcelHelpers.export(exports, "FaHandshakeAltSlash", ()=>FaHandshakeAltSlash);
parcelHelpers.export(exports, "FaHandshakeSlash", ()=>FaHandshakeSlash);
parcelHelpers.export(exports, "FaHandshake", ()=>FaHandshake);
parcelHelpers.export(exports, "FaHanukiah", ()=>FaHanukiah);
parcelHelpers.export(exports, "FaHardHat", ()=>FaHardHat);
parcelHelpers.export(exports, "FaHashtag", ()=>FaHashtag);
parcelHelpers.export(exports, "FaHatCowboySide", ()=>FaHatCowboySide);
parcelHelpers.export(exports, "FaHatCowboy", ()=>FaHatCowboy);
parcelHelpers.export(exports, "FaHatWizard", ()=>FaHatWizard);
parcelHelpers.export(exports, "FaHdd", ()=>FaHdd);
parcelHelpers.export(exports, "FaHeadSideCoughSlash", ()=>FaHeadSideCoughSlash);
parcelHelpers.export(exports, "FaHeadSideCough", ()=>FaHeadSideCough);
parcelHelpers.export(exports, "FaHeadSideMask", ()=>FaHeadSideMask);
parcelHelpers.export(exports, "FaHeadSideVirus", ()=>FaHeadSideVirus);
parcelHelpers.export(exports, "FaHeading", ()=>FaHeading);
parcelHelpers.export(exports, "FaHeadphonesAlt", ()=>FaHeadphonesAlt);
parcelHelpers.export(exports, "FaHeadphones", ()=>FaHeadphones);
parcelHelpers.export(exports, "FaHeadset", ()=>FaHeadset);
parcelHelpers.export(exports, "FaHeartBroken", ()=>FaHeartBroken);
parcelHelpers.export(exports, "FaHeart", ()=>FaHeart);
parcelHelpers.export(exports, "FaHeartbeat", ()=>FaHeartbeat);
parcelHelpers.export(exports, "FaHelicopter", ()=>FaHelicopter);
parcelHelpers.export(exports, "FaHighlighter", ()=>FaHighlighter);
parcelHelpers.export(exports, "FaHiking", ()=>FaHiking);
parcelHelpers.export(exports, "FaHippo", ()=>FaHippo);
parcelHelpers.export(exports, "FaHistory", ()=>FaHistory);
parcelHelpers.export(exports, "FaHockeyPuck", ()=>FaHockeyPuck);
parcelHelpers.export(exports, "FaHollyBerry", ()=>FaHollyBerry);
parcelHelpers.export(exports, "FaHome", ()=>FaHome);
parcelHelpers.export(exports, "FaHorseHead", ()=>FaHorseHead);
parcelHelpers.export(exports, "FaHorse", ()=>FaHorse);
parcelHelpers.export(exports, "FaHospitalAlt", ()=>FaHospitalAlt);
parcelHelpers.export(exports, "FaHospitalSymbol", ()=>FaHospitalSymbol);
parcelHelpers.export(exports, "FaHospitalUser", ()=>FaHospitalUser);
parcelHelpers.export(exports, "FaHospital", ()=>FaHospital);
parcelHelpers.export(exports, "FaHotTub", ()=>FaHotTub);
parcelHelpers.export(exports, "FaHotdog", ()=>FaHotdog);
parcelHelpers.export(exports, "FaHotel", ()=>FaHotel);
parcelHelpers.export(exports, "FaHourglassEnd", ()=>FaHourglassEnd);
parcelHelpers.export(exports, "FaHourglassHalf", ()=>FaHourglassHalf);
parcelHelpers.export(exports, "FaHourglassStart", ()=>FaHourglassStart);
parcelHelpers.export(exports, "FaHourglass", ()=>FaHourglass);
parcelHelpers.export(exports, "FaHouseDamage", ()=>FaHouseDamage);
parcelHelpers.export(exports, "FaHouseUser", ()=>FaHouseUser);
parcelHelpers.export(exports, "FaHryvnia", ()=>FaHryvnia);
parcelHelpers.export(exports, "FaICursor", ()=>FaICursor);
parcelHelpers.export(exports, "FaIceCream", ()=>FaIceCream);
parcelHelpers.export(exports, "FaIcicles", ()=>FaIcicles);
parcelHelpers.export(exports, "FaIcons", ()=>FaIcons);
parcelHelpers.export(exports, "FaIdBadge", ()=>FaIdBadge);
parcelHelpers.export(exports, "FaIdCardAlt", ()=>FaIdCardAlt);
parcelHelpers.export(exports, "FaIdCard", ()=>FaIdCard);
parcelHelpers.export(exports, "FaIgloo", ()=>FaIgloo);
parcelHelpers.export(exports, "FaImage", ()=>FaImage);
parcelHelpers.export(exports, "FaImages", ()=>FaImages);
parcelHelpers.export(exports, "FaInbox", ()=>FaInbox);
parcelHelpers.export(exports, "FaIndent", ()=>FaIndent);
parcelHelpers.export(exports, "FaIndustry", ()=>FaIndustry);
parcelHelpers.export(exports, "FaInfinity", ()=>FaInfinity);
parcelHelpers.export(exports, "FaInfoCircle", ()=>FaInfoCircle);
parcelHelpers.export(exports, "FaInfo", ()=>FaInfo);
parcelHelpers.export(exports, "FaItalic", ()=>FaItalic);
parcelHelpers.export(exports, "FaJedi", ()=>FaJedi);
parcelHelpers.export(exports, "FaJoint", ()=>FaJoint);
parcelHelpers.export(exports, "FaJournalWhills", ()=>FaJournalWhills);
parcelHelpers.export(exports, "FaKaaba", ()=>FaKaaba);
parcelHelpers.export(exports, "FaKey", ()=>FaKey);
parcelHelpers.export(exports, "FaKeyboard", ()=>FaKeyboard);
parcelHelpers.export(exports, "FaKhanda", ()=>FaKhanda);
parcelHelpers.export(exports, "FaKissBeam", ()=>FaKissBeam);
parcelHelpers.export(exports, "FaKissWinkHeart", ()=>FaKissWinkHeart);
parcelHelpers.export(exports, "FaKiss", ()=>FaKiss);
parcelHelpers.export(exports, "FaKiwiBird", ()=>FaKiwiBird);
parcelHelpers.export(exports, "FaLandmark", ()=>FaLandmark);
parcelHelpers.export(exports, "FaLanguage", ()=>FaLanguage);
parcelHelpers.export(exports, "FaLaptopCode", ()=>FaLaptopCode);
parcelHelpers.export(exports, "FaLaptopHouse", ()=>FaLaptopHouse);
parcelHelpers.export(exports, "FaLaptopMedical", ()=>FaLaptopMedical);
parcelHelpers.export(exports, "FaLaptop", ()=>FaLaptop);
parcelHelpers.export(exports, "FaLaughBeam", ()=>FaLaughBeam);
parcelHelpers.export(exports, "FaLaughSquint", ()=>FaLaughSquint);
parcelHelpers.export(exports, "FaLaughWink", ()=>FaLaughWink);
parcelHelpers.export(exports, "FaLaugh", ()=>FaLaugh);
parcelHelpers.export(exports, "FaLayerGroup", ()=>FaLayerGroup);
parcelHelpers.export(exports, "FaLeaf", ()=>FaLeaf);
parcelHelpers.export(exports, "FaLemon", ()=>FaLemon);
parcelHelpers.export(exports, "FaLessThanEqual", ()=>FaLessThanEqual);
parcelHelpers.export(exports, "FaLessThan", ()=>FaLessThan);
parcelHelpers.export(exports, "FaLevelDownAlt", ()=>FaLevelDownAlt);
parcelHelpers.export(exports, "FaLevelUpAlt", ()=>FaLevelUpAlt);
parcelHelpers.export(exports, "FaLifeRing", ()=>FaLifeRing);
parcelHelpers.export(exports, "FaLightbulb", ()=>FaLightbulb);
parcelHelpers.export(exports, "FaLink", ()=>FaLink);
parcelHelpers.export(exports, "FaLiraSign", ()=>FaLiraSign);
parcelHelpers.export(exports, "FaListAlt", ()=>FaListAlt);
parcelHelpers.export(exports, "FaListOl", ()=>FaListOl);
parcelHelpers.export(exports, "FaListUl", ()=>FaListUl);
parcelHelpers.export(exports, "FaList", ()=>FaList);
parcelHelpers.export(exports, "FaLocationArrow", ()=>FaLocationArrow);
parcelHelpers.export(exports, "FaLockOpen", ()=>FaLockOpen);
parcelHelpers.export(exports, "FaLock", ()=>FaLock);
parcelHelpers.export(exports, "FaLongArrowAltDown", ()=>FaLongArrowAltDown);
parcelHelpers.export(exports, "FaLongArrowAltLeft", ()=>FaLongArrowAltLeft);
parcelHelpers.export(exports, "FaLongArrowAltRight", ()=>FaLongArrowAltRight);
parcelHelpers.export(exports, "FaLongArrowAltUp", ()=>FaLongArrowAltUp);
parcelHelpers.export(exports, "FaLowVision", ()=>FaLowVision);
parcelHelpers.export(exports, "FaLuggageCart", ()=>FaLuggageCart);
parcelHelpers.export(exports, "FaLungsVirus", ()=>FaLungsVirus);
parcelHelpers.export(exports, "FaLungs", ()=>FaLungs);
parcelHelpers.export(exports, "FaMagic", ()=>FaMagic);
parcelHelpers.export(exports, "FaMagnet", ()=>FaMagnet);
parcelHelpers.export(exports, "FaMailBulk", ()=>FaMailBulk);
parcelHelpers.export(exports, "FaMale", ()=>FaMale);
parcelHelpers.export(exports, "FaMapMarkedAlt", ()=>FaMapMarkedAlt);
parcelHelpers.export(exports, "FaMapMarked", ()=>FaMapMarked);
parcelHelpers.export(exports, "FaMapMarkerAlt", ()=>FaMapMarkerAlt);
parcelHelpers.export(exports, "FaMapMarker", ()=>FaMapMarker);
parcelHelpers.export(exports, "FaMapPin", ()=>FaMapPin);
parcelHelpers.export(exports, "FaMapSigns", ()=>FaMapSigns);
parcelHelpers.export(exports, "FaMap", ()=>FaMap);
parcelHelpers.export(exports, "FaMarker", ()=>FaMarker);
parcelHelpers.export(exports, "FaMarsDouble", ()=>FaMarsDouble);
parcelHelpers.export(exports, "FaMarsStrokeH", ()=>FaMarsStrokeH);
parcelHelpers.export(exports, "FaMarsStrokeV", ()=>FaMarsStrokeV);
parcelHelpers.export(exports, "FaMarsStroke", ()=>FaMarsStroke);
parcelHelpers.export(exports, "FaMars", ()=>FaMars);
parcelHelpers.export(exports, "FaMask", ()=>FaMask);
parcelHelpers.export(exports, "FaMedal", ()=>FaMedal);
parcelHelpers.export(exports, "FaMedkit", ()=>FaMedkit);
parcelHelpers.export(exports, "FaMehBlank", ()=>FaMehBlank);
parcelHelpers.export(exports, "FaMehRollingEyes", ()=>FaMehRollingEyes);
parcelHelpers.export(exports, "FaMeh", ()=>FaMeh);
parcelHelpers.export(exports, "FaMemory", ()=>FaMemory);
parcelHelpers.export(exports, "FaMenorah", ()=>FaMenorah);
parcelHelpers.export(exports, "FaMercury", ()=>FaMercury);
parcelHelpers.export(exports, "FaMeteor", ()=>FaMeteor);
parcelHelpers.export(exports, "FaMicrochip", ()=>FaMicrochip);
parcelHelpers.export(exports, "FaMicrophoneAltSlash", ()=>FaMicrophoneAltSlash);
parcelHelpers.export(exports, "FaMicrophoneAlt", ()=>FaMicrophoneAlt);
parcelHelpers.export(exports, "FaMicrophoneSlash", ()=>FaMicrophoneSlash);
parcelHelpers.export(exports, "FaMicrophone", ()=>FaMicrophone);
parcelHelpers.export(exports, "FaMicroscope", ()=>FaMicroscope);
parcelHelpers.export(exports, "FaMinusCircle", ()=>FaMinusCircle);
parcelHelpers.export(exports, "FaMinusSquare", ()=>FaMinusSquare);
parcelHelpers.export(exports, "FaMinus", ()=>FaMinus);
parcelHelpers.export(exports, "FaMitten", ()=>FaMitten);
parcelHelpers.export(exports, "FaMobileAlt", ()=>FaMobileAlt);
parcelHelpers.export(exports, "FaMobile", ()=>FaMobile);
parcelHelpers.export(exports, "FaMoneyBillAlt", ()=>FaMoneyBillAlt);
parcelHelpers.export(exports, "FaMoneyBillWaveAlt", ()=>FaMoneyBillWaveAlt);
parcelHelpers.export(exports, "FaMoneyBillWave", ()=>FaMoneyBillWave);
parcelHelpers.export(exports, "FaMoneyBill", ()=>FaMoneyBill);
parcelHelpers.export(exports, "FaMoneyCheckAlt", ()=>FaMoneyCheckAlt);
parcelHelpers.export(exports, "FaMoneyCheck", ()=>FaMoneyCheck);
parcelHelpers.export(exports, "FaMonument", ()=>FaMonument);
parcelHelpers.export(exports, "FaMoon", ()=>FaMoon);
parcelHelpers.export(exports, "FaMortarPestle", ()=>FaMortarPestle);
parcelHelpers.export(exports, "FaMosque", ()=>FaMosque);
parcelHelpers.export(exports, "FaMotorcycle", ()=>FaMotorcycle);
parcelHelpers.export(exports, "FaMountain", ()=>FaMountain);
parcelHelpers.export(exports, "FaMousePointer", ()=>FaMousePointer);
parcelHelpers.export(exports, "FaMouse", ()=>FaMouse);
parcelHelpers.export(exports, "FaMugHot", ()=>FaMugHot);
parcelHelpers.export(exports, "FaMusic", ()=>FaMusic);
parcelHelpers.export(exports, "FaNetworkWired", ()=>FaNetworkWired);
parcelHelpers.export(exports, "FaNeuter", ()=>FaNeuter);
parcelHelpers.export(exports, "FaNewspaper", ()=>FaNewspaper);
parcelHelpers.export(exports, "FaNotEqual", ()=>FaNotEqual);
parcelHelpers.export(exports, "FaNotesMedical", ()=>FaNotesMedical);
parcelHelpers.export(exports, "FaObjectGroup", ()=>FaObjectGroup);
parcelHelpers.export(exports, "FaObjectUngroup", ()=>FaObjectUngroup);
parcelHelpers.export(exports, "FaOilCan", ()=>FaOilCan);
parcelHelpers.export(exports, "FaOm", ()=>FaOm);
parcelHelpers.export(exports, "FaOtter", ()=>FaOtter);
parcelHelpers.export(exports, "FaOutdent", ()=>FaOutdent);
parcelHelpers.export(exports, "FaPager", ()=>FaPager);
parcelHelpers.export(exports, "FaPaintBrush", ()=>FaPaintBrush);
parcelHelpers.export(exports, "FaPaintRoller", ()=>FaPaintRoller);
parcelHelpers.export(exports, "FaPalette", ()=>FaPalette);
parcelHelpers.export(exports, "FaPallet", ()=>FaPallet);
parcelHelpers.export(exports, "FaPaperPlane", ()=>FaPaperPlane);
parcelHelpers.export(exports, "FaPaperclip", ()=>FaPaperclip);
parcelHelpers.export(exports, "FaParachuteBox", ()=>FaParachuteBox);
parcelHelpers.export(exports, "FaParagraph", ()=>FaParagraph);
parcelHelpers.export(exports, "FaParking", ()=>FaParking);
parcelHelpers.export(exports, "FaPassport", ()=>FaPassport);
parcelHelpers.export(exports, "FaPastafarianism", ()=>FaPastafarianism);
parcelHelpers.export(exports, "FaPaste", ()=>FaPaste);
parcelHelpers.export(exports, "FaPauseCircle", ()=>FaPauseCircle);
parcelHelpers.export(exports, "FaPause", ()=>FaPause);
parcelHelpers.export(exports, "FaPaw", ()=>FaPaw);
parcelHelpers.export(exports, "FaPeace", ()=>FaPeace);
parcelHelpers.export(exports, "FaPenAlt", ()=>FaPenAlt);
parcelHelpers.export(exports, "FaPenFancy", ()=>FaPenFancy);
parcelHelpers.export(exports, "FaPenNib", ()=>FaPenNib);
parcelHelpers.export(exports, "FaPenSquare", ()=>FaPenSquare);
parcelHelpers.export(exports, "FaPen", ()=>FaPen);
parcelHelpers.export(exports, "FaPencilAlt", ()=>FaPencilAlt);
parcelHelpers.export(exports, "FaPencilRuler", ()=>FaPencilRuler);
parcelHelpers.export(exports, "FaPeopleArrows", ()=>FaPeopleArrows);
parcelHelpers.export(exports, "FaPeopleCarry", ()=>FaPeopleCarry);
parcelHelpers.export(exports, "FaPepperHot", ()=>FaPepperHot);
parcelHelpers.export(exports, "FaPercent", ()=>FaPercent);
parcelHelpers.export(exports, "FaPercentage", ()=>FaPercentage);
parcelHelpers.export(exports, "FaPersonBooth", ()=>FaPersonBooth);
parcelHelpers.export(exports, "FaPhoneAlt", ()=>FaPhoneAlt);
parcelHelpers.export(exports, "FaPhoneSlash", ()=>FaPhoneSlash);
parcelHelpers.export(exports, "FaPhoneSquareAlt", ()=>FaPhoneSquareAlt);
parcelHelpers.export(exports, "FaPhoneSquare", ()=>FaPhoneSquare);
parcelHelpers.export(exports, "FaPhoneVolume", ()=>FaPhoneVolume);
parcelHelpers.export(exports, "FaPhone", ()=>FaPhone);
parcelHelpers.export(exports, "FaPhotoVideo", ()=>FaPhotoVideo);
parcelHelpers.export(exports, "FaPiggyBank", ()=>FaPiggyBank);
parcelHelpers.export(exports, "FaPills", ()=>FaPills);
parcelHelpers.export(exports, "FaPizzaSlice", ()=>FaPizzaSlice);
parcelHelpers.export(exports, "FaPlaceOfWorship", ()=>FaPlaceOfWorship);
parcelHelpers.export(exports, "FaPlaneArrival", ()=>FaPlaneArrival);
parcelHelpers.export(exports, "FaPlaneDeparture", ()=>FaPlaneDeparture);
parcelHelpers.export(exports, "FaPlaneSlash", ()=>FaPlaneSlash);
parcelHelpers.export(exports, "FaPlane", ()=>FaPlane);
parcelHelpers.export(exports, "FaPlayCircle", ()=>FaPlayCircle);
parcelHelpers.export(exports, "FaPlay", ()=>FaPlay);
parcelHelpers.export(exports, "FaPlug", ()=>FaPlug);
parcelHelpers.export(exports, "FaPlusCircle", ()=>FaPlusCircle);
parcelHelpers.export(exports, "FaPlusSquare", ()=>FaPlusSquare);
parcelHelpers.export(exports, "FaPlus", ()=>FaPlus);
parcelHelpers.export(exports, "FaPodcast", ()=>FaPodcast);
parcelHelpers.export(exports, "FaPollH", ()=>FaPollH);
parcelHelpers.export(exports, "FaPoll", ()=>FaPoll);
parcelHelpers.export(exports, "FaPooStorm", ()=>FaPooStorm);
parcelHelpers.export(exports, "FaPoo", ()=>FaPoo);
parcelHelpers.export(exports, "FaPoop", ()=>FaPoop);
parcelHelpers.export(exports, "FaPortrait", ()=>FaPortrait);
parcelHelpers.export(exports, "FaPoundSign", ()=>FaPoundSign);
parcelHelpers.export(exports, "FaPowerOff", ()=>FaPowerOff);
parcelHelpers.export(exports, "FaPray", ()=>FaPray);
parcelHelpers.export(exports, "FaPrayingHands", ()=>FaPrayingHands);
parcelHelpers.export(exports, "FaPrescriptionBottleAlt", ()=>FaPrescriptionBottleAlt);
parcelHelpers.export(exports, "FaPrescriptionBottle", ()=>FaPrescriptionBottle);
parcelHelpers.export(exports, "FaPrescription", ()=>FaPrescription);
parcelHelpers.export(exports, "FaPrint", ()=>FaPrint);
parcelHelpers.export(exports, "FaProcedures", ()=>FaProcedures);
parcelHelpers.export(exports, "FaProjectDiagram", ()=>FaProjectDiagram);
parcelHelpers.export(exports, "FaPumpMedical", ()=>FaPumpMedical);
parcelHelpers.export(exports, "FaPumpSoap", ()=>FaPumpSoap);
parcelHelpers.export(exports, "FaPuzzlePiece", ()=>FaPuzzlePiece);
parcelHelpers.export(exports, "FaQrcode", ()=>FaQrcode);
parcelHelpers.export(exports, "FaQuestionCircle", ()=>FaQuestionCircle);
parcelHelpers.export(exports, "FaQuestion", ()=>FaQuestion);
parcelHelpers.export(exports, "FaQuidditch", ()=>FaQuidditch);
parcelHelpers.export(exports, "FaQuoteLeft", ()=>FaQuoteLeft);
parcelHelpers.export(exports, "FaQuoteRight", ()=>FaQuoteRight);
parcelHelpers.export(exports, "FaQuran", ()=>FaQuran);
parcelHelpers.export(exports, "FaRadiationAlt", ()=>FaRadiationAlt);
parcelHelpers.export(exports, "FaRadiation", ()=>FaRadiation);
parcelHelpers.export(exports, "FaRainbow", ()=>FaRainbow);
parcelHelpers.export(exports, "FaRandom", ()=>FaRandom);
parcelHelpers.export(exports, "FaReceipt", ()=>FaReceipt);
parcelHelpers.export(exports, "FaRecordVinyl", ()=>FaRecordVinyl);
parcelHelpers.export(exports, "FaRecycle", ()=>FaRecycle);
parcelHelpers.export(exports, "FaRedoAlt", ()=>FaRedoAlt);
parcelHelpers.export(exports, "FaRedo", ()=>FaRedo);
parcelHelpers.export(exports, "FaRegistered", ()=>FaRegistered);
parcelHelpers.export(exports, "FaRemoveFormat", ()=>FaRemoveFormat);
parcelHelpers.export(exports, "FaReplyAll", ()=>FaReplyAll);
parcelHelpers.export(exports, "FaReply", ()=>FaReply);
parcelHelpers.export(exports, "FaRepublican", ()=>FaRepublican);
parcelHelpers.export(exports, "FaRestroom", ()=>FaRestroom);
parcelHelpers.export(exports, "FaRetweet", ()=>FaRetweet);
parcelHelpers.export(exports, "FaRibbon", ()=>FaRibbon);
parcelHelpers.export(exports, "FaRing", ()=>FaRing);
parcelHelpers.export(exports, "FaRoad", ()=>FaRoad);
parcelHelpers.export(exports, "FaRobot", ()=>FaRobot);
parcelHelpers.export(exports, "FaRocket", ()=>FaRocket);
parcelHelpers.export(exports, "FaRoute", ()=>FaRoute);
parcelHelpers.export(exports, "FaRssSquare", ()=>FaRssSquare);
parcelHelpers.export(exports, "FaRss", ()=>FaRss);
parcelHelpers.export(exports, "FaRubleSign", ()=>FaRubleSign);
parcelHelpers.export(exports, "FaRulerCombined", ()=>FaRulerCombined);
parcelHelpers.export(exports, "FaRulerHorizontal", ()=>FaRulerHorizontal);
parcelHelpers.export(exports, "FaRulerVertical", ()=>FaRulerVertical);
parcelHelpers.export(exports, "FaRuler", ()=>FaRuler);
parcelHelpers.export(exports, "FaRunning", ()=>FaRunning);
parcelHelpers.export(exports, "FaRupeeSign", ()=>FaRupeeSign);
parcelHelpers.export(exports, "FaSadCry", ()=>FaSadCry);
parcelHelpers.export(exports, "FaSadTear", ()=>FaSadTear);
parcelHelpers.export(exports, "FaSatelliteDish", ()=>FaSatelliteDish);
parcelHelpers.export(exports, "FaSatellite", ()=>FaSatellite);
parcelHelpers.export(exports, "FaSave", ()=>FaSave);
parcelHelpers.export(exports, "FaSchool", ()=>FaSchool);
parcelHelpers.export(exports, "FaScrewdriver", ()=>FaScrewdriver);
parcelHelpers.export(exports, "FaScroll", ()=>FaScroll);
parcelHelpers.export(exports, "FaSdCard", ()=>FaSdCard);
parcelHelpers.export(exports, "FaSearchDollar", ()=>FaSearchDollar);
parcelHelpers.export(exports, "FaSearchLocation", ()=>FaSearchLocation);
parcelHelpers.export(exports, "FaSearchMinus", ()=>FaSearchMinus);
parcelHelpers.export(exports, "FaSearchPlus", ()=>FaSearchPlus);
parcelHelpers.export(exports, "FaSearch", ()=>FaSearch);
parcelHelpers.export(exports, "FaSeedling", ()=>FaSeedling);
parcelHelpers.export(exports, "FaServer", ()=>FaServer);
parcelHelpers.export(exports, "FaShapes", ()=>FaShapes);
parcelHelpers.export(exports, "FaShareAltSquare", ()=>FaShareAltSquare);
parcelHelpers.export(exports, "FaShareAlt", ()=>FaShareAlt);
parcelHelpers.export(exports, "FaShareSquare", ()=>FaShareSquare);
parcelHelpers.export(exports, "FaShare", ()=>FaShare);
parcelHelpers.export(exports, "FaShekelSign", ()=>FaShekelSign);
parcelHelpers.export(exports, "FaShieldAlt", ()=>FaShieldAlt);
parcelHelpers.export(exports, "FaShieldVirus", ()=>FaShieldVirus);
parcelHelpers.export(exports, "FaShip", ()=>FaShip);
parcelHelpers.export(exports, "FaShippingFast", ()=>FaShippingFast);
parcelHelpers.export(exports, "FaShoePrints", ()=>FaShoePrints);
parcelHelpers.export(exports, "FaShoppingBag", ()=>FaShoppingBag);
parcelHelpers.export(exports, "FaShoppingBasket", ()=>FaShoppingBasket);
parcelHelpers.export(exports, "FaShoppingCart", ()=>FaShoppingCart);
parcelHelpers.export(exports, "FaShower", ()=>FaShower);
parcelHelpers.export(exports, "FaShuttleVan", ()=>FaShuttleVan);
parcelHelpers.export(exports, "FaSignInAlt", ()=>FaSignInAlt);
parcelHelpers.export(exports, "FaSignLanguage", ()=>FaSignLanguage);
parcelHelpers.export(exports, "FaSignOutAlt", ()=>FaSignOutAlt);
parcelHelpers.export(exports, "FaSign", ()=>FaSign);
parcelHelpers.export(exports, "FaSignal", ()=>FaSignal);
parcelHelpers.export(exports, "FaSignature", ()=>FaSignature);
parcelHelpers.export(exports, "FaSimCard", ()=>FaSimCard);
parcelHelpers.export(exports, "FaSink", ()=>FaSink);
parcelHelpers.export(exports, "FaSitemap", ()=>FaSitemap);
parcelHelpers.export(exports, "FaSkating", ()=>FaSkating);
parcelHelpers.export(exports, "FaSkiingNordic", ()=>FaSkiingNordic);
parcelHelpers.export(exports, "FaSkiing", ()=>FaSkiing);
parcelHelpers.export(exports, "FaSkullCrossbones", ()=>FaSkullCrossbones);
parcelHelpers.export(exports, "FaSkull", ()=>FaSkull);
parcelHelpers.export(exports, "FaSlash", ()=>FaSlash);
parcelHelpers.export(exports, "FaSleigh", ()=>FaSleigh);
parcelHelpers.export(exports, "FaSlidersH", ()=>FaSlidersH);
parcelHelpers.export(exports, "FaSmileBeam", ()=>FaSmileBeam);
parcelHelpers.export(exports, "FaSmileWink", ()=>FaSmileWink);
parcelHelpers.export(exports, "FaSmile", ()=>FaSmile);
parcelHelpers.export(exports, "FaSmog", ()=>FaSmog);
parcelHelpers.export(exports, "FaSmokingBan", ()=>FaSmokingBan);
parcelHelpers.export(exports, "FaSmoking", ()=>FaSmoking);
parcelHelpers.export(exports, "FaSms", ()=>FaSms);
parcelHelpers.export(exports, "FaSnowboarding", ()=>FaSnowboarding);
parcelHelpers.export(exports, "FaSnowflake", ()=>FaSnowflake);
parcelHelpers.export(exports, "FaSnowman", ()=>FaSnowman);
parcelHelpers.export(exports, "FaSnowplow", ()=>FaSnowplow);
parcelHelpers.export(exports, "FaSoap", ()=>FaSoap);
parcelHelpers.export(exports, "FaSocks", ()=>FaSocks);
parcelHelpers.export(exports, "FaSolarPanel", ()=>FaSolarPanel);
parcelHelpers.export(exports, "FaSortAlphaDownAlt", ()=>FaSortAlphaDownAlt);
parcelHelpers.export(exports, "FaSortAlphaDown", ()=>FaSortAlphaDown);
parcelHelpers.export(exports, "FaSortAlphaUpAlt", ()=>FaSortAlphaUpAlt);
parcelHelpers.export(exports, "FaSortAlphaUp", ()=>FaSortAlphaUp);
parcelHelpers.export(exports, "FaSortAmountDownAlt", ()=>FaSortAmountDownAlt);
parcelHelpers.export(exports, "FaSortAmountDown", ()=>FaSortAmountDown);
parcelHelpers.export(exports, "FaSortAmountUpAlt", ()=>FaSortAmountUpAlt);
parcelHelpers.export(exports, "FaSortAmountUp", ()=>FaSortAmountUp);
parcelHelpers.export(exports, "FaSortDown", ()=>FaSortDown);
parcelHelpers.export(exports, "FaSortNumericDownAlt", ()=>FaSortNumericDownAlt);
parcelHelpers.export(exports, "FaSortNumericDown", ()=>FaSortNumericDown);
parcelHelpers.export(exports, "FaSortNumericUpAlt", ()=>FaSortNumericUpAlt);
parcelHelpers.export(exports, "FaSortNumericUp", ()=>FaSortNumericUp);
parcelHelpers.export(exports, "FaSortUp", ()=>FaSortUp);
parcelHelpers.export(exports, "FaSort", ()=>FaSort);
parcelHelpers.export(exports, "FaSpa", ()=>FaSpa);
parcelHelpers.export(exports, "FaSpaceShuttle", ()=>FaSpaceShuttle);
parcelHelpers.export(exports, "FaSpellCheck", ()=>FaSpellCheck);
parcelHelpers.export(exports, "FaSpider", ()=>FaSpider);
parcelHelpers.export(exports, "FaSpinner", ()=>FaSpinner);
parcelHelpers.export(exports, "FaSplotch", ()=>FaSplotch);
parcelHelpers.export(exports, "FaSprayCan", ()=>FaSprayCan);
parcelHelpers.export(exports, "FaSquareFull", ()=>FaSquareFull);
parcelHelpers.export(exports, "FaSquareRootAlt", ()=>FaSquareRootAlt);
parcelHelpers.export(exports, "FaSquare", ()=>FaSquare);
parcelHelpers.export(exports, "FaStamp", ()=>FaStamp);
parcelHelpers.export(exports, "FaStarAndCrescent", ()=>FaStarAndCrescent);
parcelHelpers.export(exports, "FaStarHalfAlt", ()=>FaStarHalfAlt);
parcelHelpers.export(exports, "FaStarHalf", ()=>FaStarHalf);
parcelHelpers.export(exports, "FaStarOfDavid", ()=>FaStarOfDavid);
parcelHelpers.export(exports, "FaStarOfLife", ()=>FaStarOfLife);
parcelHelpers.export(exports, "FaStar", ()=>FaStar);
parcelHelpers.export(exports, "FaStepBackward", ()=>FaStepBackward);
parcelHelpers.export(exports, "FaStepForward", ()=>FaStepForward);
parcelHelpers.export(exports, "FaStethoscope", ()=>FaStethoscope);
parcelHelpers.export(exports, "FaStickyNote", ()=>FaStickyNote);
parcelHelpers.export(exports, "FaStopCircle", ()=>FaStopCircle);
parcelHelpers.export(exports, "FaStop", ()=>FaStop);
parcelHelpers.export(exports, "FaStopwatch20", ()=>FaStopwatch20);
parcelHelpers.export(exports, "FaStopwatch", ()=>FaStopwatch);
parcelHelpers.export(exports, "FaStoreAltSlash", ()=>FaStoreAltSlash);
parcelHelpers.export(exports, "FaStoreAlt", ()=>FaStoreAlt);
parcelHelpers.export(exports, "FaStoreSlash", ()=>FaStoreSlash);
parcelHelpers.export(exports, "FaStore", ()=>FaStore);
parcelHelpers.export(exports, "FaStream", ()=>FaStream);
parcelHelpers.export(exports, "FaStreetView", ()=>FaStreetView);
parcelHelpers.export(exports, "FaStrikethrough", ()=>FaStrikethrough);
parcelHelpers.export(exports, "FaStroopwafel", ()=>FaStroopwafel);
parcelHelpers.export(exports, "FaSubscript", ()=>FaSubscript);
parcelHelpers.export(exports, "FaSubway", ()=>FaSubway);
parcelHelpers.export(exports, "FaSuitcaseRolling", ()=>FaSuitcaseRolling);
parcelHelpers.export(exports, "FaSuitcase", ()=>FaSuitcase);
parcelHelpers.export(exports, "FaSun", ()=>FaSun);
parcelHelpers.export(exports, "FaSuperscript", ()=>FaSuperscript);
parcelHelpers.export(exports, "FaSurprise", ()=>FaSurprise);
parcelHelpers.export(exports, "FaSwatchbook", ()=>FaSwatchbook);
parcelHelpers.export(exports, "FaSwimmer", ()=>FaSwimmer);
parcelHelpers.export(exports, "FaSwimmingPool", ()=>FaSwimmingPool);
parcelHelpers.export(exports, "FaSynagogue", ()=>FaSynagogue);
parcelHelpers.export(exports, "FaSyncAlt", ()=>FaSyncAlt);
parcelHelpers.export(exports, "FaSync", ()=>FaSync);
parcelHelpers.export(exports, "FaSyringe", ()=>FaSyringe);
parcelHelpers.export(exports, "FaTableTennis", ()=>FaTableTennis);
parcelHelpers.export(exports, "FaTable", ()=>FaTable);
parcelHelpers.export(exports, "FaTabletAlt", ()=>FaTabletAlt);
parcelHelpers.export(exports, "FaTablet", ()=>FaTablet);
parcelHelpers.export(exports, "FaTablets", ()=>FaTablets);
parcelHelpers.export(exports, "FaTachometerAlt", ()=>FaTachometerAlt);
parcelHelpers.export(exports, "FaTag", ()=>FaTag);
parcelHelpers.export(exports, "FaTags", ()=>FaTags);
parcelHelpers.export(exports, "FaTape", ()=>FaTape);
parcelHelpers.export(exports, "FaTasks", ()=>FaTasks);
parcelHelpers.export(exports, "FaTaxi", ()=>FaTaxi);
parcelHelpers.export(exports, "FaTeethOpen", ()=>FaTeethOpen);
parcelHelpers.export(exports, "FaTeeth", ()=>FaTeeth);
parcelHelpers.export(exports, "FaTemperatureHigh", ()=>FaTemperatureHigh);
parcelHelpers.export(exports, "FaTemperatureLow", ()=>FaTemperatureLow);
parcelHelpers.export(exports, "FaTenge", ()=>FaTenge);
parcelHelpers.export(exports, "FaTerminal", ()=>FaTerminal);
parcelHelpers.export(exports, "FaTextHeight", ()=>FaTextHeight);
parcelHelpers.export(exports, "FaTextWidth", ()=>FaTextWidth);
parcelHelpers.export(exports, "FaThLarge", ()=>FaThLarge);
parcelHelpers.export(exports, "FaThList", ()=>FaThList);
parcelHelpers.export(exports, "FaTh", ()=>FaTh);
parcelHelpers.export(exports, "FaTheaterMasks", ()=>FaTheaterMasks);
parcelHelpers.export(exports, "FaThermometerEmpty", ()=>FaThermometerEmpty);
parcelHelpers.export(exports, "FaThermometerFull", ()=>FaThermometerFull);
parcelHelpers.export(exports, "FaThermometerHalf", ()=>FaThermometerHalf);
parcelHelpers.export(exports, "FaThermometerQuarter", ()=>FaThermometerQuarter);
parcelHelpers.export(exports, "FaThermometerThreeQuarters", ()=>FaThermometerThreeQuarters);
parcelHelpers.export(exports, "FaThermometer", ()=>FaThermometer);
parcelHelpers.export(exports, "FaThumbsDown", ()=>FaThumbsDown);
parcelHelpers.export(exports, "FaThumbsUp", ()=>FaThumbsUp);
parcelHelpers.export(exports, "FaThumbtack", ()=>FaThumbtack);
parcelHelpers.export(exports, "FaTicketAlt", ()=>FaTicketAlt);
parcelHelpers.export(exports, "FaTimesCircle", ()=>FaTimesCircle);
parcelHelpers.export(exports, "FaTimes", ()=>FaTimes);
parcelHelpers.export(exports, "FaTintSlash", ()=>FaTintSlash);
parcelHelpers.export(exports, "FaTint", ()=>FaTint);
parcelHelpers.export(exports, "FaTired", ()=>FaTired);
parcelHelpers.export(exports, "FaToggleOff", ()=>FaToggleOff);
parcelHelpers.export(exports, "FaToggleOn", ()=>FaToggleOn);
parcelHelpers.export(exports, "FaToiletPaperSlash", ()=>FaToiletPaperSlash);
parcelHelpers.export(exports, "FaToiletPaper", ()=>FaToiletPaper);
parcelHelpers.export(exports, "FaToilet", ()=>FaToilet);
parcelHelpers.export(exports, "FaToolbox", ()=>FaToolbox);
parcelHelpers.export(exports, "FaTools", ()=>FaTools);
parcelHelpers.export(exports, "FaTooth", ()=>FaTooth);
parcelHelpers.export(exports, "FaTorah", ()=>FaTorah);
parcelHelpers.export(exports, "FaToriiGate", ()=>FaToriiGate);
parcelHelpers.export(exports, "FaTractor", ()=>FaTractor);
parcelHelpers.export(exports, "FaTrademark", ()=>FaTrademark);
parcelHelpers.export(exports, "FaTrafficLight", ()=>FaTrafficLight);
parcelHelpers.export(exports, "FaTrailer", ()=>FaTrailer);
parcelHelpers.export(exports, "FaTrain", ()=>FaTrain);
parcelHelpers.export(exports, "FaTram", ()=>FaTram);
parcelHelpers.export(exports, "FaTransgenderAlt", ()=>FaTransgenderAlt);
parcelHelpers.export(exports, "FaTransgender", ()=>FaTransgender);
parcelHelpers.export(exports, "FaTrashAlt", ()=>FaTrashAlt);
parcelHelpers.export(exports, "FaTrashRestoreAlt", ()=>FaTrashRestoreAlt);
parcelHelpers.export(exports, "FaTrashRestore", ()=>FaTrashRestore);
parcelHelpers.export(exports, "FaTrash", ()=>FaTrash);
parcelHelpers.export(exports, "FaTree", ()=>FaTree);
parcelHelpers.export(exports, "FaTrophy", ()=>FaTrophy);
parcelHelpers.export(exports, "FaTruckLoading", ()=>FaTruckLoading);
parcelHelpers.export(exports, "FaTruckMonster", ()=>FaTruckMonster);
parcelHelpers.export(exports, "FaTruckMoving", ()=>FaTruckMoving);
parcelHelpers.export(exports, "FaTruckPickup", ()=>FaTruckPickup);
parcelHelpers.export(exports, "FaTruck", ()=>FaTruck);
parcelHelpers.export(exports, "FaTshirt", ()=>FaTshirt);
parcelHelpers.export(exports, "FaTty", ()=>FaTty);
parcelHelpers.export(exports, "FaTv", ()=>FaTv);
parcelHelpers.export(exports, "FaUmbrellaBeach", ()=>FaUmbrellaBeach);
parcelHelpers.export(exports, "FaUmbrella", ()=>FaUmbrella);
parcelHelpers.export(exports, "FaUnderline", ()=>FaUnderline);
parcelHelpers.export(exports, "FaUndoAlt", ()=>FaUndoAlt);
parcelHelpers.export(exports, "FaUndo", ()=>FaUndo);
parcelHelpers.export(exports, "FaUniversalAccess", ()=>FaUniversalAccess);
parcelHelpers.export(exports, "FaUniversity", ()=>FaUniversity);
parcelHelpers.export(exports, "FaUnlink", ()=>FaUnlink);
parcelHelpers.export(exports, "FaUnlockAlt", ()=>FaUnlockAlt);
parcelHelpers.export(exports, "FaUnlock", ()=>FaUnlock);
parcelHelpers.export(exports, "FaUpload", ()=>FaUpload);
parcelHelpers.export(exports, "FaUserAltSlash", ()=>FaUserAltSlash);
parcelHelpers.export(exports, "FaUserAlt", ()=>FaUserAlt);
parcelHelpers.export(exports, "FaUserAstronaut", ()=>FaUserAstronaut);
parcelHelpers.export(exports, "FaUserCheck", ()=>FaUserCheck);
parcelHelpers.export(exports, "FaUserCircle", ()=>FaUserCircle);
parcelHelpers.export(exports, "FaUserClock", ()=>FaUserClock);
parcelHelpers.export(exports, "FaUserCog", ()=>FaUserCog);
parcelHelpers.export(exports, "FaUserEdit", ()=>FaUserEdit);
parcelHelpers.export(exports, "FaUserFriends", ()=>FaUserFriends);
parcelHelpers.export(exports, "FaUserGraduate", ()=>FaUserGraduate);
parcelHelpers.export(exports, "FaUserInjured", ()=>FaUserInjured);
parcelHelpers.export(exports, "FaUserLock", ()=>FaUserLock);
parcelHelpers.export(exports, "FaUserMd", ()=>FaUserMd);
parcelHelpers.export(exports, "FaUserMinus", ()=>FaUserMinus);
parcelHelpers.export(exports, "FaUserNinja", ()=>FaUserNinja);
parcelHelpers.export(exports, "FaUserNurse", ()=>FaUserNurse);
parcelHelpers.export(exports, "FaUserPlus", ()=>FaUserPlus);
parcelHelpers.export(exports, "FaUserSecret", ()=>FaUserSecret);
parcelHelpers.export(exports, "FaUserShield", ()=>FaUserShield);
parcelHelpers.export(exports, "FaUserSlash", ()=>FaUserSlash);
parcelHelpers.export(exports, "FaUserTag", ()=>FaUserTag);
parcelHelpers.export(exports, "FaUserTie", ()=>FaUserTie);
parcelHelpers.export(exports, "FaUserTimes", ()=>FaUserTimes);
parcelHelpers.export(exports, "FaUser", ()=>FaUser);
parcelHelpers.export(exports, "FaUsersCog", ()=>FaUsersCog);
parcelHelpers.export(exports, "FaUsersSlash", ()=>FaUsersSlash);
parcelHelpers.export(exports, "FaUsers", ()=>FaUsers);
parcelHelpers.export(exports, "FaUtensilSpoon", ()=>FaUtensilSpoon);
parcelHelpers.export(exports, "FaUtensils", ()=>FaUtensils);
parcelHelpers.export(exports, "FaVectorSquare", ()=>FaVectorSquare);
parcelHelpers.export(exports, "FaVenusDouble", ()=>FaVenusDouble);
parcelHelpers.export(exports, "FaVenusMars", ()=>FaVenusMars);
parcelHelpers.export(exports, "FaVenus", ()=>FaVenus);
parcelHelpers.export(exports, "FaVestPatches", ()=>FaVestPatches);
parcelHelpers.export(exports, "FaVest", ()=>FaVest);
parcelHelpers.export(exports, "FaVial", ()=>FaVial);
parcelHelpers.export(exports, "FaVials", ()=>FaVials);
parcelHelpers.export(exports, "FaVideoSlash", ()=>FaVideoSlash);
parcelHelpers.export(exports, "FaVideo", ()=>FaVideo);
parcelHelpers.export(exports, "FaVihara", ()=>FaVihara);
parcelHelpers.export(exports, "FaVirusSlash", ()=>FaVirusSlash);
parcelHelpers.export(exports, "FaVirus", ()=>FaVirus);
parcelHelpers.export(exports, "FaViruses", ()=>FaViruses);
parcelHelpers.export(exports, "FaVoicemail", ()=>FaVoicemail);
parcelHelpers.export(exports, "FaVolleyballBall", ()=>FaVolleyballBall);
parcelHelpers.export(exports, "FaVolumeDown", ()=>FaVolumeDown);
parcelHelpers.export(exports, "FaVolumeMute", ()=>FaVolumeMute);
parcelHelpers.export(exports, "FaVolumeOff", ()=>FaVolumeOff);
parcelHelpers.export(exports, "FaVolumeUp", ()=>FaVolumeUp);
parcelHelpers.export(exports, "FaVoteYea", ()=>FaVoteYea);
parcelHelpers.export(exports, "FaVrCardboard", ()=>FaVrCardboard);
parcelHelpers.export(exports, "FaWalking", ()=>FaWalking);
parcelHelpers.export(exports, "FaWallet", ()=>FaWallet);
parcelHelpers.export(exports, "FaWarehouse", ()=>FaWarehouse);
parcelHelpers.export(exports, "FaWater", ()=>FaWater);
parcelHelpers.export(exports, "FaWaveSquare", ()=>FaWaveSquare);
parcelHelpers.export(exports, "FaWeightHanging", ()=>FaWeightHanging);
parcelHelpers.export(exports, "FaWeight", ()=>FaWeight);
parcelHelpers.export(exports, "FaWheelchair", ()=>FaWheelchair);
parcelHelpers.export(exports, "FaWifi", ()=>FaWifi);
parcelHelpers.export(exports, "FaWind", ()=>FaWind);
parcelHelpers.export(exports, "FaWindowClose", ()=>FaWindowClose);
parcelHelpers.export(exports, "FaWindowMaximize", ()=>FaWindowMaximize);
parcelHelpers.export(exports, "FaWindowMinimize", ()=>FaWindowMinimize);
parcelHelpers.export(exports, "FaWindowRestore", ()=>FaWindowRestore);
parcelHelpers.export(exports, "FaWineBottle", ()=>FaWineBottle);
parcelHelpers.export(exports, "FaWineGlassAlt", ()=>FaWineGlassAlt);
parcelHelpers.export(exports, "FaWineGlass", ()=>FaWineGlass);
parcelHelpers.export(exports, "FaWonSign", ()=>FaWonSign);
parcelHelpers.export(exports, "FaWrench", ()=>FaWrench);
parcelHelpers.export(exports, "FaXRay", ()=>FaXRay);
parcelHelpers.export(exports, "FaYenSign", ()=>FaYenSign);
parcelHelpers.export(exports, "FaYinYang", ()=>FaYinYang);
parcelHelpers.export(exports, "FaRegAddressBook", ()=>FaRegAddressBook);
parcelHelpers.export(exports, "FaRegAddressCard", ()=>FaRegAddressCard);
parcelHelpers.export(exports, "FaRegAngry", ()=>FaRegAngry);
parcelHelpers.export(exports, "FaRegArrowAltCircleDown", ()=>FaRegArrowAltCircleDown);
parcelHelpers.export(exports, "FaRegArrowAltCircleLeft", ()=>FaRegArrowAltCircleLeft);
parcelHelpers.export(exports, "FaRegArrowAltCircleRight", ()=>FaRegArrowAltCircleRight);
parcelHelpers.export(exports, "FaRegArrowAltCircleUp", ()=>FaRegArrowAltCircleUp);
parcelHelpers.export(exports, "FaRegBellSlash", ()=>FaRegBellSlash);
parcelHelpers.export(exports, "FaRegBell", ()=>FaRegBell);
parcelHelpers.export(exports, "FaRegBookmark", ()=>FaRegBookmark);
parcelHelpers.export(exports, "FaRegBuilding", ()=>FaRegBuilding);
parcelHelpers.export(exports, "FaRegCalendarAlt", ()=>FaRegCalendarAlt);
parcelHelpers.export(exports, "FaRegCalendarCheck", ()=>FaRegCalendarCheck);
parcelHelpers.export(exports, "FaRegCalendarMinus", ()=>FaRegCalendarMinus);
parcelHelpers.export(exports, "FaRegCalendarPlus", ()=>FaRegCalendarPlus);
parcelHelpers.export(exports, "FaRegCalendarTimes", ()=>FaRegCalendarTimes);
parcelHelpers.export(exports, "FaRegCalendar", ()=>FaRegCalendar);
parcelHelpers.export(exports, "FaRegCaretSquareDown", ()=>FaRegCaretSquareDown);
parcelHelpers.export(exports, "FaRegCaretSquareLeft", ()=>FaRegCaretSquareLeft);
parcelHelpers.export(exports, "FaRegCaretSquareRight", ()=>FaRegCaretSquareRight);
parcelHelpers.export(exports, "FaRegCaretSquareUp", ()=>FaRegCaretSquareUp);
parcelHelpers.export(exports, "FaRegChartBar", ()=>FaRegChartBar);
parcelHelpers.export(exports, "FaRegCheckCircle", ()=>FaRegCheckCircle);
parcelHelpers.export(exports, "FaRegCheckSquare", ()=>FaRegCheckSquare);
parcelHelpers.export(exports, "FaRegCircle", ()=>FaRegCircle);
parcelHelpers.export(exports, "FaRegClipboard", ()=>FaRegClipboard);
parcelHelpers.export(exports, "FaRegClock", ()=>FaRegClock);
parcelHelpers.export(exports, "FaRegClone", ()=>FaRegClone);
parcelHelpers.export(exports, "FaRegClosedCaptioning", ()=>FaRegClosedCaptioning);
parcelHelpers.export(exports, "FaRegCommentAlt", ()=>FaRegCommentAlt);
parcelHelpers.export(exports, "FaRegCommentDots", ()=>FaRegCommentDots);
parcelHelpers.export(exports, "FaRegComment", ()=>FaRegComment);
parcelHelpers.export(exports, "FaRegComments", ()=>FaRegComments);
parcelHelpers.export(exports, "FaRegCompass", ()=>FaRegCompass);
parcelHelpers.export(exports, "FaRegCopy", ()=>FaRegCopy);
parcelHelpers.export(exports, "FaRegCopyright", ()=>FaRegCopyright);
parcelHelpers.export(exports, "FaRegCreditCard", ()=>FaRegCreditCard);
parcelHelpers.export(exports, "FaRegDizzy", ()=>FaRegDizzy);
parcelHelpers.export(exports, "FaRegDotCircle", ()=>FaRegDotCircle);
parcelHelpers.export(exports, "FaRegEdit", ()=>FaRegEdit);
parcelHelpers.export(exports, "FaRegEnvelopeOpen", ()=>FaRegEnvelopeOpen);
parcelHelpers.export(exports, "FaRegEnvelope", ()=>FaRegEnvelope);
parcelHelpers.export(exports, "FaRegEyeSlash", ()=>FaRegEyeSlash);
parcelHelpers.export(exports, "FaRegEye", ()=>FaRegEye);
parcelHelpers.export(exports, "FaRegFileAlt", ()=>FaRegFileAlt);
parcelHelpers.export(exports, "FaRegFileArchive", ()=>FaRegFileArchive);
parcelHelpers.export(exports, "FaRegFileAudio", ()=>FaRegFileAudio);
parcelHelpers.export(exports, "FaRegFileCode", ()=>FaRegFileCode);
parcelHelpers.export(exports, "FaRegFileExcel", ()=>FaRegFileExcel);
parcelHelpers.export(exports, "FaRegFileImage", ()=>FaRegFileImage);
parcelHelpers.export(exports, "FaRegFilePdf", ()=>FaRegFilePdf);
parcelHelpers.export(exports, "FaRegFilePowerpoint", ()=>FaRegFilePowerpoint);
parcelHelpers.export(exports, "FaRegFileVideo", ()=>FaRegFileVideo);
parcelHelpers.export(exports, "FaRegFileWord", ()=>FaRegFileWord);
parcelHelpers.export(exports, "FaRegFile", ()=>FaRegFile);
parcelHelpers.export(exports, "FaRegFlag", ()=>FaRegFlag);
parcelHelpers.export(exports, "FaRegFlushed", ()=>FaRegFlushed);
parcelHelpers.export(exports, "FaRegFolderOpen", ()=>FaRegFolderOpen);
parcelHelpers.export(exports, "FaRegFolder", ()=>FaRegFolder);
parcelHelpers.export(exports, "FaRegFontAwesomeLogoFull", ()=>FaRegFontAwesomeLogoFull);
parcelHelpers.export(exports, "FaRegFrownOpen", ()=>FaRegFrownOpen);
parcelHelpers.export(exports, "FaRegFrown", ()=>FaRegFrown);
parcelHelpers.export(exports, "FaRegFutbol", ()=>FaRegFutbol);
parcelHelpers.export(exports, "FaRegGem", ()=>FaRegGem);
parcelHelpers.export(exports, "FaRegGrimace", ()=>FaRegGrimace);
parcelHelpers.export(exports, "FaRegGrinAlt", ()=>FaRegGrinAlt);
parcelHelpers.export(exports, "FaRegGrinBeamSweat", ()=>FaRegGrinBeamSweat);
parcelHelpers.export(exports, "FaRegGrinBeam", ()=>FaRegGrinBeam);
parcelHelpers.export(exports, "FaRegGrinHearts", ()=>FaRegGrinHearts);
parcelHelpers.export(exports, "FaRegGrinSquintTears", ()=>FaRegGrinSquintTears);
parcelHelpers.export(exports, "FaRegGrinSquint", ()=>FaRegGrinSquint);
parcelHelpers.export(exports, "FaRegGrinStars", ()=>FaRegGrinStars);
parcelHelpers.export(exports, "FaRegGrinTears", ()=>FaRegGrinTears);
parcelHelpers.export(exports, "FaRegGrinTongueSquint", ()=>FaRegGrinTongueSquint);
parcelHelpers.export(exports, "FaRegGrinTongueWink", ()=>FaRegGrinTongueWink);
parcelHelpers.export(exports, "FaRegGrinTongue", ()=>FaRegGrinTongue);
parcelHelpers.export(exports, "FaRegGrinWink", ()=>FaRegGrinWink);
parcelHelpers.export(exports, "FaRegGrin", ()=>FaRegGrin);
parcelHelpers.export(exports, "FaRegHandLizard", ()=>FaRegHandLizard);
parcelHelpers.export(exports, "FaRegHandPaper", ()=>FaRegHandPaper);
parcelHelpers.export(exports, "FaRegHandPeace", ()=>FaRegHandPeace);
parcelHelpers.export(exports, "FaRegHandPointDown", ()=>FaRegHandPointDown);
parcelHelpers.export(exports, "FaRegHandPointLeft", ()=>FaRegHandPointLeft);
parcelHelpers.export(exports, "FaRegHandPointRight", ()=>FaRegHandPointRight);
parcelHelpers.export(exports, "FaRegHandPointUp", ()=>FaRegHandPointUp);
parcelHelpers.export(exports, "FaRegHandPointer", ()=>FaRegHandPointer);
parcelHelpers.export(exports, "FaRegHandRock", ()=>FaRegHandRock);
parcelHelpers.export(exports, "FaRegHandScissors", ()=>FaRegHandScissors);
parcelHelpers.export(exports, "FaRegHandSpock", ()=>FaRegHandSpock);
parcelHelpers.export(exports, "FaRegHandshake", ()=>FaRegHandshake);
parcelHelpers.export(exports, "FaRegHdd", ()=>FaRegHdd);
parcelHelpers.export(exports, "FaRegHeart", ()=>FaRegHeart);
parcelHelpers.export(exports, "FaRegHospital", ()=>FaRegHospital);
parcelHelpers.export(exports, "FaRegHourglass", ()=>FaRegHourglass);
parcelHelpers.export(exports, "FaRegIdBadge", ()=>FaRegIdBadge);
parcelHelpers.export(exports, "FaRegIdCard", ()=>FaRegIdCard);
parcelHelpers.export(exports, "FaRegImage", ()=>FaRegImage);
parcelHelpers.export(exports, "FaRegImages", ()=>FaRegImages);
parcelHelpers.export(exports, "FaRegKeyboard", ()=>FaRegKeyboard);
parcelHelpers.export(exports, "FaRegKissBeam", ()=>FaRegKissBeam);
parcelHelpers.export(exports, "FaRegKissWinkHeart", ()=>FaRegKissWinkHeart);
parcelHelpers.export(exports, "FaRegKiss", ()=>FaRegKiss);
parcelHelpers.export(exports, "FaRegLaughBeam", ()=>FaRegLaughBeam);
parcelHelpers.export(exports, "FaRegLaughSquint", ()=>FaRegLaughSquint);
parcelHelpers.export(exports, "FaRegLaughWink", ()=>FaRegLaughWink);
parcelHelpers.export(exports, "FaRegLaugh", ()=>FaRegLaugh);
parcelHelpers.export(exports, "FaRegLemon", ()=>FaRegLemon);
parcelHelpers.export(exports, "FaRegLifeRing", ()=>FaRegLifeRing);
parcelHelpers.export(exports, "FaRegLightbulb", ()=>FaRegLightbulb);
parcelHelpers.export(exports, "FaRegListAlt", ()=>FaRegListAlt);
parcelHelpers.export(exports, "FaRegMap", ()=>FaRegMap);
parcelHelpers.export(exports, "FaRegMehBlank", ()=>FaRegMehBlank);
parcelHelpers.export(exports, "FaRegMehRollingEyes", ()=>FaRegMehRollingEyes);
parcelHelpers.export(exports, "FaRegMeh", ()=>FaRegMeh);
parcelHelpers.export(exports, "FaRegMinusSquare", ()=>FaRegMinusSquare);
parcelHelpers.export(exports, "FaRegMoneyBillAlt", ()=>FaRegMoneyBillAlt);
parcelHelpers.export(exports, "FaRegMoon", ()=>FaRegMoon);
parcelHelpers.export(exports, "FaRegNewspaper", ()=>FaRegNewspaper);
parcelHelpers.export(exports, "FaRegObjectGroup", ()=>FaRegObjectGroup);
parcelHelpers.export(exports, "FaRegObjectUngroup", ()=>FaRegObjectUngroup);
parcelHelpers.export(exports, "FaRegPaperPlane", ()=>FaRegPaperPlane);
parcelHelpers.export(exports, "FaRegPauseCircle", ()=>FaRegPauseCircle);
parcelHelpers.export(exports, "FaRegPlayCircle", ()=>FaRegPlayCircle);
parcelHelpers.export(exports, "FaRegPlusSquare", ()=>FaRegPlusSquare);
parcelHelpers.export(exports, "FaRegQuestionCircle", ()=>FaRegQuestionCircle);
parcelHelpers.export(exports, "FaRegRegistered", ()=>FaRegRegistered);
parcelHelpers.export(exports, "FaRegSadCry", ()=>FaRegSadCry);
parcelHelpers.export(exports, "FaRegSadTear", ()=>FaRegSadTear);
parcelHelpers.export(exports, "FaRegSave", ()=>FaRegSave);
parcelHelpers.export(exports, "FaRegShareSquare", ()=>FaRegShareSquare);
parcelHelpers.export(exports, "FaRegSmileBeam", ()=>FaRegSmileBeam);
parcelHelpers.export(exports, "FaRegSmileWink", ()=>FaRegSmileWink);
parcelHelpers.export(exports, "FaRegSmile", ()=>FaRegSmile);
parcelHelpers.export(exports, "FaRegSnowflake", ()=>FaRegSnowflake);
parcelHelpers.export(exports, "FaRegSquare", ()=>FaRegSquare);
parcelHelpers.export(exports, "FaRegStarHalf", ()=>FaRegStarHalf);
parcelHelpers.export(exports, "FaRegStar", ()=>FaRegStar);
parcelHelpers.export(exports, "FaRegStickyNote", ()=>FaRegStickyNote);
parcelHelpers.export(exports, "FaRegStopCircle", ()=>FaRegStopCircle);
parcelHelpers.export(exports, "FaRegSun", ()=>FaRegSun);
parcelHelpers.export(exports, "FaRegSurprise", ()=>FaRegSurprise);
parcelHelpers.export(exports, "FaRegThumbsDown", ()=>FaRegThumbsDown);
parcelHelpers.export(exports, "FaRegThumbsUp", ()=>FaRegThumbsUp);
parcelHelpers.export(exports, "FaRegTimesCircle", ()=>FaRegTimesCircle);
parcelHelpers.export(exports, "FaRegTired", ()=>FaRegTired);
parcelHelpers.export(exports, "FaRegTrashAlt", ()=>FaRegTrashAlt);
parcelHelpers.export(exports, "FaRegUserCircle", ()=>FaRegUserCircle);
parcelHelpers.export(exports, "FaRegUser", ()=>FaRegUser);
parcelHelpers.export(exports, "FaRegWindowClose", ()=>FaRegWindowClose);
parcelHelpers.export(exports, "FaRegWindowMaximize", ()=>FaRegWindowMaximize);
parcelHelpers.export(exports, "FaRegWindowMinimize", ()=>FaRegWindowMinimize);
parcelHelpers.export(exports, "FaRegWindowRestore", ()=>FaRegWindowRestore);
var _lib = require("../lib");
function Fa500Px(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M103.3 344.3c-6.5-14.2-6.9-18.3 7.4-23.1 25.6-8 8 9.2 43.2 49.2h.3v-93.9c1.2-50.2 44-92.2 97.7-92.2 53.9 0 97.7 43.5 97.7 96.8 0 63.4-60.8 113.2-128.5 93.3-10.5-4.2-2.1-31.7 8.5-28.6 53 0 89.4-10.1 89.4-64.4 0-61-77.1-89.6-116.9-44.6-23.5 26.4-17.6 42.1-17.6 157.6 50.7 31 118.3 22 160.4-20.1 24.8-24.8 38.5-58 38.5-93 0-35.2-13.8-68.2-38.8-93.3-24.8-24.8-57.8-38.5-93.3-38.5s-68.8 13.8-93.5 38.5c-.3.3-16 16.5-21.2 23.9l-.5.6c-3.3 4.7-6.3 9.1-20.1 6.1-6.9-1.7-14.3-5.8-14.3-11.8V20c0-5 3.9-10.5 10.5-10.5h241.3c8.3 0 8.3 11.6 8.3 15.1 0 3.9 0 15.1-8.3 15.1H130.3v132.9h.3c104.2-109.8 282.8-36 282.8 108.9 0 178.1-244.8 220.3-310.1 62.8zm63.3-260.8c-.5 4.2 4.6 24.5 14.6 20.6C306 56.6 384 144.5 390.6 144.5c4.8 0 22.8-15.3 14.3-22.8-93.2-89-234.5-57-238.3-38.2zM393 414.7C283 524.6 94 475.5 61 310.5c0-12.2-30.4-7.4-28.9 3.3 24 173.4 246 256.9 381.6 121.3 6.9-7.8-12.6-28.4-20.7-20.4zM213.6 306.6c0 4 4.3 7.3 5.5 8.5 3 3 6.1 4.4 8.5 4.4 3.8 0 2.6.2 22.3-19.5 19.6 19.3 19.1 19.5 22.3 19.5 5.4 0 18.5-10.4 10.7-18.2L265.6 284l18.2-18.2c6.3-6.8-10.1-21.8-16.2-15.7L249.7 268c-18.6-18.8-18.4-19.5-21.5-19.5-5 0-18 11.7-12.4 17.3L234 284c-18.1 17.9-20.4 19.2-20.4 22.6z"
                }
            }
        ]
    })(props);
}
function FaAccessibleIcon(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M423.9 255.8L411 413.1c-3.3 40.7-63.9 35.1-60.6-4.9l10-122.5-41.1 2.3c10.1 20.7 15.8 43.9 15.8 68.5 0 41.2-16.1 78.7-42.3 106.5l-39.3-39.3c57.9-63.7 13.1-167.2-74-167.2-25.9 0-49.5 9.9-67.2 26L73 243.2c22-20.7 50.1-35.1 81.4-40.2l75.3-85.7-42.6-24.8-51.6 46c-30 26.8-70.6-18.5-40.5-45.4l68-60.7c9.8-8.8 24.1-10.2 35.5-3.6 0 0 139.3 80.9 139.5 81.1 16.2 10.1 20.7 36 6.1 52.6L285.7 229l106.1-5.9c18.5-1.1 33.6 14.4 32.1 32.7zm-64.9-154c28.1 0 50.9-22.8 50.9-50.9C409.9 22.8 387.1 0 359 0c-28.1 0-50.9 22.8-50.9 50.9 0 28.1 22.8 50.9 50.9 50.9zM179.6 456.5c-80.6 0-127.4-90.6-82.7-156.1l-39.7-39.7C36.4 287 24 320.3 24 356.4c0 130.7 150.7 201.4 251.4 122.5l-39.7-39.7c-16 10.9-35.3 17.3-56.1 17.3z"
                }
            }
        ]
    })(props);
}
function FaAccusoft(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M322.1 252v-1l-51.2-65.8s-12 1.6-25 15.1c-9 9.3-242.1 239.1-243.4 240.9-7 10 1.6 6.8 15.7 1.7.8 0 114.5-36.6 114.5-36.6.5-.6-.1-.1.6-.6-.4-5.1-.8-26.2-1-27.7-.6-5.2 2.2-6.9 7-8.9l92.6-33.8c.6-.8 88.5-81.7 90.2-83.3zm160.1 120.1c13.3 16.1 20.7 13.3 30.8 9.3 3.2-1.2 115.4-47.6 117.8-48.9 8-4.3-1.7-16.7-7.2-23.4-2.1-2.5-205.1-245.6-207.2-248.3-9.7-12.2-14.3-12.9-38.4-12.8-10.2 0-106.8.5-116.5.6-19.2.1-32.9-.3-19.2 16.9C250 75 476.5 365.2 482.2 372.1zm152.7 1.6c-2.3-.3-24.6-4.7-38-7.2 0 0-115 50.4-117.5 51.6-16 7.3-26.9-3.2-36.7-14.6l-57.1-74c-5.4-.9-60.4-9.6-65.3-9.3-3.1.2-9.6.8-14.4 2.9-4.9 2.1-145.2 52.8-150.2 54.7-5.1 2-11.4 3.6-11.1 7.6.2 2.5 2 2.6 4.6 3.5 2.7.8 300.9 67.6 308 69.1 15.6 3.3 38.5 10.5 53.6 1.7 2.1-1.2 123.8-76.4 125.8-77.8 5.4-4 4.3-6.8-1.7-8.2z"
                }
            }
        ]
    })(props);
}
function FaAcquisitionsIncorporated(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M357.45 468.2c-1.2-7.7-1.3-7.6-9.6-7.6-99.8.2-111.8-2.4-112.7-2.6-12.3-1.7-20.6-10.5-21-23.1-.1-1.6-.2-71.6-1-129.1-.1-4.7 1.6-6.4 5.9-7.5 12.5-3 24.9-6.1 37.3-9.7 4.3-1.3 6.8-.2 8.4 3.5 4.5 10.3 8.8 20.6 13.2 30.9 1.6 3.7.1 4.4-3.4 4.4-10-.2-20-.1-30.4-.1v27h116c-1.4-9.5-2.7-18.1-4-27.5-7 0-13.8.4-20.4-.1-22.6-1.6-18.3-4.4-84-158.6-8.8-20.1-27.9-62.1-36.5-89.2-4.4-14 5.5-25.4 18.9-26.6 18.6-1.7 37.5-1.6 56.2-2 20.6-.4 41.2-.4 61.8-.5 3.1 0 4-1.4 4.3-4.3 1.2-9.8 2.7-19.5 4-29.2.8-5.3 1.6-10.7 2.4-16.1L23.75 0c-3.6 0-5.3 1.1-4.6 5.3 2.2 13.2-.8.8 6.4 45.3 63.4 0 71.8.9 101.8.5 12.3-.2 37 3.5 37.7 22.1.4 11.4-1.1 11.3-32.6 87.4-53.8 129.8-50.7 120.3-67.3 161-1.7 4.1-3.6 5.2-7.6 5.2-8.5-.2-17-.3-25.4.1-1.9.1-5.2 1.8-5.5 3.2-1.5 8.1-2.2 16.3-3.2 24.9h114.3v-27.6c-6.9 0-33.5.4-35.3-2.9 5.3-12.3 10.4-24.4 15.7-36.7 16.3 4 31.9 7.8 47.6 11.7 3.4.9 4.6 3 4.6 6.8-.1 42.9.1 85.9.2 128.8 0 10.2-5.5 19.1-14.9 23.1-6.5 2.7-3.3 3.4-121.4 2.4-5.3 0-7.1 2-7.6 6.8-1.5 12.9-2.9 25.9-5 38.8-.8 5 1.3 5.7 5.3 5.7 183.2.6-30.7 0 337.1 0-2.5-15-4.4-29.4-6.6-43.7zm-174.9-205.7c-13.3-4.2-26.6-8.2-39.9-12.5a44.53 44.53 0 0 1-5.8-2.9c17.2-44.3 34.2-88.1 51.3-132.1 7.5 2.4 7.9-.8 9.4 0 9.3 22.5 18.1 60.1 27 82.8 6.6 16.7 13 33.5 19.7 50.9a35.78 35.78 0 0 1-3.9 2.1c-13.1 3.9-26.4 7.5-39.4 11.7a27.66 27.66 0 0 1-18.4 0z"
                }
            }
        ]
    })(props);
}
function FaAdn(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 167.5l64.9 98.8H183.1l64.9-98.8zM496 256c0 136.9-111.1 248-248 248S0 392.9 0 256 111.1 8 248 8s248 111.1 248 248zm-99.8 82.7L248 115.5 99.8 338.7h30.4l33.6-51.7h168.6l33.6 51.7h30.2z"
                }
            }
        ]
    })(props);
}
function FaAdversal(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M482.1 32H28.7C5.8 32 0 37.9 0 60.9v390.2C0 474.4 5.8 480 28.7 480h453.4c24.4 0 29.9-5.2 29.9-29.7V62.2c0-24.6-5.4-30.2-29.9-30.2zM178.4 220.3c-27.5-20.2-72.1-8.7-84.2 23.4-4.3 11.1-9.3 9.5-17.5 8.3-9.7-1.5-17.2-3.2-22.5-5.5-28.8-11.4 8.6-55.3 24.9-64.3 41.1-21.4 83.4-22.2 125.3-4.8 40.9 16.8 34.5 59.2 34.5 128.5 2.7 25.8-4.3 58.3 9.3 88.8 1.9 4.4.4 7.9-2.7 10.7-8.4 6.7-39.3 2.2-46.6-7.4-1.9-2.2-1.8-3.6-3.9-6.2-3.6-3.9-7.3-2.2-11.9 1-57.4 36.4-140.3 21.4-147-43.3-3.1-29.3 12.4-57.1 39.6-71 38.2-19.5 112.2-11.8 114-30.9 1.1-10.2-1.9-20.1-11.3-27.3zm286.7 222c0 15.1-11.1 9.9-17.8 9.9H52.4c-7.4 0-18.2 4.8-17.8-10.7.4-13.9 10.5-9.1 17.1-9.1 132.3-.4 264.5-.4 396.8 0 6.8 0 16.6-4.4 16.6 9.9zm3.8-340.5v291c0 5.7-.7 13.9-8.1 13.9-12.4-.4-27.5 7.1-36.1-5.6-5.8-8.7-7.8-4-12.4-1.2-53.4 29.7-128.1 7.1-144.4-85.2-6.1-33.4-.7-67.1 15.7-100 11.8-23.9 56.9-76.1 136.1-30.5v-71c0-26.2-.1-26.2 26-26.2 3.1 0 6.6.4 9.7 0 10.1-.8 13.6 4.4 13.6 14.3-.1.2-.1.3-.1.5zm-51.5 232.3c-19.5 47.6-72.9 43.3-90 5.2-15.1-33.3-15.5-68.2.4-101.5 16.3-34.1 59.7-35.7 81.5-4.8 20.6 28.8 14.9 84.6 8.1 101.1zm-294.8 35.3c-7.5-1.3-33-3.3-33.7-27.8-.4-13.9 7.8-23 19.8-25.8 24.4-5.9 49.3-9.9 73.7-14.7 8.9-2 7.4 4.4 7.8 9.5 1.4 33-26.1 59.2-67.6 58.8z"
                }
            }
        ]
    })(props);
}
function FaAffiliatetheme(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M159.7 237.4C108.4 308.3 43.1 348.2 14 326.6-15.2 304.9 2.8 230 54.2 159.1c51.3-70.9 116.6-110.8 145.7-89.2 29.1 21.6 11.1 96.6-40.2 167.5zm351.2-57.3C437.1 303.5 319 367.8 246.4 323.7c-25-15.2-41.3-41.2-49-73.8-33.6 64.8-92.8 113.8-164.1 133.2 49.8 59.3 124.1 96.9 207 96.9 150 0 271.6-123.1 271.6-274.9.1-8.5-.3-16.8-1-25z"
                }
            }
        ]
    })(props);
}
function FaAirbnb(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M224 373.12c-25.24-31.67-40.08-59.43-45-83.18-22.55-88 112.61-88 90.06 0-5.45 24.25-20.29 52-45 83.18zm138.15 73.23c-42.06 18.31-83.67-10.88-119.3-50.47 103.9-130.07 46.11-200-18.85-200-54.92 0-85.16 46.51-73.28 100.5 6.93 29.19 25.23 62.39 54.43 99.5-32.53 36.05-60.55 52.69-85.15 54.92-50 7.43-89.11-41.06-71.3-91.09 15.1-39.16 111.72-231.18 115.87-241.56 15.75-30.07 25.56-57.4 59.38-57.4 32.34 0 43.4 25.94 60.37 59.87 36 70.62 89.35 177.48 114.84 239.09 13.17 33.07-1.37 71.29-37.01 86.64zm47-136.12C280.27 35.93 273.13 32 224 32c-45.52 0-64.87 31.67-84.66 72.79C33.18 317.1 22.89 347.19 22 349.81-3.22 419.14 48.74 480 111.63 480c21.71 0 60.61-6.06 112.37-62.4 58.68 63.78 101.26 62.4 112.37 62.4 62.89.05 114.85-60.86 89.61-130.19.02-3.89-16.82-38.9-16.82-39.58z"
                }
            }
        ]
    })(props);
}
function FaAlgolia(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M229.3 182.6c-49.3 0-89.2 39.9-89.2 89.2 0 49.3 39.9 89.2 89.2 89.2s89.2-39.9 89.2-89.2c0-49.3-40-89.2-89.2-89.2zm62.7 56.6l-58.9 30.6c-1.8.9-3.8-.4-3.8-2.3V201c0-1.5 1.3-2.7 2.7-2.6 26.2 1 48.9 15.7 61.1 37.1.7 1.3.2 3-1.1 3.7zM389.1 32H58.9C26.4 32 0 58.4 0 90.9V421c0 32.6 26.4 59 58.9 59H389c32.6 0 58.9-26.4 58.9-58.9V90.9C448 58.4 421.6 32 389.1 32zm-202.6 84.7c0-10.8 8.7-19.5 19.5-19.5h45.3c10.8 0 19.5 8.7 19.5 19.5v15.4c0 1.8-1.7 3-3.3 2.5-12.3-3.4-25.1-5.1-38.1-5.1-13.5 0-26.7 1.8-39.4 5.5-1.7.5-3.4-.8-3.4-2.5v-15.8zm-84.4 37l9.2-9.2c7.6-7.6 19.9-7.6 27.5 0l7.7 7.7c1.1 1.1 1 3-.3 4-6.2 4.5-12.1 9.4-17.6 14.9-5.4 5.4-10.4 11.3-14.8 17.4-1 1.3-2.9 1.5-4 .3l-7.7-7.7c-7.6-7.5-7.6-19.8 0-27.4zm127.2 244.8c-70 0-126.6-56.7-126.6-126.6s56.7-126.6 126.6-126.6c70 0 126.6 56.6 126.6 126.6 0 69.8-56.7 126.6-126.6 126.6z"
                }
            }
        ]
    })(props);
}
function FaAlipay(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M377.74 32H70.26C31.41 32 0 63.41 0 102.26v307.48C0 448.59 31.41 480 70.26 480h307.48c38.52 0 69.76-31.08 70.26-69.6-45.96-25.62-110.59-60.34-171.6-88.44-32.07 43.97-84.14 81-148.62 81-70.59 0-93.73-45.3-97.04-76.37-3.97-39.01 14.88-81.5 99.52-81.5 35.38 0 79.35 10.25 127.13 24.96 16.53-30.09 26.45-60.34 26.45-60.34h-178.2v-16.7h92.08v-31.24H88.28v-19.01h109.44V92.34h50.92v50.42h109.44v19.01H248.63v31.24h88.77s-15.21 46.62-38.35 90.92c48.93 16.7 100.01 36.04 148.62 52.74V102.26C447.83 63.57 416.43 32 377.74 32zM47.28 322.95c.99 20.17 10.25 53.73 69.93 53.73 52.07 0 92.58-39.68 117.87-72.9-44.63-18.68-84.48-31.41-109.44-31.41-67.45 0-79.35 33.06-78.36 50.58z"
                }
            }
        ]
    })(props);
}
function FaAmazonPay(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14 325.3c2.3-4.2 5.2-4.9 9.7-2.5 10.4 5.6 20.6 11.4 31.2 16.7a595.88 595.88 0 0 0 127.4 46.3 616.61 616.61 0 0 0 63.2 11.8 603.33 603.33 0 0 0 95 5.2c17.4-.4 34.8-1.8 52.1-3.8a603.66 603.66 0 0 0 163.3-42.8c2.9-1.2 5.9-2 9.1-1.2 6.7 1.8 9 9 4.1 13.9a70 70 0 0 1-9.6 7.4c-30.7 21.1-64.2 36.4-99.6 47.9a473.31 473.31 0 0 1-75.1 17.6 431 431 0 0 1-53.2 4.8 21.3 21.3 0 0 0-2.5.3H308a21.3 21.3 0 0 0-2.5-.3c-3.6-.2-7.2-.3-10.7-.4a426.3 426.3 0 0 1-50.4-5.3A448.4 448.4 0 0 1 164 420a443.33 443.33 0 0 1-145.6-87c-1.8-1.6-3-3.8-4.4-5.7zM172 65.1l-4.3.6a80.92 80.92 0 0 0-38 15.1c-2.4 1.7-4.6 3.5-7.1 5.4a4.29 4.29 0 0 1-.4-1.4c-.4-2.7-.8-5.5-1.3-8.2-.7-4.6-3-6.6-7.6-6.6h-11.5c-6.9 0-8.2 1.3-8.2 8.2v209.3c0 1 0 2 .1 3 .2 3 2 4.9 4.9 5 7 .1 14.1.1 21.1 0 2.9 0 4.7-2 5-5 .1-1 .1-2 .1-3v-72.4c1.1.9 1.7 1.4 2.2 1.9 17.9 14.9 38.5 19.8 61 15.4 20.4-4 34.6-16.5 43.8-34.9 7-13.9 9.9-28.7 10.3-44.1.5-17.1-1.2-33.9-8.1-49.8-8.5-19.6-22.6-32.5-43.9-36.9-3.2-.7-6.5-1-9.8-1.5-2.8-.1-5.5-.1-8.3-.1zM124.6 107a3.48 3.48 0 0 1 1.7-3.3c13.7-9.5 28.8-14.5 45.6-13.2 14.9 1.1 27.1 8.4 33.5 25.9 3.9 10.7 4.9 21.8 4.9 33 0 10.4-.8 20.6-4 30.6-6.8 21.3-22.4 29.4-42.6 28.5-14-.6-26.2-6-37.4-13.9a3.57 3.57 0 0 1-1.7-3.3c.1-14.1 0-28.1 0-42.2s.1-28 0-42.1zm205.7-41.9c-1 .1-2 .3-2.9.4a148 148 0 0 0-28.9 4.1c-6.1 1.6-12 3.8-17.9 5.8-3.6 1.2-5.4 3.8-5.3 7.7.1 3.3-.1 6.6 0 9.9.1 4.8 2.1 6.1 6.8 4.9 7.8-2 15.6-4.2 23.5-5.7 12.3-2.3 24.7-3.3 37.2-1.4 6.5 1 12.6 2.9 16.8 8.4 3.7 4.8 5.1 10.5 5.3 16.4.3 8.3.2 16.6.3 24.9a7.84 7.84 0 0 1-.2 1.4c-.5-.1-.9 0-1.3-.1a180.56 180.56 0 0 0-32-4.9c-11.3-.6-22.5.1-33.3 3.9-12.9 4.5-23.3 12.3-29.4 24.9-4.7 9.8-5.4 20.2-3.9 30.7 2 14 9 24.8 21.4 31.7 11.9 6.6 24.8 7.4 37.9 5.4 15.1-2.3 28.5-8.7 40.3-18.4a7.36 7.36 0 0 1 1.6-1.1c.6 3.8 1.1 7.4 1.8 11 .6 3.1 2.5 5.1 5.4 5.2 5.4.1 10.9.1 16.3 0a4.84 4.84 0 0 0 4.8-4.7 26.2 26.2 0 0 0 .1-2.8v-106a80 80 0 0 0-.9-12.9c-1.9-12.9-7.4-23.5-19-30.4-6.7-4-14.1-6-21.8-7.1-3.6-.5-7.2-.8-10.8-1.3-3.9.1-7.9.1-11.9.1zm35 127.7a3.33 3.33 0 0 1-1.5 3c-11.2 8.1-23.5 13.5-37.4 14.9-5.7.6-11.4.4-16.8-1.8a20.08 20.08 0 0 1-12.4-13.3 32.9 32.9 0 0 1-.1-19.4c2.5-8.3 8.4-13 16.4-15.6a61.33 61.33 0 0 1 24.8-2.2c8.4.7 16.6 2.3 25 3.4 1.6.2 2.1 1 2.1 2.6-.1 4.8 0 9.5 0 14.3s-.2 9.4-.1 14.1zm259.9 129.4c-1-5-4.8-6.9-9.1-8.3a88.42 88.42 0 0 0-21-3.9 147.32 147.32 0 0 0-39.2 1.9c-14.3 2.7-27.9 7.3-40 15.6a13.75 13.75 0 0 0-3.7 3.5 5.11 5.11 0 0 0-.5 4c.4 1.5 2.1 1.9 3.6 1.8a16.2 16.2 0 0 0 2.2-.1c7.8-.8 15.5-1.7 23.3-2.5 11.4-1.1 22.9-1.8 34.3-.9a71.64 71.64 0 0 1 14.4 2.7c5.1 1.4 7.4 5.2 7.6 10.4.4 8-1.4 15.7-3.5 23.3-4.1 15.4-10 30.3-15.8 45.1a17.6 17.6 0 0 0-1 3c-.5 2.9 1.2 4.8 4.1 4.1a10.56 10.56 0 0 0 4.8-2.5 145.91 145.91 0 0 0 12.7-13.4c12.8-16.4 20.3-35.3 24.7-55.6.8-3.6 1.4-7.3 2.1-10.9v-17.3zM493.1 199q-19.35-53.55-38.7-107.2c-2-5.7-4.2-11.3-6.3-16.9-1.1-2.9-3.2-4.8-6.4-4.8-7.6-.1-15.2-.2-22.9-.1-2.5 0-3.7 2-3.2 4.5a43.1 43.1 0 0 0 1.9 6.1q29.4 72.75 59.1 145.5c1.7 4.1 2.1 7.6.2 11.8-3.3 7.3-5.9 15-9.3 22.3-3 6.5-8 11.4-15.2 13.3a42.13 42.13 0 0 1-15.4 1.1c-2.5-.2-5-.8-7.5-1-3.4-.2-5.1 1.3-5.2 4.8q-.15 5 0 9.9c.1 5.5 2 8 7.4 8.9a108.18 108.18 0 0 0 16.9 2c17.1.4 30.7-6.5 39.5-21.4a131.63 131.63 0 0 0 9.2-18.4q35.55-89.7 70.6-179.6a26.62 26.62 0 0 0 1.6-5.5c.4-2.8-.9-4.4-3.7-4.4-6.6-.1-13.3 0-19.9 0a7.54 7.54 0 0 0-7.7 5.2c-.5 1.4-1.1 2.7-1.6 4.1l-34.8 100c-2.5 7.2-5.1 14.5-7.7 22.2-.4-1.1-.6-1.7-.9-2.4z"
                }
            }
        ]
    })(props);
}
function FaAmazon(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M257.2 162.7c-48.7 1.8-169.5 15.5-169.5 117.5 0 109.5 138.3 114 183.5 43.2 6.5 10.2 35.4 37.5 45.3 46.8l56.8-56S341 288.9 341 261.4V114.3C341 89 316.5 32 228.7 32 140.7 32 94 87 94 136.3l73.5 6.8c16.3-49.5 54.2-49.5 54.2-49.5 40.7-.1 35.5 29.8 35.5 69.1zm0 86.8c0 80-84.2 68-84.2 17.2 0-47.2 50.5-56.7 84.2-57.8v40.6zm136 163.5c-7.7 10-70 67-174.5 67S34.2 408.5 9.7 379c-6.8-7.7 1-11.3 5.5-8.3C88.5 415.2 203 488.5 387.7 401c7.5-3.7 13.3 2 5.5 12zm39.8 2.2c-6.5 15.8-16 26.8-21.2 31-5.5 4.5-9.5 2.7-6.5-3.8s19.3-46.5 12.7-55c-6.5-8.3-37-4.3-48-3.2-10.8 1-13 2-14-.3-2.3-5.7 21.7-15.5 37.5-17.5 15.7-1.8 41-.8 46 5.7 3.7 5.1 0 27.1-6.5 43.1z"
                }
            }
        ]
    })(props);
}
function FaAmilia(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M240.1 32c-61.9 0-131.5 16.9-184.2 55.4-5.1 3.1-9.1 9.2-7.2 19.4 1.1 5.1 5.1 27.4 10.2 39.6 4.1 10.2 14.2 10.2 20.3 6.1 32.5-22.3 96.5-47.7 152.3-47.7 57.9 0 58.9 28.4 58.9 73.1v38.5C203 227.7 78.2 251 46.7 264.2 11.2 280.5 16.3 357.7 16.3 376s15.2 104 124.9 104c47.8 0 113.7-20.7 153.3-42.1v25.4c0 3 2.1 8.2 6.1 9.1 3.1 1 50.7 2 59.9 2s62.5.3 66.5-.7c4.1-1 5.1-6.1 5.1-9.1V168c-.1-80.3-57.9-136-192-136zm50.2 348c-21.4 13.2-48.7 24.4-79.1 24.4-52.8 0-58.9-33.5-59-44.7 0-12.2-3-42.7 18.3-52.9 24.3-13.2 75.1-29.4 119.8-33.5z"
                }
            }
        ]
    })(props);
}
function FaAndroid(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M420.55,301.93a24,24,0,1,1,24-24,24,24,0,0,1-24,24m-265.1,0a24,24,0,1,1,24-24,24,24,0,0,1-24,24m273.7-144.48,47.94-83a10,10,0,1,0-17.27-10h0l-48.54,84.07a301.25,301.25,0,0,0-246.56,0L116.18,64.45a10,10,0,1,0-17.27,10h0l47.94,83C64.53,202.22,8.24,285.55,0,384H576c-8.24-98.45-64.54-181.78-146.85-226.55"
                }
            }
        ]
    })(props);
}
function FaAngellist(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M347.1 215.4c11.7-32.6 45.4-126.9 45.4-157.1 0-26.6-15.7-48.9-43.7-48.9-44.6 0-84.6 131.7-97.1 163.1C242 144 196.6 0 156.6 0c-31.1 0-45.7 22.9-45.7 51.7 0 35.3 34.2 126.8 46.6 162-6.3-2.3-13.1-4.3-20-4.3-23.4 0-48.3 29.1-48.3 52.6 0 8.9 4.9 21.4 8 29.7-36.9 10-51.1 34.6-51.1 71.7C46 435.6 114.4 512 210.6 512c118 0 191.4-88.6 191.4-202.9 0-43.1-6.9-82-54.9-93.7zM311.7 108c4-12.3 21.1-64.3 37.1-64.3 8.6 0 10.9 8.9 10.9 16 0 19.1-38.6 124.6-47.1 148l-34-6 33.1-93.7zM142.3 48.3c0-11.9 14.5-45.7 46.3 47.1l34.6 100.3c-15.6-1.3-27.7-3-35.4 1.4-10.9-28.8-45.5-119.7-45.5-148.8zM140 244c29.3 0 67.1 94.6 67.1 107.4 0 5.1-4.9 11.4-10.6 11.4-20.9 0-76.9-76.9-76.9-97.7.1-7.7 12.7-21.1 20.4-21.1zm184.3 186.3c-29.1 32-66.3 48.6-109.7 48.6-59.4 0-106.3-32.6-128.9-88.3-17.1-43.4 3.8-68.3 20.6-68.3 11.4 0 54.3 60.3 54.3 73.1 0 4.9-7.7 8.3-11.7 8.3-16.1 0-22.4-15.5-51.1-51.4-29.7 29.7 20.5 86.9 58.3 86.9 26.1 0 43.1-24.2 38-42 3.7 0 8.3.3 11.7-.6 1.1 27.1 9.1 59.4 41.7 61.7 0-.9 2-7.1 2-7.4 0-17.4-10.6-32.6-10.6-50.3 0-28.3 21.7-55.7 43.7-71.7 8-6 17.7-9.7 27.1-13.1 9.7-3.7 20-8 27.4-15.4-1.1-11.2-5.7-21.1-16.9-21.1-27.7 0-120.6 4-120.6-39.7 0-6.7.1-13.1 17.4-13.1 32.3 0 114.3 8 138.3 29.1 18.1 16.1 24.3 113.2-31 174.7zm-98.6-126c9.7 3.1 19.7 4 29.7 6-7.4 5.4-14 12-20.3 19.1-2.8-8.5-6.2-16.8-9.4-25.1z"
                }
            }
        ]
    })(props);
}
function FaAngrycreative(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M640 238.2l-3.2 28.2-34.5 2.3-2 18.1 34.5-2.3-3.2 28.2-34.4 2.2-2.3 20.1 34.4-2.2-3 26.1-64.7 4.1 12.7-113.2L527 365.2l-31.9 2-23.8-117.8 30.3-2 13.6 79.4 31.7-82.4 93.1-6.2zM426.8 371.5l28.3-1.8L468 249.6l-28.4 1.9-12.8 120zM162 388.1l-19.4-36-3.5 37.4-28.2 1.7 2.7-29.1c-11 18-32 34.3-56.9 35.8C23.9 399.9-3 377 .3 339.7c2.6-29.3 26.7-62.8 67.5-65.4 37.7-2.4 47.6 23.2 51.3 28.8l2.8-30.8 38.9-2.5c20.1-1.3 38.7 3.7 42.5 23.7l2.6-26.6 64.8-4.2-2.7 27.9-36.4 2.4-1.7 17.9 36.4-2.3-2.7 27.9-36.4 2.3-1.9 19.9 36.3-2.3-2.1 20.8 55-117.2 23.8-1.6L370.4 369l8.9-85.6-22.3 1.4 2.9-27.9 75-4.9-3 28-24.3 1.6-9.7 91.9-58 3.7-4.3-15.6-39.4 2.5-8 16.3-126.2 7.7zm-44.3-70.2l-26.4 1.7C84.6 307.2 76.9 303 65 303.8c-19 1.2-33.3 17.5-34.6 33.3-1.4 16 7.3 32.5 28.7 31.2 12.8-.8 21.3-8.6 28.9-18.9l27-1.7 2.7-29.8zm56.1-7.7c1.2-12.9-7.6-13.6-26.1-12.4l-2.7 28.5c14.2-.9 27.5-2.1 28.8-16.1zm21.1 70.8l5.8-60c-5 13.5-14.7 21.1-27.9 26.6l22.1 33.4zm135.4-45l-7.9-37.8-15.8 39.3 23.7-1.5zm-170.1-74.6l-4.3-17.5-39.6 2.6-8.1 18.2-31.9 2.1 57-121.9 23.9-1.6 30.7 102 9.9-104.7 27-1.8 37.8 63.6 6.5-66.6 28.5-1.9-4 41.2c7.4-13.5 22.9-44.7 63.6-47.5 40.5-2.8 52.4 29.3 53.4 30.3l3.3-32 39.3-2.7c12.7-.9 27.8.3 36.3 9.7l-4.4-11.9 32.2-2.2 12.9 43.2 23-45.7 31-2.2-43.6 78.4-4.8 44.3-28.4 1.9 4.8-44.3-15.8-43c1 22.3-9.2 40.1-32 49.6l25.2 38.8-36.4 2.4-19.2-36.8-4 38.3-28.4 1.9 3.3-31.5c-6.7 9.3-19.7 35.4-59.6 38-26.2 1.7-45.6-10.3-55.4-39.2l-4 40.3-25 1.6-37.6-63.3-6.3 66.2-56.8 3.7zm276.6-82.1c10.2-.7 17.5-2.1 21.6-4.3 4.5-2.4 7-6.4 7.6-12.1.6-5.3-.6-8.8-3.4-10.4-3.6-2.1-10.6-2.8-22.9-2l-2.9 28.8zM327.7 214c5.6 5.9 12.7 8.5 21.3 7.9 4.7-.3 9.1-1.8 13.3-4.1 5.5-3 10.6-8 15.1-14.3l-34.2 2.3 2.4-23.9 63.1-4.3 1.2-12-31.2 2.1c-4.1-3.7-7.8-6.6-11.1-8.1-4-1.7-8.1-2.8-12.2-2.5-8 .5-15.3 3.6-22 9.2-7.7 6.4-12 14.5-12.9 24.4-1.1 9.6 1.4 17.3 7.2 23.3zm-201.3 8.2l23.8-1.6-8.3-37.6-15.5 39.2z"
                }
            }
        ]
    })(props);
}
function FaAngular(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M185.7 268.1h76.2l-38.1-91.6-38.1 91.6zM223.8 32L16 106.4l31.8 275.7 176 97.9 176-97.9 31.8-275.7zM354 373.8h-48.6l-26.2-65.4H168.6l-26.2 65.4H93.7L223.8 81.5z"
                }
            }
        ]
    })(props);
}
function FaAppStoreIos(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zM127 384.5c-5.5 9.6-17.8 12.8-27.3 7.3-9.6-5.5-12.8-17.8-7.3-27.3l14.3-24.7c16.1-4.9 29.3-1.1 39.6 11.4L127 384.5zm138.9-53.9H84c-11 0-20-9-20-20s9-20 20-20h51l65.4-113.2-20.5-35.4c-5.5-9.6-2.2-21.8 7.3-27.3 9.6-5.5 21.8-2.2 27.3 7.3l8.9 15.4 8.9-15.4c5.5-9.6 17.8-12.8 27.3-7.3 9.6 5.5 12.8 17.8 7.3 27.3l-85.8 148.6h62.1c20.2 0 31.5 23.7 22.7 40zm98.1 0h-29l19.6 33.9c5.5 9.6 2.2 21.8-7.3 27.3-9.6 5.5-21.8 2.2-27.3-7.3-32.9-56.9-57.5-99.7-74-128.1-16.7-29-4.8-58 7.1-67.8 13.1 22.7 32.7 56.7 58.9 102h52c11 0 20 9 20 20 0 11.1-9 20-20 20z"
                }
            }
        ]
    })(props);
}
function FaAppStore(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M255.9 120.9l9.1-15.7c5.6-9.8 18.1-13.1 27.9-7.5 9.8 5.6 13.1 18.1 7.5 27.9l-87.5 151.5h63.3c20.5 0 32 24.1 23.1 40.8H113.8c-11.3 0-20.4-9.1-20.4-20.4 0-11.3 9.1-20.4 20.4-20.4h52l66.6-115.4-20.8-36.1c-5.6-9.8-2.3-22.2 7.5-27.9 9.8-5.6 22.2-2.3 27.9 7.5l8.9 15.7zm-78.7 218l-19.6 34c-5.6 9.8-18.1 13.1-27.9 7.5-9.8-5.6-13.1-18.1-7.5-27.9l14.6-25.2c16.4-5.1 29.8-1.2 40.4 11.6zm168.9-61.7h53.1c11.3 0 20.4 9.1 20.4 20.4 0 11.3-9.1 20.4-20.4 20.4h-29.5l19.9 34.5c5.6 9.8 2.3 22.2-7.5 27.9-9.8 5.6-22.2 2.3-27.9-7.5-33.5-58.1-58.7-101.6-75.4-130.6-17.1-29.5-4.9-59.1 7.2-69.1 13.4 23 33.4 57.7 60.1 104zM256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm216 248c0 118.7-96.1 216-216 216-118.7 0-216-96.1-216-216 0-118.7 96.1-216 216-216 118.7 0 216 96.1 216 216z"
                }
            }
        ]
    })(props);
}
function FaApper(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M42.1 239.1c22.2 0 29 2.8 33.5 14.6h.8v-22.9c0-11.3-4.8-15.4-17.9-15.4-11.3 0-14.4 2.5-15.1 12.8H4.8c.3-13.9 1.5-19.1 5.8-24.4C17.9 195 29.5 192 56.7 192c33 0 47.1 5 53.9 18.9 2 4.3 4 15.6 4 23.7v76.3H76.3l1.3-19.1h-1c-5.3 15.6-13.6 20.4-35.5 20.4-30.3 0-41.1-10.1-41.1-37.3 0-25.2 12.3-35.8 42.1-35.8zm17.1 48.1c13.1 0 16.9-3 16.9-13.4 0-9.1-4.3-11.6-19.6-11.6-13.1 0-17.9 3-17.9 12.1-.1 10.4 3.7 12.9 20.6 12.9zm77.8-94.9h38.3l-1.5 20.6h.8c9.1-17.1 15.9-20.9 37.5-20.9 14.4 0 24.7 3 31.5 9.1 9.8 8.6 12.8 20.4 12.8 48.1 0 30-3 43.1-12.1 52.9-6.8 7.3-16.4 10.1-33.2 10.1-20.4 0-29.2-5.5-33.8-21.2h-.8v70.3H137v-169zm80.9 60.7c0-27.5-3.3-32.5-20.7-32.5-16.9 0-20.7 5-20.7 28.7 0 28 3.5 33.5 21.2 33.5 16.4 0 20.2-5.6 20.2-29.7zm57.9-60.7h38.3l-1.5 20.6h.8c9.1-17.1 15.9-20.9 37.5-20.9 14.4 0 24.7 3 31.5 9.1 9.8 8.6 12.8 20.4 12.8 48.1 0 30-3 43.1-12.1 52.9-6.8 7.3-16.4 10.1-33.3 10.1-20.4 0-29.2-5.5-33.8-21.2h-.8v70.3h-39.5v-169zm80.9 60.7c0-27.5-3.3-32.5-20.7-32.5-16.9 0-20.7 5-20.7 28.7 0 28 3.5 33.5 21.2 33.5 16.4 0 20.2-5.6 20.2-29.7zm53.8-3.8c0-25.4 3.3-37.8 12.3-45.8 8.8-8.1 22.2-11.3 45.1-11.3 42.8 0 55.7 12.8 55.7 55.7v11.1h-75.3c-.3 2-.3 4-.3 4.8 0 16.9 4.5 21.9 20.1 21.9 13.9 0 17.9-3 17.9-13.9h37.5v2.3c0 9.8-2.5 18.9-6.8 24.7-7.3 9.8-19.6 13.6-44.3 13.6-27.5 0-41.6-3.3-50.6-12.3-8.5-8.5-11.3-21.3-11.3-50.8zm76.4-11.6c-.3-1.8-.3-3.3-.3-3.8 0-12.3-3.3-14.6-19.6-14.6-14.4 0-17.1 3-18.1 15.1l-.3 3.3h38.3zm55.6-45.3h38.3l-1.8 19.9h.7c6.8-14.9 14.4-20.2 29.7-20.2 10.8 0 19.1 3.3 23.4 9.3 5.3 7.3 6.8 14.4 6.8 34 0 1.5 0 5 .2 9.3h-35c.3-1.8.3-3.3.3-4 0-15.4-2-19.4-10.3-19.4-6.3 0-10.8 3.3-13.1 9.3-1 3-1 4.3-1 12.3v68h-38.3V192.3z"
                }
            }
        ]
    })(props);
}
function FaApplePay(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M116.9 158.5c-7.5 8.9-19.5 15.9-31.5 14.9-1.5-12 4.4-24.8 11.3-32.6 7.5-9.1 20.6-15.6 31.3-16.1 1.2 12.4-3.7 24.7-11.1 33.8m10.9 17.2c-17.4-1-32.3 9.9-40.5 9.9-8.4 0-21-9.4-34.8-9.1-17.9.3-34.5 10.4-43.6 26.5-18.8 32.3-4.9 80 13.3 106.3 8.9 13 19.5 27.3 33.5 26.8 13.3-.5 18.5-8.6 34.5-8.6 16.1 0 20.8 8.6 34.8 8.4 14.5-.3 23.6-13 32.5-26 10.1-14.8 14.3-29.1 14.5-29.9-.3-.3-28-10.9-28.3-42.9-.3-26.8 21.9-39.5 22.9-40.3-12.5-18.6-32-20.6-38.8-21.1m100.4-36.2v194.9h30.3v-66.6h41.9c38.3 0 65.1-26.3 65.1-64.3s-26.4-64-64.1-64h-73.2zm30.3 25.5h34.9c26.3 0 41.3 14 41.3 38.6s-15 38.8-41.4 38.8h-34.8V165zm162.2 170.9c19 0 36.6-9.6 44.6-24.9h.6v23.4h28v-97c0-28.1-22.5-46.3-57.1-46.3-32.1 0-55.9 18.4-56.8 43.6h27.3c2.3-12 13.4-19.9 28.6-19.9 18.5 0 28.9 8.6 28.9 24.5v10.8l-37.8 2.3c-35.1 2.1-54.1 16.5-54.1 41.5.1 25.2 19.7 42 47.8 42zm8.2-23.1c-16.1 0-26.4-7.8-26.4-19.6 0-12.3 9.9-19.4 28.8-20.5l33.6-2.1v11c0 18.2-15.5 31.2-36 31.2zm102.5 74.6c29.5 0 43.4-11.3 55.5-45.4L640 193h-30.8l-35.6 115.1h-.6L537.4 193h-31.6L557 334.9l-2.8 8.6c-4.6 14.6-12.1 20.3-25.5 20.3-2.4 0-7-.3-8.9-.5v23.4c1.8.4 9.3.7 11.6.7z"
                }
            }
        ]
    })(props);
}
function FaApple(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M318.7 268.7c-.2-36.7 16.4-64.4 50-84.8-18.8-26.9-47.2-41.7-84.7-44.6-35.5-2.8-74.3 20.7-88.5 20.7-15 0-49.4-19.7-76.4-19.7C63.3 141.2 4 184.8 4 273.5q0 39.3 14.4 81.2c12.8 36.7 59 126.7 107.2 125.2 25.2-.6 43-17.9 75.8-17.9 31.8 0 48.3 17.9 76.4 17.9 48.6-.7 90.4-82.5 102.6-119.3-65.2-30.7-61.7-90-61.7-91.9zm-56.6-164.2c27.3-32.4 24.8-61.9 24-72.5-24.1 1.4-52 16.4-67.9 34.9-17.5 19.8-27.8 44.3-25.6 71.9 26.1 2 49.9-11.4 69.5-34.3z"
                }
            }
        ]
    })(props);
}
function FaArtstation(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 377.4l43 74.3A51.35 51.35 0 0 0 90.9 480h285.4l-59.2-102.6zM501.8 350L335.6 59.3A51.38 51.38 0 0 0 290.2 32h-88.4l257.3 447.6 40.7-70.5c1.9-3.2 21-29.7 2-59.1zM275 304.5l-115.5-200L44 304.5z"
                }
            }
        ]
    })(props);
}
function FaAsymmetrik(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M517.5 309.2c38.8-40 58.1-80 58.5-116.1.8-65.5-59.4-118.2-169.4-135C277.9 38.4 118.1 73.6 0 140.5 52 114 110.6 92.3 170.7 82.3c74.5-20.5 153-25.4 221.3-14.8C544.5 91.3 588.8 195 490.8 299.2c-10.2 10.8-22 21.1-35 30.6L304.9 103.4 114.7 388.9c-65.6-29.4-76.5-90.2-19.1-151.2 20.8-22.2 48.3-41.9 79.5-58.1 20-12.2 39.7-22.6 62-30.7-65.1 20.3-122.7 52.9-161.6 92.9-27.7 28.6-41.4 57.1-41.7 82.9-.5 35.1 23.4 65.1 68.4 83l-34.5 51.7h101.6l22-34.4c22.2 1 45.3 0 68.6-2.7l-22.8 37.1h135.5L340 406.3c18.6-5.3 36.9-11.5 54.5-18.7l45.9 71.8H542L468.6 349c18.5-12.1 35-25.5 48.9-39.8zm-187.6 80.5l-25-40.6-32.7 53.3c-23.4 3.5-46.7 5.1-69.2 4.4l101.9-159.3 78.7 123c-17.2 7.4-35.3 13.9-53.7 19.2z"
                }
            }
        ]
    })(props);
}
function FaAtlassian(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M152.2 236.4c-7.7-8.2-19.7-7.7-24.8 2.8L1.6 490.2c-5 10 2.4 21.7 13.4 21.7h175c5.8.1 11-3.2 13.4-8.4 37.9-77.8 15.1-196.3-51.2-267.1zM244.4 8.1c-122.3 193.4-8.5 348.6 65 495.5 2.5 5.1 7.7 8.4 13.4 8.4H497c11.2 0 18.4-11.8 13.4-21.7 0 0-234.5-470.6-240.4-482.3-5.3-10.6-18.8-10.8-25.6.1z"
                }
            }
        ]
    })(props);
}
function FaAudible(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M640 199.9v54l-320 200L0 254v-54l320 200 320-200.1zm-194.5 72l47.1-29.4c-37.2-55.8-100.7-92.6-172.7-92.6-72 0-135.5 36.7-172.6 92.4h.3c2.5-2.3 5.1-4.5 7.7-6.7 89.7-74.4 219.4-58.1 290.2 36.3zm-220.1 18.8c16.9-11.9 36.5-18.7 57.4-18.7 34.4 0 65.2 18.4 86.4 47.6l45.4-28.4c-20.9-29.9-55.6-49.5-94.8-49.5-38.9 0-73.4 19.4-94.4 49zM103.6 161.1c131.8-104.3 318.2-76.4 417.5 62.1l.7 1 48.8-30.4C517.1 112.1 424.8 58.1 319.9 58.1c-103.5 0-196.6 53.5-250.5 135.6 9.9-10.5 22.7-23.5 34.2-32.6zm467 32.7z"
                }
            }
        ]
    })(props);
}
function FaAutoprefixer(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M318.4 16l-161 480h77.5l25.4-81.4h119.5L405 496h77.5L318.4 16zm-40.3 341.9l41.2-130.4h1.5l40.9 130.4h-83.6zM640 405l-10-31.4L462.1 358l19.4 56.5L640 405zm-462.1-47L10 373.7 0 405l158.5 9.4 19.4-56.4z"
                }
            }
        ]
    })(props);
}
function FaAvianex(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M453.1 32h-312c-38.9 0-76.2 31.2-83.3 69.7L1.2 410.3C-5.9 448.8 19.9 480 58.9 480h312c38.9 0 76.2-31.2 83.3-69.7l56.7-308.5c7-38.6-18.8-69.8-57.8-69.8zm-58.2 347.3l-32 13.5-115.4-110c-14.7 10-29.2 19.5-41.7 27.1l22.1 64.2-17.9 12.7-40.6-61-52.4-48.1 15.7-15.4 58 31.1c9.3-10.5 20.8-22.6 32.8-34.9L203 228.9l-68.8-99.8 18.8-28.9 8.9-4.8L265 207.8l4.9 4.5c19.4-18.8 33.8-32.4 33.8-32.4 7.7-6.5 21.5-2.9 30.7 7.9 9 10.5 10.6 24.7 2.7 31.3-1.8 1.3-15.5 11.4-35.3 25.6l4.5 7.3 94.9 119.4-6.3 7.9z"
                }
            }
        ]
    })(props);
}
function FaAviato(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M107.2 283.5l-19-41.8H36.1l-19 41.8H0l62.2-131.4 62.2 131.4h-17.2zm-45-98.1l-19.6 42.5h39.2l-19.6-42.5zm112.7 102.4l-62.2-131.4h17.1l45.1 96 45.1-96h17l-62.1 131.4zm80.6-4.3V156.4H271v127.1h-15.5zm209.1-115.6v115.6h-17.3V167.9h-41.2v-11.5h99.6v11.5h-41.1zM640 218.8c0 9.2-1.7 17.8-5.1 25.8-3.4 8-8.2 15.1-14.2 21.1-6 6-13.1 10.8-21.1 14.2-8 3.4-16.6 5.1-25.8 5.1s-17.8-1.7-25.8-5.1c-8-3.4-15.1-8.2-21.1-14.2-6-6-10.8-13-14.2-21.1-3.4-8-5.1-16.6-5.1-25.8s1.7-17.8 5.1-25.8c3.4-8 8.2-15.1 14.2-21.1 6-6 13-8.4 21.1-11.9 8-3.4 16.6-5.1 25.8-5.1s17.8 1.7 25.8 5.1c8 3.4 15.1 5.8 21.1 11.9 6 6 10.7 13.1 14.2 21.1 3.4 8 5.1 16.6 5.1 25.8zm-15.5 0c0-7.3-1.3-14-3.9-20.3-2.6-6.3-6.2-11.7-10.8-16.3-4.6-4.6-10-8.2-16.2-10.9-6.2-2.7-12.8-4-19.8-4s-13.6 1.3-19.8 4c-6.2 2.7-11.6 6.3-16.2 10.9-4.6 4.6-8.2 10-10.8 16.3-2.6 6.3-3.9 13.1-3.9 20.3 0 7.3 1.3 14 3.9 20.3 2.6 6.3 6.2 11.7 10.8 16.3 4.6 4.6 10 8.2 16.2 10.9 6.2 2.7 12.8 4 19.8 4s13.6-1.3 19.8-4c6.2-2.7 11.6-6.3 16.2-10.9 4.6-4.6 8.2-10 10.8-16.3 2.6-6.3 3.9-13.1 3.9-20.3zm-94.8 96.7v-6.3l88.9-10-242.9 13.4c.6-2.2 1.1-4.6 1.4-7.2.3-2 .5-4.2.6-6.5l64.8-8.1-64.9 1.9c0-.4-.1-.7-.1-1.1-2.8-17.2-25.5-23.7-25.5-23.7l-1.1-26.3h23.8l19 41.8h17.1L348.6 152l-62.2 131.4h17.1l19-41.8h23.6L345 268s-22.7 6.5-25.5 23.7c-.1.3-.1.7-.1 1.1l-64.9-1.9 64.8 8.1c.1 2.3.3 4.4.6 6.5.3 2.6.8 5 1.4 7.2L78.4 299.2l88.9 10v6.3c-5.9.9-10.5 6-10.5 12.2 0 6.8 5.6 12.4 12.4 12.4 6.8 0 12.4-5.6 12.4-12.4 0-6.2-4.6-11.3-10.5-12.2v-5.8l80.3 9v5.4c-5.7 1.1-9.9 6.2-9.9 12.1 0 6.8 5.6 10.2 12.4 10.2 6.8 0 12.4-3.4 12.4-10.2 0-6-4.3-11-9.9-12.1v-4.9l28.4 3.2v23.7h-5.9V360h5.9v-6.6h5v6.6h5.9v-13.8h-5.9V323l38.3 4.3c8.1 11.4 19 13.6 19 13.6l-.1 6.7-5.1.2-.1 12.1h4.1l.1-5h5.2l.1 5h4.1l-.1-12.1-5.1-.2-.1-6.7s10.9-2.1 19-13.6l38.3-4.3v23.2h-5.9V360h5.9v-6.6h5v6.6h5.9v-13.8h-5.9v-23.7l28.4-3.2v4.9c-5.7 1.1-9.9 6.2-9.9 12.1 0 6.8 5.6 10.2 12.4 10.2 6.8 0 12.4-3.4 12.4-10.2 0-6-4.3-11-9.9-12.1v-5.4l80.3-9v5.8c-5.9.9-10.5 6-10.5 12.2 0 6.8 5.6 12.4 12.4 12.4 6.8 0 12.4-5.6 12.4-12.4-.2-6.3-4.7-11.4-10.7-12.3zm-200.8-87.6l19.6-42.5 19.6 42.5h-17.9l-1.7-40.3-1.7 40.3h-17.9z"
                }
            }
        ]
    })(props);
}
function FaAws(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M180.41 203.01c-.72 22.65 10.6 32.68 10.88 39.05a8.164 8.164 0 0 1-4.1 6.27l-12.8 8.96a10.66 10.66 0 0 1-5.63 1.92c-.43-.02-8.19 1.83-20.48-25.61a78.608 78.608 0 0 1-62.61 29.45c-16.28.89-60.4-9.24-58.13-56.21-1.59-38.28 34.06-62.06 70.93-60.05 7.1.02 21.6.37 46.99 6.27v-15.62c2.69-26.46-14.7-46.99-44.81-43.91-2.4.01-19.4-.5-45.84 10.11-7.36 3.38-8.3 2.82-10.75 2.82-7.41 0-4.36-21.48-2.94-24.2 5.21-6.4 35.86-18.35 65.94-18.18a76.857 76.857 0 0 1 55.69 17.28 70.285 70.285 0 0 1 17.67 52.36l-.01 69.29zM93.99 235.4c32.43-.47 46.16-19.97 49.29-30.47 2.46-10.05 2.05-16.41 2.05-27.4-9.67-2.32-23.59-4.85-39.56-4.87-15.15-1.14-42.82 5.63-41.74 32.26-1.24 16.79 11.12 31.4 29.96 30.48zm170.92 23.05c-7.86.72-11.52-4.86-12.68-10.37l-49.8-164.65c-.97-2.78-1.61-5.65-1.92-8.58a4.61 4.61 0 0 1 3.86-5.25c.24-.04-2.13 0 22.25 0 8.78-.88 11.64 6.03 12.55 10.37l35.72 140.83 33.16-140.83c.53-3.22 2.94-11.07 12.8-10.24h17.16c2.17-.18 11.11-.5 12.68 10.37l33.42 142.63L420.98 80.1c.48-2.18 2.72-11.37 12.68-10.37h19.72c.85-.13 6.15-.81 5.25 8.58-.43 1.85 3.41-10.66-52.75 169.9-1.15 5.51-4.82 11.09-12.68 10.37h-18.69c-10.94 1.15-12.51-9.66-12.68-10.75L328.67 110.7l-32.78 136.99c-.16 1.09-1.73 11.9-12.68 10.75h-18.3zm273.48 5.63c-5.88.01-33.92-.3-57.36-12.29a12.802 12.802 0 0 1-7.81-11.91v-10.75c0-8.45 6.2-6.9 8.83-5.89 10.04 4.06 16.48 7.14 28.81 9.6 36.65 7.53 52.77-2.3 56.72-4.48 13.15-7.81 14.19-25.68 5.25-34.95-10.48-8.79-15.48-9.12-53.13-21-4.64-1.29-43.7-13.61-43.79-52.36-.61-28.24 25.05-56.18 69.52-55.95 12.67-.01 46.43 4.13 55.57 15.62 1.35 2.09 2.02 4.55 1.92 7.04v10.11c0 4.44-1.62 6.66-4.87 6.66-7.71-.86-21.39-11.17-49.16-10.75-6.89-.36-39.89.91-38.41 24.97-.43 18.96 26.61 26.07 29.7 26.89 36.46 10.97 48.65 12.79 63.12 29.58 17.14 22.25 7.9 48.3 4.35 55.44-19.08 37.49-68.42 34.44-69.26 34.42zm40.2 104.86c-70.03 51.72-171.69 79.25-258.49 79.25A469.127 469.127 0 0 1 2.83 327.46c-6.53-5.89-.77-13.96 7.17-9.47a637.37 637.37 0 0 0 316.88 84.12 630.22 630.22 0 0 0 241.59-49.55c11.78-5 21.77 7.8 10.12 16.38zm29.19-33.29c-8.96-11.52-59.28-5.38-81.81-2.69-6.79.77-7.94-5.12-1.79-9.47 40.07-28.17 105.88-20.1 113.44-10.63 7.55 9.47-2.05 75.41-39.56 106.91-5.76 4.87-11.27 2.3-8.71-4.1 8.44-21.25 27.39-68.49 18.43-80.02z"
                }
            }
        ]
    })(props);
}
function FaBandcamp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256,8C119,8,8,119,8,256S119,504,256,504,504,393,504,256,393,8,256,8Zm48.2,326.1h-181L207.9,178h181Z"
                }
            }
        ]
    })(props);
}
function FaBattleNet(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M448.61 225.62c26.87.18 35.57-7.43 38.92-12.37 12.47-16.32-7.06-47.6-52.85-71.33 17.76-33.58 30.11-63.68 36.34-85.3 3.38-11.83 1.09-19 .45-20.25-1.72 10.52-15.85 48.46-48.2 100.05-25-11.22-56.52-20.1-93.77-23.8-8.94-16.94-34.88-63.86-60.48-88.93C252.18 7.14 238.7 1.07 228.18.22h-.05c-13.83-1.55-22.67 5.85-27.4 11-17.2 18.53-24.33 48.87-25 84.07-7.24-12.35-17.17-24.63-28.5-25.93h-.18c-20.66-3.48-38.39 29.22-36 81.29-38.36 1.38-71 5.75-93 11.23-9.9 2.45-16.22 7.27-17.76 9.72 1-.38 22.4-9.22 111.56-9.22 5.22 53 29.75 101.82 26 93.19-9.73 15.4-38.24 62.36-47.31 97.7-5.87 22.88-4.37 37.61.15 47.14 5.57 12.75 16.41 16.72 23.2 18.26 25 5.71 55.38-3.63 86.7-21.14-7.53 12.84-13.9 28.51-9.06 39.34 7.31 19.65 44.49 18.66 88.44-9.45 20.18 32.18 40.07 57.94 55.7 74.12a39.79 39.79 0 0 0 8.75 7.09c5.14 3.21 8.58 3.37 8.58 3.37-8.24-6.75-34-38-62.54-91.78 22.22-16 45.65-38.87 67.47-69.27 122.82 4.6 143.29-24.76 148-31.64 14.67-19.88 3.43-57.44-57.32-93.69zm-77.85 106.22c23.81-37.71 30.34-67.77 29.45-92.33 27.86 17.57 47.18 37.58 49.06 58.83 1.14 12.93-8.1 29.12-78.51 33.5zM216.9 387.69c9.76-6.23 19.53-13.12 29.2-20.49 6.68 13.33 13.6 26.1 20.6 38.19-40.6 21.86-68.84 12.76-49.8-17.7zm215-171.35c-10.29-5.34-21.16-10.34-32.38-15.05a722.459 722.459 0 0 0 22.74-36.9c39.06 24.1 45.9 53.18 9.64 51.95zM279.18 398c-5.51-11.35-11-23.5-16.5-36.44 43.25 1.27 62.42-18.73 63.28-20.41 0 .07-25 15.64-62.53 12.25a718.78 718.78 0 0 0 85.06-84q13.06-15.31 24.93-31.11c-.36-.29-1.54-3-16.51-12-51.7 60.27-102.34 98-132.75 115.92-20.59-11.18-40.84-31.78-55.71-61.49-20-39.92-30-82.39-31.57-116.07 12.3.91 25.27 2.17 38.85 3.88-22.29 36.8-14.39 63-13.47 64.23 0-.07-.95-29.17 20.14-59.57a695.23 695.23 0 0 0 44.67 152.84c.93-.38 1.84.88 18.67-8.25-26.33-74.47-33.76-138.17-34-173.43 20-12.42 48.18-19.8 81.63-17.81 44.57 2.67 86.36 15.25 116.32 30.71q-10.69 15.66-23.33 32.47C365.63 152 339.1 145.84 337.5 146c.11 0 25.9 14.07 41.52 47.22a717.63 717.63 0 0 0-115.34-31.71 646.608 646.608 0 0 0-39.39-6.05c-.07.45-1.81 1.85-2.16 20.33C300 190.28 358.78 215.68 389.36 233c.74 23.55-6.95 51.61-25.41 79.57-24.6 37.31-56.39 67.23-84.77 85.43zm27.4-287c-44.56-1.66-73.58 7.43-94.69 20.67 2-52.3 21.31-76.38 38.21-75.28C267 52.15 305 108.55 306.58 111zm-130.65 3.1c.48 12.11 1.59 24.62 3.21 37.28-14.55-.85-28.74-1.25-42.4-1.26-.08 3.24-.12-51 24.67-49.59h.09c5.76 1.09 10.63 6.88 14.43 13.57zm-28.06 162c20.76 39.7 43.3 60.57 65.25 72.31-46.79 24.76-77.53 20-84.92 4.51-.2-.21-11.13-15.3 19.67-76.81zm210.06 74.8"
                }
            }
        ]
    })(props);
}
function FaBehanceSquare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M186.5 293c0 19.3-14 25.4-31.2 25.4h-45.1v-52.9h46c18.6.1 30.3 7.8 30.3 27.5zm-7.7-82.3c0-17.7-13.7-21.9-28.9-21.9h-39.6v44.8H153c15.1 0 25.8-6.6 25.8-22.9zm132.3 23.2c-18.3 0-30.5 11.4-31.7 29.7h62.2c-1.7-18.5-11.3-29.7-30.5-29.7zM448 80v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h352c26.5 0 48 21.5 48 48zM271.7 185h77.8v-18.9h-77.8V185zm-43 110.3c0-24.1-11.4-44.9-35-51.6 17.2-8.2 26.2-17.7 26.2-37 0-38.2-28.5-47.5-61.4-47.5H68v192h93.1c34.9-.2 67.6-16.9 67.6-55.9zM380 280.5c0-41.1-24.1-75.4-67.6-75.4-42.4 0-71.1 31.8-71.1 73.6 0 43.3 27.3 73 71.1 73 33.2 0 54.7-14.9 65.1-46.8h-33.7c-3.7 11.9-18.6 18.1-30.2 18.1-22.4 0-34.1-13.1-34.1-35.3h100.2c.1-2.3.3-4.8.3-7.2z"
                }
            }
        ]
    })(props);
}
function FaBehance(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M232 237.2c31.8-15.2 48.4-38.2 48.4-74 0-70.6-52.6-87.8-113.3-87.8H0v354.4h171.8c64.4 0 124.9-30.9 124.9-102.9 0-44.5-21.1-77.4-64.7-89.7zM77.9 135.9H151c28.1 0 53.4 7.9 53.4 40.5 0 30.1-19.7 42.2-47.5 42.2h-79v-82.7zm83.3 233.7H77.9V272h84.9c34.3 0 56 14.3 56 50.6 0 35.8-25.9 47-57.6 47zm358.5-240.7H376V94h143.7v34.9zM576 305.2c0-75.9-44.4-139.2-124.9-139.2-78.2 0-131.3 58.8-131.3 135.8 0 79.9 50.3 134.7 131.3 134.7 61.3 0 101-27.6 120.1-86.3H509c-6.7 21.9-34.3 33.5-55.7 33.5-41.3 0-63-24.2-63-65.3h185.1c.3-4.2.6-8.7.6-13.2zM390.4 274c2.3-33.7 24.7-54.8 58.5-54.8 35.4 0 53.2 20.8 56.2 54.8H390.4z"
                }
            }
        ]
    })(props);
}
function FaBimobject(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M416 32H32C14.4 32 0 46.4 0 64v384c0 17.6 14.4 32 32 32h384c17.6 0 32-14.4 32-32V64c0-17.6-14.4-32-32-32zm-64 257.4c0 49.4-11.4 82.6-103.8 82.6h-16.9c-44.1 0-62.4-14.9-70.4-38.8h-.9V368H96V136h64v74.7h1.1c4.6-30.5 39.7-38.8 69.7-38.8h17.3c92.4 0 103.8 33.1 103.8 82.5v35zm-64-28.9v22.9c0 21.7-3.4 33.8-38.4 33.8h-45.3c-28.9 0-44.1-6.5-44.1-35.7v-19c0-29.3 15.2-35.7 44.1-35.7h45.3c35-.2 38.4 12 38.4 33.7z"
                }
            }
        ]
    })(props);
}
function FaBitbucket(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M22.2 32A16 16 0 0 0 6 47.8a26.35 26.35 0 0 0 .2 2.8l67.9 412.1a21.77 21.77 0 0 0 21.3 18.2h325.7a16 16 0 0 0 16-13.4L505 50.7a16 16 0 0 0-13.2-18.3 24.58 24.58 0 0 0-2.8-.2L22.2 32zm285.9 297.8h-104l-28.1-147h157.3l-25.2 147z"
                }
            }
        ]
    })(props);
}
function FaBitcoin(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M504 256c0 136.967-111.033 248-248 248S8 392.967 8 256 119.033 8 256 8s248 111.033 248 248zm-141.651-35.33c4.937-32.999-20.191-50.739-54.55-62.573l11.146-44.702-27.213-6.781-10.851 43.524c-7.154-1.783-14.502-3.464-21.803-5.13l10.929-43.81-27.198-6.781-11.153 44.686c-5.922-1.349-11.735-2.682-17.377-4.084l.031-.14-37.53-9.37-7.239 29.062s20.191 4.627 19.765 4.913c11.022 2.751 13.014 10.044 12.68 15.825l-12.696 50.925c.76.194 1.744.473 2.829.907-.907-.225-1.876-.473-2.876-.713l-17.796 71.338c-1.349 3.348-4.767 8.37-12.471 6.464.271.395-19.78-4.937-19.78-4.937l-13.51 31.147 35.414 8.827c6.588 1.651 13.045 3.379 19.4 5.006l-11.262 45.213 27.182 6.781 11.153-44.733a1038.209 1038.209 0 0 0 21.687 5.627l-11.115 44.523 27.213 6.781 11.262-45.128c46.404 8.781 81.299 5.239 95.986-36.727 11.836-33.79-.589-53.281-25.004-65.991 17.78-4.098 31.174-15.792 34.747-39.949zm-62.177 87.179c-8.41 33.79-65.308 15.523-83.755 10.943l14.944-59.899c18.446 4.603 77.6 13.717 68.811 48.956zm8.417-87.667c-7.673 30.736-55.031 15.12-70.393 11.292l13.548-54.327c15.363 3.828 64.836 10.973 56.845 43.035z"
                }
            }
        ]
    })(props);
}
function FaBity(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M78.4 67.2C173.8-22 324.5-24 421.5 71c14.3 14.1-6.4 37.1-22.4 21.5-84.8-82.4-215.8-80.3-298.9-3.2-16.3 15.1-36.5-8.3-21.8-22.1zm98.9 418.6c19.3 5.7 29.3-23.6 7.9-30C73 421.9 9.4 306.1 37.7 194.8c5-19.6-24.9-28.1-30.2-7.1-32.1 127.4 41.1 259.8 169.8 298.1zm148.1-2c121.9-40.2 192.9-166.9 164.4-291-4.5-19.7-34.9-13.8-30 7.9 24.2 107.7-37.1 217.9-143.2 253.4-21.2 7-10.4 36 8.8 29.7zm-62.9-79l.2-71.8c0-8.2-6.6-14.8-14.8-14.8-8.2 0-14.8 6.7-14.8 14.8l-.2 71.8c0 8.2 6.6 14.8 14.8 14.8s14.8-6.6 14.8-14.8zm71-269c2.1 90.9 4.7 131.9-85.5 132.5-92.5-.7-86.9-44.3-85.5-132.5 0-21.8-32.5-19.6-32.5 0v71.6c0 69.3 60.7 90.9 118 90.1 57.3.8 118-20.8 118-90.1v-71.6c0-19.6-32.5-21.8-32.5 0z"
                }
            }
        ]
    })(props);
}
function FaBlackTie(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 32v448h448V32H0zm316.5 325.2L224 445.9l-92.5-88.7 64.5-184-64.5-86.6h184.9L252 173.2l64.5 184z"
                }
            }
        ]
    })(props);
}
function FaBlackberry(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M166 116.9c0 23.4-16.4 49.1-72.5 49.1H23.4l21-88.8h67.8c42.1 0 53.8 23.3 53.8 39.7zm126.2-39.7h-67.8L205.7 166h70.1c53.8 0 70.1-25.7 70.1-49.1.1-16.4-11.6-39.7-53.7-39.7zM88.8 208.1H21L0 296.9h70.1c56.1 0 72.5-23.4 72.5-49.1 0-16.3-11.7-39.7-53.8-39.7zm180.1 0h-67.8l-18.7 88.8h70.1c53.8 0 70.1-23.4 70.1-49.1 0-16.3-11.7-39.7-53.7-39.7zm189.3-53.8h-67.8l-18.7 88.8h70.1c53.8 0 70.1-23.4 70.1-49.1.1-16.3-11.6-39.7-53.7-39.7zm-28 137.9h-67.8L343.7 381h70.1c56.1 0 70.1-23.4 70.1-49.1 0-16.3-11.6-39.7-53.7-39.7zM240.8 346H173l-18.7 88.8h70.1c56.1 0 70.1-25.7 70.1-49.1.1-16.3-11.6-39.7-53.7-39.7z"
                }
            }
        ]
    })(props);
}
function FaBloggerB(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M446.6 222.7c-1.8-8-6.8-15.4-12.5-18.5-1.8-1-13-2.2-25-2.7-20.1-.9-22.3-1.3-28.7-5-10.1-5.9-12.8-12.3-12.9-29.5-.1-33-13.8-63.7-40.9-91.3-19.3-19.7-40.9-33-65.5-40.5-5.9-1.8-19.1-2.4-63.3-2.9-69.4-.8-84.8.6-108.4 10C45.9 59.5 14.7 96.1 3.3 142.9 1.2 151.7.7 165.8.2 246.8c-.6 101.5.1 116.4 6.4 136.5 15.6 49.6 59.9 86.3 104.4 94.3 14.8 2.7 197.3 3.3 216 .8 32.5-4.4 58-17.5 81.9-41.9 17.3-17.7 28.1-36.8 35.2-62.1 4.9-17.6 4.5-142.8 2.5-151.7zm-322.1-63.6c7.8-7.9 10-8.2 58.8-8.2 43.9 0 45.4.1 51.8 3.4 9.3 4.7 13.4 11.3 13.4 21.9 0 9.5-3.8 16.2-12.3 21.6-4.6 2.9-7.3 3.1-50.3 3.3-26.5.2-47.7-.4-50.8-1.2-16.6-4.7-22.8-28.5-10.6-40.8zm191.8 199.8l-14.9 2.4-77.5.9c-68.1.8-87.3-.4-90.9-2-7.1-3.1-13.8-11.7-14.9-19.4-1.1-7.3 2.6-17.3 8.2-22.4 7.1-6.4 10.2-6.6 97.3-6.7 89.6-.1 89.1-.1 97.6 7.8 12.1 11.3 9.5 31.2-4.9 39.4z"
                }
            }
        ]
    })(props);
}
function FaBlogger(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M162.4 196c4.8-4.9 6.2-5.1 36.4-5.1 27.2 0 28.1.1 32.1 2.1 5.8 2.9 8.3 7 8.3 13.6 0 5.9-2.4 10-7.6 13.4-2.8 1.8-4.5 1.9-31.1 2.1-16.4.1-29.5-.2-31.5-.8-10.3-2.9-14.1-17.7-6.6-25.3zm61.4 94.5c-53.9 0-55.8.2-60.2 4.1-3.5 3.1-5.7 9.4-5.1 13.9.7 4.7 4.8 10.1 9.2 12 2.2 1 14.1 1.7 56.3 1.2l47.9-.6 9.2-1.5c9-5.1 10.5-17.4 3.1-24.4-5.3-4.7-5-4.7-60.4-4.7zm223.4 130.1c-3.5 28.4-23 50.4-51.1 57.5-7.2 1.8-9.7 1.9-172.9 1.8-157.8 0-165.9-.1-172-1.8-8.4-2.2-15.6-5.5-22.3-10-5.6-3.8-13.9-11.8-17-16.4-3.8-5.6-8.2-15.3-10-22C.1 423 0 420.3 0 256.3 0 93.2 0 89.7 1.8 82.6 8.1 57.9 27.7 39 53 33.4c7.3-1.6 332.1-1.9 340-.3 21.2 4.3 37.9 17.1 47.6 36.4 7.7 15.3 7-1.5 7.3 180.6.2 115.8 0 164.5-.7 170.5zm-85.4-185.2c-1.1-5-4.2-9.6-7.7-11.5-1.1-.6-8-1.3-15.5-1.7-12.4-.6-13.8-.8-17.8-3.1-6.2-3.6-7.9-7.6-8-18.3 0-20.4-8.5-39.4-25.3-56.5-12-12.2-25.3-20.5-40.6-25.1-3.6-1.1-11.8-1.5-39.2-1.8-42.9-.5-52.5.4-67.1 6.2-27 10.7-46.3 33.4-53.4 62.4-1.3 5.4-1.6 14.2-1.9 64.3-.4 62.8 0 72.1 4 84.5 9.7 30.7 37.1 53.4 64.6 58.4 9.2 1.7 122.2 2.1 133.7.5 20.1-2.7 35.9-10.8 50.7-25.9 10.7-10.9 17.4-22.8 21.8-38.5 3.2-10.9 2.9-88.4 1.7-93.9z"
                }
            }
        ]
    })(props);
}
function FaBluetoothB(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 320 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M196.48 260.023l92.626-103.333L143.125 0v206.33l-86.111-86.111-31.406 31.405 108.061 108.399L25.608 368.422l31.406 31.405 86.111-86.111L145.84 512l148.552-148.644-97.912-103.333zm40.86-102.996l-49.977 49.978-.338-100.295 50.315 50.317zM187.363 313.04l49.977 49.978-50.315 50.316.338-100.294z"
                }
            }
        ]
    })(props);
}
function FaBluetooth(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M292.6 171.1L249.7 214l-.3-86 43.2 43.1m-43.2 219.8l43.1-43.1-42.9-42.9-.2 86zM416 259.4C416 465 344.1 512 230.9 512S32 465 32 259.4 115.4 0 228.6 0 416 53.9 416 259.4zm-158.5 0l79.4-88.6L211.8 36.5v176.9L138 139.6l-27 26.9 92.7 93-92.7 93 26.9 26.9 73.8-73.8 2.3 170 127.4-127.5-83.9-88.7z"
                }
            }
        ]
    })(props);
}
function FaBootstrap(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M333.5,201.4c0-22.1-15.6-34.3-43-34.3h-50.4v71.2h42.5C315.4,238.2,333.5,225,333.5,201.4z M517,188.6 c-9.5-30.9-10.9-68.8-9.8-98.1c1.1-30.5-22.7-58.5-54.7-58.5H123.7c-32.1,0-55.8,28.1-54.7,58.5c1,29.3-0.3,67.2-9.8,98.1 c-9.6,31-25.7,50.6-52.2,53.1v28.5c26.4,2.5,42.6,22.1,52.2,53.1c9.5,30.9,10.9,68.8,9.8,98.1c-1.1,30.5,22.7,58.5,54.7,58.5h328.7 c32.1,0,55.8-28.1,54.7-58.5c-1-29.3,0.3-67.2,9.8-98.1c9.6-31,25.7-50.6,52.1-53.1v-28.5C542.7,239.2,526.5,219.6,517,188.6z M300.2,375.1h-97.9V136.8h97.4c43.3,0,71.7,23.4,71.7,59.4c0,25.3-19.1,47.9-43.5,51.8v1.3c33.2,3.6,55.5,26.6,55.5,58.3 C383.4,349.7,352.1,375.1,300.2,375.1z M290.2,266.4h-50.1v78.4h52.3c34.2,0,52.3-13.7,52.3-39.5 C344.7,279.6,326.1,266.4,290.2,266.4z"
                }
            }
        ]
    })(props);
}
function FaBtc(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M310.204 242.638c27.73-14.18 45.377-39.39 41.28-81.3-5.358-57.351-52.458-76.573-114.85-81.929V0h-48.528v77.203c-12.605 0-25.525.315-38.444.63V0h-48.528v79.409c-17.842.539-38.622.276-97.37 0v51.678c38.314-.678 58.417-3.14 63.023 21.427v217.429c-2.925 19.492-18.524 16.685-53.255 16.071L3.765 443.68c88.481 0 97.37.315 97.37.315V512h48.528v-67.06c13.234.315 26.154.315 38.444.315V512h48.528v-68.005c81.299-4.412 135.647-24.894 142.895-101.467 5.671-61.446-23.32-88.862-69.326-99.89zM150.608 134.553c27.415 0 113.126-8.507 113.126 48.528 0 54.515-85.71 48.212-113.126 48.212v-96.74zm0 251.776V279.821c32.772 0 133.127-9.138 133.127 53.255-.001 60.186-100.355 53.253-133.127 53.253z"
                }
            }
        ]
    })(props);
}
function FaBuffer(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M427.84 380.67l-196.5 97.82a18.6 18.6 0 0 1-14.67 0L20.16 380.67c-4-2-4-5.28 0-7.29L67.22 350a18.65 18.65 0 0 1 14.69 0l134.76 67a18.51 18.51 0 0 0 14.67 0l134.76-67a18.62 18.62 0 0 1 14.68 0l47.06 23.43c4.05 1.96 4.05 5.24 0 7.24zm0-136.53l-47.06-23.43a18.62 18.62 0 0 0-14.68 0l-134.76 67.08a18.68 18.68 0 0 1-14.67 0L81.91 220.71a18.65 18.65 0 0 0-14.69 0l-47.06 23.43c-4 2-4 5.29 0 7.31l196.51 97.8a18.6 18.6 0 0 0 14.67 0l196.5-97.8c4.05-2.02 4.05-5.3 0-7.31zM20.16 130.42l196.5 90.29a20.08 20.08 0 0 0 14.67 0l196.51-90.29c4-1.86 4-4.89 0-6.74L231.33 33.4a19.88 19.88 0 0 0-14.67 0l-196.5 90.28c-4.05 1.85-4.05 4.88 0 6.74z"
                }
            }
        ]
    })(props);
}
function FaBuromobelexperte(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 32v128h128V32H0zm120 120H8V40h112v112zm40-120v128h128V32H160zm120 120H168V40h112v112zm40-120v128h128V32H320zm120 120H328V40h112v112zM0 192v128h128V192H0zm120 120H8V200h112v112zm40-120v128h128V192H160zm120 120H168V200h112v112zm40-120v128h128V192H320zm120 120H328V200h112v112zM0 352v128h128V352H0zm120 120H8V360h112v112zm40-120v128h128V352H160zm120 120H168V360h112v112zm40-120v128h128V352H320z"
                }
            }
        ]
    })(props);
}
function FaBuyNLarge(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M288 32C133.27 32 7.79 132.32 7.79 256S133.27 480 288 480s280.21-100.32 280.21-224S442.73 32 288 32zm-85.39 357.19L64.1 390.55l77.25-290.74h133.44c63.15 0 84.93 28.65 78 72.84a60.24 60.24 0 0 1-1.5 6.85 77.39 77.39 0 0 0-17.21-1.93c-42.35 0-76.69 33.88-76.69 75.65 0 37.14 27.14 68 62.93 74.45-18.24 37.16-56.16 60.92-117.71 61.52zM358 207.11h32l-22.16 90.31h-35.41l-11.19-35.63-7.83 35.63h-37.83l26.63-90.31h31.34l15 36.75zm145.86 182.08H306.79L322.63 328a78.8 78.8 0 0 0 11.47.83c42.34 0 76.69-33.87 76.69-75.65 0-32.65-21-60.46-50.38-71.06l21.33-82.35h92.5l-53.05 205.36h103.87zM211.7 269.39H187l-13.8 56.47h24.7c16.14 0 32.11-3.18 37.94-26.65 5.56-22.31-7.99-29.82-24.14-29.82zM233 170h-21.34L200 217.71h21.37c18 0 35.38-14.64 39.21-30.14C265.23 168.71 251.07 170 233 170z"
                }
            }
        ]
    })(props);
}
function FaBuysellads(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M224 150.7l42.9 160.7h-85.8L224 150.7zM448 80v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h352c26.5 0 48 21.5 48 48zm-65.3 325.3l-94.5-298.7H159.8L65.3 405.3H156l111.7-91.6 24.2 91.6h90.8z"
                }
            }
        ]
    })(props);
}
function FaCanadianMapleLeaf(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M383.8 351.7c2.5-2.5 105.2-92.4 105.2-92.4l-17.5-7.5c-10-4.9-7.4-11.5-5-17.4 2.4-7.6 20.1-67.3 20.1-67.3s-47.7 10-57.7 12.5c-7.5 2.4-10-2.5-12.5-7.5s-15-32.4-15-32.4-52.6 59.9-55.1 62.3c-10 7.5-20.1 0-17.6-10 0-10 27.6-129.6 27.6-129.6s-30.1 17.4-40.1 22.4c-7.5 5-12.6 5-17.6-5C293.5 72.3 255.9 0 255.9 0s-37.5 72.3-42.5 79.8c-5 10-10 10-17.6 5-10-5-40.1-22.4-40.1-22.4S183.3 182 183.3 192c2.5 10-7.5 17.5-17.6 10-2.5-2.5-55.1-62.3-55.1-62.3S98.1 167 95.6 172s-5 9.9-12.5 7.5C73 177 25.4 167 25.4 167s17.6 59.7 20.1 67.3c2.4 6 5 12.5-5 17.4L23 259.3s102.6 89.9 105.2 92.4c5.1 5 10 7.5 5.1 22.5-5.1 15-10.1 35.1-10.1 35.1s95.2-20.1 105.3-22.6c8.7-.9 18.3 2.5 18.3 12.5S241 512 241 512h30s-5.8-102.7-5.8-112.8 9.5-13.4 18.4-12.5c10 2.5 105.2 22.6 105.2 22.6s-5-20.1-10-35.1 0-17.5 5-22.5z"
                }
            }
        ]
    })(props);
}
function FaCcAmazonPay(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M124.7 201.8c.1-11.8 0-23.5 0-35.3v-35.3c0-1.3.4-2 1.4-2.7 11.5-8 24.1-12.1 38.2-11.1 12.5.9 22.7 7 28.1 21.7 3.3 8.9 4.1 18.2 4.1 27.7 0 8.7-.7 17.3-3.4 25.6-5.7 17.8-18.7 24.7-35.7 23.9-11.7-.5-21.9-5-31.4-11.7-.9-.8-1.4-1.6-1.3-2.8zm154.9 14.6c4.6 1.8 9.3 2 14.1 1.5 11.6-1.2 21.9-5.7 31.3-12.5.9-.6 1.3-1.3 1.3-2.5-.1-3.9 0-7.9 0-11.8 0-4-.1-8 0-12 0-1.4-.4-2-1.8-2.2-7-.9-13.9-2.2-20.9-2.9-7-.6-14-.3-20.8 1.9-6.7 2.2-11.7 6.2-13.7 13.1-1.6 5.4-1.6 10.8.1 16.2 1.6 5.5 5.2 9.2 10.4 11.2zM576 80v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h480c26.5 0 48 21.5 48 48zm-207.5 23.9c.4 1.7.9 3.4 1.6 5.1 16.5 40.6 32.9 81.3 49.5 121.9 1.4 3.5 1.7 6.4.2 9.9-2.8 6.2-4.9 12.6-7.8 18.7-2.6 5.5-6.7 9.5-12.7 11.2-4.2 1.1-8.5 1.3-12.9.9-2.1-.2-4.2-.7-6.3-.8-2.8-.2-4.2 1.1-4.3 4-.1 2.8-.1 5.6 0 8.3.1 4.6 1.6 6.7 6.2 7.5 4.7.8 9.4 1.6 14.2 1.7 14.3.3 25.7-5.4 33.1-17.9 2.9-4.9 5.6-10.1 7.7-15.4 19.8-50.1 39.5-100.3 59.2-150.5.6-1.5 1.1-3 1.3-4.6.4-2.4-.7-3.6-3.1-3.7-5.6-.1-11.1 0-16.7 0-3.1 0-5.3 1.4-6.4 4.3-.4 1.1-.9 2.3-1.3 3.4l-29.1 83.7c-2.1 6.1-4.2 12.1-6.5 18.6-.4-.9-.6-1.4-.8-1.9-10.8-29.9-21.6-59.9-32.4-89.8-1.7-4.7-3.5-9.5-5.3-14.2-.9-2.5-2.7-4-5.4-4-6.4-.1-12.8-.2-19.2-.1-2.2 0-3.3 1.6-2.8 3.7zM242.4 206c1.7 11.7 7.6 20.8 18 26.6 9.9 5.5 20.7 6.2 31.7 4.6 12.7-1.9 23.9-7.3 33.8-15.5.4-.3.8-.6 1.4-1 .5 3.2.9 6.2 1.5 9.2.5 2.6 2.1 4.3 4.5 4.4 4.6.1 9.1.1 13.7 0 2.3-.1 3.8-1.6 4-3.9.1-.8.1-1.6.1-2.3v-88.8c0-3.6-.2-7.2-.7-10.8-1.6-10.8-6.2-19.7-15.9-25.4-5.6-3.3-11.8-5-18.2-5.9-3-.4-6-.7-9.1-1.1h-10c-.8.1-1.6.3-2.5.3-8.2.4-16.3 1.4-24.2 3.5-5.1 1.3-10 3.2-15 4.9-3 1-4.5 3.2-4.4 6.5.1 2.8-.1 5.6 0 8.3.1 4.1 1.8 5.2 5.7 4.1 6.5-1.7 13.1-3.5 19.7-4.8 10.3-1.9 20.7-2.7 31.1-1.2 5.4.8 10.5 2.4 14.1 7 3.1 4 4.2 8.8 4.4 13.7.3 6.9.2 13.9.3 20.8 0 .4-.1.7-.2 1.2-.4 0-.8 0-1.1-.1-8.8-2.1-17.7-3.6-26.8-4.1-9.5-.5-18.9.1-27.9 3.2-10.8 3.8-19.5 10.3-24.6 20.8-4.1 8.3-4.6 17-3.4 25.8zM98.7 106.9v175.3c0 .8 0 1.7.1 2.5.2 2.5 1.7 4.1 4.1 4.2 5.9.1 11.8.1 17.7 0 2.5 0 4-1.7 4.1-4.1.1-.8.1-1.7.1-2.5v-60.7c.9.7 1.4 1.2 1.9 1.6 15 12.5 32.2 16.6 51.1 12.9 17.1-3.4 28.9-13.9 36.7-29.2 5.8-11.6 8.3-24.1 8.7-37 .5-14.3-1-28.4-6.8-41.7-7.1-16.4-18.9-27.3-36.7-30.9-2.7-.6-5.5-.8-8.2-1.2h-7c-1.2.2-2.4.3-3.6.5-11.7 1.4-22.3 5.8-31.8 12.7-2 1.4-3.9 3-5.9 4.5-.1-.5-.3-.8-.4-1.2-.4-2.3-.7-4.6-1.1-6.9-.6-3.9-2.5-5.5-6.4-5.6h-9.7c-5.9-.1-6.9 1-6.9 6.8zM493.6 339c-2.7-.7-5.1 0-7.6 1-43.9 18.4-89.5 30.2-136.8 35.8-14.5 1.7-29.1 2.8-43.7 3.2-26.6.7-53.2-.8-79.6-4.3-17.8-2.4-35.5-5.7-53-9.9-37-8.9-72.7-21.7-106.7-38.8-8.8-4.4-17.4-9.3-26.1-14-3.8-2.1-6.2-1.5-8.2 2.1v1.7c1.2 1.6 2.2 3.4 3.7 4.8 36 32.2 76.6 56.5 122 72.9 21.9 7.9 44.4 13.7 67.3 17.5 14 2.3 28 3.8 42.2 4.5 3 .1 6 .2 9 .4.7 0 1.4.2 2.1.3h17.7c.7-.1 1.4-.3 2.1-.3 14.9-.4 29.8-1.8 44.6-4 21.4-3.2 42.4-8.1 62.9-14.7 29.6-9.6 57.7-22.4 83.4-40.1 2.8-1.9 5.7-3.8 8-6.2 4.3-4.4 2.3-10.4-3.3-11.9zm50.4-27.7c-.8-4.2-4-5.8-7.6-7-5.7-1.9-11.6-2.8-17.6-3.3-11-.9-22-.4-32.8 1.6-12 2.2-23.4 6.1-33.5 13.1-1.2.8-2.4 1.8-3.1 3-.6.9-.7 2.3-.5 3.4.3 1.3 1.7 1.6 3 1.5.6 0 1.2 0 1.8-.1l19.5-2.1c9.6-.9 19.2-1.5 28.8-.8 4.1.3 8.1 1.2 12 2.2 4.3 1.1 6.2 4.4 6.4 8.7.3 6.7-1.2 13.1-2.9 19.5-3.5 12.9-8.3 25.4-13.3 37.8-.3.8-.7 1.7-.8 2.5-.4 2.5 1 4 3.4 3.5 1.4-.3 3-1.1 4-2.1 3.7-3.6 7.5-7.2 10.6-11.2 10.7-13.8 17-29.6 20.7-46.6.7-3 1.2-6.1 1.7-9.1.2-4.7.2-9.6.2-14.5z"
                }
            }
        ]
    })(props);
}
function FaCcAmex(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M325.1 167.8c0-16.4-14.1-18.4-27.4-18.4l-39.1-.3v69.3H275v-25.1h18c18.4 0 14.5 10.3 14.8 25.1h16.6v-13.5c0-9.2-1.5-15.1-11-18.4 7.4-3 11.8-10.7 11.7-18.7zm-29.4 11.3H275v-15.3h21c5.1 0 10.7 1 10.7 7.4 0 6.6-5.3 7.9-11 7.9zM279 268.6h-52.7l-21 22.8-20.5-22.8h-66.5l-.1 69.3h65.4l21.3-23 20.4 23h32.2l.1-23.3c18.9 0 49.3 4.6 49.3-23.3 0-17.3-12.3-22.7-27.9-22.7zm-103.8 54.7h-40.6v-13.8h36.3v-14.1h-36.3v-12.5h41.7l17.9 20.2zm65.8 8.2l-25.3-28.1L241 276zm37.8-31h-21.2v-17.6h21.5c5.6 0 10.2 2.3 10.2 8.4 0 6.4-4.6 9.2-10.5 9.2zm-31.6-136.7v-14.6h-55.5v69.3h55.5v-14.3h-38.9v-13.8h37.8v-14.1h-37.8v-12.5zM576 255.4h-.2zm-194.6 31.9c0-16.4-14.1-18.7-27.1-18.7h-39.4l-.1 69.3h16.6l.1-25.3h17.6c11 0 14.8 2 14.8 13.8l-.1 11.5h16.6l.1-13.8c0-8.9-1.8-15.1-11-18.4 7.7-3.1 11.8-10.8 11.9-18.4zm-29.2 11.2h-20.7v-15.6h21c5.1 0 10.7 1 10.7 7.4 0 6.9-5.4 8.2-11 8.2zm-172.8-80v-69.3h-27.6l-19.7 47-21.7-47H83.3v65.7l-28.1-65.7H30.7L1 218.5h17.9l6.4-15.3h34.5l6.4 15.3H100v-54.2l24 54.2h14.6l24-54.2v54.2zM31.2 188.8l11.2-27.6 11.5 27.6zm477.4 158.9v-4.5c-10.8 5.6-3.9 4.5-156.7 4.5 0-25.2.1-23.9 0-25.2-1.7-.1-3.2-.1-9.4-.1 0 17.9-.1 6.8-.1 25.3h-39.6c0-12.1.1-15.3.1-29.2-10 6-22.8 6.4-34.3 6.2 0 14.7-.1 8.3-.1 23h-48.9c-5.1-5.7-2.7-3.1-15.4-17.4-3.2 3.5-12.8 13.9-16.1 17.4h-82v-92.3h83.1c5 5.6 2.8 3.1 15.5 17.2 3.2-3.5 12.2-13.4 15.7-17.2h58c9.8 0 18 1.9 24.3 5.6v-5.6c54.3 0 64.3-1.4 75.7 5.1v-5.1h78.2v5.2c11.4-6.9 19.6-5.2 64.9-5.2v5c10.3-5.9 16.6-5.2 54.3-5V80c0-26.5-21.5-48-48-48h-480c-26.5 0-48 21.5-48 48v109.8c9.4-21.9 19.7-46 23.1-53.9h39.7c4.3 10.1 1.6 3.7 9 21.1v-21.1h46c2.9 6.2 11.1 24 13.9 30 5.8-13.6 10.1-23.9 12.6-30h103c0-.1 11.5 0 11.6 0 43.7.2 53.6-.8 64.4 5.3v-5.3H363v9.3c7.6-6.1 17.9-9.3 30.7-9.3h27.6c0 .5 1.9.3 2.3.3H456c4.2 9.8 2.6 6 8.8 20.6v-20.6h43.3c4.9 8-1-1.8 11.2 18.4v-18.4h39.9v92h-41.6c-5.4-9-1.4-2.2-13.2-21.9v21.9h-52.8c-6.4-14.8-.1-.3-6.6-15.3h-19c-4.2 10-2.2 5.2-6.4 15.3h-26.8c-12.3 0-22.3-3-29.7-8.9v8.9h-66.5c-.3-13.9-.1-24.8-.1-24.8-1.8-.3-3.4-.2-9.8-.2v25.1H151.2v-11.4c-2.5 5.6-2.7 5.9-5.1 11.4h-29.5c-4-8.9-2.9-6.4-5.1-11.4v11.4H58.6c-4.2-10.1-2.2-5.3-6.4-15.3H33c-4.2 10-2.2 5.2-6.4 15.3H0V432c0 26.5 21.5 48 48 48h480.1c26.5 0 48-21.5 48-48v-90.4c-12.7 8.3-32.7 6.1-67.5 6.1zm36.3-64.5H575v-14.6h-32.9c-12.8 0-23.8 6.6-23.8 20.7 0 33 42.7 12.8 42.7 27.4 0 5.1-4.3 6.4-8.4 6.4h-32l-.1 14.8h32c8.4 0 17.6-1.8 22.5-8.9v-25.8c-10.5-13.8-39.3-1.3-39.3-13.5 0-5.8 4.6-6.5 9.2-6.5zm-57 39.8h-32.2l-.1 14.8h32.2c14.8 0 26.2-5.6 26.2-22 0-33.2-42.9-11.2-42.9-26.3 0-5.6 4.9-6.4 9.2-6.4h30.4v-14.6h-33.2c-12.8 0-23.5 6.6-23.5 20.7 0 33 42.7 12.5 42.7 27.4-.1 5.4-4.7 6.4-8.8 6.4zm-42.2-40.1v-14.3h-55.2l-.1 69.3h55.2l.1-14.3-38.6-.3v-13.8H445v-14.1h-37.8v-12.5zm-56.3-108.1c-.3.2-1.4 2.2-1.4 7.6 0 6 .9 7.7 1.1 7.9.2.1 1.1.5 3.4.5l7.3-16.9c-1.1 0-2.1-.1-3.1-.1-5.6 0-7 .7-7.3 1zm20.4-10.5h-.1zm-16.2-15.2c-23.5 0-34 12-34 35.3 0 22.2 10.2 34 33 34h19.2l6.4-15.3h34.3l6.6 15.3h33.7v-51.9l31.2 51.9h23.6v-69h-16.9v48.1l-29.1-48.1h-25.3v65.4l-27.9-65.4h-24.8l-23.5 54.5h-7.4c-13.3 0-16.1-8.1-16.1-19.9 0-23.8 15.7-20 33.1-19.7v-15.2zm42.1 12.1l11.2 27.6h-22.8zm-101.1-12v69.3h16.9v-69.3z"
                }
            }
        ]
    })(props);
}
function FaCcApplePay(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M302.2 218.4c0 17.2-10.5 27.1-29 27.1h-24.3v-54.2h24.4c18.4 0 28.9 9.8 28.9 27.1zm47.5 62.6c0 8.3 7.2 13.7 18.5 13.7 14.4 0 25.2-9.1 25.2-21.9v-7.7l-23.5 1.5c-13.3.9-20.2 5.8-20.2 14.4zM576 79v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V79c0-26.5 21.5-48 48-48h480c26.5 0 48 21.5 48 48zM127.8 197.2c8.4.7 16.8-4.2 22.1-10.4 5.2-6.4 8.6-15 7.7-23.7-7.4.3-16.6 4.9-21.9 11.3-4.8 5.5-8.9 14.4-7.9 22.8zm60.6 74.5c-.2-.2-19.6-7.6-19.8-30-.2-18.7 15.3-27.7 16-28.2-8.8-13-22.4-14.4-27.1-14.7-12.2-.7-22.6 6.9-28.4 6.9-5.9 0-14.7-6.6-24.3-6.4-12.5.2-24.2 7.3-30.5 18.6-13.1 22.6-3.4 56 9.3 74.4 6.2 9.1 13.7 19.1 23.5 18.7 9.3-.4 13-6 24.2-6 11.3 0 14.5 6 24.3 5.9 10.2-.2 16.5-9.1 22.8-18.2 6.9-10.4 9.8-20.4 10-21zm135.4-53.4c0-26.6-18.5-44.8-44.9-44.8h-51.2v136.4h21.2v-46.6h29.3c26.8 0 45.6-18.4 45.6-45zm90 23.7c0-19.7-15.8-32.4-40-32.4-22.5 0-39.1 12.9-39.7 30.5h19.1c1.6-8.4 9.4-13.9 20-13.9 13 0 20.2 6 20.2 17.2v7.5l-26.4 1.6c-24.6 1.5-37.9 11.6-37.9 29.1 0 17.7 13.7 29.4 33.4 29.4 13.3 0 25.6-6.7 31.2-17.4h.4V310h19.6v-68zM516 210.9h-21.5l-24.9 80.6h-.4l-24.9-80.6H422l35.9 99.3-1.9 6c-3.2 10.2-8.5 14.2-17.9 14.2-1.7 0-4.9-.2-6.2-.3v16.4c1.2.4 6.5.5 8.1.5 20.7 0 30.4-7.9 38.9-31.8L516 210.9z"
                }
            }
        ]
    })(props);
}
function FaCcDinersClub(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M239.7 79.9c-96.9 0-175.8 78.6-175.8 175.8 0 96.9 78.9 175.8 175.8 175.8 97.2 0 175.8-78.9 175.8-175.8 0-97.2-78.6-175.8-175.8-175.8zm-39.9 279.6c-41.7-15.9-71.4-56.4-71.4-103.8s29.7-87.9 71.4-104.1v207.9zm79.8.3V151.6c41.7 16.2 71.4 56.7 71.4 104.1s-29.7 87.9-71.4 104.1zM528 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h480c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zM329.7 448h-90.3c-106.2 0-193.8-85.5-193.8-190.2C45.6 143.2 133.2 64 239.4 64h90.3c105 0 200.7 79.2 200.7 193.8 0 104.7-95.7 190.2-200.7 190.2z"
                }
            }
        ]
    })(props);
}
function FaCcDiscover(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M520.4 196.1c0-7.9-5.5-12.1-15.6-12.1h-4.9v24.9h4.7c10.3 0 15.8-4.4 15.8-12.8zM528 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h480c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zm-44.1 138.9c22.6 0 52.9-4.1 52.9 24.4 0 12.6-6.6 20.7-18.7 23.2l25.8 34.4h-19.6l-22.2-32.8h-2.2v32.8h-16zm-55.9.1h45.3v14H444v18.2h28.3V217H444v22.2h29.3V253H428zm-68.7 0l21.9 55.2 22.2-55.2h17.5l-35.5 84.2h-8.6l-35-84.2zm-55.9-3c24.7 0 44.6 20 44.6 44.6 0 24.7-20 44.6-44.6 44.6-24.7 0-44.6-20-44.6-44.6 0-24.7 20-44.6 44.6-44.6zm-49.3 6.1v19c-20.1-20.1-46.8-4.7-46.8 19 0 25 27.5 38.5 46.8 19.2v19c-29.7 14.3-63.3-5.7-63.3-38.2 0-31.2 33.1-53 63.3-38zm-97.2 66.3c11.4 0 22.4-15.3-3.3-24.4-15-5.5-20.2-11.4-20.2-22.7 0-23.2 30.6-31.4 49.7-14.3l-8.4 10.8c-10.4-11.6-24.9-6.2-24.9 2.5 0 4.4 2.7 6.9 12.3 10.3 18.2 6.6 23.6 12.5 23.6 25.6 0 29.5-38.8 37.4-56.6 11.3l10.3-9.9c3.7 7.1 9.9 10.8 17.5 10.8zM55.4 253H32v-82h23.4c26.1 0 44.1 17 44.1 41.1 0 18.5-13.2 40.9-44.1 40.9zm67.5 0h-16v-82h16zM544 433c0 8.2-6.8 15-15 15H128c189.6-35.6 382.7-139.2 416-160zM74.1 191.6c-5.2-4.9-11.6-6.6-21.9-6.6H48v54.2h4.2c10.3 0 17-2 21.9-6.4 5.7-5.2 8.9-12.8 8.9-20.7s-3.2-15.5-8.9-20.5z"
                }
            }
        ]
    })(props);
}
function FaCcJcb(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M431.5 244.3V212c41.2 0 38.5.2 38.5.2 7.3 1.3 13.3 7.3 13.3 16 0 8.8-6 14.5-13.3 15.8-1.2.4-3.3.3-38.5.3zm42.8 20.2c-2.8-.7-3.3-.5-42.8-.5v35c39.6 0 40 .2 42.8-.5 7.5-1.5 13.5-8 13.5-17 0-8.7-6-15.5-13.5-17zM576 80v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h480c26.5 0 48 21.5 48 48zM182 192.3h-57c0 67.1 10.7 109.7-35.8 109.7-19.5 0-38.8-5.7-57.2-14.8v28c30 8.3 68 8.3 68 8.3 97.9 0 82-47.7 82-131.2zm178.5 4.5c-63.4-16-165-14.9-165 59.3 0 77.1 108.2 73.6 165 59.2V287C312.9 311.7 253 309 253 256s59.8-55.6 107.5-31.2v-28zM544 286.5c0-18.5-16.5-30.5-38-32v-.8c19.5-2.7 30.3-15.5 30.3-30.2 0-19-15.7-30-37-31 0 0 6.3-.3-120.3-.3v127.5h122.7c24.3.1 42.3-12.9 42.3-33.2z"
                }
            }
        ]
    })(props);
}
function FaCcMastercard(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M482.9 410.3c0 6.8-4.6 11.7-11.2 11.7-6.8 0-11.2-5.2-11.2-11.7 0-6.5 4.4-11.7 11.2-11.7 6.6 0 11.2 5.2 11.2 11.7zm-310.8-11.7c-7.1 0-11.2 5.2-11.2 11.7 0 6.5 4.1 11.7 11.2 11.7 6.5 0 10.9-4.9 10.9-11.7-.1-6.5-4.4-11.7-10.9-11.7zm117.5-.3c-5.4 0-8.7 3.5-9.5 8.7h19.1c-.9-5.7-4.4-8.7-9.6-8.7zm107.8.3c-6.8 0-10.9 5.2-10.9 11.7 0 6.5 4.1 11.7 10.9 11.7 6.8 0 11.2-4.9 11.2-11.7 0-6.5-4.4-11.7-11.2-11.7zm105.9 26.1c0 .3.3.5.3 1.1 0 .3-.3.5-.3 1.1-.3.3-.3.5-.5.8-.3.3-.5.5-1.1.5-.3.3-.5.3-1.1.3-.3 0-.5 0-1.1-.3-.3 0-.5-.3-.8-.5-.3-.3-.5-.5-.5-.8-.3-.5-.3-.8-.3-1.1 0-.5 0-.8.3-1.1 0-.5.3-.8.5-1.1.3-.3.5-.3.8-.5.5-.3.8-.3 1.1-.3.5 0 .8 0 1.1.3.5.3.8.3 1.1.5s.2.6.5 1.1zm-2.2 1.4c.5 0 .5-.3.8-.3.3-.3.3-.5.3-.8 0-.3 0-.5-.3-.8-.3 0-.5-.3-1.1-.3h-1.6v3.5h.8V426h.3l1.1 1.4h.8l-1.1-1.3zM576 81v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V81c0-26.5 21.5-48 48-48h480c26.5 0 48 21.5 48 48zM64 220.6c0 76.5 62.1 138.5 138.5 138.5 27.2 0 53.9-8.2 76.5-23.1-72.9-59.3-72.4-171.2 0-230.5-22.6-15-49.3-23.1-76.5-23.1-76.4-.1-138.5 62-138.5 138.2zm224 108.8c70.5-55 70.2-162.2 0-217.5-70.2 55.3-70.5 162.6 0 217.5zm-142.3 76.3c0-8.7-5.7-14.4-14.7-14.7-4.6 0-9.5 1.4-12.8 6.5-2.4-4.1-6.5-6.5-12.2-6.5-3.8 0-7.6 1.4-10.6 5.4V392h-8.2v36.7h8.2c0-18.9-2.5-30.2 9-30.2 10.2 0 8.2 10.2 8.2 30.2h7.9c0-18.3-2.5-30.2 9-30.2 10.2 0 8.2 10 8.2 30.2h8.2v-23zm44.9-13.7h-7.9v4.4c-2.7-3.3-6.5-5.4-11.7-5.4-10.3 0-18.2 8.2-18.2 19.3 0 11.2 7.9 19.3 18.2 19.3 5.2 0 9-1.9 11.7-5.4v4.6h7.9V392zm40.5 25.6c0-15-22.9-8.2-22.9-15.2 0-5.7 11.9-4.8 18.5-1.1l3.3-6.5c-9.4-6.1-30.2-6-30.2 8.2 0 14.3 22.9 8.3 22.9 15 0 6.3-13.5 5.8-20.7.8l-3.5 6.3c11.2 7.6 32.6 6 32.6-7.5zm35.4 9.3l-2.2-6.8c-3.8 2.1-12.2 4.4-12.2-4.1v-16.6h13.1V392h-13.1v-11.2h-8.2V392h-7.6v7.3h7.6V416c0 17.6 17.3 14.4 22.6 10.9zm13.3-13.4h27.5c0-16.2-7.4-22.6-17.4-22.6-10.6 0-18.2 7.9-18.2 19.3 0 20.5 22.6 23.9 33.8 14.2l-3.8-6c-7.8 6.4-19.6 5.8-21.9-4.9zm59.1-21.5c-4.6-2-11.6-1.8-15.2 4.4V392h-8.2v36.7h8.2V408c0-11.6 9.5-10.1 12.8-8.4l2.4-7.6zm10.6 18.3c0-11.4 11.6-15.1 20.7-8.4l3.8-6.5c-11.6-9.1-32.7-4.1-32.7 15 0 19.8 22.4 23.8 32.7 15l-3.8-6.5c-9.2 6.5-20.7 2.6-20.7-8.6zm66.7-18.3H408v4.4c-8.3-11-29.9-4.8-29.9 13.9 0 19.2 22.4 24.7 29.9 13.9v4.6h8.2V392zm33.7 0c-2.4-1.2-11-2.9-15.2 4.4V392h-7.9v36.7h7.9V408c0-11 9-10.3 12.8-8.4l2.4-7.6zm40.3-14.9h-7.9v19.3c-8.2-10.9-29.9-5.1-29.9 13.9 0 19.4 22.5 24.6 29.9 13.9v4.6h7.9v-51.7zm7.6-75.1v4.6h.8V302h1.9v-.8h-4.6v.8h1.9zm6.6 123.8c0-.5 0-1.1-.3-1.6-.3-.3-.5-.8-.8-1.1-.3-.3-.8-.5-1.1-.8-.5 0-1.1-.3-1.6-.3-.3 0-.8.3-1.4.3-.5.3-.8.5-1.1.8-.5.3-.8.8-.8 1.1-.3.5-.3 1.1-.3 1.6 0 .3 0 .8.3 1.4 0 .3.3.8.8 1.1.3.3.5.5 1.1.8.5.3 1.1.3 1.4.3.5 0 1.1 0 1.6-.3.3-.3.8-.5 1.1-.8.3-.3.5-.8.8-1.1.3-.6.3-1.1.3-1.4zm3.2-124.7h-1.4l-1.6 3.5-1.6-3.5h-1.4v5.4h.8v-4.1l1.6 3.5h1.1l1.4-3.5v4.1h1.1v-5.4zm4.4-80.5c0-76.2-62.1-138.3-138.5-138.3-27.2 0-53.9 8.2-76.5 23.1 72.1 59.3 73.2 171.5 0 230.5 22.6 15 49.5 23.1 76.5 23.1 76.4.1 138.5-61.9 138.5-138.4z"
                }
            }
        ]
    })(props);
}
function FaCcPaypal(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M186.3 258.2c0 12.2-9.7 21.5-22 21.5-9.2 0-16-5.2-16-15 0-12.2 9.5-22 21.7-22 9.3 0 16.3 5.7 16.3 15.5zM80.5 209.7h-4.7c-1.5 0-3 1-3.2 2.7l-4.3 26.7 8.2-.3c11 0 19.5-1.5 21.5-14.2 2.3-13.4-6.2-14.9-17.5-14.9zm284 0H360c-1.8 0-3 1-3.2 2.7l-4.2 26.7 8-.3c13 0 22-3 22-18-.1-10.6-9.6-11.1-18.1-11.1zM576 80v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h480c26.5 0 48 21.5 48 48zM128.3 215.4c0-21-16.2-28-34.7-28h-40c-2.5 0-5 2-5.2 4.7L32 294.2c-.3 2 1.2 4 3.2 4h19c2.7 0 5.2-2.9 5.5-5.7l4.5-26.6c1-7.2 13.2-4.7 18-4.7 28.6 0 46.1-17 46.1-45.8zm84.2 8.8h-19c-3.8 0-4 5.5-4.2 8.2-5.8-8.5-14.2-10-23.7-10-24.5 0-43.2 21.5-43.2 45.2 0 19.5 12.2 32.2 31.7 32.2 9 0 20.2-4.9 26.5-11.9-.5 1.5-1 4.7-1 6.2 0 2.3 1 4 3.2 4H200c2.7 0 5-2.9 5.5-5.7l10.2-64.3c.3-1.9-1.2-3.9-3.2-3.9zm40.5 97.9l63.7-92.6c.5-.5.5-1 .5-1.7 0-1.7-1.5-3.5-3.2-3.5h-19.2c-1.7 0-3.5 1-4.5 2.5l-26.5 39-11-37.5c-.8-2.2-3-4-5.5-4h-18.7c-1.7 0-3.2 1.8-3.2 3.5 0 1.2 19.5 56.8 21.2 62.1-2.7 3.8-20.5 28.6-20.5 31.6 0 1.8 1.5 3.2 3.2 3.2h19.2c1.8-.1 3.5-1.1 4.5-2.6zm159.3-106.7c0-21-16.2-28-34.7-28h-39.7c-2.7 0-5.2 2-5.5 4.7l-16.2 102c-.2 2 1.3 4 3.2 4h20.5c2 0 3.5-1.5 4-3.2l4.5-29c1-7.2 13.2-4.7 18-4.7 28.4 0 45.9-17 45.9-45.8zm84.2 8.8h-19c-3.8 0-4 5.5-4.3 8.2-5.5-8.5-14-10-23.7-10-24.5 0-43.2 21.5-43.2 45.2 0 19.5 12.2 32.2 31.7 32.2 9.3 0 20.5-4.9 26.5-11.9-.3 1.5-1 4.7-1 6.2 0 2.3 1 4 3.2 4H484c2.7 0 5-2.9 5.5-5.7l10.2-64.3c.3-1.9-1.2-3.9-3.2-3.9zm47.5-33.3c0-2-1.5-3.5-3.2-3.5h-18.5c-1.5 0-3 1.2-3.2 2.7l-16.2 104-.3.5c0 1.8 1.5 3.5 3.5 3.5h16.5c2.5 0 5-2.9 5.2-5.7L544 191.2v-.3zm-90 51.8c-12.2 0-21.7 9.7-21.7 22 0 9.7 7 15 16.2 15 12 0 21.7-9.2 21.7-21.5.1-9.8-6.9-15.5-16.2-15.5z"
                }
            }
        ]
    })(props);
}
function FaCcStripe(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M492.4 220.8c-8.9 0-18.7 6.7-18.7 22.7h36.7c0-16-9.3-22.7-18-22.7zM375 223.4c-8.2 0-13.3 2.9-17 7l.2 52.8c3.5 3.7 8.5 6.7 16.8 6.7 13.1 0 21.9-14.3 21.9-33.4 0-18.6-9-33.2-21.9-33.1zM528 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h480c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zM122.2 281.1c0 25.6-20.3 40.1-49.9 40.3-12.2 0-25.6-2.4-38.8-8.1v-33.9c12 6.4 27.1 11.3 38.9 11.3 7.9 0 13.6-2.1 13.6-8.7 0-17-54-10.6-54-49.9 0-25.2 19.2-40.2 48-40.2 11.8 0 23.5 1.8 35.3 6.5v33.4c-10.8-5.8-24.5-9.1-35.3-9.1-7.5 0-12.1 2.2-12.1 7.7 0 16 54.3 8.4 54.3 50.7zm68.8-56.6h-27V275c0 20.9 22.5 14.4 27 12.6v28.9c-4.7 2.6-13.3 4.7-24.9 4.7-21.1 0-36.9-15.5-36.9-36.5l.2-113.9 34.7-7.4v30.8H191zm74 2.4c-4.5-1.5-18.7-3.6-27.1 7.4v84.4h-35.5V194.2h30.7l2.2 10.5c8.3-15.3 24.9-12.2 29.6-10.5h.1zm44.1 91.8h-35.7V194.2h35.7zm0-142.9l-35.7 7.6v-28.9l35.7-7.6zm74.1 145.5c-12.4 0-20-5.3-25.1-9l-.1 40.2-35.5 7.5V194.2h31.3l1.8 8.8c4.9-4.5 13.9-11.1 27.8-11.1 24.9 0 48.4 22.5 48.4 63.8 0 45.1-23.2 65.5-48.6 65.6zm160.4-51.5h-69.5c1.6 16.6 13.8 21.5 27.6 21.5 14.1 0 25.2-3 34.9-7.9V312c-9.7 5.3-22.4 9.2-39.4 9.2-34.6 0-58.8-21.7-58.8-64.5 0-36.2 20.5-64.9 54.3-64.9 33.7 0 51.3 28.7 51.3 65.1 0 3.5-.3 10.9-.4 12.9z"
                }
            }
        ]
    })(props);
}
function FaCcVisa(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M470.1 231.3s7.6 37.2 9.3 45H446c3.3-8.9 16-43.5 16-43.5-.2.3 3.3-9.1 5.3-14.9l2.8 13.4zM576 80v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h480c26.5 0 48 21.5 48 48zM152.5 331.2L215.7 176h-42.5l-39.3 106-4.3-21.5-14-71.4c-2.3-9.9-9.4-12.7-18.2-13.1H32.7l-.7 3.1c15.8 4 29.9 9.8 42.2 17.1l35.8 135h42.5zm94.4.2L272.1 176h-40.2l-25.1 155.4h40.1zm139.9-50.8c.2-17.7-10.6-31.2-33.7-42.3-14.1-7.1-22.7-11.9-22.7-19.2.2-6.6 7.3-13.4 23.1-13.4 13.1-.3 22.7 2.8 29.9 5.9l3.6 1.7 5.5-33.6c-7.9-3.1-20.5-6.6-36-6.6-39.7 0-67.6 21.2-67.8 51.4-.3 22.3 20 34.7 35.2 42.2 15.5 7.6 20.8 12.6 20.8 19.3-.2 10.4-12.6 15.2-24.1 15.2-16 0-24.6-2.5-37.7-8.3l-5.3-2.5-5.6 34.9c9.4 4.3 26.8 8.1 44.8 8.3 42.2.1 69.7-20.8 70-53zM528 331.4L495.6 176h-31.1c-9.6 0-16.9 2.8-21 12.9l-59.7 142.5H426s6.9-19.2 8.4-23.3H486c1.2 5.5 4.8 23.3 4.8 23.3H528z"
                }
            }
        ]
    })(props);
}
function FaCentercode(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M329.2 268.6c-3.8 35.2-35.4 60.6-70.6 56.8-35.2-3.8-60.6-35.4-56.8-70.6 3.8-35.2 35.4-60.6 70.6-56.8 35.1 3.8 60.6 35.4 56.8 70.6zm-85.8 235.1C96.7 496-8.2 365.5 10.1 224.3c11.2-86.6 65.8-156.9 139.1-192 161-77.1 349.7 37.4 354.7 216.6 4.1 147-118.4 262.2-260.5 254.8zm179.9-180c27.9-118-160.5-205.9-237.2-234.2-57.5 56.3-69.1 188.6-33.8 344.4 68.8 15.8 169.1-26.4 271-110.2z"
                }
            }
        ]
    })(props);
}
function FaCentos(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M289.6 97.5l31.6 31.7-76.3 76.5V97.5zm-162.4 31.7l76.3 76.5V97.5h-44.7zm41.5-41.6h44.7v127.9l10.8 10.8 10.8-10.8V87.6h44.7L224.2 32zm26.2 168.1l-10.8-10.8H55.5v-44.8L0 255.7l55.5 55.6v-44.8h128.6l10.8-10.8zm79.3-20.7h107.9v-44.8l-31.6-31.7zm173.3 20.7L392 200.1v44.8H264.3l-10.8 10.8 10.8 10.8H392v44.8l55.5-55.6zM65.4 176.2l32.5-31.7 90.3 90.5h15.3v-15.3l-90.3-90.5 31.6-31.7H65.4zm316.7-78.7h-78.5l31.6 31.7-90.3 90.5V235h15.3l90.3-90.5 31.6 31.7zM203.5 413.9V305.8l-76.3 76.5 31.6 31.7h44.7zM65.4 235h108.8l-76.3-76.5-32.5 31.7zm316.7 100.2l-31.6 31.7-90.3-90.5h-15.3v15.3l90.3 90.5-31.6 31.7h78.5zm0-58.8H274.2l76.3 76.5 31.6-31.7zm-60.9 105.8l-76.3-76.5v108.1h44.7zM97.9 352.9l76.3-76.5H65.4v44.8zm181.8 70.9H235V295.9l-10.8-10.8-10.8 10.8v127.9h-44.7l55.5 55.6zm-166.5-41.6l90.3-90.5v-15.3h-15.3l-90.3 90.5-32.5-31.7v78.7h79.4z"
                }
            }
        ]
    })(props);
}
function FaChrome(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M131.5 217.5L55.1 100.1c47.6-59.2 119-91.8 192-92.1 42.3-.3 85.5 10.5 124.8 33.2 43.4 25.2 76.4 61.4 97.4 103L264 133.4c-58.1-3.4-113.4 29.3-132.5 84.1zm32.9 38.5c0 46.2 37.4 83.6 83.6 83.6s83.6-37.4 83.6-83.6-37.4-83.6-83.6-83.6-83.6 37.3-83.6 83.6zm314.9-89.2L339.6 174c37.9 44.3 38.5 108.2 6.6 157.2L234.1 503.6c46.5 2.5 94.4-7.7 137.8-32.9 107.4-62 150.9-192 107.4-303.9zM133.7 303.6L40.4 120.1C14.9 159.1 0 205.9 0 256c0 124 90.8 226.7 209.5 244.9l63.7-124.8c-57.6 10.8-113.2-20.8-139.5-72.5z"
                }
            }
        ]
    })(props);
}
function FaChromecast(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M447.8,64H64c-23.6,0-42.7,19.1-42.7,42.7v63.9H64v-63.9h383.8v298.6H298.6V448H448c23.6,0,42.7-19.1,42.7-42.7V106.7 C490.7,83.1,471.4,64,447.8,64z M21.3,383.6L21.3,383.6l0,63.9h63.9C85.2,412.2,56.6,383.6,21.3,383.6L21.3,383.6z M21.3,298.6V341 c58.9,0,106.6,48.1,106.6,107h42.7C170.7,365.6,103.7,298.7,21.3,298.6z M213.4,448h42.7c-0.5-129.5-105.3-234.3-234.8-234.6l0,42.4 C127.3,255.6,213.3,342,213.4,448z"
                }
            }
        ]
    })(props);
}
function FaCloudflare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M407.906,319.913l-230.8-2.928a4.58,4.58,0,0,1-3.632-1.926,4.648,4.648,0,0,1-.494-4.147,6.143,6.143,0,0,1,5.361-4.076L411.281,303.9c27.631-1.26,57.546-23.574,68.022-50.784l13.286-34.542a7.944,7.944,0,0,0,.524-2.936,7.735,7.735,0,0,0-.164-1.631A151.91,151.91,0,0,0,201.257,198.4,68.12,68.12,0,0,0,94.2,269.59C41.924,271.106,0,313.728,0,366.12a96.054,96.054,0,0,0,1.029,13.958,4.508,4.508,0,0,0,4.445,3.871l426.1.051c.043,0,.08-.019.122-.02a5.606,5.606,0,0,0,5.271-4l3.273-11.265c3.9-13.4,2.448-25.8-4.1-34.9C430.124,325.423,420.09,320.487,407.906,319.913ZM513.856,221.1c-2.141,0-4.271.062-6.391.164a3.771,3.771,0,0,0-3.324,2.653l-9.077,31.193c-3.9,13.4-2.449,25.786,4.1,34.89,6.02,8.4,16.054,13.323,28.238,13.9l49.2,2.939a4.491,4.491,0,0,1,3.51,1.894,4.64,4.64,0,0,1,.514,4.169,6.153,6.153,0,0,1-5.351,4.075l-51.125,2.939c-27.754,1.27-57.669,23.574-68.145,50.784l-3.695,9.606a2.716,2.716,0,0,0,2.427,3.68c.046,0,.088.017.136.017h175.91a4.69,4.69,0,0,0,4.539-3.37,124.807,124.807,0,0,0,4.682-34C640,277.3,583.524,221.1,513.856,221.1Z"
                }
            }
        ]
    })(props);
}
function FaCloudscale(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M318.1 154l-9.4 7.6c-22.5-19.3-51.5-33.6-83.3-33.6C153.8 128 96 188.8 96 260.3c0 6.6.4 13.1 1.4 19.4-2-56 41.8-97.4 92.6-97.4 24.2 0 46.2 9.4 62.6 24.7l-25.2 20.4c-8.3-.9-16.8 1.8-23.1 8.1-11.1 11-11.1 28.9 0 40 11.1 11 28.9 11 40 0 6.3-6.3 9-14.9 8.1-23.1l75.2-88.8c6.3-6.5-3.3-15.9-9.5-9.6zm-83.8 111.5c-5.6 5.5-14.6 5.5-20.2 0-5.6-5.6-5.6-14.6 0-20.2s14.6-5.6 20.2 0 5.6 14.7 0 20.2zM224 32C100.5 32 0 132.5 0 256s100.5 224 224 224 224-100.5 224-224S347.5 32 224 32zm0 384c-88.2 0-160-71.8-160-160S135.8 96 224 96s160 71.8 160 160-71.8 160-160 160z"
                }
            }
        ]
    })(props);
}
function FaCloudsmith(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 332 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M332.5 419.9c0 46.4-37.6 84.1-84 84.1s-84-37.7-84-84.1 37.6-84 84-84 84 37.6 84 84zm-84-243.9c46.4 0 80-37.6 80-84s-33.6-84-80-84-88 37.6-88 84-29.6 76-76 76-84 41.6-84 88 37.6 80 84 80 84-33.6 84-80 33.6-80 80-80z"
                }
            }
        ]
    })(props);
}
function FaCloudversify(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 616 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M148.6 304c8.2 68.5 67.4 115.5 146 111.3 51.2 43.3 136.8 45.8 186.4-5.6 69.2 1.1 118.5-44.6 131.5-99.5 14.8-62.5-18.2-132.5-92.1-155.1-33-88.1-131.4-101.5-186.5-85-57.3 17.3-84.3 53.2-99.3 109.7-7.8 2.7-26.5 8.9-45 24.1 11.7 0 15.2 8.9 15.2 19.5v20.4c0 10.7-8.7 19.5-19.5 19.5h-20.2c-10.7 0-19.5-6-19.5-16.7V240H98.8C95 240 88 244.3 88 251.9v40.4c0 6.4 5.3 11.8 11.7 11.8h48.9zm227.4 8c-10.7 46.3 21.7 72.4 55.3 86.8C324.1 432.6 259.7 348 296 288c-33.2 21.6-33.7 71.2-29.2 92.9-17.9-12.4-53.8-32.4-57.4-79.8-3-39.9 21.5-75.7 57-93.9C297 191.4 369.9 198.7 400 248c-14.1-48-53.8-70.1-101.8-74.8 30.9-30.7 64.4-50.3 114.2-43.7 69.8 9.3 133.2 82.8 67.7 150.5 35-16.3 48.7-54.4 47.5-76.9l10.5 19.6c11.8 22 15.2 47.6 9.4 72-9.2 39-40.6 68.8-79.7 76.5-32.1 6.3-83.1-5.1-91.8-59.2zM128 208H88.2c-8.9 0-16.2-7.3-16.2-16.2v-39.6c0-8.9 7.3-16.2 16.2-16.2H128c8.9 0 16.2 7.3 16.2 16.2v39.6c0 8.9-7.3 16.2-16.2 16.2zM10.1 168C4.5 168 0 163.5 0 157.9v-27.8c0-5.6 4.5-10.1 10.1-10.1h27.7c5.5 0 10.1 4.5 10.1 10.1v27.8c0 5.6-4.5 10.1-10.1 10.1H10.1zM168 142.7v-21.4c0-5.1 4.2-9.3 9.3-9.3h21.4c5.1 0 9.3 4.2 9.3 9.3v21.4c0 5.1-4.2 9.3-9.3 9.3h-21.4c-5.1 0-9.3-4.2-9.3-9.3zM56 235.5v25c0 6.3-5.1 11.5-11.4 11.5H19.4C13.1 272 8 266.8 8 260.5v-25c0-6.3 5.1-11.5 11.4-11.5h25.1c6.4 0 11.5 5.2 11.5 11.5z"
                }
            }
        ]
    })(props);
}
function FaCodepen(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M502.285 159.704l-234-156c-7.987-4.915-16.511-4.96-24.571 0l-234 156C3.714 163.703 0 170.847 0 177.989v155.999c0 7.143 3.714 14.286 9.715 18.286l234 156.022c7.987 4.915 16.511 4.96 24.571 0l234-156.022c6-3.999 9.715-11.143 9.715-18.286V177.989c-.001-7.142-3.715-14.286-9.716-18.285zM278 63.131l172.286 114.858-76.857 51.429L278 165.703V63.131zm-44 0v102.572l-95.429 63.715-76.857-51.429L234 63.131zM44 219.132l55.143 36.857L44 292.846v-73.714zm190 229.715L61.714 333.989l76.857-51.429L234 346.275v102.572zm22-140.858l-77.715-52 77.715-52 77.715 52-77.715 52zm22 140.858V346.275l95.429-63.715 76.857 51.429L278 448.847zm190-156.001l-55.143-36.857L468 219.132v73.714z"
                }
            }
        ]
    })(props);
}
function FaCodiepie(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 472 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M422.5 202.9c30.7 0 33.5 53.1-.3 53.1h-10.8v44.3h-26.6v-97.4h37.7zM472 352.6C429.9 444.5 350.4 504 248 504 111 504 0 393 0 256S111 8 248 8c97.4 0 172.8 53.7 218.2 138.4l-186 108.8L472 352.6zm-38.5 12.5l-60.3-30.7c-27.1 44.3-70.4 71.4-122.4 71.4-82.5 0-149.2-66.7-149.2-148.9 0-82.5 66.7-149.2 149.2-149.2 48.4 0 88.9 23.5 116.9 63.4l59.5-34.6c-40.7-62.6-104.7-100-179.2-100-121.2 0-219.5 98.3-219.5 219.5S126.8 475.5 248 475.5c78.6 0 146.5-42.1 185.5-110.4z"
                }
            }
        ]
    })(props);
}
function FaConfluence(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2.3 412.2c-4.5 7.6-2.1 17.5 5.5 22.2l105.9 65.2c7.7 4.7 17.7 2.4 22.4-5.3 0-.1.1-.2.1-.2 67.1-112.2 80.5-95.9 280.9-.7 8.1 3.9 17.8.4 21.7-7.7.1-.1.1-.3.2-.4l50.4-114.1c3.6-8.1-.1-17.6-8.1-21.3-22.2-10.4-66.2-31.2-105.9-50.3C127.5 179 44.6 345.3 2.3 412.2zm507.4-312.1c4.5-7.6 2.1-17.5-5.5-22.2L398.4 12.8c-7.5-5-17.6-3.1-22.6 4.4-.2.3-.4.6-.6 1-67.3 112.6-81.1 95.6-280.6.9-8.1-3.9-17.8-.4-21.7 7.7-.1.1-.1.3-.2.4L22.2 141.3c-3.6 8.1.1 17.6 8.1 21.3 22.2 10.4 66.3 31.2 106 50.4 248 120 330.8-45.4 373.4-112.9z"
                }
            }
        ]
    })(props);
}
function FaConnectdevelop(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M550.5 241l-50.089-86.786c1.071-2.142 1.875-4.553 1.875-7.232 0-8.036-6.696-14.733-14.732-15.001l-55.447-95.893c.536-1.607 1.071-3.214 1.071-4.821 0-8.571-6.964-15.268-15.268-15.268-4.821 0-8.839 2.143-11.786 5.625H299.518C296.839 18.143 292.821 16 288 16s-8.839 2.143-11.518 5.625H170.411C167.464 18.143 163.447 16 158.625 16c-8.303 0-15.268 6.696-15.268 15.268 0 1.607.536 3.482 1.072 4.821l-55.983 97.233c-5.356 2.41-9.107 7.5-9.107 13.661 0 .535.268 1.071.268 1.607l-53.304 92.143c-7.232 1.339-12.59 7.5-12.59 15 0 7.232 5.089 13.393 12.054 15l55.179 95.358c-.536 1.607-.804 2.946-.804 4.821 0 7.232 5.089 13.393 12.054 14.732l51.697 89.732c-.536 1.607-1.071 3.482-1.071 5.357 0 8.571 6.964 15.268 15.268 15.268 4.821 0 8.839-2.143 11.518-5.357h106.875C279.161 493.857 283.447 496 288 496s8.839-2.143 11.518-5.357h107.143c2.678 2.946 6.696 4.821 10.982 4.821 8.571 0 15.268-6.964 15.268-15.268 0-1.607-.267-2.946-.803-4.285l51.697-90.268c6.964-1.339 12.054-7.5 12.054-14.732 0-1.607-.268-3.214-.804-4.821l54.911-95.358c6.964-1.339 12.322-7.5 12.322-15-.002-7.232-5.092-13.393-11.788-14.732zM153.535 450.732l-43.66-75.803h43.66v75.803zm0-83.839h-43.66c-.268-1.071-.804-2.142-1.339-3.214l44.999-47.41v50.624zm0-62.411l-50.357 53.304c-1.339-.536-2.679-1.34-4.018-1.607L43.447 259.75c.535-1.339.535-2.679.535-4.018s0-2.41-.268-3.482l51.965-90c2.679-.268 5.357-1.072 7.768-2.679l50.089 51.965v92.946zm0-102.322l-45.803-47.41c1.339-2.143 2.143-4.821 2.143-7.767 0-.268-.268-.804-.268-1.072l43.928-15.804v72.053zm0-80.625l-43.66 15.804 43.66-75.536v59.732zm326.519 39.108l.804 1.339L445.5 329.125l-63.75-67.232 98.036-101.518.268.268zM291.75 355.107l11.518 11.786H280.5l11.25-11.786zm-.268-11.25l-83.303-85.446 79.553-84.375 83.036 87.589-79.286 82.232zm5.357 5.893l79.286-82.232 67.5 71.25-5.892 28.125H313.714l-16.875-17.143zM410.411 44.393c1.071.536 2.142 1.072 3.482 1.34l57.857 100.714v.536c0 2.946.803 5.624 2.143 7.767L376.393 256l-83.035-87.589L410.411 44.393zm-9.107-2.143L287.732 162.518l-57.054-60.268 166.339-60h4.287zm-123.483 0c2.678 2.678 6.16 4.285 10.179 4.285s7.5-1.607 10.179-4.285h75L224.786 95.821 173.893 42.25h103.928zm-116.249 5.625l1.071-2.142a33.834 33.834 0 0 0 2.679-.804l51.161 53.84-54.911 19.821V47.875zm0 79.286l60.803-21.964 59.732 63.214-79.553 84.107-40.982-42.053v-83.304zm0 92.678L198 257.607l-36.428 38.304v-76.072zm0 87.858l42.053-44.464 82.768 85.982-17.143 17.678H161.572v-59.196zm6.964 162.053c-1.607-1.607-3.482-2.678-5.893-3.482l-1.071-1.607v-89.732h99.91l-91.607 94.821h-1.339zm129.911 0c-2.679-2.41-6.428-4.285-10.447-4.285s-7.767 1.875-10.447 4.285h-96.429l91.607-94.821h38.304l91.607 94.821H298.447zm120-11.786l-4.286 7.5c-1.339.268-2.41.803-3.482 1.339l-89.196-91.875h114.376l-17.412 83.036zm12.856-22.232l12.858-60.803h21.964l-34.822 60.803zm34.822-68.839h-20.357l4.553-21.16 17.143 18.214c-.535.803-1.071 1.874-1.339 2.946zm66.161-107.411l-55.447 96.697c-1.339.535-2.679 1.071-4.018 1.874l-20.625-21.964 34.554-163.928 45.803 79.286c-.267 1.339-.803 2.678-.803 4.285 0 1.339.268 2.411.536 3.75z"
                }
            }
        ]
    })(props);
}
function FaContao(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M45.4 305c14.4 67.1 26.4 129 68.2 175H34c-18.7 0-34-15.2-34-34V66c0-18.7 15.2-34 34-34h57.7C77.9 44.6 65.6 59.2 54.8 75.6c-45.4 70-27 146.8-9.4 229.4zM478 32h-90.2c21.4 21.4 39.2 49.5 52.7 84.1l-137.1 29.3c-14.9-29-37.8-53.3-82.6-43.9-24.6 5.3-41 19.3-48.3 34.6-8.8 18.7-13.2 39.8 8.2 140.3 21.1 100.2 33.7 117.7 49.5 131.2 12.9 11.1 33.4 17 58.3 11.7 44.5-9.4 55.7-40.7 57.4-73.2l137.4-29.6c3.2 71.5-18.7 125.2-57.4 163.6H478c18.7 0 34-15.2 34-34V66c0-18.8-15.2-34-34-34z"
                }
            }
        ]
    })(props);
}
function FaCottonBureau(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M474.31 330.41c-23.66 91.85-94.23 144.59-201.9 148.35V429.6c0-48 26.41-74.39 74.39-74.39 62 0 99.2-37.2 99.2-99.21 0-61.37-36.53-98.28-97.38-99.06-33-69.32-146.5-64.65-177.24 0C110.52 157.72 74 194.63 74 256c0 62.13 37.27 99.41 99.4 99.41 48 0 74.55 26.23 74.55 74.39V479c-134.43-5-211.1-85.07-211.1-223 0-141.82 81.35-223.2 223.2-223.2 114.77 0 189.84 53.2 214.69 148.81H500C473.88 71.51 388.22 8 259.82 8 105 8 12 101.19 12 255.82 12 411.14 105.19 504.34 259.82 504c128.27 0 213.87-63.81 239.67-173.59zM357 182.33c41.37 3.45 64.2 29 64.2 73.67 0 48-26.43 74.41-74.4 74.41-28.61 0-49.33-9.59-61.59-27.33 83.06-16.55 75.59-99.67 71.79-120.75zm-81.68 97.36c-2.46-10.34-16.33-87 56.23-97 2.27 10.09 16.52 87.11-56.26 97zM260 132c28.61 0 49 9.67 61.44 27.61-28.36 5.48-49.36 20.59-61.59 43.45-12.23-22.86-33.23-38-61.6-43.45 12.41-17.69 33.27-27.35 61.57-27.35zm-71.52 50.72c73.17 10.57 58.91 86.81 56.49 97-72.41-9.84-59-86.95-56.25-97zM173.2 330.41c-48 0-74.4-26.4-74.4-74.41 0-44.36 22.86-70 64.22-73.67-6.75 37.2-1.38 106.53 71.65 120.75-12.14 17.63-32.84 27.3-61.14 27.3zm53.21 12.39A80.8 80.8 0 0 0 260 309.25c7.77 14.49 19.33 25.54 33.82 33.55a80.28 80.28 0 0 0-33.58 33.83c-8-14.5-19.07-26.23-33.56-33.83z"
                }
            }
        ]
    })(props);
}
function FaCpanel(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M210.3 220.2c-5.6-24.8-26.9-41.2-51-41.2h-37c-7.1 0-12.5 4.5-14.3 10.9L73.1 320l24.7-.1c6.8 0 12.3-4.5 14.2-10.7l25.8-95.7h19.8c8.4 0 16.2 5.6 18.3 14.8 2.5 10.9-5.9 22.6-18.3 22.6h-10.3c-7 0-12.5 4.6-14.3 10.8l-6.4 23.8h32c37.2 0 58.3-36.2 51.7-65.3zm-156.5 28h18.6c6.9 0 12.4-4.4 14.3-10.9l6.2-23.6h-40C30 213.7 9 227.8 1.7 254.8-7 288.6 18.5 320 52 320h12.4l7.1-26.1c1.2-4.4-2.2-8.3-6.4-8.3H53.8c-24.7 0-24.9-37.4 0-37.4zm247.5-34.8h-77.9l-3.5 13.4c-2.4 9.6 4.5 18.5 14.2 18.5h57.5c4 0 2.4 4.3 2.1 5.3l-8.6 31.8c-.4 1.4-.9 5.3-5.5 5.3h-34.9c-5.3 0-5.3-7.9 0-7.9h21.6c6.8 0 12.3-4.6 14.2-10.8l3.5-13.2h-48.4c-39.2 0-43.6 63.8-.7 63.8l57.5.2c11.2 0 20.6-7.2 23.4-17.8l14-51.8c4.8-19.2-9.7-36.8-28.5-36.8zM633.1 179h-18.9c-4.9 0-9.2 3.2-10.4 7.9L568.2 320c20.7 0 39.8-13.8 44.9-34.5l26.5-98.2c1.2-4.3-2-8.3-6.5-8.3zm-236.3 34.7v.1h-48.3l-26.2 98c-1.2 4.4 2.2 8.3 6.4 8.3h18.9c4.8 0 9.2-3 10.4-7.8l17.2-64H395c12.5 0 21.4 11.8 18.1 23.4l-10.6 40c-1.2 4.3 1.9 8.3 6.4 8.3H428c4.6 0 9.1-2.9 10.3-7.8l8.8-33.1c9-33.1-15.9-65.4-50.3-65.4zm98.3 74.6c-3.6 0-6-3.4-5.1-6.7l8-30c.9-3.9 3.7-6 7.8-6h32.9c2.6 0 4.6 2.4 3.9 5.1l-.7 2.6c-.6 2-1.9 3-3.9 3h-21.6c-7 0-12.6 4.6-14.2 10.8l-3.5 13h53.4c10.5 0 20.3-6.6 23.2-17.6l3.2-12c4.9-19.1-9.3-36.8-28.3-36.8h-47.3c-17.9 0-33.8 12-38.6 29.6l-10.8 40c-5 17.7 8.3 36.7 28.3 36.7h66.7c6.8 0 12.3-4.5 14.2-10.7l5.7-21z"
                }
            }
        ]
    })(props);
}
function FaCreativeCommonsBy(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M314.9 194.4v101.4h-28.3v120.5h-77.1V295.9h-28.3V194.4c0-4.4 1.6-8.2 4.6-11.3 3.1-3.1 6.9-4.7 11.3-4.7H299c4.1 0 7.8 1.6 11.1 4.7 3.1 3.2 4.8 6.9 4.8 11.3zm-101.5-63.7c0-23.3 11.5-35 34.5-35s34.5 11.7 34.5 35c0 23-11.5 34.5-34.5 34.5s-34.5-11.5-34.5-34.5zM247.6 8C389.4 8 496 118.1 496 256c0 147.1-118.5 248-248.4 248C113.6 504 0 394.5 0 256 0 123.1 104.7 8 247.6 8zm.8 44.7C130.2 52.7 44.7 150.6 44.7 256c0 109.8 91.2 202.8 203.7 202.8 103.2 0 202.8-81.1 202.8-202.8.1-113.8-90.2-203.3-202.8-203.3z"
                }
            }
        ]
    })(props);
}
function FaCreativeCommonsNcEu(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M247.7 8C103.6 8 0 124.8 0 256c0 136.3 111.7 248 247.7 248C377.9 504 496 403.1 496 256 496 117 388.4 8 247.7 8zm.6 450.7c-112 0-203.6-92.5-203.6-202.7 0-23.2 3.7-45.2 10.9-66l65.7 29.1h-4.7v29.5h23.3c0 6.2-.4 3.2-.4 19.5h-22.8v29.5h27c11.4 67 67.2 101.3 124.6 101.3 26.6 0 50.6-7.9 64.8-15.8l-10-46.1c-8.7 4.6-28.2 10.8-47.3 10.8-28.2 0-58.1-10.9-67.3-50.2h90.3l128.3 56.8c-1.5 2.1-56.2 104.3-178.8 104.3zm-16.7-190.6l-.5-.4.9.4h-.4zm77.2-19.5h3.7v-29.5h-70.3l-28.6-12.6c2.5-5.5 5.4-10.5 8.8-14.3 12.9-15.8 31.1-22.4 51.1-22.4 18.3 0 35.3 5.4 46.1 10l11.6-47.3c-15-6.6-37-12.4-62.3-12.4-39 0-72.2 15.8-95.9 42.3-5.3 6.1-9.8 12.9-13.9 20.1l-81.6-36.1c64.6-96.8 157.7-93.6 170.7-93.6 113 0 203 90.2 203 203.4 0 18.7-2.1 36.3-6.3 52.9l-136.1-60.5z"
                }
            }
        ]
    })(props);
}
function FaCreativeCommonsNcJp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M247.7 8C103.6 8 0 124.8 0 256c0 136.4 111.8 248 247.7 248C377.9 504 496 403.2 496 256 496 117.2 388.5 8 247.7 8zm.6 450.7c-112 0-203.6-92.5-203.6-202.7 0-21.1 3-41.2 9-60.3l127 56.5h-27.9v38.6h58.1l5.7 11.8v18.7h-63.8V360h63.8v56h61.7v-56h64.2v-35.7l81 36.1c-1.5 2.2-57.1 98.3-175.2 98.3zm87.6-137.3h-57.6v-18.7l2.9-5.6 54.7 24.3zm6.5-51.4v-17.8h-38.6l63-116H301l-43.4 96-23-10.2-39.6-85.7h-65.8l27.3 51-81.9-36.5c27.8-44.1 82.6-98.1 173.7-98.1 112.8 0 203 90 203 203.4 0 21-2.7 40.6-7.9 59l-101-45.1z"
                }
            }
        ]
    })(props);
}
function FaCreativeCommonsNc(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M247.6 8C387.4 8 496 115.9 496 256c0 147.2-118.5 248-248.4 248C113.1 504 0 393.2 0 256 0 123.1 104.7 8 247.6 8zM55.8 189.1c-7.4 20.4-11.1 42.7-11.1 66.9 0 110.9 92.1 202.4 203.7 202.4 122.4 0 177.2-101.8 178.5-104.1l-93.4-41.6c-7.7 37.1-41.2 53-68.2 55.4v38.1h-28.8V368c-27.5-.3-52.6-10.2-75.3-29.7l34.1-34.5c31.7 29.4 86.4 31.8 86.4-2.2 0-6.2-2.2-11.2-6.6-15.1-14.2-6-1.8-.1-219.3-97.4zM248.4 52.3c-38.4 0-112.4 8.7-170.5 93l94.8 42.5c10-31.3 40.4-42.9 63.8-44.3v-38.1h28.8v38.1c22.7 1.2 43.4 8.9 62 23L295 199.7c-42.7-29.9-83.5-8-70 11.1 53.4 24.1 43.8 19.8 93 41.6l127.1 56.7c4.1-17.4 6.2-35.1 6.2-53.1 0-57-19.8-105-59.3-143.9-39.3-39.9-87.2-59.8-143.6-59.8z"
                }
            }
        ]
    })(props);
}
function FaCreativeCommonsNd(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M247.6 8C389.4 8 496 118.1 496 256c0 147.1-118.5 248-248.4 248C113.6 504 0 394.5 0 256 0 123.1 104.7 8 247.6 8zm.8 44.7C130.2 52.7 44.7 150.6 44.7 256c0 109.8 91.2 202.8 203.7 202.8 103.2 0 202.8-81.1 202.8-202.8.1-113.8-90.2-203.3-202.8-203.3zm94 144.3v42.5H162.1V197h180.3zm0 79.8v42.5H162.1v-42.5h180.3z"
                }
            }
        ]
    })(props);
}
function FaCreativeCommonsPdAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M247.6 8C104.7 8 0 123.1 0 256c0 138.5 113.6 248 247.6 248C377.5 504 496 403.1 496 256 496 118.1 389.4 8 247.6 8zm.8 450.8c-112.5 0-203.7-93-203.7-202.8 0-105.4 85.5-203.3 203.7-203.3 112.6 0 202.9 89.5 202.8 203.3 0 121.7-99.6 202.8-202.8 202.8zM316.7 186h-53.2v137.2h53.2c21.4 0 70-5.1 70-68.6 0-63.4-48.6-68.6-70-68.6zm.8 108.5h-19.9v-79.7l19.4-.1c3.8 0 35-2.1 35 39.9 0 24.6-10.5 39.9-34.5 39.9zM203.7 186h-68.2v137.3h34.6V279h27c54.1 0 57.1-37.5 57.1-46.5 0-31-16.8-46.5-50.5-46.5zm-4.9 67.3h-29.2v-41.6h28.3c30.9 0 28.8 41.6.9 41.6z"
                }
            }
        ]
    })(props);
}
function FaCreativeCommonsPd(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111 8 0 119.1 0 256c0 137 111 248 248 248s248-111 248-248C496 119.1 385 8 248 8zm0 449.5c-139.2 0-235.8-138-190.2-267.9l78.8 35.1c-2.1 10.5-3.3 21.5-3.3 32.9 0 99 73.9 126.9 120.4 126.9 22.9 0 53.5-6.7 79.4-29.5L297 311.1c-5.5 6.3-17.6 16.7-36.3 16.7-37.8 0-53.7-39.9-53.9-71.9 230.4 102.6 216.5 96.5 217.9 96.8-34.3 62.4-100.6 104.8-176.7 104.8zm194.2-150l-224-100c18.8-34 54.9-30.7 74.7-11l40.4-41.6c-27.1-23.3-58-27.5-78.1-27.5-47.4 0-80.9 20.5-100.7 51.6l-74.9-33.4c36.1-54.9 98.1-91.2 168.5-91.2 111.1 0 201.5 90.4 201.5 201.5 0 18-2.4 35.4-6.8 52-.3-.1-.4-.2-.6-.4z"
                }
            }
        ]
    })(props);
}
function FaCreativeCommonsRemix(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M247.6 8C389.4 8 496 118.1 496 256c0 147.1-118.5 248-248.4 248C113.6 504 0 394.5 0 256 0 123.1 104.7 8 247.6 8zm.8 44.7C130.2 52.7 44.7 150.6 44.7 256c0 109.8 91.2 202.8 203.7 202.8 103.2 0 202.8-81.1 202.8-202.8.1-113.8-90.2-203.3-202.8-203.3zm161.7 207.7l4.9 2.2v70c-7.2 3.6-63.4 27.5-67.3 28.8-6.5-1.8-113.7-46.8-137.3-56.2l-64.2 26.6-63.3-27.5v-63.8l59.3-24.8c-.7-.7-.4 5-.4-70.4l67.3-29.7L361 178.5v61.6l49.1 20.3zm-70.4 81.5v-43.8h-.4v-1.8l-113.8-46.5V295l113.8 46.9v-.4l.4.4zm7.5-57.6l39.9-16.4-36.8-15.5-39 16.4 35.9 15.5zm52.3 38.1v-43L355.2 298v43.4l44.3-19z"
                }
            }
        ]
    })(props);
}
function FaCreativeCommonsSa(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M247.6 8C389.4 8 496 118.1 496 256c0 147.1-118.5 248-248.4 248C113.6 504 0 394.5 0 256 0 123.1 104.7 8 247.6 8zm.8 44.7C130.2 52.7 44.7 150.6 44.7 256c0 109.8 91.2 202.8 203.7 202.8 103.2 0 202.8-81.1 202.8-202.8.1-113.8-90.2-203.3-202.8-203.3zM137.7 221c13-83.9 80.5-95.7 108.9-95.7 99.8 0 127.5 82.5 127.5 134.2 0 63.6-41 132.9-128.9 132.9-38.9 0-99.1-20-109.4-97h62.5c1.5 30.1 19.6 45.2 54.5 45.2 23.3 0 58-18.2 58-82.8 0-82.5-49.1-80.6-56.7-80.6-33.1 0-51.7 14.6-55.8 43.8h18.2l-49.2 49.2-49-49.2h19.4z"
                }
            }
        ]
    })(props);
}
function FaCreativeCommonsSamplingPlus(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M247.6 8C389.4 8 496 118.1 496 256c0 147.1-118.5 248-248.4 248C113.6 504 0 394.5 0 256 0 123.1 104.7 8 247.6 8zm.8 44.7C130.2 52.7 44.7 150.6 44.7 256c0 109.8 91.2 202.8 203.7 202.8 103.2 0 202.8-81.1 202.8-202.8.1-113.8-90.2-203.3-202.8-203.3zm107 205.6c-4.7 0-9 2.8-10.7 7.2l-4 9.5-11-92.8c-1.7-13.9-22-13.4-23.1.4l-4.3 51.4-5.2-68.8c-1.1-14.3-22.1-14.2-23.2 0l-3.5 44.9-5.9-94.3c-.9-14.5-22.3-14.4-23.2 0l-5.1 83.7-4.3-66.3c-.9-14.4-22.2-14.4-23.2 0l-5.3 80.2-4.1-57c-1.1-14.3-22-14.3-23.2-.2l-7.7 89.8-1.8-12.2c-1.7-11.4-17.1-13.6-22-3.3l-13.2 27.7H87.5v23.2h51.3c4.4 0 8.4-2.5 10.4-6.4l10.7 73.1c2 13.5 21.9 13 23.1-.7l3.8-43.6 5.7 78.3c1.1 14.4 22.3 14.2 23.2-.1l4.6-70.4 4.8 73.3c.9 14.4 22.3 14.4 23.2-.1l4.9-80.5 4.5 71.8c.9 14.3 22.1 14.5 23.2.2l4.6-58.6 4.9 64.4c1.1 14.3 22 14.2 23.1.1l6.8-83 2.7 22.3c1.4 11.8 17.7 14.1 22.3 3.1l18-43.4h50.5V258l-58.4.3zm-78 5.2h-21.9v21.9c0 4.1-3.3 7.5-7.5 7.5-4.1 0-7.5-3.3-7.5-7.5v-21.9h-21.9c-4.1 0-7.5-3.3-7.5-7.5 0-4.1 3.4-7.5 7.5-7.5h21.9v-21.9c0-4.1 3.4-7.5 7.5-7.5s7.5 3.3 7.5 7.5v21.9h21.9c4.1 0 7.5 3.3 7.5 7.5 0 4.1-3.4 7.5-7.5 7.5z"
                }
            }
        ]
    })(props);
}
function FaCreativeCommonsSampling(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M247.6 8C389.4 8 496 118.1 496 256c0 147.1-118.5 248-248.4 248C113.6 504 0 394.5 0 256 0 123.1 104.7 8 247.6 8zm.8 44.7C130.2 52.7 44.7 150.6 44.7 256c0 109.8 91.2 202.8 203.7 202.8 103.2 0 202.8-81.1 202.8-202.8.1-113.8-90.2-203.3-202.8-203.3zm3.6 53.2c2.8-.3 11.5 1 11.5 11.5l6.6 107.2 4.9-59.3c0-6 4.7-10.6 10.6-10.6 5.9 0 10.6 4.7 10.6 10.6 0 2.5-.5-5.7 5.7 81.5l5.8-64.2c.3-2.9 2.9-9.3 10.2-9.3 3.8 0 9.9 2.3 10.6 8.9l11.5 96.5 5.3-12.8c1.8-4.4 5.2-6.6 10.2-6.6h58v21.3h-50.9l-18.2 44.3c-3.9 9.9-19.5 9.1-20.8-3.1l-4-31.9-7.5 92.6c-.3 3-3 9.3-10.2 9.3-3 0-9.8-2.1-10.6-9.3 0-1.9.6 5.8-6.2-77.9l-5.3 72.2c-1.1 4.8-4.8 9.3-10.6 9.3-2.9 0-9.8-2-10.6-9.3 0-1.9.5 6.7-5.8-87.7l-5.8 94.8c0 6.3-3.6 12.4-10.6 12.4-5.2 0-10.6-4.1-10.6-12l-5.8-87.7c-5.8 92.5-5.3 84-5.3 85.9-1.1 4.8-4.8 9.3-10.6 9.3-3 0-9.8-2.1-10.6-9.3 0-.7-.4-1.1-.4-2.6l-6.2-88.6L182 348c-.7 6.5-6.7 9.3-10.6 9.3-5.8 0-9.6-4.1-10.6-8.9L149.7 272c-2 4-3.5 8.4-11.1 8.4H87.2v-21.3H132l13.7-27.9c4.4-9.9 18.2-7.2 19.9 2.7l3.1 20.4 8.4-97.9c0-6 4.8-10.6 10.6-10.6.5 0 10.6-.2 10.6 12.4l4.9 69.1 6.6-92.6c0-10.1 9.5-10.6 10.2-10.6.6 0 10.6.7 10.6 10.6l5.3 80.6 6.2-97.9c.1-1.1-.6-10.3 9.9-11.5z"
                }
            }
        ]
    })(props);
}
function FaCreativeCommonsShare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M247.6 8C389.4 8 496 118.1 496 256c0 147.1-118.5 248-248.4 248C113.6 504 0 394.5 0 256 0 123.1 104.7 8 247.6 8zm.8 44.7C130.2 52.7 44.7 150.6 44.7 256c0 109.8 91.2 202.8 203.7 202.8 103.2 0 202.8-81.1 202.8-202.8.1-113.8-90.2-203.3-202.8-203.3zm101 132.4c7.8 0 13.7 6.1 13.7 13.7v182.5c0 7.7-6.1 13.7-13.7 13.7H214.3c-7.7 0-13.7-6-13.7-13.7v-54h-54c-7.8 0-13.7-6-13.7-13.7V131.1c0-8.2 6.6-12.7 12.4-13.7h136.4c7.7 0 13.7 6 13.7 13.7v54h54zM159.9 300.3h40.7V198.9c0-7.4 5.8-12.6 12-13.7h55.8v-40.3H159.9v155.4zm176.2-88.1H227.6v155.4h108.5V212.2z"
                }
            }
        ]
    })(props);
}
function FaCreativeCommonsZero(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M247.6 8C389.4 8 496 118.1 496 256c0 147.1-118.5 248-248.4 248C113.6 504 0 394.5 0 256 0 123.1 104.7 8 247.6 8zm.8 44.7C130.2 52.7 44.7 150.6 44.7 256c0 109.8 91.2 202.8 203.7 202.8 103.2 0 202.8-81.1 202.8-202.8.1-113.8-90.2-203.3-202.8-203.3zm-.4 60.5c-81.9 0-102.5 77.3-102.5 142.8 0 65.5 20.6 142.8 102.5 142.8S350.5 321.5 350.5 256c0-65.5-20.6-142.8-102.5-142.8zm0 53.9c3.3 0 6.4.5 9.2 1.2 5.9 5.1 8.8 12.1 3.1 21.9l-54.5 100.2c-1.7-12.7-1.9-25.1-1.9-34.4 0-28.8 2-88.9 44.1-88.9zm40.8 46.2c2.9 15.4 3.3 31.4 3.3 42.7 0 28.9-2 88.9-44.1 88.9-13.5 0-32.6-7.7-20.1-26.4l60.9-105.2z"
                }
            }
        ]
    })(props);
}
function FaCreativeCommons(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M245.83 214.87l-33.22 17.28c-9.43-19.58-25.24-19.93-27.46-19.93-22.13 0-33.22 14.61-33.22 43.84 0 23.57 9.21 43.84 33.22 43.84 14.47 0 24.65-7.09 30.57-21.26l30.55 15.5c-6.17 11.51-25.69 38.98-65.1 38.98-22.6 0-73.96-10.32-73.96-77.05 0-58.69 43-77.06 72.63-77.06 30.72-.01 52.7 11.95 65.99 35.86zm143.05 0l-32.78 17.28c-9.5-19.77-25.72-19.93-27.9-19.93-22.14 0-33.22 14.61-33.22 43.84 0 23.55 9.23 43.84 33.22 43.84 14.45 0 24.65-7.09 30.54-21.26l31 15.5c-2.1 3.75-21.39 38.98-65.09 38.98-22.69 0-73.96-9.87-73.96-77.05 0-58.67 42.97-77.06 72.63-77.06 30.71-.01 52.58 11.95 65.56 35.86zM247.56 8.05C104.74 8.05 0 123.11 0 256.05c0 138.49 113.6 248 247.56 248 129.93 0 248.44-100.87 248.44-248 0-137.87-106.62-248-248.44-248zm.87 450.81c-112.54 0-203.7-93.04-203.7-202.81 0-105.42 85.43-203.27 203.72-203.27 112.53 0 202.82 89.46 202.82 203.26-.01 121.69-99.68 202.82-202.84 202.82z"
                }
            }
        ]
    })(props);
}
function FaCriticalRole(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M225.82 0c.26.15 216.57 124.51 217.12 124.72 3 1.18 3.7 3.46 3.7 6.56q-.11 125.17 0 250.36a5.88 5.88 0 0 1-3.38 5.78c-21.37 12-207.86 118.29-218.93 124.58h-3C142 466.34 3.08 386.56 2.93 386.48a3.29 3.29 0 0 1-1.88-3.24c0-.87 0-225.94-.05-253.1a5 5 0 0 1 2.93-4.93C27.19 112.11 213.2 6 224.07 0zM215.4 20.42l-.22-.16Q118.06 75.55 21 130.87c0 .12.08.23.13.35l30.86 11.64c-7.71 6-8.32 6-10.65 5.13-.1 0-24.17-9.28-26.8-10v230.43c.88-1.41 64.07-110.91 64.13-111 1.62-2.82 3-1.92 9.12-1.52 1.4.09 1.48.22.78 1.42-41.19 71.33-36.4 63-67.48 116.94-.81 1.4-.61 1.13 1.25 1.13h186.5c1.44 0 1.69-.23 1.7-1.64v-8.88c0-1.34 2.36-.81-18.37-1-7.46-.07-14.14-3.22-21.38-12.7-7.38-9.66-14.62-19.43-21.85-29.21-2.28-3.08-3.45-2.38-16.76-2.38-1.75 0-1.78 0-1.76 1.82.29 26.21.15 25.27 1 32.66.52 4.37 2.16 4.2 9.69 4.81 3.14.26 3.88 4.08.52 4.92-1.57.39-31.6.51-33.67-.1a2.42 2.42 0 0 1 .3-4.73c3.29-.76 6.16.81 6.66-4.44 1.3-13.66 1.17-9 1.1-79.42 0-10.82-.35-12.58-5.36-13.55-1.22-.24-3.54-.16-4.69-.55-2.88-1-2-4.84 1.77-4.85 33.67 0 46.08-1.07 56.06 4.86 7.74 4.61 12 11.48 12.51 20.4.88 14.59-6.51 22.35-15 32.59a1.46 1.46 0 0 0 0 2.22c2.6 3.25 5 6.63 7.71 9.83 27.56 33.23 24.11 30.54 41.28 33.06.89.13 1-.42 1-1.15v-11c0-1 .32-1.43 1.41-1.26a72.37 72.37 0 0 0 23.58-.3c1.08-.15 1.5.2 1.48 1.33 0 .11.88 26.69.87 26.8-.05 1.52.67 1.62 1.89 1.62h186.71Q386.51 304.6 346 234.33c2.26-.66-.4 0 6.69-1.39 2-.39 2.05-.41 3.11 1.44 7.31 12.64 77.31 134 77.37 134.06V138c-1.72.5-103.3 38.72-105.76 39.68-1.08.42-1.55.2-1.91-.88-.63-1.9-1.34-3.76-2.09-5.62-.32-.79-.09-1.13.65-1.39.1 0 95.53-35.85 103-38.77-65.42-37.57-130.56-75-196-112.6l86.82 150.39-.28.33c-9.57-.9-10.46-1.6-11.8-3.94-1-1.69-73.5-127.71-82-142.16-9.1 14.67-83.56 146.21-85.37 146.32-2.93.17-5.88.08-9.25.08q43.25-74.74 86.18-149zm51.93 129.92a37.68 37.68 0 0 0 5.54-.85c1.69-.3 2.53.2 2.6 1.92 0 .11.07 19.06-.86 20.45s-1.88 1.22-2.6-.19c-5-9.69 6.22-9.66-39.12-12-.7 0-1 .23-1 .93 0 .13 3.72 122 3.73 122.11 0 .89.52 1.2 1.21 1.51a83.92 83.92 0 0 1 8.7 4.05c7.31 4.33 11.38 10.84 12.41 19.31 1.44 11.8-2.77 35.77-32.21 37.14-2.75.13-28.26 1.08-34.14-23.25-4.66-19.26 8.26-32.7 19.89-36.4a2.45 2.45 0 0 0 2-2.66c.1-5.63 3-107.1 3.71-121.35.05-1.08-.62-1.16-1.35-1.15-32.35.52-36.75-.34-40.22 8.52-2.42 6.18-4.14 1.32-3.95.23q1.59-9 3.31-18c.4-2.11 1.43-2.61 3.43-1.86 5.59 2.11 6.72 1.7 37.25 1.92 1.73 0 1.78-.08 1.82-1.85.68-27.49.58-22.59 1-29.55a2.69 2.69 0 0 0-1.63-2.8c-5.6-2.91-8.75-7.55-8.9-13.87-.35-14.81 17.72-21.67 27.38-11.51 6.84 7.19 5.8 18.91-2.45 24.15a4.35 4.35 0 0 0-2.22 4.34c0 .59-.11-4.31 1 30.05 0 .9.43 1.12 1.24 1.11.1 0 23-.09 34.47-.37zM68.27 141.7c19.84-4.51 32.68-.56 52.49 1.69 2.76.31 3.74 1.22 3.62 4-.21 5-1.16 22.33-1.24 23.15a2.65 2.65 0 0 1-1.63 2.34c-4.06 1.7-3.61-4.45-4-7.29-3.13-22.43-73.87-32.7-74.63 25.4-.31 23.92 17 53.63 54.08 50.88 27.24-2 19-20.19 24.84-20.47a2.72 2.72 0 0 1 3 3.36c-1.83 10.85-3.42 18.95-3.45 19.15-1.54 9.17-86.7 22.09-93.35-42.06-2.71-25.85 10.44-53.37 40.27-60.15zm80 87.67h-19.49a2.57 2.57 0 0 1-2.66-1.79c2.38-3.75 5.89.92 5.86-6.14-.08-25.75.21-38 .23-40.1 0-3.42-.53-4.65-3.32-4.94-7-.72-3.11-3.37-1.11-3.38 11.84-.1 22.62-.18 30.05.72 8.77 1.07 16.71 12.63 7.93 22.62-2 2.25-4 4.42-6.14 6.73.95 1.15 6.9 8.82 17.28 19.68 2.66 2.78 6.15 3.51 9.88 3.13a2.21 2.21 0 0 0 2.23-2.12c.3-3.42.26 4.73.45-40.58 0-5.65-.34-6.58-3.23-6.83-3.95-.35-4-2.26-.69-3.37l19.09-.09c.32 0 4.49.53 1 3.38 0 .05-.16 0-.24 0-3.61.26-3.94 1-4 4.62-.27 43.93.07 40.23.41 42.82.11.84.27 2.23 5.1 2.14 2.49 0 3.86 3.37 0 3.4-10.37.08-20.74 0-31.11.07-10.67 0-13.47-6.2-24.21-20.82-1.6-2.18-8.31-2.36-8.2-.37.88 16.47 0 17.78 4 17.67 4.75-.1 4.73 3.57.83 3.55zm275-10.15c-1.21 7.13.17 10.38-5.3 10.34-61.55-.42-47.82-.22-50.72-.31a18.4 18.4 0 0 1-3.63-.73c-2.53-.6 1.48-1.23-.38-5.6-1.43-3.37-2.78-6.78-4.11-10.19a1.94 1.94 0 0 0-2-1.44 138 138 0 0 0-14.58.07 2.23 2.23 0 0 0-1.62 1.06c-1.58 3.62-3.07 7.29-4.51 11-1.27 3.23 7.86 1.32 12.19 2.16 3 .57 4.53 3.72.66 3.73H322.9c-2.92 0-3.09-3.15-.74-3.21a6.3 6.3 0 0 0 5.92-3.47c1.5-3 2.8-6 4.11-9.09 18.18-42.14 17.06-40.17 18.42-41.61a1.83 1.83 0 0 1 3 0c2.93 3.34 18.4 44.71 23.62 51.92 2 2.7 5.74 2 6.36 2 3.61.13 4-1.11 4.13-4.29.09-1.87.08 1.17.07-41.24 0-4.46-2.36-3.74-5.55-4.27-.26 0-2.56-.63-.08-3.06.21-.2-.89-.24 21.7-.15 2.32 0 5.32 2.75-1.21 3.45a2.56 2.56 0 0 0-2.66 2.83c-.07 1.63-.19 38.89.29 41.21a3.06 3.06 0 0 0 3.23 2.43c13.25.43 14.92.44 16-3.41 1.67-5.78 4.13-2.52 3.73-.19zm-104.72 64.37c-4.24 0-4.42-3.39-.61-3.41 35.91-.16 28.11.38 37.19-.65 1.68-.19 2.38.24 2.25 1.89-.26 3.39-.64 6.78-1 10.16-.25 2.16-3.2 2.61-3.4-.15-.38-5.31-2.15-4.45-15.63-5.08-1.58-.07-1.64 0-1.64 1.52V304c0 1.65 0 1.6 1.62 1.47 3.12-.25 10.31.34 15.69-1.52.47-.16 3.3-1.79 3.07 1.76 0 .21-.76 10.35-1.18 11.39-.53 1.29-1.88 1.51-2.58.32-1.17-2 0-5.08-3.71-5.3-15.42-.9-12.91-2.55-12.91 6 0 12.25-.76 16.11 3.89 16.24 16.64.48 14.4 0 16.43-5.71.84-2.37 3.5-1.77 3.18.58-.44 3.21-.85 6.43-1.23 9.64 0 .36-.16 2.4-4.66 2.39-37.16-.08-34.54-.19-35.21-.31-2.72-.51-2.2-3 .22-3.45 1.1-.19 4 .54 4.16-2.56 2.44-56.22-.07-51.34-3.91-51.33zm-.41-109.52c2.46.61 3.13 1.76 2.95 4.65-.33 5.3-.34 9-.55 9.69-.66 2.23-3.15 2.12-3.34-.27-.38-4.81-3.05-7.82-7.57-9.15-26.28-7.73-32.81 15.46-27.17 30.22 5.88 15.41 22 15.92 28.86 13.78 5.92-1.85 5.88-6.5 6.91-7.58 1.23-1.3 2.25-1.84 3.12 1.1 0 .1.57 11.89-6 12.75-1.6.21-19.38 3.69-32.68-3.39-21-11.19-16.74-35.47-6.88-45.33 14-14.06 39.91-7.06 42.32-6.47zM289.8 280.14c3.28 0 3.66 3 .16 3.43-2.61.32-5-.42-5 5.46 0 2-.19 29.05.4 41.45.11 2.29 1.15 3.52 3.44 3.65 22 1.21 14.95-1.65 18.79-6.34 1.83-2.24 2.76.84 2.76 1.08.35 13.62-4 12.39-5.19 12.4l-38.16-.19c-1.93-.23-2.06-3-.42-3.38 2-.48 4.94.4 5.13-2.8 1-15.87.57-44.65.34-47.81-.27-3.77-2.8-3.27-5.68-3.71-2.47-.38-2-3.22.34-3.22 1.45-.02 17.97-.03 23.09-.02zm-31.63-57.79c.07 4.08 2.86 3.46 6 3.58 2.61.1 2.53 3.41-.07 3.43-6.48 0-13.7 0-21.61-.06-3.84 0-3.38-3.35 0-3.37 4.49 0 3.24 1.61 3.41-45.54 0-5.08-3.27-3.54-4.72-4.23-2.58-1.23-1.36-3.09.41-3.15 1.29 0 20.19-.41 21.17.21s1.87 1.65-.42 2.86c-1 .52-3.86-.28-4.15 2.47 0 .21-.82 1.63-.07 43.8zm-36.91 274.27a2.93 2.93 0 0 0 3.26 0c17-9.79 182-103.57 197.42-112.51-.14-.43 11.26-.18-181.52-.27-1.22 0-1.57.37-1.53 1.56 0 .1 1.25 44.51 1.22 50.38a28.33 28.33 0 0 1-1.36 7.71c-.55 1.83.38-.5-13.5 32.23-.73 1.72-1 2.21-2-.08-4.19-10.34-8.28-20.72-12.57-31a23.6 23.6 0 0 1-2-10.79c.16-2.46.8-16.12 1.51-48 0-1.95 0-2-2-2h-183c2.58 1.63 178.32 102.57 196 112.76zm-90.9-188.75c0 2.4.36 2.79 2.76 3 11.54 1.17 21 3.74 25.64-7.32 6-14.46 2.66-34.41-12.48-38.84-2-.59-16-2.76-15.94 1.51.05 8.04.01 11.61.02 41.65zm105.75-15.05c0 2.13 1.07 38.68 1.09 39.13.34 9.94-25.58 5.77-25.23-2.59.08-2 1.37-37.42 1.1-39.43-14.1 7.44-14.42 40.21 6.44 48.8a17.9 17.9 0 0 0 22.39-7.07c4.91-7.76 6.84-29.47-5.43-39a2.53 2.53 0 0 1-.36.12zm-12.28-198c-9.83 0-9.73 14.75-.07 14.87s10.1-14.88.07-14.91zm-80.15 103.83c0 1.8.41 2.4 2.17 2.58 13.62 1.39 12.51-11 12.16-13.36-1.69-11.22-14.38-10.2-14.35-7.81.05 4.5-.03 13.68.02 18.59zm212.32 6.4l-6.1-15.84c-2.16 5.48-4.16 10.57-6.23 15.84z"
                }
            }
        ]
    })(props);
}
function FaCss3Alt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 32l34.9 395.8L192 480l157.1-52.2L384 32H0zm313.1 80l-4.8 47.3L193 208.6l-.3.1h111.5l-12.8 146.6-98.2 28.7-98.8-29.2-6.4-73.9h48.9l3.2 38.3 52.6 13.3 54.7-15.4 3.7-61.6-166.3-.5v-.1l-.2.1-3.6-46.3L193.1 162l6.5-2.7H76.7L70.9 112h242.2z"
                }
            }
        ]
    })(props);
}
function FaCss3(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M480 32l-64 368-223.3 80L0 400l19.6-94.8h82l-8 40.6L210 390.2l134.1-44.4 18.8-97.1H29.5l16-82h333.7l10.5-52.7H56.3l16.3-82H480z"
                }
            }
        ]
    })(props);
}
function FaCuttlefish(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 440 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M344 305.5c-17.5 31.6-57.4 54.5-96 54.5-56.6 0-104-47.4-104-104s47.4-104 104-104c38.6 0 78.5 22.9 96 54.5 13.7-50.9 41.7-93.3 87-117.8C385.7 39.1 320.5 8 248 8 111 8 0 119 0 256s111 248 248 248c72.5 0 137.7-31.1 183-80.7-45.3-24.5-73.3-66.9-87-117.8z"
                }
            }
        ]
    })(props);
}
function FaDAndDBeyond(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M313.8 241.5c13.8 0 21-10.1 24.8-17.9-1-1.1-5-4.2-7.4-6.6-2.4 4.3-8.2 10.7-13.9 10.7-10.2 0-15.4-14.7-3.2-26.6-.5-.2-4.3-1.8-8 2.4 0-3 1-5.1 2.1-6.6-3.5 1.3-9.8 5.6-11.4 7.9.2-5.8 1.6-7.5.6-9l-.2-.2s-8.5 5.6-9.3 14.7c0 0 1.1-1.6 2.1-1.9.6-.3 1.3 0 .6 1.9-.2.6-5.8 15.7 5.1 26-.6-1.6-1.9-7.6 2.4-1.9-.3.1 5.8 7.1 15.7 7.1zm52.4-21.1c0-4-4.9-4.4-5.6-4.5 2 3.9.9 7.5.2 9 2.5-.4 5.4-1.6 5.4-4.5zm10.3 5.2c0-6.4-6.2-11.4-13.5-10.7 8 1.3 5.6 13.8-5 11.4 3.7-2.6 3.2-9.9-1.3-12.5 1.4 4.2-3 8.2-7.4 4.6-2.4-1.9-8-6.6-10.6-8.6-2.4-2.1-5.5-1-6.6-1.8-1.3-1.1-.5-3.8-2.2-5-1.6-.8-3-.3-4.8-1-1.6-.6-2.7-1.9-2.6-3.5-2.5 4.4 3.4 6.3 4.5 8.5 1 1.9-.8 4.8 4 8.5 14.8 11.6 9.1 8 10.4 18.1.6 4.3 4.2 6.7 6.4 7.4-2.1-1.9-2.9-6.4 0-9.3 0 13.9 19.2 13.3 23.1 6.4-2.4 1.1-7-.2-9-1.9 7.7 1 14.2-4.1 14.6-10.6zm-39.4-18.4c2 .8 1.6.7 6.4 4.5 10.2-24.5 21.7-15.7 22-15.5 2.2-1.9 9.8-3.8 13.8-2.7-2.4-2.7-7.5-6.2-13.3-6.2-4.7 0-7.4 2.2-8 1.3-.8-1.4 3.2-3.4 3.2-3.4-5.4.2-9.6 6.7-11.2 5.9-1.1-.5 1.4-3.7 1.4-3.7-5.1 2.9-9.3 9.1-10.2 13 4.6-5.8 13.8-9.8 19.7-9-10.5.5-19.5 9.7-23.8 15.8zm242.5 51.9c-20.7 0-40 1.3-50.3 2.1l7.4 8.2v77.2l-7.4 8.2c10.4.8 30.9 2.1 51.6 2.1 42.1 0 59.1-20.7 59.1-48.9 0-29.3-23.2-48.9-60.4-48.9zm-15.1 75.6v-53.3c30.1-3.3 46.8 3.8 46.8 26.3 0 25.6-21.4 30.2-46.8 27zM301.6 181c-1-3.4-.2-6.9 1.1-9.4 1 3 2.6 6.4 7.5 9-.5-2.4-.2-5.6.5-8-1.4-5.4 2.1-9.9 6.4-9.9 6.9 0 8.5 8.8 4.7 14.4 2.1 3.2 5.5 5.6 7.7 7.8 3.2-3.7 5.5-9.5 5.5-13.8 0-8.2-5.5-15.9-16.7-16.5-20-.9-20.2 16.6-20 18.9.5 5.2 3.4 7.8 3.3 7.5zm-.4 6c-.5 1.8-7 3.7-10.2 6.9 4.8-1 7-.2 7.8 1.8.5 1.4-.2 3.4-.5 5.6 1.6-1.8 7-5.5 11-6.2-1-.3-3.4-.8-4.3-.8 2.9-3.4 9.3-4.5 12.8-3.7-2.2-.2-6.7 1.1-8.5 2.6 1.6.3 3 .6 4.3 1.1-2.1.8-4.8 3.4-5.8 6.1 7-5 13.1 5.2 7 8.2.8.2 2.7 0 3.5-.5-.3 1.1-1.9 3-3 3.4 2.9 0 7-1.9 8.2-4.6 0 0-1.8.6-2.6-.2s.3-4.3.3-4.3c-2.3 2.9-3.4-1.3-1.3-4.2-1-.3-3.5-.6-4.6-.5 3.2-1.1 10.4-1.8 11.2-.3.6 1.1-1 3.4-1 3.4 4-.5 8.3 1.1 6.7 5.1 2.9-1.4 5.5-5.9 4.8-10.4-.3 1-1.6 2.4-2.9 2.7.2-1.4-1-2.2-1.9-2.6 1.7-9.6-14.6-14.2-14.1-23.9-1 1.3-1.8 5-.8 7.1 2.7 3.2 8.7 6.7 10.1 12.2-2.6-6.4-15.1-11.4-14.6-20.2-1.6 1.6-2.6 7.8-1.3 11 2.4 1.4 4.5 3.8 4.8 6.1-2.2-5.1-11.4-6.1-13.9-12.2-.6 2.2-.3 5 1 6.7 0 0-2.2-.8-7-.6 1.7.6 5.1 3.5 4.8 5.2zm25.9 7.4c-2.7 0-3.5-2.1-4.2-4.3 3.3 1.3 4.2 4.3 4.2 4.3zm38.9 3.7l-1-.6c-1.1-1-2.9-1.4-4.7-1.4-2.9 0-5.8 1.3-7.5 3.4-.8.8-1.4 1.8-2.1 2.6v15.7c3.5 2.6 7.1-2.9 3-7.2 1.5.3 4.6 2.7 5.1 3.2 0 0 2.6-.5 5-.5 2.1 0 3.9.3 5.6 1.1V196c-1.1.5-2.2 1-2.7 1.4zM79.9 305.9c17.2-4.6 16.2-18 16.2-19.9 0-20.6-24.1-25-37-25H3l8.3 8.6v29.5H0l11.4 14.6V346L3 354.6c61.7 0 73.8 1.5 86.4-5.9 6.7-4 9.9-9.8 9.9-17.6 0-5.1 2.6-18.8-19.4-25.2zm-41.3-27.5c20 0 29.6-.8 29.6 9.1v3c0 12.1-19 8.8-29.6 8.8zm0 59.2V315c12.2 0 32.7-2.3 32.7 8.8v4.5h.2c0 11.2-12.5 9.3-32.9 9.3zm101.2-19.3l23.1.2v-.2l14.1-21.2h-37.2v-14.9h52.4l-14.1-21v-.2l-73.5.2 7.4 8.2v77.1l-7.4 8.2h81.2l14.1-21.2-60.1.2zm214.7-60.1c-73.9 0-77.5 99.3-.3 99.3 77.9 0 74.1-99.3.3-99.3zm-.3 77.5c-37.4 0-36.9-55.3.2-55.3 36.8.1 38.8 55.3-.2 55.3zm-91.3-8.3l44.1-66.2h-41.7l6.1 7.2-20.5 37.2h-.3l-21-37.2 6.4-7.2h-44.9l44.1 65.8.2 19.4-7.7 8.2h42.6l-7.2-8.2zm-28.4-151.3c1.6 1.3 2.9 2.4 2.9 6.6v38.8c0 4.2-.8 5.3-2.7 6.4-.1.1-7.5 4.5-7.9 4.6h35.1c10 0 17.4-1.5 26-8.6-.6-5 .2-9.5.8-12 0-.2-1.8 1.4-2.7 3.5 0-5.7 1.6-15.4 9.6-20.5-.1 0-3.7-.8-9 1.1 2-3.1 10-7.9 10.4-7.9-8.2-26-38-22.9-32.2-22.9-30.9 0-32.6.3-39.9-4 .1.8.5 8.2 9.6 14.9zm21.5 5.5c4.6 0 23.1-3.3 23.1 17.3 0 20.7-18.4 17.3-23.1 17.3zm228.9 79.6l7 8.3V312h-.3c-5.4-14.4-42.3-41.5-45.2-50.9h-31.6l7.4 8.5v76.9l-7.2 8.3h39l-7.4-8.2v-47.4h.3c3.7 10.6 44.5 42.9 48.5 55.6h21.3v-85.2l7.4-8.3zm-106.7-96.1c-32.2 0-32.8.2-39.9-4 .1.7.5 8.3 9.6 14.9 3.1 2 2.9 4.3 2.9 9.5 1.8-1.1 3.8-2.2 6.1-3-1.1 1.1-2.7 2.7-3.5 4.5 1-1.1 7.5-5.1 14.6-3.5-1.6.3-4 1.1-6.1 2.9.1 0 2.1-1.1 7.5-.3v-4.3c4.7 0 23.1-3.4 23.1 17.3 0 20.5-18.5 17.3-19.7 17.3 5.7 4.4 5.8 12 2.2 16.3h.3c33.4 0 36.7-27.3 36.7-34 0-3.8-1.1-32-33.8-33.6z"
                }
            }
        ]
    })(props);
}
function FaDAndD(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M82.5 98.9c-.6-17.2 2-33.8 12.7-48.2.3 7.4 1.2 14.5 4.2 21.6 5.9-27.5 19.7-49.3 42.3-65.5-1.9 5.9-3.5 11.8-3 17.7 8.7-7.4 18.8-17.8 44.4-22.7 14.7-2.8 29.7-2 42.1 1 38.5 9.3 61 34.3 69.7 72.3 5.3 23.1.7 45-8.3 66.4-5.2 12.4-12 24.4-20.7 35.1-2-1.9-3.9-3.8-5.8-5.6-42.8-40.8-26.8-25.2-37.4-37.4-1.1-1.2-1-2.2-.1-3.6 8.3-13.5 11.8-28.2 10-44-1.1-9.8-4.3-18.9-11.3-26.2-14.5-15.3-39.2-15-53.5.6-11.4 12.5-14.1 27.4-10.9 43.6.2 1.3.4 2.7 0 3.9-3.4 13.7-4.6 27.6-2.5 41.6.1.5.1 1.1.1 1.6 0 .3-.1.5-.2 1.1-21.8-11-36-28.3-43.2-52.2-8.3 17.8-11.1 35.5-6.6 54.1-15.6-15.2-21.3-34.3-22-55.2zm469.6 123.2c-11.6-11.6-25-20.4-40.1-26.6-12.8-5.2-26-7.9-39.9-7.1-10 .6-19.6 3.1-29 6.4-2.5.9-5.1 1.6-7.7 2.2-4.9 1.2-7.3-3.1-4.7-6.8 3.2-4.6 3.4-4.2 15-12 .6-.4 1.2-.8 2.2-1.5h-2.5c-.6 0-1.2.2-1.9.3-19.3 3.3-30.7 15.5-48.9 29.6-10.4 8.1-13.8 3.8-12-.5 1.4-3.5 3.3-6.7 5.1-10 1-1.8 2.3-3.4 3.5-5.1-.2-.2-.5-.3-.7-.5-27 18.3-46.7 42.4-57.7 73.3.3.3.7.6 1 .9.3-.6.5-1.2.9-1.7 10.4-12.1 22.8-21.8 36.6-29.8 18.2-10.6 37.5-18.3 58.7-20.2 4.3-.4 8.7-.1 13.1-.1-1.8.7-3.5.9-5.3 1.1-18.5 2.4-35.5 9-51.5 18.5-30.2 17.9-54.5 42.2-75.1 70.4-.3.4-.4.9-.7 1.3 14.5 5.3 24 17.3 36.1 25.6.2-.1.3-.2.4-.4l1.2-2.7c12.2-26.9 27-52.3 46.7-74.5 16.7-18.8 38-25.3 62.5-20 5.9 1.3 11.4 4.4 17.2 6.8 2.3-1.4 5.1-3.2 8-4.7 8.4-4.3 17.4-7 26.7-9 14.7-3.1 29.5-4.9 44.5-1.3v-.5c-.5-.4-1.2-.8-1.7-1.4zM316.7 397.6c-39.4-33-22.8-19.5-42.7-35.6-.8.9 0-.2-1.9 3-11.2 19.1-25.5 35.3-44 47.6-10.3 6.8-21.5 11.8-34.1 11.8-21.6 0-38.2-9.5-49.4-27.8-12-19.5-13.3-40.7-8.2-62.6 7.8-33.8 30.1-55.2 38.6-64.3-18.7-6.2-33 1.7-46.4 13.9.8-13.9 4.3-26.2 11.8-37.3-24.3 10.6-45.9 25-64.8 43.9-.3-5.8 5.4-43.7 5.6-44.7.3-2.7-.6-5.3-3-7.4-24.2 24.7-44.5 51.8-56.1 84.6 7.4-5.9 14.9-11.4 23.6-16.2-8.3 22.3-19.6 52.8-7.8 101.1 4.6 19 11.9 36.8 24.1 52.3 2.9 3.7 6.3 6.9 9.5 10.3.2-.2.4-.3.6-.5-1.4-7-2.2-14.1-1.5-21.9 2.2 3.2 3.9 6 5.9 8.6 12.6 16 28.7 27.4 47.2 35.6 25 11.3 51.1 13.3 77.9 8.6 54.9-9.7 90.7-48.6 116-98.8 1-1.8.6-2.9-.9-4.2zm172-46.4c-9.5-3.1-22.2-4.2-28.7-2.9 9.9 4 14.1 6.6 18.8 12 12.6 14.4 10.4 34.7-5.4 45.6-11.7 8.1-24.9 10.5-38.9 9.1-1.2-.1-2.3-.4-3-.6 2.8-3.7 6-7 8.1-10.8 9.4-16.8 5.4-42.1-8.7-56.1-2.1-2.1-4.6-3.9-7-5.9-.3 1.3-.1 2.1.1 2.8 4.2 16.6-8.1 32.4-24.8 31.8-7.6-.3-13.9-3.8-19.6-8.5-19.5-16.1-39.1-32.1-58.5-48.3-5.9-4.9-12.5-8.1-20.1-8.7-4.6-.4-9.3-.6-13.9-.9-5.9-.4-8.8-2.8-10.4-8.4-.9-3.4-1.5-6.8-2.2-10.2-1.5-8.1-6.2-13-14.3-14.2-4.4-.7-8.9-1-13.3-1.5-13-1.4-19.8-7.4-22.6-20.3-5 11-1.6 22.4 7.3 29.9 4.5 3.8 9.3 7.3 13.8 11.2 4.6 3.8 7.4 8.7 7.9 14.8.4 4.7.8 9.5 1.8 14.1 2.2 10.6 8.9 18.4 17 25.1 16.5 13.7 33 27.3 49.5 41.1 17.9 15 13.9 32.8 13 56-.9 22.9 12.2 42.9 33.5 51.2 1 .4 2 .6 3.6 1.1-15.7-18.2-10.1-44.1.7-52.3.3 2.2.4 4.3.9 6.4 9.4 44.1 45.4 64.2 85 56.9 16-2.9 30.6-8.9 42.9-19.8 2-1.8 3.7-4.1 5.9-6.5-19.3 4.6-35.8.1-50.9-10.6.7-.3 1.3-.3 1.9-.3 21.3 1.8 40.6-3.4 57-17.4 19.5-16.6 26.6-42.9 17.4-66-8.3-20.1-23.6-32.3-43.8-38.9zM99.4 179.3c-5.3-9.2-13.2-15.6-22.1-21.3 13.7-.5 26.6.2 39.6 3.7-7-12.2-8.5-24.7-5-38.7 5.3 11.9 13.7 20.1 23.6 26.8 19.7 13.2 35.7 19.6 46.7 30.2 3.4 3.3 6.3 7.1 9.6 10.9-.8-2.1-1.4-4.1-2.2-6-5-10.6-13-18.6-22.6-25-1.8-1.2-2.8-2.5-3.4-4.5-3.3-12.5-3-25.1-.7-37.6 1-5.5 2.8-10.9 4.5-16.3.8-2.4 2.3-4.6 4-6.6.6 6.9 0 25.5 19.6 46 10.8 11.3 22.4 21.9 33.9 32.7 9 8.5 18.3 16.7 25.5 26.8 1.1 1.6 2.2 3.3 3.8 4.7-5-13-14.2-24.1-24.2-33.8-9.6-9.3-19.4-18.4-29.2-27.4-3.3-3-4.6-6.7-5.1-10.9-1.2-10.4 0-20.6 4.3-30.2.5-1 1.1-2 1.9-3.3.5 4.2.6 7.9 1.4 11.6 4.8 23.1 20.4 36.3 49.3 63.5 10 9.4 19.3 19.2 25.6 31.6 4.8 9.3 7.3 19 5.7 29.6-.1.6.5 1.7 1.1 2 6.2 2.6 10 6.9 9.7 14.3 7.7-2.6 12.5-8 16.4-14.5 4.2 20.2-9.1 50.3-27.2 58.7.4-4.5 5-23.4-16.5-27.7-6.8-1.3-12.8-1.3-22.9-2.1 4.7-9 10.4-20.6.5-22.4-24.9-4.6-52.8 1.9-57.8 4.6 8.2.4 16.3 1 23.5 3.3-2 6.5-4 12.7-5.8 18.9-1.9 6.5 2.1 14.6 9.3 9.6 1.2-.9 2.3-1.9 3.3-2.7-3.1 17.9-2.9 15.9-2.8 18.3.3 10.2 9.5 7.8 15.7 7.3-2.5 11.8-29.5 27.3-45.4 25.8 7-4.7 12.7-10.3 15.9-17.9-6.5.8-12.9 1.6-19.2 2.4l-.3-.9c4.7-3.4 8-7.8 10.2-13.1 8.7-21.1-3.6-38-25-39.9-9.1-.8-17.8.8-25.9 5.5 6.2-15.6 17.2-26.6 32.6-34.5-15.2-4.3-8.9-2.7-24.6-6.3 14.6-9.3 30.2-13.2 46.5-14.6-5.2-3.2-48.1-3.6-70.2 20.9 7.9 1.4 15.5 2.8 23.2 4.2-23.8 7-44 19.7-62.4 35.6 1.1-4.8 2.7-9.5 3.3-14.3.6-4.5.8-9.2.1-13.6-1.5-9.4-8.9-15.1-19.7-16.3-7.9-.9-15.6.1-23.3 1.3-.9.1-1.7.3-2.9 0 15.8-14.8 36-21.7 53.1-33.5 6-4.5 6.8-8.2 3-14.9zm128.4 26.8c3.3 16 12.6 25.5 23.8 24.3-4.6-11.3-12.1-19.5-23.8-24.3z"
                }
            }
        ]
    })(props);
}
function FaDailymotion(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M298.93,267a48.4,48.4,0,0,0-24.36-6.21q-19.83,0-33.44,13.27t-13.61,33.42q0,21.16,13.28,34.6t33.43,13.44q20.5,0,34.11-13.78T322,307.47A47.13,47.13,0,0,0,315.9,284,44.13,44.13,0,0,0,298.93,267ZM0,32V480H448V32ZM374.71,405.26h-53.1V381.37h-.67q-15.79,26.2-55.78,26.2-27.56,0-48.89-13.1a88.29,88.29,0,0,1-32.94-35.77q-11.6-22.68-11.59-50.89,0-27.56,11.76-50.22a89.9,89.9,0,0,1,32.93-35.78q21.18-13.09,47.72-13.1a80.87,80.87,0,0,1,29.74,5.21q13.28,5.21,25,17V153l55.79-12.09Z"
                }
            }
        ]
    })(props);
}
function FaDashcube(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M326.6 104H110.4c-51.1 0-91.2 43.3-91.2 93.5V427c0 50.5 40.1 85 91.2 85h227.2c51.1 0 91.2-34.5 91.2-85V0L326.6 104zM153.9 416.5c-17.7 0-32.4-15.1-32.4-32.8V240.8c0-17.7 14.7-32.5 32.4-32.5h140.7c17.7 0 32 14.8 32 32.5v123.5l51.1 52.3H153.9z"
                }
            }
        ]
    })(props);
}
function FaDeezer(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M451.46,244.71H576V172H451.46Zm0-173.89v72.67H576V70.82Zm0,275.06H576V273.2H451.46ZM0,447.09H124.54V374.42H0Zm150.47,0H275V374.42H150.47Zm150.52,0H425.53V374.42H301Zm150.47,0H576V374.42H451.46ZM301,345.88H425.53V273.2H301Zm-150.52,0H275V273.2H150.47Zm0-101.17H275V172H150.47Z"
                }
            }
        ]
    })(props);
}
function FaDelicious(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M446.5 68c-.4-1.5-.9-3-1.4-4.5-.9-2.5-2-4.8-3.3-7.1-1.4-2.4-3-4.8-4.7-6.9-2.1-2.5-4.4-4.8-6.9-6.8-1.1-.9-2.2-1.7-3.3-2.5-1.3-.9-2.6-1.7-4-2.4-1.8-1-3.6-1.8-5.5-2.5-1.7-.7-3.5-1.3-5.4-1.7-3.8-1-7.9-1.5-12-1.5H48C21.5 32 0 53.5 0 80v352c0 4.1.5 8.2 1.5 12 2 7.7 5.8 14.6 11 20.3 1 1.1 2.1 2.2 3.3 3.3 5.7 5.2 12.6 9 20.3 11 3.8 1 7.9 1.5 12 1.5h352c26.5 0 48-21.5 48-48V80c-.1-4.1-.6-8.2-1.6-12zM416 432c0 8.8-7.2 16-16 16H224V256H32V80c0-8.8 7.2-16 16-16h176v192h192z"
                }
            }
        ]
    })(props);
}
function FaDeploydog(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M382.2 136h51.7v239.6h-51.7v-20.7c-19.8 24.8-52.8 24.1-73.8 14.7-26.2-11.7-44.3-38.1-44.3-71.8 0-29.8 14.8-57.9 43.3-70.8 20.2-9.1 52.7-10.6 74.8 12.9V136zm-64.7 161.8c0 18.2 13.6 33.5 33.2 33.5 19.8 0 33.2-16.4 33.2-32.9 0-17.1-13.7-33.2-33.2-33.2-19.6 0-33.2 16.4-33.2 32.6zM188.5 136h51.7v239.6h-51.7v-20.7c-19.8 24.8-52.8 24.1-73.8 14.7-26.2-11.7-44.3-38.1-44.3-71.8 0-29.8 14.8-57.9 43.3-70.8 20.2-9.1 52.7-10.6 74.8 12.9V136zm-64.7 161.8c0 18.2 13.6 33.5 33.2 33.5 19.8 0 33.2-16.4 33.2-32.9 0-17.1-13.7-33.2-33.2-33.2-19.7 0-33.2 16.4-33.2 32.6zM448 96c17.5 0 32 14.4 32 32v256c0 17.5-14.4 32-32 32H64c-17.5 0-32-14.4-32-32V128c0-17.5 14.4-32 32-32h384m0-32H64C28.8 64 0 92.8 0 128v256c0 35.2 28.8 64 64 64h384c35.2 0 64-28.8 64-64V128c0-35.2-28.8-64-64-64z"
                }
            }
        ]
    })(props);
}
function FaDeskpro(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 480 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M205.9 512l31.1-38.4c12.3-.2 25.6-1.4 36.5-6.6 38.9-18.6 38.4-61.9 38.3-63.8-.1-5-.8-4.4-28.9-37.4H362c-.2 50.1-7.3 68.5-10.2 75.7-9.4 23.7-43.9 62.8-95.2 69.4-8.7 1.1-32.8 1.2-50.7 1.1zm200.4-167.7c38.6 0 58.5-13.6 73.7-30.9l-175.5-.3-17.4 31.3 119.2-.1zm-43.6-223.9v168.3h-73.5l-32.7 55.5H250c-52.3 0-58.1-56.5-58.3-58.9-1.2-13.2-21.3-11.6-20.1 1.8 1.4 15.8 8.8 40 26.4 57.1h-91c-25.5 0-110.8-26.8-107-114V16.9C0 .9 9.7.3 15 .1h82c.2 0 .3.1.5.1 4.3-.4 50.1-2.1 50.1 43.7 0 13.3 20.2 13.4 20.2 0 0-18.2-5.5-32.8-15.8-43.7h84.2c108.7-.4 126.5 79.4 126.5 120.2zm-132.5 56l64 29.3c13.3-45.5-42.2-71.7-64-29.3z"
                }
            }
        ]
    })(props);
}
function FaDev(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M120.12 208.29c-3.88-2.9-7.77-4.35-11.65-4.35H91.03v104.47h17.45c3.88 0 7.77-1.45 11.65-4.35 3.88-2.9 5.82-7.25 5.82-13.06v-69.65c-.01-5.8-1.96-10.16-5.83-13.06zM404.1 32H43.9C19.7 32 .06 51.59 0 75.8v360.4C.06 460.41 19.7 480 43.9 480h360.2c24.21 0 43.84-19.59 43.9-43.8V75.8c-.06-24.21-19.7-43.8-43.9-43.8zM154.2 291.19c0 18.81-11.61 47.31-48.36 47.25h-46.4V172.98h47.38c35.44 0 47.36 28.46 47.37 47.28l.01 70.93zm100.68-88.66H201.6v38.42h32.57v29.57H201.6v38.41h53.29v29.57h-62.18c-11.16.29-20.44-8.53-20.72-19.69V193.7c-.27-11.15 8.56-20.41 19.71-20.69h63.19l-.01 29.52zm103.64 115.29c-13.2 30.75-36.85 24.63-47.44 0l-38.53-144.8h32.57l29.71 113.72 29.57-113.72h32.58l-38.46 144.8z"
                }
            }
        ]
    })(props);
}
function FaDeviantart(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 320 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M320 93.2l-98.2 179.1 7.4 9.5H320v127.7H159.1l-13.5 9.2-43.7 84c-.3 0-8.6 8.6-9.2 9.2H0v-93.2l93.2-179.4-7.4-9.2H0V102.5h156l13.5-9.2 43.7-84c.3 0 8.6-8.6 9.2-9.2H320v93.1z"
                }
            }
        ]
    })(props);
}
function FaDhl(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M238 301.2h58.7L319 271h-58.7L238 301.2zM0 282.9v6.4h81.8l4.7-6.4H0zM172.9 271c-8.7 0-6-3.6-4.6-5.5 2.8-3.8 7.6-10.4 10.4-14.1 2.8-3.7 2.8-5.9-2.8-5.9h-51l-41.1 55.8h100.1c33.1 0 51.5-22.5 57.2-30.3h-68.2zm317.5-6.9l39.3-53.4h-62.2l-39.3 53.4h62.2zM95.3 271H0v6.4h90.6l4.7-6.4zm111-26.6c-2.8 3.8-7.5 10.4-10.3 14.2-1.4 2-4.1 5.5 4.6 5.5h45.6s7.3-10 13.5-18.4c8.4-11.4.7-35-29.2-35H112.6l-20.4 27.8h111.4c5.6 0 5.5 2.2 2.7 5.9zM0 301.2h73.1l4.7-6.4H0v6.4zm323 0h58.7L404 271h-58.7c-.1 0-22.3 30.2-22.3 30.2zm222 .1h95v-6.4h-90.3l-4.7 6.4zm22.3-30.3l-4.7 6.4H640V271h-72.7zm-13.5 18.3H640v-6.4h-81.5l-4.7 6.4zm-164.2-78.6l-22.5 30.6h-26.2l22.5-30.6h-58.7l-39.3 53.4H409l39.3-53.4h-58.7zm33.5 60.3s-4.3 5.9-6.4 8.7c-7.4 10-.9 21.6 23.2 21.6h94.3l22.3-30.3H423.1z"
                }
            }
        ]
    })(props);
}
function FaDiaspora(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M251.64 354.55c-1.4 0-88 119.9-88.7 119.9S76.34 414 76 413.25s86.6-125.7 86.6-127.4c0-2.2-129.6-44-137.6-47.1-1.3-.5 31.4-101.8 31.7-102.1.6-.7 144.4 47 145.5 47 .4 0 .9-.6 1-1.3.4-2 1-148.6 1.7-149.6.8-1.2 104.5-.7 105.1-.3 1.5 1 3.5 156.1 6.1 156.1 1.4 0 138.7-47 139.3-46.3.8.9 31.9 102.2 31.5 102.6-.9.9-140.2 47.1-140.6 48.8-.3 1.4 82.8 122.1 82.5 122.9s-85.5 63.5-86.3 63.5c-1-.2-89-125.5-90.9-125.5z"
                }
            }
        ]
    })(props);
}
function FaDigg(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M81.7 172.3H0v174.4h132.7V96h-51v76.3zm0 133.4H50.9v-92.3h30.8v92.3zm297.2-133.4v174.4h81.8v28.5h-81.8V416H512V172.3H378.9zm81.8 133.4h-30.8v-92.3h30.8v92.3zm-235.6 41h82.1v28.5h-82.1V416h133.3V172.3H225.1v174.4zm51.2-133.3h30.8v92.3h-30.8v-92.3zM153.3 96h51.3v51h-51.3V96zm0 76.3h51.3v174.4h-51.3V172.3z"
                }
            }
        ]
    })(props);
}
function FaDigitalOcean(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M87 481.8h73.7v-73.6H87zM25.4 346.6v61.6H87v-61.6zm466.2-169.7c-23-74.2-82.4-133.3-156.6-156.6C164.9-32.8 8 93.7 8 255.9h95.8c0-101.8 101-180.5 208.1-141.7 39.7 14.3 71.5 46.1 85.8 85.7 39.1 107-39.7 207.8-141.4 208v.3h-.3V504c162.6 0 288.8-156.8 235.6-327.1zm-235.3 231v-95.3h-95.6v95.6H256v-.3z"
                }
            }
        ]
    })(props);
}
function FaDiscord(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M524.531,69.836a1.5,1.5,0,0,0-.764-.7A485.065,485.065,0,0,0,404.081,32.03a1.816,1.816,0,0,0-1.923.91,337.461,337.461,0,0,0-14.9,30.6,447.848,447.848,0,0,0-134.426,0,309.541,309.541,0,0,0-15.135-30.6,1.89,1.89,0,0,0-1.924-.91A483.689,483.689,0,0,0,116.085,69.137a1.712,1.712,0,0,0-.788.676C39.068,183.651,18.186,294.69,28.43,404.354a2.016,2.016,0,0,0,.765,1.375A487.666,487.666,0,0,0,176.02,479.918a1.9,1.9,0,0,0,2.063-.676A348.2,348.2,0,0,0,208.12,430.4a1.86,1.86,0,0,0-1.019-2.588,321.173,321.173,0,0,1-45.868-21.853,1.885,1.885,0,0,1-.185-3.126c3.082-2.309,6.166-4.711,9.109-7.137a1.819,1.819,0,0,1,1.9-.256c96.229,43.917,200.41,43.917,295.5,0a1.812,1.812,0,0,1,1.924.233c2.944,2.426,6.027,4.851,9.132,7.16a1.884,1.884,0,0,1-.162,3.126,301.407,301.407,0,0,1-45.89,21.83,1.875,1.875,0,0,0-1,2.611,391.055,391.055,0,0,0,30.014,48.815,1.864,1.864,0,0,0,2.063.7A486.048,486.048,0,0,0,610.7,405.729a1.882,1.882,0,0,0,.765-1.352C623.729,277.594,590.933,167.465,524.531,69.836ZM222.491,337.58c-28.972,0-52.844-26.587-52.844-59.239S193.056,219.1,222.491,219.1c29.665,0,53.306,26.82,52.843,59.239C275.334,310.993,251.924,337.58,222.491,337.58Zm195.38,0c-28.971,0-52.843-26.587-52.843-59.239S388.437,219.1,417.871,219.1c29.667,0,53.307,26.82,52.844,59.239C470.715,310.993,447.538,337.58,417.871,337.58Z"
                }
            }
        ]
    })(props);
}
function FaDiscourse(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M225.9 32C103.3 32 0 130.5 0 252.1 0 256 .1 480 .1 480l225.8-.2c122.7 0 222.1-102.3 222.1-223.9C448 134.3 348.6 32 225.9 32zM224 384c-19.4 0-37.9-4.3-54.4-12.1L88.5 392l22.9-75c-9.8-18.1-15.4-38.9-15.4-61 0-70.7 57.3-128 128-128s128 57.3 128 128-57.3 128-128 128z"
                }
            }
        ]
    })(props);
}
function FaDochub(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 416 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M397.9 160H256V19.6L397.9 160zM304 192v130c0 66.8-36.5 100.1-113.3 100.1H96V84.8h94.7c12 0 23.1.8 33.1 2.5v-84C212.9 1.1 201.4 0 189.2 0H0v512h189.2C329.7 512 400 447.4 400 318.1V192h-96z"
                }
            }
        ]
    })(props);
}
function FaDocker(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M349.9 236.3h-66.1v-59.4h66.1v59.4zm0-204.3h-66.1v60.7h66.1V32zm78.2 144.8H362v59.4h66.1v-59.4zm-156.3-72.1h-66.1v60.1h66.1v-60.1zm78.1 0h-66.1v60.1h66.1v-60.1zm276.8 100c-14.4-9.7-47.6-13.2-73.1-8.4-3.3-24-16.7-44.9-41.1-63.7l-14-9.3-9.3 14c-18.4 27.8-23.4 73.6-3.7 103.8-8.7 4.7-25.8 11.1-48.4 10.7H2.4c-8.7 50.8 5.8 116.8 44 162.1 37.1 43.9 92.7 66.2 165.4 66.2 157.4 0 273.9-72.5 328.4-204.2 21.4.4 67.6.1 91.3-45.2 1.5-2.5 6.6-13.2 8.5-17.1l-13.3-8.9zm-511.1-27.9h-66v59.4h66.1v-59.4zm78.1 0h-66.1v59.4h66.1v-59.4zm78.1 0h-66.1v59.4h66.1v-59.4zm-78.1-72.1h-66.1v60.1h66.1v-60.1z"
                }
            }
        ]
    })(props);
}
function FaDraft2Digital(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 480 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M480 398.1l-144-82.2v64.7h-91.3c30.8-35 81.8-95.9 111.8-149.3 35.2-62.6 16.1-123.4-12.8-153.3-4.4-4.6-62.2-62.9-166-41.2-59.1 12.4-89.4 43.4-104.3 67.3-13.1 20.9-17 39.8-18.2 47.7-5.5 33 19.4 67.1 56.7 67.1 31.7 0 57.3-25.7 57.3-57.4 0-27.1-19.7-52.1-48-56.8 1.8-7.3 17.7-21.1 26.3-24.7 41.1-17.3 78 5.2 83.3 33.5 8.3 44.3-37.1 90.4-69.7 127.6C84.5 328.1 18.3 396.8 0 415.9l336-.1V480zM369.9 371l47.1 27.2-47.1 27.2zM134.2 161.4c0 12.4-10 22.4-22.4 22.4s-22.4-10-22.4-22.4 10-22.4 22.4-22.4 22.4 10.1 22.4 22.4zM82.5 380.5c25.6-27.4 97.7-104.7 150.8-169.9 35.1-43.1 40.3-82.4 28.4-112.7-7.4-18.8-17.5-30.2-24.3-35.7 45.3 2.1 68 23.4 82.2 38.3 0 0 42.4 48.2 5.8 113.3-37 65.9-110.9 147.5-128.5 166.7z"
                }
            }
        ]
    })(props);
}
function FaDribbbleSquare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M90.2 228.2c8.9-42.4 37.4-77.7 75.7-95.7 3.6 4.9 28 38.8 50.7 79-64 17-120.3 16.8-126.4 16.7zM314.6 154c-33.6-29.8-79.3-41.1-122.6-30.6 3.8 5.1 28.6 38.9 51 80 48.6-18.3 69.1-45.9 71.6-49.4zM140.1 364c40.5 31.6 93.3 36.7 137.3 18-2-12-10-53.8-29.2-103.6-55.1 18.8-93.8 56.4-108.1 85.6zm98.8-108.2c-3.4-7.8-7.2-15.5-11.1-23.2C159.6 253 93.4 252.2 87.4 252c0 1.4-.1 2.8-.1 4.2 0 35.1 13.3 67.1 35.1 91.4 22.2-37.9 67.1-77.9 116.5-91.8zm34.9 16.3c17.9 49.1 25.1 89.1 26.5 97.4 30.7-20.7 52.5-53.6 58.6-91.6-4.6-1.5-42.3-12.7-85.1-5.8zm-20.3-48.4c4.8 9.8 8.3 17.8 12 26.8 45.5-5.7 90.7 3.4 95.2 4.4-.3-32.3-11.8-61.9-30.9-85.1-2.9 3.9-25.8 33.2-76.3 53.9zM448 80v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h352c26.5 0 48 21.5 48 48zm-64 176c0-88.2-71.8-160-160-160S64 167.8 64 256s71.8 160 160 160 160-71.8 160-160z"
                }
            }
        ]
    })(props);
}
function FaDribbble(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 8C119.252 8 8 119.252 8 256s111.252 248 248 248 248-111.252 248-248S392.748 8 256 8zm163.97 114.366c29.503 36.046 47.369 81.957 47.835 131.955-6.984-1.477-77.018-15.682-147.502-6.818-5.752-14.041-11.181-26.393-18.617-41.614 78.321-31.977 113.818-77.482 118.284-83.523zM396.421 97.87c-3.81 5.427-35.697 48.286-111.021 76.519-34.712-63.776-73.185-116.168-79.04-124.008 67.176-16.193 137.966 1.27 190.061 47.489zm-230.48-33.25c5.585 7.659 43.438 60.116 78.537 122.509-99.087 26.313-186.36 25.934-195.834 25.809C62.38 147.205 106.678 92.573 165.941 64.62zM44.17 256.323c0-2.166.043-4.322.108-6.473 9.268.19 111.92 1.513 217.706-30.146 6.064 11.868 11.857 23.915 17.174 35.949-76.599 21.575-146.194 83.527-180.531 142.306C64.794 360.405 44.17 310.73 44.17 256.323zm81.807 167.113c22.127-45.233 82.178-103.622 167.579-132.756 29.74 77.283 42.039 142.053 45.189 160.638-68.112 29.013-150.015 21.053-212.768-27.882zm248.38 8.489c-2.171-12.886-13.446-74.897-41.152-151.033 66.38-10.626 124.7 6.768 131.947 9.055-9.442 58.941-43.273 109.844-90.795 141.978z"
                }
            }
        ]
    })(props);
}
function FaDropbox(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 528 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M264.4 116.3l-132 84.3 132 84.3-132 84.3L0 284.1l132.3-84.3L0 116.3 132.3 32l132.1 84.3zM131.6 395.7l132-84.3 132 84.3-132 84.3-132-84.3zm132.8-111.6l132-84.3-132-83.6L395.7 32 528 116.3l-132.3 84.3L528 284.8l-132.3 84.3-131.3-85z"
                }
            }
        ]
    })(props);
}
function FaDrupal(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M319.5 114.7c-22.2-14-43.5-19.5-64.7-33.5-13-8.8-31.3-30-46.5-48.3-2.7 29.3-11.5 41.2-22 49.5-21.3 17-34.8 22.2-53.5 32.3C117 123 32 181.5 32 290.5 32 399.7 123.8 480 225.8 480 327.5 480 416 406 416 294c0-112.3-83-171-96.5-179.3zm2.5 325.6c-20.1 20.1-90.1 28.7-116.7 4.2-4.8-4.8.3-12 6.5-12 0 0 17 13.3 51.5 13.3 27 0 46-7.7 54.5-14 6.1-4.6 8.4 4.3 4.2 8.5zm-54.5-52.6c8.7-3.6 29-3.8 36.8 1.3 4.1 2.8 16.1 18.8 6.2 23.7-8.4 4.2-1.2-15.7-26.5-15.7-14.7 0-19.5 5.2-26.7 11-7 6-9.8 8-12.2 4.7-6-8.2 15.9-22.3 22.4-25zM360 405c-15.2-1-45.5-48.8-65-49.5-30.9-.9-104.1 80.7-161.3 42-38.8-26.6-14.6-104.8 51.8-105.2 49.5-.5 83.8 49 108.5 48.5 21.3-.3 61.8-41.8 81.8-41.8 48.7 0 23.3 109.3-15.8 106z"
                }
            }
        ]
    })(props);
}
function FaDyalog(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 416 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 32v119.2h64V96h107.2C284.6 96 352 176.2 352 255.9 352 332 293.4 416 171.2 416H0v64h171.2C331.9 480 416 367.3 416 255.9c0-58.7-22.1-113.4-62.3-154.3C308.9 56 245.7 32 171.2 32H0z"
                }
            }
        ]
    })(props);
}
function FaEarlybirds(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 480 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M313.2 47.5c1.2-13 21.3-14 36.6-8.7.9.3 26.2 9.7 19 15.2-27.9-7.4-56.4 18.2-55.6-6.5zm-201 6.9c30.7-8.1 62 20 61.1-7.1-1.3-14.2-23.4-15.3-40.2-9.6-1 .3-28.7 10.5-20.9 16.7zM319.4 160c-8.8 0-16 7.2-16 16s7.2 16 16 16 16-7.2 16-16-7.2-16-16-16zm-159.7 0c-8.8 0-16 7.2-16 16s7.2 16 16 16 16-7.2 16-16-7.2-16-16-16zm318.5 163.2c-9.9 24-40.7 11-63.9-1.2-13.5 69.1-58.1 111.4-126.3 124.2.3.9-2-.1 24 1 33.6 1.4 63.8-3.1 97.4-8-19.8-13.8-11.4-37.1-9.8-38.1 1.4-.9 14.7 1.7 21.6 11.5 8.6-12.5 28.4-14.8 30.2-13.6 1.6 1.1 6.6 20.9-6.9 34.6 4.7-.9 8.2-1.6 9.8-2.1 2.6-.8 17.7 11.3 3.1 13.3-14.3 2.3-22.6 5.1-47.1 10.8-45.9 10.7-85.9 11.8-117.7 12.8l1 11.6c3.8 18.1-23.4 24.3-27.6 6.2.8 17.9-27.1 21.8-28.4-1l-.5 5.3c-.7 18.4-28.4 17.9-28.3-.6-7.5 13.5-28.1 6.8-26.4-8.5l1.2-12.4c-36.7.9-59.7 3.1-61.8 3.1-20.9 0-20.9-31.6 0-31.6 2.4 0 27.7 1.3 63.2 2.8-61.1-15.5-103.7-55-114.9-118.2-25 12.8-57.5 26.8-68.2.8-10.5-25.4 21.5-42.6 66.8-73.4.7-6.6 1.6-13.3 2.7-19.8-14.4-19.6-11.6-36.3-16.1-60.4-16.8 2.4-23.2-9.1-23.6-23.1.3-7.3 2.1-14.9 2.4-15.4 1.1-1.8 10.1-2 12.7-2.6 6-31.7 50.6-33.2 90.9-34.5 19.7-21.8 45.2-41.5 80.9-48.3C203.3 29 215.2 8.5 216.2 8c1.7-.8 21.2 4.3 26.3 23.2 5.2-8.8 18.3-11.4 19.6-10.7 1.1.6 6.4 15-4.9 25.9 40.3 3.5 72.2 24.7 96 50.7 36.1 1.5 71.8 5.9 77.1 34 2.7.6 11.6.8 12.7 2.6.3.5 2.1 8.1 2.4 15.4-.5 13.9-6.8 25.4-23.6 23.1-3.2 17.3-2.7 32.9-8.7 47.7 2.4 11.7 4 23.8 4.8 36.4 37 25.4 70.3 42.5 60.3 66.9zM207.4 159.9c.9-44-37.9-42.2-78.6-40.3-21.7 1-38.9 1.9-45.5 13.9-11.4 20.9 5.9 92.9 23.2 101.2 9.8 4.7 73.4 7.9 86.3-7.1 8.2-9.4 15-49.4 14.6-67.7zm52 58.3c-4.3-12.4-6-30.1-15.3-32.7-2-.5-9-.5-11 0-10 2.8-10.8 22.1-17 37.2 15.4 0 19.3 9.7 23.7 9.7 4.3 0 6.3-11.3 19.6-14.2zm135.7-84.7c-6.6-12.1-24.8-12.9-46.5-13.9-40.2-1.9-78.2-3.8-77.3 40.3-.5 18.3 5 58.3 13.2 67.8 13 14.9 76.6 11.8 86.3 7.1 15.8-7.6 36.5-78.9 24.3-101.3z"
                }
            }
        ]
    })(props);
}
function FaEbay(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M606 189.5l-54.8 109.9-54.9-109.9h-37.5l10.9 20.6c-11.5-19-35.9-26-63.3-26-31.8 0-67.9 8.7-71.5 43.1h33.7c1.4-13.8 15.7-21.8 35-21.8 26 0 41 9.6 41 33v3.4c-12.7 0-28 .1-41.7.4-42.4.9-69.6 10-76.7 34.4 1-5.2 1.5-10.6 1.5-16.2 0-52.1-39.7-76.2-75.4-76.2-21.3 0-43 5.5-58.7 24.2v-80.6h-32.1v169.5c0 10.3-.6 22.9-1.1 33.1h31.5c.7-6.3 1.1-12.9 1.1-19.5 13.6 16.6 35.4 24.9 58.7 24.9 36.9 0 64.9-21.9 73.3-54.2-.5 2.8-.7 5.8-.7 9 0 24.1 21.1 45 60.6 45 26.6 0 45.8-5.7 61.9-25.5 0 6.6.3 13.3 1.1 20.2h29.8c-.7-8.2-1-17.5-1-26.8v-65.6c0-9.3-1.7-17.2-4.8-23.8l61.5 116.1-28.5 54.1h35.9L640 189.5zM243.7 313.8c-29.6 0-50.2-21.5-50.2-53.8 0-32.4 20.6-53.8 50.2-53.8 29.8 0 50.2 21.4 50.2 53.8 0 32.3-20.4 53.8-50.2 53.8zm200.9-47.3c0 30-17.9 48.4-51.6 48.4-25.1 0-35-13.4-35-25.8 0-19.1 18.1-24.4 47.2-25.3 13.1-.5 27.6-.6 39.4-.6zm-411.9 1.6h128.8v-8.5c0-51.7-33.1-75.4-78.4-75.4-56.8 0-83 30.8-83 77.6 0 42.5 25.3 74 82.5 74 31.4 0 68-11.7 74.4-46.1h-33.1c-12 35.8-87.7 36.7-91.2-21.6zm95-21.4H33.3c6.9-56.6 92.1-54.7 94.4 0z"
                }
            }
        ]
    })(props);
}
function FaEdgeLegacy(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M25.71,228.16l.35-.48c0,.16,0,.32-.07.48Zm460.58,15.51c0-44-7.76-84.46-28.81-122.4C416.5,47.88,343.91,8,258.89,8,119,7.72,40.62,113.21,26.06,227.68c42.42-61.31,117.07-121.38,220.37-125,0,0,109.67,0,99.42,105H170c6.37-37.39,18.55-59,34.34-78.93-75.05,34.9-121.85,96.1-120.75,188.32.83,71.45,50.13,144.84,120.75,172,83.35,31.84,192.77,7.2,240.13-21.33V363.31C363.6,419.8,173.6,424.23,172.21,295.74H486.29V243.67Z"
                }
            }
        ]
    })(props);
}
function FaEdge(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M481.92,134.48C440.87,54.18,352.26,8,255.91,8,137.05,8,37.51,91.68,13.47,203.66c26-46.49,86.22-79.14,149.46-79.14,79.27,0,121.09,48.93,122.25,50.18,22,23.8,33,50.39,33,83.1,0,10.4-5.31,25.82-15.11,38.57-1.57,2-6.39,4.84-6.39,11,0,5.06,3.29,9.92,9.14,14,27.86,19.37,80.37,16.81,80.51,16.81A115.39,115.39,0,0,0,444.94,322a118.92,118.92,0,0,0,58.95-102.44C504.39,176.13,488.39,147.26,481.92,134.48ZM212.77,475.67a154.88,154.88,0,0,1-46.64-45c-32.94-47.42-34.24-95.6-20.1-136A155.5,155.5,0,0,1,203,215.75c59-45.2,94.84-5.65,99.06-1a80,80,0,0,0-4.89-10.14c-9.24-15.93-24-36.41-56.56-53.51-33.72-17.69-70.59-18.59-77.64-18.59-38.71,0-77.9,13-107.53,35.69C35.68,183.3,12.77,208.72,8.6,243c-1.08,12.31-2.75,62.8,23,118.27a248,248,0,0,0,248.3,141.61C241.78,496.26,214.05,476.24,212.77,475.67Zm250.72-98.33a7.76,7.76,0,0,0-7.92-.23,181.66,181.66,0,0,1-20.41,9.12,197.54,197.54,0,0,1-69.55,12.52c-91.67,0-171.52-63.06-171.52-144A61.12,61.12,0,0,1,200.61,228,168.72,168.72,0,0,0,161.85,278c-14.92,29.37-33,88.13,13.33,151.66,6.51,8.91,23,30,56,47.67,23.57,12.65,49,19.61,71.7,19.61,35.14,0,115.43-33.44,163-108.87A7.75,7.75,0,0,0,463.49,377.34Z"
                }
            }
        ]
    })(props);
}
function FaElementor(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M425.6 32H22.4C10 32 0 42 0 54.4v403.2C0 470 10 480 22.4 480h403.2c12.4 0 22.4-10 22.4-22.4V54.4C448 42 438 32 425.6 32M164.3 355.5h-39.8v-199h39.8v199zm159.3 0H204.1v-39.8h119.5v39.8zm0-79.6H204.1v-39.8h119.5v39.8zm0-79.7H204.1v-39.8h119.5v39.8z"
                }
            }
        ]
    })(props);
}
function FaEllo(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111.03 8 0 119.03 0 256s111.03 248 248 248 248-111.03 248-248S384.97 8 248 8zm143.84 285.2C375.31 358.51 315.79 404.8 248 404.8s-127.31-46.29-143.84-111.6c-1.65-7.44 2.48-15.71 9.92-17.36 7.44-1.65 15.71 2.48 17.36 9.92 14.05 52.91 62 90.11 116.56 90.11s102.51-37.2 116.56-90.11c1.65-7.44 9.92-12.4 17.36-9.92 7.44 1.65 12.4 9.92 9.92 17.36z"
                }
            }
        ]
    })(props);
}
function FaEmber(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M639.9 254.6c-1.1-10.7-10.7-6.8-10.7-6.8s-15.6 12.1-29.3 10.7c-13.7-1.3-9.4-32-9.4-32s3-28.1-5.1-30.4c-8.1-2.4-18 7.3-18 7.3s-12.4 13.7-18.3 31.2l-1.6.5s1.9-30.6-.3-37.6c-1.6-3.5-16.4-3.2-18.8 3s-14.2 49.2-15 67.2c0 0-23.1 19.6-43.3 22.8s-25-9.4-25-9.4 54.8-15.3 52.9-59.1-44.2-27.6-49-24c-4.6 3.5-29.4 18.4-36.6 59.7-.2 1.4-.7 7.5-.7 7.5s-21.2 14.2-33 18c0 0 33-55.6-7.3-80.9-11.4-6.8-21.3-.5-27.2 5.3 13.6-17.3 46.4-64.2 36.9-105.2-5.8-24.4-18-27.1-29.2-23.1-17 6.7-23.5 16.7-23.5 16.7s-22 32-27.1 79.5-12.6 105.1-12.6 105.1-10.5 10.2-20.2 10.7-5.4-28.7-5.4-28.7 7.5-44.6 7-52.1-1.1-11.6-9.9-14.2c-8.9-2.7-18.5 8.6-18.5 8.6s-25.5 38.7-27.7 44.6l-1.3 2.4-1.3-1.6s18-52.7.8-53.5-28.5 18.8-28.5 18.8-19.6 32.8-20.4 36.5l-1.3-1.6s8.1-38.2 6.4-47.6c-1.6-9.4-10.5-7.5-10.5-7.5s-11.3-1.3-14.2 5.9-13.7 55.3-15 70.7c0 0-28.2 20.2-46.8 20.4-18.5.3-16.7-11.8-16.7-11.8s68-23.3 49.4-69.2c-8.3-11.8-18-15.5-31.7-15.3-13.7.3-30.3 8.6-41.3 33.3-5.3 11.8-6.8 23-7.8 31.5 0 0-12.3 2.4-18.8-2.9s-10 0-10 0-11.2 14-.1 18.3 28.1 6.1 28.1 6.1c1.6 7.5 6.2 19.5 19.6 29.7 20.2 15.3 58.8-1.3 58.8-1.3l15.9-8.8s.5 14.6 12.1 16.7 16.4 1 36.5-47.9c11.8-25 12.6-23.6 12.6-23.6l1.3-.3s-9.1 46.8-5.6 59.7C187.7 319.4 203 318 203 318s8.3 2.4 15-21.2 19.6-49.9 19.6-49.9h1.6s-5.6 48.1 3 63.7 30.9 5.3 30.9 5.3 15.6-7.8 18-10.2c0 0 18.5 15.8 44.6 12.9 58.3-11.5 79.1-25.9 79.1-25.9s10 24.4 41.1 26.7c35.5 2.7 54.8-18.6 54.8-18.6s-.3 13.5 12.1 18.6 20.7-22.8 20.7-22.8l20.7-57.2h1.9s1.1 37.3 21.5 43.2 47-13.7 47-13.7 6.4-3.5 5.3-14.3zm-578 5.3c.8-32 21.8-45.9 29-39 7.3 7 4.6 22-9.1 31.4-13.7 9.5-19.9 7.6-19.9 7.6zm272.8-123.8s19.1-49.7 23.6-25.5-40 96.2-40 96.2c.5-16.2 16.4-70.7 16.4-70.7zm22.8 138.4c-12.6 33-43.3 19.6-43.3 19.6s-3.5-11.8 6.4-44.9 33.3-20.2 33.3-20.2 16.2 12.4 3.6 45.5zm84.6-14.6s-3-10.5 8.1-30.6c11-20.2 19.6-9.1 19.6-9.1s9.4 10.2-1.3 25.5-26.4 14.2-26.4 14.2z"
                }
            }
        ]
    })(props);
}
function FaEmpire(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M287.6 54.2c-10.8-2.2-22.1-3.3-33.5-3.6V32.4c78.1 2.2 146.1 44 184.6 106.6l-15.8 9.1c-6.1-9.7-12.7-18.8-20.2-27.1l-18 15.5c-26-29.6-61.4-50.7-101.9-58.4l4.8-23.9zM53.4 322.4l23-7.7c-6.4-18.3-10-38.2-10-58.7s3.3-40.4 9.7-58.7l-22.7-7.7c3.6-10.8 8.3-21.3 13.6-31l-15.8-9.1C34 181 24.1 217.5 24.1 256s10 75 27.1 106.6l15.8-9.1c-5.3-10-9.7-20.3-13.6-31.1zM213.1 434c-40.4-8-75.8-29.1-101.9-58.7l-18 15.8c-7.5-8.6-14.4-17.7-20.2-27.4l-16 9.4c38.5 62.3 106.8 104.3 184.9 106.6v-18.3c-11.3-.3-22.7-1.7-33.5-3.6l4.7-23.8zM93.3 120.9l18 15.5c26-29.6 61.4-50.7 101.9-58.4l-4.7-23.8c10.8-2.2 22.1-3.3 33.5-3.6V32.4C163.9 34.6 95.9 76.4 57.4 139l15.8 9.1c6-9.7 12.6-18.9 20.1-27.2zm309.4 270.2l-18-15.8c-26 29.6-61.4 50.7-101.9 58.7l4.7 23.8c-10.8 1.9-22.1 3.3-33.5 3.6v18.3c78.1-2.2 146.4-44.3 184.9-106.6l-16.1-9.4c-5.7 9.7-12.6 18.8-20.1 27.4zM496 256c0 137-111 248-248 248S0 393 0 256 111 8 248 8s248 111 248 248zm-12.2 0c0-130.1-105.7-235.8-235.8-235.8S12.2 125.9 12.2 256 117.9 491.8 248 491.8 483.8 386.1 483.8 256zm-39-106.6l-15.8 9.1c5.3 9.7 10 20.2 13.6 31l-22.7 7.7c6.4 18.3 9.7 38.2 9.7 58.7s-3.6 40.4-10 58.7l23 7.7c-3.9 10.8-8.3 21-13.6 31l15.8 9.1C462 331 471.9 294.5 471.9 256s-9.9-75-27.1-106.6zm-183 177.7c16.3-3.3 30.4-11.6 40.7-23.5l51.2 44.8c11.9-13.6 21.3-29.3 27.1-46.8l-64.2-22.1c2.5-7.5 3.9-15.2 3.9-23.5s-1.4-16.1-3.9-23.5l64.5-22.1c-6.1-17.4-15.5-33.2-27.4-46.8l-51.2 44.8c-10.2-11.9-24.4-20.5-40.7-23.8l13.3-66.4c-8.6-1.9-17.7-2.8-27.1-2.8-9.4 0-18.5.8-27.1 2.8l13.3 66.4c-16.3 3.3-30.4 11.9-40.7 23.8l-51.2-44.8c-11.9 13.6-21.3 29.3-27.4 46.8l64.5 22.1c-2.5 7.5-3.9 15.2-3.9 23.5s1.4 16.1 3.9 23.5l-64.2 22.1c5.8 17.4 15.2 33.2 27.1 46.8l51.2-44.8c10.2 11.9 24.4 20.2 40.7 23.5l-13.3 66.7c8.6 1.7 17.7 2.8 27.1 2.8 9.4 0 18.5-1.1 27.1-2.8l-13.3-66.7z"
                }
            }
        ]
    })(props);
}
function FaEnvira(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 32c477.6 0 366.6 317.3 367.1 366.3L448 480h-26l-70.4-71.2c-39 4.2-124.4 34.5-214.4-37C47 300.3 52 214.7 0 32zm79.7 46c-49.7-23.5-5.2 9.2-5.2 9.2 45.2 31.2 66 73.7 90.2 119.9 31.5 60.2 79 139.7 144.2 167.7 65 28 34.2 12.5 6-8.5-28.2-21.2-68.2-87-91-130.2-31.7-60-61-118.6-144.2-158.1z"
                }
            }
        ]
    })(props);
}
function FaErlang(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M87.2 53.5H0v405h100.4c-49.7-52.6-78.8-125.3-78.7-212.1-.1-76.7 24-142.7 65.5-192.9zm238.2 9.7c-45.9.1-85.1 33.5-89.2 83.2h169.9c-1.1-49.7-34.5-83.1-80.7-83.2zm230.7-9.6h.3l-.1-.1zm.3 0c31.4 42.7 48.7 97.5 46.2 162.7.5 6 .5 11.7 0 24.1H230.2c-.2 109.7 38.9 194.9 138.6 195.3 68.5-.3 118-51 151.9-106.1l96.4 48.2c-17.4 30.9-36.5 57.8-57.9 80.8H640v-405z"
                }
            }
        ]
    })(props);
}
function FaEthereum(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 320 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M311.9 260.8L160 353.6 8 260.8 160 0l151.9 260.8zM160 383.4L8 290.6 160 512l152-221.4-152 92.8z"
                }
            }
        ]
    })(props);
}
function FaEtsy(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M384 348c-1.75 10.75-13.75 110-15.5 132-117.879-4.299-219.895-4.743-368.5 0v-25.5c45.457-8.948 60.627-8.019 61-35.25 1.793-72.322 3.524-244.143 0-322-1.029-28.46-12.13-26.765-61-36v-25.5c73.886 2.358 255.933 8.551 362.999-3.75-3.5 38.25-7.75 126.5-7.75 126.5H332C320.947 115.665 313.241 68 277.25 68h-137c-10.25 0-10.75 3.5-10.75 9.75V241.5c58 .5 88.5-2.5 88.5-2.5 29.77-.951 27.56-8.502 40.75-65.251h25.75c-4.407 101.351-3.91 61.829-1.75 160.25H257c-9.155-40.086-9.065-61.045-39.501-61.5 0 0-21.5-2-88-2v139c0 26 14.25 38.25 44.25 38.25H263c63.636 0 66.564-24.996 98.751-99.75H384z"
                }
            }
        ]
    })(props);
}
function FaEvernote(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M120.82 132.21c1.6 22.31-17.55 21.59-21.61 21.59-68.93 0-73.64-1-83.58 3.34-.56.22-.74 0-.37-.37L123.79 46.45c.38-.37.6-.22.38.37-4.35 9.99-3.35 15.09-3.35 85.39zm79 308c-14.68-37.08 13-76.93 52.52-76.62 17.49 0 22.6 23.21 7.95 31.42-6.19 3.3-24.95 1.74-25.14 19.2-.05 17.09 19.67 25 31.2 24.89A45.64 45.64 0 0 0 312 393.45v-.08c0-11.63-7.79-47.22-47.54-55.34-7.72-1.54-65-6.35-68.35-50.52-3.74 16.93-17.4 63.49-43.11 69.09-8.74 1.94-69.68 7.64-112.92-36.77 0 0-18.57-15.23-28.23-57.95-3.38-15.75-9.28-39.7-11.14-62 0-18 11.14-30.45 25.07-32.2 81 0 90 2.32 101-7.8 9.82-9.24 7.8-15.5 7.8-102.78 1-8.3 7.79-30.81 53.41-24.14 6 .86 31.91 4.18 37.48 30.64l64.26 11.15c20.43 3.71 70.94 7 80.6 57.94 22.66 121.09 8.91 238.46 7.8 238.46C362.15 485.53 267.06 480 267.06 480c-18.95-.23-54.25-9.4-67.27-39.83zm80.94-204.84c-1 1.92-2.2 6 .85 7 14.09 4.93 39.75 6.84 45.88 5.53 3.11-.25 3.05-4.43 2.48-6.65-3.53-21.85-40.83-26.5-49.24-5.92z"
                }
            }
        ]
    })(props);
}
function FaExpeditedssl(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 43.4C130.6 43.4 35.4 138.6 35.4 256S130.6 468.6 248 468.6 460.6 373.4 460.6 256 365.4 43.4 248 43.4zm-97.4 132.9c0-53.7 43.7-97.4 97.4-97.4s97.4 43.7 97.4 97.4v26.6c0 5-3.9 8.9-8.9 8.9h-17.7c-5 0-8.9-3.9-8.9-8.9v-26.6c0-82.1-124-82.1-124 0v26.6c0 5-3.9 8.9-8.9 8.9h-17.7c-5 0-8.9-3.9-8.9-8.9v-26.6zM389.7 380c0 9.7-8 17.7-17.7 17.7H124c-9.7 0-17.7-8-17.7-17.7V238.3c0-9.7 8-17.7 17.7-17.7h248c9.7 0 17.7 8 17.7 17.7V380zm-248-137.3v132.9c0 2.5-1.9 4.4-4.4 4.4h-8.9c-2.5 0-4.4-1.9-4.4-4.4V242.7c0-2.5 1.9-4.4 4.4-4.4h8.9c2.5 0 4.4 1.9 4.4 4.4zm141.7 48.7c0 13-7.2 24.4-17.7 30.4v31.6c0 5-3.9 8.9-8.9 8.9h-17.7c-5 0-8.9-3.9-8.9-8.9v-31.6c-10.5-6.1-17.7-17.4-17.7-30.4 0-19.7 15.8-35.4 35.4-35.4s35.5 15.8 35.5 35.4zM248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 478.3C121 486.3 17.7 383 17.7 256S121 25.7 248 25.7 478.3 129 478.3 256 375 486.3 248 486.3z"
                }
            }
        ]
    })(props);
}
function FaFacebookF(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 320 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M279.14 288l14.22-92.66h-88.91v-60.13c0-25.35 12.42-50.06 52.24-50.06h40.42V6.26S260.43 0 225.36 0c-73.22 0-121.08 44.38-121.08 124.72v70.62H22.89V288h81.39v224h100.17V288z"
                }
            }
        ]
    })(props);
}
function FaFacebookMessenger(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256.55 8C116.52 8 8 110.34 8 248.57c0 72.3 29.71 134.78 78.07 177.94 8.35 7.51 6.63 11.86 8.05 58.23A19.92 19.92 0 0 0 122 502.31c52.91-23.3 53.59-25.14 62.56-22.7C337.85 521.8 504 423.7 504 248.57 504 110.34 396.59 8 256.55 8zm149.24 185.13l-73 115.57a37.37 37.37 0 0 1-53.91 9.93l-58.08-43.47a15 15 0 0 0-18 0l-78.37 59.44c-10.46 7.93-24.16-4.6-17.11-15.67l73-115.57a37.36 37.36 0 0 1 53.91-9.93l58.06 43.46a15 15 0 0 0 18 0l78.41-59.38c10.44-7.98 24.14 4.54 17.09 15.62z"
                }
            }
        ]
    })(props);
}
function FaFacebookSquare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M400 32H48A48 48 0 0 0 0 80v352a48 48 0 0 0 48 48h137.25V327.69h-63V256h63v-54.64c0-62.15 37-96.48 93.67-96.48 27.14 0 55.52 4.84 55.52 4.84v61h-31.27c-30.81 0-40.42 19.12-40.42 38.73V256h68.78l-11 71.69h-57.78V480H400a48 48 0 0 0 48-48V80a48 48 0 0 0-48-48z"
                }
            }
        ]
    })(props);
}
function FaFacebook(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M504 256C504 119 393 8 256 8S8 119 8 256c0 123.78 90.69 226.38 209.25 245V327.69h-63V256h63v-54.64c0-62.15 37-96.48 93.67-96.48 27.14 0 55.52 4.84 55.52 4.84v61h-31.28c-30.8 0-40.41 19.12-40.41 38.73V256h68.78l-11 71.69h-57.78V501C413.31 482.38 504 379.78 504 256z"
                }
            }
        ]
    })(props);
}
function FaFantasyFlightGames(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 32.86L32.86 256 256 479.14 479.14 256 256 32.86zM88.34 255.83c1.96-2 11.92-12.3 96.49-97.48 41.45-41.75 86.19-43.77 119.77-18.69 24.63 18.4 62.06 58.9 62.15 59 .68.74 1.07 2.86.58 3.38-11.27 11.84-22.68 23.54-33.5 34.69-34.21-32.31-40.52-38.24-48.51-43.95-17.77-12.69-41.4-10.13-56.98 5.1-2.17 2.13-1.79 3.43.12 5.35 2.94 2.95 28.1 28.33 35.09 35.78-11.95 11.6-23.66 22.97-35.69 34.66-12.02-12.54-24.48-25.53-36.54-38.11-21.39 21.09-41.69 41.11-61.85 60.99a42569.01 42569.01 0 0 1-41.13-40.72zm234.82 101.6c-35.49 35.43-78.09 38.14-106.99 20.47-22.08-13.5-39.38-32.08-72.93-66.84 12.05-12.37 23.79-24.42 35.37-36.31 33.02 31.91 37.06 36.01 44.68 42.09 18.48 14.74 42.52 13.67 59.32-1.8 3.68-3.39 3.69-3.64.14-7.24-10.59-10.73-21.19-21.44-31.77-32.18-1.32-1.34-3.03-2.48-.8-4.69 10.79-10.71 21.48-21.52 32.21-32.29.26-.26.65-.38 1.91-1.07 12.37 12.87 24.92 25.92 37.25 38.75 21.01-20.73 41.24-40.68 61.25-60.42 13.68 13.4 27.13 26.58 40.86 40.03-20.17 20.86-81.68 82.71-100.5 101.5zM256 0L0 256l256 256 256-256L256 0zM16 256L256 16l240 240-240 240L16 256z"
                }
            }
        ]
    })(props);
}
function FaFedex(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M586 284.5l53.3-59.9h-62.4l-21.7 24.8-22.5-24.8H414v-16h56.1v-48.1H318.9V236h-.5c-9.6-11-21.5-14.8-35.4-14.8-28.4 0-49.8 19.4-57.3 44.9-18-59.4-97.4-57.6-121.9-14v-24.2H49v-26.2h60v-41.1H0V345h49v-77.5h48.9c-1.5 5.7-2.3 11.8-2.3 18.2 0 73.1 102.6 91.4 130.2 23.7h-42c-14.7 20.9-45.8 8.9-45.8-14.6h85.5c3.7 30.5 27.4 56.9 60.1 56.9 14.1 0 27-6.9 34.9-18.6h.5V345h212.2l22.1-25 22.3 25H640l-54-60.5zm-446.7-16.6c6.1-26.3 41.7-25.6 46.5 0h-46.5zm153.4 48.9c-34.6 0-34-62.8 0-62.8 32.6 0 34.5 62.8 0 62.8zm167.8 19.1h-94.4V169.4h95v30.2H405v33.9h55.5v28.1h-56.1v44.7h56.1v29.6zm-45.9-39.8v-24.4h56.1v-44l50.7 57-50.7 57v-45.6h-56.1zm138.6 10.3l-26.1 29.5H489l45.6-51.2-45.6-51.2h39.7l26.6 29.3 25.6-29.3h38.5l-45.4 51 46 51.4h-40.5l-26.3-29.5z"
                }
            }
        ]
    })(props);
}
function FaFedora(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M225 32C101.3 31.7.8 131.7.4 255.4L0 425.7a53.6 53.6 0 0 0 53.6 53.9l170.2.4c123.7.3 224.3-99.7 224.6-223.4S348.7 32.3 225 32zm169.8 157.2L333 126.6c2.3-4.7 3.8-9.2 3.8-14.3v-1.6l55.2 56.1a101 101 0 0 1 2.8 22.4zM331 94.3a106.06 106.06 0 0 1 58.5 63.8l-54.3-54.6a26.48 26.48 0 0 0-4.2-9.2zM118.1 247.2a49.66 49.66 0 0 0-7.7 11.4l-8.5-8.5a85.78 85.78 0 0 1 16.2-2.9zM97 251.4l11.8 11.9-.9 8a34.74 34.74 0 0 0 2.4 12.5l-27-27.2a80.6 80.6 0 0 1 13.7-5.2zm-18.2 7.4l38.2 38.4a53.17 53.17 0 0 0-14.1 4.7L67.6 266a107 107 0 0 1 11.2-7.2zm-15.2 9.8l35.3 35.5a67.25 67.25 0 0 0-10.5 8.5L53.5 278a64.33 64.33 0 0 1 10.1-9.4zm-13.3 12.3l34.9 35a56.84 56.84 0 0 0-7.7 11.4l-35.8-35.9c2.8-3.8 5.7-7.2 8.6-10.5zm-11 14.3l36.4 36.6a48.29 48.29 0 0 0-3.6 15.2l-39.5-39.8a99.81 99.81 0 0 1 6.7-12zm-8.8 16.3l41.3 41.8a63.47 63.47 0 0 0 6.7 26.2L25.8 326c1.4-4.9 2.9-9.6 4.7-14.5zm-7.9 43l61.9 62.2a31.24 31.24 0 0 0-3.6 14.3v1.1l-55.4-55.7a88.27 88.27 0 0 1-2.9-21.9zm5.3 30.7l54.3 54.6a28.44 28.44 0 0 0 4.2 9.2 106.32 106.32 0 0 1-58.5-63.8zm-5.3-37a80.69 80.69 0 0 1 2.1-17l72.2 72.5a37.59 37.59 0 0 0-9.9 8.7zm253.3-51.8l-42.6-.1-.1 56c-.2 69.3-64.4 115.8-125.7 102.9-5.7 0-19.9-8.7-19.9-24.2a24.89 24.89 0 0 1 24.5-24.6c6.3 0 6.3 1.6 15.7 1.6a55.91 55.91 0 0 0 56.1-55.9l.1-47c0-4.5-4.5-9-8.9-9l-33.6-.1c-32.6-.1-32.5-49.4.1-49.3l42.6.1.1-56a105.18 105.18 0 0 1 105.6-105 86.35 86.35 0 0 1 20.2 2.3c11.2 1.8 19.9 11.9 19.9 24 0 15.5-14.9 27.8-30.3 23.9-27.4-5.9-65.9 14.4-66 54.9l-.1 47a8.94 8.94 0 0 0 8.9 9l33.6.1c32.5.2 32.4 49.5-.2 49.4zm23.5-.3a35.58 35.58 0 0 0 7.6-11.4l8.5 8.5a102 102 0 0 1-16.1 2.9zm21-4.2L308.6 280l.9-8.1a34.74 34.74 0 0 0-2.4-12.5l27 27.2a74.89 74.89 0 0 1-13.7 5.3zm18-7.4l-38-38.4c4.9-1.1 9.6-2.4 13.7-4.7l36.2 35.9c-3.8 2.5-7.9 5-11.9 7.2zm15.5-9.8l-35.3-35.5a61.06 61.06 0 0 0 10.5-8.5l34.9 35a124.56 124.56 0 0 1-10.1 9zm13.2-12.3l-34.9-35a63.18 63.18 0 0 0 7.7-11.4l35.8 35.9a130.28 130.28 0 0 1-8.6 10.5zm11-14.3l-36.4-36.6a48.29 48.29 0 0 0 3.6-15.2l39.5 39.8a87.72 87.72 0 0 1-6.7 12zm13.5-30.9a140.63 140.63 0 0 1-4.7 14.3L345.6 190a58.19 58.19 0 0 0-7.1-26.2zm1-5.6l-71.9-72.1a32 32 0 0 0 9.9-9.2l64.3 64.7a90.93 90.93 0 0 1-2.3 16.6z"
                }
            }
        ]
    })(props);
}
function FaFigma(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14 95.7924C14 42.8877 56.8878 0 109.793 0H274.161C327.066 0 369.954 42.8877 369.954 95.7924C369.954 129.292 352.758 158.776 326.711 175.897C352.758 193.019 369.954 222.502 369.954 256.002C369.954 308.907 327.066 351.795 274.161 351.795H272.081C247.279 351.795 224.678 342.369 207.666 326.904V415.167C207.666 468.777 163.657 512 110.309 512C57.5361 512 14 469.243 14 416.207C14 382.709 31.1945 353.227 57.2392 336.105C31.1945 318.983 14 289.5 14 256.002C14 222.502 31.196 193.019 57.2425 175.897C31.196 158.776 14 129.292 14 95.7924ZM176.288 191.587H109.793C74.2172 191.587 45.3778 220.427 45.3778 256.002C45.3778 291.44 73.9948 320.194 109.381 320.416C109.518 320.415 109.655 320.415 109.793 320.415H176.288V191.587ZM207.666 256.002C207.666 291.577 236.505 320.417 272.081 320.417H274.161C309.737 320.417 338.576 291.577 338.576 256.002C338.576 220.427 309.737 191.587 274.161 191.587H272.081C236.505 191.587 207.666 220.427 207.666 256.002ZM109.793 351.795C109.655 351.795 109.518 351.794 109.381 351.794C73.9948 352.015 45.3778 380.769 45.3778 416.207C45.3778 451.652 74.6025 480.622 110.309 480.622C146.591 480.622 176.288 451.186 176.288 415.167V351.795H109.793ZM109.793 31.3778C74.2172 31.3778 45.3778 60.2173 45.3778 95.7924C45.3778 131.368 74.2172 160.207 109.793 160.207H176.288V31.3778H109.793ZM207.666 160.207H274.161C309.737 160.207 338.576 131.368 338.576 95.7924C338.576 60.2173 309.737 31.3778 274.161 31.3778H207.666V160.207Z"
                }
            }
        ]
    })(props);
}
function FaFirefoxBrowser(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M189.37,152.86Zm-58.74-29.37C130.79,123.5,130.71,123.5,130.63,123.49Zm351.42,45.35c-10.61-25.5-32.08-53-48.94-61.73,13.72,26.89,21.67,53.88,24.7,74,0,0,0,.14.05.41-27.58-68.75-74.35-96.47-112.55-156.83-1.93-3.05-3.86-6.11-5.74-9.33-1-1.65-1.86-3.34-2.69-5.05A44.88,44.88,0,0,1,333.24.69a.63.63,0,0,0-.55-.66.9.9,0,0,0-.46,0l-.12.07-.18.1.1-.14c-54.23,31.77-76.72,87.38-82.5,122.78a130,130,0,0,0-48.33,12.33,6.25,6.25,0,0,0-3.09,7.75,6.13,6.13,0,0,0,7.79,3.79l.52-.21a117.84,117.84,0,0,1,42.11-11l1.42-.1c2-.12,4-.2,6-.22A122.61,122.61,0,0,1,291,140c.67.2,1.32.42,2,.63,1.89.57,3.76,1.2,5.62,1.87,1.36.5,2.71,1,4.05,1.58,1.09.44,2.18.88,3.25,1.35q2.52,1.13,5,2.35c.75.37,1.5.74,2.25,1.13q2.4,1.26,4.74,2.63,1.51.87,3,1.8a124.89,124.89,0,0,1,42.66,44.13c-13-9.15-36.35-18.19-58.82-14.28,87.74,43.86,64.18,194.9-57.39,189.2a108.43,108.43,0,0,1-31.74-6.12c-2.42-.91-4.8-1.89-7.16-2.93-1.38-.63-2.76-1.27-4.12-2C174.5,346,149.9,316.92,146.83,281.59c0,0,11.25-41.95,80.62-41.95,7.5,0,28.93-20.92,29.33-27-.09-2-42.54-18.87-59.09-35.18-8.85-8.71-13.05-12.91-16.77-16.06a69.58,69.58,0,0,0-6.31-4.77A113.05,113.05,0,0,1,173.92,97c-25.06,11.41-44.55,29.45-58.71,45.37h-.12c-9.67-12.25-9-52.65-8.43-61.08-.12-.53-7.22,3.68-8.15,4.31a178.54,178.54,0,0,0-23.84,20.43A214,214,0,0,0,51.9,133.36l0,0a.08.08,0,0,1,0,0,205.84,205.84,0,0,0-32.73,73.9c-.06.27-2.33,10.21-4,22.48q-.42,2.87-.78,5.74c-.57,3.69-1,7.71-1.44,14,0,.24,0,.48-.05.72-.18,2.71-.34,5.41-.49,8.12,0,.41,0,.82,0,1.24,0,134.7,109.21,243.89,243.92,243.89,120.64,0,220.82-87.58,240.43-202.62.41-3.12.74-6.26,1.11-9.41,4.85-41.83-.54-85.79-15.82-122.55Z"
                }
            }
        ]
    })(props);
}
function FaFirefox(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M503.52,241.48c-.12-1.56-.24-3.12-.24-4.68v-.12l-.36-4.68v-.12a245.86,245.86,0,0,0-7.32-41.15c0-.12,0-.12-.12-.24l-1.08-4c-.12-.24-.12-.48-.24-.6-.36-1.2-.72-2.52-1.08-3.72-.12-.24-.12-.6-.24-.84-.36-1.2-.72-2.4-1.08-3.48-.12-.36-.24-.6-.36-1-.36-1.2-.72-2.28-1.2-3.48l-.36-1.08c-.36-1.08-.84-2.28-1.2-3.36a8.27,8.27,0,0,0-.36-1c-.48-1.08-.84-2.28-1.32-3.36-.12-.24-.24-.6-.36-.84-.48-1.2-1-2.28-1.44-3.48,0-.12-.12-.24-.12-.36-1.56-3.84-3.24-7.68-5-11.4l-.36-.72c-.48-1-.84-1.8-1.32-2.64-.24-.48-.48-1.08-.72-1.56-.36-.84-.84-1.56-1.2-2.4-.36-.6-.6-1.2-1-1.8s-.84-1.44-1.2-2.28c-.36-.6-.72-1.32-1.08-1.92s-.84-1.44-1.2-2.16a18.07,18.07,0,0,0-1.2-2c-.36-.72-.84-1.32-1.2-2s-.84-1.32-1.2-2-.84-1.32-1.2-1.92-.84-1.44-1.32-2.16a15.63,15.63,0,0,0-1.2-1.8L463.2,119a15.63,15.63,0,0,0-1.2-1.8c-.48-.72-1.08-1.56-1.56-2.28-.36-.48-.72-1.08-1.08-1.56l-1.8-2.52c-.36-.48-.6-.84-1-1.32-1-1.32-1.8-2.52-2.76-3.72a248.76,248.76,0,0,0-23.51-26.64A186.82,186.82,0,0,0,412,62.46c-4-3.48-8.16-6.72-12.48-9.84a162.49,162.49,0,0,0-24.6-15.12c-2.4-1.32-4.8-2.52-7.2-3.72a254,254,0,0,0-55.43-19.56c-1.92-.36-3.84-.84-5.64-1.2h-.12c-1-.12-1.8-.36-2.76-.48a236.35,236.35,0,0,0-38-4H255.14a234.62,234.62,0,0,0-45.48,5c-33.59,7.08-63.23,21.24-82.91,39-1.08,1-1.92,1.68-2.4,2.16l-.48.48H124l-.12.12.12-.12a.12.12,0,0,0,.12-.12l-.12.12a.42.42,0,0,1,.24-.12c14.64-8.76,34.92-16,49.44-19.56l5.88-1.44c.36-.12.84-.12,1.2-.24,1.68-.36,3.36-.72,5.16-1.08.24,0,.6-.12.84-.12C250.94,20.94,319.34,40.14,367,85.61a171.49,171.49,0,0,1,26.88,32.76c30.36,49.2,27.48,111.11,3.84,147.59-34.44,53-111.35,71.27-159,24.84a84.19,84.19,0,0,1-25.56-59,74.05,74.05,0,0,1,6.24-31c1.68-3.84,13.08-25.67,18.24-24.59-13.08-2.76-37.55,2.64-54.71,28.19-15.36,22.92-14.52,58.2-5,83.28a132.85,132.85,0,0,1-12.12-39.24c-12.24-82.55,43.31-153,94.31-170.51-27.48-24-96.47-22.31-147.71,15.36-29.88,22-51.23,53.16-62.51,90.36,1.68-20.88,9.6-52.08,25.8-83.88-17.16,8.88-39,37-49.8,62.88-15.6,37.43-21,82.19-16.08,124.79.36,3.24.72,6.36,1.08,9.6,19.92,117.11,122,206.38,244.78,206.38C392.77,503.42,504,392.19,504,255,503.88,250.48,503.76,245.92,503.52,241.48Z"
                }
            }
        ]
    })(props);
}
function FaFirstOrderAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111.03 8 0 119.03 0 256s111.03 248 248 248 248-111.03 248-248S384.97 8 248 8zm0 488.21C115.34 496.21 7.79 388.66 7.79 256S115.34 15.79 248 15.79 488.21 123.34 488.21 256 380.66 496.21 248 496.21zm0-459.92C126.66 36.29 28.29 134.66 28.29 256S126.66 475.71 248 475.71 467.71 377.34 467.71 256 369.34 36.29 248 36.29zm0 431.22c-116.81 0-211.51-94.69-211.51-211.51S131.19 44.49 248 44.49 459.51 139.19 459.51 256 364.81 467.51 248 467.51zm186.23-162.98a191.613 191.613 0 0 1-20.13 48.69l-74.13-35.88 61.48 54.82a193.515 193.515 0 0 1-37.2 37.29l-54.8-61.57 35.88 74.27a190.944 190.944 0 0 1-48.63 20.23l-27.29-78.47 4.79 82.93c-8.61 1.18-17.4 1.8-26.33 1.8s-17.72-.62-26.33-1.8l4.76-82.46-27.15 78.03a191.365 191.365 0 0 1-48.65-20.2l35.93-74.34-54.87 61.64a193.85 193.85 0 0 1-37.22-37.28l61.59-54.9-74.26 35.93a191.638 191.638 0 0 1-20.14-48.69l77.84-27.11-82.23 4.76c-1.16-8.57-1.78-17.32-1.78-26.21 0-9 .63-17.84 1.82-26.51l82.38 4.77-77.94-27.16a191.726 191.726 0 0 1 20.23-48.67l74.22 35.92-61.52-54.86a193.85 193.85 0 0 1 37.28-37.22l54.76 61.53-35.83-74.17a191.49 191.49 0 0 1 48.65-20.13l26.87 77.25-4.71-81.61c8.61-1.18 17.39-1.8 26.32-1.8s17.71.62 26.32 1.8l-4.74 82.16 27.05-77.76c17.27 4.5 33.6 11.35 48.63 20.17l-35.82 74.12 54.72-61.47a193.13 193.13 0 0 1 37.24 37.23l-61.45 54.77 74.12-35.86a191.515 191.515 0 0 1 20.2 48.65l-77.81 27.1 82.24-4.75c1.19 8.66 1.82 17.5 1.82 26.49 0 8.88-.61 17.63-1.78 26.19l-82.12-4.75 77.72 27.09z"
                }
            }
        ]
    })(props);
}
function FaFirstOrder(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.9 229.2c.1-.1.2-.3.3-.4 0 .1 0 .3-.1.4h-.2zM224 96.6c-7.1 0-14.6.6-21.4 1.7l3.7 67.4-22-64c-14.3 3.7-27.7 9.4-40 16.6l29.4 61.4-45.1-50.9c-11.4 8.9-21.7 19.1-30.6 30.9l50.6 45.4-61.1-29.7c-7.1 12.3-12.9 25.7-16.6 40l64.3 22.6-68-4c-.9 7.1-1.4 14.6-1.4 22s.6 14.6 1.4 21.7l67.7-4-64 22.6c3.7 14.3 9.4 27.7 16.6 40.3l61.1-29.7L97.7 352c8.9 11.7 19.1 22.3 30.9 30.9l44.9-50.9-29.5 61.4c12.3 7.4 25.7 13.1 40 16.9l22.3-64.6-4 68c7.1 1.1 14.6 1.7 21.7 1.7 7.4 0 14.6-.6 21.7-1.7l-4-68.6 22.6 65.1c14.3-4 27.7-9.4 40-16.9L274.9 332l44.9 50.9c11.7-8.9 22-19.1 30.6-30.9l-50.6-45.1 61.1 29.4c7.1-12.3 12.9-25.7 16.6-40.3l-64-22.3 67.4 4c1.1-7.1 1.4-14.3 1.4-21.7s-.3-14.9-1.4-22l-67.7 4 64-22.3c-3.7-14.3-9.1-28-16.6-40.3l-60.9 29.7 50.6-45.4c-8.9-11.7-19.1-22-30.6-30.9l-45.1 50.9 29.4-61.1c-12.3-7.4-25.7-13.1-40-16.9L241.7 166l4-67.7c-7.1-1.2-14.3-1.7-21.7-1.7zM443.4 128v256L224 512 4.6 384V128L224 0l219.4 128zm-17.1 10.3L224 20.9 21.7 138.3v235.1L224 491.1l202.3-117.7V138.3zM224 37.1l187.7 109.4v218.9L224 474.9 36.3 365.4V146.6L224 37.1zm0 50.9c-92.3 0-166.9 75.1-166.9 168 0 92.6 74.6 167.7 166.9 167.7 92 0 166.9-75.1 166.9-167.7 0-92.9-74.9-168-166.9-168z"
                }
            }
        ]
    })(props);
}
function FaFirstdraft(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M384 192h-64v128H192v128H0v-25.6h166.4v-128h128v-128H384V192zm-25.6 38.4v128h-128v128H64V512h192V384h128V230.4h-25.6zm25.6 192h-89.6V512H320v-64h64v-25.6zM0 0v384h128V256h128V128h128V0H0z"
                }
            }
        ]
    })(props);
}
function FaFlickr(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zM144.5 319c-35.1 0-63.5-28.4-63.5-63.5s28.4-63.5 63.5-63.5 63.5 28.4 63.5 63.5-28.4 63.5-63.5 63.5zm159 0c-35.1 0-63.5-28.4-63.5-63.5s28.4-63.5 63.5-63.5 63.5 28.4 63.5 63.5-28.4 63.5-63.5 63.5z"
                }
            }
        ]
    })(props);
}
function FaFlipboard(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 32v448h448V32H0zm358.4 179.2h-89.6v89.6h-89.6v89.6H89.6V121.6h268.8v89.6z"
                }
            }
        ]
    })(props);
}
function FaFly(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M197.8 427.8c12.9 11.7 33.7 33.3 33.2 50.7 0 .8-.1 1.6-.1 2.5-1.8 19.8-18.8 31.1-39.1 31-25-.1-39.9-16.8-38.7-35.8 1-16.2 20.5-36.7 32.4-47.6 2.3-2.1 2.7-2.7 5.6-3.6 3.4 0 3.9.3 6.7 2.8zM331.9 67.3c-16.3-25.7-38.6-40.6-63.3-52.1C243.1 4.5 214-.2 192 0c-44.1 0-71.2 13.2-81.1 17.3C57.3 45.2 26.5 87.2 28 158.6c7.1 82.2 97 176 155.8 233.8 1.7 1.6 4.5 4.5 6.2 5.1l3.3.1c2.1-.7 1.8-.5 3.5-2.1 52.3-49.2 140.7-145.8 155.9-215.7 7-39.2 3.1-72.5-20.8-112.5zM186.8 351.9c-28-51.1-65.2-130.7-69.3-189-3.4-47.5 11.4-131.2 69.3-136.7v325.7zM328.7 180c-16.4 56.8-77.3 128-118.9 170.3C237.6 298.4 275 217 277 158.4c1.6-45.9-9.8-105.8-48-131.4 88.8 18.3 115.5 98.1 99.7 153z"
                }
            }
        ]
    })(props);
}
function FaFontAwesomeAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M400 32H48A48 48 0 0 0 0 80V432a48 48 0 0 0 48 48H400a48 48 0 0 0 48-48V80A48 48 0 0 0 400 32Zm16 400a16 16 0 0 1-16 16H48a16 16 0 0 1-16-16V80A16 16 0 0 1 48 64H400a16 16 0 0 1 16 16ZM201.6 152c-25.4 0-37.4 10.4-57.6 14.4V160a16 16 0 0 0-32 0V352a16 16 0 0 0 32 0V198.4c20.2-4 32.2-14.4 57.6-14.4 31.4 0 43.2 16 74.6 16 10.2 0 17.8-1.4 27.8-4.6v96c-10 3.2-17.6 4.6-27.8 4.6-31.4 0-43.4-16-74.6-16a85.9 85.9 0 0 0-25.6 4v32a80 80 0 0 1 25.6-4c31.4 0 43.2 16 74.6 16 18.6 0 28.2-4.8 59.8-16V152c-31.6 11.2-41.2 16-59.8 16C244.8 168 232.8 152 201.6 152Z"
                }
            }
        ]
    })(props);
}
function FaFontAwesomeFlag(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M448 48V384c-63 23-82 32-119 32-63 0-87-32-150-32-20 0-36 4-51 8V328c15-4 31-8 51-8 63 0 87 32 150 32 20 0 35-3 55-9V135c-20 6-35 9-55 9-63 0-87-32-150-32-51 0-75 21-115 29V448a31.6 31.6 0 0 1-32 32A31.6 31.6 0 0 1 0 448V64A31.6 31.6 0 0 1 32 32 31.6 31.6 0 0 1 64 64V77c40-8 64-29 115-29 63 0 87 32 150 32C366 80 385 71 448 48Z"
                }
            }
        ]
    })(props);
}
function FaFontAwesomeLogoFull(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 3992 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M1209.7 156.5c-57.8 0-102 43.9-102 99.1 0 56 44.6 99.1 102 99.1 57.4 0 102-43.1 102-99.1C1311.7 200.4 1267.5 156.5 1209.7 156.5Zm0 152.7c-35.1 0-51.8-27.4-51.8-53.2 0-25.8 16.7-53.2 51.8-53.2 35.1 0 51.8 27.8 51.8 53.2C1261.1 281.8 1244.8 309.2 1209.7 309.2Zm962.1-136.1c-4.4-10.9-12.3-16.5-23.5-16.5s-19.1 5.6-23.5 16.5l-59.4 145.8c-7.2 17.7 2.8 27.4 4.4 29a24.6 24.6 0 0 0 17.5 6.8c10.8 0 18.7-6 23.1-18.1l4-10.1h67.7l4 10.1c4.8 12.1 12.3 18.1 23.1 18.1a24.6 24.6 0 0 0 17.5-6.8c10-10.1 6.8-22.6 4.4-29Zm-43 113.6 19.1-56 19.1 56Zm-574.5-130.1c-14.3 0-24.7 10.9-24.7 25.4v76.5l-68.5-85.8c-4.4-5.6-11.6-16.1-25.5-16.1-19.1 0-24.3 17.7-24.3 25.4V329.7c0 14.1 10.4 25.4 24.7 25.4 14.3 0 24.7-10.9 24.7-25.4V252.8l68.9 86.2c4.8 5.6 11.6 16.1 25.5 16.1 19.1 0 23.9-17.3 23.9-25.4V181.9C1579 167.4 1568.6 156.5 1554.3 156.5Zm-554.1 1.6H916.5c-19.9 0-25.1 17.3-25.1 25.4V328.1c0 19.7 16.7 25.4 24.7 25.4 8 0 24.7-5.2 24.7-25.4V285h44.6c12.8 0 22.7-9.3 22.7-22.6 0-17.7-15.5-22.1-22.7-22.1H940.8V203.6h59.4c12.8 0 22.7-9.3 22.7-22.6C1022.9 163 1007.3 158.1 1000.2 158.1Zm815.1 0H1691.7c-7.2 0-22.7 4.4-22.7 22.2 0 13.3 10 22.6 22.7 22.6h37V327.7c0 14.1 10.4 25.4 24.7 25.4 14.3 0 24.7-10.9 24.7-25.4V202.8h37c12.7 0 22.7-9.3 22.7-22.6C1837.9 163 1822.4 158.1 1815.2 158.1Zm1789.5-1.6c-9.6 0-17.5 6-25.1 18.1l-46.6 76.1L3486.4 174.6q-10.8-18.1-25.1-18.1c-19.5 0-24.7 18.1-24.7 25.8V329.7c0 14.1 10.4 25.4 24.7 25.4s24.7-10.9 24.7-25.4V262.8L3510.7 302.7c6.4 10.1 13.9 15.3 22.3 15.3 8.8 0 15.9-5.2 22.3-15.3l24.7-39.9v66.9c0 14.1 10.3 25.4 24.7 25.4 14.3 0 24.7-10.9 24.7-25.4V182.3C3629.4 174.2 3624.6 156.5 3604.7 156.5Zm248.6 149.8h-65.7V272.9h39.4c11.9 0 21.1-8.9 21.1-20.9 0-12.1-9.2-20.9-21.1-20.9h-39.4V204.8h62.1c12.8 0 22.7-9.3 22.7-22.6 0-17.7-15.6-22.2-22.7-22.2h-86.4c-19.9 0-25.1 17.3-25.1 25.4V326.5c0 8.1 5.2 25.4 25.1 25.4h90c12.8 0 22.7-9.3 22.7-22.6C3876 311.2 3860.5 306.3 3853.3 306.3ZM3235 156.5c-57.8 0-102 43.9-102 99.1 0 56 44.6 99.1 102 99.1 57.4 0 102-43.1 102-99.1C3337 200.4 3292.8 156.5 3235 156.5Zm0 152.7c-35.1 0-51.8-27.4-51.8-53.2 0-25.8 16.7-53.2 51.8-53.2 35.1 0 51.8 27.8 51.8 53.2C3286.8 281.8 3270.1 309.2 3235 309.2ZM2550.2 156.5c-11.2 0-19.1 5.6-23.1 16.5l-34.3 94.7-31.5-92.2c-4.4-12.5-12.3-18.9-24.3-18.9-11.9 0-19.9 6.4-24.3 18.9l-31.5 92.2-34.3-95.5q-5.4-15.7-22.7-15.7c-6.8 0-12.3 2.4-17.5 7.3-5.2 5.2-10.8 14.5-4.8 28.6l55.8 145.8c4 11.3 11.6 16.9 23.1 16.9q16.7 0 22.7-16.9l33.5-91.8 33.5 91.8q6 16.9 22.7 16.9c11.2 0 19.1-5.6 23.1-16.9l55.8-145.8c3.6-9.3 4.4-19.3-4.8-28.6A23 23 0 0 0 2550.2 156.5Zm444.2 81-21.9-9.3c-11.9-4.8-16.3-8.5-16.3-15.7q0-12.1 16.7-12.1c12.7 0 19.5 7.7 24.3 10.9 7.2 5.2 18.3 6.8 27.9-2 10.8-10.5 6.8-23.8 1.2-30.6-12.3-14.9-30.3-22.2-53.8-22.2-19.1 0-35.1 5.2-47.4 15.7-12.3 10.5-18.7 24.2-18.7 41.1 0 24.2 15.9 43.5 47.8 57.6l19.5 8.9c15.9 6.8 19.1 9.7 19.1 17.7 0 9.3-6.4 14.1-19.5 14.1-19.1 0-34.7-14.9-36.3-16.1-10.8-7.3-21.5-2-26.3 2.8-6.8 6.4-12.7 20.9 3.2 36.2 6.8 6.4 15.5 11.7 26.7 15.3a94.6 94.6 0 0 0 32.7 5.6c19.9 0 36.7-5.2 49.8-16.1 13.1-10.9 19.5-25.4 19.5-43.5q0-20.5-12-33.8C3022.7 253.2 3010.7 244.3 2994.4 237.5Zm-206.4 68.9h-65.7V272.9h39.4c12 0 21.1-8.9 21.1-20.9 0-12.1-9.2-20.9-21.1-20.9h-39.4V204.8h62.1c12.8 0 22.7-9.3 22.7-22.6 0-17.7-15.5-22.2-22.7-22.2h-86.4c-19.9 0-25.1 17.3-25.1 25.4V326.5c0 8.1 5.2 25.4 25.1 25.4h90c12.7 0 22.7-9.3 22.7-22.6C2810.8 311.2 2795.2 306.3 2788 306.3ZM178.3 49.1c-50.5 0-74.4 20.7-114.6 28.7V65A31.8 31.8 0 1 0 0 65V447a31.8 31.8 0 0 0 63.7 0V141.4c40.2-8 64.1-28.7 114.6-28.7 62.5 0 86 31.8 148.4 31.8 20.3 0 35.4-2.8 55.3-9.2v191c-19.9 6.4-35 9.2-55.3 9.2-62.5 0-86.4-31.8-148.4-31.8-20.3 0-36.2 3.6-50.9 8V375.4a159.1 159.1 0 0 1 50.9-8c62.5 0 86 31.8 148.4 31.8 37 0 56.1-9.6 119-31.8V49.1C382.8 71.4 363.7 80.9 326.7 80.9 264.2 80.9 240.4 49.1 178.3 49.1Z"
                }
            }
        ]
    })(props);
}
function FaFontAwesome(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M400 32H48A48 48 0 0 0 0 80V432a48 48 0 0 0 48 48H400a48 48 0 0 0 48-48V80A48 48 0 0 0 400 32ZM336 312c-31.6 11.2-41.2 16-59.8 16-31.4 0-43.2-16-74.6-16a80 80 0 0 0-25.6 4V284a85.9 85.9 0 0 1 25.6-4c31.2 0 43.2 16 74.6 16 10.2 0 17.8-1.4 27.8-4.6v-96c-10 3.2-17.6 4.6-27.8 4.6-31.4 0-43.2-16-74.6-16-25.4 0-37.4 10.4-57.6 14.4V352a16 16 0 0 1-32 0V160a16 16 0 0 1 32 0v6.4c20.2-4 32.2-14.4 57.6-14.4 31.2 0 43.2 16 74.6 16 18.6 0 28.2-4.8 59.8-16Z"
                }
            }
        ]
    })(props);
}
function FaFonticonsFi(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M114.4 224h92.4l-15.2 51.2h-76.4V433c0 8-2.8 9.2 4.4 10l59.6 5.6V483H0v-35.2l29.2-2.8c7.2-.8 9.2-3.2 9.2-10.8V278.4c0-3.2-4-3.2-8-3.2H0V224h38.4v-28.8c0-68 36.4-96 106-96 46.8 0 88.8 11.2 88.8 72.4l-69.6 8.4c.4-25.6-6-31.6-22.4-31.6-25.2 0-26 13.6-26 37.6v32c0 3.2-4.8 6-.8 6zM384 483H243.2v-34.4l28-3.6c7.2-.8 10.4-2.4 10.4-10V287c0-5.6-4-9.2-9.2-10.8l-33.2-8.8 9.2-40.4h110v208c0 8-3.6 8.8 4 10l21.6 3.6V483zm-30-347.2l12.4 45.6-10 10-42.8-22.8-42.8 22.8-10-10 12.4-45.6-30-36.4 4.8-10h38L307.2 51H320l21.2 38.4h38l4.8 13.2-30 33.2z"
                }
            }
        ]
    })(props);
}
function FaFonticons(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 32v448h448V32zm187 140.9c-18.4 0-19 9.9-19 27.4v23.3c0 2.4-3.5 4.4-.6 4.4h67.4l-11.1 37.3H168v112.9c0 5.8-2 6.7 3.2 7.3l43.5 4.1v25.1H84V389l21.3-2c5.2-.6 6.7-2.3 6.7-7.9V267.7c0-2.3-2.9-2.3-5.8-2.3H84V228h28v-21c0-49.6 26.5-70 77.3-70 34.1 0 64.7 8.2 64.7 52.8l-50.7 6.1c.3-18.7-4.4-23-16.3-23zm74.3 241.8v-25.1l20.4-2.6c5.2-.6 7.6-1.7 7.6-7.3V271.8c0-4.1-2.9-6.7-6.7-7.9l-24.2-6.4 6.7-29.5h80.2v151.7c0 5.8-2.6 6.4 2.9 7.3l15.7 2.6v25.1zm80.8-255.5l9 33.2-7.3 7.3-31.2-16.6-31.2 16.6-7.3-7.3 9-33.2-21.8-24.2 3.5-9.6h27.7l15.5-28h9.3l15.5 28h27.7l3.5 9.6z"
                }
            }
        ]
    })(props);
}
function FaFortAwesomeAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M208 237.4h-22.2c-2.1 0-3.7 1.6-3.7 3.7v51.7c0 2.1 1.6 3.7 3.7 3.7H208c2.1 0 3.7-1.6 3.7-3.7v-51.7c0-2.1-1.6-3.7-3.7-3.7zm118.2 0H304c-2.1 0-3.7 1.6-3.7 3.7v51.7c0 2.1 1.6 3.7 3.7 3.7h22.2c2.1 0 3.7-1.6 3.7-3.7v-51.7c-.1-2.1-1.7-3.7-3.7-3.7zm132-125.1c-2.3-3.2-4.6-6.4-7.1-9.5-9.8-12.5-20.8-24-32.8-34.4-4.5-3.9-9.1-7.6-13.9-11.2-1.6-1.2-3.2-2.3-4.8-3.5C372 34.1 340.3 20 306 13c-16.2-3.3-32.9-5-50-5s-33.9 1.7-50 5c-34.3 7.1-66 21.2-93.3 40.8-1.6 1.1-3.2 2.3-4.8 3.5-4.8 3.6-9.4 7.3-13.9 11.2-3 2.6-5.9 5.3-8.8 8s-5.7 5.5-8.4 8.4c-5.5 5.7-10.7 11.8-15.6 18-2.4 3.1-4.8 6.3-7.1 9.5C25.2 153 8.3 202.5 8.3 256c0 2 .1 4 .1 6 .1.7.1 1.3.1 2 .1 1.3.1 2.7.2 4 0 .8.1 1.5.1 2.3 0 1.3.1 2.5.2 3.7.1.8.1 1.6.2 2.4.1 1.1.2 2.3.3 3.5 0 .8.1 1.6.2 2.4.1 1.2.3 2.4.4 3.6.1.8.2 1.5.3 2.3.1 1.3.3 2.6.5 3.9.1.6.2 1.3.3 1.9l.9 5.7c.1.6.2 1.1.3 1.7.3 1.3.5 2.7.8 4 .2.8.3 1.6.5 2.4.2 1 .5 2.1.7 3.2.2.9.4 1.7.6 2.6.2 1 .4 2 .7 3 .2.9.5 1.8.7 2.7.3 1 .5 1.9.8 2.9.3.9.5 1.8.8 2.7.2.9.5 1.9.8 2.8s.5 1.8.8 2.7c.3 1 .6 1.9.9 2.8.6 1.6 1.1 3.3 1.7 4.9.4 1 .7 1.9 1 2.8.3 1 .7 2 1.1 3 .3.8.6 1.5.9 2.3l1.2 3c.3.7.6 1.5.9 2.2.4 1 .9 2 1.3 3l.9 2.1c.5 1 .9 2 1.4 3 .3.7.6 1.3.9 2 .5 1 1 2.1 1.5 3.1.2.6.5 1.1.8 1.7.6 1.1 1.1 2.2 1.7 3.3.1.2.2.3.3.5 2.2 4.1 4.4 8.2 6.8 12.2.2.4.5.8.7 1.2.7 1.1 1.3 2.2 2 3.3.3.5.6.9.9 1.4.6 1.1 1.3 2.1 2 3.2.3.5.6.9.9 1.4.7 1.1 1.4 2.1 2.1 3.2.2.4.5.8.8 1.2.7 1.1 1.5 2.2 2.3 3.3.2.2.3.5.5.7 37.5 51.7 94.4 88.5 160 99.4.9.1 1.7.3 2.6.4 1 .2 2.1.4 3.1.5s1.9.3 2.8.4c1 .2 2 .3 3 .4.9.1 1.9.2 2.9.3s1.9.2 2.9.3 2.1.2 3.1.3c.9.1 1.8.1 2.7.2 1.1.1 2.3.1 3.4.2.8 0 1.7.1 2.5.1 1.3 0 2.6.1 3.9.1.7.1 1.4.1 2.1.1 2 .1 4 .1 6 .1s4-.1 6-.1c.7 0 1.4-.1 2.1-.1 1.3 0 2.6 0 3.9-.1.8 0 1.7-.1 2.5-.1 1.1-.1 2.3-.1 3.4-.2.9 0 1.8-.1 2.7-.2 1-.1 2.1-.2 3.1-.3s1.9-.2 2.9-.3c.9-.1 1.9-.2 2.9-.3s2-.3 3-.4 1.9-.3 2.8-.4c1-.2 2.1-.3 3.1-.5.9-.1 1.7-.3 2.6-.4 65.6-11 122.5-47.7 160.1-102.4.2-.2.3-.5.5-.7.8-1.1 1.5-2.2 2.3-3.3.2-.4.5-.8.8-1.2.7-1.1 1.4-2.1 2.1-3.2.3-.5.6-.9.9-1.4.6-1.1 1.3-2.1 2-3.2.3-.5.6-.9.9-1.4.7-1.1 1.3-2.2 2-3.3.2-.4.5-.8.7-1.2 2.4-4 4.6-8.1 6.8-12.2.1-.2.2-.3.3-.5.6-1.1 1.1-2.2 1.7-3.3.2-.6.5-1.1.8-1.7.5-1 1-2.1 1.5-3.1.3-.7.6-1.3.9-2 .5-1 1-2 1.4-3l.9-2.1c.5-1 .9-2 1.3-3 .3-.7.6-1.5.9-2.2l1.2-3c.3-.8.6-1.5.9-2.3.4-1 .7-2 1.1-3s.7-1.9 1-2.8c.6-1.6 1.2-3.3 1.7-4.9.3-1 .6-1.9.9-2.8s.5-1.8.8-2.7c.2-.9.5-1.9.8-2.8s.6-1.8.8-2.7c.3-1 .5-1.9.8-2.9.2-.9.5-1.8.7-2.7.2-1 .5-2 .7-3 .2-.9.4-1.7.6-2.6.2-1 .5-2.1.7-3.2.2-.8.3-1.6.5-2.4.3-1.3.6-2.7.8-4 .1-.6.2-1.1.3-1.7l.9-5.7c.1-.6.2-1.3.3-1.9.1-1.3.3-2.6.5-3.9.1-.8.2-1.5.3-2.3.1-1.2.3-2.4.4-3.6 0-.8.1-1.6.2-2.4.1-1.1.2-2.3.3-3.5.1-.8.1-1.6.2-2.4.1 1.7.1.5.2-.7 0-.8.1-1.5.1-2.3.1-1.3.2-2.7.2-4 .1-.7.1-1.3.1-2 .1-2 .1-4 .1-6 0-53.5-16.9-103-45.8-143.7zM448 371.5c-9.4 15.5-20.6 29.9-33.6 42.9-20.6 20.6-44.5 36.7-71.2 48-13.9 5.8-28.2 10.3-42.9 13.2v-75.8c0-58.6-88.6-58.6-88.6 0v75.8c-14.7-2.9-29-7.3-42.9-13.2-26.7-11.3-50.6-27.4-71.2-48-13-13-24.2-27.4-33.6-42.9v-71.3c0-2.1 1.6-3.7 3.7-3.7h22.1c2.1 0 3.7 1.6 3.7 3.7V326h29.6V182c0-2.1 1.6-3.7 3.7-3.7h22.1c2.1 0 3.7 1.6 3.7 3.7v25.9h29.5V182c0-2.1 1.6-3.7 3.7-3.7H208c2.1 0 3.7 1.6 3.7 3.7v25.9h29.5V182c0-4.8 6.5-3.7 9.5-3.7V88.1c-4.4-2-7.4-6.7-7.4-11.5 0-16.8 25.4-16.8 25.4 0 0 4.8-3 9.4-7.4 11.5V92c6.3-1.4 12.7-2.3 19.2-2.3 9.4 0 18.4 3.5 26.3 3.5 7.2 0 15.2-3.5 19.4-3.5 2.1 0 3.7 1.6 3.7 3.7v48.4c0 5.6-18.7 6.5-22.4 6.5-8.6 0-16.6-3.5-25.4-3.5-7 0-14.1 1.2-20.8 2.8v30.7c3 0 9.5-1.1 9.5 3.7v25.9h29.5V182c0-2.1 1.6-3.7 3.7-3.7h22.2c2.1 0 3.7 1.6 3.7 3.7v25.9h29.5V182c0-2.1 1.6-3.7 3.7-3.7h22.1c2.1 0 3.7 1.6 3.7 3.7v144h29.5v-25.8c0-2.1 1.6-3.7 3.7-3.7h22.2c2.1 0 3.7 1.6 3.7 3.7z"
                }
            }
        ]
    })(props);
}
function FaFortAwesome(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M489.2 287.9h-27.4c-2.6 0-4.6 2-4.6 4.6v32h-36.6V146.2c0-2.6-2-4.6-4.6-4.6h-27.4c-2.6 0-4.6 2-4.6 4.6v32h-36.6v-32c0-2.6-2-4.6-4.6-4.6h-27.4c-2.6 0-4.6 2-4.6 4.6v32h-36.6v-32c0-6-8-4.6-11.7-4.6v-38c8.3-2 17.1-3.4 25.7-3.4 10.9 0 20.9 4.3 31.4 4.3 4.6 0 27.7-1.1 27.7-8v-60c0-2.6-2-4.6-4.6-4.6-5.1 0-15.1 4.3-24 4.3-9.7 0-20.9-4.3-32.6-4.3-8 0-16 1.1-23.7 2.9v-4.9c5.4-2.6 9.1-8.3 9.1-14.3 0-20.7-31.4-20.8-31.4 0 0 6 3.7 11.7 9.1 14.3v111.7c-3.7 0-11.7-1.4-11.7 4.6v32h-36.6v-32c0-2.6-2-4.6-4.6-4.6h-27.4c-2.6 0-4.6 2-4.6 4.6v32H128v-32c0-2.6-2-4.6-4.6-4.6H96c-2.6 0-4.6 2-4.6 4.6v178.3H54.8v-32c0-2.6-2-4.6-4.6-4.6H22.8c-2.6 0-4.6 2-4.6 4.6V512h182.9v-96c0-72.6 109.7-72.6 109.7 0v96h182.9V292.5c.1-2.6-1.9-4.6-4.5-4.6zm-288.1-4.5c0 2.6-2 4.6-4.6 4.6h-27.4c-2.6 0-4.6-2-4.6-4.6v-64c0-2.6 2-4.6 4.6-4.6h27.4c2.6 0 4.6 2 4.6 4.6v64zm146.4 0c0 2.6-2 4.6-4.6 4.6h-27.4c-2.6 0-4.6-2-4.6-4.6v-64c0-2.6 2-4.6 4.6-4.6h27.4c2.6 0 4.6 2 4.6 4.6v64z"
                }
            }
        ]
    })(props);
}
function FaForumbee(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5.8 309.7C2 292.7 0 275.5 0 258.3 0 135 99.8 35 223.1 35c16.6 0 33.3 2 49.3 5.5C149 87.5 51.9 186 5.8 309.7zm392.9-189.2C385 103 369 87.8 350.9 75.2c-149.6 44.3-266.3 162.1-309.7 312 12.5 18.1 28 35.6 45.2 49 43.1-151.3 161.2-271.7 312.3-315.7zm15.8 252.7c15.2-25.1 25.4-53.7 29.5-82.8-79.4 42.9-145 110.6-187.6 190.3 30-4.4 58.9-15.3 84.6-31.3 35 13.1 70.9 24.3 107 33.6-9.3-36.5-20.4-74.5-33.5-109.8zm29.7-145.5c-2.6-19.5-7.9-38.7-15.8-56.8C290.5 216.7 182 327.5 137.1 466c18.1 7.6 37 12.5 56.6 15.2C240 367.1 330.5 274.4 444.2 227.7z"
                }
            }
        ]
    })(props);
}
function FaFoursquare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 368 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M323.1 3H49.9C12.4 3 0 31.3 0 49.1v433.8c0 20.3 12.1 27.7 18.2 30.1 6.2 2.5 22.8 4.6 32.9-7.1C180 356.5 182.2 354 182.2 354c3.1-3.4 3.4-3.1 6.8-3.1h83.4c35.1 0 40.6-25.2 44.3-39.7l48.6-243C373.8 25.8 363.1 3 323.1 3zm-16.3 73.8l-11.4 59.7c-1.2 6.5-9.5 13.2-16.9 13.2H172.1c-12 0-20.6 8.3-20.6 20.3v13c0 12 8.6 20.6 20.6 20.6h90.4c8.3 0 16.6 9.2 14.8 18.2-1.8 8.9-10.5 53.8-11.4 58.8-.9 4.9-6.8 13.5-16.9 13.5h-73.5c-13.5 0-17.2 1.8-26.5 12.6 0 0-8.9 11.4-89.5 108.3-.9.9-1.8.6-1.8-.3V75.9c0-7.7 6.8-16.6 16.6-16.6h219c8.2 0 15.6 7.7 13.5 17.5z"
                }
            }
        ]
    })(props);
}
function FaFreeCodeCamp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M97.22,96.21c10.36-10.65,16-17.12,16-21.9,0-2.76-1.92-5.51-3.83-7.42A14.81,14.81,0,0,0,101,64.05c-8.48,0-20.92,8.79-35.84,25.69C23.68,137,2.51,182.81,3.37,250.34s17.47,117,54.06,161.87C76.22,435.86,90.62,448,100.9,448a13.55,13.55,0,0,0,8.37-3.84c1.91-2.76,3.81-5.63,3.81-8.38,0-5.63-3.86-12.2-13.2-20.55-44.45-42.33-67.32-97-67.48-165C32.25,188.8,54,137.83,97.22,96.21ZM239.47,420.07c.58.37.91.55.91.55Zm93.79.55.17-.13C333.24,420.62,333.17,420.67,333.26,420.62Zm3.13-158.18c-16.24-4.15,50.41-82.89-68.05-177.17,0,0,15.54,49.38-62.83,159.57-74.27,104.35,23.46,168.73,34,175.23-6.73-4.35-47.4-35.7,9.55-128.64,11-18.3,25.53-34.87,43.5-72.16,0,0,15.91,22.45,7.6,71.13C287.7,364,354,342.91,355,343.94c22.75,26.78-17.72,73.51-21.58,76.55,5.49-3.65,117.71-78,33-188.1C360.43,238.4,352.62,266.59,336.39,262.44ZM510.88,89.69C496,72.79,483.52,64,475,64a14.81,14.81,0,0,0-8.39,2.84c-1.91,1.91-3.83,4.66-3.83,7.42,0,4.78,5.6,11.26,16,21.9,43.23,41.61,65,92.59,64.82,154.06-.16,68-23,122.63-67.48,165-9.34,8.35-13.18,14.92-13.2,20.55,0,2.75,1.9,5.62,3.81,8.38A13.61,13.61,0,0,0,475.1,448c10.28,0,24.68-12.13,43.47-35.79,36.59-44.85,53.14-94.38,54.06-161.87S552.32,137,510.88,89.69Z"
                }
            }
        ]
    })(props);
}
function FaFreebsd(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M303.7 96.2c11.1-11.1 115.5-77 139.2-53.2 23.7 23.7-42.1 128.1-53.2 139.2-11.1 11.1-39.4.9-63.1-22.9-23.8-23.7-34.1-52-22.9-63.1zM109.9 68.1C73.6 47.5 22 24.6 5.6 41.1c-16.6 16.6 7.1 69.4 27.9 105.7 18.5-32.2 44.8-59.3 76.4-78.7zM406.7 174c3.3 11.3 2.7 20.7-2.7 26.1-20.3 20.3-87.5-27-109.3-70.1-18-32.3-11.1-53.4 14.9-48.7 5.7-3.6 12.3-7.6 19.6-11.6-29.8-15.5-63.6-24.3-99.5-24.3-119.1 0-215.6 96.5-215.6 215.6 0 119 96.5 215.6 215.6 215.6S445.3 380.1 445.3 261c0-38.4-10.1-74.5-27.7-105.8-3.9 7-7.6 13.3-10.9 18.8z"
                }
            }
        ]
    })(props);
}
function FaFulcrum(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 320 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M95.75 164.14l-35.38 43.55L25 164.14l35.38-43.55zM144.23 0l-20.54 198.18L72.72 256l51 57.82L144.23 512V300.89L103.15 256l41.08-44.89zm79.67 164.14l35.38 43.55 35.38-43.55-35.38-43.55zm-48.48 47L216.5 256l-41.08 44.89V512L196 313.82 247 256l-51-57.82L175.42 0z"
                }
            }
        ]
    })(props);
}
function FaGalacticRepublic(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 504C111.25 504 0 392.75 0 256S111.25 8 248 8s248 111.25 248 248-111.25 248-248 248zm0-479.47C120.37 24.53 16.53 128.37 16.53 256S120.37 487.47 248 487.47 479.47 383.63 479.47 256 375.63 24.53 248 24.53zm27.62 21.81v24.62a185.933 185.933 0 0 1 83.57 34.54l17.39-17.36c-28.75-22.06-63.3-36.89-100.96-41.8zm-55.37.07c-37.64 4.94-72.16 19.8-100.88 41.85l17.28 17.36h.08c24.07-17.84 52.55-30.06 83.52-34.67V46.41zm12.25 50.17v82.87c-10.04 2.03-19.42 5.94-27.67 11.42l-58.62-58.59-21.93 21.93 58.67 58.67c-5.47 8.23-9.45 17.59-11.47 27.62h-82.9v31h82.9c2.02 10.02 6.01 19.31 11.47 27.54l-58.67 58.69 21.93 21.93 58.62-58.62a77.873 77.873 0 0 0 27.67 11.47v82.9h31v-82.9c10.05-2.03 19.37-6.06 27.62-11.55l58.67 58.69 21.93-21.93-58.67-58.69c5.46-8.23 9.47-17.52 11.5-27.54h82.87v-31h-82.87c-2.02-10.02-6.03-19.38-11.5-27.62l58.67-58.67-21.93-21.93-58.67 58.67c-8.25-5.49-17.57-9.47-27.62-11.5V96.58h-31zm183.24 30.72l-17.36 17.36a186.337 186.337 0 0 1 34.67 83.67h24.62c-4.95-37.69-19.83-72.29-41.93-101.03zm-335.55.13c-22.06 28.72-36.91 63.26-41.85 100.91h24.65c4.6-30.96 16.76-59.45 34.59-83.52l-17.39-17.39zM38.34 283.67c4.92 37.64 19.75 72.18 41.8 100.9l17.36-17.39c-17.81-24.07-29.92-52.57-34.51-83.52H38.34zm394.7 0c-4.61 30.99-16.8 59.5-34.67 83.6l17.36 17.36c22.08-28.74 36.98-63.29 41.93-100.96h-24.62zM136.66 406.38l-17.36 17.36c28.73 22.09 63.3 36.98 100.96 41.93v-24.64c-30.99-4.63-59.53-16.79-83.6-34.65zm222.53.05c-24.09 17.84-52.58 30.08-83.57 34.67v24.57c37.67-4.92 72.21-19.79 100.96-41.85l-17.31-17.39h-.08z"
                }
            }
        ]
    })(props);
}
function FaGalacticSenate(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M249.86 33.48v26.07C236.28 80.17 226 168.14 225.39 274.9c11.74-15.62 19.13-33.33 19.13-48.24v-16.88c-.03-5.32.75-10.53 2.19-15.65.65-2.14 1.39-4.08 2.62-5.82 1.23-1.75 3.43-3.79 6.68-3.79 3.24 0 5.45 2.05 6.68 3.79 1.23 1.75 1.97 3.68 2.62 5.82 1.44 5.12 2.22 10.33 2.19 15.65v16.88c0 14.91 7.39 32.62 19.13 48.24-.63-106.76-10.91-194.73-24.49-215.35V33.48h-12.28zm-26.34 147.77c-9.52 2.15-18.7 5.19-27.46 9.08 8.9 16.12 9.76 32.64 1.71 37.29-8 4.62-21.85-4.23-31.36-19.82-11.58 8.79-21.88 19.32-30.56 31.09 14.73 9.62 22.89 22.92 18.32 30.66-4.54 7.7-20.03 7.14-35.47-.96-5.78 13.25-9.75 27.51-11.65 42.42 9.68.18 18.67 2.38 26.18 6.04 17.78-.3 32.77-1.96 40.49-4.22 5.55-26.35 23.02-48.23 46.32-59.51.73-25.55 1.88-49.67 3.48-72.07zm64.96 0c1.59 22.4 2.75 46.52 3.47 72.07 23.29 11.28 40.77 33.16 46.32 59.51 7.72 2.26 22.71 3.92 40.49 4.22 7.51-3.66 16.5-5.85 26.18-6.04-1.9-14.91-5.86-29.17-11.65-42.42-15.44 8.1-30.93 8.66-35.47.96-4.57-7.74 3.6-21.05 18.32-30.66-8.68-11.77-18.98-22.3-30.56-31.09-9.51 15.59-23.36 24.44-31.36 19.82-8.05-4.65-7.19-21.16 1.71-37.29a147.49 147.49 0 0 0-27.45-9.08zm-32.48 8.6c-3.23 0-5.86 8.81-6.09 19.93h-.05v16.88c0 41.42-49.01 95.04-93.49 95.04-52 0-122.75-1.45-156.37 29.17v2.51c9.42 17.12 20.58 33.17 33.18 47.97C45.7 380.26 84.77 360.4 141.2 360c45.68 1.02 79.03 20.33 90.76 40.87.01.01-.01.04 0 .05 7.67 2.14 15.85 3.23 24.04 3.21 8.19.02 16.37-1.07 24.04-3.21.01-.01-.01-.04 0-.05 11.74-20.54 45.08-39.85 90.76-40.87 56.43.39 95.49 20.26 108.02 41.35 12.6-14.8 23.76-30.86 33.18-47.97v-2.51c-33.61-30.62-104.37-29.17-156.37-29.17-44.48 0-93.49-53.62-93.49-95.04v-16.88h-.05c-.23-11.12-2.86-19.93-6.09-19.93zm0 96.59c22.42 0 40.6 18.18 40.6 40.6s-18.18 40.65-40.6 40.65-40.6-18.23-40.6-40.65c0-22.42 18.18-40.6 40.6-40.6zm0 7.64c-18.19 0-32.96 14.77-32.96 32.96S237.81 360 256 360s32.96-14.77 32.96-32.96-14.77-32.96-32.96-32.96zm0 6.14c14.81 0 26.82 12.01 26.82 26.82s-12.01 26.82-26.82 26.82-26.82-12.01-26.82-26.82 12.01-26.82 26.82-26.82zm-114.8 66.67c-10.19.07-21.6.36-30.5 1.66.43 4.42 1.51 18.63 7.11 29.76 9.11-2.56 18.36-3.9 27.62-3.9 41.28.94 71.48 34.35 78.26 74.47l.11 4.7c10.4 1.91 21.19 2.94 32.21 2.94 11.03 0 21.81-1.02 32.21-2.94l.11-4.7c6.78-40.12 36.98-73.53 78.26-74.47 9.26 0 18.51 1.34 27.62 3.9 5.6-11.13 6.68-25.34 7.11-29.76-8.9-1.3-20.32-1.58-30.5-1.66-18.76.42-35.19 4.17-48.61 9.67-12.54 16.03-29.16 30.03-49.58 33.07-.09.02-.17.04-.27.05-.05.01-.11.04-.16.05-5.24 1.07-10.63 1.6-16.19 1.6-5.55 0-10.95-.53-16.19-1.6-.05-.01-.11-.04-.16-.05-.1-.02-.17-.04-.27-.05-20.42-3.03-37.03-17.04-49.58-33.07-13.42-5.49-29.86-9.25-48.61-9.67z"
                }
            }
        ]
    })(props);
}
function FaGetPocket(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M407.6 64h-367C18.5 64 0 82.5 0 104.6v135.2C0 364.5 99.7 464 224.2 464c124 0 223.8-99.5 223.8-224.2V104.6c0-22.4-17.7-40.6-40.4-40.6zm-162 268.5c-12.4 11.8-31.4 11.1-42.4 0C89.5 223.6 88.3 227.4 88.3 209.3c0-16.9 13.8-30.7 30.7-30.7 17 0 16.1 3.8 105.2 89.3 90.6-86.9 88.6-89.3 105.5-89.3 16.9 0 30.7 13.8 30.7 30.7 0 17.8-2.9 15.7-114.8 123.2z"
                }
            }
        ]
    })(props);
}
function FaGgCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M257 8C120 8 9 119 9 256s111 248 248 248 248-111 248-248S394 8 257 8zm-49.5 374.8L81.8 257.1l125.7-125.7 35.2 35.4-24.2 24.2-11.1-11.1-77.2 77.2 77.2 77.2 26.6-26.6-53.1-52.9 24.4-24.4 77.2 77.2-75 75.2zm99-2.2l-35.2-35.2 24.1-24.4 11.1 11.1 77.2-77.2-77.2-77.2-26.5 26.5 53.1 52.9-24.4 24.4-77.2-77.2 75-75L432.2 255 306.5 380.6z"
                }
            }
        ]
    })(props);
}
function FaGg(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M179.2 230.4l102.4 102.4-102.4 102.4L0 256 179.2 76.8l44.8 44.8-25.6 25.6-19.2-19.2-128 128 128 128 51.5-51.5-77.1-76.5 25.6-25.6zM332.8 76.8L230.4 179.2l102.4 102.4 25.6-25.6-77.1-76.5 51.5-51.5 128 128-128 128-19.2-19.2-25.6 25.6 44.8 44.8L512 256 332.8 76.8z"
                }
            }
        ]
    })(props);
}
function FaGitAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M439.55 236.05L244 40.45a28.87 28.87 0 0 0-40.81 0l-40.66 40.63 51.52 51.52c27.06-9.14 52.68 16.77 43.39 43.68l49.66 49.66c34.23-11.8 61.18 31 35.47 56.69-26.49 26.49-70.21-2.87-56-37.34L240.22 199v121.85c25.3 12.54 22.26 41.85 9.08 55a34.34 34.34 0 0 1-48.55 0c-17.57-17.6-11.07-46.91 11.25-56v-123c-20.8-8.51-24.6-30.74-18.64-45L142.57 101 8.45 235.14a28.86 28.86 0 0 0 0 40.81l195.61 195.6a28.86 28.86 0 0 0 40.8 0l194.69-194.69a28.86 28.86 0 0 0 0-40.81z"
                }
            }
        ]
    })(props);
}
function FaGitSquare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M100.59 334.24c48.57 3.31 58.95 2.11 58.95 11.94 0 20-65.55 20.06-65.55 1.52.01-5.09 3.29-9.4 6.6-13.46zm27.95-116.64c-32.29 0-33.75 44.47-.75 44.47 32.51 0 31.71-44.47.75-44.47zM448 80v352a48 48 0 0 1-48 48H48a48 48 0 0 1-48-48V80a48 48 0 0 1 48-48h352a48 48 0 0 1 48 48zm-227 69.31c0 14.49 8.38 22.88 22.86 22.88 14.74 0 23.13-8.39 23.13-22.88S258.62 127 243.88 127c-14.48 0-22.88 7.84-22.88 22.31zM199.18 195h-49.55c-25-6.55-81.56-4.85-81.56 46.75 0 18.8 9.4 32 21.85 38.11C74.23 294.23 66.8 301 66.8 310.6c0 6.87 2.79 13.22 11.18 16.76-8.9 8.4-14 14.48-14 25.92C64 373.35 81.53 385 127.52 385c44.22 0 69.87-16.51 69.87-45.73 0-36.67-28.23-35.32-94.77-39.38l8.38-13.43c17 4.74 74.19 6.23 74.19-42.43 0-11.69-4.83-19.82-9.4-25.67l23.38-1.78zm84.34 109.84l-13-1.78c-3.82-.51-4.07-1-4.07-5.09V192.52h-52.6l-2.79 20.57c15.75 5.55 17 4.86 17 10.17V298c0 5.62-.31 4.58-17 6.87v20.06h72.42zM384 315l-6.87-22.37c-40.93 15.37-37.85-12.41-37.85-16.73v-60.72h37.85v-25.41h-35.82c-2.87 0-2 2.52-2-38.63h-24.18c-2.79 27.7-11.68 38.88-34 41.42v22.62c20.47 0 19.82-.85 19.82 2.54v66.57c0 28.72 11.43 40.91 41.67 40.91 14.45 0 30.45-4.83 41.38-10.2z"
                }
            }
        ]
    })(props);
}
function FaGit(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M216.29 158.39H137C97 147.9 6.51 150.63 6.51 233.18c0 30.09 15 51.23 35 61-25.1 23-37 33.85-37 49.21 0 11 4.47 21.14 17.89 26.81C8.13 383.61 0 393.35 0 411.65c0 32.11 28.05 50.82 101.63 50.82 70.75 0 111.79-26.42 111.79-73.18 0-58.66-45.16-56.5-151.63-63l13.43-21.55c27.27 7.58 118.7 10 118.7-67.89 0-18.7-7.73-31.71-15-41.07l37.41-2.84zm-63.42 241.9c0 32.06-104.89 32.1-104.89 2.43 0-8.14 5.27-15 10.57-21.54 77.71 5.3 94.32 3.37 94.32 19.11zm-50.81-134.58c-52.8 0-50.46-71.16 1.2-71.16 49.54 0 50.82 71.16-1.2 71.16zm133.3 100.51v-32.1c26.75-3.66 27.24-2 27.24-11V203.61c0-8.5-2.05-7.38-27.24-16.26l4.47-32.92H324v168.71c0 6.51.4 7.32 6.51 8.14l20.73 2.84v32.1zm52.45-244.31c-23.17 0-36.59-13.43-36.59-36.61s13.42-35.77 36.59-35.77c23.58 0 37 12.62 37 35.77s-13.42 36.61-37 36.61zM512 350.46c-17.49 8.53-43.1 16.26-66.28 16.26-48.38 0-66.67-19.5-66.67-65.46V194.75c0-5.42 1.05-4.06-31.71-4.06V154.5c35.78-4.07 50-22 54.47-66.27h38.63c0 65.83-1.34 61.81 3.26 61.81H501v40.65h-60.56v97.15c0 6.92-4.92 51.41 60.57 26.84z"
                }
            }
        ]
    })(props);
}
function FaGithubAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 480 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M186.1 328.7c0 20.9-10.9 55.1-36.7 55.1s-36.7-34.2-36.7-55.1 10.9-55.1 36.7-55.1 36.7 34.2 36.7 55.1zM480 278.2c0 31.9-3.2 65.7-17.5 95-37.9 76.6-142.1 74.8-216.7 74.8-75.8 0-186.2 2.7-225.6-74.8-14.6-29-20.2-63.1-20.2-95 0-41.9 13.9-81.5 41.5-113.6-5.2-15.8-7.7-32.4-7.7-48.8 0-21.5 4.9-32.3 14.6-51.8 45.3 0 74.3 9 108.8 36 29-6.9 58.8-10 88.7-10 27 0 54.2 2.9 80.4 9.2 34-26.7 63-35.2 107.8-35.2 9.8 19.5 14.6 30.3 14.6 51.8 0 16.4-2.6 32.7-7.7 48.2 27.5 32.4 39 72.3 39 114.2zm-64.3 50.5c0-43.9-26.7-82.6-73.5-82.6-18.9 0-37 3.4-56 6-14.9 2.3-29.8 3.2-45.1 3.2-15.2 0-30.1-.9-45.1-3.2-18.7-2.6-37-6-56-6-46.8 0-73.5 38.7-73.5 82.6 0 87.8 80.4 101.3 150.4 101.3h48.2c70.3 0 150.6-13.4 150.6-101.3zm-82.6-55.1c-25.8 0-36.7 34.2-36.7 55.1s10.9 55.1 36.7 55.1 36.7-34.2 36.7-55.1-10.9-55.1-36.7-55.1z"
                }
            }
        ]
    })(props);
}
function FaGithubSquare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zM277.3 415.7c-8.4 1.5-11.5-3.7-11.5-8 0-5.4.2-33 .2-55.3 0-15.6-5.2-25.5-11.3-30.7 37-4.1 76-9.2 76-73.1 0-18.2-6.5-27.3-17.1-39 1.7-4.3 7.4-22-1.7-45-13.9-4.3-45.7 17.9-45.7 17.9-13.2-3.7-27.5-5.6-41.6-5.6-14.1 0-28.4 1.9-41.6 5.6 0 0-31.8-22.2-45.7-17.9-9.1 22.9-3.5 40.6-1.7 45-10.6 11.7-15.6 20.8-15.6 39 0 63.6 37.3 69 74.3 73.1-4.8 4.3-9.1 11.7-10.6 22.3-9.5 4.3-33.8 11.7-48.3-13.9-9.1-15.8-25.5-17.1-25.5-17.1-16.2-.2-1.1 10.2-1.1 10.2 10.8 5 18.4 24.2 18.4 24.2 9.7 29.7 56.1 19.7 56.1 19.7 0 13.9.2 36.5.2 40.6 0 4.3-3 9.5-11.5 8-66-22.1-112.2-84.9-112.2-158.3 0-91.8 70.2-161.5 162-161.5S388 165.6 388 257.4c.1 73.4-44.7 136.3-110.7 158.3zm-98.1-61.1c-1.9.4-3.7-.4-3.9-1.7-.2-1.5 1.1-2.8 3-3.2 1.9-.2 3.7.6 3.9 1.9.3 1.3-1 2.6-3 3zm-9.5-.9c0 1.3-1.5 2.4-3.5 2.4-2.2.2-3.7-.9-3.7-2.4 0-1.3 1.5-2.4 3.5-2.4 1.9-.2 3.7.9 3.7 2.4zm-13.7-1.1c-.4 1.3-2.4 1.9-4.1 1.3-1.9-.4-3.2-1.9-2.8-3.2.4-1.3 2.4-1.9 4.1-1.5 2 .6 3.3 2.1 2.8 3.4zm-12.3-5.4c-.9 1.1-2.8.9-4.3-.6-1.5-1.3-1.9-3.2-.9-4.1.9-1.1 2.8-.9 4.3.6 1.3 1.3 1.8 3.3.9 4.1zm-9.1-9.1c-.9.6-2.6 0-3.7-1.5s-1.1-3.2 0-3.9c1.1-.9 2.8-.2 3.7 1.3 1.1 1.5 1.1 3.3 0 4.1zm-6.5-9.7c-.9.9-2.4.4-3.5-.6-1.1-1.3-1.3-2.8-.4-3.5.9-.9 2.4-.4 3.5.6 1.1 1.3 1.3 2.8.4 3.5zm-6.7-7.4c-.4.9-1.7 1.1-2.8.4-1.3-.6-1.9-1.7-1.5-2.6.4-.6 1.5-.9 2.8-.4 1.3.7 1.9 1.8 1.5 2.6z"
                }
            }
        ]
    })(props);
}
function FaGithub(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M165.9 397.4c0 2-2.3 3.6-5.2 3.6-3.3.3-5.6-1.3-5.6-3.6 0-2 2.3-3.6 5.2-3.6 3-.3 5.6 1.3 5.6 3.6zm-31.1-4.5c-.7 2 1.3 4.3 4.3 4.9 2.6 1 5.6 0 6.2-2s-1.3-4.3-4.3-5.2c-2.6-.7-5.5.3-6.2 2.3zm44.2-1.7c-2.9.7-4.9 2.6-4.6 4.9.3 2 2.9 3.3 5.9 2.6 2.9-.7 4.9-2.6 4.6-4.6-.3-1.9-3-3.2-5.9-2.9zM244.8 8C106.1 8 0 113.3 0 252c0 110.9 69.8 205.8 169.5 239.2 12.8 2.3 17.3-5.6 17.3-12.1 0-6.2-.3-40.4-.3-61.4 0 0-70 15-84.7-29.8 0 0-11.4-29.1-27.8-36.6 0 0-22.9-15.7 1.6-15.4 0 0 24.9 2 38.6 25.8 21.9 38.6 58.6 27.5 72.9 20.9 2.3-16 8.8-27.1 16-33.7-55.9-6.2-112.3-14.3-112.3-110.5 0-27.5 7.6-41.3 23.6-58.9-2.6-6.5-11.1-33.3 2.6-67.9 20.9-6.5 69 27 69 27 20-5.6 41.5-8.5 62.8-8.5s42.8 2.9 62.8 8.5c0 0 48.1-33.6 69-27 13.7 34.7 5.2 61.4 2.6 67.9 16 17.7 25.8 31.5 25.8 58.9 0 96.5-58.9 104.2-114.8 110.5 9.2 7.9 17 22.9 17 46.4 0 33.7-.3 75.4-.3 83.6 0 6.5 4.6 14.4 17.3 12.1C428.2 457.8 496 362.9 496 252 496 113.3 383.5 8 244.8 8zM97.2 352.9c-1.3 1-1 3.3.7 5.2 1.6 1.6 3.9 2.3 5.2 1 1.3-1 1-3.3-.7-5.2-1.6-1.6-3.9-2.3-5.2-1zm-10.8-8.1c-.7 1.3.3 2.9 2.3 3.9 1.6 1 3.6.7 4.3-.7.7-1.3-.3-2.9-2.3-3.9-2-.6-3.6-.3-4.3.7zm32.4 35.6c-1.6 1.3-1 4.3 1.3 6.2 2.3 2.3 5.2 2.6 6.5 1 1.3-1.3.7-4.3-1.3-6.2-2.2-2.3-5.2-2.6-6.5-1zm-11.4-14.7c-1.6 1-1.6 3.6 0 5.9 1.6 2.3 4.3 3.3 5.6 2.3 1.6-1.3 1.6-3.9 0-6.2-1.4-2.3-4-3.3-5.6-2z"
                }
            }
        ]
    })(props);
}
function FaGitkraken(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 592 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M565.7 118.1c-2.3-6.1-9.3-9.2-15.3-6.6-5.7 2.4-8.5 8.9-6.3 14.6 10.9 29 16.9 60.5 16.9 93.3 0 134.6-100.3 245.7-230.2 262.7V358.4c7.9-1.5 15.5-3.6 23-6.2v104c106.7-25.9 185.9-122.1 185.9-236.8 0-91.8-50.8-171.8-125.8-213.3-5.7-3.2-13-.9-15.9 5-2.7 5.5-.6 12.2 4.7 15.1 67.9 37.6 113.9 110 113.9 193.2 0 93.3-57.9 173.1-139.8 205.4v-92.2c14.2-4.5 24.9-17.7 24.9-33.5 0-13.1-6.8-24.4-17.3-30.5 8.3-79.5 44.5-58.6 44.5-83.9V170c0-38-87.9-161.8-129-164.7-2.5-.2-5-.2-7.6 0C251.1 8.3 163.2 132 163.2 170v14.8c0 25.3 36.3 4.3 44.5 83.9-10.6 6.1-17.3 17.4-17.3 30.5 0 15.8 10.6 29 24.8 33.5v92.2c-81.9-32.2-139.8-112-139.8-205.4 0-83.1 46-155.5 113.9-193.2 5.4-3 7.4-9.6 4.7-15.1-2.9-5.9-10.1-8.2-15.9-5-75 41.5-125.8 121.5-125.8 213.3 0 114.7 79.2 210.8 185.9 236.8v-104c7.6 2.5 15.1 4.6 23 6.2v123.7C131.4 465.2 31 354.1 31 219.5c0-32.8 6-64.3 16.9-93.3 2.2-5.8-.6-12.2-6.3-14.6-6-2.6-13 .4-15.3 6.6C14.5 149.7 8 183.8 8 219.5c0 155.1 122.6 281.6 276.3 287.8V361.4c6.8.4 15 .5 23.4 0v145.8C461.4 501.1 584 374.6 584 219.5c0-35.7-6.5-69.8-18.3-101.4zM365.9 275.5c13 0 23.7 10.5 23.7 23.7 0 13.1-10.6 23.7-23.7 23.7-13 0-23.7-10.5-23.7-23.7 0-13.1 10.6-23.7 23.7-23.7zm-139.8 47.3c-13.2 0-23.7-10.7-23.7-23.7s10.5-23.7 23.7-23.7c13.1 0 23.7 10.6 23.7 23.7 0 13-10.5 23.7-23.7 23.7z"
                }
            }
        ]
    })(props);
}
function FaGitlab(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M105.2 24.9c-3.1-8.9-15.7-8.9-18.9 0L29.8 199.7h132c-.1 0-56.6-174.8-56.6-174.8zM.9 287.7c-2.6 8 .3 16.9 7.1 22l247.9 184-226.2-294zm160.8-88l94.3 294 94.3-294zm349.4 88l-28.8-88-226.3 294 247.9-184c6.9-5.1 9.7-14 7.2-22zM425.7 24.9c-3.1-8.9-15.7-8.9-18.9 0l-56.6 174.8h132z"
                }
            }
        ]
    })(props);
}
function FaGitter(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M66.4 322.5H16V0h50.4v322.5zM166.9 76.1h-50.4V512h50.4V76.1zm100.6 0h-50.4V512h50.4V76.1zM368 76h-50.4v247H368V76z"
                }
            }
        ]
    })(props);
}
function FaGlideG(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M407.1 211.2c-3.5-1.4-11.6-3.8-15.4-3.8-37.1 0-62.2 16.8-93.5 34.5l-.9-.9c7-47.3 23.5-91.9 23.5-140.4C320.8 29.1 282.6 0 212.4 0 97.3 0 39 113.7 39 198.4 39 286.3 90.3 335 177.6 335c12 0 11-1 11 3.8-16.9 128.9-90.8 133.1-90.8 94.6 0-39.2 45-58.6 45.5-61-.3-12.2-47-27.6-58.9-27.6-33.9.1-52.4 51.2-52.4 79.3C32 476 64.8 512 117.5 512c77.4 0 134-77.8 151.4-145.4 15.1-60.5 11.2-63.3 19.7-67.6 32.2-16.2 57.5-27 93.8-27 17.8 0 30.5 3.7 58.9 8.4 2.9 0 6.7-2.9 6.7-5.8 0-8-33.4-60.5-40.9-63.4zm-175.3-84.4c-9.3 44.7-18.6 89.6-27.8 134.3-2.3 10.2-13.3 7.8-22 7.8-38.3 0-49-41.8-49-73.1 0-47 18-109.3 61.8-133.4 7-4.1 14.8-6.7 22.6-6.7 18.6 0 20 13.3 20 28.7-.1 14.3-2.7 28.5-5.6 42.4z"
                }
            }
        ]
    })(props);
}
function FaGlide(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M252.8 148.6c0 8.8-1.6 17.7-3.4 26.4-5.8 27.8-11.6 55.8-17.3 83.6-1.4 6.3-8.3 4.9-13.7 4.9-23.8 0-30.5-26-30.5-45.5 0-29.3 11.2-68.1 38.5-83.1 4.3-2.5 9.2-4.2 14.1-4.2 11.4 0 12.3 8.3 12.3 17.9zM448 80v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h352c26.5 0 48 21.5 48 48zm-64 187c0-5.1-20.8-37.7-25.5-39.5-2.2-.9-7.2-2.3-9.6-2.3-23.1 0-38.7 10.5-58.2 21.5l-.5-.5c4.3-29.4 14.6-57.2 14.6-87.4 0-44.6-23.8-62.7-67.5-62.7-71.7 0-108 70.8-108 123.5 0 54.7 32 85 86.3 85 7.5 0 6.9-.6 6.9 2.3-10.5 80.3-56.5 82.9-56.5 58.9 0-24.4 28-36.5 28.3-38-.2-7.6-29.3-17.2-36.7-17.2-21.1 0-32.7 33-32.7 50.6 0 32.3 20.4 54.7 53.3 54.7 48.2 0 83.4-49.7 94.3-91.7 9.4-37.7 7-39.4 12.3-42.1 20-10.1 35.8-16.8 58.4-16.8 11.1 0 19 2.3 36.7 5.2 1.8.1 4.1-1.7 4.1-3.5z"
                }
            }
        ]
    })(props);
}
function FaGofore(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 400 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M324 319.8h-13.2v34.7c-24.5 23.1-56.3 35.8-89.9 35.8-73.2 0-132.4-60.2-132.4-134.4 0-74.1 59.2-134.4 132.4-134.4 35.3 0 68.6 14 93.6 39.4l62.3-63.3C335 55.3 279.7 32 220.7 32 98 32 0 132.6 0 256c0 122.5 97 224 220.7 224 63.2 0 124.5-26.2 171-82.5-2-27.6-13.4-77.7-67.7-77.7zm-12.1-112.5H205.6v89H324c33.5 0 60.5 15.1 76 41.8v-30.6c0-65.2-40.4-100.2-88.1-100.2z"
                }
            }
        ]
    })(props);
}
function FaGoodreadsG(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M42.6 403.3h2.8c12.7 0 25.5 0 38.2.1 1.6 0 3.1-.4 3.6 2.1 7.1 34.9 30 54.6 62.9 63.9 26.9 7.6 54.1 7.8 81.3 1.8 33.8-7.4 56-28.3 68-60.4 8-21.5 10.7-43.8 11-66.5.1-5.8.3-47-.2-52.8l-.9-.3c-.8 1.5-1.7 2.9-2.5 4.4-22.1 43.1-61.3 67.4-105.4 69.1-103 4-169.4-57-172-176.2-.5-23.7 1.8-46.9 8.3-69.7C58.3 47.7 112.3.6 191.6 0c61.3-.4 101.5 38.7 116.2 70.3.5 1.1 1.3 2.3 2.4 1.9V10.6h44.3c0 280.3.1 332.2.1 332.2-.1 78.5-26.7 143.7-103 162.2-69.5 16.9-159 4.8-196-57.2-8-13.5-11.8-28.3-13-44.5zM188.9 36.5c-52.5-.5-108.5 40.7-115 133.8-4.1 59 14.8 122.2 71.5 148.6 27.6 12.9 74.3 15 108.3-8.7 47.6-33.2 62.7-97 54.8-154-9.7-71.1-47.8-120-119.6-119.7z"
                }
            }
        ]
    })(props);
}
function FaGoodreads(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M299.9 191.2c5.1 37.3-4.7 79-35.9 100.7-22.3 15.5-52.8 14.1-70.8 5.7-37.1-17.3-49.5-58.6-46.8-97.2 4.3-60.9 40.9-87.9 75.3-87.5 46.9-.2 71.8 31.8 78.2 78.3zM448 88v336c0 30.9-25.1 56-56 56H56c-30.9 0-56-25.1-56-56V88c0-30.9 25.1-56 56-56h336c30.9 0 56 25.1 56 56zM330 313.2s-.1-34-.1-217.3h-29v40.3c-.8.3-1.2-.5-1.6-1.2-9.6-20.7-35.9-46.3-76-46-51.9.4-87.2 31.2-100.6 77.8-4.3 14.9-5.8 30.1-5.5 45.6 1.7 77.9 45.1 117.8 112.4 115.2 28.9-1.1 54.5-17 69-45.2.5-1 1.1-1.9 1.7-2.9.2.1.4.1.6.2.3 3.8.2 30.7.1 34.5-.2 14.8-2 29.5-7.2 43.5-7.8 21-22.3 34.7-44.5 39.5-17.8 3.9-35.6 3.8-53.2-1.2-21.5-6.1-36.5-19-41.1-41.8-.3-1.6-1.3-1.3-2.3-1.3h-26.8c.8 10.6 3.2 20.3 8.5 29.2 24.2 40.5 82.7 48.5 128.2 37.4 49.9-12.3 67.3-54.9 67.4-106.3z"
                }
            }
        ]
    })(props);
}
function FaGoogleDrive(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M339 314.9L175.4 32h161.2l163.6 282.9H339zm-137.5 23.6L120.9 480h310.5L512 338.5H201.5zM154.1 67.4L0 338.5 80.6 480 237 208.8 154.1 67.4z"
                }
            }
        ]
    })(props);
}
function FaGooglePay(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M105.72,215v41.25h57.1a49.66,49.66,0,0,1-21.14,32.6c-9.54,6.55-21.72,10.28-36,10.28-27.6,0-50.93-18.91-59.3-44.22a65.61,65.61,0,0,1,0-41l0,0c8.37-25.46,31.7-44.37,59.3-44.37a56.43,56.43,0,0,1,40.51,16.08L176.47,155a101.24,101.24,0,0,0-70.75-27.84,105.55,105.55,0,0,0-94.38,59.11,107.64,107.64,0,0,0,0,96.18v.15a105.41,105.41,0,0,0,94.38,59c28.47,0,52.55-9.53,70-25.91,20-18.61,31.41-46.15,31.41-78.91A133.76,133.76,0,0,0,205.38,215Zm389.41-4c-10.13-9.38-23.93-14.14-41.39-14.14-22.46,0-39.34,8.34-50.5,24.86l20.85,13.26q11.45-17,31.26-17a34.05,34.05,0,0,1,22.75,8.79A28.14,28.14,0,0,1,487.79,248v5.51c-9.1-5.07-20.55-7.75-34.64-7.75-16.44,0-29.65,3.88-39.49,11.77s-14.82,18.31-14.82,31.56a39.74,39.74,0,0,0,13.94,31.27c9.25,8.34,21,12.51,34.79,12.51,16.29,0,29.21-7.3,39-21.89h1v17.72h22.61V250C510.25,233.45,505.26,220.34,495.13,211ZM475.9,300.3a37.32,37.32,0,0,1-26.57,11.16A28.61,28.61,0,0,1,431,305.21a19.41,19.41,0,0,1-7.77-15.63c0-7,3.22-12.81,9.54-17.42s14.53-7,24.07-7C470,265,480.3,268,487.64,273.94,487.64,284.07,483.68,292.85,475.9,300.3Zm-93.65-142A55.71,55.71,0,0,0,341.74,142H279.07V328.74H302.7V253.1h39c16,0,29.5-5.36,40.51-15.93.88-.89,1.76-1.79,2.65-2.68A54.45,54.45,0,0,0,382.25,158.26Zm-16.58,62.23a30.65,30.65,0,0,1-23.34,9.68H302.7V165h39.63a32,32,0,0,1,22.6,9.23A33.18,33.18,0,0,1,365.67,220.49ZM614.31,201,577.77,292.7h-.45L539.9,201H514.21L566,320.55l-29.35,64.32H561L640,201Z"
                }
            }
        ]
    })(props);
}
function FaGooglePlay(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M325.3 234.3L104.6 13l280.8 161.2-60.1 60.1zM47 0C34 6.8 25.3 19.2 25.3 35.3v441.3c0 16.1 8.7 28.5 21.7 35.3l256.6-256L47 0zm425.2 225.6l-58.9-34.1-65.7 64.5 65.7 64.5 60.1-34.1c18-14.3 18-46.5-1.2-60.8zM104.6 499l280.8-161.2-60.1-60.1L104.6 499z"
                }
            }
        ]
    })(props);
}
function FaGooglePlusG(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M386.061 228.496c1.834 9.692 3.143 19.384 3.143 31.956C389.204 370.205 315.599 448 204.8 448c-106.084 0-192-85.915-192-192s85.916-192 192-192c51.864 0 95.083 18.859 128.611 50.292l-52.126 50.03c-14.145-13.621-39.028-29.599-76.485-29.599-65.484 0-118.92 54.221-118.92 121.277 0 67.056 53.436 121.277 118.92 121.277 75.961 0 104.513-54.745 108.965-82.773H204.8v-66.009h181.261zm185.406 6.437V179.2h-56.001v55.733h-55.733v56.001h55.733v55.733h56.001v-55.733H627.2v-56.001h-55.733z"
                }
            }
        ]
    })(props);
}
function FaGooglePlusSquare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zM164 356c-55.3 0-100-44.7-100-100s44.7-100 100-100c27 0 49.5 9.8 67 26.2l-27.1 26.1c-7.4-7.1-20.3-15.4-39.8-15.4-34.1 0-61.9 28.2-61.9 63.2 0 34.9 27.8 63.2 61.9 63.2 39.6 0 54.4-28.5 56.8-43.1H164v-34.4h94.4c1 5 1.6 10.1 1.6 16.6 0 57.1-38.3 97.6-96 97.6zm220-81.8h-29v29h-29.2v-29h-29V245h29v-29H355v29h29v29.2z"
                }
            }
        ]
    })(props);
}
function FaGooglePlus(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256,8C119.1,8,8,119.1,8,256S119.1,504,256,504,504,392.9,504,256,392.9,8,256,8ZM185.3,380a124,124,0,0,1,0-248c31.3,0,60.1,11,83,32.3l-33.6,32.6c-13.2-12.9-31.3-19.1-49.4-19.1-42.9,0-77.2,35.5-77.2,78.1S142.3,334,185.3,334c32.6,0,64.9-19.1,70.1-53.3H185.3V238.1H302.2a109.2,109.2,0,0,1,1.9,20.7c0,70.8-47.5,121.2-118.8,121.2ZM415.5,273.8v35.5H380V273.8H344.5V238.3H380V202.8h35.5v35.5h35.2v35.5Z"
                }
            }
        ]
    })(props);
}
function FaGoogleWallet(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M156.8 126.8c37.6 60.6 64.2 113.1 84.3 162.5-8.3 33.8-18.8 66.5-31.3 98.3-13.2-52.3-26.5-101.3-56-148.5 6.5-36.4 2.3-73.6 3-112.3zM109.3 200H16.1c-6.5 0-10.5 7.5-6.5 12.7C51.8 267 81.3 330.5 101.3 400h103.5c-16.2-69.7-38.7-133.7-82.5-193.5-3-4-8-6.5-13-6.5zm47.8-88c68.5 108 130 234.5 138.2 368H409c-12-138-68.4-265-143.2-368H157.1zm251.8-68.5c-1.8-6.8-8.2-11.5-15.2-11.5h-88.3c-5.3 0-9 5-7.8 10.3 13.2 46.5 22.3 95.5 26.5 146 48.2 86.2 79.7 178.3 90.6 270.8 15.8-60.5 25.3-133.5 25.3-203 0-73.6-12.1-145.1-31.1-212.6z"
                }
            }
        ]
    })(props);
}
function FaGoogle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 488 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M488 261.8C488 403.3 391.1 504 248 504 110.8 504 0 393.2 0 256S110.8 8 248 8c66.8 0 123 24.5 166.3 64.9l-67.5 64.9C258.5 52.6 94.3 116.6 94.3 256c0 86.5 69.1 156.6 153.7 156.6 98.2 0 135-70.4 140.8-106.9H248v-85.3h236.1c2.3 12.7 3.9 24.9 3.9 41.4z"
                }
            }
        ]
    })(props);
}
function FaGratipay(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111.1 8 0 119.1 0 256s111.1 248 248 248 248-111.1 248-248S384.9 8 248 8zm114.6 226.4l-113 152.7-112.7-152.7c-8.7-11.9-19.1-50.4 13.6-72 28.1-18.1 54.6-4.2 68.5 11.9 15.9 17.9 46.6 16.9 61.7 0 13.9-16.1 40.4-30 68.1-11.9 32.9 21.6 22.6 60 13.8 72z"
                }
            }
        ]
    })(props);
}
function FaGrav(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M301.1 212c4.4 4.4 4.4 11.9 0 16.3l-9.7 9.7c-4.4 4.7-11.9 4.7-16.6 0l-10.5-10.5c-4.4-4.7-4.4-11.9 0-16.6l9.7-9.7c4.4-4.4 11.9-4.4 16.6 0l10.5 10.8zm-30.2-19.7c3-3 3-7.8 0-10.5-2.8-3-7.5-3-10.5 0-2.8 2.8-2.8 7.5 0 10.5 3.1 2.8 7.8 2.8 10.5 0zm-26 5.3c-3 2.8-3 7.5 0 10.2 2.8 3 7.5 3 10.5 0 2.8-2.8 2.8-7.5 0-10.2-3-3-7.7-3-10.5 0zm72.5-13.3c-19.9-14.4-33.8-43.2-11.9-68.1 21.6-24.9 40.7-17.2 59.8.8 11.9 11.3 29.3 24.9 17.2 48.2-12.5 23.5-45.1 33.2-65.1 19.1zm47.7-44.5c-8.9-10-23.3 6.9-15.5 16.1 7.4 9 32.1 2.4 15.5-16.1zM504 256c0 137-111 248-248 248S8 393 8 256 119 8 256 8s248 111 248 248zm-66.2 42.6c2.5-16.1-20.2-16.6-25.2-25.7-13.6-24.1-27.7-36.8-54.5-30.4 11.6-8 23.5-6.1 23.5-6.1.3-6.4 0-13-9.4-24.9 3.9-12.5.3-22.4.3-22.4 15.5-8.6 26.8-24.4 29.1-43.2 3.6-31-18.8-59.2-49.8-62.8-22.1-2.5-43.7 7.7-54.3 25.7-23.2 40.1 1.4 70.9 22.4 81.4-14.4-1.4-34.3-11.9-40.1-34.3-6.6-25.7 2.8-49.8 8.9-61.4 0 0-4.4-5.8-8-8.9 0 0-13.8 0-24.6 5.3 11.9-15.2 25.2-14.4 25.2-14.4 0-6.4-.6-14.9-3.6-21.6-5.4-11-23.8-12.9-31.7 2.8.1-.2.3-.4.4-.5-5 11.9-1.1 55.9 16.9 87.2-2.5 1.4-9.1 6.1-13 10-21.6 9.7-56.2 60.3-56.2 60.3-28.2 10.8-77.2 50.9-70.6 79.7.3 3 1.4 5.5 3 7.5-2.8 2.2-5.5 5-8.3 8.3-11.9 13.8-5.3 35.2 17.7 24.4 15.8-7.2 29.6-20.2 36.3-30.4 0 0-5.5-5-16.3-4.4 27.7-6.6 34.3-9.4 46.2-9.1 8 3.9 8-34.3 8-34.3 0-14.7-2.2-31-11.1-41.5 12.5 12.2 29.1 32.7 28 60.6-.8 18.3-15.2 23-15.2 23-9.1 16.6-43.2 65.9-30.4 106 0 0-9.7-14.9-10.2-22.1-17.4 19.4-46.5 52.3-24.6 64.5 26.6 14.7 108.8-88.6 126.2-142.3 34.6-20.8 55.4-47.3 63.9-65 22 43.5 95.3 94.5 101.1 59z"
                }
            }
        ]
    })(props);
}
function FaGripfire(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M112.5 301.4c0-73.8 105.1-122.5 105.1-203 0-47.1-34-88-39.1-90.4.4 3.3.6 6.7.6 10C179.1 110.1 32 171.9 32 286.6c0 49.8 32.2 79.2 66.5 108.3 65.1 46.7 78.1 71.4 78.1 86.6 0 10.1-4.8 17-4.8 22.3 13.1-16.7 17.4-31.9 17.5-46.4 0-29.6-21.7-56.3-44.2-86.5-16-22.3-32.6-42.6-32.6-69.5zm205.3-39c-12.1-66.8-78-124.4-94.7-130.9l4 7.2c2.4 5.1 3.4 10.9 3.4 17.1 0 44.7-54.2 111.2-56.6 116.7-2.2 5.1-3.2 10.5-3.2 15.8 0 20.1 15.2 42.1 17.9 42.1 2.4 0 56.6-55.4 58.1-87.7 6.4 11.7 9.1 22.6 9.1 33.4 0 41.2-41.8 96.9-41.8 96.9 0 11.6 31.9 53.2 35.5 53.2 1 0 2.2-1.4 3.2-2.4 37.9-39.3 67.3-85 67.3-136.8 0-8-.7-16.2-2.2-24.6z"
                }
            }
        ]
    })(props);
}
function FaGrunt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M61.3 189.3c-1.1 10 5.2 19.1 5.2 19.1.7-7.5 2.2-12.8 4-16.6.4 10.3 3.2 23.5 12.8 34.1 6.9 7.6 35.6 23.3 54.9 6.1 1 2.4 2.1 5.3 3 8.5 2.9 10.3-2.7 25.3-2.7 25.3s15.1-17.1 13.9-32.5c10.8-.5 21.4-8.4 21.1-19.5 0 0-18.9 10.4-35.5-8.8-9.7-11.2-40.9-42-83.1-31.8 4.3 1 8.9 2.4 13.5 4.1h-.1c-4.2 2-6.5 7.1-7 12zm28.3-1.8c19.5 11 37.4 25.7 44.9 37-5.7 3.3-21.7 10.4-38-1.7-10.3-7.6-9.8-26.2-6.9-35.3zm142.1 45.8c-1.2 15.5 13.9 32.5 13.9 32.5s-5.6-15-2.7-25.3c.9-3.2 2-6 3-8.5 19.3 17.3 48 1.5 54.8-6.1 9.6-10.6 12.3-23.8 12.8-34.1 1.8 3.8 3.4 9.1 4 16.6 0 0 6.4-9.1 5.2-19.1-.6-5-2.9-10-7-11.8h-.1c4.6-1.8 9.2-3.2 13.5-4.1-42.3-10.2-73.4 20.6-83.1 31.8-16.7 19.2-35.5 8.8-35.5 8.8-.2 10.9 10.4 18.9 21.2 19.3zm62.7-45.8c3 9.1 3.4 27.7-7 35.4-16.3 12.1-32.2 5-37.9 1.6 7.5-11.4 25.4-26 44.9-37zM160 418.5h-29.4c-5.5 0-8.2 1.6-9.5 2.9-1.9 2-2.2 4.7-.9 8.1 3.5 9.1 11.4 16.5 13.7 18.6 3.1 2.7 7.5 4.3 11.8 4.3 4.4 0 8.3-1.7 11-4.6 7.5-8.2 11.9-17.1 13-19.8.6-1.5 1.3-4.5-.9-6.8-1.8-1.8-4.7-2.7-8.8-2.7zm189.2-101.2c-2.4 17.9-13 33.8-24.6 43.7-3.1-22.7-3.7-55.5-3.7-62.4 0-14.7 9.5-24.5 12.2-26.1 2.5-1.5 5.4-3 8.3-4.6 18-9.6 40.4-21.6 40.4-43.7 0-16.2-9.3-23.2-15.4-27.8-.8-.6-1.5-1.1-2.2-1.7-2.1-1.7-3.7-3-4.3-4.4-4.4-9.8-3.6-34.2-1.7-37.6.6-.6 16.7-20.9 11.8-39.2-2-7.4-6.9-13.3-14.1-17-5.3-2.7-11.9-4.2-19.5-4.5-.1-2-.5-3.9-.9-5.9-.6-2.6-1.1-5.3-.9-8.1.4-4.7.8-9 2.2-11.3 8.4-13.3 28.8-17.6 29-17.6l12.3-2.4-8.1-9.5c-.1-.2-17.3-17.5-46.3-17.5-7.9 0-16 1.3-24.1 3.9-24.2 7.8-42.9 30.5-49.4 39.3-3.1-1-6.3-1.9-9.6-2.7-4.2-15.8 9-38.5 9-38.5s-13.6-3-33.7 15.2c-2.6-6.5-8.1-20.5-1.8-37.2C184.6 10.1 177.2 26 175 40.4c-7.6-5.4-6.7-23.1-7.2-27.6-7.5.9-29.2 21.9-28.2 48.3-2 .5-3.9 1.1-5.9 1.7-6.5-8.8-25.1-31.5-49.4-39.3-7.9-2.2-16-3.5-23.9-3.5-29 0-46.1 17.3-46.3 17.5L6 46.9l12.3 2.4c.2 0 20.6 4.3 29 17.6 1.4 2.2 1.8 6.6 2.2 11.3.2 2.8-.4 5.5-.9 8.1-.4 1.9-.8 3.9-.9 5.9-7.7.3-14.2 1.8-19.5 4.5-7.2 3.7-12.1 9.6-14.1 17-5 18.2 11.2 38.5 11.8 39.2 1.9 3.4 2.7 27.8-1.7 37.6-.6 1.4-2.2 2.7-4.3 4.4-.7.5-1.4 1.1-2.2 1.7-6.1 4.6-15.4 11.7-15.4 27.8 0 22.1 22.4 34.1 40.4 43.7 3 1.6 5.8 3.1 8.3 4.6 2.7 1.6 12.2 11.4 12.2 26.1 0 6.9-.6 39.7-3.7 62.4-11.6-9.9-22.2-25.9-24.6-43.8 0 0-29.2 22.6-20.6 70.8 5.2 29.5 23.2 46.1 47 54.7 8.8 19.1 29.4 45.7 67.3 49.6C143 504.3 163 512 192.2 512h.2c29.1 0 49.1-7.7 63.6-19.5 37.9-3.9 58.5-30.5 67.3-49.6 23.8-8.7 41.7-25.2 47-54.7 8.2-48.4-21.1-70.9-21.1-70.9zM305.7 37.7c5.6-1.8 11.6-2.7 17.7-2.7 11 0 19.9 3 24.7 5-3.1 1.4-6.4 3.2-9.7 5.3-2.4-.4-5.6-.8-9.2-.8-10.5 0-20.5 3.1-28.7 8.9-12.3 8.7-18 16.9-20.7 22.4-2.2-1.3-4.5-2.5-7.1-3.7-1.6-.8-3.1-1.5-4.7-2.2 6.1-9.1 19.9-26.5 37.7-32.2zm21 18.2c-.8 1-1.6 2.1-2.3 3.2-3.3 5.2-3.9 11.6-4.4 17.8-.5 6.4-1.1 12.5-4.4 17-4.2.8-8.1 1.7-11.5 2.7-2.3-3.1-5.6-7-10.5-11.2 1.4-4.8 5.5-16.1 13.5-22.5 5.6-4.3 12.2-6.7 19.6-7zM45.6 45.3c-3.3-2.2-6.6-4-9.7-5.3 4.8-2 13.7-5 24.7-5 6.1 0 12 .9 17.7 2.7 17.8 5.8 31.6 23.2 37.7 32.1-1.6.7-3.2 1.4-4.8 2.2-2.5 1.2-4.9 2.5-7.1 3.7-2.6-5.4-8.3-13.7-20.7-22.4-8.3-5.8-18.2-8.9-28.8-8.9-3.4.1-6.6.5-9 .9zm44.7 40.1c-4.9 4.2-8.3 8-10.5 11.2-3.4-.9-7.3-1.9-11.5-2.7C65 89.5 64.5 83.4 64 77c-.5-6.2-1.1-12.6-4.4-17.8-.7-1.1-1.5-2.2-2.3-3.2 7.4.3 14 2.6 19.5 7 8 6.3 12.1 17.6 13.5 22.4zM58.1 259.9c-2.7-1.6-5.6-3.1-8.4-4.6-14.9-8-30.2-16.3-30.2-30.5 0-11.1 4.3-14.6 8.9-18.2l.5-.4c.7-.6 1.4-1.2 2.2-1.8-.9 7.2-1.9 13.3-2.7 14.9 0 0 12.1-15 15.7-44.3 1.4-11.5-1.1-34.3-5.1-43 .2 4.9 0 9.8-.3 14.4-.4-.8-.8-1.6-1.3-2.2-3.2-4-11.8-17.5-9.4-26.6.9-3.5 3.1-6 6.7-7.8 3.8-1.9 8.8-2.9 15.1-2.9 12.3 0 25.9 3.7 32.9 6 25.1 8 55.4 30.9 64.1 37.7.2.2.4.3.4.3l5.6 3.9-3.5-5.8c-.2-.3-19.1-31.4-53.2-46.5 2-2.9 7.4-8.1 21.6-15.1 21.4-10.5 46.5-15.8 74.3-15.8 27.9 0 52.9 5.3 74.3 15.8 14.2 6.9 19.6 12.2 21.6 15.1-34 15.1-52.9 46.2-53.1 46.5l-3.5 5.8 5.6-3.9s.2-.1.4-.3c8.7-6.8 39-29.8 64.1-37.7 7-2.2 20.6-6 32.9-6 6.3 0 11.3 1 15.1 2.9 3.5 1.8 5.7 4.4 6.7 7.8 2.5 9.1-6.1 22.6-9.4 26.6-.5.6-.9 1.3-1.3 2.2-.3-4.6-.5-9.5-.3-14.4-4 8.8-6.5 31.5-5.1 43 3.6 29.3 15.7 44.3 15.7 44.3-.8-1.6-1.8-7.7-2.7-14.9.7.6 1.5 1.2 2.2 1.8l.5.4c4.6 3.7 8.9 7.1 8.9 18.2 0 14.2-15.4 22.5-30.2 30.5-2.9 1.5-5.7 3.1-8.4 4.6-8.7 5-18 16.7-19.1 34.2-.9 14.6.9 49.9 3.4 75.9-12.4 4.8-26.7 6.4-39.7 6.8-2-4.1-3.9-8.5-5.5-13.1-.7-2-19.6-51.1-26.4-62.2 5.5 39 17.5 73.7 23.5 89.6-3.5-.5-7.3-.7-11.7-.7h-117c-4.4 0-8.3.3-11.7.7 6-15.9 18.1-50.6 23.5-89.6-6.8 11.2-25.7 60.3-26.4 62.2-1.6 4.6-3.5 9-5.5 13.1-13-.4-27.2-2-39.7-6.8 2.5-26 4.3-61.2 3.4-75.9-.9-17.4-10.3-29.2-19-34.2zM34.8 404.6c-12.1-20-8.7-54.1-3.7-59.1 10.9 34.4 47.2 44.3 74.4 45.4-2.7 4.2-5.2 7.6-7 10l-1.4 1.4c-7.2 7.8-8.6 18.5-4.1 31.8-22.7-.1-46.3-9.8-58.2-29.5zm45.7 43.5c6 1.1 12.2 1.9 18.6 2.4 3.5 8 7.4 15.9 12.3 23.1-14.4-5.9-24.4-16-30.9-25.5zM192 498.2c-60.6-.1-78.3-45.8-84.9-64.7-3.7-10.5-3.4-18.2.9-23.1 2.9-3.3 9.5-7.2 24.6-7.2h118.8c15.1 0 21.8 3.9 24.6 7.2 4.2 4.8 4.5 12.6.9 23.1-6.6 18.8-24.3 64.6-84.9 64.7zm80.6-24.6c4.9-7.2 8.8-15.1 12.3-23.1 6.4-.5 12.6-1.3 18.6-2.4-6.5 9.5-16.5 19.6-30.9 25.5zm76.6-69c-12 19.7-35.6 29.3-58.1 29.7 4.5-13.3 3.1-24.1-4.1-31.8-.4-.5-.9-1-1.4-1.5-1.8-2.4-4.3-5.8-7-10 27.2-1.2 63.5-11 74.4-45.4 5 5 8.4 39.1-3.8 59zM191.9 187.7h.2c12.7-.1 27.2-17.8 27.2-17.8-9.9 6-18.8 8.1-27.3 8.3-8.5-.2-17.4-2.3-27.3-8.3 0 0 14.5 17.6 27.2 17.8zm61.7 230.7h-29.4c-4.2 0-7.2.9-8.9 2.7-2.2 2.3-1.5 5.2-.9 6.7 1 2.6 5.5 11.3 13 19.3 2.7 2.9 6.6 4.5 11 4.5s8.7-1.6 11.8-4.2c2.3-2 10.2-9.2 13.7-18.1 1.3-3.3 1-6-.9-7.9-1.3-1.3-4-2.9-9.4-3z"
                }
            }
        ]
    })(props);
}
function FaGuilded(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M443.427,64H4.571c0,103.26,22.192,180.06,43.418,222.358C112.046,414.135,224,448,225.256,448a312.824,312.824,0,0,0,140.55-103.477c25.907-33.923,53.1-87.19,65.916-145.761H171.833c4.14,36.429,22.177,67.946,45.1,86.944h88.589c-17.012,28.213-48.186,54.4-80.456,69.482-31.232-13.259-69.09-46.544-96.548-98.362-26.726-53.833-27.092-105.883-27.092-105.883H437.573A625.91,625.91,0,0,0,443.427,64Z"
                }
            }
        ]
    })(props);
}
function FaGulp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 256 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M209.8 391.1l-14.1 24.6-4.6 80.2c0 8.9-28.3 16.1-63.1 16.1s-63.1-7.2-63.1-16.1l-5.8-79.4-14.9-25.4c41.2 17.3 126 16.7 165.6 0zm-196-253.3l13.6 125.5c5.9-20 20.8-47 40-55.2 6.3-2.7 12.7-2.7 18.7.9 5.2 3 9.6 9.3 10.1 11.8 1.2 6.5-2 9.1-4.5 9.1-3 0-5.3-4.6-6.8-7.3-4.1-7.3-10.3-7.6-16.9-2.8-6.9 5-12.9 13.4-17.1 20.7-5.1 8.8-9.4 18.5-12 28.2-1.5 5.6-2.9 14.6-.6 19.9 1 2.2 2.5 3.6 4.9 3.6 5 0 12.3-6.6 15.8-10.1 4.5-4.5 10.3-11.5 12.5-16l5.2-15.5c2.6-6.8 9.9-5.6 9.9 0 0 10.2-3.7 13.6-10 34.7-5.8 19.5-7.6 25.8-7.6 25.8-.7 2.8-3.4 7.5-6.3 7.5-1.2 0-2.1-.4-2.6-1.2-1-1.4-.9-5.3-.8-6.3.2-3.2 6.3-22.2 7.3-25.2-2 2.2-4.1 4.4-6.4 6.6-5.4 5.1-14.1 11.8-21.5 11.8-3.4 0-5.6-.9-7.7-2.4l7.6 79.6c2 5 39.2 17.1 88.2 17.1 49.1 0 86.3-12.2 88.2-17.1l10.9-94.6c-5.7 5.2-12.3 11.6-19.6 14.8-5.4 2.3-17.4 3.8-17.4-5.7 0-5.2 9.1-14.8 14.4-21.5 1.4-1.7 4.7-5.9 4.7-8.1 0-2.9-6-2.2-11.7 2.5-3.2 2.7-6.2 6.3-8.7 9.7-4.3 6-6.6 11.2-8.5 15.5-6.2 14.2-4.1 8.6-9.1 22-5 13.3-4.2 11.8-5.2 14-.9 1.9-2.2 3.5-4 4.5-1.9 1-4.5.9-6.1-.3-.9-.6-1.3-1.9-1.3-3.7 0-.9.1-1.8.3-2.7 1.5-6.1 7.8-18.1 15-34.3 1.6-3.7 1-2.6.8-2.3-6.2 6-10.9 8.9-14.4 10.5-5.8 2.6-13 2.6-14.5-4.1-.1-.4-.1-.8-.2-1.2-11.8 9.2-24.3 11.7-20-8.1-4.6 8.2-12.6 14.9-22.4 14.9-4.1 0-7.1-1.4-8.6-5.1-2.3-5.5 1.3-14.9 4.6-23.8 1.7-4.5 4-9.9 7.1-16.2 1.6-3.4 4.2-5.4 7.6-4.5.6.2 1.1.4 1.6.7 2.6 1.8 1.6 4.5.3 7.2-3.8 7.5-7.1 13-9.3 20.8-.9 3.3-2 9 1.5 9 2.4 0 4.7-.8 6.9-2.4 4.6-3.4 8.3-8.5 11.1-13.5 2-3.6 4.4-8.3 5.6-12.3.5-1.7 1.1-3.3 1.8-4.8 1.1-2.5 2.6-5.1 5.2-5.1 1.3 0 2.4.5 3.2 1.5 1.7 2.2 1.3 4.5.4 6.9-2 5.6-4.7 10.6-6.9 16.7-1.3 3.5-2.7 8-2.7 11.7 0 3.4 3.7 2.6 6.8 1.2 2.4-1.1 4.8-2.8 6.8-4.5 1.2-4.9.9-3.8 26.4-68.2 1.3-3.3 3.7-4.7 6.1-4.7 1.2 0 2.2.4 3.2 1.1 1.7 1.3 1.7 4.1 1 6.2-.7 1.9-.6 1.3-4.5 10.5-5.2 12.1-8.6 20.8-13.2 31.9-1.9 4.6-7.7 18.9-8.7 22.3-.6 2.2-1.3 5.8 1 5.8 5.4 0 19.3-13.1 23.1-17 .2-.3.5-.4.9-.6.6-1.9 1.2-3.7 1.7-5.5 1.4-3.8 2.7-8.2 5.3-11.3.8-1 1.7-1.6 2.7-1.6 2.8 0 4.2 1.2 4.2 4 0 1.1-.7 5.1-1.1 6.2 1.4-1.5 2.9-3 4.5-4.5 15-13.9 25.7-6.8 25.7.2 0 7.4-8.9 17.7-13.8 23.4-1.6 1.9-4.9 5.4-5 6.4 0 1.3.9 1.8 2.2 1.8 2 0 6.4-3.5 8-4.7 5-3.9 11.8-9.9 16.6-14.1l14.8-136.8c-30.5 17.1-197.6 17.2-228.3.2zm229.7-8.5c0 21-231.2 21-231.2 0 0-8.8 51.8-15.9 115.6-15.9 9 0 17.8.1 26.3.4l12.6-48.7L228.1.6c1.4-1.4 5.8-.2 9.9 3.5s6.6 7.9 5.3 9.3l-.1.1L185.9 74l-10 40.7c39.9 2.6 67.6 8.1 67.6 14.6zm-69.4 4.6c0-.8-.9-1.5-2.5-2.1l-.2.8c0 1.3-5 2.4-11.1 2.4s-11.1-1.1-11.1-2.4c0-.1 0-.2.1-.3l.2-.7c-1.8.6-3 1.4-3 2.3 0 2.1 6.2 3.7 13.7 3.7 7.7.1 13.9-1.6 13.9-3.7z"
                }
            }
        ]
    })(props);
}
function FaHackerNewsSquare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zM21.2 229.2H21c.1-.1.2-.3.3-.4 0 .1 0 .3-.1.4zm218 53.9V384h-31.4V281.3L128 128h37.3c52.5 98.3 49.2 101.2 59.3 125.6 12.3-27 5.8-24.4 60.6-125.6H320l-80.8 155.1z"
                }
            }
        ]
    })(props);
}
function FaHackerNews(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 32v448h448V32H0zm21.2 197.2H21c.1-.1.2-.3.3-.4 0 .1 0 .3-.1.4zm218 53.9V384h-31.4V281.3L128 128h37.3c52.5 98.3 49.2 101.2 59.3 125.6 12.3-27 5.8-24.4 60.6-125.6H320l-80.8 155.1z"
                }
            }
        ]
    })(props);
}
function FaHackerrank(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M477.5 128C463 103.05 285.13 0 256.16 0S49.25 102.79 34.84 128s-14.49 230.8 0 256 192.38 128 221.32 128S463 409.08 477.49 384s14.51-231 .01-256zM316.13 414.22c-4 0-40.91-35.77-38-38.69.87-.87 6.26-1.48 17.55-1.83 0-26.23.59-68.59.94-86.32 0-2-.44-3.43-.44-5.85h-79.93c0 7.1-.46 36.2 1.37 72.88.23 4.54-1.58 6-5.74 5.94-10.13 0-20.27-.11-30.41-.08-4.1 0-5.87-1.53-5.74-6.11.92-33.44 3-84-.15-212.67v-3.17c-9.67-.35-16.38-1-17.26-1.84-2.92-2.92 34.54-38.69 38.49-38.69s41.17 35.78 38.27 38.69c-.87.87-7.9 1.49-16.77 1.84v3.16c-2.42 25.75-2 79.59-2.63 105.39h80.26c0-4.55.39-34.74-1.2-83.64-.1-3.39.95-5.17 4.21-5.2 11.07-.08 22.15-.13 33.23-.06 3.46 0 4.57 1.72 4.5 5.38C333 354.64 336 341.29 336 373.69c8.87.35 16.82 1 17.69 1.84 2.88 2.91-33.62 38.69-37.58 38.69z"
                }
            }
        ]
    })(props);
}
function FaHips(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M251.6 157.6c0-1.9-.9-2.8-2.8-2.8h-40.9c-1.6 0-2.7 1.4-2.7 2.8v201.8c0 1.4 1.1 2.8 2.7 2.8h40.9c1.9 0 2.8-.9 2.8-2.8zM156.5 168c-16.1-11.8-36.3-17.9-60.3-18-18.1-.1-34.6 3.7-49.8 11.4V80.2c0-1.8-.9-2.7-2.8-2.7H2.7c-1.8 0-2.7.9-2.7 2.7v279.2c0 1.9.9 2.8 2.7 2.8h41c1.9 0 2.8-.9 2.8-2.8V223.3c0-.8-2.8-27 45.8-27 48.5 0 45.8 26.1 45.8 27v122.6c0 9 7.3 16.3 16.4 16.3h27.3c1.8 0 2.7-.9 2.7-2.8V223.3c0-23.4-9.3-41.8-28-55.3zm478.4 110.1c-6.8-15.7-18.4-27-34.9-34.1l-57.6-25.3c-8.6-3.6-9.2-11.2-2.6-16.1 7.4-5.5 44.3-13.9 84 6.8 1.7 1 4-.3 4-2.4v-44.7c0-1.3-.6-2.1-1.9-2.6-17.7-6.6-36.1-9.9-55.1-9.9-26.5 0-45.3 5.8-58.5 15.4-.5.4-28.4 20-22.7 53.7 3.4 19.6 15.8 34.2 37.2 43.6l53.6 23.5c11.6 5.1 15.2 13.3 12.2 21.2-3.7 9.1-13.2 13.6-36.5 13.6-24.3 0-44.7-8.9-58.4-19.1-2.1-1.4-4.4.2-4.4 2.3v34.4c0 10.4 4.9 17.3 14.6 20.7 15.6 5.5 31.6 8.2 48.2 8.2 12.7 0 25.8-1.2 36.3-4.3.7-.3 36-8.9 45.6-45.8 3.5-13.5 2.4-26.5-3.1-39.1zM376.2 149.8c-31.7 0-104.2 20.1-104.2 103.5v183.5c0 .8.6 2.7 2.7 2.7h40.9c1.9 0 2.8-.9 2.8-2.7V348c16.5 12.7 35.8 19.1 57.7 19.1 60.5 0 108.7-48.5 108.7-108.7.1-60.3-48.2-108.6-108.6-108.6zm0 170.9c-17.2 0-31.9-6.1-44-18.2-12.2-12.2-18.2-26.8-18.2-44 0-34.5 27.6-62.2 62.2-62.2 34.5 0 62.2 27.6 62.2 62.2.1 34.3-27.3 62.2-62.2 62.2zM228.3 72.5c-15.9 0-28.8 12.9-28.9 28.9 0 15.6 12.7 28.9 28.9 28.9s28.9-13.1 28.9-28.9c0-16.2-13-28.9-28.9-28.9z"
                }
            }
        ]
    })(props);
}
function FaHireAHelper(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M443.1 0H71.9C67.9 37.3 37.4 67.8 0 71.7v371.5c37.4 4.9 66 32.4 71.9 68.8h372.2c3-36.4 32.5-65.8 67.9-69.8V71.7c-36.4-5.9-65-35.3-68.9-71.7zm-37 404.9c-36.3 0-18.8-2-55.1-2-35.8 0-21 2-56.1 2-5.9 0-4.9-8.2 0-9.8 22.8-7.6 22.9-10.2 24.6-12.8 10.4-15.6 5.9-83 5.9-113 0-5.3-6.4-12.8-13.8-12.8H200.4c-7.4 0-13.8 7.5-13.8 12.8 0 30-4.5 97.4 5.9 113 1.7 2.5 1.8 5.2 24.6 12.8 4.9 1.6 6 9.8 0 9.8-35.1 0-20.3-2-56.1-2-36.3 0-18.8 2-55.1 2-7.9 0-5.8-10.8 0-10.8 10.2-3.4 13.5-3.5 21.7-13.8 7.7-12.9 7.9-44.4 7.9-127.8V151.3c0-22.2-12.2-28.3-28.6-32.4-8.8-2.2-4-11.8 1-11.8 36.5 0 20.6 2 57.1 2 32.7 0 16.5-2 49.2-2 3.3 0 8.5 8.3 1 10.8-4.9 1.6-27.6 3.7-27.6 39.3 0 45.6-.2 55.8 1 68.8 0 1.3 2.3 12.8 12.8 12.8h109.2c10.5 0 12.8-11.5 12.8-12.8 1.2-13 1-23.2 1-68.8 0-35.6-22.7-37.7-27.6-39.3-7.5-2.5-2.3-10.8 1-10.8 32.7 0 16.5 2 49.2 2 36.5 0 20.6-2 57.1-2 4.9 0 9.9 9.6 1 11.8-16.4 4.1-28.6 10.3-28.6 32.4v101.2c0 83.4.1 114.9 7.9 127.8 8.2 10.2 11.4 10.4 21.7 13.8 5.8 0 7.8 10.8 0 10.8z"
                }
            }
        ]
    })(props);
}
function FaHive(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M260.353,254.878,131.538,33.1a2.208,2.208,0,0,0-3.829.009L.3,254.887A2.234,2.234,0,0,0,.3,257.122L129.116,478.9a2.208,2.208,0,0,0,3.83-.009L260.358,257.113A2.239,2.239,0,0,0,260.353,254.878Zm39.078-25.713a2.19,2.19,0,0,0,1.9,1.111h66.509a2.226,2.226,0,0,0,1.9-3.341L259.115,33.111a2.187,2.187,0,0,0-1.9-1.111H190.707a2.226,2.226,0,0,0-1.9,3.341ZM511.7,254.886,384.9,33.112A2.2,2.2,0,0,0,382.99,32h-66.6a2.226,2.226,0,0,0-1.906,3.34L440.652,256,314.481,476.66a2.226,2.226,0,0,0,1.906,3.34h66.6a2.2,2.2,0,0,0,1.906-1.112L511.7,257.114A2.243,2.243,0,0,0,511.7,254.886ZM366.016,284.917H299.508a2.187,2.187,0,0,0-1.9,1.111l-108.8,190.631a2.226,2.226,0,0,0,1.9,3.341h66.509a2.187,2.187,0,0,0,1.9-1.111l108.8-190.631A2.226,2.226,0,0,0,366.016,284.917Z"
                }
            }
        ]
    })(props);
}
function FaHooli(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M144.5 352l38.3.8c-13.2-4.6-26-10.2-38.3-16.8zm57.7-5.3v5.3l-19.4.8c36.5 12.5 69.9 14.2 94.7 7.2-19.9.2-45.8-2.6-75.3-13.3zm408.9-115.2c15.9 0 28.9-12.9 28.9-28.9s-12.9-24.5-28.9-24.5c-15.9 0-28.9 8.6-28.9 24.5s12.9 28.9 28.9 28.9zm-29 120.5H640V241.5h-57.9zm-73.7 0h57.9V156.7L508.4 184zm-31-119.4c-18.2-18.2-50.4-17.1-50.4-17.1s-32.3-1.1-50.4 17.1c-18.2 18.2-16.8 33.9-16.8 52.6s-1.4 34.3 16.8 52.5 50.4 17.1 50.4 17.1 32.3 1.1 50.4-17.1c18.2-18.2 16.8-33.8 16.8-52.5-.1-18.8 1.3-34.5-16.8-52.6zm-39.8 71.9c0 3.6-1.8 12.5-10.7 12.5s-10.7-8.9-10.7-12.5v-40.4c0-8.7 7.3-10.9 10.7-10.9s10.7 2.1 10.7 10.9zm-106.2-71.9c-18.2-18.2-50.4-17.1-50.4-17.1s-32.2-1.1-50.4 17.1c-1.9 1.9-3.7 3.9-5.3 6-38.2-29.6-72.5-46.5-102.1-61.1v-20.7l-22.5 10.6c-54.4-22.1-89-18.2-97.3.1 0 0-24.9 32.8 61.8 110.8V352h57.9v-28.6c-6.5-4.2-13-8.7-19.4-13.6-14.8-11.2-27.4-21.6-38.4-31.4v-31c13.1 14.7 30.5 31.4 53.4 50.3l4.5 3.6v-29.8c0-6.9 1.7-18.2 10.8-18.2s10.6 6.9 10.6 15V317c18 12.2 37.3 22.1 57.7 29.6v-93.9c0-18.7-13.4-37.4-40.6-37.4-15.8-.1-30.5 8.2-38.5 21.9v-54.3c41.9 20.9 83.9 46.5 99.9 58.3-10.2 14.6-9.3 28.1-9.3 43.7 0 18.7-1.4 34.3 16.8 52.5s50.4 17.1 50.4 17.1 32.3 1.1 50.4-17.1c18.2-18.2 16.7-33.8 16.7-52.5 0-18.5 1.5-34.2-16.7-52.3zM65.2 184v63.3c-48.7-54.5-38.9-76-35.2-79.1 13.5-11.4 37.5-8 64.4 2.1zm226.5 120.5c0 3.6-1.8 12.5-10.7 12.5s-10.7-8.9-10.7-12.5v-40.4c0-8.7 7.3-10.9 10.7-10.9s10.7 2.1 10.7 10.9z"
                }
            }
        ]
    })(props);
}
function FaHornbill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M76.38 370.3a37.8 37.8 0 1 1-32.07-32.42c-78.28-111.35 52-190.53 52-190.53-5.86 43-8.24 91.16-8.24 91.16-67.31 41.49.93 64.06 39.81 72.87a140.38 140.38 0 0 0 131.66 91.94c1.92 0 3.77-.21 5.67-.28l.11 18.86c-99.22 1.39-158.7-29.14-188.94-51.6zm108-327.7A37.57 37.57 0 0 0 181 21.45a37.95 37.95 0 1 0-31.17 54.22c-22.55 29.91-53.83 89.57-52.42 190l21.84-.15c0-.9-.14-1.77-.14-2.68A140.42 140.42 0 0 1 207 132.71c8-37.71 30.7-114.3 73.8-44.29 0 0 48.14 2.38 91.18 8.24 0 0-77.84-128-187.59-54.06zm304.19 134.17a37.94 37.94 0 1 0-53.84-28.7C403 126.13 344.89 99 251.28 100.33l.14 22.5c2.7-.15 5.39-.41 8.14-.41a140.37 140.37 0 0 1 130.49 88.76c39.1 9 105.06 31.58 38.46 72.54 0 0-2.34 48.13-8.21 91.16 0 0 133.45-81.16 49-194.61a37.45 37.45 0 0 0 19.31-3.5zM374.06 436.24c21.43-32.46 46.42-89.69 45.14-179.66l-19.52.14c.08 2.06.3 4.07.3 6.15a140.34 140.34 0 0 1-91.39 131.45c-8.85 38.95-31.44 106.66-72.77 39.49 0 0-48.12-2.34-91.19-8.22 0 0 79.92 131.34 191.9 51a37.5 37.5 0 0 0 3.64 14 37.93 37.93 0 1 0 33.89-54.29z"
                }
            }
        ]
    })(props);
}
function FaHotjar(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M414.9 161.5C340.2 29 121.1 0 121.1 0S222.2 110.4 93 197.7C11.3 252.8-21 324.4 14 402.6c26.8 59.9 83.5 84.3 144.6 93.4-29.2-55.1-6.6-122.4-4.1-129.6 57.1 86.4 165 0 110.8-93.9 71 15.4 81.6 138.6 27.1 215.5 80.5-25.3 134.1-88.9 148.8-145.6 15.5-59.3 3.7-127.9-26.3-180.9z"
                }
            }
        ]
    })(props);
}
function FaHouzz(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M275.9 330.7H171.3V480H17V32h109.5v104.5l305.1 85.6V480H275.9z"
                }
            }
        ]
    })(props);
}
function FaHtml5(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 32l34.9 395.8L191.5 480l157.6-52.2L384 32H0zm308.2 127.9H124.4l4.1 49.4h175.6l-13.6 148.4-97.9 27v.3h-1.1l-98.7-27.3-6-75.8h47.7L138 320l53.5 14.5 53.7-14.5 6-62.2H84.3L71.5 112.2h241.1l-4.4 47.7z"
                }
            }
        ]
    })(props);
}
function FaHubspot(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M267.4 211.6c-25.1 23.7-40.8 57.3-40.8 94.6 0 29.3 9.7 56.3 26 78L203.1 434c-4.4-1.6-9.1-2.5-14-2.5-10.8 0-20.9 4.2-28.5 11.8-7.6 7.6-11.8 17.8-11.8 28.6s4.2 20.9 11.8 28.5c7.6 7.6 17.8 11.6 28.5 11.6 10.8 0 20.9-3.9 28.6-11.6 7.6-7.6 11.8-17.8 11.8-28.5 0-4.2-.6-8.2-1.9-12.1l50-50.2c22 16.9 49.4 26.9 79.3 26.9 71.9 0 130-58.3 130-130.2 0-65.2-47.7-119.2-110.2-128.7V116c17.5-7.4 28.2-23.8 28.2-42.9 0-26.1-20.9-47.9-47-47.9S311.2 47 311.2 73.1c0 19.1 10.7 35.5 28.2 42.9v61.2c-15.2 2.1-29.6 6.7-42.7 13.6-27.6-20.9-117.5-85.7-168.9-124.8 1.2-4.4 2-9 2-13.8C129.8 23.4 106.3 0 77.4 0 48.6 0 25.2 23.4 25.2 52.2c0 28.9 23.4 52.3 52.2 52.3 9.8 0 18.9-2.9 26.8-7.6l163.2 114.7zm89.5 163.6c-38.1 0-69-30.9-69-69s30.9-69 69-69 69 30.9 69 69-30.9 69-69 69z"
                }
            }
        ]
    })(props);
}
function FaIdeal(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M125.61,165.48a49.07,49.07,0,1,0,49.06,49.06A49.08,49.08,0,0,0,125.61,165.48ZM86.15,425.84h78.94V285.32H86.15Zm151.46-211.6c0-20-10-22.53-18.74-22.53H204.82V237.5h14.05C228.62,237.5,237.61,234.69,237.61,214.24Zm201.69,46V168.93h22.75V237.5h33.69C486.5,113.08,388.61,86.19,299.67,86.19H204.84V169h14c25.6,0,41.5,17.35,41.5,45.26,0,28.81-15.52,46-41.5,46h-14V425.88h94.83c144.61,0,194.94-67.16,196.72-165.64Zm-109.75,0H273.3V169h54.43v22.73H296v10.58h30V225H296V237.5h33.51Zm74.66,0-5.16-17.67H369.31l-5.18,17.67H340.47L368,168.92h32.35l27.53,91.34ZM299.65,32H32V480H299.65c161.85,0,251-79.73,251-224.52C550.62,172,518,32,299.65,32Zm0,426.92H53.07V53.07H299.65c142.1,0,229.9,64.61,229.9,202.41C529.55,389.57,448.55,458.92,299.65,458.92Zm83.86-264.85L376,219.88H392.4l-7.52-25.81Z"
                }
            }
        ]
    })(props);
}
function FaImdb(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zM21.3 229.2H21c.1-.1.2-.3.3-.4zM97 319.8H64V192h33zm113.2 0h-28.7v-86.4l-11.6 86.4h-20.6l-12.2-84.5v84.5h-29V192h42.8c3.3 19.8 6 39.9 8.7 59.9l7.6-59.9h43zm11.4 0V192h24.6c17.6 0 44.7-1.6 49 20.9 1.7 7.6 1.4 16.3 1.4 24.4 0 88.5 11.1 82.6-75 82.5zm160.9-29.2c0 15.7-2.4 30.9-22.2 30.9-9 0-15.2-3-20.9-9.8l-1.9 8.1h-29.8V192h31.7v41.7c6-6.5 12-9.2 20.9-9.2 21.4 0 22.2 12.8 22.2 30.1zM265 229.9c0-9.7 1.6-16-10.3-16v83.7c12.2.3 10.3-8.7 10.3-18.4zm85.5 26.1c0-5.4 1.1-12.7-6.2-12.7-6 0-4.9 8.9-4.9 12.7 0 .6-1.1 39.6 1.1 44.7.8 1.6 2.2 2.4 3.8 2.4 7.8 0 6.2-9 6.2-14.4z"
                }
            }
        ]
    })(props);
}
function FaInnosoft(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M422.559,159.71a27.379,27.379,0,0,0-13.866-23.337,26.42,26.42,0,0,0-26.211.133L73.943,314.647V176.261a11.955,11.955,0,0,1,6.047-10.34L218.066,86.208a12.153,12.153,0,0,1,11.922.025l32.656,18.853L112.581,191.723v56L359.642,105.086,241.129,36.679c-10.992-6.129-22.3-6.255-33.8-.27l-164.6,95.026c-10.634,6.12-16.771,16.39-17.29,29.124l0,191.5c.17,10.135,5.08,18.672,13.474,23.428a27.037,27.037,0,0,0,26.736-.045L374.057,197.376V335.657a11.976,11.976,0,0,1-5.92,10.368L230.025,425.77a12.175,12.175,0,0,1-11.937.062l-32.723-18.9,150.051-86.627v-56L88.367,406.932l118.794,68.583a33.88,33.88,0,0,0,34.25-.327l164.527-94.995c10.746-6.631,16.649-17.118,16.624-29.528Z"
                }
            }
        ]
    })(props);
}
function FaInstagramSquare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M224,202.66A53.34,53.34,0,1,0,277.36,256,53.38,53.38,0,0,0,224,202.66Zm124.71-41a54,54,0,0,0-30.41-30.41c-21-8.29-71-6.43-94.3-6.43s-73.25-1.93-94.31,6.43a54,54,0,0,0-30.41,30.41c-8.28,21-6.43,71.05-6.43,94.33S91,329.26,99.32,350.33a54,54,0,0,0,30.41,30.41c21,8.29,71,6.43,94.31,6.43s73.24,1.93,94.3-6.43a54,54,0,0,0,30.41-30.41c8.35-21,6.43-71.05,6.43-94.33S357.1,182.74,348.75,161.67ZM224,338a82,82,0,1,1,82-82A81.9,81.9,0,0,1,224,338Zm85.38-148.3a19.14,19.14,0,1,1,19.13-19.14A19.1,19.1,0,0,1,309.42,189.74ZM400,32H48A48,48,0,0,0,0,80V432a48,48,0,0,0,48,48H400a48,48,0,0,0,48-48V80A48,48,0,0,0,400,32ZM382.88,322c-1.29,25.63-7.14,48.34-25.85,67s-41.4,24.63-67,25.85c-26.41,1.49-105.59,1.49-132,0-25.63-1.29-48.26-7.15-67-25.85s-24.63-41.42-25.85-67c-1.49-26.42-1.49-105.61,0-132,1.29-25.63,7.07-48.34,25.85-67s41.47-24.56,67-25.78c26.41-1.49,105.59-1.49,132,0,25.63,1.29,48.33,7.15,67,25.85s24.63,41.42,25.85,67.05C384.37,216.44,384.37,295.56,382.88,322Z"
                }
            }
        ]
    })(props);
}
function FaInstagram(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M224.1 141c-63.6 0-114.9 51.3-114.9 114.9s51.3 114.9 114.9 114.9S339 319.5 339 255.9 287.7 141 224.1 141zm0 189.6c-41.1 0-74.7-33.5-74.7-74.7s33.5-74.7 74.7-74.7 74.7 33.5 74.7 74.7-33.6 74.7-74.7 74.7zm146.4-194.3c0 14.9-12 26.8-26.8 26.8-14.9 0-26.8-12-26.8-26.8s12-26.8 26.8-26.8 26.8 12 26.8 26.8zm76.1 27.2c-1.7-35.9-9.9-67.7-36.2-93.9-26.2-26.2-58-34.4-93.9-36.2-37-2.1-147.9-2.1-184.9 0-35.8 1.7-67.6 9.9-93.9 36.1s-34.4 58-36.2 93.9c-2.1 37-2.1 147.9 0 184.9 1.7 35.9 9.9 67.7 36.2 93.9s58 34.4 93.9 36.2c37 2.1 147.9 2.1 184.9 0 35.9-1.7 67.7-9.9 93.9-36.2 26.2-26.2 34.4-58 36.2-93.9 2.1-37 2.1-147.8 0-184.8zM398.8 388c-7.8 19.6-22.9 34.7-42.6 42.6-29.5 11.7-99.5 9-132.1 9s-102.7 2.6-132.1-9c-19.6-7.8-34.7-22.9-42.6-42.6-11.7-29.5-9-99.5-9-132.1s-2.6-102.7 9-132.1c7.8-19.6 22.9-34.7 42.6-42.6 29.5-11.7 99.5-9 132.1-9s102.7-2.6 132.1 9c19.6 7.8 34.7 22.9 42.6 42.6 11.7 29.5 9 99.5 9 132.1s2.7 102.7-9 132.1z"
                }
            }
        ]
    })(props);
}
function FaInstalod(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M153.384,480H387.113L502.554,275.765,204.229,333.211ZM504.726,240.078,387.113,32H155.669L360.23,267.9ZM124.386,48.809,7.274,256,123.236,461.154,225.627,165.561Z"
                }
            }
        ]
    })(props);
}
function FaIntercom(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M392 32H56C25.1 32 0 57.1 0 88v336c0 30.9 25.1 56 56 56h336c30.9 0 56-25.1 56-56V88c0-30.9-25.1-56-56-56zm-108.3 82.1c0-19.8 29.9-19.8 29.9 0v199.5c0 19.8-29.9 19.8-29.9 0V114.1zm-74.6-7.5c0-19.8 29.9-19.8 29.9 0v216.5c0 19.8-29.9 19.8-29.9 0V106.6zm-74.7 7.5c0-19.8 29.9-19.8 29.9 0v199.5c0 19.8-29.9 19.8-29.9 0V114.1zM59.7 144c0-19.8 29.9-19.8 29.9 0v134.3c0 19.8-29.9 19.8-29.9 0V144zm323.4 227.8c-72.8 63-241.7 65.4-318.1 0-15-12.8 4.4-35.5 19.4-22.7 65.9 55.3 216.1 53.9 279.3 0 14.9-12.9 34.3 9.8 19.4 22.7zm5.2-93.5c0 19.8-29.9 19.8-29.9 0V144c0-19.8 29.9-19.8 29.9 0v134.3z"
                }
            }
        ]
    })(props);
}
function FaInternetExplorer(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M483.049 159.706c10.855-24.575 21.424-60.438 21.424-87.871 0-72.722-79.641-98.371-209.673-38.577-107.632-7.181-211.221 73.67-237.098 186.457 30.852-34.862 78.271-82.298 121.977-101.158C125.404 166.85 79.128 228.002 43.992 291.725 23.246 329.651 0 390.94 0 436.747c0 98.575 92.854 86.5 180.251 42.006 31.423 15.43 66.559 15.573 101.695 15.573 97.124 0 184.249-54.294 216.814-146.022H377.927c-52.509 88.593-196.819 52.996-196.819-47.436H509.9c6.407-43.581-1.655-95.715-26.851-141.162zM64.559 346.877c17.711 51.15 53.703 95.871 100.266 123.304-88.741 48.94-173.267 29.096-100.266-123.304zm115.977-108.873c2-55.151 50.276-94.871 103.98-94.871 53.418 0 101.981 39.72 103.981 94.871H180.536zm184.536-187.6c21.425-10.287 48.563-22.003 72.558-22.003 31.422 0 54.274 21.717 54.274 53.722 0 20.003-7.427 49.007-14.569 67.867-26.28-42.292-65.986-81.584-112.263-99.586z"
                }
            }
        ]
    })(props);
}
function FaInvision(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M407.4 32H40.6C18.2 32 0 50.2 0 72.6v366.8C0 461.8 18.2 480 40.6 480h366.8c22.4 0 40.6-18.2 40.6-40.6V72.6c0-22.4-18.2-40.6-40.6-40.6zM176.1 145.6c.4 23.4-22.4 27.3-26.6 27.4-14.9 0-27.1-12-27.1-27 .1-35.2 53.1-35.5 53.7-.4zM332.8 377c-65.6 0-34.1-74-25-106.6 14.1-46.4-45.2-59-59.9.7l-25.8 103.3H177l8.1-32.5c-31.5 51.8-94.6 44.4-94.6-4.3.1-14.3.9-14 23-104.1H81.7l9.7-35.6h76.4c-33.6 133.7-32.6 126.9-32.9 138.2 0 20.9 40.9 13.5 57.4-23.2l19.8-79.4h-32.3l9.7-35.6h68.8l-8.9 40.5c40.5-75.5 127.9-47.8 101.8 38-14.2 51.1-14.6 50.7-14.9 58.8 0 15.5 17.5 22.6 31.8-16.9L386 325c-10.5 36.7-29.4 52-53.2 52z"
                }
            }
        ]
    })(props);
}
function FaIoxhost(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M616 160h-67.3C511.2 70.7 422.9 8 320 8 183 8 72 119 72 256c0 16.4 1.6 32.5 4.7 48H24c-13.3 0-24 10.8-24 24 0 13.3 10.7 24 24 24h67.3c37.5 89.3 125.8 152 228.7 152 137 0 248-111 248-248 0-16.4-1.6-32.5-4.7-48H616c13.3 0 24-10.8 24-24 0-13.3-10.7-24-24-24zm-96 96c0 110.5-89.5 200-200 200-75.7 0-141.6-42-175.5-104H424c13.3 0 24-10.8 24-24 0-13.3-10.7-24-24-24H125.8c-3.8-15.4-5.8-31.4-5.8-48 0-110.5 89.5-200 200-200 75.7 0 141.6 42 175.5 104H216c-13.3 0-24 10.8-24 24 0 13.3 10.7 24 24 24h298.2c3.8 15.4 5.8 31.4 5.8 48zm-304-24h208c13.3 0 24 10.7 24 24 0 13.2-10.7 24-24 24H216c-13.3 0-24-10.7-24-24 0-13.2 10.7-24 24-24z"
                }
            }
        ]
    })(props);
}
function FaItchIo(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M71.92 34.77C50.2 47.67 7.4 96.84 7 109.73v21.34c0 27.06 25.29 50.84 48.25 50.84 27.57 0 50.54-22.85 50.54-50 0 27.12 22.18 50 49.76 50s49-22.85 49-50c0 27.12 23.59 50 51.16 50h.5c27.57 0 51.16-22.85 51.16-50 0 27.12 21.47 50 49 50s49.76-22.85 49.76-50c0 27.12 23 50 50.54 50 23 0 48.25-23.78 48.25-50.84v-21.34c-.4-12.9-43.2-62.07-64.92-75C372.56 32.4 325.76 32 256 32S91.14 33.1 71.92 34.77zm132.32 134.39c-22 38.4-77.9 38.71-99.85.25-13.17 23.14-43.17 32.07-56 27.66-3.87 40.15-13.67 237.13 17.73 269.15 80 18.67 302.08 18.12 379.76 0 31.65-32.27 21.32-232 17.75-269.15-12.92 4.44-42.88-4.6-56-27.66-22 38.52-77.85 38.1-99.85-.24-7.1 12.49-23.05 28.94-51.76 28.94a57.54 57.54 0 0 1-51.75-28.94zm-41.58 53.77c16.47 0 31.09 0 49.22 19.78a436.91 436.91 0 0 1 88.18 0C318.22 223 332.85 223 349.31 223c52.33 0 65.22 77.53 83.87 144.45 17.26 62.15-5.52 63.67-33.95 63.73-42.15-1.57-65.49-32.18-65.49-62.79-39.25 6.43-101.93 8.79-155.55 0 0 30.61-23.34 61.22-65.49 62.79-28.42-.06-51.2-1.58-33.94-63.73 18.67-67 31.56-144.45 83.88-144.45zM256 270.79s-44.38 40.77-52.35 55.21l29-1.17v25.32c0 1.55 21.34.16 23.33.16 11.65.54 23.31 1 23.31-.16v-25.28l29 1.17c-8-14.48-52.35-55.24-52.35-55.24z"
                }
            }
        ]
    })(props);
}
function FaItunesNote(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M381.9 388.2c-6.4 27.4-27.2 42.8-55.1 48-24.5 4.5-44.9 5.6-64.5-10.2-23.9-20.1-24.2-53.4-2.7-74.4 17-16.2 40.9-19.5 76.8-25.8 6-1.1 11.2-2.5 15.6-7.4 6.4-7.2 4.4-4.1 4.4-163.2 0-11.2-5.5-14.3-17-12.3-8.2 1.4-185.7 34.6-185.7 34.6-10.2 2.2-13.4 5.2-13.4 16.7 0 234.7 1.1 223.9-2.5 239.5-4.2 18.2-15.4 31.9-30.2 39.5-16.8 9.3-47.2 13.4-63.4 10.4-43.2-8.1-58.4-58-29.1-86.6 17-16.2 40.9-19.5 76.8-25.8 6-1.1 11.2-2.5 15.6-7.4 10.1-11.5 1.8-256.6 5.2-270.2.8-5.2 3-9.6 7.1-12.9 4.2-3.5 11.8-5.5 13.4-5.5 204-38.2 228.9-43.1 232.4-43.1 11.5-.8 18.1 6 18.1 17.6.2 344.5 1.1 326-1.8 338.5z"
                }
            }
        ]
    })(props);
}
function FaItunes(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M223.6 80.3C129 80.3 52.5 157 52.5 251.5S129 422.8 223.6 422.8s171.2-76.7 171.2-171.2c0-94.6-76.7-171.3-171.2-171.3zm79.4 240c-3.2 13.6-13.5 21.2-27.3 23.8-12.1 2.2-22.2 2.8-31.9-5-11.8-10-12-26.4-1.4-36.8 8.4-8 20.3-9.6 38-12.8 3-.5 5.6-1.2 7.7-3.7 3.2-3.6 2.2-2 2.2-80.8 0-5.6-2.7-7.1-8.4-6.1-4 .7-91.9 17.1-91.9 17.1-5 1.1-6.7 2.6-6.7 8.3 0 116.1.5 110.8-1.2 118.5-2.1 9-7.6 15.8-14.9 19.6-8.3 4.6-23.4 6.6-31.4 5.2-21.4-4-28.9-28.7-14.4-42.9 8.4-8 20.3-9.6 38-12.8 3-.5 5.6-1.2 7.7-3.7 5-5.7.9-127 2.6-133.7.4-2.6 1.5-4.8 3.5-6.4 2.1-1.7 5.8-2.7 6.7-2.7 101-19 113.3-21.4 115.1-21.4 5.7-.4 9 3 9 8.7-.1 170.6.4 161.4-1 167.6zM345.2 32H102.8C45.9 32 0 77.9 0 134.8v242.4C0 434.1 45.9 480 102.8 480h242.4c57 0 102.8-45.9 102.8-102.8V134.8C448 77.9 402.1 32 345.2 32zM223.6 444c-106.3 0-192.5-86.2-192.5-192.5S117.3 59 223.6 59s192.5 86.2 192.5 192.5S329.9 444 223.6 444z"
                }
            }
        ]
    })(props);
}
function FaJava(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M277.74 312.9c9.8-6.7 23.4-12.5 23.4-12.5s-38.7 7-77.2 10.2c-47.1 3.9-97.7 4.7-123.1 1.3-60.1-8 33-30.1 33-30.1s-36.1-2.4-80.6 19c-52.5 25.4 130 37 224.5 12.1zm-85.4-32.1c-19-42.7-83.1-80.2 0-145.8C296 53.2 242.84 0 242.84 0c21.5 84.5-75.6 110.1-110.7 162.6-23.9 35.9 11.7 74.4 60.2 118.2zm114.6-176.2c.1 0-175.2 43.8-91.5 140.2 24.7 28.4-6.5 54-6.5 54s62.7-32.4 33.9-72.9c-26.9-37.8-47.5-56.6 64.1-121.3zm-6.1 270.5a12.19 12.19 0 0 1-2 2.6c128.3-33.7 81.1-118.9 19.8-97.3a17.33 17.33 0 0 0-8.2 6.3 70.45 70.45 0 0 1 11-3c31-6.5 75.5 41.5-20.6 91.4zM348 437.4s14.5 11.9-15.9 21.2c-57.9 17.5-240.8 22.8-291.6.7-18.3-7.9 16-19 26.8-21.3 11.2-2.4 17.7-2 17.7-2-20.3-14.3-131.3 28.1-56.4 40.2C232.84 509.4 401 461.3 348 437.4zM124.44 396c-78.7 22 47.9 67.4 148.1 24.5a185.89 185.89 0 0 1-28.2-13.8c-44.7 8.5-65.4 9.1-106 4.5-33.5-3.8-13.9-15.2-13.9-15.2zm179.8 97.2c-78.7 14.8-175.8 13.1-233.3 3.6 0-.1 11.8 9.7 72.4 13.6 92.2 5.9 233.8-3.3 237.1-46.9 0 0-6.4 16.5-76.2 29.7zM260.64 353c-59.2 11.4-93.5 11.1-136.8 6.6-33.5-3.5-11.6-19.7-11.6-19.7-86.8 28.8 48.2 61.4 169.5 25.9a60.37 60.37 0 0 1-21.1-12.8z"
                }
            }
        ]
    })(props);
}
function FaJediOrder(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M398.5 373.6c95.9-122.1 17.2-233.1 17.2-233.1 45.4 85.8-41.4 170.5-41.4 170.5 105-171.5-60.5-271.5-60.5-271.5 96.9 72.7-10.1 190.7-10.1 190.7 85.8 158.4-68.6 230.1-68.6 230.1s-.4-16.9-2.2-85.7c4.3 4.5 34.5 36.2 34.5 36.2l-24.2-47.4 62.6-9.1-62.6-9.1 20.2-55.5-31.4 45.9c-2.2-87.7-7.8-305.1-7.9-306.9v-2.4 1-1 2.4c0 1-5.6 219-7.9 306.9l-31.4-45.9 20.2 55.5-62.6 9.1 62.6 9.1-24.2 47.4 34.5-36.2c-1.8 68.8-2.2 85.7-2.2 85.7s-154.4-71.7-68.6-230.1c0 0-107-118.1-10.1-190.7 0 0-165.5 99.9-60.5 271.5 0 0-86.8-84.8-41.4-170.5 0 0-78.7 111 17.2 233.1 0 0-26.2-16.1-49.4-77.7 0 0 16.9 183.3 222 185.7h4.1c205-2.4 222-185.7 222-185.7-23.6 61.5-49.9 77.7-49.9 77.7z"
                }
            }
        ]
    })(props);
}
function FaJenkins(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M487.1 425c-1.4-11.2-19-23.1-28.2-31.9-5.1-5-29-23.1-30.4-29.9-1.4-6.6 9.7-21.5 13.3-28.9 5.1-10.7 8.8-23.7 11.3-32.6 18.8-66.1 20.7-156.9-6.2-211.2-10.2-20.6-38.6-49-56.4-62.5-42-31.7-119.6-35.3-170.1-16.6-14.1 5.2-27.8 9.8-40.1 17.1-33.1 19.4-68.3 32.5-78.1 71.6-24.2 10.8-31.5 41.8-30.3 77.8.2 7 4.1 15.8 2.7 22.4-.7 3.3-5.2 7.6-6.1 9.8-11.6 27.7-2.3 64 11.1 83.7 8.1 11.9 21.5 22.4 39.2 25.2.7 10.6 3.3 19.7 8.2 30.4 3.1 6.8 14.7 19 10.4 27.7-2.2 4.4-21 13.8-27.3 17.6C89 407.2 73.7 415 54.2 429c-12.6 9-32.3 10.2-29.2 31.1 2.1 14.1 10.1 31.6 14.7 45.8.7 2 1.4 4.1 2.1 6h422c4.9-15.3 9.7-30.9 14.6-47.2 3.4-11.4 10.2-27.8 8.7-39.7zM205.9 33.7c1.8-.5 3.4.7 4.9 2.4-.2 5.2-5.4 5.1-8.9 6.8-5.4 6.7-13.4 9.8-20 17.2-6.8 7.5-14.4 27.7-23.4 30-4.5 1.1-9.7-.8-13.6-.5-10.4.7-17.7 6-28.3 7.5 13.6-29.9 56.1-54 89.3-63.4zm-104.8 93.6c13.5-14.9 32.1-24.1 54.8-25.9 11.7 29.7-8.4 65-.9 97.6 2.3 9.9 10.2 25.4-2.4 25.7.3-28.3-34.8-46.3-61.3-29.6-1.8-21.5-4.9-51.7 9.8-67.8zm36.7 200.2c-1-4.1-2.7-12.9-2.3-15.1 1.6-8.7 17.1-12.5 11-24.7-11.3-.1-13.8 10.2-24.1 11.3-26.7 2.6-45.6-35.4-44.4-58.4 1-19.5 17.6-38.2 40.1-35.8 16 1.8 21.4 19.2 24.5 34.7 9.2.5 22.5-.4 26.9-7.6-.6-17.5-8.8-31.6-8.2-47.7 1-30.3 17.5-57.6 4.8-87.4 13.6-30.9 53.5-55.3 83.1-70 36.6-18.3 94.9-3.7 129.3 15.8 19.7 11.1 34.4 32.7 48.3 50.7-19.5-5.8-36.1 4.2-33.1 20.3 16.3-14.9 44.2-.2 52.5 16.4 7.9 15.8 7.8 39.3 9 62.8 2.9 57-10.4 115.9-39.1 157.1-7.7 11-14.1 23-24.9 30.6-26 18.2-65.4 34.7-99.2 23.4-44.7-15-65-44.8-89.5-78.8.7 18.7 13.8 34.1 26.8 48.4 11.3 12.5 25 26.6 39.7 32.4-12.3-2.9-31.1-3.8-36.2 7.2-28.6-1.9-55.1-4.8-68.7-24.2-10.6-15.4-21.4-41.4-26.3-61.4zm222 124.1c4.1-3 11.1-2.9 17.4-3.6-5.4-2.7-13-3.7-19.3-2.2-.1-4.2-2-6.8-3.2-10.2 10.6-3.8 35.5-28.5 49.6-20.3 6.7 3.9 9.5 26.2 10.1 37 .4 9-.8 18-4.5 22.8-18.8-.6-35.8-2.8-50.7-7 .9-6.1-1-12.1.6-16.5zm-17.2-20c-16.8.8-26-1.2-38.3-10.8.2-.8 1.4-.5 1.5-1.4 18 8 40.8-3.3 59-4.9-7.9 5.1-14.6 11.6-22.2 17.1zm-12.1 33.2c-1.6-9.4-3.5-12-2.8-20.2 25-16.6 29.7 28.6 2.8 20.2zM226 438.6c-11.6-.7-48.1-14-38.5-23.7 9.4 6.5 27.5 4.9 41.3 7.3.8 4.4-2.8 10.2-2.8 16.4zM57.7 497.1c-4.3-12.7-9.2-25.1-14.8-36.9 30.8-23.8 65.3-48.9 102.2-63.5 2.8-1.1 23.2 25.4 26.2 27.6 16.5 11.7 37 21 56.2 30.2 1.2 8.8 3.9 20.2 8.7 35.5.7 2.3 1.4 4.7 2.2 7.2H57.7zm240.6 5.7h-.8c.3-.2.5-.4.8-.5v.5zm7.5-5.7c2.1-1.4 4.3-2.8 6.4-4.3 1.1 1.4 2.2 2.8 3.2 4.3h-9.6zm15.1-24.7c-10.8 7.3-20.6 18.3-33.3 25.2-6 3.3-27 11.7-33.4 10.2-3.6-.8-3.9-5.3-5.4-9.5-3.1-9-10.1-23.4-10.8-37-.8-17.2-2.5-46 16-42.4 14.9 2.9 32.3 9.7 43.9 16.1 7.1 3.9 11.1 8.6 21.9 9.5-.1 1.4-.1 2.8-.2 4.3-5.9 3.9-15.3 3.8-21.8 7.1 9.5.4 17 2.7 23.5 5.9-.1 3.4-.3 7-.4 10.6zm53.4 24.7h-14c-.1-3.2-2.8-5.8-6.1-5.8s-5.9 2.6-6.1 5.8h-17.4c-2.8-4.4-5.7-8.6-8.9-12.5 2.1-2.2 4-4.7 6-6.9 9 3.7 14.8-4.9 21.7-4.2 7.9.8 14.2 11.7 25.4 11l-.6 12.6zm8.7 0c.2-4 .4-7.8.6-11.5 15.6-7.3 29 1.3 35.7 11.5H383zm83.4-37c-2.3 11.2-5.8 24-9.9 37.1-.2-.1-.4-.1-.6-.1H428c.6-1.1 1.2-2.2 1.9-3.3-2.6-6.1-9-8.7-10.9-15.5 12.1-22.7 6.5-93.4-24.2-78.5 4.3-6.3 15.6-11.5 20.8-19.3 13 10.4 20.8 20.3 33.2 31.4 6.8 6 20 13.3 21.4 23.1.8 5.5-2.6 18.9-3.8 25.1zM222.2 130.5c5.4-14.9 27.2-34.7 45-32 7.7 1.2 18 8.2 12.2 17.7-30.2-7-45.2 12.6-54.4 33.1-8.1-2-4.9-13.1-2.8-18.8zm184.1 63.1c8.2-3.6 22.4-.7 29.6-5.3-4.2-11.5-10.3-21.4-9.3-37.7.5 0 1 0 1.4.1 6.8 14.2 12.7 29.2 21.4 41.7-5.7 13.5-43.6 25.4-43.1 1.2zm20.4-43zm-117.2 45.7c-6.8-10.9-19-32.5-14.5-45.3 6.5 11.9 8.6 24.4 17.8 33.3 4.1 4 12.2 9 8.2 20.2-.9 2.7-7.8 8.6-11.7 9.7-14.4 4.3-47.9.9-36.6-17.1 11.9.7 27.9 7.8 36.8-.8zm27.3 70c3.8 6.6 1.4 18.7 12.1 20.6 20.2 3.4 43.6-12.3 58.1-17.8 9-15.2-.8-20.7-8.9-30.5-16.6-20-38.8-44.8-38-74.7 6.7-4.9 7.3 7.4 8.2 9.7 8.7 20.3 30.4 46.2 46.3 63.5 3.9 4.3 10.3 8.4 11 11.2 2.1 8.2-5.4 18-4.5 23.5-21.7 13.9-45.8 29.1-81.4 25.6-7.4-6.7-10.3-21.4-2.9-31.1zm-201.3-9.2c-6.8-3.9-8.4-21-16.4-21.4-11.4-.7-9.3 22.2-9.3 35.5-7.8-7.1-9.2-29.1-3.5-40.3-6.6-3.2-9.5 3.6-13.1 5.9 4.7-34.1 49.8-15.8 42.3 20.3zm299.6 28.8c-10.1 19.2-24.4 40.4-54 41-.6-6.2-1.1-15.6 0-19.4 22.7-2.2 36.6-13.7 54-21.6zm-141.9 12.4c18.9 9.9 53.6 11 79.3 10.2 1.4 5.6 1.3 12.6 1.4 19.4-33 1.8-72-6.4-80.7-29.6zm92.2 46.7c-1.7 4.3-5.3 9.3-9.8 11.1-12.1 4.9-45.6 8.7-62.4-.3-10.7-5.7-17.5-18.5-23.4-26-2.8-3.6-16.9-12.9-.2-12.9 13.1 32.7 58 29 95.8 28.1z"
                }
            }
        ]
    })(props);
}
function FaJira(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M490 241.7C417.1 169 320.6 71.8 248.5 0 83 164.9 6 241.7 6 241.7c-7.9 7.9-7.9 20.7 0 28.7C138.8 402.7 67.8 331.9 248.5 512c379.4-378 15.7-16.7 241.5-241.7 8-7.9 8-20.7 0-28.6zm-241.5 90l-76-75.7 76-75.7 76 75.7-76 75.7z"
                }
            }
        ]
    })(props);
}
function FaJoget(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M378.1 45C337.6 19.9 292.6 8 248.2 8 165 8 83.8 49.9 36.9 125.9c-71.9 116.6-35.6 269.3 81 341.2s269.3 35.6 341.2-80.9c71.9-116.6 35.6-269.4-81-341.2zm51.8 323.2c-40.4 65.5-110.4 101.5-182 101.5-6.8 0-13.6-.4-20.4-1-9-13.6-19.9-33.3-23.7-42.4-5.7-13.7-27.2-45.6 31.2-67.1 51.7-19.1 176.7-16.5 208.8-17.6-4 9-8.6 17.9-13.9 26.6zm-200.8-86.3c-55.5-1.4-81.7-20.8-58.5-48.2s51.1-40.7 68.9-51.2c17.9-10.5 27.3-33.7-23.6-29.7C87.3 161.5 48.6 252.1 37.6 293c-8.8-49.7-.1-102.7 28.5-149.1C128 43.4 259.6 12.2 360.1 74.1c74.8 46.1 111.2 130.9 99.3 212.7-24.9-.5-179.3-3.6-230.3-4.9zm183.8-54.8c-22.7-6-57 11.3-86.7 27.2-29.7 15.8-31.1 8.2-31.1 8.2s40.2-28.1 50.7-34.5 31.9-14 13.4-24.6c-3.2-1.8-6.7-2.7-10.4-2.7-17.8 0-41.5 18.7-67.5 35.6-31.5 20.5-65.3 31.3-65.3 31.3l169.5-1.6 46.5-23.4s3.6-9.5-19.1-15.5z"
                }
            }
        ]
    })(props);
}
function FaJoomla(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M.6 92.1C.6 58.8 27.4 32 60.4 32c30 0 54.5 21.9 59.2 50.2 32.6-7.6 67.1.6 96.5 30l-44.3 44.3c-20.5-20.5-42.6-16.3-55.4-3.5-14.3 14.3-14.3 37.9 0 52.2l99.5 99.5-44 44.3c-87.7-87.2-49.7-49.7-99.8-99.7-26.8-26.5-35-64.8-24.8-98.9C20.4 144.6.6 120.7.6 92.1zm129.5 116.4l44.3 44.3c10-10 89.7-89.7 99.7-99.8 14.3-14.3 37.6-14.3 51.9 0 12.8 12.8 17 35-3.5 55.4l44 44.3c31.2-31.2 38.5-67.6 28.9-101.2 29.2-4.1 51.9-29.2 51.9-59.5 0-33.2-26.8-60.1-59.8-60.1-30.3 0-55.4 22.5-59.5 51.6-33.8-9.9-71.7-1.5-98.3 25.1-18.3 19.1-71.1 71.5-99.6 99.9zm266.3 152.2c8.2-32.7-.9-68.5-26.3-93.9-11.8-12.2 5 4.7-99.5-99.7l-44.3 44.3 99.7 99.7c14.3 14.3 14.3 37.6 0 51.9-12.8 12.8-35 17-55.4-3.5l-44 44.3c27.6 30.2 68 38.8 102.7 28 5.5 27.4 29.7 48.1 58.9 48.1 33 0 59.8-26.8 59.8-60.1 0-30.2-22.5-55-51.6-59.1zm-84.3-53.1l-44-44.3c-87 86.4-50.4 50.4-99.7 99.8-14.3 14.3-37.6 14.3-51.9 0-13.1-13.4-16.9-35.3 3.2-55.4l-44-44.3c-30.2 30.2-38 65.2-29.5 98.3-26.7 6-46.2 29.9-46.2 58.2C0 453.2 26.8 480 59.8 480c28.6 0 52.5-19.8 58.6-46.7 32.7 8.2 68.5-.6 94.2-26 32.1-32 12.2-12.4 99.5-99.7z"
                }
            }
        ]
    })(props);
}
function FaJsSquare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zM243.8 381.4c0 43.6-25.6 63.5-62.9 63.5-33.7 0-53.2-17.4-63.2-38.5l34.3-20.7c6.6 11.7 12.6 21.6 27.1 21.6 13.8 0 22.6-5.4 22.6-26.5V237.7h42.1v143.7zm99.6 63.5c-39.1 0-64.4-18.6-76.7-43l34.3-19.8c9 14.7 20.8 25.6 41.5 25.6 17.4 0 28.6-8.7 28.6-20.8 0-14.4-11.4-19.5-30.7-28l-10.5-4.5c-30.4-12.9-50.5-29.2-50.5-63.5 0-31.6 24.1-55.6 61.6-55.6 26.8 0 46 9.3 59.8 33.7L368 290c-7.2-12.9-15-18-27.1-18-12.3 0-20.1 7.8-20.1 18 0 12.6 7.8 17.7 25.9 25.6l10.5 4.5c35.8 15.3 55.9 31 55.9 66.2 0 37.8-29.8 58.6-69.7 58.6z"
                }
            }
        ]
    })(props);
}
function FaJs(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 32v448h448V32H0zm243.8 349.4c0 43.6-25.6 63.5-62.9 63.5-33.7 0-53.2-17.4-63.2-38.5l34.3-20.7c6.6 11.7 12.6 21.6 27.1 21.6 13.8 0 22.6-5.4 22.6-26.5V237.7h42.1v143.7zm99.6 63.5c-39.1 0-64.4-18.6-76.7-43l34.3-19.8c9 14.7 20.8 25.6 41.5 25.6 17.4 0 28.6-8.7 28.6-20.8 0-14.4-11.4-19.5-30.7-28l-10.5-4.5c-30.4-12.9-50.5-29.2-50.5-63.5 0-31.6 24.1-55.6 61.6-55.6 26.8 0 46 9.3 59.8 33.7L368 290c-7.2-12.9-15-18-27.1-18-12.3 0-20.1 7.8-20.1 18 0 12.6 7.8 17.7 25.9 25.6l10.5 4.5c35.8 15.3 55.9 31 55.9 66.2 0 37.8-29.8 58.6-69.7 58.6z"
                }
            }
        ]
    })(props);
}
function FaJsfiddle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M510.634 237.462c-4.727-2.621-5.664-5.748-6.381-10.776-2.352-16.488-3.539-33.619-9.097-49.095-35.895-99.957-153.99-143.386-246.849-91.646-27.37 15.25-48.971 36.369-65.493 63.903-3.184-1.508-5.458-2.71-7.824-3.686-30.102-12.421-59.049-10.121-85.331 9.167-25.531 18.737-36.422 44.548-32.676 76.408.355 3.025-1.967 7.621-4.514 9.545-39.712 29.992-56.031 78.065-41.902 124.615 13.831 45.569 57.514 79.796 105.608 81.433 30.291 1.031 60.637.546 90.959.539 84.041-.021 168.09.531 252.12-.48 52.664-.634 96.108-36.873 108.212-87.293 11.54-48.074-11.144-97.3-56.832-122.634zm21.107 156.88c-18.23 22.432-42.343 35.253-71.28 35.65-56.874.781-113.767.23-170.652.23 0 .7-163.028.159-163.728.154-43.861-.332-76.739-19.766-95.175-59.995-18.902-41.245-4.004-90.848 34.186-116.106 9.182-6.073 12.505-11.566 10.096-23.136-5.49-26.361 4.453-47.956 26.42-62.981 22.987-15.723 47.422-16.146 72.034-3.083 10.269 5.45 14.607 11.564 22.198-2.527 14.222-26.399 34.557-46.727 60.671-61.294 97.46-54.366 228.37 7.568 230.24 132.697.122 8.15 2.412 12.428 9.848 15.894 57.56 26.829 74.456 96.122 35.142 144.497zm-87.789-80.499c-5.848 31.157-34.622 55.096-66.666 55.095-16.953-.001-32.058-6.545-44.079-17.705-27.697-25.713-71.141-74.98-95.937-93.387-20.056-14.888-41.99-12.333-60.272 3.782-49.996 44.071 15.859 121.775 67.063 77.188 4.548-3.96 7.84-9.543 12.744-12.844 8.184-5.509 20.766-.884 13.168 10.622-17.358 26.284-49.33 38.197-78.863 29.301-28.897-8.704-48.84-35.968-48.626-70.179 1.225-22.485 12.364-43.06 35.414-55.965 22.575-12.638 46.369-13.146 66.991 2.474C295.68 280.7 320.467 323.97 352.185 343.47c24.558 15.099 54.254 7.363 68.823-17.506 28.83-49.209-34.592-105.016-78.868-63.46-3.989 3.744-6.917 8.932-11.41 11.72-10.975 6.811-17.333-4.113-12.809-10.353 20.703-28.554 50.464-40.44 83.271-28.214 31.429 11.714 49.108 44.366 42.76 78.186z"
                }
            }
        ]
    })(props);
}
function FaKaggle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 320 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M304.2 501.5L158.4 320.3 298.2 185c2.6-2.7 1.7-10.5-5.3-10.5h-69.2c-3.5 0-7 1.8-10.5 5.3L80.9 313.5V7.5q0-7.5-7.5-7.5H21.5Q14 0 14 7.5v497q0 7.5 7.5 7.5h51.9q7.5 0 7.5-7.5v-109l30.8-29.3 110.5 140.6c3 3.5 6.5 5.3 10.5 5.3h66.9q5.25 0 6-3z"
                }
            }
        ]
    })(props);
}
function FaKeybase(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M286.17 419a18 18 0 1 0 18 18 18 18 0 0 0-18-18zm111.92-147.6c-9.5-14.62-39.37-52.45-87.26-73.71q-9.1-4.06-18.38-7.27a78.43 78.43 0 0 0-47.88-104.13c-12.41-4.1-23.33-6-32.41-5.77-.6-2-1.89-11 9.4-35L198.66 32l-5.48 7.56c-8.69 12.06-16.92 23.55-24.34 34.89a51 51 0 0 0-8.29-1.25c-41.53-2.45-39-2.33-41.06-2.33-50.61 0-50.75 52.12-50.75 45.88l-2.36 36.68c-1.61 27 19.75 50.21 47.63 51.85l8.93.54a214 214 0 0 0-46.29 35.54C14 304.66 14 374 14 429.77v33.64l23.32-29.8a148.6 148.6 0 0 0 14.56 37.56c5.78 10.13 14.87 9.45 19.64 7.33 4.21-1.87 10-6.92 3.75-20.11a178.29 178.29 0 0 1-15.76-53.13l46.82-59.83-24.66 74.11c58.23-42.4 157.38-61.76 236.25-38.59 34.2 10.05 67.45.69 84.74-23.84.72-1 1.2-2.16 1.85-3.22a156.09 156.09 0 0 1 2.8 28.43c0 23.3-3.69 52.93-14.88 81.64-2.52 6.46 1.76 14.5 8.6 15.74 7.42 1.57 15.33-3.1 18.37-11.15C429 443 434 414 434 382.32c0-38.58-13-77.46-35.91-110.92zM142.37 128.58l-15.7-.93-1.39 21.79 13.13.78a93 93 0 0 0 .32 19.57l-22.38-1.34a12.28 12.28 0 0 1-11.76-12.79L107 119c1-12.17 13.87-11.27 13.26-11.32l29.11 1.73a144.35 144.35 0 0 0-7 19.17zm148.42 172.18a10.51 10.51 0 0 1-14.35-1.39l-9.68-11.49-34.42 27a8.09 8.09 0 0 1-11.13-1.08l-15.78-18.64a7.38 7.38 0 0 1 1.34-10.34l34.57-27.18-14.14-16.74-17.09 13.45a7.75 7.75 0 0 1-10.59-1s-3.72-4.42-3.8-4.53a7.38 7.38 0 0 1 1.37-10.34L214 225.19s-18.51-22-18.6-22.14a9.56 9.56 0 0 1 1.74-13.42 10.38 10.38 0 0 1 14.3 1.37l81.09 96.32a9.58 9.58 0 0 1-1.74 13.44zM187.44 419a18 18 0 1 0 18 18 18 18 0 0 0-18-18z"
                }
            }
        ]
    })(props);
}
function FaKeycdn(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M63.8 409.3l60.5-59c32.1 42.8 71.1 66 126.6 67.4 30.5.7 60.3-7 86.4-22.4 5.1 5.3 18.5 19.5 20.9 22-32.2 20.7-69.6 31.1-108.1 30.2-43.3-1.1-84.6-16.7-117.7-44.4.3-.6-38.2 37.5-38.6 37.9 9.5 29.8-13.1 62.4-46.3 62.4C20.7 503.3 0 481.7 0 454.9c0-34.3 33.1-56.6 63.8-45.6zm354.9-252.4c19.1 31.3 29.6 67.4 28.7 104-1.1 44.8-19 87.5-48.6 121 .3.3 23.8 25.2 24.1 25.5 9.6-1.3 19.2 2 25.9 9.1 11.3 12 10.9 30.9-1.1 42.4-12 11.3-30.9 10.9-42.4-1.1-6.7-7-9.4-16.8-7.6-26.3-24.9-26.6-44.4-47.2-44.4-47.2 42.7-34.1 63.3-79.6 64.4-124.2.7-28.9-7.2-57.2-21.1-82.2l22.1-21zM104 53.1c6.7 7 9.4 16.8 7.6 26.3l45.9 48.1c-4.7 3.8-13.3 10.4-22.8 21.3-25.4 28.5-39.6 64.8-40.7 102.9-.7 28.9 6.1 57.2 20 82.4l-22 21.5C72.7 324 63.1 287.9 64.2 250.9c1-44.6 18.3-87.6 47.5-121.1l-25.3-26.4c-9.6 1.3-19.2-2-25.9-9.1-11.3-12-10.9-30.9 1.1-42.4C73.5 40.7 92.2 41 104 53.1zM464.9 8c26 0 47.1 22.4 47.1 48.3S490.9 104 464.9 104c-6.3.1-14-1.1-15.9-1.8l-62.9 59.7c-32.7-43.6-76.7-65.9-126.9-67.2-30.5-.7-60.3 6.8-86.2 22.4l-21.1-22C184.1 74.3 221.5 64 260 64.9c43.3 1.1 84.6 16.7 117.7 44.6l41.1-38.6c-1.5-4.7-2.2-9.6-2.2-14.5C416.5 29.7 438.9 8 464.9 8zM256.7 113.4c5.5 0 10.9.4 16.4 1.1 78.1 9.8 133.4 81.1 123.8 159.1-9.8 78.1-81.1 133.4-159.1 123.8-78.1-9.8-133.4-81.1-123.8-159.2 9.3-72.4 70.1-124.6 142.7-124.8zm-59 119.4c.6 22.7 12.2 41.8 32.4 52.2l-11 51.7h73.7l-11-51.7c20.1-10.9 32.1-29 32.4-52.2-.4-32.8-25.8-57.5-58.3-58.3-32.1.8-57.3 24.8-58.2 58.3zM256 160"
                }
            }
        ]
    })(props);
}
function FaKickstarterK(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M147.3 114.4c0-56.2-32.5-82.4-73.4-82.4C26.2 32 0 68.2 0 113.4v283c0 47.3 25.3 83.4 74.9 83.4 39.8 0 72.4-25.6 72.4-83.4v-76.5l112.1 138.3c22.7 27.2 72.1 30.7 103.2 0 27-27.6 27.3-67.4 7.4-92.2l-90.8-114.8 74.9-107.4c17.4-24.7 17.5-63.1-10.4-89.8-30.3-29-82.4-31.6-113.6 12.8L147.3 185v-70.6z"
                }
            }
        ]
    })(props);
}
function FaKickstarter(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M400 480H48c-26.4 0-48-21.6-48-48V80c0-26.4 21.6-48 48-48h352c26.4 0 48 21.6 48 48v352c0 26.4-21.6 48-48 48zM199.6 178.5c0-30.7-17.6-45.1-39.7-45.1-25.8 0-40 19.8-40 44.5v154.8c0 25.8 13.7 45.6 40.5 45.6 21.5 0 39.2-14 39.2-45.6v-41.8l60.6 75.7c12.3 14.9 39 16.8 55.8 0 14.6-15.1 14.8-36.8 4-50.4l-49.1-62.8 40.5-58.7c9.4-13.5 9.5-34.5-5.6-49.1-16.4-15.9-44.6-17.3-61.4 7l-44.8 64.7v-38.8z"
                }
            }
        ]
    })(props);
}
function FaKorvue(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 446 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M386.5 34h-327C26.8 34 0 60.8 0 93.5v327.1C0 453.2 26.8 480 59.5 480h327.1c33 0 59.5-26.8 59.5-59.5v-327C446 60.8 419.2 34 386.5 34zM87.1 120.8h96v116l61.8-116h110.9l-81.2 132H87.1v-132zm161.8 272.1l-65.7-113.6v113.6h-96V262.1h191.5l88.6 130.8H248.9z"
                }
            }
        ]
    })(props);
}
function FaLaravel(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M504.4,115.83a5.72,5.72,0,0,0-.28-.68,8.52,8.52,0,0,0-.53-1.25,6,6,0,0,0-.54-.71,9.36,9.36,0,0,0-.72-.94c-.23-.22-.52-.4-.77-.6a8.84,8.84,0,0,0-.9-.68L404.4,55.55a8,8,0,0,0-8,0L300.12,111h0a8.07,8.07,0,0,0-.88.69,7.68,7.68,0,0,0-.78.6,8.23,8.23,0,0,0-.72.93c-.17.24-.39.45-.54.71a9.7,9.7,0,0,0-.52,1.25c-.08.23-.21.44-.28.68a8.08,8.08,0,0,0-.28,2.08V223.18l-80.22,46.19V63.44a7.8,7.8,0,0,0-.28-2.09c-.06-.24-.2-.45-.28-.68a8.35,8.35,0,0,0-.52-1.24c-.14-.26-.37-.47-.54-.72a9.36,9.36,0,0,0-.72-.94,9.46,9.46,0,0,0-.78-.6,9.8,9.8,0,0,0-.88-.68h0L115.61,1.07a8,8,0,0,0-8,0L11.34,56.49h0a6.52,6.52,0,0,0-.88.69,7.81,7.81,0,0,0-.79.6,8.15,8.15,0,0,0-.71.93c-.18.25-.4.46-.55.72a7.88,7.88,0,0,0-.51,1.24,6.46,6.46,0,0,0-.29.67,8.18,8.18,0,0,0-.28,2.1v329.7a8,8,0,0,0,4,6.95l192.5,110.84a8.83,8.83,0,0,0,1.33.54c.21.08.41.2.63.26a7.92,7.92,0,0,0,4.1,0c.2-.05.37-.16.55-.22a8.6,8.6,0,0,0,1.4-.58L404.4,400.09a8,8,0,0,0,4-6.95V287.88l92.24-53.11a8,8,0,0,0,4-7V117.92A8.63,8.63,0,0,0,504.4,115.83ZM111.6,17.28h0l80.19,46.15-80.2,46.18L31.41,63.44Zm88.25,60V278.6l-46.53,26.79-33.69,19.4V123.5l46.53-26.79Zm0,412.78L23.37,388.5V77.32L57.06,96.7l46.52,26.8V338.68a6.94,6.94,0,0,0,.12.9,8,8,0,0,0,.16,1.18h0a5.92,5.92,0,0,0,.38.9,6.38,6.38,0,0,0,.42,1v0a8.54,8.54,0,0,0,.6.78,7.62,7.62,0,0,0,.66.84l0,0c.23.22.52.38.77.58a8.93,8.93,0,0,0,.86.66l0,0,0,0,92.19,52.18Zm8-106.17-80.06-45.32,84.09-48.41,92.26-53.11,80.13,46.13-58.8,33.56Zm184.52,4.57L215.88,490.11V397.8L346.6,323.2l45.77-26.15Zm0-119.13L358.68,250l-46.53-26.79V131.79l33.69,19.4L392.37,178Zm8-105.28-80.2-46.17,80.2-46.16,80.18,46.15Zm8,105.28V178L455,151.19l33.68-19.4v91.39h0Z"
                }
            }
        ]
    })(props);
}
function FaLastfmSquare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zm-92.2 312.9c-63.4 0-85.4-28.6-97.1-64.1-16.3-51-21.5-84.3-63-84.3-22.4 0-45.1 16.1-45.1 61.2 0 35.2 18 57.2 43.3 57.2 28.6 0 47.6-21.3 47.6-21.3l11.7 31.9s-19.8 19.4-61.2 19.4c-51.3 0-79.9-30.1-79.9-85.8 0-57.9 28.6-92 82.5-92 73.5 0 80.8 41.4 100.8 101.9 8.8 26.8 24.2 46.2 61.2 46.2 24.9 0 38.1-5.5 38.1-19.1 0-19.9-21.8-22-49.9-28.6-30.4-7.3-42.5-23.1-42.5-48 0-40 32.3-52.4 65.2-52.4 37.4 0 60.1 13.6 63 46.6l-36.7 4.4c-1.5-15.8-11-22.4-28.6-22.4-16.1 0-26 7.3-26 19.8 0 11 4.8 17.6 20.9 21.3 32.7 7.1 71.8 12 71.8 57.5.1 36.7-30.7 50.6-76.1 50.6z"
                }
            }
        ]
    })(props);
}
function FaLastfm(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M225.8 367.1l-18.8-51s-30.5 34-76.2 34c-40.5 0-69.2-35.2-69.2-91.5 0-72.1 36.4-97.9 72.1-97.9 66.5 0 74.8 53.3 100.9 134.9 18.8 56.9 54 102.6 155.4 102.6 72.7 0 122-22.3 122-80.9 0-72.9-62.7-80.6-115-92.1-25.8-5.9-33.4-16.4-33.4-34 0-19.9 15.8-31.7 41.6-31.7 28.2 0 43.4 10.6 45.7 35.8l58.6-7c-4.7-52.8-41.1-74.5-100.9-74.5-52.8 0-104.4 19.9-104.4 83.9 0 39.9 19.4 65.1 68 76.8 44.9 10.6 79.8 13.8 79.8 45.7 0 21.7-21.1 30.5-61 30.5-59.2 0-83.9-31.1-97.9-73.9-32-96.8-43.6-163-161.3-163C45.7 113.8 0 168.3 0 261c0 89.1 45.7 137.2 127.9 137.2 66.2 0 97.9-31.1 97.9-31.1z"
                }
            }
        ]
    })(props);
}
function FaLeanpub(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M386.539 111.485l15.096 248.955-10.979-.275c-36.232-.824-71.64 8.783-102.657 27.997-31.016-19.214-66.424-27.997-102.657-27.997-45.564 0-82.07 10.705-123.516 27.723L93.117 129.6c28.546-11.803 61.484-18.115 92.226-18.115 41.173 0 73.836 13.175 102.657 42.544 27.723-28.271 59.013-41.721 98.539-42.544zM569.07 448c-25.526 0-47.485-5.215-70.542-15.645-34.31-15.645-69.993-24.978-107.871-24.978-38.977 0-74.934 12.901-102.657 40.623-27.723-27.723-63.68-40.623-102.657-40.623-37.878 0-73.561 9.333-107.871 24.978C55.239 442.236 32.731 448 8.303 448H6.93L49.475 98.859C88.726 76.626 136.486 64 181.775 64 218.83 64 256.984 71.685 288 93.095 319.016 71.685 357.17 64 394.225 64c45.289 0 93.049 12.626 132.3 34.859L569.07 448zm-43.368-44.741l-34.036-280.246c-30.742-13.999-67.248-21.41-101.009-21.41-38.428 0-74.385 12.077-102.657 38.702-28.272-26.625-64.228-38.702-102.657-38.702-33.761 0-70.267 7.411-101.009 21.41L50.298 403.259c47.211-19.487 82.894-33.486 135.045-33.486 37.604 0 70.817 9.606 102.657 29.644 31.84-20.038 65.052-29.644 102.657-29.644 52.151 0 87.834 13.999 135.045 33.486z"
                }
            }
        ]
    })(props);
}
function FaLess(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M612.7 219c0-20.5 3.2-32.6 3.2-54.6 0-34.2-12.6-45.2-40.5-45.2h-20.5v24.2h6.3c14.2 0 17.3 4.7 17.3 22.1 0 16.3-1.6 32.6-1.6 51.5 0 24.2 7.9 33.6 23.6 37.3v1.6c-15.8 3.7-23.6 13.1-23.6 37.3 0 18.9 1.6 34.2 1.6 51.5 0 17.9-3.7 22.6-17.3 22.6v.5h-6.3V393h20.5c27.8 0 40.5-11 40.5-45.2 0-22.6-3.2-34.2-3.2-54.6 0-11 6.8-22.6 27.3-23.6v-27.3c-20.5-.7-27.3-12.3-27.3-23.3zm-105.6 32c-15.8-6.3-30.5-10-30.5-20.5 0-7.9 6.3-12.6 17.9-12.6s22.1 4.7 33.6 13.1l21-27.8c-13.1-10-31-20.5-55.2-20.5-35.7 0-59.9 20.5-59.9 49.4 0 25.7 22.6 38.9 41.5 46.2 16.3 6.3 32.1 11.6 32.1 22.1 0 7.9-6.3 13.1-20.5 13.1-13.1 0-26.3-5.3-40.5-16.3l-21 30.5c15.8 13.1 39.9 22.1 59.9 22.1 42 0 64.6-22.1 64.6-51s-22.5-41-43-47.8zm-358.9 59.4c-3.7 0-8.4-3.2-8.4-13.1V119.1H65.2c-28.4 0-41 11-41 45.2 0 22.6 3.2 35.2 3.2 54.6 0 11-6.8 22.6-27.3 23.6v27.3c20.5.5 27.3 12.1 27.3 23.1 0 19.4-3.2 31-3.2 53.6 0 34.2 12.6 45.2 40.5 45.2h20.5v-24.2h-6.3c-13.1 0-17.3-5.3-17.3-22.6s1.6-32.1 1.6-51.5c0-24.2-7.9-33.6-23.6-37.3v-1.6c15.8-3.7 23.6-13.1 23.6-37.3 0-18.9-1.6-34.2-1.6-51.5s3.7-22.1 17.3-22.1H93v150.8c0 32.1 11 53.1 43.1 53.1 10 0 17.9-1.6 23.6-3.7l-5.3-34.2c-3.1.8-4.6.8-6.2.8zM379.9 251c-16.3-6.3-31-10-31-20.5 0-7.9 6.3-12.6 17.9-12.6 11.6 0 22.1 4.7 33.6 13.1l21-27.8c-13.1-10-31-20.5-55.2-20.5-35.7 0-59.9 20.5-59.9 49.4 0 25.7 22.6 38.9 41.5 46.2 16.3 6.3 32.1 11.6 32.1 22.1 0 7.9-6.3 13.1-20.5 13.1-13.1 0-26.3-5.3-40.5-16.3l-20.5 30.5c15.8 13.1 39.9 22.1 59.9 22.1 42 0 64.6-22.1 64.6-51 .1-28.9-22.5-41-43-47.8zm-155-68.8c-38.4 0-75.1 32.1-74.1 82.5 0 52 34.2 82.5 79.3 82.5 18.9 0 39.9-6.8 56.2-17.9l-15.8-27.8c-11.6 6.8-22.6 10-34.2 10-21 0-37.3-10-41.5-34.2H290c.5-3.7 1.6-11 1.6-19.4.6-42.6-22.6-75.7-66.7-75.7zm-30 66.2c3.2-21 15.8-31 30.5-31 18.9 0 26.3 13.1 26.3 31h-56.8z"
                }
            }
        ]
    })(props);
}
function FaLine(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M272.1 204.2v71.1c0 1.8-1.4 3.2-3.2 3.2h-11.4c-1.1 0-2.1-.6-2.6-1.3l-32.6-44v42.2c0 1.8-1.4 3.2-3.2 3.2h-11.4c-1.8 0-3.2-1.4-3.2-3.2v-71.1c0-1.8 1.4-3.2 3.2-3.2H219c1 0 2.1.5 2.6 1.4l32.6 44v-42.2c0-1.8 1.4-3.2 3.2-3.2h11.4c1.8-.1 3.3 1.4 3.3 3.1zm-82-3.2h-11.4c-1.8 0-3.2 1.4-3.2 3.2v71.1c0 1.8 1.4 3.2 3.2 3.2h11.4c1.8 0 3.2-1.4 3.2-3.2v-71.1c0-1.7-1.4-3.2-3.2-3.2zm-27.5 59.6h-31.1v-56.4c0-1.8-1.4-3.2-3.2-3.2h-11.4c-1.8 0-3.2 1.4-3.2 3.2v71.1c0 .9.3 1.6.9 2.2.6.5 1.3.9 2.2.9h45.7c1.8 0 3.2-1.4 3.2-3.2v-11.4c0-1.7-1.4-3.2-3.1-3.2zM332.1 201h-45.7c-1.7 0-3.2 1.4-3.2 3.2v71.1c0 1.7 1.4 3.2 3.2 3.2h45.7c1.8 0 3.2-1.4 3.2-3.2v-11.4c0-1.8-1.4-3.2-3.2-3.2H301v-12h31.1c1.8 0 3.2-1.4 3.2-3.2V234c0-1.8-1.4-3.2-3.2-3.2H301v-12h31.1c1.8 0 3.2-1.4 3.2-3.2v-11.4c-.1-1.7-1.5-3.2-3.2-3.2zM448 113.7V399c-.1 44.8-36.8 81.1-81.7 81H81c-44.8-.1-81.1-36.9-81-81.7V113c.1-44.8 36.9-81.1 81.7-81H367c44.8.1 81.1 36.8 81 81.7zm-61.6 122.6c0-73-73.2-132.4-163.1-132.4-89.9 0-163.1 59.4-163.1 132.4 0 65.4 58 120.2 136.4 130.6 19.1 4.1 16.9 11.1 12.6 36.8-.7 4.1-3.3 16.1 14.1 8.8 17.4-7.3 93.9-55.3 128.2-94.7 23.6-26 34.9-52.3 34.9-81.5z"
                }
            }
        ]
    })(props);
}
function FaLinkedinIn(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M100.28 448H7.4V148.9h92.88zM53.79 108.1C24.09 108.1 0 83.5 0 53.8a53.79 53.79 0 0 1 107.58 0c0 29.7-24.1 54.3-53.79 54.3zM447.9 448h-92.68V302.4c0-34.7-.7-79.2-48.29-79.2-48.29 0-55.69 37.7-55.69 76.7V448h-92.78V148.9h89.08v40.8h1.3c12.4-23.5 42.69-48.3 87.88-48.3 94 0 111.28 61.9 111.28 142.3V448z"
                }
            }
        ]
    })(props);
}
function FaLinkedin(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M416 32H31.9C14.3 32 0 46.5 0 64.3v383.4C0 465.5 14.3 480 31.9 480H416c17.6 0 32-14.5 32-32.3V64.3c0-17.8-14.4-32.3-32-32.3zM135.4 416H69V202.2h66.5V416zm-33.2-243c-21.3 0-38.5-17.3-38.5-38.5S80.9 96 102.2 96c21.2 0 38.5 17.3 38.5 38.5 0 21.3-17.2 38.5-38.5 38.5zm282.1 243h-66.4V312c0-24.8-.5-56.7-34.5-56.7-34.6 0-39.9 27-39.9 54.9V416h-66.4V202.2h63.7v29.2h.9c8.9-16.8 30.6-34.5 62.9-34.5 67.2 0 79.7 44.3 79.7 101.9V416z"
                }
            }
        ]
    })(props);
}
function FaLinode(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M437.4 226.3c-.3-.9-.9-1.4-1.4-2l-70-38.6c-.9-.6-2-.6-3.1 0l-58.9 36c-.9.6-1.4 1.7-1.4 2.6l-.9 31.4-24-16c-.9-.6-2.3-.6-3.1 0L240 260.9l-1.4-35.1c0-.9-.6-2-1.4-2.3l-36-24.3 33.7-17.4c1.1-.6 1.7-1.7 1.7-2.9l-5.7-132.3c0-.9-.9-2-1.7-2.6L138.6.3c-.9-.3-1.7-.3-2.3-.3L12.6 38.6c-1.4.6-2.3 2-2 3.7L38 175.4c.9 3.4 34 27.4 38.6 30.9l-26.9 12.9c-1.4.9-2 2.3-1.7 3.4l20.6 100.3c.6 2.9 23.7 23.1 27.1 26.3l-17.4 10.6c-.9.6-1.7 2-1.4 3.1 1.4 7.1 15.4 77.7 16.9 79.1l65.1 69.1c.6.6 1.4.6 2.3.9.6 0 1.1-.3 1.7-.6l83.7-66.9c.9-.6 1.1-1.4 1.1-2.3l-2-46 28 23.7c1.1.9 2.9.9 4 0l66.9-53.4c.9-.6 1.1-1.4 1.1-2.3l2.3-33.4 20.3 14c1.1.9 2.6.9 3.7 0l54.6-43.7c.6-.3 1.1-1.1 1.1-2 .9-6.5 10.3-70.8 9.7-72.8zm-204.8 4.8l4 92.6-90.6 61.2-14-96.6 100.6-57.2zm-7.7-180l5.4 126-106.6 55.4L104 97.7l120.9-46.6zM44 173.1L18 48l79.7 49.4 19.4 132.9L44 173.1zm30.6 147.8L55.7 230l70 58.3 13.7 93.4-64.8-60.8zm24.3 117.7l-13.7-67.1 61.7 60.9 9.7 67.4-57.7-61.2zm64.5 64.5l-10.6-70.9 85.7-61.4 3.1 70-78.2 62.3zm82-115.1c0-3.4.9-22.9-2-25.1l-24.3-20 22.3-14.9c2.3-1.7 1.1-5.7 1.1-8l29.4 22.6.6 68.3-27.1-22.9zm94.3-25.4l-60.9 48.6-.6-68.6 65.7-46.9-4.2 66.9zm27.7-25.7l-19.1-13.4 2-34c.3-.9-.3-2-1.1-2.6L308 259.7l.6-30 64.6 40.6-5.8 66.6zm54.6-39.8l-48.3 38.3 5.7-65.1 51.1-36.6-8.5 63.4z"
                }
            }
        ]
    })(props);
}
function FaLinux(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M220.8 123.3c1 .5 1.8 1.7 3 1.7 1.1 0 2.8-.4 2.9-1.5.2-1.4-1.9-2.3-3.2-2.9-1.7-.7-3.9-1-5.5-.1-.4.2-.8.7-.6 1.1.3 1.3 2.3 1.1 3.4 1.7zm-21.9 1.7c1.2 0 2-1.2 3-1.7 1.1-.6 3.1-.4 3.5-1.6.2-.4-.2-.9-.6-1.1-1.6-.9-3.8-.6-5.5.1-1.3.6-3.4 1.5-3.2 2.9.1 1 1.8 1.5 2.8 1.4zM420 403.8c-3.6-4-5.3-11.6-7.2-19.7-1.8-8.1-3.9-16.8-10.5-22.4-1.3-1.1-2.6-2.1-4-2.9-1.3-.8-2.7-1.5-4.1-2 9.2-27.3 5.6-54.5-3.7-79.1-11.4-30.1-31.3-56.4-46.5-74.4-17.1-21.5-33.7-41.9-33.4-72C311.1 85.4 315.7.1 234.8 0 132.4-.2 158 103.4 156.9 135.2c-1.7 23.4-6.4 41.8-22.5 64.7-18.9 22.5-45.5 58.8-58.1 96.7-6 17.9-8.8 36.1-6.2 53.3-6.5 5.8-11.4 14.7-16.6 20.2-4.2 4.3-10.3 5.9-17 8.3s-14 6-18.5 14.5c-2.1 3.9-2.8 8.1-2.8 12.4 0 3.9.6 7.9 1.2 11.8 1.2 8.1 2.5 15.7.8 20.8-5.2 14.4-5.9 24.4-2.2 31.7 3.8 7.3 11.4 10.5 20.1 12.3 17.3 3.6 40.8 2.7 59.3 12.5 19.8 10.4 39.9 14.1 55.9 10.4 11.6-2.6 21.1-9.6 25.9-20.2 12.5-.1 26.3-5.4 48.3-6.6 14.9-1.2 33.6 5.3 55.1 4.1.6 2.3 1.4 4.6 2.5 6.7v.1c8.3 16.7 23.8 24.3 40.3 23 16.6-1.3 34.1-11 48.3-27.9 13.6-16.4 36-23.2 50.9-32.2 7.4-4.5 13.4-10.1 13.9-18.3.4-8.2-4.4-17.3-15.5-29.7zM223.7 87.3c9.8-22.2 34.2-21.8 44-.4 6.5 14.2 3.6 30.9-4.3 40.4-1.6-.8-5.9-2.6-12.6-4.9 1.1-1.2 3.1-2.7 3.9-4.6 4.8-11.8-.2-27-9.1-27.3-7.3-.5-13.9 10.8-11.8 23-4.1-2-9.4-3.5-13-4.4-1-6.9-.3-14.6 2.9-21.8zM183 75.8c10.1 0 20.8 14.2 19.1 33.5-3.5 1-7.1 2.5-10.2 4.6 1.2-8.9-3.3-20.1-9.6-19.6-8.4.7-9.8 21.2-1.8 28.1 1 .8 1.9-.2-5.9 5.5-15.6-14.6-10.5-52.1 8.4-52.1zm-13.6 60.7c6.2-4.6 13.6-10 14.1-10.5 4.7-4.4 13.5-14.2 27.9-14.2 7.1 0 15.6 2.3 25.9 8.9 6.3 4.1 11.3 4.4 22.6 9.3 8.4 3.5 13.7 9.7 10.5 18.2-2.6 7.1-11 14.4-22.7 18.1-11.1 3.6-19.8 16-38.2 14.9-3.9-.2-7-1-9.6-2.1-8-3.5-12.2-10.4-20-15-8.6-4.8-13.2-10.4-14.7-15.3-1.4-4.9 0-9 4.2-12.3zm3.3 334c-2.7 35.1-43.9 34.4-75.3 18-29.9-15.8-68.6-6.5-76.5-21.9-2.4-4.7-2.4-12.7 2.6-26.4v-.2c2.4-7.6.6-16-.6-23.9-1.2-7.8-1.8-15 .9-20 3.5-6.7 8.5-9.1 14.8-11.3 10.3-3.7 11.8-3.4 19.6-9.9 5.5-5.7 9.5-12.9 14.3-18 5.1-5.5 10-8.1 17.7-6.9 8.1 1.2 15.1 6.8 21.9 16l19.6 35.6c9.5 19.9 43.1 48.4 41 68.9zm-1.4-25.9c-4.1-6.6-9.6-13.6-14.4-19.6 7.1 0 14.2-2.2 16.7-8.9 2.3-6.2 0-14.9-7.4-24.9-13.5-18.2-38.3-32.5-38.3-32.5-13.5-8.4-21.1-18.7-24.6-29.9s-3-23.3-.3-35.2c5.2-22.9 18.6-45.2 27.2-59.2 2.3-1.7.8 3.2-8.7 20.8-8.5 16.1-24.4 53.3-2.6 82.4.6-20.7 5.5-41.8 13.8-61.5 12-27.4 37.3-74.9 39.3-112.7 1.1.8 4.6 3.2 6.2 4.1 4.6 2.7 8.1 6.7 12.6 10.3 12.4 10 28.5 9.2 42.4 1.2 6.2-3.5 11.2-7.5 15.9-9 9.9-3.1 17.8-8.6 22.3-15 7.7 30.4 25.7 74.3 37.2 95.7 6.1 11.4 18.3 35.5 23.6 64.6 3.3-.1 7 .4 10.9 1.4 13.8-35.7-11.7-74.2-23.3-84.9-4.7-4.6-4.9-6.6-2.6-6.5 12.6 11.2 29.2 33.7 35.2 59 2.8 11.6 3.3 23.7.4 35.7 16.4 6.8 35.9 17.9 30.7 34.8-2.2-.1-3.2 0-4.2 0 3.2-10.1-3.9-17.6-22.8-26.1-19.6-8.6-36-8.6-38.3 12.5-12.1 4.2-18.3 14.7-21.4 27.3-2.8 11.2-3.6 24.7-4.4 39.9-.5 7.7-3.6 18-6.8 29-32.1 22.9-76.7 32.9-114.3 7.2zm257.4-11.5c-.9 16.8-41.2 19.9-63.2 46.5-13.2 15.7-29.4 24.4-43.6 25.5s-26.5-4.8-33.7-19.3c-4.7-11.1-2.4-23.1 1.1-36.3 3.7-14.2 9.2-28.8 9.9-40.6.8-15.2 1.7-28.5 4.2-38.7 2.6-10.3 6.6-17.2 13.7-21.1.3-.2.7-.3 1-.5.8 13.2 7.3 26.6 18.8 29.5 12.6 3.3 30.7-7.5 38.4-16.3 9-.3 15.7-.9 22.6 5.1 9.9 8.5 7.1 30.3 17.1 41.6 10.6 11.6 14 19.5 13.7 24.6zM173.3 148.7c2 1.9 4.7 4.5 8 7.1 6.6 5.2 15.8 10.6 27.3 10.6 11.6 0 22.5-5.9 31.8-10.8 4.9-2.6 10.9-7 14.8-10.4s5.9-6.3 3.1-6.6-2.6 2.6-6 5.1c-4.4 3.2-9.7 7.4-13.9 9.8-7.4 4.2-19.5 10.2-29.9 10.2s-18.7-4.8-24.9-9.7c-3.1-2.5-5.7-5-7.7-6.9-1.5-1.4-1.9-4.6-4.3-4.9-1.4-.1-1.8 3.7 1.7 6.5z"
                }
            }
        ]
    })(props);
}
function FaLyft(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 81.1h77.8v208.7c0 33.1 15 52.8 27.2 61-12.7 11.1-51.2 20.9-80.2-2.8C7.8 334 0 310.7 0 289V81.1zm485.9 173.5v-22h23.8v-76.8h-26.1c-10.1-46.3-51.2-80.7-100.3-80.7-56.6 0-102.7 46-102.7 102.7V357c16 2.3 35.4-.3 51.7-14 17.1-14 24.8-37.2 24.8-59v-6.7h38.8v-76.8h-38.8v-23.3c0-34.6 52.2-34.6 52.2 0v77.1c0 56.6 46 102.7 102.7 102.7v-76.5c-14.5 0-26.1-11.7-26.1-25.9zm-294.3-99v113c0 15.4-23.8 15.4-23.8 0v-113H91v132.7c0 23.8 8 54 45 63.9 37 9.8 58.2-10.6 58.2-10.6-2.1 13.4-14.5 23.3-34.9 25.3-15.5 1.6-35.2-3.6-45-7.8v70.3c25.1 7.5 51.5 9.8 77.6 4.7 47.1-9.1 76.8-48.4 76.8-100.8V155.1h-77.1v.5z"
                }
            }
        ]
    })(props);
}
function FaMagento(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M445.7 127.9V384l-63.4 36.5V164.7L223.8 73.1 65.2 164.7l.4 255.9L2.3 384V128.1L224.2 0l221.5 127.9zM255.6 420.5L224 438.9l-31.8-18.2v-256l-63.3 36.6.1 255.9 94.9 54.9 95.1-54.9v-256l-63.4-36.6v255.9z"
                }
            }
        ]
    })(props);
}
function FaMailchimp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M330.61 243.52a36.15 36.15 0 0 1 9.3 0c1.66-3.83 1.95-10.43.45-17.61-2.23-10.67-5.25-17.14-11.48-16.13s-6.47 8.74-4.24 19.42c1.26 6 3.49 11.14 6 14.32zM277.05 252c4.47 2 7.2 3.26 8.28 2.13 1.89-1.94-3.48-9.39-12.12-13.09a31.44 31.44 0 0 0-30.61 3.68c-3 2.18-5.81 5.22-5.41 7.06.85 3.74 10-2.71 22.6-3.48 7-.44 12.8 1.75 17.26 3.71zm-9 5.13c-9.07 1.42-15 6.53-13.47 10.1.9.34 1.17.81 5.21-.81a37 37 0 0 1 18.72-1.95c2.92.34 4.31.52 4.94-.49 1.46-2.22-5.71-8-15.39-6.85zm54.17 17.1c3.38-6.87-10.9-13.93-14.3-7s10.92 13.88 14.32 6.97zm15.66-20.47c-7.66-.13-7.95 15.8-.26 15.93s7.98-15.81.28-15.96zm-218.79 78.9c-1.32.31-6 1.45-8.47-2.35-5.2-8 11.11-20.38 3-35.77-9.1-17.47-27.82-13.54-35.05-5.54-8.71 9.6-8.72 23.54-5 24.08 4.27.57 4.08-6.47 7.38-11.63a12.83 12.83 0 0 1 17.85-3.72c11.59 7.59 1.37 17.76 2.28 28.62 1.39 16.68 18.42 16.37 21.58 9a2.08 2.08 0 0 0-.2-2.33c.03.89.68-1.3-3.35-.39zm299.72-17.07c-3.35-11.73-2.57-9.22-6.78-20.52 2.45-3.67 15.29-24-3.07-43.25-10.4-10.92-33.9-16.54-41.1-18.54-1.5-11.39 4.65-58.7-21.52-83 20.79-21.55 33.76-45.29 33.73-65.65-.06-39.16-48.15-51-107.42-26.47l-12.55 5.33c-.06-.05-22.71-22.27-23.05-22.57C169.5-18-41.77 216.81 25.78 273.85l14.76 12.51a72.49 72.49 0 0 0-4.1 33.5c3.36 33.4 36 60.42 67.53 60.38 57.73 133.06 267.9 133.28 322.29 3 1.74-4.47 9.11-24.61 9.11-42.38s-10.09-25.27-16.53-25.27zm-316 48.16c-22.82-.61-47.46-21.15-49.91-45.51-6.17-61.31 74.26-75.27 84-12.33 4.54 29.64-4.67 58.49-34.12 57.81zM84.3 249.55C69.14 252.5 55.78 261.09 47.6 273c-4.88-4.07-14-12-15.59-15-13.01-24.85 14.24-73 33.3-100.21C112.42 90.56 186.19 39.68 220.36 48.91c5.55 1.57 23.94 22.89 23.94 22.89s-34.15 18.94-65.8 45.35c-42.66 32.85-74.89 80.59-94.2 132.4zM323.18 350.7s-35.74 5.3-69.51-7.07c6.21-20.16 27 6.1 96.4-13.81 15.29-4.38 35.37-13 51-25.35a102.85 102.85 0 0 1 7.12 24.28c3.66-.66 14.25-.52 11.44 18.1-3.29 19.87-11.73 36-25.93 50.84A106.86 106.86 0 0 1 362.55 421a132.45 132.45 0 0 1-20.34 8.58c-53.51 17.48-108.3-1.74-126-43a66.33 66.33 0 0 1-3.55-9.74c-7.53-27.2-1.14-59.83 18.84-80.37 1.23-1.31 2.48-2.85 2.48-4.79a8.45 8.45 0 0 0-1.92-4.54c-7-10.13-31.19-27.4-26.33-60.83 3.5-24 24.49-40.91 44.07-39.91l5 .29c8.48.5 15.89 1.59 22.88 1.88 11.69.5 22.2-1.19 34.64-11.56 4.2-3.5 7.57-6.54 13.26-7.51a17.45 17.45 0 0 1 13.6 2.24c10 6.64 11.4 22.73 11.92 34.49.29 6.72 1.1 23 1.38 27.63.63 10.67 3.43 12.17 9.11 14 3.19 1.05 6.15 1.83 10.51 3.06 13.21 3.71 21 7.48 26 12.31a16.38 16.38 0 0 1 4.74 9.29c1.56 11.37-8.82 25.4-36.31 38.16-46.71 21.68-93.68 14.45-100.48 13.68-20.15-2.71-31.63 23.32-19.55 41.15 22.64 33.41 122.4 20 151.37-21.35.69-1 .12-1.59-.73-1-41.77 28.58-97.06 38.21-128.46 26-4.77-1.85-14.73-6.44-15.94-16.67 43.6 13.49 71 .74 71 .74s2.03-2.79-.56-2.53zm-68.47-5.7zm-83.4-187.5c16.74-19.35 37.36-36.18 55.83-45.63a.73.73 0 0 1 1 1c-1.46 2.66-4.29 8.34-5.19 12.65a.75.75 0 0 0 1.16.79c11.49-7.83 31.48-16.22 49-17.3a.77.77 0 0 1 .52 1.38 41.86 41.86 0 0 0-7.71 7.74.75.75 0 0 0 .59 1.19c12.31.09 29.66 4.4 41 10.74.76.43.22 1.91-.64 1.72-69.55-15.94-123.08 18.53-134.5 26.83a.76.76 0 0 1-1-1.12z"
                }
            }
        ]
    })(props);
}
function FaMandalorian(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M232.27 511.89c-1-3.26-1.69-15.83-1.39-24.58.55-15.89 1-24.72 1.4-28.76.64-6.2 2.87-20.72 3.28-21.38.6-1 .4-27.87-.24-33.13-.31-2.58-.63-11.9-.69-20.73-.13-16.47-.53-20.12-2.73-24.76-1.1-2.32-1.23-3.84-1-11.43a92.38 92.38 0 0 0-.34-12.71c-2-13-3.46-27.7-3.25-33.9s.43-7.15 2.06-9.67c3.05-4.71 6.51-14 8.62-23.27 2.26-9.86 3.88-17.18 4.59-20.74a109.54 109.54 0 0 1 4.42-15.05c2.27-6.25 2.49-15.39.37-15.39-.3 0-1.38 1.22-2.41 2.71s-4.76 4.8-8.29 7.36c-8.37 6.08-11.7 9.39-12.66 12.58s-1 7.23-.16 7.76c.34.21 1.29 2.4 2.11 4.88a28.83 28.83 0 0 1 .72 15.36c-.39 1.77-1 5.47-1.46 8.23s-1 6.46-1.25 8.22a9.85 9.85 0 0 1-1.55 4.26c-1 1-1.14.91-2.05-.53a14.87 14.87 0 0 1-1.44-4.75c-.25-1.74-1.63-7.11-3.08-11.93-3.28-10.9-3.52-16.15-1-21a14.24 14.24 0 0 0 1.67-4.61c0-2.39-2.2-5.32-7.41-9.89-7-6.18-8.63-7.92-10.23-11.3-1.71-3.6-3.06-4.06-4.54-1.54-1.78 3-2.6 9.11-3 22l-.34 12.19 2 2.25c3.21 3.7 12.07 16.45 13.78 19.83 3.41 6.74 4.34 11.69 4.41 23.56s.95 22.75 2 24.71c.36.66.51 1.35.34 1.52s.41 2.09 1.29 4.27a38.14 38.14 0 0 1 2.06 9 91 91 0 0 0 1.71 10.37c2.23 9.56 2.77 14.08 2.39 20.14-.2 3.27-.53 11.07-.73 17.32-1.31 41.76-1.85 58-2 61.21-.12 2-.39 11.51-.6 21.07-.36 16.3-1.3 27.37-2.42 28.65-.64.73-8.07-4.91-12.52-9.49-3.75-3.87-4-4.79-2.83-9.95.7-3 2.26-18.29 3.33-32.62.36-4.78.81-10.5 1-12.71.83-9.37 1.66-20.35 2.61-34.78.56-8.46 1.33-16.44 1.72-17.73s.89-9.89 1.13-19.11l.43-16.77-2.26-4.3c-1.72-3.28-4.87-6.94-13.22-15.34-6-6.07-11.84-12.3-12.91-13.85l-1.95-2.81.75-10.9c1.09-15.71 1.1-48.57 0-59.06l-.89-8.7-3.28-4.52c-5.86-8.08-5.8-7.75-6.22-33.27-.1-6.07-.38-11.5-.63-12.06-.83-1.87-3.05-2.66-8.54-3.05-8.86-.62-11-1.9-23.85-14.55-6.15-6-12.34-12-13.75-13.19-2.81-2.42-2.79-2-.56-9.63l1.35-4.65-1.69-3a32.22 32.22 0 0 0-2.59-4.07c-1.33-1.51-5.5-10.89-6-13.49a4.24 4.24 0 0 1 .87-3.9c2.23-2.86 3.4-5.68 4.45-10.73 2.33-11.19 7.74-26.09 10.6-29.22 3.18-3.47 7.7-1 9.41 5 1.34 4.79 1.37 9.79.1 18.55a101.2 101.2 0 0 0-1 11.11c0 4 .19 4.69 2.25 7.39 3.33 4.37 7.73 7.41 15.2 10.52a18.67 18.67 0 0 1 4.72 2.85c11.17 10.72 18.62 16.18 22.95 16.85 5.18.8 8 4.54 10 13.39 1.31 5.65 4 11.14 5.46 11.14a9.38 9.38 0 0 0 3.33-1.39c2-1.22 2.25-1.73 2.25-4.18a132.88 132.88 0 0 0-2-17.84c-.37-1.66-.78-4.06-.93-5.35s-.61-3.85-1-5.69c-2.55-11.16-3.65-15.46-4.1-16-1.55-2-4.08-10.2-4.93-15.92-1.64-11.11-4-14.23-12.91-17.39A43.15 43.15 0 0 1 165.24 78c-1.15-1-4-3.22-6.35-5.06s-4.41-3.53-4.6-3.76a22.7 22.7 0 0 0-2.69-2c-6.24-4.22-8.84-7-11.26-12l-2.44-5-.22-13-.22-13 6.91-6.55c3.95-3.75 8.48-7.35 10.59-8.43 3.31-1.69 4.45-1.89 11.37-2 8.53-.19 10.12 0 11.66 1.56s1.36 6.4-.29 8.5a6.66 6.66 0 0 0-1.34 2.32c0 .58-2.61 4.91-5.42 9a30.39 30.39 0 0 0-2.37 6.82c20.44 13.39 21.55 3.77 14.07 29L194 66.92c3.11-8.66 6.47-17.26 8.61-26.22.29-7.63-12-4.19-15.4-8.68-2.33-5.93 3.13-14.18 6.06-19.2 1.6-2.34 6.62-4.7 8.82-4.15.88.22 4.16-.35 7.37-1.28a45.3 45.3 0 0 1 7.55-1.68 29.57 29.57 0 0 0 6-1.29c3.65-1.11 4.5-1.17 6.35-.4a29.54 29.54 0 0 0 5.82 1.36 18.18 18.18 0 0 1 6 1.91 22.67 22.67 0 0 0 5 2.17c2.51.68 3 .57 7.05-1.67l4.35-2.4L268.32 5c10.44-.4 10.81-.47 15.26-2.68L288.16 0l2.46 1.43c1.76 1 3.14 2.73 4.85 6 2.36 4.51 2.38 4.58 1.37 7.37-.88 2.44-.89 3.3-.1 6.39a35.76 35.76 0 0 0 2.1 5.91 13.55 13.55 0 0 1 1.31 4c.31 4.33 0 5.3-2.41 6.92-2.17 1.47-7 7.91-7 9.34a14.77 14.77 0 0 1-1.07 3c-5 11.51-6.76 13.56-14.26 17-9.2 4.2-12.3 5.19-16.21 5.19-3.1 0-4 .25-4.54 1.26a18.33 18.33 0 0 1-4.09 3.71 13.62 13.62 0 0 0-4.38 4.78 5.89 5.89 0 0 1-2.49 2.91 6.88 6.88 0 0 0-2.45 1.71 67.62 67.62 0 0 1-7 5.38c-3.33 2.34-6.87 5-7.87 6A7.27 7.27 0 0 1 224 100a5.76 5.76 0 0 0-2.13 1.65c-1.31 1.39-1.49 2.11-1.14 4.6a36.45 36.45 0 0 0 1.42 5.88c1.32 3.8 1.31 7.86 0 10.57s-.89 6.65 1.35 9.59c2 2.63 2.16 4.56.71 8.84a33.45 33.45 0 0 0-1.06 8.91c0 4.88.22 6.28 1.46 8.38s1.82 2.48 3.24 2.32c2-.23 2.3-1.05 4.71-12.12 2.18-10 3.71-11.92 13.76-17.08 2.94-1.51 7.46-4 10-5.44s6.79-3.69 9.37-4.91a40.09 40.09 0 0 0 15.22-11.67c7.11-8.79 10-16.22 12.85-33.3a18.37 18.37 0 0 1 2.86-7.73 20.39 20.39 0 0 0 2.89-7.31c1-5.3 2.85-9.08 5.58-11.51 4.7-4.18 6-1.09 4.59 10.87-.46 3.86-1.1 10.33-1.44 14.38l-.61 7.36 4.45 4.09 4.45 4.09.11 8.42c.06 4.63.47 9.53.92 10.89l.82 2.47-6.43 6.28c-8.54 8.33-12.88 13.93-16.76 21.61-1.77 3.49-3.74 7.11-4.38 8-2.18 3.11-6.46 13-8.76 20.26l-2.29 7.22-7 6.49c-3.83 3.57-8 7.25-9.17 8.17-3.05 2.32-4.26 5.15-4.26 10a14.62 14.62 0 0 0 1.59 7.26 42 42 0 0 1 2.09 4.83 9.28 9.28 0 0 0 1.57 2.89c1.4 1.59 1.92 16.12.83 23.22-.68 4.48-3.63 12-4.7 12-1.79 0-4.06 9.27-5.07 20.74-.18 2-.62 5.94-1 8.7s-1 10-1.35 16.05c-.77 12.22-.19 18.77 2 23.15 3.41 6.69.52 12.69-11 22.84l-4 3.49.07 5.19a40.81 40.81 0 0 0 1.14 8.87c4.61 16 4.73 16.92 4.38 37.13-.46 26.4-.26 40.27.63 44.15a61.31 61.31 0 0 1 1.08 7c.17 2 .66 5.33 1.08 7.36.47 2.26.78 11 .79 22.74v19.06l-1.81 2.63c-2.71 3.91-15.11 13.54-15.49 12.29zm29.53-45.11c-.18-.3-.33-6.87-.33-14.59 0-14.06-.89-27.54-2.26-34.45-.4-2-.81-9.7-.9-17.06-.15-11.93-1.4-24.37-2.64-26.38-.66-1.07-3-17.66-3-21.3 0-4.23 1-6 5.28-9.13s4.86-3.14 5.48-.72c.28 1.1 1.45 5.62 2.6 10 3.93 15.12 4.14 16.27 4.05 21.74-.1 5.78-.13 6.13-1.74 17.73-1 7.07-1.17 12.39-1 28.43.17 19.4-.64 35.73-2 41.27-.71 2.78-2.8 5.48-3.43 4.43zm-71-37.58a101 101 0 0 1-1.73-10.79 100.5 100.5 0 0 0-1.73-10.79 37.53 37.53 0 0 1-1-6.49c-.31-3.19-.91-7.46-1.33-9.48-1-4.79-3.35-19.35-3.42-21.07 0-.74-.34-4.05-.7-7.36-.67-6.21-.84-27.67-.22-28.29 1-1 6.63 2.76 11.33 7.43l5.28 5.25-.45 6.47c-.25 3.56-.6 10.23-.78 14.83s-.49 9.87-.67 11.71-.61 9.36-.94 16.72c-.79 17.41-1.94 31.29-2.65 32a.62.62 0 0 1-1-.14zm-87.18-266.59c21.07 12.79 17.84 14.15 28.49 17.66 13 4.29 18.87 7.13 23.15 16.87C111.6 233.28 86.25 255 78.55 268c-31 52-6 101.59 62.75 87.21-14.18 29.23-78 28.63-98.68-4.9-24.68-39.95-22.09-118.3 61-187.66zm210.79 179c56.66 6.88 82.32-37.74 46.54-89.23 0 0-26.87-29.34-64.28-68 3-15.45 9.49-32.12 30.57-53.82 89.2 63.51 92 141.61 92.46 149.36 4.3 70.64-78.7 91.18-105.29 61.71z"
                }
            }
        ]
    })(props);
}
function FaMarkdown(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M593.8 59.1H46.2C20.7 59.1 0 79.8 0 105.2v301.5c0 25.5 20.7 46.2 46.2 46.2h547.7c25.5 0 46.2-20.7 46.1-46.1V105.2c0-25.4-20.7-46.1-46.2-46.1zM338.5 360.6H277v-120l-61.5 76.9-61.5-76.9v120H92.3V151.4h61.5l61.5 76.9 61.5-76.9h61.5v209.2zm135.3 3.1L381.5 256H443V151.4h61.5V256H566z"
                }
            }
        ]
    })(props);
}
function FaMastodon(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M433 179.11c0-97.2-63.71-125.7-63.71-125.7-62.52-28.7-228.56-28.4-290.48 0 0 0-63.72 28.5-63.72 125.7 0 115.7-6.6 259.4 105.63 289.1 40.51 10.7 75.32 13 103.33 11.4 50.81-2.8 79.32-18.1 79.32-18.1l-1.7-36.9s-36.31 11.4-77.12 10.1c-40.41-1.4-83-4.4-89.63-54a102.54 102.54 0 0 1-.9-13.9c85.63 20.9 158.65 9.1 178.75 6.7 56.12-6.7 105-41.3 111.23-72.9 9.8-49.8 9-121.5 9-121.5zm-75.12 125.2h-46.63v-114.2c0-49.7-64-51.6-64 6.9v62.5h-46.33V197c0-58.5-64-56.6-64-6.9v114.2H90.19c0-122.1-5.2-147.9 18.41-175 25.9-28.9 79.82-30.8 103.83 6.1l11.6 19.5 11.6-19.5c24.11-37.1 78.12-34.8 103.83-6.1 23.71 27.3 18.4 53 18.4 175z"
                }
            }
        ]
    })(props);
}
function FaMaxcdn(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M461.1 442.7h-97.4L415.6 200c2.3-10.2.9-19.5-4.4-25.7-5-6.1-13.7-9.6-24.2-9.6h-49.3l-59.5 278h-97.4l59.5-278h-83.4l-59.5 278H0l59.5-278-44.6-95.4H387c39.4 0 75.3 16.3 98.3 44.9 23.3 28.6 31.8 67.4 23.6 105.9l-47.8 222.6z"
                }
            }
        ]
    })(props);
}
function FaMdb(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M17.37 160.41L7 352h43.91l5.59-79.83L84.43 352h44.71l25.54-77.43 4.79 77.43H205l-12.79-191.59H146.7L106 277.74 63.67 160.41zm281 0h-47.9V352h47.9s95 .8 94.2-95.79c-.78-94.21-94.18-95.78-94.18-95.78zm-1.2 146.46V204.78s46 4.27 46.8 50.57-46.78 51.54-46.78 51.54zm238.29-74.24a56.16 56.16 0 0 0 8-38.31c-5.34-35.76-55.08-34.32-55.08-34.32h-51.9v191.58H482s87 4.79 87-63.85c0-43.14-33.52-55.08-33.52-55.08zm-51.9-31.94s13.57-1.59 16 9.59c1.43 6.66-4 12-4 12h-12v-21.57zm-.1 109.46l.1-24.92V267h.08s41.58-4.73 41.19 22.43c-.33 25.65-41.35 20.74-41.35 20.74z"
                }
            }
        ]
    })(props);
}
function FaMedapps(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 320 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M118.3 238.4c3.5-12.5 6.9-33.6 13.2-33.6 8.3 1.8 9.6 23.4 18.6 36.6 4.6-23.5 5.3-85.1 14.1-86.7 9-.7 19.7 66.5 22 77.5 9.9 4.1 48.9 6.6 48.9 6.6 1.9 7.3-24 7.6-40 7.8-4.6 14.8-5.4 27.7-11.4 28-4.7.2-8.2-28.8-17.5-49.6l-9.4 65.5c-4.4 13-15.5-22.5-21.9-39.3-3.3-.1-62.4-1.6-47.6-7.8l31-5zM228 448c21.2 0 21.2-32 0-32H92c-21.2 0-21.2 32 0 32h136zm-24 64c21.2 0 21.2-32 0-32h-88c-21.2 0-21.2 32 0 32h88zm34.2-141.5c3.2-18.9 5.2-36.4 11.9-48.8 7.9-14.7 16.1-28.1 24-41 24.6-40.4 45.9-75.2 45.9-125.5C320 69.6 248.2 0 160 0S0 69.6 0 155.2c0 50.2 21.3 85.1 45.9 125.5 7.9 12.9 16 26.3 24 41 6.7 12.5 8.7 29.8 11.9 48.9 3.5 21 36.1 15.7 32.6-5.1-3.6-21.7-5.6-40.7-15.3-58.6C66.5 246.5 33 211.3 33 155.2 33 87.3 90 32 160 32s127 55.3 127 123.2c0 56.1-33.5 91.3-66.1 151.6-9.7 18-11.7 37.4-15.3 58.6-3.4 20.6 29 26.4 32.6 5.1z"
                }
            }
        ]
    })(props);
}
function FaMediumM(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M71.5 142.3c.6-5.9-1.7-11.8-6.1-15.8L20.3 72.1V64h140.2l108.4 237.7L364.2 64h133.7v8.1l-38.6 37c-3.3 2.5-5 6.7-4.3 10.8v272c-.7 4.1 1 8.3 4.3 10.8l37.7 37v8.1H307.3v-8.1l39.1-37.9c3.8-3.8 3.8-5 3.8-10.8V171.2L241.5 447.1h-14.7L100.4 171.2v184.9c-1.1 7.8 1.5 15.6 7 21.2l50.8 61.6v8.1h-144v-8L65 377.3c5.4-5.6 7.9-13.5 6.5-21.2V142.3z"
                }
            }
        ]
    })(props);
}
function FaMedium(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 32v448h448V32H0zm372.2 106.1l-24 23c-2.1 1.6-3.1 4.2-2.7 6.7v169.3c-.4 2.6.6 5.2 2.7 6.7l23.5 23v5.1h-118V367l24.3-23.6c2.4-2.4 2.4-3.1 2.4-6.7V199.8l-67.6 171.6h-9.1L125 199.8v115c-.7 4.8 1 9.7 4.4 13.2l31.6 38.3v5.1H71.2v-5.1l31.6-38.3c3.4-3.5 4.9-8.4 4.1-13.2v-133c.4-3.7-1-7.3-3.8-9.8L75 138.1V133h87.3l67.4 148L289 133.1h83.2v5z"
                }
            }
        ]
    })(props);
}
function FaMedrt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 544 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M113.7 256c0 121.8 83.9 222.8 193.5 241.1-18.7 4.5-38.2 6.9-58.2 6.9C111.4 504 0 393 0 256S111.4 8 248.9 8c20.1 0 39.6 2.4 58.2 6.9C197.5 33.2 113.7 134.2 113.7 256m297.4 100.3c-77.7 55.4-179.6 47.5-240.4-14.6 5.5 14.1 12.7 27.7 21.7 40.5 61.6 88.2 182.4 109.3 269.7 47 87.3-62.3 108.1-184.3 46.5-272.6-9-12.9-19.3-24.3-30.5-34.2 37.4 78.8 10.7 178.5-67 233.9m-218.8-244c-1.4 1-2.7 2.1-4 3.1 64.3-17.8 135.9 4 178.9 60.5 35.7 47 42.9 106.6 24.4 158 56.7-56.2 67.6-142.1 22.3-201.8-50-65.5-149.1-74.4-221.6-19.8M296 224c-4.4 0-8-3.6-8-8v-40c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v40c0 4.4-3.6 8-8 8h-40c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h40c4.4 0 8 3.6 8 8v40c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8v-40c0-4.4 3.6-8 8-8h40c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8h-40z"
                }
            }
        ]
    })(props);
}
function FaMeetup(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M99 414.3c1.1 5.7-2.3 11.1-8 12.3-5.4 1.1-10.9-2.3-12-8-1.1-5.4 2.3-11.1 7.7-12.3 5.4-1.2 11.1 2.3 12.3 8zm143.1 71.4c-6.3 4.6-8 13.4-3.7 20 4.6 6.6 13.4 8.3 20 3.7 6.3-4.6 8-13.4 3.4-20-4.2-6.5-13.1-8.3-19.7-3.7zm-86-462.3c6.3-1.4 10.3-7.7 8.9-14-1.1-6.6-7.4-10.6-13.7-9.1-6.3 1.4-10.3 7.7-9.1 14 1.4 6.6 7.6 10.6 13.9 9.1zM34.4 226.3c-10-6.9-23.7-4.3-30.6 6-6.9 10-4.3 24 5.7 30.9 10 7.1 23.7 4.6 30.6-5.7 6.9-10.4 4.3-24.1-5.7-31.2zm272-170.9c10.6-6.3 13.7-20 7.7-30.3-6.3-10.6-19.7-14-30-7.7s-13.7 20-7.4 30.6c6 10.3 19.4 13.7 29.7 7.4zm-191.1 58c7.7-5.4 9.4-16 4.3-23.7s-15.7-9.4-23.1-4.3c-7.7 5.4-9.4 16-4.3 23.7 5.1 7.8 15.6 9.5 23.1 4.3zm372.3 156c-7.4 1.7-12.3 9.1-10.6 16.9 1.4 7.4 8.9 12.3 16.3 10.6 7.4-1.4 12.3-8.9 10.6-16.6-1.5-7.4-8.9-12.3-16.3-10.9zm39.7-56.8c-1.1-5.7-6.6-9.1-12-8-5.7 1.1-9.1 6.9-8 12.6 1.1 5.4 6.6 9.1 12.3 8 5.4-1.5 9.1-6.9 7.7-12.6zM447 138.9c-8.6 6-10.6 17.7-4.9 26.3 5.7 8.6 17.4 10.6 26 4.9 8.3-6 10.3-17.7 4.6-26.3-5.7-8.7-17.4-10.9-25.7-4.9zm-6.3 139.4c26.3 43.1 15.1 100-26.3 129.1-17.4 12.3-37.1 17.7-56.9 17.1-12 47.1-69.4 64.6-105.1 32.6-1.1.9-2.6 1.7-3.7 2.9-39.1 27.1-92.3 17.4-119.4-22.3-9.7-14.3-14.6-30.6-15.1-46.9-65.4-10.9-90-94-41.1-139.7-28.3-46.9.6-107.4 53.4-114.9C151.6 70 234.1 38.6 290.1 82c67.4-22.3 136.3 29.4 130.9 101.1 41.1 12.6 52.8 66.9 19.7 95.2zm-70 74.3c-3.1-20.6-40.9-4.6-43.1-27.1-3.1-32 43.7-101.1 40-128-3.4-24-19.4-29.1-33.4-29.4-13.4-.3-16.9 2-21.4 4.6-2.9 1.7-6.6 4.9-11.7-.3-6.3-6-11.1-11.7-19.4-12.9-12.3-2-17.7 2-26.6 9.7-3.4 2.9-12 12.9-20 9.1-3.4-1.7-15.4-7.7-24-11.4-16.3-7.1-40 4.6-48.6 20-12.9 22.9-38 113.1-41.7 125.1-8.6 26.6 10.9 48.6 36.9 47.1 11.1-.6 18.3-4.6 25.4-17.4 4-7.4 41.7-107.7 44.6-112.6 2-3.4 8.9-8 14.6-5.1 5.7 3.1 6.9 9.4 6 15.1-1.1 9.7-28 70.9-28.9 77.7-3.4 22.9 26.9 26.6 38.6 4 3.7-7.1 45.7-92.6 49.4-98.3 4.3-6.3 7.4-8.3 11.7-8 3.1 0 8.3.9 7.1 10.9-1.4 9.4-35.1 72.3-38.9 87.7-4.6 20.6 6.6 41.4 24.9 50.6 11.4 5.7 62.5 15.7 58.5-11.1zm5.7 92.3c-10.3 7.4-12.9 22-5.7 32.6 7.1 10.6 21.4 13.1 32 6 10.6-7.4 13.1-22 6-32.6-7.4-10.6-21.7-13.5-32.3-6z"
                }
            }
        ]
    })(props);
}
function FaMegaport(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M214.5 209.6v66.2l33.5 33.5 33.3-33.3v-66.4l-33.4-33.4zM248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm145.1 414.4L367 441.6l-26-19.2v-65.5l-33.4-33.4-33.4 33.4v65.5L248 441.6l-26.1-19.2v-65.5l-33.4-33.4-33.5 33.4v65.5l-26.1 19.2-26.1-19.2v-87l59.5-59.5V188l59.5-59.5V52.9l26.1-19.2L274 52.9v75.6l59.5 59.5v87.6l59.7 59.7v87.1z"
                }
            }
        ]
    })(props);
}
function FaMendeley(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M624.6 325.2c-12.3-12.4-29.7-19.2-48.4-17.2-43.3-1-49.7-34.9-37.5-98.8 22.8-57.5-14.9-131.5-87.4-130.8-77.4.7-81.7 82-130.9 82-48.1 0-54-81.3-130.9-82-72.9-.8-110.1 73.3-87.4 130.8 12.2 63.9 5.8 97.8-37.5 98.8-21.2-2.3-37 6.5-53 22.5-19.9 19.7-19.3 94.8 42.6 102.6 47.1 5.9 81.6-42.9 61.2-87.8-47.3-103.7 185.9-106.1 146.5-8.2-.1.1-.2.2-.3.4-26.8 42.8 6.8 97.4 58.8 95.2 52.1 2.1 85.4-52.6 58.8-95.2-.1-.2-.2-.3-.3-.4-39.4-97.9 193.8-95.5 146.5 8.2-4.6 10-6.7 21.3-5.7 33 4.9 53.4 68.7 74.1 104.9 35.2 17.8-14.8 23.1-65.6 0-88.3zm-303.9-19.1h-.6c-43.4 0-62.8-37.5-62.8-62.8 0-34.7 28.2-62.8 62.8-62.8h.6c34.7 0 62.8 28.1 62.8 62.8 0 25-19.2 62.8-62.8 62.8z"
                }
            }
        ]
    })(props);
}
function FaMicroblog(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M399.36,362.23c29.49-34.69,47.1-78.34,47.1-125.79C446.46,123.49,346.86,32,224,32S1.54,123.49,1.54,236.44,101.14,440.87,224,440.87a239.28,239.28,0,0,0,79.44-13.44,7.18,7.18,0,0,1,8.12,2.56c18.58,25.09,47.61,42.74,79.89,49.92a4.42,4.42,0,0,0,5.22-3.43,4.37,4.37,0,0,0-.85-3.62,87,87,0,0,1,3.69-110.69ZM329.52,212.4l-57.3,43.49L293,324.75a6.5,6.5,0,0,1-9.94,7.22L224,290.92,164.94,332a6.51,6.51,0,0,1-9.95-7.22l20.79-68.86-57.3-43.49a6.5,6.5,0,0,1,3.8-11.68l71.88-1.51,23.66-67.92a6.5,6.5,0,0,1,12.28,0l23.66,67.92,71.88,1.51a6.5,6.5,0,0,1,3.88,11.68Z"
                }
            }
        ]
    })(props);
}
function FaMicrosoft(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 32h214.6v214.6H0V32zm233.4 0H448v214.6H233.4V32zM0 265.4h214.6V480H0V265.4zm233.4 0H448V480H233.4V265.4z"
                }
            }
        ]
    })(props);
}
function FaMix(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 64v348.9c0 56.2 88 58.1 88 0V174.3c7.9-52.9 88-50.4 88 6.5v175.3c0 57.9 96 58 96 0V240c5.3-54.7 88-52.5 88 4.3v23.8c0 59.9 88 56.6 88 0V64H0z"
                }
            }
        ]
    })(props);
}
function FaMixcloud(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M424.43 219.729C416.124 134.727 344.135 68 256.919 68c-72.266 0-136.224 46.516-159.205 114.074-54.545 8.029-96.63 54.822-96.63 111.582 0 62.298 50.668 112.966 113.243 112.966h289.614c52.329 0 94.969-42.362 94.969-94.693 0-45.131-32.118-83.063-74.48-92.2zm-20.489 144.53H114.327c-39.04 0-70.881-31.564-70.881-70.604s31.841-70.604 70.881-70.604c18.827 0 36.548 7.475 49.838 20.766 19.963 19.963 50.133-10.227 30.18-30.18-14.675-14.398-32.672-24.365-52.053-29.349 19.935-44.3 64.79-73.926 114.628-73.926 69.496 0 125.979 56.483 125.979 125.702 0 13.568-2.215 26.857-6.369 39.594-8.943 27.517 32.133 38.939 40.147 13.29 2.769-8.306 4.984-16.889 6.369-25.472 19.381 7.476 33.502 26.303 33.502 48.453 0 28.795-23.535 52.33-52.607 52.33zm235.069-52.33c0 44.024-12.737 86.386-37.102 122.657-4.153 6.092-10.798 9.414-17.72 9.414-16.317 0-27.127-18.826-17.443-32.949 19.381-29.349 29.903-63.682 29.903-99.122s-10.521-69.773-29.903-98.845c-15.655-22.831 19.361-47.24 35.163-23.534 24.366 35.993 37.102 78.356 37.102 122.379zm-70.88 0c0 31.565-9.137 62.021-26.857 88.325-4.153 6.091-10.798 9.136-17.72 9.136-17.201 0-27.022-18.979-17.443-32.948 13.013-19.104 19.658-41.255 19.658-64.513 0-22.981-6.645-45.408-19.658-64.512-15.761-22.986 19.008-47.095 35.163-23.535 17.719 26.026 26.857 56.483 26.857 88.047z"
                }
            }
        ]
    })(props);
}
function FaMixer(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M114.57,76.07a45.71,45.71,0,0,0-67.51-6.41c-17.58,16.18-19,43.52-4.75,62.77l91.78,123L41.76,379.58c-14.23,19.25-13.11,46.59,4.74,62.77A45.71,45.71,0,0,0,114,435.94L242.89,262.7a12.14,12.14,0,0,0,0-14.23ZM470.24,379.58,377.91,255.45l91.78-123c14.22-19.25,12.83-46.59-4.75-62.77a45.71,45.71,0,0,0-67.51,6.41l-128,172.12a12.14,12.14,0,0,0,0,14.23L398,435.94a45.71,45.71,0,0,0,67.51,6.41C483.35,426.17,484.47,398.83,470.24,379.58Z"
                }
            }
        ]
    })(props);
}
function FaMizuni(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111 8 0 119.1 0 256c0 137 111 248 248 248s248-111 248-248C496 119.1 385 8 248 8zm-80 351.9c-31.4 10.6-58.8 27.3-80 48.2V136c0-22.1 17.9-40 40-40s40 17.9 40 40v223.9zm120-9.9c-12.9-2-26.2-3.1-39.8-3.1-13.8 0-27.2 1.1-40.2 3.1V136c0-22.1 17.9-40 40-40s40 17.9 40 40v214zm120 57.7c-21.2-20.8-48.6-37.4-80-48V136c0-22.1 17.9-40 40-40s40 17.9 40 40v271.7z"
                }
            }
        ]
    })(props);
}
function FaModx(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M356 241.8l36.7 23.7V480l-133-83.8L356 241.8zM440 75H226.3l-23 37.8 153.5 96.5L440 75zm-89 142.8L55.2 32v214.5l46 29L351 217.8zM97 294.2L8 437h213.7l125-200.5L97 294.2z"
                }
            }
        ]
    })(props);
}
function FaMonero(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M352 384h108.4C417 455.9 338.1 504 248 504S79 455.9 35.6 384H144V256.2L248 361l104-105v128zM88 336V128l159.4 159.4L408 128v208h74.8c8.5-25.1 13.2-52 13.2-80C496 119 385 8 248 8S0 119 0 256c0 28 4.6 54.9 13.2 80H88z"
                }
            }
        ]
    })(props);
}
function FaNapster(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M298.3 373.6c-14.2 13.6-31.3 24.1-50.4 30.5-19-6.4-36.2-16.9-50.3-30.5h100.7zm44-199.6c20-16.9 43.6-29.2 69.6-36.2V299c0 219.4-328 217.6-328 .3V137.7c25.9 6.9 49.6 19.6 69.5 36.4 56.8-40 132.5-39.9 188.9-.1zm-208.8-58.5c64.4-60 164.3-60.1 228.9-.2-7.1 3.5-13.9 7.3-20.6 11.5-58.7-30.5-129.2-30.4-187.9.1-6.3-4-13.9-8.2-20.4-11.4zM43.8 93.2v69.3c-58.4 36.5-58.4 121.1.1 158.3 26.4 245.1 381.7 240.3 407.6 1.5l.3-1.7c58.7-36.3 58.9-121.7.2-158.2V93.2c-17.3.5-34 3-50.1 7.4-82-91.5-225.5-91.5-307.5.1-16.3-4.4-33.1-7-50.6-7.5zM259.2 352s36-.3 61.3-1.5c10.2-.5 21.1-4 25.5-6.5 26.3-15.1 25.4-39.2 26.2-47.4-79.5-.6-99.9-3.9-113 55.4zm-135.5-55.3c.8 8.2-.1 32.3 26.2 47.4 4.4 2.5 15.2 6 25.5 6.5 25.3 1.1 61.3 1.5 61.3 1.5-13.2-59.4-33.7-56.1-113-55.4zm169.1 123.4c-3.2-5.3-6.9-7.3-6.9-7.3-24.8 7.3-52.2 6.9-75.9 0 0 0-2.9 1.5-6.4 6.6-2.8 4.1-3.7 9.6-3.7 9.6 29.1 17.6 67.1 17.6 96.2 0-.1-.1-.3-4-3.3-8.9z"
                }
            }
        ]
    })(props);
}
function FaNeos(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M415.44 512h-95.11L212.12 357.46v91.1L125.69 512H28V29.82L68.47 0h108.05l123.74 176.13V63.45L386.69 0h97.69v461.5zM38.77 35.27V496l72-52.88V194l215.5 307.64h84.79l52.35-38.17h-78.27L69 13zm82.54 466.61l80-58.78v-101l-79.76-114.4v220.94L49 501.89h72.34zM80.63 10.77l310.6 442.57h82.37V10.77h-79.75v317.56L170.91 10.77zM311 191.65l72 102.81V15.93l-72 53v122.72z"
                }
            }
        ]
    })(props);
}
function FaNimblr(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M246.6 299.29c15.57 0 27.15 11.46 27.15 27s-11.62 27-27.15 27c-15.7 0-27.15-11.57-27.15-27s11.55-27 27.15-27zM113 326.25c0-15.61 11.68-27 27.15-27s27.15 11.46 27.15 27-11.47 27-27.15 27c-15.44 0-27.15-11.31-27.15-27M191.76 159C157 159 89.45 178.77 59.25 227L14 0v335.48C14 433.13 93.61 512 191.76 512s177.76-78.95 177.76-176.52S290.13 159 191.76 159zm0 308.12c-73.27 0-132.51-58.9-132.51-131.59s59.24-131.59 132.51-131.59 132.51 58.86 132.51 131.54S265 467.07 191.76 467.07z"
                }
            }
        ]
    })(props);
}
function FaNodeJs(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M224 508c-6.7 0-13.5-1.8-19.4-5.2l-61.7-36.5c-9.2-5.2-4.7-7-1.7-8 12.3-4.3 14.8-5.2 27.9-12.7 1.4-.8 3.2-.5 4.6.4l47.4 28.1c1.7 1 4.1 1 5.7 0l184.7-106.6c1.7-1 2.8-3 2.8-5V149.3c0-2.1-1.1-4-2.9-5.1L226.8 37.7c-1.7-1-4-1-5.7 0L36.6 144.3c-1.8 1-2.9 3-2.9 5.1v213.1c0 2 1.1 4 2.9 4.9l50.6 29.2c27.5 13.7 44.3-2.4 44.3-18.7V167.5c0-3 2.4-5.3 5.4-5.3h23.4c2.9 0 5.4 2.3 5.4 5.3V378c0 36.6-20 57.6-54.7 57.6-10.7 0-19.1 0-42.5-11.6l-48.4-27.9C8.1 389.2.7 376.3.7 362.4V149.3c0-13.8 7.4-26.8 19.4-33.7L204.6 9c11.7-6.6 27.2-6.6 38.8 0l184.7 106.7c12 6.9 19.4 19.8 19.4 33.7v213.1c0 13.8-7.4 26.7-19.4 33.7L243.4 502.8c-5.9 3.4-12.6 5.2-19.4 5.2zm149.1-210.1c0-39.9-27-50.5-83.7-58-57.4-7.6-63.2-11.5-63.2-24.9 0-11.1 4.9-25.9 47.4-25.9 37.9 0 51.9 8.2 57.7 33.8.5 2.4 2.7 4.2 5.2 4.2h24c1.5 0 2.9-.6 3.9-1.7s1.5-2.6 1.4-4.1c-3.7-44.1-33-64.6-92.2-64.6-52.7 0-84.1 22.2-84.1 59.5 0 40.4 31.3 51.6 81.8 56.6 60.5 5.9 65.2 14.8 65.2 26.7 0 20.6-16.6 29.4-55.5 29.4-48.9 0-59.6-12.3-63.2-36.6-.4-2.6-2.6-4.5-5.3-4.5h-23.9c-3 0-5.3 2.4-5.3 5.3 0 31.1 16.9 68.2 97.8 68.2 58.4-.1 92-23.2 92-63.4z"
                }
            }
        ]
    })(props);
}
function FaNode(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M316.3 452c-2.1 0-4.2-.6-6.1-1.6L291 439c-2.9-1.6-1.5-2.2-.5-2.5 3.8-1.3 4.6-1.6 8.7-4 .4-.2 1-.1 1.4.1l14.8 8.8c.5.3 1.3.3 1.8 0L375 408c.5-.3.9-.9.9-1.6v-66.7c0-.7-.3-1.3-.9-1.6l-57.8-33.3c-.5-.3-1.2-.3-1.8 0l-57.8 33.3c-.6.3-.9 1-.9 1.6v66.7c0 .6.4 1.2.9 1.5l15.8 9.1c8.6 4.3 13.9-.8 13.9-5.8v-65.9c0-.9.7-1.7 1.7-1.7h7.3c.9 0 1.7.7 1.7 1.7v65.9c0 11.5-6.2 18-17.1 18-3.3 0-6 0-13.3-3.6l-15.2-8.7c-3.7-2.2-6.1-6.2-6.1-10.5v-66.7c0-4.3 2.3-8.4 6.1-10.5l57.8-33.4c3.7-2.1 8.5-2.1 12.1 0l57.8 33.4c3.7 2.2 6.1 6.2 6.1 10.5v66.7c0 4.3-2.3 8.4-6.1 10.5l-57.8 33.4c-1.7 1.1-3.8 1.7-6 1.7zm46.7-65.8c0-12.5-8.4-15.8-26.2-18.2-18-2.4-19.8-3.6-19.8-7.8 0-3.5 1.5-8.1 14.8-8.1 11.9 0 16.3 2.6 18.1 10.6.2.8.8 1.3 1.6 1.3h7.5c.5 0 .9-.2 1.2-.5.3-.4.5-.8.4-1.3-1.2-13.8-10.3-20.2-28.8-20.2-16.5 0-26.3 7-26.3 18.6 0 12.7 9.8 16.1 25.6 17.7 18.9 1.9 20.4 4.6 20.4 8.3 0 6.5-5.2 9.2-17.4 9.2-15.3 0-18.7-3.8-19.8-11.4-.1-.8-.8-1.4-1.7-1.4h-7.5c-.9 0-1.7.7-1.7 1.7 0 9.7 5.3 21.3 30.6 21.3 18.5 0 29-7.2 29-19.8zm54.5-50.1c0 6.1-5 11.1-11.1 11.1s-11.1-5-11.1-11.1c0-6.3 5.2-11.1 11.1-11.1 6-.1 11.1 4.8 11.1 11.1zm-1.8 0c0-5.2-4.2-9.3-9.4-9.3-5.1 0-9.3 4.1-9.3 9.3 0 5.2 4.2 9.4 9.3 9.4 5.2-.1 9.4-4.3 9.4-9.4zm-4.5 6.2h-2.6c-.1-.6-.5-3.8-.5-3.9-.2-.7-.4-1.1-1.3-1.1h-2.2v5h-2.4v-12.5h4.3c1.5 0 4.4 0 4.4 3.3 0 2.3-1.5 2.8-2.4 3.1 1.7.1 1.8 1.2 2.1 2.8.1 1 .3 2.7.6 3.3zm-2.8-8.8c0-1.7-1.2-1.7-1.8-1.7h-2v3.5h1.9c1.6 0 1.9-1.1 1.9-1.8zM137.3 191c0-2.7-1.4-5.1-3.7-6.4l-61.3-35.3c-1-.6-2.2-.9-3.4-1h-.6c-1.2 0-2.3.4-3.4 1L3.7 184.6C1.4 185.9 0 188.4 0 191l.1 95c0 1.3.7 2.5 1.8 3.2 1.1.7 2.5.7 3.7 0L42 268.3c2.3-1.4 3.7-3.8 3.7-6.4v-44.4c0-2.6 1.4-5.1 3.7-6.4l15.5-8.9c1.2-.7 2.4-1 3.7-1 1.3 0 2.6.3 3.7 1l15.5 8.9c2.3 1.3 3.7 3.8 3.7 6.4v44.4c0 2.6 1.4 5.1 3.7 6.4l36.4 20.9c1.1.7 2.6.7 3.7 0 1.1-.6 1.8-1.9 1.8-3.2l.2-95zM472.5 87.3v176.4c0 2.6-1.4 5.1-3.7 6.4l-61.3 35.4c-2.3 1.3-5.1 1.3-7.4 0l-61.3-35.4c-2.3-1.3-3.7-3.8-3.7-6.4v-70.8c0-2.6 1.4-5.1 3.7-6.4l61.3-35.4c2.3-1.3 5.1-1.3 7.4 0l15.3 8.8c1.7 1 3.9-.3 3.9-2.2v-94c0-2.8 3-4.6 5.5-3.2l36.5 20.4c2.3 1.2 3.8 3.7 3.8 6.4zm-46 128.9c0-.7-.4-1.3-.9-1.6l-21-12.2c-.6-.3-1.3-.3-1.9 0l-21 12.2c-.6.3-.9.9-.9 1.6v24.3c0 .7.4 1.3.9 1.6l21 12.1c.6.3 1.3.3 1.8 0l21-12.1c.6-.3.9-.9.9-1.6v-24.3zm209.8-.7c2.3-1.3 3.7-3.8 3.7-6.4V192c0-2.6-1.4-5.1-3.7-6.4l-60.9-35.4c-2.3-1.3-5.1-1.3-7.4 0l-61.3 35.4c-2.3 1.3-3.7 3.8-3.7 6.4v70.8c0 2.7 1.4 5.1 3.7 6.4l60.9 34.7c2.2 1.3 5 1.3 7.3 0l36.8-20.5c2.5-1.4 2.5-5 0-6.4L550 241.6c-1.2-.7-1.9-1.9-1.9-3.2v-22.2c0-1.3.7-2.5 1.9-3.2l19.2-11.1c1.1-.7 2.6-.7 3.7 0l19.2 11.1c1.1.7 1.9 1.9 1.9 3.2v17.4c0 2.8 3.1 4.6 5.6 3.2l36.7-21.3zM559 219c-.4.3-.7.7-.7 1.2v13.6c0 .5.3 1 .7 1.2l11.8 6.8c.4.3 1 .3 1.4 0L584 235c.4-.3.7-.7.7-1.2v-13.6c0-.5-.3-1-.7-1.2l-11.8-6.8c-.4-.3-1-.3-1.4 0L559 219zm-254.2 43.5v-70.4c0-2.6-1.6-5.1-3.9-6.4l-61.1-35.2c-2.1-1.2-5-1.4-7.4 0l-61.1 35.2c-2.3 1.3-3.9 3.7-3.9 6.4v70.4c0 2.8 1.9 5.2 4 6.4l61.2 35.2c2.4 1.4 5.2 1.3 7.4 0l61-35.2c1.8-1 3.1-2.7 3.6-4.7.1-.5.2-1.1.2-1.7zm-74.3-124.9l-.8.5h1.1l-.3-.5zm76.2 130.2l-.4-.7v.9l.4-.2z"
                }
            }
        ]
    })(props);
}
function FaNpm(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M288 288h-32v-64h32v64zm288-128v192H288v32H160v-32H0V160h576zm-416 32H32v128h64v-96h32v96h32V192zm160 0H192v160h64v-32h64V192zm224 0H352v128h64v-96h32v96h32v-96h32v96h32V192z"
                }
            }
        ]
    })(props);
}
function FaNs8(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M104.324,269.172h26.067V242.994H104.324Zm52.466-26.178-.055-26.178v-.941a39.325,39.325,0,0,0-78.644.941v.166h26.4v-.166a12.98,12.98,0,0,1,25.956,0v26.178Zm52.356,25.846a91.1,91.1,0,0,1-91.1,91.1h-.609a91.1,91.1,0,0,1-91.1-91.1H0v.166A117.33,117.33,0,0,0,117.44,386.28h.775A117.331,117.331,0,0,0,235.49,268.84V242.828H209.146Zm-157.233,0a65.362,65.362,0,0,0,130.723,0H156.292a39.023,39.023,0,0,1-78.035,0V242.883H51.968v-26.62A65.42,65.42,0,0,1,182.8,217.48v25.293h26.344V217.48a91.761,91.761,0,0,0-183.522,0v25.4H51.913Zm418.4-71.173c13.67,0,24.573,6.642,30.052,18.264l.719,1.549,23.245-11.511-.609-1.439c-8.025-19.26-28.5-31.27-53.407-31.27-23.134,0-43.611,11.4-50.972,28.447-.123,26.876-.158,23.9,0,24.85,4.7,11.013,14.555,19.37,28.668,24.241a102.033,102.033,0,0,0,19.813,3.984c5.479.72,10.626,1.384,15.829,3.1,6.364,2.1,10.46,5.257,12.84,9.851v9.851c-3.708,7.527-13.781,12.342-25.791,12.342-14.334,0-25.956-6.918-31.933-19.039l-.72-1.494L415.026,280.9l.553,1.439c7.915,19.426,29.609,32.044,55.289,32.044,23.632,0,44.608-11.4,52.3-28.447l.166-25.9-.166-.664c-4.87-11.014-15.219-19.647-28.944-24.241-7.693-2.712-14.335-3.6-20.7-4.427a83.777,83.777,0,0,1-14.832-2.878c-6.31-1.937-10.4-5.092-12.619-9.63v-8.412C449.45,202.427,458.969,197.667,470.315,197.667ZM287.568,311.344h26.067v-68.4H287.568Zm352.266-53.3c-2.933-6.254-8.3-12.01-15.441-16.714A37.99,37.99,0,0,0,637.4,226l.166-25.347-.166-.664C630.038,184,610.667,173.26,589.25,173.26S548.461,184,541.1,199.992l-.166,25.347.166.664a39.643,39.643,0,0,0,13.006,15.331c-7.2,4.7-12.508,10.46-15.441,16.714l-.166,28.889.166.72c7.582,15.994,27.893,26.731,50.585,26.731s43.057-10.737,50.584-26.731l.166-28.89Zm-73.22-50.806c3.6-6.31,12.563-10.516,22.58-10.516s19.038,4.206,22.636,10.516v13.725c-3.542,6.2-12.563,10.349-22.636,10.349s-19.094-4.15-22.58-10.349Zm47.319,72.169c-3.764,6.641-13.338,10.9-24.683,10.9-11.125,0-20.976-4.372-24.684-10.9V263.25c3.708-6.309,13.5-10.515,24.684-10.515,11.345,0,20.919,4.15,24.683,10.515ZM376.4,265.962l-59.827-89.713h-29v40.623h26.51v.387l62.539,94.085H402.3V176.249H376.4Z"
                }
            }
        ]
    })(props);
}
function FaNutritionix(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 400 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M88 8.1S221.4-.1 209 112.5c0 0 19.1-74.9 103-40.6 0 0-17.7 74-88 56 0 0 14.6-54.6 66.1-56.6 0 0-39.9-10.3-82.1 48.8 0 0-19.8-94.5-93.6-99.7 0 0 75.2 19.4 77.6 107.5 0 .1-106.4 7-104-119.8zm312 315.6c0 48.5-9.7 95.3-32 132.3-42.2 30.9-105 48-168 48-62.9 0-125.8-17.1-168-48C9.7 419 0 372.2 0 323.7 0 275.3 17.7 229 40 192c42.2-30.9 97.1-48.6 160-48.6 63 0 117.8 17.6 160 48.6 22.3 37 40 83.3 40 131.7zM120 428c0-15.5-12.5-28-28-28s-28 12.5-28 28 12.5 28 28 28 28-12.5 28-28zm0-66.2c0-15.5-12.5-28-28-28s-28 12.5-28 28 12.5 28 28 28 28-12.5 28-28zm0-66.2c0-15.5-12.5-28-28-28s-28 12.5-28 28 12.5 28 28 28 28-12.5 28-28zM192 428c0-15.5-12.5-28-28-28s-28 12.5-28 28 12.5 28 28 28 28-12.5 28-28zm0-66.2c0-15.5-12.5-28-28-28s-28 12.5-28 28 12.5 28 28 28 28-12.5 28-28zm0-66.2c0-15.5-12.5-28-28-28s-28 12.5-28 28 12.5 28 28 28 28-12.5 28-28zM264 428c0-15.5-12.5-28-28-28s-28 12.5-28 28 12.5 28 28 28 28-12.5 28-28zm0-66.2c0-15.5-12.5-28-28-28s-28 12.5-28 28 12.5 28 28 28 28-12.5 28-28zm0-66.2c0-15.5-12.5-28-28-28s-28 12.5-28 28 12.5 28 28 28 28-12.5 28-28zM336 428c0-15.5-12.5-28-28-28s-28 12.5-28 28 12.5 28 28 28 28-12.5 28-28zm0-66.2c0-15.5-12.5-28-28-28s-28 12.5-28 28 12.5 28 28 28 28-12.5 28-28zm0-66.2c0-15.5-12.5-28-28-28s-28 12.5-28 28 12.5 28 28 28 28-12.5 28-28zm24-39.6c-4.8-22.3-7.4-36.9-16-56-38.8-19.9-90.5-32-144-32S94.8 180.1 56 200c-8.8 19.5-11.2 33.9-16 56 42.2-7.9 98.7-14.8 160-14.8s117.8 6.9 160 14.8z"
                }
            }
        ]
    })(props);
}
function FaOctopusDeploy(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M455.6,349.2c-45.891-39.09-36.67-77.877-16.095-128.11C475.16,134.04,415.967,34.14,329.93,8.3,237.04-19.6,134.252,24.341,99.677,117.147a180.862,180.862,0,0,0-10.988,73.544c1.733,29.543,14.717,52.97,24.09,80.3,17.2,50.161-28.1,92.743-66.662,117.582-46.806,30.2-36.319,39.857-8.428,41.858,23.378,1.68,44.478-4.548,65.265-15.045,9.2-4.647,40.687-18.931,45.13-28.588C135.9,413.388,111.122,459.5,126.621,488.9c19.1,36.229,67.112-31.77,76.709-45.812,8.591-12.572,42.963-81.279,63.627-46.926,18.865,31.361,8.6,76.391,35.738,104.622,32.854,34.2,51.155-18.312,51.412-44.221.163-16.411-6.1-95.852,29.9-59.944C405.428,418,436.912,467.8,472.568,463.642c38.736-4.516-22.123-67.967-28.262-78.695,5.393,4.279,53.665,34.128,53.818,9.52C498.234,375.678,468.039,359.8,455.6,349.2Z"
                }
            }
        ]
    })(props);
}
function FaOdnoklassnikiSquare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M184.2 177.1c0-22.1 17.9-40 39.8-40s39.8 17.9 39.8 40c0 22-17.9 39.8-39.8 39.8s-39.8-17.9-39.8-39.8zM448 80v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h352c26.5 0 48 21.5 48 48zm-305.1 97.1c0 44.6 36.4 80.9 81.1 80.9s81.1-36.2 81.1-80.9c0-44.8-36.4-81.1-81.1-81.1s-81.1 36.2-81.1 81.1zm174.5 90.7c-4.6-9.1-17.3-16.8-34.1-3.6 0 0-22.7 18-59.3 18s-59.3-18-59.3-18c-16.8-13.2-29.5-5.5-34.1 3.6-7.9 16.1 1.1 23.7 21.4 37 17.3 11.1 41.2 15.2 56.6 16.8l-12.9 12.9c-18.2 18-35.5 35.5-47.7 47.7-17.6 17.6 10.7 45.8 28.4 28.6l47.7-47.9c18.2 18.2 35.7 35.7 47.7 47.9 17.6 17.2 46-10.7 28.6-28.6l-47.7-47.7-13-12.9c15.5-1.6 39.1-5.9 56.2-16.8 20.4-13.3 29.3-21 21.5-37z"
                }
            }
        ]
    })(props);
}
function FaOdnoklassniki(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 320 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M275.1 334c-27.4 17.4-65.1 24.3-90 26.9l20.9 20.6 76.3 76.3c27.9 28.6-17.5 73.3-45.7 45.7-19.1-19.4-47.1-47.4-76.3-76.6L84 503.4c-28.2 27.5-73.6-17.6-45.4-45.7 19.4-19.4 47.1-47.4 76.3-76.3l20.6-20.6c-24.6-2.6-62.9-9.1-90.6-26.9-32.6-21-46.9-33.3-34.3-59 7.4-14.6 27.7-26.9 54.6-5.7 0 0 36.3 28.9 94.9 28.9s94.9-28.9 94.9-28.9c26.9-21.1 47.1-8.9 54.6 5.7 12.4 25.7-1.9 38-34.5 59.1zM30.3 129.7C30.3 58 88.6 0 160 0s129.7 58 129.7 129.7c0 71.4-58.3 129.4-129.7 129.4s-129.7-58-129.7-129.4zm66 0c0 35.1 28.6 63.7 63.7 63.7s63.7-28.6 63.7-63.7c0-35.4-28.6-64-63.7-64s-63.7 28.6-63.7 64z"
                }
            }
        ]
    })(props);
}
function FaOldRepublic(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M235.76 10.23c7.5-.31 15-.28 22.5-.09 3.61.14 7.2.4 10.79.73 4.92.27 9.79 1.03 14.67 1.62 2.93.43 5.83.98 8.75 1.46 7.9 1.33 15.67 3.28 23.39 5.4 12.24 3.47 24.19 7.92 35.76 13.21 26.56 12.24 50.94 29.21 71.63 49.88 20.03 20.09 36.72 43.55 48.89 69.19 1.13 2.59 2.44 5.1 3.47 7.74 2.81 6.43 5.39 12.97 7.58 19.63 4.14 12.33 7.34 24.99 9.42 37.83.57 3.14 1.04 6.3 1.4 9.47.55 3.83.94 7.69 1.18 11.56.83 8.34.84 16.73.77 25.1-.07 4.97-.26 9.94-.75 14.89-.24 3.38-.51 6.76-.98 10.12-.39 2.72-.63 5.46-1.11 8.17-.9 5.15-1.7 10.31-2.87 15.41-4.1 18.5-10.3 36.55-18.51 53.63-15.77 32.83-38.83 62.17-67.12 85.12a246.503 246.503 0 0 1-56.91 34.86c-6.21 2.68-12.46 5.25-18.87 7.41-3.51 1.16-7.01 2.38-10.57 3.39-6.62 1.88-13.29 3.64-20.04 5-4.66.91-9.34 1.73-14.03 2.48-5.25.66-10.5 1.44-15.79 1.74-6.69.66-13.41.84-20.12.81-6.82.03-13.65-.12-20.45-.79-3.29-.23-6.57-.5-9.83-.95-2.72-.39-5.46-.63-8.17-1.11-4.12-.72-8.25-1.37-12.35-2.22-4.25-.94-8.49-1.89-12.69-3.02-8.63-2.17-17.08-5.01-25.41-8.13-10.49-4.12-20.79-8.75-30.64-14.25-2.14-1.15-4.28-2.29-6.35-3.57-11.22-6.58-21.86-14.1-31.92-22.34-34.68-28.41-61.41-66.43-76.35-108.7-3.09-8.74-5.71-17.65-7.8-26.68-1.48-6.16-2.52-12.42-3.58-18.66-.4-2.35-.61-4.73-.95-7.09-.6-3.96-.75-7.96-1.17-11.94-.8-9.47-.71-18.99-.51-28.49.14-3.51.34-7.01.7-10.51.31-3.17.46-6.37.92-9.52.41-2.81.65-5.65 1.16-8.44.7-3.94 1.3-7.9 2.12-11.82 3.43-16.52 8.47-32.73 15.26-48.18 1.15-2.92 2.59-5.72 3.86-8.59 8.05-16.71 17.9-32.56 29.49-47.06 20-25.38 45.1-46.68 73.27-62.47 7.5-4.15 15.16-8.05 23.07-11.37 15.82-6.88 32.41-11.95 49.31-15.38 3.51-.67 7.04-1.24 10.56-1.85 2.62-.47 5.28-.7 7.91-1.08 3.53-.53 7.1-.68 10.65-1.04 2.46-.24 4.91-.36 7.36-.51m8.64 24.41c-9.23.1-18.43.99-27.57 2.23-7.3 1.08-14.53 2.6-21.71 4.3-13.91 3.5-27.48 8.34-40.46 14.42-10.46 4.99-20.59 10.7-30.18 17.22-4.18 2.92-8.4 5.8-12.34 9.03-5.08 3.97-9.98 8.17-14.68 12.59-2.51 2.24-4.81 4.7-7.22 7.06-28.22 28.79-48.44 65.39-57.5 104.69-2.04 8.44-3.54 17.02-4.44 25.65-1.1 8.89-1.44 17.85-1.41 26.8.11 7.14.38 14.28 1.22 21.37.62 7.12 1.87 14.16 3.2 21.18 1.07 4.65 2.03 9.32 3.33 13.91 6.29 23.38 16.5 45.7 30.07 65.75 8.64 12.98 18.78 24.93 29.98 35.77 16.28 15.82 35.05 29.04 55.34 39.22 7.28 3.52 14.66 6.87 22.27 9.63 5.04 1.76 10.06 3.57 15.22 4.98 11.26 3.23 22.77 5.6 34.39 7.06 2.91.29 5.81.61 8.72.9 13.82 1.08 27.74 1 41.54-.43 4.45-.6 8.92-.99 13.35-1.78 3.63-.67 7.28-1.25 10.87-2.1 4.13-.98 8.28-1.91 12.36-3.07 26.5-7.34 51.58-19.71 73.58-36.2 15.78-11.82 29.96-25.76 42.12-41.28 3.26-4.02 6.17-8.31 9.13-12.55 3.39-5.06 6.58-10.25 9.6-15.54 2.4-4.44 4.74-8.91 6.95-13.45 5.69-12.05 10.28-24.62 13.75-37.49 2.59-10.01 4.75-20.16 5.9-30.45 1.77-13.47 1.94-27.1 1.29-40.65-.29-3.89-.67-7.77-1-11.66-2.23-19.08-6.79-37.91-13.82-55.8-5.95-15.13-13.53-29.63-22.61-43.13-12.69-18.8-28.24-35.68-45.97-49.83-25.05-20-54.47-34.55-85.65-42.08-7.78-1.93-15.69-3.34-23.63-4.45-3.91-.59-7.85-.82-11.77-1.24-7.39-.57-14.81-.72-22.22-.58zM139.26 83.53c13.3-8.89 28.08-15.38 43.3-20.18-3.17 1.77-6.44 3.38-9.53 5.29-11.21 6.68-21.52 14.9-30.38 24.49-6.8 7.43-12.76 15.73-17.01 24.89-3.29 6.86-5.64 14.19-6.86 21.71-.93 4.85-1.3 9.81-1.17 14.75.13 13.66 4.44 27.08 11.29 38.82 5.92 10.22 13.63 19.33 22.36 27.26 4.85 4.36 10.24 8.09 14.95 12.6 2.26 2.19 4.49 4.42 6.43 6.91 2.62 3.31 4.89 6.99 5.99 11.1.9 3.02.66 6.2.69 9.31.02 4.1-.04 8.2.03 12.3.14 3.54-.02 7.09.11 10.63.08 2.38.02 4.76.05 7.14.16 5.77.06 11.53.15 17.3.11 2.91.02 5.82.13 8.74.03 1.63.13 3.28-.03 4.91-.91.12-1.82.18-2.73.16-10.99 0-21.88-2.63-31.95-6.93-6-2.7-11.81-5.89-17.09-9.83-5.75-4.19-11.09-8.96-15.79-14.31-6.53-7.24-11.98-15.39-16.62-23.95-1.07-2.03-2.24-4.02-3.18-6.12-1.16-2.64-2.62-5.14-3.67-7.82-4.05-9.68-6.57-19.94-8.08-30.31-.49-4.44-1.09-8.88-1.2-13.35-.7-15.73.84-31.55 4.67-46.82 2.12-8.15 4.77-16.18 8.31-23.83 6.32-14.2 15.34-27.18 26.3-38.19 6.28-6.2 13.13-11.84 20.53-16.67zm175.37-20.12c2.74.74 5.41 1.74 8.09 2.68 6.36 2.33 12.68 4.84 18.71 7.96 13.11 6.44 25.31 14.81 35.82 24.97 10.2 9.95 18.74 21.6 25.14 34.34 1.28 2.75 2.64 5.46 3.81 8.26 6.31 15.1 10 31.26 11.23 47.57.41 4.54.44 9.09.45 13.64.07 11.64-1.49 23.25-4.3 34.53-1.97 7.27-4.35 14.49-7.86 21.18-3.18 6.64-6.68 13.16-10.84 19.24-6.94 10.47-15.6 19.87-25.82 27.22-10.48 7.64-22.64 13.02-35.4 15.38-3.51.69-7.08 1.08-10.66 1.21-1.85.06-3.72.16-5.56-.1-.28-2.15 0-4.31-.01-6.46-.03-3.73.14-7.45.1-11.17.19-7.02.02-14.05.21-21.07.03-2.38-.03-4.76.03-7.14.17-5.07-.04-10.14.14-15.21.1-2.99-.24-6.04.51-8.96.66-2.5 1.78-4.86 3.09-7.08 4.46-7.31 11.06-12.96 17.68-18.26 5.38-4.18 10.47-8.77 15.02-13.84 7.68-8.37 14.17-17.88 18.78-28.27 2.5-5.93 4.52-12.1 5.55-18.46.86-4.37 1.06-8.83 1.01-13.27-.02-7.85-1.4-15.65-3.64-23.17-1.75-5.73-4.27-11.18-7.09-16.45-3.87-6.93-8.65-13.31-13.96-19.2-9.94-10.85-21.75-19.94-34.6-27.1-1.85-1.02-3.84-1.82-5.63-2.97zm-100.8 58.45c.98-1.18 1.99-2.33 3.12-3.38-.61.93-1.27 1.81-1.95 2.68-3.1 3.88-5.54 8.31-7.03 13.06-.87 3.27-1.68 6.6-1.73 10-.07 2.52-.08 5.07.32 7.57 1.13 7.63 4.33 14.85 8.77 21.12 2 2.7 4.25 5.27 6.92 7.33 1.62 1.27 3.53 2.09 5.34 3.05 3.11 1.68 6.32 3.23 9.07 5.48 2.67 2.09 4.55 5.33 4.4 8.79-.01 73.67 0 147.34-.01 221.02 0 1.35-.08 2.7.04 4.04.13 1.48.82 2.83 1.47 4.15.86 1.66 1.78 3.34 3.18 4.62.85.77 1.97 1.4 3.15 1.24 1.5-.2 2.66-1.35 3.45-2.57.96-1.51 1.68-3.16 2.28-4.85.76-2.13.44-4.42.54-6.63.14-4.03-.02-8.06.14-12.09.03-5.89.03-11.77.06-17.66.14-3.62.03-7.24.11-10.86.15-4.03-.02-8.06.14-12.09.03-5.99.03-11.98.07-17.97.14-3.62.02-7.24.11-10.86.14-3.93-.02-7.86.14-11.78.03-5.99.03-11.98.06-17.97.16-3.94-.01-7.88.19-11.82.29 1.44.13 2.92.22 4.38.19 3.61.42 7.23.76 10.84.32 3.44.44 6.89.86 10.32.37 3.1.51 6.22.95 9.31.57 4.09.87 8.21 1.54 12.29 1.46 9.04 2.83 18.11 5.09 26.99 1.13 4.82 2.4 9.61 4 14.3 2.54 7.9 5.72 15.67 10.31 22.62 1.73 2.64 3.87 4.98 6.1 7.21.27.25.55.51.88.71.6.25 1.31-.07 1.7-.57.71-.88 1.17-1.94 1.7-2.93 4.05-7.8 8.18-15.56 12.34-23.31.7-1.31 1.44-2.62 2.56-3.61 1.75-1.57 3.84-2.69 5.98-3.63 2.88-1.22 5.9-2.19 9.03-2.42 6.58-.62 13.11.75 19.56 1.85 3.69.58 7.4 1.17 11.13 1.41 3.74.1 7.48.05 11.21-.28 8.55-.92 16.99-2.96 24.94-6.25 5.3-2.24 10.46-4.83 15.31-7.93 11.46-7.21 21.46-16.57 30.04-27.01 1.17-1.42 2.25-2.9 3.46-4.28-1.2 3.24-2.67 6.37-4.16 9.48-1.25 2.9-2.84 5.61-4.27 8.42-5.16 9.63-11.02 18.91-17.75 27.52-4.03 5.21-8.53 10.05-13.33 14.57-6.64 6.05-14.07 11.37-22.43 14.76-8.21 3.37-17.31 4.63-26.09 3.29-3.56-.58-7.01-1.69-10.41-2.88-2.79-.97-5.39-2.38-8.03-3.69-3.43-1.71-6.64-3.81-9.71-6.08 2.71 3.06 5.69 5.86 8.7 8.61 4.27 3.76 8.74 7.31 13.63 10.23 3.98 2.45 8.29 4.4 12.84 5.51 1.46.37 2.96.46 4.45.6-1.25 1.1-2.63 2.04-3.99 2.98-9.61 6.54-20.01 11.86-30.69 16.43-20.86 8.7-43.17 13.97-65.74 15.34-4.66.24-9.32.36-13.98.36-4.98-.11-9.97-.13-14.92-.65-11.2-.76-22.29-2.73-33.17-5.43-10.35-2.71-20.55-6.12-30.3-10.55-8.71-3.86-17.12-8.42-24.99-13.79-1.83-1.31-3.74-2.53-5.37-4.08 6.6-1.19 13.03-3.39 18.99-6.48 5.74-2.86 10.99-6.66 15.63-11.07 2.24-2.19 4.29-4.59 6.19-7.09-3.43 2.13-6.93 4.15-10.62 5.78-4.41 2.16-9.07 3.77-13.81 5.02-5.73 1.52-11.74 1.73-17.61 1.14-8.13-.95-15.86-4.27-22.51-8.98-4.32-2.94-8.22-6.43-11.96-10.06-9.93-10.16-18.2-21.81-25.66-33.86-3.94-6.27-7.53-12.75-11.12-19.22-1.05-2.04-2.15-4.05-3.18-6.1 2.85 2.92 5.57 5.97 8.43 8.88 8.99 8.97 18.56 17.44 29.16 24.48 7.55 4.9 15.67 9.23 24.56 11.03 3.11.73 6.32.47 9.47.81 2.77.28 5.56.2 8.34.3 5.05.06 10.11.04 15.16-.16 3.65-.16 7.27-.66 10.89-1.09 2.07-.25 4.11-.71 6.14-1.2 3.88-.95 8.11-.96 11.83.61 4.76 1.85 8.44 5.64 11.38 9.71 2.16 3.02 4.06 6.22 5.66 9.58 1.16 2.43 2.46 4.79 3.55 7.26 1 2.24 2.15 4.42 3.42 6.52.67 1.02 1.4 2.15 2.62 2.55 1.06-.75 1.71-1.91 2.28-3.03 2.1-4.16 3.42-8.65 4.89-13.05 2.02-6.59 3.78-13.27 5.19-20.02 2.21-9.25 3.25-18.72 4.54-28.13.56-3.98.83-7.99 1.31-11.97.87-10.64 1.9-21.27 2.24-31.94.08-1.86.24-3.71.25-5.57.01-4.35.25-8.69.22-13.03-.01-2.38-.01-4.76 0-7.13.05-5.07-.2-10.14-.22-15.21-.2-6.61-.71-13.2-1.29-19.78-.73-5.88-1.55-11.78-3.12-17.51-2.05-7.75-5.59-15.03-9.8-21.82-3.16-5.07-6.79-9.88-11.09-14.03-3.88-3.86-8.58-7.08-13.94-8.45-1.5-.41-3.06-.45-4.59-.64.07-2.99.7-5.93 1.26-8.85 1.59-7.71 3.8-15.3 6.76-22.6 1.52-4.03 3.41-7.9 5.39-11.72 3.45-6.56 7.62-12.79 12.46-18.46zm31.27 1.7c.35-.06.71-.12 1.07-.19.19 1.79.09 3.58.1 5.37v38.13c-.01 1.74.13 3.49-.15 5.22-.36-.03-.71-.05-1.06-.05-.95-3.75-1.72-7.55-2.62-11.31-.38-1.53-.58-3.09-1.07-4.59-1.7-.24-3.43-.17-5.15-.2-5.06-.01-10.13 0-15.19-.01-1.66-.01-3.32.09-4.98-.03-.03-.39-.26-.91.16-1.18 1.28-.65 2.72-.88 4.06-1.35 3.43-1.14 6.88-2.16 10.31-3.31 1.39-.48 2.9-.72 4.16-1.54.04-.56.02-1.13-.05-1.68-1.23-.55-2.53-.87-3.81-1.28-3.13-1.03-6.29-1.96-9.41-3.02-1.79-.62-3.67-1-5.41-1.79-.03-.37-.07-.73-.11-1.09 5.09-.19 10.2.06 15.3-.12 3.36-.13 6.73.08 10.09-.07.12-.39.26-.77.37-1.16 1.08-4.94 2.33-9.83 3.39-14.75zm5.97-.2c.36.05.72.12 1.08.2.98 3.85 1.73 7.76 2.71 11.61.36 1.42.56 2.88 1.03 4.27 2.53.18 5.07-.01 7.61.05 5.16.12 10.33.12 15.49.07.76-.01 1.52.03 2.28.08-.04.36-.07.72-.1 1.08-1.82.83-3.78 1.25-5.67 1.89-3.73 1.23-7.48 2.39-11.22 3.57-.57.17-1.12.42-1.67.64-.15.55-.18 1.12-.12 1.69.87.48 1.82.81 2.77 1.09 4.88 1.52 9.73 3.14 14.63 4.6.38.13.78.27 1.13.49.4.27.23.79.15 1.18-1.66.13-3.31.03-4.97.04-5.17.01-10.33-.01-15.5.01-1.61.03-3.22-.02-4.82.21-.52 1.67-.72 3.42-1.17 5.11-.94 3.57-1.52 7.24-2.54 10.78-.36.01-.71.02-1.06.06-.29-1.73-.15-3.48-.15-5.22v-38.13c.02-1.78-.08-3.58.11-5.37zM65.05 168.33c1.12-2.15 2.08-4.4 3.37-6.46-1.82 7.56-2.91 15.27-3.62 23-.8 7.71-.85 15.49-.54 23.23 1.05 19.94 5.54 39.83 14.23 57.88 2.99 5.99 6.35 11.83 10.5 17.11 6.12 7.47 12.53 14.76 19.84 21.09 4.8 4.1 9.99 7.78 15.54 10.8 3.27 1.65 6.51 3.39 9.94 4.68 5.01 2.03 10.19 3.61 15.42 4.94 3.83.96 7.78 1.41 11.52 2.71 5 1.57 9.47 4.61 13.03 8.43 4.93 5.23 8.09 11.87 10.2 18.67.99 2.9 1.59 5.91 2.17 8.92.15.75.22 1.52.16 2.29-6.5 2.78-13.26 5.06-20.26 6.18-4.11.78-8.29.99-12.46 1.08-10.25.24-20.47-1.76-30.12-5.12-3.74-1.42-7.49-2.85-11.03-4.72-8.06-3.84-15.64-8.7-22.46-14.46-2.92-2.55-5.83-5.13-8.4-8.03-9.16-9.83-16.3-21.41-21.79-33.65-2.39-5.55-4.61-11.18-6.37-16.96-1.17-3.94-2.36-7.89-3.26-11.91-.75-2.94-1.22-5.95-1.87-8.92-.46-2.14-.69-4.32-1.03-6.48-.85-5.43-1.28-10.93-1.33-16.43.11-6.18.25-12.37 1.07-18.5.4-2.86.67-5.74 1.15-8.6.98-5.7 2.14-11.37 3.71-16.93 3.09-11.65 7.48-22.95 12.69-33.84zm363.73-6.44c1.1 1.66 1.91 3.48 2.78 5.26 2.1 4.45 4.24 8.9 6.02 13.49 7.61 18.76 12.3 38.79 13.04 59.05.02 1.76.07 3.52.11 5.29.13 9.57-1.27 19.09-3.18 28.45-.73 3.59-1.54 7.17-2.58 10.69-4.04 14.72-10 29-18.41 41.78-8.21 12.57-19.01 23.55-31.84 31.41-5.73 3.59-11.79 6.64-18.05 9.19-5.78 2.19-11.71 4.03-17.8 5.11-6.4 1.05-12.91 1.52-19.4 1.23-7.92-.48-15.78-2.07-23.21-4.85-1.94-.8-3.94-1.46-5.84-2.33-.21-1.51.25-2.99.53-4.46 1.16-5.74 3.03-11.36 5.7-16.58 2.37-4.51 5.52-8.65 9.46-11.9 2.43-2.05 5.24-3.61 8.16-4.83 3.58-1.5 7.47-1.97 11.24-2.83 7.23-1.71 14.37-3.93 21.15-7 10.35-4.65 19.71-11.38 27.65-19.46 1.59-1.61 3.23-3.18 4.74-4.87 3.37-3.76 6.71-7.57 9.85-11.53 7.48-10.07 12.82-21.59 16.71-33.48 1.58-5.3 3.21-10.6 4.21-16.05.63-2.87 1.04-5.78 1.52-8.68.87-6.09 1.59-12.22 1.68-18.38.12-6.65.14-13.32-.53-19.94-.73-7.99-1.87-15.96-3.71-23.78z"
                }
            }
        ]
    })(props);
}
function FaOpencart(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M423.3 440.7c0 25.3-20.3 45.6-45.6 45.6s-45.8-20.3-45.8-45.6 20.6-45.8 45.8-45.8c25.4 0 45.6 20.5 45.6 45.8zm-253.9-45.8c-25.3 0-45.6 20.6-45.6 45.8s20.3 45.6 45.6 45.6 45.8-20.3 45.8-45.6-20.5-45.8-45.8-45.8zm291.7-270C158.9 124.9 81.9 112.1 0 25.7c34.4 51.7 53.3 148.9 373.1 144.2 333.3-5 130 86.1 70.8 188.9 186.7-166.7 319.4-233.9 17.2-233.9z"
                }
            }
        ]
    })(props);
}
function FaOpenid(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M271.5 432l-68 32C88.5 453.7 0 392.5 0 318.2c0-71.5 82.5-131 191.7-144.3v43c-71.5 12.5-124 53-124 101.3 0 51 58.5 93.3 135.7 103v-340l68-33.2v384zM448 291l-131.3-28.5 36.8-20.7c-19.5-11.5-43.5-20-70-24.8v-43c46.2 5.5 87.7 19.5 120.3 39.3l35-19.8L448 291z"
                }
            }
        ]
    })(props);
}
function FaOpera(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M313.9 32.7c-170.2 0-252.6 223.8-147.5 355.1 36.5 45.4 88.6 75.6 147.5 75.6 36.3 0 70.3-11.1 99.4-30.4-43.8 39.2-101.9 63-165.3 63-3.9 0-8 0-11.9-.3C104.6 489.6 0 381.1 0 248 0 111 111 0 248 0h.8c63.1.3 120.7 24.1 164.4 63.1-29-19.4-63.1-30.4-99.3-30.4zm101.8 397.7c-40.9 24.7-90.7 23.6-132-5.8 56.2-20.5 97.7-91.6 97.7-176.6 0-84.7-41.2-155.8-97.4-176.6 41.8-29.2 91.2-30.3 132.9-5 105.9 98.7 105.5 265.7-1.2 364z"
                }
            }
        ]
    })(props);
}
function FaOptinMonster(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M572.6 421.4c5.6-9.5 4.7-15.2-5.4-11.6-3-4.9-7-9.5-11.1-13.8 2.9-9.7-.7-14.2-10.8-9.2-4.6-3.2-10.3-6.5-15.9-9.2 0-15.1-11.6-11.6-17.6-5.7-10.4-1.5-18.7-.3-26.8 5.7.3-6.5.3-13 .3-19.7 12.6 0 40.2-11 45.9-36.2 1.4-6.8 1.6-13.8-.3-21.9-3-13.5-14.3-21.3-25.1-25.7-.8-5.9-7.6-14.3-14.9-15.9s-12.4 4.9-14.1 10.3c-8.5 0-19.2 2.8-21.1 8.4-5.4-.5-11.1-1.4-16.8-1.9 2.7-1.9 5.4-3.5 8.4-4.6 5.4-9.2 14.6-11.4 25.7-11.6V256c19.5-.5 43-5.9 53.8-18.1 12.7-13.8 14.6-37.3 12.4-55.1-2.4-17.3-9.7-37.6-24.6-48.1-8.4-5.9-21.6-.8-22.7 9.5-2.2 19.6 1.2 30-38.6 25.1-10.3-23.8-24.6-44.6-42.7-60C341 49.6 242.9 55.5 166.4 71.7c19.7 4.6 41.1 8.6 59.7 16.5-26.2 2.4-52.7 11.3-76.2 23.2-32.8 17-44 29.9-56.7 42.4 14.9-2.2 28.9-5.1 43.8-3.8-9.7 5.4-18.4 12.2-26.5 20-25.8.9-23.8-5.3-26.2-25.9-1.1-10.5-14.3-15.4-22.7-9.7-28.1 19.9-33.5 79.9-12.2 103.5 10.8 12.2 35.1 17.3 54.9 17.8-.3 1.1-.3 1.9-.3 2.7 10.8.5 19.5 2.7 24.6 11.6 3 1.1 5.7 2.7 8.1 4.6-5.4.5-11.1 1.4-16.5 1.9-3.3-6.6-13.7-8.1-21.1-8.1-1.6-5.7-6.5-12.2-14.1-10.3-6.8 1.9-14.1 10-14.9 15.9-22.5 9.5-30.1 26.8-25.1 47.6 5.3 24.8 33 36.2 45.9 36.2v19.7c-6.6-5-14.3-7.5-26.8-5.7-5.5-5.5-17.3-10.1-17.3 5.7-5.9 2.7-11.4 5.9-15.9 9.2-9.8-4.9-13.6-1.7-11.1 9.2-4.1 4.3-7.8 8.6-11.1 13.8-10.2-3.7-11 2.2-5.4 11.6-1.1 3.5-1.6 7-1.9 10.8-.5 31.6 44.6 64 73.5 65.1 17.3.5 34.6-8.4 43-23.5 113.2 4.9 226.7 4.1 340.2 0 8.1 15.1 25.4 24.3 42.7 23.5 29.2-1.1 74.3-33.5 73.5-65.1.2-3.7-.7-7.2-1.7-10.7zm-73.8-254c1.1-3 2.4-8.4 2.4-14.6 0-5.9 6.8-8.1 14.1-.8 11.1 11.6 14.9 40.5 13.8 51.1-4.1-13.6-13-29-30.3-35.7zm-4.6 6.7c19.5 6.2 28.6 27.6 29.7 48.9-1.1 2.7-3 5.4-4.9 7.6-5.7 5.9-15.4 10-26.2 12.2 4.3-21.3.3-47.3-12.7-63 4.9-.8 10.9-2.4 14.1-5.7zm-24.1 6.8c13.8 11.9 20 39.2 14.1 63.5-4.1.5-8.1.8-11.6.8-1.9-21.9-6.8-44-14.3-64.6 3.7.3 8.1.3 11.8.3zM47.5 203c-1.1-10.5 2.4-39.5 13.8-51.1 7-7.3 14.1-5.1 14.1.8 0 6.2 1.4 11.6 2.4 14.6-17.3 6.8-26.2 22.2-30.3 35.7zm9.7 27.6c-1.9-2.2-3.5-4.9-4.9-7.6 1.4-21.3 10.3-42.7 29.7-48.9 3.2 3.2 9.2 4.9 14.1 5.7-13 15.7-17 41.6-12.7 63-10.8-2.2-20.5-6-26.2-12.2zm47.9 14.6c-4.1 0-8.1-.3-12.7-.8-4.6-18.6-1.9-38.9 5.4-53v.3l12.2-5.1c4.9-1.9 9.7-3.8 14.9-4.9-10.7 19.7-17.4 41.3-19.8 63.5zm184-162.7c41.9 0 76.2 34 76.2 75.9 0 42.2-34.3 76.2-76.2 76.2s-76.2-34-76.2-76.2c0-41.8 34.3-75.9 76.2-75.9zm115.6 174.3c-.3 17.8-7 48.9-23 57-13.2 6.6-6.5-7.5-16.5-58.1 13.3.3 26.6.3 39.5 1.1zm-54-1.6c.8 4.9 3.8 40.3-1.6 41.9-11.6 3.5-40 4.3-51.1-1.1-4.1-3-4.6-35.9-4.3-41.1v.3c18.9-.3 38.1-.3 57 0zM278.3 309c-13 3.5-41.6 4.1-54.6-1.6-6.5-2.7-3.8-42.4-1.9-51.6 19.2-.5 38.4-.5 57.8-.8v.3c1.1 8.3 3.3 51.2-1.3 53.7zm-106.5-51.1c12.2-.8 24.6-1.4 36.8-1.6-2.4 15.4-3 43.5-4.9 52.2-1.1 6.8-4.3 6.8-9.7 4.3-21.9-9.8-27.6-35.2-22.2-54.9zm-35.4 31.3c7.8-1.1 15.7-1.9 23.5-2.7 1.6 6.2 3.8 11.9 7 17.6 10 17 44 35.7 45.1 7 6.2 14.9 40.8 12.2 54.9 10.8 15.7-1.4 23.8-1.4 26.8-14.3 12.4 4.3 30.8 4.1 44 3 11.3-.8 20.8-.5 24.6-8.9 1.1 5.1 1.9 11.6 4.6 16.8 10.8 21.3 37.3 1.4 46.8-31.6 8.6.8 17.6 1.9 26.5 2.7-.4 1.3-3.8 7.3 7.3 11.6-47.6 47-95.7 87.8-163.2 107-63.2-20.8-112.1-59.5-155.9-106.5 9.6-3.4 10.4-8.8 8-12.5zm-21.6 172.5c-3.8 17.8-21.9 29.7-39.7 28.9-19.2-.8-46.5-17-59.2-36.5-2.7-31.1 43.8-61.3 66.2-54.6 14.9 4.3 27.8 30.8 33.5 54 0 3-.3 5.7-.8 8.2zm-8.7-66c-.5-13.5-.5-27-.3-40.5h.3c2.7-1.6 5.7-3.8 7.8-6.5 6.5-1.6 13-5.1 15.1-9.2 3.3-7.1-7-7.5-5.4-12.4 2.7-1.1 5.7-2.2 7.8-3.5 29.2 29.2 58.6 56.5 97.3 77-36.8 11.3-72.4 27.6-105.9 47-1.2-18.6-7.7-35.9-16.7-51.9zm337.6 64.6c-103 3.5-206.2 4.1-309.4 0 0 .3 0 .3-.3.3v-.3h.3c35.1-21.6 72.2-39.2 112.4-50.8 11.6 5.1 23 9.5 34.9 13.2 2.2.8 2.2.8 4.3 0 14.3-4.1 28.4-9.2 42.2-15.4 41.5 11.7 78.8 31.7 115.6 53zm10.5-12.4c-35.9-19.5-73-35.9-111.9-47.6 38.1-20 71.9-47.3 103.5-76.7 2.2 1.4 4.6 2.4 7.6 3.2 0 .8.3 1.9.5 2.4-4.6 2.7-7.8 6.2-5.9 10.3 2.2 3.8 8.6 7.6 15.1 8.9 2.4 2.7 5.1 5.1 8.1 6.8 0 13.8-.3 27.6-.8 41.3l.3-.3c-9.3 15.9-15.5 37-16.5 51.7zm105.9 6.2c-12.7 19.5-40 35.7-59.2 36.5-19.3.9-40.5-13.2-40.5-37 5.7-23.2 18.9-49.7 33.5-54 22.7-6.9 69.2 23.4 66.2 54.5zM372.9 75.2c-3.8-72.1-100.8-79.7-126-23.5 44.6-24.3 90.3-15.7 126 23.5zM74.8 407.1c-15.7 1.6-49.5 25.4-49.5 43.2 0 11.6 15.7 19.5 32.2 14.9 12.2-3.2 31.1-17.6 35.9-27.3 6-11.6-3.7-32.7-18.6-30.8zm215.9-176.2c28.6 0 51.9-21.6 51.9-48.4 0-36.1-40.5-58.1-72.2-44.3 9.5 3 16.5 11.6 16.5 21.6 0 23.3-33.3 32-46.5 11.3-7.3 34.1 19.4 59.8 50.3 59.8zM68 474.1c.5 6.5 12.2 12.7 21.6 9.5 6.8-2.7 14.6-10.5 17.3-16.2 3-7-1.1-20-9.7-18.4-8.9 1.6-29.7 16.7-29.2 25.1zm433.2-67c-14.9-1.9-24.6 19.2-18.9 30.8 4.9 9.7 24.1 24.1 36.2 27.3 16.5 4.6 32.2-3.2 32.2-14.9 0-17.8-33.8-41.6-49.5-43.2zM478.8 449c-8.4-1.6-12.4 11.3-9.5 18.4 2.4 5.7 10.3 13.5 17.3 16.2 9.2 3.2 21.1-3 21.3-9.5.9-8.4-20.2-23.5-29.1-25.1z"
                }
            }
        ]
    })(props);
}
function FaOrcid(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M294.75 188.19h-45.92V342h47.47c67.62 0 83.12-51.34 83.12-76.91 0-41.64-26.54-76.9-84.67-76.9zM256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm-80.79 360.76h-29.84v-207.5h29.84zm-14.92-231.14a19.57 19.57 0 1 1 19.57-19.57 19.64 19.64 0 0 1-19.57 19.57zM300 369h-81V161.26h80.6c76.73 0 110.44 54.83 110.44 103.85C410 318.39 368.38 369 300 369z"
                }
            }
        ]
    })(props);
}
function FaOsi(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 266.44C10.3 130.64 105.4 34 221.8 18.34c138.8-18.6 255.6 75.8 278 201.1 21.3 118.8-44 230-151.6 274-9.3 3.8-14.4 1.7-18-7.7q-26.7-69.45-53.4-139c-3.1-8.1-1-13.2 7-16.8 24.2-11 39.3-29.4 43.3-55.8a71.47 71.47 0 0 0-64.5-82.2c-39-3.4-71.8 23.7-77.5 59.7-5.2 33 11.1 63.7 41.9 77.7 9.6 4.4 11.5 8.6 7.8 18.4q-26.85 69.9-53.7 139.9c-2.6 6.9-8.3 9.3-15.5 6.5-52.6-20.3-101.4-61-130.8-119-24.9-49.2-25.2-87.7-26.8-108.7zm20.9-1.9c.4 6.6.6 14.3 1.3 22.1 6.3 71.9 49.6 143.5 131 183.1 3.2 1.5 4.4.8 5.6-2.3q22.35-58.65 45-117.3c1.3-3.3.6-4.8-2.4-6.7-31.6-19.9-47.3-48.5-45.6-86 1-21.6 9.3-40.5 23.8-56.3 30-32.7 77-39.8 115.5-17.6a91.64 91.64 0 0 1 45.2 90.4c-3.6 30.6-19.3 53.9-45.7 69.8-2.7 1.6-3.5 2.9-2.3 6q22.8 58.8 45.2 117.7c1.2 3.1 2.4 3.8 5.6 2.3 35.5-16.6 65.2-40.3 88.1-72 34.8-48.2 49.1-101.9 42.3-161-13.7-117.5-119.4-214.8-255.5-198-106.1 13-195.3 102.5-197.1 225.8z"
                }
            }
        ]
    })(props);
}
function FaPage4(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 504C111 504 0 393 0 256S111 8 248 8c20.9 0 41.3 2.6 60.7 7.5L42.3 392H248v112zm0-143.6V146.8L98.6 360.4H248zm96 31.6v92.7c45.7-19.2 84.5-51.7 111.4-92.7H344zm57.4-138.2l-21.2 8.4 21.2 8.3v-16.7zm-20.3 54.5c-6.7 0-8 6.3-8 12.9v7.7h16.2v-10c0-5.9-2.3-10.6-8.2-10.6zM496 256c0 37.3-8.2 72.7-23 104.4H344V27.3C433.3 64.8 496 153.1 496 256zM360.4 143.6h68.2V96h-13.9v32.6h-13.9V99h-13.9v29.6h-12.7V96h-13.9v47.6zm68.1 185.3H402v-11c0-15.4-5.6-25.2-20.9-25.2-15.4 0-20.7 10.6-20.7 25.9v25.3h68.2v-15zm0-103l-68.2 29.7V268l68.2 29.5v-16.6l-14.4-5.7v-26.5l14.4-5.9v-16.9zm-4.8-68.5h-35.6V184H402v-12.2h11c8.6 15.8 1.3 35.3-18.6 35.3-22.5 0-28.3-25.3-15.5-37.7l-11.6-10.6c-16.2 17.5-12.2 63.9 27.1 63.9 34 0 44.7-35.9 29.3-65.3z"
                }
            }
        ]
    })(props);
}
function FaPagelines(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M384 312.7c-55.1 136.7-187.1 54-187.1 54-40.5 81.8-107.4 134.4-184.6 134.7-16.1 0-16.6-24.4 0-24.4 64.4-.3 120.5-42.7 157.2-110.1-41.1 15.9-118.6 27.9-161.6-82.2 109-44.9 159.1 11.2 178.3 45.5 9.9-24.4 17-50.9 21.6-79.7 0 0-139.7 21.9-149.5-98.1 119.1-47.9 152.6 76.7 152.6 76.7 1.6-16.7 3.3-52.6 3.3-53.4 0 0-106.3-73.7-38.1-165.2 124.6 43 61.4 162.4 61.4 162.4.5 1.6.5 23.8 0 33.4 0 0 45.2-89 136.4-57.5-4.2 134-141.9 106.4-141.9 106.4-4.4 27.4-11.2 53.4-20 77.5 0 0 83-91.8 172-20z"
                }
            }
        ]
    })(props);
}
function FaPalfed(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M384.9 193.9c0-47.4-55.2-44.2-95.4-29.8-1.3 39.4-2.5 80.7-3 119.8.7 2.8 2.6 6.2 15.1 6.2 36.8 0 83.4-42.8 83.3-96.2zm-194.5 72.2c.2 0 6.5-2.7 11.2-2.7 26.6 0 20.7 44.1-14.4 44.1-21.5 0-37.1-18.1-37.1-43 0-42 42.9-95.6 100.7-126.5 1-12.4 3-22 10.5-28.2 11.2-9 26.6-3.5 29.5 11.1 72.2-22.2 135.2 1 135.2 72 0 77.9-79.3 152.6-140.1 138.2-.1 39.4.9 74.4 2.7 100v.2c.2 3.4.6 12.5-5.3 19.1-9.6 10.6-33.4 10-36.4-22.3-4.1-44.4.2-206.1 1.4-242.5-21.5 15-58.5 50.3-58.5 75.9.2 2.5.4 4 .6 4.6zM8 181.1s-.1 37.4 38.4 37.4h30l22.4 217.2s0 44.3 44.7 44.3h288.9s44.7-.4 44.7-44.3l22.4-217.2h30s38.4 1.2 38.4-37.4c0 0 .1-37.4-38.4-37.4h-30.1c-7.3-25.6-30.2-74.3-119.4-74.3h-28V50.3s-2.7-18.4-21.1-18.4h-85.8s-21.1 0-21.1 18.4v19.1h-28.1s-105 4.2-120.5 74.3h-29S8 142.5 8 181.1z"
                }
            }
        ]
    })(props);
}
function FaPatreon(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M512 194.8c0 101.3-82.4 183.8-183.8 183.8-101.7 0-184.4-82.4-184.4-183.8 0-101.6 82.7-184.3 184.4-184.3C429.6 10.5 512 93.2 512 194.8zM0 501.5h90v-491H0v491z"
                }
            }
        ]
    })(props);
}
function FaPaypal(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M111.4 295.9c-3.5 19.2-17.4 108.7-21.5 134-.3 1.8-1 2.5-3 2.5H12.3c-7.6 0-13.1-6.6-12.1-13.9L58.8 46.6c1.5-9.6 10.1-16.9 20-16.9 152.3 0 165.1-3.7 204 11.4 60.1 23.3 65.6 79.5 44 140.3-21.5 62.6-72.5 89.5-140.1 90.3-43.4.7-69.5-7-75.3 24.2zM357.1 152c-1.8-1.3-2.5-1.8-3 1.3-2 11.4-5.1 22.5-8.8 33.6-39.9 113.8-150.5 103.9-204.5 103.9-6.1 0-10.1 3.3-10.9 9.4-22.6 140.4-27.1 169.7-27.1 169.7-1 7.1 3.5 12.9 10.6 12.9h63.5c8.6 0 15.7-6.3 17.4-14.9.7-5.4-1.1 6.1 14.4-91.3 4.6-22 14.3-19.7 29.3-19.7 71 0 126.4-28.8 142.9-112.3 6.5-34.8 4.6-71.4-23.8-92.6z"
                }
            }
        ]
    })(props);
}
function FaPennyArcade(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M421.91 164.27c-4.49 19.45-1.4 6.06-15.1 65.29l39.73-10.61c-22.34-49.61-17.29-38.41-24.63-54.68zm-206.09 51.11c-20.19 5.4-11.31 3.03-39.63 10.58l4.46 46.19c28.17-7.59 20.62-5.57 34.82-9.34 42.3-9.79 32.85-56.42.35-47.43zm326.16-26.19l-45.47-99.2c-5.69-12.37-19.46-18.84-32.62-15.33-70.27 18.75-38.72 10.32-135.59 36.23a27.618 27.618 0 0 0-18.89 17.41C144.26 113.27 0 153.75 0 226.67c0 33.5 30.67 67.11 80.9 95.37l1.74 17.88a27.891 27.891 0 0 0-17.77 28.67l4.3 44.48c1.39 14.31 13.43 25.21 27.8 25.2 5.18-.01-3.01 1.78 122.53-31.76 12.57-3.37 21.12-15.02 20.58-28.02 216.59 45.5 401.99-5.98 399.89-84.83.01-28.15-22.19-66.56-97.99-104.47zM255.14 298.3l-21.91 5.88-48.44 12.91 2.46 23.55 20.53-5.51 4.51 44.51-115.31 30.78-4.3-44.52 20.02-5.35-11.11-114.64-20.12 5.39-4.35-44.5c178.15-47.54 170.18-46.42 186.22-46.65 56.66-1.13 64.15 71.84 42.55 104.43a86.7 86.7 0 0 1-50.75 33.72zm199.18 16.62l-3.89-39.49 14.9-3.98-6.61-14.68-57.76 15.42-4.1 17.54 19.2-5.12 4.05 39.54-112.85 30.07-4.46-44.43 20.99-5.59 33.08-126.47-17.15 4.56-4.2-44.48c93.36-24.99 65.01-17.41 135.59-36.24l66.67 145.47 20.79-5.56 4.3 44.48-108.55 28.96z"
                }
            }
        ]
    })(props);
}
function FaPerbyte(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M305.314,284.578H246.6V383.3h58.711q24.423,0,38.193-13.77t13.77-36.11q0-21.826-14.032-35.335T305.314,284.578ZM149.435,128.7H90.724v98.723h58.711q24.42,0,38.19-13.773t13.77-36.107q0-21.826-14.029-35.338T149.435,128.7ZM366.647,32H81.353A81.445,81.445,0,0,0,0,113.352V398.647A81.445,81.445,0,0,0,81.353,480H366.647A81.445,81.445,0,0,0,448,398.647V113.352A81.445,81.445,0,0,0,366.647,32Zm63.635,366.647a63.706,63.706,0,0,1-63.635,63.635H81.353a63.706,63.706,0,0,1-63.635-63.635V113.352A63.706,63.706,0,0,1,81.353,49.718H366.647a63.706,63.706,0,0,1,63.635,63.634ZM305.314,128.7H246.6v98.723h58.711q24.423,0,38.193-13.773t13.77-36.107q0-21.826-14.032-35.338T305.314,128.7Z"
                }
            }
        ]
    })(props);
}
function FaPeriscope(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M370 63.6C331.4 22.6 280.5 0 226.6 0 111.9 0 18.5 96.2 18.5 214.4c0 75.1 57.8 159.8 82.7 192.7C137.8 455.5 192.6 512 226.6 512c41.6 0 112.9-94.2 120.9-105 24.6-33.1 82-118.3 82-192.6 0-56.5-21.1-110.1-59.5-150.8zM226.6 493.9c-42.5 0-190-167.3-190-279.4 0-107.4 83.9-196.3 190-196.3 100.8 0 184.7 89 184.7 196.3.1 112.1-147.4 279.4-184.7 279.4zM338 206.8c0 59.1-51.1 109.7-110.8 109.7-100.6 0-150.7-108.2-92.9-181.8v.4c0 24.5 20.1 44.4 44.8 44.4 24.7 0 44.8-19.9 44.8-44.4 0-18.2-11.1-33.8-26.9-40.7 76.6-19.2 141 39.3 141 112.4z"
                }
            }
        ]
    })(props);
}
function FaPhabricator(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M323 262.1l-.1-13s21.7-19.8 21.1-21.2l-9.5-20c-.6-1.4-29.5-.5-29.5-.5l-9.4-9.3s.2-28.5-1.2-29.1l-20.1-9.2c-1.4-.6-20.7 21-20.7 21l-13.1-.2s-20.5-21.4-21.9-20.8l-20 8.3c-1.4.5.2 28.9.2 28.9l-9.1 9.1s-29.2-.9-29.7.4l-8.1 19.8c-.6 1.4 21 21 21 21l.1 12.9s-21.7 19.8-21.1 21.2l9.5 20c.6 1.4 29.5.5 29.5.5l9.4 9.3s-.2 31.8 1.2 32.3l20.1 8.3c1.4.6 20.7-23.5 20.7-23.5l13.1.2s20.5 23.8 21.8 23.3l20-7.5c1.4-.6-.2-32.1-.2-32.1l9.1-9.1s29.2.9 29.7-.5l8.1-19.8c.7-1.1-20.9-20.7-20.9-20.7zm-44.9-8.7c.7 17.1-12.8 31.6-30.1 32.4-17.3.8-32.1-12.5-32.8-29.6-.7-17.1 12.8-31.6 30.1-32.3 17.3-.8 32.1 12.5 32.8 29.5zm201.2-37.9l-97-97-.1.1c-75.1-73.3-195.4-72.8-269.8 1.6-50.9 51-27.8 27.9-95.7 95.3-22.3 22.3-22.3 58.7 0 81 69.9 69.4 46.4 46 97.4 97l.1-.1c75.1 73.3 195.4 72.9 269.8-1.6 51-50.9 27.9-27.9 95.3-95.3 22.3-22.3 22.3-58.7 0-81zM140.4 363.8c-59.6-59.5-59.6-156 0-215.5 59.5-59.6 156-59.5 215.6 0 59.5 59.5 59.6 156 0 215.6-59.6 59.5-156 59.4-215.6-.1z"
                }
            }
        ]
    })(props);
}
function FaPhoenixFramework(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M212.9 344.3c3.8-.1 22.8-1.4 25.6-2.2-2.4-2.6-43.6-1-68-49.6-4.3-8.6-7.5-17.6-6.4-27.6 2.9-25.5 32.9-30 52-18.5 36 21.6 63.3 91.3 113.7 97.5 37 4.5 84.6-17 108.2-45.4-.6-.1-.8-.2-1-.1-.4.1-.8.2-1.1.3-33.3 12.1-94.3 9.7-134.7-14.8-37.6-22.8-53.1-58.7-51.8-74.6 1.8-21.3 22.9-23.2 35.9-19.6 14.4 3.9 24.4 17.6 38.9 27.4 15.6 10.4 32.9 13.7 51.3 10.3 14.9-2.7 34.4-12.3 36.5-14.5-1.1-.1-1.8-.1-2.5-.2-6.2-.6-12.4-.8-18.5-1.7C279.8 194.5 262.1 47.4 138.5 37.9 94.2 34.5 39.1 46 2.2 72.9c-.8.6-1.5 1.2-2.2 1.8.1.2.1.3.2.5.8 0 1.6-.1 2.4-.2 6.3-1 12.5-.8 18.7.3 23.8 4.3 47.7 23.1 55.9 76.5 5.3 34.3-.7 50.8 8 86.1 19 77.1 91 107.6 127.7 106.4zM75.3 64.9c-.9-1-.9-1.2-1.3-2 12.1-2.6 24.2-4.1 36.6-4.8-1.1 14.7-22.2 21.3-35.3 6.8zm196.9 350.5c-42.8 1.2-92-26.7-123.5-61.4-4.6-5-16.8-20.2-18.6-23.4l.4-.4c6.6 4.1 25.7 18.6 54.8 27 24.2 7 48.1 6.3 71.6-3.3 22.7-9.3 41-.5 43.1 2.9-18.5 3.8-20.1 4.4-24 7.9-5.1 4.4-4.6 11.7 7 17.2 26.2 12.4 63-2.8 97.2 25.4 2.4 2 8.1 7.8 10.1 10.7-.1.2-.3.3-.4.5-4.8-1.5-16.4-7.5-40.2-9.3-24.7-2-46.3 5.3-77.5 6.2zm174.8-252c16.4-5.2 41.3-13.4 66.5-3.3 16.1 6.5 26.2 18.7 32.1 34.6 3.5 9.4 5.1 19.7 5.1 28.7-.2 0-.4 0-.6.1-.2-.4-.4-.9-.5-1.3-5-22-29.9-43.8-67.6-29.9-50.2 18.6-130.4 9.7-176.9-48-.7-.9-2.4-1.7-1.3-3.2.1-.2 2.1.6 3 1.3 18.1 13.4 38.3 21.9 60.3 26.2 30.5 6.1 54.6 2.9 79.9-5.2zm102.7 117.5c-32.4.2-33.8 50.1-103.6 64.4-18.2 3.7-38.7 4.6-44.9 4.2v-.4c2.8-1.5 14.7-2.6 29.7-16.6 7.9-7.3 15.3-15.1 22.8-22.9 19.5-20.2 41.4-42.2 81.9-39 23.1 1.8 29.3 8.2 36.1 12.7.3.2.4.5.7.9-.5 0-.7.1-.9 0-7-2.7-14.3-3.3-21.8-3.3zm-12.3-24.1c-.1.2-.1.4-.2.6-28.9-4.4-48-7.9-68.5 4-17 9.9-31.4 20.5-62 24.4-27.1 3.4-45.1 2.4-66.1-8-.3-.2-.6-.4-1-.6 0-.2.1-.3.1-.5 24.9 3.8 36.4 5.1 55.5-5.8 22.3-12.9 40.1-26.6 71.3-31 29.6-4.1 51.3 2.5 70.9 16.9zM268.6 97.3c-.6-.6-1.1-1.2-2.1-2.3 7.6 0 29.7-1.2 53.4 8.4 19.7 8 32.2 21 50.2 32.9 11.1 7.3 23.4 9.3 36.4 8.1 4.3-.4 8.5-1.2 12.8-1.7.4-.1.9 0 1.5.3-.6.4-1.2.9-1.8 1.2-8.1 4-16.7 6.3-25.6 7.1-26.1 2.6-50.3-3.7-73.4-15.4-19.3-9.9-36.4-22.9-51.4-38.6zM640 335.7c-3.5 3.1-22.7 11.6-42.7 5.3-12.3-3.9-19.5-14.9-31.6-24.1-10-7.6-20.9-7.9-28.1-8.4.6-.8.9-1.2 1.2-1.4 14.8-9.2 30.5-12.2 47.3-6.5 12.5 4.2 19.2 13.5 30.4 24.2 10.8 10.4 21 9.9 23.1 10.5.1-.1.2 0 .4.4zm-212.5 137c2.2 1.2 1.6 1.5 1.5 2-18.5-1.4-33.9-7.6-46.8-22.2-21.8-24.7-41.7-27.9-48.6-29.7.5-.2.8-.4 1.1-.4 13.1.1 26.1.7 38.9 3.9 25.3 6.4 35 25.4 41.6 35.3 3.2 4.8 7.3 8.3 12.3 11.1z"
                }
            }
        ]
    })(props);
}
function FaPhoenixSquadron(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M96 63.38C142.49 27.25 201.55 7.31 260.51 8.81c29.58-.38 59.11 5.37 86.91 15.33-24.13-4.63-49-6.34-73.38-2.45C231.17 27 191 48.84 162.21 80.87c5.67-1 10.78-3.67 16-5.86 18.14-7.87 37.49-13.26 57.23-14.83 19.74-2.13 39.64-.43 59.28 1.92-14.42 2.79-29.12 4.57-43 9.59-34.43 11.07-65.27 33.16-86.3 62.63-13.8 19.71-23.63 42.86-24.67 67.13-.35 16.49 5.22 34.81 19.83 44a53.27 53.27 0 0 0 37.52 6.74c15.45-2.46 30.07-8.64 43.6-16.33 11.52-6.82 22.67-14.55 32-24.25 3.79-3.22 2.53-8.45 2.62-12.79-2.12-.34-4.38-1.11-6.3.3a203 203 0 0 1-35.82 15.37c-20 6.17-42.16 8.46-62.1.78 12.79 1.73 26.06.31 37.74-5.44 20.23-9.72 36.81-25.2 54.44-38.77a526.57 526.57 0 0 1 88.9-55.31c25.71-12 52.94-22.78 81.57-24.12-15.63 13.72-32.15 26.52-46.78 41.38-14.51 14-27.46 29.5-40.11 45.18-3.52 4.6-8.95 6.94-13.58 10.16a150.7 150.7 0 0 0-51.89 60.1c-9.33 19.68-14.5 41.85-11.77 63.65 1.94 13.69 8.71 27.59 20.9 34.91 12.9 8 29.05 8.07 43.48 5.1 32.8-7.45 61.43-28.89 81-55.84 20.44-27.52 30.52-62.2 29.16-96.35-.52-7.5-1.57-15-1.66-22.49 8 19.48 14.82 39.71 16.65 60.83 2 14.28.75 28.76-1.62 42.9-1.91 11-5.67 21.51-7.78 32.43a165 165 0 0 0 39.34-81.07 183.64 183.64 0 0 0-14.21-104.64c20.78 32 32.34 69.58 35.71 107.48.49 12.73.49 25.51 0 38.23A243.21 243.21 0 0 1 482 371.34c-26.12 47.34-68 85.63-117.19 108-78.29 36.23-174.68 31.32-248-14.68A248.34 248.34 0 0 1 25.36 366 238.34 238.34 0 0 1 0 273.08v-31.34C3.93 172 40.87 105.82 96 63.38m222 80.33a79.13 79.13 0 0 0 16-4.48c5-1.77 9.24-5.94 10.32-11.22-8.96 4.99-17.98 9.92-26.32 15.7z"
                }
            }
        ]
    })(props);
}
function FaPhp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M320 104.5c171.4 0 303.2 72.2 303.2 151.5S491.3 407.5 320 407.5c-171.4 0-303.2-72.2-303.2-151.5S148.7 104.5 320 104.5m0-16.8C143.3 87.7 0 163 0 256s143.3 168.3 320 168.3S640 349 640 256 496.7 87.7 320 87.7zM218.2 242.5c-7.9 40.5-35.8 36.3-70.1 36.3l13.7-70.6c38 0 63.8-4.1 56.4 34.3zM97.4 350.3h36.7l8.7-44.8c41.1 0 66.6 3 90.2-19.1 26.1-24 32.9-66.7 14.3-88.1-9.7-11.2-25.3-16.7-46.5-16.7h-70.7L97.4 350.3zm185.7-213.6h36.5l-8.7 44.8c31.5 0 60.7-2.3 74.8 10.7 14.8 13.6 7.7 31-8.3 113.1h-37c15.4-79.4 18.3-86 12.7-92-5.4-5.8-17.7-4.6-47.4-4.6l-18.8 96.6h-36.5l32.7-168.6zM505 242.5c-8 41.1-36.7 36.3-70.1 36.3l13.7-70.6c38.2 0 63.8-4.1 56.4 34.3zM384.2 350.3H421l8.7-44.8c43.2 0 67.1 2.5 90.2-19.1 26.1-24 32.9-66.7 14.3-88.1-9.7-11.2-25.3-16.7-46.5-16.7H417l-32.8 168.7z"
                }
            }
        ]
    })(props);
}
function FaPiedPiperAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M244 246c-3.2-2-6.3-2.9-10.1-2.9-6.6 0-12.6 3.2-19.3 3.7l1.7 4.9zm135.9 197.9c-19 0-64.1 9.5-79.9 19.8l6.9 45.1c35.7 6.1 70.1 3.6 106-9.8-4.8-10-23.5-55.1-33-55.1zM340.8 177c6.6 2.8 11.5 9.2 22.7 22.1 2-1.4 7.5-5.2 7.5-8.6 0-4.9-11.8-13.2-13.2-23 11.2-5.7 25.2-6 37.6-8.9 68.1-16.4 116.3-52.9 146.8-116.7C548.3 29.3 554 16.1 554.6 2l-2 2.6c-28.4 50-33 63.2-81.3 100-31.9 24.4-69.2 40.2-106.6 54.6l-6.3-.3v-21.8c-19.6 1.6-19.7-14.6-31.6-23-18.7 20.6-31.6 40.8-58.9 51.1-12.7 4.8-19.6 10-25.9 21.8 34.9-16.4 91.2-13.5 98.8-10zM555.5 0l-.6 1.1-.3.9.6-.6zm-59.2 382.1c-33.9-56.9-75.3-118.4-150-115.5l-.3-6c-1.1-13.5 32.8 3.2 35.1-31l-14.4 7.2c-19.8-45.7-8.6-54.3-65.5-54.3-14.7 0-26.7 1.7-41.4 4.6 2.9 18.6 2.2 36.7-10.9 50.3l19.5 5.5c-1.7 3.2-2.9 6.3-2.9 9.8 0 21 42.8 2.9 42.8 33.6 0 18.4-36.8 60.1-54.9 60.1-8 0-53.7-50-53.4-60.1l.3-4.6 52.3-11.5c13-2.6 12.3-22.7-2.9-22.7-3.7 0-43.1 9.2-49.4 10.6-2-5.2-7.5-14.1-13.8-14.1-3.2 0-6.3 3.2-9.5 4-9.2 2.6-31 2.9-21.5 20.1L15.9 298.5c-5.5 1.1-8.9 6.3-8.9 11.8 0 6 5.5 10.9 11.5 10.9 8 0 131.3-28.4 147.4-32.2 2.6 3.2 4.6 6.3 7.8 8.6 20.1 14.4 59.8 85.9 76.4 85.9 24.1 0 58-22.4 71.3-41.9 3.2-4.3 6.9-7.5 12.4-6.9.6 13.8-31.6 34.2-33 43.7-1.4 10.2-1 35.2-.3 41.1 26.7 8.1 52-3.6 77.9-2.9 4.3-21 10.6-41.9 9.8-63.5l-.3-9.5c-1.4-34.2-10.9-38.5-34.8-58.6-1.1-1.1-2.6-2.6-3.7-4 2.2-1.4 1.1-1 4.6-1.7 88.5 0 56.3 183.6 111.5 229.9 33.1-15 72.5-27.9 103.5-47.2-29-25.6-52.6-45.7-72.7-79.9zm-196.2 46.1v27.2l11.8-3.4-2.9-23.8zm-68.7-150.4l24.1 61.2 21-13.8-31.3-50.9zm84.4 154.9l2 12.4c9-1.5 58.4-6.6 58.4-14.1 0-1.4-.6-3.2-.9-4.6-26.8 0-36.9 3.8-59.5 6.3z"
                }
            }
        ]
    })(props);
}
function FaPiedPiperHat(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M640 24.9c-80.8 53.6-89.4 92.5-96.4 104.4-6.7 12.2-11.7 60.3-23.3 83.6-11.7 23.6-54.2 42.2-66.1 50-11.7 7.8-28.3 38.1-41.9 64.2-108.1-4.4-167.4 38.8-259.2 93.6 29.4-9.7 43.3-16.7 43.3-16.7 94.2-36 139.3-68.3 281.1-49.2 1.1 0 1.9.6 2.8.8 3.9 2.2 5.3 6.9 3.1 10.8l-53.9 95.8c-2.5 4.7-7.8 7.2-13.1 6.1-126.8-23.8-226.9 17.3-318.9 18.6C24.1 488 0 453.4 0 451.8c0-1.1.6-1.7 1.7-1.7 0 0 38.3 0 103.1-15.3C178.4 294.5 244 245.4 315.4 245.4c0 0 71.7 0 90.6 61.9 22.8-39.7 28.3-49.2 28.3-49.2 5.3-9.4 35-77.2 86.4-141.4 51.5-64 90.4-79.9 119.3-91.8z"
                }
            }
        ]
    })(props);
}
function FaPiedPiperPp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M205.3 174.6c0 21.1-14.2 38.1-31.7 38.1-7.1 0-12.8-1.2-17.2-3.7v-68c4.4-2.7 10.1-4.2 17.2-4.2 17.5 0 31.7 16.9 31.7 37.8zm52.6 67c-7.1 0-12.8 1.5-17.2 4.2v68c4.4 2.5 10.1 3.7 17.2 3.7 17.4 0 31.7-16.9 31.7-37.8 0-21.1-14.3-38.1-31.7-38.1zM448 80v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h352c26.5 0 48 21.5 48 48zM185 255.1c41 0 74.2-35.6 74.2-79.6 0-44-33.2-79.6-74.2-79.6-12 0-24.1 3.2-34.6 8.8h-45.7V311l51.8-10.1v-50.6c8.6 3.1 18.1 4.8 28.5 4.8zm158.4 25.3c0-44-33.2-79.6-73.9-79.6-3.2 0-6.4.2-9.6.7-3.7 12.5-10.1 23.8-19.2 33.4-13.8 15-32.2 23.8-51.8 24.8V416l51.8-10.1v-50.6c8.6 3.2 18.2 4.7 28.7 4.7 40.8 0 74-35.6 74-79.6z"
                }
            }
        ]
    })(props);
}
function FaPiedPiperSquare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M32 419L0 479.2l.8-328C.8 85.3 54 32 120 32h327.2c-93 28.9-189.9 94.2-253.9 168.6C122.7 282 82.6 338 32 419M448 32S305.2 98.8 261.6 199.1c-23.2 53.6-28.9 118.1-71 158.6-28.9 27.8-69.8 38.2-105.3 56.3-23.2 12-66.4 40.5-84.9 66h328.4c66 0 119.3-53.3 119.3-119.2-.1 0-.1-328.8-.1-328.8z"
                }
            }
        ]
    })(props);
}
function FaPiedPiper(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 480 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M455.93,23.2C429.23,30,387.79,51.69,341.35,90.66A206,206,0,0,0,240,64C125.13,64,32,157.12,32,272s93.13,208,208,208,208-93.13,208-208a207.25,207.25,0,0,0-58.75-144.81,155.35,155.35,0,0,0-17,27.4A176.16,176.16,0,0,1,417.1,272c0,97.66-79.44,177.11-177.09,177.11a175.81,175.81,0,0,1-87.63-23.4c82.94-107.33,150.79-37.77,184.31-226.65,5.79-32.62,28-94.26,126.23-160.18C471,33.45,465.35,20.8,455.93,23.2ZM125,406.4A176.66,176.66,0,0,1,62.9,272C62.9,174.34,142.35,94.9,240,94.9a174,174,0,0,1,76.63,17.75C250.64,174.76,189.77,265.52,125,406.4Z"
                }
            }
        ]
    })(props);
}
function FaPinterestP(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M204 6.5C101.4 6.5 0 74.9 0 185.6 0 256 39.6 296 63.6 296c9.9 0 15.6-27.6 15.6-35.4 0-9.3-23.7-29.1-23.7-67.8 0-80.4 61.2-137.4 140.4-137.4 68.1 0 118.5 38.7 118.5 109.8 0 53.1-21.3 152.7-90.3 152.7-24.9 0-46.2-18-46.2-43.8 0-37.8 26.4-74.4 26.4-113.4 0-66.2-93.9-54.2-93.9 25.8 0 16.8 2.1 35.4 9.6 50.7-13.8 59.4-42 147.9-42 209.1 0 18.9 2.7 37.5 4.5 56.4 3.4 3.8 1.7 3.4 6.9 1.5 50.4-69 48.6-82.5 71.4-172.8 12.3 23.4 44.1 36 69.3 36 106.2 0 153.9-103.5 153.9-196.8C384 71.3 298.2 6.5 204 6.5z"
                }
            }
        ]
    })(props);
}
function FaPinterestSquare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M448 80v352c0 26.5-21.5 48-48 48H154.4c9.8-16.4 22.4-40 27.4-59.3 3-11.5 15.3-58.4 15.3-58.4 8 15.3 31.4 28.2 56.3 28.2 74.1 0 127.4-68.1 127.4-152.7 0-81.1-66.2-141.8-151.4-141.8-106 0-162.2 71.1-162.2 148.6 0 36 19.2 80.8 49.8 95.1 4.7 2.2 7.1 1.2 8.2-3.3.8-3.4 5-20.1 6.8-27.8.6-2.5.3-4.6-1.7-7-10.1-12.3-18.3-34.9-18.3-56 0-54.2 41-106.6 110.9-106.6 60.3 0 102.6 41.1 102.6 99.9 0 66.4-33.5 112.4-77.2 112.4-24.1 0-42.1-19.9-36.4-44.4 6.9-29.2 20.3-60.7 20.3-81.8 0-53-75.5-45.7-75.5 25 0 21.7 7.3 36.5 7.3 36.5-31.4 132.8-36.1 134.5-29.6 192.6l2.2.8H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h352c26.5 0 48 21.5 48 48z"
                }
            }
        ]
    })(props);
}
function FaPinterest(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M496 256c0 137-111 248-248 248-25.6 0-50.2-3.9-73.4-11.1 10.1-16.5 25.2-43.5 30.8-65 3-11.6 15.4-59 15.4-59 8.1 15.4 31.7 28.5 56.8 28.5 74.8 0 128.7-68.8 128.7-154.3 0-81.9-66.9-143.2-152.9-143.2-107 0-163.9 71.8-163.9 150.1 0 36.4 19.4 81.7 50.3 96.1 4.7 2.2 7.2 1.2 8.3-3.3.8-3.4 5-20.3 6.9-28.1.6-2.5.3-4.7-1.7-7.1-10.1-12.5-18.3-35.3-18.3-56.6 0-54.7 41.4-107.6 112-107.6 60.9 0 103.6 41.5 103.6 100.9 0 67.1-33.9 113.6-78 113.6-24.3 0-42.6-20.1-36.7-44.8 7-29.5 20.5-61.3 20.5-82.6 0-19-10.2-34.9-31.4-34.9-24.9 0-44.9 25.7-44.9 60.2 0 22 7.4 36.8 7.4 36.8s-24.5 103.8-29 123.2c-5 21.4-3 51.6-.9 71.2C65.4 450.9 0 361.1 0 256 0 119 111 8 248 8s248 111 248 248z"
                }
            }
        ]
    })(props);
}
function FaPlaystation(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M570.9 372.3c-11.3 14.2-38.8 24.3-38.8 24.3L327 470.2v-54.3l150.9-53.8c17.1-6.1 19.8-14.8 5.8-19.4-13.9-4.6-39.1-3.3-56.2 2.9L327 381.1v-56.4c23.2-7.8 47.1-13.6 75.7-16.8 40.9-4.5 90.9.6 130.2 15.5 44.2 14 49.2 34.7 38 48.9zm-224.4-92.5v-139c0-16.3-3-31.3-18.3-35.6-11.7-3.8-19 7.1-19 23.4v347.9l-93.8-29.8V32c39.9 7.4 98 24.9 129.2 35.4C424.1 94.7 451 128.7 451 205.2c0 74.5-46 102.8-104.5 74.6zM43.2 410.2c-45.4-12.8-53-39.5-32.3-54.8 19.1-14.2 51.7-24.9 51.7-24.9l134.5-47.8v54.5l-96.8 34.6c-17.1 6.1-19.7 14.8-5.8 19.4 13.9 4.6 39.1 3.3 56.2-2.9l46.4-16.9v48.8c-51.6 9.3-101.4 7.3-153.9-10z"
                }
            }
        ]
    })(props);
}
function FaProductHunt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M326.3 218.8c0 20.5-16.7 37.2-37.2 37.2h-70.3v-74.4h70.3c20.5 0 37.2 16.7 37.2 37.2zM504 256c0 137-111 248-248 248S8 393 8 256 119 8 256 8s248 111 248 248zm-128.1-37.2c0-47.9-38.9-86.8-86.8-86.8H169.2v248h49.6v-74.4h70.3c47.9 0 86.8-38.9 86.8-86.8z"
                }
            }
        ]
    })(props);
}
function FaPushed(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 432 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M407 111.9l-98.5-9 14-33.4c10.4-23.5-10.8-40.4-28.7-37L22.5 76.9c-15.1 2.7-26 18.3-21.4 36.6l105.1 348.3c6.5 21.3 36.7 24.2 47.7 7l35.3-80.8 235.2-231.3c16.4-16.8 4.3-42.9-17.4-44.8zM297.6 53.6c5.1-.7 7.5 2.5 5.2 7.4L286 100.9 108.6 84.6l189-31zM22.7 107.9c-3.1-5.1 1-10 6.1-9.1l248.7 22.7-96.9 230.7L22.7 107.9zM136 456.4c-2.6 4-7.9 3.1-9.4-1.2L43.5 179.7l127.7 197.6c-7 15-35.2 79.1-35.2 79.1zm272.8-314.5L210.1 337.3l89.7-213.7 106.4 9.7c4 1.1 5.7 5.3 2.6 8.6z"
                }
            }
        ]
    })(props);
}
function FaPython(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M439.8 200.5c-7.7-30.9-22.3-54.2-53.4-54.2h-40.1v47.4c0 36.8-31.2 67.8-66.8 67.8H172.7c-29.2 0-53.4 25-53.4 54.3v101.8c0 29 25.2 46 53.4 54.3 33.8 9.9 66.3 11.7 106.8 0 26.9-7.8 53.4-23.5 53.4-54.3v-40.7H226.2v-13.6h160.2c31.1 0 42.6-21.7 53.4-54.2 11.2-33.5 10.7-65.7 0-108.6zM286.2 404c11.1 0 20.1 9.1 20.1 20.3 0 11.3-9 20.4-20.1 20.4-11 0-20.1-9.2-20.1-20.4.1-11.3 9.1-20.3 20.1-20.3zM167.8 248.1h106.8c29.7 0 53.4-24.5 53.4-54.3V91.9c0-29-24.4-50.7-53.4-55.6-35.8-5.9-74.7-5.6-106.8.1-45.2 8-53.4 24.7-53.4 55.6v40.7h106.9v13.6h-147c-31.1 0-58.3 18.7-66.8 54.2-9.8 40.7-10.2 66.1 0 108.6 7.6 31.6 25.7 54.2 56.8 54.2H101v-48.8c0-35.3 30.5-66.4 66.8-66.4zm-6.7-142.6c-11.1 0-20.1-9.1-20.1-20.3.1-11.3 9-20.4 20.1-20.4 11 0 20.1 9.2 20.1 20.4s-9 20.3-20.1 20.3z"
                }
            }
        ]
    })(props);
}
function FaQq(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M433.754 420.445c-11.526 1.393-44.86-52.741-44.86-52.741 0 31.345-16.136 72.247-51.051 101.786 16.842 5.192 54.843 19.167 45.803 34.421-7.316 12.343-125.51 7.881-159.632 4.037-34.122 3.844-152.316 8.306-159.632-4.037-9.045-15.25 28.918-29.214 45.783-34.415-34.92-29.539-51.059-70.445-51.059-101.792 0 0-33.334 54.134-44.859 52.741-5.37-.65-12.424-29.644 9.347-99.704 10.261-33.024 21.995-60.478 40.144-105.779C60.683 98.063 108.982.006 224 0c113.737.006 163.156 96.133 160.264 214.963 18.118 45.223 29.912 72.85 40.144 105.778 21.768 70.06 14.716 99.053 9.346 99.704z"
                }
            }
        ]
    })(props);
}
function FaQuinscape(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M313.6 474.6h-1a158.1 158.1 0 0 1 0-316.2c94.9 0 168.2 83.1 157 176.6 4 5.1 8.2 9.6 11.2 15.3 13.4-30.3 20.3-62.4 20.3-97.7C501.1 117.5 391.6 8 256.5 8S12 117.5 12 252.6s109.5 244.6 244.5 244.6a237.36 237.36 0 0 0 70.4-10.1c-5.2-3.5-8.9-8.1-13.3-12.5zm-.1-.1l.4.1zm78.4-168.9a99.2 99.2 0 1 0 99.2 99.2 99.18 99.18 0 0 0-99.2-99.2z"
                }
            }
        ]
    })(props);
}
function FaQuora(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M440.5 386.7h-29.3c-1.5 13.5-10.5 30.8-33 30.8-20.5 0-35.3-14.2-49.5-35.8 44.2-34.2 74.7-87.5 74.7-153C403.5 111.2 306.8 32 205 32 105.3 32 7.3 111.7 7.3 228.7c0 134.1 131.3 221.6 249 189C276 451.3 302 480 351.5 480c81.8 0 90.8-75.3 89-93.3zM297 329.2C277.5 300 253.3 277 205.5 277c-30.5 0-54.3 10-69 22.8l12.2 24.3c6.2-3 13-4 19.8-4 35.5 0 53.7 30.8 69.2 61.3-10 3-20.7 4.2-32.7 4.2-75 0-107.5-53-107.5-156.7C97.5 124.5 130 71 205 71c76.2 0 108.7 53.5 108.7 157.7.1 41.8-5.4 75.6-16.7 100.5z"
                }
            }
        ]
    })(props);
}
function FaRProject(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 581 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M581 226.6C581 119.1 450.9 32 290.5 32S0 119.1 0 226.6C0 322.4 103.3 402 239.4 418.1V480h99.1v-61.5c24.3-2.7 47.6-7.4 69.4-13.9L448 480h112l-67.4-113.7c54.5-35.4 88.4-84.9 88.4-139.7zm-466.8 14.5c0-73.5 98.9-133 220.8-133s211.9 40.7 211.9 133c0 50.1-26.5 85-70.3 106.4-2.4-1.6-4.7-2.9-6.4-3.7-10.2-5.2-27.8-10.5-27.8-10.5s86.6-6.4 86.6-92.7-90.6-87.9-90.6-87.9h-199V361c-74.1-21.5-125.2-67.1-125.2-119.9zm225.1 38.3v-55.6c57.8 0 87.8-6.8 87.8 27.3 0 36.5-38.2 28.3-87.8 28.3zm-.9 72.5H365c10.8 0 18.9 11.7 24 19.2-16.1 1.9-33 2.8-50.6 2.9v-22.1z"
                }
            }
        ]
    })(props);
}
function FaRaspberryPi(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 407 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M372 232.5l-3.7-6.5c.1-46.4-21.4-65.3-46.5-79.7 7.6-2 15.4-3.6 17.6-13.2 13.1-3.3 15.8-9.4 17.1-15.8 3.4-2.3 14.8-8.7 13.6-19.7 6.4-4.4 10-10.1 8.1-18.1 6.9-7.5 8.7-13.7 5.8-19.4 8.3-10.3 4.6-15.6 1.1-20.9 6.2-11.2.7-23.2-16.6-21.2-6.9-10.1-21.9-7.8-24.2-7.8-2.6-3.2-6-6-16.5-4.7-6.8-6.1-14.4-5-22.3-2.1-9.3-7.3-15.5-1.4-22.6.8C271.6.6 269 5.5 263.5 7.6c-12.3-2.6-16.1 3-22 8.9l-6.9-.1c-18.6 10.8-27.8 32.8-31.1 44.1-3.3-11.3-12.5-33.3-31.1-44.1l-6.9.1c-5.9-5.9-9.7-11.5-22-8.9-5.6-2-8.1-7-19.4-3.4-4.6-1.4-8.9-4.4-13.9-4.3-2.6.1-5.5 1-8.7 3.5-7.9-3-15.5-4-22.3 2.1-10.5-1.3-14 1.4-16.5 4.7-2.3 0-17.3-2.3-24.2 7.8C21.2 16 15.8 28 22 39.2c-3.5 5.4-7.2 10.7 1.1 20.9-2.9 5.7-1.1 11.9 5.8 19.4-1.8 8 1.8 13.7 8.1 18.1-1.2 11 10.2 17.4 13.6 19.7 1.3 6.4 4 12.4 17.1 15.8 2.2 9.5 10 11.2 17.6 13.2-25.1 14.4-46.6 33.3-46.5 79.7l-3.7 6.5c-28.8 17.2-54.7 72.7-14.2 117.7 2.6 14.1 7.1 24.2 11 35.4 5.9 45.2 44.5 66.3 54.6 68.8 14.9 11.2 30.8 21.8 52.2 29.2C159 504.2 181 512 203 512h1c22.1 0 44-7.8 64.2-28.4 21.5-7.4 37.3-18 52.2-29.2 10.2-2.5 48.7-23.6 54.6-68.8 3.9-11.2 8.4-21.3 11-35.4 40.6-45.1 14.7-100.5-14-117.7zm-22.2-8c-1.5 18.7-98.9-65.1-82.1-67.9 45.7-7.5 83.6 19.2 82.1 67.9zm-43 93.1c-24.5 15.8-59.8 5.6-78.8-22.8s-14.6-64.2 9.9-80c24.5-15.8 59.8-5.6 78.8 22.8s14.6 64.2-9.9 80zM238.9 29.3c.8 4.2 1.8 6.8 2.9 7.6 5.4-5.8 9.8-11.7 16.8-17.3 0 3.3-1.7 6.8 2.5 9.4 3.7-5 8.8-9.5 15.5-13.3-3.2 5.6-.6 7.3 1.2 9.6 5.1-4.4 10-8.8 19.4-12.3-2.6 3.1-6.2 6.2-2.4 9.8 5.3-3.3 10.6-6.6 23.1-8.9-2.8 3.1-8.7 6.3-5.1 9.4 6.6-2.5 14-4.4 22.1-5.4-3.9 3.2-7.1 6.3-3.9 8.8 7.1-2.2 16.9-5.1 26.4-2.6l-6 6.1c-.7.8 14.1.6 23.9.8-3.6 5-7.2 9.7-9.3 18.2 1 1 5.8.4 10.4 0-4.7 9.9-12.8 12.3-14.7 16.6 2.9 2.2 6.8 1.6 11.2.1-3.4 6.9-10.4 11.7-16 17.3 1.4 1 3.9 1.6 9.7.9-5.2 5.5-11.4 10.5-18.8 15 1.3 1.5 5.8 1.5 10 1.6-6.7 6.5-15.3 9.9-23.4 14.2 4 2.7 6.9 2.1 10 2.1-5.7 4.7-15.4 7.1-24.4 10 1.7 2.7 3.4 3.4 7.1 4.1-9.5 5.3-23.2 2.9-27 5.6.9 2.7 3.6 4.4 6.7 5.8-15.4.9-57.3-.6-65.4-32.3 15.7-17.3 44.4-37.5 93.7-62.6-38.4 12.8-73 30-102 53.5-34.3-15.9-10.8-55.9 5.8-71.8zm-34.4 114.6c24.2-.3 54.1 17.8 54 34.7-.1 15-21 27.1-53.8 26.9-32.1-.4-53.7-15.2-53.6-29.8 0-11.9 26.2-32.5 53.4-31.8zm-123-12.8c3.7-.7 5.4-1.5 7.1-4.1-9-2.8-18.7-5.3-24.4-10 3.1 0 6 .7 10-2.1-8.1-4.3-16.7-7.7-23.4-14.2 4.2-.1 8.7 0 10-1.6-7.4-4.5-13.6-9.5-18.8-15 5.8.7 8.3.1 9.7-.9-5.6-5.6-12.7-10.4-16-17.3 4.3 1.5 8.3 2 11.2-.1-1.9-4.2-10-6.7-14.7-16.6 4.6.4 9.4 1 10.4 0-2.1-8.5-5.8-13.3-9.3-18.2 9.8-.1 24.6 0 23.9-.8l-6-6.1c9.5-2.5 19.3.4 26.4 2.6 3.2-2.5-.1-5.6-3.9-8.8 8.1 1.1 15.4 2.9 22.1 5.4 3.5-3.1-2.3-6.3-5.1-9.4 12.5 2.3 17.8 5.6 23.1 8.9 3.8-3.6.2-6.7-2.4-9.8 9.4 3.4 14.3 7.9 19.4 12.3 1.7-2.3 4.4-4 1.2-9.6 6.7 3.8 11.8 8.3 15.5 13.3 4.1-2.6 2.5-6.2 2.5-9.4 7 5.6 11.4 11.5 16.8 17.3 1.1-.8 2-3.4 2.9-7.6 16.6 15.9 40.1 55.9 6 71.8-29-23.5-63.6-40.7-102-53.5 49.3 25 78 45.3 93.7 62.6-8 31.8-50 33.2-65.4 32.3 3.1-1.4 5.8-3.2 6.7-5.8-4-2.8-17.6-.4-27.2-5.6zm60.1 24.1c16.8 2.8-80.6 86.5-82.1 67.9-1.5-48.7 36.5-75.5 82.1-67.9zM38.2 342c-23.7-18.8-31.3-73.7 12.6-98.3 26.5-7 9 107.8-12.6 98.3zm91 98.2c-13.3 7.9-45.8 4.7-68.8-27.9-15.5-27.4-13.5-55.2-2.6-63.4 16.3-9.8 41.5 3.4 60.9 25.6 16.9 20 24.6 55.3 10.5 65.7zm-26.4-119.7c-24.5-15.8-28.9-51.6-9.9-80s54.3-38.6 78.8-22.8 28.9 51.6 9.9 80c-19.1 28.4-54.4 38.6-78.8 22.8zM205 496c-29.4 1.2-58.2-23.7-57.8-32.3-.4-12.7 35.8-22.6 59.3-22 23.7-1 55.6 7.5 55.7 18.9.5 11-28.8 35.9-57.2 35.4zm58.9-124.9c.2 29.7-26.2 53.8-58.8 54-32.6.2-59.2-23.8-59.4-53.4v-.6c-.2-29.7 26.2-53.8 58.8-54 32.6-.2 59.2 23.8 59.4 53.4v.6zm82.2 42.7c-25.3 34.6-59.6 35.9-72.3 26.3-13.3-12.4-3.2-50.9 15.1-72 20.9-23.3 43.3-38.5 58.9-26.6 10.5 10.3 16.7 49.1-1.7 72.3zm22.9-73.2c-21.5 9.4-39-105.3-12.6-98.3 43.9 24.7 36.3 79.6 12.6 98.3z"
                }
            }
        ]
    })(props);
}
function FaRavelry(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M498.252,234.223c-1.208-10.34-1.7-20.826-3.746-31a310.306,310.306,0,0,0-9.622-36.6,184.068,184.068,0,0,0-30.874-57.5,251.154,251.154,0,0,0-18.818-21.689,237.362,237.362,0,0,0-47.113-36.116A240.8,240.8,0,0,0,331.356,26.65c-11.018-3.1-22.272-5.431-33.515-7.615-6.78-1.314-13.749-1.667-20.627-2.482-.316-.036-.6-.358-.9-.553q-16.143.009-32.288.006c-2.41.389-4.808.925-7.236,1.15a179.331,179.331,0,0,0-34.256,7.1,221.5,221.5,0,0,0-39.768,16.355,281.385,281.385,0,0,0-38.08,24.158c-6.167,4.61-12.268,9.36-17.974,14.518C96.539,88.494,86.34,97.72,76.785,107.555a243.878,243.878,0,0,0-33.648,43.95,206.488,206.488,0,0,0-20.494,44.6,198.2,198.2,0,0,0-7.691,34.759A201.13,201.13,0,0,0,13.4,266.385a299.716,299.716,0,0,0,4.425,40.24,226.865,226.865,0,0,0,16.73,53.3,210.543,210.543,0,0,0,24,39.528,213.589,213.589,0,0,0,26.358,28.416A251.313,251.313,0,0,0,126.7,458.455a287.831,287.831,0,0,0,55.9,25.277,269.5,269.5,0,0,0,40.641,9.835c6.071,1.01,12.275,1.253,18.412,1.873a4.149,4.149,0,0,1,1.19.56h32.289c2.507-.389,5-.937,7.527-1.143,16.336-1.332,32.107-5.335,47.489-10.717A219.992,219.992,0,0,0,379.1,460.322c9.749-6.447,19.395-13.077,28.737-20.1,5.785-4.348,10.988-9.5,16.3-14.457,3.964-3.7,7.764-7.578,11.51-11.5a232.162,232.162,0,0,0,31.427-41.639c9.542-16.045,17.355-32.905,22.3-50.926,2.859-10.413,4.947-21.045,7.017-31.652,1.032-5.279,1.251-10.723,1.87-16.087.036-.317.358-.6.552-.9V236.005A9.757,9.757,0,0,1,498.252,234.223Zm-161.117-1.15s-16.572-2.98-28.47-2.98c-27.2,0-33.57,14.9-33.57,37.04V360.8H201.582V170.062H275.1v31.931c8.924-26.822,26.771-36.189,62.04-36.189Z"
                }
            }
        ]
    })(props);
}
function FaReact(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M418.2 177.2c-5.4-1.8-10.8-3.5-16.2-5.1.9-3.7 1.7-7.4 2.5-11.1 12.3-59.6 4.2-107.5-23.1-123.3-26.3-15.1-69.2.6-112.6 38.4-4.3 3.7-8.5 7.6-12.5 11.5-2.7-2.6-5.5-5.2-8.3-7.7-45.5-40.4-91.1-57.4-118.4-41.5-26.2 15.2-34 60.3-23 116.7 1.1 5.6 2.3 11.1 3.7 16.7-6.4 1.8-12.7 3.8-18.6 5.9C38.3 196.2 0 225.4 0 255.6c0 31.2 40.8 62.5 96.3 81.5 4.5 1.5 9 3 13.6 4.3-1.5 6-2.8 11.9-4 18-10.5 55.5-2.3 99.5 23.9 114.6 27 15.6 72.4-.4 116.6-39.1 3.5-3.1 7-6.3 10.5-9.7 4.4 4.3 9 8.4 13.6 12.4 42.8 36.8 85.1 51.7 111.2 36.6 27-15.6 35.8-62.9 24.4-120.5-.9-4.4-1.9-8.9-3-13.5 3.2-.9 6.3-1.9 9.4-2.9 57.7-19.1 99.5-50 99.5-81.7 0-30.3-39.4-59.7-93.8-78.4zM282.9 92.3c37.2-32.4 71.9-45.1 87.7-36 16.9 9.7 23.4 48.9 12.8 100.4-.7 3.4-1.4 6.7-2.3 10-22.2-5-44.7-8.6-67.3-10.6-13-18.6-27.2-36.4-42.6-53.1 3.9-3.7 7.7-7.2 11.7-10.7zM167.2 307.5c5.1 8.7 10.3 17.4 15.8 25.9-15.6-1.7-31.1-4.2-46.4-7.5 4.4-14.4 9.9-29.3 16.3-44.5 4.6 8.8 9.3 17.5 14.3 26.1zm-30.3-120.3c14.4-3.2 29.7-5.8 45.6-7.8-5.3 8.3-10.5 16.8-15.4 25.4-4.9 8.5-9.7 17.2-14.2 26-6.3-14.9-11.6-29.5-16-43.6zm27.4 68.9c6.6-13.8 13.8-27.3 21.4-40.6s15.8-26.2 24.4-38.9c15-1.1 30.3-1.7 45.9-1.7s31 .6 45.9 1.7c8.5 12.6 16.6 25.5 24.3 38.7s14.9 26.7 21.7 40.4c-6.7 13.8-13.9 27.4-21.6 40.8-7.6 13.3-15.7 26.2-24.2 39-14.9 1.1-30.4 1.6-46.1 1.6s-30.9-.5-45.6-1.4c-8.7-12.7-16.9-25.7-24.6-39s-14.8-26.8-21.5-40.6zm180.6 51.2c5.1-8.8 9.9-17.7 14.6-26.7 6.4 14.5 12 29.2 16.9 44.3-15.5 3.5-31.2 6.2-47 8 5.4-8.4 10.5-17 15.5-25.6zm14.4-76.5c-4.7-8.8-9.5-17.6-14.5-26.2-4.9-8.5-10-16.9-15.3-25.2 16.1 2 31.5 4.7 45.9 8-4.6 14.8-10 29.2-16.1 43.4zM256.2 118.3c10.5 11.4 20.4 23.4 29.6 35.8-19.8-.9-39.7-.9-59.5 0 9.8-12.9 19.9-24.9 29.9-35.8zM140.2 57c16.8-9.8 54.1 4.2 93.4 39 2.5 2.2 5 4.6 7.6 7-15.5 16.7-29.8 34.5-42.9 53.1-22.6 2-45 5.5-67.2 10.4-1.3-5.1-2.4-10.3-3.5-15.5-9.4-48.4-3.2-84.9 12.6-94zm-24.5 263.6c-4.2-1.2-8.3-2.5-12.4-3.9-21.3-6.7-45.5-17.3-63-31.2-10.1-7-16.9-17.8-18.8-29.9 0-18.3 31.6-41.7 77.2-57.6 5.7-2 11.5-3.8 17.3-5.5 6.8 21.7 15 43 24.5 63.6-9.6 20.9-17.9 42.5-24.8 64.5zm116.6 98c-16.5 15.1-35.6 27.1-56.4 35.3-11.1 5.3-23.9 5.8-35.3 1.3-15.9-9.2-22.5-44.5-13.5-92 1.1-5.6 2.3-11.2 3.7-16.7 22.4 4.8 45 8.1 67.9 9.8 13.2 18.7 27.7 36.6 43.2 53.4-3.2 3.1-6.4 6.1-9.6 8.9zm24.5-24.3c-10.2-11-20.4-23.2-30.3-36.3 9.6.4 19.5.6 29.5.6 10.3 0 20.4-.2 30.4-.7-9.2 12.7-19.1 24.8-29.6 36.4zm130.7 30c-.9 12.2-6.9 23.6-16.5 31.3-15.9 9.2-49.8-2.8-86.4-34.2-4.2-3.6-8.4-7.5-12.7-11.5 15.3-16.9 29.4-34.8 42.2-53.6 22.9-1.9 45.7-5.4 68.2-10.5 1 4.1 1.9 8.2 2.7 12.2 4.9 21.6 5.7 44.1 2.5 66.3zm18.2-107.5c-2.8.9-5.6 1.8-8.5 2.6-7-21.8-15.6-43.1-25.5-63.8 9.6-20.4 17.7-41.4 24.5-62.9 5.2 1.5 10.2 3.1 15 4.7 46.6 16 79.3 39.8 79.3 58 0 19.6-34.9 44.9-84.8 61.4zm-149.7-15c25.3 0 45.8-20.5 45.8-45.8s-20.5-45.8-45.8-45.8c-25.3 0-45.8 20.5-45.8 45.8s20.5 45.8 45.8 45.8z"
                }
            }
        ]
    })(props);
}
function FaReacteurope(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M250.6 211.74l5.8-4.1 5.8 4.1-2.1-6.8 5.7-4.3-7.1-.1-2.3-6.8-2.3 6.8-7.2.1 5.7 4.3zm63.7 0l5.8-4.1 5.8 4.1-2.1-6.8 5.7-4.3-7.2-.1-2.3-6.8-2.3 6.8-7.2.1 5.7 4.3zm-91.3 50.5h-3.4c-4.8 0-3.8 4-3.8 12.1 0 4.7-2.3 6.1-5.8 6.1s-5.8-1.4-5.8-6.1v-36.6c0-4.7 2.3-6.1 5.8-6.1s5.8 1.4 5.8 6.1c0 7.2-.7 10.5 3.8 10.5h3.4c4.7-.1 3.8-3.9 3.8-12.3 0-9.9-6.7-14.1-16.8-14.1h-.2c-10.1 0-16.8 4.2-16.8 14.1V276c0 10.4 6.7 14.1 16.8 14.1h.2c10.1 0 16.8-3.8 16.8-14.1 0-9.86 1.1-13.76-3.8-13.76zm-80.7 17.4h-14.7v-19.3H139c2.5 0 3.8-1.3 3.8-3.8v-2.1c0-2.5-1.3-3.8-3.8-3.8h-11.4v-18.3H142c2.5 0 3.8-1.3 3.8-3.8v-2.1c0-2.5-1.3-3.8-3.8-3.8h-21.7c-2.4-.1-3.7 1.3-3.7 3.8v59.1c0 2.5 1.3 3.8 3.8 3.8h21.9c2.5 0 3.8-1.3 3.8-3.8v-2.1c0-2.5-1.3-3.8-3.8-3.8zm-42-18.5c4.6-2 7.3-6 7.3-12.4v-11.9c0-10.1-6.7-14.1-16.8-14.1H77.4c-2.5 0-3.8 1.3-3.8 3.8v59.1c0 2.5 1.3 3.8 3.8 3.8h3.4c2.5 0 3.8-1.3 3.8-3.8v-22.9h5.6l7.4 23.5a4.1 4.1 0 0 0 4.3 3.2h3.3c2.8 0 4-1.8 3.2-4.4zm-3.8-14c0 4.8-2.5 6.1-6.1 6.1h-5.8v-20.9h5.8c3.6 0 6.1 1.3 6.1 6.1zM176 226a3.82 3.82 0 0 0-4.2-3.4h-6.9a3.68 3.68 0 0 0-4 3.4l-11 59.2c-.5 2.7.9 4.1 3.4 4.1h3a3.74 3.74 0 0 0 4.1-3.5l1.8-11.3h12.2l1.8 11.3a3.74 3.74 0 0 0 4.1 3.5h3.5c2.6 0 3.9-1.4 3.4-4.1zm-12.3 39.3l4.7-29.7 4.7 29.7zm89.3 20.2v-53.2h7.5c2.5 0 3.8-1.3 3.8-3.8v-2.1c0-2.5-1.3-3.8-3.8-3.8h-25.8c-2.5 0-3.8 1.3-3.8 3.8v2.1c0 2.5 1.3 3.8 3.8 3.8h7.3v53.2c0 2.5 1.3 3.8 3.8 3.8h3.4c2.5.04 3.8-1.3 3.8-3.76zm248-.8h-19.4V258h16.1a1.89 1.89 0 0 0 2-2v-.8a1.89 1.89 0 0 0-2-2h-16.1v-25.8h19.1a1.89 1.89 0 0 0 2-2v-.8a1.77 1.77 0 0 0-2-1.9h-22.2a1.62 1.62 0 0 0-2 1.8v63a1.81 1.81 0 0 0 2 1.9H501a1.81 1.81 0 0 0 2-1.9v-.8a1.84 1.84 0 0 0-2-1.96zm-93.1-62.9h-.8c-10.1 0-15.3 4.7-15.3 14.1V276c0 9.3 5.2 14.1 15.3 14.1h.8c10.1 0 15.3-4.8 15.3-14.1v-40.1c0-9.36-5.2-14.06-15.3-14.06zm10.2 52.4c-.1 8-3 11.1-10.5 11.1s-10.5-3.1-10.5-11.1v-36.6c0-7.9 3-11.1 10.5-11.1s10.5 3.2 10.5 11.1zm-46.5-14.5c6.1-1.6 9.2-6.1 9.2-13.3v-9.7c0-9.4-5.2-14.1-15.3-14.1h-13.7a1.81 1.81 0 0 0-2 1.9v63a1.81 1.81 0 0 0 2 1.9h1.2a1.74 1.74 0 0 0 1.9-1.9v-26.9h11.6l10.4 27.2a2.32 2.32 0 0 0 2.3 1.5h1.5c1.4 0 2-1 1.5-2.3zm-6.4-3.9H355v-28.5h10.2c7.5 0 10.5 3.1 10.5 11.1v6.4c0 7.84-3 11.04-10.5 11.04zm85.9-33.1h-13.7a1.62 1.62 0 0 0-2 1.8v63a1.81 1.81 0 0 0 2 1.9h1.2a1.74 1.74 0 0 0 1.9-1.9v-26.1h10.6c10.1 0 15.3-4.8 15.3-14.1v-10.5c0-9.4-5.2-14.1-15.3-14.1zm10.2 22.8c0 7.9-3 11.1-10.5 11.1h-10.2v-29.2h10.2c7.5-.1 10.5 3.1 10.5 11zM259.5 308l-2.3-6.8-2.3 6.8-7.1.1 5.7 4.3-2.1 6.8 5.8-4.1 5.8 4.1-2.1-6.8 5.7-4.3zm227.6-136.1a364.42 364.42 0 0 0-35.6-11.3c19.6-78 11.6-134.7-22.3-153.9C394.7-12.66 343.3 11 291 61.94q5.1 4.95 10.2 10.2c82.5-80 119.6-53.5 120.9-52.8 22.4 12.7 36 55.8 15.5 137.8a587.83 587.83 0 0 0-84.6-13C281.1 43.64 212.4 2 170.8 2 140 2 127 23 123.2 29.74c-18.1 32-13.3 84.2.1 133.8-70.5 20.3-120.7 54.1-120.3 95 .5 59.6 103.2 87.8 122.1 92.8-20.5 81.9-10.1 135.6 22.3 153.9 28 15.8 75.1 6 138.2-55.2q-5.1-4.95-10.2-10.2c-82.5 80-119.7 53.5-120.9 52.8-22.3-12.6-36-55.6-15.5-137.9 12.4 2.9 41.8 9.5 84.6 13 71.9 100.4 140.6 142 182.1 142 30.8 0 43.8-21 47.6-27.7 18-31.9 13.3-84.1-.1-133.8 152.3-43.8 156.2-130.2 33.9-176.3zM135.9 36.84c2.9-5.1 11.9-20.3 34.9-20.3 36.8 0 98.8 39.6 163.3 126.2a714 714 0 0 0-93.9.9 547.76 547.76 0 0 1 42.2-52.4Q277.3 86 272.2 81a598.25 598.25 0 0 0-50.7 64.2 569.69 569.69 0 0 0-84.4 14.6c-.2-1.4-24.3-82.2-1.2-123zm304.8 438.3c-2.9 5.1-11.8 20.3-34.9 20.3-36.7 0-98.7-39.4-163.3-126.2a695.38 695.38 0 0 0 93.9-.9 547.76 547.76 0 0 1-42.2 52.4q5.1 5.25 10.2 10.2a588.47 588.47 0 0 0 50.7-64.2c47.3-4.7 80.3-13.5 84.4-14.6 22.7 84.4 4.5 117 1.2 123zm9.1-138.6c-3.6-11.9-7.7-24.1-12.4-36.4a12.67 12.67 0 0 1-10.7-5.7l-.1.1a19.61 19.61 0 0 1-5.4 3.6c5.7 14.3 10.6 28.4 14.7 42.2a535.3 535.3 0 0 1-72 13c3.5-5.3 17.2-26.2 32.2-54.2a24.6 24.6 0 0 1-6-3.2c-1.1 1.2-3.6 4.2-10.9 4.2-6.2 11.2-17.4 30.9-33.9 55.2a711.91 711.91 0 0 1-112.4 1c-7.9-11.2-21.5-31.1-36.8-57.8a21 21 0 0 1-3-1.5c-1.9 1.6-3.9 3.2-12.6 3.2 6.3 11.2 17.5 30.7 33.8 54.6a548.81 548.81 0 0 1-72.2-11.7q5.85-21 14.1-42.9c-3.2 0-5.4.2-8.4-1a17.58 17.58 0 0 1-6.9 1c-4.9 13.4-9.1 26.5-12.7 39.4C-31.7 297-12.1 216 126.7 175.64c3.6 11.9 7.7 24.1 12.4 36.4 10.4 0 12.9 3.4 14.4 5.3a12 12 0 0 1 2.3-2.2c-5.8-14.7-10.9-29.2-15.2-43.3 7-1.8 32.4-8.4 72-13-15.9 24.3-26.7 43.9-32.8 55.3a14.22 14.22 0 0 1 6.4 8 23.42 23.42 0 0 1 10.2-8.4c6.5-11.7 17.9-31.9 34.8-56.9a711.72 711.72 0 0 1 112.4-1c31.5 44.6 28.9 48.1 42.5 64.5a21.42 21.42 0 0 1 10.4-7.4c-6.4-11.4-17.6-31-34.3-55.5 40.4 4.1 65 10 72.2 11.7-4 14.4-8.9 29.2-14.6 44.2a20.74 20.74 0 0 1 6.8 4.3l.1.1a12.72 12.72 0 0 1 8.9-5.6c4.9-13.4 9.2-26.6 12.8-39.5a359.71 359.71 0 0 1 34.5 11c106.1 39.9 74 87.9 72.6 90.4-19.8 35.1-80.1 55.2-105.7 62.5zm-114.4-114h-1.2a1.74 1.74 0 0 0-1.9 1.9v49.8c0 7.9-2.6 11.1-10.1 11.1s-10.1-3.1-10.1-11.1v-49.8a1.69 1.69 0 0 0-1.9-1.9H309a1.81 1.81 0 0 0-2 1.9v51.5c0 9.6 5 14.1 15.1 14.1h.4c10.1 0 15.1-4.6 15.1-14.1v-51.5a2 2 0 0 0-2.2-1.9zM321.7 308l-2.3-6.8-2.3 6.8-7.1.1 5.7 4.3-2.1 6.8 5.8-4.1 5.8 4.1-2.1-6.8 5.7-4.3zm-31.1 7.4l-2.3-6.8-2.3 6.8-7.1.1 5.7 4.3-2.1 6.8 5.8-4.1 5.8 4.1-2.1-6.8 5.7-4.3zm5.1-30.8h-19.4v-26.7h16.1a1.89 1.89 0 0 0 2-2v-.8a1.89 1.89 0 0 0-2-2h-16.1v-25.8h19.1a1.89 1.89 0 0 0 2-2v-.8a1.77 1.77 0 0 0-2-1.9h-22.2a1.81 1.81 0 0 0-2 1.9v63a1.81 1.81 0 0 0 2 1.9h22.5a1.77 1.77 0 0 0 2-1.9v-.8a1.83 1.83 0 0 0-2-2.06zm-7.4-99.4L286 192l-7.1.1 5.7 4.3-2.1 6.8 5.8-4.1 5.8 4.1-2.1-6.8 5.7-4.3-7.1-.1z"
                }
            }
        ]
    })(props);
}
function FaReadme(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M528.3 46.5H388.5c-48.1 0-89.9 33.3-100.4 80.3-10.6-47-52.3-80.3-100.4-80.3H48c-26.5 0-48 21.5-48 48v245.8c0 26.5 21.5 48 48 48h89.7c102.2 0 132.7 24.4 147.3 75 .7 2.8 5.2 2.8 6 0 14.7-50.6 45.2-75 147.3-75H528c26.5 0 48-21.5 48-48V94.6c0-26.4-21.3-47.9-47.7-48.1zM242 311.9c0 1.9-1.5 3.5-3.5 3.5H78.2c-1.9 0-3.5-1.5-3.5-3.5V289c0-1.9 1.5-3.5 3.5-3.5h160.4c1.9 0 3.5 1.5 3.5 3.5v22.9zm0-60.9c0 1.9-1.5 3.5-3.5 3.5H78.2c-1.9 0-3.5-1.5-3.5-3.5v-22.9c0-1.9 1.5-3.5 3.5-3.5h160.4c1.9 0 3.5 1.5 3.5 3.5V251zm0-60.9c0 1.9-1.5 3.5-3.5 3.5H78.2c-1.9 0-3.5-1.5-3.5-3.5v-22.9c0-1.9 1.5-3.5 3.5-3.5h160.4c1.9 0 3.5 1.5 3.5 3.5v22.9zm259.3 121.7c0 1.9-1.5 3.5-3.5 3.5H337.5c-1.9 0-3.5-1.5-3.5-3.5v-22.9c0-1.9 1.5-3.5 3.5-3.5h160.4c1.9 0 3.5 1.5 3.5 3.5v22.9zm0-60.9c0 1.9-1.5 3.5-3.5 3.5H337.5c-1.9 0-3.5-1.5-3.5-3.5V228c0-1.9 1.5-3.5 3.5-3.5h160.4c1.9 0 3.5 1.5 3.5 3.5v22.9zm0-60.9c0 1.9-1.5 3.5-3.5 3.5H337.5c-1.9 0-3.5-1.5-3.5-3.5v-22.8c0-1.9 1.5-3.5 3.5-3.5h160.4c1.9 0 3.5 1.5 3.5 3.5V190z"
                }
            }
        ]
    })(props);
}
function FaRebel(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256.5 504C117.2 504 9 387.8 13.2 249.9 16 170.7 56.4 97.7 129.7 49.5c.3 0 1.9-.6 1.1.8-5.8 5.5-111.3 129.8-14.1 226.4 49.8 49.5 90 2.5 90 2.5 38.5-50.1-.6-125.9-.6-125.9-10-24.9-45.7-40.1-45.7-40.1l28.8-31.8c24.4 10.5 43.2 38.7 43.2 38.7.8-29.6-21.9-61.4-21.9-61.4L255.1 8l44.3 50.1c-20.5 28.8-21.9 62.6-21.9 62.6 13.8-23 43.5-39.3 43.5-39.3l28.5 31.8c-27.4 8.9-45.4 39.9-45.4 39.9-15.8 28.5-27.1 89.4.6 127.3 32.4 44.6 87.7-2.8 87.7-2.8 102.7-91.9-10.5-225-10.5-225-6.1-5.5.8-2.8.8-2.8 50.1 36.5 114.6 84.4 116.2 204.8C500.9 400.2 399 504 256.5 504z"
                }
            }
        ]
    })(props);
}
function FaRedRiver(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M353.2 32H94.8C42.4 32 0 74.4 0 126.8v258.4C0 437.6 42.4 480 94.8 480h258.4c52.4 0 94.8-42.4 94.8-94.8V126.8c0-52.4-42.4-94.8-94.8-94.8zM144.9 200.9v56.3c0 27-21.9 48.9-48.9 48.9V151.9c0-13.2 10.7-23.9 23.9-23.9h154.2c0 27-21.9 48.9-48.9 48.9h-56.3c-12.3-.6-24.6 11.6-24 24zm176.3 72h-56.3c-12.3-.6-24.6 11.6-24 24v56.3c0 27-21.9 48.9-48.9 48.9V247.9c0-13.2 10.7-23.9 23.9-23.9h154.2c0 27-21.9 48.9-48.9 48.9z"
                }
            }
        ]
    })(props);
}
function FaRedditAlien(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M440.3 203.5c-15 0-28.2 6.2-37.9 15.9-35.7-24.7-83.8-40.6-137.1-42.3L293 52.3l88.2 19.8c0 21.6 17.6 39.2 39.2 39.2 22 0 39.7-18.1 39.7-39.7s-17.6-39.7-39.7-39.7c-15.4 0-28.7 9.3-35.3 22l-97.4-21.6c-4.9-1.3-9.7 2.2-11 7.1L246.3 177c-52.9 2.2-100.5 18.1-136.3 42.8-9.7-10.1-23.4-16.3-38.4-16.3-55.6 0-73.8 74.6-22.9 100.1-1.8 7.9-2.6 16.3-2.6 24.7 0 83.8 94.4 151.7 210.3 151.7 116.4 0 210.8-67.9 210.8-151.7 0-8.4-.9-17.2-3.1-25.1 49.9-25.6 31.5-99.7-23.8-99.7zM129.4 308.9c0-22 17.6-39.7 39.7-39.7 21.6 0 39.2 17.6 39.2 39.7 0 21.6-17.6 39.2-39.2 39.2-22 .1-39.7-17.6-39.7-39.2zm214.3 93.5c-36.4 36.4-139.1 36.4-175.5 0-4-3.5-4-9.7 0-13.7 3.5-3.5 9.7-3.5 13.2 0 27.8 28.5 120 29 149 0 3.5-3.5 9.7-3.5 13.2 0 4.1 4 4.1 10.2.1 13.7zm-.8-54.2c-21.6 0-39.2-17.6-39.2-39.2 0-22 17.6-39.7 39.2-39.7 22 0 39.7 17.6 39.7 39.7-.1 21.5-17.7 39.2-39.7 39.2z"
                }
            }
        ]
    })(props);
}
function FaRedditSquare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M283.2 345.5c2.7 2.7 2.7 6.8 0 9.2-24.5 24.5-93.8 24.6-118.4 0-2.7-2.4-2.7-6.5 0-9.2 2.4-2.4 6.5-2.4 8.9 0 18.7 19.2 81 19.6 100.5 0 2.4-2.3 6.6-2.3 9 0zm-91.3-53.8c0-14.9-11.9-26.8-26.5-26.8-14.9 0-26.8 11.9-26.8 26.8 0 14.6 11.9 26.5 26.8 26.5 14.6 0 26.5-11.9 26.5-26.5zm90.7-26.8c-14.6 0-26.5 11.9-26.5 26.8 0 14.6 11.9 26.5 26.5 26.5 14.9 0 26.8-11.9 26.8-26.5 0-14.9-11.9-26.8-26.8-26.8zM448 80v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h352c26.5 0 48 21.5 48 48zm-99.7 140.6c-10.1 0-19 4.2-25.6 10.7-24.1-16.7-56.5-27.4-92.5-28.6l18.7-84.2 59.5 13.4c0 14.6 11.9 26.5 26.5 26.5 14.9 0 26.8-12.2 26.8-26.8 0-14.6-11.9-26.8-26.8-26.8-10.4 0-19.3 6.2-23.8 14.9l-65.7-14.6c-3.3-.9-6.5 1.5-7.4 4.8l-20.5 92.8c-35.7 1.5-67.8 12.2-91.9 28.9-6.5-6.8-15.8-11-25.9-11-37.5 0-49.8 50.4-15.5 67.5-1.2 5.4-1.8 11-1.8 16.7 0 56.5 63.7 102.3 141.9 102.3 78.5 0 142.2-45.8 142.2-102.3 0-5.7-.6-11.6-2.1-17 33.6-17.2 21.2-67.2-16.1-67.2z"
                }
            }
        ]
    })(props);
}
function FaReddit(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M201.5 305.5c-13.8 0-24.9-11.1-24.9-24.6 0-13.8 11.1-24.9 24.9-24.9 13.6 0 24.6 11.1 24.6 24.9 0 13.6-11.1 24.6-24.6 24.6zM504 256c0 137-111 248-248 248S8 393 8 256 119 8 256 8s248 111 248 248zm-132.3-41.2c-9.4 0-17.7 3.9-23.8 10-22.4-15.5-52.6-25.5-86.1-26.6l17.4-78.3 55.4 12.5c0 13.6 11.1 24.6 24.6 24.6 13.8 0 24.9-11.3 24.9-24.9s-11.1-24.9-24.9-24.9c-9.7 0-18 5.8-22.1 13.8l-61.2-13.6c-3-.8-6.1 1.4-6.9 4.4l-19.1 86.4c-33.2 1.4-63.1 11.3-85.5 26.8-6.1-6.4-14.7-10.2-24.1-10.2-34.9 0-46.3 46.9-14.4 62.8-1.1 5-1.7 10.2-1.7 15.5 0 52.6 59.2 95.2 132 95.2 73.1 0 132.3-42.6 132.3-95.2 0-5.3-.6-10.8-1.9-15.8 31.3-16 19.8-62.5-14.9-62.5zM302.8 331c-18.2 18.2-76.1 17.9-93.6 0-2.2-2.2-6.1-2.2-8.3 0-2.5 2.5-2.5 6.4 0 8.6 22.8 22.8 87.3 22.8 110.2 0 2.5-2.2 2.5-6.1 0-8.6-2.2-2.2-6.1-2.2-8.3 0zm7.7-75c-13.6 0-24.6 11.1-24.6 24.9 0 13.6 11.1 24.6 24.6 24.6 13.8 0 24.9-11.1 24.9-24.6 0-13.8-11-24.9-24.9-24.9z"
                }
            }
        ]
    })(props);
}
function FaRedhat(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M341.52 285.56c33.65 0 82.34-6.94 82.34-47 .22-6.74.86-1.82-20.88-96.24-4.62-19.15-8.68-27.84-42.31-44.65-26.09-13.34-82.92-35.37-99.73-35.37-15.66 0-20.2 20.17-38.87 20.17-18 0-31.31-15.06-48.12-15.06-16.14 0-26.66 11-34.78 33.62-27.5 77.55-26.28 74.27-26.12 78.27 0 24.8 97.64 106.11 228.47 106.11M429 254.84c4.65 22 4.65 24.35 4.65 27.25 0 37.66-42.33 58.56-98 58.56-125.74.08-235.91-73.65-235.91-122.33a49.55 49.55 0 0 1 4.06-19.72C58.56 200.86 0 208.93 0 260.63c0 84.67 200.63 189 359.49 189 121.79 0 152.51-55.08 152.51-98.58 0-34.21-29.59-73.05-82.93-96.24"
                }
            }
        ]
    })(props);
}
function FaRenren(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M214 169.1c0 110.4-61 205.4-147.6 247.4C30 373.2 8 317.7 8 256.6 8 133.9 97.1 32.2 214 12.5v156.6zM255 504c-42.9 0-83.3-11-118.5-30.4C193.7 437.5 239.9 382.9 255 319c15.5 63.9 61.7 118.5 118.8 154.7C338.7 493 298.3 504 255 504zm190.6-87.5C359 374.5 298 279.6 298 169.1V12.5c116.9 19.7 206 121.4 206 244.1 0 61.1-22 116.6-58.4 159.9z"
                }
            }
        ]
    })(props);
}
function FaReplyd(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M320 480H128C57.6 480 0 422.4 0 352V160C0 89.6 57.6 32 128 32h192c70.4 0 128 57.6 128 128v192c0 70.4-57.6 128-128 128zM193.4 273.2c-6.1-2-11.6-3.1-16.4-3.1-7.2 0-13.5 1.9-18.9 5.6-5.4 3.7-9.6 9-12.8 15.8h-1.1l-4.2-18.3h-28v138.9h36.1v-89.7c1.5-5.4 4.4-9.8 8.7-13.2 4.3-3.4 9.8-5.1 16.2-5.1 4.6 0 9.8 1 15.6 3.1l4.8-34zm115.2 103.4c-3.2 2.4-7.7 4.8-13.7 7.1-6 2.3-12.8 3.5-20.4 3.5-12.2 0-21.1-3-26.5-8.9-5.5-5.9-8.5-14.7-9-26.4h83.3c.9-4.8 1.6-9.4 2.1-13.9.5-4.4.7-8.6.7-12.5 0-10.7-1.6-19.7-4.7-26.9-3.2-7.2-7.3-13-12.5-17.2-5.2-4.3-11.1-7.3-17.8-9.2-6.7-1.8-13.5-2.8-20.6-2.8-21.1 0-37.5 6.1-49.2 18.3s-17.5 30.5-17.5 55c0 22.8 5.2 40.7 15.6 53.7 10.4 13.1 26.8 19.6 49.2 19.6 10.7 0 20.9-1.5 30.4-4.6 9.5-3.1 17.1-6.8 22.6-11.2l-12-23.6zm-21.8-70.3c3.8 5.4 5.3 13.1 4.6 23.1h-51.7c.9-9.4 3.7-17 8.2-22.6 4.5-5.6 11.5-8.5 21-8.5 8.2-.1 14.1 2.6 17.9 8zm79.9 2.5c4.1 3.9 9.4 5.8 16.1 5.8 7 0 12.6-1.9 16.7-5.8s6.1-9.1 6.1-15.6-2-11.6-6.1-15.4c-4.1-3.8-9.6-5.7-16.7-5.7-6.7 0-12 1.9-16.1 5.7-4.1 3.8-6.1 8.9-6.1 15.4s2 11.7 6.1 15.6zm0 100.5c4.1 3.9 9.4 5.8 16.1 5.8 7 0 12.6-1.9 16.7-5.8s6.1-9.1 6.1-15.6-2-11.6-6.1-15.4c-4.1-3.8-9.6-5.7-16.7-5.7-6.7 0-12 1.9-16.1 5.7-4.1 3.8-6.1 8.9-6.1 15.4 0 6.6 2 11.7 6.1 15.6z"
                }
            }
        ]
    })(props);
}
function FaResearchgate(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 32v448h448V32H0zm262.2 334.4c-6.6 3-33.2 6-50-14.2-9.2-10.6-25.3-33.3-42.2-63.6-8.9 0-14.7 0-21.4-.6v46.4c0 23.5 6 21.2 25.8 23.9v8.1c-6.9-.3-23.1-.8-35.6-.8-13.1 0-26.1.6-33.6.8v-8.1c15.5-2.9 22-1.3 22-23.9V225c0-22.6-6.4-21-22-23.9V193c25.8 1 53.1-.6 70.9-.6 31.7 0 55.9 14.4 55.9 45.6 0 21.1-16.7 42.2-39.2 47.5 13.6 24.2 30 45.6 42.2 58.9 7.2 7.8 17.2 14.7 27.2 14.7v7.3zm22.9-135c-23.3 0-32.2-15.7-32.2-32.2V167c0-12.2 8.8-30.4 34-30.4s30.4 17.9 30.4 17.9l-10.7 7.2s-5.5-12.5-19.7-12.5c-7.9 0-19.7 7.3-19.7 19.7v26.8c0 13.4 6.6 23.3 17.9 23.3 14.1 0 21.5-10.9 21.5-26.8h-17.9v-10.7h30.4c0 20.5 4.7 49.9-34 49.9zm-116.5 44.7c-9.4 0-13.6-.3-20-.8v-69.7c6.4-.6 15-.6 22.5-.6 23.3 0 37.2 12.2 37.2 34.5 0 21.9-15 36.6-39.7 36.6z"
                }
            }
        ]
    })(props);
}
function FaResolving(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M281.2 278.2c46-13.3 49.6-23.5 44-43.4L314 195.5c-6.1-20.9-18.4-28.1-71.1-12.8L54.7 236.8l28.6 98.6 197.9-57.2zM248.5 8C131.4 8 33.2 88.7 7.2 197.5l221.9-63.9c34.8-10.2 54.2-11.7 79.3-8.2 36.3 6.1 52.7 25 61.4 55.2l10.7 37.8c8.2 28.1 1 50.6-23.5 73.6-19.4 17.4-31.2 24.5-61.4 33.2L203 351.8l220.4 27.1 9.7 34.2-48.1 13.3-286.8-37.3 23 80.2c36.8 22 80.3 34.7 126.3 34.7 137 0 248.5-111.4 248.5-248.3C497 119.4 385.5 8 248.5 8zM38.3 388.6L0 256.8c0 48.5 14.3 93.4 38.3 131.8z"
                }
            }
        ]
    })(props);
}
function FaRev(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M289.67 274.89a65.57 65.57 0 1 1-65.56-65.56 65.64 65.64 0 0 1 65.56 65.56zm139.55-5.05h-.13a204.69 204.69 0 0 0-74.32-153l-45.38 26.2a157.07 157.07 0 0 1 71.81 131.84C381.2 361.5 310.73 432 224.11 432S67 361.5 67 274.88c0-81.88 63-149.27 143-156.43v39.12l108.77-62.79L210 32v38.32c-106.7 7.25-191 96-191 204.57 0 111.59 89.12 202.29 200.06 205v.11h210.16V269.84z"
                }
            }
        ]
    })(props);
}
function FaRocketchat(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M284.046,224.8a34.114,34.114,0,1,0,34.317,34.113A34.217,34.217,0,0,0,284.046,224.8Zm-110.45,0a34.114,34.114,0,1,0,34.317,34.113A34.217,34.217,0,0,0,173.6,224.8Zm220.923,0a34.114,34.114,0,1,0,34.317,34.113A34.215,34.215,0,0,0,394.519,224.8Zm153.807-55.319c-15.535-24.172-37.31-45.57-64.681-63.618-52.886-34.817-122.374-54-195.666-54a405.975,405.975,0,0,0-72.032,6.357,238.524,238.524,0,0,0-49.51-36.588C99.684-11.7,40.859.711,11.135,11.421A14.291,14.291,0,0,0,5.58,34.782C26.542,56.458,61.222,99.3,52.7,138.252c-33.142,33.9-51.112,74.776-51.112,117.337,0,43.372,17.97,84.248,51.112,118.148,8.526,38.956-26.154,81.816-47.116,103.491a14.284,14.284,0,0,0,5.555,23.34c29.724,10.709,88.549,23.147,155.324-10.2a238.679,238.679,0,0,0,49.51-36.589A405.972,405.972,0,0,0,288,460.14c73.313,0,142.8-19.159,195.667-53.975,27.371-18.049,49.145-39.426,64.679-63.619,17.309-26.923,26.07-55.916,26.07-86.125C574.394,225.4,565.634,196.43,548.326,169.485ZM284.987,409.9a345.65,345.65,0,0,1-89.446-11.5l-20.129,19.393a184.366,184.366,0,0,1-37.138,27.585,145.767,145.767,0,0,1-52.522,14.87c.983-1.771,1.881-3.563,2.842-5.356q30.258-55.68,16.325-100.078c-32.992-25.962-52.778-59.2-52.778-95.4,0-83.1,104.254-150.469,232.846-150.469s232.867,67.373,232.867,150.469C517.854,342.525,413.6,409.9,284.987,409.9Z"
                }
            }
        ]
    })(props);
}
function FaRockrms(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm157.4 419.5h-90l-112-131.3c-17.9-20.4-3.9-56.1 26.6-56.1h75.3l-84.6-99.3-84.3 98.9h-90L193.5 67.2c14.4-18.4 41.3-17.3 54.5 0l157.7 185.1c19 22.8 2 57.2-27.6 56.1-.6 0-74.2.2-74.2.2l101.5 118.9z"
                }
            }
        ]
    })(props);
}
function FaRust(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M508.52,249.75,486.7,236.24c-.17-2-.34-3.93-.55-5.88l18.72-17.5a7.35,7.35,0,0,0-2.44-12.25l-24-9c-.54-1.88-1.08-3.78-1.67-5.64l15-20.83a7.35,7.35,0,0,0-4.79-11.54l-25.42-4.15c-.9-1.73-1.79-3.45-2.73-5.15l10.68-23.42a7.35,7.35,0,0,0-6.95-10.39l-25.82.91q-1.79-2.22-3.61-4.4L439,81.84A7.36,7.36,0,0,0,430.16,73L405,78.93q-2.17-1.83-4.4-3.61l.91-25.82a7.35,7.35,0,0,0-10.39-7L367.7,53.23c-1.7-.94-3.43-1.84-5.15-2.73L358.4,25.08a7.35,7.35,0,0,0-11.54-4.79L326,35.26c-1.86-.59-3.75-1.13-5.64-1.67l-9-24a7.35,7.35,0,0,0-12.25-2.44l-17.5,18.72c-1.95-.21-3.91-.38-5.88-.55L262.25,3.48a7.35,7.35,0,0,0-12.5,0L236.24,25.3c-2,.17-3.93.34-5.88.55L212.86,7.13a7.35,7.35,0,0,0-12.25,2.44l-9,24c-1.89.55-3.79,1.08-5.66,1.68l-20.82-15a7.35,7.35,0,0,0-11.54,4.79l-4.15,25.41c-1.73.9-3.45,1.79-5.16,2.73L120.88,42.55a7.35,7.35,0,0,0-10.39,7l.92,25.81c-1.49,1.19-3,2.39-4.42,3.61L81.84,73A7.36,7.36,0,0,0,73,81.84L78.93,107c-1.23,1.45-2.43,2.93-3.62,4.41l-25.81-.91a7.42,7.42,0,0,0-6.37,3.26,7.35,7.35,0,0,0-.57,7.13l10.66,23.41c-.94,1.7-1.83,3.43-2.73,5.16L25.08,153.6a7.35,7.35,0,0,0-4.79,11.54l15,20.82c-.59,1.87-1.13,3.77-1.68,5.66l-24,9a7.35,7.35,0,0,0-2.44,12.25l18.72,17.5c-.21,1.95-.38,3.91-.55,5.88L3.48,249.75a7.35,7.35,0,0,0,0,12.5L25.3,275.76c.17,2,.34,3.92.55,5.87L7.13,299.13a7.35,7.35,0,0,0,2.44,12.25l24,9c.55,1.89,1.08,3.78,1.68,5.65l-15,20.83a7.35,7.35,0,0,0,4.79,11.54l25.42,4.15c.9,1.72,1.79,3.45,2.73,5.14L42.56,391.12a7.35,7.35,0,0,0,.57,7.13,7.13,7.13,0,0,0,6.37,3.26l25.83-.91q1.77,2.22,3.6,4.4L73,430.16A7.36,7.36,0,0,0,81.84,439L107,433.07q2.18,1.83,4.41,3.61l-.92,25.82a7.35,7.35,0,0,0,10.39,6.95l23.43-10.68c1.69.94,3.42,1.83,5.14,2.73l4.15,25.42a7.34,7.34,0,0,0,11.54,4.78l20.83-15c1.86.6,3.76,1.13,5.65,1.68l9,24a7.36,7.36,0,0,0,12.25,2.44l17.5-18.72c1.95.21,3.92.38,5.88.55l13.51,21.82a7.35,7.35,0,0,0,12.5,0l13.51-21.82c2-.17,3.93-.34,5.88-.56l17.5,18.73a7.36,7.36,0,0,0,12.25-2.44l9-24c1.89-.55,3.78-1.08,5.65-1.68l20.82,15a7.34,7.34,0,0,0,11.54-4.78l4.15-25.42c1.72-.9,3.45-1.79,5.15-2.73l23.42,10.68a7.35,7.35,0,0,0,10.39-6.95l-.91-25.82q2.22-1.79,4.4-3.61L430.16,439a7.36,7.36,0,0,0,8.84-8.84L433.07,405q1.83-2.17,3.61-4.4l25.82.91a7.23,7.23,0,0,0,6.37-3.26,7.35,7.35,0,0,0,.58-7.13L458.77,367.7c.94-1.7,1.83-3.43,2.73-5.15l25.42-4.15a7.35,7.35,0,0,0,4.79-11.54l-15-20.83c.59-1.87,1.13-3.76,1.67-5.65l24-9a7.35,7.35,0,0,0,2.44-12.25l-18.72-17.5c.21-1.95.38-3.91.55-5.87l21.82-13.51a7.35,7.35,0,0,0,0-12.5Zm-151,129.08A13.91,13.91,0,0,0,341,389.51l-7.64,35.67A187.51,187.51,0,0,1,177,424.44l-7.64-35.66a13.87,13.87,0,0,0-16.46-10.68l-31.51,6.76a187.38,187.38,0,0,1-16.26-19.21H258.3c1.72,0,2.89-.29,2.89-1.91V309.55c0-1.57-1.17-1.91-2.89-1.91H213.47l.05-34.35H262c4.41,0,23.66,1.28,29.79,25.87,1.91,7.55,6.17,32.14,9.06,40,2.89,8.82,14.6,26.46,27.1,26.46H407a187.3,187.3,0,0,1-17.34,20.09Zm25.77,34.49A15.24,15.24,0,1,1,368,398.08h.44A15.23,15.23,0,0,1,383.24,413.32Zm-225.62-.68a15.24,15.24,0,1,1-15.25-15.25h.45A15.25,15.25,0,0,1,157.62,412.64ZM69.57,234.15l32.83-14.6a13.88,13.88,0,0,0,7.06-18.33L102.69,186h26.56V305.73H75.65A187.65,187.65,0,0,1,69.57,234.15ZM58.31,198.09a15.24,15.24,0,0,1,15.23-15.25H74a15.24,15.24,0,1,1-15.67,15.24Zm155.16,24.49.05-35.32h63.26c3.28,0,23.07,3.77,23.07,18.62,0,12.29-15.19,16.7-27.68,16.7ZM399,306.71c-9.8,1.13-20.63-4.12-22-10.09-5.78-32.49-15.39-39.4-30.57-51.4,18.86-11.95,38.46-29.64,38.46-53.26,0-25.52-17.49-41.59-29.4-49.48-16.76-11-35.28-13.23-40.27-13.23H116.32A187.49,187.49,0,0,1,221.21,70.06l23.47,24.6a13.82,13.82,0,0,0,19.6.44l26.26-25a187.51,187.51,0,0,1,128.37,91.43l-18,40.57A14,14,0,0,0,408,220.43l34.59,15.33a187.12,187.12,0,0,1,.4,32.54H423.71c-1.91,0-2.69,1.27-2.69,3.13v8.82C421,301,409.31,305.58,399,306.71ZM240,60.21A15.24,15.24,0,0,1,255.21,45h.45A15.24,15.24,0,1,1,240,60.21ZM436.84,214a15.24,15.24,0,1,1,0-30.48h.44a15.24,15.24,0,0,1-.44,30.48Z"
                }
            }
        ]
    })(props);
}
function FaSafari(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M274.69,274.69l-37.38-37.38L166,346ZM256,8C119,8,8,119,8,256S119,504,256,504,504,393,504,256,393,8,256,8ZM411.85,182.79l14.78-6.13A8,8,0,0,1,437.08,181h0a8,8,0,0,1-4.33,10.46L418,197.57a8,8,0,0,1-10.45-4.33h0A8,8,0,0,1,411.85,182.79ZM314.43,94l6.12-14.78A8,8,0,0,1,331,74.92h0a8,8,0,0,1,4.33,10.45l-6.13,14.78a8,8,0,0,1-10.45,4.33h0A8,8,0,0,1,314.43,94ZM256,60h0a8,8,0,0,1,8,8V84a8,8,0,0,1-8,8h0a8,8,0,0,1-8-8V68A8,8,0,0,1,256,60ZM181,74.92a8,8,0,0,1,10.46,4.33L197.57,94a8,8,0,1,1-14.78,6.12l-6.13-14.78A8,8,0,0,1,181,74.92Zm-63.58,42.49h0a8,8,0,0,1,11.31,0L140,128.72A8,8,0,0,1,140,140h0a8,8,0,0,1-11.31,0l-11.31-11.31A8,8,0,0,1,117.41,117.41ZM60,256h0a8,8,0,0,1,8-8H84a8,8,0,0,1,8,8h0a8,8,0,0,1-8,8H68A8,8,0,0,1,60,256Zm40.15,73.21-14.78,6.13A8,8,0,0,1,74.92,331h0a8,8,0,0,1,4.33-10.46L94,314.43a8,8,0,0,1,10.45,4.33h0A8,8,0,0,1,100.15,329.21Zm4.33-136h0A8,8,0,0,1,94,197.57l-14.78-6.12A8,8,0,0,1,74.92,181h0a8,8,0,0,1,10.45-4.33l14.78,6.13A8,8,0,0,1,104.48,193.24ZM197.57,418l-6.12,14.78a8,8,0,0,1-14.79-6.12l6.13-14.78A8,8,0,1,1,197.57,418ZM264,444a8,8,0,0,1-8,8h0a8,8,0,0,1-8-8V428a8,8,0,0,1,8-8h0a8,8,0,0,1,8,8Zm67-6.92h0a8,8,0,0,1-10.46-4.33L314.43,418a8,8,0,0,1,4.33-10.45h0a8,8,0,0,1,10.45,4.33l6.13,14.78A8,8,0,0,1,331,437.08Zm63.58-42.49h0a8,8,0,0,1-11.31,0L372,383.28A8,8,0,0,1,372,372h0a8,8,0,0,1,11.31,0l11.31,11.31A8,8,0,0,1,394.59,394.59ZM286.25,286.25,110.34,401.66,225.75,225.75,401.66,110.34ZM437.08,331h0a8,8,0,0,1-10.45,4.33l-14.78-6.13a8,8,0,0,1-4.33-10.45h0A8,8,0,0,1,418,314.43l14.78,6.12A8,8,0,0,1,437.08,331ZM444,264H428a8,8,0,0,1-8-8h0a8,8,0,0,1,8-8h16a8,8,0,0,1,8,8h0A8,8,0,0,1,444,264Z"
                }
            }
        ]
    })(props);
}
function FaSalesforce(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248.89 245.64h-26.35c.69-5.16 3.32-14.12 13.64-14.12 6.75 0 11.97 3.82 12.71 14.12zm136.66-13.88c-.47 0-14.11-1.77-14.11 20s13.63 20 14.11 20c13 0 14.11-13.54 14.11-20 0-21.76-13.66-20-14.11-20zm-243.22 23.76a8.63 8.63 0 0 0-3.29 7.29c0 4.78 2.08 6.05 3.29 7.05 4.7 3.7 15.07 2.12 20.93.95v-16.94c-5.32-1.07-16.73-1.96-20.93 1.65zM640 232c0 87.58-80 154.39-165.36 136.43-18.37 33-70.73 70.75-132.2 41.63-41.16 96.05-177.89 92.18-213.81-5.17C8.91 428.78-50.19 266.52 53.36 205.61 18.61 126.18 76 32 167.67 32a124.24 124.24 0 0 1 98.56 48.7c20.7-21.4 49.4-34.81 81.15-34.81 42.34 0 79 23.52 98.8 58.57C539 63.78 640 132.69 640 232zm-519.55 31.8c0-11.76-11.69-15.17-17.87-17.17-5.27-2.11-13.41-3.51-13.41-8.94 0-9.46 17-6.66 25.17-2.12 0 0 1.17.71 1.64-.47.24-.7 2.36-6.58 2.59-7.29a1.13 1.13 0 0 0-.7-1.41c-12.33-7.63-40.7-8.51-40.7 12.7 0 12.46 11.49 15.44 17.88 17.17 4.72 1.58 13.17 3 13.17 8.7 0 4-3.53 7.06-9.17 7.06a31.76 31.76 0 0 1-19-6.35c-.47-.23-1.42-.71-1.65.71l-2.4 7.47c-.47.94.23 1.18.23 1.41 1.75 1.4 10.3 6.59 22.82 6.59 13.17 0 21.4-7.06 21.4-18.11zm32-42.58c-10.13 0-18.66 3.17-21.4 5.18a1 1 0 0 0-.24 1.41l2.59 7.06a1 1 0 0 0 1.18.7c.65 0 6.8-4 16.93-4 4 0 7.06.71 9.18 2.36 3.6 2.8 3.06 8.29 3.06 10.58-4.79-.3-19.11-3.44-29.41 3.76a16.92 16.92 0 0 0-7.34 14.54c0 5.9 1.51 10.4 6.59 14.35 12.24 8.16 36.28 2 38.1 1.41 1.58-.32 3.53-.66 3.53-1.88v-33.88c.04-4.61.32-21.64-22.78-21.64zM199 200.24a1.11 1.11 0 0 0-1.18-1.18H188a1.11 1.11 0 0 0-1.17 1.18v79a1.11 1.11 0 0 0 1.17 1.18h9.88a1.11 1.11 0 0 0 1.18-1.18zm55.75 28.93c-2.1-2.31-6.79-7.53-17.65-7.53-3.51 0-14.16.23-20.7 8.94-6.35 7.63-6.58 18.11-6.58 21.41 0 3.12.15 14.26 7.06 21.17 2.64 2.91 9.06 8.23 22.81 8.23 10.82 0 16.47-2.35 18.58-3.76.47-.24.71-.71.24-1.88l-2.35-6.83a1.26 1.26 0 0 0-1.41-.7c-2.59.94-6.35 2.82-15.29 2.82-17.42 0-16.85-14.74-16.94-16.7h37.17a1.23 1.23 0 0 0 1.17-.94c-.29 0 2.07-14.7-6.09-24.23zm36.69 52.69c13.17 0 21.41-7.06 21.41-18.11 0-11.76-11.7-15.17-17.88-17.17-4.14-1.66-13.41-3.38-13.41-8.94 0-3.76 3.29-6.35 8.47-6.35a38.11 38.11 0 0 1 16.7 4.23s1.18.71 1.65-.47c.23-.7 2.35-6.58 2.58-7.29a1.13 1.13 0 0 0-.7-1.41c-7.91-4.9-16.74-4.94-20.23-4.94-12 0-20.46 7.29-20.46 17.64 0 12.46 11.48 15.44 17.87 17.17 6.11 2 13.17 3.26 13.17 8.7 0 4-3.52 7.06-9.17 7.06a31.8 31.8 0 0 1-19-6.35 1 1 0 0 0-1.65.71l-2.35 7.52c-.47.94.23 1.18.23 1.41 1.72 1.4 10.33 6.59 22.79 6.59zM357.09 224c0-.71-.24-1.18-1.18-1.18h-11.76c0-.14.94-8.94 4.47-12.47 4.16-4.15 11.76-1.64 12-1.64 1.17.47 1.41 0 1.64-.47l2.83-7.77c.7-.94 0-1.17-.24-1.41-5.09-2-17.35-2.87-24.46 4.24-5.48 5.48-7 13.92-8 19.52h-8.47a1.28 1.28 0 0 0-1.17 1.18l-1.42 7.76c0 .7.24 1.17 1.18 1.17h8.23c-8.51 47.9-8.75 50.21-10.35 55.52-1.08 3.62-3.29 6.9-5.88 7.76-.09 0-3.88 1.68-9.64-.24 0 0-.94-.47-1.41.71-.24.71-2.59 6.82-2.83 7.53s0 1.41.47 1.41c5.11 2 13 1.77 17.88 0 6.28-2.28 9.72-7.89 11.53-12.94 2.75-7.71 2.81-9.79 11.76-59.74h12.23a1.29 1.29 0 0 0 1.18-1.18zm53.39 16c-.56-1.68-5.1-18.11-25.17-18.11-15.25 0-23 10-25.16 18.11-1 3-3.18 14 0 23.52.09.3 4.41 18.12 25.16 18.12 14.95 0 22.9-9.61 25.17-18.12 3.21-9.61 1.01-20.52 0-23.52zm45.4-16.7c-5-1.65-16.62-1.9-22.11 5.41v-4.47a1.11 1.11 0 0 0-1.18-1.17h-9.4a1.11 1.11 0 0 0-1.18 1.17v55.28a1.12 1.12 0 0 0 1.18 1.18h9.64a1.12 1.12 0 0 0 1.18-1.18v-27.77c0-2.91.05-11.37 4.46-15.05 4.9-4.9 12-3.36 13.41-3.06a1.57 1.57 0 0 0 1.41-.94 74 74 0 0 0 3.06-8 1.16 1.16 0 0 0-.47-1.41zm46.81 54.1l-2.12-7.29c-.47-1.18-1.41-.71-1.41-.71-4.23 1.82-10.15 1.89-11.29 1.89-4.64 0-17.17-1.13-17.17-19.76 0-6.23 1.85-19.76 16.47-19.76a34.85 34.85 0 0 1 11.52 1.65s.94.47 1.18-.71c.94-2.59 1.64-4.47 2.59-7.53.23-.94-.47-1.17-.71-1.17-11.59-3.87-22.34-2.53-27.76 0-1.59.74-16.23 6.49-16.23 27.52 0 2.9-.58 30.11 28.94 30.11a44.45 44.45 0 0 0 15.52-2.83 1.3 1.3 0 0 0 .47-1.42zm53.87-39.52c-.8-3-5.37-16.23-22.35-16.23-16 0-23.52 10.11-25.64 18.59a38.58 38.58 0 0 0-1.65 11.76c0 25.87 18.84 29.4 29.88 29.4 10.82 0 16.46-2.35 18.58-3.76.47-.24.71-.71.24-1.88l-2.36-6.83a1.26 1.26 0 0 0-1.41-.7c-2.59.94-6.35 2.82-15.29 2.82-17.42 0-16.85-14.74-16.93-16.7h37.16a1.25 1.25 0 0 0 1.18-.94c-.24-.01.94-7.07-1.41-15.54zm-23.29-6.35c-10.33 0-13 9-13.64 14.12H546c-.88-11.92-7.62-14.13-12.73-14.13z"
                }
            }
        ]
    })(props);
}
function FaSass(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M301.84 378.92c-.3.6-.6 1.08 0 0zm249.13-87a131.16 131.16 0 0 0-58 13.5c-5.9-11.9-12-22.3-13-30.1-1.2-9.1-2.5-14.5-1.1-25.3s7.7-26.1 7.6-27.2-1.4-6.6-14.3-6.7-24 2.5-25.29 5.9a122.83 122.83 0 0 0-5.3 19.1c-2.3 11.7-25.79 53.5-39.09 75.3-4.4-8.5-8.1-16-8.9-22-1.2-9.1-2.5-14.5-1.1-25.3s7.7-26.1 7.6-27.2-1.4-6.6-14.29-6.7-24 2.5-25.3 5.9-2.7 11.4-5.3 19.1-33.89 77.3-42.08 95.4c-4.2 9.2-7.8 16.6-10.4 21.6-.4.8-.7 1.3-.9 1.7.3-.5.5-1 .5-.8-2.2 4.3-3.5 6.7-3.5 6.7v.1c-1.7 3.2-3.6 6.1-4.5 6.1-.6 0-1.9-8.4.3-19.9 4.7-24.2 15.8-61.8 15.7-63.1-.1-.7 2.1-7.2-7.3-10.7-9.1-3.3-12.4 2.2-13.2 2.2s-1.4 2-1.4 2 10.1-42.4-19.39-42.4c-18.4 0-44 20.2-56.58 38.5-7.9 4.3-25 13.6-43 23.5-6.9 3.8-14 7.7-20.7 11.4-.5-.5-.9-1-1.4-1.5-35.79-38.2-101.87-65.2-99.07-116.5 1-18.7 7.5-67.8 127.07-127.4 98-48.8 176.35-35.4 189.84-5.6 19.4 42.5-41.89 121.6-143.66 133-38.79 4.3-59.18-10.7-64.28-16.3-5.3-5.9-6.1-6.2-8.1-5.1-3.3 1.8-1.2 7 0 10.1 3 7.9 15.5 21.9 36.79 28.9 18.7 6.1 64.18 9.5 119.17-11.8 61.78-23.8 109.87-90.1 95.77-145.6C386.52 18.32 293-.18 204.57 31.22c-52.69 18.7-109.67 48.1-150.66 86.4-48.69 45.6-56.48 85.3-53.28 101.9 11.39 58.9 92.57 97.3 125.06 125.7-1.6.9-3.1 1.7-4.5 2.5-16.29 8.1-78.18 40.5-93.67 74.7-17.5 38.8 2.9 66.6 16.29 70.4 41.79 11.6 84.58-9.3 107.57-43.6s20.2-79.1 9.6-99.5c-.1-.3-.3-.5-.4-.8 4.2-2.5 8.5-5 12.8-7.5 8.29-4.9 16.39-9.4 23.49-13.3-4 10.8-6.9 23.8-8.4 42.6-1.8 22 7.3 50.5 19.1 61.7 5.2 4.9 11.49 5 15.39 5 13.8 0 20-11.4 26.89-25 8.5-16.6 16-35.9 16-35.9s-9.4 52.2 16.3 52.2c9.39 0 18.79-12.1 23-18.3v.1s.2-.4.7-1.2c1-1.5 1.5-2.4 1.5-2.4v-.3c3.8-6.5 12.1-21.4 24.59-46 16.2-31.8 31.69-71.5 31.69-71.5a201.24 201.24 0 0 0 6.2 25.8c2.8 9.5 8.7 19.9 13.4 30-3.8 5.2-6.1 8.2-6.1 8.2a.31.31 0 0 0 .1.2c-3 4-6.4 8.3-9.9 12.5-12.79 15.2-28 32.6-30 37.6-2.4 5.9-1.8 10.3 2.8 13.7 3.4 2.6 9.4 3 15.69 2.5 11.5-.8 19.6-3.6 23.5-5.4a82.2 82.2 0 0 0 20.19-10.6c12.5-9.2 20.1-22.4 19.4-39.8-.4-9.6-3.5-19.2-7.3-28.2 1.1-1.6 2.3-3.3 3.4-5C434.8 301.72 450.1 270 450.1 270a201.24 201.24 0 0 0 6.2 25.8c2.4 8.1 7.09 17 11.39 25.7-18.59 15.1-30.09 32.6-34.09 44.1-7.4 21.3-1.6 30.9 9.3 33.1 4.9 1 11.9-1.3 17.1-3.5a79.46 79.46 0 0 0 21.59-11.1c12.5-9.2 24.59-22.1 23.79-39.6-.3-7.9-2.5-15.8-5.4-23.4 15.7-6.6 36.09-10.2 62.09-7.2 55.68 6.5 66.58 41.3 64.48 55.8s-13.8 22.6-17.7 25-5.1 3.3-4.8 5.1c.5 2.6 2.3 2.5 5.6 1.9 4.6-.8 29.19-11.8 30.29-38.7 1.6-34-31.09-71.4-89-71.1zm-429.18 144.7c-18.39 20.1-44.19 27.7-55.28 21.3C54.61 451 59.31 421.42 82 400c13.8-13 31.59-25 43.39-32.4 2.7-1.6 6.6-4 11.4-6.9.8-.5 1.2-.7 1.2-.7.9-.6 1.9-1.1 2.9-1.7 8.29 30.4.3 57.2-19.1 78.3zm134.36-91.4c-6.4 15.7-19.89 55.7-28.09 53.6-7-1.8-11.3-32.3-1.4-62.3 5-15.1 15.6-33.1 21.9-40.1 10.09-11.3 21.19-14.9 23.79-10.4 3.5 5.9-12.2 49.4-16.2 59.2zm111 53c-2.7 1.4-5.2 2.3-6.4 1.6-.9-.5 1.1-2.4 1.1-2.4s13.9-14.9 19.4-21.7c3.2-4 6.9-8.7 10.89-13.9 0 .5.1 1 .1 1.6-.13 17.9-17.32 30-25.12 34.8zm85.58-19.5c-2-1.4-1.7-6.1 5-20.7 2.6-5.7 8.59-15.3 19-24.5a36.18 36.18 0 0 1 1.9 10.8c-.1 22.5-16.2 30.9-25.89 34.4z"
                }
            }
        ]
    })(props);
}
function FaSchlix(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M350.5 157.7l-54.2-46.1 73.4-39 78.3 44.2-97.5 40.9zM192 122.1l45.7-28.2 34.7 34.6-55.4 29-25-35.4zm-65.1 6.6l31.9-22.1L176 135l-36.7 22.5-12.4-28.8zm-23.3 88.2l-8.8-34.8 29.6-18.3 13.1 35.3-33.9 17.8zm-21.2-83.7l23.9-18.1 8.9 24-26.7 18.3-6.1-24.2zM59 206.5l-3.6-28.4 22.3-15.5 6.1 28.7L59 206.5zm-30.6 16.6l20.8-12.8 3.3 33.4-22.9 12-1.2-32.6zM1.4 268l19.2-10.2.4 38.2-21 8.8L1.4 268zm59.1 59.3l-28.3 8.3-1.6-46.8 25.1-10.7 4.8 49.2zM99 263.2l-31.1 13-5.2-40.8L90.1 221l8.9 42.2zM123.2 377l-41.6 5.9-8.1-63.5 35.2-10.8 14.5 68.4zm28.5-139.9l21.2 57.1-46.2 13.6-13.7-54.1 38.7-16.6zm85.7 230.5l-70.9-3.3-24.3-95.8 55.2-8.6 40 107.7zm-84.9-279.7l42.2-22.4 28 45.9-50.8 21.3-19.4-44.8zm41 94.9l61.3-18.7 52.8 86.6-79.8 11.3-34.3-79.2zm51.4-85.6l67.3-28.8 65.5 65.4-88.6 26.2-44.2-62.8z"
                }
            }
        ]
    })(props);
}
function FaScribd(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M42.3 252.7c-16.1-19-24.7-45.9-24.8-79.9 0-100.4 75.2-153.1 167.2-153.1 98.6-1.6 156.8 49 184.3 70.6l-50.5 72.1-37.3-24.6 26.9-38.6c-36.5-24-79.4-36.5-123-35.8-50.7-.8-111.7 27.2-111.7 76.2 0 18.7 11.2 20.7 28.6 15.6 23.3-5.3 41.9.6 55.8 14 26.4 24.3 23.2 67.6-.7 91.9-29.2 29.5-85.2 27.3-114.8-8.4zm317.7 5.9c-15.5-18.8-38.9-29.4-63.2-28.6-38.1-2-71.1 28-70.5 67.2-.7 16.8 6 33 18.4 44.3 14.1 13.9 33 19.7 56.3 14.4 17.4-5.1 28.6-3.1 28.6 15.6 0 4.3-.5 8.5-1.4 12.7-16.7 40.9-59.5 64.4-121.4 64.4-51.9.2-102.4-16.4-144.1-47.3l33.7-39.4-35.6-27.4L0 406.3l15.4 13.8c52.5 46.8 120.4 72.5 190.7 72.2 51.4 0 94.4-10.5 133.6-44.1 57.1-51.4 54.2-149.2 20.3-189.6z"
                }
            }
        ]
    })(props);
}
function FaSearchengin(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 460 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M220.6 130.3l-67.2 28.2V43.2L98.7 233.5l54.7-24.2v130.3l67.2-209.3zm-83.2-96.7l-1.3 4.7-15.2 52.9C80.6 106.7 52 145.8 52 191.5c0 52.3 34.3 95.9 83.4 105.5v53.6C57.5 340.1 0 272.4 0 191.6c0-80.5 59.8-147.2 137.4-158zm311.4 447.2c-11.2 11.2-23.1 12.3-28.6 10.5-5.4-1.8-27.1-19.9-60.4-44.4-33.3-24.6-33.6-35.7-43-56.7-9.4-20.9-30.4-42.6-57.5-52.4l-9.7-14.7c-24.7 16.9-53 26.9-81.3 28.7l2.1-6.6 15.9-49.5c46.5-11.9 80.9-54 80.9-104.2 0-54.5-38.4-102.1-96-107.1V32.3C254.4 37.4 320 106.8 320 191.6c0 33.6-11.2 64.7-29 90.4l14.6 9.6c9.8 27.1 31.5 48 52.4 57.4s32.2 9.7 56.8 43c24.6 33.2 42.7 54.9 44.5 60.3s.7 17.3-10.5 28.5zm-9.9-17.9c0-4.4-3.6-8-8-8s-8 3.6-8 8 3.6 8 8 8 8-3.6 8-8z"
                }
            }
        ]
    })(props);
}
function FaSellcast(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M353.4 32H94.7C42.6 32 0 74.6 0 126.6v258.7C0 437.4 42.6 480 94.7 480h258.7c52.1 0 94.7-42.6 94.7-94.6V126.6c0-52-42.6-94.6-94.7-94.6zm-50 316.4c-27.9 48.2-89.9 64.9-138.2 37.2-22.9 39.8-54.9 8.6-42.3-13.2l15.7-27.2c5.9-10.3 19.2-13.9 29.5-7.9 18.6 10.8-.1-.1 18.5 10.7 27.6 15.9 63.4 6.3 79.4-21.3 15.9-27.6 6.3-63.4-21.3-79.4-17.8-10.2-.6-.4-18.6-10.6-24.6-14.2-3.4-51.9 21.6-37.5 18.6 10.8-.1-.1 18.5 10.7 48.4 28 65.1 90.3 37.2 138.5zm21.8-208.8c-17 29.5-16.3 28.8-19 31.5-6.5 6.5-16.3 8.7-26.5 3.6-18.6-10.8.1.1-18.5-10.7-27.6-15.9-63.4-6.3-79.4 21.3s-6.3 63.4 21.3 79.4c0 0 18.5 10.6 18.6 10.6 24.6 14.2 3.4 51.9-21.6 37.5-18.6-10.8.1.1-18.5-10.7-48.2-27.8-64.9-90.1-37.1-138.4 27.9-48.2 89.9-64.9 138.2-37.2l4.8-8.4c14.3-24.9 52-3.3 37.7 21.5z"
                }
            }
        ]
    })(props);
}
function FaSellsy(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M539.71 237.308c3.064-12.257 4.29-24.821 4.29-37.384C544 107.382 468.618 32 376.076 32c-77.22 0-144.634 53.012-163.02 127.781-15.322-13.176-34.934-20.53-55.157-20.53-46.271 0-83.962 37.69-83.962 83.961 0 7.354.92 15.015 3.065 22.369-42.9 20.225-70.785 63.738-70.785 111.234C6.216 424.843 61.68 480 129.401 480h381.198c67.72 0 123.184-55.157 123.184-123.184.001-56.384-38.916-106.025-94.073-119.508zM199.88 401.554c0 8.274-7.048 15.321-15.321 15.321H153.61c-8.274 0-15.321-7.048-15.321-15.321V290.626c0-8.273 7.048-15.321 15.321-15.321h30.949c8.274 0 15.321 7.048 15.321 15.321v110.928zm89.477 0c0 8.274-7.048 15.321-15.322 15.321h-30.949c-8.274 0-15.321-7.048-15.321-15.321V270.096c0-8.274 7.048-15.321 15.321-15.321h30.949c8.274 0 15.322 7.048 15.322 15.321v131.458zm89.477 0c0 8.274-7.047 15.321-15.321 15.321h-30.949c-8.274 0-15.322-7.048-15.322-15.321V238.84c0-8.274 7.048-15.321 15.322-15.321h30.949c8.274 0 15.321 7.048 15.321 15.321v162.714zm87.027 0c0 8.274-7.048 15.321-15.322 15.321h-28.497c-8.274 0-15.321-7.048-15.321-15.321V176.941c0-8.579 7.047-15.628 15.321-15.628h28.497c8.274 0 15.322 7.048 15.322 15.628v224.613z"
                }
            }
        ]
    })(props);
}
function FaServicestack(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M88 216c81.7 10.2 273.7 102.3 304 232H0c99.5-8.1 184.5-137 88-232zm32-152c32.3 35.6 47.7 83.9 46.4 133.6C249.3 231.3 373.7 321.3 400 448h96C455.3 231.9 222.8 79.5 120 64z"
                }
            }
        ]
    })(props);
}
function FaShirtsinbulk(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M100 410.3l30.6 13.4 4.4-9.9-30.6-13.4zm39.4 17.5l30.6 13.4 4.4-9.9-30.6-13.4zm172.1-14l4.4 9.9 30.6-13.4-4.4-9.9zM179.1 445l30.3 13.7 4.4-9.9-30.3-13.4zM60.4 392.8L91 406.2l4.4-9.6-30.6-13.7zm211.4 38.5l4.4 9.9 30.6-13.4-4.4-9.9zm-39.3 17.5l4.4 9.9 30.6-13.7-4.4-9.6zm118.4-52.2l4.4 9.6 30.6-13.4-4.4-9.9zM170 46.6h-33.5v10.5H170zm-47.2 0H89.2v10.5h33.5zm-47.3 0H42.3v10.5h33.3zm141.5 0h-33.2v10.5H217zm94.5 0H278v10.5h33.5zm47.3 0h-33.5v10.5h33.5zm-94.6 0H231v10.5h33.2zm141.5 0h-33.3v10.5h33.3zM52.8 351.1H42v33.5h10.8zm70-215.9H89.2v10.5h33.5zm-70 10.6h22.8v-10.5H42v33.5h10.8zm168.9 228.6c50.5 0 91.3-40.8 91.3-91.3 0-50.2-40.8-91.3-91.3-91.3-50.2 0-91.3 41.1-91.3 91.3 0 50.5 41.1 91.3 91.3 91.3zm-48.2-111.1c0-25.4 29.5-31.8 49.6-31.8 16.9 0 29.2 5.8 44.3 12l-8.8 16.9h-.9c-6.4-9.9-24.8-13.1-35.6-13.1-9 0-29.8 1.8-29.8 14.9 0 21.6 78.5-10.2 78.5 37.9 0 25.4-31.5 31.2-51 31.2-18.1 0-32.4-2.9-47.2-12.2l9-18.4h.9c6.1 12.2 23.6 14.9 35.9 14.9 8.7 0 32.7-1.2 32.7-14.3 0-26.1-77.6 6.3-77.6-38zM52.8 178.4H42V212h10.8zm342.4 206.2H406v-33.5h-10.8zM52.8 307.9H42v33.5h10.8zM0 3.7v406l221.7 98.6L448 409.7V3.7zm418.8 387.1L222 476.5 29.2 390.8V120.7h389.7v270.1zm0-299.3H29.2V32.9h389.7v58.6zm-366 130.1H42v33.5h10.8zm0 43.2H42v33.5h10.8zM170 135.2h-33.5v10.5H170zm225.2 163.1H406v-33.5h-10.8zm0-43.2H406v-33.5h-10.8zM217 135.2h-33.2v10.5H217zM395.2 212H406v-33.5h-10.8zm0 129.5H406V308h-10.8zm-131-206.3H231v10.5h33.2zm47.3 0H278v10.5h33.5zm83.7 33.6H406v-33.5h-33.5v10.5h22.8zm-36.4-33.6h-33.5v10.5h33.5z"
                }
            }
        ]
    })(props);
}
function FaShopify(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M388.32,104.1a4.66,4.66,0,0,0-4.4-4c-2,0-37.23-.8-37.23-.8s-21.61-20.82-29.62-28.83V503.2L442.76,472S388.72,106.5,388.32,104.1ZM288.65,70.47a116.67,116.67,0,0,0-7.21-17.61C271,32.85,255.42,22,237,22a15,15,0,0,0-4,.4c-.4-.8-1.2-1.2-1.6-2C223.4,11.63,213,7.63,200.58,8c-24,.8-48,18-67.25,48.83-13.61,21.62-24,48.84-26.82,70.06-27.62,8.4-46.83,14.41-47.23,14.81-14,4.4-14.41,4.8-16,18-1.2,10-38,291.82-38,291.82L307.86,504V65.67a41.66,41.66,0,0,0-4.4.4S297.86,67.67,288.65,70.47ZM233.41,87.69c-16,4.8-33.63,10.4-50.84,15.61,4.8-18.82,14.41-37.63,25.62-50,4.4-4.4,10.41-9.61,17.21-12.81C232.21,54.86,233.81,74.48,233.41,87.69ZM200.58,24.44A27.49,27.49,0,0,1,215,28c-6.4,3.2-12.81,8.41-18.81,14.41-15.21,16.42-26.82,42-31.62,66.45-14.42,4.41-28.83,8.81-42,12.81C131.33,83.28,163.75,25.24,200.58,24.44ZM154.15,244.61c1.6,25.61,69.25,31.22,73.25,91.66,2.8,47.64-25.22,80.06-65.65,82.47-48.83,3.2-75.65-25.62-75.65-25.62l10.4-44s26.82,20.42,48.44,18.82c14-.8,19.22-12.41,18.81-20.42-2-33.62-57.24-31.62-60.84-86.86-3.2-46.44,27.22-93.27,94.47-97.68,26-1.6,39.23,4.81,39.23,4.81L221.4,225.39s-17.21-8-37.63-6.4C154.15,221,153.75,239.8,154.15,244.61ZM249.42,82.88c0-12-1.6-29.22-7.21-43.63,18.42,3.6,27.22,24,31.23,36.43Q262.63,78.68,249.42,82.88Z"
                }
            }
        ]
    })(props);
}
function FaShopware(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M403.5 455.41A246.17 246.17 0 0 1 256 504C118.81 504 8 393 8 256 8 118.81 119 8 256 8a247.39 247.39 0 0 1 165.7 63.5 3.57 3.57 0 0 1-2.86 6.18A418.62 418.62 0 0 0 362.13 74c-129.36 0-222.4 53.47-222.4 155.35 0 109 92.13 145.88 176.83 178.73 33.64 13 65.4 25.36 87 41.59a3.58 3.58 0 0 1 0 5.72zM503 233.09a3.64 3.64 0 0 0-1.27-2.44c-51.76-43-93.62-60.48-144.48-60.48-84.13 0-80.25 52.17-80.25 53.63 0 42.6 52.06 62 112.34 84.49 31.07 11.59 63.19 23.57 92.68 39.93a3.57 3.57 0 0 0 5-1.82A249 249 0 0 0 503 233.09z"
                }
            }
        ]
    })(props);
}
function FaSimplybuilt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M481.2 64h-106c-14.5 0-26.6 11.8-26.6 26.3v39.6H163.3V90.3c0-14.5-12-26.3-26.6-26.3h-106C16.1 64 4.3 75.8 4.3 90.3v331.4c0 14.5 11.8 26.3 26.6 26.3h450.4c14.8 0 26.6-11.8 26.6-26.3V90.3c-.2-14.5-12-26.3-26.7-26.3zM149.8 355.8c-36.6 0-66.4-29.7-66.4-66.4 0-36.9 29.7-66.6 66.4-66.6 36.9 0 66.6 29.7 66.6 66.6 0 36.7-29.7 66.4-66.6 66.4zm212.4 0c-36.9 0-66.6-29.7-66.6-66.6 0-36.6 29.7-66.4 66.6-66.4 36.6 0 66.4 29.7 66.4 66.4 0 36.9-29.8 66.6-66.4 66.6z"
                }
            }
        ]
    })(props);
}
function FaSistrix(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M448 449L301.2 300.2c20-27.9 31.9-62.2 31.9-99.2 0-93.1-74.7-168.9-166.5-168.9C74.7 32 0 107.8 0 200.9s74.7 168.9 166.5 168.9c39.8 0 76.3-14.2 105-37.9l146 148.1 30.5-31zM166.5 330.8c-70.6 0-128.1-58.3-128.1-129.9S95.9 71 166.5 71s128.1 58.3 128.1 129.9-57.4 129.9-128.1 129.9z"
                }
            }
        ]
    })(props);
}
function FaSith(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 32l69.71 118.75-58.86-11.52 69.84 91.03a146.741 146.741 0 0 0 0 51.45l-69.84 91.03 58.86-11.52L0 480l118.75-69.71-11.52 58.86 91.03-69.84c17.02 3.04 34.47 3.04 51.48 0l91.03 69.84-11.52-58.86L448 480l-69.71-118.78 58.86 11.52-69.84-91.03c3.03-17.01 3.04-34.44 0-51.45l69.84-91.03-58.86 11.52L448 32l-118.75 69.71 11.52-58.9-91.06 69.87c-8.5-1.52-17.1-2.29-25.71-2.29s-17.21.78-25.71 2.29l-91.06-69.87 11.52 58.9L0 32zm224 99.78c31.8 0 63.6 12.12 87.85 36.37 48.5 48.5 48.49 127.21 0 175.7s-127.2 48.46-175.7-.03c-48.5-48.5-48.49-127.21 0-175.7 24.24-24.25 56.05-36.34 87.85-36.34zm0 36.66c-22.42 0-44.83 8.52-61.92 25.61-34.18 34.18-34.19 89.68 0 123.87s89.65 34.18 123.84 0c34.18-34.18 34.19-89.68 0-123.87-17.09-17.09-39.5-25.61-61.92-25.61z"
                }
            }
        ]
    })(props);
}
function FaSketch(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M27.5 162.2L9 187.1h90.5l6.9-130.7-78.9 105.8zM396.3 45.7L267.7 32l135.7 147.2-7.1-133.5zM112.2 218.3l-11.2-22H9.9L234.8 458zm2-31.2h284l-81.5-88.5L256.3 33zm297.3 9.1L277.6 458l224.8-261.7h-90.9zM415.4 69L406 56.4l.9 17.3 6.1 113.4h90.3zM113.5 93.5l-4.6 85.6L244.7 32 116.1 45.7zm287.7 102.7h-290l42.4 82.9L256.3 480l144.9-283.8z"
                }
            }
        ]
    })(props);
}
function FaSkyatlas(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M640 329.3c0 65.9-52.5 114.4-117.5 114.4-165.9 0-196.6-249.7-359.7-249.7-146.9 0-147.1 212.2 5.6 212.2 42.5 0 90.9-17.8 125.3-42.5 5.6-4.1 16.9-16.3 22.8-16.3s10.9 5 10.9 10.9c0 7.8-13.1 19.1-18.7 24.1-40.9 35.6-100.3 61.2-154.7 61.2-83.4.1-154-59-154-144.9s67.5-149.1 152.8-149.1c185.3 0 222.5 245.9 361.9 245.9 99.9 0 94.8-139.7 3.4-139.7-17.5 0-35 11.6-46.9 11.6-8.4 0-15.9-7.2-15.9-15.6 0-11.6 5.3-23.7 5.3-36.3 0-66.6-50.9-114.7-116.9-114.7-53.1 0-80 36.9-88.8 36.9-6.2 0-11.2-5-11.2-11.2 0-5.6 4.1-10.3 7.8-14.4 25.3-28.8 64.7-43.7 102.8-43.7 79.4 0 139.1 58.4 139.1 137.8 0 6.9-.3 13.7-1.2 20.6 11.9-3.1 24.1-4.7 35.9-4.7 60.7 0 111.9 45.3 111.9 107.2z"
                }
            }
        ]
    })(props);
}
function FaSkype(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M424.7 299.8c2.9-14 4.7-28.9 4.7-43.8 0-113.5-91.9-205.3-205.3-205.3-14.9 0-29.7 1.7-43.8 4.7C161.3 40.7 137.7 32 112 32 50.2 32 0 82.2 0 144c0 25.7 8.7 49.3 23.3 68.2-2.9 14-4.7 28.9-4.7 43.8 0 113.5 91.9 205.3 205.3 205.3 14.9 0 29.7-1.7 43.8-4.7 19 14.6 42.6 23.3 68.2 23.3 61.8 0 112-50.2 112-112 .1-25.6-8.6-49.2-23.2-68.1zm-194.6 91.5c-65.6 0-120.5-29.2-120.5-65 0-16 9-30.6 29.5-30.6 31.2 0 34.1 44.9 88.1 44.9 25.7 0 42.3-11.4 42.3-26.3 0-18.7-16-21.6-42-28-62.5-15.4-117.8-22-117.8-87.2 0-59.2 58.6-81.1 109.1-81.1 55.1 0 110.8 21.9 110.8 55.4 0 16.9-11.4 31.8-30.3 31.8-28.3 0-29.2-33.5-75-33.5-25.7 0-42 7-42 22.5 0 19.8 20.8 21.8 69.1 33 41.4 9.3 90.7 26.8 90.7 77.6 0 59.1-57.1 86.5-112 86.5z"
                }
            }
        ]
    })(props);
}
function FaSlackHash(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M446.2 270.4c-6.2-19-26.9-29.1-46-22.9l-45.4 15.1-30.3-90 45.4-15.1c19.1-6.2 29.1-26.8 23-45.9-6.2-19-26.9-29.1-46-22.9l-45.4 15.1-15.7-47c-6.2-19-26.9-29.1-46-22.9-19.1 6.2-29.1 26.8-23 45.9l15.7 47-93.4 31.2-15.7-47c-6.2-19-26.9-29.1-46-22.9-19.1 6.2-29.1 26.8-23 45.9l15.7 47-45.3 15c-19.1 6.2-29.1 26.8-23 45.9 5 14.5 19.1 24 33.6 24.6 6.8 1 12-1.6 57.7-16.8l30.3 90L78 354.8c-19 6.2-29.1 26.9-23 45.9 5 14.5 19.1 24 33.6 24.6 6.8 1 12-1.6 57.7-16.8l15.7 47c5.9 16.9 24.7 29 46 22.9 19.1-6.2 29.1-26.8 23-45.9l-15.7-47 93.6-31.3 15.7 47c5.9 16.9 24.7 29 46 22.9 19.1-6.2 29.1-26.8 23-45.9l-15.7-47 45.4-15.1c19-6 29.1-26.7 22.9-45.7zm-254.1 47.2l-30.3-90.2 93.5-31.3 30.3 90.2-93.5 31.3z"
                }
            }
        ]
    })(props);
}
function FaSlack(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M94.12 315.1c0 25.9-21.16 47.06-47.06 47.06S0 341 0 315.1c0-25.9 21.16-47.06 47.06-47.06h47.06v47.06zm23.72 0c0-25.9 21.16-47.06 47.06-47.06s47.06 21.16 47.06 47.06v117.84c0 25.9-21.16 47.06-47.06 47.06s-47.06-21.16-47.06-47.06V315.1zm47.06-188.98c-25.9 0-47.06-21.16-47.06-47.06S139 32 164.9 32s47.06 21.16 47.06 47.06v47.06H164.9zm0 23.72c25.9 0 47.06 21.16 47.06 47.06s-21.16 47.06-47.06 47.06H47.06C21.16 243.96 0 222.8 0 196.9s21.16-47.06 47.06-47.06H164.9zm188.98 47.06c0-25.9 21.16-47.06 47.06-47.06 25.9 0 47.06 21.16 47.06 47.06s-21.16 47.06-47.06 47.06h-47.06V196.9zm-23.72 0c0 25.9-21.16 47.06-47.06 47.06-25.9 0-47.06-21.16-47.06-47.06V79.06c0-25.9 21.16-47.06 47.06-47.06 25.9 0 47.06 21.16 47.06 47.06V196.9zM283.1 385.88c25.9 0 47.06 21.16 47.06 47.06 0 25.9-21.16 47.06-47.06 47.06-25.9 0-47.06-21.16-47.06-47.06v-47.06h47.06zm0-23.72c-25.9 0-47.06-21.16-47.06-47.06 0-25.9 21.16-47.06 47.06-47.06h117.84c25.9 0 47.06 21.16 47.06 47.06 0 25.9-21.16 47.06-47.06 47.06H283.1z"
                }
            }
        ]
    })(props);
}
function FaSlideshare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M187.7 153.7c-34 0-61.7 25.7-61.7 57.7 0 31.7 27.7 57.7 61.7 57.7s61.7-26 61.7-57.7c0-32-27.7-57.7-61.7-57.7zm143.4 0c-34 0-61.7 25.7-61.7 57.7 0 31.7 27.7 57.7 61.7 57.7 34.3 0 61.7-26 61.7-57.7.1-32-27.4-57.7-61.7-57.7zm156.6 90l-6 4.3V49.7c0-27.4-20.6-49.7-46-49.7H76.6c-25.4 0-46 22.3-46 49.7V248c-2-1.4-4.3-2.9-6.3-4.3-15.1-10.6-25.1 4-16 17.7 18.3 22.6 53.1 50.3 106.3 72C58.3 525.1 252 555.7 248.9 457.5c0-.7.3-56.6.3-96.6 5.1 1.1 9.4 2.3 13.7 3.1 0 39.7.3 92.8.3 93.5-3.1 98.3 190.6 67.7 134.3-124 53.1-21.7 88-49.4 106.3-72 9.1-13.8-.9-28.3-16.1-17.8zm-30.5 19.2c-68.9 37.4-128.3 31.1-160.6 29.7-23.7-.9-32.6 9.1-33.7 24.9-10.3-7.7-18.6-15.5-20.3-17.1-5.1-5.4-13.7-8-27.1-7.7-31.7 1.1-89.7 7.4-157.4-28V72.3c0-34.9 8.9-45.7 40.6-45.7h317.7c30.3 0 40.9 12.9 40.9 45.7v190.6z"
                }
            }
        ]
    })(props);
}
function FaSnapchatGhost(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M510.846 392.673c-5.211 12.157-27.239 21.089-67.36 27.318-2.064 2.786-3.775 14.686-6.507 23.956-1.625 5.566-5.623 8.869-12.128 8.869l-.297-.005c-9.395 0-19.203-4.323-38.852-4.323-26.521 0-35.662 6.043-56.254 20.588-21.832 15.438-42.771 28.764-74.027 27.399-31.646 2.334-58.025-16.908-72.871-27.404-20.714-14.643-29.828-20.582-56.241-20.582-18.864 0-30.736 4.72-38.852 4.72-8.073 0-11.213-4.922-12.422-9.04-2.703-9.189-4.404-21.263-6.523-24.13-20.679-3.209-67.31-11.344-68.498-32.15a10.627 10.627 0 0 1 8.877-11.069c69.583-11.455 100.924-82.901 102.227-85.934.074-.176.155-.344.237-.515 3.713-7.537 4.544-13.849 2.463-18.753-5.05-11.896-26.872-16.164-36.053-19.796-23.715-9.366-27.015-20.128-25.612-27.504 2.437-12.836 21.725-20.735 33.002-15.453 8.919 4.181 16.843 6.297 23.547 6.297 5.022 0 8.212-1.204 9.96-2.171-2.043-35.936-7.101-87.29 5.687-115.969C158.122 21.304 229.705 15.42 250.826 15.42c.944 0 9.141-.089 10.11-.089 52.148 0 102.254 26.78 126.723 81.643 12.777 28.65 7.749 79.792 5.695 116.009 1.582.872 4.357 1.942 8.599 2.139 6.397-.286 13.815-2.389 22.069-6.257 6.085-2.846 14.406-2.461 20.48.058l.029.01c9.476 3.385 15.439 10.215 15.589 17.87.184 9.747-8.522 18.165-25.878 25.018-2.118.835-4.694 1.655-7.434 2.525-9.797 3.106-24.6 7.805-28.616 17.271-2.079 4.904-1.256 11.211 2.46 18.748.087.168.166.342.239.515 1.301 3.03 32.615 74.46 102.23 85.934 6.427 1.058 11.163 7.877 7.725 15.859z"
                }
            }
        ]
    })(props);
}
function FaSnapchatSquare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zm-6.5 314.9c-3.5 8.1-18.1 14-44.8 18.2-1.4 1.9-2.5 9.8-4.3 15.9-1.1 3.7-3.7 5.9-8.1 5.9h-.2c-6.2 0-12.8-2.9-25.8-2.9-17.6 0-23.7 4-37.4 13.7-14.5 10.3-28.4 19.1-49.2 18.2-21 1.6-38.6-11.2-48.5-18.2-13.8-9.7-19.8-13.7-37.4-13.7-12.5 0-20.4 3.1-25.8 3.1-5.4 0-7.5-3.3-8.3-6-1.8-6.1-2.9-14.1-4.3-16-13.8-2.1-44.8-7.5-45.5-21.4-.2-3.6 2.3-6.8 5.9-7.4 46.3-7.6 67.1-55.1 68-57.1 0-.1.1-.2.2-.3 2.5-5 3-9.2 1.6-12.5-3.4-7.9-17.9-10.7-24-13.2-15.8-6.2-18-13.4-17-18.3 1.6-8.5 14.4-13.8 21.9-10.3 5.9 2.8 11.2 4.2 15.7 4.2 3.3 0 5.5-.8 6.6-1.4-1.4-23.9-4.7-58 3.8-77.1C159.1 100 206.7 96 220.7 96c.6 0 6.1-.1 6.7-.1 34.7 0 68 17.8 84.3 54.3 8.5 19.1 5.2 53.1 3.8 77.1 1.1.6 2.9 1.3 5.7 1.4 4.3-.2 9.2-1.6 14.7-4.2 4-1.9 9.6-1.6 13.6 0 6.3 2.3 10.3 6.8 10.4 11.9.1 6.5-5.7 12.1-17.2 16.6-1.4.6-3.1 1.1-4.9 1.7-6.5 2.1-16.4 5.2-19 11.5-1.4 3.3-.8 7.5 1.6 12.5.1.1.1.2.2.3.9 2 21.7 49.5 68 57.1 4 1 7.1 5.5 4.9 10.8z"
                }
            }
        ]
    })(props);
}
function FaSnapchat(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm169.5 338.9c-3.5 8.1-18.1 14-44.8 18.2-1.4 1.9-2.5 9.8-4.3 15.9-1.1 3.7-3.7 5.9-8.1 5.9h-.2c-6.2 0-12.8-2.9-25.8-2.9-17.6 0-23.7 4-37.4 13.7-14.5 10.3-28.4 19.1-49.2 18.2-21 1.6-38.6-11.2-48.5-18.2-13.8-9.7-19.8-13.7-37.4-13.7-12.5 0-20.4 3.1-25.8 3.1-5.4 0-7.5-3.3-8.3-6-1.8-6.1-2.9-14.1-4.3-16-13.8-2.1-44.8-7.5-45.5-21.4-.2-3.6 2.3-6.8 5.9-7.4 46.3-7.6 67.1-55.1 68-57.1 0-.1.1-.2.2-.3 2.5-5 3-9.2 1.6-12.5-3.4-7.9-17.9-10.7-24-13.2-15.8-6.2-18-13.4-17-18.3 1.6-8.5 14.4-13.8 21.9-10.3 5.9 2.8 11.2 4.2 15.7 4.2 3.3 0 5.5-.8 6.6-1.4-1.4-23.9-4.7-58 3.8-77.1C183.1 100 230.7 96 244.7 96c.6 0 6.1-.1 6.7-.1 34.7 0 68 17.8 84.3 54.3 8.5 19.1 5.2 53.1 3.8 77.1 1.1.6 2.9 1.3 5.7 1.4 4.3-.2 9.2-1.6 14.7-4.2 4-1.9 9.6-1.6 13.6 0 6.3 2.3 10.3 6.8 10.4 11.9.1 6.5-5.7 12.1-17.2 16.6-1.4.6-3.1 1.1-4.9 1.7-6.5 2.1-16.4 5.2-19 11.5-1.4 3.3-.8 7.5 1.6 12.5.1.1.1.2.2.3.9 2 21.7 49.5 68 57.1 4 1 7.1 5.5 4.9 10.8z"
                }
            }
        ]
    })(props);
}
function FaSoundcloud(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M111.4 256.3l5.8 65-5.8 68.3c-.3 2.5-2.2 4.4-4.4 4.4s-4.2-1.9-4.2-4.4l-5.6-68.3 5.6-65c0-2.2 1.9-4.2 4.2-4.2 2.2 0 4.1 2 4.4 4.2zm21.4-45.6c-2.8 0-4.7 2.2-5 5l-5 105.6 5 68.3c.3 2.8 2.2 5 5 5 2.5 0 4.7-2.2 4.7-5l5.8-68.3-5.8-105.6c0-2.8-2.2-5-4.7-5zm25.5-24.1c-3.1 0-5.3 2.2-5.6 5.3l-4.4 130 4.4 67.8c.3 3.1 2.5 5.3 5.6 5.3 2.8 0 5.3-2.2 5.3-5.3l5.3-67.8-5.3-130c0-3.1-2.5-5.3-5.3-5.3zM7.2 283.2c-1.4 0-2.2 1.1-2.5 2.5L0 321.3l4.7 35c.3 1.4 1.1 2.5 2.5 2.5s2.2-1.1 2.5-2.5l5.6-35-5.6-35.6c-.3-1.4-1.1-2.5-2.5-2.5zm23.6-21.9c-1.4 0-2.5 1.1-2.5 2.5l-6.4 57.5 6.4 56.1c0 1.7 1.1 2.8 2.5 2.8s2.5-1.1 2.8-2.5l7.2-56.4-7.2-57.5c-.3-1.4-1.4-2.5-2.8-2.5zm25.3-11.4c-1.7 0-3.1 1.4-3.3 3.3L47 321.3l5.8 65.8c.3 1.7 1.7 3.1 3.3 3.1 1.7 0 3.1-1.4 3.1-3.1l6.9-65.8-6.9-68.1c0-1.9-1.4-3.3-3.1-3.3zm25.3-2.2c-1.9 0-3.6 1.4-3.6 3.6l-5.8 70 5.8 67.8c0 2.2 1.7 3.6 3.6 3.6s3.6-1.4 3.9-3.6l6.4-67.8-6.4-70c-.3-2.2-2-3.6-3.9-3.6zm241.4-110.9c-1.1-.8-2.8-1.4-4.2-1.4-2.2 0-4.2.8-5.6 1.9-1.9 1.7-3.1 4.2-3.3 6.7v.8l-3.3 176.7 1.7 32.5 1.7 31.7c.3 4.7 4.2 8.6 8.9 8.6s8.6-3.9 8.6-8.6l3.9-64.2-3.9-177.5c-.4-3-2-5.8-4.5-7.2zm-26.7 15.3c-1.4-.8-2.8-1.4-4.4-1.4s-3.1.6-4.4 1.4c-2.2 1.4-3.6 3.9-3.6 6.7l-.3 1.7-2.8 160.8s0 .3 3.1 65.6v.3c0 1.7.6 3.3 1.7 4.7 1.7 1.9 3.9 3.1 6.4 3.1 2.2 0 4.2-1.1 5.6-2.5 1.7-1.4 2.5-3.3 2.5-5.6l.3-6.7 3.1-58.6-3.3-162.8c-.3-2.8-1.7-5.3-3.9-6.7zm-111.4 22.5c-3.1 0-5.8 2.8-5.8 6.1l-4.4 140.6 4.4 67.2c.3 3.3 2.8 5.8 5.8 5.8 3.3 0 5.8-2.5 6.1-5.8l5-67.2-5-140.6c-.2-3.3-2.7-6.1-6.1-6.1zm376.7 62.8c-10.8 0-21.1 2.2-30.6 6.1-6.4-70.8-65.8-126.4-138.3-126.4-17.8 0-35 3.3-50.3 9.4-6.1 2.2-7.8 4.4-7.8 9.2v249.7c0 5 3.9 8.6 8.6 9.2h218.3c43.3 0 78.6-35 78.6-78.3.1-43.6-35.2-78.9-78.5-78.9zm-296.7-60.3c-4.2 0-7.5 3.3-7.8 7.8l-3.3 136.7 3.3 65.6c.3 4.2 3.6 7.5 7.8 7.5 4.2 0 7.5-3.3 7.5-7.5l3.9-65.6-3.9-136.7c-.3-4.5-3.3-7.8-7.5-7.8zm-53.6-7.8c-3.3 0-6.4 3.1-6.4 6.7l-3.9 145.3 3.9 66.9c.3 3.6 3.1 6.4 6.4 6.4 3.6 0 6.4-2.8 6.7-6.4l4.4-66.9-4.4-145.3c-.3-3.6-3.1-6.7-6.7-6.7zm26.7 3.4c-3.9 0-6.9 3.1-6.9 6.9L227 321.3l3.9 66.4c.3 3.9 3.1 6.9 6.9 6.9s6.9-3.1 6.9-6.9l4.2-66.4-4.2-141.7c0-3.9-3-6.9-6.9-6.9z"
                }
            }
        ]
    })(props);
}
function FaSourcetree(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M427.2 203c0-112.1-90.9-203-203-203C112.1-.2 21.2 90.6 21 202.6A202.86 202.86 0 0 0 161.5 396v101.7a14.3 14.3 0 0 0 14.3 14.3h96.4a14.3 14.3 0 0 0 14.3-14.3V396.1A203.18 203.18 0 0 0 427.2 203zm-271.6 0c0-90.8 137.3-90.8 137.3 0-.1 89.9-137.3 91-137.3 0z"
                }
            }
        ]
    })(props);
}
function FaSpeakap(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M64 391.78C-15.41 303.59-8 167.42 80.64 87.64s224.8-73 304.21 15.24 72 224.36-16.64 304.14c-18.74 16.87 64 43.09 42 52.26-82.06 34.21-253.91 35-346.23-67.5zm213.31-211.6l38.5-40.86c-9.61-8.89-32-26.83-76.17-27.6-52.33-.91-95.86 28.3-96.77 80-.2 11.33.29 36.72 29.42 54.83 34.46 21.42 86.52 21.51 86 52.26-.37 21.28-26.42 25.81-38.59 25.6-3-.05-30.23-.46-47.61-24.62l-40 42.61c28.16 27 59 32.62 83.49 33.05 10.23.18 96.42.33 97.84-81 .28-15.81-2.07-39.72-28.86-56.59-34.36-21.64-85-19.45-84.43-49.75.41-23.25 31-25.37 37.53-25.26.43 0 26.62.26 39.62 17.37z"
                }
            }
        ]
    })(props);
}
function FaSpeakerDeck(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M213.86 296H100a100 100 0 0 1 0-200h132.84a40 40 0 0 1 0 80H98c-26.47 0-26.45 40 0 40h113.82a100 100 0 0 1 0 200H40a40 40 0 0 1 0-80h173.86c26.48 0 26.46-40 0-40zM298 416a120.21 120.21 0 0 0 51.11-80h64.55a19.83 19.83 0 0 0 19.66-20V196a19.83 19.83 0 0 0-19.66-20H296.42a60.77 60.77 0 0 0 0-80h136.93c43.44 0 78.65 35.82 78.65 80v160c0 44.18-35.21 80-78.65 80z"
                }
            }
        ]
    })(props);
}
function FaSpotify(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111.1 8 0 119.1 0 256s111.1 248 248 248 248-111.1 248-248S384.9 8 248 8zm100.7 364.9c-4.2 0-6.8-1.3-10.7-3.6-62.4-37.6-135-39.2-206.7-24.5-3.9 1-9 2.6-11.9 2.6-9.7 0-15.8-7.7-15.8-15.8 0-10.3 6.1-15.2 13.6-16.8 81.9-18.1 165.6-16.5 237 26.2 6.1 3.9 9.7 7.4 9.7 16.5s-7.1 15.4-15.2 15.4zm26.9-65.6c-5.2 0-8.7-2.3-12.3-4.2-62.5-37-155.7-51.9-238.6-29.4-4.8 1.3-7.4 2.6-11.9 2.6-10.7 0-19.4-8.7-19.4-19.4s5.2-17.8 15.5-20.7c27.8-7.8 56.2-13.6 97.8-13.6 64.9 0 127.6 16.1 177 45.5 8.1 4.8 11.3 11 11.3 19.7-.1 10.8-8.5 19.5-19.4 19.5zm31-76.2c-5.2 0-8.4-1.3-12.9-3.9-71.2-42.5-198.5-52.7-280.9-29.7-3.6 1-8.1 2.6-12.9 2.6-13.2 0-23.3-10.3-23.3-23.6 0-13.6 8.4-21.3 17.4-23.9 35.2-10.3 74.6-15.2 117.5-15.2 73 0 149.5 15.2 205.4 47.8 7.8 4.5 12.9 10.7 12.9 22.6 0 13.6-11 23.3-23.2 23.3z"
                }
            }
        ]
    })(props);
}
function FaSquarespace(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M186.12 343.34c-9.65 9.65-9.65 25.29 0 34.94 9.65 9.65 25.29 9.65 34.94 0L378.24 221.1c19.29-19.29 50.57-19.29 69.86 0s19.29 50.57 0 69.86L293.95 445.1c19.27 19.29 50.53 19.31 69.82.04l.04-.04 119.25-119.24c38.59-38.59 38.59-101.14 0-139.72-38.59-38.59-101.15-38.59-139.72 0l-157.22 157.2zm244.53-104.8c-9.65-9.65-25.29-9.65-34.93 0l-157.2 157.18c-19.27 19.29-50.53 19.31-69.82.05l-.05-.05c-9.64-9.64-25.27-9.65-34.92-.01l-.01.01c-9.65 9.64-9.66 25.28-.02 34.93l.02.02c38.58 38.57 101.14 38.57 139.72 0l157.2-157.2c9.65-9.65 9.65-25.29.01-34.93zm-261.99 87.33l157.18-157.18c9.64-9.65 9.64-25.29 0-34.94-9.64-9.64-25.27-9.64-34.91 0L133.72 290.93c-19.28 19.29-50.56 19.3-69.85.01l-.01-.01c-19.29-19.28-19.31-50.54-.03-69.84l.03-.03L218.03 66.89c-19.28-19.29-50.55-19.3-69.85-.02l-.02.02L28.93 186.14c-38.58 38.59-38.58 101.14 0 139.72 38.6 38.59 101.13 38.59 139.73.01zm-87.33-52.4c9.64 9.64 25.27 9.64 34.91 0l157.21-157.19c19.28-19.29 50.55-19.3 69.84-.02l.02.02c9.65 9.65 25.29 9.65 34.93 0 9.65-9.65 9.65-25.29 0-34.93-38.59-38.59-101.13-38.59-139.72 0L81.33 238.54c-9.65 9.64-9.65 25.28-.01 34.93h.01z"
                }
            }
        ]
    })(props);
}
function FaStackExchange(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M17.7 332.3h412.7v22c0 37.7-29.3 68-65.3 68h-19L259.3 512v-89.7H83c-36 0-65.3-30.3-65.3-68v-22zm0-23.6h412.7v-85H17.7v85zm0-109.4h412.7v-85H17.7v85zM365 0H83C47 0 17.7 30.3 17.7 67.7V90h412.7V67.7C430.3 30.3 401 0 365 0z"
                }
            }
        ]
    })(props);
}
function FaStackOverflow(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M290.7 311L95 269.7 86.8 309l195.7 41zm51-87L188.2 95.7l-25.5 30.8 153.5 128.3zm-31.2 39.7L129.2 179l-16.7 36.5L293.7 300zM262 32l-32 24 119.3 160.3 32-24zm20.5 328h-200v39.7h200zm39.7 80H42.7V320h-40v160h359.5V320h-40z"
                }
            }
        ]
    })(props);
}
function FaStackpath(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M244.6 232.4c0 8.5-4.26 20.49-21.34 20.49h-19.61v-41.47h19.61c17.13 0 21.34 12.36 21.34 20.98zM448 32v448H0V32zM151.3 287.84c0-21.24-12.12-34.54-46.72-44.85-20.57-7.41-26-10.91-26-18.63s7-14.61 20.41-14.61c14.09 0 20.79 8.45 20.79 18.35h30.7l.19-.57c.5-19.57-15.06-41.65-51.12-41.65-23.37 0-52.55 10.75-52.55 38.29 0 19.4 9.25 31.29 50.74 44.37 17.26 6.15 21.91 10.4 21.91 19.48 0 15.2-19.13 14.23-19.47 14.23-20.4 0-25.65-9.1-25.65-21.9h-30.8l-.18.56c-.68 31.32 28.38 45.22 56.63 45.22 29.98 0 51.12-13.55 51.12-38.29zm125.38-55.63c0-25.3-18.43-45.46-53.42-45.46h-51.78v138.18h32.17v-47.36h19.61c30.25 0 53.42-15.95 53.42-45.36zM297.94 325L347 186.78h-31.09L268 325zm106.52-138.22h-31.09L325.46 325h29.94z"
                }
            }
        ]
    })(props);
}
function FaStaylinked(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 440 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M382.7 292.5l2.7 2.7-170-167.3c-3.5-3.5-9.7-3.7-13.8-.5L144.3 171c-4.2 3.2-4.6 8.7-1.1 12.2l68.1 64.3c3.6 3.5 9.9 3.7 14 .5l.1-.1c4.1-3.2 10.4-3 14 .5l84 81.3c3.6 3.5 3.2 9-.9 12.2l-93.2 74c-4.2 3.3-10.5 3.1-14.2-.4L63.2 268c-3.5-3.5-9.7-3.7-13.9-.5L3.5 302.4c-4.2 3.2-4.7 8.7-1.2 12.2L211 510.7s7.4 6.8 17.3-.8l198-163.9c4-3.2 4.4-8.7.7-12.2zm54.5-83.4L226.7 2.5c-1.5-1.2-8-5.5-16.3 1.1L3.6 165.7c-4.2 3.2-4.8 8.7-1.2 12.2l42.3 41.7 171.7 165.1c3.7 3.5 10.1 3.7 14.3.4l50.2-38.8-.3-.3 7.7-6c4.2-3.2 4.6-8.7.9-12.2l-57.1-54.4c-3.6-3.5-10-3.7-14.2-.5l-.1.1c-4.2 3.2-10.5 3.1-14.2-.4L109 180.8c-3.6-3.5-3.1-8.9 1.1-12.2l92.2-71.5c4.1-3.2 10.3-3 13.9.5l160.4 159c3.7 3.5 10 3.7 14.1.5l45.8-35.8c4.1-3.2 4.4-8.7.7-12.2z"
                }
            }
        ]
    })(props);
}
function FaSteamSquare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M185.2 356.5c7.7-18.5-1-39.7-19.6-47.4l-29.5-12.2c11.4-4.3 24.3-4.5 36.4.5 12.2 5.1 21.6 14.6 26.7 26.7 5 12.2 5 25.6-.1 37.7-10.5 25.1-39.4 37-64.6 26.5-11.6-4.8-20.4-13.6-25.4-24.2l28.5 11.8c18.6 7.8 39.9-.9 47.6-19.4zM400 32H48C21.5 32 0 53.5 0 80v160.7l116.6 48.1c12-8.2 26.2-12.1 40.7-11.3l55.4-80.2v-1.1c0-48.2 39.3-87.5 87.6-87.5s87.6 39.3 87.6 87.5c0 49.2-40.9 88.7-89.6 87.5l-79 56.3c1.6 38.5-29.1 68.8-65.7 68.8-31.8 0-58.5-22.7-64.5-52.7L0 319.2V432c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zm-99.7 222.5c-32.2 0-58.4-26.1-58.4-58.3s26.2-58.3 58.4-58.3 58.4 26.2 58.4 58.3-26.2 58.3-58.4 58.3zm.1-14.6c24.2 0 43.9-19.6 43.9-43.8 0-24.2-19.6-43.8-43.9-43.8-24.2 0-43.9 19.6-43.9 43.8 0 24.2 19.7 43.8 43.9 43.8z"
                }
            }
        ]
    })(props);
}
function FaSteamSymbol(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M395.5 177.5c0 33.8-27.5 61-61 61-33.8 0-61-27.3-61-61s27.3-61 61-61c33.5 0 61 27.2 61 61zm52.5.2c0 63-51 113.8-113.7 113.8L225 371.3c-4 43-40.5 76.8-84.5 76.8-40.5 0-74.7-28.8-83-67L0 358V250.7L97.2 290c15.1-9.2 32.2-13.3 52-11.5l71-101.7c.5-62.3 51.5-112.8 114-112.8C397 64 448 115 448 177.7zM203 363c0-34.7-27.8-62.5-62.5-62.5-4.5 0-9 .5-13.5 1.5l26 10.5c25.5 10.2 38 39 27.7 64.5-10.2 25.5-39.2 38-64.7 27.5-10.2-4-20.5-8.3-30.7-12.2 10.5 19.7 31.2 33.2 55.2 33.2 34.7 0 62.5-27.8 62.5-62.5zm207.5-185.3c0-42-34.3-76.2-76.2-76.2-42.3 0-76.5 34.2-76.5 76.2 0 42.2 34.3 76.2 76.5 76.2 41.9.1 76.2-33.9 76.2-76.2z"
                }
            }
        ]
    })(props);
}
function FaSteam(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M496 256c0 137-111.2 248-248.4 248-113.8 0-209.6-76.3-239-180.4l95.2 39.3c6.4 32.1 34.9 56.4 68.9 56.4 39.2 0 71.9-32.4 70.2-73.5l84.5-60.2c52.1 1.3 95.8-40.9 95.8-93.5 0-51.6-42-93.5-93.7-93.5s-93.7 42-93.7 93.5v1.2L176.6 279c-15.5-.9-30.7 3.4-43.5 12.1L0 236.1C10.2 108.4 117.1 8 247.6 8 384.8 8 496 119 496 256zM155.7 384.3l-30.5-12.6a52.79 52.79 0 0 0 27.2 25.8c26.9 11.2 57.8-1.6 69-28.4 5.4-13 5.5-27.3.1-40.3-5.4-13-15.5-23.2-28.5-28.6-12.9-5.4-26.7-5.2-38.9-.6l31.5 13c19.8 8.2 29.2 30.9 20.9 50.7-8.3 19.9-31 29.2-50.8 21zm173.8-129.9c-34.4 0-62.4-28-62.4-62.3s28-62.3 62.4-62.3 62.4 28 62.4 62.3-27.9 62.3-62.4 62.3zm.1-15.6c25.9 0 46.9-21 46.9-46.8 0-25.9-21-46.8-46.9-46.8s-46.9 21-46.9 46.8c.1 25.8 21.1 46.8 46.9 46.8z"
                }
            }
        ]
    })(props);
}
function FaStickerMule(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M561.7 199.6c-1.3.3.3 0 0 0zm-6.2-77.4c-7.7-22.3-5.1-7.2-13.4-36.9-1.6-6.5-3.6-14.5-6.2-20-4.4-8.7-4.6-7.5-4.6-9.5 0-5.3 30.7-45.3 19-46.9-5.7-.6-12.2 11.6-20.6 17-8.6 4.2-8 5-10.3 5-2.6 0-5.7-3-6.2-5-2-5.7 1.9-25.9-3.6-25.9-3.6 0-12.3 24.8-17 25.8-5.2 1.3-27.9-11.4-75.1 18-25.3 13.2-86.9 65.2-87 65.3-6.7 4.7-20 4.7-35.5 16-44.4 30.1-109.6 9.4-110.7 9-110.6-26.8-128-15.2-159 11.5-20.8 17.9-23.7 36.5-24.2 38.9-4.2 20.4 5.2 48.3 6.7 64.3 1.8 19.3-2.7 17.7 7.7 98.3.5 1 4.1 0 5.1 1.5 0 8.4-3.8 12.1-4.1 13-1.5 4.5-1.5 10.5 0 16 2.3 8.2 8.2 37.2 8.2 46.9 0 41.8.4 44 2.6 49.4 3.9 10 12.5 9.1 17 12 3.1 3.5-.5 8.5 1 12.5.5 2 3.6 4 6.2 5 9.2 3.6 27 .3 29.9-2.5 1.6-1.5.5-4.5 3.1-5 5.1 0 10.8-.5 14.4-2.5 5.1-2.5 4.1-6 1.5-10.5-.4-.8-7-13.3-9.8-16-2.1-2-5.1-3-7.2-4.5-5.8-4.9-10.3-19.4-10.3-19.5-4.6-19.4-10.3-46.3-4.1-66.8 4.6-17.2 39.5-87.7 39.6-87.8 4.1-6.5 17-11.5 27.3-7 6 1.9 19.3 22 65.4 30.9 47.9 8.7 97.4-2 112.2-2 2.8 2-1.9 13-.5 38.9 0 26.4-.4 13.7-4.1 29.9-2.2 9.7 3.4 23.2-1.5 46.9-1.4 9.8-9.9 32.7-8.2 43.4.5 1 1 2 1.5 3.5.5 4.5 1.5 8.5 4.6 10 7.3 3.6 12-3.5 9.8 11.5-.7 3.1-2.6 12 1.5 15 4.4 3.7 30.6 3.4 36.5.5 2.6-1.5 1.6-4.5 6.4-7.4 1.9-.9 11.3-.4 11.3-6.5.3-1.8-9.2-19.9-9.3-20-2.6-3.5-9.2-4.5-11.3-8-6.9-10.1-1.7-52.6.5-59.4 3-11 5.6-22.4 8.7-32.4 11-42.5 10.3-50.6 16.5-68.3.8-1.8 6.4-23.1 10.3-29.9 9.3-17 21.7-32.4 33.5-47.4 18-22.9 34-46.9 52-69.8 6.1-7 8.2-13.7 18-8 10.8 5.7 21.6 7 31.9 17 14.6 12.8 10.2 18.2 11.8 22.9 1.5 5 7.7 10.5 14.9 9.5 10.4-2 13-2.5 13.4-2.5 2.6-.5 5.7-5 7.2-8 3.1-5.5 7.2-9 7.2-16.5 0-7.7-.4-2.8-20.6-52.9z"
                }
            }
        ]
    })(props);
}
function FaStrava(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M158.4 0L7 292h89.2l62.2-116.1L220.1 292h88.5zm150.2 292l-43.9 88.2-44.6-88.2h-67.6l112.2 220 111.5-220z"
                }
            }
        ]
    })(props);
}
function FaStripeS(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M155.3 154.6c0-22.3 18.6-30.9 48.4-30.9 43.4 0 98.5 13.3 141.9 36.7V26.1C298.3 7.2 251.1 0 203.8 0 88.1 0 11 60.4 11 161.4c0 157.9 216.8 132.3 216.8 200.4 0 26.4-22.9 34.9-54.7 34.9-47.2 0-108.2-19.5-156.1-45.5v128.5a396.09 396.09 0 0 0 156 32.4c118.6 0 200.3-51 200.3-153.6 0-170.2-218-139.7-218-203.9z"
                }
            }
        ]
    })(props);
}
function FaStripe(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M165 144.7l-43.3 9.2-.2 142.4c0 26.3 19.8 43.3 46.1 43.3 14.6 0 25.3-2.7 31.2-5.9v-33.8c-5.7 2.3-33.7 10.5-33.7-15.7V221h33.7v-37.8h-33.7zm89.1 51.6l-2.7-13.1H213v153.2h44.3V233.3c10.5-13.8 28.2-11.1 33.9-9.3v-40.8c-6-2.1-26.7-6-37.1 13.1zm92.3-72.3l-44.6 9.5v36.2l44.6-9.5zM44.9 228.3c0-6.9 5.8-9.6 15.1-9.7 13.5 0 30.7 4.1 44.2 11.4v-41.8c-14.7-5.8-29.4-8.1-44.1-8.1-36 0-60 18.8-60 50.2 0 49.2 67.5 41.2 67.5 62.4 0 8.2-7.1 10.9-17 10.9-14.7 0-33.7-6.1-48.6-14.2v40c16.5 7.1 33.2 10.1 48.5 10.1 36.9 0 62.3-15.8 62.3-47.8 0-52.9-67.9-43.4-67.9-63.4zM640 261.6c0-45.5-22-81.4-64.2-81.4s-67.9 35.9-67.9 81.1c0 53.5 30.3 78.2 73.5 78.2 21.2 0 37.1-4.8 49.2-11.5v-33.4c-12.1 6.1-26 9.8-43.6 9.8-17.3 0-32.5-6.1-34.5-26.9h86.9c.2-2.3.6-11.6.6-15.9zm-87.9-16.8c0-20 12.3-28.4 23.4-28.4 10.9 0 22.5 8.4 22.5 28.4zm-112.9-64.6c-17.4 0-28.6 8.2-34.8 13.9l-2.3-11H363v204.8l44.4-9.4.1-50.2c6.4 4.7 15.9 11.2 31.4 11.2 31.8 0 60.8-23.2 60.8-79.6.1-51.6-29.3-79.7-60.5-79.7zm-10.6 122.5c-10.4 0-16.6-3.8-20.9-8.4l-.3-66c4.6-5.1 11-8.8 21.2-8.8 16.2 0 27.4 18.2 27.4 41.4.1 23.9-10.9 41.8-27.4 41.8zm-126.7 33.7h44.6V183.2h-44.6z"
                }
            }
        ]
    })(props);
}
function FaStudiovinari(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M480.3 187.7l4.2 28v28l-25.1 44.1-39.8 78.4-56.1 67.5-79.1 37.8-17.7 24.5-7.7 12-9.6 4s17.3-63.6 19.4-63.6c2.1 0 20.3.7 20.3.7l66.7-38.6-92.5 26.1-55.9 36.8-22.8 28-6.6 1.4 20.8-73.6 6.9-5.5 20.7 12.9 88.3-45.2 56.8-51.5 14.8-68.4-125.4 23.3 15.2-18.2-173.4-53.3 81.9-10.5-166-122.9L133.5 108 32.2 0l252.9 126.6-31.5-38L378 163 234.7 64l18.7 38.4-49.6-18.1L158.3 0l194.6 122L310 66.2l108 96.4 12-8.9-21-16.4 4.2-37.8L451 89.1l29.2 24.7 11.5 4.2-7 6.2 8.5 12-13.1 7.4-10.3 20.2 10.5 23.9z"
                }
            }
        ]
    })(props);
}
function FaStumbleuponCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm0 177.5c-9.8 0-17.8 8-17.8 17.8v106.9c0 40.9-33.9 73.9-74.9 73.9-41.4 0-74.9-33.5-74.9-74.9v-46.5h57.3v45.8c0 10 8 17.8 17.8 17.8s17.8-7.9 17.8-17.8V200.1c0-40 34.2-72.1 74.7-72.1 40.7 0 74.7 32.3 74.7 72.6v23.7l-34.1 10.1-22.9-10.7v-20.6c.1-9.6-7.9-17.6-17.7-17.6zm167.6 123.6c0 41.4-33.5 74.9-74.9 74.9-41.2 0-74.9-33.2-74.9-74.2V263l22.9 10.7 34.1-10.1v47.1c0 9.8 8 17.6 17.8 17.6s17.8-7.9 17.8-17.6v-48h57.3c-.1 45.9-.1 46.4-.1 46.4z"
                }
            }
        ]
    })(props);
}
function FaStumbleupon(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M502.9 266v69.7c0 62.1-50.3 112.4-112.4 112.4-61.8 0-112.4-49.8-112.4-111.3v-70.2l34.3 16 51.1-15.2V338c0 14.7 12 26.5 26.7 26.5S417 352.7 417 338v-72h85.9zm-224.7-58.2l34.3 16 51.1-15.2V173c0-60.5-51.1-109-112.1-109-60.8 0-112.1 48.2-112.1 108.2v162.4c0 14.9-12 26.7-26.7 26.7S86 349.5 86 334.6V266H0v69.7C0 397.7 50.3 448 112.4 448c61.6 0 112.4-49.5 112.4-110.8V176.9c0-14.7 12-26.7 26.7-26.7s26.7 12 26.7 26.7v30.9z"
                }
            }
        ]
    })(props);
}
function FaSuperpowers(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M448 32c-83.3 11-166.8 22-250 33-92 12.5-163.3 86.7-169 180-3.3 55.5 18 109.5 57.8 148.2L0 480c83.3-11 166.5-22 249.8-33 91.8-12.5 163.3-86.8 168.7-179.8 3.5-55.5-18-109.5-57.7-148.2L448 32zm-79.7 232.3c-4.2 79.5-74 139.2-152.8 134.5-79.5-4.7-140.7-71-136.3-151 4.5-79.2 74.3-139.3 153-134.5 79.3 4.7 140.5 71 136.1 151z"
                }
            }
        ]
    })(props);
}
function FaSupple(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M640 262.5c0 64.1-109 116.1-243.5 116.1-24.8 0-48.6-1.8-71.1-5 7.7.4 15.5.6 23.4.6 134.5 0 243.5-56.9 243.5-127.1 0-29.4-19.1-56.4-51.2-78 60 21.1 98.9 55.1 98.9 93.4zM47.7 227.9c-.1-70.2 108.8-127.3 243.3-127.6 7.9 0 15.6.2 23.3.5-22.5-3.2-46.3-4.9-71-4.9C108.8 96.3-.1 148.5 0 212.6c.1 38.3 39.1 72.3 99.3 93.3-32.3-21.5-51.5-48.6-51.6-78zm60.2 39.9s10.5 13.2 29.3 13.2c17.9 0 28.4-11.5 28.4-25.1 0-28-40.2-25.1-40.2-39.7 0-5.4 5.3-9.1 12.5-9.1 5.7 0 11.3 2.6 11.3 6.6v3.9h14.2v-7.9c0-12.1-15.4-16.8-25.4-16.8-16.5 0-28.5 10.2-28.5 24.1 0 26.6 40.2 25.4 40.2 39.9 0 6.6-5.8 10.1-12.3 10.1-11.9 0-20.7-10.1-20.7-10.1l-8.8 10.9zm120.8-73.6v54.4c0 11.3-7.1 17.8-17.8 17.8-10.7 0-17.8-6.5-17.8-17.7v-54.5h-15.8v55c0 18.9 13.4 31.9 33.7 31.9 20.1 0 33.4-13 33.4-31.9v-55h-15.7zm34.4 85.4h15.8v-29.5h15.5c16 0 27.2-11.5 27.2-28.1s-11.2-27.8-27.2-27.8h-39.1v13.4h7.8v72zm15.8-43v-29.1h12.9c8.7 0 13.7 5.7 13.7 14.4 0 8.9-5.1 14.7-14 14.7h-12.6zm57 43h15.8v-29.5h15.5c16 0 27.2-11.5 27.2-28.1s-11.2-27.8-27.2-27.8h-39.1v13.4h7.8v72zm15.7-43v-29.1h12.9c8.7 0 13.7 5.7 13.7 14.4 0 8.9-5 14.7-14 14.7h-12.6zm57.1 34.8c0 5.8 2.4 8.2 8.2 8.2h37.6c5.8 0 8.2-2.4 8.2-8.2v-13h-14.3v5.2c0 1.7-1 2.6-2.6 2.6h-18.6c-1.7 0-2.6-1-2.6-2.6v-61.2c0-5.7-2.4-8.2-8.2-8.2H401v13.4h5.2c1.7 0 2.6 1 2.6 2.6v61.2zm63.4 0c0 5.8 2.4 8.2 8.2 8.2H519c5.7 0 8.2-2.4 8.2-8.2v-13h-14.3v5.2c0 1.7-1 2.6-2.6 2.6h-19.7c-1.7 0-2.6-1-2.6-2.6v-20.3h27.7v-13.4H488v-22.4h19.2c1.7 0 2.6 1 2.6 2.6v5.2H524v-13c0-5.7-2.5-8.2-8.2-8.2h-51.6v13.4h7.8v63.9zm58.9-76v5.9h1.6v-5.9h2.7v-1.2h-7v1.2h2.7zm5.7-1.2v7.1h1.5v-5.7l2.3 5.7h1.3l2.3-5.7v5.7h1.5v-7.1h-2.3l-2.1 5.1-2.1-5.1h-2.4z"
                }
            }
        ]
    })(props);
}
function FaSuse(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M471.08 102.66s-.3 18.3-.3 20.3c-9.1-3-74.4-24.1-135.7-26.3-51.9-1.8-122.8-4.3-223 57.3-19.4 12.4-73.9 46.1-99.6 109.7C7 277-.12 307 7 335.06a111 111 0 0 0 16.5 35.7c17.4 25 46.6 41.6 78.1 44.4 44.4 3.9 78.1-16 90-53.3 8.2-25.8 0-63.6-31.5-82.9-25.6-15.7-53.3-12.1-69.2-1.6-13.9 9.2-21.8 23.5-21.6 39.2.3 27.8 24.3 42.6 41.5 42.6a49 49 0 0 0 15.8-2.7c6.5-1.8 13.3-6.5 13.3-14.9 0-12.1-11.6-14.8-16.8-13.9-2.9.5-4.5 2-11.8 2.4-2-.2-12-3.1-12-14V316c.2-12.3 13.2-18 25.5-16.9 32.3 2.8 47.7 40.7 28.5 65.7-18.3 23.7-76.6 23.2-99.7-20.4-26-49.2 12.7-111.2 87-98.4 33.2 5.7 83.6 35.5 102.4 104.3h45.9c-5.7-17.6-8.9-68.3 42.7-68.3 56.7 0 63.9 39.9 79.8 68.3H460c-12.8-18.3-21.7-38.7-18.9-55.8 5.6-33.8 39.7-18.4 82.4-17.4 66.5.4 102.1-27 103.1-28 3.7-3.1 6.5-15.8 7-17.7 1.3-5.1-3.2-2.4-3.2-2.4-8.7 5.2-30.5 15.2-50.9 15.6-25.3.5-76.2-25.4-81.6-28.2-.3-.4.1 1.2-11-25.5 88.4 58.3 118.3 40.5 145.2 21.7.8-.6 4.3-2.9 3.6-5.7-13.8-48.1-22.4-62.7-34.5-69.6-37-21.6-125-34.7-129.2-35.3.1-.1-.9-.3-.9.7zm60.4 72.8a37.54 37.54 0 0 1 38.9-36.3c33.4 1.2 48.8 42.3 24.4 65.2-24.2 22.7-64.4 4.6-63.3-28.9zm38.6-25.3a26.27 26.27 0 1 0 25.4 27.2 26.19 26.19 0 0 0-25.4-27.2zm4.3 28.8c-15.4 0-15.4-15.6 0-15.6s15.4 15.64 0 15.64z"
                }
            }
        ]
    })(props);
}
function FaSwift(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M448 156.09c0-4.51-.08-9-.2-13.52a196.31 196.31 0 0 0-2.58-29.42 99.62 99.62 0 0 0-9.22-28A94.08 94.08 0 0 0 394.84 44a99.17 99.17 0 0 0-28-9.22 195 195 0 0 0-29.43-2.59c-4.51-.12-9-.17-13.52-.2H124.14c-4.51 0-9 .08-13.52.2-2.45.07-4.91.15-7.37.27a171.68 171.68 0 0 0-22.06 2.32 103.06 103.06 0 0 0-21.21 6.1q-3.46 1.45-6.81 3.12a94.66 94.66 0 0 0-18.39 12.32c-1.88 1.61-3.69 3.28-5.43 5A93.86 93.86 0 0 0 12 85.17a99.45 99.45 0 0 0-9.22 28 196.31 196.31 0 0 0-2.54 29.4c-.13 4.51-.18 9-.21 13.52v199.83c0 4.51.08 9 .21 13.51a196.08 196.08 0 0 0 2.58 29.42 99.3 99.3 0 0 0 9.22 28A94.31 94.31 0 0 0 53.17 468a99.47 99.47 0 0 0 28 9.21 195 195 0 0 0 29.43 2.59c4.5.12 9 .17 13.52.2H323.91c4.51 0 9-.08 13.52-.2a196.59 196.59 0 0 0 29.44-2.59 99.57 99.57 0 0 0 28-9.21A94.22 94.22 0 0 0 436 426.84a99.3 99.3 0 0 0 9.22-28 194.79 194.79 0 0 0 2.59-29.42c.12-4.5.17-9 .2-13.51V172.14c-.01-5.35-.01-10.7-.01-16.05zm-69.88 241c-20-38.93-57.23-29.27-76.31-19.47-1.72 1-3.48 2-5.25 3l-.42.25c-39.5 21-92.53 22.54-145.85-.38A234.64 234.64 0 0 1 45 290.12a230.63 230.63 0 0 0 39.17 23.37c56.36 26.4 113 24.49 153 0-57-43.85-104.6-101-141.09-147.22a197.09 197.09 0 0 1-18.78-25.9c43.7 40 112.7 90.22 137.48 104.12-52.57-55.49-98.89-123.94-96.72-121.74 82.79 83.42 159.18 130.59 159.18 130.59 2.88 1.58 5 2.85 6.73 4a127.44 127.44 0 0 0 4.16-12.47c13.22-48.33-1.66-103.58-35.31-149.2C329.61 141.75 375 229.34 356.4 303.42c-.44 1.73-.95 3.4-1.44 5.09 38.52 47.4 28.04 98.17 23.13 88.59z"
                }
            }
        ]
    })(props);
}
function FaSymfony(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm133.74 143.54c-11.47.41-19.4-6.45-19.77-16.87-.27-9.18 6.68-13.44 6.53-18.85-.23-6.55-10.16-6.82-12.87-6.67-39.78 1.29-48.59 57-58.89 113.85 21.43 3.15 36.65-.72 45.14-6.22 12-7.75-3.34-15.72-1.42-24.56 4-18.16 32.55-19 32 5.3-.36 17.86-25.92 41.81-77.6 35.7-10.76 59.52-18.35 115-58.2 161.72-29 34.46-58.4 39.82-71.58 40.26-24.65.85-41-12.31-41.58-29.84-.56-17 14.45-26.26 24.31-26.59 21.89-.75 30.12 25.67 14.88 34-12.09 9.71.11 12.61 2.05 12.55 10.42-.36 17.34-5.51 22.18-9 24-20 33.24-54.86 45.35-118.35 8.19-49.66 17-78 18.23-82-16.93-12.75-27.08-28.55-49.85-34.72-15.61-4.23-25.12-.63-31.81 7.83-7.92 10-5.29 23 2.37 30.7l12.63 14c15.51 17.93 24 31.87 20.8 50.62-5.06 29.93-40.72 52.9-82.88 39.94-36-11.11-42.7-36.56-38.38-50.62 7.51-24.15 42.36-11.72 34.62 13.6-2.79 8.6-4.92 8.68-6.28 13.07-4.56 14.77 41.85 28.4 51-1.39 4.47-14.52-5.3-21.71-22.25-39.85-28.47-31.75-16-65.49 2.95-79.67C204.23 140.13 251.94 197 262 205.29c37.17-109 100.53-105.46 102.43-105.53 25.16-.81 44.19 10.59 44.83 28.65.25 7.69-4.17 22.59-19.52 23.13z"
                }
            }
        ]
    })(props);
}
function FaTeamspeak(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M244.2 346.79c2.4-12.3-12-30-32.4-48.7-20.9-19.2-48.2-39.1-63.4-46.6-21.7-12-41.7-1.8-46.3 22.7-5 26.2 0 51.4 14.5 73.9 10.2 15.5 25.4 22.7 43.4 24 11.6.6 52.5 2.2 61.7-1 11.9-4.3 20.1-11.8 22.5-24.3zm205 20.8a5.22 5.22 0 0 0-8.3 2.4c-8 25.4-44.7 112.5-172.1 121.5-149.7 10.5 80.3 43.6 145.4-6.4 22.7-17.4 47.6-35 46.6-85.4-.4-10.1-4.9-26.69-11.6-32.1zm62-122.4c-.3-18.9-8.6-33.4-26-42.2-2.9-1.3-5-2.7-5.9-6.4A222.64 222.64 0 0 0 438.9 103c-1.1-1.5-3.5-3.2-2.2-5 8.5-11.5-.3-18-7-24.4Q321.4-31.11 177.4 13.09c-40.1 12.3-73.9 35.6-102 67.4-4 4.3-6.7 9.1-3 14.5 3 4 1.3 6.2-1 9.3C51.6 132 38.2 162.59 32.1 196c-.7 4.3-2.9 6-6.4 7.8-14.2 7-22.5 18.5-24.9 34L0 264.29v20.9c0 30.8 21 50.4 51.8 49 7.7-.3 11.7-4.3 12-11.5 2-77.5-2.4-95.4 3.7-125.8C92.1 72.39 234.3 5 345.3 65.39 411.4 102 445.7 159 447.6 234.79c.8 28.2 0 56.5 0 84.6 0 7 2.2 12.5 9.4 14.2 24.1 5 49.2-12 53.2-36.7 2.9-17.1 1-34.5 1-51.7zm-159.6 131.5c36.5 2.8 59.3-28.5 58.4-60.5-2.1-45.2-66.2-16.5-87.8-8-73.2 28.1-45 54.9-22.2 60.8z"
                }
            }
        ]
    })(props);
}
function FaTelegramPlane(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M446.7 98.6l-67.6 318.8c-5.1 22.5-18.4 28.1-37.3 17.5l-103-75.9-49.7 47.8c-5.5 5.5-10.1 10.1-20.7 10.1l7.4-104.9 190.9-172.5c8.3-7.4-1.8-11.5-12.9-4.1L117.8 284 16.2 252.2c-22.1-6.9-22.5-22.1 4.6-32.7L418.2 66.4c18.4-6.9 34.5 4.1 28.5 32.2z"
                }
            }
        ]
    })(props);
}
function FaTelegram(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm121.8 169.9l-40.7 191.8c-3 13.6-11.1 16.9-22.4 10.5l-62-45.7-29.9 28.8c-3.3 3.3-6.1 6.1-12.5 6.1l4.4-63.1 114.9-103.8c5-4.4-1.1-6.9-7.7-2.5l-142 89.4-61.2-19.1c-13.3-4.2-13.6-13.3 2.8-19.7l239.1-92.2c11.1-4 20.8 2.7 17.2 19.5z"
                }
            }
        ]
    })(props);
}
function FaTencentWeibo(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M72.3 495.8c1.4 19.9-27.6 22.2-29.7 2.9C31 368.8 73.7 259.2 144 185.5c-15.6-34 9.2-77.1 50.6-77.1 30.3 0 55.1 24.6 55.1 55.1 0 44-49.5 70.8-86.9 45.1-65.7 71.3-101.4 169.8-90.5 287.2zM192 .1C66.1.1-12.3 134.3 43.7 242.4 52.4 259.8 79 246.9 70 229 23.7 136.4 91 29.8 192 29.8c75.4 0 136.9 61.4 136.9 136.9 0 90.8-86.9 153.9-167.7 133.1-19.1-4.1-25.6 24.4-6.6 29.1 110.7 23.2 204-60 204-162.3C358.6 74.7 284 .1 192 .1z"
                }
            }
        ]
    })(props);
}
function FaTheRedYeti(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M488.23 241.7l20.7 7.1c-9.6-23.9-23.9-37-31.7-44.8l7.1-18.2c.2 0 12.3-27.8-2.5-30.7-.6-11.3-6.6-27-18.4-27-7.6-10.6-17.7-12.3-30.7-5.9a122.2 122.2 0 0 0-25.3 16.5c-5.3-6.4-3 .4-3-29.8-37.1-24.3-45.4-11.7-74.8 3l.5.5a239.36 239.36 0 0 0-68.4-13.3c-5.5-8.7-18.6-19.1-25.1-25.1l24.8 7.1c-5.5-5.5-26.8-12.9-34.2-15.2 18.2-4.1 29.8-20.8 42.5-33-34.9-10.1-67.9-5.9-97.9 11.8l12-44.2L182 0c-31.6 24.2-33 41.9-33.7 45.5-.9-2.4-6.3-19.6-15.2-27a35.12 35.12 0 0 0-.5 25.3c3 8.4 5.9 14.8 8.4 18.9-16-3.3-28.3-4.9-49.2 0h-3.7l33 14.3a194.26 194.26 0 0 0-46.7 67.4l-1.7 8.4 1.7 1.7 7.6-4.7c-3.3 11.6-5.3 19.4-6.6 25.8a200.18 200.18 0 0 0-27.8 40.3c-15 1-31.8 10.8-40.3 14.3l3 3.4 28.8 1c-.5 1-.7 2.2-1.2 3.2-7.3 6.4-39.8 37.7-33 80.7l20.2-22.4c.5 1.7.7 3.4 1.2 5.2 0 25.5.4 89.6 64.9 150.5 43.6 40 96 60.2 157.5 60.2 121.7 0 223-87.3 223-211.5 6.8-9.7-1.2 3 16.7-25.1l13 14.3 2.5-.5A181.84 181.84 0 0 0 495 255a44.74 44.74 0 0 0-6.8-13.3zM398 111.2l-.5 21.9c5.5 18.1 16.9 17.2 22.4 17.2l-3.4-4.7 22.4-5.4a242.44 242.44 0 0 1-27 0c12.8-2.1 33.3-29 43-11.3 3.4 7.6 6.4 17.2 9.3 27.8l1.7-5.9a56.38 56.38 0 0 1-1.7-15.2c5.4.5 8.8 3.4 9.3 10.1.5 6.4 1.7 14.8 3.4 25.3l4.7-11.3c4.6 0 4.5-3.6-2.5 20.7-20.9-8.7-35.1-8.4-46.5-8.4l18.2-16c-25.3 8.2-33 10.8-54.8 20.9-1.1-5.4-5-13.5-16-19.9-3.2 3.8-2.8.9-.7 14.8h-2.5a62.32 62.32 0 0 0-8.4-23.1l4.2-3.4c8.4-7.1 11.8-14.3 10.6-21.9-.5-6.4-5.4-13.5-13.5-20.7 5.6-3.4 15.2-.4 28.3 8.5zm-39.6-10.1c2.7 1.9 11.4 5.4 18.9 17.2 4.2 8.4 4 9.8 3.4 11.1-.5 2.4-.5 4.3-3 7.1-1.7 2.5-5.4 4.7-11.8 7.6-7.6-13-16.5-23.6-27.8-31.2zM91 143.1l1.2-1.7c1.2-2.9 4.2-7.6 9.3-15.2l2.5-3.4-13 12.3 5.4-4.7-10.1 9.3-4.2 1.2c12.3-24.1 23.1-41.3 32.5-50.2 9.3-9.3 16-16 20.2-19.4l-6.4 1.2c-11.3-4.2-19.4-7.1-24.8-8.4 2.5-.5 3.7-.5 3.2-.5 10.3 0 17.5.5 20.9 1.2a52.35 52.35 0 0 0 16 2.5l.5-1.7-8.4-35.8 13.5 29a42.89 42.89 0 0 0 5.9-14.3c1.7-6.4 5.4-13 10.1-19.4s7.6-10.6 9.3-11.3a234.68 234.68 0 0 0-6.4 25.3l-1.7 7.1-.5 4.7 2.5 2.5C190.4 39.9 214 34 239.8 34.5l21.1.5c-11.8 13.5-27.8 21.9-48.5 24.8a201.26 201.26 0 0 1-23.4 2.9l-.2-.5-2.5-1.2a20.75 20.75 0 0 0-14 2c-2.5-.2-4.9-.5-7.1-.7l-2.5 1.7.5 1.2c2 .2 3.9.5 6.2.7l-2 3.4 3.4-.5-10.6 11.3c-4.2 3-5.4 6.4-4.2 9.3l5.4-3.4h1.2a39.4 39.4 0 0 1 25.3-15.2v-3c6.4.5 13 1 19.4 1.2 6.4 0 8.4.5 5.4 1.2a189.6 189.6 0 0 1 20.7 13.5c13.5 10.1 23.6 21.9 30 35.4 8.8 18.2 13.5 37.1 13.5 56.6a141.13 141.13 0 0 1-3 28.3 209.91 209.91 0 0 1-16 46l2.5.5c18.2-19.7 41.9-16 49.2-16l-6.4 5.9 22.4 17.7-1.7 30.7c-5.4-12.3-16.5-21.1-33-27.8 16.5 14.8 23.6 21.1 21.9 20.2-4.8-2.8-3.5-1.9-10.8-3.7 4.1 4.1 17.5 18.8 18.2 20.7l.2.2-.2.2c0 1.8 1.6-1.2-14 22.9-75.2-15.3-106.27-42.7-141.2-63.2l11.8 1.2c-11.8-18.5-15.6-17.7-38.4-26.1L149 225c-8.8-3-18.2-3-28.3.5l7.6-10.6-1.2-1.7c-14.9 4.3-19.8 9.2-22.6 11.3-1.1-5.5-2.8-12.4-12.3-28.8l-1.2 27-13.2-5c1.5-25.2 5.4-50.5 13.2-74.6zm276.5 330c-49.9 25-56.1 22.4-59 23.9-29.8-11.8-50.9-31.7-63.5-58.8l30 16.5c-9.8-9.3-18.3-16.5-38.4-44.3l11.8 23.1-17.7-7.6c14.2 21.1 23.5 51.7 66.6 73.5-120.8 24.2-199-72.1-200.9-74.3a262.57 262.57 0 0 0 35.4 24.8c3.4 1.7 7.1 2.5 10.1 1.2l-16-20.7c9.2 4.2 9.5 4.5 69.1 29-42.5-20.7-73.8-40.8-93.2-60.2-.5 6.4-1.2 10.1-1.2 10.1a80.25 80.25 0 0 1 20.7 26.6c-39-18.9-57.6-47.6-71.3-82.6 49.9 55.1 118.9 37.5 120.5 37.1 34.8 16.4 69.9 23.6 113.9 10.6 3.3 0 20.3 17 25.3 39.1l4.2-3-2.5-23.6c9 9 24.9 22.6 34.4 13-15.6-5.3-23.5-9.5-29.5-31.7 4.6 4.2 7.6 9 27.8 15l1.2-1.2-10.5-14.2c11.7-4.8-3.5 1 32-10.8 4.3 34.3 9 49.2.7 89.5zm115.3-214.4l-2.5.5 3 9.3c-3.5 5.9-23.7 44.3-71.6 79.7-39.5 29.8-76.6 39.1-80.9 40.3l-7.6-7.1-1.2 3 14.3 16-7.1-4.7 3.4 4.2h-1.2l-21.9-13.5 9.3 26.6-19-27.9-1.2 2.5 7.6 29c-6.1-8.2-21-32.6-56.8-39.6l32.5 21.2a214.82 214.82 0 0 1-93.2-6.4c-4.2-1.2-8.9-2.5-13.5-4.2l1.2-3-44.8-22.4 26.1 22.4c-57.7 9.1-113-25.4-126.4-83.4l-2.5-16.4-22.27 22.3c19.5-57.5 25.6-57.9 51.4-70.1-9.1-5.3-1.6-3.3-38.4-9.3 15.8-5.8 33-15.4 73 5.2a18.5 18.5 0 0 1 3.7-1.7c.6-3.2.4-.8 1-11.8 3.9 10 3.6 8.7 3 9.3l1.7.5c12.7-6.5 8.9-4.5 17-8.9l-5.4 13.5 22.3-5.8-8.4 8.4 2.5 2.5c4.5-1.8 30.3 3.4 40.8 16l-23.6-2.5c39.4 23 51.5 54 55.8 69.6l1.7-1.2c-2.8-22.3-12.4-33.9-16-40.1 4.2 5 39.2 34.6 110.4 46-11.3-.5-23.1 5.4-34.9 18.9l46.7-20.2-9.3 21.9c7.6-10.1 14.8-23.6 21.2-39.6v-.5l1.2-3-1.2 16c13.5-41.8 25.3-78.5 35.4-109.7l13.5-27.8v-2l-5.4-4.2h10.1l5.9 4.2 2.5-1.2-3.4-16 12.3 18.9 41.8-20.2-14.8 13 .5 2.9 17.7-.5a184 184 0 0 1 33 4.2l-23.6 2.5-1.2 3 26.6 23.1a254.21 254.21 0 0 1 27 32c-11.2-3.3-10.3-3.4-21.2-3.4l12.3 32.5zm-6.1-71.3l-3.9 13-14.3-11.8zm-254.8 7.1c1.7 10.6 4.7 17.7 8.8 21.9-9.3 6.6-27.5 13.9-46.5 16l.5 1.2a50.22 50.22 0 0 0 24.8-2.5l-7.1 13c4.2-1.7 10.1-7.1 17.7-14.8 11.9-5.5 12.7-5.1 20.2-16-12.7-6.4-15.7-13.7-18.4-18.8zm3.7-102.3c-6.4-3.4-10.6 3-12.3 18.9s2.5 29.5 11.8 39.6 18.2 10.6 26.1 3 3.4-23.6-11.3-47.7a39.57 39.57 0 0 0-14.27-13.8zm-4.7 46.3c5.4 2.2 10.5 1.9 12.3-10.6v-4.7l-1.2.5c-4.3-3.1-2.5-4.5-1.7-6.2l.5-.5c-.9-1.2-5-8.1-12.5 4.7-.5-13.5.5-21.9 3-24.8 1.2-2.5 4.7-1.2 11.3 4.2 6.4 5.4 11.3 16 15.2 32.5 6.5 28-19.8 26.2-26.9 4.9zm-45-5.5c1.6.3 9.3-1.1 9.3-14.8h-.5c-5.4-1.1-2.2-5.5-.7-5.9-1.7-3-3.4-4.2-5.4-4.7-8.1 0-11.6 12.7-8.1 21.2a7.51 7.51 0 0 0 5.43 4.2zM216 82.9l-2.5.5.5 3a48.94 48.94 0 0 1 26.1 5.9c-2.5-5.5-10-14.3-28.3-14.3l.5 2.5zm-71.8 49.4c21.7 16.8 16.5 21.4 46.5 23.6l-2.9-4.7a42.67 42.67 0 0 0 14.8-28.3c1.7-16-1.2-29.5-8.8-41.3l13-7.6a2.26 2.26 0 0 0-.5-1.7 14.21 14.21 0 0 0-13.5 1.7c-12.7 6.7-28 20.9-29 22.4-1.7 1.7-3.4 5.9-5.4 13.5a99.61 99.61 0 0 0-2.9 23.6c-4.7-8-10.5-6.4-19.9-5.9l7.1 7.6c-16.5 0-23.3 15.4-23.6 16 6.8 0 4.6-7.6 30-12.3-4.3-6.3-3.3-5-4.9-6.6zm18.7-18.7c1.2-7.6 3.4-13 6.4-17.2 5.4-6.4 10.6-10.1 16-11.8 4.2-1.7 7.1 1.2 10.1 9.3a72.14 72.14 0 0 1 3 25.3c-.5 9.3-3.4 17.2-8.4 23.1-2.9 3.4-5.4 5.9-6.4 7.6a39.21 39.21 0 0 1-11.3-.5l-7.1-3.4-5.4-6.4c.8-10 1.3-18.8 3.1-26zm42 56.1c-34.8 14.4-34.7 14-36.1 14.3-20.8 4.7-19-24.4-18.9-24.8l5.9-1.2-.5-2.5c-20.2-2.6-31 4.2-32.5 4.9.5.5 3 3.4 5.9 9.3 4.2-6.4 8.8-10.1 15.2-10.6a83.47 83.47 0 0 0 1.7 33.7c.1.5 2.6 17.4 27.5 24.1 11.3 3 27 1.2 48.9-5.4l-9.2.5c-4.2-14.8-6.4-24.8-5.9-29.5 11.3-8.8 21.9-11.3 30.7-7.6h2.5l-11.8-7.6-7.1.5c-5.9 1.2-12.3 4.2-19.4 8.4z"
                }
            }
        ]
    })(props);
}
function FaThemeco(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M202.9 8.43c9.9-5.73 26-5.82 35.95-.21L430 115.85c10 5.6 18 19.44 18 30.86V364c0 11.44-8.06 25.29-18 31L238.81 503.74c-9.93 5.66-26 5.57-35.85-.21L17.86 395.12C8 389.34 0 375.38 0 364V146.71c0-11.44 8-25.36 17.91-31.08zm-77.4 199.83c-15.94 0-31.89.14-47.83.14v101.45H96.8V280h28.7c49.71 0 49.56-71.74 0-71.74zm140.14 100.29l-30.73-34.64c37-7.51 34.8-65.23-10.87-65.51-16.09 0-32.17-.14-48.26-.14v101.59h19.13v-33.91h18.41l29.56 33.91h22.76zm-41.59-82.32c23.34 0 23.26 32.46 0 32.46h-29.13v-32.46zm-95.56-1.6c21.18 0 21.11 38.85 0 38.85H96.18v-38.84zm192.65-18.25c-68.46 0-71 105.8 0 105.8 69.48-.01 69.41-105.8 0-105.8zm0 17.39c44.12 0 44.8 70.86 0 70.86s-44.43-70.86 0-70.86z"
                }
            }
        ]
    })(props);
}
function FaThemeisle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M208 88.286c0-10 6.286-21.714 17.715-21.714 11.142 0 17.714 11.714 17.714 21.714 0 10.285-6.572 21.714-17.714 21.714C214.286 110 208 98.571 208 88.286zm304 160c0 36.001-11.429 102.286-36.286 129.714-22.858 24.858-87.428 61.143-120.857 70.572l-1.143.286v32.571c0 16.286-12.572 30.571-29.143 30.571-10 0-19.429-5.714-24.572-14.286-5.427 8.572-14.856 14.286-24.856 14.286-10 0-19.429-5.714-24.858-14.286-5.142 8.572-14.571 14.286-24.57 14.286-10.286 0-19.429-5.714-24.858-14.286-5.143 8.572-14.571 14.286-24.571 14.286-18.857 0-29.429-15.714-29.429-32.857-16.286 12.285-35.715 19.428-56.571 19.428-22 0-43.429-8.285-60.286-22.857 10.285-.286 20.571-2.286 30.285-5.714-20.857-5.714-39.428-18.857-52-36.286 21.37 4.645 46.209 1.673 67.143-11.143-22-22-56.571-58.857-68.572-87.428C1.143 321.714 0 303.714 0 289.429c0-49.714 20.286-160 86.286-160 10.571 0 18.857 4.858 23.143 14.857a158.792 158.792 0 0 1 12-15.428c2-2.572 5.714-5.429 7.143-8.286 7.999-12.571 11.714-21.142 21.714-34C182.571 45.428 232 17.143 285.143 17.143c6 0 12 .285 17.714 1.143C313.714 6.571 328.857 0 344.572 0c14.571 0 29.714 6 40 16.286.857.858 1.428 2.286 1.428 3.428 0 3.714-10.285 13.429-12.857 16.286 4.286 1.429 15.714 6.858 15.714 12 0 2.857-2.857 5.143-4.571 7.143 31.429 27.714 49.429 67.143 56.286 108 4.286-5.143 10.285-8.572 17.143-8.572 10.571 0 20.857 7.144 28.571 14.001C507.143 187.143 512 221.714 512 248.286zM188 89.428c0 18.286 12.571 37.143 32.286 37.143 19.714 0 32.285-18.857 32.285-37.143 0-18-12.571-36.857-32.285-36.857-19.715 0-32.286 18.858-32.286 36.857zM237.714 194c0-19.714 3.714-39.143 8.571-58.286-52.039 79.534-13.531 184.571 68.858 184.571 21.428 0 42.571-7.714 60-20 2-7.429 3.714-14.857 3.714-22.572 0-14.286-6.286-21.428-20.572-21.428-4.571 0-9.143.857-13.429 1.714-63.343 12.668-107.142 3.669-107.142-63.999zm-41.142 254.858c0-11.143-8.858-20.857-20.286-20.857-11.429 0-20 9.715-20 20.857v32.571c0 11.143 8.571 21.142 20 21.142 11.428 0 20.286-9.715 20.286-21.142v-32.571zm49.143 0c0-11.143-8.572-20.857-20-20.857-11.429 0-20.286 9.715-20.286 20.857v32.571c0 11.143 8.857 21.142 20.286 21.142 11.428 0 20-10 20-21.142v-32.571zm49.713 0c0-11.143-8.857-20.857-20.285-20.857-11.429 0-20.286 9.715-20.286 20.857v32.571c0 11.143 8.857 21.142 20.286 21.142 11.428 0 20.285-9.715 20.285-21.142v-32.571zm49.715 0c0-11.143-8.857-20.857-20.286-20.857-11.428 0-20.286 9.715-20.286 20.857v32.571c0 11.143 8.858 21.142 20.286 21.142 11.429 0 20.286-10 20.286-21.142v-32.571zM421.714 286c-30.857 59.142-90.285 102.572-158.571 102.572-96.571 0-160.571-84.572-160.571-176.572 0-16.857 2-33.429 6-49.714-20 33.715-29.714 72.572-29.714 111.429 0 60.286 24.857 121.715 71.429 160.857 5.143-9.714 14.857-16.286 26-16.286 10 0 19.428 5.714 24.571 14.286 5.429-8.571 14.571-14.286 24.858-14.286 10 0 19.428 5.714 24.571 14.286 5.429-8.571 14.857-14.286 24.858-14.286 10 0 19.428 5.714 24.857 14.286 5.143-8.571 14.571-14.286 24.572-14.286 10.857 0 20.857 6.572 25.714 16 43.427-36.286 68.569-92 71.426-148.286zm10.572-99.714c0-53.714-34.571-105.714-92.572-105.714-30.285 0-58.571 15.143-78.857 36.857C240.862 183.812 233.41 254 302.286 254c28.805 0 97.357-28.538 84.286 36.857 28.857-26 45.714-65.714 45.714-104.571z"
                }
            }
        ]
    })(props);
}
function FaThinkPeaks(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M465.4 409.4l87.1-150.2-32-.3-55.1 95L259.2 0 23 407.4l32 .3L259.2 55.6zm-355.3-44.1h32.1l117.4-202.5L463 511.9l32.5.1-235.8-404.6z"
                }
            }
        ]
    })(props);
}
function FaTiktok(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M448,209.91a210.06,210.06,0,0,1-122.77-39.25V349.38A162.55,162.55,0,1,1,185,188.31V278.2a74.62,74.62,0,1,0,52.23,71.18V0l88,0a121.18,121.18,0,0,0,1.86,22.17h0A122.18,122.18,0,0,0,381,102.39a121.43,121.43,0,0,0,67,20.14Z"
                }
            }
        ]
    })(props);
}
function FaTradeFederation(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8.8c-137 0-248 111-248 248s111 248 248 248 248-111 248-248-111-248-248-248zm0 482.8c-129.7 0-234.8-105.1-234.8-234.8S118.3 22 248 22s234.8 105.1 234.8 234.8S377.7 491.6 248 491.6zm155.1-328.5v-46.8H209.3V198H54.2l36.7 46h117.7v196.8h48.8V245h83.3v-47h-83.3v-34.8h145.7zm-73.3 45.1v23.9h-82.9v197.4h-26.8V232.1H96.3l-20.1-23.9h143.9v-80.6h171.8V152h-145v56.2zm-161.3-69l-12.4-20.7 2.1 23.8-23.5 5.4 23.3 5.4-2.1 24 12.3-20.5 22.2 9.5-15.7-18.1 15.8-18.1zm-29.6-19.7l9.3-11.5-12.7 5.9-8-12.4 1.7 13.9-14.3 3.8 13.7 2.7-.8 14.7 6.8-12.2 13.8 5.3zm165.4 145.2l-13.1 5.6-7.3-12.2 1.3 14.2-13.9 3.2 13.9 3.2-1.2 14.2 7.3-12.2 13.1 5.5-9.4-10.7zm106.9-77.2l-20.9 9.1-12-19.6 2.2 22.7-22.3 5.4 22.2 4.9-1.8 22.9 11.5-19.6 21.2 8.8-15.1-17zM248 29.9c-125.3 0-226.9 101.6-226.9 226.9S122.7 483.7 248 483.7s226.9-101.6 226.9-226.9S373.3 29.9 248 29.9zM342.6 196v51h-83.3v195.7h-52.7V245.9H89.9l-40-49.9h157.4v-81.6h197.8v50.7H259.4V196zM248 43.2c60.3 0 114.8 25 153.6 65.2H202.5V190H45.1C73.1 104.8 153.4 43.2 248 43.2zm0 427.1c-117.9 0-213.6-95.6-213.6-213.5 0-21.2 3.1-41.8 8.9-61.1L87.1 252h114.7v196.8h64.6V253h83.3v-62.7h-83.2v-19.2h145.6v-50.8c30.8 37 49.3 84.6 49.3 136.5.1 117.9-95.5 213.5-213.4 213.5zM178.8 275l-11-21.4 1.7 24.5-23.7 3.9 23.8 5.9-3.7 23.8 13-20.9 21.5 10.8-15.8-18.8 16.9-17.1z"
                }
            }
        ]
    })(props);
}
function FaTrello(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M392.3 32H56.1C25.1 32 0 57.1 0 88c-.1 0 0-4 0 336 0 30.9 25.1 56 56 56h336.2c30.8-.2 55.7-25.2 55.7-56V88c.1-30.8-24.8-55.8-55.6-56zM197 371.3c-.2 14.7-12.1 26.6-26.9 26.6H87.4c-14.8.1-26.9-11.8-27-26.6V117.1c0-14.8 12-26.9 26.9-26.9h82.9c14.8 0 26.9 12 26.9 26.9v254.2zm193.1-112c0 14.8-12 26.9-26.9 26.9h-81c-14.8 0-26.9-12-26.9-26.9V117.2c0-14.8 12-26.9 26.8-26.9h81.1c14.8 0 26.9 12 26.9 26.9v142.1z"
                }
            }
        ]
    })(props);
}
function FaTripadvisor(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M528.91,178.82,576,127.58H471.66a326.11,326.11,0,0,0-367,0H0l47.09,51.24A143.911,143.911,0,0,0,241.86,390.73L288,440.93l46.11-50.17A143.94,143.94,0,0,0,575.88,285.18h-.03A143.56,143.56,0,0,0,528.91,178.82ZM144.06,382.57a97.39,97.39,0,1,1,97.39-97.39A97.39,97.39,0,0,1,144.06,382.57ZM288,282.37c0-64.09-46.62-119.08-108.09-142.59a281,281,0,0,1,216.17,0C334.61,163.3,288,218.29,288,282.37Zm143.88,100.2h-.01a97.405,97.405,0,1,1,.01,0ZM144.06,234.12h-.01a51.06,51.06,0,1,0,51.06,51.06v-.11A51,51,0,0,0,144.06,234.12Zm287.82,0a51.06,51.06,0,1,0,51.06,51.06A51.06,51.06,0,0,0,431.88,234.12Z"
                }
            }
        ]
    })(props);
}
function FaTumblrSquare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zm-82.3 364.2c-8.5 9.1-31.2 19.8-60.9 19.8-75.5 0-91.9-55.5-91.9-87.9v-90h-29.7c-3.4 0-6.2-2.8-6.2-6.2v-42.5c0-4.5 2.8-8.5 7.1-10 38.8-13.7 50.9-47.5 52.7-73.2.5-6.9 4.1-10.2 10-10.2h44.3c3.4 0 6.2 2.8 6.2 6.2v72h51.9c3.4 0 6.2 2.8 6.2 6.2v51.1c0 3.4-2.8 6.2-6.2 6.2h-52.1V321c0 21.4 14.8 33.5 42.5 22.4 3-1.2 5.6-2 8-1.4 2.2.5 3.6 2.1 4.6 4.9l13.8 40.2c1 3.2 2 6.7-.3 9.1z"
                }
            }
        ]
    })(props);
}
function FaTumblr(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 320 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M309.8 480.3c-13.6 14.5-50 31.7-97.4 31.7-120.8 0-147-88.8-147-140.6v-144H17.9c-5.5 0-10-4.5-10-10v-68c0-7.2 4.5-13.6 11.3-16 62-21.8 81.5-76 84.3-117.1.8-11 6.5-16.3 16.1-16.3h70.9c5.5 0 10 4.5 10 10v115.2h83c5.5 0 10 4.4 10 9.9v81.7c0 5.5-4.5 10-10 10h-83.4V360c0 34.2 23.7 53.6 68 35.8 4.8-1.9 9-3.2 12.7-2.2 3.5.9 5.8 3.4 7.4 7.9l22 64.3c1.8 5 3.3 10.6-.4 14.5z"
                }
            }
        ]
    })(props);
}
function FaTwitch(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M391.17,103.47H352.54v109.7h38.63ZM285,103H246.37V212.75H285ZM120.83,0,24.31,91.42V420.58H140.14V512l96.53-91.42h77.25L487.69,256V0ZM449.07,237.75l-77.22,73.12H294.61l-67.6,64v-64H140.14V36.58H449.07Z"
                }
            }
        ]
    })(props);
}
function FaTwitterSquare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zm-48.9 158.8c.2 2.8.2 5.7.2 8.5 0 86.7-66 186.6-186.6 186.6-37.2 0-71.7-10.8-100.7-29.4 5.3.6 10.4.8 15.8.8 30.7 0 58.9-10.4 81.4-28-28.8-.6-53-19.5-61.3-45.5 10.1 1.5 19.2 1.5 29.6-1.2-30-6.1-52.5-32.5-52.5-64.4v-.8c8.7 4.9 18.9 7.9 29.6 8.3a65.447 65.447 0 0 1-29.2-54.6c0-12.2 3.2-23.4 8.9-33.1 32.3 39.8 80.8 65.8 135.2 68.6-9.3-44.5 24-80.6 64-80.6 18.9 0 35.9 7.9 47.9 20.7 14.8-2.8 29-8.3 41.6-15.8-4.9 15.2-15.2 28-28.8 36.1 13.2-1.4 26-5.1 37.8-10.2-8.9 13.1-20.1 24.7-32.9 34z"
                }
            }
        ]
    })(props);
}
function FaTwitter(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M459.37 151.716c.325 4.548.325 9.097.325 13.645 0 138.72-105.583 298.558-298.558 298.558-59.452 0-114.68-17.219-161.137-47.106 8.447.974 16.568 1.299 25.34 1.299 49.055 0 94.213-16.568 130.274-44.832-46.132-.975-84.792-31.188-98.112-72.772 6.498.974 12.995 1.624 19.818 1.624 9.421 0 18.843-1.3 27.614-3.573-48.081-9.747-84.143-51.98-84.143-102.985v-1.299c13.969 7.797 30.214 12.67 47.431 13.319-28.264-18.843-46.781-51.005-46.781-87.391 0-19.492 5.197-37.36 14.294-52.954 51.655 63.675 129.3 105.258 216.365 109.807-1.624-7.797-2.599-15.918-2.599-24.04 0-57.828 46.782-104.934 104.934-104.934 30.213 0 57.502 12.67 76.67 33.137 23.715-4.548 46.456-13.32 66.599-25.34-7.798 24.366-24.366 44.833-46.132 57.827 21.117-2.273 41.584-8.122 60.426-16.243-14.292 20.791-32.161 39.308-52.628 54.253z"
                }
            }
        ]
    })(props);
}
function FaTypo3(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M178.7 78.4c0-24.7 5.4-32.4 13.9-39.4-69.5 8.5-149.3 34-176.3 66.4-5.4 7.7-9.3 20.8-9.3 37.1C7 246 113.8 480 191.1 480c36.3 0 97.3-59.5 146.7-139-7 2.3-11.6 2.3-18.5 2.3-57.2 0-140.6-198.5-140.6-264.9zM301.5 32c-30.1 0-41.7 5.4-41.7 36.3 0 66.4 53.8 198.5 101.7 198.5 26.3 0 78.8-99.7 78.8-182.3 0-40.9-67-52.5-138.8-52.5z"
                }
            }
        ]
    })(props);
}
function FaUber(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M414.1 32H33.9C15.2 32 0 47.2 0 65.9V446c0 18.8 15.2 34 33.9 34H414c18.7 0 33.9-15.2 33.9-33.9V65.9C448 47.2 432.8 32 414.1 32zM237.6 391.1C163 398.6 96.4 344.2 88.9 269.6h94.4V290c0 3.7 3 6.8 6.8 6.8H258c3.7 0 6.8-3 6.8-6.8v-67.9c0-3.7-3-6.8-6.8-6.8h-67.9c-3.7 0-6.8 3-6.8 6.8v20.4H88.9c7-69.4 65.4-122.2 135.1-122.2 69.7 0 128.1 52.8 135.1 122.2 7.5 74.5-46.9 141.1-121.5 148.6z"
                }
            }
        ]
    })(props);
}
function FaUbuntu(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm52.7 93c8.8-15.2 28.3-20.5 43.5-11.7 15.3 8.8 20.5 28.3 11.7 43.6-8.8 15.2-28.3 20.5-43.5 11.7-15.3-8.9-20.5-28.4-11.7-43.6zM87.4 287.9c-17.6 0-31.9-14.3-31.9-31.9 0-17.6 14.3-31.9 31.9-31.9 17.6 0 31.9 14.3 31.9 31.9 0 17.6-14.3 31.9-31.9 31.9zm28.1 3.1c22.3-17.9 22.4-51.9 0-69.9 8.6-32.8 29.1-60.7 56.5-79.1l23.7 39.6c-51.5 36.3-51.5 112.5 0 148.8L172 370c-27.4-18.3-47.8-46.3-56.5-79zm228.7 131.7c-15.3 8.8-34.7 3.6-43.5-11.7-8.8-15.3-3.6-34.8 11.7-43.6 15.2-8.8 34.7-3.6 43.5 11.7 8.8 15.3 3.6 34.8-11.7 43.6zm.3-69.5c-26.7-10.3-56.1 6.6-60.5 35-5.2 1.4-48.9 14.3-96.7-9.4l22.5-40.3c57 26.5 123.4-11.7 128.9-74.4l46.1.7c-2.3 34.5-17.3 65.5-40.3 88.4zm-5.9-105.3c-5.4-62-71.3-101.2-128.9-74.4l-22.5-40.3c47.9-23.7 91.5-10.8 96.7-9.4 4.4 28.3 33.8 45.3 60.5 35 23.1 22.9 38 53.9 40.2 88.5l-46 .6z"
                }
            }
        ]
    })(props);
}
function FaUikit(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M443.9 128v256L218 512 0 384V169.7l87.6 45.1v117l133.5 75.5 135.8-75.5v-151l-101.1-57.6 87.6-53.1L443.9 128zM308.6 49.1L223.8 0l-88.6 54.8 86 47.3 87.4-53z"
                }
            }
        ]
    })(props);
}
function FaUmbraco(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 510 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M255.35 8C118.36 7.83 7.14 118.72 7 255.68c-.07 137 111 248.2 248 248.27 136.85 0 247.82-110.7 248-247.67S392.34 8.17 255.35 8zm145 266q-1.14 40.68-14 65t-43.51 35q-30.61 10.7-85.45 10.47h-4.6q-54.78.22-85.44-10.47t-43.52-35q-12.85-24.36-14-65a224.81 224.81 0 0 1 0-30.71 418.37 418.37 0 0 1 3.6-43.88c1.88-13.39 3.57-22.58 5.4-32 1-4.88 1.28-6.42 1.82-8.45a5.09 5.09 0 0 1 4.9-3.89h.69l32 5a5.07 5.07 0 0 1 4.16 5 5 5 0 0 1 0 .77l-1.7 8.78q-2.41 13.25-4.84 33.68a380.62 380.62 0 0 0-2.64 42.15q-.28 40.43 8.13 59.83a43.87 43.87 0 0 0 31.31 25.18A243 243 0 0 0 250 340.6h10.25a242.64 242.64 0 0 0 57.27-5.16 43.86 43.86 0 0 0 31.15-25.23q8.53-19.42 8.13-59.78a388 388 0 0 0-2.6-42.15q-2.48-20.38-4.89-33.68l-1.69-8.78a5 5 0 0 1 0-.77 5 5 0 0 1 4.2-5l32-5h.82a5 5 0 0 1 4.9 3.89c.55 2.05.81 3.57 1.83 8.45 1.82 9.62 3.52 18.78 5.39 32a415.71 415.71 0 0 1 3.61 43.88 228.06 228.06 0 0 1-.04 30.73z"
                }
            }
        ]
    })(props);
}
function FaUncharted(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M171.73,232.813A5.381,5.381,0,0,0,176.7,229.5,48.081,48.081,0,0,1,191.6,204.244c1.243-.828,1.657-2.484,1.657-4.141a4.22,4.22,0,0,0-2.071-3.312L74.429,128.473,148.958,85a9.941,9.941,0,0,0,4.968-8.281,9.108,9.108,0,0,0-4.968-8.281L126.6,55.6a9.748,9.748,0,0,0-9.523,0l-100.2,57.966a9.943,9.943,0,0,0-4.969,8.281V236.954a9.109,9.109,0,0,0,4.969,8.281L39.235,258.07a8.829,8.829,0,0,0,4.968,1.242,9.4,9.4,0,0,0,6.625-2.484,10.8,10.8,0,0,0,2.9-7.039V164.5L169.66,232.4A4.5,4.5,0,0,0,171.73,232.813ZM323.272,377.73a12.478,12.478,0,0,0-4.969,1.242l-74.528,43.062V287.882c0-2.9-2.9-5.8-6.211-4.555a53.036,53.036,0,0,1-28.984.414,4.86,4.86,0,0,0-6.21,4.555V421.619l-74.529-43.061a8.83,8.83,0,0,0-4.969-1.242,9.631,9.631,0,0,0-9.523,9.523v26.085a9.107,9.107,0,0,0,4.969,8.281l100.2,57.553A8.829,8.829,0,0,0,223.486,480a11.027,11.027,0,0,0,4.969-1.242l100.2-57.553a9.941,9.941,0,0,0,4.968-8.281V386.839C332.8,382.285,328.24,377.73,323.272,377.73ZM286.007,78a23,23,0,1,0-23-23A23,23,0,0,0,286.007,78Zm63.627-10.086a23,23,0,1,0,23,23A23,23,0,0,0,349.634,67.914ZM412.816,151.6a23,23,0,1,0-23-23A23,23,0,0,0,412.816,151.6Zm-63.182-9.2a23,23,0,1,0,23,23A23,23,0,0,0,349.634,142.4Zm-63.627,83.244a23,23,0,1,0-23-23A23,23,0,0,0,286.007,225.648Zm-62.074,36.358a23,23,0,1,0-23-23A23,23,0,0,0,223.933,262.006Zm188.883-82.358a23,23,0,1,0,23,23A23,23,0,0,0,412.816,179.648Zm0,72.272a23,23,0,1,0,23,23A23,23,0,0,0,412.816,251.92Z"
                }
            }
        ]
    })(props);
}
function FaUniregistry(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M192 480c39.5 0 76.2-11.8 106.8-32.2H85.3C115.8 468.2 152.5 480 192 480zm-89.1-193.1v-12.4H0v12.4c0 2.5 0 5 .1 7.4h103.1c-.2-2.4-.3-4.9-.3-7.4zm20.5 57H8.5c2.6 8.5 5.8 16.8 9.6 24.8h138.3c-12.9-5.7-24.1-14.2-33-24.8zm-17.7-34.7H1.3c.9 7.6 2.2 15 3.9 22.3h109.7c-4-6.9-7.2-14.4-9.2-22.3zm-2.8-69.3H0v17.3h102.9zm0-173.2H0v4.9h102.9zm0-34.7H0v2.5h102.9zm0 69.3H0v7.4h102.9zm0 104H0v14.8h102.9zm0-69.3H0v9.9h102.9zm0 34.6H0V183h102.9zm166.2 160.9h109.7c1.8-7.3 3.1-14.7 3.9-22.3H278.3c-2.1 7.9-5.2 15.4-9.2 22.3zm12-185.7H384V136H281.1zm0 37.2H384v-12.4H281.1zm0-74.3H384v-7.4H281.1zm0-76.7v2.5H384V32zm-203 410.9h227.7c11.8-8.7 22.7-18.6 32.2-29.7H44.9c9.6 11 21.4 21 33.2 29.7zm203-371.3H384v-4.9H281.1zm0 148.5H384v-14.8H281.1zM38.8 405.7h305.3c6.7-8.5 12.6-17.6 17.8-27.2H23c5.2 9.6 9.2 18.7 15.8 27.2zm188.8-37.1H367c3.7-8 5.8-16.2 8.5-24.8h-115c-8.8 10.7-20.1 19.2-32.9 24.8zm53.5-81.7c0 2.5-.1 5-.4 7.4h103.1c.1-2.5.2-4.9.2-7.4v-12.4H281.1zm0-29.7H384v-17.3H281.1z"
                }
            }
        ]
    })(props);
}
function FaUnity(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M498.11,206.4,445.31,14.72,248.2,66.08,219,116.14l-59.2-.43L15.54,256,159.82,396.32l59.17-.43,29.24,50,197.08,51.36,52.8-191.62-30-49.63ZM223.77,124.2,374.55,86.51,288,232.33H114.87Zm0,263.63L114.87,279.71H288l86.55,145.81Zm193,14L330.17,256l86.58-145.84L458.56,256Z"
                }
            }
        ]
    })(props);
}
function FaUnsplash(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M448,230.17V480H0V230.17H141.13V355.09H306.87V230.17ZM306.87,32H141.13V156.91H306.87Z"
                }
            }
        ]
    })(props);
}
function FaUntappd(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M401.3 49.9c-79.8 160.1-84.6 152.5-87.9 173.2l-5.2 32.8c-1.9 12-6.6 23.5-13.7 33.4L145.6 497.1c-7.6 10.6-20.4 16.2-33.4 14.6-40.3-5-77.8-32.2-95.3-68.5-5.7-11.8-4.5-25.8 3.1-36.4l148.9-207.9c7.1-9.9 16.4-18 27.2-23.7l29.3-15.5c18.5-9.8 9.7-11.9 135.6-138.9 1-4.8 1-7.3 3.6-8 3-.7 6.6-1 6.3-4.6l-.4-4.6c-.2-1.9 1.3-3.6 3.2-3.6 4.5-.1 13.2 1.2 25.6 10 12.3 8.9 16.4 16.8 17.7 21.1.6 1.8-.6 3.7-2.4 4.2l-4.5 1.1c-3.4.9-2.5 4.4-2.3 7.4.1 2.8-2.3 3.6-6.5 6.1zM230.1 36.4c3.4.9 2.5 4.4 2.3 7.4-.2 2.7 2.1 3.5 6.4 6 7.9 15.9 15.3 30.5 22.2 44 .7 1.3 2.3 1.5 3.3.5 11.2-12 24.6-26.2 40.5-42.6 1.3-1.4 1.4-3.5.1-4.9-8-8.2-16.5-16.9-25.6-26.1-1-4.7-1-7.3-3.6-8-3-.8-6.6-1-6.3-4.6.3-3.3 1.4-8.1-2.8-8.2-4.5-.1-13.2 1.1-25.6 10-12.3 8.9-16.4 16.8-17.7 21.1-1.4 4.2 3.6 4.6 6.8 5.4zM620 406.7L471.2 198.8c-13.2-18.5-26.6-23.4-56.4-39.1-11.2-5.9-14.2-10.9-30.5-28.9-1-1.1-2.9-.9-3.6.5-46.3 88.8-47.1 82.8-49 94.8-1.7 10.7-1.3 20 .3 29.8 1.9 12 6.6 23.5 13.7 33.4l148.9 207.9c7.6 10.6 20.2 16.2 33.1 14.7 40.3-4.9 78-32 95.7-68.6 5.4-11.9 4.3-25.9-3.4-36.6z"
                }
            }
        ]
    })(props);
}
function FaUps(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M103.2 303c-5.2 3.6-32.6 13.1-32.6-19V180H37.9v102.6c0 74.9 80.2 51.1 97.9 39V180h-32.6zM4 74.82v220.9c0 103.7 74.9 135.2 187.7 184.1 112.4-48.9 187.7-80.2 187.7-184.1V74.82c-116.3-61.6-281.8-49.6-375.4 0zm358.1 220.9c0 86.6-53.2 113.6-170.4 165.3-117.5-51.8-170.5-78.7-170.5-165.3v-126.4c102.3-93.8 231.6-100 340.9-89.8zm-209.6-107.4v212.8h32.7v-68.7c24.4 7.3 71.7-2.6 71.7-78.5 0-97.4-80.7-80.92-104.4-65.6zm32.7 117.3v-100.3c8.4-4.2 38.4-12.7 38.4 49.3 0 67.9-36.4 51.8-38.4 51zm79.1-86.4c.1 47.3 51.6 42.5 52.2 70.4.6 23.5-30.4 23-50.8 4.9v30.1c36.2 21.5 81.9 8.1 83.2-33.5 1.7-51.5-54.1-46.6-53.4-73.2.6-20.3 30.6-20.5 48.5-2.2v-28.4c-28.5-22-79.9-9.2-79.7 31.9z"
                }
            }
        ]
    })(props);
}
function FaUsb(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M641.5 256c0 3.1-1.7 6.1-4.5 7.5L547.9 317c-1.4.8-2.8 1.4-4.5 1.4-1.4 0-3.1-.3-4.5-1.1-2.8-1.7-4.5-4.5-4.5-7.8v-35.6H295.7c25.3 39.6 40.5 106.9 69.6 106.9H392V354c0-5 3.9-8.9 8.9-8.9H490c5 0 8.9 3.9 8.9 8.9v89.1c0 5-3.9 8.9-8.9 8.9h-89.1c-5 0-8.9-3.9-8.9-8.9v-26.7h-26.7c-75.4 0-81.1-142.5-124.7-142.5H140.3c-8.1 30.6-35.9 53.5-69 53.5C32 327.3 0 295.3 0 256s32-71.3 71.3-71.3c33.1 0 61 22.8 69 53.5 39.1 0 43.9 9.5 74.6-60.4C255 88.7 273 95.7 323.8 95.7c7.5-20.9 27-35.6 50.4-35.6 29.5 0 53.5 23.9 53.5 53.5s-23.9 53.5-53.5 53.5c-23.4 0-42.9-14.8-50.4-35.6H294c-29.1 0-44.3 67.4-69.6 106.9h310.1v-35.6c0-3.3 1.7-6.1 4.5-7.8 2.8-1.7 6.4-1.4 8.9.3l89.1 53.5c2.8 1.1 4.5 4.1 4.5 7.2z"
                }
            }
        ]
    })(props);
}
function FaUsps(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M460.3 241.7c25.8-41.3 15.2-48.8-11.7-48.8h-27c-.1 0-1.5-1.4-10.9 8-11.2 5.6-37.9 6.3-37.9 8.7 0 4.5 70.3-3.1 88.1 0 9.5 1.5-1.5 20.4-4.4 32-.5 4.5 2.4 2.3 3.8.1zm-112.1 22.6c64-21.3 97.3-23.9 102-26.2 4.4-2.9-4.4-6.6-26.2-5.8-51.7 2.2-137.6 37.1-172.6 53.9l-30.7-93.3h196.6c-2.7-28.2-152.9-22.6-337.9-22.6L27 415.8c196.4-97.3 258.9-130.3 321.2-151.5zM94.7 96c253.3 53.7 330 65.7 332.1 85.2 36.4 0 45.9 0 52.4 6.6 21.1 19.7-14.6 67.7-14.6 67.7-4.4 2.9-406.4 160.2-406.4 160.2h423.1L549 96z"
                }
            }
        ]
    })(props);
}
function FaUssunnah(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M156.8 285.1l5.7 14.4h-8.2c-1.3-3.2-3.1-7.7-3.8-9.5-2.5-6.3-1.1-8.4 0-10 1.9-2.7 3.2-4.4 3.6-5.2 0 2.2.8 5.7 2.7 10.3zm297.3 18.8c-2.1 13.8-5.7 27.1-10.5 39.7l43 23.4-44.8-18.8c-5.3 13.2-12 25.6-19.9 37.2l34.2 30.2-36.8-26.4c-8.4 11.8-18 22.6-28.7 32.3l24.9 34.7-28.1-31.8c-11 9.6-23.1 18-36.1 25.1l15.7 37.2-19.3-35.3c-13.1 6.8-27 12.1-41.6 15.9l6.7 38.4-10.5-37.4c-14.3 3.4-29.2 5.3-44.5 5.4L256 512l-1.9-38.4c-15.3-.1-30.2-2-44.5-5.3L199 505.6l6.7-38.2c-14.6-3.7-28.6-9.1-41.7-15.8l-19.2 35.1 15.6-37c-13-7-25.2-15.4-36.2-25.1l-27.9 31.6 24.7-34.4c-10.7-9.7-20.4-20.5-28.8-32.3l-36.5 26.2 33.9-29.9c-7.9-11.6-14.6-24.1-20-37.3l-44.4 18.7L67.8 344c-4.8-12.7-8.4-26.1-10.5-39.9l-51 9 50.3-14.2c-1.1-8.5-1.7-17.1-1.7-25.9 0-4.7.2-9.4.5-14.1L0 256l56-2.8c1.3-13.1 3.8-25.8 7.5-38.1L6.4 199l58.9 10.4c4-12 9.1-23.5 15.2-34.4l-55.1-30 58.3 24.6C90 159 97.2 149.2 105.3 140L55.8 96.4l53.9 38.7c8.1-8.6 17-16.5 26.6-23.6l-40-55.6 45.6 51.6c9.5-6.6 19.7-12.3 30.3-17.2l-27.3-64.9 33.8 62.1c10.5-4.4 21.4-7.9 32.7-10.4L199 6.4l19.5 69.2c11-2.1 22.3-3.2 33.8-3.4L256 0l3.6 72.2c11.5.2 22.8 1.4 33.8 3.5L313 6.4l-12.4 70.7c11.3 2.6 22.2 6.1 32.6 10.5l33.9-62.2-27.4 65.1c10.6 4.9 20.7 10.7 30.2 17.2l45.8-51.8-40.1 55.9c9.5 7.1 18.4 15 26.5 23.6l54.2-38.9-49.7 43.9c8 9.1 15.2 18.9 21.5 29.4l58.7-24.7-55.5 30.2c6.1 10.9 11.1 22.3 15.1 34.3l59.3-10.4-57.5 16.2c3.7 12.2 6.2 24.9 7.5 37.9L512 256l-56 2.8c.3 4.6.5 9.3.5 14.1 0 8.7-.6 17.3-1.6 25.8l50.7 14.3-51.5-9.1zm-21.8-31c0-97.5-79-176.5-176.5-176.5s-176.5 79-176.5 176.5 79 176.5 176.5 176.5 176.5-79 176.5-176.5zm-24 0c0 84.3-68.3 152.6-152.6 152.6s-152.6-68.3-152.6-152.6 68.3-152.6 152.6-152.6 152.6 68.3 152.6 152.6zM195 241c0 2.1 1.3 3.8 3.6 5.1 3.3 1.9 6.2 4.6 8.2 8.2 2.8-5.7 4.3-9.5 4.3-11.2 0-2.2-1.1-4.4-3.2-7-2.1-2.5-3.2-5.2-3.3-7.7-6.5 6.8-9.6 10.9-9.6 12.6zm-40.7-19c0 2.1 1.3 3.8 3.6 5.1 3.5 1.9 6.2 4.6 8.2 8.2 2.8-5.7 4.3-9.5 4.3-11.2 0-2.2-1.1-4.4-3.2-7-2.1-2.5-3.2-5.2-3.3-7.7-6.5 6.8-9.6 10.9-9.6 12.6zm-19 0c0 2.1 1.3 3.8 3.6 5.1 3.3 1.9 6.2 4.6 8.2 8.2 2.8-5.7 4.3-9.5 4.3-11.2 0-2.2-1.1-4.4-3.2-7-2.1-2.5-3.2-5.2-3.3-7.7-6.4 6.8-9.6 10.9-9.6 12.6zm204.9 87.9c-8.4-3-8.7-6.8-8.7-15.6V182c-8.2 12.5-14.2 18.6-18 18.6 6.3 14.4 9.5 23.9 9.5 28.3v64.3c0 2.2-2.2 6.5-4.7 6.5h-18c-2.8-7.5-10.2-26.9-15.3-40.3-2 2.5-7.2 9.2-10.7 13.7 2.4 1.6 4.1 3.6 5.2 6.3 2.6 6.7 6.4 16.5 7.9 20.2h-9.2c-3.9-10.4-9.6-25.4-11.8-31.1-2 2.5-7.2 9.2-10.7 13.7 2.4 1.6 4.1 3.6 5.2 6.3.8 2 2.8 7.3 4.3 10.9H256c-1.5-4.1-5.6-14.6-8.4-22-2 2.5-7.2 9.2-10.7 13.7 2.5 1.6 4.3 3.6 5.2 6.3.2.6.5 1.4.6 1.7H225c-4.6-13.9-11.4-27.7-11.4-34.1 0-2.2.3-5.1 1.1-8.2-8.8 10.8-14 15.9-14 25 0 7.5 10.4 28.3 10.4 33.3 0 1.7-.5 3.3-1.4 4.9-9.6-12.7-15.5-20.7-18.8-20.7h-12l-11.2-28c-3.8-9.6-5.7-16-5.7-18.8 0-3.8.5-7.7 1.7-12.2-1 1.3-3.7 4.7-5.5 7.1-.8-2.1-3.1-7.7-4.6-11.5-2.1 2.5-7.5 9.1-11.2 13.6.9 2.3 3.3 8.1 4.9 12.2-2.5 3.3-9.1 11.8-13.6 17.7-4 5.3-5.8 13.3-2.7 21.8 2.5 6.7 2 7.9-1.7 14.1H191c5.5 0 14.3 14 15.5 22 13.2-16 15.4-19.6 16.8-21.6h107c3.9 0 7.2-1.9 9.9-5.8zm20.1-26.6V181.7c-9 12.5-15.9 18.6-20.7 18.6 7.1 14.4 10.7 23.9 10.7 28.3v66.3c0 17.5 8.6 20.4 24 20.4 8.1 0 12.5-.8 13.7-2.7-4.3-1.6-7.6-2.5-9.9-3.3-8.1-3.2-17.8-7.4-17.8-26z"
                }
            }
        ]
    })(props);
}
function FaVaadin(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M224.5 140.7c1.5-17.6 4.9-52.7 49.8-52.7h98.6c20.7 0 32.1-7.8 32.1-21.6V54.1c0-12.2 9.3-22.1 21.5-22.1S448 41.9 448 54.1v36.5c0 42.9-21.5 62-66.8 62H280.7c-30.1 0-33 14.7-33 27.1 0 1.3-.1 2.5-.2 3.7-.7 12.3-10.9 22.2-23.4 22.2s-22.7-9.8-23.4-22.2c-.1-1.2-.2-2.4-.2-3.7 0-12.3-3-27.1-33-27.1H66.8c-45.3 0-66.8-19.1-66.8-62V54.1C0 41.9 9.4 32 21.6 32s21.5 9.9 21.5 22.1v12.3C43.1 80.2 54.5 88 75.2 88h98.6c44.8 0 48.3 35.1 49.8 52.7h.9zM224 456c11.5 0 21.4-7 25.7-16.3 1.1-1.8 97.1-169.6 98.2-171.4 11.9-19.6-3.2-44.3-27.2-44.3-13.9 0-23.3 6.4-29.8 20.3L224 362l-66.9-117.7c-6.4-13.9-15.9-20.3-29.8-20.3-24 0-39.1 24.6-27.2 44.3 1.1 1.9 97.1 169.6 98.2 171.4 4.3 9.3 14.2 16.3 25.7 16.3z"
                }
            }
        ]
    })(props);
}
function FaViacoin(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M384 32h-64l-80.7 192h-94.5L64 32H0l48 112H0v48h68.5l13.8 32H0v48h102.8L192 480l89.2-208H384v-48h-82.3l13.8-32H384v-48h-48l48-112zM192 336l-27-64h54l-27 64z"
                }
            }
        ]
    })(props);
}
function FaViadeoSquare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zM280.7 381.2c-42.4 46.2-120 46.6-162.4 0-68-73.6-19.8-196.1 81.2-196.1 13.3 0 26.6 2.1 39.1 6.7-4.3 8.4-7.3 17.6-8.4 27.1-9.7-4.1-20.2-6-30.7-6-48.8 0-84.6 41.7-84.6 88.9 0 43 28.5 78.7 69.5 85.9 61.5-24 72.9-117.6 72.9-175 0-7.3 0-14.8-.6-22.1-11.2-32.9-26.6-64.6-44.2-94.5 27.1 18.3 41.9 62.5 44.2 94.1v.4c7.7 22.5 11.8 46.2 11.8 70 0 54.1-21.9 99-68.3 128.2l-2.4.2c50 1 86.2-38.6 86.2-87.2 0-12.2-2.1-24.3-6.9-35.7 9.5-1.9 18.5-5.6 26.4-10.5 15.3 36.6 12.6 87.3-22.8 125.6zM309 233.7c-13.3 0-25.1-7.1-34.4-16.1 21.9-12 49.6-30.7 62.3-53 1.5-3 4.1-8.6 4.5-12-12.5 27.9-44.2 49.8-73.9 56.7-4.7-7.3-7.5-15.5-7.5-24.3 0-10.3 5.2-24.1 12.9-31.6 21.6-20.5 53-8.5 72.4-50 32.5 46.2 13.1 130.3-36.3 130.3z"
                }
            }
        ]
    })(props);
}
function FaViadeo(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M276.2 150.5v.7C258.3 98.6 233.6 47.8 205.4 0c43.3 29.2 67 100 70.8 150.5zm32.7 121.7c7.6 18.2 11 37.5 11 57 0 77.7-57.8 141-137.8 139.4l3.8-.3c74.2-46.7 109.3-118.6 109.3-205.1 0-38.1-6.5-75.9-18.9-112 1 11.7 1 23.7 1 35.4 0 91.8-18.1 241.6-116.6 280C95 455.2 49.4 398 49.4 329.2c0-75.6 57.4-142.3 135.4-142.3 16.8 0 33.7 3.1 49.1 9.6 1.7-15.1 6.5-29.9 13.4-43.3-19.9-7.2-41.2-10.7-62.5-10.7-161.5 0-238.7 195.9-129.9 313.7 67.9 74.6 192 73.9 259.8 0 56.6-61.3 60.9-142.4 36.4-201-12.7 8-27.1 13.9-42.2 17zM418.1 11.7c-31 66.5-81.3 47.2-115.8 80.1-12.4 12-20.6 34-20.6 50.5 0 14.1 4.5 27.1 12 38.8 47.4-11 98.3-46 118.2-90.7-.7 5.5-4.8 14.4-7.2 19.2-20.3 35.7-64.6 65.6-99.7 84.9 14.8 14.4 33.7 25.8 55 25.8 79 0 110.1-134.6 58.1-208.6z"
                }
            }
        ]
    })(props);
}
function FaViber(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M444 49.9C431.3 38.2 379.9.9 265.3.4c0 0-135.1-8.1-200.9 52.3C27.8 89.3 14.9 143 13.5 209.5c-1.4 66.5-3.1 191.1 117 224.9h.1l-.1 51.6s-.8 20.9 13 25.1c16.6 5.2 26.4-10.7 42.3-27.8 8.7-9.4 20.7-23.2 29.8-33.7 82.2 6.9 145.3-8.9 152.5-11.2 16.6-5.4 110.5-17.4 125.7-142 15.8-128.6-7.6-209.8-49.8-246.5zM457.9 287c-12.9 104-89 110.6-103 115.1-6 1.9-61.5 15.7-131.2 11.2 0 0-52 62.7-68.2 79-5.3 5.3-11.1 4.8-11-5.7 0-6.9.4-85.7.4-85.7-.1 0-.1 0 0 0-101.8-28.2-95.8-134.3-94.7-189.8 1.1-55.5 11.6-101 42.6-131.6 55.7-50.5 170.4-43 170.4-43 96.9.4 143.3 29.6 154.1 39.4 35.7 30.6 53.9 103.8 40.6 211.1zm-139-80.8c.4 8.6-12.5 9.2-12.9.6-1.1-22-11.4-32.7-32.6-33.9-8.6-.5-7.8-13.4.7-12.9 27.9 1.5 43.4 17.5 44.8 46.2zm20.3 11.3c1-42.4-25.5-75.6-75.8-79.3-8.5-.6-7.6-13.5.9-12.9 58 4.2 88.9 44.1 87.8 92.5-.1 8.6-13.1 8.2-12.9-.3zm47 13.4c.1 8.6-12.9 8.7-12.9.1-.6-81.5-54.9-125.9-120.8-126.4-8.5-.1-8.5-12.9 0-12.9 73.7.5 133 51.4 133.7 139.2zM374.9 329v.2c-10.8 19-31 40-51.8 33.3l-.2-.3c-21.1-5.9-70.8-31.5-102.2-56.5-16.2-12.8-31-27.9-42.4-42.4-10.3-12.9-20.7-28.2-30.8-46.6-21.3-38.5-26-55.7-26-55.7-6.7-20.8 14.2-41 33.3-51.8h.2c9.2-4.8 18-3.2 23.9 3.9 0 0 12.4 14.8 17.7 22.1 5 6.8 11.7 17.7 15.2 23.8 6.1 10.9 2.3 22-3.7 26.6l-12 9.6c-6.1 4.9-5.3 14-5.3 14s17.8 67.3 84.3 84.3c0 0 9.1.8 14-5.3l9.6-12c4.6-6 15.7-9.8 26.6-3.7 14.7 8.3 33.4 21.2 45.8 32.9 7 5.7 8.6 14.4 3.8 23.6z"
                }
            }
        ]
    })(props);
}
function FaVimeoSquare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zm-16.2 149.6c-1.4 31.1-23.2 73.8-65.3 127.9-43.5 56.5-80.3 84.8-110.4 84.8-18.7 0-34.4-17.2-47.3-51.6-25.2-92.3-35.9-146.4-56.7-146.4-2.4 0-10.8 5-25.1 15.1L64 192c36.9-32.4 72.1-68.4 94.1-70.4 24.9-2.4 40.2 14.6 46 51.1 20.5 129.6 29.6 149.2 66.8 90.5 13.4-21.2 20.6-37.2 21.5-48.3 3.4-32.8-25.6-30.6-45.2-22.2 15.7-51.5 45.8-76.5 90.1-75.1 32.9 1 48.4 22.4 46.5 64z"
                }
            }
        ]
    })(props);
}
function FaVimeoV(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M447.8 153.6c-2 43.6-32.4 103.3-91.4 179.1-60.9 79.2-112.4 118.8-154.6 118.8-26.1 0-48.2-24.1-66.3-72.3C100.3 250 85.3 174.3 56.2 174.3c-3.4 0-15.1 7.1-35.2 21.1L0 168.2c51.6-45.3 100.9-95.7 131.8-98.5 34.9-3.4 56.3 20.5 64.4 71.5 28.7 181.5 41.4 208.9 93.6 126.7 18.7-29.6 28.8-52.1 30.2-67.6 4.8-45.9-35.8-42.8-63.3-31 22-72.1 64.1-107.1 126.2-105.1 45.8 1.2 67.5 31.1 64.9 89.4z"
                }
            }
        ]
    })(props);
}
function FaVimeo(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M403.2 32H44.8C20.1 32 0 52.1 0 76.8v358.4C0 459.9 20.1 480 44.8 480h358.4c24.7 0 44.8-20.1 44.8-44.8V76.8c0-24.7-20.1-44.8-44.8-44.8zM377 180.8c-1.4 31.5-23.4 74.7-66 129.4-44 57.2-81.3 85.8-111.7 85.8-18.9 0-34.8-17.4-47.9-52.3-25.5-93.3-36.4-148-57.4-148-2.4 0-10.9 5.1-25.4 15.2l-15.2-19.6c37.3-32.8 72.9-69.2 95.2-71.2 25.2-2.4 40.7 14.8 46.5 51.7 20.7 131.2 29.9 151 67.6 91.6 13.5-21.4 20.8-37.7 21.8-48.9 3.5-33.2-25.9-30.9-45.8-22.4 15.9-52.1 46.3-77.4 91.2-76 33.3.9 49 22.5 47.1 64.7z"
                }
            }
        ]
    })(props);
}
function FaVine(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M384 254.7v52.1c-18.4 4.2-36.9 6.1-52.1 6.1-36.9 77.4-103 143.8-125.1 156.2-14 7.9-27.1 8.4-42.7-.8C137 452 34.2 367.7 0 102.7h74.5C93.2 261.8 139 343.4 189.3 404.5c27.9-27.9 54.8-65.1 75.6-106.9-49.8-25.3-80.1-80.9-80.1-145.6 0-65.6 37.7-115.1 102.2-115.1 114.9 0 106.2 127.9 81.6 181.5 0 0-46.4 9.2-63.5-20.5 3.4-11.3 8.2-30.8 8.2-48.5 0-31.3-11.3-46.6-28.4-46.6-18.2 0-30.8 17.1-30.8 50 .1 79.2 59.4 118.7 129.9 101.9z"
                }
            }
        ]
    })(props);
}
function FaVk(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M545 117.7c3.7-12.5 0-21.7-17.8-21.7h-58.9c-15 0-21.9 7.9-25.6 16.7 0 0-30 73.1-72.4 120.5-13.7 13.7-20 18.1-27.5 18.1-3.7 0-9.4-4.4-9.4-16.9V117.7c0-15-4.2-21.7-16.6-21.7h-92.6c-9.4 0-15 7-15 13.5 0 14.2 21.2 17.5 23.4 57.5v86.8c0 19-3.4 22.5-10.9 22.5-20 0-68.6-73.4-97.4-157.4-5.8-16.3-11.5-22.9-26.6-22.9H38.8c-16.8 0-20.2 7.9-20.2 16.7 0 15.6 20 93.1 93.1 195.5C160.4 378.1 229 416 291.4 416c37.5 0 42.1-8.4 42.1-22.9 0-66.8-3.4-73.1 15.4-73.1 8.7 0 23.7 4.4 58.7 38.1 40 40 46.6 57.9 69 57.9h58.9c16.8 0 25.3-8.4 20.4-25-11.2-34.9-86.9-106.7-90.3-111.5-8.7-11.2-6.2-16.2 0-26.2.1-.1 72-101.3 79.4-135.6z"
                }
            }
        ]
    })(props);
}
function FaVnv(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M104.9 352c-34.1 0-46.4-30.4-46.4-30.4L2.6 210.1S-7.8 192 13 192h32.8c10.4 0 13.2 8.7 18.8 18.1l36.7 74.5s5.2 13.1 21.1 13.1 21.1-13.1 21.1-13.1l36.7-74.5c5.6-9.5 8.4-18.1 18.8-18.1h32.8c20.8 0 10.4 18.1 10.4 18.1l-55.8 111.5S174.2 352 140 352h-35.1zm395 0c-34.1 0-46.4-30.4-46.4-30.4l-55.9-111.5S387.2 192 408 192h32.8c10.4 0 13.2 8.7 18.8 18.1l36.7 74.5s5.2 13.1 21.1 13.1 21.1-13.1 21.1-13.1l36.8-74.5c5.6-9.5 8.4-18.1 18.8-18.1H627c20.8 0 10.4 18.1 10.4 18.1l-55.9 111.5S569.3 352 535.1 352h-35.2zM337.6 192c34.1 0 46.4 30.4 46.4 30.4l55.9 111.5s10.4 18.1-10.4 18.1h-32.8c-10.4 0-13.2-8.7-18.8-18.1l-36.7-74.5s-5.2-13.1-21.1-13.1c-15.9 0-21.1 13.1-21.1 13.1l-36.7 74.5c-5.6 9.4-8.4 18.1-18.8 18.1h-32.9c-20.8 0-10.4-18.1-10.4-18.1l55.9-111.5s12.2-30.4 46.4-30.4h35.1z"
                }
            }
        ]
    })(props);
}
function FaVuejs(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M356.9 64.3H280l-56 88.6-48-88.6H0L224 448 448 64.3h-91.1zm-301.2 32h53.8L224 294.5 338.4 96.3h53.8L224 384.5 55.7 96.3z"
                }
            }
        ]
    })(props);
}
function FaWatchmanMonitoring(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256,16C123.452,16,16,123.452,16,256S123.452,496,256,496,496,388.548,496,256,388.548,16,256,16ZM121.69,429.122C70.056,388.972,36.741,326.322,36.741,256a218.519,218.519,0,0,1,9.587-64.122l102.9-17.895-.121,10.967-13.943,2.013s-.144,12.5-.144,19.549a12.778,12.778,0,0,0,4.887,10.349l9.468,7.4Zm105.692-283.27,8.48-7.618s6.934-5.38-.143-9.344c-7.188-4.024-39.53-34.5-39.53-34.5-5.348-5.477-8.257-7.347-15.46,0,0,0-32.342,30.474-39.529,34.5-7.078,3.964-.144,9.344-.144,9.344l8.481,7.618-.048,4.369L75.982,131.045c39.644-56.938,105.532-94.3,180.018-94.3A218.754,218.754,0,0,1,420.934,111.77l-193.512,37.7Zm34.063,329.269-33.9-250.857,9.467-7.4a12.778,12.778,0,0,0,4.888-10.349c0-7.044-.144-19.549-.144-19.549l-13.943-2.013-.116-10.474,241.711,31.391A218.872,218.872,0,0,1,475.259,256C475.259,375.074,379.831,472.212,261.445,475.121Z"
                }
            }
        ]
    })(props);
}
function FaWaze(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M502.17 201.67C516.69 287.53 471.23 369.59 389 409.8c13 34.1-12.4 70.2-48.32 70.2a51.68 51.68 0 0 1-51.57-49c-6.44.19-64.2 0-76.33-.64A51.69 51.69 0 0 1 159 479.92c-33.86-1.36-57.95-34.84-47-67.92-37.21-13.11-72.54-34.87-99.62-70.8-13-17.28-.48-41.8 20.84-41.8 46.31 0 32.22-54.17 43.15-110.26C94.8 95.2 193.12 32 288.09 32c102.48 0 197.15 70.67 214.08 169.67zM373.51 388.28c42-19.18 81.33-56.71 96.29-102.14 40.48-123.09-64.15-228-181.71-228-83.45 0-170.32 55.42-186.07 136-9.53 48.91 5 131.35-68.75 131.35C58.21 358.6 91.6 378.11 127 389.54c24.66-21.8 63.87-15.47 79.83 14.34 14.22 1 79.19 1.18 87.9.82a51.69 51.69 0 0 1 78.78-16.42zM205.12 187.13c0-34.74 50.84-34.75 50.84 0s-50.84 34.74-50.84 0zm116.57 0c0-34.74 50.86-34.75 50.86 0s-50.86 34.75-50.86 0zm-122.61 70.69c-3.44-16.94 22.18-22.18 25.62-5.21l.06.28c4.14 21.42 29.85 44 64.12 43.07 35.68-.94 59.25-22.21 64.11-42.77 4.46-16.05 28.6-10.36 25.47 6-5.23 22.18-31.21 62-91.46 62.9-42.55 0-80.88-27.84-87.9-64.25z"
                }
            }
        ]
    })(props);
}
function FaWeebly(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M425.09 65.83c-39.88 0-73.28 25.73-83.66 64.33-18.16-58.06-65.5-64.33-84.95-64.33-19.78 0-66.8 6.28-85.28 64.33-10.38-38.6-43.45-64.33-83.66-64.33C38.59 65.83 0 99.72 0 143.03c0 28.96 4.18 33.27 77.17 233.48 22.37 60.57 67.77 69.35 92.74 69.35 39.23 0 70.04-19.46 85.93-53.98 15.89 34.83 46.69 54.29 85.93 54.29 24.97 0 70.36-9.1 92.74-69.67 76.55-208.65 77.5-205.58 77.5-227.2.63-48.32-36.01-83.47-86.92-83.47zm26.34 114.81l-65.57 176.44c-7.92 21.49-21.22 37.22-46.24 37.22-23.44 0-37.38-12.41-44.03-33.9l-39.28-117.42h-.95L216.08 360.4c-6.96 21.5-20.9 33.6-44.02 33.6-25.02 0-38.33-15.74-46.24-37.22L60.88 181.55c-5.38-14.83-7.92-23.91-7.92-34.5 0-16.34 15.84-29.36 38.33-29.36 18.69 0 31.99 11.8 36.11 29.05l44.03 139.82h.95l44.66-136.79c6.02-19.67 16.47-32.08 38.96-32.08s32.94 12.11 38.96 32.08l44.66 136.79h.95l44.03-139.82c4.12-17.25 17.42-29.05 36.11-29.05 22.17 0 38.33 13.32 38.33 35.71-.32 7.87-4.12 16.04-7.61 27.24z"
                }
            }
        ]
    })(props);
}
function FaWeibo(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M407 177.6c7.6-24-13.4-46.8-37.4-41.7-22 4.8-28.8-28.1-7.1-32.8 50.1-10.9 92.3 37.1 76.5 84.8-6.8 21.2-38.8 10.8-32-10.3zM214.8 446.7C108.5 446.7 0 395.3 0 310.4c0-44.3 28-95.4 76.3-143.7C176 67 279.5 65.8 249.9 161c-4 13.1 12.3 5.7 12.3 6 79.5-33.6 140.5-16.8 114 51.4-3.7 9.4 1.1 10.9 8.3 13.1 135.7 42.3 34.8 215.2-169.7 215.2zm143.7-146.3c-5.4-55.7-78.5-94-163.4-85.7-84.8 8.6-148.8 60.3-143.4 116s78.5 94 163.4 85.7c84.8-8.6 148.8-60.3 143.4-116zM347.9 35.1c-25.9 5.6-16.8 43.7 8.3 38.3 72.3-15.2 134.8 52.8 111.7 124-7.4 24.2 29.1 37 37.4 12 31.9-99.8-55.1-195.9-157.4-174.3zm-78.5 311c-17.1 38.8-66.8 60-109.1 46.3-40.8-13.1-58-53.4-40.3-89.7 17.7-35.4 63.1-55.4 103.4-45.1 42 10.8 63.1 50.2 46 88.5zm-86.3-30c-12.9-5.4-30 .3-38 12.9-8.3 12.9-4.3 28 8.6 34 13.1 6 30.8.3 39.1-12.9 8-13.1 3.7-28.3-9.7-34zm32.6-13.4c-5.1-1.7-11.4.6-14.3 5.4-2.9 5.1-1.4 10.6 3.7 12.9 5.1 2 11.7-.3 14.6-5.4 2.8-5.2 1.1-10.9-4-12.9z"
                }
            }
        ]
    })(props);
}
function FaWeixin(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M385.2 167.6c6.4 0 12.6.3 18.8 1.1C387.4 90.3 303.3 32 207.7 32 100.5 32 13 104.8 13 197.4c0 53.4 29.3 97.5 77.9 131.6l-19.3 58.6 68-34.1c24.4 4.8 43.8 9.7 68.2 9.7 6.2 0 12.1-.3 18.3-.8-4-12.9-6.2-26.6-6.2-40.8-.1-84.9 72.9-154 165.3-154zm-104.5-52.9c14.5 0 24.2 9.7 24.2 24.4 0 14.5-9.7 24.2-24.2 24.2-14.8 0-29.3-9.7-29.3-24.2.1-14.7 14.6-24.4 29.3-24.4zm-136.4 48.6c-14.5 0-29.3-9.7-29.3-24.2 0-14.8 14.8-24.4 29.3-24.4 14.8 0 24.4 9.7 24.4 24.4 0 14.6-9.6 24.2-24.4 24.2zM563 319.4c0-77.9-77.9-141.3-165.4-141.3-92.7 0-165.4 63.4-165.4 141.3S305 460.7 397.6 460.7c19.3 0 38.9-5.1 58.6-9.9l53.4 29.3-14.8-48.6C534 402.1 563 363.2 563 319.4zm-219.1-24.5c-9.7 0-19.3-9.7-19.3-19.6 0-9.7 9.7-19.3 19.3-19.3 14.8 0 24.4 9.7 24.4 19.3 0 10-9.7 19.6-24.4 19.6zm107.1 0c-9.7 0-19.3-9.7-19.3-19.6 0-9.7 9.7-19.3 19.3-19.3 14.5 0 24.4 9.7 24.4 19.3.1 10-9.9 19.6-24.4 19.6z"
                }
            }
        ]
    })(props);
}
function FaWhatsappSquare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M224 122.8c-72.7 0-131.8 59.1-131.9 131.8 0 24.9 7 49.2 20.2 70.1l3.1 5-13.3 48.6 49.9-13.1 4.8 2.9c20.2 12 43.4 18.4 67.1 18.4h.1c72.6 0 133.3-59.1 133.3-131.8 0-35.2-15.2-68.3-40.1-93.2-25-25-58-38.7-93.2-38.7zm77.5 188.4c-3.3 9.3-19.1 17.7-26.7 18.8-12.6 1.9-22.4.9-47.5-9.9-39.7-17.2-65.7-57.2-67.7-59.8-2-2.6-16.2-21.5-16.2-41s10.2-29.1 13.9-33.1c3.6-4 7.9-5 10.6-5 2.6 0 5.3 0 7.6.1 2.4.1 5.7-.9 8.9 6.8 3.3 7.9 11.2 27.4 12.2 29.4s1.7 4.3.3 6.9c-7.6 15.2-15.7 14.6-11.6 21.6 15.3 26.3 30.6 35.4 53.9 47.1 4 2 6.3 1.7 8.6-1 2.3-2.6 9.9-11.6 12.5-15.5 2.6-4 5.3-3.3 8.9-2 3.6 1.3 23.1 10.9 27.1 12.9s6.6 3 7.6 4.6c.9 1.9.9 9.9-2.4 19.1zM400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zM223.9 413.2c-26.6 0-52.7-6.7-75.8-19.3L64 416l22.5-82.2c-13.9-24-21.2-51.3-21.2-79.3C65.4 167.1 136.5 96 223.9 96c42.4 0 82.2 16.5 112.2 46.5 29.9 30 47.9 69.8 47.9 112.2 0 87.4-72.7 158.5-160.1 158.5z"
                }
            }
        ]
    })(props);
}
function FaWhatsapp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M380.9 97.1C339 55.1 283.2 32 223.9 32c-122.4 0-222 99.6-222 222 0 39.1 10.2 77.3 29.6 111L0 480l117.7-30.9c32.4 17.7 68.9 27 106.1 27h.1c122.3 0 224.1-99.6 224.1-222 0-59.3-25.2-115-67.1-157zm-157 341.6c-33.2 0-65.7-8.9-94-25.7l-6.7-4-69.8 18.3L72 359.2l-4.4-7c-18.5-29.4-28.2-63.3-28.2-98.2 0-101.7 82.8-184.5 184.6-184.5 49.3 0 95.6 19.2 130.4 54.1 34.8 34.9 56.2 81.2 56.1 130.5 0 101.8-84.9 184.6-186.6 184.6zm101.2-138.2c-5.5-2.8-32.8-16.2-37.9-18-5.1-1.9-8.8-2.8-12.5 2.8-3.7 5.6-14.3 18-17.6 21.8-3.2 3.7-6.5 4.2-12 1.4-32.6-16.3-54-29.1-75.5-66-5.7-9.8 5.7-9.1 16.3-30.3 1.8-3.7.9-6.9-.5-9.7-1.4-2.8-12.5-30.1-17.1-41.2-4.5-10.8-9.1-9.3-12.5-9.5-3.2-.2-6.9-.2-10.6-.2-3.7 0-9.7 1.4-14.8 6.9-5.1 5.6-19.4 19-19.4 46.3 0 27.3 19.9 53.7 22.6 57.4 2.8 3.7 39.1 59.7 94.8 83.8 35.2 15.2 49 16.5 66.6 13.9 10.7-1.6 32.8-13.4 37.4-26.4 4.6-13 4.6-24.1 3.2-26.4-1.3-2.5-5-3.9-10.5-6.6z"
                }
            }
        ]
    })(props);
}
function FaWhmcs(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M448 161v-21.3l-28.5-8.8-2.2-10.4 20.1-20.7L427 80.4l-29 7.5-7.2-7.5 7.5-28.2-19.1-11.6-21.3 21-10.7-3.2-7-26.4h-22.6l-6.2 26.4-12.1 3.2-19.7-21-19.4 11 8.1 27.7-8.1 8.4-28.5-7.5-11 19.1 20.7 21-2.9 10.4-28.5 7.8-.3 21.7 28.8 7.5 2.4 12.1-20.1 19.9 10.4 18.5 29.6-7.5 7.2 8.6-8.1 26.9 19.9 11.6 19.4-20.4 11.6 2.9 6.7 28.5 22.6.3 6.7-28.8 11.6-3.5 20.7 21.6 20.4-12.1-8.8-28 7.8-8.1 28.8 8.8 10.3-20.1-20.9-18.8 2.2-12.1 29.1-7zm-119.2 45.2c-31.3 0-56.8-25.4-56.8-56.8s25.4-56.8 56.8-56.8 56.8 25.4 56.8 56.8c0 31.5-25.4 56.8-56.8 56.8zm72.3 16.4l46.9 14.5V277l-55.1 13.4-4.1 22.7 38.9 35.3-19.2 37.9-54-16.7-14.6 15.2 16.7 52.5-38.3 22.7-38.9-40.5-21.7 6.6-12.6 54-42.4-.5-12.6-53.6-21.7-5.6-36.4 38.4-37.4-21.7 15.2-50.5-13.7-16.1-55.5 14.1-19.7-34.8 37.9-37.4-4.8-22.8-54-14.1.5-40.9L54 219.9l5.7-19.7-38.9-39.4L41.5 125l53.6 14.1 15.2-15.7-15.2-52 36.4-20.7 36.8 39.4L191 84l11.6-52H245l11.6 45.9L234 72l-6.3-1.7-3.3 5.7-11 19.1-3.3 5.6 4.6 4.6 17.2 17.4-.3 1-23.8 6.5-6.2 1.7-.1 6.4-.2 12.9C153.8 161.6 118 204 118 254.7c0 58.3 47.3 105.7 105.7 105.7 50.5 0 92.7-35.4 103.2-82.8l13.2.2 6.9.1 1.6-6.7 5.6-24 1.9-.6 17.1 17.8 4.7 4.9 5.8-3.4 20.4-12.1 5.8-3.5-2-6.5-6.8-21.2z"
                }
            }
        ]
    })(props);
}
function FaWikipediaW(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M640 51.2l-.3 12.2c-28.1.8-45 15.8-55.8 40.3-25 57.8-103.3 240-155.3 358.6H415l-81.9-193.1c-32.5 63.6-68.3 130-99.2 193.1-.3.3-15 0-15-.3C172 352.3 122.8 243.4 75.8 133.4 64.4 106.7 26.4 63.4.2 63.7c0-3.1-.3-10-.3-14.2h161.9v13.9c-19.2 1.1-52.8 13.3-43.3 34.2 21.9 49.7 103.6 240.3 125.6 288.6 15-29.7 57.8-109.2 75.3-142.8-13.9-28.3-58.6-133.9-72.8-160-9.7-17.8-36.1-19.4-55.8-19.7V49.8l142.5.3v13.1c-19.4.6-38.1 7.8-29.4 26.1 18.9 40 30.6 68.1 48.1 104.7 5.6-10.8 34.7-69.4 48.1-100.8 8.9-20.6-3.9-28.6-38.6-29.4.3-3.6 0-10.3.3-13.6 44.4-.3 111.1-.3 123.1-.6v13.6c-22.5.8-45.8 12.8-58.1 31.7l-59.2 122.8c6.4 16.1 63.3 142.8 69.2 156.7L559.2 91.8c-8.6-23.1-36.4-28.1-47.2-28.3V49.6l127.8 1.1.2.5z"
                }
            }
        ]
    })(props);
}
function FaWindows(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 93.7l183.6-25.3v177.4H0V93.7zm0 324.6l183.6 25.3V268.4H0v149.9zm203.8 28L448 480V268.4H203.8v177.9zm0-380.6v180.1H448V32L203.8 65.7z"
                }
            }
        ]
    })(props);
}
function FaWix(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M393.38 131.69c0 13.03 2.08 32.69-28.68 43.83-9.52 3.45-15.95 9.66-15.95 9.66 0-31 4.72-42.22 17.4-48.86 9.75-5.11 27.23-4.63 27.23-4.63zm-115.8 35.54l-34.24 132.66-28.48-108.57c-7.69-31.99-20.81-48.53-48.43-48.53-27.37 0-40.66 16.18-48.43 48.53L89.52 299.89 55.28 167.23C49.73 140.51 23.86 128.96 0 131.96l65.57 247.93s21.63 1.56 32.46-3.96c14.22-7.25 20.98-12.84 29.59-46.57 7.67-30.07 29.11-118.41 31.12-124.7 4.76-14.94 11.09-13.81 15.4 0 1.97 6.3 23.45 94.63 31.12 124.7 8.6 33.73 15.37 39.32 29.59 46.57 10.82 5.52 32.46 3.96 32.46 3.96l65.57-247.93c-24.42-3.07-49.82 8.93-55.3 35.27zm115.78 5.21s-4.1 6.34-13.46 11.57c-6.01 3.36-11.78 5.64-17.97 8.61-15.14 7.26-13.18 13.95-13.18 35.2v152.07s16.55 2.09 27.37-3.43c13.93-7.1 17.13-13.95 17.26-44.78V181.41l-.02.01v-8.98zm163.44 84.08L640 132.78s-35.11-5.98-52.5 9.85c-13.3 12.1-24.41 29.55-54.18 72.47-.47.73-6.25 10.54-13.07 0-29.29-42.23-40.8-60.29-54.18-72.47-17.39-15.83-52.5-9.85-52.5-9.85l83.2 123.74-82.97 123.36s36.57 4.62 53.95-11.21c11.49-10.46 17.58-20.37 52.51-70.72 6.81-10.52 12.57-.77 13.07 0 29.4 42.38 39.23 58.06 53.14 70.72 17.39 15.83 53.32 11.21 53.32 11.21L556.8 256.52z"
                }
            }
        ]
    })(props);
}
function FaWizardsOfTheCoast(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M219.19 345.69c-1.9 1.38-11.07 8.44-.26 23.57 4.64 6.42 14.11 12.79 21.73 6.55 6.5-4.88 7.35-12.92.26-23.04-5.47-7.76-14.28-12.88-21.73-7.08zm336.75 75.94c-.34 1.7-.55 1.67.79 0 2.09-4.19 4.19-10.21 4.98-19.9 3.14-38.49-40.33-71.49-101.34-78.03-54.73-6.02-124.38 9.17-188.8 60.49l-.26 1.57c2.62 4.98 4.98 10.74 3.4 21.21l.79.26c63.89-58.4 131.19-77.25 184.35-73.85 58.4 3.67 100.03 34.04 100.03 68.08-.01 9.96-2.63 15.72-3.94 20.17zM392.28 240.42c.79 7.07 4.19 10.21 9.17 10.47 5.5.26 9.43-2.62 10.47-6.55.79-3.4 2.09-29.85 2.09-29.85s-11.26 6.55-14.93 10.47c-3.66 3.68-7.33 8.39-6.8 15.46zm-50.02-151.1C137.75 89.32 13.1 226.8.79 241.2c-1.05.52-1.31.79.79 1.31 60.49 16.5 155.81 81.18 196.13 202.16l1.05.26c55.25-69.92 140.88-128.05 236.99-128.05 80.92 0 130.15 42.16 130.15 80.39 0 18.33-6.55 33.52-22.26 46.35 0 .96-.2.79.79.79 14.66-10.74 27.5-28.8 27.5-48.18 0-22.78-12.05-38.23-12.05-38.23 7.07 7.07 10.74 16.24 10.74 16.24 5.76-40.85 26.97-62.32 26.97-62.32-2.36-9.69-6.81-17.81-6.81-17.81 7.59 8.12 14.4 27.5 14.4 41.37 0 10.47-3.4 22.78-12.57 31.95l.26.52c8.12-4.98 16.5-16.76 16.5-37.97 0-15.71-4.71-25.92-4.71-25.92 5.76-5.24 11.26-9.17 15.97-11.78.79 3.4 2.09 9.69 2.36 14.93 0 1.05.79 1.83 1.05 0 .79-5.76-.26-16.24-.26-16.5 6.02-3.14 9.69-4.45 9.69-4.45C617.74 176 489.43 89.32 342.26 89.32zm-99.24 289.62c-11.06 8.99-24.2 4.08-30.64-4.19-7.45-9.58-6.76-24.09 4.19-32.47 14.85-11.35 27.08-.49 31.16 5.5.28.39 12.13 16.57-4.71 31.16zm2.09-136.43l9.43-17.81 11.78 70.96-12.57 6.02-24.62-28.8 14.14-26.71 3.67 4.45-1.83-8.11zm18.59 117.58l-.26-.26c2.05-4.1-2.5-6.61-17.54-31.69-1.31-2.36-3.14-2.88-4.45-2.62l-.26-.52c7.86-5.76 15.45-10.21 25.4-15.71l.52.26c1.31 1.83 2.09 2.88 3.4 4.71l-.26.52c-1.05-.26-2.36-.79-5.24.26-2.09.79-7.86 3.67-12.31 7.59v1.31c1.57 2.36 3.93 6.55 5.76 9.69h.26c10.05-6.28 7.56-4.55 11.52-7.86h.26c.52 1.83.52 1.83 1.83 5.5l-.26.26c-3.06.61-4.65.34-11.52 5.5v.26c9.46 17.02 11.01 16.75 12.57 15.97l.26.26c-2.34 1.59-6.27 4.21-9.68 6.57zm55.26-32.47c-3.14 1.57-6.02 2.88-9.95 4.98l-.26-.26c1.29-2.59 1.16-2.71-11.78-32.47l-.26-.26c-.15 0-8.9 3.65-9.95 7.33h-.52l-1.05-5.76.26-.52c7.29-4.56 25.53-11.64 27.76-12.57l.52.26 3.14 4.98-.26.52c-3.53-1.76-7.35.76-12.31 2.62v.26c12.31 32.01 12.67 30.64 14.66 30.64v.25zm44.77-16.5c-4.19 1.05-5.24 1.31-9.69 2.88l-.26-.26.52-4.45c-1.05-3.4-3.14-11.52-3.67-13.62l-.26-.26c-3.4.79-8.9 2.62-12.83 3.93l-.26.26c.79 2.62 3.14 9.95 4.19 13.88.79 2.36 1.83 2.88 2.88 3.14v.52c-3.67 1.05-7.07 2.62-10.21 3.93l-.26-.26c1.05-1.31 1.05-2.88.26-4.98-1.05-3.14-8.12-23.83-9.17-27.23-.52-1.83-1.57-3.14-2.62-3.14v-.52c3.14-1.05 6.02-2.09 10.74-3.4l.26.26-.26 4.71c1.31 3.93 2.36 7.59 3.14 9.69h.26c3.93-1.31 9.43-2.88 12.83-3.93l.26-.26-2.62-9.43c-.52-1.83-1.05-3.4-2.62-3.93v-.26c4.45-1.05 7.33-1.83 10.74-2.36l.26.26c-1.05 1.31-1.05 2.88-.52 4.45 1.57 6.28 4.71 20.43 6.28 26.45.54 2.62 1.85 3.41 2.63 3.93zm32.21-6.81l-.26.26c-4.71.52-14.14 2.36-22.52 4.19l-.26-.26.79-4.19c-1.57-7.86-3.4-18.59-4.98-26.19-.26-1.83-.79-2.88-2.62-3.67l.79-.52c9.17-1.57 20.16-2.36 24.88-2.62l.26.26c.52 2.36.79 3.14 1.57 5.5l-.26.26c-1.14-1.14-3.34-3.2-16.24-.79l-.26.26c.26 1.57 1.05 6.55 1.57 9.95l.26.26c9.52-1.68 4.76-.06 10.74-2.36h.26c0 1.57-.26 1.83-.26 5.24h-.26c-4.81-1.03-2.15-.9-10.21 0l-.26.26c.26 2.09 1.57 9.43 2.09 12.57l.26.26c1.15.38 14.21-.65 16.24-4.71h.26c-.53 2.38-1.05 4.21-1.58 6.04zm10.74-44.51c-4.45 2.36-8.12 2.88-11 2.88-.25.02-11.41 1.09-17.54-9.95-6.74-10.79-.98-25.2 5.5-31.69 8.8-8.12 23.35-10.1 28.54-17.02 8.03-10.33-13.04-22.31-29.59-5.76l-2.62-2.88 5.24-16.24c25.59-1.57 45.2-3.04 50.02 16.24.79 3.14 0 9.43-.26 12.05 0 2.62-1.83 18.85-2.09 23.04-.52 4.19-.79 18.33-.79 20.69.26 2.36.52 4.19 1.57 5.5 1.57 1.83 5.76 1.83 5.76 1.83l-.79 4.71c-11.82-1.07-10.28-.59-20.43-1.05-3.22-5.15-2.23-3.28-4.19-7.86 0 .01-4.19 3.94-7.33 5.51zm37.18 21.21c-6.35-10.58-19.82-7.16-21.73 5.5-2.63 17.08 14.3 19.79 20.69 10.21l.26.26c-.52 1.83-1.83 6.02-1.83 6.28l-.52.52c-10.3 6.87-28.5-2.5-25.66-18.59 1.94-10.87 14.44-18.93 28.8-9.95l.26.52c0 1.06-.27 3.41-.27 5.25zm5.77-87.73v-6.55c.69 0 19.65 3.28 27.76 7.33l-1.57 17.54s10.21-9.43 15.45-10.74c5.24-1.57 14.93 7.33 14.93 7.33l-11.26 11.26c-12.07-6.35-19.59-.08-20.69.79-5.29 38.72-8.6 42.17 4.45 46.09l-.52 4.71c-17.55-4.29-18.53-4.5-36.92-7.33l.79-4.71c7.25 0 7.48-5.32 7.59-6.81 0 0 4.98-53.16 4.98-55.25-.02-2.87-4.99-3.66-4.99-3.66zm10.99 114.44c-8.12-2.09-14.14-11-10.74-20.69 3.14-9.43 12.31-12.31 18.85-10.21 9.17 2.62 12.83 11.78 10.74 19.38-2.61 8.9-9.42 13.87-18.85 11.52zm42.16 9.69c-2.36-.52-7.07-2.36-8.64-2.88v-.26l1.57-1.83c.59-8.24.59-7.27.26-7.59-4.82-1.81-6.66-2.36-7.07-2.36-1.31 1.83-2.88 4.45-3.67 5.5l-.79 3.4v.26c-1.31-.26-3.93-1.31-6.02-1.57v-.26l2.62-1.83c3.4-4.71 9.95-14.14 13.88-20.16v-2.09l.52-.26c2.09.79 5.5 2.09 7.59 2.88.48.48.18-1.87-1.05 25.14-.24 1.81.02 2.6.8 3.91zm-4.71-89.82c11.25-18.27 30.76-16.19 34.04-3.4L539.7 198c2.34-6.25-2.82-9.9-4.45-11.26l1.83-3.67c12.22 10.37 16.38 13.97 22.52 20.43-25.91 73.07-30.76 80.81-24.62 84.32l-1.83 4.45c-6.37-3.35-8.9-4.42-17.81-8.64l2.09-6.81c-.26-.26-3.93 3.93-9.69 3.67-19.06-1.3-22.89-31.75-9.67-52.9zm29.33 79.34c0-5.71-6.34-7.89-7.86-5.24-1.31 2.09 1.05 4.98 2.88 8.38 1.57 2.62 2.62 6.28 1.05 9.43-2.64 6.34-12.4 5.31-15.45-.79 0-.7-.27.09 1.83-4.71l.79-.26c-.57 5.66 6.06 9.61 8.38 4.98 1.05-2.09-.52-5.5-2.09-8.38-1.57-2.62-3.67-6.28-1.83-9.69 2.72-5.06 11.25-4.47 14.66 2.36v.52l-2.36 3.4zm21.21 13.36c-1.96-3.27-.91-2.14-4.45-4.71h-.26c-2.36 4.19-5.76 10.47-8.64 16.24-1.31 2.36-1.05 3.4-.79 3.93l-.26.26-5.76-4.45.26-.26 2.09-1.31c3.14-5.76 6.55-12.05 9.17-17.02v-.26c-2.64-1.98-1.22-1.51-6.02-1.83v-.26l3.14-3.4h.26c3.67 2.36 9.95 6.81 12.31 8.9l.26.26-1.31 3.91zm27.23-44.26l-2.88-2.88c.79-2.36 1.83-4.98 2.09-7.59.75-9.74-11.52-11.84-11.52-4.98 0 4.98 7.86 19.38 7.86 27.76 0 10.21-5.76 15.71-13.88 16.5-8.38.79-20.16-10.47-20.16-10.47l4.98-14.4 2.88 2.09c-2.97 17.8 17.68 20.37 13.35 5.24-1.06-4.02-18.75-34.2 2.09-38.23 13.62-2.36 23.04 16.5 23.04 16.5l-7.85 10.46zm35.62-10.21c-11-30.38-60.49-127.53-191.95-129.62-53.42-1.05-94.27 15.45-132.76 37.97l85.63-9.17-91.39 20.69 25.14 19.64-3.93-16.5c7.5-1.71 39.15-8.45 66.77-8.9l-22.26 80.39c13.61-.7 18.97-8.98 19.64-22.78l4.98-1.05.26 26.71c-22.46 3.21-37.3 6.69-49.49 9.95l13.09-43.21-61.54-36.66 2.36 8.12 10.21 4.98c6.28 18.59 19.38 56.56 20.43 58.66 1.95 4.28 3.16 5.78 12.05 4.45l1.05 4.98c-16.08 4.86-23.66 7.61-39.02 14.4l-2.36-4.71c4.4-2.94 8.73-3.94 5.5-12.83-23.7-62.5-21.48-58.14-22.78-59.44l2.36-4.45 33.52 67.3c-3.84-11.87 1.68 1.69-32.99-78.82l-41.9 88.51 4.71-13.88-35.88-42.16 27.76 93.48-11.78 8.38C95 228.58 101.05 231.87 93.23 231.52c-5.5-.26-13.62 5.5-13.62 5.5L74.63 231c30.56-23.53 31.62-24.33 58.4-42.68l4.19 7.07s-5.76 4.19-7.86 7.07c-5.9 9.28 1.67 13.28 61.8 75.68l-18.85-58.92 39.8-10.21 25.66 30.64 4.45-12.31-4.98-24.62 13.09-3.4.52 3.14 3.67-10.47-94.27 29.33 11.26-4.98-13.62-42.42 17.28-9.17 30.11 36.14 28.54-13.09c-1.41-7.47-2.47-14.5-4.71-19.64l17.28 13.88 4.71-2.09-59.18-42.68 23.08 11.5c18.98-6.07 25.23-7.47 32.21-9.69l2.62 11c-12.55 12.55 1.43 16.82 6.55 19.38l-13.62-61.01 12.05 28.28c4.19-1.31 7.33-2.09 7.33-2.09l2.62 8.64s-3.14 1.05-6.28 2.09l8.9 20.95 33.78-65.73-20.69 61.01c42.42-24.09 81.44-36.66 131.98-35.88 67.04 1.05 167.33 40.85 199.8 139.83.78 2.1-.01 2.63-.79.27zM203.48 152.43s1.83-.52 4.19-1.31l9.43 7.59c-.4 0-3.44-.25-11.26 2.36l-2.36-8.64zm143.76 38.5c-1.57-.6-26.46-4.81-33.26 20.69l21.73 17.02 11.53-37.71zM318.43 67.07c-58.4 0-106.05 12.05-114.96 14.4v.79c8.38 2.09 14.4 4.19 21.21 11.78l1.57.26c6.55-1.83 48.97-13.88 110.24-13.88 180.16 0 301.67 116.79 301.67 223.37v9.95c0 1.31.79 2.62 1.05.52.52-2.09.79-8.64.79-19.64.26-83.79-96.63-227.55-321.57-227.55zm211.06 169.68c1.31-5.76 0-12.31-7.33-13.09-9.62-1.13-16.14 23.79-17.02 33.52-.79 5.5-1.31 14.93 6.02 14.93 4.68-.01 9.72-.91 18.33-35.36zm-61.53 42.95c-2.62-.79-9.43-.79-12.57 10.47-1.83 6.81.52 13.35 6.02 14.66 3.67 1.05 8.9.52 11.78-10.74 2.62-9.94-1.83-13.61-5.23-14.39zM491 300.65c1.83.52 3.14 1.05 5.76 1.83 0-1.83.52-8.38.79-12.05-1.05 1.31-5.5 8.12-6.55 9.95v.27z"
                }
            }
        ]
    })(props);
}
function FaWodu(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M178.414 339.706H141.1L112.166 223.475h-.478L83.228 339.706H45.2L0 168.946H37.548L64.574 285.177h.478L94.707 168.946h35.157l29.178 117.667h.479L187.5 168.946h36.831zM271.4 212.713c38.984 0 64.1 25.828 64.1 65.291 0 39.222-25.111 65.05-64.1 65.05-38.743 0-63.855-25.828-63.855-65.05C207.547 238.541 232.659 212.713 271.4 212.713zm0 104.753c23.2 0 30.133-19.852 30.133-39.462 0-19.852-6.934-39.7-30.133-39.7-27.7 0-29.894 19.85-29.894 39.7C241.508 297.614 248.443 317.466 271.4 317.466zM435.084 323.922h-.478c-7.893 13.392-21.765 19.132-37.548 19.132-37.31 0-55.485-32.045-55.485-66.246 0-33.243 18.415-64.095 54.767-64.095 14.589 0 28.938 6.218 36.831 18.416h.24V168.946h33.96v170.76H435.084zM405.428 238.3c-22.24 0-29.894 19.134-29.894 39.463 0 19.371 8.848 39.7 29.894 39.7 22.482 0 29.178-19.613 29.178-39.94C434.606 257.436 427.432 238.3 405.428 238.3zM592.96 339.706H560.673V322.487h-.718c-8.609 13.87-23.436 20.567-37.786 20.567-36.113 0-45.2-20.328-45.2-50.941V216.061h33.959V285.9c0 20.329 5.979 30.372 21.765 30.372 18.415 0 26.306-10.283 26.306-35.393V216.061H592.96zM602.453 302.876H640v36.83H602.453z"
                }
            }
        ]
    })(props);
}
function FaWolfPackBattalion(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M267.73 471.53l10.56 15.84 5.28-12.32 5.28 7V512c21.06-7.92 21.11-66.86 25.51-97.21 4.62-31.89-.88-92.81 81.37-149.11-8.88-23.61-12-49.43-2.64-80.05C421 189 447 196.21 456.43 239.73l-30.35 8.36c11.15 23 17 46.76 13.2 72.14L412 313.18l-6.16 33.43-18.47-7-8.8 33.39-19.35-7 26.39 21.11 8.8-28.15L419 364.2l7-35.63 26.39 14.52c.25-20 7-58.06-8.8-84.45l26.39 5.28c4-22.07-2.38-39.21-7.92-56.74l22.43 9.68c-.44-25.07-29.94-56.79-61.58-58.5-20.22-1.09-56.74-25.17-54.1-51.9 2-19.87 17.45-42.62 43.11-49.7-44 36.51-9.68 67.3 5.28 73.46 4.4-11.44 17.54-69.08 0-130.2-40.39 22.87-89.65 65.1-93.2 147.79l-58 38.71-3.52 93.25L369.78 220l7 7-17.59 3.52-44 38.71-15.84-5.28-28.1 49.25-3.52 119.64 21.11 15.84-32.55 15.84-32.55-15.84 21.11-15.84-3.52-119.64-28.15-49.26-15.84 5.28-44-38.71-17.58-3.51 7-7 107.33 59.82-3.52-93.25-58.06-38.71C185 65.1 135.77 22.87 95.3 0c-17.54 61.12-4.4 118.76 0 130.2 15-6.16 49.26-36.95 5.28-73.46 25.66 7.08 41.15 29.83 43.11 49.7 2.63 26.74-33.88 50.81-54.1 51.9-31.65 1.72-61.15 33.44-61.59 58.51l22.43-9.68c-5.54 17.53-11.91 34.67-7.92 56.74l26.39-5.28c-15.76 26.39-9.05 64.43-8.8 84.45l26.39-14.52 7 35.63 24.63-5.28 8.8 28.15L153.35 366 134 373l-8.8-33.43-18.47 7-6.16-33.43-27.27 7c-3.82-25.38 2-49.1 13.2-72.14l-30.35-8.36c9.4-43.52 35.47-50.77 63.34-54.1 9.36 30.62 6.24 56.45-2.64 80.05 82.25 56.3 76.75 117.23 81.37 149.11 4.4 30.35 4.45 89.29 25.51 97.21v-29.83l5.28-7 5.28 12.32 10.56-15.84 11.44 21.11 11.43-21.1zm79.17-95L331.06 366c7.47-4.36 13.76-8.42 19.35-12.32-.6 7.22-.27 13.84-3.51 22.84zm28.15-49.26c-.4 10.94-.9 21.66-1.76 31.67-7.85-1.86-15.57-3.8-21.11-7 8.24-7.94 15.55-16.32 22.87-24.68zm24.63 5.28c0-13.43-2.05-24.21-5.28-33.43a235 235 0 0 1-18.47 27.27zm3.52-80.94c19.44 12.81 27.8 33.66 29.91 56.3-12.32-4.53-24.63-9.31-36.95-10.56 5.06-12 6.65-28.14 7-45.74zm-1.76-45.74c.81 14.3 1.84 28.82 1.76 42.23 19.22-8.11 29.78-9.72 44-14.08-10.61-18.96-27.2-25.53-45.76-28.16zM165.68 376.52L181.52 366c-7.47-4.36-13.76-8.42-19.35-12.32.6 7.26.27 13.88 3.51 22.88zm-28.15-49.26c.4 10.94.9 21.66 1.76 31.67 7.85-1.86 15.57-3.8 21.11-7-8.24-7.93-15.55-16.31-22.87-24.67zm-24.64 5.28c0-13.43 2-24.21 5.28-33.43a235 235 0 0 0 18.47 27.27zm-3.52-80.94c-19.44 12.81-27.8 33.66-29.91 56.3 12.32-4.53 24.63-9.31 37-10.56-5-12-6.65-28.14-7-45.74zm1.76-45.74c-.81 14.3-1.84 28.82-1.76 42.23-19.22-8.11-29.78-9.72-44-14.08 10.63-18.95 27.23-25.52 45.76-28.15z"
                }
            }
        ]
    })(props);
}
function FaWordpressSimple(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 8C119.3 8 8 119.2 8 256c0 136.7 111.3 248 248 248s248-111.3 248-248C504 119.2 392.7 8 256 8zM33 256c0-32.3 6.9-63 19.3-90.7l106.4 291.4C84.3 420.5 33 344.2 33 256zm223 223c-21.9 0-43-3.2-63-9.1l66.9-194.4 68.5 187.8c.5 1.1 1 2.1 1.6 3.1-23.1 8.1-48 12.6-74 12.6zm30.7-327.5c13.4-.7 25.5-2.1 25.5-2.1 12-1.4 10.6-19.1-1.4-18.4 0 0-36.1 2.8-59.4 2.8-21.9 0-58.7-2.8-58.7-2.8-12-.7-13.4 17.7-1.4 18.4 0 0 11.4 1.4 23.4 2.1l34.7 95.2L200.6 393l-81.2-241.5c13.4-.7 25.5-2.1 25.5-2.1 12-1.4 10.6-19.1-1.4-18.4 0 0-36.1 2.8-59.4 2.8-4.2 0-9.1-.1-14.4-.3C109.6 73 178.1 33 256 33c58 0 110.9 22.2 150.6 58.5-1-.1-1.9-.2-2.9-.2-21.9 0-37.4 19.1-37.4 39.6 0 18.4 10.6 33.9 21.9 52.3 8.5 14.8 18.4 33.9 18.4 61.5 0 19.1-7.3 41.2-17 72.1l-22.2 74.3-80.7-239.6zm81.4 297.2l68.1-196.9c12.7-31.8 17-57.2 17-79.9 0-8.2-.5-15.8-1.5-22.9 17.4 31.8 27.3 68.2 27.3 107 0 82.3-44.6 154.1-110.9 192.7z"
                }
            }
        ]
    })(props);
}
function FaWordpress(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M61.7 169.4l101.5 278C92.2 413 43.3 340.2 43.3 256c0-30.9 6.6-60.1 18.4-86.6zm337.9 75.9c0-26.3-9.4-44.5-17.5-58.7-10.8-17.5-20.9-32.4-20.9-49.9 0-19.6 14.8-37.8 35.7-37.8.9 0 1.8.1 2.8.2-37.9-34.7-88.3-55.9-143.7-55.9-74.3 0-139.7 38.1-177.8 95.9 5 .2 9.7.3 13.7.3 22.2 0 56.7-2.7 56.7-2.7 11.5-.7 12.8 16.2 1.4 17.5 0 0-11.5 1.3-24.3 2l77.5 230.4L249.8 247l-33.1-90.8c-11.5-.7-22.3-2-22.3-2-11.5-.7-10.1-18.2 1.3-17.5 0 0 35.1 2.7 56 2.7 22.2 0 56.7-2.7 56.7-2.7 11.5-.7 12.8 16.2 1.4 17.5 0 0-11.5 1.3-24.3 2l76.9 228.7 21.2-70.9c9-29.4 16-50.5 16-68.7zm-139.9 29.3l-63.8 185.5c19.1 5.6 39.2 8.7 60.1 8.7 24.8 0 48.5-4.3 70.6-12.1-.6-.9-1.1-1.9-1.5-2.9l-65.4-179.2zm183-120.7c.9 6.8 1.4 14 1.4 21.9 0 21.6-4 45.8-16.2 76.2l-65 187.9C426.2 403 468.7 334.5 468.7 256c0-37-9.4-71.8-26-102.1zM504 256c0 136.8-111.3 248-248 248C119.2 504 8 392.7 8 256 8 119.2 119.2 8 256 8c136.7 0 248 111.2 248 248zm-11.4 0c0-130.5-106.2-236.6-236.6-236.6C125.5 19.4 19.4 125.5 19.4 256S125.6 492.6 256 492.6c130.5 0 236.6-106.1 236.6-236.6z"
                }
            }
        ]
    })(props);
}
function FaWpbeginner(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M462.799 322.374C519.01 386.682 466.961 480 370.944 480c-39.602 0-78.824-17.687-100.142-50.04-6.887.356-22.702.356-29.59 0C219.848 462.381 180.588 480 141.069 480c-95.49 0-148.348-92.996-91.855-157.626C-29.925 190.523 80.479 32 256.006 32c175.632 0 285.87 158.626 206.793 290.374zm-339.647-82.972h41.529v-58.075h-41.529v58.075zm217.18 86.072v-23.839c-60.506 20.915-132.355 9.198-187.589-33.971l.246 24.897c51.101 46.367 131.746 57.875 187.343 32.913zm-150.753-86.072h166.058v-58.075H189.579v58.075z"
                }
            }
        ]
    })(props);
}
function FaWpexplorer(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M512 256c0 141.2-114.7 256-256 256C114.8 512 0 397.3 0 256S114.7 0 256 0s256 114.7 256 256zm-32 0c0-123.2-100.3-224-224-224C132.5 32 32 132.5 32 256s100.5 224 224 224 224-100.5 224-224zM160.9 124.6l86.9 37.1-37.1 86.9-86.9-37.1 37.1-86.9zm110 169.1l46.6 94h-14.6l-50-100-48.9 100h-14l51.1-106.9-22.3-9.4 6-14 68.6 29.1-6 14.3-16.5-7.1zm-11.8-116.3l68.6 29.4-29.4 68.3L230 246l29.1-68.6zm80.3 42.9l54.6 23.1-23.4 54.3-54.3-23.1 23.1-54.3z"
                }
            }
        ]
    })(props);
}
function FaWpforms(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M448 75.2v361.7c0 24.3-19 43.2-43.2 43.2H43.2C19.3 480 0 461.4 0 436.8V75.2C0 51.1 18.8 32 43.2 32h361.7c24 0 43.1 18.8 43.1 43.2zm-37.3 361.6V75.2c0-3-2.6-5.8-5.8-5.8h-9.3L285.3 144 224 94.1 162.8 144 52.5 69.3h-9.3c-3.2 0-5.8 2.8-5.8 5.8v361.7c0 3 2.6 5.8 5.8 5.8h361.7c3.2.1 5.8-2.7 5.8-5.8zM150.2 186v37H76.7v-37h73.5zm0 74.4v37.3H76.7v-37.3h73.5zm11.1-147.3l54-43.7H96.8l64.5 43.7zm210 72.9v37h-196v-37h196zm0 74.4v37.3h-196v-37.3h196zm-84.6-147.3l64.5-43.7H232.8l53.9 43.7zM371.3 335v37.3h-99.4V335h99.4z"
                }
            }
        ]
    })(props);
}
function FaWpressr(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111.03 8 0 119.03 0 256s111.03 248 248 248 248-111.03 248-248S384.97 8 248 8zm171.33 158.6c-15.18 34.51-30.37 69.02-45.63 103.5-2.44 5.51-6.89 8.24-12.97 8.24-23.02-.01-46.03.06-69.05-.05-5.12-.03-8.25 1.89-10.34 6.72-10.19 23.56-20.63 47-30.95 70.5-1.54 3.51-4.06 5.29-7.92 5.29-45.94-.01-91.87-.02-137.81 0-3.13 0-5.63-1.15-7.72-3.45-11.21-12.33-22.46-24.63-33.68-36.94-2.69-2.95-2.79-6.18-1.21-9.73 8.66-19.54 17.27-39.1 25.89-58.66 12.93-29.35 25.89-58.69 38.75-88.08 1.7-3.88 4.28-5.68 8.54-5.65 14.24.1 28.48.02 42.72.05 6.24.01 9.2 4.84 6.66 10.59-13.6 30.77-27.17 61.55-40.74 92.33-5.72 12.99-11.42 25.99-17.09 39-3.91 8.95 7.08 11.97 10.95 5.6.23-.37-1.42 4.18 30.01-67.69 1.36-3.1 3.41-4.4 6.77-4.39 15.21.08 30.43.02 45.64.04 5.56.01 7.91 3.64 5.66 8.75-8.33 18.96-16.71 37.9-24.98 56.89-4.98 11.43 8.08 12.49 11.28 5.33.04-.08 27.89-63.33 32.19-73.16 2.02-4.61 5.44-6.51 10.35-6.5 26.43.05 52.86 0 79.29.05 12.44.02 13.93-13.65 3.9-13.64-25.26.03-50.52.02-75.78.02-6.27 0-7.84-2.47-5.27-8.27 5.78-13.06 11.59-26.11 17.3-39.21 1.73-3.96 4.52-5.79 8.84-5.78 23.09.06 25.98.02 130.78.03 6.08-.01 8.03 2.79 5.62 8.27z"
                }
            }
        ]
    })(props);
}
function FaXbox(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M369.9 318.2c44.3 54.3 64.7 98.8 54.4 118.7-7.9 15.1-56.7 44.6-92.6 55.9-29.6 9.3-68.4 13.3-100.4 10.2-38.2-3.7-76.9-17.4-110.1-39C93.3 445.8 87 438.3 87 423.4c0-29.9 32.9-82.3 89.2-142.1 32-33.9 76.5-73.7 81.4-72.6 9.4 2.1 84.3 75.1 112.3 109.5zM188.6 143.8c-29.7-26.9-58.1-53.9-86.4-63.4-15.2-5.1-16.3-4.8-28.7 8.1-29.2 30.4-53.5 79.7-60.3 122.4-5.4 34.2-6.1 43.8-4.2 60.5 5.6 50.5 17.3 85.4 40.5 120.9 9.5 14.6 12.1 17.3 9.3 9.9-4.2-11-.3-37.5 9.5-64 14.3-39 53.9-112.9 120.3-194.4zm311.6 63.5C483.3 127.3 432.7 77 425.6 77c-7.3 0-24.2 6.5-36 13.9-23.3 14.5-41 31.4-64.3 52.8C367.7 197 427.5 283.1 448.2 346c6.8 20.7 9.7 41.1 7.4 52.3-1.7 8.5-1.7 8.5 1.4 4.6 6.1-7.7 19.9-31.3 25.4-43.5 7.4-16.2 15-40.2 18.6-58.7 4.3-22.5 3.9-70.8-.8-93.4zM141.3 43C189 40.5 251 77.5 255.6 78.4c.7.1 10.4-4.2 21.6-9.7 63.9-31.1 94-25.8 107.4-25.2-63.9-39.3-152.7-50-233.9-11.7-23.4 11.1-24 11.9-9.4 11.2z"
                }
            }
        ]
    })(props);
}
function FaXingSquare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zM140.4 320.2H93.8c-5.5 0-8.7-5.3-6-10.3l49.3-86.7c.1 0 .1-.1 0-.2l-31.4-54c-3-5.6.2-10.1 6-10.1h46.6c5.2 0 9.5 2.9 12.9 8.7l31.9 55.3c-1.3 2.3-18 31.7-50.1 88.2-3.5 6.2-7.7 9.1-12.6 9.1zm219.7-214.1L257.3 286.8v.2l65.5 119c2.8 5.1.1 10.1-6 10.1h-46.6c-5.5 0-9.7-2.9-12.9-8.7l-66-120.3c2.3-4.1 36.8-64.9 103.4-182.3 3.3-5.8 7.4-8.7 12.5-8.7h46.9c5.7-.1 8.8 4.7 6 10z"
                }
            }
        ]
    })(props);
}
function FaXing(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M162.7 210c-1.8 3.3-25.2 44.4-70.1 123.5-4.9 8.3-10.8 12.5-17.7 12.5H9.8c-7.7 0-12.1-7.5-8.5-14.4l69-121.3c.2 0 .2-.1 0-.3l-43.9-75.6c-4.3-7.8.3-14.1 8.5-14.1H100c7.3 0 13.3 4.1 18 12.2l44.7 77.5zM382.6 46.1l-144 253v.3L330.2 466c3.9 7.1.2 14.1-8.5 14.1h-65.2c-7.6 0-13.6-4-18-12.2l-92.4-168.5c3.3-5.8 51.5-90.8 144.8-255.2 4.6-8.1 10.4-12.2 17.5-12.2h65.7c8 0 12.3 6.7 8.5 14.1z"
                }
            }
        ]
    })(props);
}
function FaYCombinator(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M448 32v448H0V32h448zM236 287.5L313.5 142h-32.7L235 233c-4.7 9.3-9 18.3-12.8 26.8L210 233l-45.2-91h-35l76.7 143.8v94.5H236v-92.8z"
                }
            }
        ]
    })(props);
}
function FaYahoo(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M223.69,141.06,167,284.23,111,141.06H14.93L120.76,390.19,82.19,480h94.17L317.27,141.06Zm105.4,135.79a58.22,58.22,0,1,0,58.22,58.22A58.22,58.22,0,0,0,329.09,276.85ZM394.65,32l-93,223.47H406.44L499.07,32Z"
                }
            }
        ]
    })(props);
}
function FaYammer(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M421.78 152.17A23.06 23.06 0 0 0 400.9 112c-.83.43-1.71.9-2.63 1.4-15.25 8.4-118.33 80.62-106.69 88.77s82.04-23.61 130.2-50zm0 217.17c-48.16-26.38-118.64-58.1-130.2-50s91.42 80.35 106.69 88.74c.92.51 1.8 1 2.63 1.41a23.07 23.07 0 0 0 20.88-40.15zM464.21 237c-.95 0-1.95-.06-3-.06-17.4 0-142.52 13.76-136.24 26.51s83.3 18.74 138.21 18.76a23 23 0 0 0 1-45.21zM31 96.65a24.88 24.88 0 0 1 46.14-18.4l81 205.06h1.21l77-203.53a23.52 23.52 0 0 1 44.45 15.27L171.2 368.44C152.65 415.66 134.08 448 77.91 448a139.67 139.67 0 0 1-23.81-1.95 21.31 21.31 0 0 1 6.9-41.77c.66.06 10.91.66 13.86.66 30.47 0 43.74-18.94 58.07-59.41z"
                }
            }
        ]
    })(props);
}
function FaYandexInternational(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 320 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M129.5 512V345.9L18.5 48h55.8l81.8 229.7L250.2 0h51.3L180.8 347.8V512h-51.3z"
                }
            }
        ]
    })(props);
}
function FaYandex(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 256 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M153.1 315.8L65.7 512H2l96-209.8c-45.1-22.9-75.2-64.4-75.2-141.1C22.7 53.7 90.8 0 171.7 0H254v512h-55.1V315.8h-45.8zm45.8-269.3h-29.4c-44.4 0-87.4 29.4-87.4 114.6 0 82.3 39.4 108.8 87.4 108.8h29.4V46.5z"
                }
            }
        ]
    })(props);
}
function FaYarn(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M393.9 345.2c-39 9.3-48.4 32.1-104 47.4 0 0-2.7 4-10.4 5.8-13.4 3.3-63.9 6-68.5 6.1-12.4.1-19.9-3.2-22-8.2-6.4-15.3 9.2-22 9.2-22-8.1-5-9-9.9-9.8-8.1-2.4 5.8-3.6 20.1-10.1 26.5-8.8 8.9-25.5 5.9-35.3.8-10.8-5.7.8-19.2.8-19.2s-5.8 3.4-10.5-3.6c-6-9.3-17.1-37.3 11.5-62-1.3-10.1-4.6-53.7 40.6-85.6 0 0-20.6-22.8-12.9-43.3 5-13.4 7-13.3 8.6-13.9 5.7-2.2 11.3-4.6 15.4-9.1 20.6-22.2 46.8-18 46.8-18s12.4-37.8 23.9-30.4c3.5 2.3 16.3 30.6 16.3 30.6s13.6-7.9 15.1-5c8.2 16 9.2 46.5 5.6 65.1-6.1 30.6-21.4 47.1-27.6 57.5-1.4 2.4 16.5 10 27.8 41.3 10.4 28.6 1.1 52.7 2.8 55.3.8 1.4 13.7.8 36.4-13.2 12.8-7.9 28.1-16.9 45.4-17 16.7-.5 17.6 19.2 4.9 22.2zM496 256c0 136.9-111.1 248-248 248S0 392.9 0 256 111.1 8 248 8s248 111.1 248 248zm-79.3 75.2c-1.7-13.6-13.2-23-28-22.8-22 .3-40.5 11.7-52.8 19.2-4.8 3-8.9 5.2-12.4 6.8 3.1-44.5-22.5-73.1-28.7-79.4 7.8-11.3 18.4-27.8 23.4-53.2 4.3-21.7 3-55.5-6.9-74.5-1.6-3.1-7.4-11.2-21-7.4-9.7-20-13-22.1-15.6-23.8-1.1-.7-23.6-16.4-41.4 28-12.2.9-31.3 5.3-47.5 22.8-2 2.2-5.9 3.8-10.1 5.4h.1c-8.4 3-12.3 9.9-16.9 22.3-6.5 17.4.2 34.6 6.8 45.7-17.8 15.9-37 39.8-35.7 82.5-34 36-11.8 73-5.6 79.6-1.6 11.1 3.7 19.4 12 23.8 12.6 6.7 30.3 9.6 43.9 2.8 4.9 5.2 13.8 10.1 30 10.1 6.8 0 58-2.9 72.6-6.5 6.8-1.6 11.5-4.5 14.6-7.1 9.8-3.1 36.8-12.3 62.2-28.7 18-11.7 24.2-14.2 37.6-17.4 12.9-3.2 21-15.1 19.4-28.2z"
                }
            }
        ]
    })(props);
}
function FaYelp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M42.9 240.32l99.62 48.61c19.2 9.4 16.2 37.51-4.5 42.71L30.5 358.45a22.79 22.79 0 0 1-28.21-19.6 197.16 197.16 0 0 1 9-85.32 22.8 22.8 0 0 1 31.61-13.21zm44 239.25a199.45 199.45 0 0 0 79.42 32.11A22.78 22.78 0 0 0 192.94 490l3.9-110.82c.7-21.3-25.5-31.91-39.81-16.1l-74.21 82.4a22.82 22.82 0 0 0 4.09 34.09zm145.34-109.92l58.81 94a22.93 22.93 0 0 0 34 5.5 198.36 198.36 0 0 0 52.71-67.61A23 23 0 0 0 364.17 370l-105.42-34.26c-20.31-6.5-37.81 15.8-26.51 33.91zm148.33-132.23a197.44 197.44 0 0 0-50.41-69.31 22.85 22.85 0 0 0-34 4.4l-62 91.92c-11.9 17.7 4.7 40.61 25.2 34.71L366 268.63a23 23 0 0 0 14.61-31.21zM62.11 30.18a22.86 22.86 0 0 0-9.9 32l104.12 180.44c11.7 20.2 42.61 11.9 42.61-11.4V22.88a22.67 22.67 0 0 0-24.5-22.8 320.37 320.37 0 0 0-112.33 30.1z"
                }
            }
        ]
    })(props);
}
function FaYoast(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M91.3 76h186l-7 18.9h-179c-39.7 0-71.9 31.6-71.9 70.3v205.4c0 35.4 24.9 70.3 84 70.3V460H91.3C41.2 460 0 419.8 0 370.5V165.2C0 115.9 40.7 76 91.3 76zm229.1-56h66.5C243.1 398.1 241.2 418.9 202.2 459.3c-20.8 21.6-49.3 31.7-78.3 32.7v-51.1c49.2-7.7 64.6-49.9 64.6-75.3 0-20.1.6-12.6-82.1-223.2h61.4L218.2 299 320.4 20zM448 161.5V460H234c6.6-9.6 10.7-16.3 12.1-19.4h182.5V161.5c0-32.5-17.1-51.9-48.2-62.9l6.7-17.6c41.7 13.6 60.9 43.1 60.9 80.5z"
                }
            }
        ]
    })(props);
}
function FaYoutubeSquare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M186.8 202.1l95.2 54.1-95.2 54.1V202.1zM448 80v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h352c26.5 0 48 21.5 48 48zm-42 176.3s0-59.6-7.6-88.2c-4.2-15.8-16.5-28.2-32.2-32.4C337.9 128 224 128 224 128s-113.9 0-142.2 7.7c-15.7 4.2-28 16.6-32.2 32.4-7.6 28.5-7.6 88.2-7.6 88.2s0 59.6 7.6 88.2c4.2 15.8 16.5 27.7 32.2 31.9C110.1 384 224 384 224 384s113.9 0 142.2-7.7c15.7-4.2 28-16.1 32.2-31.9 7.6-28.5 7.6-88.1 7.6-88.1z"
                }
            }
        ]
    })(props);
}
function FaYoutube(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M549.655 124.083c-6.281-23.65-24.787-42.276-48.284-48.597C458.781 64 288 64 288 64S117.22 64 74.629 75.486c-23.497 6.322-42.003 24.947-48.284 48.597-11.412 42.867-11.412 132.305-11.412 132.305s0 89.438 11.412 132.305c6.281 23.65 24.787 41.5 48.284 47.821C117.22 448 288 448 288 448s170.78 0 213.371-11.486c23.497-6.321 42.003-24.171 48.284-47.821 11.412-42.867 11.412-132.305 11.412-132.305s0-89.438-11.412-132.305zm-317.51 213.508V175.185l142.739 81.205-142.739 81.201z"
                }
            }
        ]
    })(props);
}
function FaZhihu(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M170.54 148.13v217.54l23.43.01 7.71 26.37 42.01-26.37h49.53V148.13H170.54zm97.75 193.93h-27.94l-27.9 17.51-5.08-17.47-11.9-.04V171.75h72.82v170.31zm-118.46-94.39H97.5c1.74-27.1 2.2-51.59 2.2-73.46h51.16s1.97-22.56-8.58-22.31h-88.5c3.49-13.12 7.87-26.66 13.12-40.67 0 0-24.07 0-32.27 21.57-3.39 8.9-13.21 43.14-30.7 78.12 5.89-.64 25.37-1.18 36.84-22.21 2.11-5.89 2.51-6.66 5.14-14.53h28.87c0 10.5-1.2 66.88-1.68 73.44H20.83c-11.74 0-15.56 23.62-15.56 23.62h65.58C66.45 321.1 42.83 363.12 0 396.34c20.49 5.85 40.91-.93 51-9.9 0 0 22.98-20.9 35.59-69.25l53.96 64.94s7.91-26.89-1.24-39.99c-7.58-8.92-28.06-33.06-36.79-41.81L87.9 311.95c4.36-13.98 6.99-27.55 7.87-40.67h61.65s-.09-23.62-7.59-23.62v.01zm412.02-1.6c20.83-25.64 44.98-58.57 44.98-58.57s-18.65-14.8-27.38-4.06c-6 8.15-36.83 48.2-36.83 48.2l19.23 14.43zm-150.09-59.09c-9.01-8.25-25.91 2.13-25.91 2.13s39.52 55.04 41.12 57.45l19.46-13.73s-25.67-37.61-34.66-45.86h-.01zM640 258.35c-19.78 0-130.91.93-131.06.93v-101c4.81 0 12.42-.4 22.85-1.2 40.88-2.41 70.13-4 87.77-4.81 0 0 12.22-27.19-.59-33.44-3.07-1.18-23.17 4.58-23.17 4.58s-165.22 16.49-232.36 18.05c1.6 8.82 7.62 17.08 15.78 19.55 13.31 3.48 22.69 1.7 49.15.89 24.83-1.6 43.68-2.43 56.51-2.43v99.81H351.41s2.82 22.31 25.51 22.85h107.94v70.92c0 13.97-11.19 21.99-24.48 21.12-14.08.11-26.08-1.15-41.69-1.81 1.99 3.97 6.33 14.39 19.31 21.84 9.88 4.81 16.17 6.57 26.02 6.57 29.56 0 45.67-17.28 44.89-45.31v-73.32h122.36c9.68 0 8.7-23.78 8.7-23.78l.03-.01z"
                }
            }
        ]
    })(props);
}
function FaAd(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M157.52 272h36.96L176 218.78 157.52 272zM352 256c-13.23 0-24 10.77-24 24s10.77 24 24 24 24-10.77 24-24-10.77-24-24-24zM464 64H48C21.5 64 0 85.5 0 112v288c0 26.5 21.5 48 48 48h416c26.5 0 48-21.5 48-48V112c0-26.5-21.5-48-48-48zM250.58 352h-16.94c-6.81 0-12.88-4.32-15.12-10.75L211.15 320h-70.29l-7.38 21.25A16 16 0 0 1 118.36 352h-16.94c-11.01 0-18.73-10.85-15.12-21.25L140 176.12A23.995 23.995 0 0 1 162.67 160h26.66A23.99 23.99 0 0 1 212 176.13l53.69 154.62c3.61 10.4-4.11 21.25-15.11 21.25zM424 336c0 8.84-7.16 16-16 16h-16c-4.85 0-9.04-2.27-11.98-5.68-8.62 3.66-18.09 5.68-28.02 5.68-39.7 0-72-32.3-72-72s32.3-72 72-72c8.46 0 16.46 1.73 24 4.42V176c0-8.84 7.16-16 16-16h16c8.84 0 16 7.16 16 16v160z"
                }
            }
        ]
    })(props);
}
function FaAddressBook(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M436 160c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12h-20V48c0-26.5-21.5-48-48-48H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h320c26.5 0 48-21.5 48-48v-48h20c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12h-20v-64h20c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12h-20v-64h20zm-228-32c35.3 0 64 28.7 64 64s-28.7 64-64 64-64-28.7-64-64 28.7-64 64-64zm112 236.8c0 10.6-10 19.2-22.4 19.2H118.4C106 384 96 375.4 96 364.8v-19.2c0-31.8 30.1-57.6 67.2-57.6h5c12.3 5.1 25.7 8 39.8 8s27.6-2.9 39.8-8h5c37.1 0 67.2 25.8 67.2 57.6v19.2z"
                }
            }
        ]
    })(props);
}
function FaAddressCard(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M528 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h480c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zm-352 96c35.3 0 64 28.7 64 64s-28.7 64-64 64-64-28.7-64-64 28.7-64 64-64zm112 236.8c0 10.6-10 19.2-22.4 19.2H86.4C74 384 64 375.4 64 364.8v-19.2c0-31.8 30.1-57.6 67.2-57.6h5c12.3 5.1 25.7 8 39.8 8s27.6-2.9 39.8-8h5c37.1 0 67.2 25.8 67.2 57.6v19.2zM512 312c0 4.4-3.6 8-8 8H360c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h144c4.4 0 8 3.6 8 8v16zm0-64c0 4.4-3.6 8-8 8H360c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h144c4.4 0 8 3.6 8 8v16zm0-64c0 4.4-3.6 8-8 8H360c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h144c4.4 0 8 3.6 8 8v16z"
                }
            }
        ]
    })(props);
}
function FaAdjust(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 256c0 136.966 111.033 248 248 248s248-111.034 248-248S392.966 8 256 8 8 119.033 8 256zm248 184V72c101.705 0 184 82.311 184 184 0 101.705-82.311 184-184 184z"
                }
            }
        ]
    })(props);
}
function FaAirFreshener(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M224 160H96C43 160 0 203 0 256V480C0 497.625 14.375 512 32 512H288C305.625 512 320 497.625 320 480V256C320 203 277 160 224 160ZM160 416C115.875 416 80 380.125 80 336S115.875 256 160 256S240 291.875 240 336S204.125 416 160 416ZM224 32C224 14.375 209.625 0 192 0H128C110.375 0 96 14.375 96 32V128H224V32ZM381.781 51.578C383 50.969 384 49.359 384 48C384 46.625 383 45.031 381.781 44.422L352 32L339.562 2.219C338.969 1 337.375 0 336 0S333.031 1 332.406 2.219L320 32L290.219 44.422C289 45.031 288 46.625 288 48C288 49.359 289 50.969 290.219 51.578L320 64L332.406 93.781C333.031 95 334.625 96 336 96S338.969 95 339.562 93.781L352 64L381.781 51.578ZM448 64L460.406 93.781C461.031 95 462.625 96 464 96S466.969 95 467.562 93.781L480 64L509.781 51.578C511 50.969 512 49.359 512 48C512 46.625 511 45.031 509.781 44.422L480 32L467.562 2.219C466.969 1 465.375 0 464 0S461.031 1 460.406 2.219L448 32L418.219 44.422C417 45.031 416 46.625 416 48C416 49.359 417 50.969 418.219 51.578L448 64ZM480 224L467.562 194.219C466.969 193 465.375 192 464 192S461.031 193 460.406 194.219L448 224L418.219 236.422C417 237.031 416 238.625 416 240C416 241.359 417 242.969 418.219 243.578L448 256L460.406 285.781C461.031 287 462.625 288 464 288S466.969 287 467.562 285.781L480 256L509.781 243.578C511 242.969 512 241.359 512 240C512 238.625 511 237.031 509.781 236.422L480 224ZM445.781 147.578C447 146.969 448 145.359 448 144C448 142.625 447 141.031 445.781 140.422L416 128L403.562 98.219C402.969 97 401.375 96 400 96S397.031 97 396.406 98.219L384 128L354.219 140.422C353 141.031 352 142.625 352 144C352 145.359 353 146.969 354.219 147.578L384 160L396.406 189.781C397.031 191 398.625 192 400 192S402.969 191 403.562 189.781L416 160L445.781 147.578Z"
                }
            }
        ]
    })(props);
}
function FaAlignCenter(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M432 160H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0 256H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zM108.1 96h231.81A12.09 12.09 0 0 0 352 83.9V44.09A12.09 12.09 0 0 0 339.91 32H108.1A12.09 12.09 0 0 0 96 44.09V83.9A12.1 12.1 0 0 0 108.1 96zm231.81 256A12.09 12.09 0 0 0 352 339.9v-39.81A12.09 12.09 0 0 0 339.91 288H108.1A12.09 12.09 0 0 0 96 300.09v39.81a12.1 12.1 0 0 0 12.1 12.1z"
                }
            }
        ]
    })(props);
}
function FaAlignJustify(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M432 416H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0-128H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0-128H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0-128H16A16 16 0 0 0 0 48v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16z"
                }
            }
        ]
    })(props);
}
function FaAlignLeft(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.83 352h262.34A12.82 12.82 0 0 0 288 339.17v-38.34A12.82 12.82 0 0 0 275.17 288H12.83A12.82 12.82 0 0 0 0 300.83v38.34A12.82 12.82 0 0 0 12.83 352zm0-256h262.34A12.82 12.82 0 0 0 288 83.17V44.83A12.82 12.82 0 0 0 275.17 32H12.83A12.82 12.82 0 0 0 0 44.83v38.34A12.82 12.82 0 0 0 12.83 96zM432 160H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0 256H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16z"
                }
            }
        ]
    })(props);
}
function FaAlignRight(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 224h416a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16zm416 192H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm3.17-384H172.83A12.82 12.82 0 0 0 160 44.83v38.34A12.82 12.82 0 0 0 172.83 96h262.34A12.82 12.82 0 0 0 448 83.17V44.83A12.82 12.82 0 0 0 435.17 32zm0 256H172.83A12.82 12.82 0 0 0 160 300.83v38.34A12.82 12.82 0 0 0 172.83 352h262.34A12.82 12.82 0 0 0 448 339.17v-38.34A12.82 12.82 0 0 0 435.17 288z"
                }
            }
        ]
    })(props);
}
function FaAllergies(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M416 112c-17.6 0-32 14.4-32 32v72c0 4.4-3.6 8-8 8h-16c-4.4 0-8-3.6-8-8V64c0-17.6-14.4-32-32-32s-32 14.4-32 32v152c0 4.4-3.6 8-8 8h-16c-4.4 0-8-3.6-8-8V32c0-17.6-14.4-32-32-32s-32 14.4-32 32v184c0 4.4-3.6 8-8 8h-16c-4.4 0-8-3.6-8-8V64c0-17.6-14.4-32-32-32S96 46.4 96 64v241l-23.6-32.5c-13-17.9-38-21.8-55.9-8.8s-21.8 38-8.8 55.9l125.6 172.7c9 12.4 23.5 19.8 38.8 19.8h197.6c22.3 0 41.6-15.3 46.7-37l26.5-112.7c3.2-13.7 4.9-28.3 5.1-42.3V144c0-17.6-14.4-32-32-32zM176 416c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16zm0-96c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16zm64 128c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16zm0-96c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16zm64 32c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16zm32 64c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16zm32-128c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16z"
                }
            }
        ]
    })(props);
}
function FaAmbulance(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M624 352h-16V243.9c0-12.7-5.1-24.9-14.1-33.9L494 110.1c-9-9-21.2-14.1-33.9-14.1H416V48c0-26.5-21.5-48-48-48H48C21.5 0 0 21.5 0 48v320c0 26.5 21.5 48 48 48h16c0 53 43 96 96 96s96-43 96-96h128c0 53 43 96 96 96s96-43 96-96h48c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zM160 464c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48zm144-248c0 4.4-3.6 8-8 8h-56v56c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8v-56h-56c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h56v-56c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v56h56c4.4 0 8 3.6 8 8v48zm176 248c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48zm80-208H416V144h44.1l99.9 99.9V256z"
                }
            }
        ]
    })(props);
}
function FaAmericanSignLanguageInterpreting(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M290.547 189.039c-20.295-10.149-44.147-11.199-64.739-3.89 42.606 0 71.208 20.475 85.578 50.576 8.576 17.899-5.148 38.071-23.617 38.071 18.429 0 32.211 20.136 23.617 38.071-14.725 30.846-46.123 50.854-80.298 50.854-.557 0-94.471-8.615-94.471-8.615l-66.406 33.347c-9.384 4.693-19.815.379-23.895-7.781L1.86 290.747c-4.167-8.615-1.111-18.897 6.946-23.621l58.072-33.069L108 159.861c6.39-57.245 34.731-109.767 79.743-146.726 11.391-9.448 28.341-7.781 37.51 3.613 9.446 11.394 7.78 28.067-3.612 37.516-12.503 10.559-23.618 22.509-32.509 35.57 21.672-14.729 46.679-24.732 74.186-28.067 14.725-1.945 28.063 8.336 29.73 23.065 1.945 14.728-8.336 28.067-23.062 29.734-16.116 1.945-31.12 7.503-44.178 15.284 26.114-5.713 58.712-3.138 88.079 11.115 13.336 6.669 18.893 22.509 12.224 35.848-6.389 13.06-22.504 18.617-35.564 12.226zm-27.229 69.472c-6.112-12.505-18.338-20.286-32.231-20.286a35.46 35.46 0 0 0-35.565 35.57c0 21.428 17.808 35.57 35.565 35.57 13.893 0 26.119-7.781 32.231-20.286 4.446-9.449 13.614-15.006 23.339-15.284-9.725-.277-18.893-5.835-23.339-15.284zm374.821-37.237c4.168 8.615 1.111 18.897-6.946 23.621l-58.071 33.069L532 352.16c-6.39 57.245-34.731 109.767-79.743 146.726-10.932 9.112-27.799 8.144-37.51-3.613-9.446-11.394-7.78-28.067 3.613-37.516 12.503-10.559 23.617-22.509 32.508-35.57-21.672 14.729-46.679 24.732-74.186 28.067-10.021 2.506-27.552-5.643-29.73-23.065-1.945-14.728 8.336-28.067 23.062-29.734 16.116-1.946 31.12-7.503 44.178-15.284-26.114 5.713-58.712 3.138-88.079-11.115-13.336-6.669-18.893-22.509-12.224-35.848 6.389-13.061 22.505-18.619 35.565-12.227 20.295 10.149 44.147 11.199 64.739 3.89-42.606 0-71.208-20.475-85.578-50.576-8.576-17.899 5.148-38.071 23.617-38.071-18.429 0-32.211-20.136-23.617-38.071 14.033-29.396 44.039-50.887 81.966-50.854l92.803 8.615 66.406-33.347c9.408-4.704 19.828-.354 23.894 7.781l44.455 88.926zm-229.227-18.618c-13.893 0-26.119 7.781-32.231 20.286-4.446 9.449-13.614 15.006-23.339 15.284 9.725.278 18.893 5.836 23.339 15.284 6.112 12.505 18.338 20.286 32.231 20.286a35.46 35.46 0 0 0 35.565-35.57c0-21.429-17.808-35.57-35.565-35.57z"
                }
            }
        ]
    })(props);
}
function FaAnchor(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.971 352h32.394C67.172 454.735 181.944 512 288 512c106.229 0 220.853-57.38 242.635-160h32.394c10.691 0 16.045-12.926 8.485-20.485l-67.029-67.029c-4.686-4.686-12.284-4.686-16.971 0l-67.029 67.029c-7.56 7.56-2.206 20.485 8.485 20.485h35.146c-20.29 54.317-84.963 86.588-144.117 94.015V256h52c6.627 0 12-5.373 12-12v-40c0-6.627-5.373-12-12-12h-52v-5.47c37.281-13.178 63.995-48.725 64-90.518C384.005 43.772 341.605.738 289.37.01 235.723-.739 192 42.525 192 96c0 41.798 26.716 77.35 64 90.53V192h-52c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h52v190.015c-58.936-7.399-123.82-39.679-144.117-94.015h35.146c10.691 0 16.045-12.926 8.485-20.485l-67.029-67.029c-4.686-4.686-12.284-4.686-16.971 0L4.485 331.515C-3.074 339.074 2.28 352 12.971 352zM288 64c17.645 0 32 14.355 32 32s-14.355 32-32 32-32-14.355-32-32 14.355-32 32-32z"
                }
            }
        ]
    })(props);
}
function FaAngleDoubleDown(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 320 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M143 256.3L7 120.3c-9.4-9.4-9.4-24.6 0-33.9l22.6-22.6c9.4-9.4 24.6-9.4 33.9 0l96.4 96.4 96.4-96.4c9.4-9.4 24.6-9.4 33.9 0L313 86.3c9.4 9.4 9.4 24.6 0 33.9l-136 136c-9.4 9.5-24.6 9.5-34 .1zm34 192l136-136c9.4-9.4 9.4-24.6 0-33.9l-22.6-22.6c-9.4-9.4-24.6-9.4-33.9 0L160 352.1l-96.4-96.4c-9.4-9.4-24.6-9.4-33.9 0L7 278.3c-9.4 9.4-9.4 24.6 0 33.9l136 136c9.4 9.5 24.6 9.5 34 .1z"
                }
            }
        ]
    })(props);
}
function FaAngleDoubleLeft(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M223.7 239l136-136c9.4-9.4 24.6-9.4 33.9 0l22.6 22.6c9.4 9.4 9.4 24.6 0 33.9L319.9 256l96.4 96.4c9.4 9.4 9.4 24.6 0 33.9L393.7 409c-9.4 9.4-24.6 9.4-33.9 0l-136-136c-9.5-9.4-9.5-24.6-.1-34zm-192 34l136 136c9.4 9.4 24.6 9.4 33.9 0l22.6-22.6c9.4-9.4 9.4-24.6 0-33.9L127.9 256l96.4-96.4c9.4-9.4 9.4-24.6 0-33.9L201.7 103c-9.4-9.4-24.6-9.4-33.9 0l-136 136c-9.5 9.4-9.5 24.6-.1 34z"
                }
            }
        ]
    })(props);
}
function FaAngleDoubleRight(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M224.3 273l-136 136c-9.4 9.4-24.6 9.4-33.9 0l-22.6-22.6c-9.4-9.4-9.4-24.6 0-33.9l96.4-96.4-96.4-96.4c-9.4-9.4-9.4-24.6 0-33.9L54.3 103c9.4-9.4 24.6-9.4 33.9 0l136 136c9.5 9.4 9.5 24.6.1 34zm192-34l-136-136c-9.4-9.4-24.6-9.4-33.9 0l-22.6 22.6c-9.4 9.4-9.4 24.6 0 33.9l96.4 96.4-96.4 96.4c-9.4 9.4-9.4 24.6 0 33.9l22.6 22.6c9.4 9.4 24.6 9.4 33.9 0l136-136c9.4-9.2 9.4-24.4 0-33.8z"
                }
            }
        ]
    })(props);
}
function FaAngleDoubleUp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 320 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M177 255.7l136 136c9.4 9.4 9.4 24.6 0 33.9l-22.6 22.6c-9.4 9.4-24.6 9.4-33.9 0L160 351.9l-96.4 96.4c-9.4 9.4-24.6 9.4-33.9 0L7 425.7c-9.4-9.4-9.4-24.6 0-33.9l136-136c9.4-9.5 24.6-9.5 34-.1zm-34-192L7 199.7c-9.4 9.4-9.4 24.6 0 33.9l22.6 22.6c9.4 9.4 24.6 9.4 33.9 0l96.4-96.4 96.4 96.4c9.4 9.4 24.6 9.4 33.9 0l22.6-22.6c9.4-9.4 9.4-24.6 0-33.9l-136-136c-9.2-9.4-24.4-9.4-33.8 0z"
                }
            }
        ]
    })(props);
}
function FaAngleDown(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 320 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M143 352.3L7 216.3c-9.4-9.4-9.4-24.6 0-33.9l22.6-22.6c9.4-9.4 24.6-9.4 33.9 0l96.4 96.4 96.4-96.4c9.4-9.4 24.6-9.4 33.9 0l22.6 22.6c9.4 9.4 9.4 24.6 0 33.9l-136 136c-9.2 9.4-24.4 9.4-33.8 0z"
                }
            }
        ]
    })(props);
}
function FaAngleLeft(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 256 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M31.7 239l136-136c9.4-9.4 24.6-9.4 33.9 0l22.6 22.6c9.4 9.4 9.4 24.6 0 33.9L127.9 256l96.4 96.4c9.4 9.4 9.4 24.6 0 33.9L201.7 409c-9.4 9.4-24.6 9.4-33.9 0l-136-136c-9.5-9.4-9.5-24.6-.1-34z"
                }
            }
        ]
    })(props);
}
function FaAngleRight(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 256 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M224.3 273l-136 136c-9.4 9.4-24.6 9.4-33.9 0l-22.6-22.6c-9.4-9.4-9.4-24.6 0-33.9l96.4-96.4-96.4-96.4c-9.4-9.4-9.4-24.6 0-33.9L54.3 103c9.4-9.4 24.6-9.4 33.9 0l136 136c9.5 9.4 9.5 24.6.1 34z"
                }
            }
        ]
    })(props);
}
function FaAngleUp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 320 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M177 159.7l136 136c9.4 9.4 9.4 24.6 0 33.9l-22.6 22.6c-9.4 9.4-24.6 9.4-33.9 0L160 255.9l-96.4 96.4c-9.4 9.4-24.6 9.4-33.9 0L7 329.7c-9.4-9.4-9.4-24.6 0-33.9l136-136c9.4-9.5 24.6-9.5 34-.1z"
                }
            }
        ]
    })(props);
}
function FaAngry(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zM136 240c0-9.3 4.1-17.5 10.5-23.4l-31-9.3c-8.5-2.5-13.3-11.5-10.7-19.9 2.5-8.5 11.4-13.2 19.9-10.7l80 24c8.5 2.5 13.3 11.5 10.7 19.9-2.1 6.9-8.4 11.4-15.3 11.4-.5 0-1.1-.2-1.7-.2.7 2.7 1.7 5.3 1.7 8.2 0 17.7-14.3 32-32 32S136 257.7 136 240zm168 154.2c-27.8-33.4-84.2-33.4-112.1 0-13.5 16.3-38.2-4.2-24.6-20.5 20-24 49.4-37.8 80.6-37.8s60.6 13.8 80.6 37.8c13.8 16.5-11.1 36.6-24.5 20.5zm76.6-186.9l-31 9.3c6.3 5.8 10.5 14.1 10.5 23.4 0 17.7-14.3 32-32 32s-32-14.3-32-32c0-2.9.9-5.6 1.7-8.2-.6.1-1.1.2-1.7.2-6.9 0-13.2-4.5-15.3-11.4-2.5-8.5 2.3-17.4 10.7-19.9l80-24c8.4-2.5 17.4 2.3 19.9 10.7 2.5 8.5-2.3 17.4-10.8 19.9z"
                }
            }
        ]
    })(props);
}
function FaAnkh(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 320 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M296 256h-44.62C272.46 222.01 288 181.65 288 144 288 55.63 230.69 0 160 0S32 55.63 32 144c0 37.65 15.54 78.01 36.62 112H24c-13.25 0-24 10.74-24 24v32c0 13.25 10.75 24 24 24h96v152c0 13.25 10.75 24 24 24h32c13.25 0 24-10.75 24-24V336h96c13.25 0 24-10.75 24-24v-32c0-13.26-10.75-24-24-24zM160 80c29.61 0 48 24.52 48 64 0 34.66-27.14 78.14-48 100.87-20.86-22.72-48-66.21-48-100.87 0-39.48 18.39-64 48-64z"
                }
            }
        ]
    })(props);
}
function FaAppleAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M350.85 129c25.97 4.67 47.27 18.67 63.92 42 14.65 20.67 24.64 46.67 29.96 78 4.67 28.67 4.32 57.33-1 86-7.99 47.33-23.97 87-47.94 119-28.64 38.67-64.59 58-107.87 58-10.66 0-22.3-3.33-34.96-10-8.66-5.33-18.31-8-28.97-8s-20.3 2.67-28.97 8c-12.66 6.67-24.3 10-34.96 10-43.28 0-79.23-19.33-107.87-58-23.97-32-39.95-71.67-47.94-119-5.32-28.67-5.67-57.33-1-86 5.32-31.33 15.31-57.33 29.96-78 16.65-23.33 37.95-37.33 63.92-42 15.98-2.67 37.95-.33 65.92 7 23.97 6.67 44.28 14.67 60.93 24 16.65-9.33 36.96-17.33 60.93-24 27.98-7.33 49.96-9.67 65.94-7zm-54.94-41c-9.32 8.67-21.65 15-36.96 19-10.66 3.33-22.3 5-34.96 5l-14.98-1c-1.33-9.33-1.33-20 0-32 2.67-24 10.32-42.33 22.97-55 9.32-8.67 21.65-15 36.96-19 10.66-3.33 22.3-5 34.96-5l14.98 1 1 15c0 12.67-1.67 24.33-4.99 35-3.99 15.33-10.31 27.67-18.98 37z"
                }
            }
        ]
    })(props);
}
function FaArchive(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M32 448c0 17.7 14.3 32 32 32h384c17.7 0 32-14.3 32-32V160H32v288zm160-212c0-6.6 5.4-12 12-12h104c6.6 0 12 5.4 12 12v8c0 6.6-5.4 12-12 12H204c-6.6 0-12-5.4-12-12v-8zM480 32H32C14.3 32 0 46.3 0 64v48c0 8.8 7.2 16 16 16h480c8.8 0 16-7.2 16-16V64c0-17.7-14.3-32-32-32z"
                }
            }
        ]
    })(props);
}
function FaArchway(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M560 448h-16V96H32v352H16.02c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16H176c8.84 0 16-7.16 16-16V320c0-53.02 42.98-96 96-96s96 42.98 96 96l.02 160v16c0 8.84 7.16 16 16 16H560c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16zm0-448H16C7.16 0 0 7.16 0 16v32c0 8.84 7.16 16 16 16h544c8.84 0 16-7.16 16-16V16c0-8.84-7.16-16-16-16z"
                }
            }
        ]
    })(props);
}
function FaArrowAltCircleDown(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M504 256c0 137-111 248-248 248S8 393 8 256 119 8 256 8s248 111 248 248zM212 140v116h-70.9c-10.7 0-16.1 13-8.5 20.5l114.9 114.3c4.7 4.7 12.2 4.7 16.9 0l114.9-114.3c7.6-7.6 2.2-20.5-8.5-20.5H300V140c0-6.6-5.4-12-12-12h-64c-6.6 0-12 5.4-12 12z"
                }
            }
        ]
    })(props);
}
function FaArrowAltCircleLeft(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 504C119 504 8 393 8 256S119 8 256 8s248 111 248 248-111 248-248 248zm116-292H256v-70.9c0-10.7-13-16.1-20.5-8.5L121.2 247.5c-4.7 4.7-4.7 12.2 0 16.9l114.3 114.9c7.6 7.6 20.5 2.2 20.5-8.5V300h116c6.6 0 12-5.4 12-12v-64c0-6.6-5.4-12-12-12z"
                }
            }
        ]
    })(props);
}
function FaArrowAltCircleRight(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 8c137 0 248 111 248 248S393 504 256 504 8 393 8 256 119 8 256 8zM140 300h116v70.9c0 10.7 13 16.1 20.5 8.5l114.3-114.9c4.7-4.7 4.7-12.2 0-16.9l-114.3-115c-7.6-7.6-20.5-2.2-20.5 8.5V212H140c-6.6 0-12 5.4-12 12v64c0 6.6 5.4 12 12 12z"
                }
            }
        ]
    })(props);
}
function FaArrowAltCircleUp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 256C8 119 119 8 256 8s248 111 248 248-111 248-248 248S8 393 8 256zm292 116V256h70.9c10.7 0 16.1-13 8.5-20.5L264.5 121.2c-4.7-4.7-12.2-4.7-16.9 0l-115 114.3c-7.6 7.6-2.2 20.5 8.5 20.5H212v116c0 6.6 5.4 12 12 12h64c6.6 0 12-5.4 12-12z"
                }
            }
        ]
    })(props);
}
function FaArrowCircleDown(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M504 256c0 137-111 248-248 248S8 393 8 256 119 8 256 8s248 111 248 248zm-143.6-28.9L288 302.6V120c0-13.3-10.7-24-24-24h-16c-13.3 0-24 10.7-24 24v182.6l-72.4-75.5c-9.3-9.7-24.8-9.9-34.3-.4l-10.9 11c-9.4 9.4-9.4 24.6 0 33.9L239 404.3c9.4 9.4 24.6 9.4 33.9 0l132.7-132.7c9.4-9.4 9.4-24.6 0-33.9l-10.9-11c-9.5-9.5-25-9.3-34.3.4z"
                }
            }
        ]
    })(props);
}
function FaArrowCircleLeft(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 504C119 504 8 393 8 256S119 8 256 8s248 111 248 248-111 248-248 248zm28.9-143.6L209.4 288H392c13.3 0 24-10.7 24-24v-16c0-13.3-10.7-24-24-24H209.4l75.5-72.4c9.7-9.3 9.9-24.8.4-34.3l-11-10.9c-9.4-9.4-24.6-9.4-33.9 0L107.7 239c-9.4 9.4-9.4 24.6 0 33.9l132.7 132.7c9.4 9.4 24.6 9.4 33.9 0l11-10.9c9.5-9.5 9.3-25-.4-34.3z"
                }
            }
        ]
    })(props);
}
function FaArrowCircleRight(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 8c137 0 248 111 248 248S393 504 256 504 8 393 8 256 119 8 256 8zm-28.9 143.6l75.5 72.4H120c-13.3 0-24 10.7-24 24v16c0 13.3 10.7 24 24 24h182.6l-75.5 72.4c-9.7 9.3-9.9 24.8-.4 34.3l11 10.9c9.4 9.4 24.6 9.4 33.9 0L404.3 273c9.4-9.4 9.4-24.6 0-33.9L271.6 106.3c-9.4-9.4-24.6-9.4-33.9 0l-11 10.9c-9.5 9.6-9.3 25.1.4 34.4z"
                }
            }
        ]
    })(props);
}
function FaArrowCircleUp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 256C8 119 119 8 256 8s248 111 248 248-111 248-248 248S8 393 8 256zm143.6 28.9l72.4-75.5V392c0 13.3 10.7 24 24 24h16c13.3 0 24-10.7 24-24V209.4l72.4 75.5c9.3 9.7 24.8 9.9 34.3.4l10.9-11c9.4-9.4 9.4-24.6 0-33.9L273 107.7c-9.4-9.4-24.6-9.4-33.9 0L106.3 240.4c-9.4 9.4-9.4 24.6 0 33.9l10.9 11c9.6 9.5 25.1 9.3 34.4-.4z"
                }
            }
        ]
    })(props);
}
function FaArrowDown(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M413.1 222.5l22.2 22.2c9.4 9.4 9.4 24.6 0 33.9L241 473c-9.4 9.4-24.6 9.4-33.9 0L12.7 278.6c-9.4-9.4-9.4-24.6 0-33.9l22.2-22.2c9.5-9.5 25-9.3 34.3.4L184 343.4V56c0-13.3 10.7-24 24-24h32c13.3 0 24 10.7 24 24v287.4l114.8-120.5c9.3-9.8 24.8-10 34.3-.4z"
                }
            }
        ]
    })(props);
}
function FaArrowLeft(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M257.5 445.1l-22.2 22.2c-9.4 9.4-24.6 9.4-33.9 0L7 273c-9.4-9.4-9.4-24.6 0-33.9L201.4 44.7c9.4-9.4 24.6-9.4 33.9 0l22.2 22.2c9.5 9.5 9.3 25-.4 34.3L136.6 216H424c13.3 0 24 10.7 24 24v32c0 13.3-10.7 24-24 24H136.6l120.5 114.8c9.8 9.3 10 24.8.4 34.3z"
                }
            }
        ]
    })(props);
}
function FaArrowRight(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M190.5 66.9l22.2-22.2c9.4-9.4 24.6-9.4 33.9 0L441 239c9.4 9.4 9.4 24.6 0 33.9L246.6 467.3c-9.4 9.4-24.6 9.4-33.9 0l-22.2-22.2c-9.5-9.5-9.3-25 .4-34.3L311.4 296H24c-13.3 0-24-10.7-24-24v-32c0-13.3 10.7-24 24-24h287.4L190.9 101.2c-9.8-9.3-10-24.8-.4-34.3z"
                }
            }
        ]
    })(props);
}
function FaArrowUp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M34.9 289.5l-22.2-22.2c-9.4-9.4-9.4-24.6 0-33.9L207 39c9.4-9.4 24.6-9.4 33.9 0l194.3 194.3c9.4 9.4 9.4 24.6 0 33.9L413 289.4c-9.5 9.5-25 9.3-34.3-.4L264 168.6V456c0 13.3-10.7 24-24 24h-32c-13.3 0-24-10.7-24-24V168.6L69.2 289.1c-9.3 9.8-24.8 10-34.3.4z"
                }
            }
        ]
    })(props);
}
function FaArrowsAltH(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M377.941 169.941V216H134.059v-46.059c0-21.382-25.851-32.09-40.971-16.971L7.029 239.029c-9.373 9.373-9.373 24.568 0 33.941l86.059 86.059c15.119 15.119 40.971 4.411 40.971-16.971V296h243.882v46.059c0 21.382 25.851 32.09 40.971 16.971l86.059-86.059c9.373-9.373 9.373-24.568 0-33.941l-86.059-86.059c-15.119-15.12-40.971-4.412-40.971 16.97z"
                }
            }
        ]
    })(props);
}
function FaArrowsAltV(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 256 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M214.059 377.941H168V134.059h46.059c21.382 0 32.09-25.851 16.971-40.971L144.971 7.029c-9.373-9.373-24.568-9.373-33.941 0L24.971 93.088c-15.119 15.119-4.411 40.971 16.971 40.971H88v243.882H41.941c-21.382 0-32.09 25.851-16.971 40.971l86.059 86.059c9.373 9.373 24.568 9.373 33.941 0l86.059-86.059c15.12-15.119 4.412-40.971-16.97-40.971z"
                }
            }
        ]
    })(props);
}
function FaArrowsAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M352.201 425.775l-79.196 79.196c-9.373 9.373-24.568 9.373-33.941 0l-79.196-79.196c-15.119-15.119-4.411-40.971 16.971-40.97h51.162L228 284H127.196v51.162c0 21.382-25.851 32.09-40.971 16.971L7.029 272.937c-9.373-9.373-9.373-24.569 0-33.941L86.225 159.8c15.119-15.119 40.971-4.411 40.971 16.971V228H228V127.196h-51.23c-21.382 0-32.09-25.851-16.971-40.971l79.196-79.196c9.373-9.373 24.568-9.373 33.941 0l79.196 79.196c15.119 15.119 4.411 40.971-16.971 40.971h-51.162V228h100.804v-51.162c0-21.382 25.851-32.09 40.97-16.971l79.196 79.196c9.373 9.373 9.373 24.569 0 33.941L425.773 352.2c-15.119 15.119-40.971 4.411-40.97-16.971V284H284v100.804h51.23c21.382 0 32.09 25.851 16.971 40.971z"
                }
            }
        ]
    })(props);
}
function FaAssistiveListeningSystems(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M216 260c0 15.464-12.536 28-28 28s-28-12.536-28-28c0-44.112 35.888-80 80-80s80 35.888 80 80c0 15.464-12.536 28-28 28s-28-12.536-28-28c0-13.234-10.767-24-24-24s-24 10.766-24 24zm24-176c-97.047 0-176 78.953-176 176 0 15.464 12.536 28 28 28s28-12.536 28-28c0-66.168 53.832-120 120-120s120 53.832 120 120c0 75.164-71.009 70.311-71.997 143.622L288 404c0 28.673-23.327 52-52 52-15.464 0-28 12.536-28 28s12.536 28 28 28c59.475 0 107.876-48.328 108-107.774.595-34.428 72-48.24 72-144.226 0-97.047-78.953-176-176-176zm-80 236c-17.673 0-32 14.327-32 32s14.327 32 32 32 32-14.327 32-32-14.327-32-32-32zM32 448c-17.673 0-32 14.327-32 32s14.327 32 32 32 32-14.327 32-32-14.327-32-32-32zm480-187.993c0-1.518-.012-3.025-.045-4.531C510.076 140.525 436.157 38.47 327.994 1.511c-14.633-4.998-30.549 2.809-35.55 17.442-5 14.633 2.81 30.549 17.442 35.55 85.906 29.354 144.61 110.513 146.077 201.953l.003.188c.026 1.118.033 2.236.033 3.363 0 15.464 12.536 28 28 28s28.001-12.536 28.001-28zM152.971 439.029l-80-80L39.03 392.97l80 80 33.941-33.941z"
                }
            }
        ]
    })(props);
}
function FaAsterisk(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M478.21 334.093L336 256l142.21-78.093c11.795-6.477 15.961-21.384 9.232-33.037l-19.48-33.741c-6.728-11.653-21.72-15.499-33.227-8.523L296 186.718l3.475-162.204C299.763 11.061 288.937 0 275.48 0h-38.96c-13.456 0-24.283 11.061-23.994 24.514L216 186.718 77.265 102.607c-11.506-6.976-26.499-3.13-33.227 8.523l-19.48 33.741c-6.728 11.653-2.562 26.56 9.233 33.037L176 256 33.79 334.093c-11.795 6.477-15.961 21.384-9.232 33.037l19.48 33.741c6.728 11.653 21.721 15.499 33.227 8.523L216 325.282l-3.475 162.204C212.237 500.939 223.064 512 236.52 512h38.961c13.456 0 24.283-11.061 23.995-24.514L296 325.282l138.735 84.111c11.506 6.976 26.499 3.13 33.227-8.523l19.48-33.741c6.728-11.653 2.563-26.559-9.232-33.036z"
                }
            }
        ]
    })(props);
}
function FaAt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 8C118.941 8 8 118.919 8 256c0 137.059 110.919 248 248 248 48.154 0 95.342-14.14 135.408-40.223 12.005-7.815 14.625-24.288 5.552-35.372l-10.177-12.433c-7.671-9.371-21.179-11.667-31.373-5.129C325.92 429.757 291.314 440 256 440c-101.458 0-184-82.542-184-184S154.542 72 256 72c100.139 0 184 57.619 184 160 0 38.786-21.093 79.742-58.17 83.693-17.349-.454-16.91-12.857-13.476-30.024l23.433-121.11C394.653 149.75 383.308 136 368.225 136h-44.981a13.518 13.518 0 0 0-13.432 11.993l-.01.092c-14.697-17.901-40.448-21.775-59.971-21.775-74.58 0-137.831 62.234-137.831 151.46 0 65.303 36.785 105.87 96 105.87 26.984 0 57.369-15.637 74.991-38.333 9.522 34.104 40.613 34.103 70.71 34.103C462.609 379.41 504 307.798 504 232 504 95.653 394.023 8 256 8zm-21.68 304.43c-22.249 0-36.07-15.623-36.07-40.771 0-44.993 30.779-72.729 58.63-72.729 22.292 0 35.601 15.241 35.601 40.77 0 45.061-33.875 72.73-58.161 72.73z"
                }
            }
        ]
    })(props);
}
function FaAtlas(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M318.38 208h-39.09c-1.49 27.03-6.54 51.35-14.21 70.41 27.71-13.24 48.02-39.19 53.3-70.41zm0-32c-5.29-31.22-25.59-57.17-53.3-70.41 7.68 19.06 12.72 43.38 14.21 70.41h39.09zM224 97.31c-7.69 7.45-20.77 34.42-23.43 78.69h46.87c-2.67-44.26-15.75-71.24-23.44-78.69zm-41.08 8.28c-27.71 13.24-48.02 39.19-53.3 70.41h39.09c1.49-27.03 6.53-51.35 14.21-70.41zm0 172.82c-7.68-19.06-12.72-43.38-14.21-70.41h-39.09c5.28 31.22 25.59 57.17 53.3 70.41zM247.43 208h-46.87c2.66 44.26 15.74 71.24 23.43 78.69 7.7-7.45 20.78-34.43 23.44-78.69zM448 358.4V25.6c0-16-9.6-25.6-25.6-25.6H96C41.6 0 0 41.6 0 96v320c0 54.4 41.6 96 96 96h326.4c12.8 0 25.6-9.6 25.6-25.6v-16c0-6.4-3.2-12.8-9.6-19.2-3.2-16-3.2-60.8 0-73.6 6.4-3.2 9.6-9.6 9.6-19.2zM224 64c70.69 0 128 57.31 128 128s-57.31 128-128 128S96 262.69 96 192 153.31 64 224 64zm160 384H96c-19.2 0-32-12.8-32-32s16-32 32-32h288v64z"
                }
            }
        ]
    })(props);
}
function FaAtom(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M223.99908,224a32,32,0,1,0,32.00782,32A32.06431,32.06431,0,0,0,223.99908,224Zm214.172-96c-10.877-19.5-40.50979-50.75-116.27544-41.875C300.39168,34.875,267.63386,0,223.99908,0s-76.39066,34.875-97.89653,86.125C50.3369,77.375,20.706,108.5,9.82907,128-6.54984,157.375-5.17484,201.125,34.958,256-5.17484,310.875-6.54984,354.625,9.82907,384c29.13087,52.375,101.64652,43.625,116.27348,41.875C147.60842,477.125,180.36429,512,223.99908,512s76.3926-34.875,97.89652-86.125c14.62891,1.75,87.14456,10.5,116.27544-41.875C454.55,354.625,453.175,310.875,413.04017,256,453.175,201.125,454.55,157.375,438.171,128ZM63.33886,352c-4-7.25-.125-24.75,15.00391-48.25,6.87695,6.5,14.12891,12.875,21.88087,19.125,1.625,13.75,4,27.125,6.75,40.125C82.34472,363.875,67.09081,358.625,63.33886,352Zm36.88478-162.875c-7.752,6.25-15.00392,12.625-21.88087,19.125-15.12891-23.5-19.00392-41-15.00391-48.25,3.377-6.125,16.37891-11.5,37.88478-11.5,1.75,0,3.875.375,5.75.375C104.09864,162.25,101.84864,175.625,100.22364,189.125ZM223.99908,64c9.50195,0,22.25586,13.5,33.88282,37.25-11.252,3.75-22.50391,8-33.88282,12.875-11.377-4.875-22.62892-9.125-33.88283-12.875C201.74516,77.5,214.49712,64,223.99908,64Zm0,384c-9.502,0-22.25392-13.5-33.88283-37.25,11.25391-3.75,22.50587-8,33.88283-12.875C235.378,402.75,246.62994,407,257.8819,410.75,246.25494,434.5,233.501,448,223.99908,448Zm0-112a80,80,0,1,1,80-80A80.00023,80.00023,0,0,1,223.99908,336ZM384.6593,352c-3.625,6.625-19.00392,11.875-43.63479,11,2.752-13,5.127-26.375,6.752-40.125,7.75195-6.25,15.00391-12.625,21.87891-19.125C384.7843,327.25,388.6593,344.75,384.6593,352ZM369.65538,208.25c-6.875-6.5-14.127-12.875-21.87891-19.125-1.625-13.5-3.875-26.875-6.752-40.25,1.875,0,4.002-.375,5.752-.375,21.50391,0,34.50782,5.375,37.88283,11.5C388.6593,167.25,384.7843,184.75,369.65538,208.25Z"
                }
            }
        ]
    })(props);
}
function FaAudioDescription(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M162.925 238.709l8.822 30.655h-25.606l9.041-30.652c1.277-4.421 2.651-9.994 3.872-15.245 1.22 5.251 2.594 10.823 3.871 15.242zm166.474-32.099h-14.523v98.781h14.523c29.776 0 46.175-17.678 46.175-49.776 0-32.239-17.49-49.005-46.175-49.005zM512 112v288c0 26.51-21.49 48-48 48H48c-26.51 0-48-21.49-48-48V112c0-26.51 21.49-48 48-48h416c26.51 0 48 21.49 48 48zM245.459 336.139l-57.097-168A12.001 12.001 0 0 0 177 160h-35.894a12.001 12.001 0 0 0-11.362 8.139l-57.097 168C70.003 343.922 75.789 352 84.009 352h29.133a12 12 0 0 0 11.535-8.693l8.574-29.906h51.367l8.793 29.977A12 12 0 0 0 204.926 352h29.172c8.22 0 14.006-8.078 11.361-15.861zm184.701-80.525c0-58.977-37.919-95.614-98.96-95.614h-57.366c-6.627 0-12 5.373-12 12v168c0 6.627 5.373 12 12 12H331.2c61.041 0 98.96-36.933 98.96-96.386z"
                }
            }
        ]
    })(props);
}
function FaAward(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M97.12 362.63c-8.69-8.69-4.16-6.24-25.12-11.85-9.51-2.55-17.87-7.45-25.43-13.32L1.2 448.7c-4.39 10.77 3.81 22.47 15.43 22.03l52.69-2.01L105.56 507c8 8.44 22.04 5.81 26.43-4.96l52.05-127.62c-10.84 6.04-22.87 9.58-35.31 9.58-19.5 0-37.82-7.59-51.61-21.37zM382.8 448.7l-45.37-111.24c-7.56 5.88-15.92 10.77-25.43 13.32-21.07 5.64-16.45 3.18-25.12 11.85-13.79 13.78-32.12 21.37-51.62 21.37-12.44 0-24.47-3.55-35.31-9.58L252 502.04c4.39 10.77 18.44 13.4 26.43 4.96l36.25-38.28 52.69 2.01c11.62.44 19.82-11.27 15.43-22.03zM263 340c15.28-15.55 17.03-14.21 38.79-20.14 13.89-3.79 24.75-14.84 28.47-28.98 7.48-28.4 5.54-24.97 25.95-45.75 10.17-10.35 14.14-25.44 10.42-39.58-7.47-28.38-7.48-24.42 0-52.83 3.72-14.14-.25-29.23-10.42-39.58-20.41-20.78-18.47-17.36-25.95-45.75-3.72-14.14-14.58-25.19-28.47-28.98-27.88-7.61-24.52-5.62-44.95-26.41-10.17-10.35-25-14.4-38.89-10.61-27.87 7.6-23.98 7.61-51.9 0-13.89-3.79-28.72.25-38.89 10.61-20.41 20.78-17.05 18.8-44.94 26.41-13.89 3.79-24.75 14.84-28.47 28.98-7.47 28.39-5.54 24.97-25.95 45.75-10.17 10.35-14.15 25.44-10.42 39.58 7.47 28.36 7.48 24.4 0 52.82-3.72 14.14.25 29.23 10.42 39.59 20.41 20.78 18.47 17.35 25.95 45.75 3.72 14.14 14.58 25.19 28.47 28.98C104.6 325.96 106.27 325 121 340c13.23 13.47 33.84 15.88 49.74 5.82a39.676 39.676 0 0 1 42.53 0c15.89 10.06 36.5 7.65 49.73-5.82zM97.66 175.96c0-53.03 42.24-96.02 94.34-96.02s94.34 42.99 94.34 96.02-42.24 96.02-94.34 96.02-94.34-42.99-94.34-96.02z"
                }
            }
        ]
    })(props);
}
function FaBabyCarriage(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M144.8 17c-11.3-17.8-37.2-22.8-54-9.4C35.3 51.9 0 118 0 192h256L144.8 17zM496 96h-48c-35.3 0-64 28.7-64 64v64H0c0 50.6 23 96.4 60.3 130.7C25.7 363.6 0 394.7 0 432c0 44.2 35.8 80 80 80s80-35.8 80-80c0-8.9-1.8-17.2-4.4-25.2 21.6 5.9 44.6 9.2 68.4 9.2s46.9-3.3 68.4-9.2c-2.7 8-4.4 16.3-4.4 25.2 0 44.2 35.8 80 80 80s80-35.8 80-80c0-37.3-25.7-68.4-60.3-77.3C425 320.4 448 274.6 448 224v-64h48c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zM80 464c-17.6 0-32-14.4-32-32s14.4-32 32-32 32 14.4 32 32-14.4 32-32 32zm320-32c0 17.6-14.4 32-32 32s-32-14.4-32-32 14.4-32 32-32 32 14.4 32 32z"
                }
            }
        ]
    })(props);
}
function FaBaby(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M192 160c44.2 0 80-35.8 80-80S236.2 0 192 0s-80 35.8-80 80 35.8 80 80 80zm-53.4 248.8l25.6-32-61.5-51.2L56.8 383c-11.4 14.2-11.7 34.4-.8 49l48 64c7.9 10.5 19.9 16 32 16 8.3 0 16.8-2.6 24-8 17.7-13.2 21.2-38.3 8-56l-29.4-39.2zm142.7-83.2l-61.5 51.2 25.6 32L216 448c-13.2 17.7-9.7 42.8 8 56 7.2 5.4 15.6 8 24 8 12.2 0 24.2-5.5 32-16l48-64c10.9-14.6 10.6-34.8-.8-49l-45.9-57.4zM376.7 145c-12.7-18.1-37.6-22.4-55.7-9.8l-40.6 28.5c-52.7 37-124.2 37-176.8 0L63 135.3C44.9 122.6 20 127 7.3 145-5.4 163.1-1 188 17 200.7l40.6 28.5c17 11.9 35.4 20.9 54.4 27.9V288h160v-30.8c19-7 37.4-16 54.4-27.9l40.6-28.5c18.1-12.8 22.4-37.7 9.7-55.8z"
                }
            }
        ]
    })(props);
}
function FaBackspace(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M576 64H205.26A63.97 63.97 0 0 0 160 82.75L9.37 233.37c-12.5 12.5-12.5 32.76 0 45.25L160 429.25c12 12 28.28 18.75 45.25 18.75H576c35.35 0 64-28.65 64-64V128c0-35.35-28.65-64-64-64zm-84.69 254.06c6.25 6.25 6.25 16.38 0 22.63l-22.62 22.62c-6.25 6.25-16.38 6.25-22.63 0L384 301.25l-62.06 62.06c-6.25 6.25-16.38 6.25-22.63 0l-22.62-22.62c-6.25-6.25-6.25-16.38 0-22.63L338.75 256l-62.06-62.06c-6.25-6.25-6.25-16.38 0-22.63l22.62-22.62c6.25-6.25 16.38-6.25 22.63 0L384 210.75l62.06-62.06c6.25-6.25 16.38-6.25 22.63 0l22.62 22.62c6.25 6.25 6.25 16.38 0 22.63L429.25 256l62.06 62.06z"
                }
            }
        ]
    })(props);
}
function FaBackward(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11.5 280.6l192 160c20.6 17.2 52.5 2.8 52.5-24.6V96c0-27.4-31.9-41.8-52.5-24.6l-192 160c-15.3 12.8-15.3 36.4 0 49.2zm256 0l192 160c20.6 17.2 52.5 2.8 52.5-24.6V96c0-27.4-31.9-41.8-52.5-24.6l-192 160c-15.3 12.8-15.3 36.4 0 49.2z"
                }
            }
        ]
    })(props);
}
function FaBacon(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M218.92 336.39c34.89-34.89 44.2-59.7 54.05-86 10.61-28.29 21.59-57.54 61.37-97.34s69.05-50.77 97.35-61.38c23.88-9 46.64-17.68 76.79-45.37L470.81 8.91a31 31 0 0 0-40.18-2.83c-13.64 10.1-25.15 14.39-41 20.3C247 79.52 209.26 191.29 200.65 214.1c-29.75 78.83-89.55 94.68-98.72 98.09-24.86 9.26-54.73 20.38-91.07 50.36C-3 374-3.63 395 9.07 407.61l35.76 35.51C80 410.52 107 400.15 133 390.39c26.27-9.84 51.06-19.12 85.92-54zm348-232l-35.75-35.51c-35.19 32.63-62.18 43-88.25 52.79-26.26 9.85-51.06 19.16-85.95 54s-44.19 59.69-54 86C292.33 290 281.34 319.22 241.55 359s-69 50.73-97.3 61.32c-23.86 9-46.61 17.66-76.72 45.33l37.68 37.43a31 31 0 0 0 40.18 2.82c13.6-10.06 25.09-14.34 40.94-20.24 142.2-53 180-164.1 188.94-187.69C405 219.18 464.8 203.3 474 199.86c24.87-9.27 54.74-20.4 91.11-50.41 13.89-11.4 14.52-32.45 1.82-45.05z"
                }
            }
        ]
    })(props);
}
function FaBacteria(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M272.35,226.4A17.71,17.71,0,0,0,281.46,203l-4-9.08a121.29,121.29,0,0,1,12.36-3.08A83.34,83.34,0,0,0,323.57,177l10,9a17.76,17.76,0,1,0,23.92-26.27l-9.72-8.76a83.12,83.12,0,0,0,11.65-48.18l11.85-3.51a17.73,17.73,0,1,0-10.15-34l-11.34,3.36a84,84,0,0,0-36.38-35.57l2.84-10.85a17.8,17.8,0,0,0-34.47-8.93l-2.82,10.78a83.25,83.25,0,0,0-16.74,1.1C250.83,27,240,30.22,229.1,33.39l-3.38-9.46a17.8,17.8,0,0,0-33.56,11.89l3.49,9.8a286.74,286.74,0,0,0-43.94,23.57l-6.32-8.43a17.9,17.9,0,0,0-24.94-3.6A17.69,17.69,0,0,0,116.84,82l6.45,8.61a286.59,286.59,0,0,0-34.95,35.33l-8.82-6.42a17.84,17.84,0,0,0-24.89,3.86,17.66,17.66,0,0,0,3.88,24.77l8.88,6.47a286.6,286.6,0,0,0-23,43.91l-10.48-3.59a17.73,17.73,0,1,0-11.59,33.52L32.67,232c-2.79,10-5.79,19.84-7.52,30.22a83.16,83.16,0,0,0-.82,19l-11.58,3.43a17.73,17.73,0,1,0,10.13,34l11.27-3.33a83.51,83.51,0,0,0,36.39,35.43l-2.88,11.06a17.81,17.81,0,0,0,34.48,8.92l2.87-11c1,0,2.07.26,3.1.26a83.39,83.39,0,0,0,45.65-13.88l8.59,8.8a17.77,17.77,0,0,0,25.56-24.7l-9.14-9.37a83.41,83.41,0,0,0,12.08-31.05,119.08,119.08,0,0,1,3.87-15.53l9,4.22a17.74,17.74,0,1,0,15.15-32.09l-8.8-4.11c.67-1,1.2-2.08,1.9-3.05a119.89,119.89,0,0,1,7.87-9.41,121.73,121.73,0,0,1,11.65-11.4,119.49,119.49,0,0,1,9.94-7.82c1.12-.77,2.32-1.42,3.47-2.15l3.92,8.85a17.86,17.86,0,0,0,16.32,10.58A18.14,18.14,0,0,0,272.35,226.4ZM128,256a32,32,0,1,1,32-32A32,32,0,0,1,128,256Zm80-96a16,16,0,1,1,16-16A16,16,0,0,1,208,160Zm431.26,45.3a17.79,17.79,0,0,0-17.06-12.69,17.55,17.55,0,0,0-5.08.74l-11.27,3.33a83.61,83.61,0,0,0-36.39-35.43l2.88-11.06a17.81,17.81,0,0,0-34.48-8.91l-2.87,11c-1,0-2.07-.26-3.1-.26a83.32,83.32,0,0,0-45.65,13.89l-8.59-8.81a17.77,17.77,0,0,0-25.56,24.7l9.14,9.37a83.28,83.28,0,0,0-12.08,31.06,119.34,119.34,0,0,1-3.87,15.52l-9-4.22a17.74,17.74,0,1,0-15.15,32.09l8.8,4.11c-.67,1-1.2,2.08-1.89,3.05a117.71,117.71,0,0,1-7.94,9.47,119,119,0,0,1-11.57,11.33,121.59,121.59,0,0,1-10,7.83c-1.12.77-2.32,1.42-3.47,2.15l-3.92-8.85a17.86,17.86,0,0,0-16.32-10.58,18.14,18.14,0,0,0-7.18,1.5A17.71,17.71,0,0,0,358.54,309l4,9.08a118.71,118.71,0,0,1-12.36,3.08,83.34,83.34,0,0,0-33.77,13.9l-10-9a17.77,17.77,0,1,0-23.92,26.28l9.72,8.75a83.12,83.12,0,0,0-11.65,48.18l-11.86,3.51a17.73,17.73,0,1,0,10.16,34l11.34-3.36A84,84,0,0,0,326.61,479l-2.84,10.85a17.8,17.8,0,0,0,34.47,8.93L361.06,488a83.3,83.3,0,0,0,16.74-1.1c11.37-1.89,22.24-5.07,33.1-8.24l3.38,9.46a17.8,17.8,0,0,0,33.56-11.89l-3.49-9.79a287.66,287.66,0,0,0,43.94-23.58l6.32,8.43a17.88,17.88,0,0,0,24.93,3.6A17.67,17.67,0,0,0,523.16,430l-6.45-8.61a287.37,287.37,0,0,0,34.95-35.34l8.82,6.42a17.76,17.76,0,1,0,21-28.63l-8.88-6.46a287.17,287.17,0,0,0,23-43.92l10.48,3.59a17.73,17.73,0,1,0,11.59-33.52L607.33,280c2.79-10,5.79-19.84,7.52-30.21a83.27,83.27,0,0,0,.82-19.05l11.58-3.43A17.7,17.7,0,0,0,639.26,205.3ZM416,416a32,32,0,1,1,32-32A32,32,0,0,1,416,416Z"
                }
            }
        ]
    })(props);
}
function FaBacterium(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M511,102.93A23.76,23.76,0,0,0,481.47,87l-15.12,4.48a111.85,111.85,0,0,0-48.5-47.42l3.79-14.47a23.74,23.74,0,0,0-46-11.91l-3.76,14.37a111.94,111.94,0,0,0-22.33,1.47,386.74,386.74,0,0,0-44.33,10.41l-4.3-12a23.74,23.74,0,0,0-44.75,15.85l4.3,12.05a383.4,383.4,0,0,0-58.69,31.83l-8-10.63a23.85,23.85,0,0,0-33.24-4.8,23.57,23.57,0,0,0-4.83,33.09l8,10.63a386.14,386.14,0,0,0-46.7,47.44l-11-8a23.68,23.68,0,1,0-28,38.17l11.09,8.06a383.45,383.45,0,0,0-30.92,58.75l-12.93-4.43a23.65,23.65,0,1,0-15.47,44.69l13,4.48a385.81,385.81,0,0,0-9.3,40.53A111.58,111.58,0,0,0,32.44,375L17,379.56a23.64,23.64,0,0,0,13.51,45.31l15-4.44a111.49,111.49,0,0,0,48.53,47.24l-3.85,14.75a23.66,23.66,0,0,0,17,28.83,24.7,24.7,0,0,0,6,.75,23.73,23.73,0,0,0,23-17.7L140,479.67c1.37.05,2.77.35,4.13.35A111.22,111.22,0,0,0,205,461.5l11.45,11.74a23.7,23.7,0,0,0,34.08-32.93l-12.19-12.5a111,111,0,0,0,16.11-41.4,158.69,158.69,0,0,1,5.16-20.71l12,5.64a23.66,23.66,0,1,0,20.19-42.79l-11.72-5.49c.89-1.32,1.59-2.77,2.52-4.06a157.86,157.86,0,0,1,10.46-12.49,159.5,159.5,0,0,1,15.59-15.28,162.18,162.18,0,0,1,13.23-10.4c1.5-1,3.1-1.89,4.63-2.87l5.23,11.8a23.74,23.74,0,0,0,43.48-19.08l-5.36-12.11a158.87,158.87,0,0,1,16.49-4.1,111,111,0,0,0,45-18.54l13.33,12a23.69,23.69,0,1,0,31.88-35l-12.94-11.67A110.83,110.83,0,0,0,479.21,137L495,132.32A23.61,23.61,0,0,0,511,102.93ZM160,368a48,48,0,1,1,48-48A48,48,0,0,1,160,368Zm80-136a24,24,0,1,1,24-24A24,24,0,0,1,240,232Z"
                }
            }
        ]
    })(props);
}
function FaBahai(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M496.25 202.52l-110-15.44 41.82-104.34c6.67-16.64-11.6-32.18-26.59-22.63L307.44 120 273.35 12.82C270.64 4.27 263.32 0 256 0c-7.32 0-14.64 4.27-17.35 12.82l-34.09 107.19-94.04-59.89c-14.99-9.55-33.25 5.99-26.59 22.63l41.82 104.34-110 15.43c-17.54 2.46-21.68 26.27-6.03 34.67l98.16 52.66-74.48 83.54c-10.92 12.25-1.72 30.93 13.29 30.93 1.31 0 2.67-.14 4.07-.45l108.57-23.65-4.11 112.55c-.43 11.65 8.87 19.22 18.41 19.22 5.15 0 10.39-2.21 14.2-7.18l68.18-88.9 68.18 88.9c3.81 4.97 9.04 7.18 14.2 7.18 9.54 0 18.84-7.57 18.41-19.22l-4.11-112.55 108.57 23.65c17.36 3.76 29.21-17.2 17.35-30.49l-74.48-83.54 98.16-52.66c15.64-8.39 11.5-32.2-6.04-34.66zM338.51 311.68l-51.89-11.3 1.97 53.79L256 311.68l-32.59 42.49 1.96-53.79-51.89 11.3 35.6-39.93-46.92-25.17 52.57-7.38-19.99-49.87 44.95 28.62L256 166.72l16.29 51.23 44.95-28.62-19.99 49.87 52.57 7.38-46.92 25.17 35.61 39.93z"
                }
            }
        ]
    })(props);
}
function FaBalanceScaleLeft(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M528 448H352V153.25c20.42-8.94 36.1-26.22 43.38-47.47l132-44.26c8.38-2.81 12.89-11.88 10.08-20.26l-10.17-30.34C524.48 2.54 515.41-1.97 507.03.84L389.11 40.37C375.3 16.36 349.69 0 320 0c-44.18 0-80 35.82-80 80 0 3.43.59 6.71 1.01 10.03l-128.39 43.05c-8.38 2.81-12.89 11.88-10.08 20.26l10.17 30.34c2.81 8.38 11.88 12.89 20.26 10.08l142.05-47.63c4.07 2.77 8.43 5.12 12.99 7.12V496c0 8.84 7.16 16 16 16h224c8.84 0 16-7.16 16-16v-32c-.01-8.84-7.17-16-16.01-16zm111.98-144c0-16.18 1.34-8.73-85.05-181.51-17.65-35.29-68.19-35.36-85.87 0-87.12 174.26-85.04 165.84-85.04 181.51H384c0 44.18 57.31 80 128 80s128-35.82 128-80h-.02zM440 288l72-144 72 144H440zm-269.07-37.51c-17.65-35.29-68.19-35.36-85.87 0C-2.06 424.75.02 416.33.02 432H0c0 44.18 57.31 80 128 80s128-35.82 128-80h-.02c0-16.18 1.34-8.73-85.05-181.51zM56 416l72-144 72 144H56z"
                }
            }
        ]
    })(props);
}
function FaBalanceScaleRight(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M96 464v32c0 8.84 7.16 16 16 16h224c8.84 0 16-7.16 16-16V153.25c4.56-2 8.92-4.35 12.99-7.12l142.05 47.63c8.38 2.81 17.45-1.71 20.26-10.08l10.17-30.34c2.81-8.38-1.71-17.45-10.08-20.26l-128.4-43.05c.42-3.32 1.01-6.6 1.01-10.03 0-44.18-35.82-80-80-80-29.69 0-55.3 16.36-69.11 40.37L132.96.83c-8.38-2.81-17.45 1.71-20.26 10.08l-10.17 30.34c-2.81 8.38 1.71 17.45 10.08 20.26l132 44.26c7.28 21.25 22.96 38.54 43.38 47.47V448H112c-8.84 0-16 7.16-16 16zM0 304c0 44.18 57.31 80 128 80s128-35.82 128-80h-.02c0-15.67 2.08-7.25-85.05-181.51-17.68-35.36-68.22-35.29-85.87 0C-1.32 295.27.02 287.82.02 304H0zm56-16l72-144 72 144H56zm328.02 144H384c0 44.18 57.31 80 128 80s128-35.82 128-80h-.02c0-15.67 2.08-7.25-85.05-181.51-17.68-35.36-68.22-35.29-85.87 0-86.38 172.78-85.04 165.33-85.04 181.51zM440 416l72-144 72 144H440z"
                }
            }
        ]
    })(props);
}
function FaBalanceScale(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 336h-.02c0-16.18 1.34-8.73-85.05-181.51-17.65-35.29-68.19-35.36-85.87 0C-2.06 328.75.02 320.33.02 336H0c0 44.18 57.31 80 128 80s128-35.82 128-80zM128 176l72 144H56l72-144zm511.98 160c0-16.18 1.34-8.73-85.05-181.51-17.65-35.29-68.19-35.36-85.87 0-87.12 174.26-85.04 165.84-85.04 181.51H384c0 44.18 57.31 80 128 80s128-35.82 128-80h-.02zM440 320l72-144 72 144H440zm88 128H352V153.25c23.51-10.29 41.16-31.48 46.39-57.25H528c8.84 0 16-7.16 16-16V48c0-8.84-7.16-16-16-16H383.64C369.04 12.68 346.09 0 320 0s-49.04 12.68-63.64 32H112c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h129.61c5.23 25.76 22.87 46.96 46.39 57.25V448H112c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h416c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16z"
                }
            }
        ]
    })(props);
}
function FaBan(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 8C119.034 8 8 119.033 8 256s111.034 248 248 248 248-111.034 248-248S392.967 8 256 8zm130.108 117.892c65.448 65.448 70 165.481 20.677 235.637L150.47 105.216c70.204-49.356 170.226-44.735 235.638 20.676zM125.892 386.108c-65.448-65.448-70-165.481-20.677-235.637L361.53 406.784c-70.203 49.356-170.226 44.736-235.638-20.676z"
                }
            }
        ]
    })(props);
}
function FaBandAid(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 160v192c0 35.3 28.7 64 64 64h96V96H64c-35.3 0-64 28.7-64 64zm576-64h-96v320h96c35.3 0 64-28.7 64-64V160c0-35.3-28.7-64-64-64zM192 416h256V96H192v320zm176-232c13.3 0 24 10.7 24 24s-10.7 24-24 24-24-10.7-24-24 10.7-24 24-24zm0 96c13.3 0 24 10.7 24 24s-10.7 24-24 24-24-10.7-24-24 10.7-24 24-24zm-96-96c13.3 0 24 10.7 24 24s-10.7 24-24 24-24-10.7-24-24 10.7-24 24-24zm0 96c13.3 0 24 10.7 24 24s-10.7 24-24 24-24-10.7-24-24 10.7-24 24-24z"
                }
            }
        ]
    })(props);
}
function FaBarcode(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 448V64h18v384H0zm26.857-.273V64H36v383.727h-9.143zm27.143 0V64h8.857v383.727H54zm44.857 0V64h8.857v383.727h-8.857zm36 0V64h17.714v383.727h-17.714zm44.857 0V64h8.857v383.727h-8.857zm18 0V64h8.857v383.727h-8.857zm18 0V64h8.857v383.727h-8.857zm35.715 0V64h18v383.727h-18zm44.857 0V64h18v383.727h-18zm35.999 0V64h18.001v383.727h-18.001zm36.001 0V64h18.001v383.727h-18.001zm26.857 0V64h18v383.727h-18zm45.143 0V64h26.857v383.727h-26.857zm35.714 0V64h9.143v383.727H476zm18 .273V64h18v384h-18z"
                }
            }
        ]
    })(props);
}
function FaBars(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 132h416c8.837 0 16-7.163 16-16V76c0-8.837-7.163-16-16-16H16C7.163 60 0 67.163 0 76v40c0 8.837 7.163 16 16 16zm0 160h416c8.837 0 16-7.163 16-16v-40c0-8.837-7.163-16-16-16H16c-8.837 0-16 7.163-16 16v40c0 8.837 7.163 16 16 16zm0 160h416c8.837 0 16-7.163 16-16v-40c0-8.837-7.163-16-16-16H16c-8.837 0-16 7.163-16 16v40c0 8.837 7.163 16 16 16z"
                }
            }
        ]
    })(props);
}
function FaBaseballBall(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M368.5 363.9l28.8-13.9c11.1 22.9 26 43.2 44.1 60.9 34-42.5 54.5-96.3 54.5-154.9 0-58.5-20.4-112.2-54.2-154.6-17.8 17.3-32.6 37.1-43.6 59.5l-28.7-14.1c12.8-26 30-49 50.8-69C375.6 34.7 315 8 248 8 181.1 8 120.5 34.6 75.9 77.7c20.7 19.9 37.9 42.9 50.7 68.8l-28.7 14.1c-11-22.3-25.7-42.1-43.5-59.4C20.4 143.7 0 197.4 0 256c0 58.6 20.4 112.3 54.4 154.7 18.2-17.7 33.2-38 44.3-61l28.8 13.9c-12.9 26.7-30.3 50.3-51.5 70.7 44.5 43.1 105.1 69.7 172 69.7 66.8 0 127.3-26.5 171.9-69.5-21.1-20.4-38.5-43.9-51.4-70.6zm-228.3-32l-30.5-9.8c14.9-46.4 12.7-93.8-.6-134l30.4-10c15 45.6 18 99.9.7 153.8zm216.3-153.4l30.4 10c-13.2 40.1-15.5 87.5-.6 134l-30.5 9.8c-17.3-54-14.3-108.3.7-153.8z"
                }
            }
        ]
    })(props);
}
function FaBasketballBall(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M212.3 10.3c-43.8 6.3-86.2 24.1-122.2 53.8l77.4 77.4c27.8-35.8 43.3-81.2 44.8-131.2zM248 222L405.9 64.1c-42.4-35-93.6-53.5-145.5-56.1-1.2 63.9-21.5 122.3-58.7 167.7L248 222zM56.1 98.1c-29.7 36-47.5 78.4-53.8 122.2 50-1.5 95.5-17 131.2-44.8L56.1 98.1zm272.2 204.2c45.3-37.1 103.7-57.4 167.7-58.7-2.6-51.9-21.1-103.1-56.1-145.5L282 256l46.3 46.3zM248 290L90.1 447.9c42.4 34.9 93.6 53.5 145.5 56.1 1.3-64 21.6-122.4 58.7-167.7L248 290zm191.9 123.9c29.7-36 47.5-78.4 53.8-122.2-50.1 1.6-95.5 17.1-131.2 44.8l77.4 77.4zM167.7 209.7C122.3 246.9 63.9 267.3 0 268.4c2.6 51.9 21.1 103.1 56.1 145.5L214 256l-46.3-46.3zm116 292c43.8-6.3 86.2-24.1 122.2-53.8l-77.4-77.4c-27.7 35.7-43.2 81.2-44.8 131.2z"
                }
            }
        ]
    })(props);
}
function FaBath(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M32,384a95.4,95.4,0,0,0,32,71.09V496a16,16,0,0,0,16,16h32a16,16,0,0,0,16-16V480H384v16a16,16,0,0,0,16,16h32a16,16,0,0,0,16-16V455.09A95.4,95.4,0,0,0,480,384V336H32ZM496,256H80V69.25a21.26,21.26,0,0,1,36.28-15l19.27,19.26c-13.13,29.88-7.61,59.11,8.62,79.73l-.17.17A16,16,0,0,0,144,176l11.31,11.31a16,16,0,0,0,22.63,0L283.31,81.94a16,16,0,0,0,0-22.63L272,48a16,16,0,0,0-22.62,0l-.17.17c-20.62-16.23-49.83-21.75-79.73-8.62L150.22,20.28A69.25,69.25,0,0,0,32,69.25V256H16A16,16,0,0,0,0,272v16a16,16,0,0,0,16,16H496a16,16,0,0,0,16-16V272A16,16,0,0,0,496,256Z"
                }
            }
        ]
    })(props);
}
function FaBatteryEmpty(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M544 160v64h32v64h-32v64H64V160h480m16-64H48c-26.51 0-48 21.49-48 48v224c0 26.51 21.49 48 48 48h512c26.51 0 48-21.49 48-48v-16h8c13.255 0 24-10.745 24-24V184c0-13.255-10.745-24-24-24h-8v-16c0-26.51-21.49-48-48-48z"
                }
            }
        ]
    })(props);
}
function FaBatteryFull(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M544 160v64h32v64h-32v64H64V160h480m16-64H48c-26.51 0-48 21.49-48 48v224c0 26.51 21.49 48 48 48h512c26.51 0 48-21.49 48-48v-16h8c13.255 0 24-10.745 24-24V184c0-13.255-10.745-24-24-24h-8v-16c0-26.51-21.49-48-48-48zm-48 96H96v128h416V192z"
                }
            }
        ]
    })(props);
}
function FaBatteryHalf(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M544 160v64h32v64h-32v64H64V160h480m16-64H48c-26.51 0-48 21.49-48 48v224c0 26.51 21.49 48 48 48h512c26.51 0 48-21.49 48-48v-16h8c13.255 0 24-10.745 24-24V184c0-13.255-10.745-24-24-24h-8v-16c0-26.51-21.49-48-48-48zm-240 96H96v128h224V192z"
                }
            }
        ]
    })(props);
}
function FaBatteryQuarter(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M544 160v64h32v64h-32v64H64V160h480m16-64H48c-26.51 0-48 21.49-48 48v224c0 26.51 21.49 48 48 48h512c26.51 0 48-21.49 48-48v-16h8c13.255 0 24-10.745 24-24V184c0-13.255-10.745-24-24-24h-8v-16c0-26.51-21.49-48-48-48zm-336 96H96v128h128V192z"
                }
            }
        ]
    })(props);
}
function FaBatteryThreeQuarters(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M544 160v64h32v64h-32v64H64V160h480m16-64H48c-26.51 0-48 21.49-48 48v224c0 26.51 21.49 48 48 48h512c26.51 0 48-21.49 48-48v-16h8c13.255 0 24-10.745 24-24V184c0-13.255-10.745-24-24-24h-8v-16c0-26.51-21.49-48-48-48zm-144 96H96v128h320V192z"
                }
            }
        ]
    })(props);
}
function FaBed(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M176 256c44.11 0 80-35.89 80-80s-35.89-80-80-80-80 35.89-80 80 35.89 80 80 80zm352-128H304c-8.84 0-16 7.16-16 16v144H64V80c0-8.84-7.16-16-16-16H16C7.16 64 0 71.16 0 80v352c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16v-48h512v48c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16V240c0-61.86-50.14-112-112-112z"
                }
            }
        ]
    })(props);
}
function FaBeer(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M368 96h-48V56c0-13.255-10.745-24-24-24H24C10.745 32 0 42.745 0 56v400c0 13.255 10.745 24 24 24h272c13.255 0 24-10.745 24-24v-42.11l80.606-35.977C429.396 365.063 448 336.388 448 304.86V176c0-44.112-35.888-80-80-80zm16 208.86a16.018 16.018 0 0 1-9.479 14.611L320 343.805V160h48c8.822 0 16 7.178 16 16v128.86zM208 384c-8.836 0-16-7.164-16-16V144c0-8.836 7.164-16 16-16s16 7.164 16 16v224c0 8.836-7.164 16-16 16zm-96 0c-8.836 0-16-7.164-16-16V144c0-8.836 7.164-16 16-16s16 7.164 16 16v224c0 8.836-7.164 16-16 16z"
                }
            }
        ]
    })(props);
}
function FaBellSlash(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M633.82 458.1l-90.62-70.05c.19-1.38.8-2.66.8-4.06.05-7.55-2.61-15.27-8.61-21.71-19.32-20.76-55.47-51.99-55.47-154.29 0-77.7-54.48-139.9-127.94-155.16V32c0-17.67-14.32-32-31.98-32s-31.98 14.33-31.98 32v20.84c-40.33 8.38-74.66 31.07-97.59 62.57L45.47 3.37C38.49-2.05 28.43-.8 23.01 6.18L3.37 31.45C-2.05 38.42-.8 48.47 6.18 53.9l588.35 454.73c6.98 5.43 17.03 4.17 22.46-2.81l19.64-25.27c5.42-6.97 4.17-17.02-2.81-22.45zM157.23 251.54c-8.61 67.96-36.41 93.33-52.62 110.75-6 6.45-8.66 14.16-8.61 21.71.11 16.4 12.98 32 32.1 32h241.92L157.23 251.54zM320 512c35.32 0 63.97-28.65 63.97-64H256.03c0 35.35 28.65 64 63.97 64z"
                }
            }
        ]
    })(props);
}
function FaBell(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M224 512c35.32 0 63.97-28.65 63.97-64H160.03c0 35.35 28.65 64 63.97 64zm215.39-149.71c-19.32-20.76-55.47-51.99-55.47-154.29 0-77.7-54.48-139.9-127.94-155.16V32c0-17.67-14.32-32-31.98-32s-31.98 14.33-31.98 32v20.84C118.56 68.1 64.08 130.3 64.08 208c0 102.3-36.15 133.53-55.47 154.29-6 6.45-8.66 14.16-8.61 21.71.11 16.4 12.98 32 32.1 32h383.8c19.12 0 32-15.6 32.1-32 .05-7.55-2.61-15.27-8.61-21.71z"
                }
            }
        ]
    })(props);
}
function FaBezierCurve(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M368 32h-96c-17.67 0-32 14.33-32 32v96c0 17.67 14.33 32 32 32h96c17.67 0 32-14.33 32-32V64c0-17.67-14.33-32-32-32zM208 88h-84.75C113.75 64.56 90.84 48 64 48 28.66 48 0 76.65 0 112s28.66 64 64 64c26.84 0 49.75-16.56 59.25-40h79.73c-55.37 32.52-95.86 87.32-109.54 152h49.4c11.3-41.61 36.77-77.21 71.04-101.56-3.7-8.08-5.88-16.99-5.88-26.44V88zm-48 232H64c-17.67 0-32 14.33-32 32v96c0 17.67 14.33 32 32 32h96c17.67 0 32-14.33 32-32v-96c0-17.67-14.33-32-32-32zM576 48c-26.84 0-49.75 16.56-59.25 40H432v72c0 9.45-2.19 18.36-5.88 26.44 34.27 24.35 59.74 59.95 71.04 101.56h49.4c-13.68-64.68-54.17-119.48-109.54-152h79.73c9.5 23.44 32.41 40 59.25 40 35.34 0 64-28.65 64-64s-28.66-64-64-64zm0 272h-96c-17.67 0-32 14.33-32 32v96c0 17.67 14.33 32 32 32h96c17.67 0 32-14.33 32-32v-96c0-17.67-14.33-32-32-32z"
                }
            }
        ]
    })(props);
}
function FaBible(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M448 358.4V25.6c0-16-9.6-25.6-25.6-25.6H96C41.6 0 0 41.6 0 96v320c0 54.4 41.6 96 96 96h326.4c12.8 0 25.6-9.6 25.6-25.6v-16c0-6.4-3.2-12.8-9.6-19.2-3.2-16-3.2-60.8 0-73.6 6.4-3.2 9.6-9.6 9.6-19.2zM144 144c0-8.84 7.16-16 16-16h48V80c0-8.84 7.16-16 16-16h32c8.84 0 16 7.16 16 16v48h48c8.84 0 16 7.16 16 16v32c0 8.84-7.16 16-16 16h-48v112c0 8.84-7.16 16-16 16h-32c-8.84 0-16-7.16-16-16V192h-48c-8.84 0-16-7.16-16-16v-32zm236.8 304H96c-19.2 0-32-12.8-32-32s16-32 32-32h284.8v64z"
                }
            }
        ]
    })(props);
}
function FaBicycle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M512.509 192.001c-16.373-.064-32.03 2.955-46.436 8.495l-77.68-125.153A24 24 0 0 0 368.001 64h-64c-8.837 0-16 7.163-16 16v16c0 8.837 7.163 16 16 16h50.649l14.896 24H256.002v-16c0-8.837-7.163-16-16-16h-87.459c-13.441 0-24.777 10.999-24.536 24.437.232 13.044 10.876 23.563 23.995 23.563h48.726l-29.417 47.52c-13.433-4.83-27.904-7.483-42.992-7.52C58.094 191.83.412 249.012.002 319.236-.413 390.279 57.055 448 128.002 448c59.642 0 109.758-40.793 123.967-96h52.033a24 24 0 0 0 20.406-11.367L410.37 201.77l14.938 24.067c-25.455 23.448-41.385 57.081-41.307 94.437.145 68.833 57.899 127.051 126.729 127.719 70.606.685 128.181-55.803 129.255-125.996 1.086-70.941-56.526-129.72-127.476-129.996zM186.75 265.772c9.727 10.529 16.673 23.661 19.642 38.228h-43.306l23.664-38.228zM128.002 400c-44.112 0-80-35.888-80-80s35.888-80 80-80c5.869 0 11.586.653 17.099 1.859l-45.505 73.509C89.715 331.327 101.213 352 120.002 352h81.3c-12.37 28.225-40.562 48-73.3 48zm162.63-96h-35.624c-3.96-31.756-19.556-59.894-42.383-80.026L237.371 184h127.547l-74.286 120zm217.057 95.886c-41.036-2.165-74.049-35.692-75.627-76.755-.812-21.121 6.633-40.518 19.335-55.263l44.433 71.586c4.66 7.508 14.524 9.816 22.032 5.156l13.594-8.437c7.508-4.66 9.817-14.524 5.156-22.032l-44.468-71.643a79.901 79.901 0 0 1 19.858-2.497c44.112 0 80 35.888 80 80-.001 45.54-38.252 82.316-84.313 79.885z"
                }
            }
        ]
    })(props);
}
function FaBiking(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M400 96a48 48 0 1 0-48-48 48 48 0 0 0 48 48zm-4 121a31.9 31.9 0 0 0 20 7h64a32 32 0 0 0 0-64h-52.78L356 103a31.94 31.94 0 0 0-40.81.68l-112 96a32 32 0 0 0 3.08 50.92L288 305.12V416a32 32 0 0 0 64 0V288a32 32 0 0 0-14.25-26.62l-41.36-27.57 58.25-49.92zm116 39a128 128 0 1 0 128 128 128 128 0 0 0-128-128zm0 192a64 64 0 1 1 64-64 64 64 0 0 1-64 64zM128 256a128 128 0 1 0 128 128 128 128 0 0 0-128-128zm0 192a64 64 0 1 1 64-64 64 64 0 0 1-64 64z"
                }
            }
        ]
    })(props);
}
function FaBinoculars(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M416 48c0-8.84-7.16-16-16-16h-64c-8.84 0-16 7.16-16 16v48h96V48zM63.91 159.99C61.4 253.84 3.46 274.22 0 404v44c0 17.67 14.33 32 32 32h96c17.67 0 32-14.33 32-32V288h32V128H95.84c-17.63 0-31.45 14.37-31.93 31.99zm384.18 0c-.48-17.62-14.3-31.99-31.93-31.99H320v160h32v160c0 17.67 14.33 32 32 32h96c17.67 0 32-14.33 32-32v-44c-3.46-129.78-61.4-150.16-63.91-244.01zM176 32h-64c-8.84 0-16 7.16-16 16v48h96V48c0-8.84-7.16-16-16-16zm48 256h64V128h-64v160z"
                }
            }
        ]
    })(props);
}
function FaBiohazard(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M287.9 112c18.6 0 36.2 3.8 52.8 9.6 13.3-10.3 23.6-24.3 29.5-40.7-25.2-10.9-53-17-82.2-17-29.1 0-56.9 6-82.1 16.9 5.9 16.4 16.2 30.4 29.5 40.7 16.5-5.7 34-9.5 52.5-9.5zM163.6 438.7c12-11.8 20.4-26.4 24.5-42.4-32.9-26.4-54.8-65.3-58.9-109.6-8.5-2.8-17.2-4.6-26.4-4.6-7.6 0-15.2 1-22.5 3.1 4.1 62.8 35.8 118 83.3 153.5zm224.2-42.6c4.1 16 12.5 30.7 24.5 42.5 47.4-35.5 79.1-90.7 83-153.5-7.2-2-14.7-3-22.2-3-9.2 0-18 1.9-26.6 4.7-4.1 44.2-26 82.9-58.7 109.3zm113.5-205c-17.6-10.4-36.3-16.6-55.3-19.9 6-17.7 10-36.4 10-56.2 0-41-14.5-80.8-41-112.2-2.5-3-6.6-3.7-10-1.8-3.3 1.9-4.8 6-3.6 9.7 4.5 13.8 6.6 26.3 6.6 38.5 0 67.8-53.8 122.9-120 122.9S168 117 168 49.2c0-12.1 2.2-24.7 6.6-38.5 1.2-3.7-.3-7.8-3.6-9.7-3.4-1.9-7.5-1.2-10 1.8C134.6 34.2 120 74 120 115c0 19.8 3.9 38.5 10 56.2-18.9 3.3-37.7 9.5-55.3 19.9-34.6 20.5-61 53.3-74.3 92.4-1.3 3.7.2 7.7 3.5 9.8 3.3 2 7.5 1.3 10-1.6 9.4-10.8 19-19.1 29.2-25.1 57.3-33.9 130.8-13.7 163.9 45 33.1 58.7 13.4 134-43.9 167.9-10.2 6.1-22 10.4-35.8 13.4-3.7.8-6.4 4.2-6.4 8.1.1 4 2.7 7.3 6.5 8 39.7 7.8 80.6.8 115.2-19.7 18-10.6 32.9-24.5 45.3-40.1 12.4 15.6 27.3 29.5 45.3 40.1 34.6 20.5 75.5 27.5 115.2 19.7 3.8-.7 6.4-4 6.5-8 0-3.9-2.6-7.3-6.4-8.1-13.9-2.9-25.6-7.3-35.8-13.4-57.3-33.9-77-109.2-43.9-167.9s106.6-78.9 163.9-45c10.2 6.1 19.8 14.3 29.2 25.1 2.5 2.9 6.7 3.6 10 1.6s4.8-6.1 3.5-9.8c-13.1-39.1-39.5-72-74.1-92.4zm-213.4 129c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48z"
                }
            }
        ]
    })(props);
}
function FaBirthdayCake(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M448 384c-28.02 0-31.26-32-74.5-32-43.43 0-46.825 32-74.75 32-27.695 0-31.454-32-74.75-32-42.842 0-47.218 32-74.5 32-28.148 0-31.202-32-74.75-32-43.547 0-46.653 32-74.75 32v-80c0-26.5 21.5-48 48-48h16V112h64v144h64V112h64v144h64V112h64v144h16c26.5 0 48 21.5 48 48v80zm0 128H0v-96c43.356 0 46.767-32 74.75-32 27.951 0 31.253 32 74.75 32 42.843 0 47.217-32 74.5-32 28.148 0 31.201 32 74.75 32 43.357 0 46.767-32 74.75-32 27.488 0 31.252 32 74.5 32v96zM96 96c-17.75 0-32-14.25-32-32 0-31 32-23 32-64 12 0 32 29.5 32 56s-14.25 40-32 40zm128 0c-17.75 0-32-14.25-32-32 0-31 32-23 32-64 12 0 32 29.5 32 56s-14.25 40-32 40zm128 0c-17.75 0-32-14.25-32-32 0-31 32-23 32-64 12 0 32 29.5 32 56s-14.25 40-32 40z"
                }
            }
        ]
    })(props);
}
function FaBlenderPhone(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M392 64h166.54L576 0H192v352h288l17.46-64H392c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h114.18l17.46-64H392c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h140.36l17.46-64H392c-4.42 0-8-3.58-8-8V72c0-4.42 3.58-8 8-8zM158.8 335.01l-25.78-63.26c-2.78-6.81-9.8-10.99-17.24-10.26l-45.03 4.42c-17.28-46.94-17.65-99.78 0-147.72l45.03 4.42c7.43.73 14.46-3.46 17.24-10.26l25.78-63.26c3.02-7.39.2-15.85-6.68-20.07l-39.28-24.1C98.51-3.87 80.09-.5 68.95 11.97c-92.57 103.6-92 259.55 2.1 362.49 9.87 10.8 29.12 12.48 41.65 4.8l39.41-24.18c6.89-4.22 9.7-12.67 6.69-20.07zM480 384H192c-35.35 0-64 28.65-64 64v32c0 17.67 14.33 32 32 32h352c17.67 0 32-14.33 32-32v-32c0-35.35-28.65-64-64-64zm-144 96c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32z"
                }
            }
        ]
    })(props);
}
function FaBlender(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M416 384H160c-35.35 0-64 28.65-64 64v32c0 17.67 14.33 32 32 32h320c17.67 0 32-14.33 32-32v-32c0-35.35-28.65-64-64-64zm-128 96c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm40-416h166.54L512 0H48C21.49 0 0 21.49 0 48v160c0 26.51 21.49 48 48 48h103.27l8.73 96h256l17.46-64H328c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h114.18l17.46-64H328c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h140.36l17.46-64H328c-4.42 0-8-3.58-8-8V72c0-4.42 3.58-8 8-8zM64 192V64h69.82l11.64 128H64z"
                }
            }
        ]
    })(props);
}
function FaBlind(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M380.15 510.837a8 8 0 0 1-10.989-2.687l-125.33-206.427a31.923 31.923 0 0 0 12.958-9.485l126.048 207.608a8 8 0 0 1-2.687 10.991zM142.803 314.338l-32.54 89.485 36.12 88.285c6.693 16.36 25.377 24.192 41.733 17.501 16.357-6.692 24.193-25.376 17.501-41.734l-62.814-153.537zM96 88c24.301 0 44-19.699 44-44S120.301 0 96 0 52 19.699 52 44s19.699 44 44 44zm154.837 169.128l-120-152c-4.733-5.995-11.75-9.108-18.837-9.112V96H80v.026c-7.146.003-14.217 3.161-18.944 9.24L0 183.766v95.694c0 13.455 11.011 24.791 24.464 24.536C37.505 303.748 48 293.1 48 280v-79.766l16-20.571v140.698L9.927 469.055c-6.04 16.609 2.528 34.969 19.138 41.009 16.602 6.039 34.968-2.524 41.009-19.138L136 309.638V202.441l-31.406-39.816a4 4 0 1 1 6.269-4.971l102.3 129.217c9.145 11.584 24.368 11.339 33.708 3.965 10.41-8.216 12.159-23.334 3.966-33.708z"
                }
            }
        ]
    })(props);
}
function FaBlog(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M172.2 226.8c-14.6-2.9-28.2 8.9-28.2 23.8V301c0 10.2 7.1 18.4 16.7 22 18.2 6.8 31.3 24.4 31.3 45 0 26.5-21.5 48-48 48s-48-21.5-48-48V120c0-13.3-10.7-24-24-24H24c-13.3 0-24 10.7-24 24v248c0 89.5 82.1 160.2 175 140.7 54.4-11.4 98.3-55.4 109.7-109.7 17.4-82.9-37-157.2-112.5-172.2zM209 0c-9.2-.5-17 6.8-17 16v31.6c0 8.5 6.6 15.5 15 15.9 129.4 7 233.4 112 240.9 241.5.5 8.4 7.5 15 15.9 15h32.1c9.2 0 16.5-7.8 16-17C503.4 139.8 372.2 8.6 209 0zm.3 96c-9.3-.7-17.3 6.7-17.3 16.1v32.1c0 8.4 6.5 15.3 14.8 15.9 76.8 6.3 138 68.2 144.9 145.2.8 8.3 7.6 14.7 15.9 14.7h32.2c9.3 0 16.8-8 16.1-17.3-8.4-110.1-96.5-198.2-206.6-206.7z"
                }
            }
        ]
    })(props);
}
function FaBold(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M333.49 238a122 122 0 0 0 27-65.21C367.87 96.49 308 32 233.42 32H34a16 16 0 0 0-16 16v48a16 16 0 0 0 16 16h31.87v288H34a16 16 0 0 0-16 16v48a16 16 0 0 0 16 16h209.32c70.8 0 134.14-51.75 141-122.4 4.74-48.45-16.39-92.06-50.83-119.6zM145.66 112h87.76a48 48 0 0 1 0 96h-87.76zm87.76 288h-87.76V288h87.76a56 56 0 0 1 0 112z"
                }
            }
        ]
    })(props);
}
function FaBolt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 320 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M296 160H180.6l42.6-129.8C227.2 15 215.7 0 200 0H56C44 0 33.8 8.9 32.2 20.8l-32 240C-1.7 275.2 9.5 288 24 288h118.7L96.6 482.5c-3.6 15.2 8 29.5 23.3 29.5 8.4 0 16.4-4.4 20.8-12l176-304c9.3-15.9-2.2-36-20.7-36z"
                }
            }
        ]
    })(props);
}
function FaBomb(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M440.5 88.5l-52 52L415 167c9.4 9.4 9.4 24.6 0 33.9l-17.4 17.4c11.8 26.1 18.4 55.1 18.4 85.6 0 114.9-93.1 208-208 208S0 418.9 0 304 93.1 96 208 96c30.5 0 59.5 6.6 85.6 18.4L311 97c9.4-9.4 24.6-9.4 33.9 0l26.5 26.5 52-52 17.1 17zM500 60h-24c-6.6 0-12 5.4-12 12s5.4 12 12 12h24c6.6 0 12-5.4 12-12s-5.4-12-12-12zM440 0c-6.6 0-12 5.4-12 12v24c0 6.6 5.4 12 12 12s12-5.4 12-12V12c0-6.6-5.4-12-12-12zm33.9 55l17-17c4.7-4.7 4.7-12.3 0-17-4.7-4.7-12.3-4.7-17 0l-17 17c-4.7 4.7-4.7 12.3 0 17 4.8 4.7 12.4 4.7 17 0zm-67.8 0c4.7 4.7 12.3 4.7 17 0 4.7-4.7 4.7-12.3 0-17l-17-17c-4.7-4.7-12.3-4.7-17 0-4.7 4.7-4.7 12.3 0 17l17 17zm67.8 34c-4.7-4.7-12.3-4.7-17 0-4.7 4.7-4.7 12.3 0 17l17 17c4.7 4.7 12.3 4.7 17 0 4.7-4.7 4.7-12.3 0-17l-17-17zM112 272c0-35.3 28.7-64 64-64 8.8 0 16-7.2 16-16s-7.2-16-16-16c-52.9 0-96 43.1-96 96 0 8.8 7.2 16 16 16s16-7.2 16-16z"
                }
            }
        ]
    })(props);
}
function FaBone(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M598.88 244.56c25.2-12.6 41.12-38.36 41.12-66.53v-7.64C640 129.3 606.7 96 565.61 96c-32.02 0-60.44 20.49-70.57 50.86-7.68 23.03-11.6 45.14-38.11 45.14H183.06c-27.38 0-31.58-25.54-38.11-45.14C134.83 116.49 106.4 96 74.39 96 33.3 96 0 129.3 0 170.39v7.64c0 28.17 15.92 53.93 41.12 66.53 9.43 4.71 9.43 18.17 0 22.88C15.92 280.04 0 305.8 0 333.97v7.64C0 382.7 33.3 416 74.38 416c32.02 0 60.44-20.49 70.57-50.86 7.68-23.03 11.6-45.14 38.11-45.14h273.87c27.38 0 31.58 25.54 38.11 45.14C505.17 395.51 533.6 416 565.61 416c41.08 0 74.38-33.3 74.38-74.39v-7.64c0-28.18-15.92-53.93-41.12-66.53-9.42-4.71-9.42-18.17.01-22.88z"
                }
            }
        ]
    })(props);
}
function FaBong(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M302.5 512c23.18 0 44.43-12.58 56-32.66C374.69 451.26 384 418.75 384 384c0-36.12-10.08-69.81-27.44-98.62L400 241.94l9.38 9.38c6.25 6.25 16.38 6.25 22.63 0l11.3-11.32c6.25-6.25 6.25-16.38 0-22.63l-52.69-52.69c-6.25-6.25-16.38-6.25-22.63 0l-11.31 11.31c-6.25 6.25-6.25 16.38 0 22.63l9.38 9.38-39.41 39.41c-11.56-11.37-24.53-21.33-38.65-29.51V63.74l15.97-.02c8.82-.01 15.97-7.16 15.98-15.98l.04-31.72C320 7.17 312.82-.01 303.97 0L80.03.26c-8.82.01-15.97 7.16-15.98 15.98l-.04 31.73c-.01 8.85 7.17 16.02 16.02 16.01L96 63.96v153.93C38.67 251.1 0 312.97 0 384c0 34.75 9.31 67.27 25.5 95.34C37.08 499.42 58.33 512 81.5 512h221zM120.06 259.43L144 245.56V63.91l96-.11v181.76l23.94 13.87c24.81 14.37 44.12 35.73 56.56 60.57h-257c12.45-24.84 31.75-46.2 56.56-60.57z"
                }
            }
        ]
    })(props);
}
function FaBookDead(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M272 136c8.8 0 16-7.2 16-16s-7.2-16-16-16-16 7.2-16 16 7.2 16 16 16zm176 222.4V25.6c0-16-9.6-25.6-25.6-25.6H96C41.6 0 0 41.6 0 96v320c0 54.4 41.6 96 96 96h326.4c12.8 0 25.6-9.6 25.6-25.6v-16c0-6.4-3.2-12.8-9.6-19.2-3.2-16-3.2-60.8 0-73.6 6.4-3.2 9.6-9.6 9.6-19.2zM240 56c44.2 0 80 28.7 80 64 0 20.9-12.7 39.2-32 50.9V184c0 8.8-7.2 16-16 16h-64c-8.8 0-16-7.2-16-16v-13.1c-19.3-11.7-32-30-32-50.9 0-35.3 35.8-64 80-64zM124.8 223.3l6.3-14.7c1.7-4.1 6.4-5.9 10.5-4.2l98.3 42.1 98.4-42.1c4.1-1.7 8.8.1 10.5 4.2l6.3 14.7c1.7 4.1-.1 8.8-4.2 10.5L280.6 264l70.3 30.1c4.1 1.7 5.9 6.4 4.2 10.5l-6.3 14.7c-1.7 4.1-6.4 5.9-10.5 4.2L240 281.4l-98.3 42.2c-4.1 1.7-8.8-.1-10.5-4.2l-6.3-14.7c-1.7-4.1.1-8.8 4.2-10.5l70.4-30.1-70.5-30.3c-4.1-1.7-5.9-6.4-4.2-10.5zm256 224.7H96c-19.2 0-32-12.8-32-32s16-32 32-32h284.8zM208 136c8.8 0 16-7.2 16-16s-7.2-16-16-16-16 7.2-16 16 7.2 16 16 16z"
                }
            }
        ]
    })(props);
}
function FaBookMedical(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M448 358.4V25.6c0-16-9.6-25.6-25.6-25.6H96C41.6 0 0 41.6 0 96v320c0 54.4 41.6 96 96 96h326.4c12.8 0 25.6-9.6 25.6-25.6v-16q0-9.6-9.6-19.2c-3.2-16-3.2-60.8 0-73.6q9.6-4.8 9.6-19.2zM144 168a8 8 0 0 1 8-8h56v-56a8 8 0 0 1 8-8h48a8 8 0 0 1 8 8v56h56a8 8 0 0 1 8 8v48a8 8 0 0 1-8 8h-56v56a8 8 0 0 1-8 8h-48a8 8 0 0 1-8-8v-56h-56a8 8 0 0 1-8-8zm236.8 280H96c-19.2 0-32-12.8-32-32s16-32 32-32h284.8z"
                }
            }
        ]
    })(props);
}
function FaBookOpen(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M542.22 32.05c-54.8 3.11-163.72 14.43-230.96 55.59-4.64 2.84-7.27 7.89-7.27 13.17v363.87c0 11.55 12.63 18.85 23.28 13.49 69.18-34.82 169.23-44.32 218.7-46.92 16.89-.89 30.02-14.43 30.02-30.66V62.75c.01-17.71-15.35-31.74-33.77-30.7zM264.73 87.64C197.5 46.48 88.58 35.17 33.78 32.05 15.36 31.01 0 45.04 0 62.75V400.6c0 16.24 13.13 29.78 30.02 30.66 49.49 2.6 149.59 12.11 218.77 46.95 10.62 5.35 23.21-1.94 23.21-13.46V100.63c0-5.29-2.62-10.14-7.27-12.99z"
                }
            }
        ]
    })(props);
}
function FaBookReader(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M352 96c0-53.02-42.98-96-96-96s-96 42.98-96 96 42.98 96 96 96 96-42.98 96-96zM233.59 241.1c-59.33-36.32-155.43-46.3-203.79-49.05C13.55 191.13 0 203.51 0 219.14v222.8c0 14.33 11.59 26.28 26.49 27.05 43.66 2.29 131.99 10.68 193.04 41.43 9.37 4.72 20.48-1.71 20.48-11.87V252.56c-.01-4.67-2.32-8.95-6.42-11.46zm248.61-49.05c-48.35 2.74-144.46 12.73-203.78 49.05-4.1 2.51-6.41 6.96-6.41 11.63v245.79c0 10.19 11.14 16.63 20.54 11.9 61.04-30.72 149.32-39.11 192.97-41.4 14.9-.78 26.49-12.73 26.49-27.06V219.14c-.01-15.63-13.56-28.01-29.81-27.09z"
                }
            }
        ]
    })(props);
}
function FaBook(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M448 360V24c0-13.3-10.7-24-24-24H96C43 0 0 43 0 96v320c0 53 43 96 96 96h328c13.3 0 24-10.7 24-24v-16c0-7.5-3.5-14.3-8.9-18.7-4.2-15.4-4.2-59.3 0-74.7 5.4-4.3 8.9-11.1 8.9-18.6zM128 134c0-3.3 2.7-6 6-6h212c3.3 0 6 2.7 6 6v20c0 3.3-2.7 6-6 6H134c-3.3 0-6-2.7-6-6v-20zm0 64c0-3.3 2.7-6 6-6h212c3.3 0 6 2.7 6 6v20c0 3.3-2.7 6-6 6H134c-3.3 0-6-2.7-6-6v-20zm253.4 250H96c-17.7 0-32-14.3-32-32 0-17.6 14.4-32 32-32h285.4c-1.9 17.1-1.9 46.9 0 64z"
                }
            }
        ]
    })(props);
}
function FaBookmark(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 512V48C0 21.49 21.49 0 48 0h288c26.51 0 48 21.49 48 48v464L192 400 0 512z"
                }
            }
        ]
    })(props);
}
function FaBorderAll(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M416 32H32A32 32 0 0 0 0 64v384a32 32 0 0 0 32 32h384a32 32 0 0 0 32-32V64a32 32 0 0 0-32-32zm-32 64v128H256V96zm-192 0v128H64V96zM64 416V288h128v128zm192 0V288h128v128z"
                }
            }
        ]
    })(props);
}
function FaBorderNone(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M240 224h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm96 0h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm96 0h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm-288 0h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm96 192h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm96 0h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm96 0h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0-96h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0-192h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zM240 320h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0-192h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm-96 288h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm96-384h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16zm96 0h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16zm96 0h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16zM48 224H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0 192H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0-96H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0-192H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0-96H16A16 16 0 0 0 0 48v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16zm96 0h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16z"
                }
            }
        ]
    })(props);
}
function FaBorderStyle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M240 416h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm-96 0h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm192 0h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm96-192h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0 96h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0 96h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0-288h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0-96H32A32 32 0 0 0 0 64v400a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16V96h368a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16z"
                }
            }
        ]
    })(props);
}
function FaBowlingBall(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zM120 192c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm64-96c0-17.7 14.3-32 32-32s32 14.3 32 32-14.3 32-32 32-32-14.3-32-32zm48 144c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32z"
                }
            }
        ]
    })(props);
}
function FaBoxOpen(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M425.7 256c-16.9 0-32.8-9-41.4-23.4L320 126l-64.2 106.6c-8.7 14.5-24.6 23.5-41.5 23.5-4.5 0-9-.6-13.3-1.9L64 215v178c0 14.7 10 27.5 24.2 31l216.2 54.1c10.2 2.5 20.9 2.5 31 0L551.8 424c14.2-3.6 24.2-16.4 24.2-31V215l-137 39.1c-4.3 1.3-8.8 1.9-13.3 1.9zm212.6-112.2L586.8 41c-3.1-6.2-9.8-9.8-16.7-8.9L320 64l91.7 152.1c3.8 6.3 11.4 9.3 18.5 7.3l197.9-56.5c9.9-2.9 14.7-13.9 10.2-23.1zM53.2 41L1.7 143.8c-4.6 9.2.3 20.2 10.1 23l197.9 56.5c7.1 2 14.7-1 18.5-7.3L320 64 69.8 32.1c-6.9-.8-13.5 2.7-16.6 8.9z"
                }
            }
        ]
    })(props);
}
function FaBoxTissue(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M383.88,287.82l64-192H338.47a70.2,70.2,0,0,1-66.59-48,70.21,70.21,0,0,0-66.6-48H63.88l64,288Zm-384,192a32,32,0,0,0,32,32h448a32,32,0,0,0,32-32v-64H-.12Zm480-256H438.94l-21.33,64h14.27a16,16,0,0,1,0,32h-352a16,16,0,1,1,0-32H95.09l-14.22-64h-49a32,32,0,0,0-32,32v128h512v-128A32,32,0,0,0,479.88,223.82Z"
                }
            }
        ]
    })(props);
}
function FaBox(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M509.5 184.6L458.9 32.8C452.4 13.2 434.1 0 413.4 0H272v192h238.7c-.4-2.5-.4-5-1.2-7.4zM240 0H98.6c-20.7 0-39 13.2-45.5 32.8L2.5 184.6c-.8 2.4-.8 4.9-1.2 7.4H240V0zM0 224v240c0 26.5 21.5 48 48 48h416c26.5 0 48-21.5 48-48V224H0z"
                }
            }
        ]
    })(props);
}
function FaBoxes(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M560 288h-80v96l-32-21.3-32 21.3v-96h-80c-8.8 0-16 7.2-16 16v192c0 8.8 7.2 16 16 16h224c8.8 0 16-7.2 16-16V304c0-8.8-7.2-16-16-16zm-384-64h224c8.8 0 16-7.2 16-16V16c0-8.8-7.2-16-16-16h-80v96l-32-21.3L256 96V0h-80c-8.8 0-16 7.2-16 16v192c0 8.8 7.2 16 16 16zm64 64h-80v96l-32-21.3L96 384v-96H16c-8.8 0-16 7.2-16 16v192c0 8.8 7.2 16 16 16h224c8.8 0 16-7.2 16-16V304c0-8.8-7.2-16-16-16z"
                }
            }
        ]
    })(props);
}
function FaBraille(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M128 256c0 35.346-28.654 64-64 64S0 291.346 0 256s28.654-64 64-64 64 28.654 64 64zM64 384c-17.673 0-32 14.327-32 32s14.327 32 32 32 32-14.327 32-32-14.327-32-32-32zm0-352C28.654 32 0 60.654 0 96s28.654 64 64 64 64-28.654 64-64-28.654-64-64-64zm160 192c-17.673 0-32 14.327-32 32s14.327 32 32 32 32-14.327 32-32-14.327-32-32-32zm0 160c-17.673 0-32 14.327-32 32s14.327 32 32 32 32-14.327 32-32-14.327-32-32-32zm0-352c-35.346 0-64 28.654-64 64s28.654 64 64 64 64-28.654 64-64-28.654-64-64-64zm224 192c-17.673 0-32 14.327-32 32s14.327 32 32 32 32-14.327 32-32-14.327-32-32-32zm0 160c-17.673 0-32 14.327-32 32s14.327 32 32 32 32-14.327 32-32-14.327-32-32-32zm0-352c-35.346 0-64 28.654-64 64s28.654 64 64 64 64-28.654 64-64-28.654-64-64-64zm160 192c-17.673 0-32 14.327-32 32s14.327 32 32 32 32-14.327 32-32-14.327-32-32-32zm0 160c-17.673 0-32 14.327-32 32s14.327 32 32 32 32-14.327 32-32-14.327-32-32-32zm0-320c-17.673 0-32 14.327-32 32s14.327 32 32 32 32-14.327 32-32-14.327-32-32-32z"
                }
            }
        ]
    })(props);
}
function FaBrain(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M208 0c-29.9 0-54.7 20.5-61.8 48.2-.8 0-1.4-.2-2.2-.2-35.3 0-64 28.7-64 64 0 4.8.6 9.5 1.7 14C52.5 138 32 166.6 32 200c0 12.6 3.2 24.3 8.3 34.9C16.3 248.7 0 274.3 0 304c0 33.3 20.4 61.9 49.4 73.9-.9 4.6-1.4 9.3-1.4 14.1 0 39.8 32.2 72 72 72 4.1 0 8.1-.5 12-1.2 9.6 28.5 36.2 49.2 68 49.2 39.8 0 72-32.2 72-72V64c0-35.3-28.7-64-64-64zm368 304c0-29.7-16.3-55.3-40.3-69.1 5.2-10.6 8.3-22.3 8.3-34.9 0-33.4-20.5-62-49.7-74 1-4.5 1.7-9.2 1.7-14 0-35.3-28.7-64-64-64-.8 0-1.5.2-2.2.2C422.7 20.5 397.9 0 368 0c-35.3 0-64 28.6-64 64v376c0 39.8 32.2 72 72 72 31.8 0 58.4-20.7 68-49.2 3.9.7 7.9 1.2 12 1.2 39.8 0 72-32.2 72-72 0-4.8-.5-9.5-1.4-14.1 29-12 49.4-40.6 49.4-73.9z"
                }
            }
        ]
    })(props);
}
function FaBreadSlice(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M288 0C108 0 0 93.4 0 169.14 0 199.44 24.24 224 64 224v256c0 17.67 16.12 32 36 32h376c19.88 0 36-14.33 36-32V224c39.76 0 64-24.56 64-54.86C576 93.4 468 0 288 0z"
                }
            }
        ]
    })(props);
}
function FaBriefcaseMedical(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M464 128h-80V80c0-26.5-21.5-48-48-48H176c-26.5 0-48 21.5-48 48v48H48c-26.5 0-48 21.5-48 48v288c0 26.5 21.5 48 48 48h416c26.5 0 48-21.5 48-48V176c0-26.5-21.5-48-48-48zM192 96h128v32H192V96zm160 248c0 4.4-3.6 8-8 8h-56v56c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8v-56h-56c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h56v-56c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v56h56c4.4 0 8 3.6 8 8v48z"
                }
            }
        ]
    })(props);
}
function FaBriefcase(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M320 336c0 8.84-7.16 16-16 16h-96c-8.84 0-16-7.16-16-16v-48H0v144c0 25.6 22.4 48 48 48h416c25.6 0 48-22.4 48-48V288H320v48zm144-208h-80V80c0-25.6-22.4-48-48-48H176c-25.6 0-48 22.4-48 48v48H48c-25.6 0-48 22.4-48 48v80h512v-80c0-25.6-22.4-48-48-48zm-144 0H192V96h128v32z"
                }
            }
        ]
    })(props);
}
function FaBroadcastTower(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M150.94 192h33.73c11.01 0 18.61-10.83 14.86-21.18-4.93-13.58-7.55-27.98-7.55-42.82s2.62-29.24 7.55-42.82C203.29 74.83 195.68 64 184.67 64h-33.73c-7.01 0-13.46 4.49-15.41 11.23C130.64 92.21 128 109.88 128 128c0 18.12 2.64 35.79 7.54 52.76 1.94 6.74 8.39 11.24 15.4 11.24zM89.92 23.34C95.56 12.72 87.97 0 75.96 0H40.63c-6.27 0-12.14 3.59-14.74 9.31C9.4 45.54 0 85.65 0 128c0 24.75 3.12 68.33 26.69 118.86 2.62 5.63 8.42 9.14 14.61 9.14h34.84c12.02 0 19.61-12.74 13.95-23.37-49.78-93.32-16.71-178.15-.17-209.29zM614.06 9.29C611.46 3.58 605.6 0 599.33 0h-35.42c-11.98 0-19.66 12.66-14.02 23.25 18.27 34.29 48.42 119.42.28 209.23-5.72 10.68 1.8 23.52 13.91 23.52h35.23c6.27 0 12.13-3.58 14.73-9.29C630.57 210.48 640 170.36 640 128s-9.42-82.48-25.94-118.71zM489.06 64h-33.73c-11.01 0-18.61 10.83-14.86 21.18 4.93 13.58 7.55 27.98 7.55 42.82s-2.62 29.24-7.55 42.82c-3.76 10.35 3.85 21.18 14.86 21.18h33.73c7.02 0 13.46-4.49 15.41-11.24 4.9-16.97 7.53-34.64 7.53-52.76 0-18.12-2.64-35.79-7.54-52.76-1.94-6.75-8.39-11.24-15.4-11.24zm-116.3 100.12c7.05-10.29 11.2-22.71 11.2-36.12 0-35.35-28.63-64-63.96-64-35.32 0-63.96 28.65-63.96 64 0 13.41 4.15 25.83 11.2 36.12l-130.5 313.41c-3.4 8.15.46 17.52 8.61 20.92l29.51 12.31c8.15 3.4 17.52-.46 20.91-8.61L244.96 384h150.07l49.2 118.15c3.4 8.16 12.76 12.01 20.91 8.61l29.51-12.31c8.15-3.4 12-12.77 8.61-20.92l-130.5-313.41zM271.62 320L320 203.81 368.38 320h-96.76z"
                }
            }
        ]
    })(props);
}
function FaBroom(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256.47 216.77l86.73 109.18s-16.6 102.36-76.57 150.12C206.66 523.85 0 510.19 0 510.19s3.8-23.14 11-55.43l94.62-112.17c3.97-4.7-.87-11.62-6.65-9.5l-60.4 22.09c14.44-41.66 32.72-80.04 54.6-97.47 59.97-47.76 163.3-40.94 163.3-40.94zM636.53 31.03l-19.86-25c-5.49-6.9-15.52-8.05-22.41-2.56l-232.48 177.8-34.14-42.97c-5.09-6.41-15.14-5.21-18.59 2.21l-25.33 54.55 86.73 109.18 58.8-12.45c8-1.69 11.42-11.2 6.34-17.6l-34.09-42.92 232.48-177.8c6.89-5.48 8.04-15.53 2.55-22.44z"
                }
            }
        ]
    })(props);
}
function FaBrush(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M352 0H32C14.33 0 0 14.33 0 32v224h384V32c0-17.67-14.33-32-32-32zM0 320c0 35.35 28.66 64 64 64h64v64c0 35.35 28.66 64 64 64s64-28.65 64-64v-64h64c35.34 0 64-28.65 64-64v-32H0v32zm192 104c13.25 0 24 10.74 24 24 0 13.25-10.75 24-24 24s-24-10.75-24-24c0-13.26 10.75-24 24-24z"
                }
            }
        ]
    })(props);
}
function FaBug(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M511.988 288.9c-.478 17.43-15.217 31.1-32.653 31.1H424v16c0 21.864-4.882 42.584-13.6 61.145l60.228 60.228c12.496 12.497 12.496 32.758 0 45.255-12.498 12.497-32.759 12.496-45.256 0l-54.736-54.736C345.886 467.965 314.351 480 280 480V236c0-6.627-5.373-12-12-12h-24c-6.627 0-12 5.373-12 12v244c-34.351 0-65.886-12.035-90.636-32.108l-54.736 54.736c-12.498 12.497-32.759 12.496-45.256 0-12.496-12.497-12.496-32.758 0-45.255l60.228-60.228C92.882 378.584 88 357.864 88 336v-16H32.666C15.23 320 .491 306.33.013 288.9-.484 270.816 14.028 256 32 256h56v-58.745l-46.628-46.628c-12.496-12.497-12.496-32.758 0-45.255 12.498-12.497 32.758-12.497 45.256 0L141.255 160h229.489l54.627-54.627c12.498-12.497 32.758-12.497 45.256 0 12.496 12.497 12.496 32.758 0 45.255L424 197.255V256h56c17.972 0 32.484 14.816 31.988 32.9zM257 0c-61.856 0-112 50.144-112 112h224C369 50.144 318.856 0 257 0z"
                }
            }
        ]
    })(props);
}
function FaBuilding(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M436 480h-20V24c0-13.255-10.745-24-24-24H56C42.745 0 32 10.745 32 24v456H12c-6.627 0-12 5.373-12 12v20h448v-20c0-6.627-5.373-12-12-12zM128 76c0-6.627 5.373-12 12-12h40c6.627 0 12 5.373 12 12v40c0 6.627-5.373 12-12 12h-40c-6.627 0-12-5.373-12-12V76zm0 96c0-6.627 5.373-12 12-12h40c6.627 0 12 5.373 12 12v40c0 6.627-5.373 12-12 12h-40c-6.627 0-12-5.373-12-12v-40zm52 148h-40c-6.627 0-12-5.373-12-12v-40c0-6.627 5.373-12 12-12h40c6.627 0 12 5.373 12 12v40c0 6.627-5.373 12-12 12zm76 160h-64v-84c0-6.627 5.373-12 12-12h40c6.627 0 12 5.373 12 12v84zm64-172c0 6.627-5.373 12-12 12h-40c-6.627 0-12-5.373-12-12v-40c0-6.627 5.373-12 12-12h40c6.627 0 12 5.373 12 12v40zm0-96c0 6.627-5.373 12-12 12h-40c-6.627 0-12-5.373-12-12v-40c0-6.627 5.373-12 12-12h40c6.627 0 12 5.373 12 12v40zm0-96c0 6.627-5.373 12-12 12h-40c-6.627 0-12-5.373-12-12V76c0-6.627 5.373-12 12-12h40c6.627 0 12 5.373 12 12v40z"
                }
            }
        ]
    })(props);
}
function FaBullhorn(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M576 240c0-23.63-12.95-44.04-32-55.12V32.01C544 23.26 537.02 0 512 0c-7.12 0-14.19 2.38-19.98 7.02l-85.03 68.03C364.28 109.19 310.66 128 256 128H64c-35.35 0-64 28.65-64 64v96c0 35.35 28.65 64 64 64h33.7c-1.39 10.48-2.18 21.14-2.18 32 0 39.77 9.26 77.35 25.56 110.94 5.19 10.69 16.52 17.06 28.4 17.06h74.28c26.05 0 41.69-29.84 25.9-50.56-16.4-21.52-26.15-48.36-26.15-77.44 0-11.11 1.62-21.79 4.41-32H256c54.66 0 108.28 18.81 150.98 52.95l85.03 68.03a32.023 32.023 0 0 0 19.98 7.02c24.92 0 32-22.78 32-32V295.13C563.05 284.04 576 263.63 576 240zm-96 141.42l-33.05-26.44C392.95 311.78 325.12 288 256 288v-96c69.12 0 136.95-23.78 190.95-66.98L480 98.58v282.84z"
                }
            }
        ]
    })(props);
}
function FaBullseye(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111.03 8 0 119.03 0 256s111.03 248 248 248 248-111.03 248-248S384.97 8 248 8zm0 432c-101.69 0-184-82.29-184-184 0-101.69 82.29-184 184-184 101.69 0 184 82.29 184 184 0 101.69-82.29 184-184 184zm0-312c-70.69 0-128 57.31-128 128s57.31 128 128 128 128-57.31 128-128-57.31-128-128-128zm0 192c-35.29 0-64-28.71-64-64s28.71-64 64-64 64 28.71 64 64-28.71 64-64 64z"
                }
            }
        ]
    })(props);
}
function FaBurn(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M192 0C79.7 101.3 0 220.9 0 300.5 0 425 79 512 192 512s192-87 192-211.5c0-79.9-80.2-199.6-192-300.5zm0 448c-56.5 0-96-39-96-94.8 0-13.5 4.6-61.5 96-161.2 91.4 99.7 96 147.7 96 161.2 0 55.8-39.5 94.8-96 94.8z"
                }
            }
        ]
    })(props);
}
function FaBusAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M488 128h-8V80c0-44.8-99.2-80-224-80S32 35.2 32 80v48h-8c-13.25 0-24 10.74-24 24v80c0 13.25 10.75 24 24 24h8v160c0 17.67 14.33 32 32 32v32c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32v-32h192v32c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32v-32h6.4c16 0 25.6-12.8 25.6-25.6V256h8c13.25 0 24-10.75 24-24v-80c0-13.26-10.75-24-24-24zM160 72c0-4.42 3.58-8 8-8h176c4.42 0 8 3.58 8 8v16c0 4.42-3.58 8-8 8H168c-4.42 0-8-3.58-8-8V72zm-48 328c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm128-112H128c-17.67 0-32-14.33-32-32v-96c0-17.67 14.33-32 32-32h112v160zm32 0V128h112c17.67 0 32 14.33 32 32v96c0 17.67-14.33 32-32 32H272zm128 112c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32z"
                }
            }
        ]
    })(props);
}
function FaBus(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M488 128h-8V80c0-44.8-99.2-80-224-80S32 35.2 32 80v48h-8c-13.25 0-24 10.74-24 24v80c0 13.25 10.75 24 24 24h8v160c0 17.67 14.33 32 32 32v32c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32v-32h192v32c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32v-32h6.4c16 0 25.6-12.8 25.6-25.6V256h8c13.25 0 24-10.75 24-24v-80c0-13.26-10.75-24-24-24zM112 400c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm16-112c-17.67 0-32-14.33-32-32V128c0-17.67 14.33-32 32-32h256c17.67 0 32 14.33 32 32v128c0 17.67-14.33 32-32 32H128zm272 112c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32z"
                }
            }
        ]
    })(props);
}
function FaBusinessTime(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M496 224c-79.59 0-144 64.41-144 144s64.41 144 144 144 144-64.41 144-144-64.41-144-144-144zm64 150.29c0 5.34-4.37 9.71-9.71 9.71h-60.57c-5.34 0-9.71-4.37-9.71-9.71v-76.57c0-5.34 4.37-9.71 9.71-9.71h12.57c5.34 0 9.71 4.37 9.71 9.71V352h38.29c5.34 0 9.71 4.37 9.71 9.71v12.58zM496 192c5.4 0 10.72.33 16 .81V144c0-25.6-22.4-48-48-48h-80V48c0-25.6-22.4-48-48-48H176c-25.6 0-48 22.4-48 48v48H48c-25.6 0-48 22.4-48 48v80h395.12c28.6-20.09 63.35-32 100.88-32zM320 96H192V64h128v32zm6.82 224H208c-8.84 0-16-7.16-16-16v-48H0v144c0 25.6 22.4 48 48 48h291.43C327.1 423.96 320 396.82 320 368c0-16.66 2.48-32.72 6.82-48z"
                }
            }
        ]
    })(props);
}
function FaCalculator(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M400 0H48C22.4 0 0 22.4 0 48v416c0 25.6 22.4 48 48 48h352c25.6 0 48-22.4 48-48V48c0-25.6-22.4-48-48-48zM128 435.2c0 6.4-6.4 12.8-12.8 12.8H76.8c-6.4 0-12.8-6.4-12.8-12.8v-38.4c0-6.4 6.4-12.8 12.8-12.8h38.4c6.4 0 12.8 6.4 12.8 12.8v38.4zm0-128c0 6.4-6.4 12.8-12.8 12.8H76.8c-6.4 0-12.8-6.4-12.8-12.8v-38.4c0-6.4 6.4-12.8 12.8-12.8h38.4c6.4 0 12.8 6.4 12.8 12.8v38.4zm128 128c0 6.4-6.4 12.8-12.8 12.8h-38.4c-6.4 0-12.8-6.4-12.8-12.8v-38.4c0-6.4 6.4-12.8 12.8-12.8h38.4c6.4 0 12.8 6.4 12.8 12.8v38.4zm0-128c0 6.4-6.4 12.8-12.8 12.8h-38.4c-6.4 0-12.8-6.4-12.8-12.8v-38.4c0-6.4 6.4-12.8 12.8-12.8h38.4c6.4 0 12.8 6.4 12.8 12.8v38.4zm128 128c0 6.4-6.4 12.8-12.8 12.8h-38.4c-6.4 0-12.8-6.4-12.8-12.8V268.8c0-6.4 6.4-12.8 12.8-12.8h38.4c6.4 0 12.8 6.4 12.8 12.8v166.4zm0-256c0 6.4-6.4 12.8-12.8 12.8H76.8c-6.4 0-12.8-6.4-12.8-12.8V76.8C64 70.4 70.4 64 76.8 64h294.4c6.4 0 12.8 6.4 12.8 12.8v102.4z"
                }
            }
        ]
    })(props);
}
function FaCalendarAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 464c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V192H0v272zm320-196c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-40zm0 128c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-40zM192 268c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-40zm0 128c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-40zM64 268c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12H76c-6.6 0-12-5.4-12-12v-40zm0 128c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12H76c-6.6 0-12-5.4-12-12v-40zM400 64h-48V16c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v48H160V16c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v48H48C21.5 64 0 85.5 0 112v48h448v-48c0-26.5-21.5-48-48-48z"
                }
            }
        ]
    })(props);
}
function FaCalendarCheck(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M436 160H12c-6.627 0-12-5.373-12-12v-36c0-26.51 21.49-48 48-48h48V12c0-6.627 5.373-12 12-12h40c6.627 0 12 5.373 12 12v52h128V12c0-6.627 5.373-12 12-12h40c6.627 0 12 5.373 12 12v52h48c26.51 0 48 21.49 48 48v36c0 6.627-5.373 12-12 12zM12 192h424c6.627 0 12 5.373 12 12v260c0 26.51-21.49 48-48 48H48c-26.51 0-48-21.49-48-48V204c0-6.627 5.373-12 12-12zm333.296 95.947l-28.169-28.398c-4.667-4.705-12.265-4.736-16.97-.068L194.12 364.665l-45.98-46.352c-4.667-4.705-12.266-4.736-16.971-.068l-28.397 28.17c-4.705 4.667-4.736 12.265-.068 16.97l82.601 83.269c4.667 4.705 12.265 4.736 16.97.068l142.953-141.805c4.705-4.667 4.736-12.265.068-16.97z"
                }
            }
        ]
    })(props);
}
function FaCalendarDay(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 464c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V192H0v272zm64-192c0-8.8 7.2-16 16-16h96c8.8 0 16 7.2 16 16v96c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16v-96zM400 64h-48V16c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v48H160V16c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v48H48C21.5 64 0 85.5 0 112v48h448v-48c0-26.5-21.5-48-48-48z"
                }
            }
        ]
    })(props);
}
function FaCalendarMinus(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M436 160H12c-6.6 0-12-5.4-12-12v-36c0-26.5 21.5-48 48-48h48V12c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v52h128V12c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v52h48c26.5 0 48 21.5 48 48v36c0 6.6-5.4 12-12 12zM12 192h424c6.6 0 12 5.4 12 12v260c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V204c0-6.6 5.4-12 12-12zm304 192c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12H132c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h184z"
                }
            }
        ]
    })(props);
}
function FaCalendarPlus(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M436 160H12c-6.6 0-12-5.4-12-12v-36c0-26.5 21.5-48 48-48h48V12c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v52h128V12c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v52h48c26.5 0 48 21.5 48 48v36c0 6.6-5.4 12-12 12zM12 192h424c6.6 0 12 5.4 12 12v260c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V204c0-6.6 5.4-12 12-12zm316 140c0-6.6-5.4-12-12-12h-60v-60c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v60h-60c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h60v60c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12v-60h60c6.6 0 12-5.4 12-12v-40z"
                }
            }
        ]
    })(props);
}
function FaCalendarTimes(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M436 160H12c-6.6 0-12-5.4-12-12v-36c0-26.5 21.5-48 48-48h48V12c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v52h128V12c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v52h48c26.5 0 48 21.5 48 48v36c0 6.6-5.4 12-12 12zM12 192h424c6.6 0 12 5.4 12 12v260c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V204c0-6.6 5.4-12 12-12zm257.3 160l48.1-48.1c4.7-4.7 4.7-12.3 0-17l-28.3-28.3c-4.7-4.7-12.3-4.7-17 0L224 306.7l-48.1-48.1c-4.7-4.7-12.3-4.7-17 0l-28.3 28.3c-4.7 4.7-4.7 12.3 0 17l48.1 48.1-48.1 48.1c-4.7 4.7-4.7 12.3 0 17l28.3 28.3c4.7 4.7 12.3 4.7 17 0l48.1-48.1 48.1 48.1c4.7 4.7 12.3 4.7 17 0l28.3-28.3c4.7-4.7 4.7-12.3 0-17L269.3 352z"
                }
            }
        ]
    })(props);
}
function FaCalendarWeek(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 464c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V192H0v272zm64-192c0-8.8 7.2-16 16-16h288c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16v-64zM400 64h-48V16c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v48H160V16c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v48H48C21.5 64 0 85.5 0 112v48h448v-48c0-26.5-21.5-48-48-48z"
                }
            }
        ]
    })(props);
}
function FaCalendar(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 192h424c6.6 0 12 5.4 12 12v260c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V204c0-6.6 5.4-12 12-12zm436-44v-36c0-26.5-21.5-48-48-48h-48V12c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v52H160V12c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v52H48C21.5 64 0 85.5 0 112v36c0 6.6 5.4 12 12 12h424c6.6 0 12-5.4 12-12z"
                }
            }
        ]
    })(props);
}
function FaCameraRetro(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M48 32C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h416c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48H48zm0 32h106c3.3 0 6 2.7 6 6v20c0 3.3-2.7 6-6 6H38c-3.3 0-6-2.7-6-6V80c0-8.8 7.2-16 16-16zm426 96H38c-3.3 0-6-2.7-6-6v-36c0-3.3 2.7-6 6-6h138l30.2-45.3c1.1-1.7 3-2.7 5-2.7H464c8.8 0 16 7.2 16 16v74c0 3.3-2.7 6-6 6zM256 424c-66.2 0-120-53.8-120-120s53.8-120 120-120 120 53.8 120 120-53.8 120-120 120zm0-208c-48.5 0-88 39.5-88 88s39.5 88 88 88 88-39.5 88-88-39.5-88-88-88zm-48 104c-8.8 0-16-7.2-16-16 0-35.3 28.7-64 64-64 8.8 0 16 7.2 16 16s-7.2 16-16 16c-17.6 0-32 14.4-32 32 0 8.8-7.2 16-16 16z"
                }
            }
        ]
    })(props);
}
function FaCamera(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M512 144v288c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V144c0-26.5 21.5-48 48-48h88l12.3-32.9c7-18.7 24.9-31.1 44.9-31.1h125.5c20 0 37.9 12.4 44.9 31.1L376 96h88c26.5 0 48 21.5 48 48zM376 288c0-66.2-53.8-120-120-120s-120 53.8-120 120 53.8 120 120 120 120-53.8 120-120zm-32 0c0 48.5-39.5 88-88 88s-88-39.5-88-88 39.5-88 88-88 88 39.5 88 88z"
                }
            }
        ]
    })(props);
}
function FaCampground(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M624 448h-24.68L359.54 117.75l53.41-73.55c5.19-7.15 3.61-17.16-3.54-22.35l-25.9-18.79c-7.15-5.19-17.15-3.61-22.35 3.55L320 63.3 278.83 6.6c-5.19-7.15-15.2-8.74-22.35-3.55l-25.88 18.8c-7.15 5.19-8.74 15.2-3.54 22.35l53.41 73.55L40.68 448H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h608c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16zM320 288l116.36 160H203.64L320 288z"
                }
            }
        ]
    })(props);
}
function FaCandyCane(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M497.5 92C469.6 33.1 411.8 0 352.4 0c-27.9 0-56.2 7.3-81.8 22.6L243.1 39c-15.2 9.1-20.1 28.7-11 43.9l32.8 54.9c6 10 16.6 15.6 27.5 15.6 5.6 0 11.2-1.5 16.4-4.5l27.5-16.4c5.1-3.1 10.8-4.5 16.4-4.5 10.9 0 21.5 5.6 27.5 15.6 9.1 15.1 4.1 34.8-11 43.9L15.6 397.6c-15.2 9.1-20.1 28.7-11 43.9l32.8 54.9c6 10 16.6 15.6 27.5 15.6 5.6 0 11.2-1.5 16.4-4.5L428.6 301c71.7-42.9 104.6-133.5 68.9-209zm-177.7 13l-2.5 1.5L296.8 45c9.7-4.7 19.8-8.1 30.3-10.2l20.6 61.8c-9.8.8-19.4 3.3-27.9 8.4zM145.9 431.8l-60.5-38.5 30.8-18.3 60.5 38.5-30.8 18.3zm107.5-63.9l-60.5-38.5 30.8-18.3 60.5 38.5-30.8 18.3zM364.3 302l-60.5-38.5 30.8-18.3 60.5 38.5-30.8 18.3zm20.4-197.3l46-46c8.4 6.5 16 14.1 22.6 22.6L407.6 127c-5.7-9.3-13.7-16.9-22.9-22.3zm82.1 107.8l-59.5-19.8c3.2-5.3 5.8-10.9 7.4-17.1 1.1-4.5 1.7-9.1 1.8-13.6l60.4 20.1c-2.1 10.4-5.5 20.6-10.1 30.4z"
                }
            }
        ]
    })(props);
}
function FaCannabis(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M503.47 360.25c-1.56-.82-32.39-16.89-76.78-25.81 64.25-75.12 84.05-161.67 84.93-165.64 1.18-5.33-.44-10.9-4.3-14.77-3.03-3.04-7.12-4.7-11.32-4.7-1.14 0-2.29.12-3.44.38-3.88.85-86.54 19.59-160.58 79.76.01-1.46.01-2.93.01-4.4 0-118.79-59.98-213.72-62.53-217.7A15.973 15.973 0 0 0 256 0c-5.45 0-10.53 2.78-13.47 7.37-2.55 3.98-62.53 98.91-62.53 217.7 0 1.47.01 2.94.01 4.4-74.03-60.16-156.69-78.9-160.58-79.76-1.14-.25-2.29-.38-3.44-.38-4.2 0-8.29 1.66-11.32 4.7A15.986 15.986 0 0 0 .38 168.8c.88 3.97 20.68 90.52 84.93 165.64-44.39 8.92-75.21 24.99-76.78 25.81a16.003 16.003 0 0 0-.02 28.29c2.45 1.29 60.76 31.72 133.49 31.72 6.14 0 11.96-.1 17.5-.31-11.37 22.23-16.52 38.31-16.81 39.22-1.8 5.68-.29 11.89 3.91 16.11a16.019 16.019 0 0 0 16.1 3.99c1.83-.57 37.72-11.99 77.3-39.29V504c0 4.42 3.58 8 8 8h16c4.42 0 8-3.58 8-8v-64.01c39.58 27.3 75.47 38.71 77.3 39.29a16.019 16.019 0 0 0 16.1-3.99c4.2-4.22 5.71-10.43 3.91-16.11-.29-.91-5.45-16.99-16.81-39.22 5.54.21 11.37.31 17.5.31 72.72 0 131.04-30.43 133.49-31.72 5.24-2.78 8.52-8.22 8.51-14.15-.01-5.94-3.29-11.39-8.53-14.15z"
                }
            }
        ]
    })(props);
}
function FaCapsules(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M555.3 300.1L424.2 112.8C401.9 81 366.4 64 330.4 64c-22.6 0-45.5 6.7-65.5 20.7-19.7 13.8-33.7 32.8-41.5 53.8C220.5 79.2 172 32 112 32 50.1 32 0 82.1 0 144v224c0 61.9 50.1 112 112 112s112-50.1 112-112V218.9c3.3 8.6 7.3 17.1 12.8 25L368 431.2c22.2 31.8 57.7 48.8 93.8 48.8 22.7 0 45.5-6.7 65.5-20.7 51.7-36.2 64.2-107.5 28-159.2zM160 256H64V144c0-26.5 21.5-48 48-48s48 21.5 48 48v112zm194.8 44.9l-65.6-93.7c-7.7-11-10.7-24.4-8.3-37.6 2.3-13.2 9.7-24.8 20.7-32.5 8.5-6 18.5-9.1 28.8-9.1 16.5 0 31.9 8 41.3 21.5l65.6 93.7-82.5 57.7z"
                }
            }
        ]
    })(props);
}
function FaCarAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 480 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M438.66 212.33l-11.24-28.1-19.93-49.83C390.38 91.63 349.57 64 303.5 64h-127c-46.06 0-86.88 27.63-103.99 70.4l-19.93 49.83-11.24 28.1C17.22 221.5 0 244.66 0 272v48c0 16.12 6.16 30.67 16 41.93V416c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32v-32h256v32c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32v-54.07c9.84-11.25 16-25.8 16-41.93v-48c0-27.34-17.22-50.5-41.34-59.67zm-306.73-54.16c7.29-18.22 24.94-30.17 44.57-30.17h127c19.63 0 37.28 11.95 44.57 30.17L368 208H112l19.93-49.83zM80 319.8c-19.2 0-32-12.76-32-31.9S60.8 256 80 256s48 28.71 48 47.85-28.8 15.95-48 15.95zm320 0c-19.2 0-48 3.19-48-15.95S380.8 256 400 256s32 12.76 32 31.9-12.8 31.9-32 31.9z"
                }
            }
        ]
    })(props);
}
function FaCarBattery(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M480 128h-32V80c0-8.84-7.16-16-16-16h-96c-8.84 0-16 7.16-16 16v48H192V80c0-8.84-7.16-16-16-16H80c-8.84 0-16 7.16-16 16v48H32c-17.67 0-32 14.33-32 32v256c0 17.67 14.33 32 32 32h448c17.67 0 32-14.33 32-32V160c0-17.67-14.33-32-32-32zM192 264c0 4.42-3.58 8-8 8H72c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h112c4.42 0 8 3.58 8 8v16zm256 0c0 4.42-3.58 8-8 8h-40v40c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8v-40h-40c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h40v-40c0-4.42 3.58-8 8-8h16c4.42 0 8 3.58 8 8v40h40c4.42 0 8 3.58 8 8v16z"
                }
            }
        ]
    })(props);
}
function FaCarCrash(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M143.25 220.81l-12.42 46.37c-3.01 11.25-3.63 22.89-2.41 34.39l-35.2 28.98c-6.57 5.41-16.31-.43-14.62-8.77l15.44-76.68c1.06-5.26-2.66-10.28-8-10.79l-77.86-7.55c-8.47-.82-11.23-11.83-4.14-16.54l65.15-43.3c4.46-2.97 5.38-9.15 1.98-13.29L21.46 93.22c-5.41-6.57.43-16.3 8.78-14.62l76.68 15.44c5.26 1.06 10.28-2.66 10.8-8l7.55-77.86c.82-8.48 11.83-11.23 16.55-4.14l43.3 65.14c2.97 4.46 9.15 5.38 13.29 1.98l60.4-49.71c6.57-5.41 16.3.43 14.62 8.77L262.1 86.38c-2.71 3.05-5.43 6.09-7.91 9.4l-32.15 42.97-10.71 14.32c-32.73 8.76-59.18 34.53-68.08 67.74zm494.57 132.51l-12.42 46.36c-3.13 11.68-9.38 21.61-17.55 29.36a66.876 66.876 0 0 1-8.76 7l-13.99 52.23c-1.14 4.27-3.1 8.1-5.65 11.38-7.67 9.84-20.74 14.68-33.54 11.25L515 502.62c-17.07-4.57-27.2-22.12-22.63-39.19l8.28-30.91-247.28-66.26-8.28 30.91c-4.57 17.07-22.12 27.2-39.19 22.63l-30.91-8.28c-12.8-3.43-21.7-14.16-23.42-26.51-.57-4.12-.35-8.42.79-12.68l13.99-52.23a66.62 66.62 0 0 1-4.09-10.45c-3.2-10.79-3.65-22.52-.52-34.2l12.42-46.37c5.31-19.8 19.36-34.83 36.89-42.21a64.336 64.336 0 0 1 18.49-4.72l18.13-24.23 32.15-42.97c3.45-4.61 7.19-8.9 11.2-12.84 8-7.89 17.03-14.44 26.74-19.51 4.86-2.54 9.89-4.71 15.05-6.49 10.33-3.58 21.19-5.63 32.24-6.04 11.05-.41 22.31.82 33.43 3.8l122.68 32.87c11.12 2.98 21.48 7.54 30.85 13.43a111.11 111.11 0 0 1 34.69 34.5c8.82 13.88 14.64 29.84 16.68 46.99l6.36 53.29 3.59 30.05a64.49 64.49 0 0 1 22.74 29.93c4.39 11.88 5.29 25.19 1.75 38.39zM255.58 234.34c-18.55-4.97-34.21 4.04-39.17 22.53-4.96 18.49 4.11 34.12 22.65 39.09 18.55 4.97 45.54 15.51 50.49-2.98 4.96-18.49-15.43-53.67-33.97-58.64zm290.61 28.17l-6.36-53.29c-.58-4.87-1.89-9.53-3.82-13.86-5.8-12.99-17.2-23.01-31.42-26.82l-122.68-32.87a48.008 48.008 0 0 0-50.86 17.61l-32.15 42.97 172 46.08 75.29 20.18zm18.49 54.65c-18.55-4.97-53.8 15.31-58.75 33.79-4.95 18.49 23.69 22.86 42.24 27.83 18.55 4.97 34.21-4.04 39.17-22.53 4.95-18.48-4.11-34.12-22.66-39.09z"
                }
            }
        ]
    })(props);
}
function FaCarSide(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M544 192h-16L419.22 56.02A64.025 64.025 0 0 0 369.24 32H155.33c-26.17 0-49.7 15.93-59.42 40.23L48 194.26C20.44 201.4 0 226.21 0 256v112c0 8.84 7.16 16 16 16h48c0 53.02 42.98 96 96 96s96-42.98 96-96h128c0 53.02 42.98 96 96 96s96-42.98 96-96h48c8.84 0 16-7.16 16-16v-80c0-53.02-42.98-96-96-96zM160 432c-26.47 0-48-21.53-48-48s21.53-48 48-48 48 21.53 48 48-21.53 48-48 48zm72-240H116.93l38.4-96H232v96zm48 0V96h89.24l76.8 96H280zm200 240c-26.47 0-48-21.53-48-48s21.53-48 48-48 48 21.53 48 48-21.53 48-48 48z"
                }
            }
        ]
    })(props);
}
function FaCar(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M499.99 176h-59.87l-16.64-41.6C406.38 91.63 365.57 64 319.5 64h-127c-46.06 0-86.88 27.63-103.99 70.4L71.87 176H12.01C4.2 176-1.53 183.34.37 190.91l6 24C7.7 220.25 12.5 224 18.01 224h20.07C24.65 235.73 16 252.78 16 272v48c0 16.12 6.16 30.67 16 41.93V416c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32v-32h256v32c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32v-54.07c9.84-11.25 16-25.8 16-41.93v-48c0-19.22-8.65-36.27-22.07-48H494c5.51 0 10.31-3.75 11.64-9.09l6-24c1.89-7.57-3.84-14.91-11.65-14.91zm-352.06-17.83c7.29-18.22 24.94-30.17 44.57-30.17h127c19.63 0 37.28 11.95 44.57 30.17L384 208H128l19.93-49.83zM96 319.8c-19.2 0-32-12.76-32-31.9S76.8 256 96 256s48 28.71 48 47.85-28.8 15.95-48 15.95zm320 0c-19.2 0-48 3.19-48-15.95S396.8 256 416 256s32 12.76 32 31.9-12.8 31.9-32 31.9z"
                }
            }
        ]
    })(props);
}
function FaCaravan(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M416,208a16,16,0,1,0,16,16A16,16,0,0,0,416,208ZM624,320H576V160A160,160,0,0,0,416,0H64A64,64,0,0,0,0,64V320a64,64,0,0,0,64,64H96a96,96,0,0,0,192,0H624a16,16,0,0,0,16-16V336A16,16,0,0,0,624,320ZM192,432a48,48,0,1,1,48-48A48.05,48.05,0,0,1,192,432Zm64-240a32,32,0,0,1-32,32H96a32,32,0,0,1-32-32V128A32,32,0,0,1,96,96H224a32,32,0,0,1,32,32ZM448,320H320V128a32,32,0,0,1,32-32h64a32,32,0,0,1,32,32Z"
                }
            }
        ]
    })(props);
}
function FaCaretDown(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 320 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M31.3 192h257.3c17.8 0 26.7 21.5 14.1 34.1L174.1 354.8c-7.8 7.8-20.5 7.8-28.3 0L17.2 226.1C4.6 213.5 13.5 192 31.3 192z"
                }
            }
        ]
    })(props);
}
function FaCaretLeft(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 192 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M192 127.338v257.324c0 17.818-21.543 26.741-34.142 14.142L29.196 270.142c-7.81-7.81-7.81-20.474 0-28.284l128.662-128.662c12.599-12.6 34.142-3.676 34.142 14.142z"
                }
            }
        ]
    })(props);
}
function FaCaretRight(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 192 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 384.662V127.338c0-17.818 21.543-26.741 34.142-14.142l128.662 128.662c7.81 7.81 7.81 20.474 0 28.284L34.142 398.804C21.543 411.404 0 402.48 0 384.662z"
                }
            }
        ]
    })(props);
}
function FaCaretSquareDown(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M448 80v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h352c26.5 0 48 21.5 48 48zM92.5 220.5l123 123c4.7 4.7 12.3 4.7 17 0l123-123c7.6-7.6 2.2-20.5-8.5-20.5H101c-10.7 0-16.1 12.9-8.5 20.5z"
                }
            }
        ]
    })(props);
}
function FaCaretSquareLeft(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M400 480H48c-26.51 0-48-21.49-48-48V80c0-26.51 21.49-48 48-48h352c26.51 0 48 21.49 48 48v352c0 26.51-21.49 48-48 48zM259.515 124.485l-123.03 123.03c-4.686 4.686-4.686 12.284 0 16.971l123.029 123.029c7.56 7.56 20.485 2.206 20.485-8.485V132.971c.001-10.691-12.925-16.045-20.484-8.486z"
                }
            }
        ]
    })(props);
}
function FaCaretSquareRight(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M48 32h352c26.51 0 48 21.49 48 48v352c0 26.51-21.49 48-48 48H48c-26.51 0-48-21.49-48-48V80c0-26.51 21.49-48 48-48zm140.485 355.515l123.029-123.029c4.686-4.686 4.686-12.284 0-16.971l-123.029-123.03c-7.56-7.56-20.485-2.206-20.485 8.485v246.059c0 10.691 12.926 16.045 20.485 8.486z"
                }
            }
        ]
    })(props);
}
function FaCaretSquareUp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 432V80c0-26.51 21.49-48 48-48h352c26.51 0 48 21.49 48 48v352c0 26.51-21.49 48-48 48H48c-26.51 0-48-21.49-48-48zm355.515-140.485l-123.03-123.03c-4.686-4.686-12.284-4.686-16.971 0L92.485 291.515c-7.56 7.56-2.206 20.485 8.485 20.485h246.059c10.691 0 16.045-12.926 8.486-20.485z"
                }
            }
        ]
    })(props);
}
function FaCaretUp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 320 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M288.662 352H31.338c-17.818 0-26.741-21.543-14.142-34.142l128.662-128.662c7.81-7.81 20.474-7.81 28.284 0l128.662 128.662c12.6 12.599 3.676 34.142-14.142 34.142z"
                }
            }
        ]
    })(props);
}
function FaCarrot(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M298.2 156.6c-52.7-25.7-114.5-10.5-150.2 32.8l55.2 55.2c6.3 6.3 6.3 16.4 0 22.6-3.1 3.1-7.2 4.7-11.3 4.7s-8.2-1.6-11.3-4.7L130.4 217 2.3 479.7c-2.9 6-3.1 13.3 0 19.7 5.4 11.1 18.9 15.7 30 10.3l133.6-65.2-49.2-49.2c-6.3-6.2-6.3-16.4 0-22.6 6.3-6.2 16.4-6.2 22.6 0l57 57 102-49.8c24-11.7 44.5-31.3 57.1-57.1 30.1-61.7 4.5-136.1-57.2-166.2zm92.1-34.9C409.8 81 399.7 32.9 360 0c-50.3 41.7-52.5 107.5-7.9 151.9l8 8c44.4 44.6 110.3 42.4 151.9-7.9-32.9-39.7-81-49.8-121.7-30.3z"
                }
            }
        ]
    })(props);
}
function FaCartArrowDown(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M504.717 320H211.572l6.545 32h268.418c15.401 0 26.816 14.301 23.403 29.319l-5.517 24.276C523.112 414.668 536 433.828 536 456c0 31.202-25.519 56.444-56.824 55.994-29.823-.429-54.35-24.631-55.155-54.447-.44-16.287 6.085-31.049 16.803-41.548H231.176C241.553 426.165 248 440.326 248 456c0 31.813-26.528 57.431-58.67 55.938-28.54-1.325-51.751-24.385-53.251-52.917-1.158-22.034 10.436-41.455 28.051-51.586L93.883 64H24C10.745 64 0 53.255 0 40V24C0 10.745 10.745 0 24 0h102.529c11.401 0 21.228 8.021 23.513 19.19L159.208 64H551.99c15.401 0 26.816 14.301 23.403 29.319l-47.273 208C525.637 312.246 515.923 320 504.717 320zM403.029 192H360v-60c0-6.627-5.373-12-12-12h-24c-6.627 0-12 5.373-12 12v60h-43.029c-10.691 0-16.045 12.926-8.485 20.485l67.029 67.029c4.686 4.686 12.284 4.686 16.971 0l67.029-67.029c7.559-7.559 2.205-20.485-8.486-20.485z"
                }
            }
        ]
    })(props);
}
function FaCartPlus(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M504.717 320H211.572l6.545 32h268.418c15.401 0 26.816 14.301 23.403 29.319l-5.517 24.276C523.112 414.668 536 433.828 536 456c0 31.202-25.519 56.444-56.824 55.994-29.823-.429-54.35-24.631-55.155-54.447-.44-16.287 6.085-31.049 16.803-41.548H231.176C241.553 426.165 248 440.326 248 456c0 31.813-26.528 57.431-58.67 55.938-28.54-1.325-51.751-24.385-53.251-52.917-1.158-22.034 10.436-41.455 28.051-51.586L93.883 64H24C10.745 64 0 53.255 0 40V24C0 10.745 10.745 0 24 0h102.529c11.401 0 21.228 8.021 23.513 19.19L159.208 64H551.99c15.401 0 26.816 14.301 23.403 29.319l-47.273 208C525.637 312.246 515.923 320 504.717 320zM408 168h-48v-40c0-8.837-7.163-16-16-16h-16c-8.837 0-16 7.163-16 16v40h-48c-8.837 0-16 7.163-16 16v16c0 8.837 7.163 16 16 16h48v40c0 8.837 7.163 16 16 16h16c8.837 0 16-7.163 16-16v-40h48c8.837 0 16-7.163 16-16v-16c0-8.837-7.163-16-16-16z"
                }
            }
        ]
    })(props);
}
function FaCashRegister(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M511.1 378.8l-26.7-160c-2.6-15.4-15.9-26.7-31.6-26.7H208v-64h96c8.8 0 16-7.2 16-16V16c0-8.8-7.2-16-16-16H48c-8.8 0-16 7.2-16 16v96c0 8.8 7.2 16 16 16h96v64H59.1c-15.6 0-29 11.3-31.6 26.7L.8 378.7c-.6 3.5-.9 7-.9 10.5V480c0 17.7 14.3 32 32 32h448c17.7 0 32-14.3 32-32v-90.7c.1-3.5-.2-7-.8-10.5zM280 248c0-8.8 7.2-16 16-16h16c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16h-16c-8.8 0-16-7.2-16-16v-16zm-32 64h16c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16h-16c-8.8 0-16-7.2-16-16v-16c0-8.8 7.2-16 16-16zm-32-80c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16h-16c-8.8 0-16-7.2-16-16v-16c0-8.8 7.2-16 16-16h16zM80 80V48h192v32H80zm40 200h-16c-8.8 0-16-7.2-16-16v-16c0-8.8 7.2-16 16-16h16c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16zm16 64v-16c0-8.8 7.2-16 16-16h16c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16h-16c-8.8 0-16-7.2-16-16zm216 112c0 4.4-3.6 8-8 8H168c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h176c4.4 0 8 3.6 8 8v16zm24-112c0 8.8-7.2 16-16 16h-16c-8.8 0-16-7.2-16-16v-16c0-8.8 7.2-16 16-16h16c8.8 0 16 7.2 16 16v16zm48-80c0 8.8-7.2 16-16 16h-16c-8.8 0-16-7.2-16-16v-16c0-8.8 7.2-16 16-16h16c8.8 0 16 7.2 16 16v16z"
                }
            }
        ]
    })(props);
}
function FaCat(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M290.59 192c-20.18 0-106.82 1.98-162.59 85.95V192c0-52.94-43.06-96-96-96-17.67 0-32 14.33-32 32s14.33 32 32 32c17.64 0 32 14.36 32 32v256c0 35.3 28.7 64 64 64h176c8.84 0 16-7.16 16-16v-16c0-17.67-14.33-32-32-32h-32l128-96v144c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16V289.86c-10.29 2.67-20.89 4.54-32 4.54-61.81 0-113.52-44.05-125.41-102.4zM448 96h-64l-64-64v134.4c0 53.02 42.98 96 96 96s96-42.98 96-96V32l-64 64zm-72 80c-8.84 0-16-7.16-16-16s7.16-16 16-16 16 7.16 16 16-7.16 16-16 16zm80 0c-8.84 0-16-7.16-16-16s7.16-16 16-16 16 7.16 16 16-7.16 16-16 16z"
                }
            }
        ]
    })(props);
}
function FaCertificate(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M458.622 255.92l45.985-45.005c13.708-12.977 7.316-36.039-10.664-40.339l-62.65-15.99 17.661-62.015c4.991-17.838-11.829-34.663-29.661-29.671l-61.994 17.667-15.984-62.671C337.085.197 313.765-6.276 300.99 7.228L256 53.57 211.011 7.229c-12.63-13.351-36.047-7.234-40.325 10.668l-15.984 62.671-61.995-17.667C74.87 57.907 58.056 74.738 63.046 92.572l17.661 62.015-62.65 15.99C.069 174.878-6.31 197.944 7.392 210.915l45.985 45.005-45.985 45.004c-13.708 12.977-7.316 36.039 10.664 40.339l62.65 15.99-17.661 62.015c-4.991 17.838 11.829 34.663 29.661 29.671l61.994-17.667 15.984 62.671c4.439 18.575 27.696 24.018 40.325 10.668L256 458.61l44.989 46.001c12.5 13.488 35.987 7.486 40.325-10.668l15.984-62.671 61.994 17.667c17.836 4.994 34.651-11.837 29.661-29.671l-17.661-62.015 62.65-15.99c17.987-4.302 24.366-27.367 10.664-40.339l-45.984-45.004z"
                }
            }
        ]
    })(props);
}
function FaChair(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M112 128c0-29.5 16.2-55 40-68.9V256h48V48h48v208h48V59.1c23.8 13.9 40 39.4 40 68.9v128h48V128C384 57.3 326.7 0 256 0h-64C121.3 0 64 57.3 64 128v128h48zm334.3 213.9l-10.7-32c-4.4-13.1-16.6-21.9-30.4-21.9H42.7c-13.8 0-26 8.8-30.4 21.9l-10.7 32C-5.2 362.6 10.2 384 32 384v112c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V384h256v112c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V384c21.8 0 37.2-21.4 30.3-42.1z"
                }
            }
        ]
    })(props);
}
function FaChalkboardTeacher(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M208 352c-2.39 0-4.78.35-7.06 1.09C187.98 357.3 174.35 360 160 360c-14.35 0-27.98-2.7-40.95-6.91-2.28-.74-4.66-1.09-7.05-1.09C49.94 352-.33 402.48 0 464.62.14 490.88 21.73 512 48 512h224c26.27 0 47.86-21.12 48-47.38.33-62.14-49.94-112.62-112-112.62zm-48-32c53.02 0 96-42.98 96-96s-42.98-96-96-96-96 42.98-96 96 42.98 96 96 96zM592 0H208c-26.47 0-48 22.25-48 49.59V96c23.42 0 45.1 6.78 64 17.8V64h352v288h-64v-64H384v64h-76.24c19.1 16.69 33.12 38.73 39.69 64H592c26.47 0 48-22.25 48-49.59V49.59C640 22.25 618.47 0 592 0z"
                }
            }
        ]
    })(props);
}
function FaChalkboard(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M96 64h448v352h64V40c0-22.06-17.94-40-40-40H72C49.94 0 32 17.94 32 40v376h64V64zm528 384H480v-64H288v64H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h608c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16z"
                }
            }
        ]
    })(props);
}
function FaChargingStation(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M336 448H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h320c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16zm208-320V80c0-8.84-7.16-16-16-16s-16 7.16-16 16v48h-32V80c0-8.84-7.16-16-16-16s-16 7.16-16 16v48h-16c-8.84 0-16 7.16-16 16v32c0 35.76 23.62 65.69 56 75.93v118.49c0 13.95-9.5 26.92-23.26 29.19C431.22 402.5 416 388.99 416 372v-28c0-48.6-39.4-88-88-88h-8V64c0-35.35-28.65-64-64-64H96C60.65 0 32 28.65 32 64v352h288V304h8c22.09 0 40 17.91 40 40v24.61c0 39.67 28.92 75.16 68.41 79.01C481.71 452.05 520 416.41 520 372V251.93c32.38-10.24 56-40.17 56-75.93v-32c0-8.84-7.16-16-16-16h-16zm-283.91 47.76l-93.7 139c-2.2 3.33-6.21 5.24-10.39 5.24-7.67 0-13.47-6.28-11.67-12.92L167.35 224H108c-7.25 0-12.85-5.59-11.89-11.89l16-107C112.9 99.9 117.98 96 124 96h68c7.88 0 13.62 6.54 11.6 13.21L192 160h57.7c9.24 0 15.01 8.78 10.39 15.76z"
                }
            }
        ]
    })(props);
}
function FaChartArea(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M500 384c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12H12c-6.6 0-12-5.4-12-12V76c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v308h436zM372.7 159.5L288 216l-85.3-113.7c-5.1-6.8-15.5-6.3-19.9 1L96 248v104h384l-89.9-187.8c-3.2-6.5-11.4-8.7-17.4-4.7z"
                }
            }
        ]
    })(props);
}
function FaChartBar(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M332.8 320h38.4c6.4 0 12.8-6.4 12.8-12.8V172.8c0-6.4-6.4-12.8-12.8-12.8h-38.4c-6.4 0-12.8 6.4-12.8 12.8v134.4c0 6.4 6.4 12.8 12.8 12.8zm96 0h38.4c6.4 0 12.8-6.4 12.8-12.8V76.8c0-6.4-6.4-12.8-12.8-12.8h-38.4c-6.4 0-12.8 6.4-12.8 12.8v230.4c0 6.4 6.4 12.8 12.8 12.8zm-288 0h38.4c6.4 0 12.8-6.4 12.8-12.8v-70.4c0-6.4-6.4-12.8-12.8-12.8h-38.4c-6.4 0-12.8 6.4-12.8 12.8v70.4c0 6.4 6.4 12.8 12.8 12.8zm96 0h38.4c6.4 0 12.8-6.4 12.8-12.8V108.8c0-6.4-6.4-12.8-12.8-12.8h-38.4c-6.4 0-12.8 6.4-12.8 12.8v198.4c0 6.4 6.4 12.8 12.8 12.8zM496 384H64V80c0-8.84-7.16-16-16-16H16C7.16 64 0 71.16 0 80v336c0 17.67 14.33 32 32 32h464c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16z"
                }
            }
        ]
    })(props);
}
function FaChartLine(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M496 384H64V80c0-8.84-7.16-16-16-16H16C7.16 64 0 71.16 0 80v336c0 17.67 14.33 32 32 32h464c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16zM464 96H345.94c-21.38 0-32.09 25.85-16.97 40.97l32.4 32.4L288 242.75l-73.37-73.37c-12.5-12.5-32.76-12.5-45.25 0l-68.69 68.69c-6.25 6.25-6.25 16.38 0 22.63l22.62 22.62c6.25 6.25 16.38 6.25 22.63 0L192 237.25l73.37 73.37c12.5 12.5 32.76 12.5 45.25 0l96-96 32.4 32.4c15.12 15.12 40.97 4.41 40.97-16.97V112c.01-8.84-7.15-16-15.99-16z"
                }
            }
        ]
    })(props);
}
function FaChartPie(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 544 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M527.79 288H290.5l158.03 158.03c6.04 6.04 15.98 6.53 22.19.68 38.7-36.46 65.32-85.61 73.13-140.86 1.34-9.46-6.51-17.85-16.06-17.85zm-15.83-64.8C503.72 103.74 408.26 8.28 288.8.04 279.68-.59 272 7.1 272 16.24V240h223.77c9.14 0 16.82-7.68 16.19-16.8zM224 288V50.71c0-9.55-8.39-17.4-17.84-16.06C86.99 51.49-4.1 155.6.14 280.37 4.5 408.51 114.83 513.59 243.03 511.98c50.4-.63 96.97-16.87 135.26-44.03 7.9-5.6 8.42-17.23 1.57-24.08L224 288z"
                }
            }
        ]
    })(props);
}
function FaCheckCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M504 256c0 136.967-111.033 248-248 248S8 392.967 8 256 119.033 8 256 8s248 111.033 248 248zM227.314 387.314l184-184c6.248-6.248 6.248-16.379 0-22.627l-22.627-22.627c-6.248-6.249-16.379-6.249-22.628 0L216 308.118l-70.059-70.059c-6.248-6.248-16.379-6.248-22.628 0l-22.627 22.627c-6.248 6.248-6.248 16.379 0 22.627l104 104c6.249 6.249 16.379 6.249 22.628.001z"
                }
            }
        ]
    })(props);
}
function FaCheckDouble(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M505 174.8l-39.6-39.6c-9.4-9.4-24.6-9.4-33.9 0L192 374.7 80.6 263.2c-9.4-9.4-24.6-9.4-33.9 0L7 302.9c-9.4 9.4-9.4 24.6 0 34L175 505c9.4 9.4 24.6 9.4 33.9 0l296-296.2c9.4-9.5 9.4-24.7.1-34zm-324.3 106c6.2 6.3 16.4 6.3 22.6 0l208-208.2c6.2-6.3 6.2-16.4 0-22.6L366.1 4.7c-6.2-6.3-16.4-6.3-22.6 0L192 156.2l-55.4-55.5c-6.2-6.3-16.4-6.3-22.6 0L68.7 146c-6.2 6.3-6.2 16.4 0 22.6l112 112.2z"
                }
            }
        ]
    })(props);
}
function FaCheckSquare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M400 480H48c-26.51 0-48-21.49-48-48V80c0-26.51 21.49-48 48-48h352c26.51 0 48 21.49 48 48v352c0 26.51-21.49 48-48 48zm-204.686-98.059l184-184c6.248-6.248 6.248-16.379 0-22.627l-22.627-22.627c-6.248-6.248-16.379-6.249-22.628 0L184 302.745l-70.059-70.059c-6.248-6.248-16.379-6.248-22.628 0l-22.627 22.627c-6.248 6.248-6.248 16.379 0 22.627l104 104c6.249 6.25 16.379 6.25 22.628.001z"
                }
            }
        ]
    })(props);
}
function FaCheck(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M173.898 439.404l-166.4-166.4c-9.997-9.997-9.997-26.206 0-36.204l36.203-36.204c9.997-9.998 26.207-9.998 36.204 0L192 312.69 432.095 72.596c9.997-9.997 26.207-9.997 36.204 0l36.203 36.204c9.997 9.997 9.997 26.206 0 36.204l-294.4 294.401c-9.998 9.997-26.207 9.997-36.204-.001z"
                }
            }
        ]
    })(props);
}
function FaCheese(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 288v160a32 32 0 0 0 32 32h448a32 32 0 0 0 32-32V288zM299.83 32a32 32 0 0 0-21.13 7L0 256h512c0-119.89-94-217.8-212.17-224z"
                }
            }
        ]
    })(props);
}
function FaChessBishop(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 320 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 287.88c0 51.64 22.14 73.83 56 84.6V416h192v-43.52c33.86-10.77 56-33 56-84.6 0-30.61-10.73-67.1-26.69-102.56L185 285.65a8 8 0 0 1-11.31 0l-11.31-11.31a8 8 0 0 1 0-11.31L270.27 155.1c-20.8-37.91-46.47-72.1-70.87-92.59C213.4 59.09 224 47.05 224 32a32 32 0 0 0-32-32h-64a32 32 0 0 0-32 32c0 15 10.6 27.09 24.6 30.51C67.81 106.8 8 214.5 8 287.88zM304 448H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h288a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16z"
                }
            }
        ]
    })(props);
}
function FaChessBoard(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M255.9.2h-64v64h64zM0 64.17v64h64v-64zM128 .2H64v64h64zm64 255.9v64h64v-64zM0 192.12v64h64v-64zM383.85.2h-64v64h64zm128 0h-64v64h64zM128 256.1H64v64h64zM511.8 448v-64h-64v64zm0-128v-64h-64v64zM383.85 512h64v-64h-64zm128-319.88v-64h-64v64zM128 512h64v-64h-64zM0 512h64v-64H0zm255.9 0h64v-64h-64zM0 320.07v64h64v-64zm319.88-191.92v-64h-64v64zm-64 128h64v-64h-64zm-64 128v64h64v-64zm128-64h64v-64h-64zm0-127.95h64v-64h-64zm0 191.93v64h64v-64zM64 384.05v64h64v-64zm128-255.9v-64h-64v64zm191.92 255.9h64v-64h-64zm-128-191.93v-64h-64v64zm128-127.95v64h64v-64zm-128 255.9v64h64v-64zm-64-127.95H128v64h64zm191.92 64h64v-64h-64zM128 128.15H64v64h64zm0 191.92v64h64v-64z"
                }
            }
        ]
    })(props);
}
function FaChessKing(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M400 448H48a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h352a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm16-288H256v-48h40a8 8 0 0 0 8-8V56a8 8 0 0 0-8-8h-40V8a8 8 0 0 0-8-8h-48a8 8 0 0 0-8 8v40h-40a8 8 0 0 0-8 8v48a8 8 0 0 0 8 8h40v48H32a32 32 0 0 0-30.52 41.54L74.56 416h298.88l73.08-214.46A32 32 0 0 0 416 160z"
                }
            }
        ]
    })(props);
}
function FaChessKnight(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19 272.47l40.63 18.06a32 32 0 0 0 24.88.47l12.78-5.12a32 32 0 0 0 18.76-20.5l9.22-30.65a24 24 0 0 1 12.55-15.65L159.94 208v50.33a48 48 0 0 1-26.53 42.94l-57.22 28.65A80 80 0 0 0 32 401.48V416h319.86V224c0-106-85.92-192-191.92-192H12A12 12 0 0 0 0 44a16.9 16.9 0 0 0 1.79 7.58L16 80l-9 9a24 24 0 0 0-7 17v137.21a32 32 0 0 0 19 29.26zM52 128a20 20 0 1 1-20 20 20 20 0 0 1 20-20zm316 320H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h352a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16z"
                }
            }
        ]
    })(props);
}
function FaChessPawn(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 320 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M105.1 224H80a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h16v5.49c0 44-4.14 86.6-24 122.51h176c-19.89-35.91-24-78.51-24-122.51V288h16a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16h-25.1c29.39-18.38 49.1-50.78 49.1-88a104 104 0 0 0-208 0c0 37.22 19.71 69.62 49.1 88zM304 448H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h288a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16z"
                }
            }
        ]
    })(props);
}
function FaChessQueen(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 112a56 56 0 1 0-56-56 56 56 0 0 0 56 56zm176 336H80a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h352a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm72.87-263.84l-28.51-15.92c-7.44-5-16.91-2.46-22.29 4.68a47.59 47.59 0 0 1-47.23 18.23C383.7 186.86 368 164.93 368 141.4a13.4 13.4 0 0 0-13.4-13.4h-38.77c-6 0-11.61 4-12.86 9.91a48 48 0 0 1-93.94 0c-1.25-5.92-6.82-9.91-12.86-9.91H157.4a13.4 13.4 0 0 0-13.4 13.4c0 25.69-19 48.75-44.67 50.49a47.5 47.5 0 0 1-41.54-19.15c-5.28-7.09-14.73-9.45-22.09-4.54l-28.57 16a16 16 0 0 0-5.44 20.47L104.24 416h303.52l102.55-211.37a16 16 0 0 0-5.44-20.47z"
                }
            }
        ]
    })(props);
}
function FaChessRook(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M368 32h-56a16 16 0 0 0-16 16v48h-48V48a16 16 0 0 0-16-16h-80a16 16 0 0 0-16 16v48H88.1V48a16 16 0 0 0-16-16H16A16 16 0 0 0 0 48v176l64 32c0 48.33-1.54 95-13.21 160h282.42C321.54 351 320 303.72 320 256l64-32V48a16 16 0 0 0-16-16zM224 320h-64v-64a32 32 0 0 1 64 0zm144 128H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h352a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16z"
                }
            }
        ]
    })(props);
}
function FaChess(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M74 208H64a16 16 0 0 0-16 16v16a16 16 0 0 0 16 16h15.94A535.78 535.78 0 0 1 64 384h128a535.78 535.78 0 0 1-15.94-128H192a16 16 0 0 0 16-16v-16a16 16 0 0 0-16-16h-10l33.89-90.38a16 16 0 0 0-15-21.62H144V64h24a8 8 0 0 0 8-8V40a8 8 0 0 0-8-8h-24V8a8 8 0 0 0-8-8h-16a8 8 0 0 0-8 8v24H88a8 8 0 0 0-8 8v16a8 8 0 0 0 8 8h24v32H55.09a16 16 0 0 0-15 21.62zm173.16 251.58L224 448v-16a16 16 0 0 0-16-16H48a16 16 0 0 0-16 16v16L8.85 459.58A16 16 0 0 0 0 473.89V496a16 16 0 0 0 16 16h224a16 16 0 0 0 16-16v-22.11a16 16 0 0 0-8.84-14.31zm92.77-157.78l-3.29 82.2h126.72l-3.29-82.21 24.6-20.79A32 32 0 0 0 496 256.54V198a6 6 0 0 0-6-6h-26.38a6 6 0 0 0-6 6v26h-24.71v-26a6 6 0 0 0-6-6H373.1a6 6 0 0 0-6 6v26h-24.71v-26a6 6 0 0 0-6-6H310a6 6 0 0 0-6 6v58.6a32 32 0 0 0 11.36 24.4zM384 304a16 16 0 0 1 32 0v32h-32zm119.16 155.58L480 448v-16a16 16 0 0 0-16-16H336a16 16 0 0 0-16 16v16l-23.15 11.58a16 16 0 0 0-8.85 14.31V496a16 16 0 0 0 16 16h192a16 16 0 0 0 16-16v-22.11a16 16 0 0 0-8.84-14.31z"
                }
            }
        ]
    })(props);
}
function FaChevronCircleDown(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M504 256c0 137-111 248-248 248S8 393 8 256 119 8 256 8s248 111 248 248zM273 369.9l135.5-135.5c9.4-9.4 9.4-24.6 0-33.9l-17-17c-9.4-9.4-24.6-9.4-33.9 0L256 285.1 154.4 183.5c-9.4-9.4-24.6-9.4-33.9 0l-17 17c-9.4 9.4-9.4 24.6 0 33.9L239 369.9c9.4 9.4 24.6 9.4 34 0z"
                }
            }
        ]
    })(props);
}
function FaChevronCircleLeft(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 504C119 504 8 393 8 256S119 8 256 8s248 111 248 248-111 248-248 248zM142.1 273l135.5 135.5c9.4 9.4 24.6 9.4 33.9 0l17-17c9.4-9.4 9.4-24.6 0-33.9L226.9 256l101.6-101.6c9.4-9.4 9.4-24.6 0-33.9l-17-17c-9.4-9.4-24.6-9.4-33.9 0L142.1 239c-9.4 9.4-9.4 24.6 0 34z"
                }
            }
        ]
    })(props);
}
function FaChevronCircleRight(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 8c137 0 248 111 248 248S393 504 256 504 8 393 8 256 119 8 256 8zm113.9 231L234.4 103.5c-9.4-9.4-24.6-9.4-33.9 0l-17 17c-9.4 9.4-9.4 24.6 0 33.9L285.1 256 183.5 357.6c-9.4 9.4-9.4 24.6 0 33.9l17 17c9.4 9.4 24.6 9.4 33.9 0L369.9 273c9.4-9.4 9.4-24.6 0-34z"
                }
            }
        ]
    })(props);
}
function FaChevronCircleUp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 256C8 119 119 8 256 8s248 111 248 248-111 248-248 248S8 393 8 256zm231-113.9L103.5 277.6c-9.4 9.4-9.4 24.6 0 33.9l17 17c9.4 9.4 24.6 9.4 33.9 0L256 226.9l101.6 101.6c9.4 9.4 24.6 9.4 33.9 0l17-17c9.4-9.4 9.4-24.6 0-33.9L273 142.1c-9.4-9.4-24.6-9.4-34 0z"
                }
            }
        ]
    })(props);
}
function FaChevronDown(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M207.029 381.476L12.686 187.132c-9.373-9.373-9.373-24.569 0-33.941l22.667-22.667c9.357-9.357 24.522-9.375 33.901-.04L224 284.505l154.745-154.021c9.379-9.335 24.544-9.317 33.901.04l22.667 22.667c9.373 9.373 9.373 24.569 0 33.941L240.971 381.476c-9.373 9.372-24.569 9.372-33.942 0z"
                }
            }
        ]
    })(props);
}
function FaChevronLeft(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 320 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M34.52 239.03L228.87 44.69c9.37-9.37 24.57-9.37 33.94 0l22.67 22.67c9.36 9.36 9.37 24.52.04 33.9L131.49 256l154.02 154.75c9.34 9.38 9.32 24.54-.04 33.9l-22.67 22.67c-9.37 9.37-24.57 9.37-33.94 0L34.52 272.97c-9.37-9.37-9.37-24.57 0-33.94z"
                }
            }
        ]
    })(props);
}
function FaChevronRight(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 320 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M285.476 272.971L91.132 467.314c-9.373 9.373-24.569 9.373-33.941 0l-22.667-22.667c-9.357-9.357-9.375-24.522-.04-33.901L188.505 256 34.484 101.255c-9.335-9.379-9.317-24.544.04-33.901l22.667-22.667c9.373-9.373 24.569-9.373 33.941 0L285.475 239.03c9.373 9.372 9.373 24.568.001 33.941z"
                }
            }
        ]
    })(props);
}
function FaChevronUp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M240.971 130.524l194.343 194.343c9.373 9.373 9.373 24.569 0 33.941l-22.667 22.667c-9.357 9.357-24.522 9.375-33.901.04L224 227.495 69.255 381.516c-9.379 9.335-24.544 9.317-33.901-.04l-22.667-22.667c-9.373-9.373-9.373-24.569 0-33.941L207.03 130.525c9.372-9.373 24.568-9.373 33.941-.001z"
                }
            }
        ]
    })(props);
}
function FaChild(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M120 72c0-39.765 32.235-72 72-72s72 32.235 72 72c0 39.764-32.235 72-72 72s-72-32.236-72-72zm254.627 1.373c-12.496-12.497-32.758-12.497-45.254 0L242.745 160H141.254L54.627 73.373c-12.496-12.497-32.758-12.497-45.254 0-12.497 12.497-12.497 32.758 0 45.255L104 213.254V480c0 17.673 14.327 32 32 32h16c17.673 0 32-14.327 32-32V368h16v112c0 17.673 14.327 32 32 32h16c17.673 0 32-14.327 32-32V213.254l94.627-94.627c12.497-12.497 12.497-32.757 0-45.254z"
                }
            }
        ]
    })(props);
}
function FaChurch(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M464.46 246.68L352 179.2V128h48c8.84 0 16-7.16 16-16V80c0-8.84-7.16-16-16-16h-48V16c0-8.84-7.16-16-16-16h-32c-8.84 0-16 7.16-16 16v48h-48c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h48v51.2l-112.46 67.48A31.997 31.997 0 0 0 160 274.12V512h96v-96c0-35.35 28.65-64 64-64s64 28.65 64 64v96h96V274.12c0-11.24-5.9-21.66-15.54-27.44zM0 395.96V496c0 8.84 7.16 16 16 16h112V320L19.39 366.54A32.024 32.024 0 0 0 0 395.96zm620.61-29.42L512 320v192h112c8.84 0 16-7.16 16-16V395.96c0-12.8-7.63-24.37-19.39-29.42z"
                }
            }
        ]
    })(props);
}
function FaCircleNotch(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M288 39.056v16.659c0 10.804 7.281 20.159 17.686 23.066C383.204 100.434 440 171.518 440 256c0 101.689-82.295 184-184 184-101.689 0-184-82.295-184-184 0-84.47 56.786-155.564 134.312-177.219C216.719 75.874 224 66.517 224 55.712V39.064c0-15.709-14.834-27.153-30.046-23.234C86.603 43.482 7.394 141.206 8.003 257.332c.72 137.052 111.477 246.956 248.531 246.667C393.255 503.711 504 392.788 504 256c0-115.633-79.14-212.779-186.211-240.236C302.678 11.889 288 23.456 288 39.056z"
                }
            }
        ]
    })(props);
}
function FaCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8z"
                }
            }
        ]
    })(props);
}
function FaCity(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M616 192H480V24c0-13.26-10.74-24-24-24H312c-13.26 0-24 10.74-24 24v72h-64V16c0-8.84-7.16-16-16-16h-16c-8.84 0-16 7.16-16 16v80h-64V16c0-8.84-7.16-16-16-16H80c-8.84 0-16 7.16-16 16v80H24c-13.26 0-24 10.74-24 24v360c0 17.67 14.33 32 32 32h576c17.67 0 32-14.33 32-32V216c0-13.26-10.75-24-24-24zM128 404c0 6.63-5.37 12-12 12H76c-6.63 0-12-5.37-12-12v-40c0-6.63 5.37-12 12-12h40c6.63 0 12 5.37 12 12v40zm0-96c0 6.63-5.37 12-12 12H76c-6.63 0-12-5.37-12-12v-40c0-6.63 5.37-12 12-12h40c6.63 0 12 5.37 12 12v40zm0-96c0 6.63-5.37 12-12 12H76c-6.63 0-12-5.37-12-12v-40c0-6.63 5.37-12 12-12h40c6.63 0 12 5.37 12 12v40zm128 192c0 6.63-5.37 12-12 12h-40c-6.63 0-12-5.37-12-12v-40c0-6.63 5.37-12 12-12h40c6.63 0 12 5.37 12 12v40zm0-96c0 6.63-5.37 12-12 12h-40c-6.63 0-12-5.37-12-12v-40c0-6.63 5.37-12 12-12h40c6.63 0 12 5.37 12 12v40zm0-96c0 6.63-5.37 12-12 12h-40c-6.63 0-12-5.37-12-12v-40c0-6.63 5.37-12 12-12h40c6.63 0 12 5.37 12 12v40zm160 96c0 6.63-5.37 12-12 12h-40c-6.63 0-12-5.37-12-12v-40c0-6.63 5.37-12 12-12h40c6.63 0 12 5.37 12 12v40zm0-96c0 6.63-5.37 12-12 12h-40c-6.63 0-12-5.37-12-12v-40c0-6.63 5.37-12 12-12h40c6.63 0 12 5.37 12 12v40zm0-96c0 6.63-5.37 12-12 12h-40c-6.63 0-12-5.37-12-12V76c0-6.63 5.37-12 12-12h40c6.63 0 12 5.37 12 12v40zm160 288c0 6.63-5.37 12-12 12h-40c-6.63 0-12-5.37-12-12v-40c0-6.63 5.37-12 12-12h40c6.63 0 12 5.37 12 12v40zm0-96c0 6.63-5.37 12-12 12h-40c-6.63 0-12-5.37-12-12v-40c0-6.63 5.37-12 12-12h40c6.63 0 12 5.37 12 12v40z"
                }
            }
        ]
    })(props);
}
function FaClinicMedical(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M288 115L69.47 307.71c-1.62 1.46-3.69 2.14-5.47 3.35V496a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16V311.1c-1.7-1.16-3.72-1.82-5.26-3.2zm96 261a8 8 0 0 1-8 8h-56v56a8 8 0 0 1-8 8h-48a8 8 0 0 1-8-8v-56h-56a8 8 0 0 1-8-8v-48a8 8 0 0 1 8-8h56v-56a8 8 0 0 1 8-8h48a8 8 0 0 1 8 8v56h56a8 8 0 0 1 8 8zm186.69-139.72l-255.94-226a39.85 39.85 0 0 0-53.45 0l-256 226a16 16 0 0 0-1.21 22.6L25.5 282.7a16 16 0 0 0 22.6 1.21L277.42 81.63a16 16 0 0 1 21.17 0L527.91 283.9a16 16 0 0 0 22.6-1.21l21.4-23.82a16 16 0 0 0-1.22-22.59z"
                }
            }
        ]
    })(props);
}
function FaClipboardCheck(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M336 64h-80c0-35.3-28.7-64-64-64s-64 28.7-64 64H48C21.5 64 0 85.5 0 112v352c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V112c0-26.5-21.5-48-48-48zM192 40c13.3 0 24 10.7 24 24s-10.7 24-24 24-24-10.7-24-24 10.7-24 24-24zm121.2 231.8l-143 141.8c-4.7 4.7-12.3 4.6-17-.1l-82.6-83.3c-4.7-4.7-4.6-12.3.1-17L99.1 285c4.7-4.7 12.3-4.6 17 .1l46 46.4 106-105.2c4.7-4.7 12.3-4.6 17 .1l28.2 28.4c4.7 4.8 4.6 12.3-.1 17z"
                }
            }
        ]
    })(props);
}
function FaClipboardList(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M336 64h-80c0-35.3-28.7-64-64-64s-64 28.7-64 64H48C21.5 64 0 85.5 0 112v352c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V112c0-26.5-21.5-48-48-48zM96 424c-13.3 0-24-10.7-24-24s10.7-24 24-24 24 10.7 24 24-10.7 24-24 24zm0-96c-13.3 0-24-10.7-24-24s10.7-24 24-24 24 10.7 24 24-10.7 24-24 24zm0-96c-13.3 0-24-10.7-24-24s10.7-24 24-24 24 10.7 24 24-10.7 24-24 24zm96-192c13.3 0 24 10.7 24 24s-10.7 24-24 24-24-10.7-24-24 10.7-24 24-24zm128 368c0 4.4-3.6 8-8 8H168c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h144c4.4 0 8 3.6 8 8v16zm0-96c0 4.4-3.6 8-8 8H168c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h144c4.4 0 8 3.6 8 8v16zm0-96c0 4.4-3.6 8-8 8H168c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h144c4.4 0 8 3.6 8 8v16z"
                }
            }
        ]
    })(props);
}
function FaClipboard(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M384 112v352c0 26.51-21.49 48-48 48H48c-26.51 0-48-21.49-48-48V112c0-26.51 21.49-48 48-48h80c0-35.29 28.71-64 64-64s64 28.71 64 64h80c26.51 0 48 21.49 48 48zM192 40c-13.255 0-24 10.745-24 24s10.745 24 24 24 24-10.745 24-24-10.745-24-24-24m96 114v-20a6 6 0 0 0-6-6H102a6 6 0 0 0-6 6v20a6 6 0 0 0 6 6h180a6 6 0 0 0 6-6z"
                }
            }
        ]
    })(props);
}
function FaClock(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256,8C119,8,8,119,8,256S119,504,256,504,504,393,504,256,393,8,256,8Zm92.49,313h0l-20,25a16,16,0,0,1-22.49,2.5h0l-67-49.72a40,40,0,0,1-15-31.23V112a16,16,0,0,1,16-16h32a16,16,0,0,1,16,16V256l58,42.5A16,16,0,0,1,348.49,321Z"
                }
            }
        ]
    })(props);
}
function FaClone(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M464 0c26.51 0 48 21.49 48 48v288c0 26.51-21.49 48-48 48H176c-26.51 0-48-21.49-48-48V48c0-26.51 21.49-48 48-48h288M176 416c-44.112 0-80-35.888-80-80V128H48c-26.51 0-48 21.49-48 48v288c0 26.51 21.49 48 48 48h288c26.51 0 48-21.49 48-48v-48H176z"
                }
            }
        ]
    })(props);
}
function FaClosedCaptioning(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M464 64H48C21.5 64 0 85.5 0 112v288c0 26.5 21.5 48 48 48h416c26.5 0 48-21.5 48-48V112c0-26.5-21.5-48-48-48zM218.1 287.7c2.8-2.5 7.1-2.1 9.2.9l19.5 27.7c1.7 2.4 1.5 5.6-.5 7.7-53.6 56.8-172.8 32.1-172.8-67.9 0-97.3 121.7-119.5 172.5-70.1 2.1 2 2.5 3.2 1 5.7l-17.5 30.5c-1.9 3.1-6.2 4-9.1 1.7-40.8-32-94.6-14.9-94.6 31.2.1 48 51.1 70.5 92.3 32.6zm190.4 0c2.8-2.5 7.1-2.1 9.2.9l19.5 27.7c1.7 2.4 1.5 5.6-.5 7.7-53.5 56.9-172.7 32.1-172.7-67.9 0-97.3 121.7-119.5 172.5-70.1 2.1 2 2.5 3.2 1 5.7L420 222.2c-1.9 3.1-6.2 4-9.1 1.7-40.8-32-94.6-14.9-94.6 31.2 0 48 51 70.5 92.2 32.6z"
                }
            }
        ]
    })(props);
}
function FaCloudDownloadAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M537.6 226.6c4.1-10.7 6.4-22.4 6.4-34.6 0-53-43-96-96-96-19.7 0-38.1 6-53.3 16.2C367 64.2 315.3 32 256 32c-88.4 0-160 71.6-160 160 0 2.7.1 5.4.2 8.1C40.2 219.8 0 273.2 0 336c0 79.5 64.5 144 144 144h368c70.7 0 128-57.3 128-128 0-61.9-44-113.6-102.4-125.4zm-132.9 88.7L299.3 420.7c-6.2 6.2-16.4 6.2-22.6 0L171.3 315.3c-10.1-10.1-2.9-27.3 11.3-27.3H248V176c0-8.8 7.2-16 16-16h48c8.8 0 16 7.2 16 16v112h65.4c14.2 0 21.4 17.2 11.3 27.3z"
                }
            }
        ]
    })(props);
}
function FaCloudMeatball(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M48 352c-26.5 0-48 21.5-48 48s21.5 48 48 48 48-21.5 48-48-21.5-48-48-48zm416 0c-26.5 0-48 21.5-48 48s21.5 48 48 48 48-21.5 48-48-21.5-48-48-48zm-119 11.1c4.6-14.5 1.6-30.8-9.8-42.3-11.5-11.5-27.8-14.4-42.3-9.9-7-13.5-20.7-23-36.9-23s-29.9 9.5-36.9 23c-14.5-4.6-30.8-1.6-42.3 9.9-11.5 11.5-14.4 27.8-9.9 42.3-13.5 7-23 20.7-23 36.9s9.5 29.9 23 36.9c-4.6 14.5-1.6 30.8 9.9 42.3 8.2 8.2 18.9 12.3 29.7 12.3 4.3 0 8.5-1.1 12.6-2.5 7 13.5 20.7 23 36.9 23s29.9-9.5 36.9-23c4.1 1.3 8.3 2.5 12.6 2.5 10.8 0 21.5-4.1 29.7-12.3 11.5-11.5 14.4-27.8 9.8-42.3 13.5-7 23-20.7 23-36.9s-9.5-29.9-23-36.9zM512 224c0-53-43-96-96-96-.6 0-1.1.2-1.6.2 1.1-5.2 1.6-10.6 1.6-16.2 0-44.2-35.8-80-80-80-24.6 0-46.3 11.3-61 28.8C256.4 24.8 219.3 0 176 0 114.1 0 64 50.1 64 112c0 7.3.8 14.3 2.1 21.2C27.8 145.8 0 181.5 0 224c0 53 43 96 96 96h43.4c3.6-8 8.4-15.4 14.8-21.8 13.5-13.5 31.5-21.1 50.8-21.3 13.5-13.2 31.7-20.9 51-20.9s37.5 7.7 51 20.9c19.3.2 37.3 7.8 50.8 21.3 6.4 6.4 11.3 13.8 14.8 21.8H416c53 0 96-43 96-96z"
                }
            }
        ]
    })(props);
}
function FaCloudMoonRain(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M350.5 225.5c-6.9-37.2-39.3-65.5-78.5-65.5-12.3 0-23.9 3-34.3 8-17.4-24.1-45.6-40-77.7-40-53 0-96 43-96 96 0 .5.2 1.1.2 1.6C27.6 232.9 0 265.2 0 304c0 44.2 35.8 80 80 80h256c44.2 0 80-35.8 80-80 0-39.2-28.2-71.7-65.5-78.5zm217.4-1.7c-70.4 13.3-135-40.3-135-110.8 0-40.6 21.9-78 57.5-98.1 5.5-3.1 4.1-11.4-2.1-12.5C479.6.8 470.7 0 461.8 0c-77.9 0-141.1 61.2-144.4 137.9 26.7 11.9 48.2 33.8 58.9 61.7 37.1 14.3 64 47.4 70.2 86.8 5.1.5 10 1.5 15.2 1.5 44.7 0 85.6-20.2 112.6-53.3 4.2-4.8-.2-12-6.4-10.8zM364.5 418.1c-7.6-4.3-17.4-1.8-21.8 6l-36.6 64c-4.4 7.7-1.7 17.4 6 21.8 2.5 1.4 5.2 2.1 7.9 2.1 5.5 0 10.9-2.9 13.9-8.1l36.6-64c4.3-7.7 1.7-17.4-6-21.8zm-96 0c-7.6-4.3-17.4-1.8-21.8 6l-36.6 64c-4.4 7.7-1.7 17.4 6 21.8 2.5 1.4 5.2 2.1 7.9 2.1 5.5 0 10.9-2.9 13.9-8.1l36.6-64c4.3-7.7 1.7-17.4-6-21.8zm-96 0c-7.6-4.3-17.4-1.8-21.8 6l-36.6 64c-4.4 7.7-1.7 17.4 6 21.8 2.5 1.4 5.2 2.1 7.9 2.1 5.5 0 10.9-2.9 13.9-8.1l36.6-64c4.3-7.7 1.7-17.4-6-21.8zm-96 0c-7.6-4.3-17.4-1.8-21.8 6l-36.6 64c-4.4 7.7-1.7 17.4 6 21.8 2.5 1.4 5.2 2.1 7.9 2.1 5.5 0 10.9-2.9 13.9-8.1l36.6-64c4.3-7.7 1.7-17.4-6-21.8z"
                }
            }
        ]
    })(props);
}
function FaCloudMoon(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M342.8 352.7c5.7-9.6 9.2-20.7 9.2-32.7 0-35.3-28.7-64-64-64-17.2 0-32.8 6.9-44.3 17.9-16.3-29.6-47.5-49.9-83.7-49.9-53 0-96 43-96 96 0 2 .5 3.8.6 5.7C27.1 338.8 0 374.1 0 416c0 53 43 96 96 96h240c44.2 0 80-35.8 80-80 0-41.9-32.3-75.8-73.2-79.3zm222.5-54.3c-93.1 17.7-178.5-53.7-178.5-147.7 0-54.2 29-104 76.1-130.8 7.3-4.1 5.4-15.1-2.8-16.7C448.4 1.1 436.7 0 425 0 319.1 0 233.1 85.9 233.1 192c0 8.5.7 16.8 1.8 25 5.9 4.3 11.6 8.9 16.7 14.2 11.4-4.7 23.7-7.2 36.4-7.2 52.9 0 96 43.1 96 96 0 3.6-.2 7.2-.6 10.7 23.6 10.8 42.4 29.5 53.5 52.6 54.4-3.4 103.7-29.3 137.1-70.4 5.3-6.5-.5-16.1-8.7-14.5z"
                }
            }
        ]
    })(props);
}
function FaCloudRain(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M416 128c-.6 0-1.1.2-1.6.2 1.1-5.2 1.6-10.6 1.6-16.2 0-44.2-35.8-80-80-80-24.6 0-46.3 11.3-61 28.8C256.4 24.8 219.3 0 176 0 114.1 0 64 50.1 64 112c0 7.3.8 14.3 2.1 21.2C27.8 145.8 0 181.5 0 224c0 53 43 96 96 96h320c53 0 96-43 96-96s-43-96-96-96zM88 374.2c-12.8 44.4-40 56.4-40 87.7 0 27.7 21.5 50.1 48 50.1s48-22.4 48-50.1c0-31.4-27.2-43.1-40-87.7-2.2-8.1-13.5-8.5-16 0zm160 0c-12.8 44.4-40 56.4-40 87.7 0 27.7 21.5 50.1 48 50.1s48-22.4 48-50.1c0-31.4-27.2-43.1-40-87.7-2.2-8.1-13.5-8.5-16 0zm160 0c-12.8 44.4-40 56.4-40 87.7 0 27.7 21.5 50.1 48 50.1s48-22.4 48-50.1c0-31.4-27.2-43.1-40-87.7-2.2-8.1-13.5-8.5-16 0z"
                }
            }
        ]
    })(props);
}
function FaCloudShowersHeavy(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M183.9 370.1c-7.6-4.4-17.4-1.8-21.8 6l-64 112c-4.4 7.7-1.7 17.5 6 21.8 2.5 1.4 5.2 2.1 7.9 2.1 5.5 0 10.9-2.9 13.9-8.1l64-112c4.4-7.6 1.7-17.4-6-21.8zm96 0c-7.6-4.4-17.4-1.8-21.8 6l-64 112c-4.4 7.7-1.7 17.5 6 21.8 2.5 1.4 5.2 2.1 7.9 2.1 5.5 0 10.9-2.9 13.9-8.1l64-112c4.4-7.6 1.7-17.4-6-21.8zm-192 0c-7.6-4.4-17.4-1.8-21.8 6l-64 112c-4.4 7.7-1.7 17.5 6 21.8 2.5 1.4 5.2 2.1 7.9 2.1 5.5 0 10.9-2.9 13.9-8.1l64-112c4.4-7.6 1.7-17.4-6-21.8zm384 0c-7.6-4.4-17.4-1.8-21.8 6l-64 112c-4.4 7.7-1.7 17.5 6 21.8 2.5 1.4 5.2 2.1 7.9 2.1 5.5 0 10.9-2.9 13.9-8.1l64-112c4.4-7.6 1.7-17.4-6-21.8zm-96 0c-7.6-4.4-17.4-1.8-21.8 6l-64 112c-4.4 7.7-1.7 17.5 6 21.8 2.5 1.4 5.2 2.1 7.9 2.1 5.5 0 10.9-2.9 13.9-8.1l64-112c4.4-7.6 1.7-17.4-6-21.8zM416 128c-.6 0-1.1.2-1.6.2 1.1-5.2 1.6-10.6 1.6-16.2 0-44.2-35.8-80-80-80-24.6 0-46.3 11.3-61 28.8C256.4 24.8 219.3 0 176 0 114.2 0 64 50.1 64 112c0 7.3.8 14.3 2.1 21.2C27.8 145.8 0 181.5 0 224c0 53 43 96 96 96h320c53 0 96-43 96-96s-43-96-96-96z"
                }
            }
        ]
    })(props);
}
function FaCloudSunRain(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M510.5 225.5c-6.9-37.2-39.3-65.5-78.5-65.5-12.3 0-23.9 3-34.3 8-17.4-24.1-45.6-40-77.7-40-53 0-96 43-96 96 0 .5.2 1.1.2 1.6C187.6 233 160 265.2 160 304c0 44.2 35.8 80 80 80h256c44.2 0 80-35.8 80-80 0-39.2-28.2-71.7-65.5-78.5zm-386.4 34.4c-37.4-37.4-37.4-98.3 0-135.8 34.6-34.6 89.1-36.8 126.7-7.4 20-12.9 43.6-20.7 69.2-20.7.7 0 1.3.2 2 .2l8.9-26.7c3.4-10.2-6.3-19.8-16.5-16.4l-75.3 25.1-35.5-71c-4.8-9.6-18.5-9.6-23.3 0l-35.5 71-75.3-25.1c-10.2-3.4-19.8 6.3-16.4 16.5l25.1 75.3-71 35.5c-9.6 4.8-9.6 18.5 0 23.3l71 35.5-25.1 75.3c-3.4 10.2 6.3 19.8 16.5 16.5l59.2-19.7c-.2-2.4-.7-4.7-.7-7.2 0-12.5 2.3-24.5 6.2-35.9-3.6-2.7-7.1-5.2-10.2-8.3zm69.8-58c4.3-24.5 15.8-46.4 31.9-64-9.8-6.2-21.4-9.9-33.8-9.9-35.3 0-64 28.7-64 64 0 18.7 8.2 35.4 21.1 47.1 11.3-15.9 26.6-28.9 44.8-37.2zm330.6 216.2c-7.6-4.3-17.4-1.8-21.8 6l-36.6 64c-4.4 7.7-1.7 17.4 6 21.8 2.5 1.4 5.2 2.1 7.9 2.1 5.5 0 10.9-2.9 13.9-8.1l36.6-64c4.3-7.7 1.7-17.4-6-21.8zm-96 0c-7.6-4.3-17.4-1.8-21.8 6l-36.6 64c-4.4 7.7-1.7 17.4 6 21.8 2.5 1.4 5.2 2.1 7.9 2.1 5.5 0 10.9-2.9 13.9-8.1l36.6-64c4.3-7.7 1.7-17.4-6-21.8zm-96 0c-7.6-4.3-17.4-1.8-21.8 6l-36.6 64c-4.4 7.7-1.7 17.4 6 21.8 2.5 1.4 5.2 2.1 7.9 2.1 5.5 0 10.9-2.9 13.9-8.1l36.6-64c4.3-7.7 1.7-17.4-6-21.8zm-96 0c-7.6-4.3-17.4-1.8-21.8 6l-36.6 64c-4.4 7.7-1.7 17.4 6 21.8 2.5 1.4 5.2 2.1 7.9 2.1 5.5 0 10.9-2.9 13.9-8.1l36.6-64c4.3-7.7 1.7-17.4-6-21.8z"
                }
            }
        ]
    })(props);
}
function FaCloudSun(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M575.2 325.7c.2-1.9.8-3.7.8-5.6 0-35.3-28.7-64-64-64-12.6 0-24.2 3.8-34.1 10-17.6-38.8-56.5-66-101.9-66-61.8 0-112 50.1-112 112 0 3 .7 5.8.9 8.7-49.6 3.7-88.9 44.7-88.9 95.3 0 53 43 96 96 96h272c53 0 96-43 96-96 0-42.1-27.2-77.4-64.8-90.4zm-430.4-22.6c-43.7-43.7-43.7-114.7 0-158.3 43.7-43.7 114.7-43.7 158.4 0 9.7 9.7 16.9 20.9 22.3 32.7 9.8-3.7 20.1-6 30.7-7.5L386 81.1c4-11.9-7.3-23.1-19.2-19.2L279 91.2 237.5 8.4C232-2.8 216-2.8 210.4 8.4L169 91.2 81.1 61.9C69.3 58 58 69.3 61.9 81.1l29.3 87.8-82.8 41.5c-11.2 5.6-11.2 21.5 0 27.1l82.8 41.4-29.3 87.8c-4 11.9 7.3 23.1 19.2 19.2l76.1-25.3c6.1-12.4 14-23.7 23.6-33.5-13.1-5.4-25.4-13.4-36-24zm-4.8-79.2c0 40.8 29.3 74.8 67.9 82.3 8-4.7 16.3-8.8 25.2-11.7 5.4-44.3 31-82.5 67.4-105C287.3 160.4 258 140 224 140c-46.3 0-84 37.6-84 83.9z"
                }
            }
        ]
    })(props);
}
function FaCloudUploadAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M537.6 226.6c4.1-10.7 6.4-22.4 6.4-34.6 0-53-43-96-96-96-19.7 0-38.1 6-53.3 16.2C367 64.2 315.3 32 256 32c-88.4 0-160 71.6-160 160 0 2.7.1 5.4.2 8.1C40.2 219.8 0 273.2 0 336c0 79.5 64.5 144 144 144h368c70.7 0 128-57.3 128-128 0-61.9-44-113.6-102.4-125.4zM393.4 288H328v112c0 8.8-7.2 16-16 16h-48c-8.8 0-16-7.2-16-16V288h-65.4c-14.3 0-21.4-17.2-11.3-27.3l105.4-105.4c6.2-6.2 16.4-6.2 22.6 0l105.4 105.4c10.1 10.1 2.9 27.3-11.3 27.3z"
                }
            }
        ]
    })(props);
}
function FaCloud(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M537.6 226.6c4.1-10.7 6.4-22.4 6.4-34.6 0-53-43-96-96-96-19.7 0-38.1 6-53.3 16.2C367 64.2 315.3 32 256 32c-88.4 0-160 71.6-160 160 0 2.7.1 5.4.2 8.1C40.2 219.8 0 273.2 0 336c0 79.5 64.5 144 144 144h368c70.7 0 128-57.3 128-128 0-61.9-44-113.6-102.4-125.4z"
                }
            }
        ]
    })(props);
}
function FaCocktail(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M296 464h-56V338.78l168.74-168.73c15.52-15.52 4.53-42.05-17.42-42.05H24.68c-21.95 0-32.94 26.53-17.42 42.05L176 338.78V464h-56c-22.09 0-40 17.91-40 40 0 4.42 3.58 8 8 8h240c4.42 0 8-3.58 8-8 0-22.09-17.91-40-40-40zM432 0c-62.61 0-115.35 40.2-135.18 96h52.54c16.65-28.55 47.27-48 82.64-48 52.93 0 96 43.06 96 96s-43.07 96-96 96c-14.04 0-27.29-3.2-39.32-8.64l-35.26 35.26C379.23 279.92 404.59 288 432 288c79.53 0 144-64.47 144-144S511.53 0 432 0z"
                }
            }
        ]
    })(props);
}
function FaCodeBranch(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M384 144c0-44.2-35.8-80-80-80s-80 35.8-80 80c0 36.4 24.3 67.1 57.5 76.8-.6 16.1-4.2 28.5-11 36.9-15.4 19.2-49.3 22.4-85.2 25.7-28.2 2.6-57.4 5.4-81.3 16.9v-144c32.5-10.2 56-40.5 56-76.3 0-44.2-35.8-80-80-80S0 35.8 0 80c0 35.8 23.5 66.1 56 76.3v199.3C23.5 365.9 0 396.2 0 432c0 44.2 35.8 80 80 80s80-35.8 80-80c0-34-21.2-63.1-51.2-74.6 3.1-5.2 7.8-9.8 14.9-13.4 16.2-8.2 40.4-10.4 66.1-12.8 42.2-3.9 90-8.4 118.2-43.4 14-17.4 21.1-39.8 21.6-67.9 31.6-10.8 54.4-40.7 54.4-75.9zM80 64c8.8 0 16 7.2 16 16s-7.2 16-16 16-16-7.2-16-16 7.2-16 16-16zm0 384c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16zm224-320c8.8 0 16 7.2 16 16s-7.2 16-16 16-16-7.2-16-16 7.2-16 16-16z"
                }
            }
        ]
    })(props);
}
function FaCode(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M278.9 511.5l-61-17.7c-6.4-1.8-10-8.5-8.2-14.9L346.2 8.7c1.8-6.4 8.5-10 14.9-8.2l61 17.7c6.4 1.8 10 8.5 8.2 14.9L293.8 503.3c-1.9 6.4-8.5 10.1-14.9 8.2zm-114-112.2l43.5-46.4c4.6-4.9 4.3-12.7-.8-17.2L117 256l90.6-79.7c5.1-4.5 5.5-12.3.8-17.2l-43.5-46.4c-4.5-4.8-12.1-5.1-17-.5L3.8 247.2c-5.1 4.7-5.1 12.8 0 17.5l144.1 135.1c4.9 4.6 12.5 4.4 17-.5zm327.2.6l144.1-135.1c5.1-4.7 5.1-12.8 0-17.5L492.1 112.1c-4.8-4.5-12.4-4.3-17 .5L431.6 159c-4.6 4.9-4.3 12.7.8 17.2L523 256l-90.6 79.7c-5.1 4.5-5.5 12.3-.8 17.2l43.5 46.4c4.5 4.9 12.1 5.1 17 .6z"
                }
            }
        ]
    })(props);
}
function FaCoffee(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M192 384h192c53 0 96-43 96-96h32c70.6 0 128-57.4 128-128S582.6 32 512 32H120c-13.3 0-24 10.7-24 24v232c0 53 43 96 96 96zM512 96c35.3 0 64 28.7 64 64s-28.7 64-64 64h-32V96h32zm47.7 384H48.3c-47.6 0-61-64-36-64h583.3c25 0 11.8 64-35.9 64z"
                }
            }
        ]
    })(props);
}
function FaCog(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M487.4 315.7l-42.6-24.6c4.3-23.2 4.3-47 0-70.2l42.6-24.6c4.9-2.8 7.1-8.6 5.5-14-11.1-35.6-30-67.8-54.7-94.6-3.8-4.1-10-5.1-14.8-2.3L380.8 110c-17.9-15.4-38.5-27.3-60.8-35.1V25.8c0-5.6-3.9-10.5-9.4-11.7-36.7-8.2-74.3-7.8-109.2 0-5.5 1.2-9.4 6.1-9.4 11.7V75c-22.2 7.9-42.8 19.8-60.8 35.1L88.7 85.5c-4.9-2.8-11-1.9-14.8 2.3-24.7 26.7-43.6 58.9-54.7 94.6-1.7 5.4.6 11.2 5.5 14L67.3 221c-4.3 23.2-4.3 47 0 70.2l-42.6 24.6c-4.9 2.8-7.1 8.6-5.5 14 11.1 35.6 30 67.8 54.7 94.6 3.8 4.1 10 5.1 14.8 2.3l42.6-24.6c17.9 15.4 38.5 27.3 60.8 35.1v49.2c0 5.6 3.9 10.5 9.4 11.7 36.7 8.2 74.3 7.8 109.2 0 5.5-1.2 9.4-6.1 9.4-11.7v-49.2c22.2-7.9 42.8-19.8 60.8-35.1l42.6 24.6c4.9 2.8 11 1.9 14.8-2.3 24.7-26.7 43.6-58.9 54.7-94.6 1.5-5.5-.7-11.3-5.6-14.1zM256 336c-44.1 0-80-35.9-80-80s35.9-80 80-80 80 35.9 80 80-35.9 80-80 80z"
                }
            }
        ]
    })(props);
}
function FaCogs(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M512.1 191l-8.2 14.3c-3 5.3-9.4 7.5-15.1 5.4-11.8-4.4-22.6-10.7-32.1-18.6-4.6-3.8-5.8-10.5-2.8-15.7l8.2-14.3c-6.9-8-12.3-17.3-15.9-27.4h-16.5c-6 0-11.2-4.3-12.2-10.3-2-12-2.1-24.6 0-37.1 1-6 6.2-10.4 12.2-10.4h16.5c3.6-10.1 9-19.4 15.9-27.4l-8.2-14.3c-3-5.2-1.9-11.9 2.8-15.7 9.5-7.9 20.4-14.2 32.1-18.6 5.7-2.1 12.1.1 15.1 5.4l8.2 14.3c10.5-1.9 21.2-1.9 31.7 0L552 6.3c3-5.3 9.4-7.5 15.1-5.4 11.8 4.4 22.6 10.7 32.1 18.6 4.6 3.8 5.8 10.5 2.8 15.7l-8.2 14.3c6.9 8 12.3 17.3 15.9 27.4h16.5c6 0 11.2 4.3 12.2 10.3 2 12 2.1 24.6 0 37.1-1 6-6.2 10.4-12.2 10.4h-16.5c-3.6 10.1-9 19.4-15.9 27.4l8.2 14.3c3 5.2 1.9 11.9-2.8 15.7-9.5 7.9-20.4 14.2-32.1 18.6-5.7 2.1-12.1-.1-15.1-5.4l-8.2-14.3c-10.4 1.9-21.2 1.9-31.7 0zm-10.5-58.8c38.5 29.6 82.4-14.3 52.8-52.8-38.5-29.7-82.4 14.3-52.8 52.8zM386.3 286.1l33.7 16.8c10.1 5.8 14.5 18.1 10.5 29.1-8.9 24.2-26.4 46.4-42.6 65.8-7.4 8.9-20.2 11.1-30.3 5.3l-29.1-16.8c-16 13.7-34.6 24.6-54.9 31.7v33.6c0 11.6-8.3 21.6-19.7 23.6-24.6 4.2-50.4 4.4-75.9 0-11.5-2-20-11.9-20-23.6V418c-20.3-7.2-38.9-18-54.9-31.7L74 403c-10 5.8-22.9 3.6-30.3-5.3-16.2-19.4-33.3-41.6-42.2-65.7-4-10.9.4-23.2 10.5-29.1l33.3-16.8c-3.9-20.9-3.9-42.4 0-63.4L12 205.8c-10.1-5.8-14.6-18.1-10.5-29 8.9-24.2 26-46.4 42.2-65.8 7.4-8.9 20.2-11.1 30.3-5.3l29.1 16.8c16-13.7 34.6-24.6 54.9-31.7V57.1c0-11.5 8.2-21.5 19.6-23.5 24.6-4.2 50.5-4.4 76-.1 11.5 2 20 11.9 20 23.6v33.6c20.3 7.2 38.9 18 54.9 31.7l29.1-16.8c10-5.8 22.9-3.6 30.3 5.3 16.2 19.4 33.2 41.6 42.1 65.8 4 10.9.1 23.2-10 29.1l-33.7 16.8c3.9 21 3.9 42.5 0 63.5zm-117.6 21.1c59.2-77-28.7-164.9-105.7-105.7-59.2 77 28.7 164.9 105.7 105.7zm243.4 182.7l-8.2 14.3c-3 5.3-9.4 7.5-15.1 5.4-11.8-4.4-22.6-10.7-32.1-18.6-4.6-3.8-5.8-10.5-2.8-15.7l8.2-14.3c-6.9-8-12.3-17.3-15.9-27.4h-16.5c-6 0-11.2-4.3-12.2-10.3-2-12-2.1-24.6 0-37.1 1-6 6.2-10.4 12.2-10.4h16.5c3.6-10.1 9-19.4 15.9-27.4l-8.2-14.3c-3-5.2-1.9-11.9 2.8-15.7 9.5-7.9 20.4-14.2 32.1-18.6 5.7-2.1 12.1.1 15.1 5.4l8.2 14.3c10.5-1.9 21.2-1.9 31.7 0l8.2-14.3c3-5.3 9.4-7.5 15.1-5.4 11.8 4.4 22.6 10.7 32.1 18.6 4.6 3.8 5.8 10.5 2.8 15.7l-8.2 14.3c6.9 8 12.3 17.3 15.9 27.4h16.5c6 0 11.2 4.3 12.2 10.3 2 12 2.1 24.6 0 37.1-1 6-6.2 10.4-12.2 10.4h-16.5c-3.6 10.1-9 19.4-15.9 27.4l8.2 14.3c3 5.2 1.9 11.9-2.8 15.7-9.5 7.9-20.4 14.2-32.1 18.6-5.7 2.1-12.1-.1-15.1-5.4l-8.2-14.3c-10.4 1.9-21.2 1.9-31.7 0zM501.6 431c38.5 29.6 82.4-14.3 52.8-52.8-38.5-29.6-82.4 14.3-52.8 52.8z"
                }
            }
        ]
    })(props);
}
function FaCoins(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 405.3V448c0 35.3 86 64 192 64s192-28.7 192-64v-42.7C342.7 434.4 267.2 448 192 448S41.3 434.4 0 405.3zM320 128c106 0 192-28.7 192-64S426 0 320 0 128 28.7 128 64s86 64 192 64zM0 300.4V352c0 35.3 86 64 192 64s192-28.7 192-64v-51.6c-41.3 34-116.9 51.6-192 51.6S41.3 334.4 0 300.4zm416 11c57.3-11.1 96-31.7 96-55.4v-42.7c-23.2 16.4-57.3 27.6-96 34.5v63.6zM192 160C86 160 0 195.8 0 240s86 80 192 80 192-35.8 192-80-86-80-192-80zm219.3 56.3c60-10.8 100.7-32 100.7-56.3v-42.7c-35.5 25.1-96.5 38.6-160.7 41.8 29.5 14.3 51.2 33.5 60 57.2z"
                }
            }
        ]
    })(props);
}
function FaColumns(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M464 32H48C21.49 32 0 53.49 0 80v352c0 26.51 21.49 48 48 48h416c26.51 0 48-21.49 48-48V80c0-26.51-21.49-48-48-48zM224 416H64V160h160v256zm224 0H288V160h160v256z"
                }
            }
        ]
    })(props);
}
function FaCommentAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M448 0H64C28.7 0 0 28.7 0 64v288c0 35.3 28.7 64 64 64h96v84c0 9.8 11.2 15.5 19.1 9.7L304 416h144c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64z"
                }
            }
        ]
    })(props);
}
function FaCommentDollar(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 32C114.62 32 0 125.12 0 240c0 49.56 21.41 95.01 57.02 130.74C44.46 421.05 2.7 465.97 2.2 466.5A7.995 7.995 0 0 0 8 480c66.26 0 115.99-31.75 140.6-51.38C181.29 440.93 217.59 448 256 448c141.38 0 256-93.12 256-208S397.38 32 256 32zm24 302.44V352c0 8.84-7.16 16-16 16h-16c-8.84 0-16-7.16-16-16v-17.73c-11.42-1.35-22.28-5.19-31.78-11.46-6.22-4.11-6.82-13.11-1.55-18.38l17.52-17.52c3.74-3.74 9.31-4.24 14.11-2.03 3.18 1.46 6.66 2.22 10.26 2.22h32.78c4.66 0 8.44-3.78 8.44-8.42 0-3.75-2.52-7.08-6.12-8.11l-50.07-14.3c-22.25-6.35-40.01-24.71-42.91-47.67-4.05-32.07 19.03-59.43 49.32-63.05V128c0-8.84 7.16-16 16-16h16c8.84 0 16 7.16 16 16v17.73c11.42 1.35 22.28 5.19 31.78 11.46 6.22 4.11 6.82 13.11 1.55 18.38l-17.52 17.52c-3.74 3.74-9.31 4.24-14.11 2.03a24.516 24.516 0 0 0-10.26-2.22h-32.78c-4.66 0-8.44 3.78-8.44 8.42 0 3.75 2.52 7.08 6.12 8.11l50.07 14.3c22.25 6.36 40.01 24.71 42.91 47.67 4.05 32.06-19.03 59.42-49.32 63.04z"
                }
            }
        ]
    })(props);
}
function FaCommentDots(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 32C114.6 32 0 125.1 0 240c0 49.6 21.4 95 57 130.7C44.5 421.1 2.7 466 2.2 466.5c-2.2 2.3-2.8 5.7-1.5 8.7S4.8 480 8 480c66.3 0 116-31.8 140.6-51.4 32.7 12.3 69 19.4 107.4 19.4 141.4 0 256-93.1 256-208S397.4 32 256 32zM128 272c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm128 0c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm128 0c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32z"
                }
            }
        ]
    })(props);
}
function FaCommentMedical(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 32C114.62 32 0 125.12 0 240c0 49.56 21.41 95 57 130.74C44.46 421.05 2.7 466 2.2 466.5A8 8 0 0 0 8 480c66.26 0 116-31.75 140.6-51.38A304.66 304.66 0 0 0 256 448c141.39 0 256-93.12 256-208S397.39 32 256 32zm96 232a8 8 0 0 1-8 8h-56v56a8 8 0 0 1-8 8h-48a8 8 0 0 1-8-8v-56h-56a8 8 0 0 1-8-8v-48a8 8 0 0 1 8-8h56v-56a8 8 0 0 1 8-8h48a8 8 0 0 1 8 8v56h56a8 8 0 0 1 8 8z"
                }
            }
        ]
    })(props);
}
function FaCommentSlash(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M64 240c0 49.6 21.4 95 57 130.7-12.6 50.3-54.3 95.2-54.8 95.8-2.2 2.3-2.8 5.7-1.5 8.7 1.3 2.9 4.1 4.8 7.3 4.8 66.3 0 116-31.8 140.6-51.4 32.7 12.3 69 19.4 107.4 19.4 27.4 0 53.7-3.6 78.4-10L72.9 186.4c-5.6 17.1-8.9 35-8.9 53.6zm569.8 218.1l-114.4-88.4C554.6 334.1 576 289.2 576 240c0-114.9-114.6-208-256-208-65.1 0-124.2 20.1-169.4 52.7L45.5 3.4C38.5-2 28.5-.8 23 6.2L3.4 31.4c-5.4 7-4.2 17 2.8 22.4l588.4 454.7c7 5.4 17 4.2 22.5-2.8l19.6-25.3c5.4-6.8 4.1-16.9-2.9-22.3z"
                }
            }
        ]
    })(props);
}
function FaComment(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 32C114.6 32 0 125.1 0 240c0 49.6 21.4 95 57 130.7C44.5 421.1 2.7 466 2.2 466.5c-2.2 2.3-2.8 5.7-1.5 8.7S4.8 480 8 480c66.3 0 116-31.8 140.6-51.4 32.7 12.3 69 19.4 107.4 19.4 141.4 0 256-93.1 256-208S397.4 32 256 32z"
                }
            }
        ]
    })(props);
}
function FaCommentsDollar(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M416 192c0-88.37-93.12-160-208-160S0 103.63 0 192c0 34.27 14.13 65.95 37.97 91.98C24.61 314.22 2.52 338.16 2.2 338.5A7.995 7.995 0 0 0 8 352c36.58 0 66.93-12.25 88.73-24.98C128.93 342.76 167.02 352 208 352c114.88 0 208-71.63 208-160zm-224 96v-16.29c-11.29-.58-22.27-4.52-31.37-11.35-3.9-2.93-4.1-8.77-.57-12.14l11.75-11.21c2.77-2.64 6.89-2.76 10.13-.73 3.87 2.42 8.26 3.72 12.82 3.72h28.11c6.5 0 11.8-5.92 11.8-13.19 0-5.95-3.61-11.19-8.77-12.73l-45-13.5c-18.59-5.58-31.58-23.42-31.58-43.39 0-24.52 19.05-44.44 42.67-45.07V96c0-4.42 3.58-8 8-8h16c4.42 0 8 3.58 8 8v16.29c11.29.58 22.27 4.51 31.37 11.35 3.9 2.93 4.1 8.77.57 12.14l-11.75 11.21c-2.77 2.64-6.89 2.76-10.13.73-3.87-2.43-8.26-3.72-12.82-3.72h-28.11c-6.5 0-11.8 5.92-11.8 13.19 0 5.95 3.61 11.19 8.77 12.73l45 13.5c18.59 5.58 31.58 23.42 31.58 43.39 0 24.53-19.05 44.44-42.67 45.07V288c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8zm346.01 123.99C561.87 385.96 576 354.27 576 320c0-66.94-53.49-124.2-129.33-148.07.86 6.6 1.33 13.29 1.33 20.07 0 105.87-107.66 192-240 192-10.78 0-21.32-.77-31.73-1.88C207.8 439.63 281.77 480 368 480c40.98 0 79.07-9.24 111.27-24.98C501.07 467.75 531.42 480 568 480c3.2 0 6.09-1.91 7.34-4.84 1.27-2.94.66-6.34-1.55-8.67-.31-.33-22.42-24.24-35.78-54.5z"
                }
            }
        ]
    })(props);
}
function FaComments(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M416 192c0-88.4-93.1-160-208-160S0 103.6 0 192c0 34.3 14.1 65.9 38 92-13.4 30.2-35.5 54.2-35.8 54.5-2.2 2.3-2.8 5.7-1.5 8.7S4.8 352 8 352c36.6 0 66.9-12.3 88.7-25 32.2 15.7 70.3 25 111.3 25 114.9 0 208-71.6 208-160zm122 220c23.9-26 38-57.7 38-92 0-66.9-53.5-124.2-129.3-148.1.9 6.6 1.3 13.3 1.3 20.1 0 105.9-107.7 192-240 192-10.8 0-21.3-.8-31.7-1.9C207.8 439.6 281.8 480 368 480c41 0 79.1-9.2 111.3-25 21.8 12.7 52.1 25 88.7 25 3.2 0 6.1-1.9 7.3-4.8 1.3-2.9.7-6.3-1.5-8.7-.3-.3-22.4-24.2-35.8-54.5z"
                }
            }
        ]
    })(props);
}
function FaCompactDisc(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zM88 256H56c0-105.9 86.1-192 192-192v32c-88.2 0-160 71.8-160 160zm160 96c-53 0-96-43-96-96s43-96 96-96 96 43 96 96-43 96-96 96zm0-128c-17.7 0-32 14.3-32 32s14.3 32 32 32 32-14.3 32-32-14.3-32-32-32z"
                }
            }
        ]
    })(props);
}
function FaCompass(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M225.38 233.37c-12.5 12.5-12.5 32.76 0 45.25 12.49 12.5 32.76 12.5 45.25 0 12.5-12.5 12.5-32.76 0-45.25-12.5-12.49-32.76-12.49-45.25 0zM248 8C111.03 8 0 119.03 0 256s111.03 248 248 248 248-111.03 248-248S384.97 8 248 8zm126.14 148.05L308.17 300.4a31.938 31.938 0 0 1-15.77 15.77l-144.34 65.97c-16.65 7.61-33.81-9.55-26.2-26.2l65.98-144.35a31.938 31.938 0 0 1 15.77-15.77l144.34-65.97c16.65-7.6 33.8 9.55 26.19 26.2z"
                }
            }
        ]
    })(props);
}
function FaCompressAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4.686 427.314L104 328l-32.922-31.029C55.958 281.851 66.666 256 88.048 256h112C213.303 256 224 266.745 224 280v112c0 21.382-25.803 32.09-40.922 16.971L152 376l-99.314 99.314c-6.248 6.248-16.379 6.248-22.627 0L4.686 449.941c-6.248-6.248-6.248-16.379 0-22.627zM443.314 84.686L344 184l32.922 31.029c15.12 15.12 4.412 40.971-16.97 40.971h-112C234.697 256 224 245.255 224 232V120c0-21.382 25.803-32.09 40.922-16.971L296 136l99.314-99.314c6.248-6.248 16.379-6.248 22.627 0l25.373 25.373c6.248 6.248 6.248 16.379 0 22.627z"
                }
            }
        ]
    })(props);
}
function FaCompressArrowsAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M200 288H88c-21.4 0-32.1 25.8-17 41l32.9 31-99.2 99.3c-6.2 6.2-6.2 16.4 0 22.6l25.4 25.4c6.2 6.2 16.4 6.2 22.6 0L152 408l31.1 33c15.1 15.1 40.9 4.4 40.9-17V312c0-13.3-10.7-24-24-24zm112-64h112c21.4 0 32.1-25.9 17-41l-33-31 99.3-99.3c6.2-6.2 6.2-16.4 0-22.6L481.9 4.7c-6.2-6.2-16.4-6.2-22.6 0L360 104l-31.1-33C313.8 55.9 288 66.6 288 88v112c0 13.3 10.7 24 24 24zm96 136l33-31.1c15.1-15.1 4.4-40.9-17-40.9H312c-13.3 0-24 10.7-24 24v112c0 21.4 25.9 32.1 41 17l31-32.9 99.3 99.3c6.2 6.2 16.4 6.2 22.6 0l25.4-25.4c6.2-6.2 6.2-16.4 0-22.6L408 360zM183 71.1L152 104 52.7 4.7c-6.2-6.2-16.4-6.2-22.6 0L4.7 30.1c-6.2 6.2-6.2 16.4 0 22.6L104 152l-33 31.1C55.9 198.2 66.6 224 88 224h112c13.3 0 24-10.7 24-24V88c0-21.3-25.9-32-41-16.9z"
                }
            }
        ]
    })(props);
}
function FaCompress(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M436 192H312c-13.3 0-24-10.7-24-24V44c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v84h84c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12zm-276-24V44c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v84H12c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h124c13.3 0 24-10.7 24-24zm0 300V344c0-13.3-10.7-24-24-24H12c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h84v84c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12zm192 0v-84h84c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12H312c-13.3 0-24 10.7-24 24v124c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12z"
                }
            }
        ]
    })(props);
}
function FaConciergeBell(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M288 130.54V112h16c8.84 0 16-7.16 16-16V80c0-8.84-7.16-16-16-16h-96c-8.84 0-16 7.16-16 16v16c0 8.84 7.16 16 16 16h16v18.54C115.49 146.11 32 239.18 32 352h448c0-112.82-83.49-205.89-192-221.46zM496 384H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h480c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16z"
                }
            }
        ]
    })(props);
}
function FaCookieBite(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M510.52 255.82c-69.97-.85-126.47-57.69-126.47-127.86-70.17 0-127-56.49-127.86-126.45-27.26-4.14-55.13.3-79.72 12.82l-69.13 35.22a132.221 132.221 0 0 0-57.79 57.81l-35.1 68.88a132.645 132.645 0 0 0-12.82 80.95l12.08 76.27a132.521 132.521 0 0 0 37.16 72.96l54.77 54.76a132.036 132.036 0 0 0 72.71 37.06l76.71 12.15c27.51 4.36 55.7-.11 80.53-12.76l69.13-35.21a132.273 132.273 0 0 0 57.79-57.81l35.1-68.88c12.56-24.64 17.01-52.58 12.91-79.91zM176 368c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm32-160c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm160 128c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32z"
                }
            }
        ]
    })(props);
}
function FaCookie(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M510.37 254.79l-12.08-76.26a132.493 132.493 0 0 0-37.16-72.95l-54.76-54.75c-19.73-19.72-45.18-32.7-72.71-37.05l-76.7-12.15c-27.51-4.36-55.69.11-80.52 12.76L107.32 49.6a132.25 132.25 0 0 0-57.79 57.8l-35.1 68.88a132.602 132.602 0 0 0-12.82 80.94l12.08 76.27a132.493 132.493 0 0 0 37.16 72.95l54.76 54.75a132.087 132.087 0 0 0 72.71 37.05l76.7 12.14c27.51 4.36 55.69-.11 80.52-12.75l69.12-35.21a132.302 132.302 0 0 0 57.79-57.8l35.1-68.87c12.71-24.96 17.2-53.3 12.82-80.96zM176 368c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm32-160c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm160 128c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32z"
                }
            }
        ]
    })(props);
}
function FaCopy(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M320 448v40c0 13.255-10.745 24-24 24H24c-13.255 0-24-10.745-24-24V120c0-13.255 10.745-24 24-24h72v296c0 30.879 25.121 56 56 56h168zm0-344V0H152c-13.255 0-24 10.745-24 24v368c0 13.255 10.745 24 24 24h272c13.255 0 24-10.745 24-24V128H344c-13.2 0-24-10.8-24-24zm120.971-31.029L375.029 7.029A24 24 0 0 0 358.059 0H352v96h96v-6.059a24 24 0 0 0-7.029-16.97z"
                }
            }
        ]
    })(props);
}
function FaCopyright(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 8C119.033 8 8 119.033 8 256s111.033 248 248 248 248-111.033 248-248S392.967 8 256 8zm117.134 346.753c-1.592 1.867-39.776 45.731-109.851 45.731-84.692 0-144.484-63.26-144.484-145.567 0-81.303 62.004-143.401 143.762-143.401 66.957 0 101.965 37.315 103.422 38.904a12 12 0 0 1 1.238 14.623l-22.38 34.655c-4.049 6.267-12.774 7.351-18.234 2.295-.233-.214-26.529-23.88-61.88-23.88-46.116 0-73.916 33.575-73.916 76.082 0 39.602 25.514 79.692 74.277 79.692 38.697 0 65.28-28.338 65.544-28.625 5.132-5.565 14.059-5.033 18.508 1.053l24.547 33.572a12.001 12.001 0 0 1-.553 14.866z"
                }
            }
        ]
    })(props);
}
function FaCouch(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M160 224v64h320v-64c0-35.3 28.7-64 64-64h32c0-53-43-96-96-96H160c-53 0-96 43-96 96h32c35.3 0 64 28.7 64 64zm416-32h-32c-17.7 0-32 14.3-32 32v96H128v-96c0-17.7-14.3-32-32-32H64c-35.3 0-64 28.7-64 64 0 23.6 13 44 32 55.1V432c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16v-16h384v16c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16V311.1c19-11.1 32-31.5 32-55.1 0-35.3-28.7-64-64-64z"
                }
            }
        ]
    })(props);
}
function FaCreditCard(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 432c0 26.5 21.5 48 48 48h480c26.5 0 48-21.5 48-48V256H0v176zm192-68c0-6.6 5.4-12 12-12h136c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12H204c-6.6 0-12-5.4-12-12v-40zm-128 0c0-6.6 5.4-12 12-12h72c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12H76c-6.6 0-12-5.4-12-12v-40zM576 80v48H0V80c0-26.5 21.5-48 48-48h480c26.5 0 48 21.5 48 48z"
                }
            }
        ]
    })(props);
}
function FaCropAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M488 352h-40V96c0-17.67-14.33-32-32-32H192v96h160v328c0 13.25 10.75 24 24 24h48c13.25 0 24-10.75 24-24v-40h40c13.25 0 24-10.75 24-24v-48c0-13.26-10.75-24-24-24zM160 24c0-13.26-10.75-24-24-24H88C74.75 0 64 10.74 64 24v40H24C10.75 64 0 74.74 0 88v48c0 13.25 10.75 24 24 24h40v256c0 17.67 14.33 32 32 32h224v-96H160V24z"
                }
            }
        ]
    })(props);
}
function FaCrop(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M488 352h-40V109.25l59.31-59.31c6.25-6.25 6.25-16.38 0-22.63L484.69 4.69c-6.25-6.25-16.38-6.25-22.63 0L402.75 64H192v96h114.75L160 306.75V24c0-13.26-10.75-24-24-24H88C74.75 0 64 10.74 64 24v40H24C10.75 64 0 74.74 0 88v48c0 13.25 10.75 24 24 24h40v264c0 13.25 10.75 24 24 24h232v-96H205.25L352 205.25V488c0 13.25 10.75 24 24 24h48c13.25 0 24-10.75 24-24v-40h40c13.25 0 24-10.75 24-24v-48c0-13.26-10.75-24-24-24z"
                }
            }
        ]
    })(props);
}
function FaCross(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M352 128h-96V32c0-17.67-14.33-32-32-32h-64c-17.67 0-32 14.33-32 32v96H32c-17.67 0-32 14.33-32 32v64c0 17.67 14.33 32 32 32h96v224c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32V256h96c17.67 0 32-14.33 32-32v-64c0-17.67-14.33-32-32-32z"
                }
            }
        ]
    })(props);
}
function FaCrosshairs(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M500 224h-30.364C455.724 130.325 381.675 56.276 288 42.364V12c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v30.364C130.325 56.276 56.276 130.325 42.364 224H12c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h30.364C56.276 381.675 130.325 455.724 224 469.636V500c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12v-30.364C381.675 455.724 455.724 381.675 469.636 288H500c6.627 0 12-5.373 12-12v-40c0-6.627-5.373-12-12-12zM288 404.634V364c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40.634C165.826 392.232 119.783 346.243 107.366 288H148c6.627 0 12-5.373 12-12v-40c0-6.627-5.373-12-12-12h-40.634C119.768 165.826 165.757 119.783 224 107.366V148c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12v-40.634C346.174 119.768 392.217 165.757 404.634 224H364c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40.634C392.232 346.174 346.243 392.217 288 404.634zM288 256c0 17.673-14.327 32-32 32s-32-14.327-32-32c0-17.673 14.327-32 32-32s32 14.327 32 32z"
                }
            }
        ]
    })(props);
}
function FaCrow(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M544 32h-16.36C513.04 12.68 490.09 0 464 0c-44.18 0-80 35.82-80 80v20.98L12.09 393.57A30.216 30.216 0 0 0 0 417.74c0 22.46 23.64 37.07 43.73 27.03L165.27 384h96.49l44.41 120.1c2.27 6.23 9.15 9.44 15.38 7.17l22.55-8.21c6.23-2.27 9.44-9.15 7.17-15.38L312.94 384H352c1.91 0 3.76-.23 5.66-.29l44.51 120.38c2.27 6.23 9.15 9.44 15.38 7.17l22.55-8.21c6.23-2.27 9.44-9.15 7.17-15.38l-41.24-111.53C485.74 352.8 544 279.26 544 192v-80l96-16c0-35.35-42.98-64-96-64zm-80 72c-13.25 0-24-10.75-24-24 0-13.26 10.75-24 24-24s24 10.74 24 24c0 13.25-10.75 24-24 24z"
                }
            }
        ]
    })(props);
}
function FaCrown(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M528 448H112c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h416c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zm64-320c-26.5 0-48 21.5-48 48 0 7.1 1.6 13.7 4.4 19.8L476 239.2c-15.4 9.2-35.3 4-44.2-11.6L350.3 85C361 76.2 368 63 368 48c0-26.5-21.5-48-48-48s-48 21.5-48 48c0 15 7 28.2 17.7 37l-81.5 142.6c-8.9 15.6-28.9 20.8-44.2 11.6l-72.3-43.4c2.7-6 4.4-12.7 4.4-19.8 0-26.5-21.5-48-48-48S0 149.5 0 176s21.5 48 48 48c2.6 0 5.2-.4 7.7-.8L128 416h384l72.3-192.8c2.5.4 5.1.8 7.7.8 26.5 0 48-21.5 48-48s-21.5-48-48-48z"
                }
            }
        ]
    })(props);
}
function FaCrutch(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M507.31 185.71l-181-181a16 16 0 0 0-22.62 0L281 27.31a16 16 0 0 0 0 22.63l181 181a16 16 0 0 0 22.63 0l22.62-22.63a16 16 0 0 0 .06-22.6zm-179.54 66.41l-67.89-67.89 55.1-55.1-45.25-45.25-109.67 109.67a96.08 96.08 0 0 0-25.67 46.29L106.65 360.1l-102 102a16 16 0 0 0 0 22.63l22.62 22.62a16 16 0 0 0 22.63 0l102-102 120.25-27.75a95.88 95.88 0 0 0 46.29-25.65l109.68-109.68L382.87 197zm-54.57 54.57a32 32 0 0 1-15.45 8.54l-79.3 18.32 18.3-79.3a32.22 32.22 0 0 1 8.56-15.45l9.31-9.31 67.89 67.89z"
                }
            }
        ]
    })(props);
}
function FaCube(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M239.1 6.3l-208 78c-18.7 7-31.1 25-31.1 45v225.1c0 18.2 10.3 34.8 26.5 42.9l208 104c13.5 6.8 29.4 6.8 42.9 0l208-104c16.3-8.1 26.5-24.8 26.5-42.9V129.3c0-20-12.4-37.9-31.1-44.9l-208-78C262 2.2 250 2.2 239.1 6.3zM256 68.4l192 72v1.1l-192 78-192-78v-1.1l192-72zm32 356V275.5l160-65v133.9l-160 80z"
                }
            }
        ]
    })(props);
}
function FaCubes(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M488.6 250.2L392 214V105.5c0-15-9.3-28.4-23.4-33.7l-100-37.5c-8.1-3.1-17.1-3.1-25.3 0l-100 37.5c-14.1 5.3-23.4 18.7-23.4 33.7V214l-96.6 36.2C9.3 255.5 0 268.9 0 283.9V394c0 13.6 7.7 26.1 19.9 32.2l100 50c10.1 5.1 22.1 5.1 32.2 0l103.9-52 103.9 52c10.1 5.1 22.1 5.1 32.2 0l100-50c12.2-6.1 19.9-18.6 19.9-32.2V283.9c0-15-9.3-28.4-23.4-33.7zM358 214.8l-85 31.9v-68.2l85-37v73.3zM154 104.1l102-38.2 102 38.2v.6l-102 41.4-102-41.4v-.6zm84 291.1l-85 42.5v-79.1l85-38.8v75.4zm0-112l-102 41.4-102-41.4v-.6l102-38.2 102 38.2v.6zm240 112l-85 42.5v-79.1l85-38.8v75.4zm0-112l-102 41.4-102-41.4v-.6l102-38.2 102 38.2v.6z"
                }
            }
        ]
    })(props);
}
function FaCut(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M278.06 256L444.48 89.57c4.69-4.69 4.69-12.29 0-16.97-32.8-32.8-85.99-32.8-118.79 0L210.18 188.12l-24.86-24.86c4.31-10.92 6.68-22.81 6.68-35.26 0-53.02-42.98-96-96-96S0 74.98 0 128s42.98 96 96 96c4.54 0 8.99-.32 13.36-.93L142.29 256l-32.93 32.93c-4.37-.61-8.83-.93-13.36-.93-53.02 0-96 42.98-96 96s42.98 96 96 96 96-42.98 96-96c0-12.45-2.37-24.34-6.68-35.26l24.86-24.86L325.69 439.4c32.8 32.8 85.99 32.8 118.79 0 4.69-4.68 4.69-12.28 0-16.97L278.06 256zM96 160c-17.64 0-32-14.36-32-32s14.36-32 32-32 32 14.36 32 32-14.36 32-32 32zm0 256c-17.64 0-32-14.36-32-32s14.36-32 32-32 32 14.36 32 32-14.36 32-32 32z"
                }
            }
        ]
    })(props);
}
function FaDatabase(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M448 73.143v45.714C448 159.143 347.667 192 224 192S0 159.143 0 118.857V73.143C0 32.857 100.333 0 224 0s224 32.857 224 73.143zM448 176v102.857C448 319.143 347.667 352 224 352S0 319.143 0 278.857V176c48.125 33.143 136.208 48.572 224 48.572S399.874 209.143 448 176zm0 160v102.857C448 479.143 347.667 512 224 512S0 479.143 0 438.857V336c48.125 33.143 136.208 48.572 224 48.572S399.874 369.143 448 336z"
                }
            }
        ]
    })(props);
}
function FaDeaf(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M216 260c0 15.464-12.536 28-28 28s-28-12.536-28-28c0-44.112 35.888-80 80-80s80 35.888 80 80c0 15.464-12.536 28-28 28s-28-12.536-28-28c0-13.234-10.767-24-24-24s-24 10.766-24 24zm24-176c-97.047 0-176 78.953-176 176 0 15.464 12.536 28 28 28s28-12.536 28-28c0-66.168 53.832-120 120-120s120 53.832 120 120c0 75.164-71.009 70.311-71.997 143.622L288 404c0 28.673-23.327 52-52 52-15.464 0-28 12.536-28 28s12.536 28 28 28c59.475 0 107.876-48.328 108-107.774.595-34.428 72-48.24 72-144.226 0-97.047-78.953-176-176-176zm268.485-52.201L480.2 3.515c-4.687-4.686-12.284-4.686-16.971 0L376.2 90.544c-4.686 4.686-4.686 12.284 0 16.971l28.285 28.285c4.686 4.686 12.284 4.686 16.97 0l87.03-87.029c4.687-4.688 4.687-12.286 0-16.972zM168.97 314.745c-4.686-4.686-12.284-4.686-16.97 0L3.515 463.23c-4.686 4.686-4.686 12.284 0 16.971L31.8 508.485c4.687 4.686 12.284 4.686 16.971 0L197.256 360c4.686-4.686 4.686-12.284 0-16.971l-28.286-28.284z"
                }
            }
        ]
    })(props);
}
function FaDemocrat(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M637.3 256.9l-19.6-29.4c-28.2-42.3-75.3-67.5-126.1-67.5H256l-81.2-81.2c20.1-20.1 22.6-51.1 7.5-73.9-3.4-5.2-10.8-5.9-15.2-1.5l-41.8 41.8L82.4 2.4c-3.6-3.6-9.6-3-12.4 1.2-12.3 18.6-10.3 44 6.1 60.4 3.3 3.3 7.3 5.3 11.3 7.5-2.2 1.7-4.7 3.1-6.4 5.4L6.4 176.2c-7.3 9.7-8.4 22.7-3 33.5l14.3 28.6c5.4 10.8 16.5 17.7 28.6 17.7h31c8.5 0 16.6-3.4 22.6-9.4L138 212l54 108h352v-77.8c16.2 12.2 18.3 17.6 40.1 50.3 4.9 7.4 14.8 9.3 22.2 4.4l26.6-17.7c7.3-5 9.3-14.9 4.4-22.3zm-341.1-13.6l-16.5 16.1 3.9 22.7c.7 4.1-3.6 7.2-7.2 5.3L256 276.7l-20.4 10.7c-3.6 1.9-7.9-1.2-7.2-5.3l3.9-22.7-16.5-16.1c-3-2.9-1.3-7.9 2.8-8.5l22.8-3.3 10.2-20.7c1.8-3.7 7.1-3.7 9 0l10.2 20.7 22.8 3.3c4 .6 5.6 5.6 2.6 8.5zm112 0l-16.5 16.1 3.9 22.7c.7 4.1-3.6 7.2-7.2 5.3L368 276.7l-20.4 10.7c-3.6 1.9-7.9-1.2-7.2-5.3l3.9-22.7-16.5-16.1c-3-2.9-1.3-7.9 2.8-8.5l22.8-3.3 10.2-20.7c1.8-3.7 7.1-3.7 9 0l10.2 20.7 22.8 3.3c4 .6 5.6 5.6 2.6 8.5zm112 0l-16.5 16.1 3.9 22.7c.7 4.1-3.6 7.2-7.2 5.3L480 276.7l-20.4 10.7c-3.6 1.9-7.9-1.2-7.2-5.3l3.9-22.7-16.5-16.1c-3-2.9-1.3-7.9 2.8-8.5l22.8-3.3 10.2-20.7c1.8-3.7 7.1-3.7 9 0l10.2 20.7 22.8 3.3c4 .6 5.6 5.6 2.6 8.5zM192 496c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16v-80h160v80c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16V352H192v144z"
                }
            }
        ]
    })(props);
}
function FaDesktop(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M528 0H48C21.5 0 0 21.5 0 48v320c0 26.5 21.5 48 48 48h192l-16 48h-72c-13.3 0-24 10.7-24 24s10.7 24 24 24h272c13.3 0 24-10.7 24-24s-10.7-24-24-24h-72l-16-48h192c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48zm-16 352H64V64h448v288z"
                }
            }
        ]
    })(props);
}
function FaDharmachakra(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M495 225.06l-17.22 1.08c-5.27-39.49-20.79-75.64-43.86-105.84l12.95-11.43c6.92-6.11 7.25-16.79.73-23.31L426.44 64.4c-6.53-6.53-17.21-6.19-23.31.73L391.7 78.07c-30.2-23.06-66.35-38.58-105.83-43.86L286.94 17c.58-9.21-6.74-17-15.97-17h-29.94c-9.23 0-16.54 7.79-15.97 17l1.08 17.22c-39.49 5.27-75.64 20.79-105.83 43.86l-11.43-12.95c-6.11-6.92-16.79-7.25-23.31-.73L64.4 85.56c-6.53 6.53-6.19 17.21.73 23.31l12.95 11.43c-23.06 30.2-38.58 66.35-43.86 105.84L17 225.06c-9.21-.58-17 6.74-17 15.97v29.94c0 9.23 7.79 16.54 17 15.97l17.22-1.08c5.27 39.49 20.79 75.64 43.86 105.83l-12.95 11.43c-6.92 6.11-7.25 16.79-.73 23.31l21.17 21.17c6.53 6.53 17.21 6.19 23.31-.73l11.43-12.95c30.2 23.06 66.35 38.58 105.84 43.86L225.06 495c-.58 9.21 6.74 17 15.97 17h29.94c9.23 0 16.54-7.79 15.97-17l-1.08-17.22c39.49-5.27 75.64-20.79 105.84-43.86l11.43 12.95c6.11 6.92 16.79 7.25 23.31.73l21.17-21.17c6.53-6.53 6.19-17.21-.73-23.31l-12.95-11.43c23.06-30.2 38.58-66.35 43.86-105.83l17.22 1.08c9.21.58 17-6.74 17-15.97v-29.94c-.01-9.23-7.8-16.54-17.01-15.97zM281.84 98.61c24.81 4.07 47.63 13.66 67.23 27.78l-42.62 48.29c-8.73-5.44-18.32-9.54-28.62-11.95l4.01-64.12zm-51.68 0l4.01 64.12c-10.29 2.41-19.89 6.52-28.62 11.95l-42.62-48.29c19.6-14.12 42.42-23.71 67.23-27.78zm-103.77 64.33l48.3 42.61c-5.44 8.73-9.54 18.33-11.96 28.62l-64.12-4.01c4.07-24.81 13.66-47.62 27.78-67.22zm-27.78 118.9l64.12-4.01c2.41 10.29 6.52 19.89 11.95 28.62l-48.29 42.62c-14.12-19.6-23.71-42.42-27.78-67.23zm131.55 131.55c-24.81-4.07-47.63-13.66-67.23-27.78l42.61-48.3c8.73 5.44 18.33 9.54 28.62 11.96l-4 64.12zM256 288c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm25.84 125.39l-4.01-64.12c10.29-2.41 19.89-6.52 28.62-11.96l42.61 48.3c-19.6 14.12-42.41 23.71-67.22 27.78zm103.77-64.33l-48.29-42.62c5.44-8.73 9.54-18.32 11.95-28.62l64.12 4.01c-4.07 24.82-13.66 47.64-27.78 67.23zm-36.34-114.89c-2.41-10.29-6.52-19.89-11.96-28.62l48.3-42.61c14.12 19.6 23.71 42.42 27.78 67.23l-64.12 4z"
                }
            }
        ]
    })(props);
}
function FaDiagnoses(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M496 256c8.8 0 16-7.2 16-16s-7.2-16-16-16-16 7.2-16 16 7.2 16 16 16zm-176-80c48.5 0 88-39.5 88-88S368.5 0 320 0s-88 39.5-88 88 39.5 88 88 88zM59.8 364c10.2 15.3 29.3 17.8 42.9 9.8 16.2-9.6 56.2-31.7 105.3-48.6V416h224v-90.7c49.1 16.8 89.1 39 105.3 48.6 13.6 8 32.7 5.3 42.9-9.8l17.8-26.7c8.8-13.2 7.6-34.6-10-45.1-11.9-7.1-29.7-17-51.1-27.4-28.1 46.1-99.4 17.8-87.7-35.1C409.3 217.2 365.1 208 320 208c-57 0-112.9 14.5-160 32.2-.2 40.2-47.6 63.3-79.2 36-11.2 6-21.3 11.6-28.7 16-17.6 10.5-18.8 31.8-10 45.1L59.8 364zM368 344c13.3 0 24 10.7 24 24s-10.7 24-24 24-24-10.7-24-24 10.7-24 24-24zm-96-96c13.3 0 24 10.7 24 24s-10.7 24-24 24-24-10.7-24-24 10.7-24 24-24zm-160 8c8.8 0 16-7.2 16-16s-7.2-16-16-16-16 7.2-16 16 7.2 16 16 16zm512 192H16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h608c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16z"
                }
            }
        ]
    })(props);
}
function FaDiceD20(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 480 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M106.75 215.06L1.2 370.95c-3.08 5 .1 11.5 5.93 12.14l208.26 22.07-108.64-190.1zM7.41 315.43L82.7 193.08 6.06 147.1c-2.67-1.6-6.06.32-6.06 3.43v162.81c0 4.03 5.29 5.53 7.41 2.09zM18.25 423.6l194.4 87.66c5.3 2.45 11.35-1.43 11.35-7.26v-65.67l-203.55-22.3c-4.45-.5-6.23 5.59-2.2 7.57zm81.22-257.78L179.4 22.88c4.34-7.06-3.59-15.25-10.78-11.14L17.81 110.35c-2.47 1.62-2.39 5.26.13 6.78l81.53 48.69zM240 176h109.21L253.63 7.62C250.5 2.54 245.25 0 240 0s-10.5 2.54-13.63 7.62L130.79 176H240zm233.94-28.9l-76.64 45.99 75.29 122.35c2.11 3.44 7.41 1.94 7.41-2.1V150.53c0-3.11-3.39-5.03-6.06-3.43zm-93.41 18.72l81.53-48.7c2.53-1.52 2.6-5.16.13-6.78l-150.81-98.6c-7.19-4.11-15.12 4.08-10.78 11.14l79.93 142.94zm79.02 250.21L256 438.32v65.67c0 5.84 6.05 9.71 11.35 7.26l194.4-87.66c4.03-1.97 2.25-8.06-2.2-7.56zm-86.3-200.97l-108.63 190.1 208.26-22.07c5.83-.65 9.01-7.14 5.93-12.14L373.25 215.06zM240 208H139.57L240 383.75 340.43 208H240z"
                }
            }
        ]
    })(props);
}
function FaDiceD6(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M422.19 109.95L256.21 9.07c-19.91-12.1-44.52-12.1-64.43 0L25.81 109.95c-5.32 3.23-5.29 11.27.06 14.46L224 242.55l198.14-118.14c5.35-3.19 5.38-11.22.05-14.46zm13.84 44.63L240 271.46v223.82c0 12.88 13.39 20.91 24.05 14.43l152.16-92.48c19.68-11.96 31.79-33.94 31.79-57.7v-197.7c0-6.41-6.64-10.43-11.97-7.25zM0 161.83v197.7c0 23.77 12.11 45.74 31.79 57.7l152.16 92.47c10.67 6.48 24.05-1.54 24.05-14.43V271.46L11.97 154.58C6.64 151.4 0 155.42 0 161.83z"
                }
            }
        ]
    })(props);
}
function FaDiceFive(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M384 32H64C28.65 32 0 60.65 0 96v320c0 35.35 28.65 64 64 64h320c35.35 0 64-28.65 64-64V96c0-35.35-28.65-64-64-64zM128 384c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm0-192c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm96 96c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm96 96c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm0-192c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32z"
                }
            }
        ]
    })(props);
}
function FaDiceFour(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M384 32H64C28.65 32 0 60.65 0 96v320c0 35.35 28.65 64 64 64h320c35.35 0 64-28.65 64-64V96c0-35.35-28.65-64-64-64zM128 384c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm0-192c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm192 192c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm0-192c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32z"
                }
            }
        ]
    })(props);
}
function FaDiceOne(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M384 32H64C28.65 32 0 60.65 0 96v320c0 35.35 28.65 64 64 64h320c35.35 0 64-28.65 64-64V96c0-35.35-28.65-64-64-64zM224 288c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32z"
                }
            }
        ]
    })(props);
}
function FaDiceSix(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M384 32H64C28.65 32 0 60.65 0 96v320c0 35.35 28.65 64 64 64h320c35.35 0 64-28.65 64-64V96c0-35.35-28.65-64-64-64zM128 384c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm0-96c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm0-96c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm192 192c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm0-96c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm0-96c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32z"
                }
            }
        ]
    })(props);
}
function FaDiceThree(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M384 32H64C28.65 32 0 60.65 0 96v320c0 35.35 28.65 64 64 64h320c35.35 0 64-28.65 64-64V96c0-35.35-28.65-64-64-64zM128 192c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm96 96c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm96 96c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32z"
                }
            }
        ]
    })(props);
}
function FaDiceTwo(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M384 32H64C28.65 32 0 60.65 0 96v320c0 35.35 28.65 64 64 64h320c35.35 0 64-28.65 64-64V96c0-35.35-28.65-64-64-64zM128 192c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm192 192c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32z"
                }
            }
        ]
    })(props);
}
function FaDice(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M592 192H473.26c12.69 29.59 7.12 65.2-17 89.32L320 417.58V464c0 26.51 21.49 48 48 48h224c26.51 0 48-21.49 48-48V240c0-26.51-21.49-48-48-48zM480 376c-13.25 0-24-10.75-24-24 0-13.26 10.75-24 24-24s24 10.74 24 24c0 13.25-10.75 24-24 24zm-46.37-186.7L258.7 14.37c-19.16-19.16-50.23-19.16-69.39 0L14.37 189.3c-19.16 19.16-19.16 50.23 0 69.39L189.3 433.63c19.16 19.16 50.23 19.16 69.39 0L433.63 258.7c19.16-19.17 19.16-50.24 0-69.4zM96 248c-13.25 0-24-10.75-24-24 0-13.26 10.75-24 24-24s24 10.74 24 24c0 13.25-10.75 24-24 24zm128 128c-13.25 0-24-10.75-24-24 0-13.26 10.75-24 24-24s24 10.74 24 24c0 13.25-10.75 24-24 24zm0-128c-13.25 0-24-10.75-24-24 0-13.26 10.75-24 24-24s24 10.74 24 24c0 13.25-10.75 24-24 24zm0-128c-13.25 0-24-10.75-24-24 0-13.26 10.75-24 24-24s24 10.74 24 24c0 13.25-10.75 24-24 24zm128 128c-13.25 0-24-10.75-24-24 0-13.26 10.75-24 24-24s24 10.74 24 24c0 13.25-10.75 24-24 24z"
                }
            }
        ]
    })(props);
}
function FaDigitalTachograph(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M608 96H32c-17.67 0-32 14.33-32 32v256c0 17.67 14.33 32 32 32h576c17.67 0 32-14.33 32-32V128c0-17.67-14.33-32-32-32zM304 352c0 4.42-3.58 8-8 8H72c-4.42 0-8-3.58-8-8v-8c0-4.42 3.58-8 8-8h224c4.42 0 8 3.58 8 8v8zM72 288v-16c0-4.42 3.58-8 8-8h16c4.42 0 8 3.58 8 8v16c0 4.42-3.58 8-8 8H80c-4.42 0-8-3.58-8-8zm64 0v-16c0-4.42 3.58-8 8-8h16c4.42 0 8 3.58 8 8v16c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8zm64 0v-16c0-4.42 3.58-8 8-8h16c4.42 0 8 3.58 8 8v16c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8zm64 0v-16c0-4.42 3.58-8 8-8h16c4.42 0 8 3.58 8 8v16c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8zm40-64c0 8.84-7.16 16-16 16H80c-8.84 0-16-7.16-16-16v-48c0-8.84 7.16-16 16-16h208c8.84 0 16 7.16 16 16v48zm272 128c0 4.42-3.58 8-8 8H344c-4.42 0-8-3.58-8-8v-8c0-4.42 3.58-8 8-8h224c4.42 0 8 3.58 8 8v8z"
                }
            }
        ]
    })(props);
}
function FaDirections(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M502.61 233.32L278.68 9.39c-12.52-12.52-32.83-12.52-45.36 0L9.39 233.32c-12.52 12.53-12.52 32.83 0 45.36l223.93 223.93c12.52 12.53 32.83 12.53 45.36 0l223.93-223.93c12.52-12.53 12.52-32.83 0-45.36zm-100.98 12.56l-84.21 77.73c-5.12 4.73-13.43 1.1-13.43-5.88V264h-96v64c0 4.42-3.58 8-8 8h-32c-4.42 0-8-3.58-8-8v-80c0-17.67 14.33-32 32-32h112v-53.73c0-6.97 8.3-10.61 13.43-5.88l84.21 77.73c3.43 3.17 3.43 8.59 0 11.76z"
                }
            }
        ]
    })(props);
}
function FaDisease(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M472.29 195.9l-67.06-23c-19.28-6.6-33.54-20.92-38.14-38.31l-16-60.45c-11.58-43.77-76.57-57.13-110-22.62L195 99.24c-13.26 13.71-33.54 20.93-54.2 19.31l-71.9-5.62c-52-4.07-86.93 44.89-59 82.84l38.54 52.42c11.08 15.07 12.82 33.86 4.64 50.24l-28.43 57C4 396.67 47.46 440.29 98.11 429.23l70-15.28c20.11-4.39 41.45 0 57.07 11.73l54.32 40.83c39.32 29.56 101 7.57 104.45-37.22l4.7-61.86c1.35-17.8 12.8-33.87 30.63-43l62-31.74c44.84-22.96 39.55-80.17-8.99-96.79zM160 256a32 32 0 1 1 32-32 32 32 0 0 1-32 32zm128 96a32 32 0 1 1 32-32 32 32 0 0 1-32 32zm16-128a16 16 0 1 1 16-16 16 16 0 0 1-16 16z"
                }
            }
        ]
    })(props);
}
function FaDivide(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M224 352c-35.35 0-64 28.65-64 64s28.65 64 64 64 64-28.65 64-64-28.65-64-64-64zm0-192c35.35 0 64-28.65 64-64s-28.65-64-64-64-64 28.65-64 64 28.65 64 64 64zm192 48H32c-17.67 0-32 14.33-32 32v32c0 17.67 14.33 32 32 32h384c17.67 0 32-14.33 32-32v-32c0-17.67-14.33-32-32-32z"
                }
            }
        ]
    })(props);
}
function FaDizzy(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm-96 206.6l-28.7 28.7c-14.8 14.8-37.8-7.5-22.6-22.6l28.7-28.7-28.7-28.7c-15-15 7.7-37.6 22.6-22.6l28.7 28.7 28.7-28.7c15-15 37.6 7.7 22.6 22.6L174.6 192l28.7 28.7c15.2 15.2-7.9 37.4-22.6 22.6L152 214.6zM248 416c-35.3 0-64-28.7-64-64s28.7-64 64-64 64 28.7 64 64-28.7 64-64 64zm147.3-195.3c15.2 15.2-7.9 37.4-22.6 22.6L344 214.6l-28.7 28.7c-14.8 14.8-37.8-7.5-22.6-22.6l28.7-28.7-28.7-28.7c-15-15 7.7-37.6 22.6-22.6l28.7 28.7 28.7-28.7c15-15 37.6 7.7 22.6 22.6L366.6 192l28.7 28.7z"
                }
            }
        ]
    })(props);
}
function FaDna(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M.1 494.1c-1.1 9.5 6.3 17.8 15.9 17.8l32.3.1c8.1 0 14.9-5.9 16-13.9.7-4.9 1.8-11.1 3.4-18.1H380c1.6 6.9 2.9 13.2 3.5 18.1 1.1 8 7.9 14 16 13.9l32.3-.1c9.6 0 17.1-8.3 15.9-17.8-4.6-37.9-25.6-129-118.9-207.7-17.6 12.4-37.1 24.2-58.5 35.4 6.2 4.6 11.4 9.4 17 14.2H159.7c21.3-18.1 47-35.6 78.7-51.4C410.5 199.1 442.1 65.8 447.9 17.9 449 8.4 441.6.1 432 .1L399.6 0c-8.1 0-14.9 5.9-16 13.9-.7 4.9-1.8 11.1-3.4 18.1H67.8c-1.6-7-2.7-13.1-3.4-18.1-1.1-8-7.9-14-16-13.9L16.1.1C6.5.1-1 8.4.1 17.9 5.3 60.8 31.4 171.8 160 256 31.5 340.2 5.3 451.2.1 494.1zM224 219.6c-25.1-13.7-46.4-28.4-64.3-43.6h128.5c-17.8 15.2-39.1 30-64.2 43.6zM355.1 96c-5.8 10.4-12.8 21.1-21 32H114c-8.3-10.9-15.3-21.6-21-32h262.1zM92.9 416c5.8-10.4 12.8-21.1 21-32h219.4c8.3 10.9 15.4 21.6 21.2 32H92.9z"
                }
            }
        ]
    })(props);
}
function FaDog(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M298.06,224,448,277.55V496a16,16,0,0,1-16,16H368a16,16,0,0,1-16-16V384H192V496a16,16,0,0,1-16,16H112a16,16,0,0,1-16-16V282.09C58.84,268.84,32,233.66,32,192a32,32,0,0,1,64,0,32.06,32.06,0,0,0,32,32ZM544,112v32a64,64,0,0,1-64,64H448v35.58L320,197.87V48c0-14.25,17.22-21.39,27.31-11.31L374.59,64h53.63c10.91,0,23.75,7.92,28.62,17.69L464,96h64A16,16,0,0,1,544,112Zm-112,0a16,16,0,1,0-16,16A16,16,0,0,0,432,112Z"
                }
            }
        ]
    })(props);
}
function FaDollarSign(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 288 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M209.2 233.4l-108-31.6C88.7 198.2 80 186.5 80 173.5c0-16.3 13.2-29.5 29.5-29.5h66.3c12.2 0 24.2 3.7 34.2 10.5 6.1 4.1 14.3 3.1 19.5-2l34.8-34c7.1-6.9 6.1-18.4-1.8-24.5C238 74.8 207.4 64.1 176 64V16c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v48h-2.5C45.8 64-5.4 118.7.5 183.6c4.2 46.1 39.4 83.6 83.8 96.6l102.5 30c12.5 3.7 21.2 15.3 21.2 28.3 0 16.3-13.2 29.5-29.5 29.5h-66.3C100 368 88 364.3 78 357.5c-6.1-4.1-14.3-3.1-19.5 2l-34.8 34c-7.1 6.9-6.1 18.4 1.8 24.5 24.5 19.2 55.1 29.9 86.5 30v48c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-48.2c46.6-.9 90.3-28.6 105.7-72.7 21.5-61.6-14.6-124.8-72.5-141.7z"
                }
            }
        ]
    })(props);
}
function FaDollyFlatbed(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M208 320h384c8.8 0 16-7.2 16-16V48c0-8.8-7.2-16-16-16H448v128l-48-32-48 32V32H208c-8.8 0-16 7.2-16 16v256c0 8.8 7.2 16 16 16zm416 64H128V16c0-8.8-7.2-16-16-16H16C7.2 0 0 7.2 0 16v32c0 8.8 7.2 16 16 16h48v368c0 8.8 7.2 16 16 16h82.9c-1.8 5-2.9 10.4-2.9 16 0 26.5 21.5 48 48 48s48-21.5 48-48c0-5.6-1.2-11-2.9-16H451c-1.8 5-2.9 10.4-2.9 16 0 26.5 21.5 48 48 48s48-21.5 48-48c0-5.6-1.2-11-2.9-16H624c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16z"
                }
            }
        ]
    })(props);
}
function FaDolly(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M294.2 277.7c18 5 34.7 13.4 49.5 24.7l161.5-53.8c8.4-2.8 12.9-11.9 10.1-20.2L454.9 47.2c-2.8-8.4-11.9-12.9-20.2-10.1l-61.1 20.4 33.1 99.4L346 177l-33.1-99.4-61.6 20.5c-8.4 2.8-12.9 11.9-10.1 20.2l53 159.4zm281 48.7L565 296c-2.8-8.4-11.9-12.9-20.2-10.1l-213.5 71.2c-17.2-22-43.6-36.4-73.5-37L158.4 21.9C154 8.8 141.8 0 128 0H16C7.2 0 0 7.2 0 16v32c0 8.8 7.2 16 16 16h88.9l92.2 276.7c-26.1 20.4-41.7 53.6-36 90.5 6.1 39.4 37.9 72.3 77.3 79.2 60.2 10.7 112.3-34.8 113.4-92.6l213.3-71.2c8.3-2.8 12.9-11.8 10.1-20.2zM256 464c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48z"
                }
            }
        ]
    })(props);
}
function FaDonate(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 416c114.9 0 208-93.1 208-208S370.9 0 256 0 48 93.1 48 208s93.1 208 208 208zM233.8 97.4V80.6c0-9.2 7.4-16.6 16.6-16.6h11.1c9.2 0 16.6 7.4 16.6 16.6v17c15.5.8 30.5 6.1 43 15.4 5.6 4.1 6.2 12.3 1.2 17.1L306 145.6c-3.8 3.7-9.5 3.8-14 1-5.4-3.4-11.4-5.1-17.8-5.1h-38.9c-9 0-16.3 8.2-16.3 18.3 0 8.2 5 15.5 12.1 17.6l62.3 18.7c25.7 7.7 43.7 32.4 43.7 60.1 0 34-26.4 61.5-59.1 62.4v16.8c0 9.2-7.4 16.6-16.6 16.6h-11.1c-9.2 0-16.6-7.4-16.6-16.6v-17c-15.5-.8-30.5-6.1-43-15.4-5.6-4.1-6.2-12.3-1.2-17.1l16.3-15.5c3.8-3.7 9.5-3.8 14-1 5.4 3.4 11.4 5.1 17.8 5.1h38.9c9 0 16.3-8.2 16.3-18.3 0-8.2-5-15.5-12.1-17.6l-62.3-18.7c-25.7-7.7-43.7-32.4-43.7-60.1.1-34 26.4-61.5 59.1-62.4zM480 352h-32.5c-19.6 26-44.6 47.7-73 64h63.8c5.3 0 9.6 3.6 9.6 8v16c0 4.4-4.3 8-9.6 8H73.6c-5.3 0-9.6-3.6-9.6-8v-16c0-4.4 4.3-8 9.6-8h63.8c-28.4-16.3-53.3-38-73-64H32c-17.7 0-32 14.3-32 32v96c0 17.7 14.3 32 32 32h448c17.7 0 32-14.3 32-32v-96c0-17.7-14.3-32-32-32z"
                }
            }
        ]
    })(props);
}
function FaDoorClosed(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M624 448H512V50.8C512 22.78 490.47 0 464 0H175.99c-26.47 0-48 22.78-48 50.8V448H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h608c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16zM415.99 288c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32c.01 17.67-14.32 32-32 32z"
                }
            }
        ]
    })(props);
}
function FaDoorOpen(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M624 448h-80V113.45C544 86.19 522.47 64 496 64H384v64h96v384h144c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16zM312.24 1.01l-192 49.74C105.99 54.44 96 67.7 96 82.92V448H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h336V33.18c0-21.58-19.56-37.41-39.76-32.17zM264 288c-13.25 0-24-14.33-24-32s10.75-32 24-32 24 14.33 24 32-10.75 32-24 32z"
                }
            }
        ]
    })(props);
}
function FaDotCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 8C119.033 8 8 119.033 8 256s111.033 248 248 248 248-111.033 248-248S392.967 8 256 8zm80 248c0 44.112-35.888 80-80 80s-80-35.888-80-80 35.888-80 80-80 80 35.888 80 80z"
                }
            }
        ]
    })(props);
}
function FaDove(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M288 167.2v-28.1c-28.2-36.3-47.1-79.3-54.1-125.2-2.1-13.5-19-18.8-27.8-8.3-21.1 24.9-37.7 54.1-48.9 86.5 34.2 38.3 80 64.6 130.8 75.1zM400 64c-44.2 0-80 35.9-80 80.1v59.4C215.6 197.3 127 133 87 41.8c-5.5-12.5-23.2-13.2-29-.9C41.4 76 32 115.2 32 156.6c0 70.8 34.1 136.9 85.1 185.9 13.2 12.7 26.1 23.2 38.9 32.8l-143.9 36C1.4 414-3.4 426.4 2.6 435.7 20 462.6 63 508.2 155.8 512c8 .3 16-2.6 22.1-7.9l65.2-56.1H320c88.4 0 160-71.5 160-159.9V128l32-64H400zm0 96.1c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16z"
                }
            }
        ]
    })(props);
}
function FaDownload(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M216 0h80c13.3 0 24 10.7 24 24v168h87.7c17.8 0 26.7 21.5 14.1 34.1L269.7 378.3c-7.5 7.5-19.8 7.5-27.3 0L90.1 226.1c-12.6-12.6-3.7-34.1 14.1-34.1H192V24c0-13.3 10.7-24 24-24zm296 376v112c0 13.3-10.7 24-24 24H24c-13.3 0-24-10.7-24-24V376c0-13.3 10.7-24 24-24h146.7l49 49c20.1 20.1 52.5 20.1 72.6 0l49-49H488c13.3 0 24 10.7 24 24zm-124 88c0-11-9-20-20-20s-20 9-20 20 9 20 20 20 20-9 20-20zm64 0c0-11-9-20-20-20s-20 9-20 20 9 20 20 20 20-9 20-20z"
                }
            }
        ]
    })(props);
}
function FaDraftingCompass(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M457.01 344.42c-25.05 20.33-52.63 37.18-82.54 49.05l54.38 94.19 53.95 23.04c9.81 4.19 20.89-2.21 22.17-12.8l7.02-58.25-54.98-95.23zm42.49-94.56c4.86-7.67 1.89-17.99-6.05-22.39l-28.07-15.57c-7.48-4.15-16.61-1.46-21.26 5.72C403.01 281.15 332.25 320 256 320c-23.93 0-47.23-4.25-69.41-11.53l67.36-116.68c.7.02 1.34.21 2.04.21s1.35-.19 2.04-.21l51.09 88.5c31.23-8.96 59.56-25.75 82.61-48.92l-51.79-89.71C347.39 128.03 352 112.63 352 96c0-53.02-42.98-96-96-96s-96 42.98-96 96c0 16.63 4.61 32.03 12.05 45.66l-68.3 118.31c-12.55-11.61-23.96-24.59-33.68-39-4.79-7.1-13.97-9.62-21.38-5.33l-27.75 16.07c-7.85 4.54-10.63 14.9-5.64 22.47 15.57 23.64 34.69 44.21 55.98 62.02L0 439.66l7.02 58.25c1.28 10.59 12.36 16.99 22.17 12.8l53.95-23.04 70.8-122.63C186.13 377.28 220.62 384 256 384c99.05 0 190.88-51.01 243.5-134.14zM256 64c17.67 0 32 14.33 32 32s-14.33 32-32 32-32-14.33-32-32 14.33-32 32-32z"
                }
            }
        ]
    })(props);
}
function FaDragon(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18.32 255.78L192 223.96l-91.28 68.69c-10.08 10.08-2.94 27.31 11.31 27.31h222.7c-9.44-26.4-14.73-54.47-14.73-83.38v-42.27l-119.73-87.6c-23.82-15.88-55.29-14.01-77.06 4.59L5.81 227.64c-12.38 10.33-3.45 30.42 12.51 28.14zm556.87 34.1l-100.66-50.31A47.992 47.992 0 0 1 448 196.65v-36.69h64l28.09 22.63c6 6 14.14 9.37 22.63 9.37h30.97a32 32 0 0 0 28.62-17.69l14.31-28.62a32.005 32.005 0 0 0-3.02-33.51l-74.53-99.38C553.02 4.7 543.54 0 533.47 0H296.02c-7.13 0-10.7 8.57-5.66 13.61L352 63.96 292.42 88.8c-5.9 2.95-5.9 11.36 0 14.31L352 127.96v108.62c0 72.08 36.03 139.39 96 179.38-195.59 6.81-344.56 41.01-434.1 60.91C5.78 478.67 0 485.88 0 494.2 0 504 7.95 512 17.76 512h499.08c63.29.01 119.61-47.56 122.99-110.76 2.52-47.28-22.73-90.4-64.64-111.36zM489.18 66.25l45.65 11.41c-2.75 10.91-12.47 18.89-24.13 18.26-12.96-.71-25.85-12.53-21.52-29.67z"
                }
            }
        ]
    })(props);
}
function FaDrawPolygon(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M384 352c-.35 0-.67.1-1.02.1l-39.2-65.32c5.07-9.17 8.22-19.56 8.22-30.78s-3.14-21.61-8.22-30.78l39.2-65.32c.35.01.67.1 1.02.1 35.35 0 64-28.65 64-64s-28.65-64-64-64c-23.63 0-44.04 12.95-55.12 32H119.12C108.04 44.95 87.63 32 64 32 28.65 32 0 60.65 0 96c0 23.63 12.95 44.04 32 55.12v209.75C12.95 371.96 0 392.37 0 416c0 35.35 28.65 64 64 64 23.63 0 44.04-12.95 55.12-32h209.75c11.09 19.05 31.49 32 55.12 32 35.35 0 64-28.65 64-64 .01-35.35-28.64-64-63.99-64zm-288 8.88V151.12A63.825 63.825 0 0 0 119.12 128h208.36l-38.46 64.1c-.35-.01-.67-.1-1.02-.1-35.35 0-64 28.65-64 64s28.65 64 64 64c.35 0 .67-.1 1.02-.1l38.46 64.1H119.12A63.748 63.748 0 0 0 96 360.88zM272 256c0-8.82 7.18-16 16-16s16 7.18 16 16-7.18 16-16 16-16-7.18-16-16zM400 96c0 8.82-7.18 16-16 16s-16-7.18-16-16 7.18-16 16-16 16 7.18 16 16zM64 80c8.82 0 16 7.18 16 16s-7.18 16-16 16-16-7.18-16-16 7.18-16 16-16zM48 416c0-8.82 7.18-16 16-16s16 7.18 16 16-7.18 16-16 16-16-7.18-16-16zm336 16c-8.82 0-16-7.18-16-16s7.18-16 16-16 16 7.18 16 16-7.18 16-16 16z"
                }
            }
        ]
    })(props);
}
function FaDrumSteelpan(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M288 32C128.94 32 0 89.31 0 160v192c0 70.69 128.94 128 288 128s288-57.31 288-128V160c0-70.69-128.94-128-288-128zm-82.99 158.36c-4.45 16.61-14.54 30.57-28.31 40.48C100.23 217.46 48 190.78 48 160c0-30.16 50.11-56.39 124.04-70.03l25.6 44.34c9.86 17.09 12.48 36.99 7.37 56.05zM288 240c-21.08 0-41.41-1-60.89-2.7 8.06-26.13 32.15-45.3 60.89-45.3s52.83 19.17 60.89 45.3C329.41 239 309.08 240 288 240zm64-144c0 35.29-28.71 64-64 64s-64-28.71-64-64V82.96c20.4-1.88 41.8-2.96 64-2.96s43.6 1.08 64 2.96V96zm46.93 134.9c-13.81-9.91-23.94-23.9-28.4-40.54-5.11-19.06-2.49-38.96 7.38-56.04l25.65-44.42C477.72 103.5 528 129.79 528 160c0 30.83-52.4 57.54-129.07 70.9z"
                }
            }
        ]
    })(props);
}
function FaDrum(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M431.34 122.05l73.53-47.42a16 16 0 0 0 4.44-22.19l-8.87-13.31a16 16 0 0 0-22.19-4.44l-110.06 71C318.43 96.91 271.22 96 256 96 219.55 96 0 100.55 0 208.15v160.23c0 30.27 27.5 57.68 72 77.86v-101.9a24 24 0 1 1 48 0v118.93c33.05 9.11 71.07 15.06 112 16.73V376.39a24 24 0 1 1 48 0V480c40.93-1.67 78.95-7.62 112-16.73V344.34a24 24 0 1 1 48 0v101.9c44.5-20.18 72-47.59 72-77.86V208.15c0-43.32-35.76-69.76-80.66-86.1zM256 272.24c-114.88 0-208-28.69-208-64.09s93.12-64.08 208-64.08c17.15 0 33.73.71 49.68 1.91l-72.81 47a16 16 0 0 0-4.43 22.19l8.87 13.31a16 16 0 0 0 22.19 4.44l118.64-76.52C430.09 168 464 186.84 464 208.15c0 35.4-93.13 64.09-208 64.09z"
                }
            }
        ]
    })(props);
}
function FaDrumstickBite(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M462.8 49.57a169.44 169.44 0 0 0-239.5 0C187.82 85 160.13 128 160.13 192v85.83l-40.62 40.59c-9.7 9.69-24 11.07-36.78 6a60.33 60.33 0 0 0-65 98.72C33 438.39 54.24 442.7 73.85 438.21c-4.5 19.6-.18 40.83 15.1 56.1a60.35 60.35 0 0 0 98.8-65c-5.09-12.73-3.72-27 6-36.75L234.36 352h85.89a187.87 187.87 0 0 0 61.89-10c-39.64-43.89-39.83-110.23 1.05-151.07 34.38-34.36 86.76-39.46 128.74-16.8 1.3-44.96-14.81-90.28-49.13-124.56z"
                }
            }
        ]
    })(props);
}
function FaDumbbell(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M104 96H56c-13.3 0-24 10.7-24 24v104H8c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h24v104c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24V120c0-13.3-10.7-24-24-24zm528 128h-24V120c0-13.3-10.7-24-24-24h-48c-13.3 0-24 10.7-24 24v272c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24V288h24c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zM456 32h-48c-13.3 0-24 10.7-24 24v168H256V56c0-13.3-10.7-24-24-24h-48c-13.3 0-24 10.7-24 24v400c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24V288h128v168c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24V56c0-13.3-10.7-24-24-24z"
                }
            }
        ]
    })(props);
}
function FaDumpsterFire(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M418.7 104.1l.2-.2-14.4-72H304v128h60.8c16.2-19.3 34.2-38.2 53.9-55.8zM272 32H171.5l-25.6 128H272V32zm189.3 72.1c18.2 16.3 35.5 33.7 51.1 51.5 5.7-5.6 11.4-11.1 17.3-16.3l21.3-19 21.3 19c1.1.9 2.1 2.1 3.1 3.1-.1-.8.2-1.5 0-2.3l-24-96C549.7 37 543.3 32 536 32h-98.9l12.3 61.5 11.9 10.6zM16 160h97.3l25.6-128H40c-7.3 0-13.7 5-15.5 12.1l-24 96C-2 150.2 5.6 160 16 160zm324.6 32H32l4 32H16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h28l20 160v16c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-16h208.8c-30.2-33.7-48.8-77.9-48.8-126.4 0-35.9 19.9-82.9 52.6-129.6zm210.5-28.8c-14.9 13.3-28.3 27.2-40.2 41.2-19.5-25.8-43.6-52-71-76.4-70.2 62.7-120 144.3-120 193.6 0 87.5 71.6 158.4 160 158.4s160-70.9 160-158.4c.1-36.6-37-112.2-88.8-158.4zm-18.6 229.4c-14.7 10.7-32.9 17-52.5 17-49 0-88.9-33.5-88.9-88 0-27.1 16.5-51 49.4-91.9 4.7 5.6 67.1 88.1 67.1 88.1l39.8-47c2.8 4.8 5.4 9.5 7.7 14 18.6 36.7 10.8 83.6-22.6 107.8z"
                }
            }
        ]
    })(props);
}
function FaDumpster(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M560 160c10.4 0 18-9.8 15.5-19.9l-24-96C549.7 37 543.3 32 536 32h-98.9l25.6 128H560zM272 32H171.5l-25.6 128H272V32zm132.5 0H304v128h126.1L404.5 32zM16 160h97.3l25.6-128H40c-7.3 0-13.7 5-15.5 12.1l-24 96C-2 150.2 5.6 160 16 160zm544 64h-20l4-32H32l4 32H16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h28l20 160v16c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-16h320v16c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-16l20-160h28c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16z"
                }
            }
        ]
    })(props);
}
function FaDungeon(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M128.73 195.32l-82.81-51.76c-8.04-5.02-18.99-2.17-22.93 6.45A254.19 254.19 0 0 0 .54 239.28C-.05 248.37 7.59 256 16.69 256h97.13c7.96 0 14.08-6.25 15.01-14.16 1.09-9.33 3.24-18.33 6.24-26.94 2.56-7.34.25-15.46-6.34-19.58zM319.03 8C298.86 2.82 277.77 0 256 0s-42.86 2.82-63.03 8c-9.17 2.35-13.91 12.6-10.39 21.39l37.47 104.03A16.003 16.003 0 0 0 235.1 144h41.8c6.75 0 12.77-4.23 15.05-10.58l37.47-104.03c3.52-8.79-1.22-19.03-10.39-21.39zM112 288H16c-8.84 0-16 7.16-16 16v64c0 8.84 7.16 16 16 16h96c8.84 0 16-7.16 16-16v-64c0-8.84-7.16-16-16-16zm0 128H16c-8.84 0-16 7.16-16 16v64c0 8.84 7.16 16 16 16h96c8.84 0 16-7.16 16-16v-64c0-8.84-7.16-16-16-16zm77.31-283.67l-36.32-90.8c-3.53-8.83-14.13-12.99-22.42-8.31a257.308 257.308 0 0 0-71.61 59.89c-6.06 7.32-3.85 18.48 4.22 23.52l82.93 51.83c6.51 4.07 14.66 2.62 20.11-2.79 5.18-5.15 10.79-9.85 16.79-14.05 6.28-4.41 9.15-12.17 6.3-19.29zM398.18 256h97.13c9.1 0 16.74-7.63 16.15-16.72a254.135 254.135 0 0 0-22.45-89.27c-3.94-8.62-14.89-11.47-22.93-6.45l-82.81 51.76c-6.59 4.12-8.9 12.24-6.34 19.58 3.01 8.61 5.15 17.62 6.24 26.94.93 7.91 7.05 14.16 15.01 14.16zm54.85-162.89a257.308 257.308 0 0 0-71.61-59.89c-8.28-4.68-18.88-.52-22.42 8.31l-36.32 90.8c-2.85 7.12.02 14.88 6.3 19.28 6 4.2 11.61 8.9 16.79 14.05 5.44 5.41 13.6 6.86 20.11 2.79l82.93-51.83c8.07-5.03 10.29-16.19 4.22-23.51zM496 288h-96c-8.84 0-16 7.16-16 16v64c0 8.84 7.16 16 16 16h96c8.84 0 16-7.16 16-16v-64c0-8.84-7.16-16-16-16zm0 128h-96c-8.84 0-16 7.16-16 16v64c0 8.84 7.16 16 16 16h96c8.84 0 16-7.16 16-16v-64c0-8.84-7.16-16-16-16zM240 177.62V472c0 4.42 3.58 8 8 8h16c4.42 0 8-3.58 8-8V177.62c-5.23-.89-10.52-1.62-16-1.62s-10.77.73-16 1.62zm-64 41.51V472c0 4.42 3.58 8 8 8h16c4.42 0 8-3.58 8-8V189.36c-12.78 7.45-23.84 17.47-32 29.77zm128-29.77V472c0 4.42 3.58 8 8 8h16c4.42 0 8-3.58 8-8V219.13c-8.16-12.3-19.22-22.32-32-29.77z"
                }
            }
        ]
    })(props);
}
function FaEdit(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M402.6 83.2l90.2 90.2c3.8 3.8 3.8 10 0 13.8L274.4 405.6l-92.8 10.3c-12.4 1.4-22.9-9.1-21.5-21.5l10.3-92.8L388.8 83.2c3.8-3.8 10-3.8 13.8 0zm162-22.9l-48.8-48.8c-15.2-15.2-39.9-15.2-55.2 0l-35.4 35.4c-3.8 3.8-3.8 10 0 13.8l90.2 90.2c3.8 3.8 10 3.8 13.8 0l35.4-35.4c15.2-15.3 15.2-40 0-55.2zM384 346.2V448H64V128h229.8c3.2 0 6.2-1.3 8.5-3.5l40-40c7.6-7.6 2.2-20.5-8.5-20.5H48C21.5 64 0 85.5 0 112v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V306.2c0-10.7-12.9-16-20.5-8.5l-40 40c-2.2 2.3-3.5 5.3-3.5 8.5z"
                }
            }
        ]
    })(props);
}
function FaEgg(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M192 0C86 0 0 214 0 320s86 192 192 192 192-86 192-192S298 0 192 0z"
                }
            }
        ]
    })(props);
}
function FaEject(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M448 384v64c0 17.673-14.327 32-32 32H32c-17.673 0-32-14.327-32-32v-64c0-17.673 14.327-32 32-32h384c17.673 0 32 14.327 32 32zM48.053 320h351.886c41.651 0 63.581-49.674 35.383-80.435L259.383 47.558c-19.014-20.743-51.751-20.744-70.767 0L12.67 239.565C-15.475 270.268 6.324 320 48.053 320z"
                }
            }
        ]
    })(props);
}
function FaEllipsisH(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M328 256c0 39.8-32.2 72-72 72s-72-32.2-72-72 32.2-72 72-72 72 32.2 72 72zm104-72c-39.8 0-72 32.2-72 72s32.2 72 72 72 72-32.2 72-72-32.2-72-72-72zm-352 0c-39.8 0-72 32.2-72 72s32.2 72 72 72 72-32.2 72-72-32.2-72-72-72z"
                }
            }
        ]
    })(props);
}
function FaEllipsisV(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 192 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M96 184c39.8 0 72 32.2 72 72s-32.2 72-72 72-72-32.2-72-72 32.2-72 72-72zM24 80c0 39.8 32.2 72 72 72s72-32.2 72-72S135.8 8 96 8 24 40.2 24 80zm0 352c0 39.8 32.2 72 72 72s72-32.2 72-72-32.2-72-72-72-72 32.2-72 72z"
                }
            }
        ]
    })(props);
}
function FaEnvelopeOpenText(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M176 216h160c8.84 0 16-7.16 16-16v-16c0-8.84-7.16-16-16-16H176c-8.84 0-16 7.16-16 16v16c0 8.84 7.16 16 16 16zm-16 80c0 8.84 7.16 16 16 16h160c8.84 0 16-7.16 16-16v-16c0-8.84-7.16-16-16-16H176c-8.84 0-16 7.16-16 16v16zm96 121.13c-16.42 0-32.84-5.06-46.86-15.19L0 250.86V464c0 26.51 21.49 48 48 48h416c26.51 0 48-21.49 48-48V250.86L302.86 401.94c-14.02 10.12-30.44 15.19-46.86 15.19zm237.61-254.18c-8.85-6.94-17.24-13.47-29.61-22.81V96c0-26.51-21.49-48-48-48h-77.55c-3.04-2.2-5.87-4.26-9.04-6.56C312.6 29.17 279.2-.35 256 0c-23.2-.35-56.59 29.17-73.41 41.44-3.17 2.3-6 4.36-9.04 6.56H96c-26.51 0-48 21.49-48 48v44.14c-12.37 9.33-20.76 15.87-29.61 22.81A47.995 47.995 0 0 0 0 200.72v10.65l96 69.35V96h320v184.72l96-69.35v-10.65c0-14.74-6.78-28.67-18.39-37.77z"
                }
            }
        ]
    })(props);
}
function FaEnvelopeOpen(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M512 464c0 26.51-21.49 48-48 48H48c-26.51 0-48-21.49-48-48V200.724a48 48 0 0 1 18.387-37.776c24.913-19.529 45.501-35.365 164.2-121.511C199.412 29.17 232.797-.347 256 .003c23.198-.354 56.596 29.172 73.413 41.433 118.687 86.137 139.303 101.995 164.2 121.512A48 48 0 0 1 512 200.724V464zm-65.666-196.605c-2.563-3.728-7.7-4.595-11.339-1.907-22.845 16.873-55.462 40.705-105.582 77.079-16.825 12.266-50.21 41.781-73.413 41.43-23.211.344-56.559-29.143-73.413-41.43-50.114-36.37-82.734-60.204-105.582-77.079-3.639-2.688-8.776-1.821-11.339 1.907l-9.072 13.196a7.998 7.998 0 0 0 1.839 10.967c22.887 16.899 55.454 40.69 105.303 76.868 20.274 14.781 56.524 47.813 92.264 47.573 35.724.242 71.961-32.771 92.263-47.573 49.85-36.179 82.418-59.97 105.303-76.868a7.998 7.998 0 0 0 1.839-10.967l-9.071-13.196z"
                }
            }
        ]
    })(props);
}
function FaEnvelopeSquare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M400 32H48C21.49 32 0 53.49 0 80v352c0 26.51 21.49 48 48 48h352c26.51 0 48-21.49 48-48V80c0-26.51-21.49-48-48-48zM178.117 262.104C87.429 196.287 88.353 196.121 64 177.167V152c0-13.255 10.745-24 24-24h272c13.255 0 24 10.745 24 24v25.167c-24.371 18.969-23.434 19.124-114.117 84.938-10.5 7.655-31.392 26.12-45.883 25.894-14.503.218-35.367-18.227-45.883-25.895zM384 217.775V360c0 13.255-10.745 24-24 24H88c-13.255 0-24-10.745-24-24V217.775c13.958 10.794 33.329 25.236 95.303 70.214 14.162 10.341 37.975 32.145 64.694 32.01 26.887.134 51.037-22.041 64.72-32.025 61.958-44.965 81.325-59.406 95.283-70.199z"
                }
            }
        ]
    })(props);
}
function FaEnvelope(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M502.3 190.8c3.9-3.1 9.7-.2 9.7 4.7V400c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V195.6c0-5 5.7-7.8 9.7-4.7 22.4 17.4 52.1 39.5 154.1 113.6 21.1 15.4 56.7 47.8 92.2 47.6 35.7.3 72-32.8 92.3-47.6 102-74.1 131.6-96.3 154-113.7zM256 320c23.2.4 56.6-29.2 73.4-41.4 132.7-96.3 142.8-104.7 173.4-128.7 5.8-4.5 9.2-11.5 9.2-18.9v-19c0-26.5-21.5-48-48-48H48C21.5 64 0 85.5 0 112v19c0 7.4 3.4 14.3 9.2 18.9 30.6 23.9 40.7 32.4 173.4 128.7 16.8 12.2 50.2 41.8 73.4 41.4z"
                }
            }
        ]
    })(props);
}
function FaEquals(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M416 304H32c-17.67 0-32 14.33-32 32v32c0 17.67 14.33 32 32 32h384c17.67 0 32-14.33 32-32v-32c0-17.67-14.33-32-32-32zm0-192H32c-17.67 0-32 14.33-32 32v32c0 17.67 14.33 32 32 32h384c17.67 0 32-14.33 32-32v-32c0-17.67-14.33-32-32-32z"
                }
            }
        ]
    })(props);
}
function FaEraser(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M497.941 273.941c18.745-18.745 18.745-49.137 0-67.882l-160-160c-18.745-18.745-49.136-18.746-67.883 0l-256 256c-18.745 18.745-18.745 49.137 0 67.882l96 96A48.004 48.004 0 0 0 144 480h356c6.627 0 12-5.373 12-12v-40c0-6.627-5.373-12-12-12H355.883l142.058-142.059zm-302.627-62.627l137.373 137.373L265.373 416H150.628l-80-80 124.686-124.686z"
                }
            }
        ]
    })(props);
}
function FaEthernet(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M496 192h-48v-48c0-8.8-7.2-16-16-16h-48V80c0-8.8-7.2-16-16-16H144c-8.8 0-16 7.2-16 16v48H80c-8.8 0-16 7.2-16 16v48H16c-8.8 0-16 7.2-16 16v224c0 8.8 7.2 16 16 16h80V320h32v128h64V320h32v128h64V320h32v128h64V320h32v128h80c8.8 0 16-7.2 16-16V208c0-8.8-7.2-16-16-16z"
                }
            }
        ]
    })(props);
}
function FaEuroSign(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 320 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M310.706 413.765c-1.314-6.63-7.835-10.872-14.424-9.369-10.692 2.439-27.422 5.413-45.426 5.413-56.763 0-101.929-34.79-121.461-85.449h113.689a12 12 0 0 0 11.708-9.369l6.373-28.36c1.686-7.502-4.019-14.631-11.708-14.631H115.22c-1.21-14.328-1.414-28.287.137-42.245H261.95a12 12 0 0 0 11.723-9.434l6.512-29.755c1.638-7.484-4.061-14.566-11.723-14.566H130.184c20.633-44.991 62.69-75.03 117.619-75.03 14.486 0 28.564 2.25 37.851 4.145 6.216 1.268 12.347-2.498 14.002-8.623l11.991-44.368c1.822-6.741-2.465-13.616-9.326-14.917C290.217 34.912 270.71 32 249.635 32 152.451 32 74.03 92.252 45.075 176H12c-6.627 0-12 5.373-12 12v29.755c0 6.627 5.373 12 12 12h21.569c-1.009 13.607-1.181 29.287-.181 42.245H12c-6.627 0-12 5.373-12 12v28.36c0 6.627 5.373 12 12 12h30.114C67.139 414.692 145.264 480 249.635 480c26.301 0 48.562-4.544 61.101-7.788 6.167-1.595 10.027-7.708 8.788-13.957l-8.818-44.49z"
                }
            }
        ]
    })(props);
}
function FaExchangeAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 168v-16c0-13.255 10.745-24 24-24h360V80c0-21.367 25.899-32.042 40.971-16.971l80 80c9.372 9.373 9.372 24.569 0 33.941l-80 80C409.956 271.982 384 261.456 384 240v-48H24c-13.255 0-24-10.745-24-24zm488 152H128v-48c0-21.314-25.862-32.08-40.971-16.971l-80 80c-9.372 9.373-9.372 24.569 0 33.941l80 80C102.057 463.997 128 453.437 128 432v-48h360c13.255 0 24-10.745 24-24v-16c0-13.255-10.745-24-24-24z"
                }
            }
        ]
    })(props);
}
function FaExclamationCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M504 256c0 136.997-111.043 248-248 248S8 392.997 8 256C8 119.083 119.043 8 256 8s248 111.083 248 248zm-248 50c-25.405 0-46 20.595-46 46s20.595 46 46 46 46-20.595 46-46-20.595-46-46-46zm-43.673-165.346l7.418 136c.347 6.364 5.609 11.346 11.982 11.346h48.546c6.373 0 11.635-4.982 11.982-11.346l7.418-136c.375-6.874-5.098-12.654-11.982-12.654h-63.383c-6.884 0-12.356 5.78-11.981 12.654z"
                }
            }
        ]
    })(props);
}
function FaExclamationTriangle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M569.517 440.013C587.975 472.007 564.806 512 527.94 512H48.054c-36.937 0-59.999-40.055-41.577-71.987L246.423 23.985c18.467-32.009 64.72-31.951 83.154 0l239.94 416.028zM288 354c-25.405 0-46 20.595-46 46s20.595 46 46 46 46-20.595 46-46-20.595-46-46-46zm-43.673-165.346l7.418 136c.347 6.364 5.609 11.346 11.982 11.346h48.546c6.373 0 11.635-4.982 11.982-11.346l7.418-136c.375-6.874-5.098-12.654-11.982-12.654h-63.383c-6.884 0-12.356 5.78-11.981 12.654z"
                }
            }
        ]
    })(props);
}
function FaExclamation(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 192 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M176 432c0 44.112-35.888 80-80 80s-80-35.888-80-80 35.888-80 80-80 80 35.888 80 80zM25.26 25.199l13.6 272C39.499 309.972 50.041 320 62.83 320h66.34c12.789 0 23.331-10.028 23.97-22.801l13.6-272C167.425 11.49 156.496 0 142.77 0H49.23C35.504 0 24.575 11.49 25.26 25.199z"
                }
            }
        ]
    })(props);
}
function FaExpandAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M212.686 315.314L120 408l32.922 31.029c15.12 15.12 4.412 40.971-16.97 40.971h-112C10.697 480 0 469.255 0 456V344c0-21.382 25.803-32.09 40.922-16.971L72 360l92.686-92.686c6.248-6.248 16.379-6.248 22.627 0l25.373 25.373c6.249 6.248 6.249 16.378 0 22.627zm22.628-118.628L328 104l-32.922-31.029C279.958 57.851 290.666 32 312.048 32h112C437.303 32 448 42.745 448 56v112c0 21.382-25.803 32.09-40.922 16.971L376 152l-92.686 92.686c-6.248 6.248-16.379 6.248-22.627 0l-25.373-25.373c-6.249-6.248-6.249-16.378 0-22.627z"
                }
            }
        ]
    })(props);
}
function FaExpandArrowsAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M448 344v112a23.94 23.94 0 0 1-24 24H312c-21.39 0-32.09-25.9-17-41l36.2-36.2L224 295.6 116.77 402.9 153 439c15.09 15.1 4.39 41-17 41H24a23.94 23.94 0 0 1-24-24V344c0-21.4 25.89-32.1 41-17l36.19 36.2L184.46 256 77.18 148.7 41 185c-15.1 15.1-41 4.4-41-17V56a23.94 23.94 0 0 1 24-24h112c21.39 0 32.09 25.9 17 41l-36.2 36.2L224 216.4l107.23-107.3L295 73c-15.09-15.1-4.39-41 17-41h112a23.94 23.94 0 0 1 24 24v112c0 21.4-25.89 32.1-41 17l-36.19-36.2L263.54 256l107.28 107.3L407 327.1c15.1-15.2 41-4.5 41 16.9z"
                }
            }
        ]
    })(props);
}
function FaExpand(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 180V56c0-13.3 10.7-24 24-24h124c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12H64v84c0 6.6-5.4 12-12 12H12c-6.6 0-12-5.4-12-12zM288 44v40c0 6.6 5.4 12 12 12h84v84c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12V56c0-13.3-10.7-24-24-24H300c-6.6 0-12 5.4-12 12zm148 276h-40c-6.6 0-12 5.4-12 12v84h-84c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h124c13.3 0 24-10.7 24-24V332c0-6.6-5.4-12-12-12zM160 468v-40c0-6.6-5.4-12-12-12H64v-84c0-6.6-5.4-12-12-12H12c-6.6 0-12 5.4-12 12v124c0 13.3 10.7 24 24 24h124c6.6 0 12-5.4 12-12z"
                }
            }
        ]
    })(props);
}
function FaExternalLinkAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M432,320H400a16,16,0,0,0-16,16V448H64V128H208a16,16,0,0,0,16-16V80a16,16,0,0,0-16-16H48A48,48,0,0,0,0,112V464a48,48,0,0,0,48,48H400a48,48,0,0,0,48-48V336A16,16,0,0,0,432,320ZM488,0h-128c-21.37,0-32.05,25.91-17,41l35.73,35.73L135,320.37a24,24,0,0,0,0,34L157.67,377a24,24,0,0,0,34,0L435.28,133.32,471,169c15,15,41,4.5,41-17V24A24,24,0,0,0,488,0Z"
                }
            }
        ]
    })(props);
}
function FaExternalLinkSquareAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M448 80v352c0 26.51-21.49 48-48 48H48c-26.51 0-48-21.49-48-48V80c0-26.51 21.49-48 48-48h352c26.51 0 48 21.49 48 48zm-88 16H248.029c-21.313 0-32.08 25.861-16.971 40.971l31.984 31.987L67.515 364.485c-4.686 4.686-4.686 12.284 0 16.971l31.029 31.029c4.687 4.686 12.285 4.686 16.971 0l195.526-195.526 31.988 31.991C358.058 263.977 384 253.425 384 231.979V120c0-13.255-10.745-24-24-24z"
                }
            }
        ]
    })(props);
}
function FaEyeDropper(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M50.75 333.25c-12 12-18.75 28.28-18.75 45.26V424L0 480l32 32 56-32h45.49c16.97 0 33.25-6.74 45.25-18.74l126.64-126.62-128-128L50.75 333.25zM483.88 28.12c-37.47-37.5-98.28-37.5-135.75 0l-77.09 77.09-13.1-13.1c-9.44-9.44-24.65-9.31-33.94 0l-40.97 40.97c-9.37 9.37-9.37 24.57 0 33.94l161.94 161.94c9.44 9.44 24.65 9.31 33.94 0L419.88 288c9.37-9.37 9.37-24.57 0-33.94l-13.1-13.1 77.09-77.09c37.51-37.48 37.51-98.26.01-135.75z"
                }
            }
        ]
    })(props);
}
function FaEyeSlash(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M320 400c-75.85 0-137.25-58.71-142.9-133.11L72.2 185.82c-13.79 17.3-26.48 35.59-36.72 55.59a32.35 32.35 0 0 0 0 29.19C89.71 376.41 197.07 448 320 448c26.91 0 52.87-4 77.89-10.46L346 397.39a144.13 144.13 0 0 1-26 2.61zm313.82 58.1l-110.55-85.44a331.25 331.25 0 0 0 81.25-102.07 32.35 32.35 0 0 0 0-29.19C550.29 135.59 442.93 64 320 64a308.15 308.15 0 0 0-147.32 37.7L45.46 3.37A16 16 0 0 0 23 6.18L3.37 31.45A16 16 0 0 0 6.18 53.9l588.36 454.73a16 16 0 0 0 22.46-2.81l19.64-25.27a16 16 0 0 0-2.82-22.45zm-183.72-142l-39.3-30.38A94.75 94.75 0 0 0 416 256a94.76 94.76 0 0 0-121.31-92.21A47.65 47.65 0 0 1 304 192a46.64 46.64 0 0 1-1.54 10l-73.61-56.89A142.31 142.31 0 0 1 320 112a143.92 143.92 0 0 1 144 144c0 21.63-5.29 41.79-13.9 60.11z"
                }
            }
        ]
    })(props);
}
function FaEye(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M572.52 241.4C518.29 135.59 410.93 64 288 64S57.68 135.64 3.48 241.41a32.35 32.35 0 0 0 0 29.19C57.71 376.41 165.07 448 288 448s230.32-71.64 284.52-177.41a32.35 32.35 0 0 0 0-29.19zM288 400a144 144 0 1 1 144-144 143.93 143.93 0 0 1-144 144zm0-240a95.31 95.31 0 0 0-25.31 3.79 47.85 47.85 0 0 1-66.9 66.9A95.78 95.78 0 1 0 288 160z"
                }
            }
        ]
    })(props);
}
function FaFan(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M352.57 128c-28.09 0-54.09 4.52-77.06 12.86l12.41-123.11C289 7.31 279.81-1.18 269.33.13 189.63 10.13 128 77.64 128 159.43c0 28.09 4.52 54.09 12.86 77.06L17.75 224.08C7.31 223-1.18 232.19.13 242.67c10 79.7 77.51 141.33 159.3 141.33 28.09 0 54.09-4.52 77.06-12.86l-12.41 123.11c-1.05 10.43 8.11 18.93 18.59 17.62 79.7-10 141.33-77.51 141.33-159.3 0-28.09-4.52-54.09-12.86-77.06l123.11 12.41c10.44 1.05 18.93-8.11 17.62-18.59-10-79.7-77.51-141.33-159.3-141.33zM256 288a32 32 0 1 1 32-32 32 32 0 0 1-32 32z"
                }
            }
        ]
    })(props);
}
function FaFastBackward(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 436V76c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v151.9L235.5 71.4C256.1 54.3 288 68.6 288 96v131.9L459.5 71.4C480.1 54.3 512 68.6 512 96v320c0 27.4-31.9 41.7-52.5 24.6L288 285.3V416c0 27.4-31.9 41.7-52.5 24.6L64 285.3V436c0 6.6-5.4 12-12 12H12c-6.6 0-12-5.4-12-12z"
                }
            }
        ]
    })(props);
}
function FaFastForward(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M512 76v360c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12V284.1L276.5 440.6c-20.6 17.2-52.5 2.8-52.5-24.6V284.1L52.5 440.6C31.9 457.8 0 443.4 0 416V96c0-27.4 31.9-41.7 52.5-24.6L224 226.8V96c0-27.4 31.9-41.7 52.5-24.6L448 226.8V76c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12z"
                }
            }
        ]
    })(props);
}
function FaFaucet(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M352,256H313.39c-15.71-13.44-35.46-23.07-57.39-28V180.44l-32-3.38-32,3.38V228c-21.93,5-41.68,14.6-57.39,28H16A16,16,0,0,0,0,272v96a16,16,0,0,0,16,16h92.79C129.38,421.73,173,448,224,448s94.62-26.27,115.21-64H352a32,32,0,0,1,32,32,32,32,0,0,0,32,32h64a32,32,0,0,0,32-32A160,160,0,0,0,352,256ZM81.59,159.91l142.41-15,142.41,15c9.42,1,17.59-6.81,17.59-16.8V112.89c0-10-8.17-17.8-17.59-16.81L256,107.74V80a16,16,0,0,0-16-16H208a16,16,0,0,0-16,16v27.74L81.59,96.08C72.17,95.09,64,102.9,64,112.89v30.22C64,153.1,72.17,160.91,81.59,159.91Z"
                }
            }
        ]
    })(props);
}
function FaFax(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M480 160V77.25a32 32 0 0 0-9.38-22.63L425.37 9.37A32 32 0 0 0 402.75 0H160a32 32 0 0 0-32 32v448a32 32 0 0 0 32 32h320a32 32 0 0 0 32-32V192a32 32 0 0 0-32-32zM288 432a16 16 0 0 1-16 16h-32a16 16 0 0 1-16-16v-32a16 16 0 0 1 16-16h32a16 16 0 0 1 16 16zm0-128a16 16 0 0 1-16 16h-32a16 16 0 0 1-16-16v-32a16 16 0 0 1 16-16h32a16 16 0 0 1 16 16zm128 128a16 16 0 0 1-16 16h-32a16 16 0 0 1-16-16v-32a16 16 0 0 1 16-16h32a16 16 0 0 1 16 16zm0-128a16 16 0 0 1-16 16h-32a16 16 0 0 1-16-16v-32a16 16 0 0 1 16-16h32a16 16 0 0 1 16 16zm0-112H192V64h160v48a16 16 0 0 0 16 16h48zM64 128H32a32 32 0 0 0-32 32v320a32 32 0 0 0 32 32h32a32 32 0 0 0 32-32V160a32 32 0 0 0-32-32z"
                }
            }
        ]
    })(props);
}
function FaFeatherAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M512 0C460.22 3.56 96.44 38.2 71.01 287.61c-3.09 26.66-4.84 53.44-5.99 80.24l178.87-178.69c6.25-6.25 16.4-6.25 22.65 0s6.25 16.38 0 22.63L7.04 471.03c-9.38 9.37-9.38 24.57 0 33.94 9.38 9.37 24.59 9.37 33.98 0l57.13-57.07c42.09-.14 84.15-2.53 125.96-7.36 53.48-5.44 97.02-26.47 132.58-56.54H255.74l146.79-48.88c11.25-14.89 21.37-30.71 30.45-47.12h-81.14l106.54-53.21C500.29 132.86 510.19 26.26 512 0z"
                }
            }
        ]
    })(props);
}
function FaFeather(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M467.14 44.84c-62.55-62.48-161.67-64.78-252.28 25.73-78.61 78.52-60.98 60.92-85.75 85.66-60.46 60.39-70.39 150.83-63.64 211.17l178.44-178.25c6.26-6.25 16.4-6.25 22.65 0s6.25 16.38 0 22.63L7.04 471.03c-9.38 9.37-9.38 24.57 0 33.94 9.38 9.37 24.6 9.37 33.98 0l66.1-66.03C159.42 454.65 279 457.11 353.95 384h-98.19l147.57-49.14c49.99-49.93 36.38-36.18 46.31-46.86h-97.78l131.54-43.8c45.44-74.46 34.31-148.84-16.26-199.36z"
                }
            }
        ]
    })(props);
}
function FaFemale(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 256 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M128 0c35.346 0 64 28.654 64 64s-28.654 64-64 64c-35.346 0-64-28.654-64-64S92.654 0 128 0m119.283 354.179l-48-192A24 24 0 0 0 176 144h-11.36c-22.711 10.443-49.59 10.894-73.28 0H80a24 24 0 0 0-23.283 18.179l-48 192C4.935 369.305 16.383 384 32 384h56v104c0 13.255 10.745 24 24 24h32c13.255 0 24-10.745 24-24V384h56c15.591 0 27.071-14.671 23.283-29.821z"
                }
            }
        ]
    })(props);
}
function FaFighterJet(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M544 224l-128-16-48-16h-24L227.158 44h39.509C278.333 44 288 41.375 288 38s-9.667-6-21.333-6H152v12h16v164h-48l-66.667-80H18.667L8 138.667V208h8v16h48v2.666l-64 8v42.667l64 8V288H16v16H8v69.333L18.667 384h34.667L120 304h48v164h-16v12h114.667c11.667 0 21.333-2.625 21.333-6s-9.667-6-21.333-6h-39.509L344 320h24l48-16 128-16c96-21.333 96-26.583 96-32 0-5.417 0-10.667-96-32z"
                }
            }
        ]
    })(props);
}
function FaFileAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M224 136V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H248c-13.2 0-24-10.8-24-24zm64 236c0 6.6-5.4 12-12 12H108c-6.6 0-12-5.4-12-12v-8c0-6.6 5.4-12 12-12h168c6.6 0 12 5.4 12 12v8zm0-64c0 6.6-5.4 12-12 12H108c-6.6 0-12-5.4-12-12v-8c0-6.6 5.4-12 12-12h168c6.6 0 12 5.4 12 12v8zm0-72v8c0 6.6-5.4 12-12 12H108c-6.6 0-12-5.4-12-12v-8c0-6.6 5.4-12 12-12h168c6.6 0 12 5.4 12 12zm96-114.1v6.1H256V0h6.1c6.4 0 12.5 2.5 17 7l97.9 98c4.5 4.5 7 10.6 7 16.9z"
                }
            }
        ]
    })(props);
}
function FaFileArchive(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M377 105L279.1 7c-4.5-4.5-10.6-7-17-7H256v128h128v-6.1c0-6.3-2.5-12.4-7-16.9zM128.4 336c-17.9 0-32.4 12.1-32.4 27 0 15 14.6 27 32.5 27s32.4-12.1 32.4-27-14.6-27-32.5-27zM224 136V0h-63.6v32h-32V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H248c-13.2 0-24-10.8-24-24zM95.9 32h32v32h-32zm32.3 384c-33.2 0-58-30.4-51.4-62.9L96.4 256v-32h32v-32h-32v-32h32v-32h-32V96h32V64h32v32h-32v32h32v32h-32v32h32v32h-32v32h22.1c5.7 0 10.7 4.1 11.8 9.7l17.3 87.7c6.4 32.4-18.4 62.6-51.4 62.6z"
                }
            }
        ]
    })(props);
}
function FaFileAudio(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M224 136V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H248c-13.2 0-24-10.8-24-24zm-64 268c0 10.7-12.9 16-20.5 8.5L104 376H76c-6.6 0-12-5.4-12-12v-56c0-6.6 5.4-12 12-12h28l35.5-36.5c7.6-7.6 20.5-2.2 20.5 8.5v136zm33.2-47.6c9.1-9.3 9.1-24.1 0-33.4-22.1-22.8 12.2-56.2 34.4-33.5 27.2 27.9 27.2 72.4 0 100.4-21.8 22.3-56.9-10.4-34.4-33.5zm86-117.1c54.4 55.9 54.4 144.8 0 200.8-21.8 22.4-57-10.3-34.4-33.5 36.2-37.2 36.3-96.5 0-133.8-22.1-22.8 12.3-56.3 34.4-33.5zM384 121.9v6.1H256V0h6.1c6.4 0 12.5 2.5 17 7l97.9 98c4.5 4.5 7 10.6 7 16.9z"
                }
            }
        ]
    })(props);
}
function FaFileCode(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M384 121.941V128H256V0h6.059c6.365 0 12.47 2.529 16.971 7.029l97.941 97.941A24.005 24.005 0 0 1 384 121.941zM248 160c-13.2 0-24-10.8-24-24V0H24C10.745 0 0 10.745 0 24v464c0 13.255 10.745 24 24 24h336c13.255 0 24-10.745 24-24V160H248zM123.206 400.505a5.4 5.4 0 0 1-7.633.246l-64.866-60.812a5.4 5.4 0 0 1 0-7.879l64.866-60.812a5.4 5.4 0 0 1 7.633.246l19.579 20.885a5.4 5.4 0 0 1-.372 7.747L101.65 336l40.763 35.874a5.4 5.4 0 0 1 .372 7.747l-19.579 20.884zm51.295 50.479l-27.453-7.97a5.402 5.402 0 0 1-3.681-6.692l61.44-211.626a5.402 5.402 0 0 1 6.692-3.681l27.452 7.97a5.4 5.4 0 0 1 3.68 6.692l-61.44 211.626a5.397 5.397 0 0 1-6.69 3.681zm160.792-111.045l-64.866 60.812a5.4 5.4 0 0 1-7.633-.246l-19.58-20.885a5.4 5.4 0 0 1 .372-7.747L284.35 336l-40.763-35.874a5.4 5.4 0 0 1-.372-7.747l19.58-20.885a5.4 5.4 0 0 1 7.633-.246l64.866 60.812a5.4 5.4 0 0 1-.001 7.879z"
                }
            }
        ]
    })(props);
}
function FaFileContract(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M224 136V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H248c-13.2 0-24-10.8-24-24zM64 72c0-4.42 3.58-8 8-8h80c4.42 0 8 3.58 8 8v16c0 4.42-3.58 8-8 8H72c-4.42 0-8-3.58-8-8V72zm0 64c0-4.42 3.58-8 8-8h80c4.42 0 8 3.58 8 8v16c0 4.42-3.58 8-8 8H72c-4.42 0-8-3.58-8-8v-16zm192.81 248H304c8.84 0 16 7.16 16 16s-7.16 16-16 16h-47.19c-16.45 0-31.27-9.14-38.64-23.86-2.95-5.92-8.09-6.52-10.17-6.52s-7.22.59-10.02 6.19l-7.67 15.34a15.986 15.986 0 0 1-14.31 8.84c-.38 0-.75-.02-1.14-.05-6.45-.45-12-4.75-14.03-10.89L144 354.59l-10.61 31.88c-5.89 17.66-22.38 29.53-41 29.53H80c-8.84 0-16-7.16-16-16s7.16-16 16-16h12.39c4.83 0 9.11-3.08 10.64-7.66l18.19-54.64c3.3-9.81 12.44-16.41 22.78-16.41s19.48 6.59 22.77 16.41l13.88 41.64c19.77-16.19 54.05-9.7 66 14.16 2.02 4.06 5.96 6.5 10.16 6.5zM377 105L279.1 7c-4.5-4.5-10.6-7-17-7H256v128h128v-6.1c0-6.3-2.5-12.4-7-16.9z"
                }
            }
        ]
    })(props);
}
function FaFileCsv(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M224 136V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H248c-13.2 0-24-10.8-24-24zm-96 144c0 4.42-3.58 8-8 8h-8c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h8c4.42 0 8 3.58 8 8v16c0 4.42-3.58 8-8 8h-8c-26.51 0-48-21.49-48-48v-32c0-26.51 21.49-48 48-48h8c4.42 0 8 3.58 8 8v16zm44.27 104H160c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h12.27c5.95 0 10.41-3.5 10.41-6.62 0-1.3-.75-2.66-2.12-3.84l-21.89-18.77c-8.47-7.22-13.33-17.48-13.33-28.14 0-21.3 19.02-38.62 42.41-38.62H200c4.42 0 8 3.58 8 8v16c0 4.42-3.58 8-8 8h-12.27c-5.95 0-10.41 3.5-10.41 6.62 0 1.3.75 2.66 2.12 3.84l21.89 18.77c8.47 7.22 13.33 17.48 13.33 28.14.01 21.29-19 38.62-42.39 38.62zM256 264v20.8c0 20.27 5.7 40.17 16 56.88 10.3-16.7 16-36.61 16-56.88V264c0-4.42 3.58-8 8-8h16c4.42 0 8 3.58 8 8v20.8c0 35.48-12.88 68.89-36.28 94.09-3.02 3.25-7.27 5.11-11.72 5.11s-8.7-1.86-11.72-5.11c-23.4-25.2-36.28-58.61-36.28-94.09V264c0-4.42 3.58-8 8-8h16c4.42 0 8 3.58 8 8zm121-159L279.1 7c-4.5-4.5-10.6-7-17-7H256v128h128v-6.1c0-6.3-2.5-12.4-7-16.9z"
                }
            }
        ]
    })(props);
}
function FaFileDownload(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M224 136V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H248c-13.2 0-24-10.8-24-24zm76.45 211.36l-96.42 95.7c-6.65 6.61-17.39 6.61-24.04 0l-96.42-95.7C73.42 337.29 80.54 320 94.82 320H160v-80c0-8.84 7.16-16 16-16h32c8.84 0 16 7.16 16 16v80h65.18c14.28 0 21.4 17.29 11.27 27.36zM377 105L279.1 7c-4.5-4.5-10.6-7-17-7H256v128h128v-6.1c0-6.3-2.5-12.4-7-16.9z"
                }
            }
        ]
    })(props);
}
function FaFileExcel(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M224 136V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H248c-13.2 0-24-10.8-24-24zm60.1 106.5L224 336l60.1 93.5c5.1 8-.6 18.5-10.1 18.5h-34.9c-4.4 0-8.5-2.4-10.6-6.3C208.9 405.5 192 373 192 373c-6.4 14.8-10 20-36.6 68.8-2.1 3.9-6.1 6.3-10.5 6.3H110c-9.5 0-15.2-10.5-10.1-18.5l60.3-93.5-60.3-93.5c-5.2-8 .6-18.5 10.1-18.5h34.8c4.4 0 8.5 2.4 10.6 6.3 26.1 48.8 20 33.6 36.6 68.5 0 0 6.1-11.7 36.6-68.5 2.1-3.9 6.2-6.3 10.6-6.3H274c9.5-.1 15.2 10.4 10.1 18.4zM384 121.9v6.1H256V0h6.1c6.4 0 12.5 2.5 17 7l97.9 98c4.5 4.5 7 10.6 7 16.9z"
                }
            }
        ]
    })(props);
}
function FaFileExport(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M384 121.9c0-6.3-2.5-12.4-7-16.9L279.1 7c-4.5-4.5-10.6-7-17-7H256v128h128zM571 308l-95.7-96.4c-10.1-10.1-27.4-3-27.4 11.3V288h-64v64h64v65.2c0 14.3 17.3 21.4 27.4 11.3L571 332c6.6-6.6 6.6-17.4 0-24zm-379 28v-32c0-8.8 7.2-16 16-16h176V160H248c-13.2 0-24-10.8-24-24V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V352H208c-8.8 0-16-7.2-16-16z"
                }
            }
        ]
    })(props);
}
function FaFileImage(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M384 121.941V128H256V0h6.059a24 24 0 0 1 16.97 7.029l97.941 97.941a24.002 24.002 0 0 1 7.03 16.971zM248 160c-13.2 0-24-10.8-24-24V0H24C10.745 0 0 10.745 0 24v464c0 13.255 10.745 24 24 24h336c13.255 0 24-10.745 24-24V160H248zm-135.455 16c26.51 0 48 21.49 48 48s-21.49 48-48 48-48-21.49-48-48 21.491-48 48-48zm208 240h-256l.485-48.485L104.545 328c4.686-4.686 11.799-4.201 16.485.485L160.545 368 264.06 264.485c4.686-4.686 12.284-4.686 16.971 0L320.545 304v112z"
                }
            }
        ]
    })(props);
}
function FaFileImport(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 288c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h112v-64zm489-183L407.1 7c-4.5-4.5-10.6-7-17-7H384v128h128v-6.1c0-6.3-2.5-12.4-7-16.9zm-153 31V0H152c-13.3 0-24 10.7-24 24v264h128v-65.2c0-14.3 17.3-21.4 27.4-11.3L379 308c6.6 6.7 6.6 17.4 0 24l-95.7 96.4c-10.1 10.1-27.4 3-27.4-11.3V352H128v136c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H376c-13.2 0-24-10.8-24-24z"
                }
            }
        ]
    })(props);
}
function FaFileInvoiceDollar(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M377 105L279.1 7c-4.5-4.5-10.6-7-17-7H256v128h128v-6.1c0-6.3-2.5-12.4-7-16.9zm-153 31V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H248c-13.2 0-24-10.8-24-24zM64 72c0-4.42 3.58-8 8-8h80c4.42 0 8 3.58 8 8v16c0 4.42-3.58 8-8 8H72c-4.42 0-8-3.58-8-8V72zm0 80v-16c0-4.42 3.58-8 8-8h80c4.42 0 8 3.58 8 8v16c0 4.42-3.58 8-8 8H72c-4.42 0-8-3.58-8-8zm144 263.88V440c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8v-24.29c-11.29-.58-22.27-4.52-31.37-11.35-3.9-2.93-4.1-8.77-.57-12.14l11.75-11.21c2.77-2.64 6.89-2.76 10.13-.73 3.87 2.42 8.26 3.72 12.82 3.72h28.11c6.5 0 11.8-5.92 11.8-13.19 0-5.95-3.61-11.19-8.77-12.73l-45-13.5c-18.59-5.58-31.58-23.42-31.58-43.39 0-24.52 19.05-44.44 42.67-45.07V232c0-4.42 3.58-8 8-8h16c4.42 0 8 3.58 8 8v24.29c11.29.58 22.27 4.51 31.37 11.35 3.9 2.93 4.1 8.77.57 12.14l-11.75 11.21c-2.77 2.64-6.89 2.76-10.13.73-3.87-2.43-8.26-3.72-12.82-3.72h-28.11c-6.5 0-11.8 5.92-11.8 13.19 0 5.95 3.61 11.19 8.77 12.73l45 13.5c18.59 5.58 31.58 23.42 31.58 43.39 0 24.53-19.05 44.44-42.67 45.07z"
                }
            }
        ]
    })(props);
}
function FaFileInvoice(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M288 256H96v64h192v-64zm89-151L279.1 7c-4.5-4.5-10.6-7-17-7H256v128h128v-6.1c0-6.3-2.5-12.4-7-16.9zm-153 31V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H248c-13.2 0-24-10.8-24-24zM64 72c0-4.42 3.58-8 8-8h80c4.42 0 8 3.58 8 8v16c0 4.42-3.58 8-8 8H72c-4.42 0-8-3.58-8-8V72zm0 64c0-4.42 3.58-8 8-8h80c4.42 0 8 3.58 8 8v16c0 4.42-3.58 8-8 8H72c-4.42 0-8-3.58-8-8v-16zm256 304c0 4.42-3.58 8-8 8h-80c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h80c4.42 0 8 3.58 8 8v16zm0-200v96c0 8.84-7.16 16-16 16H80c-8.84 0-16-7.16-16-16v-96c0-8.84 7.16-16 16-16h224c8.84 0 16 7.16 16 16z"
                }
            }
        ]
    })(props);
}
function FaFileMedicalAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M288 136V0H88C74.7 0 64 10.7 64 24v232H8c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h140.9c3 0 5.8 1.7 7.2 4.4l19.9 39.8 56.8-113.7c2.9-5.9 11.4-5.9 14.3 0l34.7 69.5H352c8.8 0 16 7.2 16 16s-7.2 16-16 16h-89.9L240 275.8l-56.8 113.7c-2.9 5.9-11.4 5.9-14.3 0L134.1 320H64v168c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H312c-13.2 0-24-10.8-24-24zm153-31L343.1 7c-4.5-4.5-10.6-7-17-7H320v128h128v-6.1c0-6.3-2.5-12.4-7-16.9z"
                }
            }
        ]
    })(props);
}
function FaFileMedical(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M377 105L279.1 7c-4.5-4.5-10.6-7-17-7H256v128h128v-6.1c0-6.3-2.5-12.4-7-16.9zm-153 31V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H248c-13.2 0-24-10.8-24-24zm64 160v48c0 4.4-3.6 8-8 8h-56v56c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8v-56h-56c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h56v-56c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v56h56c4.4 0 8 3.6 8 8z"
                }
            }
        ]
    })(props);
}
function FaFilePdf(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M181.9 256.1c-5-16-4.9-46.9-2-46.9 8.4 0 7.6 36.9 2 46.9zm-1.7 47.2c-7.7 20.2-17.3 43.3-28.4 62.7 18.3-7 39-17.2 62.9-21.9-12.7-9.6-24.9-23.4-34.5-40.8zM86.1 428.1c0 .8 13.2-5.4 34.9-40.2-6.7 6.3-29.1 24.5-34.9 40.2zM248 160h136v328c0 13.3-10.7 24-24 24H24c-13.3 0-24-10.7-24-24V24C0 10.7 10.7 0 24 0h200v136c0 13.2 10.8 24 24 24zm-8 171.8c-20-12.2-33.3-29-42.7-53.8 4.5-18.5 11.6-46.6 6.2-64.2-4.7-29.4-42.4-26.5-47.8-6.8-5 18.3-.4 44.1 8.1 77-11.6 27.6-28.7 64.6-40.8 85.8-.1 0-.1.1-.2.1-27.1 13.9-73.6 44.5-54.5 68 5.6 6.9 16 10 21.5 10 17.9 0 35.7-18 61.1-61.8 25.8-8.5 54.1-19.1 79-23.2 21.7 11.8 47.1 19.5 64 19.5 29.2 0 31.2-32 19.7-43.4-13.9-13.6-54.3-9.7-73.6-7.2zM377 105L279 7c-4.5-4.5-10.6-7-17-7h-6v128h128v-6.1c0-6.3-2.5-12.4-7-16.9zm-74.1 255.3c4.1-2.7-2.5-11.9-42.8-9 37.1 15.8 42.8 9 42.8 9z"
                }
            }
        ]
    })(props);
}
function FaFilePowerpoint(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M193.7 271.2c8.8 0 15.5 2.7 20.3 8.1 9.6 10.9 9.8 32.7-.2 44.1-4.9 5.6-11.9 8.5-21.1 8.5h-26.9v-60.7h27.9zM377 105L279 7c-4.5-4.5-10.6-7-17-7h-6v128h128v-6.1c0-6.3-2.5-12.4-7-16.9zm-153 31V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H248c-13.2 0-24-10.8-24-24zm53 165.2c0 90.3-88.8 77.6-111.1 77.6V436c0 6.6-5.4 12-12 12h-30.8c-6.6 0-12-5.4-12-12V236.2c0-6.6 5.4-12 12-12h81c44.5 0 72.9 32.8 72.9 77z"
                }
            }
        ]
    })(props);
}
function FaFilePrescription(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M224 136V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H248c-13.2 0-24-10.8-24-24zm68.53 179.48l11.31 11.31c6.25 6.25 6.25 16.38 0 22.63l-29.9 29.9L304 409.38c6.25 6.25 6.25 16.38 0 22.63l-11.31 11.31c-6.25 6.25-16.38 6.25-22.63 0L240 413.25l-30.06 30.06c-6.25 6.25-16.38 6.25-22.63 0L176 432c-6.25-6.25-6.25-16.38 0-22.63l30.06-30.06L146.74 320H128v48c0 8.84-7.16 16-16 16H96c-8.84 0-16-7.16-16-16V208c0-8.84 7.16-16 16-16h80c35.35 0 64 28.65 64 64 0 24.22-13.62 45.05-33.46 55.92L240 345.38l29.9-29.9c6.25-6.25 16.38-6.25 22.63 0zM176 272h-48v-32h48c8.82 0 16 7.18 16 16s-7.18 16-16 16zm208-150.1v6.1H256V0h6.1c6.4 0 12.5 2.5 17 7l97.9 98c4.5 4.5 7 10.6 7 16.9z"
                }
            }
        ]
    })(props);
}
function FaFileSignature(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M218.17 424.14c-2.95-5.92-8.09-6.52-10.17-6.52s-7.22.59-10.02 6.19l-7.67 15.34c-6.37 12.78-25.03 11.37-29.48-2.09L144 386.59l-10.61 31.88c-5.89 17.66-22.38 29.53-41 29.53H80c-8.84 0-16-7.16-16-16s7.16-16 16-16h12.39c4.83 0 9.11-3.08 10.64-7.66l18.19-54.64c3.3-9.81 12.44-16.41 22.78-16.41s19.48 6.59 22.77 16.41l13.88 41.64c19.75-16.19 54.06-9.7 66 14.16 1.89 3.78 5.49 5.95 9.36 6.26v-82.12l128-127.09V160H248c-13.2 0-24-10.8-24-24V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24v-40l-128-.11c-16.12-.31-30.58-9.28-37.83-23.75zM384 121.9c0-6.3-2.5-12.4-7-16.9L279.1 7c-4.5-4.5-10.6-7-17-7H256v128h128v-6.1zm-96 225.06V416h68.99l161.68-162.78-67.88-67.88L288 346.96zm280.54-179.63l-31.87-31.87c-9.94-9.94-26.07-9.94-36.01 0l-27.25 27.25 67.88 67.88 27.25-27.25c9.95-9.94 9.95-26.07 0-36.01z"
                }
            }
        ]
    })(props);
}
function FaFileUpload(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M224 136V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H248c-13.2 0-24-10.8-24-24zm65.18 216.01H224v80c0 8.84-7.16 16-16 16h-32c-8.84 0-16-7.16-16-16v-80H94.82c-14.28 0-21.41-17.29-11.27-27.36l96.42-95.7c6.65-6.61 17.39-6.61 24.04 0l96.42 95.7c10.15 10.07 3.03 27.36-11.25 27.36zM377 105L279.1 7c-4.5-4.5-10.6-7-17-7H256v128h128v-6.1c0-6.3-2.5-12.4-7-16.9z"
                }
            }
        ]
    })(props);
}
function FaFileVideo(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M384 121.941V128H256V0h6.059c6.365 0 12.47 2.529 16.971 7.029l97.941 97.941A24.005 24.005 0 0 1 384 121.941zM224 136V0H24C10.745 0 0 10.745 0 24v464c0 13.255 10.745 24 24 24h336c13.255 0 24-10.745 24-24V160H248c-13.2 0-24-10.8-24-24zm96 144.016v111.963c0 21.445-25.943 31.998-40.971 16.971L224 353.941V392c0 13.255-10.745 24-24 24H88c-13.255 0-24-10.745-24-24V280c0-13.255 10.745-24 24-24h112c13.255 0 24 10.745 24 24v38.059l55.029-55.013c15.011-15.01 40.971-4.491 40.971 16.97z"
                }
            }
        ]
    })(props);
}
function FaFileWord(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M224 136V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H248c-13.2 0-24-10.8-24-24zm57.1 120H305c7.7 0 13.4 7.1 11.7 14.7l-38 168c-1.2 5.5-6.1 9.3-11.7 9.3h-38c-5.5 0-10.3-3.8-11.6-9.1-25.8-103.5-20.8-81.2-25.6-110.5h-.5c-1.1 14.3-2.4 17.4-25.6 110.5-1.3 5.3-6.1 9.1-11.6 9.1H117c-5.6 0-10.5-3.9-11.7-9.4l-37.8-168c-1.7-7.5 4-14.6 11.7-14.6h24.5c5.7 0 10.7 4 11.8 9.7 15.6 78 20.1 109.5 21 122.2 1.6-10.2 7.3-32.7 29.4-122.7 1.3-5.4 6.1-9.1 11.7-9.1h29.1c5.6 0 10.4 3.8 11.7 9.2 24 100.4 28.8 124 29.6 129.4-.2-11.2-2.6-17.8 21.6-129.2 1-5.6 5.9-9.5 11.5-9.5zM384 121.9v6.1H256V0h6.1c6.4 0 12.5 2.5 17 7l97.9 98c4.5 4.5 7 10.6 7 16.9z"
                }
            }
        ]
    })(props);
}
function FaFile(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M224 136V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H248c-13.2 0-24-10.8-24-24zm160-14.1v6.1H256V0h6.1c6.4 0 12.5 2.5 17 7l97.9 98c4.5 4.5 7 10.6 7 16.9z"
                }
            }
        ]
    })(props);
}
function FaFillDrip(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M512 320s-64 92.65-64 128c0 35.35 28.66 64 64 64s64-28.65 64-64-64-128-64-128zm-9.37-102.94L294.94 9.37C288.69 3.12 280.5 0 272.31 0s-16.38 3.12-22.62 9.37l-81.58 81.58L81.93 4.76c-6.25-6.25-16.38-6.25-22.62 0L36.69 27.38c-6.24 6.25-6.24 16.38 0 22.62l86.19 86.18-94.76 94.76c-37.49 37.48-37.49 98.26 0 135.75l117.19 117.19c18.74 18.74 43.31 28.12 67.87 28.12 24.57 0 49.13-9.37 67.87-28.12l221.57-221.57c12.5-12.5 12.5-32.75.01-45.25zm-116.22 70.97H65.93c1.36-3.84 3.57-7.98 7.43-11.83l13.15-13.15 81.61-81.61 58.6 58.6c12.49 12.49 32.75 12.49 45.24 0s12.49-32.75 0-45.24l-58.6-58.6 58.95-58.95 162.44 162.44-48.34 48.34z"
                }
            }
        ]
    })(props);
}
function FaFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M502.63 217.06L294.94 9.37C288.69 3.12 280.5 0 272.31 0s-16.38 3.12-22.62 9.37l-81.58 81.58L81.93 4.77c-6.24-6.25-16.38-6.25-22.62 0L36.69 27.38c-6.24 6.25-6.24 16.38 0 22.63l86.19 86.18-94.76 94.76c-37.49 37.49-37.49 98.26 0 135.75l117.19 117.19c18.75 18.74 43.31 28.12 67.87 28.12 24.57 0 49.13-9.37 67.88-28.12l221.57-221.57c12.49-12.5 12.49-32.76 0-45.26zm-116.22 70.97H65.93c1.36-3.84 3.57-7.98 7.43-11.83l13.15-13.15 81.61-81.61 58.61 58.6c12.49 12.49 32.75 12.49 45.24 0 12.49-12.49 12.49-32.75 0-45.24l-58.61-58.6 58.95-58.95 162.45 162.44-48.35 48.34z"
                }
            }
        ]
    })(props);
}
function FaFilm(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M488 64h-8v20c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12V64H96v20c0 6.6-5.4 12-12 12H44c-6.6 0-12-5.4-12-12V64h-8C10.7 64 0 74.7 0 88v336c0 13.3 10.7 24 24 24h8v-20c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v20h320v-20c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v20h8c13.3 0 24-10.7 24-24V88c0-13.3-10.7-24-24-24zM96 372c0 6.6-5.4 12-12 12H44c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40zm0-96c0 6.6-5.4 12-12 12H44c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40zm0-96c0 6.6-5.4 12-12 12H44c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40zm272 208c0 6.6-5.4 12-12 12H156c-6.6 0-12-5.4-12-12v-96c0-6.6 5.4-12 12-12h200c6.6 0 12 5.4 12 12v96zm0-168c0 6.6-5.4 12-12 12H156c-6.6 0-12-5.4-12-12v-96c0-6.6 5.4-12 12-12h200c6.6 0 12 5.4 12 12v96zm112 152c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40zm0-96c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40zm0-96c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40z"
                }
            }
        ]
    })(props);
}
function FaFilter(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M487.976 0H24.028C2.71 0-8.047 25.866 7.058 40.971L192 225.941V432c0 7.831 3.821 15.17 10.237 19.662l80 55.98C298.02 518.69 320 507.493 320 487.98V225.941l184.947-184.97C520.021 25.896 509.338 0 487.976 0z"
                }
            }
        ]
    })(props);
}
function FaFingerprint(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256.12 245.96c-13.25 0-24 10.74-24 24 1.14 72.25-8.14 141.9-27.7 211.55-2.73 9.72 2.15 30.49 23.12 30.49 10.48 0 20.11-6.92 23.09-17.52 13.53-47.91 31.04-125.41 29.48-224.52.01-13.25-10.73-24-23.99-24zm-.86-81.73C194 164.16 151.25 211.3 152.1 265.32c.75 47.94-3.75 95.91-13.37 142.55-2.69 12.98 5.67 25.69 18.64 28.36 13.05 2.67 25.67-5.66 28.36-18.64 10.34-50.09 15.17-101.58 14.37-153.02-.41-25.95 19.92-52.49 54.45-52.34 31.31.47 57.15 25.34 57.62 55.47.77 48.05-2.81 96.33-10.61 143.55-2.17 13.06 6.69 25.42 19.76 27.58 19.97 3.33 26.81-15.1 27.58-19.77 8.28-50.03 12.06-101.21 11.27-152.11-.88-55.8-47.94-101.88-104.91-102.72zm-110.69-19.78c-10.3-8.34-25.37-6.8-33.76 3.48-25.62 31.5-39.39 71.28-38.75 112 .59 37.58-2.47 75.27-9.11 112.05-2.34 13.05 6.31 25.53 19.36 27.89 20.11 3.5 27.07-14.81 27.89-19.36 7.19-39.84 10.5-80.66 9.86-121.33-.47-29.88 9.2-57.88 28-80.97 8.35-10.28 6.79-25.39-3.49-33.76zm109.47-62.33c-15.41-.41-30.87 1.44-45.78 4.97-12.89 3.06-20.87 15.98-17.83 28.89 3.06 12.89 16 20.83 28.89 17.83 11.05-2.61 22.47-3.77 34-3.69 75.43 1.13 137.73 61.5 138.88 134.58.59 37.88-1.28 76.11-5.58 113.63-1.5 13.17 7.95 25.08 21.11 26.58 16.72 1.95 25.51-11.88 26.58-21.11a929.06 929.06 0 0 0 5.89-119.85c-1.56-98.75-85.07-180.33-186.16-181.83zm252.07 121.45c-2.86-12.92-15.51-21.2-28.61-18.27-12.94 2.86-21.12 15.66-18.26 28.61 4.71 21.41 4.91 37.41 4.7 61.6-.11 13.27 10.55 24.09 23.8 24.2h.2c13.17 0 23.89-10.61 24-23.8.18-22.18.4-44.11-5.83-72.34zm-40.12-90.72C417.29 43.46 337.6 1.29 252.81.02 183.02-.82 118.47 24.91 70.46 72.94 24.09 119.37-.9 181.04.14 246.65l-.12 21.47c-.39 13.25 10.03 24.31 23.28 24.69.23.02.48.02.72.02 12.92 0 23.59-10.3 23.97-23.3l.16-23.64c-.83-52.5 19.16-101.86 56.28-139 38.76-38.8 91.34-59.67 147.68-58.86 69.45 1.03 134.73 35.56 174.62 92.39 7.61 10.86 22.56 13.45 33.42 5.86 10.84-7.62 13.46-22.59 5.84-33.43z"
                }
            }
        ]
    })(props);
}
function FaFireAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M323.56 51.2c-20.8 19.3-39.58 39.59-56.22 59.97C240.08 73.62 206.28 35.53 168 0 69.74 91.17 0 209.96 0 281.6 0 408.85 100.29 512 224 512s224-103.15 224-230.4c0-53.27-51.98-163.14-124.44-230.4zm-19.47 340.65C282.43 407.01 255.72 416 226.86 416 154.71 416 96 368.26 96 290.75c0-38.61 24.31-72.63 72.79-130.75 6.93 7.98 98.83 125.34 98.83 125.34l58.63-66.88c4.14 6.85 7.91 13.55 11.27 19.97 27.35 52.19 15.81 118.97-33.43 153.42z"
                }
            }
        ]
    })(props);
}
function FaFireExtinguisher(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M434.027 26.329l-168 28C254.693 56.218 256 67.8 256 72h-58.332C208.353 36.108 181.446 0 144 0c-39.435 0-66.368 39.676-52.228 76.203-52.039 13.051-75.381 54.213-90.049 90.884-4.923 12.307 1.063 26.274 13.37 31.197 12.317 4.926 26.279-1.075 31.196-13.37C75.058 112.99 106.964 120 168 120v27.076c-41.543 10.862-72 49.235-72 94.129V488c0 13.255 10.745 24 24 24h144c13.255 0 24-10.745 24-24V240c0-44.731-30.596-82.312-72-92.97V120h40c0 2.974-1.703 15.716 10.027 17.671l168 28C441.342 166.89 448 161.25 448 153.834V38.166c0-7.416-6.658-13.056-13.973-11.837zM144 72c-8.822 0-16-7.178-16-16s7.178-16 16-16 16 7.178 16 16-7.178 16-16 16z"
                }
            }
        ]
    })(props);
}
function FaFire(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M216 23.86c0-23.8-30.65-32.77-44.15-13.04C48 191.85 224 200 224 288c0 35.63-29.11 64.46-64.85 63.99-35.17-.45-63.15-29.77-63.15-64.94v-85.51c0-21.7-26.47-32.23-41.43-16.5C27.8 213.16 0 261.33 0 320c0 105.87 86.13 192 192 192s192-86.13 192-192c0-170.29-168-193-168-296.14z"
                }
            }
        ]
    })(props);
}
function FaFirstAid(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 80v352c0 26.5 21.5 48 48 48h48V32H48C21.5 32 0 53.5 0 80zm128 400h320V32H128v448zm64-248c0-4.4 3.6-8 8-8h56v-56c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v56h56c4.4 0 8 3.6 8 8v48c0 4.4-3.6 8-8 8h-56v56c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8v-56h-56c-4.4 0-8-3.6-8-8v-48zM528 32h-48v448h48c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48z"
                }
            }
        ]
    })(props);
}
function FaFish(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M327.1 96c-89.97 0-168.54 54.77-212.27 101.63L27.5 131.58c-12.13-9.18-30.24.6-27.14 14.66L24.54 256 .35 365.77c-3.1 14.06 15.01 23.83 27.14 14.66l87.33-66.05C158.55 361.23 237.13 416 327.1 416 464.56 416 576 288 576 256S464.56 96 327.1 96zm87.43 184c-13.25 0-24-10.75-24-24 0-13.26 10.75-24 24-24 13.26 0 24 10.74 24 24 0 13.25-10.75 24-24 24z"
                }
            }
        ]
    })(props);
}
function FaFistRaised(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M255.98 160V16c0-8.84-7.16-16-16-16h-32c-8.84 0-16 7.16-16 16v146.93c5.02-1.78 10.34-2.93 15.97-2.93h48.03zm128 95.99c-.01-35.34-28.66-63.99-63.99-63.99H207.85c-8.78 0-15.9 7.07-15.9 15.85v.56c0 26.27 21.3 47.59 47.57 47.59h35.26c9.68 0 13.2 3.58 13.2 8v16.2c0 4.29-3.59 7.78-7.88 8-44.52 2.28-64.16 24.71-96.05 72.55l-6.31 9.47a7.994 7.994 0 0 1-11.09 2.22l-13.31-8.88a7.994 7.994 0 0 1-2.22-11.09l6.31-9.47c15.73-23.6 30.2-43.26 47.31-58.08-17.27-5.51-31.4-18.12-38.87-34.45-6.59 3.41-13.96 5.52-21.87 5.52h-32c-12.34 0-23.49-4.81-32-12.48C71.48 251.19 60.33 256 48 256H16c-5.64 0-10.97-1.15-16-2.95v77.93c0 33.95 13.48 66.5 37.49 90.51L63.99 448v64h255.98v-63.96l35.91-35.92A96.035 96.035 0 0 0 384 344.21l-.02-88.22zm-32.01-90.09V48c0-8.84-7.16-16-16-16h-32c-8.84 0-16 7.16-16 16v112h32c11.28 0 21.94 2.31 32 5.9zM16 224h32c8.84 0 16-7.16 16-16V80c0-8.84-7.16-16-16-16H16C7.16 64 0 71.16 0 80v128c0 8.84 7.16 16 16 16zm95.99 0h32c8.84 0 16-7.16 16-16V48c0-8.84-7.16-16-16-16h-32c-8.84 0-16 7.16-16 16v160c0 8.84 7.16 16 16 16z"
                }
            }
        ]
    })(props);
}
function FaFlagCheckered(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M243.2 189.9V258c26.1 5.9 49.3 15.6 73.6 22.3v-68.2c-26-5.8-49.4-15.5-73.6-22.2zm223.3-123c-34.3 15.9-76.5 31.9-117 31.9C296 98.8 251.7 64 184.3 64c-25 0-47.3 4.4-68 12 2.8-7.3 4.1-15.2 3.6-23.6C118.1 24 94.8 1.2 66.3 0 34.3-1.3 8 24.3 8 56c0 19 9.5 35.8 24 45.9V488c0 13.3 10.7 24 24 24h16c13.3 0 24-10.7 24-24v-94.4c28.3-12.1 63.6-22.1 114.4-22.1 53.6 0 97.8 34.8 165.2 34.8 48.2 0 86.7-16.3 122.5-40.9 8.7-6 13.8-15.8 13.8-26.4V95.9c.1-23.3-24.2-38.8-45.4-29zM169.6 325.5c-25.8 2.7-50 8.2-73.6 16.6v-70.5c26.2-9.3 47.5-15 73.6-17.4zM464 191c-23.6 9.8-46.3 19.5-73.6 23.9V286c24.8-3.4 51.4-11.8 73.6-26v70.5c-25.1 16.1-48.5 24.7-73.6 27.1V286c-27 3.7-47.9 1.5-73.6-5.6v67.4c-23.9-7.4-47.3-16.7-73.6-21.3V258c-19.7-4.4-40.8-6.8-73.6-3.8v-70c-22.4 3.1-44.6 10.2-73.6 20.9v-70.5c33.2-12.2 50.1-19.8 73.6-22v71.6c27-3.7 48.4-1.3 73.6 5.7v-67.4c23.7 7.4 47.2 16.7 73.6 21.3v68.4c23.7 5.3 47.6 6.9 73.6 2.7V143c27-4.8 52.3-13.6 73.6-22.5z"
                }
            }
        ]
    })(props);
}
function FaFlagUsa(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M32 0C14.3 0 0 14.3 0 32v464c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V32C64 14.3 49.7 0 32 0zm267.9 303.6c-57.2-15.1-111.7-28.8-203.9 11.1V384c185.7-92.2 221.7 53.3 397.5-23.1 11.4-5 18.5-16.5 18.5-28.8v-36c-43.6 17.3-80.2 24.1-112.1 24.1-37.4-.1-68.9-8.4-100-16.6zm0-96c-57.2-15.1-111.7-28.8-203.9 11.1v61.5c94.8-37.6 154.6-22.7 212.1-7.6 57.2 15.1 111.7 28.8 203.9-11.1V200c-43.6 17.3-80.2 24.1-112.1 24.1-37.4 0-68.9-8.3-100-16.5zm9.5-125.9c51.8 15.6 97.4 29 202.6-20.1V30.8c0-25.1-26.8-38.1-49.4-26.6C291.3 91.5 305.4-62.2 96 32.4v151.9c94.8-37.5 154.6-22.7 212.1-7.6 57.2 15 111.7 28.7 203.9-11.1V96.7c-53.6 23.5-93.3 31.4-126.1 31.4s-59-7.8-85.7-15.9c-4-1.2-8.1-2.4-12.1-3.5V75.5c7.2 2 14.3 4.1 21.3 6.2zM160 128.1c-8.8 0-16-7.1-16-16 0-8.8 7.2-16 16-16s16 7.1 16 16-7.2 16-16 16zm0-55.8c-8.8 0-16-7.1-16-16 0-8.8 7.2-16 16-16s16 7.1 16 16c0 8.8-7.2 16-16 16zm64 47.9c-8.8 0-16-7.1-16-16 0-8.8 7.2-16 16-16s16 7.1 16 16c0 8.8-7.2 16-16 16zm0-55.9c-8.8 0-16-7.1-16-16 0-8.8 7.2-16 16-16s16 7.1 16 16c0 8.8-7.2 16-16 16z"
                }
            }
        ]
    })(props);
}
function FaFlag(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M349.565 98.783C295.978 98.783 251.721 64 184.348 64c-24.955 0-47.309 4.384-68.045 12.013a55.947 55.947 0 0 0 3.586-23.562C118.117 24.015 94.806 1.206 66.338.048 34.345-1.254 8 24.296 8 56c0 19.026 9.497 35.825 24 45.945V488c0 13.255 10.745 24 24 24h16c13.255 0 24-10.745 24-24v-94.4c28.311-12.064 63.582-22.122 114.435-22.122 53.588 0 97.844 34.783 165.217 34.783 48.169 0 86.667-16.294 122.505-40.858C506.84 359.452 512 349.571 512 339.045v-243.1c0-23.393-24.269-38.87-45.485-29.016-34.338 15.948-76.454 31.854-116.95 31.854z"
                }
            }
        ]
    })(props);
}
function FaFlask(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M437.2 403.5L320 215V64h8c13.3 0 24-10.7 24-24V24c0-13.3-10.7-24-24-24H120c-13.3 0-24 10.7-24 24v16c0 13.3 10.7 24 24 24h8v151L10.8 403.5C-18.5 450.6 15.3 512 70.9 512h306.2c55.7 0 89.4-61.5 60.1-108.5zM137.9 320l48.2-77.6c3.7-5.2 5.8-11.6 5.8-18.4V64h64v160c0 6.9 2.2 13.2 5.8 18.4l48.2 77.6h-172z"
                }
            }
        ]
    })(props);
}
function FaFlushed(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M344 200c-13.3 0-24 10.7-24 24s10.7 24 24 24 24-10.7 24-24-10.7-24-24-24zm-192 0c-13.3 0-24 10.7-24 24s10.7 24 24 24 24-10.7 24-24-10.7-24-24-24zM248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zM80 224c0-39.8 32.2-72 72-72s72 32.2 72 72-32.2 72-72 72-72-32.2-72-72zm232 176H184c-21.2 0-21.2-32 0-32h128c21.2 0 21.2 32 0 32zm32-104c-39.8 0-72-32.2-72-72s32.2-72 72-72 72 32.2 72 72-32.2 72-72 72z"
                }
            }
        ]
    })(props);
}
function FaFolderMinus(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M464 128H272l-64-64H48C21.49 64 0 85.49 0 112v288c0 26.51 21.49 48 48 48h416c26.51 0 48-21.49 48-48V176c0-26.51-21.49-48-48-48zm-96 168c0 8.84-7.16 16-16 16H160c-8.84 0-16-7.16-16-16v-16c0-8.84 7.16-16 16-16h192c8.84 0 16 7.16 16 16v16z"
                }
            }
        ]
    })(props);
}
function FaFolderOpen(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M572.694 292.093L500.27 416.248A63.997 63.997 0 0 1 444.989 448H45.025c-18.523 0-30.064-20.093-20.731-36.093l72.424-124.155A64 64 0 0 1 152 256h399.964c18.523 0 30.064 20.093 20.73 36.093zM152 224h328v-48c0-26.51-21.49-48-48-48H272l-64-64H48C21.49 64 0 85.49 0 112v278.046l69.077-118.418C86.214 242.25 117.989 224 152 224z"
                }
            }
        ]
    })(props);
}
function FaFolderPlus(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M464,128H272L208,64H48A48,48,0,0,0,0,112V400a48,48,0,0,0,48,48H464a48,48,0,0,0,48-48V176A48,48,0,0,0,464,128ZM359.5,296a16,16,0,0,1-16,16h-64v64a16,16,0,0,1-16,16h-16a16,16,0,0,1-16-16V312h-64a16,16,0,0,1-16-16V280a16,16,0,0,1,16-16h64V200a16,16,0,0,1,16-16h16a16,16,0,0,1,16,16v64h64a16,16,0,0,1,16,16Z"
                }
            }
        ]
    })(props);
}
function FaFolder(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M464 128H272l-64-64H48C21.49 64 0 85.49 0 112v288c0 26.51 21.49 48 48 48h416c26.51 0 48-21.49 48-48V176c0-26.51-21.49-48-48-48z"
                }
            }
        ]
    })(props);
}
function FaFont(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M432 416h-23.41L277.88 53.69A32 32 0 0 0 247.58 32h-47.16a32 32 0 0 0-30.3 21.69L39.41 416H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h128a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16h-19.58l23.3-64h152.56l23.3 64H304a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h128a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zM176.85 272L224 142.51 271.15 272z"
                }
            }
        ]
    })(props);
}
function FaFootballBall(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M481.5 60.3c-4.8-18.2-19.1-32.5-37.3-37.4C420.3 16.5 383 8.9 339.4 8L496 164.8c-.8-43.5-8.2-80.6-14.5-104.5zm-467 391.4c4.8 18.2 19.1 32.5 37.3 37.4 23.9 6.4 61.2 14 104.8 14.9L0 347.2c.8 43.5 8.2 80.6 14.5 104.5zM4.2 283.4L220.4 500c132.5-19.4 248.8-118.7 271.5-271.4L275.6 12C143.1 31.4 26.8 130.7 4.2 283.4zm317.3-123.6c3.1-3.1 8.2-3.1 11.3 0l11.3 11.3c3.1 3.1 3.1 8.2 0 11.3l-28.3 28.3 28.3 28.3c3.1 3.1 3.1 8.2 0 11.3l-11.3 11.3c-3.1 3.1-8.2 3.1-11.3 0l-28.3-28.3-22.6 22.7 28.3 28.3c3.1 3.1 3.1 8.2 0 11.3l-11.3 11.3c-3.1 3.1-8.2 3.1-11.3 0L248 278.6l-22.6 22.6 28.3 28.3c3.1 3.1 3.1 8.2 0 11.3l-11.3 11.3c-3.1 3.1-8.2 3.1-11.3 0l-28.3-28.3-28.3 28.3c-3.1 3.1-8.2 3.1-11.3 0l-11.3-11.3c-3.1-3.1-3.1-8.2 0-11.3l28.3-28.3-28.3-28.2c-3.1-3.1-3.1-8.2 0-11.3l11.3-11.3c3.1-3.1 8.2-3.1 11.3 0l28.3 28.3 22.6-22.6-28.3-28.3c-3.1-3.1-3.1-8.2 0-11.3l11.3-11.3c3.1-3.1 8.2-3.1 11.3 0l28.3 28.3 22.6-22.6-28.3-28.3c-3.1-3.1-3.1-8.2 0-11.3l11.3-11.3c3.1-3.1 8.2-3.1 11.3 0l28.3 28.3 28.3-28.5z"
                }
            }
        ]
    })(props);
}
function FaForward(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M500.5 231.4l-192-160C287.9 54.3 256 68.6 256 96v320c0 27.4 31.9 41.8 52.5 24.6l192-160c15.3-12.8 15.3-36.4 0-49.2zm-256 0l-192-160C31.9 54.3 0 68.6 0 96v320c0 27.4 31.9 41.8 52.5 24.6l192-160c15.3-12.8 15.3-36.4 0-49.2z"
                }
            }
        ]
    })(props);
}
function FaFrog(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M446.53 97.43C439.67 60.23 407.19 32 368 32c-39.23 0-71.72 28.29-78.54 65.54C126.75 112.96-.5 250.12 0 416.98.11 451.9 29.08 480 64 480h304c8.84 0 16-7.16 16-16 0-17.67-14.33-32-32-32h-79.49l35.8-48.33c24.14-36.23 10.35-88.28-33.71-106.6-23.89-9.93-51.55-4.65-72.24 10.88l-32.76 24.59c-7.06 5.31-17.09 3.91-22.41-3.19-5.3-7.08-3.88-17.11 3.19-22.41l34.78-26.09c36.84-27.66 88.28-27.62 125.13 0 10.87 8.15 45.87 39.06 40.8 93.21L469.62 480H560c8.84 0 16-7.16 16-16 0-17.67-14.33-32-32-32h-53.63l-98.52-104.68 154.44-86.65A58.16 58.16 0 0 0 576 189.94c0-21.4-11.72-40.95-30.48-51.23-40.56-22.22-98.99-41.28-98.99-41.28zM368 136c-13.26 0-24-10.75-24-24 0-13.26 10.74-24 24-24 13.25 0 24 10.74 24 24 0 13.25-10.75 24-24 24z"
                }
            }
        ]
    })(props);
}
function FaFrownOpen(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zM136 208c0-17.7 14.3-32 32-32s32 14.3 32 32-14.3 32-32 32-32-14.3-32-32zm187.3 183.3c-31.2-9.6-59.4-15.3-75.3-15.3s-44.1 5.7-75.3 15.3c-11.5 3.5-22.5-6.3-20.5-18.1 7-40 60.1-61.2 95.8-61.2s88.8 21.3 95.8 61.2c2 11.9-9.1 21.6-20.5 18.1zM328 240c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32z"
                }
            }
        ]
    })(props);
}
function FaFrown(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm80 168c17.7 0 32 14.3 32 32s-14.3 32-32 32-32-14.3-32-32 14.3-32 32-32zm-160 0c17.7 0 32 14.3 32 32s-14.3 32-32 32-32-14.3-32-32 14.3-32 32-32zm170.2 218.2C315.8 367.4 282.9 352 248 352s-67.8 15.4-90.2 42.2c-13.5 16.3-38.1-4.2-24.6-20.5C161.7 339.6 203.6 320 248 320s86.3 19.6 114.7 53.8c13.6 16.2-11 36.7-24.5 20.4z"
                }
            }
        ]
    })(props);
}
function FaFunnelDollar(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M433.46 165.94l101.2-111.87C554.61 34.12 540.48 0 512.26 0H31.74C3.52 0-10.61 34.12 9.34 54.07L192 256v155.92c0 12.59 5.93 24.44 16 32l79.99 60c20.86 15.64 48.47 6.97 59.22-13.57C310.8 455.38 288 406.35 288 352c0-89.79 62.05-165.17 145.46-186.06zM480 192c-88.37 0-160 71.63-160 160s71.63 160 160 160 160-71.63 160-160-71.63-160-160-160zm16 239.88V448c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8v-16.29c-11.29-.58-22.27-4.52-31.37-11.35-3.9-2.93-4.1-8.77-.57-12.14l11.75-11.21c2.77-2.64 6.89-2.76 10.13-.73 3.87 2.42 8.26 3.72 12.82 3.72h28.11c6.5 0 11.8-5.92 11.8-13.19 0-5.95-3.61-11.19-8.77-12.73l-45-13.5c-18.59-5.58-31.58-23.42-31.58-43.39 0-24.52 19.05-44.44 42.67-45.07V256c0-4.42 3.58-8 8-8h16c4.42 0 8 3.58 8 8v16.29c11.29.58 22.27 4.51 31.37 11.35 3.9 2.93 4.1 8.77.57 12.14l-11.75 11.21c-2.77 2.64-6.89 2.76-10.13.73-3.87-2.43-8.26-3.72-12.82-3.72h-28.11c-6.5 0-11.8 5.92-11.8 13.19 0 5.95 3.61 11.19 8.77 12.73l45 13.5c18.59 5.58 31.58 23.42 31.58 43.39 0 24.53-19.04 44.44-42.67 45.07z"
                }
            }
        ]
    })(props);
}
function FaFutbol(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M504 256c0 136.967-111.033 248-248 248S8 392.967 8 256 119.033 8 256 8s248 111.033 248 248zm-48 0l-.003-.282-26.064 22.741-62.679-58.5 16.454-84.355 34.303 3.072c-24.889-34.216-60.004-60.089-100.709-73.141l13.651 31.939L256 139l-74.953-41.525 13.651-31.939c-40.631 13.028-75.78 38.87-100.709 73.141l34.565-3.073 16.192 84.355-62.678 58.5-26.064-22.741-.003.282c0 43.015 13.497 83.952 38.472 117.991l7.704-33.897 85.138 10.447 36.301 77.826-29.902 17.786c40.202 13.122 84.29 13.148 124.572 0l-29.902-17.786 36.301-77.826 85.138-10.447 7.704 33.897C442.503 339.952 456 299.015 456 256zm-248.102 69.571l-29.894-91.312L256 177.732l77.996 56.527-29.622 91.312h-96.476z"
                }
            }
        ]
    })(props);
}
function FaGamepad(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M480.07 96H160a160 160 0 1 0 114.24 272h91.52A160 160 0 1 0 480.07 96zM248 268a12 12 0 0 1-12 12h-52v52a12 12 0 0 1-12 12h-24a12 12 0 0 1-12-12v-52H84a12 12 0 0 1-12-12v-24a12 12 0 0 1 12-12h52v-52a12 12 0 0 1 12-12h24a12 12 0 0 1 12 12v52h52a12 12 0 0 1 12 12zm216 76a40 40 0 1 1 40-40 40 40 0 0 1-40 40zm64-96a40 40 0 1 1 40-40 40 40 0 0 1-40 40z"
                }
            }
        ]
    })(props);
}
function FaGasPump(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M336 448H16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h320c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zm157.2-340.7l-81-81c-6.2-6.2-16.4-6.2-22.6 0l-11.3 11.3c-6.2 6.2-6.2 16.4 0 22.6L416 97.9V160c0 28.1 20.9 51.3 48 55.2V376c0 13.2-10.8 24-24 24s-24-10.8-24-24v-32c0-48.6-39.4-88-88-88h-8V64c0-35.3-28.7-64-64-64H96C60.7 0 32 28.7 32 64v352h288V304h8c22.1 0 40 17.9 40 40v27.8c0 37.7 27 72 64.5 75.9 43 4.3 79.5-29.5 79.5-71.7V152.6c0-17-6.8-33.3-18.8-45.3zM256 192H96V64h160v128z"
                }
            }
        ]
    })(props);
}
function FaGavel(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M504.971 199.362l-22.627-22.627c-9.373-9.373-24.569-9.373-33.941 0l-5.657 5.657L329.608 69.255l5.657-5.657c9.373-9.373 9.373-24.569 0-33.941L312.638 7.029c-9.373-9.373-24.569-9.373-33.941 0L154.246 131.48c-9.373 9.373-9.373 24.569 0 33.941l22.627 22.627c9.373 9.373 24.569 9.373 33.941 0l5.657-5.657 39.598 39.598-81.04 81.04-5.657-5.657c-12.497-12.497-32.758-12.497-45.255 0L9.373 412.118c-12.497 12.497-12.497 32.758 0 45.255l45.255 45.255c12.497 12.497 32.758 12.497 45.255 0l114.745-114.745c12.497-12.497 12.497-32.758 0-45.255l-5.657-5.657 81.04-81.04 39.598 39.598-5.657 5.657c-9.373 9.373-9.373 24.569 0 33.941l22.627 22.627c9.373 9.373 24.569 9.373 33.941 0l124.451-124.451c9.372-9.372 9.372-24.568 0-33.941z"
                }
            }
        ]
    })(props);
}
function FaGem(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M485.5 0L576 160H474.9L405.7 0h79.8zm-128 0l69.2 160H149.3L218.5 0h139zm-267 0h79.8l-69.2 160H0L90.5 0zM0 192h100.7l123 251.7c1.5 3.1-2.7 5.9-5 3.3L0 192zm148.2 0h279.6l-137 318.2c-1 2.4-4.5 2.4-5.5 0L148.2 192zm204.1 251.7l123-251.7H576L357.3 446.9c-2.3 2.7-6.5-.1-5-3.2z"
                }
            }
        ]
    })(props);
}
function FaGenderless(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 288 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M144 176c44.1 0 80 35.9 80 80s-35.9 80-80 80-80-35.9-80-80 35.9-80 80-80m0-64C64.5 112 0 176.5 0 256s64.5 144 144 144 144-64.5 144-144-64.5-144-144-144z"
                }
            }
        ]
    })(props);
}
function FaGhost(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M186.1.09C81.01 3.24 0 94.92 0 200.05v263.92c0 14.26 17.23 21.39 27.31 11.31l24.92-18.53c6.66-4.95 16-3.99 21.51 2.21l42.95 48.35c6.25 6.25 16.38 6.25 22.63 0l40.72-45.85c6.37-7.17 17.56-7.17 23.92 0l40.72 45.85c6.25 6.25 16.38 6.25 22.63 0l42.95-48.35c5.51-6.2 14.85-7.17 21.51-2.21l24.92 18.53c10.08 10.08 27.31 2.94 27.31-11.31V192C384 84 294.83-3.17 186.1.09zM128 224c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm128 0c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32z"
                }
            }
        ]
    })(props);
}
function FaGift(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M32 448c0 17.7 14.3 32 32 32h160V320H32v128zm256 32h160c17.7 0 32-14.3 32-32V320H288v160zm192-320h-42.1c6.2-12.1 10.1-25.5 10.1-40 0-48.5-39.5-88-88-88-41.6 0-68.5 21.3-103 68.3-34.5-47-61.4-68.3-103-68.3-48.5 0-88 39.5-88 88 0 14.5 3.8 27.9 10.1 40H32c-17.7 0-32 14.3-32 32v80c0 8.8 7.2 16 16 16h480c8.8 0 16-7.2 16-16v-80c0-17.7-14.3-32-32-32zm-326.1 0c-22.1 0-40-17.9-40-40s17.9-40 40-40c19.9 0 34.6 3.3 86.1 80h-86.1zm206.1 0h-86.1c51.4-76.5 65.7-80 86.1-80 22.1 0 40 17.9 40 40s-17.9 40-40 40z"
                }
            }
        ]
    })(props);
}
function FaGifts(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M240.6 194.1c1.9-30.8 17.3-61.2 44-79.8C279.4 103.5 268.7 96 256 96h-29.4l30.7-22c7.2-5.1 8.9-15.1 3.7-22.3l-9.3-13c-5.1-7.2-15.1-8.9-22.3-3.7l-32 22.9 11.5-30.6c3.1-8.3-1.1-17.5-9.4-20.6l-15-5.6c-8.3-3.1-17.5 1.1-20.6 9.4l-19.9 53-19.9-53.1C121 2.1 111.8-2.1 103.5 1l-15 5.6C80.2 9.7 76 19 79.2 27.2l11.5 30.6L58.6 35c-7.2-5.1-17.2-3.5-22.3 3.7l-9.3 13c-5.1 7.2-3.5 17.2 3.7 22.3l30.7 22H32c-17.7 0-32 14.3-32 32v352c0 17.7 14.3 32 32 32h168.9c-5.5-9.5-8.9-20.3-8.9-32V256c0-29.9 20.8-55 48.6-61.9zM224 480c0 17.7 14.3 32 32 32h160V384H224v96zm224 32h160c17.7 0 32-14.3 32-32v-96H448v128zm160-288h-20.4c2.6-7.6 4.4-15.5 4.4-23.8 0-35.5-27-72.2-72.1-72.2-48.1 0-75.9 47.7-87.9 75.3-12.1-27.6-39.9-75.3-87.9-75.3-45.1 0-72.1 36.7-72.1 72.2 0 8.3 1.7 16.2 4.4 23.8H256c-17.7 0-32 14.3-32 32v96h192V224h15.3l.7-.2.7.2H448v128h192v-96c0-17.7-14.3-32-32-32zm-272 0c-2.7-1.4-5.1-3-7.2-4.8-7.3-6.4-8.8-13.8-8.8-19 0-9.7 6.4-24.2 24.1-24.2 18.7 0 35.6 27.4 44.5 48H336zm199.2-4.8c-2.1 1.8-4.5 3.4-7.2 4.8h-52.6c8.8-20.3 25.8-48 44.5-48 17.7 0 24.1 14.5 24.1 24.2 0 5.2-1.5 12.6-8.8 19z"
                }
            }
        ]
    })(props);
}
function FaGlassCheers(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M639.4 433.6c-8.4-20.4-31.8-30.1-52.2-21.6l-22.1 9.2-38.7-101.9c47.9-35 64.8-100.3 34.5-152.8L474.3 16c-8-13.9-25.1-19.7-40-13.6L320 49.8 205.7 2.4c-14.9-6.2-32-.3-40 13.6L79.1 166.5C48.9 219 65.7 284.3 113.6 319.2L74.9 421.1l-22.1-9.2c-20.4-8.5-43.7 1.2-52.2 21.6-1.7 4.1.2 8.8 4.3 10.5l162.3 67.4c4.1 1.7 8.7-.2 10.4-4.3 8.4-20.4-1.2-43.8-21.6-52.3l-22.1-9.2L173.3 342c4.4.5 8.8 1.3 13.1 1.3 51.7 0 99.4-33.1 113.4-85.3l20.2-75.4 20.2 75.4c14 52.2 61.7 85.3 113.4 85.3 4.3 0 8.7-.8 13.1-1.3L506 445.6l-22.1 9.2c-20.4 8.5-30.1 31.9-21.6 52.3 1.7 4.1 6.4 6 10.4 4.3L635.1 444c4-1.7 6-6.3 4.3-10.4zM275.9 162.1l-112.1-46.5 36.5-63.4 94.5 39.2-18.9 70.7zm88.2 0l-18.9-70.7 94.5-39.2 36.5 63.4-112.1 46.5z"
                }
            }
        ]
    })(props);
}
function FaGlassMartiniAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M502.05 57.6C523.3 36.34 508.25 0 478.2 0H33.8C3.75 0-11.3 36.34 9.95 57.6L224 271.64V464h-56c-22.09 0-40 17.91-40 40 0 4.42 3.58 8 8 8h240c4.42 0 8-3.58 8-8 0-22.09-17.91-40-40-40h-56V271.64L502.05 57.6zM443.77 48l-48 48H116.24l-48-48h375.53z"
                }
            }
        ]
    })(props);
}
function FaGlassMartini(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M502.05 57.6C523.3 36.34 508.25 0 478.2 0H33.8C3.75 0-11.3 36.34 9.95 57.6L224 271.64V464h-56c-22.09 0-40 17.91-40 40 0 4.42 3.58 8 8 8h240c4.42 0 8-3.58 8-8 0-22.09-17.91-40-40-40h-56V271.64L502.05 57.6z"
                }
            }
        ]
    })(props);
}
function FaGlassWhiskey(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M480 32H32C12.5 32-2.4 49.2.3 68.5l56 356.5c4.5 31.5 31.5 54.9 63.4 54.9h273c31.8 0 58.9-23.4 63.4-54.9l55.6-356.5C514.4 49.2 499.5 32 480 32zm-37.4 64l-30 192h-313L69.4 96h373.2z"
                }
            }
        ]
    })(props);
}
function FaGlasses(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M574.1 280.37L528.75 98.66c-5.91-23.7-21.59-44.05-43-55.81-21.44-11.73-46.97-14.11-70.19-6.33l-15.25 5.08c-8.39 2.79-12.92 11.86-10.12 20.24l5.06 15.18c2.79 8.38 11.85 12.91 20.23 10.12l13.18-4.39c10.87-3.62 23-3.57 33.16 1.73 10.29 5.37 17.57 14.56 20.37 25.82l38.46 153.82c-22.19-6.81-49.79-12.46-81.2-12.46-34.77 0-73.98 7.02-114.85 26.74h-73.18c-40.87-19.74-80.08-26.75-114.86-26.75-31.42 0-59.02 5.65-81.21 12.46l38.46-153.83c2.79-11.25 10.09-20.45 20.38-25.81 10.16-5.3 22.28-5.35 33.15-1.73l13.17 4.39c8.38 2.79 17.44-1.74 20.23-10.12l5.06-15.18c2.8-8.38-1.73-17.45-10.12-20.24l-15.25-5.08c-23.22-7.78-48.75-5.41-70.19 6.33-21.41 11.77-37.09 32.11-43 55.8L1.9 280.37A64.218 64.218 0 0 0 0 295.86v70.25C0 429.01 51.58 480 115.2 480h37.12c60.28 0 110.37-45.94 114.88-105.37l2.93-38.63h35.75l2.93 38.63C313.31 434.06 363.4 480 423.68 480h37.12c63.62 0 115.2-50.99 115.2-113.88v-70.25c0-5.23-.64-10.43-1.9-15.5zm-370.72 89.42c-1.97 25.91-24.4 46.21-51.06 46.21H115.2C86.97 416 64 393.62 64 366.11v-37.54c18.12-6.49 43.42-12.92 72.58-12.92 23.86 0 47.26 4.33 69.93 12.92l-3.13 41.22zM512 366.12c0 27.51-22.97 49.88-51.2 49.88h-37.12c-26.67 0-49.1-20.3-51.06-46.21l-3.13-41.22c22.67-8.59 46.08-12.92 69.95-12.92 29.12 0 54.43 6.44 72.55 12.93v37.54z"
                }
            }
        ]
    })(props);
}
function FaGlobeAfrica(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111.03 8 0 119.03 0 256s111.03 248 248 248 248-111.03 248-248S384.97 8 248 8zm160 215.5v6.93c0 5.87-3.32 11.24-8.57 13.86l-15.39 7.7a15.485 15.485 0 0 1-15.53-.97l-18.21-12.14a15.52 15.52 0 0 0-13.5-1.81l-2.65.88c-9.7 3.23-13.66 14.79-7.99 23.3l13.24 19.86c2.87 4.31 7.71 6.9 12.89 6.9h8.21c8.56 0 15.5 6.94 15.5 15.5v11.34c0 3.35-1.09 6.62-3.1 9.3l-18.74 24.98c-1.42 1.9-2.39 4.1-2.83 6.43l-4.3 22.83c-.62 3.29-2.29 6.29-4.76 8.56a159.608 159.608 0 0 0-25 29.16l-13.03 19.55a27.756 27.756 0 0 1-23.09 12.36c-10.51 0-20.12-5.94-24.82-15.34a78.902 78.902 0 0 1-8.33-35.29V367.5c0-8.56-6.94-15.5-15.5-15.5h-25.88c-14.49 0-28.38-5.76-38.63-16a54.659 54.659 0 0 1-16-38.63v-14.06c0-17.19 8.1-33.38 21.85-43.7l27.58-20.69a54.663 54.663 0 0 1 32.78-10.93h.89c8.48 0 16.85 1.97 24.43 5.77l14.72 7.36c3.68 1.84 7.93 2.14 11.83.84l47.31-15.77c6.33-2.11 10.6-8.03 10.6-14.7 0-8.56-6.94-15.5-15.5-15.5h-10.09c-4.11 0-8.05-1.63-10.96-4.54l-6.92-6.92a15.493 15.493 0 0 0-10.96-4.54H199.5c-8.56 0-15.5-6.94-15.5-15.5v-4.4c0-7.11 4.84-13.31 11.74-15.04l14.45-3.61c3.74-.94 7-3.23 9.14-6.44l8.08-12.11c2.87-4.31 7.71-6.9 12.89-6.9h24.21c8.56 0 15.5-6.94 15.5-15.5v-21.7C359.23 71.63 422.86 131.02 441.93 208H423.5c-8.56 0-15.5 6.94-15.5 15.5z"
                }
            }
        ]
    })(props);
}
function FaGlobeAmericas(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111.03 8 0 119.03 0 256s111.03 248 248 248 248-111.03 248-248S384.97 8 248 8zm82.29 357.6c-3.9 3.88-7.99 7.95-11.31 11.28-2.99 3-5.1 6.7-6.17 10.71-1.51 5.66-2.73 11.38-4.77 16.87l-17.39 46.85c-13.76 3-28 4.69-42.65 4.69v-27.38c1.69-12.62-7.64-36.26-22.63-51.25-6-6-9.37-14.14-9.37-22.63v-32.01c0-11.64-6.27-22.34-16.46-27.97-14.37-7.95-34.81-19.06-48.81-26.11-11.48-5.78-22.1-13.14-31.65-21.75l-.8-.72a114.792 114.792 0 0 1-18.06-20.74c-9.38-13.77-24.66-36.42-34.59-51.14 20.47-45.5 57.36-82.04 103.2-101.89l24.01 12.01C203.48 89.74 216 82.01 216 70.11v-11.3c7.99-1.29 16.12-2.11 24.39-2.42l28.3 28.3c6.25 6.25 6.25 16.38 0 22.63L264 112l-10.34 10.34c-3.12 3.12-3.12 8.19 0 11.31l4.69 4.69c3.12 3.12 3.12 8.19 0 11.31l-8 8a8.008 8.008 0 0 1-5.66 2.34h-8.99c-2.08 0-4.08.81-5.58 2.27l-9.92 9.65a8.008 8.008 0 0 0-1.58 9.31l15.59 31.19c2.66 5.32-1.21 11.58-7.15 11.58h-5.64c-1.93 0-3.79-.7-5.24-1.96l-9.28-8.06a16.017 16.017 0 0 0-15.55-3.1l-31.17 10.39a11.95 11.95 0 0 0-8.17 11.34c0 4.53 2.56 8.66 6.61 10.69l11.08 5.54c9.41 4.71 19.79 7.16 30.31 7.16s22.59 27.29 32 32h66.75c8.49 0 16.62 3.37 22.63 9.37l13.69 13.69a30.503 30.503 0 0 1 8.93 21.57 46.536 46.536 0 0 1-13.72 32.98zM417 274.25c-5.79-1.45-10.84-5-14.15-9.97l-17.98-26.97a23.97 23.97 0 0 1 0-26.62l19.59-29.38c2.32-3.47 5.5-6.29 9.24-8.15l12.98-6.49C440.2 193.59 448 223.87 448 256c0 8.67-.74 17.16-1.82 25.54L417 274.25z"
                }
            }
        ]
    })(props);
}
function FaGlobeAsia(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111.03 8 0 119.03 0 256s111.03 248 248 248 248-111.03 248-248S384.97 8 248 8zm-11.34 240.23c-2.89 4.82-8.1 7.77-13.72 7.77h-.31c-4.24 0-8.31 1.69-11.31 4.69l-5.66 5.66c-3.12 3.12-3.12 8.19 0 11.31l5.66 5.66c3 3 4.69 7.07 4.69 11.31V304c0 8.84-7.16 16-16 16h-6.11c-6.06 0-11.6-3.42-14.31-8.85l-22.62-45.23c-2.44-4.88-8.95-5.94-12.81-2.08l-19.47 19.46c-3 3-7.07 4.69-11.31 4.69H50.81C49.12 277.55 48 266.92 48 256c0-110.28 89.72-200 200-200 21.51 0 42.2 3.51 61.63 9.82l-50.16 38.53c-5.11 3.41-4.63 11.06.86 13.81l10.83 5.41c5.42 2.71 8.84 8.25 8.84 14.31V216c0 4.42-3.58 8-8 8h-3.06c-3.03 0-5.8-1.71-7.15-4.42-1.56-3.12-5.96-3.29-7.76-.3l-17.37 28.95zM408 358.43c0 4.24-1.69 8.31-4.69 11.31l-9.57 9.57c-3 3-7.07 4.69-11.31 4.69h-15.16c-4.24 0-8.31-1.69-11.31-4.69l-13.01-13.01a26.767 26.767 0 0 0-25.42-7.04l-21.27 5.32c-1.27.32-2.57.48-3.88.48h-10.34c-4.24 0-8.31-1.69-11.31-4.69l-11.91-11.91a8.008 8.008 0 0 1-2.34-5.66v-10.2c0-3.27 1.99-6.21 5.03-7.43l39.34-15.74c1.98-.79 3.86-1.82 5.59-3.05l23.71-16.89a7.978 7.978 0 0 1 4.64-1.48h12.09c3.23 0 6.15 1.94 7.39 4.93l5.35 12.85a4 4 0 0 0 3.69 2.46h3.8c1.78 0 3.35-1.18 3.84-2.88l4.2-14.47c.5-1.71 2.06-2.88 3.84-2.88h6.06c2.21 0 4 1.79 4 4v12.93c0 2.12.84 4.16 2.34 5.66l11.91 11.91c3 3 4.69 7.07 4.69 11.31v24.6z"
                }
            }
        ]
    })(props);
}
function FaGlobeEurope(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm200 248c0 22.5-3.9 44.2-10.8 64.4h-20.3c-4.3 0-8.4-1.7-11.4-4.8l-32-32.6c-4.5-4.6-4.5-12.1.1-16.7l12.5-12.5v-8.7c0-3-1.2-5.9-3.3-8l-9.4-9.4c-2.1-2.1-5-3.3-8-3.3h-16c-6.2 0-11.3-5.1-11.3-11.3 0-3 1.2-5.9 3.3-8l9.4-9.4c2.1-2.1 5-3.3 8-3.3h32c6.2 0 11.3-5.1 11.3-11.3v-9.4c0-6.2-5.1-11.3-11.3-11.3h-36.7c-8.8 0-16 7.2-16 16v4.5c0 6.9-4.4 13-10.9 15.2l-31.6 10.5c-3.3 1.1-5.5 4.1-5.5 7.6v2.2c0 4.4-3.6 8-8 8h-16c-4.4 0-8-3.6-8-8s-3.6-8-8-8H247c-3 0-5.8 1.7-7.2 4.4l-9.4 18.7c-2.7 5.4-8.2 8.8-14.3 8.8H194c-8.8 0-16-7.2-16-16V199c0-4.2 1.7-8.3 4.7-11.3l20.1-20.1c4.6-4.6 7.2-10.9 7.2-17.5 0-3.4 2.2-6.5 5.5-7.6l40-13.3c1.7-.6 3.2-1.5 4.4-2.7l26.8-26.8c2.1-2.1 3.3-5 3.3-8 0-6.2-5.1-11.3-11.3-11.3H258l-16 16v8c0 4.4-3.6 8-8 8h-16c-4.4 0-8-3.6-8-8v-20c0-2.5 1.2-4.9 3.2-6.4l28.9-21.7c1.9-.1 3.8-.3 5.7-.3C358.3 56 448 145.7 448 256zM130.1 149.1c0-3 1.2-5.9 3.3-8l25.4-25.4c2.1-2.1 5-3.3 8-3.3 6.2 0 11.3 5.1 11.3 11.3v16c0 3-1.2 5.9-3.3 8l-9.4 9.4c-2.1 2.1-5 3.3-8 3.3h-16c-6.2 0-11.3-5.1-11.3-11.3zm128 306.4v-7.1c0-8.8-7.2-16-16-16h-20.2c-10.8 0-26.7-5.3-35.4-11.8l-22.2-16.7c-11.5-8.6-18.2-22.1-18.2-36.4v-23.9c0-16 8.4-30.8 22.1-39l42.9-25.7c7.1-4.2 15.2-6.5 23.4-6.5h31.2c10.9 0 21.4 3.9 29.6 10.9l43.2 37.1h18.3c8.5 0 16.6 3.4 22.6 9.4l17.3 17.3c3.4 3.4 8.1 5.3 12.9 5.3H423c-32.4 58.9-93.8 99.5-164.9 103.1z"
                }
            }
        ]
    })(props);
}
function FaGlobe(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M336.5 160C322 70.7 287.8 8 248 8s-74 62.7-88.5 152h177zM152 256c0 22.2 1.2 43.5 3.3 64h185.3c2.1-20.5 3.3-41.8 3.3-64s-1.2-43.5-3.3-64H155.3c-2.1 20.5-3.3 41.8-3.3 64zm324.7-96c-28.6-67.9-86.5-120.4-158-141.6 24.4 33.8 41.2 84.7 50 141.6h108zM177.2 18.4C105.8 39.6 47.8 92.1 19.3 160h108c8.7-56.9 25.5-107.8 49.9-141.6zM487.4 192H372.7c2.1 21 3.3 42.5 3.3 64s-1.2 43-3.3 64h114.6c5.5-20.5 8.6-41.8 8.6-64s-3.1-43.5-8.5-64zM120 256c0-21.5 1.2-43 3.3-64H8.6C3.2 212.5 0 233.8 0 256s3.2 43.5 8.6 64h114.6c-2-21-3.2-42.5-3.2-64zm39.5 96c14.5 89.3 48.7 152 88.5 152s74-62.7 88.5-152h-177zm159.3 141.6c71.4-21.2 129.4-73.7 158-141.6h-108c-8.8 56.9-25.6 107.8-50 141.6zM19.3 352c28.6 67.9 86.5 120.4 158 141.6-24.4-33.8-41.2-84.7-50-141.6h-108z"
                }
            }
        ]
    })(props);
}
function FaGolfBall(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 416 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M96 416h224c0 17.7-14.3 32-32 32h-16c-17.7 0-32 14.3-32 32v20c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-20c0-17.7-14.3-32-32-32h-16c-17.7 0-32-14.3-32-32zm320-208c0 74.2-39 139.2-97.5 176h-221C39 347.2 0 282.2 0 208 0 93.1 93.1 0 208 0s208 93.1 208 208zm-180.1 43.9c18.3 0 33.1-14.8 33.1-33.1 0-14.4-9.3-26.3-22.1-30.9 9.6 26.8-15.6 51.3-41.9 41.9 4.6 12.8 16.5 22.1 30.9 22.1zm49.1 46.9c0-14.4-9.3-26.3-22.1-30.9 9.6 26.8-15.6 51.3-41.9 41.9 4.6 12.8 16.5 22.1 30.9 22.1 18.3 0 33.1-14.9 33.1-33.1zm64-64c0-14.4-9.3-26.3-22.1-30.9 9.6 26.8-15.6 51.3-41.9 41.9 4.6 12.8 16.5 22.1 30.9 22.1 18.3 0 33.1-14.9 33.1-33.1z"
                }
            }
        ]
    })(props);
}
function FaGopuram(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M496 352h-16V240c0-8.8-7.2-16-16-16h-16v-80c0-8.8-7.2-16-16-16h-16V16c0-8.8-7.2-16-16-16s-16 7.2-16 16v16h-64V16c0-8.8-7.2-16-16-16s-16 7.2-16 16v16h-64V16c0-8.8-7.2-16-16-16s-16 7.2-16 16v16h-64V16c0-8.8-7.2-16-16-16S96 7.2 96 16v112H80c-8.8 0-16 7.2-16 16v80H48c-8.8 0-16 7.2-16 16v112H16c-8.8 0-16 7.2-16 16v128c0 8.8 7.2 16 16 16h80V352h32V224h32v-96h32v96h-32v128h-32v160h80v-80c0-8.8 7.2-16 16-16h64c8.8 0 16 7.2 16 16v80h80V352h-32V224h-32v-96h32v96h32v128h32v160h80c8.8 0 16-7.2 16-16V368c0-8.8-7.2-16-16-16zM232 176c0-8.8 7.2-16 16-16h16c8.8 0 16 7.2 16 16v48h-48zm56 176h-64v-64c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16z"
                }
            }
        ]
    })(props);
}
function FaGraduationCap(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M622.34 153.2L343.4 67.5c-15.2-4.67-31.6-4.67-46.79 0L17.66 153.2c-23.54 7.23-23.54 38.36 0 45.59l48.63 14.94c-10.67 13.19-17.23 29.28-17.88 46.9C38.78 266.15 32 276.11 32 288c0 10.78 5.68 19.85 13.86 25.65L20.33 428.53C18.11 438.52 25.71 448 35.94 448h56.11c10.24 0 17.84-9.48 15.62-19.47L82.14 313.65C90.32 307.85 96 298.78 96 288c0-11.57-6.47-21.25-15.66-26.87.76-15.02 8.44-28.3 20.69-36.72L296.6 284.5c9.06 2.78 26.44 6.25 46.79 0l278.95-85.7c23.55-7.24 23.55-38.36 0-45.6zM352.79 315.09c-28.53 8.76-52.84 3.92-65.59 0l-145.02-44.55L128 384c0 35.35 85.96 64 192 64s192-28.65 192-64l-14.18-113.47-145.03 44.56z"
                }
            }
        ]
    })(props);
}
function FaGreaterThanEqual(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M55.22 107.69l175.56 68.09-175.44 68.05c-18.39 6.03-27.88 24.39-21.2 41l12.09 30.08c6.68 16.61 26.99 25.19 45.38 19.15L393.02 214.2c13.77-4.52 22.98-16.61 22.98-30.17v-15.96c0-13.56-9.21-25.65-22.98-30.17L91.3 17.92c-18.29-6-38.51 2.53-45.15 19.06L34.12 66.9c-6.64 16.53 2.81 34.79 21.1 40.79zM424 400H24c-13.25 0-24 10.74-24 24v48c0 13.25 10.75 24 24 24h400c13.25 0 24-10.75 24-24v-48c0-13.26-10.75-24-24-24z"
                }
            }
        ]
    })(props);
}
function FaGreaterThan(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M365.52 209.85L59.22 67.01c-16.06-7.49-35.15-.54-42.64 15.52L3.01 111.61c-7.49 16.06-.54 35.15 15.52 42.64L236.96 256.1 18.49 357.99C2.47 365.46-4.46 384.5 3.01 400.52l13.52 29C24 445.54 43.04 452.47 59.06 445l306.47-142.91a32.003 32.003 0 0 0 18.48-29v-34.23c-.01-12.45-7.21-23.76-18.49-29.01z"
                }
            }
        ]
    })(props);
}
function FaGrimace(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zM144 400h-8c-17.7 0-32-14.3-32-32v-8h40v40zm0-56h-40v-8c0-17.7 14.3-32 32-32h8v40zm-8-136c0-17.7 14.3-32 32-32s32 14.3 32 32-14.3 32-32 32-32-14.3-32-32zm72 192h-48v-40h48v40zm0-56h-48v-40h48v40zm64 56h-48v-40h48v40zm0-56h-48v-40h48v40zm64 56h-48v-40h48v40zm0-56h-48v-40h48v40zm-8-104c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm64 128c0 17.7-14.3 32-32 32h-8v-40h40v8zm0-24h-40v-40h8c17.7 0 32 14.3 32 32v8z"
                }
            }
        ]
    })(props);
}
function FaGrinAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm63.7 128.7c7.6-11.4 24.7-11.7 32.7 0 12.4 18.4 15.1 36.9 15.7 55.3-.5 18.4-3.3 36.9-15.7 55.3-7.6 11.4-24.7 11.7-32.7 0-12.4-18.4-15.1-36.9-15.7-55.3.5-18.4 3.3-36.9 15.7-55.3zm-160 0c7.6-11.4 24.7-11.7 32.7 0 12.4 18.4 15.1 36.9 15.7 55.3-.5 18.4-3.3 36.9-15.7 55.3-7.6 11.4-24.7 11.7-32.7 0-12.4-18.4-15.1-36.9-15.7-55.3.5-18.4 3.3-36.9 15.7-55.3zM248 432c-60.6 0-134.5-38.3-143.8-93.3-2-11.8 9.3-21.6 20.7-17.9C155.1 330.5 200 336 248 336s92.9-5.5 123.1-15.2c11.4-3.7 22.6 6.1 20.7 17.9-9.3 55-83.2 93.3-143.8 93.3z"
                }
            }
        ]
    })(props);
}
function FaGrinBeamSweat(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 504 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M456 128c26.5 0 48-21 48-47 0-20-28.5-60.4-41.6-77.8-3.2-4.3-9.6-4.3-12.8 0C436.5 20.6 408 61 408 81c0 26 21.5 47 48 47zm0 32c-44.1 0-80-35.4-80-79 0-4.4.3-14.2 8.1-32.2C345 23.1 298.3 8 248 8 111 8 0 119 0 256s111 248 248 248 248-111 248-248c0-35.1-7.4-68.4-20.5-98.6-6.3 1.5-12.7 2.6-19.5 2.6zm-128-8c23.8 0 52.7 29.3 56 71.4.7 8.6-10.8 12-14.9 4.5l-9.5-17c-7.7-13.7-19.2-21.6-31.5-21.6s-23.8 7.9-31.5 21.6l-9.5 17c-4.1 7.4-15.6 4-14.9-4.5 3.1-42.1 32-71.4 55.8-71.4zm-160 0c23.8 0 52.7 29.3 56 71.4.7 8.6-10.8 12-14.9 4.5l-9.5-17c-7.7-13.7-19.2-21.6-31.5-21.6s-23.8 7.9-31.5 21.6l-9.5 17c-4.2 7.4-15.6 4-14.9-4.5 3.1-42.1 32-71.4 55.8-71.4zm80 280c-60.6 0-134.5-38.3-143.8-93.3-2-11.8 9.3-21.6 20.7-17.9C155.1 330.5 200 336 248 336s92.9-5.5 123.1-15.2c11.5-3.7 22.6 6.2 20.7 17.9-9.3 55-83.2 93.3-143.8 93.3z"
                }
            }
        ]
    })(props);
}
function FaGrinBeam(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm80 144c23.8 0 52.7 29.3 56 71.4.7 8.6-10.8 11.9-14.9 4.5l-9.5-17c-7.7-13.7-19.2-21.6-31.5-21.6s-23.8 7.9-31.5 21.6l-9.5 17c-4.1 7.3-15.6 4-14.9-4.5 3.1-42.1 32-71.4 55.8-71.4zm-160 0c23.8 0 52.7 29.3 56 71.4.7 8.6-10.8 11.9-14.9 4.5l-9.5-17c-7.7-13.7-19.2-21.6-31.5-21.6s-23.8 7.9-31.5 21.6l-9.5 17c-4.2 7.4-15.6 4-14.9-4.5 3.1-42.1 32-71.4 55.8-71.4zm80 280c-60.6 0-134.5-38.3-143.8-93.3-2-11.9 9.4-21.6 20.7-17.9C155.1 330.5 200 336 248 336s92.9-5.5 123.1-15.2c11.4-3.7 22.6 6.1 20.7 17.9-9.3 55-83.2 93.3-143.8 93.3z"
                }
            }
        ]
    })(props);
}
function FaGrinHearts(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zM90.4 183.6c6.7-17.6 26.7-26.7 44.9-21.9l7.1 1.9 2-7.1c5-18.1 22.8-30.9 41.5-27.9 21.4 3.4 34.4 24.2 28.8 44.5L195.3 243c-1.2 4.5-5.9 7.2-10.5 6l-70.2-18.2c-20.4-5.4-31.9-27-24.2-47.2zM248 432c-60.6 0-134.5-38.3-143.8-93.3-2-11.8 9.2-21.5 20.7-17.9C155.1 330.5 200 336 248 336s92.9-5.5 123.1-15.2c11.4-3.6 22.6 6.1 20.7 17.9-9.3 55-83.2 93.3-143.8 93.3zm133.4-201.3l-70.2 18.2c-4.5 1.2-9.2-1.5-10.5-6L281.3 173c-5.6-20.3 7.4-41.1 28.8-44.5 18.6-3 36.4 9.8 41.5 27.9l2 7.1 7.1-1.9c18.2-4.7 38.2 4.3 44.9 21.9 7.7 20.3-3.8 41.9-24.2 47.2z"
                }
            }
        ]
    })(props);
}
function FaGrinSquintTears(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M409.6 111.9c22.6-3.2 73.5-12 88.3-26.8 19.2-19.2 18.9-50.6-.7-70.2S446-5 426.9 14.2c-14.8 14.8-23.5 65.7-26.8 88.3-.8 5.5 3.9 10.2 9.5 9.4zM102.4 400.1c-22.6 3.2-73.5 12-88.3 26.8-19.1 19.1-18.8 50.6.8 70.2s51 19.9 70.2.7c14.8-14.8 23.5-65.7 26.8-88.3.8-5.5-3.9-10.2-9.5-9.4zm311.7-256.5c-33 3.9-48.6-25.1-45.7-45.7 3.4-24 7.4-42.1 11.5-56.5C285.1-13.4 161.8-.5 80.6 80.6-.5 161.7-13.4 285 41.4 379.9c14.4-4.1 32.4-8 56.5-11.5 33.2-3.9 48.6 25.2 45.7 45.7-3.4 24-7.4 42.1-11.5 56.5 94.8 54.8 218.1 41.9 299.3-39.2s94-204.4 39.2-299.3c-14.4 4.1-32.5 8-56.5 11.5zM255.7 106c3.3-13.2 22.4-11.5 23.6 1.8l4.8 52.3 52.3 4.8c13.4 1.2 14.9 20.3 1.8 23.6l-90.5 22.6c-8.9 2.2-16.7-5.9-14.5-14.5l22.5-90.6zm-90.9 230.3L160 284l-52.3-4.8c-13.4-1.2-14.9-20.3-1.8-23.6l90.5-22.6c8.8-2.2 16.7 5.8 14.5 14.5L188.3 338c-3.1 13.2-22.2 11.7-23.5-1.7zm215.7 44.2c-29.3 29.3-75.7 50.4-116.7 50.4-18.9 0-36.6-4.5-51-14.7-9.8-6.9-8.7-21.8 2-27.2 28.3-14.6 63.9-42.4 97.8-76.3s61.7-69.6 76.3-97.8c5.4-10.5 20.2-11.9 27.3-2 32.3 45.3 7.1 124.7-35.7 167.6z"
                }
            }
        ]
    })(props);
}
function FaGrinSquint(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm33.8 189.7l80-48c11.6-6.9 24 7.7 15.4 18L343.6 208l33.6 40.3c8.7 10.4-3.9 24.8-15.4 18l-80-48c-7.7-4.7-7.7-15.9 0-20.6zm-163-30c-8.6-10.3 3.8-24.9 15.4-18l80 48c7.8 4.7 7.8 15.9 0 20.6l-80 48c-11.5 6.8-24-7.6-15.4-18l33.6-40.3-33.6-40.3zM248 432c-60.6 0-134.5-38.3-143.8-93.3-2-11.9 9.4-21.6 20.7-17.9C155.1 330.5 200 336 248 336s92.9-5.5 123.1-15.2c11.5-3.7 22.6 6.2 20.7 17.9-9.3 55-83.2 93.3-143.8 93.3z"
                }
            }
        ]
    })(props);
}
function FaGrinStars(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zM94.6 168.9l34.9-5 15.5-31.6c2.9-5.8 11-5.8 13.9 0l15.5 31.6 34.9 5c6.2 1 8.9 8.6 4.3 13.2l-25.4 24.6 6 34.9c1 6.2-5.3 11-11 7.9L152 233.3l-31.3 16.3c-5.7 3.1-12-1.7-11-7.9l6-34.9-25.4-24.6c-4.6-4.7-1.9-12.3 4.3-13.3zM248 432c-60.6 0-134.5-38.3-143.8-93.3-2-11.8 9.3-21.5 20.7-17.9C155.1 330.5 200 336 248 336s92.9-5.5 123.1-15.2c11.5-3.7 22.6 6.1 20.7 17.9-9.3 55-83.2 93.3-143.8 93.3zm157.7-249.9l-25.4 24.6 6 34.9c1 6.2-5.3 11-11 7.9L344 233.3l-31.3 16.3c-5.7 3.1-12-1.7-11-7.9l6-34.9-25.4-24.6c-4.5-4.6-1.9-12.2 4.3-13.2l34.9-5 15.5-31.6c2.9-5.8 11-5.8 13.9 0l15.5 31.6 34.9 5c6.3.9 9 8.5 4.4 13.1z"
                }
            }
        ]
    })(props);
}
function FaGrinTears(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M102.4 256.1c-22.6 3.2-73.5 12-88.3 26.8-19.1 19.1-18.8 50.6.8 70.2s51 19.9 70.2.7c14.8-14.8 23.5-65.7 26.8-88.3.8-5.5-3.9-10.2-9.5-9.4zm523.4 26.8c-14.8-14.8-65.7-23.5-88.3-26.8-5.5-.8-10.3 3.9-9.5 9.5 3.2 22.6 12 73.5 26.8 88.3 19.2 19.2 50.6 18.9 70.2-.7s20-51.2.8-70.3zm-129.4-12.8c-3.8-26.6 19.1-49.5 45.7-45.7 8.9 1.3 16.8 2.7 24.3 4.1C552.7 104.5 447.7 8 320 8S87.3 104.5 73.6 228.5c7.5-1.4 15.4-2.8 24.3-4.1 33.2-3.9 48.6 25.3 45.7 45.7-11.8 82.3-29.9 100.4-35.8 106.4-.9.9-2 1.6-3 2.5 42.7 74.6 123 125 215.2 125s172.5-50.4 215.2-125.1c-1-.9-2.1-1.5-3-2.5-5.9-5.9-24-24-35.8-106.3zM400 152c23.8 0 52.7 29.3 56 71.4.7 8.6-10.8 12-14.9 4.5l-9.5-17c-7.7-13.7-19.2-21.6-31.5-21.6s-23.8 7.9-31.5 21.6l-9.5 17c-4.2 7.4-15.6 4-14.9-4.5 3.1-42.1 32-71.4 55.8-71.4zm-160 0c23.8 0 52.7 29.3 56 71.4.7 8.6-10.8 12-14.9 4.5l-9.5-17c-7.7-13.7-19.2-21.6-31.5-21.6s-23.8 7.9-31.5 21.6l-9.5 17c-4.2 7.4-15.6 4-14.9-4.5 3.1-42.1 32-71.4 55.8-71.4zm80 280c-60.6 0-134.5-38.3-143.8-93.3-2-11.7 9.2-21.6 20.7-17.9C227.1 330.5 272 336 320 336s92.9-5.5 123.1-15.2c11.4-3.7 22.6 6.1 20.7 17.9-9.3 55-83.2 93.3-143.8 93.3z"
                }
            }
        ]
    })(props);
}
function FaGrinTongueSquint(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M293.1 374.6c-14.4-6.5-31.1 2.2-34.6 17.6l-1.8 7.8c-2.1 9.2-15.2 9.2-17.3 0l-1.8-7.8c-3.5-15.4-20.2-24.1-34.6-17.6-.9.4.3-.2-18.9 9.4v63c0 35.2 28 64.5 63.1 64.9 35.7.5 64.9-28.4 64.9-64v-64c-19.5-9.6-18.2-8.9-19-9.3zM248 8C111 8 0 119 0 256c0 106.3 67 196.7 161 232-5.6-12.2-9-25.7-9-40v-45.5c-24.7-16.2-43.5-38.1-47.8-63.8-2-11.8 9.2-21.5 20.7-17.9C155.1 330.5 200 336 248 336s92.9-5.5 123.1-15.2c11.4-3.7 22.6 6.1 20.7 17.9-4.3 25.7-23.1 47.6-47.8 63.8V448c0 14.3-3.4 27.8-9 40 94-35.3 161-125.7 161-232C496 119 385 8 248 8zm-33.8 210.3l-80 48c-11.5 6.8-24-7.6-15.4-18l33.6-40.3-33.6-40.3c-8.6-10.3 3.8-24.9 15.4-18l80 48c7.7 4.7 7.7 15.9 0 20.6zm163 30c8.7 10.4-3.9 24.8-15.4 18l-80-48c-7.8-4.7-7.8-15.9 0-20.6l80-48c11.7-6.9 23.9 7.7 15.4 18L343.6 208l33.6 40.3z"
                }
            }
        ]
    })(props);
}
function FaGrinTongueWink(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M344 184c-13.3 0-24 10.7-24 24s10.7 24 24 24 24-10.7 24-24-10.7-24-24-24zM248 8C111 8 0 119 0 256c0 106.3 67 196.7 161 232-5.6-12.2-9-25.7-9-40v-45.5c-24.7-16.2-43.5-38.1-47.8-63.8-2-11.8 9.3-21.5 20.7-17.9C155.1 330.5 200 336 248 336s92.9-5.5 123.1-15.2c11.5-3.7 22.6 6.1 20.7 17.9-4.3 25.7-23.1 47.6-47.8 63.8V448c0 14.3-3.4 27.8-9 40 94-35.3 161-125.7 161-232C496 119 385 8 248 8zm-56 225l-9.5-8.5c-14.8-13.2-46.2-13.2-61 0L112 233c-8.5 7.4-21.6.3-19.8-10.8 4-25.2 34.2-42.1 59.9-42.1S208 197 212 222.2c1.6 11.1-11.6 18.2-20 10.8zm152 39c-35.3 0-64-28.7-64-64s28.7-64 64-64 64 28.7 64 64-28.7 64-64 64zm-50.9 102.6c-14.4-6.5-31.1 2.2-34.6 17.6l-1.8 7.8c-2.1 9.2-15.2 9.2-17.3 0l-1.8-7.8c-3.5-15.4-20.2-24.1-34.6-17.6-.9.4.3-.2-18.9 9.4v63c0 35.2 28 64.5 63.1 64.9 35.7.5 64.9-28.4 64.9-64v-64c-19.5-9.6-18.2-8.9-19-9.3z"
                }
            }
        ]
    })(props);
}
function FaGrinTongue(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111 8 0 119 0 256c0 106.3 67 196.7 161 232-5.6-12.2-9-25.7-9-40v-45.5c-24.7-16.2-43.5-38.1-47.8-63.8-2-11.8 9.3-21.5 20.7-17.9C155.1 330.5 200 336 248 336s92.9-5.5 123.1-15.2c11.4-3.6 22.6 6.1 20.7 17.9-4.3 25.7-23.1 47.6-47.8 63.8V448c0 14.3-3.4 27.8-9 40 94-35.3 161-125.7 161-232C496 119 385 8 248 8zm-80 232c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm160 0c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm-34.9 134.6c-14.4-6.5-31.1 2.2-34.6 17.6l-1.8 7.8c-2.1 9.2-15.2 9.2-17.3 0l-1.8-7.8c-3.5-15.4-20.2-24.1-34.6-17.6-.9.4.3-.2-18.9 9.4v63c0 35.2 28 64.5 63.1 64.9 35.7.5 64.9-28.4 64.9-64v-64c-19.5-9.6-18.2-8.9-19-9.3z"
                }
            }
        ]
    })(props);
}
function FaGrinWink(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 256c0 137 111 248 248 248s248-111 248-248S385 8 248 8 0 119 0 256zm200-48c0 17.7-14.3 32-32 32s-32-14.3-32-32 14.3-32 32-32 32 14.3 32 32zm168 25l-9.5-8.5c-14.8-13.2-46.2-13.2-61 0L288 233c-8.3 7.4-21.6.4-19.8-10.8 4-25.2 34.2-42.1 59.9-42.1S384 197 388 222.2c1.6 11-11.5 18.2-20 10.8zm-243.1 87.8C155.1 330.5 200 336 248 336s92.9-5.5 123.1-15.2c11.3-3.7 22.6 6 20.7 17.9-9.2 55-83.2 93.3-143.8 93.3s-134.5-38.3-143.8-93.3c-2-11.9 9.3-21.6 20.7-17.9z"
                }
            }
        ]
    })(props);
}
function FaGrin(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm80 168c17.7 0 32 14.3 32 32s-14.3 32-32 32-32-14.3-32-32 14.3-32 32-32zm-160 0c17.7 0 32 14.3 32 32s-14.3 32-32 32-32-14.3-32-32 14.3-32 32-32zm80 256c-60.6 0-134.5-38.3-143.8-93.3-2-11.8 9.3-21.6 20.7-17.9C155.1 330.5 200 336 248 336s92.9-5.5 123.1-15.2c11.3-3.7 22.6 6.1 20.7 17.9-9.3 55-83.2 93.3-143.8 93.3z"
                }
            }
        ]
    })(props);
}
function FaGripHorizontal(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M96 288H32c-17.67 0-32 14.33-32 32v64c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32v-64c0-17.67-14.33-32-32-32zm160 0h-64c-17.67 0-32 14.33-32 32v64c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32v-64c0-17.67-14.33-32-32-32zm160 0h-64c-17.67 0-32 14.33-32 32v64c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32v-64c0-17.67-14.33-32-32-32zM96 96H32c-17.67 0-32 14.33-32 32v64c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32v-64c0-17.67-14.33-32-32-32zm160 0h-64c-17.67 0-32 14.33-32 32v64c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32v-64c0-17.67-14.33-32-32-32zm160 0h-64c-17.67 0-32 14.33-32 32v64c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32v-64c0-17.67-14.33-32-32-32z"
                }
            }
        ]
    })(props);
}
function FaGripLinesVertical(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 256 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M96 496V16c0-8.8-7.2-16-16-16H48c-8.8 0-16 7.2-16 16v480c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16zm128 0V16c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v480c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16z"
                }
            }
        ]
    })(props);
}
function FaGripLines(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M496 288H16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h480c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zm0-128H16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h480c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16z"
                }
            }
        ]
    })(props);
}
function FaGripVertical(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 320 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M96 32H32C14.33 32 0 46.33 0 64v64c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32V64c0-17.67-14.33-32-32-32zm0 160H32c-17.67 0-32 14.33-32 32v64c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32v-64c0-17.67-14.33-32-32-32zm0 160H32c-17.67 0-32 14.33-32 32v64c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32v-64c0-17.67-14.33-32-32-32zM288 32h-64c-17.67 0-32 14.33-32 32v64c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32V64c0-17.67-14.33-32-32-32zm0 160h-64c-17.67 0-32 14.33-32 32v64c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32v-64c0-17.67-14.33-32-32-32zm0 160h-64c-17.67 0-32 14.33-32 32v64c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32v-64c0-17.67-14.33-32-32-32z"
                }
            }
        ]
    })(props);
}
function FaGuitar(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M502.63 39L473 9.37a32 32 0 0 0-45.26 0L381.46 55.7a35.14 35.14 0 0 0-8.53 13.79L360.77 106l-76.26 76.26c-12.16-8.76-25.5-15.74-40.1-19.14-33.45-7.78-67-.88-89.88 22a82.45 82.45 0 0 0-20.24 33.47c-6 18.56-23.21 32.69-42.15 34.46-23.7 2.27-45.73 11.45-62.61 28.44C-16.11 327-7.9 409 47.58 464.45S185 528 230.56 482.52c17-16.88 26.16-38.9 28.45-62.71 1.76-18.85 15.89-36.13 34.43-42.14a82.6 82.6 0 0 0 33.48-20.25c22.87-22.88 29.74-56.36 22-89.75-3.39-14.64-10.37-28-19.16-40.2L406 151.23l36.48-12.16a35.14 35.14 0 0 0 13.79-8.53l46.33-46.32a32 32 0 0 0 .03-45.22zM208 352a48 48 0 1 1 48-48 48 48 0 0 1-48 48z"
                }
            }
        ]
    })(props);
}
function FaHSquare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M448 80v352c0 26.51-21.49 48-48 48H48c-26.51 0-48-21.49-48-48V80c0-26.51 21.49-48 48-48h352c26.51 0 48 21.49 48 48zm-112 48h-32c-8.837 0-16 7.163-16 16v80H160v-80c0-8.837-7.163-16-16-16h-32c-8.837 0-16 7.163-16 16v224c0 8.837 7.163 16 16 16h32c8.837 0 16-7.163 16-16v-80h128v80c0 8.837 7.163 16 16 16h32c8.837 0 16-7.163 16-16V144c0-8.837-7.163-16-16-16z"
                }
            }
        ]
    })(props);
}
function FaHamburger(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M464 256H48a48 48 0 0 0 0 96h416a48 48 0 0 0 0-96zm16 128H32a16 16 0 0 0-16 16v16a64 64 0 0 0 64 64h352a64 64 0 0 0 64-64v-16a16 16 0 0 0-16-16zM58.64 224h394.72c34.57 0 54.62-43.9 34.82-75.88C448 83.2 359.55 32.1 256 32c-103.54.1-192 51.2-232.18 116.11C4 180.09 24.07 224 58.64 224zM384 112a16 16 0 1 1-16 16 16 16 0 0 1 16-16zM256 80a16 16 0 1 1-16 16 16 16 0 0 1 16-16zm-128 32a16 16 0 1 1-16 16 16 16 0 0 1 16-16z"
                }
            }
        ]
    })(props);
}
function FaHammer(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M571.31 193.94l-22.63-22.63c-6.25-6.25-16.38-6.25-22.63 0l-11.31 11.31-28.9-28.9c5.63-21.31.36-44.9-16.35-61.61l-45.25-45.25c-62.48-62.48-163.79-62.48-226.28 0l90.51 45.25v18.75c0 16.97 6.74 33.25 18.75 45.25l49.14 49.14c16.71 16.71 40.3 21.98 61.61 16.35l28.9 28.9-11.31 11.31c-6.25 6.25-6.25 16.38 0 22.63l22.63 22.63c6.25 6.25 16.38 6.25 22.63 0l90.51-90.51c6.23-6.24 6.23-16.37-.02-22.62zm-286.72-15.2c-3.7-3.7-6.84-7.79-9.85-11.95L19.64 404.96c-25.57 23.88-26.26 64.19-1.53 88.93s65.05 24.05 88.93-1.53l238.13-255.07c-3.96-2.91-7.9-5.87-11.44-9.41l-49.14-49.14z"
                }
            }
        ]
    })(props);
}
function FaHamsa(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M509.34 307.25C504.28 295.56 492.75 288 480 288h-64V80c0-22-18-40-40-40s-40 18-40 40v134c0 5.52-4.48 10-10 10h-20c-5.52 0-10-4.48-10-10V40c0-22-18-40-40-40s-40 18-40 40v174c0 5.52-4.48 10-10 10h-20c-5.52 0-10-4.48-10-10V80c0-22-18-40-40-40S96 58 96 80v208H32c-12.75 0-24.28 7.56-29.34 19.25a31.966 31.966 0 0 0 5.94 34.58l102.69 110.03C146.97 490.08 199.69 512 256 512s109.03-21.92 144.72-60.14L503.4 341.83a31.966 31.966 0 0 0 5.94-34.58zM256 416c-53.02 0-96-64-96-64s42.98-64 96-64 96 64 96 64-42.98 64-96 64zm0-96c-17.67 0-32 14.33-32 32s14.33 32 32 32 32-14.33 32-32-14.33-32-32-32z"
                }
            }
        ]
    })(props);
}
function FaHandHoldingHeart(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M275.3 250.5c7 7.4 18.4 7.4 25.5 0l108.9-114.2c31.6-33.2 29.8-88.2-5.6-118.8-30.8-26.7-76.7-21.9-104.9 7.7L288 36.9l-11.1-11.6C248.7-4.4 202.8-9.2 172 17.5c-35.3 30.6-37.2 85.6-5.6 118.8l108.9 114.2zm290 77.6c-11.8-10.7-30.2-10-42.6 0L430.3 402c-11.3 9.1-25.4 14-40 14H272c-8.8 0-16-7.2-16-16s7.2-16 16-16h78.3c15.9 0 30.7-10.9 33.3-26.6 3.3-20-12.1-37.4-31.6-37.4H192c-27 0-53.1 9.3-74.1 26.3L71.4 384H16c-8.8 0-16 7.2-16 16v96c0 8.8 7.2 16 16 16h356.8c14.5 0 28.6-4.9 40-14L564 377c15.2-12.1 16.4-35.3 1.3-48.9z"
                }
            }
        ]
    })(props);
}
function FaHandHoldingMedical(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M159.88,175.82h64v64a16,16,0,0,0,16,16h64a16,16,0,0,0,16-16v-64h64a16,16,0,0,0,16-16v-64a16,16,0,0,0-16-16h-64v-64a16,16,0,0,0-16-16h-64a16,16,0,0,0-16,16v64h-64a16,16,0,0,0-16,16v64A16,16,0,0,0,159.88,175.82ZM568.07,336.13a39.91,39.91,0,0,0-55.93-8.47L392.47,415.84H271.86a16,16,0,0,1,0-32H350.1c16,0,30.75-10.87,33.37-26.61a32.06,32.06,0,0,0-31.62-37.38h-160a117.7,117.7,0,0,0-74.12,26.25l-46.5,37.74H15.87a16.11,16.11,0,0,0-16,16v96a16.11,16.11,0,0,0,16,16h347a104.8,104.8,0,0,0,61.7-20.27L559.6,392A40,40,0,0,0,568.07,336.13Z"
                }
            }
        ]
    })(props);
}
function FaHandHoldingUsd(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M271.06,144.3l54.27,14.3a8.59,8.59,0,0,1,6.63,8.1c0,4.6-4.09,8.4-9.12,8.4h-35.6a30,30,0,0,1-11.19-2.2c-5.24-2.2-11.28-1.7-15.3,2l-19,17.5a11.68,11.68,0,0,0-2.25,2.66,11.42,11.42,0,0,0,3.88,15.74,83.77,83.77,0,0,0,34.51,11.5V240c0,8.8,7.83,16,17.37,16h17.37c9.55,0,17.38-7.2,17.38-16V222.4c32.93-3.6,57.84-31,53.5-63-3.15-23-22.46-41.3-46.56-47.7L282.68,97.4a8.59,8.59,0,0,1-6.63-8.1c0-4.6,4.09-8.4,9.12-8.4h35.6A30,30,0,0,1,332,83.1c5.23,2.2,11.28,1.7,15.3-2l19-17.5A11.31,11.31,0,0,0,368.47,61a11.43,11.43,0,0,0-3.84-15.78,83.82,83.82,0,0,0-34.52-11.5V16c0-8.8-7.82-16-17.37-16H295.37C285.82,0,278,7.2,278,16V33.6c-32.89,3.6-57.85,31-53.51,63C227.63,119.6,247,137.9,271.06,144.3ZM565.27,328.1c-11.8-10.7-30.2-10-42.6,0L430.27,402a63.64,63.64,0,0,1-40,14H272a16,16,0,0,1,0-32h78.29c15.9,0,30.71-10.9,33.25-26.6a31.2,31.2,0,0,0,.46-5.46A32,32,0,0,0,352,320H192a117.66,117.66,0,0,0-74.1,26.29L71.4,384H16A16,16,0,0,0,0,400v96a16,16,0,0,0,16,16H372.77a64,64,0,0,0,40-14L564,377a32,32,0,0,0,1.28-48.9Z"
                }
            }
        ]
    })(props);
}
function FaHandHoldingWater(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M288 256c53 0 96-42.1 96-94 0-40-57.1-120.7-83.2-155.6-6.4-8.5-19.2-8.5-25.6 0C249.1 41.3 192 122 192 162c0 51.9 43 94 96 94zm277.3 72.1c-11.8-10.7-30.2-10-42.6 0L430.3 402c-11.3 9.1-25.4 14-40 14H272c-8.8 0-16-7.2-16-16s7.2-16 16-16h78.3c15.9 0 30.7-10.9 33.3-26.6 3.3-20-12.1-37.4-31.6-37.4H192c-27 0-53.1 9.3-74.1 26.3L71.4 384H16c-8.8 0-16 7.2-16 16v96c0 8.8 7.2 16 16 16h356.8c14.5 0 28.6-4.9 40-14L564 377c15.2-12.1 16.4-35.3 1.3-48.9z"
                }
            }
        ]
    })(props);
}
function FaHandHolding(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M565.3 328.1c-11.8-10.7-30.2-10-42.6 0L430.3 402c-11.3 9.1-25.4 14-40 14H272c-8.8 0-16-7.2-16-16s7.2-16 16-16h78.3c15.9 0 30.7-10.9 33.3-26.6 3.3-20-12.1-37.4-31.6-37.4H192c-27 0-53.1 9.3-74.1 26.3L71.4 384H16c-8.8 0-16 7.2-16 16v96c0 8.8 7.2 16 16 16h356.8c14.5 0 28.6-4.9 40-14L564 377c15.2-12.1 16.4-35.3 1.3-48.9z"
                }
            }
        ]
    })(props);
}
function FaHandLizard(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M384 480h192V363.778a95.998 95.998 0 0 0-14.833-51.263L398.127 54.368A48 48 0 0 0 357.544 32H24C10.745 32 0 42.745 0 56v16c0 30.928 25.072 56 56 56h229.981c12.844 0 21.556 13.067 16.615 24.923l-21.41 51.385A32 32 0 0 1 251.648 224H128c-35.346 0-64 28.654-64 64v8c0 13.255 10.745 24 24 24h147.406a47.995 47.995 0 0 1 25.692 7.455l111.748 70.811A24.001 24.001 0 0 1 384 418.539V480z"
                }
            }
        ]
    })(props);
}
function FaHandMiddleFinger(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M479.93 317.12a37.33 37.33 0 0 0-28.28-36.19L416 272v-49.59c0-11.44-9.69-21.29-23.15-23.54l-38.4-6.4C336.63 189.5 320 200.86 320 216v32a8 8 0 0 1-16 0V50c0-26.28-20.25-49.2-46.52-50A48 48 0 0 0 208 48v200a8 8 0 0 1-16 0v-32c0-15.15-16.63-26.51-34.45-23.54l-30.68 5.12c-18 3-30.87 16.12-30.87 31.38V376a8 8 0 0 1-16 0v-76l-27.36 15A37.34 37.34 0 0 0 32 348.4v73.47a37.31 37.31 0 0 0 10.93 26.39l30.93 30.93A112 112 0 0 0 153.05 512h215A112 112 0 0 0 480 400z"
                }
            }
        ]
    })(props);
}
function FaHandPaper(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M408.781 128.007C386.356 127.578 368 146.36 368 168.79V256h-8V79.79c0-22.43-18.356-41.212-40.781-40.783C297.488 39.423 280 57.169 280 79v177h-8V40.79C272 18.36 253.644-.422 231.219.007 209.488.423 192 18.169 192 40v216h-8V80.79c0-22.43-18.356-41.212-40.781-40.783C121.488 40.423 104 58.169 104 80v235.992l-31.648-43.519c-12.993-17.866-38.009-21.817-55.877-8.823-17.865 12.994-21.815 38.01-8.822 55.877l125.601 172.705A48 48 0 0 0 172.073 512h197.59c22.274 0 41.622-15.324 46.724-37.006l26.508-112.66a192.011 192.011 0 0 0 5.104-43.975V168c.001-21.831-17.487-39.577-39.218-39.993z"
                }
            }
        ]
    })(props);
}
function FaHandPeace(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M408 216c-22.092 0-40 17.909-40 40h-8v-32c0-22.091-17.908-40-40-40s-40 17.909-40 40v32h-8V48c0-26.51-21.49-48-48-48s-48 21.49-48 48v208h-13.572L92.688 78.449C82.994 53.774 55.134 41.63 30.461 51.324 5.787 61.017-6.356 88.877 3.337 113.551l74.765 190.342-31.09 24.872c-15.381 12.306-19.515 33.978-9.741 51.081l64 112A39.998 39.998 0 0 0 136 512h240c18.562 0 34.686-12.77 38.937-30.838l32-136A39.97 39.97 0 0 0 448 336v-80c0-22.091-17.908-40-40-40z"
                }
            }
        ]
    })(props);
}
function FaHandPointDown(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M91.826 467.2V317.966c-8.248 5.841-16.558 10.57-24.918 14.153C35.098 345.752-.014 322.222 0 288c.008-18.616 10.897-32.203 29.092-40 28.286-12.122 64.329-78.648 77.323-107.534 7.956-17.857 25.479-28.453 43.845-28.464l.001-.002h171.526c11.812 0 21.897 8.596 23.703 20.269 7.25 46.837 38.483 61.76 38.315 123.731-.007 2.724.195 13.254.195 16 0 50.654-22.122 81.574-71.263 72.6-9.297 18.597-39.486 30.738-62.315 16.45-21.177 24.645-53.896 22.639-70.944 6.299V467.2c0 24.15-20.201 44.8-43.826 44.8-23.283 0-43.826-21.35-43.826-44.8zM112 72V24c0-13.255 10.745-24 24-24h192c13.255 0 24 10.745 24 24v48c0 13.255-10.745 24-24 24H136c-13.255 0-24-10.745-24-24zm212-24c0-11.046-8.954-20-20-20s-20 8.954-20 20 8.954 20 20 20 20-8.954 20-20z"
                }
            }
        ]
    })(props);
}
function FaHandPointLeft(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M44.8 155.826h149.234c-5.841-8.248-10.57-16.558-14.153-24.918C166.248 99.098 189.778 63.986 224 64c18.616.008 32.203 10.897 40 29.092 12.122 28.286 78.648 64.329 107.534 77.323 17.857 7.956 28.453 25.479 28.464 43.845l.002.001v171.526c0 11.812-8.596 21.897-20.269 23.703-46.837 7.25-61.76 38.483-123.731 38.315-2.724-.007-13.254.195-16 .195-50.654 0-81.574-22.122-72.6-71.263-18.597-9.297-30.738-39.486-16.45-62.315-24.645-21.177-22.639-53.896-6.299-70.944H44.8c-24.15 0-44.8-20.201-44.8-43.826 0-23.283 21.35-43.826 44.8-43.826zM440 176h48c13.255 0 24 10.745 24 24v192c0 13.255-10.745 24-24 24h-48c-13.255 0-24-10.745-24-24V200c0-13.255 10.745-24 24-24zm24 212c11.046 0 20-8.954 20-20s-8.954-20-20-20-20 8.954-20 20 8.954 20 20 20z"
                }
            }
        ]
    })(props);
}
function FaHandPointRight(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M512 199.652c0 23.625-20.65 43.826-44.8 43.826h-99.851c16.34 17.048 18.346 49.766-6.299 70.944 14.288 22.829 2.147 53.017-16.45 62.315C353.574 425.878 322.654 448 272 448c-2.746 0-13.276-.203-16-.195-61.971.168-76.894-31.065-123.731-38.315C120.596 407.683 112 397.599 112 385.786V214.261l.002-.001c.011-18.366 10.607-35.889 28.464-43.845 28.886-12.994 95.413-49.038 107.534-77.323 7.797-18.194 21.384-29.084 40-29.092 34.222-.014 57.752 35.098 44.119 66.908-3.583 8.359-8.312 16.67-14.153 24.918H467.2c23.45 0 44.8 20.543 44.8 43.826zM96 200v192c0 13.255-10.745 24-24 24H24c-13.255 0-24-10.745-24-24V200c0-13.255 10.745-24 24-24h48c13.255 0 24 10.745 24 24zM68 368c0-11.046-8.954-20-20-20s-20 8.954-20 20 8.954 20 20 20 20-8.954 20-20z"
                }
            }
        ]
    })(props);
}
function FaHandPointUp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M135.652 0c23.625 0 43.826 20.65 43.826 44.8v99.851c17.048-16.34 49.766-18.346 70.944 6.299 22.829-14.288 53.017-2.147 62.315 16.45C361.878 158.426 384 189.346 384 240c0 2.746-.203 13.276-.195 16 .168 61.971-31.065 76.894-38.315 123.731C343.683 391.404 333.599 400 321.786 400H150.261l-.001-.002c-18.366-.011-35.889-10.607-43.845-28.464C93.421 342.648 57.377 276.122 29.092 264 10.897 256.203.008 242.616 0 224c-.014-34.222 35.098-57.752 66.908-44.119 8.359 3.583 16.67 8.312 24.918 14.153V44.8c0-23.45 20.543-44.8 43.826-44.8zM136 416h192c13.255 0 24 10.745 24 24v48c0 13.255-10.745 24-24 24H136c-13.255 0-24-10.745-24-24v-48c0-13.255 10.745-24 24-24zm168 28c-11.046 0-20 8.954-20 20s8.954 20 20 20 20-8.954 20-20-8.954-20-20-20z"
                }
            }
        ]
    })(props);
}
function FaHandPointer(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M448 240v96c0 3.084-.356 6.159-1.063 9.162l-32 136C410.686 499.23 394.562 512 376 512H168a40.004 40.004 0 0 1-32.35-16.473l-127.997-176c-12.993-17.866-9.043-42.883 8.822-55.876 17.867-12.994 42.884-9.043 55.877 8.823L104 315.992V40c0-22.091 17.908-40 40-40s40 17.909 40 40v200h8v-40c0-22.091 17.908-40 40-40s40 17.909 40 40v40h8v-24c0-22.091 17.908-40 40-40s40 17.909 40 40v24h8c0-22.091 17.908-40 40-40s40 17.909 40 40zm-256 80h-8v96h8v-96zm88 0h-8v96h8v-96zm88 0h-8v96h8v-96z"
                }
            }
        ]
    })(props);
}
function FaHandRock(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M464.8 80c-26.9-.4-48.8 21.2-48.8 48h-8V96.8c0-26.3-20.9-48.3-47.2-48.8-26.9-.4-48.8 21.2-48.8 48v32h-8V80.8c0-26.3-20.9-48.3-47.2-48.8-26.9-.4-48.8 21.2-48.8 48v48h-8V96.8c0-26.3-20.9-48.3-47.2-48.8-26.9-.4-48.8 21.2-48.8 48v136l-8-7.1v-48.1c0-26.3-20.9-48.3-47.2-48.8C21.9 127.6 0 149.2 0 176v66.4c0 27.4 11.7 53.5 32.2 71.8l111.7 99.3c10.2 9.1 16.1 22.2 16.1 35.9v6.7c0 13.3 10.7 24 24 24h240c13.3 0 24-10.7 24-24v-2.9c0-12.8 2.6-25.5 7.5-37.3l49-116.3c5-11.8 7.5-24.5 7.5-37.3V128.8c0-26.3-20.9-48.4-47.2-48.8z"
                }
            }
        ]
    })(props);
}
function FaHandScissors(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M216 440c0-22.092 17.909-40 40-40v-8h-32c-22.091 0-40-17.908-40-40s17.909-40 40-40h32v-8H48c-26.51 0-48-21.49-48-48s21.49-48 48-48h208v-13.572l-177.551-69.74c-24.674-9.694-36.818-37.555-27.125-62.228 9.693-24.674 37.554-36.817 62.228-27.124l190.342 74.765 24.872-31.09c12.306-15.381 33.978-19.515 51.081-9.741l112 64A40.002 40.002 0 0 1 512 168v240c0 18.562-12.77 34.686-30.838 38.937l-136 32A39.982 39.982 0 0 1 336 480h-80c-22.091 0-40-17.908-40-40z"
                }
            }
        ]
    })(props);
}
function FaHandSparkles(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M106.66,170.64l.09,0,49.55-20.65a7.32,7.32,0,0,0,3.68-6h0a7.29,7.29,0,0,0-3.68-6l-49.57-20.67-.07,0L86,67.68a6.66,6.66,0,0,0-11.92,0l-20.7,49.63-.05,0L3.7,138A7.29,7.29,0,0,0,0,144H0a7.32,7.32,0,0,0,3.68,6L53.27,170.6l.07,0L74,220.26a6.65,6.65,0,0,0,11.92,0l20.69-49.62ZM471.38,467.41l-1-.42-1-.5a38.67,38.67,0,0,1,0-69.14l1-.49,1-.43,37.49-15.63,15.63-37.48.41-1,.47-.95c3.85-7.74,10.58-13.63,18.35-17.34,0-1.33.25-2.69.27-4V144a32,32,0,0,0-64,0v72a8,8,0,0,1-8,8H456a8,8,0,0,1-8-8V64a32,32,0,0,0-64,0V216a8,8,0,0,1-8,8H360a8,8,0,0,1-8-8V32a32,32,0,0,0-64,0V216a8,8,0,0,1-8,8H264a8,8,0,0,1-8-8V64a32,32,0,0,0-64,0v241l-23.59-32.49a40,40,0,0,0-64.71,47.09L229.3,492.21A48.07,48.07,0,0,0,268.09,512H465.7c19.24,0,35.65-11.73,43.24-28.79l-.07-.17ZM349.79,339.52,320,351.93l-12.42,29.78a4,4,0,0,1-7.15,0L288,351.93l-29.79-12.41a4,4,0,0,1,0-7.16L288,319.94l12.42-29.78a4,4,0,0,1,7.15,0L320,319.94l29.79,12.42a4,4,0,0,1,0,7.16ZM640,431.91a7.28,7.28,0,0,0-3.68-6l-49.57-20.67-.07,0L566,355.63a6.66,6.66,0,0,0-11.92,0l-20.7,49.63-.05,0L483.7,426a7.28,7.28,0,0,0-3.68,6h0a7.29,7.29,0,0,0,3.68,5.95l49.57,20.67.07,0L554,508.21a6.65,6.65,0,0,0,11.92,0l20.69-49.62h0l.09,0,49.55-20.66a7.29,7.29,0,0,0,3.68-5.95h0Z"
                }
            }
        ]
    })(props);
}
function FaHandSpock(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M510.9005,145.27027,442.604,432.09391A103.99507,103.99507,0,0,1,341.43745,512H214.074a135.96968,135.96968,0,0,1-93.18489-36.95291L12.59072,373.12723a39.992,39.992,0,0,1,54.8122-58.24988l60.59342,57.02528v0a283.24849,283.24849,0,0,0-11.6703-80.46734L73.63726,147.36011a40.00575,40.00575,0,1,1,76.71833-22.7187l37.15458,125.39477a8.33113,8.33113,0,0,0,16.05656-4.4414L153.26183,49.95406A39.99638,39.99638,0,1,1,230.73015,30.0166l56.09491,218.15825a10.42047,10.42047,0,0,0,20.30018-.501L344.80766,63.96966a40.052,40.052,0,0,1,51.30245-30.0893c19.86073,6.2998,30.86262,27.67378,26.67564,48.08487l-33.83869,164.966a7.55172,7.55172,0,0,0,14.74406,3.2666l29.3973-123.45874a39.99414,39.99414,0,1,1,77.81208,18.53121Z"
                }
            }
        ]
    })(props);
}
function FaHandsHelping(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M488 192H336v56c0 39.7-32.3 72-72 72s-72-32.3-72-72V126.4l-64.9 39C107.8 176.9 96 197.8 96 220.2v47.3l-80 46.2C.7 322.5-4.6 342.1 4.3 357.4l80 138.6c8.8 15.3 28.4 20.5 43.7 11.7L231.4 448H368c35.3 0 64-28.7 64-64h16c17.7 0 32-14.3 32-32v-64h8c13.3 0 24-10.7 24-24v-48c0-13.3-10.7-24-24-24zm147.7-37.4L555.7 16C546.9.7 527.3-4.5 512 4.3L408.6 64H306.4c-12 0-23.7 3.4-33.9 9.7L239 94.6c-9.4 5.8-15 16.1-15 27.1V248c0 22.1 17.9 40 40 40s40-17.9 40-40v-88h184c30.9 0 56 25.1 56 56v28.5l80-46.2c15.3-8.9 20.5-28.4 11.7-43.7z"
                }
            }
        ]
    })(props);
}
function FaHandsWash(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M496,224a48,48,0,1,0-48-48A48,48,0,0,0,496,224ZM311.47,178.45A56.77,56.77,0,0,1,328,176a56,56,0,0,1,19,3.49l15.35-48.61A24,24,0,0,0,342,99.74c-11.53-1.35-22.21,6.44-25.71,17.51l-20.9,66.17ZM93.65,386.33c.8-.19,1.54-.54,2.35-.71V359.93a156,156,0,0,1,107.06-148l73.7-22.76L310.92,81.05a24,24,0,0,0-20.33-31.11c-11.53-1.34-22.22,6.45-25.72,17.52L231.42,173.88a8,8,0,0,1-15.26-4.83L259.53,31.26A24,24,0,0,0,239.2.15C227.67-1.19,217,6.6,213.49,17.66L165.56,169.37a8,8,0,1,1-15.26-4.82l38.56-122a24,24,0,0,0-20.33-31.11C157,10,146.32,17.83,142.82,28.9l-60,189.85L80.76,168.7A24,24,0,0,0,56.9,144.55c-13.23-.05-24.72,10.54-24.9,23.86V281.14A123.69,123.69,0,0,0,93.65,386.33ZM519.1,336H360a8,8,0,0,1,0-16H488a24,24,0,0,0,23.54-28.76C509.35,279.84,498.71,272,487.1,272H288l47.09-17.06a24,24,0,0,0-14.18-45.88L213.19,242.31A123.88,123.88,0,0,0,128,360v25.65a79.78,79.78,0,0,1,58,108.63A118.9,118.9,0,0,0,248,512H456a24,24,0,0,0,23.54-28.76C477.35,471.84,466.71,464,455.1,464H360a8,8,0,0,1,0-16H488a24,24,0,0,0,23.54-28.76C509.35,407.84,498.71,400,487.1,400H360a8,8,0,0,1,0-16H520a24,24,0,0,0,23.54-28.76C541.35,343.84,530.71,336,519.1,336ZM416,64a32,32,0,1,0-32-32A32,32,0,0,0,416,64ZM112,416a48,48,0,1,0,48,48A48,48,0,0,0,112,416Z"
                }
            }
        ]
    })(props);
}
function FaHands(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M204.8 230.4c-10.6-14.1-30.7-17-44.8-6.4-14.1 10.6-17 30.7-6.4 44.8l38.1 50.8c4.8 6.4 4.1 15.3-1.5 20.9l-12.8 12.8c-6.7 6.7-17.6 6.2-23.6-1.1L64 244.4V96c0-17.7-14.3-32-32-32S0 78.3 0 96v218.4c0 10.9 3.7 21.5 10.5 30l104.1 134.3c5 6.5 8.4 13.9 10.4 21.7 1.8 6.9 8.1 11.6 15.3 11.6H272c8.8 0 16-7.2 16-16V384c0-27.7-9-54.6-25.6-76.8l-57.6-76.8zM608 64c-17.7 0-32 14.3-32 32v148.4l-89.8 107.8c-6 7.2-17 7.7-23.6 1.1l-12.8-12.8c-5.6-5.6-6.3-14.5-1.5-20.9l38.1-50.8c10.6-14.1 7.7-34.2-6.4-44.8-14.1-10.6-34.2-7.7-44.8 6.4l-57.6 76.8C361 329.4 352 356.3 352 384v112c0 8.8 7.2 16 16 16h131.7c7.1 0 13.5-4.7 15.3-11.6 2-7.8 5.4-15.2 10.4-21.7l104.1-134.3c6.8-8.5 10.5-19.1 10.5-30V96c0-17.7-14.3-32-32-32z"
                }
            }
        ]
    })(props);
}
function FaHandshakeAltSlash(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M358.59,195.6,504.2,313.8a63.4,63.4,0,0,1,22.21,37.91H624a16.05,16.05,0,0,0,16-16V143.91A16,16,0,0,0,624,128H512L457.41,73.41A32,32,0,0,0,434.8,64H348.91a32,32,0,0,0-21.61,8.41l-88.12,80.68-25.69-19.85L289.09,64H205.3a32,32,0,0,0-22.6,9.41l-20.34,20.3L45.47,3.38A16,16,0,0,0,23,6.19L3.38,31.46A16,16,0,0,0,6.19,53.91L594.54,508.63A16,16,0,0,0,617,505.82l19.64-25.27a16,16,0,0,0-2.81-22.45L303.4,202.72l32.69-29.92,27-24.7a16,16,0,0,1,21.61,23.61ZM16,128A16.05,16.05,0,0,0,0,144V335.91a16,16,0,0,0,16,16H146.3l90.5,81.89a64,64,0,0,0,90-9.3l.2-.2,17.91,15.5a37.16,37.16,0,0,0,52.29-5.39l8.8-10.82L23.56,128Z"
                }
            }
        ]
    })(props);
}
function FaHandshakeSlash(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0,128.21V384H64a32,32,0,0,0,32-32V184L23.83,128.21ZM48,320.1a16,16,0,1,1-16,16A16,16,0,0,1,48,320.1Zm80,31.81h18.3l90.5,81.89a64,64,0,0,0,90-9.3l.2-.2,17.91,15.5a37.16,37.16,0,0,0,52.29-5.39l8.8-10.82L128,208.72Zm416-223.7V352.1a32,32,0,0,0,32,32h64V128.21ZM592,352.1a16,16,0,1,1,16-16A16,16,0,0,1,592,352.1ZM303.33,202.67l59.58-54.57a16,16,0,0,1,21.59,23.61L358.41,195.6,504,313.8a73.08,73.08,0,0,1,7.91,7.7V128L457.3,73.41A31.76,31.76,0,0,0,434.7,64H348.8a31.93,31.93,0,0,0-21.6,8.41l-88.07,80.64-25.64-19.81L289.09,64H205.3a32,32,0,0,0-22.6,9.41L162.36,93.72,45.47,3.38A16,16,0,0,0,23,6.19L3.38,31.46A16,16,0,0,0,6.19,53.91L594.53,508.63A16,16,0,0,0,617,505.82l19.65-25.27a16,16,0,0,0-2.82-22.45Z"
                }
            }
        ]
    })(props);
}
function FaHandshake(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M434.7 64h-85.9c-8 0-15.7 3-21.6 8.4l-98.3 90c-.1.1-.2.3-.3.4-16.6 15.6-16.3 40.5-2.1 56 12.7 13.9 39.4 17.6 56.1 2.7.1-.1.3-.1.4-.2l79.9-73.2c6.5-5.9 16.7-5.5 22.6 1 6 6.5 5.5 16.6-1 22.6l-26.1 23.9L504 313.8c2.9 2.4 5.5 5 7.9 7.7V128l-54.6-54.6c-5.9-6-14.1-9.4-22.6-9.4zM544 128.2v223.9c0 17.7 14.3 32 32 32h64V128.2h-96zm48 223.9c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16zM0 384h64c17.7 0 32-14.3 32-32V128.2H0V384zm48-63.9c8.8 0 16 7.2 16 16s-7.2 16-16 16-16-7.2-16-16c0-8.9 7.2-16 16-16zm435.9 18.6L334.6 217.5l-30 27.5c-29.7 27.1-75.2 24.5-101.7-4.4-26.9-29.4-24.8-74.9 4.4-101.7L289.1 64h-83.8c-8.5 0-16.6 3.4-22.6 9.4L128 128v223.9h18.3l90.5 81.9c27.4 22.3 67.7 18.1 90-9.3l.2-.2 17.9 15.5c15.9 13 39.4 10.5 52.3-5.4l31.4-38.6 5.4 4.4c13.7 11.1 33.9 9.1 45-4.7l9.5-11.7c11.2-13.8 9.1-33.9-4.6-45.1z"
                }
            }
        ]
    })(props);
}
function FaHanukiah(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M232 160c-4.42 0-8 3.58-8 8v120h32V168c0-4.42-3.58-8-8-8h-16zm-64 0c-4.42 0-8 3.58-8 8v120h32V168c0-4.42-3.58-8-8-8h-16zm224 0c-4.42 0-8 3.58-8 8v120h32V168c0-4.42-3.58-8-8-8h-16zm64 0c-4.42 0-8 3.58-8 8v120h32V168c0-4.42-3.58-8-8-8h-16zm88 8c0-4.42-3.58-8-8-8h-16c-4.42 0-8 3.58-8 8v120h32V168zm-440-8c-4.42 0-8 3.58-8 8v120h32V168c0-4.42-3.58-8-8-8h-16zm520 0h-32c-8.84 0-16 7.16-16 16v112c0 17.67-14.33 32-32 32H352V128c0-8.84-7.16-16-16-16h-32c-8.84 0-16 7.16-16 16v192H96c-17.67 0-32-14.33-32-32V176c0-8.84-7.16-16-16-16H16c-8.84 0-16 7.16-16 16v112c0 53.02 42.98 96 96 96h192v64H112c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h416c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16H352v-64h192c53.02 0 96-42.98 96-96V176c0-8.84-7.16-16-16-16zm-16-32c13.25 0 24-11.94 24-26.67S608 48 608 48s-24 38.61-24 53.33S594.75 128 608 128zm-576 0c13.25 0 24-11.94 24-26.67S32 48 32 48 8 86.61 8 101.33 18.75 128 32 128zm288-48c13.25 0 24-11.94 24-26.67S320 0 320 0s-24 38.61-24 53.33S306.75 80 320 80zm-208 48c13.25 0 24-11.94 24-26.67S112 48 112 48s-24 38.61-24 53.33S98.75 128 112 128zm64 0c13.25 0 24-11.94 24-26.67S176 48 176 48s-24 38.61-24 53.33S162.75 128 176 128zm64 0c13.25 0 24-11.94 24-26.67S240 48 240 48s-24 38.61-24 53.33S226.75 128 240 128zm160 0c13.25 0 24-11.94 24-26.67S400 48 400 48s-24 38.61-24 53.33S386.75 128 400 128zm64 0c13.25 0 24-11.94 24-26.67S464 48 464 48s-24 38.61-24 53.33S450.75 128 464 128zm64 0c13.25 0 24-11.94 24-26.67S528 48 528 48s-24 38.61-24 53.33S514.75 128 528 128z"
                }
            }
        ]
    })(props);
}
function FaHardHat(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M480 288c0-80.25-49.28-148.92-119.19-177.62L320 192V80a16 16 0 0 0-16-16h-96a16 16 0 0 0-16 16v112l-40.81-81.62C81.28 139.08 32 207.75 32 288v64h448zm16 96H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h480a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16z"
                }
            }
        ]
    })(props);
}
function FaHashtag(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M440.667 182.109l7.143-40c1.313-7.355-4.342-14.109-11.813-14.109h-74.81l14.623-81.891C377.123 38.754 371.468 32 363.997 32h-40.632a12 12 0 0 0-11.813 9.891L296.175 128H197.54l14.623-81.891C213.477 38.754 207.822 32 200.35 32h-40.632a12 12 0 0 0-11.813 9.891L132.528 128H53.432a12 12 0 0 0-11.813 9.891l-7.143 40C33.163 185.246 38.818 192 46.289 192h74.81L98.242 320H19.146a12 12 0 0 0-11.813 9.891l-7.143 40C-1.123 377.246 4.532 384 12.003 384h74.81L72.19 465.891C70.877 473.246 76.532 480 84.003 480h40.632a12 12 0 0 0 11.813-9.891L151.826 384h98.634l-14.623 81.891C234.523 473.246 240.178 480 247.65 480h40.632a12 12 0 0 0 11.813-9.891L315.472 384h79.096a12 12 0 0 0 11.813-9.891l7.143-40c1.313-7.355-4.342-14.109-11.813-14.109h-74.81l22.857-128h79.096a12 12 0 0 0 11.813-9.891zM261.889 320h-98.634l22.857-128h98.634l-22.857 128z"
                }
            }
        ]
    })(props);
}
function FaHatCowboySide(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M260.8 291.06c-28.63-22.94-62-35.06-96.4-35.06C87 256 21.47 318.72 1.43 412.06c-3.55 16.6-.43 33.83 8.57 47.3C18.75 472.47 31.83 480 45.88 480H592c-103.21 0-155-37.07-233.19-104.46zm234.65-18.29L468.4 116.2A64 64 0 0 0 392 64.41L200.85 105a64 64 0 0 0-50.35 55.79L143.61 226c6.9-.83 13.7-2 20.79-2 41.79 0 82 14.55 117.29 42.82l98 84.48C450.76 412.54 494.9 448 592 448a48 48 0 0 0 48-48c0-25.39-29.6-119.33-144.55-127.23z"
                }
            }
        ]
    })(props);
}
function FaHatCowboy(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M490 296.9C480.51 239.51 450.51 64 392.3 64c-14 0-26.49 5.93-37 14a58.21 58.21 0 0 1-70.58 0c-10.51-8-23-14-37-14-58.2 0-88.2 175.47-97.71 232.88C188.81 309.47 243.73 320 320 320s131.23-10.51 170-23.1zm142.9-37.18a16 16 0 0 0-19.75 1.5c-1 .9-101.27 90.78-293.16 90.78-190.82 0-292.22-89.94-293.24-90.84A16 16 0 0 0 1 278.53C1.73 280.55 78.32 480 320 480s318.27-199.45 319-201.47a16 16 0 0 0-6.09-18.81z"
                }
            }
        ]
    })(props);
}
function FaHatWizard(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M496 448H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h480c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16zm-304-64l-64-32 64-32 32-64 32 64 64 32-64 32-16 32h208l-86.41-201.63a63.955 63.955 0 0 1-1.89-45.45L416 0 228.42 107.19a127.989 127.989 0 0 0-53.46 59.15L64 416h144l-16-32zm64-224l16-32 16 32 32 16-32 16-16 32-16-32-32-16 32-16z"
                }
            }
        ]
    })(props);
}
function FaHdd(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M576 304v96c0 26.51-21.49 48-48 48H48c-26.51 0-48-21.49-48-48v-96c0-26.51 21.49-48 48-48h480c26.51 0 48 21.49 48 48zm-48-80a79.557 79.557 0 0 1 30.777 6.165L462.25 85.374A48.003 48.003 0 0 0 422.311 64H153.689a48 48 0 0 0-39.938 21.374L17.223 230.165A79.557 79.557 0 0 1 48 224h480zm-48 96c-17.673 0-32 14.327-32 32s14.327 32 32 32 32-14.327 32-32-14.327-32-32-32zm-96 0c-17.673 0-32 14.327-32 32s14.327 32 32 32 32-14.327 32-32-14.327-32-32-32z"
                }
            }
        ]
    })(props);
}
function FaHeadSideCoughSlash(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M454.11,319.21c19.56-3.81,31.62-25,23.11-44.21-21-47.12-48.5-151.75-73.12-186.75A208.13,208.13,0,0,0,234.1,0H192A190.64,190.64,0,0,0,84.18,33.3L45.46,3.38A16,16,0,0,0,23,6.19L3.37,31.46A16,16,0,0,0,6.18,53.91L594.53,508.63A16,16,0,0,0,617,505.82l19.64-25.27a16,16,0,0,0-2.81-22.45ZM313.39,210.45,263.61,172c5.88-7.14,14.43-12,24.36-12a32.06,32.06,0,0,1,32,32C320,199,317.24,205.17,313.39,210.45ZM616,304a24,24,0,1,0-24-24A24,24,0,0,0,616,304Zm-64,64a24,24,0,1,0-24-24A24,24,0,0,0,552,368ZM288,384a32,32,0,0,1,32-32h19.54L20.73,105.59A190.86,190.86,0,0,0,0,192c0,56.75,24.75,107.62,64,142.88V512H288V480h64a64,64,0,0,0,64-64H320A32,32,0,0,1,288,384Zm328-24a24,24,0,1,0,24,24A24,24,0,0,0,616,360Z"
                }
            }
        ]
    })(props);
}
function FaHeadSideCough(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M616,304a24,24,0,1,0-24-24A24,24,0,0,0,616,304ZM552,416a24,24,0,1,0,24,24A24,24,0,0,0,552,416Zm-64-56a24,24,0,1,0,24,24A24,24,0,0,0,488,360ZM616,464a24,24,0,1,0,24,24A24,24,0,0,0,616,464Zm0-104a24,24,0,1,0,24,24A24,24,0,0,0,616,360Zm-64-40a24,24,0,1,0,24,24A24,24,0,0,0,552,320Zm-74.78-45c-21-47.12-48.5-151.75-73.12-186.75A208.13,208.13,0,0,0,234.1,0H192C86,0,0,86,0,192c0,56.75,24.75,107.62,64,142.88V512H288V480h64a64,64,0,0,0,64-64H320a32,32,0,0,1,0-64h96V320h32A32,32,0,0,0,477.22,275ZM288,224a32,32,0,1,1,32-32A32.07,32.07,0,0,1,288,224Z"
                }
            }
        ]
    })(props);
}
function FaHeadSideMask(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M.15,184.42C-2.17,244.21,23,298.06,64,334.88V512H224V316.51L3.67,156.25A182.28,182.28,0,0,0,.15,184.42ZM509.22,275c-21-47.12-48.5-151.75-73.12-186.75A208.11,208.11,0,0,0,266.11,0H200C117,0,42.48,50.57,13.25,123.65L239.21,288H511.76A31.35,31.35,0,0,0,509.22,275ZM320,224a32,32,0,1,1,32-32A32.07,32.07,0,0,1,320,224Zm16,144H496l16-48H256V512H401.88a64,64,0,0,0,60.71-43.76L464,464H336a16,16,0,0,1,0-32H474.67l10.67-32H336a16,16,0,0,1,0-32Z"
                }
            }
        ]
    })(props);
}
function FaHeadSideVirus(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M272,240a16,16,0,1,0,16,16A16,16,0,0,0,272,240Zm-64-64a16,16,0,1,0,16,16A16,16,0,0,0,208,176Zm301.2,99c-20.93-47.12-48.43-151.73-73.07-186.75A207.9,207.9,0,0,0,266.09,0H192C86,0,0,86,0,192A191.23,191.23,0,0,0,64,334.81V512H320V448h64a64,64,0,0,0,64-64V320H480A32,32,0,0,0,509.2,275ZM368,240H355.88c-28.51,0-42.79,34.47-22.63,54.63l8.58,8.57a16,16,0,1,1-22.63,22.63l-8.57-8.58C290.47,297.09,256,311.37,256,339.88V352a16,16,0,0,1-32,0V339.88c0-28.51-34.47-42.79-54.63-22.63l-8.57,8.58a16,16,0,0,1-22.63-22.63l8.58-8.57c20.16-20.16,5.88-54.63-22.63-54.63H112a16,16,0,0,1,0-32h12.12c28.51,0,42.79-34.47,22.63-54.63l-8.58-8.57a16,16,0,0,1,22.63-22.63l8.57,8.58c20.16,20.16,54.63,5.88,54.63-22.63V96a16,16,0,0,1,32,0v12.12c0,28.51,34.47,42.79,54.63,22.63l8.57-8.58a16,16,0,0,1,22.63,22.63l-8.58,8.57C313.09,173.53,327.37,208,355.88,208H368a16,16,0,0,1,0,32Z"
                }
            }
        ]
    })(props);
}
function FaHeading(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M448 96v320h32a16 16 0 0 1 16 16v32a16 16 0 0 1-16 16H320a16 16 0 0 1-16-16v-32a16 16 0 0 1 16-16h32V288H160v128h32a16 16 0 0 1 16 16v32a16 16 0 0 1-16 16H32a16 16 0 0 1-16-16v-32a16 16 0 0 1 16-16h32V96H32a16 16 0 0 1-16-16V48a16 16 0 0 1 16-16h160a16 16 0 0 1 16 16v32a16 16 0 0 1-16 16h-32v128h192V96h-32a16 16 0 0 1-16-16V48a16 16 0 0 1 16-16h160a16 16 0 0 1 16 16v32a16 16 0 0 1-16 16z"
                }
            }
        ]
    })(props);
}
function FaHeadphonesAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M160 288h-16c-35.35 0-64 28.7-64 64.12v63.76c0 35.41 28.65 64.12 64 64.12h16c17.67 0 32-14.36 32-32.06V320.06c0-17.71-14.33-32.06-32-32.06zm208 0h-16c-17.67 0-32 14.35-32 32.06v127.88c0 17.7 14.33 32.06 32 32.06h16c35.35 0 64-28.71 64-64.12v-63.76c0-35.41-28.65-64.12-64-64.12zM256 32C112.91 32 4.57 151.13 0 288v112c0 8.84 7.16 16 16 16h16c8.84 0 16-7.16 16-16V288c0-114.67 93.33-207.8 208-207.82 114.67.02 208 93.15 208 207.82v112c0 8.84 7.16 16 16 16h16c8.84 0 16-7.16 16-16V288C507.43 151.13 399.09 32 256 32z"
                }
            }
        ]
    })(props);
}
function FaHeadphones(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 32C114.52 32 0 146.496 0 288v48a32 32 0 0 0 17.689 28.622l14.383 7.191C34.083 431.903 83.421 480 144 480h24c13.255 0 24-10.745 24-24V280c0-13.255-10.745-24-24-24h-24c-31.342 0-59.671 12.879-80 33.627V288c0-105.869 86.131-192 192-192s192 86.131 192 192v1.627C427.671 268.879 399.342 256 368 256h-24c-13.255 0-24 10.745-24 24v176c0 13.255 10.745 24 24 24h24c60.579 0 109.917-48.098 111.928-108.187l14.382-7.191A32 32 0 0 0 512 336v-48c0-141.479-114.496-256-256-256z"
                }
            }
        ]
    })(props);
}
function FaHeadset(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M192 208c0-17.67-14.33-32-32-32h-16c-35.35 0-64 28.65-64 64v48c0 35.35 28.65 64 64 64h16c17.67 0 32-14.33 32-32V208zm176 144c35.35 0 64-28.65 64-64v-48c0-35.35-28.65-64-64-64h-16c-17.67 0-32 14.33-32 32v112c0 17.67 14.33 32 32 32h16zM256 0C113.18 0 4.58 118.83 0 256v16c0 8.84 7.16 16 16 16h16c8.84 0 16-7.16 16-16v-16c0-114.69 93.31-208 208-208s208 93.31 208 208h-.12c.08 2.43.12 165.72.12 165.72 0 23.35-18.93 42.28-42.28 42.28H320c0-26.51-21.49-48-48-48h-32c-26.51 0-48 21.49-48 48s21.49 48 48 48h181.72c49.86 0 90.28-40.42 90.28-90.28V256C507.42 118.83 398.82 0 256 0z"
                }
            }
        ]
    })(props);
}
function FaHeartBroken(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M473.7 73.8l-2.4-2.5c-46-47-118-51.7-169.6-14.8L336 159.9l-96 64 48 128-144-144 96-64-28.6-86.5C159.7 19.6 87 24 40.7 71.4l-2.4 2.4C-10.4 123.6-12.5 202.9 31 256l212.1 218.6c7.1 7.3 18.6 7.3 25.7 0L481 255.9c43.5-53 41.4-132.3-7.3-182.1z"
                }
            }
        ]
    })(props);
}
function FaHeart(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M462.3 62.6C407.5 15.9 326 24.3 275.7 76.2L256 96.5l-19.7-20.3C186.1 24.3 104.5 15.9 49.7 62.6c-62.8 53.6-66.1 149.8-9.9 207.9l193.5 199.8c12.5 12.9 32.8 12.9 45.3 0l193.5-199.8c56.3-58.1 53-154.3-9.8-207.9z"
                }
            }
        ]
    })(props);
}
function FaHeartbeat(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M320.2 243.8l-49.7 99.4c-6 12.1-23.4 11.7-28.9-.6l-56.9-126.3-30 71.7H60.6l182.5 186.5c7.1 7.3 18.6 7.3 25.7 0L451.4 288H342.3l-22.1-44.2zM473.7 73.9l-2.4-2.5c-51.5-52.6-135.8-52.6-187.4 0L256 100l-27.9-28.5c-51.5-52.7-135.9-52.7-187.4 0l-2.4 2.4C-10.4 123.7-12.5 203 31 256h102.4l35.9-86.2c5.4-12.9 23.6-13.2 29.4-.4l58.2 129.3 49-97.9c5.9-11.8 22.7-11.8 28.6 0l27.6 55.2H481c43.5-53 41.4-132.3-7.3-182.1z"
                }
            }
        ]
    })(props);
}
function FaHelicopter(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M304 384h272c17.67 0 32-14.33 32-32 0-123.71-100.29-224-224-224V64h176c8.84 0 16-7.16 16-16V16c0-8.84-7.16-16-16-16H144c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h176v64H112L68.8 70.4C65.78 66.37 61.03 64 56 64H16.01C5.6 64-2.04 73.78.49 83.88L32 192l160 64 86.4 115.2A31.992 31.992 0 0 0 304 384zm112-188.49C478.55 208.3 528.03 257.44 540.79 320H416V195.51zm219.37 263.3l-22.15-22.2c-6.25-6.26-16.24-6.1-22.64.01-7.09 6.77-13.84 11.25-24.64 11.25H240c-8.84 0-16 7.18-16 16.03v32.06c0 8.85 7.16 16.03 16 16.03h325.94c14.88 0 35.3-.47 68.45-29.52 7.02-6.14 7.57-17.05.98-23.66z"
                }
            }
        ]
    })(props);
}
function FaHighlighter(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 544 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 479.98L99.92 512l35.45-35.45-67.04-67.04L0 479.98zm124.61-240.01a36.592 36.592 0 0 0-10.79 38.1l13.05 42.83-50.93 50.94 96.23 96.23 50.86-50.86 42.74 13.08c13.73 4.2 28.65-.01 38.15-10.78l35.55-41.64-173.34-173.34-41.52 35.44zm403.31-160.7l-63.2-63.2c-20.49-20.49-53.38-21.52-75.12-2.35L190.55 183.68l169.77 169.78L530.27 154.4c19.18-21.74 18.15-54.63-2.35-75.13z"
                }
            }
        ]
    })(props);
}
function FaHiking(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M80.95 472.23c-4.28 17.16 6.14 34.53 23.28 38.81 2.61.66 5.22.95 7.8.95 14.33 0 27.37-9.7 31.02-24.23l25.24-100.97-52.78-52.78-34.56 138.22zm14.89-196.12L137 117c2.19-8.42-3.14-16.95-11.92-19.06-43.88-10.52-88.35 15.07-99.32 57.17L.49 253.24c-2.19 8.42 3.14 16.95 11.92 19.06l63.56 15.25c8.79 2.1 17.68-3.02 19.87-11.44zM368 160h-16c-8.84 0-16 7.16-16 16v16h-34.75l-46.78-46.78C243.38 134.11 228.61 128 212.91 128c-27.02 0-50.47 18.3-57.03 44.52l-26.92 107.72a32.012 32.012 0 0 0 8.42 30.39L224 397.25V480c0 17.67 14.33 32 32 32s32-14.33 32-32v-82.75c0-17.09-6.66-33.16-18.75-45.25l-46.82-46.82c.15-.5.49-.89.62-1.41l19.89-79.57 22.43 22.43c6 6 14.14 9.38 22.62 9.38h48v240c0 8.84 7.16 16 16 16h16c8.84 0 16-7.16 16-16V176c.01-8.84-7.15-16-15.99-16zM240 96c26.51 0 48-21.49 48-48S266.51 0 240 0s-48 21.49-48 48 21.49 48 48 48z"
                }
            }
        ]
    })(props);
}
function FaHippo(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M581.12 96.2c-27.67-.15-52.5 17.58-76.6 26.62C489.98 88.27 455.83 64 416 64c-11.28 0-21.95 2.3-32 5.88V56c0-13.26-10.75-24-24-24h-16c-13.25 0-24 10.74-24 24v48.98C286.01 79.58 241.24 64 192 64 85.96 64 0 135.64 0 224v240c0 8.84 7.16 16 16 16h64c8.84 0 16-7.16 16-16v-70.79C128.35 407.57 166.72 416 208 416s79.65-8.43 112-22.79V464c0 8.84 7.16 16 16 16h64c8.84 0 16-7.16 16-16V288h128v32c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16v-32c17.67 0 32-14.33 32-32v-92.02c0-34.09-24.79-67.59-58.88-67.78zM448 176c-8.84 0-16-7.16-16-16s7.16-16 16-16 16 7.16 16 16-7.16 16-16 16z"
                }
            }
        ]
    })(props);
}
function FaHistory(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M504 255.531c.253 136.64-111.18 248.372-247.82 248.468-59.015.042-113.223-20.53-155.822-54.911-11.077-8.94-11.905-25.541-1.839-35.607l11.267-11.267c8.609-8.609 22.353-9.551 31.891-1.984C173.062 425.135 212.781 440 256 440c101.705 0 184-82.311 184-184 0-101.705-82.311-184-184-184-48.814 0-93.149 18.969-126.068 49.932l50.754 50.754c10.08 10.08 2.941 27.314-11.313 27.314H24c-8.837 0-16-7.163-16-16V38.627c0-14.254 17.234-21.393 27.314-11.314l49.372 49.372C129.209 34.136 189.552 8 256 8c136.81 0 247.747 110.78 248 247.531zm-180.912 78.784l9.823-12.63c8.138-10.463 6.253-25.542-4.21-33.679L288 256.349V152c0-13.255-10.745-24-24-24h-16c-13.255 0-24 10.745-24 24v135.651l65.409 50.874c10.463 8.137 25.541 6.253 33.679-4.21z"
                }
            }
        ]
    })(props);
}
function FaHockeyPuck(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 160c0-53 114.6-96 256-96s256 43 256 96-114.6 96-256 96S0 213 0 160zm0 82.2V352c0 53 114.6 96 256 96s256-43 256-96V242.2c-113.4 82.3-398.5 82.4-512 0z"
                }
            }
        ]
    })(props);
}
function FaHollyBerry(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M144 192c26.5 0 48-21.5 48-48s-21.5-48-48-48-48 21.5-48 48 21.5 48 48 48zm112-48c0 26.5 21.5 48 48 48s48-21.5 48-48-21.5-48-48-48-48 21.5-48 48zm-32-48c26.5 0 48-21.5 48-48S250.5 0 224 0s-48 21.5-48 48 21.5 48 48 48zm-16.2 139.1c.1-12.4-13.1-20.1-23.8-13.7-34.3 20.3-71.4 32.7-108.7 36.2-9.7.9-15.6 11.3-11.6 20.2 6.2 13.9 11.1 28.6 14.7 43.8 3.6 15.2-5.3 30.6-20.2 35.1-14.9 4.5-30.1 7.6-45.3 9.1-9.7 1-15.7 11.3-11.7 20.2 15 32.8 22.9 69.5 23 107.7.1 14.4 15.2 23.1 27.6 16 33.2-19 68.9-30.5 104.8-33.9 9.7-.9 15.6-11.3 11.6-20.2-6.2-13.9-11.1-28.6-14.7-43.8-3.6-15.2 5.3-30.6 20.2-35.1 14.9-4.5 30.1-7.6 45.3-9.1 9.7-1 15.7-11.3 11.7-20.2-15.5-34.2-23.3-72.5-22.9-112.3zM435 365.6c-15.2-1.6-30.3-4.7-45.3-9.1-14.9-4.5-23.8-19.9-20.2-35.1 3.6-15.2 8.5-29.8 14.7-43.8 4-8.9-1.9-19.3-11.6-20.2-37.3-3.5-74.4-15.9-108.7-36.2-10.7-6.3-23.9 1.4-23.8 13.7 0 1.6-.2 3.2-.2 4.9.2 33.3 7 65.7 19.9 94 5.7 12.4 5.2 26.6-.6 38.9 4.9 1.2 9.9 2.2 14.8 3.7 14.9 4.5 23.8 19.9 20.2 35.1-3.6 15.2-8.5 29.8-14.7 43.8-4 8.9 1.9 19.3 11.6 20.2 35.9 3.4 71.6 14.9 104.8 33.9 12.5 7.1 27.6-1.6 27.6-16 .2-38.2 8-75 23-107.7 4.3-8.7-1.8-19.1-11.5-20.1z"
                }
            }
        ]
    })(props);
}
function FaHome(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M280.37 148.26L96 300.11V464a16 16 0 0 0 16 16l112.06-.29a16 16 0 0 0 15.92-16V368a16 16 0 0 1 16-16h64a16 16 0 0 1 16 16v95.64a16 16 0 0 0 16 16.05L464 480a16 16 0 0 0 16-16V300L295.67 148.26a12.19 12.19 0 0 0-15.3 0zM571.6 251.47L488 182.56V44.05a12 12 0 0 0-12-12h-56a12 12 0 0 0-12 12v72.61L318.47 43a48 48 0 0 0-61 0L4.34 251.47a12 12 0 0 0-1.6 16.9l25.5 31A12 12 0 0 0 45.15 301l235.22-193.74a12.19 12.19 0 0 1 15.3 0L530.9 301a12 12 0 0 0 16.9-1.6l25.5-31a12 12 0 0 0-1.7-16.93z"
                }
            }
        ]
    })(props);
}
function FaHorseHead(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M509.8 332.5l-69.9-164.3c-14.9-41.2-50.4-71-93-79.2 18-10.6 46.3-35.9 34.2-82.3-1.3-5-7.1-7.9-12-6.1L166.9 76.3C35.9 123.4 0 238.9 0 398.8V480c0 17.7 14.3 32 32 32h236.2c23.8 0 39.3-25 28.6-46.3L256 384v-.7c-45.6-3.5-84.6-30.7-104.3-69.6-1.6-3.1-.9-6.9 1.6-9.3l12.1-12.1c3.9-3.9 10.6-2.7 12.9 2.4 14.8 33.7 48.2 57.4 87.4 57.4 17.2 0 33-5.1 46.8-13.2l46 63.9c6 8.4 15.7 13.3 26 13.3h50.3c8.5 0 16.6-3.4 22.6-9.4l45.3-39.8c8.9-9.1 11.7-22.6 7.1-34.4zM328 224c-13.3 0-24-10.7-24-24s10.7-24 24-24 24 10.7 24 24-10.7 24-24 24z"
                }
            }
        ]
    })(props);
}
function FaHorse(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M575.92 76.6c-.01-8.13-3.02-15.87-8.58-21.8-3.78-4.03-8.58-9.12-13.69-14.5 11.06-6.84 19.5-17.49 22.18-30.66C576.85 4.68 572.96 0 567.9 0H447.92c-70.69 0-128 57.31-128 128H160c-28.84 0-54.4 12.98-72 33.11V160c-48.53 0-88 39.47-88 88v56c0 8.84 7.16 16 16 16h16c8.84 0 16-7.16 16-16v-56c0-13.22 6.87-24.39 16.78-31.68-.21 2.58-.78 5.05-.78 7.68 0 27.64 11.84 52.36 30.54 69.88l-25.72 68.6a63.945 63.945 0 0 0-2.16 37.99l24.85 99.41A15.982 15.982 0 0 0 107.02 512h65.96c10.41 0 18.05-9.78 15.52-19.88l-26.31-105.26 23.84-63.59L320 345.6V496c0 8.84 7.16 16 16 16h64c8.84 0 16-7.16 16-16V318.22c19.74-20.19 32-47.75 32-78.22 0-.22-.07-.42-.08-.64V136.89l16 7.11 18.9 37.7c7.45 14.87 25.05 21.55 40.49 15.37l32.55-13.02a31.997 31.997 0 0 0 20.12-29.74l-.06-77.71zm-64 19.4c-8.84 0-16-7.16-16-16s7.16-16 16-16 16 7.16 16 16-7.16 16-16 16z"
                }
            }
        ]
    })(props);
}
function FaHospitalAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M544 96H416V32c0-17.7-14.3-32-32-32H192c-17.7 0-32 14.3-32 32v64H32c-17.7 0-32 14.3-32 32v368c0 8.8 7.2 16 16 16h544c8.8 0 16-7.2 16-16V128c0-17.7-14.3-32-32-32zM160 436c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40zm0-128c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40zm160 128c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40zm0-128c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40zm16-170c0 3.3-2.7 6-6 6h-26v26c0 3.3-2.7 6-6 6h-20c-3.3 0-6-2.7-6-6v-26h-26c-3.3 0-6-2.7-6-6v-20c0-3.3 2.7-6 6-6h26V86c0-3.3 2.7-6 6-6h20c3.3 0 6 2.7 6 6v26h26c3.3 0 6 2.7 6 6v20zm144 298c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40zm0-128c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40z"
                }
            }
        ]
    })(props);
}
function FaHospitalSymbol(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 0C114.6 0 0 114.6 0 256s114.6 256 256 256 256-114.6 256-256S397.4 0 256 0zm112 376c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8v-88h-96v88c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V136c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v88h96v-88c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v240z"
                }
            }
        ]
    })(props);
}
function FaHospitalUser(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M480 320a96 96 0 1 0-96-96 96 96 0 0 0 96 96zm48 32a22.88 22.88 0 0 0-7.06 1.09 124.76 124.76 0 0 1-81.89 0A22.82 22.82 0 0 0 432 352a112 112 0 0 0-112 112.62c.14 26.26 21.73 47.38 48 47.38h224c26.27 0 47.86-21.12 48-47.38A112 112 0 0 0 528 352zm-198.09 10.45A145.19 145.19 0 0 1 352 344.62V128a32 32 0 0 0-32-32h-32V32a32 32 0 0 0-32-32H96a32 32 0 0 0-32 32v64H32a32 32 0 0 0-32 32v368a16 16 0 0 0 16 16h288.31A78.62 78.62 0 0 1 288 464.79a143.06 143.06 0 0 1 41.91-102.34zM144 404a12 12 0 0 1-12 12H92a12 12 0 0 1-12-12v-40a12 12 0 0 1 12-12h40a12 12 0 0 1 12 12zm0-128a12 12 0 0 1-12 12H92a12 12 0 0 1-12-12v-40a12 12 0 0 1 12-12h40a12 12 0 0 1 12 12zm48-122a6 6 0 0 1-6 6h-20a6 6 0 0 1-6-6v-26h-26a6 6 0 0 1-6-6v-20a6 6 0 0 1 6-6h26V70a6 6 0 0 1 6-6h20a6 6 0 0 1 6 6v26h26a6 6 0 0 1 6 6v20a6 6 0 0 1-6 6h-26zm80 250a12 12 0 0 1-12 12h-40a12 12 0 0 1-12-12v-40a12 12 0 0 1 12-12h40a12 12 0 0 1 12 12zm0-128a12 12 0 0 1-12 12h-40a12 12 0 0 1-12-12v-40a12 12 0 0 1 12-12h40a12 12 0 0 1 12 12z"
                }
            }
        ]
    })(props);
}
function FaHospital(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M448 492v20H0v-20c0-6.627 5.373-12 12-12h20V120c0-13.255 10.745-24 24-24h88V24c0-13.255 10.745-24 24-24h112c13.255 0 24 10.745 24 24v72h88c13.255 0 24 10.745 24 24v360h20c6.627 0 12 5.373 12 12zM308 192h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12v-40c0-6.627-5.373-12-12-12zm-168 64h40c6.627 0 12-5.373 12-12v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12zm104 128h-40c-6.627 0-12 5.373-12 12v84h64v-84c0-6.627-5.373-12-12-12zm64-96h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12v-40c0-6.627-5.373-12-12-12zm-116 12c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12v-40zM182 96h26v26a6 6 0 0 0 6 6h20a6 6 0 0 0 6-6V96h26a6 6 0 0 0 6-6V70a6 6 0 0 0-6-6h-26V38a6 6 0 0 0-6-6h-20a6 6 0 0 0-6 6v26h-26a6 6 0 0 0-6 6v20a6 6 0 0 0 6 6z"
                }
            }
        ]
    })(props);
}
function FaHotTub(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M414.21 177.65c1.02 8.21 7.75 14.35 15.75 14.35h16.12c9.51 0 17.08-8.57 16-18.35-4.34-39.11-22.4-74.53-50.13-97.16-17.37-14.17-28.82-36.75-31.98-62.15C378.96 6.14 372.22 0 364.23 0h-16.12c-9.51 0-17.09 8.57-16 18.35 4.34 39.11 22.4 74.53 50.13 97.16 17.36 14.17 28.82 36.75 31.97 62.14zm-108 0c1.02 8.21 7.75 14.35 15.75 14.35h16.12c9.51 0 17.08-8.57 16-18.35-4.34-39.11-22.4-74.53-50.13-97.16-17.37-14.17-28.82-36.75-31.98-62.15C270.96 6.14 264.22 0 256.23 0h-16.12c-9.51 0-17.09 8.57-16 18.35 4.34 39.11 22.4 74.53 50.13 97.16 17.36 14.17 28.82 36.75 31.97 62.14zM480 256H256l-110.93-83.2a63.99 63.99 0 0 0-38.4-12.8H64c-35.35 0-64 28.65-64 64v224c0 35.35 28.65 64 64 64h384c35.35 0 64-28.65 64-64V288c0-17.67-14.33-32-32-32zM128 440c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8V328c0-4.42 3.58-8 8-8h16c4.42 0 8 3.58 8 8v112zm96 0c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8V328c0-4.42 3.58-8 8-8h16c4.42 0 8 3.58 8 8v112zm96 0c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8V328c0-4.42 3.58-8 8-8h16c4.42 0 8 3.58 8 8v112zm96 0c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8V328c0-4.42 3.58-8 8-8h16c4.42 0 8 3.58 8 8v112zM64 128c35.35 0 64-28.65 64-64S99.35 0 64 0 0 28.65 0 64s28.65 64 64 64z"
                }
            }
        ]
    })(props);
}
function FaHotdog(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M488.56 23.44a80 80 0 0 0-113.12 0l-352 352a80 80 0 1 0 113.12 113.12l352-352a80 80 0 0 0 0-113.12zm-49.93 95.19c-19.6 19.59-37.52 22.67-51.93 25.14C373.76 146 364.4 147.6 352 160s-14 21.76-16.23 34.71c-2.48 14.4-5.55 32.33-25.15 51.92s-37.52 22.67-51.92 25.15C245.75 274 236.4 275.6 224 288s-14 21.75-16.23 34.7c-2.47 14.4-5.54 32.33-25.14 51.92s-37.53 22.68-51.93 25.15C117.76 402 108.4 403.6 96 416a16 16 0 0 1-22.63-22.63c19.6-19.59 37.52-22.67 51.92-25.14 13-2.22 22.3-3.82 34.71-16.23s14-21.75 16.22-34.7c2.48-14.4 5.55-32.33 25.15-51.92s37.52-22.67 51.92-25.14c13-2.22 22.3-3.83 34.7-16.23s14-21.76 16.24-34.71c2.47-14.4 5.54-32.33 25.14-51.92s37.52-22.68 51.92-25.15C394.24 110 403.59 108.41 416 96a16 16 0 0 1 22.63 22.63zM31.44 322.18L322.18 31.44l-11.54-11.55c-25-25-63.85-26.66-86.79-3.72L16.17 223.85c-22.94 22.94-21.27 61.79 3.72 86.78zm449.12-132.36L189.82 480.56l11.54 11.55c25 25 63.85 26.66 86.79 3.72l207.68-207.68c22.94-22.94 21.27-61.79-3.72-86.79z"
                }
            }
        ]
    })(props);
}
function FaHotel(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M560 64c8.84 0 16-7.16 16-16V16c0-8.84-7.16-16-16-16H16C7.16 0 0 7.16 0 16v32c0 8.84 7.16 16 16 16h15.98v384H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h240v-80c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v80h240c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16h-16V64h16zm-304 44.8c0-6.4 6.4-12.8 12.8-12.8h38.4c6.4 0 12.8 6.4 12.8 12.8v38.4c0 6.4-6.4 12.8-12.8 12.8h-38.4c-6.4 0-12.8-6.4-12.8-12.8v-38.4zm0 96c0-6.4 6.4-12.8 12.8-12.8h38.4c6.4 0 12.8 6.4 12.8 12.8v38.4c0 6.4-6.4 12.8-12.8 12.8h-38.4c-6.4 0-12.8-6.4-12.8-12.8v-38.4zm-128-96c0-6.4 6.4-12.8 12.8-12.8h38.4c6.4 0 12.8 6.4 12.8 12.8v38.4c0 6.4-6.4 12.8-12.8 12.8h-38.4c-6.4 0-12.8-6.4-12.8-12.8v-38.4zM179.2 256h-38.4c-6.4 0-12.8-6.4-12.8-12.8v-38.4c0-6.4 6.4-12.8 12.8-12.8h38.4c6.4 0 12.8 6.4 12.8 12.8v38.4c0 6.4-6.4 12.8-12.8 12.8zM192 384c0-53.02 42.98-96 96-96s96 42.98 96 96H192zm256-140.8c0 6.4-6.4 12.8-12.8 12.8h-38.4c-6.4 0-12.8-6.4-12.8-12.8v-38.4c0-6.4 6.4-12.8 12.8-12.8h38.4c6.4 0 12.8 6.4 12.8 12.8v38.4zm0-96c0 6.4-6.4 12.8-12.8 12.8h-38.4c-6.4 0-12.8-6.4-12.8-12.8v-38.4c0-6.4 6.4-12.8 12.8-12.8h38.4c6.4 0 12.8 6.4 12.8 12.8v38.4z"
                }
            }
        ]
    })(props);
}
function FaHourglassEnd(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M360 64c13.255 0 24-10.745 24-24V24c0-13.255-10.745-24-24-24H24C10.745 0 0 10.745 0 24v16c0 13.255 10.745 24 24 24 0 90.965 51.016 167.734 120.842 192C75.016 280.266 24 357.035 24 448c-13.255 0-24 10.745-24 24v16c0 13.255 10.745 24 24 24h336c13.255 0 24-10.745 24-24v-16c0-13.255-10.745-24-24-24 0-90.965-51.016-167.734-120.842-192C308.984 231.734 360 154.965 360 64zM192 208c-57.787 0-104-66.518-104-144h208c0 77.945-46.51 144-104 144z"
                }
            }
        ]
    })(props);
}
function FaHourglassHalf(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M360 0H24C10.745 0 0 10.745 0 24v16c0 13.255 10.745 24 24 24 0 90.965 51.016 167.734 120.842 192C75.016 280.266 24 357.035 24 448c-13.255 0-24 10.745-24 24v16c0 13.255 10.745 24 24 24h336c13.255 0 24-10.745 24-24v-16c0-13.255-10.745-24-24-24 0-90.965-51.016-167.734-120.842-192C308.984 231.734 360 154.965 360 64c13.255 0 24-10.745 24-24V24c0-13.255-10.745-24-24-24zm-75.078 384H99.08c17.059-46.797 52.096-80 92.92-80 40.821 0 75.862 33.196 92.922 80zm.019-256H99.078C91.988 108.548 88 86.748 88 64h208c0 22.805-3.987 44.587-11.059 64z"
                }
            }
        ]
    })(props);
}
function FaHourglassStart(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M360 0H24C10.745 0 0 10.745 0 24v16c0 13.255 10.745 24 24 24 0 90.965 51.016 167.734 120.842 192C75.016 280.266 24 357.035 24 448c-13.255 0-24 10.745-24 24v16c0 13.255 10.745 24 24 24h336c13.255 0 24-10.745 24-24v-16c0-13.255-10.745-24-24-24 0-90.965-51.016-167.734-120.842-192C308.984 231.734 360 154.965 360 64c13.255 0 24-10.745 24-24V24c0-13.255-10.745-24-24-24zm-64 448H88c0-77.458 46.204-144 104-144 57.786 0 104 66.517 104 144z"
                }
            }
        ]
    })(props);
}
function FaHourglass(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M360 64c13.255 0 24-10.745 24-24V24c0-13.255-10.745-24-24-24H24C10.745 0 0 10.745 0 24v16c0 13.255 10.745 24 24 24 0 90.965 51.016 167.734 120.842 192C75.016 280.266 24 357.035 24 448c-13.255 0-24 10.745-24 24v16c0 13.255 10.745 24 24 24h336c13.255 0 24-10.745 24-24v-16c0-13.255-10.745-24-24-24 0-90.965-51.016-167.734-120.842-192C308.984 231.734 360 154.965 360 64z"
                }
            }
        ]
    })(props);
}
function FaHouseDamage(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M288 114.96L69.47 307.71c-1.62 1.46-3.69 2.14-5.47 3.35V496c0 8.84 7.16 16 16 16h149.23L192 439.19l104.11-64-60.16-119.22L384 392.75l-104.11 64L319.81 512H496c8.84 0 16-7.16 16-16V311.1c-1.7-1.16-3.72-1.82-5.26-3.2L288 114.96zm282.69 121.32L512 184.45V48c0-8.84-7.16-16-16-16h-64c-8.84 0-16 7.16-16 16v51.69L314.75 10.31C307.12 3.45 297.56.01 288 0s-19.1 3.41-26.7 10.27L5.31 236.28c-6.57 5.91-7.12 16.02-1.21 22.6l21.4 23.82c5.9 6.57 16.02 7.12 22.6 1.21L277.42 81.63c6.05-5.33 15.12-5.33 21.17 0L527.91 283.9c6.57 5.9 16.69 5.36 22.6-1.21l21.4-23.82c5.9-6.57 5.36-16.69-1.22-22.59z"
                }
            }
        ]
    })(props);
}
function FaHouseUser(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M570.69,236.27,512,184.44V48a16,16,0,0,0-16-16H432a16,16,0,0,0-16,16V99.67L314.78,10.3C308.5,4.61,296.53,0,288,0s-20.46,4.61-26.74,10.3l-256,226A18.27,18.27,0,0,0,0,248.2a18.64,18.64,0,0,0,4.09,10.71L25.5,282.7a21.14,21.14,0,0,0,12,5.3,21.67,21.67,0,0,0,10.69-4.11l15.9-14V480a32,32,0,0,0,32,32H480a32,32,0,0,0,32-32V269.88l15.91,14A21.94,21.94,0,0,0,538.63,288a20.89,20.89,0,0,0,11.87-5.31l21.41-23.81A21.64,21.64,0,0,0,576,248.19,21,21,0,0,0,570.69,236.27ZM288,176a64,64,0,1,1-64,64A64,64,0,0,1,288,176ZM400,448H176a16,16,0,0,1-16-16,96,96,0,0,1,96-96h64a96,96,0,0,1,96,96A16,16,0,0,1,400,448Z"
                }
            }
        ]
    })(props);
}
function FaHryvnia(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M368 240c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16h-41.86c13.41-28.63 13.74-63.33-4.13-94.05C303.34 49.84 267.1 32 229.96 32h-78.82c-24.32 0-47.86 8.53-66.54 24.09L72.83 65.9c-10.18 8.49-11.56 23.62-3.07 33.8l20.49 24.59c8.49 10.19 23.62 11.56 33.81 3.07l11.73-9.78c4.32-3.6 9.77-5.57 15.39-5.57h83.62c11.69 0 21.2 9.52 21.2 21.2 0 5.91-2.48 11.58-6.81 15.58L219.7 176H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h134.37l-34.67 32H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h41.86c-13.41 28.63-13.74 63.33 4.13 94.05C80.66 462.15 116.9 480 154.04 480h78.82c24.32 0 47.86-8.53 66.54-24.09l11.77-9.81c10.18-8.49 11.56-23.62 3.07-33.8l-20.49-24.59c-8.49-10.19-23.62-11.56-33.81-3.07l-11.75 9.8a23.992 23.992 0 0 1-15.36 5.56H149.2c-11.69 0-21.2-9.52-21.2-21.2 0-5.91 2.48-11.58 6.81-15.58L164.3 336H368c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16H233.63l34.67-32H368z"
                }
            }
        ]
    })(props);
}
function FaICursor(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 256 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 52.048V12.065C256 5.496 250.726.148 244.158.066 211.621-.344 166.469.011 128 37.959 90.266.736 46.979-.114 11.913.114 5.318.157 0 5.519 0 12.114v39.645c0 6.687 5.458 12.078 12.145 11.998C38.111 63.447 96 67.243 96 112.182V224H60c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h36v112c0 44.932-56.075 48.031-83.95 47.959C5.404 447.942 0 453.306 0 459.952v39.983c0 6.569 5.274 11.917 11.842 11.999 32.537.409 77.689.054 116.158-37.894 37.734 37.223 81.021 38.073 116.087 37.845 6.595-.043 11.913-5.405 11.913-12V460.24c0-6.687-5.458-12.078-12.145-11.998C217.889 448.553 160 444.939 160 400V288h36c6.627 0 12-5.373 12-12v-40c0-6.627-5.373-12-12-12h-36V112.182c0-44.932 56.075-48.213 83.95-48.142 6.646.018 12.05-5.346 12.05-11.992z"
                }
            }
        ]
    })(props);
}
function FaIceCream(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M368 160h-.94a144 144 0 1 0-286.12 0H80a48 48 0 0 0 0 96h288a48 48 0 0 0 0-96zM195.38 493.69a31.52 31.52 0 0 0 57.24 0L352 288H96z"
                }
            }
        ]
    })(props);
}
function FaIcicles(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M511.4 37.9C515.1 18.2 500 0 480 0H32C10.6 0-4.8 20.7 1.4 41.2l87.1 273.4c2.5 7.2 12.7 7.2 15.1 0L140 190.5l44.2 187.3c1.9 8.3 13.7 8.3 15.6 0l46.5-196.9 34.1 133.4c2.3 7.6 13 7.6 15.3 0l45.8-172.5 66.7 363.8c1.7 8.6 14 8.6 15.7 0l87.5-467.7z"
                }
            }
        ]
    })(props);
}
function FaIcons(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M116.65 219.35a15.68 15.68 0 0 0 22.65 0l96.75-99.83c28.15-29 26.5-77.1-4.91-103.88C203.75-7.7 163-3.5 137.86 22.44L128 32.58l-9.85-10.14C93.05-3.5 52.25-7.7 24.86 15.64c-31.41 26.78-33 74.85-5 103.88zm143.92 100.49h-48l-7.08-14.24a27.39 27.39 0 0 0-25.66-17.78h-71.71a27.39 27.39 0 0 0-25.66 17.78l-7 14.24h-48A27.45 27.45 0 0 0 0 347.3v137.25A27.44 27.44 0 0 0 27.43 512h233.14A27.45 27.45 0 0 0 288 484.55V347.3a27.45 27.45 0 0 0-27.43-27.46zM144 468a52 52 0 1 1 52-52 52 52 0 0 1-52 52zm355.4-115.9h-60.58l22.36-50.75c2.1-6.65-3.93-13.21-12.18-13.21h-75.59c-6.3 0-11.66 3.9-12.5 9.1l-16.8 106.93c-1 6.3 4.88 11.89 12.5 11.89h62.31l-24.2 83c-1.89 6.65 4.2 12.9 12.23 12.9a13.26 13.26 0 0 0 10.92-5.25l92.4-138.91c4.88-6.91-1.16-15.7-10.87-15.7zM478.08.33L329.51 23.17C314.87 25.42 304 38.92 304 54.83V161.6a83.25 83.25 0 0 0-16-1.7c-35.35 0-64 21.48-64 48s28.65 48 64 48c35.2 0 63.73-21.32 64-47.66V99.66l112-17.22v47.18a83.25 83.25 0 0 0-16-1.7c-35.35 0-64 21.48-64 48s28.65 48 64 48c35.2 0 63.73-21.32 64-47.66V32c0-19.48-16-34.42-33.92-31.67z"
                }
            }
        ]
    })(props);
}
function FaIdBadge(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M336 0H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48zM144 32h96c8.8 0 16 7.2 16 16s-7.2 16-16 16h-96c-8.8 0-16-7.2-16-16s7.2-16 16-16zm48 128c35.3 0 64 28.7 64 64s-28.7 64-64 64-64-28.7-64-64 28.7-64 64-64zm112 236.8c0 10.6-10 19.2-22.4 19.2H102.4C90 416 80 407.4 80 396.8v-19.2c0-31.8 30.1-57.6 67.2-57.6h5c12.3 5.1 25.7 8 39.8 8s27.6-2.9 39.8-8h5c37.1 0 67.2 25.8 67.2 57.6v19.2z"
                }
            }
        ]
    })(props);
}
function FaIdCardAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M528 64H384v96H192V64H48C21.5 64 0 85.5 0 112v352c0 26.5 21.5 48 48 48h480c26.5 0 48-21.5 48-48V112c0-26.5-21.5-48-48-48zM288 224c35.3 0 64 28.7 64 64s-28.7 64-64 64-64-28.7-64-64 28.7-64 64-64zm93.3 224H194.7c-10.4 0-18.8-10-15.6-19.8 8.3-25.6 32.4-44.2 60.9-44.2h8.2c12.3 5.1 25.7 8 39.8 8s27.6-2.9 39.8-8h8.2c28.4 0 52.5 18.5 60.9 44.2 3.2 9.8-5.2 19.8-15.6 19.8zM352 32c0-17.7-14.3-32-32-32h-64c-17.7 0-32 14.3-32 32v96h128V32z"
                }
            }
        ]
    })(props);
}
function FaIdCard(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M528 32H48C21.5 32 0 53.5 0 80v16h576V80c0-26.5-21.5-48-48-48zM0 432c0 26.5 21.5 48 48 48h480c26.5 0 48-21.5 48-48V128H0v304zm352-232c0-4.4 3.6-8 8-8h144c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8H360c-4.4 0-8-3.6-8-8v-16zm0 64c0-4.4 3.6-8 8-8h144c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8H360c-4.4 0-8-3.6-8-8v-16zm0 64c0-4.4 3.6-8 8-8h144c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8H360c-4.4 0-8-3.6-8-8v-16zM176 192c35.3 0 64 28.7 64 64s-28.7 64-64 64-64-28.7-64-64 28.7-64 64-64zM67.1 396.2C75.5 370.5 99.6 352 128 352h8.2c12.3 5.1 25.7 8 39.8 8s27.6-2.9 39.8-8h8.2c28.4 0 52.5 18.5 60.9 44.2 3.2 9.9-5.2 19.8-15.6 19.8H82.7c-10.4 0-18.8-10-15.6-19.8z"
                }
            }
        ]
    })(props);
}
function FaIgloo(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M320 33.9c-10.5-1.2-21.2-1.9-32-1.9-99.8 0-187.8 50.8-239.4 128H320V33.9zM96 192H30.3C11.1 230.6 0 274 0 320h96V192zM352 39.4V160h175.4C487.2 99.9 424.8 55.9 352 39.4zM480 320h96c0-46-11.1-89.4-30.3-128H480v128zm-64 64v96h128c17.7 0 32-14.3 32-32v-96H411.5c2.6 10.3 4.5 20.9 4.5 32zm32-192H128v128h49.8c22.2-38.1 63-64 110.2-64s88 25.9 110.2 64H448V192zM0 448c0 17.7 14.3 32 32 32h128v-96c0-11.1 1.9-21.7 4.5-32H0v96zm288-160c-53 0-96 43-96 96v96h192v-96c0-53-43-96-96-96z"
                }
            }
        ]
    })(props);
}
function FaImage(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M464 448H48c-26.51 0-48-21.49-48-48V112c0-26.51 21.49-48 48-48h416c26.51 0 48 21.49 48 48v288c0 26.51-21.49 48-48 48zM112 120c-30.928 0-56 25.072-56 56s25.072 56 56 56 56-25.072 56-56-25.072-56-56-56zM64 384h384V272l-87.515-87.515c-4.686-4.686-12.284-4.686-16.971 0L208 320l-55.515-55.515c-4.686-4.686-12.284-4.686-16.971 0L64 336v48z"
                }
            }
        ]
    })(props);
}
function FaImages(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M480 416v16c0 26.51-21.49 48-48 48H48c-26.51 0-48-21.49-48-48V176c0-26.51 21.49-48 48-48h16v208c0 44.112 35.888 80 80 80h336zm96-80V80c0-26.51-21.49-48-48-48H144c-26.51 0-48 21.49-48 48v256c0 26.51 21.49 48 48 48h384c26.51 0 48-21.49 48-48zM256 128c0 26.51-21.49 48-48 48s-48-21.49-48-48 21.49-48 48-48 48 21.49 48 48zm-96 144l55.515-55.515c4.686-4.686 12.284-4.686 16.971 0L272 256l135.515-135.515c4.686-4.686 12.284-4.686 16.971 0L512 208v112H160v-48z"
                }
            }
        ]
    })(props);
}
function FaInbox(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M567.938 243.908L462.25 85.374A48.003 48.003 0 0 0 422.311 64H153.689a48 48 0 0 0-39.938 21.374L8.062 243.908A47.994 47.994 0 0 0 0 270.533V400c0 26.51 21.49 48 48 48h480c26.51 0 48-21.49 48-48V270.533a47.994 47.994 0 0 0-8.062-26.625zM162.252 128h251.497l85.333 128H376l-32 64H232l-32-64H76.918l85.334-128z"
                }
            }
        ]
    })(props);
}
function FaIndent(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M27.31 363.3l96-96a16 16 0 0 0 0-22.62l-96-96C17.27 138.66 0 145.78 0 160v192c0 14.31 17.33 21.3 27.31 11.3zM432 416H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm3.17-128H204.83A12.82 12.82 0 0 0 192 300.83v38.34A12.82 12.82 0 0 0 204.83 352h230.34A12.82 12.82 0 0 0 448 339.17v-38.34A12.82 12.82 0 0 0 435.17 288zm0-128H204.83A12.82 12.82 0 0 0 192 172.83v38.34A12.82 12.82 0 0 0 204.83 224h230.34A12.82 12.82 0 0 0 448 211.17v-38.34A12.82 12.82 0 0 0 435.17 160zM432 32H16A16 16 0 0 0 0 48v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16z"
                }
            }
        ]
    })(props);
}
function FaIndustry(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M475.115 163.781L336 252.309v-68.28c0-18.916-20.931-30.399-36.885-20.248L160 252.309V56c0-13.255-10.745-24-24-24H24C10.745 32 0 42.745 0 56v400c0 13.255 10.745 24 24 24h464c13.255 0 24-10.745 24-24V184.029c0-18.917-20.931-30.399-36.885-20.248z"
                }
            }
        ]
    })(props);
}
function FaInfinity(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M471.1 96C405 96 353.3 137.3 320 174.6 286.7 137.3 235 96 168.9 96 75.8 96 0 167.8 0 256s75.8 160 168.9 160c66.1 0 117.8-41.3 151.1-78.6 33.3 37.3 85 78.6 151.1 78.6 93.1 0 168.9-71.8 168.9-160S564.2 96 471.1 96zM168.9 320c-40.2 0-72.9-28.7-72.9-64s32.7-64 72.9-64c38.2 0 73.4 36.1 94 64-20.4 27.6-55.9 64-94 64zm302.2 0c-38.2 0-73.4-36.1-94-64 20.4-27.6 55.9-64 94-64 40.2 0 72.9 28.7 72.9 64s-32.7 64-72.9 64z"
                }
            }
        ]
    })(props);
}
function FaInfoCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 8C119.043 8 8 119.083 8 256c0 136.997 111.043 248 248 248s248-111.003 248-248C504 119.083 392.957 8 256 8zm0 110c23.196 0 42 18.804 42 42s-18.804 42-42 42-42-18.804-42-42 18.804-42 42-42zm56 254c0 6.627-5.373 12-12 12h-88c-6.627 0-12-5.373-12-12v-24c0-6.627 5.373-12 12-12h12v-64h-12c-6.627 0-12-5.373-12-12v-24c0-6.627 5.373-12 12-12h64c6.627 0 12 5.373 12 12v100h12c6.627 0 12 5.373 12 12v24z"
                }
            }
        ]
    })(props);
}
function FaInfo(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 192 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 424.229h20V279.771H20c-11.046 0-20-8.954-20-20V212c0-11.046 8.954-20 20-20h112c11.046 0 20 8.954 20 20v212.229h20c11.046 0 20 8.954 20 20V492c0 11.046-8.954 20-20 20H20c-11.046 0-20-8.954-20-20v-47.771c0-11.046 8.954-20 20-20zM96 0C56.235 0 24 32.235 24 72s32.235 72 72 72 72-32.235 72-72S135.764 0 96 0z"
                }
            }
        ]
    })(props);
}
function FaItalic(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 320 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M320 48v32a16 16 0 0 1-16 16h-62.76l-80 320H208a16 16 0 0 1 16 16v32a16 16 0 0 1-16 16H16a16 16 0 0 1-16-16v-32a16 16 0 0 1 16-16h62.76l80-320H112a16 16 0 0 1-16-16V48a16 16 0 0 1 16-16h192a16 16 0 0 1 16 16z"
                }
            }
        ]
    })(props);
}
function FaJedi(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M535.95308,352c-42.64069,94.17188-137.64086,160-247.9848,160q-6.39844,0-12.84377-.29688C171.15558,506.9375,81.26481,442.23438,40.01474,352H79.93668L21.3272,293.40625a264.82522,264.82522,0,0,1-5.10938-39.42187,273.6653,273.6653,0,0,1,.5-29.98438H63.93665L22.546,182.625A269.79782,269.79782,0,0,1,130.51489,20.54688a16.06393,16.06393,0,0,1,9.28127-3,16.36332,16.36332,0,0,1,13.5,7.25,16.02739,16.02739,0,0,1,1.625,15.09374,138.387,138.387,0,0,0-9.84376,51.26563c0,45.10937,21.04691,86.57813,57.71884,113.73437a16.29989,16.29989,0,0,1,1.20313,25.39063c-26.54692,23.98437-41.17194,56.5-41.17194,91.57813,0,60.03124,42.95319,110.28124,99.89079,121.92187l2.5-65.26563L238.062,397a8.33911,8.33911,0,0,1-10-.75,8.025,8.025,0,0,1-1.39063-9.9375l20.125-33.76562-42.06257-8.73438a7.9898,7.9898,0,0,1,0-15.65625l42.06257-8.71875-20.10941-33.73438a7.99122,7.99122,0,0,1,11.35939-10.71874L268.437,295.64062,279.95265,7.67188a7.97138,7.97138,0,0,1,8-7.67188h.04687a8.02064,8.02064,0,0,1,7.95314,7.70312L307.48394,295.625l30.39068-20.67188a8.08327,8.08327,0,0,1,10,.8125,7.99866,7.99866,0,0,1,1.39062,9.90626L329.12461,319.4375l42.07819,8.73438a7.99373,7.99373,0,0,1,0,15.65624l-42.07819,8.71876,20.1094,33.73437a7.97791,7.97791,0,0,1-1.32812,9.92187A8.25739,8.25739,0,0,1,337.87462,397L310.7027,378.53125l2.5,65.34375c48.48446-9.40625,87.57828-48.15625,97.31267-96.5A123.52652,123.52652,0,0,0,371.9528,230.29688a16.30634,16.30634,0,0,1,1.20313-25.42188c36.65631-27.17188,57.6876-68.60938,57.6876-113.73438a138.01689,138.01689,0,0,0-9.85939-51.3125,15.98132,15.98132,0,0,1,1.60937-15.09374,16.36914,16.36914,0,0,1,13.5-7.23438,16.02453,16.02453,0,0,1,9.25,2.98438A271.26947,271.26947,0,0,1,553.25,182.76562L511.99992,224h46.9532C559.3125,229.76562,560,235.45312,560,241.26562a270.092,270.092,0,0,1-5.125,51.85938L495.98427,352Z"
                }
            }
        ]
    })(props);
}
function FaJoint(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M444.34 181.1c22.38 15.68 35.66 41.16 35.66 68.59V280c0 4.42 3.58 8 8 8h48c4.42 0 8-3.58 8-8v-30.31c0-43.24-21.01-83.41-56.34-108.06C463.85 125.02 448 99.34 448 70.31V8c0-4.42-3.58-8-8-8h-48c-4.42 0-8 3.58-8 8v66.4c0 43.69 24.56 81.63 60.34 106.7zM194.97 358.98C126.03 370.07 59.69 394.69 0 432c83.65 52.28 180.3 80 278.94 80h88.57L254.79 380.49c-14.74-17.2-37.45-25.11-59.82-21.51zM553.28 87.09c-5.67-3.8-9.28-9.96-9.28-16.78V8c0-4.42-3.58-8-8-8h-48c-4.42 0-8 3.58-8 8v62.31c0 22.02 10.17 43.41 28.64 55.39C550.79 153.04 576 199.54 576 249.69V280c0 4.42 3.58 8 8 8h48c4.42 0 8-3.58 8-8v-30.31c0-65.44-32.41-126.19-86.72-162.6zM360.89 352.05c-34.4.06-86.81.15-88.21.17l117.8 137.43A63.987 63.987 0 0 0 439.07 512h88.45L409.57 374.4a63.955 63.955 0 0 0-48.68-22.35zM616 352H432l117.99 137.65A63.987 63.987 0 0 0 598.58 512H616c13.25 0 24-10.75 24-24V376c0-13.26-10.75-24-24-24z"
                }
            }
        ]
    })(props);
}
function FaJournalWhills(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M438.40625,377.59375c-3.20313,12.8125-3.20313,57.60937,0,73.60937Q447.9922,460.78907,448,470.40625v16c0,16-12.79688,25.59375-25.59375,25.59375H96c-54.40625,0-96-41.59375-96-96V96C0,41.59375,41.59375,0,96,0H422.40625C438.40625,0,448,9.59375,448,25.59375v332.8125Q448,372.79688,438.40625,377.59375ZM380.79688,384H96c-16,0-32,12.79688-32,32s12.79688,32,32,32H380.79688ZM128.01562,176.01562c0,.51563.14063.98438.14063,1.5l37.10937,32.46876A7.99954,7.99954,0,0,1,160,224h-.01562a9.17678,9.17678,0,0,1-5.25-1.98438L131.14062,201.375C142.6875,250.95312,186.90625,288,240,288s97.3125-37.04688,108.875-86.625l-23.59375,20.64062a8.02516,8.02516,0,0,1-5.26563,1.96876H320a9.14641,9.14641,0,0,1-6.01562-2.71876A9.26508,9.26508,0,0,1,312,216a9.097,9.097,0,0,1,2.73438-6.01562l37.10937-32.46876c.01563-.53124.15625-1,.15625-1.51562,0-11.04688-2.09375-21.51562-5.06251-31.59375l-21.26562,21.25a8.00467,8.00467,0,0,1-11.32812-11.3125l26.42187-26.40625a111.81517,111.81517,0,0,0-46.35937-49.26562,63.02336,63.02336,0,0,1-14.0625,82.64062A55.83846,55.83846,0,0,1,251.625,254.73438l-1.42188-34.28126,12.67188,8.625a3.967,3.967,0,0,0,2.25.6875,3.98059,3.98059,0,0,0,3.43749-6.03124l-8.53124-14.3125,17.90625-3.71876a4.00647,4.00647,0,0,0,0-7.84374l-17.90625-3.71876,8.53124-14.3125a3.98059,3.98059,0,0,0-3.43749-6.03124,4.726,4.726,0,0,0-2.25.67187L248.6875,184.125,244,71.82812a4.00386,4.00386,0,0,0-8,0l-4.625,110.8125-12-8.15624a4.003,4.003,0,0,0-5.68751,5.35937l8.53126,14.3125L204.3125,197.875a3.99686,3.99686,0,0,0,0,7.82812l17.90625,3.73438-8.53126,14.29688a4.72469,4.72469,0,0,0-.56249,2.04687,4.59547,4.59547,0,0,0,1.25,2.90625,4.01059,4.01059,0,0,0,2.75,1.09375,4.09016,4.09016,0,0,0,2.25-.6875l10.35937-7.04687L228.375,254.76562a55.86414,55.86414,0,0,1-28.71875-93.45312,63.01119,63.01119,0,0,1-14.04688-82.65625,111.93158,111.93158,0,0,0-46.375,49.26563l26.42187,26.42187a7.99917,7.99917,0,0,1-11.3125,11.3125l-21.26563-21.26563C130.09375,154.48438,128,164.95312,128.01562,176.01562Z"
                }
            }
        ]
    })(props);
}
function FaKaaba(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M554.12 83.51L318.36 4.93a95.962 95.962 0 0 0-60.71 0L21.88 83.51A32.006 32.006 0 0 0 0 113.87v49.01l265.02-79.51c15.03-4.5 30.92-4.5 45.98 0l265 79.51v-49.01c0-13.77-8.81-26-21.88-30.36zm-279.9 30.52L0 196.3v228.38c0 15 10.42 27.98 25.06 31.24l242.12 53.8a95.937 95.937 0 0 0 41.65 0l242.12-53.8c14.64-3.25 25.06-16.24 25.06-31.24V196.29l-274.2-82.26c-9.04-2.72-18.59-2.72-27.59 0zM128 230.11c0 3.61-2.41 6.77-5.89 7.72l-80 21.82C37.02 261.03 32 257.2 32 251.93v-16.58c0-3.61 2.41-6.77 5.89-7.72l80-21.82c5.09-1.39 10.11 2.44 10.11 7.72v16.58zm144-39.28c0 3.61-2.41 6.77-5.89 7.72l-96 26.18c-5.09 1.39-10.11-2.44-10.11-7.72v-16.58c0-3.61 2.41-6.77 5.89-7.72l96-26.18c5.09-1.39 10.11 2.44 10.11 7.72v16.58zm176 22.7c0-5.28 5.02-9.11 10.11-7.72l80 21.82c3.48.95 5.89 4.11 5.89 7.72v16.58c0 5.28-5.02 9.11-10.11 7.72l-80-21.82a7.997 7.997 0 0 1-5.89-7.72v-16.58zm-144-39.27c0-5.28 5.02-9.11 10.11-7.72l96 26.18c3.48.95 5.89 4.11 5.89 7.72v16.58c0 5.28-5.02 9.11-10.11 7.72l-96-26.18a7.997 7.997 0 0 1-5.89-7.72v-16.58z"
                }
            }
        ]
    })(props);
}
function FaKey(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M512 176.001C512 273.203 433.202 352 336 352c-11.22 0-22.19-1.062-32.827-3.069l-24.012 27.014A23.999 23.999 0 0 1 261.223 384H224v40c0 13.255-10.745 24-24 24h-40v40c0 13.255-10.745 24-24 24H24c-13.255 0-24-10.745-24-24v-78.059c0-6.365 2.529-12.47 7.029-16.971l161.802-161.802C163.108 213.814 160 195.271 160 176 160 78.798 238.797.001 335.999 0 433.488-.001 512 78.511 512 176.001zM336 128c0 26.51 21.49 48 48 48s48-21.49 48-48-21.49-48-48-48-48 21.49-48 48z"
                }
            }
        ]
    })(props);
}
function FaKeyboard(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M528 448H48c-26.51 0-48-21.49-48-48V112c0-26.51 21.49-48 48-48h480c26.51 0 48 21.49 48 48v288c0 26.51-21.49 48-48 48zM128 180v-40c0-6.627-5.373-12-12-12H76c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm-336 96v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm-336 96v-40c0-6.627-5.373-12-12-12H76c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm288 0v-40c0-6.627-5.373-12-12-12H172c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h232c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12z"
                }
            }
        ]
    })(props);
}
function FaKhanda(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M415.81 66c-6.37-3.5-14.37-2.33-19.36 3.02a15.974 15.974 0 0 0-1.91 19.52c16.49 26.16 25.2 56.39 25.2 87.41-.19 53.25-26.77 102.69-71.27 132.41l-76.63 53.35v-20.1l44.05-36.09c3.92-4.2 5-10.09 2.81-15.28L310.85 273c33.84-19.26 56.94-55.25 56.94-96.99 0-40.79-22.02-76.13-54.59-95.71l5.22-11.44c2.34-5.53.93-11.83-3.57-16.04L255.86 0l-58.99 52.81c-4.5 4.21-5.9 10.51-3.57 16.04l5.22 11.44c-32.57 19.58-54.59 54.93-54.59 95.72 0 41.75 23.09 77.73 56.94 96.99l-7.85 17.24c-2.19 5.18-1.1 11.07 2.81 15.28l44.05 36.09v19.9l-76.59-53.33C119.02 278.62 92.44 229.19 92.26 176c0-31.08 8.71-61.31 25.2-87.47 3.87-6.16 2.4-13.77-2.59-19.08-5-5.34-13.68-6.2-20.02-2.7C16.32 109.6-22.3 205.3 13.36 295.99c7.07 17.99 17.89 34.38 30.46 49.06l55.97 65.36c4.87 5.69 13.04 7.24 19.65 3.72l79.35-42.23L228 392.23l-47.08 32.78c-1.67-.37-3.23-1.01-5.01-1.01-13.25 0-23.99 10.74-23.99 24 0 13.25 10.74 24 23.99 24 12.1 0 21.69-9.11 23.33-20.76l40.63-28.28v29.95c-9.39 5.57-15.99 15.38-15.99 27.1 0 17.67 14.32 32 31.98 32s31.98-14.33 31.98-32c0-11.71-6.61-21.52-15.99-27.1v-30.15l40.91 28.48C314.41 462.89 324 472 336.09 472c13.25 0 23.99-10.75 23.99-24 0-13.26-10.74-24-23.99-24-1.78 0-3.34.64-5.01 1.01L284 392.23l29.21-20.34 79.35 42.23c6.61 3.52 14.78 1.97 19.65-3.71l52.51-61.31c18.87-22.02 34-47.5 41.25-75.59 21.62-83.66-16.45-167.27-90.16-207.51zm-95.99 110c0 22.3-11.49 41.92-28.83 53.38l-5.65-12.41c-8.75-24.52-8.75-51.04 0-75.56l7.83-17.18c16.07 11.65 26.65 30.45 26.65 51.77zm-127.93 0c0-21.32 10.58-40.12 26.66-51.76l7.83 17.18c8.75 24.52 8.75 51.03 0 75.56l-5.65 12.41c-17.34-11.46-28.84-31.09-28.84-53.39z"
                }
            }
        ]
    })(props);
}
function FaKissBeam(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm-39 219.9l-9.5-17c-7.7-13.7-19.2-21.6-31.5-21.6s-23.8 7.9-31.5 21.6l-9.5 17c-4.2 7.4-15.6 4-14.9-4.5 3.3-42.1 32.2-71.4 56-71.4s52.7 29.3 56 71.4c.5 8.5-10.9 12-15.1 4.5zM304 396c0 19.2-28.7 41.5-71.5 44-8.5.8-12.1-11.8-3.6-15.4l17-7.2c13-5.5 20.8-13.5 20.8-21.5s-7.8-16-20.8-21.5l-17-7.2c-6-2.5-6.1-12.2 0-14.8l17-7.2c13-5.5 20.8-13.5 20.8-21.5s-7.8-16-20.8-21.5l-17-7.2c-8.6-3.6-4.8-16.5 3.6-15.4 42.8 2.5 71.5 24.8 71.5 44 0 13-13.4 27.3-35.2 36C290.6 368.7 304 383 304 396zm65-168.1l-9.5-17c-7.7-13.7-19.2-21.6-31.5-21.6s-23.8 7.9-31.5 21.6l-9.5 17c-4.1 7.3-15.6 4-14.9-4.5 3.3-42.1 32.2-71.4 56-71.4s52.7 29.3 56 71.4c.5 8.5-10.9 12-15.1 4.5z"
                }
            }
        ]
    })(props);
}
function FaKissWinkHeart(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 504 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M501.1 402.5c-8-20.8-31.5-31.5-53.1-25.9l-8.4 2.2-2.3-8.4c-5.9-21.4-27-36.5-49-33-25.2 4-40.6 28.6-34 52.6l22.9 82.6c1.5 5.3 7 8.5 12.4 7.1l83-21.5c24.1-6.3 37.7-31.8 28.5-55.7zm-177.6-4c-5.6-20.3-2.3-42 9-59.7 29.7-46.3 98.7-45.5 127.8 4.3 6.4.1 12.6 1.4 18.6 2.9 10.9-27.9 17.1-58.2 17.1-90C496 119 385 8 248 8S0 119 0 256s111 248 248 248c35.4 0 68.9-7.5 99.4-20.9-.3-.7-23.9-84.6-23.9-84.6zM168 240c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm120 156c0 19.2-28.7 41.5-71.5 44-8.5.8-12.1-11.8-3.6-15.4l17-7.2c13-5.5 20.8-13.5 20.8-21.5s-7.8-16-20.8-21.5l-17-7.2c-6-2.5-5.7-12.3 0-14.8l17-7.2c13-5.5 20.8-13.5 20.8-21.5s-7.8-16-20.8-21.5l-17-7.2c-8.8-3.7-4.6-16.6 3.6-15.4 42.8 2.5 71.5 24.8 71.5 44 0 13-13.4 27.3-35.2 36C274.6 368.7 288 383 288 396zm16-179c-8.3 7.4-21.6.4-19.8-10.8 4-25.2 34.2-42.1 59.9-42.1S400 181 404 206.2c1.7 11.1-11.3 18.3-19.8 10.8l-9.5-8.5c-14.8-13.2-46.2-13.2-61 0L304 217z"
                }
            }
        ]
    })(props);
}
function FaKiss(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm-80 232c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm136 156c0 19.2-28.7 41.5-71.5 44-8.5.8-12.1-11.8-3.6-15.4l17-7.2c13-5.5 20.8-13.5 20.8-21.5s-7.8-16-20.8-21.5l-17-7.2c-6-2.5-6.1-12.2 0-14.8l17-7.2c13-5.5 20.8-13.5 20.8-21.5s-7.8-16-20.8-21.5l-17-7.2c-8.6-3.6-4.8-16.5 3.6-15.4 42.8 2.5 71.5 24.8 71.5 44 0 13-13.4 27.3-35.2 36C290.6 368.7 304 383 304 396zm24-156c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32z"
                }
            }
        ]
    })(props);
}
function FaKiwiBird(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M575.81 217.98C572.64 157.41 518.28 112 457.63 112h-9.37c-52.82 0-104.25-16.25-147.74-46.24-41.99-28.96-96.04-41.62-153.21-28.7C129.3 41.12-.08 78.24 0 224c.04 70.95 38.68 132.8 95.99 166.01V464c0 8.84 7.16 16 16 16h16c8.84 0 16-7.16 16-16v-54.26c15.36 3.96 31.4 6.26 48 6.26 5.44 0 10.68-.73 16-1.18V464c0 8.84 7.16 16 16 16h16c8.84 0 16-7.16 16-16v-59.43c14.24-5.06 27.88-11.39 40.34-19.51C342.07 355.25 393.86 336 448.46 336c25.48 0 16.01-.31 23.05-.78l74.41 136.44c2.86 5.23 8.3 8.34 14.05 8.34 1.31 0 2.64-.16 3.95-.5 7.09-1.8 12.05-8.19 12.05-15.5 0 0 .14-240.24-.16-246.02zM463.97 248c-13.25 0-24-10.75-24-24 0-13.26 10.75-24 24-24s24 10.74 24 24c0 13.25-10.75 24-24 24zm80 153.25l-39.86-73.08c15.12-5.83 28.73-14.6 39.86-25.98v99.06z"
                }
            }
        ]
    })(props);
}
function FaLandmark(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M501.62 92.11L267.24 2.04a31.958 31.958 0 0 0-22.47 0L10.38 92.11A16.001 16.001 0 0 0 0 107.09V144c0 8.84 7.16 16 16 16h480c8.84 0 16-7.16 16-16v-36.91c0-6.67-4.14-12.64-10.38-14.98zM64 192v160H48c-8.84 0-16 7.16-16 16v48h448v-48c0-8.84-7.16-16-16-16h-16V192h-64v160h-96V192h-64v160h-96V192H64zm432 256H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h480c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16z"
                }
            }
        ]
    })(props);
}
function FaLanguage(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M152.1 236.2c-3.5-12.1-7.8-33.2-7.8-33.2h-.5s-4.3 21.1-7.8 33.2l-11.1 37.5H163zM616 96H336v320h280c13.3 0 24-10.7 24-24V120c0-13.3-10.7-24-24-24zm-24 120c0 6.6-5.4 12-12 12h-11.4c-6.9 23.6-21.7 47.4-42.7 69.9 8.4 6.4 17.1 12.5 26.1 18 5.5 3.4 7.3 10.5 4.1 16.2l-7.9 13.9c-3.4 5.9-10.9 7.8-16.7 4.3-12.6-7.8-24.5-16.1-35.4-24.9-10.9 8.7-22.7 17.1-35.4 24.9-5.8 3.5-13.3 1.6-16.7-4.3l-7.9-13.9c-3.2-5.6-1.4-12.8 4.2-16.2 9.3-5.7 18-11.7 26.1-18-7.9-8.4-14.9-17-21-25.7-4-5.7-2.2-13.6 3.7-17.1l6.5-3.9 7.3-4.3c5.4-3.2 12.4-1.7 16 3.4 5 7 10.8 14 17.4 20.9 13.5-14.2 23.8-28.9 30-43.2H412c-6.6 0-12-5.4-12-12v-16c0-6.6 5.4-12 12-12h64v-16c0-6.6 5.4-12 12-12h16c6.6 0 12 5.4 12 12v16h64c6.6 0 12 5.4 12 12zM0 120v272c0 13.3 10.7 24 24 24h280V96H24c-13.3 0-24 10.7-24 24zm58.9 216.1L116.4 167c1.7-4.9 6.2-8.1 11.4-8.1h32.5c5.1 0 9.7 3.3 11.4 8.1l57.5 169.1c2.6 7.8-3.1 15.9-11.4 15.9h-22.9a12 12 0 0 1-11.5-8.6l-9.4-31.9h-60.2l-9.1 31.8c-1.5 5.1-6.2 8.7-11.5 8.7H70.3c-8.2 0-14-8.1-11.4-15.9z"
                }
            }
        ]
    })(props);
}
function FaLaptopCode(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M255.03 261.65c6.25 6.25 16.38 6.25 22.63 0l11.31-11.31c6.25-6.25 6.25-16.38 0-22.63L253.25 192l35.71-35.72c6.25-6.25 6.25-16.38 0-22.63l-11.31-11.31c-6.25-6.25-16.38-6.25-22.63 0l-58.34 58.34c-6.25 6.25-6.25 16.38 0 22.63l58.35 58.34zm96.01-11.3l11.31 11.31c6.25 6.25 16.38 6.25 22.63 0l58.34-58.34c6.25-6.25 6.25-16.38 0-22.63l-58.34-58.34c-6.25-6.25-16.38-6.25-22.63 0l-11.31 11.31c-6.25 6.25-6.25 16.38 0 22.63L386.75 192l-35.71 35.72c-6.25 6.25-6.25 16.38 0 22.63zM624 416H381.54c-.74 19.81-14.71 32-32.74 32H288c-18.69 0-33.02-17.47-32.77-32H16c-8.8 0-16 7.2-16 16v16c0 35.2 28.8 64 64 64h512c35.2 0 64-28.8 64-64v-16c0-8.8-7.2-16-16-16zM576 48c0-26.4-21.6-48-48-48H112C85.6 0 64 21.6 64 48v336h512V48zm-64 272H128V64h384v256z"
                }
            }
        ]
    })(props);
}
function FaLaptopHouse(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M272,288H208a16,16,0,0,1-16-16V208a16,16,0,0,1,16-16h64a16,16,0,0,1,16,16v37.12C299.11,232.24,315,224,332.8,224H469.74l6.65-7.53A16.51,16.51,0,0,0,480,207a16.31,16.31,0,0,0-4.75-10.61L416,144V48a16,16,0,0,0-16-16H368a16,16,0,0,0-16,16V87.3L263.5,8.92C258,4,247.45,0,240.05,0s-17.93,4-23.47,8.92L4.78,196.42A16.15,16.15,0,0,0,0,207a16.4,16.4,0,0,0,3.55,9.39L22.34,237.7A16.22,16.22,0,0,0,33,242.48,16.51,16.51,0,0,0,42.34,239L64,219.88V384a32,32,0,0,0,32,32H272ZM629.33,448H592V288c0-17.67-12.89-32-28.8-32H332.8c-15.91,0-28.8,14.33-28.8,32V448H266.67A10.67,10.67,0,0,0,256,458.67v10.66A42.82,42.82,0,0,0,298.6,512H597.4A42.82,42.82,0,0,0,640,469.33V458.67A10.67,10.67,0,0,0,629.33,448ZM544,448H352V304H544Z"
                }
            }
        ]
    })(props);
}
function FaLaptopMedical(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M232 224h56v56a8 8 0 0 0 8 8h48a8 8 0 0 0 8-8v-56h56a8 8 0 0 0 8-8v-48a8 8 0 0 0-8-8h-56v-56a8 8 0 0 0-8-8h-48a8 8 0 0 0-8 8v56h-56a8 8 0 0 0-8 8v48a8 8 0 0 0 8 8zM576 48a48.14 48.14 0 0 0-48-48H112a48.14 48.14 0 0 0-48 48v336h512zm-64 272H128V64h384zm112 96H381.54c-.74 19.81-14.71 32-32.74 32H288c-18.69 0-33-17.47-32.77-32H16a16 16 0 0 0-16 16v16a64.19 64.19 0 0 0 64 64h512a64.19 64.19 0 0 0 64-64v-16a16 16 0 0 0-16-16z"
                }
            }
        ]
    })(props);
}
function FaLaptop(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M624 416H381.54c-.74 19.81-14.71 32-32.74 32H288c-18.69 0-33.02-17.47-32.77-32H16c-8.8 0-16 7.2-16 16v16c0 35.2 28.8 64 64 64h512c35.2 0 64-28.8 64-64v-16c0-8.8-7.2-16-16-16zM576 48c0-26.4-21.6-48-48-48H112C85.6 0 64 21.6 64 48v336h512V48zm-64 272H128V64h384v256z"
                }
            }
        ]
    })(props);
}
function FaLaughBeam(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm24 199.4c3.3-42.1 32.2-71.4 56-71.4s52.7 29.3 56 71.4c.7 8.6-10.8 11.9-14.9 4.5l-9.5-17c-7.7-13.7-19.2-21.6-31.5-21.6s-23.8 7.9-31.5 21.6l-9.5 17c-4.2 7.4-15.8 4.1-15.1-4.5zm-160 0c3.3-42.1 32.2-71.4 56-71.4s52.7 29.3 56 71.4c.7 8.6-10.8 11.9-14.9 4.5l-9.5-17c-7.7-13.7-19.2-21.6-31.5-21.6s-23.8 7.9-31.5 21.6l-9.5 17c-4.3 7.4-15.8 4-15.1-4.5zM398.9 306C390 377 329.4 432 256 432h-16c-73.4 0-134-55-142.9-126-1.2-9.5 6.3-18 15.9-18h270c9.6 0 17.1 8.4 15.9 18z"
                }
            }
        ]
    })(props);
}
function FaLaughSquint(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm33.8 161.7l80-48c11.6-6.9 24 7.7 15.4 18L343.6 180l33.6 40.3c8.7 10.4-3.9 24.8-15.4 18l-80-48c-7.7-4.7-7.7-15.9 0-20.6zm-163-30c-8.6-10.3 3.8-24.9 15.4-18l80 48c7.8 4.7 7.8 15.9 0 20.6l-80 48c-11.5 6.8-24-7.6-15.4-18l33.6-40.3-33.6-40.3zM398.9 306C390 377 329.4 432 256 432h-16c-73.4 0-134-55-142.9-126-1.2-9.5 6.3-18 15.9-18h270c9.6 0 17.1 8.4 15.9 18z"
                }
            }
        ]
    })(props);
}
function FaLaughWink(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm20.1 198.1c4-25.2 34.2-42.1 59.9-42.1s55.9 16.9 59.9 42.1c1.7 11.1-11.4 18.3-19.8 10.8l-9.5-8.5c-14.8-13.2-46.2-13.2-61 0L288 217c-8.4 7.4-21.6.3-19.9-10.9zM168 160c17.7 0 32 14.3 32 32s-14.3 32-32 32-32-14.3-32-32 14.3-32 32-32zm230.9 146C390 377 329.4 432 256 432h-16c-73.4 0-134-55-142.9-126-1.2-9.5 6.3-18 15.9-18h270c9.6 0 17.1 8.4 15.9 18z"
                }
            }
        ]
    })(props);
}
function FaLaugh(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm80 152c17.7 0 32 14.3 32 32s-14.3 32-32 32-32-14.3-32-32 14.3-32 32-32zm-160 0c17.7 0 32 14.3 32 32s-14.3 32-32 32-32-14.3-32-32 14.3-32 32-32zm88 272h-16c-73.4 0-134-55-142.9-126-1.2-9.5 6.3-18 15.9-18h270c9.6 0 17.1 8.4 15.9 18-8.9 71-69.5 126-142.9 126z"
                }
            }
        ]
    })(props);
}
function FaLayerGroup(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.41 148.02l232.94 105.67c6.8 3.09 14.49 3.09 21.29 0l232.94-105.67c16.55-7.51 16.55-32.52 0-40.03L266.65 2.31a25.607 25.607 0 0 0-21.29 0L12.41 107.98c-16.55 7.51-16.55 32.53 0 40.04zm487.18 88.28l-58.09-26.33-161.64 73.27c-7.56 3.43-15.59 5.17-23.86 5.17s-16.29-1.74-23.86-5.17L70.51 209.97l-58.1 26.33c-16.55 7.5-16.55 32.5 0 40l232.94 105.59c6.8 3.08 14.49 3.08 21.29 0L499.59 276.3c16.55-7.5 16.55-32.5 0-40zm0 127.8l-57.87-26.23-161.86 73.37c-7.56 3.43-15.59 5.17-23.86 5.17s-16.29-1.74-23.86-5.17L70.29 337.87 12.41 364.1c-16.55 7.5-16.55 32.5 0 40l232.94 105.59c6.8 3.08 14.49 3.08 21.29 0L499.59 404.1c16.55-7.5 16.55-32.5 0-40z"
                }
            }
        ]
    })(props);
}
function FaLeaf(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M546.2 9.7c-5.6-12.5-21.6-13-28.3-1.2C486.9 62.4 431.4 96 368 96h-80C182 96 96 182 96 288c0 7 .8 13.7 1.5 20.5C161.3 262.8 253.4 224 384 224c8.8 0 16 7.2 16 16s-7.2 16-16 16C132.6 256 26 410.1 2.4 468c-6.6 16.3 1.2 34.9 17.5 41.6 16.4 6.8 35-1.1 41.8-17.3 1.5-3.6 20.9-47.9 71.9-90.6 32.4 43.9 94 85.8 174.9 77.2C465.5 467.5 576 326.7 576 154.3c0-50.2-10.8-102.2-29.8-144.6z"
                }
            }
        ]
    })(props);
}
function FaLemon(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M489.038 22.963C465.944-.13 434.648-5.93 413.947 6.129c-58.906 34.312-181.25-53.077-321.073 86.746S40.441 355.041 6.129 413.945c-12.059 20.702-6.26 51.999 16.833 75.093 23.095 23.095 54.392 28.891 75.095 16.832 58.901-34.31 181.246 53.079 321.068-86.743S471.56 156.96 505.871 98.056c12.059-20.702 6.261-51.999-16.833-75.093zM243.881 95.522c-58.189 14.547-133.808 90.155-148.358 148.358-1.817 7.27-8.342 12.124-15.511 12.124-1.284 0-2.59-.156-3.893-.481-8.572-2.144-13.784-10.83-11.642-19.403C81.901 166.427 166.316 81.93 236.119 64.478c8.575-2.143 17.261 3.069 19.403 11.642s-3.069 17.259-11.641 19.402z"
                }
            }
        ]
    })(props);
}
function FaLessThanEqual(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M54.98 214.2l301.41 119.87c18.39 6.03 38.71-2.54 45.38-19.15l12.09-30.08c6.68-16.61-2.82-34.97-21.21-41l-175.44-68.05 175.56-68.09c18.29-6 27.74-24.27 21.1-40.79l-12.03-29.92c-6.64-16.53-26.86-25.06-45.15-19.06L54.98 137.89C41.21 142.41 32 154.5 32 168.07v15.96c0 13.56 9.21 25.65 22.98 30.17zM424 400H24c-13.25 0-24 10.74-24 24v48c0 13.25 10.75 24 24 24h400c13.25 0 24-10.75 24-24v-48c0-13.26-10.75-24-24-24z"
                }
            }
        ]
    })(props);
}
function FaLessThan(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M365.46 357.74L147.04 255.89l218.47-101.88c16.02-7.47 22.95-26.51 15.48-42.53l-13.52-29C360 66.46 340.96 59.53 324.94 67L18.48 209.91a32.014 32.014 0 0 0-18.48 29v34.24c0 12.44 7.21 23.75 18.48 29l306.31 142.83c16.06 7.49 35.15.54 42.64-15.52l13.56-29.08c7.49-16.06.54-35.15-15.53-42.64z"
                }
            }
        ]
    })(props);
}
function FaLevelDownAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 320 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M313.553 392.331L209.587 504.334c-9.485 10.214-25.676 10.229-35.174 0L70.438 392.331C56.232 377.031 67.062 352 88.025 352H152V80H68.024a11.996 11.996 0 0 1-8.485-3.515l-56-56C-4.021 12.926 1.333 0 12.024 0H208c13.255 0 24 10.745 24 24v328h63.966c20.878 0 31.851 24.969 17.587 40.331z"
                }
            }
        ]
    })(props);
}
function FaLevelUpAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 320 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M313.553 119.669L209.587 7.666c-9.485-10.214-25.676-10.229-35.174 0L70.438 119.669C56.232 134.969 67.062 160 88.025 160H152v272H68.024a11.996 11.996 0 0 0-8.485 3.515l-56 56C-4.021 499.074 1.333 512 12.024 512H208c13.255 0 24-10.745 24-24V160h63.966c20.878 0 31.851-24.969 17.587-40.331z"
                }
            }
        ]
    })(props);
}
function FaLifeRing(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 8C119.033 8 8 119.033 8 256s111.033 248 248 248 248-111.033 248-248S392.967 8 256 8zm173.696 119.559l-63.399 63.399c-10.987-18.559-26.67-34.252-45.255-45.255l63.399-63.399a218.396 218.396 0 0 1 45.255 45.255zM256 352c-53.019 0-96-42.981-96-96s42.981-96 96-96 96 42.981 96 96-42.981 96-96 96zM127.559 82.304l63.399 63.399c-18.559 10.987-34.252 26.67-45.255 45.255l-63.399-63.399a218.372 218.372 0 0 1 45.255-45.255zM82.304 384.441l63.399-63.399c10.987 18.559 26.67 34.252 45.255 45.255l-63.399 63.399a218.396 218.396 0 0 1-45.255-45.255zm302.137 45.255l-63.399-63.399c18.559-10.987 34.252-26.67 45.255-45.255l63.399 63.399a218.403 218.403 0 0 1-45.255 45.255z"
                }
            }
        ]
    })(props);
}
function FaLightbulb(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 352 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M96.06 454.35c.01 6.29 1.87 12.45 5.36 17.69l17.09 25.69a31.99 31.99 0 0 0 26.64 14.28h61.71a31.99 31.99 0 0 0 26.64-14.28l17.09-25.69a31.989 31.989 0 0 0 5.36-17.69l.04-38.35H96.01l.05 38.35zM0 176c0 44.37 16.45 84.85 43.56 115.78 16.52 18.85 42.36 58.23 52.21 91.45.04.26.07.52.11.78h160.24c.04-.26.07-.51.11-.78 9.85-33.22 35.69-72.6 52.21-91.45C335.55 260.85 352 220.37 352 176 352 78.61 272.91-.3 175.45 0 73.44.31 0 82.97 0 176zm176-80c-44.11 0-80 35.89-80 80 0 8.84-7.16 16-16 16s-16-7.16-16-16c0-61.76 50.24-112 112-112 8.84 0 16 7.16 16 16s-7.16 16-16 16z"
                }
            }
        ]
    })(props);
}
function FaLink(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M326.612 185.391c59.747 59.809 58.927 155.698.36 214.59-.11.12-.24.25-.36.37l-67.2 67.2c-59.27 59.27-155.699 59.262-214.96 0-59.27-59.26-59.27-155.7 0-214.96l37.106-37.106c9.84-9.84 26.786-3.3 27.294 10.606.648 17.722 3.826 35.527 9.69 52.721 1.986 5.822.567 12.262-3.783 16.612l-13.087 13.087c-28.026 28.026-28.905 73.66-1.155 101.96 28.024 28.579 74.086 28.749 102.325.51l67.2-67.19c28.191-28.191 28.073-73.757 0-101.83-3.701-3.694-7.429-6.564-10.341-8.569a16.037 16.037 0 0 1-6.947-12.606c-.396-10.567 3.348-21.456 11.698-29.806l21.054-21.055c5.521-5.521 14.182-6.199 20.584-1.731a152.482 152.482 0 0 1 20.522 17.197zM467.547 44.449c-59.261-59.262-155.69-59.27-214.96 0l-67.2 67.2c-.12.12-.25.25-.36.37-58.566 58.892-59.387 154.781.36 214.59a152.454 152.454 0 0 0 20.521 17.196c6.402 4.468 15.064 3.789 20.584-1.731l21.054-21.055c8.35-8.35 12.094-19.239 11.698-29.806a16.037 16.037 0 0 0-6.947-12.606c-2.912-2.005-6.64-4.875-10.341-8.569-28.073-28.073-28.191-73.639 0-101.83l67.2-67.19c28.239-28.239 74.3-28.069 102.325.51 27.75 28.3 26.872 73.934-1.155 101.96l-13.087 13.087c-4.35 4.35-5.769 10.79-3.783 16.612 5.864 17.194 9.042 34.999 9.69 52.721.509 13.906 17.454 20.446 27.294 10.606l37.106-37.106c59.271-59.259 59.271-155.699.001-214.959z"
                }
            }
        ]
    })(props);
}
function FaLiraSign(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M371.994 256h-48.019C317.64 256 312 260.912 312 267.246 312 368 230.179 416 144 416V256.781l134.603-29.912A12 12 0 0 0 288 215.155v-40.976c0-7.677-7.109-13.38-14.603-11.714L144 191.219V160.78l134.603-29.912A12 12 0 0 0 288 119.154V78.179c0-7.677-7.109-13.38-14.603-11.714L144 95.219V44c0-6.627-5.373-12-12-12H76c-6.627 0-12 5.373-12 12v68.997L9.397 125.131A12 12 0 0 0 0 136.845v40.976c0 7.677 7.109 13.38 14.603 11.714L64 178.558v30.439L9.397 221.131A12 12 0 0 0 0 232.845v40.976c0 7.677 7.109 13.38 14.603 11.714L64 274.558V468c0 6.627 5.373 12 12 12h79.583c134.091 0 223.255-77.834 228.408-211.592.261-6.782-5.211-12.408-11.997-12.408z"
                }
            }
        ]
    })(props);
}
function FaListAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M464 480H48c-26.51 0-48-21.49-48-48V80c0-26.51 21.49-48 48-48h416c26.51 0 48 21.49 48 48v352c0 26.51-21.49 48-48 48zM128 120c-22.091 0-40 17.909-40 40s17.909 40 40 40 40-17.909 40-40-17.909-40-40-40zm0 96c-22.091 0-40 17.909-40 40s17.909 40 40 40 40-17.909 40-40-17.909-40-40-40zm0 96c-22.091 0-40 17.909-40 40s17.909 40 40 40 40-17.909 40-40-17.909-40-40-40zm288-136v-32c0-6.627-5.373-12-12-12H204c-6.627 0-12 5.373-12 12v32c0 6.627 5.373 12 12 12h200c6.627 0 12-5.373 12-12zm0 96v-32c0-6.627-5.373-12-12-12H204c-6.627 0-12 5.373-12 12v32c0 6.627 5.373 12 12 12h200c6.627 0 12-5.373 12-12zm0 96v-32c0-6.627-5.373-12-12-12H204c-6.627 0-12 5.373-12 12v32c0 6.627 5.373 12 12 12h200c6.627 0 12-5.373 12-12z"
                }
            }
        ]
    })(props);
}
function FaListOl(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M61.77 401l17.5-20.15a19.92 19.92 0 0 0 5.07-14.19v-3.31C84.34 356 80.5 352 73 352H16a8 8 0 0 0-8 8v16a8 8 0 0 0 8 8h22.83a157.41 157.41 0 0 0-11 12.31l-5.61 7c-4 5.07-5.25 10.13-2.8 14.88l1.05 1.93c3 5.76 6.29 7.88 12.25 7.88h4.73c10.33 0 15.94 2.44 15.94 9.09 0 4.72-4.2 8.22-14.36 8.22a41.54 41.54 0 0 1-15.47-3.12c-6.49-3.88-11.74-3.5-15.6 3.12l-5.59 9.31c-3.72 6.13-3.19 11.72 2.63 15.94 7.71 4.69 20.38 9.44 37 9.44 34.16 0 48.5-22.75 48.5-44.12-.03-14.38-9.12-29.76-28.73-34.88zM496 224H176a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h320a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0-160H176a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h320a16 16 0 0 0 16-16V80a16 16 0 0 0-16-16zm0 320H176a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h320a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zM16 160h64a8 8 0 0 0 8-8v-16a8 8 0 0 0-8-8H64V40a8 8 0 0 0-8-8H32a8 8 0 0 0-7.14 4.42l-8 16A8 8 0 0 0 24 64h8v64H16a8 8 0 0 0-8 8v16a8 8 0 0 0 8 8zm-3.91 160H80a8 8 0 0 0 8-8v-16a8 8 0 0 0-8-8H41.32c3.29-10.29 48.34-18.68 48.34-56.44 0-29.06-25-39.56-44.47-39.56-21.36 0-33.8 10-40.46 18.75-4.37 5.59-3 10.84 2.8 15.37l8.58 6.88c5.61 4.56 11 2.47 16.12-2.44a13.44 13.44 0 0 1 9.46-3.84c3.33 0 9.28 1.56 9.28 8.75C51 248.19 0 257.31 0 304.59v4C0 316 5.08 320 12.09 320z"
                }
            }
        ]
    })(props);
}
function FaListUl(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M48 48a48 48 0 1 0 48 48 48 48 0 0 0-48-48zm0 160a48 48 0 1 0 48 48 48 48 0 0 0-48-48zm0 160a48 48 0 1 0 48 48 48 48 0 0 0-48-48zm448 16H176a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h320a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0-320H176a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h320a16 16 0 0 0 16-16V80a16 16 0 0 0-16-16zm0 160H176a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h320a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16z"
                }
            }
        ]
    })(props);
}
function FaList(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M80 368H16a16 16 0 0 0-16 16v64a16 16 0 0 0 16 16h64a16 16 0 0 0 16-16v-64a16 16 0 0 0-16-16zm0-320H16A16 16 0 0 0 0 64v64a16 16 0 0 0 16 16h64a16 16 0 0 0 16-16V64a16 16 0 0 0-16-16zm0 160H16a16 16 0 0 0-16 16v64a16 16 0 0 0 16 16h64a16 16 0 0 0 16-16v-64a16 16 0 0 0-16-16zm416 176H176a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h320a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0-320H176a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h320a16 16 0 0 0 16-16V80a16 16 0 0 0-16-16zm0 160H176a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h320a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16z"
                }
            }
        ]
    })(props);
}
function FaLocationArrow(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M444.52 3.52L28.74 195.42c-47.97 22.39-31.98 92.75 19.19 92.75h175.91v175.91c0 51.17 70.36 67.17 92.75 19.19l191.9-415.78c15.99-38.39-25.59-79.97-63.97-63.97z"
                }
            }
        ]
    })(props);
}
function FaLockOpen(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M423.5 0C339.5.3 272 69.5 272 153.5V224H48c-26.5 0-48 21.5-48 48v192c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V272c0-26.5-21.5-48-48-48h-48v-71.1c0-39.6 31.7-72.5 71.3-72.9 40-.4 72.7 32.1 72.7 72v80c0 13.3 10.7 24 24 24h32c13.3 0 24-10.7 24-24v-80C576 68 507.5-.3 423.5 0z"
                }
            }
        ]
    })(props);
}
function FaLock(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M400 224h-24v-72C376 68.2 307.8 0 224 0S72 68.2 72 152v72H48c-26.5 0-48 21.5-48 48v192c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V272c0-26.5-21.5-48-48-48zm-104 0H152v-72c0-39.7 32.3-72 72-72s72 32.3 72 72v72z"
                }
            }
        ]
    })(props);
}
function FaLongArrowAltDown(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 256 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M168 345.941V44c0-6.627-5.373-12-12-12h-56c-6.627 0-12 5.373-12 12v301.941H41.941c-21.382 0-32.09 25.851-16.971 40.971l86.059 86.059c9.373 9.373 24.569 9.373 33.941 0l86.059-86.059c15.119-15.119 4.411-40.971-16.971-40.971H168z"
                }
            }
        ]
    })(props);
}
function FaLongArrowAltLeft(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M134.059 296H436c6.627 0 12-5.373 12-12v-56c0-6.627-5.373-12-12-12H134.059v-46.059c0-21.382-25.851-32.09-40.971-16.971L7.029 239.029c-9.373 9.373-9.373 24.569 0 33.941l86.059 86.059c15.119 15.119 40.971 4.411 40.971-16.971V296z"
                }
            }
        ]
    })(props);
}
function FaLongArrowAltRight(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M313.941 216H12c-6.627 0-12 5.373-12 12v56c0 6.627 5.373 12 12 12h301.941v46.059c0 21.382 25.851 32.09 40.971 16.971l86.059-86.059c9.373-9.373 9.373-24.569 0-33.941l-86.059-86.059c-15.119-15.119-40.971-4.411-40.971 16.971V216z"
                }
            }
        ]
    })(props);
}
function FaLongArrowAltUp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 256 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M88 166.059V468c0 6.627 5.373 12 12 12h56c6.627 0 12-5.373 12-12V166.059h46.059c21.382 0 32.09-25.851 16.971-40.971l-86.059-86.059c-9.373-9.373-24.569-9.373-33.941 0l-86.059 86.059c-15.119 15.119-4.411 40.971 16.971 40.971H88z"
                }
            }
        ]
    })(props);
}
function FaLowVision(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M569.344 231.631C512.96 135.949 407.81 72 288 72c-28.468 0-56.102 3.619-82.451 10.409L152.778 10.24c-7.601-10.858-22.564-13.5-33.423-5.9l-13.114 9.178c-10.86 7.601-13.502 22.566-5.9 33.426l43.131 58.395C89.449 131.73 40.228 174.683 6.682 231.581c-.01.017-.023.033-.034.05-8.765 14.875-8.964 33.528 0 48.739 38.5 65.332 99.742 115.862 172.859 141.349L55.316 244.302A272.194 272.194 0 0 1 83.61 208.39l119.4 170.58h.01l40.63 58.04a330.055 330.055 0 0 0 78.94 1.17l-189.98-271.4a277.628 277.628 0 0 1 38.777-21.563l251.836 356.544c7.601 10.858 22.564 13.499 33.423 5.9l13.114-9.178c10.86-7.601 13.502-22.567 5.9-33.426l-43.12-58.377-.007-.009c57.161-27.978 104.835-72.04 136.81-126.301a47.938 47.938 0 0 0 .001-48.739zM390.026 345.94l-19.066-27.23c24.682-32.567 27.711-76.353 8.8-111.68v.03c0 23.65-19.17 42.82-42.82 42.82-23.828 0-42.82-19.349-42.82-42.82 0-23.65 19.17-42.82 42.82-42.82h.03c-24.75-13.249-53.522-15.643-79.51-7.68l-19.068-27.237C253.758 123.306 270.488 120 288 120c75.162 0 136 60.826 136 136 0 34.504-12.833 65.975-33.974 89.94z"
                }
            }
        ]
    })(props);
}
function FaLuggageCart(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M224 320h32V96h-32c-17.67 0-32 14.33-32 32v160c0 17.67 14.33 32 32 32zm352-32V128c0-17.67-14.33-32-32-32h-32v224h32c17.67 0 32-14.33 32-32zm48 96H128V16c0-8.84-7.16-16-16-16H16C7.16 0 0 7.16 0 16v32c0 8.84 7.16 16 16 16h48v368c0 8.84 7.16 16 16 16h82.94c-1.79 5.03-2.94 10.36-2.94 16 0 26.51 21.49 48 48 48s48-21.49 48-48c0-5.64-1.15-10.97-2.94-16h197.88c-1.79 5.03-2.94 10.36-2.94 16 0 26.51 21.49 48 48 48s48-21.49 48-48c0-5.64-1.15-10.97-2.94-16H624c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16zM480 96V48c0-26.51-21.49-48-48-48h-96c-26.51 0-48 21.49-48 48v272h192V96zm-48 0h-96V48h96v48z"
                }
            }
        ]
    })(props);
}
function FaLungsVirus(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M344,150.68V16A16,16,0,0,0,328,0H312a16,16,0,0,0-16,16V150.68a46.45,46.45,0,0,1,48,0ZM195.54,444.46a48.06,48.06,0,0,1,0-67.88l8.58-8.58H192a48,48,0,0,1,0-96h12.12l-8.58-8.57a48,48,0,0,1,60.46-74V161.75C256,125.38,224.62,96,186,96c-44,0-58,28.5-80.12,63.13a819.52,819.52,0,0,0-102,231A113.16,113.16,0,0,0,0,419.75C0,481,62.5,525.26,125.25,508.38l59.5-15.87a98.51,98.51,0,0,0,52.5-34.75,46.49,46.49,0,0,1-41.71-13.3Zm226.29-22.63a16,16,0,0,0,0-22.62l-8.58-8.58C393.09,370.47,407.37,336,435.88,336H448a16,16,0,0,0,0-32H435.88c-28.51,0-42.79-34.47-22.63-54.62l8.58-8.58a16,16,0,0,0-22.63-22.63l-8.57,8.58C370.47,246.91,336,232.63,336,204.12V192a16,16,0,0,0-32,0v12.12c0,28.51-34.47,42.79-54.63,22.63l-8.57-8.58a16,16,0,0,0-22.63,22.63l8.58,8.58c20.16,20.15,5.88,54.62-22.63,54.62H192a16,16,0,0,0,0,32h12.12c28.51,0,42.79,34.47,22.63,54.63l-8.58,8.58a16,16,0,1,0,22.63,22.62l8.57-8.57C269.53,393.1,304,407.38,304,435.88V448a16,16,0,0,0,32,0V435.88c0-28.5,34.47-42.78,54.63-22.62l8.57,8.57a16,16,0,0,0,22.63,0ZM288,304a16,16,0,1,1,16-16A16,16,0,0,1,288,304Zm64,64a16,16,0,1,1,16-16A16,16,0,0,1,352,368Zm284.12,22.13a819.52,819.52,0,0,0-102-231C512,124.5,498,96,454,96c-38.62,0-70,29.38-70,65.75v27.72a48,48,0,0,1,60.46,74L435.88,272H448a48,48,0,0,1,0,96H435.88l8.58,8.58a47.7,47.7,0,0,1-41.71,81.18,98.51,98.51,0,0,0,52.5,34.75l59.5,15.87C577.5,525.26,640,481,640,419.75A113.16,113.16,0,0,0,636.12,390.13Z"
                }
            }
        ]
    })(props);
}
function FaLungs(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M636.11 390.15C614.44 308.85 580.07 231 534.1 159.13 511.98 124.56 498.03 96 454.05 96 415.36 96 384 125.42 384 161.71v60.11l-32.88-21.92a15.996 15.996 0 0 1-7.12-13.31V16c0-8.84-7.16-16-16-16h-16c-8.84 0-16 7.16-16 16v170.59c0 5.35-2.67 10.34-7.12 13.31L256 221.82v-60.11C256 125.42 224.64 96 185.95 96c-43.98 0-57.93 28.56-80.05 63.13C59.93 231 25.56 308.85 3.89 390.15 1.3 399.84 0 409.79 0 419.78c0 61.23 62.48 105.44 125.24 88.62l59.5-15.95c42.18-11.3 71.26-47.47 71.26-88.62v-87.49l-85.84 57.23a7.992 7.992 0 0 1-11.09-2.22l-8.88-13.31a7.992 7.992 0 0 1 2.22-11.09L320 235.23l167.59 111.72a7.994 7.994 0 0 1 2.22 11.09l-8.88 13.31a7.994 7.994 0 0 1-11.09 2.22L384 316.34v87.49c0 41.15 29.08 77.31 71.26 88.62l59.5 15.95C577.52 525.22 640 481.01 640 419.78c0-9.99-1.3-19.94-3.89-29.63z"
                }
            }
        ]
    })(props);
}
function FaMagic(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M224 96l16-32 32-16-32-16-16-32-16 32-32 16 32 16 16 32zM80 160l26.66-53.33L160 80l-53.34-26.67L80 0 53.34 53.33 0 80l53.34 26.67L80 160zm352 128l-26.66 53.33L352 368l53.34 26.67L432 448l26.66-53.33L512 368l-53.34-26.67L432 288zm70.62-193.77L417.77 9.38C411.53 3.12 403.34 0 395.15 0c-8.19 0-16.38 3.12-22.63 9.38L9.38 372.52c-12.5 12.5-12.5 32.76 0 45.25l84.85 84.85c6.25 6.25 14.44 9.37 22.62 9.37 8.19 0 16.38-3.12 22.63-9.37l363.14-363.15c12.5-12.48 12.5-32.75 0-45.24zM359.45 203.46l-50.91-50.91 86.6-86.6 50.91 50.91-86.6 86.6z"
                }
            }
        ]
    })(props);
}
function FaMagnet(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M164.07 148.1H12a12 12 0 0 1-12-12v-80a36 36 0 0 1 36-36h104a36 36 0 0 1 36 36v80a11.89 11.89 0 0 1-11.93 12zm347.93-12V56a36 36 0 0 0-36-36H372a36 36 0 0 0-36 36v80a12 12 0 0 0 12 12h152a11.89 11.89 0 0 0 12-11.9zm-164 44a12 12 0 0 0-12 12v52c0 128.1-160 127.9-160 0v-52a12 12 0 0 0-12-12H12.1a12 12 0 0 0-12 12.1c.1 21.4.6 40.3 0 53.3 0 150.6 136.17 246.6 256.75 246.6s255-96 255-246.7c-.6-12.8-.2-33 0-53.2a12 12 0 0 0-12-12.1z"
                }
            }
        ]
    })(props);
}
function FaMailBulk(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M160 448c-25.6 0-51.2-22.4-64-32-64-44.8-83.2-60.8-96-70.4V480c0 17.67 14.33 32 32 32h256c17.67 0 32-14.33 32-32V345.6c-12.8 9.6-32 25.6-96 70.4-12.8 9.6-38.4 32-64 32zm128-192H32c-17.67 0-32 14.33-32 32v16c25.6 19.2 22.4 19.2 115.2 86.4 9.6 6.4 28.8 25.6 44.8 25.6s35.2-19.2 44.8-22.4c92.8-67.2 89.6-67.2 115.2-86.4V288c0-17.67-14.33-32-32-32zm256-96H224c-17.67 0-32 14.33-32 32v32h96c33.21 0 60.59 25.42 63.71 57.82l.29-.22V416h192c17.67 0 32-14.33 32-32V192c0-17.67-14.33-32-32-32zm-32 128h-64v-64h64v64zm-352-96c0-35.29 28.71-64 64-64h224V32c0-17.67-14.33-32-32-32H96C78.33 0 64 14.33 64 32v192h96v-32z"
                }
            }
        ]
    })(props);
}
function FaMale(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 192 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M96 0c35.346 0 64 28.654 64 64s-28.654 64-64 64-64-28.654-64-64S60.654 0 96 0m48 144h-11.36c-22.711 10.443-49.59 10.894-73.28 0H48c-26.51 0-48 21.49-48 48v136c0 13.255 10.745 24 24 24h16v136c0 13.255 10.745 24 24 24h64c13.255 0 24-10.745 24-24V352h16c13.255 0 24-10.745 24-24V192c0-26.51-21.49-48-48-48z"
                }
            }
        ]
    })(props);
}
function FaMapMarkedAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M288 0c-69.59 0-126 56.41-126 126 0 56.26 82.35 158.8 113.9 196.02 6.39 7.54 17.82 7.54 24.2 0C331.65 284.8 414 182.26 414 126 414 56.41 357.59 0 288 0zm0 168c-23.2 0-42-18.8-42-42s18.8-42 42-42 42 18.8 42 42-18.8 42-42 42zM20.12 215.95A32.006 32.006 0 0 0 0 245.66v250.32c0 11.32 11.43 19.06 21.94 14.86L160 448V214.92c-8.84-15.98-16.07-31.54-21.25-46.42L20.12 215.95zM288 359.67c-14.07 0-27.38-6.18-36.51-16.96-19.66-23.2-40.57-49.62-59.49-76.72v182l192 64V266c-18.92 27.09-39.82 53.52-59.49 76.72-9.13 10.77-22.44 16.95-36.51 16.95zm266.06-198.51L416 224v288l139.88-55.95A31.996 31.996 0 0 0 576 426.34V176.02c0-11.32-11.43-19.06-21.94-14.86z"
                }
            }
        ]
    })(props);
}
function FaMapMarked(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M288 0c-69.59 0-126 56.41-126 126 0 56.26 82.35 158.8 113.9 196.02 6.39 7.54 17.82 7.54 24.2 0C331.65 284.8 414 182.26 414 126 414 56.41 357.59 0 288 0zM20.12 215.95A32.006 32.006 0 0 0 0 245.66v250.32c0 11.32 11.43 19.06 21.94 14.86L160 448V214.92c-8.84-15.98-16.07-31.54-21.25-46.42L20.12 215.95zM288 359.67c-14.07 0-27.38-6.18-36.51-16.96-19.66-23.2-40.57-49.62-59.49-76.72v182l192 64V266c-18.92 27.09-39.82 53.52-59.49 76.72-9.13 10.77-22.44 16.95-36.51 16.95zm266.06-198.51L416 224v288l139.88-55.95A31.996 31.996 0 0 0 576 426.34V176.02c0-11.32-11.43-19.06-21.94-14.86z"
                }
            }
        ]
    })(props);
}
function FaMapMarkerAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M172.268 501.67C26.97 291.031 0 269.413 0 192 0 85.961 85.961 0 192 0s192 85.961 192 192c0 77.413-26.97 99.031-172.268 309.67-9.535 13.774-29.93 13.773-39.464 0zM192 272c44.183 0 80-35.817 80-80s-35.817-80-80-80-80 35.817-80 80 35.817 80 80 80z"
                }
            }
        ]
    })(props);
}
function FaMapMarker(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M172.268 501.67C26.97 291.031 0 269.413 0 192 0 85.961 85.961 0 192 0s192 85.961 192 192c0 77.413-26.97 99.031-172.268 309.67-9.535 13.774-29.93 13.773-39.464 0z"
                }
            }
        ]
    })(props);
}
function FaMapPin(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 288 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M112 316.94v156.69l22.02 33.02c4.75 7.12 15.22 7.12 19.97 0L176 473.63V316.94c-10.39 1.92-21.06 3.06-32 3.06s-21.61-1.14-32-3.06zM144 0C64.47 0 0 64.47 0 144s64.47 144 144 144 144-64.47 144-144S223.53 0 144 0zm0 76c-37.5 0-68 30.5-68 68 0 6.62-5.38 12-12 12s-12-5.38-12-12c0-50.73 41.28-92 92-92 6.62 0 12 5.38 12 12s-5.38 12-12 12z"
                }
            }
        ]
    })(props);
}
function FaMapSigns(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M507.31 84.69L464 41.37c-6-6-14.14-9.37-22.63-9.37H288V16c0-8.84-7.16-16-16-16h-32c-8.84 0-16 7.16-16 16v16H56c-13.25 0-24 10.75-24 24v80c0 13.25 10.75 24 24 24h385.37c8.49 0 16.62-3.37 22.63-9.37l43.31-43.31c6.25-6.26 6.25-16.38 0-22.63zM224 496c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16V384h-64v112zm232-272H288v-32h-64v32H70.63c-8.49 0-16.62 3.37-22.63 9.37L4.69 276.69c-6.25 6.25-6.25 16.38 0 22.63L48 342.63c6 6 14.14 9.37 22.63 9.37H456c13.25 0 24-10.75 24-24v-80c0-13.25-10.75-24-24-24z"
                }
            }
        ]
    })(props);
}
function FaMap(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 117.66v346.32c0 11.32 11.43 19.06 21.94 14.86L160 416V32L20.12 87.95A32.006 32.006 0 0 0 0 117.66zM192 416l192 64V96L192 32v384zM554.06 33.16L416 96v384l139.88-55.95A31.996 31.996 0 0 0 576 394.34V48.02c0-11.32-11.43-19.06-21.94-14.86z"
                }
            }
        ]
    })(props);
}
function FaMarker(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M93.95 290.03A327.038 327.038 0 0 0 .17 485.11l-.03.23c-1.7 15.28 11.21 28.2 26.49 26.51a327.02 327.02 0 0 0 195.34-93.8l75.4-75.4-128.02-128.02-75.4 75.4zM485.49 26.51c-35.35-35.35-92.67-35.35-128.02 0l-21.76 21.76-36.56-36.55c-15.62-15.62-40.95-15.62-56.56 0L138.47 115.84c-6.25 6.25-6.25 16.38 0 22.63l22.62 22.62c6.25 6.25 16.38 6.25 22.63 0l87.15-87.15 19.59 19.59L191.98 192 320 320.02l165.49-165.49c35.35-35.35 35.35-92.66 0-128.02z"
                }
            }
        ]
    })(props);
}
function FaMarsDouble(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M340 0h-79c-10.7 0-16 12.9-8.5 20.5l16.9 16.9-48.7 48.7C198.5 72.1 172.2 64 144 64 64.5 64 0 128.5 0 208s64.5 144 144 144 144-64.5 144-144c0-28.2-8.1-54.5-22.1-76.7l48.7-48.7 16.9 16.9c2.4 2.4 5.5 3.5 8.4 3.5 6.2 0 12.1-4.8 12.1-12V12c0-6.6-5.4-12-12-12zM144 288c-44.1 0-80-35.9-80-80s35.9-80 80-80 80 35.9 80 80-35.9 80-80 80zm356-128.1h-79c-10.7 0-16 12.9-8.5 20.5l16.9 16.9-48.7 48.7c-18.2-11.4-39-18.9-61.5-21.3-2.1 21.8-8.2 43.3-18.4 63.3 1.1 0 2.2-.1 3.2-.1 44.1 0 80 35.9 80 80s-35.9 80-80 80-80-35.9-80-80c0-1.1 0-2.2.1-3.2-20 10.2-41.5 16.4-63.3 18.4C168.4 455.6 229.6 512 304 512c79.5 0 144-64.5 144-144 0-28.2-8.1-54.5-22.1-76.7l48.7-48.7 16.9 16.9c2.4 2.4 5.4 3.5 8.4 3.5 6.2 0 12.1-4.8 12.1-12v-79c0-6.7-5.4-12.1-12-12.1z"
                }
            }
        ]
    })(props);
}
function FaMarsStrokeH(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 480 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M476.2 247.5l-55.9-55.9c-7.6-7.6-20.5-2.2-20.5 8.5V224H376v-20c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v20h-27.6c-5.8-25.6-18.7-49.9-38.6-69.8C189.6 98 98.4 98 42.2 154.2c-56.2 56.2-56.2 147.4 0 203.6 56.2 56.2 147.4 56.2 203.6 0 19.9-19.9 32.8-44.2 38.6-69.8H312v20c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12v-20h23.9v23.9c0 10.7 12.9 16 20.5 8.5l55.9-55.9c4.6-4.7 4.6-12.3-.1-17zm-275.6 65.1c-31.2 31.2-81.9 31.2-113.1 0-31.2-31.2-31.2-81.9 0-113.1 31.2-31.2 81.9-31.2 113.1 0 31.2 31.1 31.2 81.9 0 113.1z"
                }
            }
        ]
    })(props);
}
function FaMarsStrokeV(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 288 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M245.8 234.2c-19.9-19.9-44.2-32.8-69.8-38.6v-25.4h20c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12h-20V81.4h23.9c10.7 0 16-12.9 8.5-20.5L152.5 5.1c-4.7-4.7-12.3-4.7-17 0L79.6 61c-7.6 7.6-2.2 20.5 8.5 20.5H112v24.7H92c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h20v25.4c-25.6 5.8-49.9 18.7-69.8 38.6-56.2 56.2-56.2 147.4 0 203.6 56.2 56.2 147.4 56.2 203.6 0 56.3-56.2 56.3-147.4 0-203.6zm-45.2 158.4c-31.2 31.2-81.9 31.2-113.1 0-31.2-31.2-31.2-81.9 0-113.1 31.2-31.2 81.9-31.2 113.1 0 31.2 31.1 31.2 81.9 0 113.1z"
                }
            }
        ]
    })(props);
}
function FaMarsStroke(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M372 64h-79c-10.7 0-16 12.9-8.5 20.5l16.9 16.9-17.5 17.5-14.1-14.1c-4.7-4.7-12.3-4.7-17 0L224.5 133c-4.7 4.7-4.7 12.3 0 17l14.1 14.1-18 18c-22.2-14-48.5-22.1-76.7-22.1C64.5 160 0 224.5 0 304s64.5 144 144 144 144-64.5 144-144c0-28.2-8.1-54.5-22.1-76.7l18-18 14.1 14.1c4.7 4.7 12.3 4.7 17 0l28.3-28.3c4.7-4.7 4.7-12.3 0-17L329.2 164l17.5-17.5 16.9 16.9c7.6 7.6 20.5 2.2 20.5-8.5V76c-.1-6.6-5.5-12-12.1-12zM144 384c-44.1 0-80-35.9-80-80s35.9-80 80-80 80 35.9 80 80-35.9 80-80 80z"
                }
            }
        ]
    })(props);
}
function FaMars(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M372 64h-79c-10.7 0-16 12.9-8.5 20.5l16.9 16.9-80.7 80.7c-22.2-14-48.5-22.1-76.7-22.1C64.5 160 0 224.5 0 304s64.5 144 144 144 144-64.5 144-144c0-28.2-8.1-54.5-22.1-76.7l80.7-80.7 16.9 16.9c7.6 7.6 20.5 2.2 20.5-8.5V76c0-6.6-5.4-12-12-12zM144 384c-44.1 0-80-35.9-80-80s35.9-80 80-80 80 35.9 80 80-35.9 80-80 80z"
                }
            }
        ]
    })(props);
}
function FaMask(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M320.67 64c-442.6 0-357.57 384-158.46 384 39.9 0 77.47-20.69 101.42-55.86l25.73-37.79c15.66-22.99 46.97-22.99 62.63 0l25.73 37.79C401.66 427.31 439.23 448 479.13 448c189.86 0 290.63-384-158.46-384zM184 308.36c-41.06 0-67.76-25.66-80.08-41.05-5.23-6.53-5.23-16.09 0-22.63 12.32-15.4 39.01-41.05 80.08-41.05s67.76 25.66 80.08 41.05c5.23 6.53 5.23 16.09 0 22.63-12.32 15.4-39.02 41.05-80.08 41.05zm272 0c-41.06 0-67.76-25.66-80.08-41.05-5.23-6.53-5.23-16.09 0-22.63 12.32-15.4 39.01-41.05 80.08-41.05s67.76 25.66 80.08 41.05c5.23 6.53 5.23 16.09 0 22.63-12.32 15.4-39.02 41.05-80.08 41.05z"
                }
            }
        ]
    })(props);
}
function FaMedal(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M223.75 130.75L154.62 15.54A31.997 31.997 0 0 0 127.18 0H16.03C3.08 0-4.5 14.57 2.92 25.18l111.27 158.96c29.72-27.77 67.52-46.83 109.56-53.39zM495.97 0H384.82c-11.24 0-21.66 5.9-27.44 15.54l-69.13 115.21c42.04 6.56 79.84 25.62 109.56 53.38L509.08 25.18C516.5 14.57 508.92 0 495.97 0zM256 160c-97.2 0-176 78.8-176 176s78.8 176 176 176 176-78.8 176-176-78.8-176-176-176zm92.52 157.26l-37.93 36.96 8.97 52.22c1.6 9.36-8.26 16.51-16.65 12.09L256 393.88l-46.9 24.65c-8.4 4.45-18.25-2.74-16.65-12.09l8.97-52.22-37.93-36.96c-6.82-6.64-3.05-18.23 6.35-19.59l52.43-7.64 23.43-47.52c2.11-4.28 6.19-6.39 10.28-6.39 4.11 0 8.22 2.14 10.33 6.39l23.43 47.52 52.43 7.64c9.4 1.36 13.17 12.95 6.35 19.59z"
                }
            }
        ]
    })(props);
}
function FaMedkit(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M96 480h320V128h-32V80c0-26.51-21.49-48-48-48H176c-26.51 0-48 21.49-48 48v48H96v352zm96-384h128v32H192V96zm320 80v256c0 26.51-21.49 48-48 48h-16V128h16c26.51 0 48 21.49 48 48zM64 480H48c-26.51 0-48-21.49-48-48V176c0-26.51 21.49-48 48-48h16v352zm288-208v32c0 8.837-7.163 16-16 16h-48v48c0 8.837-7.163 16-16 16h-32c-8.837 0-16-7.163-16-16v-48h-48c-8.837 0-16-7.163-16-16v-32c0-8.837 7.163-16 16-16h48v-48c0-8.837 7.163-16 16-16h32c8.837 0 16 7.163 16 16v48h48c8.837 0 16 7.163 16 16z"
                }
            }
        ]
    })(props);
}
function FaMehBlank(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm-80 232c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm160 0c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32z"
                }
            }
        ]
    })(props);
}
function FaMehRollingEyes(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zM88 224c0-24.3 13.7-45.2 33.6-56-.7 2.6-1.6 5.2-1.6 8 0 17.7 14.3 32 32 32s32-14.3 32-32c0-2.8-.9-5.4-1.6-8 19.9 10.8 33.6 31.7 33.6 56 0 35.3-28.7 64-64 64s-64-28.7-64-64zm224 176H184c-21.2 0-21.2-32 0-32h128c21.2 0 21.2 32 0 32zm32-112c-35.3 0-64-28.7-64-64 0-24.3 13.7-45.2 33.6-56-.7 2.6-1.6 5.2-1.6 8 0 17.7 14.3 32 32 32s32-14.3 32-32c0-2.8-.9-5.4-1.6-8 19.9 10.8 33.6 31.7 33.6 56 0 35.3-28.7 64-64 64z"
                }
            }
        ]
    })(props);
}
function FaMeh(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm-80 168c17.7 0 32 14.3 32 32s-14.3 32-32 32-32-14.3-32-32 14.3-32 32-32zm176 192H152c-21.2 0-21.2-32 0-32h192c21.2 0 21.2 32 0 32zm-16-128c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32z"
                }
            }
        ]
    })(props);
}
function FaMemory(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M640 130.94V96c0-17.67-14.33-32-32-32H32C14.33 64 0 78.33 0 96v34.94c18.6 6.61 32 24.19 32 45.06s-13.4 38.45-32 45.06V320h640v-98.94c-18.6-6.61-32-24.19-32-45.06s13.4-38.45 32-45.06zM224 256h-64V128h64v128zm128 0h-64V128h64v128zm128 0h-64V128h64v128zM0 448h64v-26.67c0-8.84 7.16-16 16-16s16 7.16 16 16V448h128v-26.67c0-8.84 7.16-16 16-16s16 7.16 16 16V448h128v-26.67c0-8.84 7.16-16 16-16s16 7.16 16 16V448h128v-26.67c0-8.84 7.16-16 16-16s16 7.16 16 16V448h64v-96H0v96z"
                }
            }
        ]
    })(props);
}
function FaMenorah(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M144 128h-32c-8.84 0-16 7.16-16 16v144h64V144c0-8.84-7.16-16-16-16zm96 0h-32c-8.84 0-16 7.16-16 16v144h64V144c0-8.84-7.16-16-16-16zm192 0h-32c-8.84 0-16 7.16-16 16v144h64V144c0-8.84-7.16-16-16-16zm96 0h-32c-8.84 0-16 7.16-16 16v144h64V144c0-8.84-7.16-16-16-16zm80-32c17.67 0 32-14.33 32-32S608 0 608 0s-32 46.33-32 64 14.33 32 32 32zm-96 0c17.67 0 32-14.33 32-32S512 0 512 0s-32 46.33-32 64 14.33 32 32 32zm-96 0c17.67 0 32-14.33 32-32S416 0 416 0s-32 46.33-32 64 14.33 32 32 32zm-96 0c17.67 0 32-14.33 32-32S320 0 320 0s-32 46.33-32 64 14.33 32 32 32zm-96 0c17.67 0 32-14.33 32-32S224 0 224 0s-32 46.33-32 64 14.33 32 32 32zm-96 0c17.67 0 32-14.33 32-32S128 0 128 0 96 46.33 96 64s14.33 32 32 32zm-96 0c17.67 0 32-14.33 32-32S32 0 32 0 0 46.33 0 64s14.33 32 32 32zm544 192c0 17.67-14.33 32-32 32H352V144c0-8.84-7.16-16-16-16h-32c-8.84 0-16 7.16-16 16v176H96c-17.67 0-32-14.33-32-32V144c0-8.84-7.16-16-16-16H16c-8.84 0-16 7.16-16 16v144c0 53.02 42.98 96 96 96h192v64H112c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h416c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16H352v-64h192c53.02 0 96-42.98 96-96V144c0-8.84-7.16-16-16-16h-32c-8.84 0-16 7.16-16 16v144z"
                }
            }
        ]
    })(props);
}
function FaMercury(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 288 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M288 208c0-44.2-19.9-83.7-51.2-110.1 2.5-1.8 4.9-3.8 7.2-5.8 24.7-21.2 39.8-48.8 43.2-78.8.9-7.1-4.7-13.3-11.9-13.3h-40.5C229 0 224.1 4.1 223 9.8c-2.4 12.5-9.6 24.3-20.7 33.8C187 56.8 166.3 64 144 64s-43-7.2-58.4-20.4C74.5 34.1 67.4 22.3 64.9 9.8 63.8 4.1 58.9 0 53.2 0H12.7C5.5 0-.1 6.2.8 13.3 4.2 43.4 19.2 71 44 92.2c2.3 2 4.7 3.9 7.2 5.8C19.9 124.3 0 163.8 0 208c0 68.5 47.9 125.9 112 140.4V400H76c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h36v36c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12v-36h36c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12h-36v-51.6c64.1-14.5 112-71.9 112-140.4zm-224 0c0-44.1 35.9-80 80-80s80 35.9 80 80-35.9 80-80 80-80-35.9-80-80z"
                }
            }
        ]
    })(props);
}
function FaMeteor(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M511.328,20.8027c-11.60759,38.70264-34.30724,111.70173-61.30311,187.70077,6.99893,2.09372,13.4042,4,18.60653,5.59368a16.06158,16.06158,0,0,1,9.49854,22.906c-22.106,42.29635-82.69047,152.795-142.47819,214.40356-.99984,1.09373-1.99969,2.5-2.99954,3.49995A194.83046,194.83046,0,1,1,57.085,179.41009c.99985-1,2.40588-2,3.49947-3,61.59994-59.90549,171.97367-120.40473,214.37343-142.4982a16.058,16.058,0,0,1,22.90274,9.49988c1.59351,5.09368,3.49947,11.5936,5.5929,18.59351C379.34818,35.00565,452.43074,12.30281,491.12794.70921A16.18325,16.18325,0,0,1,511.328,20.8027ZM319.951,320.00207A127.98041,127.98041,0,1,0,191.97061,448.00046,127.97573,127.97573,0,0,0,319.951,320.00207Zm-127.98041-31.9996a31.9951,31.9951,0,1,1-31.9951-31.9996A31.959,31.959,0,0,1,191.97061,288.00247Zm31.9951,79.999a15.99755,15.99755,0,1,1-15.99755-15.9998A16.04975,16.04975,0,0,1,223.96571,368.00147Z"
                }
            }
        ]
    })(props);
}
function FaMicrochip(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M416 48v416c0 26.51-21.49 48-48 48H144c-26.51 0-48-21.49-48-48V48c0-26.51 21.49-48 48-48h224c26.51 0 48 21.49 48 48zm96 58v12a6 6 0 0 1-6 6h-18v6a6 6 0 0 1-6 6h-42V88h42a6 6 0 0 1 6 6v6h18a6 6 0 0 1 6 6zm0 96v12a6 6 0 0 1-6 6h-18v6a6 6 0 0 1-6 6h-42v-48h42a6 6 0 0 1 6 6v6h18a6 6 0 0 1 6 6zm0 96v12a6 6 0 0 1-6 6h-18v6a6 6 0 0 1-6 6h-42v-48h42a6 6 0 0 1 6 6v6h18a6 6 0 0 1 6 6zm0 96v12a6 6 0 0 1-6 6h-18v6a6 6 0 0 1-6 6h-42v-48h42a6 6 0 0 1 6 6v6h18a6 6 0 0 1 6 6zM30 376h42v48H30a6 6 0 0 1-6-6v-6H6a6 6 0 0 1-6-6v-12a6 6 0 0 1 6-6h18v-6a6 6 0 0 1 6-6zm0-96h42v48H30a6 6 0 0 1-6-6v-6H6a6 6 0 0 1-6-6v-12a6 6 0 0 1 6-6h18v-6a6 6 0 0 1 6-6zm0-96h42v48H30a6 6 0 0 1-6-6v-6H6a6 6 0 0 1-6-6v-12a6 6 0 0 1 6-6h18v-6a6 6 0 0 1 6-6zm0-96h42v48H30a6 6 0 0 1-6-6v-6H6a6 6 0 0 1-6-6v-12a6 6 0 0 1 6-6h18v-6a6 6 0 0 1 6-6z"
                }
            }
        ]
    })(props);
}
function FaMicrophoneAltSlash(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M633.82 458.1L476.26 336.33C488.74 312.21 496 284.98 496 256v-48c0-8.84-7.16-16-16-16h-16c-8.84 0-16 7.16-16 16v48c0 17.92-3.96 34.8-10.72 50.2l-26.55-20.52c3.1-9.4 5.28-19.22 5.28-29.67h-43.67l-41.4-32H416v-32h-85.33c-5.89 0-10.67-3.58-10.67-8v-16c0-4.42 4.78-8 10.67-8H416v-32h-85.33c-5.89 0-10.67-3.58-10.67-8v-16c0-4.42 4.78-8 10.67-8H416c0-53.02-42.98-96-96-96s-96 42.98-96 96v45.36L45.47 3.37C38.49-2.05 28.43-.8 23.01 6.18L3.37 31.45C-2.05 38.42-.8 48.47 6.18 53.9l588.36 454.73c6.98 5.43 17.03 4.17 22.46-2.81l19.64-25.27c5.41-6.97 4.16-17.02-2.82-22.45zM400 464h-56v-33.78c11.71-1.62 23.1-4.28 33.96-8.08l-50.4-38.96c-6.71.4-13.41.87-20.35.2-55.85-5.45-98.74-48.63-111.18-101.85L144 241.31v6.85c0 89.64 63.97 169.55 152 181.69V464h-56c-8.84 0-16 7.16-16 16v16c0 8.84 7.16 16 16 16h160c8.84 0 16-7.16 16-16v-16c0-8.84-7.16-16-16-16z"
                }
            }
        ]
    })(props);
}
function FaMicrophoneAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 352 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M336 192h-16c-8.84 0-16 7.16-16 16v48c0 74.8-64.49 134.82-140.79 127.38C96.71 376.89 48 317.11 48 250.3V208c0-8.84-7.16-16-16-16H16c-8.84 0-16 7.16-16 16v40.16c0 89.64 63.97 169.55 152 181.69V464H96c-8.84 0-16 7.16-16 16v16c0 8.84 7.16 16 16 16h160c8.84 0 16-7.16 16-16v-16c0-8.84-7.16-16-16-16h-56v-33.77C285.71 418.47 352 344.9 352 256v-48c0-8.84-7.16-16-16-16zM176 352c53.02 0 96-42.98 96-96h-85.33c-5.89 0-10.67-3.58-10.67-8v-16c0-4.42 4.78-8 10.67-8H272v-32h-85.33c-5.89 0-10.67-3.58-10.67-8v-16c0-4.42 4.78-8 10.67-8H272v-32h-85.33c-5.89 0-10.67-3.58-10.67-8v-16c0-4.42 4.78-8 10.67-8H272c0-53.02-42.98-96-96-96S80 42.98 80 96v160c0 53.02 42.98 96 96 96z"
                }
            }
        ]
    })(props);
}
function FaMicrophoneSlash(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M633.82 458.1l-157.8-121.96C488.61 312.13 496 285.01 496 256v-48c0-8.84-7.16-16-16-16h-16c-8.84 0-16 7.16-16 16v48c0 17.92-3.96 34.8-10.72 50.2l-26.55-20.52c3.1-9.4 5.28-19.22 5.28-29.67V96c0-53.02-42.98-96-96-96s-96 42.98-96 96v45.36L45.47 3.37C38.49-2.05 28.43-.8 23.01 6.18L3.37 31.45C-2.05 38.42-.8 48.47 6.18 53.9l588.36 454.73c6.98 5.43 17.03 4.17 22.46-2.81l19.64-25.27c5.41-6.97 4.16-17.02-2.82-22.45zM400 464h-56v-33.77c11.66-1.6 22.85-4.54 33.67-8.31l-50.11-38.73c-6.71.4-13.41.87-20.35.2-55.85-5.45-98.74-48.63-111.18-101.85L144 241.31v6.85c0 89.64 63.97 169.55 152 181.69V464h-56c-8.84 0-16 7.16-16 16v16c0 8.84 7.16 16 16 16h160c8.84 0 16-7.16 16-16v-16c0-8.84-7.16-16-16-16z"
                }
            }
        ]
    })(props);
}
function FaMicrophone(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 352 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M176 352c53.02 0 96-42.98 96-96V96c0-53.02-42.98-96-96-96S80 42.98 80 96v160c0 53.02 42.98 96 96 96zm160-160h-16c-8.84 0-16 7.16-16 16v48c0 74.8-64.49 134.82-140.79 127.38C96.71 376.89 48 317.11 48 250.3V208c0-8.84-7.16-16-16-16H16c-8.84 0-16 7.16-16 16v40.16c0 89.64 63.97 169.55 152 181.69V464H96c-8.84 0-16 7.16-16 16v16c0 8.84 7.16 16 16 16h160c8.84 0 16-7.16 16-16v-16c0-8.84-7.16-16-16-16h-56v-33.77C285.71 418.47 352 344.9 352 256v-48c0-8.84-7.16-16-16-16z"
                }
            }
        ]
    })(props);
}
function FaMicroscope(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M160 320h12v16c0 8.84 7.16 16 16 16h40c8.84 0 16-7.16 16-16v-16h12c17.67 0 32-14.33 32-32V64c0-17.67-14.33-32-32-32V16c0-8.84-7.16-16-16-16h-64c-8.84 0-16 7.16-16 16v16c-17.67 0-32 14.33-32 32v224c0 17.67 14.33 32 32 32zm304 128h-1.29C493.24 413.99 512 369.2 512 320c0-105.88-86.12-192-192-192v64c70.58 0 128 57.42 128 128s-57.42 128-128 128H48c-26.51 0-48 21.49-48 48 0 8.84 7.16 16 16 16h480c8.84 0 16-7.16 16-16 0-26.51-21.49-48-48-48zm-360-32h208c4.42 0 8-3.58 8-8v-16c0-4.42-3.58-8-8-8H104c-4.42 0-8 3.58-8 8v16c0 4.42 3.58 8 8 8z"
                }
            }
        ]
    })(props);
}
function FaMinusCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zM124 296c-6.6 0-12-5.4-12-12v-56c0-6.6 5.4-12 12-12h264c6.6 0 12 5.4 12 12v56c0 6.6-5.4 12-12 12H124z"
                }
            }
        ]
    })(props);
}
function FaMinusSquare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zM92 296c-6.6 0-12-5.4-12-12v-56c0-6.6 5.4-12 12-12h264c6.6 0 12 5.4 12 12v56c0 6.6-5.4 12-12 12H92z"
                }
            }
        ]
    })(props);
}
function FaMinus(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M416 208H32c-17.67 0-32 14.33-32 32v32c0 17.67 14.33 32 32 32h384c17.67 0 32-14.33 32-32v-32c0-17.67-14.33-32-32-32z"
                }
            }
        ]
    })(props);
}
function FaMitten(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M368 416H48c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16h320c8.8 0 16-7.2 16-16v-64c0-8.8-7.2-16-16-16zm57-209.1c-27.2-22.6-67.5-19-90.1 8.2l-20.9 25-29.6-128.4c-18-77.5-95.4-125.9-172.8-108C34.2 21.6-14.2 98.9 3.7 176.4L51.6 384h309l72.5-87c22.7-27.2 19-67.5-8.1-90.1z"
                }
            }
        ]
    })(props);
}
function FaMobileAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 320 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M272 0H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h224c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48zM160 480c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm112-108c0 6.6-5.4 12-12 12H60c-6.6 0-12-5.4-12-12V60c0-6.6 5.4-12 12-12h200c6.6 0 12 5.4 12 12v312z"
                }
            }
        ]
    })(props);
}
function FaMobile(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 320 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M272 0H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h224c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48zM160 480c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32z"
                }
            }
        ]
    })(props);
}
function FaMoneyBillAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M352 288h-16v-88c0-4.42-3.58-8-8-8h-13.58c-4.74 0-9.37 1.4-13.31 4.03l-15.33 10.22a7.994 7.994 0 0 0-2.22 11.09l8.88 13.31a7.994 7.994 0 0 0 11.09 2.22l.47-.31V288h-16c-4.42 0-8 3.58-8 8v16c0 4.42 3.58 8 8 8h64c4.42 0 8-3.58 8-8v-16c0-4.42-3.58-8-8-8zM608 64H32C14.33 64 0 78.33 0 96v320c0 17.67 14.33 32 32 32h576c17.67 0 32-14.33 32-32V96c0-17.67-14.33-32-32-32zM48 400v-64c35.35 0 64 28.65 64 64H48zm0-224v-64h64c0 35.35-28.65 64-64 64zm272 192c-53.02 0-96-50.15-96-112 0-61.86 42.98-112 96-112s96 50.14 96 112c0 61.87-43 112-96 112zm272 32h-64c0-35.35 28.65-64 64-64v64zm0-224c-35.35 0-64-28.65-64-64h64v64z"
                }
            }
        ]
    })(props);
}
function FaMoneyBillWaveAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M621.16 54.46C582.37 38.19 543.55 32 504.75 32c-123.17-.01-246.33 62.34-369.5 62.34-30.89 0-61.76-3.92-92.65-13.72-3.47-1.1-6.95-1.62-10.35-1.62C15.04 79 0 92.32 0 110.81v317.26c0 12.63 7.23 24.6 18.84 29.46C57.63 473.81 96.45 480 135.25 480c123.17 0 246.34-62.35 369.51-62.35 30.89 0 61.76 3.92 92.65 13.72 3.47 1.1 6.95 1.62 10.35 1.62 17.21 0 32.25-13.32 32.25-31.81V83.93c-.01-12.64-7.24-24.6-18.85-29.47zM320 352c-44.19 0-80-42.99-80-96 0-53.02 35.82-96 80-96s80 42.98 80 96c0 53.03-35.83 96-80 96z"
                }
            }
        ]
    })(props);
}
function FaMoneyBillWave(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M621.16 54.46C582.37 38.19 543.55 32 504.75 32c-123.17-.01-246.33 62.34-369.5 62.34-30.89 0-61.76-3.92-92.65-13.72-3.47-1.1-6.95-1.62-10.35-1.62C15.04 79 0 92.32 0 110.81v317.26c0 12.63 7.23 24.6 18.84 29.46C57.63 473.81 96.45 480 135.25 480c123.17 0 246.34-62.35 369.51-62.35 30.89 0 61.76 3.92 92.65 13.72 3.47 1.1 6.95 1.62 10.35 1.62 17.21 0 32.25-13.32 32.25-31.81V83.93c-.01-12.64-7.24-24.6-18.85-29.47zM48 132.22c20.12 5.04 41.12 7.57 62.72 8.93C104.84 170.54 79 192.69 48 192.69v-60.47zm0 285v-47.78c34.37 0 62.18 27.27 63.71 61.4-22.53-1.81-43.59-6.31-63.71-13.62zM320 352c-44.19 0-80-42.99-80-96 0-53.02 35.82-96 80-96s80 42.98 80 96c0 53.03-35.83 96-80 96zm272 27.78c-17.52-4.39-35.71-6.85-54.32-8.44 5.87-26.08 27.5-45.88 54.32-49.28v57.72zm0-236.11c-30.89-3.91-54.86-29.7-55.81-61.55 19.54 2.17 38.09 6.23 55.81 12.66v48.89z"
                }
            }
        ]
    })(props);
}
function FaMoneyBill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M608 64H32C14.33 64 0 78.33 0 96v320c0 17.67 14.33 32 32 32h576c17.67 0 32-14.33 32-32V96c0-17.67-14.33-32-32-32zM48 400v-64c35.35 0 64 28.65 64 64H48zm0-224v-64h64c0 35.35-28.65 64-64 64zm272 176c-44.19 0-80-42.99-80-96 0-53.02 35.82-96 80-96s80 42.98 80 96c0 53.03-35.83 96-80 96zm272 48h-64c0-35.35 28.65-64 64-64v64zm0-224c-35.35 0-64-28.65-64-64h64v64z"
                }
            }
        ]
    })(props);
}
function FaMoneyCheckAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M608 32H32C14.33 32 0 46.33 0 64v384c0 17.67 14.33 32 32 32h576c17.67 0 32-14.33 32-32V64c0-17.67-14.33-32-32-32zM176 327.88V344c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8v-16.29c-11.29-.58-22.27-4.52-31.37-11.35-3.9-2.93-4.1-8.77-.57-12.14l11.75-11.21c2.77-2.64 6.89-2.76 10.13-.73 3.87 2.42 8.26 3.72 12.82 3.72h28.11c6.5 0 11.8-5.92 11.8-13.19 0-5.95-3.61-11.19-8.77-12.73l-45-13.5c-18.59-5.58-31.58-23.42-31.58-43.39 0-24.52 19.05-44.44 42.67-45.07V152c0-4.42 3.58-8 8-8h16c4.42 0 8 3.58 8 8v16.29c11.29.58 22.27 4.51 31.37 11.35 3.9 2.93 4.1 8.77.57 12.14l-11.75 11.21c-2.77 2.64-6.89 2.76-10.13.73-3.87-2.43-8.26-3.72-12.82-3.72h-28.11c-6.5 0-11.8 5.92-11.8 13.19 0 5.95 3.61 11.19 8.77 12.73l45 13.5c18.59 5.58 31.58 23.42 31.58 43.39 0 24.53-19.05 44.44-42.67 45.07zM416 312c0 4.42-3.58 8-8 8H296c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h112c4.42 0 8 3.58 8 8v16zm160 0c0 4.42-3.58 8-8 8h-80c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h80c4.42 0 8 3.58 8 8v16zm0-96c0 4.42-3.58 8-8 8H296c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h272c4.42 0 8 3.58 8 8v16z"
                }
            }
        ]
    })(props);
}
function FaMoneyCheck(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 448c0 17.67 14.33 32 32 32h576c17.67 0 32-14.33 32-32V128H0v320zm448-208c0-8.84 7.16-16 16-16h96c8.84 0 16 7.16 16 16v32c0 8.84-7.16 16-16 16h-96c-8.84 0-16-7.16-16-16v-32zm0 120c0-4.42 3.58-8 8-8h112c4.42 0 8 3.58 8 8v16c0 4.42-3.58 8-8 8H456c-4.42 0-8-3.58-8-8v-16zM64 264c0-4.42 3.58-8 8-8h304c4.42 0 8 3.58 8 8v16c0 4.42-3.58 8-8 8H72c-4.42 0-8-3.58-8-8v-16zm0 96c0-4.42 3.58-8 8-8h176c4.42 0 8 3.58 8 8v16c0 4.42-3.58 8-8 8H72c-4.42 0-8-3.58-8-8v-16zM624 32H16C7.16 32 0 39.16 0 48v48h640V48c0-8.84-7.16-16-16-16z"
                }
            }
        ]
    })(props);
}
function FaMonument(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M368 448H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h352c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16zm-78.86-347.26a31.97 31.97 0 0 0-9.21-19.44L203.31 4.69c-6.25-6.25-16.38-6.25-22.63 0l-76.6 76.61a31.97 31.97 0 0 0-9.21 19.44L64 416h256l-30.86-315.26zM240 307.2c0 6.4-6.4 12.8-12.8 12.8h-70.4c-6.4 0-12.8-6.4-12.8-12.8v-38.4c0-6.4 6.4-12.8 12.8-12.8h70.4c6.4 0 12.8 6.4 12.8 12.8v38.4z"
                }
            }
        ]
    })(props);
}
function FaMoon(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M283.211 512c78.962 0 151.079-35.925 198.857-94.792 7.068-8.708-.639-21.43-11.562-19.35-124.203 23.654-238.262-71.576-238.262-196.954 0-72.222 38.662-138.635 101.498-174.394 9.686-5.512 7.25-20.197-3.756-22.23A258.156 258.156 0 0 0 283.211 0c-141.309 0-256 114.511-256 256 0 141.309 114.511 256 256 256z"
                }
            }
        ]
    })(props);
}
function FaMortarPestle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M501.54 60.91c17.22-17.22 12.51-46.25-9.27-57.14a35.696 35.696 0 0 0-37.37 3.37L251.09 160h151.37l99.08-99.09zM496 192H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h16c0 80.98 50.2 150.11 121.13 178.32-12.76 16.87-21.72 36.8-24.95 58.69-1.46 9.92 6.04 18.98 16.07 18.98h223.5c10.03 0 17.53-9.06 16.07-18.98-3.22-21.89-12.18-41.82-24.95-58.69C429.8 406.11 480 336.98 480 256h16c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16z"
                }
            }
        ]
    })(props);
}
function FaMosque(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 480c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32V160H0v320zm579.16-192c17.86-17.39 28.84-37.34 28.84-58.91 0-52.86-41.79-93.79-87.92-122.9-41.94-26.47-80.63-57.77-111.96-96.22L400 0l-8.12 9.97c-31.33 38.45-70.01 69.76-111.96 96.22C233.79 135.3 192 176.23 192 229.09c0 21.57 10.98 41.52 28.84 58.91h358.32zM608 320H192c-17.67 0-32 14.33-32 32v128c0 17.67 14.33 32 32 32h32v-64c0-17.67 14.33-32 32-32s32 14.33 32 32v64h64v-72c0-48 48-72 48-72s48 24 48 72v72h64v-64c0-17.67 14.33-32 32-32s32 14.33 32 32v64h32c17.67 0 32-14.33 32-32V352c0-17.67-14.33-32-32-32zM64 0S0 32 0 96v32h128V96c0-64-64-96-64-96z"
                }
            }
        ]
    })(props);
}
function FaMotorcycle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M512.9 192c-14.9-.1-29.1 2.3-42.4 6.9L437.6 144H520c13.3 0 24-10.7 24-24V88c0-13.3-10.7-24-24-24h-45.3c-6.8 0-13.3 2.9-17.8 7.9l-37.5 41.7-22.8-38C392.2 68.4 384.4 64 376 64h-80c-8.8 0-16 7.2-16 16v16c0 8.8 7.2 16 16 16h66.4l19.2 32H227.9c-17.7-23.1-44.9-40-99.9-40H72.5C59 104 47.7 115 48 128.5c.2 13 10.9 23.5 24 23.5h56c24.5 0 38.7 10.9 47.8 24.8l-11.3 20.5c-13-3.9-26.9-5.7-41.3-5.2C55.9 194.5 1.6 249.6 0 317c-1.6 72.1 56.3 131 128 131 59.6 0 109.7-40.8 124-96h84.2c13.7 0 24.6-11.4 24-25.1-2.1-47.1 17.5-93.7 56.2-125l12.5 20.8c-27.6 23.7-45.1 58.9-44.8 98.2.5 69.6 57.2 126.5 126.8 127.1 71.6.7 129.8-57.5 129.2-129.1-.7-69.6-57.6-126.4-127.2-126.9zM128 400c-44.1 0-80-35.9-80-80s35.9-80 80-80c4.2 0 8.4.3 12.5 1L99 316.4c-8.8 16 2.8 35.6 21 35.6h81.3c-12.4 28.2-40.6 48-73.3 48zm463.9-75.6c-2.2 40.6-35 73.4-75.5 75.5-46.1 2.5-84.4-34.3-84.4-79.9 0-21.4 8.4-40.8 22.1-55.1l49.4 82.4c4.5 7.6 14.4 10 22 5.5l13.7-8.2c7.6-4.5 10-14.4 5.5-22l-48.6-80.9c5.2-1.1 10.5-1.6 15.9-1.6 45.6-.1 82.3 38.2 79.9 84.3z"
                }
            }
        ]
    })(props);
}
function FaMountain(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M634.92 462.7l-288-448C341.03 5.54 330.89 0 320 0s-21.03 5.54-26.92 14.7l-288 448a32.001 32.001 0 0 0-1.17 32.64A32.004 32.004 0 0 0 32 512h576c11.71 0 22.48-6.39 28.09-16.67a31.983 31.983 0 0 0-1.17-32.63zM320 91.18L405.39 224H320l-64 64-38.06-38.06L320 91.18z"
                }
            }
        ]
    })(props);
}
function FaMousePointer(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 320 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M302.189 329.126H196.105l55.831 135.993c3.889 9.428-.555 19.999-9.444 23.999l-49.165 21.427c-9.165 4-19.443-.571-23.332-9.714l-53.053-129.136-86.664 89.138C18.729 472.71 0 463.554 0 447.977V18.299C0 1.899 19.921-6.096 30.277 5.443l284.412 292.542c11.472 11.179 3.007 31.141-12.5 31.141z"
                }
            }
        ]
    })(props);
}
function FaMouse(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 352a160 160 0 0 0 160 160h64a160 160 0 0 0 160-160V224H0zM176 0h-16A160 160 0 0 0 0 160v32h176zm48 0h-16v192h176v-32A160 160 0 0 0 224 0z"
                }
            }
        ]
    })(props);
}
function FaMugHot(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M127.1 146.5c1.3 7.7 8 13.5 16 13.5h16.5c9.8 0 17.6-8.5 16.3-18-3.8-28.2-16.4-54.2-36.6-74.7-14.4-14.7-23.6-33.3-26.4-53.5C111.8 5.9 105 0 96.8 0H80.4C70.6 0 63 8.5 64.1 18c3.9 31.9 18 61.3 40.6 84.4 12 12.2 19.7 27.5 22.4 44.1zm112 0c1.3 7.7 8 13.5 16 13.5h16.5c9.8 0 17.6-8.5 16.3-18-3.8-28.2-16.4-54.2-36.6-74.7-14.4-14.7-23.6-33.3-26.4-53.5C223.8 5.9 217 0 208.8 0h-16.4c-9.8 0-17.5 8.5-16.3 18 3.9 31.9 18 61.3 40.6 84.4 12 12.2 19.7 27.5 22.4 44.1zM400 192H32c-17.7 0-32 14.3-32 32v192c0 53 43 96 96 96h192c53 0 96-43 96-96h16c61.8 0 112-50.2 112-112s-50.2-112-112-112zm0 160h-16v-96h16c26.5 0 48 21.5 48 48s-21.5 48-48 48z"
                }
            }
        ]
    })(props);
}
function FaMusic(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M470.38 1.51L150.41 96A32 32 0 0 0 128 126.51v261.41A139 139 0 0 0 96 384c-53 0-96 28.66-96 64s43 64 96 64 96-28.66 96-64V214.32l256-75v184.61a138.4 138.4 0 0 0-32-3.93c-53 0-96 28.66-96 64s43 64 96 64 96-28.65 96-64V32a32 32 0 0 0-41.62-30.49z"
                }
            }
        ]
    })(props);
}
function FaNetworkWired(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M640 264v-16c0-8.84-7.16-16-16-16H344v-40h72c17.67 0 32-14.33 32-32V32c0-17.67-14.33-32-32-32H224c-17.67 0-32 14.33-32 32v128c0 17.67 14.33 32 32 32h72v40H16c-8.84 0-16 7.16-16 16v16c0 8.84 7.16 16 16 16h104v40H64c-17.67 0-32 14.33-32 32v128c0 17.67 14.33 32 32 32h160c17.67 0 32-14.33 32-32V352c0-17.67-14.33-32-32-32h-56v-40h304v40h-56c-17.67 0-32 14.33-32 32v128c0 17.67 14.33 32 32 32h160c17.67 0 32-14.33 32-32V352c0-17.67-14.33-32-32-32h-56v-40h104c8.84 0 16-7.16 16-16zM256 128V64h128v64H256zm-64 320H96v-64h96v64zm352 0h-96v-64h96v64z"
                }
            }
        ]
    })(props);
}
function FaNeuter(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 288 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M288 176c0-79.5-64.5-144-144-144S0 96.5 0 176c0 68.5 47.9 125.9 112 140.4V468c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12V316.4c64.1-14.5 112-71.9 112-140.4zm-144 80c-44.1 0-80-35.9-80-80s35.9-80 80-80 80 35.9 80 80-35.9 80-80 80z"
                }
            }
        ]
    })(props);
}
function FaNewspaper(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M552 64H88c-13.255 0-24 10.745-24 24v8H24c-13.255 0-24 10.745-24 24v272c0 30.928 25.072 56 56 56h472c26.51 0 48-21.49 48-48V88c0-13.255-10.745-24-24-24zM56 400a8 8 0 0 1-8-8V144h16v248a8 8 0 0 1-8 8zm236-16H140c-6.627 0-12-5.373-12-12v-8c0-6.627 5.373-12 12-12h152c6.627 0 12 5.373 12 12v8c0 6.627-5.373 12-12 12zm208 0H348c-6.627 0-12-5.373-12-12v-8c0-6.627 5.373-12 12-12h152c6.627 0 12 5.373 12 12v8c0 6.627-5.373 12-12 12zm-208-96H140c-6.627 0-12-5.373-12-12v-8c0-6.627 5.373-12 12-12h152c6.627 0 12 5.373 12 12v8c0 6.627-5.373 12-12 12zm208 0H348c-6.627 0-12-5.373-12-12v-8c0-6.627 5.373-12 12-12h152c6.627 0 12 5.373 12 12v8c0 6.627-5.373 12-12 12zm0-96H140c-6.627 0-12-5.373-12-12v-40c0-6.627 5.373-12 12-12h360c6.627 0 12 5.373 12 12v40c0 6.627-5.373 12-12 12z"
                }
            }
        ]
    })(props);
}
function FaNotEqual(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M416 208c17.67 0 32-14.33 32-32v-32c0-17.67-14.33-32-32-32h-23.88l51.87-66.81c5.37-7.02 4.04-17.06-2.97-22.43L415.61 3.3c-7.02-5.38-17.06-4.04-22.44 2.97L311.09 112H32c-17.67 0-32 14.33-32 32v32c0 17.67 14.33 32 32 32h204.56l-74.53 96H32c-17.67 0-32 14.33-32 32v32c0 17.67 14.33 32 32 32h55.49l-51.87 66.81c-5.37 7.01-4.04 17.05 2.97 22.43L64 508.7c7.02 5.38 17.06 4.04 22.43-2.97L168.52 400H416c17.67 0 32-14.33 32-32v-32c0-17.67-14.33-32-32-32H243.05l74.53-96H416z"
                }
            }
        ]
    })(props);
}
function FaNotesMedical(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M336 64h-80c0-35.3-28.7-64-64-64s-64 28.7-64 64H48C21.5 64 0 85.5 0 112v352c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V112c0-26.5-21.5-48-48-48zM192 40c13.3 0 24 10.7 24 24s-10.7 24-24 24-24-10.7-24-24 10.7-24 24-24zm96 304c0 4.4-3.6 8-8 8h-56v56c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8v-56h-56c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h56v-56c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v56h56c4.4 0 8 3.6 8 8v48zm0-192c0 4.4-3.6 8-8 8H104c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h176c4.4 0 8 3.6 8 8v16z"
                }
            }
        ]
    })(props);
}
function FaObjectGroup(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M480 128V96h20c6.627 0 12-5.373 12-12V44c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v20H64V44c0-6.627-5.373-12-12-12H12C5.373 32 0 37.373 0 44v40c0 6.627 5.373 12 12 12h20v320H12c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12v-20h384v20c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12v-40c0-6.627-5.373-12-12-12h-20V128zM96 276V140c0-6.627 5.373-12 12-12h168c6.627 0 12 5.373 12 12v136c0 6.627-5.373 12-12 12H108c-6.627 0-12-5.373-12-12zm320 96c0 6.627-5.373 12-12 12H236c-6.627 0-12-5.373-12-12v-52h72c13.255 0 24-10.745 24-24v-72h84c6.627 0 12 5.373 12 12v136z"
                }
            }
        ]
    })(props);
}
function FaObjectUngroup(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M64 320v26a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6v-52a6 6 0 0 1 6-6h26V96H6a6 6 0 0 1-6-6V38a6 6 0 0 1 6-6h52a6 6 0 0 1 6 6v26h288V38a6 6 0 0 1 6-6h52a6 6 0 0 1 6 6v52a6 6 0 0 1-6 6h-26v192h26a6 6 0 0 1 6 6v52a6 6 0 0 1-6 6h-52a6 6 0 0 1-6-6v-26H64zm480-64v-32h26a6 6 0 0 0 6-6v-52a6 6 0 0 0-6-6h-52a6 6 0 0 0-6 6v26H408v72h8c13.255 0 24 10.745 24 24v64c0 13.255-10.745 24-24 24h-64c-13.255 0-24-10.745-24-24v-8H192v72h-26a6 6 0 0 0-6 6v52a6 6 0 0 0 6 6h52a6 6 0 0 0 6-6v-26h288v26a6 6 0 0 0 6 6h52a6 6 0 0 0 6-6v-52a6 6 0 0 0-6-6h-26V256z"
                }
            }
        ]
    })(props);
}
function FaOilCan(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M629.8 160.31L416 224l-50.49-25.24a64.07 64.07 0 0 0-28.62-6.76H280v-48h56c8.84 0 16-7.16 16-16v-16c0-8.84-7.16-16-16-16H176c-8.84 0-16 7.16-16 16v16c0 8.84 7.16 16 16 16h56v48h-56L37.72 166.86a31.9 31.9 0 0 0-5.79-.53C14.67 166.33 0 180.36 0 198.34v94.95c0 15.46 11.06 28.72 26.28 31.48L96 337.46V384c0 17.67 14.33 32 32 32h274.63c8.55 0 16.75-3.42 22.76-9.51l212.26-214.75c1.5-1.5 2.34-3.54 2.34-5.66V168c.01-5.31-5.08-9.15-10.19-7.69zM96 288.67l-48-8.73v-62.43l48 8.73v62.43zm453.33 84.66c0 23.56 19.1 42.67 42.67 42.67s42.67-19.1 42.67-42.67S592 288 592 288s-42.67 61.77-42.67 85.33z"
                }
            }
        ]
    })(props);
}
function FaOm(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M360.6 60.94a10.43 10.43 0 0 0 14.76 0l21.57-21.56a10.43 10.43 0 0 0 0-14.76L375.35 3.06c-4.08-4.07-10.68-4.07-14.76 0l-21.57 21.56a10.43 10.43 0 0 0 0 14.76l21.58 21.56zM412.11 192c-26.69 0-51.77 10.39-70.64 29.25l-24.25 24.25c-6.78 6.77-15.78 10.5-25.38 10.5H245c10.54-22.1 14.17-48.11 7.73-75.23-10.1-42.55-46.36-76.11-89.52-83.19-36.15-5.93-70.9 5.04-96.01 28.78-7.36 6.96-6.97 18.85 1.12 24.93l26.15 19.63c5.72 4.3 13.66 4.32 19.2-.21 8.45-6.9 19.02-10.71 30.27-10.71 26.47 0 48.01 21.53 48.01 48s-21.54 48-48.01 48h-31.9c-11.96 0-19.74 12.58-14.39 23.28l16.09 32.17c2.53 5.06 7.6 8.1 13.17 8.55h33.03c35.3 0 64.01 28.7 64.01 64s-28.71 64-64.01 64c-96.02 0-122.35-54.02-145.15-92.03-4.53-7.55-14.77-3.58-14.79 5.22C-.09 416 41.13 512 159.94 512c70.59 0 128.02-57.42 128.02-128 0-23.42-6.78-45.1-17.81-64h21.69c26.69 0 51.77-10.39 70.64-29.25l24.25-24.25c6.78-6.77 15.78-10.5 25.38-10.5 19.78 0 35.88 16.09 35.88 35.88V392c0 13.23-18.77 24-32.01 24-39.4 0-66.67-24.24-81.82-42.89-4.77-5.87-14.2-2.54-14.2 5.02V416s0 64 96.02 64c48.54 0 96.02-39.47 96.02-88V291.88c0-55.08-44.8-99.88-99.89-99.88zm42.18-124.73c-85.55 65.12-169.05 2.75-172.58.05-6.02-4.62-14.44-4.38-20.14.55-5.74 4.92-7.27 13.17-3.66 19.8 1.61 2.95 40.37 72.34 118.8 72.34 79.92 0 98.78-31.36 101.75-37.66 1.02-2.12 1.53-4.47 1.53-6.83V80c0-13.22-15.14-20.69-25.7-12.73z"
                }
            }
        ]
    })(props);
}
function FaOtter(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M608 32h-32l-13.25-13.25A63.97 63.97 0 0 0 517.49 0H497c-11.14 0-22.08 2.91-31.75 8.43L312 96h-56C149.96 96 64 181.96 64 288v1.61c0 32.75-16 62.14-39.56 84.89-18.19 17.58-28.1 43.68-23.19 71.8 6.76 38.8 42.9 65.7 82.28 65.7H192c17.67 0 32-14.33 32-32s-14.33-32-32-32H80c-8.83 0-16-7.17-16-16s7.17-16 16-16h224c8.84 0 16-7.16 16-16v-16c0-17.67-14.33-32-32-32h-64l149.49-80.5L448 416h80c8.84 0 16-7.16 16-16v-16c0-17.67-14.33-32-32-32h-28.22l-55.11-110.21L521.14 192H544c53.02 0 96-42.98 96-96V64c0-17.67-14.33-32-32-32zm-96 16c8.84 0 16 7.16 16 16s-7.16 16-16 16-16-7.16-16-16 7.16-16 16-16zm32 96h-34.96L407.2 198.84l-13.77-27.55L512 112h77.05c-6.62 18.58-24.22 32-45.05 32z"
                }
            }
        ]
    })(props);
}
function FaOutdent(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M100.69 363.29c10 10 27.31 2.93 27.31-11.31V160c0-14.32-17.33-21.31-27.31-11.31l-96 96a16 16 0 0 0 0 22.62zM432 416H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm3.17-128H204.83A12.82 12.82 0 0 0 192 300.83v38.34A12.82 12.82 0 0 0 204.83 352h230.34A12.82 12.82 0 0 0 448 339.17v-38.34A12.82 12.82 0 0 0 435.17 288zm0-128H204.83A12.82 12.82 0 0 0 192 172.83v38.34A12.82 12.82 0 0 0 204.83 224h230.34A12.82 12.82 0 0 0 448 211.17v-38.34A12.82 12.82 0 0 0 435.17 160zM432 32H16A16 16 0 0 0 0 48v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16z"
                }
            }
        ]
    })(props);
}
function FaPager(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M448 64H64a64 64 0 0 0-64 64v256a64 64 0 0 0 64 64h384a64 64 0 0 0 64-64V128a64 64 0 0 0-64-64zM160 368H80a16 16 0 0 1-16-16v-16a16 16 0 0 1 16-16h80zm128-16a16 16 0 0 1-16 16h-80v-48h80a16 16 0 0 1 16 16zm160-128a32 32 0 0 1-32 32H96a32 32 0 0 1-32-32v-64a32 32 0 0 1 32-32h320a32 32 0 0 1 32 32z"
                }
            }
        ]
    })(props);
}
function FaPaintBrush(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M167.02 309.34c-40.12 2.58-76.53 17.86-97.19 72.3-2.35 6.21-8 9.98-14.59 9.98-11.11 0-45.46-27.67-55.25-34.35C0 439.62 37.93 512 128 512c75.86 0 128-43.77 128-120.19 0-3.11-.65-6.08-.97-9.13l-88.01-73.34zM457.89 0c-15.16 0-29.37 6.71-40.21 16.45C213.27 199.05 192 203.34 192 257.09c0 13.7 3.25 26.76 8.73 38.7l63.82 53.18c7.21 1.8 14.64 3.03 22.39 3.03 62.11 0 98.11-45.47 211.16-256.46 7.38-14.35 13.9-29.85 13.9-45.99C512 20.64 486 0 457.89 0z"
                }
            }
        ]
    })(props);
}
function FaPaintRoller(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M416 128V32c0-17.67-14.33-32-32-32H32C14.33 0 0 14.33 0 32v96c0 17.67 14.33 32 32 32h352c17.67 0 32-14.33 32-32zm32-64v128c0 17.67-14.33 32-32 32H256c-35.35 0-64 28.65-64 64v32c-17.67 0-32 14.33-32 32v128c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32V352c0-17.67-14.33-32-32-32v-32h160c53.02 0 96-42.98 96-96v-64c0-35.35-28.65-64-64-64z"
                }
            }
        ]
    })(props);
}
function FaPalette(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M204.3 5C104.9 24.4 24.8 104.3 5.2 203.4c-37 187 131.7 326.4 258.8 306.7 41.2-6.4 61.4-54.6 42.5-91.7-23.1-45.4 9.9-98.4 60.9-98.4h79.7c35.8 0 64.8-29.6 64.9-65.3C511.5 97.1 368.1-26.9 204.3 5zM96 320c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm32-128c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm128-64c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm128 64c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32z"
                }
            }
        ]
    })(props);
}
function FaPallet(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M144 256h352c8.8 0 16-7.2 16-16V16c0-8.8-7.2-16-16-16H384v128l-64-32-64 32V0H144c-8.8 0-16 7.2-16 16v224c0 8.8 7.2 16 16 16zm480 128c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16H16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h48v64H16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h608c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16h-48v-64h48zm-336 64H128v-64h160v64zm224 0H352v-64h160v64z"
                }
            }
        ]
    })(props);
}
function FaPaperPlane(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M476 3.2L12.5 270.6c-18.1 10.4-15.8 35.6 2.2 43.2L121 358.4l287.3-253.2c5.5-4.9 13.3 2.6 8.6 8.3L176 407v80.5c0 23.6 28.5 32.9 42.5 15.8L282 426l124.6 52.2c14.2 6 30.4-2.9 33-18.2l72-432C515 7.8 493.3-6.8 476 3.2z"
                }
            }
        ]
    })(props);
}
function FaPaperclip(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M43.246 466.142c-58.43-60.289-57.341-157.511 1.386-217.581L254.392 34c44.316-45.332 116.351-45.336 160.671 0 43.89 44.894 43.943 117.329 0 162.276L232.214 383.128c-29.855 30.537-78.633 30.111-107.982-.998-28.275-29.97-27.368-77.473 1.452-106.953l143.743-146.835c6.182-6.314 16.312-6.422 22.626-.241l22.861 22.379c6.315 6.182 6.422 16.312.241 22.626L171.427 319.927c-4.932 5.045-5.236 13.428-.648 18.292 4.372 4.634 11.245 4.711 15.688.165l182.849-186.851c19.613-20.062 19.613-52.725-.011-72.798-19.189-19.627-49.957-19.637-69.154 0L90.39 293.295c-34.763 35.56-35.299 93.12-1.191 128.313 34.01 35.093 88.985 35.137 123.058.286l172.06-175.999c6.177-6.319 16.307-6.433 22.626-.256l22.877 22.364c6.319 6.177 6.434 16.307.256 22.626l-172.06 175.998c-59.576 60.938-155.943 60.216-214.77-.485z"
                }
            }
        ]
    })(props);
}
function FaParachuteBox(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M511.9 175c-9.1-75.6-78.4-132.4-158.3-158.7C390 55.7 416 116.9 416 192h28.1L327.5 321.5c-2.5-.6-4.8-1.5-7.5-1.5h-48V192h112C384 76.8 315.1 0 256 0S128 76.8 128 192h112v128h-48c-2.7 0-5 .9-7.5 1.5L67.9 192H96c0-75.1 26-136.3 62.4-175.7C78.5 42.7 9.2 99.5.1 175c-1.1 9.1 6.8 17 16 17h8.7l136.7 151.9c-.7 2.6-1.6 5.2-1.6 8.1v128c0 17.7 14.3 32 32 32h128c17.7 0 32-14.3 32-32V352c0-2.9-.9-5.4-1.6-8.1L487.1 192h8.7c9.3 0 17.2-7.8 16.1-17z"
                }
            }
        ]
    })(props);
}
function FaParagraph(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M448 48v32a16 16 0 0 1-16 16h-48v368a16 16 0 0 1-16 16h-32a16 16 0 0 1-16-16V96h-32v368a16 16 0 0 1-16 16h-32a16 16 0 0 1-16-16V352h-32a160 160 0 0 1 0-320h240a16 16 0 0 1 16 16z"
                }
            }
        ]
    })(props);
}
function FaParking(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zM240 320h-48v48c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16V144c0-8.8 7.2-16 16-16h96c52.9 0 96 43.1 96 96s-43.1 96-96 96zm0-128h-48v64h48c17.6 0 32-14.4 32-32s-14.4-32-32-32z"
                }
            }
        ]
    })(props);
}
function FaPassport(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M129.62 176h39.09c1.49-27.03 6.54-51.35 14.21-70.41-27.71 13.24-48.02 39.19-53.3 70.41zm0 32c5.29 31.22 25.59 57.17 53.3 70.41-7.68-19.06-12.72-43.38-14.21-70.41h-39.09zM224 286.69c7.69-7.45 20.77-34.42 23.43-78.69h-46.87c2.67 44.26 15.75 71.24 23.44 78.69zM200.57 176h46.87c-2.66-44.26-15.74-71.24-23.43-78.69-7.7 7.45-20.78 34.43-23.44 78.69zm64.51 102.41c27.71-13.24 48.02-39.19 53.3-70.41h-39.09c-1.49 27.03-6.53 51.35-14.21 70.41zM416 0H64C28.65 0 0 28.65 0 64v384c0 35.35 28.65 64 64 64h352c17.67 0 32-14.33 32-32V32c0-17.67-14.33-32-32-32zm-80 416H112c-8.8 0-16-7.2-16-16s7.2-16 16-16h224c8.8 0 16 7.2 16 16s-7.2 16-16 16zm-112-96c-70.69 0-128-57.31-128-128S153.31 64 224 64s128 57.31 128 128-57.31 128-128 128zm41.08-214.41c7.68 19.06 12.72 43.38 14.21 70.41h39.09c-5.28-31.22-25.59-57.17-53.3-70.41z"
                }
            }
        ]
    })(props);
}
function FaPastafarianism(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M624.54 347.67c-32.7-12.52-57.36 4.25-75.37 16.45-17.06 11.53-23.25 14.42-31.41 11.36-8.12-3.09-10.83-9.38-15.89-29.38-3.33-13.15-7.44-29.32-17.95-42.65 2.24-2.91 4.43-5.79 6.38-8.57C500.47 304.45 513.71 312 532 312c33.95 0 50.87-25.78 62.06-42.83 10.59-16.14 15-21.17 21.94-21.17 13.25 0 24-10.75 24-24s-10.75-24-24-24c-33.95 0-50.87 25.78-62.06 42.83-10.6 16.14-15 21.17-21.94 21.17-17.31 0-37.48-61.43-97.26-101.91l17.25-34.5C485.43 125.5 512 97.98 512 64c0-35.35-28.65-64-64-64s-64 28.65-64 64c0 13.02 3.94 25.1 10.62 35.21l-18.15 36.3c-16.98-4.6-35.6-7.51-56.46-7.51s-39.49 2.91-56.46 7.51l-18.15-36.3C252.06 89.1 256 77.02 256 64c0-35.35-28.65-64-64-64s-64 28.65-64 64c0 33.98 26.56 61.5 60.02 63.6l17.25 34.5C145.68 202.44 125.15 264 108 264c-6.94 0-11.34-5.03-21.94-21.17C74.88 225.78 57.96 200 24 200c-13.25 0-24 10.75-24 24s10.75 24 24 24c6.94 0 11.34 5.03 21.94 21.17C57.13 286.22 74.05 312 108 312c18.29 0 31.53-7.55 41.7-17.11 1.95 2.79 4.14 5.66 6.38 8.57-10.51 13.33-14.62 29.5-17.95 42.65-5.06 20-7.77 26.28-15.89 29.38-8.11 3.06-14.33.17-31.41-11.36-18.03-12.2-42.72-28.92-75.37-16.45-12.39 4.72-18.59 18.58-13.87 30.97 4.72 12.41 18.61 18.61 30.97 13.88 8.16-3.09 14.34-.19 31.39 11.36 13.55 9.16 30.83 20.86 52.42 20.84 7.17 0 14.83-1.28 22.97-4.39 32.66-12.44 39.98-41.33 45.33-62.44 2.21-8.72 3.99-14.49 5.95-18.87 16.62 13.61 36.95 25.88 61.64 34.17-9.96 37-32.18 90.8-60.26 90.8-13.25 0-24 10.75-24 24s10.75 24 24 24c66.74 0 97.05-88.63 107.42-129.14 6.69.6 13.42 1.14 20.58 1.14s13.89-.54 20.58-1.14C350.95 423.37 381.26 512 448 512c13.25 0 24-10.75 24-24s-10.75-24-24-24c-27.94 0-50.21-53.81-60.22-90.81 24.69-8.29 45-20.56 61.62-34.16 1.96 4.38 3.74 10.15 5.95 18.87 5.34 21.11 12.67 50 45.33 62.44 8.14 3.11 15.8 4.39 22.97 4.39 21.59 0 38.87-11.69 52.42-20.84 17.05-11.55 23.28-14.45 31.39-11.36 12.39 4.75 26.27-1.47 30.97-13.88 4.71-12.4-1.49-26.26-13.89-30.98zM448 48c8.82 0 16 7.18 16 16s-7.18 16-16 16-16-7.18-16-16 7.18-16 16-16zm-256 0c8.82 0 16 7.18 16 16s-7.18 16-16 16-16-7.18-16-16 7.18-16 16-16z"
                }
            }
        ]
    })(props);
}
function FaPaste(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M128 184c0-30.879 25.122-56 56-56h136V56c0-13.255-10.745-24-24-24h-80.61C204.306 12.89 183.637 0 160 0s-44.306 12.89-55.39 32H24C10.745 32 0 42.745 0 56v336c0 13.255 10.745 24 24 24h104V184zm32-144c13.255 0 24 10.745 24 24s-10.745 24-24 24-24-10.745-24-24 10.745-24 24-24zm184 248h104v200c0 13.255-10.745 24-24 24H184c-13.255 0-24-10.745-24-24V184c0-13.255 10.745-24 24-24h136v104c0 13.2 10.8 24 24 24zm104-38.059V256h-96v-96h6.059a24 24 0 0 1 16.97 7.029l65.941 65.941a24.002 24.002 0 0 1 7.03 16.971z"
                }
            }
        ]
    })(props);
}
function FaPauseCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm-16 328c0 8.8-7.2 16-16 16h-48c-8.8 0-16-7.2-16-16V176c0-8.8 7.2-16 16-16h48c8.8 0 16 7.2 16 16v160zm112 0c0 8.8-7.2 16-16 16h-48c-8.8 0-16-7.2-16-16V176c0-8.8 7.2-16 16-16h48c8.8 0 16 7.2 16 16v160z"
                }
            }
        ]
    })(props);
}
function FaPause(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M144 479H48c-26.5 0-48-21.5-48-48V79c0-26.5 21.5-48 48-48h96c26.5 0 48 21.5 48 48v352c0 26.5-21.5 48-48 48zm304-48V79c0-26.5-21.5-48-48-48h-96c-26.5 0-48 21.5-48 48v352c0 26.5 21.5 48 48 48h96c26.5 0 48-21.5 48-48z"
                }
            }
        ]
    })(props);
}
function FaPaw(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 224c-79.41 0-192 122.76-192 200.25 0 34.9 26.81 55.75 71.74 55.75 48.84 0 81.09-25.08 120.26-25.08 39.51 0 71.85 25.08 120.26 25.08 44.93 0 71.74-20.85 71.74-55.75C448 346.76 335.41 224 256 224zm-147.28-12.61c-10.4-34.65-42.44-57.09-71.56-50.13-29.12 6.96-44.29 40.69-33.89 75.34 10.4 34.65 42.44 57.09 71.56 50.13 29.12-6.96 44.29-40.69 33.89-75.34zm84.72-20.78c30.94-8.14 46.42-49.94 34.58-93.36s-46.52-72.01-77.46-63.87-46.42 49.94-34.58 93.36c11.84 43.42 46.53 72.02 77.46 63.87zm281.39-29.34c-29.12-6.96-61.15 15.48-71.56 50.13-10.4 34.65 4.77 68.38 33.89 75.34 29.12 6.96 61.15-15.48 71.56-50.13 10.4-34.65-4.77-68.38-33.89-75.34zm-156.27 29.34c30.94 8.14 65.62-20.45 77.46-63.87 11.84-43.42-3.64-85.21-34.58-93.36s-65.62 20.45-77.46 63.87c-11.84 43.42 3.64 85.22 34.58 93.36z"
                }
            }
        ]
    })(props);
}
function FaPeace(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111.03 8 0 119.03 0 256s111.03 248 248 248 248-111.03 248-248S384.97 8 248 8zm184 248c0 31.93-8.2 61.97-22.57 88.17L280 240.63V74.97c86.23 15.21 152 90.5 152 181.03zM216 437.03c-33.86-5.97-64.49-21.2-89.29-43.02L216 322.57v114.46zm64-114.46L369.29 394c-24.8 21.82-55.43 37.05-89.29 43.02V322.57zm-64-247.6v165.66L86.57 344.17C72.2 317.97 64 287.93 64 256c0-90.53 65.77-165.82 152-181.03z"
                }
            }
        ]
    })(props);
}
function FaPenAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M497.94 74.17l-60.11-60.11c-18.75-18.75-49.16-18.75-67.91 0l-56.55 56.55 128.02 128.02 56.55-56.55c18.75-18.75 18.75-49.15 0-67.91zm-246.8-20.53c-15.62-15.62-40.94-15.62-56.56 0L75.8 172.43c-6.25 6.25-6.25 16.38 0 22.62l22.63 22.63c6.25 6.25 16.38 6.25 22.63 0l101.82-101.82 22.63 22.62L93.95 290.03A327.038 327.038 0 0 0 .17 485.11l-.03.23c-1.7 15.28 11.21 28.2 26.49 26.51a327.02 327.02 0 0 0 195.34-93.8l196.79-196.79-82.77-82.77-84.85-84.85z"
                }
            }
        ]
    })(props);
}
function FaPenFancy(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M79.18 282.94a32.005 32.005 0 0 0-20.24 20.24L0 480l4.69 4.69 92.89-92.89c-.66-2.56-1.57-5.03-1.57-7.8 0-17.67 14.33-32 32-32s32 14.33 32 32-14.33 32-32 32c-2.77 0-5.24-.91-7.8-1.57l-92.89 92.89L32 512l176.82-58.94a31.983 31.983 0 0 0 20.24-20.24l33.07-84.07-98.88-98.88-84.07 33.07zM369.25 28.32L186.14 227.81l97.85 97.85 199.49-183.11C568.4 67.48 443.73-55.94 369.25 28.32z"
                }
            }
        ]
    })(props);
}
function FaPenNib(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M136.6 138.79a64.003 64.003 0 0 0-43.31 41.35L0 460l14.69 14.69L164.8 324.58c-2.99-6.26-4.8-13.18-4.8-20.58 0-26.51 21.49-48 48-48s48 21.49 48 48-21.49 48-48 48c-7.4 0-14.32-1.81-20.58-4.8L37.31 497.31 52 512l279.86-93.29a64.003 64.003 0 0 0 41.35-43.31L416 224 288 96l-151.4 42.79zm361.34-64.62l-60.11-60.11c-18.75-18.75-49.16-18.75-67.91 0l-56.55 56.55 128.02 128.02 56.55-56.55c18.75-18.75 18.75-49.15 0-67.91z"
                }
            }
        ]
    })(props);
}
function FaPenSquare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M400 480H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h352c26.5 0 48 21.5 48 48v352c0 26.5-21.5 48-48 48zM238.1 177.9L102.4 313.6l-6.3 57.1c-.8 7.6 5.6 14.1 13.3 13.3l57.1-6.3L302.2 242c2.3-2.3 2.3-6.1 0-8.5L246.7 178c-2.5-2.4-6.3-2.4-8.6-.1zM345 165.1L314.9 135c-9.4-9.4-24.6-9.4-33.9 0l-23.1 23.1c-2.3 2.3-2.3 6.1 0 8.5l55.5 55.5c2.3 2.3 6.1 2.3 8.5 0L345 199c9.3-9.3 9.3-24.5 0-33.9z"
                }
            }
        ]
    })(props);
}
function FaPen(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M290.74 93.24l128.02 128.02-277.99 277.99-114.14 12.6C11.35 513.54-1.56 500.62.14 485.34l12.7-114.22 277.9-277.88zm207.2-19.06l-60.11-60.11c-18.75-18.75-49.16-18.75-67.91 0l-56.55 56.55 128.02 128.02 56.55-56.55c18.75-18.76 18.75-49.16 0-67.91z"
                }
            }
        ]
    })(props);
}
function FaPencilAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M497.9 142.1l-46.1 46.1c-4.7 4.7-12.3 4.7-17 0l-111-111c-4.7-4.7-4.7-12.3 0-17l46.1-46.1c18.7-18.7 49.1-18.7 67.9 0l60.1 60.1c18.8 18.7 18.8 49.1 0 67.9zM284.2 99.8L21.6 362.4.4 483.9c-2.9 16.4 11.4 30.6 27.8 27.8l121.5-21.3 262.6-262.6c4.7-4.7 4.7-12.3 0-17l-111-111c-4.8-4.7-12.4-4.7-17.1 0zM124.1 339.9c-5.5-5.5-5.5-14.3 0-19.8l154-154c5.5-5.5 14.3-5.5 19.8 0s5.5 14.3 0 19.8l-154 154c-5.5 5.5-14.3 5.5-19.8 0zM88 424h48v36.3l-64.5 11.3-31.1-31.1L51.7 376H88v48z"
                }
            }
        ]
    })(props);
}
function FaPencilRuler(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M109.46 244.04l134.58-134.56-44.12-44.12-61.68 61.68a7.919 7.919 0 0 1-11.21 0l-11.21-11.21c-3.1-3.1-3.1-8.12 0-11.21l61.68-61.68-33.64-33.65C131.47-3.1 111.39-3.1 99 9.29L9.29 99c-12.38 12.39-12.39 32.47 0 44.86l100.17 100.18zm388.47-116.8c18.76-18.76 18.75-49.17 0-67.93l-45.25-45.25c-18.76-18.76-49.18-18.76-67.95 0l-46.02 46.01 113.2 113.2 46.02-46.03zM316.08 82.71l-297 296.96L.32 487.11c-2.53 14.49 10.09 27.11 24.59 24.56l107.45-18.84L429.28 195.9 316.08 82.71zm186.63 285.43l-33.64-33.64-61.68 61.68c-3.1 3.1-8.12 3.1-11.21 0l-11.21-11.21c-3.09-3.1-3.09-8.12 0-11.21l61.68-61.68-44.14-44.14L267.93 402.5l100.21 100.2c12.39 12.39 32.47 12.39 44.86 0l89.71-89.7c12.39-12.39 12.39-32.47 0-44.86z"
                }
            }
        ]
    })(props);
}
function FaPeopleArrows(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M96,128A64,64,0,1,0,32,64,64,64,0,0,0,96,128Zm0,176.08a44.11,44.11,0,0,1,13.64-32L181.77,204c1.65-1.55,3.77-2.31,5.61-3.57A63.91,63.91,0,0,0,128,160H64A64,64,0,0,0,0,224v96a32,32,0,0,0,32,32V480a32,32,0,0,0,32,32h64a32,32,0,0,0,32-32V383.61l-50.36-47.53A44.08,44.08,0,0,1,96,304.08ZM480,128a64,64,0,1,0-64-64A64,64,0,0,0,480,128Zm32,32H448a63.91,63.91,0,0,0-59.38,40.42c1.84,1.27,4,2,5.62,3.59l72.12,68.06a44.37,44.37,0,0,1,0,64L416,383.62V480a32,32,0,0,0,32,32h64a32,32,0,0,0,32-32V352a32,32,0,0,0,32-32V224A64,64,0,0,0,512,160ZM444.4,295.34l-72.12-68.06A12,12,0,0,0,352,236v36H224V236a12,12,0,0,0-20.28-8.73L131.6,295.34a12.4,12.4,0,0,0,0,17.47l72.12,68.07A12,12,0,0,0,224,372.14V336H352v36.14a12,12,0,0,0,20.28,8.74l72.12-68.07A12.4,12.4,0,0,0,444.4,295.34Z"
                }
            }
        ]
    })(props);
}
function FaPeopleCarry(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M128 96c26.5 0 48-21.5 48-48S154.5 0 128 0 80 21.5 80 48s21.5 48 48 48zm384 0c26.5 0 48-21.5 48-48S538.5 0 512 0s-48 21.5-48 48 21.5 48 48 48zm125.7 372.1l-44-110-41.1 46.4-2 18.2 27.7 69.2c5 12.5 17 20.1 29.7 20.1 4 0 8-.7 11.9-2.3 16.4-6.6 24.4-25.2 17.8-41.6zm-34.2-209.8L585 178.1c-4.6-20-18.6-36.8-37.5-44.9-18.5-8-39-6.7-56.1 3.3-22.7 13.4-39.7 34.5-48.1 59.4L432 229.8 416 240v-96c0-8.8-7.2-16-16-16H240c-8.8 0-16 7.2-16 16v96l-16.1-10.2-11.3-33.9c-8.3-25-25.4-46-48.1-59.4-17.2-10-37.6-11.3-56.1-3.3-18.9 8.1-32.9 24.9-37.5 44.9l-18.4 80.2c-4.6 20 .7 41.2 14.4 56.7l67.2 75.9 10.1 92.6C130 499.8 143.8 512 160 512c1.2 0 2.3-.1 3.5-.2 17.6-1.9 30.2-17.7 28.3-35.3l-10.1-92.8c-1.5-13-6.9-25.1-15.6-35l-43.3-49 17.6-70.3 6.8 20.4c4.1 12.5 11.9 23.4 24.5 32.6l51.1 32.5c4.6 2.9 12.1 4.6 17.2 5h160c5.1-.4 12.6-2.1 17.2-5l51.1-32.5c12.6-9.2 20.4-20 24.5-32.6l6.8-20.4 17.6 70.3-43.3 49c-8.7 9.9-14.1 22-15.6 35l-10.1 92.8c-1.9 17.6 10.8 33.4 28.3 35.3 1.2.1 2.3.2 3.5.2 16.1 0 30-12.1 31.8-28.5l10.1-92.6 67.2-75.9c13.6-15.5 19-36.7 14.4-56.7zM46.3 358.1l-44 110c-6.6 16.4 1.4 35 17.8 41.6 16.8 6.6 35.1-1.7 41.6-17.8l27.7-69.2-2-18.2-41.1-46.4z"
                }
            }
        ]
    })(props);
}
function FaPepperHot(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M330.67 263.12V173.4l-52.75-24.22C219.44 218.76 197.58 400 56 400a56 56 0 0 0 0 112c212.64 0 370.65-122.87 419.18-210.34l-37.05-38.54zm131.09-128.37C493.92 74.91 477.18 26.48 458.62 3a8 8 0 0 0-11.93-.59l-22.9 23a8.06 8.06 0 0 0-.89 10.23c6.86 10.36 17.05 35.1-1.4 72.32A142.85 142.85 0 0 0 364.34 96c-28 0-54 8.54-76.34 22.59l74.67 34.29v78.24h89.09L506.44 288c3.26-12.62 5.56-25.63 5.56-39.31a154 154 0 0 0-50.24-113.94z"
                }
            }
        ]
    })(props);
}
function FaPercent(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M112 224c61.9 0 112-50.1 112-112S173.9 0 112 0 0 50.1 0 112s50.1 112 112 112zm0-160c26.5 0 48 21.5 48 48s-21.5 48-48 48-48-21.5-48-48 21.5-48 48-48zm224 224c-61.9 0-112 50.1-112 112s50.1 112 112 112 112-50.1 112-112-50.1-112-112-112zm0 160c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48zM392.3.2l31.6-.1c19.4-.1 30.9 21.8 19.7 37.8L77.4 501.6a23.95 23.95 0 0 1-19.6 10.2l-33.4.1c-19.5 0-30.9-21.9-19.7-37.8l368-463.7C377.2 4 384.5.2 392.3.2z"
                }
            }
        ]
    })(props);
}
function FaPercentage(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M109.25 173.25c24.99-24.99 24.99-65.52 0-90.51-24.99-24.99-65.52-24.99-90.51 0-24.99 24.99-24.99 65.52 0 90.51 25 25 65.52 25 90.51 0zm256 165.49c-24.99-24.99-65.52-24.99-90.51 0-24.99 24.99-24.99 65.52 0 90.51 24.99 24.99 65.52 24.99 90.51 0 25-24.99 25-65.51 0-90.51zm-1.94-231.43l-22.62-22.62c-12.5-12.5-32.76-12.5-45.25 0L20.69 359.44c-12.5 12.5-12.5 32.76 0 45.25l22.62 22.62c12.5 12.5 32.76 12.5 45.25 0l274.75-274.75c12.5-12.49 12.5-32.75 0-45.25z"
                }
            }
        ]
    })(props);
}
function FaPersonBooth(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M192 496c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V320h-64v176zm32-272h-50.9l-45.2-45.3C115.8 166.6 99.7 160 82.7 160H64c-17.1 0-33.2 6.7-45.3 18.8C6.7 190.9 0 207 0 224.1L.2 320 0 480c0 17.7 14.3 32 31.9 32 17.6 0 32-14.3 32-32l.1-100.7c.9.5 1.6 1.3 2.5 1.7l29.1 43v56c0 17.7 14.3 32 32 32s32-14.3 32-32v-56.5c0-9.9-2.3-19.8-6.7-28.6l-41.2-61.3V253l20.9 20.9c9.1 9.1 21.1 14.1 33.9 14.1H224c17.7 0 32-14.3 32-32s-14.3-32-32-32zM64 128c26.5 0 48-21.5 48-48S90.5 32 64 32 16 53.5 16 80s21.5 48 48 48zm224-96l31.5 223.1-30.9 154.6c-4.3 21.6 13 38.3 31.4 38.3 15.2 0 28-9.1 32.3-30.4.9 16.9 14.6 30.4 31.7 30.4 17.7 0 32-14.3 32-32 0 17.7 14.3 32 32 32s32-14.3 32-32V0H288v32zm-96 0v160h64V0h-32c-17.7 0-32 14.3-32 32zM544 0h-32v496c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V32c0-17.7-14.3-32-32-32z"
                }
            }
        ]
    })(props);
}
function FaPhoneAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M497.39 361.8l-112-48a24 24 0 0 0-28 6.9l-49.6 60.6A370.66 370.66 0 0 1 130.6 204.11l60.6-49.6a23.94 23.94 0 0 0 6.9-28l-48-112A24.16 24.16 0 0 0 122.6.61l-104 24A24 24 0 0 0 0 48c0 256.5 207.9 464 464 464a24 24 0 0 0 23.4-18.6l24-104a24.29 24.29 0 0 0-14.01-27.6z"
                }
            }
        ]
    })(props);
}
function FaPhoneSlash(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M268.2 381.4l-49.6-60.6c-6.8-8.3-18.2-11.1-28-6.9l-112 48c-10.7 4.6-16.5 16.1-13.9 27.5l24 104c2.5 10.8 12.1 18.6 23.4 18.6 100.7 0 193.7-32.4 269.7-86.9l-80-61.8c-10.9 6.5-22.1 12.7-33.6 18.1zm365.6 76.7L475.1 335.5C537.9 256.4 576 156.9 576 48c0-11.2-7.7-20.9-18.6-23.4l-104-24c-11.3-2.6-22.9 3.3-27.5 13.9l-48 112c-4.2 9.8-1.4 21.3 6.9 28l60.6 49.6c-12.2 26.1-27.9 50.3-46 72.8L45.5 3.4C38.5-2 28.5-.8 23 6.2L3.4 31.4c-5.4 7-4.2 17 2.8 22.4l588.4 454.7c7 5.4 17 4.2 22.5-2.8l19.6-25.3c5.4-6.8 4.1-16.9-2.9-22.3z"
                }
            }
        ]
    })(props);
}
function FaPhoneSquareAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M400 32H48A48 48 0 0 0 0 80v352a48 48 0 0 0 48 48h352a48 48 0 0 0 48-48V80a48 48 0 0 0-48-48zm-16.39 307.37l-15 65A15 15 0 0 1 354 416C194 416 64 286.29 64 126a15.7 15.7 0 0 1 11.63-14.61l65-15A18.23 18.23 0 0 1 144 96a16.27 16.27 0 0 1 13.79 9.09l30 70A17.9 17.9 0 0 1 189 181a17 17 0 0 1-5.5 11.61l-37.89 31a231.91 231.91 0 0 0 110.78 110.78l31-37.89A17 17 0 0 1 299 291a17.85 17.85 0 0 1 5.91 1.21l70 30A16.25 16.25 0 0 1 384 336a17.41 17.41 0 0 1-.39 3.37z"
                }
            }
        ]
    })(props);
}
function FaPhoneSquare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M400 32H48C21.49 32 0 53.49 0 80v352c0 26.51 21.49 48 48 48h352c26.51 0 48-21.49 48-48V80c0-26.51-21.49-48-48-48zM94 416c-7.033 0-13.057-4.873-14.616-11.627l-14.998-65a15 15 0 0 1 8.707-17.16l69.998-29.999a15 15 0 0 1 17.518 4.289l30.997 37.885c48.944-22.963 88.297-62.858 110.781-110.78l-37.886-30.997a15.001 15.001 0 0 1-4.289-17.518l30-69.998a15 15 0 0 1 17.16-8.707l65 14.998A14.997 14.997 0 0 1 384 126c0 160.292-129.945 290-290 290z"
                }
            }
        ]
    })(props);
}
function FaPhoneVolume(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M97.333 506.966c-129.874-129.874-129.681-340.252 0-469.933 5.698-5.698 14.527-6.632 21.263-2.422l64.817 40.513a17.187 17.187 0 0 1 6.849 20.958l-32.408 81.021a17.188 17.188 0 0 1-17.669 10.719l-55.81-5.58c-21.051 58.261-20.612 122.471 0 179.515l55.811-5.581a17.188 17.188 0 0 1 17.669 10.719l32.408 81.022a17.188 17.188 0 0 1-6.849 20.958l-64.817 40.513a17.19 17.19 0 0 1-21.264-2.422zM247.126 95.473c11.832 20.047 11.832 45.008 0 65.055-3.95 6.693-13.108 7.959-18.718 2.581l-5.975-5.726c-3.911-3.748-4.793-9.622-2.261-14.41a32.063 32.063 0 0 0 0-29.945c-2.533-4.788-1.65-10.662 2.261-14.41l5.975-5.726c5.61-5.378 14.768-4.112 18.718 2.581zm91.787-91.187c60.14 71.604 60.092 175.882 0 247.428-4.474 5.327-12.53 5.746-17.552.933l-5.798-5.557c-4.56-4.371-4.977-11.529-.93-16.379 49.687-59.538 49.646-145.933 0-205.422-4.047-4.85-3.631-12.008.93-16.379l5.798-5.557c5.022-4.813 13.078-4.394 17.552.933zm-45.972 44.941c36.05 46.322 36.108 111.149 0 157.546-4.39 5.641-12.697 6.251-17.856 1.304l-5.818-5.579c-4.4-4.219-4.998-11.095-1.285-15.931 26.536-34.564 26.534-82.572 0-117.134-3.713-4.836-3.115-11.711 1.285-15.931l5.818-5.579c5.159-4.947 13.466-4.337 17.856 1.304z"
                }
            }
        ]
    })(props);
}
function FaPhone(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M493.4 24.6l-104-24c-11.3-2.6-22.9 3.3-27.5 13.9l-48 112c-4.2 9.8-1.4 21.3 6.9 28l60.6 49.6c-36 76.7-98.9 140.5-177.2 177.2l-49.6-60.6c-6.8-8.3-18.2-11.1-28-6.9l-112 48C3.9 366.5-2 378.1.6 389.4l24 104C27.1 504.2 36.7 512 48 512c256.1 0 464-207.5 464-464 0-11.2-7.7-20.9-18.6-23.4z"
                }
            }
        ]
    })(props);
}
function FaPhotoVideo(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M608 0H160a32 32 0 0 0-32 32v96h160V64h192v320h128a32 32 0 0 0 32-32V32a32 32 0 0 0-32-32zM232 103a9 9 0 0 1-9 9h-30a9 9 0 0 1-9-9V73a9 9 0 0 1 9-9h30a9 9 0 0 1 9 9zm352 208a9 9 0 0 1-9 9h-30a9 9 0 0 1-9-9v-30a9 9 0 0 1 9-9h30a9 9 0 0 1 9 9zm0-104a9 9 0 0 1-9 9h-30a9 9 0 0 1-9-9v-30a9 9 0 0 1 9-9h30a9 9 0 0 1 9 9zm0-104a9 9 0 0 1-9 9h-30a9 9 0 0 1-9-9V73a9 9 0 0 1 9-9h30a9 9 0 0 1 9 9zm-168 57H32a32 32 0 0 0-32 32v288a32 32 0 0 0 32 32h384a32 32 0 0 0 32-32V192a32 32 0 0 0-32-32zM96 224a32 32 0 1 1-32 32 32 32 0 0 1 32-32zm288 224H64v-32l64-64 32 32 128-128 96 96z"
                }
            }
        ]
    })(props);
}
function FaPiggyBank(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M560 224h-29.5c-8.8-20-21.6-37.7-37.4-52.5L512 96h-32c-29.4 0-55.4 13.5-73 34.3-7.6-1.1-15.1-2.3-23-2.3H256c-77.4 0-141.9 55-156.8 128H56c-14.8 0-26.5-13.5-23.5-28.8C34.7 215.8 45.4 208 57 208h1c3.3 0 6-2.7 6-6v-20c0-3.3-2.7-6-6-6-28.5 0-53.9 20.4-57.5 48.6C-3.9 258.8 22.7 288 56 288h40c0 52.2 25.4 98.1 64 127.3V496c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16v-48h128v48c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16v-80.7c11.8-8.9 22.3-19.4 31.3-31.3H560c8.8 0 16-7.2 16-16V240c0-8.8-7.2-16-16-16zm-128 64c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16zM256 96h128c5.4 0 10.7.4 15.9.8 0-.3.1-.5.1-.8 0-53-43-96-96-96s-96 43-96 96c0 2.1.5 4.1.6 6.2 15.2-3.9 31-6.2 47.4-6.2z"
                }
            }
        ]
    })(props);
}
function FaPills(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M112 32C50.1 32 0 82.1 0 144v224c0 61.9 50.1 112 112 112s112-50.1 112-112V144c0-61.9-50.1-112-112-112zm48 224H64V144c0-26.5 21.5-48 48-48s48 21.5 48 48v112zm139.7-29.7c-3.5-3.5-9.4-3.1-12.3.8-45.3 62.5-40.4 150.1 15.9 206.4 56.3 56.3 143.9 61.2 206.4 15.9 4-2.9 4.3-8.8.8-12.3L299.7 226.3zm229.8-19c-56.3-56.3-143.9-61.2-206.4-15.9-4 2.9-4.3 8.8-.8 12.3l210.8 210.8c3.5 3.5 9.4 3.1 12.3-.8 45.3-62.6 40.5-150.1-15.9-206.4z"
                }
            }
        ]
    })(props);
}
function FaPizzaSlice(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M158.87.15c-16.16-1.52-31.2 8.42-35.33 24.12l-14.81 56.27c187.62 5.49 314.54 130.61 322.48 317l56.94-15.78c15.72-4.36 25.49-19.68 23.62-35.9C490.89 165.08 340.78 17.32 158.87.15zm-58.47 112L.55 491.64a16.21 16.21 0 0 0 20 19.75l379-105.1c-4.27-174.89-123.08-292.14-299.15-294.1zM128 416a32 32 0 1 1 32-32 32 32 0 0 1-32 32zm48-152a32 32 0 1 1 32-32 32 32 0 0 1-32 32zm104 104a32 32 0 1 1 32-32 32 32 0 0 1-32 32z"
                }
            }
        ]
    })(props);
}
function FaPlaceOfWorship(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M620.61 366.55L512 320v192h112c8.84 0 16-7.16 16-16V395.96a32 32 0 0 0-19.39-29.41zM0 395.96V496c0 8.84 7.16 16 16 16h112V320L19.39 366.55A32 32 0 0 0 0 395.96zm464.46-149.28L416 217.6V102.63c0-8.49-3.37-16.62-9.38-22.63L331.31 4.69c-6.25-6.25-16.38-6.25-22.62 0L233.38 80c-6 6-9.38 14.14-9.38 22.63V217.6l-48.46 29.08A31.997 31.997 0 0 0 160 274.12V512h96v-96c0-35.35 28.66-64 64-64s64 28.65 64 64v96h96V274.12c0-11.24-5.9-21.66-15.54-27.44z"
                }
            }
        ]
    })(props);
}
function FaPlaneArrival(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M624 448H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h608c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16zM44.81 205.66l88.74 80a62.607 62.607 0 0 0 25.47 13.93l287.6 78.35c26.48 7.21 54.56 8.72 81 1.36 29.67-8.27 43.44-21.21 47.25-35.71 3.83-14.5-1.73-32.71-23.37-54.96-19.28-19.82-44.35-32.79-70.83-40l-97.51-26.56L282.8 30.22c-1.51-5.81-5.95-10.35-11.66-11.91L206.05.58c-10.56-2.88-20.9 5.32-20.71 16.44l47.92 164.21-102.2-27.84-27.59-67.88c-1.93-4.89-6.01-8.57-11.02-9.93L52.72 64.75c-10.34-2.82-20.53 5-20.72 15.88l.23 101.78c.19 8.91 6.03 17.34 12.58 23.25z"
                }
            }
        ]
    })(props);
}
function FaPlaneDeparture(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M624 448H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h608c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16zM80.55 341.27c6.28 6.84 15.1 10.72 24.33 10.71l130.54-.18a65.62 65.62 0 0 0 29.64-7.12l290.96-147.65c26.74-13.57 50.71-32.94 67.02-58.31 18.31-28.48 20.3-49.09 13.07-63.65-7.21-14.57-24.74-25.27-58.25-27.45-29.85-1.94-59.54 5.92-86.28 19.48l-98.51 49.99-218.7-82.06a17.799 17.799 0 0 0-18-1.11L90.62 67.29c-10.67 5.41-13.25 19.65-5.17 28.53l156.22 98.1-103.21 52.38-72.35-36.47a17.804 17.804 0 0 0-16.07.02L9.91 230.22c-10.44 5.3-13.19 19.12-5.57 28.08l76.21 82.97z"
                }
            }
        ]
    })(props);
}
function FaPlaneSlash(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M32.48,147.88,64,256,32.48,364.13A16,16,0,0,0,48,384H88a16,16,0,0,0,12.8-6.41L144,320H246.85l-49,171.59A16,16,0,0,0,213.2,512h65.5a16,16,0,0,0,13.89-8.06l66.6-116.54L34.35,136.34A15.47,15.47,0,0,0,32.48,147.88ZM633.82,458.09,455.14,320H512c35.34,0,96-28.66,96-64s-60.66-64-96-64H397.7L292.61,8.06C290.06,3.61,283.84,0,278.71,0H213.2a16,16,0,0,0-15.38,20.39l36.94,129.29L45.46,3.38A16,16,0,0,0,23,6.19L3.37,31.45A16,16,0,0,0,6.18,53.91L594.54,508.63A16,16,0,0,0,617,505.81l19.64-25.26A16,16,0,0,0,633.82,458.09Z"
                }
            }
        ]
    })(props);
}
function FaPlane(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M480 192H365.71L260.61 8.06A16.014 16.014 0 0 0 246.71 0h-65.5c-10.63 0-18.3 10.17-15.38 20.39L214.86 192H112l-43.2-57.6c-3.02-4.03-7.77-6.4-12.8-6.4H16.01C5.6 128-2.04 137.78.49 147.88L32 256 .49 364.12C-2.04 374.22 5.6 384 16.01 384H56c5.04 0 9.78-2.37 12.8-6.4L112 320h102.86l-49.03 171.6c-2.92 10.22 4.75 20.4 15.38 20.4h65.5c5.74 0 11.04-3.08 13.89-8.06L365.71 320H480c35.35 0 96-28.65 96-64s-60.65-64-96-64z"
                }
            }
        ]
    })(props);
}
function FaPlayCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm115.7 272l-176 101c-15.8 8.8-35.7-2.5-35.7-21V152c0-18.4 19.8-29.8 35.7-21l176 107c16.4 9.2 16.4 32.9 0 42z"
                }
            }
        ]
    })(props);
}
function FaPlay(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M424.4 214.7L72.4 6.6C43.8-10.3 0 6.1 0 47.9V464c0 37.5 40.7 60.1 72.4 41.3l352-208c31.4-18.5 31.5-64.1 0-82.6z"
                }
            }
        ]
    })(props);
}
function FaPlug(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M320,32a32,32,0,0,0-64,0v96h64Zm48,128H16A16,16,0,0,0,0,176v32a16,16,0,0,0,16,16H32v32A160.07,160.07,0,0,0,160,412.8V512h64V412.8A160.07,160.07,0,0,0,352,256V224h16a16,16,0,0,0,16-16V176A16,16,0,0,0,368,160ZM128,32a32,32,0,0,0-64,0v96h64Z"
                }
            }
        ]
    })(props);
}
function FaPlusCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm144 276c0 6.6-5.4 12-12 12h-92v92c0 6.6-5.4 12-12 12h-56c-6.6 0-12-5.4-12-12v-92h-92c-6.6 0-12-5.4-12-12v-56c0-6.6 5.4-12 12-12h92v-92c0-6.6 5.4-12 12-12h56c6.6 0 12 5.4 12 12v92h92c6.6 0 12 5.4 12 12v56z"
                }
            }
        ]
    })(props);
}
function FaPlusSquare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zm-32 252c0 6.6-5.4 12-12 12h-92v92c0 6.6-5.4 12-12 12h-56c-6.6 0-12-5.4-12-12v-92H92c-6.6 0-12-5.4-12-12v-56c0-6.6 5.4-12 12-12h92v-92c0-6.6 5.4-12 12-12h56c6.6 0 12 5.4 12 12v92h92c6.6 0 12 5.4 12 12v56z"
                }
            }
        ]
    })(props);
}
function FaPlus(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M416 208H272V64c0-17.67-14.33-32-32-32h-32c-17.67 0-32 14.33-32 32v144H32c-17.67 0-32 14.33-32 32v32c0 17.67 14.33 32 32 32h144v144c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32V304h144c17.67 0 32-14.33 32-32v-32c0-17.67-14.33-32-32-32z"
                }
            }
        ]
    })(props);
}
function FaPodcast(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M267.429 488.563C262.286 507.573 242.858 512 224 512c-18.857 0-38.286-4.427-43.428-23.437C172.927 460.134 160 388.898 160 355.75c0-35.156 31.142-43.75 64-43.75s64 8.594 64 43.75c0 32.949-12.871 104.179-20.571 132.813zM156.867 288.554c-18.693-18.308-29.958-44.173-28.784-72.599 2.054-49.724 42.395-89.956 92.124-91.881C274.862 121.958 320 165.807 320 220c0 26.827-11.064 51.116-28.866 68.552-2.675 2.62-2.401 6.986.628 9.187 9.312 6.765 16.46 15.343 21.234 25.363 1.741 3.654 6.497 4.66 9.449 1.891 28.826-27.043 46.553-65.783 45.511-108.565-1.855-76.206-63.595-138.208-139.793-140.369C146.869 73.753 80 139.215 80 220c0 41.361 17.532 78.7 45.55 104.989 2.953 2.771 7.711 1.77 9.453-1.887 4.774-10.021 11.923-18.598 21.235-25.363 3.029-2.2 3.304-6.566.629-9.185zM224 0C100.204 0 0 100.185 0 224c0 89.992 52.602 165.647 125.739 201.408 4.333 2.118 9.267-1.544 8.535-6.31-2.382-15.512-4.342-30.946-5.406-44.339-.146-1.836-1.149-3.486-2.678-4.512-47.4-31.806-78.564-86.016-78.187-147.347.592-96.237 79.29-174.648 175.529-174.899C320.793 47.747 400 126.797 400 224c0 61.932-32.158 116.49-80.65 147.867-.999 14.037-3.069 30.588-5.624 47.23-.732 4.767 4.203 8.429 8.535 6.31C395.227 389.727 448 314.187 448 224 448 100.205 347.815 0 224 0zm0 160c-35.346 0-64 28.654-64 64s28.654 64 64 64 64-28.654 64-64-28.654-64-64-64z"
                }
            }
        ]
    })(props);
}
function FaPollH(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M448 432V80c0-26.5-21.5-48-48-48H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48zM112 192c-8.84 0-16-7.16-16-16v-32c0-8.84 7.16-16 16-16h128c8.84 0 16 7.16 16 16v32c0 8.84-7.16 16-16 16H112zm0 96c-8.84 0-16-7.16-16-16v-32c0-8.84 7.16-16 16-16h224c8.84 0 16 7.16 16 16v32c0 8.84-7.16 16-16 16H112zm0 96c-8.84 0-16-7.16-16-16v-32c0-8.84 7.16-16 16-16h64c8.84 0 16 7.16 16 16v32c0 8.84-7.16 16-16 16h-64z"
                }
            }
        ]
    })(props);
}
function FaPoll(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zM160 368c0 8.84-7.16 16-16 16h-32c-8.84 0-16-7.16-16-16V240c0-8.84 7.16-16 16-16h32c8.84 0 16 7.16 16 16v128zm96 0c0 8.84-7.16 16-16 16h-32c-8.84 0-16-7.16-16-16V144c0-8.84 7.16-16 16-16h32c8.84 0 16 7.16 16 16v224zm96 0c0 8.84-7.16 16-16 16h-32c-8.84 0-16-7.16-16-16v-64c0-8.84 7.16-16 16-16h32c8.84 0 16 7.16 16 16v64z"
                }
            }
        ]
    })(props);
}
function FaPooStorm(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M308 336h-57.7l17.3-64.9c2-7.6-3.7-15.1-11.6-15.1h-68c-6 0-11.1 4.5-11.9 10.4l-16 120c-1 7.2 4.6 13.6 11.9 13.6h59.3l-23 97.2c-1.8 7.6 4 14.8 11.7 14.8 4.2 0 8.2-2.2 10.4-6l88-152c4.6-8-1.2-18-10.4-18zm66.4-111.3c5.9-9.6 9.6-20.6 9.6-32.7 0-35.3-28.7-64-64-64h-5.9c3.6-10.1 5.9-20.7 5.9-32 0-53-43-96-96-96-5.2 0-10.2.7-15.1 1.5C218.3 14.6 224 30.6 224 48c0 44.2-35.8 80-80 80h-16c-35.3 0-64 28.7-64 64 0 12.1 3.7 23.1 9.6 32.7C32.6 228 0 262.2 0 304c0 44 36 80 80 80h48.3c.1-.6 0-1.2 0-1.8l16-120c3-21.8 21.7-38.2 43.7-38.2h68c13.8 0 26.5 6.3 34.9 17.2s11.2 24.8 7.6 38.1l-6.6 24.7h16c15.7 0 30.3 8.4 38.1 22 7.8 13.6 7.8 30.5 0 44l-8.1 14h30c44 0 80-36 80-80 .1-41.8-32.5-76-73.5-79.3z"
                }
            }
        ]
    })(props);
}
function FaPoo(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M451.4 369.1C468.7 356 480 335.4 480 312c0-39.8-32.2-72-72-72h-14.1c13.4-11.7 22.1-28.8 22.1-48 0-35.3-28.7-64-64-64h-5.9c3.6-10.1 5.9-20.7 5.9-32 0-53-43-96-96-96-5.2 0-10.2.7-15.1 1.5C250.3 14.6 256 30.6 256 48c0 44.2-35.8 80-80 80h-16c-35.3 0-64 28.7-64 64 0 19.2 8.7 36.3 22.1 48H104c-39.8 0-72 32.2-72 72 0 23.4 11.3 44 28.6 57.1C26.3 374.6 0 404.1 0 440c0 39.8 32.2 72 72 72h368c39.8 0 72-32.2 72-72 0-35.9-26.3-65.4-60.6-70.9zM192 256c17.7 0 32 14.3 32 32s-14.3 32-32 32-32-14.3-32-32 14.3-32 32-32zm159.5 139C341 422.9 293 448 256 448s-85-25.1-95.5-53c-2-5.3 2-11 7.8-11h175.4c5.8 0 9.8 5.7 7.8 11zM320 320c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32z"
                }
            }
        ]
    })(props);
}
function FaPoop(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M451.36 369.14C468.66 355.99 480 335.41 480 312c0-39.77-32.24-72-72-72h-14.07c13.42-11.73 22.07-28.78 22.07-48 0-35.35-28.65-64-64-64h-5.88c3.57-10.05 5.88-20.72 5.88-32 0-53.02-42.98-96-96-96-5.17 0-10.15.74-15.11 1.52C250.31 14.64 256 30.62 256 48c0 44.18-35.82 80-80 80h-16c-35.35 0-64 28.65-64 64 0 19.22 8.65 36.27 22.07 48H104c-39.76 0-72 32.23-72 72 0 23.41 11.34 43.99 28.64 57.14C26.31 374.62 0 404.12 0 440c0 39.76 32.24 72 72 72h368c39.76 0 72-32.24 72-72 0-35.88-26.31-65.38-60.64-70.86z"
                }
            }
        ]
    })(props);
}
function FaPortrait(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M336 0H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48zM192 128c35.3 0 64 28.7 64 64s-28.7 64-64 64-64-28.7-64-64 28.7-64 64-64zm112 236.8c0 10.6-10 19.2-22.4 19.2H102.4C90 384 80 375.4 80 364.8v-19.2c0-31.8 30.1-57.6 67.2-57.6h5c12.3 5.1 25.7 8 39.8 8s27.6-2.9 39.8-8h5c37.1 0 67.2 25.8 67.2 57.6v19.2z"
                }
            }
        ]
    })(props);
}
function FaPoundSign(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 320 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M308 352h-45.495c-6.627 0-12 5.373-12 12v50.848H128V288h84c6.627 0 12-5.373 12-12v-40c0-6.627-5.373-12-12-12h-84v-63.556c0-32.266 24.562-57.086 61.792-57.086 23.658 0 45.878 11.505 57.652 18.849 5.151 3.213 11.888 2.051 15.688-2.685l28.493-35.513c4.233-5.276 3.279-13.005-2.119-17.081C273.124 54.56 236.576 32 187.931 32 106.026 32 48 84.742 48 157.961V224H20c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h28v128H12c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h296c6.627 0 12-5.373 12-12V364c0-6.627-5.373-12-12-12z"
                }
            }
        ]
    })(props);
}
function FaPowerOff(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M400 54.1c63 45 104 118.6 104 201.9 0 136.8-110.8 247.7-247.5 248C120 504.3 8.2 393 8 256.4 7.9 173.1 48.9 99.3 111.8 54.2c11.7-8.3 28-4.8 35 7.7L162.6 90c5.9 10.5 3.1 23.8-6.6 31-41.5 30.8-68 79.6-68 134.9-.1 92.3 74.5 168.1 168 168.1 91.6 0 168.6-74.2 168-169.1-.3-51.8-24.7-101.8-68.1-134-9.7-7.2-12.4-20.5-6.5-30.9l15.8-28.1c7-12.4 23.2-16.1 34.8-7.8zM296 264V24c0-13.3-10.7-24-24-24h-32c-13.3 0-24 10.7-24 24v240c0 13.3 10.7 24 24 24h32c13.3 0 24-10.7 24-24z"
                }
            }
        ]
    })(props);
}
function FaPray(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 128c35.35 0 64-28.65 64-64S291.35 0 256 0s-64 28.65-64 64 28.65 64 64 64zm-30.63 169.75c14.06 16.72 39 19.09 55.97 5.22l88-72.02c17.09-13.98 19.59-39.19 5.62-56.28-13.97-17.11-39.19-19.59-56.31-5.62l-57.44 47-38.91-46.31c-15.44-18.39-39.22-27.92-64-25.33-24.19 2.48-45.25 16.27-56.37 36.92l-49.37 92.03c-23.4 43.64-8.69 96.37 34.19 123.75L131.56 432H40c-22.09 0-40 17.91-40 40s17.91 40 40 40h208c34.08 0 53.77-42.79 28.28-68.28L166.42 333.86l34.8-64.87 24.15 28.76z"
                }
            }
        ]
    })(props);
}
function FaPrayingHands(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M272 191.91c-17.6 0-32 14.4-32 32v80c0 8.84-7.16 16-16 16s-16-7.16-16-16v-76.55c0-17.39 4.72-34.47 13.69-49.39l77.75-129.59c9.09-15.16 4.19-34.81-10.97-43.91-14.45-8.67-32.72-4.3-42.3 9.21-.2.23-.62.21-.79.48l-117.26 175.9C117.56 205.9 112 224.31 112 243.29v80.23l-90.12 30.04A31.974 31.974 0 0 0 0 383.91v96c0 10.82 8.52 32 32 32 2.69 0 5.41-.34 8.06-1.03l179.19-46.62C269.16 449.99 304 403.8 304 351.91v-128c0-17.6-14.4-32-32-32zm346.12 161.73L528 323.6v-80.23c0-18.98-5.56-37.39-16.12-53.23L394.62 14.25c-.18-.27-.59-.24-.79-.48-9.58-13.51-27.85-17.88-42.3-9.21-15.16 9.09-20.06 28.75-10.97 43.91l77.75 129.59c8.97 14.92 13.69 32 13.69 49.39V304c0 8.84-7.16 16-16 16s-16-7.16-16-16v-80c0-17.6-14.4-32-32-32s-32 14.4-32 32v128c0 51.89 34.84 98.08 84.75 112.34l179.19 46.62c2.66.69 5.38 1.03 8.06 1.03 23.48 0 32-21.18 32-32v-96c0-13.77-8.81-25.99-21.88-30.35z"
                }
            }
        ]
    })(props);
}
function FaPrescriptionBottleAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M360 0H24C10.8 0 0 10.8 0 24v48c0 13.2 10.8 24 24 24h336c13.2 0 24-10.8 24-24V24c0-13.2-10.8-24-24-24zM32 480c0 17.6 14.4 32 32 32h256c17.6 0 32-14.4 32-32V128H32v352zm64-184c0-4.4 3.6-8 8-8h56v-56c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v56h56c4.4 0 8 3.6 8 8v48c0 4.4-3.6 8-8 8h-56v56c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8v-56h-56c-4.4 0-8-3.6-8-8v-48z"
                }
            }
        ]
    })(props);
}
function FaPrescriptionBottle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M32 192h120c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8H32v64h120c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8H32v64h120c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8H32v64c0 17.6 14.4 32 32 32h256c17.6 0 32-14.4 32-32V128H32v64zM360 0H24C10.8 0 0 10.8 0 24v48c0 13.2 10.8 24 24 24h336c13.2 0 24-10.8 24-24V24c0-13.2-10.8-24-24-24z"
                }
            }
        ]
    })(props);
}
function FaPrescription(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M301.26 352l78.06-78.06c6.25-6.25 6.25-16.38 0-22.63l-22.63-22.63c-6.25-6.25-16.38-6.25-22.63 0L256 306.74l-83.96-83.96C219.31 216.8 256 176.89 256 128c0-53.02-42.98-96-96-96H16C7.16 32 0 39.16 0 48v256c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16v-80h18.75l128 128-78.06 78.06c-6.25 6.25-6.25 16.38 0 22.63l22.63 22.63c6.25 6.25 16.38 6.25 22.63 0L256 397.25l78.06 78.06c6.25 6.25 16.38 6.25 22.63 0l22.63-22.63c6.25-6.25 6.25-16.38 0-22.63L301.26 352zM64 96h96c17.64 0 32 14.36 32 32s-14.36 32-32 32H64V96z"
                }
            }
        ]
    })(props);
}
function FaPrint(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M448 192V77.25c0-8.49-3.37-16.62-9.37-22.63L393.37 9.37c-6-6-14.14-9.37-22.63-9.37H96C78.33 0 64 14.33 64 32v160c-35.35 0-64 28.65-64 64v112c0 8.84 7.16 16 16 16h48v96c0 17.67 14.33 32 32 32h320c17.67 0 32-14.33 32-32v-96h48c8.84 0 16-7.16 16-16V256c0-35.35-28.65-64-64-64zm-64 256H128v-96h256v96zm0-224H128V64h192v48c0 8.84 7.16 16 16 16h48v96zm48 72c-13.25 0-24-10.75-24-24 0-13.26 10.75-24 24-24s24 10.74 24 24c0 13.25-10.75 24-24 24z"
                }
            }
        ]
    })(props);
}
function FaProcedures(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M528 224H272c-8.8 0-16 7.2-16 16v144H64V144c0-8.8-7.2-16-16-16H16c-8.8 0-16 7.2-16 16v352c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-48h512v48c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V336c0-61.9-50.1-112-112-112zM136 96h126.1l27.6 55.2c5.9 11.8 22.7 11.8 28.6 0L368 51.8 390.1 96H512c8.8 0 16-7.2 16-16s-7.2-16-16-16H409.9L382.3 8.8C376.4-3 359.6-3 353.7 8.8L304 108.2l-19.9-39.8c-1.4-2.7-4.1-4.4-7.2-4.4H136c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8zm24 256c35.3 0 64-28.7 64-64s-28.7-64-64-64-64 28.7-64 64 28.7 64 64 64z"
                }
            }
        ]
    })(props);
}
function FaProjectDiagram(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M384 320H256c-17.67 0-32 14.33-32 32v128c0 17.67 14.33 32 32 32h128c17.67 0 32-14.33 32-32V352c0-17.67-14.33-32-32-32zM192 32c0-17.67-14.33-32-32-32H32C14.33 0 0 14.33 0 32v128c0 17.67 14.33 32 32 32h95.72l73.16 128.04C211.98 300.98 232.4 288 256 288h.28L192 175.51V128h224V64H192V32zM608 0H480c-17.67 0-32 14.33-32 32v128c0 17.67 14.33 32 32 32h128c17.67 0 32-14.33 32-32V32c0-17.67-14.33-32-32-32z"
                }
            }
        ]
    })(props);
}
function FaPumpMedical(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M235.51,159.82H84.24A64,64,0,0,0,20.51,218L.14,442a64,64,0,0,0,63.74,69.8h192A64,64,0,0,0,319.61,442L299.24,218A64,64,0,0,0,235.51,159.82Zm4.37,173.33a13.35,13.35,0,0,1-13.34,13.34h-40v40a13.33,13.33,0,0,1-13.33,13.33H146.54a13.33,13.33,0,0,1-13.33-13.33v-40h-40a13.34,13.34,0,0,1-13.33-13.34V306.49a13.33,13.33,0,0,1,13.33-13.34h40v-40a13.33,13.33,0,0,1,13.33-13.33h26.67a13.33,13.33,0,0,1,13.33,13.33v40h40a13.34,13.34,0,0,1,13.34,13.34ZM379.19,93.88,335.87,50.56a64,64,0,0,0-45.24-18.74H223.88a32,32,0,0,0-32-32h-64a32,32,0,0,0-32,32v96h128v-32h66.75l43.31,43.31a16,16,0,0,0,22.63,0l22.62-22.62A16,16,0,0,0,379.19,93.88Z"
                }
            }
        ]
    })(props);
}
function FaPumpSoap(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M235.63,160H84.37a64,64,0,0,0-63.74,58.21L.27,442.21A64,64,0,0,0,64,512H256a64,64,0,0,0,63.74-69.79l-20.36-224A64,64,0,0,0,235.63,160ZM160,416c-33.12,0-60-26.33-60-58.75,0-25,35.7-75.47,52-97.27A10,10,0,0,1,168,260c16.33,21.8,52,72.27,52,97.27C220,389.67,193.12,416,160,416ZM379.31,94.06,336,50.74A64,64,0,0,0,290.75,32H224A32,32,0,0,0,192,0H128A32,32,0,0,0,96,32v96H224V96h66.75l43.31,43.31a16,16,0,0,0,22.63,0l22.62-22.62A16,16,0,0,0,379.31,94.06Z"
                }
            }
        ]
    })(props);
}
function FaPuzzlePiece(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M519.442 288.651c-41.519 0-59.5 31.593-82.058 31.593C377.409 320.244 432 144 432 144s-196.288 80-196.288-3.297c0-35.827 36.288-46.25 36.288-85.985C272 19.216 243.885 0 210.539 0c-34.654 0-66.366 18.891-66.366 56.346 0 41.364 31.711 59.277 31.711 81.75C175.885 207.719 0 166.758 0 166.758v333.237s178.635 41.047 178.635-28.662c0-22.473-40-40.107-40-81.471 0-37.456 29.25-56.346 63.577-56.346 33.673 0 61.788 19.216 61.788 54.717 0 39.735-36.288 50.158-36.288 85.985 0 60.803 129.675 25.73 181.23 25.73 0 0-34.725-120.101 25.827-120.101 35.962 0 46.423 36.152 86.308 36.152C556.712 416 576 387.99 576 354.443c0-34.199-18.962-65.792-56.558-65.792z"
                }
            }
        ]
    })(props);
}
function FaQrcode(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 224h192V32H0v192zM64 96h64v64H64V96zm192-64v192h192V32H256zm128 128h-64V96h64v64zM0 480h192V288H0v192zm64-128h64v64H64v-64zm352-64h32v128h-96v-32h-32v96h-64V288h96v32h64v-32zm0 160h32v32h-32v-32zm-64 0h32v32h-32v-32z"
                }
            }
        ]
    })(props);
}
function FaQuestionCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M504 256c0 136.997-111.043 248-248 248S8 392.997 8 256C8 119.083 119.043 8 256 8s248 111.083 248 248zM262.655 90c-54.497 0-89.255 22.957-116.549 63.758-3.536 5.286-2.353 12.415 2.715 16.258l34.699 26.31c5.205 3.947 12.621 3.008 16.665-2.122 17.864-22.658 30.113-35.797 57.303-35.797 20.429 0 45.698 13.148 45.698 32.958 0 14.976-12.363 22.667-32.534 33.976C247.128 238.528 216 254.941 216 296v4c0 6.627 5.373 12 12 12h56c6.627 0 12-5.373 12-12v-1.333c0-28.462 83.186-29.647 83.186-106.667 0-58.002-60.165-102-116.531-102zM256 338c-25.365 0-46 20.635-46 46 0 25.364 20.635 46 46 46s46-20.636 46-46c0-25.365-20.635-46-46-46z"
                }
            }
        ]
    })(props);
}
function FaQuestion(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M202.021 0C122.202 0 70.503 32.703 29.914 91.026c-7.363 10.58-5.093 25.086 5.178 32.874l43.138 32.709c10.373 7.865 25.132 6.026 33.253-4.148 25.049-31.381 43.63-49.449 82.757-49.449 30.764 0 68.816 19.799 68.816 49.631 0 22.552-18.617 34.134-48.993 51.164-35.423 19.86-82.299 44.576-82.299 106.405V320c0 13.255 10.745 24 24 24h72.471c13.255 0 24-10.745 24-24v-5.773c0-42.86 125.268-44.645 125.268-160.627C377.504 66.256 286.902 0 202.021 0zM192 373.459c-38.196 0-69.271 31.075-69.271 69.271 0 38.195 31.075 69.27 69.271 69.27s69.271-31.075 69.271-69.271-31.075-69.27-69.271-69.27z"
                }
            }
        ]
    })(props);
}
function FaQuidditch(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256.5 216.8L343.2 326s-16.6 102.4-76.6 150.1C206.7 523.8 0 510.2 0 510.2s3.8-23.1 11-55.4l94.6-112.2c4-4.7-.9-11.6-6.6-9.5l-60.4 22.1c14.4-41.7 32.7-80 54.6-97.5 59.9-47.8 163.3-40.9 163.3-40.9zm238 135c-44 0-79.8 35.8-79.8 79.9 0 44.1 35.7 79.9 79.8 79.9 44.1 0 79.8-35.8 79.8-79.9 0-44.2-35.8-79.9-79.8-79.9zM636.5 31L616.7 6c-5.5-6.9-15.5-8-22.4-2.6L361.8 181.3l-34.1-43c-5.1-6.4-15.1-5.2-18.6 2.2l-25.3 54.6 86.7 109.2 58.8-12.4c8-1.7 11.4-11.2 6.3-17.6l-34.1-42.9L634 53.5c6.9-5.5 8-15.6 2.5-22.5z"
                }
            }
        ]
    })(props);
}
function FaQuoteLeft(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M464 256h-80v-64c0-35.3 28.7-64 64-64h8c13.3 0 24-10.7 24-24V56c0-13.3-10.7-24-24-24h-8c-88.4 0-160 71.6-160 160v240c0 26.5 21.5 48 48 48h128c26.5 0 48-21.5 48-48V304c0-26.5-21.5-48-48-48zm-288 0H96v-64c0-35.3 28.7-64 64-64h8c13.3 0 24-10.7 24-24V56c0-13.3-10.7-24-24-24h-8C71.6 32 0 103.6 0 192v240c0 26.5 21.5 48 48 48h128c26.5 0 48-21.5 48-48V304c0-26.5-21.5-48-48-48z"
                }
            }
        ]
    })(props);
}
function FaQuoteRight(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M464 32H336c-26.5 0-48 21.5-48 48v128c0 26.5 21.5 48 48 48h80v64c0 35.3-28.7 64-64 64h-8c-13.3 0-24 10.7-24 24v48c0 13.3 10.7 24 24 24h8c88.4 0 160-71.6 160-160V80c0-26.5-21.5-48-48-48zm-288 0H48C21.5 32 0 53.5 0 80v128c0 26.5 21.5 48 48 48h80v64c0 35.3-28.7 64-64 64h-8c-13.3 0-24 10.7-24 24v48c0 13.3 10.7 24 24 24h8c88.4 0 160-71.6 160-160V80c0-26.5-21.5-48-48-48z"
                }
            }
        ]
    })(props);
}
function FaQuran(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M448 358.4V25.6c0-16-9.6-25.6-25.6-25.6H96C41.6 0 0 41.6 0 96v320c0 54.4 41.6 96 96 96h326.4c12.8 0 25.6-9.6 25.6-25.6v-16c0-6.4-3.2-12.8-9.6-19.2-3.2-16-3.2-60.8 0-73.6 6.4-3.2 9.6-9.6 9.6-19.2zM301.08 145.82c.6-1.21 1.76-1.82 2.92-1.82s2.32.61 2.92 1.82l11.18 22.65 25 3.63c2.67.39 3.74 3.67 1.81 5.56l-18.09 17.63 4.27 24.89c.36 2.11-1.31 3.82-3.21 3.82-.5 0-1.02-.12-1.52-.38L304 211.87l-22.36 11.75c-.5.26-1.02.38-1.52.38-1.9 0-3.57-1.71-3.21-3.82l4.27-24.89-18.09-17.63c-1.94-1.89-.87-5.17 1.81-5.56l24.99-3.63 11.19-22.65zm-57.89-69.01c13.67 0 27.26 2.49 40.38 7.41a6.775 6.775 0 1 1-2.38 13.12c-.67 0-3.09-.21-4.13-.21-52.31 0-94.86 42.55-94.86 94.86 0 52.3 42.55 94.86 94.86 94.86 1.03 0 3.48-.21 4.13-.21 3.93 0 6.8 3.14 6.8 6.78 0 2.98-1.94 5.51-4.62 6.42-13.07 4.87-26.59 7.34-40.19 7.34C179.67 307.19 128 255.51 128 192c0-63.52 51.67-115.19 115.19-115.19zM380.8 448H96c-19.2 0-32-12.8-32-32s16-32 32-32h284.8v64z"
                }
            }
        ]
    })(props);
}
function FaRadiationAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M312 256h79.1c9.2 0 16.9-7.7 16-16.8-4.6-43.6-27-81.8-59.5-107.8-7.6-6.1-18.8-4.5-24 3.8L281.9 202c18 11.2 30.1 31.2 30.1 54zm-97.8 54.1L172.4 377c-4.9 7.8-2.4 18.4 5.8 22.5 21.1 10.4 44.7 16.5 69.8 16.5s48.7-6.1 69.9-16.5c8.2-4.1 10.6-14.7 5.8-22.5l-41.8-66.9c-9.8 6.2-21.4 9.9-33.8 9.9s-24.1-3.7-33.9-9.9zM104.9 256H184c0-22.8 12.1-42.8 30.2-54.1l-41.7-66.8c-5.2-8.3-16.4-9.9-24-3.8-32.6 26-54.9 64.2-59.5 107.8-1.1 9.2 6.7 16.9 15.9 16.9zM248 504c137 0 248-111 248-248S385 8 248 8 0 119 0 256s111 248 248 248zm0-432c101.5 0 184 82.5 184 184s-82.5 184-184 184S64 357.5 64 256 146.5 72 248 72zm0 216c17.7 0 32-14.3 32-32s-14.3-32-32-32-32 14.3-32 32 14.3 32 32 32z"
                }
            }
        ]
    })(props);
}
function FaRadiation(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M328.2 255.8h151.6c9.1 0 16.8-7.7 16.2-16.8-5.1-75.8-44.4-142.2-102.5-184.2-7.4-5.3-17.9-2.9-22.7 4.8L290.4 188c22.6 14.3 37.8 39.2 37.8 67.8zm-37.8 67.7c-12.3 7.7-26.8 12.4-42.4 12.4-15.6 0-30-4.7-42.4-12.4L125.2 452c-4.8 7.7-2.4 18.1 5.6 22.4C165.7 493.2 205.6 504 248 504s82.3-10.8 117.2-29.6c8-4.3 10.4-14.8 5.6-22.4l-80.4-128.5zM248 303.8c26.5 0 48-21.5 48-48s-21.5-48-48-48-48 21.5-48 48 21.5 48 48 48zm-231.8-48h151.6c0-28.6 15.2-53.5 37.8-67.7L125.2 59.7c-4.8-7.7-15.3-10.2-22.7-4.8C44.4 96.9 5.1 163.3 0 239.1c-.6 9 7.1 16.7 16.2 16.7z"
                }
            }
        ]
    })(props);
}
function FaRainbow(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M268.3 32.7C115.4 42.9 0 176.9 0 330.2V464c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V320C64 186.8 180.9 80.3 317.5 97.9 430.4 112.4 512 214 512 327.8V464c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V320c0-165.3-140-298.6-307.7-287.3zm-5.6 96.9C166 142 96 229.1 96 326.7V464c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V320c0-74.8 64.5-134.8 140.8-127.4 66.5 6.5 115.2 66.2 115.2 133.1V464c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V320c0-114.2-100.2-205.4-217.3-190.4zm6.2 96.3c-45.6 8.9-76.9 51.5-76.9 97.9V464c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V320c0-17.6 14.3-32 32-32s32 14.4 32 32v144c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V320c0-59.2-53.8-106-115.1-94.1z"
                }
            }
        ]
    })(props);
}
function FaRandom(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M504.971 359.029c9.373 9.373 9.373 24.569 0 33.941l-80 79.984c-15.01 15.01-40.971 4.49-40.971-16.971V416h-58.785a12.004 12.004 0 0 1-8.773-3.812l-70.556-75.596 53.333-57.143L352 336h32v-39.981c0-21.438 25.943-31.998 40.971-16.971l80 79.981zM12 176h84l52.781 56.551 53.333-57.143-70.556-75.596A11.999 11.999 0 0 0 122.785 96H12c-6.627 0-12 5.373-12 12v56c0 6.627 5.373 12 12 12zm372 0v39.984c0 21.46 25.961 31.98 40.971 16.971l80-79.984c9.373-9.373 9.373-24.569 0-33.941l-80-79.981C409.943 24.021 384 34.582 384 56.019V96h-58.785a12.004 12.004 0 0 0-8.773 3.812L96 336H12c-6.627 0-12 5.373-12 12v56c0 6.627 5.373 12 12 12h110.785c3.326 0 6.503-1.381 8.773-3.812L352 176h32z"
                }
            }
        ]
    })(props);
}
function FaReceipt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M358.4 3.2L320 48 265.6 3.2a15.9 15.9 0 0 0-19.2 0L192 48 137.6 3.2a15.9 15.9 0 0 0-19.2 0L64 48 25.6 3.2C15-4.7 0 2.8 0 16v480c0 13.2 15 20.7 25.6 12.8L64 464l54.4 44.8a15.9 15.9 0 0 0 19.2 0L192 464l54.4 44.8a15.9 15.9 0 0 0 19.2 0L320 464l38.4 44.8c10.5 7.9 25.6.4 25.6-12.8V16c0-13.2-15-20.7-25.6-12.8zM320 360c0 4.4-3.6 8-8 8H72c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h240c4.4 0 8 3.6 8 8v16zm0-96c0 4.4-3.6 8-8 8H72c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h240c4.4 0 8 3.6 8 8v16zm0-96c0 4.4-3.6 8-8 8H72c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h240c4.4 0 8 3.6 8 8v16z"
                }
            }
        ]
    })(props);
}
function FaRecordVinyl(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 152a104 104 0 1 0 104 104 104 104 0 0 0-104-104zm0 128a24 24 0 1 1 24-24 24 24 0 0 1-24 24zm0-272C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm0 376a128 128 0 1 1 128-128 128 128 0 0 1-128 128z"
                }
            }
        ]
    })(props);
}
function FaRecycle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M184.561 261.903c3.232 13.997-12.123 24.635-24.068 17.168l-40.736-25.455-50.867 81.402C55.606 356.273 70.96 384 96.012 384H148c6.627 0 12 5.373 12 12v40c0 6.627-5.373 12-12 12H96.115c-75.334 0-121.302-83.048-81.408-146.88l50.822-81.388-40.725-25.448c-12.081-7.547-8.966-25.961 4.879-29.158l110.237-25.45c8.611-1.988 17.201 3.381 19.189 11.99l25.452 110.237zm98.561-182.915l41.289 66.076-40.74 25.457c-12.051 7.528-9 25.953 4.879 29.158l110.237 25.45c8.672 1.999 17.215-3.438 19.189-11.99l25.45-110.237c3.197-13.844-11.99-24.719-24.068-17.168l-40.687 25.424-41.263-66.082c-37.521-60.033-125.209-60.171-162.816 0l-17.963 28.766c-3.51 5.62-1.8 13.021 3.82 16.533l33.919 21.195c5.62 3.512 13.024 1.803 16.536-3.817l17.961-28.743c12.712-20.341 41.973-19.676 54.257-.022zM497.288 301.12l-27.515-44.065c-3.511-5.623-10.916-7.334-16.538-3.821l-33.861 21.159c-5.62 3.512-7.33 10.915-3.818 16.536l27.564 44.112c13.257 21.211-2.057 48.96-27.136 48.96H320V336.02c0-14.213-17.242-21.383-27.313-11.313l-80 79.981c-6.249 6.248-6.249 16.379 0 22.627l80 79.989C302.689 517.308 320 510.3 320 495.989V448h95.88c75.274 0 121.335-82.997 81.408-146.88z"
                }
            }
        ]
    })(props);
}
function FaRedoAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256.455 8c66.269.119 126.437 26.233 170.859 68.685l35.715-35.715C478.149 25.851 504 36.559 504 57.941V192c0 13.255-10.745 24-24 24H345.941c-21.382 0-32.09-25.851-16.971-40.971l41.75-41.75c-30.864-28.899-70.801-44.907-113.23-45.273-92.398-.798-170.283 73.977-169.484 169.442C88.764 348.009 162.184 424 256 424c41.127 0 79.997-14.678 110.629-41.556 4.743-4.161 11.906-3.908 16.368.553l39.662 39.662c4.872 4.872 4.631 12.815-.482 17.433C378.202 479.813 319.926 504 256 504 119.034 504 8.001 392.967 8 256.002 7.999 119.193 119.646 7.755 256.455 8z"
                }
            }
        ]
    })(props);
}
function FaRedo(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M500.33 0h-47.41a12 12 0 0 0-12 12.57l4 82.76A247.42 247.42 0 0 0 256 8C119.34 8 7.9 119.53 8 256.19 8.1 393.07 119.1 504 256 504a247.1 247.1 0 0 0 166.18-63.91 12 12 0 0 0 .48-17.43l-34-34a12 12 0 0 0-16.38-.55A176 176 0 1 1 402.1 157.8l-101.53-4.87a12 12 0 0 0-12.57 12v47.41a12 12 0 0 0 12 12h200.33a12 12 0 0 0 12-12V12a12 12 0 0 0-12-12z"
                }
            }
        ]
    })(props);
}
function FaRegistered(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M285.363 207.475c0 18.6-9.831 28.431-28.431 28.431h-29.876v-56.14h23.378c28.668 0 34.929 8.773 34.929 27.709zM504 256c0 136.967-111.033 248-248 248S8 392.967 8 256 119.033 8 256 8s248 111.033 248 248zM363.411 360.414c-46.729-84.825-43.299-78.636-44.702-80.98 23.432-15.172 37.945-42.979 37.945-74.486 0-54.244-31.5-89.252-105.498-89.252h-70.667c-13.255 0-24 10.745-24 24V372c0 13.255 10.745 24 24 24h22.567c13.255 0 24-10.745 24-24v-71.663h25.556l44.129 82.937a24.001 24.001 0 0 0 21.188 12.727h24.464c18.261-.001 29.829-19.591 21.018-35.587z"
                }
            }
        ]
    })(props);
}
function FaRemoveFormat(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M336 416h-11.17l9.26-27.77L267 336.4 240.49 416H208a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h128a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm297.82 42.1L377 259.59 426.17 112H544v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16H176a16 16 0 0 0-16 16v43.9L45.46 3.38A16 16 0 0 0 23 6.19L3.37 31.46a16 16 0 0 0 2.81 22.45l588.36 454.72a16 16 0 0 0 22.46-2.81l19.64-25.27a16 16 0 0 0-2.82-22.45zM309.91 207.76L224 141.36V112h117.83z"
                }
            }
        ]
    })(props);
}
function FaReplyAll(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M136.309 189.836L312.313 37.851C327.72 24.546 352 35.348 352 56.015v82.763c129.182 10.231 224 52.212 224 183.548 0 61.441-39.582 122.309-83.333 154.132-13.653 9.931-33.111-2.533-28.077-18.631 38.512-123.162-3.922-169.482-112.59-182.015v84.175c0 20.701-24.3 31.453-39.687 18.164L136.309 226.164c-11.071-9.561-11.086-26.753 0-36.328zm-128 36.328L184.313 378.15C199.7 391.439 224 380.687 224 359.986v-15.818l-108.606-93.785A55.96 55.96 0 0 1 96 207.998a55.953 55.953 0 0 1 19.393-42.38L224 71.832V56.015c0-20.667-24.28-31.469-39.687-18.164L8.309 189.836c-11.086 9.575-11.071 26.767 0 36.328z"
                }
            }
        ]
    })(props);
}
function FaReply(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8.309 189.836L184.313 37.851C199.719 24.546 224 35.347 224 56.015v80.053c160.629 1.839 288 34.032 288 186.258 0 61.441-39.581 122.309-83.333 154.132-13.653 9.931-33.111-2.533-28.077-18.631 45.344-145.012-21.507-183.51-176.59-185.742V360c0 20.7-24.3 31.453-39.687 18.164l-176.004-152c-11.071-9.562-11.086-26.753 0-36.328z"
                }
            }
        ]
    })(props);
}
function FaRepublican(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M544 192c0-88.4-71.6-160-160-160H160C71.6 32 0 103.6 0 192v64h544v-64zm-367.7-21.6l-19.8 19.3 4.7 27.3c.8 4.9-4.3 8.6-8.7 6.3L128 210.4l-24.5 12.9c-4.3 2.3-9.5-1.4-8.7-6.3l4.7-27.3-19.8-19.3c-3.6-3.5-1.6-9.5 3.3-10.2l27.4-4 12.2-24.8c2.2-4.5 8.6-4.4 10.7 0l12.2 24.8 27.4 4c5 .7 6.9 6.7 3.4 10.2zm144 0l-19.8 19.3 4.7 27.3c.8 4.9-4.3 8.6-8.7 6.3L272 210.4l-24.5 12.9c-4.3 2.3-9.5-1.4-8.7-6.3l4.7-27.3-19.8-19.3c-3.6-3.5-1.6-9.5 3.3-10.2l27.4-4 12.2-24.8c2.2-4.5 8.6-4.4 10.7 0l12.2 24.8 27.4 4c5 .7 6.9 6.7 3.4 10.2zm144 0l-19.8 19.3 4.7 27.3c.8 4.9-4.3 8.6-8.7 6.3L416 210.4l-24.5 12.9c-4.3 2.3-9.5-1.4-8.7-6.3l4.7-27.3-19.8-19.3c-3.6-3.5-1.6-9.5 3.3-10.2l27.4-4 12.2-24.8c2.2-4.5 8.6-4.4 10.7 0l12.2 24.8 27.4 4c5 .7 6.9 6.7 3.4 10.2zM624 320h-32c-8.8 0-16 7.2-16 16v64c0 8.8-7.2 16-16 16s-16-7.2-16-16V288H0v176c0 8.8 7.2 16 16 16h96c8.8 0 16-7.2 16-16v-80h192v80c0 8.8 7.2 16 16 16h96c8.8 0 16-7.2 16-16V352h32v43.3c0 41.8 30 80.1 71.6 84.3 47.8 4.9 88.4-32.7 88.4-79.6v-64c0-8.8-7.2-16-16-16z"
                }
            }
        ]
    })(props);
}
function FaRestroom(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M128 128c35.3 0 64-28.7 64-64S163.3 0 128 0 64 28.7 64 64s28.7 64 64 64zm384 0c35.3 0 64-28.7 64-64S547.3 0 512 0s-64 28.7-64 64 28.7 64 64 64zm127.3 226.5l-45.6-185.8c-3.3-13.5-15.5-23-29.8-24.2-15 9.7-32.8 15.5-52 15.5-19.2 0-37-5.8-52-15.5-14.3 1.2-26.5 10.7-29.8 24.2l-45.6 185.8C381 369.6 393 384 409.2 384H464v104c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24V384h54.8c16.2 0 28.2-14.4 24.5-29.5zM336 0h-32c-8.8 0-16 7.2-16 16v480c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V16c0-8.8-7.2-16-16-16zM180.1 144.4c-15 9.8-32.9 15.6-52.1 15.6-19.2 0-37.1-5.8-52.1-15.6C51.3 146.5 32 166.9 32 192v136c0 13.3 10.7 24 24 24h8v136c0 13.3 10.7 24 24 24h80c13.3 0 24-10.7 24-24V352h8c13.3 0 24-10.7 24-24V192c0-25.1-19.3-45.5-43.9-47.6z"
                }
            }
        ]
    })(props);
}
function FaRetweet(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M629.657 343.598L528.971 444.284c-9.373 9.372-24.568 9.372-33.941 0L394.343 343.598c-9.373-9.373-9.373-24.569 0-33.941l10.823-10.823c9.562-9.562 25.133-9.34 34.419.492L480 342.118V160H292.451a24.005 24.005 0 0 1-16.971-7.029l-16-16C244.361 121.851 255.069 96 276.451 96H520c13.255 0 24 10.745 24 24v222.118l40.416-42.792c9.285-9.831 24.856-10.054 34.419-.492l10.823 10.823c9.372 9.372 9.372 24.569-.001 33.941zm-265.138 15.431A23.999 23.999 0 0 0 347.548 352H160V169.881l40.416 42.792c9.286 9.831 24.856 10.054 34.419.491l10.822-10.822c9.373-9.373 9.373-24.569 0-33.941L144.971 67.716c-9.373-9.373-24.569-9.373-33.941 0L10.343 168.402c-9.373 9.373-9.373 24.569 0 33.941l10.822 10.822c9.562 9.562 25.133 9.34 34.419-.491L96 169.881V392c0 13.255 10.745 24 24 24h243.549c21.382 0 32.09-25.851 16.971-40.971l-16.001-16z"
                }
            }
        ]
    })(props);
}
function FaRibbon(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6.1 444.3c-9.6 10.8-7.5 27.6 4.5 35.7l68.8 27.9c9.9 6.7 23.3 5 31.3-3.8l91.8-101.9-79.2-87.9-117.2 130zm435.8 0s-292-324.6-295.4-330.1c15.4-8.4 40.2-17.9 77.5-17.9s62.1 9.5 77.5 17.9c-3.3 5.6-56 64.6-56 64.6l79.1 87.7 34.2-38c28.7-31.9 33.3-78.6 11.4-115.5l-43.7-73.5c-4.3-7.2-9.9-13.3-16.8-18-40.7-27.6-127.4-29.7-171.4 0-6.9 4.7-12.5 10.8-16.8 18l-43.6 73.2c-1.5 2.5-37.1 62.2 11.5 116L337.5 504c8 8.9 21.4 10.5 31.3 3.8l68.8-27.9c11.9-8 14-24.8 4.3-35.6z"
                }
            }
        ]
    })(props);
}
function FaRing(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 64C110.06 64 0 125.91 0 208v98.13C0 384.48 114.62 448 256 448s256-63.52 256-141.87V208c0-82.09-110.06-144-256-144zm0 64c106.04 0 192 35.82 192 80 0 9.26-3.97 18.12-10.91 26.39C392.15 208.21 328.23 192 256 192s-136.15 16.21-181.09 42.39C67.97 226.12 64 217.26 64 208c0-44.18 85.96-80 192-80zM120.43 264.64C155.04 249.93 201.64 240 256 240s100.96 9.93 135.57 24.64C356.84 279.07 308.93 288 256 288s-100.84-8.93-135.57-23.36z"
                }
            }
        ]
    })(props);
}
function FaRoad(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M573.19 402.67l-139.79-320C428.43 71.29 417.6 64 405.68 64h-97.59l2.45 23.16c.5 4.72-3.21 8.84-7.96 8.84h-29.16c-4.75 0-8.46-4.12-7.96-8.84L267.91 64h-97.59c-11.93 0-22.76 7.29-27.73 18.67L2.8 402.67C-6.45 423.86 8.31 448 30.54 448h196.84l10.31-97.68c.86-8.14 7.72-14.32 15.91-14.32h68.8c8.19 0 15.05 6.18 15.91 14.32L348.62 448h196.84c22.23 0 36.99-24.14 27.73-45.33zM260.4 135.16a8 8 0 0 1 7.96-7.16h39.29c4.09 0 7.53 3.09 7.96 7.16l4.6 43.58c.75 7.09-4.81 13.26-11.93 13.26h-40.54c-7.13 0-12.68-6.17-11.93-13.26l4.59-43.58zM315.64 304h-55.29c-9.5 0-16.91-8.23-15.91-17.68l5.07-48c.86-8.14 7.72-14.32 15.91-14.32h45.15c8.19 0 15.05 6.18 15.91 14.32l5.07 48c1 9.45-6.41 17.68-15.91 17.68z"
                }
            }
        ]
    })(props);
}
function FaRobot(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M32,224H64V416H32A31.96166,31.96166,0,0,1,0,384V256A31.96166,31.96166,0,0,1,32,224Zm512-48V448a64.06328,64.06328,0,0,1-64,64H160a64.06328,64.06328,0,0,1-64-64V176a79.974,79.974,0,0,1,80-80H288V32a32,32,0,0,1,64,0V96H464A79.974,79.974,0,0,1,544,176ZM264,256a40,40,0,1,0-40,40A39.997,39.997,0,0,0,264,256Zm-8,128H192v32h64Zm96,0H288v32h64ZM456,256a40,40,0,1,0-40,40A39.997,39.997,0,0,0,456,256Zm-8,128H384v32h64ZM640,256V384a31.96166,31.96166,0,0,1-32,32H576V224h32A31.96166,31.96166,0,0,1,640,256Z"
                }
            }
        ]
    })(props);
}
function FaRocket(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M505.12019,19.09375c-1.18945-5.53125-6.65819-11-12.207-12.1875C460.716,0,435.507,0,410.40747,0,307.17523,0,245.26909,55.20312,199.05238,128H94.83772c-16.34763.01562-35.55658,11.875-42.88664,26.48438L2.51562,253.29688A28.4,28.4,0,0,0,0,264a24.00867,24.00867,0,0,0,24.00582,24H127.81618l-22.47457,22.46875c-11.36521,11.36133-12.99607,32.25781,0,45.25L156.24582,406.625c11.15623,11.1875,32.15619,13.15625,45.27726,0l22.47457-22.46875V488a24.00867,24.00867,0,0,0,24.00581,24,28.55934,28.55934,0,0,0,10.707-2.51562l98.72834-49.39063c14.62888-7.29687,26.50776-26.5,26.50776-42.85937V312.79688c72.59753-46.3125,128.03493-108.40626,128.03493-211.09376C512.07526,76.5,512.07526,51.29688,505.12019,19.09375ZM384.04033,168A40,40,0,1,1,424.05,128,40.02322,40.02322,0,0,1,384.04033,168Z"
                }
            }
        ]
    })(props);
}
function FaRoute(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M416 320h-96c-17.6 0-32-14.4-32-32s14.4-32 32-32h96s96-107 96-160-43-96-96-96-96 43-96 96c0 25.5 22.2 63.4 45.3 96H320c-52.9 0-96 43.1-96 96s43.1 96 96 96h96c17.6 0 32 14.4 32 32s-14.4 32-32 32H185.5c-16 24.8-33.8 47.7-47.3 64H416c52.9 0 96-43.1 96-96s-43.1-96-96-96zm0-256c17.7 0 32 14.3 32 32s-14.3 32-32 32-32-14.3-32-32 14.3-32 32-32zM96 256c-53 0-96 43-96 96s96 160 96 160 96-107 96-160-43-96-96-96zm0 128c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32z"
                }
            }
        ]
    })(props);
}
function FaRssSquare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M400 32H48C21.49 32 0 53.49 0 80v352c0 26.51 21.49 48 48 48h352c26.51 0 48-21.49 48-48V80c0-26.51-21.49-48-48-48zM112 416c-26.51 0-48-21.49-48-48s21.49-48 48-48 48 21.49 48 48-21.49 48-48 48zm157.533 0h-34.335c-6.011 0-11.051-4.636-11.442-10.634-5.214-80.05-69.243-143.92-149.123-149.123-5.997-.39-10.633-5.431-10.633-11.441v-34.335c0-6.535 5.468-11.777 11.994-11.425 110.546 5.974 198.997 94.536 204.964 204.964.352 6.526-4.89 11.994-11.425 11.994zm103.027 0h-34.334c-6.161 0-11.175-4.882-11.427-11.038-5.598-136.535-115.204-246.161-251.76-251.76C68.882 152.949 64 147.935 64 141.774V107.44c0-6.454 5.338-11.664 11.787-11.432 167.83 6.025 302.21 141.191 308.205 308.205.232 6.449-4.978 11.787-11.432 11.787z"
                }
            }
        ]
    })(props);
}
function FaRss(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M128.081 415.959c0 35.369-28.672 64.041-64.041 64.041S0 451.328 0 415.959s28.672-64.041 64.041-64.041 64.04 28.673 64.04 64.041zm175.66 47.25c-8.354-154.6-132.185-278.587-286.95-286.95C7.656 175.765 0 183.105 0 192.253v48.069c0 8.415 6.49 15.472 14.887 16.018 111.832 7.284 201.473 96.702 208.772 208.772.547 8.397 7.604 14.887 16.018 14.887h48.069c9.149.001 16.489-7.655 15.995-16.79zm144.249.288C439.596 229.677 251.465 40.445 16.503 32.01 7.473 31.686 0 38.981 0 48.016v48.068c0 8.625 6.835 15.645 15.453 15.999 191.179 7.839 344.627 161.316 352.465 352.465.353 8.618 7.373 15.453 15.999 15.453h48.068c9.034-.001 16.329-7.474 16.005-16.504z"
                }
            }
        ]
    })(props);
}
function FaRubleSign(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M239.36 320C324.48 320 384 260.542 384 175.071S324.48 32 239.36 32H76c-6.627 0-12 5.373-12 12v206.632H12c-6.627 0-12 5.373-12 12V308c0 6.627 5.373 12 12 12h52v32H12c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h52v52c0 6.627 5.373 12 12 12h58.56c6.627 0 12-5.373 12-12v-52H308c6.627 0 12-5.373 12-12v-40c0-6.627-5.373-12-12-12H146.56v-32h92.8zm-92.8-219.252h78.72c46.72 0 74.88 29.11 74.88 74.323 0 45.832-28.16 75.561-76.16 75.561h-77.44V100.748z"
                }
            }
        ]
    })(props);
}
function FaRulerCombined(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M160 288h-56c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h56v-64h-56c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h56V96h-56c-4.42 0-8-3.58-8-8V72c0-4.42 3.58-8 8-8h56V32c0-17.67-14.33-32-32-32H32C14.33 0 0 14.33 0 32v448c0 2.77.91 5.24 1.57 7.8L160 329.38V288zm320 64h-32v56c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8v-56h-64v56c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8v-56h-64v56c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8v-56h-41.37L24.2 510.43c2.56.66 5.04 1.57 7.8 1.57h448c17.67 0 32-14.33 32-32v-96c0-17.67-14.33-32-32-32z"
                }
            }
        ]
    })(props);
}
function FaRulerHorizontal(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M544 128h-48v88c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8v-88h-64v88c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8v-88h-64v88c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8v-88h-64v88c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8v-88h-64v88c0 4.42-3.58 8-8 8H88c-4.42 0-8-3.58-8-8v-88H32c-17.67 0-32 14.33-32 32v192c0 17.67 14.33 32 32 32h512c17.67 0 32-14.33 32-32V160c0-17.67-14.33-32-32-32z"
                }
            }
        ]
    })(props);
}
function FaRulerVertical(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 256 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M168 416c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h88v-64h-88c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h88v-64h-88c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h88v-64h-88c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h88V32c0-17.67-14.33-32-32-32H32C14.33 0 0 14.33 0 32v448c0 17.67 14.33 32 32 32h192c17.67 0 32-14.33 32-32v-64h-88z"
                }
            }
        ]
    })(props);
}
function FaRuler(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M635.7 167.2L556.1 31.7c-8.8-15-28.3-20.1-43.5-11.5l-69 39.1L503.3 161c2.2 3.8.9 8.5-2.9 10.7l-13.8 7.8c-3.8 2.2-8.7.9-10.9-2.9L416 75l-55.2 31.3 27.9 47.4c2.2 3.8.9 8.5-2.9 10.7l-13.8 7.8c-3.8 2.2-8.7.9-10.9-2.9L333.2 122 278 153.3 337.8 255c2.2 3.7.9 8.5-2.9 10.7l-13.8 7.8c-3.8 2.2-8.7.9-10.9-2.9l-59.7-101.7-55.2 31.3 27.9 47.4c2.2 3.8.9 8.5-2.9 10.7l-13.8 7.8c-3.8 2.2-8.7.9-10.9-2.9l-27.9-47.5-55.2 31.3 59.7 101.7c2.2 3.7.9 8.5-2.9 10.7l-13.8 7.8c-3.8 2.2-8.7.9-10.9-2.9L84.9 262.9l-69 39.1C.7 310.7-4.6 329.8 4.2 344.8l79.6 135.6c8.8 15 28.3 20.1 43.5 11.5L624.1 210c15.2-8.6 20.4-27.8 11.6-42.8z"
                }
            }
        ]
    })(props);
}
function FaRunning(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 416 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M272 96c26.51 0 48-21.49 48-48S298.51 0 272 0s-48 21.49-48 48 21.49 48 48 48zM113.69 317.47l-14.8 34.52H32c-17.67 0-32 14.33-32 32s14.33 32 32 32h77.45c19.25 0 36.58-11.44 44.11-29.09l8.79-20.52-10.67-6.3c-17.32-10.23-30.06-25.37-37.99-42.61zM384 223.99h-44.03l-26.06-53.25c-12.5-25.55-35.45-44.23-61.78-50.94l-71.08-21.14c-28.3-6.8-57.77-.55-80.84 17.14l-39.67 30.41c-14.03 10.75-16.69 30.83-5.92 44.86s30.84 16.66 44.86 5.92l39.69-30.41c7.67-5.89 17.44-8 25.27-6.14l14.7 4.37-37.46 87.39c-12.62 29.48-1.31 64.01 26.3 80.31l84.98 50.17-27.47 87.73c-5.28 16.86 4.11 34.81 20.97 40.09 3.19 1 6.41 1.48 9.58 1.48 13.61 0 26.23-8.77 30.52-22.45l31.64-101.06c5.91-20.77-2.89-43.08-21.64-54.39l-61.24-36.14 31.31-78.28 20.27 41.43c8 16.34 24.92 26.89 43.11 26.89H384c17.67 0 32-14.33 32-32s-14.33-31.99-32-31.99z"
                }
            }
        ]
    })(props);
}
function FaRupeeSign(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 320 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M308 96c6.627 0 12-5.373 12-12V44c0-6.627-5.373-12-12-12H12C5.373 32 0 37.373 0 44v44.748c0 6.627 5.373 12 12 12h85.28c27.308 0 48.261 9.958 60.97 27.252H12c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h158.757c-6.217 36.086-32.961 58.632-74.757 58.632H12c-6.627 0-12 5.373-12 12v53.012c0 3.349 1.4 6.546 3.861 8.818l165.052 152.356a12.001 12.001 0 0 0 8.139 3.182h82.562c10.924 0 16.166-13.408 8.139-20.818L116.871 319.906c76.499-2.34 131.144-53.395 138.318-127.906H308c6.627 0 12-5.373 12-12v-40c0-6.627-5.373-12-12-12h-58.69c-3.486-11.541-8.28-22.246-14.252-32H308z"
                }
            }
        ]
    })(props);
}
function FaSadCry(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111 8 0 119 0 256c0 90.1 48.2 168.7 120 212.1V288c0-8.8 7.2-16 16-16s16 7.2 16 16v196.7c29.5 12.4 62 19.3 96 19.3s66.5-6.9 96-19.3V288c0-8.8 7.2-16 16-16s16 7.2 16 16v180.1C447.8 424.7 496 346 496 256 496 119 385 8 248 8zm-65.5 216.5c-14.8-13.2-46.2-13.2-61 0L112 233c-3.8 3.3-9.3 4-13.7 1.6-4.4-2.4-6.9-7.4-6.1-12.4 4-25.2 34.2-42.1 59.9-42.1S208 197 212 222.2c.8 5-1.7 10-6.1 12.4-5.8 3.1-11.2.7-13.7-1.6l-9.7-8.5zM248 416c-26.5 0-48-28.7-48-64s21.5-64 48-64 48 28.7 48 64-21.5 64-48 64zm149.8-181.5c-5.8 3.1-11.2.7-13.7-1.6l-9.5-8.5c-14.8-13.2-46.2-13.2-61 0L304 233c-3.8 3.3-9.3 4-13.7 1.6-4.4-2.4-6.9-7.4-6.1-12.4 4-25.2 34.2-42.1 59.9-42.1S400 197 404 222.2c.6 4.9-1.8 9.9-6.2 12.3z"
                }
            }
        ]
    })(props);
}
function FaSadTear(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm80 168c17.7 0 32 14.3 32 32s-14.3 32-32 32-32-14.3-32-32 14.3-32 32-32zM152 416c-26.5 0-48-21-48-47 0-20 28.5-60.4 41.6-77.8 3.2-4.3 9.6-4.3 12.8 0C171.5 308.6 200 349 200 369c0 26-21.5 47-48 47zm16-176c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm170.2 154.2C315.8 367.4 282.9 352 248 352c-21.2 0-21.2-32 0-32 44.4 0 86.3 19.6 114.7 53.8 13.8 16.4-11.2 36.5-24.5 20.4z"
                }
            }
        ]
    })(props);
}
function FaSatelliteDish(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M305.44954,462.59c7.39157,7.29792,6.18829,20.09661-3.00038,25.00356-77.713,41.80281-176.72559,29.9105-242.34331-35.7082C-5.49624,386.28227-17.404,287.362,24.41381,209.554c4.89125-9.095,17.68975-10.29834,25.00318-3.00043L166.22872,323.36708l27.39411-27.39452c-.68759-2.60974-1.594-5.00071-1.594-7.81361a32.00407,32.00407,0,1,1,32.00407,32.00455c-2.79723,0-5.20378-.89075-7.79786-1.594l-27.40974,27.41015ZM511.9758,303.06732a16.10336,16.10336,0,0,1-16.002,17.00242H463.86031a15.96956,15.96956,0,0,1-15.89265-15.00213C440.46671,175.5492,336.45348,70.53427,207.03078,63.53328a15.84486,15.84486,0,0,1-15.00191-15.90852V16.02652A16.09389,16.09389,0,0,1,209.031.02425C372.25491,8.61922,503.47472,139.841,511.9758,303.06732Zm-96.01221-.29692a16.21093,16.21093,0,0,1-16.11142,17.29934H367.645a16.06862,16.06862,0,0,1-15.89265-14.70522c-6.90712-77.01094-68.118-138.91037-144.92467-145.22376a15.94,15.94,0,0,1-14.79876-15.89289V112.13393a16.134,16.134,0,0,1,17.29908-16.096C319.45132,104.5391,407.55627,192.64538,415.96359,302.7704Z"
                }
            }
        ]
    })(props);
}
function FaSatellite(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M502.60969,310.04206l-96.70393,96.71625a31.88151,31.88151,0,0,1-45.00765,0L280.572,326.34115l-9.89231,9.90759a190.56343,190.56343,0,0,1-5.40716,168.52287c-4.50077,8.50115-16.39342,9.59505-23.20707,2.79725L134.54715,400.05428l-17.7999,17.79929c.70324,2.60972,1.60965,5.00067,1.60965,7.79793a32.00544,32.00544,0,1,1-32.00544-32.00434c2.79735,0,5.18838.90637,7.7982,1.60959l17.7999-17.79929L4.43129,269.94287c-6.798-6.81342-5.70409-18.6119,2.79735-23.20627a190.58161,190.58161,0,0,1,168.52864-5.407l9.79854-9.79821-80.31053-80.41716a32.002,32.002,0,0,1,0-45.09987L201.96474,9.29814A31.62639,31.62639,0,0,1,224.46868,0a31.99951,31.99951,0,0,1,22.59759,9.29814l80.32615,80.30777,47.805-47.89713a33.6075,33.6075,0,0,1,47.50808,0l47.50807,47.50645a33.63308,33.63308,0,0,1,0,47.50644l-47.805,47.89713L502.71908,265.036A31.78938,31.78938,0,0,1,502.60969,310.04206ZM219.56159,197.433l73.82505-73.82252-68.918-68.9-73.80942,73.80689Zm237.74352,90.106-68.90233-68.9156-73.825,73.82252,68.918,68.9Z"
                }
            }
        ]
    })(props);
}
function FaSave(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M433.941 129.941l-83.882-83.882A48 48 0 0 0 316.118 32H48C21.49 32 0 53.49 0 80v352c0 26.51 21.49 48 48 48h352c26.51 0 48-21.49 48-48V163.882a48 48 0 0 0-14.059-33.941zM224 416c-35.346 0-64-28.654-64-64 0-35.346 28.654-64 64-64s64 28.654 64 64c0 35.346-28.654 64-64 64zm96-304.52V212c0 6.627-5.373 12-12 12H76c-6.627 0-12-5.373-12-12V108c0-6.627 5.373-12 12-12h228.52c3.183 0 6.235 1.264 8.485 3.515l3.48 3.48A11.996 11.996 0 0 1 320 111.48z"
                }
            }
        ]
    })(props);
}
function FaSchool(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 224v272c0 8.84 7.16 16 16 16h80V192H32c-17.67 0-32 14.33-32 32zm360-48h-24v-40c0-4.42-3.58-8-8-8h-16c-4.42 0-8 3.58-8 8v64c0 4.42 3.58 8 8 8h48c4.42 0 8-3.58 8-8v-16c0-4.42-3.58-8-8-8zm137.75-63.96l-160-106.67a32.02 32.02 0 0 0-35.5 0l-160 106.67A32.002 32.002 0 0 0 128 138.66V512h128V368c0-8.84 7.16-16 16-16h96c8.84 0 16 7.16 16 16v144h128V138.67c0-10.7-5.35-20.7-14.25-26.63zM320 256c-44.18 0-80-35.82-80-80s35.82-80 80-80 80 35.82 80 80-35.82 80-80 80zm288-64h-64v320h80c8.84 0 16-7.16 16-16V224c0-17.67-14.33-32-32-32z"
                }
            }
        ]
    })(props);
}
function FaScrewdriver(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M448 0L320 96v62.06l-83.03 83.03c6.79 4.25 13.27 9.06 19.07 14.87 5.8 5.8 10.62 12.28 14.87 19.07L353.94 192H416l96-128-64-64zM128 278.59L10.92 395.67c-14.55 14.55-14.55 38.15 0 52.71l52.7 52.7c14.56 14.56 38.15 14.56 52.71 0L233.41 384c29.11-29.11 29.11-76.3 0-105.41s-76.3-29.11-105.41 0z"
                }
            }
        ]
    })(props);
}
function FaScroll(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M48 0C21.53 0 0 21.53 0 48v64c0 8.84 7.16 16 16 16h80V48C96 21.53 74.47 0 48 0zm208 412.57V352h288V96c0-52.94-43.06-96-96-96H111.59C121.74 13.41 128 29.92 128 48v368c0 38.87 34.65 69.65 74.75 63.12C234.22 474 256 444.46 256 412.57zM288 384v32c0 52.93-43.06 96-96 96h336c61.86 0 112-50.14 112-112 0-8.84-7.16-16-16-16H288z"
                }
            }
        ]
    })(props);
}
function FaSdCard(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M320 0H128L0 128v320c0 35.3 28.7 64 64 64h256c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64zM160 160h-48V64h48v96zm80 0h-48V64h48v96zm80 0h-48V64h48v96z"
                }
            }
        ]
    })(props);
}
function FaSearchDollar(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M505.04 442.66l-99.71-99.69c-4.5-4.5-10.6-7-17-7h-16.3c27.6-35.3 44-79.69 44-127.99C416.03 93.09 322.92 0 208.02 0S0 93.09 0 207.98s93.11 207.98 208.02 207.98c48.3 0 92.71-16.4 128.01-44v16.3c0 6.4 2.5 12.5 7 17l99.71 99.69c9.4 9.4 24.6 9.4 33.9 0l28.3-28.3c9.4-9.4 9.4-24.59.1-33.99zm-297.02-90.7c-79.54 0-144-64.34-144-143.98 0-79.53 64.35-143.98 144-143.98 79.54 0 144 64.34 144 143.98 0 79.53-64.35 143.98-144 143.98zm27.11-152.54l-45.01-13.5c-5.16-1.55-8.77-6.78-8.77-12.73 0-7.27 5.3-13.19 11.8-13.19h28.11c4.56 0 8.96 1.29 12.82 3.72 3.24 2.03 7.36 1.91 10.13-.73l11.75-11.21c3.53-3.37 3.33-9.21-.57-12.14-9.1-6.83-20.08-10.77-31.37-11.35V112c0-4.42-3.58-8-8-8h-16c-4.42 0-8 3.58-8 8v16.12c-23.63.63-42.68 20.55-42.68 45.07 0 19.97 12.99 37.81 31.58 43.39l45.01 13.5c5.16 1.55 8.77 6.78 8.77 12.73 0 7.27-5.3 13.19-11.8 13.19h-28.1c-4.56 0-8.96-1.29-12.82-3.72-3.24-2.03-7.36-1.91-10.13.73l-11.75 11.21c-3.53 3.37-3.33 9.21.57 12.14 9.1 6.83 20.08 10.77 31.37 11.35V304c0 4.42 3.58 8 8 8h16c4.42 0 8-3.58 8-8v-16.12c23.63-.63 42.68-20.54 42.68-45.07 0-19.97-12.99-37.81-31.59-43.39z"
                }
            }
        ]
    })(props);
}
function FaSearchLocation(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M505.04 442.66l-99.71-99.69c-4.5-4.5-10.6-7-17-7h-16.3c27.6-35.3 44-79.69 44-127.99C416.03 93.09 322.92 0 208.02 0S0 93.09 0 207.98s93.11 207.98 208.02 207.98c48.3 0 92.71-16.4 128.01-44v16.3c0 6.4 2.5 12.5 7 17l99.71 99.69c9.4 9.4 24.6 9.4 33.9 0l28.3-28.3c9.4-9.4 9.4-24.59.1-33.99zm-297.02-90.7c-79.54 0-144-64.34-144-143.98 0-79.53 64.35-143.98 144-143.98 79.54 0 144 64.34 144 143.98 0 79.53-64.35 143.98-144 143.98zm.02-239.96c-40.78 0-73.84 33.05-73.84 73.83 0 32.96 48.26 93.05 66.75 114.86a9.24 9.24 0 0 0 14.18 0c18.49-21.81 66.75-81.89 66.75-114.86 0-40.78-33.06-73.83-73.84-73.83zm0 96c-13.26 0-24-10.75-24-24 0-13.26 10.75-24 24-24s24 10.74 24 24c0 13.25-10.75 24-24 24z"
                }
            }
        ]
    })(props);
}
function FaSearchMinus(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M304 192v32c0 6.6-5.4 12-12 12H124c-6.6 0-12-5.4-12-12v-32c0-6.6 5.4-12 12-12h168c6.6 0 12 5.4 12 12zm201 284.7L476.7 505c-9.4 9.4-24.6 9.4-33.9 0L343 405.3c-4.5-4.5-7-10.6-7-17V372c-35.3 27.6-79.7 44-128 44C93.1 416 0 322.9 0 208S93.1 0 208 0s208 93.1 208 208c0 48.3-16.4 92.7-44 128h16.3c6.4 0 12.5 2.5 17 7l99.7 99.7c9.3 9.4 9.3 24.6 0 34zM344 208c0-75.2-60.8-136-136-136S72 132.8 72 208s60.8 136 136 136 136-60.8 136-136z"
                }
            }
        ]
    })(props);
}
function FaSearchPlus(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M304 192v32c0 6.6-5.4 12-12 12h-56v56c0 6.6-5.4 12-12 12h-32c-6.6 0-12-5.4-12-12v-56h-56c-6.6 0-12-5.4-12-12v-32c0-6.6 5.4-12 12-12h56v-56c0-6.6 5.4-12 12-12h32c6.6 0 12 5.4 12 12v56h56c6.6 0 12 5.4 12 12zm201 284.7L476.7 505c-9.4 9.4-24.6 9.4-33.9 0L343 405.3c-4.5-4.5-7-10.6-7-17V372c-35.3 27.6-79.7 44-128 44C93.1 416 0 322.9 0 208S93.1 0 208 0s208 93.1 208 208c0 48.3-16.4 92.7-44 128h16.3c6.4 0 12.5 2.5 17 7l99.7 99.7c9.3 9.4 9.3 24.6 0 34zM344 208c0-75.2-60.8-136-136-136S72 132.8 72 208s60.8 136 136 136 136-60.8 136-136z"
                }
            }
        ]
    })(props);
}
function FaSearch(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M505 442.7L405.3 343c-4.5-4.5-10.6-7-17-7H372c27.6-35.3 44-79.7 44-128C416 93.1 322.9 0 208 0S0 93.1 0 208s93.1 208 208 208c48.3 0 92.7-16.4 128-44v16.3c0 6.4 2.5 12.5 7 17l99.7 99.7c9.4 9.4 24.6 9.4 33.9 0l28.3-28.3c9.4-9.4 9.4-24.6.1-34zM208 336c-70.7 0-128-57.2-128-128 0-70.7 57.2-128 128-128 70.7 0 128 57.2 128 128 0 70.7-57.2 128-128 128z"
                }
            }
        ]
    })(props);
}
function FaSeedling(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M64 96H0c0 123.7 100.3 224 224 224v144c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V320C288 196.3 187.7 96 64 96zm384-64c-84.2 0-157.4 46.5-195.7 115.2 27.7 30.2 48.2 66.9 59 107.6C424 243.1 512 147.9 512 32h-64z"
                }
            }
        ]
    })(props);
}
function FaServer(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M480 160H32c-17.673 0-32-14.327-32-32V64c0-17.673 14.327-32 32-32h448c17.673 0 32 14.327 32 32v64c0 17.673-14.327 32-32 32zm-48-88c-13.255 0-24 10.745-24 24s10.745 24 24 24 24-10.745 24-24-10.745-24-24-24zm-64 0c-13.255 0-24 10.745-24 24s10.745 24 24 24 24-10.745 24-24-10.745-24-24-24zm112 248H32c-17.673 0-32-14.327-32-32v-64c0-17.673 14.327-32 32-32h448c17.673 0 32 14.327 32 32v64c0 17.673-14.327 32-32 32zm-48-88c-13.255 0-24 10.745-24 24s10.745 24 24 24 24-10.745 24-24-10.745-24-24-24zm-64 0c-13.255 0-24 10.745-24 24s10.745 24 24 24 24-10.745 24-24-10.745-24-24-24zm112 248H32c-17.673 0-32-14.327-32-32v-64c0-17.673 14.327-32 32-32h448c17.673 0 32 14.327 32 32v64c0 17.673-14.327 32-32 32zm-48-88c-13.255 0-24 10.745-24 24s10.745 24 24 24 24-10.745 24-24-10.745-24-24-24zm-64 0c-13.255 0-24 10.745-24 24s10.745 24 24 24 24-10.745 24-24-10.745-24-24-24z"
                }
            }
        ]
    })(props);
}
function FaShapes(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M128,256A128,128,0,1,0,256,384,128,128,0,0,0,128,256Zm379-54.86L400.07,18.29a37.26,37.26,0,0,0-64.14,0L229,201.14C214.76,225.52,232.58,256,261.09,256H474.91C503.42,256,521.24,225.52,507,201.14ZM480,288H320a32,32,0,0,0-32,32V480a32,32,0,0,0,32,32H480a32,32,0,0,0,32-32V320A32,32,0,0,0,480,288Z"
                }
            }
        ]
    })(props);
}
function FaShareAltSquare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M448 80v352c0 26.51-21.49 48-48 48H48c-26.51 0-48-21.49-48-48V80c0-26.51 21.49-48 48-48h352c26.51 0 48 21.49 48 48zM304 296c-14.562 0-27.823 5.561-37.783 14.671l-67.958-40.775a56.339 56.339 0 0 0 0-27.793l67.958-40.775C276.177 210.439 289.438 216 304 216c30.928 0 56-25.072 56-56s-25.072-56-56-56-56 25.072-56 56c0 4.797.605 9.453 1.74 13.897l-67.958 40.775C171.823 205.561 158.562 200 144 200c-30.928 0-56 25.072-56 56s25.072 56 56 56c14.562 0 27.823-5.561 37.783-14.671l67.958 40.775a56.088 56.088 0 0 0-1.74 13.897c0 30.928 25.072 56 56 56s56-25.072 56-56C360 321.072 334.928 296 304 296z"
                }
            }
        ]
    })(props);
}
function FaShareAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M352 320c-22.608 0-43.387 7.819-59.79 20.895l-102.486-64.054a96.551 96.551 0 0 0 0-41.683l102.486-64.054C308.613 184.181 329.392 192 352 192c53.019 0 96-42.981 96-96S405.019 0 352 0s-96 42.981-96 96c0 7.158.79 14.13 2.276 20.841L155.79 180.895C139.387 167.819 118.608 160 96 160c-53.019 0-96 42.981-96 96s42.981 96 96 96c22.608 0 43.387-7.819 59.79-20.895l102.486 64.054A96.301 96.301 0 0 0 256 416c0 53.019 42.981 96 96 96s96-42.981 96-96-42.981-96-96-96z"
                }
            }
        ]
    })(props);
}
function FaShareSquare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M568.482 177.448L424.479 313.433C409.3 327.768 384 317.14 384 295.985v-71.963c-144.575.97-205.566 35.113-164.775 171.353 4.483 14.973-12.846 26.567-25.006 17.33C155.252 383.105 120 326.488 120 269.339c0-143.937 117.599-172.5 264-173.312V24.012c0-21.174 25.317-31.768 40.479-17.448l144.003 135.988c10.02 9.463 10.028 25.425 0 34.896zM384 379.128V448H64V128h50.916a11.99 11.99 0 0 0 8.648-3.693c14.953-15.568 32.237-27.89 51.014-37.676C185.708 80.83 181.584 64 169.033 64H48C21.49 64 0 85.49 0 112v352c0 26.51 21.49 48 48 48h352c26.51 0 48-21.49 48-48v-88.806c0-8.288-8.197-14.066-16.011-11.302a71.83 71.83 0 0 1-34.189 3.377c-7.27-1.046-13.8 4.514-13.8 11.859z"
                }
            }
        ]
    })(props);
}
function FaShare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M503.691 189.836L327.687 37.851C312.281 24.546 288 35.347 288 56.015v80.053C127.371 137.907 0 170.1 0 322.326c0 61.441 39.581 122.309 83.333 154.132 13.653 9.931 33.111-2.533 28.077-18.631C66.066 312.814 132.917 274.316 288 272.085V360c0 20.7 24.3 31.453 39.687 18.164l176.004-152c11.071-9.562 11.086-26.753 0-36.328z"
                }
            }
        ]
    })(props);
}
function FaShekelSign(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 168v168c0 8.84 7.16 16 16 16h48c8.84 0 16-7.16 16-16V168c0-75.11-60.89-136-136-136H24C10.75 32 0 42.74 0 56v408c0 8.84 7.16 16 16 16h48c8.84 0 16-7.16 16-16V112h112c30.93 0 56 25.07 56 56zM432 32h-48c-8.84 0-16 7.16-16 16v296c0 30.93-25.07 56-56 56H200V176c0-8.84-7.16-16-16-16h-48c-8.84 0-16 7.16-16 16v280c0 13.25 10.75 24 24 24h168c75.11 0 136-60.89 136-136V48c0-8.84-7.16-16-16-16z"
                }
            }
        ]
    })(props);
}
function FaShieldAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M466.5 83.7l-192-80a48.15 48.15 0 0 0-36.9 0l-192 80C27.7 91.1 16 108.6 16 128c0 198.5 114.5 335.7 221.5 380.3 11.8 4.9 25.1 4.9 36.9 0C360.1 472.6 496 349.3 496 128c0-19.4-11.7-36.9-29.5-44.3zM256.1 446.3l-.1-381 175.9 73.3c-3.3 151.4-82.1 261.1-175.8 307.7z"
                }
            }
        ]
    })(props);
}
function FaShieldVirus(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M224,192a16,16,0,1,0,16,16A16,16,0,0,0,224,192ZM466.5,83.68l-192-80A57.4,57.4,0,0,0,256.05,0a57.4,57.4,0,0,0-18.46,3.67l-192,80A47.93,47.93,0,0,0,16,128C16,326.5,130.5,463.72,237.5,508.32a48.09,48.09,0,0,0,36.91,0C360.09,472.61,496,349.3,496,128A48,48,0,0,0,466.5,83.68ZM384,256H371.88c-28.51,0-42.79,34.47-22.63,54.63l8.58,8.57a16,16,0,1,1-22.63,22.63l-8.57-8.58C306.47,313.09,272,327.37,272,355.88V368a16,16,0,0,1-32,0V355.88c0-28.51-34.47-42.79-54.63-22.63l-8.57,8.58a16,16,0,0,1-22.63-22.63l8.58-8.57c20.16-20.16,5.88-54.63-22.63-54.63H128a16,16,0,0,1,0-32h12.12c28.51,0,42.79-34.47,22.63-54.63l-8.58-8.57a16,16,0,0,1,22.63-22.63l8.57,8.58c20.16,20.16,54.63,5.88,54.63-22.63V112a16,16,0,0,1,32,0v12.12c0,28.51,34.47,42.79,54.63,22.63l8.57-8.58a16,16,0,0,1,22.63,22.63l-8.58,8.57C329.09,189.53,343.37,224,371.88,224H384a16,16,0,0,1,0,32Zm-96,0a16,16,0,1,0,16,16A16,16,0,0,0,288,256Z"
                }
            }
        ]
    })(props);
}
function FaShip(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M496.616 372.639l70.012-70.012c16.899-16.9 9.942-45.771-12.836-53.092L512 236.102V96c0-17.673-14.327-32-32-32h-64V24c0-13.255-10.745-24-24-24H248c-13.255 0-24 10.745-24 24v40h-64c-17.673 0-32 14.327-32 32v140.102l-41.792 13.433c-22.753 7.313-29.754 36.173-12.836 53.092l70.012 70.012C125.828 416.287 85.587 448 24 448c-13.255 0-24 10.745-24 24v16c0 13.255 10.745 24 24 24 61.023 0 107.499-20.61 143.258-59.396C181.677 487.432 216.021 512 256 512h128c39.979 0 74.323-24.568 88.742-59.396C508.495 491.384 554.968 512 616 512c13.255 0 24-10.745 24-24v-16c0-13.255-10.745-24-24-24-60.817 0-101.542-31.001-119.384-75.361zM192 128h256v87.531l-118.208-37.995a31.995 31.995 0 0 0-19.584 0L192 215.531V128z"
                }
            }
        ]
    })(props);
}
function FaShippingFast(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M624 352h-16V243.9c0-12.7-5.1-24.9-14.1-33.9L494 110.1c-9-9-21.2-14.1-33.9-14.1H416V48c0-26.5-21.5-48-48-48H112C85.5 0 64 21.5 64 48v48H8c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h272c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8H40c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h208c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8H8c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h208c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8H64v128c0 53 43 96 96 96s96-43 96-96h128c0 53 43 96 96 96s96-43 96-96h48c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zM160 464c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48zm320 0c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48zm80-208H416V144h44.1l99.9 99.9V256z"
                }
            }
        ]
    })(props);
}
function FaShoePrints(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M192 160h32V32h-32c-35.35 0-64 28.65-64 64s28.65 64 64 64zM0 416c0 35.35 28.65 64 64 64h32V352H64c-35.35 0-64 28.65-64 64zm337.46-128c-34.91 0-76.16 13.12-104.73 32-24.79 16.38-44.52 32-104.73 32v128l57.53 15.97c26.21 7.28 53.01 13.12 80.31 15.05 32.69 2.31 65.6.67 97.58-6.2C472.9 481.3 512 429.22 512 384c0-64-84.18-96-174.54-96zM491.42 7.19C459.44.32 426.53-1.33 393.84.99c-27.3 1.93-54.1 7.77-80.31 15.04L256 32v128c60.2 0 79.94 15.62 104.73 32 28.57 18.88 69.82 32 104.73 32C555.82 224 640 192 640 128c0-45.22-39.1-97.3-148.58-120.81z"
                }
            }
        ]
    })(props);
}
function FaShoppingBag(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M352 160v-32C352 57.42 294.579 0 224 0 153.42 0 96 57.42 96 128v32H0v272c0 44.183 35.817 80 80 80h288c44.183 0 80-35.817 80-80V160h-96zm-192-32c0-35.29 28.71-64 64-64s64 28.71 64 64v32H160v-32zm160 120c-13.255 0-24-10.745-24-24s10.745-24 24-24 24 10.745 24 24-10.745 24-24 24zm-192 0c-13.255 0-24-10.745-24-24s10.745-24 24-24 24 10.745 24 24-10.745 24-24 24z"
                }
            }
        ]
    })(props);
}
function FaShoppingBasket(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M576 216v16c0 13.255-10.745 24-24 24h-8l-26.113 182.788C514.509 462.435 494.257 480 470.37 480H105.63c-23.887 0-44.139-17.565-47.518-41.212L32 256h-8c-13.255 0-24-10.745-24-24v-16c0-13.255 10.745-24 24-24h67.341l106.78-146.821c10.395-14.292 30.407-17.453 44.701-7.058 14.293 10.395 17.453 30.408 7.058 44.701L170.477 192h235.046L326.12 82.821c-10.395-14.292-7.234-34.306 7.059-44.701 14.291-10.395 34.306-7.235 44.701 7.058L484.659 192H552c13.255 0 24 10.745 24 24zM312 392V280c0-13.255-10.745-24-24-24s-24 10.745-24 24v112c0 13.255 10.745 24 24 24s24-10.745 24-24zm112 0V280c0-13.255-10.745-24-24-24s-24 10.745-24 24v112c0 13.255 10.745 24 24 24s24-10.745 24-24zm-224 0V280c0-13.255-10.745-24-24-24s-24 10.745-24 24v112c0 13.255 10.745 24 24 24s24-10.745 24-24z"
                }
            }
        ]
    })(props);
}
function FaShoppingCart(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M528.12 301.319l47.273-208C578.806 78.301 567.391 64 551.99 64H159.208l-9.166-44.81C147.758 8.021 137.93 0 126.529 0H24C10.745 0 0 10.745 0 24v16c0 13.255 10.745 24 24 24h69.883l70.248 343.435C147.325 417.1 136 435.222 136 456c0 30.928 25.072 56 56 56s56-25.072 56-56c0-15.674-6.447-29.835-16.824-40h209.647C430.447 426.165 424 440.326 424 456c0 30.928 25.072 56 56 56s56-25.072 56-56c0-22.172-12.888-41.332-31.579-50.405l5.517-24.276c3.413-15.018-8.002-29.319-23.403-29.319H218.117l-6.545-32h293.145c11.206 0 20.92-7.754 23.403-18.681z"
                }
            }
        ]
    })(props);
}
function FaShower(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M304,320a16,16,0,1,0,16,16A16,16,0,0,0,304,320Zm32-96a16,16,0,1,0,16,16A16,16,0,0,0,336,224Zm32,64a16,16,0,1,0-16-16A16,16,0,0,0,368,288Zm-32,32a16,16,0,1,0-16-16A16,16,0,0,0,336,320Zm-32-64a16,16,0,1,0,16,16A16,16,0,0,0,304,256Zm128-32a16,16,0,1,0-16-16A16,16,0,0,0,432,224Zm-48,16a16,16,0,1,0,16-16A16,16,0,0,0,384,240Zm-16-48a16,16,0,1,0,16,16A16,16,0,0,0,368,192Zm96,32a16,16,0,1,0,16,16A16,16,0,0,0,464,224Zm32-32a16,16,0,1,0,16,16A16,16,0,0,0,496,192Zm-64,64a16,16,0,1,0,16,16A16,16,0,0,0,432,256Zm-32,32a16,16,0,1,0,16,16A16,16,0,0,0,400,288Zm-64,64a16,16,0,1,0,16,16A16,16,0,0,0,336,352Zm-32,32a16,16,0,1,0,16,16A16,16,0,0,0,304,384Zm64-64a16,16,0,1,0,16,16A16,16,0,0,0,368,320Zm21.65-218.35-11.3-11.31a16,16,0,0,0-22.63,0L350.05,96A111.19,111.19,0,0,0,272,64c-19.24,0-37.08,5.3-52.9,13.85l-10-10A121.72,121.72,0,0,0,123.44,32C55.49,31.5,0,92.91,0,160.85V464a16,16,0,0,0,16,16H48a16,16,0,0,0,16-16V158.4c0-30.15,21-58.2,51-61.93a58.38,58.38,0,0,1,48.93,16.67l10,10C165.3,138.92,160,156.76,160,176a111.23,111.23,0,0,0,32,78.05l-5.66,5.67a16,16,0,0,0,0,22.62l11.3,11.31a16,16,0,0,0,22.63,0L389.65,124.28A16,16,0,0,0,389.65,101.65Z"
                }
            }
        ]
    })(props);
}
function FaShuttleVan(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M628.88 210.65L494.39 49.27A48.01 48.01 0 0 0 457.52 32H32C14.33 32 0 46.33 0 64v288c0 17.67 14.33 32 32 32h32c0 53.02 42.98 96 96 96s96-42.98 96-96h128c0 53.02 42.98 96 96 96s96-42.98 96-96h32c17.67 0 32-14.33 32-32V241.38c0-11.23-3.94-22.1-11.12-30.73zM64 192V96h96v96H64zm96 240c-26.51 0-48-21.49-48-48s21.49-48 48-48 48 21.49 48 48-21.49 48-48 48zm160-240h-96V96h96v96zm160 240c-26.51 0-48-21.49-48-48s21.49-48 48-48 48 21.49 48 48-21.49 48-48 48zm-96-240V96h66.02l80 96H384z"
                }
            }
        ]
    })(props);
}
function FaSignInAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M416 448h-84c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h84c17.7 0 32-14.3 32-32V160c0-17.7-14.3-32-32-32h-84c-6.6 0-12-5.4-12-12V76c0-6.6 5.4-12 12-12h84c53 0 96 43 96 96v192c0 53-43 96-96 96zm-47-201L201 79c-15-15-41-4.5-41 17v96H24c-13.3 0-24 10.7-24 24v96c0 13.3 10.7 24 24 24h136v96c0 21.5 26 32 41 17l168-168c9.3-9.4 9.3-24.6 0-34z"
                }
            }
        ]
    })(props);
}
function FaSignLanguage(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M91.434 483.987c-.307-16.018 13.109-29.129 29.13-29.129h62.293v-5.714H56.993c-16.021 0-29.437-13.111-29.13-29.129C28.16 404.491 40.835 392 56.428 392h126.429v-5.714H29.136c-16.021 0-29.437-13.111-29.13-29.129.297-15.522 12.973-28.013 28.566-28.013h154.286v-5.714H57.707c-16.021 0-29.437-13.111-29.13-29.129.297-15.522 12.973-28.013 28.566-28.013h168.566l-31.085-22.606c-12.762-9.281-15.583-27.149-6.302-39.912 9.281-12.761 27.15-15.582 39.912-6.302l123.361 89.715a34.287 34.287 0 0 1 14.12 27.728v141.136c0 15.91-10.946 29.73-26.433 33.374l-80.471 18.934a137.16 137.16 0 0 1-31.411 3.646H120c-15.593-.001-28.269-12.492-28.566-28.014zm73.249-225.701h36.423l-11.187-8.136c-18.579-13.511-20.313-40.887-3.17-56.536l-13.004-16.7c-9.843-12.641-28.43-15.171-40.88-5.088-12.065 9.771-14.133 27.447-4.553 39.75l36.371 46.71zm283.298-2.103l-5.003-152.452c-.518-15.771-13.722-28.136-29.493-27.619-15.773.518-28.137 13.722-27.619 29.493l1.262 38.415L283.565 11.019c-9.58-12.303-27.223-14.63-39.653-5.328-12.827 9.599-14.929 28.24-5.086 40.881l76.889 98.745-4.509 3.511-94.79-121.734c-9.58-12.303-27.223-14.63-39.653-5.328-12.827 9.599-14.929 28.24-5.086 40.881l94.443 121.288-4.509 3.511-77.675-99.754c-9.58-12.303-27.223-14.63-39.653-5.328-12.827 9.599-14.929 28.24-5.086 40.881l52.053 66.849c12.497-8.257 29.055-8.285 41.69.904l123.36 89.714c10.904 7.93 17.415 20.715 17.415 34.198v16.999l61.064-47.549a34.285 34.285 0 0 0 13.202-28.177z"
                }
            }
        ]
    })(props);
}
function FaSignOutAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M497 273L329 441c-15 15-41 4.5-41-17v-96H152c-13.3 0-24-10.7-24-24v-96c0-13.3 10.7-24 24-24h136V88c0-21.4 25.9-32 41-17l168 168c9.3 9.4 9.3 24.6 0 34zM192 436v-40c0-6.6-5.4-12-12-12H96c-17.7 0-32-14.3-32-32V160c0-17.7 14.3-32 32-32h84c6.6 0 12-5.4 12-12V76c0-6.6-5.4-12-12-12H96c-53 0-96 43-96 96v192c0 53 43 96 96 96h84c6.6 0 12-5.4 12-12z"
                }
            }
        ]
    })(props);
}
function FaSign(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M496 64H128V16c0-8.8-7.2-16-16-16H80c-8.8 0-16 7.2-16 16v48H16C7.2 64 0 71.2 0 80v32c0 8.8 7.2 16 16 16h48v368c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V128h368c8.8 0 16-7.2 16-16V80c0-8.8-7.2-16-16-16zM160 384h320V160H160v224z"
                }
            }
        ]
    })(props);
}
function FaSignal(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M216 288h-48c-8.84 0-16 7.16-16 16v192c0 8.84 7.16 16 16 16h48c8.84 0 16-7.16 16-16V304c0-8.84-7.16-16-16-16zM88 384H40c-8.84 0-16 7.16-16 16v96c0 8.84 7.16 16 16 16h48c8.84 0 16-7.16 16-16v-96c0-8.84-7.16-16-16-16zm256-192h-48c-8.84 0-16 7.16-16 16v288c0 8.84 7.16 16 16 16h48c8.84 0 16-7.16 16-16V208c0-8.84-7.16-16-16-16zm128-96h-48c-8.84 0-16 7.16-16 16v384c0 8.84 7.16 16 16 16h48c8.84 0 16-7.16 16-16V112c0-8.84-7.16-16-16-16zM600 0h-48c-8.84 0-16 7.16-16 16v480c0 8.84 7.16 16 16 16h48c8.84 0 16-7.16 16-16V16c0-8.84-7.16-16-16-16z"
                }
            }
        ]
    })(props);
}
function FaSignature(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M623.2 192c-51.8 3.5-125.7 54.7-163.1 71.5-29.1 13.1-54.2 24.4-76.1 24.4-22.6 0-26-16.2-21.3-51.9 1.1-8 11.7-79.2-42.7-76.1-25.1 1.5-64.3 24.8-169.5 126L192 182.2c30.4-75.9-53.2-151.5-129.7-102.8L7.4 116.3C0 121-2.2 130.9 2.5 138.4l17.2 27c4.7 7.5 14.6 9.7 22.1 4.9l58-38.9c18.4-11.7 40.7 7.2 32.7 27.1L34.3 404.1C27.5 421 37 448 64 448c8.3 0 16.5-3.2 22.6-9.4 42.2-42.2 154.7-150.7 211.2-195.8-2.2 28.5-2.1 58.9 20.6 83.8 15.3 16.8 37.3 25.3 65.5 25.3 35.6 0 68-14.6 102.3-30 33-14.8 99-62.6 138.4-65.8 8.5-.7 15.2-7.3 15.2-15.8v-32.1c.2-9.1-7.5-16.8-16.6-16.2z"
                }
            }
        ]
    })(props);
}
function FaSimCard(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 64v384c0 35.3 28.7 64 64 64h256c35.3 0 64-28.7 64-64V128L256 0H64C28.7 0 0 28.7 0 64zm224 192h-64v-64h64v64zm96 0h-64v-64h32c17.7 0 32 14.3 32 32v32zm-64 128h64v32c0 17.7-14.3 32-32 32h-32v-64zm-96 0h64v64h-64v-64zm-96 0h64v64H96c-17.7 0-32-14.3-32-32v-32zm0-96h256v64H64v-64zm0-64c0-17.7 14.3-32 32-32h32v64H64v-32z"
                }
            }
        ]
    })(props);
}
function FaSink(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M32,416a96,96,0,0,0,96,96H384a96,96,0,0,0,96-96V384H32ZM496,288H400V256h64a16,16,0,0,0,16-16V224a16,16,0,0,0-16-16H384a32,32,0,0,0-32,32v48H288V96a32,32,0,0,1,64,0v16a16,16,0,0,0,16,16h32a16,16,0,0,0,16-16V96A96.16,96.16,0,0,0,300.87,1.86C255.29,10.71,224,53.36,224,99.79V288H160V240a32,32,0,0,0-32-32H48a16,16,0,0,0-16,16v16a16,16,0,0,0,16,16h64v32H16A16,16,0,0,0,0,304v32a16,16,0,0,0,16,16H496a16,16,0,0,0,16-16V304A16,16,0,0,0,496,288Z"
                }
            }
        ]
    })(props);
}
function FaSitemap(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M128 352H32c-17.67 0-32 14.33-32 32v96c0 17.67 14.33 32 32 32h96c17.67 0 32-14.33 32-32v-96c0-17.67-14.33-32-32-32zm-24-80h192v48h48v-48h192v48h48v-57.59c0-21.17-17.23-38.41-38.41-38.41H344v-64h40c17.67 0 32-14.33 32-32V32c0-17.67-14.33-32-32-32H256c-17.67 0-32 14.33-32 32v96c0 17.67 14.33 32 32 32h40v64H94.41C73.23 224 56 241.23 56 262.41V320h48v-48zm264 80h-96c-17.67 0-32 14.33-32 32v96c0 17.67 14.33 32 32 32h96c17.67 0 32-14.33 32-32v-96c0-17.67-14.33-32-32-32zm240 0h-96c-17.67 0-32 14.33-32 32v96c0 17.67 14.33 32 32 32h96c17.67 0 32-14.33 32-32v-96c0-17.67-14.33-32-32-32z"
                }
            }
        ]
    })(props);
}
function FaSkating(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M400 0c-26.5 0-48 21.5-48 48s21.5 48 48 48 48-21.5 48-48-21.5-48-48-48zm0 448c-8.8 0-16 7.2-16 16s-7.2 16-16 16h-96c-8.8 0-16 7.2-16 16s7.2 16 16 16h96c26.5 0 48-21.5 48-48 0-8.8-7.2-16-16-16zm-282.2 8.6c-6.2 6.2-16.4 6.3-22.6 0l-67.9-67.9c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l67.9 67.9c9.4 9.4 21.7 14 34 14s24.6-4.7 33.9-14c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.3-22.7 0zm56.1-179.8l-93.7 93.7c-12.5 12.5-12.5 32.8 0 45.2 6.2 6.2 14.4 9.4 22.6 9.4s16.4-3.1 22.6-9.4l91.9-91.9-30.2-30.2c-5-5-9.4-10.7-13.2-16.8zM128 160h105.5l-20.1 17.2c-13.5 11.5-21.6 28.4-22.3 46.1-.7 17.8 6.1 35.2 18.7 47.7l78.2 78.2V432c0 17.7 14.3 32 32 32s32-14.3 32-32v-89.4c0-12.6-5.1-25-14.1-33.9l-61-61c.5-.4 1.2-.6 1.7-1.1l82.3-82.3c11.5-11.5 14.9-28.6 8.7-43.6-6.2-15-20.7-24.7-37-24.7H128c-17.7 0-32 14.3-32 32s14.3 32 32 32z"
                }
            }
        ]
    })(props);
}
function FaSkiingNordic(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M336 96c26.5 0 48-21.5 48-48S362.5 0 336 0s-48 21.5-48 48 21.5 48 48 48zm216 320c-13.2 0-24 10.7-24 24 0 13.2-10.8 24-24 24h-69.5L460 285.6c11.7-4.7 20.1-16.2 20.1-29.6 0-17.7-14.3-32-32-32h-44L378 170.8c-12.5-25.5-35.5-44.2-61.8-50.9L245 98.7c-28.3-6.8-57.8-.5-80.8 17.1l-39.7 30.4c-14 10.7-16.7 30.8-5.9 44.9.7.9 1.7 1.3 2.4 2.1L66.9 464H24c-13.2 0-24 10.7-24 24s10.8 24 24 24h480c39.7 0 72-32.3 72-72 0-13.2-10.8-24-24-24zm-260.5 48h-96.9l43.1-91-22-13c-12.1-7.2-21.9-16.9-29.5-27.8L123.7 464H99.5l52.3-261.4c4.1-1 8.1-2.9 11.7-5.6l39.7-30.4c7.7-5.9 17.4-8 25.3-6.1l14.7 4.4-37.5 87.4c-12.6 29.5-1.3 64 26.3 80.3l85 50.2-25.5 81.2zm110.6 0h-43.6l23.6-75.5c5.9-20.8-2.9-43.1-21.6-54.4L299.3 298l31.3-78.3 20.3 41.4c8 16.3 24.9 26.9 43.1 26.9h33.3l-25.2 176z"
                }
            }
        ]
    })(props);
}
function FaSkiing(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M432 96c26.5 0 48-21.5 48-48S458.5 0 432 0s-48 21.5-48 48 21.5 48 48 48zm73 356.1c-9.4-9.4-24.6-9.4-33.9 0-12.1 12.1-30.5 15.4-45.1 8.7l-135.8-70.2 49.2-73.8c12.7-19 10.2-44.5-6-60.6L293 215.7l-107-53.1c-2.9 19.9 3.4 40 17.7 54.4l75.1 75.2-45.9 68.8L35 258.7c-11.7-6-26.2-1.5-32.3 10.3-6.1 11.8-1.5 26.3 10.3 32.3l391.9 202.5c11.9 5.5 24.5 8.1 37.1 8.1 23.2 0 46-9 63-26 9.3-9.3 9.3-24.5 0-33.8zM120 91.6l-11.5 22.5c14.4 7.3 31.2 4.9 42.8-4.8l47.2 23.4c-.1.1-.1.2-.2.3l114.5 56.8 32.4-13 6.4 19.1c4 12.1 12.6 22 24 27.7l58.1 29c15.9 7.9 35 1.5 42.9-14.3 7.9-15.8 1.5-35-14.3-42.9l-52.1-26.1-17.1-51.2c-8.1-24.2-40.9-56.6-84.5-39.2l-81.2 32.5-62.5-31c.3-14.5-7.2-28.6-20.9-35.6l-11.1 21.7h-.2l-34.4-7c-1.8-.4-3.7.2-5 1.7-1.9 2.2-1.7 5.5.5 7.4l26.2 23z"
                }
            }
        ]
    })(props);
}
function FaSkullCrossbones(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M439.15 453.06L297.17 384l141.99-69.06c7.9-3.95 11.11-13.56 7.15-21.46L432 264.85c-3.95-7.9-13.56-11.11-21.47-7.16L224 348.41 37.47 257.69c-7.9-3.95-17.51-.75-21.47 7.16L1.69 293.48c-3.95 7.9-.75 17.51 7.15 21.46L150.83 384 8.85 453.06c-7.9 3.95-11.11 13.56-7.15 21.47l14.31 28.63c3.95 7.9 13.56 11.11 21.47 7.15L224 419.59l186.53 90.72c7.9 3.95 17.51.75 21.47-7.15l14.31-28.63c3.95-7.91.74-17.52-7.16-21.47zM150 237.28l-5.48 25.87c-2.67 12.62 5.42 24.85 16.45 24.85h126.08c11.03 0 19.12-12.23 16.45-24.85l-5.5-25.87c41.78-22.41 70-62.75 70-109.28C368 57.31 303.53 0 224 0S80 57.31 80 128c0 46.53 28.22 86.87 70 109.28zM280 112c17.65 0 32 14.35 32 32s-14.35 32-32 32-32-14.35-32-32 14.35-32 32-32zm-112 0c17.65 0 32 14.35 32 32s-14.35 32-32 32-32-14.35-32-32 14.35-32 32-32z"
                }
            }
        ]
    })(props);
}
function FaSkull(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 0C114.6 0 0 100.3 0 224c0 70.1 36.9 132.6 94.5 173.7 9.6 6.9 15.2 18.1 13.5 29.9l-9.4 66.2c-1.4 9.6 6 18.2 15.7 18.2H192v-56c0-4.4 3.6-8 8-8h16c4.4 0 8 3.6 8 8v56h64v-56c0-4.4 3.6-8 8-8h16c4.4 0 8 3.6 8 8v56h77.7c9.7 0 17.1-8.6 15.7-18.2l-9.4-66.2c-1.7-11.7 3.8-23 13.5-29.9C475.1 356.6 512 294.1 512 224 512 100.3 397.4 0 256 0zm-96 320c-35.3 0-64-28.7-64-64s28.7-64 64-64 64 28.7 64 64-28.7 64-64 64zm192 0c-35.3 0-64-28.7-64-64s28.7-64 64-64 64 28.7 64 64-28.7 64-64 64z"
                }
            }
        ]
    })(props);
}
function FaSlash(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M594.53 508.63L6.18 53.9c-6.97-5.42-8.23-15.47-2.81-22.45L23.01 6.18C28.43-.8 38.49-2.06 45.47 3.37L633.82 458.1c6.97 5.42 8.23 15.47 2.81 22.45l-19.64 25.27c-5.42 6.98-15.48 8.23-22.46 2.81z"
                }
            }
        ]
    })(props);
}
function FaSleigh(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M612.7 350.7l-9.3-7.4c-6.9-5.5-17-4.4-22.5 2.5l-10 12.5c-5.5 6.9-4.4 17 2.5 22.5l9.3 7.4c5.9 4.7 9.2 11.7 9.2 19.2 0 13.6-11 24.6-24.6 24.6H48c-8.8 0-16 7.2-16 16v16c0 8.8 7.2 16 16 16h516c39 0 73.7-29.3 75.9-68.3 1.4-23.8-8.7-46.3-27.2-61zM32 224c0 59.6 40.9 109.2 96 123.5V400h64v-48h192v48h64v-48c53 0 96-43 96-96v-96c17.7 0 32-14.3 32-32s-14.3-32-32-32h-96v64c0 35.3-28.7 64-64 64h-20.7c-65.8 0-125.9-37.2-155.3-96-29.4-58.8-89.6-96-155.3-96H32C14.3 32 0 46.3 0 64s14.3 32 32 32v128z"
                }
            }
        ]
    })(props);
}
function FaSlidersH(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M496 384H160v-16c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v16H16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h80v16c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-16h336c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zm0-160h-80v-16c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v16H16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h336v16c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-16h80c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zm0-160H288V48c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v16H16C7.2 64 0 71.2 0 80v32c0 8.8 7.2 16 16 16h208v16c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-16h208c8.8 0 16-7.2 16-16V80c0-8.8-7.2-16-16-16z"
                }
            }
        ]
    })(props);
}
function FaSmileBeam(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zM112 223.4c3.3-42.1 32.2-71.4 56-71.4s52.7 29.3 56 71.4c.7 8.6-10.8 11.9-14.9 4.5l-9.5-17c-7.7-13.7-19.2-21.6-31.5-21.6s-23.8 7.9-31.5 21.6l-9.5 17c-4.3 7.4-15.8 4-15.1-4.5zm250.8 122.8C334.3 380.4 292.5 400 248 400s-86.3-19.6-114.8-53.8c-13.5-16.3 11-36.7 24.6-20.5 22.4 26.9 55.2 42.2 90.2 42.2s67.8-15.4 90.2-42.2c13.6-16.2 38.1 4.3 24.6 20.5zm6.2-118.3l-9.5-17c-7.7-13.7-19.2-21.6-31.5-21.6s-23.8 7.9-31.5 21.6l-9.5 17c-4.1 7.3-15.6 4-14.9-4.5 3.3-42.1 32.2-71.4 56-71.4s52.7 29.3 56 71.4c.6 8.6-11 11.9-15.1 4.5z"
                }
            }
        ]
    })(props);
}
function FaSmileWink(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 256c0 137 111 248 248 248s248-111 248-248S385 8 248 8 0 119 0 256zm200-48c0 17.7-14.3 32-32 32s-32-14.3-32-32 14.3-32 32-32 32 14.3 32 32zm158.5 16.5c-14.8-13.2-46.2-13.2-61 0L288 233c-8.3 7.4-21.6.4-19.8-10.8 4-25.2 34.2-42.1 59.9-42.1S384 197 388 222.2c1.7 11.1-11.4 18.3-19.8 10.8l-9.7-8.5zM157.8 325.8C180.2 352.7 213 368 248 368s67.8-15.4 90.2-42.2c13.6-16.2 38.1 4.2 24.6 20.5C334.3 380.4 292.5 400 248 400s-86.3-19.6-114.8-53.8c-13.5-16.3 11.2-36.7 24.6-20.4z"
                }
            }
        ]
    })(props);
}
function FaSmile(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm80 168c17.7 0 32 14.3 32 32s-14.3 32-32 32-32-14.3-32-32 14.3-32 32-32zm-160 0c17.7 0 32 14.3 32 32s-14.3 32-32 32-32-14.3-32-32 14.3-32 32-32zm194.8 170.2C334.3 380.4 292.5 400 248 400s-86.3-19.6-114.8-53.8c-13.6-16.3 11-36.7 24.6-20.5 22.4 26.9 55.2 42.2 90.2 42.2s67.8-15.4 90.2-42.2c13.4-16.2 38.1 4.2 24.6 20.5z"
                }
            }
        ]
    })(props);
}
function FaSmog(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M624 368H80c-8.8 0-16 7.2-16 16v16c0 8.8 7.2 16 16 16h544c8.8 0 16-7.2 16-16v-16c0-8.8-7.2-16-16-16zm-480 96H16c-8.8 0-16 7.2-16 16v16c0 8.8 7.2 16 16 16h128c8.8 0 16-7.2 16-16v-16c0-8.8-7.2-16-16-16zm416 0H224c-8.8 0-16 7.2-16 16v16c0 8.8 7.2 16 16 16h336c8.8 0 16-7.2 16-16v-16c0-8.8-7.2-16-16-16zM144 288h156.1c22.5 19.7 51.6 32 83.9 32s61.3-12.3 83.9-32H528c61.9 0 112-50.1 112-112S589.9 64 528 64c-18 0-34.7 4.6-49.7 12.1C454 31 406.8 0 352 0c-41 0-77.8 17.3-104 44.8C221.8 17.3 185 0 144 0 64.5 0 0 64.5 0 144s64.5 144 144 144z"
                }
            }
        ]
    })(props);
}
function FaSmokingBan(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M96 304c0 8.8 7.2 16 16 16h117.5l-96-96H112c-8.8 0-16 7.2-16 16v64zM256 0C114.6 0 0 114.6 0 256s114.6 256 256 256 256-114.6 256-256S397.4 0 256 0zm0 448c-105.9 0-192-86.1-192-192 0-41.4 13.3-79.7 35.7-111.1l267.4 267.4C335.7 434.7 297.4 448 256 448zm45.2-192H384v32h-50.8l-32-32zm111.1 111.1L365.2 320H400c8.8 0 16-7.2 16-16v-64c0-8.8-7.2-16-16-16H269.2L144.9 99.7C176.3 77.3 214.6 64 256 64c105.9 0 192 86.1 192 192 0 41.4-13.3 79.7-35.7 111.1zM320.6 128c-15.6 0-28.6-11.2-31.4-25.9-.7-3.6-4-6.1-7.7-6.1h-16.2c-5 0-8.7 4.5-8 9.4 4.6 30.9 31.2 54.6 63.3 54.6 15.6 0 28.6 11.2 31.4 25.9.7 3.6 4 6.1 7.7 6.1h16.2c5 0 8.7-4.5 8-9.4-4.6-30.9-31.2-54.6-63.3-54.6z"
                }
            }
        ]
    })(props);
}
function FaSmoking(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M632 352h-48c-4.4 0-8 3.6-8 8v144c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V360c0-4.4-3.6-8-8-8zM553.3 87.1c-5.7-3.8-9.3-10-9.3-16.8V8c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v62.3c0 22 10.2 43.4 28.6 55.4 42.2 27.3 67.4 73.8 67.4 124V280c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8v-30.3c0-65.5-32.4-126.2-86.7-162.6zM432 352H48c-26.5 0-48 21.5-48 48v64c0 26.5 21.5 48 48 48h384c8.8 0 16-7.2 16-16V368c0-8.8-7.2-16-16-16zm-32 112H224v-64h176v64zm87.7-322.4C463.8 125 448 99.3 448 70.3V8c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v66.4c0 43.7 24.6 81.6 60.3 106.7 22.4 15.7 35.7 41.2 35.7 68.6V280c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8v-30.3c0-43.3-21-83.4-56.3-108.1zM536 352h-48c-4.4 0-8 3.6-8 8v144c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V360c0-4.4-3.6-8-8-8z"
                }
            }
        ]
    })(props);
}
function FaSms(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 32C114.6 32 0 125.1 0 240c0 49.6 21.4 95 57 130.7C44.5 421.1 2.7 466 2.2 466.5c-2.2 2.3-2.8 5.7-1.5 8.7 1.3 3 4.1 4.8 7.3 4.8 66.3 0 116-31.8 140.6-51.4 32.7 12.3 69 19.4 107.4 19.4 141.4 0 256-93.1 256-208S397.4 32 256 32zM128.2 304H116c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h12.3c6 0 10.4-3.5 10.4-6.6 0-1.3-.8-2.7-2.1-3.8l-21.9-18.8c-8.5-7.2-13.3-17.5-13.3-28.1 0-21.3 19-38.6 42.4-38.6H156c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8h-12.3c-6 0-10.4 3.5-10.4 6.6 0 1.3.8 2.7 2.1 3.8l21.9 18.8c8.5 7.2 13.3 17.5 13.3 28.1.1 21.3-19 38.6-42.4 38.6zm191.8-8c0 4.4-3.6 8-8 8h-16c-4.4 0-8-3.6-8-8v-68.2l-24.8 55.8c-2.9 5.9-11.4 5.9-14.3 0L224 227.8V296c0 4.4-3.6 8-8 8h-16c-4.4 0-8-3.6-8-8V192c0-8.8 7.2-16 16-16h16c6.1 0 11.6 3.4 14.3 8.8l17.7 35.4 17.7-35.4c2.7-5.4 8.3-8.8 14.3-8.8h16c8.8 0 16 7.2 16 16v104zm48.3 8H356c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h12.3c6 0 10.4-3.5 10.4-6.6 0-1.3-.8-2.7-2.1-3.8l-21.9-18.8c-8.5-7.2-13.3-17.5-13.3-28.1 0-21.3 19-38.6 42.4-38.6H396c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8h-12.3c-6 0-10.4 3.5-10.4 6.6 0 1.3.8 2.7 2.1 3.8l21.9 18.8c8.5 7.2 13.3 17.5 13.3 28.1.1 21.3-18.9 38.6-42.3 38.6z"
                }
            }
        ]
    })(props);
}
function FaSnowboarding(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M432 96c26.5 0 48-21.5 48-48S458.5 0 432 0s-48 21.5-48 48 21.5 48 48 48zm28.8 153.6c5.8 4.3 12.5 6.4 19.2 6.4 9.7 0 19.3-4.4 25.6-12.8 10.6-14.1 7.8-34.2-6.4-44.8l-111.4-83.5c-13.8-10.3-29.1-18.4-45.4-23.8l-63.7-21.2-26.1-52.1C244.7 2 225.5-4.4 209.7 3.5c-15.8 7.9-22.2 27.1-14.3 42.9l29.1 58.1c5.7 11.4 15.6 19.9 27.7 24l16.4 5.5-41.2 20.6c-21.8 10.9-35.4 32.8-35.4 57.2v53.1l-74.1 24.7c-16.8 5.6-25.8 23.7-20.2 40.5 1.7 5.2 4.9 9.4 8.7 12.9l-38.7-14.1c-9.7-3.5-17.4-10.6-21.8-20-5.6-12-19.9-17.2-31.9-11.6s-17.2 19.9-11.6 31.9c9.8 21 27.1 36.9 48.9 44.8l364.8 132.7c9.7 3.5 19.7 5.3 29.7 5.3 12.5 0 24.9-2.7 36.5-8.2 12-5.6 17.2-19.9 11.6-31.9S474 454.7 462 460.3c-9.3 4.4-19.8 4.8-29.5 1.3l-90.8-33.1c8.7-4.1 15.6-11.8 17.8-21.9l21.9-102c3.9-18.2-3.2-37.2-18.1-48.4l-52-39 66-30.5 83.5 62.9zm-144.4 51.7l-19.7 92c-1.5 7.1-.1 13.9 2.8 20l-169.4-61.6c2.7-.2 5.4-.4 8-1.3l85-28.4c19.6-6.5 32.8-24.8 32.8-45.5V256l60.5 45.3z"
                }
            }
        ]
    })(props);
}
function FaSnowflake(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M440.3 345.2l-33.8-19.5 26-7c8.2-2.2 13.1-10.7 10.9-18.9l-4-14.9c-2.2-8.2-10.7-13.1-18.9-10.9l-70.8 19-63.9-37 63.8-36.9 70.8 19c8.2 2.2 16.7-2.7 18.9-10.9l4-14.9c2.2-8.2-2.7-16.7-10.9-18.9l-26-7 33.8-19.5c7.4-4.3 9.9-13.7 5.7-21.1L430.4 119c-4.3-7.4-13.7-9.9-21.1-5.7l-33.8 19.5 7-26c2.2-8.2-2.7-16.7-10.9-18.9l-14.9-4c-8.2-2.2-16.7 2.7-18.9 10.9l-19 70.8-62.8 36.2v-77.5l53.7-53.7c6.2-6.2 6.2-16.4 0-22.6l-11.3-11.3c-6.2-6.2-16.4-6.2-22.6 0L256 56.4V16c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v40.4l-19.7-19.7c-6.2-6.2-16.4-6.2-22.6 0L138.3 48c-6.3 6.2-6.3 16.4 0 22.6l53.7 53.7v77.5l-62.8-36.2-19-70.8c-2.2-8.2-10.7-13.1-18.9-10.9l-14.9 4c-8.2 2.2-13.1 10.7-10.9 18.9l7 26-33.8-19.5c-7.4-4.3-16.8-1.7-21.1 5.7L2.1 145.7c-4.3 7.4-1.7 16.8 5.7 21.1l33.8 19.5-26 7c-8.3 2.2-13.2 10.7-11 19l4 14.9c2.2 8.2 10.7 13.1 18.9 10.9l70.8-19 63.8 36.9-63.8 36.9-70.8-19c-8.2-2.2-16.7 2.7-18.9 10.9l-4 14.9c-2.2 8.2 2.7 16.7 10.9 18.9l26 7-33.8 19.6c-7.4 4.3-9.9 13.7-5.7 21.1l15.5 26.8c4.3 7.4 13.7 9.9 21.1 5.7l33.8-19.5-7 26c-2.2 8.2 2.7 16.7 10.9 18.9l14.9 4c8.2 2.2 16.7-2.7 18.9-10.9l19-70.8 62.8-36.2v77.5l-53.7 53.7c-6.3 6.2-6.3 16.4 0 22.6l11.3 11.3c6.2 6.2 16.4 6.2 22.6 0l19.7-19.7V496c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-40.4l19.7 19.7c6.2 6.2 16.4 6.2 22.6 0l11.3-11.3c6.2-6.2 6.2-16.4 0-22.6L256 387.7v-77.5l62.8 36.2 19 70.8c2.2 8.2 10.7 13.1 18.9 10.9l14.9-4c8.2-2.2 13.1-10.7 10.9-18.9l-7-26 33.8 19.5c7.4 4.3 16.8 1.7 21.1-5.7l15.5-26.8c4.3-7.3 1.8-16.8-5.6-21z"
                }
            }
        ]
    })(props);
}
function FaSnowman(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M510.9 152.3l-5.9-14.5c-3.3-8-12.6-11.9-20.8-8.7L456 140.6v-29c0-8.6-7.2-15.6-16-15.6h-16c-8.8 0-16 7-16 15.6v46.9c0 .5.3 1 .3 1.5l-56.4 23c-5.9-10-13.3-18.9-22-26.6 13.6-16.6 22-37.4 22-60.5 0-53-43-96-96-96s-96 43-96 96c0 23.1 8.5 43.9 22 60.5-8.7 7.7-16 16.6-22 26.6l-56.4-23c.1-.5.3-1 .3-1.5v-46.9C104 103 96.8 96 88 96H72c-8.8 0-16 7-16 15.6v29l-28.1-11.5c-8.2-3.2-17.5.7-20.8 8.7l-5.9 14.5c-3.3 8 .7 17.1 8.9 20.3l135.2 55.2c-.4 4-1.2 8-1.2 12.2 0 10.1 1.7 19.6 4.2 28.9C120.9 296.4 104 334.2 104 376c0 54 28.4 100.9 70.8 127.8 9.3 5.9 20.3 8.2 31.3 8.2h99.2c13.3 0 26.3-4.1 37.2-11.7 46.5-32.3 74.4-89.4 62.9-152.6-5.5-30.2-20.5-57.6-41.6-79 2.5-9.2 4.2-18.7 4.2-28.7 0-4.2-.8-8.1-1.2-12.2L502 172.6c8.1-3.1 12.1-12.2 8.9-20.3zM224 96c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16zm32 272c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16zm0-64c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16zm0-64c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16zm0-88s-16-23.2-16-32 7.2-16 16-16 16 7.2 16 16-16 32-16 32zm32-56c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16z"
                }
            }
        ]
    })(props);
}
function FaSnowplow(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M120 376c-13.3 0-24 10.7-24 24s10.7 24 24 24 24-10.7 24-24-10.7-24-24-24zm80 0c-13.3 0-24 10.7-24 24s10.7 24 24 24 24-10.7 24-24-10.7-24-24-24zm80 0c-13.3 0-24 10.7-24 24s10.7 24 24 24 24-10.7 24-24-10.7-24-24-24zm80 0c-13.3 0-24 10.7-24 24s10.7 24 24 24 24-10.7 24-24-10.7-24-24-24zm238.6 49.4c-14.5-14.5-22.6-34.1-22.6-54.6V269.2c0-20.5 8.1-40.1 22.6-54.6l36.7-36.7c6.2-6.2 6.2-16.4 0-22.6l-22.6-22.6c-6.2-6.2-16.4-6.2-22.6 0l-36.7 36.7c-26.5 26.5-41.4 62.4-41.4 99.9V288h-64v-50.9c0-8.7-1.8-17.2-5.2-25.2L364.5 29.1C356.9 11.4 339.6 0 320.3 0H176c-26.5 0-48 21.5-48 48v112h-16c-26.5 0-48 21.5-48 48v91.2C26.3 317.2 0 355.4 0 400c0 61.9 50.1 112 112 112h256c61.9 0 112-50.1 112-112 0-17.3-4.2-33.4-11.2-48H512v18.7c0 37.5 14.9 73.4 41.4 99.9l36.7 36.7c6.2 6.2 16.4 6.2 22.6 0l22.6-22.6c6.2-6.2 6.2-16.4 0-22.6l-36.7-36.7zM192 64h117.8l68.6 160H256l-64-64V64zm176 384H112c-26.5 0-48-21.5-48-48s21.5-48 48-48h256c26.5 0 48 21.5 48 48s-21.5 48-48 48z"
                }
            }
        ]
    })(props);
}
function FaSoap(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M416,192a95.42,95.42,0,0,1-30.94,70.21A95.8,95.8,0,0,1,352,448H160a96,96,0,0,1,0-192h88.91A95.3,95.3,0,0,1,224,192H96A96,96,0,0,0,0,288V416a96,96,0,0,0,96,96H416a96,96,0,0,0,96-96V288A96,96,0,0,0,416,192Zm-96,64a64,64,0,1,0-64-64A64,64,0,0,0,320,256ZM208,96a48,48,0,1,0-48-48A48,48,0,0,0,208,96ZM384,64a32,32,0,1,0-32-32A32,32,0,0,0,384,64ZM160,288a64,64,0,0,0,0,128H352a64,64,0,0,0,0-128Z"
                }
            }
        ]
    })(props);
}
function FaSocks(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M214.66 311.01L288 256V96H128v176l-86.65 64.61c-39.4 29.56-53.86 84.42-29.21 127.06C30.39 495.25 63.27 512 96.08 512c20.03 0 40.25-6.25 57.52-19.2l21.86-16.39c-29.85-55.38-13.54-125.84 39.2-165.4zM288 32c0-11.05 3.07-21.3 8.02-30.38C293.4.92 290.85 0 288 0H160c-17.67 0-32 14.33-32 32v32h160V32zM480 0H352c-17.67 0-32 14.33-32 32v32h192V32c0-17.67-14.33-32-32-32zM320 272l-86.13 64.61c-39.4 29.56-53.86 84.42-29.21 127.06 18.25 31.58 50.61 48.33 83.42 48.33 20.03 0 40.25-6.25 57.52-19.2l115.2-86.4A127.997 127.997 0 0 0 512 304V96H320v176z"
                }
            }
        ]
    })(props);
}
function FaSolarPanel(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M431.98 448.01l-47.97.05V416h-128v32.21l-47.98.05c-8.82.01-15.97 7.16-15.98 15.99l-.05 31.73c-.01 8.85 7.17 16.03 16.02 16.02l223.96-.26c8.82-.01 15.97-7.16 15.98-15.98l.04-31.73c.01-8.85-7.17-16.03-16.02-16.02zM585.2 26.74C582.58 11.31 568.99 0 553.06 0H86.93C71 0 57.41 11.31 54.79 26.74-3.32 369.16.04 348.08.03 352c-.03 17.32 14.29 32 32.6 32h574.74c18.23 0 32.51-14.56 32.59-31.79.02-4.08 3.35 16.95-54.76-325.47zM259.83 64h120.33l9.77 96H250.06l9.77-96zm-75.17 256H71.09L90.1 208h105.97l-11.41 112zm16.29-160H98.24l16.29-96h96.19l-9.77 96zm32.82 160l11.4-112h149.65l11.4 112H233.77zm195.5-256h96.19l16.29 96H439.04l-9.77-96zm26.06 256l-11.4-112H549.9l19.01 112H455.33z"
                }
            }
        ]
    })(props);
}
function FaSortAlphaDownAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M176 352h-48V48a16 16 0 0 0-16-16H80a16 16 0 0 0-16 16v304H16c-14.19 0-21.36 17.24-11.29 27.31l80 96a16 16 0 0 0 22.62 0l80-96C197.35 369.26 190.22 352 176 352zm112-128h128a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16h-56l61.26-70.45A32 32 0 0 0 432 65.63V48a16 16 0 0 0-16-16H288a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h56l-61.26 70.45A32 32 0 0 0 272 190.37V208a16 16 0 0 0 16 16zm159.06 234.62l-59.27-160A16 16 0 0 0 372.72 288h-41.44a16 16 0 0 0-15.07 10.62l-59.27 160A16 16 0 0 0 272 480h24.83a16 16 0 0 0 15.23-11.08l4.42-12.92h71l4.41 12.92A16 16 0 0 0 407.16 480H432a16 16 0 0 0 15.06-21.38zM335.61 400L352 352l16.39 48z"
                }
            }
        ]
    })(props);
}
function FaSortAlphaDown(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M176 352h-48V48a16 16 0 0 0-16-16H80a16 16 0 0 0-16 16v304H16c-14.19 0-21.36 17.24-11.29 27.31l80 96a16 16 0 0 0 22.62 0l80-96C197.35 369.26 190.22 352 176 352zm240-64H288a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h56l-61.26 70.45A32 32 0 0 0 272 446.37V464a16 16 0 0 0 16 16h128a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16h-56l61.26-70.45A32 32 0 0 0 432 321.63V304a16 16 0 0 0-16-16zm31.06-85.38l-59.27-160A16 16 0 0 0 372.72 32h-41.44a16 16 0 0 0-15.07 10.62l-59.27 160A16 16 0 0 0 272 224h24.83a16 16 0 0 0 15.23-11.08l4.42-12.92h71l4.41 12.92A16 16 0 0 0 407.16 224H432a16 16 0 0 0 15.06-21.38zM335.61 144L352 96l16.39 48z"
                }
            }
        ]
    })(props);
}
function FaSortAlphaUpAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 160h48v304a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16V160h48c14.21 0 21.38-17.24 11.31-27.31l-80-96a16 16 0 0 0-22.62 0l-80 96C-5.35 142.74 1.78 160 16 160zm272 64h128a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16h-56l61.26-70.45A32 32 0 0 0 432 65.63V48a16 16 0 0 0-16-16H288a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h56l-61.26 70.45A32 32 0 0 0 272 190.37V208a16 16 0 0 0 16 16zm159.06 234.62l-59.27-160A16 16 0 0 0 372.72 288h-41.44a16 16 0 0 0-15.07 10.62l-59.27 160A16 16 0 0 0 272 480h24.83a16 16 0 0 0 15.23-11.08l4.42-12.92h71l4.41 12.92A16 16 0 0 0 407.16 480H432a16 16 0 0 0 15.06-21.38zM335.61 400L352 352l16.39 48z"
                }
            }
        ]
    })(props);
}
function FaSortAlphaUp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 160h48v304a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16V160h48c14.21 0 21.38-17.24 11.31-27.31l-80-96a16 16 0 0 0-22.62 0l-80 96C-5.35 142.74 1.78 160 16 160zm400 128H288a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h56l-61.26 70.45A32 32 0 0 0 272 446.37V464a16 16 0 0 0 16 16h128a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16h-56l61.26-70.45A32 32 0 0 0 432 321.63V304a16 16 0 0 0-16-16zm31.06-85.38l-59.27-160A16 16 0 0 0 372.72 32h-41.44a16 16 0 0 0-15.07 10.62l-59.27 160A16 16 0 0 0 272 224h24.83a16 16 0 0 0 15.23-11.08l4.42-12.92h71l4.41 12.92A16 16 0 0 0 407.16 224H432a16 16 0 0 0 15.06-21.38zM335.61 144L352 96l16.39 48z"
                }
            }
        ]
    })(props);
}
function FaSortAmountDownAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M240 96h64a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16h-64a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16zm0 128h128a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16H240a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16zm256 192H240a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h256a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm-256-64h192a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16H240a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16zm-64 0h-48V48a16 16 0 0 0-16-16H80a16 16 0 0 0-16 16v304H16c-14.19 0-21.37 17.24-11.29 27.31l80 96a16 16 0 0 0 22.62 0l80-96C197.35 369.26 190.22 352 176 352z"
                }
            }
        ]
    })(props);
}
function FaSortAmountDown(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M304 416h-64a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h64a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm-128-64h-48V48a16 16 0 0 0-16-16H80a16 16 0 0 0-16 16v304H16c-14.19 0-21.37 17.24-11.29 27.31l80 96a16 16 0 0 0 22.62 0l80-96C197.35 369.26 190.22 352 176 352zm256-192H240a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h192a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm-64 128H240a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h128a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zM496 32H240a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h256a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16z"
                }
            }
        ]
    })(props);
}
function FaSortAmountUpAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M240 96h64a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16h-64a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16zm0 128h128a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16H240a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16zm256 192H240a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h256a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm-256-64h192a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16H240a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16zM16 160h48v304a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16V160h48c14.21 0 21.39-17.24 11.31-27.31l-80-96a16 16 0 0 0-22.62 0l-80 96C-5.35 142.74 1.78 160 16 160z"
                }
            }
        ]
    })(props);
}
function FaSortAmountUp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M304 416h-64a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h64a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zM16 160h48v304a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16V160h48c14.21 0 21.38-17.24 11.31-27.31l-80-96a16 16 0 0 0-22.62 0l-80 96C-5.35 142.74 1.77 160 16 160zm416 0H240a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h192a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm-64 128H240a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h128a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zM496 32H240a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h256a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16z"
                }
            }
        ]
    })(props);
}
function FaSortDown(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 320 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M41 288h238c21.4 0 32.1 25.9 17 41L177 448c-9.4 9.4-24.6 9.4-33.9 0L24 329c-15.1-15.1-4.4-41 17-41z"
                }
            }
        ]
    })(props);
}
function FaSortNumericDownAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M176 352h-48V48a16 16 0 0 0-16-16H80a16 16 0 0 0-16 16v304H16c-14.19 0-21.36 17.24-11.29 27.31l80 96a16 16 0 0 0 22.62 0l80-96C197.35 369.26 190.22 352 176 352zm224 64h-16V304a16 16 0 0 0-16-16h-48a16 16 0 0 0-14.29 8.83l-16 32A16 16 0 0 0 304 352h16v64h-16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h96a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zM330.17 34.91a79 79 0 0 0-55 54.17c-14.27 51.05 21.19 97.77 68.83 102.53a84.07 84.07 0 0 1-20.85 12.91c-7.57 3.4-10.8 12.47-8.18 20.34l9.9 20c2.87 8.63 12.53 13.49 20.9 9.91 58-24.77 86.25-61.61 86.25-132V112c-.02-51.21-48.4-91.34-101.85-77.09zM352 132a20 20 0 1 1 20-20 20 20 0 0 1-20 20z"
                }
            }
        ]
    })(props);
}
function FaSortNumericDown(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M304 96h16v64h-16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h96a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16h-16V48a16 16 0 0 0-16-16h-48a16 16 0 0 0-14.29 8.83l-16 32A16 16 0 0 0 304 96zm26.15 162.91a79 79 0 0 0-55 54.17c-14.25 51.05 21.21 97.77 68.85 102.53a84.07 84.07 0 0 1-20.85 12.91c-7.57 3.4-10.8 12.47-8.18 20.34l9.9 20c2.87 8.63 12.53 13.49 20.9 9.91 58-24.76 86.25-61.61 86.25-132V336c-.02-51.21-48.4-91.34-101.85-77.09zM352 356a20 20 0 1 1 20-20 20 20 0 0 1-20 20zm-176-4h-48V48a16 16 0 0 0-16-16H80a16 16 0 0 0-16 16v304H16c-14.19 0-21.36 17.24-11.29 27.31l80 96a16 16 0 0 0 22.62 0l80-96C197.35 369.26 190.22 352 176 352z"
                }
            }
        ]
    })(props);
}
function FaSortNumericUpAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M107.31 36.69a16 16 0 0 0-22.62 0l-80 96C-5.35 142.74 1.78 160 16 160h48v304a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16V160h48c14.21 0 21.38-17.24 11.31-27.31zM400 416h-16V304a16 16 0 0 0-16-16h-48a16 16 0 0 0-14.29 8.83l-16 32A16 16 0 0 0 304 352h16v64h-16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h96a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zM330.17 34.91a79 79 0 0 0-55 54.17c-14.27 51.05 21.19 97.77 68.83 102.53a84.07 84.07 0 0 1-20.85 12.91c-7.57 3.4-10.8 12.47-8.18 20.34l9.9 20c2.87 8.63 12.53 13.49 20.9 9.91 58-24.77 86.25-61.61 86.25-132V112c-.02-51.21-48.4-91.34-101.85-77.09zM352 132a20 20 0 1 1 20-20 20 20 0 0 1-20 20z"
                }
            }
        ]
    })(props);
}
function FaSortNumericUp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M330.17 258.91a79 79 0 0 0-55 54.17c-14.27 51.05 21.19 97.77 68.83 102.53a84.07 84.07 0 0 1-20.85 12.91c-7.57 3.4-10.8 12.47-8.18 20.34l9.9 20c2.87 8.63 12.53 13.49 20.9 9.91 58-24.76 86.25-61.61 86.25-132V336c-.02-51.21-48.4-91.34-101.85-77.09zM352 356a20 20 0 1 1 20-20 20 20 0 0 1-20 20zM304 96h16v64h-16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h96a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16h-16V48a16 16 0 0 0-16-16h-48a16 16 0 0 0-14.29 8.83l-16 32A16 16 0 0 0 304 96zM107.31 36.69a16 16 0 0 0-22.62 0l-80 96C-5.35 142.74 1.78 160 16 160h48v304a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16V160h48c14.21 0 21.38-17.24 11.31-27.31z"
                }
            }
        ]
    })(props);
}
function FaSortUp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 320 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M279 224H41c-21.4 0-32.1-25.9-17-41L143 64c9.4-9.4 24.6-9.4 33.9 0l119 119c15.2 15.1 4.5 41-16.9 41z"
                }
            }
        ]
    })(props);
}
function FaSort(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 320 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M41 288h238c21.4 0 32.1 25.9 17 41L177 448c-9.4 9.4-24.6 9.4-33.9 0L24 329c-15.1-15.1-4.4-41 17-41zm255-105L177 64c-9.4-9.4-24.6-9.4-33.9 0L24 183c-15.1 15.1-4.4 41 17 41h238c21.4 0 32.1-25.9 17-41z"
                }
            }
        ]
    })(props);
}
function FaSpa(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M568.25 192c-29.04.13-135.01 6.16-213.84 83-33.12 29.63-53.36 63.3-66.41 94.86-13.05-31.56-33.29-65.23-66.41-94.86-78.83-76.84-184.8-82.87-213.84-83-4.41-.02-7.79 3.4-7.75 7.82.23 27.92 7.14 126.14 88.77 199.3C172.79 480.94 256 480 288 480s115.19.95 199.23-80.88c81.64-73.17 88.54-171.38 88.77-199.3.04-4.42-3.34-7.84-7.75-7.82zM287.98 302.6c12.82-18.85 27.6-35.78 44.09-50.52 19.09-18.61 39.58-33.3 60.26-45.18-16.44-70.5-51.72-133.05-96.73-172.22-4.11-3.58-11.02-3.58-15.14 0-44.99 39.14-80.27 101.63-96.74 172.07 20.37 11.7 40.5 26.14 59.22 44.39a282.768 282.768 0 0 1 45.04 51.46z"
                }
            }
        ]
    })(props);
}
function FaSpaceShuttle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M592.604 208.244C559.735 192.836 515.777 184 472 184H186.327c-4.952-6.555-10.585-11.978-16.72-16H376C229.157 137.747 219.403 32 96.003 32H96v128H80V32c-26.51 0-48 28.654-48 64v64c-23.197 0-32 10.032-32 24v40c0 13.983 8.819 24 32 24v16c-23.197 0-32 10.032-32 24v40c0 13.983 8.819 24 32 24v64c0 35.346 21.49 64 48 64V352h16v128h.003c123.4 0 133.154-105.747 279.997-136H169.606c6.135-4.022 11.768-9.445 16.72-16H472c43.777 0 87.735-8.836 120.604-24.244C622.282 289.845 640 271.992 640 256s-17.718-33.845-47.396-47.756zM488 296a8 8 0 0 1-8-8v-64a8 8 0 0 1 8-8c31.909 0 31.942 80 0 80z"
                }
            }
        ]
    })(props);
}
function FaSpellCheck(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M272 256h91.36c43.2 0 82-32.2 84.51-75.34a79.82 79.82 0 0 0-25.26-63.07 79.81 79.81 0 0 0 9.06-44.91C427.9 30.57 389.3 0 347 0h-75a16 16 0 0 0-16 16v224a16 16 0 0 0 16 16zm40-200h40a24 24 0 0 1 0 48h-40zm0 96h56a24 24 0 0 1 0 48h-56zM155.12 22.25A32 32 0 0 0 124.64 0H99.36a32 32 0 0 0-30.48 22.25L.59 235.73A16 16 0 0 0 16 256h24.93a16 16 0 0 0 15.42-11.73L68.29 208h87.42l11.94 36.27A16 16 0 0 0 183.07 256H208a16 16 0 0 0 15.42-20.27zM89.37 144L112 75.3l22.63 68.7zm482 132.48l-45.21-45.3a15.88 15.88 0 0 0-22.59 0l-151.5 151.5-55.41-55.5a15.88 15.88 0 0 0-22.59 0l-45.3 45.3a16 16 0 0 0 0 22.59l112 112.21a15.89 15.89 0 0 0 22.6 0l208-208.21a16 16 0 0 0-.02-22.59z"
                }
            }
        ]
    })(props);
}
function FaSpider(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M151.17 167.35L177.1 176h4.67l5.22-26.12c.72-3.58 1.8-7.58 3.21-11.79l-20.29-40.58 23.8-71.39c2.79-8.38-1.73-17.44-10.12-20.24L168.42.82c-8.38-2.8-17.45 1.73-20.24 10.12l-25.89 77.68a32.04 32.04 0 0 0 1.73 24.43l27.15 54.3zm422.14 182.03l-52.75-79.12a32.002 32.002 0 0 0-26.62-14.25H416l68.99-24.36a32.03 32.03 0 0 0 16.51-12.61l53.6-80.41c4.9-7.35 2.91-17.29-4.44-22.19l-13.31-8.88c-7.35-4.9-17.29-2.91-22.19 4.44l-50.56 75.83L404.1 208H368l-10.37-51.85C355.44 145.18 340.26 96 288 96c-52.26 0-67.44 49.18-69.63 60.15L208 208h-36.1l-60.49-20.17L60.84 112c-4.9-7.35-14.83-9.34-22.19-4.44l-13.31 8.88c-7.35 4.9-9.34 14.83-4.44 22.19l53.6 80.41a32.03 32.03 0 0 0 16.51 12.61L160 256H82.06a32.02 32.02 0 0 0-26.63 14.25L2.69 349.38c-4.9 7.35-2.92 17.29 4.44 22.19l13.31 8.88c7.35 4.9 17.29 2.91 22.19-4.44l48-72h47.06l-60.83 97.33A31.988 31.988 0 0 0 72 418.3V496c0 8.84 7.16 16 16 16h16c8.84 0 16-7.16 16-16v-73.11l74.08-118.53c-1.01 14.05-2.08 28.11-2.08 42.21C192 399.64 232.76 448 288 448s96-48.36 96-101.43c0-14.1-1.08-28.16-2.08-42.21L456 422.89V496c0 8.84 7.16 16 16 16h16c8.84 0 16-7.16 16-16v-77.71c0-6-1.69-11.88-4.86-16.96L438.31 304h47.06l48 72c4.9 7.35 14.84 9.34 22.19 4.44l13.31-8.88c7.36-4.9 9.34-14.83 4.44-22.18zM406.09 97.51l-20.29 40.58c1.41 4.21 2.49 8.21 3.21 11.79l5.22 26.12h4.67l25.93-8.65 27.15-54.3a31.995 31.995 0 0 0 1.73-24.43l-25.89-77.68C425.03 2.56 415.96-1.98 407.58.82l-15.17 5.06c-8.38 2.8-12.91 11.86-10.12 20.24l23.8 71.39z"
                }
            }
        ]
    })(props);
}
function FaSpinner(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M304 48c0 26.51-21.49 48-48 48s-48-21.49-48-48 21.49-48 48-48 48 21.49 48 48zm-48 368c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.49-48-48-48zm208-208c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.49-48-48-48zM96 256c0-26.51-21.49-48-48-48S0 229.49 0 256s21.49 48 48 48 48-21.49 48-48zm12.922 99.078c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48c0-26.509-21.491-48-48-48zm294.156 0c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48c0-26.509-21.49-48-48-48zM108.922 60.922c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.491-48-48-48z"
                }
            }
        ]
    })(props);
}
function FaSplotch(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M472.29 195.89l-67.06-22.95c-19.28-6.6-33.54-20.92-38.14-38.3L351.1 74.19c-11.58-43.77-76.57-57.13-109.98-22.62l-46.14 47.67c-13.26 13.71-33.54 20.93-54.2 19.31l-71.88-5.62c-52.05-4.07-86.93 44.88-59.03 82.83l38.54 52.42c11.08 15.07 12.82 33.86 4.64 50.24L24.62 355.4c-20.59 41.25 22.84 84.87 73.49 73.81l69.96-15.28c20.11-4.39 41.45 0 57.07 11.73l54.32 40.83c39.32 29.56 101.04 7.57 104.45-37.22l4.7-61.86c1.35-17.79 12.8-33.86 30.63-42.99l62-31.74c44.88-22.96 39.59-80.17-8.95-96.79z"
                }
            }
        ]
    })(props);
}
function FaSprayCan(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M224 32c0-17.67-14.33-32-32-32h-64c-17.67 0-32 14.33-32 32v96h128V32zm256 96c-17.67 0-32 14.33-32 32s14.33 32 32 32 32-14.33 32-32-14.33-32-32-32zm-256 32H96c-53.02 0-96 42.98-96 96v224c0 17.67 14.33 32 32 32h256c17.67 0 32-14.33 32-32V256c0-53.02-42.98-96-96-96zm-64 256c-44.18 0-80-35.82-80-80s35.82-80 80-80 80 35.82 80 80-35.82 80-80 80zM480 96c17.67 0 32-14.33 32-32s-14.33-32-32-32-32 14.33-32 32 14.33 32 32 32zm-96 32c-17.67 0-32 14.33-32 32s14.33 32 32 32 32-14.33 32-32-14.33-32-32-32zm-96-96c-17.67 0-32 14.33-32 32s14.33 32 32 32 32-14.33 32-32-14.33-32-32-32zm96 0c-17.67 0-32 14.33-32 32s14.33 32 32 32 32-14.33 32-32-14.33-32-32-32zm96 192c-17.67 0-32 14.33-32 32s14.33 32 32 32 32-14.33 32-32-14.33-32-32-32z"
                }
            }
        ]
    })(props);
}
function FaSquareFull(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M512 512H0V0h512v512z"
                }
            }
        ]
    })(props);
}
function FaSquareRootAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M571.31 251.31l-22.62-22.62c-6.25-6.25-16.38-6.25-22.63 0L480 274.75l-46.06-46.06c-6.25-6.25-16.38-6.25-22.63 0l-22.62 22.62c-6.25 6.25-6.25 16.38 0 22.63L434.75 320l-46.06 46.06c-6.25 6.25-6.25 16.38 0 22.63l22.62 22.62c6.25 6.25 16.38 6.25 22.63 0L480 365.25l46.06 46.06c6.25 6.25 16.38 6.25 22.63 0l22.62-22.62c6.25-6.25 6.25-16.38 0-22.63L525.25 320l46.06-46.06c6.25-6.25 6.25-16.38 0-22.63zM552 0H307.65c-14.54 0-27.26 9.8-30.95 23.87l-84.79 322.8-58.41-106.1A32.008 32.008 0 0 0 105.47 224H24c-13.25 0-24 10.74-24 24v48c0 13.25 10.75 24 24 24h43.62l88.88 163.73C168.99 503.5 186.3 512 204.94 512c17.27 0 44.44-9 54.28-41.48L357.03 96H552c13.25 0 24-10.75 24-24V24c0-13.26-10.75-24-24-24z"
                }
            }
        ]
    })(props);
}
function FaSquare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48z"
                }
            }
        ]
    })(props);
}
function FaStamp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M32 512h448v-64H32v64zm384-256h-66.56c-16.26 0-29.44-13.18-29.44-29.44v-9.46c0-27.37 8.88-53.41 21.46-77.72 9.11-17.61 12.9-38.39 9.05-60.42-6.77-38.78-38.47-70.7-77.26-77.45C212.62-9.04 160 37.33 160 96c0 14.16 3.12 27.54 8.69 39.58C182.02 164.43 192 194.7 192 226.49v.07c0 16.26-13.18 29.44-29.44 29.44H96c-53.02 0-96 42.98-96 96v32c0 17.67 14.33 32 32 32h448c17.67 0 32-14.33 32-32v-32c0-53.02-42.98-96-96-96z"
                }
            }
        ]
    })(props);
}
function FaStarAndCrescent(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M340.47 466.36c-1.45 0-6.89.46-9.18.46-116.25 0-210.82-94.57-210.82-210.82S215.04 45.18 331.29 45.18c2.32 0 7.7.46 9.18.46 7.13 0 13.33-5.03 14.75-12.07 1.46-7.25-2.55-14.49-9.47-17.09C316.58 5.54 286.39 0 256 0 114.84 0 0 114.84 0 256s114.84 256 256 256c30.23 0 60.28-5.49 89.32-16.32 5.96-2.02 10.28-7.64 10.28-14.26 0-8.09-6.39-15.06-15.13-15.06zm162.99-252.5l-76.38-11.1-34.16-69.21c-1.83-3.7-5.38-5.55-8.93-5.55s-7.1 1.85-8.93 5.55l-34.16 69.21-76.38 11.1c-8.17 1.18-11.43 11.22-5.52 16.99l55.27 53.87-13.05 76.07c-1.11 6.44 4.01 11.66 9.81 11.66 1.53 0 3.11-.36 4.64-1.17L384 335.37l68.31 35.91c1.53.8 3.11 1.17 4.64 1.17 5.8 0 10.92-5.23 9.81-11.66l-13.05-76.07 55.27-53.87c5.91-5.77 2.65-15.81-5.52-16.99z"
                }
            }
        ]
    })(props);
}
function FaStarHalfAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 536 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M508.55 171.51L362.18 150.2 296.77 17.81C290.89 5.98 279.42 0 267.95 0c-11.4 0-22.79 5.9-28.69 17.81l-65.43 132.38-146.38 21.29c-26.25 3.8-36.77 36.09-17.74 54.59l105.89 103-25.06 145.48C86.98 495.33 103.57 512 122.15 512c4.93 0 10-1.17 14.87-3.75l130.95-68.68 130.94 68.7c4.86 2.55 9.92 3.71 14.83 3.71 18.6 0 35.22-16.61 31.66-37.4l-25.03-145.49 105.91-102.98c19.04-18.5 8.52-50.8-17.73-54.6zm-121.74 123.2l-18.12 17.62 4.28 24.88 19.52 113.45-102.13-53.59-22.38-11.74.03-317.19 51.03 103.29 11.18 22.63 25.01 3.64 114.23 16.63-82.65 80.38z"
                }
            }
        ]
    })(props);
}
function FaStarHalf(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M288 0c-11.4 0-22.8 5.9-28.7 17.8L194 150.2 47.9 171.4c-26.2 3.8-36.7 36.1-17.7 54.6l105.7 103-25 145.5c-4.5 26.1 23 46 46.4 33.7L288 439.6V0z"
                }
            }
        ]
    })(props);
}
function FaStarOfDavid(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 464 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M405.68 256l53.21-89.39C473.3 142.4 455.48 112 426.88 112H319.96l-55.95-93.98C256.86 6.01 244.43 0 232 0s-24.86 6.01-32.01 18.02L144.04 112H37.11c-28.6 0-46.42 30.4-32.01 54.61L58.32 256 5.1 345.39C-9.31 369.6 8.51 400 37.11 400h106.93l55.95 93.98C207.14 505.99 219.57 512 232 512s24.86-6.01 32.01-18.02L319.96 400h106.93c28.6 0 46.42-30.4 32.01-54.61L405.68 256zm-12.78-88l-19.8 33.26L353.3 168h39.6zm-52.39 88l-52.39 88H175.88l-52.39-88 52.38-88h112.25l52.39 88zM232 73.72L254.79 112h-45.57L232 73.72zM71.1 168h39.6l-19.8 33.26L71.1 168zm0 176l19.8-33.26L110.7 344H71.1zM232 438.28L209.21 400h45.57L232 438.28zM353.29 344l19.8-33.26L392.9 344h-39.61z"
                }
            }
        ]
    })(props);
}
function FaStarOfLife(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 480 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M471.99 334.43L336.06 256l135.93-78.43c7.66-4.42 10.28-14.2 5.86-21.86l-32.02-55.43c-4.42-7.65-14.21-10.28-21.87-5.86l-135.93 78.43V16c0-8.84-7.17-16-16.01-16h-64.04c-8.84 0-16.01 7.16-16.01 16v156.86L56.04 94.43c-7.66-4.42-17.45-1.79-21.87 5.86L2.15 155.71c-4.42 7.65-1.8 17.44 5.86 21.86L143.94 256 8.01 334.43c-7.66 4.42-10.28 14.21-5.86 21.86l32.02 55.43c4.42 7.65 14.21 10.27 21.87 5.86l135.93-78.43V496c0 8.84 7.17 16 16.01 16h64.04c8.84 0 16.01-7.16 16.01-16V339.14l135.93 78.43c7.66 4.42 17.45 1.8 21.87-5.86l32.02-55.43c4.42-7.65 1.8-17.43-5.86-21.85z"
                }
            }
        ]
    })(props);
}
function FaStar(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M259.3 17.8L194 150.2 47.9 171.5c-26.2 3.8-36.7 36.1-17.7 54.6l105.7 103-25 145.5c-4.5 26.3 23.2 46 46.4 33.7L288 439.6l130.7 68.7c23.2 12.2 50.9-7.4 46.4-33.7l-25-145.5 105.7-103c19-18.5 8.5-50.8-17.7-54.6L382 150.2 316.7 17.8c-11.7-23.6-45.6-23.9-57.4 0z"
                }
            }
        ]
    })(props);
}
function FaStepBackward(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M64 468V44c0-6.6 5.4-12 12-12h48c6.6 0 12 5.4 12 12v176.4l195.5-181C352.1 22.3 384 36.6 384 64v384c0 27.4-31.9 41.7-52.5 24.6L136 292.7V468c0 6.6-5.4 12-12 12H76c-6.6 0-12-5.4-12-12z"
                }
            }
        ]
    })(props);
}
function FaStepForward(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M384 44v424c0 6.6-5.4 12-12 12h-48c-6.6 0-12-5.4-12-12V291.6l-195.5 181C95.9 489.7 64 475.4 64 448V64c0-27.4 31.9-41.7 52.5-24.6L312 219.3V44c0-6.6 5.4-12 12-12h48c6.6 0 12 5.4 12 12z"
                }
            }
        ]
    })(props);
}
function FaStethoscope(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M447.1 112c-34.2.5-62.3 28.4-63 62.6-.5 24.3 12.5 45.6 32 56.8V344c0 57.3-50.2 104-112 104-60 0-109.2-44.1-111.9-99.2C265 333.8 320 269.2 320 192V36.6c0-11.4-8.1-21.3-19.3-23.5L237.8.5c-13-2.6-25.6 5.8-28.2 18.8L206.4 35c-2.6 13 5.8 25.6 18.8 28.2l30.7 6.1v121.4c0 52.9-42.2 96.7-95.1 97.2-53.4.5-96.9-42.7-96.9-96V69.4l30.7-6.1c13-2.6 21.4-15.2 18.8-28.2l-3.1-15.7C107.7 6.4 95.1-2 82.1.6L19.3 13C8.1 15.3 0 25.1 0 36.6V192c0 77.3 55.1 142 128.1 156.8C130.7 439.2 208.6 512 304 512c97 0 176-75.4 176-168V231.4c19.1-11.1 32-31.7 32-55.4 0-35.7-29.2-64.5-64.9-64zm.9 80c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16z"
                }
            }
        ]
    })(props);
}
function FaStickyNote(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M312 320h136V56c0-13.3-10.7-24-24-24H24C10.7 32 0 42.7 0 56v400c0 13.3 10.7 24 24 24h264V344c0-13.2 10.8-24 24-24zm129 55l-98 98c-4.5 4.5-10.6 7-17 7h-6V352h128v6.1c0 6.3-2.5 12.4-7 16.9z"
                }
            }
        ]
    })(props);
}
function FaStopCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm96 328c0 8.8-7.2 16-16 16H176c-8.8 0-16-7.2-16-16V176c0-8.8 7.2-16 16-16h160c8.8 0 16 7.2 16 16v160z"
                }
            }
        ]
    })(props);
}
function FaStop(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48z"
                }
            }
        ]
    })(props);
}
function FaStopwatch20(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M398.5,190.91l.59-.61,26.59-26.58a16,16,0,0,0,0-22.63L403,118.41a16,16,0,0,0-22.63,0l-24.68,24.68A206.68,206.68,0,0,0,256,98.5V64h32a16,16,0,0,0,16-16V16A16,16,0,0,0,288,0H160a16.05,16.05,0,0,0-16,16V48a16.05,16.05,0,0,0,16,16h32V98.5A207.92,207.92,0,0,0,16.09,297.57C12.64,411.5,106.76,510.22,220.72,512,337.13,513.77,432,420,432,304A206,206,0,0,0,398.5,190.91ZM204.37,377.55a8.2,8.2,0,0,1,8.32,8.07v22.31a8.2,8.2,0,0,1-8.32,8.07H121.52a16.46,16.46,0,0,1-16.61-17.62c2.78-35.22,14.67-57.41,38.45-91.37,20.42-29.19,27.1-37.32,27.1-62.34,0-16.92-1.79-24.27-12.21-24.27-9.39,0-12.69,7.4-12.69,22.68v5.23a8.2,8.2,0,0,1-8.33,8.07h-24.9a8.2,8.2,0,0,1-8.33-8.07v-4.07c0-27.3,8.48-60.24,56.43-60.24,43,0,55.57,25.85,55.57,61,0,35.58-12.44,51.21-34.35,81.31-11.56,15-24.61,35.57-26.41,51.2ZM344,352.32c0,35.16-12.3,63.68-57.23,63.68C243.19,416,232,386.48,232,352.55V247.22c0-40.73,19.58-63.22,56.2-63.22C325,184,344,206.64,344,245.3ZM287.87,221.73c-9.41,0-13.23,7.5-13.23,20V357.68c0,13.11,3.59,20.59,13.23,20.59s13-8,13-21.27V241.06C300.89,229.79,297.88,221.73,287.87,221.73Z"
                }
            }
        ]
    })(props);
}
function FaStopwatch(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M432 304c0 114.9-93.1 208-208 208S16 418.9 16 304c0-104 76.3-190.2 176-205.5V64h-28c-6.6 0-12-5.4-12-12V12c0-6.6 5.4-12 12-12h120c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12h-28v34.5c37.5 5.8 71.7 21.6 99.7 44.6l27.5-27.5c4.7-4.7 12.3-4.7 17 0l28.3 28.3c4.7 4.7 4.7 12.3 0 17l-29.4 29.4-.6.6C419.7 223.3 432 262.2 432 304zm-176 36V188.5c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12V340c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12z"
                }
            }
        ]
    })(props);
}
function FaStoreAltSlash(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M17.89,123.62,5.51,142.2c-14.2,21.3,1,49.8,26.59,49.8h74.26ZM576,413.42V224H512V364L384,265V224H330.92l-41.4-32H608c25.5,0,40.7-28.5,26.59-49.8l-85.29-128A32.18,32.18,0,0,0,522.6,0H117.42A31.87,31.87,0,0,0,90.81,14.2l-10.66,16L45.46,3.38A16,16,0,0,0,23,6.19L3.37,31.46A16,16,0,0,0,6.18,53.91L594.53,508.63A16,16,0,0,0,617,505.81l19.64-25.26a16,16,0,0,0-2.81-22.45ZM320,384H128V224H64V480a32,32,0,0,0,32,32H352a32,32,0,0,0,32-32V406.59l-64-49.47Z"
                }
            }
        ]
    })(props);
}
function FaStoreAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M320 384H128V224H64v256c0 17.7 14.3 32 32 32h256c17.7 0 32-14.3 32-32V224h-64v160zm314.6-241.8l-85.3-128c-6-8.9-16-14.2-26.7-14.2H117.4c-10.7 0-20.7 5.3-26.6 14.2l-85.3 128c-14.2 21.3 1 49.8 26.6 49.8H608c25.5 0 40.7-28.5 26.6-49.8zM512 496c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V224h-64v272z"
                }
            }
        ]
    })(props);
}
function FaStoreSlash(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M121.51,384V284.2a119.43,119.43,0,0,1-28,3.8,123.46,123.46,0,0,1-17.1-1.2,114.88,114.88,0,0,1-15.58-3.6V480c0,17.7,13.59,32,30.4,32H505.75L348.42,384Zm-28-128.09c25.1,0,47.29-10.72,64-27.24L24,120.05c-30.52,53.39-2.45,126.53,56.49,135A95.68,95.68,0,0,0,93.48,255.91ZM602.13,458.09,547.2,413.41V283.2a93.5,93.5,0,0,1-15.57,3.6,127.31,127.31,0,0,1-17.29,1.2,114.89,114.89,0,0,1-28-3.8v79.68L348.52,251.77a88.06,88.06,0,0,0,25.41,4.14c28.11,0,53-13,70.11-33.11,17.19,20.11,42.08,33.11,70.11,33.11a94.31,94.31,0,0,0,13-.91c59.66-8.41,88-82.8,56.06-136.4L521.55,15A30.1,30.1,0,0,0,495.81,0H112A30.11,30.11,0,0,0,86.27,15L76.88,30.78,43.19,3.38A14.68,14.68,0,0,0,21.86,6.19L3.2,31.45A16.58,16.58,0,0,0,5.87,53.91L564.81,508.63a14.69,14.69,0,0,0,21.33-2.82l18.66-25.26A16.58,16.58,0,0,0,602.13,458.09Z"
                }
            }
        ]
    })(props);
}
function FaStore(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 616 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M602 118.6L537.1 15C531.3 5.7 521 0 510 0H106C95 0 84.7 5.7 78.9 15L14 118.6c-33.5 53.5-3.8 127.9 58.8 136.4 4.5.6 9.1.9 13.7.9 29.6 0 55.8-13 73.8-33.1 18 20.1 44.3 33.1 73.8 33.1 29.6 0 55.8-13 73.8-33.1 18 20.1 44.3 33.1 73.8 33.1 29.6 0 55.8-13 73.8-33.1 18.1 20.1 44.3 33.1 73.8 33.1 4.7 0 9.2-.3 13.7-.9 62.8-8.4 92.6-82.8 59-136.4zM529.5 288c-10 0-19.9-1.5-29.5-3.8V384H116v-99.8c-9.6 2.2-19.5 3.8-29.5 3.8-6 0-12.1-.4-18-1.2-5.6-.8-11.1-2.1-16.4-3.6V480c0 17.7 14.3 32 32 32h448c17.7 0 32-14.3 32-32V283.2c-5.4 1.6-10.8 2.9-16.4 3.6-6.1.8-12.1 1.2-18.2 1.2z"
                }
            }
        ]
    })(props);
}
function FaStream(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 128h416c8.84 0 16-7.16 16-16V48c0-8.84-7.16-16-16-16H16C7.16 32 0 39.16 0 48v64c0 8.84 7.16 16 16 16zm480 80H80c-8.84 0-16 7.16-16 16v64c0 8.84 7.16 16 16 16h416c8.84 0 16-7.16 16-16v-64c0-8.84-7.16-16-16-16zm-64 176H16c-8.84 0-16 7.16-16 16v64c0 8.84 7.16 16 16 16h416c8.84 0 16-7.16 16-16v-64c0-8.84-7.16-16-16-16z"
                }
            }
        ]
    })(props);
}
function FaStreetView(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M367.9 329.76c-4.62 5.3-9.78 10.1-15.9 13.65v22.94c66.52 9.34 112 28.05 112 49.65 0 30.93-93.12 56-208 56S48 446.93 48 416c0-21.6 45.48-40.3 112-49.65v-22.94c-6.12-3.55-11.28-8.35-15.9-13.65C58.87 345.34 0 378.05 0 416c0 53.02 114.62 96 256 96s256-42.98 256-96c0-37.95-58.87-70.66-144.1-86.24zM256 128c35.35 0 64-28.65 64-64S291.35 0 256 0s-64 28.65-64 64 28.65 64 64 64zm-64 192v96c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32v-96c17.67 0 32-14.33 32-32v-96c0-26.51-21.49-48-48-48h-11.8c-11.07 5.03-23.26 8-36.2 8s-25.13-2.97-36.2-8H208c-26.51 0-48 21.49-48 48v96c0 17.67 14.33 32 32 32z"
                }
            }
        ]
    })(props);
}
function FaStrikethrough(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M496 224H293.9l-87.17-26.83A43.55 43.55 0 0 1 219.55 112h66.79A49.89 49.89 0 0 1 331 139.58a16 16 0 0 0 21.46 7.15l42.94-21.47a16 16 0 0 0 7.16-21.46l-.53-1A128 128 0 0 0 287.51 32h-68a123.68 123.68 0 0 0-123 135.64c2 20.89 10.1 39.83 21.78 56.36H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h480a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm-180.24 96A43 43 0 0 1 336 356.45 43.59 43.59 0 0 1 292.45 400h-66.79A49.89 49.89 0 0 1 181 372.42a16 16 0 0 0-21.46-7.15l-42.94 21.47a16 16 0 0 0-7.16 21.46l.53 1A128 128 0 0 0 224.49 480h68a123.68 123.68 0 0 0 123-135.64 114.25 114.25 0 0 0-5.34-24.36z"
                }
            }
        ]
    })(props);
}
function FaStroopwafel(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M188.12 210.74L142.86 256l45.25 45.25L233.37 256l-45.25-45.26zm113.13-22.62L256 142.86l-45.25 45.25L256 233.37l45.25-45.25zm-90.5 135.76L256 369.14l45.26-45.26L256 278.63l-45.25 45.25zM256 0C114.62 0 0 114.62 0 256s114.62 256 256 256 256-114.62 256-256S397.38 0 256 0zm186.68 295.6l-11.31 11.31c-3.12 3.12-8.19 3.12-11.31 0l-28.29-28.29-45.25 45.25 33.94 33.94 16.97-16.97c3.12-3.12 8.19-3.12 11.31 0l11.31 11.31c3.12 3.12 3.12 8.19 0 11.31l-16.97 16.97 16.97 16.97c3.12 3.12 3.12 8.19 0 11.31l-11.31 11.31c-3.12 3.12-8.19 3.12-11.31 0l-16.97-16.97-16.97 16.97c-3.12 3.12-8.19 3.12-11.31 0l-11.31-11.31c-3.12-3.12-3.12-8.19 0-11.31l16.97-16.97-33.94-33.94-45.26 45.26 28.29 28.29c3.12 3.12 3.12 8.19 0 11.31l-11.31 11.31c-3.12 3.12-8.19 3.12-11.31 0L256 414.39l-28.29 28.29c-3.12 3.12-8.19 3.12-11.31 0l-11.31-11.31c-3.12-3.12-3.12-8.19 0-11.31l28.29-28.29-45.25-45.26-33.94 33.94 16.97 16.97c3.12 3.12 3.12 8.19 0 11.31l-11.31 11.31c-3.12 3.12-8.19 3.12-11.31 0l-16.97-16.97-16.97 16.97c-3.12 3.12-8.19 3.12-11.31 0l-11.31-11.31c-3.12-3.12-3.12-8.19 0-11.31l16.97-16.97-16.97-16.97c-3.12-3.12-3.12-8.19 0-11.31l11.31-11.31c3.12-3.12 8.19-3.12 11.31 0l16.97 16.97 33.94-33.94-45.25-45.25-28.29 28.29c-3.12 3.12-8.19 3.12-11.31 0L69.32 295.6c-3.12-3.12-3.12-8.19 0-11.31L97.61 256l-28.29-28.29c-3.12-3.12-3.12-8.19 0-11.31l11.31-11.31c3.12-3.12 8.19-3.12 11.31 0l28.29 28.29 45.25-45.26-33.94-33.94-16.97 16.97c-3.12 3.12-8.19 3.12-11.31 0l-11.31-11.31c-3.12-3.12-3.12-8.19 0-11.31l16.97-16.97-16.97-16.97c-3.12-3.12-3.12-8.19 0-11.31l11.31-11.31c3.12-3.12 8.19-3.12 11.31 0l16.97 16.97 16.97-16.97c3.12-3.12 8.19-3.12 11.31 0l11.31 11.31c3.12 3.12 3.12 8.19 0 11.31l-16.97 16.97 33.94 33.94 45.26-45.25-28.29-28.29c-3.12-3.12-3.12-8.19 0-11.31l11.31-11.31c3.12-3.12 8.19-3.12 11.31 0L256 97.61l28.29-28.29c3.12-3.12 8.19-3.12 11.31 0l11.31 11.31c3.12 3.12 3.12 8.19 0 11.31l-28.29 28.29 45.26 45.25 33.94-33.94-16.97-16.97c-3.12-3.12-3.12-8.19 0-11.31l11.31-11.31c3.12-3.12 8.19-3.12 11.31 0l16.97 16.97 16.97-16.97c3.12-3.12 8.19-3.12 11.31 0l11.31 11.31c3.12 3.12 3.12 8.19 0 11.31l-16.97 16.97 16.97 16.97c3.12 3.12 3.12 8.19 0 11.31l-11.31 11.31c-3.12 3.12-8.19 3.12-11.31 0l-16.97-16.97-33.94 33.94 45.25 45.26 28.29-28.29c3.12-3.12 8.19-3.12 11.31 0l11.31 11.31c3.12 3.12 3.12 8.19 0 11.31L414.39 256l28.29 28.28a8.015 8.015 0 0 1 0 11.32zM278.63 256l45.26 45.25L369.14 256l-45.25-45.26L278.63 256z"
                }
            }
        ]
    })(props);
}
function FaSubscript(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M496 448h-16V304a16 16 0 0 0-16-16h-48a16 16 0 0 0-14.29 8.83l-16 32A16 16 0 0 0 400 352h16v96h-16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h96a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zM336 64h-67a16 16 0 0 0-13.14 6.87l-79.9 115-79.9-115A16 16 0 0 0 83 64H16A16 16 0 0 0 0 80v48a16 16 0 0 0 16 16h33.48l77.81 112-77.81 112H16a16 16 0 0 0-16 16v48a16 16 0 0 0 16 16h67a16 16 0 0 0 13.14-6.87l79.9-115 79.9 115A16 16 0 0 0 269 448h67a16 16 0 0 0 16-16v-48a16 16 0 0 0-16-16h-33.48l-77.81-112 77.81-112H336a16 16 0 0 0 16-16V80a16 16 0 0 0-16-16z"
                }
            }
        ]
    })(props);
}
function FaSubway(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M448 96v256c0 51.815-61.624 96-130.022 96l62.98 49.721C386.905 502.417 383.562 512 376 512H72c-7.578 0-10.892-9.594-4.957-14.279L130.022 448C61.82 448 0 403.954 0 352V96C0 42.981 64 0 128 0h192c65 0 128 42.981 128 96zM200 232V120c0-13.255-10.745-24-24-24H72c-13.255 0-24 10.745-24 24v112c0 13.255 10.745 24 24 24h104c13.255 0 24-10.745 24-24zm200 0V120c0-13.255-10.745-24-24-24H272c-13.255 0-24 10.745-24 24v112c0 13.255 10.745 24 24 24h104c13.255 0 24-10.745 24-24zm-48 56c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.49-48-48-48zm-256 0c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.49-48-48-48z"
                }
            }
        ]
    })(props);
}
function FaSuitcaseRolling(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M336 160H48c-26.51 0-48 21.49-48 48v224c0 26.51 21.49 48 48 48h16v16c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16v-16h128v16c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16v-16h16c26.51 0 48-21.49 48-48V208c0-26.51-21.49-48-48-48zm-16 216c0 4.42-3.58 8-8 8H72c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h240c4.42 0 8 3.58 8 8v16zm0-96c0 4.42-3.58 8-8 8H72c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h240c4.42 0 8 3.58 8 8v16zM144 48h96v80h48V48c0-26.51-21.49-48-48-48h-96c-26.51 0-48 21.49-48 48v80h48V48z"
                }
            }
        ]
    })(props);
}
function FaSuitcase(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M128 480h256V80c0-26.5-21.5-48-48-48H176c-26.5 0-48 21.5-48 48v400zm64-384h128v32H192V96zm320 80v256c0 26.5-21.5 48-48 48h-48V128h48c26.5 0 48 21.5 48 48zM96 480H48c-26.5 0-48-21.5-48-48V176c0-26.5 21.5-48 48-48h48v352z"
                }
            }
        ]
    })(props);
}
function FaSun(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 160c-52.9 0-96 43.1-96 96s43.1 96 96 96 96-43.1 96-96-43.1-96-96-96zm246.4 80.5l-94.7-47.3 33.5-100.4c4.5-13.6-8.4-26.5-21.9-21.9l-100.4 33.5-47.4-94.8c-6.4-12.8-24.6-12.8-31 0l-47.3 94.7L92.7 70.8c-13.6-4.5-26.5 8.4-21.9 21.9l33.5 100.4-94.7 47.4c-12.8 6.4-12.8 24.6 0 31l94.7 47.3-33.5 100.5c-4.5 13.6 8.4 26.5 21.9 21.9l100.4-33.5 47.3 94.7c6.4 12.8 24.6 12.8 31 0l47.3-94.7 100.4 33.5c13.6 4.5 26.5-8.4 21.9-21.9l-33.5-100.4 94.7-47.3c13-6.5 13-24.7.2-31.1zm-155.9 106c-49.9 49.9-131.1 49.9-181 0-49.9-49.9-49.9-131.1 0-181 49.9-49.9 131.1-49.9 181 0 49.9 49.9 49.9 131.1 0 181z"
                }
            }
        ]
    })(props);
}
function FaSuperscript(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M496 160h-16V16a16 16 0 0 0-16-16h-48a16 16 0 0 0-14.29 8.83l-16 32A16 16 0 0 0 400 64h16v96h-16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h96a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zM336 64h-67a16 16 0 0 0-13.14 6.87l-79.9 115-79.9-115A16 16 0 0 0 83 64H16A16 16 0 0 0 0 80v48a16 16 0 0 0 16 16h33.48l77.81 112-77.81 112H16a16 16 0 0 0-16 16v48a16 16 0 0 0 16 16h67a16 16 0 0 0 13.14-6.87l79.9-115 79.9 115A16 16 0 0 0 269 448h67a16 16 0 0 0 16-16v-48a16 16 0 0 0-16-16h-33.48l-77.81-112 77.81-112H336a16 16 0 0 0 16-16V80a16 16 0 0 0-16-16z"
                }
            }
        ]
    })(props);
}
function FaSurprise(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zM136 208c0-17.7 14.3-32 32-32s32 14.3 32 32-14.3 32-32 32-32-14.3-32-32zm112 208c-35.3 0-64-28.7-64-64s28.7-64 64-64 64 28.7 64 64-28.7 64-64 64zm80-176c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32z"
                }
            }
        ]
    })(props);
}
function FaSwatchbook(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M434.66,167.71h0L344.5,77.36a31.83,31.83,0,0,0-45-.07h0l-.07.07L224,152.88V424L434.66,212.9A32,32,0,0,0,434.66,167.71ZM480,320H373.09L186.68,506.51c-2.06,2.07-4.5,3.58-6.68,5.49H480a32,32,0,0,0,32-32V352A32,32,0,0,0,480,320ZM192,32A32,32,0,0,0,160,0H32A32,32,0,0,0,0,32V416a96,96,0,0,0,192,0ZM96,440a24,24,0,1,1,24-24A24,24,0,0,1,96,440Zm32-184H64V192h64Zm0-128H64V64h64Z"
                }
            }
        ]
    })(props);
}
function FaSwimmer(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M189.61 310.58c3.54 3.26 15.27 9.42 34.39 9.42s30.86-6.16 34.39-9.42c16.02-14.77 34.5-22.58 53.46-22.58h16.3c18.96 0 37.45 7.81 53.46 22.58 3.54 3.26 15.27 9.42 34.39 9.42s30.86-6.16 34.39-9.42c14.86-13.71 31.88-21.12 49.39-22.16l-112.84-80.6 18-12.86c3.64-2.58 8.28-3.52 12.62-2.61l100.35 21.53c25.91 5.53 51.44-10.97 57-36.88 5.55-25.92-10.95-51.44-36.88-57L437.68 98.47c-30.73-6.58-63.02.12-88.56 18.38l-80.02 57.17c-10.38 7.39-19.36 16.44-26.72 26.94L173.75 299c5.47 3.23 10.82 6.93 15.86 11.58zM624 352h-16c-26.04 0-45.8-8.42-56.09-17.9-8.9-8.21-19.66-14.1-31.77-14.1h-16.3c-12.11 0-22.87 5.89-31.77 14.1C461.8 343.58 442.04 352 416 352s-45.8-8.42-56.09-17.9c-8.9-8.21-19.66-14.1-31.77-14.1h-16.3c-12.11 0-22.87 5.89-31.77 14.1C269.8 343.58 250.04 352 224 352s-45.8-8.42-56.09-17.9c-8.9-8.21-19.66-14.1-31.77-14.1h-16.3c-12.11 0-22.87 5.89-31.77 14.1C77.8 343.58 58.04 352 32 352H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h16c38.62 0 72.72-12.19 96-31.84 23.28 19.66 57.38 31.84 96 31.84s72.72-12.19 96-31.84c23.28 19.66 57.38 31.84 96 31.84s72.72-12.19 96-31.84c23.28 19.66 57.38 31.84 96 31.84h16c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16zm-512-96c44.18 0 80-35.82 80-80s-35.82-80-80-80-80 35.82-80 80 35.82 80 80 80z"
                }
            }
        ]
    })(props);
}
function FaSwimmingPool(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M624 416h-16c-26.04 0-45.8-8.42-56.09-17.9-8.9-8.21-19.66-14.1-31.77-14.1h-16.3c-12.11 0-22.87 5.89-31.77 14.1C461.8 407.58 442.04 416 416 416s-45.8-8.42-56.09-17.9c-8.9-8.21-19.66-14.1-31.77-14.1h-16.3c-12.11 0-22.87 5.89-31.77 14.1C269.8 407.58 250.04 416 224 416s-45.8-8.42-56.09-17.9c-8.9-8.21-19.66-14.1-31.77-14.1h-16.3c-12.11 0-22.87 5.89-31.77 14.1C77.8 407.58 58.04 416 32 416H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h16c38.62 0 72.72-12.19 96-31.84 23.28 19.66 57.38 31.84 96 31.84s72.72-12.19 96-31.84c23.28 19.66 57.38 31.84 96 31.84s72.72-12.19 96-31.84c23.28 19.66 57.38 31.84 96 31.84h16c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16zm-400-32v-96h192v96c19.12 0 30.86-6.16 34.39-9.42 9.17-8.46 19.2-14.34 29.61-18.07V128c0-17.64 14.36-32 32-32s32 14.36 32 32v16c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16v-16c0-52.94-43.06-96-96-96s-96 43.06-96 96v96H224v-96c0-17.64 14.36-32 32-32s32 14.36 32 32v16c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16v-16c0-52.94-43.06-96-96-96s-96 43.06-96 96v228.5c10.41 3.73 20.44 9.62 29.61 18.07 3.53 3.27 15.27 9.43 34.39 9.43z"
                }
            }
        ]
    })(props);
}
function FaSynagogue(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M70 196.51L6.67 268.29A26.643 26.643 0 0 0 0 285.93V512h128V239.58l-38-43.07c-5.31-6.01-14.69-6.01-20 0zm563.33 71.78L570 196.51c-5.31-6.02-14.69-6.02-20 0l-38 43.07V512h128V285.93c0-6.5-2.37-12.77-6.67-17.64zM339.99 7.01c-11.69-9.35-28.29-9.35-39.98 0l-128 102.4A32.005 32.005 0 0 0 160 134.4V512h96v-92.57c0-31.88 21.78-61.43 53.25-66.55C349.34 346.35 384 377.13 384 416v96h96V134.4c0-9.72-4.42-18.92-12.01-24.99l-128-102.4zm52.07 215.55c1.98 3.15-.29 7.24-4 7.24h-38.94L324 269.79c-1.85 2.95-6.15 2.95-8 0l-25.12-39.98h-38.94c-3.72 0-5.98-4.09-4-7.24l19.2-30.56-19.2-30.56c-1.98-3.15.29-7.24 4-7.24h38.94l25.12-40c1.85-2.95 6.15-2.95 8 0l25.12 39.98h38.95c3.71 0 5.98 4.09 4 7.24L372.87 192l19.19 30.56z"
                }
            }
        ]
    })(props);
}
function FaSyncAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M370.72 133.28C339.458 104.008 298.888 87.962 255.848 88c-77.458.068-144.328 53.178-162.791 126.85-1.344 5.363-6.122 9.15-11.651 9.15H24.103c-7.498 0-13.194-6.807-11.807-14.176C33.933 94.924 134.813 8 256 8c66.448 0 126.791 26.136 171.315 68.685L463.03 40.97C478.149 25.851 504 36.559 504 57.941V192c0 13.255-10.745 24-24 24H345.941c-21.382 0-32.09-25.851-16.971-40.971l41.75-41.749zM32 296h134.059c21.382 0 32.09 25.851 16.971 40.971l-41.75 41.75c31.262 29.273 71.835 45.319 114.876 45.28 77.418-.07 144.315-53.144 162.787-126.849 1.344-5.363 6.122-9.15 11.651-9.15h57.304c7.498 0 13.194 6.807 11.807 14.176C478.067 417.076 377.187 504 256 504c-66.448 0-126.791-26.136-171.315-68.685L48.97 471.03C33.851 486.149 8 475.441 8 454.059V320c0-13.255 10.745-24 24-24z"
                }
            }
        ]
    })(props);
}
function FaSync(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M440.65 12.57l4 82.77A247.16 247.16 0 0 0 255.83 8C134.73 8 33.91 94.92 12.29 209.82A12 12 0 0 0 24.09 224h49.05a12 12 0 0 0 11.67-9.26 175.91 175.91 0 0 1 317-56.94l-101.46-4.86a12 12 0 0 0-12.57 12v47.41a12 12 0 0 0 12 12H500a12 12 0 0 0 12-12V12a12 12 0 0 0-12-12h-47.37a12 12 0 0 0-11.98 12.57zM255.83 432a175.61 175.61 0 0 1-146-77.8l101.8 4.87a12 12 0 0 0 12.57-12v-47.4a12 12 0 0 0-12-12H12a12 12 0 0 0-12 12V500a12 12 0 0 0 12 12h47.35a12 12 0 0 0 12-12.6l-4.15-82.57A247.17 247.17 0 0 0 255.83 504c121.11 0 221.93-86.92 243.55-201.82a12 12 0 0 0-11.8-14.18h-49.05a12 12 0 0 0-11.67 9.26A175.86 175.86 0 0 1 255.83 432z"
                }
            }
        ]
    })(props);
}
function FaSyringe(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M201.5 174.8l55.7 55.8c3.1 3.1 3.1 8.2 0 11.3l-11.3 11.3c-3.1 3.1-8.2 3.1-11.3 0l-55.7-55.8-45.3 45.3 55.8 55.8c3.1 3.1 3.1 8.2 0 11.3l-11.3 11.3c-3.1 3.1-8.2 3.1-11.3 0L111 265.2l-26.4 26.4c-17.3 17.3-25.6 41.1-23 65.4l7.1 63.6L2.3 487c-3.1 3.1-3.1 8.2 0 11.3l11.3 11.3c3.1 3.1 8.2 3.1 11.3 0l66.3-66.3 63.6 7.1c23.9 2.6 47.9-5.4 65.4-23l181.9-181.9-135.7-135.7-64.9 65zm308.2-93.3L430.5 2.3c-3.1-3.1-8.2-3.1-11.3 0l-11.3 11.3c-3.1 3.1-3.1 8.2 0 11.3l28.3 28.3-45.3 45.3-56.6-56.6-17-17c-3.1-3.1-8.2-3.1-11.3 0l-33.9 33.9c-3.1 3.1-3.1 8.2 0 11.3l17 17L424.8 223l17 17c3.1 3.1 8.2 3.1 11.3 0l33.9-34c3.1-3.1 3.1-8.2 0-11.3l-73.5-73.5 45.3-45.3 28.3 28.3c3.1 3.1 8.2 3.1 11.3 0l11.3-11.3c3.1-3.2 3.1-8.2 0-11.4z"
                }
            }
        ]
    })(props);
}
function FaTableTennis(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M496.2 296.5C527.7 218.7 512 126.2 449 63.1 365.1-21 229-21 145.1 63.1l-56 56.1 211.5 211.5c46.1-62.1 131.5-77.4 195.6-34.2zm-217.9 79.7L57.9 155.9c-27.3 45.3-21.7 105 17.3 144.1l34.5 34.6L6.7 424c-8.6 7.5-9.1 20.7-1 28.8l53.4 53.5c8 8.1 21.2 7.6 28.7-1L177.1 402l35.7 35.7c19.7 19.7 44.6 30.5 70.3 33.3-7.1-17-11-35.6-11-55.1-.1-13.8 2.5-27 6.2-39.7zM416 320c-53 0-96 43-96 96s43 96 96 96 96-43 96-96-43-96-96-96z"
                }
            }
        ]
    })(props);
}
function FaTable(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M464 32H48C21.49 32 0 53.49 0 80v352c0 26.51 21.49 48 48 48h416c26.51 0 48-21.49 48-48V80c0-26.51-21.49-48-48-48zM224 416H64v-96h160v96zm0-160H64v-96h160v96zm224 160H288v-96h160v96zm0-160H288v-96h160v96z"
                }
            }
        ]
    })(props);
}
function FaTabletAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M400 0H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48zM224 480c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm176-108c0 6.6-5.4 12-12 12H60c-6.6 0-12-5.4-12-12V60c0-6.6 5.4-12 12-12h328c6.6 0 12 5.4 12 12v312z"
                }
            }
        ]
    })(props);
}
function FaTablet(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M400 0H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48zM224 480c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32z"
                }
            }
        ]
    })(props);
}
function FaTablets(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M160 192C78.9 192 12.5 250.5.1 326.7c-.8 4.8 3.3 9.3 8.3 9.3h303.3c5 0 9.1-4.5 8.3-9.3C307.5 250.5 241.1 192 160 192zm151.6 176H8.4c-5 0-9.1 4.5-8.3 9.3C12.5 453.5 78.9 512 160 512s147.5-58.5 159.9-134.7c.8-4.8-3.3-9.3-8.3-9.3zM593.4 46.6c-56.5-56.5-144.2-61.4-206.9-16-4 2.9-4.3 8.9-.8 12.3L597 254.3c3.5 3.5 9.5 3.2 12.3-.8 45.5-62.7 40.6-150.4-15.9-206.9zM363 65.7c-3.5-3.5-9.5-3.2-12.3.8-45.4 62.7-40.5 150.4 15.9 206.9 56.5 56.5 144.2 61.4 206.9 15.9 4-2.9 4.3-8.9.8-12.3L363 65.7z"
                }
            }
        ]
    })(props);
}
function FaTachometerAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M288 32C128.94 32 0 160.94 0 320c0 52.8 14.25 102.26 39.06 144.8 5.61 9.62 16.3 15.2 27.44 15.2h443c11.14 0 21.83-5.58 27.44-15.2C561.75 422.26 576 372.8 576 320c0-159.06-128.94-288-288-288zm0 64c14.71 0 26.58 10.13 30.32 23.65-1.11 2.26-2.64 4.23-3.45 6.67l-9.22 27.67c-5.13 3.49-10.97 6.01-17.64 6.01-17.67 0-32-14.33-32-32S270.33 96 288 96zM96 384c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm48-160c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm246.77-72.41l-61.33 184C343.13 347.33 352 364.54 352 384c0 11.72-3.38 22.55-8.88 32H232.88c-5.5-9.45-8.88-20.28-8.88-32 0-33.94 26.5-61.43 59.9-63.59l61.34-184.01c4.17-12.56 17.73-19.45 30.36-15.17 12.57 4.19 19.35 17.79 15.17 30.36zm14.66 57.2l15.52-46.55c3.47-1.29 7.13-2.23 11.05-2.23 17.67 0 32 14.33 32 32s-14.33 32-32 32c-11.38-.01-20.89-6.28-26.57-15.22zM480 384c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32z"
                }
            }
        ]
    })(props);
}
function FaTag(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 252.118V48C0 21.49 21.49 0 48 0h204.118a48 48 0 0 1 33.941 14.059l211.882 211.882c18.745 18.745 18.745 49.137 0 67.882L293.823 497.941c-18.745 18.745-49.137 18.745-67.882 0L14.059 286.059A48 48 0 0 1 0 252.118zM112 64c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.49-48-48-48z"
                }
            }
        ]
    })(props);
}
function FaTags(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M497.941 225.941L286.059 14.059A48 48 0 0 0 252.118 0H48C21.49 0 0 21.49 0 48v204.118a48 48 0 0 0 14.059 33.941l211.882 211.882c18.744 18.745 49.136 18.746 67.882 0l204.118-204.118c18.745-18.745 18.745-49.137 0-67.882zM112 160c-26.51 0-48-21.49-48-48s21.49-48 48-48 48 21.49 48 48-21.49 48-48 48zm513.941 133.823L421.823 497.941c-18.745 18.745-49.137 18.745-67.882 0l-.36-.36L527.64 323.522c16.999-16.999 26.36-39.6 26.36-63.64s-9.362-46.641-26.36-63.64L331.397 0h48.721a48 48 0 0 1 33.941 14.059l211.882 211.882c18.745 18.745 18.745 49.137 0 67.882z"
                }
            }
        ]
    })(props);
}
function FaTape(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M224 192c-35.3 0-64 28.7-64 64s28.7 64 64 64 64-28.7 64-64-28.7-64-64-64zm400 224H380.6c41.5-40.7 67.4-97.3 67.4-160 0-123.7-100.3-224-224-224S0 132.3 0 256s100.3 224 224 224h400c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zm-400-64c-53 0-96-43-96-96s43-96 96-96 96 43 96 96-43 96-96 96z"
                }
            }
        ]
    })(props);
}
function FaTasks(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M139.61 35.5a12 12 0 0 0-17 0L58.93 98.81l-22.7-22.12a12 12 0 0 0-17 0L3.53 92.41a12 12 0 0 0 0 17l47.59 47.4a12.78 12.78 0 0 0 17.61 0l15.59-15.62L156.52 69a12.09 12.09 0 0 0 .09-17zm0 159.19a12 12 0 0 0-17 0l-63.68 63.72-22.7-22.1a12 12 0 0 0-17 0L3.53 252a12 12 0 0 0 0 17L51 316.5a12.77 12.77 0 0 0 17.6 0l15.7-15.69 72.2-72.22a12 12 0 0 0 .09-16.9zM64 368c-26.49 0-48.59 21.5-48.59 48S37.53 464 64 464a48 48 0 0 0 0-96zm432 16H208a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h288a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0-320H208a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h288a16 16 0 0 0 16-16V80a16 16 0 0 0-16-16zm0 160H208a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h288a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16z"
                }
            }
        ]
    })(props);
}
function FaTaxi(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M462 241.64l-22-84.84c-9.6-35.2-41.6-60.8-76.8-60.8H352V64c0-17.67-14.33-32-32-32H192c-17.67 0-32 14.33-32 32v32h-11.2c-35.2 0-67.2 25.6-76.8 60.8l-22 84.84C21.41 248.04 0 273.47 0 304v48c0 23.63 12.95 44.04 32 55.12V448c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32v-32h256v32c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32v-40.88c19.05-11.09 32-31.5 32-55.12v-48c0-30.53-21.41-55.96-50-62.36zM96 352c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm20.55-112l17.2-66.36c2.23-8.16 9.59-13.64 15.06-13.64h214.4c5.47 0 12.83 5.48 14.85 12.86L395.45 240h-278.9zM416 352c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32z"
                }
            }
        ]
    })(props);
}
function FaTeethOpen(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M544 0H96C42.98 0 0 42.98 0 96v64c0 35.35 28.66 64 64 64h512c35.34 0 64-28.65 64-64V96c0-53.02-42.98-96-96-96zM160 176c0 8.84-7.16 16-16 16H80c-8.84 0-16-7.16-16-16v-32c0-26.51 21.49-48 48-48s48 21.49 48 48v32zm144 0c0 8.84-7.16 16-16 16h-80c-8.84 0-16-7.16-16-16v-56c0-30.93 25.07-56 56-56s56 25.07 56 56v56zm144 0c0 8.84-7.16 16-16 16h-80c-8.84 0-16-7.16-16-16v-56c0-30.93 25.07-56 56-56s56 25.07 56 56v56zm128 0c0 8.84-7.16 16-16 16h-64c-8.84 0-16-7.16-16-16v-32c0-26.51 21.49-48 48-48s48 21.49 48 48v32zm0 144H64c-35.34 0-64 28.65-64 64v32c0 53.02 42.98 96 96 96h448c53.02 0 96-42.98 96-96v-32c0-35.35-28.66-64-64-64zm-416 80c0 26.51-21.49 48-48 48s-48-21.49-48-48v-32c0-8.84 7.16-16 16-16h64c8.84 0 16 7.16 16 16v32zm144-8c0 30.93-25.07 56-56 56s-56-25.07-56-56v-24c0-8.84 7.16-16 16-16h80c8.84 0 16 7.16 16 16v24zm144 0c0 30.93-25.07 56-56 56s-56-25.07-56-56v-24c0-8.84 7.16-16 16-16h80c8.84 0 16 7.16 16 16v24zm128 8c0 26.51-21.49 48-48 48s-48-21.49-48-48v-32c0-8.84 7.16-16 16-16h64c8.84 0 16 7.16 16 16v32z"
                }
            }
        ]
    })(props);
}
function FaTeeth(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M544 0H96C42.98 0 0 42.98 0 96v320c0 53.02 42.98 96 96 96h448c53.02 0 96-42.98 96-96V96c0-53.02-42.98-96-96-96zM160 368c0 26.51-21.49 48-48 48s-48-21.49-48-48v-64c0-8.84 7.16-16 16-16h64c8.84 0 16 7.16 16 16v64zm0-128c0 8.84-7.16 16-16 16H80c-8.84 0-16-7.16-16-16v-64c0-26.51 21.49-48 48-48s48 21.49 48 48v64zm144 120c0 30.93-25.07 56-56 56s-56-25.07-56-56v-56c0-8.84 7.16-16 16-16h80c8.84 0 16 7.16 16 16v56zm0-120c0 8.84-7.16 16-16 16h-80c-8.84 0-16-7.16-16-16v-88c0-30.93 25.07-56 56-56s56 25.07 56 56v88zm144 120c0 30.93-25.07 56-56 56s-56-25.07-56-56v-56c0-8.84 7.16-16 16-16h80c8.84 0 16 7.16 16 16v56zm0-120c0 8.84-7.16 16-16 16h-80c-8.84 0-16-7.16-16-16v-88c0-30.93 25.07-56 56-56s56 25.07 56 56v88zm128 128c0 26.51-21.49 48-48 48s-48-21.49-48-48v-64c0-8.84 7.16-16 16-16h64c8.84 0 16 7.16 16 16v64zm0-128c0 8.84-7.16 16-16 16h-64c-8.84 0-16-7.16-16-16v-64c0-26.51 21.49-48 48-48s48 21.49 48 48v64z"
                }
            }
        ]
    })(props);
}
function FaTemperatureHigh(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M416 0c-52.9 0-96 43.1-96 96s43.1 96 96 96 96-43.1 96-96-43.1-96-96-96zm0 128c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm-160-16C256 50.1 205.9 0 144 0S32 50.1 32 112v166.5C12.3 303.2 0 334 0 368c0 79.5 64.5 144 144 144s144-64.5 144-144c0-34-12.3-64.9-32-89.5V112zM144 448c-44.1 0-80-35.9-80-80 0-25.5 12.2-48.9 32-63.8V112c0-26.5 21.5-48 48-48s48 21.5 48 48v192.2c19.8 14.8 32 38.3 32 63.8 0 44.1-35.9 80-80 80zm16-125.1V112c0-8.8-7.2-16-16-16s-16 7.2-16 16v210.9c-18.6 6.6-32 24.2-32 45.1 0 26.5 21.5 48 48 48s48-21.5 48-48c0-20.9-13.4-38.5-32-45.1z"
                }
            }
        ]
    })(props);
}
function FaTemperatureLow(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M416 0c-52.9 0-96 43.1-96 96s43.1 96 96 96 96-43.1 96-96-43.1-96-96-96zm0 128c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm-160-16C256 50.1 205.9 0 144 0S32 50.1 32 112v166.5C12.3 303.2 0 334 0 368c0 79.5 64.5 144 144 144s144-64.5 144-144c0-34-12.3-64.9-32-89.5V112zM144 448c-44.1 0-80-35.9-80-80 0-25.5 12.2-48.9 32-63.8V112c0-26.5 21.5-48 48-48s48 21.5 48 48v192.2c19.8 14.8 32 38.3 32 63.8 0 44.1-35.9 80-80 80zm16-125.1V304c0-8.8-7.2-16-16-16s-16 7.2-16 16v18.9c-18.6 6.6-32 24.2-32 45.1 0 26.5 21.5 48 48 48s48-21.5 48-48c0-20.9-13.4-38.5-32-45.1z"
                }
            }
        ]
    })(props);
}
function FaTenge(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M372 160H12c-6.6 0-12 5.4-12 12v56c0 6.6 5.4 12 12 12h140v228c0 6.6 5.4 12 12 12h56c6.6 0 12-5.4 12-12V240h140c6.6 0 12-5.4 12-12v-56c0-6.6-5.4-12-12-12zm0-128H12C5.4 32 0 37.4 0 44v56c0 6.6 5.4 12 12 12h360c6.6 0 12-5.4 12-12V44c0-6.6-5.4-12-12-12z"
                }
            }
        ]
    })(props);
}
function FaTerminal(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M257.981 272.971L63.638 467.314c-9.373 9.373-24.569 9.373-33.941 0L7.029 444.647c-9.357-9.357-9.375-24.522-.04-33.901L161.011 256 6.99 101.255c-9.335-9.379-9.317-24.544.04-33.901l22.667-22.667c9.373-9.373 24.569-9.373 33.941 0L257.981 239.03c9.373 9.372 9.373 24.568 0 33.941zM640 456v-32c0-13.255-10.745-24-24-24H312c-13.255 0-24 10.745-24 24v32c0 13.255 10.745 24 24 24h304c13.255 0 24-10.745 24-24z"
                }
            }
        ]
    })(props);
}
function FaTextHeight(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M304 32H16A16 16 0 0 0 0 48v96a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32h56v304H80a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h160a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16h-40V112h56v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16zm256 336h-48V144h48c14.31 0 21.33-17.31 11.31-27.31l-80-80a16 16 0 0 0-22.62 0l-80 80C379.36 126 384.36 144 400 144h48v224h-48c-14.31 0-21.32 17.31-11.31 27.31l80 80a16 16 0 0 0 22.62 0l80-80C580.64 386 575.64 368 560 368z"
                }
            }
        ]
    })(props);
}
function FaTextWidth(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M432 32H16A16 16 0 0 0 0 48v80a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-16h120v112h-24a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h128a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16h-24V112h120v16a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16zm-68.69 260.69C354 283.36 336 288.36 336 304v48H112v-48c0-14.31-17.31-21.32-27.31-11.31l-80 80a16 16 0 0 0 0 22.62l80 80C94 484.64 112 479.64 112 464v-48h224v48c0 14.31 17.31 21.33 27.31 11.31l80-80a16 16 0 0 0 0-22.62z"
                }
            }
        ]
    })(props);
}
function FaThLarge(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M296 32h192c13.255 0 24 10.745 24 24v160c0 13.255-10.745 24-24 24H296c-13.255 0-24-10.745-24-24V56c0-13.255 10.745-24 24-24zm-80 0H24C10.745 32 0 42.745 0 56v160c0 13.255 10.745 24 24 24h192c13.255 0 24-10.745 24-24V56c0-13.255-10.745-24-24-24zM0 296v160c0 13.255 10.745 24 24 24h192c13.255 0 24-10.745 24-24V296c0-13.255-10.745-24-24-24H24c-13.255 0-24 10.745-24 24zm296 184h192c13.255 0 24-10.745 24-24V296c0-13.255-10.745-24-24-24H296c-13.255 0-24 10.745-24 24v160c0 13.255 10.745 24 24 24z"
                }
            }
        ]
    })(props);
}
function FaThList(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M149.333 216v80c0 13.255-10.745 24-24 24H24c-13.255 0-24-10.745-24-24v-80c0-13.255 10.745-24 24-24h101.333c13.255 0 24 10.745 24 24zM0 376v80c0 13.255 10.745 24 24 24h101.333c13.255 0 24-10.745 24-24v-80c0-13.255-10.745-24-24-24H24c-13.255 0-24 10.745-24 24zM125.333 32H24C10.745 32 0 42.745 0 56v80c0 13.255 10.745 24 24 24h101.333c13.255 0 24-10.745 24-24V56c0-13.255-10.745-24-24-24zm80 448H488c13.255 0 24-10.745 24-24v-80c0-13.255-10.745-24-24-24H205.333c-13.255 0-24 10.745-24 24v80c0 13.255 10.745 24 24 24zm-24-424v80c0 13.255 10.745 24 24 24H488c13.255 0 24-10.745 24-24V56c0-13.255-10.745-24-24-24H205.333c-13.255 0-24 10.745-24 24zm24 264H488c13.255 0 24-10.745 24-24v-80c0-13.255-10.745-24-24-24H205.333c-13.255 0-24 10.745-24 24v80c0 13.255 10.745 24 24 24z"
                }
            }
        ]
    })(props);
}
function FaTh(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M149.333 56v80c0 13.255-10.745 24-24 24H24c-13.255 0-24-10.745-24-24V56c0-13.255 10.745-24 24-24h101.333c13.255 0 24 10.745 24 24zm181.334 240v-80c0-13.255-10.745-24-24-24H205.333c-13.255 0-24 10.745-24 24v80c0 13.255 10.745 24 24 24h101.333c13.256 0 24.001-10.745 24.001-24zm32-240v80c0 13.255 10.745 24 24 24H488c13.255 0 24-10.745 24-24V56c0-13.255-10.745-24-24-24H386.667c-13.255 0-24 10.745-24 24zm-32 80V56c0-13.255-10.745-24-24-24H205.333c-13.255 0-24 10.745-24 24v80c0 13.255 10.745 24 24 24h101.333c13.256 0 24.001-10.745 24.001-24zm-205.334 56H24c-13.255 0-24 10.745-24 24v80c0 13.255 10.745 24 24 24h101.333c13.255 0 24-10.745 24-24v-80c0-13.255-10.745-24-24-24zM0 376v80c0 13.255 10.745 24 24 24h101.333c13.255 0 24-10.745 24-24v-80c0-13.255-10.745-24-24-24H24c-13.255 0-24 10.745-24 24zm386.667-56H488c13.255 0 24-10.745 24-24v-80c0-13.255-10.745-24-24-24H386.667c-13.255 0-24 10.745-24 24v80c0 13.255 10.745 24 24 24zm0 160H488c13.255 0 24-10.745 24-24v-80c0-13.255-10.745-24-24-24H386.667c-13.255 0-24 10.745-24 24v80c0 13.255 10.745 24 24 24zM181.333 376v80c0 13.255 10.745 24 24 24h101.333c13.255 0 24-10.745 24-24v-80c0-13.255-10.745-24-24-24H205.333c-13.255 0-24 10.745-24 24z"
                }
            }
        ]
    })(props);
}
function FaTheaterMasks(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M206.86 245.15c-35.88 10.45-59.95 41.2-57.53 74.1 11.4-12.72 28.81-23.7 49.9-30.92l7.63-43.18zM95.81 295L64.08 115.49c-.29-1.62.28-2.62.24-2.65 57.76-32.06 123.12-49.01 189.01-49.01 1.61 0 3.23.17 4.85.19 13.95-13.47 31.73-22.83 51.59-26 18.89-3.02 38.05-4.55 57.18-5.32-9.99-13.95-24.48-24.23-41.77-27C301.27 1.89 277.24 0 253.32 0 176.66 0 101.02 19.42 33.2 57.06 9.03 70.48-3.92 98.48 1.05 126.58l31.73 179.51c14.23 80.52 136.33 142.08 204.45 142.08 3.59 0 6.75-.46 10.01-.8-13.52-17.08-28.94-40.48-39.5-67.58-47.61-12.98-106.06-51.62-111.93-84.79zm97.55-137.46c-.73-4.12-2.23-7.87-4.07-11.4-8.25 8.91-20.67 15.75-35.32 18.32-14.65 2.58-28.67.4-39.48-5.17-.52 3.94-.64 7.98.09 12.1 3.84 21.7 24.58 36.19 46.34 32.37 21.75-3.82 36.28-24.52 32.44-46.22zM606.8 120.9c-88.98-49.38-191.43-67.41-291.98-51.35-27.31 4.36-49.08 26.26-54.04 54.36l-31.73 179.51c-15.39 87.05 95.28 196.27 158.31 207.35 63.03 11.09 204.47-53.79 219.86-140.84l31.73-179.51c4.97-28.11-7.98-56.11-32.15-69.52zm-273.24 96.8c3.84-21.7 24.58-36.19 46.34-32.36 21.76 3.83 36.28 24.52 32.45 46.22-.73 4.12-2.23 7.87-4.07 11.4-8.25-8.91-20.67-15.75-35.32-18.32-14.65-2.58-28.67-.4-39.48 5.17-.53-3.95-.65-7.99.08-12.11zm70.47 198.76c-55.68-9.79-93.52-59.27-89.04-112.9 20.6 25.54 56.21 46.17 99.49 53.78 43.28 7.61 83.82.37 111.93-16.6-14.18 51.94-66.71 85.51-122.38 75.72zm130.3-151.34c-8.25-8.91-20.68-15.75-35.33-18.32-14.65-2.58-28.67-.4-39.48 5.17-.52-3.94-.64-7.98.09-12.1 3.84-21.7 24.58-36.19 46.34-32.37 21.75 3.83 36.28 24.52 32.45 46.22-.73 4.13-2.23 7.88-4.07 11.4z"
                }
            }
        ]
    })(props);
}
function FaThermometerEmpty(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 256 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M192 384c0 35.346-28.654 64-64 64s-64-28.654-64-64c0-35.346 28.654-64 64-64s64 28.654 64 64zm32-84.653c19.912 22.563 32 52.194 32 84.653 0 70.696-57.303 128-128 128-.299 0-.609-.001-.909-.003C56.789 511.509-.357 453.636.002 383.333.166 351.135 12.225 321.755 32 299.347V96c0-53.019 42.981-96 96-96s96 42.981 96 96v203.347zM208 384c0-34.339-19.37-52.19-32-66.502V96c0-26.467-21.533-48-48-48S80 69.533 80 96v221.498c-12.732 14.428-31.825 32.1-31.999 66.08-.224 43.876 35.563 80.116 79.423 80.42L128 464c44.112 0 80-35.888 80-80z"
                }
            }
        ]
    })(props);
}
function FaThermometerFull(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 256 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M224 96c0-53.019-42.981-96-96-96S32 42.981 32 96v203.347C12.225 321.756.166 351.136.002 383.333c-.359 70.303 56.787 128.176 127.089 128.664.299.002.61.003.909.003 70.698 0 128-57.304 128-128 0-32.459-12.088-62.09-32-84.653V96zm-96 368l-.576-.002c-43.86-.304-79.647-36.544-79.423-80.42.173-33.98 19.266-51.652 31.999-66.08V96c0-26.467 21.533-48 48-48s48 21.533 48 48v221.498c12.63 14.312 32 32.164 32 66.502 0 44.112-35.888 80-80 80zm64-80c0 35.346-28.654 64-64 64s-64-28.654-64-64c0-23.685 12.876-44.349 32-55.417V96c0-17.673 14.327-32 32-32s32 14.327 32 32v232.583c19.124 11.068 32 31.732 32 55.417z"
                }
            }
        ]
    })(props);
}
function FaThermometerHalf(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 256 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M192 384c0 35.346-28.654 64-64 64s-64-28.654-64-64c0-23.685 12.876-44.349 32-55.417V224c0-17.673 14.327-32 32-32s32 14.327 32 32v104.583c19.124 11.068 32 31.732 32 55.417zm32-84.653c19.912 22.563 32 52.194 32 84.653 0 70.696-57.303 128-128 128-.299 0-.609-.001-.909-.003C56.789 511.509-.357 453.636.002 383.333.166 351.135 12.225 321.755 32 299.347V96c0-53.019 42.981-96 96-96s96 42.981 96 96v203.347zM208 384c0-34.339-19.37-52.19-32-66.502V96c0-26.467-21.533-48-48-48S80 69.533 80 96v221.498c-12.732 14.428-31.825 32.1-31.999 66.08-.224 43.876 35.563 80.116 79.423 80.42L128 464c44.112 0 80-35.888 80-80z"
                }
            }
        ]
    })(props);
}
function FaThermometerQuarter(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 256 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M192 384c0 35.346-28.654 64-64 64s-64-28.654-64-64c0-23.685 12.876-44.349 32-55.417V288c0-17.673 14.327-32 32-32s32 14.327 32 32v40.583c19.124 11.068 32 31.732 32 55.417zm32-84.653c19.912 22.563 32 52.194 32 84.653 0 70.696-57.303 128-128 128-.299 0-.609-.001-.909-.003C56.789 511.509-.357 453.636.002 383.333.166 351.135 12.225 321.755 32 299.347V96c0-53.019 42.981-96 96-96s96 42.981 96 96v203.347zM208 384c0-34.339-19.37-52.19-32-66.502V96c0-26.467-21.533-48-48-48S80 69.533 80 96v221.498c-12.732 14.428-31.825 32.1-31.999 66.08-.224 43.876 35.563 80.116 79.423 80.42L128 464c44.112 0 80-35.888 80-80z"
                }
            }
        ]
    })(props);
}
function FaThermometerThreeQuarters(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 256 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M192 384c0 35.346-28.654 64-64 64-35.346 0-64-28.654-64-64 0-23.685 12.876-44.349 32-55.417V160c0-17.673 14.327-32 32-32s32 14.327 32 32v168.583c19.124 11.068 32 31.732 32 55.417zm32-84.653c19.912 22.563 32 52.194 32 84.653 0 70.696-57.303 128-128 128-.299 0-.609-.001-.909-.003C56.789 511.509-.357 453.636.002 383.333.166 351.135 12.225 321.755 32 299.347V96c0-53.019 42.981-96 96-96s96 42.981 96 96v203.347zM208 384c0-34.339-19.37-52.19-32-66.502V96c0-26.467-21.533-48-48-48S80 69.533 80 96v221.498c-12.732 14.428-31.825 32.1-31.999 66.08-.224 43.876 35.563 80.116 79.423 80.42L128 464c44.112 0 80-35.888 80-80z"
                }
            }
        ]
    })(props);
}
function FaThermometer(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M476.8 20.4c-37.5-30.7-95.5-26.3-131.9 10.2l-45.7 46 50.5 50.5c3.1 3.1 3.1 8.2 0 11.3l-11.3 11.3c-3.1 3.1-8.2 3.1-11.3 0l-50.4-50.5-45.1 45.4 50.3 50.4c3.1 3.1 3.1 8.2 0 11.3l-11.3 11.3c-3.1 3.1-8.2 3.1-11.3 0L209 167.4l-45.1 45.4L214 263c3.1 3.1 3.1 8.2 0 11.3l-11.3 11.3c-3.1 3.1-8.2 3.1-11.3 0l-50.1-50.2L96 281.1V382L7 471c-9.4 9.4-9.4 24.6 0 33.9 9.4 9.4 24.6 9.4 33.9 0l89-89h99.9L484 162.6c34.9-34.9 42.2-101.5-7.2-142.2z"
                }
            }
        ]
    })(props);
}
function FaThumbsDown(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 56v240c0 13.255 10.745 24 24 24h80c13.255 0 24-10.745 24-24V56c0-13.255-10.745-24-24-24H24C10.745 32 0 42.745 0 56zm40 200c0-13.255 10.745-24 24-24s24 10.745 24 24-10.745 24-24 24-24-10.745-24-24zm272 256c-20.183 0-29.485-39.293-33.931-57.795-5.206-21.666-10.589-44.07-25.393-58.902-32.469-32.524-49.503-73.967-89.117-113.111a11.98 11.98 0 0 1-3.558-8.521V59.901c0-6.541 5.243-11.878 11.783-11.998 15.831-.29 36.694-9.079 52.651-16.178C256.189 17.598 295.709.017 343.995 0h2.844c42.777 0 93.363.413 113.774 29.737 8.392 12.057 10.446 27.034 6.148 44.632 16.312 17.053 25.063 48.863 16.382 74.757 17.544 23.432 19.143 56.132 9.308 79.469l.11.11c11.893 11.949 19.523 31.259 19.439 49.197-.156 30.352-26.157 58.098-59.553 58.098H350.723C358.03 364.34 384 388.132 384 430.548 384 504 336 512 312 512z"
                }
            }
        ]
    })(props);
}
function FaThumbsUp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M104 224H24c-13.255 0-24 10.745-24 24v240c0 13.255 10.745 24 24 24h80c13.255 0 24-10.745 24-24V248c0-13.255-10.745-24-24-24zM64 472c-13.255 0-24-10.745-24-24s10.745-24 24-24 24 10.745 24 24-10.745 24-24 24zM384 81.452c0 42.416-25.97 66.208-33.277 94.548h101.723c33.397 0 59.397 27.746 59.553 58.098.084 17.938-7.546 37.249-19.439 49.197l-.11.11c9.836 23.337 8.237 56.037-9.308 79.469 8.681 25.895-.069 57.704-16.382 74.757 4.298 17.598 2.244 32.575-6.148 44.632C440.202 511.587 389.616 512 346.839 512l-2.845-.001c-48.287-.017-87.806-17.598-119.56-31.725-15.957-7.099-36.821-15.887-52.651-16.178-6.54-.12-11.783-5.457-11.783-11.998v-213.77c0-3.2 1.282-6.271 3.558-8.521 39.614-39.144 56.648-80.587 89.117-113.111 14.804-14.832 20.188-37.236 25.393-58.902C282.515 39.293 291.817 0 312 0c24 0 72 8 72 81.452z"
                }
            }
        ]
    })(props);
}
function FaThumbtack(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M298.028 214.267L285.793 96H328c13.255 0 24-10.745 24-24V24c0-13.255-10.745-24-24-24H56C42.745 0 32 10.745 32 24v48c0 13.255 10.745 24 24 24h42.207L85.972 214.267C37.465 236.82 0 277.261 0 328c0 13.255 10.745 24 24 24h136v104.007c0 1.242.289 2.467.845 3.578l24 48c2.941 5.882 11.364 5.893 14.311 0l24-48a8.008 8.008 0 0 0 .845-3.578V352h136c13.255 0 24-10.745 24-24-.001-51.183-37.983-91.42-85.973-113.733z"
                }
            }
        ]
    })(props);
}
function FaTicketAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M128 160h320v192H128V160zm400 96c0 26.51 21.49 48 48 48v96c0 26.51-21.49 48-48 48H48c-26.51 0-48-21.49-48-48v-96c26.51 0 48-21.49 48-48s-21.49-48-48-48v-96c0-26.51 21.49-48 48-48h480c26.51 0 48 21.49 48 48v96c-26.51 0-48 21.49-48 48zm-48-104c0-13.255-10.745-24-24-24H120c-13.255 0-24 10.745-24 24v208c0 13.255 10.745 24 24 24h336c13.255 0 24-10.745 24-24V152z"
                }
            }
        ]
    })(props);
}
function FaTimesCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm121.6 313.1c4.7 4.7 4.7 12.3 0 17L338 377.6c-4.7 4.7-12.3 4.7-17 0L256 312l-65.1 65.6c-4.7 4.7-12.3 4.7-17 0L134.4 338c-4.7-4.7-4.7-12.3 0-17l65.6-65-65.6-65.1c-4.7-4.7-4.7-12.3 0-17l39.6-39.6c4.7-4.7 12.3-4.7 17 0l65 65.7 65.1-65.6c4.7-4.7 12.3-4.7 17 0l39.6 39.6c4.7 4.7 4.7 12.3 0 17L312 256l65.6 65.1z"
                }
            }
        ]
    })(props);
}
function FaTimes(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 352 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M242.72 256l100.07-100.07c12.28-12.28 12.28-32.19 0-44.48l-22.24-22.24c-12.28-12.28-32.19-12.28-44.48 0L176 189.28 75.93 89.21c-12.28-12.28-32.19-12.28-44.48 0L9.21 111.45c-12.28 12.28-12.28 32.19 0 44.48L109.28 256 9.21 356.07c-12.28 12.28-12.28 32.19 0 44.48l22.24 22.24c12.28 12.28 32.2 12.28 44.48 0L176 322.72l100.07 100.07c12.28 12.28 32.2 12.28 44.48 0l22.24-22.24c12.28-12.28 12.28-32.19 0-44.48L242.72 256z"
                }
            }
        ]
    })(props);
}
function FaTintSlash(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M633.82 458.1L494.97 350.78c.52-5.57 1.03-11.16 1.03-16.87 0-111.76-99.79-153.34-146.78-311.82-7.94-28.78-49.44-30.12-58.44 0-15.52 52.34-36.87 91.96-58.49 125.68L45.47 3.37C38.49-2.05 28.43-.8 23.01 6.18L3.37 31.45C-2.05 38.42-.8 48.47 6.18 53.9l588.36 454.73c6.98 5.43 17.03 4.17 22.46-2.81l19.64-25.27c5.41-6.97 4.16-17.02-2.82-22.45zM144 333.91C144 432.35 222.72 512 320 512c44.71 0 85.37-16.96 116.4-44.7L162.72 255.78c-11.41 23.5-18.72 48.35-18.72 78.13z"
                }
            }
        ]
    })(props);
}
function FaTint(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 352 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M205.22 22.09c-7.94-28.78-49.44-30.12-58.44 0C100.01 179.85 0 222.72 0 333.91 0 432.35 78.72 512 176 512s176-79.65 176-178.09c0-111.75-99.79-153.34-146.78-311.82zM176 448c-61.75 0-112-50.25-112-112 0-8.84 7.16-16 16-16s16 7.16 16 16c0 44.11 35.89 80 80 80 8.84 0 16 7.16 16 16s-7.16 16-16 16z"
                }
            }
        ]
    })(props);
}
function FaTired(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm33.8 189.7l80-48c11.6-6.9 24 7.7 15.4 18L343.6 208l33.6 40.3c8.7 10.4-3.9 24.8-15.4 18l-80-48c-7.7-4.7-7.7-15.9 0-20.6zm-163-30c-8.6-10.3 3.8-24.9 15.4-18l80 48c7.8 4.7 7.8 15.9 0 20.6l-80 48c-11.5 6.8-24-7.6-15.4-18l33.6-40.3-33.6-40.3zM248 288c51.9 0 115.3 43.8 123.2 106.7 1.7 13.6-8 24.6-17.7 20.4-25.9-11.1-64.4-17.4-105.5-17.4s-79.6 6.3-105.5 17.4c-9.8 4.2-19.4-7-17.7-20.4C132.7 331.8 196.1 288 248 288z"
                }
            }
        ]
    })(props);
}
function FaToggleOff(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M384 64H192C85.961 64 0 149.961 0 256s85.961 192 192 192h192c106.039 0 192-85.961 192-192S490.039 64 384 64zM64 256c0-70.741 57.249-128 128-128 70.741 0 128 57.249 128 128 0 70.741-57.249 128-128 128-70.741 0-128-57.249-128-128zm320 128h-48.905c65.217-72.858 65.236-183.12 0-256H384c70.741 0 128 57.249 128 128 0 70.74-57.249 128-128 128z"
                }
            }
        ]
    })(props);
}
function FaToggleOn(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M384 64H192C86 64 0 150 0 256s86 192 192 192h192c106 0 192-86 192-192S490 64 384 64zm0 320c-70.8 0-128-57.3-128-128 0-70.8 57.3-128 128-128 70.8 0 128 57.3 128 128 0 70.8-57.3 128-128 128z"
                }
            }
        ]
    })(props);
}
function FaToiletPaperSlash(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M64,192V364.13c0,41.12-9.75,62.75-31.12,126.87A16,16,0,0,0,48,512H328.86a31.87,31.87,0,0,0,30.38-21.87c9.31-27.83,18-53.35,22.18-85.55l-316-244.25C64.53,170.66,64,181.19,64,192ZM633.82,458.09l-102-78.81C575.28,360.91,608,284.32,608,192,608,86,565,0,512,0s-96,86-96,192c0,42,7,80.4,18.43,112L384,265V192c0-83.62,23.63-153.5,60.5-192H160c-23.33,0-44.63,16.83-61.26,44.53L45.46,3.38A16,16,0,0,0,23,6.19L3.37,31.45A16,16,0,0,0,6.18,53.91L594.54,508.63A16,16,0,0,0,617,505.81l19.64-25.26A16,16,0,0,0,633.82,458.09ZM512,256c-17.63,0-32-28.62-32-64s14.37-64,32-64,32,28.63,32,64S529.62,256,512,256Z"
                }
            }
        ]
    })(props);
}
function FaToiletPaper(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M128 0C74.98 0 32 85.96 32 192v172.07c0 41.12-9.8 62.77-31.17 126.87C-2.62 501.3 5.09 512 16.01 512h280.92c13.77 0 26-8.81 30.36-21.88 12.83-38.48 24.71-72.4 24.71-126.05V192c0-83.6 23.67-153.52 60.44-192H128zM96 224c-8.84 0-16-7.16-16-16s7.16-16 16-16 16 7.16 16 16-7.16 16-16 16zm64 0c-8.84 0-16-7.16-16-16s7.16-16 16-16 16 7.16 16 16-7.16 16-16 16zm64 0c-8.84 0-16-7.16-16-16s7.16-16 16-16 16 7.16 16 16-7.16 16-16 16zm64 0c-8.84 0-16-7.16-16-16s7.16-16 16-16 16 7.16 16 16-7.16 16-16 16zM480 0c-53.02 0-96 85.96-96 192s42.98 192 96 192 96-85.96 96-192S533.02 0 480 0zm0 256c-17.67 0-32-28.65-32-64s14.33-64 32-64 32 28.65 32 64-14.33 64-32 64z"
                }
            }
        ]
    })(props);
}
function FaToilet(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M368 48c8.8 0 16-7.2 16-16V16c0-8.8-7.2-16-16-16H16C7.2 0 0 7.2 0 16v16c0 8.8 7.2 16 16 16h16v156.7C11.8 214.8 0 226.9 0 240c0 67.2 34.6 126.2 86.8 160.5l-21.4 70.2C59.1 491.2 74.5 512 96 512h192c21.5 0 36.9-20.8 30.6-41.3l-21.4-70.2C349.4 366.2 384 307.2 384 240c0-13.1-11.8-25.2-32-35.3V48h16zM80 72c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8H88c-4.4 0-8-3.6-8-8V72zm112 200c-77.1 0-139.6-14.3-139.6-32s62.5-32 139.6-32 139.6 14.3 139.6 32-62.5 32-139.6 32z"
                }
            }
        ]
    })(props);
}
function FaToolbox(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M502.63 214.63l-45.25-45.25c-6-6-14.14-9.37-22.63-9.37H384V80c0-26.51-21.49-48-48-48H176c-26.51 0-48 21.49-48 48v80H77.25c-8.49 0-16.62 3.37-22.63 9.37L9.37 214.63c-6 6-9.37 14.14-9.37 22.63V320h128v-16c0-8.84 7.16-16 16-16h32c8.84 0 16 7.16 16 16v16h128v-16c0-8.84 7.16-16 16-16h32c8.84 0 16 7.16 16 16v16h128v-82.75c0-8.48-3.37-16.62-9.37-22.62zM320 160H192V96h128v64zm64 208c0 8.84-7.16 16-16 16h-32c-8.84 0-16-7.16-16-16v-16H192v16c0 8.84-7.16 16-16 16h-32c-8.84 0-16-7.16-16-16v-16H0v96c0 17.67 14.33 32 32 32h448c17.67 0 32-14.33 32-32v-96H384v16z"
                }
            }
        ]
    })(props);
}
function FaTools(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M501.1 395.7L384 278.6c-23.1-23.1-57.6-27.6-85.4-13.9L192 158.1V96L64 0 0 64l96 128h62.1l106.6 106.6c-13.6 27.8-9.2 62.3 13.9 85.4l117.1 117.1c14.6 14.6 38.2 14.6 52.7 0l52.7-52.7c14.5-14.6 14.5-38.2 0-52.7zM331.7 225c28.3 0 54.9 11 74.9 31l19.4 19.4c15.8-6.9 30.8-16.5 43.8-29.5 37.1-37.1 49.7-89.3 37.9-136.7-2.2-9-13.5-12.1-20.1-5.5l-74.4 74.4-67.9-11.3L334 98.9l74.4-74.4c6.6-6.6 3.4-17.9-5.7-20.2-47.4-11.7-99.6.9-136.6 37.9-28.5 28.5-41.9 66.1-41.2 103.6l82.1 82.1c8.1-1.9 16.5-2.9 24.7-2.9zm-103.9 82l-56.7-56.7L18.7 402.8c-25 25-25 65.5 0 90.5s65.5 25 90.5 0l123.6-123.6c-7.6-19.9-9.9-41.6-5-62.7zM64 472c-13.2 0-24-10.8-24-24 0-13.3 10.7-24 24-24s24 10.7 24 24c0 13.2-10.7 24-24 24z"
                }
            }
        ]
    })(props);
}
function FaTooth(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M443.98 96.25c-11.01-45.22-47.11-82.06-92.01-93.72-32.19-8.36-63 5.1-89.14 24.33-3.25 2.39-6.96 3.73-10.5 5.48l28.32 18.21c7.42 4.77 9.58 14.67 4.8 22.11-4.46 6.95-14.27 9.86-22.11 4.8L162.83 12.84c-20.7-10.85-43.38-16.4-66.81-10.31-44.9 11.67-81 48.5-92.01 93.72-10.13 41.62-.42 80.81 21.5 110.43 23.36 31.57 32.68 68.66 36.29 107.35 4.4 47.16 10.33 94.16 20.94 140.32l7.8 33.95c3.19 13.87 15.49 23.7 29.67 23.7 13.97 0 26.15-9.55 29.54-23.16l34.47-138.42c4.56-18.32 20.96-31.16 39.76-31.16s35.2 12.85 39.76 31.16l34.47 138.42c3.39 13.61 15.57 23.16 29.54 23.16 14.18 0 26.48-9.83 29.67-23.7l7.8-33.95c10.61-46.15 16.53-93.16 20.94-140.32 3.61-38.7 12.93-75.78 36.29-107.35 21.95-29.61 31.66-68.8 21.53-110.43z"
                }
            }
        ]
    })(props);
}
function FaTorah(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M320.05 366.48l17.72-29.64h-35.46zm99.21-166H382.4l18.46 30.82zM48 0C21.49 0 0 14.33 0 32v448c0 17.67 21.49 32 48 32s48-14.33 48-32V32C96 14.33 74.51 0 48 0zm172.74 311.5h36.85l-18.46-30.82zm161.71 0h36.86l-18.45-30.8zM128 464h384V48H128zm66.77-278.13a21.22 21.22 0 0 1 18.48-10.71h59.45l29.13-48.71a21.13 21.13 0 0 1 18.22-10.37A20.76 20.76 0 0 1 338 126.29l29.25 48.86h59.52a21.12 21.12 0 0 1 18.1 32L415.63 256 445 305a20.69 20.69 0 0 1 .24 21.12 21.25 21.25 0 0 1-18.48 10.72h-59.47l-29.13 48.7a21.13 21.13 0 0 1-18.16 10.4 20.79 20.79 0 0 1-18-10.22l-29.25-48.88h-59.5a21.11 21.11 0 0 1-18.1-32L224.36 256 195 207a20.7 20.7 0 0 1-.23-21.13zM592 0c-26.51 0-48 14.33-48 32v448c0 17.67 21.49 32 48 32s48-14.33 48-32V32c0-17.67-21.49-32-48-32zM320 145.53l-17.78 29.62h35.46zm-62.45 55h-36.81l18.44 30.8zm29.58 111h65.79L386.09 256l-33.23-55.52h-65.79L253.9 256z"
                }
            }
        ]
    })(props);
}
function FaToriiGate(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M376.45 32h-240.9A303.17 303.17 0 0 1 0 0v96c0 17.67 14.33 32 32 32h32v64H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h48v240c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16V256h256v240c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16V256h48c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16h-48v-64h32c17.67 0 32-14.33 32-32V0a303.17 303.17 0 0 1-135.55 32zM128 128h96v64h-96v-64zm256 64h-96v-64h96v64z"
                }
            }
        ]
    })(props);
}
function FaTractor(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M528 336c-48.6 0-88 39.4-88 88s39.4 88 88 88 88-39.4 88-88-39.4-88-88-88zm0 112c-13.23 0-24-10.77-24-24s10.77-24 24-24 24 10.77 24 24-10.77 24-24 24zm80-288h-64v-40.2c0-14.12 4.7-27.76 13.15-38.84 4.42-5.8 3.55-14.06-1.32-19.49L534.2 37.3c-6.66-7.45-18.32-6.92-24.7.78C490.58 60.9 480 89.81 480 119.8V160H377.67L321.58 29.14A47.914 47.914 0 0 0 277.45 0H144c-26.47 0-48 21.53-48 48v146.52c-8.63-6.73-20.96-6.46-28.89 1.47L36 227.1c-8.59 8.59-8.59 22.52 0 31.11l5.06 5.06c-4.99 9.26-8.96 18.82-11.91 28.72H22c-12.15 0-22 9.85-22 22v44c0 12.15 9.85 22 22 22h7.14c2.96 9.91 6.92 19.46 11.91 28.73l-5.06 5.06c-8.59 8.59-8.59 22.52 0 31.11L67.1 476c8.59 8.59 22.52 8.59 31.11 0l5.06-5.06c9.26 4.99 18.82 8.96 28.72 11.91V490c0 12.15 9.85 22 22 22h44c12.15 0 22-9.85 22-22v-7.14c9.9-2.95 19.46-6.92 28.72-11.91l5.06 5.06c8.59 8.59 22.52 8.59 31.11 0l31.11-31.11c8.59-8.59 8.59-22.52 0-31.11l-5.06-5.06c4.99-9.26 8.96-18.82 11.91-28.72H330c12.15 0 22-9.85 22-22v-6h80.54c21.91-28.99 56.32-48 95.46-48 18.64 0 36.07 4.61 51.8 12.2l50.82-50.82c6-6 9.37-14.14 9.37-22.63V192c.01-17.67-14.32-32-31.99-32zM176 416c-44.18 0-80-35.82-80-80s35.82-80 80-80 80 35.82 80 80-35.82 80-80 80zm22-256h-38V64h106.89l41.15 96H198z"
                }
            }
        ]
    })(props);
}
function FaTrademark(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M260.6 96H12c-6.6 0-12 5.4-12 12v43.1c0 6.6 5.4 12 12 12h85.1V404c0 6.6 5.4 12 12 12h54.3c6.6 0 12-5.4 12-12V163.1h85.1c6.6 0 12-5.4 12-12V108c.1-6.6-5.3-12-11.9-12zM640 403l-24-296c-.5-6.2-5.7-11-12-11h-65.4c-5.1 0-9.7 3.3-11.3 8.1l-43.8 127.1c-7.2 20.6-16.1 52.8-16.1 52.8h-.9s-8.9-32.2-16.1-52.8l-43.8-127.1c-1.7-4.8-6.2-8.1-11.3-8.1h-65.4c-6.2 0-11.4 4.8-12 11l-24.4 296c-.6 7 4.9 13 12 13H360c6.3 0 11.5-4.9 12-11.2l9.1-132.9c1.8-24.2 0-53.7 0-53.7h.9s10.7 33.6 17.9 53.7l30.7 84.7c1.7 4.7 6.2 7.9 11.3 7.9h50.3c5.1 0 9.6-3.2 11.3-7.9l30.7-84.7c7.2-20.1 17.9-53.7 17.9-53.7h.9s-1.8 29.5 0 53.7l9.1 132.9c.4 6.3 5.7 11.2 12 11.2H628c7 0 12.5-6 12-13z"
                }
            }
        ]
    })(props);
}
function FaTrafficLight(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M384 192h-64v-37.88c37.2-13.22 64-48.38 64-90.12h-64V32c0-17.67-14.33-32-32-32H96C78.33 0 64 14.33 64 32v32H0c0 41.74 26.8 76.9 64 90.12V192H0c0 41.74 26.8 76.9 64 90.12V320H0c0 42.84 28.25 78.69 66.99 91.05C79.42 468.72 130.6 512 192 512s112.58-43.28 125.01-100.95C355.75 398.69 384 362.84 384 320h-64v-37.88c37.2-13.22 64-48.38 64-90.12zM192 416c-26.51 0-48-21.49-48-48s21.49-48 48-48 48 21.49 48 48-21.49 48-48 48zm0-128c-26.51 0-48-21.49-48-48s21.49-48 48-48 48 21.49 48 48-21.49 48-48 48zm0-128c-26.51 0-48-21.49-48-48s21.49-48 48-48 48 21.49 48 48-21.49 48-48 48z"
                }
            }
        ]
    })(props);
}
function FaTrailer(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M624,320H544V80a16,16,0,0,0-16-16H16A16,16,0,0,0,0,80V368a16,16,0,0,0,16,16H65.61c7.83-54.21,54-96,110.39-96s102.56,41.79,110.39,96H624a16,16,0,0,0,16-16V336A16,16,0,0,0,624,320ZM96,243.68a176.29,176.29,0,0,0-32,20.71V136a8,8,0,0,1,8-8H88a8,8,0,0,1,8,8Zm96-18.54c-5.31-.49-10.57-1.14-16-1.14s-10.69.65-16,1.14V136a8,8,0,0,1,8-8h16a8,8,0,0,1,8,8Zm96,39.25a176.29,176.29,0,0,0-32-20.71V136a8,8,0,0,1,8-8h16a8,8,0,0,1,8,8ZM384,320H352V136a8,8,0,0,1,8-8h16a8,8,0,0,1,8,8Zm96,0H448V136a8,8,0,0,1,8-8h16a8,8,0,0,1,8,8Zm-304,0a80,80,0,1,0,80,80A80,80,0,0,0,176,320Zm0,112a32,32,0,1,1,32-32A32,32,0,0,1,176,432Z"
                }
            }
        ]
    })(props);
}
function FaTrain(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M448 96v256c0 51.815-61.624 96-130.022 96l62.98 49.721C386.905 502.417 383.562 512 376 512H72c-7.578 0-10.892-9.594-4.957-14.279L130.022 448C61.82 448 0 403.954 0 352V96C0 42.981 64 0 128 0h192c65 0 128 42.981 128 96zm-48 136V120c0-13.255-10.745-24-24-24H72c-13.255 0-24 10.745-24 24v112c0 13.255 10.745 24 24 24h304c13.255 0 24-10.745 24-24zm-176 64c-30.928 0-56 25.072-56 56s25.072 56 56 56 56-25.072 56-56-25.072-56-56-56z"
                }
            }
        ]
    })(props);
}
function FaTram(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M288 64c17.7 0 32-14.3 32-32S305.7 0 288 0s-32 14.3-32 32 14.3 32 32 32zm223.5-12.1c-2.3-8.6-11-13.6-19.6-11.3l-480 128c-8.5 2.3-13.6 11-11.3 19.6C2.5 195.3 8.9 200 16 200c1.4 0 2.8-.2 4.1-.5L240 140.8V224H64c-17.7 0-32 14.3-32 32v224c0 17.7 14.3 32 32 32h384c17.7 0 32-14.3 32-32V256c0-17.7-14.3-32-32-32H272v-91.7l228.1-60.8c8.6-2.3 13.6-11.1 11.4-19.6zM176 384H80v-96h96v96zm160-96h96v96h-96v-96zm-32 0v96h-96v-96h96zM192 96c17.7 0 32-14.3 32-32s-14.3-32-32-32-32 14.3-32 32 14.3 32 32 32z"
                }
            }
        ]
    })(props);
}
function FaTransgenderAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 480 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M468 0h-79c-10.7 0-16 12.9-8.5 20.5l16.9 16.9-80.7 80.7C294.5 104.1 268.2 96 240 96c-28.2 0-54.5 8.1-76.7 22.1l-16.5-16.5 19.8-19.8c4.7-4.7 4.7-12.3 0-17l-28.3-28.3c-4.7-4.7-12.3-4.7-17 0l-19.8 19.8-19-19 16.9-16.9C107.1 12.9 101.7 0 91 0H12C5.4 0 0 5.4 0 12v79c0 10.7 12.9 16 20.5 8.5l16.9-16.9 19 19-19.8 19.8c-4.7 4.7-4.7 12.3 0 17l28.3 28.3c4.7 4.7 12.3 4.7 17 0l19.8-19.8 16.5 16.5C104.1 185.5 96 211.8 96 240c0 68.5 47.9 125.9 112 140.4V408h-36c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h36v28c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12v-28h36c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12h-36v-27.6c64.1-14.6 112-71.9 112-140.4 0-28.2-8.1-54.5-22.1-76.7l80.7-80.7 16.9 16.9c7.6 7.6 20.5 2.2 20.5-8.5V12c0-6.6-5.4-12-12-12zM240 320c-44.1 0-80-35.9-80-80s35.9-80 80-80 80 35.9 80 80-35.9 80-80 80z"
                }
            }
        ]
    })(props);
}
function FaTransgender(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M372 0h-79c-10.7 0-16 12.9-8.5 20.5l16.9 16.9-80.7 80.7C198.5 104.1 172.2 96 144 96 64.5 96 0 160.5 0 240c0 68.5 47.9 125.9 112 140.4V408H76c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h36v28c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12v-28h36c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12h-36v-27.6c64.1-14.6 112-71.9 112-140.4 0-28.2-8.1-54.5-22.1-76.7l80.7-80.7 16.9 16.9c7.6 7.6 20.5 2.2 20.5-8.5V12c0-6.6-5.4-12-12-12zM144 320c-44.1 0-80-35.9-80-80s35.9-80 80-80 80 35.9 80 80-35.9 80-80 80z"
                }
            }
        ]
    })(props);
}
function FaTrashAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M32 464a48 48 0 0 0 48 48h288a48 48 0 0 0 48-48V128H32zm272-256a16 16 0 0 1 32 0v224a16 16 0 0 1-32 0zm-96 0a16 16 0 0 1 32 0v224a16 16 0 0 1-32 0zm-96 0a16 16 0 0 1 32 0v224a16 16 0 0 1-32 0zM432 32H312l-9.4-18.7A24 24 0 0 0 281.1 0H166.8a23.72 23.72 0 0 0-21.4 13.3L136 32H16A16 16 0 0 0 0 48v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16z"
                }
            }
        ]
    })(props);
}
function FaTrashRestoreAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M32 464a48 48 0 0 0 48 48h288a48 48 0 0 0 48-48V128H32zm91.31-172.8l89.38-94.26a15.41 15.41 0 0 1 22.62 0l89.38 94.26c10.08 10.62 2.94 28.8-11.32 28.8H256v112a16 16 0 0 1-16 16h-32a16 16 0 0 1-16-16V320h-57.37c-14.26 0-21.4-18.18-11.32-28.8zM432 32H312l-9.4-18.7A24 24 0 0 0 281.1 0H166.8a23.72 23.72 0 0 0-21.4 13.3L136 32H16A16 16 0 0 0 0 48v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16z"
                }
            }
        ]
    })(props);
}
function FaTrashRestore(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M53.2 467a48 48 0 0 0 47.9 45h245.8a48 48 0 0 0 47.9-45L416 128H32zm70.11-175.8l89.38-94.26a15.41 15.41 0 0 1 22.62 0l89.38 94.26c10.08 10.62 2.94 28.8-11.32 28.8H256v112a16 16 0 0 1-16 16h-32a16 16 0 0 1-16-16V320h-57.37c-14.26 0-21.4-18.18-11.32-28.8zM432 32H312l-9.4-18.7A24 24 0 0 0 281.1 0H166.8a23.72 23.72 0 0 0-21.4 13.3L136 32H16A16 16 0 0 0 0 48v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16z"
                }
            }
        ]
    })(props);
}
function FaTrash(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M432 32H312l-9.4-18.7A24 24 0 0 0 281.1 0H166.8a23.72 23.72 0 0 0-21.4 13.3L136 32H16A16 16 0 0 0 0 48v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16zM53.2 467a48 48 0 0 0 47.9 45h245.8a48 48 0 0 0 47.9-45L416 128H32z"
                }
            }
        ]
    })(props);
}
function FaTree(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M378.31 378.49L298.42 288h30.63c9.01 0 16.98-5 20.78-13.06 3.8-8.04 2.55-17.26-3.28-24.05L268.42 160h28.89c9.1 0 17.3-5.35 20.86-13.61 3.52-8.13 1.86-17.59-4.24-24.08L203.66 4.83c-6.03-6.45-17.28-6.45-23.32 0L70.06 122.31c-6.1 6.49-7.75 15.95-4.24 24.08C69.38 154.65 77.59 160 86.69 160h28.89l-78.14 90.91c-5.81 6.78-7.06 15.99-3.27 24.04C37.97 283 45.93 288 54.95 288h30.63L5.69 378.49c-6 6.79-7.36 16.09-3.56 24.26 3.75 8.05 12 13.25 21.01 13.25H160v24.45l-30.29 48.4c-5.32 10.64 2.42 23.16 14.31 23.16h95.96c11.89 0 19.63-12.52 14.31-23.16L224 440.45V416h136.86c9.01 0 17.26-5.2 21.01-13.25 3.8-8.17 2.44-17.47-3.56-24.26z"
                }
            }
        ]
    })(props);
}
function FaTrophy(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M552 64H448V24c0-13.3-10.7-24-24-24H152c-13.3 0-24 10.7-24 24v40H24C10.7 64 0 74.7 0 88v56c0 35.7 22.5 72.4 61.9 100.7 31.5 22.7 69.8 37.1 110 41.7C203.3 338.5 240 360 240 360v72h-48c-35.3 0-64 20.7-64 56v12c0 6.6 5.4 12 12 12h296c6.6 0 12-5.4 12-12v-12c0-35.3-28.7-56-64-56h-48v-72s36.7-21.5 68.1-73.6c40.3-4.6 78.6-19 110-41.7 39.3-28.3 61.9-65 61.9-100.7V88c0-13.3-10.7-24-24-24zM99.3 192.8C74.9 175.2 64 155.6 64 144v-16h64.2c1 32.6 5.8 61.2 12.8 86.2-15.1-5.2-29.2-12.4-41.7-21.4zM512 144c0 16.1-17.7 36.1-35.3 48.8-12.5 9-26.7 16.2-41.8 21.4 7-25 11.8-53.6 12.8-86.2H512v16z"
                }
            }
        ]
    })(props);
}
function FaTruckLoading(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M50.2 375.6c2.3 8.5 11.1 13.6 19.6 11.3l216.4-58c8.5-2.3 13.6-11.1 11.3-19.6l-49.7-185.5c-2.3-8.5-11.1-13.6-19.6-11.3L151 133.3l24.8 92.7-61.8 16.5-24.8-92.7-77.3 20.7C3.4 172.8-1.7 181.6.6 190.1l49.6 185.5zM384 0c-17.7 0-32 14.3-32 32v323.6L5.9 450c-4.3 1.2-6.8 5.6-5.6 9.8l12.6 46.3c1.2 4.3 5.6 6.8 9.8 5.6l393.7-107.4C418.8 464.1 467.6 512 528 512c61.9 0 112-50.1 112-112V0H384zm144 448c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48z"
                }
            }
        ]
    })(props);
}
function FaTruckMonster(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M624 224h-16v-64c0-17.67-14.33-32-32-32h-73.6L419.22 24.02A64.025 64.025 0 0 0 369.24 0H256c-17.67 0-32 14.33-32 32v96H48c-8.84 0-16 7.16-16 16v80H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h16.72c29.21-38.65 75.1-64 127.28-64s98.07 25.35 127.28 64h65.45c29.21-38.65 75.1-64 127.28-64s98.07 25.35 127.28 64H624c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16zm-336-96V64h81.24l51.2 64H288zm304 224h-5.2c-2.2-7.33-5.07-14.28-8.65-20.89l3.67-3.67c6.25-6.25 6.25-16.38 0-22.63l-22.63-22.63c-6.25-6.25-16.38-6.25-22.63 0l-3.67 3.67A110.85 110.85 0 0 0 512 277.2V272c0-8.84-7.16-16-16-16h-32c-8.84 0-16 7.16-16 16v5.2c-7.33 2.2-14.28 5.07-20.89 8.65l-3.67-3.67c-6.25-6.25-16.38-6.25-22.63 0l-22.63 22.63c-6.25 6.25-6.25 16.38 0 22.63l3.67 3.67A110.85 110.85 0 0 0 373.2 352H368c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h5.2c2.2 7.33 5.07 14.28 8.65 20.89l-3.67 3.67c-6.25 6.25-6.25 16.38 0 22.63l22.63 22.63c6.25 6.25 16.38 6.25 22.63 0l3.67-3.67c6.61 3.57 13.57 6.45 20.9 8.65v5.2c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16v-5.2c7.33-2.2 14.28-5.07 20.9-8.65l3.67 3.67c6.25 6.25 16.38 6.25 22.63 0l22.63-22.63c6.25-6.25 6.25-16.38 0-22.63l-3.67-3.67a110.85 110.85 0 0 0 8.65-20.89h5.2c8.84 0 16-7.16 16-16v-32c-.02-8.84-7.18-16-16.02-16zm-112 80c-26.51 0-48-21.49-48-48s21.49-48 48-48 48 21.49 48 48-21.49 48-48 48zm-208-80h-5.2c-2.2-7.33-5.07-14.28-8.65-20.89l3.67-3.67c6.25-6.25 6.25-16.38 0-22.63l-22.63-22.63c-6.25-6.25-16.38-6.25-22.63 0l-3.67 3.67A110.85 110.85 0 0 0 192 277.2V272c0-8.84-7.16-16-16-16h-32c-8.84 0-16 7.16-16 16v5.2c-7.33 2.2-14.28 5.07-20.89 8.65l-3.67-3.67c-6.25-6.25-16.38-6.25-22.63 0L58.18 304.8c-6.25 6.25-6.25 16.38 0 22.63l3.67 3.67a110.85 110.85 0 0 0-8.65 20.89H48c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h5.2c2.2 7.33 5.07 14.28 8.65 20.89l-3.67 3.67c-6.25 6.25-6.25 16.38 0 22.63l22.63 22.63c6.25 6.25 16.38 6.25 22.63 0l3.67-3.67c6.61 3.57 13.57 6.45 20.9 8.65v5.2c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16v-5.2c7.33-2.2 14.28-5.07 20.9-8.65l3.67 3.67c6.25 6.25 16.38 6.25 22.63 0l22.63-22.63c6.25-6.25 6.25-16.38 0-22.63l-3.67-3.67a110.85 110.85 0 0 0 8.65-20.89h5.2c8.84 0 16-7.16 16-16v-32C288 359.16 280.84 352 272 352zm-112 80c-26.51 0-48-21.49-48-48s21.49-48 48-48 48 21.49 48 48-21.49 48-48 48z"
                }
            }
        ]
    })(props);
}
function FaTruckMoving(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M621.3 237.3l-58.5-58.5c-12-12-28.3-18.7-45.3-18.7H480V64c0-17.7-14.3-32-32-32H32C14.3 32 0 46.3 0 64v336c0 44.2 35.8 80 80 80 26.3 0 49.4-12.9 64-32.4 14.6 19.6 37.7 32.4 64 32.4 44.2 0 80-35.8 80-80 0-5.5-.6-10.8-1.6-16h163.2c-1.1 5.2-1.6 10.5-1.6 16 0 44.2 35.8 80 80 80s80-35.8 80-80c0-5.5-.6-10.8-1.6-16H624c8.8 0 16-7.2 16-16v-85.5c0-17-6.7-33.2-18.7-45.2zM80 432c-17.6 0-32-14.4-32-32s14.4-32 32-32 32 14.4 32 32-14.4 32-32 32zm128 0c-17.6 0-32-14.4-32-32s14.4-32 32-32 32 14.4 32 32-14.4 32-32 32zm272-224h37.5c4.3 0 8.3 1.7 11.3 4.7l43.3 43.3H480v-48zm48 224c-17.6 0-32-14.4-32-32s14.4-32 32-32 32 14.4 32 32-14.4 32-32 32z"
                }
            }
        ]
    })(props);
}
function FaTruckPickup(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M624 288h-16v-64c0-17.67-14.33-32-32-32h-48L419.22 56.02A64.025 64.025 0 0 0 369.24 32H256c-17.67 0-32 14.33-32 32v128H64c-17.67 0-32 14.33-32 32v64H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h49.61c-.76 5.27-1.61 10.52-1.61 16 0 61.86 50.14 112 112 112s112-50.14 112-112c0-5.48-.85-10.73-1.61-16h67.23c-.76 5.27-1.61 10.52-1.61 16 0 61.86 50.14 112 112 112s112-50.14 112-112c0-5.48-.85-10.73-1.61-16H624c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16zM288 96h81.24l76.8 96H288V96zM176 416c-26.47 0-48-21.53-48-48s21.53-48 48-48 48 21.53 48 48-21.53 48-48 48zm288 0c-26.47 0-48-21.53-48-48s21.53-48 48-48 48 21.53 48 48-21.53 48-48 48z"
                }
            }
        ]
    })(props);
}
function FaTruck(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M624 352h-16V243.9c0-12.7-5.1-24.9-14.1-33.9L494 110.1c-9-9-21.2-14.1-33.9-14.1H416V48c0-26.5-21.5-48-48-48H48C21.5 0 0 21.5 0 48v320c0 26.5 21.5 48 48 48h16c0 53 43 96 96 96s96-43 96-96h128c0 53 43 96 96 96s96-43 96-96h48c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zM160 464c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48zm320 0c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48zm80-208H416V144h44.1l99.9 99.9V256z"
                }
            }
        ]
    })(props);
}
function FaTshirt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M631.2 96.5L436.5 0C416.4 27.8 371.9 47.2 320 47.2S223.6 27.8 203.5 0L8.8 96.5c-7.9 4-11.1 13.6-7.2 21.5l57.2 114.5c4 7.9 13.6 11.1 21.5 7.2l56.6-27.7c10.6-5.2 23 2.5 23 14.4V480c0 17.7 14.3 32 32 32h256c17.7 0 32-14.3 32-32V226.3c0-11.8 12.4-19.6 23-14.4l56.6 27.7c7.9 4 17.5.8 21.5-7.2L638.3 118c4-7.9.8-17.6-7.1-21.5z"
                }
            }
        ]
    })(props);
}
function FaTty(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5.37 103.822c138.532-138.532 362.936-138.326 501.262 0 6.078 6.078 7.074 15.496 2.583 22.681l-43.214 69.138a18.332 18.332 0 0 1-22.356 7.305l-86.422-34.569a18.335 18.335 0 0 1-11.434-18.846L351.741 90c-62.145-22.454-130.636-21.986-191.483 0l5.953 59.532a18.331 18.331 0 0 1-11.434 18.846l-86.423 34.568a18.334 18.334 0 0 1-22.356-7.305L2.787 126.502a18.333 18.333 0 0 1 2.583-22.68zM96 308v-40c0-6.627-5.373-12-12-12H44c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm-336 96v-40c0-6.627-5.373-12-12-12H92c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zM96 500v-40c0-6.627-5.373-12-12-12H44c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm288 0v-40c0-6.627-5.373-12-12-12H140c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h232c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12z"
                }
            }
        ]
    })(props);
}
function FaTv(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M592 0H48A48 48 0 0 0 0 48v320a48 48 0 0 0 48 48h240v32H112a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16H352v-32h240a48 48 0 0 0 48-48V48a48 48 0 0 0-48-48zm-16 352H64V64h512z"
                }
            }
        ]
    })(props);
}
function FaUmbrellaBeach(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M115.38 136.9l102.11 37.18c35.19-81.54 86.21-144.29 139-173.7-95.88-4.89-188.78 36.96-248.53 111.8-6.69 8.4-2.66 21.05 7.42 24.72zm132.25 48.16l238.48 86.83c35.76-121.38 18.7-231.66-42.63-253.98-7.4-2.7-15.13-4-23.09-4-58.02.01-128.27 69.17-172.76 171.15zM521.48 60.5c6.22 16.3 10.83 34.6 13.2 55.19 5.74 49.89-1.42 108.23-18.95 166.98l102.62 37.36c10.09 3.67 21.31-3.43 21.57-14.17 2.32-95.69-41.91-187.44-118.44-245.36zM560 447.98H321.06L386 269.5l-60.14-21.9-72.9 200.37H16c-8.84 0-16 7.16-16 16.01v32.01C0 504.83 7.16 512 16 512h544c8.84 0 16-7.17 16-16.01v-32.01c0-8.84-7.16-16-16-16z"
                }
            }
        ]
    })(props);
}
function FaUmbrella(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M575.7 280.8C547.1 144.5 437.3 62.6 320 49.9V32c0-17.7-14.3-32-32-32s-32 14.3-32 32v17.9C138.3 62.6 29.5 144.5.3 280.8c-2.2 10.1 8.5 21.3 18.7 11.4 52-55 107.7-52.4 158.6 37 5.3 9.5 14.9 8.6 19.7 0 20.2-35.4 44.9-73.2 90.7-73.2 58.5 0 88.2 68.8 90.7 73.2 4.8 8.6 14.4 9.5 19.7 0 51-89.5 107.1-91.4 158.6-37 10.3 10 20.9-1.3 18.7-11.4zM256 301.7V432c0 8.8-7.2 16-16 16-7.8 0-13.2-5.3-15.1-10.7-5.9-16.7-24.1-25.4-40.8-19.5-16.7 5.9-25.4 24.2-19.5 40.8 11.2 31.9 41.6 53.3 75.4 53.3 44.1 0 80-35.9 80-80V301.6c-9.1-7.9-19.8-13.6-32-13.6-12.3.1-22.4 4.8-32 13.7z"
                }
            }
        ]
    })(props);
}
function FaUnderline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M32 64h32v160c0 88.22 71.78 160 160 160s160-71.78 160-160V64h32a16 16 0 0 0 16-16V16a16 16 0 0 0-16-16H272a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32v160a80 80 0 0 1-160 0V64h32a16 16 0 0 0 16-16V16a16 16 0 0 0-16-16H32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16zm400 384H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16z"
                }
            }
        ]
    })(props);
}
function FaUndoAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M255.545 8c-66.269.119-126.438 26.233-170.86 68.685L48.971 40.971C33.851 25.851 8 36.559 8 57.941V192c0 13.255 10.745 24 24 24h134.059c21.382 0 32.09-25.851 16.971-40.971l-41.75-41.75c30.864-28.899 70.801-44.907 113.23-45.273 92.398-.798 170.283 73.977 169.484 169.442C423.236 348.009 349.816 424 256 424c-41.127 0-79.997-14.678-110.63-41.556-4.743-4.161-11.906-3.908-16.368.553L89.34 422.659c-4.872 4.872-4.631 12.815.482 17.433C133.798 479.813 192.074 504 256 504c136.966 0 247.999-111.033 248-247.998C504.001 119.193 392.354 7.755 255.545 8z"
                }
            }
        ]
    })(props);
}
function FaUndo(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M212.333 224.333H12c-6.627 0-12-5.373-12-12V12C0 5.373 5.373 0 12 0h48c6.627 0 12 5.373 12 12v78.112C117.773 39.279 184.26 7.47 258.175 8.007c136.906.994 246.448 111.623 246.157 248.532C504.041 393.258 393.12 504 256.333 504c-64.089 0-122.496-24.313-166.51-64.215-5.099-4.622-5.334-12.554-.467-17.42l33.967-33.967c4.474-4.474 11.662-4.717 16.401-.525C170.76 415.336 211.58 432 256.333 432c97.268 0 176-78.716 176-176 0-97.267-78.716-176-176-176-58.496 0-110.28 28.476-142.274 72.333h98.274c6.627 0 12 5.373 12 12v48c0 6.627-5.373 12-12 12z"
                }
            }
        ]
    })(props);
}
function FaUniversalAccess(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 48c114.953 0 208 93.029 208 208 0 114.953-93.029 208-208 208-114.953 0-208-93.029-208-208 0-114.953 93.029-208 208-208m0-40C119.033 8 8 119.033 8 256s111.033 248 248 248 248-111.033 248-248S392.967 8 256 8zm0 56C149.961 64 64 149.961 64 256s85.961 192 192 192 192-85.961 192-192S362.039 64 256 64zm0 44c19.882 0 36 16.118 36 36s-16.118 36-36 36-36-16.118-36-36 16.118-36 36-36zm117.741 98.023c-28.712 6.779-55.511 12.748-82.14 15.807.851 101.023 12.306 123.052 25.037 155.621 3.617 9.26-.957 19.698-10.217 23.315-9.261 3.617-19.699-.957-23.316-10.217-8.705-22.308-17.086-40.636-22.261-78.549h-9.686c-5.167 37.851-13.534 56.208-22.262 78.549-3.615 9.255-14.05 13.836-23.315 10.217-9.26-3.617-13.834-14.056-10.217-23.315 12.713-32.541 24.185-54.541 25.037-155.621-26.629-3.058-53.428-9.027-82.141-15.807-8.6-2.031-13.926-10.648-11.895-19.249s10.647-13.926 19.249-11.895c96.686 22.829 124.283 22.783 220.775 0 8.599-2.03 17.218 3.294 19.249 11.895 2.029 8.601-3.297 17.219-11.897 19.249z"
                }
            }
        ]
    })(props);
}
function FaUniversity(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M496 128v16a8 8 0 0 1-8 8h-24v12c0 6.627-5.373 12-12 12H60c-6.627 0-12-5.373-12-12v-12H24a8 8 0 0 1-8-8v-16a8 8 0 0 1 4.941-7.392l232-88a7.996 7.996 0 0 1 6.118 0l232 88A8 8 0 0 1 496 128zm-24 304H40c-13.255 0-24 10.745-24 24v16a8 8 0 0 0 8 8h464a8 8 0 0 0 8-8v-16c0-13.255-10.745-24-24-24zM96 192v192H60c-6.627 0-12 5.373-12 12v20h416v-20c0-6.627-5.373-12-12-12h-36V192h-64v192h-64V192h-64v192h-64V192H96z"
                }
            }
        ]
    })(props);
}
function FaUnlink(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M304.083 405.907c4.686 4.686 4.686 12.284 0 16.971l-44.674 44.674c-59.263 59.262-155.693 59.266-214.961 0-59.264-59.265-59.264-155.696 0-214.96l44.675-44.675c4.686-4.686 12.284-4.686 16.971 0l39.598 39.598c4.686 4.686 4.686 12.284 0 16.971l-44.675 44.674c-28.072 28.073-28.072 73.75 0 101.823 28.072 28.072 73.75 28.073 101.824 0l44.674-44.674c4.686-4.686 12.284-4.686 16.971 0l39.597 39.598zm-56.568-260.216c4.686 4.686 12.284 4.686 16.971 0l44.674-44.674c28.072-28.075 73.75-28.073 101.824 0 28.072 28.073 28.072 73.75 0 101.823l-44.675 44.674c-4.686 4.686-4.686 12.284 0 16.971l39.598 39.598c4.686 4.686 12.284 4.686 16.971 0l44.675-44.675c59.265-59.265 59.265-155.695 0-214.96-59.266-59.264-155.695-59.264-214.961 0l-44.674 44.674c-4.686 4.686-4.686 12.284 0 16.971l39.597 39.598zm234.828 359.28l22.627-22.627c9.373-9.373 9.373-24.569 0-33.941L63.598 7.029c-9.373-9.373-24.569-9.373-33.941 0L7.029 29.657c-9.373 9.373-9.373 24.569 0 33.941l441.373 441.373c9.373 9.372 24.569 9.372 33.941 0z"
                }
            }
        ]
    })(props);
}
function FaUnlockAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M400 256H152V152.9c0-39.6 31.7-72.5 71.3-72.9 40-.4 72.7 32.1 72.7 72v16c0 13.3 10.7 24 24 24h32c13.3 0 24-10.7 24-24v-16C376 68 307.5-.3 223.5 0 139.5.3 72 69.5 72 153.5V256H48c-26.5 0-48 21.5-48 48v160c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V304c0-26.5-21.5-48-48-48zM264 408c0 22.1-17.9 40-40 40s-40-17.9-40-40v-48c0-22.1 17.9-40 40-40s40 17.9 40 40v48z"
                }
            }
        ]
    })(props);
}
function FaUnlock(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M400 256H152V152.9c0-39.6 31.7-72.5 71.3-72.9 40-.4 72.7 32.1 72.7 72v16c0 13.3 10.7 24 24 24h32c13.3 0 24-10.7 24-24v-16C376 68 307.5-.3 223.5 0 139.5.3 72 69.5 72 153.5V256H48c-26.5 0-48 21.5-48 48v160c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V304c0-26.5-21.5-48-48-48z"
                }
            }
        ]
    })(props);
}
function FaUpload(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M296 384h-80c-13.3 0-24-10.7-24-24V192h-87.7c-17.8 0-26.7-21.5-14.1-34.1L242.3 5.7c7.5-7.5 19.8-7.5 27.3 0l152.2 152.2c12.6 12.6 3.7 34.1-14.1 34.1H320v168c0 13.3-10.7 24-24 24zm216-8v112c0 13.3-10.7 24-24 24H24c-13.3 0-24-10.7-24-24V376c0-13.3 10.7-24 24-24h136v8c0 30.9 25.1 56 56 56h80c30.9 0 56-25.1 56-56v-8h136c13.3 0 24 10.7 24 24zm-124 88c0-11-9-20-20-20s-20 9-20 20 9 20 20 20 20-9 20-20zm64 0c0-11-9-20-20-20s-20 9-20 20 9 20 20 20 20-9 20-20z"
                }
            }
        ]
    })(props);
}
function FaUserAltSlash(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M633.8 458.1L389.6 269.3C433.8 244.7 464 198.1 464 144 464 64.5 399.5 0 320 0c-67.1 0-123 46.1-139 108.2L45.5 3.4C38.5-2 28.5-.8 23 6.2L3.4 31.4c-5.4 7-4.2 17 2.8 22.4l588.4 454.7c7 5.4 17 4.2 22.5-2.8l19.6-25.3c5.4-6.8 4.1-16.9-2.9-22.3zM198.4 320C124.2 320 64 380.2 64 454.4v9.6c0 26.5 21.5 48 48 48h382.2L245.8 320h-47.4z"
                }
            }
        ]
    })(props);
}
function FaUserAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 288c79.5 0 144-64.5 144-144S335.5 0 256 0 112 64.5 112 144s64.5 144 144 144zm128 32h-55.1c-22.2 10.2-46.9 16-72.9 16s-50.6-5.8-72.9-16H128C57.3 320 0 377.3 0 448v16c0 26.5 21.5 48 48 48h416c26.5 0 48-21.5 48-48v-16c0-70.7-57.3-128-128-128z"
                }
            }
        ]
    })(props);
}
function FaUserAstronaut(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M64 224h13.5c24.7 56.5 80.9 96 146.5 96s121.8-39.5 146.5-96H384c8.8 0 16-7.2 16-16v-96c0-8.8-7.2-16-16-16h-13.5C345.8 39.5 289.6 0 224 0S102.2 39.5 77.5 96H64c-8.8 0-16 7.2-16 16v96c0 8.8 7.2 16 16 16zm40-88c0-22.1 21.5-40 48-40h144c26.5 0 48 17.9 48 40v24c0 53-43 96-96 96h-48c-53 0-96-43-96-96v-24zm72 72l12-36 36-12-36-12-12-36-12 36-36 12 36 12 12 36zm151.6 113.4C297.7 340.7 262.2 352 224 352s-73.7-11.3-103.6-30.6C52.9 328.5 0 385 0 454.4v9.6c0 26.5 21.5 48 48 48h80v-64c0-17.7 14.3-32 32-32h128c17.7 0 32 14.3 32 32v64h80c26.5 0 48-21.5 48-48v-9.6c0-69.4-52.9-125.9-120.4-133zM272 448c-8.8 0-16 7.2-16 16s7.2 16 16 16 16-7.2 16-16-7.2-16-16-16zm-96 0c-8.8 0-16 7.2-16 16v48h32v-48c0-8.8-7.2-16-16-16z"
                }
            }
        ]
    })(props);
}
function FaUserCheck(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M224 256c70.7 0 128-57.3 128-128S294.7 0 224 0 96 57.3 96 128s57.3 128 128 128zm89.6 32h-16.7c-22.2 10.2-46.9 16-72.9 16s-50.6-5.8-72.9-16h-16.7C60.2 288 0 348.2 0 422.4V464c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48v-41.6c0-74.2-60.2-134.4-134.4-134.4zm323-128.4l-27.8-28.1c-4.6-4.7-12.1-4.7-16.8-.1l-104.8 104-45.5-45.8c-4.6-4.7-12.1-4.7-16.8-.1l-28.1 27.9c-4.7 4.6-4.7 12.1-.1 16.8l81.7 82.3c4.6 4.7 12.1 4.7 16.8.1l141.3-140.2c4.6-4.7 4.7-12.2.1-16.8z"
                }
            }
        ]
    })(props);
}
function FaUserCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 96c48.6 0 88 39.4 88 88s-39.4 88-88 88-88-39.4-88-88 39.4-88 88-88zm0 344c-58.7 0-111.3-26.6-146.5-68.2 18.8-35.4 55.6-59.8 98.5-59.8 2.4 0 4.8.4 7.1 1.1 13 4.2 26.6 6.9 40.9 6.9 14.3 0 28-2.7 40.9-6.9 2.3-.7 4.7-1.1 7.1-1.1 42.9 0 79.7 24.4 98.5 59.8C359.3 421.4 306.7 448 248 448z"
                }
            }
        ]
    })(props);
}
function FaUserClock(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M496 224c-79.6 0-144 64.4-144 144s64.4 144 144 144 144-64.4 144-144-64.4-144-144-144zm64 150.3c0 5.3-4.4 9.7-9.7 9.7h-60.6c-5.3 0-9.7-4.4-9.7-9.7v-76.6c0-5.3 4.4-9.7 9.7-9.7h12.6c5.3 0 9.7 4.4 9.7 9.7V352h38.3c5.3 0 9.7 4.4 9.7 9.7v12.6zM320 368c0-27.8 6.7-54.1 18.2-77.5-8-1.5-16.2-2.5-24.6-2.5h-16.7c-22.2 10.2-46.9 16-72.9 16s-50.6-5.8-72.9-16h-16.7C60.2 288 0 348.2 0 422.4V464c0 26.5 21.5 48 48 48h347.1c-45.3-31.9-75.1-84.5-75.1-144zm-96-112c70.7 0 128-57.3 128-128S294.7 0 224 0 96 57.3 96 128s57.3 128 128 128z"
                }
            }
        ]
    })(props);
}
function FaUserCog(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M610.5 373.3c2.6-14.1 2.6-28.5 0-42.6l25.8-14.9c3-1.7 4.3-5.2 3.3-8.5-6.7-21.6-18.2-41.2-33.2-57.4-2.3-2.5-6-3.1-9-1.4l-25.8 14.9c-10.9-9.3-23.4-16.5-36.9-21.3v-29.8c0-3.4-2.4-6.4-5.7-7.1-22.3-5-45-4.8-66.2 0-3.3.7-5.7 3.7-5.7 7.1v29.8c-13.5 4.8-26 12-36.9 21.3l-25.8-14.9c-2.9-1.7-6.7-1.1-9 1.4-15 16.2-26.5 35.8-33.2 57.4-1 3.3.4 6.8 3.3 8.5l25.8 14.9c-2.6 14.1-2.6 28.5 0 42.6l-25.8 14.9c-3 1.7-4.3 5.2-3.3 8.5 6.7 21.6 18.2 41.1 33.2 57.4 2.3 2.5 6 3.1 9 1.4l25.8-14.9c10.9 9.3 23.4 16.5 36.9 21.3v29.8c0 3.4 2.4 6.4 5.7 7.1 22.3 5 45 4.8 66.2 0 3.3-.7 5.7-3.7 5.7-7.1v-29.8c13.5-4.8 26-12 36.9-21.3l25.8 14.9c2.9 1.7 6.7 1.1 9-1.4 15-16.2 26.5-35.8 33.2-57.4 1-3.3-.4-6.8-3.3-8.5l-25.8-14.9zM496 400.5c-26.8 0-48.5-21.8-48.5-48.5s21.8-48.5 48.5-48.5 48.5 21.8 48.5 48.5-21.7 48.5-48.5 48.5zM224 256c70.7 0 128-57.3 128-128S294.7 0 224 0 96 57.3 96 128s57.3 128 128 128zm201.2 226.5c-2.3-1.2-4.6-2.6-6.8-3.9l-7.9 4.6c-6 3.4-12.8 5.3-19.6 5.3-10.9 0-21.4-4.6-28.9-12.6-18.3-19.8-32.3-43.9-40.2-69.6-5.5-17.7 1.9-36.4 17.9-45.7l7.9-4.6c-.1-2.6-.1-5.2 0-7.8l-7.9-4.6c-16-9.2-23.4-28-17.9-45.7.9-2.9 2.2-5.8 3.2-8.7-3.8-.3-7.5-1.2-11.4-1.2h-16.7c-22.2 10.2-46.9 16-72.9 16s-50.6-5.8-72.9-16h-16.7C60.2 288 0 348.2 0 422.4V464c0 26.5 21.5 48 48 48h352c10.1 0 19.5-3.2 27.2-8.5-1.2-3.8-2-7.7-2-11.8v-9.2z"
                }
            }
        ]
    })(props);
}
function FaUserEdit(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M224 256c70.7 0 128-57.3 128-128S294.7 0 224 0 96 57.3 96 128s57.3 128 128 128zm89.6 32h-16.7c-22.2 10.2-46.9 16-72.9 16s-50.6-5.8-72.9-16h-16.7C60.2 288 0 348.2 0 422.4V464c0 26.5 21.5 48 48 48h274.9c-2.4-6.8-3.4-14-2.6-21.3l6.8-60.9 1.2-11.1 7.9-7.9 77.3-77.3c-24.5-27.7-60-45.5-99.9-45.5zm45.3 145.3l-6.8 61c-1.1 10.2 7.5 18.8 17.6 17.6l60.9-6.8 137.9-137.9-71.7-71.7-137.9 137.8zM633 268.9L595.1 231c-9.3-9.3-24.5-9.3-33.8 0l-37.8 37.8-4.1 4.1 71.8 71.7 41.8-41.8c9.3-9.4 9.3-24.5 0-33.9z"
                }
            }
        ]
    })(props);
}
function FaUserFriends(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M192 256c61.9 0 112-50.1 112-112S253.9 32 192 32 80 82.1 80 144s50.1 112 112 112zm76.8 32h-8.3c-20.8 10-43.9 16-68.5 16s-47.6-6-68.5-16h-8.3C51.6 288 0 339.6 0 403.2V432c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48v-28.8c0-63.6-51.6-115.2-115.2-115.2zM480 256c53 0 96-43 96-96s-43-96-96-96-96 43-96 96 43 96 96 96zm48 32h-3.8c-13.9 4.8-28.6 8-44.2 8s-30.3-3.2-44.2-8H432c-20.4 0-39.2 5.9-55.7 15.4 24.4 26.3 39.7 61.2 39.7 99.8v38.4c0 2.2-.5 4.3-.6 6.4H592c26.5 0 48-21.5 48-48 0-61.9-50.1-112-112-112z"
                }
            }
        ]
    })(props);
}
function FaUserGraduate(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M319.4 320.6L224 416l-95.4-95.4C57.1 323.7 0 382.2 0 454.4v9.6c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48v-9.6c0-72.2-57.1-130.7-128.6-133.8zM13.6 79.8l6.4 1.5v58.4c-7 4.2-12 11.5-12 20.3 0 8.4 4.6 15.4 11.1 19.7L3.5 242c-1.7 6.9 2.1 14 7.6 14h41.8c5.5 0 9.3-7.1 7.6-14l-15.6-62.3C51.4 175.4 56 168.4 56 160c0-8.8-5-16.1-12-20.3V87.1l66 15.9c-8.6 17.2-14 36.4-14 57 0 70.7 57.3 128 128 128s128-57.3 128-128c0-20.6-5.3-39.8-14-57l96.3-23.2c18.2-4.4 18.2-27.1 0-31.5l-190.4-46c-13-3.1-26.7-3.1-39.7 0L13.6 48.2c-18.1 4.4-18.1 27.2 0 31.6z"
                }
            }
        ]
    })(props);
}
function FaUserInjured(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M277.37 11.98C261.08 4.47 243.11 0 224 0c-53.69 0-99.5 33.13-118.51 80h81.19l90.69-68.02zM342.51 80c-7.9-19.47-20.67-36.2-36.49-49.52L239.99 80h102.52zM224 256c70.69 0 128-57.31 128-128 0-5.48-.95-10.7-1.61-16H97.61c-.67 5.3-1.61 10.52-1.61 16 0 70.69 57.31 128 128 128zM80 299.7V512h128.26l-98.45-221.52A132.835 132.835 0 0 0 80 299.7zM0 464c0 26.51 21.49 48 48 48V320.24C18.88 344.89 0 381.26 0 422.4V464zm256-48h-55.38l42.67 96H256c26.47 0 48-21.53 48-48s-21.53-48-48-48zm57.6-128h-16.71c-22.24 10.18-46.88 16-72.89 16s-50.65-5.82-72.89-16h-7.37l42.67 96H256c44.11 0 80 35.89 80 80 0 18.08-6.26 34.59-16.41 48H400c26.51 0 48-21.49 48-48v-41.6c0-74.23-60.17-134.4-134.4-134.4z"
                }
            }
        ]
    })(props);
}
function FaUserLock(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M224 256A128 128 0 1 0 96 128a128 128 0 0 0 128 128zm96 64a63.08 63.08 0 0 1 8.1-30.5c-4.8-.5-9.5-1.5-14.5-1.5h-16.7a174.08 174.08 0 0 1-145.8 0h-16.7A134.43 134.43 0 0 0 0 422.4V464a48 48 0 0 0 48 48h280.9a63.54 63.54 0 0 1-8.9-32zm288-32h-32v-80a80 80 0 0 0-160 0v80h-32a32 32 0 0 0-32 32v160a32 32 0 0 0 32 32h224a32 32 0 0 0 32-32V320a32 32 0 0 0-32-32zM496 432a32 32 0 1 1 32-32 32 32 0 0 1-32 32zm32-144h-64v-80a32 32 0 0 1 64 0z"
                }
            }
        ]
    })(props);
}
function FaUserMd(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M224 256c70.7 0 128-57.3 128-128S294.7 0 224 0 96 57.3 96 128s57.3 128 128 128zM104 424c0 13.3 10.7 24 24 24s24-10.7 24-24-10.7-24-24-24-24 10.7-24 24zm216-135.4v49c36.5 7.4 64 39.8 64 78.4v41.7c0 7.6-5.4 14.2-12.9 15.7l-32.2 6.4c-4.3.9-8.5-1.9-9.4-6.3l-3.1-15.7c-.9-4.3 1.9-8.6 6.3-9.4l19.3-3.9V416c0-62.8-96-65.1-96 1.9v26.7l19.3 3.9c4.3.9 7.1 5.1 6.3 9.4l-3.1 15.7c-.9 4.3-5.1 7.1-9.4 6.3l-31.2-4.2c-7.9-1.1-13.8-7.8-13.8-15.9V416c0-38.6 27.5-70.9 64-78.4v-45.2c-2.2.7-4.4 1.1-6.6 1.9-18 6.3-37.3 9.8-57.4 9.8s-39.4-3.5-57.4-9.8c-7.4-2.6-14.9-4.2-22.6-5.2v81.6c23.1 6.9 40 28.1 40 53.4 0 30.9-25.1 56-56 56s-56-25.1-56-56c0-25.3 16.9-46.5 40-53.4v-80.4C48.5 301 0 355.8 0 422.4v44.8C0 491.9 20.1 512 44.8 512h358.4c24.7 0 44.8-20.1 44.8-44.8v-44.8c0-72-56.8-130.3-128-133.8z"
                }
            }
        ]
    })(props);
}
function FaUserMinus(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M624 208H432c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h192c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zm-400 48c70.7 0 128-57.3 128-128S294.7 0 224 0 96 57.3 96 128s57.3 128 128 128zm89.6 32h-16.7c-22.2 10.2-46.9 16-72.9 16s-50.6-5.8-72.9-16h-16.7C60.2 288 0 348.2 0 422.4V464c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48v-41.6c0-74.2-60.2-134.4-134.4-134.4z"
                }
            }
        ]
    })(props);
}
function FaUserNinja(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M325.4 289.2L224 390.6 122.6 289.2C54 295.3 0 352.2 0 422.4V464c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48v-41.6c0-70.2-54-127.1-122.6-133.2zM32 192c27.3 0 51.8-11.5 69.2-29.7 15.1 53.9 64 93.7 122.8 93.7 70.7 0 128-57.3 128-128S294.7 0 224 0c-50.4 0-93.6 29.4-114.5 71.8C92.1 47.8 64 32 32 32c0 33.4 17.1 62.8 43.1 80-26 17.2-43.1 46.6-43.1 80zm144-96h96c17.7 0 32 14.3 32 32H144c0-17.7 14.3-32 32-32z"
                }
            }
        ]
    })(props);
}
function FaUserNurse(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M319.41,320,224,415.39,128.59,320C57.1,323.1,0,381.6,0,453.79A58.21,58.21,0,0,0,58.21,512H389.79A58.21,58.21,0,0,0,448,453.79C448,381.6,390.9,323.1,319.41,320ZM224,304A128,128,0,0,0,352,176V65.82a32,32,0,0,0-20.76-30L246.47,4.07a64,64,0,0,0-44.94,0L116.76,35.86A32,32,0,0,0,96,65.82V176A128,128,0,0,0,224,304ZM184,71.67a5,5,0,0,1,5-5h21.67V45a5,5,0,0,1,5-5h16.66a5,5,0,0,1,5,5V66.67H259a5,5,0,0,1,5,5V88.33a5,5,0,0,1-5,5H237.33V115a5,5,0,0,1-5,5H215.67a5,5,0,0,1-5-5V93.33H189a5,5,0,0,1-5-5ZM144,160H304v16a80,80,0,0,1-160,0Z"
                }
            }
        ]
    })(props);
}
function FaUserPlus(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M624 208h-64v-64c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v64h-64c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h64v64c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-64h64c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zm-400 48c70.7 0 128-57.3 128-128S294.7 0 224 0 96 57.3 96 128s57.3 128 128 128zm89.6 32h-16.7c-22.2 10.2-46.9 16-72.9 16s-50.6-5.8-72.9-16h-16.7C60.2 288 0 348.2 0 422.4V464c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48v-41.6c0-74.2-60.2-134.4-134.4-134.4z"
                }
            }
        ]
    })(props);
}
function FaUserSecret(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M383.9 308.3l23.9-62.6c4-10.5-3.7-21.7-15-21.7h-58.5c11-18.9 17.8-40.6 17.8-64v-.3c39.2-7.8 64-19.1 64-31.7 0-13.3-27.3-25.1-70.1-33-9.2-32.8-27-65.8-40.6-82.8-9.5-11.9-25.9-15.6-39.5-8.8l-27.6 13.8c-9 4.5-19.6 4.5-28.6 0L182.1 3.4c-13.6-6.8-30-3.1-39.5 8.8-13.5 17-31.4 50-40.6 82.8-42.7 7.9-70 19.7-70 33 0 12.6 24.8 23.9 64 31.7v.3c0 23.4 6.8 45.1 17.8 64H56.3c-11.5 0-19.2 11.7-14.7 22.3l25.8 60.2C27.3 329.8 0 372.7 0 422.4v44.8C0 491.9 20.1 512 44.8 512h358.4c24.7 0 44.8-20.1 44.8-44.8v-44.8c0-48.4-25.8-90.4-64.1-114.1zM176 480l-41.6-192 49.6 32 24 40-32 120zm96 0l-32-120 24-40 49.6-32L272 480zm41.7-298.5c-3.9 11.9-7 24.6-16.5 33.4-10.1 9.3-48 22.4-64-25-2.8-8.4-15.4-8.4-18.3 0-17 50.2-56 32.4-64 25-9.5-8.8-12.7-21.5-16.5-33.4-.8-2.5-6.3-5.7-6.3-5.8v-10.8c28.3 3.6 61 5.8 96 5.8s67.7-2.1 96-5.8v10.8c-.1.1-5.6 3.2-6.4 5.8z"
                }
            }
        ]
    })(props);
}
function FaUserShield(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M622.3 271.1l-115.2-45c-4.1-1.6-12.6-3.7-22.2 0l-115.2 45c-10.7 4.2-17.7 14-17.7 24.9 0 111.6 68.7 188.8 132.9 213.9 9.6 3.7 18 1.6 22.2 0C558.4 489.9 640 420.5 640 296c0-10.9-7-20.7-17.7-24.9zM496 462.4V273.3l95.5 37.3c-5.6 87.1-60.9 135.4-95.5 151.8zM224 256c70.7 0 128-57.3 128-128S294.7 0 224 0 96 57.3 96 128s57.3 128 128 128zm96 40c0-2.5.8-4.8 1.1-7.2-2.5-.1-4.9-.8-7.5-.8h-16.7c-22.2 10.2-46.9 16-72.9 16s-50.6-5.8-72.9-16h-16.7C60.2 288 0 348.2 0 422.4V464c0 26.5 21.5 48 48 48h352c6.8 0 13.3-1.5 19.2-4-54-42.9-99.2-116.7-99.2-212z"
                }
            }
        ]
    })(props);
}
function FaUserSlash(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M633.8 458.1L362.3 248.3C412.1 230.7 448 183.8 448 128 448 57.3 390.7 0 320 0c-67.1 0-121.5 51.8-126.9 117.4L45.5 3.4C38.5-2 28.5-.8 23 6.2L3.4 31.4c-5.4 7-4.2 17 2.8 22.4l588.4 454.7c7 5.4 17 4.2 22.5-2.8l19.6-25.3c5.4-6.8 4.1-16.9-2.9-22.3zM96 422.4V464c0 26.5 21.5 48 48 48h350.2L207.4 290.3C144.2 301.3 96 356 96 422.4z"
                }
            }
        ]
    })(props);
}
function FaUserTag(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M630.6 364.9l-90.3-90.2c-12-12-28.3-18.7-45.3-18.7h-79.3c-17.7 0-32 14.3-32 32v79.2c0 17 6.7 33.2 18.7 45.2l90.3 90.2c12.5 12.5 32.8 12.5 45.3 0l92.5-92.5c12.6-12.5 12.6-32.7.1-45.2zm-182.8-21c-13.3 0-24-10.7-24-24s10.7-24 24-24 24 10.7 24 24c0 13.2-10.7 24-24 24zm-223.8-88c70.7 0 128-57.3 128-128C352 57.3 294.7 0 224 0S96 57.3 96 128c0 70.6 57.3 127.9 128 127.9zm127.8 111.2V294c-12.2-3.6-24.9-6.2-38.2-6.2h-16.7c-22.2 10.2-46.9 16-72.9 16s-50.6-5.8-72.9-16h-16.7C60.2 287.9 0 348.1 0 422.3v41.6c0 26.5 21.5 48 48 48h352c15.5 0 29.1-7.5 37.9-18.9l-58-58c-18.1-18.1-28.1-42.2-28.1-67.9z"
                }
            }
        ]
    })(props);
}
function FaUserTie(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M224 256c70.7 0 128-57.3 128-128S294.7 0 224 0 96 57.3 96 128s57.3 128 128 128zm95.8 32.6L272 480l-32-136 32-56h-96l32 56-32 136-47.8-191.4C56.9 292 0 350.3 0 422.4V464c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48v-41.6c0-72.1-56.9-130.4-128.2-133.8z"
                }
            }
        ]
    })(props);
}
function FaUserTimes(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M589.6 240l45.6-45.6c6.3-6.3 6.3-16.5 0-22.8l-22.8-22.8c-6.3-6.3-16.5-6.3-22.8 0L544 194.4l-45.6-45.6c-6.3-6.3-16.5-6.3-22.8 0l-22.8 22.8c-6.3 6.3-6.3 16.5 0 22.8l45.6 45.6-45.6 45.6c-6.3 6.3-6.3 16.5 0 22.8l22.8 22.8c6.3 6.3 16.5 6.3 22.8 0l45.6-45.6 45.6 45.6c6.3 6.3 16.5 6.3 22.8 0l22.8-22.8c6.3-6.3 6.3-16.5 0-22.8L589.6 240zM224 256c70.7 0 128-57.3 128-128S294.7 0 224 0 96 57.3 96 128s57.3 128 128 128zm89.6 32h-16.7c-22.2 10.2-46.9 16-72.9 16s-50.6-5.8-72.9-16h-16.7C60.2 288 0 348.2 0 422.4V464c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48v-41.6c0-74.2-60.2-134.4-134.4-134.4z"
                }
            }
        ]
    })(props);
}
function FaUser(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M224 256c70.7 0 128-57.3 128-128S294.7 0 224 0 96 57.3 96 128s57.3 128 128 128zm89.6 32h-16.7c-22.2 10.2-46.9 16-72.9 16s-50.6-5.8-72.9-16h-16.7C60.2 288 0 348.2 0 422.4V464c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48v-41.6c0-74.2-60.2-134.4-134.4-134.4z"
                }
            }
        ]
    })(props);
}
function FaUsersCog(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M610.5 341.3c2.6-14.1 2.6-28.5 0-42.6l25.8-14.9c3-1.7 4.3-5.2 3.3-8.5-6.7-21.6-18.2-41.2-33.2-57.4-2.3-2.5-6-3.1-9-1.4l-25.8 14.9c-10.9-9.3-23.4-16.5-36.9-21.3v-29.8c0-3.4-2.4-6.4-5.7-7.1-22.3-5-45-4.8-66.2 0-3.3.7-5.7 3.7-5.7 7.1v29.8c-13.5 4.8-26 12-36.9 21.3l-25.8-14.9c-2.9-1.7-6.7-1.1-9 1.4-15 16.2-26.5 35.8-33.2 57.4-1 3.3.4 6.8 3.3 8.5l25.8 14.9c-2.6 14.1-2.6 28.5 0 42.6l-25.8 14.9c-3 1.7-4.3 5.2-3.3 8.5 6.7 21.6 18.2 41.1 33.2 57.4 2.3 2.5 6 3.1 9 1.4l25.8-14.9c10.9 9.3 23.4 16.5 36.9 21.3v29.8c0 3.4 2.4 6.4 5.7 7.1 22.3 5 45 4.8 66.2 0 3.3-.7 5.7-3.7 5.7-7.1v-29.8c13.5-4.8 26-12 36.9-21.3l25.8 14.9c2.9 1.7 6.7 1.1 9-1.4 15-16.2 26.5-35.8 33.2-57.4 1-3.3-.4-6.8-3.3-8.5l-25.8-14.9zM496 368.5c-26.8 0-48.5-21.8-48.5-48.5s21.8-48.5 48.5-48.5 48.5 21.8 48.5 48.5-21.7 48.5-48.5 48.5zM96 224c35.3 0 64-28.7 64-64s-28.7-64-64-64-64 28.7-64 64 28.7 64 64 64zm224 32c1.9 0 3.7-.5 5.6-.6 8.3-21.7 20.5-42.1 36.3-59.2 7.4-8 17.9-12.6 28.9-12.6 6.9 0 13.7 1.8 19.6 5.3l7.9 4.6c.8-.5 1.6-.9 2.4-1.4 7-14.6 11.2-30.8 11.2-48 0-61.9-50.1-112-112-112S208 82.1 208 144c0 61.9 50.1 112 112 112zm105.2 194.5c-2.3-1.2-4.6-2.6-6.8-3.9-8.2 4.8-15.3 9.8-27.5 9.8-10.9 0-21.4-4.6-28.9-12.6-18.3-19.8-32.3-43.9-40.2-69.6-10.7-34.5 24.9-49.7 25.8-50.3-.1-2.6-.1-5.2 0-7.8l-7.9-4.6c-3.8-2.2-7-5-9.8-8.1-3.3.2-6.5.6-9.8.6-24.6 0-47.6-6-68.5-16h-8.3C179.6 288 128 339.6 128 403.2V432c0 26.5 21.5 48 48 48h255.4c-3.7-6-6.2-12.8-6.2-20.3v-9.2zM173.1 274.6C161.5 263.1 145.6 256 128 256H64c-35.3 0-64 28.7-64 64v32c0 17.7 14.3 32 32 32h65.9c6.3-47.4 34.9-87.3 75.2-109.4z"
                }
            }
        ]
    })(props);
}
function FaUsersSlash(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M132.65,212.32,36.21,137.78A63.4,63.4,0,0,0,32,160a63.84,63.84,0,0,0,100.65,52.32Zm40.44,62.28A63.79,63.79,0,0,0,128,256H64A64.06,64.06,0,0,0,0,320v32a32,32,0,0,0,32,32H97.91A146.62,146.62,0,0,1,173.09,274.6ZM544,224a64,64,0,1,0-64-64A64.06,64.06,0,0,0,544,224ZM500.56,355.11a114.24,114.24,0,0,0-84.47-65.28L361,247.23c41.46-16.3,71-55.92,71-103.23A111.93,111.93,0,0,0,320,32c-57.14,0-103.69,42.83-110.6,98.08L45.46,3.38A16,16,0,0,0,23,6.19L3.37,31.46A16,16,0,0,0,6.18,53.91L594.53,508.63A16,16,0,0,0,617,505.82l19.64-25.27a16,16,0,0,0-2.81-22.45ZM128,403.21V432a48,48,0,0,0,48,48H464a47.45,47.45,0,0,0,12.57-1.87L232,289.13C173.74,294.83,128,343.42,128,403.21ZM576,256H512a63.79,63.79,0,0,0-45.09,18.6A146.29,146.29,0,0,1,542,384h66a32,32,0,0,0,32-32V320A64.06,64.06,0,0,0,576,256Z"
                }
            }
        ]
    })(props);
}
function FaUsers(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M96 224c35.3 0 64-28.7 64-64s-28.7-64-64-64-64 28.7-64 64 28.7 64 64 64zm448 0c35.3 0 64-28.7 64-64s-28.7-64-64-64-64 28.7-64 64 28.7 64 64 64zm32 32h-64c-17.6 0-33.5 7.1-45.1 18.6 40.3 22.1 68.9 62 75.1 109.4h66c17.7 0 32-14.3 32-32v-32c0-35.3-28.7-64-64-64zm-256 0c61.9 0 112-50.1 112-112S381.9 32 320 32 208 82.1 208 144s50.1 112 112 112zm76.8 32h-8.3c-20.8 10-43.9 16-68.5 16s-47.6-6-68.5-16h-8.3C179.6 288 128 339.6 128 403.2V432c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48v-28.8c0-63.6-51.6-115.2-115.2-115.2zm-223.7-13.4C161.5 263.1 145.6 256 128 256H64c-35.3 0-64 28.7-64 64v32c0 17.7 14.3 32 32 32h65.9c6.3-47.4 34.9-87.3 75.2-109.4z"
                }
            }
        ]
    })(props);
}
function FaUtensilSpoon(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M480.1 31.9c-55-55.1-164.9-34.5-227.8 28.5-49.3 49.3-55.1 110-28.8 160.4L9 413.2c-11.6 10.5-12.1 28.5-1 39.5L59.3 504c11 11 29.1 10.5 39.5-1.1l192.4-214.4c50.4 26.3 111.1 20.5 160.4-28.8 63-62.9 83.6-172.8 28.5-227.8z"
                }
            }
        ]
    })(props);
}
function FaUtensils(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 416 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M207.9 15.2c.8 4.7 16.1 94.5 16.1 128.8 0 52.3-27.8 89.6-68.9 104.6L168 486.7c.7 13.7-10.2 25.3-24 25.3H80c-13.7 0-24.7-11.5-24-25.3l12.9-238.1C27.7 233.6 0 196.2 0 144 0 109.6 15.3 19.9 16.1 15.2 19.3-5.1 61.4-5.4 64 16.3v141.2c1.3 3.4 15.1 3.2 16 0 1.4-25.3 7.9-139.2 8-141.8 3.3-20.8 44.7-20.8 47.9 0 .2 2.7 6.6 116.5 8 141.8.9 3.2 14.8 3.4 16 0V16.3c2.6-21.6 44.8-21.4 48-1.1zm119.2 285.7l-15 185.1c-1.2 14 9.9 26 23.9 26h56c13.3 0 24-10.7 24-24V24c0-13.2-10.7-24-24-24-82.5 0-221.4 178.5-64.9 300.9z"
                }
            }
        ]
    })(props);
}
function FaVectorSquare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M512 128V32c0-17.67-14.33-32-32-32h-96c-17.67 0-32 14.33-32 32H160c0-17.67-14.33-32-32-32H32C14.33 0 0 14.33 0 32v96c0 17.67 14.33 32 32 32v192c-17.67 0-32 14.33-32 32v96c0 17.67 14.33 32 32 32h96c17.67 0 32-14.33 32-32h192c0 17.67 14.33 32 32 32h96c17.67 0 32-14.33 32-32v-96c0-17.67-14.33-32-32-32V160c17.67 0 32-14.33 32-32zm-96-64h32v32h-32V64zM64 64h32v32H64V64zm32 384H64v-32h32v32zm352 0h-32v-32h32v32zm-32-96h-32c-17.67 0-32 14.33-32 32v32H160v-32c0-17.67-14.33-32-32-32H96V160h32c17.67 0 32-14.33 32-32V96h192v32c0 17.67 14.33 32 32 32h32v192z"
                }
            }
        ]
    })(props);
}
function FaVenusDouble(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M288 176c0-79.5-64.5-144-144-144S0 96.5 0 176c0 68.5 47.9 125.9 112 140.4V368H76c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h36v36c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12v-36h36c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12h-36v-51.6c64.1-14.5 112-71.9 112-140.4zm-224 0c0-44.1 35.9-80 80-80s80 35.9 80 80-35.9 80-80 80-80-35.9-80-80zm336 140.4V368h36c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12h-36v36c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-36h-36c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h36v-51.6c-21.2-4.8-40.6-14.3-57.2-27.3 14-16.7 25-36 32.1-57.1 14.5 14.8 34.7 24 57.1 24 44.1 0 80-35.9 80-80s-35.9-80-80-80c-22.3 0-42.6 9.2-57.1 24-7.1-21.1-18-40.4-32.1-57.1C303.4 43.6 334.3 32 368 32c79.5 0 144 64.5 144 144 0 68.5-47.9 125.9-112 140.4z"
                }
            }
        ]
    })(props);
}
function FaVenusMars(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M564 0h-79c-10.7 0-16 12.9-8.5 20.5l16.9 16.9-48.7 48.7C422.5 72.1 396.2 64 368 64c-33.7 0-64.6 11.6-89.2 30.9 14 16.7 25 36 32.1 57.1 14.5-14.8 34.7-24 57.1-24 44.1 0 80 35.9 80 80s-35.9 80-80 80c-22.3 0-42.6-9.2-57.1-24-7.1 21.1-18 40.4-32.1 57.1 24.5 19.4 55.5 30.9 89.2 30.9 79.5 0 144-64.5 144-144 0-28.2-8.1-54.5-22.1-76.7l48.7-48.7 16.9 16.9c2.4 2.4 5.4 3.5 8.4 3.5 6.2 0 12.1-4.8 12.1-12V12c0-6.6-5.4-12-12-12zM144 64C64.5 64 0 128.5 0 208c0 68.5 47.9 125.9 112 140.4V400H76c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h36v36c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12v-36h36c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12h-36v-51.6c64.1-14.6 112-71.9 112-140.4 0-79.5-64.5-144-144-144zm0 224c-44.1 0-80-35.9-80-80s35.9-80 80-80 80 35.9 80 80-35.9 80-80 80z"
                }
            }
        ]
    })(props);
}
function FaVenus(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 288 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M288 176c0-79.5-64.5-144-144-144S0 96.5 0 176c0 68.5 47.9 125.9 112 140.4V368H76c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h36v36c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12v-36h36c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12h-36v-51.6c64.1-14.5 112-71.9 112-140.4zm-224 0c0-44.1 35.9-80 80-80s80 35.9 80 80-35.9 80-80 80-80-35.9-80-80z"
                }
            }
        ]
    })(props);
}
function FaVestPatches(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M437.252,239.877,384,160V32A32,32,0,0,0,352,0H320a23.982,23.982,0,0,0-13.312,4.031l-25,16.672a103.794,103.794,0,0,1-115.376,0l-25-16.672A23.982,23.982,0,0,0,128,0H96A32,32,0,0,0,64,32V160L10.748,239.877A64,64,0,0,0,0,275.377V480a32,32,0,0,0,32,32H192V288a31.987,31.987,0,0,1,1.643-10.119L207.135,237.4,150.188,66.561A151.579,151.579,0,0,0,224,86.234a151.565,151.565,0,0,0,73.811-19.668L224,288V512H416a32,32,0,0,0,32-32V275.377A64,64,0,0,0,437.252,239.877ZM63.5,272.484a12.01,12.01,0,0,1,17-16.968l15.5,15.5,15.5-15.5a12.01,12.01,0,0,1,17,16.968L112.984,288,128.5,303.516a12.01,12.01,0,0,1-17,16.968L96,304.984l-15.5,15.5a12.01,12.01,0,0,1-17-16.968L79.016,288ZM96,456a40,40,0,1,1,40-40A40,40,0,0,1,96,456ZM359.227,335.785,310.7,336a6.671,6.671,0,0,1-6.7-6.7l.215-48.574A24.987,24.987,0,0,1,331.43,256.1c12.789,1.162,22.129,12.619,22.056,25.419l-.037,5.057,5.051-.037c12.826-.035,24.236,9.275,25.4,22.076A24.948,24.948,0,0,1,359.227,335.785Z"
                }
            }
        ]
    })(props);
}
function FaVest(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M437.252,239.877,384,160V32A32,32,0,0,0,352,0H320a24.021,24.021,0,0,0-13.312,4.031l-25,16.672a103.794,103.794,0,0,1-115.376,0l-25-16.672A24.021,24.021,0,0,0,128,0H96A32,32,0,0,0,64,32V160L10.748,239.877A64,64,0,0,0,0,275.377V480a32,32,0,0,0,32,32H192V288a31.987,31.987,0,0,1,1.643-10.119L207.135,237.4,150.188,66.564A151.518,151.518,0,0,0,224,86.234a151.55,151.55,0,0,0,73.812-19.672L224,288V512H416a32,32,0,0,0,32-32V275.377A64,64,0,0,0,437.252,239.877ZM131.312,371.312l-48,48a16,16,0,0,1-22.624-22.624l48-48a16,16,0,0,1,22.624,22.624Zm256,48a15.992,15.992,0,0,1-22.624,0l-48-48a16,16,0,0,1,22.624-22.624l48,48A15.993,15.993,0,0,1,387.312,419.312Z"
                }
            }
        ]
    })(props);
}
function FaVial(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 480 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M477.7 186.1L309.5 18.3c-3.1-3.1-8.2-3.1-11.3 0l-34 33.9c-3.1 3.1-3.1 8.2 0 11.3l11.2 11.1L33 316.5c-38.8 38.7-45.1 102-9.4 143.5 20.6 24 49.5 36 78.4 35.9 26.4 0 52.8-10 72.9-30.1l246.3-245.7 11.2 11.1c3.1 3.1 8.2 3.1 11.3 0l34-33.9c3.1-3 3.1-8.1 0-11.2zM318 256H161l148-147.7 78.5 78.3L318 256z"
                }
            }
        ]
    })(props);
}
function FaVials(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M72 64h24v240c0 44.1 35.9 80 80 80s80-35.9 80-80V64h24c4.4 0 8-3.6 8-8V8c0-4.4-3.6-8-8-8H72c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8zm72 0h64v96h-64V64zm480 384H16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h608c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zM360 64h24v240c0 44.1 35.9 80 80 80s80-35.9 80-80V64h24c4.4 0 8-3.6 8-8V8c0-4.4-3.6-8-8-8H360c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8zm72 0h64v96h-64V64z"
                }
            }
        ]
    })(props);
}
function FaVideoSlash(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M633.8 458.1l-55-42.5c15.4-1.4 29.2-13.7 29.2-31.1v-257c0-25.5-29.1-40.4-50.4-25.8L448 177.3v137.2l-32-24.7v-178c0-26.4-21.4-47.8-47.8-47.8H123.9L45.5 3.4C38.5-2 28.5-.8 23 6.2L3.4 31.4c-5.4 7-4.2 17 2.8 22.4L42.7 82 416 370.6l178.5 138c7 5.4 17 4.2 22.5-2.8l19.6-25.3c5.5-6.9 4.2-17-2.8-22.4zM32 400.2c0 26.4 21.4 47.8 47.8 47.8h288.4c11.2 0 21.4-4 29.6-10.5L32 154.7v245.5z"
                }
            }
        ]
    })(props);
}
function FaVideo(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M336.2 64H47.8C21.4 64 0 85.4 0 111.8v288.4C0 426.6 21.4 448 47.8 448h288.4c26.4 0 47.8-21.4 47.8-47.8V111.8c0-26.4-21.4-47.8-47.8-47.8zm189.4 37.7L416 177.3v157.4l109.6 75.5c21.2 14.6 50.4-.3 50.4-25.8V127.5c0-25.4-29.1-40.4-50.4-25.8z"
                }
            }
        ]
    })(props);
}
function FaVihara(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M632.88 400.71L544 352v-64l55.16-17.69c11.79-5.9 11.79-22.72 0-28.62L480 192v-64l27.31-16.3c7.72-7.72 5.61-20.74-4.16-25.62L320 0 136.85 86.07c-9.77 4.88-11.88 17.9-4.16 25.62L160 128v64L40.84 241.69c-11.79 5.9-11.79 22.72 0 28.62L96 288v64L7.12 400.71c-5.42 3.62-7.7 9.63-7 15.29.62 5.01 3.57 9.75 8.72 12.33L64 448v48c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16v-48h160v48c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16v-48h160v48c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16v-48l55.15-19.67c5.16-2.58 8.1-7.32 8.72-12.33.71-5.67-1.57-11.68-6.99-15.29zM224 128h192v64H224v-64zm-64 224v-64h320v64H160z"
                }
            }
        ]
    })(props);
}
function FaVirusSlash(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M114,227.6H92.4C76.7,227.6,64,240.3,64,256s12.7,28.4,28.4,28.4H114c50.7,0,76.1,61.3,40.2,97.1L139,396.8 c-11.5,10.7-12.2,28.7-1.6,40.2s28.7,12.2,40.2,1.6c0.5-0.5,1.1-1,1.6-1.6l15.2-15.2c35.8-35.8,97.1-10.5,97.1,40.2v21.5 c0,15.7,12.8,28.4,28.5,28.4c15.7,0,28.4-12.7,28.4-28.4V462c0-26.6,17-45.9,38.2-53.4l-244.5-189 C133.7,224.7,123.9,227.5,114,227.6z M617,505.8l19.6-25.3c5.4-7,4.2-17-2.8-22.5L470.6,332c4.2-25.4,24.9-47.5,55.4-47.5h21.5 c15.7,0,28.4-12.7,28.4-28.4s-12.7-28.4-28.4-28.4H526c-50.7,0-76.1-61.3-40.2-97.1l15.2-15.3c10.7-11.5,10-29.5-1.6-40.2 c-10.9-10.1-27.7-10.1-38.6,0l-15.2,15.2c-35.8,35.8-97.1,10.5-97.1-40.2V28.5C348.4,12.7,335.7,0,320,0 c-15.7,0-28.4,12.7-28.4,28.4V50c0,50.7-61.3,76.1-97.1,40.2L179.2,75c-11.1-11.1-29.4-10.6-40.5,0.5L45.5,3.4 c-7-5.4-17-4.2-22.5,2.8L3.4,31.5c-5.4,7-4.2,17,2.8,22.5l588.4,454.7C601.5,514.1,611.6,512.8,617,505.8z M335.4,227.5l-62.9-48.6 c4.9-1.8,10.2-2.8,15.4-2.9c26.5,0,48,21.5,48,48C336,225.2,335.5,226.3,335.4,227.5z"
                }
            }
        ]
    })(props);
}
function FaVirus(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M483.55,227.55H462c-50.68,0-76.07-61.27-40.23-97.11L437,115.19A28.44,28.44,0,0,0,396.8,75L381.56,90.22c-35.84,35.83-97.11,10.45-97.11-40.23V28.44a28.45,28.45,0,0,0-56.9,0V50c0,50.68-61.27,76.06-97.11,40.23L115.2,75A28.44,28.44,0,0,0,75,115.19l15.25,15.25c35.84,35.84,10.45,97.11-40.23,97.11H28.45a28.45,28.45,0,1,0,0,56.89H50c50.68,0,76.07,61.28,40.23,97.12L75,396.8A28.45,28.45,0,0,0,115.2,437l15.24-15.25c35.84-35.84,97.11-10.45,97.11,40.23v21.54a28.45,28.45,0,0,0,56.9,0V462c0-50.68,61.27-76.07,97.11-40.23L396.8,437A28.45,28.45,0,0,0,437,396.8l-15.25-15.24c-35.84-35.84-10.45-97.12,40.23-97.12h21.54a28.45,28.45,0,1,0,0-56.89ZM224,272a48,48,0,1,1,48-48A48,48,0,0,1,224,272Zm80,56a24,24,0,1,1,24-24A24,24,0,0,1,304,328Z"
                }
            }
        ]
    })(props);
}
function FaViruses(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M624,352H611.88c-28.51,0-42.79-34.47-22.63-54.63l8.58-8.57a16,16,0,1,0-22.63-22.63l-8.57,8.58C546.47,294.91,512,280.63,512,252.12V240a16,16,0,0,0-32,0v12.12c0,28.51-34.47,42.79-54.63,22.63l-8.57-8.58a16,16,0,0,0-22.63,22.63l8.58,8.57c20.16,20.16,5.88,54.63-22.63,54.63H368a16,16,0,0,0,0,32h12.12c28.51,0,42.79,34.47,22.63,54.63l-8.58,8.57a16,16,0,1,0,22.63,22.63l8.57-8.58c20.16-20.16,54.63-5.88,54.63,22.63V496a16,16,0,0,0,32,0V483.88c0-28.51,34.47-42.79,54.63-22.63l8.57,8.58a16,16,0,1,0,22.63-22.63l-8.58-8.57C569.09,418.47,583.37,384,611.88,384H624a16,16,0,0,0,0-32ZM480,384a32,32,0,1,1,32-32A32,32,0,0,1,480,384ZM346.51,213.33h16.16a21.33,21.33,0,0,0,0-42.66H346.51c-38,0-57.05-46-30.17-72.84l11.43-11.44A21.33,21.33,0,0,0,297.6,56.23L286.17,67.66c-26.88,26.88-72.84,7.85-72.84-30.17V21.33a21.33,21.33,0,0,0-42.66,0V37.49c0,38-46,57.05-72.84,30.17L86.4,56.23A21.33,21.33,0,0,0,56.23,86.39L67.66,97.83c26.88,26.88,7.85,72.84-30.17,72.84H21.33a21.33,21.33,0,0,0,0,42.66H37.49c38,0,57.05,46,30.17,72.84L56.23,297.6A21.33,21.33,0,1,0,86.4,327.77l11.43-11.43c26.88-26.88,72.84-7.85,72.84,30.17v16.16a21.33,21.33,0,0,0,42.66,0V346.51c0-38,46-57.05,72.84-30.17l11.43,11.43a21.33,21.33,0,0,0,30.17-30.17l-11.43-11.43C289.46,259.29,308.49,213.33,346.51,213.33ZM160,192a32,32,0,1,1,32-32A32,32,0,0,1,160,192Zm80,32a16,16,0,1,1,16-16A16,16,0,0,1,240,224Z"
                }
            }
        ]
    })(props);
}
function FaVoicemail(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M496 128a144 144 0 0 0-119.74 224H263.74A144 144 0 1 0 144 416h352a144 144 0 0 0 0-288zM64 272a80 80 0 1 1 80 80 80 80 0 0 1-80-80zm432 80a80 80 0 1 1 80-80 80 80 0 0 1-80 80z"
                }
            }
        ]
    })(props);
}
function FaVolleyballBall(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M231.39 243.48a285.56 285.56 0 0 0-22.7-105.7c-90.8 42.4-157.5 122.4-180.3 216.8a249 249 0 0 0 56.9 81.1 333.87 333.87 0 0 1 146.1-192.2zm-36.9-134.4a284.23 284.23 0 0 0-57.4-70.7c-91 49.8-144.8 152.9-125 262.2 33.4-83.1 98.4-152 182.4-191.5zm187.6 165.1c8.6-99.8-27.3-197.5-97.5-264.4-14.7-1.7-51.6-5.5-98.9 8.5A333.87 333.87 0 0 1 279.19 241a285 285 0 0 0 102.9 33.18zm-124.7 9.5a286.33 286.33 0 0 0-80.2 72.6c82 57.3 184.5 75.1 277.5 47.8a247.15 247.15 0 0 0 42.2-89.9 336.1 336.1 0 0 1-80.9 10.4c-54.6-.1-108.9-14.1-158.6-40.9zm-98.3 99.7c-15.2 26-25.7 54.4-32.1 84.2a247.07 247.07 0 0 0 289-22.1c-112.9 16.1-203.3-24.8-256.9-62.1zm180.3-360.6c55.3 70.4 82.5 161.2 74.6 253.6a286.59 286.59 0 0 0 89.7-14.2c0-2 .3-4 .3-6 0-107.8-68.7-199.1-164.6-233.4z"
                }
            }
        ]
    })(props);
}
function FaVolumeDown(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M215.03 72.04L126.06 161H24c-13.26 0-24 10.74-24 24v144c0 13.25 10.74 24 24 24h102.06l88.97 88.95c15.03 15.03 40.97 4.47 40.97-16.97V89.02c0-21.47-25.96-31.98-40.97-16.98zm123.2 108.08c-11.58-6.33-26.19-2.16-32.61 9.45-6.39 11.61-2.16 26.2 9.45 32.61C327.98 229.28 336 242.62 336 257c0 14.38-8.02 27.72-20.92 34.81-11.61 6.41-15.84 21-9.45 32.61 6.43 11.66 21.05 15.8 32.61 9.45 28.23-15.55 45.77-45 45.77-76.88s-17.54-61.32-45.78-76.87z"
                }
            }
        ]
    })(props);
}
function FaVolumeMute(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M215.03 71.05L126.06 160H24c-13.26 0-24 10.74-24 24v144c0 13.25 10.74 24 24 24h102.06l88.97 88.95c15.03 15.03 40.97 4.47 40.97-16.97V88.02c0-21.46-25.96-31.98-40.97-16.97zM461.64 256l45.64-45.64c6.3-6.3 6.3-16.52 0-22.82l-22.82-22.82c-6.3-6.3-16.52-6.3-22.82 0L416 210.36l-45.64-45.64c-6.3-6.3-16.52-6.3-22.82 0l-22.82 22.82c-6.3 6.3-6.3 16.52 0 22.82L370.36 256l-45.63 45.63c-6.3 6.3-6.3 16.52 0 22.82l22.82 22.82c6.3 6.3 16.52 6.3 22.82 0L416 301.64l45.64 45.64c6.3 6.3 16.52 6.3 22.82 0l22.82-22.82c6.3-6.3 6.3-16.52 0-22.82L461.64 256z"
                }
            }
        ]
    })(props);
}
function FaVolumeOff(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 256 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M215 71l-89 89H24a24 24 0 0 0-24 24v144a24 24 0 0 0 24 24h102.06L215 441c15 15 41 4.47 41-17V88c0-21.47-26-32-41-17z"
                }
            }
        ]
    })(props);
}
function FaVolumeUp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M215.03 71.05L126.06 160H24c-13.26 0-24 10.74-24 24v144c0 13.25 10.74 24 24 24h102.06l88.97 88.95c15.03 15.03 40.97 4.47 40.97-16.97V88.02c0-21.46-25.96-31.98-40.97-16.97zm233.32-51.08c-11.17-7.33-26.18-4.24-33.51 6.95-7.34 11.17-4.22 26.18 6.95 33.51 66.27 43.49 105.82 116.6 105.82 195.58 0 78.98-39.55 152.09-105.82 195.58-11.17 7.32-14.29 22.34-6.95 33.5 7.04 10.71 21.93 14.56 33.51 6.95C528.27 439.58 576 351.33 576 256S528.27 72.43 448.35 19.97zM480 256c0-63.53-32.06-121.94-85.77-156.24-11.19-7.14-26.03-3.82-33.12 7.46s-3.78 26.21 7.41 33.36C408.27 165.97 432 209.11 432 256s-23.73 90.03-63.48 115.42c-11.19 7.14-14.5 22.07-7.41 33.36 6.51 10.36 21.12 15.14 33.12 7.46C447.94 377.94 480 319.54 480 256zm-141.77-76.87c-11.58-6.33-26.19-2.16-32.61 9.45-6.39 11.61-2.16 26.2 9.45 32.61C327.98 228.28 336 241.63 336 256c0 14.38-8.02 27.72-20.92 34.81-11.61 6.41-15.84 21-9.45 32.61 6.43 11.66 21.05 15.8 32.61 9.45 28.23-15.55 45.77-45 45.77-76.88s-17.54-61.32-45.78-76.86z"
                }
            }
        ]
    })(props);
}
function FaVoteYea(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M608 320h-64v64h22.4c5.3 0 9.6 3.6 9.6 8v16c0 4.4-4.3 8-9.6 8H73.6c-5.3 0-9.6-3.6-9.6-8v-16c0-4.4 4.3-8 9.6-8H96v-64H32c-17.7 0-32 14.3-32 32v96c0 17.7 14.3 32 32 32h576c17.7 0 32-14.3 32-32v-96c0-17.7-14.3-32-32-32zm-96 64V64.3c0-17.9-14.5-32.3-32.3-32.3H160.4C142.5 32 128 46.5 128 64.3V384h384zM211.2 202l25.5-25.3c4.2-4.2 11-4.2 15.2.1l41.3 41.6 95.2-94.4c4.2-4.2 11-4.2 15.2.1l25.3 25.5c4.2 4.2 4.2 11-.1 15.2L300.5 292c-4.2 4.2-11 4.2-15.2-.1l-74.1-74.7c-4.3-4.2-4.2-11 0-15.2z"
                }
            }
        ]
    })(props);
}
function FaVrCardboard(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M608 64H32C14.33 64 0 78.33 0 96v320c0 17.67 14.33 32 32 32h160.22c25.19 0 48.03-14.77 58.36-37.74l27.74-61.64C286.21 331.08 302.35 320 320 320s33.79 11.08 41.68 28.62l27.74 61.64C399.75 433.23 422.6 448 447.78 448H608c17.67 0 32-14.33 32-32V96c0-17.67-14.33-32-32-32zM160 304c-35.35 0-64-28.65-64-64s28.65-64 64-64 64 28.65 64 64-28.65 64-64 64zm320 0c-35.35 0-64-28.65-64-64s28.65-64 64-64 64 28.65 64 64-28.65 64-64 64z"
                }
            }
        ]
    })(props);
}
function FaWalking(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 320 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M208 96c26.5 0 48-21.5 48-48S234.5 0 208 0s-48 21.5-48 48 21.5 48 48 48zm94.5 149.1l-23.3-11.8-9.7-29.4c-14.7-44.6-55.7-75.8-102.2-75.9-36-.1-55.9 10.1-93.3 25.2-21.6 8.7-39.3 25.2-49.7 46.2L17.6 213c-7.8 15.8-1.5 35 14.2 42.9 15.6 7.9 34.6 1.5 42.5-14.3L81 228c3.5-7 9.3-12.5 16.5-15.4l26.8-10.8-15.2 60.7c-5.2 20.8.4 42.9 14.9 58.8l59.9 65.4c7.2 7.9 12.3 17.4 14.9 27.7l18.3 73.3c4.3 17.1 21.7 27.6 38.8 23.3 17.1-4.3 27.6-21.7 23.3-38.8l-22.2-89c-2.6-10.3-7.7-19.9-14.9-27.7l-45.5-49.7 17.2-68.7 5.5 16.5c5.3 16.1 16.7 29.4 31.7 37l23.3 11.8c15.6 7.9 34.6 1.5 42.5-14.3 7.7-15.7 1.4-35.1-14.3-43zM73.6 385.8c-3.2 8.1-8 15.4-14.2 21.5l-50 50.1c-12.5 12.5-12.5 32.8 0 45.3s32.7 12.5 45.2 0l59.4-59.4c6.1-6.1 10.9-13.4 14.2-21.5l13.5-33.8c-55.3-60.3-38.7-41.8-47.4-53.7l-20.7 51.5z"
                }
            }
        ]
    })(props);
}
function FaWallet(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M461.2 128H80c-8.84 0-16-7.16-16-16s7.16-16 16-16h384c8.84 0 16-7.16 16-16 0-26.51-21.49-48-48-48H64C28.65 32 0 60.65 0 96v320c0 35.35 28.65 64 64 64h397.2c28.02 0 50.8-21.53 50.8-48V176c0-26.47-22.78-48-50.8-48zM416 336c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32z"
                }
            }
        ]
    })(props);
}
function FaWarehouse(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M504 352H136.4c-4.4 0-8 3.6-8 8l-.1 48c0 4.4 3.6 8 8 8H504c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zm0 96H136.1c-4.4 0-8 3.6-8 8l-.1 48c0 4.4 3.6 8 8 8h368c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zm0-192H136.6c-4.4 0-8 3.6-8 8l-.1 48c0 4.4 3.6 8 8 8H504c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zm106.5-139L338.4 3.7a48.15 48.15 0 0 0-36.9 0L29.5 117C11.7 124.5 0 141.9 0 161.3V504c0 4.4 3.6 8 8 8h80c4.4 0 8-3.6 8-8V256c0-17.6 14.6-32 32.6-32h382.8c18 0 32.6 14.4 32.6 32v248c0 4.4 3.6 8 8 8h80c4.4 0 8-3.6 8-8V161.3c0-19.4-11.7-36.8-29.5-44.3z"
                }
            }
        ]
    })(props);
}
function FaWater(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M562.1 383.9c-21.5-2.4-42.1-10.5-57.9-22.9-14.1-11.1-34.2-11.3-48.2 0-37.9 30.4-107.2 30.4-145.7-1.5-13.5-11.2-33-9.1-46.7 1.8-38 30.1-106.9 30-145.2-1.7-13.5-11.2-33.3-8.9-47.1 2-15.5 12.2-36 20.1-57.7 22.4-7.9.8-13.6 7.8-13.6 15.7v32.2c0 9.1 7.6 16.8 16.7 16 28.8-2.5 56.1-11.4 79.4-25.9 56.5 34.6 137 34.1 192 0 56.5 34.6 137 34.1 192 0 23.3 14.2 50.9 23.3 79.1 25.8 9.1.8 16.7-6.9 16.7-16v-31.6c.1-8-5.7-15.4-13.8-16.3zm0-144c-21.5-2.4-42.1-10.5-57.9-22.9-14.1-11.1-34.2-11.3-48.2 0-37.9 30.4-107.2 30.4-145.7-1.5-13.5-11.2-33-9.1-46.7 1.8-38 30.1-106.9 30-145.2-1.7-13.5-11.2-33.3-8.9-47.1 2-15.5 12.2-36 20.1-57.7 22.4-7.9.8-13.6 7.8-13.6 15.7v32.2c0 9.1 7.6 16.8 16.7 16 28.8-2.5 56.1-11.4 79.4-25.9 56.5 34.6 137 34.1 192 0 56.5 34.6 137 34.1 192 0 23.3 14.2 50.9 23.3 79.1 25.8 9.1.8 16.7-6.9 16.7-16v-31.6c.1-8-5.7-15.4-13.8-16.3zm0-144C540.6 93.4 520 85.4 504.2 73 490.1 61.9 470 61.7 456 73c-37.9 30.4-107.2 30.4-145.7-1.5-13.5-11.2-33-9.1-46.7 1.8-38 30.1-106.9 30-145.2-1.7-13.5-11.2-33.3-8.9-47.1 2-15.5 12.2-36 20.1-57.7 22.4-7.9.8-13.6 7.8-13.6 15.7v32.2c0 9.1 7.6 16.8 16.7 16 28.8-2.5 56.1-11.4 79.4-25.9 56.5 34.6 137 34.1 192 0 56.5 34.6 137 34.1 192 0 23.3 14.2 50.9 23.3 79.1 25.8 9.1.8 16.7-6.9 16.7-16v-31.6c.1-8-5.7-15.4-13.8-16.3z"
                }
            }
        ]
    })(props);
}
function FaWaveSquare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M476 480H324a36 36 0 0 1-36-36V96h-96v156a36 36 0 0 1-36 36H16a16 16 0 0 1-16-16v-32a16 16 0 0 1 16-16h112V68a36 36 0 0 1 36-36h152a36 36 0 0 1 36 36v348h96V260a36 36 0 0 1 36-36h140a16 16 0 0 1 16 16v32a16 16 0 0 1-16 16H512v156a36 36 0 0 1-36 36z"
                }
            }
        ]
    })(props);
}
function FaWeightHanging(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M510.28 445.86l-73.03-292.13c-3.8-15.19-16.44-25.72-30.87-25.72h-60.25c3.57-10.05 5.88-20.72 5.88-32 0-53.02-42.98-96-96-96s-96 42.98-96 96c0 11.28 2.3 21.95 5.88 32h-60.25c-14.43 0-27.08 10.54-30.87 25.72L1.72 445.86C-6.61 479.17 16.38 512 48.03 512h415.95c31.64 0 54.63-32.83 46.3-66.14zM256 128c-17.64 0-32-14.36-32-32s14.36-32 32-32 32 14.36 32 32-14.36 32-32 32z"
                }
            }
        ]
    })(props);
}
function FaWeight(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M448 64h-25.98C438.44 92.28 448 125.01 448 160c0 105.87-86.13 192-192 192S64 265.87 64 160c0-34.99 9.56-67.72 25.98-96H64C28.71 64 0 92.71 0 128v320c0 35.29 28.71 64 64 64h384c35.29 0 64-28.71 64-64V128c0-35.29-28.71-64-64-64zM256 320c88.37 0 160-71.63 160-160S344.37 0 256 0 96 71.63 96 160s71.63 160 160 160zm-.3-151.94l33.58-78.36c3.5-8.17 12.94-11.92 21.03-8.41 8.12 3.48 11.88 12.89 8.41 21l-33.67 78.55C291.73 188 296 197.45 296 208c0 22.09-17.91 40-40 40s-40-17.91-40-40c0-21.98 17.76-39.77 39.7-39.94z"
                }
            }
        ]
    })(props);
}
function FaWheelchair(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M496.101 385.669l14.227 28.663c3.929 7.915.697 17.516-7.218 21.445l-65.465 32.886c-16.049 7.967-35.556 1.194-43.189-15.055L331.679 320H192c-15.925 0-29.426-11.71-31.679-27.475C126.433 55.308 128.38 70.044 128 64c0-36.358 30.318-65.635 67.052-63.929 33.271 1.545 60.048 28.905 60.925 62.201.868 32.933-23.152 60.423-54.608 65.039l4.67 32.69H336c8.837 0 16 7.163 16 16v32c0 8.837-7.163 16-16 16H215.182l4.572 32H352a32 32 0 0 1 28.962 18.392L438.477 396.8l36.178-18.349c7.915-3.929 17.517-.697 21.446 7.218zM311.358 352h-24.506c-7.788 54.204-54.528 96-110.852 96-61.757 0-112-50.243-112-112 0-41.505 22.694-77.809 56.324-97.156-3.712-25.965-6.844-47.86-9.488-66.333C45.956 198.464 0 261.963 0 336c0 97.047 78.953 176 176 176 71.87 0 133.806-43.308 161.11-105.192L311.358 352z"
                }
            }
        ]
    })(props);
}
function FaWifi(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M634.91 154.88C457.74-8.99 182.19-8.93 5.09 154.88c-6.66 6.16-6.79 16.59-.35 22.98l34.24 33.97c6.14 6.1 16.02 6.23 22.4.38 145.92-133.68 371.3-133.71 517.25 0 6.38 5.85 16.26 5.71 22.4-.38l34.24-33.97c6.43-6.39 6.3-16.82-.36-22.98zM320 352c-35.35 0-64 28.65-64 64s28.65 64 64 64 64-28.65 64-64-28.65-64-64-64zm202.67-83.59c-115.26-101.93-290.21-101.82-405.34 0-6.9 6.1-7.12 16.69-.57 23.15l34.44 33.99c6 5.92 15.66 6.32 22.05.8 83.95-72.57 209.74-72.41 293.49 0 6.39 5.52 16.05 5.13 22.05-.8l34.44-33.99c6.56-6.46 6.33-17.06-.56-23.15z"
                }
            }
        ]
    })(props);
}
function FaWind(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M156.7 256H16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h142.2c15.9 0 30.8 10.9 33.4 26.6 3.3 20-12.1 37.4-31.6 37.4-14.1 0-26.1-9.2-30.4-21.9-2.1-6.3-8.6-10.1-15.2-10.1H81.6c-9.8 0-17.7 8.8-15.9 18.4 8.6 44.1 47.6 77.6 94.2 77.6 57.1 0 102.7-50.1 95.2-108.6C249 291 205.4 256 156.7 256zM16 224h336c59.7 0 106.8-54.8 93.8-116.7-7.6-36.2-36.9-65.5-73.1-73.1-55.4-11.6-105.1 24.9-114.9 75.5-1.9 9.6 6.1 18.3 15.8 18.3h32.8c6.7 0 13.1-3.8 15.2-10.1C325.9 105.2 337.9 96 352 96c19.4 0 34.9 17.4 31.6 37.4-2.6 15.7-17.4 26.6-33.4 26.6H16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16zm384 32H243.7c19.3 16.6 33.2 38.8 39.8 64H400c26.5 0 48 21.5 48 48s-21.5 48-48 48c-17.9 0-33.3-9.9-41.6-24.4-2.9-5-8.7-7.6-14.5-7.6h-33.8c-10.9 0-19 10.8-15.3 21.1 17.8 50.6 70.5 84.8 129.4 72.3 41.2-8.7 75.1-41.6 84.7-82.7C526 321.5 470.5 256 400 256z"
                }
            }
        ]
    })(props);
}
function FaWindowClose(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M464 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h416c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zm-83.6 290.5c4.8 4.8 4.8 12.6 0 17.4l-40.5 40.5c-4.8 4.8-12.6 4.8-17.4 0L256 313.3l-66.5 67.1c-4.8 4.8-12.6 4.8-17.4 0l-40.5-40.5c-4.8-4.8-4.8-12.6 0-17.4l67.1-66.5-67.1-66.5c-4.8-4.8-4.8-12.6 0-17.4l40.5-40.5c4.8-4.8 12.6-4.8 17.4 0l66.5 67.1 66.5-67.1c4.8-4.8 12.6-4.8 17.4 0l40.5 40.5c4.8 4.8 4.8 12.6 0 17.4L313.3 256l67.1 66.5z"
                }
            }
        ]
    })(props);
}
function FaWindowMaximize(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M464 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h416c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zm-16 160H64v-84c0-6.6 5.4-12 12-12h360c6.6 0 12 5.4 12 12v84z"
                }
            }
        ]
    })(props);
}
function FaWindowMinimize(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M464 352H48c-26.5 0-48 21.5-48 48v32c0 26.5 21.5 48 48 48h416c26.5 0 48-21.5 48-48v-32c0-26.5-21.5-48-48-48z"
                }
            }
        ]
    })(props);
}
function FaWindowRestore(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M512 48v288c0 26.5-21.5 48-48 48h-48V176c0-44.1-35.9-80-80-80H128V48c0-26.5 21.5-48 48-48h288c26.5 0 48 21.5 48 48zM384 176v288c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V176c0-26.5 21.5-48 48-48h288c26.5 0 48 21.5 48 48zm-68 28c0-6.6-5.4-12-12-12H76c-6.6 0-12 5.4-12 12v52h252v-52z"
                }
            }
        ]
    })(props);
}
function FaWineBottle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M507.31 72.57L439.43 4.69c-6.25-6.25-16.38-6.25-22.63 0l-22.63 22.63c-6.25 6.25-6.25 16.38 0 22.63l-76.67 76.67c-46.58-19.7-102.4-10.73-140.37 27.23L18.75 312.23c-24.99 24.99-24.99 65.52 0 90.51l90.51 90.51c24.99 24.99 65.52 24.99 90.51 0l158.39-158.39c37.96-37.96 46.93-93.79 27.23-140.37l76.67-76.67c6.25 6.25 16.38 6.25 22.63 0l22.63-22.63c6.24-6.24 6.24-16.37-.01-22.62zM179.22 423.29l-90.51-90.51 122.04-122.04 90.51 90.51-122.04 122.04z"
                }
            }
        ]
    })(props);
}
function FaWineGlassAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 288 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M216 464h-40V346.81c68.47-15.89 118.05-79.91 111.4-154.16l-15.95-178.1C270.71 6.31 263.9 0 255.74 0H32.26c-8.15 0-14.97 6.31-15.7 14.55L.6 192.66C-6.05 266.91 43.53 330.93 112 346.82V464H72c-22.09 0-40 17.91-40 40 0 4.42 3.58 8 8 8h208c4.42 0 8-3.58 8-8 0-22.09-17.91-40-40-40zM61.75 48h164.5l7.17 80H54.58l7.17-80z"
                }
            }
        ]
    })(props);
}
function FaWineGlass(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 288 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M216 464h-40V346.81c68.47-15.89 118.05-79.91 111.4-154.16l-15.95-178.1C270.71 6.31 263.9 0 255.74 0H32.26c-8.15 0-14.97 6.31-15.7 14.55L.6 192.66C-6.05 266.91 43.53 330.93 112 346.82V464H72c-22.09 0-40 17.91-40 40 0 4.42 3.58 8 8 8h208c4.42 0 8-3.58 8-8 0-22.09-17.91-40-40-40z"
                }
            }
        ]
    })(props);
}
function FaWonSign(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M564 192c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12h-48l18.6-80.6c1.7-7.5-4-14.7-11.7-14.7h-46.1c-5.7 0-10.6 4-11.7 9.5L450.7 128H340.8l-19.7-86c-1.3-5.5-6.1-9.3-11.7-9.3h-44c-5.6 0-10.4 3.8-11.7 9.3l-20 86H125l-17.5-85.7c-1.1-5.6-6.1-9.6-11.8-9.6H53.6c-7.7 0-13.4 7.1-11.7 14.6L60 128H12c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h62.3l7.2 32H12c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h83.9l40.9 182.6c1.2 5.5 6.1 9.4 11.7 9.4h56.8c5.6 0 10.4-3.9 11.7-9.3L259.3 288h55.1l42.4 182.7c1.3 5.4 6.1 9.3 11.7 9.3h56.8c5.6 0 10.4-3.9 11.7-9.3L479.1 288H564c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12h-70.1l7.4-32zM183.8 342c-6.2 25.8-6.8 47.2-7.3 47.2h-1.1s-1.7-22-6.8-47.2l-11-54h38.8zm27.5-118h-66.8l-6.5-32h80.8zm62.9 0l2-8.6c1.9-8 3.5-16 4.8-23.4h11.8c1.3 7.4 2.9 15.4 4.8 23.4l2 8.6zm130.9 118c-5.1 25.2-6.8 47.2-6.8 47.2h-1.1c-.6 0-1.1-21.4-7.3-47.2l-12.4-54h39.1zm25.2-118h-67.4l-7.3-32h81.6z"
                }
            }
        ]
    })(props);
}
function FaWrench(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M507.73 109.1c-2.24-9.03-13.54-12.09-20.12-5.51l-74.36 74.36-67.88-11.31-11.31-67.88 74.36-74.36c6.62-6.62 3.43-17.9-5.66-20.16-47.38-11.74-99.55.91-136.58 37.93-39.64 39.64-50.55 97.1-34.05 147.2L18.74 402.76c-24.99 24.99-24.99 65.51 0 90.5 24.99 24.99 65.51 24.99 90.5 0l213.21-213.21c50.12 16.71 107.47 5.68 147.37-34.22 37.07-37.07 49.7-89.32 37.91-136.73zM64 472c-13.25 0-24-10.75-24-24 0-13.26 10.75-24 24-24s24 10.74 24 24c0 13.25-10.75 24-24 24z"
                }
            }
        ]
    })(props);
}
function FaXRay(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M240 384c-8.8 0-16 7.2-16 16s7.2 16 16 16 16-7.2 16-16-7.2-16-16-16zm160 32c8.8 0 16-7.2 16-16s-7.2-16-16-16-16 7.2-16 16 7.2 16 16 16zM624 0H16C7.2 0 0 7.2 0 16v32c0 8.8 7.2 16 16 16h608c8.8 0 16-7.2 16-16V16c0-8.8-7.2-16-16-16zm0 448h-48V96H64v352H16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h608c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zM480 248c0 4.4-3.6 8-8 8H336v32h104c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8H336v32h64c26.5 0 48 21.5 48 48s-21.5 48-48 48-48-21.5-48-48v-16h-64v16c0 26.5-21.5 48-48 48s-48-21.5-48-48 21.5-48 48-48h64v-32H200c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h104v-32H168c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h136v-32H200c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h104v-24c0-4.4 3.6-8 8-8h16c4.4 0 8 3.6 8 8v24h104c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8H336v32h136c4.4 0 8 3.6 8 8v16z"
                }
            }
        ]
    })(props);
}
function FaYenSign(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M351.2 32h-65.3c-4.6 0-8.8 2.6-10.8 6.7l-55.4 113.2c-14.5 34.7-27.1 71.9-27.1 71.9h-1.3s-12.6-37.2-27.1-71.9L108.8 38.7c-2-4.1-6.2-6.7-10.8-6.7H32.8c-9.1 0-14.8 9.7-10.6 17.6L102.3 200H44c-6.6 0-12 5.4-12 12v32c0 6.6 5.4 12 12 12h88.2l19.8 37.2V320H44c-6.6 0-12 5.4-12 12v32c0 6.6 5.4 12 12 12h108v92c0 6.6 5.4 12 12 12h56c6.6 0 12-5.4 12-12v-92h108c6.6 0 12-5.4 12-12v-32c0-6.6-5.4-12-12-12H232v-26.8l19.8-37.2H340c6.6 0 12-5.4 12-12v-32c0-6.6-5.4-12-12-12h-58.3l80.1-150.4c4.3-7.9-1.5-17.6-10.6-17.6z"
                }
            }
        ]
    })(props);
}
function FaYinYang(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111.03 8 0 119.03 0 256s111.03 248 248 248 248-111.03 248-248S384.97 8 248 8zm0 376c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm0-128c-53.02 0-96 42.98-96 96s42.98 96 96 96c-106.04 0-192-85.96-192-192S141.96 64 248 64c53.02 0 96 42.98 96 96s-42.98 96-96 96zm0-128c-17.67 0-32 14.33-32 32s14.33 32 32 32 32-14.33 32-32-14.33-32-32-32z"
                }
            }
        ]
    })(props);
}
function FaRegAddressBook(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M436 160c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12h-20V48c0-26.5-21.5-48-48-48H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h320c26.5 0 48-21.5 48-48v-48h20c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12h-20v-64h20c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12h-20v-64h20zm-68 304H48V48h320v416zM208 256c35.3 0 64-28.7 64-64s-28.7-64-64-64-64 28.7-64 64 28.7 64 64 64zm-89.6 128h179.2c12.4 0 22.4-8.6 22.4-19.2v-19.2c0-31.8-30.1-57.6-67.2-57.6-10.8 0-18.7 8-44.8 8-26.9 0-33.4-8-44.8-8-37.1 0-67.2 25.8-67.2 57.6v19.2c0 10.6 10 19.2 22.4 19.2z"
                }
            }
        ]
    })(props);
}
function FaRegAddressCard(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M528 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h480c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zm0 400H48V80h480v352zM208 256c35.3 0 64-28.7 64-64s-28.7-64-64-64-64 28.7-64 64 28.7 64 64 64zm-89.6 128h179.2c12.4 0 22.4-8.6 22.4-19.2v-19.2c0-31.8-30.1-57.6-67.2-57.6-10.8 0-18.7 8-44.8 8-26.9 0-33.4-8-44.8-8-37.1 0-67.2 25.8-67.2 57.6v19.2c0 10.6 10 19.2 22.4 19.2zM360 320h112c4.4 0 8-3.6 8-8v-16c0-4.4-3.6-8-8-8H360c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8zm0-64h112c4.4 0 8-3.6 8-8v-16c0-4.4-3.6-8-8-8H360c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8zm0-64h112c4.4 0 8-3.6 8-8v-16c0-4.4-3.6-8-8-8H360c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8z"
                }
            }
        ]
    })(props);
}
function FaRegAngry(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 448c-110.3 0-200-89.7-200-200S137.7 56 248 56s200 89.7 200 200-89.7 200-200 200zm0-144c-33.6 0-65.2 14.8-86.8 40.6-8.5 10.2-7.1 25.3 3.1 33.8s25.3 7.2 33.8-3c24.8-29.7 75-29.7 99.8 0 8.1 9.7 23.2 11.9 33.8 3 10.2-8.5 11.5-23.6 3.1-33.8-21.6-25.8-53.2-40.6-86.8-40.6zm-48-72c10.3 0 19.9-6.7 23-17.1 3.8-12.7-3.4-26.1-16.1-29.9l-80-24c-12.8-3.9-26.1 3.4-29.9 16.1-3.8 12.7 3.4 26.1 16.1 29.9l28.2 8.5c-3.1 4.9-5.3 10.4-5.3 16.6 0 17.7 14.3 32 32 32s32-14.4 32-32.1zm199-54.9c-3.8-12.7-17.1-19.9-29.9-16.1l-80 24c-12.7 3.8-19.9 17.2-16.1 29.9 3.1 10.4 12.7 17.1 23 17.1 0 17.7 14.3 32 32 32s32-14.3 32-32c0-6.2-2.2-11.7-5.3-16.6l28.2-8.5c12.7-3.7 19.9-17.1 16.1-29.8z"
                }
            }
        ]
    })(props);
}
function FaRegArrowAltCircleDown(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm0 448c-110.5 0-200-89.5-200-200S145.5 56 256 56s200 89.5 200 200-89.5 200-200 200zm-32-316v116h-67c-10.7 0-16 12.9-8.5 20.5l99 99c4.7 4.7 12.3 4.7 17 0l99-99c7.6-7.6 2.2-20.5-8.5-20.5h-67V140c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12z"
                }
            }
        ]
    })(props);
}
function FaRegArrowAltCircleLeft(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 256c0 137 111 248 248 248s248-111 248-248S393 8 256 8 8 119 8 256zm448 0c0 110.5-89.5 200-200 200S56 366.5 56 256 145.5 56 256 56s200 89.5 200 200zm-72-20v40c0 6.6-5.4 12-12 12H256v67c0 10.7-12.9 16-20.5 8.5l-99-99c-4.7-4.7-4.7-12.3 0-17l99-99c7.6-7.6 20.5-2.2 20.5 8.5v67h116c6.6 0 12 5.4 12 12z"
                }
            }
        ]
    })(props);
}
function FaRegArrowAltCircleRight(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M504 256C504 119 393 8 256 8S8 119 8 256s111 248 248 248 248-111 248-248zm-448 0c0-110.5 89.5-200 200-200s200 89.5 200 200-89.5 200-200 200S56 366.5 56 256zm72 20v-40c0-6.6 5.4-12 12-12h116v-67c0-10.7 12.9-16 20.5-8.5l99 99c4.7 4.7 4.7 12.3 0 17l-99 99c-7.6 7.6-20.5 2.2-20.5-8.5v-67H140c-6.6 0-12-5.4-12-12z"
                }
            }
        ]
    })(props);
}
function FaRegArrowAltCircleUp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 504c137 0 248-111 248-248S393 8 256 8 8 119 8 256s111 248 248 248zm0-448c110.5 0 200 89.5 200 200s-89.5 200-200 200S56 366.5 56 256 145.5 56 256 56zm20 328h-40c-6.6 0-12-5.4-12-12V256h-67c-10.7 0-16-12.9-8.5-20.5l99-99c4.7-4.7 12.3-4.7 17 0l99 99c7.6 7.6 2.2 20.5-8.5 20.5h-67v116c0 6.6-5.4 12-12 12z"
                }
            }
        ]
    })(props);
}
function FaRegBellSlash(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M633.99 471.02L36 3.51C29.1-2.01 19.03-.9 13.51 6l-10 12.49C-2.02 25.39-.9 35.46 6 40.98l598 467.51c6.9 5.52 16.96 4.4 22.49-2.49l10-12.49c5.52-6.9 4.41-16.97-2.5-22.49zM163.53 368c16.71-22.03 34.48-55.8 41.4-110.58l-45.47-35.55c-3.27 90.73-36.47 120.68-54.84 140.42-6 6.45-8.66 14.16-8.61 21.71.11 16.4 12.98 32 32.1 32h279.66l-61.4-48H163.53zM320 96c61.86 0 112 50.14 112 112 0 .2-.06.38-.06.58.02 16.84 1.16 31.77 2.79 45.73l59.53 46.54c-8.31-22.13-14.34-51.49-14.34-92.85 0-77.7-54.48-139.9-127.94-155.16V32c0-17.67-14.32-32-31.98-32s-31.98 14.33-31.98 32v20.84c-26.02 5.41-49.45 16.94-69.13 32.72l38.17 29.84C275 103.18 296.65 96 320 96zm0 416c35.32 0 63.97-28.65 63.97-64H256.03c0 35.35 28.65 64 63.97 64z"
                }
            }
        ]
    })(props);
}
function FaRegBell(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M439.39 362.29c-19.32-20.76-55.47-51.99-55.47-154.29 0-77.7-54.48-139.9-127.94-155.16V32c0-17.67-14.32-32-31.98-32s-31.98 14.33-31.98 32v20.84C118.56 68.1 64.08 130.3 64.08 208c0 102.3-36.15 133.53-55.47 154.29-6 6.45-8.66 14.16-8.61 21.71.11 16.4 12.98 32 32.1 32h383.8c19.12 0 32-15.6 32.1-32 .05-7.55-2.61-15.27-8.61-21.71zM67.53 368c21.22-27.97 44.42-74.33 44.53-159.42 0-.2-.06-.38-.06-.58 0-61.86 50.14-112 112-112s112 50.14 112 112c0 .2-.06.38-.06.58.11 85.1 23.31 131.46 44.53 159.42H67.53zM224 512c35.32 0 63.97-28.65 63.97-64H160.03c0 35.35 28.65 64 63.97 64z"
                }
            }
        ]
    })(props);
}
function FaRegBookmark(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M336 0H48C21.49 0 0 21.49 0 48v464l192-112 192 112V48c0-26.51-21.49-48-48-48zm0 428.43l-144-84-144 84V54a6 6 0 0 1 6-6h276c3.314 0 6 2.683 6 5.996V428.43z"
                }
            }
        ]
    })(props);
}
function FaRegBuilding(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M128 148v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12zm140 12h40c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12zm-128 96h40c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12zm128 0h40c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12zm-76 84v-40c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12zm76 12h40c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12zm180 124v36H0v-36c0-6.6 5.4-12 12-12h19.5V24c0-13.3 10.7-24 24-24h337c13.3 0 24 10.7 24 24v440H436c6.6 0 12 5.4 12 12zM79.5 463H192v-67c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v67h112.5V49L80 48l-.5 415z"
                }
            }
        ]
    })(props);
}
function FaRegCalendarAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M148 288h-40c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12zm108-12v-40c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12zm96 0v-40c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12zm-96 96v-40c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12zm-96 0v-40c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12zm192 0v-40c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12zm96-260v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V112c0-26.5 21.5-48 48-48h48V12c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v52h128V12c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v52h48c26.5 0 48 21.5 48 48zm-48 346V160H48v298c0 3.3 2.7 6 6 6h340c3.3 0 6-2.7 6-6z"
                }
            }
        ]
    })(props);
}
function FaRegCalendarCheck(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M400 64h-48V12c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v52H160V12c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v52H48C21.49 64 0 85.49 0 112v352c0 26.51 21.49 48 48 48h352c26.51 0 48-21.49 48-48V112c0-26.51-21.49-48-48-48zm-6 400H54a6 6 0 0 1-6-6V160h352v298a6 6 0 0 1-6 6zm-52.849-200.65L198.842 404.519c-4.705 4.667-12.303 4.637-16.971-.068l-75.091-75.699c-4.667-4.705-4.637-12.303.068-16.971l22.719-22.536c4.705-4.667 12.303-4.637 16.97.069l44.104 44.461 111.072-110.181c4.705-4.667 12.303-4.637 16.971.068l22.536 22.718c4.667 4.705 4.636 12.303-.069 16.97z"
                }
            }
        ]
    })(props);
}
function FaRegCalendarMinus(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M124 328c-6.6 0-12-5.4-12-12v-24c0-6.6 5.4-12 12-12h200c6.6 0 12 5.4 12 12v24c0 6.6-5.4 12-12 12H124zm324-216v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V112c0-26.5 21.5-48 48-48h48V12c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v52h128V12c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v52h48c26.5 0 48 21.5 48 48zm-48 346V160H48v298c0 3.3 2.7 6 6 6h340c3.3 0 6-2.7 6-6z"
                }
            }
        ]
    })(props);
}
function FaRegCalendarPlus(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M336 292v24c0 6.6-5.4 12-12 12h-76v76c0 6.6-5.4 12-12 12h-24c-6.6 0-12-5.4-12-12v-76h-76c-6.6 0-12-5.4-12-12v-24c0-6.6 5.4-12 12-12h76v-76c0-6.6 5.4-12 12-12h24c6.6 0 12 5.4 12 12v76h76c6.6 0 12 5.4 12 12zm112-180v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V112c0-26.5 21.5-48 48-48h48V12c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v52h128V12c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v52h48c26.5 0 48 21.5 48 48zm-48 346V160H48v298c0 3.3 2.7 6 6 6h340c3.3 0 6-2.7 6-6z"
                }
            }
        ]
    })(props);
}
function FaRegCalendarTimes(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M311.7 374.7l-17 17c-4.7 4.7-12.3 4.7-17 0L224 337.9l-53.7 53.7c-4.7 4.7-12.3 4.7-17 0l-17-17c-4.7-4.7-4.7-12.3 0-17l53.7-53.7-53.7-53.7c-4.7-4.7-4.7-12.3 0-17l17-17c4.7-4.7 12.3-4.7 17 0l53.7 53.7 53.7-53.7c4.7-4.7 12.3-4.7 17 0l17 17c4.7 4.7 4.7 12.3 0 17L257.9 304l53.7 53.7c4.8 4.7 4.8 12.3.1 17zM448 112v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V112c0-26.5 21.5-48 48-48h48V12c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v52h128V12c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v52h48c26.5 0 48 21.5 48 48zm-48 346V160H48v298c0 3.3 2.7 6 6 6h340c3.3 0 6-2.7 6-6z"
                }
            }
        ]
    })(props);
}
function FaRegCalendar(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M400 64h-48V12c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v52H160V12c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v52H48C21.5 64 0 85.5 0 112v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V112c0-26.5-21.5-48-48-48zm-6 400H54c-3.3 0-6-2.7-6-6V160h352v298c0 3.3-2.7 6-6 6z"
                }
            }
        ]
    })(props);
}
function FaRegCaretSquareDown(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M125.1 208h197.8c10.7 0 16.1 13 8.5 20.5l-98.9 98.3c-4.7 4.7-12.2 4.7-16.9 0l-98.9-98.3c-7.7-7.5-2.3-20.5 8.4-20.5zM448 80v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h352c26.5 0 48 21.5 48 48zm-48 346V86c0-3.3-2.7-6-6-6H54c-3.3 0-6 2.7-6 6v340c0 3.3 2.7 6 6 6h340c3.3 0 6-2.7 6-6z"
                }
            }
        ]
    })(props);
}
function FaRegCaretSquareLeft(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M272 157.1v197.8c0 10.7-13 16.1-20.5 8.5l-98.3-98.9c-4.7-4.7-4.7-12.2 0-16.9l98.3-98.9c7.5-7.7 20.5-2.3 20.5 8.4zM448 80v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h352c26.5 0 48 21.5 48 48zm-48 346V86c0-3.3-2.7-6-6-6H54c-3.3 0-6 2.7-6 6v340c0 3.3 2.7 6 6 6h340c3.3 0 6-2.7 6-6z"
                }
            }
        ]
    })(props);
}
function FaRegCaretSquareRight(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M176 354.9V157.1c0-10.7 13-16.1 20.5-8.5l98.3 98.9c4.7 4.7 4.7 12.2 0 16.9l-98.3 98.9c-7.5 7.7-20.5 2.3-20.5-8.4zM448 80v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h352c26.5 0 48 21.5 48 48zm-48 346V86c0-3.3-2.7-6-6-6H54c-3.3 0-6 2.7-6 6v340c0 3.3 2.7 6 6 6h340c3.3 0 6-2.7 6-6z"
                }
            }
        ]
    })(props);
}
function FaRegCaretSquareUp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M322.9 304H125.1c-10.7 0-16.1-13-8.5-20.5l98.9-98.3c4.7-4.7 12.2-4.7 16.9 0l98.9 98.3c7.7 7.5 2.3 20.5-8.4 20.5zM448 80v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h352c26.5 0 48 21.5 48 48zm-48 346V86c0-3.3-2.7-6-6-6H54c-3.3 0-6 2.7-6 6v340c0 3.3 2.7 6 6 6h340c3.3 0 6-2.7 6-6z"
                }
            }
        ]
    })(props);
}
function FaRegChartBar(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M396.8 352h22.4c6.4 0 12.8-6.4 12.8-12.8V108.8c0-6.4-6.4-12.8-12.8-12.8h-22.4c-6.4 0-12.8 6.4-12.8 12.8v230.4c0 6.4 6.4 12.8 12.8 12.8zm-192 0h22.4c6.4 0 12.8-6.4 12.8-12.8V140.8c0-6.4-6.4-12.8-12.8-12.8h-22.4c-6.4 0-12.8 6.4-12.8 12.8v198.4c0 6.4 6.4 12.8 12.8 12.8zm96 0h22.4c6.4 0 12.8-6.4 12.8-12.8V204.8c0-6.4-6.4-12.8-12.8-12.8h-22.4c-6.4 0-12.8 6.4-12.8 12.8v134.4c0 6.4 6.4 12.8 12.8 12.8zM496 400H48V80c0-8.84-7.16-16-16-16H16C7.16 64 0 71.16 0 80v336c0 17.67 14.33 32 32 32h464c8.84 0 16-7.16 16-16v-16c0-8.84-7.16-16-16-16zm-387.2-48h22.4c6.4 0 12.8-6.4 12.8-12.8v-70.4c0-6.4-6.4-12.8-12.8-12.8h-22.4c-6.4 0-12.8 6.4-12.8 12.8v70.4c0 6.4 6.4 12.8 12.8 12.8z"
                }
            }
        ]
    })(props);
}
function FaRegCheckCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 8C119.033 8 8 119.033 8 256s111.033 248 248 248 248-111.033 248-248S392.967 8 256 8zm0 48c110.532 0 200 89.451 200 200 0 110.532-89.451 200-200 200-110.532 0-200-89.451-200-200 0-110.532 89.451-200 200-200m140.204 130.267l-22.536-22.718c-4.667-4.705-12.265-4.736-16.97-.068L215.346 303.697l-59.792-60.277c-4.667-4.705-12.265-4.736-16.97-.069l-22.719 22.536c-4.705 4.667-4.736 12.265-.068 16.971l90.781 91.516c4.667 4.705 12.265 4.736 16.97.068l172.589-171.204c4.704-4.668 4.734-12.266.067-16.971z"
                }
            }
        ]
    })(props);
}
function FaRegCheckSquare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M400 32H48C21.49 32 0 53.49 0 80v352c0 26.51 21.49 48 48 48h352c26.51 0 48-21.49 48-48V80c0-26.51-21.49-48-48-48zm0 400H48V80h352v352zm-35.864-241.724L191.547 361.48c-4.705 4.667-12.303 4.637-16.97-.068l-90.781-91.516c-4.667-4.705-4.637-12.303.069-16.971l22.719-22.536c4.705-4.667 12.303-4.637 16.97.069l59.792 60.277 141.352-140.216c4.705-4.667 12.303-4.637 16.97.068l22.536 22.718c4.667 4.706 4.637 12.304-.068 16.971z"
                }
            }
        ]
    })(props);
}
function FaRegCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm0 448c-110.5 0-200-89.5-200-200S145.5 56 256 56s200 89.5 200 200-89.5 200-200 200z"
                }
            }
        ]
    })(props);
}
function FaRegClipboard(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M336 64h-80c0-35.3-28.7-64-64-64s-64 28.7-64 64H48C21.5 64 0 85.5 0 112v352c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V112c0-26.5-21.5-48-48-48zM192 40c13.3 0 24 10.7 24 24s-10.7 24-24 24-24-10.7-24-24 10.7-24 24-24zm144 418c0 3.3-2.7 6-6 6H54c-3.3 0-6-2.7-6-6V118c0-3.3 2.7-6 6-6h42v36c0 6.6 5.4 12 12 12h168c6.6 0 12-5.4 12-12v-36h42c3.3 0 6 2.7 6 6z"
                }
            }
        ]
    })(props);
}
function FaRegClock(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm0 448c-110.5 0-200-89.5-200-200S145.5 56 256 56s200 89.5 200 200-89.5 200-200 200zm61.8-104.4l-84.9-61.7c-3.1-2.3-4.9-5.9-4.9-9.7V116c0-6.6 5.4-12 12-12h32c6.6 0 12 5.4 12 12v141.7l66.8 48.6c5.4 3.9 6.5 11.4 2.6 16.8L334.6 349c-3.9 5.3-11.4 6.5-16.8 2.6z"
                }
            }
        ]
    })(props);
}
function FaRegClone(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M464 0H144c-26.51 0-48 21.49-48 48v48H48c-26.51 0-48 21.49-48 48v320c0 26.51 21.49 48 48 48h320c26.51 0 48-21.49 48-48v-48h48c26.51 0 48-21.49 48-48V48c0-26.51-21.49-48-48-48zM362 464H54a6 6 0 0 1-6-6V150a6 6 0 0 1 6-6h42v224c0 26.51 21.49 48 48 48h224v42a6 6 0 0 1-6 6zm96-96H150a6 6 0 0 1-6-6V54a6 6 0 0 1 6-6h308a6 6 0 0 1 6 6v308a6 6 0 0 1-6 6z"
                }
            }
        ]
    })(props);
}
function FaRegClosedCaptioning(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M464 64H48C21.5 64 0 85.5 0 112v288c0 26.5 21.5 48 48 48h416c26.5 0 48-21.5 48-48V112c0-26.5-21.5-48-48-48zm-6 336H54c-3.3 0-6-2.7-6-6V118c0-3.3 2.7-6 6-6h404c3.3 0 6 2.7 6 6v276c0 3.3-2.7 6-6 6zm-211.1-85.7c1.7 2.4 1.5 5.6-.5 7.7-53.6 56.8-172.8 32.1-172.8-67.9 0-97.3 121.7-119.5 172.5-70.1 2.1 2 2.5 3.2 1 5.7l-17.5 30.5c-1.9 3.1-6.2 4-9.1 1.7-40.8-32-94.6-14.9-94.6 31.2 0 48 51 70.5 92.2 32.6 2.8-2.5 7.1-2.1 9.2.9l19.6 27.7zm190.4 0c1.7 2.4 1.5 5.6-.5 7.7-53.6 56.9-172.8 32.1-172.8-67.9 0-97.3 121.7-119.5 172.5-70.1 2.1 2 2.5 3.2 1 5.7L420 220.2c-1.9 3.1-6.2 4-9.1 1.7-40.8-32-94.6-14.9-94.6 31.2 0 48 51 70.5 92.2 32.6 2.8-2.5 7.1-2.1 9.2.9l19.6 27.7z"
                }
            }
        ]
    })(props);
}
function FaRegCommentAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M448 0H64C28.7 0 0 28.7 0 64v288c0 35.3 28.7 64 64 64h96v84c0 7.1 5.8 12 12 12 2.4 0 4.9-.7 7.1-2.4L304 416h144c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64zm16 352c0 8.8-7.2 16-16 16H288l-12.8 9.6L208 428v-60H64c-8.8 0-16-7.2-16-16V64c0-8.8 7.2-16 16-16h384c8.8 0 16 7.2 16 16v288z"
                }
            }
        ]
    })(props);
}
function FaRegCommentDots(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M144 208c-17.7 0-32 14.3-32 32s14.3 32 32 32 32-14.3 32-32-14.3-32-32-32zm112 0c-17.7 0-32 14.3-32 32s14.3 32 32 32 32-14.3 32-32-14.3-32-32-32zm112 0c-17.7 0-32 14.3-32 32s14.3 32 32 32 32-14.3 32-32-14.3-32-32-32zM256 32C114.6 32 0 125.1 0 240c0 47.6 19.9 91.2 52.9 126.3C38 405.7 7 439.1 6.5 439.5c-6.6 7-8.4 17.2-4.6 26S14.4 480 24 480c61.5 0 110-25.7 139.1-46.3C192 442.8 223.2 448 256 448c141.4 0 256-93.1 256-208S397.4 32 256 32zm0 368c-26.7 0-53.1-4.1-78.4-12.1l-22.7-7.2-19.5 13.8c-14.3 10.1-33.9 21.4-57.5 29 7.3-12.1 14.4-25.7 19.9-40.2l10.6-28.1-20.6-21.8C69.7 314.1 48 282.2 48 240c0-88.2 93.3-160 208-160s208 71.8 208 160-93.3 160-208 160z"
                }
            }
        ]
    })(props);
}
function FaRegComment(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 32C114.6 32 0 125.1 0 240c0 47.6 19.9 91.2 52.9 126.3C38 405.7 7 439.1 6.5 439.5c-6.6 7-8.4 17.2-4.6 26S14.4 480 24 480c61.5 0 110-25.7 139.1-46.3C192 442.8 223.2 448 256 448c141.4 0 256-93.1 256-208S397.4 32 256 32zm0 368c-26.7 0-53.1-4.1-78.4-12.1l-22.7-7.2-19.5 13.8c-14.3 10.1-33.9 21.4-57.5 29 7.3-12.1 14.4-25.7 19.9-40.2l10.6-28.1-20.6-21.8C69.7 314.1 48 282.2 48 240c0-88.2 93.3-160 208-160s208 71.8 208 160-93.3 160-208 160z"
                }
            }
        ]
    })(props);
}
function FaRegComments(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M532 386.2c27.5-27.1 44-61.1 44-98.2 0-80-76.5-146.1-176.2-157.9C368.3 72.5 294.3 32 208 32 93.1 32 0 103.6 0 192c0 37 16.5 71 44 98.2-15.3 30.7-37.3 54.5-37.7 54.9-6.3 6.7-8.1 16.5-4.4 25 3.6 8.5 12 14 21.2 14 53.5 0 96.7-20.2 125.2-38.8 9.2 2.1 18.7 3.7 28.4 4.9C208.1 407.6 281.8 448 368 448c20.8 0 40.8-2.4 59.8-6.8C456.3 459.7 499.4 480 553 480c9.2 0 17.5-5.5 21.2-14 3.6-8.5 1.9-18.3-4.4-25-.4-.3-22.5-24.1-37.8-54.8zm-392.8-92.3L122.1 305c-14.1 9.1-28.5 16.3-43.1 21.4 2.7-4.7 5.4-9.7 8-14.8l15.5-31.1L77.7 256C64.2 242.6 48 220.7 48 192c0-60.7 73.3-112 160-112s160 51.3 160 112-73.3 112-160 112c-16.5 0-33-1.9-49-5.6l-19.8-4.5zM498.3 352l-24.7 24.4 15.5 31.1c2.6 5.1 5.3 10.1 8 14.8-14.6-5.1-29-12.3-43.1-21.4l-17.1-11.1-19.9 4.6c-16 3.7-32.5 5.6-49 5.6-54 0-102.2-20.1-131.3-49.7C338 339.5 416 272.9 416 192c0-3.4-.4-6.7-.7-10C479.7 196.5 528 238.8 528 288c0 28.7-16.2 50.6-29.7 64z"
                }
            }
        ]
    })(props);
}
function FaRegCompass(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M347.94 129.86L203.6 195.83a31.938 31.938 0 0 0-15.77 15.77l-65.97 144.34c-7.61 16.65 9.54 33.81 26.2 26.2l144.34-65.97a31.938 31.938 0 0 0 15.77-15.77l65.97-144.34c7.61-16.66-9.54-33.81-26.2-26.2zm-77.36 148.72c-12.47 12.47-32.69 12.47-45.16 0-12.47-12.47-12.47-32.69 0-45.16 12.47-12.47 32.69-12.47 45.16 0 12.47 12.47 12.47 32.69 0 45.16zM248 8C111.03 8 0 119.03 0 256s111.03 248 248 248 248-111.03 248-248S384.97 8 248 8zm0 448c-110.28 0-200-89.72-200-200S137.72 56 248 56s200 89.72 200 200-89.72 200-200 200z"
                }
            }
        ]
    })(props);
}
function FaRegCopy(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M433.941 65.941l-51.882-51.882A48 48 0 0 0 348.118 0H176c-26.51 0-48 21.49-48 48v48H48c-26.51 0-48 21.49-48 48v320c0 26.51 21.49 48 48 48h224c26.51 0 48-21.49 48-48v-48h80c26.51 0 48-21.49 48-48V99.882a48 48 0 0 0-14.059-33.941zM266 464H54a6 6 0 0 1-6-6V150a6 6 0 0 1 6-6h74v224c0 26.51 21.49 48 48 48h96v42a6 6 0 0 1-6 6zm128-96H182a6 6 0 0 1-6-6V54a6 6 0 0 1 6-6h106v88c0 13.255 10.745 24 24 24h88v202a6 6 0 0 1-6 6zm6-256h-64V48h9.632c1.591 0 3.117.632 4.243 1.757l48.368 48.368a6 6 0 0 1 1.757 4.243V112z"
                }
            }
        ]
    })(props);
}
function FaRegCopyright(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 8C119.033 8 8 119.033 8 256s111.033 248 248 248 248-111.033 248-248S392.967 8 256 8zm0 448c-110.532 0-200-89.451-200-200 0-110.531 89.451-200 200-200 110.532 0 200 89.451 200 200 0 110.532-89.451 200-200 200zm107.351-101.064c-9.614 9.712-45.53 41.396-104.065 41.396-82.43 0-140.484-61.425-140.484-141.567 0-79.152 60.275-139.401 139.762-139.401 55.531 0 88.738 26.62 97.593 34.779a11.965 11.965 0 0 1 1.936 15.322l-18.155 28.113c-3.841 5.95-11.966 7.282-17.499 2.921-8.595-6.776-31.814-22.538-61.708-22.538-48.303 0-77.916 35.33-77.916 80.082 0 41.589 26.888 83.692 78.277 83.692 32.657 0 56.843-19.039 65.726-27.225 5.27-4.857 13.596-4.039 17.82 1.738l19.865 27.17a11.947 11.947 0 0 1-1.152 15.518z"
                }
            }
        ]
    })(props);
}
function FaRegCreditCard(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M527.9 32H48.1C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48.1 48h479.8c26.6 0 48.1-21.5 48.1-48V80c0-26.5-21.5-48-48.1-48zM54.1 80h467.8c3.3 0 6 2.7 6 6v42H48.1V86c0-3.3 2.7-6 6-6zm467.8 352H54.1c-3.3 0-6-2.7-6-6V256h479.8v170c0 3.3-2.7 6-6 6zM192 332v40c0 6.6-5.4 12-12 12h-72c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h72c6.6 0 12 5.4 12 12zm192 0v40c0 6.6-5.4 12-12 12H236c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h136c6.6 0 12 5.4 12 12z"
                }
            }
        ]
    })(props);
}
function FaRegDizzy(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 448c-110.3 0-200-89.7-200-200S137.7 56 248 56s200 89.7 200 200-89.7 200-200 200zm-33.8-217.9c7.8-7.8 7.8-20.5 0-28.3L196.3 192l17.9-17.9c7.8-7.8 7.8-20.5 0-28.3-7.8-7.8-20.5-7.8-28.3 0L168 163.7l-17.8-17.8c-7.8-7.8-20.5-7.8-28.3 0-7.8 7.8-7.8 20.5 0 28.3l17.9 17.9-17.9 17.9c-7.8 7.8-7.8 20.5 0 28.3 7.8 7.8 20.5 7.8 28.3 0l17.8-17.8 17.8 17.8c7.9 7.7 20.5 7.7 28.4-.2zm160-92.2c-7.8-7.8-20.5-7.8-28.3 0L328 163.7l-17.8-17.8c-7.8-7.8-20.5-7.8-28.3 0-7.8 7.8-7.8 20.5 0 28.3l17.9 17.9-17.9 17.9c-7.8 7.8-7.8 20.5 0 28.3 7.8 7.8 20.5 7.8 28.3 0l17.8-17.8 17.8 17.8c7.8 7.8 20.5 7.8 28.3 0 7.8-7.8 7.8-20.5 0-28.3l-17.8-18 17.9-17.9c7.7-7.8 7.7-20.4 0-28.2zM248 272c-35.3 0-64 28.7-64 64s28.7 64 64 64 64-28.7 64-64-28.7-64-64-64z"
                }
            }
        ]
    })(props);
}
function FaRegDotCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 56c110.532 0 200 89.451 200 200 0 110.532-89.451 200-200 200-110.532 0-200-89.451-200-200 0-110.532 89.451-200 200-200m0-48C119.033 8 8 119.033 8 256s111.033 248 248 248 248-111.033 248-248S392.967 8 256 8zm0 168c-44.183 0-80 35.817-80 80s35.817 80 80 80 80-35.817 80-80-35.817-80-80-80z"
                }
            }
        ]
    })(props);
}
function FaRegEdit(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M402.3 344.9l32-32c5-5 13.7-1.5 13.7 5.7V464c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V112c0-26.5 21.5-48 48-48h273.5c7.1 0 10.7 8.6 5.7 13.7l-32 32c-1.5 1.5-3.5 2.3-5.7 2.3H48v352h352V350.5c0-2.1.8-4.1 2.3-5.6zm156.6-201.8L296.3 405.7l-90.4 10c-26.2 2.9-48.5-19.2-45.6-45.6l10-90.4L432.9 17.1c22.9-22.9 59.9-22.9 82.7 0l43.2 43.2c22.9 22.9 22.9 60 .1 82.8zM460.1 174L402 115.9 216.2 301.8l-7.3 65.3 65.3-7.3L460.1 174zm64.8-79.7l-43.2-43.2c-4.1-4.1-10.8-4.1-14.8 0L436 82l58.1 58.1 30.9-30.9c4-4.2 4-10.8-.1-14.9z"
                }
            }
        ]
    })(props);
}
function FaRegEnvelopeOpen(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M494.586 164.516c-4.697-3.883-111.723-89.95-135.251-108.657C337.231 38.191 299.437 0 256 0c-43.205 0-80.636 37.717-103.335 55.859-24.463 19.45-131.07 105.195-135.15 108.549A48.004 48.004 0 0 0 0 201.485V464c0 26.51 21.49 48 48 48h416c26.51 0 48-21.49 48-48V201.509a48 48 0 0 0-17.414-36.993zM464 458a6 6 0 0 1-6 6H54a6 6 0 0 1-6-6V204.347c0-1.813.816-3.526 2.226-4.665 15.87-12.814 108.793-87.554 132.364-106.293C200.755 78.88 232.398 48 256 48c23.693 0 55.857 31.369 73.41 45.389 23.573 18.741 116.503 93.493 132.366 106.316a5.99 5.99 0 0 1 2.224 4.663V458zm-31.991-187.704c4.249 5.159 3.465 12.795-1.745 16.981-28.975 23.283-59.274 47.597-70.929 56.863C336.636 362.283 299.205 400 256 400c-43.452 0-81.287-38.237-103.335-55.86-11.279-8.967-41.744-33.413-70.927-56.865-5.21-4.187-5.993-11.822-1.745-16.981l15.258-18.528c4.178-5.073 11.657-5.843 16.779-1.726 28.618 23.001 58.566 47.035 70.56 56.571C200.143 320.631 232.307 352 256 352c23.602 0 55.246-30.88 73.41-45.389 11.994-9.535 41.944-33.57 70.563-56.568 5.122-4.116 12.601-3.346 16.778 1.727l15.258 18.526z"
                }
            }
        ]
    })(props);
}
function FaRegEnvelope(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M464 64H48C21.49 64 0 85.49 0 112v288c0 26.51 21.49 48 48 48h416c26.51 0 48-21.49 48-48V112c0-26.51-21.49-48-48-48zm0 48v40.805c-22.422 18.259-58.168 46.651-134.587 106.49-16.841 13.247-50.201 45.072-73.413 44.701-23.208.375-56.579-31.459-73.413-44.701C106.18 199.465 70.425 171.067 48 152.805V112h416zM48 400V214.398c22.914 18.251 55.409 43.862 104.938 82.646 21.857 17.205 60.134 55.186 103.062 54.955 42.717.231 80.509-37.199 103.053-54.947 49.528-38.783 82.032-64.401 104.947-82.653V400H48z"
                }
            }
        ]
    })(props);
}
function FaRegEyeSlash(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M634 471L36 3.51A16 16 0 0 0 13.51 6l-10 12.49A16 16 0 0 0 6 41l598 467.49a16 16 0 0 0 22.49-2.49l10-12.49A16 16 0 0 0 634 471zM296.79 146.47l134.79 105.38C429.36 191.91 380.48 144 320 144a112.26 112.26 0 0 0-23.21 2.47zm46.42 219.07L208.42 260.16C210.65 320.09 259.53 368 320 368a113 113 0 0 0 23.21-2.46zM320 112c98.65 0 189.09 55 237.93 144a285.53 285.53 0 0 1-44 60.2l37.74 29.5a333.7 333.7 0 0 0 52.9-75.11 32.35 32.35 0 0 0 0-29.19C550.29 135.59 442.93 64 320 64c-36.7 0-71.71 7-104.63 18.81l46.41 36.29c18.94-4.3 38.34-7.1 58.22-7.1zm0 288c-98.65 0-189.08-55-237.93-144a285.47 285.47 0 0 1 44.05-60.19l-37.74-29.5a333.6 333.6 0 0 0-52.89 75.1 32.35 32.35 0 0 0 0 29.19C89.72 376.41 197.08 448 320 448c36.7 0 71.71-7.05 104.63-18.81l-46.41-36.28C359.28 397.2 339.89 400 320 400z"
                }
            }
        ]
    })(props);
}
function FaRegEye(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M288 144a110.94 110.94 0 0 0-31.24 5 55.4 55.4 0 0 1 7.24 27 56 56 0 0 1-56 56 55.4 55.4 0 0 1-27-7.24A111.71 111.71 0 1 0 288 144zm284.52 97.4C518.29 135.59 410.93 64 288 64S57.68 135.64 3.48 241.41a32.35 32.35 0 0 0 0 29.19C57.71 376.41 165.07 448 288 448s230.32-71.64 284.52-177.41a32.35 32.35 0 0 0 0-29.19zM288 400c-98.65 0-189.09-55-237.93-144C98.91 167 189.34 112 288 112s189.09 55 237.93 144C477.1 345 386.66 400 288 400z"
                }
            }
        ]
    })(props);
}
function FaRegFileAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M288 248v28c0 6.6-5.4 12-12 12H108c-6.6 0-12-5.4-12-12v-28c0-6.6 5.4-12 12-12h168c6.6 0 12 5.4 12 12zm-12 72H108c-6.6 0-12 5.4-12 12v28c0 6.6 5.4 12 12 12h168c6.6 0 12-5.4 12-12v-28c0-6.6-5.4-12-12-12zm108-188.1V464c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V48C0 21.5 21.5 0 48 0h204.1C264.8 0 277 5.1 286 14.1L369.9 98c9 8.9 14.1 21.2 14.1 33.9zm-128-80V128h76.1L256 51.9zM336 464V176H232c-13.3 0-24-10.7-24-24V48H48v416h288z"
                }
            }
        ]
    })(props);
}
function FaRegFileArchive(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M128.3 160v32h32v-32zm64-96h-32v32h32zm-64 32v32h32V96zm64 32h-32v32h32zm177.6-30.1L286 14C277 5 264.8-.1 252.1-.1H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V131.9c0-12.7-5.1-25-14.1-34zM256 51.9l76.1 76.1H256zM336 464H48V48h79.7v16h32V48H208v104c0 13.3 10.7 24 24 24h104zM194.2 265.7c-1.1-5.6-6-9.7-11.8-9.7h-22.1v-32h-32v32l-19.7 97.1C102 385.6 126.8 416 160 416c33.1 0 57.9-30.2 51.5-62.6zm-33.9 124.4c-17.9 0-32.4-12.1-32.4-27s14.5-27 32.4-27 32.4 12.1 32.4 27-14.5 27-32.4 27zm32-198.1h-32v32h32z"
                }
            }
        ]
    })(props);
}
function FaRegFileAudio(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M369.941 97.941l-83.882-83.882A48 48 0 0 0 252.118 0H48C21.49 0 0 21.49 0 48v416c0 26.51 21.49 48 48 48h288c26.51 0 48-21.49 48-48V131.882a48 48 0 0 0-14.059-33.941zM332.118 128H256V51.882L332.118 128zM48 464V48h160v104c0 13.255 10.745 24 24 24h104v288H48zm144-76.024c0 10.691-12.926 16.045-20.485 8.485L136 360.486h-28c-6.627 0-12-5.373-12-12v-56c0-6.627 5.373-12 12-12h28l35.515-36.947c7.56-7.56 20.485-2.206 20.485 8.485v135.952zm41.201-47.13c9.051-9.297 9.06-24.133.001-33.439-22.149-22.752 12.235-56.246 34.395-33.481 27.198 27.94 27.212 72.444.001 100.401-21.793 22.386-56.947-10.315-34.397-33.481z"
                }
            }
        ]
    })(props);
}
function FaRegFileCode(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M149.9 349.1l-.2-.2-32.8-28.9 32.8-28.9c3.6-3.2 4-8.8.8-12.4l-.2-.2-17.4-18.6c-3.4-3.6-9-3.7-12.4-.4l-57.7 54.1c-3.7 3.5-3.7 9.4 0 12.8l57.7 54.1c1.6 1.5 3.8 2.4 6 2.4 2.4 0 4.8-1 6.4-2.8l17.4-18.6c3.3-3.5 3.1-9.1-.4-12.4zm220-251.2L286 14C277 5 264.8-.1 252.1-.1H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V131.9c0-12.7-5.1-25-14.1-34zM256 51.9l76.1 76.1H256zM336 464H48V48h160v104c0 13.3 10.7 24 24 24h104zM209.6 214c-4.7-1.4-9.5 1.3-10.9 6L144 408.1c-1.4 4.7 1.3 9.6 6 10.9l24.4 7.1c4.7 1.4 9.6-1.4 10.9-6L240 231.9c1.4-4.7-1.3-9.6-6-10.9zm24.5 76.9l.2.2 32.8 28.9-32.8 28.9c-3.6 3.2-4 8.8-.8 12.4l.2.2 17.4 18.6c3.3 3.5 8.9 3.7 12.4.4l57.7-54.1c3.7-3.5 3.7-9.4 0-12.8l-57.7-54.1c-3.5-3.3-9.1-3.2-12.4.4l-17.4 18.6c-3.3 3.5-3.1 9.1.4 12.4z"
                }
            }
        ]
    })(props);
}
function FaRegFileExcel(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M369.9 97.9L286 14C277 5 264.8-.1 252.1-.1H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V131.9c0-12.7-5.1-25-14.1-34zM332.1 128H256V51.9l76.1 76.1zM48 464V48h160v104c0 13.3 10.7 24 24 24h104v288H48zm212-240h-28.8c-4.4 0-8.4 2.4-10.5 6.3-18 33.1-22.2 42.4-28.6 57.7-13.9-29.1-6.9-17.3-28.6-57.7-2.1-3.9-6.2-6.3-10.6-6.3H124c-9.3 0-15 10-10.4 18l46.3 78-46.3 78c-4.7 8 1.1 18 10.4 18h28.9c4.4 0 8.4-2.4 10.5-6.3 21.7-40 23-45 28.6-57.7 14.9 30.2 5.9 15.9 28.6 57.7 2.1 3.9 6.2 6.3 10.6 6.3H260c9.3 0 15-10 10.4-18L224 320c.7-1.1 30.3-50.5 46.3-78 4.7-8-1.1-18-10.3-18z"
                }
            }
        ]
    })(props);
}
function FaRegFileImage(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M369.9 97.9L286 14C277 5 264.8-.1 252.1-.1H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V131.9c0-12.7-5.1-25-14.1-34zM332.1 128H256V51.9l76.1 76.1zM48 464V48h160v104c0 13.3 10.7 24 24 24h104v288H48zm32-48h224V288l-23.5-23.5c-4.7-4.7-12.3-4.7-17 0L176 352l-39.5-39.5c-4.7-4.7-12.3-4.7-17 0L80 352v64zm48-240c-26.5 0-48 21.5-48 48s21.5 48 48 48 48-21.5 48-48-21.5-48-48-48z"
                }
            }
        ]
    })(props);
}
function FaRegFilePdf(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M369.9 97.9L286 14C277 5 264.8-.1 252.1-.1H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V131.9c0-12.7-5.1-25-14.1-34zM332.1 128H256V51.9l76.1 76.1zM48 464V48h160v104c0 13.3 10.7 24 24 24h104v288H48zm250.2-143.7c-12.2-12-47-8.7-64.4-6.5-17.2-10.5-28.7-25-36.8-46.3 3.9-16.1 10.1-40.6 5.4-56-4.2-26.2-37.8-23.6-42.6-5.9-4.4 16.1-.4 38.5 7 67.1-10 23.9-24.9 56-35.4 74.4-20 10.3-47 26.2-51 46.2-3.3 15.8 26 55.2 76.1-31.2 22.4-7.4 46.8-16.5 68.4-20.1 18.9 10.2 41 17 55.8 17 25.5 0 28-28.2 17.5-38.7zm-198.1 77.8c5.1-13.7 24.5-29.5 30.4-35-19 30.3-30.4 35.7-30.4 35zm81.6-190.6c7.4 0 6.7 32.1 1.8 40.8-4.4-13.9-4.3-40.8-1.8-40.8zm-24.4 136.6c9.7-16.9 18-37 24.7-54.7 8.3 15.1 18.9 27.2 30.1 35.5-20.8 4.3-38.9 13.1-54.8 19.2zm131.6-5s-5 6-37.3-7.8c35.1-2.6 40.9 5.4 37.3 7.8z"
                }
            }
        ]
    })(props);
}
function FaRegFilePowerpoint(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M369.9 97.9L286 14C277 5 264.8-.1 252.1-.1H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V131.9c0-12.7-5.1-25-14.1-34zM332.1 128H256V51.9l76.1 76.1zM48 464V48h160v104c0 13.3 10.7 24 24 24h104v288H48zm72-60V236c0-6.6 5.4-12 12-12h69.2c36.7 0 62.8 27 62.8 66.3 0 74.3-68.7 66.5-95.5 66.5V404c0 6.6-5.4 12-12 12H132c-6.6 0-12-5.4-12-12zm48.5-87.4h23c7.9 0 13.9-2.4 18.1-7.2 8.5-9.8 8.4-28.5.1-37.8-4.1-4.6-9.9-7-17.4-7h-23.9v52z"
                }
            }
        ]
    })(props);
}
function FaRegFileVideo(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M369.941 97.941l-83.882-83.882A48 48 0 0 0 252.118 0H48C21.49 0 0 21.49 0 48v416c0 26.51 21.49 48 48 48h288c26.51 0 48-21.49 48-48V131.882a48 48 0 0 0-14.059-33.941zM332.118 128H256V51.882L332.118 128zM48 464V48h160v104c0 13.255 10.745 24 24 24h104v288H48zm228.687-211.303L224 305.374V268c0-11.046-8.954-20-20-20H100c-11.046 0-20 8.954-20 20v104c0 11.046 8.954 20 20 20h104c11.046 0 20-8.954 20-20v-37.374l52.687 52.674C286.704 397.318 304 390.28 304 375.986V264.011c0-14.311-17.309-21.319-27.313-11.314z"
                }
            }
        ]
    })(props);
}
function FaRegFileWord(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M369.9 97.9L286 14C277 5 264.8-.1 252.1-.1H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V131.9c0-12.7-5.1-25-14.1-34zM332.1 128H256V51.9l76.1 76.1zM48 464V48h160v104c0 13.3 10.7 24 24 24h104v288H48zm220.1-208c-5.7 0-10.6 4-11.7 9.5-20.6 97.7-20.4 95.4-21 103.5-.2-1.2-.4-2.6-.7-4.3-.8-5.1.3.2-23.6-99.5-1.3-5.4-6.1-9.2-11.7-9.2h-13.3c-5.5 0-10.3 3.8-11.7 9.1-24.4 99-24 96.2-24.8 103.7-.1-1.1-.2-2.5-.5-4.2-.7-5.2-14.1-73.3-19.1-99-1.1-5.6-6-9.7-11.8-9.7h-16.8c-7.8 0-13.5 7.3-11.7 14.8 8 32.6 26.7 109.5 33.2 136 1.3 5.4 6.1 9.1 11.7 9.1h25.2c5.5 0 10.3-3.7 11.6-9.1l17.9-71.4c1.5-6.2 2.5-12 3-17.3l2.9 17.3c.1.4 12.6 50.5 17.9 71.4 1.3 5.3 6.1 9.1 11.6 9.1h24.7c5.5 0 10.3-3.7 11.6-9.1 20.8-81.9 30.2-119 34.5-136 1.9-7.6-3.8-14.9-11.6-14.9h-15.8z"
                }
            }
        ]
    })(props);
}
function FaRegFile(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M369.9 97.9L286 14C277 5 264.8-.1 252.1-.1H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V131.9c0-12.7-5.1-25-14.1-34zM332.1 128H256V51.9l76.1 76.1zM48 464V48h160v104c0 13.3 10.7 24 24 24h104v288H48z"
                }
            }
        ]
    })(props);
}
function FaRegFlag(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M336.174 80c-49.132 0-93.305-32-161.913-32-31.301 0-58.303 6.482-80.721 15.168a48.04 48.04 0 0 0 2.142-20.727C93.067 19.575 74.167 1.594 51.201.104 23.242-1.71 0 20.431 0 48c0 17.764 9.657 33.262 24 41.562V496c0 8.837 7.163 16 16 16h16c8.837 0 16-7.163 16-16v-83.443C109.869 395.28 143.259 384 199.826 384c49.132 0 93.305 32 161.913 32 58.479 0 101.972-22.617 128.548-39.981C503.846 367.161 512 352.051 512 335.855V95.937c0-34.459-35.264-57.768-66.904-44.117C409.193 67.309 371.641 80 336.174 80zM464 336c-21.783 15.412-60.824 32-102.261 32-59.945 0-102.002-32-161.913-32-43.361 0-96.379 9.403-127.826 24V128c21.784-15.412 60.824-32 102.261-32 59.945 0 102.002 32 161.913 32 43.271 0 96.32-17.366 127.826-32v240z"
                }
            }
        ]
    })(props);
}
function FaRegFlushed(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 448c-110.3 0-200-89.7-200-200S137.7 56 248 56s200 89.7 200 200-89.7 200-200 200zm96-312c-44.2 0-80 35.8-80 80s35.8 80 80 80 80-35.8 80-80-35.8-80-80-80zm0 128c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48zm0-72c-13.3 0-24 10.7-24 24s10.7 24 24 24 24-10.7 24-24-10.7-24-24-24zm-112 24c0-44.2-35.8-80-80-80s-80 35.8-80 80 35.8 80 80 80 80-35.8 80-80zm-80 48c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48zm0-72c-13.3 0-24 10.7-24 24s10.7 24 24 24 24-10.7 24-24-10.7-24-24-24zm160 144H184c-13.2 0-24 10.8-24 24s10.8 24 24 24h128c13.2 0 24-10.8 24-24s-10.8-24-24-24z"
                }
            }
        ]
    })(props);
}
function FaRegFolderOpen(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M527.9 224H480v-48c0-26.5-21.5-48-48-48H272l-64-64H48C21.5 64 0 85.5 0 112v288c0 26.5 21.5 48 48 48h400c16.5 0 31.9-8.5 40.7-22.6l79.9-128c20-31.9-3-73.4-40.7-73.4zM48 118c0-3.3 2.7-6 6-6h134.1l64 64H426c3.3 0 6 2.7 6 6v42H152c-16.8 0-32.4 8.8-41.1 23.2L48 351.4zm400 282H72l77.2-128H528z"
                }
            }
        ]
    })(props);
}
function FaRegFolder(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M464 128H272l-54.63-54.63c-6-6-14.14-9.37-22.63-9.37H48C21.49 64 0 85.49 0 112v288c0 26.51 21.49 48 48 48h416c26.51 0 48-21.49 48-48V176c0-26.51-21.49-48-48-48zm0 272H48V112h140.12l54.63 54.63c6 6 14.14 9.37 22.63 9.37H464v224z"
                }
            }
        ]
    })(props);
}
function FaRegFontAwesomeLogoFull(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 3992 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M454.6 0H57.4C25.9 0 0 25.9 0 57.4v397.3C0 486.1 25.9 512 57.4 512h397.3c31.4 0 57.4-25.9 57.4-57.4V57.4C512 25.9 486.1 0 454.6 0zm-58.9 324.9c0 4.8-4.1 6.9-8.9 8.9-19.2 8.1-39.7 15.7-61.5 15.7-40.5 0-68.7-44.8-163.2 2.5v51.8c0 30.3-45.7 30.2-45.7 0v-250c-9-7-15-17.9-15-30.3 0-21 17.1-38.2 38.2-38.2 21 0 38.2 17.1 38.2 38.2 0 12.2-5.8 23.2-14.9 30.2v21c37.1-12 65.5-34.4 146.1-3.4 26.6 11.4 68.7-15.7 76.5-15.7 5.5 0 10.3 4.1 10.3 8.9v160.4zm432.9-174.2h-137v70.1H825c39.8 0 40.4 62.2 0 62.2H691.6v105.6c0 45.5-70.7 46.4-70.7 0V128.3c0-22 18-39.8 39.8-39.8h167.8c39.6 0 40.5 62.2.1 62.2zm191.1 23.4c-169.3 0-169.1 252.4 0 252.4 169.9 0 169.9-252.4 0-252.4zm0 196.1c-81.6 0-82.1-139.8 0-139.8 82.5 0 82.4 139.8 0 139.8zm372.4 53.4c-17.5 0-31.4-13.9-31.4-31.4v-117c0-62.4-72.6-52.5-99.1-16.4v133.4c0 41.5-63.3 41.8-63.3 0V208c0-40 63.1-41.6 63.1 0v3.4c43.3-51.6 162.4-60.4 162.4 39.3v141.5c.3 30.4-31.5 31.4-31.7 31.4zm179.7 2.9c-44.3 0-68.3-22.9-68.3-65.8V235.2H1488c-35.6 0-36.7-55.3 0-55.3h15.5v-37.3c0-41.3 63.8-42.1 63.8 0v37.5h24.9c35.4 0 35.7 55.3 0 55.3h-24.9v108.5c0 29.6 26.1 26.3 27.4 26.3 31.4 0 52.6 56.3-22.9 56.3zM1992 123c-19.5-50.2-95.5-50-114.5 0-107.3 275.7-99.5 252.7-99.5 262.8 0 42.8 58.3 51.2 72.1 14.4l13.5-35.9H2006l13 35.9c14.2 37.7 72.1 27.2 72.1-14.4 0-10.1 5.3 6.8-99.1-262.8zm-108.9 179.1l51.7-142.9 51.8 142.9h-103.5zm591.3-85.6l-53.7 176.3c-12.4 41.2-72 41-84 0l-42.3-135.9-42.3 135.9c-12.4 40.9-72 41.2-84.5 0l-54.2-176.3c-12.5-39.4 49.8-56.1 60.2-16.9L2213 342l45.3-139.5c10.9-32.7 59.6-34.7 71.2 0l45.3 139.5 39.3-142.4c10.3-38.3 72.6-23.8 60.3 16.9zm275.4 75.1c0-42.4-33.9-117.5-119.5-117.5-73.2 0-124.4 56.3-124.4 126 0 77.2 55.3 126.4 128.5 126.4 31.7 0 93-11.5 93-39.8 0-18.3-21.1-31.5-39.3-22.4-49.4 26.2-109 8.4-115.9-43.8h148.3c16.3 0 29.3-13.4 29.3-28.9zM2571 277.7c9.5-73.4 113.9-68.6 118.6 0H2571zm316.7 148.8c-31.4 0-81.6-10.5-96.6-31.9-12.4-17 2.5-39.8 21.8-39.8 16.3 0 36.8 22.9 77.7 22.9 27.4 0 40.4-11 40.4-25.8 0-39.8-142.9-7.4-142.9-102 0-40.4 35.3-75.7 98.6-75.7 31.4 0 74.1 9.9 87.6 29.4 10.8 14.8-1.4 36.2-20.9 36.2-15.1 0-26.7-17.3-66.2-17.3-22.9 0-37.8 10.5-37.8 23.8 0 35.9 142.4 6 142.4 103.1-.1 43.7-37.4 77.1-104.1 77.1zm266.8-252.4c-169.3 0-169.1 252.4 0 252.4 170.1 0 169.6-252.4 0-252.4zm0 196.1c-81.8 0-82-139.8 0-139.8 82.5 0 82.4 139.8 0 139.8zm476.9 22V268.7c0-53.8-61.4-45.8-85.7-10.5v134c0 41.3-63.8 42.1-63.8 0V268.7c0-52.1-59.5-47.4-85.7-10.1v133.6c0 41.5-63.3 41.8-63.3 0V208c0-40 63.1-41.6 63.1 0v3.4c9.9-14.4 41.8-37.3 78.6-37.3 35.3 0 57.7 16.4 66.7 43.8 13.9-21.8 45.8-43.8 82.6-43.8 44.3 0 70.7 23.4 70.7 72.7v145.3c.5 17.3-13.5 31.4-31.9 31.4 3.5.1-31.3 1.1-31.3-31.3zM3992 291.6c0-42.4-32.4-117.5-117.9-117.5-73.2 0-127.5 56.3-127.5 126 0 77.2 58.3 126.4 131.6 126.4 31.7 0 91.5-11.5 91.5-39.8 0-18.3-21.1-31.5-39.3-22.4-49.4 26.2-110.5 8.4-117.5-43.8h149.8c16.3 0 29.1-13.4 29.3-28.9zm-180.5-13.9c9.7-74.4 115.9-68.3 120.1 0h-120.1z"
                }
            }
        ]
    })(props);
}
function FaRegFrownOpen(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 448c-110.3 0-200-89.7-200-200S137.7 56 248 56s200 89.7 200 200-89.7 200-200 200zm-48-248c0-17.7-14.3-32-32-32s-32 14.3-32 32 14.3 32 32 32 32-14.3 32-32zm128-32c-17.7 0-32 14.3-32 32s14.3 32 32 32 32-14.3 32-32-14.3-32-32-32zm-80 112c-35.6 0-88.8 21.3-95.8 61.2-2 11.8 9 21.5 20.5 18.1 31.2-9.6 59.4-15.3 75.3-15.3s44.1 5.7 75.3 15.3c11.4 3.5 22.5-6.3 20.5-18.1-7-39.9-60.2-61.2-95.8-61.2z"
                }
            }
        ]
    })(props);
}
function FaRegFrown(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 448c-110.3 0-200-89.7-200-200S137.7 56 248 56s200 89.7 200 200-89.7 200-200 200zm-80-216c17.7 0 32-14.3 32-32s-14.3-32-32-32-32 14.3-32 32 14.3 32 32 32zm160-64c-17.7 0-32 14.3-32 32s14.3 32 32 32 32-14.3 32-32-14.3-32-32-32zm-80 128c-40.2 0-78 17.7-103.8 48.6-8.5 10.2-7.1 25.3 3.1 33.8 10.2 8.4 25.3 7.1 33.8-3.1 16.6-19.9 41-31.4 66.9-31.4s50.3 11.4 66.9 31.4c8.1 9.7 23.1 11.9 33.8 3.1 10.2-8.5 11.5-23.6 3.1-33.8C326 321.7 288.2 304 248 304z"
                }
            }
        ]
    })(props);
}
function FaRegFutbol(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M483.8 179.4C449.8 74.6 352.6 8 248.1 8c-25.4 0-51.2 3.9-76.7 12.2C41.2 62.5-30.1 202.4 12.2 332.6 46.2 437.4 143.4 504 247.9 504c25.4 0 51.2-3.9 76.7-12.2 130.2-42.3 201.5-182.2 159.2-312.4zm-74.5 193.7l-52.2 6.4-43.7-60.9 24.4-75.2 71.1-22.1 38.9 36.4c-.2 30.7-7.4 61.1-21.7 89.2-4.7 9.3-10.7 17.8-16.8 26.2zm0-235.4l-10.4 53.1-70.7 22-64.2-46.5V92.5l47.4-26.2c39.2 13 73.4 38 97.9 71.4zM184.9 66.4L232 92.5v73.8l-64.2 46.5-70.6-22-10.1-52.5c24.3-33.4 57.9-58.6 97.8-71.9zM139 379.5L85.9 373c-14.4-20.1-37.3-59.6-37.8-115.3l39-36.4 71.1 22.2 24.3 74.3-43.5 61.7zm48.2 67l-22.4-48.1 43.6-61.7H287l44.3 61.7-22.4 48.1c-6.2 1.8-57.6 20.4-121.7 0z"
                }
            }
        ]
    })(props);
}
function FaRegGem(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M464 0H112c-4 0-7.8 2-10 5.4L2 152.6c-2.9 4.4-2.6 10.2.7 14.2l276 340.8c4.8 5.9 13.8 5.9 18.6 0l276-340.8c3.3-4.1 3.6-9.8.7-14.2L474.1 5.4C471.8 2 468.1 0 464 0zm-19.3 48l63.3 96h-68.4l-51.7-96h56.8zm-202.1 0h90.7l51.7 96H191l51.6-96zm-111.3 0h56.8l-51.7 96H68l63.3-96zm-43 144h51.4L208 352 88.3 192zm102.9 0h193.6L288 435.3 191.2 192zM368 352l68.2-160h51.4L368 352z"
                }
            }
        ]
    })(props);
}
function FaRegGrimace(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 448c-110.3 0-200-89.7-200-200S137.7 56 248 56s200 89.7 200 200-89.7 200-200 200zm-80-216c17.7 0 32-14.3 32-32s-14.3-32-32-32-32 14.3-32 32 14.3 32 32 32zm160 0c17.7 0 32-14.3 32-32s-14.3-32-32-32-32 14.3-32 32 14.3 32 32 32zm16 16H152c-26.5 0-48 21.5-48 48v32c0 26.5 21.5 48 48 48h192c26.5 0 48-21.5 48-48v-32c0-26.5-21.5-48-48-48zm-168 96h-24c-8.8 0-16-7.2-16-16v-8h40v24zm0-40h-40v-8c0-8.8 7.2-16 16-16h24v24zm64 40h-48v-24h48v24zm0-40h-48v-24h48v24zm64 40h-48v-24h48v24zm0-40h-48v-24h48v24zm56 24c0 8.8-7.2 16-16 16h-24v-24h40v8zm0-24h-40v-24h24c8.8 0 16 7.2 16 16v8z"
                }
            }
        ]
    })(props);
}
function FaRegGrinAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M200.3 248c12.4-18.7 15.1-37.3 15.7-56-.5-18.7-3.3-37.3-15.7-56-8-12-25.1-11.4-32.7 0-12.4 18.7-15.1 37.3-15.7 56 .5 18.7 3.3 37.3 15.7 56 8.1 12 25.2 11.4 32.7 0zm128 0c12.4-18.7 15.1-37.3 15.7-56-.5-18.7-3.3-37.3-15.7-56-8-12-25.1-11.4-32.7 0-12.4 18.7-15.1 37.3-15.7 56 .5 18.7 3.3 37.3 15.7 56 8.1 12 25.2 11.4 32.7 0zM248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 448c-110.3 0-200-89.7-200-200S137.7 56 248 56s200 89.7 200 200-89.7 200-200 200zm105.6-151.4c-25.9 8.3-64.4 13.1-105.6 13.1s-79.6-4.8-105.6-13.1c-9.9-3.1-19.4 5.3-17.7 15.3 7.9 47.2 71.3 80 123.3 80s115.3-32.9 123.3-80c1.6-9.8-7.7-18.4-17.7-15.3z"
                }
            }
        ]
    })(props);
}
function FaRegGrinBeamSweat(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M440 160c29.5 0 53.3-26.3 53.3-58.7 0-25-31.7-75.5-46.2-97.3-3.6-5.3-10.7-5.3-14.2 0-14.5 21.8-46.2 72.3-46.2 97.3 0 32.4 23.8 58.7 53.3 58.7zM248 400c51.9 0 115.3-32.9 123.3-80 1.7-9.9-7.7-18.5-17.7-15.3-25.9 8.3-64.4 13.1-105.6 13.1s-79.6-4.8-105.6-13.1c-9.8-3.1-19.4 5.3-17.7 15.3 8 47.1 71.4 80 123.3 80zm130.3-168.3c3.6-1.1 6-4.5 5.7-8.3-3.3-42.1-32.2-71.4-56-71.4s-52.7 29.3-56 71.4c-.3 3.7 2.1 7.2 5.7 8.3 3.5 1.1 7.4-.5 9.3-3.7l9.5-17c7.7-13.7 19.2-21.6 31.5-21.6s23.8 7.9 31.5 21.6l9.5 17c2.1 3.6 6.2 4.6 9.3 3.7zm105.3-52.9c-24.6 15.7-46 12.9-46.4 12.9 6.9 20.2 10.8 41.8 10.8 64.3 0 110.3-89.7 200-200 200S48 366.3 48 256 137.7 56 248 56c39.8 0 76.8 11.8 108 31.9 1.7-9.5 6.3-24.1 17.2-45.7C336.4 20.6 293.7 8 248 8 111 8 0 119 0 256s111 248 248 248 248-111 248-248c0-27-4.4-52.9-12.4-77.2zM168 189.4c12.3 0 23.8 7.9 31.5 21.6l9.5 17c2.1 3.7 6.2 4.7 9.3 3.7 3.6-1.1 6-4.5 5.7-8.3-3.3-42.1-32.2-71.4-56-71.4s-52.7 29.3-56 71.4c-.3 3.7 2.1 7.2 5.7 8.3 3.5 1.1 7.4-.5 9.3-3.7l9.5-17c7.7-13.8 19.2-21.6 31.5-21.6z"
                }
            }
        ]
    })(props);
}
function FaRegGrinBeam(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 448c-110.3 0-200-89.7-200-200S137.7 56 248 56s200 89.7 200 200-89.7 200-200 200zm105.6-151.4c-25.9 8.3-64.4 13.1-105.6 13.1s-79.6-4.8-105.6-13.1c-9.8-3.1-19.4 5.3-17.7 15.3 7.9 47.1 71.3 80 123.3 80s115.3-32.9 123.3-80c1.6-9.8-7.7-18.4-17.7-15.3zm-235.9-72.9c3.5 1.1 7.4-.5 9.3-3.7l9.5-17c7.7-13.7 19.2-21.6 31.5-21.6s23.8 7.9 31.5 21.6l9.5 17c2.1 3.7 6.2 4.7 9.3 3.7 3.6-1.1 6-4.5 5.7-8.3-3.3-42.1-32.2-71.4-56-71.4s-52.7 29.3-56 71.4c-.3 3.7 2.1 7.2 5.7 8.3zm160 0c3.5 1.1 7.4-.5 9.3-3.7l9.5-17c7.7-13.7 19.2-21.6 31.5-21.6s23.8 7.9 31.5 21.6l9.5 17c2.1 3.7 6.2 4.7 9.3 3.7 3.6-1.1 6-4.5 5.7-8.3-3.3-42.1-32.2-71.4-56-71.4s-52.7 29.3-56 71.4c-.3 3.7 2.1 7.2 5.7 8.3z"
                }
            }
        ]
    })(props);
}
function FaRegGrinHearts(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M353.6 304.6c-25.9 8.3-64.4 13.1-105.6 13.1s-79.6-4.8-105.6-13.1c-9.8-3.1-19.4 5.3-17.7 15.3 7.9 47.2 71.3 80 123.3 80s115.3-32.9 123.3-80c1.6-9.8-7.7-18.4-17.7-15.3zm-152.8-48.9c4.5 1.2 9.2-1.5 10.5-6l19.4-69.9c5.6-20.3-7.4-41.1-28.8-44.5-18.6-3-36.4 9.8-41.5 27.9l-2 7.1-7.1-1.9c-18.2-4.7-38.2 4.3-44.9 22-7.7 20.2 3.8 41.9 24.2 47.2l70.2 18.1zm188.8-65.3c-6.7-17.6-26.7-26.7-44.9-22l-7.1 1.9-2-7.1c-5-18.1-22.8-30.9-41.5-27.9-21.4 3.4-34.4 24.2-28.8 44.5l19.4 69.9c1.2 4.5 5.9 7.2 10.5 6l70.2-18.2c20.4-5.3 31.9-26.9 24.2-47.1zM248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 448c-110.3 0-200-89.7-200-200S137.7 56 248 56s200 89.7 200 200-89.7 200-200 200z"
                }
            }
        ]
    })(props);
}
function FaRegGrinSquintTears(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M117.1 384.1c-25.8 3.7-84 13.7-100.9 30.6-21.9 21.9-21.5 57.9.9 80.3s58.3 22.8 80.3.9C114.3 479 124.3 420.8 128 395c.8-6.4-4.6-11.8-10.9-10.9zm-41.2-41.7C40.3 268 53 176.1 114.6 114.6 152.4 76.8 202.6 56 256 56c36.2 0 70.8 9.8 101.2 27.7 3.8-20.3 8-36.1 12-48.3C333.8 17.2 294.9 8 256 8 192.5 8 129.1 32.2 80.6 80.6c-74.1 74.1-91.3 183.4-52 274 12.2-4.1 27.7-8.3 47.3-12.2zm352.3-187.6c45 76.6 34.9 176.9-30.8 242.6-37.8 37.8-88 58.6-141.4 58.6-30.5 0-59.8-7-86.4-19.8-3.9 19.5-8 35-12.2 47.2 31.4 13.6 65 20.6 98.7 20.6 63.5 0 126.9-24.2 175.4-72.6 78.1-78.1 93.1-195.4 45.2-288.6-12.3 4-28.2 8.1-48.5 12zm-33.3-26.9c25.8-3.7 84-13.7 100.9-30.6 21.9-21.9 21.5-57.9-.9-80.3s-58.3-22.8-80.3-.9C397.7 33 387.7 91.2 384 117c-.8 6.4 4.6 11.8 10.9 10.9zm-187 108.3c-3-3-7.2-4.2-11.4-3.2L106 255.7c-5.7 1.4-9.5 6.7-9.1 12.6.5 5.8 5.1 10.5 10.9 11l52.3 4.8 4.8 52.3c.5 5.8 5.2 10.4 11 10.9h.9c5.5 0 10.3-3.7 11.7-9.1l22.6-90.5c1-4.2-.2-8.5-3.2-11.5zm39.7-25.1l90.5-22.6c5.7-1.4 9.5-6.7 9.1-12.6-.5-5.8-5.1-10.5-10.9-11l-52.3-4.8-4.8-52.3c-.5-5.8-5.2-10.4-11-10.9-5.6-.1-11.2 3.4-12.6 9.1L233 196.5c-1 4.1.2 8.4 3.2 11.4 5 5 11.3 3.2 11.4 3.2zm52 88.5c-29.1 29.1-59.7 52.9-83.9 65.4-9.2 4.8-10 17.5-1.7 23.4 38.9 27.7 107 6.2 143.7-30.6S416 253 388.3 214.1c-5.8-8.2-18.5-7.6-23.4 1.7-12.3 24.2-36.2 54.7-65.3 83.8z"
                }
            }
        ]
    })(props);
}
function FaRegGrinSquint(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 448c-110.3 0-200-89.7-200-200S137.7 56 248 56s200 89.7 200 200-89.7 200-200 200zm105.6-151.4c-25.9 8.3-64.4 13.1-105.6 13.1s-79.6-4.8-105.6-13.1c-9.9-3.1-19.4 5.4-17.7 15.3 7.9 47.1 71.3 80 123.3 80s115.3-32.9 123.3-80c1.6-9.8-7.7-18.4-17.7-15.3zm-234.7-40.8c3.6 4.2 9.9 5.7 15.3 2.5l80-48c3.6-2.2 5.8-6.1 5.8-10.3s-2.2-8.1-5.8-10.3l-80-48c-5.1-3-11.4-1.9-15.3 2.5-3.8 4.5-3.8 11-.1 15.5l33.6 40.3-33.6 40.3c-3.8 4.5-3.7 11.1.1 15.5zm242.9 2.5c5.4 3.2 11.7 1.7 15.3-2.5 3.8-4.5 3.8-11 .1-15.5L343.6 208l33.6-40.3c3.8-4.5 3.7-11-.1-15.5-3.8-4.4-10.2-5.4-15.3-2.5l-80 48c-3.6 2.2-5.8 6.1-5.8 10.3s2.2 8.1 5.8 10.3l80 48z"
                }
            }
        ]
    })(props);
}
function FaRegGrinStars(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 448c-110.3 0-200-89.7-200-200S137.7 56 248 56s200 89.7 200 200-89.7 200-200 200zm105.6-151.4c-25.9 8.3-64.4 13.1-105.6 13.1s-79.6-4.8-105.6-13.1c-9.8-3.1-19.4 5.3-17.7 15.3 7.9 47.2 71.3 80 123.3 80s115.3-32.9 123.3-80c1.6-9.8-7.7-18.4-17.7-15.3zm-227.9-57.5c-1 6.2 5.4 11 11 7.9l31.3-16.3 31.3 16.3c5.6 3.1 12-1.7 11-7.9l-6-34.9 25.4-24.6c4.5-4.5 1.9-12.2-4.3-13.2l-34.9-5-15.5-31.6c-2.9-5.8-11-5.8-13.9 0l-15.5 31.6-34.9 5c-6.2.9-8.9 8.6-4.3 13.2l25.4 24.6-6.1 34.9zm259.7-72.7l-34.9-5-15.5-31.6c-2.9-5.8-11-5.8-13.9 0l-15.5 31.6-34.9 5c-6.2.9-8.9 8.6-4.3 13.2l25.4 24.6-6 34.9c-1 6.2 5.4 11 11 7.9l31.3-16.3 31.3 16.3c5.6 3.1 12-1.7 11-7.9l-6-34.9 25.4-24.6c4.5-4.6 1.8-12.2-4.4-13.2z"
                }
            }
        ]
    })(props);
}
function FaRegGrinTears(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M117.1 256.1c-25.8 3.7-84 13.7-100.9 30.6-21.9 21.9-21.5 57.9.9 80.3s58.3 22.8 80.3.9C114.3 351 124.3 292.8 128 267c.8-6.4-4.6-11.8-10.9-10.9zm506.7 30.6c-16.9-16.9-75.1-26.9-100.9-30.6-6.3-.9-11.7 4.5-10.8 10.8 3.7 25.8 13.7 84 30.6 100.9 21.9 21.9 57.9 21.5 80.3-.9 22.3-22.3 22.7-58.3.8-80.2zm-126.6 61.7C463.8 412.3 396.9 456 320 456c-76.9 0-143.8-43.7-177.2-107.6-12.5 37.4-25.2 43.9-28.3 46.5C159.1 460.7 234.5 504 320 504s160.9-43.3 205.5-109.1c-3.2-2.7-15.9-9.2-28.3-46.5zM122.7 224.5C137.9 129.2 220.5 56 320 56c99.5 0 182.1 73.2 197.3 168.5 2.1-.2 5.2-2.4 49.5 7C554.4 106 448.7 8 320 8S85.6 106 73.2 231.4c44.5-9.4 47.1-7.2 49.5-6.9zM320 400c51.9 0 115.3-32.9 123.3-80 1.7-9.9-7.7-18.5-17.7-15.3-25.9 8.3-64.4 13.1-105.6 13.1s-79.6-4.8-105.6-13.1c-9.8-3.1-19.4 5.3-17.7 15.3 8 47.1 71.4 80 123.3 80zm130.3-168.3c3.6-1.1 6-4.5 5.7-8.3-3.3-42.1-32.2-71.4-56-71.4s-52.7 29.3-56 71.4c-.3 3.7 2.1 7.2 5.7 8.3 3.5 1.1 7.4-.5 9.3-3.7l9.5-17c7.7-13.7 19.2-21.6 31.5-21.6s23.8 7.9 31.5 21.6l9.5 17c2.1 3.6 6.2 4.6 9.3 3.7zM240 189.4c12.3 0 23.8 7.9 31.5 21.6l9.5 17c2.1 3.7 6.2 4.7 9.3 3.7 3.6-1.1 6-4.5 5.7-8.3-3.3-42.1-32.2-71.4-56-71.4s-52.7 29.3-56 71.4c-.3 3.7 2.1 7.2 5.7 8.3 3.5 1.1 7.4-.5 9.3-3.7l9.5-17c7.7-13.8 19.2-21.6 31.5-21.6z"
                }
            }
        ]
    })(props);
}
function FaRegGrinTongueSquint(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm64 400c0 35.6-29.1 64.5-64.9 64-35.1-.5-63.1-29.8-63.1-65v-42.8l17.7-8.8c15-7.5 31.5 1.7 34.9 16.5l2.8 12.1c2.1 9.2 15.2 9.2 17.3 0l2.8-12.1c3.4-14.8 19.8-24.1 34.9-16.5l17.7 8.8V408zm28.2 25.3c2.2-8.1 3.8-16.5 3.8-25.3v-43.5c14.2-12.4 24.4-27.5 27.3-44.5 1.7-9.9-7.7-18.5-17.7-15.3-25.9 8.3-64.4 13.1-105.6 13.1s-79.6-4.8-105.6-13.1c-9.9-3.1-19.4 5.3-17.7 15.3 2.9 17 13.1 32.1 27.3 44.5V408c0 8.8 1.6 17.2 3.8 25.3C91.8 399.9 48 333 48 256c0-110.3 89.7-200 200-200s200 89.7 200 200c0 77-43.8 143.9-107.8 177.3zm36.9-281.1c-3.8-4.4-10.3-5.5-15.3-2.5l-80 48c-3.6 2.2-5.8 6.1-5.8 10.3s2.2 8.1 5.8 10.3l80 48c5.4 3.2 11.7 1.7 15.3-2.5 3.8-4.5 3.8-11 .1-15.5L343.6 208l33.6-40.3c3.8-4.5 3.7-11.1-.1-15.5zm-162.9 45.5l-80-48c-5-3-11.4-2-15.3 2.5-3.8 4.5-3.8 11-.1 15.5l33.6 40.3-33.6 40.3c-3.8 4.5-3.7 11 .1 15.5 3.6 4.2 9.9 5.7 15.3 2.5l80-48c3.6-2.2 5.8-6.1 5.8-10.3s-2.2-8.1-5.8-10.3z"
                }
            }
        ]
    })(props);
}
function FaRegGrinTongueWink(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M152 180c-25.7 0-55.9 16.9-59.8 42.1-.8 5 1.7 10 6.1 12.4 4.4 2.4 9.9 1.8 13.7-1.6l9.5-8.5c14.8-13.2 46.2-13.2 61 0l9.5 8.5c2.5 2.2 8 4.7 13.7 1.6 4.4-2.4 6.9-7.4 6.1-12.4-3.9-25.2-34.1-42.1-59.8-42.1zm176-52c-44.2 0-80 35.8-80 80s35.8 80 80 80 80-35.8 80-80-35.8-80-80-80zm0 128c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48zm0-72c-13.3 0-24 10.7-24 24s10.7 24 24 24 24-10.7 24-24-10.7-24-24-24zM248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm64 400c0 35.6-29.1 64.5-64.9 64-35.1-.5-63.1-29.8-63.1-65v-42.8l17.7-8.8c15-7.5 31.5 1.7 34.9 16.5l2.8 12.1c2.1 9.2 15.2 9.2 17.3 0l2.8-12.1c3.4-14.8 19.8-24.1 34.9-16.5l17.7 8.8V408zm28.2 25.3c2.2-8.1 3.8-16.5 3.8-25.3v-43.5c14.2-12.4 24.4-27.5 27.3-44.5 1.7-9.9-7.7-18.5-17.7-15.3-25.9 8.3-64.4 13.1-105.6 13.1s-79.6-4.8-105.6-13.1c-9.9-3.1-19.4 5.3-17.7 15.3 2.9 17 13.1 32.1 27.3 44.5V408c0 8.8 1.6 17.2 3.8 25.3C91.8 399.9 48 333 48 256c0-110.3 89.7-200 200-200s200 89.7 200 200c0 77-43.8 143.9-107.8 177.3z"
                }
            }
        ]
    })(props);
}
function FaRegGrinTongue(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm64 400c0 35.6-29.1 64.5-64.9 64-35.1-.5-63.1-29.8-63.1-65v-42.8l17.7-8.8c15-7.5 31.5 1.7 34.9 16.5l2.8 12.1c2.1 9.2 15.2 9.2 17.3 0l2.8-12.1c3.4-14.8 19.8-24.1 34.9-16.5l17.7 8.8V408zm28.2 25.3c2.2-8.1 3.8-16.5 3.8-25.3v-43.5c14.2-12.4 24.4-27.5 27.3-44.5 1.7-9.9-7.7-18.5-17.7-15.3-25.9 8.3-64.4 13.1-105.6 13.1s-79.6-4.8-105.6-13.1c-9.9-3.1-19.4 5.3-17.7 15.3 2.9 17 13.1 32.1 27.3 44.5V408c0 8.8 1.6 17.2 3.8 25.3C91.8 399.9 48 333 48 256c0-110.3 89.7-200 200-200s200 89.7 200 200c0 77-43.8 143.9-107.8 177.3zM168 176c-17.7 0-32 14.3-32 32s14.3 32 32 32 32-14.3 32-32-14.3-32-32-32zm160 0c-17.7 0-32 14.3-32 32s14.3 32 32 32 32-14.3 32-32-14.3-32-32-32z"
                }
            }
        ]
    })(props);
}
function FaRegGrinWink(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M328 180c-25.69 0-55.88 16.92-59.86 42.12-1.75 11.22 11.5 18.24 19.83 10.84l9.55-8.48c14.81-13.19 46.16-13.19 60.97 0l9.55 8.48c8.48 7.43 21.56.25 19.83-10.84C383.88 196.92 353.69 180 328 180zm-160 60c17.67 0 32-14.33 32-32s-14.33-32-32-32-32 14.33-32 32 14.33 32 32 32zm185.55 64.64c-25.93 8.3-64.4 13.06-105.55 13.06s-79.62-4.75-105.55-13.06c-9.94-3.13-19.4 5.37-17.71 15.34C132.67 367.13 196.06 400 248 400s115.33-32.87 123.26-80.02c1.68-9.89-7.67-18.48-17.71-15.34zM248 8C111.03 8 0 119.03 0 256s111.03 248 248 248 248-111.03 248-248S384.97 8 248 8zm0 448c-110.28 0-200-89.72-200-200S137.72 56 248 56s200 89.72 200 200-89.72 200-200 200z"
                }
            }
        ]
    })(props);
}
function FaRegGrin(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 448c-110.3 0-200-89.7-200-200S137.7 56 248 56s200 89.7 200 200-89.7 200-200 200zm105.6-151.4c-25.9 8.3-64.4 13.1-105.6 13.1s-79.6-4.8-105.6-13.1c-9.9-3.1-19.4 5.4-17.7 15.3 7.9 47.1 71.3 80 123.3 80s115.3-32.9 123.3-80c1.6-9.8-7.7-18.4-17.7-15.3zM168 240c17.7 0 32-14.3 32-32s-14.3-32-32-32-32 14.3-32 32 14.3 32 32 32zm160 0c17.7 0 32-14.3 32-32s-14.3-32-32-32-32 14.3-32 32 14.3 32 32 32z"
                }
            }
        ]
    })(props);
}
function FaRegHandLizard(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M556.686 290.542L410.328 64.829C397.001 44.272 374.417 32 349.917 32H56C25.121 32 0 57.122 0 88v8c0 44.112 35.888 80 80 80h196.042l-18.333 48H144c-48.523 0-88 39.477-88 88 0 30.879 25.121 56 56 56h131.552c2.987 0 5.914.549 8.697 1.631L352 408.418V480h224V355.829c0-23.225-6.679-45.801-19.314-65.287zM528 432H400v-23.582c0-19.948-12.014-37.508-30.604-44.736l-99.751-38.788A71.733 71.733 0 0 0 243.552 320H112c-4.411 0-8-3.589-8-8 0-22.056 17.944-40 40-40h113.709c19.767 0 37.786-12.407 44.84-30.873l24.552-64.281c8.996-23.553-8.428-48.846-33.63-48.846H80c-17.645 0-32-14.355-32-32v-8c0-4.411 3.589-8 8-8h293.917c8.166 0 15.693 4.09 20.137 10.942l146.358 225.715A71.84 71.84 0 0 1 528 355.829V432z"
                }
            }
        ]
    })(props);
}
function FaRegHandPaper(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M372.57 112.641v-10.825c0-43.612-40.52-76.691-83.039-65.546-25.629-49.5-94.09-47.45-117.982.747C130.269 26.456 89.144 57.945 89.144 102v126.13c-19.953-7.427-43.308-5.068-62.083 8.871-29.355 21.796-35.794 63.333-14.55 93.153L132.48 498.569a32 32 0 0 0 26.062 13.432h222.897c14.904 0 27.835-10.289 31.182-24.813l30.184-130.958A203.637 203.637 0 0 0 448 310.564V179c0-40.62-35.523-71.992-75.43-66.359zm27.427 197.922c0 11.731-1.334 23.469-3.965 34.886L368.707 464h-201.92L51.591 302.303c-14.439-20.27 15.023-42.776 29.394-22.605l27.128 38.079c8.995 12.626 29.031 6.287 29.031-9.283V102c0-25.645 36.571-24.81 36.571.691V256c0 8.837 7.163 16 16 16h6.856c8.837 0 16-7.163 16-16V67c0-25.663 36.571-24.81 36.571.691V256c0 8.837 7.163 16 16 16h6.856c8.837 0 16-7.163 16-16V101.125c0-25.672 36.57-24.81 36.57.691V256c0 8.837 7.163 16 16 16h6.857c8.837 0 16-7.163 16-16v-76.309c0-26.242 36.57-25.64 36.57-.691v131.563z"
                }
            }
        ]
    })(props);
}
function FaRegHandPeace(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M362.146 191.976c-13.71-21.649-38.761-34.016-65.006-30.341V74c0-40.804-32.811-74-73.141-74-40.33 0-73.14 33.196-73.14 74L160 168l-18.679-78.85C126.578 50.843 83.85 32.11 46.209 47.208 8.735 62.238-9.571 104.963 5.008 142.85l55.757 144.927c-30.557 24.956-43.994 57.809-24.733 92.218l54.853 97.999C102.625 498.97 124.73 512 148.575 512h205.702c30.744 0 57.558-21.44 64.555-51.797l27.427-118.999a67.801 67.801 0 0 0 1.729-15.203L448 256c0-44.956-43.263-77.343-85.854-64.024zM399.987 326c0 1.488-.169 2.977-.502 4.423l-27.427 119.001c-1.978 8.582-9.29 14.576-17.782 14.576H148.575c-6.486 0-12.542-3.621-15.805-9.449l-54.854-98c-4.557-8.141-2.619-18.668 4.508-24.488l26.647-21.764a16 16 0 0 0 4.812-18.139l-64.09-166.549C37.226 92.956 84.37 74.837 96.51 106.389l59.784 155.357A16 16 0 0 0 171.227 272h11.632c8.837 0 16-7.163 16-16V74c0-34.375 50.281-34.43 50.281 0v182c0 8.837 7.163 16 16 16h6.856c8.837 0 16-7.163 16-16v-28c0-25.122 36.567-25.159 36.567 0v28c0 8.837 7.163 16 16 16h6.856c8.837 0 16-7.163 16-16 0-25.12 36.567-25.16 36.567 0v70z"
                }
            }
        ]
    })(props);
}
function FaRegHandPointDown(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M188.8 512c45.616 0 83.2-37.765 83.2-83.2v-35.647a93.148 93.148 0 0 0 22.064-7.929c22.006 2.507 44.978-3.503 62.791-15.985C409.342 368.1 448 331.841 448 269.299V248c0-60.063-40-98.512-40-127.2v-2.679c4.952-5.747 8-13.536 8-22.12V32c0-17.673-12.894-32-28.8-32H156.8C140.894 0 128 14.327 128 32v64c0 8.584 3.048 16.373 8 22.12v2.679c0 6.964-6.193 14.862-23.668 30.183l-.148.129-.146.131c-9.937 8.856-20.841 18.116-33.253 25.851C48.537 195.798 0 207.486 0 252.8c0 56.928 35.286 92 83.2 92 8.026 0 15.489-.814 22.4-2.176V428.8c0 45.099 38.101 83.2 83.2 83.2zm0-48c-18.7 0-35.2-16.775-35.2-35.2V270.4c-17.325 0-35.2 26.4-70.4 26.4-26.4 0-35.2-20.625-35.2-44 0-8.794 32.712-20.445 56.1-34.926 14.575-9.074 27.225-19.524 39.875-30.799 18.374-16.109 36.633-33.836 39.596-59.075h176.752C364.087 170.79 400 202.509 400 248v21.299c0 40.524-22.197 57.124-61.325 50.601-8.001 14.612-33.979 24.151-53.625 12.925-18.225 19.365-46.381 17.787-61.05 4.95V428.8c0 18.975-16.225 35.2-35.2 35.2zM328 64c0-13.255 10.745-24 24-24s24 10.745 24 24-10.745 24-24 24-24-10.745-24-24z"
                }
            }
        ]
    })(props);
}
function FaRegHandPointLeft(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 220.8C0 266.416 37.765 304 83.2 304h35.647a93.148 93.148 0 0 0 7.929 22.064c-2.507 22.006 3.503 44.978 15.985 62.791C143.9 441.342 180.159 480 242.701 480H264c60.063 0 98.512-40 127.2-40h2.679c5.747 4.952 13.536 8 22.12 8h64c17.673 0 32-12.894 32-28.8V188.8c0-15.906-14.327-28.8-32-28.8h-64c-8.584 0-16.373 3.048-22.12 8H391.2c-6.964 0-14.862-6.193-30.183-23.668l-.129-.148-.131-.146c-8.856-9.937-18.116-20.841-25.851-33.253C316.202 80.537 304.514 32 259.2 32c-56.928 0-92 35.286-92 83.2 0 8.026.814 15.489 2.176 22.4H83.2C38.101 137.6 0 175.701 0 220.8zm48 0c0-18.7 16.775-35.2 35.2-35.2h158.4c0-17.325-26.4-35.2-26.4-70.4 0-26.4 20.625-35.2 44-35.2 8.794 0 20.445 32.712 34.926 56.1 9.074 14.575 19.524 27.225 30.799 39.875 16.109 18.374 33.836 36.633 59.075 39.596v176.752C341.21 396.087 309.491 432 264 432h-21.299c-40.524 0-57.124-22.197-50.601-61.325-14.612-8.001-24.151-33.979-12.925-53.625-19.365-18.225-17.787-46.381-4.95-61.05H83.2C64.225 256 48 239.775 48 220.8zM448 360c13.255 0 24 10.745 24 24s-10.745 24-24 24-24-10.745-24-24 10.745-24 24-24z"
                }
            }
        ]
    })(props);
}
function FaRegHandPointRight(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M428.8 137.6h-86.177a115.52 115.52 0 0 0 2.176-22.4c0-47.914-35.072-83.2-92-83.2-45.314 0-57.002 48.537-75.707 78.784-7.735 12.413-16.994 23.317-25.851 33.253l-.131.146-.129.148C135.662 161.807 127.764 168 120.8 168h-2.679c-5.747-4.952-13.536-8-22.12-8H32c-17.673 0-32 12.894-32 28.8v230.4C0 435.106 14.327 448 32 448h64c8.584 0 16.373-3.048 22.12-8h2.679c28.688 0 67.137 40 127.2 40h21.299c62.542 0 98.8-38.658 99.94-91.145 12.482-17.813 18.491-40.785 15.985-62.791A93.148 93.148 0 0 0 393.152 304H428.8c45.435 0 83.2-37.584 83.2-83.2 0-45.099-38.101-83.2-83.2-83.2zm0 118.4h-91.026c12.837 14.669 14.415 42.825-4.95 61.05 11.227 19.646 1.687 45.624-12.925 53.625 6.524 39.128-10.076 61.325-50.6 61.325H248c-45.491 0-77.21-35.913-120-39.676V215.571c25.239-2.964 42.966-21.222 59.075-39.596 11.275-12.65 21.725-25.3 30.799-39.875C232.355 112.712 244.006 80 252.8 80c23.375 0 44 8.8 44 35.2 0 35.2-26.4 53.075-26.4 70.4h158.4c18.425 0 35.2 16.5 35.2 35.2 0 18.975-16.225 35.2-35.2 35.2zM88 384c0 13.255-10.745 24-24 24s-24-10.745-24-24 10.745-24 24-24 24 10.745 24 24z"
                }
            }
        ]
    })(props);
}
function FaRegHandPointUp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M105.6 83.2v86.177a115.52 115.52 0 0 0-22.4-2.176c-47.914 0-83.2 35.072-83.2 92 0 45.314 48.537 57.002 78.784 75.707 12.413 7.735 23.317 16.994 33.253 25.851l.146.131.148.129C129.807 376.338 136 384.236 136 391.2v2.679c-4.952 5.747-8 13.536-8 22.12v64c0 17.673 12.894 32 28.8 32h230.4c15.906 0 28.8-14.327 28.8-32v-64c0-8.584-3.048-16.373-8-22.12V391.2c0-28.688 40-67.137 40-127.2v-21.299c0-62.542-38.658-98.8-91.145-99.94-17.813-12.482-40.785-18.491-62.791-15.985A93.148 93.148 0 0 0 272 118.847V83.2C272 37.765 234.416 0 188.8 0c-45.099 0-83.2 38.101-83.2 83.2zm118.4 0v91.026c14.669-12.837 42.825-14.415 61.05 4.95 19.646-11.227 45.624-1.687 53.625 12.925 39.128-6.524 61.325 10.076 61.325 50.6V264c0 45.491-35.913 77.21-39.676 120H183.571c-2.964-25.239-21.222-42.966-39.596-59.075-12.65-11.275-25.3-21.725-39.875-30.799C80.712 279.645 48 267.994 48 259.2c0-23.375 8.8-44 35.2-44 35.2 0 53.075 26.4 70.4 26.4V83.2c0-18.425 16.5-35.2 35.2-35.2 18.975 0 35.2 16.225 35.2 35.2zM352 424c13.255 0 24 10.745 24 24s-10.745 24-24 24-24-10.745-24-24 10.745-24 24-24z"
                }
            }
        ]
    })(props);
}
function FaRegHandPointer(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M358.182 179.361c-19.493-24.768-52.679-31.945-79.872-19.098-15.127-15.687-36.182-22.487-56.595-19.629V67c0-36.944-29.736-67-66.286-67S89.143 30.056 89.143 67v161.129c-19.909-7.41-43.272-5.094-62.083 8.872-29.355 21.795-35.793 63.333-14.55 93.152l109.699 154.001C134.632 501.59 154.741 512 176 512h178.286c30.802 0 57.574-21.5 64.557-51.797l27.429-118.999A67.873 67.873 0 0 0 448 326v-84c0-46.844-46.625-79.273-89.818-62.639zM80.985 279.697l27.126 38.079c8.995 12.626 29.031 6.287 29.031-9.283V67c0-25.12 36.571-25.16 36.571 0v175c0 8.836 7.163 16 16 16h6.857c8.837 0 16-7.164 16-16v-35c0-25.12 36.571-25.16 36.571 0v35c0 8.836 7.163 16 16 16H272c8.837 0 16-7.164 16-16v-21c0-25.12 36.571-25.16 36.571 0v21c0 8.836 7.163 16 16 16h6.857c8.837 0 16-7.164 16-16 0-25.121 36.571-25.16 36.571 0v84c0 1.488-.169 2.977-.502 4.423l-27.43 119.001c-1.978 8.582-9.29 14.576-17.782 14.576H176c-5.769 0-11.263-2.878-14.697-7.697l-109.712-154c-14.406-20.223 14.994-42.818 29.394-22.606zM176.143 400v-96c0-8.837 6.268-16 14-16h6c7.732 0 14 7.163 14 16v96c0 8.837-6.268 16-14 16h-6c-7.733 0-14-7.163-14-16zm75.428 0v-96c0-8.837 6.268-16 14-16h6c7.732 0 14 7.163 14 16v96c0 8.837-6.268 16-14 16h-6c-7.732 0-14-7.163-14-16zM327 400v-96c0-8.837 6.268-16 14-16h6c7.732 0 14 7.163 14 16v96c0 8.837-6.268 16-14 16h-6c-7.732 0-14-7.163-14-16z"
                }
            }
        ]
    })(props);
}
function FaRegHandRock(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M408.864 79.052c-22.401-33.898-66.108-42.273-98.813-23.588-29.474-31.469-79.145-31.093-108.334-.022-47.16-27.02-108.71 5.055-110.671 60.806C44.846 105.407 0 140.001 0 187.429v56.953c0 32.741 14.28 63.954 39.18 85.634l97.71 85.081c4.252 3.702 3.11 5.573 3.11 32.903 0 17.673 14.327 32 32 32h252c17.673 0 32-14.327 32-32 0-23.513-1.015-30.745 3.982-42.37l42.835-99.656c6.094-14.177 9.183-29.172 9.183-44.568V146.963c0-52.839-54.314-88.662-103.136-67.911zM464 261.406a64.505 64.505 0 0 1-5.282 25.613l-42.835 99.655c-5.23 12.171-7.883 25.04-7.883 38.25V432H188v-10.286c0-16.37-7.14-31.977-19.59-42.817l-97.71-85.08C56.274 281.255 48 263.236 48 244.381v-56.953c0-33.208 52-33.537 52 .677v41.228a16 16 0 0 0 5.493 12.067l7 6.095A16 16 0 0 0 139 235.429V118.857c0-33.097 52-33.725 52 .677v26.751c0 8.836 7.164 16 16 16h7c8.836 0 16-7.164 16-16v-41.143c0-33.134 52-33.675 52 .677v40.466c0 8.836 7.163 16 16 16h7c8.837 0 16-7.164 16-16v-27.429c0-33.03 52-33.78 52 .677v26.751c0 8.836 7.163 16 16 16h7c8.837 0 16-7.164 16-16 0-33.146 52-33.613 52 .677v114.445z"
                }
            }
        ]
    })(props);
}
function FaRegHandScissors(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 480l70-.013c5.114 0 10.231-.583 15.203-1.729l118.999-27.427C490.56 443.835 512 417.02 512 386.277V180.575c0-23.845-13.03-45.951-34.005-57.69l-97.999-54.853c-34.409-19.261-67.263-5.824-92.218 24.733L142.85 37.008c-37.887-14.579-80.612 3.727-95.642 41.201-15.098 37.642 3.635 80.37 41.942 95.112L168 192l-94-9.141c-40.804 0-74 32.811-74 73.14 0 40.33 33.196 73.141 74 73.141h87.635c-3.675 26.245 8.692 51.297 30.341 65.006C178.657 436.737 211.044 480 256 480zm0-48.013c-25.16 0-25.12-36.567 0-36.567 8.837 0 16-7.163 16-16v-6.856c0-8.837-7.163-16-16-16h-28c-25.159 0-25.122-36.567 0-36.567h28c8.837 0 16-7.163 16-16v-6.856c0-8.837-7.163-16-16-16H74c-34.43 0-34.375-50.281 0-50.281h182c8.837 0 16-7.163 16-16v-11.632a16 16 0 0 0-10.254-14.933L106.389 128.51c-31.552-12.14-13.432-59.283 19.222-46.717l166.549 64.091a16.001 16.001 0 0 0 18.139-4.812l21.764-26.647c5.82-7.127 16.348-9.064 24.488-4.508l98 54.854c5.828 3.263 9.449 9.318 9.449 15.805v205.701c0 8.491-5.994 15.804-14.576 17.782l-119.001 27.427a19.743 19.743 0 0 1-4.423.502h-70z"
                }
            }
        ]
    })(props);
}
function FaRegHandSpock(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M501.03053,116.17605c-19.39059-31.50779-51.24406-35.72849-66.31044-35.01756-14.11325-50.81051-62.0038-54.08-70.73816-54.08a74.03091,74.03091,0,0,0-72.23816,58.916l-4.64648,22.66014-13.68357-53.207c-9.09569-35.37107-46.412-64.05074-89.66-53.07223a73.89749,73.89749,0,0,0-55.121,78.94722,73.68273,73.68273,0,0,0-64.8495,94.42181l24.35933,82.19721c-38.24017-7.54492-62.79677,16.18358-68.11512,21.84764a73.6791,73.6791,0,0,0,3.19921,104.19329l91.36509,85.9765A154.164,154.164,0,0,0,220.62279,512h107.4549A127.30079,127.30079,0,0,0,452.3392,413.86139l57.623-241.96272A73.20274,73.20274,0,0,0,501.03053,116.17605Zm-37.7597,44.60544L405.64788,402.74812a79.46616,79.46616,0,0,1-77.57019,61.25972H220.62279a106.34052,106.34052,0,0,1-73.1366-28.998l-91.369-85.98041C31.34381,325.72669,66.61133,288.131,91.39644,311.5392l51.123,48.10739c5.42577,5.10937,13.48239.71679,13.48239-5.82617a246.79914,246.79914,0,0,0-10.17771-70.1523l-36.01362-121.539c-9.7324-32.88279,39.69916-47.27145,49.38664-14.625l31.3437,105.77923c5.59374,18.90428,33.78119,10.71288,28.9648-8.00781L177.06427,80.23662c-8.50389-33.1035,41.43157-45.64646,49.86515-12.83593l47.32609,184.035c4.42773,17.24218,29.16207,16.5039,32.71089-.80468l31.791-154.9706c6.81054-33.1074,57.51748-24.10741,50.11906,11.96288L360.32764,246.78924c-3.72265,18.10936,23.66793,24.63084,28.05659,6.21679L413.185,148.85962C421.1498,115.512,471.14,127.79713,463.27083,160.78149Z"
                }
            }
        ]
    })(props);
}
function FaRegHandshake(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M519.2 127.9l-47.6-47.6A56.252 56.252 0 0 0 432 64H205.2c-14.8 0-29.1 5.9-39.6 16.3L118 127.9H0v255.7h64c17.6 0 31.8-14.2 31.9-31.7h9.1l84.6 76.4c30.9 25.1 73.8 25.7 105.6 3.8 12.5 10.8 26 15.9 41.1 15.9 18.2 0 35.3-7.4 48.8-24 22.1 8.7 48.2 2.6 64-16.8l26.2-32.3c5.6-6.9 9.1-14.8 10.9-23h57.9c.1 17.5 14.4 31.7 31.9 31.7h64V127.9H519.2zM48 351.6c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16c0 8.9-7.2 16-16 16zm390-6.9l-26.1 32.2c-2.8 3.4-7.8 4-11.3 1.2l-23.9-19.4-30 36.5c-6 7.3-15 4.8-18 2.4l-36.8-31.5-15.6 19.2c-13.9 17.1-39.2 19.7-55.3 6.6l-97.3-88H96V175.8h41.9l61.7-61.6c2-.8 3.7-1.5 5.7-2.3H262l-38.7 35.5c-29.4 26.9-31.1 72.3-4.4 101.3 14.8 16.2 61.2 41.2 101.5 4.4l8.2-7.5 108.2 87.8c3.4 2.8 3.9 7.9 1.2 11.3zm106-40.8h-69.2c-2.3-2.8-4.9-5.4-7.7-7.7l-102.7-83.4 12.5-11.4c6.5-6 7-16.1 1-22.6L367 167.1c-6-6.5-16.1-6.9-22.6-1l-55.2 50.6c-9.5 8.7-25.7 9.4-34.6 0-9.3-9.9-8.5-25.1 1.2-33.9l65.6-60.1c7.4-6.8 17-10.5 27-10.5l83.7-.2c2.1 0 4.1.8 5.5 2.3l61.7 61.6H544v128zm48 47.7c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16c0 8.9-7.2 16-16 16z"
                }
            }
        ]
    })(props);
}
function FaRegHdd(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M567.403 235.642L462.323 84.589A48 48 0 0 0 422.919 64H153.081a48 48 0 0 0-39.404 20.589L8.597 235.642A48.001 48.001 0 0 0 0 263.054V400c0 26.51 21.49 48 48 48h480c26.51 0 48-21.49 48-48V263.054c0-9.801-3-19.366-8.597-27.412zM153.081 112h269.838l77.913 112H75.168l77.913-112zM528 400H48V272h480v128zm-32-64c0 17.673-14.327 32-32 32s-32-14.327-32-32 14.327-32 32-32 32 14.327 32 32zm-96 0c0 17.673-14.327 32-32 32s-32-14.327-32-32 14.327-32 32-32 32 14.327 32 32z"
                }
            }
        ]
    })(props);
}
function FaRegHeart(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M458.4 64.3C400.6 15.7 311.3 23 256 79.3 200.7 23 111.4 15.6 53.6 64.3-21.6 127.6-10.6 230.8 43 285.5l175.4 178.7c10 10.2 23.4 15.9 37.6 15.9 14.3 0 27.6-5.6 37.6-15.8L469 285.6c53.5-54.7 64.7-157.9-10.6-221.3zm-23.6 187.5L259.4 430.5c-2.4 2.4-4.4 2.4-6.8 0L77.2 251.8c-36.5-37.2-43.9-107.6 7.3-150.7 38.9-32.7 98.9-27.8 136.5 10.5l35 35.7 35-35.7c37.8-38.5 97.8-43.2 136.5-10.6 51.1 43.1 43.5 113.9 7.3 150.8z"
                }
            }
        ]
    })(props);
}
function FaRegHospital(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M128 244v-40c0-6.627 5.373-12 12-12h40c6.627 0 12 5.373 12 12v40c0 6.627-5.373 12-12 12h-40c-6.627 0-12-5.373-12-12zm140 12h40c6.627 0 12-5.373 12-12v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12zm-76 84v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm76 12h40c6.627 0 12-5.373 12-12v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12zm180 124v36H0v-36c0-6.627 5.373-12 12-12h19.5V85.035C31.5 73.418 42.245 64 55.5 64H144V24c0-13.255 10.745-24 24-24h112c13.255 0 24 10.745 24 24v40h88.5c13.255 0 24 9.418 24 21.035V464H436c6.627 0 12 5.373 12 12zM79.5 463H192v-67c0-6.627 5.373-12 12-12h40c6.627 0 12 5.373 12 12v67h112.5V112H304v24c0 13.255-10.745 24-24 24H168c-13.255 0-24-10.745-24-24v-24H79.5v351zM266 64h-26V38a6 6 0 0 0-6-6h-20a6 6 0 0 0-6 6v26h-26a6 6 0 0 0-6 6v20a6 6 0 0 0 6 6h26v26a6 6 0 0 0 6 6h20a6 6 0 0 0 6-6V96h26a6 6 0 0 0 6-6V70a6 6 0 0 0-6-6z"
                }
            }
        ]
    })(props);
}
function FaRegHourglass(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M368 48h4c6.627 0 12-5.373 12-12V12c0-6.627-5.373-12-12-12H12C5.373 0 0 5.373 0 12v24c0 6.627 5.373 12 12 12h4c0 80.564 32.188 165.807 97.18 208C47.899 298.381 16 383.9 16 464h-4c-6.627 0-12 5.373-12 12v24c0 6.627 5.373 12 12 12h360c6.627 0 12-5.373 12-12v-24c0-6.627-5.373-12-12-12h-4c0-80.564-32.188-165.807-97.18-208C336.102 213.619 368 128.1 368 48zM64 48h256c0 101.62-57.307 184-128 184S64 149.621 64 48zm256 416H64c0-101.62 57.308-184 128-184s128 82.38 128 184z"
                }
            }
        ]
    })(props);
}
function FaRegIdBadge(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M336 0H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48zm0 464H48V48h288v416zM144 112h96c8.8 0 16-7.2 16-16s-7.2-16-16-16h-96c-8.8 0-16 7.2-16 16s7.2 16 16 16zm48 176c35.3 0 64-28.7 64-64s-28.7-64-64-64-64 28.7-64 64 28.7 64 64 64zm-89.6 128h179.2c12.4 0 22.4-8.6 22.4-19.2v-19.2c0-31.8-30.1-57.6-67.2-57.6-10.8 0-18.7 8-44.8 8-26.9 0-33.4-8-44.8-8-37.1 0-67.2 25.8-67.2 57.6v19.2c0 10.6 10 19.2 22.4 19.2z"
                }
            }
        ]
    })(props);
}
function FaRegIdCard(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M528 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h480c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zm0 400H303.2c.9-4.5.8 3.6.8-22.4 0-31.8-30.1-57.6-67.2-57.6-10.8 0-18.7 8-44.8 8-26.9 0-33.4-8-44.8-8-37.1 0-67.2 25.8-67.2 57.6 0 26-.2 17.9.8 22.4H48V144h480v288zm-168-80h112c4.4 0 8-3.6 8-8v-16c0-4.4-3.6-8-8-8H360c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8zm0-64h112c4.4 0 8-3.6 8-8v-16c0-4.4-3.6-8-8-8H360c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8zm0-64h112c4.4 0 8-3.6 8-8v-16c0-4.4-3.6-8-8-8H360c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8zm-168 96c35.3 0 64-28.7 64-64s-28.7-64-64-64-64 28.7-64 64 28.7 64 64 64z"
                }
            }
        ]
    })(props);
}
function FaRegImage(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M464 64H48C21.49 64 0 85.49 0 112v288c0 26.51 21.49 48 48 48h416c26.51 0 48-21.49 48-48V112c0-26.51-21.49-48-48-48zm-6 336H54a6 6 0 0 1-6-6V118a6 6 0 0 1 6-6h404a6 6 0 0 1 6 6v276a6 6 0 0 1-6 6zM128 152c-22.091 0-40 17.909-40 40s17.909 40 40 40 40-17.909 40-40-17.909-40-40-40zM96 352h320v-80l-87.515-87.515c-4.686-4.686-12.284-4.686-16.971 0L192 304l-39.515-39.515c-4.686-4.686-12.284-4.686-16.971 0L96 304v48z"
                }
            }
        ]
    })(props);
}
function FaRegImages(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M480 416v16c0 26.51-21.49 48-48 48H48c-26.51 0-48-21.49-48-48V176c0-26.51 21.49-48 48-48h16v48H54a6 6 0 0 0-6 6v244a6 6 0 0 0 6 6h372a6 6 0 0 0 6-6v-10h48zm42-336H150a6 6 0 0 0-6 6v244a6 6 0 0 0 6 6h372a6 6 0 0 0 6-6V86a6 6 0 0 0-6-6zm6-48c26.51 0 48 21.49 48 48v256c0 26.51-21.49 48-48 48H144c-26.51 0-48-21.49-48-48V80c0-26.51 21.49-48 48-48h384zM264 144c0 22.091-17.909 40-40 40s-40-17.909-40-40 17.909-40 40-40 40 17.909 40 40zm-72 96l39.515-39.515c4.686-4.686 12.284-4.686 16.971 0L288 240l103.515-103.515c4.686-4.686 12.284-4.686 16.971 0L480 208v80H192v-48z"
                }
            }
        ]
    })(props);
}
function FaRegKeyboard(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M528 64H48C21.49 64 0 85.49 0 112v288c0 26.51 21.49 48 48 48h480c26.51 0 48-21.49 48-48V112c0-26.51-21.49-48-48-48zm8 336c0 4.411-3.589 8-8 8H48c-4.411 0-8-3.589-8-8V112c0-4.411 3.589-8 8-8h480c4.411 0 8 3.589 8 8v288zM170 270v-28c0-6.627-5.373-12-12-12h-28c-6.627 0-12 5.373-12 12v28c0 6.627 5.373 12 12 12h28c6.627 0 12-5.373 12-12zm96 0v-28c0-6.627-5.373-12-12-12h-28c-6.627 0-12 5.373-12 12v28c0 6.627 5.373 12 12 12h28c6.627 0 12-5.373 12-12zm96 0v-28c0-6.627-5.373-12-12-12h-28c-6.627 0-12 5.373-12 12v28c0 6.627 5.373 12 12 12h28c6.627 0 12-5.373 12-12zm96 0v-28c0-6.627-5.373-12-12-12h-28c-6.627 0-12 5.373-12 12v28c0 6.627 5.373 12 12 12h28c6.627 0 12-5.373 12-12zm-336 82v-28c0-6.627-5.373-12-12-12H82c-6.627 0-12 5.373-12 12v28c0 6.627 5.373 12 12 12h28c6.627 0 12-5.373 12-12zm384 0v-28c0-6.627-5.373-12-12-12h-28c-6.627 0-12 5.373-12 12v28c0 6.627 5.373 12 12 12h28c6.627 0 12-5.373 12-12zM122 188v-28c0-6.627-5.373-12-12-12H82c-6.627 0-12 5.373-12 12v28c0 6.627 5.373 12 12 12h28c6.627 0 12-5.373 12-12zm96 0v-28c0-6.627-5.373-12-12-12h-28c-6.627 0-12 5.373-12 12v28c0 6.627 5.373 12 12 12h28c6.627 0 12-5.373 12-12zm96 0v-28c0-6.627-5.373-12-12-12h-28c-6.627 0-12 5.373-12 12v28c0 6.627 5.373 12 12 12h28c6.627 0 12-5.373 12-12zm96 0v-28c0-6.627-5.373-12-12-12h-28c-6.627 0-12 5.373-12 12v28c0 6.627 5.373 12 12 12h28c6.627 0 12-5.373 12-12zm96 0v-28c0-6.627-5.373-12-12-12h-28c-6.627 0-12 5.373-12 12v28c0 6.627 5.373 12 12 12h28c6.627 0 12-5.373 12-12zm-98 158v-16c0-6.627-5.373-12-12-12H180c-6.627 0-12 5.373-12 12v16c0 6.627 5.373 12 12 12h216c6.627 0 12-5.373 12-12z"
                }
            }
        ]
    })(props);
}
function FaRegKissBeam(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M168 152c-23.8 0-52.7 29.3-56 71.4-.3 3.7 2 7.2 5.6 8.3 3.5 1 7.5-.5 9.3-3.7l9.5-17c7.7-13.7 19.2-21.6 31.5-21.6s23.8 7.9 31.5 21.6l9.5 17c2.1 3.7 6.2 4.7 9.3 3.7 3.6-1.1 5.9-4.5 5.6-8.3-3.1-42.1-32-71.4-55.8-71.4zM248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 448c-110.3 0-200-89.7-200-200S137.7 56 248 56s200 89.7 200 200-89.7 200-200 200zm56-148c0-19.2-28.8-41.5-71.5-44-3.8-.4-7.4 2.4-8.2 6.2-.9 3.8 1.1 7.7 4.7 9.2l16.9 7.2c13 5.5 20.8 13.5 20.8 21.5s-7.8 16-20.7 21.5l-17 7.2c-5.7 2.4-6 12.2 0 14.8l16.9 7.2c13 5.5 20.8 13.5 20.8 21.5s-7.8 16-20.7 21.5l-17 7.2c-3.6 1.5-5.6 5.4-4.7 9.2.8 3.6 4.1 6.2 7.8 6.2h.5c42.8-2.5 71.5-24.8 71.5-44 0-13-13.4-27.3-35.2-36C290.6 335.3 304 321 304 308zm24-156c-23.8 0-52.7 29.3-56 71.4-.3 3.7 2 7.2 5.6 8.3 3.5 1 7.5-.5 9.3-3.7l9.5-17c7.7-13.7 19.2-21.6 31.5-21.6s23.8 7.9 31.5 21.6l9.5 17c2.1 3.7 6.2 4.7 9.3 3.7 3.6-1.1 5.9-4.5 5.6-8.3-3.1-42.1-32-71.4-55.8-71.4z"
                }
            }
        ]
    })(props);
}
function FaRegKissWinkHeart(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 504 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M304 308.5c0-19.2-28.8-41.5-71.5-44-3.8-.4-7.4 2.4-8.2 6.2-.9 3.8 1.1 7.7 4.7 9.2l16.9 7.2c13 5.5 20.8 13.5 20.8 21.5s-7.8 16-20.7 21.5l-17 7.2c-5.7 2.4-6 12.2 0 14.8l16.9 7.2c13 5.5 20.8 13.5 20.8 21.5s-7.8 16-20.7 21.5l-17 7.2c-3.6 1.5-5.6 5.4-4.7 9.2.8 3.6 4.1 6.2 7.8 6.2h.5c42.8-2.5 71.5-24.8 71.5-44 0-13-13.4-27.3-35.2-36 21.7-9.1 35.1-23.4 35.1-36.4zm70.5-83.5l9.5 8.5c3.8 3.3 9.3 4 13.7 1.6 4.4-2.4 6.9-7.4 6.1-12.4-4-25.2-34.2-42.1-59.8-42.1s-55.9 16.9-59.8 42.1c-.8 5 1.7 10 6.1 12.4 5.8 3.1 11.2.7 13.7-1.6l9.5-8.5c14.8-13.2 46.2-13.2 61 0zM136 208.5c0 17.7 14.3 32 32 32s32-14.3 32-32-14.3-32-32-32-32 14.3-32 32zm365.1 194c-8-20.8-31.5-31.5-53.1-25.9l-8.4 2.2-2.3-8.4c-5.9-21.4-27-36.5-49-33-25.2 4-40.6 28.6-34 52.6l22.9 82.6c1.5 5.3 7 8.5 12.4 7.1l83-21.5c24.1-6.3 37.7-31.8 28.5-55.7zM334 436.3c-26.1 12.5-55.2 19.7-86 19.7-110.3 0-200-89.7-200-200S137.7 56 248 56s200 89.7 200 200c0 22.1-3.7 43.3-10.4 63.2 9 6.4 17 14.2 22.6 23.9 6.4.1 12.6 1.4 18.6 2.9 10.9-27.9 17.1-58.2 17.1-90C496 119 385 8 248 8S0 119 0 256s111 248 248 248c35.4 0 68.9-7.5 99.4-20.9-2.5-7.3 4.3 17.2-13.4-46.8z"
                }
            }
        ]
    })(props);
}
function FaRegKiss(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M168 176c-17.7 0-32 14.3-32 32s14.3 32 32 32 32-14.3 32-32-14.3-32-32-32zm136 132c0-19.2-28.8-41.5-71.5-44-3.8-.4-7.4 2.4-8.2 6.2-.9 3.8 1.1 7.7 4.7 9.2l16.9 7.2c13 5.5 20.8 13.5 20.8 21.5s-7.8 16-20.7 21.5l-17 7.2c-5.7 2.4-6 12.2 0 14.8l16.9 7.2c13 5.5 20.8 13.5 20.8 21.5s-7.8 16-20.7 21.5l-17 7.2c-3.6 1.5-5.6 5.4-4.7 9.2.8 3.6 4.1 6.2 7.8 6.2h.5c42.8-2.5 71.5-24.8 71.5-44 0-13-13.4-27.3-35.2-36C290.6 335.3 304 321 304 308zM248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 448c-110.3 0-200-89.7-200-200S137.7 56 248 56s200 89.7 200 200-89.7 200-200 200zm80-280c-17.7 0-32 14.3-32 32s14.3 32 32 32 32-14.3 32-32-14.3-32-32-32z"
                }
            }
        ]
    })(props);
}
function FaRegLaughBeam(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm141.4 389.4c-37.8 37.8-88 58.6-141.4 58.6s-103.6-20.8-141.4-58.6S48 309.4 48 256s20.8-103.6 58.6-141.4S194.6 56 248 56s103.6 20.8 141.4 58.6S448 202.6 448 256s-20.8 103.6-58.6 141.4zM328 152c-23.8 0-52.7 29.3-56 71.4-.7 8.6 10.8 11.9 14.9 4.5l9.5-17c7.7-13.7 19.2-21.6 31.5-21.6s23.8 7.9 31.5 21.6l9.5 17c4.1 7.4 15.6 4 14.9-4.5-3.1-42.1-32-71.4-55.8-71.4zm-201 75.9l9.5-17c7.7-13.7 19.2-21.6 31.5-21.6s23.8 7.9 31.5 21.6l9.5 17c4.1 7.4 15.6 4 14.9-4.5-3.3-42.1-32.2-71.4-56-71.4s-52.7 29.3-56 71.4c-.6 8.5 10.9 11.9 15.1 4.5zM362.4 288H133.6c-8.2 0-14.5 7-13.5 15 7.5 59.2 58.9 105 121.1 105h13.6c62.2 0 113.6-45.8 121.1-105 1-8-5.3-15-13.5-15z"
                }
            }
        ]
    })(props);
}
function FaRegLaughSquint(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm141.4 389.4c-37.8 37.8-88 58.6-141.4 58.6s-103.6-20.8-141.4-58.6S48 309.4 48 256s20.8-103.6 58.6-141.4S194.6 56 248 56s103.6 20.8 141.4 58.6S448 202.6 448 256s-20.8 103.6-58.6 141.4zM343.6 196l33.6-40.3c8.6-10.3-3.8-24.8-15.4-18l-80 48c-7.8 4.7-7.8 15.9 0 20.6l80 48c11.5 6.8 24-7.6 15.4-18L343.6 196zm-209.4 58.3l80-48c7.8-4.7 7.8-15.9 0-20.6l-80-48c-11.6-6.9-24 7.7-15.4 18l33.6 40.3-33.6 40.3c-8.7 10.4 3.8 24.8 15.4 18zM362.4 288H133.6c-8.2 0-14.5 7-13.5 15 7.5 59.2 58.9 105 121.1 105h13.6c62.2 0 113.6-45.8 121.1-105 1-8-5.3-15-13.5-15z"
                }
            }
        ]
    })(props);
}
function FaRegLaughWink(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm141.4 389.4c-37.8 37.8-88 58.6-141.4 58.6s-103.6-20.8-141.4-58.6C68.8 359.6 48 309.4 48 256s20.8-103.6 58.6-141.4C144.4 76.8 194.6 56 248 56s103.6 20.8 141.4 58.6c37.8 37.8 58.6 88 58.6 141.4s-20.8 103.6-58.6 141.4zM328 164c-25.7 0-55.9 16.9-59.9 42.1-1.7 11.2 11.5 18.2 19.8 10.8l9.5-8.5c14.8-13.2 46.2-13.2 61 0l9.5 8.5c8.5 7.4 21.6.3 19.8-10.8-3.8-25.2-34-42.1-59.7-42.1zm-160 60c17.7 0 32-14.3 32-32s-14.3-32-32-32-32 14.3-32 32 14.3 32 32 32zm194.4 64H133.6c-8.2 0-14.5 7-13.5 15 7.5 59.2 58.9 105 121.1 105h13.6c62.2 0 113.6-45.8 121.1-105 1-8-5.3-15-13.5-15z"
                }
            }
        ]
    })(props);
}
function FaRegLaugh(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm141.4 389.4c-37.8 37.8-88 58.6-141.4 58.6s-103.6-20.8-141.4-58.6S48 309.4 48 256s20.8-103.6 58.6-141.4S194.6 56 248 56s103.6 20.8 141.4 58.6S448 202.6 448 256s-20.8 103.6-58.6 141.4zM328 224c17.7 0 32-14.3 32-32s-14.3-32-32-32-32 14.3-32 32 14.3 32 32 32zm-160 0c17.7 0 32-14.3 32-32s-14.3-32-32-32-32 14.3-32 32 14.3 32 32 32zm194.4 64H133.6c-8.2 0-14.5 7-13.5 15 7.5 59.2 58.9 105 121.1 105h13.6c62.2 0 113.6-45.8 121.1-105 1-8-5.3-15-13.5-15z"
                }
            }
        ]
    })(props);
}
function FaRegLemon(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M484.112 27.889C455.989-.233 416.108-8.057 387.059 8.865 347.604 31.848 223.504-41.111 91.196 91.197-41.277 223.672 31.923 347.472 8.866 387.058c-16.922 29.051-9.1 68.932 19.022 97.054 28.135 28.135 68.011 35.938 97.057 19.021 39.423-22.97 163.557 49.969 295.858-82.329 132.474-132.477 59.273-256.277 82.331-295.861 16.922-29.05 9.1-68.931-19.022-97.054zm-22.405 72.894c-38.8 66.609 45.6 165.635-74.845 286.08-120.44 120.443-219.475 36.048-286.076 74.843-22.679 13.207-64.035-27.241-50.493-50.488 38.8-66.609-45.6-165.635 74.845-286.08C245.573 4.702 344.616 89.086 411.219 50.292c22.73-13.24 64.005 27.288 50.488 50.491zm-169.861 8.736c1.37 10.96-6.404 20.957-17.365 22.327-54.846 6.855-135.779 87.787-142.635 142.635-1.373 10.989-11.399 18.734-22.326 17.365-10.961-1.37-18.735-11.366-17.365-22.326 9.162-73.286 104.167-168.215 177.365-177.365 10.953-1.368 20.956 6.403 22.326 17.364z"
                }
            }
        ]
    })(props);
}
function FaRegLifeRing(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 504c136.967 0 248-111.033 248-248S392.967 8 256 8 8 119.033 8 256s111.033 248 248 248zm-103.398-76.72l53.411-53.411c31.806 13.506 68.128 13.522 99.974 0l53.411 53.411c-63.217 38.319-143.579 38.319-206.796 0zM336 256c0 44.112-35.888 80-80 80s-80-35.888-80-80 35.888-80 80-80 80 35.888 80 80zm91.28 103.398l-53.411-53.411c13.505-31.806 13.522-68.128 0-99.974l53.411-53.411c38.319 63.217 38.319 143.579 0 206.796zM359.397 84.72l-53.411 53.411c-31.806-13.505-68.128-13.522-99.973 0L152.602 84.72c63.217-38.319 143.579-38.319 206.795 0zM84.72 152.602l53.411 53.411c-13.506 31.806-13.522 68.128 0 99.974L84.72 359.398c-38.319-63.217-38.319-143.579 0-206.796z"
                }
            }
        ]
    })(props);
}
function FaRegLightbulb(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 352 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M176 80c-52.94 0-96 43.06-96 96 0 8.84 7.16 16 16 16s16-7.16 16-16c0-35.3 28.72-64 64-64 8.84 0 16-7.16 16-16s-7.16-16-16-16zM96.06 459.17c0 3.15.93 6.22 2.68 8.84l24.51 36.84c2.97 4.46 7.97 7.14 13.32 7.14h78.85c5.36 0 10.36-2.68 13.32-7.14l24.51-36.84c1.74-2.62 2.67-5.7 2.68-8.84l.05-43.18H96.02l.04 43.18zM176 0C73.72 0 0 82.97 0 176c0 44.37 16.45 84.85 43.56 115.78 16.64 18.99 42.74 58.8 52.42 92.16v.06h48v-.12c-.01-4.77-.72-9.51-2.15-14.07-5.59-17.81-22.82-64.77-62.17-109.67-20.54-23.43-31.52-53.15-31.61-84.14-.2-73.64 59.67-128 127.95-128 70.58 0 128 57.42 128 128 0 30.97-11.24 60.85-31.65 84.14-39.11 44.61-56.42 91.47-62.1 109.46a47.507 47.507 0 0 0-2.22 14.3v.1h48v-.05c9.68-33.37 35.78-73.18 52.42-92.16C335.55 260.85 352 220.37 352 176 352 78.8 273.2 0 176 0z"
                }
            }
        ]
    })(props);
}
function FaRegListAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M464 32H48C21.49 32 0 53.49 0 80v352c0 26.51 21.49 48 48 48h416c26.51 0 48-21.49 48-48V80c0-26.51-21.49-48-48-48zm-6 400H54a6 6 0 0 1-6-6V86a6 6 0 0 1 6-6h404a6 6 0 0 1 6 6v340a6 6 0 0 1-6 6zm-42-92v24c0 6.627-5.373 12-12 12H204c-6.627 0-12-5.373-12-12v-24c0-6.627 5.373-12 12-12h200c6.627 0 12 5.373 12 12zm0-96v24c0 6.627-5.373 12-12 12H204c-6.627 0-12-5.373-12-12v-24c0-6.627 5.373-12 12-12h200c6.627 0 12 5.373 12 12zm0-96v24c0 6.627-5.373 12-12 12H204c-6.627 0-12-5.373-12-12v-24c0-6.627 5.373-12 12-12h200c6.627 0 12 5.373 12 12zm-252 12c0 19.882-16.118 36-36 36s-36-16.118-36-36 16.118-36 36-36 36 16.118 36 36zm0 96c0 19.882-16.118 36-36 36s-36-16.118-36-36 16.118-36 36-36 36 16.118 36 36zm0 96c0 19.882-16.118 36-36 36s-36-16.118-36-36 16.118-36 36-36 36 16.118 36 36z"
                }
            }
        ]
    })(props);
}
function FaRegMap(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M560.02 32c-1.96 0-3.98.37-5.96 1.16L384.01 96H384L212 35.28A64.252 64.252 0 0 0 191.76 32c-6.69 0-13.37 1.05-19.81 3.14L20.12 87.95A32.006 32.006 0 0 0 0 117.66v346.32C0 473.17 7.53 480 15.99 480c1.96 0 3.97-.37 5.96-1.16L192 416l172 60.71a63.98 63.98 0 0 0 40.05.15l151.83-52.81A31.996 31.996 0 0 0 576 394.34V48.02c0-9.19-7.53-16.02-15.98-16.02zM224 90.42l128 45.19v285.97l-128-45.19V90.42zM48 418.05V129.07l128-44.53v286.2l-.64.23L48 418.05zm480-35.13l-128 44.53V141.26l.64-.24L528 93.95v288.97z"
                }
            }
        ]
    })(props);
}
function FaRegMehBlank(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 448c-110.3 0-200-89.7-200-200S137.7 56 248 56s200 89.7 200 200-89.7 200-200 200zm-80-280c-17.7 0-32 14.3-32 32s14.3 32 32 32 32-14.3 32-32-14.3-32-32-32zm160 0c-17.7 0-32 14.3-32 32s14.3 32 32 32 32-14.3 32-32-14.3-32-32-32z"
                }
            }
        ]
    })(props);
}
function FaRegMehRollingEyes(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 448c-110.3 0-200-89.7-200-200S137.7 56 248 56s200 89.7 200 200-89.7 200-200 200zm88-304c-39.8 0-72 32.2-72 72s32.2 72 72 72 72-32.2 72-72-32.2-72-72-72zm0 112c-22.1 0-40-17.9-40-40 0-13.6 7.3-25.1 17.7-32.3-1 2.6-1.7 5.3-1.7 8.3 0 13.3 10.7 24 24 24s24-10.7 24-24c0-2.9-.7-5.7-1.7-8.3 10.4 7.2 17.7 18.7 17.7 32.3 0 22.1-17.9 40-40 40zm-104-40c0-39.8-32.2-72-72-72s-72 32.2-72 72 32.2 72 72 72 72-32.2 72-72zm-112 0c0-13.6 7.3-25.1 17.7-32.3-1 2.6-1.7 5.3-1.7 8.3 0 13.3 10.7 24 24 24s24-10.7 24-24c0-2.9-.7-5.7-1.7-8.3 10.4 7.2 17.7 18.7 17.7 32.3 0 22.1-17.9 40-40 40s-40-17.9-40-40zm192 128H184c-13.2 0-24 10.8-24 24s10.8 24 24 24h128c13.2 0 24-10.8 24-24s-10.8-24-24-24z"
                }
            }
        ]
    })(props);
}
function FaRegMeh(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 448c-110.3 0-200-89.7-200-200S137.7 56 248 56s200 89.7 200 200-89.7 200-200 200zm-80-216c17.7 0 32-14.3 32-32s-14.3-32-32-32-32 14.3-32 32 14.3 32 32 32zm160-64c-17.7 0-32 14.3-32 32s14.3 32 32 32 32-14.3 32-32-14.3-32-32-32zm8 144H160c-13.2 0-24 10.8-24 24s10.8 24 24 24h176c13.2 0 24-10.8 24-24s-10.8-24-24-24z"
                }
            }
        ]
    })(props);
}
function FaRegMinusSquare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M108 284c-6.6 0-12-5.4-12-12v-32c0-6.6 5.4-12 12-12h232c6.6 0 12 5.4 12 12v32c0 6.6-5.4 12-12 12H108zM448 80v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h352c26.5 0 48 21.5 48 48zm-48 346V86c0-3.3-2.7-6-6-6H54c-3.3 0-6 2.7-6 6v340c0 3.3 2.7 6 6 6h340c3.3 0 6-2.7 6-6z"
                }
            }
        ]
    })(props);
}
function FaRegMoneyBillAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M320 144c-53.02 0-96 50.14-96 112 0 61.85 42.98 112 96 112 53 0 96-50.13 96-112 0-61.86-42.98-112-96-112zm40 168c0 4.42-3.58 8-8 8h-64c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h16v-55.44l-.47.31a7.992 7.992 0 0 1-11.09-2.22l-8.88-13.31a7.992 7.992 0 0 1 2.22-11.09l15.33-10.22a23.99 23.99 0 0 1 13.31-4.03H328c4.42 0 8 3.58 8 8v88h16c4.42 0 8 3.58 8 8v16zM608 64H32C14.33 64 0 78.33 0 96v320c0 17.67 14.33 32 32 32h576c17.67 0 32-14.33 32-32V96c0-17.67-14.33-32-32-32zm-16 272c-35.35 0-64 28.65-64 64H112c0-35.35-28.65-64-64-64V176c35.35 0 64-28.65 64-64h416c0 35.35 28.65 64 64 64v160z"
                }
            }
        ]
    })(props);
}
function FaRegMoon(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M279.135 512c78.756 0 150.982-35.804 198.844-94.775 28.27-34.831-2.558-85.722-46.249-77.401-82.348 15.683-158.272-47.268-158.272-130.792 0-48.424 26.06-92.292 67.434-115.836 38.745-22.05 28.999-80.788-15.022-88.919A257.936 257.936 0 0 0 279.135 0c-141.36 0-256 114.575-256 256 0 141.36 114.576 256 256 256zm0-464c12.985 0 25.689 1.201 38.016 3.478-54.76 31.163-91.693 90.042-91.693 157.554 0 113.848 103.641 199.2 215.252 177.944C402.574 433.964 344.366 464 279.135 464c-114.875 0-208-93.125-208-208s93.125-208 208-208z"
                }
            }
        ]
    })(props);
}
function FaRegNewspaper(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M552 64H112c-20.858 0-38.643 13.377-45.248 32H24c-13.255 0-24 10.745-24 24v272c0 30.928 25.072 56 56 56h496c13.255 0 24-10.745 24-24V88c0-13.255-10.745-24-24-24zM48 392V144h16v248c0 4.411-3.589 8-8 8s-8-3.589-8-8zm480 8H111.422c.374-2.614.578-5.283.578-8V112h416v288zM172 280h136c6.627 0 12-5.373 12-12v-96c0-6.627-5.373-12-12-12H172c-6.627 0-12 5.373-12 12v96c0 6.627 5.373 12 12 12zm28-80h80v40h-80v-40zm-40 140v-24c0-6.627 5.373-12 12-12h136c6.627 0 12 5.373 12 12v24c0 6.627-5.373 12-12 12H172c-6.627 0-12-5.373-12-12zm192 0v-24c0-6.627 5.373-12 12-12h104c6.627 0 12 5.373 12 12v24c0 6.627-5.373 12-12 12H364c-6.627 0-12-5.373-12-12zm0-144v-24c0-6.627 5.373-12 12-12h104c6.627 0 12 5.373 12 12v24c0 6.627-5.373 12-12 12H364c-6.627 0-12-5.373-12-12zm0 72v-24c0-6.627 5.373-12 12-12h104c6.627 0 12 5.373 12 12v24c0 6.627-5.373 12-12 12H364c-6.627 0-12-5.373-12-12z"
                }
            }
        ]
    })(props);
}
function FaRegObjectGroup(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M500 128c6.627 0 12-5.373 12-12V44c0-6.627-5.373-12-12-12h-72c-6.627 0-12 5.373-12 12v12H96V44c0-6.627-5.373-12-12-12H12C5.373 32 0 37.373 0 44v72c0 6.627 5.373 12 12 12h12v256H12c-6.627 0-12 5.373-12 12v72c0 6.627 5.373 12 12 12h72c6.627 0 12-5.373 12-12v-12h320v12c0 6.627 5.373 12 12 12h72c6.627 0 12-5.373 12-12v-72c0-6.627-5.373-12-12-12h-12V128h12zm-52-64h32v32h-32V64zM32 64h32v32H32V64zm32 384H32v-32h32v32zm416 0h-32v-32h32v32zm-40-64h-12c-6.627 0-12 5.373-12 12v12H96v-12c0-6.627-5.373-12-12-12H72V128h12c6.627 0 12-5.373 12-12v-12h320v12c0 6.627 5.373 12 12 12h12v256zm-36-192h-84v-52c0-6.628-5.373-12-12-12H108c-6.627 0-12 5.372-12 12v168c0 6.628 5.373 12 12 12h84v52c0 6.628 5.373 12 12 12h200c6.627 0 12-5.372 12-12V204c0-6.628-5.373-12-12-12zm-268-24h144v112H136V168zm240 176H232v-24h76c6.627 0 12-5.372 12-12v-76h56v112z"
                }
            }
        ]
    })(props);
}
function FaRegObjectUngroup(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M564 224c6.627 0 12-5.373 12-12v-72c0-6.627-5.373-12-12-12h-72c-6.627 0-12 5.373-12 12v12h-88v-24h12c6.627 0 12-5.373 12-12V44c0-6.627-5.373-12-12-12h-72c-6.627 0-12 5.373-12 12v12H96V44c0-6.627-5.373-12-12-12H12C5.373 32 0 37.373 0 44v72c0 6.627 5.373 12 12 12h12v160H12c-6.627 0-12 5.373-12 12v72c0 6.627 5.373 12 12 12h72c6.627 0 12-5.373 12-12v-12h88v24h-12c-6.627 0-12 5.373-12 12v72c0 6.627 5.373 12 12 12h72c6.627 0 12-5.373 12-12v-12h224v12c0 6.627 5.373 12 12 12h72c6.627 0 12-5.373 12-12v-72c0-6.627-5.373-12-12-12h-12V224h12zM352 64h32v32h-32V64zm0 256h32v32h-32v-32zM64 352H32v-32h32v32zm0-256H32V64h32v32zm32 216v-12c0-6.627-5.373-12-12-12H72V128h12c6.627 0 12-5.373 12-12v-12h224v12c0 6.627 5.373 12 12 12h12v160h-12c-6.627 0-12 5.373-12 12v12H96zm128 136h-32v-32h32v32zm280-64h-12c-6.627 0-12 5.373-12 12v12H256v-12c0-6.627-5.373-12-12-12h-12v-24h88v12c0 6.627 5.373 12 12 12h72c6.627 0 12-5.373 12-12v-72c0-6.627-5.373-12-12-12h-12v-88h88v12c0 6.627 5.373 12 12 12h12v160zm40 64h-32v-32h32v32zm0-256h-32v-32h32v32z"
                }
            }
        ]
    })(props);
}
function FaRegPaperPlane(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M440 6.5L24 246.4c-34.4 19.9-31.1 70.8 5.7 85.9L144 379.6V464c0 46.4 59.2 65.5 86.6 28.6l43.8-59.1 111.9 46.2c5.9 2.4 12.1 3.6 18.3 3.6 8.2 0 16.3-2.1 23.6-6.2 12.8-7.2 21.6-20 23.9-34.5l59.4-387.2c6.1-40.1-36.9-68.8-71.5-48.9zM192 464v-64.6l36.6 15.1L192 464zm212.6-28.7l-153.8-63.5L391 169.5c10.7-15.5-9.5-33.5-23.7-21.2L155.8 332.6 48 288 464 48l-59.4 387.3z"
                }
            }
        ]
    })(props);
}
function FaRegPauseCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm0 448c-110.5 0-200-89.5-200-200S145.5 56 256 56s200 89.5 200 200-89.5 200-200 200zm96-280v160c0 8.8-7.2 16-16 16h-48c-8.8 0-16-7.2-16-16V176c0-8.8 7.2-16 16-16h48c8.8 0 16 7.2 16 16zm-112 0v160c0 8.8-7.2 16-16 16h-48c-8.8 0-16-7.2-16-16V176c0-8.8 7.2-16 16-16h48c8.8 0 16 7.2 16 16z"
                }
            }
        ]
    })(props);
}
function FaRegPlayCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M371.7 238l-176-107c-15.8-8.8-35.7 2.5-35.7 21v208c0 18.4 19.8 29.8 35.7 21l176-101c16.4-9.1 16.4-32.8 0-42zM504 256C504 119 393 8 256 8S8 119 8 256s111 248 248 248 248-111 248-248zm-448 0c0-110.5 89.5-200 200-200s200 89.5 200 200-89.5 200-200 200S56 366.5 56 256z"
                }
            }
        ]
    })(props);
}
function FaRegPlusSquare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M352 240v32c0 6.6-5.4 12-12 12h-88v88c0 6.6-5.4 12-12 12h-32c-6.6 0-12-5.4-12-12v-88h-88c-6.6 0-12-5.4-12-12v-32c0-6.6 5.4-12 12-12h88v-88c0-6.6 5.4-12 12-12h32c6.6 0 12 5.4 12 12v88h88c6.6 0 12 5.4 12 12zm96-160v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h352c26.5 0 48 21.5 48 48zm-48 346V86c0-3.3-2.7-6-6-6H54c-3.3 0-6 2.7-6 6v340c0 3.3 2.7 6 6 6h340c3.3 0 6-2.7 6-6z"
                }
            }
        ]
    })(props);
}
function FaRegQuestionCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 8C119.043 8 8 119.083 8 256c0 136.997 111.043 248 248 248s248-111.003 248-248C504 119.083 392.957 8 256 8zm0 448c-110.532 0-200-89.431-200-200 0-110.495 89.472-200 200-200 110.491 0 200 89.471 200 200 0 110.53-89.431 200-200 200zm107.244-255.2c0 67.052-72.421 68.084-72.421 92.863V300c0 6.627-5.373 12-12 12h-45.647c-6.627 0-12-5.373-12-12v-8.659c0-35.745 27.1-50.034 47.579-61.516 17.561-9.845 28.324-16.541 28.324-29.579 0-17.246-21.999-28.693-39.784-28.693-23.189 0-33.894 10.977-48.942 29.969-4.057 5.12-11.46 6.071-16.666 2.124l-27.824-21.098c-5.107-3.872-6.251-11.066-2.644-16.363C184.846 131.491 214.94 112 261.794 112c49.071 0 101.45 38.304 101.45 88.8zM298 368c0 23.159-18.841 42-42 42s-42-18.841-42-42 18.841-42 42-42 42 18.841 42 42z"
                }
            }
        ]
    })(props);
}
function FaRegRegistered(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 8C119.033 8 8 119.033 8 256s111.033 248 248 248 248-111.033 248-248S392.967 8 256 8zm0 448c-110.532 0-200-89.451-200-200 0-110.531 89.451-200 200-200 110.532 0 200 89.451 200 200 0 110.532-89.451 200-200 200zm110.442-81.791c-53.046-96.284-50.25-91.468-53.271-96.085 24.267-13.879 39.482-41.563 39.482-73.176 0-52.503-30.247-85.252-101.498-85.252h-78.667c-6.617 0-12 5.383-12 12V380c0 6.617 5.383 12 12 12h38.568c6.617 0 12-5.383 12-12v-83.663h31.958l47.515 89.303a11.98 11.98 0 0 0 10.593 6.36h42.81c9.14 0 14.914-9.799 10.51-17.791zM256.933 239.906h-33.875v-64.14h27.377c32.417 0 38.929 12.133 38.929 31.709-.001 20.913-11.518 32.431-32.431 32.431z"
                }
            }
        ]
    })(props);
}
function FaRegSadCry(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm144 386.4V280c0-13.2-10.8-24-24-24s-24 10.8-24 24v151.4C315.5 447 282.8 456 248 456s-67.5-9-96-24.6V280c0-13.2-10.8-24-24-24s-24 10.8-24 24v114.4c-34.6-36-56-84.7-56-138.4 0-110.3 89.7-200 200-200s200 89.7 200 200c0 53.7-21.4 102.5-56 138.4zM205.8 234.5c4.4-2.4 6.9-7.4 6.1-12.4-4-25.2-34.2-42.1-59.8-42.1s-55.9 16.9-59.8 42.1c-.8 5 1.7 10 6.1 12.4 4.4 2.4 9.9 1.8 13.7-1.6l9.5-8.5c14.8-13.2 46.2-13.2 61 0l9.5 8.5c2.5 2.3 7.9 4.8 13.7 1.6zM344 180c-25.7 0-55.9 16.9-59.8 42.1-.8 5 1.7 10 6.1 12.4 4.5 2.4 9.9 1.8 13.7-1.6l9.5-8.5c14.8-13.2 46.2-13.2 61 0l9.5 8.5c2.5 2.2 8 4.7 13.7 1.6 4.4-2.4 6.9-7.4 6.1-12.4-3.9-25.2-34.1-42.1-59.8-42.1zm-96 92c-30.9 0-56 28.7-56 64s25.1 64 56 64 56-28.7 56-64-25.1-64-56-64z"
                }
            }
        ]
    })(props);
}
function FaRegSadTear(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 448c-110.3 0-200-89.7-200-200S137.7 56 248 56s200 89.7 200 200-89.7 200-200 200zm8-152c-13.2 0-24 10.8-24 24s10.8 24 24 24c23.8 0 46.3 10.5 61.6 28.8 8.1 9.8 23.2 11.9 33.8 3.1 10.2-8.5 11.6-23.6 3.1-33.8C330 320.8 294.1 304 256 304zm-88-64c17.7 0 32-14.3 32-32s-14.3-32-32-32-32 14.3-32 32 14.3 32 32 32zm160-64c-17.7 0-32 14.3-32 32s14.3 32 32 32 32-14.3 32-32-14.3-32-32-32zm-165.6 98.8C151 290.1 126 325.4 126 342.9c0 22.7 18.8 41.1 42 41.1s42-18.4 42-41.1c0-17.5-25-52.8-36.4-68.1-2.8-3.7-8.4-3.7-11.2 0z"
                }
            }
        ]
    })(props);
}
function FaRegSave(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M433.941 129.941l-83.882-83.882A48 48 0 0 0 316.118 32H48C21.49 32 0 53.49 0 80v352c0 26.51 21.49 48 48 48h352c26.51 0 48-21.49 48-48V163.882a48 48 0 0 0-14.059-33.941zM272 80v80H144V80h128zm122 352H54a6 6 0 0 1-6-6V86a6 6 0 0 1 6-6h42v104c0 13.255 10.745 24 24 24h176c13.255 0 24-10.745 24-24V83.882l78.243 78.243a6 6 0 0 1 1.757 4.243V426a6 6 0 0 1-6 6zM224 232c-48.523 0-88 39.477-88 88s39.477 88 88 88 88-39.477 88-88-39.477-88-88-88zm0 128c-22.056 0-40-17.944-40-40s17.944-40 40-40 40 17.944 40 40-17.944 40-40 40z"
                }
            }
        ]
    })(props);
}
function FaRegShareSquare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M561.938 158.06L417.94 14.092C387.926-15.922 336 5.097 336 48.032v57.198c-42.45 1.88-84.03 6.55-120.76 17.99-35.17 10.95-63.07 27.58-82.91 49.42C108.22 199.2 96 232.6 96 271.94c0 61.697 33.178 112.455 84.87 144.76 37.546 23.508 85.248-12.651 71.02-55.74-15.515-47.119-17.156-70.923 84.11-78.76V336c0 42.993 51.968 63.913 81.94 33.94l143.998-144c18.75-18.74 18.75-49.14 0-67.88zM384 336V232.16C255.309 234.082 166.492 255.35 206.31 376 176.79 357.55 144 324.08 144 271.94c0-109.334 129.14-118.947 240-119.85V48l144 144-144 144zm24.74 84.493a82.658 82.658 0 0 0 20.974-9.303c7.976-4.952 18.286.826 18.286 10.214V464c0 26.51-21.49 48-48 48H48c-26.51 0-48-21.49-48-48V112c0-26.51 21.49-48 48-48h132c6.627 0 12 5.373 12 12v4.486c0 4.917-2.987 9.369-7.569 11.152-13.702 5.331-26.396 11.537-38.05 18.585a12.138 12.138 0 0 1-6.28 1.777H54a6 6 0 0 0-6 6v340a6 6 0 0 0 6 6h340a6 6 0 0 0 6-6v-25.966c0-5.37 3.579-10.059 8.74-11.541z"
                }
            }
        ]
    })(props);
}
function FaRegSmileBeam(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 448c-110.3 0-200-89.7-200-200S137.7 56 248 56s200 89.7 200 200-89.7 200-200 200zm84-143.4c-20.8 25-51.5 39.4-84 39.4s-63.2-14.3-84-39.4c-8.5-10.2-23.6-11.5-33.8-3.1-10.2 8.5-11.5 23.6-3.1 33.8 30 36 74.1 56.6 120.9 56.6s90.9-20.6 120.9-56.6c8.5-10.2 7.1-25.3-3.1-33.8-10.2-8.4-25.3-7.1-33.8 3.1zM136.5 211c7.7-13.7 19.2-21.6 31.5-21.6s23.8 7.9 31.5 21.6l9.5 17c2.1 3.7 6.2 4.7 9.3 3.7 3.6-1.1 6-4.5 5.7-8.3-3.3-42.1-32.2-71.4-56-71.4s-52.7 29.3-56 71.4c-.3 3.7 2.1 7.2 5.7 8.3 3.4 1.1 7.4-.5 9.3-3.7l9.5-17zM328 152c-23.8 0-52.7 29.3-56 71.4-.3 3.7 2.1 7.2 5.7 8.3 3.5 1.1 7.4-.5 9.3-3.7l9.5-17c7.7-13.7 19.2-21.6 31.5-21.6s23.8 7.9 31.5 21.6l9.5 17c2.1 3.7 6.2 4.7 9.3 3.7 3.6-1.1 6-4.5 5.7-8.3-3.3-42.1-32.2-71.4-56-71.4z"
                }
            }
        ]
    })(props);
}
function FaRegSmileWink(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 448c-110.3 0-200-89.7-200-200S137.7 56 248 56s200 89.7 200 200-89.7 200-200 200zm117.8-146.4c-10.2-8.5-25.3-7.1-33.8 3.1-20.8 25-51.5 39.4-84 39.4s-63.2-14.3-84-39.4c-8.5-10.2-23.7-11.5-33.8-3.1-10.2 8.5-11.5 23.6-3.1 33.8 30 36 74.1 56.6 120.9 56.6s90.9-20.6 120.9-56.6c8.5-10.2 7.1-25.3-3.1-33.8zM168 240c17.7 0 32-14.3 32-32s-14.3-32-32-32-32 14.3-32 32 14.3 32 32 32zm160-60c-25.7 0-55.9 16.9-59.9 42.1-1.7 11.2 11.5 18.2 19.8 10.8l9.5-8.5c14.8-13.2 46.2-13.2 61 0l9.5 8.5c8.5 7.4 21.6.3 19.8-10.8-3.8-25.2-34-42.1-59.7-42.1z"
                }
            }
        ]
    })(props);
}
function FaRegSmile(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 448c-110.3 0-200-89.7-200-200S137.7 56 248 56s200 89.7 200 200-89.7 200-200 200zm-80-216c17.7 0 32-14.3 32-32s-14.3-32-32-32-32 14.3-32 32 14.3 32 32 32zm160 0c17.7 0 32-14.3 32-32s-14.3-32-32-32-32 14.3-32 32 14.3 32 32 32zm4 72.6c-20.8 25-51.5 39.4-84 39.4s-63.2-14.3-84-39.4c-8.5-10.2-23.7-11.5-33.8-3.1-10.2 8.5-11.5 23.6-3.1 33.8 30 36 74.1 56.6 120.9 56.6s90.9-20.6 120.9-56.6c8.5-10.2 7.1-25.3-3.1-33.8-10.1-8.4-25.3-7.1-33.8 3.1z"
                }
            }
        ]
    })(props);
}
function FaRegSnowflake(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M440.1 355.2l-39.2-23 34.1-9.3c8.4-2.3 13.4-11.1 11.1-19.6l-4.1-15.5c-2.2-8.5-10.9-13.6-19.3-11.3L343 298.2 271.2 256l71.9-42.2 79.7 21.7c8.4 2.3 17-2.8 19.3-11.3l4.1-15.5c2.2-8.5-2.7-17.3-11.1-19.6l-34.1-9.3 39.2-23c7.5-4.4 10.1-14.2 5.8-21.9l-7.9-13.9c-4.3-7.7-14-10.3-21.5-5.9l-39.2 23 9.1-34.7c2.2-8.5-2.7-17.3-11.1-19.6l-15.2-4.1c-8.4-2.3-17 2.8-19.3 11.3l-21.3 81-71.9 42.2v-84.5L306 70.4c6.1-6.2 6.1-16.4 0-22.6l-11.1-11.3c-6.1-6.2-16.1-6.2-22.2 0l-24.9 25.4V16c0-8.8-7-16-15.7-16h-15.7c-8.7 0-15.7 7.2-15.7 16v46.1l-24.9-25.4c-6.1-6.2-16.1-6.2-22.2 0L142.1 48c-6.1 6.2-6.1 16.4 0 22.6l58.3 59.3v84.5l-71.9-42.2-21.3-81c-2.2-8.5-10.9-13.6-19.3-11.3L72.7 84c-8.4 2.3-13.4 11.1-11.1 19.6l9.1 34.7-39.2-23c-7.5-4.4-17.1-1.8-21.5 5.9l-7.9 13.9c-4.3 7.7-1.8 17.4 5.8 21.9l39.2 23-34.1 9.1c-8.4 2.3-13.4 11.1-11.1 19.6L6 224.2c2.2 8.5 10.9 13.6 19.3 11.3l79.7-21.7 71.9 42.2-71.9 42.2-79.7-21.7c-8.4-2.3-17 2.8-19.3 11.3l-4.1 15.5c-2.2 8.5 2.7 17.3 11.1 19.6l34.1 9.3-39.2 23c-7.5 4.4-10.1 14.2-5.8 21.9L10 391c4.3 7.7 14 10.3 21.5 5.9l39.2-23-9.1 34.7c-2.2 8.5 2.7 17.3 11.1 19.6l15.2 4.1c8.4 2.3 17-2.8 19.3-11.3l21.3-81 71.9-42.2v84.5l-58.3 59.3c-6.1 6.2-6.1 16.4 0 22.6l11.1 11.3c6.1 6.2 16.1 6.2 22.2 0l24.9-25.4V496c0 8.8 7 16 15.7 16h15.7c8.7 0 15.7-7.2 15.7-16v-46.1l24.9 25.4c6.1 6.2 16.1 6.2 22.2 0l11.1-11.3c6.1-6.2 6.1-16.4 0-22.6l-58.3-59.3v-84.5l71.9 42.2 21.3 81c2.2 8.5 10.9 13.6 19.3 11.3L375 428c8.4-2.3 13.4-11.1 11.1-19.6l-9.1-34.7 39.2 23c7.5 4.4 17.1 1.8 21.5-5.9l7.9-13.9c4.6-7.5 2.1-17.3-5.5-21.7z"
                }
            }
        ]
    })(props);
}
function FaRegSquare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zm-6 400H54c-3.3 0-6-2.7-6-6V86c0-3.3 2.7-6 6-6h340c3.3 0 6 2.7 6 6v340c0 3.3-2.7 6-6 6z"
                }
            }
        ]
    })(props);
}
function FaRegStarHalf(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M288 385.3l-124.3 65.4 23.7-138.4-100.6-98 139-20.2 62.2-126V0c-11.4 0-22.8 5.9-28.7 17.8L194 150.2 47.9 171.4c-26.2 3.8-36.7 36.1-17.7 54.6l105.7 103-25 145.5c-4.5 26.1 23 46 46.4 33.7L288 439.6v-54.3z"
                }
            }
        ]
    })(props);
}
function FaRegStar(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M528.1 171.5L382 150.2 316.7 17.8c-11.7-23.6-45.6-23.9-57.4 0L194 150.2 47.9 171.5c-26.2 3.8-36.7 36.1-17.7 54.6l105.7 103-25 145.5c-4.5 26.3 23.2 46 46.4 33.7L288 439.6l130.7 68.7c23.2 12.2 50.9-7.4 46.4-33.7l-25-145.5 105.7-103c19-18.5 8.5-50.8-17.7-54.6zM388.6 312.3l23.7 138.4L288 385.4l-124.3 65.3 23.7-138.4-100.6-98 139-20.2 62.2-126 62.2 126 139 20.2-100.6 98z"
                }
            }
        ]
    })(props);
}
function FaRegStickyNote(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M448 348.106V80c0-26.51-21.49-48-48-48H48C21.49 32 0 53.49 0 80v351.988c0 26.51 21.49 48 48 48h268.118a48 48 0 0 0 33.941-14.059l83.882-83.882A48 48 0 0 0 448 348.106zm-128 80v-76.118h76.118L320 428.106zM400 80v223.988H296c-13.255 0-24 10.745-24 24v104H48V80h352z"
                }
            }
        ]
    })(props);
}
function FaRegStopCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M504 256C504 119 393 8 256 8S8 119 8 256s111 248 248 248 248-111 248-248zm-448 0c0-110.5 89.5-200 200-200s200 89.5 200 200-89.5 200-200 200S56 366.5 56 256zm296-80v160c0 8.8-7.2 16-16 16H176c-8.8 0-16-7.2-16-16V176c0-8.8 7.2-16 16-16h160c8.8 0 16 7.2 16 16z"
                }
            }
        ]
    })(props);
}
function FaRegSun(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M494.2 221.9l-59.8-40.5 13.7-71c2.6-13.2-1.6-26.8-11.1-36.4-9.6-9.5-23.2-13.7-36.2-11.1l-70.9 13.7-40.4-59.9c-15.1-22.3-51.9-22.3-67 0l-40.4 59.9-70.8-13.7C98 60.4 84.5 64.5 75 74.1c-9.5 9.6-13.7 23.1-11.1 36.3l13.7 71-59.8 40.5C6.6 229.5 0 242 0 255.5s6.7 26 17.8 33.5l59.8 40.5-13.7 71c-2.6 13.2 1.6 26.8 11.1 36.3 9.5 9.5 22.9 13.7 36.3 11.1l70.8-13.7 40.4 59.9C230 505.3 242.6 512 256 512s26-6.7 33.5-17.8l40.4-59.9 70.9 13.7c13.4 2.7 26.8-1.6 36.3-11.1 9.5-9.5 13.6-23.1 11.1-36.3l-13.7-71 59.8-40.5c11.1-7.5 17.8-20.1 17.8-33.5-.1-13.6-6.7-26.1-17.9-33.7zm-112.9 85.6l17.6 91.2-91-17.6L256 458l-51.9-77-90.9 17.6 17.6-91.2-76.8-52 76.8-52-17.6-91.2 91 17.6L256 53l51.9 76.9 91-17.6-17.6 91.1 76.8 52-76.8 52.1zM256 152c-57.3 0-104 46.7-104 104s46.7 104 104 104 104-46.7 104-104-46.7-104-104-104zm0 160c-30.9 0-56-25.1-56-56s25.1-56 56-56 56 25.1 56 56-25.1 56-56 56z"
                }
            }
        ]
    })(props);
}
function FaRegSurprise(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 448c-110.3 0-200-89.7-200-200S137.7 56 248 56s200 89.7 200 200-89.7 200-200 200zm0-176c-35.3 0-64 28.7-64 64s28.7 64 64 64 64-28.7 64-64-28.7-64-64-64zm-48-72c0-17.7-14.3-32-32-32s-32 14.3-32 32 14.3 32 32 32 32-14.3 32-32zm128-32c-17.7 0-32 14.3-32 32s14.3 32 32 32 32-14.3 32-32-14.3-32-32-32z"
                }
            }
        ]
    })(props);
}
function FaRegThumbsDown(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M466.27 225.31c4.674-22.647.864-44.538-8.99-62.99 2.958-23.868-4.021-48.565-17.34-66.99C438.986 39.423 404.117 0 327 0c-7 0-15 .01-22.22.01C201.195.01 168.997 40 128 40h-10.845c-5.64-4.975-13.042-8-21.155-8H32C14.327 32 0 46.327 0 64v240c0 17.673 14.327 32 32 32h64c11.842 0 22.175-6.438 27.708-16h7.052c19.146 16.953 46.013 60.653 68.76 83.4 13.667 13.667 10.153 108.6 71.76 108.6 57.58 0 95.27-31.936 95.27-104.73 0-18.41-3.93-33.73-8.85-46.54h36.48c48.602 0 85.82-41.565 85.82-85.58 0-19.15-4.96-34.99-13.73-49.84zM64 296c-13.255 0-24-10.745-24-24s10.745-24 24-24 24 10.745 24 24-10.745 24-24 24zm330.18 16.73H290.19c0 37.82 28.36 55.37 28.36 94.54 0 23.75 0 56.73-47.27 56.73-18.91-18.91-9.46-66.18-37.82-94.54C206.9 342.89 167.28 272 138.92 272H128V85.83c53.611 0 100.001-37.82 171.64-37.82h37.82c35.512 0 60.82 17.12 53.12 65.9 15.2 8.16 26.5 36.44 13.94 57.57 21.581 20.384 18.699 51.065 5.21 65.62 9.45 0 22.36 18.91 22.27 37.81-.09 18.91-16.71 37.82-37.82 37.82z"
                }
            }
        ]
    })(props);
}
function FaRegThumbsUp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M466.27 286.69C475.04 271.84 480 256 480 236.85c0-44.015-37.218-85.58-85.82-85.58H357.7c4.92-12.81 8.85-28.13 8.85-46.54C366.55 31.936 328.86 0 271.28 0c-61.607 0-58.093 94.933-71.76 108.6-22.747 22.747-49.615 66.447-68.76 83.4H32c-17.673 0-32 14.327-32 32v240c0 17.673 14.327 32 32 32h64c14.893 0 27.408-10.174 30.978-23.95 44.509 1.001 75.06 39.94 177.802 39.94 7.22 0 15.22.01 22.22.01 77.117 0 111.986-39.423 112.94-95.33 13.319-18.425 20.299-43.122 17.34-66.99 9.854-18.452 13.664-40.343 8.99-62.99zm-61.75 53.83c12.56 21.13 1.26 49.41-13.94 57.57 7.7 48.78-17.608 65.9-53.12 65.9h-37.82c-71.639 0-118.029-37.82-171.64-37.82V240h10.92c28.36 0 67.98-70.89 94.54-97.46 28.36-28.36 18.91-75.63 37.82-94.54 47.27 0 47.27 32.98 47.27 56.73 0 39.17-28.36 56.72-28.36 94.54h103.99c21.11 0 37.73 18.91 37.82 37.82.09 18.9-12.82 37.81-22.27 37.81 13.489 14.555 16.371 45.236-5.21 65.62zM88 432c0 13.255-10.745 24-24 24s-24-10.745-24-24 10.745-24 24-24 24 10.745 24 24z"
                }
            }
        ]
    })(props);
}
function FaRegTimesCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm0 448c-110.5 0-200-89.5-200-200S145.5 56 256 56s200 89.5 200 200-89.5 200-200 200zm101.8-262.2L295.6 256l62.2 62.2c4.7 4.7 4.7 12.3 0 17l-22.6 22.6c-4.7 4.7-12.3 4.7-17 0L256 295.6l-62.2 62.2c-4.7 4.7-12.3 4.7-17 0l-22.6-22.6c-4.7-4.7-4.7-12.3 0-17l62.2-62.2-62.2-62.2c-4.7-4.7-4.7-12.3 0-17l22.6-22.6c4.7-4.7 12.3-4.7 17 0l62.2 62.2 62.2-62.2c4.7-4.7 12.3-4.7 17 0l22.6 22.6c4.7 4.7 4.7 12.3 0 17z"
                }
            }
        ]
    })(props);
}
function FaRegTired(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 448c-110.3 0-200-89.7-200-200S137.7 56 248 56s200 89.7 200 200-89.7 200-200 200zm129.1-303.8c-3.8-4.4-10.3-5.4-15.3-2.5l-80 48c-3.6 2.2-5.8 6.1-5.8 10.3s2.2 8.1 5.8 10.3l80 48c5.4 3.2 11.8 1.6 15.3-2.5 3.8-4.5 3.9-11 .1-15.5L343.6 208l33.6-40.3c3.8-4.5 3.7-11.1-.1-15.5zM220 208c0-4.2-2.2-8.1-5.8-10.3l-80-48c-5-3-11.5-1.9-15.3 2.5-3.8 4.5-3.9 11-.1 15.5l33.6 40.3-33.6 40.3c-3.8 4.5-3.7 11 .1 15.5 3.5 4.1 9.9 5.7 15.3 2.5l80-48c3.6-2.2 5.8-6.1 5.8-10.3zm28 64c-45.4 0-100.9 38.3-107.8 93.3-1.5 11.8 6.9 21.6 15.5 17.9C178.4 373.5 212 368 248 368s69.6 5.5 92.3 15.2c8.5 3.7 17-6 15.5-17.9-6.9-55-62.4-93.3-107.8-93.3z"
                }
            }
        ]
    })(props);
}
function FaRegTrashAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M268 416h24a12 12 0 0 0 12-12V188a12 12 0 0 0-12-12h-24a12 12 0 0 0-12 12v216a12 12 0 0 0 12 12zM432 80h-82.41l-34-56.7A48 48 0 0 0 274.41 0H173.59a48 48 0 0 0-41.16 23.3L98.41 80H16A16 16 0 0 0 0 96v16a16 16 0 0 0 16 16h16v336a48 48 0 0 0 48 48h288a48 48 0 0 0 48-48V128h16a16 16 0 0 0 16-16V96a16 16 0 0 0-16-16zM171.84 50.91A6 6 0 0 1 177 48h94a6 6 0 0 1 5.15 2.91L293.61 80H154.39zM368 464H80V128h288zm-212-48h24a12 12 0 0 0 12-12V188a12 12 0 0 0-12-12h-24a12 12 0 0 0-12 12v216a12 12 0 0 0 12 12z"
                }
            }
        ]
    })(props);
}
function FaRegUserCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 104c-53 0-96 43-96 96s43 96 96 96 96-43 96-96-43-96-96-96zm0 144c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48zm0-240C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 448c-49.7 0-95.1-18.3-130.1-48.4 14.9-23 40.4-38.6 69.6-39.5 20.8 6.4 40.6 9.6 60.5 9.6s39.7-3.1 60.5-9.6c29.2 1 54.7 16.5 69.6 39.5-35 30.1-80.4 48.4-130.1 48.4zm162.7-84.1c-24.4-31.4-62.1-51.9-105.1-51.9-10.2 0-26 9.6-57.6 9.6-31.5 0-47.4-9.6-57.6-9.6-42.9 0-80.6 20.5-105.1 51.9C61.9 339.2 48 299.2 48 256c0-110.3 89.7-200 200-200s200 89.7 200 200c0 43.2-13.9 83.2-37.3 115.9z"
                }
            }
        ]
    })(props);
}
function FaRegUser(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M313.6 304c-28.7 0-42.5 16-89.6 16-47.1 0-60.8-16-89.6-16C60.2 304 0 364.2 0 438.4V464c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48v-25.6c0-74.2-60.2-134.4-134.4-134.4zM400 464H48v-25.6c0-47.6 38.8-86.4 86.4-86.4 14.6 0 38.3 16 89.6 16 51.7 0 74.9-16 89.6-16 47.6 0 86.4 38.8 86.4 86.4V464zM224 288c79.5 0 144-64.5 144-144S303.5 0 224 0 80 64.5 80 144s64.5 144 144 144zm0-240c52.9 0 96 43.1 96 96s-43.1 96-96 96-96-43.1-96-96 43.1-96 96-96z"
                }
            }
        ]
    })(props);
}
function FaRegWindowClose(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M464 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h416c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zm0 394c0 3.3-2.7 6-6 6H54c-3.3 0-6-2.7-6-6V86c0-3.3 2.7-6 6-6h404c3.3 0 6 2.7 6 6v340zM356.5 194.6L295.1 256l61.4 61.4c4.6 4.6 4.6 12.1 0 16.8l-22.3 22.3c-4.6 4.6-12.1 4.6-16.8 0L256 295.1l-61.4 61.4c-4.6 4.6-12.1 4.6-16.8 0l-22.3-22.3c-4.6-4.6-4.6-12.1 0-16.8l61.4-61.4-61.4-61.4c-4.6-4.6-4.6-12.1 0-16.8l22.3-22.3c4.6-4.6 12.1-4.6 16.8 0l61.4 61.4 61.4-61.4c4.6-4.6 12.1-4.6 16.8 0l22.3 22.3c4.7 4.6 4.7 12.1 0 16.8z"
                }
            }
        ]
    })(props);
}
function FaRegWindowMaximize(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M464 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h416c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zm0 394c0 3.3-2.7 6-6 6H54c-3.3 0-6-2.7-6-6V192h416v234z"
                }
            }
        ]
    })(props);
}
function FaRegWindowMinimize(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M480 480H32c-17.7 0-32-14.3-32-32s14.3-32 32-32h448c17.7 0 32 14.3 32 32s-14.3 32-32 32z"
                }
            }
        ]
    })(props);
}
function FaRegWindowRestore(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M464 0H144c-26.5 0-48 21.5-48 48v48H48c-26.5 0-48 21.5-48 48v320c0 26.5 21.5 48 48 48h320c26.5 0 48-21.5 48-48v-48h48c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48zm-96 464H48V256h320v208zm96-96h-48V144c0-26.5-21.5-48-48-48H144V48h320v320z"
                }
            }
        ]
    })(props);
}

},{"../lib":"ciihV","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"ciihV":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _iconsManifest = require("./iconsManifest");
parcelHelpers.exportAll(_iconsManifest, exports);
var _iconBase = require("./iconBase");
parcelHelpers.exportAll(_iconBase, exports);
var _iconContext = require("./iconContext");
parcelHelpers.exportAll(_iconContext, exports);

},{"./iconsManifest":"7mRe1","./iconBase":"5XN5J","./iconContext":"dsBDH","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7mRe1":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "IconsManifest", ()=>IconsManifest);
var IconsManifest = [
    {
        "id": "ci",
        "name": "Circum Icons",
        "projectUrl": "https://circumicons.com/",
        "license": "MPL-2.0 license",
        "licenseUrl": "https://github.com/Klarr-Agency/Circum-Icons/blob/main/LICENSE"
    },
    {
        "id": "fa",
        "name": "Font Awesome 5",
        "projectUrl": "https://fontawesome.com/",
        "license": "CC BY 4.0 License",
        "licenseUrl": "https://creativecommons.org/licenses/by/4.0/"
    },
    {
        "id": "fa6",
        "name": "Font Awesome 6",
        "projectUrl": "https://fontawesome.com/",
        "license": "CC BY 4.0 License",
        "licenseUrl": "https://creativecommons.org/licenses/by/4.0/"
    },
    {
        "id": "io",
        "name": "Ionicons 4",
        "projectUrl": "https://ionicons.com/",
        "license": "MIT",
        "licenseUrl": "https://github.com/ionic-team/ionicons/blob/master/LICENSE"
    },
    {
        "id": "io5",
        "name": "Ionicons 5",
        "projectUrl": "https://ionicons.com/",
        "license": "MIT",
        "licenseUrl": "https://github.com/ionic-team/ionicons/blob/master/LICENSE"
    },
    {
        "id": "md",
        "name": "Material Design icons",
        "projectUrl": "http://google.github.io/material-design-icons/",
        "license": "Apache License Version 2.0",
        "licenseUrl": "https://github.com/google/material-design-icons/blob/master/LICENSE"
    },
    {
        "id": "ti",
        "name": "Typicons",
        "projectUrl": "http://s-ings.com/typicons/",
        "license": "CC BY-SA 3.0",
        "licenseUrl": "https://creativecommons.org/licenses/by-sa/3.0/"
    },
    {
        "id": "go",
        "name": "Github Octicons icons",
        "projectUrl": "https://octicons.github.com/",
        "license": "MIT",
        "licenseUrl": "https://github.com/primer/octicons/blob/master/LICENSE"
    },
    {
        "id": "fi",
        "name": "Feather",
        "projectUrl": "https://feathericons.com/",
        "license": "MIT",
        "licenseUrl": "https://github.com/feathericons/feather/blob/master/LICENSE"
    },
    {
        "id": "lu",
        "name": "Lucide",
        "projectUrl": "https://lucide.dev/",
        "license": "ISC",
        "licenseUrl": "https://github.com/lucide-icons/lucide/blob/main/LICENSE"
    },
    {
        "id": "gi",
        "name": "Game Icons",
        "projectUrl": "https://game-icons.net/",
        "license": "CC BY 3.0",
        "licenseUrl": "https://creativecommons.org/licenses/by/3.0/"
    },
    {
        "id": "wi",
        "name": "Weather Icons",
        "projectUrl": "https://erikflowers.github.io/weather-icons/",
        "license": "SIL OFL 1.1",
        "licenseUrl": "http://scripts.sil.org/OFL"
    },
    {
        "id": "di",
        "name": "Devicons",
        "projectUrl": "https://vorillaz.github.io/devicons/",
        "license": "MIT",
        "licenseUrl": "https://opensource.org/licenses/MIT"
    },
    {
        "id": "ai",
        "name": "Ant Design Icons",
        "projectUrl": "https://github.com/ant-design/ant-design-icons",
        "license": "MIT",
        "licenseUrl": "https://opensource.org/licenses/MIT"
    },
    {
        "id": "bs",
        "name": "Bootstrap Icons",
        "projectUrl": "https://github.com/twbs/icons",
        "license": "MIT",
        "licenseUrl": "https://opensource.org/licenses/MIT"
    },
    {
        "id": "ri",
        "name": "Remix Icon",
        "projectUrl": "https://github.com/Remix-Design/RemixIcon",
        "license": "Apache License Version 2.0",
        "licenseUrl": "http://www.apache.org/licenses/"
    },
    {
        "id": "fc",
        "name": "Flat Color Icons",
        "projectUrl": "https://github.com/icons8/flat-color-icons",
        "license": "MIT",
        "licenseUrl": "https://opensource.org/licenses/MIT"
    },
    {
        "id": "gr",
        "name": "Grommet-Icons",
        "projectUrl": "https://github.com/grommet/grommet-icons",
        "license": "Apache License Version 2.0",
        "licenseUrl": "http://www.apache.org/licenses/"
    },
    {
        "id": "hi",
        "name": "Heroicons",
        "projectUrl": "https://github.com/tailwindlabs/heroicons",
        "license": "MIT",
        "licenseUrl": "https://opensource.org/licenses/MIT"
    },
    {
        "id": "hi2",
        "name": "Heroicons 2",
        "projectUrl": "https://github.com/tailwindlabs/heroicons",
        "license": "MIT",
        "licenseUrl": "https://opensource.org/licenses/MIT"
    },
    {
        "id": "si",
        "name": "Simple Icons",
        "projectUrl": "https://simpleicons.org/",
        "license": "CC0 1.0 Universal",
        "licenseUrl": "https://creativecommons.org/publicdomain/zero/1.0/"
    },
    {
        "id": "sl",
        "name": "Simple Line Icons",
        "projectUrl": "https://thesabbir.github.io/simple-line-icons/",
        "license": "MIT",
        "licenseUrl": "https://opensource.org/licenses/MIT"
    },
    {
        "id": "im",
        "name": "IcoMoon Free",
        "projectUrl": "https://github.com/Keyamoon/IcoMoon-Free",
        "license": "CC BY 4.0 License",
        "licenseUrl": "https://github.com/Keyamoon/IcoMoon-Free/blob/master/License.txt"
    },
    {
        "id": "bi",
        "name": "BoxIcons",
        "projectUrl": "https://github.com/atisawd/boxicons",
        "license": "CC BY 4.0 License",
        "licenseUrl": "https://github.com/atisawd/boxicons/blob/master/LICENSE"
    },
    {
        "id": "cg",
        "name": "css.gg",
        "projectUrl": "https://github.com/astrit/css.gg",
        "license": "MIT",
        "licenseUrl": "https://opensource.org/licenses/MIT"
    },
    {
        "id": "vsc",
        "name": "VS Code Icons",
        "projectUrl": "https://github.com/microsoft/vscode-codicons",
        "license": "CC BY 4.0",
        "licenseUrl": "https://creativecommons.org/licenses/by/4.0/"
    },
    {
        "id": "tb",
        "name": "Tabler Icons",
        "projectUrl": "https://github.com/tabler/tabler-icons",
        "license": "MIT",
        "licenseUrl": "https://opensource.org/licenses/MIT"
    },
    {
        "id": "tfi",
        "name": "Themify Icons",
        "projectUrl": "https://github.com/lykmapipo/themify-icons",
        "license": "MIT",
        "licenseUrl": "https://github.com/thecreation/standard-icons/blob/master/modules/themify-icons/LICENSE"
    },
    {
        "id": "rx",
        "name": "Radix Icons",
        "projectUrl": "https://icons.radix-ui.com",
        "license": "MIT",
        "licenseUrl": "https://github.com/radix-ui/icons/blob/master/LICENSE"
    },
    {
        "id": "pi",
        "name": "Phosphor Icons",
        "projectUrl": "https://github.com/phosphor-icons/core",
        "license": "MIT",
        "licenseUrl": "https://github.com/phosphor-icons/core/blob/main/LICENSE"
    },
    {
        "id": "lia",
        "name": "Icons8 Line Awesome",
        "projectUrl": "https://icons8.com/line-awesome",
        "license": "MIT",
        "licenseUrl": "https://github.com/icons8/line-awesome/blob/master/LICENSE.md"
    }
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"5XN5J":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "GenIcon", ()=>GenIcon);
parcelHelpers.export(exports, "IconBase", ()=>IconBase);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _iconContext = require("./iconContext");
var __assign = undefined && undefined.__assign || function() {
    __assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
function Tree2Element(tree) {
    return tree && tree.map(function(node, i) {
        return (0, _reactDefault.default).createElement(node.tag, __assign({
            key: i
        }, node.attr), Tree2Element(node.child));
    });
}
function GenIcon(data) {
    // eslint-disable-next-line react/display-name
    return function(props) {
        return (0, _reactDefault.default).createElement(IconBase, __assign({
            attr: __assign({}, data.attr)
        }, props), Tree2Element(data.child));
    };
}
function IconBase(props) {
    var elem = function(conf) {
        var attr = props.attr, size = props.size, title = props.title, svgProps = __rest(props, [
            "attr",
            "size",
            "title"
        ]);
        var computedSize = size || conf.size || "1em";
        var className;
        if (conf.className) className = conf.className;
        if (props.className) className = (className ? className + " " : "") + props.className;
        return (0, _reactDefault.default).createElement("svg", __assign({
            stroke: "currentColor",
            fill: "currentColor",
            strokeWidth: "0"
        }, conf.attr, attr, svgProps, {
            className: className,
            style: __assign(__assign({
                color: props.color || conf.color
            }, conf.style), props.style),
            height: computedSize,
            width: computedSize,
            xmlns: "http://www.w3.org/2000/svg"
        }), title && (0, _reactDefault.default).createElement("title", null, title), props.children);
    };
    return (0, _iconContext.IconContext) !== undefined ? (0, _reactDefault.default).createElement((0, _iconContext.IconContext).Consumer, null, function(conf) {
        return elem(conf);
    }) : elem((0, _iconContext.DefaultContext));
}

},{"react":"6uln9","./iconContext":"dsBDH","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"dsBDH":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DefaultContext", ()=>DefaultContext);
parcelHelpers.export(exports, "IconContext", ()=>IconContext);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var DefaultContext = {
    color: undefined,
    size: undefined,
    className: undefined,
    style: undefined,
    attr: undefined
};
var IconContext = (0, _reactDefault.default).createContext && (0, _reactDefault.default).createContext(DefaultContext);

},{"react":"6uln9","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"75gjJ":[function() {},{}],"i0aNL":[function(require,module,exports) {
module.exports = require("a42bb428f150cebb").getBundleURL("8aiQJ") + "enter.84bc31e6.png";

},{"a42bb428f150cebb":"c7Tr5"}],"7C0JV":[function(require,module,exports) {
// import Mint from '../components/Mint/Mint'
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Home);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _intro = require("./Intro");
var _introDefault = parcelHelpers.interopDefault(_intro);
var _story1 = require("./Story1");
var _story1Default = parcelHelpers.interopDefault(_story1);
var _story2 = require("./Story2");
var _story2Default = parcelHelpers.interopDefault(_story2);
var _story2Caption = require("./Story2Caption");
var _story2CaptionDefault = parcelHelpers.interopDefault(_story2Caption);
var _story3 = require("./Story3");
var _story3Default = parcelHelpers.interopDefault(_story3);
var _story4 = require("./Story4");
var _story4Default = parcelHelpers.interopDefault(_story4);
var _story5 = require("./Story5");
var _story5Default = parcelHelpers.interopDefault(_story5);
var _story6Caption = require("./Story6Caption");
var _story6CaptionDefault = parcelHelpers.interopDefault(_story6Caption);
var _story6 = require("./Story6");
var _story6Default = parcelHelpers.interopDefault(_story6);
var _story7Caption = require("./Story7Caption");
var _story7CaptionDefault = parcelHelpers.interopDefault(_story7Caption);
var _story7 = require("./Story7");
var _story7Default = parcelHelpers.interopDefault(_story7);
var _story8Caption = require("./Story8Caption");
var _story8CaptionDefault = parcelHelpers.interopDefault(_story8Caption);
var _story8 = require("./Story8");
var _story8Default = parcelHelpers.interopDefault(_story8);
var _story9 = require("./Story9");
var _story9Default = parcelHelpers.interopDefault(_story9);
var _story10 = require("./Story10");
var _story10Default = parcelHelpers.interopDefault(_story10);
var _story11 = require("./Story11");
var _story11Default = parcelHelpers.interopDefault(_story11);
var _story12 = require("./Story12");
var _story12Default = parcelHelpers.interopDefault(_story12);
var _story12Caption = require("./Story12Caption");
var _story12CaptionDefault = parcelHelpers.interopDefault(_story12Caption);
var _story13Caption = require("./Story13Caption");
var _story13CaptionDefault = parcelHelpers.interopDefault(_story13Caption);
var _story13 = require("./Story13");
var _story13Default = parcelHelpers.interopDefault(_story13);
var _story14 = require("./Story14");
var _story14Default = parcelHelpers.interopDefault(_story14);
var _story14Caption = require("./Story14Caption");
var _story14CaptionDefault = parcelHelpers.interopDefault(_story14Caption);
var _story15Caption = require("./Story15Caption");
var _story15CaptionDefault = parcelHelpers.interopDefault(_story15Caption);
var _story15 = require("./Story15");
var _story15Default = parcelHelpers.interopDefault(_story15);
var _climax = require("./Climax");
var _climaxDefault = parcelHelpers.interopDefault(_climax);
var _outro = require("./Outro");
var _outroDefault = parcelHelpers.interopDefault(_outro);
var _background2Png = require("../../assets/images/Background2.png");
var _background2PngDefault = parcelHelpers.interopDefault(_background2Png);
// import '../../assets/styles/App.css'
// import '../../assets/styles/BioSlider.scss'
// import '../../assets/styles/CollectionSlider.scss'
// import '../../assets/styles/Homepage.css'
// import '../../assets/styles/Mint.css'
// import globalCSS from '../../styles/globals.css'
// import navbarCSS from '../../styles/NavBar.css'
// import aboutCSS from '../../styles/About.css'
// import '../../styles/RoadMap.css'
var _storyCss = require("../../styles/Story.css");
var _playPng = require("../../assets/images/play.png");
var _playPngDefault = parcelHelpers.interopDefault(_playPng);
var _musicPlayPng = require("../../assets/images/musicPlay.png");
var _musicPlayPngDefault = parcelHelpers.interopDefault(_musicPlayPng);
var _musicPausePng = require("../../assets/images/musicPause.png");
var _musicPausePngDefault = parcelHelpers.interopDefault(_musicPausePng);
function Home() {
    (0, _react.useEffect)(()=>{
        const audio = document.getElementById("backgroundMusic");
        const musicControl = document.getElementById("musicControl");
        const imgElement = document.getElementById("musicButtonImg");
        musicControl.addEventListener("click", ()=>{
            if (audio.paused) {
                audio.play();
                imgElement.src = (0, _musicPlayPngDefault.default);
            } else {
                audio.pause();
                imgElement.src = (0, _musicPausePngDefault.default);
            }
        });
        // Add a scroll event listener to play audio when the user scrolls down the page
        window.addEventListener("scroll", ()=>{
            // Adjust this value as needed to determine when to play audio
            const scrollThreshold = 500;
            if (window.scrollY >= scrollThreshold && audio.paused) {
                audio.play();
                imgElement.src = (0, _musicPlayPngDefault.default);
            }
        });
    }, []);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "DarkContainer noselect",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("audio", {
                id: "backgroundMusic",
                loop: true,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("source", {
                        src: "https://firebasestorage.googleapis.com/v0/b/jti-demo-93fdd.appspot.com/o/Halo.wav?alt=media&token=eb2e8b67-ffcd-449f-8eef-b13618b6cc80",
                        type: "audio/mpeg"
                    }),
                    "Your browser does not support the audio element."
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                className: "PlayButton w-12",
                id: "musicControl",
                onClick: ()=>{
                    const audio = document.getElementById("backgroundMusic");
                    // const musicControl = document.getElementById("musicControl");
                    const imgElement = document.getElementById("musicButtonImg");
                    if (audio.paused) {
                        audio.play();
                        imgElement.src = (0, _musicPlayPngDefault.default);
                    } else {
                        audio.pause();
                        imgElement.src = (0, _musicPausePngDefault.default);
                    }
                },
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                    id: "musicButtonImg",
                    src: (0, _musicPausePngDefault.default)
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "overlay",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                    draggable: "false",
                    id: "video",
                    src: (0, _background2PngDefault.default)
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _introDefault.default), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _story1Default.default), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "StoryBlock"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _story2CaptionDefault.default), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _story2Default.default), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _story3Default.default), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _story4Default.default), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _story5Default.default), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _story6CaptionDefault.default), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _story6Default.default), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _story7CaptionDefault.default), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _story7Default.default), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _story8CaptionDefault.default), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _story8Default.default), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _story9Default.default), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _story10Default.default), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _story11Default.default), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _story12CaptionDefault.default), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _story12Default.default), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _story13CaptionDefault.default), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _story13Default.default), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _story14CaptionDefault.default), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _story14Default.default), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _story15CaptionDefault.default), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _story15Default.default), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _climaxDefault.default), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _outroDefault.default), {})
        ]
    });
}

},{"react/jsx-runtime":"gaGEj","react":"6uln9","./Intro":"eyLNT","./Story1":"7Jfjf","./Story2":"bAxgI","./Story2Caption":"yneGt","./Story3":"1Nm7b","./Story4":"hlYSb","./Story5":"iFsLh","./Story6Caption":"8ouNo","./Story6":"hDMZk","./Story7Caption":"96oAh","./Story7":"1UwzB","./Story8Caption":"5w2fX","./Story8":"7xK5a","./Story9":"kZUry","./Story10":"1SDmu","./Story11":"ldQH1","./Story12":"kKjdV","./Story12Caption":"fPhMZ","./Story13Caption":"fymAk","./Story13":"h7YNc","./Story14":"lwigv","./Story14Caption":"bwppZ","./Story15Caption":"b15Im","./Story15":"45b1f","./Climax":"jdv5g","./Outro":"V6zcm","../../assets/images/Background2.png":"hbhPO","../../styles/Story.css":"jgZcN","../../assets/images/play.png":"kSWSV","../../assets/images/musicPlay.png":"fR5ag","../../assets/images/musicPause.png":"kF8ey","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"eyLNT":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Welcome);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _ai = require("react-icons/ai");
var _framerMotion = require("framer-motion");
var _reactIntersectionObserver = require("react-intersection-observer");
var _artpocalypsePng = require("../../assets/images/Artpocalypse.png");
var _artpocalypsePngDefault = parcelHelpers.interopDefault(_artpocalypsePng);
function Welcome() {
    const { ref, inView } = (0, _reactIntersectionObserver.useInView)();
    const IntroAnimation = (0, _framerMotion.useAnimation)();
    const IntroTextAnimation = (0, _framerMotion.useAnimation)();
    (0, _react.useEffect)(()=>{
        if (inView) {
            IntroAnimation.start({
                y: "0",
                opacity: 1,
                scale: [
                    .8,
                    1,
                    .8
                ],
                transition: {
                    type: "tween",
                    duration: .5,
                    bounce: 0.3
                }
            });
            IntroTextAnimation.start({
                y: "0",
                scale: 1,
                opacity: 1,
                transition: {
                    type: "tween",
                    duration: .5,
                    bounce: 0.3
                }
            });
        }
        if (!inView) {
            IntroAnimation.start({
                y: "200px",
                scale: 0,
                opacity: 0,
                transition: {
                    type: "tween",
                    duration: .5,
                    bounce: 0.3
                }
            });
            IntroTextAnimation.start({
                y: "200px",
                scale: 0,
                opacity: 0,
                transition: {
                    type: "tween",
                    duration: .5,
                    bounce: 0.3
                }
            });
        }
    }, [
        inView
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("section", {
        ref: ref,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            className: "AppContainer3",
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "NavContainer",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "NavLogo",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("a", {
                            href: "/",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _ai.AiFillHome), {})
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _framerMotion.motion).div, {
                            animate: IntroAnimation,
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                draggable: "false",
                                className: "NavLogo",
                                src: (0, _artpocalypsePngDefault.default)
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _framerMotion.motion).div, {
                            className: "StoryCaption fontArt",
                            animate: IntroTextAnimation,
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                                children: [
                                    "The Year is ",
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                        className: "fontAlt",
                                        children: "2069"
                                    }),
                                    ",  Each country is trying to one-up the others by showing that they possess the most powerful atomic weapons\u2014a dangerous game of chicken to prove who has the biggest piece."
                                ]
                            })
                        })
                    ]
                })
            })
        })
    });
}

},{"react/jsx-runtime":"gaGEj","react":"6uln9","react-icons/ai":"c3Upi","framer-motion":"fI0Q4","react-intersection-observer":"fxOjV","../../assets/images/Artpocalypse.png":"1NUNP","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"c3Upi":[function(require,module,exports) {
// THIS FILE IS AUTO GENERATED
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AiFillAccountBook", ()=>AiFillAccountBook);
parcelHelpers.export(exports, "AiFillAlert", ()=>AiFillAlert);
parcelHelpers.export(exports, "AiFillAlipayCircle", ()=>AiFillAlipayCircle);
parcelHelpers.export(exports, "AiFillAlipaySquare", ()=>AiFillAlipaySquare);
parcelHelpers.export(exports, "AiFillAliwangwang", ()=>AiFillAliwangwang);
parcelHelpers.export(exports, "AiFillAmazonCircle", ()=>AiFillAmazonCircle);
parcelHelpers.export(exports, "AiFillAmazonSquare", ()=>AiFillAmazonSquare);
parcelHelpers.export(exports, "AiFillAndroid", ()=>AiFillAndroid);
parcelHelpers.export(exports, "AiFillApi", ()=>AiFillApi);
parcelHelpers.export(exports, "AiFillApple", ()=>AiFillApple);
parcelHelpers.export(exports, "AiFillAppstore", ()=>AiFillAppstore);
parcelHelpers.export(exports, "AiFillAudio", ()=>AiFillAudio);
parcelHelpers.export(exports, "AiFillBackward", ()=>AiFillBackward);
parcelHelpers.export(exports, "AiFillBank", ()=>AiFillBank);
parcelHelpers.export(exports, "AiFillBehanceCircle", ()=>AiFillBehanceCircle);
parcelHelpers.export(exports, "AiFillBehanceSquare", ()=>AiFillBehanceSquare);
parcelHelpers.export(exports, "AiFillBell", ()=>AiFillBell);
parcelHelpers.export(exports, "AiFillBook", ()=>AiFillBook);
parcelHelpers.export(exports, "AiFillBoxPlot", ()=>AiFillBoxPlot);
parcelHelpers.export(exports, "AiFillBug", ()=>AiFillBug);
parcelHelpers.export(exports, "AiFillBuild", ()=>AiFillBuild);
parcelHelpers.export(exports, "AiFillBulb", ()=>AiFillBulb);
parcelHelpers.export(exports, "AiFillCalculator", ()=>AiFillCalculator);
parcelHelpers.export(exports, "AiFillCalendar", ()=>AiFillCalendar);
parcelHelpers.export(exports, "AiFillCamera", ()=>AiFillCamera);
parcelHelpers.export(exports, "AiFillCar", ()=>AiFillCar);
parcelHelpers.export(exports, "AiFillCaretDown", ()=>AiFillCaretDown);
parcelHelpers.export(exports, "AiFillCaretLeft", ()=>AiFillCaretLeft);
parcelHelpers.export(exports, "AiFillCaretRight", ()=>AiFillCaretRight);
parcelHelpers.export(exports, "AiFillCaretUp", ()=>AiFillCaretUp);
parcelHelpers.export(exports, "AiFillCarryOut", ()=>AiFillCarryOut);
parcelHelpers.export(exports, "AiFillCheckCircle", ()=>AiFillCheckCircle);
parcelHelpers.export(exports, "AiFillCheckSquare", ()=>AiFillCheckSquare);
parcelHelpers.export(exports, "AiFillChrome", ()=>AiFillChrome);
parcelHelpers.export(exports, "AiFillCiCircle", ()=>AiFillCiCircle);
parcelHelpers.export(exports, "AiFillClockCircle", ()=>AiFillClockCircle);
parcelHelpers.export(exports, "AiFillCloseCircle", ()=>AiFillCloseCircle);
parcelHelpers.export(exports, "AiFillCloseSquare", ()=>AiFillCloseSquare);
parcelHelpers.export(exports, "AiFillCloud", ()=>AiFillCloud);
parcelHelpers.export(exports, "AiFillCodeSandboxCircle", ()=>AiFillCodeSandboxCircle);
parcelHelpers.export(exports, "AiFillCodeSandboxSquare", ()=>AiFillCodeSandboxSquare);
parcelHelpers.export(exports, "AiFillCode", ()=>AiFillCode);
parcelHelpers.export(exports, "AiFillCodepenCircle", ()=>AiFillCodepenCircle);
parcelHelpers.export(exports, "AiFillCodepenSquare", ()=>AiFillCodepenSquare);
parcelHelpers.export(exports, "AiFillCompass", ()=>AiFillCompass);
parcelHelpers.export(exports, "AiFillContacts", ()=>AiFillContacts);
parcelHelpers.export(exports, "AiFillContainer", ()=>AiFillContainer);
parcelHelpers.export(exports, "AiFillControl", ()=>AiFillControl);
parcelHelpers.export(exports, "AiFillCopy", ()=>AiFillCopy);
parcelHelpers.export(exports, "AiFillCopyrightCircle", ()=>AiFillCopyrightCircle);
parcelHelpers.export(exports, "AiFillCreditCard", ()=>AiFillCreditCard);
parcelHelpers.export(exports, "AiFillCrown", ()=>AiFillCrown);
parcelHelpers.export(exports, "AiFillCustomerService", ()=>AiFillCustomerService);
parcelHelpers.export(exports, "AiFillDashboard", ()=>AiFillDashboard);
parcelHelpers.export(exports, "AiFillDatabase", ()=>AiFillDatabase);
parcelHelpers.export(exports, "AiFillDelete", ()=>AiFillDelete);
parcelHelpers.export(exports, "AiFillDiff", ()=>AiFillDiff);
parcelHelpers.export(exports, "AiFillDingtalkCircle", ()=>AiFillDingtalkCircle);
parcelHelpers.export(exports, "AiFillDingtalkSquare", ()=>AiFillDingtalkSquare);
parcelHelpers.export(exports, "AiFillDislike", ()=>AiFillDislike);
parcelHelpers.export(exports, "AiFillDollarCircle", ()=>AiFillDollarCircle);
parcelHelpers.export(exports, "AiFillDownCircle", ()=>AiFillDownCircle);
parcelHelpers.export(exports, "AiFillDownSquare", ()=>AiFillDownSquare);
parcelHelpers.export(exports, "AiFillDribbbleCircle", ()=>AiFillDribbbleCircle);
parcelHelpers.export(exports, "AiFillDribbbleSquare", ()=>AiFillDribbbleSquare);
parcelHelpers.export(exports, "AiFillDropboxCircle", ()=>AiFillDropboxCircle);
parcelHelpers.export(exports, "AiFillDropboxSquare", ()=>AiFillDropboxSquare);
parcelHelpers.export(exports, "AiFillEdit", ()=>AiFillEdit);
parcelHelpers.export(exports, "AiFillEnvironment", ()=>AiFillEnvironment);
parcelHelpers.export(exports, "AiFillEuroCircle", ()=>AiFillEuroCircle);
parcelHelpers.export(exports, "AiFillExclamationCircle", ()=>AiFillExclamationCircle);
parcelHelpers.export(exports, "AiFillExperiment", ()=>AiFillExperiment);
parcelHelpers.export(exports, "AiFillEyeInvisible", ()=>AiFillEyeInvisible);
parcelHelpers.export(exports, "AiFillEye", ()=>AiFillEye);
parcelHelpers.export(exports, "AiFillFacebook", ()=>AiFillFacebook);
parcelHelpers.export(exports, "AiFillFastBackward", ()=>AiFillFastBackward);
parcelHelpers.export(exports, "AiFillFastForward", ()=>AiFillFastForward);
parcelHelpers.export(exports, "AiFillFileAdd", ()=>AiFillFileAdd);
parcelHelpers.export(exports, "AiFillFileExcel", ()=>AiFillFileExcel);
parcelHelpers.export(exports, "AiFillFileExclamation", ()=>AiFillFileExclamation);
parcelHelpers.export(exports, "AiFillFileImage", ()=>AiFillFileImage);
parcelHelpers.export(exports, "AiFillFileMarkdown", ()=>AiFillFileMarkdown);
parcelHelpers.export(exports, "AiFillFilePdf", ()=>AiFillFilePdf);
parcelHelpers.export(exports, "AiFillFilePpt", ()=>AiFillFilePpt);
parcelHelpers.export(exports, "AiFillFileText", ()=>AiFillFileText);
parcelHelpers.export(exports, "AiFillFileUnknown", ()=>AiFillFileUnknown);
parcelHelpers.export(exports, "AiFillFileWord", ()=>AiFillFileWord);
parcelHelpers.export(exports, "AiFillFileZip", ()=>AiFillFileZip);
parcelHelpers.export(exports, "AiFillFile", ()=>AiFillFile);
parcelHelpers.export(exports, "AiFillFilter", ()=>AiFillFilter);
parcelHelpers.export(exports, "AiFillFire", ()=>AiFillFire);
parcelHelpers.export(exports, "AiFillFlag", ()=>AiFillFlag);
parcelHelpers.export(exports, "AiFillFolderAdd", ()=>AiFillFolderAdd);
parcelHelpers.export(exports, "AiFillFolderOpen", ()=>AiFillFolderOpen);
parcelHelpers.export(exports, "AiFillFolder", ()=>AiFillFolder);
parcelHelpers.export(exports, "AiFillFormatPainter", ()=>AiFillFormatPainter);
parcelHelpers.export(exports, "AiFillForward", ()=>AiFillForward);
parcelHelpers.export(exports, "AiFillFrown", ()=>AiFillFrown);
parcelHelpers.export(exports, "AiFillFund", ()=>AiFillFund);
parcelHelpers.export(exports, "AiFillFunnelPlot", ()=>AiFillFunnelPlot);
parcelHelpers.export(exports, "AiFillGift", ()=>AiFillGift);
parcelHelpers.export(exports, "AiFillGithub", ()=>AiFillGithub);
parcelHelpers.export(exports, "AiFillGitlab", ()=>AiFillGitlab);
parcelHelpers.export(exports, "AiFillGold", ()=>AiFillGold);
parcelHelpers.export(exports, "AiFillGolden", ()=>AiFillGolden);
parcelHelpers.export(exports, "AiFillGoogleCircle", ()=>AiFillGoogleCircle);
parcelHelpers.export(exports, "AiFillGooglePlusCircle", ()=>AiFillGooglePlusCircle);
parcelHelpers.export(exports, "AiFillGooglePlusSquare", ()=>AiFillGooglePlusSquare);
parcelHelpers.export(exports, "AiFillGoogleSquare", ()=>AiFillGoogleSquare);
parcelHelpers.export(exports, "AiFillHdd", ()=>AiFillHdd);
parcelHelpers.export(exports, "AiFillHeart", ()=>AiFillHeart);
parcelHelpers.export(exports, "AiFillHighlight", ()=>AiFillHighlight);
parcelHelpers.export(exports, "AiFillHome", ()=>AiFillHome);
parcelHelpers.export(exports, "AiFillHourglass", ()=>AiFillHourglass);
parcelHelpers.export(exports, "AiFillHtml5", ()=>AiFillHtml5);
parcelHelpers.export(exports, "AiFillIdcard", ()=>AiFillIdcard);
parcelHelpers.export(exports, "AiFillIeCircle", ()=>AiFillIeCircle);
parcelHelpers.export(exports, "AiFillIeSquare", ()=>AiFillIeSquare);
parcelHelpers.export(exports, "AiFillInfoCircle", ()=>AiFillInfoCircle);
parcelHelpers.export(exports, "AiFillInstagram", ()=>AiFillInstagram);
parcelHelpers.export(exports, "AiFillInsurance", ()=>AiFillInsurance);
parcelHelpers.export(exports, "AiFillInteraction", ()=>AiFillInteraction);
parcelHelpers.export(exports, "AiFillLayout", ()=>AiFillLayout);
parcelHelpers.export(exports, "AiFillLeftCircle", ()=>AiFillLeftCircle);
parcelHelpers.export(exports, "AiFillLeftSquare", ()=>AiFillLeftSquare);
parcelHelpers.export(exports, "AiFillLike", ()=>AiFillLike);
parcelHelpers.export(exports, "AiFillLinkedin", ()=>AiFillLinkedin);
parcelHelpers.export(exports, "AiFillLock", ()=>AiFillLock);
parcelHelpers.export(exports, "AiFillMacCommand", ()=>AiFillMacCommand);
parcelHelpers.export(exports, "AiFillMail", ()=>AiFillMail);
parcelHelpers.export(exports, "AiFillMedicineBox", ()=>AiFillMedicineBox);
parcelHelpers.export(exports, "AiFillMediumCircle", ()=>AiFillMediumCircle);
parcelHelpers.export(exports, "AiFillMediumSquare", ()=>AiFillMediumSquare);
parcelHelpers.export(exports, "AiFillMeh", ()=>AiFillMeh);
parcelHelpers.export(exports, "AiFillMessage", ()=>AiFillMessage);
parcelHelpers.export(exports, "AiFillMinusCircle", ()=>AiFillMinusCircle);
parcelHelpers.export(exports, "AiFillMinusSquare", ()=>AiFillMinusSquare);
parcelHelpers.export(exports, "AiFillMobile", ()=>AiFillMobile);
parcelHelpers.export(exports, "AiFillMoneyCollect", ()=>AiFillMoneyCollect);
parcelHelpers.export(exports, "AiFillNotification", ()=>AiFillNotification);
parcelHelpers.export(exports, "AiFillPauseCircle", ()=>AiFillPauseCircle);
parcelHelpers.export(exports, "AiFillPayCircle", ()=>AiFillPayCircle);
parcelHelpers.export(exports, "AiFillPhone", ()=>AiFillPhone);
parcelHelpers.export(exports, "AiFillPicture", ()=>AiFillPicture);
parcelHelpers.export(exports, "AiFillPieChart", ()=>AiFillPieChart);
parcelHelpers.export(exports, "AiFillPlayCircle", ()=>AiFillPlayCircle);
parcelHelpers.export(exports, "AiFillPlaySquare", ()=>AiFillPlaySquare);
parcelHelpers.export(exports, "AiFillPlusCircle", ()=>AiFillPlusCircle);
parcelHelpers.export(exports, "AiFillPlusSquare", ()=>AiFillPlusSquare);
parcelHelpers.export(exports, "AiFillPoundCircle", ()=>AiFillPoundCircle);
parcelHelpers.export(exports, "AiFillPrinter", ()=>AiFillPrinter);
parcelHelpers.export(exports, "AiFillProfile", ()=>AiFillProfile);
parcelHelpers.export(exports, "AiFillProject", ()=>AiFillProject);
parcelHelpers.export(exports, "AiFillPropertySafety", ()=>AiFillPropertySafety);
parcelHelpers.export(exports, "AiFillPushpin", ()=>AiFillPushpin);
parcelHelpers.export(exports, "AiFillQqCircle", ()=>AiFillQqCircle);
parcelHelpers.export(exports, "AiFillQqSquare", ()=>AiFillQqSquare);
parcelHelpers.export(exports, "AiFillQuestionCircle", ()=>AiFillQuestionCircle);
parcelHelpers.export(exports, "AiFillRead", ()=>AiFillRead);
parcelHelpers.export(exports, "AiFillReconciliation", ()=>AiFillReconciliation);
parcelHelpers.export(exports, "AiFillRedEnvelope", ()=>AiFillRedEnvelope);
parcelHelpers.export(exports, "AiFillRedditCircle", ()=>AiFillRedditCircle);
parcelHelpers.export(exports, "AiFillRedditSquare", ()=>AiFillRedditSquare);
parcelHelpers.export(exports, "AiFillRest", ()=>AiFillRest);
parcelHelpers.export(exports, "AiFillRightCircle", ()=>AiFillRightCircle);
parcelHelpers.export(exports, "AiFillRightSquare", ()=>AiFillRightSquare);
parcelHelpers.export(exports, "AiFillRobot", ()=>AiFillRobot);
parcelHelpers.export(exports, "AiFillRocket", ()=>AiFillRocket);
parcelHelpers.export(exports, "AiFillSafetyCertificate", ()=>AiFillSafetyCertificate);
parcelHelpers.export(exports, "AiFillSave", ()=>AiFillSave);
parcelHelpers.export(exports, "AiFillSchedule", ()=>AiFillSchedule);
parcelHelpers.export(exports, "AiFillSecurityScan", ()=>AiFillSecurityScan);
parcelHelpers.export(exports, "AiFillSetting", ()=>AiFillSetting);
parcelHelpers.export(exports, "AiFillShop", ()=>AiFillShop);
parcelHelpers.export(exports, "AiFillShopping", ()=>AiFillShopping);
parcelHelpers.export(exports, "AiFillSignal", ()=>AiFillSignal);
parcelHelpers.export(exports, "AiFillSketchCircle", ()=>AiFillSketchCircle);
parcelHelpers.export(exports, "AiFillSketchSquare", ()=>AiFillSketchSquare);
parcelHelpers.export(exports, "AiFillSkin", ()=>AiFillSkin);
parcelHelpers.export(exports, "AiFillSkype", ()=>AiFillSkype);
parcelHelpers.export(exports, "AiFillSlackCircle", ()=>AiFillSlackCircle);
parcelHelpers.export(exports, "AiFillSlackSquare", ()=>AiFillSlackSquare);
parcelHelpers.export(exports, "AiFillSliders", ()=>AiFillSliders);
parcelHelpers.export(exports, "AiFillSmile", ()=>AiFillSmile);
parcelHelpers.export(exports, "AiFillSnippets", ()=>AiFillSnippets);
parcelHelpers.export(exports, "AiFillSound", ()=>AiFillSound);
parcelHelpers.export(exports, "AiFillStar", ()=>AiFillStar);
parcelHelpers.export(exports, "AiFillStepBackward", ()=>AiFillStepBackward);
parcelHelpers.export(exports, "AiFillStepForward", ()=>AiFillStepForward);
parcelHelpers.export(exports, "AiFillStop", ()=>AiFillStop);
parcelHelpers.export(exports, "AiFillSwitcher", ()=>AiFillSwitcher);
parcelHelpers.export(exports, "AiFillTablet", ()=>AiFillTablet);
parcelHelpers.export(exports, "AiFillTag", ()=>AiFillTag);
parcelHelpers.export(exports, "AiFillTags", ()=>AiFillTags);
parcelHelpers.export(exports, "AiFillTaobaoCircle", ()=>AiFillTaobaoCircle);
parcelHelpers.export(exports, "AiFillTaobaoSquare", ()=>AiFillTaobaoSquare);
parcelHelpers.export(exports, "AiFillThunderbolt", ()=>AiFillThunderbolt);
parcelHelpers.export(exports, "AiFillTool", ()=>AiFillTool);
parcelHelpers.export(exports, "AiFillTrademarkCircle", ()=>AiFillTrademarkCircle);
parcelHelpers.export(exports, "AiFillTrophy", ()=>AiFillTrophy);
parcelHelpers.export(exports, "AiFillTwitterCircle", ()=>AiFillTwitterCircle);
parcelHelpers.export(exports, "AiFillTwitterSquare", ()=>AiFillTwitterSquare);
parcelHelpers.export(exports, "AiFillUnlock", ()=>AiFillUnlock);
parcelHelpers.export(exports, "AiFillUpCircle", ()=>AiFillUpCircle);
parcelHelpers.export(exports, "AiFillUpSquare", ()=>AiFillUpSquare);
parcelHelpers.export(exports, "AiFillUsb", ()=>AiFillUsb);
parcelHelpers.export(exports, "AiFillVideoCamera", ()=>AiFillVideoCamera);
parcelHelpers.export(exports, "AiFillWallet", ()=>AiFillWallet);
parcelHelpers.export(exports, "AiFillWarning", ()=>AiFillWarning);
parcelHelpers.export(exports, "AiFillWechat", ()=>AiFillWechat);
parcelHelpers.export(exports, "AiFillWeiboCircle", ()=>AiFillWeiboCircle);
parcelHelpers.export(exports, "AiFillWeiboSquare", ()=>AiFillWeiboSquare);
parcelHelpers.export(exports, "AiFillWindows", ()=>AiFillWindows);
parcelHelpers.export(exports, "AiFillYahoo", ()=>AiFillYahoo);
parcelHelpers.export(exports, "AiFillYoutube", ()=>AiFillYoutube);
parcelHelpers.export(exports, "AiFillYuque", ()=>AiFillYuque);
parcelHelpers.export(exports, "AiFillZhihuCircle", ()=>AiFillZhihuCircle);
parcelHelpers.export(exports, "AiFillZhihuSquare", ()=>AiFillZhihuSquare);
parcelHelpers.export(exports, "AiOutlineAccountBook", ()=>AiOutlineAccountBook);
parcelHelpers.export(exports, "AiOutlineAim", ()=>AiOutlineAim);
parcelHelpers.export(exports, "AiOutlineAlert", ()=>AiOutlineAlert);
parcelHelpers.export(exports, "AiOutlineAlibaba", ()=>AiOutlineAlibaba);
parcelHelpers.export(exports, "AiOutlineAlignCenter", ()=>AiOutlineAlignCenter);
parcelHelpers.export(exports, "AiOutlineAlignLeft", ()=>AiOutlineAlignLeft);
parcelHelpers.export(exports, "AiOutlineAlignRight", ()=>AiOutlineAlignRight);
parcelHelpers.export(exports, "AiOutlineAlipayCircle", ()=>AiOutlineAlipayCircle);
parcelHelpers.export(exports, "AiOutlineAlipay", ()=>AiOutlineAlipay);
parcelHelpers.export(exports, "AiOutlineAliwangwang", ()=>AiOutlineAliwangwang);
parcelHelpers.export(exports, "AiOutlineAliyun", ()=>AiOutlineAliyun);
parcelHelpers.export(exports, "AiOutlineAmazon", ()=>AiOutlineAmazon);
parcelHelpers.export(exports, "AiOutlineAndroid", ()=>AiOutlineAndroid);
parcelHelpers.export(exports, "AiOutlineAntCloud", ()=>AiOutlineAntCloud);
parcelHelpers.export(exports, "AiOutlineAntDesign", ()=>AiOutlineAntDesign);
parcelHelpers.export(exports, "AiOutlineApartment", ()=>AiOutlineApartment);
parcelHelpers.export(exports, "AiOutlineApi", ()=>AiOutlineApi);
parcelHelpers.export(exports, "AiOutlineApple", ()=>AiOutlineApple);
parcelHelpers.export(exports, "AiOutlineAppstoreAdd", ()=>AiOutlineAppstoreAdd);
parcelHelpers.export(exports, "AiOutlineAppstore", ()=>AiOutlineAppstore);
parcelHelpers.export(exports, "AiOutlineAreaChart", ()=>AiOutlineAreaChart);
parcelHelpers.export(exports, "AiOutlineArrowDown", ()=>AiOutlineArrowDown);
parcelHelpers.export(exports, "AiOutlineArrowLeft", ()=>AiOutlineArrowLeft);
parcelHelpers.export(exports, "AiOutlineArrowRight", ()=>AiOutlineArrowRight);
parcelHelpers.export(exports, "AiOutlineArrowUp", ()=>AiOutlineArrowUp);
parcelHelpers.export(exports, "AiOutlineArrowsAlt", ()=>AiOutlineArrowsAlt);
parcelHelpers.export(exports, "AiOutlineAudioMuted", ()=>AiOutlineAudioMuted);
parcelHelpers.export(exports, "AiOutlineAudio", ()=>AiOutlineAudio);
parcelHelpers.export(exports, "AiOutlineAudit", ()=>AiOutlineAudit);
parcelHelpers.export(exports, "AiOutlineBackward", ()=>AiOutlineBackward);
parcelHelpers.export(exports, "AiOutlineBank", ()=>AiOutlineBank);
parcelHelpers.export(exports, "AiOutlineBarChart", ()=>AiOutlineBarChart);
parcelHelpers.export(exports, "AiOutlineBarcode", ()=>AiOutlineBarcode);
parcelHelpers.export(exports, "AiOutlineBars", ()=>AiOutlineBars);
parcelHelpers.export(exports, "AiOutlineBehanceSquare", ()=>AiOutlineBehanceSquare);
parcelHelpers.export(exports, "AiOutlineBehance", ()=>AiOutlineBehance);
parcelHelpers.export(exports, "AiOutlineBell", ()=>AiOutlineBell);
parcelHelpers.export(exports, "AiOutlineBgColors", ()=>AiOutlineBgColors);
parcelHelpers.export(exports, "AiOutlineBlock", ()=>AiOutlineBlock);
parcelHelpers.export(exports, "AiOutlineBold", ()=>AiOutlineBold);
parcelHelpers.export(exports, "AiOutlineBook", ()=>AiOutlineBook);
parcelHelpers.export(exports, "AiOutlineBorderBottom", ()=>AiOutlineBorderBottom);
parcelHelpers.export(exports, "AiOutlineBorderHorizontal", ()=>AiOutlineBorderHorizontal);
parcelHelpers.export(exports, "AiOutlineBorderInner", ()=>AiOutlineBorderInner);
parcelHelpers.export(exports, "AiOutlineBorderLeft", ()=>AiOutlineBorderLeft);
parcelHelpers.export(exports, "AiOutlineBorderOuter", ()=>AiOutlineBorderOuter);
parcelHelpers.export(exports, "AiOutlineBorderRight", ()=>AiOutlineBorderRight);
parcelHelpers.export(exports, "AiOutlineBorderTop", ()=>AiOutlineBorderTop);
parcelHelpers.export(exports, "AiOutlineBorderVerticle", ()=>AiOutlineBorderVerticle);
parcelHelpers.export(exports, "AiOutlineBorder", ()=>AiOutlineBorder);
parcelHelpers.export(exports, "AiOutlineBorderlessTable", ()=>AiOutlineBorderlessTable);
parcelHelpers.export(exports, "AiOutlineBoxPlot", ()=>AiOutlineBoxPlot);
parcelHelpers.export(exports, "AiOutlineBranches", ()=>AiOutlineBranches);
parcelHelpers.export(exports, "AiOutlineBug", ()=>AiOutlineBug);
parcelHelpers.export(exports, "AiOutlineBuild", ()=>AiOutlineBuild);
parcelHelpers.export(exports, "AiOutlineBulb", ()=>AiOutlineBulb);
parcelHelpers.export(exports, "AiOutlineCalculator", ()=>AiOutlineCalculator);
parcelHelpers.export(exports, "AiOutlineCalendar", ()=>AiOutlineCalendar);
parcelHelpers.export(exports, "AiOutlineCamera", ()=>AiOutlineCamera);
parcelHelpers.export(exports, "AiOutlineCar", ()=>AiOutlineCar);
parcelHelpers.export(exports, "AiOutlineCaretDown", ()=>AiOutlineCaretDown);
parcelHelpers.export(exports, "AiOutlineCaretLeft", ()=>AiOutlineCaretLeft);
parcelHelpers.export(exports, "AiOutlineCaretRight", ()=>AiOutlineCaretRight);
parcelHelpers.export(exports, "AiOutlineCaretUp", ()=>AiOutlineCaretUp);
parcelHelpers.export(exports, "AiOutlineCarryOut", ()=>AiOutlineCarryOut);
parcelHelpers.export(exports, "AiOutlineCheckCircle", ()=>AiOutlineCheckCircle);
parcelHelpers.export(exports, "AiOutlineCheckSquare", ()=>AiOutlineCheckSquare);
parcelHelpers.export(exports, "AiOutlineCheck", ()=>AiOutlineCheck);
parcelHelpers.export(exports, "AiOutlineChrome", ()=>AiOutlineChrome);
parcelHelpers.export(exports, "AiOutlineCiCircle", ()=>AiOutlineCiCircle);
parcelHelpers.export(exports, "AiOutlineCi", ()=>AiOutlineCi);
parcelHelpers.export(exports, "AiOutlineClear", ()=>AiOutlineClear);
parcelHelpers.export(exports, "AiOutlineClockCircle", ()=>AiOutlineClockCircle);
parcelHelpers.export(exports, "AiOutlineCloseCircle", ()=>AiOutlineCloseCircle);
parcelHelpers.export(exports, "AiOutlineCloseSquare", ()=>AiOutlineCloseSquare);
parcelHelpers.export(exports, "AiOutlineClose", ()=>AiOutlineClose);
parcelHelpers.export(exports, "AiOutlineCloudDownload", ()=>AiOutlineCloudDownload);
parcelHelpers.export(exports, "AiOutlineCloudServer", ()=>AiOutlineCloudServer);
parcelHelpers.export(exports, "AiOutlineCloudSync", ()=>AiOutlineCloudSync);
parcelHelpers.export(exports, "AiOutlineCloudUpload", ()=>AiOutlineCloudUpload);
parcelHelpers.export(exports, "AiOutlineCloud", ()=>AiOutlineCloud);
parcelHelpers.export(exports, "AiOutlineCluster", ()=>AiOutlineCluster);
parcelHelpers.export(exports, "AiOutlineCodeSandbox", ()=>AiOutlineCodeSandbox);
parcelHelpers.export(exports, "AiOutlineCode", ()=>AiOutlineCode);
parcelHelpers.export(exports, "AiOutlineCodepenCircle", ()=>AiOutlineCodepenCircle);
parcelHelpers.export(exports, "AiOutlineCodepen", ()=>AiOutlineCodepen);
parcelHelpers.export(exports, "AiOutlineCoffee", ()=>AiOutlineCoffee);
parcelHelpers.export(exports, "AiOutlineColumnHeight", ()=>AiOutlineColumnHeight);
parcelHelpers.export(exports, "AiOutlineColumnWidth", ()=>AiOutlineColumnWidth);
parcelHelpers.export(exports, "AiOutlineComment", ()=>AiOutlineComment);
parcelHelpers.export(exports, "AiOutlineCompass", ()=>AiOutlineCompass);
parcelHelpers.export(exports, "AiOutlineCompress", ()=>AiOutlineCompress);
parcelHelpers.export(exports, "AiOutlineConsoleSql", ()=>AiOutlineConsoleSql);
parcelHelpers.export(exports, "AiOutlineContacts", ()=>AiOutlineContacts);
parcelHelpers.export(exports, "AiOutlineContainer", ()=>AiOutlineContainer);
parcelHelpers.export(exports, "AiOutlineControl", ()=>AiOutlineControl);
parcelHelpers.export(exports, "AiOutlineCopy", ()=>AiOutlineCopy);
parcelHelpers.export(exports, "AiOutlineCopyrightCircle", ()=>AiOutlineCopyrightCircle);
parcelHelpers.export(exports, "AiOutlineCopyright", ()=>AiOutlineCopyright);
parcelHelpers.export(exports, "AiOutlineCreditCard", ()=>AiOutlineCreditCard);
parcelHelpers.export(exports, "AiOutlineCrown", ()=>AiOutlineCrown);
parcelHelpers.export(exports, "AiOutlineCustomerService", ()=>AiOutlineCustomerService);
parcelHelpers.export(exports, "AiOutlineDash", ()=>AiOutlineDash);
parcelHelpers.export(exports, "AiOutlineDashboard", ()=>AiOutlineDashboard);
parcelHelpers.export(exports, "AiOutlineDatabase", ()=>AiOutlineDatabase);
parcelHelpers.export(exports, "AiOutlineDeleteColumn", ()=>AiOutlineDeleteColumn);
parcelHelpers.export(exports, "AiOutlineDeleteRow", ()=>AiOutlineDeleteRow);
parcelHelpers.export(exports, "AiOutlineDelete", ()=>AiOutlineDelete);
parcelHelpers.export(exports, "AiOutlineDeliveredProcedure", ()=>AiOutlineDeliveredProcedure);
parcelHelpers.export(exports, "AiOutlineDeploymentUnit", ()=>AiOutlineDeploymentUnit);
parcelHelpers.export(exports, "AiOutlineDesktop", ()=>AiOutlineDesktop);
parcelHelpers.export(exports, "AiOutlineDiff", ()=>AiOutlineDiff);
parcelHelpers.export(exports, "AiOutlineDingding", ()=>AiOutlineDingding);
parcelHelpers.export(exports, "AiOutlineDingtalk", ()=>AiOutlineDingtalk);
parcelHelpers.export(exports, "AiOutlineDisconnect", ()=>AiOutlineDisconnect);
parcelHelpers.export(exports, "AiOutlineDislike", ()=>AiOutlineDislike);
parcelHelpers.export(exports, "AiOutlineDollarCircle", ()=>AiOutlineDollarCircle);
parcelHelpers.export(exports, "AiOutlineDollar", ()=>AiOutlineDollar);
parcelHelpers.export(exports, "AiOutlineDotChart", ()=>AiOutlineDotChart);
parcelHelpers.export(exports, "AiOutlineDoubleLeft", ()=>AiOutlineDoubleLeft);
parcelHelpers.export(exports, "AiOutlineDoubleRight", ()=>AiOutlineDoubleRight);
parcelHelpers.export(exports, "AiOutlineDownCircle", ()=>AiOutlineDownCircle);
parcelHelpers.export(exports, "AiOutlineDownSquare", ()=>AiOutlineDownSquare);
parcelHelpers.export(exports, "AiOutlineDown", ()=>AiOutlineDown);
parcelHelpers.export(exports, "AiOutlineDownload", ()=>AiOutlineDownload);
parcelHelpers.export(exports, "AiOutlineDrag", ()=>AiOutlineDrag);
parcelHelpers.export(exports, "AiOutlineDribbbleSquare", ()=>AiOutlineDribbbleSquare);
parcelHelpers.export(exports, "AiOutlineDribbble", ()=>AiOutlineDribbble);
parcelHelpers.export(exports, "AiOutlineDropbox", ()=>AiOutlineDropbox);
parcelHelpers.export(exports, "AiOutlineEdit", ()=>AiOutlineEdit);
parcelHelpers.export(exports, "AiOutlineEllipsis", ()=>AiOutlineEllipsis);
parcelHelpers.export(exports, "AiOutlineEnter", ()=>AiOutlineEnter);
parcelHelpers.export(exports, "AiOutlineEnvironment", ()=>AiOutlineEnvironment);
parcelHelpers.export(exports, "AiOutlineEuroCircle", ()=>AiOutlineEuroCircle);
parcelHelpers.export(exports, "AiOutlineEuro", ()=>AiOutlineEuro);
parcelHelpers.export(exports, "AiOutlineException", ()=>AiOutlineException);
parcelHelpers.export(exports, "AiOutlineExclamationCircle", ()=>AiOutlineExclamationCircle);
parcelHelpers.export(exports, "AiOutlineExclamation", ()=>AiOutlineExclamation);
parcelHelpers.export(exports, "AiOutlineExpandAlt", ()=>AiOutlineExpandAlt);
parcelHelpers.export(exports, "AiOutlineExpand", ()=>AiOutlineExpand);
parcelHelpers.export(exports, "AiOutlineExperiment", ()=>AiOutlineExperiment);
parcelHelpers.export(exports, "AiOutlineExport", ()=>AiOutlineExport);
parcelHelpers.export(exports, "AiOutlineEyeInvisible", ()=>AiOutlineEyeInvisible);
parcelHelpers.export(exports, "AiOutlineEye", ()=>AiOutlineEye);
parcelHelpers.export(exports, "AiOutlineFacebook", ()=>AiOutlineFacebook);
parcelHelpers.export(exports, "AiOutlineFall", ()=>AiOutlineFall);
parcelHelpers.export(exports, "AiOutlineFastBackward", ()=>AiOutlineFastBackward);
parcelHelpers.export(exports, "AiOutlineFastForward", ()=>AiOutlineFastForward);
parcelHelpers.export(exports, "AiOutlineFieldBinary", ()=>AiOutlineFieldBinary);
parcelHelpers.export(exports, "AiOutlineFieldNumber", ()=>AiOutlineFieldNumber);
parcelHelpers.export(exports, "AiOutlineFieldString", ()=>AiOutlineFieldString);
parcelHelpers.export(exports, "AiOutlineFieldTime", ()=>AiOutlineFieldTime);
parcelHelpers.export(exports, "AiOutlineFileAdd", ()=>AiOutlineFileAdd);
parcelHelpers.export(exports, "AiOutlineFileDone", ()=>AiOutlineFileDone);
parcelHelpers.export(exports, "AiOutlineFileExcel", ()=>AiOutlineFileExcel);
parcelHelpers.export(exports, "AiOutlineFileExclamation", ()=>AiOutlineFileExclamation);
parcelHelpers.export(exports, "AiOutlineFileGif", ()=>AiOutlineFileGif);
parcelHelpers.export(exports, "AiOutlineFileImage", ()=>AiOutlineFileImage);
parcelHelpers.export(exports, "AiOutlineFileJpg", ()=>AiOutlineFileJpg);
parcelHelpers.export(exports, "AiOutlineFileMarkdown", ()=>AiOutlineFileMarkdown);
parcelHelpers.export(exports, "AiOutlineFilePdf", ()=>AiOutlineFilePdf);
parcelHelpers.export(exports, "AiOutlineFilePpt", ()=>AiOutlineFilePpt);
parcelHelpers.export(exports, "AiOutlineFileProtect", ()=>AiOutlineFileProtect);
parcelHelpers.export(exports, "AiOutlineFileSearch", ()=>AiOutlineFileSearch);
parcelHelpers.export(exports, "AiOutlineFileSync", ()=>AiOutlineFileSync);
parcelHelpers.export(exports, "AiOutlineFileText", ()=>AiOutlineFileText);
parcelHelpers.export(exports, "AiOutlineFileUnknown", ()=>AiOutlineFileUnknown);
parcelHelpers.export(exports, "AiOutlineFileWord", ()=>AiOutlineFileWord);
parcelHelpers.export(exports, "AiOutlineFileZip", ()=>AiOutlineFileZip);
parcelHelpers.export(exports, "AiOutlineFile", ()=>AiOutlineFile);
parcelHelpers.export(exports, "AiOutlineFilter", ()=>AiOutlineFilter);
parcelHelpers.export(exports, "AiOutlineFire", ()=>AiOutlineFire);
parcelHelpers.export(exports, "AiOutlineFlag", ()=>AiOutlineFlag);
parcelHelpers.export(exports, "AiOutlineFolderAdd", ()=>AiOutlineFolderAdd);
parcelHelpers.export(exports, "AiOutlineFolderOpen", ()=>AiOutlineFolderOpen);
parcelHelpers.export(exports, "AiOutlineFolderView", ()=>AiOutlineFolderView);
parcelHelpers.export(exports, "AiOutlineFolder", ()=>AiOutlineFolder);
parcelHelpers.export(exports, "AiOutlineFontColors", ()=>AiOutlineFontColors);
parcelHelpers.export(exports, "AiOutlineFontSize", ()=>AiOutlineFontSize);
parcelHelpers.export(exports, "AiOutlineFork", ()=>AiOutlineFork);
parcelHelpers.export(exports, "AiOutlineForm", ()=>AiOutlineForm);
parcelHelpers.export(exports, "AiOutlineFormatPainter", ()=>AiOutlineFormatPainter);
parcelHelpers.export(exports, "AiOutlineForward", ()=>AiOutlineForward);
parcelHelpers.export(exports, "AiOutlineFrown", ()=>AiOutlineFrown);
parcelHelpers.export(exports, "AiOutlineFullscreenExit", ()=>AiOutlineFullscreenExit);
parcelHelpers.export(exports, "AiOutlineFullscreen", ()=>AiOutlineFullscreen);
parcelHelpers.export(exports, "AiOutlineFunction", ()=>AiOutlineFunction);
parcelHelpers.export(exports, "AiOutlineFundProjectionScreen", ()=>AiOutlineFundProjectionScreen);
parcelHelpers.export(exports, "AiOutlineFundView", ()=>AiOutlineFundView);
parcelHelpers.export(exports, "AiOutlineFund", ()=>AiOutlineFund);
parcelHelpers.export(exports, "AiOutlineFunnelPlot", ()=>AiOutlineFunnelPlot);
parcelHelpers.export(exports, "AiOutlineGateway", ()=>AiOutlineGateway);
parcelHelpers.export(exports, "AiOutlineGif", ()=>AiOutlineGif);
parcelHelpers.export(exports, "AiOutlineGift", ()=>AiOutlineGift);
parcelHelpers.export(exports, "AiOutlineGithub", ()=>AiOutlineGithub);
parcelHelpers.export(exports, "AiOutlineGitlab", ()=>AiOutlineGitlab);
parcelHelpers.export(exports, "AiOutlineGlobal", ()=>AiOutlineGlobal);
parcelHelpers.export(exports, "AiOutlineGold", ()=>AiOutlineGold);
parcelHelpers.export(exports, "AiOutlineGooglePlus", ()=>AiOutlineGooglePlus);
parcelHelpers.export(exports, "AiOutlineGoogle", ()=>AiOutlineGoogle);
parcelHelpers.export(exports, "AiOutlineGroup", ()=>AiOutlineGroup);
parcelHelpers.export(exports, "AiOutlineHdd", ()=>AiOutlineHdd);
parcelHelpers.export(exports, "AiOutlineHeart", ()=>AiOutlineHeart);
parcelHelpers.export(exports, "AiOutlineHeatMap", ()=>AiOutlineHeatMap);
parcelHelpers.export(exports, "AiOutlineHighlight", ()=>AiOutlineHighlight);
parcelHelpers.export(exports, "AiOutlineHistory", ()=>AiOutlineHistory);
parcelHelpers.export(exports, "AiOutlineHolder", ()=>AiOutlineHolder);
parcelHelpers.export(exports, "AiOutlineHome", ()=>AiOutlineHome);
parcelHelpers.export(exports, "AiOutlineHourglass", ()=>AiOutlineHourglass);
parcelHelpers.export(exports, "AiOutlineHtml5", ()=>AiOutlineHtml5);
parcelHelpers.export(exports, "AiOutlineIdcard", ()=>AiOutlineIdcard);
parcelHelpers.export(exports, "AiOutlineIe", ()=>AiOutlineIe);
parcelHelpers.export(exports, "AiOutlineImport", ()=>AiOutlineImport);
parcelHelpers.export(exports, "AiOutlineInbox", ()=>AiOutlineInbox);
parcelHelpers.export(exports, "AiOutlineInfoCircle", ()=>AiOutlineInfoCircle);
parcelHelpers.export(exports, "AiOutlineInfo", ()=>AiOutlineInfo);
parcelHelpers.export(exports, "AiOutlineInsertRowAbove", ()=>AiOutlineInsertRowAbove);
parcelHelpers.export(exports, "AiOutlineInsertRowBelow", ()=>AiOutlineInsertRowBelow);
parcelHelpers.export(exports, "AiOutlineInsertRowLeft", ()=>AiOutlineInsertRowLeft);
parcelHelpers.export(exports, "AiOutlineInsertRowRight", ()=>AiOutlineInsertRowRight);
parcelHelpers.export(exports, "AiOutlineInstagram", ()=>AiOutlineInstagram);
parcelHelpers.export(exports, "AiOutlineInsurance", ()=>AiOutlineInsurance);
parcelHelpers.export(exports, "AiOutlineInteraction", ()=>AiOutlineInteraction);
parcelHelpers.export(exports, "AiOutlineIssuesClose", ()=>AiOutlineIssuesClose);
parcelHelpers.export(exports, "AiOutlineItalic", ()=>AiOutlineItalic);
parcelHelpers.export(exports, "AiOutlineKey", ()=>AiOutlineKey);
parcelHelpers.export(exports, "AiOutlineLaptop", ()=>AiOutlineLaptop);
parcelHelpers.export(exports, "AiOutlineLayout", ()=>AiOutlineLayout);
parcelHelpers.export(exports, "AiOutlineLeftCircle", ()=>AiOutlineLeftCircle);
parcelHelpers.export(exports, "AiOutlineLeftSquare", ()=>AiOutlineLeftSquare);
parcelHelpers.export(exports, "AiOutlineLeft", ()=>AiOutlineLeft);
parcelHelpers.export(exports, "AiOutlineLike", ()=>AiOutlineLike);
parcelHelpers.export(exports, "AiOutlineLineChart", ()=>AiOutlineLineChart);
parcelHelpers.export(exports, "AiOutlineLineHeight", ()=>AiOutlineLineHeight);
parcelHelpers.export(exports, "AiOutlineLine", ()=>AiOutlineLine);
parcelHelpers.export(exports, "AiOutlineLink", ()=>AiOutlineLink);
parcelHelpers.export(exports, "AiOutlineLinkedin", ()=>AiOutlineLinkedin);
parcelHelpers.export(exports, "AiOutlineLoading3Quarters", ()=>AiOutlineLoading3Quarters);
parcelHelpers.export(exports, "AiOutlineLoading", ()=>AiOutlineLoading);
parcelHelpers.export(exports, "AiOutlineLock", ()=>AiOutlineLock);
parcelHelpers.export(exports, "AiOutlineLogin", ()=>AiOutlineLogin);
parcelHelpers.export(exports, "AiOutlineLogout", ()=>AiOutlineLogout);
parcelHelpers.export(exports, "AiOutlineMacCommand", ()=>AiOutlineMacCommand);
parcelHelpers.export(exports, "AiOutlineMail", ()=>AiOutlineMail);
parcelHelpers.export(exports, "AiOutlineMan", ()=>AiOutlineMan);
parcelHelpers.export(exports, "AiOutlineMedicineBox", ()=>AiOutlineMedicineBox);
parcelHelpers.export(exports, "AiOutlineMediumWorkmark", ()=>AiOutlineMediumWorkmark);
parcelHelpers.export(exports, "AiOutlineMedium", ()=>AiOutlineMedium);
parcelHelpers.export(exports, "AiOutlineMeh", ()=>AiOutlineMeh);
parcelHelpers.export(exports, "AiOutlineMenuFold", ()=>AiOutlineMenuFold);
parcelHelpers.export(exports, "AiOutlineMenuUnfold", ()=>AiOutlineMenuUnfold);
parcelHelpers.export(exports, "AiOutlineMenu", ()=>AiOutlineMenu);
parcelHelpers.export(exports, "AiOutlineMergeCells", ()=>AiOutlineMergeCells);
parcelHelpers.export(exports, "AiOutlineMessage", ()=>AiOutlineMessage);
parcelHelpers.export(exports, "AiOutlineMinusCircle", ()=>AiOutlineMinusCircle);
parcelHelpers.export(exports, "AiOutlineMinusSquare", ()=>AiOutlineMinusSquare);
parcelHelpers.export(exports, "AiOutlineMinus", ()=>AiOutlineMinus);
parcelHelpers.export(exports, "AiOutlineMobile", ()=>AiOutlineMobile);
parcelHelpers.export(exports, "AiOutlineMoneyCollect", ()=>AiOutlineMoneyCollect);
parcelHelpers.export(exports, "AiOutlineMonitor", ()=>AiOutlineMonitor);
parcelHelpers.export(exports, "AiOutlineMore", ()=>AiOutlineMore);
parcelHelpers.export(exports, "AiOutlineNodeCollapse", ()=>AiOutlineNodeCollapse);
parcelHelpers.export(exports, "AiOutlineNodeExpand", ()=>AiOutlineNodeExpand);
parcelHelpers.export(exports, "AiOutlineNodeIndex", ()=>AiOutlineNodeIndex);
parcelHelpers.export(exports, "AiOutlineNotification", ()=>AiOutlineNotification);
parcelHelpers.export(exports, "AiOutlineNumber", ()=>AiOutlineNumber);
parcelHelpers.export(exports, "AiOutlineOneToOne", ()=>AiOutlineOneToOne);
parcelHelpers.export(exports, "AiOutlineOrderedList", ()=>AiOutlineOrderedList);
parcelHelpers.export(exports, "AiOutlinePaperClip", ()=>AiOutlinePaperClip);
parcelHelpers.export(exports, "AiOutlinePartition", ()=>AiOutlinePartition);
parcelHelpers.export(exports, "AiOutlinePauseCircle", ()=>AiOutlinePauseCircle);
parcelHelpers.export(exports, "AiOutlinePause", ()=>AiOutlinePause);
parcelHelpers.export(exports, "AiOutlinePayCircle", ()=>AiOutlinePayCircle);
parcelHelpers.export(exports, "AiOutlinePercentage", ()=>AiOutlinePercentage);
parcelHelpers.export(exports, "AiOutlinePhone", ()=>AiOutlinePhone);
parcelHelpers.export(exports, "AiOutlinePicCenter", ()=>AiOutlinePicCenter);
parcelHelpers.export(exports, "AiOutlinePicLeft", ()=>AiOutlinePicLeft);
parcelHelpers.export(exports, "AiOutlinePicRight", ()=>AiOutlinePicRight);
parcelHelpers.export(exports, "AiOutlinePicture", ()=>AiOutlinePicture);
parcelHelpers.export(exports, "AiOutlinePieChart", ()=>AiOutlinePieChart);
parcelHelpers.export(exports, "AiOutlinePlayCircle", ()=>AiOutlinePlayCircle);
parcelHelpers.export(exports, "AiOutlinePlaySquare", ()=>AiOutlinePlaySquare);
parcelHelpers.export(exports, "AiOutlinePlusCircle", ()=>AiOutlinePlusCircle);
parcelHelpers.export(exports, "AiOutlinePlusSquare", ()=>AiOutlinePlusSquare);
parcelHelpers.export(exports, "AiOutlinePlus", ()=>AiOutlinePlus);
parcelHelpers.export(exports, "AiOutlinePoundCircle", ()=>AiOutlinePoundCircle);
parcelHelpers.export(exports, "AiOutlinePound", ()=>AiOutlinePound);
parcelHelpers.export(exports, "AiOutlinePoweroff", ()=>AiOutlinePoweroff);
parcelHelpers.export(exports, "AiOutlinePrinter", ()=>AiOutlinePrinter);
parcelHelpers.export(exports, "AiOutlineProfile", ()=>AiOutlineProfile);
parcelHelpers.export(exports, "AiOutlineProject", ()=>AiOutlineProject);
parcelHelpers.export(exports, "AiOutlinePropertySafety", ()=>AiOutlinePropertySafety);
parcelHelpers.export(exports, "AiOutlinePullRequest", ()=>AiOutlinePullRequest);
parcelHelpers.export(exports, "AiOutlinePushpin", ()=>AiOutlinePushpin);
parcelHelpers.export(exports, "AiOutlineQq", ()=>AiOutlineQq);
parcelHelpers.export(exports, "AiOutlineQrcode", ()=>AiOutlineQrcode);
parcelHelpers.export(exports, "AiOutlineQuestionCircle", ()=>AiOutlineQuestionCircle);
parcelHelpers.export(exports, "AiOutlineQuestion", ()=>AiOutlineQuestion);
parcelHelpers.export(exports, "AiOutlineRadarChart", ()=>AiOutlineRadarChart);
parcelHelpers.export(exports, "AiOutlineRadiusBottomleft", ()=>AiOutlineRadiusBottomleft);
parcelHelpers.export(exports, "AiOutlineRadiusBottomright", ()=>AiOutlineRadiusBottomright);
parcelHelpers.export(exports, "AiOutlineRadiusSetting", ()=>AiOutlineRadiusSetting);
parcelHelpers.export(exports, "AiOutlineRadiusUpleft", ()=>AiOutlineRadiusUpleft);
parcelHelpers.export(exports, "AiOutlineRadiusUpright", ()=>AiOutlineRadiusUpright);
parcelHelpers.export(exports, "AiOutlineRead", ()=>AiOutlineRead);
parcelHelpers.export(exports, "AiOutlineReconciliation", ()=>AiOutlineReconciliation);
parcelHelpers.export(exports, "AiOutlineRedEnvelope", ()=>AiOutlineRedEnvelope);
parcelHelpers.export(exports, "AiOutlineReddit", ()=>AiOutlineReddit);
parcelHelpers.export(exports, "AiOutlineRedo", ()=>AiOutlineRedo);
parcelHelpers.export(exports, "AiOutlineReload", ()=>AiOutlineReload);
parcelHelpers.export(exports, "AiOutlineRest", ()=>AiOutlineRest);
parcelHelpers.export(exports, "AiOutlineRetweet", ()=>AiOutlineRetweet);
parcelHelpers.export(exports, "AiOutlineRightCircle", ()=>AiOutlineRightCircle);
parcelHelpers.export(exports, "AiOutlineRightSquare", ()=>AiOutlineRightSquare);
parcelHelpers.export(exports, "AiOutlineRight", ()=>AiOutlineRight);
parcelHelpers.export(exports, "AiOutlineRise", ()=>AiOutlineRise);
parcelHelpers.export(exports, "AiOutlineRobot", ()=>AiOutlineRobot);
parcelHelpers.export(exports, "AiOutlineRocket", ()=>AiOutlineRocket);
parcelHelpers.export(exports, "AiOutlineRollback", ()=>AiOutlineRollback);
parcelHelpers.export(exports, "AiOutlineRotateLeft", ()=>AiOutlineRotateLeft);
parcelHelpers.export(exports, "AiOutlineRotateRight", ()=>AiOutlineRotateRight);
parcelHelpers.export(exports, "AiOutlineSafetyCertificate", ()=>AiOutlineSafetyCertificate);
parcelHelpers.export(exports, "AiOutlineSafety", ()=>AiOutlineSafety);
parcelHelpers.export(exports, "AiOutlineSave", ()=>AiOutlineSave);
parcelHelpers.export(exports, "AiOutlineScan", ()=>AiOutlineScan);
parcelHelpers.export(exports, "AiOutlineSchedule", ()=>AiOutlineSchedule);
parcelHelpers.export(exports, "AiOutlineScissor", ()=>AiOutlineScissor);
parcelHelpers.export(exports, "AiOutlineSearch", ()=>AiOutlineSearch);
parcelHelpers.export(exports, "AiOutlineSecurityScan", ()=>AiOutlineSecurityScan);
parcelHelpers.export(exports, "AiOutlineSelect", ()=>AiOutlineSelect);
parcelHelpers.export(exports, "AiOutlineSend", ()=>AiOutlineSend);
parcelHelpers.export(exports, "AiOutlineSetting", ()=>AiOutlineSetting);
parcelHelpers.export(exports, "AiOutlineShake", ()=>AiOutlineShake);
parcelHelpers.export(exports, "AiOutlineShareAlt", ()=>AiOutlineShareAlt);
parcelHelpers.export(exports, "AiOutlineShop", ()=>AiOutlineShop);
parcelHelpers.export(exports, "AiOutlineShoppingCart", ()=>AiOutlineShoppingCart);
parcelHelpers.export(exports, "AiOutlineShopping", ()=>AiOutlineShopping);
parcelHelpers.export(exports, "AiOutlineShrink", ()=>AiOutlineShrink);
parcelHelpers.export(exports, "AiOutlineSisternode", ()=>AiOutlineSisternode);
parcelHelpers.export(exports, "AiOutlineSketch", ()=>AiOutlineSketch);
parcelHelpers.export(exports, "AiOutlineSkin", ()=>AiOutlineSkin);
parcelHelpers.export(exports, "AiOutlineSkype", ()=>AiOutlineSkype);
parcelHelpers.export(exports, "AiOutlineSlackSquare", ()=>AiOutlineSlackSquare);
parcelHelpers.export(exports, "AiOutlineSlack", ()=>AiOutlineSlack);
parcelHelpers.export(exports, "AiOutlineSliders", ()=>AiOutlineSliders);
parcelHelpers.export(exports, "AiOutlineSmallDash", ()=>AiOutlineSmallDash);
parcelHelpers.export(exports, "AiOutlineSmile", ()=>AiOutlineSmile);
parcelHelpers.export(exports, "AiOutlineSnippets", ()=>AiOutlineSnippets);
parcelHelpers.export(exports, "AiOutlineSolution", ()=>AiOutlineSolution);
parcelHelpers.export(exports, "AiOutlineSortAscending", ()=>AiOutlineSortAscending);
parcelHelpers.export(exports, "AiOutlineSortDescending", ()=>AiOutlineSortDescending);
parcelHelpers.export(exports, "AiOutlineSound", ()=>AiOutlineSound);
parcelHelpers.export(exports, "AiOutlineSplitCells", ()=>AiOutlineSplitCells);
parcelHelpers.export(exports, "AiOutlineStar", ()=>AiOutlineStar);
parcelHelpers.export(exports, "AiOutlineStepBackward", ()=>AiOutlineStepBackward);
parcelHelpers.export(exports, "AiOutlineStepForward", ()=>AiOutlineStepForward);
parcelHelpers.export(exports, "AiOutlineStock", ()=>AiOutlineStock);
parcelHelpers.export(exports, "AiOutlineStop", ()=>AiOutlineStop);
parcelHelpers.export(exports, "AiOutlineStrikethrough", ()=>AiOutlineStrikethrough);
parcelHelpers.export(exports, "AiOutlineSubnode", ()=>AiOutlineSubnode);
parcelHelpers.export(exports, "AiOutlineSwapLeft", ()=>AiOutlineSwapLeft);
parcelHelpers.export(exports, "AiOutlineSwapRight", ()=>AiOutlineSwapRight);
parcelHelpers.export(exports, "AiOutlineSwap", ()=>AiOutlineSwap);
parcelHelpers.export(exports, "AiOutlineSwitcher", ()=>AiOutlineSwitcher);
parcelHelpers.export(exports, "AiOutlineSync", ()=>AiOutlineSync);
parcelHelpers.export(exports, "AiOutlineTable", ()=>AiOutlineTable);
parcelHelpers.export(exports, "AiOutlineTablet", ()=>AiOutlineTablet);
parcelHelpers.export(exports, "AiOutlineTag", ()=>AiOutlineTag);
parcelHelpers.export(exports, "AiOutlineTags", ()=>AiOutlineTags);
parcelHelpers.export(exports, "AiOutlineTaobaoCircle", ()=>AiOutlineTaobaoCircle);
parcelHelpers.export(exports, "AiOutlineTaobao", ()=>AiOutlineTaobao);
parcelHelpers.export(exports, "AiOutlineTeam", ()=>AiOutlineTeam);
parcelHelpers.export(exports, "AiOutlineThunderbolt", ()=>AiOutlineThunderbolt);
parcelHelpers.export(exports, "AiOutlineToTop", ()=>AiOutlineToTop);
parcelHelpers.export(exports, "AiOutlineTool", ()=>AiOutlineTool);
parcelHelpers.export(exports, "AiOutlineTrademarkCircle", ()=>AiOutlineTrademarkCircle);
parcelHelpers.export(exports, "AiOutlineTrademark", ()=>AiOutlineTrademark);
parcelHelpers.export(exports, "AiOutlineTransaction", ()=>AiOutlineTransaction);
parcelHelpers.export(exports, "AiOutlineTranslation", ()=>AiOutlineTranslation);
parcelHelpers.export(exports, "AiOutlineTrophy", ()=>AiOutlineTrophy);
parcelHelpers.export(exports, "AiOutlineTwitter", ()=>AiOutlineTwitter);
parcelHelpers.export(exports, "AiOutlineUnderline", ()=>AiOutlineUnderline);
parcelHelpers.export(exports, "AiOutlineUndo", ()=>AiOutlineUndo);
parcelHelpers.export(exports, "AiOutlineUngroup", ()=>AiOutlineUngroup);
parcelHelpers.export(exports, "AiOutlineUnlock", ()=>AiOutlineUnlock);
parcelHelpers.export(exports, "AiOutlineUnorderedList", ()=>AiOutlineUnorderedList);
parcelHelpers.export(exports, "AiOutlineUpCircle", ()=>AiOutlineUpCircle);
parcelHelpers.export(exports, "AiOutlineUpSquare", ()=>AiOutlineUpSquare);
parcelHelpers.export(exports, "AiOutlineUp", ()=>AiOutlineUp);
parcelHelpers.export(exports, "AiOutlineUpload", ()=>AiOutlineUpload);
parcelHelpers.export(exports, "AiOutlineUsb", ()=>AiOutlineUsb);
parcelHelpers.export(exports, "AiOutlineUserAdd", ()=>AiOutlineUserAdd);
parcelHelpers.export(exports, "AiOutlineUserDelete", ()=>AiOutlineUserDelete);
parcelHelpers.export(exports, "AiOutlineUserSwitch", ()=>AiOutlineUserSwitch);
parcelHelpers.export(exports, "AiOutlineUser", ()=>AiOutlineUser);
parcelHelpers.export(exports, "AiOutlineUsergroupAdd", ()=>AiOutlineUsergroupAdd);
parcelHelpers.export(exports, "AiOutlineUsergroupDelete", ()=>AiOutlineUsergroupDelete);
parcelHelpers.export(exports, "AiOutlineVerified", ()=>AiOutlineVerified);
parcelHelpers.export(exports, "AiOutlineVerticalAlignBottom", ()=>AiOutlineVerticalAlignBottom);
parcelHelpers.export(exports, "AiOutlineVerticalAlignMiddle", ()=>AiOutlineVerticalAlignMiddle);
parcelHelpers.export(exports, "AiOutlineVerticalAlignTop", ()=>AiOutlineVerticalAlignTop);
parcelHelpers.export(exports, "AiOutlineVerticalLeft", ()=>AiOutlineVerticalLeft);
parcelHelpers.export(exports, "AiOutlineVerticalRight", ()=>AiOutlineVerticalRight);
parcelHelpers.export(exports, "AiOutlineVideoCameraAdd", ()=>AiOutlineVideoCameraAdd);
parcelHelpers.export(exports, "AiOutlineVideoCamera", ()=>AiOutlineVideoCamera);
parcelHelpers.export(exports, "AiOutlineWallet", ()=>AiOutlineWallet);
parcelHelpers.export(exports, "AiOutlineWarning", ()=>AiOutlineWarning);
parcelHelpers.export(exports, "AiOutlineWechat", ()=>AiOutlineWechat);
parcelHelpers.export(exports, "AiOutlineWeiboCircle", ()=>AiOutlineWeiboCircle);
parcelHelpers.export(exports, "AiOutlineWeiboSquare", ()=>AiOutlineWeiboSquare);
parcelHelpers.export(exports, "AiOutlineWeibo", ()=>AiOutlineWeibo);
parcelHelpers.export(exports, "AiOutlineWhatsApp", ()=>AiOutlineWhatsApp);
parcelHelpers.export(exports, "AiOutlineWifi", ()=>AiOutlineWifi);
parcelHelpers.export(exports, "AiOutlineWindows", ()=>AiOutlineWindows);
parcelHelpers.export(exports, "AiOutlineWoman", ()=>AiOutlineWoman);
parcelHelpers.export(exports, "AiOutlineYahoo", ()=>AiOutlineYahoo);
parcelHelpers.export(exports, "AiOutlineYoutube", ()=>AiOutlineYoutube);
parcelHelpers.export(exports, "AiOutlineYuque", ()=>AiOutlineYuque);
parcelHelpers.export(exports, "AiOutlineZhihu", ()=>AiOutlineZhihu);
parcelHelpers.export(exports, "AiOutlineZoomIn", ()=>AiOutlineZoomIn);
parcelHelpers.export(exports, "AiOutlineZoomOut", ()=>AiOutlineZoomOut);
parcelHelpers.export(exports, "AiTwotoneAccountBook", ()=>AiTwotoneAccountBook);
parcelHelpers.export(exports, "AiTwotoneAlert", ()=>AiTwotoneAlert);
parcelHelpers.export(exports, "AiTwotoneApi", ()=>AiTwotoneApi);
parcelHelpers.export(exports, "AiTwotoneAppstore", ()=>AiTwotoneAppstore);
parcelHelpers.export(exports, "AiTwotoneAudio", ()=>AiTwotoneAudio);
parcelHelpers.export(exports, "AiTwotoneBank", ()=>AiTwotoneBank);
parcelHelpers.export(exports, "AiTwotoneBell", ()=>AiTwotoneBell);
parcelHelpers.export(exports, "AiTwotoneBook", ()=>AiTwotoneBook);
parcelHelpers.export(exports, "AiTwotoneBoxPlot", ()=>AiTwotoneBoxPlot);
parcelHelpers.export(exports, "AiTwotoneBug", ()=>AiTwotoneBug);
parcelHelpers.export(exports, "AiTwotoneBuild", ()=>AiTwotoneBuild);
parcelHelpers.export(exports, "AiTwotoneBulb", ()=>AiTwotoneBulb);
parcelHelpers.export(exports, "AiTwotoneCalculator", ()=>AiTwotoneCalculator);
parcelHelpers.export(exports, "AiTwotoneCalendar", ()=>AiTwotoneCalendar);
parcelHelpers.export(exports, "AiTwotoneCamera", ()=>AiTwotoneCamera);
parcelHelpers.export(exports, "AiTwotoneCar", ()=>AiTwotoneCar);
parcelHelpers.export(exports, "AiTwotoneCarryOut", ()=>AiTwotoneCarryOut);
parcelHelpers.export(exports, "AiTwotoneCheckCircle", ()=>AiTwotoneCheckCircle);
parcelHelpers.export(exports, "AiTwotoneCheckSquare", ()=>AiTwotoneCheckSquare);
parcelHelpers.export(exports, "AiTwotoneCiCircle", ()=>AiTwotoneCiCircle);
parcelHelpers.export(exports, "AiTwotoneCi", ()=>AiTwotoneCi);
parcelHelpers.export(exports, "AiTwotoneClockCircle", ()=>AiTwotoneClockCircle);
parcelHelpers.export(exports, "AiTwotoneCloseCircle", ()=>AiTwotoneCloseCircle);
parcelHelpers.export(exports, "AiTwotoneCloseSquare", ()=>AiTwotoneCloseSquare);
parcelHelpers.export(exports, "AiTwotoneCloud", ()=>AiTwotoneCloud);
parcelHelpers.export(exports, "AiTwotoneCode", ()=>AiTwotoneCode);
parcelHelpers.export(exports, "AiTwotoneCompass", ()=>AiTwotoneCompass);
parcelHelpers.export(exports, "AiTwotoneContacts", ()=>AiTwotoneContacts);
parcelHelpers.export(exports, "AiTwotoneContainer", ()=>AiTwotoneContainer);
parcelHelpers.export(exports, "AiTwotoneControl", ()=>AiTwotoneControl);
parcelHelpers.export(exports, "AiTwotoneCopy", ()=>AiTwotoneCopy);
parcelHelpers.export(exports, "AiTwotoneCopyrightCircle", ()=>AiTwotoneCopyrightCircle);
parcelHelpers.export(exports, "AiTwotoneCopyright", ()=>AiTwotoneCopyright);
parcelHelpers.export(exports, "AiTwotoneCreditCard", ()=>AiTwotoneCreditCard);
parcelHelpers.export(exports, "AiTwotoneCrown", ()=>AiTwotoneCrown);
parcelHelpers.export(exports, "AiTwotoneCustomerService", ()=>AiTwotoneCustomerService);
parcelHelpers.export(exports, "AiTwotoneDashboard", ()=>AiTwotoneDashboard);
parcelHelpers.export(exports, "AiTwotoneDatabase", ()=>AiTwotoneDatabase);
parcelHelpers.export(exports, "AiTwotoneDelete", ()=>AiTwotoneDelete);
parcelHelpers.export(exports, "AiTwotoneDiff", ()=>AiTwotoneDiff);
parcelHelpers.export(exports, "AiTwotoneDislike", ()=>AiTwotoneDislike);
parcelHelpers.export(exports, "AiTwotoneDollarCircle", ()=>AiTwotoneDollarCircle);
parcelHelpers.export(exports, "AiTwotoneDollar", ()=>AiTwotoneDollar);
parcelHelpers.export(exports, "AiTwotoneDownCircle", ()=>AiTwotoneDownCircle);
parcelHelpers.export(exports, "AiTwotoneDownSquare", ()=>AiTwotoneDownSquare);
parcelHelpers.export(exports, "AiTwotoneEdit", ()=>AiTwotoneEdit);
parcelHelpers.export(exports, "AiTwotoneEnvironment", ()=>AiTwotoneEnvironment);
parcelHelpers.export(exports, "AiTwotoneEuroCircle", ()=>AiTwotoneEuroCircle);
parcelHelpers.export(exports, "AiTwotoneEuro", ()=>AiTwotoneEuro);
parcelHelpers.export(exports, "AiTwotoneExclamationCircle", ()=>AiTwotoneExclamationCircle);
parcelHelpers.export(exports, "AiTwotoneExperiment", ()=>AiTwotoneExperiment);
parcelHelpers.export(exports, "AiTwotoneEyeInvisible", ()=>AiTwotoneEyeInvisible);
parcelHelpers.export(exports, "AiTwotoneEye", ()=>AiTwotoneEye);
parcelHelpers.export(exports, "AiTwotoneFileAdd", ()=>AiTwotoneFileAdd);
parcelHelpers.export(exports, "AiTwotoneFileExcel", ()=>AiTwotoneFileExcel);
parcelHelpers.export(exports, "AiTwotoneFileExclamation", ()=>AiTwotoneFileExclamation);
parcelHelpers.export(exports, "AiTwotoneFileImage", ()=>AiTwotoneFileImage);
parcelHelpers.export(exports, "AiTwotoneFileMarkdown", ()=>AiTwotoneFileMarkdown);
parcelHelpers.export(exports, "AiTwotoneFilePdf", ()=>AiTwotoneFilePdf);
parcelHelpers.export(exports, "AiTwotoneFilePpt", ()=>AiTwotoneFilePpt);
parcelHelpers.export(exports, "AiTwotoneFileText", ()=>AiTwotoneFileText);
parcelHelpers.export(exports, "AiTwotoneFileUnknown", ()=>AiTwotoneFileUnknown);
parcelHelpers.export(exports, "AiTwotoneFileWord", ()=>AiTwotoneFileWord);
parcelHelpers.export(exports, "AiTwotoneFileZip", ()=>AiTwotoneFileZip);
parcelHelpers.export(exports, "AiTwotoneFile", ()=>AiTwotoneFile);
parcelHelpers.export(exports, "AiTwotoneFilter", ()=>AiTwotoneFilter);
parcelHelpers.export(exports, "AiTwotoneFire", ()=>AiTwotoneFire);
parcelHelpers.export(exports, "AiTwotoneFlag", ()=>AiTwotoneFlag);
parcelHelpers.export(exports, "AiTwotoneFolderAdd", ()=>AiTwotoneFolderAdd);
parcelHelpers.export(exports, "AiTwotoneFolderOpen", ()=>AiTwotoneFolderOpen);
parcelHelpers.export(exports, "AiTwotoneFolder", ()=>AiTwotoneFolder);
parcelHelpers.export(exports, "AiTwotoneFrown", ()=>AiTwotoneFrown);
parcelHelpers.export(exports, "AiTwotoneFund", ()=>AiTwotoneFund);
parcelHelpers.export(exports, "AiTwotoneFunnelPlot", ()=>AiTwotoneFunnelPlot);
parcelHelpers.export(exports, "AiTwotoneGift", ()=>AiTwotoneGift);
parcelHelpers.export(exports, "AiTwotoneGold", ()=>AiTwotoneGold);
parcelHelpers.export(exports, "AiTwotoneHdd", ()=>AiTwotoneHdd);
parcelHelpers.export(exports, "AiTwotoneHeart", ()=>AiTwotoneHeart);
parcelHelpers.export(exports, "AiTwotoneHighlight", ()=>AiTwotoneHighlight);
parcelHelpers.export(exports, "AiTwotoneHome", ()=>AiTwotoneHome);
parcelHelpers.export(exports, "AiTwotoneHourglass", ()=>AiTwotoneHourglass);
parcelHelpers.export(exports, "AiTwotoneHtml5", ()=>AiTwotoneHtml5);
parcelHelpers.export(exports, "AiTwotoneIdcard", ()=>AiTwotoneIdcard);
parcelHelpers.export(exports, "AiTwotoneInfoCircle", ()=>AiTwotoneInfoCircle);
parcelHelpers.export(exports, "AiTwotoneInsurance", ()=>AiTwotoneInsurance);
parcelHelpers.export(exports, "AiTwotoneInteraction", ()=>AiTwotoneInteraction);
parcelHelpers.export(exports, "AiTwotoneLayout", ()=>AiTwotoneLayout);
parcelHelpers.export(exports, "AiTwotoneLeftCircle", ()=>AiTwotoneLeftCircle);
parcelHelpers.export(exports, "AiTwotoneLeftSquare", ()=>AiTwotoneLeftSquare);
parcelHelpers.export(exports, "AiTwotoneLike", ()=>AiTwotoneLike);
parcelHelpers.export(exports, "AiTwotoneLock", ()=>AiTwotoneLock);
parcelHelpers.export(exports, "AiTwotoneMail", ()=>AiTwotoneMail);
parcelHelpers.export(exports, "AiTwotoneMedicineBox", ()=>AiTwotoneMedicineBox);
parcelHelpers.export(exports, "AiTwotoneMeh", ()=>AiTwotoneMeh);
parcelHelpers.export(exports, "AiTwotoneMessage", ()=>AiTwotoneMessage);
parcelHelpers.export(exports, "AiTwotoneMinusCircle", ()=>AiTwotoneMinusCircle);
parcelHelpers.export(exports, "AiTwotoneMinusSquare", ()=>AiTwotoneMinusSquare);
parcelHelpers.export(exports, "AiTwotoneMobile", ()=>AiTwotoneMobile);
parcelHelpers.export(exports, "AiTwotoneMoneyCollect", ()=>AiTwotoneMoneyCollect);
parcelHelpers.export(exports, "AiTwotoneNotification", ()=>AiTwotoneNotification);
parcelHelpers.export(exports, "AiTwotonePauseCircle", ()=>AiTwotonePauseCircle);
parcelHelpers.export(exports, "AiTwotonePhone", ()=>AiTwotonePhone);
parcelHelpers.export(exports, "AiTwotonePicture", ()=>AiTwotonePicture);
parcelHelpers.export(exports, "AiTwotonePieChart", ()=>AiTwotonePieChart);
parcelHelpers.export(exports, "AiTwotonePlayCircle", ()=>AiTwotonePlayCircle);
parcelHelpers.export(exports, "AiTwotonePlaySquare", ()=>AiTwotonePlaySquare);
parcelHelpers.export(exports, "AiTwotonePlusCircle", ()=>AiTwotonePlusCircle);
parcelHelpers.export(exports, "AiTwotonePlusSquare", ()=>AiTwotonePlusSquare);
parcelHelpers.export(exports, "AiTwotonePoundCircle", ()=>AiTwotonePoundCircle);
parcelHelpers.export(exports, "AiTwotonePrinter", ()=>AiTwotonePrinter);
parcelHelpers.export(exports, "AiTwotoneProfile", ()=>AiTwotoneProfile);
parcelHelpers.export(exports, "AiTwotoneProject", ()=>AiTwotoneProject);
parcelHelpers.export(exports, "AiTwotonePropertySafety", ()=>AiTwotonePropertySafety);
parcelHelpers.export(exports, "AiTwotonePushpin", ()=>AiTwotonePushpin);
parcelHelpers.export(exports, "AiTwotoneQuestionCircle", ()=>AiTwotoneQuestionCircle);
parcelHelpers.export(exports, "AiTwotoneReconciliation", ()=>AiTwotoneReconciliation);
parcelHelpers.export(exports, "AiTwotoneRedEnvelope", ()=>AiTwotoneRedEnvelope);
parcelHelpers.export(exports, "AiTwotoneRest", ()=>AiTwotoneRest);
parcelHelpers.export(exports, "AiTwotoneRightCircle", ()=>AiTwotoneRightCircle);
parcelHelpers.export(exports, "AiTwotoneRightSquare", ()=>AiTwotoneRightSquare);
parcelHelpers.export(exports, "AiTwotoneRocket", ()=>AiTwotoneRocket);
parcelHelpers.export(exports, "AiTwotoneSafetyCertificate", ()=>AiTwotoneSafetyCertificate);
parcelHelpers.export(exports, "AiTwotoneSave", ()=>AiTwotoneSave);
parcelHelpers.export(exports, "AiTwotoneSchedule", ()=>AiTwotoneSchedule);
parcelHelpers.export(exports, "AiTwotoneSecurityScan", ()=>AiTwotoneSecurityScan);
parcelHelpers.export(exports, "AiTwotoneSetting", ()=>AiTwotoneSetting);
parcelHelpers.export(exports, "AiTwotoneShop", ()=>AiTwotoneShop);
parcelHelpers.export(exports, "AiTwotoneShopping", ()=>AiTwotoneShopping);
parcelHelpers.export(exports, "AiTwotoneSkin", ()=>AiTwotoneSkin);
parcelHelpers.export(exports, "AiTwotoneSliders", ()=>AiTwotoneSliders);
parcelHelpers.export(exports, "AiTwotoneSmile", ()=>AiTwotoneSmile);
parcelHelpers.export(exports, "AiTwotoneSnippets", ()=>AiTwotoneSnippets);
parcelHelpers.export(exports, "AiTwotoneSound", ()=>AiTwotoneSound);
parcelHelpers.export(exports, "AiTwotoneStar", ()=>AiTwotoneStar);
parcelHelpers.export(exports, "AiTwotoneStop", ()=>AiTwotoneStop);
parcelHelpers.export(exports, "AiTwotoneSwitcher", ()=>AiTwotoneSwitcher);
parcelHelpers.export(exports, "AiTwotoneTablet", ()=>AiTwotoneTablet);
parcelHelpers.export(exports, "AiTwotoneTag", ()=>AiTwotoneTag);
parcelHelpers.export(exports, "AiTwotoneTags", ()=>AiTwotoneTags);
parcelHelpers.export(exports, "AiTwotoneThunderbolt", ()=>AiTwotoneThunderbolt);
parcelHelpers.export(exports, "AiTwotoneTool", ()=>AiTwotoneTool);
parcelHelpers.export(exports, "AiTwotoneTrademarkCircle", ()=>AiTwotoneTrademarkCircle);
parcelHelpers.export(exports, "AiTwotoneTrophy", ()=>AiTwotoneTrophy);
parcelHelpers.export(exports, "AiTwotoneUnlock", ()=>AiTwotoneUnlock);
parcelHelpers.export(exports, "AiTwotoneUpCircle", ()=>AiTwotoneUpCircle);
parcelHelpers.export(exports, "AiTwotoneUpSquare", ()=>AiTwotoneUpSquare);
parcelHelpers.export(exports, "AiTwotoneUsb", ()=>AiTwotoneUsb);
parcelHelpers.export(exports, "AiTwotoneVideoCamera", ()=>AiTwotoneVideoCamera);
parcelHelpers.export(exports, "AiTwotoneWallet", ()=>AiTwotoneWallet);
parcelHelpers.export(exports, "AiTwotoneWarning", ()=>AiTwotoneWarning);
var _lib = require("../lib");
function AiFillAccountBook(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M880 184H712v-64c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v64H384v-64c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v64H144c-17.7 0-32 14.3-32 32v664c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V216c0-17.7-14.3-32-32-32zM648.3 426.8l-87.7 161.1h45.7c5.5 0 10 4.5 10 10v21.3c0 5.5-4.5 10-10 10h-63.4v29.7h63.4c5.5 0 10 4.5 10 10v21.3c0 5.5-4.5 10-10 10h-63.4V752c0 5.5-4.5 10-10 10h-41.3c-5.5 0-10-4.5-10-10v-51.8h-63.1c-5.5 0-10-4.5-10-10v-21.3c0-5.5 4.5-10 10-10h63.1v-29.7h-63.1c-5.5 0-10-4.5-10-10v-21.3c0-5.5 4.5-10 10-10h45.2l-88-161.1c-2.6-4.8-.9-10.9 4-13.6 1.5-.8 3.1-1.2 4.8-1.2h46c3.8 0 7.2 2.1 8.9 5.5l72.9 144.3 73.2-144.3a10 10 0 0 1 8.9-5.5h45c5.5 0 10 4.5 10 10 .1 1.7-.3 3.3-1.1 4.8z"
                }
            }
        ]
    })(props);
}
function AiFillAlert(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M512 244c176.18 0 319 142.82 319 319v233a32 32 0 0 1-32 32H225a32 32 0 0 1-32-32V563c0-176.18 142.82-319 319-319zM484 68h56a8 8 0 0 1 8 8v96a8 8 0 0 1-8 8h-56a8 8 0 0 1-8-8V76a8 8 0 0 1 8-8zM177.25 191.66a8 8 0 0 1 11.32 0l67.88 67.88a8 8 0 0 1 0 11.31l-39.6 39.6a8 8 0 0 1-11.31 0l-67.88-67.88a8 8 0 0 1 0-11.31l39.6-39.6zm669.6 0l39.6 39.6a8 8 0 0 1 0 11.3l-67.88 67.9a8 8 0 0 1-11.32 0l-39.6-39.6a8 8 0 0 1 0-11.32l67.89-67.88a8 8 0 0 1 11.31 0zM192 892h640a32 32 0 0 1 32 32v24a8 8 0 0 1-8 8H168a8 8 0 0 1-8-8v-24a32 32 0 0 1 32-32zm148-317v253h64V575h-64z"
                }
            }
        ]
    })(props);
}
function AiFillAlipayCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M308.6 545.7c-19.8 2-57.1 10.7-77.4 28.6-61 53-24.5 150 99 150 71.8 0 143.5-45.7 199.8-119-80.2-38.9-148.1-66.8-221.4-59.6zm460.5 67c100.1 33.4 154.7 43 166.7 44.8A445.9 445.9 0 0 0 960 512c0-247.4-200.6-448-448-448S64 264.6 64 512s200.6 448 448 448c155.9 0 293.2-79.7 373.5-200.5-75.6-29.8-213.6-85-286.8-120.1-69.9 85.7-160.1 137.8-253.7 137.8-158.4 0-212.1-138.1-137.2-229 16.3-19.8 44.2-38.7 87.3-49.4 67.5-16.5 175 10.3 275.7 43.4 18.1-33.3 33.4-69.9 44.7-108.9H305.1V402h160v-56.2H271.3v-31.3h193.8v-80.1s0-13.5 13.7-13.5H557v93.6h191.7v31.3H557.1V402h156.4c-15 61.1-37.7 117.4-66.2 166.8 47.5 17.1 90.1 33.3 121.8 43.9z"
                }
            }
        ]
    })(props);
}
function AiFillAlipaySquare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M308.6 545.7c-19.8 2-57.1 10.7-77.4 28.6-61 53-24.5 150 99 150 71.8 0 143.5-45.7 199.8-119-80.2-38.9-148.1-66.8-221.4-59.6zM880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm29.4 663.2S703 689.4 598.7 639.5C528.8 725.2 438.6 777.3 345 777.3c-158.4 0-212.1-138.1-137.2-229 16.3-19.8 44.2-38.7 87.3-49.4 67.5-16.5 175 10.3 275.7 43.4 18.1-33.3 33.4-69.9 44.7-108.9H305.1V402h160v-56.2H271.3v-31.3h193.8v-80.1s0-13.5 13.7-13.5H557v93.6h191.7v31.3H557.1V402h156.4c-15 61.1-37.7 117.4-66.2 166.8 47.5 17.1 90.1 33.3 121.8 43.9 114.3 38.2 140.2 40.2 140.2 40.2v122.3z"
                }
            }
        ]
    })(props);
}
function AiFillAliwangwang(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M868.2 377.4c-18.9-45.1-46.3-85.6-81.2-120.6a377.26 377.26 0 0 0-120.5-81.2A375.65 375.65 0 0 0 519 145.8c-41.9 0-82.9 6.7-121.9 20C306 123.3 200.8 120 170.6 120c-2.2 0-7.4 0-9.4.2-11.9.4-22.8 6.5-29.2 16.4-6.5 9.9-7.7 22.4-3.4 33.5l64.3 161.6a378.59 378.59 0 0 0-52.8 193.2c0 51.4 10 101 29.8 147.6 18.9 45 46.2 85.6 81.2 120.5 34.7 34.8 75.4 62.1 120.5 81.2C418.3 894 467.9 904 519 904c51.3 0 100.9-10 147.7-29.8 44.9-18.9 85.5-46.3 120.4-81.2 34.7-34.8 62.1-75.4 81.2-120.6a376.5 376.5 0 0 0 29.8-147.6c-.2-51.2-10.1-100.8-29.9-147.4zm-325.2 79c0 20.4-16.6 37.1-37.1 37.1-20.4 0-37.1-16.7-37.1-37.1v-55.1c0-20.4 16.6-37.1 37.1-37.1 20.4 0 37.1 16.6 37.1 37.1v55.1zm175.2 0c0 20.4-16.6 37.1-37.1 37.1S644 476.8 644 456.4v-55.1c0-20.4 16.7-37.1 37.1-37.1 20.4 0 37.1 16.6 37.1 37.1v55.1z"
                }
            }
        ]
    })(props);
}
function AiFillAmazonCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M485 467.5c-11.6 4.9-20.9 12.2-27.8 22-6.9 9.8-10.4 21.6-10.4 35.5 0 17.8 7.5 31.5 22.4 41.2 14.1 9.1 28.9 11.4 44.4 6.8 17.9-5.2 30-17.9 36.4-38.1 3-9.3 4.5-19.7 4.5-31.3v-50.2c-12.6.4-24.4 1.6-35.5 3.7-11.1 2.1-22.4 5.6-34 10.4zM512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm35.8 262.7c-7.2-10.9-20.1-16.4-38.7-16.4-1.3 0-3 .1-5.3.3-2.2.2-6.6 1.5-12.9 3.7a79.4 79.4 0 0 0-17.9 9.1c-5.5 3.8-11.5 10-18 18.4-6.4 8.5-11.5 18.4-15.3 29.8l-94-8.4c0-12.4 2.4-24.7 7-36.9 4.7-12.2 11.8-23.9 21.4-35 9.6-11.2 21.1-21 34.5-29.4 13.4-8.5 29.6-15.2 48.4-20.3 18.9-5.1 39.1-7.6 60.9-7.6 21.3 0 40.6 2.6 57.8 7.7 17.2 5.2 31.1 11.5 41.4 19.1a117 117 0 0 1 25.9 25.7c6.9 9.6 11.7 18.5 14.4 26.7 2.7 8.2 4 15.7 4 22.8v182.5c0 6.4 1.4 13 4.3 19.8 2.9 6.8 6.3 12.8 10.2 18 3.9 5.2 7.9 9.9 12 14.3 4.1 4.3 7.6 7.7 10.6 9.9l4.1 3.4-72.5 69.4c-8.5-7.7-16.9-15.4-25.2-23.4-8.3-8-14.5-14-18.5-18.1l-6.1-6.2c-2.4-2.3-5-5.7-8-10.2-8.1 12.2-18.5 22.8-31.1 31.8-12.7 9-26.3 15.6-40.7 19.7-14.5 4.1-29.4 6.5-44.7 7.1-15.3.6-30-1.5-43.9-6.5-13.9-5-26.5-11.7-37.6-20.3-11.1-8.6-19.9-20.2-26.5-35-6.6-14.8-9.9-31.5-9.9-50.4 0-17.4 3-33.3 8.9-47.7 6-14.5 13.6-26.5 23-36.1 9.4-9.6 20.7-18.2 34-25.7s26.4-13.4 39.2-17.7c12.8-4.2 26.6-7.8 41.5-10.7 14.9-2.9 27.6-4.8 38.2-5.7 10.6-.9 21.2-1.6 31.8-2v-39.4c0-13.5-2.3-23.5-6.7-30.1zm180.5 379.6c-2.8 3.3-7.5 7.8-14.1 13.5s-16.8 12.7-30.5 21.1c-13.7 8.4-28.8 16-45 22.9-16.3 6.9-36.3 12.9-60.1 18-23.7 5.1-48.2 7.6-73.3 7.6-25.4 0-50.7-3.2-76.1-9.6-25.4-6.4-47.6-14.3-66.8-23.7-19.1-9.4-37.6-20.2-55.1-32.2-17.6-12.1-31.7-22.9-42.4-32.5-10.6-9.6-19.6-18.7-26.8-27.1-1.7-1.9-2.8-3.6-3.2-5.1-.4-1.5-.3-2.8.3-3.7.6-.9 1.5-1.6 2.6-2.2a7.42 7.42 0 0 1 7.4.8c40.9 24.2 72.9 41.3 95.9 51.4 82.9 36.4 168 45.7 255.3 27.9 40.5-8.3 82.1-22.2 124.9-41.8 3.2-1.2 6-1.5 8.3-.9 2.3.6 3.5 2.4 3.5 5.4 0 2.8-1.6 6.3-4.8 10.2zm59.9-29c-1.8 11.1-4.9 21.6-9.1 31.8-7.2 17.1-16.3 30-27.1 38.4-3.6 2.9-6.4 3.8-8.3 2.8-1.9-1-1.9-3.5 0-7.4 4.5-9.3 9.2-21.8 14.2-37.7 5-15.8 5.7-26 2.1-30.5-1.1-1.5-2.7-2.6-5-3.6-2.2-.9-5.1-1.5-8.6-1.9s-6.7-.6-9.4-.8c-2.8-.2-6.5-.2-11.2 0-4.7.2-8 .4-10.1.6a874.4 874.4 0 0 1-17.1 1.5c-1.3.2-2.7.4-4.1.5-1.5.1-2.7.2-3.5.3l-2.7.3c-1 .1-1.7.2-2.2.2h-3.2l-1-.2-.6-.5-.5-.9c-1.3-3.3 3.7-7.4 15-12.4s22.3-8.1 32.9-9.3c9.8-1.5 21.3-1.5 34.5-.3s21.3 3.7 24.3 7.4c2.3 3.5 2.5 10.7.7 21.7z"
                }
            }
        ]
    })(props);
}
function AiFillAmazonSquare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM547.8 326.7c-7.2-10.9-20.1-16.4-38.7-16.4-1.3 0-3 .1-5.3.3-2.2.2-6.6 1.5-12.9 3.7a79.4 79.4 0 0 0-17.9 9.1c-5.5 3.8-11.5 10-18 18.4-6.4 8.5-11.5 18.4-15.3 29.8l-94-8.4c0-12.4 2.4-24.7 7-36.9s11.8-23.9 21.4-35c9.6-11.2 21.1-21 34.5-29.4 13.4-8.5 29.6-15.2 48.4-20.3 18.9-5.1 39.1-7.6 60.9-7.6 21.3 0 40.6 2.6 57.8 7.7 17.2 5.2 31.1 11.5 41.4 19.1a117 117 0 0 1 25.9 25.7c6.9 9.6 11.7 18.5 14.4 26.7 2.7 8.2 4 15.7 4 22.8v182.5c0 6.4 1.4 13 4.3 19.8 2.9 6.8 6.3 12.8 10.2 18 3.9 5.2 7.9 9.9 12 14.3 4.1 4.3 7.6 7.7 10.6 9.9l4.1 3.4-72.5 69.4c-8.5-7.7-16.9-15.4-25.2-23.4-8.3-8-14.5-14-18.5-18.1l-6.1-6.2c-2.4-2.3-5-5.7-8-10.2-8.1 12.2-18.5 22.8-31.1 31.8-12.7 9-26.3 15.6-40.7 19.7-14.5 4.1-29.4 6.5-44.7 7.1-15.3.6-30-1.5-43.9-6.5-13.9-5-26.5-11.7-37.6-20.3-11.1-8.6-19.9-20.2-26.5-35-6.6-14.8-9.9-31.5-9.9-50.4 0-17.4 3-33.3 8.9-47.7 6-14.5 13.6-26.5 23-36.1 9.4-9.6 20.7-18.2 34-25.7s26.4-13.4 39.2-17.7c12.8-4.2 26.6-7.8 41.5-10.7 14.9-2.9 27.6-4.8 38.2-5.7 10.6-.9 21.2-1.6 31.8-2v-39.4c0-13.5-2.3-23.5-6.7-30.1zm180.5 379.6c-2.8 3.3-7.5 7.8-14.1 13.5s-16.8 12.7-30.5 21.1c-13.7 8.4-28.8 16-45 22.9-16.3 6.9-36.3 12.9-60.1 18-23.7 5.1-48.2 7.6-73.3 7.6-25.4 0-50.7-3.2-76.1-9.6-25.4-6.4-47.6-14.3-66.8-23.7-19.1-9.4-37.6-20.2-55.1-32.2-17.6-12.1-31.7-22.9-42.4-32.5-10.6-9.6-19.6-18.7-26.8-27.1-1.7-1.9-2.8-3.6-3.2-5.1-.4-1.5-.3-2.8.3-3.7.6-.9 1.5-1.6 2.6-2.2a7.42 7.42 0 0 1 7.4.8c40.9 24.2 72.9 41.3 95.9 51.4 82.9 36.4 168 45.7 255.3 27.9 40.5-8.3 82.1-22.2 124.9-41.8 3.2-1.2 6-1.5 8.3-.9 2.3.6 3.5 2.4 3.5 5.4 0 2.8-1.6 6.3-4.8 10.2zm59.9-29c-1.8 11.1-4.9 21.6-9.1 31.8-7.2 17.1-16.3 30-27.1 38.4-3.6 2.9-6.4 3.8-8.3 2.8-1.9-1-1.9-3.5 0-7.4 4.5-9.3 9.2-21.8 14.2-37.7 5-15.8 5.7-26 2.1-30.5-1.1-1.5-2.7-2.6-5-3.6-2.2-.9-5.1-1.5-8.6-1.9s-6.7-.6-9.4-.8c-2.8-.2-6.5-.2-11.2 0-4.7.2-8 .4-10.1.6a874.4 874.4 0 0 1-17.1 1.5c-1.3.2-2.7.4-4.1.5-1.5.1-2.7.2-3.5.3l-2.7.3c-1 .1-1.7.2-2.2.2h-3.2l-1-.2-.6-.5-.5-.9c-1.3-3.3 3.7-7.4 15-12.4s22.3-8.1 32.9-9.3c9.8-1.5 21.3-1.5 34.5-.3s21.3 3.7 24.3 7.4c2.3 3.5 2.5 10.7.7 21.7zM485 467.5c-11.6 4.9-20.9 12.2-27.8 22-6.9 9.8-10.4 21.6-10.4 35.5 0 17.8 7.5 31.5 22.4 41.2 14.1 9.1 28.9 11.4 44.4 6.8 17.9-5.2 30-17.9 36.4-38.1 3-9.3 4.5-19.7 4.5-31.3v-50.2c-12.6.4-24.4 1.6-35.5 3.7-11.1 2.1-22.4 5.6-34 10.4z"
                }
            }
        ]
    })(props);
}
function AiFillAndroid(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M270.1 741.7c0 23.4 19.1 42.5 42.6 42.5h48.7v120.4c0 30.5 24.5 55.4 54.6 55.4 30.2 0 54.6-24.8 54.6-55.4V784.1h85v120.4c0 30.5 24.5 55.4 54.6 55.4 30.2 0 54.6-24.8 54.6-55.4V784.1h48.7c23.5 0 42.6-19.1 42.6-42.5V346.4h-486v395.3zm357.1-600.1l44.9-65c2.6-3.8 2-8.9-1.5-11.4-3.5-2.4-8.5-1.2-11.1 2.6l-46.6 67.6c-30.7-12.1-64.9-18.8-100.8-18.8-35.9 0-70.1 6.7-100.8 18.8l-46.6-67.5c-2.6-3.8-7.6-5.1-11.1-2.6-3.5 2.4-4.1 7.4-1.5 11.4l44.9 65c-71.4 33.2-121.4 96.1-127.8 169.6h486c-6.6-73.6-56.7-136.5-128-169.7zM409.5 244.1a26.9 26.9 0 1 1 26.9-26.9 26.97 26.97 0 0 1-26.9 26.9zm208.4 0a26.9 26.9 0 1 1 26.9-26.9 26.97 26.97 0 0 1-26.9 26.9zm223.4 100.7c-30.2 0-54.6 24.8-54.6 55.4v216.4c0 30.5 24.5 55.4 54.6 55.4 30.2 0 54.6-24.8 54.6-55.4V400.1c.1-30.6-24.3-55.3-54.6-55.3zm-658.6 0c-30.2 0-54.6 24.8-54.6 55.4v216.4c0 30.5 24.5 55.4 54.6 55.4 30.2 0 54.6-24.8 54.6-55.4V400.1c0-30.6-24.5-55.3-54.6-55.3z"
                }
            }
        ]
    })(props);
}
function AiFillApi(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M917.7 148.8l-42.4-42.4c-1.6-1.6-3.6-2.3-5.7-2.3s-4.1.8-5.7 2.3l-76.1 76.1a199.27 199.27 0 0 0-112.1-34.3c-51.2 0-102.4 19.5-141.5 58.6L432.3 308.7a8.03 8.03 0 0 0 0 11.3L704 591.7c1.6 1.6 3.6 2.3 5.7 2.3 2 0 4.1-.8 5.7-2.3l101.9-101.9c68.9-69 77-175.7 24.3-253.5l76.1-76.1c3.1-3.2 3.1-8.3 0-11.4zM578.9 546.7a8.03 8.03 0 0 0-11.3 0L501 613.3 410.7 523l66.7-66.7c3.1-3.1 3.1-8.2 0-11.3L441 408.6a8.03 8.03 0 0 0-11.3 0L363 475.3l-43-43a7.85 7.85 0 0 0-5.7-2.3c-2 0-4.1.8-5.7 2.3L206.8 534.2c-68.9 68.9-77 175.7-24.3 253.5l-76.1 76.1a8.03 8.03 0 0 0 0 11.3l42.4 42.4c1.6 1.6 3.6 2.3 5.7 2.3s4.1-.8 5.7-2.3l76.1-76.1c33.7 22.9 72.9 34.3 112.1 34.3 51.2 0 102.4-19.5 141.5-58.6l101.9-101.9c3.1-3.1 3.1-8.2 0-11.3l-43-43 66.7-66.7c3.1-3.1 3.1-8.2 0-11.3l-36.6-36.2z"
                }
            }
        ]
    })(props);
}
function AiFillApple(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M747.4 535.7c-.4-68.2 30.5-119.6 92.9-157.5-34.9-50-87.7-77.5-157.3-82.8-65.9-5.2-138 38.4-164.4 38.4-27.9 0-91.7-36.6-141.9-36.6C273.1 298.8 163 379.8 163 544.6c0 48.7 8.9 99 26.7 150.8 23.8 68.2 109.6 235.3 199.1 232.6 46.8-1.1 79.9-33.2 140.8-33.2 59.1 0 89.7 33.2 141.9 33.2 90.3-1.3 167.9-153.2 190.5-221.6-121.1-57.1-114.6-167.2-114.6-170.7zm-105.1-305c50.7-60.2 46.1-115 44.6-134.7-44.8 2.6-96.6 30.5-126.1 64.8-32.5 36.8-51.6 82.3-47.5 133.6 48.4 3.7 92.6-21.2 129-63.7z"
                }
            }
        ]
    })(props);
}
function AiFillAppstore(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M864 144H560c-8.8 0-16 7.2-16 16v304c0 8.8 7.2 16 16 16h304c8.8 0 16-7.2 16-16V160c0-8.8-7.2-16-16-16zm0 400H560c-8.8 0-16 7.2-16 16v304c0 8.8 7.2 16 16 16h304c8.8 0 16-7.2 16-16V560c0-8.8-7.2-16-16-16zM464 144H160c-8.8 0-16 7.2-16 16v304c0 8.8 7.2 16 16 16h304c8.8 0 16-7.2 16-16V160c0-8.8-7.2-16-16-16zm0 400H160c-8.8 0-16 7.2-16 16v304c0 8.8 7.2 16 16 16h304c8.8 0 16-7.2 16-16V560c0-8.8-7.2-16-16-16z"
                }
            }
        ]
    })(props);
}
function AiFillAudio(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M512 624c93.9 0 170-75.2 170-168V232c0-92.8-76.1-168-170-168s-170 75.2-170 168v224c0 92.8 76.1 168 170 168zm330-170c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8 0 140.3-113.7 254-254 254S258 594.3 258 454c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8 0 168.7 126.6 307.9 290 327.6V884H326.7c-13.7 0-24.7 14.3-24.7 32v36c0 4.4 2.8 8 6.2 8h407.6c3.4 0 6.2-3.6 6.2-8v-36c0-17.7-11-32-24.7-32H548V782.1c165.3-18 294-158 294-328.1z"
                }
            }
        ]
    })(props);
}
function AiFillBackward(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M485.6 249.9L198.2 498c-8.3 7.1-8.3 20.8 0 27.9l287.4 248.2c10.7 9.2 26.4.9 26.4-14V263.8c0-14.8-15.7-23.2-26.4-13.9zm320 0L518.2 498a18.6 18.6 0 0 0-6.2 14c0 5.2 2.1 10.4 6.2 14l287.4 248.2c10.7 9.2 26.4.9 26.4-14V263.8c0-14.8-15.7-23.2-26.4-13.9z"
                }
            }
        ]
    })(props);
}
function AiFillBank(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M894 462c30.9 0 43.8-39.7 18.7-58L530.8 126.2a31.81 31.81 0 0 0-37.6 0L111.3 404c-25.1 18.2-12.2 58 18.8 58H192v374h-72c-4.4 0-8 3.6-8 8v52c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-52c0-4.4-3.6-8-8-8h-72V462h62zM381 836H264V462h117v374zm189 0H453V462h117v374zm190 0H642V462h118v374z"
                }
            }
        ]
    })(props);
}
function AiFillBehanceCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M420.3 470.3c8.7-6.3 12.9-16.7 12.9-31 .3-6.8-1.1-13.5-4.1-19.6-2.7-4.9-6.7-9-11.6-11.9a44.8 44.8 0 0 0-16.6-6c-6.4-1.2-12.9-1.8-19.3-1.7h-70.3v79.7h76.1c13.1.1 24.2-3.1 32.9-9.5zm11.8 72c-9.8-7.5-22.9-11.2-39.2-11.2h-81.8v94h80.2c7.5 0 14.4-.7 21.1-2.1a50.5 50.5 0 0 0 17.8-7.2c5.1-3.3 9.2-7.8 12.3-13.6 3-5.8 4.5-13.2 4.5-22.1 0-17.7-5-30.2-14.9-37.8zM512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm86.5 286.9h138.4v33.7H598.5v-33.7zM512 628.8a89.52 89.52 0 0 1-27 31c-11.8 8.2-24.9 14.2-38.8 17.7a167.4 167.4 0 0 1-44.6 5.7H236V342.1h161c16.3 0 31.1 1.5 44.6 4.3 13.4 2.8 24.8 7.6 34.4 14.1 9.5 6.5 17 15.2 22.3 26 5.2 10.7 7.9 24.1 7.9 40 0 17.2-3.9 31.4-11.7 42.9-7.9 11.5-19.3 20.8-34.8 28.1 21.1 6 36.6 16.7 46.8 31.7 10.4 15.2 15.5 33.4 15.5 54.8 0 17.4-3.3 32.3-10 44.8zM790.8 576H612.4c0 19.4 6.7 38 16.8 48 10.2 9.9 24.8 14.9 43.9 14.9 13.8 0 25.5-3.5 35.5-10.4 9.9-6.9 15.9-14.2 18.1-21.8h59.8c-9.6 29.7-24.2 50.9-44 63.7-19.6 12.8-43.6 19.2-71.5 19.2-19.5 0-37-3.2-52.7-9.3-15.1-5.9-28.7-14.9-39.9-26.5a121.2 121.2 0 0 1-25.1-41.2c-6.1-16.9-9.1-34.7-8.9-52.6 0-18.5 3.1-35.7 9.1-51.7 11.5-31.1 35.4-56 65.9-68.9 16.3-6.8 33.8-10.2 51.5-10 21 0 39.2 4 55 12.2a111.6 111.6 0 0 1 38.6 32.8c10.1 13.7 17.2 29.3 21.7 46.9 4.3 17.3 5.8 35.5 4.6 54.7zm-122-95.6c-10.8 0-19.9 1.9-26.9 5.6-7 3.7-12.8 8.3-17.2 13.6a48.4 48.4 0 0 0-9.1 17.4c-1.6 5.3-2.7 10.7-3.1 16.2H723c-1.6-17.3-7.6-30.1-15.6-39.1-8.4-8.9-21.9-13.7-38.6-13.7z"
                }
            }
        ]
    })(props);
}
function AiFillBehanceSquare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM598.5 350.9h138.4v33.7H598.5v-33.7zM512 628.8a89.52 89.52 0 0 1-27 31c-11.8 8.2-24.9 14.2-38.8 17.7a167.4 167.4 0 0 1-44.6 5.7H236V342.1h161c16.3 0 31.1 1.5 44.6 4.3 13.4 2.8 24.8 7.6 34.4 14.1 9.5 6.5 17 15.2 22.3 26 5.2 10.7 7.9 24.1 7.9 40 0 17.2-3.9 31.4-11.7 42.9-7.9 11.5-19.3 20.8-34.8 28.1 21.1 6 36.6 16.7 46.8 31.7 10.4 15.2 15.5 33.4 15.5 54.8 0 17.4-3.3 32.3-10 44.8zM790.8 576H612.4c0 19.4 6.7 38 16.8 48 10.2 9.9 24.8 14.9 43.9 14.9 13.8 0 25.5-3.5 35.5-10.4 9.9-6.9 15.9-14.2 18.1-21.8h59.8c-9.6 29.7-24.2 50.9-44 63.7-19.6 12.8-43.6 19.2-71.5 19.2-19.5 0-37-3.2-52.7-9.3-15.1-5.9-28.7-14.9-39.9-26.5a121.2 121.2 0 0 1-25.1-41.2c-6.1-16.9-9.1-34.7-8.9-52.6 0-18.5 3.1-35.7 9.1-51.7 11.5-31.1 35.4-56 65.9-68.9 16.3-6.8 33.8-10.2 51.5-10 21 0 39.2 4 55 12.2a111.6 111.6 0 0 1 38.6 32.8c10.1 13.7 17.2 29.3 21.7 46.9 4.3 17.3 5.8 35.5 4.6 54.7zm-122-95.6c-10.8 0-19.9 1.9-26.9 5.6-7 3.7-12.8 8.3-17.2 13.6a48.4 48.4 0 0 0-9.1 17.4c-1.6 5.3-2.7 10.7-3.1 16.2H723c-1.6-17.3-7.6-30.1-15.6-39.1-8.4-8.9-21.9-13.7-38.6-13.7zm-248.5-10.1c8.7-6.3 12.9-16.7 12.9-31 .3-6.8-1.1-13.5-4.1-19.6-2.7-4.9-6.7-9-11.6-11.9a44.8 44.8 0 0 0-16.6-6c-6.4-1.2-12.9-1.8-19.3-1.7h-70.3v79.7h76.1c13.1.1 24.2-3.1 32.9-9.5zm11.8 72c-9.8-7.5-22.9-11.2-39.2-11.2h-81.8v94h80.2c7.5 0 14.4-.7 21.1-2.1s12.7-3.8 17.8-7.2c5.1-3.3 9.2-7.8 12.3-13.6 3-5.8 4.5-13.2 4.5-22.1 0-17.7-5-30.2-14.9-37.8z"
                }
            }
        ]
    })(props);
}
function AiFillBell(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M816 768h-24V428c0-141.1-104.3-257.8-240-277.2V112c0-22.1-17.9-40-40-40s-40 17.9-40 40v38.8C336.3 170.2 232 286.9 232 428v340h-24c-17.7 0-32 14.3-32 32v32c0 4.4 3.6 8 8 8h216c0 61.8 50.2 112 112 112s112-50.2 112-112h216c4.4 0 8-3.6 8-8v-32c0-17.7-14.3-32-32-32zM512 888c-26.5 0-48-21.5-48-48h96c0 26.5-21.5 48-48 48z"
                }
            }
        ]
    })(props);
}
function AiFillBook(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M832 64H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32zM668 345.9L621.5 312 572 347.4V124h96v221.9z"
                }
            }
        ]
    })(props);
}
function AiFillBoxPlot(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M952 224h-52c-4.4 0-8 3.6-8 8v248h-92V304c0-4.4-3.6-8-8-8H448v432h344c4.4 0 8-3.6 8-8V548h92v244c0 4.4 3.6 8 8 8h52c4.4 0 8-3.6 8-8V232c0-4.4-3.6-8-8-8zm-728 80v176h-92V232c0-4.4-3.6-8-8-8H72c-4.4 0-8 3.6-8 8v560c0 4.4 3.6 8 8 8h52c4.4 0 8-3.6 8-8V548h92v172c0 4.4 3.6 8 8 8h152V296H232c-4.4 0-8 3.6-8 8z"
                }
            }
        ]
    })(props);
}
function AiFillBug(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M304 280h416c4.4 0 8-3.6 8-8 0-40-8.8-76.7-25.9-108.1-17.2-31.5-42.5-56.8-74-74C596.7 72.8 560 64 520 64h-16c-40 0-76.7 8.8-108.1 25.9-31.5 17.2-56.8 42.5-74 74C304.8 195.3 296 232 296 272c0 4.4 3.6 8 8 8z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M940 512H792V412c76.8 0 139-62.2 139-139 0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8 0 34.8-28.2 63-63 63H232c-34.8 0-63-28.2-63-63 0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8 0 76.8 62.2 139 139 139v100H84c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h148v96c0 6.5.2 13 .7 19.3C164.1 728.6 116 796.7 116 876c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8 0-44.2 23.9-82.9 59.6-103.7 6 17.2 13.6 33.6 22.7 49 24.3 41.5 59 76.2 100.5 100.5 28.9 16.9 61 28.8 95.3 34.5 4.4 0 8-3.6 8-8V484c0-4.4 3.6-8 8-8h60c4.4 0 8 3.6 8 8v464.2c0 4.4 3.6 8 8 8 34.3-5.7 66.4-17.6 95.3-34.5 41.5-24.3 76.2-59 100.5-100.5 9.1-15.5 16.7-31.9 22.7-49C812.1 793.1 836 831.8 836 876c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8 0-79.3-48.1-147.4-116.7-176.7.4-6.4.7-12.8.7-19.3v-96h148c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8z"
                }
            }
        ]
    })(props);
}
function AiFillBuild(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M916 210H376c-17.7 0-32 14.3-32 32v236H108c-17.7 0-32 14.3-32 32v272c0 17.7 14.3 32 32 32h540c17.7 0 32-14.3 32-32V546h236c17.7 0 32-14.3 32-32V242c0-17.7-14.3-32-32-32zM612 746H412V546h200v200zm268-268H680V278h200v200z"
                }
            }
        ]
    })(props);
}
function AiFillBulb(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M348 676.1C250 619.4 184 513.4 184 392c0-181.1 146.9-328 328-328s328 146.9 328 328c0 121.4-66 227.4-164 284.1V792c0 17.7-14.3 32-32 32H380c-17.7 0-32-14.3-32-32V676.1zM392 888h240c4.4 0 8 3.6 8 8v32c0 17.7-14.3 32-32 32H416c-17.7 0-32-14.3-32-32v-32c0-4.4 3.6-8 8-8z"
                }
            }
        ]
    })(props);
}
function AiFillCalculator(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM440.2 765h-50.8c-2.2 0-4.5-1.1-5.9-2.9L348 718.6l-35.5 43.5a7.38 7.38 0 0 1-5.9 2.9h-50.8c-6.6 0-10.2-7.9-5.8-13.1l62.7-76.8-61.2-74.9c-4.3-5.2-.7-13.1 5.9-13.1h50.9c2.2 0 4.5 1.1 5.9 2.9l34 41.6 34-41.6c1.5-1.9 3.6-2.9 5.9-2.9h50.8c6.6 0 10.2 7.9 5.9 13.1L383.5 675l62.7 76.8c4.2 5.3.6 13.2-6 13.2zm7.8-382c0 2.2-1.4 4-3.2 4H376v68.7c0 1.9-1.8 3.3-4 3.3h-48c-2.2 0-4-1.4-4-3.2V387h-68.8c-1.8 0-3.2-1.8-3.2-4v-48c0-2.2 1.4-4 3.2-4H320v-68.8c0-1.8 1.8-3.2 4-3.2h48c2.2 0 4 1.4 4 3.2V331h68.7c1.9 0 3.3 1.8 3.3 4v48zm328 369c0 2.2-1.4 4-3.2 4H579.2c-1.8 0-3.2-1.8-3.2-4v-48c0-2.2 1.4-4 3.2-4h193.5c1.9 0 3.3 1.8 3.3 4v48zm0-104c0 2.2-1.4 4-3.2 4H579.2c-1.8 0-3.2-1.8-3.2-4v-48c0-2.2 1.4-4 3.2-4h193.5c1.9 0 3.3 1.8 3.3 4v48zm0-265c0 2.2-1.4 4-3.2 4H579.2c-1.8 0-3.2-1.8-3.2-4v-48c0-2.2 1.4-4 3.2-4h193.5c1.9 0 3.3 1.8 3.3 4v48z"
                }
            }
        ]
    })(props);
}
function AiFillCalendar(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M112 880c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V460H112v420zm768-696H712v-64c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v64H384v-64c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v64H144c-17.7 0-32 14.3-32 32v176h800V216c0-17.7-14.3-32-32-32z"
                }
            }
        ]
    })(props);
}
function AiFillCamera(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M864 260H728l-32.4-90.8a32.07 32.07 0 0 0-30.2-21.2H358.6c-13.5 0-25.6 8.5-30.1 21.2L296 260H160c-44.2 0-80 35.8-80 80v456c0 44.2 35.8 80 80 80h704c44.2 0 80-35.8 80-80V340c0-44.2-35.8-80-80-80zM512 716c-88.4 0-160-71.6-160-160s71.6-160 160-160 160 71.6 160 160-71.6 160-160 160zm-96-160a96 96 0 1 0 192 0 96 96 0 1 0-192 0z"
                }
            }
        ]
    })(props);
}
function AiFillCar(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M959 413.4L935.3 372a8 8 0 0 0-10.9-2.9l-50.7 29.6-78.3-216.2a63.9 63.9 0 0 0-60.9-44.4H301.2c-34.7 0-65.5 22.4-76.2 55.5l-74.6 205.2-50.8-29.6a8 8 0 0 0-10.9 2.9L65 413.4c-2.2 3.8-.9 8.6 2.9 10.8l60.4 35.2-14.5 40c-1.2 3.2-1.8 6.6-1.8 10v348.2c0 15.7 11.8 28.4 26.3 28.4h67.6c12.3 0 23-9.3 25.6-22.3l7.7-37.7h545.6l7.7 37.7c2.7 13 13.3 22.3 25.6 22.3h67.6c14.5 0 26.3-12.7 26.3-28.4V509.4c0-3.4-.6-6.8-1.8-10l-14.5-40 60.3-35.2a8 8 0 0 0 3-10.8zM264 621c-22.1 0-40-17.9-40-40s17.9-40 40-40 40 17.9 40 40-17.9 40-40 40zm388 75c0 4.4-3.6 8-8 8H380c-4.4 0-8-3.6-8-8v-84c0-4.4 3.6-8 8-8h40c4.4 0 8 3.6 8 8v36h168v-36c0-4.4 3.6-8 8-8h40c4.4 0 8 3.6 8 8v84zm108-75c-22.1 0-40-17.9-40-40s17.9-40 40-40 40 17.9 40 40-17.9 40-40 40zM220 418l72.7-199.9.5-1.3.4-1.3c1.1-3.3 4.1-5.5 7.6-5.5h427.6l75.4 208H220z"
                }
            }
        ]
    })(props);
}
function AiFillCaretDown(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M840.4 300H183.6c-19.7 0-30.7 20.8-18.5 35l328.4 380.8c9.4 10.9 27.5 10.9 37 0L858.9 335c12.2-14.2 1.2-35-18.5-35z"
                }
            }
        ]
    })(props);
}
function AiFillCaretLeft(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M689 165.1L308.2 493.5c-10.9 9.4-10.9 27.5 0 37L689 858.9c14.2 12.2 35 1.2 35-18.5V183.6c0-19.7-20.8-30.7-35-18.5z"
                }
            }
        ]
    })(props);
}
function AiFillCaretRight(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M715.8 493.5L335 165.1c-14.2-12.2-35-1.2-35 18.5v656.8c0 19.7 20.8 30.7 35 18.5l380.8-328.4c10.9-9.4 10.9-27.6 0-37z"
                }
            }
        ]
    })(props);
}
function AiFillCaretUp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M858.9 689L530.5 308.2c-9.4-10.9-27.5-10.9-37 0L165.1 689c-12.2 14.2-1.2 35 18.5 35h656.8c19.7 0 30.7-20.8 18.5-35z"
                }
            }
        ]
    })(props);
}
function AiFillCarryOut(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M880 184H712v-64c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v64H384v-64c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v64H144c-17.7 0-32 14.3-32 32v664c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V216c0-17.7-14.3-32-32-32zM694.5 432.7L481.9 725.4a16.1 16.1 0 0 1-26 0l-126.4-174c-3.8-5.3 0-12.7 6.5-12.7h55.2c5.1 0 10 2.5 13 6.6l64.7 89 150.9-207.8c3-4.1 7.8-6.6 13-6.6H688c6.5.1 10.3 7.5 6.5 12.8z"
                }
            }
        ]
    })(props);
}
function AiFillCheckCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm193.5 301.7l-210.6 292a31.8 31.8 0 0 1-51.7 0L318.5 484.9c-3.8-5.3 0-12.7 6.5-12.7h46.9c10.2 0 19.9 4.9 25.9 13.3l71.2 98.8 157.2-218c6-8.3 15.6-13.3 25.9-13.3H699c6.5 0 10.3 7.4 6.5 12.7z"
                }
            }
        ]
    })(props);
}
function AiFillCheckSquare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM695.5 365.7l-210.6 292a31.8 31.8 0 0 1-51.7 0L308.5 484.9c-3.8-5.3 0-12.7 6.5-12.7h46.9c10.2 0 19.9 4.9 25.9 13.3l71.2 98.8 157.2-218c6-8.3 15.6-13.3 25.9-13.3H689c6.5 0 10.3 7.4 6.5 12.7z"
                }
            }
        ]
    })(props);
}
function AiFillChrome(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M371.8 512c0 77.5 62.7 140.2 140.2 140.2S652.2 589.5 652.2 512 589.5 371.8 512 371.8 371.8 434.4 371.8 512zM900 362.4l-234.3 12.1c63.6 74.3 64.6 181.5 11.1 263.7l-188 289.2c78 4.2 158.4-12.9 231.2-55.2 180-104 253-322.1 180-509.8zM320.3 591.9L163.8 284.1A415.35 415.35 0 0 0 96 512c0 208 152.3 380.3 351.4 410.8l106.9-209.4c-96.6 18.2-189.9-34.8-234-121.5zm218.5-285.5l344.4 18.1C848 254.7 792.6 194 719.8 151.7 653.9 113.6 581.5 95.5 510.5 96c-122.5.5-242.2 55.2-322.1 154.5l128.2 196.9c32-91.9 124.8-146.7 222.2-141z"
                }
            }
        ]
    })(props);
}
function AiFillCiCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm-63.6 656c-103 0-162.4-68.6-162.4-182.6v-49C286 373.5 345.4 304 448.3 304c88.3 0 152.3 56.9 152.3 138.1 0 2.4-2 4.4-4.4 4.4h-52.6c-4.2 0-7.6-3.2-8-7.4-4-46.1-37.6-77.6-87-77.6-61.1 0-95.6 45.4-95.6 126.9v49.3c0 80.3 34.5 125.1 95.6 125.1 49.3 0 82.8-29.5 87-72.4.4-4.1 3.8-7.3 8-7.3h52.7c2.4 0 4.4 2 4.4 4.4 0 77.4-64.3 132.5-152.3 132.5zM738 704.1c0 4.4-3.6 8-8 8h-50.4c-4.4 0-8-3.6-8-8V319.9c0-4.4 3.6-8 8-8H730c4.4 0 8 3.6 8 8v384.2z"
                }
            }
        ]
    })(props);
}
function AiFillClockCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm176.5 585.7l-28.6 39a7.99 7.99 0 0 1-11.2 1.7L483.3 569.8a7.92 7.92 0 0 1-3.3-6.5V288c0-4.4 3.6-8 8-8h48.1c4.4 0 8 3.6 8 8v247.5l142.6 103.1c3.6 2.5 4.4 7.5 1.8 11.1z"
                }
            }
        ]
    })(props);
}
function AiFillCloseCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024",
            "fill": "currentColor",
            "fillRule": "evenodd"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M512 64c247.4 0 448 200.6 448 448S759.4 960 512 960 64 759.4 64 512 264.6 64 512 64Zm127.978 274.82-.034.006c-.023.007-.042.018-.083.059L512 466.745l-127.86-127.86c-.042-.041-.06-.052-.084-.059a.118.118 0 0 0-.07 0c-.022.007-.041.018-.082.059l-45.02 45.019c-.04.04-.05.06-.058.083a.118.118 0 0 0 0 .07l.01.022a.268.268 0 0 0 .049.06L466.745 512l-127.86 127.862c-.041.04-.052.06-.059.083a.118.118 0 0 0 0 .07c.007.022.018.041.059.082l45.019 45.02c.04.04.06.05.083.058a.118.118 0 0 0 .07 0c.022-.007.041-.018.082-.059L512 557.254l127.862 127.861c.04.041.06.052.083.059a.118.118 0 0 0 .07 0c.022-.007.041-.018.082-.059l45.02-45.019c.04-.04.05-.06.058-.083a.118.118 0 0 0 0-.07l-.01-.022a.268.268 0 0 0-.049-.06L557.254 512l127.861-127.86c.041-.042.052-.06.059-.084a.118.118 0 0 0 0-.07c-.007-.022-.018-.041-.059-.082l-45.019-45.02c-.04-.04-.06-.05-.083-.058a.118.118 0 0 0-.07 0Z"
                }
            }
        ]
    })(props);
}
function AiFillCloseSquare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024",
            "fill": "currentColor",
            "fillRule": "evenodd"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M880 112c17.7 0 32 14.3 32 32v736c0 17.7-14.3 32-32 32H144c-17.7 0-32-14.3-32-32V144c0-17.7 14.3-32 32-32ZM639.978 338.82l-.034.006c-.023.007-.042.018-.083.059L512 466.745l-127.86-127.86c-.042-.041-.06-.052-.084-.059a.118.118 0 0 0-.07 0c-.022.007-.041.018-.082.059l-45.02 45.019c-.04.04-.05.06-.058.083a.118.118 0 0 0 0 .07l.01.022a.268.268 0 0 0 .049.06L466.745 512l-127.86 127.862c-.041.04-.052.06-.059.083a.118.118 0 0 0 0 .07c.007.022.018.041.059.082l45.019 45.02c.04.04.06.05.083.058a.118.118 0 0 0 .07 0c.022-.007.041-.018.082-.059L512 557.254l127.862 127.861c.04.041.06.052.083.059a.118.118 0 0 0 .07 0c.022-.007.041-.018.082-.059l45.02-45.019c.04-.04.05-.06.058-.083a.118.118 0 0 0 0-.07l-.01-.022a.268.268 0 0 0-.049-.06L557.254 512l127.861-127.86c.041-.042.052-.06.059-.084a.118.118 0 0 0 0-.07c-.007-.022-.018-.041-.059-.082l-45.019-45.02c-.04-.04-.06-.05-.083-.058a.118.118 0 0 0-.07 0Z"
                }
            }
        ]
    })(props);
}
function AiFillCloud(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M811.4 418.7C765.6 297.9 648.9 212 512.2 212S258.8 297.8 213 418.6C127.3 441.1 64 519.1 64 612c0 110.5 89.5 200 199.9 200h496.2C870.5 812 960 722.5 960 612c0-92.7-63.1-170.7-148.6-193.3z"
                }
            }
        ]
    })(props);
}
function AiFillCodeSandboxCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm243.7 589.2L512 794 268.3 653.2V371.8l110-63.6-.4-.2h.2L512 231l134 77h-.2l-.3.2 110.1 63.6v281.4zM307.9 536.7l87.6 49.9V681l96.7 55.9V524.8L307.9 418.4zm203.9-151.8L418 331l-91.1 52.6 185.2 107 185.2-106.9-91.4-52.8zm20 352l97.3-56.2v-94.1l87-49.5V418.5L531.8 525z"
                }
            }
        ]
    })(props);
}
function AiFillCodeSandboxSquare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M307.9 536.7l87.6 49.9V681l96.7 55.9V524.8L307.9 418.4zM880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM755.7 653.2L512 794 268.3 653.2V371.8l110-63.6-.4-.2h.2L512 231l134 77h-.2l-.3.2 110.1 63.6v281.4zm-223.9 83.7l97.3-56.2v-94.1l87-49.5V418.5L531.8 525zm-20-352L418 331l-91.1 52.6 185.2 107 185.2-106.9-91.4-52.8z"
                }
            }
        ]
    })(props);
}
function AiFillCode(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM513.1 518.1l-192 161c-5.2 4.4-13.1.7-13.1-6.1v-62.7c0-2.3 1.1-4.6 2.9-6.1L420.7 512l-109.8-92.2a7.63 7.63 0 0 1-2.9-6.1V351c0-6.8 7.9-10.5 13.1-6.1l192 160.9c3.9 3.2 3.9 9.1 0 12.3zM716 673c0 4.4-3.4 8-7.5 8h-185c-4.1 0-7.5-3.6-7.5-8v-48c0-4.4 3.4-8 7.5-8h185c4.1 0 7.5 3.6 7.5 8v48z"
                }
            }
        ]
    })(props);
}
function AiFillCodepenCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M488.1 414.7V303.4L300.9 428l83.6 55.8zm254.1 137.7v-79.8l-59.8 39.9zM512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm278 533c0 1.1-.1 2.1-.2 3.1 0 .4-.1.7-.2 1a14.16 14.16 0 0 1-.8 3.2c-.2.6-.4 1.2-.6 1.7-.2.4-.4.8-.5 1.2-.3.5-.5 1.1-.8 1.6-.2.4-.4.7-.7 1.1-.3.5-.7 1-1 1.5-.3.4-.5.7-.8 1-.4.4-.8.9-1.2 1.3-.3.3-.6.6-1 .9-.4.4-.9.8-1.4 1.1-.4.3-.7.6-1.1.8-.1.1-.3.2-.4.3L525.2 786c-4 2.7-8.6 4-13.2 4-4.7 0-9.3-1.4-13.3-4L244.6 616.9c-.1-.1-.3-.2-.4-.3l-1.1-.8c-.5-.4-.9-.7-1.3-1.1-.3-.3-.6-.6-1-.9-.4-.4-.8-.8-1.2-1.3a7 7 0 0 1-.8-1c-.4-.5-.7-1-1-1.5-.2-.4-.5-.7-.7-1.1-.3-.5-.6-1.1-.8-1.6-.2-.4-.4-.8-.5-1.2-.2-.6-.4-1.2-.6-1.7-.1-.4-.3-.8-.4-1.2-.2-.7-.3-1.3-.4-2-.1-.3-.1-.7-.2-1-.1-1-.2-2.1-.2-3.1V427.9c0-1 .1-2.1.2-3.1.1-.3.1-.7.2-1a14.16 14.16 0 0 1 .8-3.2c.2-.6.4-1.2.6-1.7.2-.4.4-.8.5-1.2.2-.5.5-1.1.8-1.6.2-.4.4-.7.7-1.1.6-.9 1.2-1.7 1.8-2.5.4-.4.8-.9 1.2-1.3.3-.3.6-.6 1-.9.4-.4.9-.8 1.3-1.1.4-.3.7-.6 1.1-.8.1-.1.3-.2.4-.3L498.7 239c8-5.3 18.5-5.3 26.5 0l254.1 169.1c.1.1.3.2.4.3l1.1.8 1.4 1.1c.3.3.6.6 1 .9.4.4.8.8 1.2 1.3.7.8 1.3 1.6 1.8 2.5.2.4.5.7.7 1.1.3.5.6 1 .8 1.6.2.4.4.8.5 1.2.2.6.4 1.2.6 1.7.1.4.3.8.4 1.2.2.7.3 1.3.4 2 .1.3.1.7.2 1 .1 1 .2 2.1.2 3.1V597zm-254.1 13.3v111.3L723.1 597l-83.6-55.8zM281.8 472.6v79.8l59.8-39.9zM512 456.1l-84.5 56.4 84.5 56.4 84.5-56.4zM723.1 428L535.9 303.4v111.3l103.6 69.1zM384.5 541.2L300.9 597l187.2 124.6V610.3l-103.6-69.1z"
                }
            }
        ]
    })(props);
}
function AiFillCodepenSquare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M723.1 428L535.9 303.4v111.3l103.6 69.1zM512 456.1l-84.5 56.4 84.5 56.4 84.5-56.4zm23.9 154.2v111.3L723.1 597l-83.6-55.8zm-151.4-69.1L300.9 597l187.2 124.6V610.3l-103.6-69.1zM880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-90 485c0 1.1-.1 2.1-.2 3.1 0 .4-.1.7-.2 1a14.16 14.16 0 0 1-.8 3.2c-.2.6-.4 1.2-.6 1.7-.2.4-.4.8-.5 1.2-.3.5-.5 1.1-.8 1.6-.2.4-.4.7-.7 1.1-.3.5-.7 1-1 1.5-.3.4-.5.7-.8 1-.4.4-.8.9-1.2 1.3-.3.3-.6.6-1 .9-.4.4-.9.8-1.4 1.1-.4.3-.7.6-1.1.8-.1.1-.3.2-.4.3L525.2 786c-4 2.7-8.6 4-13.2 4-4.7 0-9.3-1.4-13.3-4L244.6 616.9c-.1-.1-.3-.2-.4-.3l-1.1-.8c-.5-.4-.9-.7-1.3-1.1-.3-.3-.6-.6-1-.9-.4-.4-.8-.8-1.2-1.3a7 7 0 0 1-.8-1c-.4-.5-.7-1-1-1.5-.2-.4-.5-.7-.7-1.1-.3-.5-.6-1.1-.8-1.6-.2-.4-.4-.8-.5-1.2-.2-.6-.4-1.2-.6-1.7-.1-.4-.3-.8-.4-1.2-.2-.7-.3-1.3-.4-2-.1-.3-.1-.7-.2-1-.1-1-.2-2.1-.2-3.1V427.9c0-1 .1-2.1.2-3.1.1-.3.1-.7.2-1a14.16 14.16 0 0 1 .8-3.2c.2-.6.4-1.2.6-1.7.2-.4.4-.8.5-1.2.2-.5.5-1.1.8-1.6.2-.4.4-.7.7-1.1.6-.9 1.2-1.7 1.8-2.5.4-.4.8-.9 1.2-1.3.3-.3.6-.6 1-.9.4-.4.9-.8 1.3-1.1.4-.3.7-.6 1.1-.8.1-.1.3-.2.4-.3L498.7 239c8-5.3 18.5-5.3 26.5 0l254.1 169.1c.1.1.3.2.4.3l1.1.8 1.4 1.1c.3.3.6.6 1 .9.4.4.8.8 1.2 1.3.7.8 1.3 1.6 1.8 2.5.2.4.5.7.7 1.1.3.5.6 1 .8 1.6.2.4.4.8.5 1.2.2.6.4 1.2.6 1.7.1.4.3.8.4 1.2.2.7.3 1.3.4 2 .1.3.1.7.2 1 .1 1 .2 2.1.2 3.1V597zm-47.8-44.6v-79.8l-59.8 39.9zm-460.4-79.8v79.8l59.8-39.9zm206.3-57.9V303.4L300.9 428l83.6 55.8z"
                }
            }
        ]
    })(props);
}
function AiFillCompass(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zM327.3 702.4c-2 .9-4.4 0-5.3-2.1-.4-1-.4-2.2 0-3.2l98.7-225.5 132.1 132.1-225.5 98.7zm375.1-375.1l-98.7 225.5-132.1-132.1L697.1 322c2-.9 4.4 0 5.3 2.1.4 1 .4 2.1 0 3.2z"
                }
            }
        ]
    })(props);
}
function AiFillContacts(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M928 224H768v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56H548v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56H328v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56H96c-17.7 0-32 14.3-32 32v576c0 17.7 14.3 32 32 32h832c17.7 0 32-14.3 32-32V256c0-17.7-14.3-32-32-32zM661 736h-43.9c-4.2 0-7.6-3.3-7.9-7.5-3.8-50.6-46-90.5-97.2-90.5s-93.4 40-97.2 90.5c-.3 4.2-3.7 7.5-7.9 7.5H363a8 8 0 0 1-8-8.4c2.8-53.3 32-99.7 74.6-126.1a111.8 111.8 0 0 1-29.1-75.5c0-61.9 49.9-112 111.4-112 61.5 0 111.4 50.1 111.4 112 0 29.1-11 55.5-29.1 75.5 42.7 26.5 71.8 72.8 74.6 126.1.4 4.6-3.2 8.4-7.8 8.4zM512 474c-28.5 0-51.7 23.3-51.7 52s23.2 52 51.7 52c28.5 0 51.7-23.3 51.7-52s-23.2-52-51.7-52z"
                }
            }
        ]
    })(props);
}
function AiFillContainer(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M832 64H192c-17.7 0-32 14.3-32 32v529c0-.6.4-1 1-1h219.3l5.2 24.7C397.6 708.5 450.8 752 512 752s114.4-43.5 126.4-103.3l5.2-24.7H863c.6 0 1 .4 1 1V96c0-17.7-14.3-32-32-32zM712 493c0 4.4-3.6 8-8 8H320c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h384c4.4 0 8 3.6 8 8v48zm0-160c0 4.4-3.6 8-8 8H320c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h384c4.4 0 8 3.6 8 8v48zm151 354H694.1c-11.6 32.8-32 62.3-59.1 84.7-34.5 28.6-78.2 44.3-123 44.3s-88.5-15.8-123-44.3a194.02 194.02 0 0 1-59.1-84.7H161c-.6 0-1-.4-1-1v242c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V686c0 .6-.4 1-1 1z"
                }
            }
        ]
    })(props);
}
function AiFillControl(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM404 683v77c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8v-77c-41.7-13.6-72-52.8-72-99s30.3-85.5 72-99V264c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v221c41.7 13.6 72 52.8 72 99s-30.3 85.5-72 99zm279.6-143.9c.2 0 .3-.1.4-.1v221c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V539c.2 0 .3.1.4.1-42-13.4-72.4-52.7-72.4-99.1 0-46.4 30.4-85.7 72.4-99.1-.2 0-.3.1-.4.1v-77c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v77c-.2 0-.3-.1-.4-.1 42 13.4 72.4 52.7 72.4 99.1 0 46.4-30.4 85.7-72.4 99.1zM616 440a36 36 0 1 0 72 0 36 36 0 1 0-72 0zM403.4 566.5l-1.5-2.4c0-.1-.1-.1-.1-.2l-.9-1.2c-.1-.1-.2-.2-.2-.3-1-1.3-2-2.5-3.2-3.6l-.2-.2c-.4-.4-.8-.8-1.2-1.1-.8-.8-1.7-1.5-2.6-2.1h-.1l-1.2-.9c-.1-.1-.3-.2-.4-.3-1.2-.8-2.5-1.6-3.9-2.2-.2-.1-.5-.2-.7-.4-.4-.2-.7-.3-1.1-.5-.3-.1-.7-.3-1-.4-.5-.2-1-.4-1.5-.5-.4-.1-.9-.3-1.3-.4l-.9-.3-1.4-.3c-.2-.1-.5-.1-.7-.2-.7-.1-1.4-.3-2.1-.4-.2 0-.4 0-.6-.1-.6-.1-1.1-.1-1.7-.2-.2 0-.4 0-.7-.1-.8 0-1.5-.1-2.3-.1s-1.5 0-2.3.1c-.2 0-.4 0-.7.1-.6 0-1.2.1-1.7.2-.2 0-.4 0-.6.1-.7.1-1.4.2-2.1.4-.2.1-.5.1-.7.2l-1.4.3-.9.3c-.4.1-.9.3-1.3.4-.5.2-1 .4-1.5.5-.3.1-.7.3-1 .4-.4.2-.7.3-1.1.5-.2.1-.5.2-.7.4-1.3.7-2.6 1.4-3.9 2.2-.1.1-.3.2-.4.3l-1.2.9h-.1c-.9.7-1.8 1.4-2.6 2.1-.4.4-.8.7-1.2 1.1l-.2.2a54.8 54.8 0 0 0-3.2 3.6c-.1.1-.2.2-.2.3l-.9 1.2c0 .1-.1.1-.1.2l-1.5 2.4c-.1.2-.2.3-.3.5-2.7 5.1-4.3 10.9-4.3 17s1.6 12 4.3 17c.1.2.2.3.3.5l1.5 2.4c0 .1.1.1.1.2l.9 1.2c.1.1.2.2.2.3 1 1.3 2 2.5 3.2 3.6l.2.2c.4.4.8.8 1.2 1.1.8.8 1.7 1.5 2.6 2.1h.1l1.2.9c.1.1.3.2.4.3 1.2.8 2.5 1.6 3.9 2.2.2.1.5.2.7.4.4.2.7.3 1.1.5.3.1.7.3 1 .4.5.2 1 .4 1.5.5.4.1.9.3 1.3.4l.9.3 1.4.3c.2.1.5.1.7.2.7.1 1.4.3 2.1.4.2 0 .4 0 .6.1.6.1 1.1.1 1.7.2.2 0 .4 0 .7.1.8 0 1.5.1 2.3.1s1.5 0 2.3-.1c.2 0 .4 0 .7-.1.6 0 1.2-.1 1.7-.2.2 0 .4 0 .6-.1.7-.1 1.4-.2 2.1-.4.2-.1.5-.1.7-.2l1.4-.3.9-.3c.4-.1.9-.3 1.3-.4.5-.2 1-.4 1.5-.5.3-.1.7-.3 1-.4.4-.2.7-.3 1.1-.5.2-.1.5-.2.7-.4 1.3-.7 2.6-1.4 3.9-2.2.1-.1.3-.2.4-.3l1.2-.9h.1c.9-.7 1.8-1.4 2.6-2.1.4-.4.8-.7 1.2-1.1l.2-.2c1.1-1.1 2.2-2.4 3.2-3.6.1-.1.2-.2.2-.3l.9-1.2c0-.1.1-.1.1-.2l1.5-2.4c.1-.2.2-.3.3-.5 2.7-5.1 4.3-10.9 4.3-17s-1.6-12-4.3-17c-.1-.2-.2-.4-.3-.5z"
                }
            }
        ]
    })(props);
}
function AiFillCopy(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M832 64H296c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h496v688c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V96c0-17.7-14.3-32-32-32zM704 192H192c-17.7 0-32 14.3-32 32v530.7c0 8.5 3.4 16.6 9.4 22.6l173.3 173.3c2.2 2.2 4.7 4 7.4 5.5v1.9h4.2c3.5 1.3 7.2 2 11 2H704c17.7 0 32-14.3 32-32V224c0-17.7-14.3-32-32-32zM382 896h-.2L232 746.2v-.2h150v150z"
                }
            }
        ]
    })(props);
}
function AiFillCopyrightCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm5.4 670c-110 0-173.4-73.2-173.4-194.9v-52.3C344 364.2 407.4 290 517.3 290c94.3 0 162.7 60.7 162.7 147.4 0 2.6-2.1 4.7-4.7 4.7h-56.7c-4.2 0-7.6-3.2-8-7.4-4-49.5-40-83.4-93-83.4-65.3 0-102.1 48.5-102.1 135.5v52.6c0 85.7 36.9 133.6 102.1 133.6 52.8 0 88.7-31.7 93-77.8.4-4.1 3.8-7.3 8-7.3h56.8c2.6 0 4.7 2.1 4.7 4.7 0 82.6-68.7 141.4-162.7 141.4z"
                }
            }
        ]
    })(props);
}
function AiFillCreditCard(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M928 160H96c-17.7 0-32 14.3-32 32v160h896V192c0-17.7-14.3-32-32-32zM64 832c0 17.7 14.3 32 32 32h832c17.7 0 32-14.3 32-32V440H64v392zm579-184c0-4.4 3.6-8 8-8h165c4.4 0 8 3.6 8 8v72c0 4.4-3.6 8-8 8H651c-4.4 0-8-3.6-8-8v-72z"
                }
            }
        ]
    })(props);
}
function AiFillCrown(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M899.6 276.5L705 396.4 518.4 147.5a8.06 8.06 0 0 0-12.9 0L319 396.4 124.3 276.5c-5.7-3.5-13.1 1.2-12.2 7.9L188.5 865c1.1 7.9 7.9 14 16 14h615.1c8 0 14.9-6 15.9-14l76.4-580.6c.8-6.7-6.5-11.4-12.3-7.9zM512 734.2c-62.1 0-112.6-50.5-112.6-112.6S449.9 509 512 509s112.6 50.5 112.6 112.6S574.1 734.2 512 734.2zm0-160.9c-26.6 0-48.2 21.6-48.2 48.3 0 26.6 21.6 48.3 48.2 48.3s48.2-21.6 48.2-48.3c0-26.6-21.6-48.3-48.2-48.3z"
                }
            }
        ]
    })(props);
}
function AiFillCustomerService(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M512 128c-212.1 0-384 171.9-384 384v360c0 13.3 10.7 24 24 24h184c35.3 0 64-28.7 64-64V624c0-35.3-28.7-64-64-64H200v-48c0-172.3 139.7-312 312-312s312 139.7 312 312v48H688c-35.3 0-64 28.7-64 64v208c0 35.3 28.7 64 64 64h184c13.3 0 24-10.7 24-24V512c0-212.1-171.9-384-384-384z"
                }
            }
        ]
    })(props);
}
function AiFillDashboard(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M924.8 385.6a446.7 446.7 0 0 0-96-142.4 446.7 446.7 0 0 0-142.4-96C631.1 123.8 572.5 112 512 112s-119.1 11.8-174.4 35.2a446.7 446.7 0 0 0-142.4 96 446.7 446.7 0 0 0-96 142.4C75.8 440.9 64 499.5 64 560c0 132.7 58.3 257.7 159.9 343.1l1.7 1.4c5.8 4.8 13.1 7.5 20.6 7.5h531.7c7.5 0 14.8-2.7 20.6-7.5l1.7-1.4C901.7 817.7 960 692.7 960 560c0-60.5-11.9-119.1-35.2-174.4zM482 232c0-4.4 3.6-8 8-8h44c4.4 0 8 3.6 8 8v80c0 4.4-3.6 8-8 8h-44c-4.4 0-8-3.6-8-8v-80zM270 582c0 4.4-3.6 8-8 8h-80c-4.4 0-8-3.6-8-8v-44c0-4.4 3.6-8 8-8h80c4.4 0 8 3.6 8 8v44zm90.7-204.5l-31.1 31.1a8.03 8.03 0 0 1-11.3 0L261.7 352a8.03 8.03 0 0 1 0-11.3l31.1-31.1c3.1-3.1 8.2-3.1 11.3 0l56.6 56.6c3.1 3.1 3.1 8.2 0 11.3zm291.1 83.6l-84.5 84.5c5 18.7.2 39.4-14.5 54.1a55.95 55.95 0 0 1-79.2 0 55.95 55.95 0 0 1 0-79.2 55.87 55.87 0 0 1 54.1-14.5l84.5-84.5c3.1-3.1 8.2-3.1 11.3 0l28.3 28.3c3.1 3.1 3.1 8.1 0 11.3zm43-52.4l-31.1-31.1a8.03 8.03 0 0 1 0-11.3l56.6-56.6c3.1-3.1 8.2-3.1 11.3 0l31.1 31.1c3.1 3.1 3.1 8.2 0 11.3l-56.6 56.6a8.03 8.03 0 0 1-11.3 0zM846 582c0 4.4-3.6 8-8 8h-80c-4.4 0-8-3.6-8-8v-44c0-4.4 3.6-8 8-8h80c4.4 0 8 3.6 8 8v44z"
                }
            }
        ]
    })(props);
}
function AiFillDatabase(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M832 64H192c-17.7 0-32 14.3-32 32v224h704V96c0-17.7-14.3-32-32-32zM288 232c-22.1 0-40-17.9-40-40s17.9-40 40-40 40 17.9 40 40-17.9 40-40 40zM160 928c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V704H160v224zm128-136c22.1 0 40 17.9 40 40s-17.9 40-40 40-40-17.9-40-40 17.9-40 40-40zM160 640h704V384H160v256zm128-168c22.1 0 40 17.9 40 40s-17.9 40-40 40-40-17.9-40-40 17.9-40 40-40z"
                }
            }
        ]
    })(props);
}
function AiFillDelete(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M864 256H736v-80c0-35.3-28.7-64-64-64H352c-35.3 0-64 28.7-64 64v80H160c-17.7 0-32 14.3-32 32v32c0 4.4 3.6 8 8 8h60.4l24.7 523c1.6 34.1 29.8 61 63.9 61h454c34.2 0 62.3-26.8 63.9-61l24.7-523H888c4.4 0 8-3.6 8-8v-32c0-17.7-14.3-32-32-32zm-200 0H360v-72h304v72z"
                }
            }
        ]
    })(props);
}
function AiFillDiff(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M854.2 306.6L611.3 72.9c-6-5.7-13.9-8.9-22.2-8.9H296c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h277l219 210.6V824c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V329.6c0-8.7-3.5-17-9.8-23zM553.4 201.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v704c0 17.7 14.3 32 32 32h512c17.7 0 32-14.3 32-32V397.3c0-8.5-3.4-16.6-9.4-22.6L553.4 201.4zM568 753c0 3.8-3.4 7-7.5 7h-225c-4.1 0-7.5-3.2-7.5-7v-42c0-3.8 3.4-7 7.5-7h225c4.1 0 7.5 3.2 7.5 7v42zm0-220c0 3.8-3.4 7-7.5 7H476v84.9c0 3.9-3.1 7.1-7 7.1h-42c-3.8 0-7-3.2-7-7.1V540h-84.5c-4.1 0-7.5-3.2-7.5-7v-42c0-3.9 3.4-7 7.5-7H420v-84.9c0-3.9 3.2-7.1 7-7.1h42c3.9 0 7 3.2 7 7.1V484h84.5c4.1 0 7.5 3.1 7.5 7v42z"
                }
            }
        ]
    })(props);
}
function AiFillDingtalkCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm227 385.3c-1 4.2-3.5 10.4-7 17.8h.1l-.4.7c-20.3 43.1-73.1 127.7-73.1 127.7s-.1-.2-.3-.5l-15.5 26.8h74.5L575.1 810l32.3-128h-58.6l20.4-84.7c-16.5 3.9-35.9 9.4-59 16.8 0 0-31.2 18.2-89.9-35 0 0-39.6-34.7-16.6-43.4 9.8-3.7 47.4-8.4 77-12.3 40-5.4 64.6-8.2 64.6-8.2S422 517 392.7 512.5c-29.3-4.6-66.4-53.1-74.3-95.8 0 0-12.2-23.4 26.3-12.3 38.5 11.1 197.9 43.2 197.9 43.2s-207.4-63.3-221.2-78.7c-13.8-15.4-40.6-84.2-37.1-126.5 0 0 1.5-10.5 12.4-7.7 0 0 153.3 69.7 258.1 107.9 104.8 37.9 195.9 57.3 184.2 106.7z"
                }
            }
        ]
    })(props);
}
function AiFillDingtalkSquare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM739 449.3c-1 4.2-3.5 10.4-7 17.8h.1l-.4.7c-20.3 43.1-73.1 127.7-73.1 127.7s-.1-.2-.3-.5l-15.5 26.8h74.5L575.1 810l32.3-128h-58.6l20.4-84.7c-16.5 3.9-35.9 9.4-59 16.8 0 0-31.2 18.2-89.9-35 0 0-39.6-34.7-16.6-43.4 9.8-3.7 47.4-8.4 77-12.3 40-5.4 64.6-8.2 64.6-8.2S422 517 392.7 512.5c-29.3-4.6-66.4-53.1-74.3-95.8 0 0-12.2-23.4 26.3-12.3 38.5 11.1 197.9 43.2 197.9 43.2s-207.4-63.3-221.2-78.7c-13.8-15.4-40.6-84.2-37.1-126.5 0 0 1.5-10.5 12.4-7.7 0 0 153.3 69.7 258.1 107.9 104.8 37.9 195.9 57.3 184.2 106.7z"
                }
            }
        ]
    })(props);
}
function AiFillDislike(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M885.9 490.3c3.6-12 5.4-24.4 5.4-37 0-28.3-9.3-55.5-26.1-77.7 3.6-12 5.4-24.4 5.4-37 0-28.3-9.3-55.5-26.1-77.7 3.6-12 5.4-24.4 5.4-37 0-51.6-30.7-98.1-78.3-118.4a66.1 66.1 0 0 0-26.5-5.4H273v428h.3l85.8 310.8C372.9 889 418.9 924 470.9 924c29.7 0 57.4-11.8 77.9-33.4 20.5-21.5 31-49.7 29.5-79.4l-6-122.9h239.9c12.1 0 23.9-3.2 34.3-9.3 40.4-23.5 65.5-66.1 65.5-111 0-28.3-9.3-55.5-26.1-77.7zM112 132v364c0 17.7 14.3 32 32 32h65V100h-65c-17.7 0-32 14.3-32 32z"
                }
            }
        ]
    })(props);
}
function AiFillDollarCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm22.3 665.2l.2 31.7c0 4.4-3.6 8.1-8 8.1h-28.4c-4.4 0-8-3.6-8-8v-31.4C401.3 723 359.5 672.4 355 617.4c-.4-4.7 3.3-8.7 8-8.7h46.2c3.9 0 7.3 2.8 7.9 6.6 5.1 31.7 29.8 55.4 74.1 61.3V533.9l-24.7-6.3c-52.3-12.5-102.1-45.1-102.1-112.7 0-72.9 55.4-112.1 126.2-119v-33c0-4.4 3.6-8 8-8h28.1c4.4 0 8 3.6 8 8v32.7c68.5 6.9 119.9 46.9 125.9 109.2.5 4.7-3.2 8.8-8 8.8h-44.9c-4 0-7.4-3-7.9-6.9-4-29.2-27.4-53-65.5-58.2v134.3l25.4 5.9c64.8 16 108.9 47 108.9 116.4 0 75.3-56 117.3-134.3 124.1zM426.6 410.3c0 25.4 15.7 45.1 49.5 57.3 4.7 1.9 9.4 3.4 15 5v-124c-36.9 4.7-64.5 25.4-64.5 61.7zm116.5 135.2c-2.8-.6-5.6-1.3-8.8-2.2V677c42.6-3.8 72-27.2 72-66.4 0-30.7-15.9-50.7-63.2-65.1z"
                }
            }
        ]
    })(props);
}
function AiFillDownCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm184.5 353.7l-178 246a7.95 7.95 0 0 1-12.9 0l-178-246c-3.8-5.3 0-12.7 6.5-12.7H381c10.2 0 19.9 4.9 25.9 13.2L512 563.6l105.2-145.4c6-8.3 15.6-13.2 25.9-13.2H690c6.5 0 10.3 7.4 6.5 12.7z"
                }
            }
        ]
    })(props);
}
function AiFillDownSquare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM696.5 412.7l-178 246a7.95 7.95 0 0 1-12.9 0l-178-246c-3.8-5.3 0-12.7 6.5-12.7H381c10.2 0 19.9 4.9 25.9 13.2L512 558.6l105.2-145.4c6-8.3 15.6-13.2 25.9-13.2H690c6.5 0 10.3 7.4 6.5 12.7z"
                }
            }
        ]
    })(props);
}
function AiFillDribbbleCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M675.1 328.3a245.2 245.2 0 0 0-220.8-55.1c6.8 9.1 51.5 69.9 91.8 144 87.5-32.8 124.5-82.6 129-88.9zM554 552.8c-138.7 48.3-188.6 144.6-193 153.6 41.7 32.5 94.1 51.9 151 51.9 34.1 0 66.6-6.9 96.1-19.5-3.7-21.6-17.9-96.8-52.5-186.6l-1.6.6zm47.7-11.9c32.2 88.4 45.3 160.4 47.8 175.4 55.2-37.3 94.5-96.4 105.4-164.9-8.4-2.6-76.1-22.8-153.2-10.5zM512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 736c-158.8 0-288-129.2-288-288s129.2-288 288-288 288 129.2 288 288-129.2 288-288 288zm53.1-346.2c5.7 11.7 11.2 23.6 16.3 35.6 1.8 4.2 3.6 8.4 5.3 12.7 81.8-10.3 163.2 6.2 171.3 7.9-.5-58.1-21.3-111.4-55.5-153.3-5.3 7.1-46.5 60-137.4 97.1zM498.6 432c-40.8-72.5-84.7-133.4-91.2-142.3-68.8 32.5-120.3 95.9-136.2 172.2 11 .2 112.4.7 227.4-29.9zm30.6 82.5c3.2-1 6.4-2 9.7-2.9-6.2-14-12.9-28-19.9-41.7-122.8 36.8-242.1 35.2-252.8 35-.1 2.5-.1 5-.1 7.5 0 63.2 23.9 120.9 63.2 164.5 5.5-9.6 73-121.4 199.9-162.4z"
                }
            }
        ]
    })(props);
}
function AiFillDribbbleSquare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M498.6 432c-40.8-72.5-84.7-133.4-91.2-142.3-68.8 32.5-120.3 95.9-136.2 172.2 11 .2 112.4.7 227.4-29.9zm66.5 21.8c5.7 11.7 11.2 23.6 16.3 35.6 1.8 4.2 3.6 8.4 5.3 12.7 81.8-10.3 163.2 6.2 171.3 7.9-.5-58.1-21.3-111.4-55.5-153.3-5.3 7.1-46.5 60-137.4 97.1zM880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM512 800c-158.8 0-288-129.2-288-288s129.2-288 288-288 288 129.2 288 288-129.2 288-288 288zm89.7-259.1c32.2 88.4 45.3 160.4 47.8 175.4 55.2-37.3 94.5-96.4 105.4-164.9-8.4-2.6-76.1-22.8-153.2-10.5zm-72.5-26.4c3.2-1 6.4-2 9.7-2.9-6.2-14-12.9-28-19.9-41.7-122.8 36.8-242.1 35.2-252.8 35-.1 2.5-.1 5-.1 7.5 0 63.2 23.9 120.9 63.2 164.5 5.5-9.6 73-121.4 199.9-162.4zm145.9-186.2a245.2 245.2 0 0 0-220.8-55.1c6.8 9.1 51.5 69.9 91.8 144 87.5-32.8 124.5-82.6 129-88.9zM554 552.8c-138.7 48.3-188.6 144.6-193 153.6 41.7 32.5 94.1 51.9 151 51.9 34.1 0 66.6-6.9 96.1-19.5-3.7-21.6-17.9-96.8-52.5-186.6l-1.6.6z"
                }
            }
        ]
    })(props);
}
function AiFillDropboxCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M663.8 455.5zm-151.5-93.8l-151.8 93.8 151.8 93.9 151.5-93.9zM512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm151.2 595.5L512.6 750l-151-90.5v-33.1l45.4 29.4 105.6-87.7 105.6 87.7 45.1-29.4v33.1zm-45.6-22.4l-105.3-87.7L407 637.1l-151-99.2 104.5-82.4L256 371.2 407 274l105.3 87.7L617.6 274 768 372.1l-104.2 83.5L768 539l-150.4 98.1z"
                }
            }
        ]
    })(props);
}
function AiFillDropboxSquare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM663.2 659.5L512.6 750l-151-90.5v-33.1l45.4 29.4 105.6-87.7 105.6 87.7 45.1-29.4v33.1zm-45.6-22.4l-105.3-87.7L407 637.1l-151-99.2 104.5-82.4L256 371.2 407 274l105.3 87.7L617.6 274 768 372.1l-104.2 83.5L768 539l-150.4 98.1zM512.3 361.7l-151.8 93.8 151.8 93.9 151.5-93.9zm151.5 93.8z"
                }
            }
        ]
    })(props);
}
function AiFillEdit(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M880 836H144c-17.7 0-32 14.3-32 32v36c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-36c0-17.7-14.3-32-32-32zm-622.3-84c2 0 4-.2 6-.5L431.9 722c2-.4 3.9-1.3 5.3-2.8l423.9-423.9a9.96 9.96 0 0 0 0-14.1L694.9 114.9c-1.9-1.9-4.4-2.9-7.1-2.9s-5.2 1-7.1 2.9L256.8 538.8c-1.5 1.5-2.4 3.3-2.8 5.3l-29.5 168.2a33.5 33.5 0 0 0 9.4 29.8c6.6 6.4 14.9 9.9 23.8 9.9z"
                }
            }
        ]
    })(props);
}
function AiFillEnvironment(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M512 327c-29.9 0-58 11.6-79.2 32.8A111.6 111.6 0 0 0 400 439c0 29.9 11.7 58 32.8 79.2A111.6 111.6 0 0 0 512 551c29.9 0 58-11.7 79.2-32.8C612.4 497 624 468.9 624 439c0-29.9-11.6-58-32.8-79.2S541.9 327 512 327zm342.6-37.9a362.49 362.49 0 0 0-79.9-115.7 370.83 370.83 0 0 0-118.2-77.8C610.7 76.6 562.1 67 512 67c-50.1 0-98.7 9.6-144.5 28.5-44.3 18.3-84 44.5-118.2 77.8A363.6 363.6 0 0 0 169.4 289c-19.5 45-29.4 92.8-29.4 142 0 70.6 16.9 140.9 50.1 208.7 26.7 54.5 64 107.6 111 158.1 80.3 86.2 164.5 138.9 188.4 153a43.9 43.9 0 0 0 22.4 6.1c7.8 0 15.5-2 22.4-6.1 23.9-14.1 108.1-66.8 188.4-153 47-50.4 84.3-103.6 111-158.1C867.1 572 884 501.8 884 431.1c0-49.2-9.9-97-29.4-142zM512 615c-97.2 0-176-78.8-176-176s78.8-176 176-176 176 78.8 176 176-78.8 176-176 176z"
                }
            }
        ]
    })(props);
}
function AiFillEuroCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm63.5 375.8c4.4 0 8 3.6 8 8V475c0 4.4-3.6 8-8 8h-136c-.3 4.4-.3 9.1-.3 13.8v36h136.2c4.4 0 8 3.6 8 8V568c0 4.4-3.6 8-8 8H444.9c15.3 62 61.3 98.6 129.8 98.6 19.9 0 37.1-1.2 51.8-4.1 4.9-1 9.5 2.8 9.5 7.8v42.8c0 3.8-2.7 7-6.4 7.8-15.9 3.4-34.3 5.1-55.3 5.1-109.8 0-183-58.8-200.2-158H344c-4.4 0-8-3.6-8-8v-27.2c0-4.4 3.6-8 8-8h26.1v-36.9c0-4.4 0-8.8.3-12.8H344c-4.4 0-8-3.6-8-8v-27.2c0-4.4 3.6-8 8-8h31.7c19.7-94.2 92-149.9 198.6-149.9 20.9 0 39.4 1.9 55.3 5.4 3.7.8 6.3 4 6.3 7.8V346h.1c0 5.1-4.6 8.8-9.6 7.8-14.7-2.9-31.8-4.4-51.7-4.4-65.4 0-110.4 33.5-127.6 90.4h128.4z"
                }
            }
        ]
    })(props);
}
function AiFillExclamationCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm-32 232c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v272c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V296zm32 440a48.01 48.01 0 0 1 0-96 48.01 48.01 0 0 1 0 96z"
                }
            }
        ]
    })(props);
}
function AiFillExperiment(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M218.9 636.3l42.6 26.6c.1.1.3.2.4.3l12.7 8 .3.3a186.9 186.9 0 0 0 94.1 25.1c44.9 0 87.2-15.7 121-43.8a256.27 256.27 0 0 1 164.9-59.9c52.3 0 102.2 15.7 144.6 44.5l7.9 5-111.6-289V179.8h63.5c4.4 0 8-3.6 8-8V120c0-4.4-3.6-8-8-8H264.7c-4.4 0-8 3.6-8 8v51.9c0 4.4 3.6 8 8 8h63.5v173.6L218.9 636.3zm333-203.1c22 0 39.9 17.9 39.9 39.9S573.9 513 551.9 513 512 495.1 512 473.1s17.9-39.9 39.9-39.9zM878 825.1l-29.9-77.4-85.7-53.5-.1.1c-.7-.5-1.5-1-2.2-1.5l-8.1-5-.3-.3c-29-17.5-62.3-26.8-97-26.8-44.9 0-87.2 15.7-121 43.8a256.27 256.27 0 0 1-164.9 59.9c-53 0-103.5-16.1-146.2-45.6l-28.9-18.1L146 825.1c-2.8 7.4-4.3 15.2-4.3 23 0 35.2 28.6 63.8 63.8 63.8h612.9c7.9 0 15.7-1.5 23-4.3a63.6 63.6 0 0 0 36.6-82.5z"
                }
            }
        ]
    })(props);
}
function AiFillEyeInvisible(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "defs",
                "attr": {},
                "child": [
                    {
                        "tag": "clipPath",
                        "attr": {},
                        "child": [
                            {
                                "tag": "path",
                                "attr": {
                                    "fill": "none",
                                    "d": "M124-288l388-672 388 672H124z",
                                    "clipRule": "evenodd"
                                }
                            }
                        ]
                    }
                ]
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M508 624a112 112 0 0 0 112-112c0-3.28-.15-6.53-.43-9.74L498.26 623.57c3.21.28 6.45.43 9.74.43zm370.72-458.44L836 122.88a8 8 0 0 0-11.31 0L715.37 232.23Q624.91 186 512 186q-288.3 0-430.2 300.3a60.3 60.3 0 0 0 0 51.5q56.7 119.43 136.55 191.45L112.56 835a8 8 0 0 0 0 11.31L155.25 889a8 8 0 0 0 11.31 0l712.16-712.12a8 8 0 0 0 0-11.32zM332 512a176 176 0 0 1 258.88-155.28l-48.62 48.62a112.08 112.08 0 0 0-140.92 140.92l-48.62 48.62A175.09 175.09 0 0 1 332 512z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M942.2 486.2Q889.4 375 816.51 304.85L672.37 449A176.08 176.08 0 0 1 445 676.37L322.74 798.63Q407.82 838 512 838q288.3 0 430.2-300.3a60.29 60.29 0 0 0 0-51.5z"
                }
            }
        ]
    })(props);
}
function AiFillEye(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M396 512a112 112 0 1 0 224 0 112 112 0 1 0-224 0zm546.2-25.8C847.4 286.5 704.1 186 512 186c-192.2 0-335.4 100.5-430.2 300.3a60.3 60.3 0 0 0 0 51.5C176.6 737.5 319.9 838 512 838c192.2 0 335.4-100.5 430.2-300.3 7.7-16.2 7.7-35 0-51.5zM508 688c-97.2 0-176-78.8-176-176s78.8-176 176-176 176 78.8 176 176-78.8 176-176 176z"
                }
            }
        ]
    })(props);
}
function AiFillFacebook(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-92.4 233.5h-63.9c-50.1 0-59.8 23.8-59.8 58.8v77.1h119.6l-15.6 120.7h-104V912H539.2V602.2H434.9V481.4h104.3v-89c0-103.3 63.1-159.6 155.3-159.6 44.2 0 82.1 3.3 93.2 4.8v107.9z"
                }
            }
        ]
    })(props);
}
function AiFillFastBackward(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M517.6 273.5L230.2 499.3a16.14 16.14 0 0 0 0 25.4l287.4 225.8c10.7 8.4 26.4.8 26.4-12.7V286.2c0-13.5-15.7-21.1-26.4-12.7zm320 0L550.2 499.3a16.14 16.14 0 0 0 0 25.4l287.4 225.8c10.7 8.4 26.4.8 26.4-12.7V286.2c0-13.5-15.7-21.1-26.4-12.7zm-620-25.5h-51.2c-3.5 0-6.4 2.7-6.4 6v516c0 3.3 2.9 6 6.4 6h51.2c3.5 0 6.4-2.7 6.4-6V254c0-3.3-2.9-6-6.4-6z"
                }
            }
        ]
    })(props);
}
function AiFillFastForward(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M793.8 499.3L506.4 273.5c-10.7-8.4-26.4-.8-26.4 12.7v451.6c0 13.5 15.7 21.1 26.4 12.7l287.4-225.8a16.14 16.14 0 0 0 0-25.4zm-320 0L186.4 273.5c-10.7-8.4-26.4-.8-26.4 12.7v451.5c0 13.5 15.7 21.1 26.4 12.7l287.4-225.8c4.1-3.2 6.2-8 6.2-12.7 0-4.6-2.1-9.4-6.2-12.6zM857.6 248h-51.2c-3.5 0-6.4 2.7-6.4 6v516c0 3.3 2.9 6 6.4 6h51.2c3.5 0 6.4-2.7 6.4-6V254c0-3.3-2.9-6-6.4-6z"
                }
            }
        ]
    })(props);
}
function AiFillFileAdd(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M480 580H372a8 8 0 0 0-8 8v48a8 8 0 0 0 8 8h108v108a8 8 0 0 0 8 8h48a8 8 0 0 0 8-8V644h108a8 8 0 0 0 8-8v-48a8 8 0 0 0-8-8H544V472a8 8 0 0 0-8-8h-48a8 8 0 0 0-8 8v108zm374.6-291.3c6 6 9.4 14.1 9.4 22.6V928c0 17.7-14.3 32-32 32H192c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32h424.7c8.5 0 16.7 3.4 22.7 9.4l215.2 215.3zM790.2 326L602 137.8V326h188.2z"
                }
            }
        ]
    })(props);
}
function AiFillFileExcel(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M854.6 288.7c6 6 9.4 14.1 9.4 22.6V928c0 17.7-14.3 32-32 32H192c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32h424.7c8.5 0 16.7 3.4 22.7 9.4l215.2 215.3zM790.2 326L602 137.8V326h188.2zM575.34 477.84l-61.22 102.3L452.3 477.8a12 12 0 0 0-10.27-5.79h-38.44a12 12 0 0 0-6.4 1.85 12 12 0 0 0-3.75 16.56l82.34 130.42-83.45 132.78a12 12 0 0 0-1.84 6.39 12 12 0 0 0 12 12h34.46a12 12 0 0 0 10.21-5.7l62.7-101.47 62.3 101.45a12 12 0 0 0 10.23 5.72h37.48a12 12 0 0 0 6.48-1.9 12 12 0 0 0 3.62-16.58l-83.83-130.55 85.3-132.47a12 12 0 0 0 1.9-6.5 12 12 0 0 0-12-12h-35.7a12 12 0 0 0-10.29 5.84z"
                }
            }
        ]
    })(props);
}
function AiFillFileExclamation(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M854.6 288.7c6 6 9.4 14.1 9.4 22.6V928c0 17.7-14.3 32-32 32H192c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32h424.7c8.5 0 16.7 3.4 22.7 9.4l215.2 215.3zM790.2 326L602 137.8V326h188.2zM512 784a40 40 0 1 0 0-80 40 40 0 0 0 0 80zm32-152V448a8 8 0 0 0-8-8h-48a8 8 0 0 0-8 8v184a8 8 0 0 0 8 8h48a8 8 0 0 0 8-8z"
                }
            }
        ]
    })(props);
}
function AiFillFileImage(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M854.6 288.7L639.4 73.4c-6-6-14.2-9.4-22.7-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.6-9.4-22.6zM400 402c22.1 0 40 17.9 40 40s-17.9 40-40 40-40-17.9-40-40 17.9-40 40-40zm296 294H328c-6.7 0-10.4-7.7-6.3-12.9l99.8-127.2a8 8 0 0 1 12.6 0l41.1 52.4 77.8-99.2a8 8 0 0 1 12.6 0l136.5 174c4.3 5.2.5 12.9-6.1 12.9zm-94-370V137.8L790.2 326H602z"
                }
            }
        ]
    })(props);
}
function AiFillFileMarkdown(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M854.6 288.7c6 6 9.4 14.1 9.4 22.6V928c0 17.7-14.3 32-32 32H192c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32h424.7c8.5 0 16.7 3.4 22.7 9.4l215.2 215.3zM790.2 326L602 137.8V326h188.2zM426.13 600.93l59.11 132.97a16 16 0 0 0 14.62 9.5h24.06a16 16 0 0 0 14.63-9.51l59.1-133.35V758a16 16 0 0 0 16.01 16H641a16 16 0 0 0 16-16V486a16 16 0 0 0-16-16h-34.75a16 16 0 0 0-14.67 9.62L512.1 662.2l-79.48-182.59a16 16 0 0 0-14.67-9.61H383a16 16 0 0 0-16 16v272a16 16 0 0 0 16 16h27.13a16 16 0 0 0 16-16V600.93z"
                }
            }
        ]
    })(props);
}
function AiFillFilePdf(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M854.6 288.7c6 6 9.4 14.1 9.4 22.6V928c0 17.7-14.3 32-32 32H192c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32h424.7c8.5 0 16.7 3.4 22.7 9.4l215.2 215.3zM790.2 326L602 137.8V326h188.2zM633.22 637.26c-15.18-.5-31.32.67-49.65 2.96-24.3-14.99-40.66-35.58-52.28-65.83l1.07-4.38 1.24-5.18c4.3-18.13 6.61-31.36 7.3-44.7.52-10.07-.04-19.36-1.83-27.97-3.3-18.59-16.45-29.46-33.02-30.13-15.45-.63-29.65 8-33.28 21.37-5.91 21.62-2.45 50.07 10.08 98.59-15.96 38.05-37.05 82.66-51.2 107.54-18.89 9.74-33.6 18.6-45.96 28.42-16.3 12.97-26.48 26.3-29.28 40.3-1.36 6.49.69 14.97 5.36 21.92 5.3 7.88 13.28 13 22.85 13.74 24.15 1.87 53.83-23.03 86.6-79.26 3.29-1.1 6.77-2.26 11.02-3.7l11.9-4.02c7.53-2.54 12.99-4.36 18.39-6.11 23.4-7.62 41.1-12.43 57.2-15.17 27.98 14.98 60.32 24.8 82.1 24.8 17.98 0 30.13-9.32 34.52-23.99 3.85-12.88.8-27.82-7.48-36.08-8.56-8.41-24.3-12.43-45.65-13.12zM385.23 765.68v-.36l.13-.34a54.86 54.86 0 0 1 5.6-10.76c4.28-6.58 10.17-13.5 17.47-20.87 3.92-3.95 8-7.8 12.79-12.12 1.07-.96 7.91-7.05 9.19-8.25l11.17-10.4-8.12 12.93c-12.32 19.64-23.46 33.78-33 43-3.51 3.4-6.6 5.9-9.1 7.51a16.43 16.43 0 0 1-2.61 1.42c-.41.17-.77.27-1.13.3a2.2 2.2 0 0 1-1.12-.15 2.07 2.07 0 0 1-1.27-1.91zM511.17 547.4l-2.26 4-1.4-4.38c-3.1-9.83-5.38-24.64-6.01-38-.72-15.2.49-24.32 5.29-24.32 6.74 0 9.83 10.8 10.07 27.05.22 14.28-2.03 29.14-5.7 35.65zm-5.81 58.46l1.53-4.05 2.09 3.8c11.69 21.24 26.86 38.96 43.54 51.31l3.6 2.66-4.39.9c-16.33 3.38-31.54 8.46-52.34 16.85 2.17-.88-21.62 8.86-27.64 11.17l-5.25 2.01 2.8-4.88c12.35-21.5 23.76-47.32 36.05-79.77zm157.62 76.26c-7.86 3.1-24.78.33-54.57-12.39l-7.56-3.22 8.2-.6c23.3-1.73 39.8-.45 49.42 3.07 4.1 1.5 6.83 3.39 8.04 5.55a4.64 4.64 0 0 1-1.36 6.31 6.7 6.7 0 0 1-2.17 1.28z"
                }
            }
        ]
    })(props);
}
function AiFillFilePpt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M854.6 288.7c6 6 9.4 14.1 9.4 22.6V928c0 17.7-14.3 32-32 32H192c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32h424.7c8.5 0 16.7 3.4 22.7 9.4l215.2 215.3zM790.2 326L602 137.8V326h188.2zM468.53 760v-91.54h59.27c60.57 0 100.2-39.65 100.2-98.12 0-58.22-39.58-98.34-99.98-98.34H424a12 12 0 0 0-12 12v276a12 12 0 0 0 12 12h32.53a12 12 0 0 0 12-12zm0-139.33h34.9c47.82 0 67.19-12.93 67.19-50.33 0-32.05-18.12-50.12-49.87-50.12h-52.22v100.45z"
                }
            }
        ]
    })(props);
}
function AiFillFileText(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M854.6 288.7c6 6 9.4 14.1 9.4 22.6V928c0 17.7-14.3 32-32 32H192c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32h424.7c8.5 0 16.7 3.4 22.7 9.4l215.2 215.3zM790.2 326L602 137.8V326h188.2zM320 482a8 8 0 0 0-8 8v48a8 8 0 0 0 8 8h384a8 8 0 0 0 8-8v-48a8 8 0 0 0-8-8H320zm0 136a8 8 0 0 0-8 8v48a8 8 0 0 0 8 8h184a8 8 0 0 0 8-8v-48a8 8 0 0 0-8-8H320z"
                }
            }
        ]
    })(props);
}
function AiFillFileUnknown(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M854.6 288.7c6 6 9.4 14.1 9.4 22.6V928c0 17.7-14.3 32-32 32H192c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32h424.7c8.5 0 16.7 3.4 22.7 9.4l215.2 215.3zM790.2 326L602 137.8V326h188.2zM402 549c0 5.4 4.4 9.5 9.8 9.5h32.4c5.4 0 9.8-4.2 9.8-9.4 0-28.2 25.8-51.6 58-51.6s58 23.4 58 51.5c0 25.3-21 47.2-49.3 50.9-19.3 2.8-34.5 20.3-34.7 40.1v32c0 5.5 4.5 10 10 10h32c5.5 0 10-4.5 10-10v-12.2c0-6 4-11.5 9.7-13.3 44.6-14.4 75-54 74.3-98.9-.8-55.5-49.2-100.8-108.5-101.6-61.4-.7-111.5 45.6-111.5 103zm110 227a32 32 0 1 0 0-64 32 32 0 0 0 0 64z"
                }
            }
        ]
    })(props);
}
function AiFillFileWord(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M854.6 288.7c6 6 9.4 14.1 9.4 22.6V928c0 17.7-14.3 32-32 32H192c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32h424.7c8.5 0 16.7 3.4 22.7 9.4l215.2 215.3zM790.2 326L602 137.8V326h188.2zM512 566.1l52.81 197a12 12 0 0 0 11.6 8.9h31.77a12 12 0 0 0 11.6-8.88l74.37-276a12 12 0 0 0 .4-3.12 12 12 0 0 0-12-12h-35.57a12 12 0 0 0-11.7 9.31l-45.78 199.1-49.76-199.32A12 12 0 0 0 528.1 472h-32.2a12 12 0 0 0-11.64 9.1L434.6 680.01 388.5 481.3a12 12 0 0 0-11.68-9.29h-35.39a12 12 0 0 0-3.11.41 12 12 0 0 0-8.47 14.7l74.17 276A12 12 0 0 0 415.6 772h31.99a12 12 0 0 0 11.59-8.9l52.81-197z"
                }
            }
        ]
    })(props);
}
function AiFillFileZip(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M854.6 288.7c6 6 9.4 14.1 9.4 22.6V928c0 17.7-14.3 32-32 32H192c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32h424.7c8.5 0 16.7 3.4 22.7 9.4l215.2 215.3zM790.2 326L602 137.8V326h188.2zM296 136v64h64v-64h-64zm64 64v64h64v-64h-64zm-64 64v64h64v-64h-64zm64 64v64h64v-64h-64zm-64 64v64h64v-64h-64zm64 64v64h64v-64h-64zm-64 64v64h64v-64h-64zm0 64v160h128V584H296zm48 48h32v64h-32v-64z"
                }
            }
        ]
    })(props);
}
function AiFillFile(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M854.6 288.7c6 6 9.4 14.1 9.4 22.6V928c0 17.7-14.3 32-32 32H192c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32h424.7c8.5 0 16.7 3.4 22.7 9.4l215.2 215.3zM790.2 326L602 137.8V326h188.2z"
                }
            }
        ]
    })(props);
}
function AiFillFilter(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M349 838c0 17.7 14.2 32 31.8 32h262.4c17.6 0 31.8-14.3 31.8-32V642H349v196zm531.1-684H143.9c-24.5 0-39.8 26.7-27.5 48l221.3 376h348.8l221.3-376c12.1-21.3-3.2-48-27.7-48z"
                }
            }
        ]
    })(props);
}
function AiFillFire(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M834.1 469.2A347.49 347.49 0 0 0 751.2 354l-29.1-26.7a8.09 8.09 0 0 0-13 3.3l-13 37.3c-8.1 23.4-23 47.3-44.1 70.8-1.4 1.5-3 1.9-4.1 2-1.1.1-2.8-.1-4.3-1.5-1.4-1.2-2.1-3-2-4.8 3.7-60.2-14.3-128.1-53.7-202C555.3 171 510 123.1 453.4 89.7l-41.3-24.3c-5.4-3.2-12.3 1-12 7.3l2.2 48c1.5 32.8-2.3 61.8-11.3 85.9-11 29.5-26.8 56.9-47 81.5a295.64 295.64 0 0 1-47.5 46.1 352.6 352.6 0 0 0-100.3 121.5A347.75 347.75 0 0 0 160 610c0 47.2 9.3 92.9 27.7 136a349.4 349.4 0 0 0 75.5 110.9c32.4 32 70 57.2 111.9 74.7C418.5 949.8 464.5 959 512 959s93.5-9.2 136.9-27.3A348.6 348.6 0 0 0 760.8 857c32.4-32 57.8-69.4 75.5-110.9a344.2 344.2 0 0 0 27.7-136c0-48.8-10-96.2-29.9-140.9z"
                }
            }
        ]
    })(props);
}
function AiFillFlag(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M880 305H624V192c0-17.7-14.3-32-32-32H184v-40c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v784c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V640h248v113c0 17.7 14.3 32 32 32h416c17.7 0 32-14.3 32-32V337c0-17.7-14.3-32-32-32z"
                }
            }
        ]
    })(props);
}
function AiFillFolderAdd(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M880 298.4H521L403.7 186.2a8.15 8.15 0 0 0-5.5-2.2H144c-17.7 0-32 14.3-32 32v592c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V330.4c0-17.7-14.3-32-32-32zM632 577c0 3.8-3.4 7-7.5 7H540v84.9c0 3.9-3.2 7.1-7 7.1h-42c-3.8 0-7-3.2-7-7.1V584h-84.5c-4.1 0-7.5-3.2-7.5-7v-42c0-3.8 3.4-7 7.5-7H484v-84.9c0-3.9 3.2-7.1 7-7.1h42c3.8 0 7 3.2 7 7.1V528h84.5c4.1 0 7.5 3.2 7.5 7v42z"
                }
            }
        ]
    })(props);
}
function AiFillFolderOpen(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M928 444H820V330.4c0-17.7-14.3-32-32-32H473L355.7 186.2a8.15 8.15 0 0 0-5.5-2.2H96c-17.7 0-32 14.3-32 32v592c0 17.7 14.3 32 32 32h698c13 0 24.8-7.9 29.7-20l134-332c1.5-3.8 2.3-7.9 2.3-12 0-17.7-14.3-32-32-32zm-180 0H238c-13 0-24.8 7.9-29.7 20L136 643.2V256h188.5l119.6 114.4H748V444z"
                }
            }
        ]
    })(props);
}
function AiFillFolder(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M880 298.4H521L403.7 186.2a8.15 8.15 0 0 0-5.5-2.2H144c-17.7 0-32 14.3-32 32v592c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V330.4c0-17.7-14.3-32-32-32z"
                }
            }
        ]
    })(props);
}
function AiFillFormatPainter(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "t": "1569683558243",
            "viewBox": "0 0 1024 1024",
            "version": "1.1"
        },
        "child": [
            {
                "tag": "defs",
                "attr": {},
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M840 192h-56v-72c0-13.3-10.7-24-24-24H168c-13.3 0-24 10.7-24 24v272c0 13.3 10.7 24 24 24h592c13.3 0 24-10.7 24-24V256h32v200H465c-22.1 0-40 17.9-40 40v136h-44c-4.4 0-8 3.6-8 8v228c0 1.1 0.2 2.2 0.6 3.1-0.4 1.6-0.6 3.2-0.6 4.9 0 46.4 37.6 84 84 84s84-37.6 84-84c0-1.7-0.2-3.3-0.6-4.9 0.4-1 0.6-2 0.6-3.1V640c0-4.4-3.6-8-8-8h-44V520h351c22.1 0 40-17.9 40-40V232c0-22.1-17.9-40-40-40z"
                }
            }
        ]
    })(props);
}
function AiFillForward(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M825.8 498L538.4 249.9c-10.7-9.2-26.4-.9-26.4 14v496.3c0 14.9 15.7 23.2 26.4 14L825.8 526c8.3-7.2 8.3-20.8 0-28zm-320 0L218.4 249.9c-10.7-9.2-26.4-.9-26.4 14v496.3c0 14.9 15.7 23.2 26.4 14L505.8 526c4.1-3.6 6.2-8.8 6.2-14 0-5.2-2.1-10.4-6.2-14z"
                }
            }
        ]
    })(props);
}
function AiFillFrown(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zM288 421a48.01 48.01 0 0 1 96 0 48.01 48.01 0 0 1-96 0zm376 272h-48.1c-4.2 0-7.8-3.2-8.1-7.4C604 636.1 562.5 597 512 597s-92.1 39.1-95.8 88.6c-.3 4.2-3.9 7.4-8.1 7.4H360a8 8 0 0 1-8-8.4c4.4-84.3 74.5-151.6 160-151.6s155.6 67.3 160 151.6a8 8 0 0 1-8 8.4zm24-224a48.01 48.01 0 0 1 0-96 48.01 48.01 0 0 1 0 96z"
                }
            }
        ]
    })(props);
}
function AiFillFund(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M926 164H94c-17.7 0-32 14.3-32 32v640c0 17.7 14.3 32 32 32h832c17.7 0 32-14.3 32-32V196c0-17.7-14.3-32-32-32zm-92.3 194.4l-297 297.2a8.03 8.03 0 0 1-11.3 0L410.9 541.1 238.4 713.7a8.03 8.03 0 0 1-11.3 0l-36.8-36.8a8.03 8.03 0 0 1 0-11.3l214.9-215c3.1-3.1 8.2-3.1 11.3 0L531 565l254.5-254.6c3.1-3.1 8.2-3.1 11.3 0l36.8 36.8c3.2 3 3.2 8.1.1 11.2z"
                }
            }
        ]
    })(props);
}
function AiFillFunnelPlot(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M336.7 586h350.6l84.9-148H251.8zm543.4-432H143.9c-24.5 0-39.8 26.7-27.5 48L215 374h594l98.7-172c12.2-21.3-3.1-48-27.6-48zM349 838c0 17.7 14.2 32 31.8 32h262.4c17.6 0 31.8-14.3 31.8-32V650H349v188z"
                }
            }
        ]
    })(props);
}
function AiFillGift(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M160 894c0 17.7 14.3 32 32 32h286V550H160v344zm386 32h286c17.7 0 32-14.3 32-32V550H546v376zm334-616H732.4c13.6-21.4 21.6-46.8 21.6-74 0-76.1-61.9-138-138-138-41.4 0-78.7 18.4-104 47.4-25.3-29-62.6-47.4-104-47.4-76.1 0-138 61.9-138 138 0 27.2 7.9 52.6 21.6 74H144c-17.7 0-32 14.3-32 32v140h366V310h68v172h366V342c0-17.7-14.3-32-32-32zm-402-4h-70c-38.6 0-70-31.4-70-70s31.4-70 70-70 70 31.4 70 70v70zm138 0h-70v-70c0-38.6 31.4-70 70-70s70 31.4 70 70-31.4 70-70 70z"
                }
            }
        ]
    })(props);
}
function AiFillGithub(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M511.6 76.3C264.3 76.2 64 276.4 64 523.5 64 718.9 189.3 885 363.8 946c23.5 5.9 19.9-10.8 19.9-22.2v-77.5c-135.7 15.9-141.2-73.9-150.3-88.9C215 726 171.5 718 184.5 703c30.9-15.9 62.4 4 98.9 57.9 26.4 39.1 77.9 32.5 104 26 5.7-23.5 17.9-44.5 34.7-60.8-140.6-25.2-199.2-111-199.2-213 0-49.5 16.3-95 48.3-131.7-20.4-60.5 1.9-112.3 4.9-120 58.1-5.2 118.5 41.6 123.2 45.3 33-8.9 70.7-13.6 112.9-13.6 42.4 0 80.2 4.9 113.5 13.9 11.3-8.6 67.3-48.8 121.3-43.9 2.9 7.7 24.7 58.3 5.5 118 32.4 36.8 48.9 82.7 48.9 132.3 0 102.2-59 188.1-200 212.9a127.5 127.5 0 0 1 38.1 91v112.5c.8 9 0 17.9 15 17.9 177.1-59.7 304.6-227 304.6-424.1 0-247.2-200.4-447.3-447.5-447.3z"
                }
            }
        ]
    })(props);
}
function AiFillGitlab(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M910.5 553.2l-109-370.8c-6.8-20.4-23.1-34.1-44.9-34.1s-39.5 12.3-46.3 32.7l-72.2 215.4H386.2L314 181.1c-6.8-20.4-24.5-32.7-46.3-32.7s-39.5 13.6-44.9 34.1L113.9 553.2c-4.1 13.6 1.4 28.6 12.3 36.8l385.4 289 386.7-289c10.8-8.1 16.3-23.1 12.2-36.8z"
                }
            }
        ]
    })(props);
}
function AiFillGold(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M905.9 806.7l-40.2-248c-.6-3.9-4-6.7-7.9-6.7H596.2c-3.9 0-7.3 2.8-7.9 6.7l-40.2 248c-.1.4-.1.9-.1 1.3 0 4.4 3.6 8 8 8h342c.4 0 .9 0 1.3-.1 4.3-.7 7.3-4.8 6.6-9.2zm-470.2-248c-.6-3.9-4-6.7-7.9-6.7H166.2c-3.9 0-7.3 2.8-7.9 6.7l-40.2 248c-.1.4-.1.9-.1 1.3 0 4.4 3.6 8 8 8h342c.4 0 .9 0 1.3-.1 4.4-.7 7.3-4.8 6.6-9.2l-40.2-248zM342 472h342c.4 0 .9 0 1.3-.1 4.4-.7 7.3-4.8 6.6-9.2l-40.2-248c-.6-3.9-4-6.7-7.9-6.7H382.2c-3.9 0-7.3 2.8-7.9 6.7l-40.2 248c-.1.4-.1.9-.1 1.3 0 4.4 3.6 8 8 8z"
                }
            }
        ]
    })(props);
}
function AiFillGolden(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M905.9 806.7l-40.2-248c-.6-3.9-4-6.7-7.9-6.7H596.2c-3.9 0-7.3 2.8-7.9 6.7l-40.2 248c-.1.4-.1.9-.1 1.3 0 4.4 3.6 8 8 8h342c.4 0 .9 0 1.3-.1 4.3-.7 7.3-4.8 6.6-9.2zm-470.2-248c-.6-3.9-4-6.7-7.9-6.7H166.2c-3.9 0-7.3 2.8-7.9 6.7l-40.2 248c-.1.4-.1.9-.1 1.3 0 4.4 3.6 8 8 8h342c.4 0 .9 0 1.3-.1 4.4-.7 7.3-4.8 6.6-9.2l-40.2-248zM342 472h342c.4 0 .9 0 1.3-.1 4.4-.7 7.3-4.8 6.6-9.2l-40.2-248c-.6-3.9-4-6.7-7.9-6.7H382.2c-3.9 0-7.3 2.8-7.9 6.7l-40.2 248c-.1.4-.1.9-.1 1.3 0 4.4 3.6 8 8 8z"
                }
            }
        ]
    })(props);
}
function AiFillGoogleCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm167 633.6C638.4 735 583 757 516.9 757c-95.7 0-178.5-54.9-218.8-134.9C281.5 589 272 551.6 272 512s9.5-77 26.1-110.1c40.3-80.1 123.1-135 218.8-135 66 0 121.4 24.3 163.9 63.8L610.6 401c-25.4-24.3-57.7-36.6-93.6-36.6-63.8 0-117.8 43.1-137.1 101-4.9 14.7-7.7 30.4-7.7 46.6s2.8 31.9 7.7 46.6c19.3 57.9 73.3 101 137 101 33 0 61-8.7 82.9-23.4 26-17.4 43.2-43.3 48.9-74H516.9v-94.8h230.7c2.9 16.1 4.4 32.8 4.4 50.1 0 74.7-26.7 137.4-73 180.1z"
                }
            }
        ]
    })(props);
}
function AiFillGooglePlusCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm36.5 558.8c-43.9 61.8-132.1 79.8-200.9 53.3-69-26.3-118-99.2-112.1-173.5 1.5-90.9 85.2-170.6 176.1-167.5 43.6-2 84.6 16.9 118 43.6-14.3 16.2-29 31.8-44.8 46.3-40.1-27.7-97.2-35.6-137.3-3.6-57.4 39.7-60 133.4-4.8 176.1 53.7 48.7 155.2 24.5 170.1-50.1-33.6-.5-67.4 0-101-1.1-.1-20.1-.2-40.1-.1-60.2 56.2-.2 112.5-.3 168.8.2 3.3 47.3-3 97.5-32 136.5zM791 536.5c-16.8.2-33.6.3-50.4.4-.2 16.8-.3 33.6-.3 50.4H690c-.2-16.8-.2-33.5-.3-50.3-16.8-.2-33.6-.3-50.4-.5v-50.1c16.8-.2 33.6-.3 50.4-.3.1-16.8.3-33.6.4-50.4h50.2l.3 50.4c16.8.2 33.6.2 50.4.3v50.1z"
                }
            }
        ]
    })(props);
}
function AiFillGooglePlusSquare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM548.5 622.8c-43.9 61.8-132.1 79.8-200.9 53.3-69-26.3-118-99.2-112.1-173.5 1.5-90.9 85.2-170.6 176.1-167.5 43.6-2 84.6 16.9 118 43.6-14.3 16.2-29 31.8-44.8 46.3-40.1-27.7-97.2-35.6-137.3-3.6-57.4 39.7-60 133.4-4.8 176.1 53.7 48.7 155.2 24.5 170.1-50.1-33.6-.5-67.4 0-101-1.1-.1-20.1-.2-40.1-.1-60.2 56.2-.2 112.5-.3 168.8.2 3.3 47.3-3 97.5-32 136.5zM791 536.5c-16.8.2-33.6.3-50.4.4-.2 16.8-.3 33.6-.3 50.4H690c-.2-16.8-.2-33.5-.3-50.3-16.8-.2-33.6-.3-50.4-.5v-50.1c16.8-.2 33.6-.3 50.4-.3.1-16.8.3-33.6.4-50.4h50.2l.3 50.4c16.8.2 33.6.2 50.4.3v50.1z"
                }
            }
        ]
    })(props);
}
function AiFillGoogleSquare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM679 697.6C638.4 735 583 757 516.9 757c-95.7 0-178.5-54.9-218.8-134.9A245.02 245.02 0 0 1 272 512c0-39.6 9.5-77 26.1-110.1 40.3-80.1 123.1-135 218.8-135 66 0 121.4 24.3 163.9 63.8L610.6 401c-25.4-24.3-57.7-36.6-93.6-36.6-63.8 0-117.8 43.1-137.1 101-4.9 14.7-7.7 30.4-7.7 46.6s2.8 31.9 7.7 46.6c19.3 57.9 73.3 101 137 101 33 0 61-8.7 82.9-23.4 26-17.4 43.2-43.3 48.9-74H516.9v-94.8h230.7c2.9 16.1 4.4 32.8 4.4 50.1 0 74.7-26.7 137.4-73 180.1z"
                }
            }
        ]
    })(props);
}
function AiFillHdd(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M832 64H192c-17.7 0-32 14.3-32 32v224h704V96c0-17.7-14.3-32-32-32zM456 216c0 4.4-3.6 8-8 8H264c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h184c4.4 0 8 3.6 8 8v48zM160 928c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V704H160v224zm576-136c22.1 0 40 17.9 40 40s-17.9 40-40 40-40-17.9-40-40 17.9-40 40-40zM160 640h704V384H160v256zm96-152c0-4.4 3.6-8 8-8h184c4.4 0 8 3.6 8 8v48c0 4.4-3.6 8-8 8H264c-4.4 0-8-3.6-8-8v-48z"
                }
            }
        ]
    })(props);
}
function AiFillHeart(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M923 283.6a260.04 260.04 0 0 0-56.9-82.8 264.4 264.4 0 0 0-84-55.5A265.34 265.34 0 0 0 679.7 125c-49.3 0-97.4 13.5-139.2 39-10 6.1-19.5 12.8-28.5 20.1-9-7.3-18.5-14-28.5-20.1-41.8-25.5-89.9-39-139.2-39-35.5 0-69.9 6.8-102.4 20.3-31.4 13-59.7 31.7-84 55.5a258.44 258.44 0 0 0-56.9 82.8c-13.9 32.3-21 66.6-21 101.9 0 33.3 6.8 68 20.3 103.3 11.3 29.5 27.5 60.1 48.2 91 32.8 48.9 77.9 99.9 133.9 151.6 92.8 85.7 184.7 144.9 188.6 147.3l23.7 15.2c10.5 6.7 24 6.7 34.5 0l23.7-15.2c3.9-2.5 95.7-61.6 188.6-147.3 56-51.7 101.1-102.7 133.9-151.6 20.7-30.9 37-61.5 48.2-91 13.5-35.3 20.3-70 20.3-103.3.1-35.3-7-69.6-20.9-101.9z"
                }
            }
        ]
    })(props);
}
function AiFillHighlight(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M957.6 507.4L603.2 158.2a7.9 7.9 0 0 0-11.2 0L353.3 393.4a8.03 8.03 0 0 0-.1 11.3l.1.1 40 39.4-117.2 115.3a8.03 8.03 0 0 0-.1 11.3l.1.1 39.5 38.9-189.1 187H72.1c-4.4 0-8.1 3.6-8.1 8V860c0 4.4 3.6 8 8 8h344.9c2.1 0 4.1-.8 5.6-2.3l76.1-75.6 40.4 39.8a7.9 7.9 0 0 0 11.2 0l117.1-115.6 40.1 39.5a7.9 7.9 0 0 0 11.2 0l238.7-235.2c3.4-3 3.4-8 .3-11.2z"
                }
            }
        ]
    })(props);
}
function AiFillHome(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M946.5 505L534.6 93.4a31.93 31.93 0 0 0-45.2 0L77.5 505c-12 12-18.8 28.3-18.8 45.3 0 35.3 28.7 64 64 64h43.4V908c0 17.7 14.3 32 32 32H448V716h112v224h265.9c17.7 0 32-14.3 32-32V614.3h43.4c17 0 33.3-6.7 45.3-18.8 24.9-25 24.9-65.5-.1-90.5z"
                }
            }
        ]
    })(props);
}
function AiFillHourglass(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M742 318V184h86c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H196c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h86v134c0 81.5 42.4 153.2 106.4 194-64 40.8-106.4 112.5-106.4 194v134h-86c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h632c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-86V706c0-81.5-42.4-153.2-106.4-194 64-40.8 106.4-112.5 106.4-194z"
                }
            }
        ]
    })(props);
}
function AiFillHtml5(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M145.2 96l66 746.6L512 928l299.6-85.4L878.9 96H145.2zm595 177.1l-4.8 47.2-1.7 19.5H382.3l8.2 94.2h335.1l-3.3 24.3-21.2 242.2-1.7 16.2-187 51.6v.3h-1.2l-.3.1v-.1h-.1l-188.6-52L310.8 572h91.1l6.5 73.2 102.4 27.7h.4l102-27.6 11.4-118.6H510.9v-.1H306l-22.8-253.5-1.7-24.3h460.3l-1.6 24.3z"
                }
            }
        ]
    })(props);
}
function AiFillIdcard(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M373 411c-28.5 0-51.7 23.3-51.7 52s23.2 52 51.7 52 51.7-23.3 51.7-52-23.2-52-51.7-52zm555-251H96c-17.7 0-32 14.3-32 32v640c0 17.7 14.3 32 32 32h832c17.7 0 32-14.3 32-32V192c0-17.7-14.3-32-32-32zM608 420c0-4.4 1-8 2.3-8h123.4c1.3 0 2.3 3.6 2.3 8v48c0 4.4-1 8-2.3 8H610.3c-1.3 0-2.3-3.6-2.3-8v-48zm-86 253h-43.9c-4.2 0-7.6-3.3-7.9-7.5-3.8-50.5-46-90.5-97.2-90.5s-93.4 40-97.2 90.5c-.3 4.2-3.7 7.5-7.9 7.5H224a8 8 0 0 1-8-8.4c2.8-53.3 32-99.7 74.6-126.1a111.8 111.8 0 0 1-29.1-75.5c0-61.9 49.9-112 111.4-112s111.4 50.1 111.4 112c0 29.1-11 55.5-29.1 75.5 42.7 26.5 71.8 72.8 74.6 126.1.4 4.6-3.2 8.4-7.8 8.4zm278.9-53H615.1c-3.9 0-7.1-3.6-7.1-8v-48c0-4.4 3.2-8 7.1-8h185.7c3.9 0 7.1 3.6 7.1 8v48h.1c0 4.4-3.2 8-7.1 8z"
                }
            }
        ]
    })(props);
}
function AiFillIeCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M693.6 284.4c-24 0-51.1 11.7-72.6 22 46.3 18 86 57.3 112.3 99.6 7.1-18.9 14.6-47.9 14.6-67.9 0-32-22.8-53.7-54.3-53.7zM512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm253.9 492.9H437.1c0 100.4 144.3 136 196.8 47.4h120.8c-32.6 91.7-119.7 146-216.8 146-35.1 0-70.3-.1-101.7-15.6-87.4 44.5-180.3 56.6-180.3-42 0-45.8 23.2-107.1 44-145C335 484 381.3 422.8 435.6 374.5c-43.7 18.9-91.1 66.3-122 101.2 25.9-112.8 129.5-193.6 237.1-186.5 130-59.8 209.7-34.1 209.7 38.6 0 27.4-10.6 63.3-21.4 87.9 25.2 45.5 33.3 97.6 26.9 141.2zM540.5 399.1c-53.7 0-102 39.7-104 94.9h208c-2-55.1-50.6-94.9-104-94.9zM320.6 602.9c-73 152.4 11.5 172.2 100.3 123.3-46.6-27.5-82.6-72.2-100.3-123.3z"
                }
            }
        ]
    })(props);
}
function AiFillIeSquare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM765.9 556.9H437.1c0 100.4 144.3 136 196.8 47.4h120.8c-32.6 91.7-119.7 146-216.8 146-35.1 0-70.3-.1-101.7-15.6-87.4 44.5-180.3 56.6-180.3-42 0-45.8 23.2-107.1 44-145C335 484 381.3 422.8 435.6 374.5c-43.7 18.9-91.1 66.3-122 101.2 25.9-112.8 129.5-193.6 237.1-186.5 130-59.8 209.7-34.1 209.7 38.6 0 27.4-10.6 63.3-21.4 87.9 25.2 45.5 33.3 97.6 26.9 141.2zm-72.3-272.5c-24 0-51.1 11.7-72.6 22 46.3 18 86 57.3 112.3 99.6 7.1-18.9 14.6-47.9 14.6-67.9 0-32-22.8-53.7-54.3-53.7zM540.5 399.1c-53.7 0-102 39.7-104 94.9h208c-2-55.1-50.6-94.9-104-94.9zM320.6 602.9c-73 152.4 11.5 172.2 100.3 123.3-46.6-27.5-82.6-72.2-100.3-123.3z"
                }
            }
        ]
    })(props);
}
function AiFillInfoCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm32 664c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V456c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v272zm-32-344a48.01 48.01 0 0 1 0-96 48.01 48.01 0 0 1 0 96z"
                }
            }
        ]
    })(props);
}
function AiFillInstagram(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M512 378.7c-73.4 0-133.3 59.9-133.3 133.3S438.6 645.3 512 645.3 645.3 585.4 645.3 512 585.4 378.7 512 378.7zM911.8 512c0-55.2.5-109.9-2.6-165-3.1-64-17.7-120.8-64.5-167.6-46.9-46.9-103.6-61.4-167.6-64.5-55.2-3.1-109.9-2.6-165-2.6-55.2 0-109.9-.5-165 2.6-64 3.1-120.8 17.7-167.6 64.5C132.6 226.3 118.1 283 115 347c-3.1 55.2-2.6 109.9-2.6 165s-.5 109.9 2.6 165c3.1 64 17.7 120.8 64.5 167.6 46.9 46.9 103.6 61.4 167.6 64.5 55.2 3.1 109.9 2.6 165 2.6 55.2 0 109.9.5 165-2.6 64-3.1 120.8-17.7 167.6-64.5 46.9-46.9 61.4-103.6 64.5-167.6 3.2-55.1 2.6-109.8 2.6-165zM512 717.1c-113.5 0-205.1-91.6-205.1-205.1S398.5 306.9 512 306.9 717.1 398.5 717.1 512 625.5 717.1 512 717.1zm213.5-370.7c-26.5 0-47.9-21.4-47.9-47.9s21.4-47.9 47.9-47.9 47.9 21.4 47.9 47.9a47.84 47.84 0 0 1-47.9 47.9z"
                }
            }
        ]
    })(props);
}
function AiFillInsurance(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M519.9 358.8h97.9v41.6h-97.9zm347-188.9L527.1 54.1C523 52.7 517.5 52 512 52s-11 .7-15.1 2.1L157.1 169.9c-8.3 2.8-15.1 12.4-15.1 21.2v482.4c0 8.8 5.7 20.4 12.6 25.9L499.3 968c3.5 2.7 8 4.1 12.6 4.1s9.2-1.4 12.6-4.1l344.7-268.6c6.9-5.4 12.6-17 12.6-25.9V191.1c.2-8.8-6.6-18.3-14.9-21.2zM411.3 656h-.2c0 4.4-3.6 8-8 8h-37.3c-4.4 0-8-3.6-8-8V471.4c-7.7 9.2-15.4 17.9-23.1 26a6.04 6.04 0 0 1-10.2-2.4l-13.2-43.5c-.6-2-.2-4.1 1.2-5.6 37-43.4 64.7-95.1 82.2-153.6 1.1-3.5 5-5.3 8.4-3.7l38.6 18.3c2.7 1.3 4.1 4.4 3.2 7.2a429.2 429.2 0 0 1-33.6 79V656zm296.5-49.2l-26.3 35.3a5.92 5.92 0 0 1-8.9.7c-30.6-29.3-56.8-65.2-78.1-106.9V656c0 4.4-3.6 8-8 8h-36.2c-4.4 0-8-3.6-8-8V536c-22 44.7-49 80.8-80.6 107.6a5.9 5.9 0 0 1-8.9-1.4L430 605.7a6 6 0 0 1 1.6-8.1c28.6-20.3 51.9-45.2 71-76h-55.1c-4.4 0-8-3.6-8-8V478c0-4.4 3.6-8 8-8h94.9v-18.6h-65.9c-4.4 0-8-3.6-8-8V316c0-4.4 3.6-8 8-8h184.7c4.4 0 8 3.6 8 8v127.2c0 4.4-3.6 8-8 8h-66.7v18.6h98.8c4.4 0 8 3.6 8 8v35.6c0 4.4-3.6 8-8 8h-59c18.1 29.1 41.8 54.3 72.3 76.9 2.6 2.1 3.2 5.9 1.2 8.5z"
                }
            }
        ]
    })(props);
}
function AiFillInteraction(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM726 585.7c0 55.3-44.7 100.1-99.7 100.1H420.6v53.4c0 5.7-6.5 8.8-10.9 5.3l-109.1-85.7c-3.5-2.7-3.5-8 0-10.7l109.1-85.7c4.4-3.5 10.9-.3 10.9 5.3v53.4h205.7c19.6 0 35.5-16 35.5-35.6v-78.9c0-3.7 3-6.8 6.8-6.8h50.7c3.7 0 6.8 3 6.8 6.8v79.1zm-2.6-209.9l-109.1 85.7c-4.4 3.5-10.9.3-10.9-5.3v-53.4H397.7c-19.6 0-35.5 16-35.5 35.6v78.9c0 3.7-3 6.8-6.8 6.8h-50.7c-3.7 0-6.8-3-6.8-6.8v-78.9c0-55.3 44.7-100.1 99.7-100.1h205.7v-53.4c0-5.7 6.5-8.8 10.9-5.3l109.1 85.7c3.6 2.5 3.6 7.8.1 10.5z"
                }
            }
        ]
    })(props);
}
function AiFillLayout(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M384 912h496c17.7 0 32-14.3 32-32V340H384v572zm496-800H384v164h528V144c0-17.7-14.3-32-32-32zm-768 32v736c0 17.7 14.3 32 32 32h176V112H144c-17.7 0-32 14.3-32 32z"
                }
            }
        ]
    })(props);
}
function AiFillLeftCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm104 316.9c0 10.2-4.9 19.9-13.2 25.9L457.4 512l145.4 105.2c8.3 6 13.2 15.6 13.2 25.9V690c0 6.5-7.4 10.3-12.7 6.5l-246-178a7.95 7.95 0 0 1 0-12.9l246-178a8 8 0 0 1 12.7 6.5v46.8z"
                }
            }
        ]
    })(props);
}
function AiFillLeftSquare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM624 380.9c0 10.2-4.9 19.9-13.2 25.9L465.4 512l145.4 105.2c8.3 6 13.2 15.6 13.2 25.9V690c0 6.5-7.4 10.3-12.7 6.5l-246-178a7.95 7.95 0 0 1 0-12.9l246-178c5.3-3.8 12.7 0 12.7 6.5v46.8z"
                }
            }
        ]
    })(props);
}
function AiFillLike(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M885.9 533.7c16.8-22.2 26.1-49.4 26.1-77.7 0-44.9-25.1-87.4-65.5-111.1a67.67 67.67 0 0 0-34.3-9.3H572.4l6-122.9c1.4-29.7-9.1-57.9-29.5-79.4A106.62 106.62 0 0 0 471 99.9c-52 0-98 35-111.8 85.1l-85.9 311h-.3v428h472.3c9.2 0 18.2-1.8 26.5-5.4 47.6-20.3 78.3-66.8 78.3-118.4 0-12.6-1.8-25-5.4-37 16.8-22.2 26.1-49.4 26.1-77.7 0-12.6-1.8-25-5.4-37 16.8-22.2 26.1-49.4 26.1-77.7-.2-12.6-2-25.1-5.6-37.1zM112 528v364c0 17.7 14.3 32 32 32h65V496h-65c-17.7 0-32 14.3-32 32z"
                }
            }
        ]
    })(props);
}
function AiFillLinkedin(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM349.3 793.7H230.6V411.9h118.7v381.8zm-59.3-434a68.8 68.8 0 1 1 68.8-68.8c-.1 38-30.9 68.8-68.8 68.8zm503.7 434H675.1V608c0-44.3-.8-101.2-61.7-101.2-61.7 0-71.2 48.2-71.2 98v188.9H423.7V411.9h113.8v52.2h1.6c15.8-30 54.5-61.7 112.3-61.7 120.2 0 142.3 79.1 142.3 181.9v209.4z"
                }
            }
        ]
    })(props);
}
function AiFillLock(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M832 464h-68V240c0-70.7-57.3-128-128-128H388c-70.7 0-128 57.3-128 128v224h-68c-17.7 0-32 14.3-32 32v384c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V496c0-17.7-14.3-32-32-32zM540 701v53c0 4.4-3.6 8-8 8h-40c-4.4 0-8-3.6-8-8v-53a48.01 48.01 0 1 1 56 0zm152-237H332V240c0-30.9 25.1-56 56-56h248c30.9 0 56 25.1 56 56v224z"
                }
            }
        ]
    })(props);
}
function AiFillMacCommand(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "t": "1569747879816",
            "viewBox": "0 0 1024 1024",
            "version": "1.1"
        },
        "child": [
            {
                "tag": "defs",
                "attr": {},
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M624 672c0 26.5 21.5 48 48 48s48-21.5 48-48-21.5-48-48-48h-48v48zM720 352c0-26.5-21.5-48-48-48s-48 21.5-48 48v48h48c26.5 0 48-21.5 48-48z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M928 64H96c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h832c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32zM672 560c61.9 0 112 50.1 112 112s-50.1 112-112 112-112-50.1-112-112v-48h-96v48c0 61.9-50.1 112-112 112s-112-50.1-112-112 50.1-112 112-112h48v-96h-48c-61.9 0-112-50.1-112-112s50.1-112 112-112 112 50.1 112 112v48h96v-48c0-61.9 50.1-112 112-112s112 50.1 112 112-50.1 112-112 112h-48v96h48z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M464 464h96v96h-96zM352 304c-26.5 0-48 21.5-48 48s21.5 48 48 48h48v-48c0-26.5-21.5-48-48-48zM304 672c0 26.5 21.5 48 48 48s48-21.5 48-48v-48h-48c-26.5 0-48 21.5-48 48z"
                }
            }
        ]
    })(props);
}
function AiFillMail(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M928 160H96c-17.7 0-32 14.3-32 32v640c0 17.7 14.3 32 32 32h832c17.7 0 32-14.3 32-32V192c0-17.7-14.3-32-32-32zm-80.8 108.9L531.7 514.4c-7.8 6.1-18.7 6.1-26.5 0L189.6 268.9A7.2 7.2 0 0 1 194 256h648.8a7.2 7.2 0 0 1 4.4 12.9z"
                }
            }
        ]
    })(props);
}
function AiFillMedicineBox(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M839.2 278.1a32 32 0 0 0-30.4-22.1H736V144c0-17.7-14.3-32-32-32H320c-17.7 0-32 14.3-32 32v112h-72.8a31.9 31.9 0 0 0-30.4 22.1L112 502v378c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V502l-72.8-223.9zM660 628c0 4.4-3.6 8-8 8H544v108c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V636H372c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h108V464c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v108h108c4.4 0 8 3.6 8 8v48zm4-372H360v-72h304v72z"
                }
            }
        ]
    })(props);
}
function AiFillMediumCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm256 253.7l-40.8 39.1c-3.6 2.7-5.3 7.1-4.6 11.4v287.7c-.7 4.4 1 8.8 4.6 11.4l40 39.1v8.7H566.4v-8.3l41.3-40.1c4.1-4.1 4.1-5.3 4.1-11.4V422.5l-115 291.6h-15.5L347.5 422.5V618c-1.2 8.2 1.7 16.5 7.5 22.4l53.8 65.1v8.7H256v-8.7l53.8-65.1a26.1 26.1 0 0 0 7-22.4V392c.7-6.3-1.7-12.4-6.5-16.7l-47.8-57.6V309H411l114.6 251.5 100.9-251.3H768v8.5z"
                }
            }
        ]
    })(props);
}
function AiFillMediumSquare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM768 317.7l-40.8 39.1c-3.6 2.7-5.3 7.1-4.6 11.4v287.7c-.7 4.4 1 8.8 4.6 11.4l40 39.1v8.7H566.4v-8.3l41.3-40.1c4.1-4.1 4.1-5.3 4.1-11.4V422.5l-115 291.6h-15.5L347.5 422.5V618c-1.2 8.2 1.7 16.5 7.5 22.4l53.8 65.1v8.7H256v-8.7l53.8-65.1a26.1 26.1 0 0 0 7-22.4V392c.7-6.3-1.7-12.4-6.5-16.7l-47.8-57.6V309H411l114.6 251.5 100.9-251.3H768v8.5z"
                }
            }
        ]
    })(props);
}
function AiFillMeh(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zM288 421a48.01 48.01 0 0 1 96 0 48.01 48.01 0 0 1-96 0zm384 200c0 4.4-3.6 8-8 8H360c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h304c4.4 0 8 3.6 8 8v48zm16-152a48.01 48.01 0 0 1 0-96 48.01 48.01 0 0 1 0 96z"
                }
            }
        ]
    })(props);
}
function AiFillMessage(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M924.3 338.4a447.57 447.57 0 0 0-96.1-143.3 443.09 443.09 0 0 0-143-96.3A443.91 443.91 0 0 0 512 64h-2c-60.5.3-119 12.3-174.1 35.9a444.08 444.08 0 0 0-141.7 96.5 445 445 0 0 0-95 142.8A449.89 449.89 0 0 0 65 514.1c.3 69.4 16.9 138.3 47.9 199.9v152c0 25.4 20.6 46 45.9 46h151.8a447.72 447.72 0 0 0 199.5 48h2.1c59.8 0 117.7-11.6 172.3-34.3A443.2 443.2 0 0 0 827 830.5c41.2-40.9 73.6-88.7 96.3-142 23.5-55.2 35.5-113.9 35.8-174.5.2-60.9-11.6-120-34.8-175.6zM312.4 560c-26.4 0-47.9-21.5-47.9-48s21.5-48 47.9-48 47.9 21.5 47.9 48-21.4 48-47.9 48zm199.6 0c-26.4 0-47.9-21.5-47.9-48s21.5-48 47.9-48 47.9 21.5 47.9 48-21.5 48-47.9 48zm199.6 0c-26.4 0-47.9-21.5-47.9-48s21.5-48 47.9-48 47.9 21.5 47.9 48-21.5 48-47.9 48z"
                }
            }
        ]
    })(props);
}
function AiFillMinusCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm192 472c0 4.4-3.6 8-8 8H328c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h368c4.4 0 8 3.6 8 8v48z"
                }
            }
        ]
    })(props);
}
function AiFillMinusSquare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM704 536c0 4.4-3.6 8-8 8H328c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h368c4.4 0 8 3.6 8 8v48z"
                }
            }
        ]
    })(props);
}
function AiFillMobile(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M744 62H280c-35.3 0-64 28.7-64 64v768c0 35.3 28.7 64 64 64h464c35.3 0 64-28.7 64-64V126c0-35.3-28.7-64-64-64zM512 824c-22.1 0-40-17.9-40-40s17.9-40 40-40 40 17.9 40 40-17.9 40-40 40z"
                }
            }
        ]
    })(props);
}
function AiFillMoneyCollect(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M911.5 699.7a8 8 0 0 0-10.3-4.8L840 717.2V179c0-37.6-30.4-68-68-68H252c-37.6 0-68 30.4-68 68v538.2l-61.3-22.3c-.9-.3-1.8-.5-2.7-.5-4.4 0-8 3.6-8 8V762c0 3.3 2.1 6.3 5.3 7.5L501 909.1c7.1 2.6 14.8 2.6 21.9 0l383.8-139.5c3.2-1.2 5.3-4.2 5.3-7.5v-59.6c0-1-.2-1.9-.5-2.8zm-243.8-377L564 514.3h57.6c4.4 0 8 3.6 8 8v27.1c0 4.4-3.6 8-8 8h-76.3v39h76.3c4.4 0 8 3.6 8 8v27.1c0 4.4-3.6 8-8 8h-76.3V703c0 4.4-3.6 8-8 8h-49.9c-4.4 0-8-3.6-8-8v-63.4h-76c-4.4 0-8-3.6-8-8v-27.1c0-4.4 3.6-8 8-8h76v-39h-76c-4.4 0-8-3.6-8-8v-27.1c0-4.4 3.6-8 8-8h57L356.5 322.8c-2.1-3.8-.7-8.7 3.2-10.8 1.2-.7 2.5-1 3.8-1h55.7a8 8 0 0 1 7.1 4.4L511 484.2h3.3L599 315.4c1.3-2.7 4.1-4.4 7.1-4.4h54.5c4.4 0 8 3.6 8.1 7.9 0 1.3-.4 2.6-1 3.8z"
                }
            }
        ]
    })(props);
}
function AiFillNotification(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M880 112c-3.8 0-7.7.7-11.6 2.3L292 345.9H128c-8.8 0-16 7.4-16 16.6v299c0 9.2 7.2 16.6 16 16.6h101.6c-3.7 11.6-5.6 23.9-5.6 36.4 0 65.9 53.8 119.5 120 119.5 55.4 0 102.1-37.6 115.9-88.4l408.6 164.2c3.9 1.5 7.8 2.3 11.6 2.3 16.9 0 32-14.2 32-33.2V145.2C912 126.2 897 112 880 112zM344 762.3c-26.5 0-48-21.4-48-47.8 0-11.2 3.9-21.9 11-30.4l84.9 34.1c-2 24.6-22.7 44.1-47.9 44.1z"
                }
            }
        ]
    })(props);
}
function AiFillPauseCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm-80 600c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V360c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v304zm224 0c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V360c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v304z"
                }
            }
        ]
    })(props);
}
function AiFillPayCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm166.6 246.8L567.5 515.6h62c4.4 0 8 3.6 8 8v29.9c0 4.4-3.6 8-8 8h-82V603h82c4.4 0 8 3.6 8 8v29.9c0 4.4-3.6 8-8 8h-82V717c0 4.4-3.6 8-8 8h-54.3c-4.4 0-8-3.6-8-8v-68.1h-81.7c-4.4 0-8-3.6-8-8V611c0-4.4 3.6-8 8-8h81.7v-41.5h-81.7c-4.4 0-8-3.6-8-8v-29.9c0-4.4 3.6-8 8-8h61.4L345.4 310.8a8.07 8.07 0 0 1 7-11.9h60.7c3 0 5.8 1.7 7.1 4.4l90.6 180h3.4l90.6-180a8 8 0 0 1 7.1-4.4h59.5c4.4 0 8 3.6 8 8 .2 1.4-.2 2.7-.8 3.9z"
                }
            }
        ]
    })(props);
}
function AiFillPhone(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M885.6 230.2L779.1 123.8a80.83 80.83 0 0 0-57.3-23.8c-21.7 0-42.1 8.5-57.4 23.8L549.8 238.4a80.83 80.83 0 0 0-23.8 57.3c0 21.7 8.5 42.1 23.8 57.4l83.8 83.8A393.82 393.82 0 0 1 553.1 553 395.34 395.34 0 0 1 437 633.8L353.2 550a80.83 80.83 0 0 0-57.3-23.8c-21.7 0-42.1 8.5-57.4 23.8L123.8 664.5a80.89 80.89 0 0 0-23.8 57.4c0 21.7 8.5 42.1 23.8 57.4l106.3 106.3c24.4 24.5 58.1 38.4 92.7 38.4 7.3 0 14.3-.6 21.2-1.8 134.8-22.2 268.5-93.9 376.4-201.7C828.2 612.8 899.8 479.2 922.3 344c6.8-41.3-6.9-83.8-36.7-113.8z"
                }
            }
        ]
    })(props);
}
function AiFillPicture(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M928 160H96c-17.7 0-32 14.3-32 32v640c0 17.7 14.3 32 32 32h832c17.7 0 32-14.3 32-32V192c0-17.7-14.3-32-32-32zM338 304c35.3 0 64 28.7 64 64s-28.7 64-64 64-64-28.7-64-64 28.7-64 64-64zm513.9 437.1a8.11 8.11 0 0 1-5.2 1.9H177.2c-4.4 0-8-3.6-8-8 0-1.9.7-3.7 1.9-5.2l170.3-202c2.8-3.4 7.9-3.8 11.3-1 .3.3.7.6 1 1l99.4 118 158.1-187.5c2.8-3.4 7.9-3.8 11.3-1 .3.3.7.6 1 1l229.6 271.6c2.6 3.3 2.2 8.4-1.2 11.2z"
                }
            }
        ]
    })(props);
}
function AiFillPieChart(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M863.1 518.5H505.5V160.9c0-4.4-3.6-8-8-8h-26a398.57 398.57 0 0 0-282.5 117 397.47 397.47 0 0 0-85.6 127C82.6 446.2 72 498.5 72 552.5S82.6 658.7 103.4 708c20.1 47.5 48.9 90.3 85.6 127 36.7 36.7 79.4 65.5 127 85.6a396.64 396.64 0 0 0 155.6 31.5 398.57 398.57 0 0 0 282.5-117c36.7-36.7 65.5-79.4 85.6-127a396.64 396.64 0 0 0 31.5-155.6v-26c-.1-4.4-3.7-8-8.1-8zM951 463l-2.6-28.2c-8.5-92-49.3-178.8-115.1-244.3A398.5 398.5 0 0 0 588.4 75.6L560.1 73c-4.7-.4-8.7 3.2-8.7 7.9v383.7c0 4.4 3.6 8 8 8l383.6-1c4.7-.1 8.4-4 8-8.6z"
                }
            }
        ]
    })(props);
}
function AiFillPlayCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm144.1 454.9L437.7 677.8a8.02 8.02 0 0 1-12.7-6.5V353.7a8 8 0 0 1 12.7-6.5L656.1 506a7.9 7.9 0 0 1 0 12.9z"
                }
            }
        ]
    })(props);
}
function AiFillPlaySquare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM641.7 520.8L442.3 677.6c-7.4 5.8-18.3.6-18.3-8.8V355.3c0-9.4 10.9-14.7 18.3-8.8l199.4 156.7a11.2 11.2 0 0 1 0 17.6z"
                }
            }
        ]
    })(props);
}
function AiFillPlusCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm192 472c0 4.4-3.6 8-8 8H544v152c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V544H328c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h152V328c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v152h152c4.4 0 8 3.6 8 8v48z"
                }
            }
        ]
    })(props);
}
function AiFillPlusSquare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM704 536c0 4.4-3.6 8-8 8H544v152c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V544H328c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h152V328c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v152h152c4.4 0 8 3.6 8 8v48z"
                }
            }
        ]
    })(props);
}
function AiFillPoundCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm146 658c0 4.4-3.6 8-8 8H376.2c-4.4 0-8-3.6-8-8v-38.5c0-3.7 2.5-6.9 6.1-7.8 44-10.9 72.8-49 72.8-94.2 0-14.7-2.5-29.4-5.9-44.2H374c-4.4 0-8-3.6-8-8v-30c0-4.4 3.6-8 8-8h53.7c-7.8-25.1-14.6-50.7-14.6-77.1 0-75.8 58.6-120.3 151.5-120.3 26.5 0 51.4 5.5 70.3 12.7 3.1 1.2 5.2 4.2 5.2 7.5v39.5a8 8 0 0 1-10.6 7.6c-17.9-6.4-39-10.5-60.4-10.5-53.3 0-87.3 26.6-87.3 70.2 0 24.7 6.2 47.9 13.4 70.5h112c4.4 0 8 3.6 8 8v30c0 4.4-3.6 8-8 8h-98.6c3.1 13.2 5.3 26.9 5.3 41 0 40.7-16.5 73.9-43.9 91.1v4.7h180c4.4 0 8 3.6 8 8V722z"
                }
            }
        ]
    })(props);
}
function AiFillPrinter(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M732 120c0-4.4-3.6-8-8-8H300c-4.4 0-8 3.6-8 8v148h440V120zm120 212H172c-44.2 0-80 35.8-80 80v328c0 17.7 14.3 32 32 32h168v132c0 4.4 3.6 8 8 8h424c4.4 0 8-3.6 8-8V772h168c17.7 0 32-14.3 32-32V412c0-44.2-35.8-80-80-80zM664 844H360V568h304v276zm164-360c0 4.4-3.6 8-8 8h-40c-4.4 0-8-3.6-8-8v-40c0-4.4 3.6-8 8-8h40c4.4 0 8 3.6 8 8v40z"
                }
            }
        ]
    })(props);
}
function AiFillProfile(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM380 696c-22.1 0-40-17.9-40-40s17.9-40 40-40 40 17.9 40 40-17.9 40-40 40zm0-144c-22.1 0-40-17.9-40-40s17.9-40 40-40 40 17.9 40 40-17.9 40-40 40zm0-144c-22.1 0-40-17.9-40-40s17.9-40 40-40 40 17.9 40 40-17.9 40-40 40zm304 272c0 4.4-3.6 8-8 8H492c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h184c4.4 0 8 3.6 8 8v48zm0-144c0 4.4-3.6 8-8 8H492c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h184c4.4 0 8 3.6 8 8v48zm0-144c0 4.4-3.6 8-8 8H492c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h184c4.4 0 8 3.6 8 8v48z"
                }
            }
        ]
    })(props);
}
function AiFillProject(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM368 744c0 4.4-3.6 8-8 8h-80c-4.4 0-8-3.6-8-8V280c0-4.4 3.6-8 8-8h80c4.4 0 8 3.6 8 8v464zm192-280c0 4.4-3.6 8-8 8h-80c-4.4 0-8-3.6-8-8V280c0-4.4 3.6-8 8-8h80c4.4 0 8 3.6 8 8v184zm192 72c0 4.4-3.6 8-8 8h-80c-4.4 0-8-3.6-8-8V280c0-4.4 3.6-8 8-8h80c4.4 0 8 3.6 8 8v256z"
                }
            }
        ]
    })(props);
}
function AiFillPropertySafety(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M866.9 169.9L527.1 54.1C523 52.7 517.5 52 512 52s-11 .7-15.1 2.1L157.1 169.9c-8.3 2.8-15.1 12.4-15.1 21.2v482.4c0 8.8 5.7 20.4 12.6 25.9L499.3 968c3.5 2.7 8 4.1 12.6 4.1s9.2-1.4 12.6-4.1l344.7-268.6c6.9-5.4 12.6-17 12.6-25.9V191.1c.2-8.8-6.6-18.3-14.9-21.2zM648.3 332.8l-87.7 161.1h45.7c5.5 0 10 4.5 10 10v21.3c0 5.5-4.5 10-10 10h-63.4v29.7h63.4c5.5 0 10 4.5 10 10v21.3c0 5.5-4.5 10-10 10h-63.4V658c0 5.5-4.5 10-10 10h-41.3c-5.5 0-10-4.5-10-10v-51.8h-63.1c-5.5 0-10-4.5-10-10v-21.3c0-5.5 4.5-10 10-10h63.1v-29.7h-63.1c-5.5 0-10-4.5-10-10v-21.3c0-5.5 4.5-10 10-10h45.2l-88-161.1c-2.6-4.8-.9-10.9 4-13.6 1.5-.8 3.1-1.2 4.8-1.2h46c3.8 0 7.2 2.1 8.9 5.5l72.9 144.3 73.2-144.3a10 10 0 0 1 8.9-5.5h45c5.5 0 10 4.5 10 10 .1 1.7-.3 3.3-1.1 4.8z"
                }
            }
        ]
    })(props);
}
function AiFillPushpin(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M878.3 392.1L631.9 145.7c-6.5-6.5-15-9.7-23.5-9.7s-17 3.2-23.5 9.7L423.8 306.9c-12.2-1.4-24.5-2-36.8-2-73.2 0-146.4 24.1-206.5 72.3-15.4 12.3-16.6 35.4-2.7 49.4l181.7 181.7-215.4 215.2a15.8 15.8 0 0 0-4.6 9.8l-3.4 37.2c-.9 9.4 6.6 17.4 15.9 17.4.5 0 1 0 1.5-.1l37.2-3.4c3.7-.3 7.2-2 9.8-4.6l215.4-215.4 181.7 181.7c6.5 6.5 15 9.7 23.5 9.7 9.7 0 19.3-4.2 25.9-12.4 56.3-70.3 79.7-158.3 70.2-243.4l161.1-161.1c12.9-12.8 12.9-33.8 0-46.8z"
                }
            }
        ]
    })(props);
}
function AiFillQqCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm210.5 612.4c-11.5 1.4-44.9-52.7-44.9-52.7 0 31.3-16.2 72.2-51.1 101.8 16.9 5.2 54.9 19.2 45.9 34.4-7.3 12.3-125.6 7.9-159.8 4-34.2 3.8-152.5 8.3-159.8-4-9.1-15.2 28.9-29.2 45.8-34.4-35-29.5-51.1-70.4-51.1-101.8 0 0-33.4 54.1-44.9 52.7-5.4-.7-12.4-29.6 9.4-99.7 10.3-33 22-60.5 40.2-105.8-3.1-116.9 45.3-215 160.4-215 113.9 0 163.3 96.1 160.4 215 18.1 45.2 29.9 72.8 40.2 105.8 21.7 70.1 14.6 99.1 9.3 99.7z"
                }
            }
        ]
    })(props);
}
function AiFillQqSquare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM722.5 676.4c-11.5 1.4-44.9-52.7-44.9-52.7 0 31.3-16.2 72.2-51.1 101.8 16.9 5.2 54.9 19.2 45.9 34.4-7.3 12.3-125.6 7.9-159.8 4-34.2 3.8-152.5 8.3-159.8-4-9.1-15.2 28.9-29.2 45.8-34.4-35-29.5-51.1-70.4-51.1-101.8 0 0-33.4 54.1-44.9 52.7-5.4-.7-12.4-29.6 9.4-99.7 10.3-33 22-60.5 40.2-105.8-3.1-116.9 45.3-215 160.4-215 113.9 0 163.3 96.1 160.4 215 18.1 45.2 29.9 72.8 40.2 105.8 21.7 70.1 14.6 99.1 9.3 99.7z"
                }
            }
        ]
    })(props);
}
function AiFillQuestionCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 708c-22.1 0-40-17.9-40-40s17.9-40 40-40 40 17.9 40 40-17.9 40-40 40zm62.9-219.5a48.3 48.3 0 0 0-30.9 44.8V620c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8v-21.5c0-23.1 6.7-45.9 19.9-64.9 12.9-18.6 30.9-32.8 52.1-40.9 34-13.1 56-41.6 56-72.7 0-44.1-43.1-80-96-80s-96 35.9-96 80v7.6c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V420c0-39.3 17.2-76 48.4-103.3C430.4 290.4 470 276 512 276s81.6 14.5 111.6 40.7C654.8 344 672 380.7 672 420c0 57.8-38.1 109.8-97.1 132.5z"
                }
            }
        ]
    })(props);
}
function AiFillRead(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M928 161H699.2c-49.1 0-97.1 14.1-138.4 40.7L512 233l-48.8-31.3A255.2 255.2 0 0 0 324.8 161H96c-17.7 0-32 14.3-32 32v568c0 17.7 14.3 32 32 32h228.8c49.1 0 97.1 14.1 138.4 40.7l44.4 28.6c1.3.8 2.8 1.3 4.3 1.3s3-.4 4.3-1.3l44.4-28.6C602 807.1 650.1 793 699.2 793H928c17.7 0 32-14.3 32-32V193c0-17.7-14.3-32-32-32zM404 553.5c0 4.1-3.2 7.5-7.1 7.5H211.1c-3.9 0-7.1-3.4-7.1-7.5v-45c0-4.1 3.2-7.5 7.1-7.5h185.7c3.9 0 7.1 3.4 7.1 7.5v45zm0-140c0 4.1-3.2 7.5-7.1 7.5H211.1c-3.9 0-7.1-3.4-7.1-7.5v-45c0-4.1 3.2-7.5 7.1-7.5h185.7c3.9 0 7.1 3.4 7.1 7.5v45zm416 140c0 4.1-3.2 7.5-7.1 7.5H627.1c-3.9 0-7.1-3.4-7.1-7.5v-45c0-4.1 3.2-7.5 7.1-7.5h185.7c3.9 0 7.1 3.4 7.1 7.5v45zm0-140c0 4.1-3.2 7.5-7.1 7.5H627.1c-3.9 0-7.1-3.4-7.1-7.5v-45c0-4.1 3.2-7.5 7.1-7.5h185.7c3.9 0 7.1 3.4 7.1 7.5v45z"
                }
            }
        ]
    })(props);
}
function AiFillReconciliation(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M676 623c-18.8 0-34 15.2-34 34s15.2 34 34 34 34-15.2 34-34-15.2-34-34-34zm204-455H668c0-30.9-25.1-56-56-56h-80c-30.9 0-56 25.1-56 56H264c-17.7 0-32 14.3-32 32v200h-88c-17.7 0-32 14.3-32 32v448c0 17.7 14.3 32 32 32h336c17.7 0 32-14.3 32-32v-16h368c17.7 0 32-14.3 32-32V200c0-17.7-14.3-32-32-32zM448 848H176V616h272v232zm0-296H176v-88h272v88zm20-272v-48h72v-56h64v56h72v48H468zm180 168v56c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8v-56c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8zm28 301c-50.8 0-92-41.2-92-92s41.2-92 92-92 92 41.2 92 92-41.2 92-92 92zm92-245c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8v-96c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v96zm-92 61c-50.8 0-92 41.2-92 92s41.2 92 92 92 92-41.2 92-92-41.2-92-92-92zm0 126c-18.8 0-34-15.2-34-34s15.2-34 34-34 34 15.2 34 34-15.2 34-34 34z"
                }
            }
        ]
    })(props);
}
function AiFillRedEnvelope(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M832 64H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32zM647 470.4l-87.2 161h45.9c4.6 0 8.4 3.8 8.4 8.4v25.1c0 4.6-3.8 8.4-8.4 8.4h-63.3v28.6h63.3c4.6 0 8.4 3.8 8.4 8.4v25c.2 4.6-3.6 8.5-8.2 8.5h-63.3v49.9c0 4.6-3.8 8.4-8.4 8.4h-43.7c-4.6 0-8.4-3.8-8.4-8.4v-49.9h-63c-4.6 0-8.4-3.8-8.4-8.4v-25.1c0-4.6 3.8-8.4 8.4-8.4h63v-28.6h-63c-4.6 0-8.4-3.8-8.4-8.4v-25.1c0-4.6 3.8-8.4 8.4-8.4h45.4l-87.5-161c-2.2-4.1-.7-9.1 3.4-11.4 1.3-.6 2.6-1 3.9-1h48.8c3.2 0 6.1 1.8 7.5 4.6l71.9 141.8 71.9-141.9a8.5 8.5 0 0 1 7.5-4.6h47.8c4.6 0 8.4 3.8 8.4 8.4-.1 1.5-.5 2.9-1.1 4.1zM512.6 323L289 148h446L512.6 323z"
                }
            }
        ]
    })(props);
}
function AiFillRedditCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M584 548a36 36 0 1 0 72 0 36 36 0 1 0-72 0zm144-108a35.9 35.9 0 0 0-32.5 20.6c18.8 14.3 34.4 30.7 45.9 48.8A35.98 35.98 0 0 0 728 440zM512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm245 477.9c4.6 13.5 7 27.6 7 42.1 0 99.4-112.8 180-252 180s-252-80.6-252-180c0-14.5 2.4-28.6 7-42.1A72.01 72.01 0 0 1 296 404c27.1 0 50.6 14.9 62.9 37 36.2-19.8 80.2-32.8 128.1-36.1l58.4-131.1c4.3-9.8 15.2-14.8 25.5-11.8l91.6 26.5a54.03 54.03 0 0 1 101.6 25.6c0 29.8-24.2 54-54 54-23.5 0-43.5-15.1-50.9-36.1L577 308.3l-43 96.5c49.1 3 94.2 16.1 131.2 36.3 12.3-22.1 35.8-37 62.9-37 39.8 0 72 32.2 72 72-.1 29.3-17.8 54.6-43.1 65.8zm-171.3 83c-14.9 11.7-44.3 24.3-73.7 24.3s-58.9-12.6-73.7-24.3c-9.3-7.3-22.7-5.7-30 3.6-7.3 9.3-5.7 22.7 3.6 30 25.7 20.4 65 33.5 100.1 33.5 35.1 0 74.4-13.1 100.2-33.5 9.3-7.3 10.9-20.8 3.6-30a21.46 21.46 0 0 0-30.1-3.6zM296 440a35.98 35.98 0 0 0-13.4 69.4c11.5-18.1 27.1-34.5 45.9-48.8A35.9 35.9 0 0 0 296 440zm72 108a36 36 0 1 0 72 0 36 36 0 1 0-72 0z"
                }
            }
        ]
    })(props);
}
function AiFillRedditSquare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M296 440a35.98 35.98 0 0 0-13.4 69.4c11.5-18.1 27.1-34.5 45.9-48.8A35.9 35.9 0 0 0 296 440zm289.7 184.9c-14.9 11.7-44.3 24.3-73.7 24.3s-58.9-12.6-73.7-24.3c-9.3-7.3-22.7-5.7-30 3.6-7.3 9.3-5.7 22.7 3.6 30 25.7 20.4 65 33.5 100.1 33.5 35.1 0 74.4-13.1 100.2-33.5 9.3-7.3 10.9-20.8 3.6-30a21.46 21.46 0 0 0-30.1-3.6zM880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM757 541.9c4.6 13.5 7 27.6 7 42.1 0 99.4-112.8 180-252 180s-252-80.6-252-180c0-14.5 2.4-28.6 7-42.1A72.01 72.01 0 0 1 296 404c27.1 0 50.6 14.9 62.9 37 36.2-19.8 80.2-32.8 128.1-36.1l58.4-131.1c4.3-9.8 15.2-14.8 25.5-11.8l91.6 26.5a54.03 54.03 0 0 1 101.6 25.6c0 29.8-24.2 54-54 54-23.5 0-43.5-15.1-50.9-36.1L577 308.3l-43 96.5c49.1 3 94.2 16.1 131.2 36.3 12.3-22.1 35.8-37 62.9-37 39.8 0 72 32.2 72 72-.1 29.3-17.8 54.6-43.1 65.8zM584 548a36 36 0 1 0 72 0 36 36 0 1 0-72 0zm144-108a35.9 35.9 0 0 0-32.5 20.6c18.8 14.3 34.4 30.7 45.9 48.8A35.98 35.98 0 0 0 728 440zM368 548a36 36 0 1 0 72 0 36 36 0 1 0-72 0z"
                }
            }
        ]
    })(props);
}
function AiFillRest(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M832 256h-28.1l-35.7-120.9c-4-13.7-16.5-23.1-30.7-23.1h-451c-14.3 0-26.8 9.4-30.7 23.1L220.1 256H192c-17.7 0-32 14.3-32 32v28c0 4.4 3.6 8 8 8h45.8l47.7 558.7a32 32 0 0 0 31.9 29.3h429.2a32 32 0 0 0 31.9-29.3L802.2 324H856c4.4 0 8-3.6 8-8v-28c0-17.7-14.3-32-32-32zM508 704c-79.5 0-144-64.5-144-144s64.5-144 144-144 144 64.5 144 144-64.5 144-144 144zM291 256l22.4-76h397.2l22.4 76H291zm137 304a80 80 0 1 0 160 0 80 80 0 1 0-160 0z"
                }
            }
        ]
    })(props);
}
function AiFillRightCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm154.7 454.5l-246 178c-5.3 3.8-12.7 0-12.7-6.5v-46.9c0-10.2 4.9-19.9 13.2-25.9L566.6 512 421.2 406.8c-8.3-6-13.2-15.6-13.2-25.9V334c0-6.5 7.4-10.3 12.7-6.5l246 178c4.4 3.2 4.4 9.8 0 13z"
                }
            }
        ]
    })(props);
}
function AiFillRightSquare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM658.7 518.5l-246 178c-5.3 3.8-12.7 0-12.7-6.5v-46.9c0-10.2 4.9-19.9 13.2-25.9L558.6 512 413.2 406.8c-8.3-6-13.2-15.6-13.2-25.9V334c0-6.5 7.4-10.3 12.7-6.5l246 178c4.4 3.2 4.4 9.8 0 13z"
                }
            }
        ]
    })(props);
}
function AiFillRobot(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "t": "1569682613478",
            "viewBox": "0 0 1024 1024",
            "version": "1.1"
        },
        "child": [
            {
                "tag": "defs",
                "attr": {},
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M852 64H172c-17.7 0-32 14.3-32 32v660c0 17.7 14.3 32 32 32h680c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32zM300 328c0-33.1 26.9-60 60-60s60 26.9 60 60-26.9 60-60 60-60-26.9-60-60z m372 248c0 4.4-3.6 8-8 8H360c-4.4 0-8-3.6-8-8v-60c0-4.4 3.6-8 8-8h304c4.4 0 8 3.6 8 8v60z m-8-188c-33.1 0-60-26.9-60-60s26.9-60 60-60 60 26.9 60 60-26.9 60-60 60zM799 864H225c-13.8 0-25 14.3-25 32v56c0 4.4 2.8 8 6.2 8h611.5c3.4 0 6.2-3.6 6.2-8v-56c0.1-17.7-11.1-32-24.9-32z"
                }
            }
        ]
    })(props);
}
function AiFillRocket(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M864 736c0-111.6-65.4-208-160-252.9V317.3c0-15.1-5.3-29.7-15.1-41.2L536.5 95.4C530.1 87.8 521 84 512 84s-18.1 3.8-24.5 11.4L335.1 276.1a63.97 63.97 0 0 0-15.1 41.2v165.8C225.4 528 160 624.4 160 736h156.5c-2.3 7.2-3.5 15-3.5 23.8 0 22.1 7.6 43.7 21.4 60.8a97.2 97.2 0 0 0 43.1 30.6c23.1 54 75.6 88.8 134.5 88.8 29.1 0 57.3-8.6 81.4-24.8 23.6-15.8 41.9-37.9 53-64a97 97 0 0 0 43.1-30.5 97.52 97.52 0 0 0 21.4-60.8c0-8.4-1.1-16.4-3.1-23.8L864 736zM512 352a48.01 48.01 0 0 1 0 96 48.01 48.01 0 0 1 0-96zm116.1 432.2c-5.2 3-11.2 4.2-17.1 3.4l-19.5-2.4-2.8 19.4c-5.4 37.9-38.4 66.5-76.7 66.5s-71.3-28.6-76.7-66.5l-2.8-19.5-19.5 2.5a27.7 27.7 0 0 1-17.1-3.5c-8.7-5-14.1-14.3-14.1-24.4 0-10.6 5.9-19.4 14.6-23.8h231.3c8.8 4.5 14.6 13.3 14.6 23.8-.1 10.2-5.5 19.6-14.2 24.5z"
                }
            }
        ]
    })(props);
}
function AiFillSafetyCertificate(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M866.9 169.9L527.1 54.1C523 52.7 517.5 52 512 52s-11 .7-15.1 2.1L157.1 169.9c-8.3 2.8-15.1 12.4-15.1 21.2v482.4c0 8.8 5.7 20.4 12.6 25.9L499.3 968c3.5 2.7 8 4.1 12.6 4.1s9.2-1.4 12.6-4.1l344.7-268.6c6.9-5.4 12.6-17 12.6-25.9V191.1c.2-8.8-6.6-18.3-14.9-21.2zM694.5 340.7L481.9 633.4a16.1 16.1 0 0 1-26 0l-126.4-174c-3.8-5.3 0-12.7 6.5-12.7h55.2c5.1 0 10 2.5 13 6.6l64.7 89 150.9-207.8c3-4.1 7.8-6.6 13-6.6H688c6.5.1 10.3 7.5 6.5 12.8z"
                }
            }
        ]
    })(props);
}
function AiFillSave(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M893.3 293.3L730.7 130.7c-12-12-28.3-18.7-45.3-18.7H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V338.5c0-17-6.7-33.2-18.7-45.2zM384 176h256v112H384V176zm128 554c-79.5 0-144-64.5-144-144s64.5-144 144-144 144 64.5 144 144-64.5 144-144 144zm0-224c-44.2 0-80 35.8-80 80s35.8 80 80 80 80-35.8 80-80-35.8-80-80-80z"
                }
            }
        ]
    })(props);
}
function AiFillSchedule(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M928 224H768v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56H548v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56H328v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56H96c-17.7 0-32 14.3-32 32v576c0 17.7 14.3 32 32 32h832c17.7 0 32-14.3 32-32V256c0-17.7-14.3-32-32-32zM424 688c0 4.4-3.6 8-8 8H232c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h184c4.4 0 8 3.6 8 8v48zm0-136c0 4.4-3.6 8-8 8H232c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h184c4.4 0 8 3.6 8 8v48zm374.5-91.3l-165 228.7a15.9 15.9 0 0 1-25.8 0L493.5 531.2c-3.8-5.3 0-12.7 6.5-12.7h54.9c5.1 0 9.9 2.5 12.9 6.6l52.8 73.1 103.7-143.7c3-4.2 7.8-6.6 12.9-6.6H792c6.5.1 10.3 7.5 6.5 12.8z"
                }
            }
        ]
    })(props);
}
function AiFillSecurityScan(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M866.9 169.9L527.1 54.1C523 52.7 517.5 52 512 52s-11 .7-15.1 2.1L157.1 169.9c-8.3 2.8-15.1 12.4-15.1 21.2v482.4c0 8.8 5.7 20.4 12.6 25.9L499.3 968c3.5 2.7 8 4.1 12.6 4.1s9.2-1.4 12.6-4.1l344.7-268.6c6.9-5.4 12.6-17 12.6-25.9V191.1c.2-8.8-6.6-18.3-14.9-21.2zM626.8 554c-48.5 48.5-123 55.2-178.6 20.1l-77.5 77.5a8.03 8.03 0 0 1-11.3 0l-34-34a8.03 8.03 0 0 1 0-11.3l77.5-77.5c-35.1-55.7-28.4-130.1 20.1-178.6 56.3-56.3 147.5-56.3 203.8 0 56.3 56.3 56.3 147.5 0 203.8zm-158.54-45.27a80.1 80.1 0 1 0 113.27-113.28 80.1 80.1 0 1 0-113.27 113.28z"
                }
            }
        ]
    })(props);
}
function AiFillSetting(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M512.5 390.6c-29.9 0-57.9 11.6-79.1 32.8-21.1 21.2-32.8 49.2-32.8 79.1 0 29.9 11.7 57.9 32.8 79.1 21.2 21.1 49.2 32.8 79.1 32.8 29.9 0 57.9-11.7 79.1-32.8 21.1-21.2 32.8-49.2 32.8-79.1 0-29.9-11.7-57.9-32.8-79.1a110.96 110.96 0 0 0-79.1-32.8zm412.3 235.5l-65.4-55.9c3.1-19 4.7-38.4 4.7-57.7s-1.6-38.8-4.7-57.7l65.4-55.9a32.03 32.03 0 0 0 9.3-35.2l-.9-2.6a442.5 442.5 0 0 0-79.6-137.7l-1.8-2.1a32.12 32.12 0 0 0-35.1-9.5l-81.2 28.9c-30-24.6-63.4-44-99.6-57.5l-15.7-84.9a32.05 32.05 0 0 0-25.8-25.7l-2.7-.5c-52-9.4-106.8-9.4-158.8 0l-2.7.5a32.05 32.05 0 0 0-25.8 25.7l-15.8 85.3a353.44 353.44 0 0 0-98.9 57.3l-81.8-29.1a32 32 0 0 0-35.1 9.5l-1.8 2.1a445.93 445.93 0 0 0-79.6 137.7l-.9 2.6c-4.5 12.5-.8 26.5 9.3 35.2l66.2 56.5c-3.1 18.8-4.6 38-4.6 57 0 19.2 1.5 38.4 4.6 57l-66 56.5a32.03 32.03 0 0 0-9.3 35.2l.9 2.6c18.1 50.3 44.8 96.8 79.6 137.7l1.8 2.1a32.12 32.12 0 0 0 35.1 9.5l81.8-29.1c29.8 24.5 63 43.9 98.9 57.3l15.8 85.3a32.05 32.05 0 0 0 25.8 25.7l2.7.5a448.27 448.27 0 0 0 158.8 0l2.7-.5a32.05 32.05 0 0 0 25.8-25.7l15.7-84.9c36.2-13.6 69.6-32.9 99.6-57.5l81.2 28.9a32 32 0 0 0 35.1-9.5l1.8-2.1c34.8-41.1 61.5-87.4 79.6-137.7l.9-2.6c4.3-12.4.6-26.3-9.5-35zm-412.3 52.2c-97.1 0-175.8-78.7-175.8-175.8s78.7-175.8 175.8-175.8 175.8 78.7 175.8 175.8-78.7 175.8-175.8 175.8z"
                }
            }
        ]
    })(props);
}
function AiFillShop(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M882 272.1V144c0-17.7-14.3-32-32-32H174c-17.7 0-32 14.3-32 32v128.1c-16.7 1-30 14.9-30 31.9v131.7a177 177 0 0 0 14.4 70.4c4.3 10.2 9.6 19.8 15.6 28.9v345c0 17.6 14.3 32 32 32h274V736h128v176h274c17.7 0 32-14.3 32-32V535a175 175 0 0 0 15.6-28.9c9.5-22.3 14.4-46 14.4-70.4V304c0-17-13.3-30.9-30-31.9zm-72 568H640V704c0-17.7-14.3-32-32-32H416c-17.7 0-32 14.3-32 32v136.1H214V597.9c2.9 1.4 5.9 2.8 9 4 22.3 9.4 46 14.1 70.4 14.1s48-4.7 70.4-14.1c13.8-5.8 26.8-13.2 38.7-22.1.2-.1.4-.1.6 0a180.4 180.4 0 0 0 38.7 22.1c22.3 9.4 46 14.1 70.4 14.1 24.4 0 48-4.7 70.4-14.1 13.8-5.8 26.8-13.2 38.7-22.1.2-.1.4-.1.6 0a180.4 180.4 0 0 0 38.7 22.1c22.3 9.4 46 14.1 70.4 14.1 24.4 0 48-4.7 70.4-14.1 3-1.3 6-2.6 9-4v242.2zm0-568.1H214v-88h596v88z"
                }
            }
        ]
    })(props);
}
function AiFillShopping(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M832 312H696v-16c0-101.6-82.4-184-184-184s-184 82.4-184 184v16H192c-17.7 0-32 14.3-32 32v536c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V344c0-17.7-14.3-32-32-32zm-208 0H400v-16c0-61.9 50.1-112 112-112s112 50.1 112 112v16z"
                }
            }
        ]
    })(props);
}
function AiFillSignal(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "t": "1569682885975",
            "viewBox": "0 0 1024 1024",
            "version": "1.1"
        },
        "child": [
            {
                "tag": "defs",
                "attr": {},
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M584 352H440c-17.7 0-32 14.3-32 32v544c0 17.7 14.3 32 32 32h144c17.7 0 32-14.3 32-32V384c0-17.7-14.3-32-32-32zM892 64H748c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h144c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32zM276 640H132c-17.7 0-32 14.3-32 32v256c0 17.7 14.3 32 32 32h144c17.7 0 32-14.3 32-32V672c0-17.7-14.3-32-32-32z"
                }
            }
        ]
    })(props);
}
function AiFillSketchCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M582.3 625.6l147.9-166.3h-63.4zm90-202.3h62.5l-92.1-115.1zm-274.7 36L512 684.5l114.4-225.2zM512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm286.7 380.2L515.8 762.3c-1 1.1-2.4 1.7-3.8 1.7s-2.8-.6-3.8-1.7L225.3 444.2a5.14 5.14 0 0 1-.2-6.6L365.6 262c1-1.2 2.4-1.9 4-1.9h284.6c1.6 0 3 .7 4 1.9l140.5 175.6a4.9 4.9 0 0 1 0 6.6zm-190.5-20.9L512 326.1l-96.2 97.2zM420.3 301.1l-23.1 89.8 88.8-89.8zm183.4 0H538l88.8 89.8zm-222.4 7.1l-92.1 115.1h62.5zm-87.5 151.1l147.9 166.3-84.5-166.3z"
                }
            }
        ]
    })(props);
}
function AiFillSketchSquare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M608.2 423.3L512 326.1l-96.2 97.2zm-25.9 202.3l147.9-166.3h-63.4zm90-202.3h62.5l-92.1-115.1zM880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-81.3 332.2L515.8 762.3c-1 1.1-2.4 1.7-3.8 1.7s-2.8-.6-3.8-1.7L225.3 444.2a5.14 5.14 0 0 1-.2-6.6L365.6 262c1-1.2 2.4-1.9 4-1.9h284.6c1.6 0 3 .7 4 1.9l140.5 175.6a4.9 4.9 0 0 1 0 6.6zm-401.1 15.1L512 684.5l114.4-225.2zm-16.3-151.1l-92.1 115.1h62.5zm-87.5 151.1l147.9 166.3-84.5-166.3zm126.5-158.2l-23.1 89.8 88.8-89.8zm183.4 0H538l88.8 89.8z"
                }
            }
        ]
    })(props);
}
function AiFillSkin(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M870 126H663.8c-17.4 0-32.9 11.9-37 29.3C614.3 208.1 567 246 512 246s-102.3-37.9-114.8-90.7a37.93 37.93 0 0 0-37-29.3H154a44 44 0 0 0-44 44v252a44 44 0 0 0 44 44h75v388a44 44 0 0 0 44 44h478a44 44 0 0 0 44-44V466h75a44 44 0 0 0 44-44V170a44 44 0 0 0-44-44z"
                }
            }
        ]
    })(props);
}
function AiFillSkype(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M883.7 578.6c4.1-22.5 6.3-45.5 6.3-68.5 0-51-10-100.5-29.7-147-19-45-46.3-85.4-81-120.1a375.79 375.79 0 0 0-120.1-80.9c-46.6-19.7-96-29.7-147-29.7-24 0-48.1 2.3-71.5 6.8A225.1 225.1 0 0 0 335.6 113c-59.7 0-115.9 23.3-158.1 65.5A222.25 222.25 0 0 0 112 336.6c0 38 9.8 75.4 28.1 108.4-3.7 21.4-5.7 43.3-5.7 65.1 0 51 10 100.5 29.7 147 19 45 46.2 85.4 80.9 120.1 34.7 34.7 75.1 61.9 120.1 80.9 46.6 19.7 96 29.7 147 29.7 22.2 0 44.4-2 66.2-5.9 33.5 18.9 71.3 29 110 29 59.7 0 115.9-23.2 158.1-65.5 42.3-42.2 65.5-98.4 65.5-158.1.1-38-9.7-75.5-28.2-108.7zm-370 162.9c-134.2 0-194.2-66-194.2-115.4 0-25.4 18.7-43.1 44.5-43.1 57.4 0 42.6 82.5 149.7 82.5 54.9 0 85.2-29.8 85.2-60.3 0-18.3-9-38.7-45.2-47.6l-119.4-29.8c-96.1-24.1-113.6-76.1-113.6-124.9 0-101.4 95.5-139.5 185.2-139.5 82.6 0 180 45.7 180 106.5 0 26.1-22.6 41.2-48.4 41.2-49 0-40-67.8-138.7-67.8-49 0-76.1 22.2-76.1 53.9s38.7 41.8 72.3 49.5l88.4 19.6c96.8 21.6 121.3 78.1 121.3 131.3 0 82.3-63.3 143.9-191 143.9z"
                }
            }
        ]
    })(props);
}
function AiFillSlackCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zM361.5 580.2c0 27.8-22.5 50.4-50.3 50.4-13.3 0-26.1-5.3-35.6-14.8-9.4-9.5-14.7-22.3-14.7-35.6 0-27.8 22.5-50.4 50.3-50.4h50.3v50.4zm134 134.4c0 27.8-22.5 50.4-50.3 50.4-27.8 0-50.3-22.6-50.3-50.4V580.2c0-27.8 22.5-50.4 50.3-50.4 13.3 0 26.1 5.3 35.6 14.8s14.7 22.3 14.7 35.6v134.4zm-50.2-218.4h-134c-27.8 0-50.3-22.6-50.3-50.4 0-27.8 22.5-50.4 50.3-50.4h134c27.8 0 50.3 22.6 50.3 50.4-.1 27.9-22.6 50.4-50.3 50.4zm0-134.4c-13.3 0-26.1-5.3-35.6-14.8S395 324.8 395 311.4c0-27.8 22.5-50.4 50.3-50.4 27.8 0 50.3 22.6 50.3 50.4v50.4h-50.3zm83.7-50.4c0-27.8 22.5-50.4 50.3-50.4 27.8 0 50.3 22.6 50.3 50.4v134.4c0 27.8-22.5 50.4-50.3 50.4-27.8 0-50.3-22.6-50.3-50.4V311.4zM579.3 765c-27.8 0-50.3-22.6-50.3-50.4v-50.4h50.3c27.8 0 50.3 22.6 50.3 50.4 0 27.8-22.5 50.4-50.3 50.4zm134-134.4h-134c-13.3 0-26.1-5.3-35.6-14.8S529 593.6 529 580.2c0-27.8 22.5-50.4 50.3-50.4h134c27.8 0 50.3 22.6 50.3 50.4 0 27.8-22.5 50.4-50.3 50.4zm0-134.4H663v-50.4c0-27.8 22.5-50.4 50.3-50.4s50.3 22.6 50.3 50.4c0 27.8-22.5 50.4-50.3 50.4z"
                }
            }
        ]
    })(props);
}
function AiFillSlackSquare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM529 311.4c0-27.8 22.5-50.4 50.3-50.4 27.8 0 50.3 22.6 50.3 50.4v134.4c0 27.8-22.5 50.4-50.3 50.4-27.8 0-50.3-22.6-50.3-50.4V311.4zM361.5 580.2c0 27.8-22.5 50.4-50.3 50.4-13.3 0-26.1-5.3-35.6-14.8-9.4-9.5-14.7-22.3-14.7-35.6 0-27.8 22.5-50.4 50.3-50.4h50.3v50.4zm134 134.4c0 27.8-22.5 50.4-50.3 50.4-27.8 0-50.3-22.6-50.3-50.4V580.2c0-27.8 22.5-50.4 50.3-50.4 13.3 0 26.1 5.3 35.6 14.8s14.7 22.3 14.7 35.6v134.4zm-50.2-218.4h-134c-27.8 0-50.3-22.6-50.3-50.4 0-27.8 22.5-50.4 50.3-50.4h134c27.8 0 50.3 22.6 50.3 50.4-.1 27.9-22.6 50.4-50.3 50.4zm0-134.4c-13.3 0-26.1-5.3-35.6-14.8S395 324.8 395 311.4c0-27.8 22.5-50.4 50.3-50.4 27.8 0 50.3 22.6 50.3 50.4v50.4h-50.3zm134 403.2c-27.8 0-50.3-22.6-50.3-50.4v-50.4h50.3c27.8 0 50.3 22.6 50.3 50.4 0 27.8-22.5 50.4-50.3 50.4zm134-134.4h-134c-13.3 0-26.1-5.3-35.6-14.8-9.4-9.5-14.7-22.3-14.7-35.6 0-27.8 22.5-50.4 50.3-50.4h134c27.8 0 50.3 22.6 50.3 50.4 0 27.8-22.5 50.4-50.3 50.4zm0-134.4H663v-50.4c0-27.8 22.5-50.4 50.3-50.4s50.3 22.6 50.3 50.4c0 27.8-22.5 50.4-50.3 50.4z"
                }
            }
        ]
    })(props);
}
function AiFillSliders(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M904 296h-66v-96c0-4.4-3.6-8-8-8h-52c-4.4 0-8 3.6-8 8v96h-66c-4.4 0-8 3.6-8 8v416c0 4.4 3.6 8 8 8h66v96c0 4.4 3.6 8 8 8h52c4.4 0 8-3.6 8-8v-96h66c4.4 0 8-3.6 8-8V304c0-4.4-3.6-8-8-8zm-584-72h-66v-56c0-4.4-3.6-8-8-8h-52c-4.4 0-8 3.6-8 8v56h-66c-4.4 0-8 3.6-8 8v560c0 4.4 3.6 8 8 8h66v56c0 4.4 3.6 8 8 8h52c4.4 0 8-3.6 8-8v-56h66c4.4 0 8-3.6 8-8V232c0-4.4-3.6-8-8-8zm292 180h-66V232c0-4.4-3.6-8-8-8h-52c-4.4 0-8 3.6-8 8v172h-66c-4.4 0-8 3.6-8 8v200c0 4.4 3.6 8 8 8h66v172c0 4.4 3.6 8 8 8h52c4.4 0 8-3.6 8-8V620h66c4.4 0 8-3.6 8-8V412c0-4.4-3.6-8-8-8z"
                }
            }
        ]
    })(props);
}
function AiFillSmile(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zM288 421a48.01 48.01 0 0 1 96 0 48.01 48.01 0 0 1-96 0zm224 272c-85.5 0-155.6-67.3-160-151.6a8 8 0 0 1 8-8.4h48.1c4.2 0 7.8 3.2 8.1 7.4C420 589.9 461.5 629 512 629s92.1-39.1 95.8-88.6c.3-4.2 3.9-7.4 8.1-7.4H664a8 8 0 0 1 8 8.4C667.6 625.7 597.5 693 512 693zm176-224a48.01 48.01 0 0 1 0-96 48.01 48.01 0 0 1 0 96z"
                }
            }
        ]
    })(props);
}
function AiFillSnippets(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M832 112H724V72c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v40H500V72c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v40H320c-17.7 0-32 14.3-32 32v120h-96c-17.7 0-32 14.3-32 32v632c0 17.7 14.3 32 32 32h512c17.7 0 32-14.3 32-32v-96h96c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM664 486H514V336h.2L664 485.8v.2zm128 274h-56V456L544 264H360v-80h68v32c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-32h152v32c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-32h68v576z"
                }
            }
        ]
    })(props);
}
function AiFillSound(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M892.1 737.8l-110.3-63.7a15.9 15.9 0 0 0-21.7 5.9l-19.9 34.5c-4.4 7.6-1.8 17.4 5.8 21.8L856.3 800a15.9 15.9 0 0 0 21.7-5.9l19.9-34.5c4.4-7.6 1.7-17.4-5.8-21.8zM760 344a15.9 15.9 0 0 0 21.7 5.9L892 286.2c7.6-4.4 10.2-14.2 5.8-21.8L878 230a15.9 15.9 0 0 0-21.7-5.9L746 287.8a15.99 15.99 0 0 0-5.8 21.8L760 344zm174 132H806c-8.8 0-16 7.2-16 16v40c0 8.8 7.2 16 16 16h128c8.8 0 16-7.2 16-16v-40c0-8.8-7.2-16-16-16zM625.9 115c-5.9 0-11.9 1.6-17.4 5.3L254 352H90c-8.8 0-16 7.2-16 16v288c0 8.8 7.2 16 16 16h164l354.5 231.7c5.5 3.6 11.6 5.3 17.4 5.3 16.7 0 32.1-13.3 32.1-32.1V147.1c0-18.8-15.4-32.1-32.1-32.1z"
                }
            }
        ]
    })(props);
}
function AiFillStar(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M908.1 353.1l-253.9-36.9L540.7 86.1c-3.1-6.3-8.2-11.4-14.5-14.5-15.8-7.8-35-1.3-42.9 14.5L369.8 316.2l-253.9 36.9c-7 1-13.4 4.3-18.3 9.3a32.05 32.05 0 0 0 .6 45.3l183.7 179.1-43.4 252.9a31.95 31.95 0 0 0 46.4 33.7L512 754l227.1 119.4c6.2 3.3 13.4 4.4 20.3 3.2 17.4-3 29.1-19.5 26.1-36.9l-43.4-252.9 183.7-179.1c5-4.9 8.3-11.3 9.3-18.3 2.7-17.5-9.5-33.7-27-36.3z"
                }
            }
        ]
    })(props);
}
function AiFillStepBackward(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M347.6 528.95l383.2 301.02c14.25 11.2 35.2 1.1 35.2-16.95V210.97c0-18.05-20.95-28.14-35.2-16.94L347.6 495.05a21.53 21.53 0 0 0 0 33.9M330 864h-64a8 8 0 0 1-8-8V168a8 8 0 0 1 8-8h64a8 8 0 0 1 8 8v688a8 8 0 0 1-8 8"
                }
            }
        ]
    })(props);
}
function AiFillStepForward(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M676.4 528.95L293.2 829.97c-14.25 11.2-35.2 1.1-35.2-16.95V210.97c0-18.05 20.95-28.14 35.2-16.94l383.2 301.02a21.53 21.53 0 0 1 0 33.9M694 864h64a8 8 0 0 0 8-8V168a8 8 0 0 0-8-8h-64a8 8 0 0 0-8 8v688a8 8 0 0 0 8 8"
                }
            }
        ]
    })(props);
}
function AiFillStop(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm234.8 736.5L223.5 277.2c16-19.7 34-37.7 53.7-53.7l523.3 523.3c-16 19.6-34 37.7-53.7 53.7z"
                }
            }
        ]
    })(props);
}
function AiFillSwitcher(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M752 240H144c-17.7 0-32 14.3-32 32v608c0 17.7 14.3 32 32 32h608c17.7 0 32-14.3 32-32V272c0-17.7-14.3-32-32-32zM596 606c0 4.4-3.6 8-8 8H308c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h280c4.4 0 8 3.6 8 8v48zm284-494H264c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h576v576c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V144c0-17.7-14.3-32-32-32z"
                }
            }
        ]
    })(props);
}
function AiFillTablet(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M800 64H224c-35.3 0-64 28.7-64 64v768c0 35.3 28.7 64 64 64h576c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64zM512 824c-22.1 0-40-17.9-40-40s17.9-40 40-40 40 17.9 40 40-17.9 40-40 40z"
                }
            }
        ]
    })(props);
}
function AiFillTag(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M938 458.8l-29.6-312.6c-1.5-16.2-14.4-29-30.6-30.6L565.2 86h-.4c-3.2 0-5.7 1-7.6 2.9L88.9 557.2a9.96 9.96 0 0 0 0 14.1l363.8 363.8c1.9 1.9 4.4 2.9 7.1 2.9s5.2-1 7.1-2.9l468.3-468.3c2-2.1 3-5 2.8-8zM699 387c-35.3 0-64-28.7-64-64s28.7-64 64-64 64 28.7 64 64-28.7 64-64 64z"
                }
            }
        ]
    })(props);
}
function AiFillTags(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M483.2 790.3L861.4 412c1.7-1.7 2.5-4 2.3-6.3l-25.5-301.4c-.7-7.8-6.8-13.9-14.6-14.6L522.2 64.3c-2.3-.2-4.7.6-6.3 2.3L137.7 444.8a8.03 8.03 0 0 0 0 11.3l334.2 334.2c3.1 3.2 8.2 3.2 11.3 0zm122.7-533.4c18.7-18.7 49.1-18.7 67.9 0 18.7 18.7 18.7 49.1 0 67.9-18.7 18.7-49.1 18.7-67.9 0-18.7-18.7-18.7-49.1 0-67.9zm283.8 282.9l-39.6-39.5a8.03 8.03 0 0 0-11.3 0l-362 361.3-237.6-237a8.03 8.03 0 0 0-11.3 0l-39.6 39.5a8.03 8.03 0 0 0 0 11.3l243.2 242.8 39.6 39.5c3.1 3.1 8.2 3.1 11.3 0l407.3-406.6c3.1-3.1 3.1-8.2 0-11.3z"
                }
            }
        ]
    })(props);
}
function AiFillTaobaoCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zM315.7 291.5c27.3 0 49.5 22.1 49.5 49.4s-22.1 49.4-49.5 49.4a49.4 49.4 0 1 1 0-98.8zM366.9 578c-13.6 42.3-10.2 26.7-64.4 144.5l-78.5-49s87.7-79.8 105.6-116.2c19.2-38.4-21.1-58.9-21.1-58.9l-60.2-37.5 32.7-50.2c45.4 33.7 48.7 36.6 79.2 67.2 23.8 23.9 20.7 56.8 6.7 100.1zm427.2 55c-15.3 143.8-202.4 90.3-202.4 90.3l10.2-41.1 43.3 9.3c80 5 72.3-64.9 72.3-64.9V423c.6-77.3-72.6-85.4-204.2-38.3l30.6 8.3c-2.5 9-12.5 23.2-25.2 38.6h176v35.6h-99.1v44.5h98.7v35.7h-98.7V622c14.9-4.8 28.6-11.5 40.5-20.5l-8.7-32.5 46.5-14.4 38.8 94.9-57.3 23.9-10.2-37.8c-25.6 19.5-78.8 48-171.8 45.4-99.2 2.6-73.7-112-73.7-112l2.5-1.3H472c-.5 14.7-6.6 38.7 1.7 51.8 6.8 10.8 24.2 12.6 35.3 13.1 1.3.1 2.6.1 3.9.1v-85.3h-101v-35.7h101v-44.5H487c-22.7 24.1-43.5 44.1-43.5 44.1l-30.6-26.7c21.7-22.9 43.3-59.1 56.8-83.2-10.9 4.4-22 9.2-33.6 14.2-11.2 14.3-24.2 29-38.7 43.5.5.8-50-28.4-50-28.4 52.2-44.4 81.4-139.9 81.4-139.9l72.5 20.4s-5.9 14-18.4 35.6c290.3-82.3 307.4 50.5 307.4 50.5s19.1 91.8 3.8 235.7z"
                }
            }
        ]
    })(props);
}
function AiFillTaobaoSquare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM315.7 291.5c27.3 0 49.5 22.1 49.5 49.4s-22.1 49.4-49.5 49.4a49.4 49.4 0 1 1 0-98.8zM366.9 578c-13.6 42.3-10.2 26.7-64.4 144.5l-78.5-49s87.7-79.8 105.6-116.2c19.2-38.4-21.1-58.9-21.1-58.9l-60.2-37.5 32.7-50.2c45.4 33.7 48.7 36.6 79.2 67.2 23.8 23.9 20.7 56.8 6.7 100.1zm427.2 55c-15.3 143.8-202.4 90.3-202.4 90.3l10.2-41.1 43.3 9.3c80 5 72.3-64.9 72.3-64.9V423c.6-77.3-72.6-85.4-204.2-38.3l30.6 8.3c-2.5 9-12.5 23.2-25.2 38.6h176v35.6h-99.1v44.5h98.7v35.7h-98.7V622c14.9-4.8 28.6-11.5 40.5-20.5l-8.7-32.5 46.5-14.4 38.8 94.9-57.3 23.9-10.2-37.8c-25.6 19.5-78.8 48-171.8 45.4-99.2 2.6-73.7-112-73.7-112l2.5-1.3H472c-.5 14.7-6.6 38.7 1.7 51.8 6.8 10.8 24.2 12.6 35.3 13.1 1.3.1 2.6.1 3.9.1v-85.3h-101v-35.7h101v-44.5H487c-22.7 24.1-43.5 44.1-43.5 44.1l-30.6-26.7c21.7-22.9 43.3-59.1 56.8-83.2-10.9 4.4-22 9.2-33.6 14.2-11.2 14.3-24.2 29-38.7 43.5.5.8-50-28.4-50-28.4 52.2-44.4 81.4-139.9 81.4-139.9l72.5 20.4s-5.9 14-18.4 35.6c290.3-82.3 307.4 50.5 307.4 50.5s19.1 91.8 3.8 235.7z"
                }
            }
        ]
    })(props);
}
function AiFillThunderbolt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M848 359.3H627.7L825.8 109c4.1-5.3.4-13-6.3-13H436c-2.8 0-5.5 1.5-6.9 4L170 547.5c-3.1 5.3.7 12 6.9 12h174.4l-89.4 357.6c-1.9 7.8 7.5 13.3 13.3 7.7L853.5 373c5.2-4.9 1.7-13.7-5.5-13.7z"
                }
            }
        ]
    })(props);
}
function AiFillTool(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M865.3 244.7c-.3-.3-61.1 59.8-182.1 180.6l-84.9-84.9 180.9-180.9c-95.2-57.3-217.5-42.6-296.8 36.7A244.42 244.42 0 0 0 419 432l1.8 6.7-283.5 283.4c-6.2 6.2-6.2 16.4 0 22.6l141.4 141.4c6.2 6.2 16.4 6.2 22.6 0l283.3-283.3 6.7 1.8c83.7 22.3 173.6-.9 236-63.3 79.4-79.3 94.1-201.6 38-296.6z"
                }
            }
        ]
    })(props);
}
function AiFillTrademarkCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm164.7 660.2c-1.1.5-2.3.8-3.5.8h-62c-3.1 0-5.9-1.8-7.2-4.6l-74.6-159.2h-88.7V717c0 4.4-3.6 8-8 8H378c-4.4 0-8-3.6-8-8V307c0-4.4 3.6-8 8-8h155.6c98.8 0 144.2 59.9 144.2 131.1 0 70.2-43.6 106.4-78.4 119.2l80.8 164.2c2.1 3.9.4 8.7-3.5 10.7zM523.9 357h-83.4v148H522c53 0 82.8-25.6 82.8-72.4 0-50.3-32.9-75.6-80.9-75.6z"
                }
            }
        ]
    })(props);
}
function AiFillTrophy(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M868 160h-92v-40c0-4.4-3.6-8-8-8H256c-4.4 0-8 3.6-8 8v40h-92a44 44 0 0 0-44 44v148c0 81.7 60 149.6 138.2 162C265.6 630.2 359 721.8 476 734.5v105.2H280c-17.7 0-32 14.3-32 32V904c0 4.4 3.6 8 8 8h512c4.4 0 8-3.6 8-8v-32.3c0-17.7-14.3-32-32-32H548V734.5C665 721.8 758.4 630.2 773.8 514 852 501.6 912 433.7 912 352V204a44 44 0 0 0-44-44zM248 439.6c-37.1-11.9-64-46.7-64-87.6V232h64v207.6zM840 352c0 41-26.9 75.8-64 87.6V232h64v120z"
                }
            }
        ]
    })(props);
}
function AiFillTwitterCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm215.3 337.7c.3 4.7.3 9.6.3 14.4 0 146.8-111.8 315.9-316.1 315.9-63 0-121.4-18.3-170.6-49.8 9 1 17.6 1.4 26.8 1.4 52 0 99.8-17.6 137.9-47.4-48.8-1-89.8-33-103.8-77 17.1 2.5 32.5 2.5 50.1-2a111 111 0 0 1-88.9-109v-1.4c14.7 8.3 32 13.4 50.1 14.1a111.13 111.13 0 0 1-49.5-92.4c0-20.7 5.4-39.6 15.1-56a315.28 315.28 0 0 0 229 116.1C492 353.1 548.4 292 616.2 292c32 0 60.8 13.4 81.1 35 25.1-4.7 49.1-14.1 70.5-26.7-8.3 25.7-25.7 47.4-48.8 61.1 22.4-2.4 44-8.6 64-17.3-15.1 22.2-34 41.9-55.7 57.6z"
                }
            }
        ]
    })(props);
}
function AiFillTwitterSquare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM727.3 401.7c.3 4.7.3 9.6.3 14.4 0 146.8-111.8 315.9-316.1 315.9-63 0-121.4-18.3-170.6-49.8 9 1 17.6 1.4 26.8 1.4 52 0 99.8-17.6 137.9-47.4-48.8-1-89.8-33-103.8-77 17.1 2.5 32.5 2.5 50.1-2a111 111 0 0 1-88.9-109v-1.4c14.7 8.3 32 13.4 50.1 14.1a111.13 111.13 0 0 1-49.5-92.4c0-20.7 5.4-39.6 15.1-56a315.28 315.28 0 0 0 229 116.1C492 353.1 548.4 292 616.2 292c32 0 60.8 13.4 81.1 35 25.1-4.7 49.1-14.1 70.5-26.7-8.3 25.7-25.7 47.4-48.8 61.1 22.4-2.4 44-8.6 64-17.3-15.1 22.2-34 41.9-55.7 57.6z"
                }
            }
        ]
    })(props);
}
function AiFillUnlock(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M832 464H332V240c0-30.9 25.1-56 56-56h248c30.9 0 56 25.1 56 56v68c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-68c0-70.7-57.3-128-128-128H388c-70.7 0-128 57.3-128 128v224h-68c-17.7 0-32 14.3-32 32v384c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V496c0-17.7-14.3-32-32-32zM540 701v53c0 4.4-3.6 8-8 8h-40c-4.4 0-8-3.6-8-8v-53a48.01 48.01 0 1 1 56 0z"
                }
            }
        ]
    })(props);
}
function AiFillUpCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm178 555h-46.9c-10.2 0-19.9-4.9-25.9-13.2L512 460.4 406.8 605.8c-6 8.3-15.6 13.2-25.9 13.2H334c-6.5 0-10.3-7.4-6.5-12.7l178-246c3.2-4.4 9.7-4.4 12.9 0l178 246c3.9 5.3.1 12.7-6.4 12.7z"
                }
            }
        ]
    })(props);
}
function AiFillUpSquare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM690 624h-46.9c-10.2 0-19.9-4.9-25.9-13.2L512 465.4 406.8 610.8c-6 8.3-15.6 13.2-25.9 13.2H334c-6.5 0-10.3-7.4-6.5-12.7l178-246c3.2-4.4 9.7-4.4 12.9 0l178 246c3.9 5.3.1 12.7-6.4 12.7z"
                }
            }
        ]
    })(props);
}
function AiFillUsb(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M408 312h48c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8zm352 120V144c0-17.7-14.3-32-32-32H296c-17.7 0-32 14.3-32 32v288c-66.2 0-120 52.1-120 116v356c0 4.4 3.6 8 8 8h720c4.4 0 8-3.6 8-8V548c0-63.9-53.8-116-120-116zm-72 0H336V184h352v248zM568 312h48c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8z"
                }
            }
        ]
    })(props);
}
function AiFillVideoCamera(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M912 302.3L784 376V224c0-35.3-28.7-64-64-64H128c-35.3 0-64 28.7-64 64v576c0 35.3 28.7 64 64 64h592c35.3 0 64-28.7 64-64V648l128 73.7c21.3 12.3 48-3.1 48-27.6V330c0-24.6-26.7-40-48-27.7zM328 352c0 4.4-3.6 8-8 8H208c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h112c4.4 0 8 3.6 8 8v48zm560 273l-104-59.8V458.9L888 399v226z"
                }
            }
        ]
    })(props);
}
function AiFillWallet(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-32 464H528V448h320v128zm-268-64a40 40 0 1 0 80 0 40 40 0 1 0-80 0z"
                }
            }
        ]
    })(props);
}
function AiFillWarning(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M955.7 856l-416-720c-6.2-10.7-16.9-16-27.7-16s-21.6 5.3-27.7 16l-416 720C56 877.4 71.4 904 96 904h832c24.6 0 40-26.6 27.7-48zM480 416c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v184c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V416zm32 352a48.01 48.01 0 0 1 0-96 48.01 48.01 0 0 1 0 96z"
                }
            }
        ]
    })(props);
}
function AiFillWechat(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M690.1 377.4c5.9 0 11.8.2 17.6.5-24.4-128.7-158.3-227.1-319.9-227.1C209 150.8 64 271.4 64 420.2c0 81.1 43.6 154.2 111.9 203.6a21.5 21.5 0 0 1 9.1 17.6c0 2.4-.5 4.6-1.1 6.9-5.5 20.3-14.2 52.8-14.6 54.3-.7 2.6-1.7 5.2-1.7 7.9 0 5.9 4.8 10.8 10.8 10.8 2.3 0 4.2-.9 6.2-2l70.9-40.9c5.3-3.1 11-5 17.2-5 3.2 0 6.4.5 9.5 1.4 33.1 9.5 68.8 14.8 105.7 14.8 6 0 11.9-.1 17.8-.4-7.1-21-10.9-43.1-10.9-66 0-135.8 132.2-245.8 295.3-245.8zm-194.3-86.5c23.8 0 43.2 19.3 43.2 43.1s-19.3 43.1-43.2 43.1c-23.8 0-43.2-19.3-43.2-43.1s19.4-43.1 43.2-43.1zm-215.9 86.2c-23.8 0-43.2-19.3-43.2-43.1s19.3-43.1 43.2-43.1 43.2 19.3 43.2 43.1-19.4 43.1-43.2 43.1zm586.8 415.6c56.9-41.2 93.2-102 93.2-169.7 0-124-120.8-224.5-269.9-224.5-149 0-269.9 100.5-269.9 224.5S540.9 847.5 690 847.5c30.8 0 60.6-4.4 88.1-12.3 2.6-.8 5.2-1.2 7.9-1.2 5.2 0 9.9 1.6 14.3 4.1l59.1 34c1.7 1 3.3 1.7 5.2 1.7a9 9 0 0 0 6.4-2.6 9 9 0 0 0 2.6-6.4c0-2.2-.9-4.4-1.4-6.6-.3-1.2-7.6-28.3-12.2-45.3-.5-1.9-.9-3.8-.9-5.7.1-5.9 3.1-11.2 7.6-14.5zM600.2 587.2c-19.9 0-36-16.1-36-35.9 0-19.8 16.1-35.9 36-35.9s36 16.1 36 35.9c0 19.8-16.2 35.9-36 35.9zm179.9 0c-19.9 0-36-16.1-36-35.9 0-19.8 16.1-35.9 36-35.9s36 16.1 36 35.9a36.08 36.08 0 0 1-36 35.9z"
                }
            }
        ]
    })(props);
}
function AiFillWeiboCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm-44.4 672C353.1 736 236 680.4 236 588.9c0-47.8 30.2-103.1 82.3-155.3 69.5-69.6 150.6-101.4 181.1-70.8 13.5 13.5 14.8 36.8 6.1 64.6-4.5 14 13.1 6.3 13.1 6.3 56.2-23.6 105.2-25 123.1.7 9.6 13.7 8.6 32.8-.2 55.1-4.1 10.2 1.3 11.8 9 14.1 31.7 9.8 66.9 33.6 66.9 75.5.2 69.5-99.7 156.9-249.8 156.9zm207.3-290.8a34.9 34.9 0 0 0-7.2-34.1 34.68 34.68 0 0 0-33.1-10.7 18.24 18.24 0 0 1-7.6-35.7c24.1-5.1 50.1 2.3 67.7 21.9 17.7 19.6 22.4 46.3 14.9 69.8a18.13 18.13 0 0 1-22.9 11.7 18.18 18.18 0 0 1-11.8-22.9zm106 34.3s0 .1 0 0a21.1 21.1 0 0 1-26.6 13.7 21.19 21.19 0 0 1-13.6-26.7c11-34.2 4-73.2-21.7-101.8a104.04 104.04 0 0 0-98.9-32.1 21.14 21.14 0 0 1-25.1-16.3 21.07 21.07 0 0 1 16.2-25.1c49.4-10.5 102.8 4.8 139.1 45.1 36.3 40.2 46.1 95.1 30.6 143.2zm-334.5 6.1c-91.4 9-160.7 65.1-154.7 125.2 5.9 60.1 84.8 101.5 176.2 92.5 91.4-9.1 160.7-65.1 154.7-125.3-5.9-60.1-84.8-101.5-176.2-92.4zm80.2 141.7c-18.7 42.3-72.3 64.8-117.8 50.1-43.9-14.2-62.5-57.7-43.3-96.8 18.9-38.4 68-60.1 111.5-48.8 45 11.7 68 54.2 49.6 95.5zm-93-32.2c-14.2-5.9-32.4.2-41.2 13.9-8.8 13.8-4.7 30.2 9.3 36.6 14.3 6.5 33.2.3 42-13.8 8.8-14.3 4.2-30.6-10.1-36.7zm34.9-14.5c-5.4-2.2-12.2.5-15.4 5.8-3.1 5.4-1.4 11.5 4.1 13.8 5.5 2.3 12.6-.3 15.8-5.8 3-5.6 1-11.8-4.5-13.8z"
                }
            }
        ]
    })(props);
}
function AiFillWeiboSquare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M433.6 595.1c-14.2-5.9-32.4.2-41.2 13.9-8.8 13.8-4.7 30.2 9.3 36.6 14.3 6.5 33.2.3 42-13.8 8.8-14.3 4.2-30.6-10.1-36.7zM880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM467.6 736C353.1 736 236 680.4 236 588.9c0-47.8 30.2-103.1 82.3-155.3 69.5-69.6 150.6-101.4 181.1-70.8 13.5 13.5 14.8 36.8 6.1 64.6-4.5 14 13.1 6.3 13.1 6.3 56.2-23.6 105.2-25 123.1.7 9.6 13.7 8.6 32.8-.2 55.1-4.1 10.2 1.3 11.8 9 14.1 31.7 9.8 66.9 33.6 66.9 75.5.2 69.5-99.7 156.9-249.8 156.9zm207.3-290.8a34.9 34.9 0 0 0-7.2-34.1 34.68 34.68 0 0 0-33.1-10.7 18.24 18.24 0 0 1-7.6-35.7c24.1-5.1 50.1 2.3 67.7 21.9 17.7 19.6 22.4 46.3 14.9 69.8a18.13 18.13 0 0 1-22.9 11.7 18.18 18.18 0 0 1-11.8-22.9zm106 34.3s0 .1 0 0a21.1 21.1 0 0 1-26.6 13.7 21.19 21.19 0 0 1-13.6-26.7c11-34.2 4-73.2-21.7-101.8a104.04 104.04 0 0 0-98.9-32.1 21.14 21.14 0 0 1-25.1-16.3 21.07 21.07 0 0 1 16.2-25.1c49.4-10.5 102.8 4.8 139.1 45.1 36.3 40.2 46.1 95.1 30.6 143.2zm-334.5 6.1c-91.4 9-160.7 65.1-154.7 125.2 5.9 60.1 84.8 101.5 176.2 92.5 91.4-9.1 160.7-65.1 154.7-125.3-5.9-60.1-84.8-101.5-176.2-92.4zm80.2 141.7c-18.7 42.3-72.3 64.8-117.8 50.1-43.9-14.2-62.5-57.7-43.3-96.8 18.9-38.4 68-60.1 111.5-48.8 45 11.7 68 54.2 49.6 95.5zm-58.1-46.7c-5.4-2.2-12.2.5-15.4 5.8-3.1 5.4-1.4 11.5 4.1 13.8 5.5 2.3 12.6-.3 15.8-5.8 3-5.6 1-11.8-4.5-13.8z"
                }
            }
        ]
    })(props);
}
function AiFillWindows(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M523.8 191.4v288.9h382V128.1zm0 642.2l382 62.2v-352h-382zM120.1 480.2H443V201.9l-322.9 53.5zm0 290.4L443 823.2V543.8H120.1z"
                }
            }
        ]
    })(props);
}
function AiFillYahoo(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M937.3 231H824.7c-15.5 0-27.7 12.6-27.1 28.1l13.1 366h84.4l65.4-366.4c2.7-15.2-7.8-27.7-23.2-27.7zm-77.4 450.4h-14.1c-27.1 0-49.2 22.2-49.2 49.3v14.1c0 27.1 22.2 49.3 49.2 49.3h14.1c27.1 0 49.2-22.2 49.2-49.3v-14.1c0-27.1-22.2-49.3-49.2-49.3zM402.6 231C216.2 231 65 357 65 512.5S216.2 794 402.6 794s337.6-126 337.6-281.5S589.1 231 402.6 231zm225.2 225.2h-65.3L458.9 559.8v65.3h84.4v56.3H318.2v-56.3h84.4v-65.3L242.9 399.9h-37v-56.3h168.5v56.3h-37l93.4 93.5 28.1-28.1V400h168.8v56.2z"
                }
            }
        ]
    })(props);
}
function AiFillYoutube(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M941.3 296.1a112.3 112.3 0 0 0-79.2-79.3C792.2 198 512 198 512 198s-280.2 0-350.1 18.7A112.12 112.12 0 0 0 82.7 296C64 366 64 512 64 512s0 146 18.7 215.9c10.3 38.6 40.7 69 79.2 79.3C231.8 826 512 826 512 826s280.2 0 350.1-18.8c38.6-10.3 68.9-40.7 79.2-79.3C960 658 960 512 960 512s0-146-18.7-215.9zM423 646V378l232 133-232 135z"
                }
            }
        ]
    })(props);
}
function AiFillYuque(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M854.6 370.6c-9.9-39.4 9.9-102.2 73.4-124.4l-67.9-3.6s-25.7-90-143.6-98c-117.9-8.1-195-3-195-3s87.4 55.6 52.4 154.7c-25.6 52.5-65.8 95.6-108.8 144.7-1.3 1.3-2.5 2.6-3.5 3.7C319.4 605 96 860 96 860c245.9 64.4 410.7-6.3 508.2-91.1 20.5-.2 35.9-.3 46.3-.3 135.8 0 250.6-117.6 245.9-248.4-3.2-89.9-31.9-110.2-41.8-149.6z"
                }
            }
        ]
    })(props);
}
function AiFillZhihuCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm-90.7 477.8l-.1 1.5c-1.5 20.4-6.3 43.9-12.9 67.6l24-18.1 71 80.7c9.2 33-3.3 63.1-3.3 63.1l-95.7-111.9v-.1c-8.9 29-20.1 57.3-33.3 84.7-22.6 45.7-55.2 54.7-89.5 57.7-34.4 3-23.3-5.3-23.3-5.3 68-55.5 78-87.8 96.8-123.1 11.9-22.3 20.4-64.3 25.3-96.8H264.1s4.8-31.2 19.2-41.7h101.6c.6-15.3-1.3-102.8-2-131.4h-49.4c-9.2 45-41 56.7-48.1 60.1-7 3.4-23.6 7.1-21.1 0 2.6-7.1 27-46.2 43.2-110.7 16.3-64.6 63.9-62 63.9-62-12.8 22.5-22.4 73.6-22.4 73.6h159.7c10.1 0 10.6 39 10.6 39h-90.8c-.7 22.7-2.8 83.8-5 131.4H519s12.2 15.4 12.2 41.7H421.3zm346.5 167h-87.6l-69.5 46.6-16.4-46.6h-40.1V321.5h213.6v387.3zM408.2 611s0-.1 0 0zm216 94.3l56.8-38.1h45.6-.1V364.7H596.7v302.5h14.1z"
                }
            }
        ]
    })(props);
}
function AiFillZhihuSquare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM432.3 592.8l71 80.7c9.2 33-3.3 63.1-3.3 63.1l-95.7-111.9v-.1c-8.9 29-20.1 57.3-33.3 84.7-22.6 45.7-55.2 54.7-89.5 57.7-34.4 3-23.3-5.3-23.3-5.3 68-55.5 78-87.8 96.8-123.1 11.9-22.3 20.4-64.3 25.3-96.8H264.1s4.8-31.2 19.2-41.7h101.6c.6-15.3-1.3-102.8-2-131.4h-49.4c-9.2 45-41 56.7-48.1 60.1-7 3.4-23.6 7.1-21.1 0 2.6-7.1 27-46.2 43.2-110.7 16.3-64.6 63.9-62 63.9-62-12.8 22.5-22.4 73.6-22.4 73.6h159.7c10.1 0 10.6 39 10.6 39h-90.8c-.7 22.7-2.8 83.8-5 131.4H519s12.2 15.4 12.2 41.7h-110l-.1 1.5c-1.5 20.4-6.3 43.9-12.9 67.6l24.1-18.1zm335.5 116h-87.6l-69.5 46.6-16.4-46.6h-40.1V321.5h213.6v387.3zM408.2 611s0-.1 0 0zm216 94.3l56.8-38.1h45.6-.1V364.7H596.7v302.5h14.1z"
                }
            }
        ]
    })(props);
}
function AiOutlineAccountBook(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M880 184H712v-64c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v64H384v-64c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v64H144c-17.7 0-32 14.3-32 32v664c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V216c0-17.7-14.3-32-32-32zm-40 656H184V256h128v48c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-48h256v48c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-48h128v584zM639.5 414h-45c-3 0-5.8 1.7-7.1 4.4L514 563.8h-2.8l-73.4-145.4a8 8 0 0 0-7.1-4.4h-46c-1.3 0-2.7.3-3.8 1-3.9 2.1-5.3 7-3.2 10.9l89.3 164h-48.6c-4.4 0-8 3.6-8 8v21.3c0 4.4 3.6 8 8 8h65.1v33.7h-65.1c-4.4 0-8 3.6-8 8v21.3c0 4.4 3.6 8 8 8h65.1V752c0 4.4 3.6 8 8 8h41.3c4.4 0 8-3.6 8-8v-53.8h65.4c4.4 0 8-3.6 8-8v-21.3c0-4.4-3.6-8-8-8h-65.4v-33.7h65.4c4.4 0 8-3.6 8-8v-21.3c0-4.4-3.6-8-8-8h-49.1l89.3-164.1c.6-1.2 1-2.5 1-3.8.1-4.4-3.4-8-7.9-8z"
                }
            }
        ]
    })(props);
}
function AiOutlineAim(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "t": "1569683657482",
            "viewBox": "0 0 1024 1024",
            "version": "1.1"
        },
        "child": [
            {
                "tag": "defs",
                "attr": {},
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M952 474H829.8C812.5 327.6 696.4 211.5 550 194.2V72c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8v122.2C327.6 211.5 211.5 327.6 194.2 474H72c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h122.2C211.5 696.4 327.6 812.5 474 829.8V952c0 4.4 3.6 8 8 8h60c4.4 0 8-3.6 8-8V829.8C696.4 812.5 812.5 696.4 829.8 550H952c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8zM512 756c-134.8 0-244-109.2-244-244s109.2-244 244-244 244 109.2 244 244-109.2 244-244 244z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M512 392c-32.1 0-62.1 12.4-84.8 35.2-22.7 22.7-35.2 52.7-35.2 84.8s12.5 62.1 35.2 84.8C449.9 619.4 480 632 512 632s62.1-12.5 84.8-35.2C619.4 574.1 632 544 632 512s-12.5-62.1-35.2-84.8C574.1 404.4 544.1 392 512 392z"
                }
            }
        ]
    })(props);
}
function AiOutlineAlert(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M193 796c0 17.7 14.3 32 32 32h574c17.7 0 32-14.3 32-32V563c0-176.2-142.8-319-319-319S193 386.8 193 563v233zm72-233c0-136.4 110.6-247 247-247s247 110.6 247 247v193H404V585c0-5.5-4.5-10-10-10h-44c-5.5 0-10 4.5-10 10v171h-75V563zm-48.1-252.5l39.6-39.6c3.1-3.1 3.1-8.2 0-11.3l-67.9-67.9a8.03 8.03 0 0 0-11.3 0l-39.6 39.6a8.03 8.03 0 0 0 0 11.3l67.9 67.9c3.1 3.1 8.1 3.1 11.3 0zm669.6-79.2l-39.6-39.6a8.03 8.03 0 0 0-11.3 0l-67.9 67.9a8.03 8.03 0 0 0 0 11.3l39.6 39.6c3.1 3.1 8.2 3.1 11.3 0l67.9-67.9c3.1-3.2 3.1-8.2 0-11.3zM832 892H192c-17.7 0-32 14.3-32 32v24c0 4.4 3.6 8 8 8h688c4.4 0 8-3.6 8-8v-24c0-17.7-14.3-32-32-32zM484 180h56c4.4 0 8-3.6 8-8V76c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v96c0 4.4 3.6 8 8 8z"
                }
            }
        ]
    })(props);
}
function AiOutlineAlibaba(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M602.9 669.8c-37.2 2.6-33.6-17.3-11.5-46.2 50.4-67.2 143.7-158.5 147.9-225.2 5.8-86.6-81.3-113.4-171-113.4-62.4 1.6-127 18.9-171 34.6-151.6 53.5-246.6 137.5-306.9 232-62.4 93.4-43 183.2 91.8 185.8 101.8-4.2 170.5-32.5 239.7-68.2.5 0-192.5 55.1-263.9 14.7-7.9-4.2-15.7-10-17.8-26.2 0-33.1 54.6-67.7 86.6-78.7v-56.7c64.5 22.6 140.6 16.3 205.7-32 2.1 5.8 4.2 13.1 3.7 21h11c2.6-22.6-12.6-44.6-37.8-46.2 7.3 5.8 12.6 10.5 15.2 14.7l-1 1-.5.5c-83.9 58.8-165.3 31.5-173.1 29.9l46.7-45.7-13.1-33.1c92.9-32.5 169.5-56.2 296.9-78.7l-28.5-23 14.7-8.9c75.5 21 126.4 36.7 123.8 76.6-1 6.8-3.7 14.7-7.9 23.1C660.1 466.1 594 538 567.2 569c-17.3 20.5-34.6 39.4-46.7 58.3-13.6 19.4-20.5 37.3-21 53.5 2.6 131.8 391.4-61.9 468-112.9-111.7 47.8-232.9 93.5-364.6 101.9zm85-302.9c2.8 5.2 4.1 11.6 4.1 19.1-.1-6.8-1.4-13.3-4.1-19.1z"
                }
            }
        ]
    })(props);
}
function AiOutlineAlignCenter(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M264 230h496c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H264c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm496 424c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H264c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h496zm144 140H120c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-424H120c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8z"
                }
            }
        ]
    })(props);
}
function AiOutlineAlignLeft(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M120 230h496c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H120c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm0 424h496c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H120c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm784 140H120c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-424H120c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8z"
                }
            }
        ]
    })(props);
}
function AiOutlineAlignRight(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M904 158H408c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h496c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 424H408c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h496c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 212H120c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-424H120c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8z"
                }
            }
        ]
    })(props);
}
function AiOutlineAlipayCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M308.6 545.7c-19.8 2-57.1 10.7-77.4 28.6-61 53-24.5 150 99 150 71.8 0 143.5-45.7 199.8-119-80.2-38.9-148.1-66.8-221.4-59.6zm460.5 67c100.1 33.4 154.7 43 166.7 44.8A445.9 445.9 0 0 0 960 512c0-247.4-200.6-448-448-448S64 264.6 64 512s200.6 448 448 448c155.9 0 293.2-79.7 373.5-200.5-75.6-29.8-213.6-85-286.8-120.1-69.9 85.7-160.1 137.8-253.7 137.8-158.4 0-212.1-138.1-137.2-229 16.3-19.8 44.2-38.7 87.3-49.4 67.5-16.5 175 10.3 275.7 43.4 18.1-33.3 33.4-69.9 44.7-108.9H305.1V402h160v-56.2H271.3v-31.3h193.8v-80.1s0-13.5 13.7-13.5H557v93.6h191.7v31.3H557.1V402h156.4c-15 61.1-37.7 117.4-66.2 166.8 47.5 17.1 90.1 33.3 121.8 43.9z"
                }
            }
        ]
    })(props);
}
function AiOutlineAlipay(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M789 610.3c-38.7-12.9-90.7-32.7-148.5-53.6 34.8-60.3 62.5-129 80.7-203.6H530.5v-68.6h233.6v-38.3H530.5V132h-95.4c-16.7 0-16.7 16.5-16.7 16.5v97.8H182.2v38.3h236.3v68.6H223.4v38.3h378.4a667.18 667.18 0 0 1-54.5 132.9c-122.8-40.4-253.8-73.2-336.1-53-52.6 13-86.5 36.1-106.5 60.3-91.4 111-25.9 279.6 167.2 279.6C386 811.2 496 747.6 581.2 643 708.3 704 960 808.7 960 808.7V659.4s-31.6-2.5-171-49.1zM253.9 746.6c-150.5 0-195-118.3-120.6-183.1 24.8-21.9 70.2-32.6 94.4-35 89.4-8.8 172.2 25.2 269.9 72.8-68.8 89.5-156.3 145.3-243.7 145.3z"
                }
            }
        ]
    })(props);
}
function AiOutlineAliwangwang(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M868.2 377.4c-18.9-45.1-46.3-85.6-81.2-120.6a377.26 377.26 0 0 0-120.5-81.2A375.65 375.65 0 0 0 519 145.8c-41.9 0-82.9 6.7-121.9 20C306 123.3 200.8 120 170.6 120c-2.2 0-7.4 0-9.4.2-11.9.4-22.8 6.5-29.2 16.4-6.5 9.9-7.7 22.4-3.4 33.5l64.3 161.6a378.59 378.59 0 0 0-52.8 193.2c0 51.4 10 101 29.8 147.6 18.9 45 46.2 85.6 81.2 120.5 34.7 34.8 75.4 62.1 120.5 81.2C418.3 894 467.9 904 519 904c51.3 0 100.9-10.1 147.7-29.8 44.9-18.9 85.5-46.3 120.4-81.2 34.7-34.8 62.1-75.4 81.2-120.6a376.5 376.5 0 0 0 29.8-147.6c-.2-51.2-10.1-100.8-29.9-147.4zm-66.4 266.5a307.08 307.08 0 0 1-65.9 98c-28.4 28.5-61.3 50.7-97.7 65.9h-.1c-38 16-78.3 24.2-119.9 24.2a306.51 306.51 0 0 1-217.5-90.2c-28.4-28.5-50.6-61.4-65.8-97.8v-.1c-16-37.8-24.1-78.2-24.1-119.9 0-55.4 14.8-109.7 42.8-157l13.2-22.1-9.5-23.9L206 192c14.9.6 35.9 2.1 59.7 5.6 43.8 6.5 82.5 17.5 114.9 32.6l19 8.9 19.9-6.8c31.5-10.8 64.8-16.2 98.9-16.2a306.51 306.51 0 0 1 217.5 90.2c28.4 28.5 50.6 61.4 65.8 97.8l.1.1.1.1c16 37.6 24.1 78 24.2 119.8-.1 41.7-8.3 82-24.3 119.8zM681.1 364.2c-20.4 0-37.1 16.7-37.1 37.1v55.1c0 20.4 16.6 37.1 37.1 37.1s37.1-16.7 37.1-37.1v-55.1c0-20.5-16.7-37.1-37.1-37.1zm-175.2 0c-20.5 0-37.1 16.7-37.1 37.1v55.1c0 20.4 16.7 37.1 37.1 37.1 20.5 0 37.1-16.7 37.1-37.1v-55.1c0-20.5-16.7-37.1-37.1-37.1z"
                }
            }
        ]
    })(props);
}
function AiOutlineAliyun(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M959.2 383.9c-.3-82.1-66.9-148.6-149.1-148.6H575.9l21.6 85.2 201 43.7a42.58 42.58 0 0 1 32.9 39.7c.1.5.1 216.1 0 216.6a42.58 42.58 0 0 1-32.9 39.7l-201 43.7-21.6 85.3h234.2c82.1 0 148.8-66.5 149.1-148.6V383.9zM225.5 660.4a42.58 42.58 0 0 1-32.9-39.7c-.1-.6-.1-216.1 0-216.6.8-19.4 14.6-35.5 32.9-39.7l201-43.7 21.6-85.2H213.8c-82.1 0-148.8 66.4-149.1 148.6V641c.3 82.1 67 148.6 149.1 148.6H448l-21.6-85.3-200.9-43.9zm200.9-158.8h171v21.3h-171z"
                }
            }
        ]
    })(props);
}
function AiOutlineAmazon(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M825 768.9c-3.3-.9-7.3-.4-11.9 1.3-61.6 28.2-121.5 48.3-179.7 60.2C507.7 856 385.2 842.6 266 790.3c-33.1-14.6-79.1-39.2-138-74a9.36 9.36 0 0 0-5.3-2c-2-.1-3.7.1-5.3.9-1.6.8-2.8 1.8-3.7 3.1-.9 1.3-1.1 3.1-.4 5.4.6 2.2 2.1 4.7 4.6 7.4 10.4 12.2 23.3 25.2 38.6 39s35.6 29.4 60.9 46.8c25.3 17.4 51.8 32.9 79.3 46.4 27.6 13.5 59.6 24.9 96.1 34.1s73 13.8 109.4 13.8c36.2 0 71.4-3.7 105.5-10.9 34.2-7.3 63-15.9 86.5-25.9 23.4-9.9 45-21 64.8-33 19.8-12 34.4-22.2 43.9-30.3 9.5-8.2 16.3-14.6 20.2-19.4 4.6-5.7 6.9-10.6 6.9-14.9.1-4.5-1.7-7.1-5-7.9zM527.4 348.1c-15.2 1.3-33.5 4.1-55 8.3-21.5 4.1-41.4 9.3-59.8 15.4s-37.2 14.6-56.3 25.4c-19.2 10.8-35.5 23.2-49 37s-24.5 31.1-33.1 52c-8.6 20.8-12.9 43.7-12.9 68.7 0 27.1 4.7 51.2 14.3 72.5 9.5 21.3 22.2 38 38.2 50.4 15.9 12.4 34 22.1 54 29.2 20 7.1 41.2 10.3 63.2 9.4 22-.9 43.5-4.3 64.4-10.3 20.8-5.9 40.4-15.4 58.6-28.3 18.2-12.9 33.1-28.2 44.8-45.7 4.3 6.6 8.1 11.5 11.5 14.7l8.7 8.9c5.8 5.9 14.7 14.6 26.7 26.1 11.9 11.5 24.1 22.7 36.3 33.7l104.4-99.9-6-4.9c-4.3-3.3-9.4-8-15.2-14.3-5.8-6.2-11.6-13.1-17.2-20.5-5.7-7.4-10.6-16.1-14.7-25.9-4.1-9.8-6.2-19.3-6.2-28.5V258.7c0-10.1-1.9-21-5.7-32.8-3.9-11.7-10.7-24.5-20.7-38.3-10-13.8-22.4-26.2-37.2-37-14.9-10.8-34.7-20-59.6-27.4-24.8-7.4-52.6-11.1-83.2-11.1-31.3 0-60.4 3.7-87.6 10.9-27.1 7.3-50.3 17-69.7 29.2-19.3 12.2-35.9 26.3-49.7 42.4-13.8 16.1-24.1 32.9-30.8 50.4-6.7 17.5-10.1 35.2-10.1 53.1L408 310c5.5-16.4 12.9-30.6 22-42.8 9.2-12.2 17.9-21 25.8-26.5 8-5.5 16.6-9.9 25.7-13.2 9.2-3.3 15.4-5 18.6-5.4 3.2-.3 5.7-.4 7.6-.4 26.7 0 45.2 7.9 55.6 23.6 6.5 9.5 9.7 23.9 9.7 43.3v56.6c-15.2.6-30.4 1.6-45.6 2.9zM573.1 500c0 16.6-2.2 31.7-6.5 45-9.2 29.1-26.7 47.4-52.4 54.8-22.4 6.6-43.7 3.3-63.9-9.8-21.5-14-32.2-33.8-32.2-59.3 0-19.9 5-36.9 15-51.1 10-14.1 23.3-24.7 40-31.7s33-12 49-14.9c15.9-3 33-4.8 51-5.4V500zm335.2 218.9c-4.3-5.4-15.9-8.9-34.9-10.7-19-1.8-35.5-1.7-49.7.4-15.3 1.8-31.1 6.2-47.3 13.4-16.3 7.1-23.4 13.1-21.6 17.8l.7 1.3.9.7 1.4.2h4.6c.8 0 1.8-.1 3.2-.2 1.4-.1 2.7-.3 3.9-.4 1.2-.1 2.9-.3 5.1-.4 2.1-.1 4.1-.4 6-.7.3 0 3.7-.3 10.3-.9 6.6-.6 11.4-1 14.3-1.3 2.9-.3 7.8-.6 14.5-.9 6.7-.3 12.1-.3 16.1 0 4 .3 8.5.7 13.6 1.1 5.1.4 9.2 1.3 12.4 2.7 3.2 1.3 5.6 3 7.1 5.1 5.2 6.6 4.2 21.2-3 43.9s-14 40.8-20.4 54.2c-2.8 5.7-2.8 9.2 0 10.7s6.7.1 11.9-4c15.6-12.2 28.6-30.6 39.1-55.3 6.1-14.6 10.5-29.8 13.1-45.7 2.4-15.9 2-26.2-1.3-31z"
                }
            }
        ]
    })(props);
}
function AiOutlineAndroid(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M448.3 225.2c-18.6 0-32 13.4-32 31.9s13.5 31.9 32 31.9c18.6 0 32-13.4 32-31.9.1-18.4-13.4-31.9-32-31.9zm393.9 96.4c-13.8-13.8-32.7-21.5-53.2-21.5-3.9 0-7.4.4-10.7 1v-1h-3.6c-5.5-30.6-18.6-60.5-38.1-87.4-18.7-25.7-43-47.9-70.8-64.9l25.1-35.8v-3.3c0-.8.4-2.3.7-3.8.6-2.4 1.4-5.5 1.4-8.9 0-18.5-13.5-31.9-32-31.9-9.8 0-19.5 5.7-25.9 15.4l-29.3 42.1c-30-9.8-62.4-15-93.8-15-31.3 0-63.7 5.2-93.8 15L389 79.4c-6.6-9.6-16.1-15.4-26-15.4-18.6 0-32 13.4-32 31.9 0 6.2 2.5 12.8 6.7 17.4l22.6 32.3c-28.7 17-53.5 39.4-72.2 65.1-19.4 26.9-32 56.8-36.7 87.4h-5.5v1c-3.2-.6-6.7-1-10.7-1-20.3 0-39.2 7.5-53.1 21.3-13.8 13.8-21.5 32.6-21.5 53v235c0 20.3 7.5 39.1 21.4 52.9 13.8 13.8 32.8 21.5 53.2 21.5 3.9 0 7.4-.4 10.7-1v93.5c0 29.2 23.9 53.1 53.2 53.1H331v58.3c0 20.3 7.5 39.1 21.4 52.9 13.8 13.8 32.8 21.5 53.2 21.5 20.3 0 39.2-7.5 53.1-21.3 13.8-13.8 21.5-32.6 21.5-53v-58.2H544v58.1c0 20.3 7.5 39.1 21.4 52.9 13.8 13.8 32.8 21.5 53.2 21.5 20.4 0 39.2-7.5 53.1-21.6 13.8-13.8 21.5-32.6 21.5-53v-58.2h31.9c29.3 0 53.2-23.8 53.2-53.1v-91.4c3.2.6 6.7 1 10.7 1 20.3 0 39.2-7.5 53.1-21.3 13.8-13.8 21.5-32.6 21.5-53v-235c-.1-20.3-7.6-39-21.4-52.9zM246 609.6c0 6.8-3.9 10.6-10.7 10.6-6.8 0-10.7-3.8-10.7-10.6V374.5c0-6.8 3.9-10.6 10.7-10.6 6.8 0 10.7 3.8 10.7 10.6v235.1zm131.1-396.8c37.5-27.3 85.3-42.3 135-42.3s97.5 15.1 135 42.5c32.4 23.7 54.2 54.2 62.7 87.5H314.4c8.5-33.4 30.5-64 62.7-87.7zm39.3 674.7c-.6 5.6-4.4 8.7-10.5 8.7-6.8 0-10.7-3.8-10.7-10.6v-58.2h21.2v60.1zm202.3 8.7c-6.8 0-10.7-3.8-10.7-10.6v-58.2h21.2v60.1c-.6 5.6-4.3 8.7-10.5 8.7zm95.8-132.6H309.9V364h404.6v399.6zm85.2-154c0 6.8-3.9 10.6-10.7 10.6-6.8 0-10.7-3.8-10.7-10.6V374.5c0-6.8 3.9-10.6 10.7-10.6 6.8 0 10.7 3.8 10.7 10.6v235.1zM576.1 225.2c-18.6 0-32 13.4-32 31.9s13.5 31.9 32 31.9c18.6 0 32.1-13.4 32.1-32-.1-18.6-13.4-31.8-32.1-31.8z"
                }
            }
        ]
    })(props);
}
function AiOutlineAntCloud(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M378.9 738c-3.1 0-6.1-.5-8.8-1.5l4.4 30.7h26.3l-15.5-29.9c-2.1.5-4.2.7-6.4.7zm421-291.2c-12.6 0-24.8 1.5-36.5 4.2-21.4-38.4-62.3-64.3-109.3-64.3-6.9 0-13.6.6-20.2 1.6-35.4-77.4-113.4-131.1-203.9-131.1-112.3 0-205.3 82.6-221.6 190.4C127.3 455.5 64 523.8 64 607c0 88.4 71.6 160.1 160 160.2h50l13.2-27.6c-26.2-8.3-43.3-29-39.1-48.8 4.6-21.6 32.8-33.9 63.1-27.5 22.9 4.9 40.4 19.1 45.5 35.1a26.1 26.1 0 0 1 22.1-12.4h.2c-.8-3.2-1.2-6.5-1.2-9.9 0-20.1 14.8-36.7 34.1-39.6v-25.4c0-4.4 3.6-8 8-8s8 3.6 8 8v26.3c4.6 1.2 8.8 3.2 12.6 5.8l19.5-21.4c3-3.3 8-3.5 11.3-.5 3.3 3 3.5 8 .5 11.3l-20 22-.2.2a40 40 0 0 1-46.9 59.2c-.4 5.6-2.6 10.7-6 14.8l20 38.4H804v-.1c86.5-2.2 156-73 156-160.1 0-88.5-71.7-160.2-160.1-160.2zM338.2 737.2l-4.3 30h24.4l-5.9-41.5c-3.5 4.6-8.3 8.5-14.2 11.5zM797.5 305a48 48 0 1 0 96 0 48 48 0 1 0-96 0zm-65.7 61.3a24 24 0 1 0 48 0 24 24 0 1 0-48 0zM303.4 742.9l-11.6 24.3h26l3.5-24.7c-5.7.8-11.7 1-17.9.4z"
                }
            }
        ]
    })(props);
}
function AiOutlineAntDesign(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M716.3 313.8c19-18.9 19-49.7 0-68.6l-69.9-69.9.1.1c-18.5-18.5-50.3-50.3-95.3-95.2-21.2-20.7-55.5-20.5-76.5.5L80.9 474.2a53.84 53.84 0 0 0 0 76.4L474.6 944a54.14 54.14 0 0 0 76.5 0l165.1-165c19-18.9 19-49.7 0-68.6a48.7 48.7 0 0 0-68.7 0l-125 125.2c-5.2 5.2-13.3 5.2-18.5 0L189.5 521.4c-5.2-5.2-5.2-13.3 0-18.5l314.4-314.2c.4-.4.9-.7 1.3-1.1 5.2-4.1 12.4-3.7 17.2 1.1l125.2 125.1c19 19 49.8 19 68.7 0zM408.6 514.4a106.3 106.2 0 1 0 212.6 0 106.3 106.2 0 1 0-212.6 0zm536.2-38.6L821.9 353.5c-19-18.9-49.8-18.9-68.7.1a48.4 48.4 0 0 0 0 68.6l83 82.9c5.2 5.2 5.2 13.3 0 18.5l-81.8 81.7a48.4 48.4 0 0 0 0 68.6 48.7 48.7 0 0 0 68.7 0l121.8-121.7a53.93 53.93 0 0 0-.1-76.4z"
                }
            }
        ]
    })(props);
}
function AiOutlineApartment(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M908 640H804V488c0-4.4-3.6-8-8-8H548v-96h108c8.8 0 16-7.2 16-16V80c0-8.8-7.2-16-16-16H368c-8.8 0-16 7.2-16 16v288c0 8.8 7.2 16 16 16h108v96H228c-4.4 0-8 3.6-8 8v152H116c-8.8 0-16 7.2-16 16v288c0 8.8 7.2 16 16 16h288c8.8 0 16-7.2 16-16V656c0-8.8-7.2-16-16-16H292v-88h440v88H620c-8.8 0-16 7.2-16 16v288c0 8.8 7.2 16 16 16h288c8.8 0 16-7.2 16-16V656c0-8.8-7.2-16-16-16zm-564 76v168H176V716h168zm84-408V140h168v168H428zm420 576H680V716h168v168z"
                }
            }
        ]
    })(props);
}
function AiOutlineApi(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M917.7 148.8l-42.4-42.4c-1.6-1.6-3.6-2.3-5.7-2.3s-4.1.8-5.7 2.3l-76.1 76.1a199.27 199.27 0 0 0-112.1-34.3c-51.2 0-102.4 19.5-141.5 58.6L432.3 308.7a8.03 8.03 0 0 0 0 11.3L704 591.7c1.6 1.6 3.6 2.3 5.7 2.3 2 0 4.1-.8 5.7-2.3l101.9-101.9c68.9-69 77-175.7 24.3-253.5l76.1-76.1c3.1-3.2 3.1-8.3 0-11.4zM769.1 441.7l-59.4 59.4-186.8-186.8 59.4-59.4c24.9-24.9 58.1-38.7 93.4-38.7 35.3 0 68.4 13.7 93.4 38.7 24.9 24.9 38.7 58.1 38.7 93.4 0 35.3-13.8 68.4-38.7 93.4zm-190.2 105a8.03 8.03 0 0 0-11.3 0L501 613.3 410.7 523l66.7-66.7c3.1-3.1 3.1-8.2 0-11.3L441 408.6a8.03 8.03 0 0 0-11.3 0L363 475.3l-43-43a7.85 7.85 0 0 0-5.7-2.3c-2 0-4.1.8-5.7 2.3L206.8 534.2c-68.9 69-77 175.7-24.3 253.5l-76.1 76.1a8.03 8.03 0 0 0 0 11.3l42.4 42.4c1.6 1.6 3.6 2.3 5.7 2.3s4.1-.8 5.7-2.3l76.1-76.1c33.7 22.9 72.9 34.3 112.1 34.3 51.2 0 102.4-19.5 141.5-58.6l101.9-101.9c3.1-3.1 3.1-8.2 0-11.3l-43-43 66.7-66.7c3.1-3.1 3.1-8.2 0-11.3l-36.6-36.2zM441.7 769.1a131.32 131.32 0 0 1-93.4 38.7c-35.3 0-68.4-13.7-93.4-38.7a131.32 131.32 0 0 1-38.7-93.4c0-35.3 13.7-68.4 38.7-93.4l59.4-59.4 186.8 186.8-59.4 59.4z"
                }
            }
        ]
    })(props);
}
function AiOutlineApple(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M747.4 535.7c-.4-68.2 30.5-119.6 92.9-157.5-34.9-50-87.7-77.5-157.3-82.8-65.9-5.2-138 38.4-164.4 38.4-27.9 0-91.7-36.6-141.9-36.6C273.1 298.8 163 379.8 163 544.6c0 48.7 8.9 99 26.7 150.8 23.8 68.2 109.6 235.3 199.1 232.6 46.8-1.1 79.9-33.2 140.8-33.2 59.1 0 89.7 33.2 141.9 33.2 90.3-1.3 167.9-153.2 190.5-221.6-121.1-57.1-114.6-167.2-114.6-170.7zm-10.6 267c-14.3 19.9-28.7 35.6-41.9 45.7-10.5 8-18.6 11.4-24 11.6-9-.1-17.7-2.3-34.7-8.8-1.2-.5-2.5-1-4.2-1.6l-4.4-1.7c-17.4-6.7-27.8-10.3-41.1-13.8-18.6-4.8-37.1-7.4-56.9-7.4-20.2 0-39.2 2.5-58.1 7.2-13.9 3.5-25.6 7.4-42.7 13.8-.7.3-8.1 3.1-10.2 3.9-3.5 1.3-6.2 2.3-8.7 3.2-10.4 3.6-17 5.1-22.9 5.2-.7 0-1.3-.1-1.8-.2-1.1-.2-2.5-.6-4.1-1.3-4.5-1.8-9.9-5.1-16-9.8-14-10.9-29.4-28-45.1-49.9-27.5-38.6-53.5-89.8-66-125.7-15.4-44.8-23-87.7-23-128.6 0-60.2 17.8-106 48.4-137.1 26.3-26.6 61.7-41.5 97.8-42.3 5.9.1 14.5 1.5 25.4 4.5 8.6 2.3 18 5.4 30.7 9.9 3.8 1.4 16.9 6.1 18.5 6.7 7.7 2.8 13.5 4.8 19.2 6.6 18.2 5.8 32.3 9 47.6 9 15.5 0 28.8-3.3 47.7-9.8 7.1-2.4 32.9-12 37.5-13.6 25.6-9.1 44.5-14 60.8-15.2 4.8-.4 9.1-.4 13.2-.1 22.7 1.8 42.1 6.3 58.6 13.8-37.6 43.4-57 96.5-56.9 158.4-.3 14.7.9 31.7 5.1 51.8 6.4 30.5 18.6 60.7 37.9 89 14.7 21.5 32.9 40.9 54.7 57.8-11.5 23.7-25.6 48.2-40.4 68.8zm-94.5-572c50.7-60.2 46.1-115 44.6-134.7-44.8 2.6-96.6 30.5-126.1 64.8-32.5 36.8-51.6 82.3-47.5 133.6 48.4 3.7 92.6-21.2 129-63.7z"
                }
            }
        ]
    })(props);
}
function AiOutlineAppstoreAdd(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "t": "1569683928793",
            "viewBox": "0 0 1024 1024",
            "version": "1.1"
        },
        "child": [
            {
                "tag": "defs",
                "attr": {},
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M464 144H160c-8.8 0-16 7.2-16 16v304c0 8.8 7.2 16 16 16h304c8.8 0 16-7.2 16-16V160c0-8.8-7.2-16-16-16z m-52 268H212V212h200v200zM864 144H560c-8.8 0-16 7.2-16 16v304c0 8.8 7.2 16 16 16h304c8.8 0 16-7.2 16-16V160c0-8.8-7.2-16-16-16z m-52 268H612V212h200v200zM864 544H560c-8.8 0-16 7.2-16 16v304c0 8.8 7.2 16 16 16h304c8.8 0 16-7.2 16-16V560c0-8.8-7.2-16-16-16z m-52 268H612V612h200v200zM424 712H296V584c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v128H104c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h128v128c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V776h128c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8z"
                }
            }
        ]
    })(props);
}
function AiOutlineAppstore(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M464 144H160c-8.8 0-16 7.2-16 16v304c0 8.8 7.2 16 16 16h304c8.8 0 16-7.2 16-16V160c0-8.8-7.2-16-16-16zm-52 268H212V212h200v200zm452-268H560c-8.8 0-16 7.2-16 16v304c0 8.8 7.2 16 16 16h304c8.8 0 16-7.2 16-16V160c0-8.8-7.2-16-16-16zm-52 268H612V212h200v200zM464 544H160c-8.8 0-16 7.2-16 16v304c0 8.8 7.2 16 16 16h304c8.8 0 16-7.2 16-16V560c0-8.8-7.2-16-16-16zm-52 268H212V612h200v200zm452-268H560c-8.8 0-16 7.2-16 16v304c0 8.8 7.2 16 16 16h304c8.8 0 16-7.2 16-16V560c0-8.8-7.2-16-16-16zm-52 268H612V612h200v200z"
                }
            }
        ]
    })(props);
}
function AiOutlineAreaChart(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M888 792H200V168c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v688c0 4.4 3.6 8 8 8h752c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-616-64h536c4.4 0 8-3.6 8-8V284c0-7.2-8.7-10.7-13.7-5.7L592 488.6l-125.4-124a8.03 8.03 0 0 0-11.3 0l-189 189.6a7.87 7.87 0 0 0-2.3 5.6V720c0 4.4 3.6 8 8 8z"
                }
            }
        ]
    })(props);
}
function AiOutlineArrowDown(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M862 465.3h-81c-4.6 0-9 2-12.1 5.5L550 723.1V160c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8v563.1L255.1 470.8c-3-3.5-7.4-5.5-12.1-5.5h-81c-6.8 0-10.5 8.1-6 13.2L487.9 861a31.96 31.96 0 0 0 48.3 0L868 478.5c4.5-5.2.8-13.2-6-13.2z"
                }
            }
        ]
    })(props);
}
function AiOutlineArrowLeft(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M872 474H286.9l350.2-304c5.6-4.9 2.2-14-5.2-14h-88.5c-3.9 0-7.6 1.4-10.5 3.9L155 487.8a31.96 31.96 0 0 0 0 48.3L535.1 866c1.5 1.3 3.3 2 5.2 2h91.5c7.4 0 10.8-9.2 5.2-14L286.9 550H872c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8z"
                }
            }
        ]
    })(props);
}
function AiOutlineArrowRight(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M869 487.8L491.2 159.9c-2.9-2.5-6.6-3.9-10.5-3.9h-88.5c-7.4 0-10.8 9.2-5.2 14l350.2 304H152c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h585.1L386.9 854c-5.6 4.9-2.2 14 5.2 14h91.5c1.9 0 3.8-.7 5.2-2L869 536.2a32.07 32.07 0 0 0 0-48.4z"
                }
            }
        ]
    })(props);
}
function AiOutlineArrowUp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M868 545.5L536.1 163a31.96 31.96 0 0 0-48.3 0L156 545.5a7.97 7.97 0 0 0 6 13.2h81c4.6 0 9-2 12.1-5.5L474 300.9V864c0 4.4 3.6 8 8 8h60c4.4 0 8-3.6 8-8V300.9l218.9 252.3c3 3.5 7.4 5.5 12.1 5.5h81c6.8 0 10.5-8 6-13.2z"
                }
            }
        ]
    })(props);
}
function AiOutlineArrowsAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M855 160.1l-189.2 23.5c-6.6.8-9.3 8.8-4.7 13.5l54.7 54.7-153.5 153.5a8.03 8.03 0 0 0 0 11.3l45.1 45.1c3.1 3.1 8.2 3.1 11.3 0l153.6-153.6 54.7 54.7a7.94 7.94 0 0 0 13.5-4.7L863.9 169a7.9 7.9 0 0 0-8.9-8.9zM416.6 562.3a8.03 8.03 0 0 0-11.3 0L251.8 715.9l-54.7-54.7a7.94 7.94 0 0 0-13.5 4.7L160.1 855c-.6 5.2 3.7 9.5 8.9 8.9l189.2-23.5c6.6-.8 9.3-8.8 4.7-13.5l-54.7-54.7 153.6-153.6c3.1-3.1 3.1-8.2 0-11.3l-45.2-45z"
                }
            }
        ]
    })(props);
}
function AiOutlineAudioMuted(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "t": "1569682811064",
            "viewBox": "0 0 1024 1024",
            "version": "1.1"
        },
        "child": [
            {
                "tag": "defs",
                "attr": {},
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M682 455V311l-76 76v68c-0.1 50.7-42 92.1-94 92-19.1 0.1-36.8-5.4-52-15l-54 55c29.1 22.4 65.9 36 106 36 93.8 0 170-75.1 170-168z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M833 446h-60c-4.4 0-8 3.6-8 8 0 140.3-113.7 254-254 254-63 0-120.7-23-165-61l-54 54c48.9 43.2 110.8 72.3 179 81v102H326c-13.9 0-24.9 14.3-25 32v36c0.1 4.4 2.9 8 6 8h408c3.2 0 6-3.6 6-8v-36c0-17.7-11-32-25-32H547V782c165.3-17.9 294-157.9 294-328 0-4.4-3.6-8-8-8zM846.1 68.3l-43.5-41.9c-3.1-3-8.1-3-11.2 0.1l-129 129C634.3 101.2 577 64 511 64c-93.9 0-170 75.3-170 168v224c0 6.7 0.4 13.3 1.2 19.8l-68 68c-10.5-27.9-16.3-58.2-16.2-89.8-0.2-4.4-3.8-8-8-8h-60c-4.4 0-8 3.6-8 8 0 53 12.5 103 34.6 147.4l-137 137c-3.1 3.1-3.1 8.2 0 11.3l42.7 42.7c3.1 3.1 8.2 3.1 11.3 0L846.2 79.8l0.1-0.1c3.1-3.2 3-8.3-0.2-11.4zM417 401V232c0-50.6 41.9-92 94-92 46 0 84.1 32.3 92.3 74.7L417 401z"
                }
            }
        ]
    })(props);
}
function AiOutlineAudio(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M842 454c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8 0 140.3-113.7 254-254 254S258 594.3 258 454c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8 0 168.7 126.6 307.9 290 327.6V884H326.7c-13.7 0-24.7 14.3-24.7 32v36c0 4.4 2.8 8 6.2 8h407.6c3.4 0 6.2-3.6 6.2-8v-36c0-17.7-11-32-24.7-32H548V782.1c165.3-18 294-158 294-328.1zM512 624c93.9 0 170-75.2 170-168V232c0-92.8-76.1-168-170-168s-170 75.2-170 168v224c0 92.8 76.1 168 170 168zm-94-392c0-50.6 41.9-92 94-92s94 41.4 94 92v224c0 50.6-41.9 92-94 92s-94-41.4-94-92V232z"
                }
            }
        ]
    })(props);
}
function AiOutlineAudit(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M296 250c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h384c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H296zm184 144H296c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h184c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zm-48 458H208V148h560v320c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V108c0-17.7-14.3-32-32-32H168c-17.7 0-32 14.3-32 32v784c0 17.7 14.3 32 32 32h264c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm440-88H728v-36.6c46.3-13.8 80-56.6 80-107.4 0-61.9-50.1-112-112-112s-112 50.1-112 112c0 50.7 33.7 93.6 80 107.4V764H520c-8.8 0-16 7.2-16 16v152c0 8.8 7.2 16 16 16h352c8.8 0 16-7.2 16-16V780c0-8.8-7.2-16-16-16zM646 620c0-27.6 22.4-50 50-50s50 22.4 50 50-22.4 50-50 50-50-22.4-50-50zm180 266H566v-60h260v60z"
                }
            }
        ]
    })(props);
}
function AiOutlineBackward(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M485.6 249.9L198.2 498c-8.3 7.1-8.3 20.8 0 27.9l287.4 248.2c10.7 9.2 26.4.9 26.4-14V263.8c0-14.8-15.7-23.2-26.4-13.9zm320 0L518.2 498a18.6 18.6 0 0 0-6.2 14c0 5.2 2.1 10.4 6.2 14l287.4 248.2c10.7 9.2 26.4.9 26.4-14V263.8c0-14.8-15.7-23.2-26.4-13.9z"
                }
            }
        ]
    })(props);
}
function AiOutlineBank(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M894 462c30.9 0 43.8-39.7 18.7-58L530.8 126.2a31.81 31.81 0 0 0-37.6 0L111.3 404c-25.1 18.2-12.2 58 18.8 58H192v374h-72c-4.4 0-8 3.6-8 8v52c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-52c0-4.4-3.6-8-8-8h-72V462h62zM512 196.7l271.1 197.2H240.9L512 196.7zM264 462h117v374H264V462zm189 0h117v374H453V462zm307 374H642V462h118v374z"
                }
            }
        ]
    })(props);
}
function AiOutlineBarChart(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M888 792H200V168c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v688c0 4.4 3.6 8 8 8h752c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-600-80h56c4.4 0 8-3.6 8-8V560c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v144c0 4.4 3.6 8 8 8zm152 0h56c4.4 0 8-3.6 8-8V384c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v320c0 4.4 3.6 8 8 8zm152 0h56c4.4 0 8-3.6 8-8V462c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v242c0 4.4 3.6 8 8 8zm152 0h56c4.4 0 8-3.6 8-8V304c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v400c0 4.4 3.6 8 8 8z"
                }
            }
        ]
    })(props);
}
function AiOutlineBarcode(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M120 160H72c-4.4 0-8 3.6-8 8v688c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V168c0-4.4-3.6-8-8-8zm833 0h-48c-4.4 0-8 3.6-8 8v688c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V168c0-4.4-3.6-8-8-8zM200 736h112c4.4 0 8-3.6 8-8V168c0-4.4-3.6-8-8-8H200c-4.4 0-8 3.6-8 8v560c0 4.4 3.6 8 8 8zm321 0h48c4.4 0 8-3.6 8-8V168c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v560c0 4.4 3.6 8 8 8zm126 0h178c4.4 0 8-3.6 8-8V168c0-4.4-3.6-8-8-8H647c-4.4 0-8 3.6-8 8v560c0 4.4 3.6 8 8 8zm-255 0h48c4.4 0 8-3.6 8-8V168c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v560c0 4.4 3.6 8 8 8zm-79 64H201c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h112c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zm257 0h-48c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zm256 0H648c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h178c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zm-385 0h-48c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8z"
                }
            }
        ]
    })(props);
}
function AiOutlineBars(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M912 192H328c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h584c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 284H328c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h584c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 284H328c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h584c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM104 228a56 56 0 1 0 112 0 56 56 0 1 0-112 0zm0 284a56 56 0 1 0 112 0 56 56 0 1 0-112 0zm0 284a56 56 0 1 0 112 0 56 56 0 1 0-112 0z"
                }
            }
        ]
    })(props);
}
function AiOutlineBehanceSquare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM598.5 350.9h138.4v33.7H598.5v-33.7zM512 628.8a89.52 89.52 0 0 1-27 31c-11.8 8.2-24.9 14.2-38.8 17.7a167.4 167.4 0 0 1-44.6 5.7H236V342.1h161c16.3 0 31.1 1.5 44.6 4.3 13.4 2.8 24.8 7.6 34.4 14.1 9.5 6.5 17 15.2 22.3 26 5.2 10.7 7.9 24.1 7.9 40 0 17.2-3.9 31.4-11.7 42.9-7.9 11.5-19.3 20.8-34.8 28.1 21.1 6 36.6 16.7 46.8 31.7 10.4 15.2 15.5 33.4 15.5 54.8 0 17.4-3.3 32.3-10 44.8zM790.8 576H612.4c0 19.4 6.7 38 16.8 48 10.2 9.9 24.8 14.9 43.9 14.9 13.8 0 25.5-3.5 35.5-10.4 9.9-6.9 15.9-14.2 18.1-21.8h59.8c-9.6 29.7-24.2 50.9-44 63.7-19.6 12.8-43.6 19.2-71.5 19.2-19.5 0-37-3.2-52.7-9.3-15.1-5.9-28.7-14.9-39.9-26.5a121.2 121.2 0 0 1-25.1-41.2c-6.1-16.9-9.1-34.7-8.9-52.6 0-18.5 3.1-35.7 9.1-51.7 11.5-31.1 35.4-56 65.9-68.9 16.3-6.8 33.8-10.2 51.5-10 21 0 39.2 4 55 12.2a111.6 111.6 0 0 1 38.6 32.8c10.1 13.7 17.2 29.3 21.7 46.9 4.3 17.3 5.8 35.5 4.6 54.7zm-122-95.6c-10.8 0-19.9 1.9-26.9 5.6-7 3.7-12.8 8.3-17.2 13.6a48.4 48.4 0 0 0-9.1 17.4c-1.6 5.3-2.7 10.7-3.1 16.2H723c-1.6-17.3-7.6-30.1-15.6-39.1-8.4-8.9-21.9-13.7-38.6-13.7zm-248.5-10.1c8.7-6.3 12.9-16.7 12.9-31 .3-6.8-1.1-13.5-4.1-19.6-2.7-4.9-6.7-9-11.6-11.9a44.8 44.8 0 0 0-16.6-6c-6.4-1.2-12.9-1.8-19.3-1.7h-70.3v79.7h76.1c13.1.1 24.2-3.1 32.9-9.5zm11.8 72c-9.8-7.5-22.9-11.2-39.2-11.2h-81.8v94h80.2c7.5 0 14.4-.7 21.1-2.1s12.7-3.8 17.8-7.2c5.1-3.3 9.2-7.8 12.3-13.6 3-5.8 4.5-13.2 4.5-22.1 0-17.7-5-30.2-14.9-37.8z"
                }
            }
        ]
    })(props);
}
function AiOutlineBehance(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M634 294.3h199.5v48.4H634zM434.1 485.8c44.1-21.1 67.2-53.2 67.2-102.8 0-98.1-73-121.9-157.3-121.9H112v492.4h238.5c89.4 0 173.3-43 173.3-143 0-61.8-29.2-107.5-89.7-124.7zM220.2 345.1h101.5c39.1 0 74.2 10.9 74.2 56.3 0 41.8-27.3 58.6-66 58.6H220.2V345.1zm115.5 324.8H220.1V534.3H338c47.6 0 77.7 19.9 77.7 70.3 0 49.6-35.9 65.3-80 65.3zm575.8-89.5c0-105.5-61.7-193.4-173.3-193.4-108.5 0-182.3 81.7-182.3 188.8 0 111 69.9 187.2 182.3 187.2 85.1 0 140.2-38.3 166.7-120h-86.3c-9.4 30.5-47.6 46.5-77.3 46.5-57.4 0-87.4-33.6-87.4-90.7h256.9c.3-5.9.7-12.1.7-18.4zM653.9 537c3.1-46.9 34.4-76.2 81.2-76.2 49.2 0 73.8 28.9 78.1 76.2H653.9z"
                }
            }
        ]
    })(props);
}
function AiOutlineBell(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M816 768h-24V428c0-141.1-104.3-257.7-240-277.1V112c0-22.1-17.9-40-40-40s-40 17.9-40 40v38.9c-135.7 19.4-240 136-240 277.1v340h-24c-17.7 0-32 14.3-32 32v32c0 4.4 3.6 8 8 8h216c0 61.8 50.2 112 112 112s112-50.2 112-112h216c4.4 0 8-3.6 8-8v-32c0-17.7-14.3-32-32-32zM512 888c-26.5 0-48-21.5-48-48h96c0 26.5-21.5 48-48 48zM304 768V428c0-55.6 21.6-107.8 60.9-147.1S456.4 220 512 220c55.6 0 107.8 21.6 147.1 60.9S720 372.4 720 428v340H304z"
                }
            }
        ]
    })(props);
}
function AiOutlineBgColors(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M766.4 744.3c43.7 0 79.4-36.2 79.4-80.5 0-53.5-79.4-140.8-79.4-140.8S687 610.3 687 663.8c0 44.3 35.7 80.5 79.4 80.5zm-377.1-44.1c7.1 7.1 18.6 7.1 25.6 0l256.1-256c7.1-7.1 7.1-18.6 0-25.6l-256-256c-.6-.6-1.3-1.2-2-1.7l-78.2-78.2a9.11 9.11 0 0 0-12.8 0l-48 48a9.11 9.11 0 0 0 0 12.8l67.2 67.2-207.8 207.9c-7.1 7.1-7.1 18.6 0 25.6l255.9 256zm12.9-448.6l178.9 178.9H223.4l178.8-178.9zM904 816H120c-4.4 0-8 3.6-8 8v80c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-80c0-4.4-3.6-8-8-8z"
                }
            }
        ]
    })(props);
}
function AiOutlineBlock(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M856 376H648V168c0-8.8-7.2-16-16-16H168c-8.8 0-16 7.2-16 16v464c0 8.8 7.2 16 16 16h208v208c0 8.8 7.2 16 16 16h464c8.8 0 16-7.2 16-16V392c0-8.8-7.2-16-16-16zm-480 16v188H220V220h360v156H392c-8.8 0-16 7.2-16 16zm204 52v136H444V444h136zm224 360H444V648h188c8.8 0 16-7.2 16-16V444h156v360z"
                }
            }
        ]
    })(props);
}
function AiOutlineBold(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M697.8 481.4c33.6-35 54.2-82.3 54.2-134.3v-10.2C752 229.3 663.9 142 555.3 142H259.4c-15.1 0-27.4 12.3-27.4 27.4v679.1c0 16.3 13.2 29.5 29.5 29.5h318.7c117 0 211.8-94.2 211.8-210.5v-11c0-73-37.4-137.3-94.2-175.1zM328 238h224.7c57.1 0 103.3 44.4 103.3 99.3v9.5c0 54.8-46.3 99.3-103.3 99.3H328V238zm366.6 429.4c0 62.9-51.7 113.9-115.5 113.9H328V542.7h251.1c63.8 0 115.5 51 115.5 113.9v10.8z"
                }
            }
        ]
    })(props);
}
function AiOutlineBook(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M832 64H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32zm-260 72h96v209.9L621.5 312 572 347.4V136zm220 752H232V136h280v296.9c0 3.3 1 6.6 3 9.3a15.9 15.9 0 0 0 22.3 3.7l83.8-59.9 81.4 59.4c2.7 2 6 3.1 9.4 3.1 8.8 0 16-7.2 16-16V136h64v752z"
                }
            }
        ]
    })(props);
}
function AiOutlineBorderBottom(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M872 808H152c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h720c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-720-94h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm0-498h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm0 332h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm0-166h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm166 166h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm0-332h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm332 0h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm0 332h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm222-72h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-388 72h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm388-404h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-388 72h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm388 426h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-388 72h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm388-404h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-388 72h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8z"
                }
            }
        ]
    })(props);
}
function AiOutlineBorderHorizontal(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M540 144h-56c-4.4 0-8 3.6-8 8v720c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V152c0-4.4-3.6-8-8-8zm-166 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm498 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-664 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm498 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM208 310h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm664 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 332h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-664 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 166h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-332h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm664 332h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-332h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM374 808h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-332h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm332 332h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-332h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8z"
                }
            }
        ]
    })(props);
}
function AiOutlineBorderInner(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M872 476H548V144h-72v332H152c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h324v332h72V548h324c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-166h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 498h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-664h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 498h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM650 216h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm56 592h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-332 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-56-592h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm-166 0h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm56 592h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-56-426h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm56 260h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8z"
                }
            }
        ]
    })(props);
}
function AiOutlineBorderLeft(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M208 144h-56c-4.4 0-8 3.6-8 8v720c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V152c0-4.4-3.6-8-8-8zm166 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm498 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-332 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm166 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM540 310h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm332 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 332h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-332 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 166h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-332h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm332 332h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-332h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM374 808h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-332h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm332 332h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-332h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8z"
                }
            }
        ]
    })(props);
}
function AiOutlineBorderOuter(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656zM484 366h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zM302 548h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm364 0h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm-182 0h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm0 182h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8z"
                }
            }
        ]
    })(props);
}
function AiOutlineBorderRight(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M872 144h-56c-4.4 0-8 3.6-8 8v720c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V152c0-4.4-3.6-8-8-8zm-166 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-498 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm332 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-166 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm166 166h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-332 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 332h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm332 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 166h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-332h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM208 808h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-332h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm498 332h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-332h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM374 808h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-332h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8z"
                }
            }
        ]
    })(props);
}
function AiOutlineBorderTop(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M872 144H152c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h720c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM208 310h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 498h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-332h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 166h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm166-166h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 332h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm332 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-332h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm166 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-332 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm332 332h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-332 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm332-498h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-332 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm332 332h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-332 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8z"
                }
            }
        ]
    })(props);
}
function AiOutlineBorderVerticle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M872 476H152c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h720c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-166h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 498h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-664h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 498h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM650 216h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm56 592h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-332 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-56-592h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm-166 0h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm332 0h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zM208 808h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm332 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM152 382h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm332 0h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zM208 642h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm332 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8z"
                }
            }
        ]
    })(props);
}
function AiOutlineBorder(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z"
                }
            }
        ]
    })(props);
}
function AiOutlineBorderlessTable(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "t": "1569683537953",
            "viewBox": "0 0 1024 1024",
            "version": "1.1"
        },
        "child": [
            {
                "tag": "defs",
                "attr": {},
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M117 368h231v64H117zM676 368h241v64H676zM412 368h200v64H412zM412 592h200v64H412zM676 592h241v64H676zM117 592h231v64H117zM412 432V179h-64v666h64V592zM676 368V179h-64v666h64V432z"
                }
            }
        ]
    })(props);
}
function AiOutlineBoxPlot(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M952 224h-52c-4.4 0-8 3.6-8 8v248h-92V304c0-4.4-3.6-8-8-8H232c-4.4 0-8 3.6-8 8v176h-92V232c0-4.4-3.6-8-8-8H72c-4.4 0-8 3.6-8 8v560c0 4.4 3.6 8 8 8h52c4.4 0 8-3.6 8-8V548h92v172c0 4.4 3.6 8 8 8h560c4.4 0 8-3.6 8-8V548h92v244c0 4.4 3.6 8 8 8h52c4.4 0 8-3.6 8-8V232c0-4.4-3.6-8-8-8zM296 368h88v288h-88V368zm432 288H448V368h280v288z"
                }
            }
        ]
    })(props);
}
function AiOutlineBranches(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M740 161c-61.8 0-112 50.2-112 112 0 50.1 33.1 92.6 78.5 106.9v95.9L320 602.4V318.1c44.2-15 76-56.9 76-106.1 0-61.8-50.2-112-112-112s-112 50.2-112 112c0 49.2 31.8 91 76 106.1V706c-44.2 15-76 56.9-76 106.1 0 61.8 50.2 112 112 112s112-50.2 112-112c0-49.2-31.8-91-76-106.1v-27.8l423.5-138.7a50.52 50.52 0 0 0 34.9-48.2V378.2c42.9-15.8 73.6-57 73.6-105.2 0-61.8-50.2-112-112-112zm-504 51a48.01 48.01 0 0 1 96 0 48.01 48.01 0 0 1-96 0zm96 600a48.01 48.01 0 0 1-96 0 48.01 48.01 0 0 1 96 0zm408-491a48.01 48.01 0 0 1 0-96 48.01 48.01 0 0 1 0 96z"
                }
            }
        ]
    })(props);
}
function AiOutlineBug(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M304 280h56c4.4 0 8-3.6 8-8 0-28.3 5.9-53.2 17.1-73.5 10.6-19.4 26-34.8 45.4-45.4C450.9 142 475.7 136 504 136h16c28.3 0 53.2 5.9 73.5 17.1 19.4 10.6 34.8 26 45.4 45.4C650 218.9 656 243.7 656 272c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8 0-40-8.8-76.7-25.9-108.1-17.2-31.5-42.5-56.8-74-74C596.7 72.8 560 64 520 64h-16c-40 0-76.7 8.8-108.1 25.9-31.5 17.2-56.8 42.5-74 74C304.8 195.3 296 232 296 272c0 4.4 3.6 8 8 8z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M940 512H792V412c76.8 0 139-62.2 139-139 0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8 0 34.8-28.2 63-63 63H232c-34.8 0-63-28.2-63-63 0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8 0 76.8 62.2 139 139 139v100H84c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h148v96c0 6.5.2 13 .7 19.3C164.1 728.6 116 796.7 116 876c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8 0-44.2 23.9-82.9 59.6-103.7 6 17.2 13.6 33.6 22.7 49 24.3 41.5 59 76.2 100.5 100.5S460.5 960 512 960s99.8-13.9 141.3-38.2c41.5-24.3 76.2-59 100.5-100.5 9.1-15.5 16.7-31.9 22.7-49C812.1 793.1 836 831.8 836 876c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8 0-79.3-48.1-147.4-116.7-176.7.4-6.4.7-12.8.7-19.3v-96h148c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM716 680c0 36.8-9.7 72-27.8 102.9-17.7 30.3-43 55.6-73.3 73.3C584 874.3 548.8 884 512 884s-72-9.7-102.9-27.8c-30.3-17.7-55.6-43-73.3-73.3C317.7 752 308 716.8 308 680V412h408v268z"
                }
            }
        ]
    })(props);
}
function AiOutlineBuild(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M916 210H376c-17.7 0-32 14.3-32 32v236H108c-17.7 0-32 14.3-32 32v272c0 17.7 14.3 32 32 32h540c17.7 0 32-14.3 32-32V546h236c17.7 0 32-14.3 32-32V242c0-17.7-14.3-32-32-32zm-504 68h200v200H412V278zm-68 468H144V546h200v200zm268 0H412V546h200v200zm268-268H680V278h200v200z"
                }
            }
        ]
    })(props);
}
function AiOutlineBulb(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M632 888H392c-4.4 0-8 3.6-8 8v32c0 17.7 14.3 32 32 32h192c17.7 0 32-14.3 32-32v-32c0-4.4-3.6-8-8-8zM512 64c-181.1 0-328 146.9-328 328 0 121.4 66 227.4 164 284.1V792c0 17.7 14.3 32 32 32h264c17.7 0 32-14.3 32-32V676.1c98-56.7 164-162.7 164-284.1 0-181.1-146.9-328-328-328zm127.9 549.8L604 634.6V752H420V634.6l-35.9-20.8C305.4 568.3 256 484.5 256 392c0-141.4 114.6-256 256-256s256 114.6 256 256c0 92.5-49.4 176.3-128.1 221.8z"
                }
            }
        ]
    })(props);
}
function AiOutlineCalculator(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M251.2 387H320v68.8c0 1.8 1.8 3.2 4 3.2h48c2.2 0 4-1.4 4-3.3V387h68.8c1.8 0 3.2-1.8 3.2-4v-48c0-2.2-1.4-4-3.3-4H376v-68.8c0-1.8-1.8-3.2-4-3.2h-48c-2.2 0-4 1.4-4 3.2V331h-68.8c-1.8 0-3.2 1.8-3.2 4v48c0 2.2 1.4 4 3.2 4zm328 0h193.6c1.8 0 3.2-1.8 3.2-4v-48c0-2.2-1.4-4-3.3-4H579.2c-1.8 0-3.2 1.8-3.2 4v48c0 2.2 1.4 4 3.2 4zm0 265h193.6c1.8 0 3.2-1.8 3.2-4v-48c0-2.2-1.4-4-3.3-4H579.2c-1.8 0-3.2 1.8-3.2 4v48c0 2.2 1.4 4 3.2 4zm0 104h193.6c1.8 0 3.2-1.8 3.2-4v-48c0-2.2-1.4-4-3.3-4H579.2c-1.8 0-3.2 1.8-3.2 4v48c0 2.2 1.4 4 3.2 4zm-195.7-81l61.2-74.9c4.3-5.2.7-13.1-5.9-13.1H388c-2.3 0-4.5 1-5.9 2.9l-34 41.6-34-41.6a7.85 7.85 0 0 0-5.9-2.9h-50.9c-6.6 0-10.2 7.9-5.9 13.1l61.2 74.9-62.7 76.8c-4.4 5.2-.8 13.1 5.8 13.1h50.8c2.3 0 4.5-1 5.9-2.9l35.5-43.5 35.5 43.5c1.5 1.8 3.7 2.9 5.9 2.9h50.8c6.6 0 10.2-7.9 5.9-13.1L383.5 675zM880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-36 732H180V180h664v664z"
                }
            }
        ]
    })(props);
}
function AiOutlineCalendar(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M880 184H712v-64c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v64H384v-64c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v64H144c-17.7 0-32 14.3-32 32v664c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V216c0-17.7-14.3-32-32-32zm-40 656H184V460h656v380zM184 392V256h128v48c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-48h256v48c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-48h128v136H184z"
                }
            }
        ]
    })(props);
}
function AiOutlineCamera(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M864 248H728l-32.4-90.8a32.07 32.07 0 0 0-30.2-21.2H358.6c-13.5 0-25.6 8.5-30.1 21.2L296 248H160c-44.2 0-80 35.8-80 80v456c0 44.2 35.8 80 80 80h704c44.2 0 80-35.8 80-80V328c0-44.2-35.8-80-80-80zm8 536c0 4.4-3.6 8-8 8H160c-4.4 0-8-3.6-8-8V328c0-4.4 3.6-8 8-8h186.7l17.1-47.8 22.9-64.2h250.5l22.9 64.2 17.1 47.8H864c4.4 0 8 3.6 8 8v456zM512 384c-88.4 0-160 71.6-160 160s71.6 160 160 160 160-71.6 160-160-71.6-160-160-160zm0 256c-53 0-96-43-96-96s43-96 96-96 96 43 96 96-43 96-96 96z"
                }
            }
        ]
    })(props);
}
function AiOutlineCar(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M380 704h264c4.4 0 8-3.6 8-8v-84c0-4.4-3.6-8-8-8h-40c-4.4 0-8 3.6-8 8v36H428v-36c0-4.4-3.6-8-8-8h-40c-4.4 0-8 3.6-8 8v84c0 4.4 3.6 8 8 8zm340-123a40 40 0 1 0 80 0 40 40 0 1 0-80 0zm239-167.6L935.3 372a8 8 0 0 0-10.9-2.9l-50.7 29.6-78.3-216.2a63.9 63.9 0 0 0-60.9-44.4H301.2c-34.7 0-65.5 22.4-76.2 55.5l-74.6 205.2-50.8-29.6a8 8 0 0 0-10.9 2.9L65 413.4c-2.2 3.8-.9 8.6 2.9 10.8l60.4 35.2-14.5 40c-1.2 3.2-1.8 6.6-1.8 10v348.2c0 15.7 11.8 28.4 26.3 28.4h67.6c12.3 0 23-9.3 25.6-22.3l7.7-37.7h545.6l7.7 37.7c2.7 13 13.3 22.3 25.6 22.3h67.6c14.5 0 26.3-12.7 26.3-28.4V509.4c0-3.4-.6-6.8-1.8-10l-14.5-40 60.3-35.2a8 8 0 0 0 3-10.8zM840 517v237H184V517l15.6-43h624.8l15.6 43zM292.7 218.1l.5-1.3.4-1.3c1.1-3.3 4.1-5.5 7.6-5.5h427.6l75.4 208H220l72.7-199.9zM224 581a40 40 0 1 0 80 0 40 40 0 1 0-80 0z"
                }
            }
        ]
    })(props);
}
function AiOutlineCaretDown(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M840.4 300H183.6c-19.7 0-30.7 20.8-18.5 35l328.4 380.8c9.4 10.9 27.5 10.9 37 0L858.9 335c12.2-14.2 1.2-35-18.5-35z"
                }
            }
        ]
    })(props);
}
function AiOutlineCaretLeft(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M689 165.1L308.2 493.5c-10.9 9.4-10.9 27.5 0 37L689 858.9c14.2 12.2 35 1.2 35-18.5V183.6c0-19.7-20.8-30.7-35-18.5z"
                }
            }
        ]
    })(props);
}
function AiOutlineCaretRight(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M715.8 493.5L335 165.1c-14.2-12.2-35-1.2-35 18.5v656.8c0 19.7 20.8 30.7 35 18.5l380.8-328.4c10.9-9.4 10.9-27.6 0-37z"
                }
            }
        ]
    })(props);
}
function AiOutlineCaretUp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M858.9 689L530.5 308.2c-9.4-10.9-27.5-10.9-37 0L165.1 689c-12.2 14.2-1.2 35 18.5 35h656.8c19.7 0 30.7-20.8 18.5-35z"
                }
            }
        ]
    })(props);
}
function AiOutlineCarryOut(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M880 184H712v-64c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v64H384v-64c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v64H144c-17.7 0-32 14.3-32 32v664c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V216c0-17.7-14.3-32-32-32zm-40 656H184V256h128v48c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-48h256v48c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-48h128v584zM688 420h-55.2c-5.1 0-10 2.5-13 6.6L468.9 634.4l-64.7-89c-3-4.1-7.8-6.6-13-6.6H336c-6.5 0-10.3 7.4-6.5 12.7l126.4 174a16.1 16.1 0 0 0 26 0l212.6-292.7c3.8-5.4 0-12.8-6.5-12.8z"
                }
            }
        ]
    })(props);
}
function AiOutlineCheckCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M699 353h-46.9c-10.2 0-19.9 4.9-25.9 13.3L469 584.3l-71.2-98.8c-6-8.3-15.6-13.3-25.9-13.3H325c-6.5 0-10.3 7.4-6.5 12.7l124.6 172.8a31.8 31.8 0 0 0 51.7 0l210.6-292c3.9-5.3.1-12.7-6.4-12.7z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z"
                }
            }
        ]
    })(props);
}
function AiOutlineCheckSquare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M433.1 657.7a31.8 31.8 0 0 0 51.7 0l210.6-292c3.8-5.3 0-12.7-6.5-12.7H642c-10.2 0-19.9 4.9-25.9 13.3L459 584.3l-71.2-98.8c-6-8.3-15.6-13.3-25.9-13.3H315c-6.5 0-10.3 7.4-6.5 12.7l124.6 172.8z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z"
                }
            }
        ]
    })(props);
}
function AiOutlineCheck(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M912 190h-69.9c-9.8 0-19.1 4.5-25.1 12.2L404.7 724.5 207 474a32 32 0 0 0-25.1-12.2H112c-6.7 0-10.4 7.7-6.3 12.9l273.9 347c12.8 16.2 37.4 16.2 50.3 0l488.4-618.9c4.1-5.1.4-12.8-6.3-12.8z"
                }
            }
        ]
    })(props);
}
function AiOutlineChrome(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M928 512.3v-.3c0-229.8-186.2-416-416-416S96 282.2 96 512v.4c0 229.8 186.2 416 416 416s416-186.2 416-416v-.3.2zm-6.7-74.6l.6 3.3-.6-3.3zM676.7 638.2c53.5-82.2 52.5-189.4-11.1-263.7l162.4-8.4c20.5 44.4 32 93.8 32 145.9 0 185.2-144.6 336.6-327.1 347.4l143.8-221.2zM512 652.3c-77.5 0-140.2-62.7-140.2-140.2 0-77.7 62.7-140.2 140.2-140.2S652.2 434.5 652.2 512 589.5 652.3 512 652.3zm369.2-331.7l-3-5.7 3 5.7zM512 164c121.3 0 228.2 62.1 290.4 156.2l-263.6-13.9c-97.5-5.7-190.2 49.2-222.3 141.1L227.8 311c63.1-88.9 166.9-147 284.2-147zM102.5 585.8c26 145 127.1 264 261.6 315.1C229.6 850 128.5 731 102.5 585.8zM164 512c0-55.9 13.2-108.7 36.6-155.5l119.7 235.4c44.1 86.7 137.4 139.7 234 121.6l-74 145.1C302.9 842.5 164 693.5 164 512zm324.7 415.4c4 .2 8 .4 12 .5-4-.2-8-.3-12-.5z"
                }
            }
        ]
    })(props);
}
function AiOutlineCiCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372zm218-572.1h-50.4c-4.4 0-8 3.6-8 8v384.2c0 4.4 3.6 8 8 8H730c4.4 0 8-3.6 8-8V319.9c0-4.4-3.6-8-8-8zm-281.4 49.6c49.5 0 83.1 31.5 87 77.6.4 4.2 3.8 7.4 8 7.4h52.6c2.4 0 4.4-2 4.4-4.4 0-81.2-64-138.1-152.3-138.1C345.4 304 286 373.5 286 488.4v49c0 114 59.4 182.6 162.3 182.6 88 0 152.3-55.1 152.3-132.5 0-2.4-2-4.4-4.4-4.4h-52.7c-4.2 0-7.6 3.2-8 7.3-4.2 43-37.7 72.4-87 72.4-61.1 0-95.6-44.9-95.6-125.2v-49.3c.1-81.4 34.6-126.8 95.7-126.8z"
                }
            }
        ]
    })(props);
}
function AiOutlineCi(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372zm218-572.1h-50.4c-4.4 0-8 3.6-8 8v384.2c0 4.4 3.6 8 8 8H730c4.4 0 8-3.6 8-8V319.9c0-4.4-3.6-8-8-8zm-281.4 49.6c49.5 0 83.1 31.5 87 77.6.4 4.2 3.8 7.4 8 7.4h52.6c2.4 0 4.4-2 4.4-4.4 0-81.2-64-138.1-152.3-138.1C345.4 304 286 373.5 286 488.4v49c0 114 59.4 182.6 162.3 182.6 88 0 152.3-55.1 152.3-132.5 0-2.4-2-4.4-4.4-4.4h-52.7c-4.2 0-7.6 3.2-8 7.3-4.2 43-37.7 72.4-87 72.4-61.1 0-95.6-44.9-95.6-125.2v-49.3c.1-81.4 34.6-126.8 95.7-126.8z"
                }
            }
        ]
    })(props);
}
function AiOutlineClear(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "t": "1569683368540",
            "viewBox": "0 0 1024 1024",
            "version": "1.1"
        },
        "child": [
            {
                "tag": "defs",
                "attr": {},
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M899.1 869.6l-53-305.6H864c14.4 0 26-11.6 26-26V346c0-14.4-11.6-26-26-26H618V138c0-14.4-11.6-26-26-26H432c-14.4 0-26 11.6-26 26v182H160c-14.4 0-26 11.6-26 26v192c0 14.4 11.6 26 26 26h17.9l-53 305.6c-0.3 1.5-0.4 3-0.4 4.4 0 14.4 11.6 26 26 26h723c1.5 0 3-0.1 4.4-0.4 14.2-2.4 23.7-15.9 21.2-30zM204 390h272V182h72v208h272v104H204V390z m468 440V674c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v156H416V674c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v156H202.8l45.1-260H776l45.1 260H672z"
                }
            }
        ]
    })(props);
}
function AiOutlineClockCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M686.7 638.6L544.1 535.5V288c0-4.4-3.6-8-8-8H488c-4.4 0-8 3.6-8 8v275.4c0 2.6 1.2 5 3.3 6.5l165.4 120.6c3.6 2.6 8.6 1.8 11.2-1.7l28.6-39c2.6-3.7 1.8-8.7-1.8-11.2z"
                }
            }
        ]
    })(props);
}
function AiOutlineCloseCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024",
            "fill": "currentColor",
            "fillRule": "evenodd"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M512 64c247.4 0 448 200.6 448 448S759.4 960 512 960 64 759.4 64 512 264.6 64 512 64Zm0 76c-205.4 0-372 166.6-372 372s166.6 372 372 372 372-166.6 372-372-166.6-372-372-372Zm128.013 198.826c.023.007.042.018.083.059l45.02 45.019c.04.04.05.06.058.083a.118.118 0 0 1 0 .07c-.007.022-.018.041-.059.082L557.254 512l127.861 127.862a.268.268 0 0 1 .05.06l.009.023a.118.118 0 0 1 0 .07c-.007.022-.018.041-.059.082l-45.019 45.02c-.04.04-.06.05-.083.058a.118.118 0 0 1-.07 0c-.022-.007-.041-.018-.082-.059L512 557.254 384.14 685.115c-.042.041-.06.052-.084.059a.118.118 0 0 1-.07 0c-.022-.007-.041-.018-.082-.059l-45.02-45.019c-.04-.04-.05-.06-.058-.083a.118.118 0 0 1 0-.07c.007-.022.018-.041.059-.082L466.745 512l-127.86-127.86a.268.268 0 0 1-.05-.061l-.009-.023a.118.118 0 0 1 0-.07c.007-.022.018-.041.059-.082l45.019-45.02c.04-.04.06-.05.083-.058a.118.118 0 0 1 .07 0c.022.007.041.018.082.059L512 466.745l127.862-127.86c.04-.041.06-.052.083-.059a.118.118 0 0 1 .07 0Z"
                }
            }
        ]
    })(props);
}
function AiOutlineCloseSquare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024",
            "fill": "currentColor",
            "fillRule": "evenodd"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M880 112c17.7 0 32 14.3 32 32v736c0 17.7-14.3 32-32 32H144c-17.7 0-32-14.3-32-32V144c0-17.7 14.3-32 32-32Zm-40 72H184v656h656V184ZM640.013 338.826c.023.007.042.018.083.059l45.02 45.019c.04.04.05.06.058.083a.118.118 0 0 1 0 .07c-.007.022-.018.041-.059.082L557.254 512l127.861 127.862a.268.268 0 0 1 .05.06l.009.023a.118.118 0 0 1 0 .07c-.007.022-.018.041-.059.082l-45.019 45.02c-.04.04-.06.05-.083.058a.118.118 0 0 1-.07 0c-.022-.007-.041-.018-.082-.059L512 557.254 384.14 685.115c-.042.041-.06.052-.084.059a.118.118 0 0 1-.07 0c-.022-.007-.041-.018-.082-.059l-45.02-45.019c-.04-.04-.05-.06-.058-.083a.118.118 0 0 1 0-.07c.007-.022.018-.041.059-.082L466.745 512l-127.86-127.86a.268.268 0 0 1-.05-.061l-.009-.023a.118.118 0 0 1 0-.07c.007-.022.018-.041.059-.082l45.019-45.02c.04-.04.06-.05.083-.058a.118.118 0 0 1 .07 0c.022.007.041.018.082.059L512 466.745l127.862-127.86c.04-.041.06-.052.083-.059a.118.118 0 0 1 .07 0Z"
                }
            }
        ]
    })(props);
}
function AiOutlineClose(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024",
            "fill": "currentColor",
            "fillRule": "evenodd"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M799.855 166.312c.023.007.043.018.084.059l57.69 57.69c.041.041.052.06.059.084a.118.118 0 0 1 0 .069c-.007.023-.018.042-.059.083L569.926 512l287.703 287.703c.041.04.052.06.059.083a.118.118 0 0 1 0 .07c-.007.022-.018.042-.059.083l-57.69 57.69c-.041.041-.06.052-.084.059a.118.118 0 0 1-.069 0c-.023-.007-.042-.018-.083-.059L512 569.926 224.297 857.629c-.04.041-.06.052-.083.059a.118.118 0 0 1-.07 0c-.022-.007-.042-.018-.083-.059l-57.69-57.69c-.041-.041-.052-.06-.059-.084a.118.118 0 0 1 0-.069c.007-.023.018-.042.059-.083L454.073 512 166.371 224.297c-.041-.04-.052-.06-.059-.083a.118.118 0 0 1 0-.07c.007-.022.018-.042.059-.083l57.69-57.69c.041-.041.06-.052.084-.059a.118.118 0 0 1 .069 0c.023.007.042.018.083.059L512 454.073l287.703-287.702c.04-.041.06-.052.083-.059a.118.118 0 0 1 .07 0Z"
                }
            }
        ]
    })(props);
}
function AiOutlineCloudDownload(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M624 706.3h-74.1V464c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8v242.3H400c-6.7 0-10.4 7.7-6.3 12.9l112 141.7a8 8 0 0 0 12.6 0l112-141.7c4.1-5.2.4-12.9-6.3-12.9z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M811.4 366.7C765.6 245.9 648.9 160 512.2 160S258.8 245.8 213 366.6C127.3 389.1 64 467.2 64 560c0 110.5 89.5 200 199.9 200H304c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8h-40.1c-33.7 0-65.4-13.4-89-37.7-23.5-24.2-36-56.8-34.9-90.6.9-26.4 9.9-51.2 26.2-72.1 16.7-21.3 40.1-36.8 66.1-43.7l37.9-9.9 13.9-36.6c8.6-22.8 20.6-44.1 35.7-63.4a245.6 245.6 0 0 1 52.4-49.9c41.1-28.9 89.5-44.2 140-44.2s98.9 15.3 140 44.2c19.9 14 37.5 30.8 52.4 49.9 15.1 19.3 27.1 40.7 35.7 63.4l13.8 36.5 37.8 10C846.1 454.5 884 503.8 884 560c0 33.1-12.9 64.3-36.3 87.7a123.07 123.07 0 0 1-87.6 36.3H720c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h40.1C870.5 760 960 670.5 960 560c0-92.7-63.1-170.7-148.6-193.3z"
                }
            }
        ]
    })(props);
}
function AiOutlineCloudServer(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M704 446H320c-4.4 0-8 3.6-8 8v402c0 4.4 3.6 8 8 8h384c4.4 0 8-3.6 8-8V454c0-4.4-3.6-8-8-8zm-328 64h272v117H376V510zm272 290H376V683h272v117z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M424 748a32 32 0 1 0 64 0 32 32 0 1 0-64 0zm0-178a32 32 0 1 0 64 0 32 32 0 1 0-64 0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M811.4 368.9C765.6 248 648.9 162 512.2 162S258.8 247.9 213 368.8C126.9 391.5 63.5 470.2 64 563.6 64.6 668 145.6 752.9 247.6 762c4.7.4 8.7-3.3 8.7-8v-60.4c0-4-3-7.4-7-7.9-27-3.4-52.5-15.2-72.1-34.5-24-23.5-37.2-55.1-37.2-88.6 0-28 9.1-54.4 26.2-76.4 16.7-21.4 40.2-36.9 66.1-43.7l37.9-10 13.9-36.7c8.6-22.8 20.6-44.2 35.7-63.5 14.9-19.2 32.6-36 52.4-50 41.1-28.9 89.5-44.2 140-44.2s98.9 15.3 140 44.3c19.9 14 37.5 30.8 52.4 50 15.1 19.3 27.1 40.7 35.7 63.5l13.8 36.6 37.8 10c54.2 14.4 92.1 63.7 92.1 120 0 33.6-13.2 65.1-37.2 88.6-19.5 19.2-44.9 31.1-71.9 34.5-4 .5-6.9 3.9-6.9 7.9V754c0 4.7 4.1 8.4 8.8 8 101.7-9.2 182.5-94 183.2-198.2.6-93.4-62.7-172.1-148.6-194.9z"
                }
            }
        ]
    })(props);
}
function AiOutlineCloudSync(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M811.4 368.9C765.6 248 648.9 162 512.2 162S258.8 247.9 213 368.8C126.9 391.5 63.5 470.2 64 563.6 64.6 668 145.6 752.9 247.6 762c4.7.4 8.7-3.3 8.7-8v-60.4c0-4-3-7.4-7-7.9-27-3.4-52.5-15.2-72.1-34.5-24-23.5-37.2-55.1-37.2-88.6 0-28 9.1-54.4 26.2-76.4 16.7-21.4 40.2-36.9 66.1-43.7l37.9-10 13.9-36.7c8.6-22.8 20.6-44.2 35.7-63.5 14.9-19.2 32.6-36 52.4-50 41.1-28.9 89.5-44.2 140-44.2s98.9 15.3 140 44.3c19.9 14 37.5 30.8 52.4 50 15.1 19.3 27.1 40.7 35.7 63.5l13.8 36.6 37.8 10c54.2 14.4 92.1 63.7 92.1 120 0 33.6-13.2 65.1-37.2 88.6-19.5 19.2-44.9 31.1-71.9 34.5-4 .5-6.9 3.9-6.9 7.9V754c0 4.7 4.1 8.4 8.8 8 101.7-9.2 182.5-94 183.2-198.2.6-93.4-62.7-172.1-148.6-194.9z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M376.9 656.4c1.8-33.5 15.7-64.7 39.5-88.6 25.4-25.5 60-39.8 96-39.8 36.2 0 70.3 14.1 96 39.8 1.4 1.4 2.7 2.8 4.1 4.3l-25 19.6a8 8 0 0 0 3 14.1l98.2 24c5 1.2 9.9-2.6 9.9-7.7l.5-101.3c0-6.7-7.6-10.5-12.9-6.3L663 532.7c-36.6-42-90.4-68.6-150.5-68.6-107.4 0-195 85.1-199.4 191.7-.2 4.5 3.4 8.3 8 8.3H369c4.2-.1 7.7-3.4 7.9-7.7zM703 664h-47.9c-4.2 0-7.7 3.3-8 7.6-1.8 33.5-15.7 64.7-39.5 88.6-25.4 25.5-60 39.8-96 39.8-36.2 0-70.3-14.1-96-39.8-1.4-1.4-2.7-2.8-4.1-4.3l25-19.6a8 8 0 0 0-3-14.1l-98.2-24c-5-1.2-9.9 2.6-9.9 7.7l-.4 101.4c0 6.7 7.6 10.5 12.9 6.3l23.2-18.2c36.6 42 90.4 68.6 150.5 68.6 107.4 0 195-85.1 199.4-191.7.2-4.5-3.4-8.3-8-8.3z"
                }
            }
        ]
    })(props);
}
function AiOutlineCloudUpload(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M518.3 459a8 8 0 0 0-12.6 0l-112 141.7a7.98 7.98 0 0 0 6.3 12.9h73.9V856c0 4.4 3.6 8 8 8h60c4.4 0 8-3.6 8-8V613.7H624c6.7 0 10.4-7.7 6.3-12.9L518.3 459z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M811.4 366.7C765.6 245.9 648.9 160 512.2 160S258.8 245.8 213 366.6C127.3 389.1 64 467.2 64 560c0 110.5 89.5 200 199.9 200H304c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8h-40.1c-33.7 0-65.4-13.4-89-37.7-23.5-24.2-36-56.8-34.9-90.6.9-26.4 9.9-51.2 26.2-72.1 16.7-21.3 40.1-36.8 66.1-43.7l37.9-9.9 13.9-36.6c8.6-22.8 20.6-44.1 35.7-63.4a245.6 245.6 0 0 1 52.4-49.9c41.1-28.9 89.5-44.2 140-44.2s98.9 15.3 140 44.2c19.9 14 37.5 30.8 52.4 49.9 15.1 19.3 27.1 40.7 35.7 63.4l13.8 36.5 37.8 10C846.1 454.5 884 503.8 884 560c0 33.1-12.9 64.3-36.3 87.7a123.07 123.07 0 0 1-87.6 36.3H720c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h40.1C870.5 760 960 670.5 960 560c0-92.7-63.1-170.7-148.6-193.3z"
                }
            }
        ]
    })(props);
}
function AiOutlineCloud(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M811.4 418.7C765.6 297.9 648.9 212 512.2 212S258.8 297.8 213 418.6C127.3 441.1 64 519.1 64 612c0 110.5 89.5 200 199.9 200h496.2C870.5 812 960 722.5 960 612c0-92.7-63.1-170.7-148.6-193.3zm36.3 281a123.07 123.07 0 0 1-87.6 36.3H263.9c-33.1 0-64.2-12.9-87.6-36.3A123.3 123.3 0 0 1 140 612c0-28 9.1-54.3 26.2-76.3a125.7 125.7 0 0 1 66.1-43.7l37.9-9.9 13.9-36.6c8.6-22.8 20.6-44.1 35.7-63.4a245.6 245.6 0 0 1 52.4-49.9c41.1-28.9 89.5-44.2 140-44.2s98.9 15.3 140 44.2c19.9 14 37.5 30.8 52.4 49.9 15.1 19.3 27.1 40.7 35.7 63.4l13.8 36.5 37.8 10c54.3 14.5 92.1 63.8 92.1 120 0 33.1-12.9 64.3-36.3 87.7z"
                }
            }
        ]
    })(props);
}
function AiOutlineCluster(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M888 680h-54V540H546v-92h238c8.8 0 16-7.2 16-16V168c0-8.8-7.2-16-16-16H240c-8.8 0-16 7.2-16 16v264c0 8.8 7.2 16 16 16h238v92H190v140h-54c-4.4 0-8 3.6-8 8v176c0 4.4 3.6 8 8 8h176c4.4 0 8-3.6 8-8V688c0-4.4-3.6-8-8-8h-54v-72h220v72h-54c-4.4 0-8 3.6-8 8v176c0 4.4 3.6 8 8 8h176c4.4 0 8-3.6 8-8V688c0-4.4-3.6-8-8-8h-54v-72h220v72h-54c-4.4 0-8 3.6-8 8v176c0 4.4 3.6 8 8 8h176c4.4 0 8-3.6 8-8V688c0-4.4-3.6-8-8-8zM256 805.3c0 1.5-1.2 2.7-2.7 2.7h-58.7c-1.5 0-2.7-1.2-2.7-2.7v-58.7c0-1.5 1.2-2.7 2.7-2.7h58.7c1.5 0 2.7 1.2 2.7 2.7v58.7zm288 0c0 1.5-1.2 2.7-2.7 2.7h-58.7c-1.5 0-2.7-1.2-2.7-2.7v-58.7c0-1.5 1.2-2.7 2.7-2.7h58.7c1.5 0 2.7 1.2 2.7 2.7v58.7zM288 384V216h448v168H288zm544 421.3c0 1.5-1.2 2.7-2.7 2.7h-58.7c-1.5 0-2.7-1.2-2.7-2.7v-58.7c0-1.5 1.2-2.7 2.7-2.7h58.7c1.5 0 2.7 1.2 2.7 2.7v58.7zM360 300a40 40 0 1 0 80 0 40 40 0 1 0-80 0z"
                }
            }
        ]
    })(props);
}
function AiOutlineCodeSandbox(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M709.6 210l.4-.2h.2L512 96 313.9 209.8h-.2l.7.3L151.5 304v416L512 928l360.5-208V304l-162.9-94zM482.7 843.6L339.6 761V621.4L210 547.8V372.9l272.7 157.3v313.4zM238.2 321.5l134.7-77.8 138.9 79.7 139.1-79.9 135.2 78-273.9 158-274-158zM814 548.3l-128.8 73.1v139.1l-143.9 83V530.4L814 373.1v175.2z"
                }
            }
        ]
    })(props);
}
function AiOutlineCode(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M516 673c0 4.4 3.4 8 7.5 8h185c4.1 0 7.5-3.6 7.5-8v-48c0-4.4-3.4-8-7.5-8h-185c-4.1 0-7.5 3.6-7.5 8v48zm-194.9 6.1l192-161c3.8-3.2 3.8-9.1 0-12.3l-192-160.9A7.95 7.95 0 0 0 308 351v62.7c0 2.4 1 4.6 2.9 6.1L420.7 512l-109.8 92.2a8.1 8.1 0 0 0-2.9 6.1V673c0 6.8 7.9 10.5 13.1 6.1zM880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z"
                }
            }
        ]
    })(props);
}
function AiOutlineCodepenCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M488.1 414.7V303.4L300.9 428l83.6 55.8zm254.1 137.7v-79.8l-59.8 39.9zM512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm278 533c0 1.1-.1 2.1-.2 3.1 0 .4-.1.7-.2 1a14.16 14.16 0 0 1-.8 3.2c-.2.6-.4 1.2-.6 1.7-.2.4-.4.8-.5 1.2-.3.5-.5 1.1-.8 1.6-.2.4-.4.7-.7 1.1-.3.5-.7 1-1 1.5-.3.4-.5.7-.8 1-.4.4-.8.9-1.2 1.3-.3.3-.6.6-1 .9-.4.4-.9.8-1.4 1.1-.4.3-.7.6-1.1.8-.1.1-.3.2-.4.3L525.2 786c-4 2.7-8.6 4-13.2 4-4.7 0-9.3-1.4-13.3-4L244.6 616.9c-.1-.1-.3-.2-.4-.3l-1.1-.8c-.5-.4-.9-.7-1.3-1.1-.3-.3-.6-.6-1-.9-.4-.4-.8-.8-1.2-1.3a7 7 0 0 1-.8-1c-.4-.5-.7-1-1-1.5-.2-.4-.5-.7-.7-1.1-.3-.5-.6-1.1-.8-1.6-.2-.4-.4-.8-.5-1.2-.2-.6-.4-1.2-.6-1.7-.1-.4-.3-.8-.4-1.2-.2-.7-.3-1.3-.4-2-.1-.3-.1-.7-.2-1-.1-1-.2-2.1-.2-3.1V427.9c0-1 .1-2.1.2-3.1.1-.3.1-.7.2-1a14.16 14.16 0 0 1 .8-3.2c.2-.6.4-1.2.6-1.7.2-.4.4-.8.5-1.2.2-.5.5-1.1.8-1.6.2-.4.4-.7.7-1.1.6-.9 1.2-1.7 1.8-2.5.4-.4.8-.9 1.2-1.3.3-.3.6-.6 1-.9.4-.4.9-.8 1.3-1.1.4-.3.7-.6 1.1-.8.1-.1.3-.2.4-.3L498.7 239c8-5.3 18.5-5.3 26.5 0l254.1 169.1c.1.1.3.2.4.3l1.1.8 1.4 1.1c.3.3.6.6 1 .9.4.4.8.8 1.2 1.3.7.8 1.3 1.6 1.8 2.5.2.4.5.7.7 1.1.3.5.6 1 .8 1.6.2.4.4.8.5 1.2.2.6.4 1.2.6 1.7.1.4.3.8.4 1.2.2.7.3 1.3.4 2 .1.3.1.7.2 1 .1 1 .2 2.1.2 3.1V597zm-254.1 13.3v111.3L723.1 597l-83.6-55.8zM281.8 472.6v79.8l59.8-39.9zM512 456.1l-84.5 56.4 84.5 56.4 84.5-56.4zM723.1 428L535.9 303.4v111.3l103.6 69.1zM384.5 541.2L300.9 597l187.2 124.6V610.3l-103.6-69.1z"
                }
            }
        ]
    })(props);
}
function AiOutlineCodepen(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M911.7 385.3l-.3-1.5c-.2-1-.3-1.9-.6-2.9-.2-.6-.4-1.1-.5-1.7-.3-.8-.5-1.7-.9-2.5-.2-.6-.5-1.1-.8-1.7-.4-.8-.8-1.5-1.2-2.3-.3-.5-.6-1.1-1-1.6-.8-1.2-1.7-2.4-2.6-3.6-.5-.6-1.1-1.3-1.7-1.9-.4-.5-.9-.9-1.4-1.3-.6-.6-1.3-1.1-1.9-1.6-.5-.4-1-.8-1.6-1.2-.2-.1-.4-.3-.6-.4L531.1 117.8a34.3 34.3 0 0 0-38.1 0L127.3 361.3c-.2.1-.4.3-.6.4-.5.4-1 .8-1.6 1.2-.7.5-1.3 1.1-1.9 1.6-.5.4-.9.9-1.4 1.3-.6.6-1.2 1.2-1.7 1.9-1 1.1-1.8 2.3-2.6 3.6-.3.5-.7 1-1 1.6-.4.7-.8 1.5-1.2 2.3-.3.5-.5 1.1-.8 1.7-.3.8-.6 1.7-.9 2.5-.2.6-.4 1.1-.5 1.7-.2.9-.4 1.9-.6 2.9l-.3 1.5c-.2 1.5-.3 3-.3 4.5v243.5c0 1.5.1 3 .3 4.5l.3 1.5.6 2.9c.2.6.3 1.1.5 1.7.3.9.6 1.7.9 2.5.2.6.5 1.1.8 1.7.4.8.7 1.5 1.2 2.3.3.5.6 1.1 1 1.6.5.7.9 1.4 1.5 2.1l1.2 1.5c.5.6 1.1 1.3 1.7 1.9.4.5.9.9 1.4 1.3.6.6 1.3 1.1 1.9 1.6.5.4 1 .8 1.6 1.2.2.1.4.3.6.4L493 905.7c5.6 3.8 12.3 5.8 19.1 5.8 6.6 0 13.3-1.9 19.1-5.8l365.6-243.5c.2-.1.4-.3.6-.4.5-.4 1-.8 1.6-1.2.7-.5 1.3-1.1 1.9-1.6.5-.4.9-.9 1.4-1.3.6-.6 1.2-1.2 1.7-1.9l1.2-1.5 1.5-2.1c.3-.5.7-1 1-1.6.4-.8.8-1.5 1.2-2.3.3-.5.5-1.1.8-1.7.3-.8.6-1.7.9-2.5.2-.5.4-1.1.5-1.7.3-.9.4-1.9.6-2.9l.3-1.5c.2-1.5.3-3 .3-4.5V389.8c-.3-1.5-.4-3-.6-4.5zM546.4 210.5l269.4 179.4-120.3 80.4-149-99.6V210.5zm-68.8 0v160.2l-149 99.6-120.3-80.4 269.3-179.4zM180.7 454.1l86 57.5-86 57.5v-115zm296.9 358.5L208.3 633.2l120.3-80.4 149 99.6v160.2zM512 592.8l-121.6-81.2L512 430.3l121.6 81.2L512 592.8zm34.4 219.8V652.4l149-99.6 120.3 80.4-269.3 179.4zM843.3 569l-86-57.5 86-57.5v115z"
                }
            }
        ]
    })(props);
}
function AiOutlineCoffee(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M275 281c19.9 0 36-16.1 36-36V36c0-19.9-16.1-36-36-36s-36 16.1-36 36v209c0 19.9 16.1 36 36 36zm613 144H768c0-39.8-32.2-72-72-72H200c-39.8 0-72 32.2-72 72v248c0 3.4.2 6.7.7 9.9-.5 7-.7 14-.7 21.1 0 176.7 143.3 320 320 320 160.1 0 292.7-117.5 316.3-271H888c39.8 0 72-32.2 72-72V497c0-39.8-32.2-72-72-72zM696 681h-1.1c.7 7.6 1.1 15.2 1.1 23 0 137-111 248-248 248S200 841 200 704c0-7.8.4-15.4 1.1-23H200V425h496v256zm192-8H776V497h112v176zM613 281c19.9 0 36-16.1 36-36V36c0-19.9-16.1-36-36-36s-36 16.1-36 36v209c0 19.9 16.1 36 36 36zm-170 0c19.9 0 36-16.1 36-36V36c0-19.9-16.1-36-36-36s-36 16.1-36 36v209c0 19.9 16.1 36 36 36z"
                }
            }
        ]
    })(props);
}
function AiOutlineColumnHeight(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M840 836H184c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h656c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8zm0-724H184c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h656c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8zM610.8 378c6 0 9.4-7 5.7-11.7L515.7 238.7a7.14 7.14 0 0 0-11.3 0L403.6 366.3a7.23 7.23 0 0 0 5.7 11.7H476v268h-62.8c-6 0-9.4 7-5.7 11.7l100.8 127.5c2.9 3.7 8.5 3.7 11.3 0l100.8-127.5c3.7-4.7.4-11.7-5.7-11.7H548V378h62.8z"
                }
            }
        ]
    })(props);
}
function AiOutlineColumnWidth(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M180 176h-60c-4.4 0-8 3.6-8 8v656c0 4.4 3.6 8 8 8h60c4.4 0 8-3.6 8-8V184c0-4.4-3.6-8-8-8zm724 0h-60c-4.4 0-8 3.6-8 8v656c0 4.4 3.6 8 8 8h60c4.4 0 8-3.6 8-8V184c0-4.4-3.6-8-8-8zM785.3 504.3L657.7 403.6a7.23 7.23 0 0 0-11.7 5.7V476H378v-62.8c0-6-7-9.4-11.7-5.7L238.7 508.3a7.14 7.14 0 0 0 0 11.3l127.5 100.8c4.7 3.7 11.7.4 11.7-5.7V548h268v62.8c0 6 7 9.4 11.7 5.7l127.5-100.8c3.8-2.9 3.8-8.5.2-11.4z"
                }
            }
        ]
    })(props);
}
function AiOutlineComment(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "t": "1569682881658",
            "viewBox": "0 0 1024 1024",
            "version": "1.1"
        },
        "child": [
            {
                "tag": "defs",
                "attr": {},
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M573 421c-23.1 0-41 17.9-41 40s17.9 40 41 40c21.1 0 39-17.9 39-40s-17.9-40-39-40zM293 421c-23.1 0-41 17.9-41 40s17.9 40 41 40c21.1 0 39-17.9 39-40s-17.9-40-39-40z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M894 345c-48.1-66-115.3-110.1-189-130v0.1c-17.1-19-36.4-36.5-58-52.1-163.7-119-393.5-82.7-513 81-96.3 133-92.2 311.9 6 439l0.8 132.6c0 3.2 0.5 6.4 1.5 9.4 5.3 16.9 23.3 26.2 40.1 20.9L309 806c33.5 11.9 68.1 18.7 102.5 20.6l-0.5 0.4c89.1 64.9 205.9 84.4 313 49l127.1 41.4c3.2 1 6.5 1.6 9.9 1.6 17.7 0 32-14.3 32-32V753c88.1-119.6 90.4-284.9 1-408zM323 735l-12-5-99 31-1-104-8-9c-84.6-103.2-90.2-251.9-11-361 96.4-132.2 281.2-161.4 413-66 132.2 96.1 161.5 280.6 66 412-80.1 109.9-223.5 150.5-348 102z m505-17l-8 10 1 104-98-33-12 5c-56 20.8-115.7 22.5-171 7l-0.2-0.1C613.7 788.2 680.7 742.2 729 676c76.4-105.3 88.8-237.6 44.4-350.4l0.6 0.4c23 16.5 44.1 37.1 62 62 72.6 99.6 68.5 235.2-8 330z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M433 421c-23.1 0-41 17.9-41 40s17.9 40 41 40c21.1 0 39-17.9 39-40s-17.9-40-39-40z"
                }
            }
        ]
    })(props);
}
function AiOutlineCompass(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372zm198.4-588.1a32 32 0 0 0-24.5.5L414.9 415 296.4 686c-3.6 8.2-3.6 17.5 0 25.7 3.4 7.8 9.7 13.9 17.7 17 3.8 1.5 7.7 2.2 11.7 2.2 4.4 0 8.7-.9 12.8-2.7l271-118.6 118.5-271a32.06 32.06 0 0 0-17.7-42.7zM576.8 534.4l26.2 26.2-42.4 42.4-26.2-26.2L380 644.4 447.5 490 422 464.4l42.4-42.4 25.5 25.5L644.4 380l-67.6 154.4zM464.4 422L422 464.4l25.5 25.6 86.9 86.8 26.2 26.2 42.4-42.4-26.2-26.2-86.8-86.9z"
                }
            }
        ]
    })(props);
}
function AiOutlineCompress(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "t": "1569683667781",
            "viewBox": "0 0 1024 1024",
            "version": "1.1"
        },
        "child": [
            {
                "tag": "defs",
                "attr": {},
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M326 664H104c-8.8 0-16 7.2-16 16v48c0 8.8 7.2 16 16 16h174v176c0 8.8 7.2 16 16 16h48c8.8 0 16-7.2 16-16V696c0-17.7-14.3-32-32-32zM342 88h-48c-8.8 0-16 7.2-16 16v176H104c-8.8 0-16 7.2-16 16v48c0 8.8 7.2 16 16 16h222c17.7 0 32-14.3 32-32V104c0-8.8-7.2-16-16-16zM920 664H698c-17.7 0-32 14.3-32 32v224c0 8.8 7.2 16 16 16h48c8.8 0 16-7.2 16-16V744h174c8.8 0 16-7.2 16-16v-48c0-8.8-7.2-16-16-16zM920 280H746V104c0-8.8-7.2-16-16-16h-48c-8.8 0-16 7.2-16 16v224c0 17.7 14.3 32 32 32h222c8.8 0 16-7.2 16-16v-48c0-8.8-7.2-16-16-16z"
                }
            }
        ]
    })(props);
}
function AiOutlineConsoleSql(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "t": "1569683650778",
            "viewBox": "0 0 1024 1024",
            "version": "1.1"
        },
        "child": [
            {
                "tag": "defs",
                "attr": {},
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M301.3 496.7c-23.8 0-40.2-10.5-41.6-26.9H205c0.9 43.4 36.9 70.3 93.9 70.3 59.1 0 95-28.4 95-75.5 0-35.8-20-55.9-64.5-64.5l-29.1-5.6c-23.8-4.7-33.8-11.9-33.8-24.2 0-15 13.3-24.5 33.4-24.5 20.1 0 35.3 11.1 36.6 27h53c-0.9-41.7-37.5-70.3-90.3-70.3-54.4 0-89.7 28.9-89.7 73 0 35.5 21.2 58 62.5 65.8l29.7 5.9c25.8 5.2 35.6 11.9 35.6 24.4 0.1 14.7-14.5 25.1-36 25.1z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M928 140H96c-17.7 0-32 14.3-32 32v496c0 17.7 14.3 32 32 32h380v112H304c-8.8 0-16 7.2-16 16v48c0 4.4 3.6 8 8 8h432c4.4 0 8-3.6 8-8v-48c0-8.8-7.2-16-16-16H548V700h380c17.7 0 32-14.3 32-32V172c0-17.7-14.3-32-32-32z m-40 488H136V212h752v416z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M828.5 486.7h-95.8V308.5h-57.4V534h153.2zM529.9 540.1c14.1 0 27.2-2 39.1-5.8l13.3 20.3h53.3L607.9 511c21.1-20 33-51.1 33-89.8 0-73.3-43.3-118.8-110.9-118.8s-111.2 45.3-111.2 118.8c-0.1 73.7 43 118.9 111.1 118.9z m0-190c31.6 0 52.7 27.7 52.7 71.1 0 16.7-3.6 30.6-10 40.5l-5.2-6.9h-48.8L542 491c-3.9 0.9-8 1.4-12.2 1.4-31.7 0-52.8-27.5-52.8-71.2 0.1-43.6 21.2-71.1 52.9-71.1z"
                }
            }
        ]
    })(props);
}
function AiOutlineContacts(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M594.3 601.5a111.8 111.8 0 0 0 29.1-75.5c0-61.9-49.9-112-111.4-112s-111.4 50.1-111.4 112c0 29.1 11 55.5 29.1 75.5a158.09 158.09 0 0 0-74.6 126.1 8 8 0 0 0 8 8.4H407c4.2 0 7.6-3.3 7.9-7.5 3.8-50.6 46-90.5 97.2-90.5s93.4 40 97.2 90.5c.3 4.2 3.7 7.5 7.9 7.5H661a8 8 0 0 0 8-8.4c-2.8-53.3-32-99.7-74.7-126.1zM512 578c-28.5 0-51.7-23.3-51.7-52s23.2-52 51.7-52 51.7 23.3 51.7 52-23.2 52-51.7 52zm416-354H768v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56H548v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56H328v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56H96c-17.7 0-32 14.3-32 32v576c0 17.7 14.3 32 32 32h832c17.7 0 32-14.3 32-32V256c0-17.7-14.3-32-32-32zm-40 568H136V296h120v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56h148v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56h148v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56h120v496z"
                }
            }
        ]
    })(props);
}
function AiOutlineContainer(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M832 64H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32zm-40 824H232V687h97.9c11.6 32.8 32 62.3 59.1 84.7 34.5 28.5 78.2 44.3 123 44.3s88.5-15.7 123-44.3c27.1-22.4 47.5-51.9 59.1-84.7H792v-63H643.6l-5.2 24.7C626.4 708.5 573.2 752 512 752s-114.4-43.5-126.5-103.3l-5.2-24.7H232V136h560v752zM320 341h384c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H320c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8zm0 160h384c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H320c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8z"
                }
            }
        ]
    })(props);
}
function AiOutlineControl(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656zM340 683v77c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8v-77c-10.1 3.3-20.8 5-32 5s-21.9-1.8-32-5zm64-198V264c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v221c10.1-3.3 20.8-5 32-5s21.9 1.8 32 5zm-64 198c10.1 3.3 20.8 5 32 5s21.9-1.8 32-5c41.8-13.5 72-52.7 72-99s-30.2-85.5-72-99c-10.1-3.3-20.8-5-32-5s-21.9 1.8-32 5c-41.8 13.5-72 52.7-72 99s30.2 85.5 72 99zm.1-115.7c.3-.6.7-1.2 1-1.8v-.1l1.2-1.8c.1-.2.2-.3.3-.5.3-.5.7-.9 1-1.4.1-.1.2-.3.3-.4.5-.6.9-1.1 1.4-1.6l.3-.3 1.2-1.2.4-.4c.5-.5 1-.9 1.6-1.4.6-.5 1.1-.9 1.7-1.3.2-.1.3-.2.5-.3.5-.3.9-.7 1.4-1 .1-.1.3-.2.4-.3.6-.4 1.2-.7 1.9-1.1.1-.1.3-.1.4-.2.5-.3 1-.5 1.6-.8l.6-.3c.7-.3 1.3-.6 2-.8.7-.3 1.4-.5 2.1-.7.2-.1.4-.1.6-.2.6-.2 1.1-.3 1.7-.4.2 0 .3-.1.5-.1.7-.2 1.5-.3 2.2-.4.2 0 .3 0 .5-.1.6-.1 1.2-.1 1.8-.2h.6c.8 0 1.5-.1 2.3-.1s1.5 0 2.3.1h.6c.6 0 1.2.1 1.8.2.2 0 .3 0 .5.1.7.1 1.5.2 2.2.4.2 0 .3.1.5.1.6.1 1.2.3 1.7.4.2.1.4.1.6.2.7.2 1.4.4 2.1.7.7.2 1.3.5 2 .8l.6.3c.5.2 1.1.5 1.6.8.1.1.3.1.4.2.6.3 1.3.7 1.9 1.1.1.1.3.2.4.3.5.3 1 .6 1.4 1 .2.1.3.2.5.3.6.4 1.2.9 1.7 1.3s1.1.9 1.6 1.4l.4.4 1.2 1.2.3.3c.5.5 1 1.1 1.4 1.6.1.1.2.3.3.4.4.4.7.9 1 1.4.1.2.2.3.3.5l1.2 1.8s0 .1.1.1a36.18 36.18 0 0 1 5.1 18.5c0 6-1.5 11.7-4.1 16.7-.3.6-.7 1.2-1 1.8 0 0 0 .1-.1.1l-1.2 1.8c-.1.2-.2.3-.3.5-.3.5-.7.9-1 1.4-.1.1-.2.3-.3.4-.5.6-.9 1.1-1.4 1.6l-.3.3-1.2 1.2-.4.4c-.5.5-1 .9-1.6 1.4-.6.5-1.1.9-1.7 1.3-.2.1-.3.2-.5.3-.5.3-.9.7-1.4 1-.1.1-.3.2-.4.3-.6.4-1.2.7-1.9 1.1-.1.1-.3.1-.4.2-.5.3-1 .5-1.6.8l-.6.3c-.7.3-1.3.6-2 .8-.7.3-1.4.5-2.1.7-.2.1-.4.1-.6.2-.6.2-1.1.3-1.7.4-.2 0-.3.1-.5.1-.7.2-1.5.3-2.2.4-.2 0-.3 0-.5.1-.6.1-1.2.1-1.8.2h-.6c-.8 0-1.5.1-2.3.1s-1.5 0-2.3-.1h-.6c-.6 0-1.2-.1-1.8-.2-.2 0-.3 0-.5-.1-.7-.1-1.5-.2-2.2-.4-.2 0-.3-.1-.5-.1-.6-.1-1.2-.3-1.7-.4-.2-.1-.4-.1-.6-.2-.7-.2-1.4-.4-2.1-.7-.7-.2-1.3-.5-2-.8l-.6-.3c-.5-.2-1.1-.5-1.6-.8-.1-.1-.3-.1-.4-.2-.6-.3-1.3-.7-1.9-1.1-.1-.1-.3-.2-.4-.3-.5-.3-1-.6-1.4-1-.2-.1-.3-.2-.5-.3-.6-.4-1.2-.9-1.7-1.3s-1.1-.9-1.6-1.4l-.4-.4-1.2-1.2-.3-.3c-.5-.5-1-1.1-1.4-1.6-.1-.1-.2-.3-.3-.4-.4-.4-.7-.9-1-1.4-.1-.2-.2-.3-.3-.5l-1.2-1.8v-.1c-.4-.6-.7-1.2-1-1.8-2.6-5-4.1-10.7-4.1-16.7s1.5-11.7 4.1-16.7zM620 539v221c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V539c-10.1 3.3-20.8 5-32 5s-21.9-1.8-32-5zm64-198v-77c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v77c10.1-3.3 20.8-5 32-5s21.9 1.8 32 5zm-64 198c10.1 3.3 20.8 5 32 5s21.9-1.8 32-5c41.8-13.5 72-52.7 72-99s-30.2-85.5-72-99c-10.1-3.3-20.8-5-32-5s-21.9 1.8-32 5c-41.8 13.5-72 52.7-72 99s30.2 85.5 72 99zm.1-115.7c.3-.6.7-1.2 1-1.8v-.1l1.2-1.8c.1-.2.2-.3.3-.5.3-.5.7-.9 1-1.4.1-.1.2-.3.3-.4.5-.6.9-1.1 1.4-1.6l.3-.3 1.2-1.2.4-.4c.5-.5 1-.9 1.6-1.4.6-.5 1.1-.9 1.7-1.3.2-.1.3-.2.5-.3.5-.3.9-.7 1.4-1 .1-.1.3-.2.4-.3.6-.4 1.2-.7 1.9-1.1.1-.1.3-.1.4-.2.5-.3 1-.5 1.6-.8l.6-.3c.7-.3 1.3-.6 2-.8.7-.3 1.4-.5 2.1-.7.2-.1.4-.1.6-.2.6-.2 1.1-.3 1.7-.4.2 0 .3-.1.5-.1.7-.2 1.5-.3 2.2-.4.2 0 .3 0 .5-.1.6-.1 1.2-.1 1.8-.2h.6c.8 0 1.5-.1 2.3-.1s1.5 0 2.3.1h.6c.6 0 1.2.1 1.8.2.2 0 .3 0 .5.1.7.1 1.5.2 2.2.4.2 0 .3.1.5.1.6.1 1.2.3 1.7.4.2.1.4.1.6.2.7.2 1.4.4 2.1.7.7.2 1.3.5 2 .8l.6.3c.5.2 1.1.5 1.6.8.1.1.3.1.4.2.6.3 1.3.7 1.9 1.1.1.1.3.2.4.3.5.3 1 .6 1.4 1 .2.1.3.2.5.3.6.4 1.2.9 1.7 1.3s1.1.9 1.6 1.4l.4.4 1.2 1.2.3.3c.5.5 1 1.1 1.4 1.6.1.1.2.3.3.4.4.4.7.9 1 1.4.1.2.2.3.3.5l1.2 1.8v.1a36.18 36.18 0 0 1 5.1 18.5c0 6-1.5 11.7-4.1 16.7-.3.6-.7 1.2-1 1.8v.1l-1.2 1.8c-.1.2-.2.3-.3.5-.3.5-.7.9-1 1.4-.1.1-.2.3-.3.4-.5.6-.9 1.1-1.4 1.6l-.3.3-1.2 1.2-.4.4c-.5.5-1 .9-1.6 1.4-.6.5-1.1.9-1.7 1.3-.2.1-.3.2-.5.3-.5.3-.9.7-1.4 1-.1.1-.3.2-.4.3-.6.4-1.2.7-1.9 1.1-.1.1-.3.1-.4.2-.5.3-1 .5-1.6.8l-.6.3c-.7.3-1.3.6-2 .8-.7.3-1.4.5-2.1.7-.2.1-.4.1-.6.2-.6.2-1.1.3-1.7.4-.2 0-.3.1-.5.1-.7.2-1.5.3-2.2.4-.2 0-.3 0-.5.1-.6.1-1.2.1-1.8.2h-.6c-.8 0-1.5.1-2.3.1s-1.5 0-2.3-.1h-.6c-.6 0-1.2-.1-1.8-.2-.2 0-.3 0-.5-.1-.7-.1-1.5-.2-2.2-.4-.2 0-.3-.1-.5-.1-.6-.1-1.2-.3-1.7-.4-.2-.1-.4-.1-.6-.2-.7-.2-1.4-.4-2.1-.7-.7-.2-1.3-.5-2-.8l-.6-.3c-.5-.2-1.1-.5-1.6-.8-.1-.1-.3-.1-.4-.2-.6-.3-1.3-.7-1.9-1.1-.1-.1-.3-.2-.4-.3-.5-.3-1-.6-1.4-1-.2-.1-.3-.2-.5-.3-.6-.4-1.2-.9-1.7-1.3s-1.1-.9-1.6-1.4l-.4-.4-1.2-1.2-.3-.3c-.5-.5-1-1.1-1.4-1.6-.1-.1-.2-.3-.3-.4-.4-.4-.7-.9-1-1.4-.1-.2-.2-.3-.3-.5l-1.2-1.8v-.1c-.4-.6-.7-1.2-1-1.8-2.6-5-4.1-10.7-4.1-16.7s1.5-11.7 4.1-16.7z"
                }
            }
        ]
    })(props);
}
function AiOutlineCopy(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M832 64H296c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h496v688c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V96c0-17.7-14.3-32-32-32zM704 192H192c-17.7 0-32 14.3-32 32v530.7c0 8.5 3.4 16.6 9.4 22.6l173.3 173.3c2.2 2.2 4.7 4 7.4 5.5v1.9h4.2c3.5 1.3 7.2 2 11 2H704c17.7 0 32-14.3 32-32V224c0-17.7-14.3-32-32-32zM350 856.2L263.9 770H350v86.2zM664 888H414V746c0-22.1-17.9-40-40-40H232V264h432v624z"
                }
            }
        ]
    })(props);
}
function AiOutlineCopyrightCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372zm5.6-532.7c53 0 89 33.8 93 83.4.3 4.2 3.8 7.4 8 7.4h56.7c2.6 0 4.7-2.1 4.7-4.7 0-86.7-68.4-147.4-162.7-147.4C407.4 290 344 364.2 344 486.8v52.3C344 660.8 407.4 734 517.3 734c94 0 162.7-58.8 162.7-141.4 0-2.6-2.1-4.7-4.7-4.7h-56.8c-4.2 0-7.6 3.2-8 7.3-4.2 46.1-40.1 77.8-93 77.8-65.3 0-102.1-47.9-102.1-133.6v-52.6c.1-87 37-135.5 102.2-135.5z"
                }
            }
        ]
    })(props);
}
function AiOutlineCopyright(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372zm5.6-532.7c53 0 89 33.8 93 83.4.3 4.2 3.8 7.4 8 7.4h56.7c2.6 0 4.7-2.1 4.7-4.7 0-86.7-68.4-147.4-162.7-147.4C407.4 290 344 364.2 344 486.8v52.3C344 660.8 407.4 734 517.3 734c94 0 162.7-58.8 162.7-141.4 0-2.6-2.1-4.7-4.7-4.7h-56.8c-4.2 0-7.6 3.2-8 7.3-4.2 46.1-40.1 77.8-93 77.8-65.3 0-102.1-47.9-102.1-133.6v-52.6c.1-87 37-135.5 102.2-135.5z"
                }
            }
        ]
    })(props);
}
function AiOutlineCreditCard(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M928 160H96c-17.7 0-32 14.3-32 32v640c0 17.7 14.3 32 32 32h832c17.7 0 32-14.3 32-32V192c0-17.7-14.3-32-32-32zm-792 72h752v120H136V232zm752 560H136V440h752v352zm-237-64h165c4.4 0 8-3.6 8-8v-72c0-4.4-3.6-8-8-8H651c-4.4 0-8 3.6-8 8v72c0 4.4 3.6 8 8 8z"
                }
            }
        ]
    })(props);
}
function AiOutlineCrown(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M899.6 276.5L705 396.4 518.4 147.5a8.06 8.06 0 0 0-12.9 0L319 396.4 124.3 276.5c-5.7-3.5-13.1 1.2-12.2 7.9L188.5 865c1.1 7.9 7.9 14 16 14h615.1c8 0 14.9-6 15.9-14l76.4-580.6c.8-6.7-6.5-11.4-12.3-7.9zm-126 534.1H250.3l-53.8-409.4 139.8 86.1L512 252.9l175.7 234.4 139.8-86.1-53.9 409.4zM512 509c-62.1 0-112.6 50.5-112.6 112.6S449.9 734.2 512 734.2s112.6-50.5 112.6-112.6S574.1 509 512 509zm0 160.9c-26.6 0-48.2-21.6-48.2-48.3 0-26.6 21.6-48.3 48.2-48.3s48.2 21.6 48.2 48.3c0 26.6-21.6 48.3-48.2 48.3z"
                }
            }
        ]
    })(props);
}
function AiOutlineCustomerService(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M512 128c-212.1 0-384 171.9-384 384v360c0 13.3 10.7 24 24 24h184c35.3 0 64-28.7 64-64V624c0-35.3-28.7-64-64-64H200v-48c0-172.3 139.7-312 312-312s312 139.7 312 312v48H688c-35.3 0-64 28.7-64 64v208c0 35.3 28.7 64 64 64h184c13.3 0 24-10.7 24-24V512c0-212.1-171.9-384-384-384zM328 632v192H200V632h128zm496 192H696V632h128v192z"
                }
            }
        ]
    })(props);
}
function AiOutlineDash(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M112 476h160v72H112zm320 0h160v72H432zm320 0h160v72H752z"
                }
            }
        ]
    })(props);
}
function AiOutlineDashboard(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M924.8 385.6a446.7 446.7 0 0 0-96-142.4 446.7 446.7 0 0 0-142.4-96C631.1 123.8 572.5 112 512 112s-119.1 11.8-174.4 35.2a446.7 446.7 0 0 0-142.4 96 446.7 446.7 0 0 0-96 142.4C75.8 440.9 64 499.5 64 560c0 132.7 58.3 257.7 159.9 343.1l1.7 1.4c5.8 4.8 13.1 7.5 20.6 7.5h531.7c7.5 0 14.8-2.7 20.6-7.5l1.7-1.4C901.7 817.7 960 692.7 960 560c0-60.5-11.9-119.1-35.2-174.4zM761.4 836H262.6A371.12 371.12 0 0 1 140 560c0-99.4 38.7-192.8 109-263 70.3-70.3 163.7-109 263-109 99.4 0 192.8 38.7 263 109 70.3 70.3 109 163.7 109 263 0 105.6-44.5 205.5-122.6 276zM623.5 421.5a8.03 8.03 0 0 0-11.3 0L527.7 506c-18.7-5-39.4-.2-54.1 14.5a55.95 55.95 0 0 0 0 79.2 55.95 55.95 0 0 0 79.2 0 55.87 55.87 0 0 0 14.5-54.1l84.5-84.5c3.1-3.1 3.1-8.2 0-11.3l-28.3-28.3zM490 320h44c4.4 0 8-3.6 8-8v-80c0-4.4-3.6-8-8-8h-44c-4.4 0-8 3.6-8 8v80c0 4.4 3.6 8 8 8zm260 218v44c0 4.4 3.6 8 8 8h80c4.4 0 8-3.6 8-8v-44c0-4.4-3.6-8-8-8h-80c-4.4 0-8 3.6-8 8zm12.7-197.2l-31.1-31.1a8.03 8.03 0 0 0-11.3 0l-56.6 56.6a8.03 8.03 0 0 0 0 11.3l31.1 31.1c3.1 3.1 8.2 3.1 11.3 0l56.6-56.6c3.1-3.1 3.1-8.2 0-11.3zm-458.6-31.1a8.03 8.03 0 0 0-11.3 0l-31.1 31.1a8.03 8.03 0 0 0 0 11.3l56.6 56.6c3.1 3.1 8.2 3.1 11.3 0l31.1-31.1c3.1-3.1 3.1-8.2 0-11.3l-56.6-56.6zM262 530h-80c-4.4 0-8 3.6-8 8v44c0 4.4 3.6 8 8 8h80c4.4 0 8-3.6 8-8v-44c0-4.4-3.6-8-8-8z"
                }
            }
        ]
    })(props);
}
function AiOutlineDatabase(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M832 64H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32zm-600 72h560v208H232V136zm560 480H232V408h560v208zm0 272H232V680h560v208zM304 240a40 40 0 1 0 80 0 40 40 0 1 0-80 0zm0 272a40 40 0 1 0 80 0 40 40 0 1 0-80 0zm0 272a40 40 0 1 0 80 0 40 40 0 1 0-80 0z"
                }
            }
        ]
    })(props);
}
function AiOutlineDeleteColumn(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "t": "1569683386799",
            "viewBox": "0 0 1024 1024",
            "version": "1.1"
        },
        "child": [
            {
                "tag": "defs",
                "attr": {},
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M651.1 641.9c-1.4-1.2-3.2-1.9-5.1-1.9h-54.7c-2.4 0-4.6 1.1-6.1 2.9L512 730.7l-73.1-87.8c-1.5-1.8-3.8-2.9-6.1-2.9H378c-1.9 0-3.7 0.7-5.1 1.9-3.4 2.8-3.9 7.9-1 11.3L474.2 776 371.8 898.9c-2.8 3.4-2.4 8.4 1 11.3 1.4 1.2 3.2 1.9 5.1 1.9h54.7c2.4 0 4.6-1.1 6.1-2.9l73.1-87.8 73.1 87.8c1.5 1.8 3.8 2.9 6.1 2.9h55c1.9 0 3.7-0.7 5.1-1.9 3.4-2.8 3.9-7.9 1-11.3L549.8 776l102.4-122.9c2.8-3.4 2.3-8.4-1.1-11.2zM472 544h80c4.4 0 8-3.6 8-8V120c0-4.4-3.6-8-8-8h-80c-4.4 0-8 3.6-8 8v416c0 4.4 3.6 8 8 8zM350 386H184V136c0-3.3-2.7-6-6-6h-60c-3.3 0-6 2.7-6 6v292c0 16.6 13.4 30 30 30h208c3.3 0 6-2.7 6-6v-60c0-3.3-2.7-6-6-6zM906 130h-60c-3.3 0-6 2.7-6 6v250H674c-3.3 0-6 2.7-6 6v60c0 3.3 2.7 6 6 6h208c16.6 0 30-13.4 30-30V136c0-3.3-2.7-6-6-6z"
                }
            }
        ]
    })(props);
}
function AiOutlineDeleteRow(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "t": "1569683582196",
            "viewBox": "0 0 1024 1024",
            "version": "1.1"
        },
        "child": [
            {
                "tag": "defs",
                "attr": {},
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M819.8 512l102.4-122.9c2.8-3.4 2.4-8.4-1-11.3-1.4-1.2-3.2-1.9-5.1-1.9h-54.7c-2.4 0-4.6 1.1-6.1 2.9L782 466.7l-73.1-87.8c-1.5-1.8-3.8-2.9-6.1-2.9H648c-1.9 0-3.7 0.7-5.1 1.9-3.4 2.8-3.9 7.9-1 11.3L744.2 512 641.8 634.9c-2.8 3.4-2.4 8.4 1 11.3 1.4 1.2 3.2 1.9 5.1 1.9h54.7c2.4 0 4.6-1.1 6.1-2.9l73.1-87.8 73.1 87.8c1.5 1.8 3.8 2.9 6.1 2.9h55c1.9 0 3.7-0.7 5.1-1.9 3.4-2.8 3.9-7.9 1-11.3L819.8 512zM536 464H120c-4.4 0-8 3.6-8 8v80c0 4.4 3.6 8 8 8h416c4.4 0 8-3.6 8-8v-80c0-4.4-3.6-8-8-8zM452 668h-60c-3.3 0-6 2.7-6 6v166H136c-3.3 0-6 2.7-6 6v60c0 3.3 2.7 6 6 6h292c16.6 0 30-13.4 30-30V674c0-3.3-2.7-6-6-6zM136 184h250v166c0 3.3 2.7 6 6 6h60c3.3 0 6-2.7 6-6V142c0-16.6-13.4-30-30-30H136c-3.3 0-6 2.7-6 6v60c0 3.3 2.7 6 6 6z"
                }
            }
        ]
    })(props);
}
function AiOutlineDelete(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M360 184h-8c4.4 0 8-3.6 8-8v8h304v-8c0 4.4 3.6 8 8 8h-8v72h72v-80c0-35.3-28.7-64-64-64H352c-35.3 0-64 28.7-64 64v80h72v-72zm504 72H160c-17.7 0-32 14.3-32 32v32c0 4.4 3.6 8 8 8h60.4l24.7 523c1.6 34.1 29.8 61 63.9 61h454c34.2 0 62.3-26.8 63.9-61l24.7-523H888c4.4 0 8-3.6 8-8v-32c0-17.7-14.3-32-32-32zM731.3 840H292.7l-24.2-512h487l-24.2 512z"
                }
            }
        ]
    })(props);
}
function AiOutlineDeliveredProcedure(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "t": "1569683642448",
            "viewBox": "0 0 1024 1024",
            "version": "1.1"
        },
        "child": [
            {
                "tag": "defs",
                "attr": {},
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M632 698.3l141.9-112c4.1-3.2 4.1-9.4 0-12.6L632 461.7c-5.3-4.2-13-0.4-13 6.3v76H295c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h324v76c0 6.7 7.8 10.4 13 6.3zM893.3 293.3L730.7 130.7c-7.5-7.5-16.7-13-26.7-16V112H144c-17.7 0-32 14.3-32 32v278c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V184h136v136c0 17.7 14.3 32 32 32h320c17.7 0 32-14.3 32-32V205.8l136 136V422c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-83.5c0-17-6.7-33.2-18.7-45.2zM640 288H384V184h256v104zM904 724h-56c-4.4 0-8 3.6-8 8v108H184V732c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v148c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V732c0-4.4-3.6-8-8-8z"
                }
            }
        ]
    })(props);
}
function AiOutlineDeploymentUnit(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M888.3 693.2c-42.5-24.6-94.3-18-129.2 12.8l-53-30.7V523.6c0-15.7-8.4-30.3-22-38.1l-136-78.3v-67.1c44.2-15 76-56.8 76-106.1 0-61.9-50.1-112-112-112s-112 50.1-112 112c0 49.3 31.8 91.1 76 106.1v67.1l-136 78.3c-13.6 7.8-22 22.4-22 38.1v151.6l-53 30.7c-34.9-30.8-86.8-37.4-129.2-12.8-53.5 31-71.7 99.4-41 152.9 30.8 53.5 98.9 71.9 152.2 41 42.5-24.6 62.7-73 53.6-118.8l48.7-28.3 140.6 81c6.8 3.9 14.4 5.9 22 5.9s15.2-2 22-5.9L674.5 740l48.7 28.3c-9.1 45.7 11.2 94.2 53.6 118.8 53.3 30.9 121.5 12.6 152.2-41 30.8-53.6 12.6-122-40.7-152.9zm-673 138.4a47.6 47.6 0 0 1-65.2-17.6c-13.2-22.9-5.4-52.3 17.5-65.5a47.6 47.6 0 0 1 65.2 17.6c13.2 22.9 5.4 52.3-17.5 65.5zM522 463.8zM464 234a48.01 48.01 0 0 1 96 0 48.01 48.01 0 0 1-96 0zm170 446.2l-122 70.3-122-70.3V539.8l122-70.3 122 70.3v140.4zm239.9 133.9c-13.2 22.9-42.4 30.8-65.2 17.6-22.8-13.2-30.7-42.6-17.5-65.5s42.4-30.8 65.2-17.6c22.9 13.2 30.7 42.5 17.5 65.5z"
                }
            }
        ]
    })(props);
}
function AiOutlineDesktop(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M928 140H96c-17.7 0-32 14.3-32 32v496c0 17.7 14.3 32 32 32h380v112H304c-8.8 0-16 7.2-16 16v48c0 4.4 3.6 8 8 8h432c4.4 0 8-3.6 8-8v-48c0-8.8-7.2-16-16-16H548V700h380c17.7 0 32-14.3 32-32V172c0-17.7-14.3-32-32-32zm-40 488H136V212h752v416z"
                }
            }
        ]
    })(props);
}
function AiOutlineDiff(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M476 399.1c0-3.9-3.1-7.1-7-7.1h-42c-3.8 0-7 3.2-7 7.1V484h-84.5c-4.1 0-7.5 3.1-7.5 7v42c0 3.8 3.4 7 7.5 7H420v84.9c0 3.9 3.2 7.1 7 7.1h42c3.9 0 7-3.2 7-7.1V540h84.5c4.1 0 7.5-3.2 7.5-7v-42c0-3.9-3.4-7-7.5-7H476v-84.9zM560.5 704h-225c-4.1 0-7.5 3.2-7.5 7v42c0 3.8 3.4 7 7.5 7h225c4.1 0 7.5-3.2 7.5-7v-42c0-3.8-3.4-7-7.5-7zm-7.1-502.6c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v704c0 17.7 14.3 32 32 32h512c17.7 0 32-14.3 32-32V397.3c0-8.5-3.4-16.6-9.4-22.6L553.4 201.4zM664 888H232V264h282.2L664 413.8V888zm190.2-581.4L611.3 72.9c-6-5.7-13.9-8.9-22.2-8.9H296c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h277l219 210.6V824c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V329.6c0-8.7-3.5-17-9.8-23z"
                }
            }
        ]
    })(props);
}
function AiOutlineDingding(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M573.7 252.5C422.5 197.4 201.3 96.7 201.3 96.7c-15.7-4.1-17.9 11.1-17.9 11.1-5 61.1 33.6 160.5 53.6 182.8 19.9 22.3 319.1 113.7 319.1 113.7S326 357.9 270.5 341.9c-55.6-16-37.9 17.8-37.9 17.8 11.4 61.7 64.9 131.8 107.2 138.4 42.2 6.6 220.1 4 220.1 4s-35.5 4.1-93.2 11.9c-42.7 5.8-97 12.5-111.1 17.8-33.1 12.5 24 62.6 24 62.6 84.7 76.8 129.7 50.5 129.7 50.5 33.3-10.7 61.4-18.5 85.2-24.2L565 743.1h84.6L603 928l205.3-271.9H700.8l22.3-38.7c.3.5.4.8.4.8S799.8 496.1 829 433.8l.6-1h-.1c5-10.8 8.6-19.7 10-25.8 17-71.3-114.5-99.4-265.8-154.5z"
                }
            }
        ]
    })(props);
}
function AiOutlineDingtalk(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M573.7 252.5C422.5 197.4 201.3 96.7 201.3 96.7c-15.7-4.1-17.9 11.1-17.9 11.1-5 61.1 33.6 160.5 53.6 182.8 19.9 22.3 319.1 113.7 319.1 113.7S326 357.9 270.5 341.9c-55.6-16-37.9 17.8-37.9 17.8 11.4 61.7 64.9 131.8 107.2 138.4 42.2 6.6 220.1 4 220.1 4s-35.5 4.1-93.2 11.9c-42.7 5.8-97 12.5-111.1 17.8-33.1 12.5 24 62.6 24 62.6 84.7 76.8 129.7 50.5 129.7 50.5 33.3-10.7 61.4-18.5 85.2-24.2L565 743.1h84.6L603 928l205.3-271.9H700.8l22.3-38.7c.3.5.4.8.4.8S799.8 496.1 829 433.8l.6-1h-.1c5-10.8 8.6-19.7 10-25.8 17-71.3-114.5-99.4-265.8-154.5z"
                }
            }
        ]
    })(props);
}
function AiOutlineDisconnect(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M832.6 191.4c-84.6-84.6-221.5-84.6-306 0l-96.9 96.9 51 51 96.9-96.9c53.8-53.8 144.6-59.5 204 0 59.5 59.5 53.8 150.2 0 204l-96.9 96.9 51.1 51.1 96.9-96.9c84.4-84.6 84.4-221.5-.1-306.1zM446.5 781.6c-53.8 53.8-144.6 59.5-204 0-59.5-59.5-53.8-150.2 0-204l96.9-96.9-51.1-51.1-96.9 96.9c-84.6 84.6-84.6 221.5 0 306s221.5 84.6 306 0l96.9-96.9-51-51-96.8 97zM260.3 209.4a8.03 8.03 0 0 0-11.3 0L209.4 249a8.03 8.03 0 0 0 0 11.3l554.4 554.4c3.1 3.1 8.2 3.1 11.3 0l39.6-39.6c3.1-3.1 3.1-8.2 0-11.3L260.3 209.4z"
                }
            }
        ]
    })(props);
}
function AiOutlineDislike(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M885.9 490.3c3.6-12 5.4-24.4 5.4-37 0-28.3-9.3-55.5-26.1-77.7 3.6-12 5.4-24.4 5.4-37 0-28.3-9.3-55.5-26.1-77.7 3.6-12 5.4-24.4 5.4-37 0-51.6-30.7-98.1-78.3-118.4a66.1 66.1 0 0 0-26.5-5.4H144c-17.7 0-32 14.3-32 32v364c0 17.7 14.3 32 32 32h129.3l85.8 310.8C372.9 889 418.9 924 470.9 924c29.7 0 57.4-11.8 77.9-33.4 20.5-21.5 31-49.7 29.5-79.4l-6-122.9h239.9c12.1 0 23.9-3.2 34.3-9.3 40.4-23.5 65.5-66.1 65.5-111 0-28.3-9.3-55.5-26.1-77.7zM184 456V172h81v284h-81zm627.2 160.4H496.8l9.6 198.4c.6 11.9-4.7 23.1-14.6 30.5-6.1 4.5-13.6 6.8-21.1 6.7a44.28 44.28 0 0 1-42.2-32.3L329 459.2V172h415.4a56.85 56.85 0 0 1 33.6 51.8c0 9.7-2.3 18.9-6.9 27.3l-13.9 25.4 21.9 19a56.76 56.76 0 0 1 19.6 43c0 9.7-2.3 18.9-6.9 27.3l-13.9 25.4 21.9 19a56.76 56.76 0 0 1 19.6 43c0 9.7-2.3 18.9-6.9 27.3l-14 25.5 21.9 19a56.76 56.76 0 0 1 19.6 43c0 19.1-11 37.5-28.8 48.4z"
                }
            }
        ]
    })(props);
}
function AiOutlineDollarCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372zm47.7-395.2l-25.4-5.9V348.6c38 5.2 61.5 29 65.5 58.2.5 4 3.9 6.9 7.9 6.9h44.9c4.7 0 8.4-4.1 8-8.8-6.1-62.3-57.4-102.3-125.9-109.2V263c0-4.4-3.6-8-8-8h-28.1c-4.4 0-8 3.6-8 8v33c-70.8 6.9-126.2 46-126.2 119 0 67.6 49.8 100.2 102.1 112.7l24.7 6.3v142.7c-44.2-5.9-69-29.5-74.1-61.3-.6-3.8-4-6.6-7.9-6.6H363c-4.7 0-8.4 4-8 8.7 4.5 55 46.2 105.6 135.2 112.1V761c0 4.4 3.6 8 8 8h28.4c4.4 0 8-3.6 8-8.1l-.2-31.7c78.3-6.9 134.3-48.8 134.3-124-.1-69.4-44.2-100.4-109-116.4zm-68.6-16.2c-5.6-1.6-10.3-3.1-15-5-33.8-12.2-49.5-31.9-49.5-57.3 0-36.3 27.5-57 64.5-61.7v124zM534.3 677V543.3c3.1.9 5.9 1.6 8.8 2.2 47.3 14.4 63.2 34.4 63.2 65.1 0 39.1-29.4 62.6-72 66.4z"
                }
            }
        ]
    })(props);
}
function AiOutlineDollar(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372zm47.7-395.2l-25.4-5.9V348.6c38 5.2 61.5 29 65.5 58.2.5 4 3.9 6.9 7.9 6.9h44.9c4.7 0 8.4-4.1 8-8.8-6.1-62.3-57.4-102.3-125.9-109.2V263c0-4.4-3.6-8-8-8h-28.1c-4.4 0-8 3.6-8 8v33c-70.8 6.9-126.2 46-126.2 119 0 67.6 49.8 100.2 102.1 112.7l24.7 6.3v142.7c-44.2-5.9-69-29.5-74.1-61.3-.6-3.8-4-6.6-7.9-6.6H363c-4.7 0-8.4 4-8 8.7 4.5 55 46.2 105.6 135.2 112.1V761c0 4.4 3.6 8 8 8h28.4c4.4 0 8-3.6 8-8.1l-.2-31.7c78.3-6.9 134.3-48.8 134.3-124-.1-69.4-44.2-100.4-109-116.4zm-68.6-16.2c-5.6-1.6-10.3-3.1-15-5-33.8-12.2-49.5-31.9-49.5-57.3 0-36.3 27.5-57 64.5-61.7v124zM534.3 677V543.3c3.1.9 5.9 1.6 8.8 2.2 47.3 14.4 63.2 34.4 63.2 65.1 0 39.1-29.4 62.6-72 66.4z"
                }
            }
        ]
    })(props);
}
function AiOutlineDotChart(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M888 792H200V168c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v688c0 4.4 3.6 8 8 8h752c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM288 604a64 64 0 1 0 128 0 64 64 0 1 0-128 0zm118-224a48 48 0 1 0 96 0 48 48 0 1 0-96 0zm158 228a96 96 0 1 0 192 0 96 96 0 1 0-192 0zm148-314a56 56 0 1 0 112 0 56 56 0 1 0-112 0z"
                }
            }
        ]
    })(props);
}
function AiOutlineDoubleLeft(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M272.9 512l265.4-339.1c4.1-5.2.4-12.9-6.3-12.9h-77.3c-4.9 0-9.6 2.3-12.6 6.1L186.8 492.3a31.99 31.99 0 0 0 0 39.5l255.3 326.1c3 3.9 7.7 6.1 12.6 6.1H532c6.7 0 10.4-7.7 6.3-12.9L272.9 512zm304 0l265.4-339.1c4.1-5.2.4-12.9-6.3-12.9h-77.3c-4.9 0-9.6 2.3-12.6 6.1L490.8 492.3a31.99 31.99 0 0 0 0 39.5l255.3 326.1c3 3.9 7.7 6.1 12.6 6.1H836c6.7 0 10.4-7.7 6.3-12.9L576.9 512z"
                }
            }
        ]
    })(props);
}
function AiOutlineDoubleRight(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M533.2 492.3L277.9 166.1c-3-3.9-7.7-6.1-12.6-6.1H188c-6.7 0-10.4 7.7-6.3 12.9L447.1 512 181.7 851.1A7.98 7.98 0 0 0 188 864h77.3c4.9 0 9.6-2.3 12.6-6.1l255.3-326.1c9.1-11.7 9.1-27.9 0-39.5zm304 0L581.9 166.1c-3-3.9-7.7-6.1-12.6-6.1H492c-6.7 0-10.4 7.7-6.3 12.9L751.1 512 485.7 851.1A7.98 7.98 0 0 0 492 864h77.3c4.9 0 9.6-2.3 12.6-6.1l255.3-326.1c9.1-11.7 9.1-27.9 0-39.5z"
                }
            }
        ]
    })(props);
}
function AiOutlineDownCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M690 405h-46.9c-10.2 0-19.9 4.9-25.9 13.2L512 563.6 406.8 418.2c-6-8.3-15.6-13.2-25.9-13.2H334c-6.5 0-10.3 7.4-6.5 12.7l178 246c3.2 4.4 9.7 4.4 12.9 0l178-246c3.9-5.3.1-12.7-6.4-12.7z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z"
                }
            }
        ]
    })(props);
}
function AiOutlineDownSquare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M505.5 658.7c3.2 4.4 9.7 4.4 12.9 0l178-246c3.8-5.3 0-12.7-6.5-12.7H643c-10.2 0-19.9 4.9-25.9 13.2L512 558.6 406.8 413.2c-6-8.3-15.6-13.2-25.9-13.2H334c-6.5 0-10.3 7.4-6.5 12.7l178 246z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z"
                }
            }
        ]
    })(props);
}
function AiOutlineDown(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M884 256h-75c-5.1 0-9.9 2.5-12.9 6.6L512 654.2 227.9 262.6c-3-4.1-7.8-6.6-12.9-6.6h-75c-6.5 0-10.3 7.4-6.5 12.7l352.6 486.1c12.8 17.6 39 17.6 51.7 0l352.6-486.1c3.9-5.3.1-12.7-6.4-12.7z"
                }
            }
        ]
    })(props);
}
function AiOutlineDownload(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M505.7 661a8 8 0 0 0 12.6 0l112-141.7c4.1-5.2.4-12.9-6.3-12.9h-74.1V168c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8v338.3H400c-6.7 0-10.4 7.7-6.3 12.9l112 141.8zM878 626h-60c-4.4 0-8 3.6-8 8v154H214V634c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8v198c0 17.7 14.3 32 32 32h684c17.7 0 32-14.3 32-32V634c0-4.4-3.6-8-8-8z"
                }
            }
        ]
    })(props);
}
function AiOutlineDrag(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M909.3 506.3L781.7 405.6a7.23 7.23 0 0 0-11.7 5.7V476H548V254h64.8c6 0 9.4-7 5.7-11.7L517.7 114.7a7.14 7.14 0 0 0-11.3 0L405.6 242.3a7.23 7.23 0 0 0 5.7 11.7H476v222H254v-64.8c0-6-7-9.4-11.7-5.7L114.7 506.3a7.14 7.14 0 0 0 0 11.3l127.5 100.8c4.7 3.7 11.7.4 11.7-5.7V548h222v222h-64.8c-6 0-9.4 7-5.7 11.7l100.8 127.5c2.9 3.7 8.5 3.7 11.3 0l100.8-127.5c3.7-4.7.4-11.7-5.7-11.7H548V548h222v64.8c0 6 7 9.4 11.7 5.7l127.5-100.8a7.3 7.3 0 0 0 .1-11.4z"
                }
            }
        ]
    })(props);
}
function AiOutlineDribbbleSquare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M498.6 432c-40.8-72.5-84.7-133.4-91.2-142.3-68.8 32.5-120.3 95.9-136.2 172.2 11 .2 112.4.7 227.4-29.9zm66.5 21.8c5.7 11.7 11.2 23.6 16.3 35.6 1.8 4.2 3.6 8.4 5.3 12.7 81.8-10.3 163.2 6.2 171.3 7.9-.5-58.1-21.3-111.4-55.5-153.3-5.3 7.1-46.5 60-137.4 97.1zM880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM512 800c-158.8 0-288-129.2-288-288s129.2-288 288-288 288 129.2 288 288-129.2 288-288 288zm89.7-259.1c32.2 88.4 45.3 160.4 47.8 175.4 55.2-37.3 94.5-96.4 105.4-164.9-8.4-2.6-76.1-22.8-153.2-10.5zm-72.5-26.4c3.2-1 6.4-2 9.7-2.9-6.2-14-12.9-28-19.9-41.7-122.8 36.8-242.1 35.2-252.8 35-.1 2.5-.1 5-.1 7.5 0 63.2 23.9 120.9 63.2 164.5 5.5-9.6 73-121.4 199.9-162.4zm145.9-186.2a245.2 245.2 0 0 0-220.8-55.1c6.8 9.1 51.5 69.9 91.8 144 87.5-32.8 124.5-82.6 129-88.9zM554 552.8c-138.7 48.3-188.6 144.6-193 153.6 41.7 32.5 94.1 51.9 151 51.9 34.1 0 66.6-6.9 96.1-19.5-3.7-21.6-17.9-96.8-52.5-186.6l-1.6.6z"
                }
            }
        ]
    })(props);
}
function AiOutlineDribbble(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M512 96C282.6 96 96 282.6 96 512s186.6 416 416 416 416-186.6 416-416S741.4 96 512 96zm275.1 191.8c49.5 60.5 79.5 137.5 80.2 221.4-11.7-2.5-129.2-26.3-247.4-11.4-2.5-6.1-5-12.2-7.6-18.3-7.4-17.3-15.3-34.6-23.6-51.5C720 374.3 779.6 298 787.1 287.8zM512 157.2c90.3 0 172.8 33.9 235.5 89.5-6.4 9.1-59.9 81-186.2 128.4-58.2-107-122.7-194.8-132.6-208 27.3-6.6 55.2-9.9 83.3-9.9zM360.9 191c9.4 12.8 72.9 100.9 131.7 205.5C326.4 440.6 180 440 164.1 439.8c23.1-110.3 97.4-201.9 196.8-248.8zM156.7 512.5c0-3.6.1-7.3.2-10.9 15.5.3 187.7 2.5 365.2-50.6 10.2 19.9 19.9 40.1 28.8 60.3-4.7 1.3-9.4 2.7-14 4.2C353.6 574.9 256.1 736.4 248 750.1c-56.7-63-91.3-146.3-91.3-237.6zM512 867.8c-82.2 0-157.9-28-218.1-75 6.4-13.1 78.3-152 278.7-221.9l2.3-.8c49.9 129.6 70.5 238.3 75.8 269.5A350.46 350.46 0 0 1 512 867.8zm198.5-60.7c-3.6-21.6-22.5-125.6-69-253.3C752.9 536 850.7 565.2 862.8 569c-15.8 98.8-72.5 184.2-152.3 238.1z"
                }
            }
        ]
    })(props);
}
function AiOutlineDropbox(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M64 556.9l264.2 173.5L512.5 577 246.8 412.7zm896-290.3zm0 0L696.8 95 512.5 248.5l265.2 164.2L512.5 577l184.3 153.4L960 558.8 777.7 412.7zM513 609.8L328.2 763.3l-79.4-51.5v57.8L513 928l263.7-158.4v-57.8l-78.9 51.5zM328.2 95L64 265.1l182.8 147.6 265.7-164.2zM64 556.9z"
                }
            }
        ]
    })(props);
}
function AiOutlineEdit(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M257.7 752c2 0 4-.2 6-.5L431.9 722c2-.4 3.9-1.3 5.3-2.8l423.9-423.9a9.96 9.96 0 0 0 0-14.1L694.9 114.9c-1.9-1.9-4.4-2.9-7.1-2.9s-5.2 1-7.1 2.9L256.8 538.8c-1.5 1.5-2.4 3.3-2.8 5.3l-29.5 168.2a33.5 33.5 0 0 0 9.4 29.8c6.6 6.4 14.9 9.9 23.8 9.9zm67.4-174.4L687.8 215l73.3 73.3-362.7 362.6-88.9 15.7 15.6-89zM880 836H144c-17.7 0-32 14.3-32 32v36c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-36c0-17.7-14.3-32-32-32z"
                }
            }
        ]
    })(props);
}
function AiOutlineEllipsis(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M176 511a56 56 0 1 0 112 0 56 56 0 1 0-112 0zm280 0a56 56 0 1 0 112 0 56 56 0 1 0-112 0zm280 0a56 56 0 1 0 112 0 56 56 0 1 0-112 0z"
                }
            }
        ]
    })(props);
}
function AiOutlineEnter(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M864 170h-60c-4.4 0-8 3.6-8 8v518H310v-73c0-6.7-7.8-10.5-13-6.3l-141.9 112a8 8 0 0 0 0 12.6l141.9 112c5.3 4.2 13 .4 13-6.3v-75h498c35.3 0 64-28.7 64-64V178c0-4.4-3.6-8-8-8z"
                }
            }
        ]
    })(props);
}
function AiOutlineEnvironment(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M854.6 289.1a362.49 362.49 0 0 0-79.9-115.7 370.83 370.83 0 0 0-118.2-77.8C610.7 76.6 562.1 67 512 67c-50.1 0-98.7 9.6-144.5 28.5-44.3 18.3-84 44.5-118.2 77.8A363.6 363.6 0 0 0 169.4 289c-19.5 45-29.4 92.8-29.4 142 0 70.6 16.9 140.9 50.1 208.7 26.7 54.5 64 107.6 111 158.1 80.3 86.2 164.5 138.9 188.4 153a43.9 43.9 0 0 0 22.4 6.1c7.8 0 15.5-2 22.4-6.1 23.9-14.1 108.1-66.8 188.4-153 47-50.4 84.3-103.6 111-158.1C867.1 572 884 501.8 884 431.1c0-49.2-9.9-97-29.4-142zM512 880.2c-65.9-41.9-300-207.8-300-449.1 0-77.9 31.1-151.1 87.6-206.3C356.3 169.5 431.7 139 512 139s155.7 30.5 212.4 85.9C780.9 280 812 353.2 812 431.1c0 241.3-234.1 407.2-300 449.1zm0-617.2c-97.2 0-176 78.8-176 176s78.8 176 176 176 176-78.8 176-176-78.8-176-176-176zm79.2 255.2A111.6 111.6 0 0 1 512 551c-29.9 0-58-11.7-79.2-32.8A111.6 111.6 0 0 1 400 439c0-29.9 11.7-58 32.8-79.2C454 338.6 482.1 327 512 327c29.9 0 58 11.6 79.2 32.8C612.4 381 624 409.1 624 439c0 29.9-11.6 58-32.8 79.2z"
                }
            }
        ]
    })(props);
}
function AiOutlineEuroCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372zm117.7-588.6c-15.9-3.5-34.4-5.4-55.3-5.4-106.7 0-178.9 55.7-198.6 149.9H344c-4.4 0-8 3.6-8 8v27.2c0 4.4 3.6 8 8 8h26.4c-.3 4.1-.3 8.4-.3 12.8v36.9H344c-4.4 0-8 3.6-8 8V568c0 4.4 3.6 8 8 8h30.2c17.2 99.2 90.4 158 200.2 158 20.9 0 39.4-1.7 55.3-5.1 3.7-.8 6.4-4 6.4-7.8v-42.8c0-5-4.6-8.8-9.5-7.8-14.7 2.8-31.9 4.1-51.8 4.1-68.5 0-114.5-36.6-129.8-98.6h130.6c4.4 0 8-3.6 8-8v-27.2c0-4.4-3.6-8-8-8H439.2v-36c0-4.7 0-9.4.3-13.8h135.9c4.4 0 8-3.6 8-8v-27.2c0-4.4-3.6-8-8-8H447.1c17.2-56.9 62.3-90.4 127.6-90.4 19.9 0 37.1 1.5 51.7 4.4a8 8 0 0 0 9.6-7.8v-42.8c0-3.8-2.6-7-6.3-7.8z"
                }
            }
        ]
    })(props);
}
function AiOutlineEuro(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372zm117.7-588.6c-15.9-3.5-34.4-5.4-55.3-5.4-106.7 0-178.9 55.7-198.6 149.9H344c-4.4 0-8 3.6-8 8v27.2c0 4.4 3.6 8 8 8h26.4c-.3 4.1-.3 8.4-.3 12.8v36.9H344c-4.4 0-8 3.6-8 8V568c0 4.4 3.6 8 8 8h30.2c17.2 99.2 90.4 158 200.2 158 20.9 0 39.4-1.7 55.3-5.1 3.7-.8 6.4-4 6.4-7.8v-42.8c0-5-4.6-8.8-9.5-7.8-14.7 2.8-31.9 4.1-51.8 4.1-68.5 0-114.5-36.6-129.8-98.6h130.6c4.4 0 8-3.6 8-8v-27.2c0-4.4-3.6-8-8-8H439.2v-36c0-4.7 0-9.4.3-13.8h135.9c4.4 0 8-3.6 8-8v-27.2c0-4.4-3.6-8-8-8H447.1c17.2-56.9 62.3-90.4 127.6-90.4 19.9 0 37.1 1.5 51.7 4.4a8 8 0 0 0 9.6-7.8v-42.8c0-3.8-2.6-7-6.3-7.8z"
                }
            }
        ]
    })(props);
}
function AiOutlineException(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M688 312v-48c0-4.4-3.6-8-8-8H296c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h384c4.4 0 8-3.6 8-8zm-392 88c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h184c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H296zm376 116c-119.3 0-216 96.7-216 216s96.7 216 216 216 216-96.7 216-216-96.7-216-216-216zm107.5 323.5C750.8 868.2 712.6 884 672 884s-78.8-15.8-107.5-44.5C535.8 810.8 520 772.6 520 732s15.8-78.8 44.5-107.5C593.2 595.8 631.4 580 672 580s78.8 15.8 107.5 44.5C808.2 653.2 824 691.4 824 732s-15.8 78.8-44.5 107.5zM640 812a32 32 0 1 0 64 0 32 32 0 1 0-64 0zm12-64h40c4.4 0 8-3.6 8-8V628c0-4.4-3.6-8-8-8h-40c-4.4 0-8 3.6-8 8v112c0 4.4 3.6 8 8 8zM440 852H208V148h560v344c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V108c0-17.7-14.3-32-32-32H168c-17.7 0-32 14.3-32 32v784c0 17.7 14.3 32 32 32h272c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8z"
                }
            }
        ]
    })(props);
}
function AiOutlineExclamationCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M464 688a48 48 0 1 0 96 0 48 48 0 1 0-96 0zm24-112h48c4.4 0 8-3.6 8-8V296c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v272c0 4.4 3.6 8 8 8z"
                }
            }
        ]
    })(props);
}
function AiOutlineExclamation(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M448 804a64 64 0 1 0 128 0 64 64 0 1 0-128 0zm32-168h64c4.4 0 8-3.6 8-8V164c0-4.4-3.6-8-8-8h-64c-4.4 0-8 3.6-8 8v464c0 4.4 3.6 8 8 8z"
                }
            }
        ]
    })(props);
}
function AiOutlineExpandAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M855 160.1l-189.2 23.5c-6.6.8-9.3 8.8-4.7 13.5l54.7 54.7-153.5 153.5a8.03 8.03 0 0 0 0 11.3l45.1 45.1c3.1 3.1 8.2 3.1 11.3 0l153.6-153.6 54.7 54.7a7.94 7.94 0 0 0 13.5-4.7L863.9 169a7.9 7.9 0 0 0-8.9-8.9zM416.6 562.3a8.03 8.03 0 0 0-11.3 0L251.8 715.9l-54.7-54.7a7.94 7.94 0 0 0-13.5 4.7L160.1 855c-.6 5.2 3.7 9.5 8.9 8.9l189.2-23.5c6.6-.8 9.3-8.8 4.7-13.5l-54.7-54.7 153.6-153.6c3.1-3.1 3.1-8.2 0-11.3l-45.2-45z"
                }
            }
        ]
    })(props);
}
function AiOutlineExpand(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "t": "1569683683230",
            "viewBox": "0 0 1024 1024",
            "version": "1.1"
        },
        "child": [
            {
                "tag": "defs",
                "attr": {},
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M342 88H120c-17.7 0-32 14.3-32 32v224c0 8.8 7.2 16 16 16h48c8.8 0 16-7.2 16-16V168h174c8.8 0 16-7.2 16-16v-48c0-8.8-7.2-16-16-16zM920 664h-48c-8.8 0-16 7.2-16 16v176H682c-8.8 0-16 7.2-16 16v48c0 8.8 7.2 16 16 16h222c17.7 0 32-14.3 32-32V680c0-8.8-7.2-16-16-16zM342 856H168V680c0-8.8-7.2-16-16-16h-48c-8.8 0-16 7.2-16 16v224c0 17.7 14.3 32 32 32h222c8.8 0 16-7.2 16-16v-48c0-8.8-7.2-16-16-16zM904 88H682c-8.8 0-16 7.2-16 16v48c0 8.8 7.2 16 16 16h174v176c0 8.8 7.2 16 16 16h48c8.8 0 16-7.2 16-16V120c0-17.7-14.3-32-32-32z"
                }
            }
        ]
    })(props);
}
function AiOutlineExperiment(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M512 472a40 40 0 1 0 80 0 40 40 0 1 0-80 0zm367 352.9L696.3 352V178H768v-68H256v68h71.7v174L145 824.9c-2.8 7.4-4.3 15.2-4.3 23.1 0 35.3 28.7 64 64 64h614.6c7.9 0 15.7-1.5 23.1-4.3 33-12.7 49.4-49.8 36.6-82.8zM395.7 364.7V180h232.6v184.7L719.2 600c-20.7-5.3-42.1-8-63.9-8-61.2 0-119.2 21.5-165.3 60a188.78 188.78 0 0 1-121.3 43.9c-32.7 0-64.1-8.3-91.8-23.7l118.8-307.5zM210.5 844l41.7-107.8c35.7 18.1 75.4 27.8 116.6 27.8 61.2 0 119.2-21.5 165.3-60 33.9-28.2 76.3-43.9 121.3-43.9 35 0 68.4 9.5 97.6 27.1L813.5 844h-603z"
                }
            }
        ]
    })(props);
}
function AiOutlineExport(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024",
            "fill": "currentColor",
            "fillRule": "evenodd"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h360c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H184V184h656v320c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V144c0-17.7-14.3-32-32-32ZM770.87 824.869l-52.2 52.2c-4.7 4.7-1.9 12.8 4.7 13.6l179.4 21c5.1.6 9.5-3.7 8.9-8.9l-21-179.4c-.8-6.6-8.9-9.4-13.6-4.7l-52.4 52.4-256.2-256.2c-3.1-3.1-8.2-3.1-11.3 0l-42.4 42.4c-3.1 3.1-3.1 8.2 0 11.3l256.1 256.3Z",
                    "transform": "matrix(1 0 0 -1 0 1024)"
                }
            }
        ]
    })(props);
}
function AiOutlineEyeInvisible(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M942.2 486.2Q889.47 375.11 816.7 305l-50.88 50.88C807.31 395.53 843.45 447.4 874.7 512 791.5 684.2 673.4 766 512 766q-72.67 0-133.87-22.38L323 798.75Q408 838 512 838q288.3 0 430.2-300.3a60.29 60.29 0 0 0 0-51.5zm-63.57-320.64L836 122.88a8 8 0 0 0-11.32 0L715.31 232.2Q624.86 186 512 186q-288.3 0-430.2 300.3a60.3 60.3 0 0 0 0 51.5q56.69 119.4 136.5 191.41L112.48 835a8 8 0 0 0 0 11.31L155.17 889a8 8 0 0 0 11.31 0l712.15-712.12a8 8 0 0 0 0-11.32zM149.3 512C232.6 339.8 350.7 258 512 258c54.54 0 104.13 9.36 149.12 28.39l-70.3 70.3a176 176 0 0 0-238.13 238.13l-83.42 83.42C223.1 637.49 183.3 582.28 149.3 512zm246.7 0a112.11 112.11 0 0 1 146.2-106.69L401.31 546.2A112 112 0 0 1 396 512z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M508 624c-3.46 0-6.87-.16-10.25-.47l-52.82 52.82a176.09 176.09 0 0 0 227.42-227.42l-52.82 52.82c.31 3.38.47 6.79.47 10.25a111.94 111.94 0 0 1-112 112z"
                }
            }
        ]
    })(props);
}
function AiOutlineEye(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M942.2 486.2C847.4 286.5 704.1 186 512 186c-192.2 0-335.4 100.5-430.2 300.3a60.3 60.3 0 0 0 0 51.5C176.6 737.5 319.9 838 512 838c192.2 0 335.4-100.5 430.2-300.3 7.7-16.2 7.7-35 0-51.5zM512 766c-161.3 0-279.4-81.8-362.7-254C232.6 339.8 350.7 258 512 258c161.3 0 279.4 81.8 362.7 254C791.5 684.2 673.4 766 512 766zm-4-430c-97.2 0-176 78.8-176 176s78.8 176 176 176 176-78.8 176-176-78.8-176-176-176zm0 288c-61.9 0-112-50.1-112-112s50.1-112 112-112 112 50.1 112 112-50.1 112-112 112z"
                }
            }
        ]
    })(props);
}
function AiOutlineFacebook(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-32 736H663.9V602.2h104l15.6-120.7H663.9v-77.1c0-35 9.7-58.8 59.8-58.8h63.9v-108c-11.1-1.5-49-4.8-93.2-4.8-92.2 0-155.3 56.3-155.3 159.6v89H434.9v120.7h104.3V848H176V176h672v672z"
                }
            }
        ]
    })(props);
}
function AiOutlineFall(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M925.9 804l-24-199.2c-.8-6.6-8.9-9.4-13.6-4.7L829 659.5 557.7 388.3c-6.3-6.2-16.4-6.2-22.6 0L433.3 490 156.6 213.3a8.03 8.03 0 0 0-11.3 0l-45 45.2a8.03 8.03 0 0 0 0 11.3L422 591.7c6.2 6.3 16.4 6.3 22.6 0L546.4 490l226.1 226-59.3 59.3a8.01 8.01 0 0 0 4.7 13.6l199.2 24c5.1.7 9.5-3.7 8.8-8.9z"
                }
            }
        ]
    })(props);
}
function AiOutlineFastBackward(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M517.6 273.5L230.2 499.3a16.14 16.14 0 0 0 0 25.4l287.4 225.8c10.7 8.4 26.4.8 26.4-12.7V286.2c0-13.5-15.7-21.1-26.4-12.7zm320 0L550.2 499.3a16.14 16.14 0 0 0 0 25.4l287.4 225.8c10.7 8.4 26.4.8 26.4-12.7V286.2c0-13.5-15.7-21.1-26.4-12.7zm-620-25.5h-51.2c-3.5 0-6.4 2.7-6.4 6v516c0 3.3 2.9 6 6.4 6h51.2c3.5 0 6.4-2.7 6.4-6V254c0-3.3-2.9-6-6.4-6z"
                }
            }
        ]
    })(props);
}
function AiOutlineFastForward(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M793.8 499.3L506.4 273.5c-10.7-8.4-26.4-.8-26.4 12.7v451.6c0 13.5 15.7 21.1 26.4 12.7l287.4-225.8a16.14 16.14 0 0 0 0-25.4zm-320 0L186.4 273.5c-10.7-8.4-26.4-.8-26.4 12.7v451.5c0 13.5 15.7 21.1 26.4 12.7l287.4-225.8c4.1-3.2 6.2-8 6.2-12.7 0-4.6-2.1-9.4-6.2-12.6zM857.6 248h-51.2c-3.5 0-6.4 2.7-6.4 6v516c0 3.3 2.9 6 6.4 6h51.2c3.5 0 6.4-2.7 6.4-6V254c0-3.3-2.9-6-6.4-6z"
                }
            }
        ]
    })(props);
}
function AiOutlineFieldBinary(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "t": "1569683645783",
            "viewBox": "0 0 1024 1024",
            "version": "1.1"
        },
        "child": [
            {
                "tag": "defs",
                "attr": {},
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M600 395.4h91V649h79V267c0-4.4-3.6-8-8-8h-48.2c-3.7 0-7 2.6-7.7 6.3-2.6 12.1-6.9 22.3-12.9 30.9-7.2 10.1-15.9 18.2-26.3 24.4-10.3 6.2-22 10.5-35 12.9-10.4 1.9-21 3-32 3.1-4.4 0.1-7.9 3.6-7.9 8v42.8c0 4.4 3.6 8 8 8zM871 702H567c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h304c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zM443.9 312.7c-16.1-19-34.4-32.4-55.2-40.4-21.3-8.2-44.1-12.3-68.4-12.3-23.9 0-46.4 4.1-67.7 12.3-20.8 8-39 21.4-54.8 40.3-15.9 19.1-28.7 44.7-38.3 77-9.6 32.5-14.5 73-14.5 121.5 0 49.9 4.9 91.4 14.5 124.4 9.6 32.8 22.4 58.7 38.3 77.7 15.8 18.9 34 32.3 54.8 40.3 21.3 8.2 43.8 12.3 67.7 12.3 24.4 0 47.2-4.1 68.4-12.3 20.8-8 39.2-21.4 55.2-40.4 16.1-19 29-44.9 38.6-77.7 9.6-33 14.5-74.5 14.5-124.4 0-48.4-4.9-88.9-14.5-121.5-9.5-32.1-22.4-57.7-38.6-76.8z m-29.5 251.7c-1 21.4-4.2 42-9.5 61.9-5.5 20.7-14.5 38.5-27 53.4-13.6 16.3-33.2 24.3-57.6 24.3-24 0-43.2-8.1-56.7-24.4-12.2-14.8-21.1-32.6-26.6-53.3-5.3-19.9-8.5-40.6-9.5-61.9-1-20.8-1.5-38.5-1.5-53.2 0-8.8 0.1-19.4 0.4-31.8 0.2-12.7 1.1-25.8 2.6-39.2 1.5-13.6 4-27.1 7.6-40.5 3.7-13.8 8.8-26.3 15.4-37.4 6.9-11.6 15.8-21.1 26.7-28.3 11.4-7.6 25.3-11.3 41.5-11.3 16.1 0 30.1 3.7 41.7 11.2 11.1 7.2 20.3 16.6 27.4 28.2 6.9 11.2 12.1 23.8 15.6 37.7 3.3 13.2 5.8 26.6 7.5 40.1 1.8 13.5 2.8 26.6 3 39.4 0.2 12.4 0.4 23 0.4 31.8 0.1 14.8-0.4 32.5-1.4 53.3z"
                }
            }
        ]
    })(props);
}
function AiOutlineFieldNumber(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "t": "1569683604581",
            "viewBox": "0 0 1024 1024",
            "version": "1.1"
        },
        "child": [
            {
                "tag": "defs",
                "attr": {},
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M508 280h-63.3c-3.3 0-6 2.7-6 6v340.2H433L197.4 282.6c-1.1-1.6-3-2.6-4.9-2.6H126c-3.3 0-6 2.7-6 6v464c0 3.3 2.7 6 6 6h62.7c3.3 0 6-2.7 6-6V405.1h5.7l238.2 348.3c1.1 1.6 3 2.6 5 2.6H508c3.3 0 6-2.7 6-6V286c0-3.3-2.7-6-6-6zM886 693H582c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h304c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zM733.8 630c52.9 0 95.2-17.2 126.2-51.7 29.4-32.9 44-75.8 44-128.8 0-53.1-14.6-96.5-44-129.3-30.9-34.8-73.2-52.2-126.2-52.2-53.7 0-95.9 17.5-126.3 52.8-29.2 33.1-43.4 75.9-43.4 128.7 0 52.4 14.3 95.2 43.5 128.3 30.6 34.7 73 52.2 126.2 52.2z m-71.5-263.7c16.9-20.6 40.3-30.9 71.4-30.9 31.5 0 54.8 9.6 71 29.1 16.4 20.3 24.9 48.6 24.9 84.9 0 36.3-8.4 64.1-24.8 83.9-16.5 19.4-40 29.2-71.1 29.2-31.2 0-55-10.3-71.4-30.4-16.3-20.1-24.5-47.3-24.5-82.6 0.1-35.8 8.2-63 24.5-83.2z"
                }
            }
        ]
    })(props);
}
function AiOutlineFieldString(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "t": "1569683607277",
            "viewBox": "0 0 1024 1024",
            "version": "1.1"
        },
        "child": [
            {
                "tag": "defs",
                "attr": {},
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M875.6 515.9c2.1 0.8 4.4-0.3 5.2-2.4 0.2-0.4 0.2-0.9 0.2-1.4v-58.3c0-1.8-1.1-3.3-2.8-3.8-6-1.8-17.2-3-27.2-3-32.9 0-61.7 16.7-73.5 41.2v-28.6c0-4.4-3.6-8-8-8H717c-4.4 0-8 3.6-8 8V729c0 4.4 3.6 8 8 8h54.8c4.4 0 8-3.6 8-8V572.7c0-36.2 26.1-60.2 65.1-60.2 10.4 0.1 26.6 1.8 30.7 3.4zM338.6 475.4l-54.7-12.6c-61.2-14.2-87.7-34.8-87.7-70.7 0-44.6 39.1-73.5 96.9-73.5 52.8 0 91.4 26.5 99.9 68.9h70C455.9 311.6 387.6 259 293.4 259c-103.3 0-171 55.5-171 139 0 68.6 38.6 109.5 122.2 128.5l61.6 14.3c63.6 14.9 91.6 37.1 91.6 75.1 0 44.1-43.5 75.2-102.5 75.2-60.6 0-104.5-27.2-112.8-70.5H111c7.2 79.9 75.6 130.4 179.1 130.4C402.3 751 471 695.2 471 605.3c0-70.2-38.6-108.5-132.4-129.9z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M877 729m-36 0a36 36 0 1 0 72 0 36 36 0 1 0-72 0Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M653 457.8h-51.4V396c0-4.4-3.6-8-8-8h-54.7c-4.4 0-8 3.6-8 8v61.8H495c-4.4 0-8 3.6-8 8v42.3c0 4.4 3.6 8 8 8h35.9v147.5c0 56.2 27.4 79.4 93.1 79.4 11.7 0 23.6-1.2 33.8-3.1 1.9-0.3 3.2-2 3.2-3.9v-49.3c0-2.2-1.8-4-4-4h-0.4c-4.9 0.5-6.2 0.6-8.3 0.8-4.1 0.3-7.8 0.5-12.6 0.5-24.1 0-34.1-10.3-34.1-35.6V516.1H653c4.4 0 8-3.6 8-8v-42.3c0-4.4-3.6-8-8-8z"
                }
            }
        ]
    })(props);
}
function AiOutlineFieldTime(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "t": "1569683618210",
            "viewBox": "0 0 1024 1024",
            "version": "1.1"
        },
        "child": [
            {
                "tag": "defs",
                "attr": {},
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M945 412H689c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h256c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zM811 548H689c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h122c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zM477.3 322.5H434c-6.2 0-11.2 5-11.2 11.2v248c0 3.6 1.7 6.9 4.6 9l148.9 108.6c5 3.6 12 2.6 15.6-2.4l25.7-35.1v-0.1c3.6-5 2.5-12-2.5-15.6l-126.7-91.6V333.7c0.1-6.2-5-11.2-11.1-11.2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M804.8 673.9H747c-5.6 0-10.9 2.9-13.9 7.7-12.7 20.1-27.5 38.7-44.5 55.7-29.3 29.3-63.4 52.3-101.3 68.3-39.3 16.6-81 25-124 25-43.1 0-84.8-8.4-124-25-37.9-16-72-39-101.3-68.3s-52.3-63.4-68.3-101.3c-16.6-39.2-25-80.9-25-124 0-43.1 8.4-84.7 25-124 16-37.9 39-72 68.3-101.3 29.3-29.3 63.4-52.3 101.3-68.3 39.2-16.6 81-25 124-25 43.1 0 84.8 8.4 124 25 37.9 16 72 39 101.3 68.3 17 17 31.8 35.6 44.5 55.7 3 4.8 8.3 7.7 13.9 7.7h57.8c6.9 0 11.3-7.2 8.2-13.3-65.2-129.7-197.4-214-345-215.7-216.1-2.7-395.6 174.2-396 390.1C71.6 727.5 246.9 903 463.2 903c149.5 0 283.9-84.6 349.8-215.8 3.1-6.1-1.4-13.3-8.2-13.3z"
                }
            }
        ]
    })(props);
}
function AiOutlineFileAdd(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M854.6 288.6L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM790.2 326H602V137.8L790.2 326zm1.8 562H232V136h302v216a42 42 0 0 0 42 42h216v494zM544 472c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v108H372c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h108v108c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V644h108c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H544V472z"
                }
            }
        ]
    })(props);
}
function AiOutlineFileDone(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M688 312v-48c0-4.4-3.6-8-8-8H296c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h384c4.4 0 8-3.6 8-8zm-392 88c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h184c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H296zm376 116c-119.3 0-216 96.7-216 216s96.7 216 216 216 216-96.7 216-216-96.7-216-216-216zm107.5 323.5C750.8 868.2 712.6 884 672 884s-78.8-15.8-107.5-44.5C535.8 810.8 520 772.6 520 732s15.8-78.8 44.5-107.5C593.2 595.8 631.4 580 672 580s78.8 15.8 107.5 44.5C808.2 653.2 824 691.4 824 732s-15.8 78.8-44.5 107.5zM761 656h-44.3c-2.6 0-5 1.2-6.5 3.3l-63.5 87.8-23.1-31.9a7.92 7.92 0 0 0-6.5-3.3H573c-6.5 0-10.3 7.4-6.5 12.7l73.8 102.1c3.2 4.4 9.7 4.4 12.9 0l114.2-158c3.9-5.3.1-12.7-6.4-12.7zM440 852H208V148h560v344c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V108c0-17.7-14.3-32-32-32H168c-17.7 0-32 14.3-32 32v784c0 17.7 14.3 32 32 32h272c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8z"
                }
            }
        ]
    })(props);
}
function AiOutlineFileExcel(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M854.6 288.6L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM790.2 326H602V137.8L790.2 326zm1.8 562H232V136h302v216a42 42 0 0 0 42 42h216v494zM514.1 580.1l-61.8-102.4c-2.2-3.6-6.1-5.8-10.3-5.8h-38.4c-2.3 0-4.5.6-6.4 1.9-5.6 3.5-7.3 10.9-3.7 16.6l82.3 130.4-83.4 132.8a12.04 12.04 0 0 0 10.2 18.4h34.5c4.2 0 8-2.2 10.2-5.7L510 664.8l62.3 101.4c2.2 3.6 6.1 5.7 10.2 5.7H620c2.3 0 4.5-.7 6.5-1.9 5.6-3.6 7.2-11 3.6-16.6l-84-130.4 85.3-132.5a12.04 12.04 0 0 0-10.1-18.5h-35.7c-4.2 0-8.1 2.2-10.3 5.8l-61.2 102.3z"
                }
            }
        ]
    })(props);
}
function AiOutlineFileExclamation(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M854.6 288.6L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM790.2 326H602V137.8L790.2 326zm1.8 562H232V136h302v216a42 42 0 0 0 42 42h216v494zM472 744a40 40 0 1 0 80 0 40 40 0 1 0-80 0zm16-104h48c4.4 0 8-3.6 8-8V448c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v184c0 4.4 3.6 8 8 8z"
                }
            }
        ]
    })(props);
}
function AiOutlineFileGif(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "t": "1569683725598",
            "viewBox": "0 0 1024 1024",
            "version": "1.1"
        },
        "child": [
            {
                "tag": "defs",
                "attr": {},
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M551.5 490.5H521c-4.6 0-8.4 3.7-8.4 8.4V720c0 4.6 3.7 8.4 8.4 8.4h30.5c4.6 0 8.4-3.7 8.4-8.4V498.9c-0.1-4.6-3.8-8.4-8.4-8.4zM477.3 600h-88.1c-4.6 0-8.4 3.7-8.4 8.4v23.8c0 4.6 3.7 8.4 8.4 8.4h47.6v0.7c-0.6 29.9-23 49.8-56.5 49.8-39.2 0-63.6-30.7-63.6-81.4 0-50.1 23.9-80.6 62.3-80.6 28.1 0 47.5 13.5 55.4 38.3l0.9 2.8h49.2l-0.7-4.6C475.9 515.9 434.7 484 379 484c-68.8 0-113 49.4-113 125.9 0 77.5 43.7 126.1 113.6 126.1 64.4 0 106-40.3 106-102.9v-24.8c0-4.6-3.7-8.3-8.3-8.3z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M854.6 288.6L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM602 137.8L790.2 326H602V137.8zM792 888H232V136h302v216c0 23.2 18.8 42 42 42h216v494z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M608.2 727.8h32.3c4.6 0 8.4-3.7 8.4-8.4v-84.8h87.8c4.6 0 8.4-3.7 8.4-8.4v-25.5c0-4.6-3.7-8.4-8.4-8.4h-87.8v-58.9h96.8c4.6 0 8.4-3.7 8.4-8.4v-26.8c0-4.6-3.7-8.4-8.4-8.4H608.2c-4.6 0-8.4 3.7-8.4 8.4v221.1c0 4.8 3.8 8.5 8.4 8.5z"
                }
            }
        ]
    })(props);
}
function AiOutlineFileImage(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M553.1 509.1l-77.8 99.2-41.1-52.4a8 8 0 0 0-12.6 0l-99.8 127.2a7.98 7.98 0 0 0 6.3 12.9H696c6.7 0 10.4-7.7 6.3-12.9l-136.5-174a8.1 8.1 0 0 0-12.7 0zM360 442a40 40 0 1 0 80 0 40 40 0 1 0-80 0zm494.6-153.4L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM790.2 326H602V137.8L790.2 326zm1.8 562H232V136h302v216a42 42 0 0 0 42 42h216v494z"
                }
            }
        ]
    })(props);
}
function AiOutlineFileJpg(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M874.6 301.8L596.8 21.3c-4.5-4.5-9.4-8.3-14.7-11.5-1.4-.8-2.8-1.6-4.3-2.3-.9-.5-1.9-.9-2.8-1.3-9-4-18.9-6.2-29-6.2H201c-39.8 0-73 32.2-73 72v880c0 39.8 33.2 72 73 72h623c39.8 0 71-32.2 71-72V352.5c0-19-7-37.2-20.4-50.7zM583 110.4L783.8 312H583V110.4zM823 952H200V72h311v240c0 39.8 33.2 72 73 72h239v568zM350 696.5c0 24.2-7.5 31.4-21.9 31.4-9 0-18.4-5.8-24.8-18.5L272.9 732c13.4 22.9 32.3 34.2 61.3 34.2 41.6 0 60.8-29.9 60.8-66.2V577h-45v119.5zM501.3 577H437v186h44v-62h21.6c39.1 0 73.1-19.6 73.1-63.6 0-45.8-33.5-60.4-74.4-60.4zm-.8 89H481v-53h18.2c21.5 0 33.4 6.2 33.4 24.9 0 18.1-10.5 28.1-32.1 28.1zm182.5-9v36h30v30.1c-4 2.9-11 4.7-17.7 4.7-34.3 0-50.7-21.4-50.7-58.2 0-36.1 19.7-57.4 47.1-57.4 15.3 0 25 6.2 34 14.4l23.7-28.3c-12.7-12.8-32.1-24.2-59.2-24.2-49.6 0-91.1 35.3-91.1 97 0 62.7 40 95.1 91.5 95.1 25.9 0 49.2-10.2 61.5-22.6V657H683z"
                }
            }
        ]
    })(props);
}
function AiOutlineFileMarkdown(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M854.6 288.6L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM790.2 326H602V137.8L790.2 326zm1.8 562H232V136h302v216a42 42 0 0 0 42 42h216v494zM429 481.2c-1.9-4.4-6.2-7.2-11-7.2h-35c-6.6 0-12 5.4-12 12v272c0 6.6 5.4 12 12 12h27.1c6.6 0 12-5.4 12-12V582.1l66.8 150.2a12 12 0 0 0 11 7.1H524c4.7 0 9-2.8 11-7.1l66.8-150.6V758c0 6.6 5.4 12 12 12H641c6.6 0 12-5.4 12-12V486c0-6.6-5.4-12-12-12h-34.7c-4.8 0-9.1 2.8-11 7.2l-83.1 191-83.2-191z"
                }
            }
        ]
    })(props);
}
function AiOutlineFilePdf(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M531.3 574.4l.3-1.4c5.8-23.9 13.1-53.7 7.4-80.7-3.8-21.3-19.5-29.6-32.9-30.2-15.8-.7-29.9 8.3-33.4 21.4-6.6 24-.7 56.8 10.1 98.6-13.6 32.4-35.3 79.5-51.2 107.5-29.6 15.3-69.3 38.9-75.2 68.7-1.2 5.5.2 12.5 3.5 18.8 3.7 7 9.6 12.4 16.5 15 3 1.1 6.6 2 10.8 2 17.6 0 46.1-14.2 84.1-79.4 5.8-1.9 11.8-3.9 17.6-5.9 27.2-9.2 55.4-18.8 80.9-23.1 28.2 15.1 60.3 24.8 82.1 24.8 21.6 0 30.1-12.8 33.3-20.5 5.6-13.5 2.9-30.5-6.2-39.6-13.2-13-45.3-16.4-95.3-10.2-24.6-15-40.7-35.4-52.4-65.8zM421.6 726.3c-13.9 20.2-24.4 30.3-30.1 34.7 6.7-12.3 19.8-25.3 30.1-34.7zm87.6-235.5c5.2 8.9 4.5 35.8.5 49.4-4.9-19.9-5.6-48.1-2.7-51.4.8.1 1.5.7 2.2 2zm-1.6 120.5c10.7 18.5 24.2 34.4 39.1 46.2-21.6 4.9-41.3 13-58.9 20.2-4.2 1.7-8.3 3.4-12.3 5 13.3-24.1 24.4-51.4 32.1-71.4zm155.6 65.5c.1.2.2.5-.4.9h-.2l-.2.3c-.8.5-9 5.3-44.3-8.6 40.6-1.9 45 7.3 45.1 7.4zm191.4-388.2L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM790.2 326H602V137.8L790.2 326zm1.8 562H232V136h302v216a42 42 0 0 0 42 42h216v494z"
                }
            }
        ]
    })(props);
}
function AiOutlineFilePpt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M424 476c-4.4 0-8 3.6-8 8v276c0 4.4 3.6 8 8 8h32.5c4.4 0 8-3.6 8-8v-95.5h63.3c59.4 0 96.2-38.9 96.2-94.1 0-54.5-36.3-94.3-96-94.3H424zm150.6 94.3c0 43.4-26.5 54.3-71.2 54.3h-38.9V516.2h56.2c33.8 0 53.9 19.7 53.9 54.1zm280-281.7L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM790.2 326H602V137.8L790.2 326zm1.8 562H232V136h302v216a42 42 0 0 0 42 42h216v494z"
                }
            }
        ]
    })(props);
}
function AiOutlineFileProtect(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M644.7 669.2a7.92 7.92 0 0 0-6.5-3.3H594c-6.5 0-10.3 7.4-6.5 12.7l73.8 102.1c3.2 4.4 9.7 4.4 12.9 0l114.2-158c3.8-5.3 0-12.7-6.5-12.7h-44.3c-2.6 0-5 1.2-6.5 3.3l-63.5 87.8-22.9-31.9zM688 306v-48c0-4.4-3.6-8-8-8H296c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h384c4.4 0 8-3.6 8-8zm-392 88c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h184c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H296zm184 458H208V148h560v296c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V108c0-17.7-14.3-32-32-32H168c-17.7 0-32 14.3-32 32v784c0 17.7 14.3 32 32 32h312c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm402.6-320.8l-192-66.7c-.9-.3-1.7-.4-2.6-.4s-1.8.1-2.6.4l-192 66.7a7.96 7.96 0 0 0-5.4 7.5v251.1c0 2.5 1.1 4.8 3.1 6.3l192 150.2c1.4 1.1 3.2 1.7 4.9 1.7s3.5-.6 4.9-1.7l192-150.2c1.9-1.5 3.1-3.8 3.1-6.3V538.7c0-3.4-2.2-6.4-5.4-7.5zM826 763.7L688 871.6 550 763.7V577l138-48 138 48v186.7z"
                }
            }
        ]
    })(props);
}
function AiOutlineFileSearch(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M688 312v-48c0-4.4-3.6-8-8-8H296c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h384c4.4 0 8-3.6 8-8zm-392 88c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h184c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H296zm144 452H208V148h560v344c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V108c0-17.7-14.3-32-32-32H168c-17.7 0-32 14.3-32 32v784c0 17.7 14.3 32 32 32h272c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm445.7 51.5l-93.3-93.3C814.7 780.7 828 743.9 828 704c0-97.2-78.8-176-176-176s-176 78.8-176 176 78.8 176 176 176c35.8 0 69-10.7 96.8-29l94.7 94.7c1.6 1.6 3.6 2.3 5.6 2.3s4.1-.8 5.6-2.3l31-31a7.9 7.9 0 0 0 0-11.2zM652 816c-61.9 0-112-50.1-112-112s50.1-112 112-112 112 50.1 112 112-50.1 112-112 112z"
                }
            }
        ]
    })(props);
}
function AiOutlineFileSync(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M296 256c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h384c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H296zm192 200v-48c0-4.4-3.6-8-8-8H296c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h184c4.4 0 8-3.6 8-8zm-48 396H208V148h560v344c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V108c0-17.7-14.3-32-32-32H168c-17.7 0-32 14.3-32 32v784c0 17.7 14.3 32 32 32h272c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm104.1-115.6c1.8-34.5 16.2-66.8 40.8-91.4 26.2-26.2 62-41 99.1-41 37.4 0 72.6 14.6 99.1 41 3.2 3.2 6.3 6.6 9.2 10.1L769.2 673a8 8 0 0 0 3 14.1l93.3 22.5c5 1.2 9.8-2.6 9.9-7.7l.6-95.4a8 8 0 0 0-12.9-6.4l-20.3 15.8C805.4 569.6 748.1 540 684 540c-109.9 0-199.6 86.9-204 195.7-.2 4.5 3.5 8.3 8 8.3h48.1c4.3 0 7.8-3.3 8-7.6zM880 744h-48.1c-4.3 0-7.8 3.3-8 7.6-1.8 34.5-16.2 66.8-40.8 91.4-26.2 26.2-62 41-99.1 41-37.4 0-72.6-14.6-99.1-41-3.2-3.2-6.3-6.6-9.2-10.1l23.1-17.9a8 8 0 0 0-3-14.1l-93.3-22.5c-5-1.2-9.8 2.6-9.9 7.7l-.6 95.4a8 8 0 0 0 12.9 6.4l20.3-15.8C562.6 918.4 619.9 948 684 948c109.9 0 199.6-86.9 204-195.7.2-4.5-3.5-8.3-8-8.3z"
                }
            }
        ]
    })(props);
}
function AiOutlineFileText(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M854.6 288.6L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM790.2 326H602V137.8L790.2 326zm1.8 562H232V136h302v216a42 42 0 0 0 42 42h216v494zM504 618H320c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h184c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zM312 490v48c0 4.4 3.6 8 8 8h384c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H320c-4.4 0-8 3.6-8 8z"
                }
            }
        ]
    })(props);
}
function AiOutlineFileUnknown(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M854.6 288.7L639.4 73.4c-6-6-14.2-9.4-22.7-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.6-9.4-22.6zM790.2 326H602V137.8L790.2 326zm1.8 562H232V136h302v216a42 42 0 0 0 42 42h216v494zM402 549c0 5.4 4.4 9.5 9.8 9.5h32.4c5.4 0 9.8-4.2 9.8-9.4 0-28.2 25.8-51.6 58-51.6s58 23.4 58 51.5c0 25.3-21 47.2-49.3 50.9-19.3 2.8-34.5 20.3-34.7 40.1v32c0 5.5 4.5 10 10 10h32c5.5 0 10-4.5 10-10v-12.2c0-6 4-11.5 9.7-13.3 44.6-14.4 75-54 74.3-98.9-.8-55.5-49.2-100.8-108.5-101.6-61.4-.7-111.5 45.6-111.5 103zm78 195a32 32 0 1 0 64 0 32 32 0 1 0-64 0z"
                }
            }
        ]
    })(props);
}
function AiOutlineFileWord(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M854.6 288.6L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM790.2 326H602V137.8L790.2 326zm1.8 562H232V136h302v216a42 42 0 0 0 42 42h216v494zM528.1 472h-32.2c-5.5 0-10.3 3.7-11.6 9.1L434.6 680l-46.1-198.7c-1.3-5.4-6.1-9.3-11.7-9.3h-35.4a12.02 12.02 0 0 0-11.6 15.1l74.2 276c1.4 5.2 6.2 8.9 11.6 8.9h32c5.4 0 10.2-3.6 11.6-8.9l52.8-197 52.8 197c1.4 5.2 6.2 8.9 11.6 8.9h31.8c5.4 0 10.2-3.6 11.6-8.9l74.4-276a12.04 12.04 0 0 0-11.6-15.1H647c-5.6 0-10.4 3.9-11.7 9.3l-45.8 199.1-49.8-199.3c-1.3-5.4-6.1-9.1-11.6-9.1z"
                }
            }
        ]
    })(props);
}
function AiOutlineFileZip(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M296 392h64v64h-64zm0 190v160h128V582h-64v-62h-64v62zm80 48v64h-32v-64h32zm-16-302h64v64h-64zm-64-64h64v64h-64zm64 192h64v64h-64zm0-256h64v64h-64zm494.6 88.6L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM790.2 326H602V137.8L790.2 326zm1.8 562H232V136h64v64h64v-64h174v216a42 42 0 0 0 42 42h216v494z"
                }
            }
        ]
    })(props);
}
function AiOutlineFile(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M854.6 288.6L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM790.2 326H602V137.8L790.2 326zm1.8 562H232V136h302v216a42 42 0 0 0 42 42h216v494z"
                }
            }
        ]
    })(props);
}
function AiOutlineFilter(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M880.1 154H143.9c-24.5 0-39.8 26.7-27.5 48L349 597.4V838c0 17.7 14.2 32 31.8 32h262.4c17.6 0 31.8-14.3 31.8-32V597.4L907.7 202c12.2-21.3-3.1-48-27.6-48zM603.4 798H420.6V642h182.9v156zm9.6-236.6l-9.5 16.6h-183l-9.5-16.6L212.7 226h598.6L613 561.4z"
                }
            }
        ]
    })(props);
}
function AiOutlineFire(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M834.1 469.2A347.49 347.49 0 0 0 751.2 354l-29.1-26.7a8.09 8.09 0 0 0-13 3.3l-13 37.3c-8.1 23.4-23 47.3-44.1 70.8-1.4 1.5-3 1.9-4.1 2-1.1.1-2.8-.1-4.3-1.5-1.4-1.2-2.1-3-2-4.8 3.7-60.2-14.3-128.1-53.7-202C555.3 171 510 123.1 453.4 89.7l-41.3-24.3c-5.4-3.2-12.3 1-12 7.3l2.2 48c1.5 32.8-2.3 61.8-11.3 85.9-11 29.5-26.8 56.9-47 81.5a295.64 295.64 0 0 1-47.5 46.1 352.6 352.6 0 0 0-100.3 121.5A347.75 347.75 0 0 0 160 610c0 47.2 9.3 92.9 27.7 136a349.4 349.4 0 0 0 75.5 110.9c32.4 32 70 57.2 111.9 74.7C418.5 949.8 464.5 959 512 959s93.5-9.2 136.9-27.3A348.6 348.6 0 0 0 760.8 857c32.4-32 57.8-69.4 75.5-110.9a344.2 344.2 0 0 0 27.7-136c0-48.8-10-96.2-29.9-140.9zM713 808.5c-53.7 53.2-125 82.4-201 82.4s-147.3-29.2-201-82.4c-53.5-53.1-83-123.5-83-198.4 0-43.5 9.8-85.2 29.1-124 18.8-37.9 46.8-71.8 80.8-97.9a349.6 349.6 0 0 0 58.6-56.8c25-30.5 44.6-64.5 58.2-101a240 240 0 0 0 12.1-46.5c24.1 22.2 44.3 49 61.2 80.4 33.4 62.6 48.8 118.3 45.8 165.7a74.01 74.01 0 0 0 24.4 59.8 73.36 73.36 0 0 0 53.4 18.8c19.7-1 37.8-9.7 51-24.4 13.3-14.9 24.8-30.1 34.4-45.6 14 17.9 25.7 37.4 35 58.4 15.9 35.8 24 73.9 24 113.1 0 74.9-29.5 145.4-83 198.4z"
                }
            }
        ]
    })(props);
}
function AiOutlineFlag(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M880 305H624V192c0-17.7-14.3-32-32-32H184v-40c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v784c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V640h248v113c0 17.7 14.3 32 32 32h416c17.7 0 32-14.3 32-32V337c0-17.7-14.3-32-32-32zM184 568V232h368v336H184zm656 145H504v-73h112c4.4 0 8-3.6 8-8V377h216v336z"
                }
            }
        ]
    })(props);
}
function AiOutlineFolderAdd(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M484 443.1V528h-84.5c-4.1 0-7.5 3.1-7.5 7v42c0 3.8 3.4 7 7.5 7H484v84.9c0 3.9 3.2 7.1 7 7.1h42c3.9 0 7-3.2 7-7.1V584h84.5c4.1 0 7.5-3.2 7.5-7v-42c0-3.9-3.4-7-7.5-7H540v-84.9c0-3.9-3.1-7.1-7-7.1h-42c-3.8 0-7 3.2-7 7.1zm396-144.7H521L403.7 186.2a8.15 8.15 0 0 0-5.5-2.2H144c-17.7 0-32 14.3-32 32v592c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V330.4c0-17.7-14.3-32-32-32zM840 768H184V256h188.5l119.6 114.4H840V768z"
                }
            }
        ]
    })(props);
}
function AiOutlineFolderOpen(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M928 444H820V330.4c0-17.7-14.3-32-32-32H473L355.7 186.2a8.15 8.15 0 0 0-5.5-2.2H96c-17.7 0-32 14.3-32 32v592c0 17.7 14.3 32 32 32h698c13 0 24.8-7.9 29.7-20l134-332c1.5-3.8 2.3-7.9 2.3-12 0-17.7-14.3-32-32-32zM136 256h188.5l119.6 114.4H748V444H238c-13 0-24.8 7.9-29.7 20L136 643.2V256zm635.3 512H159l103.3-256h612.4L771.3 768z"
                }
            }
        ]
    })(props);
}
function AiOutlineFolderView(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "t": "1569683698855",
            "viewBox": "0 0 1024 1024",
            "version": "1.1"
        },
        "child": [
            {
                "tag": "defs",
                "attr": {},
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M309.1 554.3c-5.4 11.6-5.4 24.9 0 36.4C353.3 684 421.6 732 512.5 732s159.2-48.1 203.4-141.3c5.4-11.5 5.4-24.8 0.1-36.3l-0.1-0.1-0.1-0.1C671.7 461 603.4 413 512.5 413s-159.2 48.1-203.4 141.3zM512.5 477c62.1 0 107.4 30 141.1 95.5C620 638 574.6 668 512.5 668s-107.4-30-141.1-95.5c33.7-65.5 79-95.5 141.1-95.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M513 573m-56 0a56 56 0 1 0 112 0 56 56 0 1 0-112 0Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M880 298.4H521L403.7 186.2c-1.5-1.4-3.5-2.2-5.5-2.2H144c-17.7 0-32 14.3-32 32v592c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V330.4c0-17.7-14.3-32-32-32zM840 768H184V256h188.5l119.6 114.4H840V768z"
                }
            }
        ]
    })(props);
}
function AiOutlineFolder(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M880 298.4H521L403.7 186.2a8.15 8.15 0 0 0-5.5-2.2H144c-17.7 0-32 14.3-32 32v592c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V330.4c0-17.7-14.3-32-32-32zM840 768H184V256h188.5l119.6 114.4H840V768z"
                }
            }
        ]
    })(props);
}
function AiOutlineFontColors(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M904 816H120c-4.4 0-8 3.6-8 8v80c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-80c0-4.4-3.6-8-8-8zm-650.3-80h85c4.2 0 8-2.7 9.3-6.8l53.7-166h219.2l53.2 166c1.3 4 5 6.8 9.3 6.8h89.1c1.1 0 2.2-.2 3.2-.5a9.7 9.7 0 0 0 6-12.4L573.6 118.6a9.9 9.9 0 0 0-9.2-6.6H462.1c-4.2 0-7.9 2.6-9.2 6.6L244.5 723.1c-.4 1-.5 2.1-.5 3.2-.1 5.3 4.3 9.7 9.7 9.7zm255.9-516.1h4.1l83.8 263.8H424.9l84.7-263.8z"
                }
            }
        ]
    })(props);
}
function AiOutlineFontSize(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M920 416H616c-4.4 0-8 3.6-8 8v112c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8v-56h60v320h-46c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h164c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8h-46V480h60v56c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V424c0-4.4-3.6-8-8-8zM656 296V168c0-4.4-3.6-8-8-8H104c-4.4 0-8 3.6-8 8v128c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-64h168v560h-92c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h264c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-92V232h168v64c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8z"
                }
            }
        ]
    })(props);
}
function AiOutlineFork(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M752 100c-61.8 0-112 50.2-112 112 0 47.7 29.9 88.5 72 104.6v27.6L512 601.4 312 344.2v-27.6c42.1-16.1 72-56.9 72-104.6 0-61.8-50.2-112-112-112s-112 50.2-112 112c0 50.6 33.8 93.5 80 107.3v34.4c0 9.7 3.3 19.3 9.3 27L476 672.3v33.6c-44.2 15-76 56.9-76 106.1 0 61.8 50.2 112 112 112s112-50.2 112-112c0-49.2-31.8-91-76-106.1v-33.6l226.7-291.6c6-7.7 9.3-17.3 9.3-27v-34.4c46.2-13.8 80-56.7 80-107.3 0-61.8-50.2-112-112-112zM224 212a48.01 48.01 0 0 1 96 0 48.01 48.01 0 0 1-96 0zm336 600a48.01 48.01 0 0 1-96 0 48.01 48.01 0 0 1 96 0zm192-552a48.01 48.01 0 0 1 0-96 48.01 48.01 0 0 1 0 96z"
                }
            }
        ]
    })(props);
}
function AiOutlineForm(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M904 512h-56c-4.4 0-8 3.6-8 8v320H184V184h320c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V520c0-4.4-3.6-8-8-8z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M355.9 534.9L354 653.8c-.1 8.9 7.1 16.2 16 16.2h.4l118-2.9c2-.1 4-.9 5.4-2.3l415.9-415c3.1-3.1 3.1-8.2 0-11.3L785.4 114.3c-1.6-1.6-3.6-2.3-5.7-2.3s-4.1.8-5.7 2.3l-415.8 415a8.3 8.3 0 0 0-2.3 5.6zm63.5 23.6L779.7 199l45.2 45.1-360.5 359.7-45.7 1.1.7-46.4z"
                }
            }
        ]
    })(props);
}
function AiOutlineFormatPainter(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "t": "1569683552617",
            "viewBox": "0 0 1024 1024",
            "version": "1.1"
        },
        "child": [
            {
                "tag": "defs",
                "attr": {},
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M840 192h-56v-72c0-13.3-10.7-24-24-24H168c-13.3 0-24 10.7-24 24v272c0 13.3 10.7 24 24 24h592c13.3 0 24-10.7 24-24V256h32v200H465c-22.1 0-40 17.9-40 40v136h-44c-4.4 0-8 3.6-8 8v228c0 0.6 0.1 1.3 0.2 1.9-0.1 2-0.2 4.1-0.2 6.1 0 46.4 37.6 84 84 84s84-37.6 84-84c0-2.1-0.1-4.1-0.2-6.1 0.1-0.6 0.2-1.2 0.2-1.9V640c0-4.4-3.6-8-8-8h-44V520h351c22.1 0 40-17.9 40-40V232c0-22.1-17.9-40-40-40zM720 352H208V160h512v192zM477 876c0 11-9 20-20 20s-20-9-20-20V696h40v180z"
                }
            }
        ]
    })(props);
}
function AiOutlineForward(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M825.8 498L538.4 249.9c-10.7-9.2-26.4-.9-26.4 14v496.3c0 14.9 15.7 23.2 26.4 14L825.8 526c8.3-7.2 8.3-20.8 0-28zm-320 0L218.4 249.9c-10.7-9.2-26.4-.9-26.4 14v496.3c0 14.9 15.7 23.2 26.4 14L505.8 526c4.1-3.6 6.2-8.8 6.2-14 0-5.2-2.1-10.4-6.2-14z"
                }
            }
        ]
    })(props);
}
function AiOutlineFrown(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M288 421a48 48 0 1 0 96 0 48 48 0 1 0-96 0zm352 0a48 48 0 1 0 96 0 48 48 0 1 0-96 0zM512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm263 711c-34.2 34.2-74 61-118.3 79.8C611 874.2 562.3 884 512 884c-50.3 0-99-9.8-144.8-29.2A370.4 370.4 0 0 1 248.9 775c-34.2-34.2-61-74-79.8-118.3C149.8 611 140 562.3 140 512s9.8-99 29.2-144.8A370.4 370.4 0 0 1 249 248.9c34.2-34.2 74-61 118.3-79.8C413 149.8 461.7 140 512 140c50.3 0 99 9.8 144.8 29.2A370.4 370.4 0 0 1 775.1 249c34.2 34.2 61 74 79.8 118.3C874.2 413 884 461.7 884 512s-9.8 99-29.2 144.8A368.89 368.89 0 0 1 775 775zM512 533c-85.5 0-155.6 67.3-160 151.6a8 8 0 0 0 8 8.4h48.1c4.2 0 7.8-3.2 8.1-7.4C420 636.1 461.5 597 512 597s92.1 39.1 95.8 88.6c.3 4.2 3.9 7.4 8.1 7.4H664a8 8 0 0 0 8-8.4C667.6 600.3 597.5 533 512 533z"
                }
            }
        ]
    })(props);
}
function AiOutlineFullscreenExit(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M391 240.9c-.8-6.6-8.9-9.4-13.6-4.7l-43.7 43.7L200 146.3a8.03 8.03 0 0 0-11.3 0l-42.4 42.3a8.03 8.03 0 0 0 0 11.3L280 333.6l-43.9 43.9a8.01 8.01 0 0 0 4.7 13.6L401 410c5.1.6 9.5-3.7 8.9-8.9L391 240.9zm10.1 373.2L240.8 633c-6.6.8-9.4 8.9-4.7 13.6l43.9 43.9L146.3 824a8.03 8.03 0 0 0 0 11.3l42.4 42.3c3.1 3.1 8.2 3.1 11.3 0L333.7 744l43.7 43.7A8.01 8.01 0 0 0 391 783l18.9-160.1c.6-5.1-3.7-9.4-8.8-8.8zm221.8-204.2L783.2 391c6.6-.8 9.4-8.9 4.7-13.6L744 333.6 877.7 200c3.1-3.1 3.1-8.2 0-11.3l-42.4-42.3a8.03 8.03 0 0 0-11.3 0L690.3 279.9l-43.7-43.7a8.01 8.01 0 0 0-13.6 4.7L614.1 401c-.6 5.2 3.7 9.5 8.8 8.9zM744 690.4l43.9-43.9a8.01 8.01 0 0 0-4.7-13.6L623 614c-5.1-.6-9.5 3.7-8.9 8.9L633 783.1c.8 6.6 8.9 9.4 13.6 4.7l43.7-43.7L824 877.7c3.1 3.1 8.2 3.1 11.3 0l42.4-42.3c3.1-3.1 3.1-8.2 0-11.3L744 690.4z"
                }
            }
        ]
    })(props);
}
function AiOutlineFullscreen(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M290 236.4l43.9-43.9a8.01 8.01 0 0 0-4.7-13.6L169 160c-5.1-.6-9.5 3.7-8.9 8.9L179 329.1c.8 6.6 8.9 9.4 13.6 4.7l43.7-43.7L370 423.7c3.1 3.1 8.2 3.1 11.3 0l42.4-42.3c3.1-3.1 3.1-8.2 0-11.3L290 236.4zm352.7 187.3c3.1 3.1 8.2 3.1 11.3 0l133.7-133.6 43.7 43.7a8.01 8.01 0 0 0 13.6-4.7L863.9 169c.6-5.1-3.7-9.5-8.9-8.9L694.8 179c-6.6.8-9.4 8.9-4.7 13.6l43.9 43.9L600.3 370a8.03 8.03 0 0 0 0 11.3l42.4 42.4zM845 694.9c-.8-6.6-8.9-9.4-13.6-4.7l-43.7 43.7L654 600.3a8.03 8.03 0 0 0-11.3 0l-42.4 42.3a8.03 8.03 0 0 0 0 11.3L734 787.6l-43.9 43.9a8.01 8.01 0 0 0 4.7 13.6L855 864c5.1.6 9.5-3.7 8.9-8.9L845 694.9zm-463.7-94.6a8.03 8.03 0 0 0-11.3 0L236.3 733.9l-43.7-43.7a8.01 8.01 0 0 0-13.6 4.7L160.1 855c-.6 5.1 3.7 9.5 8.9 8.9L329.2 845c6.6-.8 9.4-8.9 4.7-13.6L290 787.6 423.7 654c3.1-3.1 3.1-8.2 0-11.3l-42.4-42.4z"
                }
            }
        ]
    })(props);
}
function AiOutlineFunction(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "t": "1569683610100",
            "viewBox": "0 0 1024 1024",
            "version": "1.1"
        },
        "child": [
            {
                "tag": "defs",
                "attr": {},
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M841 370c3-3.3 2.7-8.3-0.6-11.3-1.5-1.3-3.4-2.1-5.3-2.1h-72.6c-2.4 0-4.6 1-6.1 2.8L633.5 504.6c-2.9 3.4-7.9 3.8-11.3 0.9-0.9-0.8-1.6-1.7-2.1-2.8l-63.5-141.3c-1.3-2.9-4.1-4.7-7.3-4.7H380.7l0.9-4.7 8-42.3c10.5-55.4 38-81.4 85.8-81.4 18.6 0 35.5 1.7 48.8 4.7l14.1-66.8c-22.6-4.7-35.2-6.1-54.9-6.1-103.3 0-156.4 44.3-175.9 147.3l-9.4 49.4h-97.6c-3.8 0-7.1 2.7-7.8 6.4L181.9 415c-0.9 4.3 1.9 8.6 6.2 9.5 0.5 0.1 1.1 0.2 1.6 0.2H284l-89 429.9c-0.9 4.3 1.9 8.6 6.2 9.5 0.5 0.1 1.1 0.2 1.6 0.2H269c3.8 0 7.1-2.7 7.8-6.4l89.7-433.1h135.8l68.2 139.1c1.4 2.9 1 6.4-1.2 8.8l-180.6 203c-2.9 3.3-2.6 8.4 0.7 11.3 1.5 1.3 3.4 2 5.3 2h72.7c2.4 0 4.6-1 6.1-2.8l123.7-146.7c2.8-3.4 7.9-3.8 11.3-1 0.9 0.8 1.6 1.7 2.1 2.8L676.4 784c1.3 2.8 4.1 4.7 7.3 4.7h64.6c4.4 0 8-3.6 8-8 0-1.2-0.3-2.4-0.8-3.5l-95.2-198.9c-1.4-2.9-0.9-6.4 1.3-8.8L841 370z"
                }
            }
        ]
    })(props);
}
function AiOutlineFundProjectionScreen(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "t": "1569683753031",
            "viewBox": "0 0 1024 1024",
            "version": "1.1"
        },
        "child": [
            {
                "tag": "defs",
                "attr": {},
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M312.1 591.5c3.1 3.1 8.2 3.1 11.3 0l101.8-101.8 86.1 86.2c3.1 3.1 8.2 3.1 11.3 0l226.3-226.5c3.1-3.1 3.1-8.2 0-11.3l-36.8-36.8c-3.1-3.1-8.2-3.1-11.3 0L517 485.3l-86.1-86.2c-3.1-3.1-8.2-3.1-11.3 0L275.3 543.4c-3.1 3.1-3.1 8.2 0 11.3l36.8 36.8z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M904 160H548V96c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v64H120c-17.7 0-32 14.3-32 32v520c0 17.7 14.3 32 32 32h356.4v32L311.6 884.1c-3.7 2.4-4.7 7.3-2.3 11l30.3 47.2v0.1c2.4 3.7 7.4 4.7 11.1 2.3L512 838.9l161.3 105.8c3.7 2.4 8.7 1.4 11.1-2.3v-0.1l30.3-47.2c2.4-3.7 1.3-8.6-2.3-11L548 776.3V744h356c17.7 0 32-14.3 32-32V192c0-17.7-14.3-32-32-32z m-40 512H160V232h704v440z"
                }
            }
        ]
    })(props);
}
function AiOutlineFundView(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "t": "1569683816874",
            "viewBox": "0 0 1024 1024",
            "version": "1.1"
        },
        "child": [
            {
                "tag": "defs",
                "attr": {},
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M956 686.5l-0.1-0.1-0.1-0.1C911.7 593 843.4 545 752.5 545s-159.2 48.1-203.4 141.3v0.1c-5.4 11.5-5.4 24.9 0 36.4C593.3 816 661.6 864 752.5 864s159.2-48.1 203.4-141.3c5.4-11.5 5.4-24.8 0.1-36.2zM752.5 800c-62.1 0-107.4-30-141.1-95.5C645 639 690.4 609 752.5 609c62.1 0 107.4 30 141.1 95.5C860 770 814.6 800 752.5 800z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M753 705m-56 0a56 56 0 1 0 112 0 56 56 0 1 0-112 0Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M136 232h704v253h72V192c0-17.7-14.3-32-32-32H96c-17.7 0-32 14.3-32 32v520c0 17.7 14.3 32 32 32h352v-72H136V232z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M724.9 338.1l-36.8-36.8c-3.1-3.1-8.2-3.1-11.3 0L493 485.3l-86.1-86.2c-3.1-3.1-8.2-3.1-11.3 0L251.3 543.4c-3.1 3.1-3.1 8.2 0 11.3l36.8 36.8c3.1 3.1 8.2 3.1 11.3 0l101.8-101.8 86.1 86.2c3.1 3.1 8.2 3.1 11.3 0l226.3-226.5c3.2-3.1 3.2-8.2 0-11.3z"
                }
            }
        ]
    })(props);
}
function AiOutlineFund(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M926 164H94c-17.7 0-32 14.3-32 32v640c0 17.7 14.3 32 32 32h832c17.7 0 32-14.3 32-32V196c0-17.7-14.3-32-32-32zm-40 632H134V236h752v560zm-658.9-82.3c3.1 3.1 8.2 3.1 11.3 0l172.5-172.5 114.4 114.5c3.1 3.1 8.2 3.1 11.3 0l297-297.2c3.1-3.1 3.1-8.2 0-11.3l-36.8-36.8a8.03 8.03 0 0 0-11.3 0L531 565 416.6 450.5a8.03 8.03 0 0 0-11.3 0l-214.9 215a8.03 8.03 0 0 0 0 11.3l36.7 36.9z"
                }
            }
        ]
    })(props);
}
function AiOutlineFunnelPlot(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M880.1 154H143.9c-24.5 0-39.8 26.7-27.5 48L349 607.4V838c0 17.7 14.2 32 31.8 32h262.4c17.6 0 31.8-14.3 31.8-32V607.4L907.7 202c12.2-21.3-3.1-48-27.6-48zM603.4 798H420.6V650h182.9v148zm9.6-226.6l-8.4 14.6H419.3l-8.4-14.6L334.4 438h355.2L613 571.4zM726.3 374H297.7l-85-148h598.6l-85 148z"
                }
            }
        ]
    })(props);
}
function AiOutlineGateway(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M928 392c8.8 0 16-7.2 16-16V192c0-8.8-7.2-16-16-16H744c-8.8 0-16 7.2-16 16v56H296v-56c0-8.8-7.2-16-16-16H96c-8.8 0-16 7.2-16 16v184c0 8.8 7.2 16 16 16h56v240H96c-8.8 0-16 7.2-16 16v184c0 8.8 7.2 16 16 16h184c8.8 0 16-7.2 16-16v-56h432v56c0 8.8 7.2 16 16 16h184c8.8 0 16-7.2 16-16V648c0-8.8-7.2-16-16-16h-56V392h56zM792 240h88v88h-88v-88zm-648 88v-88h88v88h-88zm88 456h-88v-88h88v88zm648-88v88h-88v-88h88zm-80-64h-56c-8.8 0-16 7.2-16 16v56H296v-56c0-8.8-7.2-16-16-16h-56V392h56c8.8 0 16-7.2 16-16v-56h432v56c0 8.8 7.2 16 16 16h56v240z"
                }
            }
        ]
    })(props);
}
function AiOutlineGif(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "t": "1569683621237",
            "viewBox": "0 0 1024 1024",
            "version": "1.1"
        },
        "child": [
            {
                "tag": "defs",
                "attr": {},
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M944 299H692c-4.4 0-8 3.6-8 8v406c0 4.4 3.6 8 8 8h59.2c4.4 0 8-3.6 8-8V549.9h168.2c4.4 0 8-3.6 8-8V495c0-4.4-3.6-8-8-8H759.2V364.2H944c4.4 0 8-3.6 8-8V307c0-4.4-3.6-8-8-8zM588 300h-56c-4.4 0-8 3.6-8 8v406c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V308c0-4.4-3.6-8-8-8zM452 500.9H290.5c-4.4 0-8 3.6-8 8v43.7c0 4.4 3.6 8 8 8h94.9l-0.3 8.9c-1.2 58.8-45.6 98.5-110.9 98.5-76.2 0-123.9-59.7-123.9-156.7 0-95.8 46.8-155.2 121.5-155.2 54.8 0 93.1 26.9 108.5 75.4h76.2c-13.6-87.2-86-143.4-184.7-143.4C150 288 72 375.2 72 511.9 72 650.2 149.1 736 273 736c114.1 0 187-70.7 187-181.6v-45.5c0-4.4-3.6-8-8-8z"
                }
            }
        ]
    })(props);
}
function AiOutlineGift(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M880 310H732.4c13.6-21.4 21.6-46.8 21.6-74 0-76.1-61.9-138-138-138-41.4 0-78.7 18.4-104 47.4-25.3-29-62.6-47.4-104-47.4-76.1 0-138 61.9-138 138 0 27.2 7.9 52.6 21.6 74H144c-17.7 0-32 14.3-32 32v200c0 4.4 3.6 8 8 8h40v344c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V550h40c4.4 0 8-3.6 8-8V342c0-17.7-14.3-32-32-32zm-334-74c0-38.6 31.4-70 70-70s70 31.4 70 70-31.4 70-70 70h-70v-70zm-138-70c38.6 0 70 31.4 70 70v70h-70c-38.6 0-70-31.4-70-70s31.4-70 70-70zM180 482V378h298v104H180zm48 68h250v308H228V550zm568 308H546V550h250v308zm48-376H546V378h298v104z"
                }
            }
        ]
    })(props);
}
function AiOutlineGithub(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M511.6 76.3C264.3 76.2 64 276.4 64 523.5 64 718.9 189.3 885 363.8 946c23.5 5.9 19.9-10.8 19.9-22.2v-77.5c-135.7 15.9-141.2-73.9-150.3-88.9C215 726 171.5 718 184.5 703c30.9-15.9 62.4 4 98.9 57.9 26.4 39.1 77.9 32.5 104 26 5.7-23.5 17.9-44.5 34.7-60.8-140.6-25.2-199.2-111-199.2-213 0-49.5 16.3-95 48.3-131.7-20.4-60.5 1.9-112.3 4.9-120 58.1-5.2 118.5 41.6 123.2 45.3 33-8.9 70.7-13.6 112.9-13.6 42.4 0 80.2 4.9 113.5 13.9 11.3-8.6 67.3-48.8 121.3-43.9 2.9 7.7 24.7 58.3 5.5 118 32.4 36.8 48.9 82.7 48.9 132.3 0 102.2-59 188.1-200 212.9a127.5 127.5 0 0 1 38.1 91v112.5c.8 9 0 17.9 15 17.9 177.1-59.7 304.6-227 304.6-424.1 0-247.2-200.4-447.3-447.5-447.3z"
                }
            }
        ]
    })(props);
}
function AiOutlineGitlab(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M913.9 552.2L805 181.4v-.1c-7.6-22.9-25.7-36.5-48.3-36.5-23.4 0-42.5 13.5-49.7 35.2l-71.4 213H388.8l-71.4-213c-7.2-21.7-26.3-35.2-49.7-35.2-23.1 0-42.5 14.8-48.4 36.6L110.5 552.2c-4.4 14.7 1.2 31.4 13.5 40.7l368.5 276.4c2.6 3.6 6.2 6.3 10.4 7.8l8.6 6.4 8.5-6.4c4.9-1.7 9-4.7 11.9-8.9l368.4-275.4c12.4-9.2 18-25.9 13.6-40.6zM751.7 193.4c1-1.8 2.9-1.9 3.5-1.9 1.1 0 2.5.3 3.4 3L818 394.3H684.5l67.2-200.9zm-487.4 1c.9-2.6 2.3-2.9 3.4-2.9 2.7 0 2.9.1 3.4 1.7l67.3 201.2H206.5l57.8-200zM158.8 558.7l28.2-97.3 202.4 270.2-230.6-172.9zm73.9-116.4h122.1l90.8 284.3-212.9-284.3zM512.9 776L405.7 442.3H620L512.9 776zm157.9-333.7h119.5L580 723.1l90.8-280.8zm-40.7 293.9l207.3-276.7 29.5 99.2-236.8 177.5z"
                }
            }
        ]
    })(props);
}
function AiOutlineGlobal(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M854.4 800.9c.2-.3.5-.6.7-.9C920.6 722.1 960 621.7 960 512s-39.4-210.1-104.8-288c-.2-.3-.5-.5-.7-.8-1.1-1.3-2.1-2.5-3.2-3.7-.4-.5-.8-.9-1.2-1.4l-4.1-4.7-.1-.1c-1.5-1.7-3.1-3.4-4.6-5.1l-.1-.1c-3.2-3.4-6.4-6.8-9.7-10.1l-.1-.1-4.8-4.8-.3-.3c-1.5-1.5-3-2.9-4.5-4.3-.5-.5-1-1-1.6-1.5-1-1-2-1.9-3-2.8-.3-.3-.7-.6-1-1C736.4 109.2 629.5 64 512 64s-224.4 45.2-304.3 119.2c-.3.3-.7.6-1 1-1 .9-2 1.9-3 2.9-.5.5-1 1-1.6 1.5-1.5 1.4-3 2.9-4.5 4.3l-.3.3-4.8 4.8-.1.1c-3.3 3.3-6.5 6.7-9.7 10.1l-.1.1c-1.6 1.7-3.1 3.4-4.6 5.1l-.1.1c-1.4 1.5-2.8 3.1-4.1 4.7-.4.5-.8.9-1.2 1.4-1.1 1.2-2.1 2.5-3.2 3.7-.2.3-.5.5-.7.8C103.4 301.9 64 402.3 64 512s39.4 210.1 104.8 288c.2.3.5.6.7.9l3.1 3.7c.4.5.8.9 1.2 1.4l4.1 4.7c0 .1.1.1.1.2 1.5 1.7 3 3.4 4.6 5l.1.1c3.2 3.4 6.4 6.8 9.6 10.1l.1.1c1.6 1.6 3.1 3.2 4.7 4.7l.3.3c3.3 3.3 6.7 6.5 10.1 9.6 80.1 74 187 119.2 304.5 119.2s224.4-45.2 304.3-119.2a300 300 0 0 0 10-9.6l.3-.3c1.6-1.6 3.2-3.1 4.7-4.7l.1-.1c3.3-3.3 6.5-6.7 9.6-10.1l.1-.1c1.5-1.7 3.1-3.3 4.6-5 0-.1.1-.1.1-.2 1.4-1.5 2.8-3.1 4.1-4.7.4-.5.8-.9 1.2-1.4a99 99 0 0 0 3.3-3.7zm4.1-142.6c-13.8 32.6-32 62.8-54.2 90.2a444.07 444.07 0 0 0-81.5-55.9c11.6-46.9 18.8-98.4 20.7-152.6H887c-3 40.9-12.6 80.6-28.5 118.3zM887 484H743.5c-1.9-54.2-9.1-105.7-20.7-152.6 29.3-15.6 56.6-34.4 81.5-55.9A373.86 373.86 0 0 1 887 484zM658.3 165.5c39.7 16.8 75.8 40 107.6 69.2a394.72 394.72 0 0 1-59.4 41.8c-15.7-45-35.8-84.1-59.2-115.4 3.7 1.4 7.4 2.9 11 4.4zm-90.6 700.6c-9.2 7.2-18.4 12.7-27.7 16.4V697a389.1 389.1 0 0 1 115.7 26.2c-8.3 24.6-17.9 47.3-29 67.8-17.4 32.4-37.8 58.3-59 75.1zm59-633.1c11 20.6 20.7 43.3 29 67.8A389.1 389.1 0 0 1 540 327V141.6c9.2 3.7 18.5 9.1 27.7 16.4 21.2 16.7 41.6 42.6 59 75zM540 640.9V540h147.5c-1.6 44.2-7.1 87.1-16.3 127.8l-.3 1.2A445.02 445.02 0 0 0 540 640.9zm0-156.9V383.1c45.8-2.8 89.8-12.5 130.9-28.1l.3 1.2c9.2 40.7 14.7 83.5 16.3 127.8H540zm-56 56v100.9c-45.8 2.8-89.8 12.5-130.9 28.1l-.3-1.2c-9.2-40.7-14.7-83.5-16.3-127.8H484zm-147.5-56c1.6-44.2 7.1-87.1 16.3-127.8l.3-1.2c41.1 15.6 85 25.3 130.9 28.1V484H336.5zM484 697v185.4c-9.2-3.7-18.5-9.1-27.7-16.4-21.2-16.7-41.7-42.7-59.1-75.1-11-20.6-20.7-43.3-29-67.8 37.2-14.6 75.9-23.3 115.8-26.1zm0-370a389.1 389.1 0 0 1-115.7-26.2c8.3-24.6 17.9-47.3 29-67.8 17.4-32.4 37.8-58.4 59.1-75.1 9.2-7.2 18.4-12.7 27.7-16.4V327zM365.7 165.5c3.7-1.5 7.3-3 11-4.4-23.4 31.3-43.5 70.4-59.2 115.4-21-12-40.9-26-59.4-41.8 31.8-29.2 67.9-52.4 107.6-69.2zM165.5 365.7c13.8-32.6 32-62.8 54.2-90.2 24.9 21.5 52.2 40.3 81.5 55.9-11.6 46.9-18.8 98.4-20.7 152.6H137c3-40.9 12.6-80.6 28.5-118.3zM137 540h143.5c1.9 54.2 9.1 105.7 20.7 152.6a444.07 444.07 0 0 0-81.5 55.9A373.86 373.86 0 0 1 137 540zm228.7 318.5c-39.7-16.8-75.8-40-107.6-69.2 18.5-15.8 38.4-29.7 59.4-41.8 15.7 45 35.8 84.1 59.2 115.4-3.7-1.4-7.4-2.9-11-4.4zm292.6 0c-3.7 1.5-7.3 3-11 4.4 23.4-31.3 43.5-70.4 59.2-115.4 21 12 40.9 26 59.4 41.8a373.81 373.81 0 0 1-107.6 69.2z"
                }
            }
        ]
    })(props);
}
function AiOutlineGold(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M342 472h342c.4 0 .9 0 1.3-.1 4.4-.7 7.3-4.8 6.6-9.2l-40.2-248c-.6-3.9-4-6.7-7.9-6.7H382.2c-3.9 0-7.3 2.8-7.9 6.7l-40.2 248c-.1.4-.1.9-.1 1.3 0 4.4 3.6 8 8 8zm91.2-196h159.5l20.7 128h-201l20.8-128zm2.5 282.7c-.6-3.9-4-6.7-7.9-6.7H166.2c-3.9 0-7.3 2.8-7.9 6.7l-40.2 248c-.1.4-.1.9-.1 1.3 0 4.4 3.6 8 8 8h342c.4 0 .9 0 1.3-.1 4.4-.7 7.3-4.8 6.6-9.2l-40.2-248zM196.5 748l20.7-128h159.5l20.7 128H196.5zm709.4 58.7l-40.2-248c-.6-3.9-4-6.7-7.9-6.7H596.2c-3.9 0-7.3 2.8-7.9 6.7l-40.2 248c-.1.4-.1.9-.1 1.3 0 4.4 3.6 8 8 8h342c.4 0 .9 0 1.3-.1 4.3-.7 7.3-4.8 6.6-9.2zM626.5 748l20.7-128h159.5l20.7 128H626.5z"
                }
            }
        ]
    })(props);
}
function AiOutlineGooglePlus(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M879.5 470.4c-.3-27-.4-54.2-.5-81.3h-80.8c-.3 27-.5 54.1-.7 81.3-27.2.1-54.2.3-81.2.6v80.9c27 .3 54.2.5 81.2.8.3 27 .3 54.1.5 81.1h80.9c.1-27 .3-54.1.5-81.3 27.2-.3 54.2-.4 81.2-.7v-80.9c-26.9-.2-54.1-.2-81.1-.5zm-530 .4c-.1 32.3 0 64.7.1 97 54.2 1.8 108.5 1 162.7 1.8-23.9 120.3-187.4 159.3-273.9 80.7-89-68.9-84.8-220 7.7-284 64.7-51.6 156.6-38.9 221.3 5.8 25.4-23.5 49.2-48.7 72.1-74.7-53.8-42.9-119.8-73.5-190-70.3-146.6-4.9-281.3 123.5-283.7 270.2-9.4 119.9 69.4 237.4 180.6 279.8 110.8 42.7 252.9 13.6 323.7-86 46.7-62.9 56.8-143.9 51.3-220-90.7-.7-181.3-.6-271.9-.3z"
                }
            }
        ]
    })(props);
}
function AiOutlineGoogle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M881 442.4H519.7v148.5h206.4c-8.9 48-35.9 88.6-76.6 115.8-34.4 23-78.3 36.6-129.9 36.6-99.9 0-184.4-67.5-214.6-158.2-7.6-23-12-47.6-12-72.9s4.4-49.9 12-72.9c30.3-90.6 114.8-158.1 214.7-158.1 56.3 0 106.8 19.4 146.6 57.4l110-110.1c-66.5-62-153.2-100-256.6-100-149.9 0-279.6 86-342.7 211.4-26 51.8-40.8 110.4-40.8 172.4S151 632.8 177 684.6C240.1 810 369.8 896 519.7 896c103.6 0 190.4-34.4 253.8-93 72.5-66.8 114.4-165.2 114.4-282.1 0-27.2-2.4-53.3-6.9-78.5z"
                }
            }
        ]
    })(props);
}
function AiOutlineGroup(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "t": "1569683739097",
            "viewBox": "0 0 1024 1024",
            "version": "1.1"
        },
        "child": [
            {
                "tag": "defs",
                "attr": {},
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M912 820.1V203.9c28-9.9 48-36.6 48-67.9 0-39.8-32.2-72-72-72-31.3 0-58 20-67.9 48H203.9C194 84 167.3 64 136 64c-39.8 0-72 32.2-72 72 0 31.3 20 58 48 67.9v616.2C84 830 64 856.7 64 888c0 39.8 32.2 72 72 72 31.3 0 58-20 67.9-48h616.2c9.9 28 36.6 48 67.9 48 39.8 0 72-32.2 72-72 0-31.3-20-58-48-67.9zM888 112c13.3 0 24 10.7 24 24s-10.7 24-24 24-24-10.7-24-24 10.7-24 24-24zM136 912c-13.3 0-24-10.7-24-24s10.7-24 24-24 24 10.7 24 24-10.7 24-24 24z m0-752c-13.3 0-24-10.7-24-24s10.7-24 24-24 24 10.7 24 24-10.7 24-24 24z m704 680H184V184h656v656z m48 72c-13.3 0-24-10.7-24-24s10.7-24 24-24 24 10.7 24 24-10.7 24-24 24z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M288 474h448c8.8 0 16-7.2 16-16V282c0-8.8-7.2-16-16-16H288c-8.8 0-16 7.2-16 16v176c0 8.8 7.2 16 16 16z m56-136h336v64H344v-64zM288 758h448c8.8 0 16-7.2 16-16V566c0-8.8-7.2-16-16-16H288c-8.8 0-16 7.2-16 16v176c0 8.8 7.2 16 16 16z m56-136h336v64H344v-64z"
                }
            }
        ]
    })(props);
}
function AiOutlineHdd(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M832 64H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32zm-600 72h560v208H232V136zm560 480H232V408h560v208zm0 272H232V680h560v208zM496 208H312c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h184c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zM312 544h184c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H312c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8zm328 244a40 40 0 1 0 80 0 40 40 0 1 0-80 0z"
                }
            }
        ]
    })(props);
}
function AiOutlineHeart(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M923 283.6a260.04 260.04 0 0 0-56.9-82.8 264.4 264.4 0 0 0-84-55.5A265.34 265.34 0 0 0 679.7 125c-49.3 0-97.4 13.5-139.2 39-10 6.1-19.5 12.8-28.5 20.1-9-7.3-18.5-14-28.5-20.1-41.8-25.5-89.9-39-139.2-39-35.5 0-69.9 6.8-102.4 20.3-31.4 13-59.7 31.7-84 55.5a258.44 258.44 0 0 0-56.9 82.8c-13.9 32.3-21 66.6-21 101.9 0 33.3 6.8 68 20.3 103.3 11.3 29.5 27.5 60.1 48.2 91 32.8 48.9 77.9 99.9 133.9 151.6 92.8 85.7 184.7 144.9 188.6 147.3l23.7 15.2c10.5 6.7 24 6.7 34.5 0l23.7-15.2c3.9-2.5 95.7-61.6 188.6-147.3 56-51.7 101.1-102.7 133.9-151.6 20.7-30.9 37-61.5 48.2-91 13.5-35.3 20.3-70 20.3-103.3.1-35.3-7-69.6-20.9-101.9zM512 814.8S156 586.7 156 385.5C156 283.6 240.3 201 344.3 201c73.1 0 136.5 40.8 167.7 100.4C543.2 241.8 606.6 201 679.7 201c104 0 188.3 82.6 188.3 184.5 0 201.2-356 429.3-356 429.3z"
                }
            }
        ]
    })(props);
}
function AiOutlineHeatMap(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M955.7 856l-416-720c-6.2-10.7-16.9-16-27.7-16s-21.6 5.3-27.7 16l-416 720C56 877.4 71.4 904 96 904h832c24.6 0 40-26.6 27.7-48zm-790.4-23.9L512 231.9 858.7 832H165.3zm319-474.1l-228 394c-12.3 21.3 3.1 48 27.7 48h455.8c24.7 0 40.1-26.7 27.7-48L539.7 358c-6.2-10.7-17-16-27.7-16-10.8 0-21.6 5.3-27.7 16zm214 386H325.7L512 422l186.3 322zm-214-194.1l-57 98.4C415 669.5 430.4 696 455 696h114c24.6 0 39.9-26.5 27.7-47.7l-57-98.4c-6.1-10.6-16.9-15.9-27.7-15.9s-21.5 5.3-27.7 15.9zm57.1 98.4h-58.7l29.4-50.7 29.3 50.7z"
                }
            }
        ]
    })(props);
}
function AiOutlineHighlight(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M957.6 507.4L603.2 158.2a7.9 7.9 0 0 0-11.2 0L353.3 393.4a8.03 8.03 0 0 0-.1 11.3l.1.1 40 39.4-117.2 115.3a8.03 8.03 0 0 0-.1 11.3l.1.1 39.5 38.9-189.1 187H72.1c-4.4 0-8.1 3.6-8.1 8V860c0 4.4 3.6 8 8 8h344.9c2.1 0 4.1-.8 5.6-2.3l76.1-75.6 40.4 39.8a7.9 7.9 0 0 0 11.2 0l117.1-115.6 40.1 39.5a7.9 7.9 0 0 0 11.2 0l238.7-235.2c3.4-3 3.4-8 .3-11.2zM389.8 796.2H229.6l134.4-133 80.1 78.9-54.3 54.1zm154.8-62.1L373.2 565.2l68.6-67.6 171.4 168.9-68.6 67.6zM713.1 658L450.3 399.1 597.6 254l262.8 259-147.3 145z"
                }
            }
        ]
    })(props);
}
function AiOutlineHistory(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M536.1 273H488c-4.4 0-8 3.6-8 8v275.3c0 2.6 1.2 5 3.3 6.5l165.3 120.7c3.6 2.6 8.6 1.9 11.2-1.7l28.6-39c2.7-3.7 1.9-8.7-1.7-11.2L544.1 528.5V281c0-4.4-3.6-8-8-8zm219.8 75.2l156.8 38.3c5 1.2 9.9-2.6 9.9-7.7l.8-161.5c0-6.7-7.7-10.5-12.9-6.3L752.9 334.1a8 8 0 0 0 3 14.1zm167.7 301.1l-56.7-19.5a8 8 0 0 0-10.1 4.8c-1.9 5.1-3.9 10.1-6 15.1-17.8 42.1-43.3 80-75.9 112.5a353 353 0 0 1-112.5 75.9 352.18 352.18 0 0 1-137.7 27.8c-47.8 0-94.1-9.3-137.7-27.8a353 353 0 0 1-112.5-75.9c-32.5-32.5-58-70.4-75.9-112.5A353.44 353.44 0 0 1 171 512c0-47.8 9.3-94.2 27.8-137.8 17.8-42.1 43.3-80 75.9-112.5a353 353 0 0 1 112.5-75.9C430.6 167.3 477 158 524.8 158s94.1 9.3 137.7 27.8A353 353 0 0 1 775 261.7c10.2 10.3 19.8 21 28.6 32.3l59.8-46.8C784.7 146.6 662.2 81.9 524.6 82 285 82.1 92.6 276.7 95 516.4 97.4 751.9 288.9 942 524.8 942c185.5 0 343.5-117.6 403.7-282.3 1.5-4.2-.7-8.9-4.9-10.4z"
                }
            }
        ]
    })(props);
}
function AiOutlineHolder(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024",
            "version": "1.1"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M300,276.497424 C317.32646,286.500861 338.67354,286.500861 356,276.497424 C373.326461,266.493987 384,248.006874 384,228 C384,207.993128 373.326461,189.506014 356,179.502578 C338.67354,169.499141 317.32646,169.499141 300,179.502578 C282.673539,189.506014 272,207.993128 272,228 C272,248.006874 282.673539,266.493987 300,276.497424 Z M300,560.497426 C317.32646,570.500863 338.67354,570.500863 356,560.497426 C373.326461,550.493989 384,532.006876 384,512.000002 C384,491.993129 373.326461,473.506016 356,463.502579 C338.67354,453.499142 317.32646,453.499142 300,463.502579 C282.673539,473.506016 272,491.993129 272,512.000002 C272,532.006876 282.673539,550.493989 300,560.497426 Z M640,228 C640,248.006874 650.673539,266.493987 668,276.497424 C685.32646,286.500861 706.67354,286.500861 724,276.497424 C741.326461,266.493987 752,248.006874 752,228 C752,207.993128 741.326461,189.506014 724,179.502578 C706.67354,169.499141 685.32646,169.499141 668,179.502578 C650.673539,189.506014 640,207.993128 640,228 L640,228 Z M640,512.000002 C640,532.006876 650.673539,550.493989 668,560.497426 C685.32646,570.500863 706.67354,570.500863 724,560.497426 C741.326461,550.493989 752,532.006876 752,512.000002 C752,491.993129 741.326461,473.506016 724,463.502579 C706.67354,453.499142 685.32646,453.499142 668,463.502579 C650.673539,473.506016 640,491.993129 640,512.000002 L640,512.000002 Z M300,844.497427 C317.32646,854.500864 338.67354,854.500864 356,844.497427 C373.326461,834.493991 384,816.006877 384,796.000003 C384,775.993131 373.326461,757.506018 356,747.502581 C338.67354,737.499144 317.32646,737.499144 300,747.502581 C282.673539,757.506018 272,775.993131 272,796.000003 C272,816.006877 282.673539,834.493991 300,844.497427 Z M640,796.000003 C640,816.006877 650.673539,834.493991 668,844.497427 C685.32646,854.500864 706.67354,854.500864 724,844.497427 C741.326461,834.493991 752,816.006877 752,796.000003 C752,775.993131 741.326461,757.506018 724,747.502581 C706.67354,737.499144 685.32646,737.499144 668,747.502581 C650.673539,757.506018 640,775.993131 640,796.000003 L640,796.000003 Z"
                }
            }
        ]
    })(props);
}
function AiOutlineHome(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M946.5 505L560.1 118.8l-25.9-25.9a31.5 31.5 0 0 0-44.4 0L77.5 505a63.9 63.9 0 0 0-18.8 46c.4 35.2 29.7 63.3 64.9 63.3h42.5V940h691.8V614.3h43.4c17.1 0 33.2-6.7 45.3-18.8a63.6 63.6 0 0 0 18.7-45.3c0-17-6.7-33.1-18.8-45.2zM568 868H456V664h112v204zm217.9-325.7V868H632V640c0-22.1-17.9-40-40-40H432c-22.1 0-40 17.9-40 40v228H238.1V542.3h-96l370-369.7 23.1 23.1L882 542.3h-96.1z"
                }
            }
        ]
    })(props);
}
function AiOutlineHourglass(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M742 318V184h86c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H196c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h86v134c0 81.5 42.4 153.2 106.4 194-64 40.8-106.4 112.5-106.4 194v134h-86c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h632c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-86V706c0-81.5-42.4-153.2-106.4-194 64-40.8 106.4-112.5 106.4-194zm-72 388v134H354V706c0-42.2 16.4-81.9 46.3-111.7C430.1 564.4 469.8 548 512 548s81.9 16.4 111.7 46.3C653.6 624.1 670 663.8 670 706zm0-388c0 42.2-16.4 81.9-46.3 111.7C593.9 459.6 554.2 476 512 476s-81.9-16.4-111.7-46.3A156.63 156.63 0 0 1 354 318V184h316v134z"
                }
            }
        ]
    })(props);
}
function AiOutlineHtml5(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M145 96l66 746.6L511.8 928l299.6-85.4L878.7 96H145zm610.9 700.6l-244.1 69.6-245.2-69.6-56.7-641.2h603.8l-57.8 641.2zM281 249l1.7 24.3 22.7 253.5h206.5v-.1h112.9l-11.4 118.5L511 672.9v.2h-.8l-102.4-27.7-6.5-73.2h-91l11.3 144.7 188.6 52h1.7v-.4l187.7-51.7 1.7-16.3 21.2-242.2 3.2-24.3H511v.2H389.9l-8.2-94.2h352.1l1.7-19.5 4.8-47.2L742 249H511z"
                }
            }
        ]
    })(props);
}
function AiOutlineIdcard(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M928 160H96c-17.7 0-32 14.3-32 32v640c0 17.7 14.3 32 32 32h832c17.7 0 32-14.3 32-32V192c0-17.7-14.3-32-32-32zm-40 632H136V232h752v560zM610.3 476h123.4c1.3 0 2.3-3.6 2.3-8v-48c0-4.4-1-8-2.3-8H610.3c-1.3 0-2.3 3.6-2.3 8v48c0 4.4 1 8 2.3 8zm4.8 144h185.7c3.9 0 7.1-3.6 7.1-8v-48c0-4.4-3.2-8-7.1-8H615.1c-3.9 0-7.1 3.6-7.1 8v48c0 4.4 3.2 8 7.1 8zM224 673h43.9c4.2 0 7.6-3.3 7.9-7.5 3.8-50.5 46-90.5 97.2-90.5s93.4 40 97.2 90.5c.3 4.2 3.7 7.5 7.9 7.5H522a8 8 0 0 0 8-8.4c-2.8-53.3-32-99.7-74.6-126.1a111.8 111.8 0 0 0 29.1-75.5c0-61.9-49.9-112-111.4-112s-111.4 50.1-111.4 112c0 29.1 11 55.5 29.1 75.5a158.09 158.09 0 0 0-74.6 126.1c-.4 4.6 3.2 8.4 7.8 8.4zm149-262c28.5 0 51.7 23.3 51.7 52s-23.2 52-51.7 52-51.7-23.3-51.7-52 23.2-52 51.7-52z"
                }
            }
        ]
    })(props);
}
function AiOutlineIe(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M852.6 367.6c16.3-36.9 32.1-90.7 32.1-131.8 0-109.1-119.5-147.6-314.5-57.9-161.4-10.8-316.8 110.5-355.6 279.7 46.3-52.3 117.4-123.4 183-151.7C316.1 378.3 246.7 470 194 565.6c-31.1 56.9-66 148.8-66 217.5 0 147.9 139.3 129.8 270.4 63 47.1 23.1 99.8 23.4 152.5 23.4 145.7 0 276.4-81.4 325.2-219H694.9c-78.8 132.9-295.2 79.5-295.2-71.2h493.2c9.6-65.4-2.5-143.6-40.3-211.7zM224.8 648.3c26.6 76.7 80.6 143.8 150.4 185-133.1 73.4-259.9 43.6-150.4-185zm174-163.3c3-82.7 75.4-142.3 156-142.3 80.1 0 153 59.6 156 142.3h-312zm276.8-281.4c32.1-15.4 72.8-33 108.8-33 47.1 0 81.4 32.6 81.4 80.6 0 30-11.1 73.5-21.9 101.8-39.3-63.5-98.9-122.4-168.3-149.4z"
                }
            }
        ]
    })(props);
}
function AiOutlineImport(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024",
            "fill": "currentColor",
            "fillRule": "evenodd"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h360c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H184V184h656v320c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V144c0-17.7-14.3-32-32-32ZM653.3 599.4l52.2-52.2c4.7-4.7 1.9-12.8-4.7-13.6l-179.4-21c-5.1-.6-9.5 3.7-8.9 8.9l21 179.4c.8 6.6 8.9 9.4 13.6 4.7l52.4-52.4 256.2 256.2c3.1 3.1 8.2 3.1 11.3 0l42.4-42.4c3.1-3.1 3.1-8.2 0-11.3L653.3 599.4Z",
                    "transform": "matrix(1 0 0 -1 0 1024)"
                }
            }
        ]
    })(props);
}
function AiOutlineInbox(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M885.2 446.3l-.2-.8-112.2-285.1c-5-16.1-19.9-27.2-36.8-27.2H281.2c-17 0-32.1 11.3-36.9 27.6L139.4 443l-.3.7-.2.8c-1.3 4.9-1.7 9.9-1 14.8-.1 1.6-.2 3.2-.2 4.8V830a60.9 60.9 0 0 0 60.8 60.8h627.2c33.5 0 60.8-27.3 60.9-60.8V464.1c0-1.3 0-2.6-.1-3.7.4-4.9 0-9.6-1.3-14.1zm-295.8-43l-.3 15.7c-.8 44.9-31.8 75.1-77.1 75.1-22.1 0-41.1-7.1-54.8-20.6S436 441.2 435.6 419l-.3-15.7H229.5L309 210h399.2l81.7 193.3H589.4zm-375 76.8h157.3c24.3 57.1 76 90.8 140.4 90.8 33.7 0 65-9.4 90.3-27.2 22.2-15.6 39.5-37.4 50.7-63.6h156.5V814H214.4V480.1z"
                }
            }
        ]
    })(props);
}
function AiOutlineInfoCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M464 336a48 48 0 1 0 96 0 48 48 0 1 0-96 0zm72 112h-48c-4.4 0-8 3.6-8 8v272c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V456c0-4.4-3.6-8-8-8z"
                }
            }
        ]
    })(props);
}
function AiOutlineInfo(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M448 224a64 64 0 1 0 128 0 64 64 0 1 0-128 0zm96 168h-64c-4.4 0-8 3.6-8 8v464c0 4.4 3.6 8 8 8h64c4.4 0 8-3.6 8-8V400c0-4.4-3.6-8-8-8z"
                }
            }
        ]
    })(props);
}
function AiOutlineInsertRowAbove(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "t": "1569683507961",
            "viewBox": "0 0 1024 1024",
            "version": "1.1"
        },
        "child": [
            {
                "tag": "defs",
                "attr": {},
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M878.7 336H145.3c-18.4 0-33.3 14.3-33.3 32v464c0 17.7 14.9 32 33.3 32h733.3c18.4 0 33.3-14.3 33.3-32V368c0.1-17.7-14.8-32-33.2-32zM360 792H184V632h176v160z m0-224H184V408h176v160z m240 224H424V632h176v160z m0-224H424V408h176v160z m240 224H664V632h176v160z m0-224H664V408h176v160zM904 160H120c-4.4 0-8 3.6-8 8v80c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-80c0-4.4-3.6-8-8-8z"
                }
            }
        ]
    })(props);
}
function AiOutlineInsertRowBelow(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "t": "1569683503597",
            "viewBox": "0 0 1024 1024",
            "version": "1.1"
        },
        "child": [
            {
                "tag": "defs",
                "attr": {},
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M904 768H120c-4.4 0-8 3.6-8 8v80c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-80c0-4.4-3.6-8-8-8zM878.7 160H145.3c-18.4 0-33.3 14.3-33.3 32v464c0 17.7 14.9 32 33.3 32h733.3c18.4 0 33.3-14.3 33.3-32V192c0.1-17.7-14.8-32-33.2-32zM360 616H184V456h176v160z m0-224H184V232h176v160z m240 224H424V456h176v160z m0-224H424V232h176v160z m240 224H664V456h176v160z m0-224H664V232h176v160z"
                }
            }
        ]
    })(props);
}
function AiOutlineInsertRowLeft(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "t": "1569683561749",
            "viewBox": "0 0 1024 1024",
            "version": "1.1"
        },
        "child": [
            {
                "tag": "defs",
                "attr": {},
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M248 112h-80c-4.4 0-8 3.6-8 8v784c0 4.4 3.6 8 8 8h80c4.4 0 8-3.6 8-8V120c0-4.4-3.6-8-8-8zM832 112H368c-17.7 0-32 14.9-32 33.3v733.3c0 18.4 14.3 33.3 32 33.3h464c17.7 0 32-14.9 32-33.3V145.3c0-18.4-14.3-33.3-32-33.3zM568 840H408V664h160v176z m0-240H408V424h160v176z m0-240H408V184h160v176z m224 480H632V664h160v176z m0-240H632V424h160v176z m0-240H632V184h160v176z"
                }
            }
        ]
    })(props);
}
function AiOutlineInsertRowRight(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "t": "1569683555439",
            "viewBox": "0 0 1024 1024",
            "version": "1.1"
        },
        "child": [
            {
                "tag": "defs",
                "attr": {},
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M856 112h-80c-4.4 0-8 3.6-8 8v784c0 4.4 3.6 8 8 8h80c4.4 0 8-3.6 8-8V120c0-4.4-3.6-8-8-8zM656 112H192c-17.7 0-32 14.9-32 33.3v733.3c0 18.4 14.3 33.3 32 33.3h464c17.7 0 32-14.9 32-33.3V145.3c0-18.4-14.3-33.3-32-33.3zM392 840H232V664h160v176z m0-240H232V424h160v176z m0-240H232V184h160v176z m224 480H456V664h160v176z m0-240H456V424h160v176z m0-240H456V184h160v176z"
                }
            }
        ]
    })(props);
}
function AiOutlineInstagram(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M512 306.9c-113.5 0-205.1 91.6-205.1 205.1S398.5 717.1 512 717.1 717.1 625.5 717.1 512 625.5 306.9 512 306.9zm0 338.4c-73.4 0-133.3-59.9-133.3-133.3S438.6 378.7 512 378.7 645.3 438.6 645.3 512 585.4 645.3 512 645.3zm213.5-394.6c-26.5 0-47.9 21.4-47.9 47.9s21.4 47.9 47.9 47.9 47.9-21.3 47.9-47.9a47.84 47.84 0 0 0-47.9-47.9zM911.8 512c0-55.2.5-109.9-2.6-165-3.1-64-17.7-120.8-64.5-167.6-46.9-46.9-103.6-61.4-167.6-64.5-55.2-3.1-109.9-2.6-165-2.6-55.2 0-109.9-.5-165 2.6-64 3.1-120.8 17.7-167.6 64.5C132.6 226.3 118.1 283 115 347c-3.1 55.2-2.6 109.9-2.6 165s-.5 109.9 2.6 165c3.1 64 17.7 120.8 64.5 167.6 46.9 46.9 103.6 61.4 167.6 64.5 55.2 3.1 109.9 2.6 165 2.6 55.2 0 109.9.5 165-2.6 64-3.1 120.8-17.7 167.6-64.5 46.9-46.9 61.4-103.6 64.5-167.6 3.2-55.1 2.6-109.8 2.6-165zm-88 235.8c-7.3 18.2-16.1 31.8-30.2 45.8-14.1 14.1-27.6 22.9-45.8 30.2C695.2 844.7 570.3 840 512 840c-58.3 0-183.3 4.7-235.9-16.1-18.2-7.3-31.8-16.1-45.8-30.2-14.1-14.1-22.9-27.6-30.2-45.8C179.3 695.2 184 570.3 184 512c0-58.3-4.7-183.3 16.1-235.9 7.3-18.2 16.1-31.8 30.2-45.8s27.6-22.9 45.8-30.2C328.7 179.3 453.7 184 512 184s183.3-4.7 235.9 16.1c18.2 7.3 31.8 16.1 45.8 30.2 14.1 14.1 22.9 27.6 30.2 45.8C844.7 328.7 840 453.7 840 512c0 58.3 4.7 183.2-16.2 235.8z"
                }
            }
        ]
    })(props);
}
function AiOutlineInsurance(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M441.6 306.8L403 288.6a6.1 6.1 0 0 0-8.4 3.7c-17.5 58.5-45.2 110.1-82.2 153.6a6.05 6.05 0 0 0-1.2 5.6l13.2 43.5c1.3 4.4 7 5.7 10.2 2.4 7.7-8.1 15.4-16.9 23.1-26V656c0 4.4 3.6 8 8 8H403c4.4 0 8-3.6 8-8V393.1a429.2 429.2 0 0 0 33.6-79c1-2.9-.3-6-3-7.3zm26.8 9.2v127.2c0 4.4 3.6 8 8 8h65.9v18.6h-94.9c-4.4 0-8 3.6-8 8v35.6c0 4.4 3.6 8 8 8h55.1c-19.1 30.8-42.4 55.7-71 76a6 6 0 0 0-1.6 8.1l22.8 36.5c1.9 3.1 6.2 3.8 8.9 1.4 31.6-26.8 58.7-62.9 80.6-107.6v120c0 4.4 3.6 8 8 8h36.2c4.4 0 8-3.6 8-8V536c21.3 41.7 47.5 77.5 78.1 106.9 2.6 2.5 6.8 2.1 8.9-.7l26.3-35.3c2-2.7 1.4-6.5-1.2-8.4-30.5-22.6-54.2-47.8-72.3-76.9h59c4.4 0 8-3.6 8-8V478c0-4.4-3.6-8-8-8h-98.8v-18.6h66.7c4.4 0 8-3.6 8-8V316c0-4.4-3.6-8-8-8H476.4c-4.4 0-8 3.6-8 8zm51.5 42.8h97.9v41.6h-97.9v-41.6zm347-188.9L527.1 54.1C523 52.7 517.5 52 512 52s-11 .7-15.1 2.1L157.1 169.9c-8.3 2.8-15.1 12.4-15.1 21.2v482.4c0 8.8 5.7 20.4 12.6 25.9L499.3 968c3.5 2.7 8 4.1 12.6 4.1s9.2-1.4 12.6-4.1l344.7-268.6c6.9-5.4 12.6-17 12.6-25.9V191.1c.2-8.8-6.6-18.3-14.9-21.2zM810 654.3L512 886.5 214 654.3V226.7l298-101.6 298 101.6v427.6z"
                }
            }
        ]
    })(props);
}
function AiOutlineInteraction(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656zM304.8 524h50.7c3.7 0 6.8-3 6.8-6.8v-78.9c0-19.7 15.9-35.6 35.5-35.6h205.7v53.4c0 5.7 6.5 8.8 10.9 5.3l109.1-85.7c3.5-2.7 3.5-8 0-10.7l-109.1-85.7c-4.4-3.5-10.9-.3-10.9 5.3V338H397.7c-55.1 0-99.7 44.8-99.7 100.1V517c0 4 3 7 6.8 7zm-4.2 134.9l109.1 85.7c4.4 3.5 10.9.3 10.9-5.3v-53.4h205.7c55.1 0 99.7-44.8 99.7-100.1v-78.9c0-3.7-3-6.8-6.8-6.8h-50.7c-3.7 0-6.8 3-6.8 6.8v78.9c0 19.7-15.9 35.6-35.5 35.6H420.6V568c0-5.7-6.5-8.8-10.9-5.3l-109.1 85.7c-3.5 2.5-3.5 7.8 0 10.5z"
                }
            }
        ]
    })(props);
}
function AiOutlineIssuesClose(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M464 688a48 48 0 1 0 96 0 48 48 0 1 0-96 0zm72-112c4.4 0 8-3.6 8-8V296c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v272c0 4.4 3.6 8 8 8h48zm400-188h-59.3c-2.6 0-5 1.2-6.5 3.3L763.7 538.1l-49.9-68.8a7.92 7.92 0 0 0-6.5-3.3H648c-6.5 0-10.3 7.4-6.5 12.7l109.2 150.7a16.1 16.1 0 0 0 26 0l165.8-228.7c3.8-5.3 0-12.7-6.5-12.7zm-44 306h-64.2c-5.5 0-10.6 2.9-13.6 7.5a352.2 352.2 0 0 1-49.8 62.2A355.92 355.92 0 0 1 651.1 840a355 355 0 0 1-138.7 27.9c-48.1 0-94.8-9.4-138.7-27.9a355.92 355.92 0 0 1-113.3-76.3A353.06 353.06 0 0 1 184 650.5c-18.6-43.8-28-90.5-28-138.5s9.4-94.7 28-138.5c17.9-42.4 43.6-80.5 76.4-113.2 32.8-32.7 70.9-58.4 113.3-76.3a355 355 0 0 1 138.7-27.9c48.1 0 94.8 9.4 138.7 27.9 42.4 17.9 80.5 43.6 113.3 76.3 19 19 35.6 39.8 49.8 62.2 2.9 4.7 8.1 7.5 13.6 7.5H892c6 0 9.8-6.3 7.2-11.6C828.8 178.5 684.7 82 517.7 80 278.9 77.2 80.5 272.5 80 511.2 79.5 750.1 273.3 944 512.4 944c169.2 0 315.6-97 386.7-238.4A8 8 0 0 0 892 694z"
                }
            }
        ]
    })(props);
}
function AiOutlineItalic(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M798 160H366c-4.4 0-8 3.6-8 8v64c0 4.4 3.6 8 8 8h181.2l-156 544H229c-4.4 0-8 3.6-8 8v64c0 4.4 3.6 8 8 8h432c4.4 0 8-3.6 8-8v-64c0-4.4-3.6-8-8-8H474.4l156-544H798c4.4 0 8-3.6 8-8v-64c0-4.4-3.6-8-8-8z"
                }
            }
        ]
    })(props);
}
function AiOutlineKey(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M608 112c-167.9 0-304 136.1-304 304 0 70.3 23.9 135 63.9 186.5l-41.1 41.1-62.3-62.3a8.15 8.15 0 0 0-11.4 0l-39.8 39.8a8.15 8.15 0 0 0 0 11.4l62.3 62.3-44.9 44.9-62.3-62.3a8.15 8.15 0 0 0-11.4 0l-39.8 39.8a8.15 8.15 0 0 0 0 11.4l62.3 62.3-65.3 65.3a8.03 8.03 0 0 0 0 11.3l42.3 42.3c3.1 3.1 8.2 3.1 11.3 0l253.6-253.6A304.06 304.06 0 0 0 608 720c167.9 0 304-136.1 304-304S775.9 112 608 112zm161.2 465.2C726.2 620.3 668.9 644 608 644c-60.9 0-118.2-23.7-161.2-66.8-43.1-43-66.8-100.3-66.8-161.2 0-60.9 23.7-118.2 66.8-161.2 43-43.1 100.3-66.8 161.2-66.8 60.9 0 118.2 23.7 161.2 66.8 43.1 43 66.8 100.3 66.8 161.2 0 60.9-23.7 118.2-66.8 161.2z"
                }
            }
        ]
    })(props);
}
function AiOutlineLaptop(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M956.9 845.1L896.4 632V168c0-17.7-14.3-32-32-32h-704c-17.7 0-32 14.3-32 32v464L67.9 845.1C60.4 866 75.8 888 98 888h828.8c22.2 0 37.6-22 30.1-42.9zM200.4 208h624v395h-624V208zm228.3 608l8.1-37h150.3l8.1 37H428.7zm224 0l-19.1-86.7c-.8-3.7-4.1-6.3-7.8-6.3H398.2c-3.8 0-7 2.6-7.8 6.3L371.3 816H151l42.3-149h638.2l42.3 149H652.7z"
                }
            }
        ]
    })(props);
}
function AiOutlineLayout(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-696 72h136v656H184V184zm656 656H384V384h456v456zM384 320V184h456v136H384z"
                }
            }
        ]
    })(props);
}
function AiOutlineLeftCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M603.3 327.5l-246 178a7.95 7.95 0 0 0 0 12.9l246 178c5.3 3.8 12.7 0 12.7-6.5V643c0-10.2-4.9-19.9-13.2-25.9L457.4 512l145.4-105.2c8.3-6 13.2-15.6 13.2-25.9V334c0-6.5-7.4-10.3-12.7-6.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z"
                }
            }
        ]
    })(props);
}
function AiOutlineLeftSquare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M365.3 518.5l246 178c5.3 3.8 12.7 0 12.7-6.5v-46.9c0-10.2-4.9-19.9-13.2-25.9L465.4 512l145.4-105.2c8.3-6 13.2-15.6 13.2-25.9V334c0-6.5-7.4-10.3-12.7-6.5l-246 178a8.05 8.05 0 0 0 0 13z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z"
                }
            }
        ]
    })(props);
}
function AiOutlineLeft(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M724 218.3V141c0-6.7-7.7-10.4-12.9-6.3L260.3 486.8a31.86 31.86 0 0 0 0 50.3l450.8 352.1c5.3 4.1 12.9.4 12.9-6.3v-77.3c0-4.9-2.3-9.6-6.1-12.6l-360-281 360-281.1c3.8-3 6.1-7.7 6.1-12.6z"
                }
            }
        ]
    })(props);
}
function AiOutlineLike(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M885.9 533.7c16.8-22.2 26.1-49.4 26.1-77.7 0-44.9-25.1-87.4-65.5-111.1a67.67 67.67 0 0 0-34.3-9.3H572.4l6-122.9c1.4-29.7-9.1-57.9-29.5-79.4A106.62 106.62 0 0 0 471 99.9c-52 0-98 35-111.8 85.1l-85.9 311H144c-17.7 0-32 14.3-32 32v364c0 17.7 14.3 32 32 32h601.3c9.2 0 18.2-1.8 26.5-5.4 47.6-20.3 78.3-66.8 78.3-118.4 0-12.6-1.8-25-5.4-37 16.8-22.2 26.1-49.4 26.1-77.7 0-12.6-1.8-25-5.4-37 16.8-22.2 26.1-49.4 26.1-77.7-.2-12.6-2-25.1-5.6-37.1zM184 852V568h81v284h-81zm636.4-353l-21.9 19 13.9 25.4a56.2 56.2 0 0 1 6.9 27.3c0 16.5-7.2 32.2-19.6 43l-21.9 19 13.9 25.4a56.2 56.2 0 0 1 6.9 27.3c0 16.5-7.2 32.2-19.6 43l-21.9 19 13.9 25.4a56.2 56.2 0 0 1 6.9 27.3c0 22.4-13.2 42.6-33.6 51.8H329V564.8l99.5-360.5a44.1 44.1 0 0 1 42.2-32.3c7.6 0 15.1 2.2 21.1 6.7 9.9 7.4 15.2 18.6 14.6 30.5l-9.6 198.4h314.4C829 418.5 840 436.9 840 456c0 16.5-7.2 32.1-19.6 43z"
                }
            }
        ]
    })(props);
}
function AiOutlineLineChart(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M888 792H200V168c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v688c0 4.4 3.6 8 8 8h752c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM305.8 637.7c3.1 3.1 8.1 3.1 11.3 0l138.3-137.6L583 628.5c3.1 3.1 8.2 3.1 11.3 0l275.4-275.3c3.1-3.1 3.1-8.2 0-11.3l-39.6-39.6a8.03 8.03 0 0 0-11.3 0l-230 229.9L461.4 404a8.03 8.03 0 0 0-11.3 0L266.3 586.7a8.03 8.03 0 0 0 0 11.3l39.5 39.7z"
                }
            }
        ]
    })(props);
}
function AiOutlineLineHeight(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M648 160H104c-4.4 0-8 3.6-8 8v128c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-64h168v560h-92c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h264c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-92V232h168v64c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V168c0-4.4-3.6-8-8-8zm272.8 546H856V318h64.8c6 0 9.4-7 5.7-11.7L825.7 178.7a7.14 7.14 0 0 0-11.3 0L713.6 306.3a7.23 7.23 0 0 0 5.7 11.7H784v388h-64.8c-6 0-9.4 7-5.7 11.7l100.8 127.5c2.9 3.7 8.5 3.7 11.3 0l100.8-127.5a7.2 7.2 0 0 0-5.6-11.7z"
                }
            }
        ]
    })(props);
}
function AiOutlineLine(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M904 476H120c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8z"
                }
            }
        ]
    })(props);
}
function AiOutlineLink(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M574 665.4a8.03 8.03 0 0 0-11.3 0L446.5 781.6c-53.8 53.8-144.6 59.5-204 0-59.5-59.5-53.8-150.2 0-204l116.2-116.2c3.1-3.1 3.1-8.2 0-11.3l-39.8-39.8a8.03 8.03 0 0 0-11.3 0L191.4 526.5c-84.6 84.6-84.6 221.5 0 306s221.5 84.6 306 0l116.2-116.2c3.1-3.1 3.1-8.2 0-11.3L574 665.4zm258.6-474c-84.6-84.6-221.5-84.6-306 0L410.3 307.6a8.03 8.03 0 0 0 0 11.3l39.7 39.7c3.1 3.1 8.2 3.1 11.3 0l116.2-116.2c53.8-53.8 144.6-59.5 204 0 59.5 59.5 53.8 150.2 0 204L665.3 562.6a8.03 8.03 0 0 0 0 11.3l39.8 39.8c3.1 3.1 8.2 3.1 11.3 0l116.2-116.2c84.5-84.6 84.5-221.5 0-306.1zM610.1 372.3a8.03 8.03 0 0 0-11.3 0L372.3 598.7a8.03 8.03 0 0 0 0 11.3l39.6 39.6c3.1 3.1 8.2 3.1 11.3 0l226.4-226.4c3.1-3.1 3.1-8.2 0-11.3l-39.5-39.6z"
                }
            }
        ]
    })(props);
}
function AiOutlineLinkedin(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M847.7 112H176.3c-35.5 0-64.3 28.8-64.3 64.3v671.4c0 35.5 28.8 64.3 64.3 64.3h671.4c35.5 0 64.3-28.8 64.3-64.3V176.3c0-35.5-28.8-64.3-64.3-64.3zm0 736c-447.8-.1-671.7-.2-671.7-.3.1-447.8.2-671.7.3-671.7 447.8.1 671.7.2 671.7.3-.1 447.8-.2 671.7-.3 671.7zM230.6 411.9h118.7v381.8H230.6zm59.4-52.2c37.9 0 68.8-30.8 68.8-68.8a68.8 68.8 0 1 0-137.6 0c-.1 38 30.7 68.8 68.8 68.8zm252.3 245.1c0-49.8 9.5-98 71.2-98 60.8 0 61.7 56.9 61.7 101.2v185.7h118.6V584.3c0-102.8-22.2-181.9-142.3-181.9-57.7 0-96.4 31.7-112.3 61.7h-1.6v-52.2H423.7v381.8h118.6V604.8z"
                }
            }
        ]
    })(props);
}
function AiOutlineLoading3Quarters(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M512 1024c-69.1 0-136.2-13.5-199.3-40.2C251.7 958 197 921 150 874c-47-47-84-101.7-109.8-162.7C13.5 648.2 0 581.1 0 512c0-19.9 16.1-36 36-36s36 16.1 36 36c0 59.4 11.6 117 34.6 171.3 22.2 52.4 53.9 99.5 94.3 139.9 40.4 40.4 87.5 72.2 139.9 94.3C395 940.4 452.6 952 512 952c59.4 0 117-11.6 171.3-34.6 52.4-22.2 99.5-53.9 139.9-94.3 40.4-40.4 72.2-87.5 94.3-139.9C940.4 629 952 571.4 952 512c0-59.4-11.6-117-34.6-171.3a440.45 440.45 0 0 0-94.3-139.9 437.71 437.71 0 0 0-139.9-94.3C629 83.6 571.4 72 512 72c-19.9 0-36-16.1-36-36s16.1-36 36-36c69.1 0 136.2 13.5 199.3 40.2C772.3 66 827 103 874 150c47 47 83.9 101.8 109.7 162.7 26.7 63.1 40.2 130.2 40.2 199.3s-13.5 136.2-40.2 199.3C958 772.3 921 827 874 874c-47 47-101.8 83.9-162.7 109.7-63.1 26.8-130.2 40.3-199.3 40.3z"
                }
            }
        ]
    })(props);
}
function AiOutlineLoading(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M988 548c-19.9 0-36-16.1-36-36 0-59.4-11.6-117-34.6-171.3a440.45 440.45 0 0 0-94.3-139.9 437.71 437.71 0 0 0-139.9-94.3C629 83.6 571.4 72 512 72c-19.9 0-36-16.1-36-36s16.1-36 36-36c69.1 0 136.2 13.5 199.3 40.3C772.3 66 827 103 874 150c47 47 83.9 101.8 109.7 162.7 26.7 63.1 40.2 130.2 40.2 199.3.1 19.9-16 36-35.9 36z"
                }
            }
        ]
    })(props);
}
function AiOutlineLock(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M832 464h-68V240c0-70.7-57.3-128-128-128H388c-70.7 0-128 57.3-128 128v224h-68c-17.7 0-32 14.3-32 32v384c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V496c0-17.7-14.3-32-32-32zM332 240c0-30.9 25.1-56 56-56h248c30.9 0 56 25.1 56 56v224H332V240zm460 600H232V536h560v304zM484 701v53c0 4.4 3.6 8 8 8h40c4.4 0 8-3.6 8-8v-53a48.01 48.01 0 1 0-56 0z"
                }
            }
        ]
    })(props);
}
function AiOutlineLogin(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "defs",
                "attr": {},
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M521.7 82c-152.5-.4-286.7 78.5-363.4 197.7-3.4 5.3.4 12.3 6.7 12.3h70.3c4.8 0 9.3-2.1 12.3-5.8 7-8.5 14.5-16.7 22.4-24.5 32.6-32.5 70.5-58.1 112.7-75.9 43.6-18.4 90-27.8 137.9-27.8 47.9 0 94.3 9.3 137.9 27.8 42.2 17.8 80.1 43.4 112.7 75.9 32.6 32.5 58.1 70.4 76 112.5C865.7 417.8 875 464.1 875 512c0 47.9-9.4 94.2-27.8 137.8-17.8 42.1-43.4 80-76 112.5s-70.5 58.1-112.7 75.9A352.8 352.8 0 0 1 520.6 866c-47.9 0-94.3-9.4-137.9-27.8A353.84 353.84 0 0 1 270 762.3c-7.9-7.9-15.3-16.1-22.4-24.5-3-3.7-7.6-5.8-12.3-5.8H165c-6.3 0-10.2 7-6.7 12.3C234.9 863.2 368.5 942 520.6 942c236.2 0 428-190.1 430.4-425.6C953.4 277.1 761.3 82.6 521.7 82zM395.02 624v-76h-314c-4.4 0-8-3.6-8-8v-56c0-4.4 3.6-8 8-8h314v-76c0-6.7 7.8-10.5 13-6.3l141.9 112a8 8 0 0 1 0 12.6l-141.9 112c-5.2 4.1-13 .4-13-6.3z"
                }
            }
        ]
    })(props);
}
function AiOutlineLogout(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M868 732h-70.3c-4.8 0-9.3 2.1-12.3 5.8-7 8.5-14.5 16.7-22.4 24.5a353.84 353.84 0 0 1-112.7 75.9A352.8 352.8 0 0 1 512.4 866c-47.9 0-94.3-9.4-137.9-27.8a353.84 353.84 0 0 1-112.7-75.9 353.28 353.28 0 0 1-76-112.5C167.3 606.2 158 559.9 158 512s9.4-94.2 27.8-137.8c17.8-42.1 43.4-80 76-112.5s70.5-58.1 112.7-75.9c43.6-18.4 90-27.8 137.9-27.8 47.9 0 94.3 9.3 137.9 27.8 42.2 17.8 80.1 43.4 112.7 75.9 7.9 7.9 15.3 16.1 22.4 24.5 3 3.7 7.6 5.8 12.3 5.8H868c6.3 0 10.2-7 6.7-12.3C798 160.5 663.8 81.6 511.3 82 271.7 82.6 79.6 277.1 82 516.4 84.4 751.9 276.2 942 512.4 942c152.1 0 285.7-78.8 362.3-197.7 3.4-5.3-.4-12.3-6.7-12.3zm88.9-226.3L815 393.7c-5.3-4.2-13-.4-13 6.3v76H488c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h314v76c0 6.7 7.8 10.5 13 6.3l141.9-112a8 8 0 0 0 0-12.6z"
                }
            }
        ]
    })(props);
}
function AiOutlineMacCommand(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "t": "1569683819749",
            "viewBox": "0 0 1024 1024",
            "version": "1.1"
        },
        "child": [
            {
                "tag": "defs",
                "attr": {},
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32z m-40 728H184V184h656v656z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M370.8 554.4c-54.6 0-98.8 44.2-98.8 98.8s44.2 98.8 98.8 98.8 98.8-44.2 98.8-98.8v-42.4h84.7v42.4c0 54.6 44.2 98.8 98.8 98.8s98.8-44.2 98.8-98.8-44.2-98.8-98.8-98.8h-42.4v-84.7h42.4c54.6 0 98.8-44.2 98.8-98.8 0-54.6-44.2-98.8-98.8-98.8s-98.8 44.2-98.8 98.8v42.4h-84.7v-42.4c0-54.6-44.2-98.8-98.8-98.8S272 316.2 272 370.8s44.2 98.8 98.8 98.8h42.4v84.7h-42.4z m42.4 98.8c0 23.4-19 42.4-42.4 42.4s-42.4-19-42.4-42.4 19-42.4 42.4-42.4h42.4v42.4z m197.6-282.4c0-23.4 19-42.4 42.4-42.4s42.4 19 42.4 42.4-19 42.4-42.4 42.4h-42.4v-42.4z m0 240h42.4c23.4 0 42.4 19 42.4 42.4s-19 42.4-42.4 42.4-42.4-19-42.4-42.4v-42.4zM469.6 469.6h84.7v84.7h-84.7v-84.7z m-98.8-56.4c-23.4 0-42.4-19-42.4-42.4s19-42.4 42.4-42.4 42.4 19 42.4 42.4v42.4h-42.4z"
                }
            }
        ]
    })(props);
}
function AiOutlineMail(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M928 160H96c-17.7 0-32 14.3-32 32v640c0 17.7 14.3 32 32 32h832c17.7 0 32-14.3 32-32V192c0-17.7-14.3-32-32-32zm-40 110.8V792H136V270.8l-27.6-21.5 39.3-50.5 42.8 33.3h643.1l42.8-33.3 39.3 50.5-27.7 21.5zM833.6 232L512 482 190.4 232l-42.8-33.3-39.3 50.5 27.6 21.5 341.6 265.6a55.99 55.99 0 0 0 68.7 0L888 270.8l27.6-21.5-39.3-50.5-42.7 33.2z"
                }
            }
        ]
    })(props);
}
function AiOutlineMan(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M874 120H622c-3.3 0-6 2.7-6 6v56c0 3.3 2.7 6 6 6h160.4L583.1 387.3c-50-38.5-111-59.3-175.1-59.3-76.9 0-149.3 30-203.6 84.4S120 539.1 120 616s30 149.3 84.4 203.6C258.7 874 331.1 904 408 904s149.3-30 203.6-84.4C666 765.3 696 692.9 696 616c0-64.1-20.8-124.9-59.2-174.9L836 241.9V402c0 3.3 2.7 6 6 6h56c3.3 0 6-2.7 6-6V150c0-16.5-13.5-30-30-30zM408 828c-116.9 0-212-95.1-212-212s95.1-212 212-212 212 95.1 212 212-95.1 212-212 212z"
                }
            }
        ]
    })(props);
}
function AiOutlineMedicineBox(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M839.2 278.1a32 32 0 0 0-30.4-22.1H736V144c0-17.7-14.3-32-32-32H320c-17.7 0-32 14.3-32 32v112h-72.8a31.9 31.9 0 0 0-30.4 22.1L112 502v378c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V502l-72.8-223.9zM360 184h304v72H360v-72zm480 656H184V513.4L244.3 328h535.4L840 513.4V840zM652 572H544V464c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v108H372c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h108v108c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V636h108c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8z"
                }
            }
        ]
    })(props);
}
function AiOutlineMediumWorkmark(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M517.2 590.55c0 3.55 0 4.36 2.4 6.55l13.43 13.25v.57h-59.57v-25.47a41.44 41.44 0 0 1-39.5 27.65c-30.61 0-52.84-24.25-52.84-68.87 0-41.8 23.99-69.69 57.65-69.69a35.15 35.15 0 0 1 34.61 21.67v-56.19a6.99 6.99 0 0 0-2.71-6.79l-12.8-12.45v-.56l59.33-7.04v177.37zm-43.74-8.09v-83.83a22.2 22.2 0 0 0-17.74-8.4c-14.48 0-28.47 13.25-28.47 52.62 0 36.86 12.07 49.88 27.1 49.88a23.91 23.91 0 0 0 19.11-10.27zm83.23 28.46V497.74a7.65 7.65 0 0 0-2.4-6.79l-13.19-13.74v-.57h59.56v114.8c0 3.55 0 4.36 2.4 6.54l13.12 12.45v.57l-59.49-.08zm-2.16-175.67c0-13.4 10.74-24.25 23.99-24.25 13.25 0 23.98 10.86 23.98 24.25 0 13.4-10.73 24.25-23.98 24.25s-23.99-10.85-23.99-24.25zm206.83 155.06c0 3.55 0 4.6 2.4 6.79l13.43 13.25v.57h-59.88V581.9a43.4 43.4 0 0 1-41.01 31.2c-26.55 0-40.78-19.56-40.78-56.59 0-17.86 0-37.43.56-59.41a6.91 6.91 0 0 0-2.4-6.55L620.5 477.2v-.57h59.09v73.81c0 24.25 3.51 40.42 18.54 40.42a23.96 23.96 0 0 0 19.35-12.2v-80.85a7.65 7.65 0 0 0-2.4-6.79l-13.27-13.82v-.57h59.56V590.3zm202.76 20.6c0-4.36.8-59.97.8-72.75 0-24.25-3.76-40.98-20.63-40.98a26.7 26.7 0 0 0-21.19 11.64 99.68 99.68 0 0 1 2.4 23.04c0 16.81-.56 38.23-.8 59.66a6.91 6.91 0 0 0 2.4 6.55l13.43 12.45v.56h-60.12c0-4.04.8-59.98.8-72.76 0-24.65-3.76-40.98-20.39-40.98-8.2.3-15.68 4.8-19.83 11.96v82.46c0 3.56 0 4.37 2.4 6.55l13.11 12.45v.56h-59.48V498.15a7.65 7.65 0 0 0-2.4-6.8l-13.19-14.14v-.57H841v28.78c5.53-19 23.13-31.76 42.7-30.96 19.82 0 33.26 11.16 38.93 32.34a46.41 46.41 0 0 1 44.77-32.34c26.55 0 41.58 19.8 41.58 57.23 0 17.87-.56 38.24-.8 59.66a6.5 6.5 0 0 0 2.72 6.55l13.11 12.45v.57h-59.88zM215.87 593.3l17.66 17.05v.57h-89.62v-.57l17.99-17.05a6.91 6.91 0 0 0 2.4-6.55V477.69c0-4.6 0-10.83.8-16.16L104.66 613.1h-.72l-62.6-139.45c-1.37-3.47-1.77-3.72-2.65-6.06v91.43a32.08 32.08 0 0 0 2.96 17.87l25.19 33.46v.57H0v-.57l25.18-33.55a32.16 32.16 0 0 0 2.96-17.78V457.97A19.71 19.71 0 0 0 24 444.15L6.16 420.78v-.56h63.96l53.56 118.1 47.17-118.1h62.6v.56l-17.58 19.8a6.99 6.99 0 0 0-2.72 6.8v139.37a6.5 6.5 0 0 0 2.72 6.55zm70.11-54.65v.56c0 34.6 17.67 48.5 38.38 48.5a43.5 43.5 0 0 0 40.77-24.97h.56c-7.2 34.2-28.14 50.36-59.48 50.36-33.82 0-65.72-20.61-65.72-68.39 0-50.2 31.98-70.25 67.32-70.25 28.46 0 58.76 13.58 58.76 57.24v6.95h-80.59zm0-6.95h39.42v-7.04c0-35.57-7.28-45.03-18.23-45.03-13.27 0-21.35 14.15-21.35 52.07h.16z"
                }
            }
        ]
    })(props);
}
function AiOutlineMedium(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M834.7 279.8l61.3-58.9V208H683.7L532.4 586.4 360.3 208H137.7v12.9l71.6 86.6c7 6.4 10.6 15.8 9.7 25.2V673c2.2 12.3-1.7 24.8-10.3 33.7L128 805v12.7h228.6v-12.9l-80.6-98a39.99 39.99 0 0 1-11.1-33.7V378.7l200.7 439.2h23.3l172.6-439.2v349.9c0 9.2 0 11.1-6 17.2l-62.1 60.3V819h301.2v-12.9l-59.9-58.9c-5.2-4-7.9-10.7-6.8-17.2V297a18.1 18.1 0 0 1 6.8-17.2z"
                }
            }
        ]
    })(props);
}
function AiOutlineMeh(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M288 421a48 48 0 1 0 96 0 48 48 0 1 0-96 0zm352 0a48 48 0 1 0 96 0 48 48 0 1 0-96 0zM512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm263 711c-34.2 34.2-74 61-118.3 79.8C611 874.2 562.3 884 512 884c-50.3 0-99-9.8-144.8-29.2A370.4 370.4 0 0 1 248.9 775c-34.2-34.2-61-74-79.8-118.3C149.8 611 140 562.3 140 512s9.8-99 29.2-144.8A370.4 370.4 0 0 1 249 248.9c34.2-34.2 74-61 118.3-79.8C413 149.8 461.7 140 512 140c50.3 0 99 9.8 144.8 29.2A370.4 370.4 0 0 1 775.1 249c34.2 34.2 61 74 79.8 118.3C874.2 413 884 461.7 884 512s-9.8 99-29.2 144.8A368.89 368.89 0 0 1 775 775zM664 565H360c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h304c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8z"
                }
            }
        ]
    })(props);
}
function AiOutlineMenuFold(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M408 442h480c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H408c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm-8 204c0 4.4 3.6 8 8 8h480c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H408c-4.4 0-8 3.6-8 8v56zm504-486H120c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 632H120c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM115.4 518.9L271.7 642c5.8 4.6 14.4.5 14.4-6.9V388.9c0-7.4-8.5-11.5-14.4-6.9L115.4 505.1a8.74 8.74 0 0 0 0 13.8z"
                }
            }
        ]
    })(props);
}
function AiOutlineMenuUnfold(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M408 442h480c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H408c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm-8 204c0 4.4 3.6 8 8 8h480c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H408c-4.4 0-8 3.6-8 8v56zm504-486H120c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 632H120c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM142.4 642.1L298.7 519a8.84 8.84 0 0 0 0-13.9L142.4 381.9c-5.8-4.6-14.4-.5-14.4 6.9v246.3a8.9 8.9 0 0 0 14.4 7z"
                }
            }
        ]
    })(props);
}
function AiOutlineMenu(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M904 160H120c-4.4 0-8 3.6-8 8v64c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-64c0-4.4-3.6-8-8-8zm0 624H120c-4.4 0-8 3.6-8 8v64c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-64c0-4.4-3.6-8-8-8zm0-312H120c-4.4 0-8 3.6-8 8v64c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-64c0-4.4-3.6-8-8-8z"
                }
            }
        ]
    })(props);
}
function AiOutlineMergeCells(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "t": "1569683404098",
            "viewBox": "0 0 1024 1024",
            "version": "1.1"
        },
        "child": [
            {
                "tag": "defs",
                "attr": {},
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M482.2 508.4L331.3 389c-3-2.4-7.3-0.2-7.3 3.6V478H184V184h204v128c0 2.2 1.8 4 4 4h60c2.2 0 4-1.8 4-4V144c0-15.5-12.5-28-28-28H144c-15.5 0-28 12.5-28 28v736c0 15.5 12.5 28 28 28h284c15.5 0 28-12.5 28-28V712c0-2.2-1.8-4-4-4h-60c-2.2 0-4 1.8-4 4v128H184V546h140v85.4c0 3.8 4.4 6 7.3 3.6l150.9-119.4c2.4-1.8 2.4-5.4 0-7.2zM880 116H596c-15.5 0-28 12.5-28 28v168c0 2.2 1.8 4 4 4h60c2.2 0 4-1.8 4-4V184h204v294H700v-85.4c0-3.8-4.3-6-7.3-3.6l-151 119.4c-2.3 1.8-2.3 5.3 0 7.1l151 119.5c2.9 2.3 7.3 0.2 7.3-3.6V546h140v294H636V712c0-2.2-1.8-4-4-4h-60c-2.2 0-4 1.8-4 4v168c0 15.5 12.5 28 28 28h284c15.5 0 28-12.5 28-28V144c0-15.5-12.5-28-28-28z"
                }
            }
        ]
    })(props);
}
function AiOutlineMessage(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M464 512a48 48 0 1 0 96 0 48 48 0 1 0-96 0zm200 0a48 48 0 1 0 96 0 48 48 0 1 0-96 0zm-400 0a48 48 0 1 0 96 0 48 48 0 1 0-96 0zm661.2-173.6c-22.6-53.7-55-101.9-96.3-143.3a444.35 444.35 0 0 0-143.3-96.3C630.6 75.7 572.2 64 512 64h-2c-60.6.3-119.3 12.3-174.5 35.9a445.35 445.35 0 0 0-142 96.5c-40.9 41.3-73 89.3-95.2 142.8-23 55.4-34.6 114.3-34.3 174.9A449.4 449.4 0 0 0 112 714v152a46 46 0 0 0 46 46h152.1A449.4 449.4 0 0 0 510 960h2.1c59.9 0 118-11.6 172.7-34.3a444.48 444.48 0 0 0 142.8-95.2c41.3-40.9 73.8-88.7 96.5-142 23.6-55.2 35.6-113.9 35.9-174.5.3-60.9-11.5-120-34.8-175.6zm-151.1 438C704 845.8 611 884 512 884h-1.7c-60.3-.3-120.2-15.3-173.1-43.5l-8.4-4.5H188V695.2l-4.5-8.4C155.3 633.9 140.3 574 140 513.7c-.4-99.7 37.7-193.3 107.6-263.8 69.8-70.5 163.1-109.5 262.8-109.9h1.7c50 0 98.5 9.7 144.2 28.9 44.6 18.7 84.6 45.6 119 80 34.3 34.3 61.3 74.4 80 119 19.4 46.2 29.1 95.2 28.9 145.8-.6 99.6-39.7 192.9-110.1 262.7z"
                }
            }
        ]
    })(props);
}
function AiOutlineMinusCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M696 480H328c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h368c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z"
                }
            }
        ]
    })(props);
}
function AiOutlineMinusSquare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M328 544h368c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H328c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z"
                }
            }
        ]
    })(props);
}
function AiOutlineMinus(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M872 474H152c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h720c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8z"
                }
            }
        ]
    })(props);
}
function AiOutlineMobile(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M744 62H280c-35.3 0-64 28.7-64 64v768c0 35.3 28.7 64 64 64h464c35.3 0 64-28.7 64-64V126c0-35.3-28.7-64-64-64zm-8 824H288V134h448v752zM472 784a40 40 0 1 0 80 0 40 40 0 1 0-80 0z"
                }
            }
        ]
    })(props);
}
function AiOutlineMoneyCollect(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M911.5 700.7a8 8 0 0 0-10.3-4.8L840 718.2V180c0-37.6-30.4-68-68-68H252c-37.6 0-68 30.4-68 68v538.2l-61.3-22.3c-.9-.3-1.8-.5-2.7-.5-4.4 0-8 3.6-8 8V763c0 3.3 2.1 6.3 5.3 7.5L501 910.1c7.1 2.6 14.8 2.6 21.9 0l383.8-139.5c3.2-1.2 5.3-4.2 5.3-7.5v-59.6c0-1-.2-1.9-.5-2.8zM512 837.5l-256-93.1V184h512v560.4l-256 93.1zM660.6 312h-54.5c-3 0-5.8 1.7-7.1 4.4l-84.7 168.8H511l-84.7-168.8a8 8 0 0 0-7.1-4.4h-55.7c-1.3 0-2.6.3-3.8 1-3.9 2.1-5.3 7-3.2 10.8l103.9 191.6h-57c-4.4 0-8 3.6-8 8v27.1c0 4.4 3.6 8 8 8h76v39h-76c-4.4 0-8 3.6-8 8v27.1c0 4.4 3.6 8 8 8h76V704c0 4.4 3.6 8 8 8h49.9c4.4 0 8-3.6 8-8v-63.5h76.3c4.4 0 8-3.6 8-8v-27.1c0-4.4-3.6-8-8-8h-76.3v-39h76.3c4.4 0 8-3.6 8-8v-27.1c0-4.4-3.6-8-8-8H564l103.7-191.6c.6-1.2 1-2.5 1-3.8-.1-4.3-3.7-7.9-8.1-7.9z"
                }
            }
        ]
    })(props);
}
function AiOutlineMonitor(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M692.8 412.7l.2-.2-34.6-44.3a7.97 7.97 0 0 0-11.2-1.4l-50.4 39.3-70.5-90.1a7.97 7.97 0 0 0-11.2-1.4l-37.9 29.7a7.97 7.97 0 0 0-1.4 11.2l70.5 90.2-.2.1 34.6 44.3c2.7 3.5 7.7 4.1 11.2 1.4l50.4-39.3 64.1 82c2.7 3.5 7.7 4.1 11.2 1.4l37.9-29.6c3.5-2.7 4.1-7.7 1.4-11.2l-64.1-82.1zM608 112c-167.9 0-304 136.1-304 304 0 70.3 23.9 135 63.9 186.5L114.3 856.1a8.03 8.03 0 0 0 0 11.3l42.3 42.3c3.1 3.1 8.2 3.1 11.3 0l253.6-253.6C473 696.1 537.7 720 608 720c167.9 0 304-136.1 304-304S775.9 112 608 112zm161.2 465.2C726.2 620.3 668.9 644 608 644s-118.2-23.7-161.2-66.8C403.7 534.2 380 476.9 380 416s23.7-118.2 66.8-161.2c43-43.1 100.3-66.8 161.2-66.8s118.2 23.7 161.2 66.8c43.1 43 66.8 100.3 66.8 161.2s-23.7 118.2-66.8 161.2z"
                }
            }
        ]
    })(props);
}
function AiOutlineMore(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M456 231a56 56 0 1 0 112 0 56 56 0 1 0-112 0zm0 280a56 56 0 1 0 112 0 56 56 0 1 0-112 0zm0 280a56 56 0 1 0 112 0 56 56 0 1 0-112 0z"
                }
            }
        ]
    })(props);
}
function AiOutlineNodeCollapse(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "t": "1569683371420",
            "viewBox": "0 0 1024 1024",
            "version": "1.1"
        },
        "child": [
            {
                "tag": "defs",
                "attr": {},
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M952 612c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H298c-14.2-35.2-48.7-60-89-60-53 0-96 43-96 96s43 96 96 96c40.3 0 74.8-24.8 89-60h150.3v152c0 55.2 44.8 100 100 100H952c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H548.3c-15.5 0-28-12.5-28-28V612H952zM451.7 313.7l172.5 136.2c6.3 5.1 15.8 0.5 15.8-7.7V344h264c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8H640v-98.2c0-8.1-9.4-12.8-15.8-7.7L451.7 298.3c-4.9 3.9-4.9 11.5 0 15.4z"
                }
            }
        ]
    })(props);
}
function AiOutlineNodeExpand(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "t": "1569683374330",
            "viewBox": "0 0 1024 1024",
            "version": "1.1"
        },
        "child": [
            {
                "tag": "defs",
                "attr": {},
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M952 612c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H298c-14.2-35.2-48.7-60-89-60-53 0-96 43-96 96s43 96 96 96c40.3 0 74.8-24.8 89-60h150.3v152c0 55.2 44.8 100 100 100H952c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H548.3c-15.5 0-28-12.5-28-28V612H952zM456 344h264v98.2c0 8.1 9.5 12.8 15.8 7.7l172.5-136.2c5-3.9 5-11.4 0-15.3L735.8 162.1c-6.4-5.1-15.8-0.5-15.8 7.7V268H456c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8z"
                }
            }
        ]
    })(props);
}
function AiOutlineNodeIndex(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "t": "1569683635191",
            "viewBox": "0 0 1024 1024",
            "version": "1.1"
        },
        "child": [
            {
                "tag": "defs",
                "attr": {},
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M843.5 737.4c-12.4-75.2-79.2-129.1-155.3-125.4S550.9 676 546 752c-153.5-4.8-208-40.7-199.1-113.7 3.3-27.3 19.8-41.9 50.1-49 18.4-4.3 38.8-4.9 57.3-3.2 1.7 0.2 3.5 0.3 5.2 0.5 11.3 2.7 22.8 5 34.3 6.8 34.1 5.6 68.8 8.4 101.8 6.6 92.8-5 156-45.9 159.2-132.7 3.1-84.1-54.7-143.7-147.9-183.6-29.9-12.8-61.6-22.7-93.3-30.2-14.3-3.4-26.3-5.7-35.2-7.2-7.9-75.9-71.5-133.8-147.8-134.4-76.3-0.6-140.9 56.1-150.1 131.9s40 146.3 114.2 163.9c74.2 17.6 149.9-23.3 175.7-95.1 9.4 1.7 18.7 3.6 28 5.8 28.2 6.6 56.4 15.4 82.4 26.6 70.7 30.2 109.3 70.1 107.5 119.9-1.6 44.6-33.6 65.2-96.2 68.6-27.5 1.5-57.6-0.9-87.3-5.8-8.3-1.4-15.9-2.8-22.6-4.3-3.9-0.8-6.6-1.5-7.8-1.8l-3.1-0.6c-2.2-0.3-5.9-0.8-10.7-1.3-25-2.3-52.1-1.5-78.5 4.6-55.2 12.9-93.9 47.2-101.1 105.8-15.7 126.2 78.6 184.7 276 188.9 29.1 70.4 106.4 107.9 179.6 87 73.3-20.9 119.3-93.4 106.9-168.6zM329.1 345.2c-46 0-83.3-37.3-83.3-83.3s37.3-83.3 83.3-83.3 83.3 37.3 83.3 83.3-37.3 83.3-83.3 83.3zM695.6 845c-46 0-83.3-37.3-83.3-83.3s37.3-83.3 83.3-83.3 83.3 37.3 83.3 83.3-37.3 83.3-83.3 83.3z"
                }
            }
        ]
    })(props);
}
function AiOutlineNotification(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M880 112c-3.8 0-7.7.7-11.6 2.3L292 345.9H128c-8.8 0-16 7.4-16 16.6v299c0 9.2 7.2 16.6 16 16.6h101.7c-3.7 11.6-5.7 23.9-5.7 36.4 0 65.9 53.8 119.5 120 119.5 55.4 0 102.1-37.6 115.9-88.4l408.6 164.2c3.9 1.5 7.8 2.3 11.6 2.3 16.9 0 32-14.2 32-33.2V145.2C912 126.2 897 112 880 112zM344 762.3c-26.5 0-48-21.4-48-47.8 0-11.2 3.9-21.9 11-30.4l84.9 34.1c-2 24.6-22.7 44.1-47.9 44.1zm496 58.4L318.8 611.3l-12.9-5.2H184V417.9h121.9l12.9-5.2L840 203.3v617.4z"
                }
            }
        ]
    })(props);
}
function AiOutlineNumber(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M872 394c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8H708V152c0-4.4-3.6-8-8-8h-64c-4.4 0-8 3.6-8 8v166H400V152c0-4.4-3.6-8-8-8h-64c-4.4 0-8 3.6-8 8v166H152c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h168v236H152c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h168v166c0 4.4 3.6 8 8 8h64c4.4 0 8-3.6 8-8V706h228v166c0 4.4 3.6 8 8 8h64c4.4 0 8-3.6 8-8V706h164c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8H708V394h164zM628 630H400V394h228v236z"
                }
            }
        ]
    })(props);
}
function AiOutlineOneToOne(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "t": "1569683653709",
            "viewBox": "0 0 1024 1024",
            "version": "1.1"
        },
        "child": [
            {
                "tag": "defs",
                "attr": {},
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M316 672h60c4.4 0 8-3.6 8-8V360c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8v304c0 4.4 3.6 8 8 8zM512 622c22.1 0 40-17.9 40-39 0-23.1-17.9-41-40-41s-40 17.9-40 41c0 21.1 17.9 39 40 39zM512 482c22.1 0 40-17.9 40-39 0-23.1-17.9-41-40-41s-40 17.9-40 41c0 21.1 17.9 39 40 39z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32z m-40 728H184V184h656v656z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M648 672h60c4.4 0 8-3.6 8-8V360c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8v304c0 4.4 3.6 8 8 8z"
                }
            }
        ]
    })(props);
}
function AiOutlineOrderedList(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M920 760H336c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h584c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-568H336c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h584c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 284H336c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h584c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM216 712H100c-2.2 0-4 1.8-4 4v34c0 2.2 1.8 4 4 4h72.4v20.5h-35.7c-2.2 0-4 1.8-4 4v34c0 2.2 1.8 4 4 4h35.7V838H100c-2.2 0-4 1.8-4 4v34c0 2.2 1.8 4 4 4h116c2.2 0 4-1.8 4-4V716c0-2.2-1.8-4-4-4zM100 188h38v120c0 2.2 1.8 4 4 4h40c2.2 0 4-1.8 4-4V152c0-4.4-3.6-8-8-8h-78c-2.2 0-4 1.8-4 4v36c0 2.2 1.8 4 4 4zm116 240H100c-2.2 0-4 1.8-4 4v36c0 2.2 1.8 4 4 4h68.4l-70.3 77.7a8.3 8.3 0 0 0-2.1 5.4V592c0 2.2 1.8 4 4 4h116c2.2 0 4-1.8 4-4v-36c0-2.2-1.8-4-4-4h-68.4l70.3-77.7a8.3 8.3 0 0 0 2.1-5.4V432c0-2.2-1.8-4-4-4z"
                }
            }
        ]
    })(props);
}
function AiOutlinePaperClip(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M779.3 196.6c-94.2-94.2-247.6-94.2-341.7 0l-261 260.8c-1.7 1.7-2.6 4-2.6 6.4s.9 4.7 2.6 6.4l36.9 36.9a9 9 0 0 0 12.7 0l261-260.8c32.4-32.4 75.5-50.2 121.3-50.2s88.9 17.8 121.2 50.2c32.4 32.4 50.2 75.5 50.2 121.2 0 45.8-17.8 88.8-50.2 121.2l-266 265.9-43.1 43.1c-40.3 40.3-105.8 40.3-146.1 0-19.5-19.5-30.2-45.4-30.2-73s10.7-53.5 30.2-73l263.9-263.8c6.7-6.6 15.5-10.3 24.9-10.3h.1c9.4 0 18.1 3.7 24.7 10.3 6.7 6.7 10.3 15.5 10.3 24.9 0 9.3-3.7 18.1-10.3 24.7L372.4 653c-1.7 1.7-2.6 4-2.6 6.4s.9 4.7 2.6 6.4l36.9 36.9a9 9 0 0 0 12.7 0l215.6-215.6c19.9-19.9 30.8-46.3 30.8-74.4s-11-54.6-30.8-74.4c-41.1-41.1-107.9-41-149 0L463 364 224.8 602.1A172.22 172.22 0 0 0 174 724.8c0 46.3 18.1 89.8 50.8 122.5 33.9 33.8 78.3 50.7 122.7 50.7 44.4 0 88.8-16.9 122.6-50.7l309.2-309C824.8 492.7 850 432 850 367.5c.1-64.6-25.1-125.3-70.7-170.9z"
                }
            }
        ]
    })(props);
}
function AiOutlinePartition(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "t": "1569683632175",
            "viewBox": "0 0 1024 1024",
            "version": "1.1"
        },
        "child": [
            {
                "tag": "defs",
                "attr": {},
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M640.6 429.8h257.1c7.9 0 14.3-6.4 14.3-14.3V158.3c0-7.9-6.4-14.3-14.3-14.3H640.6c-7.9 0-14.3 6.4-14.3 14.3v92.9H490.6c-3.9 0-7.1 3.2-7.1 7.1v221.5h-85.7v-96.5c0-7.9-6.4-14.3-14.3-14.3H126.3c-7.9 0-14.3 6.4-14.3 14.3v257.2c0 7.9 6.4 14.3 14.3 14.3h257.1c7.9 0 14.3-6.4 14.3-14.3V544h85.7v221.5c0 3.9 3.2 7.1 7.1 7.1h135.7v92.9c0 7.9 6.4 14.3 14.3 14.3h257.1c7.9 0 14.3-6.4 14.3-14.3v-257c0-7.9-6.4-14.3-14.3-14.3h-257c-7.9 0-14.3 6.4-14.3 14.3v100h-78.6v-393h78.6v100c0 7.9 6.4 14.3 14.3 14.3z m53.5-217.9h150V362h-150V211.9zM329.9 587h-150V437h150v150z m364.2 75.1h150v150.1h-150V662.1z"
                }
            }
        ]
    })(props);
}
function AiOutlinePauseCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372zm-88-532h-48c-4.4 0-8 3.6-8 8v304c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V360c0-4.4-3.6-8-8-8zm224 0h-48c-4.4 0-8 3.6-8 8v304c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V360c0-4.4-3.6-8-8-8z"
                }
            }
        ]
    })(props);
}
function AiOutlinePause(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M304 176h80v672h-80zm408 0h-64c-4.4 0-8 3.6-8 8v656c0 4.4 3.6 8 8 8h64c4.4 0 8-3.6 8-8V184c0-4.4-3.6-8-8-8z"
                }
            }
        ]
    })(props);
}
function AiOutlinePayCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372zm159.6-585h-59.5c-3 0-5.8 1.7-7.1 4.4l-90.6 180H511l-90.6-180a8 8 0 0 0-7.1-4.4h-60.7c-1.3 0-2.6.3-3.8 1-3.9 2.1-5.3 7-3.2 10.9L457 515.7h-61.4c-4.4 0-8 3.6-8 8v29.9c0 4.4 3.6 8 8 8h81.7V603h-81.7c-4.4 0-8 3.6-8 8v29.9c0 4.4 3.6 8 8 8h81.7V717c0 4.4 3.6 8 8 8h54.3c4.4 0 8-3.6 8-8v-68.1h82c4.4 0 8-3.6 8-8V611c0-4.4-3.6-8-8-8h-82v-41.5h82c4.4 0 8-3.6 8-8v-29.9c0-4.4-3.6-8-8-8h-62l111.1-204.8c.6-1.2 1-2.5 1-3.8-.1-4.4-3.7-8-8.1-8z"
                }
            }
        ]
    })(props);
}
function AiOutlinePercentage(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M855.7 210.8l-42.4-42.4a8.03 8.03 0 0 0-11.3 0L168.3 801.9a8.03 8.03 0 0 0 0 11.3l42.4 42.4c3.1 3.1 8.2 3.1 11.3 0L855.6 222c3.2-3 3.2-8.1.1-11.2zM304 448c79.4 0 144-64.6 144-144s-64.6-144-144-144-144 64.6-144 144 64.6 144 144 144zm0-216c39.7 0 72 32.3 72 72s-32.3 72-72 72-72-32.3-72-72 32.3-72 72-72zm416 344c-79.4 0-144 64.6-144 144s64.6 144 144 144 144-64.6 144-144-64.6-144-144-144zm0 216c-39.7 0-72-32.3-72-72s32.3-72 72-72 72 32.3 72 72-32.3 72-72 72z"
                }
            }
        ]
    })(props);
}
function AiOutlinePhone(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M877.1 238.7L770.6 132.3c-13-13-30.4-20.3-48.8-20.3s-35.8 7.2-48.8 20.3L558.3 246.8c-13 13-20.3 30.5-20.3 48.9 0 18.5 7.2 35.8 20.3 48.9l89.6 89.7a405.46 405.46 0 0 1-86.4 127.3c-36.7 36.9-79.6 66-127.2 86.6l-89.6-89.7c-13-13-30.4-20.3-48.8-20.3a68.2 68.2 0 0 0-48.8 20.3L132.3 673c-13 13-20.3 30.5-20.3 48.9 0 18.5 7.2 35.8 20.3 48.9l106.4 106.4c22.2 22.2 52.8 34.9 84.2 34.9 6.5 0 12.8-.5 19.2-1.6 132.4-21.8 263.8-92.3 369.9-198.3C818 606 888.4 474.6 910.4 342.1c6.3-37.6-6.3-76.3-33.3-103.4zm-37.6 91.5c-19.5 117.9-82.9 235.5-178.4 331s-213 158.9-330.9 178.4c-14.8 2.5-30-2.5-40.8-13.2L184.9 721.9 295.7 611l119.8 120 .9.9 21.6-8a481.29 481.29 0 0 0 285.7-285.8l8-21.6-120.8-120.7 110.8-110.9 104.5 104.5c10.8 10.8 15.8 26 13.3 40.8z"
                }
            }
        ]
    })(props);
}
function AiOutlinePicCenter(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M952 792H72c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h880c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-632H72c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h880c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM848 660c8.8 0 16-7.2 16-16V380c0-8.8-7.2-16-16-16H176c-8.8 0-16 7.2-16 16v264c0 8.8 7.2 16 16 16h672zM232 436h560v152H232V436z"
                }
            }
        ]
    })(props);
}
function AiOutlinePicLeft(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M952 792H72c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h880c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-632H72c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h880c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM608 660c8.8 0 16-7.2 16-16V380c0-8.8-7.2-16-16-16H96c-8.8 0-16 7.2-16 16v264c0 8.8 7.2 16 16 16h512zM152 436h400v152H152V436zm552 210c0 4.4 3.6 8 8 8h224c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H712c-4.4 0-8 3.6-8 8v56zm8-204h224c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H712c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8z"
                }
            }
        ]
    })(props);
}
function AiOutlinePicRight(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M952 792H72c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h880c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-632H72c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h880c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-24 500c8.8 0 16-7.2 16-16V380c0-8.8-7.2-16-16-16H416c-8.8 0-16 7.2-16 16v264c0 8.8 7.2 16 16 16h512zM472 436h400v152H472V436zM80 646c0 4.4 3.6 8 8 8h224c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H88c-4.4 0-8 3.6-8 8v56zm8-204h224c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H88c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8z"
                }
            }
        ]
    })(props);
}
function AiOutlinePicture(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M928 160H96c-17.7 0-32 14.3-32 32v640c0 17.7 14.3 32 32 32h832c17.7 0 32-14.3 32-32V192c0-17.7-14.3-32-32-32zm-40 632H136v-39.9l138.5-164.3 150.1 178L658.1 489 888 761.6V792zm0-129.8L664.2 396.8c-3.2-3.8-9-3.8-12.2 0L424.6 666.4l-144-170.7c-3.2-3.8-9-3.8-12.2 0L136 652.7V232h752v430.2zM304 456a88 88 0 1 0 0-176 88 88 0 0 0 0 176zm0-116c15.5 0 28 12.5 28 28s-12.5 28-28 28-28-12.5-28-28 12.5-28 28-28z"
                }
            }
        ]
    })(props);
}
function AiOutlinePieChart(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M864 518H506V160c0-4.4-3.6-8-8-8h-26a398.46 398.46 0 0 0-282.8 117.1 398.19 398.19 0 0 0-85.7 127.1A397.61 397.61 0 0 0 72 552a398.46 398.46 0 0 0 117.1 282.8c36.7 36.7 79.5 65.6 127.1 85.7A397.61 397.61 0 0 0 472 952a398.46 398.46 0 0 0 282.8-117.1c36.7-36.7 65.6-79.5 85.7-127.1A397.61 397.61 0 0 0 872 552v-26c0-4.4-3.6-8-8-8zM705.7 787.8A331.59 331.59 0 0 1 470.4 884c-88.1-.4-170.9-34.9-233.2-97.2C174.5 724.1 140 640.7 140 552c0-88.7 34.5-172.1 97.2-234.8 54.6-54.6 124.9-87.9 200.8-95.5V586h364.3c-7.7 76.3-41.3 147-96.6 201.8zM952 462.4l-2.6-28.2c-8.5-92.1-49.4-179-115.2-244.6A399.4 399.4 0 0 0 589 74.6L560.7 72c-4.7-.4-8.7 3.2-8.7 7.9V464c0 4.4 3.6 8 8 8l384-1c4.7 0 8.4-4 8-8.6zm-332.2-58.2V147.6a332.24 332.24 0 0 1 166.4 89.8c45.7 45.6 77 103.6 90 166.1l-256.4.7z"
                }
            }
        ]
    })(props);
}
function AiOutlinePlayCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M719.4 499.1l-296.1-215A15.9 15.9 0 0 0 398 297v430c0 13.1 14.8 20.5 25.3 12.9l296.1-215a15.9 15.9 0 0 0 0-25.8zm-257.6 134V390.9L628.5 512 461.8 633.1z"
                }
            }
        ]
    })(props);
}
function AiOutlinePlaySquare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M442.3 677.6l199.4-156.7a11.3 11.3 0 0 0 0-17.7L442.3 346.4c-7.4-5.8-18.3-.6-18.3 8.8v313.5c0 9.4 10.9 14.7 18.3 8.9z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z"
                }
            }
        ]
    })(props);
}
function AiOutlinePlusCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M696 480H544V328c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v152H328c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h152v152c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V544h152c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z"
                }
            }
        ]
    })(props);
}
function AiOutlinePlusSquare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M328 544h152v152c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V544h152c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H544V328c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v152H328c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z"
                }
            }
        ]
    })(props);
}
function AiOutlinePlus(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M482 152h60q8 0 8 8v704q0 8-8 8h-60q-8 0-8-8V160q0-8 8-8Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M192 474h672q8 0 8 8v60q0 8-8 8H160q-8 0-8-8v-60q0-8 8-8Z"
                }
            }
        ]
    })(props);
}
function AiOutlinePoundCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372zm138-209.8H469.8v-4.7c27.4-17.2 43.9-50.4 43.9-91.1 0-14.1-2.2-27.9-5.3-41H607c4.4 0 8-3.6 8-8v-30c0-4.4-3.6-8-8-8H495c-7.2-22.6-13.4-45.7-13.4-70.5 0-43.5 34-70.2 87.3-70.2 21.5 0 42.5 4.1 60.4 10.5 5.2 1.9 10.6-2 10.6-7.6v-39.5c0-3.3-2.1-6.3-5.2-7.5-18.8-7.2-43.8-12.7-70.3-12.7-92.9 0-151.5 44.5-151.5 120.3 0 26.3 6.9 52 14.6 77.1H374c-4.4 0-8 3.6-8 8v30c0 4.4 3.6 8 8 8h67.1c3.4 14.7 5.9 29.4 5.9 44.2 0 45.2-28.8 83.3-72.8 94.2-3.6.9-6.1 4.1-6.1 7.8V722c0 4.4 3.6 8 8 8H650c4.4 0 8-3.6 8-8v-39.8c0-4.4-3.6-8-8-8z"
                }
            }
        ]
    })(props);
}
function AiOutlinePound(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372zm138-209.8H469.8v-4.7c27.4-17.2 43.9-50.4 43.9-91.1 0-14.1-2.2-27.9-5.3-41H607c4.4 0 8-3.6 8-8v-30c0-4.4-3.6-8-8-8H495c-7.2-22.6-13.4-45.7-13.4-70.5 0-43.5 34-70.2 87.3-70.2 21.5 0 42.5 4.1 60.4 10.5 5.2 1.9 10.6-2 10.6-7.6v-39.5c0-3.3-2.1-6.3-5.2-7.5-18.8-7.2-43.8-12.7-70.3-12.7-92.9 0-151.5 44.5-151.5 120.3 0 26.3 6.9 52 14.6 77.1H374c-4.4 0-8 3.6-8 8v30c0 4.4 3.6 8 8 8h67.1c3.4 14.7 5.9 29.4 5.9 44.2 0 45.2-28.8 83.3-72.8 94.2-3.6.9-6.1 4.1-6.1 7.8V722c0 4.4 3.6 8 8 8H650c4.4 0 8-3.6 8-8v-39.8c0-4.4-3.6-8-8-8z"
                }
            }
        ]
    })(props);
}
function AiOutlinePoweroff(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M705.6 124.9a8 8 0 0 0-11.6 7.2v64.2c0 5.5 2.9 10.6 7.5 13.6a352.2 352.2 0 0 1 62.2 49.8c32.7 32.8 58.4 70.9 76.3 113.3a355 355 0 0 1 27.9 138.7c0 48.1-9.4 94.8-27.9 138.7a355.92 355.92 0 0 1-76.3 113.3 353.06 353.06 0 0 1-113.2 76.4c-43.8 18.6-90.5 28-138.5 28s-94.7-9.4-138.5-28a353.06 353.06 0 0 1-113.2-76.4A355.92 355.92 0 0 1 184 650.4a355 355 0 0 1-27.9-138.7c0-48.1 9.4-94.8 27.9-138.7 17.9-42.4 43.6-80.5 76.3-113.3 19-19 39.8-35.6 62.2-49.8 4.7-2.9 7.5-8.1 7.5-13.6V132c0-6-6.3-9.8-11.6-7.2C178.5 195.2 82 339.3 80 506.3 77.2 745.1 272.5 943.5 511.2 944c239 .5 432.8-193.3 432.8-432.4 0-169.2-97-315.7-238.4-386.7zM480 560h64c4.4 0 8-3.6 8-8V88c0-4.4-3.6-8-8-8h-64c-4.4 0-8 3.6-8 8v464c0 4.4 3.6 8 8 8z"
                }
            }
        ]
    })(props);
}
function AiOutlinePrinter(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M820 436h-40c-4.4 0-8 3.6-8 8v40c0 4.4 3.6 8 8 8h40c4.4 0 8-3.6 8-8v-40c0-4.4-3.6-8-8-8zm32-104H732V120c0-4.4-3.6-8-8-8H300c-4.4 0-8 3.6-8 8v212H172c-44.2 0-80 35.8-80 80v328c0 17.7 14.3 32 32 32h168v132c0 4.4 3.6 8 8 8h424c4.4 0 8-3.6 8-8V772h168c17.7 0 32-14.3 32-32V412c0-44.2-35.8-80-80-80zM360 180h304v152H360V180zm304 664H360V568h304v276zm200-140H732V500H292v204H160V412c0-6.6 5.4-12 12-12h680c6.6 0 12 5.4 12 12v292z"
                }
            }
        ]
    })(props);
}
function AiOutlineProfile(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656zM492 400h184c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H492c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8zm0 144h184c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H492c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8zm0 144h184c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H492c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8zM340 368a40 40 0 1 0 80 0 40 40 0 1 0-80 0zm0 144a40 40 0 1 0 80 0 40 40 0 1 0-80 0zm0 144a40 40 0 1 0 80 0 40 40 0 1 0-80 0z"
                }
            }
        ]
    })(props);
}
function AiOutlineProject(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M280 752h80c4.4 0 8-3.6 8-8V280c0-4.4-3.6-8-8-8h-80c-4.4 0-8 3.6-8 8v464c0 4.4 3.6 8 8 8zm192-280h80c4.4 0 8-3.6 8-8V280c0-4.4-3.6-8-8-8h-80c-4.4 0-8 3.6-8 8v184c0 4.4 3.6 8 8 8zm192 72h80c4.4 0 8-3.6 8-8V280c0-4.4-3.6-8-8-8h-80c-4.4 0-8 3.6-8 8v256c0 4.4 3.6 8 8 8zm216-432H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z"
                }
            }
        ]
    })(props);
}
function AiOutlinePropertySafety(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M866.9 169.9L527.1 54.1C523 52.7 517.5 52 512 52s-11 .7-15.1 2.1L157.1 169.9c-8.3 2.8-15.1 12.4-15.1 21.2v482.4c0 8.8 5.7 20.4 12.6 25.9L499.3 968c3.5 2.7 8 4.1 12.6 4.1s9.2-1.4 12.6-4.1l344.7-268.6c6.9-5.4 12.6-17 12.6-25.9V191.1c.2-8.8-6.6-18.3-14.9-21.2zM810 654.3L512 886.5 214 654.3V226.7l298-101.6 298 101.6v427.6zM430.5 318h-46c-1.7 0-3.3.4-4.8 1.2a10.1 10.1 0 0 0-4 13.6l88 161.1h-45.2c-5.5 0-10 4.5-10 10v21.3c0 5.5 4.5 10 10 10h63.1v29.7h-63.1c-5.5 0-10 4.5-10 10v21.3c0 5.5 4.5 10 10 10h63.1V658c0 5.5 4.5 10 10 10h41.3c5.5 0 10-4.5 10-10v-51.8h63.4c5.5 0 10-4.5 10-10v-21.3c0-5.5-4.5-10-10-10h-63.4v-29.7h63.4c5.5 0 10-4.5 10-10v-21.3c0-5.5-4.5-10-10-10h-45.7l87.7-161.1a10.05 10.05 0 0 0-8.8-14.8h-45c-3.8 0-7.2 2.1-8.9 5.5l-73.2 144.3-72.9-144.3c-1.7-3.4-5.2-5.5-9-5.5z"
                }
            }
        ]
    })(props);
}
function AiOutlinePullRequest(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M788 705.9V192c0-8.8-7.2-16-16-16H602v-68.8c0-6-7-9.4-11.7-5.7L462.7 202.3a7.14 7.14 0 0 0 0 11.3l127.5 100.8c4.7 3.7 11.7.4 11.7-5.7V240h114v465.9c-44.2 15-76 56.9-76 106.1 0 61.8 50.2 112 112 112s112-50.2 112-112c.1-49.2-31.7-91-75.9-106.1zM752 860a48.01 48.01 0 0 1 0-96 48.01 48.01 0 0 1 0 96zM384 212c0-61.8-50.2-112-112-112s-112 50.2-112 112c0 49.2 31.8 91 76 106.1V706c-44.2 15-76 56.9-76 106.1 0 61.8 50.2 112 112 112s112-50.2 112-112c0-49.2-31.8-91-76-106.1V318.1c44.2-15.1 76-56.9 76-106.1zm-160 0a48.01 48.01 0 0 1 96 0 48.01 48.01 0 0 1-96 0zm96 600a48.01 48.01 0 0 1-96 0 48.01 48.01 0 0 1 96 0z"
                }
            }
        ]
    })(props);
}
function AiOutlinePushpin(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M878.3 392.1L631.9 145.7c-6.5-6.5-15-9.7-23.5-9.7s-17 3.2-23.5 9.7L423.8 306.9c-12.2-1.4-24.5-2-36.8-2-73.2 0-146.4 24.1-206.5 72.3a33.23 33.23 0 0 0-2.7 49.4l181.7 181.7-215.4 215.2a15.8 15.8 0 0 0-4.6 9.8l-3.4 37.2c-.9 9.4 6.6 17.4 15.9 17.4.5 0 1 0 1.5-.1l37.2-3.4c3.7-.3 7.2-2 9.8-4.6l215.4-215.4 181.7 181.7c6.5 6.5 15 9.7 23.5 9.7 9.7 0 19.3-4.2 25.9-12.4 56.3-70.3 79.7-158.3 70.2-243.4l161.1-161.1c12.9-12.8 12.9-33.8 0-46.8zM666.2 549.3l-24.5 24.5 3.8 34.4a259.92 259.92 0 0 1-30.4 153.9L262 408.8c12.9-7.1 26.3-13.1 40.3-17.9 27.2-9.4 55.7-14.1 84.7-14.1 9.6 0 19.3.5 28.9 1.6l34.4 3.8 24.5-24.5L608.5 224 800 415.5 666.2 549.3z"
                }
            }
        ]
    })(props);
}
function AiOutlineQq(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M824.8 613.2c-16-51.4-34.4-94.6-62.7-165.3C766.5 262.2 689.3 112 511.5 112 331.7 112 256.2 265.2 261 447.9c-28.4 70.8-46.7 113.7-62.7 165.3-34 109.5-23 154.8-14.6 155.8 18 2.2 70.1-82.4 70.1-82.4 0 49 25.2 112.9 79.8 159-26.4 8.1-85.7 29.9-71.6 53.8 11.4 19.3 196.2 12.3 249.5 6.3 53.3 6 238.1 13 249.5-6.3 14.1-23.8-45.3-45.7-71.6-53.8 54.6-46.2 79.8-110.1 79.8-159 0 0 52.1 84.6 70.1 82.4 8.5-1.1 19.5-46.4-14.5-155.8z"
                }
            }
        ]
    })(props);
}
function AiOutlineQrcode(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M468 128H160c-17.7 0-32 14.3-32 32v308c0 4.4 3.6 8 8 8h332c4.4 0 8-3.6 8-8V136c0-4.4-3.6-8-8-8zm-56 284H192V192h220v220zm-138-74h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm194 210H136c-4.4 0-8 3.6-8 8v308c0 17.7 14.3 32 32 32h308c4.4 0 8-3.6 8-8V556c0-4.4-3.6-8-8-8zm-56 284H192V612h220v220zm-138-74h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm590-630H556c-4.4 0-8 3.6-8 8v332c0 4.4 3.6 8 8 8h332c4.4 0 8-3.6 8-8V160c0-17.7-14.3-32-32-32zm-32 284H612V192h220v220zm-138-74h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm194 210h-48c-4.4 0-8 3.6-8 8v134h-78V556c0-4.4-3.6-8-8-8H556c-4.4 0-8 3.6-8 8v332c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V644h78v102c0 4.4 3.6 8 8 8h190c4.4 0 8-3.6 8-8V556c0-4.4-3.6-8-8-8zM746 832h-48c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zm142 0h-48c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8z"
                }
            }
        ]
    })(props);
}
function AiOutlineQuestionCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M623.6 316.7C593.6 290.4 554 276 512 276s-81.6 14.5-111.6 40.7C369.2 344 352 380.7 352 420v7.6c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V420c0-44.1 43.1-80 96-80s96 35.9 96 80c0 31.1-22 59.6-56.1 72.7-21.2 8.1-39.2 22.3-52.1 40.9-13.1 19-19.9 41.8-19.9 64.9V620c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8v-22.7a48.3 48.3 0 0 1 30.9-44.8c59-22.7 97.1-74.7 97.1-132.5.1-39.3-17.1-76-48.3-103.3zM472 732a40 40 0 1 0 80 0 40 40 0 1 0-80 0z"
                }
            }
        ]
    })(props);
}
function AiOutlineQuestion(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M764 280.9c-14-30.6-33.9-58.1-59.3-81.6C653.1 151.4 584.6 125 512 125s-141.1 26.4-192.7 74.2c-25.4 23.6-45.3 51-59.3 81.7-14.6 32-22 65.9-22 100.9v27c0 6.2 5 11.2 11.2 11.2h54c6.2 0 11.2-5 11.2-11.2v-27c0-99.5 88.6-180.4 197.6-180.4s197.6 80.9 197.6 180.4c0 40.8-14.5 79.2-42 111.2-27.2 31.7-65.6 54.4-108.1 64-24.3 5.5-46.2 19.2-61.7 38.8a110.85 110.85 0 0 0-23.9 68.6v31.4c0 6.2 5 11.2 11.2 11.2h54c6.2 0 11.2-5 11.2-11.2v-31.4c0-15.7 10.9-29.5 26-32.9 58.4-13.2 111.4-44.7 149.3-88.7 19.1-22.3 34-47.1 44.3-74 10.7-27.9 16.1-57.2 16.1-87 0-35-7.4-69-22-100.9zM512 787c-30.9 0-56 25.1-56 56s25.1 56 56 56 56-25.1 56-56-25.1-56-56-56z"
                }
            }
        ]
    })(props);
}
function AiOutlineRadarChart(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M926.8 397.1l-396-288a31.81 31.81 0 0 0-37.6 0l-396 288a31.99 31.99 0 0 0-11.6 35.8l151.3 466a32 32 0 0 0 30.4 22.1h489.5c13.9 0 26.1-8.9 30.4-22.1l151.3-466c4.2-13.2-.5-27.6-11.7-35.8zM838.6 417l-98.5 32-200-144.7V199.9L838.6 417zM466 567.2l-89.1 122.3-55.2-169.2L466 567.2zm-116.3-96.8L484 373.3v140.8l-134.3-43.7zM512 599.2l93.9 128.9H418.1L512 599.2zm28.1-225.9l134.2 97.1L540.1 514V373.3zM558 567.2l144.3-46.9-55.2 169.2L558 567.2zm-74-367.3v104.4L283.9 449l-98.5-32L484 199.9zM169.3 470.8l86.5 28.1 80.4 246.4-53.8 73.9-113.1-348.4zM327.1 853l50.3-69h269.3l50.3 69H327.1zm414.5-33.8l-53.8-73.9 80.4-246.4 86.5-28.1-113.1 348.4z"
                }
            }
        ]
    })(props);
}
function AiOutlineRadiusBottomleft(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M712 824h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm2-696h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM136 374h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm0-174h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm752 624h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-174h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-174h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-174h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-174h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-348 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-230 72h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm230 624H358c-87.3 0-158-70.7-158-158V484c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v182c0 127 103 230 230 230h182c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8z"
                }
            }
        ]
    })(props);
}
function AiOutlineRadiusBottomright(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M368 824h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-58-624h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm578 102h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-174h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM192 824h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-174h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-174h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-174h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-174h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm292 72h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm174 0h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm230 276h-56c-4.4 0-8 3.6-8 8v182c0 87.3-70.7 158-158 158H484c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h182c127 0 230-103 230-230V484c0-4.4-3.6-8-8-8z"
                }
            }
        ]
    })(props);
}
function AiOutlineRadiusSetting(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M396 140h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-44 684h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm524-204h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM192 344h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 160h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 160h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 160h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm320 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm160 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm140-284c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V370c0-127-103-230-230-230H484c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h170c87.3 0 158 70.7 158 158v170zM236 96H92c-4.4 0-8 3.6-8 8v144c0 4.4 3.6 8 8 8h144c4.4 0 8-3.6 8-8V104c0-4.4-3.6-8-8-8zm-48 101.6c0 1.3-1.1 2.4-2.4 2.4h-43.2c-1.3 0-2.4-1.1-2.4-2.4v-43.2c0-1.3 1.1-2.4 2.4-2.4h43.2c1.3 0 2.4 1.1 2.4 2.4v43.2zM920 780H776c-4.4 0-8 3.6-8 8v144c0 4.4 3.6 8 8 8h144c4.4 0 8-3.6 8-8V788c0-4.4-3.6-8-8-8zm-48 101.6c0 1.3-1.1 2.4-2.4 2.4h-43.2c-1.3 0-2.4-1.1-2.4-2.4v-43.2c0-1.3 1.1-2.4 2.4-2.4h43.2c1.3 0 2.4 1.1 2.4 2.4v43.2z"
                }
            }
        ]
    })(props);
}
function AiOutlineRadiusUpleft(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M656 200h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm58 624h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM192 650h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 174h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm696-696h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 174h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 174h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 174h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 174h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-348 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-174 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm174-696H358c-127 0-230 103-230 230v182c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V358c0-87.3 70.7-158 158-158h182c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8z"
                }
            }
        ]
    })(props);
}
function AiOutlineRadiusUpright(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M368 128h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-2 696h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm522-174h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 174h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM192 128h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 174h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 174h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 174h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 174h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm348 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm174 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-48-696H484c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h182c87.3 0 158 70.7 158 158v182c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V358c0-127-103-230-230-230z"
                }
            }
        ]
    })(props);
}
function AiOutlineRead(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M928 161H699.2c-49.1 0-97.1 14.1-138.4 40.7L512 233l-48.8-31.3A255.2 255.2 0 0 0 324.8 161H96c-17.7 0-32 14.3-32 32v568c0 17.7 14.3 32 32 32h228.8c49.1 0 97.1 14.1 138.4 40.7l44.4 28.6c1.3.8 2.8 1.3 4.3 1.3s3-.4 4.3-1.3l44.4-28.6C602 807.1 650.1 793 699.2 793H928c17.7 0 32-14.3 32-32V193c0-17.7-14.3-32-32-32zM324.8 721H136V233h188.8c35.4 0 69.8 10.1 99.5 29.2l48.8 31.3 6.9 4.5v462c-47.6-25.6-100.8-39-155.2-39zm563.2 0H699.2c-54.4 0-107.6 13.4-155.2 39V298l6.9-4.5 48.8-31.3c29.7-19.1 64.1-29.2 99.5-29.2H888v488zM396.9 361H211.1c-3.9 0-7.1 3.4-7.1 7.5v45c0 4.1 3.2 7.5 7.1 7.5h185.7c3.9 0 7.1-3.4 7.1-7.5v-45c.1-4.1-3.1-7.5-7-7.5zm223.1 7.5v45c0 4.1 3.2 7.5 7.1 7.5h185.7c3.9 0 7.1-3.4 7.1-7.5v-45c0-4.1-3.2-7.5-7.1-7.5H627.1c-3.9 0-7.1 3.4-7.1 7.5zM396.9 501H211.1c-3.9 0-7.1 3.4-7.1 7.5v45c0 4.1 3.2 7.5 7.1 7.5h185.7c3.9 0 7.1-3.4 7.1-7.5v-45c.1-4.1-3.1-7.5-7-7.5zm416 0H627.1c-3.9 0-7.1 3.4-7.1 7.5v45c0 4.1 3.2 7.5 7.1 7.5h185.7c3.9 0 7.1-3.4 7.1-7.5v-45c.1-4.1-3.1-7.5-7-7.5z"
                }
            }
        ]
    })(props);
}
function AiOutlineReconciliation(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M676 565c-50.8 0-92 41.2-92 92s41.2 92 92 92 92-41.2 92-92-41.2-92-92-92zm0 126c-18.8 0-34-15.2-34-34s15.2-34 34-34 34 15.2 34 34-15.2 34-34 34zm204-523H668c0-30.9-25.1-56-56-56h-80c-30.9 0-56 25.1-56 56H264c-17.7 0-32 14.3-32 32v200h-88c-17.7 0-32 14.3-32 32v448c0 17.7 14.3 32 32 32h336c17.7 0 32-14.3 32-32v-16h368c17.7 0 32-14.3 32-32V200c0-17.7-14.3-32-32-32zm-412 64h72v-56h64v56h72v48H468v-48zm-20 616H176V616h272v232zm0-296H176v-88h272v88zm392 240H512V432c0-17.7-14.3-32-32-32H304V240h100v104h336V240h100v552zM704 408v96c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8v-96c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8zM592 512h48c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8z"
                }
            }
        ]
    })(props);
}
function AiOutlineRedEnvelope(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M440.6 462.6a8.38 8.38 0 0 0-7.5-4.6h-48.8c-1.3 0-2.6.4-3.9 1a8.4 8.4 0 0 0-3.4 11.4l87.4 161.1H419c-4.6 0-8.4 3.8-8.4 8.4V665c0 4.6 3.8 8.4 8.4 8.4h63V702h-63c-4.6 0-8.4 3.8-8.4 8.4v25.1c0 4.6 3.8 8.4 8.4 8.4h63v49.9c0 4.6 3.8 8.4 8.4 8.4h43.7c4.6 0 8.4-3.8 8.4-8.4v-49.9h63.3c4.7 0 8.4-3.8 8.2-8.5v-25c0-4.6-3.8-8.4-8.4-8.4h-63.3v-28.6h63.3c4.6 0 8.4-3.8 8.4-8.4v-25.1c0-4.6-3.8-8.4-8.4-8.4h-45.9l87.2-161a8.45 8.45 0 0 0-7.4-12.4h-47.8c-3.1 0-6 1.8-7.5 4.6l-71.9 141.9-71.7-142zM832 64H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32zm-40 824H232V193.1l260.3 204.1c11.6 9.1 27.9 9.1 39.5 0L792 193.1V888zm0-751.3h-31.7L512 331.3 263.7 136.7H232v-.7h560v.7z"
                }
            }
        ]
    })(props);
}
function AiOutlineReddit(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M288 568a56 56 0 1 0 112 0 56 56 0 1 0-112 0zm338.7 119.7c-23.1 18.2-68.9 37.8-114.7 37.8s-91.6-19.6-114.7-37.8c-14.4-11.3-35.3-8.9-46.7 5.5s-8.9 35.3 5.5 46.7C396.3 771.6 457.5 792 512 792s115.7-20.4 155.9-52.1a33.25 33.25 0 1 0-41.2-52.2zM960 456c0-61.9-50.1-112-112-112-42.1 0-78.7 23.2-97.9 57.6-57.6-31.5-127.7-51.8-204.1-56.5L612.9 195l127.9 36.9c11.5 32.6 42.6 56.1 79.2 56.1 46.4 0 84-37.6 84-84s-37.6-84-84-84c-32 0-59.8 17.9-74 44.2L603.5 123a33.2 33.2 0 0 0-39.6 18.4l-90.8 203.9c-74.5 5.2-142.9 25.4-199.2 56.2A111.94 111.94 0 0 0 176 344c-61.9 0-112 50.1-112 112 0 45.8 27.5 85.1 66.8 102.5-7.1 21-10.8 43-10.8 65.5 0 154.6 175.5 280 392 280s392-125.4 392-280c0-22.6-3.8-44.5-10.8-65.5C932.5 541.1 960 501.8 960 456zM820 172.5a31.5 31.5 0 1 1 0 63 31.5 31.5 0 0 1 0-63zM120 456c0-30.9 25.1-56 56-56a56 56 0 0 1 50.6 32.1c-29.3 22.2-53.5 47.8-71.5 75.9a56.23 56.23 0 0 1-35.1-52zm392 381.5c-179.8 0-325.5-95.6-325.5-213.5S332.2 410.5 512 410.5 837.5 506.1 837.5 624 691.8 837.5 512 837.5zM868.8 508c-17.9-28.1-42.2-53.7-71.5-75.9 9-18.9 28.3-32.1 50.6-32.1 30.9 0 56 25.1 56 56 .1 23.5-14.5 43.7-35.1 52zM624 568a56 56 0 1 0 112 0 56 56 0 1 0-112 0z"
                }
            }
        ]
    })(props);
}
function AiOutlineRedo(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M758.2 839.1C851.8 765.9 912 651.9 912 523.9 912 303 733.5 124.3 512.6 124 291.4 123.7 112 302.8 112 523.9c0 125.2 57.5 236.9 147.6 310.2 3.5 2.8 8.6 2.2 11.4-1.3l39.4-50.5c2.7-3.4 2.1-8.3-1.2-11.1-8.1-6.6-15.9-13.7-23.4-21.2a318.64 318.64 0 0 1-68.6-101.7C200.4 609 192 567.1 192 523.9s8.4-85.1 25.1-124.5c16.1-38.1 39.2-72.3 68.6-101.7 29.4-29.4 63.6-52.5 101.7-68.6C426.9 212.4 468.8 204 512 204s85.1 8.4 124.5 25.1c38.1 16.1 72.3 39.2 101.7 68.6 29.4 29.4 52.5 63.6 68.6 101.7 16.7 39.4 25.1 81.3 25.1 124.5s-8.4 85.1-25.1 124.5a318.64 318.64 0 0 1-68.6 101.7c-9.3 9.3-19.1 18-29.3 26L668.2 724a8 8 0 0 0-14.1 3l-39.6 162.2c-1.2 5 2.6 9.9 7.7 9.9l167 .8c6.7 0 10.5-7.7 6.3-12.9l-37.3-47.9z"
                }
            }
        ]
    })(props);
}
function AiOutlineReload(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M909.1 209.3l-56.4 44.1C775.8 155.1 656.2 92 521.9 92 290 92 102.3 279.5 102 511.5 101.7 743.7 289.8 932 521.9 932c181.3 0 335.8-115 394.6-276.1 1.5-4.2-.7-8.9-4.9-10.3l-56.7-19.5a8 8 0 0 0-10.1 4.8c-1.8 5-3.8 10-5.9 14.9-17.3 41-42.1 77.8-73.7 109.4A344.77 344.77 0 0 1 655.9 829c-42.3 17.9-87.4 27-133.8 27-46.5 0-91.5-9.1-133.8-27A341.5 341.5 0 0 1 279 755.2a342.16 342.16 0 0 1-73.7-109.4c-17.9-42.4-27-87.4-27-133.9s9.1-91.5 27-133.9c17.3-41 42.1-77.8 73.7-109.4 31.6-31.6 68.4-56.4 109.3-73.8 42.3-17.9 87.4-27 133.8-27 46.5 0 91.5 9.1 133.8 27a341.5 341.5 0 0 1 109.3 73.8c9.9 9.9 19.2 20.4 27.8 31.4l-60.2 47a8 8 0 0 0 3 14.1l175.6 43c5 1.2 9.9-2.6 9.9-7.7l.8-180.9c-.1-6.6-7.8-10.3-13-6.2z"
                }
            }
        ]
    })(props);
}
function AiOutlineRest(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "defs",
                "attr": {},
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M508 704c79.5 0 144-64.5 144-144s-64.5-144-144-144-144 64.5-144 144 64.5 144 144 144zm0-224c44.2 0 80 35.8 80 80s-35.8 80-80 80-80-35.8-80-80 35.8-80 80-80z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M832 256h-28.1l-35.7-120.9c-4-13.7-16.5-23.1-30.7-23.1h-451c-14.3 0-26.8 9.4-30.7 23.1L220.1 256H192c-17.7 0-32 14.3-32 32v28c0 4.4 3.6 8 8 8h45.8l47.7 558.7a32 32 0 0 0 31.9 29.3h429.2a32 32 0 0 0 31.9-29.3L802.2 324H856c4.4 0 8-3.6 8-8v-28c0-17.7-14.3-32-32-32zm-518.6-76h397.2l22.4 76H291l22.4-76zm376.2 664H326.4L282 324h451.9l-44.3 520z"
                }
            }
        ]
    })(props);
}
function AiOutlineRetweet(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M136 552h63.6c4.4 0 8-3.6 8-8V288.7h528.6v72.6c0 1.9.6 3.7 1.8 5.2a8.3 8.3 0 0 0 11.7 1.4L893 255.4c4.3-5 3.6-10.3 0-13.2L749.7 129.8a8.22 8.22 0 0 0-5.2-1.8c-4.6 0-8.4 3.8-8.4 8.4V209H199.7c-39.5 0-71.7 32.2-71.7 71.8V544c0 4.4 3.6 8 8 8zm752-80h-63.6c-4.4 0-8 3.6-8 8v255.3H287.8v-72.6c0-1.9-.6-3.7-1.8-5.2a8.3 8.3 0 0 0-11.7-1.4L131 768.6c-4.3 5-3.6 10.3 0 13.2l143.3 112.4c1.5 1.2 3.3 1.8 5.2 1.8 4.6 0 8.4-3.8 8.4-8.4V815h536.6c39.5 0 71.7-32.2 71.7-71.8V480c-.2-4.4-3.8-8-8.2-8z"
                }
            }
        ]
    })(props);
}
function AiOutlineRightCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M666.7 505.5l-246-178A8 8 0 0 0 408 334v46.9c0 10.2 4.9 19.9 13.2 25.9L566.6 512 421.2 617.2c-8.3 6-13.2 15.6-13.2 25.9V690c0 6.5 7.4 10.3 12.7 6.5l246-178c4.4-3.2 4.4-9.8 0-13z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z"
                }
            }
        ]
    })(props);
}
function AiOutlineRightSquare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M412.7 696.5l246-178c4.4-3.2 4.4-9.7 0-12.9l-246-178c-5.3-3.8-12.7 0-12.7 6.5V381c0 10.2 4.9 19.9 13.2 25.9L558.6 512 413.2 617.2c-8.3 6-13.2 15.6-13.2 25.9V690c0 6.5 7.4 10.3 12.7 6.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z"
                }
            }
        ]
    })(props);
}
function AiOutlineRight(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M765.7 486.8L314.9 134.7A7.97 7.97 0 0 0 302 141v77.3c0 4.9 2.3 9.6 6.1 12.6l360 281.1-360 281.1c-3.9 3-6.1 7.7-6.1 12.6V883c0 6.7 7.7 10.4 12.9 6.3l450.8-352.1a31.96 31.96 0 0 0 0-50.4z"
                }
            }
        ]
    })(props);
}
function AiOutlineRise(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M917 211.1l-199.2 24c-6.6.8-9.4 8.9-4.7 13.6l59.3 59.3-226 226-101.8-101.7c-6.3-6.3-16.4-6.2-22.6 0L100.3 754.1a8.03 8.03 0 0 0 0 11.3l45 45.2c3.1 3.1 8.2 3.1 11.3 0L433.3 534 535 635.7c6.3 6.2 16.4 6.2 22.6 0L829 364.5l59.3 59.3a8.01 8.01 0 0 0 13.6-4.7l24-199.2c.7-5.1-3.7-9.5-8.9-8.8z"
                }
            }
        ]
    })(props);
}
function AiOutlineRobot(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M300 328a60 60 0 1 0 120 0 60 60 0 1 0-120 0zM852 64H172c-17.7 0-32 14.3-32 32v660c0 17.7 14.3 32 32 32h680c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32zm-32 660H204V128h616v596zM604 328a60 60 0 1 0 120 0 60 60 0 1 0-120 0zm250.2 556H169.8c-16.5 0-29.8 14.3-29.8 32v36c0 4.4 3.3 8 7.4 8h729.1c4.1 0 7.4-3.6 7.4-8v-36c.1-17.7-13.2-32-29.7-32zM664 508H360c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h304c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8z"
                }
            }
        ]
    })(props);
}
function AiOutlineRocket(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M864 736c0-111.6-65.4-208-160-252.9V317.3c0-15.1-5.3-29.7-15.1-41.2L536.5 95.4C530.1 87.8 521 84 512 84s-18.1 3.8-24.5 11.4L335.1 276.1a63.97 63.97 0 0 0-15.1 41.2v165.8C225.4 528 160 624.4 160 736h156.5c-2.3 7.2-3.5 15-3.5 23.8 0 22.1 7.6 43.7 21.4 60.8a97.2 97.2 0 0 0 43.1 30.6c23.1 54 75.6 88.8 134.5 88.8 29.1 0 57.3-8.6 81.4-24.8 23.6-15.8 41.9-37.9 53-64a97 97 0 0 0 43.1-30.5 97.52 97.52 0 0 0 21.4-60.8c0-8.4-1.1-16.4-3.1-23.8H864zM762.3 621.4c9.4 14.6 17 30.3 22.5 46.6H700V558.7a211.6 211.6 0 0 1 62.3 62.7zM388 483.1V318.8l124-147 124 147V668H388V483.1zM239.2 668c5.5-16.3 13.1-32 22.5-46.6 16.3-25.2 37.5-46.5 62.3-62.7V668h-84.8zm388.9 116.2c-5.2 3-11.2 4.2-17.1 3.4l-19.5-2.4-2.8 19.4c-5.4 37.9-38.4 66.5-76.7 66.5-38.3 0-71.3-28.6-76.7-66.5l-2.8-19.5-19.5 2.5a27.7 27.7 0 0 1-17.1-3.5c-8.7-5-14.1-14.3-14.1-24.4 0-10.6 5.9-19.4 14.6-23.8h231.3c8.8 4.5 14.6 13.3 14.6 23.8-.1 10.2-5.5 19.6-14.2 24.5zM464 400a48 48 0 1 0 96 0 48 48 0 1 0-96 0z"
                }
            }
        ]
    })(props);
}
function AiOutlineRollback(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M793 242H366v-74c0-6.7-7.7-10.4-12.9-6.3l-142 112a8 8 0 0 0 0 12.6l142 112c5.2 4.1 12.9.4 12.9-6.3v-74h415v470H175c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h618c35.3 0 64-28.7 64-64V306c0-35.3-28.7-64-64-64z"
                }
            }
        ]
    })(props);
}
function AiOutlineRotateLeft(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "t": "1569683455503",
            "viewBox": "0 0 1024 1024",
            "version": "1.1"
        },
        "child": [
            {
                "tag": "defs",
                "attr": {},
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M672 418H144c-17.7 0-32 14.3-32 32v414c0 17.7 14.3 32 32 32h528c17.7 0 32-14.3 32-32V450c0-17.7-14.3-32-32-32z m-44 402H188V494h440v326z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M819.3 328.5c-78.8-100.7-196-153.6-314.6-154.2l-0.2-64c0-6.5-7.6-10.1-12.6-6.1l-128 101c-4 3.1-3.9 9.1 0 12.3L492 318.6c5.1 4 12.7 0.4 12.6-6.1v-63.9c12.9 0.1 25.9 0.9 38.8 2.5 42.1 5.2 82.1 18.2 119 38.7 38.1 21.2 71.2 49.7 98.4 84.3 27.1 34.7 46.7 73.7 58.1 115.8 11 40.7 14 82.7 8.9 124.8-0.7 5.4-1.4 10.8-2.4 16.1h74.9c14.8-103.6-11.3-213-81-302.3z"
                }
            }
        ]
    })(props);
}
function AiOutlineRotateRight(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "t": "1569683458761",
            "viewBox": "0 0 1024 1024",
            "version": "1.1"
        },
        "child": [
            {
                "tag": "defs",
                "attr": {},
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M480.5 251.2c13-1.6 25.9-2.4 38.8-2.5v63.9c0 6.5 7.5 10.1 12.6 6.1L660 217.6c4-3.2 4-9.2 0-12.3l-128-101c-5.1-4-12.6-0.4-12.6 6.1l-0.2 64c-118.6 0.5-235.8 53.4-314.6 154.2-69.6 89.2-95.7 198.6-81.1 302.4h74.9c-0.9-5.3-1.7-10.7-2.4-16.1-5.1-42.1-2.1-84.1 8.9-124.8 11.4-42.2 31-81.1 58.1-115.8 27.2-34.7 60.3-63.2 98.4-84.3 37-20.6 76.9-33.6 119.1-38.8z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M880 418H352c-17.7 0-32 14.3-32 32v414c0 17.7 14.3 32 32 32h528c17.7 0 32-14.3 32-32V450c0-17.7-14.3-32-32-32z m-44 402H396V494h440v326z"
                }
            }
        ]
    })(props);
}
function AiOutlineSafetyCertificate(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M866.9 169.9L527.1 54.1C523 52.7 517.5 52 512 52s-11 .7-15.1 2.1L157.1 169.9c-8.3 2.8-15.1 12.4-15.1 21.2v482.4c0 8.8 5.7 20.4 12.6 25.9L499.3 968c3.5 2.7 8 4.1 12.6 4.1s9.2-1.4 12.6-4.1l344.7-268.6c6.9-5.4 12.6-17 12.6-25.9V191.1c.2-8.8-6.6-18.3-14.9-21.2zM810 654.3L512 886.5 214 654.3V226.7l298-101.6 298 101.6v427.6zm-405.8-201c-3-4.1-7.8-6.6-13-6.6H336c-6.5 0-10.3 7.4-6.5 12.7l126.4 174a16.1 16.1 0 0 0 26 0l212.6-292.7c3.8-5.3 0-12.7-6.5-12.7h-55.2c-5.1 0-10 2.5-13 6.6L468.9 542.4l-64.7-89.1z"
                }
            }
        ]
    })(props);
}
function AiOutlineSafety(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M512 64L128 192v384c0 212.1 171.9 384 384 384s384-171.9 384-384V192L512 64zm312 512c0 172.3-139.7 312-312 312S200 748.3 200 576V246l312-110 312 110v330z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M378.4 475.1a35.91 35.91 0 0 0-50.9 0 35.91 35.91 0 0 0 0 50.9l129.4 129.4 2.1 2.1a33.98 33.98 0 0 0 48.1 0L730.6 434a33.98 33.98 0 0 0 0-48.1l-2.8-2.8a33.98 33.98 0 0 0-48.1 0L483 579.7 378.4 475.1z"
                }
            }
        ]
    })(props);
}
function AiOutlineSave(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M893.3 293.3L730.7 130.7c-7.5-7.5-16.7-13-26.7-16V112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V338.5c0-17-6.7-33.2-18.7-45.2zM384 184h256v104H384V184zm456 656H184V184h136v136c0 17.7 14.3 32 32 32h320c17.7 0 32-14.3 32-32V205.8l136 136V840zM512 442c-79.5 0-144 64.5-144 144s64.5 144 144 144 144-64.5 144-144-64.5-144-144-144zm0 224c-44.2 0-80-35.8-80-80s35.8-80 80-80 80 35.8 80 80-35.8 80-80 80z"
                }
            }
        ]
    })(props);
}
function AiOutlineScan(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M136 384h56c4.4 0 8-3.6 8-8V200h176c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H196c-37.6 0-68 30.4-68 68v180c0 4.4 3.6 8 8 8zm512-184h176v176c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V196c0-37.6-30.4-68-68-68H648c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zM376 824H200V648c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v180c0 37.6 30.4 68 68 68h180c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm512-184h-56c-4.4 0-8 3.6-8 8v176H648c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h180c37.6 0 68-30.4 68-68V648c0-4.4-3.6-8-8-8zm16-164H120c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8z"
                }
            }
        ]
    })(props);
}
function AiOutlineSchedule(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M928 224H768v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56H548v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56H328v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56H96c-17.7 0-32 14.3-32 32v576c0 17.7 14.3 32 32 32h832c17.7 0 32-14.3 32-32V256c0-17.7-14.3-32-32-32zm-40 568H136V296h120v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56h148v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56h148v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56h120v496zM416 496H232c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h184c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zm0 136H232c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h184c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zm308.2-177.4L620.6 598.3l-52.8-73.1c-3-4.2-7.8-6.6-12.9-6.6H500c-6.5 0-10.3 7.4-6.5 12.7l114.1 158.2a15.9 15.9 0 0 0 25.8 0l165-228.7c3.8-5.3 0-12.7-6.5-12.7H737c-5-.1-9.8 2.4-12.8 6.5z"
                }
            }
        ]
    })(props);
}
function AiOutlineScissor(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M567.1 512l318.5-319.3c5-5 1.5-13.7-5.6-13.7h-90.5c-2.1 0-4.2.8-5.6 2.3l-273.3 274-90.2-90.5c12.5-22.1 19.7-47.6 19.7-74.8 0-83.9-68.1-152-152-152s-152 68.1-152 152 68.1 152 152 152c27.7 0 53.6-7.4 75.9-20.3l90 90.3-90.1 90.3A151.04 151.04 0 0 0 288 582c-83.9 0-152 68.1-152 152s68.1 152 152 152 152-68.1 152-152c0-27.2-7.2-52.7-19.7-74.8l90.2-90.5 273.3 274c1.5 1.5 3.5 2.3 5.6 2.3H880c7.1 0 10.7-8.6 5.6-13.7L567.1 512zM288 370c-44.1 0-80-35.9-80-80s35.9-80 80-80 80 35.9 80 80-35.9 80-80 80zm0 444c-44.1 0-80-35.9-80-80s35.9-80 80-80 80 35.9 80 80-35.9 80-80 80z"
                }
            }
        ]
    })(props);
}
function AiOutlineSearch(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M909.6 854.5L649.9 594.8C690.2 542.7 712 479 712 412c0-80.2-31.3-155.4-87.9-212.1-56.6-56.7-132-87.9-212.1-87.9s-155.5 31.3-212.1 87.9C143.2 256.5 112 331.8 112 412c0 80.1 31.3 155.5 87.9 212.1C256.5 680.8 331.8 712 412 712c67 0 130.6-21.8 182.7-62l259.7 259.6a8.2 8.2 0 0 0 11.6 0l43.6-43.5a8.2 8.2 0 0 0 0-11.6zM570.4 570.4C528 612.7 471.8 636 412 636s-116-23.3-158.4-65.6C211.3 528 188 471.8 188 412s23.3-116.1 65.6-158.4C296 211.3 352.2 188 412 188s116.1 23.2 158.4 65.6S636 352.2 636 412s-23.3 116.1-65.6 158.4z"
                }
            }
        ]
    })(props);
}
function AiOutlineSecurityScan(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M866.9 169.9L527.1 54.1C523 52.7 517.5 52 512 52s-11 .7-15.1 2.1L157.1 169.9c-8.3 2.8-15.1 12.4-15.1 21.2v482.4c0 8.8 5.7 20.4 12.6 25.9L499.3 968c3.5 2.7 8 4.1 12.6 4.1s9.2-1.4 12.6-4.1l344.7-268.6c6.9-5.4 12.6-17 12.6-25.9V191.1c.2-8.8-6.6-18.3-14.9-21.2zM810 654.3L512 886.5 214 654.3V226.7l298-101.6 298 101.6v427.6zM402.9 528.8l-77.5 77.5a8.03 8.03 0 0 0 0 11.3l34 34c3.1 3.1 8.2 3.1 11.3 0l77.5-77.5c55.7 35.1 130.1 28.4 178.6-20.1 56.3-56.3 56.3-147.5 0-203.8-56.3-56.3-147.5-56.3-203.8 0-48.5 48.5-55.2 123-20.1 178.6zm65.4-133.3c31.3-31.3 82-31.3 113.2 0 31.3 31.3 31.3 82 0 113.2-31.3 31.3-82 31.3-113.2 0s-31.3-81.9 0-113.2z"
                }
            }
        ]
    })(props);
}
function AiOutlineSelect(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h360c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H184V184h656v320c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V144c0-17.7-14.3-32-32-32zM653.3 599.4l52.2-52.2a8.01 8.01 0 0 0-4.7-13.6l-179.4-21c-5.1-.6-9.5 3.7-8.9 8.9l21 179.4c.8 6.6 8.9 9.4 13.6 4.7l52.4-52.4 256.2 256.2c3.1 3.1 8.2 3.1 11.3 0l42.4-42.4c3.1-3.1 3.1-8.2 0-11.3L653.3 599.4z"
                }
            }
        ]
    })(props);
}
function AiOutlineSend(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "t": "1569683742680",
            "viewBox": "0 0 1024 1024",
            "version": "1.1"
        },
        "child": [
            {
                "tag": "defs",
                "attr": {},
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M931.4 498.9L94.9 79.5c-3.4-1.7-7.3-2.1-11-1.2-8.5 2.1-13.8 10.7-11.7 19.3l86.2 352.2c1.3 5.3 5.2 9.6 10.4 11.3l147.7 50.7-147.6 50.7c-5.2 1.8-9.1 6-10.3 11.3L72.2 926.5c-0.9 3.7-0.5 7.6 1.2 10.9 3.9 7.9 13.5 11.1 21.5 7.2l836.5-417c3.1-1.5 5.6-4.1 7.2-7.1 3.9-8 0.7-17.6-7.2-21.6zM170.8 826.3l50.3-205.6 295.2-101.3c2.3-0.8 4.2-2.6 5-5 1.4-4.2-0.8-8.7-5-10.2L221.1 403 171 198.2l628 314.9-628.2 313.2z"
                }
            }
        ]
    })(props);
}
function AiOutlineSetting(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M924.8 625.7l-65.5-56c3.1-19 4.7-38.4 4.7-57.8s-1.6-38.8-4.7-57.8l65.5-56a32.03 32.03 0 0 0 9.3-35.2l-.9-2.6a443.74 443.74 0 0 0-79.7-137.9l-1.8-2.1a32.12 32.12 0 0 0-35.1-9.5l-81.3 28.9c-30-24.6-63.5-44-99.7-57.6l-15.7-85a32.05 32.05 0 0 0-25.8-25.7l-2.7-.5c-52.1-9.4-106.9-9.4-159 0l-2.7.5a32.05 32.05 0 0 0-25.8 25.7l-15.8 85.4a351.86 351.86 0 0 0-99 57.4l-81.9-29.1a32 32 0 0 0-35.1 9.5l-1.8 2.1a446.02 446.02 0 0 0-79.7 137.9l-.9 2.6c-4.5 12.5-.8 26.5 9.3 35.2l66.3 56.6c-3.1 18.8-4.6 38-4.6 57.1 0 19.2 1.5 38.4 4.6 57.1L99 625.5a32.03 32.03 0 0 0-9.3 35.2l.9 2.6c18.1 50.4 44.9 96.9 79.7 137.9l1.8 2.1a32.12 32.12 0 0 0 35.1 9.5l81.9-29.1c29.8 24.5 63.1 43.9 99 57.4l15.8 85.4a32.05 32.05 0 0 0 25.8 25.7l2.7.5a449.4 449.4 0 0 0 159 0l2.7-.5a32.05 32.05 0 0 0 25.8-25.7l15.7-85a350 350 0 0 0 99.7-57.6l81.3 28.9a32 32 0 0 0 35.1-9.5l1.8-2.1c34.8-41.1 61.6-87.5 79.7-137.9l.9-2.6c4.5-12.3.8-26.3-9.3-35zM788.3 465.9c2.5 15.1 3.8 30.6 3.8 46.1s-1.3 31-3.8 46.1l-6.6 40.1 74.7 63.9a370.03 370.03 0 0 1-42.6 73.6L721 702.8l-31.4 25.8c-23.9 19.6-50.5 35-79.3 45.8l-38.1 14.3-17.9 97a377.5 377.5 0 0 1-85 0l-17.9-97.2-37.8-14.5c-28.5-10.8-55-26.2-78.7-45.7l-31.4-25.9-93.4 33.2c-17-22.9-31.2-47.6-42.6-73.6l75.5-64.5-6.5-40c-2.4-14.9-3.7-30.3-3.7-45.5 0-15.3 1.2-30.6 3.7-45.5l6.5-40-75.5-64.5c11.3-26.1 25.6-50.7 42.6-73.6l93.4 33.2 31.4-25.9c23.7-19.5 50.2-34.9 78.7-45.7l37.9-14.3 17.9-97.2c28.1-3.2 56.8-3.2 85 0l17.9 97 38.1 14.3c28.7 10.8 55.4 26.2 79.3 45.8l31.4 25.8 92.8-32.9c17 22.9 31.2 47.6 42.6 73.6L781.8 426l6.5 39.9zM512 326c-97.2 0-176 78.8-176 176s78.8 176 176 176 176-78.8 176-176-78.8-176-176-176zm79.2 255.2A111.6 111.6 0 0 1 512 614c-29.9 0-58-11.7-79.2-32.8A111.6 111.6 0 0 1 400 502c0-29.9 11.7-58 32.8-79.2C454 401.6 482.1 390 512 390c29.9 0 58 11.6 79.2 32.8A111.6 111.6 0 0 1 624 502c0 29.9-11.7 58-32.8 79.2z"
                }
            }
        ]
    })(props);
}
function AiOutlineShake(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M324 666a48 48 0 1 0 96 0 48 48 0 1 0-96 0zm616.7-309.6L667.6 83.2C655.2 70.9 638.7 64 621.1 64s-34.1 6.8-46.5 19.2L83.3 574.5a65.85 65.85 0 0 0 0 93.1l273.2 273.2c12.3 12.3 28.9 19.2 46.5 19.2s34.1-6.8 46.5-19.2l491.3-491.3c25.6-25.7 25.6-67.5-.1-93.1zM403 880.1L143.9 621l477.2-477.2 259 259.2L403 880.1zM152.8 373.7a7.9 7.9 0 0 0 11.2 0L373.7 164a7.9 7.9 0 0 0 0-11.2l-38.4-38.4a7.9 7.9 0 0 0-11.2 0L114.3 323.9a7.9 7.9 0 0 0 0 11.2l38.5 38.6zm718.6 276.6a7.9 7.9 0 0 0-11.2 0L650.3 860.1a7.9 7.9 0 0 0 0 11.2l38.4 38.4a7.9 7.9 0 0 0 11.2 0L909.7 700a7.9 7.9 0 0 0 0-11.2l-38.3-38.5z"
                }
            }
        ]
    })(props);
}
function AiOutlineShareAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M752 664c-28.5 0-54.8 10-75.4 26.7L469.4 540.8a160.68 160.68 0 0 0 0-57.6l207.2-149.9C697.2 350 723.5 360 752 360c66.2 0 120-53.8 120-120s-53.8-120-120-120-120 53.8-120 120c0 11.6 1.6 22.7 4.7 33.3L439.9 415.8C410.7 377.1 364.3 352 312 352c-88.4 0-160 71.6-160 160s71.6 160 160 160c52.3 0 98.7-25.1 127.9-63.8l196.8 142.5c-3.1 10.6-4.7 21.8-4.7 33.3 0 66.2 53.8 120 120 120s120-53.8 120-120-53.8-120-120-120zm0-476c28.7 0 52 23.3 52 52s-23.3 52-52 52-52-23.3-52-52 23.3-52 52-52zM312 600c-48.5 0-88-39.5-88-88s39.5-88 88-88 88 39.5 88 88-39.5 88-88 88zm440 236c-28.7 0-52-23.3-52-52s23.3-52 52-52 52 23.3 52 52-23.3 52-52 52z"
                }
            }
        ]
    })(props);
}
function AiOutlineShop(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M882 272.1V144c0-17.7-14.3-32-32-32H174c-17.7 0-32 14.3-32 32v128.1c-16.7 1-30 14.9-30 31.9v131.7a177 177 0 0 0 14.4 70.4c4.3 10.2 9.6 19.8 15.6 28.9v345c0 17.6 14.3 32 32 32h676c17.7 0 32-14.3 32-32V535a175 175 0 0 0 15.6-28.9c9.5-22.3 14.4-46 14.4-70.4V304c0-17-13.3-30.9-30-31.9zM214 184h596v88H214v-88zm362 656.1H448V736h128v104.1zm234 0H640V704c0-17.7-14.3-32-32-32H416c-17.7 0-32 14.3-32 32v136.1H214V597.9c2.9 1.4 5.9 2.8 9 4 22.3 9.4 46 14.1 70.4 14.1s48-4.7 70.4-14.1c13.8-5.8 26.8-13.2 38.7-22.1.2-.1.4-.1.6 0a180.4 180.4 0 0 0 38.7 22.1c22.3 9.4 46 14.1 70.4 14.1 24.4 0 48-4.7 70.4-14.1 13.8-5.8 26.8-13.2 38.7-22.1.2-.1.4-.1.6 0a180.4 180.4 0 0 0 38.7 22.1c22.3 9.4 46 14.1 70.4 14.1 24.4 0 48-4.7 70.4-14.1 3-1.3 6-2.6 9-4v242.2zm30-404.4c0 59.8-49 108.3-109.3 108.3-40.8 0-76.4-22.1-95.2-54.9-2.9-5-8.1-8.1-13.9-8.1h-.6c-5.7 0-11 3.1-13.9 8.1A109.24 109.24 0 0 1 512 544c-40.7 0-76.2-22-95-54.7-3-5.1-8.4-8.3-14.3-8.3s-11.4 3.2-14.3 8.3a109.63 109.63 0 0 1-95.1 54.7C233 544 184 495.5 184 435.7v-91.2c0-.3.2-.5.5-.5h655c.3 0 .5.2.5.5v91.2z"
                }
            }
        ]
    })(props);
}
function AiOutlineShoppingCart(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M922.9 701.9H327.4l29.9-60.9 496.8-.9c16.8 0 31.2-12 34.2-28.6l68.8-385.1c1.8-10.1-.9-20.5-7.5-28.4a34.99 34.99 0 0 0-26.6-12.5l-632-2.1-5.4-25.4c-3.4-16.2-18-28-34.6-28H96.5a35.3 35.3 0 1 0 0 70.6h125.9L246 312.8l58.1 281.3-74.8 122.1a34.96 34.96 0 0 0-3 36.8c6 11.9 18.1 19.4 31.5 19.4h62.8a102.43 102.43 0 0 0-20.6 61.7c0 56.6 46 102.6 102.6 102.6s102.6-46 102.6-102.6c0-22.3-7.4-44-20.6-61.7h161.1a102.43 102.43 0 0 0-20.6 61.7c0 56.6 46 102.6 102.6 102.6s102.6-46 102.6-102.6c0-22.3-7.4-44-20.6-61.7H923c19.4 0 35.3-15.8 35.3-35.3a35.42 35.42 0 0 0-35.4-35.2zM305.7 253l575.8 1.9-56.4 315.8-452.3.8L305.7 253zm96.9 612.7c-17.4 0-31.6-14.2-31.6-31.6 0-17.4 14.2-31.6 31.6-31.6s31.6 14.2 31.6 31.6a31.6 31.6 0 0 1-31.6 31.6zm325.1 0c-17.4 0-31.6-14.2-31.6-31.6 0-17.4 14.2-31.6 31.6-31.6s31.6 14.2 31.6 31.6a31.6 31.6 0 0 1-31.6 31.6z"
                }
            }
        ]
    })(props);
}
function AiOutlineShopping(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M832 312H696v-16c0-101.6-82.4-184-184-184s-184 82.4-184 184v16H192c-17.7 0-32 14.3-32 32v536c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V344c0-17.7-14.3-32-32-32zm-432-16c0-61.9 50.1-112 112-112s112 50.1 112 112v16H400v-16zm392 544H232V384h96v88c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-88h224v88c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-88h96v456z"
                }
            }
        ]
    })(props);
}
function AiOutlineShrink(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M881.7 187.4l-45.1-45.1a8.03 8.03 0 0 0-11.3 0L667.8 299.9l-54.7-54.7a7.94 7.94 0 0 0-13.5 4.7L576.1 439c-.6 5.2 3.7 9.5 8.9 8.9l189.2-23.5c6.6-.8 9.3-8.8 4.7-13.5l-54.7-54.7 157.6-157.6c3-3 3-8.1-.1-11.2zM439 576.1l-189.2 23.5c-6.6.8-9.3 8.9-4.7 13.5l54.7 54.7-157.5 157.5a8.03 8.03 0 0 0 0 11.3l45.1 45.1c3.1 3.1 8.2 3.1 11.3 0l157.6-157.6 54.7 54.7a7.94 7.94 0 0 0 13.5-4.7L447.9 585a7.9 7.9 0 0 0-8.9-8.9z"
                }
            }
        ]
    })(props);
}
function AiOutlineSisternode(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "t": "1569683586275",
            "viewBox": "0 0 1024 1024",
            "version": "1.1"
        },
        "child": [
            {
                "tag": "defs",
                "attr": {},
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M672 432c-120.3 0-219.9 88.5-237.3 204H320c-15.5 0-28-12.5-28-28V244h291c14.2 35.2 48.7 60 89 60 53 0 96-43 96-96s-43-96-96-96c-40.3 0-74.8 24.8-89 60H112v72h108v364c0 55.2 44.8 100 100 100h114.7c17.4 115.5 117 204 237.3 204 132.5 0 240-107.5 240-240S804.5 432 672 432z m128 266c0 4.4-3.6 8-8 8h-86v86c0 4.4-3.6 8-8 8h-52c-4.4 0-8-3.6-8-8v-86h-86c-4.4 0-8-3.6-8-8v-52c0-4.4 3.6-8 8-8h86v-86c0-4.4 3.6-8 8-8h52c4.4 0 8 3.6 8 8v86h86c4.4 0 8 3.6 8 8v52z"
                }
            }
        ]
    })(props);
}
function AiOutlineSketch(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M925.6 405.1l-203-253.7a6.5 6.5 0 0 0-5-2.4H306.4c-1.9 0-3.8.9-5 2.4l-203 253.7a6.5 6.5 0 0 0 .2 8.3l408.6 459.5c1.2 1.4 3 2.1 4.8 2.1 1.8 0 3.5-.8 4.8-2.1l408.6-459.5a6.5 6.5 0 0 0 .2-8.3zM645.2 206.4l34.4 133.9-132.5-133.9h98.1zm8.2 178.5H370.6L512 242l141.4 142.9zM378.8 206.4h98.1L344.3 340.3l34.5-133.9zm-53.4 7l-44.1 171.5h-93.1l137.2-171.5zM194.6 434.9H289l125.8 247.7-220.2-247.7zM512 763.4L345.1 434.9h333.7L512 763.4zm97.1-80.8L735 434.9h94.4L609.1 682.6zm133.6-297.7l-44.1-171.5 137.2 171.5h-93.1z"
                }
            }
        ]
    })(props);
}
function AiOutlineSkin(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M870 126H663.8c-17.4 0-32.9 11.9-37 29.3C614.3 208.1 567 246 512 246s-102.3-37.9-114.8-90.7a37.93 37.93 0 0 0-37-29.3H154a44 44 0 0 0-44 44v252a44 44 0 0 0 44 44h75v388a44 44 0 0 0 44 44h478a44 44 0 0 0 44-44V466h75a44 44 0 0 0 44-44V170a44 44 0 0 0-44-44zm-28 268H723v432H301V394H182V198h153.3c28.2 71.2 97.5 120 176.7 120s148.5-48.8 176.7-120H842v196z"
                }
            }
        ]
    })(props);
}
function AiOutlineSkype(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M883.7 578.6c4.1-22.5 6.3-45.5 6.3-68.5 0-51-10-100.5-29.7-147-19-45-46.3-85.4-81-120.1a375.79 375.79 0 0 0-120.1-80.9c-46.6-19.7-96-29.7-147-29.7-24 0-48.1 2.3-71.5 6.8A225.1 225.1 0 0 0 335.6 113c-59.7 0-115.9 23.3-158.1 65.5A222.25 222.25 0 0 0 112 336.6c0 38 9.8 75.4 28.1 108.4-3.7 21.4-5.7 43.3-5.7 65.1 0 51 10 100.5 29.7 147 19 45 46.2 85.4 80.9 120.1 34.7 34.7 75.1 61.9 120.1 80.9 46.6 19.7 96 29.7 147 29.7 22.2 0 44.4-2 66.2-5.9 33.5 18.9 71.3 29 110 29 59.7 0 115.9-23.2 158.1-65.5 42.3-42.2 65.5-98.4 65.5-158.1.1-38-9.7-75.5-28.2-108.7zm-88.1 216C766.9 823.4 729 839 688.4 839c-26.1 0-51.8-6.8-74.6-19.7l-22.5-12.7-25.5 4.5c-17.8 3.2-35.8 4.8-53.6 4.8-41.4 0-81.3-8.1-119.1-24.1-36.3-15.3-69-37.3-97.2-65.5a304.29 304.29 0 0 1-65.5-97.1c-16-37.7-24-77.6-24-119 0-17.4 1.6-35.2 4.6-52.8l4.4-25.1L203 410a151.02 151.02 0 0 1-19.1-73.4c0-40.6 15.7-78.5 44.4-107.2C257.1 200.7 295 185 335.6 185a153 153 0 0 1 71.4 17.9l22.4 11.8 24.8-4.8c18.9-3.6 38.4-5.5 58-5.5 41.4 0 81.3 8.1 119 24 36.5 15.4 69.1 37.4 97.2 65.5 28.2 28.1 50.2 60.8 65.6 97.2 16 37.7 24 77.6 24 119 0 18.4-1.7 37-5.1 55.5l-4.7 25.5 12.6 22.6c12.6 22.5 19.2 48 19.2 73.7 0 40.7-15.7 78.5-44.4 107.2zM583.4 466.2L495 446.6c-33.6-7.7-72.3-17.8-72.3-49.5s27.1-53.9 76.1-53.9c98.7 0 89.7 67.8 138.7 67.8 25.8 0 48.4-15.2 48.4-41.2 0-60.8-97.4-106.5-180-106.5-89.7 0-185.2 38.1-185.2 139.5 0 48.8 17.4 100.8 113.6 124.9l119.4 29.8c36.1 8.9 45.2 29.2 45.2 47.6 0 30.5-30.3 60.3-85.2 60.3-107.2 0-92.3-82.5-149.7-82.5-25.8 0-44.5 17.8-44.5 43.1 0 49.4 60 115.4 194.2 115.4 127.7 0 191-61.5 191-144 0-53.1-24.5-109.6-121.3-131.2z"
                }
            }
        ]
    })(props);
}
function AiOutlineSlackSquare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM529 311.4c0-27.8 22.5-50.4 50.3-50.4 27.8 0 50.3 22.6 50.3 50.4v134.4c0 27.8-22.5 50.4-50.3 50.4-27.8 0-50.3-22.6-50.3-50.4V311.4zM361.5 580.2c0 27.8-22.5 50.4-50.3 50.4-13.3 0-26.1-5.3-35.6-14.8-9.4-9.5-14.7-22.3-14.7-35.6 0-27.8 22.5-50.4 50.3-50.4h50.3v50.4zm134 134.4c0 27.8-22.5 50.4-50.3 50.4-27.8 0-50.3-22.6-50.3-50.4V580.2c0-27.8 22.5-50.4 50.3-50.4 13.3 0 26.1 5.3 35.6 14.8s14.7 22.3 14.7 35.6v134.4zm-50.2-218.4h-134c-27.8 0-50.3-22.6-50.3-50.4 0-27.8 22.5-50.4 50.3-50.4h134c27.8 0 50.3 22.6 50.3 50.4-.1 27.9-22.6 50.4-50.3 50.4zm0-134.4c-13.3 0-26.1-5.3-35.6-14.8S395 324.8 395 311.4c0-27.8 22.5-50.4 50.3-50.4 27.8 0 50.3 22.6 50.3 50.4v50.4h-50.3zm134 403.2c-27.8 0-50.3-22.6-50.3-50.4v-50.4h50.3c27.8 0 50.3 22.6 50.3 50.4 0 27.8-22.5 50.4-50.3 50.4zm134-134.4h-134c-13.3 0-26.1-5.3-35.6-14.8-9.4-9.5-14.7-22.3-14.7-35.6 0-27.8 22.5-50.4 50.3-50.4h134c27.8 0 50.3 22.6 50.3 50.4 0 27.8-22.5 50.4-50.3 50.4zm0-134.4H663v-50.4c0-27.8 22.5-50.4 50.3-50.4s50.3 22.6 50.3 50.4c0 27.8-22.5 50.4-50.3 50.4z"
                }
            }
        ]
    })(props);
}
function AiOutlineSlack(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M409.4 128c-42.4 0-76.7 34.4-76.7 76.8 0 20.3 8.1 39.9 22.4 54.3 14.4 14.4 33.9 22.5 54.3 22.5h76.7v-76.8c0-42.3-34.3-76.7-76.7-76.8zm0 204.8H204.7c-42.4 0-76.7 34.4-76.7 76.8s34.4 76.8 76.7 76.8h204.6c42.4 0 76.7-34.4 76.7-76.8.1-42.4-34.3-76.8-76.6-76.8zM614 486.4c42.4 0 76.8-34.4 76.7-76.8V204.8c0-42.4-34.3-76.8-76.7-76.8-42.4 0-76.7 34.4-76.7 76.8v204.8c0 42.5 34.3 76.8 76.7 76.8zm281.4-76.8c0-42.4-34.4-76.8-76.7-76.8S742 367.2 742 409.6v76.8h76.7c42.3 0 76.7-34.4 76.7-76.8zm-76.8 128H614c-42.4 0-76.7 34.4-76.7 76.8 0 20.3 8.1 39.9 22.4 54.3 14.4 14.4 33.9 22.5 54.3 22.5h204.6c42.4 0 76.7-34.4 76.7-76.8.1-42.4-34.3-76.7-76.7-76.8zM614 742.4h-76.7v76.8c0 42.4 34.4 76.8 76.7 76.8 42.4 0 76.8-34.4 76.7-76.8.1-42.4-34.3-76.7-76.7-76.8zM409.4 537.6c-42.4 0-76.7 34.4-76.7 76.8v204.8c0 42.4 34.4 76.8 76.7 76.8 42.4 0 76.8-34.4 76.7-76.8V614.4c0-20.3-8.1-39.9-22.4-54.3-14.4-14.4-34-22.5-54.3-22.5zM128 614.4c0 20.3 8.1 39.9 22.4 54.3 14.4 14.4 33.9 22.5 54.3 22.5 42.4 0 76.8-34.4 76.7-76.8v-76.8h-76.7c-42.3 0-76.7 34.4-76.7 76.8z"
                }
            }
        ]
    })(props);
}
function AiOutlineSliders(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M320 224h-66v-56c0-4.4-3.6-8-8-8h-52c-4.4 0-8 3.6-8 8v56h-66c-4.4 0-8 3.6-8 8v560c0 4.4 3.6 8 8 8h66v56c0 4.4 3.6 8 8 8h52c4.4 0 8-3.6 8-8v-56h66c4.4 0 8-3.6 8-8V232c0-4.4-3.6-8-8-8zm-60 508h-80V292h80v440zm644-436h-66v-96c0-4.4-3.6-8-8-8h-52c-4.4 0-8 3.6-8 8v96h-66c-4.4 0-8 3.6-8 8v416c0 4.4 3.6 8 8 8h66v96c0 4.4 3.6 8 8 8h52c4.4 0 8-3.6 8-8v-96h66c4.4 0 8-3.6 8-8V304c0-4.4-3.6-8-8-8zm-60 364h-80V364h80v296zM612 404h-66V232c0-4.4-3.6-8-8-8h-52c-4.4 0-8 3.6-8 8v172h-66c-4.4 0-8 3.6-8 8v200c0 4.4 3.6 8 8 8h66v172c0 4.4 3.6 8 8 8h52c4.4 0 8-3.6 8-8V620h66c4.4 0 8-3.6 8-8V412c0-4.4-3.6-8-8-8zm-60 145a3 3 0 0 1-3 3h-74a3 3 0 0 1-3-3v-74a3 3 0 0 1 3-3h74a3 3 0 0 1 3 3v74z"
                }
            }
        ]
    })(props);
}
function AiOutlineSmallDash(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M112 476h72v72h-72zm182 0h72v72h-72zm364 0h72v72h-72zm182 0h72v72h-72zm-364 0h72v72h-72z"
                }
            }
        ]
    })(props);
}
function AiOutlineSmile(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M288 421a48 48 0 1 0 96 0 48 48 0 1 0-96 0zm352 0a48 48 0 1 0 96 0 48 48 0 1 0-96 0zM512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm263 711c-34.2 34.2-74 61-118.3 79.8C611 874.2 562.3 884 512 884c-50.3 0-99-9.8-144.8-29.2A370.4 370.4 0 0 1 248.9 775c-34.2-34.2-61-74-79.8-118.3C149.8 611 140 562.3 140 512s9.8-99 29.2-144.8A370.4 370.4 0 0 1 249 248.9c34.2-34.2 74-61 118.3-79.8C413 149.8 461.7 140 512 140c50.3 0 99 9.8 144.8 29.2A370.4 370.4 0 0 1 775.1 249c34.2 34.2 61 74 79.8 118.3C874.2 413 884 461.7 884 512s-9.8 99-29.2 144.8A368.89 368.89 0 0 1 775 775zM664 533h-48.1c-4.2 0-7.8 3.2-8.1 7.4C604 589.9 562.5 629 512 629s-92.1-39.1-95.8-88.6c-.3-4.2-3.9-7.4-8.1-7.4H360a8 8 0 0 0-8 8.4c4.4 84.3 74.5 151.6 160 151.6s155.6-67.3 160-151.6a8 8 0 0 0-8-8.4z"
                }
            }
        ]
    })(props);
}
function AiOutlineSnippets(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M832 112H724V72c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v40H500V72c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v40H320c-17.7 0-32 14.3-32 32v120h-96c-17.7 0-32 14.3-32 32v632c0 17.7 14.3 32 32 32h512c17.7 0 32-14.3 32-32v-96h96c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM664 888H232V336h218v174c0 22.1 17.9 40 40 40h174v338zm0-402H514V336h.2L664 485.8v.2zm128 274h-56V456L544 264H360v-80h68v32c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-32h152v32c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-32h68v576z"
                }
            }
        ]
    })(props);
}
function AiOutlineSolution(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M688 264c0-4.4-3.6-8-8-8H296c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h384c4.4 0 8-3.6 8-8v-48zm-8 136H296c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h384c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zM480 544H296c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h184c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zm-48 308H208V148h560v344c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V108c0-17.7-14.3-32-32-32H168c-17.7 0-32 14.3-32 32v784c0 17.7 14.3 32 32 32h264c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm356.8-74.4c29-26.3 47.2-64.3 47.2-106.6 0-79.5-64.5-144-144-144s-144 64.5-144 144c0 42.3 18.2 80.3 47.2 106.6-57 32.5-96.2 92.7-99.2 162.1-.2 4.5 3.5 8.3 8 8.3h48.1c4.2 0 7.7-3.3 8-7.6C564 871.2 621.7 816 692 816s128 55.2 131.9 124.4c.2 4.2 3.7 7.6 8 7.6H880c4.6 0 8.2-3.8 8-8.3-2.9-69.5-42.2-129.6-99.2-162.1zM692 591c44.2 0 80 35.8 80 80s-35.8 80-80 80-80-35.8-80-80 35.8-80 80-80z"
                }
            }
        ]
    })(props);
}
function AiOutlineSortAscending(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M839.6 433.8L749 150.5a9.24 9.24 0 0 0-8.9-6.5h-77.4c-4.1 0-7.6 2.6-8.9 6.5l-91.3 283.3c-.3.9-.5 1.9-.5 2.9 0 5.1 4.2 9.3 9.3 9.3h56.4c4.2 0 7.8-2.8 9-6.8l17.5-61.6h89l17.3 61.5c1.1 4 4.8 6.8 9 6.8h61.2c1 0 1.9-.1 2.8-.4 2.4-.8 4.3-2.4 5.5-4.6 1.1-2.2 1.3-4.7.6-7.1zM663.3 325.5l32.8-116.9h6.3l32.1 116.9h-71.2zm143.5 492.9H677.2v-.4l132.6-188.9c1.1-1.6 1.7-3.4 1.7-5.4v-36.4c0-5.1-4.2-9.3-9.3-9.3h-204c-5.1 0-9.3 4.2-9.3 9.3v43c0 5.1 4.2 9.3 9.3 9.3h122.6v.4L587.7 828.9a9.35 9.35 0 0 0-1.7 5.4v36.4c0 5.1 4.2 9.3 9.3 9.3h211.4c5.1 0 9.3-4.2 9.3-9.3v-43a9.2 9.2 0 0 0-9.2-9.3zM416 702h-76V172c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v530h-76c-6.7 0-10.5 7.8-6.3 13l112 141.9a8 8 0 0 0 12.6 0l112-141.9c4.1-5.2.4-13-6.3-13z"
                }
            }
        ]
    })(props);
}
function AiOutlineSortDescending(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M839.6 433.8L749 150.5a9.24 9.24 0 0 0-8.9-6.5h-77.4c-4.1 0-7.6 2.6-8.9 6.5l-91.3 283.3c-.3.9-.5 1.9-.5 2.9 0 5.1 4.2 9.3 9.3 9.3h56.4c4.2 0 7.8-2.8 9-6.8l17.5-61.6h89l17.3 61.5c1.1 4 4.8 6.8 9 6.8h61.2c1 0 1.9-.1 2.8-.4 2.4-.8 4.3-2.4 5.5-4.6 1.1-2.2 1.3-4.7.6-7.1zM663.3 325.5l32.8-116.9h6.3l32.1 116.9h-71.2zm143.5 492.9H677.2v-.4l132.6-188.9c1.1-1.6 1.7-3.4 1.7-5.4v-36.4c0-5.1-4.2-9.3-9.3-9.3h-204c-5.1 0-9.3 4.2-9.3 9.3v43c0 5.1 4.2 9.3 9.3 9.3h122.6v.4L587.7 828.9a9.35 9.35 0 0 0-1.7 5.4v36.4c0 5.1 4.2 9.3 9.3 9.3h211.4c5.1 0 9.3-4.2 9.3-9.3v-43a9.2 9.2 0 0 0-9.2-9.3zM310.3 167.1a8 8 0 0 0-12.6 0L185.7 309c-4.2 5.3-.4 13 6.3 13h76v530c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V322h76c6.7 0 10.5-7.8 6.3-13l-112-141.9z"
                }
            }
        ]
    })(props);
}
function AiOutlineSound(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M625.9 115c-5.9 0-11.9 1.6-17.4 5.3L254 352H90c-8.8 0-16 7.2-16 16v288c0 8.8 7.2 16 16 16h164l354.5 231.7c5.5 3.6 11.6 5.3 17.4 5.3 16.7 0 32.1-13.3 32.1-32.1V147.1c0-18.8-15.4-32.1-32.1-32.1zM586 803L293.4 611.7l-18-11.7H146V424h129.4l17.9-11.7L586 221v582zm348-327H806c-8.8 0-16 7.2-16 16v40c0 8.8 7.2 16 16 16h128c8.8 0 16-7.2 16-16v-40c0-8.8-7.2-16-16-16zm-41.9 261.8l-110.3-63.7a15.9 15.9 0 0 0-21.7 5.9l-19.9 34.5c-4.4 7.6-1.8 17.4 5.8 21.8L856.3 800a15.9 15.9 0 0 0 21.7-5.9l19.9-34.5c4.4-7.6 1.7-17.4-5.8-21.8zM760 344a15.9 15.9 0 0 0 21.7 5.9L892 286.2c7.6-4.4 10.2-14.2 5.8-21.8L878 230a15.9 15.9 0 0 0-21.7-5.9L746 287.8a15.99 15.99 0 0 0-5.8 21.8L760 344z"
                }
            }
        ]
    })(props);
}
function AiOutlineSplitCells(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "t": "1569683545621",
            "viewBox": "0 0 1024 1024",
            "version": "1.1"
        },
        "child": [
            {
                "tag": "defs",
                "attr": {},
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M938.2 508.4L787.3 389c-3-2.4-7.3-0.2-7.3 3.6V478H636V184h204v128c0 2.2 1.8 4 4 4h60c2.2 0 4-1.8 4-4V144c0-15.5-12.5-28-28-28H596c-15.5 0-28 12.5-28 28v736c0 15.5 12.5 28 28 28h284c15.5 0 28-12.5 28-28V712c0-2.2-1.8-4-4-4h-60c-2.2 0-4 1.8-4 4v128H636V546h144v85.4c0 3.8 4.4 6 7.3 3.6l150.9-119.4c2.4-1.8 2.4-5.4 0-7.2zM428 116H144c-15.5 0-28 12.5-28 28v168c0 2.2 1.8 4 4 4h60c2.2 0 4-1.8 4-4V184h204v294H244v-85.4c0-3.8-4.3-6-7.3-3.6l-151 119.4c-2.3 1.8-2.3 5.3 0 7.1l151 119.5c2.9 2.3 7.3 0.2 7.3-3.6V546h144v294H184V712c0-2.2-1.8-4-4-4h-60c-2.2 0-4 1.8-4 4v168c0 15.5 12.5 28 28 28h284c15.5 0 28-12.5 28-28V144c0-15.5-12.5-28-28-28z"
                }
            }
        ]
    })(props);
}
function AiOutlineStar(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M908.1 353.1l-253.9-36.9L540.7 86.1c-3.1-6.3-8.2-11.4-14.5-14.5-15.8-7.8-35-1.3-42.9 14.5L369.8 316.2l-253.9 36.9c-7 1-13.4 4.3-18.3 9.3a32.05 32.05 0 0 0 .6 45.3l183.7 179.1-43.4 252.9a31.95 31.95 0 0 0 46.4 33.7L512 754l227.1 119.4c6.2 3.3 13.4 4.4 20.3 3.2 17.4-3 29.1-19.5 26.1-36.9l-43.4-252.9 183.7-179.1c5-4.9 8.3-11.3 9.3-18.3 2.7-17.5-9.5-33.7-27-36.3zM664.8 561.6l36.1 210.3L512 672.7 323.1 772l36.1-210.3-152.8-149L417.6 382 512 190.7 606.4 382l211.2 30.7-152.8 148.9z"
                }
            }
        ]
    })(props);
}
function AiOutlineStepBackward(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M347.6 528.95l383.2 301.02c14.25 11.2 35.2 1.1 35.2-16.95V210.97c0-18.05-20.95-28.14-35.2-16.94L347.6 495.05a21.53 21.53 0 0 0 0 33.9M330 864h-64a8 8 0 0 1-8-8V168a8 8 0 0 1 8-8h64a8 8 0 0 1 8 8v688a8 8 0 0 1-8 8"
                }
            }
        ]
    })(props);
}
function AiOutlineStepForward(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M676.4 528.95L293.2 829.97c-14.25 11.2-35.2 1.1-35.2-16.95V210.97c0-18.05 20.95-28.14 35.2-16.94l383.2 301.02a21.53 21.53 0 0 1 0 33.9M694 864h64a8 8 0 0 0 8-8V168a8 8 0 0 0-8-8h-64a8 8 0 0 0-8 8v688a8 8 0 0 0 8 8"
                }
            }
        ]
    })(props);
}
function AiOutlineStock(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M904 747H120c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM165.7 621.8l39.7 39.5c3.1 3.1 8.2 3.1 11.3 0l234.7-233.9 97.6 97.3a32.11 32.11 0 0 0 45.2 0l264.2-263.2c3.1-3.1 3.1-8.2 0-11.3l-39.7-39.6a8.03 8.03 0 0 0-11.3 0l-235.7 235-97.7-97.3a32.11 32.11 0 0 0-45.2 0L165.7 610.5a7.94 7.94 0 0 0 0 11.3z"
                }
            }
        ]
    })(props);
}
function AiOutlineStop(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372 0-89 31.3-170.8 83.5-234.8l523.3 523.3C682.8 852.7 601 884 512 884zm288.5-137.2L277.2 223.5C341.2 171.3 423 140 512 140c205.4 0 372 166.6 372 372 0 89-31.3 170.8-83.5 234.8z"
                }
            }
        ]
    })(props);
}
function AiOutlineStrikethrough(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M952 474H569.9c-10-2-20.5-4-31.6-6-15.9-2.9-22.2-4.1-30.8-5.8-51.3-10-82.2-20-106.8-34.2-35.1-20.5-52.2-48.3-52.2-85.1 0-37 15.2-67.7 44-89 28.4-21 68.8-32.1 116.8-32.1 54.8 0 97.1 14.4 125.8 42.8 14.6 14.4 25.3 32.1 31.8 52.6 1.3 4.1 2.8 10 4.3 17.8.9 4.8 5.2 8.2 9.9 8.2h72.8c5.6 0 10.1-4.6 10.1-10.1v-1c-.7-6.8-1.3-12.1-2-16-7.3-43.5-28-81.7-59.7-110.3-44.4-40.5-109.7-61.8-188.7-61.8-72.3 0-137.4 18.1-183.3 50.9-25.6 18.4-45.4 41.2-58.6 67.7-13.5 27.1-20.3 58.4-20.3 92.9 0 29.5 5.7 54.5 17.3 76.5 8.3 15.7 19.6 29.5 34.1 42H72c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h433.2c2.1.4 3.9.8 5.9 1.2 30.9 6.2 49.5 10.4 66.6 15.2 23 6.5 40.6 13.3 55.2 21.5 35.8 20.2 53.3 49.2 53.3 89 0 35.3-15.5 66.8-43.6 88.8-30.5 23.9-75.6 36.4-130.5 36.4-43.7 0-80.7-8.5-110.2-25-29.1-16.3-49.1-39.8-59.7-69.5-.8-2.2-1.7-5.2-2.7-9-1.2-4.4-5.3-7.5-9.7-7.5h-79.7c-5.6 0-10.1 4.6-10.1 10.1v1c.2 2.3.4 4.2.6 5.7 6.5 48.8 30.3 88.8 70.7 118.8 47.1 34.8 113.4 53.2 191.8 53.2 84.2 0 154.8-19.8 204.2-57.3 25-18.9 44.2-42.2 57.1-69 13-27.1 19.7-57.9 19.7-91.5 0-31.8-5.8-58.4-17.8-81.4-5.8-11.2-13.1-21.5-21.8-30.8H952c4.4 0 8-3.6 8-8v-60a8 8 0 0 0-8-7.9z"
                }
            }
        ]
    })(props);
}
function AiOutlineSubnode(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "t": "1569683432252",
            "viewBox": "0 0 1024 1024",
            "version": "1.1"
        },
        "child": [
            {
                "tag": "defs",
                "attr": {},
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M688 240c-138 0-252 102.8-269.6 236H249c-14.2-35.2-48.7-60-89-60-53 0-96 43-96 96s43 96 96 96c40.3 0 74.8-24.8 89-60h169.3C436 681.2 550 784 688 784c150.2 0 272-121.8 272-272S838.2 240 688 240z m128 298c0 4.4-3.6 8-8 8h-86v86c0 4.4-3.6 8-8 8h-52c-4.4 0-8-3.6-8-8v-86h-86c-4.4 0-8-3.6-8-8v-52c0-4.4 3.6-8 8-8h86v-86c0-4.4 3.6-8 8-8h52c4.4 0 8 3.6 8 8v86h86c4.4 0 8 3.6 8 8v52z"
                }
            }
        ]
    })(props);
}
function AiOutlineSwapLeft(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M872 572H266.8l144.3-183c4.1-5.2.4-13-6.3-13H340c-9.8 0-19.1 4.5-25.1 12.2l-164 208c-16.5 21-1.6 51.8 25.1 51.8h696c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8z"
                }
            }
        ]
    })(props);
}
function AiOutlineSwapRight(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M873.1 596.2l-164-208A32 32 0 0 0 684 376h-64.8c-6.7 0-10.4 7.7-6.3 13l144.3 183H152c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h695.9c26.8 0 41.7-30.8 25.2-51.8z"
                }
            }
        ]
    })(props);
}
function AiOutlineSwap(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M847.9 592H152c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h605.2L612.9 851c-4.1 5.2-.4 13 6.3 13h72.5c4.9 0 9.5-2.2 12.6-6.1l168.8-214.1c16.5-21 1.6-51.8-25.2-51.8zM872 356H266.8l144.3-183c4.1-5.2.4-13-6.3-13h-72.5c-4.9 0-9.5 2.2-12.6 6.1L150.9 380.2c-16.5 21-1.6 51.8 25.1 51.8h696c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8z"
                }
            }
        ]
    })(props);
}
function AiOutlineSwitcher(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M752 240H144c-17.7 0-32 14.3-32 32v608c0 17.7 14.3 32 32 32h608c17.7 0 32-14.3 32-32V272c0-17.7-14.3-32-32-32zm-40 600H184V312h528v528zm168-728H264c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h576v576c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V144c0-17.7-14.3-32-32-32zM300 550h296v64H300z"
                }
            }
        ]
    })(props);
}
function AiOutlineSync(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M168 504.2c1-43.7 10-86.1 26.9-126 17.3-41 42.1-77.7 73.7-109.4S337 212.3 378 195c42.4-17.9 87.4-27 133.9-27s91.5 9.1 133.8 27A341.5 341.5 0 0 1 755 268.8c9.9 9.9 19.2 20.4 27.8 31.4l-60.2 47a8 8 0 0 0 3 14.1l175.7 43c5 1.2 9.9-2.6 9.9-7.7l.8-180.9c0-6.7-7.7-10.5-12.9-6.3l-56.4 44.1C765.8 155.1 646.2 92 511.8 92 282.7 92 96.3 275.6 92 503.8a8 8 0 0 0 8 8.2h60c4.4 0 7.9-3.5 8-7.8zm756 7.8h-60c-4.4 0-7.9 3.5-8 7.8-1 43.7-10 86.1-26.9 126-17.3 41-42.1 77.8-73.7 109.4A342.45 342.45 0 0 1 512.1 856a342.24 342.24 0 0 1-243.2-100.8c-9.9-9.9-19.2-20.4-27.8-31.4l60.2-47a8 8 0 0 0-3-14.1l-175.7-43c-5-1.2-9.9 2.6-9.9 7.7l-.7 181c0 6.7 7.7 10.5 12.9 6.3l56.4-44.1C258.2 868.9 377.8 932 512.2 932c229.2 0 415.5-183.7 419.8-411.8a8 8 0 0 0-8-8.2z"
                }
            }
        ]
    })(props);
}
function AiOutlineTable(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M928 160H96c-17.7 0-32 14.3-32 32v640c0 17.7 14.3 32 32 32h832c17.7 0 32-14.3 32-32V192c0-17.7-14.3-32-32-32zm-40 208H676V232h212v136zm0 224H676V432h212v160zM412 432h200v160H412V432zm200-64H412V232h200v136zm-476 64h212v160H136V432zm0-200h212v136H136V232zm0 424h212v136H136V656zm276 0h200v136H412V656zm476 136H676V656h212v136z"
                }
            }
        ]
    })(props);
}
function AiOutlineTablet(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M800 64H224c-35.3 0-64 28.7-64 64v768c0 35.3 28.7 64 64 64h576c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64zm-8 824H232V136h560v752zM472 784a40 40 0 1 0 80 0 40 40 0 1 0-80 0z"
                }
            }
        ]
    })(props);
}
function AiOutlineTag(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M938 458.8l-29.6-312.6c-1.5-16.2-14.4-29-30.6-30.6L565.2 86h-.4c-3.2 0-5.7 1-7.6 2.9L88.9 557.2a9.96 9.96 0 0 0 0 14.1l363.8 363.8c1.9 1.9 4.4 2.9 7.1 2.9s5.2-1 7.1-2.9l468.3-468.3c2-2.1 3-5 2.8-8zM459.7 834.7L189.3 564.3 589 164.6 836 188l23.4 247-399.7 399.7zM680 256c-48.5 0-88 39.5-88 88s39.5 88 88 88 88-39.5 88-88-39.5-88-88-88zm0 120c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32z"
                }
            }
        ]
    })(props);
}
function AiOutlineTags(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M483.2 790.3L861.4 412c1.7-1.7 2.5-4 2.3-6.3l-25.5-301.4c-.7-7.8-6.8-13.9-14.6-14.6L522.2 64.3c-2.3-.2-4.7.6-6.3 2.3L137.7 444.8a8.03 8.03 0 0 0 0 11.3l334.2 334.2c3.1 3.2 8.2 3.2 11.3 0zm62.6-651.7l224.6 19 19 224.6L477.5 694 233.9 450.5l311.9-311.9zm60.16 186.23a48 48 0 1 0 67.88-67.89 48 48 0 1 0-67.88 67.89zM889.7 539.8l-39.6-39.5a8.03 8.03 0 0 0-11.3 0l-362 361.3-237.6-237a8.03 8.03 0 0 0-11.3 0l-39.6 39.5a8.03 8.03 0 0 0 0 11.3l243.2 242.8 39.6 39.5c3.1 3.1 8.2 3.1 11.3 0l407.3-406.6c3.1-3.1 3.1-8.2 0-11.3z"
                }
            }
        ]
    })(props);
}
function AiOutlineTaobaoCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zM315.7 291.5c27.3 0 49.5 22.1 49.5 49.4s-22.1 49.4-49.5 49.4a49.4 49.4 0 1 1 0-98.8zM366.9 578c-13.6 42.3-10.2 26.7-64.4 144.5l-78.5-49s87.7-79.8 105.6-116.2c19.2-38.4-21.1-58.9-21.1-58.9l-60.2-37.5 32.7-50.2c45.4 33.7 48.7 36.6 79.2 67.2 23.8 23.9 20.7 56.8 6.7 100.1zm427.2 55c-15.3 143.8-202.4 90.3-202.4 90.3l10.2-41.1 43.3 9.3c80 5 72.3-64.9 72.3-64.9V423c.6-77.3-72.6-85.4-204.2-38.3l30.6 8.3c-2.5 9-12.5 23.2-25.2 38.6h176v35.6h-99.1v44.5h98.7v35.7h-98.7V622c14.9-4.8 28.6-11.5 40.5-20.5l-8.7-32.5 46.5-14.4 38.8 94.9-57.3 23.9-10.2-37.8c-25.6 19.5-78.8 48-171.8 45.4-99.2 2.6-73.7-112-73.7-112l2.5-1.3H472c-.5 14.7-6.6 38.7 1.7 51.8 6.8 10.8 24.2 12.6 35.3 13.1 1.3.1 2.6.1 3.9.1v-85.3h-101v-35.7h101v-44.5H487c-22.7 24.1-43.5 44.1-43.5 44.1l-30.6-26.7c21.7-22.9 43.3-59.1 56.8-83.2-10.9 4.4-22 9.2-33.6 14.2-11.2 14.3-24.2 29-38.7 43.5.5.8-50-28.4-50-28.4 52.2-44.4 81.4-139.9 81.4-139.9l72.5 20.4s-5.9 14-18.4 35.6c290.3-82.3 307.4 50.5 307.4 50.5s19.1 91.8 3.8 235.7z"
                }
            }
        ]
    })(props);
}
function AiOutlineTaobao(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M168.5 273.7a68.7 68.7 0 1 0 137.4 0 68.7 68.7 0 1 0-137.4 0zm730 79.2s-23.7-184.4-426.9-70.1c17.3-30 25.6-49.5 25.6-49.5L396.4 205s-40.6 132.6-113 194.4c0 0 70.1 40.6 69.4 39.4 20.1-20.1 38.2-40.6 53.7-60.4 16.1-7 31.5-13.6 46.7-19.8-18.6 33.5-48.7 83.8-78.8 115.6l42.4 37s28.8-27.7 60.4-61.2h36v61.8H372.9v49.5h140.3v118.5c-1.7 0-3.6 0-5.4-.2-15.4-.7-39.5-3.3-49-18.2-11.5-18.1-3-51.5-2.4-71.9h-97l-3.4 1.8s-35.5 159.1 102.3 155.5c129.1 3.6 203-36 238.6-63.1l14.2 52.6 79.6-33.2-53.9-131.9-64.6 20.1 12.1 45.2c-16.6 12.4-35.6 21.7-56.2 28.4V561.3h137.1v-49.5H628.1V450h137.6v-49.5H521.3c17.6-21.4 31.5-41.1 35-53.6l-42.5-11.6c182.8-65.5 284.5-54.2 283.6 53.2v282.8s10.8 97.1-100.4 90.1l-60.2-12.9-14.2 57.1S882.5 880 903.7 680.2c21.3-200-5.2-327.3-5.2-327.3zm-707.4 18.3l-45.4 69.7 83.6 52.1s56 28.5 29.4 81.9C233.8 625.5 112 736.3 112 736.3l109 68.1c75.4-163.7 70.5-142 89.5-200.7 19.5-60.1 23.7-105.9-9.4-139.1-42.4-42.6-47-46.6-110-93.4z"
                }
            }
        ]
    })(props);
}
function AiOutlineTeam(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M824.2 699.9a301.55 301.55 0 0 0-86.4-60.4C783.1 602.8 812 546.8 812 484c0-110.8-92.4-201.7-203.2-200-109.1 1.7-197 90.6-197 200 0 62.8 29 118.8 74.2 155.5a300.95 300.95 0 0 0-86.4 60.4C345 754.6 314 826.8 312 903.8a8 8 0 0 0 8 8.2h56c4.3 0 7.9-3.4 8-7.7 1.9-58 25.4-112.3 66.7-153.5A226.62 226.62 0 0 1 612 684c60.9 0 118.2 23.7 161.3 66.8C814.5 792 838 846.3 840 904.3c.1 4.3 3.7 7.7 8 7.7h56a8 8 0 0 0 8-8.2c-2-77-33-149.2-87.8-203.9zM612 612c-34.2 0-66.4-13.3-90.5-37.5a126.86 126.86 0 0 1-37.5-91.8c.3-32.8 13.4-64.5 36.3-88 24-24.6 56.1-38.3 90.4-38.7 33.9-.3 66.8 12.9 91 36.6 24.8 24.3 38.4 56.8 38.4 91.4 0 34.2-13.3 66.3-37.5 90.5A127.3 127.3 0 0 1 612 612zM361.5 510.4c-.9-8.7-1.4-17.5-1.4-26.4 0-15.9 1.5-31.4 4.3-46.5.7-3.6-1.2-7.3-4.5-8.8-13.6-6.1-26.1-14.5-36.9-25.1a127.54 127.54 0 0 1-38.7-95.4c.9-32.1 13.8-62.6 36.3-85.6 24.7-25.3 57.9-39.1 93.2-38.7 31.9.3 62.7 12.6 86 34.4 7.9 7.4 14.7 15.6 20.4 24.4 2 3.1 5.9 4.4 9.3 3.2 17.6-6.1 36.2-10.4 55.3-12.4 5.6-.6 8.8-6.6 6.3-11.6-32.5-64.3-98.9-108.7-175.7-109.9-110.9-1.7-203.3 89.2-203.3 199.9 0 62.8 28.9 118.8 74.2 155.5-31.8 14.7-61.1 35-86.5 60.4-54.8 54.7-85.8 126.9-87.8 204a8 8 0 0 0 8 8.2h56.1c4.3 0 7.9-3.4 8-7.7 1.9-58 25.4-112.3 66.7-153.5 29.4-29.4 65.4-49.8 104.7-59.7 3.9-1 6.5-4.7 6-8.7z"
                }
            }
        ]
    })(props);
}
function AiOutlineThunderbolt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M848 359.3H627.7L825.8 109c4.1-5.3.4-13-6.3-13H436c-2.8 0-5.5 1.5-6.9 4L170 547.5c-3.1 5.3.7 12 6.9 12h174.4l-89.4 357.6c-1.9 7.8 7.5 13.3 13.3 7.7L853.5 373c5.2-4.9 1.7-13.7-5.5-13.7zM378.2 732.5l60.3-241H281.1l189.6-327.4h224.6L487 427.4h211L378.2 732.5z"
                }
            }
        ]
    })(props);
}
function AiOutlineToTop(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M885 780H165c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h720c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8zM400 325.7h73.9V664c0 4.4 3.6 8 8 8h60c4.4 0 8-3.6 8-8V325.7H624c6.7 0 10.4-7.7 6.3-12.9L518.3 171a8 8 0 0 0-12.6 0l-112 141.7c-4.1 5.3-.4 13 6.3 13z"
                }
            }
        ]
    })(props);
}
function AiOutlineTool(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M876.6 239.5c-.5-.9-1.2-1.8-2-2.5-5-5-13.1-5-18.1 0L684.2 409.3l-67.9-67.9L788.7 169c.8-.8 1.4-1.6 2-2.5 3.6-6.1 1.6-13.9-4.5-17.5-98.2-58-226.8-44.7-311.3 39.7-67 67-89.2 162-66.5 247.4l-293 293c-3 3-2.8 7.9.3 11l169.7 169.7c3.1 3.1 8.1 3.3 11 .3l292.9-292.9c85.5 22.8 180.5.7 247.6-66.4 84.4-84.5 97.7-213.1 39.7-311.3zM786 499.8c-58.1 58.1-145.3 69.3-214.6 33.6l-8.8 8.8-.1-.1-274 274.1-79.2-79.2 230.1-230.1s0 .1.1.1l52.8-52.8c-35.7-69.3-24.5-156.5 33.6-214.6a184.2 184.2 0 0 1 144-53.5L537 318.9a32.05 32.05 0 0 0 0 45.3l124.5 124.5a32.05 32.05 0 0 0 45.3 0l132.8-132.8c3.7 51.8-14.4 104.8-53.6 143.9z"
                }
            }
        ]
    })(props);
}
function AiOutlineTrademarkCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372zm87.5-334.7c34.8-12.8 78.4-49 78.4-119.2 0-71.2-45.5-131.1-144.2-131.1H378c-4.4 0-8 3.6-8 8v410c0 4.4 3.6 8 8 8h54.5c4.4 0 8-3.6 8-8V561.2h88.7l74.6 159.2c1.3 2.8 4.1 4.6 7.2 4.6h62a7.9 7.9 0 0 0 7.1-11.5l-80.6-164.2zM522 505h-81.5V357h83.4c48 0 80.9 25.3 80.9 75.5 0 46.9-29.8 72.5-82.8 72.5z"
                }
            }
        ]
    })(props);
}
function AiOutlineTrademark(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372zm87.5-334.7c34.8-12.8 78.4-49 78.4-119.2 0-71.2-45.5-131.1-144.2-131.1H378c-4.4 0-8 3.6-8 8v410c0 4.4 3.6 8 8 8h54.5c4.4 0 8-3.6 8-8V561.2h88.7l74.6 159.2c1.3 2.8 4.1 4.6 7.2 4.6h62a7.9 7.9 0 0 0 7.1-11.5l-80.6-164.2zM522 505h-81.5V357h83.4c48 0 80.9 25.3 80.9 75.5 0 46.9-29.8 72.5-82.8 72.5z"
                }
            }
        ]
    })(props);
}
function AiOutlineTransaction(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M668.6 320c0-4.4-3.6-8-8-8h-54.5c-3 0-5.8 1.7-7.1 4.4l-84.7 168.8H511l-84.7-168.8a8 8 0 0 0-7.1-4.4h-55.7c-1.3 0-2.6.3-3.8 1-3.9 2.1-5.3 7-3.2 10.8l103.9 191.6h-57c-4.4 0-8 3.6-8 8v27.1c0 4.4 3.6 8 8 8h76v39h-76c-4.4 0-8 3.6-8 8v27.1c0 4.4 3.6 8 8 8h76V704c0 4.4 3.6 8 8 8h49.9c4.4 0 8-3.6 8-8v-63.5h76.3c4.4 0 8-3.6 8-8v-27.1c0-4.4-3.6-8-8-8h-76.3v-39h76.3c4.4 0 8-3.6 8-8v-27.1c0-4.4-3.6-8-8-8H564l103.7-191.6c.5-1.1.9-2.4.9-3.7zM157.9 504.2a352.7 352.7 0 0 1 103.5-242.4c32.5-32.5 70.3-58.1 112.4-75.9 43.6-18.4 89.9-27.8 137.6-27.8 47.8 0 94.1 9.3 137.6 27.8 42.1 17.8 79.9 43.4 112.4 75.9 10 10 19.3 20.5 27.9 31.4l-50 39.1a8 8 0 0 0 3 14.1l156.8 38.3c5 1.2 9.9-2.6 9.9-7.7l.8-161.5c0-6.7-7.7-10.5-12.9-6.3l-47.8 37.4C770.7 146.3 648.6 82 511.5 82 277 82 86.3 270.1 82 503.8a8 8 0 0 0 8 8.2h60c4.3 0 7.8-3.5 7.9-7.8zM934 512h-60c-4.3 0-7.9 3.5-8 7.8a352.7 352.7 0 0 1-103.5 242.4 352.57 352.57 0 0 1-112.4 75.9c-43.6 18.4-89.9 27.8-137.6 27.8s-94.1-9.3-137.6-27.8a352.57 352.57 0 0 1-112.4-75.9c-10-10-19.3-20.5-27.9-31.4l49.9-39.1a8 8 0 0 0-3-14.1l-156.8-38.3c-5-1.2-9.9 2.6-9.9 7.7l-.8 161.7c0 6.7 7.7 10.5 12.9 6.3l47.8-37.4C253.3 877.7 375.4 942 512.5 942 747 942 937.7 753.9 942 520.2a8 8 0 0 0-8-8.2z"
                }
            }
        ]
    })(props);
}
function AiOutlineTranslation(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "t": "1569683569194",
            "viewBox": "0 0 1024 1024",
            "version": "1.1"
        },
        "child": [
            {
                "tag": "defs",
                "attr": {},
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M140 188h584v164h76V144c0-17.7-14.3-32-32-32H96c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h544v-76H140V188z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M414.3 256h-60.6c-3.4 0-6.4 2.2-7.6 5.4L219 629.4c-0.3 0.8-0.4 1.7-0.4 2.6 0 4.4 3.6 8 8 8h55.1c3.4 0 6.4-2.2 7.6-5.4L322 540h196.2L422 261.4c-1.3-3.2-4.3-5.4-7.7-5.4z m12.4 228h-85.5L384 360.2 426.7 484zM936 528H800v-93c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v93H592c-13.3 0-24 10.7-24 24v176c0 13.3 10.7 24 24 24h136v152c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V752h136c13.3 0 24-10.7 24-24V552c0-13.3-10.7-24-24-24zM728 680h-88v-80h88v80z m160 0h-88v-80h88v80z"
                }
            }
        ]
    })(props);
}
function AiOutlineTrophy(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M868 160h-92v-40c0-4.4-3.6-8-8-8H256c-4.4 0-8 3.6-8 8v40h-92a44 44 0 0 0-44 44v148c0 81.7 60 149.6 138.2 162C265.7 630.2 359 721.7 476 734.5v105.2H280c-17.7 0-32 14.3-32 32V904c0 4.4 3.6 8 8 8h512c4.4 0 8-3.6 8-8v-32.3c0-17.7-14.3-32-32-32H548V734.5C665 721.7 758.3 630.2 773.8 514 852 501.6 912 433.7 912 352V204a44 44 0 0 0-44-44zM184 352V232h64v207.6a91.99 91.99 0 0 1-64-87.6zm520 128c0 49.1-19.1 95.4-53.9 130.1-34.8 34.8-81 53.9-130.1 53.9h-16c-49.1 0-95.4-19.1-130.1-53.9-34.8-34.8-53.9-81-53.9-130.1V184h384v296zm136-128c0 41-26.9 75.8-64 87.6V232h64v120z"
                }
            }
        ]
    })(props);
}
function AiOutlineTwitter(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M928 254.3c-30.6 13.2-63.9 22.7-98.2 26.4a170.1 170.1 0 0 0 75-94 336.64 336.64 0 0 1-108.2 41.2A170.1 170.1 0 0 0 672 174c-94.5 0-170.5 76.6-170.5 170.6 0 13.2 1.6 26.4 4.2 39.1-141.5-7.4-267.7-75-351.6-178.5a169.32 169.32 0 0 0-23.2 86.1c0 59.2 30.1 111.4 76 142.1a172 172 0 0 1-77.1-21.7v2.1c0 82.9 58.6 151.6 136.7 167.4a180.6 180.6 0 0 1-44.9 5.8c-11.1 0-21.6-1.1-32.2-2.6C211 652 273.9 701.1 348.8 702.7c-58.6 45.9-132 72.9-211.7 72.9-14.3 0-27.5-.5-41.2-2.1C171.5 822 261.2 850 357.8 850 671.4 850 843 590.2 843 364.7c0-7.4 0-14.8-.5-22.2 33.2-24.3 62.3-54.4 85.5-88.2z"
                }
            }
        ]
    })(props);
}
function AiOutlineUnderline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M824 804H200c-4.4 0-8 3.4-8 7.6v60.8c0 4.2 3.6 7.6 8 7.6h624c4.4 0 8-3.4 8-7.6v-60.8c0-4.2-3.6-7.6-8-7.6zm-312-76c69.4 0 134.6-27.1 183.8-76.2C745 602.7 772 537.4 772 468V156c0-6.6-5.4-12-12-12h-60c-6.6 0-12 5.4-12 12v312c0 97-79 176-176 176s-176-79-176-176V156c0-6.6-5.4-12-12-12h-60c-6.6 0-12 5.4-12 12v312c0 69.4 27.1 134.6 76.2 183.8C377.3 701 442.6 728 512 728z"
                }
            }
        ]
    })(props);
}
function AiOutlineUndo(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M511.4 124C290.5 124.3 112 303 112 523.9c0 128 60.2 242 153.8 315.2l-37.5 48c-4.1 5.3-.3 13 6.3 12.9l167-.8c5.2 0 9-4.9 7.7-9.9L369.8 727a8 8 0 0 0-14.1-3L315 776.1c-10.2-8-20-16.7-29.3-26a318.64 318.64 0 0 1-68.6-101.7C200.4 609 192 567.1 192 523.9s8.4-85.1 25.1-124.5c16.1-38.1 39.2-72.3 68.6-101.7 29.4-29.4 63.6-52.5 101.7-68.6C426.9 212.4 468.8 204 512 204s85.1 8.4 124.5 25.1c38.1 16.1 72.3 39.2 101.7 68.6 29.4 29.4 52.5 63.6 68.6 101.7 16.7 39.4 25.1 81.3 25.1 124.5s-8.4 85.1-25.1 124.5a318.64 318.64 0 0 1-68.6 101.7c-7.5 7.5-15.3 14.5-23.4 21.2a7.93 7.93 0 0 0-1.2 11.1l39.4 50.5c2.8 3.5 7.9 4.1 11.4 1.3C854.5 760.8 912 649.1 912 523.9c0-221.1-179.4-400.2-400.6-399.9z"
                }
            }
        ]
    })(props);
}
function AiOutlineUngroup(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "t": "1569683823033",
            "viewBox": "0 0 1024 1024",
            "version": "1.1"
        },
        "child": [
            {
                "tag": "defs",
                "attr": {},
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M736 550H288c-8.8 0-16 7.2-16 16v176c0 8.8 7.2 16 16 16h448c8.8 0 16-7.2 16-16V566c0-8.8-7.2-16-16-16z m-56 136H344v-64h336v64zM888 816c-39.8 0-72 32.2-72 72s32.2 72 72 72 72-32.2 72-72-32.2-72-72-72z m0 96c-13.3 0-24-10.7-24-24s10.7-24 24-24 24 10.7 24 24-10.7 24-24 24zM736 266H288c-8.8 0-16 7.2-16 16v176c0 8.8 7.2 16 16 16h448c8.8 0 16-7.2 16-16V282c0-8.8-7.2-16-16-16z m-56 136H344v-64h336v64zM888 208c39.8 0 72-32.2 72-72s-32.2-72-72-72-72 32.2-72 72 32.2 72 72 72z m0-96c13.3 0 24 10.7 24 24s-10.7 24-24 24-24-10.7-24-24 10.7-24 24-24zM136 64c-39.8 0-72 32.2-72 72s32.2 72 72 72 72-32.2 72-72-32.2-72-72-72z m0 96c-13.3 0-24-10.7-24-24s10.7-24 24-24 24 10.7 24 24-10.7 24-24 24zM136 816c-39.8 0-72 32.2-72 72s32.2 72 72 72 72-32.2 72-72-32.2-72-72-72z m0 96c-13.3 0-24-10.7-24-24s10.7-24 24-24 24 10.7 24 24-10.7 24-24 24z"
                }
            }
        ]
    })(props);
}
function AiOutlineUnlock(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M832 464H332V240c0-30.9 25.1-56 56-56h248c30.9 0 56 25.1 56 56v68c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-68c0-70.7-57.3-128-128-128H388c-70.7 0-128 57.3-128 128v224h-68c-17.7 0-32 14.3-32 32v384c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V496c0-17.7-14.3-32-32-32zm-40 376H232V536h560v304zM484 701v53c0 4.4 3.6 8 8 8h40c4.4 0 8-3.6 8-8v-53a48.01 48.01 0 1 0-56 0z"
                }
            }
        ]
    })(props);
}
function AiOutlineUnorderedList(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M912 192H328c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h584c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 284H328c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h584c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 284H328c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h584c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM104 228a56 56 0 1 0 112 0 56 56 0 1 0-112 0zm0 284a56 56 0 1 0 112 0 56 56 0 1 0-112 0zm0 284a56 56 0 1 0 112 0 56 56 0 1 0-112 0z"
                }
            }
        ]
    })(props);
}
function AiOutlineUpCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M518.5 360.3a7.95 7.95 0 0 0-12.9 0l-178 246c-3.8 5.3 0 12.7 6.5 12.7H381c10.2 0 19.9-4.9 25.9-13.2L512 460.4l105.2 145.4c6 8.3 15.6 13.2 25.9 13.2H690c6.5 0 10.3-7.4 6.5-12.7l-178-246z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z"
                }
            }
        ]
    })(props);
}
function AiOutlineUpSquare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M334 624h46.9c10.2 0 19.9-4.9 25.9-13.2L512 465.4l105.2 145.4c6 8.3 15.6 13.2 25.9 13.2H690c6.5 0 10.3-7.4 6.5-12.7l-178-246a7.95 7.95 0 0 0-12.9 0l-178 246A7.96 7.96 0 0 0 334 624z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z"
                }
            }
        ]
    })(props);
}
function AiOutlineUp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M890.5 755.3L537.9 269.2c-12.8-17.6-39-17.6-51.7 0L133.5 755.3A8 8 0 0 0 140 768h75c5.1 0 9.9-2.5 12.9-6.6L512 369.8l284.1 391.6c3 4.1 7.8 6.6 12.9 6.6h75c6.5 0 10.3-7.4 6.5-12.7z"
                }
            }
        ]
    })(props);
}
function AiOutlineUpload(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M400 317.7h73.9V656c0 4.4 3.6 8 8 8h60c4.4 0 8-3.6 8-8V317.7H624c6.7 0 10.4-7.7 6.3-12.9L518.3 163a8 8 0 0 0-12.6 0l-112 141.7c-4.1 5.3-.4 13 6.3 13zM878 626h-60c-4.4 0-8 3.6-8 8v154H214V634c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8v198c0 17.7 14.3 32 32 32h684c17.7 0 32-14.3 32-32V634c0-4.4-3.6-8-8-8z"
                }
            }
        ]
    })(props);
}
function AiOutlineUsb(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M760 432V144c0-17.7-14.3-32-32-32H296c-17.7 0-32 14.3-32 32v288c-66.2 0-120 52.1-120 116v356c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V548c0-24.3 21.6-44 48.1-44h495.8c26.5 0 48.1 19.7 48.1 44v356c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V548c0-63.9-53.8-116-120-116zm-424 0V184h352v248H336zm120-184h-48c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zm160 0h-48c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8z"
                }
            }
        ]
    })(props);
}
function AiOutlineUserAdd(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M678.3 642.4c24.2-13 51.9-20.4 81.4-20.4h.1c3 0 4.4-3.6 2.2-5.6a371.67 371.67 0 0 0-103.7-65.8c-.4-.2-.8-.3-1.2-.5C719.2 505 759.6 431.7 759.6 349c0-137-110.8-248-247.5-248S264.7 212 264.7 349c0 82.7 40.4 156 102.6 201.1-.4.2-.8.3-1.2.5-44.7 18.9-84.8 46-119.3 80.6a373.42 373.42 0 0 0-80.4 119.5A373.6 373.6 0 0 0 137 888.8a8 8 0 0 0 8 8.2h59.9c4.3 0 7.9-3.5 8-7.8 2-77.2 32.9-149.5 87.6-204.3C357 628.2 432.2 597 512.2 597c56.7 0 111.1 15.7 158 45.1a8.1 8.1 0 0 0 8.1.3zM512.2 521c-45.8 0-88.9-17.9-121.4-50.4A171.2 171.2 0 0 1 340.5 349c0-45.9 17.9-89.1 50.3-121.6S466.3 177 512.2 177s88.9 17.9 121.4 50.4A171.2 171.2 0 0 1 683.9 349c0 45.9-17.9 89.1-50.3 121.6C601.1 503.1 558 521 512.2 521zM880 759h-84v-84c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v84h-84c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h84v84c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-84h84c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8z"
                }
            }
        ]
    })(props);
}
function AiOutlineUserDelete(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M678.3 655.4c24.2-13 51.9-20.4 81.4-20.4h.1c3 0 4.4-3.6 2.2-5.6a371.67 371.67 0 0 0-103.7-65.8c-.4-.2-.8-.3-1.2-.5C719.2 518 759.6 444.7 759.6 362c0-137-110.8-248-247.5-248S264.7 225 264.7 362c0 82.7 40.4 156 102.6 201.1-.4.2-.8.3-1.2.5-44.7 18.9-84.8 46-119.3 80.6a373.42 373.42 0 0 0-80.4 119.5A373.6 373.6 0 0 0 137 901.8a8 8 0 0 0 8 8.2h59.9c4.3 0 7.9-3.5 8-7.8 2-77.2 32.9-149.5 87.6-204.3C357 641.2 432.2 610 512.2 610c56.7 0 111.1 15.7 158 45.1a8.1 8.1 0 0 0 8.1.3zM512.2 534c-45.8 0-88.9-17.9-121.4-50.4A171.2 171.2 0 0 1 340.5 362c0-45.9 17.9-89.1 50.3-121.6S466.3 190 512.2 190s88.9 17.9 121.4 50.4A171.2 171.2 0 0 1 683.9 362c0 45.9-17.9 89.1-50.3 121.6C601.1 516.1 558 534 512.2 534zM880 772H640c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h240c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8z"
                }
            }
        ]
    })(props);
}
function AiOutlineUserSwitch(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "t": "1569683921137",
            "viewBox": "0 0 1024 1024",
            "version": "1.1"
        },
        "child": [
            {
                "tag": "defs",
                "attr": {},
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M759 335c0-137-111-248-248-248S263 198 263 335c0 82.8 40.6 156.2 103 201.2-0.4 0.2-0.7 0.3-0.9 0.4-44.7 18.9-84.8 46-119.3 80.6-34.5 34.5-61.5 74.7-80.4 119.5C146.9 780.5 137 827 136 874.8c-0.1 4.5 3.5 8.2 8 8.2h59.9c4.3 0 7.9-3.5 8-7.8 2-77.2 32.9-149.5 87.6-204.3C356 614.2 431 583 511 583c137 0 248-111 248-248zM511 507c-95 0-172-77-172-172s77-172 172-172 172 77 172 172-77 172-172 172zM616 728h264c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H703.5l47.2-60.1c1.1-1.4 1.7-3.2 1.7-4.9 0-4.4-3.6-8-8-8h-72.6c-4.9 0-9.5 2.3-12.6 6.1l-68.5 87.1c-4.4 5.6-6.8 12.6-6.8 19.8 0.1 17.7 14.4 32 32.1 32zM856 792H592c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h176.5l-47.2 60.1c-1.1 1.4-1.7 3.2-1.7 4.9 0 4.4 3.6 8 8 8h72.6c4.9 0 9.5-2.3 12.6-6.1l68.5-87.1c4.4-5.6 6.8-12.6 6.8-19.8-0.1-17.7-14.4-32-32.1-32z"
                }
            }
        ]
    })(props);
}
function AiOutlineUser(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M858.5 763.6a374 374 0 0 0-80.6-119.5 375.63 375.63 0 0 0-119.5-80.6c-.4-.2-.8-.3-1.2-.5C719.5 518 760 444.7 760 362c0-137-111-248-248-248S264 225 264 362c0 82.7 40.5 156 102.8 201.1-.4.2-.8.3-1.2.5-44.8 18.9-85 46-119.5 80.6a375.63 375.63 0 0 0-80.6 119.5A371.7 371.7 0 0 0 136 901.8a8 8 0 0 0 8 8.2h60c4.4 0 7.9-3.5 8-7.8 2-77.2 33-149.5 87.8-204.3 56.7-56.7 132-87.9 212.2-87.9s155.5 31.2 212.2 87.9C779 752.7 810 825 812 902.2c.1 4.4 3.6 7.8 8 7.8h60a8 8 0 0 0 8-8.2c-1-47.8-10.9-94.3-29.5-138.2zM512 534c-45.9 0-89.1-17.9-121.6-50.4S340 407.9 340 362c0-45.9 17.9-89.1 50.4-121.6S466.1 190 512 190s89.1 17.9 121.6 50.4S684 316.1 684 362c0 45.9-17.9 89.1-50.4 121.6S557.9 534 512 534z"
                }
            }
        ]
    })(props);
}
function AiOutlineUsergroupAdd(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M892 772h-80v-80c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v80h-80c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h80v80c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8v-80h80c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zM373.5 498.4c-.9-8.7-1.4-17.5-1.4-26.4 0-15.9 1.5-31.4 4.3-46.5.7-3.6-1.2-7.3-4.5-8.8-13.6-6.1-26.1-14.5-36.9-25.1a127.54 127.54 0 0 1-38.7-95.4c.9-32.1 13.8-62.6 36.3-85.6 24.7-25.3 57.9-39.1 93.2-38.7 31.9.3 62.7 12.6 86 34.4 7.9 7.4 14.7 15.6 20.4 24.4 2 3.1 5.9 4.4 9.3 3.2 17.6-6.1 36.2-10.4 55.3-12.4 5.6-.6 8.8-6.6 6.3-11.6-32.5-64.3-98.9-108.7-175.7-109.9-110.8-1.7-203.2 89.2-203.2 200 0 62.8 28.9 118.8 74.2 155.5-31.8 14.7-61.1 35-86.5 60.4-54.8 54.7-85.8 126.9-87.8 204a8 8 0 0 0 8 8.2h56.1c4.3 0 7.9-3.4 8-7.7 1.9-58 25.4-112.3 66.7-153.5 29.4-29.4 65.4-49.8 104.7-59.7 3.8-1.1 6.4-4.8 5.9-8.8zM824 472c0-109.4-87.9-198.3-196.9-200C516.3 270.3 424 361.2 424 472c0 62.8 29 118.8 74.2 155.5a300.95 300.95 0 0 0-86.4 60.4C357 742.6 326 814.8 324 891.8a8 8 0 0 0 8 8.2h56c4.3 0 7.9-3.4 8-7.7 1.9-58 25.4-112.3 66.7-153.5C505.8 695.7 563 672 624 672c110.4 0 200-89.5 200-200zm-109.5 90.5C690.3 586.7 658.2 600 624 600s-66.3-13.3-90.5-37.5a127.26 127.26 0 0 1-37.5-91.8c.3-32.8 13.4-64.5 36.3-88 24-24.6 56.1-38.3 90.4-38.7 33.9-.3 66.8 12.9 91 36.6 24.8 24.3 38.4 56.8 38.4 91.4-.1 34.2-13.4 66.3-37.6 90.5z"
                }
            }
        ]
    })(props);
}
function AiOutlineUsergroupDelete(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M888 784H664c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h224c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zM373.5 510.4c-.9-8.7-1.4-17.5-1.4-26.4 0-15.9 1.5-31.4 4.3-46.5.7-3.6-1.2-7.3-4.5-8.8-13.6-6.1-26.1-14.5-36.9-25.1a127.54 127.54 0 0 1-38.7-95.4c.9-32.1 13.8-62.6 36.3-85.6 24.7-25.3 57.9-39.1 93.2-38.7 31.9.3 62.7 12.6 86 34.4 7.9 7.4 14.7 15.6 20.4 24.4 2 3.1 5.9 4.4 9.3 3.2 17.6-6.1 36.2-10.4 55.3-12.4 5.6-.6 8.8-6.6 6.3-11.6-32.5-64.3-98.9-108.7-175.7-109.9-110.9-1.7-203.3 89.2-203.3 199.9 0 62.8 28.9 118.8 74.2 155.5-31.8 14.7-61.1 35-86.5 60.4-54.8 54.7-85.8 126.9-87.8 204a8 8 0 0 0 8 8.2h56.1c4.3 0 7.9-3.4 8-7.7 1.9-58 25.4-112.3 66.7-153.5 29.4-29.4 65.4-49.8 104.7-59.7 3.9-1 6.5-4.7 6-8.7zM824 484c0-109.4-87.9-198.3-196.9-200C516.3 282.3 424 373.2 424 484c0 62.8 29 118.8 74.2 155.5a300.95 300.95 0 0 0-86.4 60.4C357 754.6 326 826.8 324 903.8a8 8 0 0 0 8 8.2h56c4.3 0 7.9-3.4 8-7.7 1.9-58 25.4-112.3 66.7-153.5C505.8 707.7 563 684 624 684c110.4 0 200-89.5 200-200zm-109.5 90.5C690.3 598.7 658.2 612 624 612s-66.3-13.3-90.5-37.5a127.26 127.26 0 0 1-37.5-91.8c.3-32.8 13.4-64.5 36.3-88 24-24.6 56.1-38.3 90.4-38.7 33.9-.3 66.8 12.9 91 36.6 24.8 24.3 38.4 56.8 38.4 91.4-.1 34.2-13.4 66.3-37.6 90.5z"
                }
            }
        ]
    })(props);
}
function AiOutlineVerified(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "t": "1569683899926",
            "viewBox": "0 0 1024 1024",
            "version": "1.1"
        },
        "child": [
            {
                "tag": "defs",
                "attr": {},
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M447.8 588.8l-7.3-32.5c-0.2-1-0.6-1.9-1.1-2.7-2.5-3.7-7.4-4.7-11.1-2.2L405 567V411c0-4.4-3.6-8-8-8h-81c-4.4 0-8 3.6-8 8v36c0 4.4 3.6 8 8 8h37v192.4c0 1.7 0.5 3.3 1.5 4.7 2.6 3.6 7.6 4.4 11.2 1.8l79-56.8c2.6-1.9 3.8-5.1 3.1-8.3zM391.1 372.2l0.2 0.2c3.2 3 8.3 2.8 11.3-0.5l24.1-26.2c2.9-3.2 2.8-8.1-0.3-11.2l-53.7-52.1c-3.1-3-8.1-3-11.2 0.1l-24.7 24.7c-3.1 3.1-3.1 8.2 0.1 11.3l54.2 53.7z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M866.9 169.9L527.1 54.1C523 52.7 517.5 52 512 52s-11 0.7-15.1 2.1L157.1 169.9c-8.3 2.8-15.1 12.4-15.1 21.2v482.4c0 8.8 5.7 20.4 12.6 25.9L499.3 968c3.5 2.7 8 4.1 12.6 4.1s9.2-1.4 12.6-4.1l344.7-268.6c6.9-5.4 12.6-17 12.6-25.9V191.1c0.2-8.8-6.6-18.3-14.9-21.2zM810 654.3L512 886.5 214 654.3V226.7l298-101.6 298 101.6v427.6z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M452 297v36c0 4.4 3.6 8 8 8h108v274h-38V405c0-4.4-3.6-8-8-8h-35c-4.4 0-8 3.6-8 8v210h-31c-4.4 0-8 3.6-8 8v37c0 4.4 3.6 8 8 8h244c4.4 0 8-3.6 8-8v-37c0-4.4-3.6-8-8-8h-72V493h58c4.4 0 8-3.6 8-8v-35c0-4.4-3.6-8-8-8h-58V341h63c4.4 0 8-3.6 8-8v-36c0-4.4-3.6-8-8-8H460c-4.4 0-8 3.6-8 8z"
                }
            }
        ]
    })(props);
}
function AiOutlineVerticalAlignBottom(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M859.9 780H164.1c-4.5 0-8.1 3.6-8.1 8v60c0 4.4 3.6 8 8.1 8h695.8c4.5 0 8.1-3.6 8.1-8v-60c0-4.4-3.6-8-8.1-8zM505.7 669a8 8 0 0 0 12.6 0l112-141.7c4.1-5.2.4-12.9-6.3-12.9h-74.1V176c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8v338.3H400c-6.7 0-10.4 7.7-6.3 12.9l112 141.8z"
                }
            }
        ]
    })(props);
}
function AiOutlineVerticalAlignMiddle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M859.9 474H164.1c-4.5 0-8.1 3.6-8.1 8v60c0 4.4 3.6 8 8.1 8h695.8c4.5 0 8.1-3.6 8.1-8v-60c0-4.4-3.6-8-8.1-8zm-353.6-74.7c2.9 3.7 8.5 3.7 11.3 0l100.8-127.5c3.7-4.7.4-11.7-5.7-11.7H550V104c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8v156h-62.8c-6 0-9.4 7-5.7 11.7l100.8 127.6zm11.4 225.4a7.14 7.14 0 0 0-11.3 0L405.6 752.3a7.23 7.23 0 0 0 5.7 11.7H474v156c0 4.4 3.6 8 8 8h60c4.4 0 8-3.6 8-8V764h62.8c6 0 9.4-7 5.7-11.7L517.7 624.7z"
                }
            }
        ]
    })(props);
}
function AiOutlineVerticalAlignTop(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M859.9 168H164.1c-4.5 0-8.1 3.6-8.1 8v60c0 4.4 3.6 8 8.1 8h695.8c4.5 0 8.1-3.6 8.1-8v-60c0-4.4-3.6-8-8.1-8zM518.3 355a8 8 0 0 0-12.6 0l-112 141.7a7.98 7.98 0 0 0 6.3 12.9h73.9V848c0 4.4 3.6 8 8 8h60c4.4 0 8-3.6 8-8V509.7H624c6.7 0 10.4-7.7 6.3-12.9L518.3 355z"
                }
            }
        ]
    })(props);
}
function AiOutlineVerticalLeft(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M762 164h-64c-4.4 0-8 3.6-8 8v688c0 4.4 3.6 8 8 8h64c4.4 0 8-3.6 8-8V172c0-4.4-3.6-8-8-8zm-508 0v72.4c0 9.5 4.2 18.4 11.4 24.5L564.6 512 265.4 763.1c-7.2 6.1-11.4 15-11.4 24.5V860c0 6.8 7.9 10.5 13.1 6.1L689 512 267.1 157.9A7.95 7.95 0 0 0 254 164z"
                }
            }
        ]
    })(props);
}
function AiOutlineVerticalRight(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M326 164h-64c-4.4 0-8 3.6-8 8v688c0 4.4 3.6 8 8 8h64c4.4 0 8-3.6 8-8V172c0-4.4-3.6-8-8-8zm444 72.4V164c0-6.8-7.9-10.5-13.1-6.1L335 512l421.9 354.1c5.2 4.4 13.1.7 13.1-6.1v-72.4c0-9.4-4.2-18.4-11.4-24.5L459.4 512l299.2-251.1c7.2-6.1 11.4-15.1 11.4-24.5z"
                }
            }
        ]
    })(props);
}
function AiOutlineVideoCameraAdd(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "t": "1569683915274",
            "viewBox": "0 0 1024 1024",
            "version": "1.1"
        },
        "child": [
            {
                "tag": "defs",
                "attr": {},
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M368 724H252V608c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v116H72c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h116v116c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V788h116c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M912 302.3L784 376V224c0-35.3-28.7-64-64-64H128c-35.3 0-64 28.7-64 64v352h72V232h576v560H448v72h272c35.3 0 64-28.7 64-64V648l128 73.7c21.3 12.3 48-3.1 48-27.6V330c0-24.6-26.7-40-48-27.7zM888 625l-104-59.8V458.9L888 399v226z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M320 360c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H208c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h112z"
                }
            }
        ]
    })(props);
}
function AiOutlineVideoCamera(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M912 302.3L784 376V224c0-35.3-28.7-64-64-64H128c-35.3 0-64 28.7-64 64v576c0 35.3 28.7 64 64 64h592c35.3 0 64-28.7 64-64V648l128 73.7c21.3 12.3 48-3.1 48-27.6V330c0-24.6-26.7-40-48-27.7zM712 792H136V232h576v560zm176-167l-104-59.8V458.9L888 399v226zM208 360h112c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H208c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8z"
                }
            }
        ]
    })(props);
}
function AiOutlineWallet(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 464H528V448h312v128zm0 264H184V184h656v200H496c-17.7 0-32 14.3-32 32v192c0 17.7 14.3 32 32 32h344v200zM580 512a40 40 0 1 0 80 0 40 40 0 1 0-80 0z"
                }
            }
        ]
    })(props);
}
function AiOutlineWarning(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M464 720a48 48 0 1 0 96 0 48 48 0 1 0-96 0zm16-304v184c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V416c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8zm475.7 440l-416-720c-6.2-10.7-16.9-16-27.7-16s-21.6 5.3-27.7 16l-416 720C56 877.4 71.4 904 96 904h832c24.6 0 40-26.6 27.7-48zm-783.5-27.9L512 239.9l339.8 588.2H172.2z"
                }
            }
        ]
    })(props);
}
function AiOutlineWechat(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M690.1 377.4c5.9 0 11.8.2 17.6.5-24.4-128.7-158.3-227.1-319.9-227.1C209 150.8 64 271.4 64 420.2c0 81.1 43.6 154.2 111.9 203.6a21.5 21.5 0 0 1 9.1 17.6c0 2.4-.5 4.6-1.1 6.9-5.5 20.3-14.2 52.8-14.6 54.3-.7 2.6-1.7 5.2-1.7 7.9 0 5.9 4.8 10.8 10.8 10.8 2.3 0 4.2-.9 6.2-2l70.9-40.9c5.3-3.1 11-5 17.2-5 3.2 0 6.4.5 9.5 1.4 33.1 9.5 68.8 14.8 105.7 14.8 6 0 11.9-.1 17.8-.4-7.1-21-10.9-43.1-10.9-66 0-135.8 132.2-245.8 295.3-245.8zm-194.3-86.5c23.8 0 43.2 19.3 43.2 43.1s-19.3 43.1-43.2 43.1c-23.8 0-43.2-19.3-43.2-43.1s19.4-43.1 43.2-43.1zm-215.9 86.2c-23.8 0-43.2-19.3-43.2-43.1s19.3-43.1 43.2-43.1 43.2 19.3 43.2 43.1-19.4 43.1-43.2 43.1zm586.8 415.6c56.9-41.2 93.2-102 93.2-169.7 0-124-120.8-224.5-269.9-224.5-149 0-269.9 100.5-269.9 224.5S540.9 847.5 690 847.5c30.8 0 60.6-4.4 88.1-12.3 2.6-.8 5.2-1.2 7.9-1.2 5.2 0 9.9 1.6 14.3 4.1l59.1 34c1.7 1 3.3 1.7 5.2 1.7a9 9 0 0 0 6.4-2.6 9 9 0 0 0 2.6-6.4c0-2.2-.9-4.4-1.4-6.6-.3-1.2-7.6-28.3-12.2-45.3-.5-1.9-.9-3.8-.9-5.7.1-5.9 3.1-11.2 7.6-14.5zM600.2 587.2c-19.9 0-36-16.1-36-35.9 0-19.8 16.1-35.9 36-35.9s36 16.1 36 35.9c0 19.8-16.2 35.9-36 35.9zm179.9 0c-19.9 0-36-16.1-36-35.9 0-19.8 16.1-35.9 36-35.9s36 16.1 36 35.9a36.08 36.08 0 0 1-36 35.9z"
                }
            }
        ]
    })(props);
}
function AiOutlineWeiboCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm-44.4 672C353.1 736 236 680.4 236 588.9c0-47.8 30.2-103.1 82.3-155.3 69.5-69.6 150.6-101.4 181.1-70.8 13.5 13.5 14.8 36.8 6.1 64.6-4.5 14 13.1 6.3 13.1 6.3 56.2-23.6 105.2-25 123.1.7 9.6 13.7 8.6 32.8-.2 55.1-4.1 10.2 1.3 11.8 9 14.1 31.7 9.8 66.9 33.6 66.9 75.5.2 69.5-99.7 156.9-249.8 156.9zm207.3-290.8a34.9 34.9 0 0 0-7.2-34.1 34.68 34.68 0 0 0-33.1-10.7 18.24 18.24 0 0 1-7.6-35.7c24.1-5.1 50.1 2.3 67.7 21.9 17.7 19.6 22.4 46.3 14.9 69.8a18.13 18.13 0 0 1-22.9 11.7 18.18 18.18 0 0 1-11.8-22.9zm106 34.3s0 .1 0 0a21.1 21.1 0 0 1-26.6 13.7 21.19 21.19 0 0 1-13.6-26.7c11-34.2 4-73.2-21.7-101.8a104.04 104.04 0 0 0-98.9-32.1 21.14 21.14 0 0 1-25.1-16.3 21.07 21.07 0 0 1 16.2-25.1c49.4-10.5 102.8 4.8 139.1 45.1 36.3 40.2 46.1 95.1 30.6 143.2zm-334.5 6.1c-91.4 9-160.7 65.1-154.7 125.2 5.9 60.1 84.8 101.5 176.2 92.5 91.4-9.1 160.7-65.1 154.7-125.3-5.9-60.1-84.8-101.5-176.2-92.4zm80.2 141.7c-18.7 42.3-72.3 64.8-117.8 50.1-43.9-14.2-62.5-57.7-43.3-96.8 18.9-38.4 68-60.1 111.5-48.8 45 11.7 68 54.2 49.6 95.5zm-93-32.2c-14.2-5.9-32.4.2-41.2 13.9-8.8 13.8-4.7 30.2 9.3 36.6 14.3 6.5 33.2.3 42-13.8 8.8-14.3 4.2-30.6-10.1-36.7zm34.9-14.5c-5.4-2.2-12.2.5-15.4 5.8-3.1 5.4-1.4 11.5 4.1 13.8 5.5 2.3 12.6-.3 15.8-5.8 3-5.6 1-11.8-4.5-13.8z"
                }
            }
        ]
    })(props);
}
function AiOutlineWeiboSquare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M433.6 595.1c-14.2-5.9-32.4.2-41.2 13.9-8.8 13.8-4.7 30.2 9.3 36.6 14.3 6.5 33.2.3 42-13.8 8.8-14.3 4.2-30.6-10.1-36.7zM880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM467.6 736C353.1 736 236 680.4 236 588.9c0-47.8 30.2-103.1 82.3-155.3 69.5-69.6 150.6-101.4 181.1-70.8 13.5 13.5 14.8 36.8 6.1 64.6-4.5 14 13.1 6.3 13.1 6.3 56.2-23.6 105.2-25 123.1.7 9.6 13.7 8.6 32.8-.2 55.1-4.1 10.2 1.3 11.8 9 14.1 31.7 9.8 66.9 33.6 66.9 75.5.2 69.5-99.7 156.9-249.8 156.9zm207.3-290.8a34.9 34.9 0 0 0-7.2-34.1 34.68 34.68 0 0 0-33.1-10.7 18.24 18.24 0 0 1-7.6-35.7c24.1-5.1 50.1 2.3 67.7 21.9 17.7 19.6 22.4 46.3 14.9 69.8a18.13 18.13 0 0 1-22.9 11.7 18.18 18.18 0 0 1-11.8-22.9zm106 34.3s0 .1 0 0a21.1 21.1 0 0 1-26.6 13.7 21.19 21.19 0 0 1-13.6-26.7c11-34.2 4-73.2-21.7-101.8a104.04 104.04 0 0 0-98.9-32.1 21.14 21.14 0 0 1-25.1-16.3 21.07 21.07 0 0 1 16.2-25.1c49.4-10.5 102.8 4.8 139.1 45.1 36.3 40.2 46.1 95.1 30.6 143.2zm-334.5 6.1c-91.4 9-160.7 65.1-154.7 125.2 5.9 60.1 84.8 101.5 176.2 92.5 91.4-9.1 160.7-65.1 154.7-125.3-5.9-60.1-84.8-101.5-176.2-92.4zm80.2 141.7c-18.7 42.3-72.3 64.8-117.8 50.1-43.9-14.2-62.5-57.7-43.3-96.8 18.9-38.4 68-60.1 111.5-48.8 45 11.7 68 54.2 49.6 95.5zm-58.1-46.7c-5.4-2.2-12.2.5-15.4 5.8-3.1 5.4-1.4 11.5 4.1 13.8 5.5 2.3 12.6-.3 15.8-5.8 3-5.6 1-11.8-4.5-13.8z"
                }
            }
        ]
    })(props);
}
function AiOutlineWeibo(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M457.3 543c-68.1-17.7-145 16.2-174.6 76.2-30.1 61.2-1 129.1 67.8 151.3 71.2 23 155.2-12.2 184.4-78.3 28.7-64.6-7.2-131-77.6-149.2zm-52 156.2c-13.8 22.1-43.5 31.7-65.8 21.6-22-10-28.5-35.7-14.6-57.2 13.7-21.4 42.3-31 64.4-21.7 22.4 9.5 29.6 35 16 57.3zm45.5-58.5c-5 8.6-16.1 12.7-24.7 9.1-8.5-3.5-11.2-13.1-6.4-21.5 5-8.4 15.6-12.4 24.1-9.1 8.7 3.2 11.8 12.9 7 21.5zm334.5-197.2c15 4.8 31-3.4 35.9-18.3 11.8-36.6 4.4-78.4-23.2-109a111.39 111.39 0 0 0-106-34.3 28.45 28.45 0 0 0-21.9 33.8 28.39 28.39 0 0 0 33.8 21.8c18.4-3.9 38.3 1.8 51.9 16.7a54.2 54.2 0 0 1 11.3 53.3 28.45 28.45 0 0 0 18.2 36zm99.8-206c-56.7-62.9-140.4-86.9-217.7-70.5a32.98 32.98 0 0 0-25.4 39.3 33.12 33.12 0 0 0 39.3 25.5c55-11.7 114.4 5.4 154.8 50.1 40.3 44.7 51.2 105.7 34 159.1-5.6 17.4 3.9 36 21.3 41.7 17.4 5.6 36-3.9 41.6-21.2v-.1c24.1-75.4 8.9-161.1-47.9-223.9zM729 499c-12.2-3.6-20.5-6.1-14.1-22.1 13.8-34.7 15.2-64.7.3-86-28-40.1-104.8-37.9-192.8-1.1 0 0-27.6 12.1-20.6-9.8 13.5-43.5 11.5-79.9-9.6-101-47.7-47.8-174.6 1.8-283.5 110.6C127.3 471.1 80 557.5 80 632.2 80 775.1 263.2 862 442.5 862c235 0 391.3-136.5 391.3-245 0-65.5-55.2-102.6-104.8-118zM443 810.8c-143 14.1-266.5-50.5-275.8-144.5-9.3-93.9 99.2-181.5 242.2-195.6 143-14.2 266.5 50.5 275.8 144.4C694.4 709 586 796.6 443 810.8z"
                }
            }
        ]
    })(props);
}
function AiOutlineWhatsApp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "t": "1569683925316",
            "viewBox": "0 0 1024 1024",
            "version": "1.1"
        },
        "child": [
            {
                "tag": "defs",
                "attr": {},
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M713.5 599.9c-10.9-5.6-65.2-32.2-75.3-35.8-10.1-3.8-17.5-5.6-24.8 5.6-7.4 11.1-28.4 35.8-35 43.3-6.4 7.4-12.9 8.3-23.8 2.8-64.8-32.4-107.3-57.8-150-131.1-11.3-19.5 11.3-18.1 32.4-60.2 3.6-7.4 1.8-13.7-1-19.3-2.8-5.6-24.8-59.8-34-81.9-8.9-21.5-18.1-18.5-24.8-18.9-6.4-0.4-13.7-0.4-21.1-0.4-7.4 0-19.3 2.8-29.4 13.7-10.1 11.1-38.6 37.8-38.6 92s39.5 106.7 44.9 114.1c5.6 7.4 77.7 118.6 188.4 166.5 70 30.2 97.4 32.8 132.4 27.6 21.3-3.2 65.2-26.6 74.3-52.5 9.1-25.8 9.1-47.9 6.4-52.5-2.7-4.9-10.1-7.7-21-13z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M925.2 338.4c-22.6-53.7-55-101.9-96.3-143.3-41.3-41.3-89.5-73.8-143.3-96.3C630.6 75.7 572.2 64 512 64h-2c-60.6 0.3-119.3 12.3-174.5 35.9-53.3 22.8-101.1 55.2-142 96.5-40.9 41.3-73 89.3-95.2 142.8-23 55.4-34.6 114.3-34.3 174.9 0.3 69.4 16.9 138.3 48 199.9v152c0 25.4 20.6 46 46 46h152.1c61.6 31.1 130.5 47.7 199.9 48h2.1c59.9 0 118-11.6 172.7-34.3 53.5-22.3 101.6-54.3 142.8-95.2 41.3-40.9 73.8-88.7 96.5-142 23.6-55.2 35.6-113.9 35.9-174.5 0.3-60.9-11.5-120-34.8-175.6z m-151.1 438C704 845.8 611 884 512 884h-1.7c-60.3-0.3-120.2-15.3-173.1-43.5l-8.4-4.5H188V695.2l-4.5-8.4C155.3 633.9 140.3 574 140 513.7c-0.4-99.7 37.7-193.3 107.6-263.8 69.8-70.5 163.1-109.5 262.8-109.9h1.7c50 0 98.5 9.7 144.2 28.9 44.6 18.7 84.6 45.6 119 80 34.3 34.3 61.3 74.4 80 119 19.4 46.2 29.1 95.2 28.9 145.8-0.6 99.6-39.7 192.9-110.1 262.7z"
                }
            }
        ]
    })(props);
}
function AiOutlineWifi(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M723 620.5C666.8 571.6 593.4 542 513 542s-153.8 29.6-210.1 78.6a8.1 8.1 0 0 0-.8 11.2l36 42.9c2.9 3.4 8 3.8 11.4.9C393.1 637.2 450.3 614 513 614s119.9 23.2 163.5 61.5c3.4 2.9 8.5 2.5 11.4-.9l36-42.9c2.8-3.3 2.4-8.3-.9-11.2zm117.4-140.1C751.7 406.5 637.6 362 513 362s-238.7 44.5-327.5 118.4a8.05 8.05 0 0 0-1 11.3l36 42.9c2.8 3.4 7.9 3.8 11.2 1C308 472.2 406.1 434 513 434s205 38.2 281.2 101.6c3.4 2.8 8.4 2.4 11.2-1l36-42.9c2.8-3.4 2.4-8.5-1-11.3zm116.7-139C835.7 241.8 680.3 182 511 182c-168.2 0-322.6 59-443.7 157.4a8 8 0 0 0-1.1 11.4l36 42.9c2.8 3.3 7.8 3.8 11.1 1.1C222 306.7 360.3 254 511 254c151.8 0 291 53.5 400 142.7 3.4 2.8 8.4 2.3 11.2-1.1l36-42.9c2.9-3.4 2.4-8.5-1.1-11.3zM448 778a64 64 0 1 0 128 0 64 64 0 1 0-128 0z"
                }
            }
        ]
    })(props);
}
function AiOutlineWindows(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M120.1 770.6L443 823.2V543.8H120.1v226.8zm63.4-163.5h196.2v141.6l-196.2-31.9V607.1zm340.3 226.5l382 62.2v-352h-382v289.8zm63.4-226.5h255.3v214.4l-255.3-41.6V607.1zm-63.4-415.7v288.8h382V128.1l-382 63.3zm318.7 225.5H587.3V245l255.3-42.3v214.2zm-722.4 63.3H443V201.9l-322.9 53.5v224.8zM183.5 309l196.2-32.5v140.4H183.5V309z"
                }
            }
        ]
    })(props);
}
function AiOutlineWoman(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M712.8 548.8c53.6-53.6 83.2-125 83.2-200.8 0-75.9-29.5-147.2-83.2-200.8C659.2 93.6 587.8 64 512 64s-147.2 29.5-200.8 83.2C257.6 200.9 228 272.1 228 348c0 63.8 20.9 124.4 59.4 173.9 7.3 9.4 15.2 18.3 23.7 26.9 8.5 8.5 17.5 16.4 26.8 23.7 39.6 30.8 86.3 50.4 136.1 57V736H360c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h114v140c0 4.4 3.6 8 8 8h60c4.4 0 8-3.6 8-8V812h114c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8H550V629.5c61.5-8.2 118.2-36.1 162.8-80.7zM512 556c-55.6 0-107.7-21.6-147.1-60.9C325.6 455.8 304 403.6 304 348s21.6-107.7 60.9-147.1C404.2 161.5 456.4 140 512 140s107.7 21.6 147.1 60.9C698.4 240.2 720 292.4 720 348s-21.6 107.7-60.9 147.1C619.7 534.4 567.6 556 512 556z"
                }
            }
        ]
    })(props);
}
function AiOutlineYahoo(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M859.9 681.4h-14.1c-27.1 0-49.2 22.2-49.2 49.3v14.1c0 27.1 22.2 49.3 49.2 49.3h14.1c27.1 0 49.2-22.2 49.2-49.3v-14.1c0-27.1-22.2-49.3-49.2-49.3zM402.6 231C216.2 231 65 357 65 512.5S216.2 794 402.6 794s337.6-126 337.6-281.5S589.1 231 402.6 231zm0 507C245.1 738 121 634.6 121 512.5c0-62.3 32.3-119.7 84.9-161v48.4h37l159.8 159.9v65.3h-84.4v56.3h225.1v-56.3H459v-65.3l103.5-103.6h65.3v-56.3H459v65.3l-28.1 28.1-93.4-93.5h37v-56.3H216.4c49.4-35 114.3-56.6 186.2-56.6 157.6 0 281.6 103.4 281.6 225.5S560.2 738 402.6 738zm534.7-507H824.7c-15.5 0-27.7 12.6-27.1 28.1l13.1 366h84.4l65.4-366.4c2.7-15.2-7.8-27.7-23.2-27.7z"
                }
            }
        ]
    })(props);
}
function AiOutlineYoutube(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M960 509.2c0-2.2 0-4.7-.1-7.6-.1-8.1-.3-17.2-.5-26.9-.8-27.9-2.2-55.7-4.4-81.9-3-36.1-7.4-66.2-13.4-88.8a139.52 139.52 0 0 0-98.3-98.5c-28.3-7.6-83.7-12.3-161.7-15.2-37.1-1.4-76.8-2.3-116.5-2.8-13.9-.2-26.8-.3-38.4-.4h-29.4c-11.6.1-24.5.2-38.4.4-39.7.5-79.4 1.4-116.5 2.8-78 3-133.5 7.7-161.7 15.2A139.35 139.35 0 0 0 82.4 304C76.3 326.6 72 356.7 69 392.8c-2.2 26.2-3.6 54-4.4 81.9-.3 9.7-.4 18.8-.5 26.9 0 2.9-.1 5.4-.1 7.6v5.6c0 2.2 0 4.7.1 7.6.1 8.1.3 17.2.5 26.9.8 27.9 2.2 55.7 4.4 81.9 3 36.1 7.4 66.2 13.4 88.8 12.8 47.9 50.4 85.7 98.3 98.5 28.2 7.6 83.7 12.3 161.7 15.2 37.1 1.4 76.8 2.3 116.5 2.8 13.9.2 26.8.3 38.4.4h29.4c11.6-.1 24.5-.2 38.4-.4 39.7-.5 79.4-1.4 116.5-2.8 78-3 133.5-7.7 161.7-15.2 47.9-12.8 85.5-50.5 98.3-98.5 6.1-22.6 10.4-52.7 13.4-88.8 2.2-26.2 3.6-54 4.4-81.9.3-9.7.4-18.8.5-26.9 0-2.9.1-5.4.1-7.6v-5.6zm-72 5.2c0 2.1 0 4.4-.1 7.1-.1 7.8-.3 16.4-.5 25.7-.7 26.6-2.1 53.2-4.2 77.9-2.7 32.2-6.5 58.6-11.2 76.3-6.2 23.1-24.4 41.4-47.4 47.5-21 5.6-73.9 10.1-145.8 12.8-36.4 1.4-75.6 2.3-114.7 2.8-13.7.2-26.4.3-37.8.3h-28.6l-37.8-.3c-39.1-.5-78.2-1.4-114.7-2.8-71.9-2.8-124.9-7.2-145.8-12.8-23-6.2-41.2-24.4-47.4-47.5-4.7-17.7-8.5-44.1-11.2-76.3-2.1-24.7-3.4-51.3-4.2-77.9-.3-9.3-.4-18-.5-25.7 0-2.7-.1-5.1-.1-7.1v-4.8c0-2.1 0-4.4.1-7.1.1-7.8.3-16.4.5-25.7.7-26.6 2.1-53.2 4.2-77.9 2.7-32.2 6.5-58.6 11.2-76.3 6.2-23.1 24.4-41.4 47.4-47.5 21-5.6 73.9-10.1 145.8-12.8 36.4-1.4 75.6-2.3 114.7-2.8 13.7-.2 26.4-.3 37.8-.3h28.6l37.8.3c39.1.5 78.2 1.4 114.7 2.8 71.9 2.8 124.9 7.2 145.8 12.8 23 6.2 41.2 24.4 47.4 47.5 4.7 17.7 8.5 44.1 11.2 76.3 2.1 24.7 3.4 51.3 4.2 77.9.3 9.3.4 18 .5 25.7 0 2.7.1 5.1.1 7.1v4.8zM423 646l232-135-232-133z"
                }
            }
        ]
    })(props);
}
function AiOutlineYuque(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M854.6 370.6c-9.9-39.4 9.9-102.2 73.4-124.4l-67.9-3.6s-25.7-90-143.6-98c-117.8-8.1-194.9-3-195-3 .1 0 87.4 55.6 52.4 154.7-25.6 52.5-65.8 95.6-108.8 144.7-1.3 1.3-2.5 2.6-3.5 3.7C319.4 605 96 860 96 860c245.9 64.4 410.7-6.3 508.2-91.1 20.5-.2 35.9-.3 46.3-.3 135.8 0 250.6-117.6 245.9-248.4-3.2-89.9-31.9-110.2-41.8-149.6zm-204.1 334c-10.6 0-26.2.1-46.8.3l-23.6.2-17.8 15.5c-47.1 41-104.4 71.5-171.4 87.6-52.5 12.6-110 16.2-172.7 9.6 18-20.5 36.5-41.6 55.4-63.1 92-104.6 173.8-197.5 236.9-268.5l1.4-1.4 1.3-1.5c4.1-4.6 20.6-23.3 24.7-28.1 9.7-11.1 17.3-19.9 24.5-28.6 30.7-36.7 52.2-67.8 69-102.2l1.6-3.3 1.2-3.4c13.7-38.8 15.4-76.9 6.2-112.8 22.5.7 46.5 1.9 71.7 3.6 33.3 2.3 55.5 12.9 71.1 29.2 5.8 6 10.2 12.5 13.4 18.7 1 2 1.7 3.6 2.3 5l5 17.7c-15.7 34.5-19.9 73.3-11.4 107.2 3 11.8 6.9 22.4 12.3 34.4 2.1 4.7 9.5 20.1 11 23.3 10.3 22.7 15.4 43 16.7 78.7 3.3 94.6-82.7 181.9-182 181.9z"
                }
            }
        ]
    })(props);
}
function AiOutlineZhihu(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M564.7 230.1V803h60l25.2 71.4L756.3 803h131.5V230.1H564.7zm247.7 497h-59.9l-75.1 50.4-17.8-50.4h-18V308.3h170.7v418.8zM526.1 486.9H393.3c2.1-44.9 4.3-104.3 6.6-172.9h130.9l-.1-8.1c0-.6-.2-14.7-2.3-29.1-2.1-15-6.6-34.9-21-34.9H287.8c4.4-20.6 15.7-69.7 29.4-93.8l6.4-11.2-12.9-.7c-.8 0-19.6-.9-41.4 10.6-35.7 19-51.7 56.4-58.7 84.4-18.4 73.1-44.6 123.9-55.7 145.6-3.3 6.4-5.3 10.2-6.2 12.8-1.8 4.9-.8 9.8 2.8 13 10.5 9.5 38.2-2.9 38.5-3 .6-.3 1.3-.6 2.2-1 13.9-6.3 55.1-25 69.8-84.5h56.7c.7 32.2 3.1 138.4 2.9 172.9h-141l-2.1 1.5c-23.1 16.9-30.5 63.2-30.8 65.2l-1.4 9.2h167c-12.3 78.3-26.5 113.4-34 127.4-3.7 7-7.3 14-10.7 20.8-21.3 42.2-43.4 85.8-126.3 153.6-3.6 2.8-7 8-4.8 13.7 2.4 6.3 9.3 9.1 24.6 9.1 5.4 0 11.8-.3 19.4-1 49.9-4.4 100.8-18 135.1-87.6 17-35.1 31.7-71.7 43.9-108.9L497 850l5-12c.8-1.9 19-46.3 5.1-95.9l-.5-1.8-108.1-123-22 16.6c6.4-26.1 10.6-49.9 12.5-71.1h158.7v-8c0-40.1-18.5-63.9-19.2-64.9l-2.4-3z"
                }
            }
        ]
    })(props);
}
function AiOutlineZoomIn(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M637 443H519V309c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8v134H325c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h118v134c0 4.4 3.6 8 8 8h60c4.4 0 8-3.6 8-8V519h118c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8zm284 424L775 721c122.1-148.9 113.6-369.5-26-509-148-148.1-388.4-148.1-537 0-148.1 148.6-148.1 389 0 537 139.5 139.6 360.1 148.1 509 26l146 146c3.2 2.8 8.3 2.8 11 0l43-43c2.8-2.7 2.8-7.8 0-11zM696 696c-118.8 118.7-311.2 118.7-430 0-118.7-118.8-118.7-311.2 0-430 118.8-118.7 311.2-118.7 430 0 118.7 118.8 118.7 311.2 0 430z"
                }
            }
        ]
    })(props);
}
function AiOutlineZoomOut(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M637 443H325c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h312c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8zm284 424L775 721c122.1-148.9 113.6-369.5-26-509-148-148.1-388.4-148.1-537 0-148.1 148.6-148.1 389 0 537 139.5 139.6 360.1 148.1 509 26l146 146c3.2 2.8 8.3 2.8 11 0l43-43c2.8-2.7 2.8-7.8 0-11zM696 696c-118.8 118.7-311.2 118.7-430 0-118.7-118.8-118.7-311.2 0-430 118.8-118.7 311.2-118.7 430 0 118.7 118.8 118.7 311.2 0 430z"
                }
            }
        ]
    })(props);
}
function AiTwotoneAccountBook(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#D9D9D9",
                    "d": "M712 304c0 4.4-3.6 8-8 8h-56c-4.4 0-8-3.6-8-8v-48H384v48c0 4.4-3.6 8-8 8h-56c-4.4 0-8-3.6-8-8v-48H184v584h656V256H712v48zm-65.6 121.8l-89.3 164.1h49.1c4.4 0 8 3.6 8 8v21.3c0 4.4-3.6 8-8 8h-65.4v33.7h65.4c4.4 0 8 3.6 8 8v21.3c0 4.4-3.6 8-8 8h-65.4V752c0 4.4-3.6 8-8 8h-41.3c-4.4 0-8-3.6-8-8v-53.8h-65.1c-4.4 0-8-3.6-8-8v-21.3c0-4.4 3.6-8 8-8h65.1v-33.7h-65.1c-4.4 0-8-3.6-8-8v-21.3c0-4.4 3.6-8 8-8H467l-89.3-164c-2.1-3.9-.7-8.8 3.2-10.9 1.1-.7 2.5-1 3.8-1h46a8 8 0 0 1 7.1 4.4l73.4 145.4h2.8l73.4-145.4c1.3-2.7 4.1-4.4 7.1-4.4h45c4.5 0 8 3.6 7.9 8 0 1.3-.4 2.6-1 3.8z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M639.5 414h-45c-3 0-5.8 1.7-7.1 4.4L514 563.8h-2.8l-73.4-145.4a8 8 0 0 0-7.1-4.4h-46c-1.3 0-2.7.3-3.8 1-3.9 2.1-5.3 7-3.2 10.9l89.3 164h-48.6c-4.4 0-8 3.6-8 8v21.3c0 4.4 3.6 8 8 8h65.1v33.7h-65.1c-4.4 0-8 3.6-8 8v21.3c0 4.4 3.6 8 8 8h65.1V752c0 4.4 3.6 8 8 8h41.3c4.4 0 8-3.6 8-8v-53.8h65.4c4.4 0 8-3.6 8-8v-21.3c0-4.4-3.6-8-8-8h-65.4v-33.7h65.4c4.4 0 8-3.6 8-8v-21.3c0-4.4-3.6-8-8-8h-49.1l89.3-164.1c.6-1.2 1-2.5 1-3.8.1-4.4-3.4-8-7.9-8z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M880 184H712v-64c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v64H384v-64c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v64H144c-17.7 0-32 14.3-32 32v664c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V216c0-17.7-14.3-32-32-32zm-40 656H184V256h128v48c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-48h256v48c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-48h128v584z"
                }
            }
        ]
    })(props);
}
function AiTwotoneAlert(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#D9D9D9",
                    "d": "M340 585c0-5.5 4.5-10 10-10h44c5.5 0 10 4.5 10 10v171h355V563c0-136.4-110.6-247-247-247S265 426.6 265 563v193h75V585z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M216.9 310.5l39.6-39.6c3.1-3.1 3.1-8.2 0-11.3l-67.9-67.9a8.03 8.03 0 0 0-11.3 0l-39.6 39.6a8.03 8.03 0 0 0 0 11.3l67.9 67.9c3.1 3.1 8.1 3.1 11.3 0zm669.6-79.2l-39.6-39.6a8.03 8.03 0 0 0-11.3 0l-67.9 67.9a8.03 8.03 0 0 0 0 11.3l39.6 39.6c3.1 3.1 8.2 3.1 11.3 0l67.9-67.9c3.1-3.2 3.1-8.2 0-11.3zM484 180h56c4.4 0 8-3.6 8-8V76c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v96c0 4.4 3.6 8 8 8zm348 712H192c-17.7 0-32 14.3-32 32v24c0 4.4 3.6 8 8 8h688c4.4 0 8-3.6 8-8v-24c0-17.7-14.3-32-32-32zm-639-96c0 17.7 14.3 32 32 32h574c17.7 0 32-14.3 32-32V563c0-176.2-142.8-319-319-319S193 386.8 193 563v233zm72-233c0-136.4 110.6-247 247-247s247 110.6 247 247v193H404V585c0-5.5-4.5-10-10-10h-44c-5.5 0-10 4.5-10 10v171h-75V563z"
                }
            }
        ]
    })(props);
}
function AiTwotoneApi(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#D9D9D9",
                    "d": "M148.2 674.6zm106.7-92.3c-25 25-38.7 58.1-38.7 93.4s13.8 68.5 38.7 93.4c25 25 58.1 38.7 93.4 38.7 35.3 0 68.5-13.8 93.4-38.7l59.4-59.4-186.8-186.8-59.4 59.4zm420.8-366.1c-35.3 0-68.5 13.8-93.4 38.7l-59.4 59.4 186.8 186.8 59.4-59.4c24.9-25 38.7-58.1 38.7-93.4s-13.8-68.5-38.7-93.4c-25-25-58.1-38.7-93.4-38.7z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M578.9 546.7a8.03 8.03 0 0 0-11.3 0L501 613.3 410.7 523l66.7-66.7c3.1-3.1 3.1-8.2 0-11.3L441 408.6a8.03 8.03 0 0 0-11.3 0L363 475.3l-43-43a7.85 7.85 0 0 0-5.7-2.3c-2 0-4.1.8-5.7 2.3L206.8 534.2a199.45 199.45 0 0 0-58.6 140.4c-.2 39.5 11.2 79.1 34.3 113.1l-76.1 76.1a8.03 8.03 0 0 0 0 11.3l42.4 42.4c1.6 1.6 3.6 2.3 5.7 2.3s4.1-.8 5.7-2.3l76.1-76.1c33.7 22.9 72.9 34.3 112.1 34.3 51.2 0 102.4-19.5 141.5-58.6l101.9-101.9c3.1-3.1 3.1-8.2 0-11.3l-43-43 66.7-66.7c3.1-3.1 3.1-8.2 0-11.3l-36.6-36.2zM441.7 769.1a131.32 131.32 0 0 1-93.4 38.7c-35.3 0-68.4-13.7-93.4-38.7-24.9-24.9-38.7-58.1-38.7-93.4s13.7-68.4 38.7-93.4l59.4-59.4 186.8 186.8-59.4 59.4zm476-620.3l-42.4-42.4c-1.6-1.6-3.6-2.3-5.7-2.3s-4.1.8-5.7 2.3l-76.1 76.1a199.27 199.27 0 0 0-112.1-34.3c-51.2 0-102.4 19.5-141.5 58.6L432.3 308.7a8.03 8.03 0 0 0 0 11.3L704 591.7c1.6 1.6 3.6 2.3 5.7 2.3 2 0 4.1-.8 5.7-2.3l101.9-101.9c68.9-69 77-175.7 24.3-253.5l76.1-76.1c3.1-3.2 3.1-8.3 0-11.4zM769.1 441.7l-59.4 59.4-186.8-186.8 59.4-59.4c24.9-24.9 58.1-38.7 93.4-38.7s68.4 13.7 93.4 38.7c24.9 24.9 38.7 58.1 38.7 93.4s-13.8 68.4-38.7 93.4z"
                }
            }
        ]
    })(props);
}
function AiTwotoneAppstore(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M864 144H560c-8.8 0-16 7.2-16 16v304c0 8.8 7.2 16 16 16h304c8.8 0 16-7.2 16-16V160c0-8.8-7.2-16-16-16zm-52 268H612V212h200v200zM464 544H160c-8.8 0-16 7.2-16 16v304c0 8.8 7.2 16 16 16h304c8.8 0 16-7.2 16-16V560c0-8.8-7.2-16-16-16zm-52 268H212V612h200v200zm52-668H160c-8.8 0-16 7.2-16 16v304c0 8.8 7.2 16 16 16h304c8.8 0 16-7.2 16-16V160c0-8.8-7.2-16-16-16zm-52 268H212V212h200v200zm452 132H560c-8.8 0-16 7.2-16 16v304c0 8.8 7.2 16 16 16h304c8.8 0 16-7.2 16-16V560c0-8.8-7.2-16-16-16zm-52 268H612V612h200v200z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#E6E6E6",
                    "d": "M212 212h200v200H212zm400 0h200v200H612zM212 612h200v200H212zm400 0h200v200H612z"
                }
            }
        ]
    })(props);
}
function AiTwotoneAudio(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#D9D9D9",
                    "d": "M512 552c54.3 0 98-43.2 98-96V232c0-52.8-43.7-96-98-96s-98 43.2-98 96v224c0 52.8 43.7 96 98 96z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M842 454c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8 0 140.3-113.7 254-254 254S258 594.3 258 454c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8 0 168.7 126.6 307.9 290 327.6V884H326.7c-13.7 0-24.7 14.3-24.7 32v36c0 4.4 2.8 8 6.2 8h407.6c3.4 0 6.2-3.6 6.2-8v-36c0-17.7-11-32-24.7-32H548V782.1c165.3-18 294-158 294-328.1z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M512 624c93.9 0 170-75.2 170-168V232c0-92.8-76.1-168-170-168s-170 75.2-170 168v224c0 92.8 76.1 168 170 168zm-98-392c0-52.8 43.7-96 98-96s98 43.2 98 96v224c0 52.8-43.7 96-98 96s-98-43.2-98-96V232z"
                }
            }
        ]
    })(props);
}
function AiTwotoneBank(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#D9D9D9",
                    "d": "M240.9 393.9h542.2L512 196.7z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M894 462c30.9 0 43.8-39.7 18.7-58L530.8 126.2a31.81 31.81 0 0 0-37.6 0L111.3 404c-25.1 18.2-12.2 58 18.8 58H192v374h-72c-4.4 0-8 3.6-8 8v52c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-52c0-4.4-3.6-8-8-8h-72V462h62zM381 836H264V462h117v374zm189 0H453V462h117v374zm190 0H642V462h118v374zM240.9 393.9L512 196.7l271.1 197.2H240.9z"
                }
            }
        ]
    })(props);
}
function AiTwotoneBell(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#D9D9D9",
                    "d": "M512 220c-55.6 0-107.8 21.6-147.1 60.9S304 372.4 304 428v340h416V428c0-55.6-21.6-107.8-60.9-147.1S567.6 220 512 220zm280 208c0-141.1-104.3-257.8-240-277.2v.1c135.7 19.4 240 136 240 277.1zM472 150.9v-.1C336.3 170.2 232 286.9 232 428c0-141.1 104.3-257.7 240-277.1z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M816 768h-24V428c0-141.1-104.3-257.7-240-277.1V112c0-22.1-17.9-40-40-40s-40 17.9-40 40v38.9c-135.7 19.4-240 136-240 277.1v340h-24c-17.7 0-32 14.3-32 32v32c0 4.4 3.6 8 8 8h216c0 61.8 50.2 112 112 112s112-50.2 112-112h216c4.4 0 8-3.6 8-8v-32c0-17.7-14.3-32-32-32zM512 888c-26.5 0-48-21.5-48-48h96c0 26.5-21.5 48-48 48zm208-120H304V428c0-55.6 21.6-107.8 60.9-147.1S456.4 220 512 220c55.6 0 107.8 21.6 147.1 60.9S720 372.4 720 428v340z"
                }
            }
        ]
    })(props);
}
function AiTwotoneBook(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M832 64H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32zm-260 72h96v209.9L621.5 312 572 347.4V136zM232 888V136h280v296.9c0 3.3 1 6.6 3 9.3a15.9 15.9 0 0 0 22.3 3.7l83.8-59.9 81.4 59.4c2.7 2 6 3.1 9.4 3.1 8.8 0 16-7.2 16-16V136h64v752H232z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#E6E6E6",
                    "d": "M668 345.9V136h-96v211.4l49.5-35.4z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#E6E6E6",
                    "d": "M727.9 136v296.5c0 8.8-7.2 16-16 16-3.4 0-6.7-1.1-9.4-3.1L621.1 386l-83.8 59.9a15.9 15.9 0 0 1-22.3-3.7c-2-2.7-3-6-3-9.3V136H232v752h559.9V136h-64z"
                }
            }
        ]
    })(props);
}
function AiTwotoneBoxPlot(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#D9D9D9",
                    "d": "M296 368h88v288h-88zm152 0h280v288H448z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M952 224h-52c-4.4 0-8 3.6-8 8v248h-92V304c0-4.4-3.6-8-8-8H232c-4.4 0-8 3.6-8 8v176h-92V232c0-4.4-3.6-8-8-8H72c-4.4 0-8 3.6-8 8v560c0 4.4 3.6 8 8 8h52c4.4 0 8-3.6 8-8V548h92v172c0 4.4 3.6 8 8 8h560c4.4 0 8-3.6 8-8V548h92v244c0 4.4 3.6 8 8 8h52c4.4 0 8-3.6 8-8V232c0-4.4-3.6-8-8-8zM384 656h-88V368h88v288zm344 0H448V368h280v288z"
                }
            }
        ]
    })(props);
}
function AiTwotoneBug(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M308 412v268c0 36.779 9.678 71.962 27.805 102.907a205.39 205.39 0 0 0 73.288 73.288C440.038 874.322 475.22 884 512 884c36.779 0 71.962-9.678 102.907-27.805a205.39 205.39 0 0 0 73.288-73.288C706.322 751.962 716 716.78 716 680V412H308zm484 172v96c0 6.503-.222 12.954-.658 19.346C859.931 728.636 908 796.705 908 876a8 8 0 0 1-8 8h-56a8 8 0 0 1-8-8c0-44.24-23.94-82.888-59.57-103.697a278.635 278.635 0 0 1-22.658 49.018 281.39 281.39 0 0 1-100.45 100.45C611.84 946.072 563.546 960 512 960s-99.84-13.929-141.321-38.228a281.39 281.39 0 0 1-100.45-100.45 278.635 278.635 0 0 1-22.658-49.019C211.94 793.113 188 831.76 188 876a8 8 0 0 1-8 8h-56a8 8 0 0 1-8-8c0-79.295 48.07-147.363 116.658-176.654A284.122 284.122 0 0 1 232 680v-96H84a8 8 0 0 1-8-8v-56a8 8 0 0 1 8-8h148V412c-76.768 0-139-62.232-139-139a8 8 0 0 1 8-8h60a8 8 0 0 1 8 8c0 34.794 28.206 63 63 63h560c34.794 0 63-28.206 63-63a8 8 0 0 1 8-8h60a8 8 0 0 1 8 8c0 76.768-62.232 139-139 139v100h148a8 8 0 0 1 8 8v56a8 8 0 0 1-8 8H792zM368 272a8 8 0 0 1-8 8h-56a8 8 0 0 1-8-8c0-40.039 8.779-76.746 25.9-108.068 17.235-31.526 42.506-56.797 74.032-74.031C427.254 72.779 463.962 64 504 64h16c40.039 0 76.746 8.779 108.068 25.9 31.526 17.235 56.797 42.506 74.031 74.032C719.221 195.254 728 231.962 728 272a8 8 0 0 1-8 8h-56a8 8 0 0 1-8-8c0-28.326-5.938-53.154-17.077-73.531-10.625-19.437-25.955-34.767-45.392-45.392C573.154 141.937 548.326 136 520 136h-16c-28.326 0-53.154 5.938-73.531 17.077-19.437 10.625-34.767 25.955-45.392 45.392C373.937 218.846 368 243.674 368 272z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M308 412v268c0 36.779 9.678 71.962 27.805 102.907a205.39 205.39 0 0 0 73.288 73.288C440.038 874.322 475.22 884 512 884c36.779 0 71.962-9.678 102.907-27.805a205.39 205.39 0 0 0 73.288-73.288C706.322 751.962 716 716.78 716 680V412H308z",
                    "fill": "#E6E6E6"
                }
            }
        ]
    })(props);
}
function AiTwotoneBuild(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#D9D9D9",
                    "d": "M144 546h200v200H144zm268-268h200v200H412z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M916 210H376c-17.7 0-32 14.3-32 32v236H108c-17.7 0-32 14.3-32 32v272c0 17.7 14.3 32 32 32h540c17.7 0 32-14.3 32-32V546h236c17.7 0 32-14.3 32-32V242c0-17.7-14.3-32-32-32zM344 746H144V546h200v200zm268 0H412V546h200v200zm0-268H412V278h200v200zm268 0H680V278h200v200z"
                }
            }
        ]
    })(props);
}
function AiTwotoneBulb(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#D9D9D9",
                    "d": "M512 136c-141.4 0-256 114.6-256 256 0 92.5 49.4 176.3 128.1 221.8l35.9 20.8V752h184V634.6l35.9-20.8C718.6 568.3 768 484.5 768 392c0-141.4-114.6-256-256-256z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M632 888H392c-4.4 0-8 3.6-8 8v32c0 17.7 14.3 32 32 32h192c17.7 0 32-14.3 32-32v-32c0-4.4-3.6-8-8-8zM512 64c-181.1 0-328 146.9-328 328 0 121.4 66 227.4 164 284.1V792c0 17.7 14.3 32 32 32h264c17.7 0 32-14.3 32-32V676.1c98-56.7 164-162.7 164-284.1 0-181.1-146.9-328-328-328zm127.9 549.8L604 634.6V752H420V634.6l-35.9-20.8C305.4 568.3 256 484.5 256 392c0-141.4 114.6-256 256-256s256 114.6 256 256c0 92.5-49.4 176.3-128.1 221.8z"
                }
            }
        ]
    })(props);
}
function AiTwotoneCalculator(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#E6E6E6",
                    "d": "M184 840h656V184H184v656zm256.2-75h-50.8c-2.2 0-4.5-1.1-5.9-2.9L348 718.6l-35.5 43.5a7.38 7.38 0 0 1-5.9 2.9h-50.8c-6.6 0-10.2-7.9-5.8-13.1l62.7-76.8-61.2-74.9c-4.3-5.2-.7-13.1 5.9-13.1h50.9c2.2 0 4.5 1.1 5.9 2.9l34 41.6 34-41.6c1.5-1.9 3.6-2.9 5.9-2.9h50.8c6.6 0 10.2 7.9 5.9 13.1L383.5 675l62.7 76.8c4.2 5.3.6 13.2-6 13.2zM576 335c0-2.2 1.4-4 3.2-4h193.5c1.9 0 3.3 1.8 3.3 4v48c0 2.2-1.4 4-3.2 4H579.2c-1.8 0-3.2-1.8-3.2-4v-48zm0 265c0-2.2 1.4-4 3.2-4h193.5c1.9 0 3.3 1.8 3.3 4v48c0 2.2-1.4 4-3.2 4H579.2c-1.8 0-3.2-1.8-3.2-4v-48zm0 104c0-2.2 1.4-4 3.2-4h193.5c1.9 0 3.3 1.8 3.3 4v48c0 2.2-1.4 4-3.2 4H579.2c-1.8 0-3.2-1.8-3.2-4v-48zM248 335c0-2.2 1.4-4 3.2-4H320v-68.8c0-1.8 1.8-3.2 4-3.2h48c2.2 0 4 1.4 4 3.2V331h68.7c1.9 0 3.3 1.8 3.3 4v48c0 2.2-1.4 4-3.2 4H376v68.7c0 1.9-1.8 3.3-4 3.3h-48c-2.2 0-4-1.4-4-3.2V387h-68.8c-1.8 0-3.2-1.8-3.2-4v-48z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M383.5 675l61.3-74.8c4.3-5.2.7-13.1-5.9-13.1h-50.8c-2.3 0-4.4 1-5.9 2.9l-34 41.6-34-41.6a7.69 7.69 0 0 0-5.9-2.9h-50.9c-6.6 0-10.2 7.9-5.9 13.1l61.2 74.9-62.7 76.8c-4.4 5.2-.8 13.1 5.8 13.1h50.8c2.3 0 4.4-1 5.9-2.9l35.5-43.5 35.5 43.5c1.4 1.8 3.7 2.9 5.9 2.9h50.8c6.6 0 10.2-7.9 6-13.2L383.5 675zM251.2 387H320v68.8c0 1.8 1.8 3.2 4 3.2h48c2.2 0 4-1.4 4-3.3V387h68.8c1.8 0 3.2-1.8 3.2-4v-48c0-2.2-1.4-4-3.3-4H376v-68.8c0-1.8-1.8-3.2-4-3.2h-48c-2.2 0-4 1.4-4 3.2V331h-68.8c-1.8 0-3.2 1.8-3.2 4v48c0 2.2 1.4 4 3.2 4zm328 369h193.6c1.8 0 3.2-1.8 3.2-4v-48c0-2.2-1.4-4-3.3-4H579.2c-1.8 0-3.2 1.8-3.2 4v48c0 2.2 1.4 4 3.2 4zm0-104h193.6c1.8 0 3.2-1.8 3.2-4v-48c0-2.2-1.4-4-3.3-4H579.2c-1.8 0-3.2 1.8-3.2 4v48c0 2.2 1.4 4 3.2 4zm0-265h193.6c1.8 0 3.2-1.8 3.2-4v-48c0-2.2-1.4-4-3.3-4H579.2c-1.8 0-3.2 1.8-3.2 4v48c0 2.2 1.4 4 3.2 4z"
                }
            }
        ]
    })(props);
}
function AiTwotoneCalendar(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#D9D9D9",
                    "d": "M712 304c0 4.4-3.6 8-8 8h-56c-4.4 0-8-3.6-8-8v-48H384v48c0 4.4-3.6 8-8 8h-56c-4.4 0-8-3.6-8-8v-48H184v136h656V256H712v48z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M880 184H712v-64c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v64H384v-64c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v64H144c-17.7 0-32 14.3-32 32v664c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V216c0-17.7-14.3-32-32-32zm-40 656H184V460h656v380zm0-448H184V256h128v48c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-48h256v48c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-48h128v136z"
                }
            }
        ]
    })(props);
}
function AiTwotoneCamera(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#D9D9D9",
                    "d": "M864 320H677.2l-17.1-47.8-22.9-64.2H386.7l-22.9 64.2-17.1 47.8H160c-4.4 0-8 3.6-8 8v456c0 4.4 3.6 8 8 8h704c4.4 0 8-3.6 8-8V328c0-4.4-3.6-8-8-8zM512 704c-88.4 0-160-71.6-160-160s71.6-160 160-160 160 71.6 160 160-71.6 160-160 160z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M512 384c-88.4 0-160 71.6-160 160s71.6 160 160 160 160-71.6 160-160-71.6-160-160-160zm0 256c-53 0-96-43-96-96s43-96 96-96 96 43 96 96-43 96-96 96z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M864 248H728l-32.4-90.8a32.07 32.07 0 0 0-30.2-21.2H358.6c-13.5 0-25.6 8.5-30.1 21.2L296 248H160c-44.2 0-80 35.8-80 80v456c0 44.2 35.8 80 80 80h704c44.2 0 80-35.8 80-80V328c0-44.2-35.8-80-80-80zm8 536c0 4.4-3.6 8-8 8H160c-4.4 0-8-3.6-8-8V328c0-4.4 3.6-8 8-8h186.7l17.1-47.8 22.9-64.2h250.5l22.9 64.2 17.1 47.8H864c4.4 0 8 3.6 8 8v456z"
                }
            }
        ]
    })(props);
}
function AiTwotoneCar(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#D9D9D9",
                    "d": "M199.6 474L184 517v237h656V517l-15.6-43H199.6zM264 621c-22.1 0-40-17.9-40-40s17.9-40 40-40 40 17.9 40 40-17.9 40-40 40zm388 75c0 4.4-3.6 8-8 8H380c-4.4 0-8-3.6-8-8v-84c0-4.4 3.6-8 8-8h40c4.4 0 8 3.6 8 8v36h168v-36c0-4.4 3.6-8 8-8h40c4.4 0 8 3.6 8 8v84zm108-75c-22.1 0-40-17.9-40-40s17.9-40 40-40 40 17.9 40 40-17.9 40-40 40z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M720 581a40 40 0 1 0 80 0 40 40 0 1 0-80 0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M959 413.4L935.3 372a8 8 0 0 0-10.9-2.9l-50.7 29.6-78.3-216.2a63.9 63.9 0 0 0-60.9-44.4H301.2c-34.7 0-65.5 22.4-76.2 55.5l-74.6 205.2-50.8-29.6a8 8 0 0 0-10.9 2.9L65 413.4c-2.2 3.8-.9 8.6 2.9 10.8l60.4 35.2-14.5 40c-1.2 3.2-1.8 6.6-1.8 10v348.2c0 15.7 11.8 28.4 26.3 28.4h67.6c12.3 0 23-9.3 25.6-22.3l7.7-37.7h545.6l7.7 37.7c2.7 13 13.3 22.3 25.6 22.3h67.6c14.5 0 26.3-12.7 26.3-28.4V509.4c0-3.4-.6-6.8-1.8-10l-14.5-40 60.3-35.2a8 8 0 0 0 3-10.8zM292.7 218.1l.5-1.3.4-1.3c1.1-3.3 4.1-5.5 7.6-5.5h427.6l75.4 208H220l72.7-199.9zM840 754H184V517l15.6-43h624.8l15.6 43v237z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M224 581a40 40 0 1 0 80 0 40 40 0 1 0-80 0zm420 23h-40c-4.4 0-8 3.6-8 8v36H428v-36c0-4.4-3.6-8-8-8h-40c-4.4 0-8 3.6-8 8v84c0 4.4 3.6 8 8 8h264c4.4 0 8-3.6 8-8v-84c0-4.4-3.6-8-8-8z"
                }
            }
        ]
    })(props);
}
function AiTwotoneCarryOut(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M880 184H712v-64c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v64H384v-64c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v64H144c-17.7 0-32 14.3-32 32v664c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V216c0-17.7-14.3-32-32-32zm-40 656H184V256h128v48c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-48h256v48c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-48h128v584z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#E6E6E6",
                    "d": "M712 304c0 4.4-3.6 8-8 8h-56c-4.4 0-8-3.6-8-8v-48H384v48c0 4.4-3.6 8-8 8h-56c-4.4 0-8-3.6-8-8v-48H184v584h656V256H712v48zm-17.5 128.8L481.9 725.5a16.1 16.1 0 0 1-26 0l-126.4-174c-3.8-5.3 0-12.7 6.5-12.7h55.2c5.2 0 10 2.5 13 6.6l64.7 89 150.9-207.8c3-4.1 7.9-6.6 13-6.6H688c6.5 0 10.3 7.4 6.5 12.8z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M688 420h-55.2c-5.1 0-10 2.5-13 6.6L468.9 634.4l-64.7-89c-3-4.1-7.8-6.6-13-6.6H336c-6.5 0-10.3 7.4-6.5 12.7l126.4 174a16.1 16.1 0 0 0 26 0l212.6-292.7c3.8-5.4 0-12.8-6.5-12.8z"
                }
            }
        ]
    })(props);
}
function AiTwotoneCheckCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#E6E6E6",
                    "d": "M512 140c-205.4 0-372 166.6-372 372s166.6 372 372 372 372-166.6 372-372-166.6-372-372-372zm193.4 225.7l-210.6 292a31.8 31.8 0 0 1-51.7 0L318.5 484.9c-3.8-5.3 0-12.7 6.5-12.7h46.9c10.3 0 19.9 5 25.9 13.3l71.2 98.8 157.2-218c6-8.4 15.7-13.3 25.9-13.3H699c6.5 0 10.3 7.4 6.4 12.7z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M699 353h-46.9c-10.2 0-19.9 4.9-25.9 13.3L469 584.3l-71.2-98.8c-6-8.3-15.6-13.3-25.9-13.3H325c-6.5 0-10.3 7.4-6.5 12.7l124.6 172.8a31.8 31.8 0 0 0 51.7 0l210.6-292c3.9-5.3.1-12.7-6.4-12.7z"
                }
            }
        ]
    })(props);
}
function AiTwotoneCheckSquare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#E6E6E6",
                    "d": "M184 840h656V184H184v656zm130-367.8h46.9c10.2 0 19.9 4.9 25.9 13.3l71.2 98.8 157.2-218c6-8.3 15.6-13.3 25.9-13.3H688c6.5 0 10.3 7.4 6.5 12.7l-210.6 292a31.8 31.8 0 0 1-51.7 0L307.5 484.9c-3.8-5.3 0-12.7 6.5-12.7z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M432.2 657.7a31.8 31.8 0 0 0 51.7 0l210.6-292c3.8-5.3 0-12.7-6.5-12.7h-46.9c-10.3 0-19.9 5-25.9 13.3L458 584.3l-71.2-98.8c-6-8.4-15.7-13.3-25.9-13.3H314c-6.5 0-10.3 7.4-6.5 12.7l124.7 172.8z"
                }
            }
        ]
    })(props);
}
function AiTwotoneCiCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#E6E6E6",
                    "d": "M512 140c-205.4 0-372 166.6-372 372s166.6 372 372 372 372-166.6 372-372-166.6-372-372-372zm-63.5 522.8c49.3 0 82.8-29.4 87-72.4.4-4.1 3.8-7.3 8-7.3h52.7c2.4 0 4.4 2 4.4 4.4 0 77.4-64.3 132.5-152.3 132.5C345.4 720 286 651.4 286 537.4v-49C286 373.5 345.4 304 448.3 304c88.3 0 152.3 56.9 152.3 138.1 0 2.4-2 4.4-4.4 4.4h-52.6c-4.2 0-7.6-3.2-8-7.4-3.9-46.1-37.5-77.6-87-77.6-61.1 0-95.6 45.4-95.7 126.8v49.3c0 80.3 34.5 125.2 95.6 125.2zM738 704.1c0 4.4-3.6 8-8 8h-50.4c-4.4 0-8-3.6-8-8V319.9c0-4.4 3.6-8 8-8H730c4.4 0 8 3.6 8 8v384.2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M730 311.9h-50.4c-4.4 0-8 3.6-8 8v384.2c0 4.4 3.6 8 8 8H730c4.4 0 8-3.6 8-8V319.9c0-4.4-3.6-8-8-8zm-281.4 49.6c49.5 0 83.1 31.5 87 77.6.4 4.2 3.8 7.4 8 7.4h52.6c2.4 0 4.4-2 4.4-4.4 0-81.2-64-138.1-152.3-138.1C345.4 304 286 373.5 286 488.4v49c0 114 59.4 182.6 162.3 182.6 88 0 152.3-55.1 152.3-132.5 0-2.4-2-4.4-4.4-4.4h-52.7c-4.2 0-7.6 3.2-8 7.3-4.2 43-37.7 72.4-87 72.4-61.1 0-95.6-44.9-95.6-125.2v-49.3c.1-81.4 34.6-126.8 95.7-126.8z"
                }
            }
        ]
    })(props);
}
function AiTwotoneCi(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#E6E6E6",
                    "d": "M512 140c-205.4 0-372 166.6-372 372s166.6 372 372 372 372-166.6 372-372-166.6-372-372-372zm-63.5 522.8c49.3 0 82.8-29.4 87-72.4.4-4.1 3.8-7.3 8-7.3h52.7c2.4 0 4.4 2 4.4 4.4 0 77.4-64.3 132.5-152.3 132.5C345.4 720 286 651.4 286 537.4v-49C286 373.5 345.4 304 448.3 304c88.3 0 152.3 56.9 152.3 138.1 0 2.4-2 4.4-4.4 4.4h-52.6c-4.2 0-7.6-3.2-8-7.4-3.9-46.1-37.5-77.6-87-77.6-61.1 0-95.6 45.4-95.7 126.8v49.3c0 80.3 34.5 125.2 95.6 125.2zM738 704.1c0 4.4-3.6 8-8 8h-50.4c-4.4 0-8-3.6-8-8V319.9c0-4.4 3.6-8 8-8H730c4.4 0 8 3.6 8 8v384.2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M730 311.9h-50.4c-4.4 0-8 3.6-8 8v384.2c0 4.4 3.6 8 8 8H730c4.4 0 8-3.6 8-8V319.9c0-4.4-3.6-8-8-8zm-281.4 49.6c49.5 0 83.1 31.5 87 77.6.4 4.2 3.8 7.4 8 7.4h52.6c2.4 0 4.4-2 4.4-4.4 0-81.2-64-138.1-152.3-138.1C345.4 304 286 373.5 286 488.4v49c0 114 59.4 182.6 162.3 182.6 88 0 152.3-55.1 152.3-132.5 0-2.4-2-4.4-4.4-4.4h-52.7c-4.2 0-7.6 3.2-8 7.3-4.2 43-37.7 72.4-87 72.4-61.1 0-95.6-44.9-95.6-125.2v-49.3c.1-81.4 34.6-126.8 95.7-126.8z"
                }
            }
        ]
    })(props);
}
function AiTwotoneClockCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#E6E6E6",
                    "d": "M512 140c-205.4 0-372 166.6-372 372s166.6 372 372 372 372-166.6 372-372-166.6-372-372-372zm176.5 509.7l-28.6 39a7.99 7.99 0 0 1-11.2 1.7L483.3 569.8a7.92 7.92 0 0 1-3.3-6.5V288c0-4.4 3.6-8 8-8h48.1c4.4 0 8 3.6 8 8v247.5l142.6 103.1c3.6 2.5 4.4 7.5 1.8 11.1z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M686.7 638.6L544.1 535.5V288c0-4.4-3.6-8-8-8H488c-4.4 0-8 3.6-8 8v275.3c0 2.6 1.2 5 3.3 6.5l165.4 120.6c3.6 2.6 8.6 1.9 11.2-1.7l28.6-39c2.6-3.6 1.8-8.6-1.8-11.1z"
                }
            }
        ]
    })(props);
}
function AiTwotoneCloseCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#E6E6E6",
                    "d": "M512 140c-205.4 0-372 166.6-372 372s166.6 372 372 372 372-166.6 372-372-166.6-372-372-372zm171.8 527.1c1.2 1.5 1.9 3.3 1.9 5.2 0 4.5-3.6 8-8 8l-66-.3-99.3-118.4-99.3 118.5-66.1.3c-4.4 0-8-3.6-8-8 0-1.9.7-3.7 1.9-5.2L471 512.3l-130.1-155a8.32 8.32 0 0 1-1.9-5.2c0-4.5 3.6-8 8-8l66.1.3 99.3 118.4 99.4-118.5 66-.3c4.4 0 8 3.6 8 8 0 1.9-.6 3.8-1.8 5.2l-130.1 155 129.9 154.9z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M685.8 352c0-4.4-3.6-8-8-8l-66 .3-99.4 118.5-99.3-118.4-66.1-.3c-4.4 0-8 3.5-8 8 0 1.9.7 3.7 1.9 5.2l130.1 155-130.1 154.9a8.32 8.32 0 0 0-1.9 5.2c0 4.4 3.6 8 8 8l66.1-.3 99.3-118.5L611.7 680l66 .3c4.4 0 8-3.5 8-8 0-1.9-.7-3.7-1.9-5.2L553.9 512.2l130.1-155c1.2-1.4 1.8-3.3 1.8-5.2z"
                }
            }
        ]
    })(props);
}
function AiTwotoneCloseSquare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#E6E6E6",
                    "d": "M184 840h656V184H184v656zm163.9-473.9A7.95 7.95 0 0 1 354 353h58.9c4.7 0 9.2 2.1 12.3 5.7L512 462.2l86.8-103.5c3-3.6 7.5-5.7 12.3-5.7H670c6.8 0 10.5 7.9 6.1 13.1L553.8 512l122.3 145.9c4.4 5.2.7 13.1-6.1 13.1h-58.9c-4.7 0-9.2-2.1-12.3-5.7L512 561.8l-86.8 103.5c-3 3.6-7.5 5.7-12.3 5.7H354c-6.8 0-10.5-7.9-6.1-13.1L470.2 512 347.9 366.1z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M354 671h58.9c4.8 0 9.3-2.1 12.3-5.7L512 561.8l86.8 103.5c3.1 3.6 7.6 5.7 12.3 5.7H670c6.8 0 10.5-7.9 6.1-13.1L553.8 512l122.3-145.9c4.4-5.2.7-13.1-6.1-13.1h-58.9c-4.8 0-9.3 2.1-12.3 5.7L512 462.2l-86.8-103.5c-3.1-3.6-7.6-5.7-12.3-5.7H354c-6.8 0-10.5 7.9-6.1 13.1L470.2 512 347.9 657.9A7.95 7.95 0 0 0 354 671z"
                }
            }
        ]
    })(props);
}
function AiTwotoneCloud(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#D9D9D9",
                    "d": "M791.9 492l-37.8-10-13.8-36.5c-8.6-22.7-20.6-44.1-35.7-63.4a245.73 245.73 0 0 0-52.4-49.9c-41.1-28.9-89.5-44.2-140-44.2s-98.9 15.3-140 44.2a245.6 245.6 0 0 0-52.4 49.9 240.47 240.47 0 0 0-35.7 63.4l-13.9 36.6-37.9 9.9a125.7 125.7 0 0 0-66.1 43.7A123.1 123.1 0 0 0 140 612c0 33.1 12.9 64.3 36.3 87.7 23.4 23.4 54.5 36.3 87.6 36.3h496.2c33.1 0 64.2-12.9 87.6-36.3A123.3 123.3 0 0 0 884 612c0-56.2-37.8-105.5-92.1-120z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M811.4 418.7C765.6 297.9 648.9 212 512.2 212S258.8 297.8 213 418.6C127.3 441.1 64 519.1 64 612c0 110.5 89.5 200 199.9 200h496.2C870.5 812 960 722.5 960 612c0-92.7-63.1-170.7-148.6-193.3zm36.3 281a123.07 123.07 0 0 1-87.6 36.3H263.9c-33.1 0-64.2-12.9-87.6-36.3A123.3 123.3 0 0 1 140 612c0-28 9.1-54.3 26.2-76.3a125.7 125.7 0 0 1 66.1-43.7l37.9-9.9 13.9-36.6c8.6-22.8 20.6-44.1 35.7-63.4a245.6 245.6 0 0 1 52.4-49.9c41.1-28.9 89.5-44.2 140-44.2s98.9 15.3 140 44.2c19.9 14 37.5 30.8 52.4 49.9 15.1 19.3 27.1 40.7 35.7 63.4l13.8 36.5 37.8 10c54.3 14.5 92.1 63.8 92.1 120 0 33.1-12.9 64.3-36.3 87.7z"
                }
            }
        ]
    })(props);
}
function AiTwotoneCode(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#E6E6E6",
                    "d": "M184 840h656V184H184v656zm339.5-223h185c4.1 0 7.5 3.6 7.5 8v48c0 4.4-3.4 8-7.5 8h-185c-4.1 0-7.5-3.6-7.5-8v-48c0-4.4 3.4-8 7.5-8zM308 610.3c0-2.3 1.1-4.6 2.9-6.1L420.7 512l-109.8-92.2a7.63 7.63 0 0 1-2.9-6.1V351c0-6.8 7.9-10.5 13.1-6.1l192 160.9c3.9 3.2 3.9 9.1 0 12.3l-192 161c-5.2 4.4-13.1.7-13.1-6.1v-62.7z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M321.1 679.1l192-161c3.9-3.2 3.9-9.1 0-12.3l-192-160.9A7.95 7.95 0 0 0 308 351v62.7c0 2.4 1 4.6 2.9 6.1L420.7 512l-109.8 92.2a8.1 8.1 0 0 0-2.9 6.1V673c0 6.8 7.9 10.5 13.1 6.1zM516 673c0 4.4 3.4 8 7.5 8h185c4.1 0 7.5-3.6 7.5-8v-48c0-4.4-3.4-8-7.5-8h-185c-4.1 0-7.5 3.6-7.5 8v48z"
                }
            }
        ]
    })(props);
}
function AiTwotoneCompass(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#E6E6E6",
                    "d": "M512 140c-205.4 0-372 166.6-372 372s166.6 372 372 372 372-166.6 372-372-166.6-372-372-372zM327.6 701.7c-2 .9-4.4 0-5.3-2.1-.4-1-.4-2.2 0-3.2L421 470.9 553.1 603l-225.5 98.7zm375.1-375.1L604 552.1 471.9 420l225.5-98.7c2-.9 4.4 0 5.3 2.1.4 1 .4 2.1 0 3.2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M322.3 696.4c-.4 1-.4 2.2 0 3.2.9 2.1 3.3 3 5.3 2.1L553.1 603 421 470.9l-98.7 225.5zm375.1-375.1L471.9 420 604 552.1l98.7-225.5c.4-1.1.4-2.2 0-3.2-.9-2.1-3.3-3-5.3-2.1z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z"
                }
            }
        ]
    })(props);
}
function AiTwotoneContacts(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#D9D9D9",
                    "d": "M460.3 526a51.7 52 0 1 0 103.4 0 51.7 52 0 1 0-103.4 0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#D9D9D9",
                    "d": "M768 352c0 4.4-3.6 8-8 8h-56c-4.4 0-8-3.6-8-8v-56H548v56c0 4.4-3.6 8-8 8h-56c-4.4 0-8-3.6-8-8v-56H328v56c0 4.4-3.6 8-8 8h-56c-4.4 0-8-3.6-8-8v-56H136v496h752V296H768v56zM661 736h-43.8c-4.2 0-7.6-3.3-7.9-7.5-3.8-50.5-46-90.5-97.2-90.5s-93.4 39.9-97.2 90.5c-.3 4.2-3.7 7.5-7.9 7.5h-43.9a8 8 0 0 1-8-8.4c2.8-53.3 31.9-99.6 74.6-126.1-18.1-20-29.1-46.4-29.1-75.5 0-61.9 49.9-112 111.4-112s111.4 50.1 111.4 112c0 29.1-11 55.6-29.1 75.5 42.7 26.4 71.9 72.8 74.7 126.1a8 8 0 0 1-8 8.4z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M594.3 601.5a111.8 111.8 0 0 0 29.1-75.5c0-61.9-49.9-112-111.4-112s-111.4 50.1-111.4 112c0 29.1 11 55.5 29.1 75.5a158.09 158.09 0 0 0-74.6 126.1 8 8 0 0 0 8 8.4H407c4.2 0 7.6-3.3 7.9-7.5 3.8-50.6 46-90.5 97.2-90.5s93.4 40 97.2 90.5c.3 4.2 3.7 7.5 7.9 7.5H661a8 8 0 0 0 8-8.4c-2.8-53.3-32-99.7-74.7-126.1zM512 578c-28.5 0-51.7-23.3-51.7-52s23.2-52 51.7-52 51.7 23.3 51.7 52-23.2 52-51.7 52z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M928 224H768v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56H548v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56H328v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56H96c-17.7 0-32 14.3-32 32v576c0 17.7 14.3 32 32 32h832c17.7 0 32-14.3 32-32V256c0-17.7-14.3-32-32-32zm-40 568H136V296h120v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56h148v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56h148v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56h120v496z"
                }
            }
        ]
    })(props);
}
function AiTwotoneContainer(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#D9D9D9",
                    "d": "M635 771.7c-34.5 28.6-78.2 44.3-123 44.3s-88.5-15.8-123-44.3a194.02 194.02 0 0 1-59.1-84.7H232v201h560V687h-97.9c-11.6 32.8-32 62.3-59.1 84.7z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M320 501h384c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H320c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M832 64H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32zm-40 824H232V687h97.9c11.6 32.8 32 62.3 59.1 84.7 34.5 28.5 78.2 44.3 123 44.3s88.5-15.7 123-44.3c27.1-22.4 47.5-51.9 59.1-84.7H792v201zm0-264H643.6l-5.2 24.7C626.4 708.5 573.2 752 512 752s-114.4-43.5-126.5-103.3l-5.2-24.7H232V136h560v488z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M320 341h384c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H320c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8z"
                }
            }
        ]
    })(props);
}
function AiTwotoneControl(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#E6E6E6",
                    "d": "M616 440a36 36 0 1 0 72 0 36 36 0 1 0-72 0zM340.4 601.5l1.5 2.4c0 .1.1.1.1.2l.9 1.2c.1.1.2.2.2.3 1 1.3 2 2.5 3.2 3.6l.2.2c.4.4.8.8 1.2 1.1.8.8 1.7 1.5 2.6 2.1h.1l1.2.9c.1.1.3.2.4.3 1.2.8 2.5 1.6 3.9 2.2.2.1.5.2.7.4.4.2.7.3 1.1.5.3.1.7.3 1 .4.5.2 1 .4 1.5.5.4.1.9.3 1.3.4l.9.3 1.4.3c.2.1.5.1.7.2.7.1 1.4.3 2.1.4.2 0 .4 0 .6.1.6.1 1.1.1 1.7.2.2 0 .4 0 .7.1.8 0 1.5.1 2.3.1s1.5 0 2.3-.1c.2 0 .4 0 .7-.1.6 0 1.2-.1 1.7-.2.2 0 .4 0 .6-.1.7-.1 1.4-.2 2.1-.4.2-.1.5-.1.7-.2l1.4-.3.9-.3c.4-.1.9-.3 1.3-.4.5-.2 1-.4 1.5-.5.3-.1.7-.3 1-.4.4-.2.7-.3 1.1-.5.2-.1.5-.2.7-.4 1.3-.7 2.6-1.4 3.9-2.2.1-.1.3-.2.4-.3l1.2-.9h.1c.9-.7 1.8-1.4 2.6-2.1.4-.4.8-.7 1.2-1.1l.2-.2c1.1-1.1 2.2-2.4 3.2-3.6.1-.1.2-.2.2-.3l.9-1.2c0-.1.1-.1.1-.2l1.5-2.4c.1-.2.2-.3.3-.5 2.7-5.1 4.3-10.9 4.3-17s-1.6-12-4.3-17c-.1-.2-.2-.4-.3-.5l-1.5-2.4c0-.1-.1-.1-.1-.2l-.9-1.2c-.1-.1-.2-.2-.2-.3-1-1.3-2-2.5-3.2-3.6l-.2-.2c-.4-.4-.8-.8-1.2-1.1-.8-.8-1.7-1.5-2.6-2.1h-.1l-1.2-.9c-.1-.1-.3-.2-.4-.3-1.2-.8-2.5-1.6-3.9-2.2-.2-.1-.5-.2-.7-.4-.4-.2-.7-.3-1.1-.5-.3-.1-.7-.3-1-.4-.5-.2-1-.4-1.5-.5-.4-.1-.9-.3-1.3-.4l-.9-.3-1.4-.3c-.2-.1-.5-.1-.7-.2-.7-.1-1.4-.3-2.1-.4-.2 0-.4 0-.6-.1-.6-.1-1.1-.1-1.7-.2-.2 0-.4 0-.7-.1-.8 0-1.5-.1-2.3-.1s-1.5 0-2.3.1c-.2 0-.4 0-.7.1-.6 0-1.2.1-1.7.2-.2 0-.4 0-.6.1-.7.1-1.4.2-2.1.4-.2.1-.5.1-.7.2l-1.4.3-.9.3c-.4.1-.9.3-1.3.4-.5.2-1 .4-1.5.5-.3.1-.7.3-1 .4-.4.2-.7.3-1.1.5-.2.1-.5.2-.7.4-1.3.7-2.6 1.4-3.9 2.2-.1.1-.3.2-.4.3l-1.2.9h-.1c-.9.7-1.8 1.4-2.6 2.1-.4.4-.8.7-1.2 1.1l-.2.2a54.8 54.8 0 0 0-3.2 3.6c-.1.1-.2.2-.2.3l-.9 1.2c0 .1-.1.1-.1.2l-1.5 2.4c-.1.2-.2.3-.3.5-2.7 5.1-4.3 10.9-4.3 17s1.6 12 4.3 17c.1.2.2.3.3.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#E6E6E6",
                    "d": "M184 840h656V184H184v656zm436.4-499.1c-.2 0-.3.1-.4.1v-77c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v77c-.2 0-.3-.1-.4-.1 42 13.4 72.4 52.7 72.4 99.1 0 46.4-30.4 85.7-72.4 99.1.2 0 .3-.1.4-.1v221c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V539c.2 0 .3.1.4.1-42-13.4-72.4-52.7-72.4-99.1 0-46.4 30.4-85.7 72.4-99.1zM340 485V264c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v221c41.7 13.6 72 52.8 72 99s-30.3 85.5-72 99v77c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8v-77c-41.7-13.6-72-52.8-72-99s30.3-85.5 72-99z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M340 683v77c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8v-77c41.7-13.5 72-52.8 72-99s-30.3-85.4-72-99V264c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v221c-41.7 13.5-72 52.8-72 99s30.3 85.4 72 99zm.1-116c.1-.2.2-.3.3-.5l1.5-2.4c0-.1.1-.1.1-.2l.9-1.2c0-.1.1-.2.2-.3 1-1.2 2.1-2.5 3.2-3.6l.2-.2c.4-.4.8-.7 1.2-1.1.8-.7 1.7-1.4 2.6-2.1h.1l1.2-.9c.1-.1.3-.2.4-.3 1.3-.8 2.6-1.5 3.9-2.2.2-.2.5-.3.7-.4.4-.2.7-.3 1.1-.5.3-.1.7-.3 1-.4.5-.1 1-.3 1.5-.5.4-.1.9-.3 1.3-.4l.9-.3 1.4-.3c.2-.1.5-.1.7-.2.7-.2 1.4-.3 2.1-.4.2-.1.4-.1.6-.1.5-.1 1.1-.2 1.7-.2.3-.1.5-.1.7-.1.8-.1 1.5-.1 2.3-.1s1.5.1 2.3.1c.3.1.5.1.7.1.6.1 1.1.1 1.7.2.2.1.4.1.6.1.7.1 1.4.3 2.1.4.2.1.5.1.7.2l1.4.3.9.3c.4.1.9.3 1.3.4.5.1 1 .3 1.5.5.3.1.7.3 1 .4.4.2.7.3 1.1.5.2.2.5.3.7.4 1.4.6 2.7 1.4 3.9 2.2.1.1.3.2.4.3l1.2.9h.1c.9.6 1.8 1.3 2.6 2.1.4.3.8.7 1.2 1.1l.2.2c1.2 1.1 2.2 2.3 3.2 3.6 0 .1.1.2.2.3l.9 1.2c0 .1.1.1.1.2l1.5 2.4A36.03 36.03 0 0 1 408 584c0 6.1-1.6 11.9-4.3 17-.1.2-.2.3-.3.5l-1.5 2.4c0 .1-.1.1-.1.2l-.9 1.2c0 .1-.1.2-.2.3-1 1.2-2.1 2.5-3.2 3.6l-.2.2c-.4.4-.8.7-1.2 1.1-.8.7-1.7 1.4-2.6 2.1h-.1l-1.2.9c-.1.1-.3.2-.4.3-1.3.8-2.6 1.5-3.9 2.2-.2.2-.5.3-.7.4-.4.2-.7.3-1.1.5-.3.1-.7.3-1 .4-.5.1-1 .3-1.5.5-.4.1-.9.3-1.3.4l-.9.3-1.4.3c-.2.1-.5.1-.7.2-.7.2-1.4.3-2.1.4-.2.1-.4.1-.6.1-.5.1-1.1.2-1.7.2-.3.1-.5.1-.7.1-.8.1-1.5.1-2.3.1s-1.5-.1-2.3-.1c-.3-.1-.5-.1-.7-.1-.6-.1-1.1-.1-1.7-.2-.2-.1-.4-.1-.6-.1-.7-.1-1.4-.3-2.1-.4-.2-.1-.5-.1-.7-.2l-1.4-.3-.9-.3c-.4-.1-.9-.3-1.3-.4-.5-.1-1-.3-1.5-.5-.3-.1-.7-.3-1-.4-.4-.2-.7-.3-1.1-.5-.2-.2-.5-.3-.7-.4-1.4-.6-2.7-1.4-3.9-2.2-.1-.1-.3-.2-.4-.3l-1.2-.9h-.1c-.9-.6-1.8-1.3-2.6-2.1-.4-.3-.8-.7-1.2-1.1l-.2-.2c-1.2-1.1-2.2-2.3-3.2-3.6 0-.1-.1-.2-.2-.3l-.9-1.2c0-.1-.1-.1-.1-.2l-1.5-2.4c-.1-.2-.2-.3-.3-.5-2.7-5-4.3-10.9-4.3-17s1.6-11.9 4.3-17zm280.3-27.9c-.1 0-.2-.1-.4-.1v221c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V539c-.1 0-.2.1-.4.1 42-13.4 72.4-52.7 72.4-99.1 0-46.4-30.4-85.7-72.4-99.1.1 0 .2.1.4.1v-77c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v77c.1 0 .2-.1.4-.1-42 13.4-72.4 52.7-72.4 99.1 0 46.4 30.4 85.7 72.4 99.1zM652 404c19.9 0 36 16.1 36 36s-16.1 36-36 36-36-16.1-36-36 16.1-36 36-36z"
                }
            }
        ]
    })(props);
}
function AiTwotoneCopy(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#D9D9D9",
                    "d": "M232 706h142c22.1 0 40 17.9 40 40v142h250V264H232v442z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M832 64H296c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h496v688c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V96c0-17.7-14.3-32-32-32z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M704 192H192c-17.7 0-32 14.3-32 32v530.7c0 8.5 3.4 16.6 9.4 22.6l173.3 173.3c2.2 2.2 4.7 4 7.4 5.5v1.9h4.2c3.5 1.3 7.2 2 11 2H704c17.7 0 32-14.3 32-32V224c0-17.7-14.3-32-32-32zM350 856.2L263.9 770H350v86.2zM664 888H414V746c0-22.1-17.9-40-40-40H232V264h432v624z"
                }
            }
        ]
    })(props);
}
function AiTwotoneCopyrightCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#E6E6E6",
                    "d": "M512 140c-205.4 0-372 166.6-372 372s166.6 372 372 372 372-166.6 372-372-166.6-372-372-372zm5.5 533c52.9 0 88.8-31.7 93-77.8.4-4.1 3.8-7.3 8-7.3h56.8c2.6 0 4.7 2.1 4.7 4.7 0 82.6-68.7 141.4-162.7 141.4C407.4 734 344 660.8 344 539.1v-52.3C344 364.2 407.4 290 517.3 290c94.3 0 162.7 60.7 162.7 147.4 0 2.6-2.1 4.7-4.7 4.7h-56.7c-4.2 0-7.7-3.2-8-7.4-4-49.6-40-83.4-93-83.4-65.2 0-102.1 48.5-102.2 135.5v52.6c0 85.7 36.8 133.6 102.1 133.6z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M517.6 351.3c53 0 89 33.8 93 83.4.3 4.2 3.8 7.4 8 7.4h56.7c2.6 0 4.7-2.1 4.7-4.7 0-86.7-68.4-147.4-162.7-147.4C407.4 290 344 364.2 344 486.8v52.3C344 660.8 407.4 734 517.3 734c94 0 162.7-58.8 162.7-141.4 0-2.6-2.1-4.7-4.7-4.7h-56.8c-4.2 0-7.6 3.2-8 7.3-4.2 46.1-40.1 77.8-93 77.8-65.3 0-102.1-47.9-102.1-133.6v-52.6c.1-87 37-135.5 102.2-135.5z"
                }
            }
        ]
    })(props);
}
function AiTwotoneCopyright(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#E6E6E6",
                    "d": "M512 140c-205.4 0-372 166.6-372 372s166.6 372 372 372 372-166.6 372-372-166.6-372-372-372zm5.5 533c52.9 0 88.8-31.7 93-77.8.4-4.1 3.8-7.3 8-7.3h56.8c2.6 0 4.7 2.1 4.7 4.7 0 82.6-68.7 141.4-162.7 141.4C407.4 734 344 660.8 344 539.1v-52.3C344 364.2 407.4 290 517.3 290c94.3 0 162.7 60.7 162.7 147.4 0 2.6-2.1 4.7-4.7 4.7h-56.7c-4.2 0-7.7-3.2-8-7.4-4-49.6-40-83.4-93-83.4-65.2 0-102.1 48.5-102.2 135.5v52.6c0 85.7 36.8 133.6 102.1 133.6z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M517.6 351.3c53 0 89 33.8 93 83.4.3 4.2 3.8 7.4 8 7.4h56.7c2.6 0 4.7-2.1 4.7-4.7 0-86.7-68.4-147.4-162.7-147.4C407.4 290 344 364.2 344 486.8v52.3C344 660.8 407.4 734 517.3 734c94 0 162.7-58.8 162.7-141.4 0-2.6-2.1-4.7-4.7-4.7h-56.8c-4.2 0-7.6 3.2-8 7.3-4.2 46.1-40.1 77.8-93 77.8-65.3 0-102.1-47.9-102.1-133.6v-52.6c.1-87 37-135.5 102.2-135.5z"
                }
            }
        ]
    })(props);
}
function AiTwotoneCreditCard(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#D9D9D9",
                    "d": "M136 792h752V440H136v352zm507-144c0-4.4 3.6-8 8-8h165c4.4 0 8 3.6 8 8v72c0 4.4-3.6 8-8 8H651c-4.4 0-8-3.6-8-8v-72zM136 232h752v120H136z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M651 728h165c4.4 0 8-3.6 8-8v-72c0-4.4-3.6-8-8-8H651c-4.4 0-8 3.6-8 8v72c0 4.4 3.6 8 8 8z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M928 160H96c-17.7 0-32 14.3-32 32v640c0 17.7 14.3 32 32 32h832c17.7 0 32-14.3 32-32V192c0-17.7-14.3-32-32-32zm-40 632H136V440h752v352zm0-440H136V232h752v120z"
                }
            }
        ]
    })(props);
}
function AiTwotoneCrown(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#D9D9D9",
                    "d": "M911.9 283.9v.5L835.5 865c-1 8-7.9 14-15.9 14H204.5c-8.1 0-14.9-6.1-16-14l-76.4-580.6v-.6 1.6L188.5 866c1.1 7.9 7.9 14 16 14h615.1c8 0 14.9-6 15.9-14l76.4-580.6c.1-.5.1-1 0-1.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#D9D9D9",
                    "d": "M773.6 810.6l53.9-409.4-139.8 86.1L512 252.9 336.3 487.3l-139.8-86.1 53.8 409.4h523.3zm-374.2-189c0-62.1 50.5-112.6 112.6-112.6s112.6 50.5 112.6 112.6v1c0 62.1-50.5 112.6-112.6 112.6s-112.6-50.5-112.6-112.6v-1z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M512 734.2c61.9 0 112.3-50.2 112.6-112.1v-.5c0-62.1-50.5-112.6-112.6-112.6s-112.6 50.5-112.6 112.6v.5c.3 61.9 50.7 112.1 112.6 112.1zm0-160.9c26.6 0 48.2 21.6 48.2 48.3 0 26.6-21.6 48.3-48.2 48.3s-48.2-21.6-48.2-48.3c0-26.6 21.6-48.3 48.2-48.3z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M188.5 865c1.1 7.9 7.9 14 16 14h615.1c8 0 14.9-6 15.9-14l76.4-580.6v-.5c.3-6.4-6.7-10.8-12.3-7.4L705 396.4 518.4 147.5a8.06 8.06 0 0 0-12.9 0L319 396.4 124.3 276.5c-5.5-3.4-12.6.9-12.2 7.3v.6L188.5 865zm147.8-377.7L512 252.9l175.7 234.4 139.8-86.1-53.9 409.4H250.3l-53.8-409.4 139.8 86.1z"
                }
            }
        ]
    })(props);
}
function AiTwotoneCustomerService(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#D9D9D9",
                    "d": "M696 632h128v192H696zm-496 0h128v192H200z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M512 128c-212.1 0-384 171.9-384 384v360c0 13.3 10.7 24 24 24h184c35.3 0 64-28.7 64-64V624c0-35.3-28.7-64-64-64H200v-48c0-172.3 139.7-312 312-312s312 139.7 312 312v48H688c-35.3 0-64 28.7-64 64v208c0 35.3 28.7 64 64 64h184c13.3 0 24-10.7 24-24V512c0-212.1-171.9-384-384-384zM328 632v192H200V632h128zm496 192H696V632h128v192z"
                }
            }
        ]
    })(props);
}
function AiTwotoneDashboard(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#D9D9D9",
                    "d": "M512 188c-99.3 0-192.7 38.7-263 109-70.3 70.2-109 163.6-109 263 0 105.6 44.5 205.5 122.6 276h498.8A371.12 371.12 0 0 0 884 560c0-99.3-38.7-192.7-109-263-70.2-70.3-163.6-109-263-109zm-30 44c0-4.4 3.6-8 8-8h44c4.4 0 8 3.6 8 8v80c0 4.4-3.6 8-8 8h-44c-4.4 0-8-3.6-8-8v-80zM270 582c0 4.4-3.6 8-8 8h-80c-4.4 0-8-3.6-8-8v-44c0-4.4 3.6-8 8-8h80c4.4 0 8 3.6 8 8v44zm90.7-204.4l-31.1 31.1a8.03 8.03 0 0 1-11.3 0l-56.6-56.6a8.03 8.03 0 0 1 0-11.3l31.1-31.1c3.1-3.1 8.2-3.1 11.3 0l56.6 56.6c3.1 3.1 3.1 8.2 0 11.3zm291.1 83.5l-84.5 84.5c5 18.7.2 39.4-14.5 54.1a55.95 55.95 0 0 1-79.2 0 55.95 55.95 0 0 1 0-79.2 55.87 55.87 0 0 1 54.1-14.5l84.5-84.5c3.1-3.1 8.2-3.1 11.3 0l28.3 28.3c3.1 3.1 3.1 8.2 0 11.3zm43-52.4l-31.1-31.1a8.03 8.03 0 0 1 0-11.3l56.6-56.6c3.1-3.1 8.2-3.1 11.3 0l31.1 31.1c3.1 3.1 3.1 8.2 0 11.3l-56.6 56.6a8.03 8.03 0 0 1-11.3 0zM846 538v44c0 4.4-3.6 8-8 8h-80c-4.4 0-8-3.6-8-8v-44c0-4.4 3.6-8 8-8h80c4.4 0 8 3.6 8 8z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M623.5 421.5a8.03 8.03 0 0 0-11.3 0L527.7 506c-18.7-5-39.4-.2-54.1 14.5a55.95 55.95 0 0 0 0 79.2 55.95 55.95 0 0 0 79.2 0 55.87 55.87 0 0 0 14.5-54.1l84.5-84.5c3.1-3.1 3.1-8.2 0-11.3l-28.3-28.3zM490 320h44c4.4 0 8-3.6 8-8v-80c0-4.4-3.6-8-8-8h-44c-4.4 0-8 3.6-8 8v80c0 4.4 3.6 8 8 8z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M924.8 385.6a446.7 446.7 0 0 0-96-142.4 446.7 446.7 0 0 0-142.4-96C631.1 123.8 572.5 112 512 112s-119.1 11.8-174.4 35.2a446.7 446.7 0 0 0-142.4 96 446.7 446.7 0 0 0-96 142.4C75.8 440.9 64 499.5 64 560c0 132.7 58.3 257.7 159.9 343.1l1.7 1.4c5.8 4.8 13.1 7.5 20.6 7.5h531.7c7.5 0 14.8-2.7 20.6-7.5l1.7-1.4C901.7 817.7 960 692.7 960 560c0-60.5-11.9-119.1-35.2-174.4zM761.4 836H262.6A371.12 371.12 0 0 1 140 560c0-99.4 38.7-192.8 109-263 70.3-70.3 163.7-109 263-109 99.4 0 192.8 38.7 263 109 70.3 70.3 109 163.7 109 263 0 105.6-44.5 205.5-122.6 276z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M762.7 340.8l-31.1-31.1a8.03 8.03 0 0 0-11.3 0l-56.6 56.6a8.03 8.03 0 0 0 0 11.3l31.1 31.1c3.1 3.1 8.2 3.1 11.3 0l56.6-56.6c3.1-3.1 3.1-8.2 0-11.3zM750 538v44c0 4.4 3.6 8 8 8h80c4.4 0 8-3.6 8-8v-44c0-4.4-3.6-8-8-8h-80c-4.4 0-8 3.6-8 8zM304.1 309.7a8.03 8.03 0 0 0-11.3 0l-31.1 31.1a8.03 8.03 0 0 0 0 11.3l56.6 56.6c3.1 3.1 8.2 3.1 11.3 0l31.1-31.1c3.1-3.1 3.1-8.2 0-11.3l-56.6-56.6zM262 530h-80c-4.4 0-8 3.6-8 8v44c0 4.4 3.6 8 8 8h80c4.4 0 8-3.6 8-8v-44c0-4.4-3.6-8-8-8z"
                }
            }
        ]
    })(props);
}
function AiTwotoneDatabase(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#D8D8D8",
                    "d": "M232 616h560V408H232v208zm112-144c22.1 0 40 17.9 40 40s-17.9 40-40 40-40-17.9-40-40 17.9-40 40-40zM232 888h560V680H232v208zm112-144c22.1 0 40 17.9 40 40s-17.9 40-40 40-40-17.9-40-40 17.9-40 40-40zM232 344h560V136H232v208zm112-144c22.1 0 40 17.9 40 40s-17.9 40-40 40-40-17.9-40-40 17.9-40 40-40z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M304 512a40 40 0 1 0 80 0 40 40 0 1 0-80 0zm0 272a40 40 0 1 0 80 0 40 40 0 1 0-80 0zm0-544a40 40 0 1 0 80 0 40 40 0 1 0-80 0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M832 64H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32zm-40 824H232V680h560v208zm0-272H232V408h560v208zm0-272H232V136h560v208z"
                }
            }
        ]
    })(props);
}
function AiTwotoneDelete(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#D9D9D9",
                    "d": "M292.7 840h438.6l24.2-512h-487z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M864 256H736v-80c0-35.3-28.7-64-64-64H352c-35.3 0-64 28.7-64 64v80H160c-17.7 0-32 14.3-32 32v32c0 4.4 3.6 8 8 8h60.4l24.7 523c1.6 34.1 29.8 61 63.9 61h454c34.2 0 62.3-26.8 63.9-61l24.7-523H888c4.4 0 8-3.6 8-8v-32c0-17.7-14.3-32-32-32zm-504-72h304v72H360v-72zm371.3 656H292.7l-24.2-512h487l-24.2 512z"
                }
            }
        ]
    })(props);
}
function AiTwotoneDiff(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#D9D9D9",
                    "d": "M232 264v624h432V413.8L514.2 264H232zm336 489c0 3.8-3.4 7-7.5 7h-225c-4.1 0-7.5-3.2-7.5-7v-42c0-3.8 3.4-7 7.5-7h225c4.1 0 7.5 3.2 7.5 7v42zm0-262v42c0 3.8-3.4 7-7.5 7H476v84.9c0 3.9-3.1 7.1-7 7.1h-42c-3.8 0-7-3.2-7-7.1V540h-84.5c-4.1 0-7.5-3.2-7.5-7v-42c0-3.9 3.4-7 7.5-7H420v-84.9c0-3.9 3.2-7.1 7-7.1h42c3.9 0 7 3.2 7 7.1V484h84.5c4.1 0 7.5 3.1 7.5 7z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M854.2 306.6L611.3 72.9c-6-5.7-13.9-8.9-22.2-8.9H296c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h277l219 210.6V824c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V329.6c0-8.7-3.5-17-9.8-23z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M553.4 201.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v704c0 17.7 14.3 32 32 32h512c17.7 0 32-14.3 32-32V397.3c0-8.5-3.4-16.6-9.4-22.6L553.4 201.4zM664 888H232V264h282.2L664 413.8V888z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M476 399.1c0-3.9-3.1-7.1-7-7.1h-42c-3.8 0-7 3.2-7 7.1V484h-84.5c-4.1 0-7.5 3.1-7.5 7v42c0 3.8 3.4 7 7.5 7H420v84.9c0 3.9 3.2 7.1 7 7.1h42c3.9 0 7-3.2 7-7.1V540h84.5c4.1 0 7.5-3.2 7.5-7v-42c0-3.9-3.4-7-7.5-7H476v-84.9zM560.5 704h-225c-4.1 0-7.5 3.2-7.5 7v42c0 3.8 3.4 7 7.5 7h225c4.1 0 7.5-3.2 7.5-7v-42c0-3.8-3.4-7-7.5-7z"
                }
            }
        ]
    })(props);
}
function AiTwotoneDislike(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#D9D9D9",
                    "d": "M273 100.1v428h.3l-.3-428zM820.4 525l-21.9-19 14-25.5a56.2 56.2 0 0 0 6.9-27.3c0-16.5-7.1-32.2-19.6-43l-21.9-19 13.9-25.4a56.2 56.2 0 0 0 6.9-27.3c0-16.5-7.1-32.2-19.6-43l-21.9-19 13.9-25.4a56.2 56.2 0 0 0 6.9-27.3c0-22.4-13.2-42.6-33.6-51.8H345v345.2c18.6 67.2 46.4 168 83.5 302.5a44.28 44.28 0 0 0 42.2 32.3c7.5.1 15-2.2 21.1-6.7 9.9-7.4 15.2-18.6 14.6-30.5l-9.6-198.4h314.4C829 605.5 840 587.1 840 568c0-16.5-7.1-32.2-19.6-43z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M112 132v364c0 17.7 14.3 32 32 32h65V100h-65c-17.7 0-32 14.3-32 32zm773.9 358.3c3.6-12 5.4-24.4 5.4-37 0-28.3-9.3-55.5-26.1-77.7 3.6-12 5.4-24.4 5.4-37 0-28.3-9.3-55.5-26.1-77.7 3.6-12 5.4-24.4 5.4-37 0-51.6-30.7-98.1-78.3-118.4a66.1 66.1 0 0 0-26.5-5.4H273l.3 428 85.8 310.8C372.9 889 418.9 924 470.9 924c29.7 0 57.4-11.8 77.9-33.4 20.5-21.5 31-49.7 29.5-79.4l-6-122.9h239.9c12.1 0 23.9-3.2 34.3-9.3 40.4-23.5 65.5-66.1 65.5-111 0-28.3-9.3-55.5-26.1-77.7zm-74.7 126.1H496.8l9.6 198.4c.6 11.9-4.7 23.1-14.6 30.5-6.1 4.5-13.6 6.8-21.1 6.7a44.28 44.28 0 0 1-42.2-32.3c-37.1-134.4-64.9-235.2-83.5-302.5V172h399.4a56.85 56.85 0 0 1 33.6 51.8c0 9.7-2.3 18.9-6.9 27.3l-13.9 25.4 21.9 19a56.76 56.76 0 0 1 19.6 43c0 9.7-2.3 18.9-6.9 27.3l-13.9 25.4 21.9 19a56.76 56.76 0 0 1 19.6 43c0 9.7-2.3 18.9-6.9 27.3l-14 25.5 21.9 19a56.76 56.76 0 0 1 19.6 43c0 19.1-11 37.5-28.8 48.4z"
                }
            }
        ]
    })(props);
}
function AiTwotoneDollarCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#E6E6E6",
                    "d": "M426.6 410.3c0 25.4 15.7 45.1 49.5 57.3 4.7 1.9 9.4 3.4 15 5v-124c-37 4.7-64.5 25.4-64.5 61.7zm116.5 135.2c-2.9-.6-5.7-1.3-8.8-2.2V677c42.6-3.8 72-27.3 72-66.4 0-30.7-15.9-50.7-63.2-65.1z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#E6E6E6",
                    "d": "M512 140c-205.4 0-372 166.6-372 372s166.6 372 372 372 372-166.6 372-372-166.6-372-372-372zm22.4 589.2l.2 31.7c0 4.5-3.6 8.1-8 8.1h-28.4c-4.4 0-8-3.6-8-8v-31.4c-89-6.5-130.7-57.1-135.2-112.1-.4-4.7 3.3-8.7 8-8.7h46.2c3.9 0 7.3 2.8 7.9 6.6 5.1 31.8 29.9 55.4 74.1 61.3V534l-24.7-6.3c-52.3-12.5-102.1-45.1-102.1-112.7 0-73 55.4-112.1 126.2-119v-33c0-4.4 3.6-8 8-8h28.1c4.4 0 8 3.6 8 8v32.7c68.5 6.9 119.8 46.9 125.9 109.2a8.1 8.1 0 0 1-8 8.8h-44.9c-4 0-7.4-2.9-7.9-6.9-4-29.2-27.5-53-65.5-58.2v134.3l25.4 5.9c64.8 16 108.9 47 109 116.4 0 75.2-56 117.1-134.3 124z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M559.7 488.8l-25.4-5.9V348.6c38 5.2 61.5 29 65.5 58.2.5 4 3.9 6.9 7.9 6.9h44.9c4.7 0 8.4-4.1 8-8.8-6.1-62.3-57.4-102.3-125.9-109.2V263c0-4.4-3.6-8-8-8h-28.1c-4.4 0-8 3.6-8 8v33c-70.8 6.9-126.2 46-126.2 119 0 67.6 49.8 100.2 102.1 112.7l24.7 6.3v142.7c-44.2-5.9-69-29.5-74.1-61.3-.6-3.8-4-6.6-7.9-6.6H363c-4.7 0-8.4 4-8 8.7 4.5 55 46.2 105.6 135.2 112.1V761c0 4.4 3.6 8 8 8h28.4c4.4 0 8-3.6 8-8.1l-.2-31.7c78.3-6.9 134.3-48.8 134.3-124-.1-69.4-44.2-100.4-109-116.4zm-68.6-16.2c-5.6-1.6-10.3-3.1-15-5-33.8-12.2-49.5-31.9-49.5-57.3 0-36.3 27.5-57 64.5-61.7v124zM534.3 677V543.3c3.1.9 5.9 1.6 8.8 2.2 47.3 14.4 63.2 34.4 63.2 65.1 0 39.1-29.4 62.6-72 66.4z"
                }
            }
        ]
    })(props);
}
function AiTwotoneDollar(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#E6E6E6",
                    "d": "M426.6 410.3c0 25.4 15.7 45.1 49.5 57.3 4.7 1.9 9.4 3.4 15 5v-124c-37 4.7-64.5 25.4-64.5 61.7zm116.5 135.2c-2.9-.6-5.7-1.3-8.8-2.2V677c42.6-3.8 72-27.3 72-66.4 0-30.7-15.9-50.7-63.2-65.1z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#E6E6E6",
                    "d": "M512 140c-205.4 0-372 166.6-372 372s166.6 372 372 372 372-166.6 372-372-166.6-372-372-372zm22.4 589.2l.2 31.7c0 4.5-3.6 8.1-8 8.1h-28.4c-4.4 0-8-3.6-8-8v-31.4c-89-6.5-130.7-57.1-135.2-112.1-.4-4.7 3.3-8.7 8-8.7h46.2c3.9 0 7.3 2.8 7.9 6.6 5.1 31.8 29.9 55.4 74.1 61.3V534l-24.7-6.3c-52.3-12.5-102.1-45.1-102.1-112.7 0-73 55.4-112.1 126.2-119v-33c0-4.4 3.6-8 8-8h28.1c4.4 0 8 3.6 8 8v32.7c68.5 6.9 119.8 46.9 125.9 109.2a8.1 8.1 0 0 1-8 8.8h-44.9c-4 0-7.4-2.9-7.9-6.9-4-29.2-27.5-53-65.5-58.2v134.3l25.4 5.9c64.8 16 108.9 47 109 116.4 0 75.2-56 117.1-134.3 124z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M559.7 488.8l-25.4-5.9V348.6c38 5.2 61.5 29 65.5 58.2.5 4 3.9 6.9 7.9 6.9h44.9c4.7 0 8.4-4.1 8-8.8-6.1-62.3-57.4-102.3-125.9-109.2V263c0-4.4-3.6-8-8-8h-28.1c-4.4 0-8 3.6-8 8v33c-70.8 6.9-126.2 46-126.2 119 0 67.6 49.8 100.2 102.1 112.7l24.7 6.3v142.7c-44.2-5.9-69-29.5-74.1-61.3-.6-3.8-4-6.6-7.9-6.6H363c-4.7 0-8.4 4-8 8.7 4.5 55 46.2 105.6 135.2 112.1V761c0 4.4 3.6 8 8 8h28.4c4.4 0 8-3.6 8-8.1l-.2-31.7c78.3-6.9 134.3-48.8 134.3-124-.1-69.4-44.2-100.4-109-116.4zm-68.6-16.2c-5.6-1.6-10.3-3.1-15-5-33.8-12.2-49.5-31.9-49.5-57.3 0-36.3 27.5-57 64.5-61.7v124zM534.3 677V543.3c3.1.9 5.9 1.6 8.8 2.2 47.3 14.4 63.2 34.4 63.2 65.1 0 39.1-29.4 62.6-72 66.4z"
                }
            }
        ]
    })(props);
}
function AiTwotoneDownCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#E6E6E6",
                    "d": "M512 140c-205.4 0-372 166.6-372 372s166.6 372 372 372 372-166.6 372-372-166.6-372-372-372zm184.4 277.7l-178 246a7.95 7.95 0 0 1-12.9 0l-178-246c-3.8-5.3 0-12.7 6.5-12.7h46.9c10.3 0 19.9 4.9 25.9 13.2L512 563.6l105.2-145.4c6-8.3 15.7-13.2 25.9-13.2H690c6.5 0 10.3 7.4 6.4 12.7z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M690 405h-46.9c-10.2 0-19.9 4.9-25.9 13.2L512 563.6 406.8 418.2c-6-8.3-15.6-13.2-25.9-13.2H334c-6.5 0-10.3 7.4-6.5 12.7l178 246c3.2 4.4 9.7 4.4 12.9 0l178-246c3.9-5.3.1-12.7-6.4-12.7z"
                }
            }
        ]
    })(props);
}
function AiTwotoneDownSquare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#E6E6E6",
                    "d": "M184 840h656V184H184v656zm150-440h46.9c10.3 0 19.9 4.9 25.9 13.2L512 558.6l105.2-145.4c6-8.3 15.7-13.2 25.9-13.2H690c6.5 0 10.3 7.4 6.4 12.7l-178 246a7.95 7.95 0 0 1-12.9 0l-178-246c-3.8-5.3 0-12.7 6.5-12.7z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M505.5 658.7c3.2 4.4 9.7 4.4 12.9 0l178-246c3.9-5.3.1-12.7-6.4-12.7h-46.9c-10.2 0-19.9 4.9-25.9 13.2L512 558.6 406.8 413.2c-6-8.3-15.6-13.2-25.9-13.2H334c-6.5 0-10.3 7.4-6.5 12.7l178 246z"
                }
            }
        ]
    })(props);
}
function AiTwotoneEdit(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#D9D9D9",
                    "d": "M761.1 288.3L687.8 215 325.1 577.6l-15.6 89 88.9-15.7z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M880 836H144c-17.7 0-32 14.3-32 32v36c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-36c0-17.7-14.3-32-32-32zm-622.3-84c2 0 4-.2 6-.5L431.9 722c2-.4 3.9-1.3 5.3-2.8l423.9-423.9a9.96 9.96 0 0 0 0-14.1L694.9 114.9c-1.9-1.9-4.4-2.9-7.1-2.9s-5.2 1-7.1 2.9L256.8 538.8c-1.5 1.5-2.4 3.3-2.8 5.3l-29.5 168.2a33.5 33.5 0 0 0 9.4 29.8c6.6 6.4 14.9 9.9 23.8 9.9zm67.4-174.4L687.8 215l73.3 73.3-362.7 362.6-88.9 15.7 15.6-89z"
                }
            }
        ]
    })(props);
}
function AiTwotoneEnvironment(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#D9D9D9",
                    "d": "M724.4 224.9C667.7 169.5 592.3 139 512 139s-155.7 30.5-212.4 85.8C243.1 280 212 353.2 212 431.1c0 241.3 234.1 407.2 300 449.1 65.9-41.9 300-207.8 300-449.1 0-77.9-31.1-151.1-87.6-206.2zM512 615c-97.2 0-176-78.8-176-176s78.8-176 176-176 176 78.8 176 176-78.8 176-176 176z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M512 263c-97.2 0-176 78.8-176 176s78.8 176 176 176 176-78.8 176-176-78.8-176-176-176zm79.2 255.2A111.6 111.6 0 0 1 512 551c-29.9 0-58-11.7-79.2-32.8A111.6 111.6 0 0 1 400 439c0-29.9 11.7-58 32.8-79.2C454 338.6 482.1 327 512 327c29.9 0 58 11.6 79.2 32.8S624 409.1 624 439c0 29.9-11.6 58-32.8 79.2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M854.6 289.1a362.49 362.49 0 0 0-79.9-115.7 370.83 370.83 0 0 0-118.2-77.8C610.7 76.6 562.1 67 512 67c-50.1 0-98.7 9.6-144.5 28.5-44.3 18.3-84 44.5-118.2 77.8A363.6 363.6 0 0 0 169.4 289c-19.5 45-29.4 92.8-29.4 142 0 70.6 16.9 140.9 50.1 208.7 26.7 54.5 64 107.6 111 158.1 80.3 86.2 164.5 138.9 188.4 153a43.9 43.9 0 0 0 22.4 6.1c7.8 0 15.5-2 22.4-6.1 23.9-14.1 108.1-66.8 188.4-153 47-50.4 84.3-103.6 111-158.1C867.1 572 884 501.8 884 431.1c0-49.2-9.9-97-29.4-142zM512 880.2c-65.9-41.9-300-207.8-300-449.1 0-77.9 31.1-151.1 87.6-206.3C356.3 169.5 431.7 139 512 139s155.7 30.5 212.4 85.9C780.9 280 812 353.2 812 431.1c0 241.3-234.1 407.2-300 449.1z"
                }
            }
        ]
    })(props);
}
function AiTwotoneEuroCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#E6E6E6",
                    "d": "M512 140c-205.4 0-372 166.6-372 372s166.6 372 372 372 372-166.6 372-372-166.6-372-372-372zm117.1 581.1c0 3.8-2.7 7-6.4 7.8-15.9 3.4-34.4 5.1-55.3 5.1-109.8 0-183-58.8-200.2-158H337c-4.4 0-8-3.6-8-8v-27.2c0-4.4 3.6-8 8-8h26.1v-36.9c0-4.4 0-8.7.3-12.8H337c-4.4 0-8-3.6-8-8v-27.2c0-4.4 3.6-8 8-8h31.8C388.5 345.7 460.7 290 567.4 290c20.9 0 39.4 1.9 55.3 5.4 3.7.8 6.3 4 6.3 7.8V346a8 8 0 0 1-9.6 7.8c-14.6-2.9-31.8-4.4-51.7-4.4-65.3 0-110.4 33.5-127.6 90.4h128.3c4.4 0 8 3.6 8 8V475c0 4.4-3.6 8-8 8H432.5c-.3 4.4-.3 9.1-.3 13.8v36h136.4c4.4 0 8 3.6 8 8V568c0 4.4-3.6 8-8 8H438c15.3 62 61.3 98.6 129.8 98.6 19.9 0 37.1-1.3 51.8-4.1 4.9-1 9.5 2.8 9.5 7.8v42.8z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M619.6 670.5c-14.7 2.8-31.9 4.1-51.8 4.1-68.5 0-114.5-36.6-129.8-98.6h130.6c4.4 0 8-3.6 8-8v-27.2c0-4.4-3.6-8-8-8H432.2v-36c0-4.7 0-9.4.3-13.8h135.9c4.4 0 8-3.6 8-8v-27.2c0-4.4-3.6-8-8-8H440.1c17.2-56.9 62.3-90.4 127.6-90.4 19.9 0 37.1 1.5 51.7 4.4a8 8 0 0 0 9.6-7.8v-42.8c0-3.8-2.6-7-6.3-7.8-15.9-3.5-34.4-5.4-55.3-5.4-106.7 0-178.9 55.7-198.6 149.9H337c-4.4 0-8 3.6-8 8v27.2c0 4.4 3.6 8 8 8h26.4c-.3 4.1-.3 8.4-.3 12.8v36.9H337c-4.4 0-8 3.6-8 8V568c0 4.4 3.6 8 8 8h30.2c17.2 99.2 90.4 158 200.2 158 20.9 0 39.4-1.7 55.3-5.1 3.7-.8 6.4-4 6.4-7.8v-42.8c0-5-4.6-8.8-9.5-7.8z"
                }
            }
        ]
    })(props);
}
function AiTwotoneEuro(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#E6E6E6",
                    "d": "M512 140c-205.4 0-372 166.6-372 372s166.6 372 372 372 372-166.6 372-372-166.6-372-372-372zm117.1 581.1c0 3.8-2.7 7-6.4 7.8-15.9 3.4-34.4 5.1-55.3 5.1-109.8 0-183-58.8-200.2-158H337c-4.4 0-8-3.6-8-8v-27.2c0-4.4 3.6-8 8-8h26.1v-36.9c0-4.4 0-8.7.3-12.8H337c-4.4 0-8-3.6-8-8v-27.2c0-4.4 3.6-8 8-8h31.8C388.5 345.7 460.7 290 567.4 290c20.9 0 39.4 1.9 55.3 5.4 3.7.8 6.3 4 6.3 7.8V346a8 8 0 0 1-9.6 7.8c-14.6-2.9-31.8-4.4-51.7-4.4-65.3 0-110.4 33.5-127.6 90.4h128.3c4.4 0 8 3.6 8 8V475c0 4.4-3.6 8-8 8H432.5c-.3 4.4-.3 9.1-.3 13.8v36h136.4c4.4 0 8 3.6 8 8V568c0 4.4-3.6 8-8 8H438c15.3 62 61.3 98.6 129.8 98.6 19.9 0 37.1-1.3 51.8-4.1 4.9-1 9.5 2.8 9.5 7.8v42.8z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M619.6 670.5c-14.7 2.8-31.9 4.1-51.8 4.1-68.5 0-114.5-36.6-129.8-98.6h130.6c4.4 0 8-3.6 8-8v-27.2c0-4.4-3.6-8-8-8H432.2v-36c0-4.7 0-9.4.3-13.8h135.9c4.4 0 8-3.6 8-8v-27.2c0-4.4-3.6-8-8-8H440.1c17.2-56.9 62.3-90.4 127.6-90.4 19.9 0 37.1 1.5 51.7 4.4a8 8 0 0 0 9.6-7.8v-42.8c0-3.8-2.6-7-6.3-7.8-15.9-3.5-34.4-5.4-55.3-5.4-106.7 0-178.9 55.7-198.6 149.9H337c-4.4 0-8 3.6-8 8v27.2c0 4.4 3.6 8 8 8h26.4c-.3 4.1-.3 8.4-.3 12.8v36.9H337c-4.4 0-8 3.6-8 8V568c0 4.4 3.6 8 8 8h30.2c17.2 99.2 90.4 158 200.2 158 20.9 0 39.4-1.7 55.3-5.1 3.7-.8 6.4-4 6.4-7.8v-42.8c0-5-4.6-8.8-9.5-7.8z"
                }
            }
        ]
    })(props);
}
function AiTwotoneExclamationCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#E6E6E6",
                    "d": "M512 140c-205.4 0-372 166.6-372 372s166.6 372 372 372 372-166.6 372-372-166.6-372-372-372zm-32 156c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v272c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V296zm32 440a48.01 48.01 0 0 1 0-96 48.01 48.01 0 0 1 0 96z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M488 576h48c4.4 0 8-3.6 8-8V296c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v272c0 4.4 3.6 8 8 8zm-24 112a48 48 0 1 0 96 0 48 48 0 1 0-96 0z"
                }
            }
        ]
    })(props);
}
function AiTwotoneExperiment(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#D9D9D9",
                    "d": "M551.9 513c19.6 0 35.9-14.2 39.3-32.8A40.02 40.02 0 0 1 552 512a40 40 0 0 1-40-39.4v.5c0 22 17.9 39.9 39.9 39.9zM752 687.8l-.3-.3c-29-17.5-62.3-26.8-97-26.8-44.9 0-87.2 15.7-121 43.8a256.27 256.27 0 0 1-164.9 59.9c-41.2 0-81-9.8-116.7-28L210.5 844h603l-59.9-155.2-1.6-1z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M879 824.9L696.3 352V178H768v-68H256v68h71.7v174L145 824.9c-2.8 7.4-4.3 15.2-4.3 23.1 0 35.3 28.7 64 64 64h614.6c7.9 0 15.7-1.5 23.1-4.3 33-12.7 49.4-49.8 36.6-82.8zM395.7 364.7V180h232.6v184.7L719.2 600c-20.7-5.3-42.1-8-63.9-8-61.2 0-119.2 21.5-165.3 60a188.78 188.78 0 0 1-121.3 43.9c-32.7 0-64.1-8.3-91.8-23.7l118.8-307.5zM210.5 844l41.6-107.6.1-.2c35.7 18.1 75.4 27.8 116.6 27.8 61.2 0 119.2-21.5 165.3-60 33.9-28.2 76.3-43.9 121.3-43.9 35 0 68.4 9.5 97.6 27.1l.6 1.6L813.5 844h-603z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M552 512c19.3 0 35.4-13.6 39.2-31.8.6-2.7.8-5.4.8-8.2 0-22.1-17.9-40-40-40s-40 17.9-40 40v.6a40 40 0 0 0 40 39.4z"
                }
            }
        ]
    })(props);
}
function AiTwotoneEyeInvisible(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#D9D9D9",
                    "d": "M254.89,758.85,380.46,633.28A176,176,0,0,1,629.28,384.46L757,256.72Q651.69,186.07,512,186,223.7,186,81.8,486.3a60.3,60.3,0,0,0,0,51.5Q151.07,683.71,254.89,758.85Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#D9D9D9",
                    "d": "M942.2,486.2Q889.46,375.11,816.7,305L672.48,449.27A176.09,176.09,0,0,1,445.26,676.48L323,798.75Q408,838,512,838q288.3,0,430.2-300.3A60.29,60.29,0,0,0,942.2,486.2Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M942.2,486.2Q889.47,375.11,816.7,305l-50.88,50.88C807.31,395.53,843.45,447.4,874.7,512,791.5,684.2,673.4,766,512,766q-72.67,0-133.87-22.38L323,798.75Q408,838,512,838q288.3,0,430.2-300.3A60.29,60.29,0,0,0,942.2,486.2Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M878.63,165.56,836,122.88a8,8,0,0,0-11.32,0L715.31,232.2Q624.86,186,512,186,223.7,186,81.8,486.3a60.3,60.3,0,0,0,0,51.5q56.69,119.4,136.5,191.41L112.48,835a8,8,0,0,0,0,11.31L155.17,889a8,8,0,0,0,11.31,0L878.63,176.88A8,8,0,0,0,878.63,165.56ZM149.3,512C232.6,339.8,350.7,258,512,258c54.54,0,104.13,9.36,149.12,28.39l-70.3,70.3A176,176,0,0,0,352.69,594.82l-83.42,83.42C223.1,637.49,183.3,582.28,149.3,512ZM396,512A112.11,112.11,0,0,1,542.2,405.31L401.31,546.2A112,112,0,0,1,396,512Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M508,624c-3.46,0-6.87-.16-10.25-.47l-52.82,52.82A176.09,176.09,0,0,0,672.35,448.93l-52.82,52.82c.31,3.38.47,6.79.47,10.25A111.94,111.94,0,0,1,508,624Z"
                }
            }
        ]
    })(props);
}
function AiTwotoneEye(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#D9D9D9",
                    "d": "M81.8 537.8a60.3 60.3 0 0 1 0-51.5C176.6 286.5 319.8 186 512 186c-192.2 0-335.4 100.5-430.2 300.3a60.3 60.3 0 0 0 0 51.5C176.6 737.5 319.9 838 512 838c-192.1 0-335.4-100.5-430.2-300.2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#D9D9D9",
                    "d": "M512 258c-161.3 0-279.4 81.8-362.7 254C232.6 684.2 350.7 766 512 766c161.4 0 279.5-81.8 362.7-254C791.4 339.8 673.3 258 512 258zm-4 430c-97.2 0-176-78.8-176-176s78.8-176 176-176 176 78.8 176 176-78.8 176-176 176z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M942.2 486.2C847.4 286.5 704.1 186 512 186c-192.2 0-335.4 100.5-430.2 300.3a60.3 60.3 0 0 0 0 51.5C176.6 737.5 319.9 838 512 838c192.2 0 335.4-100.5 430.2-300.3 7.7-16.2 7.7-35 0-51.5zM512 766c-161.3 0-279.4-81.8-362.7-254C232.6 339.8 350.7 258 512 258s279.4 81.8 362.7 254C791.5 684.2 673.4 766 512 766z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M508 336c-97.2 0-176 78.8-176 176s78.8 176 176 176 176-78.8 176-176-78.8-176-176-176zm0 288c-61.9 0-112-50.1-112-112s50.1-112 112-112 112 50.1 112 112-50.1 112-112 112z"
                }
            }
        ]
    })(props);
}
function AiTwotoneFileAdd(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#D9D9D9",
                    "d": "M534 352V136H232v752h560V394H576a42 42 0 0 1-42-42zm126 236v48c0 4.4-3.6 8-8 8H544v108c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V644H372c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h108V472c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v108h108c4.4 0 8 3.6 8 8z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M854.6 288.6L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM602 137.8L790.2 326H602V137.8zM792 888H232V136h302v216a42 42 0 0 0 42 42h216v494z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M544 472c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v108H372c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h108v108c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V644h108c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H544V472z"
                }
            }
        ]
    })(props);
}
function AiTwotoneFileExcel(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#D9D9D9",
                    "d": "M534 352V136H232v752h560V394H576a42 42 0 0 1-42-42zm51.6 120h35.7a12.04 12.04 0 0 1 10.1 18.5L546.1 623l84 130.4c3.6 5.6 2 13-3.6 16.6-2 1.2-4.2 1.9-6.5 1.9h-37.5c-4.1 0-8-2.1-10.2-5.7L510 664.8l-62.7 101.5c-2.2 3.5-6 5.7-10.2 5.7h-34.5a12.04 12.04 0 0 1-10.2-18.4l83.4-132.8-82.3-130.4c-3.6-5.7-1.9-13.1 3.7-16.6 1.9-1.3 4.1-1.9 6.4-1.9H442c4.2 0 8.1 2.2 10.3 5.8l61.8 102.4 61.2-102.3c2.2-3.6 6.1-5.8 10.3-5.8z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M854.6 288.6L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM602 137.8L790.2 326H602V137.8zM792 888H232V136h302v216a42 42 0 0 0 42 42h216v494z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M514.1 580.1l-61.8-102.4c-2.2-3.6-6.1-5.8-10.3-5.8h-38.4c-2.3 0-4.5.6-6.4 1.9-5.6 3.5-7.3 10.9-3.7 16.6l82.3 130.4-83.4 132.8a12.04 12.04 0 0 0 10.2 18.4h34.5c4.2 0 8-2.2 10.2-5.7L510 664.8l62.3 101.4c2.2 3.6 6.1 5.7 10.2 5.7H620c2.3 0 4.5-.7 6.5-1.9 5.6-3.6 7.2-11 3.6-16.6l-84-130.4 85.3-132.5a12.04 12.04 0 0 0-10.1-18.5h-35.7c-4.2 0-8.1 2.2-10.3 5.8l-61.2 102.3z"
                }
            }
        ]
    })(props);
}
function AiTwotoneFileExclamation(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#D9D9D9",
                    "d": "M534 352V136H232v752h560V394H576a42 42 0 0 1-42-42zm-54 96c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v184c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V448zm32 336c-22.1 0-40-17.9-40-40s17.9-40 40-40 40 17.9 40 40-17.9 40-40 40z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M854.6 288.6L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM602 137.8L790.2 326H602V137.8zM792 888H232V136h302v216a42 42 0 0 0 42 42h216v494z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M488 640h48c4.4 0 8-3.6 8-8V448c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v184c0 4.4 3.6 8 8 8zm-16 104a40 40 0 1 0 80 0 40 40 0 1 0-80 0z"
                }
            }
        ]
    })(props);
}
function AiTwotoneFileImage(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#D9D9D9",
                    "d": "M534 352V136H232v752h560V394H576a42 42 0 0 1-42-42zm-134 50c22.1 0 40 17.9 40 40s-17.9 40-40 40-40-17.9-40-40 17.9-40 40-40zm296 294H328.1c-6.7 0-10.4-7.7-6.3-12.9l99.8-127.2a8 8 0 0 1 12.6 0l41.1 52.4 77.8-99.2a8.1 8.1 0 0 1 12.7 0l136.5 174c4.1 5.2.4 12.9-6.3 12.9z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M854.6 288.6L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM602 137.8L790.2 326H602V137.8zM792 888H232V136h302v216a42 42 0 0 0 42 42h216v494z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M553.1 509.1l-77.8 99.2-41.1-52.4a8 8 0 0 0-12.6 0l-99.8 127.2a7.98 7.98 0 0 0 6.3 12.9H696c6.7 0 10.4-7.7 6.3-12.9l-136.5-174a8.1 8.1 0 0 0-12.7 0zM360 442a40 40 0 1 0 80 0 40 40 0 1 0-80 0z"
                }
            }
        ]
    })(props);
}
function AiTwotoneFileMarkdown(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#D9D9D9",
                    "d": "M534 352V136H232v752h560V394H576a42 42 0 0 1-42-42zm72.3 122H641c6.6 0 12 5.4 12 12v272c0 6.6-5.4 12-12 12h-27.2c-6.6 0-12-5.4-12-12V581.7L535 732.3c-2 4.3-6.3 7.1-11 7.1h-24.1a12 12 0 0 1-11-7.1l-66.8-150.2V758c0 6.6-5.4 12-12 12H383c-6.6 0-12-5.4-12-12V486c0-6.6 5.4-12 12-12h35c4.8 0 9.1 2.8 11 7.2l83.2 191 83.1-191c1.9-4.4 6.2-7.2 11-7.2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M854.6 288.6L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM602 137.8L790.2 326H602V137.8zM792 888H232V136h302v216a42 42 0 0 0 42 42h216v494z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M429 481.2c-1.9-4.4-6.2-7.2-11-7.2h-35c-6.6 0-12 5.4-12 12v272c0 6.6 5.4 12 12 12h27.1c6.6 0 12-5.4 12-12V582.1l66.8 150.2a12 12 0 0 0 11 7.1H524c4.7 0 9-2.8 11-7.1l66.8-150.6V758c0 6.6 5.4 12 12 12H641c6.6 0 12-5.4 12-12V486c0-6.6-5.4-12-12-12h-34.7c-4.8 0-9.1 2.8-11 7.2l-83.1 191-83.2-191z"
                }
            }
        ]
    })(props);
}
function AiTwotoneFilePdf(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#D9D9D9",
                    "d": "M509.2 490.8c-.7-1.3-1.4-1.9-2.2-2-2.9 3.3-2.2 31.5 2.7 51.4 4-13.6 4.7-40.5-.5-49.4zm-1.6 120.5c-7.7 20-18.8 47.3-32.1 71.4 4-1.6 8.1-3.3 12.3-5 17.6-7.2 37.3-15.3 58.9-20.2-14.9-11.8-28.4-27.7-39.1-46.2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#D9D9D9",
                    "d": "M534 352V136H232v752h560V394H576a42 42 0 0 1-42-42zm55 287.6c16.1-1.9 30.6-2.8 44.3-2.3 12.8.4 23.6 2 32 5.1.2.1.3.1.5.2.4.2.8.3 1.2.5.5.2 1.1.4 1.6.7.1.1.3.1.4.2 4.1 1.8 7.5 4 10.1 6.6 9.1 9.1 11.8 26.1 6.2 39.6-3.2 7.7-11.7 20.5-33.3 20.5-21.8 0-53.9-9.7-82.1-24.8-25.5 4.3-53.7 13.9-80.9 23.1-5.8 2-11.8 4-17.6 5.9-38 65.2-66.5 79.4-84.1 79.4-4.2 0-7.8-.9-10.8-2-6.9-2.6-12.8-8-16.5-15-.9-1.7-1.6-3.4-2.2-5.2-1.6-4.8-2.1-9.6-1.3-13.6l.6-2.7c.1-.2.1-.4.2-.6.2-.7.4-1.4.7-2.1 0-.1.1-.2.1-.3 4.1-11.9 13.6-23.4 27.7-34.6 12.3-9.8 27.1-18.7 45.9-28.4 15.9-28 37.6-75.1 51.2-107.4-10.8-41.8-16.7-74.6-10.1-98.6.9-3.3 2.5-6.4 4.6-9.1.2-.2.3-.4.5-.6.1-.1.1-.2.2-.2 6.3-7.5 16.9-11.9 28.1-11.5 16.6.7 29.7 11.5 33 30.1 1.7 8 2.2 16.5 1.9 25.7v.7c0 .5 0 1-.1 1.5-.7 13.3-3 26.6-7.3 44.7-.4 1.6-.8 3.2-1.2 5.2l-1 4.1-.1.3c.1.2.1.3.2.5l1.8 4.5c.1.3.3.7.4 1 .7 1.6 1.4 3.3 2.1 4.8v.1c8.7 18.8 19.7 33.4 33.9 45.1 4.3 3.5 8.9 6.7 13.9 9.8 1.8-.5 3.5-.7 5.3-.9z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#D9D9D9",
                    "d": "M391.5 761c5.7-4.4 16.2-14.5 30.1-34.7-10.3 9.4-23.4 22.4-30.1 34.7zm270.9-83l.2-.3h.2c.6-.4.5-.7.4-.9-.1-.1-4.5-9.3-45.1-7.4 35.3 13.9 43.5 9.1 44.3 8.6z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M854.6 288.6L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM602 137.8L790.2 326H602V137.8zM792 888H232V136h302v216a42 42 0 0 0 42 42h216v494z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M535.9 585.3c-.8-1.7-1.5-3.3-2.2-4.9-.1-.3-.3-.7-.4-1l-1.8-4.5c-.1-.2-.1-.3-.2-.5l.1-.3.2-1.1c4-16.3 8.6-35.3 9.4-54.4v-.7c.3-8.6-.2-17.2-2-25.6-3.8-21.3-19.5-29.6-32.9-30.2-11.3-.5-21.8 4-28.1 11.4-.1.1-.1.2-.2.2-.2.2-.4.4-.5.6-2.1 2.7-3.7 5.8-4.6 9.1-6.6 24-.7 56.8 10.1 98.6-13.6 32.4-35.3 79.4-51.2 107.4v.1c-27.7 14.3-64.1 35.8-73.6 62.9 0 .1-.1.2-.1.3-.2.7-.5 1.4-.7 2.1-.1.2-.1.4-.2.6-.2.9-.5 1.8-.6 2.7-.9 4-.4 8.8 1.3 13.6.6 1.8 1.3 3.5 2.2 5.2 3.7 7 9.6 12.4 16.5 15 3 1.1 6.6 2 10.8 2 17.6 0 46.1-14.2 84.1-79.4 5.8-1.9 11.8-3.9 17.6-5.9 27.2-9.2 55.4-18.8 80.9-23.1 28.2 15.1 60.3 24.8 82.1 24.8 21.6 0 30.1-12.8 33.3-20.5 5.6-13.5 2.9-30.5-6.2-39.6-2.6-2.6-6-4.8-10.1-6.6-.1-.1-.3-.1-.4-.2-.5-.2-1.1-.4-1.6-.7-.4-.2-.8-.3-1.2-.5-.2-.1-.3-.1-.5-.2-16.2-5.8-41.7-6.7-76.3-2.8l-5.3.6c-5-3-9.6-6.3-13.9-9.8-14.2-11.3-25.1-25.8-33.8-44.7zM391.5 761c6.7-12.3 19.8-25.3 30.1-34.7-13.9 20.2-24.4 30.3-30.1 34.7zM507 488.8c.8.1 1.5.7 2.2 2 5.2 8.9 4.5 35.8.5 49.4-4.9-19.9-5.6-48.1-2.7-51.4zm-19.2 188.9c-4.2 1.7-8.3 3.4-12.3 5 13.3-24.1 24.4-51.4 32.1-71.4 10.7 18.5 24.2 34.4 39.1 46.2-21.6 4.9-41.3 13-58.9 20.2zm175.4-.9c.1.2.2.5-.4.9h-.2l-.2.3c-.8.5-9 5.3-44.3-8.6 40.6-1.9 45 7.3 45.1 7.4z"
                }
            }
        ]
    })(props);
}
function AiTwotoneFilePpt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#D9D9D9",
                    "d": "M464.5 516.2v108.4h38.9c44.7 0 71.2-10.9 71.2-54.3 0-34.4-20.1-54.1-53.9-54.1h-56.2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#D9D9D9",
                    "d": "M534 352V136H232v752h560V394H576a42 42 0 0 1-42-42zm90 218.4c0 55.2-36.8 94.1-96.2 94.1h-63.3V760c0 4.4-3.6 8-8 8H424c-4.4 0-8-3.6-8-8V484c0-4.4 3.6-8 8-8v.1h104c59.7 0 96 39.8 96 94.3z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M854.6 288.6L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM602 137.8L790.2 326H602V137.8zM792 888H232V136h302v216a42 42 0 0 0 42 42h216v494z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M424 476.1c-4.4-.1-8 3.5-8 7.9v276c0 4.4 3.6 8 8 8h32.5c4.4 0 8-3.6 8-8v-95.5h63.3c59.4 0 96.2-38.9 96.2-94.1 0-54.5-36.3-94.3-96-94.3H424zm150.6 94.2c0 43.4-26.5 54.3-71.2 54.3h-38.9V516.2h56.2c33.8 0 53.9 19.7 53.9 54.1z"
                }
            }
        ]
    })(props);
}
function AiTwotoneFileText(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#D9D9D9",
                    "d": "M534 352V136H232v752h560V394H576a42 42 0 0 1-42-42zm-22 322c0 4.4-3.6 8-8 8H320c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h184c4.4 0 8 3.6 8 8v48zm200-184v48c0 4.4-3.6 8-8 8H320c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h384c4.4 0 8 3.6 8 8z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M854.6 288.6L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM602 137.8L790.2 326H602V137.8zM792 888H232V136h302v216a42 42 0 0 0 42 42h216v494z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M312 490v48c0 4.4 3.6 8 8 8h384c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H320c-4.4 0-8 3.6-8 8zm192 128H320c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h184c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8z"
                }
            }
        ]
    })(props);
}
function AiTwotoneFileUnknown(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#D9D9D9",
                    "d": "M534 352V136H232v752h560V394H576a42 42 0 0 1-42-42zm-22 424c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm110-228.4c.7 44.9-29.7 84.5-74.3 98.9-5.7 1.8-9.7 7.3-9.7 13.3V672c0 5.5-4.5 10-10 10h-32c-5.5 0-10-4.5-10-10v-32c.2-19.8 15.4-37.3 34.7-40.1C549 596.2 570 574.3 570 549c0-28.1-25.8-51.5-58-51.5s-58 23.4-58 51.6c0 5.2-4.4 9.4-9.8 9.4h-32.4c-5.4 0-9.8-4.1-9.8-9.5 0-57.4 50.1-103.7 111.5-103 59.3.8 107.7 46.1 108.5 101.6z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M854.6 288.7L639.4 73.4c-6-6-14.2-9.4-22.7-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.6-9.4-22.6zM602 137.8L790.2 326H602V137.8zM792 888H232V136h302v216a42 42 0 0 0 42 42h216v494z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M480 744a32 32 0 1 0 64 0 32 32 0 1 0-64 0zm-78-195c0 5.4 4.4 9.5 9.8 9.5h32.4c5.4 0 9.8-4.2 9.8-9.4 0-28.2 25.8-51.6 58-51.6s58 23.4 58 51.5c0 25.3-21 47.2-49.3 50.9-19.3 2.8-34.5 20.3-34.7 40.1v32c0 5.5 4.5 10 10 10h32c5.5 0 10-4.5 10-10v-12.2c0-6 4-11.5 9.7-13.3 44.6-14.4 75-54 74.3-98.9-.8-55.5-49.2-100.8-108.5-101.6-61.4-.7-111.5 45.6-111.5 103z"
                }
            }
        ]
    })(props);
}
function AiTwotoneFileWord(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#D9D9D9",
                    "d": "M534 352V136H232v752h560V394H576a42 42 0 0 1-42-42zm101.3 129.3c1.3-5.4 6.1-9.3 11.7-9.3h35.6a12.04 12.04 0 0 1 11.6 15.1l-74.4 276c-1.4 5.3-6.2 8.9-11.6 8.9h-31.8c-5.4 0-10.2-3.7-11.6-8.9l-52.8-197-52.8 197c-1.4 5.3-6.2 8.9-11.6 8.9h-32c-5.4 0-10.2-3.7-11.6-8.9l-74.2-276a12.02 12.02 0 0 1 11.6-15.1h35.4c5.6 0 10.4 3.9 11.7 9.3L434.6 680l49.7-198.9c1.3-5.4 6.1-9.1 11.6-9.1h32.2c5.5 0 10.3 3.7 11.6 9.1l49.8 199.3 45.8-199.1z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M854.6 288.6L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM602 137.8L790.2 326H602V137.8zM792 888H232V136h302v216a42 42 0 0 0 42 42h216v494z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M528.1 472h-32.2c-5.5 0-10.3 3.7-11.6 9.1L434.6 680l-46.1-198.7c-1.3-5.4-6.1-9.3-11.7-9.3h-35.4a12.02 12.02 0 0 0-11.6 15.1l74.2 276c1.4 5.2 6.2 8.9 11.6 8.9h32c5.4 0 10.2-3.6 11.6-8.9l52.8-197 52.8 197c1.4 5.2 6.2 8.9 11.6 8.9h31.8c5.4 0 10.2-3.6 11.6-8.9l74.4-276a12.04 12.04 0 0 0-11.6-15.1H647c-5.6 0-10.4 3.9-11.7 9.3l-45.8 199.1-49.8-199.3c-1.3-5.4-6.1-9.1-11.6-9.1z"
                }
            }
        ]
    })(props);
}
function AiTwotoneFileZip(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#D9D9D9",
                    "d": "M344 630h32v2h-32z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#D9D9D9",
                    "d": "M534 352V136H360v64h64v64h-64v64h64v64h-64v64h64v64h-64v62h64v160H296V520h64v-64h-64v-64h64v-64h-64v-64h64v-64h-64v-64h-64v752h560V394H576a42 42 0 0 1-42-42z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M854.6 288.6L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM602 137.8L790.2 326H602V137.8zM792 888H232V136h64v64h64v-64h174v216a42 42 0 0 0 42 42h216v494z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M296 392h64v64h-64zm0-128h64v64h-64zm0 318v160h128V582h-64v-62h-64v62zm48 50v-2h32v64h-32v-62zm16-432h64v64h-64zm0 256h64v64h-64zm0-128h64v64h-64z"
                }
            }
        ]
    })(props);
}
function AiTwotoneFile(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#D9D9D9",
                    "d": "M534 352V136H232v752h560V394H576a42 42 0 0 1-42-42z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M854.6 288.6L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM602 137.8L790.2 326H602V137.8zM792 888H232V136h302v216a42 42 0 0 0 42 42h216v494z"
                }
            }
        ]
    })(props);
}
function AiTwotoneFilter(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#D9D9D9",
                    "d": "M420.6 798h182.9V642H420.6zM411 561.4l9.5 16.6h183l9.5-16.6L811.3 226H212.7z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M880.1 154H143.9c-24.5 0-39.8 26.7-27.5 48L349 597.4V838c0 17.7 14.2 32 31.8 32h262.4c17.6 0 31.8-14.3 31.8-32V597.4L907.7 202c12.2-21.3-3.1-48-27.6-48zM603.5 798H420.6V642h182.9v156zm9.5-236.6l-9.5 16.6h-183l-9.5-16.6L212.7 226h598.6L613 561.4z"
                }
            }
        ]
    })(props);
}
function AiTwotoneFire(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#D9D9D9",
                    "d": "M737 438.6c-9.6 15.5-21.1 30.7-34.4 45.6a73.1 73.1 0 0 1-51 24.4 73.36 73.36 0 0 1-53.4-18.8 74.01 74.01 0 0 1-24.4-59.8c3-47.4-12.4-103.1-45.8-165.7-16.9-31.4-37.1-58.2-61.2-80.4a240 240 0 0 1-12.1 46.5 354.26 354.26 0 0 1-58.2 101 349.6 349.6 0 0 1-58.6 56.8c-34 26.1-62 60-80.8 97.9a275.96 275.96 0 0 0-29.1 124c0 74.9 29.5 145.3 83 198.4 53.7 53.2 125 82.4 201 82.4s147.3-29.2 201-82.4c53.5-53 83-123.5 83-198.4 0-39.2-8.1-77.3-24-113.1-9.3-21-21-40.5-35-58.4z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M834.1 469.2A347.49 347.49 0 0 0 751.2 354l-29.1-26.7a8.09 8.09 0 0 0-13 3.3l-13 37.3c-8.1 23.4-23 47.3-44.1 70.8-1.4 1.5-3 1.9-4.1 2-1.1.1-2.8-.1-4.3-1.5-1.4-1.2-2.1-3-2-4.8 3.7-60.2-14.3-128.1-53.7-202C555.3 171 510 123.1 453.4 89.7l-41.3-24.3c-5.4-3.2-12.3 1-12 7.3l2.2 48c1.5 32.8-2.3 61.8-11.3 85.9-11 29.5-26.8 56.9-47 81.5a295.64 295.64 0 0 1-47.5 46.1 352.6 352.6 0 0 0-100.3 121.5A347.75 347.75 0 0 0 160 610c0 47.2 9.3 92.9 27.7 136a349.4 349.4 0 0 0 75.5 110.9c32.4 32 70 57.2 111.9 74.7C418.5 949.8 464.5 959 512 959s93.5-9.2 136.9-27.3A348.6 348.6 0 0 0 760.8 857c32.4-32 57.8-69.4 75.5-110.9a344.2 344.2 0 0 0 27.7-136c0-48.8-10-96.2-29.9-140.9zM713 808.5c-53.7 53.2-125 82.4-201 82.4s-147.3-29.2-201-82.4c-53.5-53.1-83-123.5-83-198.4 0-43.5 9.8-85.2 29.1-124 18.8-37.9 46.8-71.8 80.8-97.9a349.6 349.6 0 0 0 58.6-56.8c25-30.5 44.6-64.5 58.2-101a240 240 0 0 0 12.1-46.5c24.1 22.2 44.3 49 61.2 80.4 33.4 62.6 48.8 118.3 45.8 165.7a74.01 74.01 0 0 0 24.4 59.8 73.36 73.36 0 0 0 53.4 18.8c19.7-1 37.8-9.7 51-24.4 13.3-14.9 24.8-30.1 34.4-45.6 14 17.9 25.7 37.4 35 58.4 15.9 35.8 24 73.9 24 113.1 0 74.9-29.5 145.4-83 198.4z"
                }
            }
        ]
    })(props);
}
function AiTwotoneFlag(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#D9D9D9",
                    "d": "M184 232h368v336H184z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#D9D9D9",
                    "d": "M624 632c0 4.4-3.6 8-8 8H504v73h336V377H624v255z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M880 305H624V192c0-17.7-14.3-32-32-32H184v-40c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v784c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V640h248v113c0 17.7 14.3 32 32 32h416c17.7 0 32-14.3 32-32V337c0-17.7-14.3-32-32-32zM184 568V232h368v336H184zm656 145H504v-73h112c4.4 0 8-3.6 8-8V377h216v336z"
                }
            }
        ]
    })(props);
}
function AiTwotoneFolderAdd(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#D9D9D9",
                    "d": "M372.5 256H184v512h656V370.4H492.1L372.5 256zM540 443.1V528h84.5c4.1 0 7.5 3.1 7.5 7v42c0 3.8-3.4 7-7.5 7H540v84.9c0 3.9-3.1 7.1-7 7.1h-42c-3.8 0-7-3.2-7-7.1V584h-84.5c-4.1 0-7.5-3.2-7.5-7v-42c0-3.9 3.4-7 7.5-7H484v-84.9c0-3.9 3.2-7.1 7-7.1h42c3.9 0 7 3.2 7 7.1z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M880 298.4H521L403.7 186.2a8.15 8.15 0 0 0-5.5-2.2H144c-17.7 0-32 14.3-32 32v592c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V330.4c0-17.7-14.3-32-32-32zM840 768H184V256h188.5l119.6 114.4H840V768z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M484 443.1V528h-84.5c-4.1 0-7.5 3.1-7.5 7v42c0 3.8 3.4 7 7.5 7H484v84.9c0 3.9 3.2 7.1 7 7.1h42c3.9 0 7-3.2 7-7.1V584h84.5c4.1 0 7.5-3.2 7.5-7v-42c0-3.9-3.4-7-7.5-7H540v-84.9c0-3.9-3.1-7.1-7-7.1h-42c-3.8 0-7 3.2-7 7.1z"
                }
            }
        ]
    })(props);
}
function AiTwotoneFolderOpen(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#D9D9D9",
                    "d": "M159 768h612.3l103.4-256H262.3z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M928 444H820V330.4c0-17.7-14.3-32-32-32H473L355.7 186.2a8.15 8.15 0 0 0-5.5-2.2H96c-17.7 0-32 14.3-32 32v592c0 17.7 14.3 32 32 32h698c13 0 24.8-7.9 29.7-20l134-332c1.5-3.8 2.3-7.9 2.3-12 0-17.7-14.3-32-32-32zM136 256h188.5l119.6 114.4H748V444H238c-13 0-24.8 7.9-29.7 20L136 643.2V256zm635.3 512H159l103.3-256h612.4L771.3 768z"
                }
            }
        ]
    })(props);
}
function AiTwotoneFolder(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M880 298.4H521L403.7 186.2a8.15 8.15 0 0 0-5.5-2.2H144c-17.7 0-32 14.3-32 32v592c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V330.4c0-17.7-14.3-32-32-32zM840 768H184V256h188.5l119.6 114.4H840V768z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#E6E6E6",
                    "d": "M372.5 256H184v512h656V370.4H492.1z"
                }
            }
        ]
    })(props);
}
function AiTwotoneFrown(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#E6E6E6",
                    "d": "M512 140c-205.4 0-372 166.6-372 372s166.6 372 372 372 372-166.6 372-372-166.6-372-372-372zM288 421a48.01 48.01 0 0 1 96 0 48.01 48.01 0 0 1-96 0zm376 272h-48.1c-4.2 0-7.8-3.2-8.1-7.4C604 636.1 562.5 597 512 597s-92.1 39.1-95.8 88.6c-.3 4.2-3.9 7.4-8.1 7.4H360a8 8 0 0 1-8-8.4c4.4-84.3 74.5-151.6 160-151.6s155.6 67.3 160 151.6a8 8 0 0 1-8 8.4zm24-224a48.01 48.01 0 0 1 0-96 48.01 48.01 0 0 1 0 96z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M288 421a48 48 0 1 0 96 0 48 48 0 1 0-96 0zm224 112c-85.5 0-155.6 67.3-160 151.6a8 8 0 0 0 8 8.4h48.1c4.2 0 7.8-3.2 8.1-7.4 3.7-49.5 45.3-88.6 95.8-88.6s92 39.1 95.8 88.6c.3 4.2 3.9 7.4 8.1 7.4H664a8 8 0 0 0 8-8.4C667.6 600.3 597.5 533 512 533zm128-112a48 48 0 1 0 96 0 48 48 0 1 0-96 0z"
                }
            }
        ]
    })(props);
}
function AiTwotoneFund(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M928 160H96c-17.7 0-32 14.3-32 32v640c0 17.7 14.3 32 32 32h832c17.7 0 32-14.3 32-32V192c0-17.7-14.3-32-32-32zm-40 632H136V232h752v560z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#E6E6E6",
                    "d": "M136 792h752V232H136v560zm56.4-130.5l214.9-215c3.1-3.1 8.2-3.1 11.3 0L533 561l254.5-254.6c3.1-3.1 8.2-3.1 11.3 0l36.8 36.8c3.1 3.1 3.1 8.2 0 11.3l-297 297.2a8.03 8.03 0 0 1-11.3 0L412.9 537.2 240.4 709.7a8.03 8.03 0 0 1-11.3 0l-36.7-36.9a8.03 8.03 0 0 1 0-11.3z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M229.1 709.7c3.1 3.1 8.2 3.1 11.3 0l172.5-172.5 114.4 114.5c3.1 3.1 8.2 3.1 11.3 0l297-297.2c3.1-3.1 3.1-8.2 0-11.3l-36.8-36.8a8.03 8.03 0 0 0-11.3 0L533 561 418.6 446.5a8.03 8.03 0 0 0-11.3 0l-214.9 215a8.03 8.03 0 0 0 0 11.3l36.7 36.9z"
                }
            }
        ]
    })(props);
}
function AiTwotoneFunnelPlot(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#D9D9D9",
                    "d": "M420.6 798h182.9V650H420.6zM297.7 374h428.6l85-148H212.7zm113.2 197.4l8.4 14.6h185.3l8.4-14.6L689.6 438H334.4z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M880.1 154H143.9c-24.5 0-39.8 26.7-27.5 48L349 607.4V838c0 17.7 14.2 32 31.8 32h262.4c17.6 0 31.8-14.3 31.8-32V607.4L907.7 202c12.2-21.3-3.1-48-27.6-48zM603.5 798H420.6V650h182.9v148zm9.5-226.6l-8.4 14.6H419.3l-8.4-14.6L334.4 438h355.2L613 571.4zM726.3 374H297.7l-85-148h598.6l-85 148z"
                }
            }
        ]
    })(props);
}
function AiTwotoneGift(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#D9D9D9",
                    "d": "M546 378h298v104H546zM228 550h250v308H228zm-48-172h298v104H180zm366 172h250v308H546z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M880 310H732.4c13.6-21.4 21.6-46.8 21.6-74 0-76.1-61.9-138-138-138-41.4 0-78.7 18.4-104 47.4-25.3-29-62.6-47.4-104-47.4-76.1 0-138 61.9-138 138 0 27.2 7.9 52.6 21.6 74H144c-17.7 0-32 14.3-32 32v200c0 4.4 3.6 8 8 8h40v344c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V550h40c4.4 0 8-3.6 8-8V342c0-17.7-14.3-32-32-32zM478 858H228V550h250v308zm0-376H180V378h298v104zm0-176h-70c-38.6 0-70-31.4-70-70s31.4-70 70-70 70 31.4 70 70v70zm68-70c0-38.6 31.4-70 70-70s70 31.4 70 70-31.4 70-70 70h-70v-70zm250 622H546V550h250v308zm48-376H546V378h298v104z"
                }
            }
        ]
    })(props);
}
function AiTwotoneGold(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M435.7 558.7c-.6-3.9-4-6.7-7.9-6.7H166.2c-3.9 0-7.3 2.8-7.9 6.7l-40.2 248c-.1.4-.1.9-.1 1.3 0 4.4 3.6 8 8 8h342c.4 0 .9 0 1.3-.1 4.4-.7 7.3-4.8 6.6-9.2l-40.2-248zM196.5 748l20.7-128h159.5l20.7 128H196.5zm709.4 58.7l-40.2-248c-.6-3.9-4-6.7-7.9-6.7H596.2c-3.9 0-7.3 2.8-7.9 6.7l-40.2 248c-.1.4-.1.9-.1 1.3 0 4.4 3.6 8 8 8h342c.4 0 .9 0 1.3-.1 4.3-.7 7.3-4.8 6.6-9.2zM626.5 748l20.7-128h159.5l20.7 128H626.5zM342 472h342c.4 0 .9 0 1.3-.1 4.4-.7 7.3-4.8 6.6-9.2l-40.2-248c-.6-3.9-4-6.7-7.9-6.7H382.2c-3.9 0-7.3 2.8-7.9 6.7l-40.2 248c-.1.4-.1.9-.1 1.3 0 4.4 3.6 8 8 8zm91.2-196h159.5l20.7 128h-201l20.8-128z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#E6E6E6",
                    "d": "M592.7 276H433.2l-20.8 128h201zM217.2 620l-20.7 128h200.9l-20.7-128zm430 0l-20.7 128h200.9l-20.7-128z"
                }
            }
        ]
    })(props);
}
function AiTwotoneHdd(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#D9D9D9",
                    "d": "M232 888h560V680H232v208zm448-140c22.1 0 40 17.9 40 40s-17.9 40-40 40-40-17.9-40-40 17.9-40 40-40zM232 616h560V408H232v208zm72-128c0-4.4 3.6-8 8-8h184c4.4 0 8 3.6 8 8v48c0 4.4-3.6 8-8 8H312c-4.4 0-8-3.6-8-8v-48zm-72-144h560V136H232v208zm72-128c0-4.4 3.6-8 8-8h184c4.4 0 8 3.6 8 8v48c0 4.4-3.6 8-8 8H312c-4.4 0-8-3.6-8-8v-48z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M832 64H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32zm-40 824H232V680h560v208zm0-272H232V408h560v208zm0-272H232V136h560v208z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M312 544h184c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H312c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8zm0-272h184c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H312c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8zm328 516a40 40 0 1 0 80 0 40 40 0 1 0-80 0z"
                }
            }
        ]
    })(props);
}
function AiTwotoneHeart(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M923 283.6a260.04 260.04 0 0 0-56.9-82.8 264.4 264.4 0 0 0-84-55.5A265.34 265.34 0 0 0 679.7 125c-49.3 0-97.4 13.5-139.2 39-10 6.1-19.5 12.8-28.5 20.1-9-7.3-18.5-14-28.5-20.1-41.8-25.5-89.9-39-139.2-39-35.5 0-69.9 6.8-102.4 20.3-31.4 13-59.7 31.7-84 55.5a258.44 258.44 0 0 0-56.9 82.8c-13.9 32.3-21 66.6-21 101.9 0 33.3 6.8 68 20.3 103.3 11.3 29.5 27.5 60.1 48.2 91 32.8 48.9 77.9 99.9 133.9 151.6 92.8 85.7 184.7 144.9 188.6 147.3l23.7 15.2c10.5 6.7 24 6.7 34.5 0l23.7-15.2c3.9-2.5 95.7-61.6 188.6-147.3 56-51.7 101.1-102.7 133.9-151.6 20.7-30.9 37-61.5 48.2-91 13.5-35.3 20.3-70 20.3-103.3.1-35.3-7-69.6-20.9-101.9zM512 814.8S156 586.7 156 385.5C156 283.6 240.3 201 344.3 201c73.1 0 136.5 40.8 167.7 100.4C543.2 241.8 606.6 201 679.7 201c104 0 188.3 82.6 188.3 184.5 0 201.2-356 429.3-356 429.3z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#E6E6E6",
                    "d": "M679.7 201c-73.1 0-136.5 40.8-167.7 100.4C480.8 241.8 417.4 201 344.3 201c-104 0-188.3 82.6-188.3 184.5 0 201.2 356 429.3 356 429.3s356-228.1 356-429.3C868 283.6 783.7 201 679.7 201z"
                }
            }
        ]
    })(props);
}
function AiTwotoneHighlight(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#D9D9D9",
                    "d": "M229.6 796.3h160.2l54.3-54.1-80.1-78.9zm220.7-397.1l262.8 258.9 147.3-145-262.8-259zm-77.1 166.1l171.4 168.9 68.6-67.6-171.4-168.9z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M957.6 507.5L603.2 158.3a7.9 7.9 0 0 0-11.2 0L353.3 393.5a8.03 8.03 0 0 0-.1 11.3l.1.1 40 39.4-117.2 115.3a8.03 8.03 0 0 0-.1 11.3l.1.1 39.5 38.9-189.1 187H72.1c-4.4 0-8.1 3.6-8.1 8v55.2c0 4.4 3.6 8 8 8h344.9c2.1 0 4.1-.8 5.6-2.3l76.1-75.6L539 830a7.9 7.9 0 0 0 11.2 0l117.1-115.6 40.1 39.5a7.9 7.9 0 0 0 11.2 0l238.7-235.2c3.4-3 3.4-8 .3-11.2zM389.8 796.3H229.6l134.4-133 80.1 78.9-54.3 54.1zm154.8-62.1L373.2 565.3l68.6-67.6 171.4 168.9-68.6 67.6zm168.5-76.1L450.3 399.2l147.3-145.1 262.8 259-147.3 145z"
                }
            }
        ]
    })(props);
}
function AiTwotoneHome(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#D9D9D9",
                    "d": "M512.1 172.6l-370 369.7h96V868H392V640c0-22.1 17.9-40 40-40h160c22.1 0 40 17.9 40 40v228h153.9V542.3H882L535.2 195.7l-23.1-23.1zm434.5 422.9c-6 6-13.1 10.8-20.8 13.9 7.7-3.2 14.8-7.9 20.8-13.9zm-887-34.7c5 30.3 31.4 53.5 63.1 53.5h.9c-31.9 0-58.9-23-64-53.5zm-.9-10.5v-1.9 1.9zm.1-2.6c.1-3.1.5-6.1 1-9.1-.6 2.9-.9 6-1 9.1z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M951 510c0-.1-.1-.1-.1-.2l-1.8-2.1c-.1-.1-.2-.3-.4-.4-.7-.8-1.5-1.6-2.2-2.4L560.1 118.8l-25.9-25.9a31.5 31.5 0 0 0-44.4 0L77.5 505a63.6 63.6 0 0 0-16 26.6l-.6 2.1-.3 1.1-.3 1.2c-.2.7-.3 1.4-.4 2.1 0 .1 0 .3-.1.4-.6 3-.9 6-1 9.1v3.3c0 .5 0 1 .1 1.5 0 .5 0 .9.1 1.4 0 .5.1 1 .1 1.5 0 .6.1 1.2.2 1.8 0 .3.1.6.1.9l.3 2.5v.1c5.1 30.5 32.2 53.5 64 53.5h42.5V940h691.7V614.3h43.4c8.6 0 16.9-1.7 24.5-4.9s14.7-7.9 20.8-13.9a63.6 63.6 0 0 0 18.7-45.3c0-14.7-5-28.8-14.3-40.2zM568 868H456V664h112v204zm217.9-325.7V868H632V640c0-22.1-17.9-40-40-40H432c-22.1 0-40 17.9-40 40v228H238.1V542.3h-96l370-369.7 23.1 23.1L882 542.3h-96.1z"
                }
            }
        ]
    })(props);
}
function AiTwotoneHourglass(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#D9D9D9",
                    "d": "M512 548c-42.2 0-81.9 16.4-111.7 46.3A156.63 156.63 0 0 0 354 706v134h316V706c0-42.2-16.4-81.9-46.3-111.7A156.63 156.63 0 0 0 512 548zM354 318c0 42.2 16.4 81.9 46.3 111.7C430.1 459.6 469.8 476 512 476s81.9-16.4 111.7-46.3C653.6 399.9 670 360.2 670 318V184H354v134z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M742 318V184h86c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H196c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h86v134c0 81.5 42.4 153.2 106.4 194-64 40.8-106.4 112.5-106.4 194v134h-86c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h632c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-86V706c0-81.5-42.4-153.2-106.4-194 64-40.8 106.4-112.5 106.4-194zm-72 388v134H354V706c0-42.2 16.4-81.9 46.3-111.7C430.1 564.4 469.8 548 512 548s81.9 16.4 111.7 46.3C653.6 624.1 670 663.8 670 706zm0-388c0 42.2-16.4 81.9-46.3 111.7C593.9 459.6 554.2 476 512 476s-81.9-16.4-111.7-46.3A156.63 156.63 0 0 1 354 318V184h316v134z"
                }
            }
        ]
    })(props);
}
function AiTwotoneHtml5(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M145 96l66 746.6L511.8 928l299.6-85.4L878.7 96H145zm610.9 700.6l-244.1 69.6-245.2-69.6-56.7-641.2h603.8l-57.8 641.2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#E6E6E6",
                    "d": "M209.9 155.4l56.7 641.2 245.2 69.6 244.1-69.6 57.8-641.2H209.9zm530.4 117.9l-4.8 47.2-1.7 19.5H381.7l8.2 94.2H511v-.2h214.7l-3.2 24.3-21.2 242.2-1.7 16.3-187.7 51.7v.4h-1.7l-188.6-52-11.3-144.7h91l6.5 73.2 102.4 27.7h.8v-.2l102.4-27.7 11.4-118.5H511.9v.1H305.4l-22.7-253.5L281 249h461l-1.7 24.3z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M281 249l1.7 24.3 22.7 253.5h206.5v-.1h112.9l-11.4 118.5L511 672.9v.2h-.8l-102.4-27.7-6.5-73.2h-91l11.3 144.7 188.6 52h1.7v-.4l187.7-51.7 1.7-16.3 21.2-242.2 3.2-24.3H511v.2H389.9l-8.2-94.2h352.1l1.7-19.5 4.8-47.2L742 249H511z"
                }
            }
        ]
    })(props);
}
function AiTwotoneIdcard(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M928 160H96c-17.7 0-32 14.3-32 32v640c0 17.7 14.3 32 32 32h832c17.7 0 32-14.3 32-32V192c0-17.7-14.3-32-32-32zm-40 632H136V232h752v560z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#E6E6E6",
                    "d": "M136 792h752V232H136v560zm472-372c0-4.4 1-8 2.3-8h123.4c1.3 0 2.3 3.6 2.3 8v48c0 4.4-1 8-2.3 8H610.3c-1.3 0-2.3-3.6-2.3-8v-48zm0 144c0-4.4 3.2-8 7.1-8h185.7c3.9 0 7.1 3.6 7.1 8v48c0 4.4-3.2 8-7.1 8H615.1c-3.9 0-7.1-3.6-7.1-8v-48zM216.2 664.6c2.8-53.3 31.9-99.6 74.6-126.1-18.1-20-29.1-46.4-29.1-75.5 0-61.9 49.9-112 111.4-112s111.4 50.1 111.4 112c0 29.1-11 55.6-29.1 75.5 42.6 26.4 71.8 72.8 74.6 126.1a8 8 0 0 1-8 8.4h-43.9c-4.2 0-7.6-3.3-7.9-7.5-3.8-50.5-46-90.5-97.2-90.5s-93.4 40-97.2 90.5c-.3 4.2-3.7 7.5-7.9 7.5H224c-4.6 0-8.2-3.8-7.8-8.4z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#E6E6E6",
                    "d": "M321.3 463a51.7 52 0 1 0 103.4 0 51.7 52 0 1 0-103.4 0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M610.3 476h123.4c1.3 0 2.3-3.6 2.3-8v-48c0-4.4-1-8-2.3-8H610.3c-1.3 0-2.3 3.6-2.3 8v48c0 4.4 1 8 2.3 8zm4.8 144h185.7c3.9 0 7.1-3.6 7.1-8v-48c0-4.4-3.2-8-7.1-8H615.1c-3.9 0-7.1 3.6-7.1 8v48c0 4.4 3.2 8 7.1 8zM224 673h43.9c4.2 0 7.6-3.3 7.9-7.5 3.8-50.5 46-90.5 97.2-90.5s93.4 40 97.2 90.5c.3 4.2 3.7 7.5 7.9 7.5H522a8 8 0 0 0 8-8.4c-2.8-53.3-32-99.7-74.6-126.1a111.8 111.8 0 0 0 29.1-75.5c0-61.9-49.9-112-111.4-112s-111.4 50.1-111.4 112c0 29.1 11 55.5 29.1 75.5a158.09 158.09 0 0 0-74.6 126.1c-.4 4.6 3.2 8.4 7.8 8.4zm149-262c28.5 0 51.7 23.3 51.7 52s-23.2 52-51.7 52-51.7-23.3-51.7-52 23.2-52 51.7-52z"
                }
            }
        ]
    })(props);
}
function AiTwotoneInfoCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#E6E6E6",
                    "d": "M512 140c-205.4 0-372 166.6-372 372s166.6 372 372 372 372-166.6 372-372-166.6-372-372-372zm32 588c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V456c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v272zm-32-344a48.01 48.01 0 0 1 0-96 48.01 48.01 0 0 1 0 96z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M464 336a48 48 0 1 0 96 0 48 48 0 1 0-96 0zm72 112h-48c-4.4 0-8 3.6-8 8v272c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V456c0-4.4-3.6-8-8-8z"
                }
            }
        ]
    })(props);
}
function AiTwotoneInsurance(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M866.9 169.9L527.1 54.1C523 52.7 517.5 52 512 52s-11 .7-15.1 2.1L157.1 169.9c-8.3 2.8-15.1 12.4-15.1 21.2v482.4c0 8.8 5.7 20.4 12.6 25.9L499.3 968c3.5 2.7 8 4.1 12.6 4.1s9.2-1.4 12.6-4.1l344.7-268.6c6.9-5.4 12.6-17 12.6-25.9V191.1c.2-8.8-6.6-18.3-14.9-21.2zM810 654.3L512 886.5 214 654.3V226.7l298-101.6 298 101.6v427.6z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#E6E6E6",
                    "d": "M521.9 358.8h97.9v41.6h-97.9z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#E6E6E6",
                    "d": "M214 226.7v427.6l298 232.2 298-232.2V226.7L512 125.1 214 226.7zM413.3 656h-.2c0 4.4-3.6 8-8 8h-37.3c-4.4 0-8-3.6-8-8V471.4c-7.7 9.2-15.4 17.9-23.1 26a6.04 6.04 0 0 1-10.2-2.4l-13.2-43.5c-.6-2-.2-4.1 1.2-5.6 37-43.4 64.7-95.1 82.2-153.6 1.1-3.5 5-5.3 8.4-3.7l38.6 18.3c2.7 1.3 4.1 4.4 3.2 7.2a429.2 429.2 0 0 1-33.6 79V656zm257.9-340v127.2c0 4.4-3.6 8-8 8h-66.7v18.6h98.8c4.4 0 8 3.6 8 8v35.6c0 4.4-3.6 8-8 8h-59c18.1 29.1 41.8 54.3 72.3 76.9 2.6 2.1 3.2 5.9 1.2 8.5l-26.3 35.3a5.92 5.92 0 0 1-8.9.7c-30.6-29.3-56.8-65.2-78.1-106.9V656c0 4.4-3.6 8-8 8h-36.2c-4.4 0-8-3.6-8-8V536c-22 44.7-49 80.8-80.6 107.6a6.38 6.38 0 0 1-4.8 1.4c-1.7-.3-3.2-1.3-4.1-2.8L432 605.7a6 6 0 0 1 1.6-8.1c28.6-20.3 51.9-45.2 71-76h-55.1c-4.4 0-8-3.6-8-8V478c0-4.4 3.6-8 8-8h94.9v-18.6h-65.9c-4.4 0-8-3.6-8-8V316c0-4.4 3.6-8 8-8h184.7c4.4 0 8 3.6 8 8z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M443.7 306.9l-38.6-18.3c-3.4-1.6-7.3.2-8.4 3.7-17.5 58.5-45.2 110.2-82.2 153.6a5.7 5.7 0 0 0-1.2 5.6l13.2 43.5c1.4 4.5 7 5.8 10.2 2.4 7.7-8.1 15.4-16.8 23.1-26V656c0 4.4 3.6 8 8 8h37.3c4.4 0 8-3.6 8-8h.2V393.1a429.2 429.2 0 0 0 33.6-79c.9-2.8-.5-5.9-3.2-7.2zm26.8 9.1v127.4c0 4.4 3.6 8 8 8h65.9V470h-94.9c-4.4 0-8 3.6-8 8v35.6c0 4.4 3.6 8 8 8h55.1c-19.1 30.8-42.4 55.7-71 76a6 6 0 0 0-1.6 8.1l22.8 36.5c.9 1.5 2.4 2.5 4.1 2.8 1.7.3 3.5-.2 4.8-1.4 31.6-26.8 58.6-62.9 80.6-107.6v120c0 4.4 3.6 8 8 8h36.2c4.4 0 8-3.6 8-8V535.9c21.3 41.7 47.5 77.6 78.1 106.9 2.6 2.5 6.7 2.2 8.9-.7l26.3-35.3c2-2.6 1.4-6.4-1.2-8.5-30.5-22.6-54.2-47.8-72.3-76.9h59c4.4 0 8-3.6 8-8v-35.6c0-4.4-3.6-8-8-8h-98.8v-18.6h66.7c4.4 0 8-3.6 8-8V316c0-4.4-3.6-8-8-8H478.5c-4.4 0-8 3.6-8 8zm51.4 42.8h97.9v41.6h-97.9v-41.6z"
                }
            }
        ]
    })(props);
}
function AiTwotoneInteraction(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#E6E6E6",
                    "d": "M184 840h656V184H184v656zm114-401.9c0-55.3 44.6-100.1 99.7-100.1h205.8v-53.4c0-5.6 6.5-8.8 10.9-5.3L723.5 365c3.5 2.7 3.5 8 0 10.7l-109.1 85.7c-4.4 3.5-10.9.4-10.9-5.3v-53.4H397.8c-19.6 0-35.5 15.9-35.5 35.6v78.9c0 3.8-3.1 6.8-6.8 6.8h-50.7c-3.8 0-6.8-3-6.8-7v-78.9zm2.6 210.3l109.1-85.7c4.4-3.5 10.9-.4 10.9 5.3v53.4h205.6c19.6 0 35.5-15.9 35.5-35.6v-78.9c0-3.8 3.1-6.8 6.8-6.8h50.7c3.8 0 6.8 3.1 6.8 6.8v78.9c0 55.3-44.6 100.1-99.7 100.1H420.6v53.4c0 5.6-6.5 8.8-10.9 5.3l-109.1-85.7c-3.5-2.7-3.5-8 0-10.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M304.8 524h50.7c3.7 0 6.8-3 6.8-6.8v-78.9c0-19.7 15.9-35.6 35.5-35.6h205.7v53.4c0 5.7 6.5 8.8 10.9 5.3l109.1-85.7c3.5-2.7 3.5-8 0-10.7l-109.1-85.7c-4.4-3.5-10.9-.3-10.9 5.3V338H397.7c-55.1 0-99.7 44.8-99.7 100.1V517c0 4 3 7 6.8 7zm-4.2 134.9l109.1 85.7c4.4 3.5 10.9.3 10.9-5.3v-53.4h205.7c55.1 0 99.7-44.8 99.7-100.1v-78.9c0-3.7-3-6.8-6.8-6.8h-50.7c-3.7 0-6.8 3-6.8 6.8v78.9c0 19.7-15.9 35.6-35.5 35.6H420.6V568c0-5.7-6.5-8.8-10.9-5.3l-109.1 85.7c-3.5 2.5-3.5 7.8 0 10.5z"
                }
            }
        ]
    })(props);
}
function AiTwotoneLayout(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#D9D9D9",
                    "d": "M384 185h456v136H384zm-200 0h136v656H184zm696-73H144c-17.7 0-32 14.3-32 32v1c0-17.7 14.3-32 32-32h736c17.7 0 32 14.3 32 32v-1c0-17.7-14.3-32-32-32zM384 385h456v456H384z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M880 113H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V145c0-17.7-14.3-32-32-32zM320 841H184V185h136v656zm520 0H384V385h456v456zm0-520H384V185h456v136z"
                }
            }
        ]
    })(props);
}
function AiTwotoneLeftCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#E6E6E6",
                    "d": "M512 140c-205.4 0-372 166.6-372 372s166.6 372 372 372 372-166.6 372-372-166.6-372-372-372zm104 240.9c0 10.3-4.9 19.9-13.2 25.9L457.4 512l145.4 105.1c8.3 6 13.2 15.7 13.2 25.9v46.9c0 6.5-7.4 10.3-12.7 6.5l-246-178a7.95 7.95 0 0 1 0-12.9l246-178c5.3-3.8 12.7 0 12.7 6.5v46.9z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M603.3 327.5l-246 178a7.95 7.95 0 0 0 0 12.9l246 178c5.3 3.8 12.7 0 12.7-6.5V643c0-10.2-4.9-19.9-13.2-25.9L457.4 512l145.4-105.2c8.3-6 13.2-15.6 13.2-25.9V334c0-6.5-7.4-10.3-12.7-6.5z"
                }
            }
        ]
    })(props);
}
function AiTwotoneLeftSquare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#E6E6E6",
                    "d": "M184 840h656V184H184v656zm181.3-334.5l246-178c5.3-3.8 12.7 0 12.7 6.5v46.9c0 10.3-4.9 19.9-13.2 25.9L465.4 512l145.4 105.2c8.3 6 13.2 15.7 13.2 25.9V690c0 6.5-7.4 10.3-12.7 6.4l-246-178a7.95 7.95 0 0 1 0-12.9z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M365.3 518.4l246 178c5.3 3.9 12.7.1 12.7-6.4v-46.9c0-10.2-4.9-19.9-13.2-25.9L465.4 512l145.4-105.2c8.3-6 13.2-15.6 13.2-25.9V334c0-6.5-7.4-10.3-12.7-6.5l-246 178a7.95 7.95 0 0 0 0 12.9z"
                }
            }
        ]
    })(props);
}
function AiTwotoneLike(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#D9D9D9",
                    "d": "M273 495.9v428l.3-428zm538.2-88.3H496.8l9.6-198.4c.6-11.9-4.7-23.1-14.6-30.5-6.1-4.5-13.6-6.8-21.1-6.7-19.6.1-36.9 13.4-42.2 32.3-37.1 134.4-64.9 235.2-83.5 302.5V852h399.4a56.85 56.85 0 0 0 33.6-51.8c0-9.7-2.3-18.9-6.9-27.3l-13.9-25.4 21.9-19a56.76 56.76 0 0 0 19.6-43c0-9.7-2.3-18.9-6.9-27.3l-13.9-25.4 21.9-19a56.76 56.76 0 0 0 19.6-43c0-9.7-2.3-18.9-6.9-27.3l-14-25.5 21.9-19a56.76 56.76 0 0 0 19.6-43c0-19.1-11-37.5-28.8-48.4z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M112 528v364c0 17.7 14.3 32 32 32h65V496h-65c-17.7 0-32 14.3-32 32zm773.9 5.7c16.8-22.2 26.1-49.4 26.1-77.7 0-44.9-25.1-87.5-65.5-111a67.67 67.67 0 0 0-34.3-9.3H572.3l6-122.9c1.5-29.7-9-57.9-29.5-79.4a106.4 106.4 0 0 0-77.9-33.4c-52 0-98 35-111.8 85.1l-85.8 310.8-.3 428h472.1c9.3 0 18.2-1.8 26.5-5.4 47.6-20.3 78.3-66.8 78.3-118.4 0-12.6-1.8-25-5.4-37 16.8-22.2 26.1-49.4 26.1-77.7 0-12.6-1.8-25-5.4-37 16.8-22.2 26.1-49.4 26.1-77.7 0-12.6-1.8-25-5.4-37zM820.4 499l-21.9 19 14 25.5a56.2 56.2 0 0 1 6.9 27.3c0 16.5-7.1 32.2-19.6 43l-21.9 19 13.9 25.4a56.2 56.2 0 0 1 6.9 27.3c0 16.5-7.1 32.2-19.6 43l-21.9 19 13.9 25.4a56.2 56.2 0 0 1 6.9 27.3c0 22.4-13.2 42.6-33.6 51.8H345V506.8c18.6-67.2 46.4-168 83.5-302.5a44.28 44.28 0 0 1 42.2-32.3c7.5-.1 15 2.2 21.1 6.7 9.9 7.4 15.2 18.6 14.6 30.5l-9.6 198.4h314.4C829 418.5 840 436.9 840 456c0 16.5-7.1 32.2-19.6 43z"
                }
            }
        ]
    })(props);
}
function AiTwotoneLock(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M832 464h-68V240c0-70.7-57.3-128-128-128H388c-70.7 0-128 57.3-128 128v224h-68c-17.7 0-32 14.3-32 32v384c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V496c0-17.7-14.3-32-32-32zM332 240c0-30.9 25.1-56 56-56h248c30.9 0 56 25.1 56 56v224H332V240zm460 600H232V536h560v304z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#E6E6E6",
                    "d": "M232 840h560V536H232v304zm280-226a48.01 48.01 0 0 1 28 87v53c0 4.4-3.6 8-8 8h-40c-4.4 0-8-3.6-8-8v-53a48.01 48.01 0 0 1 28-87z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M484 701v53c0 4.4 3.6 8 8 8h40c4.4 0 8-3.6 8-8v-53a48.01 48.01 0 1 0-56 0z"
                }
            }
        ]
    })(props);
}
function AiTwotoneMail(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#D9D9D9",
                    "d": "M477.5 536.3L135.9 270.7l-27.5-21.4 27.6 21.5V792h752V270.8L546.2 536.3a55.99 55.99 0 0 1-68.7 0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#D9D9D9",
                    "d": "M876.3 198.8l39.3 50.5-27.6 21.5 27.7-21.5-39.3-50.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M928 160H96c-17.7 0-32 14.3-32 32v640c0 17.7 14.3 32 32 32h832c17.7 0 32-14.3 32-32V192c0-17.7-14.3-32-32-32zm-94.5 72.1L512 482 190.5 232.1h643zm54.5 38.7V792H136V270.8l-27.6-21.5 27.5 21.4 341.6 265.6a55.99 55.99 0 0 0 68.7 0L888 270.8l27.6-21.5-39.3-50.5h.1l39.3 50.5-27.7 21.5z"
                }
            }
        ]
    })(props);
}
function AiTwotoneMedicineBox(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#D9D9D9",
                    "d": "M244.3 328L184 513.4V840h656V513.4L779.7 328H244.3zM660 628c0 4.4-3.6 8-8 8H544v108c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V636H372c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h108V464c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v108h108c4.4 0 8 3.6 8 8v48z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M652 572H544V464c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v108H372c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h108v108c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V636h108c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M839.2 278.1a32 32 0 0 0-30.4-22.1H736V144c0-17.7-14.3-32-32-32H320c-17.7 0-32 14.3-32 32v112h-72.8a31.9 31.9 0 0 0-30.4 22.1L112 502v378c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V502l-72.8-223.9zM360 184h304v72H360v-72zm480 656H184V513.4L244.3 328h535.4L840 513.4V840z"
                }
            }
        ]
    })(props);
}
function AiTwotoneMeh(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#E6E6E6",
                    "d": "M512 140c-205.4 0-372 166.6-372 372s166.6 372 372 372 372-166.6 372-372-166.6-372-372-372zM288 421a48.01 48.01 0 0 1 96 0 48.01 48.01 0 0 1-96 0zm384 200c0 4.4-3.6 8-8 8H360c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h304c4.4 0 8 3.6 8 8v48zm16-152a48.01 48.01 0 0 1 0-96 48.01 48.01 0 0 1 0 96z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M288 421a48 48 0 1 0 96 0 48 48 0 1 0-96 0zm376 144H360c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h304c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zm-24-144a48 48 0 1 0 96 0 48 48 0 1 0-96 0z"
                }
            }
        ]
    })(props);
}
function AiTwotoneMessage(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#D8D8D8",
                    "d": "M775.3 248.9a369.62 369.62 0 0 0-119-80A370.2 370.2 0 0 0 512.1 140h-1.7c-99.7.4-193 39.4-262.8 109.9-69.9 70.5-108 164.1-107.6 263.8.3 60.3 15.3 120.2 43.5 173.1l4.5 8.4V836h140.8l8.4 4.5c52.9 28.2 112.8 43.2 173.1 43.5h1.7c99 0 192-38.2 262.1-107.6 70.4-69.8 109.5-163.1 110.1-262.7.2-50.6-9.5-99.6-28.9-145.8a370.15 370.15 0 0 0-80-119zM312 560a48.01 48.01 0 0 1 0-96 48.01 48.01 0 0 1 0 96zm200 0a48.01 48.01 0 0 1 0-96 48.01 48.01 0 0 1 0 96zm200 0a48.01 48.01 0 0 1 0-96 48.01 48.01 0 0 1 0 96z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M664 512a48 48 0 1 0 96 0 48 48 0 1 0-96 0zm-400 0a48 48 0 1 0 96 0 48 48 0 1 0-96 0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M925.2 338.4c-22.6-53.7-55-101.9-96.3-143.3a444.35 444.35 0 0 0-143.3-96.3C630.6 75.7 572.2 64 512 64h-2c-60.6.3-119.3 12.3-174.5 35.9a445.35 445.35 0 0 0-142 96.5c-40.9 41.3-73 89.3-95.2 142.8-23 55.4-34.6 114.3-34.3 174.9A449.4 449.4 0 0 0 112 714v152a46 46 0 0 0 46 46h152.1A449.4 449.4 0 0 0 510 960h2.1c59.9 0 118-11.6 172.7-34.3a444.48 444.48 0 0 0 142.8-95.2c41.3-40.9 73.8-88.7 96.5-142 23.6-55.2 35.6-113.9 35.9-174.5.3-60.9-11.5-120-34.8-175.6zm-151.1 438C704 845.8 611 884 512 884h-1.7c-60.3-.3-120.2-15.3-173.1-43.5l-8.4-4.5H188V695.2l-4.5-8.4C155.3 633.9 140.3 574 140 513.7c-.4-99.7 37.7-193.3 107.6-263.8 69.8-70.5 163.1-109.5 262.8-109.9h1.7c50 0 98.5 9.7 144.2 28.9 44.6 18.7 84.6 45.6 119 80 34.3 34.3 61.3 74.4 80 119 19.4 46.2 29.1 95.2 28.9 145.8-.6 99.6-39.7 192.9-110.1 262.7z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M464 512a48 48 0 1 0 96 0 48 48 0 1 0-96 0z"
                }
            }
        ]
    })(props);
}
function AiTwotoneMinusCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#E6E6E6",
                    "d": "M512 140c-205.4 0-372 166.6-372 372s166.6 372 372 372 372-166.6 372-372-166.6-372-372-372zm192 396c0 4.4-3.6 8-8 8H328c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h368c4.4 0 8 3.6 8 8v48z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M696 480H328c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h368c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8z"
                }
            }
        ]
    })(props);
}
function AiTwotoneMinusSquare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#E6E6E6",
                    "d": "M184 840h656V184H184v656zm136-352c0-4.4 3.6-8 8-8h368c4.4 0 8 3.6 8 8v48c0 4.4-3.6 8-8 8H328c-4.4 0-8-3.6-8-8v-48z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M328 544h368c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H328c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8z"
                }
            }
        ]
    })(props);
}
function AiTwotoneMobile(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M744 64H280c-35.3 0-64 28.7-64 64v768c0 35.3 28.7 64 64 64h464c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64zm-8 824H288V136h448v752z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#E6E6E6",
                    "d": "M288 888h448V136H288v752zm224-142c22.1 0 40 17.9 40 40s-17.9 40-40 40-40-17.9-40-40 17.9-40 40-40z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M472 786a40 40 0 1 0 80 0 40 40 0 1 0-80 0z"
                }
            }
        ]
    })(props);
}
function AiTwotoneMoneyCollect(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#D9D9D9",
                    "d": "M256 744.4l256 93.1 256-93.1V184H256v560.4zM359.7 313c1.2-.7 2.5-1 3.8-1h55.7a8 8 0 0 1 7.1 4.4L511 485.2h3.3L599 316.4c1.3-2.7 4.1-4.4 7.1-4.4h54.5c4.4 0 8 3.6 8.1 7.9 0 1.3-.4 2.6-1 3.8L564 515.3h57.6c4.4 0 8 3.6 8 8v27.1c0 4.4-3.6 8-8 8h-76.3v39h76.3c4.4 0 8 3.6 8 8v27.1c0 4.4-3.6 8-8 8h-76.3V704c0 4.4-3.6 8-8 8h-49.9c-4.4 0-8-3.6-8-8v-63.4h-76c-4.4 0-8-3.6-8-8v-27.1c0-4.4 3.6-8 8-8h76v-39h-76c-4.4 0-8-3.6-8-8v-27.1c0-4.4 3.6-8 8-8h57L356.5 323.8c-2.1-3.8-.7-8.7 3.2-10.8z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M911.5 700.7a8 8 0 0 0-10.3-4.8L840 718.2V180c0-37.6-30.4-68-68-68H252c-37.6 0-68 30.4-68 68v538.2l-61.3-22.3c-.9-.3-1.8-.5-2.7-.5-4.4 0-8 3.6-8 8V763c0 3.3 2.1 6.3 5.3 7.5L501 910.1c7.1 2.6 14.8 2.6 21.9 0l383.8-139.5c3.2-1.2 5.3-4.2 5.3-7.5v-59.6c0-1-.2-1.9-.5-2.8zM768 744.4l-256 93.1-256-93.1V184h512v560.4z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M460.4 515.4h-57c-4.4 0-8 3.6-8 8v27.1c0 4.4 3.6 8 8 8h76v39h-76c-4.4 0-8 3.6-8 8v27.1c0 4.4 3.6 8 8 8h76V704c0 4.4 3.6 8 8 8h49.9c4.4 0 8-3.6 8-8v-63.5h76.3c4.4 0 8-3.6 8-8v-27.1c0-4.4-3.6-8-8-8h-76.3v-39h76.3c4.4 0 8-3.6 8-8v-27.1c0-4.4-3.6-8-8-8H564l103.7-191.6c.6-1.2 1-2.5 1-3.8-.1-4.3-3.7-7.9-8.1-7.9h-54.5c-3 0-5.8 1.7-7.1 4.4l-84.7 168.8H511l-84.7-168.8a8 8 0 0 0-7.1-4.4h-55.7c-1.3 0-2.6.3-3.8 1-3.9 2.1-5.3 7-3.2 10.8l103.9 191.6z"
                }
            }
        ]
    })(props);
}
function AiTwotoneNotification(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#D9D9D9",
                    "d": "M229.6 678.1c-3.7 11.6-5.6 23.9-5.6 36.4 0-12.5 2-24.8 5.7-36.4h-.1zm76.3-260.2H184v188.2h121.9l12.9 5.2L840 820.7V203.3L318.8 412.7z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M880 112c-3.8 0-7.7.7-11.6 2.3L292 345.9H128c-8.8 0-16 7.4-16 16.6v299c0 9.2 7.2 16.6 16 16.6h101.7c-3.7 11.6-5.7 23.9-5.7 36.4 0 65.9 53.8 119.5 120 119.5 55.4 0 102.1-37.6 115.9-88.4l408.6 164.2c3.9 1.5 7.8 2.3 11.6 2.3 16.9 0 32-14.2 32-33.2V145.2C912 126.2 897 112 880 112zM344 762.3c-26.5 0-48-21.4-48-47.8 0-11.2 3.9-21.9 11-30.4l84.9 34.1c-2 24.6-22.7 44.1-47.9 44.1zm496 58.4L318.8 611.3l-12.9-5.2H184V417.9h121.9l12.9-5.2L840 203.3v617.4z"
                }
            }
        ]
    })(props);
}
function AiTwotonePauseCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#E6E6E6",
                    "d": "M512 140c-205.4 0-372 166.6-372 372s166.6 372 372 372 372-166.6 372-372-166.6-372-372-372zm-80 524c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V360c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v304zm224 0c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V360c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v304z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M424 352h-48c-4.4 0-8 3.6-8 8v304c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V360c0-4.4-3.6-8-8-8zm224 0h-48c-4.4 0-8 3.6-8 8v304c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V360c0-4.4-3.6-8-8-8z"
                }
            }
        ]
    })(props);
}
function AiTwotonePhone(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#D9D9D9",
                    "d": "M721.7 184.9L610.9 295.8l120.8 120.7-8 21.6A481.29 481.29 0 0 1 438 723.9l-21.6 8-.9-.9-119.8-120-110.8 110.9 104.5 104.5c10.8 10.7 26 15.7 40.8 13.2 117.9-19.5 235.4-82.9 330.9-178.4s158.9-213.1 178.4-331c2.5-14.8-2.5-30-13.3-40.8L721.7 184.9z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M877.1 238.7L770.6 132.3c-13-13-30.4-20.3-48.8-20.3s-35.8 7.2-48.8 20.3L558.3 246.8c-13 13-20.3 30.5-20.3 48.9 0 18.5 7.2 35.8 20.3 48.9l89.6 89.7a405.46 405.46 0 0 1-86.4 127.3c-36.7 36.9-79.6 66-127.2 86.6l-89.6-89.7c-13-13-30.4-20.3-48.8-20.3a68.2 68.2 0 0 0-48.8 20.3L132.3 673c-13 13-20.3 30.5-20.3 48.9 0 18.5 7.2 35.8 20.3 48.9l106.4 106.4c22.2 22.2 52.8 34.9 84.2 34.9 6.5 0 12.8-.5 19.2-1.6 132.4-21.8 263.8-92.3 369.9-198.3C818 606 888.4 474.6 910.4 342.1c6.3-37.6-6.3-76.3-33.3-103.4zm-37.6 91.5c-19.5 117.9-82.9 235.5-178.4 331s-213 158.9-330.9 178.4c-14.8 2.5-30-2.5-40.8-13.2L184.9 721.9 295.7 611l119.8 120 .9.9 21.6-8a481.29 481.29 0 0 0 285.7-285.8l8-21.6-120.8-120.7 110.8-110.9 104.5 104.5c10.8 10.8 15.8 26 13.3 40.8z"
                }
            }
        ]
    })(props);
}
function AiTwotonePicture(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M928 160H96c-17.7 0-32 14.3-32 32v640c0 17.7 14.3 32 32 32h832c17.7 0 32-14.3 32-32V192c0-17.7-14.3-32-32-32zm-40 632H136v-39.9l138.5-164.3 150.1 178L658.1 489 888 761.6V792zm0-129.8L664.2 396.8c-3.2-3.8-9-3.8-12.2 0L424.6 666.4l-144-170.7c-3.2-3.8-9-3.8-12.2 0L136 652.7V232h752v430.2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#E6E6E6",
                    "d": "M424.6 765.8l-150.1-178L136 752.1V792h752v-30.4L658.1 489z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#E6E6E6",
                    "d": "M136 652.7l132.4-157c3.2-3.8 9-3.8 12.2 0l144 170.7L652 396.8c3.2-3.8 9-3.8 12.2 0L888 662.2V232H136v420.7zM304 280a88 88 0 1 1 0 176 88 88 0 0 1 0-176z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#E6E6E6",
                    "d": "M276 368a28 28 0 1 0 56 0 28 28 0 1 0-56 0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M304 456a88 88 0 1 0 0-176 88 88 0 0 0 0 176zm0-116c15.5 0 28 12.5 28 28s-12.5 28-28 28-28-12.5-28-28 12.5-28 28-28z"
                }
            }
        ]
    })(props);
}
function AiTwotonePieChart(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#D9D9D9",
                    "d": "M316.2 920.5c-47.6-20.1-90.4-49-127.1-85.7a398.19 398.19 0 0 1-85.7-127.1A397.12 397.12 0 0 1 72 552.2v.2a398.57 398.57 0 0 0 117 282.5c36.7 36.7 79.4 65.5 127 85.6A396.64 396.64 0 0 0 471.6 952c27 0 53.6-2.7 79.7-7.9-25.9 5.2-52.4 7.8-79.3 7.8-54 .1-106.4-10.5-155.8-31.4zM560 472c-4.4 0-8-3.6-8-8V79.9c0-1.3.3-2.5.9-3.6-.9 1.3-1.5 2.9-1.5 4.6v383.7c0 4.4 3.6 8 8 8l383.6-1c1.6 0 3.1-.5 4.4-1.3-1 .5-2.2.7-3.4.7l-384 1z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#D9D9D9",
                    "d": "M619.8 147.6v256.6l256.4-.7c-13-62.5-44.3-120.5-90-166.1a332.24 332.24 0 0 0-166.4-89.8z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#D9D9D9",
                    "d": "M438 221.7c-75.9 7.6-146.2 40.9-200.8 95.5C174.5 379.9 140 463.3 140 552s34.5 172.1 97.2 234.8c62.3 62.3 145.1 96.8 233.2 97.2 88.2.4 172.7-34.1 235.3-96.2C761 733 794.6 662.3 802.3 586H438V221.7z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M864 518H506V160c0-4.4-3.6-8-8-8h-26a398.46 398.46 0 0 0-282.8 117.1 398.19 398.19 0 0 0-85.7 127.1A397.61 397.61 0 0 0 72 552v.2c0 53.9 10.6 106.2 31.4 155.5 20.1 47.6 49 90.4 85.7 127.1 36.7 36.7 79.5 65.6 127.1 85.7A397.61 397.61 0 0 0 472 952c26.9 0 53.4-2.6 79.3-7.8 26.1-5.3 51.7-13.1 76.4-23.6 47.6-20.1 90.4-49 127.1-85.7 36.7-36.7 65.6-79.5 85.7-127.1A397.61 397.61 0 0 0 872 552v-26c0-4.4-3.6-8-8-8zM705.7 787.8A331.59 331.59 0 0 1 470.4 884c-88.1-.4-170.9-34.9-233.2-97.2C174.5 724.1 140 640.7 140 552s34.5-172.1 97.2-234.8c54.6-54.6 124.9-87.9 200.8-95.5V586h364.3c-7.7 76.3-41.3 147-96.6 201.8z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M952 462.4l-2.6-28.2c-8.5-92.1-49.4-179-115.2-244.6A399.4 399.4 0 0 0 589 74.6L560.7 72c-3.4-.3-6.4 1.5-7.8 4.3a8.7 8.7 0 0 0-.9 3.6V464c0 4.4 3.6 8 8 8l384-1c1.2 0 2.3-.3 3.4-.7a8.1 8.1 0 0 0 4.6-7.9zm-332.2-58.2V147.6a332.24 332.24 0 0 1 166.4 89.8c45.7 45.6 77 103.6 90 166.1l-256.4.7z"
                }
            }
        ]
    })(props);
}
function AiTwotonePlayCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#E6E6E6",
                    "d": "M512 140c-205.4 0-372 166.6-372 372s166.6 372 372 372 372-166.6 372-372-166.6-372-372-372zm164.1 378.2L457.7 677.1a8.02 8.02 0 0 1-12.7-6.5V353a8 8 0 0 1 12.7-6.5l218.4 158.8a7.9 7.9 0 0 1 0 12.9z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M676.1 505.3L457.7 346.5A8 8 0 0 0 445 353v317.6a8.02 8.02 0 0 0 12.7 6.5l218.4-158.9a7.9 7.9 0 0 0 0-12.9z"
                }
            }
        ]
    })(props);
}
function AiTwotonePlaySquare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#E6E6E6",
                    "d": "M184 840h656V184H184v656zm240-484.7c0-9.4 10.9-14.7 18.3-8.8l199.4 156.7a11.2 11.2 0 0 1 0 17.6L442.3 677.6c-7.4 5.8-18.3.6-18.3-8.8V355.3z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M442.3 677.6l199.4-156.8a11.2 11.2 0 0 0 0-17.6L442.3 346.5c-7.4-5.9-18.3-.6-18.3 8.8v313.5c0 9.4 10.9 14.6 18.3 8.8z"
                }
            }
        ]
    })(props);
}
function AiTwotonePlusCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#E6E6E6",
                    "d": "M512 140c-205.4 0-372 166.6-372 372s166.6 372 372 372 372-166.6 372-372-166.6-372-372-372zm192 396c0 4.4-3.6 8-8 8H544v152c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V544H328c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h152V328c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v152h152c4.4 0 8 3.6 8 8v48z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M696 480H544V328c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v152H328c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h152v152c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V544h152c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8z"
                }
            }
        ]
    })(props);
}
function AiTwotonePlusSquare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#E6E6E6",
                    "d": "M184 840h656V184H184v656zm136-352c0-4.4 3.6-8 8-8h152V328c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v152h152c4.4 0 8 3.6 8 8v48c0 4.4-3.6 8-8 8H544v152c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V544H328c-4.4 0-8-3.6-8-8v-48z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M328 544h152v152c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V544h152c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H544V328c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v152H328c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8z"
                }
            }
        ]
    })(props);
}
function AiTwotonePoundCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#E6E6E6",
                    "d": "M512 140c-205.4 0-372 166.6-372 372s166.6 372 372 372 372-166.6 372-372-166.6-372-372-372zm146 582.1c0 4.4-3.6 8-8 8H376.2c-4.4 0-8-3.6-8-8v-38.5c0-3.7 2.5-6.9 6.1-7.8 44-10.9 72.8-49 72.8-94.2 0-14.7-2.5-29.4-5.9-44.2H374c-4.4 0-8-3.6-8-8v-30c0-4.4 3.6-8 8-8h53.7c-7.8-25.1-14.6-50.7-14.6-77.1 0-75.8 58.6-120.3 151.5-120.3 26.5 0 51.4 5.5 70.3 12.7 3.1 1.2 5.2 4.2 5.2 7.5v39.5a8 8 0 0 1-10.6 7.6c-17.9-6.4-39-10.5-60.4-10.5-53.3 0-87.3 26.6-87.3 70.2 0 24.7 6.2 47.9 13.4 70.5h112c4.4 0 8 3.6 8 8v30c0 4.4-3.6 8-8 8h-98.6c3.1 13.2 5.3 26.9 5.3 41 0 40.7-16.5 73.9-43.9 91.1v4.7h180c4.4 0 8 3.6 8 8v39.8z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M650 674.3H470v-4.7c27.4-17.2 43.9-50.4 43.9-91.1 0-14.1-2.2-27.8-5.3-41h98.6c4.4 0 8-3.6 8-8v-30c0-4.4-3.6-8-8-8h-112c-7.2-22.6-13.4-45.8-13.4-70.5 0-43.6 34-70.2 87.3-70.2 21.4 0 42.5 4.1 60.4 10.5a8 8 0 0 0 10.6-7.6v-39.5c0-3.3-2.1-6.3-5.2-7.5-18.9-7.2-43.8-12.7-70.3-12.7-92.9 0-151.5 44.5-151.5 120.3 0 26.4 6.8 52 14.6 77.1H374c-4.4 0-8 3.6-8 8v30c0 4.4 3.6 8 8 8h67.2c3.4 14.8 5.9 29.5 5.9 44.2 0 45.2-28.8 83.3-72.8 94.2-3.6.9-6.1 4.1-6.1 7.8v38.5c0 4.4 3.6 8 8 8H650c4.4 0 8-3.6 8-8v-39.8c0-4.4-3.6-8-8-8z"
                }
            }
        ]
    })(props);
}
function AiTwotonePrinter(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#D9D9D9",
                    "d": "M360 180h304v152H360zm492 220H172c-6.6 0-12 5.4-12 12v292h132V500h440v204h132V412c0-6.6-5.4-12-12-12zm-24 84c0 4.4-3.6 8-8 8h-40c-4.4 0-8-3.6-8-8v-40c0-4.4 3.6-8 8-8h40c4.4 0 8 3.6 8 8v40z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M852 332H732V120c0-4.4-3.6-8-8-8H300c-4.4 0-8 3.6-8 8v212H172c-44.2 0-80 35.8-80 80v328c0 17.7 14.3 32 32 32h168v132c0 4.4 3.6 8 8 8h424c4.4 0 8-3.6 8-8V772h168c17.7 0 32-14.3 32-32V412c0-44.2-35.8-80-80-80zM360 180h304v152H360V180zm304 664H360V568h304v276zm200-140H732V500H292v204H160V412c0-6.6 5.4-12 12-12h680c6.6 0 12 5.4 12 12v292z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M820 436h-40c-4.4 0-8 3.6-8 8v40c0 4.4 3.6 8 8 8h40c4.4 0 8-3.6 8-8v-40c0-4.4-3.6-8-8-8z"
                }
            }
        ]
    })(props);
}
function AiTwotoneProfile(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#E6E6E6",
                    "d": "M184 840h656V184H184v656zm300-496c0-4.4 3.6-8 8-8h184c4.4 0 8 3.6 8 8v48c0 4.4-3.6 8-8 8H492c-4.4 0-8-3.6-8-8v-48zm0 144c0-4.4 3.6-8 8-8h184c4.4 0 8 3.6 8 8v48c0 4.4-3.6 8-8 8H492c-4.4 0-8-3.6-8-8v-48zm0 144c0-4.4 3.6-8 8-8h184c4.4 0 8 3.6 8 8v48c0 4.4-3.6 8-8 8H492c-4.4 0-8-3.6-8-8v-48zM380 328c22.1 0 40 17.9 40 40s-17.9 40-40 40-40-17.9-40-40 17.9-40 40-40zm0 144c22.1 0 40 17.9 40 40s-17.9 40-40 40-40-17.9-40-40 17.9-40 40-40zm0 144c22.1 0 40 17.9 40 40s-17.9 40-40 40-40-17.9-40-40 17.9-40 40-40z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M340 656a40 40 0 1 0 80 0 40 40 0 1 0-80 0zm0-144a40 40 0 1 0 80 0 40 40 0 1 0-80 0zm0-144a40 40 0 1 0 80 0 40 40 0 1 0-80 0zm152 320h184c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H492c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8zm0-144h184c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H492c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8zm0-144h184c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H492c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8z"
                }
            }
        ]
    })(props);
}
function AiTwotoneProject(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#E6E6E6",
                    "d": "M184 840h656V184H184v656zm472-560c0-4.4 3.6-8 8-8h80c4.4 0 8 3.6 8 8v256c0 4.4-3.6 8-8 8h-80c-4.4 0-8-3.6-8-8V280zm-192 0c0-4.4 3.6-8 8-8h80c4.4 0 8 3.6 8 8v184c0 4.4-3.6 8-8 8h-80c-4.4 0-8-3.6-8-8V280zm-192 0c0-4.4 3.6-8 8-8h80c4.4 0 8 3.6 8 8v464c0 4.4-3.6 8-8 8h-80c-4.4 0-8-3.6-8-8V280z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M280 752h80c4.4 0 8-3.6 8-8V280c0-4.4-3.6-8-8-8h-80c-4.4 0-8 3.6-8 8v464c0 4.4 3.6 8 8 8zm192-280h80c4.4 0 8-3.6 8-8V280c0-4.4-3.6-8-8-8h-80c-4.4 0-8 3.6-8 8v184c0 4.4 3.6 8 8 8zm192 72h80c4.4 0 8-3.6 8-8V280c0-4.4-3.6-8-8-8h-80c-4.4 0-8 3.6-8 8v256c0 4.4 3.6 8 8 8z"
                }
            }
        ]
    })(props);
}
function AiTwotonePropertySafety(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M866.9 169.9L527.1 54.1C523 52.7 517.5 52 512 52s-11 .7-15.1 2.1L157.1 169.9c-8.3 2.8-15.1 12.4-15.1 21.2v482.4c0 8.8 5.7 20.4 12.6 25.9L499.3 968c3.5 2.7 8 4.1 12.6 4.1s9.2-1.4 12.6-4.1l344.7-268.6c6.9-5.4 12.6-17 12.6-25.9V191.1c.2-8.8-6.6-18.3-14.9-21.2zM810 654.3L512 886.5 214 654.3V226.7l298-101.6 298 101.6v427.6z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#E6E6E6",
                    "d": "M214 226.7v427.6l298 232.2 298-232.2V226.7L512 125.1 214 226.7zM593.9 318h45c5.5 0 10 4.5 10 10 .1 1.7-.3 3.3-1.1 4.8l-87.7 161.1h45.7c5.5 0 10 4.5 10 10v21.3c0 5.5-4.5 10-10 10h-63.4v29.7h63.4c5.5 0 10 4.5 10 10v21.3c0 5.5-4.5 10-10 10h-63.4V658c0 5.5-4.5 10-10 10h-41.3c-5.5 0-10-4.5-10-10v-51.8H418c-5.5 0-10-4.5-10-10v-21.3c0-5.5 4.5-10 10-10h63.1v-29.7H418c-5.5 0-10-4.5-10-10v-21.3c0-5.5 4.5-10 10-10h45.2l-88-161.1c-2.6-4.8-.9-10.9 4-13.6 1.5-.8 3.1-1.2 4.8-1.2h46c3.8 0 7.2 2.1 8.9 5.5l72.9 144.3L585 323.5a10 10 0 0 1 8.9-5.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M438.9 323.5a9.88 9.88 0 0 0-8.9-5.5h-46c-1.7 0-3.3.4-4.8 1.2-4.9 2.7-6.6 8.8-4 13.6l88 161.1H418c-5.5 0-10 4.5-10 10v21.3c0 5.5 4.5 10 10 10h63.1v29.7H418c-5.5 0-10 4.5-10 10v21.3c0 5.5 4.5 10 10 10h63.1V658c0 5.5 4.5 10 10 10h41.3c5.5 0 10-4.5 10-10v-51.8h63.4c5.5 0 10-4.5 10-10v-21.3c0-5.5-4.5-10-10-10h-63.4v-29.7h63.4c5.5 0 10-4.5 10-10v-21.3c0-5.5-4.5-10-10-10h-45.7l87.7-161.1c.8-1.5 1.2-3.1 1.1-4.8 0-5.5-4.5-10-10-10h-45a10 10 0 0 0-8.9 5.5l-73.2 144.3-72.9-144.3z"
                }
            }
        ]
    })(props);
}
function AiTwotonePushpin(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#D9D9D9",
                    "d": "M474.8 357.7l-24.5 24.5-34.4-3.8c-9.6-1.1-19.3-1.6-28.9-1.6-29 0-57.5 4.7-84.7 14.1-14 4.8-27.4 10.8-40.3 17.9l353.1 353.3a259.92 259.92 0 0 0 30.4-153.9l-3.8-34.4 24.5-24.5L800 415.5 608.5 224 474.8 357.7z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M878.3 392.1L631.9 145.7c-6.5-6.5-15-9.7-23.5-9.7s-17 3.2-23.5 9.7L423.8 306.9c-12.2-1.4-24.5-2-36.8-2-73.2 0-146.4 24.1-206.5 72.3a33.23 33.23 0 0 0-2.7 49.4l181.7 181.7-215.4 215.2a15.8 15.8 0 0 0-4.6 9.8l-3.4 37.2c-.9 9.4 6.6 17.4 15.9 17.4.5 0 1 0 1.5-.1l37.2-3.4c3.7-.3 7.2-2 9.8-4.6l215.4-215.4 181.7 181.7c6.5 6.5 15 9.7 23.5 9.7 9.7 0 19.3-4.2 25.9-12.4 56.3-70.3 79.7-158.3 70.2-243.4l161.1-161.1c12.9-12.8 12.9-33.8 0-46.8zM666.2 549.3l-24.5 24.5 3.8 34.4a259.92 259.92 0 0 1-30.4 153.9L262 408.8c12.9-7.1 26.3-13.1 40.3-17.9 27.2-9.4 55.7-14.1 84.7-14.1 9.6 0 19.3.5 28.9 1.6l34.4 3.8 24.5-24.5L608.5 224 800 415.5 666.2 549.3z"
                }
            }
        ]
    })(props);
}
function AiTwotoneQuestionCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#E6E6E6",
                    "d": "M512 140c-205.4 0-372 166.6-372 372s166.6 372 372 372 372-166.6 372-372-166.6-372-372-372zm0 632c-22.1 0-40-17.9-40-40s17.9-40 40-40 40 17.9 40 40-17.9 40-40 40zm62.9-219.5a48.3 48.3 0 0 0-30.9 44.8V620c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8v-21.5c0-23.1 6.7-45.9 19.9-64.9 12.9-18.6 30.9-32.8 52.1-40.9 34-13.1 56-41.6 56-72.7 0-44.1-43.1-80-96-80s-96 35.9-96 80v7.6c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V420c0-39.3 17.2-76 48.4-103.3C430.4 290.4 470 276 512 276s81.6 14.5 111.6 40.7C654.8 344 672 380.7 672 420c0 57.8-38.1 109.8-97.1 132.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M472 732a40 40 0 1 0 80 0 40 40 0 1 0-80 0zm151.6-415.3C593.6 290.5 554 276 512 276s-81.6 14.4-111.6 40.7C369.2 344 352 380.7 352 420v7.6c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V420c0-44.1 43.1-80 96-80s96 35.9 96 80c0 31.1-22 59.6-56 72.7-21.2 8.1-39.2 22.3-52.1 40.9-13.2 19-19.9 41.8-19.9 64.9V620c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8v-22.7a48.3 48.3 0 0 1 30.9-44.8c59-22.7 97.1-74.7 97.1-132.5 0-39.3-17.2-76-48.4-103.3z"
                }
            }
        ]
    })(props);
}
function AiTwotoneReconciliation(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#D9D9D9",
                    "d": "M740 344H404V240H304v160h176c17.7 0 32 14.3 32 32v360h328V240H740v104zM584 448c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v56c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8v-56zm92 301c-50.8 0-92-41.2-92-92s41.2-92 92-92 92 41.2 92 92-41.2 92-92 92zm92-341v96c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8v-96c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#D9D9D9",
                    "d": "M642 657a34 34 0 1 0 68 0 34 34 0 1 0-68 0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M592 512h48c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm112-104v96c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8v-96c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M880 168H668c0-30.9-25.1-56-56-56h-80c-30.9 0-56 25.1-56 56H264c-17.7 0-32 14.3-32 32v200h-88c-17.7 0-32 14.3-32 32v448c0 17.7 14.3 32 32 32h336c17.7 0 32-14.3 32-32v-16h368c17.7 0 32-14.3 32-32V200c0-17.7-14.3-32-32-32zm-412 64h72v-56h64v56h72v48H468v-48zm-20 616H176V616h272v232zm0-296H176v-88h272v88zm392 240H512V432c0-17.7-14.3-32-32-32H304V240h100v104h336V240h100v552z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M676 565c-50.8 0-92 41.2-92 92s41.2 92 92 92 92-41.2 92-92-41.2-92-92-92zm0 126c-18.8 0-34-15.2-34-34s15.2-34 34-34 34 15.2 34 34-15.2 34-34 34z"
                }
            }
        ]
    })(props);
}
function AiTwotoneRedEnvelope(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M832 64H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32zm-40 824H232V193.1l260.3 204.1c11.6 9.1 27.9 9.1 39.5 0L792 193.1V888zm0-751.3h-31.7L512 331.3 263.7 136.7H232v-.7h560v.7z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#E6E6E6",
                    "d": "M492.3 397.2L232 193.1V888h560V193.1L531.8 397.2a31.99 31.99 0 0 1-39.5 0zm99.4 60.9h47.8a8.45 8.45 0 0 1 7.4 12.4l-87.2 161h45.9c4.6 0 8.4 3.8 8.4 8.4V665c0 4.6-3.8 8.4-8.4 8.4h-63.3V702h63.3c4.6 0 8.4 3.8 8.4 8.4v25c.2 4.7-3.5 8.5-8.2 8.5h-63.3v49.9c0 4.6-3.8 8.4-8.4 8.4h-43.7c-4.6 0-8.4-3.8-8.4-8.4v-49.9h-63c-4.6 0-8.4-3.8-8.4-8.4v-25.1c0-4.6 3.8-8.4 8.4-8.4h63v-28.6h-63c-4.6 0-8.4-3.8-8.4-8.4v-25.1c0-4.6 3.8-8.4 8.4-8.4h45.4L377 470.4a8.4 8.4 0 0 1 3.4-11.4c1.3-.6 2.6-1 3.9-1h48.8c3.2 0 6.1 1.8 7.5 4.6l71.7 142 71.9-141.9a8.6 8.6 0 0 1 7.5-4.6z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#E6E6E6",
                    "d": "M232 136.7h31.7L512 331.3l248.3-194.6H792v-.7H232z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M440.6 462.6a8.38 8.38 0 0 0-7.5-4.6h-48.8c-1.3 0-2.6.4-3.9 1a8.4 8.4 0 0 0-3.4 11.4l87.4 161.1H419c-4.6 0-8.4 3.8-8.4 8.4V665c0 4.6 3.8 8.4 8.4 8.4h63V702h-63c-4.6 0-8.4 3.8-8.4 8.4v25.1c0 4.6 3.8 8.4 8.4 8.4h63v49.9c0 4.6 3.8 8.4 8.4 8.4h43.7c4.6 0 8.4-3.8 8.4-8.4v-49.9h63.3c4.7 0 8.4-3.8 8.2-8.5v-25c0-4.6-3.8-8.4-8.4-8.4h-63.3v-28.6h63.3c4.6 0 8.4-3.8 8.4-8.4v-25.1c0-4.6-3.8-8.4-8.4-8.4h-45.9l87.2-161a8.45 8.45 0 0 0-7.4-12.4h-47.8c-3.1 0-6 1.8-7.5 4.6l-71.9 141.9-71.7-142z"
                }
            }
        ]
    })(props);
}
function AiTwotoneRest(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#D9D9D9",
                    "d": "M326.4 844h363.2l44.3-520H282l44.4 520zM508 416c79.5 0 144 64.5 144 144s-64.5 144-144 144-144-64.5-144-144 64.5-144 144-144z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M508 704c79.5 0 144-64.5 144-144s-64.5-144-144-144-144 64.5-144 144 64.5 144 144 144zm0-224c44.2 0 80 35.8 80 80s-35.8 80-80 80-80-35.8-80-80 35.8-80 80-80z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M832 256h-28.1l-35.7-120.9c-4-13.7-16.5-23.1-30.7-23.1h-451c-14.3 0-26.8 9.4-30.7 23.1L220.1 256H192c-17.7 0-32 14.3-32 32v28c0 4.4 3.6 8 8 8h45.8l47.7 558.7a32 32 0 0 0 31.9 29.3h429.2a32 32 0 0 0 31.9-29.3L802.2 324H856c4.4 0 8-3.6 8-8v-28c0-17.7-14.3-32-32-32zm-518.6-76h397.2l22.4 76H291l22.4-76zm376.2 664H326.4L282 324h451.9l-44.3 520z"
                }
            }
        ]
    })(props);
}
function AiTwotoneRightCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#E6E6E6",
                    "d": "M512 140c-205.4 0-372 166.6-372 372s166.6 372 372 372 372-166.6 372-372-166.6-372-372-372zm154.7 378.4l-246 178c-5.3 3.8-12.7 0-12.7-6.5V643c0-10.2 4.9-19.9 13.2-25.9L566.6 512 421.2 406.8c-8.3-6-13.2-15.6-13.2-25.9V334c0-6.5 7.4-10.3 12.7-6.5l246 178c4.4 3.2 4.4 9.7 0 12.9z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M666.7 505.5l-246-178c-5.3-3.8-12.7 0-12.7 6.5v46.9c0 10.3 4.9 19.9 13.2 25.9L566.6 512 421.2 617.1c-8.3 6-13.2 15.7-13.2 25.9v46.9c0 6.5 7.4 10.3 12.7 6.5l246-178c4.4-3.2 4.4-9.7 0-12.9z"
                }
            }
        ]
    })(props);
}
function AiTwotoneRightSquare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#E6E6E6",
                    "d": "M184 840h656V184H184v656zm216-196.9c0-10.2 4.9-19.9 13.2-25.9L558.6 512 413.2 406.8c-8.3-6-13.2-15.6-13.2-25.9V334c0-6.5 7.4-10.3 12.7-6.5l246 178c4.4 3.2 4.4 9.7 0 12.9l-246 178c-5.3 3.9-12.7.1-12.7-6.4v-46.9z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M412.7 696.4l246-178c4.4-3.2 4.4-9.7 0-12.9l-246-178c-5.3-3.8-12.7 0-12.7 6.5v46.9c0 10.3 4.9 19.9 13.2 25.9L558.6 512 413.2 617.2c-8.3 6-13.2 15.7-13.2 25.9V690c0 6.5 7.4 10.3 12.7 6.4z"
                }
            }
        ]
    })(props);
}
function AiTwotoneRocket(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#D9D9D9",
                    "d": "M261.7 621.4c-9.4 14.6-17 30.3-22.5 46.6H324V558.7c-24.8 16.2-46 37.5-62.3 62.7zM700 558.7V668h84.8c-5.5-16.3-13.1-32-22.5-46.6a211.6 211.6 0 0 0-62.3-62.7zm-64-239.9l-124-147-124 147V668h248V318.8zM512 448a48.01 48.01 0 0 1 0-96 48.01 48.01 0 0 1 0 96z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M864 736c0-111.6-65.4-208-160-252.9V317.3c0-15.1-5.3-29.7-15.1-41.2L536.5 95.4C530.1 87.8 521 84 512 84s-18.1 3.8-24.5 11.4L335.1 276.1a63.97 63.97 0 0 0-15.1 41.2v165.8C225.4 528 160 624.4 160 736h156.5c-2.3 7.2-3.5 15-3.5 23.8 0 22.1 7.6 43.7 21.4 60.8a97.2 97.2 0 0 0 43.1 30.6c23.1 54 75.6 88.8 134.5 88.8 29.1 0 57.3-8.6 81.4-24.8 23.6-15.8 41.9-37.9 53-64a97 97 0 0 0 43.1-30.5 97.52 97.52 0 0 0 21.4-60.8c0-8.4-1.1-16.4-3.1-23.8L864 736zm-540-68h-84.8c5.5-16.3 13.1-32 22.5-46.6 16.3-25.2 37.5-46.5 62.3-62.7V668zm64-184.9V318.8l124-147 124 147V668H388V483.1zm240.1 301.1c-5.2 3-11.2 4.2-17.1 3.4l-19.5-2.4-2.8 19.4c-5.4 37.9-38.4 66.5-76.7 66.5s-71.3-28.6-76.7-66.5l-2.8-19.5-19.5 2.5a27.7 27.7 0 0 1-17.1-3.5c-8.7-5-14.1-14.3-14.1-24.4 0-10.6 5.9-19.4 14.6-23.8h231.3c8.8 4.5 14.6 13.3 14.6 23.8-.1 10.2-5.5 19.6-14.2 24.5zM700 668V558.7a211.6 211.6 0 0 1 62.3 62.7c9.4 14.6 17 30.3 22.5 46.6H700z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M464 400a48 48 0 1 0 96 0 48 48 0 1 0-96 0z"
                }
            }
        ]
    })(props);
}
function AiTwotoneSafetyCertificate(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M866.9 169.9L527.1 54.1C523 52.7 517.5 52 512 52s-11 .7-15.1 2.1L157.1 169.9c-8.3 2.8-15.1 12.4-15.1 21.2v482.4c0 8.8 5.7 20.4 12.6 25.9L499.3 968c3.5 2.7 8 4.1 12.6 4.1s9.2-1.4 12.6-4.1l344.7-268.6c6.9-5.4 12.6-17 12.6-25.9V191.1c.2-8.8-6.6-18.3-14.9-21.2zM810 654.3L512 886.5 214 654.3V226.7l298-101.6 298 101.6v427.6z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#E6E6E6",
                    "d": "M214 226.7v427.6l298 232.2 298-232.2V226.7L512 125.1 214 226.7zM632.8 328H688c6.5 0 10.3 7.4 6.5 12.7L481.9 633.4a16.1 16.1 0 0 1-26 0l-126.4-174c-3.8-5.3 0-12.7 6.5-12.7h55.2c5.2 0 10 2.5 13 6.6l64.7 89.1 150.9-207.8c3-4.1 7.9-6.6 13-6.6z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M404.2 453.3c-3-4.1-7.8-6.6-13-6.6H336c-6.5 0-10.3 7.4-6.5 12.7l126.4 174a16.1 16.1 0 0 0 26 0l212.6-292.7c3.8-5.3 0-12.7-6.5-12.7h-55.2c-5.1 0-10 2.5-13 6.6L468.9 542.4l-64.7-89.1z"
                }
            }
        ]
    })(props);
}
function AiTwotoneSave(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#D9D9D9",
                    "d": "M704 320c0 17.7-14.3 32-32 32H352c-17.7 0-32-14.3-32-32V184H184v656h656V341.8l-136-136V320zM512 730c-79.5 0-144-64.5-144-144s64.5-144 144-144 144 64.5 144 144-64.5 144-144 144z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M512 442c-79.5 0-144 64.5-144 144s64.5 144 144 144 144-64.5 144-144-64.5-144-144-144zm0 224c-44.2 0-80-35.8-80-80s35.8-80 80-80 80 35.8 80 80-35.8 80-80 80z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M893.3 293.3L730.7 130.7c-.7-.7-1.4-1.3-2.1-2-.1-.1-.3-.2-.4-.3-.7-.7-1.5-1.3-2.2-1.9a64 64 0 0 0-22-11.7V112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V338.5c0-17-6.7-33.2-18.7-45.2zM384 184h256v104H384V184zm456 656H184V184h136v136c0 17.7 14.3 32 32 32h320c17.7 0 32-14.3 32-32V205.8l136 136V840z"
                }
            }
        ]
    })(props);
}
function AiTwotoneSchedule(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#D9D9D9",
                    "d": "M768 352c0 4.4-3.6 8-8 8h-56c-4.4 0-8-3.6-8-8v-56H548v56c0 4.4-3.6 8-8 8h-56c-4.4 0-8-3.6-8-8v-56H328v56c0 4.4-3.6 8-8 8h-56c-4.4 0-8-3.6-8-8v-56H136v496h752V296H768v56zM424 688c0 4.4-3.6 8-8 8H232c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h184c4.4 0 8 3.6 8 8v48zm0-136c0 4.4-3.6 8-8 8H232c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h184c4.4 0 8 3.6 8 8v48zm374.4-91.2l-165 228.7a15.9 15.9 0 0 1-25.8 0L493.5 531.3c-3.8-5.3 0-12.7 6.5-12.7h54.9c5.1 0 9.9 2.4 12.9 6.6l52.8 73.1 103.6-143.7c3-4.1 7.8-6.6 12.8-6.5h54.9c6.5 0 10.3 7.4 6.5 12.7z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M724.2 454.6L620.6 598.3l-52.8-73.1c-3-4.2-7.8-6.6-12.9-6.6H500c-6.5 0-10.3 7.4-6.5 12.7l114.1 158.2a15.9 15.9 0 0 0 25.8 0l165-228.7c3.8-5.3 0-12.7-6.5-12.7H737c-5-.1-9.8 2.4-12.8 6.5zM416 496H232c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h184c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M928 224H768v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56H548v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56H328v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56H96c-17.7 0-32 14.3-32 32v576c0 17.7 14.3 32 32 32h832c17.7 0 32-14.3 32-32V256c0-17.7-14.3-32-32-32zm-40 568H136V296h120v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56h148v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56h148v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56h120v496z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M416 632H232c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h184c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8z"
                }
            }
        ]
    })(props);
}
function AiTwotoneSecurityScan(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M866.9 169.9L527.1 54.1C523 52.7 517.5 52 512 52s-11 .7-15.1 2.1L157.1 169.9c-8.3 2.8-15.1 12.4-15.1 21.2v482.4c0 8.8 5.7 20.4 12.6 25.9L499.3 968c3.5 2.7 8 4.1 12.6 4.1s9.2-1.4 12.6-4.1l344.7-268.6c6.9-5.4 12.6-17 12.6-25.9V191.1c.2-8.8-6.6-18.3-14.9-21.2zM810 654.3L512 886.5 214 654.3V226.7l298-101.6 298 101.6v427.6z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#E6E6E6",
                    "d": "M460.7 451.1a80.1 80.1 0 1 0 160.2 0 80.1 80.1 0 1 0-160.2 0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#E6E6E6",
                    "d": "M214 226.7v427.6l298 232.2 298-232.2V226.7L512 125.1 214 226.7zm428.7 122.5c56.3 56.3 56.3 147.5 0 203.8-48.5 48.5-123 55.2-178.6 20.1l-77.5 77.5a8.03 8.03 0 0 1-11.3 0l-34-34a8.03 8.03 0 0 1 0-11.3l77.5-77.5c-35.1-55.7-28.4-130.1 20.1-178.6 56.3-56.3 147.5-56.3 203.8 0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M418.8 527.8l-77.5 77.5a8.03 8.03 0 0 0 0 11.3l34 34c3.1 3.1 8.2 3.1 11.3 0l77.5-77.5c55.6 35.1 130.1 28.4 178.6-20.1 56.3-56.3 56.3-147.5 0-203.8-56.3-56.3-147.5-56.3-203.8 0-48.5 48.5-55.2 122.9-20.1 178.6zm65.4-133.3a80.1 80.1 0 0 1 113.3 0 80.1 80.1 0 0 1 0 113.3c-31.3 31.3-82 31.3-113.3 0s-31.3-82 0-113.3z"
                }
            }
        ]
    })(props);
}
function AiTwotoneSetting(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#D9D9D9",
                    "d": "M859.3 569.7l.2.1c3.1-18.9 4.6-38.2 4.6-57.3 0-17.1-1.3-34.3-3.7-51.1 2.4 16.7 3.6 33.6 3.6 50.5 0 19.4-1.6 38.8-4.7 57.8zM99 398.1c-.5-.4-.9-.8-1.4-1.3.7.7 1.4 1.4 2.2 2.1l65.5 55.9v-.1L99 398.1zm536.6-216h.1l-15.5-83.8c-.2-1-.4-1.9-.7-2.8.1.5.3 1.1.4 1.6l15.7 85zm54 546.5l31.4-25.8 92.8 32.9c17-22.9 31.3-47.5 42.6-73.6l-74.7-63.9 6.6-40.1c2.5-15.1 3.8-30.6 3.8-46.1s-1.3-31-3.8-46.1l-6.5-39.9 74.7-63.9c-11.4-26-25.6-50.7-42.6-73.6l-92.8 32.9-31.4-25.8c-23.9-19.6-50.6-35-79.3-45.8l-38.1-14.3-17.9-97a377.5 377.5 0 0 0-85 0l-17.9 97.2-37.9 14.3c-28.5 10.8-55 26.2-78.7 45.7l-31.4 25.9-93.4-33.2c-17 22.9-31.3 47.5-42.6 73.6l75.5 64.5-6.5 40c-2.5 14.9-3.7 30.2-3.7 45.5 0 15.2 1.3 30.6 3.7 45.5l6.5 40-75.5 64.5c11.4 26 25.6 50.7 42.6 73.6l93.4-33.2 31.4 25.9c23.7 19.5 50.2 34.9 78.7 45.7l37.8 14.5 17.9 97.2c28.2 3.2 56.9 3.2 85 0l17.9-97 38.1-14.3c28.8-10.8 55.4-26.2 79.3-45.8zm-177.1-50.3c-30.5 0-59.2-7.8-84.3-21.5C373.3 627 336 568.9 336 502c0-97.2 78.8-176 176-176 66.9 0 125 37.3 154.8 92.2 13.7 25 21.5 53.7 21.5 84.3 0 97.1-78.7 175.8-175.8 175.8zM207.2 812.8c-5.5 1.9-11.2 2.3-16.6 1.2 5.7 1.2 11.7 1 17.5-1l81.4-29c-.1-.1-.3-.2-.4-.3l-81.9 29.1zm717.6-414.7l-65.5 56c0 .2.1.5.1.7l65.4-55.9c7.1-6.1 11.1-14.9 11.2-24-.3 8.8-4.3 17.3-11.2 23.2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#D9D9D9",
                    "d": "M935.8 646.6c.5 4.7 0 9.5-1.7 14.1l-.9 2.6a446.02 446.02 0 0 1-79.7 137.9l-1.8 2.1a32 32 0 0 1-35.1 9.5l-81.3-28.9a350 350 0 0 1-99.7 57.6l-15.7 85a32.05 32.05 0 0 1-25.8 25.7l-2.7.5a445.2 445.2 0 0 1-79.2 7.1h.3c26.7 0 53.4-2.4 79.4-7.1l2.7-.5a32.05 32.05 0 0 0 25.8-25.7l15.7-84.9c36.2-13.6 69.6-32.9 99.6-57.5l81.2 28.9a32 32 0 0 0 35.1-9.5l1.8-2.1c34.8-41.1 61.5-87.4 79.6-137.7l.9-2.6c1.6-4.7 2.1-9.7 1.5-14.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M688 502c0-30.3-7.7-58.9-21.2-83.8C637 363.3 578.9 326 512 326c-97.2 0-176 78.8-176 176 0 66.9 37.3 125 92.2 154.8 24.9 13.5 53.4 21.2 83.8 21.2 97.2 0 176-78.8 176-176zm-288 0c0-29.9 11.7-58 32.8-79.2C454 401.6 482.1 390 512 390c29.9 0 58 11.6 79.2 32.8A111.6 111.6 0 0 1 624 502c0 29.9-11.7 58-32.8 79.2A111.6 111.6 0 0 1 512 614c-29.9 0-58-11.7-79.2-32.8A111.6 111.6 0 0 1 400 502z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M594.1 952.2a32.05 32.05 0 0 0 25.8-25.7l15.7-85a350 350 0 0 0 99.7-57.6l81.3 28.9a32 32 0 0 0 35.1-9.5l1.8-2.1c34.8-41.1 61.6-87.5 79.7-137.9l.9-2.6c1.7-4.6 2.2-9.4 1.7-14.1-.9-7.9-4.7-15.4-11-20.9l-65.3-55.9-.2-.1c3.1-19 4.7-38.4 4.7-57.8 0-16.9-1.2-33.9-3.6-50.5-.3-2.2-.7-4.4-1-6.6 0-.2-.1-.5-.1-.7l65.5-56c6.9-5.9 10.9-14.4 11.2-23.2.1-4-.5-8.1-1.9-12l-.9-2.6a443.74 443.74 0 0 0-79.7-137.9l-1.8-2.1a32.12 32.12 0 0 0-35.1-9.5l-81.3 28.9c-30-24.6-63.4-44-99.6-57.6h-.1l-15.7-85c-.1-.5-.2-1.1-.4-1.6a32.08 32.08 0 0 0-25.4-24.1l-2.7-.5c-52.1-9.4-106.9-9.4-159 0l-2.7.5a32.05 32.05 0 0 0-25.8 25.7l-15.8 85.4a351.86 351.86 0 0 0-99 57.4l-81.9-29.1a32 32 0 0 0-35.1 9.5l-1.8 2.1a446.02 446.02 0 0 0-79.7 137.9l-.9 2.6a32.09 32.09 0 0 0 7.9 33.9c.5.4.9.9 1.4 1.3l66.3 56.6v.1c-3.1 18.8-4.6 37.9-4.6 57 0 19.2 1.5 38.4 4.6 57.1L99 625.5a32.03 32.03 0 0 0-9.3 35.2l.9 2.6c18.1 50.4 44.9 96.9 79.7 137.9l1.8 2.1c4.9 5.7 11.4 9.4 18.5 10.7 5.4 1 11.1.7 16.6-1.2l81.9-29.1c.1.1.3.2.4.3 29.7 24.3 62.8 43.6 98.6 57.1l15.8 85.4a32.05 32.05 0 0 0 25.8 25.7l2.7.5c26.1 4.7 52.8 7.1 79.5 7.1h.3c26.6 0 53.3-2.4 79.2-7.1l2.7-.5zm-39.8-66.5a377.5 377.5 0 0 1-85 0l-17.9-97.2-37.8-14.5c-28.5-10.8-55-26.2-78.7-45.7l-31.4-25.9-93.4 33.2c-17-22.9-31.2-47.6-42.6-73.6l75.5-64.5-6.5-40c-2.4-14.9-3.7-30.3-3.7-45.5 0-15.3 1.2-30.6 3.7-45.5l6.5-40-75.5-64.5c11.3-26.1 25.6-50.7 42.6-73.6l93.4 33.2 31.4-25.9c23.7-19.5 50.2-34.9 78.7-45.7l37.9-14.3 17.9-97.2c28.1-3.2 56.8-3.2 85 0l17.9 97 38.1 14.3c28.7 10.8 55.4 26.2 79.3 45.8l31.4 25.8 92.8-32.9c17 22.9 31.2 47.6 42.6 73.6L781.8 426l6.5 39.9c2.5 15.1 3.8 30.6 3.8 46.1s-1.3 31-3.8 46.1l-6.6 40.1 74.7 63.9a370.03 370.03 0 0 1-42.6 73.6L721 702.8l-31.4 25.8c-23.9 19.6-50.5 35-79.3 45.8l-38.1 14.3-17.9 97z"
                }
            }
        ]
    })(props);
}
function AiTwotoneShop(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#D9D9D9",
                    "d": "M839.5 344h-655c-.3 0-.5.2-.5.5v91.2c0 59.8 49 108.3 109.3 108.3 40.7 0 76.2-22 95.1-54.7 2.9-5.1 8.4-8.3 14.3-8.3s11.3 3.2 14.3 8.3c18.8 32.7 54.3 54.7 95 54.7 40.8 0 76.4-22.1 95.1-54.9 2.9-5 8.2-8.1 13.9-8.1h.6c5.8 0 11 3.1 13.9 8.1 18.8 32.8 54.4 54.9 95.2 54.9C791 544 840 495.5 840 435.7v-91.2c0-.3-.2-.5-.5-.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M882 272.1V144c0-17.7-14.3-32-32-32H174c-17.7 0-32 14.3-32 32v128.1c-16.7 1-30 14.9-30 31.9v131.7a177 177 0 0 0 14.4 70.4c4.3 10.2 9.6 19.8 15.6 28.9v345c0 17.6 14.3 32 32 32h676c17.7 0 32-14.3 32-32V535a175 175 0 0 0 15.6-28.9c9.5-22.3 14.4-46 14.4-70.4V304c0-17-13.3-30.9-30-31.9zM214 184h596v88H214v-88zm362 656.1H448V736h128v104.1zm234.4 0H640V704c0-17.7-14.3-32-32-32H416c-17.7 0-32 14.3-32 32v136.1H214V597.9c2.9 1.4 5.9 2.8 9 4 22.3 9.4 46 14.1 70.4 14.1 24.4 0 48-4.7 70.4-14.1 13.8-5.8 26.8-13.2 38.7-22.1.2-.1.4-.1.6 0a180.4 180.4 0 0 0 38.7 22.1c22.3 9.4 46 14.1 70.4 14.1s48-4.7 70.4-14.1c13.8-5.8 26.8-13.2 38.7-22.1.2-.1.4-.1.6 0a180.4 180.4 0 0 0 38.7 22.1c22.3 9.4 46 14.1 70.4 14.1s48-4.7 70.4-14.1c3-1.3 6-2.6 9-4v242.2zM840 435.7c0 59.8-49 108.3-109.3 108.3-40.8 0-76.4-22.1-95.2-54.9-2.9-5-8.1-8.1-13.9-8.1h-.6c-5.7 0-11 3.1-13.9 8.1A109.24 109.24 0 0 1 512 544c-40.7 0-76.2-22-95-54.7-3-5.1-8.4-8.3-14.3-8.3s-11.4 3.2-14.3 8.3a109.63 109.63 0 0 1-95.1 54.7C233 544 184 495.5 184 435.7v-91.2c0-.3.2-.5.5-.5h655c.3 0 .5.2.5.5v91.2z"
                }
            }
        ]
    })(props);
}
function AiTwotoneShopping(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#D9D9D9",
                    "d": "M696 472c0 4.4-3.6 8-8 8h-56c-4.4 0-8-3.6-8-8v-88H400v88c0 4.4-3.6 8-8 8h-56c-4.4 0-8-3.6-8-8v-88h-96v456h560V384h-96v88z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M832 312H696v-16c0-101.6-82.4-184-184-184s-184 82.4-184 184v16H192c-17.7 0-32 14.3-32 32v536c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V344c0-17.7-14.3-32-32-32zm-432-16c0-61.9 50.1-112 112-112s112 50.1 112 112v16H400v-16zm392 544H232V384h96v88c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-88h224v88c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-88h96v456z"
                }
            }
        ]
    })(props);
}
function AiTwotoneSkin(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#D9D9D9",
                    "d": "M512 318c-79.2 0-148.5-48.8-176.7-120H182v196h119v432h422V394h119V198H688.7c-28.2 71.2-97.5 120-176.7 120z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M870 126H663.8c-17.4 0-32.9 11.9-37 29.3C614.3 208.1 567 246 512 246s-102.3-37.9-114.8-90.7a37.93 37.93 0 0 0-37-29.3H154a44 44 0 0 0-44 44v252a44 44 0 0 0 44 44h75v388a44 44 0 0 0 44 44h478a44 44 0 0 0 44-44V466h75a44 44 0 0 0 44-44V170a44 44 0 0 0-44-44zm-28 268H723v432H301V394H182V198h153.3c28.2 71.2 97.5 120 176.7 120s148.5-48.8 176.7-120H842v196z"
                }
            }
        ]
    })(props);
}
function AiTwotoneSliders(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#D9D9D9",
                    "d": "M180 292h80v440h-80zm369 180h-74a3 3 0 0 0-3 3v74a3 3 0 0 0 3 3h74a3 3 0 0 0 3-3v-74a3 3 0 0 0-3-3zm215-108h80v296h-80z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M904 296h-66v-96c0-4.4-3.6-8-8-8h-52c-4.4 0-8 3.6-8 8v96h-66c-4.4 0-8 3.6-8 8v416c0 4.4 3.6 8 8 8h66v96c0 4.4 3.6 8 8 8h52c4.4 0 8-3.6 8-8v-96h66c4.4 0 8-3.6 8-8V304c0-4.4-3.6-8-8-8zm-60 364h-80V364h80v296zM612 404h-66V232c0-4.4-3.6-8-8-8h-52c-4.4 0-8 3.6-8 8v172h-66c-4.4 0-8 3.6-8 8v200c0 4.4 3.6 8 8 8h66v172c0 4.4 3.6 8 8 8h52c4.4 0 8-3.6 8-8V620h66c4.4 0 8-3.6 8-8V412c0-4.4-3.6-8-8-8zm-60 145a3 3 0 0 1-3 3h-74a3 3 0 0 1-3-3v-74a3 3 0 0 1 3-3h74a3 3 0 0 1 3 3v74zM320 224h-66v-56c0-4.4-3.6-8-8-8h-52c-4.4 0-8 3.6-8 8v56h-66c-4.4 0-8 3.6-8 8v560c0 4.4 3.6 8 8 8h66v56c0 4.4 3.6 8 8 8h52c4.4 0 8-3.6 8-8v-56h66c4.4 0 8-3.6 8-8V232c0-4.4-3.6-8-8-8zm-60 508h-80V292h80v440z"
                }
            }
        ]
    })(props);
}
function AiTwotoneSmile(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#E6E6E6",
                    "d": "M512 140c-205.4 0-372 166.6-372 372s166.6 372 372 372 372-166.6 372-372-166.6-372-372-372zM288 421a48.01 48.01 0 0 1 96 0 48.01 48.01 0 0 1-96 0zm224 272c-85.5 0-155.6-67.3-160-151.6a8 8 0 0 1 8-8.4h48.1c4.2 0 7.8 3.2 8.1 7.4C420 589.9 461.5 629 512 629s92.1-39.1 95.8-88.6c.3-4.2 3.9-7.4 8.1-7.4H664a8 8 0 0 1 8 8.4C667.6 625.7 597.5 693 512 693zm176-224a48.01 48.01 0 0 1 0-96 48.01 48.01 0 0 1 0 96z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M288 421a48 48 0 1 0 96 0 48 48 0 1 0-96 0zm376 112h-48.1c-4.2 0-7.8 3.2-8.1 7.4-3.7 49.5-45.3 88.6-95.8 88.6s-92-39.1-95.8-88.6c-.3-4.2-3.9-7.4-8.1-7.4H360a8 8 0 0 0-8 8.4c4.4 84.3 74.5 151.6 160 151.6s155.6-67.3 160-151.6a8 8 0 0 0-8-8.4zm-24-112a48 48 0 1 0 96 0 48 48 0 1 0-96 0z"
                }
            }
        ]
    })(props);
}
function AiTwotoneSnippets(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#D9D9D9",
                    "d": "M450 510V336H232v552h432V550H490c-22.1 0-40-17.9-40-40z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M832 112H724V72c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v40H500V72c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v40H320c-17.7 0-32 14.3-32 32v120h-96c-17.7 0-32 14.3-32 32v632c0 17.7 14.3 32 32 32h512c17.7 0 32-14.3 32-32v-96h96c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM664 888H232V336h218v174c0 22.1 17.9 40 40 40h174v338zm0-402H514V336h.2L664 485.8v.2zm128 274h-56V456L544 264H360v-80h68v32c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-32h152v32c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-32h68v576z"
                }
            }
        ]
    })(props);
}
function AiTwotoneSound(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#D9D9D9",
                    "d": "M275.4 424H146v176h129.4l18 11.7L586 803V221L293.3 412.3z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M892.1 737.8l-110.3-63.7a15.9 15.9 0 0 0-21.7 5.9l-19.9 34.5c-4.4 7.6-1.8 17.4 5.8 21.8L856.3 800a15.9 15.9 0 0 0 21.7-5.9l19.9-34.5c4.4-7.6 1.7-17.4-5.8-21.8zM934 476H806c-8.8 0-16 7.2-16 16v40c0 8.8 7.2 16 16 16h128c8.8 0 16-7.2 16-16v-40c0-8.8-7.2-16-16-16zM760 344a15.9 15.9 0 0 0 21.7 5.9L892 286.2c7.6-4.4 10.2-14.2 5.8-21.8L878 230a15.9 15.9 0 0 0-21.7-5.9L746 287.8a15.99 15.99 0 0 0-5.8 21.8L760 344zM625.9 115c-5.9 0-11.9 1.6-17.4 5.3L254 352H90c-8.8 0-16 7.2-16 16v288c0 8.8 7.2 16 16 16h164l354.5 231.7c5.5 3.6 11.6 5.3 17.4 5.3 16.7 0 32.1-13.3 32.1-32.1V147.1c0-18.8-15.4-32.1-32.1-32.1zM586 803L293.4 611.7l-18-11.7H146V424h129.4l17.9-11.7L586 221v582z"
                }
            }
        ]
    })(props);
}
function AiTwotoneStar(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#D9D9D9",
                    "d": "M512.5 190.4l-94.4 191.3-211.2 30.7 152.8 149-36.1 210.3 188.9-99.3 188.9 99.2-36.1-210.3 152.8-148.9-211.2-30.7z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M908.6 352.8l-253.9-36.9L541.2 85.8c-3.1-6.3-8.2-11.4-14.5-14.5-15.8-7.8-35-1.3-42.9 14.5L370.3 315.9l-253.9 36.9c-7 1-13.4 4.3-18.3 9.3a32.05 32.05 0 0 0 .6 45.3l183.7 179.1L239 839.4a31.95 31.95 0 0 0 46.4 33.7l227.1-119.4 227.1 119.4c6.2 3.3 13.4 4.4 20.3 3.2 17.4-3 29.1-19.5 26.1-36.9l-43.4-252.9 183.7-179.1c5-4.9 8.3-11.3 9.3-18.3 2.7-17.5-9.5-33.7-27-36.3zM665.3 561.3l36.1 210.3-188.9-99.2-188.9 99.3 36.1-210.3-152.8-149 211.2-30.7 94.4-191.3 94.4 191.3 211.2 30.7-152.8 148.9z"
                }
            }
        ]
    })(props);
}
function AiTwotoneStop(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm288.5 682.8L277.7 224C258 240 240 258 224 277.7l522.8 522.8C682.8 852.7 601 884 512 884c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372c0 89-31.3 170.8-83.5 234.8z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#E6E6E6",
                    "d": "M512 140c-205.4 0-372 166.6-372 372s166.6 372 372 372c89 0 170.8-31.3 234.8-83.5L224 277.7c16-19.7 34-37.7 53.7-53.7l522.8 522.8C852.7 682.8 884 601 884 512c0-205.4-166.6-372-372-372z"
                }
            }
        ]
    })(props);
}
function AiTwotoneSwitcher(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#D9D9D9",
                    "d": "M184 840h528V312H184v528zm116-290h296v64H300v-64z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M880 112H264c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h576v576c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V144c0-17.7-14.3-32-32-32z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M752 240H144c-17.7 0-32 14.3-32 32v608c0 17.7 14.3 32 32 32h608c17.7 0 32-14.3 32-32V272c0-17.7-14.3-32-32-32zm-40 600H184V312h528v528z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M300 550h296v64H300z"
                }
            }
        ]
    })(props);
}
function AiTwotoneTablet(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M800 64H224c-35.3 0-64 28.7-64 64v768c0 35.3 28.7 64 64 64h576c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64zm-8 824H232V136h560v752z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#E6E6E6",
                    "d": "M232 888h560V136H232v752zm280-144c22.1 0 40 17.9 40 40s-17.9 40-40 40-40-17.9-40-40 17.9-40 40-40z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M472 784a40 40 0 1 0 80 0 40 40 0 1 0-80 0z"
                }
            }
        ]
    })(props);
}
function AiTwotoneTag(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#D9D9D9",
                    "d": "M589 164.6L189.3 564.3l270.4 270.4L859.4 435 836 188l-247-23.4zM680 432c-48.5 0-88-39.5-88-88s39.5-88 88-88 88 39.5 88 88-39.5 88-88 88z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M680 256c-48.5 0-88 39.5-88 88s39.5 88 88 88 88-39.5 88-88-39.5-88-88-88zm0 120c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M938 458.8l-29.6-312.6c-1.5-16.2-14.4-29-30.6-30.6L565.2 86h-.4c-3.2 0-5.7 1-7.6 2.9L88.9 557.2a9.96 9.96 0 0 0 0 14.1l363.8 363.8a9.9 9.9 0 0 0 7.1 2.9c2.7 0 5.2-1 7.1-2.9l468.3-468.3c2-2.1 3-5 2.8-8zM459.7 834.7L189.3 564.3 589 164.6 836 188l23.4 247-399.7 399.7z"
                }
            }
        ]
    })(props);
}
function AiTwotoneTags(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#D9D9D9",
                    "d": "M477.5 694l311.9-311.8-19-224.6-224.6-19-311.9 311.9L477.5 694zm116-415.5a47.81 47.81 0 0 1 33.9-33.9c16.6-4.4 34.2.3 46.4 12.4a47.93 47.93 0 0 1 12.4 46.4 47.81 47.81 0 0 1-33.9 33.9c-16.6 4.4-34.2-.3-46.4-12.4a48.3 48.3 0 0 1-12.4-46.4z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#D9D9D9",
                    "d": "M476.6 792.6c-1.7-.2-3.4-1-4.7-2.3L137.7 456.1a8.03 8.03 0 0 1 0-11.3L515.9 66.6c1.2-1.3 2.9-2.1 4.7-2.3h-.4c-2.3-.2-4.7.6-6.3 2.3L135.7 444.8a8.03 8.03 0 0 0 0 11.3l334.2 334.2c1.8 1.9 4.3 2.6 6.7 2.3z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M889.7 539.8l-39.6-39.5a8.03 8.03 0 0 0-11.3 0l-362 361.3-237.6-237a8.03 8.03 0 0 0-11.3 0l-39.6 39.5a8.03 8.03 0 0 0 0 11.3l243.2 242.8 39.6 39.5c3.1 3.1 8.2 3.1 11.3 0l407.3-406.6c3.1-3.1 3.1-8.2 0-11.3zM652.3 337.3a47.81 47.81 0 0 0 33.9-33.9c4.4-16.6-.3-34.2-12.4-46.4a47.93 47.93 0 0 0-46.4-12.4 47.81 47.81 0 0 0-33.9 33.9c-4.4 16.6.3 34.2 12.4 46.4a48.3 48.3 0 0 0 46.4 12.4z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M137.7 444.8a8.03 8.03 0 0 0 0 11.3l334.2 334.2c1.3 1.3 2.9 2.1 4.7 2.3 2.4.3 4.8-.5 6.6-2.3L861.4 412c1.7-1.7 2.5-4 2.3-6.3l-25.5-301.4c-.7-7.8-6.8-13.9-14.6-14.6L522.2 64.3h-1.6c-1.8.2-3.4 1-4.7 2.3L137.7 444.8zm408.1-306.2l224.6 19 19 224.6L477.5 694 233.9 450.5l311.9-311.9z"
                }
            }
        ]
    })(props);
}
function AiTwotoneThunderbolt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#D9D9D9",
                    "d": "M695.4 164.1H470.8L281.2 491.5h157.4l-60.3 241 319.8-305.1h-211z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M848.1 359.3H627.8L825.9 109c4.1-5.3.4-13-6.3-13H436.1c-2.8 0-5.5 1.5-6.9 4L170.1 547.5c-3.1 5.3.7 12 6.9 12h174.4L262 917.1c-1.9 7.8 7.5 13.3 13.3 7.7L853.6 373c5.2-4.9 1.7-13.7-5.5-13.7zM378.3 732.5l60.3-241H281.2l189.6-327.4h224.6L487.1 427.4h211L378.3 732.5z"
                }
            }
        ]
    })(props);
}
function AiTwotoneTool(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#D9D9D9",
                    "d": "M706.8 488.7a32.05 32.05 0 0 1-45.3 0L537 364.2a32.05 32.05 0 0 1 0-45.3l132.9-132.8a184.2 184.2 0 0 0-144 53.5c-58.1 58.1-69.3 145.3-33.6 214.6L439.5 507c-.1 0-.1-.1-.1-.1L209.3 737l79.2 79.2 274-274.1.1.1 8.8-8.8c69.3 35.7 156.5 24.5 214.6-33.6 39.2-39.1 57.3-92.1 53.6-143.9L706.8 488.7z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M876.6 239.5c-.5-.9-1.2-1.8-2-2.5-5-5-13.1-5-18.1 0L684.2 409.3l-67.9-67.9L788.7 169c.8-.8 1.4-1.6 2-2.5 3.6-6.1 1.6-13.9-4.5-17.5-98.2-58-226.8-44.7-311.3 39.7-67 67-89.2 162-66.5 247.4l-293 293c-3 3-2.8 7.9.3 11l169.7 169.7c3.1 3.1 8.1 3.3 11 .3l292.9-292.9c85.5 22.8 180.5.7 247.6-66.4 84.4-84.5 97.7-213.1 39.7-311.3zM786 499.8c-58.1 58.1-145.3 69.3-214.6 33.6l-8.8 8.8-.1-.1-274 274.1-79.2-79.2 230.1-230.1s0 .1.1.1l52.8-52.8c-35.7-69.3-24.5-156.5 33.6-214.6a184.2 184.2 0 0 1 144-53.5L537 318.9a32.05 32.05 0 0 0 0 45.3l124.5 124.5a32.05 32.05 0 0 0 45.3 0l132.8-132.8c3.7 51.8-14.4 104.8-53.6 143.9z"
                }
            }
        ]
    })(props);
}
function AiTwotoneTrademarkCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#E6E6E6",
                    "d": "M512 140c-205.4 0-372 166.6-372 372s166.6 372 372 372 372-166.6 372-372-166.6-372-372-372zm170.7 584.2c-1.1.5-2.3.8-3.5.8h-62c-3.1 0-5.9-1.8-7.2-4.6l-74.6-159.2h-88.7V717c0 4.4-3.6 8-8 8H384c-4.4 0-8-3.6-8-8V307c0-4.4 3.6-8 8-8h155.6c98.8 0 144.2 59.9 144.2 131.1 0 70.2-43.6 106.4-78.4 119.2l80.8 164.2c2.1 3.9.4 8.7-3.5 10.7z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#E6E6E6",
                    "d": "M529.9 357h-83.4v148H528c53 0 82.8-25.6 82.8-72.4 0-50.3-32.9-75.6-80.9-75.6z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M605.4 549.3c34.8-12.8 78.4-49 78.4-119.2 0-71.2-45.4-131.1-144.2-131.1H384c-4.4 0-8 3.6-8 8v410c0 4.4 3.6 8 8 8h54.7c4.4 0 8-3.6 8-8V561.2h88.7L610 720.4c1.3 2.8 4.1 4.6 7.2 4.6h62c1.2 0 2.4-.3 3.5-.8 3.9-2 5.6-6.8 3.5-10.7l-80.8-164.2zM528 505h-81.5V357h83.4c48 0 80.9 25.3 80.9 75.6 0 46.8-29.8 72.4-82.8 72.4z"
                }
            }
        ]
    })(props);
}
function AiTwotoneTrophy(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#D9D9D9",
                    "d": "M320 480c0 49.1 19.1 95.3 53.9 130.1 34.7 34.8 81 53.9 130.1 53.9h16c49.1 0 95.3-19.1 130.1-53.9 34.8-34.7 53.9-81 53.9-130.1V184H320v296zM184 352c0 41 26.9 75.8 64 87.6-37.1-11.9-64-46.7-64-87.6zm364 382.5C665 721.8 758.4 630.2 773.8 514 758.3 630.2 665 721.7 548 734.5zM250.2 514C265.6 630.2 359 721.8 476 734.5 359 721.7 265.7 630.2 250.2 514z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M868 160h-92v-40c0-4.4-3.6-8-8-8H256c-4.4 0-8 3.6-8 8v40h-92a44 44 0 0 0-44 44v148c0 81.7 60 149.6 138.2 162C265.7 630.2 359 721.7 476 734.5v105.2H280c-17.7 0-32 14.3-32 32V904c0 4.4 3.6 8 8 8h512c4.4 0 8-3.6 8-8v-32.3c0-17.7-14.3-32-32-32H548V734.5C665 721.7 758.3 630.2 773.8 514 852 501.6 912 433.7 912 352V204a44 44 0 0 0-44-44zM248 439.6a91.99 91.99 0 0 1-64-87.6V232h64v207.6zM704 480c0 49.1-19.1 95.4-53.9 130.1-34.8 34.8-81 53.9-130.1 53.9h-16c-49.1 0-95.4-19.1-130.1-53.9-34.8-34.8-53.9-81-53.9-130.1V184h384v296zm136-128c0 41-26.9 75.8-64 87.6V232h64v120z"
                }
            }
        ]
    })(props);
}
function AiTwotoneUnlock(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#D9D9D9",
                    "d": "M232 840h560V536H232v304zm280-226a48.01 48.01 0 0 1 28 87v53c0 4.4-3.6 8-8 8h-40c-4.4 0-8-3.6-8-8v-53a48.01 48.01 0 0 1 28-87z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M484 701v53c0 4.4 3.6 8 8 8h40c4.4 0 8-3.6 8-8v-53a48.01 48.01 0 1 0-56 0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M832 464H332V240c0-30.9 25.1-56 56-56h248c30.9 0 56 25.1 56 56v68c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-68c0-70.7-57.3-128-128-128H388c-70.7 0-128 57.3-128 128v224h-68c-17.7 0-32 14.3-32 32v384c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V496c0-17.7-14.3-32-32-32zm-40 376H232V536h560v304z"
                }
            }
        ]
    })(props);
}
function AiTwotoneUpCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#E6E6E6",
                    "d": "M512 140c-205.4 0-372 166.6-372 372s166.6 372 372 372 372-166.6 372-372-166.6-372-372-372zm178 479h-46.9c-10.2 0-19.9-4.9-25.9-13.2L512 460.4 406.8 605.8c-6 8.3-15.6 13.2-25.9 13.2H334c-6.5 0-10.3-7.4-6.5-12.7l178-246c3.2-4.4 9.7-4.4 12.9 0l178 246c3.9 5.3.1 12.7-6.4 12.7z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M518.4 360.3a7.95 7.95 0 0 0-12.9 0l-178 246c-3.8 5.3 0 12.7 6.5 12.7h46.9c10.3 0 19.9-4.9 25.9-13.2L512 460.4l105.2 145.4c6 8.3 15.7 13.2 25.9 13.2H690c6.5 0 10.3-7.4 6.4-12.7l-178-246z"
                }
            }
        ]
    })(props);
}
function AiTwotoneUpSquare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#E6E6E6",
                    "d": "M184 840h656V184H184v656zm143.5-228.7l178-246c3.2-4.4 9.7-4.4 12.9 0l178 246c3.9 5.3.1 12.7-6.4 12.7h-46.9c-10.2 0-19.9-4.9-25.9-13.2L512 465.4 406.8 610.8c-6 8.3-15.6 13.2-25.9 13.2H334c-6.5 0-10.3-7.4-6.5-12.7z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M334 624h46.9c10.3 0 19.9-4.9 25.9-13.2L512 465.4l105.2 145.4c6 8.3 15.7 13.2 25.9 13.2H690c6.5 0 10.3-7.4 6.4-12.7l-178-246a7.95 7.95 0 0 0-12.9 0l-178 246c-3.8 5.3 0 12.7 6.5 12.7z"
                }
            }
        ]
    })(props);
}
function AiTwotoneUsb(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#D9D9D9",
                    "d": "M759.9 504H264.1c-26.5 0-48.1 19.7-48.1 44v292h592V548c0-24.3-21.6-44-48.1-44z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M456 248h-48c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zm160 0h-48c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M760 432V144c0-17.7-14.3-32-32-32H296c-17.7 0-32 14.3-32 32v288c-66.2 0-120 52.1-120 116v356c0 4.4 3.6 8 8 8h720c4.4 0 8-3.6 8-8V548c0-63.9-53.8-116-120-116zM336 184h352v248H336V184zm472 656H216V548c0-24.3 21.6-44 48.1-44h495.8c26.5 0 48.1 19.7 48.1 44v292z"
                }
            }
        ]
    })(props);
}
function AiTwotoneVideoCamera(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#D9D9D9",
                    "d": "M136 792h576V232H136v560zm64-488c0-4.4 3.6-8 8-8h112c4.4 0 8 3.6 8 8v48c0 4.4-3.6 8-8 8H208c-4.4 0-8-3.6-8-8v-48z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M912 302.3L784 376V224c0-35.3-28.7-64-64-64H128c-35.3 0-64 28.7-64 64v576c0 35.3 28.7 64 64 64h592c35.3 0 64-28.7 64-64V648l128 73.7c21.3 12.3 48-3.1 48-27.6V330c0-24.6-26.7-40-48-27.7zM712 792H136V232h576v560zm176-167l-104-59.8V458.9L888 399v226z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M208 360h112c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H208c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8z"
                }
            }
        ]
    })(props);
}
function AiTwotoneWallet(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 464H528V448h312v128zm0-192H496c-17.7 0-32 14.3-32 32v192c0 17.7 14.3 32 32 32h344v200H184V184h656v200z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#E6E6E6",
                    "d": "M528 576h312V448H528v128zm92-104c22.1 0 40 17.9 40 40s-17.9 40-40 40-40-17.9-40-40 17.9-40 40-40z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M580 512a40 40 0 1 0 80 0 40 40 0 1 0-80 0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#E6E6E6",
                    "d": "M184 840h656V640H496c-17.7 0-32-14.3-32-32V416c0-17.7 14.3-32 32-32h344V184H184v656z"
                }
            }
        ]
    })(props);
}
function AiTwotoneWarning(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M955.7 856l-416-720c-6.2-10.7-16.9-16-27.7-16s-21.6 5.3-27.7 16l-416 720C56 877.4 71.4 904 96 904h832c24.6 0 40-26.6 27.7-48zm-783.5-27.9L512 239.9l339.8 588.2H172.2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#E6E6E6",
                    "d": "M172.2 828.1h679.6L512 239.9 172.2 828.1zM560 720a48.01 48.01 0 0 1-96 0 48.01 48.01 0 0 1 96 0zm-16-304v184c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V416c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M464 720a48 48 0 1 0 96 0 48 48 0 1 0-96 0zm16-304v184c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V416c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8z"
                }
            }
        ]
    })(props);
}

},{"../lib":"ciihV","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"fI0Q4":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createDomMotionComponent", ()=>(0, _motionMjs.createDomMotionComponent));
parcelHelpers.export(exports, "motion", ()=>(0, _motionMjs.motion));
parcelHelpers.export(exports, "m", ()=>(0, _motionMinimalMjs.m));
parcelHelpers.export(exports, "AnimatePresence", ()=>(0, _indexMjs.AnimatePresence));
parcelHelpers.export(exports, "MotionConfig", ()=>(0, _indexMjs1.MotionConfig));
parcelHelpers.export(exports, "LazyMotion", ()=>(0, _indexMjs2.LazyMotion));
parcelHelpers.export(exports, "LayoutGroup", ()=>(0, _indexMjs3.LayoutGroup));
parcelHelpers.export(exports, "Reorder", ()=>(0, _indexMjs4.Reorder));
parcelHelpers.export(exports, "domAnimation", ()=>(0, _featuresAnimationMjs.domAnimation));
parcelHelpers.export(exports, "domMax", ()=>(0, _featuresMaxMjs.domMax));
parcelHelpers.export(exports, "useMotionValue", ()=>(0, _useMotionValueMjs.useMotionValue));
parcelHelpers.export(exports, "useMotionTemplate", ()=>(0, _useMotionTemplateMjs.useMotionTemplate));
parcelHelpers.export(exports, "resolveMotionValue", ()=>(0, _resolveMotionValueMjs.resolveMotionValue));
parcelHelpers.export(exports, "useTransform", ()=>(0, _useTransformMjs.useTransform));
parcelHelpers.export(exports, "useSpring", ()=>(0, _useSpringMjs.useSpring));
parcelHelpers.export(exports, "useVelocity", ()=>(0, _useVelocityMjs.useVelocity));
parcelHelpers.export(exports, "useScroll", ()=>(0, _useScrollMjs.useScroll));
parcelHelpers.export(exports, "useElementScroll", ()=>(0, _useElementScrollMjs.useElementScroll));
parcelHelpers.export(exports, "useViewportScroll", ()=>(0, _useViewportScrollMjs.useViewportScroll));
parcelHelpers.export(exports, "useTime", ()=>(0, _useTimeMjs.useTime));
parcelHelpers.export(exports, "useWillChange", ()=>(0, _indexMjs5.useWillChange));
parcelHelpers.export(exports, "useMotionValueEvent", ()=>(0, _useMotionValueEventMjs.useMotionValueEvent));
parcelHelpers.export(exports, "useReducedMotion", ()=>(0, _useReducedMotionMjs.useReducedMotion));
parcelHelpers.export(exports, "useReducedMotionConfig", ()=>(0, _useReducedMotionConfigMjs.useReducedMotionConfig));
parcelHelpers.export(exports, "animationControls", ()=>(0, _animationControlsMjs.animationControls));
parcelHelpers.export(exports, "useAnimate", ()=>(0, _useAnimateMjs.useAnimate));
parcelHelpers.export(exports, "useAnimation", ()=>(0, _useAnimationMjs.useAnimation));
parcelHelpers.export(exports, "useAnimationControls", ()=>(0, _useAnimationMjs.useAnimationControls));
parcelHelpers.export(exports, "useAnimationFrame", ()=>(0, _useAnimationFrameMjs.useAnimationFrame));
parcelHelpers.export(exports, "animateVisualElement", ()=>(0, _visualElementMjs.animateVisualElement));
parcelHelpers.export(exports, "useCycle", ()=>(0, _useCycleMjs.useCycle));
parcelHelpers.export(exports, "isValidMotionProp", ()=>(0, _validPropMjs.isValidMotionProp));
parcelHelpers.export(exports, "useIsPresent", ()=>(0, _usePresenceMjs.useIsPresent));
parcelHelpers.export(exports, "usePresence", ()=>(0, _usePresenceMjs.usePresence));
parcelHelpers.export(exports, "useInView", ()=>(0, _useInViewMjs.useInView));
parcelHelpers.export(exports, "DragControls", ()=>(0, _useDragControlsMjs.DragControls));
parcelHelpers.export(exports, "useDragControls", ()=>(0, _useDragControlsMjs.useDragControls));
parcelHelpers.export(exports, "useDomEvent", ()=>(0, _useDomEventMjs.useDomEvent));
parcelHelpers.export(exports, "createMotionComponent", ()=>(0, _indexMjs6.createMotionComponent));
parcelHelpers.export(exports, "isMotionComponent", ()=>(0, _isMotionComponentMjs.isMotionComponent));
parcelHelpers.export(exports, "unwrapMotionComponent", ()=>(0, _unwrapMotionComponentMjs.unwrapMotionComponent));
parcelHelpers.export(exports, "VisualElement", ()=>(0, _visualElementMjs1.VisualElement));
parcelHelpers.export(exports, "addScaleCorrector", ()=>(0, _scaleCorrectionMjs.addScaleCorrector));
parcelHelpers.export(exports, "disableInstantTransitions", ()=>(0, _useInstantTransitionMjs.disableInstantTransitions));
parcelHelpers.export(exports, "useInstantTransition", ()=>(0, _useInstantTransitionMjs.useInstantTransition));
parcelHelpers.export(exports, "useInstantLayoutTransition", ()=>(0, _useInstantLayoutTransitionMjs.useInstantLayoutTransition));
parcelHelpers.export(exports, "useResetProjection", ()=>(0, _useResetProjectionMjs.useResetProjection));
parcelHelpers.export(exports, "buildTransform", ()=>(0, _buildTransformMjs.buildTransform));
parcelHelpers.export(exports, "visualElementStore", ()=>(0, _storeMjs.visualElementStore));
parcelHelpers.export(exports, "animateValue", ()=>(0, _indexMjs7.animateValue));
parcelHelpers.export(exports, "color", ()=>(0, _indexMjs8.color));
parcelHelpers.export(exports, "complex", ()=>(0, _indexMjs9.complex));
parcelHelpers.export(exports, "px", ()=>(0, _unitsMjs.px));
parcelHelpers.export(exports, "MotionGlobalConfig", ()=>(0, _globalConfigMjs.MotionGlobalConfig));
parcelHelpers.export(exports, "startOptimizedAppearAnimation", ()=>(0, _startMjs.startOptimizedAppearAnimation));
parcelHelpers.export(exports, "optimizedAppearDataAttribute", ()=>(0, _dataIdMjs.optimizedAppearDataAttribute));
parcelHelpers.export(exports, "spring", ()=>(0, _indexMjs10.spring));
parcelHelpers.export(exports, "MotionContext", ()=>(0, _indexMjs11.MotionContext));
parcelHelpers.export(exports, "MotionConfigContext", ()=>(0, _motionConfigContextMjs.MotionConfigContext));
parcelHelpers.export(exports, "PresenceContext", ()=>(0, _presenceContextMjs.PresenceContext));
parcelHelpers.export(exports, "LayoutGroupContext", ()=>(0, _layoutGroupContextMjs.LayoutGroupContext));
parcelHelpers.export(exports, "SwitchLayoutGroupContext", ()=>(0, _switchLayoutGroupContextMjs.SwitchLayoutGroupContext));
parcelHelpers.export(exports, "FlatTree", ()=>(0, _flatTreeMjs.FlatTree));
parcelHelpers.export(exports, "DeprecatedLayoutGroupContext", ()=>(0, _deprecatedLayoutGroupContextMjs.DeprecatedLayoutGroupContext));
parcelHelpers.export(exports, "useDeprecatedAnimatedState", ()=>(0, _useAnimatedStateMjs.useAnimatedState));
parcelHelpers.export(exports, "useDeprecatedInvertedScale", ()=>(0, _useInvertedScaleMjs.useInvertedScale));
parcelHelpers.export(exports, "AnimateSharedLayout", ()=>(0, _animateSharedLayoutMjs.AnimateSharedLayout));
parcelHelpers.export(exports, "MotionValue", ()=>(0, _indexMjs12.MotionValue));
parcelHelpers.export(exports, "motionValue", ()=>(0, _indexMjs12.motionValue));
parcelHelpers.export(exports, "animate", ()=>(0, _animateMjs.animate));
parcelHelpers.export(exports, "createScopedAnimate", ()=>(0, _animateMjs.createScopedAnimate));
parcelHelpers.export(exports, "scroll", ()=>(0, _indexMjs13.scroll));
parcelHelpers.export(exports, "scrollInfo", ()=>(0, _trackMjs.scrollInfo));
parcelHelpers.export(exports, "inView", ()=>(0, _indexMjs14.inView));
parcelHelpers.export(exports, "stagger", ()=>(0, _staggerMjs.stagger));
parcelHelpers.export(exports, "transform", ()=>(0, _transformMjs.transform));
parcelHelpers.export(exports, "clamp", ()=>(0, _clampMjs.clamp));
parcelHelpers.export(exports, "mix", ()=>(0, _mixMjs.mix));
parcelHelpers.export(exports, "pipe", ()=>(0, _pipeMjs.pipe));
parcelHelpers.export(exports, "progress", ()=>(0, _progressMjs.progress));
parcelHelpers.export(exports, "wrap", ()=>(0, _wrapMjs.wrap));
parcelHelpers.export(exports, "cancelSync", ()=>(0, _indexLegacyMjs.cancelSync));
parcelHelpers.export(exports, "sync", ()=>(0, _indexLegacyMjs.sync));
parcelHelpers.export(exports, "anticipate", ()=>(0, _anticipateMjs.anticipate));
parcelHelpers.export(exports, "backIn", ()=>(0, _backMjs.backIn));
parcelHelpers.export(exports, "backInOut", ()=>(0, _backMjs.backInOut));
parcelHelpers.export(exports, "backOut", ()=>(0, _backMjs.backOut));
parcelHelpers.export(exports, "circIn", ()=>(0, _circMjs.circIn));
parcelHelpers.export(exports, "circInOut", ()=>(0, _circMjs.circInOut));
parcelHelpers.export(exports, "circOut", ()=>(0, _circMjs.circOut));
parcelHelpers.export(exports, "easeIn", ()=>(0, _easeMjs.easeIn));
parcelHelpers.export(exports, "easeInOut", ()=>(0, _easeMjs.easeInOut));
parcelHelpers.export(exports, "easeOut", ()=>(0, _easeMjs.easeOut));
parcelHelpers.export(exports, "cubicBezier", ()=>(0, _cubicBezierMjs.cubicBezier));
parcelHelpers.export(exports, "mirrorEasing", ()=>(0, _mirrorMjs.mirrorEasing));
parcelHelpers.export(exports, "reverseEasing", ()=>(0, _reverseMjs.reverseEasing));
parcelHelpers.export(exports, "delay", ()=>(0, _delayMjs.delay));
parcelHelpers.export(exports, "distance", ()=>(0, _distanceMjs.distance));
parcelHelpers.export(exports, "distance2D", ()=>(0, _distanceMjs.distance2D));
parcelHelpers.export(exports, "invariant", ()=>(0, _errorsMjs.invariant));
parcelHelpers.export(exports, "warning", ()=>(0, _errorsMjs.warning));
parcelHelpers.export(exports, "interpolate", ()=>(0, _interpolateMjs.interpolate));
parcelHelpers.export(exports, "cancelFrame", ()=>(0, _frameMjs.cancelFrame));
parcelHelpers.export(exports, "frame", ()=>(0, _frameMjs.frame));
parcelHelpers.export(exports, "frameData", ()=>(0, _frameMjs.frameData));
parcelHelpers.export(exports, "steps", ()=>(0, _frameMjs.steps));
parcelHelpers.export(exports, "animations", ()=>(0, _animationsMjs.animations));
parcelHelpers.export(exports, "checkTargetForNewValues", ()=>(0, _settersMjs.checkTargetForNewValues));
parcelHelpers.export(exports, "createBox", ()=>(0, _modelsMjs.createBox));
parcelHelpers.export(exports, "calcLength", ()=>(0, _deltaCalcMjs.calcLength));
parcelHelpers.export(exports, "filterProps", ()=>(0, _filterPropsMjs.filterProps));
parcelHelpers.export(exports, "makeUseVisualState", ()=>(0, _useVisualStateMjs.makeUseVisualState));
parcelHelpers.export(exports, "isDragActive", ()=>(0, _lockMjs.isDragActive));
parcelHelpers.export(exports, "addPointerEvent", ()=>(0, _addPointerEventMjs.addPointerEvent));
parcelHelpers.export(exports, "addPointerInfo", ()=>(0, _eventInfoMjs.addPointerInfo));
parcelHelpers.export(exports, "isMotionValue", ()=>(0, _isMotionValueMjs.isMotionValue));
parcelHelpers.export(exports, "isBrowser", ()=>(0, _isBrowserMjs.isBrowser));
parcelHelpers.export(exports, "useUnmountEffect", ()=>(0, _useUnmountEffectMjs.useUnmountEffect));
parcelHelpers.export(exports, "useIsomorphicLayoutEffect", ()=>(0, _useIsomorphicEffectMjs.useIsomorphicLayoutEffect));
parcelHelpers.export(exports, "useForceUpdate", ()=>(0, _useForceUpdateMjs.useForceUpdate));
var _motionMjs = require("./render/dom/motion.mjs");
var _motionMinimalMjs = require("./render/dom/motion-minimal.mjs");
var _indexMjs = require("./components/AnimatePresence/index.mjs");
var _indexMjs1 = require("./components/MotionConfig/index.mjs");
var _indexMjs2 = require("./components/LazyMotion/index.mjs");
var _indexMjs3 = require("./components/LayoutGroup/index.mjs");
var _indexMjs4 = require("./components/Reorder/index.mjs");
var _featuresAnimationMjs = require("./render/dom/features-animation.mjs");
var _featuresMaxMjs = require("./render/dom/features-max.mjs");
var _useMotionValueMjs = require("./value/use-motion-value.mjs");
var _useMotionTemplateMjs = require("./value/use-motion-template.mjs");
var _resolveMotionValueMjs = require("./value/utils/resolve-motion-value.mjs");
var _useTransformMjs = require("./value/use-transform.mjs");
var _useSpringMjs = require("./value/use-spring.mjs");
var _useVelocityMjs = require("./value/use-velocity.mjs");
var _useScrollMjs = require("./value/use-scroll.mjs");
var _useElementScrollMjs = require("./value/scroll/use-element-scroll.mjs");
var _useViewportScrollMjs = require("./value/scroll/use-viewport-scroll.mjs");
var _useTimeMjs = require("./value/use-time.mjs");
var _indexMjs5 = require("./value/use-will-change/index.mjs");
var _useMotionValueEventMjs = require("./utils/use-motion-value-event.mjs");
var _useReducedMotionMjs = require("./utils/reduced-motion/use-reduced-motion.mjs");
var _useReducedMotionConfigMjs = require("./utils/reduced-motion/use-reduced-motion-config.mjs");
var _animationControlsMjs = require("./animation/hooks/animation-controls.mjs");
var _useAnimateMjs = require("./animation/hooks/use-animate.mjs");
var _useAnimationMjs = require("./animation/hooks/use-animation.mjs");
var _useAnimationFrameMjs = require("./utils/use-animation-frame.mjs");
var _visualElementMjs = require("./animation/interfaces/visual-element.mjs");
var _useCycleMjs = require("./utils/use-cycle.mjs");
var _validPropMjs = require("./motion/utils/valid-prop.mjs");
var _usePresenceMjs = require("./components/AnimatePresence/use-presence.mjs");
var _useInViewMjs = require("./utils/use-in-view.mjs");
var _useDragControlsMjs = require("./gestures/drag/use-drag-controls.mjs");
var _useDomEventMjs = require("./events/use-dom-event.mjs");
var _indexMjs6 = require("./motion/index.mjs");
var _isMotionComponentMjs = require("./motion/utils/is-motion-component.mjs");
var _unwrapMotionComponentMjs = require("./motion/utils/unwrap-motion-component.mjs");
var _visualElementMjs1 = require("./render/VisualElement.mjs");
var _scaleCorrectionMjs = require("./projection/styles/scale-correction.mjs");
var _useInstantTransitionMjs = require("./utils/use-instant-transition.mjs");
var _useInstantLayoutTransitionMjs = require("./projection/use-instant-layout-transition.mjs");
var _useResetProjectionMjs = require("./projection/use-reset-projection.mjs");
var _buildTransformMjs = require("./render/html/utils/build-transform.mjs");
var _storeMjs = require("./render/store.mjs");
var _indexMjs7 = require("./animation/animators/js/index.mjs");
var _indexMjs8 = require("./value/types/color/index.mjs");
var _indexMjs9 = require("./value/types/complex/index.mjs");
var _unitsMjs = require("./value/types/numbers/units.mjs");
var _globalConfigMjs = require("./utils/GlobalConfig.mjs");
var _startMjs = require("./animation/optimized-appear/start.mjs");
var _dataIdMjs = require("./animation/optimized-appear/data-id.mjs");
var _indexMjs10 = require("./animation/generators/spring/index.mjs");
var _indexMjs11 = require("./context/MotionContext/index.mjs");
var _motionConfigContextMjs = require("./context/MotionConfigContext.mjs");
var _presenceContextMjs = require("./context/PresenceContext.mjs");
var _layoutGroupContextMjs = require("./context/LayoutGroupContext.mjs");
var _switchLayoutGroupContextMjs = require("./context/SwitchLayoutGroupContext.mjs");
var _flatTreeMjs = require("./render/utils/flat-tree.mjs");
var _deprecatedLayoutGroupContextMjs = require("./context/DeprecatedLayoutGroupContext.mjs");
var _useAnimatedStateMjs = require("./animation/hooks/use-animated-state.mjs");
var _useInvertedScaleMjs = require("./value/use-inverted-scale.mjs");
var _animateSharedLayoutMjs = require("./components/AnimateSharedLayout.mjs");
var _indexMjs12 = require("./value/index.mjs");
var _animateMjs = require("./animation/animate.mjs");
var _indexMjs13 = require("./render/dom/scroll/index.mjs");
var _trackMjs = require("./render/dom/scroll/track.mjs");
var _indexMjs14 = require("./render/dom/viewport/index.mjs");
var _staggerMjs = require("./animation/utils/stagger.mjs");
var _transformMjs = require("./utils/transform.mjs");
var _clampMjs = require("./utils/clamp.mjs");
var _mixMjs = require("./utils/mix.mjs");
var _pipeMjs = require("./utils/pipe.mjs");
var _progressMjs = require("./utils/progress.mjs");
var _wrapMjs = require("./utils/wrap.mjs");
var _indexLegacyMjs = require("./frameloop/index-legacy.mjs");
var _anticipateMjs = require("./easing/anticipate.mjs");
var _backMjs = require("./easing/back.mjs");
var _circMjs = require("./easing/circ.mjs");
var _easeMjs = require("./easing/ease.mjs");
var _cubicBezierMjs = require("./easing/cubic-bezier.mjs");
var _mirrorMjs = require("./easing/modifiers/mirror.mjs");
var _reverseMjs = require("./easing/modifiers/reverse.mjs");
var _delayMjs = require("./utils/delay.mjs");
var _distanceMjs = require("./utils/distance.mjs");
var _errorsMjs = require("./utils/errors.mjs");
var _interpolateMjs = require("./utils/interpolate.mjs");
var _frameMjs = require("./frameloop/frame.mjs");
var _animationsMjs = require("./motion/features/animations.mjs");
var _settersMjs = require("./render/utils/setters.mjs");
var _modelsMjs = require("./projection/geometry/models.mjs");
var _deltaCalcMjs = require("./projection/geometry/delta-calc.mjs");
var _filterPropsMjs = require("./render/dom/utils/filter-props.mjs");
var _useVisualStateMjs = require("./motion/utils/use-visual-state.mjs");
var _lockMjs = require("./gestures/drag/utils/lock.mjs");
var _addPointerEventMjs = require("./events/add-pointer-event.mjs");
var _eventInfoMjs = require("./events/event-info.mjs");
var _isMotionValueMjs = require("./value/utils/is-motion-value.mjs");
var _isBrowserMjs = require("./utils/is-browser.mjs");
var _useUnmountEffectMjs = require("./utils/use-unmount-effect.mjs");
var _useIsomorphicEffectMjs = require("./utils/use-isomorphic-effect.mjs");
var _useForceUpdateMjs = require("./utils/use-force-update.mjs");

},{"./render/dom/motion.mjs":"8FwSn","./render/dom/motion-minimal.mjs":false,"./components/AnimatePresence/index.mjs":false,"./components/MotionConfig/index.mjs":false,"./components/LazyMotion/index.mjs":false,"./components/LayoutGroup/index.mjs":false,"./components/Reorder/index.mjs":false,"./render/dom/features-animation.mjs":false,"./render/dom/features-max.mjs":false,"./value/use-motion-value.mjs":false,"./value/use-motion-template.mjs":false,"./value/utils/resolve-motion-value.mjs":false,"./value/use-transform.mjs":false,"./value/use-spring.mjs":false,"./value/use-velocity.mjs":false,"./value/use-scroll.mjs":false,"./value/scroll/use-element-scroll.mjs":false,"./value/scroll/use-viewport-scroll.mjs":false,"./value/use-time.mjs":false,"./value/use-will-change/index.mjs":false,"./utils/use-motion-value-event.mjs":false,"./utils/reduced-motion/use-reduced-motion.mjs":false,"./utils/reduced-motion/use-reduced-motion-config.mjs":false,"./animation/hooks/animation-controls.mjs":false,"./animation/hooks/use-animate.mjs":false,"./animation/hooks/use-animation.mjs":"aKmmf","./utils/use-animation-frame.mjs":false,"./animation/interfaces/visual-element.mjs":false,"./utils/use-cycle.mjs":false,"./motion/utils/valid-prop.mjs":false,"./components/AnimatePresence/use-presence.mjs":false,"./utils/use-in-view.mjs":false,"./gestures/drag/use-drag-controls.mjs":false,"./events/use-dom-event.mjs":false,"./motion/index.mjs":false,"./motion/utils/is-motion-component.mjs":false,"./motion/utils/unwrap-motion-component.mjs":false,"./render/VisualElement.mjs":false,"./projection/styles/scale-correction.mjs":false,"./utils/use-instant-transition.mjs":false,"./projection/use-instant-layout-transition.mjs":false,"./projection/use-reset-projection.mjs":false,"./render/html/utils/build-transform.mjs":false,"./render/store.mjs":false,"./animation/animators/js/index.mjs":false,"./value/types/color/index.mjs":false,"./value/types/complex/index.mjs":false,"./value/types/numbers/units.mjs":false,"./utils/GlobalConfig.mjs":false,"./animation/optimized-appear/start.mjs":false,"./animation/optimized-appear/data-id.mjs":false,"./animation/generators/spring/index.mjs":false,"./context/MotionContext/index.mjs":false,"./context/MotionConfigContext.mjs":false,"./context/PresenceContext.mjs":false,"./context/LayoutGroupContext.mjs":false,"./context/SwitchLayoutGroupContext.mjs":false,"./render/utils/flat-tree.mjs":false,"./context/DeprecatedLayoutGroupContext.mjs":false,"./animation/hooks/use-animated-state.mjs":false,"./value/use-inverted-scale.mjs":false,"./components/AnimateSharedLayout.mjs":false,"./value/index.mjs":false,"./animation/animate.mjs":false,"./render/dom/scroll/index.mjs":false,"./render/dom/scroll/track.mjs":false,"./render/dom/viewport/index.mjs":false,"./animation/utils/stagger.mjs":false,"./utils/transform.mjs":false,"./utils/clamp.mjs":false,"./utils/mix.mjs":false,"./utils/pipe.mjs":false,"./utils/progress.mjs":false,"./utils/wrap.mjs":false,"./frameloop/index-legacy.mjs":false,"./easing/anticipate.mjs":false,"./easing/back.mjs":false,"./easing/circ.mjs":false,"./easing/ease.mjs":false,"./easing/cubic-bezier.mjs":false,"./easing/modifiers/mirror.mjs":false,"./easing/modifiers/reverse.mjs":false,"./utils/delay.mjs":false,"./utils/distance.mjs":false,"./utils/errors.mjs":false,"./utils/interpolate.mjs":false,"./frameloop/frame.mjs":false,"./motion/features/animations.mjs":false,"./render/utils/setters.mjs":false,"./projection/geometry/models.mjs":false,"./projection/geometry/delta-calc.mjs":false,"./render/dom/utils/filter-props.mjs":false,"./motion/utils/use-visual-state.mjs":false,"./gestures/drag/utils/lock.mjs":false,"./events/add-pointer-event.mjs":false,"./events/event-info.mjs":false,"./value/utils/is-motion-value.mjs":false,"./utils/is-browser.mjs":false,"./utils/use-unmount-effect.mjs":false,"./utils/use-isomorphic-effect.mjs":false,"./utils/use-force-update.mjs":false,"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8FwSn":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createDomMotionComponent", ()=>createDomMotionComponent);
parcelHelpers.export(exports, "motion", ()=>motion);
var _indexMjs = require("../../motion/index.mjs");
var _motionProxyMjs = require("./motion-proxy.mjs");
var _createConfigMjs = require("./utils/create-config.mjs");
var _gesturesMjs = require("../../motion/features/gestures.mjs");
var _animationsMjs = require("../../motion/features/animations.mjs");
var _dragMjs = require("../../motion/features/drag.mjs");
var _createVisualElementMjs = require("./create-visual-element.mjs");
var _layoutMjs = require("../../motion/features/layout.mjs");
const preloadedFeatures = {
    ...(0, _animationsMjs.animations),
    ...(0, _gesturesMjs.gestureAnimations),
    ...(0, _dragMjs.drag),
    ...(0, _layoutMjs.layout)
};
/**
 * HTML & SVG components, optimised for use with gestures and animation. These can be used as
 * drop-in replacements for any HTML & SVG component, all CSS & SVG properties are supported.
 *
 * @public
 */ const motion = /*@__PURE__*/ (0, _motionProxyMjs.createMotionProxy)((Component, config)=>(0, _createConfigMjs.createDomMotionConfig)(Component, config, preloadedFeatures, (0, _createVisualElementMjs.createDomVisualElement)));
/**
 * Create a DOM `motion` component with the provided string. This is primarily intended
 * as a full alternative to `motion` for consumers who have to support environments that don't
 * support `Proxy`.
 *
 * ```javascript
 * import { createDomMotionComponent } from "framer-motion"
 *
 * const motion = {
 *   div: createDomMotionComponent('div')
 * }
 * ```
 *
 * @public
 */ function createDomMotionComponent(key) {
    return (0, _indexMjs.createMotionComponent)((0, _createConfigMjs.createDomMotionConfig)(key, {
        forwardMotionProps: false
    }, preloadedFeatures, (0, _createVisualElementMjs.createDomVisualElement)));
}

},{"../../motion/index.mjs":"4SUx6","./motion-proxy.mjs":"jQLVc","./utils/create-config.mjs":"eIW0T","../../motion/features/gestures.mjs":"7BuHh","../../motion/features/animations.mjs":"Rvk5C","../../motion/features/drag.mjs":"89DRL","./create-visual-element.mjs":"7HD63","../../motion/features/layout.mjs":"81FkM","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4SUx6":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createMotionComponent", ()=>createMotionComponent);
var _react = require("react");
var _motionConfigContextMjs = require("../context/MotionConfigContext.mjs");
var _indexMjs = require("../context/MotionContext/index.mjs");
var _useVisualElementMjs = require("./utils/use-visual-element.mjs");
var _useMotionRefMjs = require("./utils/use-motion-ref.mjs");
var _createMjs = require("../context/MotionContext/create.mjs");
var _loadFeaturesMjs = require("./features/load-features.mjs");
var _isBrowserMjs = require("../utils/is-browser.mjs");
var _layoutGroupContextMjs = require("../context/LayoutGroupContext.mjs");
var _lazyContextMjs = require("../context/LazyContext.mjs");
var _switchLayoutGroupContextMjs = require("../context/SwitchLayoutGroupContext.mjs");
var _symbolMjs = require("./utils/symbol.mjs");
/**
 * Create a `motion` component.
 *
 * This function accepts a Component argument, which can be either a string (ie "div"
 * for `motion.div`), or an actual React component.
 *
 * Alongside this is a config option which provides a way of rendering the provided
 * component "offline", or outside the React render cycle.
 */ function createMotionComponent({ preloadedFeatures, createVisualElement, useRender, useVisualState, Component }) {
    preloadedFeatures && (0, _loadFeaturesMjs.loadFeatures)(preloadedFeatures);
    function MotionComponent(props, externalRef) {
        /**
         * If we need to measure the element we load this functionality in a
         * separate class component in order to gain access to getSnapshotBeforeUpdate.
         */ let MeasureLayout;
        const configAndProps = {
            ...(0, _react.useContext)((0, _motionConfigContextMjs.MotionConfigContext)),
            ...props,
            layoutId: useLayoutId(props)
        };
        const { isStatic } = configAndProps;
        const context = (0, _createMjs.useCreateMotionContext)(props);
        const visualState = useVisualState(props, isStatic);
        if (!isStatic && (0, _isBrowserMjs.isBrowser)) {
            /**
             * Create a VisualElement for this component. A VisualElement provides a common
             * interface to renderer-specific APIs (ie DOM/Three.js etc) as well as
             * providing a way of rendering to these APIs outside of the React render loop
             * for more performant animations and interactions
             */ context.visualElement = (0, _useVisualElementMjs.useVisualElement)(Component, visualState, configAndProps, createVisualElement);
            /**
             * Load Motion gesture and animation features. These are rendered as renderless
             * components so each feature can optionally make use of React lifecycle methods.
             */ const initialLayoutGroupConfig = (0, _react.useContext)((0, _switchLayoutGroupContextMjs.SwitchLayoutGroupContext));
            const isStrict = (0, _react.useContext)((0, _lazyContextMjs.LazyContext)).strict;
            if (context.visualElement) MeasureLayout = context.visualElement.loadFeatures(// Note: Pass the full new combined props to correctly re-render dynamic feature components.
            configAndProps, isStrict, preloadedFeatures, initialLayoutGroupConfig);
        }
        /**
         * The mount order and hierarchy is specific to ensure our element ref
         * is hydrated by the time features fire their effects.
         */ return _react.createElement((0, _indexMjs.MotionContext).Provider, {
            value: context
        }, MeasureLayout && context.visualElement ? _react.createElement(MeasureLayout, {
            visualElement: context.visualElement,
            ...configAndProps
        }) : null, useRender(Component, props, (0, _useMotionRefMjs.useMotionRef)(visualState, context.visualElement, externalRef), visualState, isStatic, context.visualElement));
    }
    const ForwardRefComponent = (0, _react.forwardRef)(MotionComponent);
    ForwardRefComponent[0, _symbolMjs.motionComponentSymbol] = Component;
    return ForwardRefComponent;
}
function useLayoutId({ layoutId }) {
    const layoutGroupId = (0, _react.useContext)((0, _layoutGroupContextMjs.LayoutGroupContext)).id;
    return layoutGroupId && layoutId !== undefined ? layoutGroupId + "-" + layoutId : layoutId;
}

},{"react":"6uln9","../context/MotionConfigContext.mjs":"92LC9","../context/MotionContext/index.mjs":"7Mlzo","./utils/use-visual-element.mjs":"iCjOe","./utils/use-motion-ref.mjs":"2OEvp","../context/MotionContext/create.mjs":"lMScg","./features/load-features.mjs":"hKPEi","../utils/is-browser.mjs":"9ew4K","../context/LayoutGroupContext.mjs":"5CkZ6","../context/LazyContext.mjs":"3Vzns","../context/SwitchLayoutGroupContext.mjs":"6krc6","./utils/symbol.mjs":"7WA7h","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"92LC9":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MotionConfigContext", ()=>MotionConfigContext);
var _react = require("react");
/**
 * @public
 */ const MotionConfigContext = (0, _react.createContext)({
    transformPagePoint: (p)=>p,
    isStatic: false,
    reducedMotion: "never"
});

},{"react":"6uln9","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7Mlzo":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MotionContext", ()=>MotionContext);
var _react = require("react");
const MotionContext = (0, _react.createContext)({});

},{"react":"6uln9","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"iCjOe":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useVisualElement", ()=>useVisualElement);
var _react = require("react");
var _presenceContextMjs = require("../../context/PresenceContext.mjs");
var _indexMjs = require("../../context/MotionContext/index.mjs");
var _useIsomorphicEffectMjs = require("../../utils/use-isomorphic-effect.mjs");
var _lazyContextMjs = require("../../context/LazyContext.mjs");
var _motionConfigContextMjs = require("../../context/MotionConfigContext.mjs");
var _dataIdMjs = require("../../animation/optimized-appear/data-id.mjs");
function useVisualElement(Component, visualState, props, createVisualElement) {
    const { visualElement: parent } = (0, _react.useContext)((0, _indexMjs.MotionContext));
    const lazyContext = (0, _react.useContext)((0, _lazyContextMjs.LazyContext));
    const presenceContext = (0, _react.useContext)((0, _presenceContextMjs.PresenceContext));
    const reducedMotionConfig = (0, _react.useContext)((0, _motionConfigContextMjs.MotionConfigContext)).reducedMotion;
    const visualElementRef = (0, _react.useRef)();
    /**
     * If we haven't preloaded a renderer, check to see if we have one lazy-loaded
     */ createVisualElement = createVisualElement || lazyContext.renderer;
    if (!visualElementRef.current && createVisualElement) visualElementRef.current = createVisualElement(Component, {
        visualState,
        parent,
        props,
        presenceContext,
        blockInitialAnimation: presenceContext ? presenceContext.initial === false : false,
        reducedMotionConfig
    });
    const visualElement = visualElementRef.current;
    (0, _react.useInsertionEffect)(()=>{
        visualElement && visualElement.update(props, presenceContext);
    });
    /**
     * Cache this value as we want to know whether HandoffAppearAnimations
     * was present on initial render - it will be deleted after this.
     */ const wantsHandoff = (0, _react.useRef)(Boolean(props[0, _dataIdMjs.optimizedAppearDataAttribute] && !window.HandoffComplete));
    (0, _useIsomorphicEffectMjs.useIsomorphicLayoutEffect)(()=>{
        if (!visualElement) return;
        visualElement.render();
        /**
         * Ideally this function would always run in a useEffect.
         *
         * However, if we have optimised appear animations to handoff from,
         * it needs to happen synchronously to ensure there's no flash of
         * incorrect styles in the event of a hydration error.
         *
         * So if we detect a situtation where optimised appear animations
         * are running, we use useLayoutEffect to trigger animations.
         */ if (wantsHandoff.current && visualElement.animationState) visualElement.animationState.animateChanges();
    });
    (0, _react.useEffect)(()=>{
        if (!visualElement) return;
        visualElement.updateFeatures();
        if (!wantsHandoff.current && visualElement.animationState) visualElement.animationState.animateChanges();
        if (wantsHandoff.current) {
            wantsHandoff.current = false;
            // This ensures all future calls to animateChanges() will run in useEffect
            window.HandoffComplete = true;
        }
    });
    return visualElement;
}

},{"react":"6uln9","../../context/PresenceContext.mjs":"dcXf9","../../context/MotionContext/index.mjs":"7Mlzo","../../utils/use-isomorphic-effect.mjs":"6Pcpq","../../context/LazyContext.mjs":"3Vzns","../../context/MotionConfigContext.mjs":"92LC9","../../animation/optimized-appear/data-id.mjs":"jLjpN","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"dcXf9":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PresenceContext", ()=>PresenceContext);
var _react = require("react");
/**
 * @public
 */ const PresenceContext = (0, _react.createContext)(null);

},{"react":"6uln9","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"6Pcpq":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useIsomorphicLayoutEffect", ()=>useIsomorphicLayoutEffect);
var _react = require("react");
var _isBrowserMjs = require("./is-browser.mjs");
const useIsomorphicLayoutEffect = (0, _isBrowserMjs.isBrowser) ? (0, _react.useLayoutEffect) : (0, _react.useEffect);

},{"react":"6uln9","./is-browser.mjs":"9ew4K","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9ew4K":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isBrowser", ()=>isBrowser);
const isBrowser = typeof document !== "undefined";

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"3Vzns":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LazyContext", ()=>LazyContext);
var _react = require("react");
const LazyContext = (0, _react.createContext)({
    strict: false
});

},{"react":"6uln9","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"jLjpN":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "optimizedAppearDataAttribute", ()=>optimizedAppearDataAttribute);
parcelHelpers.export(exports, "optimizedAppearDataId", ()=>optimizedAppearDataId);
var _camelToDashMjs = require("../../render/dom/utils/camel-to-dash.mjs");
const optimizedAppearDataId = "framerAppearId";
const optimizedAppearDataAttribute = "data-" + (0, _camelToDashMjs.camelToDash)(optimizedAppearDataId);

},{"../../render/dom/utils/camel-to-dash.mjs":"kNuZz","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"kNuZz":[function(require,module,exports) {
/**
 * Convert camelCase to dash-case properties.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "camelToDash", ()=>camelToDash);
const camelToDash = (str)=>str.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase();

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2OEvp":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useMotionRef", ()=>useMotionRef);
var _react = require("react");
var _isRefObjectMjs = require("../../utils/is-ref-object.mjs");
/**
 * Creates a ref function that, when called, hydrates the provided
 * external ref and VisualElement.
 */ function useMotionRef(visualState, visualElement, externalRef) {
    return (0, _react.useCallback)((instance)=>{
        instance && visualState.mount && visualState.mount(instance);
        if (visualElement) instance ? visualElement.mount(instance) : visualElement.unmount();
        if (externalRef) {
            if (typeof externalRef === "function") externalRef(instance);
            else if ((0, _isRefObjectMjs.isRefObject)(externalRef)) externalRef.current = instance;
        }
    }, /**
     * Only pass a new ref callback to React if we've received a visual element
     * factory. Otherwise we'll be mounting/remounting every time externalRef
     * or other dependencies change.
     */ [
        visualElement
    ]);
}

},{"react":"6uln9","../../utils/is-ref-object.mjs":"gluK5","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"gluK5":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isRefObject", ()=>isRefObject);
function isRefObject(ref) {
    return ref && typeof ref === "object" && Object.prototype.hasOwnProperty.call(ref, "current");
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"lMScg":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useCreateMotionContext", ()=>useCreateMotionContext);
var _react = require("react");
var _indexMjs = require("./index.mjs");
var _utilsMjs = require("./utils.mjs");
function useCreateMotionContext(props) {
    const { initial, animate } = (0, _utilsMjs.getCurrentTreeVariants)(props, (0, _react.useContext)((0, _indexMjs.MotionContext)));
    return (0, _react.useMemo)(()=>({
            initial,
            animate
        }), [
        variantLabelsAsDependency(initial),
        variantLabelsAsDependency(animate)
    ]);
}
function variantLabelsAsDependency(prop) {
    return Array.isArray(prop) ? prop.join(" ") : prop;
}

},{"react":"6uln9","./index.mjs":"7Mlzo","./utils.mjs":"jOm5Y","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"jOm5Y":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getCurrentTreeVariants", ()=>getCurrentTreeVariants);
var _isVariantLabelMjs = require("../../render/utils/is-variant-label.mjs");
var _isControllingVariantsMjs = require("../../render/utils/is-controlling-variants.mjs");
function getCurrentTreeVariants(props, context) {
    if ((0, _isControllingVariantsMjs.isControllingVariants)(props)) {
        const { initial, animate } = props;
        return {
            initial: initial === false || (0, _isVariantLabelMjs.isVariantLabel)(initial) ? initial : undefined,
            animate: (0, _isVariantLabelMjs.isVariantLabel)(animate) ? animate : undefined
        };
    }
    return props.inherit !== false ? context : {};
}

},{"../../render/utils/is-variant-label.mjs":"hGXyz","../../render/utils/is-controlling-variants.mjs":"tz7Ig","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"hGXyz":[function(require,module,exports) {
/**
 * Decides if the supplied variable is variant label
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isVariantLabel", ()=>isVariantLabel);
function isVariantLabel(v) {
    return typeof v === "string" || Array.isArray(v);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"tz7Ig":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isControllingVariants", ()=>isControllingVariants);
parcelHelpers.export(exports, "isVariantNode", ()=>isVariantNode);
var _isAnimationControlsMjs = require("../../animation/utils/is-animation-controls.mjs");
var _isVariantLabelMjs = require("./is-variant-label.mjs");
var _variantPropsMjs = require("./variant-props.mjs");
function isControllingVariants(props) {
    return (0, _isAnimationControlsMjs.isAnimationControls)(props.animate) || (0, _variantPropsMjs.variantProps).some((name)=>(0, _isVariantLabelMjs.isVariantLabel)(props[name]));
}
function isVariantNode(props) {
    return Boolean(isControllingVariants(props) || props.variants);
}

},{"../../animation/utils/is-animation-controls.mjs":"fDSp3","./is-variant-label.mjs":"hGXyz","./variant-props.mjs":"8wQuM","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"fDSp3":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isAnimationControls", ()=>isAnimationControls);
function isAnimationControls(v) {
    return v !== null && typeof v === "object" && typeof v.start === "function";
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8wQuM":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "variantPriorityOrder", ()=>variantPriorityOrder);
parcelHelpers.export(exports, "variantProps", ()=>variantProps);
const variantPriorityOrder = [
    "animate",
    "whileInView",
    "whileFocus",
    "whileHover",
    "whileTap",
    "whileDrag",
    "exit"
];
const variantProps = [
    "initial",
    ...variantPriorityOrder
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"hKPEi":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "loadFeatures", ()=>loadFeatures);
var _definitionsMjs = require("./definitions.mjs");
function loadFeatures(features) {
    for(const key in features)(0, _definitionsMjs.featureDefinitions)[key] = {
        ...(0, _definitionsMjs.featureDefinitions)[key],
        ...features[key]
    };
}

},{"./definitions.mjs":"hJfDG","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"hJfDG":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "featureDefinitions", ()=>featureDefinitions);
const featureProps = {
    animation: [
        "animate",
        "variants",
        "whileHover",
        "whileTap",
        "exit",
        "whileInView",
        "whileFocus",
        "whileDrag"
    ],
    exit: [
        "exit"
    ],
    drag: [
        "drag",
        "dragControls"
    ],
    focus: [
        "whileFocus"
    ],
    hover: [
        "whileHover",
        "onHoverStart",
        "onHoverEnd"
    ],
    tap: [
        "whileTap",
        "onTap",
        "onTapStart",
        "onTapCancel"
    ],
    pan: [
        "onPan",
        "onPanStart",
        "onPanSessionStart",
        "onPanEnd"
    ],
    inView: [
        "whileInView",
        "onViewportEnter",
        "onViewportLeave"
    ],
    layout: [
        "layout",
        "layoutId"
    ]
};
const featureDefinitions = {};
for(const key in featureProps)featureDefinitions[key] = {
    isEnabled: (props)=>featureProps[key].some((name)=>!!props[name])
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"5CkZ6":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LayoutGroupContext", ()=>LayoutGroupContext);
var _react = require("react");
const LayoutGroupContext = (0, _react.createContext)({});

},{"react":"6uln9","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"6krc6":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SwitchLayoutGroupContext", ()=>SwitchLayoutGroupContext);
var _react = require("react");
/**
 * Internal, exported only for usage in Framer
 */ const SwitchLayoutGroupContext = (0, _react.createContext)({});

},{"react":"6uln9","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7WA7h":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "motionComponentSymbol", ()=>motionComponentSymbol);
const motionComponentSymbol = Symbol.for("motionComponentSymbol");

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"jQLVc":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createMotionProxy", ()=>createMotionProxy);
var _indexMjs = require("../../motion/index.mjs");
/**
 * Convert any React component into a `motion` component. The provided component
 * **must** use `React.forwardRef` to the underlying DOM component you want to animate.
 *
 * ```jsx
 * const Component = React.forwardRef((props, ref) => {
 *   return <div ref={ref} />
 * })
 *
 * const MotionComponent = motion(Component)
 * ```
 *
 * @public
 */ function createMotionProxy(createConfig) {
    function custom(Component, customMotionComponentConfig = {}) {
        return (0, _indexMjs.createMotionComponent)(createConfig(Component, customMotionComponentConfig));
    }
    if (typeof Proxy === "undefined") return custom;
    /**
     * A cache of generated `motion` components, e.g `motion.div`, `motion.input` etc.
     * Rather than generating them anew every render.
     */ const componentCache = new Map();
    return new Proxy(custom, {
        /**
         * Called when `motion` is referenced with a prop: `motion.div`, `motion.input` etc.
         * The prop name is passed through as `key` and we can use that to generate a `motion`
         * DOM component with that name.
         */ get: (_target, key)=>{
            /**
             * If this element doesn't exist in the component cache, create it and cache.
             */ if (!componentCache.has(key)) componentCache.set(key, custom(key));
            return componentCache.get(key);
        }
    });
}

},{"../../motion/index.mjs":"4SUx6","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"eIW0T":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createDomMotionConfig", ()=>createDomMotionConfig);
var _isSvgComponentMjs = require("./is-svg-component.mjs");
var _useRenderMjs = require("../use-render.mjs");
var _configMotionMjs = require("../../svg/config-motion.mjs");
var _configMotionMjs1 = require("../../html/config-motion.mjs");
function createDomMotionConfig(Component, { forwardMotionProps = false }, preloadedFeatures, createVisualElement) {
    const baseConfig = (0, _isSvgComponentMjs.isSVGComponent)(Component) ? (0, _configMotionMjs.svgMotionConfig) : (0, _configMotionMjs1.htmlMotionConfig);
    return {
        ...baseConfig,
        preloadedFeatures,
        useRender: (0, _useRenderMjs.createUseRender)(forwardMotionProps),
        createVisualElement,
        Component
    };
}

},{"./is-svg-component.mjs":"2Ozjv","../use-render.mjs":"g2NMN","../../svg/config-motion.mjs":"5XVUv","../../html/config-motion.mjs":"3omuU","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2Ozjv":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isSVGComponent", ()=>isSVGComponent);
var _lowercaseElementsMjs = require("../../svg/lowercase-elements.mjs");
function isSVGComponent(Component) {
    if (/**
     * If it's not a string, it's a custom React component. Currently we only support
     * HTML custom React components.
     */ typeof Component !== "string" || /**
         * If it contains a dash, the element is a custom HTML webcomponent.
         */ Component.includes("-")) return false;
    else if (/**
     * If it's in our list of lowercase SVG tags, it's an SVG component
     */ (0, _lowercaseElementsMjs.lowercaseSVGElements).indexOf(Component) > -1 || /**
         * If it contains a capital letter, it's an SVG component
         */ /[A-Z]/.test(Component)) return true;
    return false;
}

},{"../../svg/lowercase-elements.mjs":"4TUrb","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4TUrb":[function(require,module,exports) {
/**
 * We keep these listed seperately as we use the lowercase tag names as part
 * of the runtime bundle to detect SVG components
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "lowercaseSVGElements", ()=>lowercaseSVGElements);
const lowercaseSVGElements = [
    "animate",
    "circle",
    "defs",
    "desc",
    "ellipse",
    "g",
    "image",
    "line",
    "filter",
    "marker",
    "mask",
    "metadata",
    "path",
    "pattern",
    "polygon",
    "polyline",
    "rect",
    "stop",
    "switch",
    "symbol",
    "svg",
    "text",
    "tspan",
    "use",
    "view"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"g2NMN":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createUseRender", ()=>createUseRender);
var _react = require("react");
var _usePropsMjs = require("../html/use-props.mjs");
var _filterPropsMjs = require("./utils/filter-props.mjs");
var _isSvgComponentMjs = require("./utils/is-svg-component.mjs");
var _usePropsMjs1 = require("../svg/use-props.mjs");
var _isMotionValueMjs = require("../../value/utils/is-motion-value.mjs");
function createUseRender(forwardMotionProps = false) {
    const useRender = (Component, props, ref, { latestValues }, isStatic)=>{
        const useVisualProps = (0, _isSvgComponentMjs.isSVGComponent)(Component) ? (0, _usePropsMjs1.useSVGProps) : (0, _usePropsMjs.useHTMLProps);
        const visualProps = useVisualProps(props, latestValues, isStatic, Component);
        const filteredProps = (0, _filterPropsMjs.filterProps)(props, typeof Component === "string", forwardMotionProps);
        const elementProps = {
            ...filteredProps,
            ...visualProps,
            ref
        };
        /**
         * If component has been handed a motion value as its child,
         * memoise its initial value and render that. Subsequent updates
         * will be handled by the onChange handler
         */ const { children } = props;
        const renderedChildren = (0, _react.useMemo)(()=>(0, _isMotionValueMjs.isMotionValue)(children) ? children.get() : children, [
            children
        ]);
        return (0, _react.createElement)(Component, {
            ...elementProps,
            children: renderedChildren
        });
    };
    return useRender;
}

},{"react":"6uln9","../html/use-props.mjs":"eKir9","./utils/filter-props.mjs":"aziKV","./utils/is-svg-component.mjs":"2Ozjv","../svg/use-props.mjs":"7mOnz","../../value/utils/is-motion-value.mjs":"2kZP7","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"eKir9":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "copyRawValuesOnly", ()=>copyRawValuesOnly);
parcelHelpers.export(exports, "useHTMLProps", ()=>useHTMLProps);
var _react = require("react");
var _isForcedMotionValueMjs = require("../../motion/utils/is-forced-motion-value.mjs");
var _isMotionValueMjs = require("../../value/utils/is-motion-value.mjs");
var _buildStylesMjs = require("./utils/build-styles.mjs");
var _createRenderStateMjs = require("./utils/create-render-state.mjs");
function copyRawValuesOnly(target, source, props) {
    for(const key in source)if (!(0, _isMotionValueMjs.isMotionValue)(source[key]) && !(0, _isForcedMotionValueMjs.isForcedMotionValue)(key, props)) target[key] = source[key];
}
function useInitialMotionValues({ transformTemplate }, visualState, isStatic) {
    return (0, _react.useMemo)(()=>{
        const state = (0, _createRenderStateMjs.createHtmlRenderState)();
        (0, _buildStylesMjs.buildHTMLStyles)(state, visualState, {
            enableHardwareAcceleration: !isStatic
        }, transformTemplate);
        return Object.assign({}, state.vars, state.style);
    }, [
        visualState
    ]);
}
function useStyle(props, visualState, isStatic) {
    const styleProp = props.style || {};
    const style = {};
    /**
     * Copy non-Motion Values straight into style
     */ copyRawValuesOnly(style, styleProp, props);
    Object.assign(style, useInitialMotionValues(props, visualState, isStatic));
    return props.transformValues ? props.transformValues(style) : style;
}
function useHTMLProps(props, visualState, isStatic) {
    // The `any` isn't ideal but it is the type of createElement props argument
    const htmlProps = {};
    const style = useStyle(props, visualState, isStatic);
    if (props.drag && props.dragListener !== false) {
        // Disable the ghost element when a user drags
        htmlProps.draggable = false;
        // Disable text selection
        style.userSelect = style.WebkitUserSelect = style.WebkitTouchCallout = "none";
        // Disable scrolling on the draggable direction
        style.touchAction = props.drag === true ? "none" : `pan-${props.drag === "x" ? "y" : "x"}`;
    }
    if (props.tabIndex === undefined && (props.onTap || props.onTapStart || props.whileTap)) htmlProps.tabIndex = 0;
    htmlProps.style = style;
    return htmlProps;
}

},{"react":"6uln9","../../motion/utils/is-forced-motion-value.mjs":"c7w2E","../../value/utils/is-motion-value.mjs":"2kZP7","./utils/build-styles.mjs":"3JcOY","./utils/create-render-state.mjs":"cXDm8","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"c7w2E":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isForcedMotionValue", ()=>isForcedMotionValue);
var _scaleCorrectionMjs = require("../../projection/styles/scale-correction.mjs");
var _transformMjs = require("../../render/html/utils/transform.mjs");
function isForcedMotionValue(key, { layout, layoutId }) {
    return (0, _transformMjs.transformProps).has(key) || key.startsWith("origin") || (layout || layoutId !== undefined) && (!!(0, _scaleCorrectionMjs.scaleCorrectors)[key] || key === "opacity");
}

},{"../../projection/styles/scale-correction.mjs":"4bQbP","../../render/html/utils/transform.mjs":"es0QE","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4bQbP":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "addScaleCorrector", ()=>addScaleCorrector);
parcelHelpers.export(exports, "scaleCorrectors", ()=>scaleCorrectors);
const scaleCorrectors = {};
function addScaleCorrector(correctors) {
    Object.assign(scaleCorrectors, correctors);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"es0QE":[function(require,module,exports) {
/**
 * Generate a list of every possible transform key.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "transformPropOrder", ()=>transformPropOrder);
parcelHelpers.export(exports, "transformProps", ()=>transformProps);
const transformPropOrder = [
    "transformPerspective",
    "x",
    "y",
    "z",
    "translateX",
    "translateY",
    "translateZ",
    "scale",
    "scaleX",
    "scaleY",
    "rotate",
    "rotateX",
    "rotateY",
    "rotateZ",
    "skew",
    "skewX",
    "skewY"
];
/**
 * A quick lookup for transform props.
 */ const transformProps = new Set(transformPropOrder);

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2kZP7":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isMotionValue", ()=>isMotionValue);
const isMotionValue = (value)=>Boolean(value && value.getVelocity);

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"3JcOY":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "buildHTMLStyles", ()=>buildHTMLStyles);
var _buildTransformMjs = require("./build-transform.mjs");
var _isCssVariableMjs = require("../../dom/utils/is-css-variable.mjs");
var _transformMjs = require("./transform.mjs");
var _getAsTypeMjs = require("../../dom/value-types/get-as-type.mjs");
var _numberMjs = require("../../dom/value-types/number.mjs");
function buildHTMLStyles(state, latestValues, options, transformTemplate) {
    const { style, vars, transform, transformOrigin } = state;
    // Track whether we encounter any transform or transformOrigin values.
    let hasTransform = false;
    let hasTransformOrigin = false;
    // Does the calculated transform essentially equal "none"?
    let transformIsNone = true;
    /**
     * Loop over all our latest animated values and decide whether to handle them
     * as a style or CSS variable.
     *
     * Transforms and transform origins are kept seperately for further processing.
     */ for(const key in latestValues){
        const value = latestValues[key];
        /**
         * If this is a CSS variable we don't do any further processing.
         */ if ((0, _isCssVariableMjs.isCSSVariableName)(key)) {
            vars[key] = value;
            continue;
        }
        // Convert the value to its default value type, ie 0 -> "0px"
        const valueType = (0, _numberMjs.numberValueTypes)[key];
        const valueAsType = (0, _getAsTypeMjs.getValueAsType)(value, valueType);
        if ((0, _transformMjs.transformProps).has(key)) {
            // If this is a transform, flag to enable further transform processing
            hasTransform = true;
            transform[key] = valueAsType;
            // If we already know we have a non-default transform, early return
            if (!transformIsNone) continue;
            // Otherwise check to see if this is a default transform
            if (value !== (valueType.default || 0)) transformIsNone = false;
        } else if (key.startsWith("origin")) {
            // If this is a transform origin, flag and enable further transform-origin processing
            hasTransformOrigin = true;
            transformOrigin[key] = valueAsType;
        } else style[key] = valueAsType;
    }
    if (!latestValues.transform) {
        if (hasTransform || transformTemplate) style.transform = (0, _buildTransformMjs.buildTransform)(state.transform, options, transformIsNone, transformTemplate);
        else if (style.transform) /**
             * If we have previously created a transform but currently don't have any,
             * reset transform style to none.
             */ style.transform = "none";
    }
    /**
     * Build a transformOrigin style. Uses the same defaults as the browser for
     * undefined origins.
     */ if (hasTransformOrigin) {
        const { originX = "50%", originY = "50%", originZ = 0 } = transformOrigin;
        style.transformOrigin = `${originX} ${originY} ${originZ}`;
    }
}

},{"./build-transform.mjs":"jHo4I","../../dom/utils/is-css-variable.mjs":"58wqN","./transform.mjs":"es0QE","../../dom/value-types/get-as-type.mjs":"9zJP1","../../dom/value-types/number.mjs":"fQqUe","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"jHo4I":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "buildTransform", ()=>buildTransform);
var _transformMjs = require("./transform.mjs");
const translateAlias = {
    x: "translateX",
    y: "translateY",
    z: "translateZ",
    transformPerspective: "perspective"
};
const numTransforms = (0, _transformMjs.transformPropOrder).length;
/**
 * Build a CSS transform style from individual x/y/scale etc properties.
 *
 * This outputs with a default order of transforms/scales/rotations, this can be customised by
 * providing a transformTemplate function.
 */ function buildTransform(transform, { enableHardwareAcceleration = true, allowTransformNone = true }, transformIsDefault, transformTemplate) {
    // The transform string we're going to build into.
    let transformString = "";
    /**
     * Loop over all possible transforms in order, adding the ones that
     * are present to the transform string.
     */ for(let i = 0; i < numTransforms; i++){
        const key = (0, _transformMjs.transformPropOrder)[i];
        if (transform[key] !== undefined) {
            const transformName = translateAlias[key] || key;
            transformString += `${transformName}(${transform[key]}) `;
        }
    }
    if (enableHardwareAcceleration && !transform.z) transformString += "translateZ(0)";
    transformString = transformString.trim();
    // If we have a custom `transform` template, pass our transform values and
    // generated transformString to that before returning
    if (transformTemplate) transformString = transformTemplate(transform, transformIsDefault ? "" : transformString);
    else if (allowTransformNone && transformIsDefault) transformString = "none";
    return transformString;
}

},{"./transform.mjs":"es0QE","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"58wqN":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "cssVariableRegex", ()=>cssVariableRegex);
parcelHelpers.export(exports, "isCSSVariableName", ()=>isCSSVariableName);
parcelHelpers.export(exports, "isCSSVariableToken", ()=>isCSSVariableToken);
const checkStringStartsWith = (token)=>(key)=>typeof key === "string" && key.startsWith(token);
const isCSSVariableName = checkStringStartsWith("--");
const isCSSVariableToken = checkStringStartsWith("var(--");
const cssVariableRegex = /var\s*\(\s*--[\w-]+(\s*,\s*(?:(?:[^)(]|\((?:[^)(]+|\([^)(]*\))*\))*)+)?\s*\)/g;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9zJP1":[function(require,module,exports) {
/**
 * Provided a value and a ValueType, returns the value as that value type.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getValueAsType", ()=>getValueAsType);
const getValueAsType = (value, type)=>{
    return type && typeof value === "number" ? type.transform(value) : value;
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"fQqUe":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "numberValueTypes", ()=>numberValueTypes);
var _indexMjs = require("../../../value/types/numbers/index.mjs");
var _unitsMjs = require("../../../value/types/numbers/units.mjs");
var _typeIntMjs = require("./type-int.mjs");
const numberValueTypes = {
    // Border props
    borderWidth: (0, _unitsMjs.px),
    borderTopWidth: (0, _unitsMjs.px),
    borderRightWidth: (0, _unitsMjs.px),
    borderBottomWidth: (0, _unitsMjs.px),
    borderLeftWidth: (0, _unitsMjs.px),
    borderRadius: (0, _unitsMjs.px),
    radius: (0, _unitsMjs.px),
    borderTopLeftRadius: (0, _unitsMjs.px),
    borderTopRightRadius: (0, _unitsMjs.px),
    borderBottomRightRadius: (0, _unitsMjs.px),
    borderBottomLeftRadius: (0, _unitsMjs.px),
    // Positioning props
    width: (0, _unitsMjs.px),
    maxWidth: (0, _unitsMjs.px),
    height: (0, _unitsMjs.px),
    maxHeight: (0, _unitsMjs.px),
    size: (0, _unitsMjs.px),
    top: (0, _unitsMjs.px),
    right: (0, _unitsMjs.px),
    bottom: (0, _unitsMjs.px),
    left: (0, _unitsMjs.px),
    // Spacing props
    padding: (0, _unitsMjs.px),
    paddingTop: (0, _unitsMjs.px),
    paddingRight: (0, _unitsMjs.px),
    paddingBottom: (0, _unitsMjs.px),
    paddingLeft: (0, _unitsMjs.px),
    margin: (0, _unitsMjs.px),
    marginTop: (0, _unitsMjs.px),
    marginRight: (0, _unitsMjs.px),
    marginBottom: (0, _unitsMjs.px),
    marginLeft: (0, _unitsMjs.px),
    // Transform props
    rotate: (0, _unitsMjs.degrees),
    rotateX: (0, _unitsMjs.degrees),
    rotateY: (0, _unitsMjs.degrees),
    rotateZ: (0, _unitsMjs.degrees),
    scale: (0, _indexMjs.scale),
    scaleX: (0, _indexMjs.scale),
    scaleY: (0, _indexMjs.scale),
    scaleZ: (0, _indexMjs.scale),
    skew: (0, _unitsMjs.degrees),
    skewX: (0, _unitsMjs.degrees),
    skewY: (0, _unitsMjs.degrees),
    distance: (0, _unitsMjs.px),
    translateX: (0, _unitsMjs.px),
    translateY: (0, _unitsMjs.px),
    translateZ: (0, _unitsMjs.px),
    x: (0, _unitsMjs.px),
    y: (0, _unitsMjs.px),
    z: (0, _unitsMjs.px),
    perspective: (0, _unitsMjs.px),
    transformPerspective: (0, _unitsMjs.px),
    opacity: (0, _indexMjs.alpha),
    originX: (0, _unitsMjs.progressPercentage),
    originY: (0, _unitsMjs.progressPercentage),
    originZ: (0, _unitsMjs.px),
    // Misc
    zIndex: (0, _typeIntMjs.int),
    // SVG
    fillOpacity: (0, _indexMjs.alpha),
    strokeOpacity: (0, _indexMjs.alpha),
    numOctaves: (0, _typeIntMjs.int)
};

},{"../../../value/types/numbers/index.mjs":"bcOBd","../../../value/types/numbers/units.mjs":"hGtBr","./type-int.mjs":"gyTzS","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"bcOBd":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "alpha", ()=>alpha);
parcelHelpers.export(exports, "number", ()=>number);
parcelHelpers.export(exports, "scale", ()=>scale);
var _clampMjs = require("../../../utils/clamp.mjs");
const number = {
    test: (v)=>typeof v === "number",
    parse: parseFloat,
    transform: (v)=>v
};
const alpha = {
    ...number,
    transform: (v)=>(0, _clampMjs.clamp)(0, 1, v)
};
const scale = {
    ...number,
    default: 1
};

},{"../../../utils/clamp.mjs":"5mu0r","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"5mu0r":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "clamp", ()=>clamp);
const clamp = (min, max, v)=>Math.min(Math.max(v, min), max);

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"hGtBr":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "degrees", ()=>degrees);
parcelHelpers.export(exports, "percent", ()=>percent);
parcelHelpers.export(exports, "progressPercentage", ()=>progressPercentage);
parcelHelpers.export(exports, "px", ()=>px);
parcelHelpers.export(exports, "vh", ()=>vh);
parcelHelpers.export(exports, "vw", ()=>vw);
var _utilsMjs = require("../utils.mjs");
const createUnitType = (unit)=>({
        test: (v)=>(0, _utilsMjs.isString)(v) && v.endsWith(unit) && v.split(" ").length === 1,
        parse: parseFloat,
        transform: (v)=>`${v}${unit}`
    });
const degrees = createUnitType("deg");
const percent = createUnitType("%");
const px = createUnitType("px");
const vh = createUnitType("vh");
const vw = createUnitType("vw");
const progressPercentage = {
    ...percent,
    parse: (v)=>percent.parse(v) / 100,
    transform: (v)=>percent.transform(v * 100)
};

},{"../utils.mjs":"6nEM8","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"6nEM8":[function(require,module,exports) {
/**
 * TODO: When we move from string as a source of truth to data models
 * everything in this folder should probably be referred to as models vs types
 */ // If this number is a decimal, make it just five decimal places
// to avoid exponents
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "colorRegex", ()=>colorRegex);
parcelHelpers.export(exports, "floatRegex", ()=>floatRegex);
parcelHelpers.export(exports, "isString", ()=>isString);
parcelHelpers.export(exports, "sanitize", ()=>sanitize);
parcelHelpers.export(exports, "singleColorRegex", ()=>singleColorRegex);
const sanitize = (v)=>Math.round(v * 100000) / 100000;
const floatRegex = /(-)?([\d]*\.?[\d])+/g;
const colorRegex = /(#[0-9a-f]{3,8}|(rgb|hsl)a?\((-?[\d\.]+%?[,\s]+){2}(-?[\d\.]+%?)\s*[\,\/]?\s*[\d\.]*%?\))/gi;
const singleColorRegex = /^(#[0-9a-f]{3,8}|(rgb|hsl)a?\((-?[\d\.]+%?[,\s]+){2}(-?[\d\.]+%?)\s*[\,\/]?\s*[\d\.]*%?\))$/i;
function isString(v) {
    return typeof v === "string";
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"gyTzS":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "int", ()=>int);
var _indexMjs = require("../../../value/types/numbers/index.mjs");
const int = {
    ...(0, _indexMjs.number),
    transform: Math.round
};

},{"../../../value/types/numbers/index.mjs":"bcOBd","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"cXDm8":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createHtmlRenderState", ()=>createHtmlRenderState);
const createHtmlRenderState = ()=>({
        style: {},
        transform: {},
        transformOrigin: {},
        vars: {}
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"aziKV":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "filterProps", ()=>filterProps);
parcelHelpers.export(exports, "loadExternalIsValidProp", ()=>loadExternalIsValidProp);
var _validPropMjs = require("../../../motion/utils/valid-prop.mjs");
let shouldForward = (key)=>!(0, _validPropMjs.isValidMotionProp)(key);
function loadExternalIsValidProp(isValidProp) {
    if (!isValidProp) return;
    // Explicitly filter our events
    shouldForward = (key)=>key.startsWith("on") ? !(0, _validPropMjs.isValidMotionProp)(key) : isValidProp(key);
}
/**
 * Emotion and Styled Components both allow users to pass through arbitrary props to their components
 * to dynamically generate CSS. They both use the `@emotion/is-prop-valid` package to determine which
 * of these should be passed to the underlying DOM node.
 *
 * However, when styling a Motion component `styled(motion.div)`, both packages pass through *all* props
 * as it's seen as an arbitrary component rather than a DOM node. Motion only allows arbitrary props
 * passed through the `custom` prop so it doesn't *need* the payload or computational overhead of
 * `@emotion/is-prop-valid`, however to fix this problem we need to use it.
 *
 * By making it an optionalDependency we can offer this functionality only in the situations where it's
 * actually required.
 */ try {
    /**
     * We attempt to import this package but require won't be defined in esm environments, in that case
     * isPropValid will have to be provided via `MotionContext`. In a 6.0.0 this should probably be removed
     * in favour of explicit injection.
     */ loadExternalIsValidProp(require("125f13913be7321c").default);
} catch (_a) {
// We don't need to actually do anything here - the fallback is the existing `isPropValid`.
}
function filterProps(props, isDom, forwardMotionProps) {
    const filteredProps = {};
    for(const key in props){
        /**
         * values is considered a valid prop by Emotion, so if it's present
         * this will be rendered out to the DOM unless explicitly filtered.
         *
         * We check the type as it could be used with the `feColorMatrix`
         * element, which we support.
         */ if (key === "values" && typeof props.values === "object") continue;
        if (shouldForward(key) || forwardMotionProps === true && (0, _validPropMjs.isValidMotionProp)(key) || !isDom && !(0, _validPropMjs.isValidMotionProp)(key) || // If trying to use native HTML drag events, forward drag listeners
        props["draggable"] && key.startsWith("onDrag")) filteredProps[key] = props[key];
    }
    return filteredProps;
}

},{"../../../motion/utils/valid-prop.mjs":"9BUQz","125f13913be7321c":"bT4hD","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9BUQz":[function(require,module,exports) {
/**
 * A list of all valid MotionProps.
 *
 * @privateRemarks
 * This doesn't throw if a `MotionProp` name is missing - it should.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isValidMotionProp", ()=>isValidMotionProp);
const validMotionProps = new Set([
    "animate",
    "exit",
    "variants",
    "initial",
    "style",
    "values",
    "variants",
    "transition",
    "transformTemplate",
    "transformValues",
    "custom",
    "inherit",
    "onBeforeLayoutMeasure",
    "onAnimationStart",
    "onAnimationComplete",
    "onUpdate",
    "onDragStart",
    "onDrag",
    "onDragEnd",
    "onMeasureDragConstraints",
    "onDirectionLock",
    "onDragTransitionEnd",
    "_dragX",
    "_dragY",
    "onHoverStart",
    "onHoverEnd",
    "onViewportEnter",
    "onViewportLeave",
    "globalTapTarget",
    "ignoreStrict",
    "viewport"
]);
/**
 * Check whether a prop name is a valid `MotionProp` key.
 *
 * @param key - Name of the property to check
 * @returns `true` is key is a valid `MotionProp`.
 *
 * @public
 */ function isValidMotionProp(key) {
    return key.startsWith("while") || key.startsWith("drag") && key !== "draggable" || key.startsWith("layout") || key.startsWith("onTap") || key.startsWith("onPan") || key.startsWith("onLayout") || validMotionProps.has(key);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"bT4hD":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _memoize = require("@emotion/memoize");
var _memoizeDefault = parcelHelpers.interopDefault(_memoize);
var reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|download|draggable|encType|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|inert|itemProp|itemScope|itemType|itemID|itemRef|on|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23
var index = (0, _memoizeDefault.default)(function(prop) {
    return reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111 && prop.charCodeAt(1) === 110 && prop.charCodeAt(2) < 91;
});
exports.default = index;

},{"@emotion/memoize":"dvuEJ","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"dvuEJ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function memoize(fn) {
    var cache = {};
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}
exports.default = memoize;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7mOnz":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useSVGProps", ()=>useSVGProps);
var _react = require("react");
var _usePropsMjs = require("../html/use-props.mjs");
var _buildAttrsMjs = require("./utils/build-attrs.mjs");
var _createRenderStateMjs = require("./utils/create-render-state.mjs");
var _isSvgTagMjs = require("./utils/is-svg-tag.mjs");
function useSVGProps(props, visualState, _isStatic, Component) {
    const visualProps = (0, _react.useMemo)(()=>{
        const state = (0, _createRenderStateMjs.createSvgRenderState)();
        (0, _buildAttrsMjs.buildSVGAttrs)(state, visualState, {
            enableHardwareAcceleration: false
        }, (0, _isSvgTagMjs.isSVGTag)(Component), props.transformTemplate);
        return {
            ...state.attrs,
            style: {
                ...state.style
            }
        };
    }, [
        visualState
    ]);
    if (props.style) {
        const rawStyles = {};
        (0, _usePropsMjs.copyRawValuesOnly)(rawStyles, props.style, props);
        visualProps.style = {
            ...rawStyles,
            ...visualProps.style
        };
    }
    return visualProps;
}

},{"react":"6uln9","../html/use-props.mjs":"eKir9","./utils/build-attrs.mjs":"bzDqj","./utils/create-render-state.mjs":"jgAzj","./utils/is-svg-tag.mjs":"7qIqE","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"bzDqj":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "buildSVGAttrs", ()=>buildSVGAttrs);
var _buildStylesMjs = require("../../html/utils/build-styles.mjs");
var _transformOriginMjs = require("./transform-origin.mjs");
var _pathMjs = require("./path.mjs");
/**
 * Build SVG visual attrbutes, like cx and style.transform
 */ function buildSVGAttrs(state, { attrX, attrY, attrScale, originX, originY, pathLength, pathSpacing = 1, pathOffset = 0, // This is object creation, which we try to avoid per-frame.
...latest }, options, isSVGTag, transformTemplate) {
    (0, _buildStylesMjs.buildHTMLStyles)(state, latest, options, transformTemplate);
    /**
     * For svg tags we just want to make sure viewBox is animatable and treat all the styles
     * as normal HTML tags.
     */ if (isSVGTag) {
        if (state.style.viewBox) state.attrs.viewBox = state.style.viewBox;
        return;
    }
    state.attrs = state.style;
    state.style = {};
    const { attrs, style, dimensions } = state;
    /**
     * However, we apply transforms as CSS transforms. So if we detect a transform we take it from attrs
     * and copy it into style.
     */ if (attrs.transform) {
        if (dimensions) style.transform = attrs.transform;
        delete attrs.transform;
    }
    // Parse transformOrigin
    if (dimensions && (originX !== undefined || originY !== undefined || style.transform)) style.transformOrigin = (0, _transformOriginMjs.calcSVGTransformOrigin)(dimensions, originX !== undefined ? originX : 0.5, originY !== undefined ? originY : 0.5);
    // Render attrX/attrY/attrScale as attributes
    if (attrX !== undefined) attrs.x = attrX;
    if (attrY !== undefined) attrs.y = attrY;
    if (attrScale !== undefined) attrs.scale = attrScale;
    // Build SVG path if one has been defined
    if (pathLength !== undefined) (0, _pathMjs.buildSVGPath)(attrs, pathLength, pathSpacing, pathOffset, false);
}

},{"../../html/utils/build-styles.mjs":"3JcOY","./transform-origin.mjs":"lwbn8","./path.mjs":"6lBpV","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"lwbn8":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "calcSVGTransformOrigin", ()=>calcSVGTransformOrigin);
var _unitsMjs = require("../../../value/types/numbers/units.mjs");
function calcOrigin(origin, offset, size) {
    return typeof origin === "string" ? origin : (0, _unitsMjs.px).transform(offset + size * origin);
}
/**
 * The SVG transform origin defaults are different to CSS and is less intuitive,
 * so we use the measured dimensions of the SVG to reconcile these.
 */ function calcSVGTransformOrigin(dimensions, originX, originY) {
    const pxOriginX = calcOrigin(originX, dimensions.x, dimensions.width);
    const pxOriginY = calcOrigin(originY, dimensions.y, dimensions.height);
    return `${pxOriginX} ${pxOriginY}`;
}

},{"../../../value/types/numbers/units.mjs":"hGtBr","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"6lBpV":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "buildSVGPath", ()=>buildSVGPath);
var _unitsMjs = require("../../../value/types/numbers/units.mjs");
const dashKeys = {
    offset: "stroke-dashoffset",
    array: "stroke-dasharray"
};
const camelKeys = {
    offset: "strokeDashoffset",
    array: "strokeDasharray"
};
/**
 * Build SVG path properties. Uses the path's measured length to convert
 * our custom pathLength, pathSpacing and pathOffset into stroke-dashoffset
 * and stroke-dasharray attributes.
 *
 * This function is mutative to reduce per-frame GC.
 */ function buildSVGPath(attrs, length, spacing = 1, offset = 0, useDashCase = true) {
    // Normalise path length by setting SVG attribute pathLength to 1
    attrs.pathLength = 1;
    // We use dash case when setting attributes directly to the DOM node and camel case
    // when defining props on a React component.
    const keys = useDashCase ? dashKeys : camelKeys;
    // Build the dash offset
    attrs[keys.offset] = (0, _unitsMjs.px).transform(-offset);
    // Build the dash array
    const pathLength = (0, _unitsMjs.px).transform(length);
    const pathSpacing = (0, _unitsMjs.px).transform(spacing);
    attrs[keys.array] = `${pathLength} ${pathSpacing}`;
}

},{"../../../value/types/numbers/units.mjs":"hGtBr","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"jgAzj":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createSvgRenderState", ()=>createSvgRenderState);
var _createRenderStateMjs = require("../../html/utils/create-render-state.mjs");
const createSvgRenderState = ()=>({
        ...(0, _createRenderStateMjs.createHtmlRenderState)(),
        attrs: {}
    });

},{"../../html/utils/create-render-state.mjs":"cXDm8","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7qIqE":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isSVGTag", ()=>isSVGTag);
const isSVGTag = (tag)=>typeof tag === "string" && tag.toLowerCase() === "svg";

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"5XVUv":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "svgMotionConfig", ()=>svgMotionConfig);
var _renderMjs = require("./utils/render.mjs");
var _scrapeMotionValuesMjs = require("./utils/scrape-motion-values.mjs");
var _useVisualStateMjs = require("../../motion/utils/use-visual-state.mjs");
var _createRenderStateMjs = require("./utils/create-render-state.mjs");
var _buildAttrsMjs = require("./utils/build-attrs.mjs");
var _isSvgTagMjs = require("./utils/is-svg-tag.mjs");
var _frameMjs = require("../../frameloop/frame.mjs");
const svgMotionConfig = {
    useVisualState: (0, _useVisualStateMjs.makeUseVisualState)({
        scrapeMotionValuesFromProps: (0, _scrapeMotionValuesMjs.scrapeMotionValuesFromProps),
        createRenderState: (0, _createRenderStateMjs.createSvgRenderState),
        onMount: (props, instance, { renderState, latestValues })=>{
            (0, _frameMjs.frame).read(()=>{
                try {
                    renderState.dimensions = typeof instance.getBBox === "function" ? instance.getBBox() : instance.getBoundingClientRect();
                } catch (e) {
                    // Most likely trying to measure an unrendered element under Firefox
                    renderState.dimensions = {
                        x: 0,
                        y: 0,
                        width: 0,
                        height: 0
                    };
                }
            });
            (0, _frameMjs.frame).render(()=>{
                (0, _buildAttrsMjs.buildSVGAttrs)(renderState, latestValues, {
                    enableHardwareAcceleration: false
                }, (0, _isSvgTagMjs.isSVGTag)(instance.tagName), props.transformTemplate);
                (0, _renderMjs.renderSVG)(instance, renderState);
            });
        }
    })
};

},{"./utils/render.mjs":"7rQiG","./utils/scrape-motion-values.mjs":"7vKCJ","../../motion/utils/use-visual-state.mjs":"5FgNd","./utils/create-render-state.mjs":"jgAzj","./utils/build-attrs.mjs":"bzDqj","./utils/is-svg-tag.mjs":"7qIqE","../../frameloop/frame.mjs":"gdRIq","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7rQiG":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "renderSVG", ()=>renderSVG);
var _camelToDashMjs = require("../../dom/utils/camel-to-dash.mjs");
var _renderMjs = require("../../html/utils/render.mjs");
var _camelCaseAttrsMjs = require("./camel-case-attrs.mjs");
function renderSVG(element, renderState, _styleProp, projection) {
    (0, _renderMjs.renderHTML)(element, renderState, undefined, projection);
    for(const key in renderState.attrs)element.setAttribute(!(0, _camelCaseAttrsMjs.camelCaseAttributes).has(key) ? (0, _camelToDashMjs.camelToDash)(key) : key, renderState.attrs[key]);
}

},{"../../dom/utils/camel-to-dash.mjs":"kNuZz","../../html/utils/render.mjs":"6SuGI","./camel-case-attrs.mjs":"jpeUe","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"6SuGI":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "renderHTML", ()=>renderHTML);
function renderHTML(element, { style, vars }, styleProp, projection) {
    Object.assign(element.style, style, projection && projection.getProjectionStyles(styleProp));
    // Loop over any CSS variables and assign those.
    for(const key in vars)element.style.setProperty(key, vars[key]);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"jpeUe":[function(require,module,exports) {
/**
 * A set of attribute names that are always read/written as camel case.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "camelCaseAttributes", ()=>camelCaseAttributes);
const camelCaseAttributes = new Set([
    "baseFrequency",
    "diffuseConstant",
    "kernelMatrix",
    "kernelUnitLength",
    "keySplines",
    "keyTimes",
    "limitingConeAngle",
    "markerHeight",
    "markerWidth",
    "numOctaves",
    "targetX",
    "targetY",
    "surfaceScale",
    "specularConstant",
    "specularExponent",
    "stdDeviation",
    "tableValues",
    "viewBox",
    "gradientTransform",
    "pathLength",
    "startOffset",
    "textLength",
    "lengthAdjust"
]);

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7vKCJ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "scrapeMotionValuesFromProps", ()=>scrapeMotionValuesFromProps);
var _isMotionValueMjs = require("../../../value/utils/is-motion-value.mjs");
var _scrapeMotionValuesMjs = require("../../html/utils/scrape-motion-values.mjs");
var _transformMjs = require("../../html/utils/transform.mjs");
function scrapeMotionValuesFromProps(props, prevProps) {
    const newValues = (0, _scrapeMotionValuesMjs.scrapeMotionValuesFromProps)(props, prevProps);
    for(const key in props)if ((0, _isMotionValueMjs.isMotionValue)(props[key]) || (0, _isMotionValueMjs.isMotionValue)(prevProps[key])) {
        const targetKey = (0, _transformMjs.transformPropOrder).indexOf(key) !== -1 ? "attr" + key.charAt(0).toUpperCase() + key.substring(1) : key;
        newValues[targetKey] = props[key];
    }
    return newValues;
}

},{"../../../value/utils/is-motion-value.mjs":"2kZP7","../../html/utils/scrape-motion-values.mjs":"irGuL","../../html/utils/transform.mjs":"es0QE","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"irGuL":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "scrapeMotionValuesFromProps", ()=>scrapeMotionValuesFromProps);
var _isForcedMotionValueMjs = require("../../../motion/utils/is-forced-motion-value.mjs");
var _isMotionValueMjs = require("../../../value/utils/is-motion-value.mjs");
function scrapeMotionValuesFromProps(props, prevProps) {
    const { style } = props;
    const newValues = {};
    for(const key in style)if ((0, _isMotionValueMjs.isMotionValue)(style[key]) || prevProps.style && (0, _isMotionValueMjs.isMotionValue)(prevProps.style[key]) || (0, _isForcedMotionValueMjs.isForcedMotionValue)(key, props)) newValues[key] = style[key];
    return newValues;
}

},{"../../../motion/utils/is-forced-motion-value.mjs":"c7w2E","../../../value/utils/is-motion-value.mjs":"2kZP7","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"5FgNd":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "makeUseVisualState", ()=>makeUseVisualState);
var _react = require("react");
var _isAnimationControlsMjs = require("../../animation/utils/is-animation-controls.mjs");
var _presenceContextMjs = require("../../context/PresenceContext.mjs");
var _resolveVariantsMjs = require("../../render/utils/resolve-variants.mjs");
var _useConstantMjs = require("../../utils/use-constant.mjs");
var _resolveMotionValueMjs = require("../../value/utils/resolve-motion-value.mjs");
var _indexMjs = require("../../context/MotionContext/index.mjs");
var _isControllingVariantsMjs = require("../../render/utils/is-controlling-variants.mjs");
function makeState({ scrapeMotionValuesFromProps, createRenderState, onMount }, props, context, presenceContext) {
    const state = {
        latestValues: makeLatestValues(props, context, presenceContext, scrapeMotionValuesFromProps),
        renderState: createRenderState()
    };
    if (onMount) state.mount = (instance)=>onMount(props, instance, state);
    return state;
}
const makeUseVisualState = (config)=>(props, isStatic)=>{
        const context = (0, _react.useContext)((0, _indexMjs.MotionContext));
        const presenceContext = (0, _react.useContext)((0, _presenceContextMjs.PresenceContext));
        const make = ()=>makeState(config, props, context, presenceContext);
        return isStatic ? make() : (0, _useConstantMjs.useConstant)(make);
    };
function makeLatestValues(props, context, presenceContext, scrapeMotionValues) {
    const values = {};
    const motionValues = scrapeMotionValues(props, {});
    for(const key in motionValues)values[key] = (0, _resolveMotionValueMjs.resolveMotionValue)(motionValues[key]);
    let { initial, animate } = props;
    const isControllingVariants$1 = (0, _isControllingVariantsMjs.isControllingVariants)(props);
    const isVariantNode$1 = (0, _isControllingVariantsMjs.isVariantNode)(props);
    if (context && isVariantNode$1 && !isControllingVariants$1 && props.inherit !== false) {
        if (initial === undefined) initial = context.initial;
        if (animate === undefined) animate = context.animate;
    }
    let isInitialAnimationBlocked = presenceContext ? presenceContext.initial === false : false;
    isInitialAnimationBlocked = isInitialAnimationBlocked || initial === false;
    const variantToSet = isInitialAnimationBlocked ? animate : initial;
    if (variantToSet && typeof variantToSet !== "boolean" && !(0, _isAnimationControlsMjs.isAnimationControls)(variantToSet)) {
        const list = Array.isArray(variantToSet) ? variantToSet : [
            variantToSet
        ];
        list.forEach((definition)=>{
            const resolved = (0, _resolveVariantsMjs.resolveVariantFromProps)(props, definition);
            if (!resolved) return;
            const { transitionEnd, transition, ...target } = resolved;
            for(const key in target){
                let valueTarget = target[key];
                if (Array.isArray(valueTarget)) {
                    /**
                     * Take final keyframe if the initial animation is blocked because
                     * we want to initialise at the end of that blocked animation.
                     */ const index = isInitialAnimationBlocked ? valueTarget.length - 1 : 0;
                    valueTarget = valueTarget[index];
                }
                if (valueTarget !== null) values[key] = valueTarget;
            }
            for(const key in transitionEnd)values[key] = transitionEnd[key];
        });
    }
    return values;
}

},{"react":"6uln9","../../animation/utils/is-animation-controls.mjs":"fDSp3","../../context/PresenceContext.mjs":"dcXf9","../../render/utils/resolve-variants.mjs":"iR2sd","../../utils/use-constant.mjs":"7bpoo","../../value/utils/resolve-motion-value.mjs":"3pwN1","../../context/MotionContext/index.mjs":"7Mlzo","../../render/utils/is-controlling-variants.mjs":"tz7Ig","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"iR2sd":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "resolveVariantFromProps", ()=>resolveVariantFromProps);
function resolveVariantFromProps(props, definition, custom, currentValues = {}, currentVelocity = {}) {
    /**
     * If the variant definition is a function, resolve.
     */ if (typeof definition === "function") definition = definition(custom !== undefined ? custom : props.custom, currentValues, currentVelocity);
    /**
     * If the variant definition is a variant label, or
     * the function returned a variant label, resolve.
     */ if (typeof definition === "string") definition = props.variants && props.variants[definition];
    /**
     * At this point we've resolved both functions and variant labels,
     * but the resolved variant label might itself have been a function.
     * If so, resolve. This can only have returned a valid target object.
     */ if (typeof definition === "function") definition = definition(custom !== undefined ? custom : props.custom, currentValues, currentVelocity);
    return definition;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7bpoo":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useConstant", ()=>useConstant);
var _react = require("react");
/**
 * Creates a constant value over the lifecycle of a component.
 *
 * Even if `useMemo` is provided an empty array as its final argument, it doesn't offer
 * a guarantee that it won't re-run for performance reasons later on. By using `useConstant`
 * you can ensure that initialisers don't execute twice or more.
 */ function useConstant(init) {
    const ref = (0, _react.useRef)(null);
    if (ref.current === null) ref.current = init();
    return ref.current;
}

},{"react":"6uln9","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"3pwN1":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "resolveMotionValue", ()=>resolveMotionValue);
var _resolveValueMjs = require("../../utils/resolve-value.mjs");
var _isMotionValueMjs = require("./is-motion-value.mjs");
/**
 * If the provided value is a MotionValue, this returns the actual value, otherwise just the value itself
 *
 * TODO: Remove and move to library
 */ function resolveMotionValue(value) {
    const unwrappedValue = (0, _isMotionValueMjs.isMotionValue)(value) ? value.get() : value;
    return (0, _resolveValueMjs.isCustomValue)(unwrappedValue) ? unwrappedValue.toValue() : unwrappedValue;
}

},{"../../utils/resolve-value.mjs":"b1tRE","./is-motion-value.mjs":"2kZP7","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"b1tRE":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isCustomValue", ()=>isCustomValue);
parcelHelpers.export(exports, "resolveFinalValueInKeyframes", ()=>resolveFinalValueInKeyframes);
var _isKeyframesTargetMjs = require("../animation/utils/is-keyframes-target.mjs");
const isCustomValue = (v)=>{
    return Boolean(v && typeof v === "object" && v.mix && v.toValue);
};
const resolveFinalValueInKeyframes = (v)=>{
    // TODO maybe throw if v.length - 1 is placeholder token?
    return (0, _isKeyframesTargetMjs.isKeyframesTarget)(v) ? v[v.length - 1] || 0 : v;
};

},{"../animation/utils/is-keyframes-target.mjs":"b9ZPA","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"b9ZPA":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isKeyframesTarget", ()=>isKeyframesTarget);
const isKeyframesTarget = (v)=>{
    return Array.isArray(v);
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"gdRIq":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "cancelFrame", ()=>cancelFrame);
parcelHelpers.export(exports, "frame", ()=>frame);
parcelHelpers.export(exports, "frameData", ()=>frameData);
parcelHelpers.export(exports, "steps", ()=>steps);
var _noopMjs = require("../utils/noop.mjs");
var _batcherMjs = require("./batcher.mjs");
const { schedule: frame, cancel: cancelFrame, state: frameData, steps } = (0, _batcherMjs.createRenderBatcher)(typeof requestAnimationFrame !== "undefined" ? requestAnimationFrame : (0, _noopMjs.noop), true);

},{"../utils/noop.mjs":"7roqC","./batcher.mjs":"6RYsY","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7roqC":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "noop", ()=>noop);
const noop = (any)=>any;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"6RYsY":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createRenderBatcher", ()=>createRenderBatcher);
parcelHelpers.export(exports, "stepsOrder", ()=>stepsOrder);
var _renderStepMjs = require("./render-step.mjs");
const stepsOrder = [
    "prepare",
    "read",
    "update",
    "preRender",
    "render",
    "postRender"
];
const maxElapsed = 40;
function createRenderBatcher(scheduleNextBatch, allowKeepAlive) {
    let runNextFrame = false;
    let useDefaultElapsed = true;
    const state = {
        delta: 0,
        timestamp: 0,
        isProcessing: false
    };
    const steps = stepsOrder.reduce((acc, key)=>{
        acc[key] = (0, _renderStepMjs.createRenderStep)(()=>runNextFrame = true);
        return acc;
    }, {});
    const processStep = (stepId)=>steps[stepId].process(state);
    const processBatch = ()=>{
        const timestamp = performance.now();
        runNextFrame = false;
        state.delta = useDefaultElapsed ? 1000 / 60 : Math.max(Math.min(timestamp - state.timestamp, maxElapsed), 1);
        state.timestamp = timestamp;
        state.isProcessing = true;
        stepsOrder.forEach(processStep);
        state.isProcessing = false;
        if (runNextFrame && allowKeepAlive) {
            useDefaultElapsed = false;
            scheduleNextBatch(processBatch);
        }
    };
    const wake = ()=>{
        runNextFrame = true;
        useDefaultElapsed = true;
        if (!state.isProcessing) scheduleNextBatch(processBatch);
    };
    const schedule = stepsOrder.reduce((acc, key)=>{
        const step = steps[key];
        acc[key] = (process, keepAlive = false, immediate = false)=>{
            if (!runNextFrame) wake();
            return step.schedule(process, keepAlive, immediate);
        };
        return acc;
    }, {});
    const cancel = (process)=>stepsOrder.forEach((key)=>steps[key].cancel(process));
    return {
        schedule,
        cancel,
        state,
        steps
    };
}

},{"./render-step.mjs":"1KqZO","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"1KqZO":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createRenderStep", ()=>createRenderStep);
class Queue {
    constructor(){
        this.order = [];
        this.scheduled = new Set();
    }
    add(process) {
        if (!this.scheduled.has(process)) {
            this.scheduled.add(process);
            this.order.push(process);
            return true;
        }
    }
    remove(process) {
        const index = this.order.indexOf(process);
        if (index !== -1) {
            this.order.splice(index, 1);
            this.scheduled.delete(process);
        }
    }
    clear() {
        this.order.length = 0;
        this.scheduled.clear();
    }
}
function createRenderStep(runNextFrame) {
    /**
     * We create and reuse two queues, one to queue jobs for the current frame
     * and one for the next. We reuse to avoid triggering GC after x frames.
     */ let thisFrame = new Queue();
    let nextFrame = new Queue();
    let numToRun = 0;
    /**
     * Track whether we're currently processing jobs in this step. This way
     * we can decide whether to schedule new jobs for this frame or next.
     */ let isProcessing = false;
    let flushNextFrame = false;
    /**
     * A set of processes which were marked keepAlive when scheduled.
     */ const toKeepAlive = new WeakSet();
    const step = {
        /**
         * Schedule a process to run on the next frame.
         */ schedule: (callback, keepAlive = false, immediate = false)=>{
            const addToCurrentFrame = immediate && isProcessing;
            const queue = addToCurrentFrame ? thisFrame : nextFrame;
            if (keepAlive) toKeepAlive.add(callback);
            if (queue.add(callback) && addToCurrentFrame && isProcessing) // If we're adding it to the currently running queue, update its measured size
            numToRun = thisFrame.order.length;
            return callback;
        },
        /**
         * Cancel the provided callback from running on the next frame.
         */ cancel: (callback)=>{
            nextFrame.remove(callback);
            toKeepAlive.delete(callback);
        },
        /**
         * Execute all schedule callbacks.
         */ process: (frameData)=>{
            /**
             * If we're already processing we've probably been triggered by a flushSync
             * inside an existing process. Instead of executing, mark flushNextFrame
             * as true and ensure we flush the following frame at the end of this one.
             */ if (isProcessing) {
                flushNextFrame = true;
                return;
            }
            isProcessing = true;
            [thisFrame, nextFrame] = [
                nextFrame,
                thisFrame
            ];
            // Clear the next frame queue
            nextFrame.clear();
            // Execute this frame
            numToRun = thisFrame.order.length;
            if (numToRun) for(let i = 0; i < numToRun; i++){
                const callback = thisFrame.order[i];
                callback(frameData);
                if (toKeepAlive.has(callback)) {
                    step.schedule(callback);
                    runNextFrame();
                }
            }
            isProcessing = false;
            if (flushNextFrame) {
                flushNextFrame = false;
                step.process(frameData);
            }
        }
    };
    return step;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"3omuU":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "htmlMotionConfig", ()=>htmlMotionConfig);
var _useVisualStateMjs = require("../../motion/utils/use-visual-state.mjs");
var _scrapeMotionValuesMjs = require("./utils/scrape-motion-values.mjs");
var _createRenderStateMjs = require("./utils/create-render-state.mjs");
const htmlMotionConfig = {
    useVisualState: (0, _useVisualStateMjs.makeUseVisualState)({
        scrapeMotionValuesFromProps: (0, _scrapeMotionValuesMjs.scrapeMotionValuesFromProps),
        createRenderState: (0, _createRenderStateMjs.createHtmlRenderState)
    })
};

},{"../../motion/utils/use-visual-state.mjs":"5FgNd","./utils/scrape-motion-values.mjs":"irGuL","./utils/create-render-state.mjs":"cXDm8","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7BuHh":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "gestureAnimations", ()=>gestureAnimations);
var _hoverMjs = require("../../gestures/hover.mjs");
var _focusMjs = require("../../gestures/focus.mjs");
var _pressMjs = require("../../gestures/press.mjs");
var _indexMjs = require("./viewport/index.mjs");
const gestureAnimations = {
    inView: {
        Feature: (0, _indexMjs.InViewFeature)
    },
    tap: {
        Feature: (0, _pressMjs.PressGesture)
    },
    focus: {
        Feature: (0, _focusMjs.FocusGesture)
    },
    hover: {
        Feature: (0, _hoverMjs.HoverGesture)
    }
};

},{"../../gestures/hover.mjs":"lRuoN","../../gestures/focus.mjs":"9SVEI","../../gestures/press.mjs":"aEl6F","./viewport/index.mjs":"b9A3a","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"lRuoN":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "HoverGesture", ()=>HoverGesture);
var _addPointerEventMjs = require("../events/add-pointer-event.mjs");
var _pipeMjs = require("../utils/pipe.mjs");
var _lockMjs = require("./drag/utils/lock.mjs");
var _featureMjs = require("../motion/features/Feature.mjs");
var _frameMjs = require("../frameloop/frame.mjs");
function addHoverEvent(node, isActive) {
    const eventName = "pointer" + (isActive ? "enter" : "leave");
    const callbackName = "onHover" + (isActive ? "Start" : "End");
    const handleEvent = (event, info)=>{
        if (event.pointerType === "touch" || (0, _lockMjs.isDragActive)()) return;
        const props = node.getProps();
        if (node.animationState && props.whileHover) node.animationState.setActive("whileHover", isActive);
        if (props[callbackName]) (0, _frameMjs.frame).update(()=>props[callbackName](event, info));
    };
    return (0, _addPointerEventMjs.addPointerEvent)(node.current, eventName, handleEvent, {
        passive: !node.getProps()[callbackName]
    });
}
class HoverGesture extends (0, _featureMjs.Feature) {
    mount() {
        this.unmount = (0, _pipeMjs.pipe)(addHoverEvent(this.node, true), addHoverEvent(this.node, false));
    }
    unmount() {}
}

},{"../events/add-pointer-event.mjs":"k9O8P","../utils/pipe.mjs":"jSVi0","./drag/utils/lock.mjs":"1quJ1","../motion/features/Feature.mjs":"9q59Z","../frameloop/frame.mjs":"gdRIq","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"k9O8P":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "addPointerEvent", ()=>addPointerEvent);
var _addDomEventMjs = require("./add-dom-event.mjs");
var _eventInfoMjs = require("./event-info.mjs");
function addPointerEvent(target, eventName, handler, options) {
    return (0, _addDomEventMjs.addDomEvent)(target, eventName, (0, _eventInfoMjs.addPointerInfo)(handler), options);
}

},{"./add-dom-event.mjs":"82u3S","./event-info.mjs":"8dFDB","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"82u3S":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "addDomEvent", ()=>addDomEvent);
function addDomEvent(target, eventName, handler, options = {
    passive: true
}) {
    target.addEventListener(eventName, handler, options);
    return ()=>target.removeEventListener(eventName, handler);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8dFDB":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "addPointerInfo", ()=>addPointerInfo);
parcelHelpers.export(exports, "extractEventInfo", ()=>extractEventInfo);
var _isPrimaryPointerMjs = require("./utils/is-primary-pointer.mjs");
function extractEventInfo(event, pointType = "page") {
    return {
        point: {
            x: event[pointType + "X"],
            y: event[pointType + "Y"]
        }
    };
}
const addPointerInfo = (handler)=>{
    return (event)=>(0, _isPrimaryPointerMjs.isPrimaryPointer)(event) && handler(event, extractEventInfo(event));
};

},{"./utils/is-primary-pointer.mjs":"3NzBE","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"3NzBE":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isPrimaryPointer", ()=>isPrimaryPointer);
const isPrimaryPointer = (event)=>{
    if (event.pointerType === "mouse") return typeof event.button !== "number" || event.button <= 0;
    else /**
         * isPrimary is true for all mice buttons, whereas every touch point
         * is regarded as its own input. So subsequent concurrent touch points
         * will be false.
         *
         * Specifically match against false here as incomplete versions of
         * PointerEvents in very old browser might have it set as undefined.
         */ return event.isPrimary !== false;
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"jSVi0":[function(require,module,exports) {
/**
 * Pipe
 * Compose other transformers to run linearily
 * pipe(min(20), max(40))
 * @param  {...functions} transformers
 * @return {function}
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "pipe", ()=>pipe);
const combineFunctions = (a, b)=>(v)=>b(a(v));
const pipe = (...transformers)=>transformers.reduce(combineFunctions);

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"1quJ1":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createLock", ()=>createLock);
parcelHelpers.export(exports, "getGlobalLock", ()=>getGlobalLock);
parcelHelpers.export(exports, "isDragActive", ()=>isDragActive);
function createLock(name) {
    let lock = null;
    return ()=>{
        const openLock = ()=>{
            lock = null;
        };
        if (lock === null) {
            lock = name;
            return openLock;
        }
        return false;
    };
}
const globalHorizontalLock = createLock("dragHorizontal");
const globalVerticalLock = createLock("dragVertical");
function getGlobalLock(drag) {
    let lock = false;
    if (drag === "y") lock = globalVerticalLock();
    else if (drag === "x") lock = globalHorizontalLock();
    else {
        const openHorizontal = globalHorizontalLock();
        const openVertical = globalVerticalLock();
        if (openHorizontal && openVertical) lock = ()=>{
            openHorizontal();
            openVertical();
        };
        else {
            // Release the locks because we don't use them
            if (openHorizontal) openHorizontal();
            if (openVertical) openVertical();
        }
    }
    return lock;
}
function isDragActive() {
    // Check the gesture lock - if we get it, it means no drag gesture is active
    // and we can safely fire the tap gesture.
    const openGestureLock = getGlobalLock(true);
    if (!openGestureLock) return true;
    openGestureLock();
    return false;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9q59Z":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Feature", ()=>Feature);
class Feature {
    constructor(node){
        this.isMounted = false;
        this.node = node;
    }
    update() {}
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9SVEI":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "FocusGesture", ()=>FocusGesture);
var _addDomEventMjs = require("../events/add-dom-event.mjs");
var _featureMjs = require("../motion/features/Feature.mjs");
var _pipeMjs = require("../utils/pipe.mjs");
class FocusGesture extends (0, _featureMjs.Feature) {
    constructor(){
        super(...arguments);
        this.isActive = false;
    }
    onFocus() {
        let isFocusVisible = false;
        /**
         * If this element doesn't match focus-visible then don't
         * apply whileHover. But, if matches throws that focus-visible
         * is not a valid selector then in that browser outline styles will be applied
         * to the element by default and we want to match that behaviour with whileFocus.
         */ try {
            isFocusVisible = this.node.current.matches(":focus-visible");
        } catch (e) {
            isFocusVisible = true;
        }
        if (!isFocusVisible || !this.node.animationState) return;
        this.node.animationState.setActive("whileFocus", true);
        this.isActive = true;
    }
    onBlur() {
        if (!this.isActive || !this.node.animationState) return;
        this.node.animationState.setActive("whileFocus", false);
        this.isActive = false;
    }
    mount() {
        this.unmount = (0, _pipeMjs.pipe)((0, _addDomEventMjs.addDomEvent)(this.node.current, "focus", ()=>this.onFocus()), (0, _addDomEventMjs.addDomEvent)(this.node.current, "blur", ()=>this.onBlur()));
    }
    unmount() {}
}

},{"../events/add-dom-event.mjs":"82u3S","../motion/features/Feature.mjs":"9q59Z","../utils/pipe.mjs":"jSVi0","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"aEl6F":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PressGesture", ()=>PressGesture);
var _eventInfoMjs = require("../events/event-info.mjs");
var _addDomEventMjs = require("../events/add-dom-event.mjs");
var _addPointerEventMjs = require("../events/add-pointer-event.mjs");
var _featureMjs = require("../motion/features/Feature.mjs");
var _pipeMjs = require("../utils/pipe.mjs");
var _lockMjs = require("./drag/utils/lock.mjs");
var _isNodeOrChildMjs = require("./utils/is-node-or-child.mjs");
var _noopMjs = require("../utils/noop.mjs");
var _frameMjs = require("../frameloop/frame.mjs");
function fireSyntheticPointerEvent(name, handler) {
    if (!handler) return;
    const syntheticPointerEvent = new PointerEvent("pointer" + name);
    handler(syntheticPointerEvent, (0, _eventInfoMjs.extractEventInfo)(syntheticPointerEvent));
}
class PressGesture extends (0, _featureMjs.Feature) {
    constructor(){
        super(...arguments);
        this.removeStartListeners = (0, _noopMjs.noop);
        this.removeEndListeners = (0, _noopMjs.noop);
        this.removeAccessibleListeners = (0, _noopMjs.noop);
        this.startPointerPress = (startEvent, startInfo)=>{
            if (this.isPressing) return;
            this.removeEndListeners();
            const props = this.node.getProps();
            const endPointerPress = (endEvent, endInfo)=>{
                if (!this.checkPressEnd()) return;
                const { onTap, onTapCancel, globalTapTarget } = this.node.getProps();
                (0, _frameMjs.frame).update(()=>{
                    /**
                     * We only count this as a tap gesture if the event.target is the same
                     * as, or a child of, this component's element
                     */ !globalTapTarget && !(0, _isNodeOrChildMjs.isNodeOrChild)(this.node.current, endEvent.target) ? onTapCancel && onTapCancel(endEvent, endInfo) : onTap && onTap(endEvent, endInfo);
                });
            };
            const removePointerUpListener = (0, _addPointerEventMjs.addPointerEvent)(window, "pointerup", endPointerPress, {
                passive: !(props.onTap || props["onPointerUp"])
            });
            const removePointerCancelListener = (0, _addPointerEventMjs.addPointerEvent)(window, "pointercancel", (cancelEvent, cancelInfo)=>this.cancelPress(cancelEvent, cancelInfo), {
                passive: !(props.onTapCancel || props["onPointerCancel"])
            });
            this.removeEndListeners = (0, _pipeMjs.pipe)(removePointerUpListener, removePointerCancelListener);
            this.startPress(startEvent, startInfo);
        };
        this.startAccessiblePress = ()=>{
            const handleKeydown = (keydownEvent)=>{
                if (keydownEvent.key !== "Enter" || this.isPressing) return;
                const handleKeyup = (keyupEvent)=>{
                    if (keyupEvent.key !== "Enter" || !this.checkPressEnd()) return;
                    fireSyntheticPointerEvent("up", (event, info)=>{
                        const { onTap } = this.node.getProps();
                        if (onTap) (0, _frameMjs.frame).update(()=>onTap(event, info));
                    });
                };
                this.removeEndListeners();
                this.removeEndListeners = (0, _addDomEventMjs.addDomEvent)(this.node.current, "keyup", handleKeyup);
                fireSyntheticPointerEvent("down", (event, info)=>{
                    this.startPress(event, info);
                });
            };
            const removeKeydownListener = (0, _addDomEventMjs.addDomEvent)(this.node.current, "keydown", handleKeydown);
            const handleBlur = ()=>{
                if (!this.isPressing) return;
                fireSyntheticPointerEvent("cancel", (cancelEvent, cancelInfo)=>this.cancelPress(cancelEvent, cancelInfo));
            };
            const removeBlurListener = (0, _addDomEventMjs.addDomEvent)(this.node.current, "blur", handleBlur);
            this.removeAccessibleListeners = (0, _pipeMjs.pipe)(removeKeydownListener, removeBlurListener);
        };
    }
    startPress(event, info) {
        this.isPressing = true;
        const { onTapStart, whileTap } = this.node.getProps();
        /**
         * Ensure we trigger animations before firing event callback
         */ if (whileTap && this.node.animationState) this.node.animationState.setActive("whileTap", true);
        if (onTapStart) (0, _frameMjs.frame).update(()=>onTapStart(event, info));
    }
    checkPressEnd() {
        this.removeEndListeners();
        this.isPressing = false;
        const props = this.node.getProps();
        if (props.whileTap && this.node.animationState) this.node.animationState.setActive("whileTap", false);
        return !(0, _lockMjs.isDragActive)();
    }
    cancelPress(event, info) {
        if (!this.checkPressEnd()) return;
        const { onTapCancel } = this.node.getProps();
        if (onTapCancel) (0, _frameMjs.frame).update(()=>onTapCancel(event, info));
    }
    mount() {
        const props = this.node.getProps();
        const removePointerListener = (0, _addPointerEventMjs.addPointerEvent)(props.globalTapTarget ? window : this.node.current, "pointerdown", this.startPointerPress, {
            passive: !(props.onTapStart || props["onPointerStart"])
        });
        const removeFocusListener = (0, _addDomEventMjs.addDomEvent)(this.node.current, "focus", this.startAccessiblePress);
        this.removeStartListeners = (0, _pipeMjs.pipe)(removePointerListener, removeFocusListener);
    }
    unmount() {
        this.removeStartListeners();
        this.removeEndListeners();
        this.removeAccessibleListeners();
    }
}

},{"../events/event-info.mjs":"8dFDB","../events/add-dom-event.mjs":"82u3S","../events/add-pointer-event.mjs":"k9O8P","../motion/features/Feature.mjs":"9q59Z","../utils/pipe.mjs":"jSVi0","./drag/utils/lock.mjs":"1quJ1","./utils/is-node-or-child.mjs":"55hTM","../utils/noop.mjs":"7roqC","../frameloop/frame.mjs":"gdRIq","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"55hTM":[function(require,module,exports) {
/**
 * Recursively traverse up the tree to check whether the provided child node
 * is the parent or a descendant of it.
 *
 * @param parent - Element to find
 * @param child - Element to test against parent
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isNodeOrChild", ()=>isNodeOrChild);
const isNodeOrChild = (parent, child)=>{
    if (!child) return false;
    else if (parent === child) return true;
    else return isNodeOrChild(parent, child.parentElement);
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"b9A3a":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "InViewFeature", ()=>InViewFeature);
var _featureMjs = require("../Feature.mjs");
var _observersMjs = require("./observers.mjs");
const thresholdNames = {
    some: 0,
    all: 1
};
class InViewFeature extends (0, _featureMjs.Feature) {
    constructor(){
        super(...arguments);
        this.hasEnteredView = false;
        this.isInView = false;
    }
    startObserver() {
        this.unmount();
        const { viewport = {} } = this.node.getProps();
        const { root, margin: rootMargin, amount = "some", once } = viewport;
        const options = {
            root: root ? root.current : undefined,
            rootMargin,
            threshold: typeof amount === "number" ? amount : thresholdNames[amount]
        };
        const onIntersectionUpdate = (entry)=>{
            const { isIntersecting } = entry;
            /**
             * If there's been no change in the viewport state, early return.
             */ if (this.isInView === isIntersecting) return;
            this.isInView = isIntersecting;
            /**
             * Handle hasEnteredView. If this is only meant to run once, and
             * element isn't visible, early return. Otherwise set hasEnteredView to true.
             */ if (once && !isIntersecting && this.hasEnteredView) return;
            else if (isIntersecting) this.hasEnteredView = true;
            if (this.node.animationState) this.node.animationState.setActive("whileInView", isIntersecting);
            /**
             * Use the latest committed props rather than the ones in scope
             * when this observer is created
             */ const { onViewportEnter, onViewportLeave } = this.node.getProps();
            const callback = isIntersecting ? onViewportEnter : onViewportLeave;
            callback && callback(entry);
        };
        return (0, _observersMjs.observeIntersection)(this.node.current, options, onIntersectionUpdate);
    }
    mount() {
        this.startObserver();
    }
    update() {
        if (typeof IntersectionObserver === "undefined") return;
        const { props, prevProps } = this.node;
        const hasOptionsChanged = [
            "amount",
            "margin",
            "root"
        ].some(hasViewportOptionChanged(props, prevProps));
        if (hasOptionsChanged) this.startObserver();
    }
    unmount() {}
}
function hasViewportOptionChanged({ viewport = {} }, { viewport: prevViewport = {} } = {}) {
    return (name)=>viewport[name] !== prevViewport[name];
}

},{"../Feature.mjs":"9q59Z","./observers.mjs":"j5r65","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"j5r65":[function(require,module,exports) {
/**
 * Map an IntersectionHandler callback to an element. We only ever make one handler for one
 * element, so even though these handlers might all be triggered by different
 * observers, we can keep them in the same map.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "observeIntersection", ()=>observeIntersection);
const observerCallbacks = new WeakMap();
/**
 * Multiple observers can be created for multiple element/document roots. Each with
 * different settings. So here we store dictionaries of observers to each root,
 * using serialised settings (threshold/margin) as lookup keys.
 */ const observers = new WeakMap();
const fireObserverCallback = (entry)=>{
    const callback = observerCallbacks.get(entry.target);
    callback && callback(entry);
};
const fireAllObserverCallbacks = (entries)=>{
    entries.forEach(fireObserverCallback);
};
function initIntersectionObserver({ root, ...options }) {
    const lookupRoot = root || document;
    /**
     * If we don't have an observer lookup map for this root, create one.
     */ if (!observers.has(lookupRoot)) observers.set(lookupRoot, {});
    const rootObservers = observers.get(lookupRoot);
    const key = JSON.stringify(options);
    /**
     * If we don't have an observer for this combination of root and settings,
     * create one.
     */ if (!rootObservers[key]) rootObservers[key] = new IntersectionObserver(fireAllObserverCallbacks, {
        root,
        ...options
    });
    return rootObservers[key];
}
function observeIntersection(element, options, callback) {
    const rootInteresectionObserver = initIntersectionObserver(options);
    observerCallbacks.set(element, callback);
    rootInteresectionObserver.observe(element);
    return ()=>{
        observerCallbacks.delete(element);
        rootInteresectionObserver.unobserve(element);
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"Rvk5C":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "animations", ()=>animations);
var _indexMjs = require("./animation/index.mjs");
var _exitMjs = require("./animation/exit.mjs");
const animations = {
    animation: {
        Feature: (0, _indexMjs.AnimationFeature)
    },
    exit: {
        Feature: (0, _exitMjs.ExitAnimationFeature)
    }
};

},{"./animation/index.mjs":"6J9oh","./animation/exit.mjs":"evYau","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"6J9oh":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AnimationFeature", ()=>AnimationFeature);
var _isAnimationControlsMjs = require("../../../animation/utils/is-animation-controls.mjs");
var _animationStateMjs = require("../../../render/utils/animation-state.mjs");
var _featureMjs = require("../Feature.mjs");
class AnimationFeature extends (0, _featureMjs.Feature) {
    /**
     * We dynamically generate the AnimationState manager as it contains a reference
     * to the underlying animation library. We only want to load that if we load this,
     * so people can optionally code split it out using the `m` component.
     */ constructor(node){
        super(node);
        node.animationState || (node.animationState = (0, _animationStateMjs.createAnimationState)(node));
    }
    updateAnimationControlsSubscription() {
        const { animate } = this.node.getProps();
        this.unmount();
        if ((0, _isAnimationControlsMjs.isAnimationControls)(animate)) this.unmount = animate.subscribe(this.node);
    }
    /**
     * Subscribe any provided AnimationControls to the component's VisualElement
     */ mount() {
        this.updateAnimationControlsSubscription();
    }
    update() {
        const { animate } = this.node.getProps();
        const { animate: prevAnimate } = this.node.prevProps || {};
        if (animate !== prevAnimate) this.updateAnimationControlsSubscription();
    }
    unmount() {}
}

},{"../../../animation/utils/is-animation-controls.mjs":"fDSp3","../../../render/utils/animation-state.mjs":"jfRti","../Feature.mjs":"9q59Z","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"jfRti":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "checkVariantsDidChange", ()=>checkVariantsDidChange);
parcelHelpers.export(exports, "createAnimationState", ()=>createAnimationState);
var _isAnimationControlsMjs = require("../../animation/utils/is-animation-controls.mjs");
var _isKeyframesTargetMjs = require("../../animation/utils/is-keyframes-target.mjs");
var _shallowCompareMjs = require("../../utils/shallow-compare.mjs");
var _isVariantLabelMjs = require("./is-variant-label.mjs");
var _resolveDynamicVariantsMjs = require("./resolve-dynamic-variants.mjs");
var _variantPropsMjs = require("./variant-props.mjs");
var _visualElementMjs = require("../../animation/interfaces/visual-element.mjs");
const reversePriorityOrder = [
    ...(0, _variantPropsMjs.variantPriorityOrder)
].reverse();
const numAnimationTypes = (0, _variantPropsMjs.variantPriorityOrder).length;
function animateList(visualElement) {
    return (animations)=>Promise.all(animations.map(({ animation, options })=>(0, _visualElementMjs.animateVisualElement)(visualElement, animation, options)));
}
function createAnimationState(visualElement) {
    let animate = animateList(visualElement);
    const state = createState();
    let isInitialRender = true;
    /**
     * This function will be used to reduce the animation definitions for
     * each active animation type into an object of resolved values for it.
     */ const buildResolvedTypeValues = (acc, definition)=>{
        const resolved = (0, _resolveDynamicVariantsMjs.resolveVariant)(visualElement, definition);
        if (resolved) {
            const { transition, transitionEnd, ...target } = resolved;
            acc = {
                ...acc,
                ...target,
                ...transitionEnd
            };
        }
        return acc;
    };
    /**
     * This just allows us to inject mocked animation functions
     * @internal
     */ function setAnimateFunction(makeAnimator) {
        animate = makeAnimator(visualElement);
    }
    /**
     * When we receive new props, we need to:
     * 1. Create a list of protected keys for each type. This is a directory of
     *    value keys that are currently being "handled" by types of a higher priority
     *    so that whenever an animation is played of a given type, these values are
     *    protected from being animated.
     * 2. Determine if an animation type needs animating.
     * 3. Determine if any values have been removed from a type and figure out
     *    what to animate those to.
     */ function animateChanges(options, changedActiveType) {
        const props = visualElement.getProps();
        const context = visualElement.getVariantContext(true) || {};
        /**
         * A list of animations that we'll build into as we iterate through the animation
         * types. This will get executed at the end of the function.
         */ const animations = [];
        /**
         * Keep track of which values have been removed. Then, as we hit lower priority
         * animation types, we can check if they contain removed values and animate to that.
         */ const removedKeys = new Set();
        /**
         * A dictionary of all encountered keys. This is an object to let us build into and
         * copy it without iteration. Each time we hit an animation type we set its protected
         * keys - the keys its not allowed to animate - to the latest version of this object.
         */ let encounteredKeys = {};
        /**
         * If a variant has been removed at a given index, and this component is controlling
         * variant animations, we want to ensure lower-priority variants are forced to animate.
         */ let removedVariantIndex = Infinity;
        /**
         * Iterate through all animation types in reverse priority order. For each, we want to
         * detect which values it's handling and whether or not they've changed (and therefore
         * need to be animated). If any values have been removed, we want to detect those in
         * lower priority props and flag for animation.
         */ for(let i = 0; i < numAnimationTypes; i++){
            const type = reversePriorityOrder[i];
            const typeState = state[type];
            const prop = props[type] !== undefined ? props[type] : context[type];
            const propIsVariant = (0, _isVariantLabelMjs.isVariantLabel)(prop);
            /**
             * If this type has *just* changed isActive status, set activeDelta
             * to that status. Otherwise set to null.
             */ const activeDelta = type === changedActiveType ? typeState.isActive : null;
            if (activeDelta === false) removedVariantIndex = i;
            /**
             * If this prop is an inherited variant, rather than been set directly on the
             * component itself, we want to make sure we allow the parent to trigger animations.
             *
             * TODO: Can probably change this to a !isControllingVariants check
             */ let isInherited = prop === context[type] && prop !== props[type] && propIsVariant;
            /**
             *
             */ if (isInherited && isInitialRender && visualElement.manuallyAnimateOnMount) isInherited = false;
            /**
             * Set all encountered keys so far as the protected keys for this type. This will
             * be any key that has been animated or otherwise handled by active, higher-priortiy types.
             */ typeState.protectedKeys = {
                ...encounteredKeys
            };
            // Check if we can skip analysing this prop early
            if (// If it isn't active and hasn't *just* been set as inactive
            !typeState.isActive && activeDelta === null || // If we didn't and don't have any defined prop for this animation type
            !prop && !typeState.prevProp || // Or if the prop doesn't define an animation
            (0, _isAnimationControlsMjs.isAnimationControls)(prop) || typeof prop === "boolean") continue;
            /**
             * As we go look through the values defined on this type, if we detect
             * a changed value or a value that was removed in a higher priority, we set
             * this to true and add this prop to the animation list.
             */ const variantDidChange = checkVariantsDidChange(typeState.prevProp, prop);
            let shouldAnimateType = variantDidChange || // If we're making this variant active, we want to always make it active
            type === changedActiveType && typeState.isActive && !isInherited && propIsVariant || // If we removed a higher-priority variant (i is in reverse order)
            i > removedVariantIndex && propIsVariant;
            let handledRemovedValues = false;
            /**
             * As animations can be set as variant lists, variants or target objects, we
             * coerce everything to an array if it isn't one already
             */ const definitionList = Array.isArray(prop) ? prop : [
                prop
            ];
            /**
             * Build an object of all the resolved values. We'll use this in the subsequent
             * animateChanges calls to determine whether a value has changed.
             */ let resolvedValues = definitionList.reduce(buildResolvedTypeValues, {});
            if (activeDelta === false) resolvedValues = {};
            /**
             * Now we need to loop through all the keys in the prev prop and this prop,
             * and decide:
             * 1. If the value has changed, and needs animating
             * 2. If it has been removed, and needs adding to the removedKeys set
             * 3. If it has been removed in a higher priority type and needs animating
             * 4. If it hasn't been removed in a higher priority but hasn't changed, and
             *    needs adding to the type's protectedKeys list.
             */ const { prevResolvedValues = {} } = typeState;
            const allKeys = {
                ...prevResolvedValues,
                ...resolvedValues
            };
            const markToAnimate = (key)=>{
                shouldAnimateType = true;
                if (removedKeys.has(key)) {
                    handledRemovedValues = true;
                    removedKeys.delete(key);
                }
                typeState.needsAnimating[key] = true;
            };
            for(const key in allKeys){
                const next = resolvedValues[key];
                const prev = prevResolvedValues[key];
                // If we've already handled this we can just skip ahead
                if (encounteredKeys.hasOwnProperty(key)) continue;
                /**
                 * If the value has changed, we probably want to animate it.
                 */ let valueHasChanged = false;
                if ((0, _isKeyframesTargetMjs.isKeyframesTarget)(next) && (0, _isKeyframesTargetMjs.isKeyframesTarget)(prev)) valueHasChanged = !(0, _shallowCompareMjs.shallowCompare)(next, prev);
                else valueHasChanged = next !== prev;
                if (valueHasChanged) {
                    if (next !== undefined) // If next is defined and doesn't equal prev, it needs animating
                    markToAnimate(key);
                    else // If it's undefined, it's been removed.
                    removedKeys.add(key);
                } else if (next !== undefined && removedKeys.has(key)) /**
                     * If next hasn't changed and it isn't undefined, we want to check if it's
                     * been removed by a higher priority
                     */ markToAnimate(key);
                else /**
                     * If it hasn't changed, we add it to the list of protected values
                     * to ensure it doesn't get animated.
                     */ typeState.protectedKeys[key] = true;
            }
            /**
             * Update the typeState so next time animateChanges is called we can compare the
             * latest prop and resolvedValues to these.
             */ typeState.prevProp = prop;
            typeState.prevResolvedValues = resolvedValues;
            /**
             *
             */ if (typeState.isActive) encounteredKeys = {
                ...encounteredKeys,
                ...resolvedValues
            };
            if (isInitialRender && visualElement.blockInitialAnimation) shouldAnimateType = false;
            /**
             * If this is an inherited prop we want to hard-block animations
             */ if (shouldAnimateType && (!isInherited || handledRemovedValues)) animations.push(...definitionList.map((animation)=>({
                    animation: animation,
                    options: {
                        type,
                        ...options
                    }
                })));
        }
        /**
         * If there are some removed value that haven't been dealt with,
         * we need to create a new animation that falls back either to the value
         * defined in the style prop, or the last read value.
         */ if (removedKeys.size) {
            const fallbackAnimation = {};
            removedKeys.forEach((key)=>{
                const fallbackTarget = visualElement.getBaseTarget(key);
                if (fallbackTarget !== undefined) fallbackAnimation[key] = fallbackTarget;
            });
            animations.push({
                animation: fallbackAnimation
            });
        }
        let shouldAnimate = Boolean(animations.length);
        if (isInitialRender && (props.initial === false || props.initial === props.animate) && !visualElement.manuallyAnimateOnMount) shouldAnimate = false;
        isInitialRender = false;
        return shouldAnimate ? animate(animations) : Promise.resolve();
    }
    /**
     * Change whether a certain animation type is active.
     */ function setActive(type, isActive, options) {
        var _a;
        // If the active state hasn't changed, we can safely do nothing here
        if (state[type].isActive === isActive) return Promise.resolve();
        // Propagate active change to children
        (_a = visualElement.variantChildren) === null || _a === void 0 || _a.forEach((child)=>{
            var _a;
            return (_a = child.animationState) === null || _a === void 0 ? void 0 : _a.setActive(type, isActive);
        });
        state[type].isActive = isActive;
        const animations = animateChanges(options, type);
        for(const key in state)state[key].protectedKeys = {};
        return animations;
    }
    return {
        animateChanges,
        setActive,
        setAnimateFunction,
        getState: ()=>state
    };
}
function checkVariantsDidChange(prev, next) {
    if (typeof next === "string") return next !== prev;
    else if (Array.isArray(next)) return !(0, _shallowCompareMjs.shallowCompare)(next, prev);
    return false;
}
function createTypeState(isActive = false) {
    return {
        isActive,
        protectedKeys: {},
        needsAnimating: {},
        prevResolvedValues: {}
    };
}
function createState() {
    return {
        animate: createTypeState(true),
        whileInView: createTypeState(),
        whileHover: createTypeState(),
        whileTap: createTypeState(),
        whileDrag: createTypeState(),
        whileFocus: createTypeState(),
        exit: createTypeState()
    };
}

},{"../../animation/utils/is-animation-controls.mjs":"fDSp3","../../animation/utils/is-keyframes-target.mjs":"b9ZPA","../../utils/shallow-compare.mjs":"5YaEU","./is-variant-label.mjs":"hGXyz","./resolve-dynamic-variants.mjs":"4tXnT","./variant-props.mjs":"8wQuM","../../animation/interfaces/visual-element.mjs":"iC4fb","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"5YaEU":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "shallowCompare", ()=>shallowCompare);
function shallowCompare(next, prev) {
    if (!Array.isArray(prev)) return false;
    const prevLength = prev.length;
    if (prevLength !== next.length) return false;
    for(let i = 0; i < prevLength; i++){
        if (prev[i] !== next[i]) return false;
    }
    return true;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4tXnT":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "resolveVariant", ()=>resolveVariant);
var _resolveVariantsMjs = require("./resolve-variants.mjs");
/**
 * Creates an object containing the latest state of every MotionValue on a VisualElement
 */ function getCurrent(visualElement) {
    const current = {};
    visualElement.values.forEach((value, key)=>current[key] = value.get());
    return current;
}
/**
 * Creates an object containing the latest velocity of every MotionValue on a VisualElement
 */ function getVelocity(visualElement) {
    const velocity = {};
    visualElement.values.forEach((value, key)=>velocity[key] = value.getVelocity());
    return velocity;
}
function resolveVariant(visualElement, definition, custom) {
    const props = visualElement.getProps();
    return (0, _resolveVariantsMjs.resolveVariantFromProps)(props, definition, custom !== undefined ? custom : props.custom, getCurrent(visualElement), getVelocity(visualElement));
}

},{"./resolve-variants.mjs":"iR2sd","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"iC4fb":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "animateVisualElement", ()=>animateVisualElement);
var _resolveDynamicVariantsMjs = require("../../render/utils/resolve-dynamic-variants.mjs");
var _visualElementTargetMjs = require("./visual-element-target.mjs");
var _visualElementVariantMjs = require("./visual-element-variant.mjs");
function animateVisualElement(visualElement, definition, options = {}) {
    visualElement.notify("AnimationStart", definition);
    let animation;
    if (Array.isArray(definition)) {
        const animations = definition.map((variant)=>(0, _visualElementVariantMjs.animateVariant)(visualElement, variant, options));
        animation = Promise.all(animations);
    } else if (typeof definition === "string") animation = (0, _visualElementVariantMjs.animateVariant)(visualElement, definition, options);
    else {
        const resolvedDefinition = typeof definition === "function" ? (0, _resolveDynamicVariantsMjs.resolveVariant)(visualElement, definition, options.custom) : definition;
        animation = Promise.all((0, _visualElementTargetMjs.animateTarget)(visualElement, resolvedDefinition, options));
    }
    return animation.then(()=>visualElement.notify("AnimationComplete", definition));
}

},{"../../render/utils/resolve-dynamic-variants.mjs":"4tXnT","./visual-element-target.mjs":"j8sQ3","./visual-element-variant.mjs":"6BoKt","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"j8sQ3":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "animateTarget", ()=>animateTarget);
var _transformMjs = require("../../render/html/utils/transform.mjs");
var _dataIdMjs = require("../optimized-appear/data-id.mjs");
var _motionValueMjs = require("./motion-value.mjs");
var _isMjs = require("../../value/use-will-change/is.mjs");
var _settersMjs = require("../../render/utils/setters.mjs");
var _transitionsMjs = require("../utils/transitions.mjs");
var _frameMjs = require("../../frameloop/frame.mjs");
/**
 * Decide whether we should block this animation. Previously, we achieved this
 * just by checking whether the key was listed in protectedKeys, but this
 * posed problems if an animation was triggered by afterChildren and protectedKeys
 * had been set to true in the meantime.
 */ function shouldBlockAnimation({ protectedKeys, needsAnimating }, key) {
    const shouldBlock = protectedKeys.hasOwnProperty(key) && needsAnimating[key] !== true;
    needsAnimating[key] = false;
    return shouldBlock;
}
function hasKeyframesChanged(value, target) {
    const current = value.get();
    if (Array.isArray(target)) for(let i = 0; i < target.length; i++){
        if (target[i] !== current) return true;
    }
    else return current !== target;
}
function animateTarget(visualElement, definition, { delay = 0, transitionOverride, type } = {}) {
    let { transition = visualElement.getDefaultTransition(), transitionEnd, ...target } = visualElement.makeTargetAnimatable(definition);
    const willChange = visualElement.getValue("willChange");
    if (transitionOverride) transition = transitionOverride;
    const animations = [];
    const animationTypeState = type && visualElement.animationState && visualElement.animationState.getState()[type];
    for(const key in target){
        const value = visualElement.getValue(key);
        const valueTarget = target[key];
        if (!value || valueTarget === undefined || animationTypeState && shouldBlockAnimation(animationTypeState, key)) continue;
        const valueTransition = {
            delay,
            elapsed: 0,
            ...(0, _transitionsMjs.getValueTransition)(transition || {}, key)
        };
        /**
         * If this is the first time a value is being animated, check
         * to see if we're handling off from an existing animation.
         */ if (window.HandoffAppearAnimations) {
            const appearId = visualElement.getProps()[0, _dataIdMjs.optimizedAppearDataAttribute];
            if (appearId) {
                const elapsed = window.HandoffAppearAnimations(appearId, key, value, (0, _frameMjs.frame));
                if (elapsed !== null) {
                    valueTransition.elapsed = elapsed;
                    valueTransition.isHandoff = true;
                }
            }
        }
        let canSkip = !valueTransition.isHandoff && !hasKeyframesChanged(value, valueTarget);
        if (valueTransition.type === "spring" && (value.getVelocity() || valueTransition.velocity)) canSkip = false;
        /**
         * Temporarily disable skipping animations if there's an animation in
         * progress. Better would be to track the current target of a value
         * and compare that against valueTarget.
         */ if (value.animation) canSkip = false;
        if (canSkip) continue;
        value.start((0, _motionValueMjs.animateMotionValue)(key, value, valueTarget, visualElement.shouldReduceMotion && (0, _transformMjs.transformProps).has(key) ? {
            type: false
        } : valueTransition));
        const animation = value.animation;
        if ((0, _isMjs.isWillChangeMotionValue)(willChange)) {
            willChange.add(key);
            animation.then(()=>willChange.remove(key));
        }
        animations.push(animation);
    }
    if (transitionEnd) Promise.all(animations).then(()=>{
        transitionEnd && (0, _settersMjs.setTarget)(visualElement, transitionEnd);
    });
    return animations;
}

},{"../../render/html/utils/transform.mjs":"es0QE","../optimized-appear/data-id.mjs":"jLjpN","./motion-value.mjs":"lumbS","../../value/use-will-change/is.mjs":"cLEeP","../../render/utils/setters.mjs":"jlhrk","../utils/transitions.mjs":"hIHWM","../../frameloop/frame.mjs":"gdRIq","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"lumbS":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "animateMotionValue", ()=>animateMotionValue);
var _errorsMjs = require("../../utils/errors.mjs");
var _timeConversionMjs = require("../../utils/time-conversion.mjs");
var _useInstantTransitionStateMjs = require("../../utils/use-instant-transition-state.mjs");
var _createAcceleratedAnimationMjs = require("../animators/waapi/create-accelerated-animation.mjs");
var _instantMjs = require("../animators/instant.mjs");
var _defaultTransitionsMjs = require("../utils/default-transitions.mjs");
var _isAnimatableMjs = require("../utils/is-animatable.mjs");
var _keyframesMjs = require("../utils/keyframes.mjs");
var _transitionsMjs = require("../utils/transitions.mjs");
var _indexMjs = require("../animators/js/index.mjs");
var _globalConfigMjs = require("../../utils/GlobalConfig.mjs");
const animateMotionValue = (valueName, value, target, transition = {})=>{
    return (onComplete)=>{
        const valueTransition = (0, _transitionsMjs.getValueTransition)(transition, valueName) || {};
        /**
         * Most transition values are currently completely overwritten by value-specific
         * transitions. In the future it'd be nicer to blend these transitions. But for now
         * delay actually does inherit from the root transition if not value-specific.
         */ const delay = valueTransition.delay || transition.delay || 0;
        /**
         * Elapsed isn't a public transition option but can be passed through from
         * optimized appear effects in milliseconds.
         */ let { elapsed = 0 } = transition;
        elapsed = elapsed - (0, _timeConversionMjs.secondsToMilliseconds)(delay);
        const keyframes = (0, _keyframesMjs.getKeyframes)(value, valueName, target, valueTransition);
        /**
         * Check if we're able to animate between the start and end keyframes,
         * and throw a warning if we're attempting to animate between one that's
         * animatable and another that isn't.
         */ const originKeyframe = keyframes[0];
        const targetKeyframe = keyframes[keyframes.length - 1];
        const isOriginAnimatable = (0, _isAnimatableMjs.isAnimatable)(valueName, originKeyframe);
        const isTargetAnimatable = (0, _isAnimatableMjs.isAnimatable)(valueName, targetKeyframe);
        (0, _errorsMjs.warning)(isOriginAnimatable === isTargetAnimatable, `You are trying to animate ${valueName} from "${originKeyframe}" to "${targetKeyframe}". ${originKeyframe} is not an animatable value - to enable this animation set ${originKeyframe} to a value animatable to ${targetKeyframe} via the \`style\` property.`);
        let options = {
            keyframes,
            velocity: value.getVelocity(),
            ease: "easeOut",
            ...valueTransition,
            delay: -elapsed,
            onUpdate: (v)=>{
                value.set(v);
                valueTransition.onUpdate && valueTransition.onUpdate(v);
            },
            onComplete: ()=>{
                onComplete();
                valueTransition.onComplete && valueTransition.onComplete();
            }
        };
        /**
         * If there's no transition defined for this value, we can generate
         * unqiue transition settings for this value.
         */ if (!(0, _transitionsMjs.isTransitionDefined)(valueTransition)) options = {
            ...options,
            ...(0, _defaultTransitionsMjs.getDefaultTransition)(valueName, options)
        };
        /**
         * Both WAAPI and our internal animation functions use durations
         * as defined by milliseconds, while our external API defines them
         * as seconds.
         */ if (options.duration) options.duration = (0, _timeConversionMjs.secondsToMilliseconds)(options.duration);
        if (options.repeatDelay) options.repeatDelay = (0, _timeConversionMjs.secondsToMilliseconds)(options.repeatDelay);
        if (!isOriginAnimatable || !isTargetAnimatable || (0, _useInstantTransitionStateMjs.instantAnimationState).current || valueTransition.type === false || (0, _globalConfigMjs.MotionGlobalConfig).skipAnimations) /**
             * If we can't animate this value, or the global instant animation flag is set,
             * or this is simply defined as an instant transition, return an instant transition.
             */ return (0, _instantMjs.createInstantAnimation)((0, _useInstantTransitionStateMjs.instantAnimationState).current ? {
            ...options,
            delay: 0
        } : options);
        /**
         * Animate via WAAPI if possible.
         */ if (/**
         * If this is a handoff animation, the optimised animation will be running via
         * WAAPI. Therefore, this animation must be JS to ensure it runs "under" the
         * optimised animation.
         */ !transition.isHandoff && value.owner && value.owner.current instanceof HTMLElement && /**
             * If we're outputting values to onUpdate then we can't use WAAPI as there's
             * no way to read the value from WAAPI every frame.
             */ !value.owner.getProps().onUpdate) {
            const acceleratedAnimation = (0, _createAcceleratedAnimationMjs.createAcceleratedAnimation)(value, valueName, options);
            if (acceleratedAnimation) return acceleratedAnimation;
        }
        /**
         * If we didn't create an accelerated animation, create a JS animation
         */ return (0, _indexMjs.animateValue)(options);
    };
};

},{"../../utils/errors.mjs":"buT6L","../../utils/time-conversion.mjs":"4Ib29","../../utils/use-instant-transition-state.mjs":"91bNg","../animators/waapi/create-accelerated-animation.mjs":"lBddZ","../animators/instant.mjs":"kyxLH","../utils/default-transitions.mjs":"1j1Wa","../utils/is-animatable.mjs":"8Qgk1","../utils/keyframes.mjs":"8nRWE","../utils/transitions.mjs":"hIHWM","../animators/js/index.mjs":"aZWjK","../../utils/GlobalConfig.mjs":"duUiC","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"buT6L":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "invariant", ()=>invariant);
parcelHelpers.export(exports, "warning", ()=>warning);
var _noopMjs = require("./noop.mjs");
let warning = (0, _noopMjs.noop);
let invariant = (0, _noopMjs.noop);
var check, message, check1, message1;

},{"./noop.mjs":"7roqC","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4Ib29":[function(require,module,exports) {
/**
 * Converts seconds to milliseconds
 *
 * @param seconds - Time in seconds.
 * @return milliseconds - Converted time in milliseconds.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "millisecondsToSeconds", ()=>millisecondsToSeconds);
parcelHelpers.export(exports, "secondsToMilliseconds", ()=>secondsToMilliseconds);
const secondsToMilliseconds = (seconds)=>seconds * 1000;
const millisecondsToSeconds = (milliseconds)=>milliseconds / 1000;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"91bNg":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "instantAnimationState", ()=>instantAnimationState);
const instantAnimationState = {
    current: false
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"lBddZ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createAcceleratedAnimation", ()=>createAcceleratedAnimation);
var _indexMjs = require("./index.mjs");
var _easingMjs = require("./easing.mjs");
var _getFinalKeyframeMjs = require("./utils/get-final-keyframe.mjs");
var _indexMjs1 = require("../js/index.mjs");
var _timeConversionMjs = require("../../../utils/time-conversion.mjs");
var _memoMjs = require("../../../utils/memo.mjs");
var _noopMjs = require("../../../utils/noop.mjs");
var _frameMjs = require("../../../frameloop/frame.mjs");
const supportsWaapi = (0, _memoMjs.memo)(()=>Object.hasOwnProperty.call(Element.prototype, "animate"));
/**
 * A list of values that can be hardware-accelerated.
 */ const acceleratedValues = new Set([
    "opacity",
    "clipPath",
    "filter",
    "transform",
    "backgroundColor"
]);
/**
 * 10ms is chosen here as it strikes a balance between smooth
 * results (more than one keyframe per frame at 60fps) and
 * keyframe quantity.
 */ const sampleDelta = 10; //ms
/**
 * Implement a practical max duration for keyframe generation
 * to prevent infinite loops
 */ const maxDuration = 20000;
const requiresPregeneratedKeyframes = (valueName, options)=>options.type === "spring" || valueName === "backgroundColor" || !(0, _easingMjs.isWaapiSupportedEasing)(options.ease);
function createAcceleratedAnimation(value, valueName, { onUpdate, onComplete, ...options }) {
    const canAccelerateAnimation = supportsWaapi() && acceleratedValues.has(valueName) && !options.repeatDelay && options.repeatType !== "mirror" && options.damping !== 0 && options.type !== "inertia";
    if (!canAccelerateAnimation) return false;
    /**
     * TODO: Unify with js/index
     */ let hasStopped = false;
    let resolveFinishedPromise;
    let currentFinishedPromise;
    /**
     * Cancelling an animation will write to the DOM. For safety we want to defer
     * this until the next `update` frame lifecycle. This flag tracks whether we
     * have a pending cancel, if so we shouldn't allow animations to finish.
     */ let pendingCancel = false;
    /**
     * Resolve the current Promise every time we enter the
     * finished state. This is WAAPI-compatible behaviour.
     */ const updateFinishedPromise = ()=>{
        currentFinishedPromise = new Promise((resolve)=>{
            resolveFinishedPromise = resolve;
        });
    };
    // Create the first finished promise
    updateFinishedPromise();
    let { keyframes, duration = 300, ease, times } = options;
    /**
     * If this animation needs pre-generated keyframes then generate.
     */ if (requiresPregeneratedKeyframes(valueName, options)) {
        const sampleAnimation = (0, _indexMjs1.animateValue)({
            ...options,
            repeat: 0,
            delay: 0
        });
        let state = {
            done: false,
            value: keyframes[0]
        };
        const pregeneratedKeyframes = [];
        /**
         * Bail after 20 seconds of pre-generated keyframes as it's likely
         * we're heading for an infinite loop.
         */ let t = 0;
        while(!state.done && t < maxDuration){
            state = sampleAnimation.sample(t);
            pregeneratedKeyframes.push(state.value);
            t += sampleDelta;
        }
        times = undefined;
        keyframes = pregeneratedKeyframes;
        duration = t - sampleDelta;
        ease = "linear";
    }
    const animation = (0, _indexMjs.animateStyle)(value.owner.current, valueName, keyframes, {
        ...options,
        duration,
        /**
         * This function is currently not called if ease is provided
         * as a function so the cast is safe.
         *
         * However it would be possible for a future refinement to port
         * in easing pregeneration from Motion One for browsers that
         * support the upcoming `linear()` easing function.
         */ ease: ease,
        times
    });
    const cancelAnimation = ()=>{
        pendingCancel = false;
        animation.cancel();
    };
    const safeCancel = ()=>{
        pendingCancel = true;
        (0, _frameMjs.frame).update(cancelAnimation);
        resolveFinishedPromise();
        updateFinishedPromise();
    };
    /**
     * Prefer the `onfinish` prop as it's more widely supported than
     * the `finished` promise.
     *
     * Here, we synchronously set the provided MotionValue to the end
     * keyframe. If we didn't, when the WAAPI animation is finished it would
     * be removed from the element which would then revert to its old styles.
     */ animation.onfinish = ()=>{
        if (pendingCancel) return;
        value.set((0, _getFinalKeyframeMjs.getFinalKeyframe)(keyframes, options));
        onComplete && onComplete();
        safeCancel();
    };
    /**
     * Animation interrupt callback.
     */ const controls = {
        then (resolve, reject) {
            return currentFinishedPromise.then(resolve, reject);
        },
        attachTimeline (timeline) {
            animation.timeline = timeline;
            animation.onfinish = null;
            return 0, _noopMjs.noop;
        },
        get time () {
            return (0, _timeConversionMjs.millisecondsToSeconds)(animation.currentTime || 0);
        },
        set time (newTime){
            animation.currentTime = (0, _timeConversionMjs.secondsToMilliseconds)(newTime);
        },
        get speed () {
            return animation.playbackRate;
        },
        set speed (newSpeed){
            animation.playbackRate = newSpeed;
        },
        get duration () {
            return (0, _timeConversionMjs.millisecondsToSeconds)(duration);
        },
        play: ()=>{
            if (hasStopped) return;
            animation.play();
            /**
             * Cancel any pending cancel tasks
             */ (0, _frameMjs.cancelFrame)(cancelAnimation);
        },
        pause: ()=>animation.pause(),
        stop: ()=>{
            hasStopped = true;
            if (animation.playState === "idle") return;
            /**
             * WAAPI doesn't natively have any interruption capabilities.
             *
             * Rather than read commited styles back out of the DOM, we can
             * create a renderless JS animation and sample it twice to calculate
             * its current value, "previous" value, and therefore allow
             * Motion to calculate velocity for any subsequent animation.
             */ const { currentTime } = animation;
            if (currentTime) {
                const sampleAnimation = (0, _indexMjs1.animateValue)({
                    ...options,
                    autoplay: false
                });
                value.setWithVelocity(sampleAnimation.sample(currentTime - sampleDelta).value, sampleAnimation.sample(currentTime).value, sampleDelta);
            }
            safeCancel();
        },
        complete: ()=>{
            if (pendingCancel) return;
            animation.finish();
        },
        cancel: safeCancel
    };
    return controls;
}

},{"./index.mjs":"evYrX","./easing.mjs":"ezjW9","./utils/get-final-keyframe.mjs":"94snX","../js/index.mjs":"aZWjK","../../../utils/time-conversion.mjs":"4Ib29","../../../utils/memo.mjs":"fxVXL","../../../utils/noop.mjs":"7roqC","../../../frameloop/frame.mjs":"gdRIq","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"evYrX":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "animateStyle", ()=>animateStyle);
var _easingMjs = require("./easing.mjs");
function animateStyle(element, valueName, keyframes, { delay = 0, duration, repeat = 0, repeatType = "loop", ease, times } = {}) {
    const keyframeOptions = {
        [valueName]: keyframes
    };
    if (times) keyframeOptions.offset = times;
    const easing = (0, _easingMjs.mapEasingToNativeEasing)(ease);
    /**
     * If this is an easing array, apply to keyframes, not animation as a whole
     */ if (Array.isArray(easing)) keyframeOptions.easing = easing;
    return element.animate(keyframeOptions, {
        delay,
        duration,
        easing: !Array.isArray(easing) ? easing : "linear",
        fill: "both",
        iterations: repeat + 1,
        direction: repeatType === "reverse" ? "alternate" : "normal"
    });
}

},{"./easing.mjs":"ezjW9","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"ezjW9":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "cubicBezierAsString", ()=>cubicBezierAsString);
parcelHelpers.export(exports, "isWaapiSupportedEasing", ()=>isWaapiSupportedEasing);
parcelHelpers.export(exports, "mapEasingToNativeEasing", ()=>mapEasingToNativeEasing);
parcelHelpers.export(exports, "supportedWaapiEasing", ()=>supportedWaapiEasing);
var _isBezierDefinitionMjs = require("../../../easing/utils/is-bezier-definition.mjs");
function isWaapiSupportedEasing(easing) {
    return Boolean(!easing || typeof easing === "string" && supportedWaapiEasing[easing] || (0, _isBezierDefinitionMjs.isBezierDefinition)(easing) || Array.isArray(easing) && easing.every(isWaapiSupportedEasing));
}
const cubicBezierAsString = ([a, b, c, d])=>`cubic-bezier(${a}, ${b}, ${c}, ${d})`;
const supportedWaapiEasing = {
    linear: "linear",
    ease: "ease",
    easeIn: "ease-in",
    easeOut: "ease-out",
    easeInOut: "ease-in-out",
    circIn: cubicBezierAsString([
        0,
        0.65,
        0.55,
        1
    ]),
    circOut: cubicBezierAsString([
        0.55,
        0,
        1,
        0.45
    ]),
    backIn: cubicBezierAsString([
        0.31,
        0.01,
        0.66,
        -0.59
    ]),
    backOut: cubicBezierAsString([
        0.33,
        1.53,
        0.69,
        0.99
    ])
};
function mapEasingToNativeEasing(easing) {
    if (!easing) return undefined;
    return (0, _isBezierDefinitionMjs.isBezierDefinition)(easing) ? cubicBezierAsString(easing) : Array.isArray(easing) ? easing.map(mapEasingToNativeEasing) : supportedWaapiEasing[easing];
}

},{"../../../easing/utils/is-bezier-definition.mjs":"8MzB8","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8MzB8":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isBezierDefinition", ()=>isBezierDefinition);
const isBezierDefinition = (easing)=>Array.isArray(easing) && typeof easing[0] === "number";

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"94snX":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getFinalKeyframe", ()=>getFinalKeyframe);
function getFinalKeyframe(keyframes, { repeat, repeatType = "loop" }) {
    const index = repeat && repeatType !== "loop" && repeat % 2 === 1 ? 0 : keyframes.length - 1;
    return keyframes[index];
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"aZWjK":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "animateValue", ()=>animateValue);
var _keyframesMjs = require("../../generators/keyframes.mjs");
var _indexMjs = require("../../generators/spring/index.mjs");
var _inertiaMjs = require("../../generators/inertia.mjs");
var _driverFrameloopMjs = require("./driver-frameloop.mjs");
var _interpolateMjs = require("../../../utils/interpolate.mjs");
var _clampMjs = require("../../../utils/clamp.mjs");
var _timeConversionMjs = require("../../../utils/time-conversion.mjs");
var _calcDurationMjs = require("../../generators/utils/calc-duration.mjs");
var _errorsMjs = require("../../../utils/errors.mjs");
const types = {
    decay: (0, _inertiaMjs.inertia),
    inertia: (0, _inertiaMjs.inertia),
    tween: (0, _keyframesMjs.keyframes),
    keyframes: (0, _keyframesMjs.keyframes),
    spring: (0, _indexMjs.spring)
};
/**
 * Animate a single value on the main thread.
 *
 * This function is written, where functionality overlaps,
 * to be largely spec-compliant with WAAPI to allow fungibility
 * between the two.
 */ function animateValue({ autoplay = true, delay = 0, driver = (0, _driverFrameloopMjs.frameloopDriver), keyframes: keyframes$1, type = "keyframes", repeat = 0, repeatDelay = 0, repeatType = "loop", onPlay, onStop, onComplete, onUpdate, ...options }) {
    let speed = 1;
    let hasStopped = false;
    let resolveFinishedPromise;
    let currentFinishedPromise;
    /**
     * Resolve the current Promise every time we enter the
     * finished state. This is WAAPI-compatible behaviour.
     */ const updateFinishedPromise = ()=>{
        currentFinishedPromise = new Promise((resolve)=>{
            resolveFinishedPromise = resolve;
        });
    };
    // Create the first finished promise
    updateFinishedPromise();
    let animationDriver;
    const generatorFactory = types[type] || (0, _keyframesMjs.keyframes);
    /**
     * If this isn't the keyframes generator and we've been provided
     * strings as keyframes, we need to interpolate these.
     */ let mapNumbersToKeyframes;
    if (generatorFactory !== (0, _keyframesMjs.keyframes) && typeof keyframes$1[0] !== "number") {
        mapNumbersToKeyframes = (0, _interpolateMjs.interpolate)([
            0,
            100
        ], keyframes$1, {
            clamp: false
        });
        keyframes$1 = [
            0,
            100
        ];
    }
    const generator = generatorFactory({
        ...options,
        keyframes: keyframes$1
    });
    let mirroredGenerator;
    if (repeatType === "mirror") mirroredGenerator = generatorFactory({
        ...options,
        keyframes: [
            ...keyframes$1
        ].reverse(),
        velocity: -(options.velocity || 0)
    });
    let playState = "idle";
    let holdTime = null;
    let startTime = null;
    let cancelTime = null;
    /**
     * If duration is undefined and we have repeat options,
     * we need to calculate a duration from the generator.
     *
     * We set it to the generator itself to cache the duration.
     * Any timeline resolver will need to have already precalculated
     * the duration by this step.
     */ if (generator.calculatedDuration === null && repeat) generator.calculatedDuration = (0, _calcDurationMjs.calcGeneratorDuration)(generator);
    const { calculatedDuration } = generator;
    let resolvedDuration = Infinity;
    let totalDuration = Infinity;
    if (calculatedDuration !== null) {
        resolvedDuration = calculatedDuration + repeatDelay;
        totalDuration = resolvedDuration * (repeat + 1) - repeatDelay;
    }
    let currentTime = 0;
    const tick = (timestamp)=>{
        if (startTime === null) return;
        /**
         * requestAnimationFrame timestamps can come through as lower than
         * the startTime as set by performance.now(). Here we prevent this,
         * though in the future it could be possible to make setting startTime
         * a pending operation that gets resolved here.
         */ if (speed > 0) startTime = Math.min(startTime, timestamp);
        if (speed < 0) startTime = Math.min(timestamp - totalDuration / speed, startTime);
        if (holdTime !== null) currentTime = holdTime;
        else // Rounding the time because floating point arithmetic is not always accurate, e.g. 3000.367 - 1000.367 =
        // 2000.0000000000002. This is a problem when we are comparing the currentTime with the duration, for
        // example.
        currentTime = Math.round(timestamp - startTime) * speed;
        // Rebase on delay
        const timeWithoutDelay = currentTime - delay * (speed >= 0 ? 1 : -1);
        const isInDelayPhase = speed >= 0 ? timeWithoutDelay < 0 : timeWithoutDelay > totalDuration;
        currentTime = Math.max(timeWithoutDelay, 0);
        /**
         * If this animation has finished, set the current time
         * to the total duration.
         */ if (playState === "finished" && holdTime === null) currentTime = totalDuration;
        let elapsed = currentTime;
        let frameGenerator = generator;
        if (repeat) {
            /**
             * Get the current progress (0-1) of the animation. If t is >
             * than duration we'll get values like 2.5 (midway through the
             * third iteration)
             */ const progress = Math.min(currentTime, totalDuration) / resolvedDuration;
            /**
             * Get the current iteration (0 indexed). For instance the floor of
             * 2.5 is 2.
             */ let currentIteration = Math.floor(progress);
            /**
             * Get the current progress of the iteration by taking the remainder
             * so 2.5 is 0.5 through iteration 2
             */ let iterationProgress = progress % 1.0;
            /**
             * If iteration progress is 1 we count that as the end
             * of the previous iteration.
             */ if (!iterationProgress && progress >= 1) iterationProgress = 1;
            iterationProgress === 1 && currentIteration--;
            currentIteration = Math.min(currentIteration, repeat + 1);
            /**
             * Reverse progress if we're not running in "normal" direction
             */ const isOddIteration = Boolean(currentIteration % 2);
            if (isOddIteration) {
                if (repeatType === "reverse") {
                    iterationProgress = 1 - iterationProgress;
                    if (repeatDelay) iterationProgress -= repeatDelay / resolvedDuration;
                } else if (repeatType === "mirror") frameGenerator = mirroredGenerator;
            }
            elapsed = (0, _clampMjs.clamp)(0, 1, iterationProgress) * resolvedDuration;
        }
        /**
         * If we're in negative time, set state as the initial keyframe.
         * This prevents delay: x, duration: 0 animations from finishing
         * instantly.
         */ const state = isInDelayPhase ? {
            done: false,
            value: keyframes$1[0]
        } : frameGenerator.next(elapsed);
        if (mapNumbersToKeyframes) state.value = mapNumbersToKeyframes(state.value);
        let { done } = state;
        if (!isInDelayPhase && calculatedDuration !== null) done = speed >= 0 ? currentTime >= totalDuration : currentTime <= 0;
        const isAnimationFinished = holdTime === null && (playState === "finished" || playState === "running" && done);
        if (onUpdate) onUpdate(state.value);
        if (isAnimationFinished) finish();
        return state;
    };
    const stopAnimationDriver = ()=>{
        animationDriver && animationDriver.stop();
        animationDriver = undefined;
    };
    const cancel = ()=>{
        playState = "idle";
        stopAnimationDriver();
        resolveFinishedPromise();
        updateFinishedPromise();
        startTime = cancelTime = null;
    };
    const finish = ()=>{
        playState = "finished";
        onComplete && onComplete();
        stopAnimationDriver();
        resolveFinishedPromise();
    };
    const play = ()=>{
        if (hasStopped) return;
        if (!animationDriver) animationDriver = driver(tick);
        const now = animationDriver.now();
        onPlay && onPlay();
        if (holdTime !== null) startTime = now - holdTime;
        else if (!startTime || playState === "finished") startTime = now;
        if (playState === "finished") updateFinishedPromise();
        cancelTime = startTime;
        holdTime = null;
        /**
         * Set playState to running only after we've used it in
         * the previous logic.
         */ playState = "running";
        animationDriver.start();
    };
    if (autoplay) play();
    const controls = {
        then (resolve, reject) {
            return currentFinishedPromise.then(resolve, reject);
        },
        get time () {
            return (0, _timeConversionMjs.millisecondsToSeconds)(currentTime);
        },
        set time (newTime){
            newTime = (0, _timeConversionMjs.secondsToMilliseconds)(newTime);
            currentTime = newTime;
            if (holdTime !== null || !animationDriver || speed === 0) holdTime = newTime;
            else startTime = animationDriver.now() - newTime / speed;
        },
        get duration () {
            const duration = generator.calculatedDuration === null ? (0, _calcDurationMjs.calcGeneratorDuration)(generator) : generator.calculatedDuration;
            return (0, _timeConversionMjs.millisecondsToSeconds)(duration);
        },
        get speed () {
            return speed;
        },
        set speed (newSpeed){
            if (newSpeed === speed || !animationDriver) return;
            speed = newSpeed;
            controls.time = (0, _timeConversionMjs.millisecondsToSeconds)(currentTime);
        },
        get state () {
            return playState;
        },
        play,
        pause: ()=>{
            playState = "paused";
            holdTime = currentTime;
        },
        stop: ()=>{
            hasStopped = true;
            if (playState === "idle") return;
            playState = "idle";
            onStop && onStop();
            cancel();
        },
        cancel: ()=>{
            if (cancelTime !== null) tick(cancelTime);
            cancel();
        },
        complete: ()=>{
            playState = "finished";
        },
        sample: (elapsed)=>{
            startTime = 0;
            return tick(elapsed);
        }
    };
    return controls;
}

},{"../../generators/keyframes.mjs":"aMfwc","../../generators/spring/index.mjs":"iksp4","../../generators/inertia.mjs":"hNMyk","./driver-frameloop.mjs":"jh6Zc","../../../utils/interpolate.mjs":"jAMAj","../../../utils/clamp.mjs":"5mu0r","../../../utils/time-conversion.mjs":"4Ib29","../../generators/utils/calc-duration.mjs":"6dAY6","../../../utils/errors.mjs":"buT6L","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"aMfwc":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "defaultEasing", ()=>defaultEasing);
parcelHelpers.export(exports, "keyframes", ()=>keyframes);
var _easeMjs = require("../../easing/ease.mjs");
var _isEasingArrayMjs = require("../../easing/utils/is-easing-array.mjs");
var _mapMjs = require("../../easing/utils/map.mjs");
var _interpolateMjs = require("../../utils/interpolate.mjs");
var _defaultMjs = require("../../utils/offsets/default.mjs");
var _timeMjs = require("../../utils/offsets/time.mjs");
function defaultEasing(values, easing) {
    return values.map(()=>easing || (0, _easeMjs.easeInOut)).splice(0, values.length - 1);
}
function keyframes({ duration = 300, keyframes: keyframeValues, times, ease = "easeInOut" }) {
    /**
     * Easing functions can be externally defined as strings. Here we convert them
     * into actual functions.
     */ const easingFunctions = (0, _isEasingArrayMjs.isEasingArray)(ease) ? ease.map((0, _mapMjs.easingDefinitionToFunction)) : (0, _mapMjs.easingDefinitionToFunction)(ease);
    /**
     * This is the Iterator-spec return value. We ensure it's mutable rather than using a generator
     * to reduce GC during animation.
     */ const state = {
        done: false,
        value: keyframeValues[0]
    };
    /**
     * Create a times array based on the provided 0-1 offsets
     */ const absoluteTimes = (0, _timeMjs.convertOffsetToTimes)(// Only use the provided offsets if they're the correct length
    // TODO Maybe we should warn here if there's a length mismatch
    times && times.length === keyframeValues.length ? times : (0, _defaultMjs.defaultOffset)(keyframeValues), duration);
    const mapTimeToKeyframe = (0, _interpolateMjs.interpolate)(absoluteTimes, keyframeValues, {
        ease: Array.isArray(easingFunctions) ? easingFunctions : defaultEasing(keyframeValues, easingFunctions)
    });
    return {
        calculatedDuration: duration,
        next: (t)=>{
            state.value = mapTimeToKeyframe(t);
            state.done = t >= duration;
            return state;
        }
    };
}

},{"../../easing/ease.mjs":"jzDFo","../../easing/utils/is-easing-array.mjs":"4Txnl","../../easing/utils/map.mjs":"hxClO","../../utils/interpolate.mjs":"jAMAj","../../utils/offsets/default.mjs":"9XN04","../../utils/offsets/time.mjs":"d7nmm","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"jzDFo":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "easeIn", ()=>easeIn);
parcelHelpers.export(exports, "easeInOut", ()=>easeInOut);
parcelHelpers.export(exports, "easeOut", ()=>easeOut);
var _cubicBezierMjs = require("./cubic-bezier.mjs");
const easeIn = (0, _cubicBezierMjs.cubicBezier)(0.42, 0, 1, 1);
const easeOut = (0, _cubicBezierMjs.cubicBezier)(0, 0, 0.58, 1);
const easeInOut = (0, _cubicBezierMjs.cubicBezier)(0.42, 0, 0.58, 1);

},{"./cubic-bezier.mjs":"kosBT","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"kosBT":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "cubicBezier", ()=>cubicBezier);
var _noopMjs = require("../utils/noop.mjs");
/*
  Bezier function generator
  This has been modified from Gaëtan Renaudeau's BezierEasing
  https://github.com/gre/bezier-easing/blob/master/src/index.js
  https://github.com/gre/bezier-easing/blob/master/LICENSE
  
  I've removed the newtonRaphsonIterate algo because in benchmarking it
  wasn't noticiably faster than binarySubdivision, indeed removing it
  usually improved times, depending on the curve.
  I also removed the lookup table, as for the added bundle size and loop we're
  only cutting ~4 or so subdivision iterations. I bumped the max iterations up
  to 12 to compensate and this still tended to be faster for no perceivable
  loss in accuracy.
  Usage
    const easeOut = cubicBezier(.17,.67,.83,.67);
    const x = easeOut(0.5); // returns 0.627...
*/ // Returns x(t) given t, x1, and x2, or y(t) given t, y1, and y2.
const calcBezier = (t, a1, a2)=>(((1.0 - 3.0 * a2 + 3.0 * a1) * t + (3.0 * a2 - 6.0 * a1)) * t + 3.0 * a1) * t;
const subdivisionPrecision = 0.0000001;
const subdivisionMaxIterations = 12;
function binarySubdivide(x, lowerBound, upperBound, mX1, mX2) {
    let currentX;
    let currentT;
    let i = 0;
    do {
        currentT = lowerBound + (upperBound - lowerBound) / 2.0;
        currentX = calcBezier(currentT, mX1, mX2) - x;
        if (currentX > 0.0) upperBound = currentT;
        else lowerBound = currentT;
    }while (Math.abs(currentX) > subdivisionPrecision && ++i < subdivisionMaxIterations);
    return currentT;
}
function cubicBezier(mX1, mY1, mX2, mY2) {
    // If this is a linear gradient, return linear easing
    if (mX1 === mY1 && mX2 === mY2) return 0, _noopMjs.noop;
    const getTForX = (aX)=>binarySubdivide(aX, 0, 1, mX1, mX2);
    // If animation is at start/end, return t without easing
    return (t)=>t === 0 || t === 1 ? t : calcBezier(getTForX(t), mY1, mY2);
}

},{"../utils/noop.mjs":"7roqC","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4Txnl":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isEasingArray", ()=>isEasingArray);
const isEasingArray = (ease)=>{
    return Array.isArray(ease) && typeof ease[0] !== "number";
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"hxClO":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "easingDefinitionToFunction", ()=>easingDefinitionToFunction);
var _errorsMjs = require("../../utils/errors.mjs");
var _cubicBezierMjs = require("../cubic-bezier.mjs");
var _noopMjs = require("../../utils/noop.mjs");
var _easeMjs = require("../ease.mjs");
var _circMjs = require("../circ.mjs");
var _backMjs = require("../back.mjs");
var _anticipateMjs = require("../anticipate.mjs");
const easingLookup = {
    linear: (0, _noopMjs.noop),
    easeIn: (0, _easeMjs.easeIn),
    easeInOut: (0, _easeMjs.easeInOut),
    easeOut: (0, _easeMjs.easeOut),
    circIn: (0, _circMjs.circIn),
    circInOut: (0, _circMjs.circInOut),
    circOut: (0, _circMjs.circOut),
    backIn: (0, _backMjs.backIn),
    backInOut: (0, _backMjs.backInOut),
    backOut: (0, _backMjs.backOut),
    anticipate: (0, _anticipateMjs.anticipate)
};
const easingDefinitionToFunction = (definition)=>{
    if (Array.isArray(definition)) {
        // If cubic bezier definition, create bezier curve
        (0, _errorsMjs.invariant)(definition.length === 4, `Cubic bezier arrays must contain four numerical values.`);
        const [x1, y1, x2, y2] = definition;
        return (0, _cubicBezierMjs.cubicBezier)(x1, y1, x2, y2);
    } else if (typeof definition === "string") {
        // Else lookup from table
        (0, _errorsMjs.invariant)(easingLookup[definition] !== undefined, `Invalid easing type '${definition}'`);
        return easingLookup[definition];
    }
    return definition;
};

},{"../../utils/errors.mjs":"buT6L","../cubic-bezier.mjs":"kosBT","../../utils/noop.mjs":"7roqC","../ease.mjs":"jzDFo","../circ.mjs":"do4I6","../back.mjs":"ltXlp","../anticipate.mjs":"dNYZe","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"do4I6":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "circIn", ()=>circIn);
parcelHelpers.export(exports, "circInOut", ()=>circInOut);
parcelHelpers.export(exports, "circOut", ()=>circOut);
var _mirrorMjs = require("./modifiers/mirror.mjs");
var _reverseMjs = require("./modifiers/reverse.mjs");
const circIn = (p)=>1 - Math.sin(Math.acos(p));
const circOut = (0, _reverseMjs.reverseEasing)(circIn);
const circInOut = (0, _mirrorMjs.mirrorEasing)(circIn);

},{"./modifiers/mirror.mjs":"gCkJC","./modifiers/reverse.mjs":"gWJrc","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"gCkJC":[function(require,module,exports) {
// Accepts an easing function and returns a new one that outputs mirrored values for
// the second half of the animation. Turns easeIn into easeInOut.
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "mirrorEasing", ()=>mirrorEasing);
const mirrorEasing = (easing)=>(p)=>p <= 0.5 ? easing(2 * p) / 2 : (2 - easing(2 * (1 - p))) / 2;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"gWJrc":[function(require,module,exports) {
// Accepts an easing function and returns a new one that outputs reversed values.
// Turns easeIn into easeOut.
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "reverseEasing", ()=>reverseEasing);
const reverseEasing = (easing)=>(p)=>1 - easing(1 - p);

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"ltXlp":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "backIn", ()=>backIn);
parcelHelpers.export(exports, "backInOut", ()=>backInOut);
parcelHelpers.export(exports, "backOut", ()=>backOut);
var _cubicBezierMjs = require("./cubic-bezier.mjs");
var _mirrorMjs = require("./modifiers/mirror.mjs");
var _reverseMjs = require("./modifiers/reverse.mjs");
const backOut = (0, _cubicBezierMjs.cubicBezier)(0.33, 1.53, 0.69, 0.99);
const backIn = (0, _reverseMjs.reverseEasing)(backOut);
const backInOut = (0, _mirrorMjs.mirrorEasing)(backIn);

},{"./cubic-bezier.mjs":"kosBT","./modifiers/mirror.mjs":"gCkJC","./modifiers/reverse.mjs":"gWJrc","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"dNYZe":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "anticipate", ()=>anticipate);
var _backMjs = require("./back.mjs");
const anticipate = (p)=>(p *= 2) < 1 ? 0.5 * (0, _backMjs.backIn)(p) : 0.5 * (2 - Math.pow(2, -10 * (p - 1)));

},{"./back.mjs":"ltXlp","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"jAMAj":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "interpolate", ()=>interpolate);
var _errorsMjs = require("./errors.mjs");
var _indexMjs = require("../value/types/color/index.mjs");
var _clampMjs = require("./clamp.mjs");
var _mixMjs = require("./mix.mjs");
var _mixColorMjs = require("./mix-color.mjs");
var _mixComplexMjs = require("./mix-complex.mjs");
var _pipeMjs = require("./pipe.mjs");
var _progressMjs = require("./progress.mjs");
var _noopMjs = require("./noop.mjs");
const mixNumber = (from, to)=>(p)=>(0, _mixMjs.mix)(from, to, p);
function detectMixerFactory(v) {
    if (typeof v === "number") return mixNumber;
    else if (typeof v === "string") return (0, _indexMjs.color).test(v) ? (0, _mixColorMjs.mixColor) : (0, _mixComplexMjs.mixComplex);
    else if (Array.isArray(v)) return 0, _mixComplexMjs.mixArray;
    else if (typeof v === "object") return 0, _mixComplexMjs.mixObject;
    return mixNumber;
}
function createMixers(output, ease, customMixer) {
    const mixers = [];
    const mixerFactory = customMixer || detectMixerFactory(output[0]);
    const numMixers = output.length - 1;
    for(let i = 0; i < numMixers; i++){
        let mixer = mixerFactory(output[i], output[i + 1]);
        if (ease) {
            const easingFunction = Array.isArray(ease) ? ease[i] || (0, _noopMjs.noop) : ease;
            mixer = (0, _pipeMjs.pipe)(easingFunction, mixer);
        }
        mixers.push(mixer);
    }
    return mixers;
}
/**
 * Create a function that maps from a numerical input array to a generic output array.
 *
 * Accepts:
 *   - Numbers
 *   - Colors (hex, hsl, hsla, rgb, rgba)
 *   - Complex (combinations of one or more numbers or strings)
 *
 * ```jsx
 * const mixColor = interpolate([0, 1], ['#fff', '#000'])
 *
 * mixColor(0.5) // 'rgba(128, 128, 128, 1)'
 * ```
 *
 * TODO Revist this approach once we've moved to data models for values,
 * probably not needed to pregenerate mixer functions.
 *
 * @public
 */ function interpolate(input, output, { clamp: isClamp = true, ease, mixer } = {}) {
    const inputLength = input.length;
    (0, _errorsMjs.invariant)(inputLength === output.length, "Both input and output ranges must be the same length");
    /**
     * If we're only provided a single input, we can just make a function
     * that returns the output.
     */ if (inputLength === 1) return ()=>output[0];
    // If input runs highest -> lowest, reverse both arrays
    if (input[0] > input[inputLength - 1]) {
        input = [
            ...input
        ].reverse();
        output = [
            ...output
        ].reverse();
    }
    const mixers = createMixers(output, ease, mixer);
    const numMixers = mixers.length;
    const interpolator = (v)=>{
        let i = 0;
        if (numMixers > 1) for(; i < input.length - 2; i++){
            if (v < input[i + 1]) break;
        }
        const progressInRange = (0, _progressMjs.progress)(input[i], input[i + 1], v);
        return mixers[i](progressInRange);
    };
    return isClamp ? (v)=>interpolator((0, _clampMjs.clamp)(input[0], input[inputLength - 1], v)) : interpolator;
}

},{"./errors.mjs":"buT6L","../value/types/color/index.mjs":"aGDwe","./clamp.mjs":"5mu0r","./mix.mjs":"cEof3","./mix-color.mjs":"h6xCO","./mix-complex.mjs":"g38iv","./pipe.mjs":"jSVi0","./progress.mjs":"4ZPxX","./noop.mjs":"7roqC","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"aGDwe":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "color", ()=>color);
var _utilsMjs = require("../utils.mjs");
var _hexMjs = require("./hex.mjs");
var _hslaMjs = require("./hsla.mjs");
var _rgbaMjs = require("./rgba.mjs");
const color = {
    test: (v)=>(0, _rgbaMjs.rgba).test(v) || (0, _hexMjs.hex).test(v) || (0, _hslaMjs.hsla).test(v),
    parse: (v)=>{
        if ((0, _rgbaMjs.rgba).test(v)) return (0, _rgbaMjs.rgba).parse(v);
        else if ((0, _hslaMjs.hsla).test(v)) return (0, _hslaMjs.hsla).parse(v);
        else return (0, _hexMjs.hex).parse(v);
    },
    transform: (v)=>{
        return (0, _utilsMjs.isString)(v) ? v : v.hasOwnProperty("red") ? (0, _rgbaMjs.rgba).transform(v) : (0, _hslaMjs.hsla).transform(v);
    }
};

},{"../utils.mjs":"6nEM8","./hex.mjs":"g5QYb","./hsla.mjs":"fk7hg","./rgba.mjs":"5TA5M","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"g5QYb":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "hex", ()=>hex);
var _rgbaMjs = require("./rgba.mjs");
var _utilsMjs = require("./utils.mjs");
function parseHex(v) {
    let r = "";
    let g = "";
    let b = "";
    let a = "";
    // If we have 6 characters, ie #FF0000
    if (v.length > 5) {
        r = v.substring(1, 3);
        g = v.substring(3, 5);
        b = v.substring(5, 7);
        a = v.substring(7, 9);
    // Or we have 3 characters, ie #F00
    } else {
        r = v.substring(1, 2);
        g = v.substring(2, 3);
        b = v.substring(3, 4);
        a = v.substring(4, 5);
        r += r;
        g += g;
        b += b;
        a += a;
    }
    return {
        red: parseInt(r, 16),
        green: parseInt(g, 16),
        blue: parseInt(b, 16),
        alpha: a ? parseInt(a, 16) / 255 : 1
    };
}
const hex = {
    test: (0, _utilsMjs.isColorString)("#"),
    parse: parseHex,
    transform: (0, _rgbaMjs.rgba).transform
};

},{"./rgba.mjs":"5TA5M","./utils.mjs":"98EVl","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"5TA5M":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "rgbUnit", ()=>rgbUnit);
parcelHelpers.export(exports, "rgba", ()=>rgba);
var _clampMjs = require("../../../utils/clamp.mjs");
var _indexMjs = require("../numbers/index.mjs");
var _utilsMjs = require("../utils.mjs");
var _utilsMjs1 = require("./utils.mjs");
const clampRgbUnit = (v)=>(0, _clampMjs.clamp)(0, 255, v);
const rgbUnit = {
    ...(0, _indexMjs.number),
    transform: (v)=>Math.round(clampRgbUnit(v))
};
const rgba = {
    test: (0, _utilsMjs1.isColorString)("rgb", "red"),
    parse: (0, _utilsMjs1.splitColor)("red", "green", "blue"),
    transform: ({ red, green, blue, alpha: alpha$1 = 1 })=>"rgba(" + rgbUnit.transform(red) + ", " + rgbUnit.transform(green) + ", " + rgbUnit.transform(blue) + ", " + (0, _utilsMjs.sanitize)((0, _indexMjs.alpha).transform(alpha$1)) + ")"
};

},{"../../../utils/clamp.mjs":"5mu0r","../numbers/index.mjs":"bcOBd","../utils.mjs":"6nEM8","./utils.mjs":"98EVl","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"98EVl":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isColorString", ()=>isColorString);
parcelHelpers.export(exports, "splitColor", ()=>splitColor);
var _utilsMjs = require("../utils.mjs");
/**
 * Returns true if the provided string is a color, ie rgba(0,0,0,0) or #000,
 * but false if a number or multiple colors
 */ const isColorString = (type, testProp)=>(v)=>{
        return Boolean((0, _utilsMjs.isString)(v) && (0, _utilsMjs.singleColorRegex).test(v) && v.startsWith(type) || testProp && Object.prototype.hasOwnProperty.call(v, testProp));
    };
const splitColor = (aName, bName, cName)=>(v)=>{
        if (!(0, _utilsMjs.isString)(v)) return v;
        const [a, b, c, alpha] = v.match((0, _utilsMjs.floatRegex));
        return {
            [aName]: parseFloat(a),
            [bName]: parseFloat(b),
            [cName]: parseFloat(c),
            alpha: alpha !== undefined ? parseFloat(alpha) : 1
        };
    };

},{"../utils.mjs":"6nEM8","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"fk7hg":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "hsla", ()=>hsla);
var _indexMjs = require("../numbers/index.mjs");
var _unitsMjs = require("../numbers/units.mjs");
var _utilsMjs = require("../utils.mjs");
var _utilsMjs1 = require("./utils.mjs");
const hsla = {
    test: (0, _utilsMjs1.isColorString)("hsl", "hue"),
    parse: (0, _utilsMjs1.splitColor)("hue", "saturation", "lightness"),
    transform: ({ hue, saturation, lightness, alpha: alpha$1 = 1 })=>{
        return "hsla(" + Math.round(hue) + ", " + (0, _unitsMjs.percent).transform((0, _utilsMjs.sanitize)(saturation)) + ", " + (0, _unitsMjs.percent).transform((0, _utilsMjs.sanitize)(lightness)) + ", " + (0, _utilsMjs.sanitize)((0, _indexMjs.alpha).transform(alpha$1)) + ")";
    }
};

},{"../numbers/index.mjs":"bcOBd","../numbers/units.mjs":"hGtBr","../utils.mjs":"6nEM8","./utils.mjs":"98EVl","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"cEof3":[function(require,module,exports) {
/*
  Value in range from progress

  Given a lower limit and an upper limit, we return the value within
  that range as expressed by progress (usually a number from 0 to 1)

  So progress = 0.5 would change

  from -------- to

  to

  from ---- to

  E.g. from = 10, to = 20, progress = 0.5 => 15

  @param [number]: Lower limit of range
  @param [number]: Upper limit of range
  @param [number]: The progress between lower and upper limits expressed 0-1
  @return [number]: Value as calculated from progress within range (not limited within range)
*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "mix", ()=>mix);
const mix = (from, to, progress)=>-progress * from + progress * to + from;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"h6xCO":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "mixColor", ()=>mixColor);
parcelHelpers.export(exports, "mixLinearColor", ()=>mixLinearColor);
var _mixMjs = require("./mix.mjs");
var _errorsMjs = require("./errors.mjs");
var _hslaToRgbaMjs = require("./hsla-to-rgba.mjs");
var _hexMjs = require("../value/types/color/hex.mjs");
var _rgbaMjs = require("../value/types/color/rgba.mjs");
var _hslaMjs = require("../value/types/color/hsla.mjs");
// Linear color space blending
// Explained https://www.youtube.com/watch?v=LKnqECcg6Gw
// Demonstrated http://codepen.io/osublake/pen/xGVVaN
const mixLinearColor = (from, to, v)=>{
    const fromExpo = from * from;
    return Math.sqrt(Math.max(0, v * (to * to - fromExpo) + fromExpo));
};
const colorTypes = [
    (0, _hexMjs.hex),
    (0, _rgbaMjs.rgba),
    (0, _hslaMjs.hsla)
];
const getColorType = (v)=>colorTypes.find((type)=>type.test(v));
function asRGBA(color) {
    const type = getColorType(color);
    (0, _errorsMjs.invariant)(Boolean(type), `'${color}' is not an animatable color. Use the equivalent color code instead.`);
    let model = type.parse(color);
    if (type === (0, _hslaMjs.hsla)) // TODO Remove this cast - needed since Framer Motion's stricter typing
    model = (0, _hslaToRgbaMjs.hslaToRgba)(model);
    return model;
}
const mixColor = (from, to)=>{
    const fromRGBA = asRGBA(from);
    const toRGBA = asRGBA(to);
    const blended = {
        ...fromRGBA
    };
    return (v)=>{
        blended.red = mixLinearColor(fromRGBA.red, toRGBA.red, v);
        blended.green = mixLinearColor(fromRGBA.green, toRGBA.green, v);
        blended.blue = mixLinearColor(fromRGBA.blue, toRGBA.blue, v);
        blended.alpha = (0, _mixMjs.mix)(fromRGBA.alpha, toRGBA.alpha, v);
        return (0, _rgbaMjs.rgba).transform(blended);
    };
};

},{"./mix.mjs":"cEof3","./errors.mjs":"buT6L","./hsla-to-rgba.mjs":"8MEIz","../value/types/color/hex.mjs":"g5QYb","../value/types/color/rgba.mjs":"5TA5M","../value/types/color/hsla.mjs":"fk7hg","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8MEIz":[function(require,module,exports) {
// Adapted from https://gist.github.com/mjackson/5311256
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "hslaToRgba", ()=>hslaToRgba);
function hueToRgb(p, q, t) {
    if (t < 0) t += 1;
    if (t > 1) t -= 1;
    if (t < 1 / 6) return p + (q - p) * 6 * t;
    if (t < 0.5) return q;
    if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
    return p;
}
function hslaToRgba({ hue, saturation, lightness, alpha }) {
    hue /= 360;
    saturation /= 100;
    lightness /= 100;
    let red = 0;
    let green = 0;
    let blue = 0;
    if (!saturation) red = green = blue = lightness;
    else {
        const q = lightness < 0.5 ? lightness * (1 + saturation) : lightness + saturation - lightness * saturation;
        const p = 2 * lightness - q;
        red = hueToRgb(p, q, hue + 1 / 3);
        green = hueToRgb(p, q, hue);
        blue = hueToRgb(p, q, hue - 1 / 3);
    }
    return {
        red: Math.round(red * 255),
        green: Math.round(green * 255),
        blue: Math.round(blue * 255),
        alpha
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"g38iv":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "mixArray", ()=>mixArray);
parcelHelpers.export(exports, "mixComplex", ()=>mixComplex);
parcelHelpers.export(exports, "mixObject", ()=>mixObject);
var _mixMjs = require("./mix.mjs");
var _mixColorMjs = require("./mix-color.mjs");
var _pipeMjs = require("./pipe.mjs");
var _errorsMjs = require("./errors.mjs");
var _indexMjs = require("../value/types/color/index.mjs");
var _indexMjs1 = require("../value/types/complex/index.mjs");
const mixImmediate = (origin, target)=>(p)=>`${p > 0 ? target : origin}`;
function getMixer(origin, target) {
    if (typeof origin === "number") return (v)=>(0, _mixMjs.mix)(origin, target, v);
    else if ((0, _indexMjs.color).test(origin)) return (0, _mixColorMjs.mixColor)(origin, target);
    else return origin.startsWith("var(") ? mixImmediate(origin, target) : mixComplex(origin, target);
}
const mixArray = (from, to)=>{
    const output = [
        ...from
    ];
    const numValues = output.length;
    const blendValue = from.map((fromThis, i)=>getMixer(fromThis, to[i]));
    return (v)=>{
        for(let i = 0; i < numValues; i++)output[i] = blendValue[i](v);
        return output;
    };
};
const mixObject = (origin, target)=>{
    const output = {
        ...origin,
        ...target
    };
    const blendValue = {};
    for(const key in output)if (origin[key] !== undefined && target[key] !== undefined) blendValue[key] = getMixer(origin[key], target[key]);
    return (v)=>{
        for(const key in blendValue)output[key] = blendValue[key](v);
        return output;
    };
};
const mixComplex = (origin, target)=>{
    const template = (0, _indexMjs1.complex).createTransformer(target);
    const originStats = (0, _indexMjs1.analyseComplexValue)(origin);
    const targetStats = (0, _indexMjs1.analyseComplexValue)(target);
    const canInterpolate = originStats.numVars === targetStats.numVars && originStats.numColors === targetStats.numColors && originStats.numNumbers >= targetStats.numNumbers;
    if (canInterpolate) return (0, _pipeMjs.pipe)(mixArray(originStats.values, targetStats.values), template);
    else {
        (0, _errorsMjs.warning)(true, `Complex values '${origin}' and '${target}' too different to mix. Ensure all colors are of the same type, and that each contains the same quantity of number and color values. Falling back to instant transition.`);
        return mixImmediate(origin, target);
    }
};

},{"./mix.mjs":"cEof3","./mix-color.mjs":"h6xCO","./pipe.mjs":"jSVi0","./errors.mjs":"buT6L","../value/types/color/index.mjs":"aGDwe","../value/types/complex/index.mjs":"7EbqM","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7EbqM":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "analyseComplexValue", ()=>analyseComplexValue);
parcelHelpers.export(exports, "complex", ()=>complex);
var _isCssVariableMjs = require("../../../render/dom/utils/is-css-variable.mjs");
var _noopMjs = require("../../../utils/noop.mjs");
var _indexMjs = require("../color/index.mjs");
var _indexMjs1 = require("../numbers/index.mjs");
var _utilsMjs = require("../utils.mjs");
function test(v) {
    var _a, _b;
    return isNaN(v) && (0, _utilsMjs.isString)(v) && (((_a = v.match((0, _utilsMjs.floatRegex))) === null || _a === void 0 ? void 0 : _a.length) || 0) + (((_b = v.match((0, _utilsMjs.colorRegex))) === null || _b === void 0 ? void 0 : _b.length) || 0) > 0;
}
const cssVarTokeniser = {
    regex: (0, _isCssVariableMjs.cssVariableRegex),
    countKey: "Vars",
    token: "${v}",
    parse: (0, _noopMjs.noop)
};
const colorTokeniser = {
    regex: (0, _utilsMjs.colorRegex),
    countKey: "Colors",
    token: "${c}",
    parse: (0, _indexMjs.color).parse
};
const numberTokeniser = {
    regex: (0, _utilsMjs.floatRegex),
    countKey: "Numbers",
    token: "${n}",
    parse: (0, _indexMjs1.number).parse
};
function tokenise(info, { regex, countKey, token, parse }) {
    const matches = info.tokenised.match(regex);
    if (!matches) return;
    info["num" + countKey] = matches.length;
    info.tokenised = info.tokenised.replace(regex, token);
    info.values.push(...matches.map(parse));
}
function analyseComplexValue(value) {
    const originalValue = value.toString();
    const info = {
        value: originalValue,
        tokenised: originalValue,
        values: [],
        numVars: 0,
        numColors: 0,
        numNumbers: 0
    };
    if (info.value.includes("var(--")) tokenise(info, cssVarTokeniser);
    tokenise(info, colorTokeniser);
    tokenise(info, numberTokeniser);
    return info;
}
function parseComplexValue(v) {
    return analyseComplexValue(v).values;
}
function createTransformer(source) {
    const { values, numColors, numVars, tokenised } = analyseComplexValue(source);
    const numValues = values.length;
    return (v)=>{
        let output = tokenised;
        for(let i = 0; i < numValues; i++){
            if (i < numVars) output = output.replace(cssVarTokeniser.token, v[i]);
            else if (i < numVars + numColors) output = output.replace(colorTokeniser.token, (0, _indexMjs.color).transform(v[i]));
            else output = output.replace(numberTokeniser.token, (0, _utilsMjs.sanitize)(v[i]));
        }
        return output;
    };
}
const convertNumbersToZero = (v)=>typeof v === "number" ? 0 : v;
function getAnimatableNone(v) {
    const parsed = parseComplexValue(v);
    const transformer = createTransformer(v);
    return transformer(parsed.map(convertNumbersToZero));
}
const complex = {
    test,
    parse: parseComplexValue,
    createTransformer,
    getAnimatableNone
};

},{"../../../render/dom/utils/is-css-variable.mjs":"58wqN","../../../utils/noop.mjs":"7roqC","../color/index.mjs":"aGDwe","../numbers/index.mjs":"bcOBd","../utils.mjs":"6nEM8","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4ZPxX":[function(require,module,exports) {
/*
  Progress within given range

  Given a lower limit and an upper limit, we return the progress
  (expressed as a number 0-1) represented by the given value, and
  limit that progress to within 0-1.

  @param [number]: Lower limit
  @param [number]: Upper limit
  @param [number]: Value to find progress within given range
  @return [number]: Progress of value within range as expressed 0-1
*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "progress", ()=>progress);
const progress = (from, to, value)=>{
    const toFromDifference = to - from;
    return toFromDifference === 0 ? 1 : (value - from) / toFromDifference;
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9XN04":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "defaultOffset", ()=>defaultOffset);
var _fillMjs = require("./fill.mjs");
function defaultOffset(arr) {
    const offset = [
        0
    ];
    (0, _fillMjs.fillOffset)(offset, arr.length - 1);
    return offset;
}

},{"./fill.mjs":"ikoC0","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"ikoC0":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "fillOffset", ()=>fillOffset);
var _mixMjs = require("../mix.mjs");
var _progressMjs = require("../progress.mjs");
function fillOffset(offset, remaining) {
    const min = offset[offset.length - 1];
    for(let i = 1; i <= remaining; i++){
        const offsetProgress = (0, _progressMjs.progress)(0, remaining, i);
        offset.push((0, _mixMjs.mix)(min, 1, offsetProgress));
    }
}

},{"../mix.mjs":"cEof3","../progress.mjs":"4ZPxX","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"d7nmm":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "convertOffsetToTimes", ()=>convertOffsetToTimes);
function convertOffsetToTimes(offset, duration) {
    return offset.map((o)=>o * duration);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"iksp4":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "spring", ()=>spring);
var _timeConversionMjs = require("../../../utils/time-conversion.mjs");
var _velocityMjs = require("../utils/velocity.mjs");
var _findMjs = require("./find.mjs");
const durationKeys = [
    "duration",
    "bounce"
];
const physicsKeys = [
    "stiffness",
    "damping",
    "mass"
];
function isSpringType(options, keys) {
    return keys.some((key)=>options[key] !== undefined);
}
function getSpringOptions(options) {
    let springOptions = {
        velocity: 0.0,
        stiffness: 100,
        damping: 10,
        mass: 1.0,
        isResolvedFromDuration: false,
        ...options
    };
    // stiffness/damping/mass overrides duration/bounce
    if (!isSpringType(options, physicsKeys) && isSpringType(options, durationKeys)) {
        const derived = (0, _findMjs.findSpring)(options);
        springOptions = {
            ...springOptions,
            ...derived,
            mass: 1.0
        };
        springOptions.isResolvedFromDuration = true;
    }
    return springOptions;
}
function spring({ keyframes, restDelta, restSpeed, ...options }) {
    const origin = keyframes[0];
    const target = keyframes[keyframes.length - 1];
    /**
     * This is the Iterator-spec return value. We ensure it's mutable rather than using a generator
     * to reduce GC during animation.
     */ const state = {
        done: false,
        value: origin
    };
    const { stiffness, damping, mass, duration, velocity, isResolvedFromDuration } = getSpringOptions({
        ...options,
        velocity: -(0, _timeConversionMjs.millisecondsToSeconds)(options.velocity || 0)
    });
    const initialVelocity = velocity || 0.0;
    const dampingRatio = damping / (2 * Math.sqrt(stiffness * mass));
    const initialDelta = target - origin;
    const undampedAngularFreq = (0, _timeConversionMjs.millisecondsToSeconds)(Math.sqrt(stiffness / mass));
    /**
     * If we're working on a granular scale, use smaller defaults for determining
     * when the spring is finished.
     *
     * These defaults have been selected emprically based on what strikes a good
     * ratio between feeling good and finishing as soon as changes are imperceptible.
     */ const isGranularScale = Math.abs(initialDelta) < 5;
    restSpeed || (restSpeed = isGranularScale ? 0.01 : 2);
    restDelta || (restDelta = isGranularScale ? 0.005 : 0.5);
    let resolveSpring;
    if (dampingRatio < 1) {
        const angularFreq = (0, _findMjs.calcAngularFreq)(undampedAngularFreq, dampingRatio);
        // Underdamped spring
        resolveSpring = (t)=>{
            const envelope = Math.exp(-dampingRatio * undampedAngularFreq * t);
            return target - envelope * ((initialVelocity + dampingRatio * undampedAngularFreq * initialDelta) / angularFreq * Math.sin(angularFreq * t) + initialDelta * Math.cos(angularFreq * t));
        };
    } else if (dampingRatio === 1) // Critically damped spring
    resolveSpring = (t)=>target - Math.exp(-undampedAngularFreq * t) * (initialDelta + (initialVelocity + undampedAngularFreq * initialDelta) * t);
    else {
        // Overdamped spring
        const dampedAngularFreq = undampedAngularFreq * Math.sqrt(dampingRatio * dampingRatio - 1);
        resolveSpring = (t)=>{
            const envelope = Math.exp(-dampingRatio * undampedAngularFreq * t);
            // When performing sinh or cosh values can hit Infinity so we cap them here
            const freqForT = Math.min(dampedAngularFreq * t, 300);
            return target - envelope * ((initialVelocity + dampingRatio * undampedAngularFreq * initialDelta) * Math.sinh(freqForT) + dampedAngularFreq * initialDelta * Math.cosh(freqForT)) / dampedAngularFreq;
        };
    }
    return {
        calculatedDuration: isResolvedFromDuration ? duration || null : null,
        next: (t)=>{
            const current = resolveSpring(t);
            if (!isResolvedFromDuration) {
                let currentVelocity = initialVelocity;
                if (t !== 0) {
                    /**
                     * We only need to calculate velocity for under-damped springs
                     * as over- and critically-damped springs can't overshoot, so
                     * checking only for displacement is enough.
                     */ if (dampingRatio < 1) currentVelocity = (0, _velocityMjs.calcGeneratorVelocity)(resolveSpring, t, current);
                    else currentVelocity = 0;
                }
                const isBelowVelocityThreshold = Math.abs(currentVelocity) <= restSpeed;
                const isBelowDisplacementThreshold = Math.abs(target - current) <= restDelta;
                state.done = isBelowVelocityThreshold && isBelowDisplacementThreshold;
            } else state.done = t >= duration;
            state.value = state.done ? target : current;
            return state;
        }
    };
}

},{"../../../utils/time-conversion.mjs":"4Ib29","../utils/velocity.mjs":"89aws","./find.mjs":"fAssx","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"89aws":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "calcGeneratorVelocity", ()=>calcGeneratorVelocity);
var _velocityPerSecondMjs = require("../../../utils/velocity-per-second.mjs");
const velocitySampleDuration = 5; // ms
function calcGeneratorVelocity(resolveValue, t, current) {
    const prevT = Math.max(t - velocitySampleDuration, 0);
    return (0, _velocityPerSecondMjs.velocityPerSecond)(current - resolveValue(prevT), t - prevT);
}

},{"../../../utils/velocity-per-second.mjs":"1HLsw","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"1HLsw":[function(require,module,exports) {
/*
  Convert velocity into velocity per second

  @param [number]: Unit per frame
  @param [number]: Frame duration in ms
*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "velocityPerSecond", ()=>velocityPerSecond);
function velocityPerSecond(velocity, frameDuration) {
    return frameDuration ? velocity * (1000 / frameDuration) : 0;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"fAssx":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "calcAngularFreq", ()=>calcAngularFreq);
parcelHelpers.export(exports, "findSpring", ()=>findSpring);
parcelHelpers.export(exports, "maxDamping", ()=>maxDamping);
parcelHelpers.export(exports, "maxDuration", ()=>maxDuration);
parcelHelpers.export(exports, "minDamping", ()=>minDamping);
parcelHelpers.export(exports, "minDuration", ()=>minDuration);
var _errorsMjs = require("../../../utils/errors.mjs");
var _clampMjs = require("../../../utils/clamp.mjs");
var _timeConversionMjs = require("../../../utils/time-conversion.mjs");
const safeMin = 0.001;
const minDuration = 0.01;
const maxDuration = 10.0;
const minDamping = 0.05;
const maxDamping = 1;
function findSpring({ duration = 800, bounce = 0.25, velocity = 0, mass = 1 }) {
    let envelope;
    let derivative;
    (0, _errorsMjs.warning)(duration <= (0, _timeConversionMjs.secondsToMilliseconds)(maxDuration), "Spring duration must be 10 seconds or less");
    let dampingRatio = 1 - bounce;
    /**
     * Restrict dampingRatio and duration to within acceptable ranges.
     */ dampingRatio = (0, _clampMjs.clamp)(minDamping, maxDamping, dampingRatio);
    duration = (0, _clampMjs.clamp)(minDuration, maxDuration, (0, _timeConversionMjs.millisecondsToSeconds)(duration));
    if (dampingRatio < 1) {
        /**
         * Underdamped spring
         */ envelope = (undampedFreq)=>{
            const exponentialDecay = undampedFreq * dampingRatio;
            const delta = exponentialDecay * duration;
            const a = exponentialDecay - velocity;
            const b = calcAngularFreq(undampedFreq, dampingRatio);
            const c = Math.exp(-delta);
            return safeMin - a / b * c;
        };
        derivative = (undampedFreq)=>{
            const exponentialDecay = undampedFreq * dampingRatio;
            const delta = exponentialDecay * duration;
            const d = delta * velocity + velocity;
            const e = Math.pow(dampingRatio, 2) * Math.pow(undampedFreq, 2) * duration;
            const f = Math.exp(-delta);
            const g = calcAngularFreq(Math.pow(undampedFreq, 2), dampingRatio);
            const factor = -envelope(undampedFreq) + safeMin > 0 ? -1 : 1;
            return factor * ((d - e) * f) / g;
        };
    } else {
        /**
         * Critically-damped spring
         */ envelope = (undampedFreq)=>{
            const a = Math.exp(-undampedFreq * duration);
            const b = (undampedFreq - velocity) * duration + 1;
            return -safeMin + a * b;
        };
        derivative = (undampedFreq)=>{
            const a = Math.exp(-undampedFreq * duration);
            const b = (velocity - undampedFreq) * (duration * duration);
            return a * b;
        };
    }
    const initialGuess = 5 / duration;
    const undampedFreq = approximateRoot(envelope, derivative, initialGuess);
    duration = (0, _timeConversionMjs.secondsToMilliseconds)(duration);
    if (isNaN(undampedFreq)) return {
        stiffness: 100,
        damping: 10,
        duration
    };
    else {
        const stiffness = Math.pow(undampedFreq, 2) * mass;
        return {
            stiffness,
            damping: dampingRatio * 2 * Math.sqrt(mass * stiffness),
            duration
        };
    }
}
const rootIterations = 12;
function approximateRoot(envelope, derivative, initialGuess) {
    let result = initialGuess;
    for(let i = 1; i < rootIterations; i++)result = result - envelope(result) / derivative(result);
    return result;
}
function calcAngularFreq(undampedFreq, dampingRatio) {
    return undampedFreq * Math.sqrt(1 - dampingRatio * dampingRatio);
}

},{"../../../utils/errors.mjs":"buT6L","../../../utils/clamp.mjs":"5mu0r","../../../utils/time-conversion.mjs":"4Ib29","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"hNMyk":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "inertia", ()=>inertia);
var _indexMjs = require("./spring/index.mjs");
var _velocityMjs = require("./utils/velocity.mjs");
function inertia({ keyframes, velocity = 0.0, power = 0.8, timeConstant = 325, bounceDamping = 10, bounceStiffness = 500, modifyTarget, min, max, restDelta = 0.5, restSpeed }) {
    const origin = keyframes[0];
    const state = {
        done: false,
        value: origin
    };
    const isOutOfBounds = (v)=>min !== undefined && v < min || max !== undefined && v > max;
    const nearestBoundary = (v)=>{
        if (min === undefined) return max;
        if (max === undefined) return min;
        return Math.abs(min - v) < Math.abs(max - v) ? min : max;
    };
    let amplitude = power * velocity;
    const ideal = origin + amplitude;
    const target = modifyTarget === undefined ? ideal : modifyTarget(ideal);
    /**
     * If the target has changed we need to re-calculate the amplitude, otherwise
     * the animation will start from the wrong position.
     */ if (target !== ideal) amplitude = target - origin;
    const calcDelta = (t)=>-amplitude * Math.exp(-t / timeConstant);
    const calcLatest = (t)=>target + calcDelta(t);
    const applyFriction = (t)=>{
        const delta = calcDelta(t);
        const latest = calcLatest(t);
        state.done = Math.abs(delta) <= restDelta;
        state.value = state.done ? target : latest;
    };
    /**
     * Ideally this would resolve for t in a stateless way, we could
     * do that by always precalculating the animation but as we know
     * this will be done anyway we can assume that spring will
     * be discovered during that.
     */ let timeReachedBoundary;
    let spring$1;
    const checkCatchBoundary = (t)=>{
        if (!isOutOfBounds(state.value)) return;
        timeReachedBoundary = t;
        spring$1 = (0, _indexMjs.spring)({
            keyframes: [
                state.value,
                nearestBoundary(state.value)
            ],
            velocity: (0, _velocityMjs.calcGeneratorVelocity)(calcLatest, t, state.value),
            damping: bounceDamping,
            stiffness: bounceStiffness,
            restDelta,
            restSpeed
        });
    };
    checkCatchBoundary(0);
    return {
        calculatedDuration: null,
        next: (t)=>{
            /**
             * We need to resolve the friction to figure out if we need a
             * spring but we don't want to do this twice per frame. So here
             * we flag if we updated for this frame and later if we did
             * we can skip doing it again.
             */ let hasUpdatedFrame = false;
            if (!spring$1 && timeReachedBoundary === undefined) {
                hasUpdatedFrame = true;
                applyFriction(t);
                checkCatchBoundary(t);
            }
            /**
             * If we have a spring and the provided t is beyond the moment the friction
             * animation crossed the min/max boundary, use the spring.
             */ if (timeReachedBoundary !== undefined && t > timeReachedBoundary) return spring$1.next(t - timeReachedBoundary);
            else {
                !hasUpdatedFrame && applyFriction(t);
                return state;
            }
        }
    };
}

},{"./spring/index.mjs":"iksp4","./utils/velocity.mjs":"89aws","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"jh6Zc":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "frameloopDriver", ()=>frameloopDriver);
var _frameMjs = require("../../../frameloop/frame.mjs");
const frameloopDriver = (update)=>{
    const passTimestamp = ({ timestamp })=>update(timestamp);
    return {
        start: ()=>(0, _frameMjs.frame).update(passTimestamp, true),
        stop: ()=>(0, _frameMjs.cancelFrame)(passTimestamp),
        /**
         * If we're processing this frame we can use the
         * framelocked timestamp to keep things in sync.
         */ now: ()=>(0, _frameMjs.frameData).isProcessing ? (0, _frameMjs.frameData).timestamp : performance.now()
    };
};

},{"../../../frameloop/frame.mjs":"gdRIq","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"6dAY6":[function(require,module,exports) {
/**
 * Implement a practical max duration for keyframe generation
 * to prevent infinite loops
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "calcGeneratorDuration", ()=>calcGeneratorDuration);
parcelHelpers.export(exports, "maxGeneratorDuration", ()=>maxGeneratorDuration);
const maxGeneratorDuration = 20000;
function calcGeneratorDuration(generator) {
    let duration = 0;
    const timeStep = 50;
    let state = generator.next(duration);
    while(!state.done && duration < maxGeneratorDuration){
        duration += timeStep;
        state = generator.next(duration);
    }
    return duration >= maxGeneratorDuration ? Infinity : duration;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"fxVXL":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "memo", ()=>memo);
function memo(callback) {
    let result;
    return ()=>{
        if (result === undefined) result = callback();
        return result;
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"kyxLH":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createInstantAnimation", ()=>createInstantAnimation);
var _indexMjs = require("./js/index.mjs");
var _noopMjs = require("../../utils/noop.mjs");
function createInstantAnimation({ keyframes, delay, onUpdate, onComplete }) {
    const setValue = ()=>{
        onUpdate && onUpdate(keyframes[keyframes.length - 1]);
        onComplete && onComplete();
        /**
         * TODO: As this API grows it could make sense to always return
         * animateValue. This will be a bigger project as animateValue
         * is frame-locked whereas this function resolves instantly.
         * This is a behavioural change and also has ramifications regarding
         * assumptions within tests.
         */ return {
            time: 0,
            speed: 1,
            duration: 0,
            play: (0, _noopMjs.noop),
            pause: (0, _noopMjs.noop),
            stop: (0, _noopMjs.noop),
            then: (resolve)=>{
                resolve();
                return Promise.resolve();
            },
            cancel: (0, _noopMjs.noop),
            complete: (0, _noopMjs.noop)
        };
    };
    return delay ? (0, _indexMjs.animateValue)({
        keyframes: [
            0,
            1
        ],
        duration: 0,
        delay,
        onComplete: setValue
    }) : setValue();
}

},{"./js/index.mjs":"aZWjK","../../utils/noop.mjs":"7roqC","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"1j1Wa":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getDefaultTransition", ()=>getDefaultTransition);
var _transformMjs = require("../../render/html/utils/transform.mjs");
const underDampedSpring = {
    type: "spring",
    stiffness: 500,
    damping: 25,
    restSpeed: 10
};
const criticallyDampedSpring = (target)=>({
        type: "spring",
        stiffness: 550,
        damping: target === 0 ? 2 * Math.sqrt(550) : 30,
        restSpeed: 10
    });
const keyframesTransition = {
    type: "keyframes",
    duration: 0.8
};
/**
 * Default easing curve is a slightly shallower version of
 * the default browser easing curve.
 */ const ease = {
    type: "keyframes",
    ease: [
        0.25,
        0.1,
        0.35,
        1
    ],
    duration: 0.3
};
const getDefaultTransition = (valueKey, { keyframes })=>{
    if (keyframes.length > 2) return keyframesTransition;
    else if ((0, _transformMjs.transformProps).has(valueKey)) return valueKey.startsWith("scale") ? criticallyDampedSpring(keyframes[1]) : underDampedSpring;
    return ease;
};

},{"../../render/html/utils/transform.mjs":"es0QE","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8Qgk1":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isAnimatable", ()=>isAnimatable);
var _indexMjs = require("../../value/types/complex/index.mjs");
/**
 * Check if a value is animatable. Examples:
 *
 * ✅: 100, "100px", "#fff"
 * ❌: "block", "url(2.jpg)"
 * @param value
 *
 * @internal
 */ const isAnimatable = (key, value)=>{
    // If the list of keys tat might be non-animatable grows, replace with Set
    if (key === "zIndex") return false;
    // If it's a number or a keyframes array, we can animate it. We might at some point
    // need to do a deep isAnimatable check of keyframes, or let Popmotion handle this,
    // but for now lets leave it like this for performance reasons
    if (typeof value === "number" || Array.isArray(value)) return true;
    if (typeof value === "string" && // It's animatable if we have a string
    ((0, _indexMjs.complex).test(value) || value === "0") && // And it contains numbers and/or colors
    !value.startsWith("url(") // Unless it starts with "url("
    ) return true;
    return false;
};

},{"../../value/types/complex/index.mjs":"7EbqM","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8nRWE":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getKeyframes", ()=>getKeyframes);
var _animatableNoneMjs = require("../../render/dom/value-types/animatable-none.mjs");
var _isAnimatableMjs = require("./is-animatable.mjs");
var _isNoneMjs = require("./is-none.mjs");
function getKeyframes(value, valueName, target, transition) {
    const isTargetAnimatable = (0, _isAnimatableMjs.isAnimatable)(valueName, target);
    let keyframes;
    if (Array.isArray(target)) keyframes = [
        ...target
    ];
    else keyframes = [
        null,
        target
    ];
    const defaultOrigin = transition.from !== undefined ? transition.from : value.get();
    let animatableTemplateValue = undefined;
    const noneKeyframeIndexes = [];
    for(let i = 0; i < keyframes.length; i++){
        /**
         * Fill null/wildcard keyframes
         */ if (keyframes[i] === null) keyframes[i] = i === 0 ? defaultOrigin : keyframes[i - 1];
        if ((0, _isNoneMjs.isNone)(keyframes[i])) noneKeyframeIndexes.push(i);
        // TODO: Clean this conditional, it works for now
        if (typeof keyframes[i] === "string" && keyframes[i] !== "none" && keyframes[i] !== "0") animatableTemplateValue = keyframes[i];
    }
    if (isTargetAnimatable && noneKeyframeIndexes.length && animatableTemplateValue) for(let i = 0; i < noneKeyframeIndexes.length; i++){
        const index = noneKeyframeIndexes[i];
        keyframes[index] = (0, _animatableNoneMjs.getAnimatableNone)(valueName, animatableTemplateValue);
    }
    return keyframes;
}

},{"../../render/dom/value-types/animatable-none.mjs":"6j7Wd","./is-animatable.mjs":"8Qgk1","./is-none.mjs":"cckdv","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"6j7Wd":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getAnimatableNone", ()=>getAnimatableNone);
var _indexMjs = require("../../../value/types/complex/index.mjs");
var _filterMjs = require("../../../value/types/complex/filter.mjs");
var _defaultsMjs = require("./defaults.mjs");
function getAnimatableNone(key, value) {
    let defaultValueType = (0, _defaultsMjs.getDefaultValueType)(key);
    if (defaultValueType !== (0, _filterMjs.filter)) defaultValueType = (0, _indexMjs.complex);
    // If value is not recognised as animatable, ie "none", create an animatable version origin based on the target
    return defaultValueType.getAnimatableNone ? defaultValueType.getAnimatableNone(value) : undefined;
}

},{"../../../value/types/complex/index.mjs":"7EbqM","../../../value/types/complex/filter.mjs":"a7Mfy","./defaults.mjs":"5j9jO","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"a7Mfy":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "filter", ()=>filter);
var _indexMjs = require("./index.mjs");
var _utilsMjs = require("../utils.mjs");
/**
 * Properties that should default to 1 or 100%
 */ const maxDefaults = new Set([
    "brightness",
    "contrast",
    "saturate",
    "opacity"
]);
function applyDefaultFilter(v) {
    const [name, value] = v.slice(0, -1).split("(");
    if (name === "drop-shadow") return v;
    const [number] = value.match((0, _utilsMjs.floatRegex)) || [];
    if (!number) return v;
    const unit = value.replace(number, "");
    let defaultValue = maxDefaults.has(name) ? 1 : 0;
    if (number !== value) defaultValue *= 100;
    return name + "(" + defaultValue + unit + ")";
}
const functionRegex = /([a-z-]*)\(.*?\)/g;
const filter = {
    ...(0, _indexMjs.complex),
    getAnimatableNone: (v)=>{
        const functions = v.match(functionRegex);
        return functions ? functions.map(applyDefaultFilter).join(" ") : v;
    }
};

},{"./index.mjs":"7EbqM","../utils.mjs":"6nEM8","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"5j9jO":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "defaultValueTypes", ()=>defaultValueTypes);
parcelHelpers.export(exports, "getDefaultValueType", ()=>getDefaultValueType);
var _indexMjs = require("../../../value/types/color/index.mjs");
var _filterMjs = require("../../../value/types/complex/filter.mjs");
var _numberMjs = require("./number.mjs");
/**
 * A map of default value types for common values
 */ const defaultValueTypes = {
    ...(0, _numberMjs.numberValueTypes),
    color: // Color props
    (0, _indexMjs.color),
    backgroundColor: (0, _indexMjs.color),
    outlineColor: (0, _indexMjs.color),
    fill: (0, _indexMjs.color),
    stroke: (0, _indexMjs.color),
    // Border props
    borderColor: (0, _indexMjs.color),
    borderTopColor: (0, _indexMjs.color),
    borderRightColor: (0, _indexMjs.color),
    borderBottomColor: (0, _indexMjs.color),
    borderLeftColor: (0, _indexMjs.color),
    filter: (0, _filterMjs.filter),
    WebkitFilter: (0, _filterMjs.filter)
};
/**
 * Gets the default ValueType for the provided value key
 */ const getDefaultValueType = (key)=>defaultValueTypes[key];

},{"../../../value/types/color/index.mjs":"aGDwe","../../../value/types/complex/filter.mjs":"a7Mfy","./number.mjs":"fQqUe","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"cckdv":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isNone", ()=>isNone);
var _isZeroValueStringMjs = require("../../utils/is-zero-value-string.mjs");
function isNone(value) {
    if (typeof value === "number") return value === 0;
    else if (value !== null) return value === "none" || value === "0" || (0, _isZeroValueStringMjs.isZeroValueString)(value);
}

},{"../../utils/is-zero-value-string.mjs":"2ZdX2","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2ZdX2":[function(require,module,exports) {
/**
 * Check if the value is a zero value string like "0px" or "0%"
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isZeroValueString", ()=>isZeroValueString);
const isZeroValueString = (v)=>/^0[^.\s]+$/.test(v);

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"hIHWM":[function(require,module,exports) {
/**
 * Decide whether a transition is defined on a given Transition.
 * This filters out orchestration options and returns true
 * if any options are left.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getValueTransition", ()=>getValueTransition);
parcelHelpers.export(exports, "isTransitionDefined", ()=>isTransitionDefined);
function isTransitionDefined({ when, delay: _delay, delayChildren, staggerChildren, staggerDirection, repeat, repeatType, repeatDelay, from, elapsed, ...transition }) {
    return !!Object.keys(transition).length;
}
function getValueTransition(transition, key) {
    return transition[key] || transition["default"] || transition;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"duUiC":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MotionGlobalConfig", ()=>MotionGlobalConfig);
const MotionGlobalConfig = {
    skipAnimations: false
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"cLEeP":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isWillChangeMotionValue", ()=>isWillChangeMotionValue);
var _isMotionValueMjs = require("../utils/is-motion-value.mjs");
function isWillChangeMotionValue(value) {
    return Boolean((0, _isMotionValueMjs.isMotionValue)(value) && value.add);
}

},{"../utils/is-motion-value.mjs":"2kZP7","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"jlhrk":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "checkTargetForNewValues", ()=>checkTargetForNewValues);
parcelHelpers.export(exports, "getOrigin", ()=>getOrigin);
parcelHelpers.export(exports, "getOriginFromTransition", ()=>getOriginFromTransition);
parcelHelpers.export(exports, "setTarget", ()=>setTarget);
parcelHelpers.export(exports, "setValues", ()=>setValues);
var _isNumericalStringMjs = require("../../utils/is-numerical-string.mjs");
var _isZeroValueStringMjs = require("../../utils/is-zero-value-string.mjs");
var _resolveValueMjs = require("../../utils/resolve-value.mjs");
var _indexMjs = require("../../value/index.mjs");
var _indexMjs1 = require("../../value/types/complex/index.mjs");
var _animatableNoneMjs = require("../dom/value-types/animatable-none.mjs");
var _findMjs = require("../dom/value-types/find.mjs");
var _resolveDynamicVariantsMjs = require("./resolve-dynamic-variants.mjs");
/**
 * Set VisualElement's MotionValue, creating a new MotionValue for it if
 * it doesn't exist.
 */ function setMotionValue(visualElement, key, value) {
    if (visualElement.hasValue(key)) visualElement.getValue(key).set(value);
    else visualElement.addValue(key, (0, _indexMjs.motionValue)(value));
}
function setTarget(visualElement, definition) {
    const resolved = (0, _resolveDynamicVariantsMjs.resolveVariant)(visualElement, definition);
    let { transitionEnd = {}, transition = {}, ...target } = resolved ? visualElement.makeTargetAnimatable(resolved, false) : {};
    target = {
        ...target,
        ...transitionEnd
    };
    for(const key in target){
        const value = (0, _resolveValueMjs.resolveFinalValueInKeyframes)(target[key]);
        setMotionValue(visualElement, key, value);
    }
}
function setVariants(visualElement, variantLabels) {
    const reversedLabels = [
        ...variantLabels
    ].reverse();
    reversedLabels.forEach((key)=>{
        const variant = visualElement.getVariant(key);
        variant && setTarget(visualElement, variant);
        if (visualElement.variantChildren) visualElement.variantChildren.forEach((child)=>{
            setVariants(child, variantLabels);
        });
    });
}
function setValues(visualElement, definition) {
    if (Array.isArray(definition)) return setVariants(visualElement, definition);
    else if (typeof definition === "string") return setVariants(visualElement, [
        definition
    ]);
    else setTarget(visualElement, definition);
}
function checkTargetForNewValues(visualElement, target, origin) {
    var _a, _b;
    const newValueKeys = Object.keys(target).filter((key)=>!visualElement.hasValue(key));
    const numNewValues = newValueKeys.length;
    if (!numNewValues) return;
    for(let i = 0; i < numNewValues; i++){
        const key = newValueKeys[i];
        const targetValue = target[key];
        let value = null;
        /**
         * If the target is a series of keyframes, we can use the first value
         * in the array. If this first value is null, we'll still need to read from the DOM.
         */ if (Array.isArray(targetValue)) value = targetValue[0];
        /**
         * If the target isn't keyframes, or the first keyframe was null, we need to
         * first check if an origin value was explicitly defined in the transition as "from",
         * if not read the value from the DOM. As an absolute fallback, take the defined target value.
         */ if (value === null) value = (_b = (_a = origin[key]) !== null && _a !== void 0 ? _a : visualElement.readValue(key)) !== null && _b !== void 0 ? _b : target[key];
        /**
         * If value is still undefined or null, ignore it. Preferably this would throw,
         * but this was causing issues in Framer.
         */ if (value === undefined || value === null) continue;
        if (typeof value === "string" && ((0, _isNumericalStringMjs.isNumericalString)(value) || (0, _isZeroValueStringMjs.isZeroValueString)(value))) // If this is a number read as a string, ie "0" or "200", convert it to a number
        value = parseFloat(value);
        else if (!(0, _findMjs.findValueType)(value) && (0, _indexMjs1.complex).test(targetValue)) value = (0, _animatableNoneMjs.getAnimatableNone)(key, targetValue);
        visualElement.addValue(key, (0, _indexMjs.motionValue)(value, {
            owner: visualElement
        }));
        if (origin[key] === undefined) origin[key] = value;
        if (value !== null) visualElement.setBaseTarget(key, value);
    }
}
function getOriginFromTransition(key, transition) {
    if (!transition) return;
    const valueTransition = transition[key] || transition["default"] || transition;
    return valueTransition.from;
}
function getOrigin(target, transition, visualElement) {
    const origin = {};
    for(const key in target){
        const transitionOrigin = getOriginFromTransition(key, transition);
        if (transitionOrigin !== undefined) origin[key] = transitionOrigin;
        else {
            const value = visualElement.getValue(key);
            if (value) origin[key] = value.get();
        }
    }
    return origin;
}

},{"../../utils/is-numerical-string.mjs":"4HKEF","../../utils/is-zero-value-string.mjs":"2ZdX2","../../utils/resolve-value.mjs":"b1tRE","../../value/index.mjs":"iyeKc","../../value/types/complex/index.mjs":"7EbqM","../dom/value-types/animatable-none.mjs":"6j7Wd","../dom/value-types/find.mjs":"jGIxI","./resolve-dynamic-variants.mjs":"4tXnT","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4HKEF":[function(require,module,exports) {
/**
 * Check if value is a numerical string, ie a string that is purely a number eg "100" or "-100.1"
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isNumericalString", ()=>isNumericalString);
const isNumericalString = (v)=>/^\-?\d*\.?\d+$/.test(v);

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"iyeKc":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MotionValue", ()=>MotionValue);
parcelHelpers.export(exports, "collectMotionValues", ()=>collectMotionValues);
parcelHelpers.export(exports, "motionValue", ()=>motionValue);
var _subscriptionManagerMjs = require("../utils/subscription-manager.mjs");
var _velocityPerSecondMjs = require("../utils/velocity-per-second.mjs");
var _warnOnceMjs = require("../utils/warn-once.mjs");
var _frameMjs = require("../frameloop/frame.mjs");
const isFloat = (value)=>{
    return !isNaN(parseFloat(value));
};
const collectMotionValues = {
    current: undefined
};
/**
 * `MotionValue` is used to track the state and velocity of motion values.
 *
 * @public
 */ class MotionValue {
    /**
     * @param init - The initiating value
     * @param config - Optional configuration options
     *
     * -  `transformer`: A function to transform incoming values with.
     *
     * @internal
     */ constructor(init, options = {}){
        /**
         * This will be replaced by the build step with the latest version number.
         * When MotionValues are provided to motion components, warn if versions are mixed.
         */ this.version = "10.18.0";
        /**
         * Duration, in milliseconds, since last updating frame.
         *
         * @internal
         */ this.timeDelta = 0;
        /**
         * Timestamp of the last time this `MotionValue` was updated.
         *
         * @internal
         */ this.lastUpdated = 0;
        /**
         * Tracks whether this value can output a velocity. Currently this is only true
         * if the value is numerical, but we might be able to widen the scope here and support
         * other value types.
         *
         * @internal
         */ this.canTrackVelocity = false;
        /**
         * An object containing a SubscriptionManager for each active event.
         */ this.events = {};
        this.updateAndNotify = (v, render = true)=>{
            this.prev = this.current;
            this.current = v;
            // Update timestamp
            const { delta, timestamp } = (0, _frameMjs.frameData);
            if (this.lastUpdated !== timestamp) {
                this.timeDelta = delta;
                this.lastUpdated = timestamp;
                (0, _frameMjs.frame).postRender(this.scheduleVelocityCheck);
            }
            // Update update subscribers
            if (this.prev !== this.current && this.events.change) this.events.change.notify(this.current);
            // Update velocity subscribers
            if (this.events.velocityChange) this.events.velocityChange.notify(this.getVelocity());
            // Update render subscribers
            if (render && this.events.renderRequest) this.events.renderRequest.notify(this.current);
        };
        /**
         * Schedule a velocity check for the next frame.
         *
         * This is an instanced and bound function to prevent generating a new
         * function once per frame.
         *
         * @internal
         */ this.scheduleVelocityCheck = ()=>(0, _frameMjs.frame).postRender(this.velocityCheck);
        /**
         * Updates `prev` with `current` if the value hasn't been updated this frame.
         * This ensures velocity calculations return `0`.
         *
         * This is an instanced and bound function to prevent generating a new
         * function once per frame.
         *
         * @internal
         */ this.velocityCheck = ({ timestamp })=>{
            if (timestamp !== this.lastUpdated) {
                this.prev = this.current;
                if (this.events.velocityChange) this.events.velocityChange.notify(this.getVelocity());
            }
        };
        this.hasAnimated = false;
        this.prev = this.current = init;
        this.canTrackVelocity = isFloat(this.current);
        this.owner = options.owner;
    }
    /**
     * Adds a function that will be notified when the `MotionValue` is updated.
     *
     * It returns a function that, when called, will cancel the subscription.
     *
     * When calling `onChange` inside a React component, it should be wrapped with the
     * `useEffect` hook. As it returns an unsubscribe function, this should be returned
     * from the `useEffect` function to ensure you don't add duplicate subscribers..
     *
     * ```jsx
     * export const MyComponent = () => {
     *   const x = useMotionValue(0)
     *   const y = useMotionValue(0)
     *   const opacity = useMotionValue(1)
     *
     *   useEffect(() => {
     *     function updateOpacity() {
     *       const maxXY = Math.max(x.get(), y.get())
     *       const newOpacity = transform(maxXY, [0, 100], [1, 0])
     *       opacity.set(newOpacity)
     *     }
     *
     *     const unsubscribeX = x.on("change", updateOpacity)
     *     const unsubscribeY = y.on("change", updateOpacity)
     *
     *     return () => {
     *       unsubscribeX()
     *       unsubscribeY()
     *     }
     *   }, [])
     *
     *   return <motion.div style={{ x }} />
     * }
     * ```
     *
     * @param subscriber - A function that receives the latest value.
     * @returns A function that, when called, will cancel this subscription.
     *
     * @deprecated
     */ onChange(subscription) {
        return this.on("change", subscription);
    }
    on(eventName, callback) {
        if (!this.events[eventName]) this.events[eventName] = new (0, _subscriptionManagerMjs.SubscriptionManager)();
        const unsubscribe = this.events[eventName].add(callback);
        if (eventName === "change") return ()=>{
            unsubscribe();
            /**
                 * If we have no more change listeners by the start
                 * of the next frame, stop active animations.
                 */ (0, _frameMjs.frame).read(()=>{
                if (!this.events.change.getSize()) this.stop();
            });
        };
        return unsubscribe;
    }
    clearListeners() {
        for(const eventManagers in this.events)this.events[eventManagers].clear();
    }
    /**
     * Attaches a passive effect to the `MotionValue`.
     *
     * @internal
     */ attach(passiveEffect, stopPassiveEffect) {
        this.passiveEffect = passiveEffect;
        this.stopPassiveEffect = stopPassiveEffect;
    }
    /**
     * Sets the state of the `MotionValue`.
     *
     * @remarks
     *
     * ```jsx
     * const x = useMotionValue(0)
     * x.set(10)
     * ```
     *
     * @param latest - Latest value to set.
     * @param render - Whether to notify render subscribers. Defaults to `true`
     *
     * @public
     */ set(v, render = true) {
        if (!render || !this.passiveEffect) this.updateAndNotify(v, render);
        else this.passiveEffect(v, this.updateAndNotify);
    }
    setWithVelocity(prev, current, delta) {
        this.set(current);
        this.prev = prev;
        this.timeDelta = delta;
    }
    /**
     * Set the state of the `MotionValue`, stopping any active animations,
     * effects, and resets velocity to `0`.
     */ jump(v) {
        this.updateAndNotify(v);
        this.prev = v;
        this.stop();
        if (this.stopPassiveEffect) this.stopPassiveEffect();
    }
    /**
     * Returns the latest state of `MotionValue`
     *
     * @returns - The latest state of `MotionValue`
     *
     * @public
     */ get() {
        if (collectMotionValues.current) collectMotionValues.current.push(this);
        return this.current;
    }
    /**
     * @public
     */ getPrevious() {
        return this.prev;
    }
    /**
     * Returns the latest velocity of `MotionValue`
     *
     * @returns - The latest velocity of `MotionValue`. Returns `0` if the state is non-numerical.
     *
     * @public
     */ getVelocity() {
        // This could be isFloat(this.prev) && isFloat(this.current), but that would be wasteful
        return this.canTrackVelocity ? (0, _velocityPerSecondMjs.velocityPerSecond)(parseFloat(this.current) - parseFloat(this.prev), this.timeDelta) : 0;
    }
    /**
     * Registers a new animation to control this `MotionValue`. Only one
     * animation can drive a `MotionValue` at one time.
     *
     * ```jsx
     * value.start()
     * ```
     *
     * @param animation - A function that starts the provided animation
     *
     * @internal
     */ start(startAnimation) {
        this.stop();
        return new Promise((resolve)=>{
            this.hasAnimated = true;
            this.animation = startAnimation(resolve);
            if (this.events.animationStart) this.events.animationStart.notify();
        }).then(()=>{
            if (this.events.animationComplete) this.events.animationComplete.notify();
            this.clearAnimation();
        });
    }
    /**
     * Stop the currently active animation.
     *
     * @public
     */ stop() {
        if (this.animation) {
            this.animation.stop();
            if (this.events.animationCancel) this.events.animationCancel.notify();
        }
        this.clearAnimation();
    }
    /**
     * Returns `true` if this value is currently animating.
     *
     * @public
     */ isAnimating() {
        return !!this.animation;
    }
    clearAnimation() {
        delete this.animation;
    }
    /**
     * Destroy and clean up subscribers to this `MotionValue`.
     *
     * The `MotionValue` hooks like `useMotionValue` and `useTransform` automatically
     * handle the lifecycle of the returned `MotionValue`, so this method is only necessary if you've manually
     * created a `MotionValue` via the `motionValue` function.
     *
     * @public
     */ destroy() {
        this.clearListeners();
        this.stop();
        if (this.stopPassiveEffect) this.stopPassiveEffect();
    }
}
function motionValue(init, options) {
    return new MotionValue(init, options);
}

},{"../utils/subscription-manager.mjs":"dlxLW","../utils/velocity-per-second.mjs":"1HLsw","../utils/warn-once.mjs":"5dNlE","../frameloop/frame.mjs":"gdRIq","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"dlxLW":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SubscriptionManager", ()=>SubscriptionManager);
var _arrayMjs = require("./array.mjs");
class SubscriptionManager {
    constructor(){
        this.subscriptions = [];
    }
    add(handler) {
        (0, _arrayMjs.addUniqueItem)(this.subscriptions, handler);
        return ()=>(0, _arrayMjs.removeItem)(this.subscriptions, handler);
    }
    notify(a, b, c) {
        const numSubscriptions = this.subscriptions.length;
        if (!numSubscriptions) return;
        if (numSubscriptions === 1) /**
             * If there's only a single handler we can just call it without invoking a loop.
             */ this.subscriptions[0](a, b, c);
        else for(let i = 0; i < numSubscriptions; i++){
            /**
                 * Check whether the handler exists before firing as it's possible
                 * the subscriptions were modified during this loop running.
                 */ const handler = this.subscriptions[i];
            handler && handler(a, b, c);
        }
    }
    getSize() {
        return this.subscriptions.length;
    }
    clear() {
        this.subscriptions.length = 0;
    }
}

},{"./array.mjs":"a76Ek","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"a76Ek":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "addUniqueItem", ()=>addUniqueItem);
parcelHelpers.export(exports, "moveItem", ()=>moveItem);
parcelHelpers.export(exports, "removeItem", ()=>removeItem);
function addUniqueItem(arr, item) {
    if (arr.indexOf(item) === -1) arr.push(item);
}
function removeItem(arr, item) {
    const index = arr.indexOf(item);
    if (index > -1) arr.splice(index, 1);
}
// Adapted from array-move
function moveItem([...arr], fromIndex, toIndex) {
    const startIndex = fromIndex < 0 ? arr.length + fromIndex : fromIndex;
    if (startIndex >= 0 && startIndex < arr.length) {
        const endIndex = toIndex < 0 ? arr.length + toIndex : toIndex;
        const [item] = arr.splice(fromIndex, 1);
        arr.splice(endIndex, 0, item);
    }
    return arr;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"5dNlE":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "warnOnce", ()=>warnOnce);
const warned = new Set();
function warnOnce(condition, message, element) {
    if (condition || warned.has(message)) return;
    console.warn(message);
    if (element) console.warn(element);
    warned.add(message);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"jGIxI":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "findValueType", ()=>findValueType);
var _indexMjs = require("../../../value/types/color/index.mjs");
var _indexMjs1 = require("../../../value/types/complex/index.mjs");
var _dimensionsMjs = require("./dimensions.mjs");
var _testMjs = require("./test.mjs");
/**
 * A list of all ValueTypes
 */ const valueTypes = [
    ...(0, _dimensionsMjs.dimensionValueTypes),
    (0, _indexMjs.color),
    (0, _indexMjs1.complex)
];
/**
 * Tests a value against the list of ValueTypes
 */ const findValueType = (v)=>valueTypes.find((0, _testMjs.testValueType)(v));

},{"../../../value/types/color/index.mjs":"aGDwe","../../../value/types/complex/index.mjs":"7EbqM","./dimensions.mjs":"8qh9y","./test.mjs":"3Alhf","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8qh9y":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "dimensionValueTypes", ()=>dimensionValueTypes);
parcelHelpers.export(exports, "findDimensionValueType", ()=>findDimensionValueType);
var _indexMjs = require("../../../value/types/numbers/index.mjs");
var _unitsMjs = require("../../../value/types/numbers/units.mjs");
var _testMjs = require("./test.mjs");
var _typeAutoMjs = require("./type-auto.mjs");
/**
 * A list of value types commonly used for dimensions
 */ const dimensionValueTypes = [
    (0, _indexMjs.number),
    (0, _unitsMjs.px),
    (0, _unitsMjs.percent),
    (0, _unitsMjs.degrees),
    (0, _unitsMjs.vw),
    (0, _unitsMjs.vh),
    (0, _typeAutoMjs.auto)
];
/**
 * Tests a dimensional value against the list of dimension ValueTypes
 */ const findDimensionValueType = (v)=>dimensionValueTypes.find((0, _testMjs.testValueType)(v));

},{"../../../value/types/numbers/index.mjs":"bcOBd","../../../value/types/numbers/units.mjs":"hGtBr","./test.mjs":"3Alhf","./type-auto.mjs":"gqTyb","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"3Alhf":[function(require,module,exports) {
/**
 * Tests a provided value against a ValueType
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "testValueType", ()=>testValueType);
const testValueType = (v)=>(type)=>type.test(v);

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"gqTyb":[function(require,module,exports) {
/**
 * ValueType for "auto"
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "auto", ()=>auto);
const auto = {
    test: (v)=>v === "auto",
    parse: (v)=>v
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"6BoKt":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "animateVariant", ()=>animateVariant);
parcelHelpers.export(exports, "sortByTreeOrder", ()=>sortByTreeOrder);
var _resolveDynamicVariantsMjs = require("../../render/utils/resolve-dynamic-variants.mjs");
var _visualElementTargetMjs = require("./visual-element-target.mjs");
function animateVariant(visualElement, variant, options = {}) {
    const resolved = (0, _resolveDynamicVariantsMjs.resolveVariant)(visualElement, variant, options.custom);
    let { transition = visualElement.getDefaultTransition() || {} } = resolved || {};
    if (options.transitionOverride) transition = options.transitionOverride;
    /**
     * If we have a variant, create a callback that runs it as an animation.
     * Otherwise, we resolve a Promise immediately for a composable no-op.
     */ const getAnimation = resolved ? ()=>Promise.all((0, _visualElementTargetMjs.animateTarget)(visualElement, resolved, options)) : ()=>Promise.resolve();
    /**
     * If we have children, create a callback that runs all their animations.
     * Otherwise, we resolve a Promise immediately for a composable no-op.
     */ const getChildAnimations = visualElement.variantChildren && visualElement.variantChildren.size ? (forwardDelay = 0)=>{
        const { delayChildren = 0, staggerChildren, staggerDirection } = transition;
        return animateChildren(visualElement, variant, delayChildren + forwardDelay, staggerChildren, staggerDirection, options);
    } : ()=>Promise.resolve();
    /**
     * If the transition explicitly defines a "when" option, we need to resolve either
     * this animation or all children animations before playing the other.
     */ const { when } = transition;
    if (when) {
        const [first, last] = when === "beforeChildren" ? [
            getAnimation,
            getChildAnimations
        ] : [
            getChildAnimations,
            getAnimation
        ];
        return first().then(()=>last());
    } else return Promise.all([
        getAnimation(),
        getChildAnimations(options.delay)
    ]);
}
function animateChildren(visualElement, variant, delayChildren = 0, staggerChildren = 0, staggerDirection = 1, options) {
    const animations = [];
    const maxStaggerDuration = (visualElement.variantChildren.size - 1) * staggerChildren;
    const generateStaggerDuration = staggerDirection === 1 ? (i = 0)=>i * staggerChildren : (i = 0)=>maxStaggerDuration - i * staggerChildren;
    Array.from(visualElement.variantChildren).sort(sortByTreeOrder).forEach((child, i)=>{
        child.notify("AnimationStart", variant);
        animations.push(animateVariant(child, variant, {
            ...options,
            delay: delayChildren + generateStaggerDuration(i)
        }).then(()=>child.notify("AnimationComplete", variant)));
    });
    return Promise.all(animations);
}
function sortByTreeOrder(a, b) {
    return a.sortNodePosition(b);
}

},{"../../render/utils/resolve-dynamic-variants.mjs":"4tXnT","./visual-element-target.mjs":"j8sQ3","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"evYau":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ExitAnimationFeature", ()=>ExitAnimationFeature);
var _featureMjs = require("../Feature.mjs");
let id = 0;
class ExitAnimationFeature extends (0, _featureMjs.Feature) {
    constructor(){
        super(...arguments);
        this.id = id++;
    }
    update() {
        if (!this.node.presenceContext) return;
        const { isPresent, onExitComplete, custom } = this.node.presenceContext;
        const { isPresent: prevIsPresent } = this.node.prevPresenceContext || {};
        if (!this.node.animationState || isPresent === prevIsPresent) return;
        const exitAnimation = this.node.animationState.setActive("exit", !isPresent, {
            custom: custom !== null && custom !== void 0 ? custom : this.node.getProps().custom
        });
        if (onExitComplete && !isPresent) exitAnimation.then(()=>onExitComplete(this.id));
    }
    mount() {
        const { register } = this.node.presenceContext || {};
        if (register) this.unmount = register(this.id);
    }
    unmount() {}
}

},{"../Feature.mjs":"9q59Z","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"89DRL":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "drag", ()=>drag);
var _indexMjs = require("../../gestures/drag/index.mjs");
var _indexMjs1 = require("../../gestures/pan/index.mjs");
var _measureLayoutMjs = require("./layout/MeasureLayout.mjs");
var _htmlprojectionNodeMjs = require("../../projection/node/HTMLProjectionNode.mjs");
const drag = {
    pan: {
        Feature: (0, _indexMjs1.PanGesture)
    },
    drag: {
        Feature: (0, _indexMjs.DragGesture),
        ProjectionNode: (0, _htmlprojectionNodeMjs.HTMLProjectionNode),
        MeasureLayout: (0, _measureLayoutMjs.MeasureLayout)
    }
};

},{"../../gestures/drag/index.mjs":"8nmhj","../../gestures/pan/index.mjs":"9LeGk","./layout/MeasureLayout.mjs":"bwaXs","../../projection/node/HTMLProjectionNode.mjs":"eJQj5","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8nmhj":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DragGesture", ()=>DragGesture);
var _featureMjs = require("../../motion/features/Feature.mjs");
var _noopMjs = require("../../utils/noop.mjs");
var _visualElementDragControlsMjs = require("./VisualElementDragControls.mjs");
class DragGesture extends (0, _featureMjs.Feature) {
    constructor(node){
        super(node);
        this.removeGroupControls = (0, _noopMjs.noop);
        this.removeListeners = (0, _noopMjs.noop);
        this.controls = new (0, _visualElementDragControlsMjs.VisualElementDragControls)(node);
    }
    mount() {
        // If we've been provided a DragControls for manual control over the drag gesture,
        // subscribe this component to it on mount.
        const { dragControls } = this.node.getProps();
        if (dragControls) this.removeGroupControls = dragControls.subscribe(this.controls);
        this.removeListeners = this.controls.addListeners() || (0, _noopMjs.noop);
    }
    unmount() {
        this.removeGroupControls();
        this.removeListeners();
    }
}

},{"../../motion/features/Feature.mjs":"9q59Z","../../utils/noop.mjs":"7roqC","./VisualElementDragControls.mjs":"6UZzM","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"6UZzM":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "VisualElementDragControls", ()=>VisualElementDragControls);
parcelHelpers.export(exports, "elementDragControls", ()=>elementDragControls);
var _errorsMjs = require("../../utils/errors.mjs");
var _panSessionMjs = require("../pan/PanSession.mjs");
var _lockMjs = require("./utils/lock.mjs");
var _isRefObjectMjs = require("../../utils/is-ref-object.mjs");
var _addPointerEventMjs = require("../../events/add-pointer-event.mjs");
var _constraintsMjs = require("./utils/constraints.mjs");
var _modelsMjs = require("../../projection/geometry/models.mjs");
var _eachAxisMjs = require("../../projection/utils/each-axis.mjs");
var _measureMjs = require("../../projection/utils/measure.mjs");
var _eventInfoMjs = require("../../events/event-info.mjs");
var _conversionMjs = require("../../projection/geometry/conversion.mjs");
var _addDomEventMjs = require("../../events/add-dom-event.mjs");
var _deltaCalcMjs = require("../../projection/geometry/delta-calc.mjs");
var _mixMjs = require("../../utils/mix.mjs");
var _unitsMjs = require("../../value/types/numbers/units.mjs");
var _motionValueMjs = require("../../animation/interfaces/motion-value.mjs");
var _getContextWindowMjs = require("../../utils/get-context-window.mjs");
var _frameMjs = require("../../frameloop/frame.mjs");
const elementDragControls = new WeakMap();
/**
 *
 */ // let latestPointerEvent: PointerEvent
class VisualElementDragControls {
    constructor(visualElement){
        // This is a reference to the global drag gesture lock, ensuring only one component
        // can "capture" the drag of one or both axes.
        // TODO: Look into moving this into pansession?
        this.openGlobalLock = null;
        this.isDragging = false;
        this.currentDirection = null;
        this.originPoint = {
            x: 0,
            y: 0
        };
        /**
         * The permitted boundaries of travel, in pixels.
         */ this.constraints = false;
        this.hasMutatedConstraints = false;
        /**
         * The per-axis resolved elastic values.
         */ this.elastic = (0, _modelsMjs.createBox)();
        this.visualElement = visualElement;
    }
    start(originEvent, { snapToCursor = false } = {}) {
        /**
         * Don't start dragging if this component is exiting
         */ const { presenceContext } = this.visualElement;
        if (presenceContext && presenceContext.isPresent === false) return;
        const onSessionStart = (event)=>{
            const { dragSnapToOrigin } = this.getProps();
            // Stop or pause any animations on both axis values immediately. This allows the user to throw and catch
            // the component.
            dragSnapToOrigin ? this.pauseAnimation() : this.stopAnimation();
            if (snapToCursor) this.snapToCursor((0, _eventInfoMjs.extractEventInfo)(event, "page").point);
        };
        const onStart = (event, info)=>{
            // Attempt to grab the global drag gesture lock - maybe make this part of PanSession
            const { drag, dragPropagation, onDragStart } = this.getProps();
            if (drag && !dragPropagation) {
                if (this.openGlobalLock) this.openGlobalLock();
                this.openGlobalLock = (0, _lockMjs.getGlobalLock)(drag);
                // If we don 't have the lock, don't start dragging
                if (!this.openGlobalLock) return;
            }
            this.isDragging = true;
            this.currentDirection = null;
            this.resolveConstraints();
            if (this.visualElement.projection) {
                this.visualElement.projection.isAnimationBlocked = true;
                this.visualElement.projection.target = undefined;
            }
            /**
             * Record gesture origin
             */ (0, _eachAxisMjs.eachAxis)((axis)=>{
                let current = this.getAxisMotionValue(axis).get() || 0;
                /**
                 * If the MotionValue is a percentage value convert to px
                 */ if ((0, _unitsMjs.percent).test(current)) {
                    const { projection } = this.visualElement;
                    if (projection && projection.layout) {
                        const measuredAxis = projection.layout.layoutBox[axis];
                        if (measuredAxis) {
                            const length = (0, _deltaCalcMjs.calcLength)(measuredAxis);
                            current = length * (parseFloat(current) / 100);
                        }
                    }
                }
                this.originPoint[axis] = current;
            });
            // Fire onDragStart event
            if (onDragStart) (0, _frameMjs.frame).update(()=>onDragStart(event, info), false, true);
            const { animationState } = this.visualElement;
            animationState && animationState.setActive("whileDrag", true);
        };
        const onMove = (event, info)=>{
            // latestPointerEvent = event
            const { dragPropagation, dragDirectionLock, onDirectionLock, onDrag } = this.getProps();
            // If we didn't successfully receive the gesture lock, early return.
            if (!dragPropagation && !this.openGlobalLock) return;
            const { offset } = info;
            // Attempt to detect drag direction if directionLock is true
            if (dragDirectionLock && this.currentDirection === null) {
                this.currentDirection = getCurrentDirection(offset);
                // If we've successfully set a direction, notify listener
                if (this.currentDirection !== null) onDirectionLock && onDirectionLock(this.currentDirection);
                return;
            }
            // Update each point with the latest position
            this.updateAxis("x", info.point, offset);
            this.updateAxis("y", info.point, offset);
            /**
             * Ideally we would leave the renderer to fire naturally at the end of
             * this frame but if the element is about to change layout as the result
             * of a re-render we want to ensure the browser can read the latest
             * bounding box to ensure the pointer and element don't fall out of sync.
             */ this.visualElement.render();
            /**
             * This must fire after the render call as it might trigger a state
             * change which itself might trigger a layout update.
             */ onDrag && onDrag(event, info);
        };
        const onSessionEnd = (event, info)=>this.stop(event, info);
        const resumeAnimation = ()=>(0, _eachAxisMjs.eachAxis)((axis)=>{
                var _a;
                return this.getAnimationState(axis) === "paused" && ((_a = this.getAxisMotionValue(axis).animation) === null || _a === void 0 ? void 0 : _a.play());
            });
        const { dragSnapToOrigin } = this.getProps();
        this.panSession = new (0, _panSessionMjs.PanSession)(originEvent, {
            onSessionStart,
            onStart,
            onMove,
            onSessionEnd,
            resumeAnimation
        }, {
            transformPagePoint: this.visualElement.getTransformPagePoint(),
            dragSnapToOrigin,
            contextWindow: (0, _getContextWindowMjs.getContextWindow)(this.visualElement)
        });
    }
    stop(event, info) {
        const isDragging = this.isDragging;
        this.cancel();
        if (!isDragging) return;
        const { velocity } = info;
        this.startAnimation(velocity);
        const { onDragEnd } = this.getProps();
        if (onDragEnd) (0, _frameMjs.frame).update(()=>onDragEnd(event, info));
    }
    cancel() {
        this.isDragging = false;
        const { projection, animationState } = this.visualElement;
        if (projection) projection.isAnimationBlocked = false;
        this.panSession && this.panSession.end();
        this.panSession = undefined;
        const { dragPropagation } = this.getProps();
        if (!dragPropagation && this.openGlobalLock) {
            this.openGlobalLock();
            this.openGlobalLock = null;
        }
        animationState && animationState.setActive("whileDrag", false);
    }
    updateAxis(axis, _point, offset) {
        const { drag } = this.getProps();
        // If we're not dragging this axis, do an early return.
        if (!offset || !shouldDrag(axis, drag, this.currentDirection)) return;
        const axisValue = this.getAxisMotionValue(axis);
        let next = this.originPoint[axis] + offset[axis];
        // Apply constraints
        if (this.constraints && this.constraints[axis]) next = (0, _constraintsMjs.applyConstraints)(next, this.constraints[axis], this.elastic[axis]);
        axisValue.set(next);
    }
    resolveConstraints() {
        var _a;
        const { dragConstraints, dragElastic } = this.getProps();
        const layout = this.visualElement.projection && !this.visualElement.projection.layout ? this.visualElement.projection.measure(false) : (_a = this.visualElement.projection) === null || _a === void 0 ? void 0 : _a.layout;
        const prevConstraints = this.constraints;
        if (dragConstraints && (0, _isRefObjectMjs.isRefObject)(dragConstraints)) {
            if (!this.constraints) this.constraints = this.resolveRefConstraints();
        } else if (dragConstraints && layout) this.constraints = (0, _constraintsMjs.calcRelativeConstraints)(layout.layoutBox, dragConstraints);
        else this.constraints = false;
        this.elastic = (0, _constraintsMjs.resolveDragElastic)(dragElastic);
        /**
         * If we're outputting to external MotionValues, we want to rebase the measured constraints
         * from viewport-relative to component-relative.
         */ if (prevConstraints !== this.constraints && layout && this.constraints && !this.hasMutatedConstraints) (0, _eachAxisMjs.eachAxis)((axis)=>{
            if (this.getAxisMotionValue(axis)) this.constraints[axis] = (0, _constraintsMjs.rebaseAxisConstraints)(layout.layoutBox[axis], this.constraints[axis]);
        });
    }
    resolveRefConstraints() {
        const { dragConstraints: constraints, onMeasureDragConstraints } = this.getProps();
        if (!constraints || !(0, _isRefObjectMjs.isRefObject)(constraints)) return false;
        const constraintsElement = constraints.current;
        (0, _errorsMjs.invariant)(constraintsElement !== null, "If `dragConstraints` is set as a React ref, that ref must be passed to another component's `ref` prop.");
        const { projection } = this.visualElement;
        // TODO
        if (!projection || !projection.layout) return false;
        const constraintsBox = (0, _measureMjs.measurePageBox)(constraintsElement, projection.root, this.visualElement.getTransformPagePoint());
        let measuredConstraints = (0, _constraintsMjs.calcViewportConstraints)(projection.layout.layoutBox, constraintsBox);
        /**
         * If there's an onMeasureDragConstraints listener we call it and
         * if different constraints are returned, set constraints to that
         */ if (onMeasureDragConstraints) {
            const userConstraints = onMeasureDragConstraints((0, _conversionMjs.convertBoxToBoundingBox)(measuredConstraints));
            this.hasMutatedConstraints = !!userConstraints;
            if (userConstraints) measuredConstraints = (0, _conversionMjs.convertBoundingBoxToBox)(userConstraints);
        }
        return measuredConstraints;
    }
    startAnimation(velocity) {
        const { drag, dragMomentum, dragElastic, dragTransition, dragSnapToOrigin, onDragTransitionEnd } = this.getProps();
        const constraints = this.constraints || {};
        const momentumAnimations = (0, _eachAxisMjs.eachAxis)((axis)=>{
            if (!shouldDrag(axis, drag, this.currentDirection)) return;
            let transition = constraints && constraints[axis] || {};
            if (dragSnapToOrigin) transition = {
                min: 0,
                max: 0
            };
            /**
             * Overdamp the boundary spring if `dragElastic` is disabled. There's still a frame
             * of spring animations so we should look into adding a disable spring option to `inertia`.
             * We could do something here where we affect the `bounceStiffness` and `bounceDamping`
             * using the value of `dragElastic`.
             */ const bounceStiffness = dragElastic ? 200 : 1000000;
            const bounceDamping = dragElastic ? 40 : 10000000;
            const inertia = {
                type: "inertia",
                velocity: dragMomentum ? velocity[axis] : 0,
                bounceStiffness,
                bounceDamping,
                timeConstant: 750,
                restDelta: 1,
                restSpeed: 10,
                ...dragTransition,
                ...transition
            };
            // If we're not animating on an externally-provided `MotionValue` we can use the
            // component's animation controls which will handle interactions with whileHover (etc),
            // otherwise we just have to animate the `MotionValue` itself.
            return this.startAxisValueAnimation(axis, inertia);
        });
        // Run all animations and then resolve the new drag constraints.
        return Promise.all(momentumAnimations).then(onDragTransitionEnd);
    }
    startAxisValueAnimation(axis, transition) {
        const axisValue = this.getAxisMotionValue(axis);
        return axisValue.start((0, _motionValueMjs.animateMotionValue)(axis, axisValue, 0, transition));
    }
    stopAnimation() {
        (0, _eachAxisMjs.eachAxis)((axis)=>this.getAxisMotionValue(axis).stop());
    }
    pauseAnimation() {
        (0, _eachAxisMjs.eachAxis)((axis)=>{
            var _a;
            return (_a = this.getAxisMotionValue(axis).animation) === null || _a === void 0 ? void 0 : _a.pause();
        });
    }
    getAnimationState(axis) {
        var _a;
        return (_a = this.getAxisMotionValue(axis).animation) === null || _a === void 0 ? void 0 : _a.state;
    }
    /**
     * Drag works differently depending on which props are provided.
     *
     * - If _dragX and _dragY are provided, we output the gesture delta directly to those motion values.
     * - Otherwise, we apply the delta to the x/y motion values.
     */ getAxisMotionValue(axis) {
        const dragKey = "_drag" + axis.toUpperCase();
        const props = this.visualElement.getProps();
        const externalMotionValue = props[dragKey];
        return externalMotionValue ? externalMotionValue : this.visualElement.getValue(axis, (props.initial ? props.initial[axis] : undefined) || 0);
    }
    snapToCursor(point) {
        (0, _eachAxisMjs.eachAxis)((axis)=>{
            const { drag } = this.getProps();
            // If we're not dragging this axis, do an early return.
            if (!shouldDrag(axis, drag, this.currentDirection)) return;
            const { projection } = this.visualElement;
            const axisValue = this.getAxisMotionValue(axis);
            if (projection && projection.layout) {
                const { min, max } = projection.layout.layoutBox[axis];
                axisValue.set(point[axis] - (0, _mixMjs.mix)(min, max, 0.5));
            }
        });
    }
    /**
     * When the viewport resizes we want to check if the measured constraints
     * have changed and, if so, reposition the element within those new constraints
     * relative to where it was before the resize.
     */ scalePositionWithinConstraints() {
        if (!this.visualElement.current) return;
        const { drag, dragConstraints } = this.getProps();
        const { projection } = this.visualElement;
        if (!(0, _isRefObjectMjs.isRefObject)(dragConstraints) || !projection || !this.constraints) return;
        /**
         * Stop current animations as there can be visual glitching if we try to do
         * this mid-animation
         */ this.stopAnimation();
        /**
         * Record the relative position of the dragged element relative to the
         * constraints box and save as a progress value.
         */ const boxProgress = {
            x: 0,
            y: 0
        };
        (0, _eachAxisMjs.eachAxis)((axis)=>{
            const axisValue = this.getAxisMotionValue(axis);
            if (axisValue) {
                const latest = axisValue.get();
                boxProgress[axis] = (0, _constraintsMjs.calcOrigin)({
                    min: latest,
                    max: latest
                }, this.constraints[axis]);
            }
        });
        /**
         * Update the layout of this element and resolve the latest drag constraints
         */ const { transformTemplate } = this.visualElement.getProps();
        this.visualElement.current.style.transform = transformTemplate ? transformTemplate({}, "") : "none";
        projection.root && projection.root.updateScroll();
        projection.updateLayout();
        this.resolveConstraints();
        /**
         * For each axis, calculate the current progress of the layout axis
         * within the new constraints.
         */ (0, _eachAxisMjs.eachAxis)((axis)=>{
            if (!shouldDrag(axis, drag, null)) return;
            /**
             * Calculate a new transform based on the previous box progress
             */ const axisValue = this.getAxisMotionValue(axis);
            const { min, max } = this.constraints[axis];
            axisValue.set((0, _mixMjs.mix)(min, max, boxProgress[axis]));
        });
    }
    addListeners() {
        if (!this.visualElement.current) return;
        elementDragControls.set(this.visualElement, this);
        const element = this.visualElement.current;
        /**
         * Attach a pointerdown event listener on this DOM element to initiate drag tracking.
         */ const stopPointerListener = (0, _addPointerEventMjs.addPointerEvent)(element, "pointerdown", (event)=>{
            const { drag, dragListener = true } = this.getProps();
            drag && dragListener && this.start(event);
        });
        const measureDragConstraints = ()=>{
            const { dragConstraints } = this.getProps();
            if ((0, _isRefObjectMjs.isRefObject)(dragConstraints)) this.constraints = this.resolveRefConstraints();
        };
        const { projection } = this.visualElement;
        const stopMeasureLayoutListener = projection.addEventListener("measure", measureDragConstraints);
        if (projection && !projection.layout) {
            projection.root && projection.root.updateScroll();
            projection.updateLayout();
        }
        measureDragConstraints();
        /**
         * Attach a window resize listener to scale the draggable target within its defined
         * constraints as the window resizes.
         */ const stopResizeListener = (0, _addDomEventMjs.addDomEvent)(window, "resize", ()=>this.scalePositionWithinConstraints());
        /**
         * If the element's layout changes, calculate the delta and apply that to
         * the drag gesture's origin point.
         */ const stopLayoutUpdateListener = projection.addEventListener("didUpdate", ({ delta, hasLayoutChanged })=>{
            if (this.isDragging && hasLayoutChanged) {
                (0, _eachAxisMjs.eachAxis)((axis)=>{
                    const motionValue = this.getAxisMotionValue(axis);
                    if (!motionValue) return;
                    this.originPoint[axis] += delta[axis].translate;
                    motionValue.set(motionValue.get() + delta[axis].translate);
                });
                this.visualElement.render();
            }
        });
        return ()=>{
            stopResizeListener();
            stopPointerListener();
            stopMeasureLayoutListener();
            stopLayoutUpdateListener && stopLayoutUpdateListener();
        };
    }
    getProps() {
        const props = this.visualElement.getProps();
        const { drag = false, dragDirectionLock = false, dragPropagation = false, dragConstraints = false, dragElastic = (0, _constraintsMjs.defaultElastic), dragMomentum = true } = props;
        return {
            ...props,
            drag,
            dragDirectionLock,
            dragPropagation,
            dragConstraints,
            dragElastic,
            dragMomentum
        };
    }
}
function shouldDrag(direction, drag, currentDirection) {
    return (drag === true || drag === direction) && (currentDirection === null || currentDirection === direction);
}
/**
 * Based on an x/y offset determine the current drag direction. If both axis' offsets are lower
 * than the provided threshold, return `null`.
 *
 * @param offset - The x/y offset from origin.
 * @param lockThreshold - (Optional) - the minimum absolute offset before we can determine a drag direction.
 */ function getCurrentDirection(offset, lockThreshold = 10) {
    let direction = null;
    if (Math.abs(offset.y) > lockThreshold) direction = "y";
    else if (Math.abs(offset.x) > lockThreshold) direction = "x";
    return direction;
}

},{"../../utils/errors.mjs":"buT6L","../pan/PanSession.mjs":"ghaRp","./utils/lock.mjs":"1quJ1","../../utils/is-ref-object.mjs":"gluK5","../../events/add-pointer-event.mjs":"k9O8P","./utils/constraints.mjs":"1iIuG","../../projection/geometry/models.mjs":"huYV1","../../projection/utils/each-axis.mjs":"dZLv7","../../projection/utils/measure.mjs":"afNeE","../../events/event-info.mjs":"8dFDB","../../projection/geometry/conversion.mjs":"4G46A","../../events/add-dom-event.mjs":"82u3S","../../projection/geometry/delta-calc.mjs":"lmUuI","../../utils/mix.mjs":"cEof3","../../value/types/numbers/units.mjs":"hGtBr","../../animation/interfaces/motion-value.mjs":"lumbS","../../utils/get-context-window.mjs":"ckiwi","../../frameloop/frame.mjs":"gdRIq","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"ghaRp":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PanSession", ()=>PanSession);
var _eventInfoMjs = require("../../events/event-info.mjs");
var _timeConversionMjs = require("../../utils/time-conversion.mjs");
var _addPointerEventMjs = require("../../events/add-pointer-event.mjs");
var _pipeMjs = require("../../utils/pipe.mjs");
var _distanceMjs = require("../../utils/distance.mjs");
var _isPrimaryPointerMjs = require("../../events/utils/is-primary-pointer.mjs");
var _frameMjs = require("../../frameloop/frame.mjs");
/**
 * @internal
 */ class PanSession {
    constructor(event, handlers, { transformPagePoint, contextWindow, dragSnapToOrigin = false } = {}){
        /**
         * @internal
         */ this.startEvent = null;
        /**
         * @internal
         */ this.lastMoveEvent = null;
        /**
         * @internal
         */ this.lastMoveEventInfo = null;
        /**
         * @internal
         */ this.handlers = {};
        /**
         * @internal
         */ this.contextWindow = window;
        this.updatePoint = ()=>{
            if (!(this.lastMoveEvent && this.lastMoveEventInfo)) return;
            const info = getPanInfo(this.lastMoveEventInfo, this.history);
            const isPanStarted = this.startEvent !== null;
            // Only start panning if the offset is larger than 3 pixels. If we make it
            // any larger than this we'll want to reset the pointer history
            // on the first update to avoid visual snapping to the cursoe.
            const isDistancePastThreshold = (0, _distanceMjs.distance2D)(info.offset, {
                x: 0,
                y: 0
            }) >= 3;
            if (!isPanStarted && !isDistancePastThreshold) return;
            const { point } = info;
            const { timestamp } = (0, _frameMjs.frameData);
            this.history.push({
                ...point,
                timestamp
            });
            const { onStart, onMove } = this.handlers;
            if (!isPanStarted) {
                onStart && onStart(this.lastMoveEvent, info);
                this.startEvent = this.lastMoveEvent;
            }
            onMove && onMove(this.lastMoveEvent, info);
        };
        this.handlePointerMove = (event, info)=>{
            this.lastMoveEvent = event;
            this.lastMoveEventInfo = transformPoint(info, this.transformPagePoint);
            // Throttle mouse move event to once per frame
            (0, _frameMjs.frame).update(this.updatePoint, true);
        };
        this.handlePointerUp = (event, info)=>{
            this.end();
            const { onEnd, onSessionEnd, resumeAnimation } = this.handlers;
            if (this.dragSnapToOrigin) resumeAnimation && resumeAnimation();
            if (!(this.lastMoveEvent && this.lastMoveEventInfo)) return;
            const panInfo = getPanInfo(event.type === "pointercancel" ? this.lastMoveEventInfo : transformPoint(info, this.transformPagePoint), this.history);
            if (this.startEvent && onEnd) onEnd(event, panInfo);
            onSessionEnd && onSessionEnd(event, panInfo);
        };
        // If we have more than one touch, don't start detecting this gesture
        if (!(0, _isPrimaryPointerMjs.isPrimaryPointer)(event)) return;
        this.dragSnapToOrigin = dragSnapToOrigin;
        this.handlers = handlers;
        this.transformPagePoint = transformPagePoint;
        this.contextWindow = contextWindow || window;
        const info = (0, _eventInfoMjs.extractEventInfo)(event);
        const initialInfo = transformPoint(info, this.transformPagePoint);
        const { point } = initialInfo;
        const { timestamp } = (0, _frameMjs.frameData);
        this.history = [
            {
                ...point,
                timestamp
            }
        ];
        const { onSessionStart } = handlers;
        onSessionStart && onSessionStart(event, getPanInfo(initialInfo, this.history));
        this.removeListeners = (0, _pipeMjs.pipe)((0, _addPointerEventMjs.addPointerEvent)(this.contextWindow, "pointermove", this.handlePointerMove), (0, _addPointerEventMjs.addPointerEvent)(this.contextWindow, "pointerup", this.handlePointerUp), (0, _addPointerEventMjs.addPointerEvent)(this.contextWindow, "pointercancel", this.handlePointerUp));
    }
    updateHandlers(handlers) {
        this.handlers = handlers;
    }
    end() {
        this.removeListeners && this.removeListeners();
        (0, _frameMjs.cancelFrame)(this.updatePoint);
    }
}
function transformPoint(info, transformPagePoint) {
    return transformPagePoint ? {
        point: transformPagePoint(info.point)
    } : info;
}
function subtractPoint(a, b) {
    return {
        x: a.x - b.x,
        y: a.y - b.y
    };
}
function getPanInfo({ point }, history) {
    return {
        point,
        delta: subtractPoint(point, lastDevicePoint(history)),
        offset: subtractPoint(point, startDevicePoint(history)),
        velocity: getVelocity(history, 0.1)
    };
}
function startDevicePoint(history) {
    return history[0];
}
function lastDevicePoint(history) {
    return history[history.length - 1];
}
function getVelocity(history, timeDelta) {
    if (history.length < 2) return {
        x: 0,
        y: 0
    };
    let i = history.length - 1;
    let timestampedPoint = null;
    const lastPoint = lastDevicePoint(history);
    while(i >= 0){
        timestampedPoint = history[i];
        if (lastPoint.timestamp - timestampedPoint.timestamp > (0, _timeConversionMjs.secondsToMilliseconds)(timeDelta)) break;
        i--;
    }
    if (!timestampedPoint) return {
        x: 0,
        y: 0
    };
    const time = (0, _timeConversionMjs.millisecondsToSeconds)(lastPoint.timestamp - timestampedPoint.timestamp);
    if (time === 0) return {
        x: 0,
        y: 0
    };
    const currentVelocity = {
        x: (lastPoint.x - timestampedPoint.x) / time,
        y: (lastPoint.y - timestampedPoint.y) / time
    };
    if (currentVelocity.x === Infinity) currentVelocity.x = 0;
    if (currentVelocity.y === Infinity) currentVelocity.y = 0;
    return currentVelocity;
}

},{"../../events/event-info.mjs":"8dFDB","../../utils/time-conversion.mjs":"4Ib29","../../events/add-pointer-event.mjs":"k9O8P","../../utils/pipe.mjs":"jSVi0","../../utils/distance.mjs":"hZ7yn","../../events/utils/is-primary-pointer.mjs":"3NzBE","../../frameloop/frame.mjs":"gdRIq","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"hZ7yn":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "distance", ()=>distance);
parcelHelpers.export(exports, "distance2D", ()=>distance2D);
const distance = (a, b)=>Math.abs(a - b);
function distance2D(a, b) {
    // Multi-dimensional
    const xDelta = distance(a.x, b.x);
    const yDelta = distance(a.y, b.y);
    return Math.sqrt(xDelta ** 2 + yDelta ** 2);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"1iIuG":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "applyConstraints", ()=>applyConstraints);
parcelHelpers.export(exports, "calcOrigin", ()=>calcOrigin);
parcelHelpers.export(exports, "calcRelativeAxisConstraints", ()=>calcRelativeAxisConstraints);
parcelHelpers.export(exports, "calcRelativeConstraints", ()=>calcRelativeConstraints);
parcelHelpers.export(exports, "calcViewportAxisConstraints", ()=>calcViewportAxisConstraints);
parcelHelpers.export(exports, "calcViewportConstraints", ()=>calcViewportConstraints);
parcelHelpers.export(exports, "defaultElastic", ()=>defaultElastic);
parcelHelpers.export(exports, "rebaseAxisConstraints", ()=>rebaseAxisConstraints);
parcelHelpers.export(exports, "resolveAxisElastic", ()=>resolveAxisElastic);
parcelHelpers.export(exports, "resolveDragElastic", ()=>resolveDragElastic);
parcelHelpers.export(exports, "resolvePointElastic", ()=>resolvePointElastic);
var _progressMjs = require("../../../utils/progress.mjs");
var _deltaCalcMjs = require("../../../projection/geometry/delta-calc.mjs");
var _clampMjs = require("../../../utils/clamp.mjs");
var _mixMjs = require("../../../utils/mix.mjs");
/**
 * Apply constraints to a point. These constraints are both physical along an
 * axis, and an elastic factor that determines how much to constrain the point
 * by if it does lie outside the defined parameters.
 */ function applyConstraints(point, { min, max }, elastic) {
    if (min !== undefined && point < min) // If we have a min point defined, and this is outside of that, constrain
    point = elastic ? (0, _mixMjs.mix)(min, point, elastic.min) : Math.max(point, min);
    else if (max !== undefined && point > max) // If we have a max point defined, and this is outside of that, constrain
    point = elastic ? (0, _mixMjs.mix)(max, point, elastic.max) : Math.min(point, max);
    return point;
}
/**
 * Calculate constraints in terms of the viewport when defined relatively to the
 * measured axis. This is measured from the nearest edge, so a max constraint of 200
 * on an axis with a max value of 300 would return a constraint of 500 - axis length
 */ function calcRelativeAxisConstraints(axis, min, max) {
    return {
        min: min !== undefined ? axis.min + min : undefined,
        max: max !== undefined ? axis.max + max - (axis.max - axis.min) : undefined
    };
}
/**
 * Calculate constraints in terms of the viewport when
 * defined relatively to the measured bounding box.
 */ function calcRelativeConstraints(layoutBox, { top, left, bottom, right }) {
    return {
        x: calcRelativeAxisConstraints(layoutBox.x, left, right),
        y: calcRelativeAxisConstraints(layoutBox.y, top, bottom)
    };
}
/**
 * Calculate viewport constraints when defined as another viewport-relative axis
 */ function calcViewportAxisConstraints(layoutAxis, constraintsAxis) {
    let min = constraintsAxis.min - layoutAxis.min;
    let max = constraintsAxis.max - layoutAxis.max;
    // If the constraints axis is actually smaller than the layout axis then we can
    // flip the constraints
    if (constraintsAxis.max - constraintsAxis.min < layoutAxis.max - layoutAxis.min) [min, max] = [
        max,
        min
    ];
    return {
        min,
        max
    };
}
/**
 * Calculate viewport constraints when defined as another viewport-relative box
 */ function calcViewportConstraints(layoutBox, constraintsBox) {
    return {
        x: calcViewportAxisConstraints(layoutBox.x, constraintsBox.x),
        y: calcViewportAxisConstraints(layoutBox.y, constraintsBox.y)
    };
}
/**
 * Calculate a transform origin relative to the source axis, between 0-1, that results
 * in an asthetically pleasing scale/transform needed to project from source to target.
 */ function calcOrigin(source, target) {
    let origin = 0.5;
    const sourceLength = (0, _deltaCalcMjs.calcLength)(source);
    const targetLength = (0, _deltaCalcMjs.calcLength)(target);
    if (targetLength > sourceLength) origin = (0, _progressMjs.progress)(target.min, target.max - sourceLength, source.min);
    else if (sourceLength > targetLength) origin = (0, _progressMjs.progress)(source.min, source.max - targetLength, target.min);
    return (0, _clampMjs.clamp)(0, 1, origin);
}
/**
 * Rebase the calculated viewport constraints relative to the layout.min point.
 */ function rebaseAxisConstraints(layout, constraints) {
    const relativeConstraints = {};
    if (constraints.min !== undefined) relativeConstraints.min = constraints.min - layout.min;
    if (constraints.max !== undefined) relativeConstraints.max = constraints.max - layout.min;
    return relativeConstraints;
}
const defaultElastic = 0.35;
/**
 * Accepts a dragElastic prop and returns resolved elastic values for each axis.
 */ function resolveDragElastic(dragElastic = defaultElastic) {
    if (dragElastic === false) dragElastic = 0;
    else if (dragElastic === true) dragElastic = defaultElastic;
    return {
        x: resolveAxisElastic(dragElastic, "left", "right"),
        y: resolveAxisElastic(dragElastic, "top", "bottom")
    };
}
function resolveAxisElastic(dragElastic, minLabel, maxLabel) {
    return {
        min: resolvePointElastic(dragElastic, minLabel),
        max: resolvePointElastic(dragElastic, maxLabel)
    };
}
function resolvePointElastic(dragElastic, label) {
    return typeof dragElastic === "number" ? dragElastic : dragElastic[label] || 0;
}

},{"../../../utils/progress.mjs":"4ZPxX","../../../projection/geometry/delta-calc.mjs":"lmUuI","../../../utils/clamp.mjs":"5mu0r","../../../utils/mix.mjs":"cEof3","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"lmUuI":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "calcAxisDelta", ()=>calcAxisDelta);
parcelHelpers.export(exports, "calcBoxDelta", ()=>calcBoxDelta);
parcelHelpers.export(exports, "calcLength", ()=>calcLength);
parcelHelpers.export(exports, "calcRelativeAxis", ()=>calcRelativeAxis);
parcelHelpers.export(exports, "calcRelativeAxisPosition", ()=>calcRelativeAxisPosition);
parcelHelpers.export(exports, "calcRelativeBox", ()=>calcRelativeBox);
parcelHelpers.export(exports, "calcRelativePosition", ()=>calcRelativePosition);
parcelHelpers.export(exports, "isNear", ()=>isNear);
var _mixMjs = require("../../utils/mix.mjs");
function calcLength(axis) {
    return axis.max - axis.min;
}
function isNear(value, target = 0, maxDistance = 0.01) {
    return Math.abs(value - target) <= maxDistance;
}
function calcAxisDelta(delta, source, target, origin = 0.5) {
    delta.origin = origin;
    delta.originPoint = (0, _mixMjs.mix)(source.min, source.max, delta.origin);
    delta.scale = calcLength(target) / calcLength(source);
    if (isNear(delta.scale, 1, 0.0001) || isNaN(delta.scale)) delta.scale = 1;
    delta.translate = (0, _mixMjs.mix)(target.min, target.max, delta.origin) - delta.originPoint;
    if (isNear(delta.translate) || isNaN(delta.translate)) delta.translate = 0;
}
function calcBoxDelta(delta, source, target, origin) {
    calcAxisDelta(delta.x, source.x, target.x, origin ? origin.originX : undefined);
    calcAxisDelta(delta.y, source.y, target.y, origin ? origin.originY : undefined);
}
function calcRelativeAxis(target, relative, parent) {
    target.min = parent.min + relative.min;
    target.max = target.min + calcLength(relative);
}
function calcRelativeBox(target, relative, parent) {
    calcRelativeAxis(target.x, relative.x, parent.x);
    calcRelativeAxis(target.y, relative.y, parent.y);
}
function calcRelativeAxisPosition(target, layout, parent) {
    target.min = layout.min - parent.min;
    target.max = target.min + calcLength(layout);
}
function calcRelativePosition(target, layout, parent) {
    calcRelativeAxisPosition(target.x, layout.x, parent.x);
    calcRelativeAxisPosition(target.y, layout.y, parent.y);
}

},{"../../utils/mix.mjs":"cEof3","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"huYV1":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createAxis", ()=>createAxis);
parcelHelpers.export(exports, "createAxisDelta", ()=>createAxisDelta);
parcelHelpers.export(exports, "createBox", ()=>createBox);
parcelHelpers.export(exports, "createDelta", ()=>createDelta);
const createAxisDelta = ()=>({
        translate: 0,
        scale: 1,
        origin: 0,
        originPoint: 0
    });
const createDelta = ()=>({
        x: createAxisDelta(),
        y: createAxisDelta()
    });
const createAxis = ()=>({
        min: 0,
        max: 0
    });
const createBox = ()=>({
        x: createAxis(),
        y: createAxis()
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"dZLv7":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "eachAxis", ()=>eachAxis);
function eachAxis(callback) {
    return [
        callback("x"),
        callback("y")
    ];
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"afNeE":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "measurePageBox", ()=>measurePageBox);
parcelHelpers.export(exports, "measureViewportBox", ()=>measureViewportBox);
var _conversionMjs = require("../geometry/conversion.mjs");
var _deltaApplyMjs = require("../geometry/delta-apply.mjs");
function measureViewportBox(instance, transformPoint) {
    return (0, _conversionMjs.convertBoundingBoxToBox)((0, _conversionMjs.transformBoxPoints)(instance.getBoundingClientRect(), transformPoint));
}
function measurePageBox(element, rootProjectionNode, transformPagePoint) {
    const viewportBox = measureViewportBox(element, transformPagePoint);
    const { scroll } = rootProjectionNode;
    if (scroll) {
        (0, _deltaApplyMjs.translateAxis)(viewportBox.x, scroll.offset.x);
        (0, _deltaApplyMjs.translateAxis)(viewportBox.y, scroll.offset.y);
    }
    return viewportBox;
}

},{"../geometry/conversion.mjs":"4G46A","../geometry/delta-apply.mjs":"36VRX","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4G46A":[function(require,module,exports) {
/**
 * Bounding boxes tend to be defined as top, left, right, bottom. For various operations
 * it's easier to consider each axis individually. This function returns a bounding box
 * as a map of single-axis min/max values.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "convertBoundingBoxToBox", ()=>convertBoundingBoxToBox);
parcelHelpers.export(exports, "convertBoxToBoundingBox", ()=>convertBoxToBoundingBox);
parcelHelpers.export(exports, "transformBoxPoints", ()=>transformBoxPoints);
function convertBoundingBoxToBox({ top, left, right, bottom }) {
    return {
        x: {
            min: left,
            max: right
        },
        y: {
            min: top,
            max: bottom
        }
    };
}
function convertBoxToBoundingBox({ x, y }) {
    return {
        top: y.min,
        right: x.max,
        bottom: y.max,
        left: x.min
    };
}
/**
 * Applies a TransformPoint function to a bounding box. TransformPoint is usually a function
 * provided by Framer to allow measured points to be corrected for device scaling. This is used
 * when measuring DOM elements and DOM event points.
 */ function transformBoxPoints(point, transformPoint) {
    if (!transformPoint) return point;
    const topLeft = transformPoint({
        x: point.left,
        y: point.top
    });
    const bottomRight = transformPoint({
        x: point.right,
        y: point.bottom
    });
    return {
        top: topLeft.y,
        left: topLeft.x,
        bottom: bottomRight.y,
        right: bottomRight.x
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"36VRX":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "applyAxisDelta", ()=>applyAxisDelta);
parcelHelpers.export(exports, "applyBoxDelta", ()=>applyBoxDelta);
parcelHelpers.export(exports, "applyPointDelta", ()=>applyPointDelta);
parcelHelpers.export(exports, "applyTreeDeltas", ()=>applyTreeDeltas);
parcelHelpers.export(exports, "scalePoint", ()=>scalePoint);
parcelHelpers.export(exports, "transformAxis", ()=>transformAxis);
parcelHelpers.export(exports, "transformBox", ()=>transformBox);
parcelHelpers.export(exports, "translateAxis", ()=>translateAxis);
var _mixMjs = require("../../utils/mix.mjs");
var _hasTransformMjs = require("../utils/has-transform.mjs");
/**
 * Scales a point based on a factor and an originPoint
 */ function scalePoint(point, scale, originPoint) {
    const distanceFromOrigin = point - originPoint;
    const scaled = scale * distanceFromOrigin;
    return originPoint + scaled;
}
/**
 * Applies a translate/scale delta to a point
 */ function applyPointDelta(point, translate, scale, originPoint, boxScale) {
    if (boxScale !== undefined) point = scalePoint(point, boxScale, originPoint);
    return scalePoint(point, scale, originPoint) + translate;
}
/**
 * Applies a translate/scale delta to an axis
 */ function applyAxisDelta(axis, translate = 0, scale = 1, originPoint, boxScale) {
    axis.min = applyPointDelta(axis.min, translate, scale, originPoint, boxScale);
    axis.max = applyPointDelta(axis.max, translate, scale, originPoint, boxScale);
}
/**
 * Applies a translate/scale delta to a box
 */ function applyBoxDelta(box, { x, y }) {
    applyAxisDelta(box.x, x.translate, x.scale, x.originPoint);
    applyAxisDelta(box.y, y.translate, y.scale, y.originPoint);
}
/**
 * Apply a tree of deltas to a box. We do this to calculate the effect of all the transforms
 * in a tree upon our box before then calculating how to project it into our desired viewport-relative box
 *
 * This is the final nested loop within updateLayoutDelta for future refactoring
 */ function applyTreeDeltas(box, treeScale, treePath, isSharedTransition = false) {
    const treeLength = treePath.length;
    if (!treeLength) return;
    // Reset the treeScale
    treeScale.x = treeScale.y = 1;
    let node;
    let delta;
    for(let i = 0; i < treeLength; i++){
        node = treePath[i];
        delta = node.projectionDelta;
        /**
         * TODO: Prefer to remove this, but currently we have motion components with
         * display: contents in Framer.
         */ const instance = node.instance;
        if (instance && instance.style && instance.style.display === "contents") continue;
        if (isSharedTransition && node.options.layoutScroll && node.scroll && node !== node.root) transformBox(box, {
            x: -node.scroll.offset.x,
            y: -node.scroll.offset.y
        });
        if (delta) {
            // Incoporate each ancestor's scale into a culmulative treeScale for this component
            treeScale.x *= delta.x.scale;
            treeScale.y *= delta.y.scale;
            // Apply each ancestor's calculated delta into this component's recorded layout box
            applyBoxDelta(box, delta);
        }
        if (isSharedTransition && (0, _hasTransformMjs.hasTransform)(node.latestValues)) transformBox(box, node.latestValues);
    }
    /**
     * Snap tree scale back to 1 if it's within a non-perceivable threshold.
     * This will help reduce useless scales getting rendered.
     */ treeScale.x = snapToDefault(treeScale.x);
    treeScale.y = snapToDefault(treeScale.y);
}
function snapToDefault(scale) {
    if (Number.isInteger(scale)) return scale;
    return scale > 1.0000000000001 || scale < 0.999999999999 ? scale : 1;
}
function translateAxis(axis, distance) {
    axis.min = axis.min + distance;
    axis.max = axis.max + distance;
}
/**
 * Apply a transform to an axis from the latest resolved motion values.
 * This function basically acts as a bridge between a flat motion value map
 * and applyAxisDelta
 */ function transformAxis(axis, transforms, [key, scaleKey, originKey]) {
    const axisOrigin = transforms[originKey] !== undefined ? transforms[originKey] : 0.5;
    const originPoint = (0, _mixMjs.mix)(axis.min, axis.max, axisOrigin);
    // Apply the axis delta to the final axis
    applyAxisDelta(axis, transforms[key], transforms[scaleKey], originPoint, transforms.scale);
}
/**
 * The names of the motion values we want to apply as translation, scale and origin.
 */ const xKeys = [
    "x",
    "scaleX",
    "originX"
];
const yKeys = [
    "y",
    "scaleY",
    "originY"
];
/**
 * Apply a transform to a box from the latest resolved motion values.
 */ function transformBox(box, transform) {
    transformAxis(box.x, transform, xKeys);
    transformAxis(box.y, transform, yKeys);
}

},{"../../utils/mix.mjs":"cEof3","../utils/has-transform.mjs":"7hVzp","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7hVzp":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "has2DTranslate", ()=>has2DTranslate);
parcelHelpers.export(exports, "hasScale", ()=>hasScale);
parcelHelpers.export(exports, "hasTransform", ()=>hasTransform);
function isIdentityScale(scale) {
    return scale === undefined || scale === 1;
}
function hasScale({ scale, scaleX, scaleY }) {
    return !isIdentityScale(scale) || !isIdentityScale(scaleX) || !isIdentityScale(scaleY);
}
function hasTransform(values) {
    return hasScale(values) || has2DTranslate(values) || values.z || values.rotate || values.rotateX || values.rotateY;
}
function has2DTranslate(values) {
    return is2DTranslate(values.x) || is2DTranslate(values.y);
}
function is2DTranslate(value) {
    return value && value !== "0%";
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"ckiwi":[function(require,module,exports) {
// Fixes https://github.com/framer/motion/issues/2270
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getContextWindow", ()=>getContextWindow);
const getContextWindow = ({ current })=>{
    return current ? current.ownerDocument.defaultView : null;
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9LeGk":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PanGesture", ()=>PanGesture);
var _panSessionMjs = require("./PanSession.mjs");
var _addPointerEventMjs = require("../../events/add-pointer-event.mjs");
var _featureMjs = require("../../motion/features/Feature.mjs");
var _noopMjs = require("../../utils/noop.mjs");
var _getContextWindowMjs = require("../../utils/get-context-window.mjs");
var _frameMjs = require("../../frameloop/frame.mjs");
const asyncHandler = (handler)=>(event, info)=>{
        if (handler) (0, _frameMjs.frame).update(()=>handler(event, info));
    };
class PanGesture extends (0, _featureMjs.Feature) {
    constructor(){
        super(...arguments);
        this.removePointerDownListener = (0, _noopMjs.noop);
    }
    onPointerDown(pointerDownEvent) {
        this.session = new (0, _panSessionMjs.PanSession)(pointerDownEvent, this.createPanHandlers(), {
            transformPagePoint: this.node.getTransformPagePoint(),
            contextWindow: (0, _getContextWindowMjs.getContextWindow)(this.node)
        });
    }
    createPanHandlers() {
        const { onPanSessionStart, onPanStart, onPan, onPanEnd } = this.node.getProps();
        return {
            onSessionStart: asyncHandler(onPanSessionStart),
            onStart: asyncHandler(onPanStart),
            onMove: onPan,
            onEnd: (event, info)=>{
                delete this.session;
                if (onPanEnd) (0, _frameMjs.frame).update(()=>onPanEnd(event, info));
            }
        };
    }
    mount() {
        this.removePointerDownListener = (0, _addPointerEventMjs.addPointerEvent)(this.node.current, "pointerdown", (event)=>this.onPointerDown(event));
    }
    update() {
        this.session && this.session.updateHandlers(this.createPanHandlers());
    }
    unmount() {
        this.removePointerDownListener();
        this.session && this.session.end();
    }
}

},{"./PanSession.mjs":"ghaRp","../../events/add-pointer-event.mjs":"k9O8P","../../motion/features/Feature.mjs":"9q59Z","../../utils/noop.mjs":"7roqC","../../utils/get-context-window.mjs":"ckiwi","../../frameloop/frame.mjs":"gdRIq","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"bwaXs":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MeasureLayout", ()=>MeasureLayout);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _usePresenceMjs = require("../../../components/AnimatePresence/use-presence.mjs");
var _layoutGroupContextMjs = require("../../../context/LayoutGroupContext.mjs");
var _switchLayoutGroupContextMjs = require("../../../context/SwitchLayoutGroupContext.mjs");
var _stateMjs = require("../../../projection/node/state.mjs");
var _scaleBorderRadiusMjs = require("../../../projection/styles/scale-border-radius.mjs");
var _scaleBoxShadowMjs = require("../../../projection/styles/scale-box-shadow.mjs");
var _scaleCorrectionMjs = require("../../../projection/styles/scale-correction.mjs");
var _frameMjs = require("../../../frameloop/frame.mjs");
class MeasureLayoutWithContext extends (0, _reactDefault.default).Component {
    /**
     * This only mounts projection nodes for components that
     * need measuring, we might want to do it for all components
     * in order to incorporate transforms
     */ componentDidMount() {
        const { visualElement, layoutGroup, switchLayoutGroup, layoutId } = this.props;
        const { projection } = visualElement;
        (0, _scaleCorrectionMjs.addScaleCorrector)(defaultScaleCorrectors);
        if (projection) {
            if (layoutGroup.group) layoutGroup.group.add(projection);
            if (switchLayoutGroup && switchLayoutGroup.register && layoutId) switchLayoutGroup.register(projection);
            projection.root.didUpdate();
            projection.addEventListener("animationComplete", ()=>{
                this.safeToRemove();
            });
            projection.setOptions({
                ...projection.options,
                onExitComplete: ()=>this.safeToRemove()
            });
        }
        (0, _stateMjs.globalProjectionState).hasEverUpdated = true;
    }
    getSnapshotBeforeUpdate(prevProps) {
        const { layoutDependency, visualElement, drag, isPresent } = this.props;
        const projection = visualElement.projection;
        if (!projection) return null;
        /**
         * TODO: We use this data in relegate to determine whether to
         * promote a previous element. There's no guarantee its presence data
         * will have updated by this point - if a bug like this arises it will
         * have to be that we markForRelegation and then find a new lead some other way,
         * perhaps in didUpdate
         */ projection.isPresent = isPresent;
        if (drag || prevProps.layoutDependency !== layoutDependency || layoutDependency === undefined) projection.willUpdate();
        else this.safeToRemove();
        if (prevProps.isPresent !== isPresent) {
            if (isPresent) projection.promote();
            else if (!projection.relegate()) /**
                 * If there's another stack member taking over from this one,
                 * it's in charge of the exit animation and therefore should
                 * be in charge of the safe to remove. Otherwise we call it here.
                 */ (0, _frameMjs.frame).postRender(()=>{
                const stack = projection.getStack();
                if (!stack || !stack.members.length) this.safeToRemove();
            });
        }
        return null;
    }
    componentDidUpdate() {
        const { projection } = this.props.visualElement;
        if (projection) {
            projection.root.didUpdate();
            queueMicrotask(()=>{
                if (!projection.currentAnimation && projection.isLead()) this.safeToRemove();
            });
        }
    }
    componentWillUnmount() {
        const { visualElement, layoutGroup, switchLayoutGroup: promoteContext } = this.props;
        const { projection } = visualElement;
        if (projection) {
            projection.scheduleCheckAfterUnmount();
            if (layoutGroup && layoutGroup.group) layoutGroup.group.remove(projection);
            if (promoteContext && promoteContext.deregister) promoteContext.deregister(projection);
        }
    }
    safeToRemove() {
        const { safeToRemove } = this.props;
        safeToRemove && safeToRemove();
    }
    render() {
        return null;
    }
}
function MeasureLayout(props) {
    const [isPresent, safeToRemove] = (0, _usePresenceMjs.usePresence)();
    const layoutGroup = (0, _react.useContext)((0, _layoutGroupContextMjs.LayoutGroupContext));
    return (0, _reactDefault.default).createElement(MeasureLayoutWithContext, {
        ...props,
        layoutGroup: layoutGroup,
        switchLayoutGroup: (0, _react.useContext)((0, _switchLayoutGroupContextMjs.SwitchLayoutGroupContext)),
        isPresent: isPresent,
        safeToRemove: safeToRemove
    });
}
const defaultScaleCorrectors = {
    borderRadius: {
        ...(0, _scaleBorderRadiusMjs.correctBorderRadius),
        applyTo: [
            "borderTopLeftRadius",
            "borderTopRightRadius",
            "borderBottomLeftRadius",
            "borderBottomRightRadius"
        ]
    },
    borderTopLeftRadius: (0, _scaleBorderRadiusMjs.correctBorderRadius),
    borderTopRightRadius: (0, _scaleBorderRadiusMjs.correctBorderRadius),
    borderBottomLeftRadius: (0, _scaleBorderRadiusMjs.correctBorderRadius),
    borderBottomRightRadius: (0, _scaleBorderRadiusMjs.correctBorderRadius),
    boxShadow: (0, _scaleBoxShadowMjs.correctBoxShadow)
};

},{"react":"6uln9","../../../components/AnimatePresence/use-presence.mjs":"7TWAj","../../../context/LayoutGroupContext.mjs":"5CkZ6","../../../context/SwitchLayoutGroupContext.mjs":"6krc6","../../../projection/node/state.mjs":"5xBUr","../../../projection/styles/scale-border-radius.mjs":"f0J1M","../../../projection/styles/scale-box-shadow.mjs":"a9KkN","../../../projection/styles/scale-correction.mjs":"4bQbP","../../../frameloop/frame.mjs":"gdRIq","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7TWAj":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isPresent", ()=>isPresent);
parcelHelpers.export(exports, "useIsPresent", ()=>useIsPresent);
parcelHelpers.export(exports, "usePresence", ()=>usePresence);
var _react = require("react");
var _presenceContextMjs = require("../../context/PresenceContext.mjs");
/**
 * When a component is the child of `AnimatePresence`, it can use `usePresence`
 * to access information about whether it's still present in the React tree.
 *
 * ```jsx
 * import { usePresence } from "framer-motion"
 *
 * export const Component = () => {
 *   const [isPresent, safeToRemove] = usePresence()
 *
 *   useEffect(() => {
 *     !isPresent && setTimeout(safeToRemove, 1000)
 *   }, [isPresent])
 *
 *   return <div />
 * }
 * ```
 *
 * If `isPresent` is `false`, it means that a component has been removed the tree, but
 * `AnimatePresence` won't really remove it until `safeToRemove` has been called.
 *
 * @public
 */ function usePresence() {
    const context = (0, _react.useContext)((0, _presenceContextMjs.PresenceContext));
    if (context === null) return [
        true,
        null
    ];
    const { isPresent, onExitComplete, register } = context;
    // It's safe to call the following hooks conditionally (after an early return) because the context will always
    // either be null or non-null for the lifespan of the component.
    const id = (0, _react.useId)();
    (0, _react.useEffect)(()=>register(id), []);
    const safeToRemove = ()=>onExitComplete && onExitComplete(id);
    return !isPresent && onExitComplete ? [
        false,
        safeToRemove
    ] : [
        true
    ];
}
/**
 * Similar to `usePresence`, except `useIsPresent` simply returns whether or not the component is present.
 * There is no `safeToRemove` function.
 *
 * ```jsx
 * import { useIsPresent } from "framer-motion"
 *
 * export const Component = () => {
 *   const isPresent = useIsPresent()
 *
 *   useEffect(() => {
 *     !isPresent && console.log("I've been removed!")
 *   }, [isPresent])
 *
 *   return <div />
 * }
 * ```
 *
 * @public
 */ function useIsPresent() {
    return isPresent((0, _react.useContext)((0, _presenceContextMjs.PresenceContext)));
}
function isPresent(context) {
    return context === null ? true : context.isPresent;
}

},{"react":"6uln9","../../context/PresenceContext.mjs":"dcXf9","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"5xBUr":[function(require,module,exports) {
/**
 * This should only ever be modified on the client otherwise it'll
 * persist through server requests. If we need instanced states we
 * could lazy-init via root.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "globalProjectionState", ()=>globalProjectionState);
const globalProjectionState = {
    /**
     * Global flag as to whether the tree has animated since the last time
     * we resized the window
     */ hasAnimatedSinceResize: true,
    /**
     * We set this to true once, on the first update. Any nodes added to the tree beyond that
     * update will be given a `data-projection-id` attribute.
     */ hasEverUpdated: false
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"f0J1M":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "correctBorderRadius", ()=>correctBorderRadius);
parcelHelpers.export(exports, "pixelsToPercent", ()=>pixelsToPercent);
var _unitsMjs = require("../../value/types/numbers/units.mjs");
function pixelsToPercent(pixels, axis) {
    if (axis.max === axis.min) return 0;
    return pixels / (axis.max - axis.min) * 100;
}
/**
 * We always correct borderRadius as a percentage rather than pixels to reduce paints.
 * For example, if you are projecting a box that is 100px wide with a 10px borderRadius
 * into a box that is 200px wide with a 20px borderRadius, that is actually a 10%
 * borderRadius in both states. If we animate between the two in pixels that will trigger
 * a paint each time. If we animate between the two in percentage we'll avoid a paint.
 */ const correctBorderRadius = {
    correct: (latest, node)=>{
        if (!node.target) return latest;
        /**
         * If latest is a string, if it's a percentage we can return immediately as it's
         * going to be stretched appropriately. Otherwise, if it's a pixel, convert it to a number.
         */ if (typeof latest === "string") {
            if ((0, _unitsMjs.px).test(latest)) latest = parseFloat(latest);
            else return latest;
        }
        /**
         * If latest is a number, it's a pixel value. We use the current viewportBox to calculate that
         * pixel value as a percentage of each axis
         */ const x = pixelsToPercent(latest, node.target.x);
        const y = pixelsToPercent(latest, node.target.y);
        return `${x}% ${y}%`;
    }
};

},{"../../value/types/numbers/units.mjs":"hGtBr","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"a9KkN":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "correctBoxShadow", ()=>correctBoxShadow);
var _mixMjs = require("../../utils/mix.mjs");
var _indexMjs = require("../../value/types/complex/index.mjs");
const correctBoxShadow = {
    correct: (latest, { treeScale, projectionDelta })=>{
        const original = latest;
        const shadow = (0, _indexMjs.complex).parse(latest);
        // TODO: Doesn't support multiple shadows
        if (shadow.length > 5) return original;
        const template = (0, _indexMjs.complex).createTransformer(latest);
        const offset = typeof shadow[0] !== "number" ? 1 : 0;
        // Calculate the overall context scale
        const xScale = projectionDelta.x.scale * treeScale.x;
        const yScale = projectionDelta.y.scale * treeScale.y;
        shadow[0 + offset] /= xScale;
        shadow[1 + offset] /= yScale;
        /**
         * Ideally we'd correct x and y scales individually, but because blur and
         * spread apply to both we have to take a scale average and apply that instead.
         * We could potentially improve the outcome of this by incorporating the ratio between
         * the two scales.
         */ const averageScale = (0, _mixMjs.mix)(xScale, yScale, 0.5);
        // Blur
        if (typeof shadow[2 + offset] === "number") shadow[2 + offset] /= averageScale;
        // Spread
        if (typeof shadow[3 + offset] === "number") shadow[3 + offset] /= averageScale;
        return template(shadow);
    }
};

},{"../../utils/mix.mjs":"cEof3","../../value/types/complex/index.mjs":"7EbqM","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"eJQj5":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "HTMLProjectionNode", ()=>HTMLProjectionNode);
parcelHelpers.export(exports, "rootProjectionNode", ()=>rootProjectionNode);
var _createProjectionNodeMjs = require("./create-projection-node.mjs");
var _documentProjectionNodeMjs = require("./DocumentProjectionNode.mjs");
const rootProjectionNode = {
    current: undefined
};
const HTMLProjectionNode = (0, _createProjectionNodeMjs.createProjectionNode)({
    measureScroll: (instance)=>({
            x: instance.scrollLeft,
            y: instance.scrollTop
        }),
    defaultParent: ()=>{
        if (!rootProjectionNode.current) {
            const documentNode = new (0, _documentProjectionNodeMjs.DocumentProjectionNode)({});
            documentNode.mount(window);
            documentNode.setOptions({
                layoutScroll: true
            });
            rootProjectionNode.current = documentNode;
        }
        return rootProjectionNode.current;
    },
    resetTransform: (instance, value)=>{
        instance.style.transform = value !== undefined ? value : "none";
    },
    checkIsScrollRoot: (instance)=>Boolean(window.getComputedStyle(instance).position === "fixed")
});

},{"./create-projection-node.mjs":"2osmA","./DocumentProjectionNode.mjs":"2Tecc","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2osmA":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "cleanDirtyNodes", ()=>cleanDirtyNodes);
parcelHelpers.export(exports, "createProjectionNode", ()=>createProjectionNode);
parcelHelpers.export(exports, "mixAxis", ()=>mixAxis);
parcelHelpers.export(exports, "mixAxisDelta", ()=>mixAxisDelta);
parcelHelpers.export(exports, "mixBox", ()=>mixBox);
parcelHelpers.export(exports, "propagateDirtyNodes", ()=>propagateDirtyNodes);
var _subscriptionManagerMjs = require("../../utils/subscription-manager.mjs");
var _mixValuesMjs = require("../animation/mix-values.mjs");
var _copyMjs = require("../geometry/copy.mjs");
var _deltaApplyMjs = require("../geometry/delta-apply.mjs");
var _deltaCalcMjs = require("../geometry/delta-calc.mjs");
var _deltaRemoveMjs = require("../geometry/delta-remove.mjs");
var _modelsMjs = require("../geometry/models.mjs");
var _transitionsMjs = require("../../animation/utils/transitions.mjs");
var _utilsMjs = require("../geometry/utils.mjs");
var _stackMjs = require("../shared/stack.mjs");
var _scaleCorrectionMjs = require("../styles/scale-correction.mjs");
var _transformMjs = require("../styles/transform.mjs");
var _eachAxisMjs = require("../utils/each-axis.mjs");
var _hasTransformMjs = require("../utils/has-transform.mjs");
var _flatTreeMjs = require("../../render/utils/flat-tree.mjs");
var _resolveMotionValueMjs = require("../../value/utils/resolve-motion-value.mjs");
var _stateMjs = require("./state.mjs");
var _delayMjs = require("../../utils/delay.mjs");
var _mixMjs = require("../../utils/mix.mjs");
var _recordMjs = require("../../debug/record.mjs");
var _isSvgElementMjs = require("../../render/dom/utils/is-svg-element.mjs");
var _singleValueMjs = require("../../animation/interfaces/single-value.mjs");
var _clampMjs = require("../../utils/clamp.mjs");
var _frameMjs = require("../../frameloop/frame.mjs");
var _noopMjs = require("../../utils/noop.mjs");
const transformAxes = [
    "",
    "X",
    "Y",
    "Z"
];
const hiddenVisibility = {
    visibility: "hidden"
};
/**
 * We use 1000 as the animation target as 0-1000 maps better to pixels than 0-1
 * which has a noticeable difference in spring animations
 */ const animationTarget = 1000;
let id = 0;
/**
 * Use a mutable data object for debug data so as to not create a new
 * object every frame.
 */ const projectionFrameData = {
    type: "projectionFrame",
    totalNodes: 0,
    resolvedTargetDeltas: 0,
    recalculatedProjection: 0
};
function createProjectionNode({ attachResizeListener, defaultParent, measureScroll, checkIsScrollRoot, resetTransform }) {
    return class ProjectionNode {
        constructor(latestValues = {}, parent = defaultParent === null || defaultParent === void 0 ? void 0 : defaultParent()){
            /**
             * A unique ID generated for every projection node.
             */ this.id = id++;
            /**
             * An id that represents a unique session instigated by startUpdate.
             */ this.animationId = 0;
            /**
             * A Set containing all this component's children. This is used to iterate
             * through the children.
             *
             * TODO: This could be faster to iterate as a flat array stored on the root node.
             */ this.children = new Set();
            /**
             * Options for the node. We use this to configure what kind of layout animations
             * we should perform (if any).
             */ this.options = {};
            /**
             * We use this to detect when its safe to shut down part of a projection tree.
             * We have to keep projecting children for scale correction and relative projection
             * until all their parents stop performing layout animations.
             */ this.isTreeAnimating = false;
            this.isAnimationBlocked = false;
            /**
             * Flag to true if we think this layout has been changed. We can't always know this,
             * currently we set it to true every time a component renders, or if it has a layoutDependency
             * if that has changed between renders. Additionally, components can be grouped by LayoutGroup
             * and if one node is dirtied, they all are.
             */ this.isLayoutDirty = false;
            /**
             * Flag to true if we think the projection calculations for this node needs
             * recalculating as a result of an updated transform or layout animation.
             */ this.isProjectionDirty = false;
            /**
             * Flag to true if the layout *or* transform has changed. This then gets propagated
             * throughout the projection tree, forcing any element below to recalculate on the next frame.
             */ this.isSharedProjectionDirty = false;
            /**
             * Flag transform dirty. This gets propagated throughout the whole tree but is only
             * respected by shared nodes.
             */ this.isTransformDirty = false;
            /**
             * Block layout updates for instant layout transitions throughout the tree.
             */ this.updateManuallyBlocked = false;
            this.updateBlockedByResize = false;
            /**
             * Set to true between the start of the first `willUpdate` call and the end of the `didUpdate`
             * call.
             */ this.isUpdating = false;
            /**
             * If this is an SVG element we currently disable projection transforms
             */ this.isSVG = false;
            /**
             * Flag to true (during promotion) if a node doing an instant layout transition needs to reset
             * its projection styles.
             */ this.needsReset = false;
            /**
             * Flags whether this node should have its transform reset prior to measuring.
             */ this.shouldResetTransform = false;
            /**
             * An object representing the calculated contextual/accumulated/tree scale.
             * This will be used to scale calculcated projection transforms, as these are
             * calculated in screen-space but need to be scaled for elements to layoutly
             * make it to their calculated destinations.
             *
             * TODO: Lazy-init
             */ this.treeScale = {
                x: 1,
                y: 1
            };
            /**
             *
             */ this.eventHandlers = new Map();
            this.hasTreeAnimated = false;
            // Note: Currently only running on root node
            this.updateScheduled = false;
            this.projectionUpdateScheduled = false;
            this.checkUpdateFailed = ()=>{
                if (this.isUpdating) {
                    this.isUpdating = false;
                    this.clearAllSnapshots();
                }
            };
            /**
             * This is a multi-step process as shared nodes might be of different depths. Nodes
             * are sorted by depth order, so we need to resolve the entire tree before moving to
             * the next step.
             */ this.updateProjection = ()=>{
                this.projectionUpdateScheduled = false;
                /**
                 * Reset debug counts. Manually resetting rather than creating a new
                 * object each frame.
                 */ projectionFrameData.totalNodes = projectionFrameData.resolvedTargetDeltas = projectionFrameData.recalculatedProjection = 0;
                this.nodes.forEach(propagateDirtyNodes);
                this.nodes.forEach(resolveTargetDelta);
                this.nodes.forEach(calcProjection);
                this.nodes.forEach(cleanDirtyNodes);
                (0, _recordMjs.record)(projectionFrameData);
            };
            this.hasProjected = false;
            this.isVisible = true;
            this.animationProgress = 0;
            /**
             * Shared layout
             */ // TODO Only running on root node
            this.sharedNodes = new Map();
            this.latestValues = latestValues;
            this.root = parent ? parent.root || parent : this;
            this.path = parent ? [
                ...parent.path,
                parent
            ] : [];
            this.parent = parent;
            this.depth = parent ? parent.depth + 1 : 0;
            for(let i = 0; i < this.path.length; i++)this.path[i].shouldResetTransform = true;
            if (this.root === this) this.nodes = new (0, _flatTreeMjs.FlatTree)();
        }
        addEventListener(name, handler) {
            if (!this.eventHandlers.has(name)) this.eventHandlers.set(name, new (0, _subscriptionManagerMjs.SubscriptionManager)());
            return this.eventHandlers.get(name).add(handler);
        }
        notifyListeners(name, ...args) {
            const subscriptionManager = this.eventHandlers.get(name);
            subscriptionManager && subscriptionManager.notify(...args);
        }
        hasListeners(name) {
            return this.eventHandlers.has(name);
        }
        /**
         * Lifecycles
         */ mount(instance, isLayoutDirty = this.root.hasTreeAnimated) {
            if (this.instance) return;
            this.isSVG = (0, _isSvgElementMjs.isSVGElement)(instance);
            this.instance = instance;
            const { layoutId, layout, visualElement } = this.options;
            if (visualElement && !visualElement.current) visualElement.mount(instance);
            this.root.nodes.add(this);
            this.parent && this.parent.children.add(this);
            if (isLayoutDirty && (layout || layoutId)) this.isLayoutDirty = true;
            if (attachResizeListener) {
                let cancelDelay;
                const resizeUnblockUpdate = ()=>this.root.updateBlockedByResize = false;
                attachResizeListener(instance, ()=>{
                    this.root.updateBlockedByResize = true;
                    cancelDelay && cancelDelay();
                    cancelDelay = (0, _delayMjs.delay)(resizeUnblockUpdate, 250);
                    if ((0, _stateMjs.globalProjectionState).hasAnimatedSinceResize) {
                        (0, _stateMjs.globalProjectionState).hasAnimatedSinceResize = false;
                        this.nodes.forEach(finishAnimation);
                    }
                });
            }
            if (layoutId) this.root.registerSharedNode(layoutId, this);
            // Only register the handler if it requires layout animation
            if (this.options.animate !== false && visualElement && (layoutId || layout)) this.addEventListener("didUpdate", ({ delta, hasLayoutChanged, hasRelativeTargetChanged, layout: newLayout })=>{
                if (this.isTreeAnimationBlocked()) {
                    this.target = undefined;
                    this.relativeTarget = undefined;
                    return;
                }
                // TODO: Check here if an animation exists
                const layoutTransition = this.options.transition || visualElement.getDefaultTransition() || defaultLayoutTransition;
                const { onLayoutAnimationStart, onLayoutAnimationComplete } = visualElement.getProps();
                /**
                     * The target layout of the element might stay the same,
                     * but its position relative to its parent has changed.
                     */ const targetChanged = !this.targetLayout || !(0, _utilsMjs.boxEqualsRounded)(this.targetLayout, newLayout) || hasRelativeTargetChanged;
                /**
                     * If the layout hasn't seemed to have changed, it might be that the
                     * element is visually in the same place in the document but its position
                     * relative to its parent has indeed changed. So here we check for that.
                     */ const hasOnlyRelativeTargetChanged = !hasLayoutChanged && hasRelativeTargetChanged;
                if (this.options.layoutRoot || this.resumeFrom && this.resumeFrom.instance || hasOnlyRelativeTargetChanged || hasLayoutChanged && (targetChanged || !this.currentAnimation)) {
                    if (this.resumeFrom) {
                        this.resumingFrom = this.resumeFrom;
                        this.resumingFrom.resumingFrom = undefined;
                    }
                    this.setAnimationOrigin(delta, hasOnlyRelativeTargetChanged);
                    const animationOptions = {
                        ...(0, _transitionsMjs.getValueTransition)(layoutTransition, "layout"),
                        onPlay: onLayoutAnimationStart,
                        onComplete: onLayoutAnimationComplete
                    };
                    if (visualElement.shouldReduceMotion || this.options.layoutRoot) {
                        animationOptions.delay = 0;
                        animationOptions.type = false;
                    }
                    this.startAnimation(animationOptions);
                } else {
                    /**
                         * If the layout hasn't changed and we have an animation that hasn't started yet,
                         * finish it immediately. Otherwise it will be animating from a location
                         * that was probably never commited to screen and look like a jumpy box.
                         */ if (!hasLayoutChanged) finishAnimation(this);
                    if (this.isLead() && this.options.onExitComplete) this.options.onExitComplete();
                }
                this.targetLayout = newLayout;
            });
        }
        unmount() {
            this.options.layoutId && this.willUpdate();
            this.root.nodes.remove(this);
            const stack = this.getStack();
            stack && stack.remove(this);
            this.parent && this.parent.children.delete(this);
            this.instance = undefined;
            (0, _frameMjs.cancelFrame)(this.updateProjection);
        }
        // only on the root
        blockUpdate() {
            this.updateManuallyBlocked = true;
        }
        unblockUpdate() {
            this.updateManuallyBlocked = false;
        }
        isUpdateBlocked() {
            return this.updateManuallyBlocked || this.updateBlockedByResize;
        }
        isTreeAnimationBlocked() {
            return this.isAnimationBlocked || this.parent && this.parent.isTreeAnimationBlocked() || false;
        }
        // Note: currently only running on root node
        startUpdate() {
            if (this.isUpdateBlocked()) return;
            this.isUpdating = true;
            this.nodes && this.nodes.forEach(resetRotation);
            this.animationId++;
        }
        getTransformTemplate() {
            const { visualElement } = this.options;
            return visualElement && visualElement.getProps().transformTemplate;
        }
        willUpdate(shouldNotifyListeners = true) {
            this.root.hasTreeAnimated = true;
            if (this.root.isUpdateBlocked()) {
                this.options.onExitComplete && this.options.onExitComplete();
                return;
            }
            !this.root.isUpdating && this.root.startUpdate();
            if (this.isLayoutDirty) return;
            this.isLayoutDirty = true;
            for(let i = 0; i < this.path.length; i++){
                const node = this.path[i];
                node.shouldResetTransform = true;
                node.updateScroll("snapshot");
                if (node.options.layoutRoot) node.willUpdate(false);
            }
            const { layoutId, layout } = this.options;
            if (layoutId === undefined && !layout) return;
            const transformTemplate = this.getTransformTemplate();
            this.prevTransformTemplateValue = transformTemplate ? transformTemplate(this.latestValues, "") : undefined;
            this.updateSnapshot();
            shouldNotifyListeners && this.notifyListeners("willUpdate");
        }
        update() {
            this.updateScheduled = false;
            const updateWasBlocked = this.isUpdateBlocked();
            // When doing an instant transition, we skip the layout update,
            // but should still clean up the measurements so that the next
            // snapshot could be taken correctly.
            if (updateWasBlocked) {
                this.unblockUpdate();
                this.clearAllSnapshots();
                this.nodes.forEach(clearMeasurements);
                return;
            }
            if (!this.isUpdating) this.nodes.forEach(clearIsLayoutDirty);
            this.isUpdating = false;
            /**
             * Write
             */ this.nodes.forEach(resetTransformStyle);
            /**
             * Read ==================
             */ // Update layout measurements of updated children
            this.nodes.forEach(updateLayout);
            /**
             * Write
             */ // Notify listeners that the layout is updated
            this.nodes.forEach(notifyLayoutUpdate);
            this.clearAllSnapshots();
            /**
             * Manually flush any pending updates. Ideally
             * we could leave this to the following requestAnimationFrame but this seems
             * to leave a flash of incorrectly styled content.
             */ const now = performance.now();
            (0, _frameMjs.frameData).delta = (0, _clampMjs.clamp)(0, 1000 / 60, now - (0, _frameMjs.frameData).timestamp);
            (0, _frameMjs.frameData).timestamp = now;
            (0, _frameMjs.frameData).isProcessing = true;
            (0, _frameMjs.steps).update.process((0, _frameMjs.frameData));
            (0, _frameMjs.steps).preRender.process((0, _frameMjs.frameData));
            (0, _frameMjs.steps).render.process((0, _frameMjs.frameData));
            (0, _frameMjs.frameData).isProcessing = false;
        }
        didUpdate() {
            if (!this.updateScheduled) {
                this.updateScheduled = true;
                queueMicrotask(()=>this.update());
            }
        }
        clearAllSnapshots() {
            this.nodes.forEach(clearSnapshot);
            this.sharedNodes.forEach(removeLeadSnapshots);
        }
        scheduleUpdateProjection() {
            if (!this.projectionUpdateScheduled) {
                this.projectionUpdateScheduled = true;
                (0, _frameMjs.frame).preRender(this.updateProjection, false, true);
            }
        }
        scheduleCheckAfterUnmount() {
            /**
             * If the unmounting node is in a layoutGroup and did trigger a willUpdate,
             * we manually call didUpdate to give a chance to the siblings to animate.
             * Otherwise, cleanup all snapshots to prevents future nodes from reusing them.
             */ (0, _frameMjs.frame).postRender(()=>{
                if (this.isLayoutDirty) this.root.didUpdate();
                else this.root.checkUpdateFailed();
            });
        }
        /**
         * Update measurements
         */ updateSnapshot() {
            if (this.snapshot || !this.instance) return;
            this.snapshot = this.measure();
        }
        updateLayout() {
            if (!this.instance) return;
            // TODO: Incorporate into a forwarded scroll offset
            this.updateScroll();
            if (!(this.options.alwaysMeasureLayout && this.isLead()) && !this.isLayoutDirty) return;
            /**
             * When a node is mounted, it simply resumes from the prevLead's
             * snapshot instead of taking a new one, but the ancestors scroll
             * might have updated while the prevLead is unmounted. We need to
             * update the scroll again to make sure the layout we measure is
             * up to date.
             */ if (this.resumeFrom && !this.resumeFrom.instance) for(let i = 0; i < this.path.length; i++){
                const node = this.path[i];
                node.updateScroll();
            }
            const prevLayout = this.layout;
            this.layout = this.measure(false);
            this.layoutCorrected = (0, _modelsMjs.createBox)();
            this.isLayoutDirty = false;
            this.projectionDelta = undefined;
            this.notifyListeners("measure", this.layout.layoutBox);
            const { visualElement } = this.options;
            visualElement && visualElement.notify("LayoutMeasure", this.layout.layoutBox, prevLayout ? prevLayout.layoutBox : undefined);
        }
        updateScroll(phase = "measure") {
            let needsMeasurement = Boolean(this.options.layoutScroll && this.instance);
            if (this.scroll && this.scroll.animationId === this.root.animationId && this.scroll.phase === phase) needsMeasurement = false;
            if (needsMeasurement) this.scroll = {
                animationId: this.root.animationId,
                phase,
                isRoot: checkIsScrollRoot(this.instance),
                offset: measureScroll(this.instance)
            };
        }
        resetTransform() {
            if (!resetTransform) return;
            const isResetRequested = this.isLayoutDirty || this.shouldResetTransform;
            const hasProjection = this.projectionDelta && !(0, _utilsMjs.isDeltaZero)(this.projectionDelta);
            const transformTemplate = this.getTransformTemplate();
            const transformTemplateValue = transformTemplate ? transformTemplate(this.latestValues, "") : undefined;
            const transformTemplateHasChanged = transformTemplateValue !== this.prevTransformTemplateValue;
            if (isResetRequested && (hasProjection || (0, _hasTransformMjs.hasTransform)(this.latestValues) || transformTemplateHasChanged)) {
                resetTransform(this.instance, transformTemplateValue);
                this.shouldResetTransform = false;
                this.scheduleRender();
            }
        }
        measure(removeTransform = true) {
            const pageBox = this.measurePageBox();
            let layoutBox = this.removeElementScroll(pageBox);
            /**
             * Measurements taken during the pre-render stage
             * still have transforms applied so we remove them
             * via calculation.
             */ if (removeTransform) layoutBox = this.removeTransform(layoutBox);
            roundBox(layoutBox);
            return {
                animationId: this.root.animationId,
                measuredBox: pageBox,
                layoutBox,
                latestValues: {},
                source: this.id
            };
        }
        measurePageBox() {
            const { visualElement } = this.options;
            if (!visualElement) return (0, _modelsMjs.createBox)();
            const box = visualElement.measureViewportBox();
            // Remove viewport scroll to give page-relative coordinates
            const { scroll } = this.root;
            if (scroll) {
                (0, _deltaApplyMjs.translateAxis)(box.x, scroll.offset.x);
                (0, _deltaApplyMjs.translateAxis)(box.y, scroll.offset.y);
            }
            return box;
        }
        removeElementScroll(box) {
            const boxWithoutScroll = (0, _modelsMjs.createBox)();
            (0, _copyMjs.copyBoxInto)(boxWithoutScroll, box);
            /**
             * Performance TODO: Keep a cumulative scroll offset down the tree
             * rather than loop back up the path.
             */ for(let i = 0; i < this.path.length; i++){
                const node = this.path[i];
                const { scroll, options } = node;
                if (node !== this.root && scroll && options.layoutScroll) {
                    /**
                     * If this is a new scroll root, we want to remove all previous scrolls
                     * from the viewport box.
                     */ if (scroll.isRoot) {
                        (0, _copyMjs.copyBoxInto)(boxWithoutScroll, box);
                        const { scroll: rootScroll } = this.root;
                        /**
                         * Undo the application of page scroll that was originally added
                         * to the measured bounding box.
                         */ if (rootScroll) {
                            (0, _deltaApplyMjs.translateAxis)(boxWithoutScroll.x, -rootScroll.offset.x);
                            (0, _deltaApplyMjs.translateAxis)(boxWithoutScroll.y, -rootScroll.offset.y);
                        }
                    }
                    (0, _deltaApplyMjs.translateAxis)(boxWithoutScroll.x, scroll.offset.x);
                    (0, _deltaApplyMjs.translateAxis)(boxWithoutScroll.y, scroll.offset.y);
                }
            }
            return boxWithoutScroll;
        }
        applyTransform(box, transformOnly = false) {
            const withTransforms = (0, _modelsMjs.createBox)();
            (0, _copyMjs.copyBoxInto)(withTransforms, box);
            for(let i = 0; i < this.path.length; i++){
                const node = this.path[i];
                if (!transformOnly && node.options.layoutScroll && node.scroll && node !== node.root) (0, _deltaApplyMjs.transformBox)(withTransforms, {
                    x: -node.scroll.offset.x,
                    y: -node.scroll.offset.y
                });
                if (!(0, _hasTransformMjs.hasTransform)(node.latestValues)) continue;
                (0, _deltaApplyMjs.transformBox)(withTransforms, node.latestValues);
            }
            if ((0, _hasTransformMjs.hasTransform)(this.latestValues)) (0, _deltaApplyMjs.transformBox)(withTransforms, this.latestValues);
            return withTransforms;
        }
        removeTransform(box) {
            const boxWithoutTransform = (0, _modelsMjs.createBox)();
            (0, _copyMjs.copyBoxInto)(boxWithoutTransform, box);
            for(let i = 0; i < this.path.length; i++){
                const node = this.path[i];
                if (!node.instance) continue;
                if (!(0, _hasTransformMjs.hasTransform)(node.latestValues)) continue;
                (0, _hasTransformMjs.hasScale)(node.latestValues) && node.updateSnapshot();
                const sourceBox = (0, _modelsMjs.createBox)();
                const nodeBox = node.measurePageBox();
                (0, _copyMjs.copyBoxInto)(sourceBox, nodeBox);
                (0, _deltaRemoveMjs.removeBoxTransforms)(boxWithoutTransform, node.latestValues, node.snapshot ? node.snapshot.layoutBox : undefined, sourceBox);
            }
            if ((0, _hasTransformMjs.hasTransform)(this.latestValues)) (0, _deltaRemoveMjs.removeBoxTransforms)(boxWithoutTransform, this.latestValues);
            return boxWithoutTransform;
        }
        setTargetDelta(delta) {
            this.targetDelta = delta;
            this.root.scheduleUpdateProjection();
            this.isProjectionDirty = true;
        }
        setOptions(options) {
            this.options = {
                ...this.options,
                ...options,
                crossfade: options.crossfade !== undefined ? options.crossfade : true
            };
        }
        clearMeasurements() {
            this.scroll = undefined;
            this.layout = undefined;
            this.snapshot = undefined;
            this.prevTransformTemplateValue = undefined;
            this.targetDelta = undefined;
            this.target = undefined;
            this.isLayoutDirty = false;
        }
        forceRelativeParentToResolveTarget() {
            if (!this.relativeParent) return;
            /**
             * If the parent target isn't up-to-date, force it to update.
             * This is an unfortunate de-optimisation as it means any updating relative
             * projection will cause all the relative parents to recalculate back
             * up the tree.
             */ if (this.relativeParent.resolvedRelativeTargetAt !== (0, _frameMjs.frameData).timestamp) this.relativeParent.resolveTargetDelta(true);
        }
        resolveTargetDelta(forceRecalculation = false) {
            var _a;
            /**
             * Once the dirty status of nodes has been spread through the tree, we also
             * need to check if we have a shared node of a different depth that has itself
             * been dirtied.
             */ const lead = this.getLead();
            this.isProjectionDirty || (this.isProjectionDirty = lead.isProjectionDirty);
            this.isTransformDirty || (this.isTransformDirty = lead.isTransformDirty);
            this.isSharedProjectionDirty || (this.isSharedProjectionDirty = lead.isSharedProjectionDirty);
            const isShared = Boolean(this.resumingFrom) || this !== lead;
            /**
             * We don't use transform for this step of processing so we don't
             * need to check whether any nodes have changed transform.
             */ const canSkip = !(forceRecalculation || isShared && this.isSharedProjectionDirty || this.isProjectionDirty || ((_a = this.parent) === null || _a === void 0 ? void 0 : _a.isProjectionDirty) || this.attemptToResolveRelativeTarget);
            if (canSkip) return;
            const { layout, layoutId } = this.options;
            /**
             * If we have no layout, we can't perform projection, so early return
             */ if (!this.layout || !(layout || layoutId)) return;
            this.resolvedRelativeTargetAt = (0, _frameMjs.frameData).timestamp;
            /**
             * If we don't have a targetDelta but do have a layout, we can attempt to resolve
             * a relativeParent. This will allow a component to perform scale correction
             * even if no animation has started.
             */ // TODO If this is unsuccessful this currently happens every frame
            if (!this.targetDelta && !this.relativeTarget) {
                // TODO: This is a semi-repetition of further down this function, make DRY
                const relativeParent = this.getClosestProjectingParent();
                if (relativeParent && relativeParent.layout && this.animationProgress !== 1) {
                    this.relativeParent = relativeParent;
                    this.forceRelativeParentToResolveTarget();
                    this.relativeTarget = (0, _modelsMjs.createBox)();
                    this.relativeTargetOrigin = (0, _modelsMjs.createBox)();
                    (0, _deltaCalcMjs.calcRelativePosition)(this.relativeTargetOrigin, this.layout.layoutBox, relativeParent.layout.layoutBox);
                    (0, _copyMjs.copyBoxInto)(this.relativeTarget, this.relativeTargetOrigin);
                } else this.relativeParent = this.relativeTarget = undefined;
            }
            /**
             * If we have no relative target or no target delta our target isn't valid
             * for this frame.
             */ if (!this.relativeTarget && !this.targetDelta) return;
            /**
             * Lazy-init target data structure
             */ if (!this.target) {
                this.target = (0, _modelsMjs.createBox)();
                this.targetWithTransforms = (0, _modelsMjs.createBox)();
            }
            /**
             * If we've got a relative box for this component, resolve it into a target relative to the parent.
             */ if (this.relativeTarget && this.relativeTargetOrigin && this.relativeParent && this.relativeParent.target) {
                this.forceRelativeParentToResolveTarget();
                (0, _deltaCalcMjs.calcRelativeBox)(this.target, this.relativeTarget, this.relativeParent.target);
            /**
                 * If we've only got a targetDelta, resolve it into a target
                 */ } else if (this.targetDelta) {
                if (Boolean(this.resumingFrom)) // TODO: This is creating a new object every frame
                this.target = this.applyTransform(this.layout.layoutBox);
                else (0, _copyMjs.copyBoxInto)(this.target, this.layout.layoutBox);
                (0, _deltaApplyMjs.applyBoxDelta)(this.target, this.targetDelta);
            } else /**
                 * If no target, use own layout as target
                 */ (0, _copyMjs.copyBoxInto)(this.target, this.layout.layoutBox);
            /**
             * If we've been told to attempt to resolve a relative target, do so.
             */ if (this.attemptToResolveRelativeTarget) {
                this.attemptToResolveRelativeTarget = false;
                const relativeParent = this.getClosestProjectingParent();
                if (relativeParent && Boolean(relativeParent.resumingFrom) === Boolean(this.resumingFrom) && !relativeParent.options.layoutScroll && relativeParent.target && this.animationProgress !== 1) {
                    this.relativeParent = relativeParent;
                    this.forceRelativeParentToResolveTarget();
                    this.relativeTarget = (0, _modelsMjs.createBox)();
                    this.relativeTargetOrigin = (0, _modelsMjs.createBox)();
                    (0, _deltaCalcMjs.calcRelativePosition)(this.relativeTargetOrigin, this.target, relativeParent.target);
                    (0, _copyMjs.copyBoxInto)(this.relativeTarget, this.relativeTargetOrigin);
                } else this.relativeParent = this.relativeTarget = undefined;
            }
            /**
             * Increase debug counter for resolved target deltas
             */ projectionFrameData.resolvedTargetDeltas++;
        }
        getClosestProjectingParent() {
            if (!this.parent || (0, _hasTransformMjs.hasScale)(this.parent.latestValues) || (0, _hasTransformMjs.has2DTranslate)(this.parent.latestValues)) return undefined;
            if (this.parent.isProjecting()) return this.parent;
            else return this.parent.getClosestProjectingParent();
        }
        isProjecting() {
            return Boolean((this.relativeTarget || this.targetDelta || this.options.layoutRoot) && this.layout);
        }
        calcProjection() {
            var _a;
            const lead = this.getLead();
            const isShared = Boolean(this.resumingFrom) || this !== lead;
            let canSkip = true;
            /**
             * If this is a normal layout animation and neither this node nor its nearest projecting
             * is dirty then we can't skip.
             */ if (this.isProjectionDirty || ((_a = this.parent) === null || _a === void 0 ? void 0 : _a.isProjectionDirty)) canSkip = false;
            /**
             * If this is a shared layout animation and this node's shared projection is dirty then
             * we can't skip.
             */ if (isShared && (this.isSharedProjectionDirty || this.isTransformDirty)) canSkip = false;
            /**
             * If we have resolved the target this frame we must recalculate the
             * projection to ensure it visually represents the internal calculations.
             */ if (this.resolvedRelativeTargetAt === (0, _frameMjs.frameData).timestamp) canSkip = false;
            if (canSkip) return;
            const { layout, layoutId } = this.options;
            /**
             * If this section of the tree isn't animating we can
             * delete our target sources for the following frame.
             */ this.isTreeAnimating = Boolean(this.parent && this.parent.isTreeAnimating || this.currentAnimation || this.pendingAnimation);
            if (!this.isTreeAnimating) this.targetDelta = this.relativeTarget = undefined;
            if (!this.layout || !(layout || layoutId)) return;
            /**
             * Reset the corrected box with the latest values from box, as we're then going
             * to perform mutative operations on it.
             */ (0, _copyMjs.copyBoxInto)(this.layoutCorrected, this.layout.layoutBox);
            /**
             * Record previous tree scales before updating.
             */ const prevTreeScaleX = this.treeScale.x;
            const prevTreeScaleY = this.treeScale.y;
            /**
             * Apply all the parent deltas to this box to produce the corrected box. This
             * is the layout box, as it will appear on screen as a result of the transforms of its parents.
             */ (0, _deltaApplyMjs.applyTreeDeltas)(this.layoutCorrected, this.treeScale, this.path, isShared);
            /**
             * If this layer needs to perform scale correction but doesn't have a target,
             * use the layout as the target.
             */ if (lead.layout && !lead.target && (this.treeScale.x !== 1 || this.treeScale.y !== 1)) lead.target = lead.layout.layoutBox;
            const { target } = lead;
            if (!target) {
                /**
                 * If we don't have a target to project into, but we were previously
                 * projecting, we want to remove the stored transform and schedule
                 * a render to ensure the elements reflect the removed transform.
                 */ if (this.projectionTransform) {
                    this.projectionDelta = (0, _modelsMjs.createDelta)();
                    this.projectionTransform = "none";
                    this.scheduleRender();
                }
                return;
            }
            if (!this.projectionDelta) {
                this.projectionDelta = (0, _modelsMjs.createDelta)();
                this.projectionDeltaWithTransform = (0, _modelsMjs.createDelta)();
            }
            const prevProjectionTransform = this.projectionTransform;
            /**
             * Update the delta between the corrected box and the target box before user-set transforms were applied.
             * This will allow us to calculate the corrected borderRadius and boxShadow to compensate
             * for our layout reprojection, but still allow them to be scaled correctly by the user.
             * It might be that to simplify this we may want to accept that user-set scale is also corrected
             * and we wouldn't have to keep and calc both deltas, OR we could support a user setting
             * to allow people to choose whether these styles are corrected based on just the
             * layout reprojection or the final bounding box.
             */ (0, _deltaCalcMjs.calcBoxDelta)(this.projectionDelta, this.layoutCorrected, target, this.latestValues);
            this.projectionTransform = (0, _transformMjs.buildProjectionTransform)(this.projectionDelta, this.treeScale);
            if (this.projectionTransform !== prevProjectionTransform || this.treeScale.x !== prevTreeScaleX || this.treeScale.y !== prevTreeScaleY) {
                this.hasProjected = true;
                this.scheduleRender();
                this.notifyListeners("projectionUpdate", target);
            }
            /**
             * Increase debug counter for recalculated projections
             */ projectionFrameData.recalculatedProjection++;
        }
        hide() {
            this.isVisible = false;
        // TODO: Schedule render
        }
        show() {
            this.isVisible = true;
        // TODO: Schedule render
        }
        scheduleRender(notifyAll = true) {
            this.options.scheduleRender && this.options.scheduleRender();
            if (notifyAll) {
                const stack = this.getStack();
                stack && stack.scheduleRender();
            }
            if (this.resumingFrom && !this.resumingFrom.instance) this.resumingFrom = undefined;
        }
        setAnimationOrigin(delta, hasOnlyRelativeTargetChanged = false) {
            const snapshot = this.snapshot;
            const snapshotLatestValues = snapshot ? snapshot.latestValues : {};
            const mixedValues = {
                ...this.latestValues
            };
            const targetDelta = (0, _modelsMjs.createDelta)();
            if (!this.relativeParent || !this.relativeParent.options.layoutRoot) this.relativeTarget = this.relativeTargetOrigin = undefined;
            this.attemptToResolveRelativeTarget = !hasOnlyRelativeTargetChanged;
            const relativeLayout = (0, _modelsMjs.createBox)();
            const snapshotSource = snapshot ? snapshot.source : undefined;
            const layoutSource = this.layout ? this.layout.source : undefined;
            const isSharedLayoutAnimation = snapshotSource !== layoutSource;
            const stack = this.getStack();
            const isOnlyMember = !stack || stack.members.length <= 1;
            const shouldCrossfadeOpacity = Boolean(isSharedLayoutAnimation && !isOnlyMember && this.options.crossfade === true && !this.path.some(hasOpacityCrossfade));
            this.animationProgress = 0;
            let prevRelativeTarget;
            this.mixTargetDelta = (latest)=>{
                const progress = latest / 1000;
                mixAxisDelta(targetDelta.x, delta.x, progress);
                mixAxisDelta(targetDelta.y, delta.y, progress);
                this.setTargetDelta(targetDelta);
                if (this.relativeTarget && this.relativeTargetOrigin && this.layout && this.relativeParent && this.relativeParent.layout) {
                    (0, _deltaCalcMjs.calcRelativePosition)(relativeLayout, this.layout.layoutBox, this.relativeParent.layout.layoutBox);
                    mixBox(this.relativeTarget, this.relativeTargetOrigin, relativeLayout, progress);
                    /**
                     * If this is an unchanged relative target we can consider the
                     * projection not dirty.
                     */ if (prevRelativeTarget && (0, _utilsMjs.boxEquals)(this.relativeTarget, prevRelativeTarget)) this.isProjectionDirty = false;
                    if (!prevRelativeTarget) prevRelativeTarget = (0, _modelsMjs.createBox)();
                    (0, _copyMjs.copyBoxInto)(prevRelativeTarget, this.relativeTarget);
                }
                if (isSharedLayoutAnimation) {
                    this.animationValues = mixedValues;
                    (0, _mixValuesMjs.mixValues)(mixedValues, snapshotLatestValues, this.latestValues, progress, shouldCrossfadeOpacity, isOnlyMember);
                }
                this.root.scheduleUpdateProjection();
                this.scheduleRender();
                this.animationProgress = progress;
            };
            this.mixTargetDelta(this.options.layoutRoot ? 1000 : 0);
        }
        startAnimation(options) {
            this.notifyListeners("animationStart");
            this.currentAnimation && this.currentAnimation.stop();
            if (this.resumingFrom && this.resumingFrom.currentAnimation) this.resumingFrom.currentAnimation.stop();
            if (this.pendingAnimation) {
                (0, _frameMjs.cancelFrame)(this.pendingAnimation);
                this.pendingAnimation = undefined;
            }
            /**
             * Start the animation in the next frame to have a frame with progress 0,
             * where the target is the same as when the animation started, so we can
             * calculate the relative positions correctly for instant transitions.
             */ this.pendingAnimation = (0, _frameMjs.frame).update(()=>{
                (0, _stateMjs.globalProjectionState).hasAnimatedSinceResize = true;
                this.currentAnimation = (0, _singleValueMjs.animateSingleValue)(0, animationTarget, {
                    ...options,
                    onUpdate: (latest)=>{
                        this.mixTargetDelta(latest);
                        options.onUpdate && options.onUpdate(latest);
                    },
                    onComplete: ()=>{
                        options.onComplete && options.onComplete();
                        this.completeAnimation();
                    }
                });
                if (this.resumingFrom) this.resumingFrom.currentAnimation = this.currentAnimation;
                this.pendingAnimation = undefined;
            });
        }
        completeAnimation() {
            if (this.resumingFrom) {
                this.resumingFrom.currentAnimation = undefined;
                this.resumingFrom.preserveOpacity = undefined;
            }
            const stack = this.getStack();
            stack && stack.exitAnimationComplete();
            this.resumingFrom = this.currentAnimation = this.animationValues = undefined;
            this.notifyListeners("animationComplete");
        }
        finishAnimation() {
            if (this.currentAnimation) {
                this.mixTargetDelta && this.mixTargetDelta(animationTarget);
                this.currentAnimation.stop();
            }
            this.completeAnimation();
        }
        applyTransformsToTarget() {
            const lead = this.getLead();
            let { targetWithTransforms, target, layout, latestValues } = lead;
            if (!targetWithTransforms || !target || !layout) return;
            /**
             * If we're only animating position, and this element isn't the lead element,
             * then instead of projecting into the lead box we instead want to calculate
             * a new target that aligns the two boxes but maintains the layout shape.
             */ if (this !== lead && this.layout && layout && shouldAnimatePositionOnly(this.options.animationType, this.layout.layoutBox, layout.layoutBox)) {
                target = this.target || (0, _modelsMjs.createBox)();
                const xLength = (0, _deltaCalcMjs.calcLength)(this.layout.layoutBox.x);
                target.x.min = lead.target.x.min;
                target.x.max = target.x.min + xLength;
                const yLength = (0, _deltaCalcMjs.calcLength)(this.layout.layoutBox.y);
                target.y.min = lead.target.y.min;
                target.y.max = target.y.min + yLength;
            }
            (0, _copyMjs.copyBoxInto)(targetWithTransforms, target);
            /**
             * Apply the latest user-set transforms to the targetBox to produce the targetBoxFinal.
             * This is the final box that we will then project into by calculating a transform delta and
             * applying it to the corrected box.
             */ (0, _deltaApplyMjs.transformBox)(targetWithTransforms, latestValues);
            /**
             * Update the delta between the corrected box and the final target box, after
             * user-set transforms are applied to it. This will be used by the renderer to
             * create a transform style that will reproject the element from its layout layout
             * into the desired bounding box.
             */ (0, _deltaCalcMjs.calcBoxDelta)(this.projectionDeltaWithTransform, this.layoutCorrected, targetWithTransforms, latestValues);
        }
        registerSharedNode(layoutId, node) {
            if (!this.sharedNodes.has(layoutId)) this.sharedNodes.set(layoutId, new (0, _stackMjs.NodeStack)());
            const stack = this.sharedNodes.get(layoutId);
            stack.add(node);
            const config = node.options.initialPromotionConfig;
            node.promote({
                transition: config ? config.transition : undefined,
                preserveFollowOpacity: config && config.shouldPreserveFollowOpacity ? config.shouldPreserveFollowOpacity(node) : undefined
            });
        }
        isLead() {
            const stack = this.getStack();
            return stack ? stack.lead === this : true;
        }
        getLead() {
            var _a;
            const { layoutId } = this.options;
            return layoutId ? ((_a = this.getStack()) === null || _a === void 0 ? void 0 : _a.lead) || this : this;
        }
        getPrevLead() {
            var _a;
            const { layoutId } = this.options;
            return layoutId ? (_a = this.getStack()) === null || _a === void 0 ? void 0 : _a.prevLead : undefined;
        }
        getStack() {
            const { layoutId } = this.options;
            if (layoutId) return this.root.sharedNodes.get(layoutId);
        }
        promote({ needsReset, transition, preserveFollowOpacity } = {}) {
            const stack = this.getStack();
            if (stack) stack.promote(this, preserveFollowOpacity);
            if (needsReset) {
                this.projectionDelta = undefined;
                this.needsReset = true;
            }
            if (transition) this.setOptions({
                transition
            });
        }
        relegate() {
            const stack = this.getStack();
            if (stack) return stack.relegate(this);
            else return false;
        }
        resetRotation() {
            const { visualElement } = this.options;
            if (!visualElement) return;
            // If there's no detected rotation values, we can early return without a forced render.
            let hasRotate = false;
            /**
             * An unrolled check for rotation values. Most elements don't have any rotation and
             * skipping the nested loop and new object creation is 50% faster.
             */ const { latestValues } = visualElement;
            if (latestValues.rotate || latestValues.rotateX || latestValues.rotateY || latestValues.rotateZ) hasRotate = true;
            // If there's no rotation values, we don't need to do any more.
            if (!hasRotate) return;
            const resetValues = {};
            // Check the rotate value of all axes and reset to 0
            for(let i = 0; i < transformAxes.length; i++){
                const key = "rotate" + transformAxes[i];
                // Record the rotation and then temporarily set it to 0
                if (latestValues[key]) {
                    resetValues[key] = latestValues[key];
                    visualElement.setStaticValue(key, 0);
                }
            }
            // Force a render of this element to apply the transform with all rotations
            // set to 0.
            visualElement.render();
            // Put back all the values we reset
            for(const key in resetValues)visualElement.setStaticValue(key, resetValues[key]);
            // Schedule a render for the next frame. This ensures we won't visually
            // see the element with the reset rotate value applied.
            visualElement.scheduleRender();
        }
        getProjectionStyles(styleProp) {
            var _a, _b;
            if (!this.instance || this.isSVG) return undefined;
            if (!this.isVisible) return hiddenVisibility;
            const styles = {
                visibility: ""
            };
            const transformTemplate = this.getTransformTemplate();
            if (this.needsReset) {
                this.needsReset = false;
                styles.opacity = "";
                styles.pointerEvents = (0, _resolveMotionValueMjs.resolveMotionValue)(styleProp === null || styleProp === void 0 ? void 0 : styleProp.pointerEvents) || "";
                styles.transform = transformTemplate ? transformTemplate(this.latestValues, "") : "none";
                return styles;
            }
            const lead = this.getLead();
            if (!this.projectionDelta || !this.layout || !lead.target) {
                const emptyStyles = {};
                if (this.options.layoutId) {
                    emptyStyles.opacity = this.latestValues.opacity !== undefined ? this.latestValues.opacity : 1;
                    emptyStyles.pointerEvents = (0, _resolveMotionValueMjs.resolveMotionValue)(styleProp === null || styleProp === void 0 ? void 0 : styleProp.pointerEvents) || "";
                }
                if (this.hasProjected && !(0, _hasTransformMjs.hasTransform)(this.latestValues)) {
                    emptyStyles.transform = transformTemplate ? transformTemplate({}, "") : "none";
                    this.hasProjected = false;
                }
                return emptyStyles;
            }
            const valuesToRender = lead.animationValues || lead.latestValues;
            this.applyTransformsToTarget();
            styles.transform = (0, _transformMjs.buildProjectionTransform)(this.projectionDeltaWithTransform, this.treeScale, valuesToRender);
            if (transformTemplate) styles.transform = transformTemplate(valuesToRender, styles.transform);
            const { x, y } = this.projectionDelta;
            styles.transformOrigin = `${x.origin * 100}% ${y.origin * 100}% 0`;
            if (lead.animationValues) /**
                 * If the lead component is animating, assign this either the entering/leaving
                 * opacity
                 */ styles.opacity = lead === this ? (_b = (_a = valuesToRender.opacity) !== null && _a !== void 0 ? _a : this.latestValues.opacity) !== null && _b !== void 0 ? _b : 1 : this.preserveOpacity ? this.latestValues.opacity : valuesToRender.opacityExit;
            else /**
                 * Or we're not animating at all, set the lead component to its layout
                 * opacity and other components to hidden.
                 */ styles.opacity = lead === this ? valuesToRender.opacity !== undefined ? valuesToRender.opacity : "" : valuesToRender.opacityExit !== undefined ? valuesToRender.opacityExit : 0;
            /**
             * Apply scale correction
             */ for(const key in 0, _scaleCorrectionMjs.scaleCorrectors){
                if (valuesToRender[key] === undefined) continue;
                const { correct, applyTo } = (0, _scaleCorrectionMjs.scaleCorrectors)[key];
                /**
                 * Only apply scale correction to the value if we have an
                 * active projection transform. Otherwise these values become
                 * vulnerable to distortion if the element changes size without
                 * a corresponding layout animation.
                 */ const corrected = styles.transform === "none" ? valuesToRender[key] : correct(valuesToRender[key], lead);
                if (applyTo) {
                    const num = applyTo.length;
                    for(let i = 0; i < num; i++)styles[applyTo[i]] = corrected;
                } else styles[key] = corrected;
            }
            /**
             * Disable pointer events on follow components. This is to ensure
             * that if a follow component covers a lead component it doesn't block
             * pointer events on the lead.
             */ if (this.options.layoutId) styles.pointerEvents = lead === this ? (0, _resolveMotionValueMjs.resolveMotionValue)(styleProp === null || styleProp === void 0 ? void 0 : styleProp.pointerEvents) || "" : "none";
            return styles;
        }
        clearSnapshot() {
            this.resumeFrom = this.snapshot = undefined;
        }
        // Only run on root
        resetTree() {
            this.root.nodes.forEach((node)=>{
                var _a;
                return (_a = node.currentAnimation) === null || _a === void 0 ? void 0 : _a.stop();
            });
            this.root.nodes.forEach(clearMeasurements);
            this.root.sharedNodes.clear();
        }
    };
}
function updateLayout(node) {
    node.updateLayout();
}
function notifyLayoutUpdate(node) {
    var _a;
    const snapshot = ((_a = node.resumeFrom) === null || _a === void 0 ? void 0 : _a.snapshot) || node.snapshot;
    if (node.isLead() && node.layout && snapshot && node.hasListeners("didUpdate")) {
        const { layoutBox: layout, measuredBox: measuredLayout } = node.layout;
        const { animationType } = node.options;
        const isShared = snapshot.source !== node.layout.source;
        // TODO Maybe we want to also resize the layout snapshot so we don't trigger
        // animations for instance if layout="size" and an element has only changed position
        if (animationType === "size") (0, _eachAxisMjs.eachAxis)((axis)=>{
            const axisSnapshot = isShared ? snapshot.measuredBox[axis] : snapshot.layoutBox[axis];
            const length = (0, _deltaCalcMjs.calcLength)(axisSnapshot);
            axisSnapshot.min = layout[axis].min;
            axisSnapshot.max = axisSnapshot.min + length;
        });
        else if (shouldAnimatePositionOnly(animationType, snapshot.layoutBox, layout)) (0, _eachAxisMjs.eachAxis)((axis)=>{
            const axisSnapshot = isShared ? snapshot.measuredBox[axis] : snapshot.layoutBox[axis];
            const length = (0, _deltaCalcMjs.calcLength)(layout[axis]);
            axisSnapshot.max = axisSnapshot.min + length;
            /**
                 * Ensure relative target gets resized and rerendererd
                 */ if (node.relativeTarget && !node.currentAnimation) {
                node.isProjectionDirty = true;
                node.relativeTarget[axis].max = node.relativeTarget[axis].min + length;
            }
        });
        const layoutDelta = (0, _modelsMjs.createDelta)();
        (0, _deltaCalcMjs.calcBoxDelta)(layoutDelta, layout, snapshot.layoutBox);
        const visualDelta = (0, _modelsMjs.createDelta)();
        if (isShared) (0, _deltaCalcMjs.calcBoxDelta)(visualDelta, node.applyTransform(measuredLayout, true), snapshot.measuredBox);
        else (0, _deltaCalcMjs.calcBoxDelta)(visualDelta, layout, snapshot.layoutBox);
        const hasLayoutChanged = !(0, _utilsMjs.isDeltaZero)(layoutDelta);
        let hasRelativeTargetChanged = false;
        if (!node.resumeFrom) {
            const relativeParent = node.getClosestProjectingParent();
            /**
             * If the relativeParent is itself resuming from a different element then
             * the relative snapshot is not relavent
             */ if (relativeParent && !relativeParent.resumeFrom) {
                const { snapshot: parentSnapshot, layout: parentLayout } = relativeParent;
                if (parentSnapshot && parentLayout) {
                    const relativeSnapshot = (0, _modelsMjs.createBox)();
                    (0, _deltaCalcMjs.calcRelativePosition)(relativeSnapshot, snapshot.layoutBox, parentSnapshot.layoutBox);
                    const relativeLayout = (0, _modelsMjs.createBox)();
                    (0, _deltaCalcMjs.calcRelativePosition)(relativeLayout, layout, parentLayout.layoutBox);
                    if (!(0, _utilsMjs.boxEqualsRounded)(relativeSnapshot, relativeLayout)) hasRelativeTargetChanged = true;
                    if (relativeParent.options.layoutRoot) {
                        node.relativeTarget = relativeLayout;
                        node.relativeTargetOrigin = relativeSnapshot;
                        node.relativeParent = relativeParent;
                    }
                }
            }
        }
        node.notifyListeners("didUpdate", {
            layout,
            snapshot,
            delta: visualDelta,
            layoutDelta,
            hasLayoutChanged,
            hasRelativeTargetChanged
        });
    } else if (node.isLead()) {
        const { onExitComplete } = node.options;
        onExitComplete && onExitComplete();
    }
    /**
     * Clearing transition
     * TODO: Investigate why this transition is being passed in as {type: false } from Framer
     * and why we need it at all
     */ node.options.transition = undefined;
}
function propagateDirtyNodes(node) {
    /**
     * Increase debug counter for nodes encountered this frame
     */ projectionFrameData.totalNodes++;
    if (!node.parent) return;
    /**
     * If this node isn't projecting, propagate isProjectionDirty. It will have
     * no performance impact but it will allow the next child that *is* projecting
     * but *isn't* dirty to just check its parent to see if *any* ancestor needs
     * correcting.
     */ if (!node.isProjecting()) node.isProjectionDirty = node.parent.isProjectionDirty;
    /**
     * Propagate isSharedProjectionDirty and isTransformDirty
     * throughout the whole tree. A future revision can take another look at
     * this but for safety we still recalcualte shared nodes.
     */ node.isSharedProjectionDirty || (node.isSharedProjectionDirty = Boolean(node.isProjectionDirty || node.parent.isProjectionDirty || node.parent.isSharedProjectionDirty));
    node.isTransformDirty || (node.isTransformDirty = node.parent.isTransformDirty);
}
function cleanDirtyNodes(node) {
    node.isProjectionDirty = node.isSharedProjectionDirty = node.isTransformDirty = false;
}
function clearSnapshot(node) {
    node.clearSnapshot();
}
function clearMeasurements(node) {
    node.clearMeasurements();
}
function clearIsLayoutDirty(node) {
    node.isLayoutDirty = false;
}
function resetTransformStyle(node) {
    const { visualElement } = node.options;
    if (visualElement && visualElement.getProps().onBeforeLayoutMeasure) visualElement.notify("BeforeLayoutMeasure");
    node.resetTransform();
}
function finishAnimation(node) {
    node.finishAnimation();
    node.targetDelta = node.relativeTarget = node.target = undefined;
    node.isProjectionDirty = true;
}
function resolveTargetDelta(node) {
    node.resolveTargetDelta();
}
function calcProjection(node) {
    node.calcProjection();
}
function resetRotation(node) {
    node.resetRotation();
}
function removeLeadSnapshots(stack) {
    stack.removeLeadSnapshot();
}
function mixAxisDelta(output, delta, p) {
    output.translate = (0, _mixMjs.mix)(delta.translate, 0, p);
    output.scale = (0, _mixMjs.mix)(delta.scale, 1, p);
    output.origin = delta.origin;
    output.originPoint = delta.originPoint;
}
function mixAxis(output, from, to, p) {
    output.min = (0, _mixMjs.mix)(from.min, to.min, p);
    output.max = (0, _mixMjs.mix)(from.max, to.max, p);
}
function mixBox(output, from, to, p) {
    mixAxis(output.x, from.x, to.x, p);
    mixAxis(output.y, from.y, to.y, p);
}
function hasOpacityCrossfade(node) {
    return node.animationValues && node.animationValues.opacityExit !== undefined;
}
const defaultLayoutTransition = {
    duration: 0.45,
    ease: [
        0.4,
        0,
        0.1,
        1
    ]
};
const userAgentContains = (string)=>typeof navigator !== "undefined" && navigator.userAgent.toLowerCase().includes(string);
/**
 * Measured bounding boxes must be rounded in Safari and
 * left untouched in Chrome, otherwise non-integer layouts within scaled-up elements
 * can appear to jump.
 */ const roundPoint = userAgentContains("applewebkit/") && !userAgentContains("chrome/") ? Math.round : (0, _noopMjs.noop);
function roundAxis(axis) {
    // Round to the nearest .5 pixels to support subpixel layouts
    axis.min = roundPoint(axis.min);
    axis.max = roundPoint(axis.max);
}
function roundBox(box) {
    roundAxis(box.x);
    roundAxis(box.y);
}
function shouldAnimatePositionOnly(animationType, snapshot, layout) {
    return animationType === "position" || animationType === "preserve-aspect" && !(0, _deltaCalcMjs.isNear)((0, _utilsMjs.aspectRatio)(snapshot), (0, _utilsMjs.aspectRatio)(layout), 0.2);
}

},{"../../utils/subscription-manager.mjs":"dlxLW","../animation/mix-values.mjs":"j7By7","../geometry/copy.mjs":"8tF3L","../geometry/delta-apply.mjs":"36VRX","../geometry/delta-calc.mjs":"lmUuI","../geometry/delta-remove.mjs":"1BpAZ","../geometry/models.mjs":"huYV1","../../animation/utils/transitions.mjs":"hIHWM","../geometry/utils.mjs":"DjrUU","../shared/stack.mjs":"hHhUs","../styles/scale-correction.mjs":"4bQbP","../styles/transform.mjs":"eJIA7","../utils/each-axis.mjs":"dZLv7","../utils/has-transform.mjs":"7hVzp","../../render/utils/flat-tree.mjs":"5W1eO","../../value/utils/resolve-motion-value.mjs":"3pwN1","./state.mjs":"5xBUr","../../utils/delay.mjs":"jfaIw","../../utils/mix.mjs":"cEof3","../../debug/record.mjs":"kf4Kb","../../render/dom/utils/is-svg-element.mjs":"ytKOV","../../animation/interfaces/single-value.mjs":"TVjEd","../../utils/clamp.mjs":"5mu0r","../../frameloop/frame.mjs":"gdRIq","../../utils/noop.mjs":"7roqC","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"j7By7":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "mixValues", ()=>mixValues);
var _circMjs = require("../../easing/circ.mjs");
var _progressMjs = require("../../utils/progress.mjs");
var _mixMjs = require("../../utils/mix.mjs");
var _noopMjs = require("../../utils/noop.mjs");
var _unitsMjs = require("../../value/types/numbers/units.mjs");
const borders = [
    "TopLeft",
    "TopRight",
    "BottomLeft",
    "BottomRight"
];
const numBorders = borders.length;
const asNumber = (value)=>typeof value === "string" ? parseFloat(value) : value;
const isPx = (value)=>typeof value === "number" || (0, _unitsMjs.px).test(value);
function mixValues(target, follow, lead, progress, shouldCrossfadeOpacity, isOnlyMember) {
    if (shouldCrossfadeOpacity) {
        target.opacity = (0, _mixMjs.mix)(0, // TODO Reinstate this if only child
        lead.opacity !== undefined ? lead.opacity : 1, easeCrossfadeIn(progress));
        target.opacityExit = (0, _mixMjs.mix)(follow.opacity !== undefined ? follow.opacity : 1, 0, easeCrossfadeOut(progress));
    } else if (isOnlyMember) target.opacity = (0, _mixMjs.mix)(follow.opacity !== undefined ? follow.opacity : 1, lead.opacity !== undefined ? lead.opacity : 1, progress);
    /**
     * Mix border radius
     */ for(let i = 0; i < numBorders; i++){
        const borderLabel = `border${borders[i]}Radius`;
        let followRadius = getRadius(follow, borderLabel);
        let leadRadius = getRadius(lead, borderLabel);
        if (followRadius === undefined && leadRadius === undefined) continue;
        followRadius || (followRadius = 0);
        leadRadius || (leadRadius = 0);
        const canMix = followRadius === 0 || leadRadius === 0 || isPx(followRadius) === isPx(leadRadius);
        if (canMix) {
            target[borderLabel] = Math.max((0, _mixMjs.mix)(asNumber(followRadius), asNumber(leadRadius), progress), 0);
            if ((0, _unitsMjs.percent).test(leadRadius) || (0, _unitsMjs.percent).test(followRadius)) target[borderLabel] += "%";
        } else target[borderLabel] = leadRadius;
    }
    /**
     * Mix rotation
     */ if (follow.rotate || lead.rotate) target.rotate = (0, _mixMjs.mix)(follow.rotate || 0, lead.rotate || 0, progress);
}
function getRadius(values, radiusName) {
    return values[radiusName] !== undefined ? values[radiusName] : values.borderRadius;
}
// /**
//  * We only want to mix the background color if there's a follow element
//  * that we're not crossfading opacity between. For instance with switch
//  * AnimateSharedLayout animations, this helps the illusion of a continuous
//  * element being animated but also cuts down on the number of paints triggered
//  * for elements where opacity is doing that work for us.
//  */
// if (
//     !hasFollowElement &&
//     latestLeadValues.backgroundColor &&
//     latestFollowValues.backgroundColor
// ) {
//     /**
//      * This isn't ideal performance-wise as mixColor is creating a new function every frame.
//      * We could probably create a mixer that runs at the start of the animation but
//      * the idea behind the crossfader is that it runs dynamically between two potentially
//      * changing targets (ie opacity or borderRadius may be animating independently via variants)
//      */
//     leadState.backgroundColor = followState.backgroundColor = mixColor(
//         latestFollowValues.backgroundColor as string,
//         latestLeadValues.backgroundColor as string
//     )(p)
// }
const easeCrossfadeIn = compress(0, 0.5, (0, _circMjs.circOut));
const easeCrossfadeOut = compress(0.5, 0.95, (0, _noopMjs.noop));
function compress(min, max, easing) {
    return (p)=>{
        // Could replace ifs with clamp
        if (p < min) return 0;
        if (p > max) return 1;
        return easing((0, _progressMjs.progress)(min, max, p));
    };
}

},{"../../easing/circ.mjs":"do4I6","../../utils/progress.mjs":"4ZPxX","../../utils/mix.mjs":"cEof3","../../utils/noop.mjs":"7roqC","../../value/types/numbers/units.mjs":"hGtBr","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8tF3L":[function(require,module,exports) {
/**
 * Reset an axis to the provided origin box.
 *
 * This is a mutative operation.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "copyAxisInto", ()=>copyAxisInto);
parcelHelpers.export(exports, "copyBoxInto", ()=>copyBoxInto);
function copyAxisInto(axis, originAxis) {
    axis.min = originAxis.min;
    axis.max = originAxis.max;
}
/**
 * Reset a box to the provided origin box.
 *
 * This is a mutative operation.
 */ function copyBoxInto(box, originBox) {
    copyAxisInto(box.x, originBox.x);
    copyAxisInto(box.y, originBox.y);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"1BpAZ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "removeAxisDelta", ()=>removeAxisDelta);
parcelHelpers.export(exports, "removeAxisTransforms", ()=>removeAxisTransforms);
parcelHelpers.export(exports, "removeBoxTransforms", ()=>removeBoxTransforms);
parcelHelpers.export(exports, "removePointDelta", ()=>removePointDelta);
var _mixMjs = require("../../utils/mix.mjs");
var _unitsMjs = require("../../value/types/numbers/units.mjs");
var _deltaApplyMjs = require("./delta-apply.mjs");
/**
 * Remove a delta from a point. This is essentially the steps of applyPointDelta in reverse
 */ function removePointDelta(point, translate, scale, originPoint, boxScale) {
    point -= translate;
    point = (0, _deltaApplyMjs.scalePoint)(point, 1 / scale, originPoint);
    if (boxScale !== undefined) point = (0, _deltaApplyMjs.scalePoint)(point, 1 / boxScale, originPoint);
    return point;
}
/**
 * Remove a delta from an axis. This is essentially the steps of applyAxisDelta in reverse
 */ function removeAxisDelta(axis, translate = 0, scale = 1, origin = 0.5, boxScale, originAxis = axis, sourceAxis = axis) {
    if ((0, _unitsMjs.percent).test(translate)) {
        translate = parseFloat(translate);
        const relativeProgress = (0, _mixMjs.mix)(sourceAxis.min, sourceAxis.max, translate / 100);
        translate = relativeProgress - sourceAxis.min;
    }
    if (typeof translate !== "number") return;
    let originPoint = (0, _mixMjs.mix)(originAxis.min, originAxis.max, origin);
    if (axis === originAxis) originPoint -= translate;
    axis.min = removePointDelta(axis.min, translate, scale, originPoint, boxScale);
    axis.max = removePointDelta(axis.max, translate, scale, originPoint, boxScale);
}
/**
 * Remove a transforms from an axis. This is essentially the steps of applyAxisTransforms in reverse
 * and acts as a bridge between motion values and removeAxisDelta
 */ function removeAxisTransforms(axis, transforms, [key, scaleKey, originKey], origin, sourceAxis) {
    removeAxisDelta(axis, transforms[key], transforms[scaleKey], transforms[originKey], transforms.scale, origin, sourceAxis);
}
/**
 * The names of the motion values we want to apply as translation, scale and origin.
 */ const xKeys = [
    "x",
    "scaleX",
    "originX"
];
const yKeys = [
    "y",
    "scaleY",
    "originY"
];
/**
 * Remove a transforms from an box. This is essentially the steps of applyAxisBox in reverse
 * and acts as a bridge between motion values and removeAxisDelta
 */ function removeBoxTransforms(box, transforms, originBox, sourceBox) {
    removeAxisTransforms(box.x, transforms, xKeys, originBox ? originBox.x : undefined, sourceBox ? sourceBox.x : undefined);
    removeAxisTransforms(box.y, transforms, yKeys, originBox ? originBox.y : undefined, sourceBox ? sourceBox.y : undefined);
}

},{"../../utils/mix.mjs":"cEof3","../../value/types/numbers/units.mjs":"hGtBr","./delta-apply.mjs":"36VRX","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"DjrUU":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "aspectRatio", ()=>aspectRatio);
parcelHelpers.export(exports, "boxEquals", ()=>boxEquals);
parcelHelpers.export(exports, "boxEqualsRounded", ()=>boxEqualsRounded);
parcelHelpers.export(exports, "isDeltaZero", ()=>isDeltaZero);
var _deltaCalcMjs = require("./delta-calc.mjs");
function isAxisDeltaZero(delta) {
    return delta.translate === 0 && delta.scale === 1;
}
function isDeltaZero(delta) {
    return isAxisDeltaZero(delta.x) && isAxisDeltaZero(delta.y);
}
function boxEquals(a, b) {
    return a.x.min === b.x.min && a.x.max === b.x.max && a.y.min === b.y.min && a.y.max === b.y.max;
}
function boxEqualsRounded(a, b) {
    return Math.round(a.x.min) === Math.round(b.x.min) && Math.round(a.x.max) === Math.round(b.x.max) && Math.round(a.y.min) === Math.round(b.y.min) && Math.round(a.y.max) === Math.round(b.y.max);
}
function aspectRatio(box) {
    return (0, _deltaCalcMjs.calcLength)(box.x) / (0, _deltaCalcMjs.calcLength)(box.y);
}

},{"./delta-calc.mjs":"lmUuI","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"hHhUs":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "NodeStack", ()=>NodeStack);
var _arrayMjs = require("../../utils/array.mjs");
class NodeStack {
    constructor(){
        this.members = [];
    }
    add(node) {
        (0, _arrayMjs.addUniqueItem)(this.members, node);
        node.scheduleRender();
    }
    remove(node) {
        (0, _arrayMjs.removeItem)(this.members, node);
        if (node === this.prevLead) this.prevLead = undefined;
        if (node === this.lead) {
            const prevLead = this.members[this.members.length - 1];
            if (prevLead) this.promote(prevLead);
        }
    }
    relegate(node) {
        const indexOfNode = this.members.findIndex((member)=>node === member);
        if (indexOfNode === 0) return false;
        /**
         * Find the next projection node that is present
         */ let prevLead;
        for(let i = indexOfNode; i >= 0; i--){
            const member = this.members[i];
            if (member.isPresent !== false) {
                prevLead = member;
                break;
            }
        }
        if (prevLead) {
            this.promote(prevLead);
            return true;
        } else return false;
    }
    promote(node, preserveFollowOpacity) {
        const prevLead = this.lead;
        if (node === prevLead) return;
        this.prevLead = prevLead;
        this.lead = node;
        node.show();
        if (prevLead) {
            prevLead.instance && prevLead.scheduleRender();
            node.scheduleRender();
            node.resumeFrom = prevLead;
            if (preserveFollowOpacity) node.resumeFrom.preserveOpacity = true;
            if (prevLead.snapshot) {
                node.snapshot = prevLead.snapshot;
                node.snapshot.latestValues = prevLead.animationValues || prevLead.latestValues;
            }
            if (node.root && node.root.isUpdating) node.isLayoutDirty = true;
            const { crossfade } = node.options;
            if (crossfade === false) prevLead.hide();
        /**
             * TODO:
             *   - Test border radius when previous node was deleted
             *   - boxShadow mixing
             *   - Shared between element A in scrolled container and element B (scroll stays the same or changes)
             *   - Shared between element A in transformed container and element B (transform stays the same or changes)
             *   - Shared between element A in scrolled page and element B (scroll stays the same or changes)
             * ---
             *   - Crossfade opacity of root nodes
             *   - layoutId changes after animation
             *   - layoutId changes mid animation
             */ }
    }
    exitAnimationComplete() {
        this.members.forEach((node)=>{
            const { options, resumingFrom } = node;
            options.onExitComplete && options.onExitComplete();
            if (resumingFrom) resumingFrom.options.onExitComplete && resumingFrom.options.onExitComplete();
        });
    }
    scheduleRender() {
        this.members.forEach((node)=>{
            node.instance && node.scheduleRender(false);
        });
    }
    /**
     * Clear any leads that have been removed this render to prevent them from being
     * used in future animations and to prevent memory leaks
     */ removeLeadSnapshot() {
        if (this.lead && this.lead.snapshot) this.lead.snapshot = undefined;
    }
}

},{"../../utils/array.mjs":"a76Ek","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"eJIA7":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "buildProjectionTransform", ()=>buildProjectionTransform);
function buildProjectionTransform(delta, treeScale, latestTransform) {
    let transform = "";
    /**
     * The translations we use to calculate are always relative to the viewport coordinate space.
     * But when we apply scales, we also scale the coordinate space of an element and its children.
     * For instance if we have a treeScale (the culmination of all parent scales) of 0.5 and we need
     * to move an element 100 pixels, we actually need to move it 200 in within that scaled space.
     */ const xTranslate = delta.x.translate / treeScale.x;
    const yTranslate = delta.y.translate / treeScale.y;
    if (xTranslate || yTranslate) transform = `translate3d(${xTranslate}px, ${yTranslate}px, 0) `;
    /**
     * Apply scale correction for the tree transform.
     * This will apply scale to the screen-orientated axes.
     */ if (treeScale.x !== 1 || treeScale.y !== 1) transform += `scale(${1 / treeScale.x}, ${1 / treeScale.y}) `;
    if (latestTransform) {
        const { rotate, rotateX, rotateY } = latestTransform;
        if (rotate) transform += `rotate(${rotate}deg) `;
        if (rotateX) transform += `rotateX(${rotateX}deg) `;
        if (rotateY) transform += `rotateY(${rotateY}deg) `;
    }
    /**
     * Apply scale to match the size of the element to the size we want it.
     * This will apply scale to the element-orientated axes.
     */ const elementScaleX = delta.x.scale * treeScale.x;
    const elementScaleY = delta.y.scale * treeScale.y;
    if (elementScaleX !== 1 || elementScaleY !== 1) transform += `scale(${elementScaleX}, ${elementScaleY})`;
    return transform || "none";
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"5W1eO":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "FlatTree", ()=>FlatTree);
var _arrayMjs = require("../../utils/array.mjs");
var _compareByDepthMjs = require("./compare-by-depth.mjs");
class FlatTree {
    constructor(){
        this.children = [];
        this.isDirty = false;
    }
    add(child) {
        (0, _arrayMjs.addUniqueItem)(this.children, child);
        this.isDirty = true;
    }
    remove(child) {
        (0, _arrayMjs.removeItem)(this.children, child);
        this.isDirty = true;
    }
    forEach(callback) {
        this.isDirty && this.children.sort((0, _compareByDepthMjs.compareByDepth));
        this.isDirty = false;
        this.children.forEach(callback);
    }
}

},{"../../utils/array.mjs":"a76Ek","./compare-by-depth.mjs":"7rffJ","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7rffJ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "compareByDepth", ()=>compareByDepth);
const compareByDepth = (a, b)=>a.depth - b.depth;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"jfaIw":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "delay", ()=>delay);
var _frameMjs = require("../frameloop/frame.mjs");
/**
 * Timeout defined in ms
 */ function delay(callback, timeout) {
    const start = performance.now();
    const checkElapsed = ({ timestamp })=>{
        const elapsed = timestamp - start;
        if (elapsed >= timeout) {
            (0, _frameMjs.cancelFrame)(checkElapsed);
            callback(elapsed - timeout);
        }
    };
    (0, _frameMjs.frame).read(checkElapsed, true);
    return ()=>(0, _frameMjs.cancelFrame)(checkElapsed);
}

},{"../frameloop/frame.mjs":"gdRIq","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"kf4Kb":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "record", ()=>record);
function record(data) {
    if (window.MotionDebug) window.MotionDebug.record(data);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"ytKOV":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isSVGElement", ()=>isSVGElement);
function isSVGElement(element) {
    return element instanceof SVGElement && element.tagName !== "svg";
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"TVjEd":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "animateSingleValue", ()=>animateSingleValue);
var _motionValueMjs = require("./motion-value.mjs");
var _indexMjs = require("../../value/index.mjs");
var _isMotionValueMjs = require("../../value/utils/is-motion-value.mjs");
function animateSingleValue(value, keyframes, options) {
    const motionValue$1 = (0, _isMotionValueMjs.isMotionValue)(value) ? value : (0, _indexMjs.motionValue)(value);
    motionValue$1.start((0, _motionValueMjs.animateMotionValue)("", motionValue$1, keyframes, options));
    return motionValue$1.animation;
}

},{"./motion-value.mjs":"lumbS","../../value/index.mjs":"iyeKc","../../value/utils/is-motion-value.mjs":"2kZP7","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2Tecc":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DocumentProjectionNode", ()=>DocumentProjectionNode);
var _createProjectionNodeMjs = require("./create-projection-node.mjs");
var _addDomEventMjs = require("../../events/add-dom-event.mjs");
const DocumentProjectionNode = (0, _createProjectionNodeMjs.createProjectionNode)({
    attachResizeListener: (ref, notify)=>(0, _addDomEventMjs.addDomEvent)(ref, "resize", notify),
    measureScroll: ()=>({
            x: document.documentElement.scrollLeft || document.body.scrollLeft,
            y: document.documentElement.scrollTop || document.body.scrollTop
        }),
    checkIsScrollRoot: ()=>true
});

},{"./create-projection-node.mjs":"2osmA","../../events/add-dom-event.mjs":"82u3S","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7HD63":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createDomVisualElement", ()=>createDomVisualElement);
var _htmlvisualElementMjs = require("../html/HTMLVisualElement.mjs");
var _svgvisualElementMjs = require("../svg/SVGVisualElement.mjs");
var _isSvgComponentMjs = require("./utils/is-svg-component.mjs");
const createDomVisualElement = (Component, options)=>{
    return (0, _isSvgComponentMjs.isSVGComponent)(Component) ? new (0, _svgvisualElementMjs.SVGVisualElement)(options, {
        enableHardwareAcceleration: false
    }) : new (0, _htmlvisualElementMjs.HTMLVisualElement)(options, {
        enableHardwareAcceleration: true
    });
};

},{"../html/HTMLVisualElement.mjs":"gjlh5","../svg/SVGVisualElement.mjs":"ivZT5","./utils/is-svg-component.mjs":"2Ozjv","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"gjlh5":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "HTMLVisualElement", ()=>HTMLVisualElement);
parcelHelpers.export(exports, "getComputedStyle", ()=>getComputedStyle);
var _buildStylesMjs = require("./utils/build-styles.mjs");
var _isCssVariableMjs = require("../dom/utils/is-css-variable.mjs");
var _transformMjs = require("./utils/transform.mjs");
var _scrapeMotionValuesMjs = require("./utils/scrape-motion-values.mjs");
var _renderMjs = require("./utils/render.mjs");
var _defaultsMjs = require("../dom/value-types/defaults.mjs");
var _measureMjs = require("../../projection/utils/measure.mjs");
var _domvisualElementMjs = require("../dom/DOMVisualElement.mjs");
var _isMotionValueMjs = require("../../value/utils/is-motion-value.mjs");
function getComputedStyle(element) {
    return window.getComputedStyle(element);
}
class HTMLVisualElement extends (0, _domvisualElementMjs.DOMVisualElement) {
    constructor(){
        super(...arguments);
        this.type = "html";
    }
    readValueFromInstance(instance, key) {
        if ((0, _transformMjs.transformProps).has(key)) {
            const defaultType = (0, _defaultsMjs.getDefaultValueType)(key);
            return defaultType ? defaultType.default || 0 : 0;
        } else {
            const computedStyle = getComputedStyle(instance);
            const value = ((0, _isCssVariableMjs.isCSSVariableName)(key) ? computedStyle.getPropertyValue(key) : computedStyle[key]) || 0;
            return typeof value === "string" ? value.trim() : value;
        }
    }
    measureInstanceViewportBox(instance, { transformPagePoint }) {
        return (0, _measureMjs.measureViewportBox)(instance, transformPagePoint);
    }
    build(renderState, latestValues, options, props) {
        (0, _buildStylesMjs.buildHTMLStyles)(renderState, latestValues, options, props.transformTemplate);
    }
    scrapeMotionValuesFromProps(props, prevProps) {
        return (0, _scrapeMotionValuesMjs.scrapeMotionValuesFromProps)(props, prevProps);
    }
    handleChildMotionValue() {
        if (this.childSubscription) {
            this.childSubscription();
            delete this.childSubscription;
        }
        const { children } = this.props;
        if ((0, _isMotionValueMjs.isMotionValue)(children)) this.childSubscription = children.on("change", (latest)=>{
            if (this.current) this.current.textContent = `${latest}`;
        });
    }
    renderInstance(instance, renderState, styleProp, projection) {
        (0, _renderMjs.renderHTML)(instance, renderState, styleProp, projection);
    }
}

},{"./utils/build-styles.mjs":"3JcOY","../dom/utils/is-css-variable.mjs":"58wqN","./utils/transform.mjs":"es0QE","./utils/scrape-motion-values.mjs":"irGuL","./utils/render.mjs":"6SuGI","../dom/value-types/defaults.mjs":"5j9jO","../../projection/utils/measure.mjs":"afNeE","../dom/DOMVisualElement.mjs":"9nP1G","../../value/utils/is-motion-value.mjs":"2kZP7","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9nP1G":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DOMVisualElement", ()=>DOMVisualElement);
var _settersMjs = require("../utils/setters.mjs");
var _parseDomVariantMjs = require("./utils/parse-dom-variant.mjs");
var _visualElementMjs = require("../VisualElement.mjs");
class DOMVisualElement extends (0, _visualElementMjs.VisualElement) {
    sortInstanceNodePosition(a, b) {
        /**
         * compareDocumentPosition returns a bitmask, by using the bitwise &
         * we're returning true if 2 in that bitmask is set to true. 2 is set
         * to true if b preceeds a.
         */ return a.compareDocumentPosition(b) & 2 ? 1 : -1;
    }
    getBaseTargetFromProps(props, key) {
        return props.style ? props.style[key] : undefined;
    }
    removeValueFromRenderState(key, { vars, style }) {
        delete vars[key];
        delete style[key];
    }
    makeTargetAnimatableFromInstance({ transition, transitionEnd, ...target }, { transformValues }, isMounted) {
        let origin = (0, _settersMjs.getOrigin)(target, transition || {}, this);
        /**
         * If Framer has provided a function to convert `Color` etc value types, convert them
         */ if (transformValues) {
            if (transitionEnd) transitionEnd = transformValues(transitionEnd);
            if (target) target = transformValues(target);
            if (origin) origin = transformValues(origin);
        }
        if (isMounted) {
            (0, _settersMjs.checkTargetForNewValues)(this, target, origin);
            const parsed = (0, _parseDomVariantMjs.parseDomVariant)(this, target, origin, transitionEnd);
            transitionEnd = parsed.transitionEnd;
            target = parsed.target;
        }
        return {
            transition,
            transitionEnd,
            ...target
        };
    }
}

},{"../utils/setters.mjs":"jlhrk","./utils/parse-dom-variant.mjs":"l6brB","../VisualElement.mjs":"dQr4l","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"l6brB":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "parseDomVariant", ()=>parseDomVariant);
var _cssVariablesConversionMjs = require("./css-variables-conversion.mjs");
var _unitConversionMjs = require("./unit-conversion.mjs");
/**
 * Parse a DOM variant to make it animatable. This involves resolving CSS variables
 * and ensuring animations like "20%" => "calc(50vw)" are performed in pixels.
 */ const parseDomVariant = (visualElement, target, origin, transitionEnd)=>{
    const resolved = (0, _cssVariablesConversionMjs.resolveCSSVariables)(visualElement, target, transitionEnd);
    target = resolved.target;
    transitionEnd = resolved.transitionEnd;
    return (0, _unitConversionMjs.unitConversion)(visualElement, target, origin, transitionEnd);
};

},{"./css-variables-conversion.mjs":"7QWs3","./unit-conversion.mjs":"eYlAT","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7QWs3":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "parseCSSVariable", ()=>parseCSSVariable);
parcelHelpers.export(exports, "resolveCSSVariables", ()=>resolveCSSVariables);
var _errorsMjs = require("../../../utils/errors.mjs");
var _isNumericalStringMjs = require("../../../utils/is-numerical-string.mjs");
var _isCssVariableMjs = require("./is-css-variable.mjs");
/**
 * Parse Framer's special CSS variable format into a CSS token and a fallback.
 *
 * ```
 * `var(--foo, #fff)` => [`--foo`, '#fff']
 * ```
 *
 * @param current
 */ const splitCSSVariableRegex = /var\((--[a-zA-Z0-9-_]+),? ?([a-zA-Z0-9 ()%#.,-]+)?\)/;
function parseCSSVariable(current) {
    const match = splitCSSVariableRegex.exec(current);
    if (!match) return [
        , 
    ];
    const [, token, fallback] = match;
    return [
        token,
        fallback
    ];
}
const maxDepth = 4;
function getVariableValue(current, element, depth = 1) {
    (0, _errorsMjs.invariant)(depth <= maxDepth, `Max CSS variable fallback depth detected in property "${current}". This may indicate a circular fallback dependency.`);
    const [token, fallback] = parseCSSVariable(current);
    // No CSS variable detected
    if (!token) return;
    // Attempt to read this CSS variable off the element
    const resolved = window.getComputedStyle(element).getPropertyValue(token);
    if (resolved) {
        const trimmed = resolved.trim();
        return (0, _isNumericalStringMjs.isNumericalString)(trimmed) ? parseFloat(trimmed) : trimmed;
    } else if ((0, _isCssVariableMjs.isCSSVariableToken)(fallback)) // The fallback might itself be a CSS variable, in which case we attempt to resolve it too.
    return getVariableValue(fallback, element, depth + 1);
    else return fallback;
}
/**
 * Resolve CSS variables from
 *
 * @internal
 */ function resolveCSSVariables(visualElement, { ...target }, transitionEnd) {
    const element = visualElement.current;
    if (!(element instanceof Element)) return {
        target,
        transitionEnd
    };
    // If `transitionEnd` isn't `undefined`, clone it. We could clone `target` and `transitionEnd`
    // only if they change but I think this reads clearer and this isn't a performance-critical path.
    if (transitionEnd) transitionEnd = {
        ...transitionEnd
    };
    // Go through existing `MotionValue`s and ensure any existing CSS variables are resolved
    visualElement.values.forEach((value)=>{
        const current = value.get();
        if (!(0, _isCssVariableMjs.isCSSVariableToken)(current)) return;
        const resolved = getVariableValue(current, element);
        if (resolved) value.set(resolved);
    });
    // Cycle through every target property and resolve CSS variables. Currently
    // we only read single-var properties like `var(--foo)`, not `calc(var(--foo) + 20px)`
    for(const key in target){
        const current = target[key];
        if (!(0, _isCssVariableMjs.isCSSVariableToken)(current)) continue;
        const resolved = getVariableValue(current, element);
        if (!resolved) continue;
        // Clone target if it hasn't already been
        target[key] = resolved;
        if (!transitionEnd) transitionEnd = {};
        // If the user hasn't already set this key on `transitionEnd`, set it to the unresolved
        // CSS variable. This will ensure that after the animation the component will reflect
        // changes in the value of the CSS variable.
        if (transitionEnd[key] === undefined) transitionEnd[key] = current;
    }
    return {
        target,
        transitionEnd
    };
}

},{"../../../utils/errors.mjs":"buT6L","../../../utils/is-numerical-string.mjs":"4HKEF","./is-css-variable.mjs":"58wqN","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"eYlAT":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "positionalValues", ()=>positionalValues);
parcelHelpers.export(exports, "unitConversion", ()=>unitConversion);
var _isKeyframesTargetMjs = require("../../../animation/utils/is-keyframes-target.mjs");
var _errorsMjs = require("../../../utils/errors.mjs");
var _transformMjs = require("../../html/utils/transform.mjs");
var _dimensionsMjs = require("../value-types/dimensions.mjs");
var _isBrowserMjs = require("../../../utils/is-browser.mjs");
var _indexMjs = require("../../../value/types/numbers/index.mjs");
var _unitsMjs = require("../../../value/types/numbers/units.mjs");
const positionalKeys = new Set([
    "width",
    "height",
    "top",
    "left",
    "right",
    "bottom",
    "x",
    "y",
    "translateX",
    "translateY"
]);
const isPositionalKey = (key)=>positionalKeys.has(key);
const hasPositionalKey = (target)=>{
    return Object.keys(target).some(isPositionalKey);
};
const isNumOrPxType = (v)=>v === (0, _indexMjs.number) || v === (0, _unitsMjs.px);
const getPosFromMatrix = (matrix, pos)=>parseFloat(matrix.split(", ")[pos]);
const getTranslateFromMatrix = (pos2, pos3)=>(_bbox, { transform })=>{
        if (transform === "none" || !transform) return 0;
        const matrix3d = transform.match(/^matrix3d\((.+)\)$/);
        if (matrix3d) return getPosFromMatrix(matrix3d[1], pos3);
        else {
            const matrix = transform.match(/^matrix\((.+)\)$/);
            if (matrix) return getPosFromMatrix(matrix[1], pos2);
            else return 0;
        }
    };
const transformKeys = new Set([
    "x",
    "y",
    "z"
]);
const nonTranslationalTransformKeys = (0, _transformMjs.transformPropOrder).filter((key)=>!transformKeys.has(key));
function removeNonTranslationalTransform(visualElement) {
    const removedTransforms = [];
    nonTranslationalTransformKeys.forEach((key)=>{
        const value = visualElement.getValue(key);
        if (value !== undefined) {
            removedTransforms.push([
                key,
                value.get()
            ]);
            value.set(key.startsWith("scale") ? 1 : 0);
        }
    });
    // Apply changes to element before measurement
    if (removedTransforms.length) visualElement.render();
    return removedTransforms;
}
const positionalValues = {
    // Dimensions
    width: ({ x }, { paddingLeft = "0", paddingRight = "0" })=>x.max - x.min - parseFloat(paddingLeft) - parseFloat(paddingRight),
    height: ({ y }, { paddingTop = "0", paddingBottom = "0" })=>y.max - y.min - parseFloat(paddingTop) - parseFloat(paddingBottom),
    top: (_bbox, { top })=>parseFloat(top),
    left: (_bbox, { left })=>parseFloat(left),
    bottom: ({ y }, { top })=>parseFloat(top) + (y.max - y.min),
    right: ({ x }, { left })=>parseFloat(left) + (x.max - x.min),
    // Transform
    x: getTranslateFromMatrix(4, 13),
    y: getTranslateFromMatrix(5, 14)
};
// Alias translate longform names
positionalValues.translateX = positionalValues.x;
positionalValues.translateY = positionalValues.y;
const convertChangedValueTypes = (target, visualElement, changedKeys)=>{
    const originBbox = visualElement.measureViewportBox();
    const element = visualElement.current;
    const elementComputedStyle = getComputedStyle(element);
    const { display } = elementComputedStyle;
    const origin = {};
    // If the element is currently set to display: "none", make it visible before
    // measuring the target bounding box
    if (display === "none") visualElement.setStaticValue("display", target.display || "block");
    /**
     * Record origins before we render and update styles
     */ changedKeys.forEach((key)=>{
        origin[key] = positionalValues[key](originBbox, elementComputedStyle);
    });
    // Apply the latest values (as set in checkAndConvertChangedValueTypes)
    visualElement.render();
    const targetBbox = visualElement.measureViewportBox();
    changedKeys.forEach((key)=>{
        // Restore styles to their **calculated computed style**, not their actual
        // originally set style. This allows us to animate between equivalent pixel units.
        const value = visualElement.getValue(key);
        value && value.jump(origin[key]);
        target[key] = positionalValues[key](targetBbox, elementComputedStyle);
    });
    return target;
};
const checkAndConvertChangedValueTypes = (visualElement, target, origin = {}, transitionEnd = {})=>{
    target = {
        ...target
    };
    transitionEnd = {
        ...transitionEnd
    };
    const targetPositionalKeys = Object.keys(target).filter(isPositionalKey);
    // We want to remove any transform values that could affect the element's bounding box before
    // it's measured. We'll reapply these later.
    let removedTransformValues = [];
    let hasAttemptedToRemoveTransformValues = false;
    const changedValueTypeKeys = [];
    targetPositionalKeys.forEach((key)=>{
        const value = visualElement.getValue(key);
        if (!visualElement.hasValue(key)) return;
        let from = origin[key];
        let fromType = (0, _dimensionsMjs.findDimensionValueType)(from);
        const to = target[key];
        let toType;
        // TODO: The current implementation of this basically throws an error
        // if you try and do value conversion via keyframes. There's probably
        // a way of doing this but the performance implications would need greater scrutiny,
        // as it'd be doing multiple resize-remeasure operations.
        if ((0, _isKeyframesTargetMjs.isKeyframesTarget)(to)) {
            const numKeyframes = to.length;
            const fromIndex = to[0] === null ? 1 : 0;
            from = to[fromIndex];
            fromType = (0, _dimensionsMjs.findDimensionValueType)(from);
            for(let i = fromIndex; i < numKeyframes; i++){
                /**
                 * Don't allow wildcard keyframes to be used to detect
                 * a difference in value types.
                 */ if (to[i] === null) break;
                if (!toType) {
                    toType = (0, _dimensionsMjs.findDimensionValueType)(to[i]);
                    (0, _errorsMjs.invariant)(toType === fromType || isNumOrPxType(fromType) && isNumOrPxType(toType), "Keyframes must be of the same dimension as the current value");
                } else (0, _errorsMjs.invariant)((0, _dimensionsMjs.findDimensionValueType)(to[i]) === toType, "All keyframes must be of the same type");
            }
        } else toType = (0, _dimensionsMjs.findDimensionValueType)(to);
        if (fromType !== toType) {
            // If they're both just number or px, convert them both to numbers rather than
            // relying on resize/remeasure to convert (which is wasteful in this situation)
            if (isNumOrPxType(fromType) && isNumOrPxType(toType)) {
                const current = value.get();
                if (typeof current === "string") value.set(parseFloat(current));
                if (typeof to === "string") target[key] = parseFloat(to);
                else if (Array.isArray(to) && toType === (0, _unitsMjs.px)) target[key] = to.map(parseFloat);
            } else if ((fromType === null || fromType === void 0 ? void 0 : fromType.transform) && (toType === null || toType === void 0 ? void 0 : toType.transform) && (from === 0 || to === 0)) {
                // If one or the other value is 0, it's safe to coerce it to the
                // type of the other without measurement
                if (from === 0) value.set(toType.transform(from));
                else target[key] = fromType.transform(to);
            } else {
                // If we're going to do value conversion via DOM measurements, we first
                // need to remove non-positional transform values that could affect the bbox measurements.
                if (!hasAttemptedToRemoveTransformValues) {
                    removedTransformValues = removeNonTranslationalTransform(visualElement);
                    hasAttemptedToRemoveTransformValues = true;
                }
                changedValueTypeKeys.push(key);
                transitionEnd[key] = transitionEnd[key] !== undefined ? transitionEnd[key] : target[key];
                value.jump(to);
            }
        }
    });
    if (changedValueTypeKeys.length) {
        const scrollY = changedValueTypeKeys.indexOf("height") >= 0 ? window.pageYOffset : null;
        const convertedTarget = convertChangedValueTypes(target, visualElement, changedValueTypeKeys);
        // If we removed transform values, reapply them before the next render
        if (removedTransformValues.length) removedTransformValues.forEach(([key, value])=>{
            visualElement.getValue(key).set(value);
        });
        // Reapply original values
        visualElement.render();
        // Restore scroll position
        if ((0, _isBrowserMjs.isBrowser) && scrollY !== null) window.scrollTo({
            top: scrollY
        });
        return {
            target: convertedTarget,
            transitionEnd
        };
    } else return {
        target,
        transitionEnd
    };
};
/**
 * Convert value types for x/y/width/height/top/left/bottom/right
 *
 * Allows animation between `'auto'` -> `'100%'` or `0` -> `'calc(50% - 10vw)'`
 *
 * @internal
 */ function unitConversion(visualElement, target, origin, transitionEnd) {
    return hasPositionalKey(target) ? checkAndConvertChangedValueTypes(visualElement, target, origin, transitionEnd) : {
        target,
        transitionEnd
    };
}

},{"../../../animation/utils/is-keyframes-target.mjs":"b9ZPA","../../../utils/errors.mjs":"buT6L","../../html/utils/transform.mjs":"es0QE","../value-types/dimensions.mjs":"8qh9y","../../../utils/is-browser.mjs":"9ew4K","../../../value/types/numbers/index.mjs":"bcOBd","../../../value/types/numbers/units.mjs":"hGtBr","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"dQr4l":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "VisualElement", ()=>VisualElement);
var _errorsMjs = require("../utils/errors.mjs");
var _modelsMjs = require("../projection/geometry/models.mjs");
var _isRefObjectMjs = require("../utils/is-ref-object.mjs");
var _indexMjs = require("../utils/reduced-motion/index.mjs");
var _stateMjs = require("../utils/reduced-motion/state.mjs");
var _subscriptionManagerMjs = require("../utils/subscription-manager.mjs");
var _indexMjs1 = require("../value/index.mjs");
var _isMjs = require("../value/use-will-change/is.mjs");
var _isMotionValueMjs = require("../value/utils/is-motion-value.mjs");
var _transformMjs = require("./html/utils/transform.mjs");
var _isControllingVariantsMjs = require("./utils/is-controlling-variants.mjs");
var _isVariantLabelMjs = require("./utils/is-variant-label.mjs");
var _motionValuesMjs = require("./utils/motion-values.mjs");
var _resolveVariantsMjs = require("./utils/resolve-variants.mjs");
var _warnOnceMjs = require("../utils/warn-once.mjs");
var _definitionsMjs = require("../motion/features/definitions.mjs");
var _variantPropsMjs = require("./utils/variant-props.mjs");
var _storeMjs = require("./store.mjs");
var _frameMjs = require("../frameloop/frame.mjs");
const featureNames = Object.keys((0, _definitionsMjs.featureDefinitions));
const numFeatures = featureNames.length;
const propEventHandlers = [
    "AnimationStart",
    "AnimationComplete",
    "Update",
    "BeforeLayoutMeasure",
    "LayoutMeasure",
    "LayoutAnimationStart",
    "LayoutAnimationComplete"
];
const numVariantProps = (0, _variantPropsMjs.variantProps).length;
/**
 * A VisualElement is an imperative abstraction around UI elements such as
 * HTMLElement, SVGElement, Three.Object3D etc.
 */ class VisualElement {
    constructor({ parent, props, presenceContext, reducedMotionConfig, visualState }, options = {}){
        /**
         * A reference to the current underlying Instance, e.g. a HTMLElement
         * or Three.Mesh etc.
         */ this.current = null;
        /**
         * A set containing references to this VisualElement's children.
         */ this.children = new Set();
        /**
         * Determine what role this visual element should take in the variant tree.
         */ this.isVariantNode = false;
        this.isControllingVariants = false;
        /**
         * Decides whether this VisualElement should animate in reduced motion
         * mode.
         *
         * TODO: This is currently set on every individual VisualElement but feels
         * like it could be set globally.
         */ this.shouldReduceMotion = null;
        /**
         * A map of all motion values attached to this visual element. Motion
         * values are source of truth for any given animated value. A motion
         * value might be provided externally by the component via props.
         */ this.values = new Map();
        /**
         * Cleanup functions for active features (hover/tap/exit etc)
         */ this.features = {};
        /**
         * A map of every subscription that binds the provided or generated
         * motion values onChange listeners to this visual element.
         */ this.valueSubscriptions = new Map();
        /**
         * A reference to the previously-provided motion values as returned
         * from scrapeMotionValuesFromProps. We use the keys in here to determine
         * if any motion values need to be removed after props are updated.
         */ this.prevMotionValues = {};
        /**
         * An object containing a SubscriptionManager for each active event.
         */ this.events = {};
        /**
         * An object containing an unsubscribe function for each prop event subscription.
         * For example, every "Update" event can have multiple subscribers via
         * VisualElement.on(), but only one of those can be defined via the onUpdate prop.
         */ this.propEventSubscriptions = {};
        this.notifyUpdate = ()=>this.notify("Update", this.latestValues);
        this.render = ()=>{
            if (!this.current) return;
            this.triggerBuild();
            this.renderInstance(this.current, this.renderState, this.props.style, this.projection);
        };
        this.scheduleRender = ()=>(0, _frameMjs.frame).render(this.render, false, true);
        const { latestValues, renderState } = visualState;
        this.latestValues = latestValues;
        this.baseTarget = {
            ...latestValues
        };
        this.initialValues = props.initial ? {
            ...latestValues
        } : {};
        this.renderState = renderState;
        this.parent = parent;
        this.props = props;
        this.presenceContext = presenceContext;
        this.depth = parent ? parent.depth + 1 : 0;
        this.reducedMotionConfig = reducedMotionConfig;
        this.options = options;
        this.isControllingVariants = (0, _isControllingVariantsMjs.isControllingVariants)(props);
        this.isVariantNode = (0, _isControllingVariantsMjs.isVariantNode)(props);
        if (this.isVariantNode) this.variantChildren = new Set();
        this.manuallyAnimateOnMount = Boolean(parent && parent.current);
        /**
         * Any motion values that are provided to the element when created
         * aren't yet bound to the element, as this would technically be impure.
         * However, we iterate through the motion values and set them to the
         * initial values for this component.
         *
         * TODO: This is impure and we should look at changing this to run on mount.
         * Doing so will break some tests but this isn't neccessarily a breaking change,
         * more a reflection of the test.
         */ const { willChange, ...initialMotionValues } = this.scrapeMotionValuesFromProps(props, {});
        for(const key in initialMotionValues){
            const value = initialMotionValues[key];
            if (latestValues[key] !== undefined && (0, _isMotionValueMjs.isMotionValue)(value)) {
                value.set(latestValues[key], false);
                if ((0, _isMjs.isWillChangeMotionValue)(willChange)) willChange.add(key);
            }
        }
    }
    /**
     * This method takes React props and returns found MotionValues. For example, HTML
     * MotionValues will be found within the style prop, whereas for Three.js within attribute arrays.
     *
     * This isn't an abstract method as it needs calling in the constructor, but it is
     * intended to be one.
     */ scrapeMotionValuesFromProps(_props, _prevProps) {
        return {};
    }
    mount(instance) {
        this.current = instance;
        (0, _storeMjs.visualElementStore).set(instance, this);
        if (this.projection && !this.projection.instance) this.projection.mount(instance);
        if (this.parent && this.isVariantNode && !this.isControllingVariants) this.removeFromVariantTree = this.parent.addVariantChild(this);
        this.values.forEach((value, key)=>this.bindToMotionValue(key, value));
        if (!(0, _stateMjs.hasReducedMotionListener).current) (0, _indexMjs.initPrefersReducedMotion)();
        this.shouldReduceMotion = this.reducedMotionConfig === "never" ? false : this.reducedMotionConfig === "always" ? true : (0, _stateMjs.prefersReducedMotion).current;
        if (this.parent) this.parent.children.add(this);
        this.update(this.props, this.presenceContext);
    }
    unmount() {
        (0, _storeMjs.visualElementStore).delete(this.current);
        this.projection && this.projection.unmount();
        (0, _frameMjs.cancelFrame)(this.notifyUpdate);
        (0, _frameMjs.cancelFrame)(this.render);
        this.valueSubscriptions.forEach((remove)=>remove());
        this.removeFromVariantTree && this.removeFromVariantTree();
        this.parent && this.parent.children.delete(this);
        for(const key in this.events)this.events[key].clear();
        for(const key in this.features)this.features[key].unmount();
        this.current = null;
    }
    bindToMotionValue(key, value) {
        const valueIsTransform = (0, _transformMjs.transformProps).has(key);
        const removeOnChange = value.on("change", (latestValue)=>{
            this.latestValues[key] = latestValue;
            this.props.onUpdate && (0, _frameMjs.frame).update(this.notifyUpdate, false, true);
            if (valueIsTransform && this.projection) this.projection.isTransformDirty = true;
        });
        const removeOnRenderRequest = value.on("renderRequest", this.scheduleRender);
        this.valueSubscriptions.set(key, ()=>{
            removeOnChange();
            removeOnRenderRequest();
        });
    }
    sortNodePosition(other) {
        /**
         * If these nodes aren't even of the same type we can't compare their depth.
         */ if (!this.current || !this.sortInstanceNodePosition || this.type !== other.type) return 0;
        return this.sortInstanceNodePosition(this.current, other.current);
    }
    loadFeatures({ children, ...renderedProps }, isStrict, preloadedFeatures, initialLayoutGroupConfig) {
        let ProjectionNodeConstructor;
        let MeasureLayout;
        for(let i = 0; i < numFeatures; i++){
            const name = featureNames[i];
            const { isEnabled, Feature: FeatureConstructor, ProjectionNode, MeasureLayout: MeasureLayoutComponent } = (0, _definitionsMjs.featureDefinitions)[name];
            if (ProjectionNode) ProjectionNodeConstructor = ProjectionNode;
            if (isEnabled(renderedProps)) {
                if (!this.features[name] && FeatureConstructor) this.features[name] = new FeatureConstructor(this);
                if (MeasureLayoutComponent) MeasureLayout = MeasureLayoutComponent;
            }
        }
        if ((this.type === "html" || this.type === "svg") && !this.projection && ProjectionNodeConstructor) {
            this.projection = new ProjectionNodeConstructor(this.latestValues, this.parent && this.parent.projection);
            const { layoutId, layout, drag, dragConstraints, layoutScroll, layoutRoot } = renderedProps;
            this.projection.setOptions({
                layoutId,
                layout,
                alwaysMeasureLayout: Boolean(drag) || dragConstraints && (0, _isRefObjectMjs.isRefObject)(dragConstraints),
                visualElement: this,
                scheduleRender: ()=>this.scheduleRender(),
                /**
                 * TODO: Update options in an effect. This could be tricky as it'll be too late
                 * to update by the time layout animations run.
                 * We also need to fix this safeToRemove by linking it up to the one returned by usePresence,
                 * ensuring it gets called if there's no potential layout animations.
                 *
                 */ animationType: typeof layout === "string" ? layout : "both",
                initialPromotionConfig: initialLayoutGroupConfig,
                layoutScroll,
                layoutRoot
            });
        }
        return MeasureLayout;
    }
    updateFeatures() {
        for(const key in this.features){
            const feature = this.features[key];
            if (feature.isMounted) feature.update();
            else {
                feature.mount();
                feature.isMounted = true;
            }
        }
    }
    triggerBuild() {
        this.build(this.renderState, this.latestValues, this.options, this.props);
    }
    /**
     * Measure the current viewport box with or without transforms.
     * Only measures axis-aligned boxes, rotate and skew must be manually
     * removed with a re-render to work.
     */ measureViewportBox() {
        return this.current ? this.measureInstanceViewportBox(this.current, this.props) : (0, _modelsMjs.createBox)();
    }
    getStaticValue(key) {
        return this.latestValues[key];
    }
    setStaticValue(key, value) {
        this.latestValues[key] = value;
    }
    /**
     * Make a target animatable by Popmotion. For instance, if we're
     * trying to animate width from 100px to 100vw we need to measure 100vw
     * in pixels to determine what we really need to animate to. This is also
     * pluggable to support Framer's custom value types like Color,
     * and CSS variables.
     */ makeTargetAnimatable(target, canMutate = true) {
        return this.makeTargetAnimatableFromInstance(target, this.props, canMutate);
    }
    /**
     * Update the provided props. Ensure any newly-added motion values are
     * added to our map, old ones removed, and listeners updated.
     */ update(props, presenceContext) {
        if (props.transformTemplate || this.props.transformTemplate) this.scheduleRender();
        this.prevProps = this.props;
        this.props = props;
        this.prevPresenceContext = this.presenceContext;
        this.presenceContext = presenceContext;
        /**
         * Update prop event handlers ie onAnimationStart, onAnimationComplete
         */ for(let i = 0; i < propEventHandlers.length; i++){
            const key = propEventHandlers[i];
            if (this.propEventSubscriptions[key]) {
                this.propEventSubscriptions[key]();
                delete this.propEventSubscriptions[key];
            }
            const listener = props["on" + key];
            if (listener) this.propEventSubscriptions[key] = this.on(key, listener);
        }
        this.prevMotionValues = (0, _motionValuesMjs.updateMotionValuesFromProps)(this, this.scrapeMotionValuesFromProps(props, this.prevProps), this.prevMotionValues);
        if (this.handleChildMotionValue) this.handleChildMotionValue();
    }
    getProps() {
        return this.props;
    }
    /**
     * Returns the variant definition with a given name.
     */ getVariant(name) {
        return this.props.variants ? this.props.variants[name] : undefined;
    }
    /**
     * Returns the defined default transition on this component.
     */ getDefaultTransition() {
        return this.props.transition;
    }
    getTransformPagePoint() {
        return this.props.transformPagePoint;
    }
    getClosestVariantNode() {
        return this.isVariantNode ? this : this.parent ? this.parent.getClosestVariantNode() : undefined;
    }
    getVariantContext(startAtParent = false) {
        if (startAtParent) return this.parent ? this.parent.getVariantContext() : undefined;
        if (!this.isControllingVariants) {
            const context = this.parent ? this.parent.getVariantContext() || {} : {};
            if (this.props.initial !== undefined) context.initial = this.props.initial;
            return context;
        }
        const context = {};
        for(let i = 0; i < numVariantProps; i++){
            const name = (0, _variantPropsMjs.variantProps)[i];
            const prop = this.props[name];
            if ((0, _isVariantLabelMjs.isVariantLabel)(prop) || prop === false) context[name] = prop;
        }
        return context;
    }
    /**
     * Add a child visual element to our set of children.
     */ addVariantChild(child) {
        const closestVariantNode = this.getClosestVariantNode();
        if (closestVariantNode) {
            closestVariantNode.variantChildren && closestVariantNode.variantChildren.add(child);
            return ()=>closestVariantNode.variantChildren.delete(child);
        }
    }
    /**
     * Add a motion value and bind it to this visual element.
     */ addValue(key, value) {
        // Remove existing value if it exists
        if (value !== this.values.get(key)) {
            this.removeValue(key);
            this.bindToMotionValue(key, value);
        }
        this.values.set(key, value);
        this.latestValues[key] = value.get();
    }
    /**
     * Remove a motion value and unbind any active subscriptions.
     */ removeValue(key) {
        this.values.delete(key);
        const unsubscribe = this.valueSubscriptions.get(key);
        if (unsubscribe) {
            unsubscribe();
            this.valueSubscriptions.delete(key);
        }
        delete this.latestValues[key];
        this.removeValueFromRenderState(key, this.renderState);
    }
    /**
     * Check whether we have a motion value for this key
     */ hasValue(key) {
        return this.values.has(key);
    }
    getValue(key, defaultValue) {
        if (this.props.values && this.props.values[key]) return this.props.values[key];
        let value = this.values.get(key);
        if (value === undefined && defaultValue !== undefined) {
            value = (0, _indexMjs1.motionValue)(defaultValue, {
                owner: this
            });
            this.addValue(key, value);
        }
        return value;
    }
    /**
     * If we're trying to animate to a previously unencountered value,
     * we need to check for it in our state and as a last resort read it
     * directly from the instance (which might have performance implications).
     */ readValue(key) {
        var _a;
        return this.latestValues[key] !== undefined || !this.current ? this.latestValues[key] : (_a = this.getBaseTargetFromProps(this.props, key)) !== null && _a !== void 0 ? _a : this.readValueFromInstance(this.current, key, this.options);
    }
    /**
     * Set the base target to later animate back to. This is currently
     * only hydrated on creation and when we first read a value.
     */ setBaseTarget(key, value) {
        this.baseTarget[key] = value;
    }
    /**
     * Find the base target for a value thats been removed from all animation
     * props.
     */ getBaseTarget(key) {
        var _a;
        const { initial } = this.props;
        const valueFromInitial = typeof initial === "string" || typeof initial === "object" ? (_a = (0, _resolveVariantsMjs.resolveVariantFromProps)(this.props, initial)) === null || _a === void 0 ? void 0 : _a[key] : undefined;
        /**
         * If this value still exists in the current initial variant, read that.
         */ if (initial && valueFromInitial !== undefined) return valueFromInitial;
        /**
         * Alternatively, if this VisualElement config has defined a getBaseTarget
         * so we can read the value from an alternative source, try that.
         */ const target = this.getBaseTargetFromProps(this.props, key);
        if (target !== undefined && !(0, _isMotionValueMjs.isMotionValue)(target)) return target;
        /**
         * If the value was initially defined on initial, but it doesn't any more,
         * return undefined. Otherwise return the value as initially read from the DOM.
         */ return this.initialValues[key] !== undefined && valueFromInitial === undefined ? undefined : this.baseTarget[key];
    }
    on(eventName, callback) {
        if (!this.events[eventName]) this.events[eventName] = new (0, _subscriptionManagerMjs.SubscriptionManager)();
        return this.events[eventName].add(callback);
    }
    notify(eventName, ...args) {
        if (this.events[eventName]) this.events[eventName].notify(...args);
    }
}

},{"../utils/errors.mjs":"buT6L","../projection/geometry/models.mjs":"huYV1","../utils/is-ref-object.mjs":"gluK5","../utils/reduced-motion/index.mjs":"kzOiA","../utils/reduced-motion/state.mjs":"9UZ9X","../utils/subscription-manager.mjs":"dlxLW","../value/index.mjs":"iyeKc","../value/use-will-change/is.mjs":"cLEeP","../value/utils/is-motion-value.mjs":"2kZP7","./html/utils/transform.mjs":"es0QE","./utils/is-controlling-variants.mjs":"tz7Ig","./utils/is-variant-label.mjs":"hGXyz","./utils/motion-values.mjs":"5DmCs","./utils/resolve-variants.mjs":"iR2sd","../utils/warn-once.mjs":"5dNlE","../motion/features/definitions.mjs":"hJfDG","./utils/variant-props.mjs":"8wQuM","./store.mjs":"gKOe8","../frameloop/frame.mjs":"gdRIq","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"kzOiA":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "initPrefersReducedMotion", ()=>initPrefersReducedMotion);
var _isBrowserMjs = require("../is-browser.mjs");
var _stateMjs = require("./state.mjs");
function initPrefersReducedMotion() {
    (0, _stateMjs.hasReducedMotionListener).current = true;
    if (!(0, _isBrowserMjs.isBrowser)) return;
    if (window.matchMedia) {
        const motionMediaQuery = window.matchMedia("(prefers-reduced-motion)");
        const setReducedMotionPreferences = ()=>(0, _stateMjs.prefersReducedMotion).current = motionMediaQuery.matches;
        motionMediaQuery.addListener(setReducedMotionPreferences);
        setReducedMotionPreferences();
    } else (0, _stateMjs.prefersReducedMotion).current = false;
}

},{"../is-browser.mjs":"9ew4K","./state.mjs":"9UZ9X","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9UZ9X":[function(require,module,exports) {
// Does this device prefer reduced motion? Returns `null` server-side.
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "hasReducedMotionListener", ()=>hasReducedMotionListener);
parcelHelpers.export(exports, "prefersReducedMotion", ()=>prefersReducedMotion);
const prefersReducedMotion = {
    current: null
};
const hasReducedMotionListener = {
    current: false
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"5DmCs":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "updateMotionValuesFromProps", ()=>updateMotionValuesFromProps);
var _isMjs = require("../../value/use-will-change/is.mjs");
var _warnOnceMjs = require("../../utils/warn-once.mjs");
var _indexMjs = require("../../value/index.mjs");
var _isMotionValueMjs = require("../../value/utils/is-motion-value.mjs");
function updateMotionValuesFromProps(element, next, prev) {
    const { willChange } = next;
    for(const key in next){
        const nextValue = next[key];
        const prevValue = prev[key];
        if ((0, _isMotionValueMjs.isMotionValue)(nextValue)) {
            /**
             * If this is a motion value found in props or style, we want to add it
             * to our visual element's motion value map.
             */ element.addValue(key, nextValue);
            if ((0, _isMjs.isWillChangeMotionValue)(willChange)) willChange.add(key);
        } else if ((0, _isMotionValueMjs.isMotionValue)(prevValue)) {
            /**
             * If we're swapping from a motion value to a static value,
             * create a new motion value from that
             */ element.addValue(key, (0, _indexMjs.motionValue)(nextValue, {
                owner: element
            }));
            if ((0, _isMjs.isWillChangeMotionValue)(willChange)) willChange.remove(key);
        } else if (prevValue !== nextValue) {
            /**
             * If this is a flat value that has changed, update the motion value
             * or create one if it doesn't exist. We only want to do this if we're
             * not handling the value with our animation state.
             */ if (element.hasValue(key)) {
                const existingValue = element.getValue(key);
                // TODO: Only update values that aren't being animated or even looked at
                !existingValue.hasAnimated && existingValue.set(nextValue);
            } else {
                const latestValue = element.getStaticValue(key);
                element.addValue(key, (0, _indexMjs.motionValue)(latestValue !== undefined ? latestValue : nextValue, {
                    owner: element
                }));
            }
        }
    }
    // Handle removed values
    for(const key in prev)if (next[key] === undefined) element.removeValue(key);
    return next;
}

},{"../../value/use-will-change/is.mjs":"cLEeP","../../utils/warn-once.mjs":"5dNlE","../../value/index.mjs":"iyeKc","../../value/utils/is-motion-value.mjs":"2kZP7","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"gKOe8":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "visualElementStore", ()=>visualElementStore);
const visualElementStore = new WeakMap();

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"ivZT5":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SVGVisualElement", ()=>SVGVisualElement);
var _scrapeMotionValuesMjs = require("./utils/scrape-motion-values.mjs");
var _domvisualElementMjs = require("../dom/DOMVisualElement.mjs");
var _buildAttrsMjs = require("./utils/build-attrs.mjs");
var _camelToDashMjs = require("../dom/utils/camel-to-dash.mjs");
var _camelCaseAttrsMjs = require("./utils/camel-case-attrs.mjs");
var _transformMjs = require("../html/utils/transform.mjs");
var _renderMjs = require("./utils/render.mjs");
var _defaultsMjs = require("../dom/value-types/defaults.mjs");
var _modelsMjs = require("../../projection/geometry/models.mjs");
var _isSvgTagMjs = require("./utils/is-svg-tag.mjs");
class SVGVisualElement extends (0, _domvisualElementMjs.DOMVisualElement) {
    constructor(){
        super(...arguments);
        this.type = "svg";
        this.isSVGTag = false;
    }
    getBaseTargetFromProps(props, key) {
        return props[key];
    }
    readValueFromInstance(instance, key) {
        if ((0, _transformMjs.transformProps).has(key)) {
            const defaultType = (0, _defaultsMjs.getDefaultValueType)(key);
            return defaultType ? defaultType.default || 0 : 0;
        }
        key = !(0, _camelCaseAttrsMjs.camelCaseAttributes).has(key) ? (0, _camelToDashMjs.camelToDash)(key) : key;
        return instance.getAttribute(key);
    }
    measureInstanceViewportBox() {
        return (0, _modelsMjs.createBox)();
    }
    scrapeMotionValuesFromProps(props, prevProps) {
        return (0, _scrapeMotionValuesMjs.scrapeMotionValuesFromProps)(props, prevProps);
    }
    build(renderState, latestValues, options, props) {
        (0, _buildAttrsMjs.buildSVGAttrs)(renderState, latestValues, options, this.isSVGTag, props.transformTemplate);
    }
    renderInstance(instance, renderState, styleProp, projection) {
        (0, _renderMjs.renderSVG)(instance, renderState, styleProp, projection);
    }
    mount(instance) {
        this.isSVGTag = (0, _isSvgTagMjs.isSVGTag)(instance.tagName);
        super.mount(instance);
    }
}

},{"./utils/scrape-motion-values.mjs":"7vKCJ","../dom/DOMVisualElement.mjs":"9nP1G","./utils/build-attrs.mjs":"bzDqj","../dom/utils/camel-to-dash.mjs":"kNuZz","./utils/camel-case-attrs.mjs":"jpeUe","../html/utils/transform.mjs":"es0QE","./utils/render.mjs":"7rQiG","../dom/value-types/defaults.mjs":"5j9jO","../../projection/geometry/models.mjs":"huYV1","./utils/is-svg-tag.mjs":"7qIqE","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"81FkM":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "layout", ()=>layout);
var _htmlprojectionNodeMjs = require("../../projection/node/HTMLProjectionNode.mjs");
var _measureLayoutMjs = require("./layout/MeasureLayout.mjs");
const layout = {
    layout: {
        ProjectionNode: (0, _htmlprojectionNodeMjs.HTMLProjectionNode),
        MeasureLayout: (0, _measureLayoutMjs.MeasureLayout)
    }
};

},{"../../projection/node/HTMLProjectionNode.mjs":"eJQj5","./layout/MeasureLayout.mjs":"bwaXs","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"lHwy8":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "animationControls", ()=>animationControls);
var _errorsMjs = require("../../utils/errors.mjs");
var _settersMjs = require("../../render/utils/setters.mjs");
var _visualElementMjs = require("../interfaces/visual-element.mjs");
function stopAnimation(visualElement) {
    visualElement.values.forEach((value)=>value.stop());
}
/**
 * @public
 */ function animationControls() {
    /**
     * Track whether the host component has mounted.
     */ let hasMounted = false;
    /**
     * A collection of linked component animation controls.
     */ const subscribers = new Set();
    const controls = {
        subscribe (visualElement) {
            subscribers.add(visualElement);
            return ()=>void subscribers.delete(visualElement);
        },
        start (definition, transitionOverride) {
            (0, _errorsMjs.invariant)(hasMounted, "controls.start() should only be called after a component has mounted. Consider calling within a useEffect hook.");
            const animations = [];
            subscribers.forEach((visualElement)=>{
                animations.push((0, _visualElementMjs.animateVisualElement)(visualElement, definition, {
                    transitionOverride
                }));
            });
            return Promise.all(animations);
        },
        set (definition) {
            (0, _errorsMjs.invariant)(hasMounted, "controls.set() should only be called after a component has mounted. Consider calling within a useEffect hook.");
            return subscribers.forEach((visualElement)=>{
                (0, _settersMjs.setValues)(visualElement, definition);
            });
        },
        stop () {
            subscribers.forEach((visualElement)=>{
                stopAnimation(visualElement);
            });
        },
        mount () {
            hasMounted = true;
            return ()=>{
                hasMounted = false;
                controls.stop();
            };
        }
    };
    return controls;
}

},{"../../utils/errors.mjs":"buT6L","../../render/utils/setters.mjs":"jlhrk","../interfaces/visual-element.mjs":"iC4fb","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"aKmmf":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useAnimation", ()=>useAnimation);
parcelHelpers.export(exports, "useAnimationControls", ()=>useAnimationControls);
var _animationControlsMjs = require("./animation-controls.mjs");
var _useConstantMjs = require("../../utils/use-constant.mjs");
var _useIsomorphicEffectMjs = require("../../utils/use-isomorphic-effect.mjs");
/**
 * Creates `AnimationControls`, which can be used to manually start, stop
 * and sequence animations on one or more components.
 *
 * The returned `AnimationControls` should be passed to the `animate` property
 * of the components you want to animate.
 *
 * These components can then be animated with the `start` method.
 *
 * ```jsx
 * import * as React from 'react'
 * import { motion, useAnimation } from 'framer-motion'
 *
 * export function MyComponent(props) {
 *    const controls = useAnimation()
 *
 *    controls.start({
 *        x: 100,
 *        transition: { duration: 0.5 },
 *    })
 *
 *    return <motion.div animate={controls} />
 * }
 * ```
 *
 * @returns Animation controller with `start` and `stop` methods
 *
 * @public
 */ function useAnimationControls() {
    const controls = (0, _useConstantMjs.useConstant)((0, _animationControlsMjs.animationControls));
    (0, _useIsomorphicEffectMjs.useIsomorphicLayoutEffect)(controls.mount, []);
    return controls;
}
const useAnimation = useAnimationControls;

},{"./animation-controls.mjs":"lHwy8","../../utils/use-constant.mjs":"7bpoo","../../utils/use-isomorphic-effect.mjs":"6Pcpq","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"fxOjV":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "InView", ()=>InView) //# sourceMappingURL=index.mjs.map
;
parcelHelpers.export(exports, "defaultFallbackInView", ()=>defaultFallbackInView);
parcelHelpers.export(exports, "observe", ()=>observe);
parcelHelpers.export(exports, "useInView", ()=>useInView);
// src/InView.tsx
var _react = require("react");
"use client";
var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value)=>key in obj ? __defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value
    }) : obj[key] = value;
var __publicField = (obj, key, value)=>__defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
// src/observe.ts
var observerMap = /* @__PURE__ */ new Map();
var RootIds = /* @__PURE__ */ new WeakMap();
var rootId = 0;
var unsupportedValue = void 0;
function defaultFallbackInView(inView) {
    unsupportedValue = inView;
}
function getRootId(root) {
    if (!root) return "0";
    if (RootIds.has(root)) return RootIds.get(root);
    rootId += 1;
    RootIds.set(root, rootId.toString());
    return RootIds.get(root);
}
function optionsToId(options) {
    return Object.keys(options).sort().filter((key)=>options[key] !== void 0).map((key)=>{
        return `${key}_${key === "root" ? getRootId(options.root) : options[key]}`;
    }).toString();
}
function createObserver(options) {
    const id = optionsToId(options);
    let instance = observerMap.get(id);
    if (!instance) {
        const elements = /* @__PURE__ */ new Map();
        let thresholds;
        const observer = new IntersectionObserver((entries)=>{
            entries.forEach((entry)=>{
                var _a;
                const inView = entry.isIntersecting && thresholds.some((threshold)=>entry.intersectionRatio >= threshold);
                if (options.trackVisibility && typeof entry.isVisible === "undefined") entry.isVisible = inView;
                (_a = elements.get(entry.target)) == null || _a.forEach((callback)=>{
                    callback(inView, entry);
                });
            });
        }, options);
        thresholds = observer.thresholds || (Array.isArray(options.threshold) ? options.threshold : [
            options.threshold || 0
        ]);
        instance = {
            id,
            observer,
            elements
        };
        observerMap.set(id, instance);
    }
    return instance;
}
function observe(element, callback, options = {}, fallbackInView = unsupportedValue) {
    if (typeof window.IntersectionObserver === "undefined" && fallbackInView !== void 0) {
        const bounds = element.getBoundingClientRect();
        callback(fallbackInView, {
            isIntersecting: fallbackInView,
            target: element,
            intersectionRatio: typeof options.threshold === "number" ? options.threshold : 0,
            time: 0,
            boundingClientRect: bounds,
            intersectionRect: bounds,
            rootBounds: bounds
        });
        return ()=>{};
    }
    const { id, observer, elements } = createObserver(options);
    const callbacks = elements.get(element) || [];
    if (!elements.has(element)) elements.set(element, callbacks);
    callbacks.push(callback);
    observer.observe(element);
    return function unobserve() {
        callbacks.splice(callbacks.indexOf(callback), 1);
        if (callbacks.length === 0) {
            elements.delete(element);
            observer.unobserve(element);
        }
        if (elements.size === 0) {
            observer.disconnect();
            observerMap.delete(id);
        }
    };
}
// src/InView.tsx
function isPlainChildren(props) {
    return typeof props.children !== "function";
}
var InView = class extends _react.Component {
    constructor(props){
        super(props);
        __publicField(this, "node", null);
        __publicField(this, "_unobserveCb", null);
        __publicField(this, "handleNode", (node)=>{
            if (this.node) {
                this.unobserve();
                if (!node && !this.props.triggerOnce && !this.props.skip) this.setState({
                    inView: !!this.props.initialInView,
                    entry: void 0
                });
            }
            this.node = node ? node : null;
            this.observeNode();
        });
        __publicField(this, "handleChange", (inView, entry)=>{
            if (inView && this.props.triggerOnce) this.unobserve();
            if (!isPlainChildren(this.props)) this.setState({
                inView,
                entry
            });
            if (this.props.onChange) this.props.onChange(inView, entry);
        });
        this.state = {
            inView: !!props.initialInView,
            entry: void 0
        };
    }
    componentDidMount() {
        this.unobserve();
        this.observeNode();
    }
    componentDidUpdate(prevProps) {
        if (prevProps.rootMargin !== this.props.rootMargin || prevProps.root !== this.props.root || prevProps.threshold !== this.props.threshold || prevProps.skip !== this.props.skip || prevProps.trackVisibility !== this.props.trackVisibility || prevProps.delay !== this.props.delay) {
            this.unobserve();
            this.observeNode();
        }
    }
    componentWillUnmount() {
        this.unobserve();
    }
    observeNode() {
        if (!this.node || this.props.skip) return;
        const { threshold, root, rootMargin, trackVisibility, delay, fallbackInView } = this.props;
        this._unobserveCb = observe(this.node, this.handleChange, {
            threshold,
            root,
            rootMargin,
            // @ts-ignore
            trackVisibility,
            // @ts-ignore
            delay
        }, fallbackInView);
    }
    unobserve() {
        if (this._unobserveCb) {
            this._unobserveCb();
            this._unobserveCb = null;
        }
    }
    render() {
        const { children } = this.props;
        if (typeof children === "function") {
            const { inView, entry } = this.state;
            return children({
                inView,
                entry,
                ref: this.handleNode
            });
        }
        const { as, triggerOnce, threshold, root, rootMargin, onChange, skip, trackVisibility, delay, initialInView, fallbackInView, ...props } = this.props;
        return _react.createElement(as || "div", {
            ref: this.handleNode,
            ...props
        }, children);
    }
};
function useInView({ threshold, delay, trackVisibility, rootMargin, root, triggerOnce, skip, initialInView, fallbackInView, onChange } = {}) {
    var _a;
    const [ref, setRef] = _react.useState(null);
    const callback = _react.useRef();
    const [state, setState] = _react.useState({
        inView: !!initialInView,
        entry: void 0
    });
    callback.current = onChange;
    _react.useEffect(()=>{
        if (skip || !ref) return;
        let unobserve;
        unobserve = observe(ref, (inView, entry)=>{
            setState({
                inView,
                entry
            });
            if (callback.current) callback.current(inView, entry);
            if (entry.isIntersecting && triggerOnce && unobserve) {
                unobserve();
                unobserve = void 0;
            }
        }, {
            root,
            rootMargin,
            threshold,
            // @ts-ignore
            trackVisibility,
            // @ts-ignore
            delay
        }, fallbackInView);
        return ()=>{
            if (unobserve) unobserve();
        };
    }, // We break the rule here, because we aren't including the actual `threshold` variable
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        // If the threshold is an array, convert it to a string, so it won't change between renders.
        Array.isArray(threshold) ? threshold.toString() : threshold,
        ref,
        root,
        rootMargin,
        triggerOnce,
        skip,
        trackVisibility,
        fallbackInView,
        delay
    ]);
    const entryTarget = (_a = state.entry) == null ? void 0 : _a.target;
    const previousEntryTarget = _react.useRef();
    if (!ref && entryTarget && !triggerOnce && !skip && previousEntryTarget.current !== entryTarget) {
        previousEntryTarget.current = entryTarget;
        setState({
            inView: !!initialInView,
            entry: void 0
        });
    }
    const result = [
        setRef,
        state.inView,
        state.entry
    ];
    result.ref = result[0];
    result.inView = result[1];
    result.entry = result[2];
    return result;
}

},{"react":"6uln9","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"1NUNP":[function(require,module,exports) {
module.exports = require("d51695b33a79c618").getBundleURL("8aiQJ") + "Artpocalypse.0b8dfea6.png";

},{"d51695b33a79c618":"c7Tr5"}],"7Jfjf":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Story1);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _fa = require("react-icons/fa");
var _framerMotion = require("framer-motion");
var _reactIntersectionObserver = require("react-intersection-observer");
var _1Png = require("../../assets/images/1.png");
var _1PngDefault = parcelHelpers.interopDefault(_1Png);
function Story1() {
    const { ref, inView } = (0, _reactIntersectionObserver.useInView)();
    const animation = (0, _framerMotion.useAnimation)();
    (0, _react.useEffect)(()=>{
        if (inView) animation.start({
            y: "000px",
            opacity: 1,
            // scale: 1,
            transition: {
                type: "tween",
                duration: .5,
                bounce: 0.3
            }
        });
        if (!inView) animation.start({
            y: "200px",
            // scale: 0,
            opacity: 0,
            transition: {
                type: "tween",
                duration: .5,
                bounce: 0.3
            }
        });
    }, [
        inView
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("section", {
        ref: ref,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _framerMotion.motion).div, {
            className: "StoryArt",
            animate: animation,
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                draggable: "false",
                src: (0, _1PngDefault.default),
                alt: "StoryArt"
            })
        })
    });
}

},{"react/jsx-runtime":"gaGEj","react":"6uln9","react-icons/fa":"4slQ2","framer-motion":"fI0Q4","react-intersection-observer":"fxOjV","../../assets/images/1.png":"juKWN","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"juKWN":[function(require,module,exports) {
module.exports = require("33be28ed32c6986a").getBundleURL("8aiQJ") + "1.f2c5ba73.png";

},{"33be28ed32c6986a":"c7Tr5"}],"bAxgI":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Story2);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _fa = require("react-icons/fa");
var _framerMotion = require("framer-motion");
var _reactIntersectionObserver = require("react-intersection-observer");
var _2Png = require("../../assets/images/2.png");
var _2PngDefault = parcelHelpers.interopDefault(_2Png);
function Story2() {
    const { ref, inView } = (0, _reactIntersectionObserver.useInView)();
    const animation = (0, _framerMotion.useAnimation)();
    (0, _react.useEffect)(()=>{
        if (inView) animation.start({
            y: "0",
            opacity: 1,
            // scale: 1,
            transition: {
                type: "tween",
                duration: .5,
                bounce: 0.3
            }
        });
        if (!inView) animation.start({
            y: "0",
            // scale: 0,
            opacity: 0,
            transition: {
                type: "tween",
                duration: .5,
                bounce: 0.3
            }
        });
    }, [
        inView
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("section", {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            ref: ref,
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _framerMotion.motion).div, {
                className: "StoryArt",
                animate: animation,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                    draggable: "false",
                    src: (0, _2PngDefault.default),
                    alt: "StoryArt"
                })
            })
        })
    });
}

},{"react/jsx-runtime":"gaGEj","react":"6uln9","react-icons/fa":"4slQ2","framer-motion":"fI0Q4","react-intersection-observer":"fxOjV","../../assets/images/2.png":"6W1iR","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"6W1iR":[function(require,module,exports) {
module.exports = require("fd146192051afe1").getBundleURL("8aiQJ") + "2.80f86cbf.png";

},{"fd146192051afe1":"c7Tr5"}],"yneGt":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Story2Caption);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _fa = require("react-icons/fa");
var _framerMotion = require("framer-motion");
var _reactIntersectionObserver = require("react-intersection-observer");
function Story2Caption() {
    const { ref, inView } = (0, _reactIntersectionObserver.useInView)();
    const IntroAnimation = (0, _framerMotion.useAnimation)();
    const IntroTextAnimation = (0, _framerMotion.useAnimation)();
    (0, _react.useEffect)(()=>{
        if (inView) {
            IntroAnimation.start({
                y: "0",
                opacity: 1,
                scale: [
                    .8,
                    1,
                    .8
                ],
                transition: {
                    type: "tween",
                    duration: .5,
                    bounce: 0.3
                }
            });
            IntroTextAnimation.start({
                y: "0px",
                scale: 1,
                opacity: 1,
                transition: {
                    type: "tween",
                    duration: .5
                }
            });
        }
        if (!inView) {
            IntroAnimation.start({
                y: "0",
                scale: 0,
                opacity: 0,
                transition: {
                    type: "tween",
                    duration: .5,
                    bounce: 0.3
                }
            });
            IntroTextAnimation.start({
                y: "0",
                scale: 0,
                opacity: 0,
                transition: {
                    type: "tween",
                    duration: .5,
                    bounce: 0.3
                }
            });
        }
    }, [
        inView
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("section", {
        ref: ref,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            className: "",
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _framerMotion.motion).div, {
                        className: "px-4 StoryCaption fontArt p-4",
                        animate: IntroTextAnimation,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                            children: "Mayhem in the street ensues"
                        })
                    })
                })
            })
        })
    });
}

},{"react/jsx-runtime":"gaGEj","react":"6uln9","react-icons/fa":"4slQ2","framer-motion":"fI0Q4","react-intersection-observer":"fxOjV","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"1Nm7b":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Story3);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _fa = require("react-icons/fa");
var _framerMotion = require("framer-motion");
var _reactIntersectionObserver = require("react-intersection-observer");
var _3Png = require("../../assets/images/3.png");
var _3PngDefault = parcelHelpers.interopDefault(_3Png);
function Story3() {
    const { ref, inView } = (0, _reactIntersectionObserver.useInView)();
    const animation = (0, _framerMotion.useAnimation)();
    (0, _react.useEffect)(()=>{
        if (inView) animation.start({
            y: "0",
            opacity: 1,
            // scale: 1,
            transition: {
                type: "tween",
                duration: .5,
                bounce: 0.3
            }
        });
        if (!inView) animation.start({
            y: "0",
            // scale: 0,
            opacity: 0,
            transition: {
                type: "tween",
                duration: .5,
                bounce: 0.3
            }
        });
    }, [
        inView
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _framerMotion.motion).section, {
        ref: ref,
        animate: animation,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _framerMotion.motion).div, {
                className: "StoryArt",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                    draggable: "false",
                    src: (0, _3PngDefault.default),
                    alt: "StoryArt"
                })
            })
        })
    });
}

},{"react/jsx-runtime":"gaGEj","react":"6uln9","react-icons/fa":"4slQ2","framer-motion":"fI0Q4","react-intersection-observer":"fxOjV","../../assets/images/3.png":"lGOGL","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"lGOGL":[function(require,module,exports) {
module.exports = require("6b91d79b35863f8f").getBundleURL("8aiQJ") + "3.08da7dab.png";

},{"6b91d79b35863f8f":"c7Tr5"}],"hlYSb":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Story4);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _fa = require("react-icons/fa");
var _framerMotion = require("framer-motion");
var _reactIntersectionObserver = require("react-intersection-observer");
var _4Png = require("../../assets/images/4.png");
var _4PngDefault = parcelHelpers.interopDefault(_4Png);
function Story4() {
    const { ref, inView } = (0, _reactIntersectionObserver.useInView)();
    const animation = (0, _framerMotion.useAnimation)();
    (0, _react.useEffect)(()=>{
        if (inView) animation.start({
            y: "0",
            opacity: 1,
            // scale: 1,
            transition: {
                type: "tween",
                duration: .5,
                bounce: 0.3
            }
        });
        if (!inView) animation.start({
            y: "0",
            // scale: 0,
            opacity: 0,
            transition: {
                type: "tween",
                duration: .5,
                bounce: 0.3
            }
        });
    }, [
        inView
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _framerMotion.motion).section, {
        ref: ref,
        animate: animation,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _framerMotion.motion).div, {
                className: "StoryArt",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                    draggable: "false",
                    src: (0, _4PngDefault.default),
                    alt: "StoryArt"
                })
            })
        })
    });
}

},{"react/jsx-runtime":"gaGEj","react":"6uln9","react-icons/fa":"4slQ2","framer-motion":"fI0Q4","react-intersection-observer":"fxOjV","../../assets/images/4.png":"bd3pC","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"bd3pC":[function(require,module,exports) {
module.exports = require("53a622d41ce334eb").getBundleURL("8aiQJ") + "4.40b86775.png";

},{"53a622d41ce334eb":"c7Tr5"}],"iFsLh":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Story5);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _fa = require("react-icons/fa");
var _framerMotion = require("framer-motion");
var _reactIntersectionObserver = require("react-intersection-observer");
var _5Png = require("../../assets/images/5.png");
var _5PngDefault = parcelHelpers.interopDefault(_5Png);
function Story5() {
    const { ref, inView } = (0, _reactIntersectionObserver.useInView)();
    const animation = (0, _framerMotion.useAnimation)();
    (0, _react.useEffect)(()=>{
        if (inView) animation.start({
            y: "0",
            opacity: 1,
            // scale: 1,
            transition: {
                type: "tween",
                duration: .5,
                bounce: 0.3
            }
        });
        if (!inView) animation.start({
            y: "0",
            // scale: 0,
            opacity: 0,
            transition: {
                type: "tween",
                duration: .5,
                bounce: 0.3
            }
        });
    }, [
        inView
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _framerMotion.motion).section, {
        ref: ref,
        animate: animation,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _framerMotion.motion).div, {
                className: "StoryArt",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                    draggable: "false",
                    src: (0, _5PngDefault.default),
                    alt: "StoryArt"
                })
            })
        })
    });
}

},{"react/jsx-runtime":"gaGEj","react":"6uln9","react-icons/fa":"4slQ2","framer-motion":"fI0Q4","react-intersection-observer":"fxOjV","../../assets/images/5.png":"4ZPVv","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4ZPVv":[function(require,module,exports) {
module.exports = require("eb7c3d8d976d17bf").getBundleURL("8aiQJ") + "5.b8f67e1c.png";

},{"eb7c3d8d976d17bf":"c7Tr5"}],"8ouNo":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Story6Caption);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _fa = require("react-icons/fa");
var _framerMotion = require("framer-motion");
var _reactIntersectionObserver = require("react-intersection-observer");
function Story6Caption() {
    const { ref, inView } = (0, _reactIntersectionObserver.useInView)();
    const IntroAnimation = (0, _framerMotion.useAnimation)();
    const IntroTextAnimation = (0, _framerMotion.useAnimation)();
    (0, _react.useEffect)(()=>{
        if (inView) {
            IntroAnimation.start({
                y: "0",
                opacity: 1,
                scale: [
                    .8,
                    1,
                    .8
                ],
                transition: {
                    type: "tween",
                    duration: .5,
                    bounce: 0.3
                }
            });
            IntroTextAnimation.start({
                y: "0px",
                scale: 1,
                opacity: 1,
                transition: {
                    type: "tween",
                    duration: .5
                }
            });
        }
        if (!inView) {
            IntroAnimation.start({
                y: "0",
                scale: 0,
                opacity: 0,
                transition: {
                    type: "tween",
                    duration: .5,
                    bounce: 0.3
                }
            });
            IntroTextAnimation.start({
                y: "0",
                scale: 0,
                opacity: 0,
                transition: {
                    type: "tween",
                    duration: .5,
                    bounce: 0.3
                }
            });
        }
    }, [
        inView
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("section", {
        ref: ref,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            className: "",
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _framerMotion.motion).div, {
                        className: "px-4 StoryCaption fontArt",
                        animate: IntroTextAnimation,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                            children: "The elites are still sitting comfortably while the rest of the world literally burns. They hold the last stockpiles of edible food and water. They are willing to make small trades in exchange for the finest of art. Specifically Picassos, Da Vincis, And Fine Art Mfers"
                        })
                    })
                })
            })
        })
    });
}

},{"react/jsx-runtime":"gaGEj","react":"6uln9","react-icons/fa":"4slQ2","framer-motion":"fI0Q4","react-intersection-observer":"fxOjV","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"hDMZk":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Story6);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _fa = require("react-icons/fa");
var _framerMotion = require("framer-motion");
var _reactIntersectionObserver = require("react-intersection-observer");
var _6Jpg = require("../../assets/images/6.jpg");
var _6JpgDefault = parcelHelpers.interopDefault(_6Jpg);
function Story6() {
    const { ref, inView } = (0, _reactIntersectionObserver.useInView)();
    const animation = (0, _framerMotion.useAnimation)();
    (0, _react.useEffect)(()=>{
        if (inView) animation.start({
            y: "0",
            opacity: 1,
            // scale: 1,
            transition: {
                type: "tween",
                duration: .5,
                bounce: 0.3
            }
        });
        if (!inView) animation.start({
            y: "0",
            // scale: 0,
            opacity: 0,
            transition: {
                type: "tween",
                duration: .5,
                bounce: 0.3
            }
        });
    }, [
        inView
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _framerMotion.motion).section, {
        ref: ref,
        animate: animation,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _framerMotion.motion).div, {
                className: "StoryArt",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                    draggable: "false",
                    src: (0, _6JpgDefault.default),
                    alt: "StoryArt"
                })
            })
        })
    });
}

},{"react/jsx-runtime":"gaGEj","react":"6uln9","react-icons/fa":"4slQ2","framer-motion":"fI0Q4","react-intersection-observer":"fxOjV","../../assets/images/6.jpg":"h6o0u","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"h6o0u":[function(require,module,exports) {
module.exports = require("358e3bb3508284e4").getBundleURL("8aiQJ") + "6.c30b5d53.jpg";

},{"358e3bb3508284e4":"c7Tr5"}],"96oAh":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Story7Caption);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _fa = require("react-icons/fa");
var _framerMotion = require("framer-motion");
var _reactIntersectionObserver = require("react-intersection-observer");
function Story7Caption() {
    const { ref, inView } = (0, _reactIntersectionObserver.useInView)();
    const IntroAnimation = (0, _framerMotion.useAnimation)();
    const IntroTextAnimation = (0, _framerMotion.useAnimation)();
    (0, _react.useEffect)(()=>{
        if (inView) {
            IntroAnimation.start({
                y: "0",
                opacity: 1,
                scale: [
                    .8,
                    1,
                    .8
                ],
                transition: {
                    type: "tween",
                    duration: .5,
                    bounce: 0.3
                }
            });
            IntroTextAnimation.start({
                y: "0px",
                scale: 1,
                opacity: 1,
                transition: {
                    type: "tween",
                    duration: .5
                }
            });
        }
        if (!inView) {
            IntroAnimation.start({
                y: "0",
                scale: 0,
                opacity: 0,
                transition: {
                    type: "tween",
                    duration: .5,
                    bounce: 0.3
                }
            });
            IntroTextAnimation.start({
                y: "0",
                scale: 0,
                opacity: 0,
                transition: {
                    type: "tween",
                    duration: .5,
                    bounce: 0.3
                }
            });
        }
    }, [
        inView
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("section", {
        ref: ref,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            className: "",
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _framerMotion.motion).div, {
                        className: "px-4 StoryCaption fontArt",
                        animate: IntroTextAnimation,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                            children: "After all, The luxury bunkers still need to be decorated"
                        })
                    })
                })
            })
        })
    });
}

},{"react/jsx-runtime":"gaGEj","react":"6uln9","react-icons/fa":"4slQ2","framer-motion":"fI0Q4","react-intersection-observer":"fxOjV","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"1UwzB":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Story7);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _fa = require("react-icons/fa");
var _framerMotion = require("framer-motion");
var _reactIntersectionObserver = require("react-intersection-observer");
var _7Jpg = require("../../assets/images/7.jpg");
var _7JpgDefault = parcelHelpers.interopDefault(_7Jpg);
function Story7() {
    const { ref, inView } = (0, _reactIntersectionObserver.useInView)();
    const animation = (0, _framerMotion.useAnimation)();
    (0, _react.useEffect)(()=>{
        if (inView) animation.start({
            y: "0",
            opacity: 1,
            // scale: 1,
            transition: {
                type: "tween",
                duration: .5,
                bounce: 0.3
            }
        });
        if (!inView) animation.start({
            y: "0",
            // scale: 0,
            opacity: 0,
            transition: {
                type: "tween",
                duration: .5,
                bounce: 0.3
            }
        });
    }, [
        inView
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _framerMotion.motion).section, {
        ref: ref,
        animate: animation,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _framerMotion.motion).div, {
                className: "StoryArt",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                    draggable: "false",
                    src: (0, _7JpgDefault.default),
                    alt: "StoryArt"
                })
            })
        })
    });
}

},{"react/jsx-runtime":"gaGEj","react":"6uln9","react-icons/fa":"4slQ2","framer-motion":"fI0Q4","react-intersection-observer":"fxOjV","../../assets/images/7.jpg":"eR2EW","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"eR2EW":[function(require,module,exports) {
module.exports = require("3b5bd15ea2016909").getBundleURL("8aiQJ") + "7.215564a7.jpg";

},{"3b5bd15ea2016909":"c7Tr5"}],"5w2fX":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Story8Caption);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _fa = require("react-icons/fa");
var _framerMotion = require("framer-motion");
var _reactIntersectionObserver = require("react-intersection-observer");
function Story8Caption() {
    const { ref, inView } = (0, _reactIntersectionObserver.useInView)();
    const IntroAnimation = (0, _framerMotion.useAnimation)();
    const IntroTextAnimation = (0, _framerMotion.useAnimation)();
    (0, _react.useEffect)(()=>{
        if (inView) {
            IntroAnimation.start({
                y: "0",
                opacity: 1,
                scale: [
                    .8,
                    1,
                    .8
                ],
                transition: {
                    type: "tween",
                    duration: .5,
                    bounce: 0.3
                }
            });
            IntroTextAnimation.start({
                y: "0px",
                scale: 1,
                opacity: 1,
                transition: {
                    type: "tween",
                    duration: .5
                }
            });
        }
        if (!inView) {
            IntroAnimation.start({
                y: "0",
                scale: 0,
                opacity: 0,
                transition: {
                    type: "tween",
                    duration: .5,
                    bounce: 0.3
                }
            });
            IntroTextAnimation.start({
                y: "0",
                scale: 0,
                opacity: 0,
                transition: {
                    type: "tween",
                    duration: .5,
                    bounce: 0.3
                }
            });
        }
    }, [
        inView
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("section", {
        ref: ref,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            className: "",
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _framerMotion.motion).div, {
                        className: "px-4 StoryCaption fontArt",
                        animate: IntroTextAnimation,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                            children: "Hearing this announcement, people flocked to the museums in droves in hopes of acquiring a fine art piece that could be traded for food or water."
                        })
                    })
                })
            })
        })
    });
}

},{"react/jsx-runtime":"gaGEj","react":"6uln9","react-icons/fa":"4slQ2","framer-motion":"fI0Q4","react-intersection-observer":"fxOjV","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7xK5a":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Story8);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _fa = require("react-icons/fa");
var _framerMotion = require("framer-motion");
var _reactIntersectionObserver = require("react-intersection-observer");
var _8Png = require("../../assets/images/8.png");
var _8PngDefault = parcelHelpers.interopDefault(_8Png);
function Story8() {
    const { ref, inView } = (0, _reactIntersectionObserver.useInView)();
    const animation = (0, _framerMotion.useAnimation)();
    (0, _react.useEffect)(()=>{
        if (inView) animation.start({
            y: "0",
            opacity: 1,
            // scale: 1,
            transition: {
                type: "tween",
                duration: .5,
                bounce: 0.3
            }
        });
        if (!inView) animation.start({
            y: "0",
            // scale: 0,
            opacity: 0,
            transition: {
                type: "tween",
                duration: .5,
                bounce: 0.3
            }
        });
    }, [
        inView
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _framerMotion.motion).section, {
        ref: ref,
        animate: animation,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _framerMotion.motion).div, {
                className: "StoryArt",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                    draggable: "false",
                    src: (0, _8PngDefault.default),
                    alt: "StoryArt"
                })
            })
        })
    });
}

},{"react/jsx-runtime":"gaGEj","react":"6uln9","react-icons/fa":"4slQ2","framer-motion":"fI0Q4","react-intersection-observer":"fxOjV","../../assets/images/8.png":"eDHI6","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"eDHI6":[function(require,module,exports) {
module.exports = require("75393262283d5a20").getBundleURL("8aiQJ") + "8.cc7940db.png";

},{"75393262283d5a20":"c7Tr5"}],"kZUry":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Story9);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _fa = require("react-icons/fa");
var _framerMotion = require("framer-motion");
var _reactIntersectionObserver = require("react-intersection-observer");
var _9Jpg = require("../../assets/images/9.jpg");
var _9JpgDefault = parcelHelpers.interopDefault(_9Jpg);
function Story9() {
    const { ref, inView } = (0, _reactIntersectionObserver.useInView)();
    const animation = (0, _framerMotion.useAnimation)();
    (0, _react.useEffect)(()=>{
        if (inView) animation.start({
            y: "0",
            opacity: 1,
            // scale: 1,
            transition: {
                type: "tween",
                duration: .5,
                bounce: 0.3
            }
        });
        if (!inView) animation.start({
            y: "0",
            // scale: 0,
            opacity: 0,
            transition: {
                type: "tween",
                duration: .5,
                bounce: 0.3
            }
        });
    }, [
        inView
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _framerMotion.motion).section, {
        ref: ref,
        animate: animation,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _framerMotion.motion).div, {
                className: "StoryArt",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                    draggable: "false",
                    src: (0, _9JpgDefault.default),
                    alt: "StoryArt"
                })
            })
        })
    });
}

},{"react/jsx-runtime":"gaGEj","react":"6uln9","react-icons/fa":"4slQ2","framer-motion":"fI0Q4","react-intersection-observer":"fxOjV","../../assets/images/9.jpg":"ev9Rh","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"ev9Rh":[function(require,module,exports) {
module.exports = require("f4c0e20a48e19b01").getBundleURL("8aiQJ") + "9.e54cfb36.jpg";

},{"f4c0e20a48e19b01":"c7Tr5"}],"1SDmu":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Story10);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _fa = require("react-icons/fa");
var _framerMotion = require("framer-motion");
var _reactIntersectionObserver = require("react-intersection-observer");
var _10Png = require("../../assets/images/10.png");
var _10PngDefault = parcelHelpers.interopDefault(_10Png);
function Story10() {
    const { ref, inView } = (0, _reactIntersectionObserver.useInView)();
    const animation = (0, _framerMotion.useAnimation)();
    (0, _react.useEffect)(()=>{
        // 
        if (inView) animation.start({
            y: "0",
            opacity: 1,
            // scale: 1,
            transition: {
                type: "tween",
                duration: .5,
                bounce: 0.3
            }
        });
        if (!inView) animation.start({
            y: "0",
            // scale: 0,
            opacity: 0,
            transition: {
                type: "tween",
                duration: .5,
                bounce: 0.3
            }
        });
    }, [
        inView
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _framerMotion.motion).section, {
        ref: ref,
        animate: animation,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _framerMotion.motion).div, {
                className: "StoryArt",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                    draggable: "false",
                    src: (0, _10PngDefault.default),
                    alt: "StoryArt"
                })
            })
        })
    });
}

},{"react/jsx-runtime":"gaGEj","react":"6uln9","react-icons/fa":"4slQ2","framer-motion":"fI0Q4","react-intersection-observer":"fxOjV","../../assets/images/10.png":"g40ED","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"g40ED":[function(require,module,exports) {
module.exports = require("e5a9f34c8918109b").getBundleURL("8aiQJ") + "10.b17b769f.png";

},{"e5a9f34c8918109b":"c7Tr5"}],"ldQH1":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Story11);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _fa = require("react-icons/fa");
var _framerMotion = require("framer-motion");
var _reactIntersectionObserver = require("react-intersection-observer");
var _11Jpg = require("../../assets/images/11.jpg");
var _11JpgDefault = parcelHelpers.interopDefault(_11Jpg);
function Story11() {
    const { ref, inView } = (0, _reactIntersectionObserver.useInView)();
    const animation = (0, _framerMotion.useAnimation)();
    (0, _react.useEffect)(()=>{
        if (inView) animation.start({
            y: "0",
            opacity: 1,
            // scale: 1,
            transition: {
                type: "tween",
                duration: .5,
                bounce: 0.3
            }
        });
        if (!inView) animation.start({
            y: "0",
            // scale: 0,
            opacity: 0,
            transition: {
                type: "tween",
                duration: .5,
                bounce: 0.3
            }
        });
    }, [
        inView
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _framerMotion.motion).section, {
        ref: ref,
        animate: animation,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _framerMotion.motion).div, {
                className: "StoryArt",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                    draggable: "false",
                    src: (0, _11JpgDefault.default),
                    alt: "StoryArt"
                })
            })
        })
    });
}

},{"react/jsx-runtime":"gaGEj","react":"6uln9","react-icons/fa":"4slQ2","framer-motion":"fI0Q4","react-intersection-observer":"fxOjV","../../assets/images/11.jpg":"7A0TS","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7A0TS":[function(require,module,exports) {
module.exports = require("9def6c32f6d94266").getBundleURL("8aiQJ") + "11.387b48f3.jpg";

},{"9def6c32f6d94266":"c7Tr5"}],"kKjdV":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Story12);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _fa = require("react-icons/fa");
var _framerMotion = require("framer-motion");
var _reactIntersectionObserver = require("react-intersection-observer");
var _12Jpeg = require("../../assets/images/12.jpeg");
var _12JpegDefault = parcelHelpers.interopDefault(_12Jpeg);
function Story12() {
    const { ref, inView } = (0, _reactIntersectionObserver.useInView)();
    const animation = (0, _framerMotion.useAnimation)();
    (0, _react.useEffect)(()=>{
        if (inView) animation.start({
            y: "0",
            opacity: 1,
            // scale: 1,
            transition: {
                type: "tween",
                duration: .5,
                bounce: 0.3
            }
        });
        if (!inView) animation.start({
            y: "0",
            // scale: 0,
            opacity: 0,
            transition: {
                type: "tween",
                duration: .5,
                bounce: 0.3
            }
        });
    }, [
        inView
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _framerMotion.motion).section, {
        ref: ref,
        animate: animation,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _framerMotion.motion).div, {
                className: "StoryArt",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                    draggable: "false",
                    src: (0, _12JpegDefault.default),
                    alt: "StoryArt"
                })
            })
        })
    });
}

},{"react/jsx-runtime":"gaGEj","react":"6uln9","react-icons/fa":"4slQ2","framer-motion":"fI0Q4","react-intersection-observer":"fxOjV","../../assets/images/12.jpeg":"eBKM0","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"eBKM0":[function(require,module,exports) {
module.exports = require("fb7edd2d13e9107b").getBundleURL("8aiQJ") + "12.8cd44acf.jpeg";

},{"fb7edd2d13e9107b":"c7Tr5"}],"fPhMZ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Story12Caption);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _fa = require("react-icons/fa");
var _framerMotion = require("framer-motion");
var _reactIntersectionObserver = require("react-intersection-observer");
function Story12Caption() {
    const { ref, inView } = (0, _reactIntersectionObserver.useInView)();
    const IntroAnimation = (0, _framerMotion.useAnimation)();
    const IntroTextAnimation = (0, _framerMotion.useAnimation)();
    (0, _react.useEffect)(()=>{
        if (inView) {
            IntroAnimation.start({
                y: "0",
                opacity: 1,
                scale: [
                    .8,
                    1,
                    .8
                ],
                transition: {
                    type: "tween",
                    duration: .5,
                    bounce: 0.3
                }
            });
            IntroTextAnimation.start({
                y: "0px",
                scale: 1,
                opacity: 1,
                transition: {
                    type: "tween",
                    duration: .5
                }
            });
        }
        if (!inView) {
            IntroAnimation.start({
                y: "0",
                scale: 0,
                opacity: 0,
                transition: {
                    type: "tween",
                    duration: .5,
                    bounce: 0.3
                }
            });
            IntroTextAnimation.start({
                y: "0",
                scale: 0,
                opacity: 0,
                transition: {
                    type: "tween",
                    duration: .5,
                    bounce: 0.3
                }
            });
        }
    }, [
        inView
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("section", {
        ref: ref,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            className: "",
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _framerMotion.motion).div, {
                        className: "px-4 StoryCaption fontArt",
                        animate: IntroTextAnimation,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                            children: "After all the dust was settled, there was one secret corridor that was untouched by the madness. This hallway contained the last remaining, highly sought after, fine art mfers. Owned by YOU"
                        })
                    })
                })
            })
        })
    });
}

},{"react/jsx-runtime":"gaGEj","react":"6uln9","react-icons/fa":"4slQ2","framer-motion":"fI0Q4","react-intersection-observer":"fxOjV","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"fymAk":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Story13Caption);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _fa = require("react-icons/fa");
var _framerMotion = require("framer-motion");
var _reactIntersectionObserver = require("react-intersection-observer");
function Story13Caption() {
    const { ref, inView } = (0, _reactIntersectionObserver.useInView)();
    const IntroAnimation = (0, _framerMotion.useAnimation)();
    const IntroTextAnimation = (0, _framerMotion.useAnimation)();
    (0, _react.useEffect)(()=>{
        if (inView) {
            IntroAnimation.start({
                y: "0",
                opacity: 1,
                scale: [
                    .8,
                    1,
                    .8
                ],
                transition: {
                    type: "tween",
                    duration: .5,
                    bounce: 0.3
                }
            });
            IntroTextAnimation.start({
                y: "0px",
                scale: 1,
                opacity: 1,
                transition: {
                    type: "tween",
                    duration: .5
                }
            });
        }
        if (!inView) {
            IntroAnimation.start({
                y: "0",
                scale: 0,
                opacity: 0,
                transition: {
                    type: "tween",
                    duration: .5,
                    bounce: 0.3
                }
            });
            IntroTextAnimation.start({
                y: "0",
                scale: 0,
                opacity: 0,
                transition: {
                    type: "tween",
                    duration: .5,
                    bounce: 0.3
                }
            });
        }
    }, [
        inView
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("section", {
        ref: ref,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            className: "",
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _framerMotion.motion).div, {
                        className: "px-4 StoryCaption fontArt",
                        animate: IntroTextAnimation,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                            children: "Due to the power of the F.A.M, these mysterious red beans began to grow from the cracks of this hidden corridor and slowly began to evolve"
                        })
                    })
                })
            })
        })
    });
}

},{"react/jsx-runtime":"gaGEj","react":"6uln9","react-icons/fa":"4slQ2","framer-motion":"fI0Q4","react-intersection-observer":"fxOjV","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"h7YNc":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Story13);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _fa = require("react-icons/fa");
var _framerMotion = require("framer-motion");
var _reactIntersectionObserver = require("react-intersection-observer");
var _13Png = require("../../assets/images/13.png");
var _13PngDefault = parcelHelpers.interopDefault(_13Png);
function Story13() {
    const { ref, inView } = (0, _reactIntersectionObserver.useInView)();
    const animation = (0, _framerMotion.useAnimation)();
    (0, _react.useEffect)(()=>{
        if (inView) animation.start({
            y: "0",
            opacity: 1,
            // scale: 1,
            transition: {
                type: "tween",
                duration: .5,
                bounce: 0.3
            }
        });
        if (!inView) animation.start({
            y: "0",
            // scale: 0,
            opacity: 0,
            transition: {
                type: "tween",
                duration: .5,
                bounce: 0.3
            }
        });
    }, [
        inView
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _framerMotion.motion).section, {
        ref: ref,
        animate: animation,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _framerMotion.motion).div, {
                className: "StoryArt",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                    draggable: "false",
                    src: (0, _13PngDefault.default),
                    alt: "StoryArt"
                })
            })
        })
    });
}

},{"react/jsx-runtime":"gaGEj","react":"6uln9","react-icons/fa":"4slQ2","framer-motion":"fI0Q4","react-intersection-observer":"fxOjV","../../assets/images/13.png":"Yojz1","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"Yojz1":[function(require,module,exports) {
module.exports = require("b4f561ca89ee2a41").getBundleURL("8aiQJ") + "13.eeecc538.png";

},{"b4f561ca89ee2a41":"c7Tr5"}],"lwigv":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Story14);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _fa = require("react-icons/fa");
var _framerMotion = require("framer-motion");
var _reactIntersectionObserver = require("react-intersection-observer");
var _14Jpg = require("../../assets/images/14.jpg");
var _14JpgDefault = parcelHelpers.interopDefault(_14Jpg);
function Story14() {
    const { ref, inView } = (0, _reactIntersectionObserver.useInView)();
    const animation = (0, _framerMotion.useAnimation)();
    (0, _react.useEffect)(()=>{
        if (inView) animation.start({
            y: "0",
            opacity: 1,
            // scale: 1,
            transition: {
                type: "tween",
                duration: .5,
                bounce: 0.3
            }
        });
        if (!inView) animation.start({
            y: "0",
            // scale: 0,
            opacity: 0,
            transition: {
                type: "tween",
                duration: .5,
                bounce: 0.3
            }
        });
    }, [
        inView
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _framerMotion.motion).section, {
        ref: ref,
        animate: animation,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _framerMotion.motion).div, {
                className: "StoryArt",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                    draggable: "false",
                    src: (0, _14JpgDefault.default),
                    alt: "StoryArt"
                })
            })
        })
    });
}

},{"react/jsx-runtime":"gaGEj","react":"6uln9","react-icons/fa":"4slQ2","framer-motion":"fI0Q4","react-intersection-observer":"fxOjV","../../assets/images/14.jpg":"a71Iz","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"a71Iz":[function(require,module,exports) {
module.exports = require("18a1f59399f606ee").getBundleURL("8aiQJ") + "14.953f3e7f.jpg";

},{"18a1f59399f606ee":"c7Tr5"}],"bwppZ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Story14Caption);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _fa = require("react-icons/fa");
var _framerMotion = require("framer-motion");
var _reactIntersectionObserver = require("react-intersection-observer");
function Story14Caption() {
    const { ref, inView } = (0, _reactIntersectionObserver.useInView)();
    const IntroAnimation = (0, _framerMotion.useAnimation)();
    const IntroTextAnimation = (0, _framerMotion.useAnimation)();
    (0, _react.useEffect)(()=>{
        if (inView) {
            IntroAnimation.start({
                y: "0",
                opacity: 1,
                scale: [
                    .8,
                    1,
                    .8
                ],
                transition: {
                    type: "tween",
                    duration: .5,
                    bounce: 0.3
                }
            });
            IntroTextAnimation.start({
                y: "0px",
                scale: 1,
                opacity: 1,
                transition: {
                    type: "tween",
                    duration: .5
                }
            });
        }
        if (!inView) {
            IntroAnimation.start({
                y: "0",
                scale: 0,
                opacity: 0,
                transition: {
                    type: "tween",
                    duration: .5,
                    bounce: 0.3
                }
            });
            IntroTextAnimation.start({
                y: "0",
                scale: 0,
                opacity: 0,
                transition: {
                    type: "tween",
                    duration: .5,
                    bounce: 0.3
                }
            });
        }
    }, [
        inView
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("section", {
        ref: ref,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            className: "",
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _framerMotion.motion).div, {
                        className: "px-4 StoryCaption fontArt",
                        animate: IntroTextAnimation,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                            children: "The genetic composition of the beans began to intertwine with the neural networks of computers, giving them the ability to transform the F.A.M."
                        })
                    })
                })
            })
        })
    });
}

},{"react/jsx-runtime":"gaGEj","react":"6uln9","react-icons/fa":"4slQ2","framer-motion":"fI0Q4","react-intersection-observer":"fxOjV","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"b15Im":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Story15Caption);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _fa = require("react-icons/fa");
var _framerMotion = require("framer-motion");
var _reactIntersectionObserver = require("react-intersection-observer");
function Story15Caption() {
    const { ref, inView } = (0, _reactIntersectionObserver.useInView)();
    const IntroAnimation = (0, _framerMotion.useAnimation)();
    const IntroTextAnimation = (0, _framerMotion.useAnimation)();
    (0, _react.useEffect)(()=>{
        if (inView) {
            IntroAnimation.start({
                y: "0",
                opacity: 1,
                scale: [
                    .8,
                    1,
                    .8
                ],
                transition: {
                    type: "tween",
                    duration: .5,
                    bounce: 0.3
                }
            });
            IntroTextAnimation.start({
                y: "0px",
                scale: 1,
                opacity: 1,
                transition: {
                    type: "tween",
                    duration: .5
                }
            });
        }
        if (!inView) {
            IntroAnimation.start({
                y: "0",
                scale: 0,
                opacity: 0,
                transition: {
                    type: "tween",
                    duration: .5,
                    bounce: 0.3
                }
            });
            IntroTextAnimation.start({
                y: "0",
                scale: 0,
                opacity: 0,
                transition: {
                    type: "tween",
                    duration: .5,
                    bounce: 0.3
                }
            });
        }
    }, [
        inView
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("section", {
        ref: ref,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            className: "",
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _framerMotion.motion).div, {
                        className: "px-4 StoryCaption fontArt",
                        animate: IntroTextAnimation,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                            children: "These beans provide the upgrades needed to storm the gates and take back the food and water to rebuild civilization"
                        })
                    })
                })
            })
        })
    });
}

},{"react/jsx-runtime":"gaGEj","react":"6uln9","react-icons/fa":"4slQ2","framer-motion":"fI0Q4","react-intersection-observer":"fxOjV","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"45b1f":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Story15);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _framerMotion = require("framer-motion");
var _reactIntersectionObserver = require("react-intersection-observer");
var _15Jpg = require("../../assets/images/15.jpg");
var _15JpgDefault = parcelHelpers.interopDefault(_15Jpg);
function Story15() {
    const { ref, inView } = (0, _reactIntersectionObserver.useInView)();
    const animation = (0, _framerMotion.useAnimation)();
    (0, _react.useEffect)(()=>{
        if (inView) animation.start({
            y: "0",
            opacity: 1,
            // scale: 1,
            transition: {
                type: "tween",
                duration: .5,
                bounce: 0.3
            }
        });
        if (!inView) animation.start({
            y: "0",
            // scale: 0,
            opacity: 0,
            transition: {
                type: "tween",
                duration: .5,
                bounce: 0.3
            }
        });
    }, [
        inView
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _framerMotion.motion).section, {
        ref: ref,
        animate: animation,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _framerMotion.motion).div, {
                className: "StoryArt",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                    draggable: "false",
                    src: (0, _15JpgDefault.default),
                    alt: "StoryArt"
                })
            })
        })
    });
}

},{"react/jsx-runtime":"gaGEj","react":"6uln9","framer-motion":"fI0Q4","react-intersection-observer":"fxOjV","../../assets/images/15.jpg":"76mUE","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"76mUE":[function(require,module,exports) {
module.exports = require("8af271ea626db5a7").getBundleURL("8aiQJ") + "15.10e4e1e0.jpg";

},{"8af271ea626db5a7":"c7Tr5"}],"jdv5g":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Climax);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _fa = require("react-icons/fa");
var _framerMotion = require("framer-motion");
var _reactIntersectionObserver = require("react-intersection-observer");
function Climax() {
    const { ref, inView } = (0, _reactIntersectionObserver.useInView)();
    const IntroAnimation = (0, _framerMotion.useAnimation)();
    const IntroTextAnimation = (0, _framerMotion.useAnimation)();
    (0, _react.useEffect)(()=>{
        if (inView) {
            IntroAnimation.start({
                y: "0",
                opacity: 1,
                scale: [
                    .8,
                    1,
                    .8
                ],
                transition: {
                    type: "tween",
                    duration: .5,
                    bounce: 0.3
                }
            });
            IntroTextAnimation.start({
                y: "0",
                scale: 1,
                opacity: 1,
                transition: {
                    type: "tween",
                    duration: .5,
                    bounce: 0.3
                }
            });
        }
        if (!inView) {
            IntroAnimation.start({
                y: "200px",
                scale: 0,
                opacity: 0,
                transition: {
                    type: "tween",
                    duration: .5,
                    bounce: 0.3
                }
            });
            IntroTextAnimation.start({
                y: "200px",
                scale: 0,
                opacity: 0,
                transition: {
                    type: "tween",
                    duration: .5,
                    bounce: 0.3
                }
            });
        }
    }, [
        inView
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("section", {
        ref: ref,
        className: "FullScreen",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            className: "",
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _framerMotion.motion).div, {
                        className: "px-4 StoryCaption4 fontArt",
                        animate: IntroTextAnimation,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                            children: "So the question is........."
                        })
                    })
                })
            })
        })
    });
}

},{"react/jsx-runtime":"gaGEj","react":"6uln9","react-icons/fa":"4slQ2","framer-motion":"fI0Q4","react-intersection-observer":"fxOjV","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"V6zcm":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Outro);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _framerMotion = require("framer-motion");
var _reactIntersectionObserver = require("react-intersection-observer");
var _popPng = require("../../assets/images/pop.png");
var _popPngDefault = parcelHelpers.interopDefault(_popPng);
var _flickPng = require("../../assets/images/flick.png");
var _flickPngDefault = parcelHelpers.interopDefault(_flickPng);
var _flickGif = require("../../assets/images/Flick.gif");
var _flickGifDefault = parcelHelpers.interopDefault(_flickGif);
var _metalogoPng = require("../../assets/images/Metalogo.png");
var _metalogoPngDefault = parcelHelpers.interopDefault(_metalogoPng);
function Outro() {
    const { ref, inView } = (0, _reactIntersectionObserver.useInView)();
    const ButtonAnimation = (0, _framerMotion.useAnimation)();
    const IntroTextAnimation = (0, _framerMotion.useAnimation)();
    const [showModal, setShowModal] = (0, _react.useState)(false);
    const [showBeanModal, setShowBeanModal] = (0, _react.useState)(false);
    const [redirectUrl, setRedirectUrl] = (0, _react.useState)("");
    (0, _react.useEffect)(()=>{
        if (inView) {
            ButtonAnimation.start({
                y: "0",
                opacity: 1,
                scale: [
                    .8,
                    1,
                    .8
                ],
                transition: {
                    type: "tween",
                    duration: .5,
                    bounce: 0.3
                }
            });
            IntroTextAnimation.start({
                y: "0",
                scale: 1,
                opacity: 1,
                transition: {
                    type: "tween",
                    duration: .5,
                    bounce: 0.3
                }
            });
        } else {
            ButtonAnimation.start({
                y: "200px",
                scale: 0,
                opacity: 0,
                transition: {
                    type: "tween",
                    duration: .5,
                    bounce: 0.3
                }
            });
            IntroTextAnimation.start({
                y: "200px",
                scale: 0,
                opacity: 0,
                transition: {
                    type: "tween",
                    duration: .5,
                    bounce: 0.3
                }
            });
        }
    }, [
        inView
    ]);
    const openModal = (url)=>{
        setRedirectUrl(url);
        setShowModal(true);
    };
    const openBeanModal = (url)=>{
        setRedirectUrl(url);
        setShowBeanModal(true);
    };
    const closeModal = ()=>{
        setShowModal(false);
    };
    const closeBeanModal = ()=>{
        setShowBeanModal(false);
    };
    const handleRedirect = ()=>{
        window.location.href = "https://artpocalypse.fineartmfers.io";
    };
    const handleAlert = (message)=>{
        window.alert(message);
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
        ref: ref,
        className: "FullScreen",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _framerMotion.motion).div, {
                                className: "px-4 StoryCaption5 fontArt",
                                animate: IntroTextAnimation,
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                                    children: [
                                        "Will you flick the bean?",
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
                                        "Or",
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
                                        "Will you pop the bean?"
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _framerMotion.motion).div, {
                                className: "EndButtons",
                                animate: ButtonAnimation,
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        onClick: openBeanModal,
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                            draggable: "false",
                                            className: "buttons",
                                            src: (0, _flickPngDefault.default)
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        onClick: openModal,
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                            draggable: "false",
                                            className: "buttons",
                                            src: (0, _popPngDefault.default)
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                })
            }),
            showModal && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "modal-overlay",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "modal",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "modal-content",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("h2", {
                                    children: "You are transferring safely"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                                    children: [
                                        "to ",
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("strong", {
                                            style: {
                                                color: "#C8F600"
                                            },
                                            children: "NFT Redeem"
                                        }),
                                        " to claim your mint."
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("code", {
                                    style: {
                                        color: "#C8F600",
                                        paddingBottom: "20px"
                                    },
                                    children: "https://artpocalypse.fineartmfers.io"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "text-[.75rem]",
                                    children: 'Click "Continue" to proceed or "Cancel" to stay on this page.'
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "modal-buttons",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            className: "bg-white",
                                            onClick: handleRedirect,
                                            children: "Continue"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            className: "bg-gray-500 text-white border-[1px] border-[#FFFFFF10]",
                                            onClick: closeModal,
                                            children: "Cancel"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "FooterMain",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "relative top-10",
                                    children: "Powered by"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("a", {
                                    href: "https://metavate.io",
                                    target: "_blank",
                                    rel: "noopener",
                                    className: "flex m-auto justify-center",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                        draggable: "false",
                                        src: (0, _metalogoPngDefault.default),
                                        alt: "Metavate",
                                        className: "invert"
                                    })
                                })
                            ]
                        })
                    ]
                })
            }),
            showBeanModal && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "modal-overlay",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "modal",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                            className: "",
                            src: (0, _flickGifDefault.default),
                            alt: "go back"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                            className: "bg-white px-4 py-2 rounded-lg mt-8",
                            onClick: closeBeanModal,
                            children: "Pick Again"
                        })
                    ]
                })
            })
        ]
    });
}

},{"react/jsx-runtime":"gaGEj","react":"6uln9","framer-motion":"fI0Q4","react-intersection-observer":"fxOjV","../../assets/images/pop.png":"i86VB","../../assets/images/flick.png":"vyoXj","../../assets/images/Flick.gif":"a9s79","../../assets/images/Metalogo.png":"9T8p8","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"i86VB":[function(require,module,exports) {
module.exports = require("69350dba9f0034bc").getBundleURL("8aiQJ") + "pop.dab2aaeb.png";

},{"69350dba9f0034bc":"c7Tr5"}],"vyoXj":[function(require,module,exports) {
module.exports = require("1fbc7ec1ed7c3e11").getBundleURL("8aiQJ") + "flick.e9e6d4ac.png";

},{"1fbc7ec1ed7c3e11":"c7Tr5"}],"a9s79":[function(require,module,exports) {
module.exports = require("6a3f2b6e9effd0e3").getBundleURL("8aiQJ") + "Flick.56fa6b53.gif";

},{"6a3f2b6e9effd0e3":"c7Tr5"}],"hbhPO":[function(require,module,exports) {
module.exports = require("144f1f6b9c831a23").getBundleURL("8aiQJ") + "Background2.35e455bf.png";

},{"144f1f6b9c831a23":"c7Tr5"}],"jgZcN":[function() {},{}],"kSWSV":[function(require,module,exports) {
module.exports = require("bcebf16e601269c5").getBundleURL("8aiQJ") + "play.0d30b728.png";

},{"bcebf16e601269c5":"c7Tr5"}],"fR5ag":[function(require,module,exports) {
module.exports = require("8fbd28377243c1fb").getBundleURL("8aiQJ") + "musicPlay.43230a0b.png";

},{"8fbd28377243c1fb":"c7Tr5"}],"kF8ey":[function(require,module,exports) {
module.exports = require("595c65e1a32edeb0").getBundleURL("8aiQJ") + "musicPause.ef2dfeb4.png";

},{"595c65e1a32edeb0":"c7Tr5"}]},["5Tqlz"], "5Tqlz", "parcelRequire3745")

//# sourceMappingURL=index.15d68a6a.js.map
